// -- (function(scope){
// -- 'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.hZ.cT === region.lX.cT)
	{
		return 'on line ' + region.hZ.cT;
	}
	return 'on lines ' + region.hZ.cT + ' through ' + region.lX.cT;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (Object.prototype.hasOwnProperty.call(value, key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	var unwrapped = _Json_unwrap(value);
	if (!(key === 'toJSON' && typeof unwrapped === 'function'))
	{
		object[key] = unwrapped;
	}
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.AN,
		impl.Kb,
		impl.I5,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


/*
function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}

*/

/*
function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}
*/


/*
function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}

*/

/*
function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}
*/



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'outerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (
		(typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		||
		(Array.isArray(_Json_unwrap(value)) && _VirtualDom_RE_js_html.test(String(_Json_unwrap(value))))
	)
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		Cs: func(record.Cs),
		I2: record.I2,
		Gk: record.Gk
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.Cs;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.I2;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.Gk) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.AN,
		impl.Kb,
		impl.I5,
		function(sendToApp, initialModel) {
			var view = impl.KO;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.AN,
		impl.Kb,
		impl.I5,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.hV && impl.hV(sendToApp)
			var view = impl.KO;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.dr);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.JB) && (_VirtualDom_doc.title = title = doc.JB);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.Ec;
	var onUrlRequest = impl.Ed;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		hV: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.Gy === next.Gy
							&& curr.d2 === next.d2
							&& curr.FX.a === next.FX.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		AN: function(flags)
		{
			return A3(impl.AN, flags, _Browser_getUrl(), key);
		},
		KO: impl.KO,
		Kb: impl.Kb,
		I5: impl.I5
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { Aj: 'hidden', u2: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { Aj: 'mozHidden', u2: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { Aj: 'msHidden', u2: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { Aj: 'webkitHidden', u2: 'webkitvisibilitychange' }
		: { Aj: 'hidden', u2: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		Iq: _Browser_getScene(),
		su: {
			sB: _Browser_window.pageXOffset,
			KZ: _Browser_window.pageYOffset,
			sA: _Browser_doc.documentElement.clientWidth,
			m3: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		sA: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		m3: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			Iq: {
				sA: node.scrollWidth,
				m3: node.scrollHeight
			},
			su: {
				sB: node.scrollLeft,
				KZ: node.scrollTop,
				sA: node.clientWidth,
				m3: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			Iq: _Browser_getScene(),
			su: {
				sB: x,
				KZ: y,
				sA: _Browser_doc.documentElement.clientWidth,
				m3: _Browser_doc.documentElement.clientHeight
			},
			lQ: {
				sB: x + rect.left,
				KZ: y + rect.top,
				sA: rect.width,
				m3: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.dU.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.dU.b, xhr)); });
		$elm$core$Maybe$isJust(request.fe) && _Http_track(router, xhr, request.fe.a);

		try {
			xhr.open(request.eg, request.aQ, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.aQ));
		}

		_Http_configureRequest(xhr, request);

		request.dr.a && xhr.setRequestHeader('Content-Type', request.dr.a);
		xhr.send(request.dr.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.d$; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.fb.a || 0;
	xhr.responseType = request.dU.d;
	xhr.withCredentials = request.tf;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		aQ: xhr.responseURL,
		rh: xhr.status,
		I$: xhr.statusText,
		d$: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			IE: event.loaded,
			rd: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			G0: event.loaded,
			rd: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}

function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}




var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


// BYTES

function _Bytes_width(bytes)
{
	return bytes.byteLength;
}

var _Bytes_getHostEndianness = F2(function(le, be)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(new Uint8Array(new Uint32Array([1]))[0] === 1 ? le : be));
	});
});


// ENCODERS

function _Bytes_encode(encoder)
{
	var mutableBytes = new DataView(new ArrayBuffer($elm$bytes$Bytes$Encode$getWidth(encoder)));
	$elm$bytes$Bytes$Encode$write(encoder)(mutableBytes)(0);
	return mutableBytes;
}


// SIGNED INTEGERS

var _Bytes_write_i8  = F3(function(mb, i, n) { mb.setInt8(i, n); return i + 1; });
var _Bytes_write_i16 = F4(function(mb, i, n, isLE) { mb.setInt16(i, n, isLE); return i + 2; });
var _Bytes_write_i32 = F4(function(mb, i, n, isLE) { mb.setInt32(i, n, isLE); return i + 4; });


// UNSIGNED INTEGERS

var _Bytes_write_u8  = F3(function(mb, i, n) { mb.setUint8(i, n); return i + 1 ;});
var _Bytes_write_u16 = F4(function(mb, i, n, isLE) { mb.setUint16(i, n, isLE); return i + 2; });
var _Bytes_write_u32 = F4(function(mb, i, n, isLE) { mb.setUint32(i, n, isLE); return i + 4; });


// FLOATS

var _Bytes_write_f32 = F4(function(mb, i, n, isLE) { mb.setFloat32(i, n, isLE); return i + 4; });
var _Bytes_write_f64 = F4(function(mb, i, n, isLE) { mb.setFloat64(i, n, isLE); return i + 8; });


// BYTES

var _Bytes_write_bytes = F3(function(mb, offset, bytes)
{
	for (var i = 0, len = bytes.byteLength, limit = len - 4; i <= limit; i += 4)
	{
		mb.setUint32(offset + i, bytes.getUint32(i));
	}
	for (; i < len; i++)
	{
		mb.setUint8(offset + i, bytes.getUint8(i));
	}
	return offset + len;
});


// STRINGS

function _Bytes_getStringWidth(string)
{
	for (var width = 0, i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		width +=
			(code < 0x80) ? 1 :
			(code < 0x800) ? 2 :
			(code < 0xD800 || 0xDBFF < code) ? 3 : (i++, 4);
	}
	return width;
}

var _Bytes_write_string = F3(function(mb, offset, string)
{
	for (var i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		offset +=
			(code < 0x80)
				? (mb.setUint8(offset, code)
				, 1
				)
				:
			(code < 0x800)
				? (mb.setUint16(offset, 0xC080 /* 0b1100000010000000 */
					| (code >>> 6 & 0x1F /* 0b00011111 */) << 8
					| code & 0x3F /* 0b00111111 */)
				, 2
				)
				:
			(code < 0xD800 || 0xDBFF < code)
				? (mb.setUint16(offset, 0xE080 /* 0b1110000010000000 */
					| (code >>> 12 & 0xF /* 0b00001111 */) << 8
					| code >>> 6 & 0x3F /* 0b00111111 */)
				, mb.setUint8(offset + 2, 0x80 /* 0b10000000 */
					| code & 0x3F /* 0b00111111 */)
				, 3
				)
				:
			(code = (code - 0xD800) * 0x400 + string.charCodeAt(++i) - 0xDC00 + 0x10000
			, mb.setUint32(offset, 0xF0808080 /* 0b11110000100000001000000010000000 */
				| (code >>> 18 & 0x7 /* 0b00000111 */) << 24
				| (code >>> 12 & 0x3F /* 0b00111111 */) << 16
				| (code >>> 6 & 0x3F /* 0b00111111 */) << 8
				| code & 0x3F /* 0b00111111 */)
			, 4
			);
	}
	return offset;
});


// DECODER

var _Bytes_decode = F2(function(decoder, bytes)
{
	try {
		return $elm$core$Maybe$Just(A2(decoder, bytes, 0).b);
	} catch(e) {
		return $elm$core$Maybe$Nothing;
	}
});

var _Bytes_read_i8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getInt8(offset)); });
var _Bytes_read_i16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getInt16(offset, isLE)); });
var _Bytes_read_i32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getInt32(offset, isLE)); });
var _Bytes_read_u8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getUint8(offset)); });
var _Bytes_read_u16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getUint16(offset, isLE)); });
var _Bytes_read_u32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getUint32(offset, isLE)); });
var _Bytes_read_f32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getFloat32(offset, isLE)); });
var _Bytes_read_f64 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 8, bytes.getFloat64(offset, isLE)); });

var _Bytes_read_bytes = F3(function(len, bytes, offset)
{
	return _Utils_Tuple2(offset + len, new DataView(bytes.buffer, bytes.byteOffset + offset, len));
});

var _Bytes_read_string = F3(function(len, bytes, offset)
{
	var string = '';
	var end = offset + len;
	for (; offset < end;)
	{
		var byte = bytes.getUint8(offset++);
		string +=
			(byte < 128)
				? String.fromCharCode(byte)
				:
			((byte & 0xE0 /* 0b11100000 */) === 0xC0 /* 0b11000000 */)
				? String.fromCharCode((byte & 0x1F /* 0b00011111 */) << 6 | bytes.getUint8(offset++) & 0x3F /* 0b00111111 */)
				:
			((byte & 0xF0 /* 0b11110000 */) === 0xE0 /* 0b11100000 */)
				? String.fromCharCode(
					(byte & 0xF /* 0b00001111 */) << 12
					| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
					| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
				)
				:
				(byte =
					((byte & 0x7 /* 0b00000111 */) << 18
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 12
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
						| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
					) - 0x10000
				, String.fromCharCode(Math.floor(byte / 0x400) + 0xD800, byte % 0x400 + 0xDC00)
				);
	}
	return _Utils_Tuple2(offset, string);
});

var _Bytes_decodeFailure = F2(function() { throw 0; });
var $author$project$Main$Update$LienClique = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$Update$UrlChangee = function (a) {
	return {$: 1, a: a};
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $author$project$Main$Update$AleaRecu = function (a) {
	return {$: 63, a: a};
};
var $author$project$Main$Update$FicheMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Notifications$Update$HeureLue = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Socle$Session$Update$HeureLue = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$ImageDeLaPage = {$: 89};
var $author$project$Components$Produits$Reference$Update$ImageProgresse = function (a) {
	return {$: 79, a: a};
};
var $author$project$Main$Update$NotificationsMsg = function (a) {
	return {$: 58, a: a};
};
var $author$project$Main$Update$ReferenceMsg = function (a) {
	return {$: 29, a: a};
};
var $author$project$Main$Update$SessionMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Socle$Session$Update$VisibiliteChangee = function (a) {
	return {$: 16, a: a};
};
var $elm$browser$Browser$Events$Visible = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.m) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.o),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.o);
		} else {
			var treeLen = builder.m * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.p) : builder.p;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.m);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.o) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.o);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{p: nodeList, m: (len / $elm$core$Array$branchFactor) | 0, o: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Ports$aleaRecu = _Platform_incomingPort(
	'aleaRecu',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$int));
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $author$project$Main$Update$DemonstrationMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Main$Update$NavigationMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Demonstration$Update$DrawerMsg = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Demonstration$Model$drawer = F2(
	function (formulaire, model) {
		switch (formulaire) {
			case 0:
				return model.ep;
			case 1:
				return model.eo;
			default:
				return model.eh;
		}
	});
var $author$project$Components$Shared$Drawer$Update$AbandonRefuse = {$: 4};
var $author$project$Components$Shared$Drawer$Update$SortieDemandee = {$: 2};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $author$project$Components$Shared$Drawer$Update$echap = function (model) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (touche) {
			var _v0 = _Utils_Tuple2(touche, model.gt);
			_v0$2:
			while (true) {
				if ((_v0.a.a === 'Escape') && (!_v0.a.b)) {
					switch (_v0.b) {
						case 1:
							var _v1 = _v0.a;
							var _v2 = _v0.b;
							return $elm$json$Json$Decode$succeed($author$project$Components$Shared$Drawer$Update$SortieDemandee);
						case 2:
							var _v3 = _v0.a;
							var _v4 = _v0.b;
							return $elm$json$Json$Decode$succeed($author$project$Components$Shared$Drawer$Update$AbandonRefuse);
						default:
							break _v0$2;
					}
				} else {
					break _v0$2;
				}
			}
			return $elm$json$Json$Decode$fail('');
		},
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'repeat', $elm$json$Json$Decode$bool)));
};
var $author$project$Components$Demonstration$Model$ModificationDeFiche = 2;
var $author$project$Components$Demonstration$Model$NouveauDossier = 1;
var $author$project$Components$Demonstration$Model$NouvellePartiePrenante = 0;
var $author$project$Components$Demonstration$Model$formulaireDeLaPage = function (route) {
	switch (route.$) {
		case 72:
			if (!route.a) {
				var _v1 = route.a;
				return $elm$core$Maybe$Just(0);
			} else {
				var _v2 = route.a;
				return $elm$core$Maybe$Just(1);
			}
		case 73:
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $elm$json$Json$Decode$map = _Json_map1;
var $author$project$Components$Demonstration$Update$clavier = F2(
	function (route, model) {
		var _v0 = $author$project$Components$Demonstration$Model$formulaireDeLaPage(route);
		if (!_v0.$) {
			var formulaire = _v0.a;
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Demonstration$Update$DrawerMsg(formulaire),
				$author$project$Components$Shared$Drawer$Update$echap(
					A2($author$project$Components$Demonstration$Model$drawer, formulaire, model)));
		} else {
			return $elm$json$Json$Decode$fail('');
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$ConfirmationAnnulee = {$: 59};
var $author$project$Components$Referentiel$Fiche$Update$DrawerDEffacementMsg = function (a) {
	return {$: 107, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$DrawerDEvolutionMsg = function (a) {
	return {$: 50, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$DrawerDExportMsg = function (a) {
	return {$: 114, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$DrawerDOuvertureMsg = function (a) {
	return {$: 49, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$DrawerDeLHistoriqueMsg = function (a) {
	return {$: 94, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$DrawerDuContactMsg = function (a) {
	return {$: 128, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$DrawerDuCycleMsg = function (a) {
	return {$: 95, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$DrawerMsg = function (a) {
	return {$: 55, a: a};
};
var $author$project$Components$Referentiel$Fiche$Liaisons$idDeLaConfirmation = 'relation-supprimer';
var $author$project$Components$Referentiel$Identifiants$relationUidToString = function (_v0) {
	var valeur = _v0;
	return valeur;
};
var $author$project$Components$Referentiel$Fiche$Liaisons$idDuDeclencheurDeSuppression = function (uid) {
	return $author$project$Components$Referentiel$Fiche$Liaisons$idDeLaConfirmation + ('-' + $author$project$Components$Referentiel$Identifiants$relationUidToString(uid));
};
var $author$project$Components$Shared$Drawer$Model$idRacine = function (model) {
	return 'drawer-' + model.Dj;
};
var $author$project$Components$Shared$Drawer$Model$idTitre = function (model) {
	return $author$project$Components$Shared$Drawer$Model$idRacine(model) + '-titre';
};
var $author$project$Components$Referentiel$Fiche$Liaisons$declencheurDeLaConfirmation = function (etat) {
	var _v0 = etat.mW;
	if (_v0.$ === 2) {
		var relation = _v0.a;
		return $elm$core$Maybe$Just(
			$author$project$Components$Referentiel$Fiche$Liaisons$idDuDeclencheurDeSuppression(relation.r8));
	} else {
		var _v1 = etat.j6;
		if (_v1.$ === 1) {
			return $elm$core$Maybe$Just(
				$author$project$Components$Shared$Drawer$Model$idTitre(etat.kX));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $author$project$Components$Referentiel$Fiche$Update$clavier = function (model) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Fiche$Update$DrawerDOuvertureMsg,
				$author$project$Components$Shared$Drawer$Update$echap(model.k4)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Fiche$Update$DrawerDEvolutionMsg,
				$author$project$Components$Shared$Drawer$Update$echap(model.k1)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Fiche$Update$DrawerMsg,
				$author$project$Components$Shared$Drawer$Update$echap(model.Bk.kX)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Fiche$Update$DrawerDeLHistoriqueMsg,
				$author$project$Components$Shared$Drawer$Update$echap(model.k9)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Fiche$Update$DrawerDuCycleMsg,
				$author$project$Components$Shared$Drawer$Update$echap(model.lr)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Fiche$Update$DrawerDEffacementMsg,
				$author$project$Components$Shared$Drawer$Update$echap(model.x9.kX)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Fiche$Update$DrawerDExportMsg,
				$author$project$Components$Shared$Drawer$Update$echap(model.ms.kX)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Fiche$Update$DrawerDuContactMsg,
				$author$project$Components$Shared$Drawer$Update$echap(model.lq)),
				A2(
				$elm$json$Json$Decode$andThen,
				function (touche) {
					var _v0 = _Utils_Tuple2(
						touche,
						$author$project$Components$Referentiel$Fiche$Liaisons$declencheurDeLaConfirmation(model.Bk));
					if (((_v0.a.a === 'Escape') && (!_v0.a.b)) && (!_v0.b.$)) {
						var _v1 = _v0.a;
						return $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$Update$ConfirmationAnnulee);
					} else {
						return $elm$json$Json$Decode$fail('');
					}
				},
				A3(
					$elm$json$Json$Decode$map2,
					$elm$core$Tuple$pair,
					A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'repeat', $elm$json$Json$Decode$bool)))
			]));
};
var $author$project$Main$Update$BibliothequeMsg = function (a) {
	return {$: 49, a: a};
};
var $author$project$Main$Update$CollectionsDeChampsMsg = function (a) {
	return {$: 48, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawer = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDeLaDefinition = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDeLaRestriction = function (a) {
	return {$: 56, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDeLaTraduction = function (a) {
	return {$: 33, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDesReglages = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDuCalcul = function (a) {
	return {$: 46, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDuChoixDeNoeud = function (a) {
	return {$: 57, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDuRattachement = function (a) {
	return {$: 38, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuNouveauChamp = function (a) {
	return {$: 71, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Update$DuDrawerDeLaListe = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Update$DuDrawerDuChamp = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Shared$Drawer$Model$Ferme = 0;
var $elm$core$Basics$neq = _Utils_notEqual;
var $author$project$Components$Shared$Drawer$Model$estOuvert = function (model) {
	return !(!model.gt);
};
var $author$project$Components$Parametrage$NouveauChamp$Update$clavier = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.lc) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Parametrage$NouveauChamp$Update$DuDrawerDeLaListe,
		$author$project$Components$Shared$Drawer$Update$echap(model.lc)) : A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Parametrage$NouveauChamp$Update$DuDrawerDuChamp,
		$author$project$Components$Shared$Drawer$Update$echap(model.lp));
};
var $author$project$Components$Parametrage$NouveauChamp$Model$ouvert = function (model) {
	return !_Utils_eq(model.ew, $elm$core$Maybe$Nothing);
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$clavier = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.lC) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDeLaRestriction,
		$author$project$Components$Shared$Drawer$Update$echap(model.lC)) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.kZ) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDuChoixDeNoeud,
		$author$project$Components$Shared$Drawer$Update$echap(model.kZ)) : ($author$project$Components$Parametrage$NouveauChamp$Model$ouvert(model.oP) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuNouveauChamp,
		$author$project$Components$Parametrage$NouveauChamp$Update$clavier(model.oP)) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.dJ) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDuCalcul,
		$author$project$Components$Shared$Drawer$Update$echap(model.dJ)) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.dQ) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDuRattachement,
		$author$project$Components$Shared$Drawer$Update$echap(model.dQ)) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.dR) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDeLaTraduction,
		$author$project$Components$Shared$Drawer$Update$echap(model.dR)) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.dO) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDeLaDefinition,
		$author$project$Components$Shared$Drawer$Update$echap(model.dO)) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.lA) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDesReglages,
		$author$project$Components$Shared$Drawer$Update$echap(model.lA)) : A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX)))))))));
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$DuDrawerDeCreation = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$DuDrawerDeTraduction = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$clavier = function (model) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Parametrage$CollectionsDeChamps$Update$DuDrawerDeCreation,
				$author$project$Components$Shared$Drawer$Update$echap(model.k7)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Parametrage$CollectionsDeChamps$Update$DuDrawerDeTraduction,
				$author$project$Components$Shared$Drawer$Update$echap(model.lj))
			]));
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Main$Update$clavierDeLaBibliotheque = function (model) {
	var _v0 = model.Ih;
	if (_v0.$ === 51) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$Main$Update$BibliothequeMsg,
					$author$project$Components$Parametrage$BibliothequeDeChamps$Update$clavier(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Model$ouvrir(model.dq))),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$Main$Update$CollectionsDeChampsMsg,
					$author$project$Components$Parametrage$CollectionsDeChamps$Update$clavier(model.vF))
				]));
	} else {
		return $elm$json$Json$Decode$fail('');
	}
};
var $author$project$Components$Notifications$Update$ClocheFermee = {$: 9};
var $author$project$Main$Update$clavierDeLaCloche = function (model) {
	return model.oN.Es ? A2(
		$elm$json$Json$Decode$andThen,
		function (touche) {
			return (touche === 'Escape') ? $elm$json$Json$Decode$succeed(
				$author$project$Main$Update$NotificationsMsg($author$project$Components$Notifications$Update$ClocheFermee)) : $elm$json$Json$Decode$fail('');
		},
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)) : $elm$json$Json$Decode$fail('');
};
var $author$project$Main$Update$ConservationMsg = function (a) {
	return {$: 50, a: a};
};
var $author$project$Components$Parametrage$Conservation$Update$DuDrawerDeProlongation = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Parametrage$Conservation$Update$DuDrawerDuType = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Parametrage$Conservation$Update$clavier = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.ld) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Parametrage$Conservation$Update$DuDrawerDeProlongation,
		$author$project$Components$Shared$Drawer$Update$echap(model.ld)) : A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Parametrage$Conservation$Update$DuDrawerDuType,
		$author$project$Components$Shared$Drawer$Update$echap(model.lw));
};
var $author$project$Main$Update$clavierDeLaConservation = function (model) {
	var _v0 = model.Ih;
	_v0$2:
	while (true) {
		switch (_v0.$) {
			case 42:
				if (_v0.a === 5) {
					var _v1 = _v0.a;
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$Main$Update$ConservationMsg,
						$author$project$Components$Parametrage$Conservation$Update$clavier(model.v5));
				} else {
					break _v0$2;
				}
			case 54:
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Main$Update$ConservationMsg,
					$author$project$Components$Parametrage$Conservation$Update$clavier(model.v5));
			default:
				break _v0$2;
		}
	}
	return $elm$json$Json$Decode$fail('');
};
var $author$project$Main$Update$NouvelleFicheMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Main$Update$PartiesPrenantesMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$VoletMsg = function (a) {
	return {$: 58, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$TriMenuFerme = {$: 17};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$VoletColonnesMsg = function (a) {
	return {$: 28, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$VoletMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$clavier = function (model) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$PartiesPrenantes$Update$VoletMsg,
				$author$project$Components$Shared$Drawer$Update$echap(model.im)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$PartiesPrenantes$Update$VoletColonnesMsg,
				$author$project$Components$Shared$Drawer$Update$echap(model.$9)),
				model.gY ? A2(
				$elm$json$Json$Decode$andThen,
				function (touche) {
					return (touche === 'Escape') ? $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$PartiesPrenantes$Update$TriMenuFerme) : $elm$json$Json$Decode$fail('');
				},
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)) : $elm$json$Json$Decode$fail('')
			]));
};
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Components$Referentiel$PartiesPrenantes$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Main$Update$clavierDeLaListe = function (model) {
	var _v0 = model.Ih;
	if (_v0.$ === 2) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$Main$Update$PartiesPrenantesMsg,
					$author$project$Components$Referentiel$PartiesPrenantes$Update$clavier(
						$author$project$Components$Referentiel$PartiesPrenantes$Model$ouvrir(model.eA))),
					A2(
					$elm$json$Json$Decode$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$NouvelleFiche$Update$VoletMsg, $author$project$Main$Update$NouvelleFicheMsg),
					$author$project$Components$Shared$Drawer$Update$echap(
						$author$project$Components$Referentiel$NouvelleFiche$Model$ouvrir(model.oU).im))
				]));
	} else {
		return $elm$json$Json$Decode$fail('');
	}
};
var $author$project$Main$Update$SecuriteMsg = function (a) {
	return {$: 57, a: a};
};
var $author$project$Components$Comptes$Securite$Update$DuDrawer = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Comptes$Securite$Update$GesteAnnule = {$: 5};
var $author$project$Components$Shared$Confirmation$Clavier$echap = function (renoncer) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (touche) {
			return _Utils_eq(
				touche,
				_Utils_Tuple2('Escape', false)) ? $elm$json$Json$Decode$succeed(renoncer) : $elm$json$Json$Decode$fail('');
		},
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'repeat', $elm$json$Json$Decode$bool)));
};
var $author$project$Components$Comptes$Securite$Update$clavier = function (model) {
	return (!_Utils_eq(model.iu, $elm$core$Maybe$Nothing)) ? $author$project$Components$Shared$Confirmation$Clavier$echap($author$project$Components$Comptes$Securite$Update$GesteAnnule) : A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Comptes$Securite$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX));
};
var $author$project$Main$Update$clavierDeLaSecurite = function (model) {
	var _v0 = model.Ih;
	switch (_v0.$) {
		case 64:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$SecuriteMsg,
				$author$project$Components$Comptes$Securite$Update$clavier(model.q1));
		case 65:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$SecuriteMsg,
				$author$project$Components$Comptes$Securite$Update$clavier(model.q1));
		default:
			return $elm$json$Json$Decode$fail('');
	}
};
var $author$project$Main$Update$CorrespondancesMsg = function (a) {
	return {$: 45, a: a};
};
var $author$project$Components$Produits$Correspondances$Update$DuDrawer = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Produits$Correspondances$Update$clavier = function (model) {
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Produits$Correspondances$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX));
};
var $author$project$Components$Produits$Correspondances$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Main$Update$clavierDesCorrespondances = function (model) {
	var _v0 = model.Ih;
	switch (_v0.$) {
		case 46:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$CorrespondancesMsg,
				$author$project$Components$Produits$Correspondances$Update$clavier(
					$author$project$Components$Produits$Correspondances$Model$ouvrir(model.wh)));
		case 50:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$CorrespondancesMsg,
				$author$project$Components$Produits$Correspondances$Update$clavier(
					$author$project$Components$Produits$Correspondances$Model$ouvrir(model.wh)));
		default:
			return $elm$json$Json$Decode$fail('');
	}
};
var $author$project$Main$Update$DroitsMsg = function (a) {
	return {$: 43, a: a};
};
var $author$project$Components$Parametrage$Droits$Update$DuDrawer = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Parametrage$Droits$Update$clavier = function (model) {
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Parametrage$Droits$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX));
};
var $author$project$Components$Parametrage$Droits$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Main$Update$clavierDesDroits = function (model) {
	var _v0 = model.Ih;
	if (_v0.$ === 53) {
		return A2(
			$elm$json$Json$Decode$map,
			$author$project$Main$Update$DroitsMsg,
			$author$project$Components$Parametrage$Droits$Update$clavier(
				$author$project$Components$Parametrage$Droits$Model$ouvrir(model.xS)));
	} else {
		return $elm$json$Json$Decode$fail('');
	}
};
var $author$project$Main$Update$FormesMsg = function (a) {
	return {$: 62, a: a};
};
var $author$project$Components$Referentiel$Formes$Update$DesNoms = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Referentiel$Formes$Update$DuDrawer = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Referentiel$Formes$Update$clavier = function (model) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Formes$Update$DesNoms,
				$author$project$Components$Shared$Drawer$Update$echap(model.DG)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Formes$Update$DuDrawer,
				$author$project$Components$Shared$Drawer$Update$echap(model.kX))
			]));
};
var $author$project$Main$Update$clavierDesFormes = function (model) {
	var _v0 = model.Ih;
	if ((_v0.$ === 42) && (_v0.a === 6)) {
		var _v1 = _v0.a;
		return A2(
			$elm$json$Json$Decode$map,
			$author$project$Main$Update$FormesMsg,
			$author$project$Components$Referentiel$Formes$Update$clavier(model.zS));
	} else {
		return $elm$json$Json$Decode$fail('');
	}
};
var $author$project$Main$Update$ImportsMsg = function (a) {
	return {$: 53, a: a};
};
var $author$project$Components$Imports$Outil$Update$DuDrawerDApplication = function (a) {
	return {$: 52, a: a};
};
var $author$project$Components$Imports$Outil$Update$DuDrawerDeCible = function (a) {
	return {$: 47, a: a};
};
var $author$project$Components$Imports$Outil$Update$DuDrawerDeConfirmation = function (a) {
	return {$: 84, a: a};
};
var $author$project$Components$Imports$Outil$Update$DuDrawerDeLHistorique = function (a) {
	return {$: 82, a: a};
};
var $author$project$Components$Imports$Outil$Update$DuDrawerDeRepartition = function (a) {
	return {$: 71, a: a};
};
var $author$project$Components$Imports$Outil$Update$DuDrawerDesLignes = function (a) {
	return {$: 83, a: a};
};
var $author$project$Components$Imports$Outil$Update$DuDrawerDesReglages = function (a) {
	return {$: 50, a: a};
};
var $author$project$Components$Imports$Outil$Update$DuDrawerDesRegles = function (a) {
	return {$: 72, a: a};
};
var $author$project$Components$Imports$Outil$Update$DuDrawerDesValeurs = function (a) {
	return {$: 73, a: a};
};
var $author$project$Components$Imports$Outil$Update$DuDrawerDuModele = function (a) {
	return {$: 51, a: a};
};
var $author$project$Components$Imports$Outil$Update$DuDrawerDuRefus = function (a) {
	return {$: 48, a: a};
};
var $author$project$Components$Imports$Outil$Update$DuDrawerDuRejeu = function (a) {
	return {$: 98, a: a};
};
var $author$project$Components$Imports$Outil$Update$clavier = function (model) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Imports$Outil$Update$DuDrawerDeCible,
				$author$project$Components$Shared$Drawer$Update$echap(model.k5)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Imports$Outil$Update$DuDrawerDuRefus,
				$author$project$Components$Shared$Drawer$Update$echap(model.lu)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Imports$Outil$Update$DuDrawerDesReglages,
				$author$project$Components$Shared$Drawer$Update$echap(model.ll)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Imports$Outil$Update$DuDrawerDuModele,
				$author$project$Components$Shared$Drawer$Update$echap(model.lt)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Imports$Outil$Update$DuDrawerDApplication,
				$author$project$Components$Shared$Drawer$Update$echap(model.k0)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Imports$Outil$Update$DuDrawerDeRepartition,
				$author$project$Components$Shared$Drawer$Update$echap(model.lf)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Imports$Outil$Update$DuDrawerDesRegles,
				$author$project$Components$Shared$Drawer$Update$echap(model.lm)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Imports$Outil$Update$DuDrawerDesValeurs,
				$author$project$Components$Shared$Drawer$Update$echap(model.ln)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Imports$Outil$Update$DuDrawerDeLHistorique,
				$author$project$Components$Shared$Drawer$Update$echap(model.k9)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Imports$Outil$Update$DuDrawerDesLignes,
				$author$project$Components$Shared$Drawer$Update$echap(model.lk)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Imports$Outil$Update$DuDrawerDeConfirmation,
				$author$project$Components$Shared$Drawer$Update$echap(model.k6)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Imports$Outil$Update$DuDrawerDuRejeu,
				$author$project$Components$Shared$Drawer$Update$echap(model.lv))
			]));
};
var $author$project$Components$Imports$Outil$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Main$Update$clavierDesImports = function (model) {
	var _v0 = model.Ih;
	switch (_v0.$) {
		case 66:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$ImportsMsg,
				$author$project$Components$Imports$Outil$Update$clavier(
					$author$project$Components$Imports$Outil$Model$ouvrir(model.AC)));
		case 67:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$ImportsMsg,
				$author$project$Components$Imports$Outil$Update$clavier(
					$author$project$Components$Imports$Outil$Model$ouvrir(model.AC)));
		case 68:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$ImportsMsg,
				$author$project$Components$Imports$Outil$Update$clavier(
					$author$project$Components$Imports$Outil$Model$ouvrir(model.AC)));
		default:
			return $elm$json$Json$Decode$fail('');
	}
};
var $author$project$Main$Update$LanguesDuClientMsg = function (a) {
	return {$: 51, a: a};
};
var $author$project$Components$Parametrage$LanguesDuClient$Update$DuDrawerDAjout = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$LanguesDuClient$Update$DuDrawerDeRetrait = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Parametrage$LanguesDuClient$Update$DuDrawerDeSuppression = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Parametrage$LanguesDuClient$Update$DuDrawerDuDefaut = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Parametrage$LanguesDuClient$Update$clavier = function (model) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Parametrage$LanguesDuClient$Update$DuDrawerDAjout,
				$author$project$Components$Shared$Drawer$Update$echap(model.k_)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Parametrage$LanguesDuClient$Update$DuDrawerDuDefaut,
				$author$project$Components$Shared$Drawer$Update$echap(model.ls)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Parametrage$LanguesDuClient$Update$DuDrawerDeRetrait,
				$author$project$Components$Shared$Drawer$Update$echap(model.lh)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Parametrage$LanguesDuClient$Update$DuDrawerDeSuppression,
				$author$project$Components$Shared$Drawer$Update$echap(model.li))
			]));
};
var $author$project$Main$Update$clavierDesLangues = function (model) {
	var _v0 = model.Ih;
	if (_v0.$ === 55) {
		return A2(
			$elm$json$Json$Decode$map,
			$author$project$Main$Update$LanguesDuClientMsg,
			$author$project$Components$Parametrage$LanguesDuClient$Update$clavier(model.Bb));
	} else {
		return $elm$json$Json$Decode$fail('');
	}
};
var $author$project$Main$Update$ListesMsg = function (a) {
	return {$: 44, a: a};
};
var $author$project$Components$Produits$Listes$Update$DuDrawer = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Produits$Listes$Update$clavier = function (model) {
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Produits$Listes$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX));
};
var $author$project$Components$Produits$Listes$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Main$Update$clavierDesListes = function (model) {
	var _v0 = model.Ih;
	switch (_v0.$) {
		case 44:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$ListesMsg,
				$author$project$Components$Produits$Listes$Update$clavier(
					$author$project$Components$Produits$Listes$Model$ouvrir(model.n_)));
		case 45:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$ListesMsg,
				$author$project$Components$Produits$Listes$Update$clavier(
					$author$project$Components$Produits$Listes$Model$ouvrir(model.n_)));
		default:
			return $elm$json$Json$Decode$fail('');
	}
};
var $author$project$Main$Update$PerimetresMsg = function (a) {
	return {$: 46, a: a};
};
var $author$project$Components$Produits$Perimetres$Model$Archivage = {$: 11};
var $author$project$Components$Produits$Perimetres$Update$DuDrawer = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Shared$Drawer$Update$Fermer = {$: 1};
var $author$project$Components$Produits$Perimetres$Update$clavier = function (model) {
	return _Utils_eq(
		model.mW,
		$elm$core$Maybe$Just($author$project$Components$Produits$Perimetres$Model$Archivage)) ? $author$project$Components$Shared$Confirmation$Clavier$echap(
		$author$project$Components$Produits$Perimetres$Update$DuDrawer($author$project$Components$Shared$Drawer$Update$Fermer)) : A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Produits$Perimetres$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX));
};
var $author$project$Components$Produits$Perimetres$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Main$Update$clavierDesPerimetres = function (model) {
	var _v0 = model.Ih;
	switch (_v0.$) {
		case 47:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$PerimetresMsg,
				$author$project$Components$Produits$Perimetres$Update$clavier(
					$author$project$Components$Produits$Perimetres$Model$ouvrir(model.pg)));
		case 48:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$PerimetresMsg,
				$author$project$Components$Produits$Perimetres$Update$clavier(
					$author$project$Components$Produits$Perimetres$Model$ouvrir(model.pg)));
		default:
			return $elm$json$Json$Decode$fail('');
	}
};
var $author$project$Main$Update$PostesMsg = function (a) {
	return {$: 61, a: a};
};
var $author$project$Components$Referentiel$Postes$Update$DesNoms = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Referentiel$Postes$Update$DuDrawer = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Referentiel$Postes$Update$clavier = function (model) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Postes$Update$DesNoms,
				$author$project$Components$Shared$Drawer$Update$echap(model.DG)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Postes$Update$DuDrawer,
				$author$project$Components$Shared$Drawer$Update$echap(model.kX))
			]));
};
var $author$project$Main$Update$clavierDesPostes = function (model) {
	var _v0 = model.Ih;
	if ((_v0.$ === 42) && (_v0.a === 6)) {
		var _v1 = _v0.a;
		return A2(
			$elm$json$Json$Decode$map,
			$author$project$Main$Update$PostesMsg,
			$author$project$Components$Referentiel$Postes$Update$clavier(model.F6));
	} else {
		return $elm$json$Json$Decode$fail('');
	}
};
var $author$project$Main$Update$CatalogueMsg = function (a) {
	return {$: 28, a: a};
};
var $author$project$Main$Update$FicheElementMsg = function (a) {
	return {$: 26, a: a};
};
var $author$project$Main$Update$FicheTypeMsg = function (a) {
	return {$: 27, a: a};
};
var $author$project$Main$Update$ListeDePrixMsg = function (a) {
	return {$: 35, a: a};
};
var $author$project$Main$Update$ListesDePrixMsg = function (a) {
	return {$: 34, a: a};
};
var $author$project$Main$Update$MarquesEtGammesMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Main$Update$ModelesDeTacheMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Main$Update$OffreMsg = function (a) {
	return {$: 31, a: a};
};
var $author$project$Main$Update$OffresMsg = function (a) {
	return {$: 30, a: a};
};
var $author$project$Main$Update$PipeEtape1Msg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Main$Update$PipeEtape2Msg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Main$Update$PipeEtape3Msg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Main$Update$PipeEtape4Msg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Main$Update$PipeEtape5Msg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Main$Update$PipeEtape6Msg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Main$Update$PipeEtape7Msg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Main$Update$PipeVersionsMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$Main$Update$SchemaDeNiveauMsg = function (a) {
	return {$: 36, a: a};
};
var $author$project$Main$Update$StructureCatalogueMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Parametrage$ModelesDeTache$Update$DuDrawer = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Parametrage$ModelesDeTache$Update$clavier = function (model) {
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Parametrage$ModelesDeTache$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX));
};
var $author$project$Components$Parametrage$PipeEtape1$Update$DuDrawer = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$Update$clavier = function (model) {
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Parametrage$PipeEtape1$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX));
};
var $author$project$Components$Parametrage$PipeEtape2$Update$DetailFerme = {$: 27};
var $author$project$Components$Parametrage$PipeEtape2$Update$DuDrawer = function (a) {
	return {$: 4, a: a};
};
var $elm$core$Basics$not = _Basics_not;
var $author$project$Components$Parametrage$PipeEtape2$Update$clavier = function (model) {
	return (model.bB && (!$author$project$Components$Shared$Drawer$Model$estOuvert(model.kX))) ? A2(
		$elm$json$Json$Decode$andThen,
		function (touche) {
			return (touche === 'Escape') ? $elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape2$Update$DetailFerme) : $elm$json$Json$Decode$fail(touche);
		},
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)) : A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Parametrage$PipeEtape2$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX));
};
var $author$project$Components$Parametrage$PipeEtape3$Update$DuDrawer = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$PipeEtape3$Update$clavier = function (model) {
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Parametrage$PipeEtape3$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX));
};
var $author$project$Components$Parametrage$PipeEtape4$Update$DuDrawer = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$Update$clavier = function (model) {
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Parametrage$PipeEtape4$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX));
};
var $author$project$Components$Parametrage$PipeEtape5$Update$DuDrawer = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$clavier = function (model) {
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Parametrage$PipeEtape5$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX));
};
var $author$project$Components$Parametrage$PipeEtape6$Update$DuDrawer = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$PipeEtape6$Update$clavier = function (model) {
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Parametrage$PipeEtape6$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX));
};
var $author$project$Components$Parametrage$PipeEtape7$Update$DuDrawer = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$PipeEtape7$Update$clavier = function (model) {
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Parametrage$PipeEtape7$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX));
};
var $author$project$Components$Parametrage$PipeVersions$Update$DuDrawer = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$PipeVersions$Update$clavier = function (model) {
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Parametrage$PipeVersions$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX));
};
var $author$project$Components$Produits$Catalogue$Update$DuDrawer = function (a) {
	return {$: 28, a: a};
};
var $author$project$Components$Produits$Catalogue$Update$TriMenuFerme = {$: 17};
var $author$project$Components$Produits$Catalogue$Update$VoletColonnesMsg = function (a) {
	return {$: 25, a: a};
};
var $author$project$Components$Produits$Catalogue$Update$VoletMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Produits$Catalogue$Update$clavier = function (model) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$Catalogue$Update$DuDrawer,
				$author$project$Components$Shared$Drawer$Update$echap(model.kX)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$Catalogue$Update$VoletMsg,
				$author$project$Components$Shared$Drawer$Update$echap(model.im)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$Catalogue$Update$VoletColonnesMsg,
				$author$project$Components$Shared$Drawer$Update$echap(model.$9)),
				model.gY ? A2(
				$elm$json$Json$Decode$andThen,
				function (touche) {
					return (touche === 'Escape') ? $elm$json$Json$Decode$succeed($author$project$Components$Produits$Catalogue$Update$TriMenuFerme) : $elm$json$Json$Decode$fail('');
				},
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)) : $elm$json$Json$Decode$fail('')
			]));
};
var $author$project$Components$Produits$FicheElement$Update$ArchivageAnnule = {$: 19};
var $author$project$Components$Produits$FicheElement$Update$DesBlocs = function (a) {
	return {$: 25, a: a};
};
var $author$project$Components$Produits$FicheElement$Update$DuDrawer = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Shared$OrdreDesBlocs$Update$DuDrawer = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$FicheElement$Update$MenuDeGammeFerme = {$: 23};
var $author$project$Components$Produits$FicheElement$Update$clavier = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.o1.kX) ? A2(
		$elm$json$Json$Decode$map,
		A2($elm$core$Basics$composeR, $author$project$Components$Shared$OrdreDesBlocs$Update$DuDrawer, $author$project$Components$Produits$FicheElement$Update$DesBlocs),
		$author$project$Components$Shared$Drawer$Update$echap(model.o1.kX)) : ((_Utils_eq(model.ir, $elm$core$Maybe$Nothing) && (!_Utils_eq(model.n7, $elm$core$Maybe$Nothing))) ? A2(
		$elm$json$Json$Decode$andThen,
		function (touche) {
			return _Utils_eq(
				touche,
				_Utils_Tuple2('Escape', false)) ? $elm$json$Json$Decode$succeed($author$project$Components$Produits$FicheElement$Update$MenuDeGammeFerme) : $elm$json$Json$Decode$fail('');
		},
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'repeat', $elm$json$Json$Decode$bool))) : (_Utils_eq(model.ir, $elm$core$Maybe$Nothing) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Produits$FicheElement$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX)) : A2(
		$elm$json$Json$Decode$andThen,
		function (touche) {
			return _Utils_eq(
				touche,
				_Utils_Tuple2('Escape', false)) ? $elm$json$Json$Decode$succeed($author$project$Components$Produits$FicheElement$Update$ArchivageAnnule) : $elm$json$Json$Decode$fail('');
		},
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'repeat', $elm$json$Json$Decode$bool)))));
};
var $author$project$Components$Produits$FicheType$Update$ArchivageAnnule = {$: 14};
var $author$project$Components$Produits$FicheType$Update$DesBlocs = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Produits$FicheType$Update$DesCollections = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Produits$FicheType$Update$DesLaRegleDeCode = function (a) {
	return {$: 31, a: a};
};
var $author$project$Components$Produits$FicheType$RegleDeCode$DuDrawer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$FicheType$Update$DuDrawer = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Shared$CollectionsDuType$Update$DuDrawerDAjout = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Shared$CollectionsDuType$Update$DuDrawerDeRetrait = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$FicheType$Update$DuDrawerDesReglages = function (a) {
	return {$: 25, a: a};
};
var $author$project$Components$Produits$FicheType$Update$DuDrawerRestriction = function (a) {
	return {$: 34, a: a};
};
var $author$project$Components$Produits$FicheType$Update$DuDrawerValeursPosees = function (a) {
	return {$: 44, a: a};
};
var $author$project$Components$Produits$FicheType$Update$DuElargissement = function (a) {
	return {$: 65, a: a};
};
var $author$project$Components$Produits$FicheType$Update$DuNouveauChamp = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Produits$FicheType$Update$DuRetrait = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Produits$FicheType$Update$clavier = function (model) {
	return model.ir ? $author$project$Components$Shared$Confirmation$Clavier$echap($author$project$Components$Produits$FicheType$Update$ArchivageAnnule) : ($author$project$Components$Parametrage$NouveauChamp$Model$ouvert(model.oP) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Produits$FicheType$Update$DuNouveauChamp,
		$author$project$Components$Parametrage$NouveauChamp$Update$clavier(model.oP)) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.lE) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Produits$FicheType$Update$DuDrawerValeursPosees,
		$author$project$Components$Shared$Drawer$Update$echap(model.lE)) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.o1.kX) ? A2(
		$elm$json$Json$Decode$map,
		A2($elm$core$Basics$composeR, $author$project$Components$Shared$OrdreDesBlocs$Update$DuDrawer, $author$project$Components$Produits$FicheType$Update$DesBlocs),
		$author$project$Components$Shared$Drawer$Update$echap(model.o1.kX)) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.vE.kY) ? A2(
		$elm$json$Json$Decode$map,
		A2($elm$core$Basics$composeR, $author$project$Components$Shared$CollectionsDuType$Update$DuDrawerDAjout, $author$project$Components$Produits$FicheType$Update$DesCollections),
		$author$project$Components$Shared$Drawer$Update$echap(model.vE.kY)) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.vE.lD) ? A2(
		$elm$json$Json$Decode$map,
		A2($elm$core$Basics$composeR, $author$project$Components$Shared$CollectionsDuType$Update$DuDrawerDeRetrait, $author$project$Components$Produits$FicheType$Update$DesCollections),
		$author$project$Components$Shared$Drawer$Update$echap(model.vE.lD)) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.lC) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Produits$FicheType$Update$DuDrawerRestriction,
		$author$project$Components$Shared$Drawer$Update$echap(model.lC)) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.lB) ? A2(
		$elm$json$Json$Decode$map,
		A2($elm$core$Basics$composeR, $author$project$Components$Produits$FicheType$RegleDeCode$DuDrawer, $author$project$Components$Produits$FicheType$Update$DesLaRegleDeCode),
		$author$project$Components$Shared$Drawer$Update$echap(model.lB)) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.lx) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Produits$FicheType$Update$DuElargissement,
		$author$project$Components$Shared$Drawer$Update$echap(model.lx)) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.eW) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Produits$FicheType$Update$DuRetrait,
		$author$project$Components$Shared$Drawer$Update$echap(model.eW)) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.lA) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Produits$FicheType$Update$DuDrawerDesReglages,
		$author$project$Components$Shared$Drawer$Update$echap(model.lA)) : A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Produits$FicheType$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX))))))))))));
};
var $author$project$Components$Produits$ListeDePrix$Update$DuDrawer = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Produits$ListeDePrix$Update$clavier = function (model) {
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Produits$ListeDePrix$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX));
};
var $author$project$Components$Produits$ListesDePrix$Update$DuDrawer = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Produits$ListesDePrix$Update$clavier = function (model) {
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Produits$ListesDePrix$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX));
};
var $author$project$Components$Produits$MarquesEtGammes$Update$DuDrawer = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Produits$MarquesEtGammes$Update$clavier = function (model) {
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Produits$MarquesEtGammes$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX));
};
var $author$project$Components$Produits$Offre$Update$ArretAnnule = {$: 16};
var $author$project$Components$Produits$Offre$Update$DuDrawer = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Produits$Offre$Update$DuDrawerDeLaFiche = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Produits$Offre$Update$clavier = function (model) {
	return model.is ? $author$project$Components$Shared$Confirmation$Clavier$echap($author$project$Components$Produits$Offre$Update$ArretAnnule) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.lb) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Produits$Offre$Update$DuDrawerDeLaFiche,
		$author$project$Components$Shared$Drawer$Update$echap(model.lb)) : A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Produits$Offre$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX)));
};
var $author$project$Components$Produits$Offres$Update$DuDrawer = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Produits$Offres$Update$clavier = function (model) {
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Produits$Offres$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX));
};
var $author$project$Components$Produits$Reference$Update$ArretAnnule = {$: 21};
var $author$project$Components$Produits$Reference$Update$DuDrawer = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Produits$Reference$Update$RetraitAnnule = {$: 71};
var $author$project$Components$Produits$Reference$Update$clavier = function (model) {
	return (!_Utils_eq(model.dh, $elm$core$Maybe$Nothing)) ? $author$project$Components$Shared$Confirmation$Clavier$echap($author$project$Components$Produits$Reference$Update$RetraitAnnule) : (model.is ? $author$project$Components$Shared$Confirmation$Clavier$echap($author$project$Components$Produits$Reference$Update$ArretAnnule) : A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Produits$Reference$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX)));
};
var $author$project$Components$Produits$SchemaDeNiveau$Update$DuDrawer = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Produits$SchemaDeNiveau$Update$clavier = function (model) {
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Produits$SchemaDeNiveau$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX));
};
var $author$project$Components$Produits$StructureCatalogue$Update$DeLAjoutDEtageLibre = function (a) {
	return {$: 68, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$DeLAjoutDEtat = function (a) {
	return {$: 33, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$DeLAjoutDeTypologie = function (a) {
	return {$: 37, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$DeLEtage = function (a) {
	return {$: 99, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$DeLInformation = function (a) {
	return {$: 97, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$DeLaConsultation = function (a) {
	return {$: 96, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$DeLaNouvelleListe = function (a) {
	return {$: 149, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$DesCategories = function (a) {
	return {$: 89, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$DesClassifications = function (a) {
	return {$: 88, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$DesGammes = function (a) {
	return {$: 91, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$DesMarques = function (a) {
	return {$: 90, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$DesProduits = function (a) {
	return {$: 93, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$DuArchivage = function (a) {
	return {$: 48, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$DuChoixDEtage = function (a) {
	return {$: 104, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$DuChoixDePerimetre = function (a) {
	return {$: 107, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$DuDrawer = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$DuDrawerDOrdre = function (a) {
	return {$: 167, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$DuDrawerDeRangement = function (a) {
	return {$: 160, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$DuNouveauChamp = function (a) {
	return {$: 146, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$DuRangementDeTypologie = function (a) {
	return {$: 84, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$DuRattachementDInformation = function (a) {
	return {$: 140, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$DuRenommage = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$DuRenommageDEtageLibre = function (a) {
	return {$: 81, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$DuRenommageDEtat = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$DuRenommageDInformation = function (a) {
	return {$: 136, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$DuRenommageDeNature = function (a) {
	return {$: 28, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$DuRenommageDeTypologie = function (a) {
	return {$: 41, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$DuRetraitDeTypologie = function (a) {
	return {$: 60, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$DuDrawer = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$DuDrawerDeLaCategorie = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$DuRenommage = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$clavier = function (model) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Categories$Update$DuRenommage,
				$author$project$Components$Shared$Drawer$Update$echap(model.hL)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Categories$Update$DuDrawerDeLaCategorie,
				$author$project$Components$Shared$Drawer$Update$echap(model.la)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Categories$Update$DuDrawer,
				$author$project$Components$Shared$Drawer$Update$echap(model.kX))
			]));
};
var $author$project$Components$Produits$StructureCatalogue$Gammes$Update$DuDrawer = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Gammes$Update$clavier = function (model) {
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Produits$StructureCatalogue$Gammes$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX));
};
var $author$project$Components$Produits$StructureCatalogue$Marques$Update$DuDrawer = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Marques$Update$clavier = function (model) {
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Produits$StructureCatalogue$Marques$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX));
};
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$DuDrawer = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$DuDrawerDeRestriction = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$clavier = function (model) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Produits$Update$DuDrawer,
				$author$project$Components$Shared$Drawer$Update$echap(model.kX)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Produits$Update$DuDrawerDeRestriction,
				$author$project$Components$Shared$Drawer$Update$echap(model.lg))
			]));
};
var $author$project$Components$Produits$StructureCatalogue$Update$clavier = function (model) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Update$DuNouveauChamp,
				$author$project$Components$Parametrage$NouveauChamp$Update$clavier(model.oP)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Update$DuRenommage,
				$author$project$Components$Shared$Drawer$Update$echap(model.hL)),
				A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Classifications$Update$DuDrawer, $author$project$Components$Produits$StructureCatalogue$Update$DesClassifications),
				$author$project$Components$Shared$Drawer$Update$echap(model.vk.kX)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Update$DuRenommageDEtat,
				$author$project$Components$Shared$Drawer$Update$echap(model.c5)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Update$DeLAjoutDEtat,
				$author$project$Components$Shared$Drawer$Update$echap(model.br)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Update$DuRenommageDeNature,
				$author$project$Components$Shared$Drawer$Update$echap(model.qn)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Update$DeLAjoutDeTypologie,
				$author$project$Components$Shared$Drawer$Update$echap(model.iG)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Update$DuRenommageDeTypologie,
				$author$project$Components$Shared$Drawer$Update$echap(model.qo)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Update$DuRetraitDeTypologie,
				$author$project$Components$Shared$Drawer$Update$echap(model.qM)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Update$DuArchivage,
				$author$project$Components$Shared$Drawer$Update$echap(model.tD.kX)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Update$DuChoixDEtage,
				$author$project$Components$Shared$Drawer$Update$echap(model.dM)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Update$DuChoixDePerimetre,
				$author$project$Components$Shared$Drawer$Update$echap(model.dN)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Update$DeLAjoutDEtageLibre,
				$author$project$Components$Shared$Drawer$Update$echap(model.y)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Update$DuRenommageDEtageLibre,
				$author$project$Components$Shared$Drawer$Update$echap(model.bg)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Update$DesCategories,
				$author$project$Components$Produits$StructureCatalogue$Categories$Update$clavier(model.dt)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Update$DesMarques,
				$author$project$Components$Produits$StructureCatalogue$Marques$Update$clavier(model.cU)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Update$DesGammes,
				$author$project$Components$Produits$StructureCatalogue$Gammes$Update$clavier(model.gG)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Update$DesProduits,
				$author$project$Components$Produits$StructureCatalogue$Produits$Update$clavier(model.aK)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Update$DeLaNouvelleListe,
				$author$project$Components$Shared$Drawer$Update$echap(model.T)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Update$DuRattachementDInformation,
				$author$project$Components$Shared$Drawer$Update$echap(model.pO)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Update$DeLInformation,
				$author$project$Components$Shared$Drawer$Update$echap(model.dL)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Update$DeLEtage,
				$author$project$Components$Shared$Drawer$Update$echap(model.dK)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Update$DeLaConsultation,
				$author$project$Components$Shared$Drawer$Update$echap(model.gc)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Update$DuRenommageDInformation,
				$author$project$Components$Shared$Drawer$Update$echap(model.c6)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Update$DuDrawerDeRangement,
				$author$project$Components$Shared$Drawer$Update$echap(model.le)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Update$DuDrawerDOrdre,
				$author$project$Components$Shared$Drawer$Update$echap(model.k3)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Update$DuRangementDeTypologie,
				$author$project$Components$Shared$Drawer$Update$echap(model.bZ))
			]));
};
var $author$project$Components$Parametrage$PipeEtape1$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Components$Parametrage$PipeEtape2$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Components$Parametrage$PipeEtape3$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Components$Parametrage$PipeEtape4$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Components$Parametrage$PipeEtape5$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Components$Parametrage$PipeEtape6$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Components$Parametrage$PipeEtape7$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Components$Produits$Catalogue$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Components$Produits$FicheElement$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Components$Produits$FicheType$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Components$Produits$ListeDePrix$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Components$Produits$MarquesEtGammes$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Components$Produits$Offre$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Components$Produits$Offres$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Components$Produits$Reference$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Components$Produits$SchemaDeNiveau$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Components$Produits$StructureCatalogue$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Main$Update$clavierDesProduits = function (model) {
	var _v0 = model.Ih;
	switch (_v0.$) {
		case 8:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$MarquesEtGammesMsg,
				$author$project$Components$Produits$MarquesEtGammes$Update$clavier(
					$author$project$Components$Produits$MarquesEtGammes$Model$ouvrir(model.B7)));
		case 23:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$FicheElementMsg,
				$author$project$Components$Produits$FicheElement$Update$clavier(
					$author$project$Components$Produits$FicheElement$Model$ouvrir(model.zr)));
		case 6:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$StructureCatalogueMsg,
				$author$project$Components$Produits$StructureCatalogue$Update$clavier(
					$author$project$Components$Produits$StructureCatalogue$Model$ouvrir(model.I3)));
		case 40:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$FicheTypeMsg,
				$author$project$Components$Produits$FicheType$Update$clavier(
					$author$project$Components$Produits$FicheType$Model$ouvrir(model.zs)));
		case 7:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$SchemaDeNiveauMsg,
				$author$project$Components$Produits$SchemaDeNiveau$Update$clavier(
					$author$project$Components$Produits$SchemaDeNiveau$Model$ouvrir(model.Ir)));
		case 25:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$CatalogueMsg,
				$author$project$Components$Produits$Catalogue$Update$clavier(
					$author$project$Components$Produits$Catalogue$Model$ouvrir(model.jB)));
		case 26:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$CatalogueMsg,
				$author$project$Components$Produits$Catalogue$Update$clavier(
					$author$project$Components$Produits$Catalogue$Model$ouvrir(model.jB)));
		case 27:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$CatalogueMsg,
				$author$project$Components$Produits$Catalogue$Update$clavier(
					$author$project$Components$Produits$Catalogue$Model$ouvrir(model.jB)));
		case 28:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$ReferenceMsg,
				$author$project$Components$Produits$Reference$Update$clavier(
					$author$project$Components$Produits$Reference$Model$ouvrir(model.Hc)));
		case 30:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$OffresMsg,
				$author$project$Components$Produits$Offres$Update$clavier(
					$author$project$Components$Produits$Offres$Model$ouvrir(model.D3)));
		case 31:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$OffreMsg,
				$author$project$Components$Produits$Offre$Update$clavier(
					$author$project$Components$Produits$Offre$Model$ouvrir(model.D1)));
		case 11:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$PipeEtape1Msg,
				$author$project$Components$Parametrage$PipeEtape1$Update$clavier(
					$author$project$Components$Parametrage$PipeEtape1$Model$ouvrir(model.Fy)));
		case 12:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$PipeEtape2Msg,
				$author$project$Components$Parametrage$PipeEtape2$Update$clavier(
					$author$project$Components$Parametrage$PipeEtape2$Model$ouvrir(model.Fz)));
		case 13:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$PipeEtape3Msg,
				$author$project$Components$Parametrage$PipeEtape3$Update$clavier(
					$author$project$Components$Parametrage$PipeEtape3$Model$ouvrir(model.FA)));
		case 14:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$PipeEtape4Msg,
				$author$project$Components$Parametrage$PipeEtape4$Update$clavier(
					$author$project$Components$Parametrage$PipeEtape4$Model$ouvrir(model.FB)));
		case 15:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$PipeEtape5Msg,
				$author$project$Components$Parametrage$PipeEtape5$Update$clavier(
					$author$project$Components$Parametrage$PipeEtape5$Model$ouvrir(model.FC)));
		case 16:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$PipeEtape6Msg,
				$author$project$Components$Parametrage$PipeEtape6$Update$clavier(
					$author$project$Components$Parametrage$PipeEtape6$Model$ouvrir(model.FD)));
		case 17:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$PipeEtape7Msg,
				$author$project$Components$Parametrage$PipeEtape7$Update$clavier(
					$author$project$Components$Parametrage$PipeEtape7$Model$ouvrir(model.FE)));
		case 19:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$PipeVersionsMsg,
				$author$project$Components$Parametrage$PipeVersions$Update$clavier(model.FL));
		case 10:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$ModelesDeTacheMsg,
				$author$project$Components$Parametrage$ModelesDeTache$Update$clavier(model.CL));
		case 37:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$ListesDePrixMsg,
				$author$project$Components$Produits$ListesDePrix$Update$clavier(model.BW));
		case 38:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$ListeDePrixMsg,
				$author$project$Components$Produits$ListeDePrix$Update$clavier(
					$author$project$Components$Produits$ListeDePrix$Model$ouvrir(model.nY)));
		default:
			return $elm$json$Json$Decode$fail('');
	}
};
var $author$project$Main$Update$DoublonsMsg = function (a) {
	return {$: 41, a: a};
};
var $author$project$Main$Update$FusionMsg = function (a) {
	return {$: 40, a: a};
};
var $author$project$Main$Update$GroupeMsg = function (a) {
	return {$: 39, a: a};
};
var $author$project$Main$Update$TypeDePartiePrenanteMsg = function (a) {
	return {$: 42, a: a};
};
var $author$project$Main$Update$TypesDePartiesPrenantesMsg = function (a) {
	return {$: 37, a: a};
};
var $author$project$Components$Referentiel$Doublons$Update$DuDrawer = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Referentiel$Doublons$Update$clavier = function (model) {
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Referentiel$Doublons$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX));
};
var $author$project$Components$Referentiel$Fusion$Update$DuVolet = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Fusion$Update$clavier = function (model) {
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Referentiel$Fusion$Update$DuVolet,
		$author$project$Components$Shared$Drawer$Update$echap(model.im));
};
var $author$project$Components$Referentiel$Groupe$Update$ArchivageAnnule = {$: 28};
var $author$project$Components$Referentiel$Groupe$Update$DesCriteres = function (a) {
	return {$: 37, a: a};
};
var $author$project$Components$Referentiel$Groupe$Update$DesNonAjoutees = function (a) {
	return {$: 46, a: a};
};
var $author$project$Components$Referentiel$Groupe$Update$DuAjout = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Referentiel$Groupe$Update$DuChangementDeResponsable = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$Referentiel$Groupe$Update$DuRenommage = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Referentiel$Groupe$Update$DuRetrait = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Referentiel$Groupe$Update$clavier = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.iH) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Referentiel$Groupe$Update$DuAjout,
		$author$project$Components$Shared$Drawer$Update$echap(model.iH)) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.kn) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Referentiel$Groupe$Update$DesCriteres,
		$author$project$Components$Shared$Drawer$Update$echap(model.kn)) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.jH) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Referentiel$Groupe$Update$DuChangementDeResponsable,
		$author$project$Components$Shared$Drawer$Update$echap(model.jH)) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.qp) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Referentiel$Groupe$Update$DuRenommage,
		$author$project$Components$Shared$Drawer$Update$echap(model.qp)) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.oE) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Referentiel$Groupe$Update$DesNonAjoutees,
		$author$project$Components$Shared$Drawer$Update$echap(model.oE)) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.qN) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Referentiel$Groupe$Update$DuRetrait,
		$author$project$Components$Shared$Drawer$Update$echap(model.qN)) : (model.ir ? A2(
		$elm$json$Json$Decode$andThen,
		function (touche) {
			return _Utils_eq(
				touche,
				_Utils_Tuple2('Escape', false)) ? $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Groupe$Update$ArchivageAnnule) : $elm$json$Json$Decode$fail('');
		},
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'repeat', $elm$json$Json$Decode$bool))) : $elm$json$Json$Decode$fail('')))))));
};
var $author$project$Components$Referentiel$Type$Update$ArchivageAnnule = {$: 19};
var $author$project$Components$Referentiel$Type$Update$DeLaLimite = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Referentiel$Type$Update$DuDrawerRattacher = function (a) {
	return {$: 33, a: a};
};
var $author$project$Components$Referentiel$Common$RattacherUnChamp$DuElargissement = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Referentiel$Type$Update$DuNouveauChamp = function (a) {
	return {$: 31, a: a};
};
var $author$project$Components$Referentiel$Type$Update$DuRattachement = function (a) {
	return {$: 32, a: a};
};
var $author$project$Components$Referentiel$Type$Update$DuRenommage = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Referentiel$Type$Update$clavier = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.hL) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Referentiel$Type$Update$DuRenommage,
		$author$project$Components$Shared$Drawer$Update$echap(model.hL)) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.nV) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Referentiel$Type$Update$DeLaLimite,
		$author$project$Components$Shared$Drawer$Update$echap(model.nV)) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.GZ.lx) ? A2(
		$elm$json$Json$Decode$map,
		A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$RattacherUnChamp$DuElargissement, $author$project$Components$Referentiel$Type$Update$DuRattachement),
		$author$project$Components$Shared$Drawer$Update$echap(model.GZ.lx)) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.lz) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Referentiel$Type$Update$DuDrawerRattacher,
		$author$project$Components$Shared$Drawer$Update$echap(model.lz)) : ($author$project$Components$Parametrage$NouveauChamp$Model$ouvert(model.oP) ? A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Referentiel$Type$Update$DuNouveauChamp,
		$author$project$Components$Parametrage$NouveauChamp$Update$clavier(model.oP)) : (model.ir ? A2(
		$elm$json$Json$Decode$andThen,
		function (touche) {
			return _Utils_eq(
				touche,
				_Utils_Tuple2('Escape', false)) ? $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Type$Update$ArchivageAnnule) : $elm$json$Json$Decode$fail('');
		},
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'repeat', $elm$json$Json$Decode$bool))) : $elm$json$Json$Decode$fail(''))))));
};
var $author$project$Components$Referentiel$Types$Update$DeLInformation = function (a) {
	return {$: 65, a: a};
};
var $author$project$Components$Referentiel$Types$Update$DeLaConsultation = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Referentiel$Types$Update$DeLaMasquee = function (a) {
	return {$: 66, a: a};
};
var $author$project$Components$Referentiel$Types$Update$DeLaRapide = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Referentiel$Types$Update$DeLaRestriction = function (a) {
	return {$: 84, a: a};
};
var $author$project$Components$Referentiel$Types$Update$DesBlocs = function (a) {
	return {$: 58, a: a};
};
var $author$project$Components$Referentiel$Types$Update$DesCollections = function (a) {
	return {$: 57, a: a};
};
var $author$project$Components$Referentiel$Types$Update$DesInformations = function (a) {
	return {$: 56, a: a};
};
var $author$project$Components$Referentiel$Types$Update$DesVersions = function (a) {
	return {$: 67, a: a};
};
var $author$project$Components$Referentiel$Types$Update$DuChemin = function (a) {
	return {$: 51, a: a};
};
var $author$project$Components$Referentiel$Types$Update$DuChoixDesOffres = function (a) {
	return {$: 37, a: a};
};
var $author$project$Components$Referentiel$Types$Update$DuChoixDuPerimetre = function (a) {
	return {$: 43, a: a};
};
var $author$project$Components$Referentiel$Types$Update$DuDrawer = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Referentiel$Types$Update$DuElargissementDeLaListe = function (a) {
	return {$: 100, a: a};
};
var $author$project$Components$Referentiel$Types$Update$DuNouveauChamp = function (a) {
	return {$: 55, a: a};
};
var $author$project$Components$Referentiel$Types$Update$DuRattachement = function (a) {
	return {$: 93, a: a};
};
var $author$project$Components$Referentiel$Types$Update$DuRenommage = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Referentiel$Types$Update$clavier = function (model) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Types$Update$DuDrawer,
				$author$project$Components$Shared$Drawer$Update$echap(model.kX)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Types$Update$DuRenommage,
				$author$project$Components$Shared$Drawer$Update$echap(model.hL)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Types$Update$DeLaRapide,
				$author$project$Components$Shared$Drawer$Update$echap(model.pJ)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Types$Update$DeLaConsultation,
				$author$project$Components$Shared$Drawer$Update$echap(model.j9)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Types$Update$DuChemin,
				$author$project$Components$Shared$Drawer$Update$echap(model.jK)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Types$Update$DuChoixDesOffres,
				$author$project$Components$Shared$Drawer$Update$echap(model.jQ)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Types$Update$DuChoixDuPerimetre,
				$author$project$Components$Shared$Drawer$Update$echap(model.jR)),
				A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeR, $author$project$Components$Shared$CollectionsDuType$Update$DuDrawerDAjout, $author$project$Components$Referentiel$Types$Update$DesCollections),
				$author$project$Components$Shared$Drawer$Update$echap(model.vE.kY)),
				A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeR, $author$project$Components$Shared$CollectionsDuType$Update$DuDrawerDeRetrait, $author$project$Components$Referentiel$Types$Update$DesCollections),
				$author$project$Components$Shared$Drawer$Update$echap(model.vE.lD)),
				A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeR, $author$project$Components$Shared$OrdreDesBlocs$Update$DuDrawer, $author$project$Components$Referentiel$Types$Update$DesBlocs),
				$author$project$Components$Shared$Drawer$Update$echap(model.o1.kX)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Types$Update$DesInformations,
				$author$project$Components$Shared$Drawer$Update$echap(model.AM.kX)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Types$Update$DuNouveauChamp,
				$author$project$Components$Parametrage$NouveauChamp$Update$clavier(model.AM.oP)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Types$Update$DeLInformation,
				$author$project$Components$Shared$Drawer$Update$echap(model.AM.zo)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Types$Update$DuElargissementDeLaListe,
				$author$project$Components$Shared$Drawer$Update$echap(model.AM.ly)),
				A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$RattacherUnChamp$DuElargissement, $author$project$Components$Referentiel$Types$Update$DuRattachement),
				$author$project$Components$Shared$Drawer$Update$echap(model.AM.GZ.lx)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Types$Update$DeLaRestriction,
				$author$project$Components$Shared$Drawer$Update$echap(model.AM.lC)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Types$Update$DeLaMasquee,
				$author$project$Components$Shared$Drawer$Update$echap(model.AM.Ca)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Types$Update$DesVersions,
				$author$project$Components$Shared$Drawer$Update$echap(model.AM.ss))
			]));
};
var $author$project$Components$Referentiel$Doublons$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Components$Referentiel$Groupe$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Components$Referentiel$Type$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Components$Referentiel$Types$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Main$Update$clavierDesTypes = function (model) {
	var _v0 = model.Ih;
	switch (_v0.$) {
		case 42:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$TypesDePartiesPrenantesMsg,
				$author$project$Components$Referentiel$Types$Update$clavier(
					$author$project$Components$Referentiel$Types$Model$ouvrir(model.J0)));
		case 69:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$TypeDePartiePrenanteMsg,
				$author$project$Components$Referentiel$Type$Update$clavier(
					$author$project$Components$Referentiel$Type$Model$ouvrir(model.JT)));
		case 52:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$GroupeMsg,
				$author$project$Components$Referentiel$Groupe$Update$clavier(
					$author$project$Components$Referentiel$Groupe$Model$ouvrir(model.m2)));
		case 3:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$FusionMsg,
				$author$project$Components$Referentiel$Fusion$Update$clavier(model.z$));
		case 35:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$DoublonsMsg,
				$author$project$Components$Referentiel$Doublons$Update$clavier(
					$author$project$Components$Referentiel$Doublons$Model$ouvrir(model.xM)));
		case 36:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$DoublonsMsg,
				$author$project$Components$Referentiel$Doublons$Update$clavier(
					$author$project$Components$Referentiel$Doublons$Model$ouvrir(model.xM)));
		default:
			return $elm$json$Json$Decode$fail('');
	}
};
var $author$project$Main$Update$TypesDeQuantiteMsg = function (a) {
	return {$: 47, a: a};
};
var $author$project$Components$Produits$TypesDeQuantite$Update$DuDrawer = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Produits$TypesDeQuantite$Update$clavier = function (model) {
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Produits$TypesDeQuantite$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX));
};
var $author$project$Components$Produits$TypesDeQuantite$Model$deballer = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Main$Update$clavierDesTypesDeQuantite = function (model) {
	var _v0 = model.Ih;
	if (_v0.$ === 49) {
		return A2(
			$elm$json$Json$Decode$map,
			$author$project$Main$Update$TypesDeQuantiteMsg,
			$author$project$Components$Produits$TypesDeQuantite$Update$clavier(
				$author$project$Components$Produits$TypesDeQuantite$Model$deballer(model.J1)));
	} else {
		return $elm$json$Json$Decode$fail('');
	}
};
var $author$project$Main$Update$TypesDeRelationMsg = function (a) {
	return {$: 60, a: a};
};
var $author$project$Components$Referentiel$TypesDeRelation$Update$DesNoms = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Referentiel$TypesDeRelation$Update$DuDrawer = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Referentiel$TypesDeRelation$Update$clavier = function (model) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$TypesDeRelation$Update$DesNoms,
				$author$project$Components$Shared$Drawer$Update$echap(model.DG)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$TypesDeRelation$Update$DuDrawer,
				$author$project$Components$Shared$Drawer$Update$echap(model.kX))
			]));
};
var $author$project$Main$Update$clavierDesTypesDeRelation = function (model) {
	var _v0 = model.Ih;
	if ((_v0.$ === 42) && (_v0.a === 6)) {
		var _v1 = _v0.a;
		return A2(
			$elm$json$Json$Decode$map,
			$author$project$Main$Update$TypesDeRelationMsg,
			$author$project$Components$Referentiel$TypesDeRelation$Update$clavier(model.J2));
	} else {
		return $elm$json$Json$Decode$fail('');
	}
};
var $author$project$Main$Update$UtilisateursMsg = function (a) {
	return {$: 52, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Update$AnnulationRenoncee = {$: 28};
var $author$project$Components$Parametrage$Utilisateurs$Update$DuDrawer = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Update$DuDrawerDeLiaison = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Update$GesteRenonce = {$: 18};
var $author$project$Components$Parametrage$Utilisateurs$Update$echap = function (renoncer) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (touche) {
			return _Utils_eq(
				touche,
				_Utils_Tuple2('Escape', false)) ? $elm$json$Json$Decode$succeed(renoncer) : $elm$json$Json$Decode$fail('');
		},
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'repeat', $elm$json$Json$Decode$bool)));
};
var $author$project$Components$Parametrage$Utilisateurs$Update$clavier = function (model) {
	return (!_Utils_eq(model.iq, $elm$core$Maybe$Nothing)) ? $author$project$Components$Parametrage$Utilisateurs$Update$echap($author$project$Components$Parametrage$Utilisateurs$Update$AnnulationRenoncee) : ((!_Utils_eq(model.iu, $elm$core$Maybe$Nothing)) ? $author$project$Components$Parametrage$Utilisateurs$Update$echap($author$project$Components$Parametrage$Utilisateurs$Update$GesteRenonce) : $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Parametrage$Utilisateurs$Update$DuDrawer,
				$author$project$Components$Shared$Drawer$Update$echap(model.kX)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Parametrage$Utilisateurs$Update$DuDrawerDeLiaison,
				$author$project$Components$Shared$Drawer$Update$echap(model.xO))
			])));
};
var $author$project$Components$Parametrage$Utilisateurs$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Main$Update$clavierDesUtilisateurs = function (model) {
	var _v0 = model.Ih;
	switch (_v0.$) {
		case 56:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$UtilisateursMsg,
				$author$project$Components$Parametrage$Utilisateurs$Update$clavier(
					$author$project$Components$Parametrage$Utilisateurs$Model$ouvrir(model.Kf)));
		case 57:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$UtilisateursMsg,
				$author$project$Components$Parametrage$Utilisateurs$Update$clavier(
					$author$project$Components$Parametrage$Utilisateurs$Model$ouvrir(model.Kf)));
		case 58:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$UtilisateursMsg,
				$author$project$Components$Parametrage$Utilisateurs$Update$clavier(
					$author$project$Components$Parametrage$Utilisateurs$Model$ouvrir(model.Kf)));
		case 59:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$UtilisateursMsg,
				$author$project$Components$Parametrage$Utilisateurs$Update$clavier(
					$author$project$Components$Parametrage$Utilisateurs$Model$ouvrir(model.Kf)));
		default:
			return $elm$json$Json$Decode$fail('');
	}
};
var $author$project$Main$Update$CompteDEnvoiMsg = function (a) {
	return {$: 55, a: a};
};
var $author$project$Components$Parametrage$CompteDEnvoi$Update$DuDrawer = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$CompteDEnvoi$Update$DuDrawerDAnnulation = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Parametrage$CompteDEnvoi$Update$DuDrawerDeDeconnexion = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Parametrage$CompteDEnvoi$Update$clavier = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.k8) ? $author$project$Components$Shared$Confirmation$Clavier$echap(
		$author$project$Components$Parametrage$CompteDEnvoi$Update$DuDrawerDeDeconnexion($author$project$Components$Shared$Drawer$Update$Fermer)) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.k$) ? $author$project$Components$Shared$Confirmation$Clavier$echap(
		$author$project$Components$Parametrage$CompteDEnvoi$Update$DuDrawerDAnnulation($author$project$Components$Shared$Drawer$Update$Fermer)) : A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Parametrage$CompteDEnvoi$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX)));
};
var $author$project$Main$Update$clavierDuCompteDEnvoi = function (model) {
	var _v0 = model.Ih;
	if (_v0.$ === 61) {
		return A2(
			$elm$json$Json$Decode$map,
			$author$project$Main$Update$CompteDEnvoiMsg,
			$author$project$Components$Parametrage$CompteDEnvoi$Update$clavier(model.vX));
	} else {
		return $elm$json$Json$Decode$fail('');
	}
};
var $author$project$Main$Update$CompteurDeCodeMsg = function (a) {
	return {$: 54, a: a};
};
var $author$project$Components$Parametrage$CompteurDeCode$Update$DuDrawer = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$CompteurDeCode$Update$clavier = function (model) {
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$Parametrage$CompteurDeCode$Update$DuDrawer,
		$author$project$Components$Shared$Drawer$Update$echap(model.kX));
};
var $author$project$Main$Update$clavierDuCompteur = function (model) {
	var _v0 = model.Ih;
	if (_v0.$ === 60) {
		return A2(
			$elm$json$Json$Decode$map,
			$author$project$Main$Update$CompteurDeCodeMsg,
			$author$project$Components$Parametrage$CompteurDeCode$Update$clavier(model.v$));
	} else {
		return $elm$json$Json$Decode$fail('');
	}
};
var $author$project$Components$Referentiel$Fiche$Model$ouvrir = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$Components$Shared$Navigation$Update$RechercheDemandee = {$: 1};
var $elm$json$Json$Decode$map5 = _Json_map5;
var $elm$core$String$toLower = _String_toLower;
var $author$project$Components$Shared$Navigation$Update$raccourci = A2(
	$elm$json$Json$Decode$andThen,
	function (demandee) {
		return demandee ? $elm$json$Json$Decode$succeed($author$project$Components$Shared$Navigation$Update$RechercheDemandee) : $elm$json$Json$Decode$fail('');
	},
	A6(
		$elm$json$Json$Decode$map5,
		F5(
			function (touche, ctrl, meta, alt, maj) {
				return ($elm$core$String$toLower(touche) === 'k') && ((ctrl || meta) && ((!alt) && (!maj)));
			}),
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'ctrlKey', $elm$json$Json$Decode$bool),
		A2($elm$json$Json$Decode$field, 'metaKey', $elm$json$Json$Decode$bool),
		A2($elm$json$Json$Decode$field, 'altKey', $elm$json$Json$Decode$bool),
		A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool)));
var $author$project$Main$Update$clavier = function (model) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$author$project$Main$Update$clavierDeLaCloche(model),
				A2($elm$json$Json$Decode$map, $author$project$Main$Update$NavigationMsg, $author$project$Components$Shared$Navigation$Update$raccourci),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$DemonstrationMsg,
				A2($author$project$Components$Demonstration$Update$clavier, model.Ih, model.xa)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Main$Update$FicheMsg,
				$author$project$Components$Referentiel$Fiche$Update$clavier(
					$author$project$Components$Referentiel$Fiche$Model$ouvrir(model.zo))),
				$author$project$Main$Update$clavierDesProduits(model),
				$author$project$Main$Update$clavierDesTypes(model),
				$author$project$Main$Update$clavierDesDroits(model),
				$author$project$Main$Update$clavierDesListes(model),
				$author$project$Main$Update$clavierDesCorrespondances(model),
				$author$project$Main$Update$clavierDesPerimetres(model),
				$author$project$Main$Update$clavierDesTypesDeQuantite(model),
				$author$project$Main$Update$clavierDeLaBibliotheque(model),
				$author$project$Main$Update$clavierDeLaConservation(model),
				$author$project$Main$Update$clavierDesLangues(model),
				$author$project$Main$Update$clavierDesUtilisateurs(model),
				$author$project$Main$Update$clavierDesImports(model),
				$author$project$Main$Update$clavierDuCompteur(model),
				$author$project$Main$Update$clavierDuCompteDEnvoi(model),
				$author$project$Main$Update$clavierDeLaSecurite(model),
				$author$project$Main$Update$clavierDesTypesDeRelation(model),
				$author$project$Main$Update$clavierDesPostes(model),
				$author$project$Main$Update$clavierDesFormes(model),
				$author$project$Main$Update$clavierDeLaListe(model)
			]));
};
var $author$project$Main$Update$clocheOuverte = function (model) {
	return model.oN.Es;
};
var $author$project$Components$Referentiel$Fiche$Update$ecouteLeDefilement = function (model) {
	return (!_Utils_eq(model.m6.I6, $elm$core$Maybe$Nothing)) && (!model.m6.an);
};
var $author$project$Main$Update$defilementDeLaFiche = function (model) {
	var _v0 = model.Ih;
	if ((_v0.$ === 3) && (_v0.b === 3)) {
		var _v1 = _v0.b;
		return $author$project$Components$Referentiel$Fiche$Update$ecouteLeDefilement(
			$author$project$Components$Referentiel$Fiche$Model$ouvrir(model.zo));
	} else {
		return false;
	}
};
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {pB: processes, rx: taggers};
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.pB;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.rx);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $elm$http$Http$fractionSent = function (p) {
	return (!p.rd) ? 1 : A3($elm$core$Basics$clamp, 0, 1, p.IE / p.rd);
};
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $elm$browser$Browser$AnimationManager$Time = function (a) {
	return {$: 0, a: a};
};
var $elm$browser$Browser$AnimationManager$State = F3(
	function (subs, request, oldTime) {
		return {hf: oldTime, qz: request, rl: subs};
	});
var $elm$browser$Browser$AnimationManager$init = $elm$core$Task$succeed(
	A3($elm$browser$Browser$AnimationManager$State, _List_Nil, $elm$core$Maybe$Nothing, 0));
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {zY: fragment, d2: host, E6: path, FX: port_, Gy: protocol, eI: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$AnimationManager$now = _Browser_now(0);
var $elm$browser$Browser$AnimationManager$rAF = _Browser_rAF(0);
var $elm$browser$Browser$AnimationManager$onEffects = F3(
	function (router, subs, _v0) {
		var request = _v0.qz;
		var oldTime = _v0.hf;
		var _v1 = _Utils_Tuple2(request, subs);
		if (_v1.a.$ === 1) {
			if (!_v1.b.b) {
				var _v2 = _v1.a;
				return $elm$browser$Browser$AnimationManager$init;
			} else {
				var _v4 = _v1.a;
				return A2(
					$elm$core$Task$andThen,
					function (pid) {
						return A2(
							$elm$core$Task$andThen,
							function (time) {
								return $elm$core$Task$succeed(
									A3(
										$elm$browser$Browser$AnimationManager$State,
										subs,
										$elm$core$Maybe$Just(pid),
										time));
							},
							$elm$browser$Browser$AnimationManager$now);
					},
					$elm$core$Process$spawn(
						A2(
							$elm$core$Task$andThen,
							$elm$core$Platform$sendToSelf(router),
							$elm$browser$Browser$AnimationManager$rAF)));
			}
		} else {
			if (!_v1.b.b) {
				var pid = _v1.a.a;
				return A2(
					$elm$core$Task$andThen,
					function (_v3) {
						return $elm$browser$Browser$AnimationManager$init;
					},
					$elm$core$Process$kill(pid));
			} else {
				return $elm$core$Task$succeed(
					A3($elm$browser$Browser$AnimationManager$State, subs, request, oldTime));
			}
		}
	});
var $elm$browser$Browser$AnimationManager$onSelfMsg = F3(
	function (router, newTime, _v0) {
		var subs = _v0.rl;
		var oldTime = _v0.hf;
		var send = function (sub) {
			if (!sub.$) {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(
						$elm$time$Time$millisToPosix(newTime)));
			} else {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(newTime - oldTime));
			}
		};
		return A2(
			$elm$core$Task$andThen,
			function (pid) {
				return A2(
					$elm$core$Task$andThen,
					function (_v1) {
						return $elm$core$Task$succeed(
							A3(
								$elm$browser$Browser$AnimationManager$State,
								subs,
								$elm$core$Maybe$Just(pid),
								newTime));
					},
					$elm$core$Task$sequence(
						A2($elm$core$List$map, send, subs)));
			},
			$elm$core$Process$spawn(
				A2(
					$elm$core$Task$andThen,
					$elm$core$Platform$sendToSelf(router),
					$elm$browser$Browser$AnimationManager$rAF)));
	});
var $elm$browser$Browser$AnimationManager$Delta = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$AnimationManager$subMap = F2(
	function (func, sub) {
		if (!sub.$) {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Time(
				A2($elm$core$Basics$composeL, func, tagger));
		} else {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Delta(
				A2($elm$core$Basics$composeL, func, tagger));
		}
	});
_Platform_effectManagers['Browser.AnimationManager'] = _Platform_createManager($elm$browser$Browser$AnimationManager$init, $elm$browser$Browser$AnimationManager$onEffects, $elm$browser$Browser$AnimationManager$onSelfMsg, 0, $elm$browser$Browser$AnimationManager$subMap);
var $elm$browser$Browser$AnimationManager$subscription = _Platform_leaf('Browser.AnimationManager');
var $elm$browser$Browser$AnimationManager$onAnimationFrame = function (tagger) {
	return $elm$browser$Browser$AnimationManager$subscription(
		$elm$browser$Browser$AnimationManager$Time(tagger));
};
var $elm$browser$Browser$Events$onAnimationFrame = $elm$browser$Browser$AnimationManager$onAnimationFrame;
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {pk: pids, rl: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {ml: event, nk: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.pk,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.nk;
		var event = _v0.ml;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.rl);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onKeyDown = A2($elm$browser$Browser$Events$on, 0, 'keydown');
var $elm$browser$Browser$Events$Hidden = 1;
var $elm$browser$Browser$Events$withHidden = F2(
	function (func, isHidden) {
		return func(
			isHidden ? 1 : 0);
	});
var $elm$browser$Browser$Events$onVisibilityChange = function (func) {
	var info = _Browser_visibilityInfo(0);
	return A3(
		$elm$browser$Browser$Events$on,
		0,
		info.u2,
		A2(
			$elm$json$Json$Decode$map,
			$elm$browser$Browser$Events$withHidden(func),
			A2(
				$elm$json$Json$Decode$field,
				'target',
				A2($elm$json$Json$Decode$field, info.Aj, $elm$json$Json$Decode$bool))));
};
var $author$project$Components$Socle$Session$Update$renouvelable = function (model) {
	var _v0 = _Utils_Tuple2(model.gt, model.GQ);
	if ((_v0.a.$ === 1) && (!_v0.b.$)) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Basics$round = _Basics_round;
var $author$project$API$Requete$traceurDuDepot = 'depot-direct';
var $author$project$Components$Produits$Common$API$HttpAPI$traceurDeLImage = $author$project$API$Requete$traceurDuDepot;
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {qy: reqs, rl: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.fe;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.qy));
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.rl)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					tf: r.tf,
					dr: r.dr,
					dU: A2(_Http_mapExpect, func, r.dU),
					d$: r.d$,
					eg: r.eg,
					fb: r.fb,
					fe: r.fe,
					aQ: r.aQ
				});
		}
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$track = F2(
	function (tracker, toMsg) {
		return $elm$http$Http$subscription(
			A2($elm$http$Http$MySub, tracker, toMsg));
	});
var $author$project$Main$abonnements = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$elm$browser$Browser$Events$onKeyDown(
				$author$project$Main$Update$clavier(model)),
				$author$project$Ports$aleaRecu($author$project$Main$Update$AleaRecu),
				A2(
				$elm$http$Http$track,
				$author$project$Components$Produits$Common$API$HttpAPI$traceurDeLImage,
				function (progres) {
					if (!progres.$) {
						var envoi = progres.a;
						return $author$project$Main$Update$ReferenceMsg(
							$author$project$Components$Produits$Reference$Update$ImageProgresse(
								$elm$core$Basics$round(
									$elm$http$Http$fractionSent(envoi) * 100)));
					} else {
						return $author$project$Main$Update$ReferenceMsg(
							$author$project$Components$Produits$Reference$Update$ImageProgresse(-1));
					}
				}),
				$author$project$Main$Update$defilementDeLaFiche(model) ? $elm$browser$Browser$Events$onAnimationFrame(
				function (_v1) {
					return $author$project$Main$Update$FicheMsg($author$project$Components$Referentiel$Fiche$Update$ImageDeLaPage);
				}) : $elm$core$Platform$Sub$none,
				$author$project$Components$Socle$Session$Update$renouvelable(model.e1) ? $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$time$Time$every,
						15000,
						A2($elm$core$Basics$composeR, $author$project$Components$Socle$Session$Update$HeureLue, $author$project$Main$Update$SessionMsg)),
						$elm$browser$Browser$Events$onVisibilityChange(
						function (visibilite) {
							return $author$project$Main$Update$SessionMsg(
								$author$project$Components$Socle$Session$Update$VisibiliteChangee(!visibilite));
						})
					])) : $elm$core$Platform$Sub$none,
				$author$project$Main$Update$clocheOuverte(model) ? A2(
				$elm$time$Time$every,
				60000,
				A2($elm$core$Basics$composeR, $author$project$Components$Notifications$Update$HeureLue, $author$project$Main$Update$NotificationsMsg)) : $elm$core$Platform$Sub$none
			]));
};
var $elm$browser$Browser$application = _Browser_application;
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$Components$Produits$Catalogue$Update$ARangerLue = function (a) {
	return {$: 42, a: a};
};
var $author$project$Main$Update$AccueilMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Imports$Outil$Update$AdmisesLues = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Main$Update$AlertesMsg = function (a) {
	return {$: 32, a: a};
};
var $author$project$Main$Update$AlertesPartiesPrenantesMsg = function (a) {
	return {$: 33, a: a};
};
var $author$project$Components$Produits$ListesDePrix$Update$AnnuaireLu = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$MarquesEtGammes$Update$AnnuaireLu = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$Offres$Update$AnnuaireLu = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$AnnuaireLu = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Marques$Update$AnnuaireLu = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Groupes$Update$AnnuaireLu = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Types$Update$AnnuaireLu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$TypesDeRelation$Update$AnnuaireLu = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$ApercuDArchivageRecu = function (a) {
	return {$: 58, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$ApercuDeLEffacementLu = F2(
	function (a, b) {
		return {$: 102, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Update$ApercuDeLExportLu = F3(
	function (a, b, c) {
		return {$: 97, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Fiche$Update$ApercuDeLaClotureLu = F2(
	function (a, b) {
		return {$: 96, a: a, b: b};
	});
var $author$project$Components$Produits$FicheType$Update$ApercuDeLaRegleLu = F2(
	function (a, b) {
		return {$: 32, a: a, b: b};
	});
var $author$project$Components$Produits$FicheType$Update$ApercuDeLaRestrictionLu = function (a) {
	return {$: 41, a: a};
};
var $author$project$Components$Referentiel$Types$Update$ApercuDeLaRestrictionLu = function (a) {
	return {$: 91, a: a};
};
var $author$project$Components$Produits$Catalogue$Update$ApercuDuLotLu = F2(
	function (a, b) {
		return {$: 50, a: a, b: b};
	});
var $author$project$Components$Imports$Outil$Update$ApercuLu = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Produits$FicheType$Update$ApercuLu = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$Produits$Reference$Update$ApercuLu = function (a) {
	return {$: 28, a: a};
};
var $author$project$Components$Referentiel$Fusion$Update$ApercuLu = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Referentiel$Types$Update$ApercuLu = function (a) {
	return {$: 63, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$ApercuRecu = function (a) {
	return {$: 173, a: a};
};
var $author$project$Components$Produits$Reference$Update$ArticlesTrouves = F2(
	function (a, b) {
		return {$: 53, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Update$ArticlesTrouves = F2(
	function (a, b) {
		return {$: 119, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fusion$Update$AvancementLu = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Produits$FicheType$Update$BibliothequeLue = function (a) {
	return {$: 54, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$BibliothequeLue = function (a) {
	return {$: 145, a: a};
};
var $author$project$Components$Referentiel$Type$Update$BibliothequeLue = function (a) {
	return {$: 30, a: a};
};
var $author$project$Components$Referentiel$Types$Update$BibliothequeLue = function (a) {
	return {$: 92, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$BlocRendu = F2(
	function (a, b) {
		return {$: 119, a: a, b: b};
	});
var $author$project$Components$Produits$Reference$Update$CatalogueDesFiltresLu = function (a) {
	return {$: 58, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$CatalogueDesFiltresLu = function (a) {
	return {$: 120, a: a};
};
var $author$project$Components$Produits$Catalogue$Update$CatalogueLu = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$CategorieLue = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Produits$Catalogue$Update$CategoriesProposees = F2(
	function (a, b) {
		return {$: 37, a: a, b: b};
	});
var $author$project$Components$Imports$Outil$Update$ChampsLus = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Update$ChronologieLue = F3(
	function (a, b, c) {
		return {$: 91, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$Catalogue$Update$CodeProposeLu = F4(
	function (a, b, c, d) {
		return {$: 40, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Referentiel$Type$Update$CollectionsLues = function (a) {
	return {$: 28, a: a};
};
var $author$project$Components$Referentiel$Types$Update$CollectionsLues = function (a) {
	return {$: 94, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$CommandeDeContactRendue = F2(
	function (a, b) {
		return {$: 34, a: a, b: b};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$CommandeDeGroupeRepondue = function (a) {
	return {$: 42, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$CommandeDeRoleRendue = F2(
	function (a, b) {
		return {$: 51, a: a, b: b};
	});
var $author$project$Components$Comptes$MonCompte$Update$CommandeRepondue = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Comptes$Securite$Update$CommandeRepondue = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Imports$Outil$Update$CommandeRepondue = function (a) {
	return {$: 37, a: a};
};
var $author$project$Components$Notifications$Update$CommandeRepondue = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$CommandeRepondue = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$CommandeRepondue = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Parametrage$CompteDEnvoi$Update$CommandeRepondue = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Parametrage$CompteurDeCode$Update$CommandeRepondue = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Parametrage$Conservation$Update$CommandeRepondue = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Parametrage$Droits$Update$CommandeRepondue = function (a) {
	return {$: 30, a: a};
};
var $author$project$Components$Parametrage$LanguesDuClient$Update$CommandeRepondue = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Parametrage$ModelesDeTache$Update$CommandeRepondue = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Update$CommandeRepondue = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$Update$CommandeRepondue = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$PipeEtape2$Update$CommandeRepondue = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$PipeEtape3$Update$CommandeRepondue = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$Update$CommandeRepondue = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$CommandeRepondue = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$PipeEtape6$Update$CommandeRepondue = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$PipeEtape7$Update$CommandeRepondue = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$PipeEtape8$Update$CommandeRepondue = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$PipeVersions$Update$CommandeRepondue = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Update$CommandeRepondue = function (a) {
	return {$: 30, a: a};
};
var $author$project$Components$Produits$Catalogue$Update$CommandeRepondue = function (a) {
	return {$: 35, a: a};
};
var $author$project$Components$Produits$Correspondances$Update$CommandeRepondue = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Produits$FicheElement$Update$CommandeRepondue = function (a) {
	return {$: 30, a: a};
};
var $author$project$Components$Produits$FicheType$Update$CommandeRepondue = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Produits$ListeDePrix$Update$CommandeRepondue = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Produits$Listes$Update$CommandeRepondue = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Produits$ListesDePrix$Update$CommandeRepondue = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Produits$MarquesEtGammes$Update$CommandeRepondue = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Produits$Offre$Update$CommandeRepondue = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Produits$Offres$Update$CommandeRepondue = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Produits$Perimetres$Update$CommandeRepondue = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$Produits$Reference$Update$CommandeRepondue = function (a) {
	return {$: 62, a: a};
};
var $author$project$Components$Produits$SchemaDeNiveau$Update$CommandeRepondue = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$CommandeRepondue = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Gammes$Update$CommandeRepondue = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Marques$Update$CommandeRepondue = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$CommandeRepondue = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$CommandeRepondue = function (a) {
	return {$: 176, a: a};
};
var $author$project$Components$Produits$TypesDeQuantite$Update$CommandeRepondue = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Referentiel$Formes$Update$CommandeRepondue = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Referentiel$Groupe$Update$CommandeRepondue = function (a) {
	return {$: 39, a: a};
};
var $author$project$Components$Referentiel$Postes$Update$CommandeRepondue = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Referentiel$Type$Update$CommandeRepondue = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$Referentiel$Types$Update$CommandeRepondue = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Referentiel$TypesDeRelation$Update$CommandeRepondue = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Produits$Offre$Update$ComptageLu = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$Offres$Update$ComptageLu = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Referentiel$Groupes$Update$CreationRepondue = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DeLApercu = {$: 3};
var $author$project$Components$Referentiel$Fiche$Update$DefilementLu = function (a) {
	return {$: 90, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$DelaiDOrganisationEcoule = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$DelaiDeDoublonEcoule = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Produits$ListeDePrix$Update$DelaiDeRechercheEcoule = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$DelaiDeRechercheEcoule = function (a) {
	return {$: 73, a: a};
};
var $author$project$Components$Referentiel$Fusion$Update$DelaiDeRechercheEcoule = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Referentiel$Groupe$Update$DelaiDeRechercheEcoule = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$DelaiDeRechercheEcoule = function (a) {
	return {$: 44, a: a};
};
var $author$project$Components$Comptes$MonCompte$Update$DelaiDeRelectureEcoule = {$: 3};
var $author$project$Components$Imports$Outil$Update$DelaiDeRelectureEcoule = {$: 46};
var $author$project$Components$Notifications$Update$DelaiDeRelectureEcoule = {$: 6};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DelaiDeRelectureEcoule = {$: 3};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$DelaiDeRelectureEcoule = {$: 3};
var $author$project$Components$Parametrage$CompteDEnvoi$Update$DelaiDeRelectureEcoule = {$: 3};
var $author$project$Components$Parametrage$CompteurDeCode$Update$DelaiDeRelectureEcoule = {$: 3};
var $author$project$Components$Parametrage$Conservation$Update$DelaiDeRelectureEcoule = {$: 4};
var $author$project$Components$Parametrage$Droits$Update$DelaiDeRelectureEcoule = {$: 3};
var $author$project$Components$Parametrage$LanguesDuClient$Update$DelaiDeRelectureEcoule = {$: 3};
var $author$project$Components$Parametrage$Utilisateurs$Update$DelaiDeRelectureEcoule = {$: 6};
var $author$project$Components$Produits$Catalogue$Update$DelaiDeRelectureEcoule = {$: 26};
var $author$project$Components$Produits$Correspondances$Update$DelaiDeRelectureEcoule = {$: 3};
var $author$project$Components$Produits$FicheElement$Update$DelaiDeRelectureEcoule = {$: 3};
var $author$project$Components$Produits$FicheType$Update$DelaiDeRelectureEcoule = {$: 4};
var $author$project$Components$Produits$ListeDePrix$Update$DelaiDeRelectureEcoule = {$: 3};
var $author$project$Components$Produits$Listes$Update$DelaiDeRelectureEcoule = {$: 3};
var $author$project$Components$Produits$ListesDePrix$Update$DelaiDeRelectureEcoule = {$: 3};
var $author$project$Components$Produits$MarquesEtGammes$Update$DelaiDeRelectureEcoule = {$: 3};
var $author$project$Components$Produits$Offre$Update$DelaiDeRelectureEcoule = {$: 6};
var $author$project$Components$Produits$Offres$Update$DelaiDeRelectureEcoule = {$: 5};
var $author$project$Components$Produits$Perimetres$Update$DelaiDeRelectureEcoule = {$: 3};
var $author$project$Components$Produits$Reference$Update$DelaiDeRelectureEcoule = {$: 7};
var $author$project$Components$Produits$SchemaDeNiveau$Update$DelaiDeRelectureEcoule = {$: 4};
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$DelaiDeRelectureEcoule = {$: 3};
var $author$project$Components$Produits$StructureCatalogue$Gammes$Update$DelaiDeRelectureEcoule = {$: 2};
var $author$project$Components$Produits$StructureCatalogue$Marques$Update$DelaiDeRelectureEcoule = {$: 3};
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$DelaiDeRelectureEcoule = {$: 10};
var $author$project$Components$Produits$StructureCatalogue$Update$DelaiDeRelectureEcoule = {$: 8};
var $author$project$Components$Produits$TypesDeQuantite$Update$DelaiDeRelectureEcoule = {$: 3};
var $author$project$Components$Referentiel$Formes$Update$DelaiDeRelectureEcoule = {$: 3};
var $author$project$Components$Referentiel$NouvelleFiche$Update$DelaiDeRelectureEcoule = function (a) {
	return {$: 43, a: a};
};
var $author$project$Components$Referentiel$Postes$Update$DelaiDeRelectureEcoule = {$: 3};
var $author$project$Components$Referentiel$Type$Update$DelaiDeRelectureEcoule = {$: 13};
var $author$project$Components$Referentiel$Types$Update$DelaiDeRelectureEcoule = {$: 5};
var $author$project$Components$Referentiel$TypesDeRelation$Update$DelaiDeRelectureEcoule = {$: 4};
var $author$project$Components$Produits$Catalogue$Update$DelaiDeSaisieEcoule = function (a) {
	return {$: 27, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$DelaiDeSaisieEcoule = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$DelaiEcoule = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Produits$Reference$Update$DepotClos = function (a) {
	return {$: 69, a: a};
};
var $author$project$Components$Produits$Reference$Update$DocumentsLus = function (a) {
	return {$: 73, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$DoublonRecu = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$DoublonsRecus = F2(
	function (a, b) {
		return {$: 45, a: a, b: b};
	});
var $author$project$Components$Referentiel$Doublons$Update$Ecartee = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$EffacementRendu = F2(
	function (a, b) {
		return {$: 108, a: a, b: b};
	});
var $author$project$Components$Referentiel$Groupe$Update$EquipeLue = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Referentiel$Groupes$Update$EquipeLue = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$EquipeLue = F2(
	function (a, b) {
		return {$: 27, a: a, b: b};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$EquipeLue = F2(
	function (a, b) {
		return {$: 33, a: a, b: b};
	});
var $author$project$Components$Socle$Session$Update$EspacesRecus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$EtablissementRelie = function (a) {
	return {$: 51, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$ExportRendu = F2(
	function (a, b) {
		return {$: 115, a: a, b: b};
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$FicheCreee = function (a) {
	return {$: 41, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$FicheCreeeLue = function (a) {
	return {$: 50, a: a};
};
var $author$project$Components$Produits$FicheElement$Update$FicheLue = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$FicheType$Update$FicheLue = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$ListeDePrix$Update$FicheLue = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$Offre$Update$FicheLue = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Produits$Reference$Update$FicheLue = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$FicheLue = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Gammes$Update$FicheLue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$FicheLue = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fusion$Update$FicheLue = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$Referentiel$Groupe$Update$FicheLue = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Type$Update$FicheLue = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$FicheRejoueeLue = F2(
	function (a, b) {
		return {$: 42, a: a, b: b};
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$FicheRestauree = F2(
	function (a, b) {
		return {$: 56, a: a, b: b};
	});
var $author$project$Components$Imports$Outil$Update$FichierChoisi = function (a) {
	return {$: 8, a: a};
};
var $author$project$Main$Update$FichierChoisi = function (a) {
	return {$: 65, a: a};
};
var $author$project$Main$Update$FocusPlace = {$: 64};
var $author$project$Components$Referentiel$Fiche$Update$FormesLues = function (a) {
	return {$: 70, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$FormesLues = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Referentiel$TypesDeRelation$Update$FormesLues = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Referentiel$Fusion$Update$FusionRepondue = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$GesteRendu = F2(
	function (a, b) {
		return {$: 63, a: a, b: b};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$GroupeChoisiLu = function (a) {
	return {$: 37, a: a};
};
var $author$project$Components$Notifications$Update$GroupeLu = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$GroupesLus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Main$Update$GroupesMsg = function (a) {
	return {$: 38, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$HistoriqueDuChampLu = F3(
	function (a, b, c) {
		return {$: 93, a: a, b: b, c: c};
	});
var $author$project$Components$Imports$Outil$Update$HistoriqueLu = function (a) {
	return {$: 76, a: a};
};
var $author$project$Components$Produits$Reference$Update$HistoriqueLu = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Produits$Reference$Update$ImageLue = function (a) {
	return {$: 76, a: a};
};
var $author$project$Components$Produits$Reference$Update$ImagePosee = function (a) {
	return {$: 78, a: a};
};
var $author$project$Components$Produits$Reference$Update$ImageRepondue = F2(
	function (a, b) {
		return {$: 77, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Update$InformationsLues = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Socle$Session$Update$JetonRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Socle$Session$Update$JetonRenouvele = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Imports$Outil$Update$LectureLue = function (a) {
	return {$: 60, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$LectureRevenue = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$LiaisonRendue = F2(
	function (a, b) {
		return {$: 57, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Update$LienDeChamp = function (a) {
	return {$: 127, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$LienDeChamp = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Imports$Outil$Update$LignesRejeteesLues = function (a) {
	return {$: 88, a: a};
};
var $author$project$Components$Referentiel$Type$Update$ListeDePrixLue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$FicheType$Update$ListeDuChampLue = function (a) {
	return {$: 33, a: a};
};
var $author$project$Components$Referentiel$Types$Update$ListeDuChampLue = function (a) {
	return {$: 83, a: a};
};
var $author$project$Components$Produits$Catalogue$Update$ListeLue = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Referentiel$Formes$Update$ListeLue = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$ListeLue = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Referentiel$Postes$Update$ListeLue = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Update$ListesLues = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$FicheType$Update$ListesLues = function (a) {
	return {$: 52, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$ListesLues = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Referentiel$Types$Update$ListesLues = function (a) {
	return {$: 95, a: a};
};
var $author$project$Components$Imports$Outil$Update$LotLu = function (a) {
	return {$: 38, a: a};
};
var $author$project$Components$Imports$Outil$Update$LotsLus = function (a) {
	return {$: 58, a: a};
};
var $author$project$Components$Parametrage$CompteDEnvoi$Update$Lu = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Accueil$Update$Lue = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Comptes$MonCompte$Update$Lue = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Comptes$Securite$Update$Lue = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Imports$Outil$Update$Lue = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Notifications$Update$Lue = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$Lue = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$Lue = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$CompteurDeCode$Update$Lue = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Parametrage$Conservation$Update$Lue = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Parametrage$Droits$Update$Lue = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Parametrage$LanguesDuClient$Update$Lue = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Parametrage$ModelesDeTache$Update$Lue = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeDestinations$Update$Lue = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$Lue = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$Lue = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape3$Update$Lue = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$Lue = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$Lue = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape6$Update$Lue = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape7$Update$Lue = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape8$Update$Lue = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeOffreUsage$Update$Lue = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeRelationsExigees$Update$Lue = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeVersions$Update$Lue = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Parametrage$Utilisateurs$Update$Lue = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$Produits$Alertes$Update$Lue = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Produits$Correspondances$Update$Lue = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Produits$Listes$Update$Lue = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Produits$Perimetres$Update$Lue = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Produits$TypesDeQuantite$Update$Lue = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Alertes$Update$Lue = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Referentiel$Doublons$Update$Lue = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Update$ModificationRendue = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Main$Update$MonCompteMsg = function (a) {
	return {$: 56, a: a};
};
var $author$project$Components$Produits$Reference$Update$MorceauPose = function (a) {
	return {$: 68, a: a};
};
var $author$project$Components$Produits$Catalogue$Update$NombreARangerLu = F2(
	function (a, b) {
		return {$: 43, a: a, b: b};
	});
var $author$project$Components$Referentiel$Groupe$Update$NombreLu = F2(
	function (a, b) {
		return {$: 35, a: a, b: b};
	});
var $author$project$Components$Referentiel$Groupe$Update$NonAjouteesLues = function (a) {
	return {$: 45, a: a};
};
var $author$project$Main$Update$NormesLues = F2(
	function (a, b) {
		return {$: 59, a: a, b: b};
	});
var $author$project$Components$Referentiel$Groupe$Update$NotificationsDeFinLues = function (a) {
	return {$: 41, a: a};
};
var $author$project$Components$Notifications$Update$NouvellesRecues = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$OccurrenceRendue = F2(
	function (a, b) {
		return {$: 124, a: a, b: b};
	});
var $author$project$Components$Produits$Reference$Update$OctetsLus = function (a) {
	return {$: 66, a: a};
};
var $author$project$Components$Imports$Outil$Update$OffresLues = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$OffresLues = function (a) {
	return {$: 37, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$OffresLues = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Referentiel$Type$Update$OffresLues = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Types$Update$OffresLues = function (a) {
	return {$: 41, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$OffresRecues = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Produits$FicheElement$Update$OrdreLu = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$Produits$FicheType$Update$OrdreLu = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Referentiel$Types$Update$OrdreLu = function (a) {
	return {$: 59, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$OrganisationsLues = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Referentiel$Doublons$Update$PaireLue = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Produits$Reference$Update$PartiesPrenantesProposees = F2(
	function (a, b) {
		return {$: 74, a: a, b: b};
	});
var $author$project$Components$Produits$Reference$Update$PerimetresLus = F2(
	function (a, b) {
		return {$: 44, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Update$PerimetresLus = F2(
	function (a, b) {
		return {$: 109, a: a, b: b};
	});
var $author$project$Components$Referentiel$Types$Update$PerimetresLus = function (a) {
	return {$: 48, a: a};
};
var $author$project$Main$Update$PipeDestinationsMsg = function (a) {
	return {$: 24, a: a};
};
var $author$project$Main$Update$PipeEtape8Msg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Main$Update$PipeOffreUsageMsg = function (a) {
	return {$: 23, a: a};
};
var $author$project$Main$Update$PipeRelationsExigeesMsg = function (a) {
	return {$: 25, a: a};
};
var $author$project$Components$Parametrage$Pipes$Update$PipesLus = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$Update$PipesMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$PostesLus = function (a) {
	return {$: 69, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$PostesLus = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$PreferencesEnregistrees = function (a) {
	return {$: 31, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$PreferencesLues = function (a) {
	return {$: 30, a: a};
};
var $author$project$Components$Socle$Session$Update$PreferencesRecues = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Referentiel$Fusion$Model$Premiere = 0;
var $author$project$Components$Produits$Offre$Update$PrixLus = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Produits$Offres$Update$PrixLus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$Reference$Update$PrixLus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$Reference$Update$ProduitLu = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$Produits$Catalogue$Update$ProduitsProposes = F3(
	function (a, b, c) {
		return {$: 38, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Fiche$Update$PropositionsLues = F2(
	function (a, b) {
		return {$: 74, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fusion$Update$PropositionsLues = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$Referentiel$Groupe$Update$PropositionsLues = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Components$Socle$Session$Update$RacineRecue = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Imports$Outil$Update$RapportLu = function (a) {
	return {$: 43, a: a};
};
var $author$project$Components$Imports$Outil$Update$Reappliquee = F2(
	function (a, b) {
		return {$: 35, a: a, b: b};
	});
var $author$project$Components$Referentiel$Common$ChoixDeLien$Recue = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Produits$ListeDePrix$Update$ReferencesTrouvees = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$RoleAjoute = F2(
	function (a, b) {
		return {$: 54, a: a, b: b};
	});
var $author$project$Components$Imports$Outil$Update$RolesLus = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Referentiel$Doublons$Update$Rouverte = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Produits$Catalogue$Update$SchemaLu = F3(
	function (a, b, c) {
		return {$: 39, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$SchemaDeNiveau$Update$SchemaLu = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Referentiel$Fusion$Model$Seconde = 1;
var $author$project$Components$Imports$Outil$Update$SimulationLue = function (a) {
	return {$: 44, a: a};
};
var $author$project$Components$Produits$Reference$Update$StructureDesFiltresLue = function (a) {
	return {$: 59, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$StructureDesFiltresLue = function (a) {
	return {$: 121, a: a};
};
var $author$project$Components$Produits$Catalogue$Update$StructureLue = function (a) {
	return {$: 36, a: a};
};
var $author$project$Components$Produits$SchemaDeNiveau$Update$StructureLue = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$StructureLue = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Referentiel$Groupe$Update$SuiviARelire = {$: 42};
var $author$project$Components$Imports$Outil$Update$SuiviLu = function (a) {
	return {$: 41, a: a};
};
var $author$project$Components$Referentiel$Groupe$Update$SuiviLu = function (a) {
	return {$: 43, a: a};
};
var $author$project$Main$Update$ThemeMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Socle$Theme$Update$ThemeRecu = $elm$core$Basics$identity;
var $author$project$Components$Socle$Session$Update$TraductionsRecues = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Notifications$Update$TraitementsLus = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Referentiel$Groupe$Update$TraitementsLus = function (a) {
	return {$: 40, a: a};
};
var $author$project$Components$Referentiel$Types$Update$TypeLu = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Referentiel$Types$Update$TypeRegleLu = function (a) {
	return {$: 30, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$TypesDeRelationLues = function (a) {
	return {$: 49, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$TypesDeRelationLus = function (a) {
	return {$: 83, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$TypesLus = function (a) {
	return {$: 36, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$TypesLus = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$TypesRecus = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Produits$Reference$Update$ValeurDuPerimetreLue = F2(
	function (a, b) {
		return {$: 25, a: a, b: b};
	});
var $author$project$Components$Imports$Outil$Update$ValeursLuesPour = F2(
	function (a, b) {
		return {$: 57, a: a, b: b};
	});
var $author$project$Components$Produits$FicheType$Update$ValeursPoseesLues = function (a) {
	return {$: 43, a: a};
};
var $author$project$Components$Produits$FicheType$Update$VersionsLues = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Referentiel$Types$Update$VersionsLues = function (a) {
	return {$: 77, a: a};
};
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$API$Requete$sansReponse = {f$: '', ri: 0};
var $author$project$API$Requete$reponse = function (recue) {
	switch (recue.$) {
		case 4:
			var metadata = recue.a;
			var corps = recue.b;
			return {f$: corps, ri: metadata.rh};
		case 3:
			var metadata = recue.a;
			var corps = recue.b;
			return {f$: corps, ri: metadata.rh};
		default:
			return $author$project$API$Requete$sansReponse;
	}
};
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{tf: false, dr: r.dr, dU: r.dU, d$: r.d$, eg: r.eg, fb: r.fb, fe: r.fe, aQ: r.aQ}));
};
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$API$Requete$requeteJson = F2(
	function (delai, requete) {
		return $elm$http$Http$request(
			{
				dr: A2(
					$elm$core$Maybe$withDefault,
					$elm$http$Http$emptyBody,
					A2($elm$core$Maybe$map, $elm$http$Http$jsonBody, requete.f$)),
				dU: A2(
					$elm$http$Http$expectStringResponse,
					$elm$core$Result$withDefault($author$project$API$Requete$sansReponse),
					A2($elm$core$Basics$composeR, $author$project$API$Requete$reponse, $elm$core$Result$Ok)),
				d$: _List_fromArray(
					[
						A2($elm$http$Http$header, 'Authorization', 'Bearer ' + requete.gM)
					]),
				eg: requete.sm,
				fb: delai,
				fe: $elm$core$Maybe$Nothing,
				aQ: requete.aQ
			});
	});
var $author$project$API$Requete$authentifiee = $author$project$API$Requete$requeteJson($elm$core$Maybe$Nothing);
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$champFacultatif = F2(
	function (nom, valeur) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (saisie) {
					return _List_fromArray(
						[
							_Utils_Tuple2(
							nom,
							$elm$json$Json$Encode$string(saisie))
						]);
				},
				valeur));
	});
var $author$project$API$ProcessUid$encode = function (_v0) {
	var valeur = _v0;
	return $elm$json$Json$Encode$string(valeur);
};
var $author$project$Components$Referentiel$Identifiants$entiteUidToString = function (_v0) {
	var valeur = _v0;
	return valeur;
};
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Components$Referentiel$Identifiants$typeUidEncode = function (_v0) {
	var valeur = _v0;
	return $elm$json$Json$Encode$string(valeur);
};
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$encodeAjouterLeRole = F4(
	function (processUid, entite, type_, offre) {
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'processUid',
						$author$project$API$ProcessUid$encode(processUid)),
						_Utils_Tuple2(
						'entite',
						$elm$json$Json$Encode$string(
							$author$project$Components$Referentiel$Identifiants$entiteUidToString(entite))),
						_Utils_Tuple2(
						'type',
						$author$project$Components$Referentiel$Identifiants$typeUidEncode(type_))
					]),
				A2($author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$champFacultatif, 'offre', offre)));
	});
var $author$project$Components$Referentiel$NouvelleFiche$API$HttpAPI$ajouterLeRoleReq = F2(
	function (ajout, jeton) {
		return $author$project$API$Requete$authentifiee(
			{
				f$: $elm$core$Maybe$Just(
					A4($author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$encodeAjouterLeRole, ajout.Gn, ajout.zo, ajout.r0, ajout.D1)),
				gM: jeton,
				aQ: ajout.nB.cM,
				sm: ajout.nB.sm
			});
	});
var $elm$http$Http$filePart = _Http_pair;
var $elm$http$Http$multipartBody = function (parts) {
	return A2(
		_Http_pair,
		'',
		_Http_toFormData(parts));
};
var $author$project$API$Requete$authentifieeEnMultipart = function (requete) {
	return $elm$http$Http$request(
		{
			dr: $elm$http$Http$multipartBody(requete.E0),
			dU: A2(
				$elm$http$Http$expectStringResponse,
				$elm$core$Result$withDefault($author$project$API$Requete$sansReponse),
				A2($elm$core$Basics$composeR, $author$project$API$Requete$reponse, $elm$core$Result$Ok)),
			d$: _List_fromArray(
				[
					A2($elm$http$Http$header, 'Authorization', 'Bearer ' + requete.gM)
				]),
			eg: requete.sm,
			fb: $elm$core$Maybe$Nothing,
			fe: $elm$core$Maybe$Nothing,
			aQ: requete.aQ
		});
};
var $author$project$Components$Imports$Outil$API$HttpAPI$multipart = F3(
	function (jeton, lien, parties) {
		return $author$project$API$Requete$authentifieeEnMultipart(
			{gM: jeton, E0: parties, aQ: lien.cM, sm: lien.sm});
	});
var $elm$http$Http$stringPart = _Http_pair;
var $author$project$Components$Imports$Outil$API$HttpAPI$apercevoirReq = function (requete) {
	return A3(
		$author$project$Components$Imports$Outil$API$HttpAPI$multipart,
		requete.gM,
		requete.nB,
		A2(
			$elm$core$List$cons,
			A2($elm$http$Http$filePart, 'fichier', requete.gw),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (_v0) {
						var domaine = _v0.a;
						var type_ = _v0.b;
						return _List_fromArray(
							[
								A2($elm$http$Http$stringPart, 'domaine', domaine),
								A2($elm$http$Http$stringPart, 'type', type_)
							]);
					},
					requete.vf))));
};
var $author$project$Catalogue$Identifiants$classificationIdEncode = function (_v0) {
	var valeur = _v0;
	return $elm$json$Json$Encode$string(valeur);
};
var $author$project$Catalogue$Identifiants$elementIdEncode = function (_v0) {
	var valeur = _v0;
	return $elm$json$Json$Encode$string(valeur);
};
var $author$project$Catalogue$Identifiants$typeDeProduitIdEncode = function (_v0) {
	var valeur = _v0;
	return $elm$json$Json$Encode$string(valeur);
};
var $author$project$Catalogue$Identifiants$valeurIdEncode = function (_v0) {
	var valeur = _v0;
	return $elm$json$Json$Encode$string(valeur);
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeValeurDEtage = function (valeur) {
	switch (valeur.$) {
		case 0:
			var id = valeur.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'Libre',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'valeur',
									$author$project$Catalogue$Identifiants$valeurIdEncode(id))
								])))
					]));
		case 1:
			var id = valeur.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'Element',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'element',
									$author$project$Catalogue$Identifiants$elementIdEncode(id))
								])))
					]));
		case 2:
			var id = valeur.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'Categorie',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'typeDeProduit',
									$author$project$Catalogue$Identifiants$typeDeProduitIdEncode(id))
								])))
					]));
		default:
			var id = valeur.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'Produit',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'produit',
									$author$project$Catalogue$Identifiants$elementIdEncode(id))
								])))
					]));
	}
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$facultatif = F3(
	function (nom, encoder, valeur) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (present) {
					return _List_fromArray(
						[
							_Utils_Tuple2(
							nom,
							encoder(present))
						]);
				},
				valeur));
	});
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Catalogue$Identifiants$referenceIdEncode = function (_v0) {
	var valeur = _v0;
	return $elm$json$Json$Encode$string(valeur);
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$porteeDArchivage = F2(
	function (references, filtre) {
		return ($elm$core$List$isEmpty(references) && _Utils_eq(filtre, $elm$core$Maybe$Nothing)) ? _List_Nil : _List_fromArray(
			[
				_Utils_Tuple2(
				'portee',
				$elm$json$Json$Encode$object(
					_Utils_ap(
						A3($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$facultatif, 'filtre', $elm$core$Basics$identity, filtre),
						$elm$core$List$isEmpty(references) ? _List_Nil : _List_fromArray(
							[
								_Utils_Tuple2(
								'references',
								A2($elm$json$Json$Encode$list, $author$project$Catalogue$Identifiants$referenceIdEncode, references))
							]))))
			]);
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeChoix = function (choix) {
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			A3($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$facultatif, 'cible', $author$project$Catalogue$Identifiants$classificationIdEncode, choix.vf),
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'correspondance',
						A2(
							$elm$json$Json$Encode$list,
							function (_v0) {
								var source = _v0.a;
								var cible = _v0.b;
								return $elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'source',
											$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeValeurDEtage(source)),
											_Utils_Tuple2(
											'cible',
											$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeValeurDEtage(cible))
										]));
							},
							choix.wg)),
						_Utils_Tuple2(
						'aCloturer',
						A2($elm$json$Json$Encode$list, $author$project$Catalogue$Identifiants$typeDeProduitIdEncode, choix.it))
					]),
				A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$porteeDArchivage, choix.hD, choix.zH))));
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeApercuDArchivage = F2(
	function (classification, choix) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'classification',
					$author$project$Catalogue$Identifiants$classificationIdEncode(classification)),
					_Utils_Tuple2(
					'choix',
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeChoix(choix))
				]));
	});
var $author$project$Components$Produits$StructureCatalogue$API$HttpAPI$apercuDArchivageReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeApercuDArchivage, requete.r3, requete.jN)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$Catalogue$RegleDeCode$encodeSegment = function (segment) {
	switch (segment.$) {
		case 0:
			var texte = segment.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'TexteFixe',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'texte',
									$elm$json$Json$Encode$string(texte))
								])))
					]));
		case 1:
			var champ = segment.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'CodeDeLaMarque',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'champ',
									$elm$json$Json$Encode$string(champ))
								])))
					]));
		case 2:
			var champ = segment.a;
			var tranche = segment.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'CodeDUneValeur',
						$elm$json$Json$Encode$object(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'champ',
									$elm$json$Json$Encode$string(champ)),
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function (n) {
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'tranche',
													$elm$json$Json$Encode$int(n))
												]);
										},
										tranche)))))
					]));
		default:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'Compteur',
						$elm$json$Json$Encode$object(_List_Nil))
					]));
	}
};
var $author$project$Components$Produits$Common$API$HttpAPI$apercuDeLaRegleDeCodeReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'typeDeProduit',
							$elm$json$Json$Encode$string(requete.fh)),
							_Utils_Tuple2(
							'regle',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'segments',
										A2($elm$json$Json$Encode$list, $author$project$Catalogue$RegleDeCode$encodeSegment, requete.Iy))
									])))
						]))),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Produits$Common$API$HttpAPI$apercuDeLaRestrictionReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'typeDeProduit',
							$elm$json$Json$Encode$string(requete.fh)),
							_Utils_Tuple2(
							'champ',
							$elm$json$Json$Encode$string(requete.uN)),
							_Utils_Tuple2(
							'valeurs',
							A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, requete.Ki))
						]))),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Referentiel$Common$API$HttpAPI$apercuDeLaRestrictionReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string(requete.r0)),
							_Utils_Tuple2(
							'champ',
							$elm$json$Json$Encode$string(requete.uN)),
							_Utils_Tuple2(
							'valeurs',
							A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, requete.Ki))
						]))),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$Texte = {$: 0};
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$Components$Shared$EditeurDeSchema$Champ$cleDeLOccurrence = 'uid';
var $author$project$Components$Shared$EditeurDeSchema$Champ$cleDesMasques = 'masques';
var $author$project$Components$Shared$EditeurDeSchema$Champ$cleDesUniques = 'uniques';
var $author$project$Components$Shared$GenreDuNom$code = function (genre) {
	if (!genre) {
		return 'feminin';
	} else {
		return 'masculin';
	}
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$codeDuGenre = $author$project$Components$Shared$GenreDuNom$code;
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $author$project$Components$Shared$EditeurDeSchema$Champ$encodeParCle = function (table) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$mapSecond($elm$json$Json$Encode$string),
			table));
};
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom = F2(
	function (nom, attributs) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					nom,
					$elm$json$Json$Encode$object(attributs))
				]));
	});
var $author$project$Components$Shared$EditeurDeSchema$Champ$encodeBorne = function (borne) {
	switch (borne.$) {
		case 0:
			var valeur = borne.a;
			return A2(
				$author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom,
				'Nombre',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'valeur',
						$elm$json$Json$Encode$float(valeur))
					]));
		case 1:
			var date = borne.a;
			return A2(
				$author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom,
				'Jour',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'date',
						$elm$json$Json$Encode$string(date))
					]));
		default:
			var inclus = borne.a;
			return A2(
				$author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom,
				'Aujourdhui',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'inclus',
						$elm$json$Json$Encode$bool(inclus))
					]));
	}
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$present = F3(
	function (nom, ecrire, valeur) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (fournie) {
					return _List_fromArray(
						[
							_Utils_Tuple2(
							nom,
							ecrire(fournie))
						]);
				},
				valeur));
	});
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $author$project$Components$Shared$EditeurDeSchema$Champ$relu = function (json) {
	return A2(
		$elm$core$Result$withDefault,
		$elm$json$Json$Encode$null,
		A2($elm$json$Json$Decode$decodeString, $elm$json$Json$Decode$value, json));
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$encodeRegle = function (regle) {
	switch (regle.$) {
		case 0:
			var min = regle.a;
			var max = regle.b;
			return A2(
				$author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom,
				'Bornes',
				_Utils_ap(
					A3($author$project$Components$Shared$EditeurDeSchema$Champ$present, 'min', $author$project$Components$Shared$EditeurDeSchema$Champ$encodeBorne, min),
					A3($author$project$Components$Shared$EditeurDeSchema$Champ$present, 'max', $author$project$Components$Shared$EditeurDeSchema$Champ$encodeBorne, max)));
		case 1:
			var min = regle.a;
			var max = regle.b;
			return A2(
				$author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom,
				'Longueur',
				_Utils_ap(
					A3($author$project$Components$Shared$EditeurDeSchema$Champ$present, 'min', $elm$json$Json$Encode$int, min),
					A3($author$project$Components$Shared$EditeurDeSchema$Champ$present, 'max', $elm$json$Json$Encode$int, max)));
		case 2:
			var regex = regle.a;
			var message = regle.b;
			return A2(
				$author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom,
				'Motif',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'regex',
						$elm$json$Json$Encode$string(regex)),
						_Utils_Tuple2(
						'message',
						$elm$json$Json$Encode$string(message))
					]));
		case 3:
			return A2($author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom, 'Unique', _List_Nil);
		default:
			var json = regle.a;
			return $author$project$Components$Shared$EditeurDeSchema$Champ$relu(json);
	}
};
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$Toujours = {$: 0};
var $author$project$Components$Shared$EditeurDeSchema$Champ$nouveau = function (fourni) {
	return {sG: false, bp: '', bq: _List_Nil, dy: fourni.dy, v6: $elm$core$Maybe$Nothing, xD: false, zU: $elm$core$Maybe$Nothing, Bl: fourni.Bl, R: _List_Nil, Bt: _List_Nil, he: false, hJ: _List_Nil, h8: false, r0: fourni.r0, KQ: $author$project$Components$Shared$EditeurDeSchema$Champ$Toujours};
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$prefixeDeListe = 'liste:';
var $author$project$Components$Shared$EditeurDeSchema$Champ$prefixeDePartiePrenante = 'partie-prenante:';
var $author$project$Components$Shared$EditeurDeSchema$Champ$prefixeDeRessource = 'ressource:';
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$si = F3(
	function (ecrit, nom, valeur) {
		return ecrit ? _List_fromArray(
			[
				_Utils_Tuple2(nom, valeur)
			]) : _List_Nil;
	});
var $author$project$Components$Shared$EditeurDeSchema$Champ$Adresse = {$: 14};
var $author$project$Components$Shared$EditeurDeSchema$Champ$Date = {$: 5};
var $author$project$Components$Shared$EditeurDeSchema$Champ$Devise = {$: 13};
var $author$project$Components$Shared$EditeurDeSchema$Champ$Email = {$: 11};
var $author$project$Components$Shared$EditeurDeSchema$Champ$Montant = {$: 4};
var $author$project$Components$Shared$EditeurDeSchema$Champ$Nombre = {$: 3};
var $author$project$Components$Shared$EditeurDeSchema$Champ$OuiNon = {$: 6};
var $author$project$Components$Shared$EditeurDeSchema$Champ$Telephone = {$: 12};
var $author$project$Components$Shared$EditeurDeSchema$Champ$TexteLong = {$: 1};
var $author$project$Components$Shared$EditeurDeSchema$Champ$TexteMisEnForme = {$: 2};
var $author$project$Components$Shared$EditeurDeSchema$Champ$typesSansAttribut = _List_fromArray(
	[
		_Utils_Tuple2('Text', $author$project$Components$Shared$EditeurDeSchema$Champ$Texte),
		_Utils_Tuple2('LongText', $author$project$Components$Shared$EditeurDeSchema$Champ$TexteLong),
		_Utils_Tuple2('Markdown', $author$project$Components$Shared$EditeurDeSchema$Champ$TexteMisEnForme),
		_Utils_Tuple2('Number', $author$project$Components$Shared$EditeurDeSchema$Champ$Nombre),
		_Utils_Tuple2('Money', $author$project$Components$Shared$EditeurDeSchema$Champ$Montant),
		_Utils_Tuple2('Date', $author$project$Components$Shared$EditeurDeSchema$Champ$Date),
		_Utils_Tuple2('Bool', $author$project$Components$Shared$EditeurDeSchema$Champ$OuiNon),
		_Utils_Tuple2('Email', $author$project$Components$Shared$EditeurDeSchema$Champ$Email),
		_Utils_Tuple2('Phone', $author$project$Components$Shared$EditeurDeSchema$Champ$Telephone),
		_Utils_Tuple2('Currency', $author$project$Components$Shared$EditeurDeSchema$Champ$Devise),
		_Utils_Tuple2('Address', $author$project$Components$Shared$EditeurDeSchema$Champ$Adresse)
	]);
var $author$project$Components$Shared$EditeurDeSchema$Champ$encode = function (champ) {
	return $elm$json$Json$Encode$object(
		$elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(champ.dy)),
						_Utils_Tuple2(
						'label',
						$elm$json$Json$Encode$string(champ.Bl)),
						_Utils_Tuple2(
						'type',
						$author$project$Components$Shared$EditeurDeSchema$Champ$encodeType(champ.r0)),
						_Utils_Tuple2(
						'required',
						$elm$json$Json$Encode$bool(champ.he)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(champ.bp))
					]),
					A3(
					$author$project$Components$Shared$EditeurDeSchema$Champ$si,
					!_Utils_eq(champ.hJ, _List_Nil),
					'regles',
					A2($elm$json$Json$Encode$list, $author$project$Components$Shared$EditeurDeSchema$Champ$encodeRegle, champ.hJ)),
					A3(
					$author$project$Components$Shared$EditeurDeSchema$Champ$si,
					champ.xD,
					'donneePersonnelle',
					$elm$json$Json$Encode$bool(true)),
					A3(
					$author$project$Components$Shared$EditeurDeSchema$Champ$present,
					'conservation',
					function (mois) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'mois',
									$elm$json$Json$Encode$int(mois))
								]));
					},
					champ.v6),
					A3(
					$author$project$Components$Shared$EditeurDeSchema$Champ$si,
					!_Utils_eq(champ.R, _List_Nil),
					'libelles',
					$author$project$Components$Shared$EditeurDeSchema$Champ$encodeParCle(champ.R)),
					A3(
					$author$project$Components$Shared$EditeurDeSchema$Champ$si,
					!_Utils_eq(champ.bq, _List_Nil),
					'aides',
					$author$project$Components$Shared$EditeurDeSchema$Champ$encodeParCle(champ.bq)),
					function () {
					var _v2 = champ.KQ;
					switch (_v2.$) {
						case 0:
							return _List_Nil;
						case 1:
							var cle = _v2.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'visibleSi',
									A2(
										$author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom,
										'Rempli',
										_List_fromArray(
											[
												_Utils_Tuple2(
												'champ',
												$elm$json$Json$Encode$string(cle))
											])))
								]);
						default:
							var json = _v2.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'visibleSi',
									$author$project$Components$Shared$EditeurDeSchema$Champ$relu(json))
								]);
					}
				}(),
					A3($author$project$Components$Shared$EditeurDeSchema$Champ$present, 'formule', $elm$json$Json$Encode$string, champ.zU),
					A3(
					$author$project$Components$Shared$EditeurDeSchema$Champ$si,
					champ.sG,
					'exigence',
					$elm$json$Json$Encode$string('ALaPublication')),
					A3(
					$author$project$Components$Shared$EditeurDeSchema$Champ$si,
					champ.h8,
					'traduisible',
					$elm$json$Json$Encode$bool(true)),
					A3(
					$author$project$Components$Shared$EditeurDeSchema$Champ$si,
					!_Utils_eq(champ.Bt, _List_Nil),
					'libellesDesValeurs',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$map,
							$elm$core$Tuple$mapSecond($author$project$Components$Shared$EditeurDeSchema$Champ$encodeParCle),
							champ.Bt)))
				])));
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$encodeType = function (type_) {
	switch (type_.$) {
		case 7:
			var valeurs = type_.a;
			return A2(
				$author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom,
				'Enum',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'values',
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, valeurs))
					]));
		case 8:
			var choix = type_.a;
			return A2(
				$author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom,
				'MultiEnum',
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'values',
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, choix.Ki)),
					_Utils_ap(
						A3($author$project$Components$Shared$EditeurDeSchema$Champ$present, 'min', $elm$json$Json$Encode$int, choix.Cx),
						A3($author$project$Components$Shared$EditeurDeSchema$Champ$present, 'max', $elm$json$Json$Encode$int, choix.Cg))));
		case 9:
			var fichier = type_.a;
			return A2(
				$author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom,
				'File',
				_Utils_ap(
					A3(
						$author$project$Components$Shared$EditeurDeSchema$Champ$si,
						!_Utils_eq(fichier.r1, _List_Nil),
						'mediaTypes',
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, fichier.r1)),
					A3($author$project$Components$Shared$EditeurDeSchema$Champ$present, 'maxBytes', $elm$json$Json$Encode$int, fichier.Jn)));
		case 10:
			var mesure = type_.a;
			return A2(
				$author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom,
				'Measure',
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'unite',
						$elm$json$Json$Encode$string(mesure.sa)),
					_Utils_ap(
						A3(
							$author$project$Components$Shared$EditeurDeSchema$Champ$si,
							!_Utils_eq(mesure.iF, _List_Nil),
							'affichage',
							$author$project$Components$Shared$EditeurDeSchema$Champ$encodeParCle(mesure.iF)),
						_Utils_ap(
							A3(
								$author$project$Components$Shared$EditeurDeSchema$Champ$si,
								!(!mesure.kv),
								'decimales',
								$elm$json$Json$Encode$int(mesure.kv)),
							_Utils_ap(
								A3($author$project$Components$Shared$EditeurDeSchema$Champ$present, 'min', $elm$json$Json$Encode$float, mesure.Cx),
								A3($author$project$Components$Shared$EditeurDeSchema$Champ$present, 'max', $elm$json$Json$Encode$float, mesure.Cg))))));
		case 17:
			var choix = type_.a;
			var renvoi = A2(
				$author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom,
				'Ref',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'target',
						$elm$json$Json$Encode$string(
							_Utils_ap($author$project$Components$Shared$EditeurDeSchema$Champ$prefixeDeListe, choix.nW)))
					]));
			return choix.FS ? A2(
				$author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom,
				'Arr',
				_List_fromArray(
					[
						_Utils_Tuple2('of', renvoi)
					])) : renvoi;
		case 21:
			var choix = type_.a;
			return A2(
				$author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom,
				'Choice',
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'valueSet',
						$elm$json$Json$Encode$string(choix.ys)),
					_Utils_ap(
						A3(
							$author$project$Components$Shared$EditeurDeSchema$Champ$si,
							choix.FS,
							'multiple',
							$elm$json$Json$Encode$bool(true)),
						_Utils_ap(
							A3($author$project$Components$Shared$EditeurDeSchema$Champ$present, 'min', $elm$json$Json$Encode$int, choix.Cx),
							A3($author$project$Components$Shared$EditeurDeSchema$Champ$present, 'max', $elm$json$Json$Encode$int, choix.Cg)))));
		case 19:
			var fiche = type_.a;
			return A2(
				$author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom,
				'Ref',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'target',
						$elm$json$Json$Encode$string(
							_Utils_ap($author$project$Components$Shared$EditeurDeSchema$Champ$prefixeDePartiePrenante, fiche.r$)))
					]));
		case 20:
			return A2(
				$author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom,
				'Ref',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'target',
						$elm$json$Json$Encode$string('utilisateur'))
					]));
		case 18:
			var lien = type_.a;
			var renvoi = A2(
				$author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom,
				'Ref',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'target',
						$elm$json$Json$Encode$string(
							_Utils_ap($author$project$Components$Shared$EditeurDeSchema$Champ$prefixeDeRessource, lien.vf)))
					]));
			var articles = lien.FS ? A2(
				$author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom,
				'Arr',
				_List_fromArray(
					[
						_Utils_Tuple2('of', renvoi)
					])) : renvoi;
			return A2(
				$author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom,
				'Obj',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'fields',
						A2(
							$elm$json$Json$Encode$list,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'name',
											$elm$json$Json$Encode$string('articles')),
											_Utils_Tuple2(
											'label',
											$elm$json$Json$Encode$string('Articles')),
											_Utils_Tuple2('type', articles),
											_Utils_Tuple2(
											'required',
											$elm$json$Json$Encode$bool(false)),
											_Utils_Tuple2(
											'description',
											$elm$json$Json$Encode$string(''))
										]))
								])))
					]));
		case 22:
			var contenu = type_.a;
			var reserve = F2(
				function (cle, valeurs) {
					return _Utils_eq(valeurs, _List_Nil) ? _List_Nil : _List_fromArray(
						[
							function (champ) {
							return _Utils_update(
								champ,
								{
									bp: A2($elm$core$String$join, ',', valeurs)
								});
						}(
							$author$project$Components$Shared$EditeurDeSchema$Champ$nouveau(
								{dy: cle, Bl: cle, r0: $author$project$Components$Shared$EditeurDeSchema$Champ$Texte}))
						]);
				});
			var masques = _Utils_ap(
				A2(reserve, $author$project$Components$Shared$EditeurDeSchema$Champ$cleDesMasques, contenu.Cd),
				A2(reserve, $author$project$Components$Shared$EditeurDeSchema$Champ$cleDesUniques, contenu.r9));
			var identifiant = function (champ) {
				return _Utils_update(
					champ,
					{
						bp: $author$project$Components$Shared$EditeurDeSchema$Champ$codeDuGenre(contenu.z9)
					});
			}(
				$author$project$Components$Shared$EditeurDeSchema$Champ$nouveau(
					{dy: $author$project$Components$Shared$EditeurDeSchema$Champ$cleDeLOccurrence, Bl: contenu.Bq, r0: $author$project$Components$Shared$EditeurDeSchema$Champ$Texte}));
			var occurrence = A2(
				$author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom,
				'Obj',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'fields',
						A2(
							$elm$json$Json$Encode$list,
							$author$project$Components$Shared$EditeurDeSchema$Champ$encode,
							_Utils_ap(
								contenu.IX,
								_Utils_ap(
									_List_fromArray(
										[identifiant]),
									masques))))
					]));
			return contenu.HI ? A2(
				$author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom,
				'Arr',
				_List_fromArray(
					[
						_Utils_Tuple2('of', occurrence)
					])) : occurrence;
		case 15:
			var choix = type_.a;
			var pays = A2($author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom, 'Country', _List_Nil);
			return choix.FS ? A2(
				$author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom,
				'Arr',
				_List_fromArray(
					[
						_Utils_Tuple2('of', pays)
					])) : pays;
		case 16:
			var choix = type_.a;
			return choix.FS ? A2(
				$author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom,
				'MultiEnum',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'values',
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, choix.vC))
					])) : A2(
				$author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom,
				'Enum',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'values',
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, choix.vC))
					]));
		case 23:
			var json = type_.a;
			return $author$project$Components$Shared$EditeurDeSchema$Champ$relu(json);
		default:
			var sansAttribut = type_;
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$json$Json$Encode$null,
				A2(
					$elm$core$Maybe$map,
					function (_v1) {
						var nom = _v1.a;
						return A2($author$project$Components$Shared$EditeurDeSchema$Champ$sousSonNom, nom, _List_Nil);
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$second,
								$elm$core$Basics$eq(sansAttribut)),
							$author$project$Components$Shared$EditeurDeSchema$Champ$typesSansAttribut))));
	}
};
var $author$project$Components$Produits$Common$API$HttpAPI$apercuDuResserrageReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'typeDeProduit',
							$elm$json$Json$Encode$string(requete.fh)),
							_Utils_Tuple2(
							'champ',
							$author$project$Components$Shared$EditeurDeSchema$Champ$encode(requete.uN))
						]))),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Referentiel$Common$API$HttpAPI$apercuDuResserrageReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string(requete.r0)),
							_Utils_Tuple2(
							'champ',
							$author$project$Components$Shared$EditeurDeSchema$Champ$encode(requete.uN))
						]))),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$DeListe = 6;
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$DePartiePrenante = 7;
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$codeDuType = function (genre) {
	switch (genre) {
		case 0:
			return 'texte';
		case 1:
			return 'nombre';
		case 2:
			return 'date';
		case 6:
			return 'choix-dans-une-liste';
		case 3:
			return 'montant';
		case 4:
			return 'mesure';
		case 5:
			return 'devise';
		case 7:
			return 'partie-prenante';
		default:
			return 'utilisateur';
	}
};
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $elm$core$String$toFloat = _String_toFloat;
var $elm$core$String$trim = _String_trim;
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$optionsDuSousChamp = function (sousChamp) {
	var uneSeuleFois = sousChamp.J9 ? _List_fromArray(
		[
			_Utils_Tuple2(
			'uneSeuleFois',
			$elm$json$Json$Encode$bool(true))
		]) : _List_Nil;
	var borne = F2(
		function (nom, texte) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (n) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								nom,
								$elm$json$Json$Encode$float(n))
							]);
					},
					$elm$core$String$toFloat(
						$elm$core$String$trim(
							A3($elm$core$String$replace, ',', '.', texte)))));
		});
	var bornes = _Utils_ap(
		A2(borne, 'min', sousChamp.Cx),
		A2(borne, 'max', sousChamp.Cg));
	var _v0 = sousChamp.M;
	switch (_v0) {
		case 4:
			return _Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'grandeur',
						$elm$json$Json$Encode$string('longueur')),
						_Utils_Tuple2(
						'unite',
						$elm$json$Json$Encode$string(sousChamp.sa)),
						_Utils_Tuple2(
						'decimales',
						$elm$json$Json$Encode$int(
							A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(sousChamp.kv))))
					]),
				bornes);
		case 1:
			return _Utils_ap(bornes, uneSeuleFois);
		case 3:
			return bornes;
		case 2:
			return uneSeuleFois;
		default:
			return _List_Nil;
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$encodeSousChamp = function (sousChamp) {
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$elm$json$Json$Encode$string(
						$elm$core$String$trim(sousChamp.Bl))),
					_Utils_Tuple2(
					'typeDeChamp',
					$elm$json$Json$Encode$string(
						$author$project$Components$Shared$EditeurDeSchema$SousChamps$codeDuType(sousChamp.M))),
					_Utils_Tuple2(
					'obligatoire',
					$elm$json$Json$Encode$bool(sousChamp.he))
				]),
			_Utils_ap(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (cle) {
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'cle',
									$elm$json$Json$Encode$string(cle))
								]);
						},
						sousChamp.dy)),
				_Utils_ap(
					(sousChamp.M === 6) ? _List_fromArray(
						[
							_Utils_Tuple2(
							'liste',
							$elm$json$Json$Encode$string(sousChamp.nW))
						]) : _List_Nil,
					_Utils_ap(
						(sousChamp.M === 7) ? _List_fromArray(
							[
								_Utils_Tuple2(
								'typeVise',
								$elm$json$Json$Encode$string(sousChamp.r$))
							]) : _List_Nil,
						$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$optionsDuSousChamp(sousChamp))))));
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$facultatif = F3(
	function (nom, encoder, valeur) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (v) {
					return _List_fromArray(
						[
							_Utils_Tuple2(
							nom,
							encoder(v))
						]);
				},
				valeur));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$encodeOptions = function (options) {
	switch (options.$) {
		case 0:
			var longueurMax = options.a.B$;
			var format = options.a.zP;
			var miseEnForme = options.a.CE;
			return $elm$json$Json$Encode$object(
				_Utils_ap(
					A3($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$facultatif, 'longueurMax', $elm$json$Json$Encode$int, longueurMax),
					_List_fromArray(
						[
							_Utils_Tuple2(
							'format',
							$elm$json$Json$Encode$string(format)),
							_Utils_Tuple2(
							'miseEnForme',
							$elm$json$Json$Encode$bool(miseEnForme))
						])));
		case 1:
			var min = options.a.Cx;
			var max = options.a.Cg;
			var decimales = options.a.kv;
			return $elm$json$Json$Encode$object(
				_Utils_ap(
					A3($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$facultatif, 'min', $elm$json$Json$Encode$float, min),
					_Utils_ap(
						A3($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$facultatif, 'max', $elm$json$Json$Encode$float, max),
						_List_fromArray(
							[
								_Utils_Tuple2(
								'decimales',
								$elm$json$Json$Encode$int(decimales))
							]))));
		case 2:
			var min = options.a.Cx;
			var max = options.a.Cg;
			return $elm$json$Json$Encode$object(
				_Utils_ap(
					A3($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$facultatif, 'min', $elm$json$Json$Encode$float, min),
					A3($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$facultatif, 'max', $elm$json$Json$Encode$float, max)));
		case 3:
			var dateMin = options.a.wA;
			var dateMax = options.a.wz;
			return $elm$json$Json$Encode$object(
				_Utils_ap(
					A3($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$facultatif, 'dateMin', $elm$json$Json$Encode$string, dateMin),
					A3($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$facultatif, 'dateMax', $elm$json$Json$Encode$string, dateMax)));
		case 8:
			return $elm$json$Json$Encode$null;
		case 9:
			return $elm$json$Json$Encode$null;
		case 5:
			var plusieurs = options.a.FS;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'plusieursChoix',
						$elm$json$Json$Encode$bool(plusieurs))
					]));
		case 6:
			var calcule = options.a;
			return $elm$json$Json$Encode$object(
				_Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'formule',
							$elm$json$Json$Encode$string(calcule.zU)),
							_Utils_Tuple2(
							'resultat',
							$elm$json$Json$Encode$string(calcule.HW)),
							_Utils_Tuple2(
							'recalcul',
							$elm$json$Json$Encode$string(calcule.G$)),
							_Utils_Tuple2(
							'valeur',
							$elm$json$Json$Encode$string(calcule.fm))
						]),
					_Utils_ap(
						A3($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$facultatif, 'decimales', $elm$json$Json$Encode$int, calcule.kv),
						A3($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$facultatif, 'unite', $elm$json$Json$Encode$string, calcule.sa))));
		case 7:
			var groupe = options.a;
			return $elm$json$Json$Encode$object(
				_Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'sousChamps',
							A2($elm$json$Json$Encode$list, $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$encodeSousChamp, groupe.IX)),
							_Utils_Tuple2(
							'repetable',
							$elm$json$Json$Encode$bool(groupe.HI))
						]),
					_Utils_ap(
						A3($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$facultatif, 'libelleOccurrence', $elm$json$Json$Encode$string, groupe.Bq),
						A3(
							$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$facultatif,
							'genreOccurrence',
							A2($elm$core$Basics$composeR, $author$project$Components$Shared$GenreDuNom$code, $elm$json$Json$Encode$string),
							groupe.z9))));
		default:
			var grandeur = options.a.m0;
			var unite = options.a.sa;
			var decimales = options.a.kv;
			var min = options.a.Cx;
			var max = options.a.Cg;
			return $elm$json$Json$Encode$object(
				_Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'grandeur',
							$elm$json$Json$Encode$string(grandeur)),
							_Utils_Tuple2(
							'unite',
							$elm$json$Json$Encode$string(unite)),
							_Utils_Tuple2(
							'decimales',
							$elm$json$Json$Encode$int(decimales))
						]),
					_Utils_ap(
						A3($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$facultatif, 'min', $elm$json$Json$Encode$float, min),
						A3($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$facultatif, 'max', $elm$json$Json$Encode$float, max))));
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$encodeApercuDeModification = F2(
	function (champ, options) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'champ',
					$elm$json$Json$Encode$string(champ)),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (o) {
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'options',
									$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$encodeOptions(o))
								]);
						},
						options))));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$encodePortee = function (portee) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'Noeud',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'classification',
							$elm$json$Json$Encode$string(portee.vj)),
							_Utils_Tuple2(
							'valeur',
							$elm$json$Json$Encode$string(portee.ou))
						])))
			]));
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$encodeApercu = F2(
	function (champ, options) {
		_v0$2:
		while (true) {
			if (!options.$) {
				switch (options.a.$) {
					case 8:
						var _v1 = options.a;
						var portee = _v1.a;
						var valeurs = _v1.b;
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'portee',
									$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$encodePortee(portee)),
									_Utils_Tuple2(
									'champ',
									$elm$json$Json$Encode$string(champ)),
									_Utils_Tuple2(
									'valeurs',
									A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, valeurs))
								]));
					case 9:
						var _v2 = options.a;
						var type_ = _v2.a;
						var valeurs = _v2.b;
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'typeDeProduit',
									$elm$json$Json$Encode$string(type_)),
									_Utils_Tuple2(
									'champ',
									$elm$json$Json$Encode$string(champ)),
									_Utils_Tuple2(
									'valeurs',
									A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, valeurs))
								]));
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$encodeApercuDeModification, champ, options);
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$HttpAPI$apercuReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$encodeApercu, requete.uN, requete.o_)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Catalogue$Formes$encodeForme = function (forme) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'pluriel',
				$elm$json$Json$Encode$string(forme.bT)),
				_Utils_Tuple2(
				'genre',
				$elm$json$Json$Encode$string(
					function () {
						var _v0 = forme.M;
						if (!_v0) {
							return 'masculin';
						} else {
							return 'feminin';
						}
					}())),
				_Utils_Tuple2(
				'elision',
				$elm$json$Json$Encode$bool(forme.av))
			]));
};
var $author$project$Catalogue$Formes$encode = function (formes) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'fr',
				$author$project$Catalogue$Formes$encodeForme(formes.zX)),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (en) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'en',
								$author$project$Catalogue$Formes$encodeForme(en))
							]);
					},
					formes.yg))));
};
var $author$project$Catalogue$Formes$sontVides = function (formes) {
	return ($elm$core$String$trim(formes.zX.bT) === '') && A2(
		$elm$core$Maybe$withDefault,
		true,
		A2(
			$elm$core$Maybe$map,
			function (en) {
				return $elm$core$String$trim(en.bT) === '';
			},
			formes.yg));
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeFormes = function (formes) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (ecrites) {
				return $author$project$Catalogue$Formes$sontVides(ecrites) ? _List_fromArray(
					[
						_Utils_Tuple2('grammaire', $elm$json$Json$Encode$null)
					]) : _List_fromArray(
					[
						_Utils_Tuple2(
						'grammaire',
						$author$project$Catalogue$Formes$encode(ecrites))
					]);
			},
			formes));
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeLibelles = function (libelles) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'fr',
				$elm$json$Json$Encode$string(libelles.zX)),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (en) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'en',
								$elm$json$Json$Encode$string(en))
							]);
					},
					libelles.yg))));
};
var $author$project$Catalogue$Identifiants$etageIdEncode = function (_v0) {
	var valeur = _v0;
	return $elm$json$Json$Encode$string(valeur);
};
var $author$project$Catalogue$Identifiants$niveauIdEncode = function (_v0) {
	var valeur = _v0;
	return $elm$json$Json$Encode$string(valeur);
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$corpsDuGeste = function (geste) {
	switch (geste.$) {
		case 0:
			var typologie = geste.a;
			var designation = geste.b;
			var rang = geste.c;
			return A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'classification',
					$author$project$Catalogue$Identifiants$classificationIdEncode(typologie)),
				_Utils_ap(
					function () {
						if (!designation.$) {
							var niveau = designation.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'niveau',
									$author$project$Catalogue$Identifiants$niveauIdEncode(niveau))
								]);
						} else {
							var libelles = designation.a;
							var formes = designation.b;
							return A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'libelles',
									$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeLibelles(libelles)),
								$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeFormes(formes));
						}
					}(),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (place) {
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'rang',
										$elm$json$Json$Encode$int(place))
									]);
							},
							rang))));
		case 1:
			var typologie = geste.a;
			var ordre = geste.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'classification',
					$author$project$Catalogue$Identifiants$classificationIdEncode(typologie)),
					_Utils_Tuple2(
					'ordre',
					A2($elm$json$Json$Encode$list, $author$project$Catalogue$Identifiants$etageIdEncode, ordre))
				]);
		default:
			var typologie = geste.a;
			var etage = geste.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'classification',
					$author$project$Catalogue$Identifiants$classificationIdEncode(typologie)),
					_Utils_Tuple2(
					'etage',
					$author$project$Catalogue$Identifiants$etageIdEncode(etage))
				]);
	}
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$nomDuGeste = function (geste) {
	switch (geste.$) {
		case 0:
			return 'ajouter';
		case 1:
			return 'reordonner';
		default:
			return 'retirer';
	}
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeGeste = function (geste) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'geste',
				$elm$json$Json$Encode$string(
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$nomDuGeste(geste))),
			$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$corpsDuGeste(geste)));
};
var $author$project$Components$Produits$StructureCatalogue$API$HttpAPI$apercuReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeGeste(requete.mW)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $author$project$API$Requete$authentifieeSousDelai = function (delaiMs) {
	return $author$project$API$Requete$requeteJson(
		$elm$core$Maybe$Just(delaiMs));
};
var $author$project$Components$Notifications$API$HttpAPI$attendreReq = function (requete) {
	return A2(
		$author$project$API$Requete$authentifieeSousDelai,
		35000,
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $elm$http$Http$cancel = function (tracker) {
	return $elm$http$Http$command(
		$elm$http$Http$Cancel(tracker));
};
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$encoderUnChampRenseigne = function (champ) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(champ.r0)),
				_Utils_Tuple2(
				'cle',
				$elm$json$Json$Encode$string(champ.dy))
			]));
};
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$encoderUnFiltreDeChamp = function (filtre) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(filtre.r0)),
				_Utils_Tuple2(
				'cle',
				$elm$json$Json$Encode$string(filtre.dy)),
				_Utils_Tuple2(
				'valeur',
				function () {
					var _v0 = filtre.fm;
					if (!_v0.$) {
						var texte = _v0.a;
						return $elm$json$Json$Encode$string(texte);
					} else {
						var booleen = _v0.a;
						return $elm$json$Json$Encode$bool(booleen);
					}
				}())
			]));
};
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$encoderLaRecherche = function (recherche) {
	return $elm$json$Json$Encode$object(
		function (poses) {
			return $elm$core$List$isEmpty(recherche.jF) ? poses : _Utils_ap(
				poses,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'champsRenseignes',
						A2($elm$json$Json$Encode$list, $author$project$Components$Referentiel$Common$API$QueryAPIModel$encoderUnChampRenseigne, recherche.jF))
					]));
		}(
			function (poses) {
				return $elm$core$List$isEmpty(recherche.dw) ? poses : _Utils_ap(
					poses,
					_List_fromArray(
						[
							_Utils_Tuple2(
							'filtresDeChamp',
							A2($elm$json$Json$Encode$list, $author$project$Components$Referentiel$Common$API$QueryAPIModel$encoderUnFiltreDeChamp, recherche.dw))
						]));
			}(
				function (poses) {
					return $elm$core$List$isEmpty(recherche.ib) ? poses : _Utils_ap(
						poses,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'types',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, recherche.ib))
							]));
				}(
					A2(
						$elm$core$List$filterMap,
						function (_v0) {
							var nom = _v0.a;
							var valeur = _v0.b;
							return A2(
								$elm$core$Maybe$map,
								function (pose) {
									return _Utils_Tuple2(
										nom,
										$elm$json$Json$Encode$string(pose));
								},
								valeur);
						},
						_List_fromArray(
							[
								_Utils_Tuple2('terme', recherche.h3),
								_Utils_Tuple2('nature', recherche.g1),
								_Utils_Tuple2('qualite', recherche.hy),
								_Utils_Tuple2('pays', recherche.ho),
								_Utils_Tuple2('etat', recherche.gt),
								_Utils_Tuple2('groupe', recherche.m2),
								_Utils_Tuple2('offre', recherche.D1)
							]))))));
};
var $author$project$Components$Referentiel$Fiche$API$HttpAPI$chercherDesFichesReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				$author$project$Components$Referentiel$Common$API$QueryAPIModel$encoderLaRecherche(requete.hC)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Catalogue$Identifiants$etatCodeEncode = function (_v0) {
	var valeur = _v0;
	return $elm$json$Json$Encode$string(valeur);
};
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Catalogue$API$QueryAPIModel$encodeRecherche = function (recherche) {
	var groupe = F3(
		function (nom, encoder, valeurs) {
			return $elm$core$List$isEmpty(valeurs) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(
					nom,
					A2($elm$json$Json$Encode$list, encoder, valeurs))
				]);
		});
	var facultatif = F3(
		function (nom, encoder, valeur) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (posee) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								nom,
								encoder(posee))
							]);
					},
					valeur));
		});
	var plages = function (posees) {
		return $elm$core$List$isEmpty(posees) ? _List_Nil : _List_fromArray(
			[
				_Utils_Tuple2(
				'plages',
				$elm$json$Json$Encode$object(
					A2(
						$elm$core$List$map,
						function (_v1) {
							var cle = _v1.a;
							var _v2 = _v1.b;
							var minimum = _v2.a;
							var maximum = _v2.b;
							return _Utils_Tuple2(
								cle,
								$elm$json$Json$Encode$object(
									_Utils_ap(
										A3(facultatif, 'minimum', $elm$json$Json$Encode$float, minimum),
										A3(facultatif, 'maximum', $elm$json$Json$Encode$float, maximum))));
						},
						posees)))
			]);
	};
	var cible = function (noeud) {
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				A3(facultatif, 'element', $author$project$Catalogue$Identifiants$elementIdEncode, noeud.lQ),
				_Utils_ap(
					A3(facultatif, 'typeDeProduit', $author$project$Catalogue$Identifiants$typeDeProduitIdEncode, noeud.fh),
					_Utils_ap(
						A3(facultatif, 'valeur', $author$project$Catalogue$Identifiants$valeurIdEncode, noeud.fm),
						A3(facultatif, 'nature', $elm$json$Json$Encode$string, noeud.g1)))));
	};
	var champs = function (cochees) {
		return $elm$core$List$isEmpty(cochees) ? _List_Nil : _List_fromArray(
			[
				_Utils_Tuple2(
				'champs',
				$elm$json$Json$Encode$object(
					A2(
						$elm$core$List$map,
						function (cle) {
							return _Utils_Tuple2(
								cle,
								A2(
									$elm$json$Json$Encode$list,
									$elm$json$Json$Encode$string,
									A2(
										$elm$core$List$filterMap,
										function (_v0) {
											var autre = _v0.a;
											var valeur = _v0.b;
											return _Utils_eq(autre, cle) ? $elm$core$Maybe$Just(valeur) : $elm$core$Maybe$Nothing;
										},
										cochees)));
						},
						A3(
							$elm$core$List$foldl,
							F2(
								function (cle, vues) {
									return A2($elm$core$List$member, cle, vues) ? vues : _Utils_ap(
										vues,
										_List_fromArray(
											[cle]));
								}),
							_List_Nil,
							A2($elm$core$List$map, $elm$core$Tuple$first, cochees)))))
			]);
	};
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			($elm$core$String$trim(recherche.h3) === '') ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(
					'terme',
					$elm$json$Json$Encode$string(
						$elm$core$String$trim(recherche.h3)))
				]),
			_Utils_ap(
				A3(facultatif, 'noeud', cible, recherche.ou),
				_Utils_ap(
					A3(facultatif, 'etat', $author$project$Catalogue$Identifiants$etatCodeEncode, recherche.gt),
					_Utils_ap(
						A3(facultatif, 'complete', $elm$json$Json$Encode$bool, recherche.j2),
						_Utils_ap(
							$elm$core$List$isEmpty(recherche.dt) ? _List_Nil : _List_fromArray(
								[
									_Utils_Tuple2(
									'categories',
									A2($elm$json$Json$Encode$list, $author$project$Catalogue$Identifiants$valeurIdEncode, recherche.dt))
								]),
							_Utils_ap(
								recherche.i2 ? _List_fromArray(
									[
										_Utils_Tuple2(
										'arretees',
										$elm$json$Json$Encode$bool(true))
									]) : _List_Nil,
								_Utils_ap(
									A3(groupe, 'etats', $author$project$Catalogue$Identifiants$etatCodeEncode, recherche.mj),
									_Utils_ap(
										A3(groupe, 'marques', $author$project$Catalogue$Identifiants$elementIdEncode, recherche.cU),
										_Utils_ap(
											A3(groupe, 'gammes', $author$project$Catalogue$Identifiants$elementIdEncode, recherche.gG),
											_Utils_ap(
												A3(groupe, 'typologies', $author$project$Catalogue$Identifiants$classificationIdEncode, recherche.r7),
												_Utils_ap(
													A3(groupe, 'familles', $author$project$Catalogue$Identifiants$valeurIdEncode, recherche.mu),
													_Utils_ap(
														champs(recherche.dw),
														_Utils_ap(
															A3(facultatif, 'typeDeProduit', $author$project$Catalogue$Identifiants$typeDeProduitIdEncode, recherche.fh),
															_Utils_ap(
																A3(groupe, 'champsRenseignes', $elm$json$Json$Encode$string, recherche.jF),
																_Utils_ap(
																	plages(recherche.pn),
																	A3(facultatif, 'tri', $elm$json$Json$Encode$string, recherche.rS)))))))))))))))));
};
var $author$project$Components$Referentiel$Common$ChoixDeLien$rechercheDArticles = function (terme) {
	return {i2: false, dt: _List_Nil, dw: _List_Nil, jF: _List_Nil, j2: $elm$core$Maybe$Nothing, gt: $elm$core$Maybe$Nothing, mj: _List_Nil, mu: _List_Nil, gG: _List_Nil, cU: _List_Nil, ou: $elm$core$Maybe$Nothing, pn: _List_Nil, h3: terme, rS: $elm$core$Maybe$Nothing, fh: $elm$core$Maybe$Nothing, r7: _List_Nil};
};
var $author$project$Components$Referentiel$Common$API$HttpAPI$chercherDesNommeesReq = function (requete) {
	var demande = requete.kC;
	var terme = ($elm$core$String$trim(demande.h3) === '') ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(
			'terme',
			$elm$json$Json$Encode$string(demande.h3))
		]);
	var corps = function () {
		var _v0 = demande.M;
		switch (_v0.$) {
			case 0:
				var visee = _v0.a;
				return $elm$json$Json$Encode$object(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'typeVise',
							$elm$json$Json$Encode$string(visee)),
						terme));
			case 1:
				return $elm$json$Json$Encode$object(terme);
			default:
				return $author$project$Catalogue$API$QueryAPIModel$encodeRecherche(
					$author$project$Components$Referentiel$Common$ChoixDeLien$rechercheDArticles(demande.h3));
		}
	}();
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(corps),
			gM: requete.gM,
			aQ: demande.nB.cM,
			sm: demande.nB.sm
		});
};
var $author$project$Components$Referentiel$NouvelleFiche$API$HttpAPI$chercherLOrganisationReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				$author$project$Components$Referentiel$Common$API$QueryAPIModel$encoderLaRecherche(requete.hC)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$encodeRechercheDeDoublons = function (criteres) {
	var liste = F2(
		function (nom, valeurs) {
			return $elm$core$List$isEmpty(valeurs) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(
					nom,
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, valeurs))
				]);
		});
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			A2(liste, 'emails', criteres.yd),
			_Utils_ap(
				A2(liste, 'telephones', criteres.Jq),
				_Utils_ap(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (personne) {
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'personne',
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'nom',
													$elm$json$Json$Encode$string(personne.Dj)),
													_Utils_Tuple2(
													'prenom',
													$elm$json$Json$Encode$string(personne.Gg))
												])))
									]);
							},
							criteres.Fd)),
					_Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (raison) {
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'raisonSociale',
											$elm$json$Json$Encode$string(raison))
										]);
								},
								criteres.GR)),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (identifiant) {
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'identifiantLegal',
											$elm$json$Json$Encode$object(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'pays',
														$elm$json$Json$Encode$string(identifiant.ho)),
														_Utils_Tuple2(
														'valeur',
														$elm$json$Json$Encode$string(identifiant.fm))
													])))
										]);
								},
								criteres.m7)))))));
};
var $author$project$Components$Referentiel$NouvelleFiche$API$HttpAPI$chercherLesDoublonsReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				$author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$encodeRechercheDeDoublons(requete.wp)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Referentiel$PartiesPrenantes$API$HttpAPI$chercherLesFichesReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				$author$project$Components$Referentiel$Common$API$QueryAPIModel$encoderLaRecherche(requete.hC)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Referentiel$Fusion$API$HttpAPI$chercherReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'terme',
							$elm$json$Json$Encode$string(requete.h3))
						]))),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Referentiel$Fiche$API$HttpAPI$chercherUnDoublonReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'identifiantLegal',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'pays',
										$elm$json$Json$Encode$string(requete.ho)),
										_Utils_Tuple2(
										'valeur',
										$elm$json$Json$Encode$string(requete.fm))
									])))
						]))),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeClore = F3(
	function (processUid, entite, cloreLesPersonnesRattachees) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
					_Utils_Tuple2(
					'entite',
					$elm$json$Json$Encode$string(
						$author$project$Components$Referentiel$Identifiants$entiteUidToString(entite))),
					_Utils_Tuple2(
					'cloreLesPersonnesRattachees',
					$elm$json$Json$Encode$bool(cloreLesPersonnesRattachees))
				]));
	});
var $author$project$Components$Referentiel$Fiche$API$HttpAPI$cloreLaFicheReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A3($author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeClore, requete.Gn, requete.yt, requete.vp)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Referentiel$Archetype$code = function (archetype) {
	switch (archetype) {
		case 0:
			return 'Suspect';
		case 1:
			return 'Prospect';
		case 2:
			return 'Client';
		case 3:
			return 'Collaborateur';
		case 4:
			return 'Fournisseur';
		case 5:
			return 'Partenaire';
		case 6:
			return 'Prescripteur';
		case 7:
			return 'RelationPresse';
		default:
			return 'Concurrent';
	}
};
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$archetype = A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Archetype$code, $elm$json$Json$Encode$string);
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$listeNonVide = F2(
	function (encoder, valeurs) {
		return $elm$core$List$isEmpty(valeurs) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A2($elm$json$Json$Encode$list, encoder, valeurs));
	});
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$posees = function (champs) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var nom = _v0.a;
				var valeur = _v0.b;
				return A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(nom),
					valeur);
			},
			champs));
};
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderFiltre = function (filtre) {
	return $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$posees(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nature',
				A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, filtre.g1)),
				_Utils_Tuple2(
				'qualite',
				A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, filtre.hy)),
				_Utils_Tuple2(
				'pays',
				A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, filtre.ho)),
				_Utils_Tuple2(
				'rolesOuverts',
				A2($author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$listeNonVide, $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$archetype, filtre.Id)),
				_Utils_Tuple2(
				'rolesNonOuverts',
				A2($author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$listeNonVide, $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$archetype, filtre.Ic))
			]));
};
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderCompter = function (filtre) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'filtre',
				$author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderFiltre(filtre))
			]));
};
var $author$project$Components$Referentiel$Common$API$Groupes$HttpAPI$compterReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				$author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderCompter(requete.zH)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$encodeLesArticles = F2(
	function (plusieurs, uids) {
		return plusieurs ? A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, uids) : $elm$json$Json$Encode$string(
			$elm$core$String$concat(
				A2($elm$core$List$take, 1, uids)));
	});
var $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$encode = function (valeur) {
	switch (valeur.$) {
		case 0:
			return $elm$json$Json$Encode$null;
		case 1:
			var texte = valeur.a;
			return $elm$json$Json$Encode$string(texte);
		case 2:
			var nombre = valeur.a;
			return $elm$json$Json$Encode$float(nombre);
		case 3:
			var coche = valeur.a;
			return $elm$json$Json$Encode$bool(coche);
		case 4:
			var textes = valeur.a;
			return A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, textes);
		case 6:
			var plusieurs = valeur.a;
			var uids = valeur.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'articles',
						A2($author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$encodeLesArticles, plusieurs, uids))
					]));
		case 7:
			var plusieurs = valeur.a;
			var uids = valeur.b;
			var perimetre = valeur.c;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'articles',
						A2($author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$encodeLesArticles, plusieurs, uids)),
						_Utils_Tuple2(
						'perimetre',
						$elm$json$Json$Encode$string(perimetre))
					]));
		case 8:
			var occurrences = valeur.a;
			return A2(
				$elm$json$Json$Encode$list,
				function (une) {
					return $elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'uid',
								$elm$json$Json$Encode$string(une.r8)),
							A2(
								$elm$core$List$map,
								$elm$core$Tuple$mapSecond($author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$encode),
								une.Ki)));
				},
				occurrences);
		case 9:
			var lue = valeur.a;
			return $elm$json$Json$Encode$object(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$elm$core$Maybe$Just(
							_Utils_Tuple2(
								'lignes',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, lue.gV))),
							A2(
							$elm$core$Maybe$map,
							function (code) {
								return _Utils_Tuple2(
									'codePostal',
									$elm$json$Json$Encode$string(code));
							},
							lue.vz),
							$elm$core$Maybe$Just(
							_Utils_Tuple2(
								'localite',
								$elm$json$Json$Encode$string(lue.B_))),
							A2(
							$elm$core$Maybe$map,
							function (region) {
								return _Utils_Tuple2(
									'region',
									$elm$json$Json$Encode$string(region));
							},
							lue.Hj),
							$elm$core$Maybe$Just(
							_Utils_Tuple2(
								'pays',
								$elm$json$Json$Encode$string(lue.ho)))
						])));
		default:
			var textes = valeur.a;
			return $elm$json$Json$Encode$object(
				A2(
					$elm$core$List$map,
					function (_v1) {
						var langue = _v1.a;
						var texte = _v1.b;
						return _Utils_Tuple2(
							langue,
							A2(
								$elm$core$Maybe$withDefault,
								$elm$json$Json$Encode$null,
								A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, texte)));
					},
					textes));
	}
};
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$champDuType = function (_v0) {
	var cle = _v0.a;
	var valeur = _v0.b;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'cle',
				$elm$json$Json$Encode$string(cle)),
				_Utils_Tuple2(
				'valeur',
				$author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$encode(valeur))
			]));
};
var $author$project$Components$Referentiel$Common$Contact$Adresse = 2;
var $author$project$Components$Referentiel$Common$Contact$canalCode = function (canal) {
	switch (canal) {
		case 0:
			return 'Email';
		case 1:
			return 'Telephone';
		case 2:
			return 'Adresse';
		case 3:
			return 'SiteWeb';
		default:
			return 'Reseau';
	}
};
var $author$project$Components$Referentiel$Common$Contact$lignesDAdresse = function (adresse) {
	return A2(
		$elm$core$List$filter,
		$elm$core$Basics$neq(''),
		A2(
			$elm$core$List$map,
			$elm$core$String$trim,
			_List_fromArray(
				[adresse.a3, adresse.a4, adresse.a5])));
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeAdresse = function (adresse) {
	var facultatif = F2(
		function (nom, valeur) {
			return (valeur === '') ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(
					nom,
					$elm$json$Json$Encode$string(valeur))
				]);
		});
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'lignes',
				A2(
					$elm$json$Json$Encode$list,
					$elm$json$Json$Encode$string,
					$author$project$Components$Referentiel$Common$Contact$lignesDAdresse(adresse))),
			_Utils_ap(
				A2(facultatif, 'codePostal', adresse.vz),
				_Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'localite',
							$elm$json$Json$Encode$string(adresse.B_))
						]),
					_Utils_ap(
						A2(facultatif, 'region', adresse.Hj),
						_List_fromArray(
							[
								_Utils_Tuple2(
								'pays',
								$elm$json$Json$Encode$string(adresse.ho))
							]))))));
};
var $author$project$Components$Referentiel$Common$Contact$usageCode = function (usage) {
	switch (usage) {
		case 0:
			return 'Personnel';
		case 1:
			return 'Professionnel';
		case 2:
			return 'Facturation';
		case 3:
			return 'Livraison';
		case 4:
			return 'Siege';
		default:
			return 'Autre';
	}
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$champs = function (contact) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'canal',
			$elm$json$Json$Encode$string(
				$author$project$Components$Referentiel$Common$Contact$canalCode(contact.uF))),
			(contact.uF === 2) ? _Utils_Tuple2(
			'adresse',
			$author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeAdresse(contact.aa)) : _Utils_Tuple2(
			'valeur',
			$elm$json$Json$Encode$string(contact.fm)),
			_Utils_Tuple2(
			'usage',
			$elm$json$Json$Encode$string(
				$author$project$Components$Referentiel$Common$Contact$usageCode(contact.sd))),
			_Utils_Tuple2(
			'principal',
			$elm$json$Json$Encode$bool(contact.px)),
			_Utils_Tuple2(
			'prospection',
			$elm$json$Json$Encode$bool(contact.Gx))
		]);
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeContact = function (contact) {
	return $elm$json$Json$Encode$object(
		$author$project$Components$Referentiel$Common$API$WriteAPIModel$champs(contact));
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeContactLie = function (contact) {
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			$author$project$Components$Referentiel$Common$API$WriteAPIModel$champs(contact),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'lieAuRattachement',
					$elm$json$Json$Encode$bool(true))
				])));
};
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$contact = F3(
	function (fiche, rang, saisi) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.BR;
					},
					$elm$core$List$member(rang)),
				fiche.pN)) ? $author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeContactLie(saisi) : $author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeContact(saisi);
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$baseLegaleCode = function (base) {
	switch (base) {
		case 0:
			return 'Consentement';
		case 1:
			return 'InteretLegitime';
		case 2:
			return 'Contrat';
		default:
			return 'ObligationLegale';
	}
};
var $author$project$Components$Referentiel$Identifiants$formeUidEncode = function (_v0) {
	var valeur = _v0;
	return $elm$json$Json$Encode$string(valeur);
};
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$encodeIdentite = function (identite) {
	if (!identite.$) {
		var personne = identite.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'Personne',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'nom',
								$elm$json$Json$Encode$string(personne.Dj)),
							_Utils_ap(
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function (prenom) {
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'prenom',
													$elm$json$Json$Encode$string(prenom))
												]);
										},
										personne.Gg)),
								_List_fromArray(
									[
										_Utils_Tuple2(
										'pays',
										$elm$json$Json$Encode$string(personne.ho)),
										_Utils_Tuple2(
										'baseLegale',
										$elm$json$Json$Encode$string(
											$author$project$Components$Referentiel$NouvelleFiche$Model$baseLegaleCode(personne.fI)))
									])))))
				]));
	} else {
		var organisation = identite.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'Organisation',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'raisonSociale',
								$elm$json$Json$Encode$string(organisation.GR)),
								_Utils_Tuple2(
								'pays',
								$elm$json$Json$Encode$string(organisation.ho)),
								_Utils_Tuple2(
								'forme',
								$author$project$Components$Referentiel$Identifiants$formeUidEncode(organisation.gB))
							])))
				]));
	}
};
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$premierRole = F3(
	function (offre, debut, uid) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'premierRole',
				$elm$json$Json$Encode$object(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'type',
							$author$project$Components$Referentiel$Identifiants$typeUidEncode(uid)),
						_Utils_ap(
							A2($author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$champFacultatif, 'offre', offre),
							A2($author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$champFacultatif, 'debut', debut)))))
			]);
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$qualiteCode = function (qualite) {
	if (!qualite) {
		return 'Particulier';
	} else {
		return 'Professionnel';
	}
};
var $author$project$Components$Referentiel$Identifiants$posteUidToString = function (_v0) {
	var valeur = _v0;
	return valeur;
};
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$rattachement = function (saisi) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'rattachement',
			$elm$json$Json$Encode$object(
				_Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'organisation',
							$elm$json$Json$Encode$string(
								$author$project$Components$Referentiel$Identifiants$entiteUidToString(saisi.En))),
							_Utils_Tuple2(
							'poste',
							$elm$json$Json$Encode$string(
								$author$project$Components$Referentiel$Identifiants$posteUidToString(saisi.F4)))
						]),
					A2($author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$champFacultatif, 'intitule', saisi.AS))))
		]);
};
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$encodeCreerUneFiche = F2(
	function (processUid, fiche) {
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'processUid',
						$author$project$API$ProcessUid$encode(processUid))
					]),
				_Utils_ap(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (qualite) {
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'qualite',
										$elm$json$Json$Encode$string(
											$author$project$Components$Referentiel$NouvelleFiche$Model$qualiteCode(qualite)))
									]);
							},
							fiche.hy)),
					_Utils_ap(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'identite',
								$author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$encodeIdentite(fiche.Av))
							]),
						_Utils_ap(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A2($author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$premierRole, fiche.D2, fiche.wG),
									fiche.pw)),
							_Utils_ap(
								$elm$core$List$isEmpty(fiche.wa) ? _List_Nil : _List_fromArray(
									[
										_Utils_Tuple2(
										'contacts',
										A2(
											$elm$json$Json$Encode$list,
											$elm$core$Basics$identity,
											A2(
												$elm$core$List$indexedMap,
												$author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$contact(fiche),
												fiche.wa)))
									]),
								_Utils_ap(
									A2($author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$champFacultatif, 'civilite', fiche.vh),
									_Utils_ap(
										A2($author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$champFacultatif, 'langue', fiche.nn),
										_Utils_ap(
											A2($author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$champFacultatif, 'responsable', fiche.qB),
											_Utils_ap(
												A2($author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$champFacultatif, 'identifiantLegal', fiche.m7),
												_Utils_ap(
													fiche.w7 ? _List_fromArray(
														[
															_Utils_Tuple2(
															'demandeDeLaPersonne',
															$elm$json$Json$Encode$bool(true))
														]) : _List_Nil,
													_Utils_ap(
														$elm$core$List$isEmpty(fiche.mA) ? _List_Nil : _List_fromArray(
															[
																_Utils_Tuple2(
																'fichesEcartees',
																A2(
																	$elm$json$Json$Encode$list,
																	A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Identifiants$entiteUidToString, $elm$json$Json$Encode$string),
																	fiche.mA))
															]),
														_Utils_ap(
															A2(
																$elm$core$Maybe$withDefault,
																_List_Nil,
																A2($elm$core$Maybe$map, $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$rattachement, fiche.pN)),
															$elm$core$List$isEmpty(fiche.jE) ? _List_Nil : _List_fromArray(
																[
																	_Utils_Tuple2(
																	'champsDuType',
																	A2($elm$json$Json$Encode$list, $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$champDuType, fiche.jE))
																]))))))))))))));
	});
var $author$project$Components$Referentiel$NouvelleFiche$API$HttpAPI$creerLaFicheReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$encodeCreerUneFiche, requete.Gn, requete.zo)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Ports$demanderAlea = _Platform_outgoingPort('demanderAlea', $elm$json$Json$Encode$int);
var $author$project$Components$Produits$Common$API$HttpAPI$deposerLeFichierReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'processUid',
							$author$project$API$ProcessUid$encode(requete.Gn)),
							_Utils_Tuple2(
							'morceaux',
							$elm$json$Json$Encode$int(requete.CU)),
							_Utils_Tuple2(
							'taille',
							$elm$json$Json$Encode$int(requete.Jm))
						]))),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $elm$http$Http$bytesBody = _Http_pair;
var $author$project$API$Requete$presignee = function (requete) {
	return $elm$http$Http$request(
		{
			dr: A2($elm$http$Http$bytesBody, requete.Ck, requete.oW),
			dU: A2(
				$elm$http$Http$expectStringResponse,
				$elm$core$Result$withDefault($author$project$API$Requete$sansReponse),
				A2($elm$core$Basics$composeR, $author$project$API$Requete$reponse, $elm$core$Result$Ok)),
			d$: _List_Nil,
			eg: requete.sm,
			fb: $elm$core$Maybe$Nothing,
			fe: $elm$core$Maybe$Just($author$project$API$Requete$traceurDuDepot),
			aQ: requete.aQ
		});
};
var $author$project$Components$Produits$Common$API$HttpAPI$deposerSurLAdresseReq = $author$project$API$Requete$presignee;
var $author$project$Components$Referentiel$Doublons$API$HttpAPI$couple = function (paire) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'fiche',
				$elm$json$Json$Encode$string(
					$author$project$Components$Referentiel$Identifiants$entiteUidToString(paire.zo))),
				_Utils_Tuple2(
				'autre',
				$elm$json$Json$Encode$string(
					$author$project$Components$Referentiel$Identifiants$entiteUidToString(paire.t3)))
			]));
};
var $author$project$Components$Referentiel$Doublons$API$HttpAPI$ecarterReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'processUid',
							$author$project$API$ProcessUid$encode(requete.Gn)),
							_Utils_Tuple2(
							'paires',
							A2($elm$json$Json$Encode$list, $author$project$Components$Referentiel$Doublons$API$HttpAPI$couple, requete.EJ))
						]))),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.rh));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectString = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		$elm$http$Http$resolve($elm$core$Result$Ok));
};
var $elm$http$Http$post = function (r) {
	return $elm$http$Http$request(
		{dr: r.dr, dU: r.dU, d$: _List_Nil, eg: 'POST', fb: $elm$core$Maybe$Nothing, fe: $elm$core$Maybe$Nothing, aQ: r.aQ});
};
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $elm$http$Http$stringBody = _Http_pair;
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $author$project$Components$Socle$Session$API$HttpAPI$echangerCodeReq = function (echange) {
	return $elm$http$Http$post(
		{
			dr: A2(
				$elm$http$Http$stringBody,
				'application/x-www-form-urlencoded',
				A2(
					$elm$core$String$dropLeft,
					1,
					$elm$url$Url$Builder$toQuery(
						_List_fromArray(
							[
								A2($elm$url$Url$Builder$string, 'grant_type', 'authorization_code'),
								A2($elm$url$Url$Builder$string, 'client_id', echange.jW),
								A2($elm$url$Url$Builder$string, 'code', echange.vx),
								A2($elm$url$Url$Builder$string, 'code_verifier', echange.vB),
								A2($elm$url$Url$Builder$string, 'redirect_uri', echange.G9)
							])))),
			dU: $elm$http$Http$expectString($elm$core$Basics$identity),
			aQ: echange.aQ
		});
};
var $author$project$Ports$ecrirePreferences = _Platform_outgoingPort('ecrirePreferences', $elm$core$Basics$identity);
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeEffacerUnContact = F3(
	function (processUid, entite, contact) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
					_Utils_Tuple2(
					'entite',
					$elm$json$Json$Encode$string(
						$author$project$Components$Referentiel$Identifiants$entiteUidToString(entite))),
					_Utils_Tuple2(
					'contact',
					$elm$json$Json$Encode$string(contact))
				]));
	});
var $author$project$Components$Referentiel$Fiche$API$HttpAPI$effacerUnContactReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A3($author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeEffacerUnContact, requete.Gn, requete.yt, requete.v8)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $elm$json$Json$Encode$dict = F3(
	function (toKey, toValue, dictionary) {
		return _Json_wrap(
			A3(
				$elm$core$Dict$foldl,
				F3(
					function (key, value, obj) {
						return A3(
							_Json_addField,
							toKey(key),
							toValue(value),
							obj);
					}),
				_Json_emptyObject(0),
				dictionary));
	});
var $author$project$Preferences$Model$vueToString = function (vue) {
	if (!vue) {
		return 'cartes';
	} else {
		return 'tableau';
	}
};
var $author$project$Preferences$Model$encodeAnnuaire = function (gardees) {
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (vue) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'vue',
								$elm$json$Json$Encode$string(
									$author$project$Preferences$Model$vueToString(vue)))
							]);
					},
					gardees.io)),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'filtresMasques',
					$elm$json$Json$Encode$bool(gardees.mH))
				])));
};
var $author$project$Preferences$Model$encode = function (preferences) {
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'version',
					$elm$json$Json$Encode$int(1)),
					_Utils_Tuple2(
					'menuReplie',
					$elm$json$Json$Encode$bool(preferences.Cr)),
					_Utils_Tuple2(
					'annuaires',
					A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$Preferences$Model$encodeAnnuaire, preferences.aq))
				]),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (alias) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'dernierEspace',
								$elm$json$Json$Encode$string(alias))
							]);
					},
					preferences.xi))));
};
var $author$project$Components$Socle$Session$Model$encoderParcours = function (parcours) {
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'state',
					$elm$json$Json$Encode$string(parcours.e3)),
					_Utils_Tuple2(
					'codeVerifier',
					$elm$json$Json$Encode$string(parcours.vB)),
					_Utils_Tuple2(
					'retour',
					$elm$json$Json$Encode$string(parcours.qL)),
					_Utils_Tuple2(
					'espace',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, parcours.yz)))
				]),
			_Utils_ap(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (action) {
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'action',
									$elm$json$Json$Encode$string(action))
								]);
						},
						parcours.fs)),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (geste) {
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'reprise',
									$elm$json$Json$Encode$string(geste))
								]);
						},
						parcours.qx)))));
};
var $author$project$Components$Referentiel$PartiesPrenantes$API$WriteAPIModel$encodeEnregistrerLesPreferences = F2(
	function (processUid, colonnes) {
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'processUid',
						$author$project$API$ProcessUid$encode(processUid)),
						_Utils_Tuple2(
						'liste',
						$elm$json$Json$Encode$string('parties-prenantes'))
					]),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (ids) {
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'colonnes',
									A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, ids))
								]);
						},
						colonnes))));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$API$HttpAPI$enregistrerLesPreferencesReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Referentiel$PartiesPrenantes$API$WriteAPIModel$encodeEnregistrerLesPreferences, requete.Gn, requete.j1)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Referentiel$Identifiants$rattachementUidToString = function (_v0) {
	var valeur = _v0;
	return valeur;
};
var $author$project$Components$Referentiel$Identifiants$typeRelationUidToString = function (_v0) {
	var valeur = _v0;
	return valeur;
};
var $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$encodeCommandeDeLiaison = F3(
	function (processUid, entite, commande) {
		var rattachement = function (uid) {
			return _Utils_Tuple2(
				'rattachement',
				$elm$json$Json$Encode$string(
					$author$project$Components$Referentiel$Identifiants$rattachementUidToString(uid)));
		};
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'processUid',
						$author$project$API$ProcessUid$encode(processUid)),
						_Utils_Tuple2(
						'entite',
						$elm$json$Json$Encode$string(
							$author$project$Components$Referentiel$Identifiants$entiteUidToString(entite)))
					]),
				function () {
					switch (commande.$) {
						case 0:
							var uid = commande.a;
							var fin = commande.b;
							return _List_fromArray(
								[
									rattachement(uid),
									_Utils_Tuple2(
									'fin',
									$elm$json$Json$Encode$string(fin))
								]);
						case 1:
							var uid = commande.a;
							var fin = commande.b;
							return _List_fromArray(
								[
									rattachement(uid),
									_Utils_Tuple2(
									'fin',
									A2(
										$elm$core$Maybe$withDefault,
										$elm$json$Json$Encode$null,
										A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, fin)))
								]);
						case 2:
							var uid = commande.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'relation',
									$elm$json$Json$Encode$string(
										$author$project$Components$Referentiel$Identifiants$relationUidToString(uid)))
								]);
						case 3:
							var uid = commande.a;
							var poste = commande.b;
							var intitule = commande.c;
							return A2(
								$elm$core$List$cons,
								rattachement(uid),
								A2(
									$elm$core$List$filterMap,
									$elm$core$Basics$identity,
									_List_fromArray(
										[
											A2(
											$elm$core$Maybe$map,
											function (choisi) {
												return _Utils_Tuple2(
													'poste',
													$elm$json$Json$Encode$string(choisi));
											},
											A2($elm$core$Maybe$map, $author$project$Components$Referentiel$Identifiants$posteUidToString, poste)),
											A2(
											$elm$core$Maybe$map,
											function (saisi) {
												return _Utils_Tuple2(
													'intitule',
													$elm$json$Json$Encode$string(saisi));
											},
											intitule)
										])));
						case 4:
							var uid = commande.a;
							var principal = commande.b;
							return _List_fromArray(
								[
									rattachement(uid),
									_Utils_Tuple2(
									'principal',
									$elm$json$Json$Encode$bool(principal))
								]);
						case 5:
							var saisi = commande.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'cible',
									$elm$json$Json$Encode$string(
										$author$project$Components$Referentiel$Identifiants$entiteUidToString(saisi.vf))),
									_Utils_Tuple2(
									'type',
									$elm$json$Json$Encode$string(
										$author$project$Components$Referentiel$Identifiants$typeRelationUidToString(saisi.r0))),
									_Utils_Tuple2(
									'sens',
									$elm$json$Json$Encode$string(
										saisi.xA ? 'Direct' : 'Inverse'))
								]);
						default:
							var saisi = commande.a;
							var facultatif = F2(
								function (nom, valeur) {
									return A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											function (pose) {
												return _List_fromArray(
													[
														_Utils_Tuple2(
														nom,
														$elm$json$Json$Encode$string(pose))
													]);
											},
											valeur));
								});
							return A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'organisation',
									$elm$json$Json$Encode$string(
										$author$project$Components$Referentiel$Identifiants$entiteUidToString(saisi.En))),
								_Utils_ap(
									A2(
										facultatif,
										'poste',
										A2($elm$core$Maybe$map, $author$project$Components$Referentiel$Identifiants$posteUidToString, saisi.F4)),
									_Utils_ap(
										A2(facultatif, 'intitule', saisi.AS),
										_Utils_ap(
											A2(facultatif, 'departement', saisi.xb),
											_Utils_ap(
												A2(facultatif, 'debut', saisi.ku),
												_List_fromArray(
													[
														_Utils_Tuple2(
														'contactPrincipal',
														$elm$json$Json$Encode$bool(saisi.v9)),
														_Utils_Tuple2(
														'contacts',
														A2($elm$json$Json$Encode$list, $author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeContact, saisi.wa))
													]))))));
					}
				}()));
	});
var $author$project$Components$Referentiel$Fiche$API$HttpAPI$envoyerALaLiaisonReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A3($author$project$Components$Referentiel$Fiche$API$WriteAPIModel$encodeCommandeDeLiaison, requete.Gn, requete.yt, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Referentiel$Fiche$Contacts$statutCode = function (statut) {
	switch (statut) {
		case 0:
			return 'Actif';
		case 1:
			return 'Invalide';
		default:
			return 'Ancien';
	}
};
var $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$encodeCommandeDeContact = F3(
	function (processUid, entite, commande) {
		var contact = function (uid) {
			return _Utils_Tuple2(
				'contact',
				$elm$json$Json$Encode$string(uid));
		};
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'processUid',
						$author$project$API$ProcessUid$encode(processUid)),
						_Utils_Tuple2(
						'entite',
						$elm$json$Json$Encode$string(
							$author$project$Components$Referentiel$Identifiants$entiteUidToString(entite)))
					]),
				function () {
					switch (commande.$) {
						case 0:
							var saisie = commande.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'saisie',
									$author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeContact(saisie))
								]);
						case 1:
							var uid = commande.a;
							var saisie = commande.b;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'saisie',
									$author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeContact(saisie)),
									_Utils_Tuple2(
									'rattachement',
									$elm$json$Json$Encode$string(
										$author$project$Components$Referentiel$Identifiants$rattachementUidToString(uid)))
								]);
						case 2:
							var uid = commande.a;
							var saisie = commande.b;
							return _List_fromArray(
								[
									contact(uid),
									_Utils_Tuple2(
									'saisie',
									$author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeContact(saisie))
								]);
						case 3:
							var uid = commande.a;
							return _List_fromArray(
								[
									contact(uid)
								]);
						case 4:
							var uid = commande.a;
							var statut = commande.b;
							return _List_fromArray(
								[
									contact(uid),
									_Utils_Tuple2(
									'statut',
									$elm$json$Json$Encode$string(
										$author$project$Components$Referentiel$Fiche$Contacts$statutCode(statut)))
								]);
						default:
							var uid = commande.a;
							var acceptee = commande.b;
							return _List_fromArray(
								[
									contact(uid),
									_Utils_Tuple2(
									'acceptee',
									$elm$json$Json$Encode$bool(acceptee))
								]);
					}
				}()));
	});
var $author$project$Components$Referentiel$Fiche$API$HttpAPI$envoyerAuContactReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A3($author$project$Components$Referentiel$Fiche$API$WriteAPIModel$encodeCommandeDeContact, requete.Gn, requete.yt, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$encodeCommandeDeRole = F3(
	function (processUid, entite, commande) {
		var role = function (uid) {
			return _Utils_Tuple2(
				'role',
				$elm$json$Json$Encode$string(uid));
		};
		var cloture = F2(
			function (nomDeLaDate, fournie) {
				return _Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple2(
							nomDeLaDate,
							$elm$json$Json$Encode$string(fournie.wv)),
							_Utils_Tuple2(
							'resultat',
							$elm$json$Json$Encode$string(fournie.HW))
						]),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (texte) {
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'commentaire',
										$elm$json$Json$Encode$string(texte))
									]);
							},
							fournie.vM)));
			});
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'processUid',
						$author$project$API$ProcessUid$encode(processUid)),
						_Utils_Tuple2(
						'entite',
						$elm$json$Json$Encode$string(
							$author$project$Components$Referentiel$Identifiants$entiteUidToString(entite)))
					]),
				function () {
					switch (commande.$) {
						case 0:
							var ouverture = commande.a;
							return A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'type',
									$elm$json$Json$Encode$string(ouverture.r0)),
								_Utils_ap(
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											function (offre) {
												return _List_fromArray(
													[
														_Utils_Tuple2(
														'offre',
														$elm$json$Json$Encode$string(offre))
													]);
											},
											ouverture.D1)),
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											function (debut) {
												return _List_fromArray(
													[
														_Utils_Tuple2(
														'debut',
														$elm$json$Json$Encode$string(debut))
													]);
											},
											ouverture.ku))));
						case 1:
							var uid = commande.a;
							var statut = commande.b;
							return _List_fromArray(
								[
									role(uid),
									_Utils_Tuple2(
									'statut',
									$elm$json$Json$Encode$string(statut))
								]);
						case 2:
							var uid = commande.a;
							var fournie = commande.b;
							return A2(
								$elm$core$List$cons,
								role(uid),
								A2(cloture, 'fin', fournie));
						case 3:
							var uid = commande.a;
							var type_ = commande.b;
							var fournie = commande.c;
							return A2(
								$elm$core$List$cons,
								role(uid),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'type',
										$elm$json$Json$Encode$string(type_)),
									A2(cloture, 'effet', fournie)));
						default:
							var uid = commande.a;
							var fin = commande.b;
							return _List_fromArray(
								[
									role(uid),
									_Utils_Tuple2(
									'fin',
									A2(
										$elm$core$Maybe$withDefault,
										$elm$json$Json$Encode$null,
										A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, fin)))
								]);
					}
				}()));
	});
var $author$project$Components$Referentiel$Fiche$API$HttpAPI$envoyerAuRoleReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A3($author$project$Components$Referentiel$Fiche$API$WriteAPIModel$encodeCommandeDeRole, requete.Gn, requete.yt, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$champChoisiEnJson = function (choisi) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'champ',
				$elm$json$Json$Encode$string(choisi.uN)),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (niveau) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'niveauDeLecture',
								$elm$json$Json$Encode$string(niveau))
							]);
					},
					choisi.g4))));
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$champDuType = function (uid) {
	return _Utils_Tuple2(
		'type',
		$author$project$Components$Referentiel$Identifiants$typeUidEncode(uid));
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$champsDeLApparence = function (apparence) {
	var facultatif = F2(
		function (nom, valeur) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (code) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								nom,
								$elm$json$Json$Encode$string(code))
							]);
					},
					valeur));
		});
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2(
			'libelles',
			$elm$json$Json$Encode$object(
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'fr',
						$elm$json$Json$Encode$string(apparence.R.zX)),
					A2(facultatif, 'en', apparence.R.yg)))),
		_Utils_ap(
			A2(facultatif, 'icone', apparence.aC),
			A2(facultatif, 'couleur', apparence.kf)));
};
var $author$project$Components$Referentiel$Admission$codeDeNature = function (nature) {
	if (!nature) {
		return 'Personne';
	} else {
		return 'Organisation';
	}
};
var $author$project$Components$Referentiel$Admission$codeDeQualite = function (qualite) {
	if (!qualite) {
		return 'Particulier';
	} else {
		return 'Professionnel';
	}
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeLibelles = function (libelles) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'fr',
				$elm$json$Json$Encode$string(libelles.zX)),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (en) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'en',
								$elm$json$Json$Encode$string(en))
							]);
					},
					libelles.yg))));
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeElement = F2(
	function (encodeId, element) {
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (id) {
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'id',
									encodeId(id))
								]);
						},
						element.Aq)),
				_List_fromArray(
					[
						_Utils_Tuple2(
						'libelles',
						$author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeLibelles(element.R))
					])));
	});
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeReferenceDOffre = function (uid) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('produits.reference')),
				_Utils_Tuple2(
				'uid',
				$elm$json$Json$Encode$string(uid))
			]));
};
var $author$project$Components$Referentiel$Identifiants$resultatIdEncode = function (_v0) {
	var valeur = _v0;
	return $elm$json$Json$Encode$string(valeur);
};
var $author$project$Components$Referentiel$Identifiants$statutIdEncode = function (_v0) {
	var valeur = _v0;
	return $elm$json$Json$Encode$string(valeur);
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeCommandeDeType = F2(
	function (processUid, commande) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
				function () {
					switch (commande.$) {
						case 0:
							var archetype = commande.a;
							var apparence = commande.b;
							return A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'archetype',
									$elm$json$Json$Encode$string(
										$author$project$Components$Referentiel$Archetype$code(archetype))),
								$author$project$Components$Referentiel$Common$API$WriteAPIModel$champsDeLApparence(apparence));
						case 1:
							var uid = commande.a;
							var apparence = commande.b;
							return A2(
								$elm$core$List$cons,
								$author$project$Components$Referentiel$Common$API$WriteAPIModel$champDuType(uid),
								$author$project$Components$Referentiel$Common$API$WriteAPIModel$champsDeLApparence(apparence));
						case 2:
							var uid = commande.a;
							return _List_fromArray(
								[
									$author$project$Components$Referentiel$Common$API$WriteAPIModel$champDuType(uid)
								]);
						case 3:
							var uid = commande.a;
							return _List_fromArray(
								[
									$author$project$Components$Referentiel$Common$API$WriteAPIModel$champDuType(uid)
								]);
						case 4:
							var uid = commande.a;
							var natures = commande.b;
							var qualites = commande.c;
							return _List_fromArray(
								[
									$author$project$Components$Referentiel$Common$API$WriteAPIModel$champDuType(uid),
									_Utils_Tuple2(
									'natures',
									A2(
										$elm$json$Json$Encode$list,
										A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Admission$codeDeNature, $elm$json$Json$Encode$string),
										natures)),
									_Utils_Tuple2(
									'qualites',
									A2(
										$elm$json$Json$Encode$list,
										A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Admission$codeDeQualite, $elm$json$Json$Encode$string),
										qualites))
								]);
						case 5:
							var uid = commande.a;
							var offres = commande.b;
							var perimetre = commande.c;
							return _Utils_ap(
								_List_fromArray(
									[
										$author$project$Components$Referentiel$Common$API$WriteAPIModel$champDuType(uid),
										_Utils_Tuple2(
										'offres',
										A2(
											$elm$json$Json$Encode$list,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.Aq;
												},
												$author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeReferenceDOffre),
											offres))
									]),
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function (cite) {
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'perimetre',
													$elm$json$Json$Encode$string(cite))
												]);
										},
										perimetre)));
						case 6:
							var uid = commande.a;
							var interdite = commande.b;
							return _List_fromArray(
								[
									$author$project$Components$Referentiel$Common$API$WriteAPIModel$champDuType(uid),
									_Utils_Tuple2(
									'interdite',
									$elm$json$Json$Encode$bool(interdite))
								]);
						case 7:
							var uid = commande.a;
							var statuts = commande.b;
							var initial = commande.c;
							return _List_fromArray(
								[
									$author$project$Components$Referentiel$Common$API$WriteAPIModel$champDuType(uid),
									_Utils_Tuple2(
									'statuts',
									A2(
										$elm$json$Json$Encode$list,
										$author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeElement($author$project$Components$Referentiel$Identifiants$statutIdEncode),
										statuts)),
									_Utils_Tuple2(
									'initial',
									$elm$json$Json$Encode$int(initial))
								]);
						case 8:
							var uid = commande.a;
							var resultats = commande.b;
							return _List_fromArray(
								[
									$author$project$Components$Referentiel$Common$API$WriteAPIModel$champDuType(uid),
									_Utils_Tuple2(
									'resultats',
									A2(
										$elm$json$Json$Encode$list,
										$author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeElement($author$project$Components$Referentiel$Identifiants$resultatIdEncode),
										resultats))
								]);
						case 9:
							var uid = commande.a;
							var evolution = commande.b;
							return _List_fromArray(
								[
									$author$project$Components$Referentiel$Common$API$WriteAPIModel$champDuType(uid),
									_Utils_Tuple2(
									'ajouts',
									A2($elm$json$Json$Encode$list, $author$project$Components$Shared$EditeurDeSchema$Champ$encode, evolution.fx)),
									_Utils_Tuple2(
									'modifications',
									A2($elm$json$Json$Encode$list, $author$project$Components$Shared$EditeurDeSchema$Champ$encode, evolution.g$))
								]);
						case 10:
							var uid = commande.a;
							var cle = commande.b;
							return _List_fromArray(
								[
									$author$project$Components$Referentiel$Common$API$WriteAPIModel$champDuType(uid),
									_Utils_Tuple2(
									'champ',
									$elm$json$Json$Encode$string(cle))
								]);
						case 11:
							var uid = commande.a;
							var cle = commande.b;
							return _List_fromArray(
								[
									$author$project$Components$Referentiel$Common$API$WriteAPIModel$champDuType(uid),
									_Utils_Tuple2(
									'champ',
									$elm$json$Json$Encode$string(cle))
								]);
						case 12:
							var uid = commande.a;
							var ordre = commande.b;
							return _List_fromArray(
								[
									$author$project$Components$Referentiel$Common$API$WriteAPIModel$champDuType(uid),
									_Utils_Tuple2(
									'ordre',
									A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, ordre))
								]);
						case 14:
							var uid = commande.a;
							var cle = commande.b;
							var valeurs = commande.c;
							return _List_fromArray(
								[
									$author$project$Components$Referentiel$Common$API$WriteAPIModel$champDuType(uid),
									_Utils_Tuple2(
									'champ',
									$elm$json$Json$Encode$string(cle)),
									_Utils_Tuple2(
									'valeurs',
									A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, valeurs))
								]);
						case 15:
							var uid = commande.a;
							var cle = commande.b;
							return _List_fromArray(
								[
									$author$project$Components$Referentiel$Common$API$WriteAPIModel$champDuType(uid),
									_Utils_Tuple2(
									'champ',
									$elm$json$Json$Encode$string(cle))
								]);
						case 13:
							var uid = commande.a;
							var cle = commande.b;
							var niveau = commande.c;
							return _List_fromArray(
								[
									$author$project$Components$Referentiel$Common$API$WriteAPIModel$champDuType(uid),
									_Utils_Tuple2(
									'champ',
									$elm$json$Json$Encode$string(cle)),
									_Utils_Tuple2(
									'niveauDeLecture',
									$elm$json$Json$Encode$string(niveau))
								]);
						case 17:
							var uid = commande.a;
							var voulu = commande.b;
							return A2(
								$elm$core$List$cons,
								$author$project$Components$Referentiel$Common$API$WriteAPIModel$champDuType(uid),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'collection',
										$elm$json$Json$Encode$string(voulu.vD)),
									function () {
										var _v1 = voulu.dw;
										if (!_v1.$) {
											var choisis = _v1.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'champs',
													A2($elm$json$Json$Encode$list, $author$project$Components$Referentiel$Common$API$WriteAPIModel$champChoisiEnJson, choisis))
												]);
										} else {
											return _List_Nil;
										}
									}()));
						case 18:
							var uid = commande.a;
							var collection = commande.b;
							return _List_fromArray(
								[
									$author$project$Components$Referentiel$Common$API$WriteAPIModel$champDuType(uid),
									_Utils_Tuple2(
									'collection',
									$elm$json$Json$Encode$string(collection))
								]);
						case 19:
							var uid = commande.a;
							var ordre = commande.b;
							return _List_fromArray(
								[
									$author$project$Components$Referentiel$Common$API$WriteAPIModel$champDuType(uid),
									_Utils_Tuple2(
									'ordre',
									A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, ordre))
								]);
						case 16:
							var uid = commande.a;
							var champ = commande.b;
							var reglages = commande.c;
							return _List_fromArray(
								[
									$author$project$Components$Referentiel$Common$API$WriteAPIModel$champDuType(uid),
									_Utils_Tuple2(
									'champ',
									$elm$json$Json$Encode$string(champ)),
									_Utils_Tuple2(
									'exigence',
									$elm$json$Json$Encode$string(reglages.mo)),
									_Utils_Tuple2(
									'niveauDeLecture',
									$elm$json$Json$Encode$string(reglages.g4)),
									_Utils_Tuple2(
									'masque',
									$elm$json$Json$Encode$bool(reglages.n4)),
									_Utils_Tuple2(
									'donneePersonnelle',
									$elm$json$Json$Encode$bool(reglages.xD))
								]);
						case 20:
							var champ = commande.a;
							var portee = commande.b;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'champ',
									$elm$json$Json$Encode$string(champ)),
									_Utils_Tuple2(
									'portee',
									$elm$json$Json$Encode$string(portee))
								]);
						default:
							var liste = commande.a;
							var vers = commande.b;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'liste',
									$elm$json$Json$Encode$string(liste)),
									_Utils_Tuple2(
									'vers',
									$elm$json$Json$Encode$string(vers))
								]);
					}
				}()));
	});
var $author$project$Components$Referentiel$Common$API$HttpAPI$envoyerAuTypeReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeCommandeDeType, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Produits$Common$API$HttpAPI$envoyerJsonReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(requete.f$),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Comptes$MonCompte$API$WriteAPIModel$encode = F2(
	function (processUid, commande) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
				function () {
					if (!commande.$) {
						var profil = commande.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'prenom',
								$elm$json$Json$Encode$string(profil.Gg)),
								_Utils_Tuple2(
								'nom',
								$elm$json$Json$Encode$string(profil.Dj)),
								_Utils_Tuple2(
								'fonction',
								$elm$json$Json$Encode$string(profil.zO)),
								_Utils_Tuple2(
								'telephonePro',
								$elm$json$Json$Encode$string(profil.Jp))
							]);
					} else {
						var preferences = commande.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'langue',
								$elm$json$Json$Encode$string(preferences.nn)),
								_Utils_Tuple2(
								'fuseau',
								$elm$json$Json$Encode$string(preferences.z_))
							]);
					}
				}()));
	});
var $author$project$Components$Comptes$MonCompte$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Comptes$MonCompte$API$WriteAPIModel$encode, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Comptes$Securite$API$WriteAPIModel$encode = F2(
	function (processUid, commande) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
				function () {
					switch (commande.$) {
						case 0:
							var renomme = commande.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'moyen',
									$elm$json$Json$Encode$string(renomme.CZ)),
									_Utils_Tuple2(
									'nom',
									$elm$json$Json$Encode$string(renomme.Dj))
								]);
						case 1:
							var moyen = commande.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'moyen',
									$elm$json$Json$Encode$string(moyen))
								]);
						case 2:
							var session = commande.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'session',
									$elm$json$Json$Encode$string(session))
								]);
						default:
							return _List_Nil;
					}
				}()));
	});
var $author$project$Components$Comptes$Securite$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Comptes$Securite$API$WriteAPIModel$encode, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Imports$Outil$API$WriteAPIModel$encoderUneCommandeDeLot = F2(
	function (processUid, lot) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
					_Utils_Tuple2(
					'lot',
					$elm$json$Json$Encode$string(lot))
				]));
	});
var $author$project$Components$Imports$Outil$API$HttpAPI$commandeDeLot = F2(
	function (requete, lot) {
		return $author$project$API$Requete$authentifiee(
			{
				f$: $elm$core$Maybe$Just(
					A2($author$project$Components$Imports$Outil$API$WriteAPIModel$encoderUneCommandeDeLot, requete.Gn, lot)),
				gM: requete.gM,
				aQ: requete.nB.cM,
				sm: requete.nB.sm
			});
	});
var $author$project$Components$Imports$Outil$API$WriteAPIModel$reglagesVides = {fI: $elm$core$Maybe$Nothing, gB: $elm$core$Maybe$Nothing, D1: $elm$core$Maybe$Nothing, hi: $elm$core$Maybe$Nothing, o4: $elm$core$Maybe$Nothing, ho: $elm$core$Maybe$Nothing, hy: $elm$core$Maybe$Nothing, eX: _List_Nil};
var $author$project$Components$Imports$Outil$API$WriteAPIModel$encoderLesReglages = function (reglages) {
	return _Utils_eq(reglages, $author$project$Components$Imports$Outil$API$WriteAPIModel$reglagesVides) ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(
			'reglages',
			$elm$json$Json$Encode$object(
				_Utils_ap(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (q) {
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'qualite',
										$elm$json$Json$Encode$string(q))
									]);
							},
							reglages.hy)),
					_Utils_ap(
						_Utils_eq(reglages.eX, _List_Nil) ? _List_Nil : _List_fromArray(
							[
								_Utils_Tuple2(
								'roles',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, reglages.eX))
							]),
						_Utils_ap(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (o) {
										return _List_fromArray(
											[
												_Utils_Tuple2(
												'offre',
												$elm$json$Json$Encode$string(o))
											]);
									},
									reglages.D1)),
							_Utils_ap(
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function (o) {
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'origine',
													$elm$json$Json$Encode$string(o))
												]);
										},
										reglages.o4)),
								_Utils_ap(
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											function (o) {
												return _List_fromArray(
													[
														_Utils_Tuple2(
														'organisationInconnue',
														$elm$json$Json$Encode$string(o))
													]);
											},
											reglages.hi)),
									_Utils_ap(
										A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2(
												$elm$core$Maybe$map,
												function (b) {
													return _List_fromArray(
														[
															_Utils_Tuple2(
															'baseLegale',
															$elm$json$Json$Encode$string(b))
														]);
												},
												reglages.fI)),
										_Utils_ap(
											A2(
												$elm$core$Maybe$withDefault,
												_List_Nil,
												A2(
													$elm$core$Maybe$map,
													function (p) {
														return _List_fromArray(
															[
																_Utils_Tuple2(
																'pays',
																$elm$json$Json$Encode$string(p))
															]);
													},
													reglages.ho)),
											A2(
												$elm$core$Maybe$withDefault,
												_List_Nil,
												A2(
													$elm$core$Maybe$map,
													function (f) {
														return _List_fromArray(
															[
																_Utils_Tuple2(
																'forme',
																$elm$json$Json$Encode$string(f))
															]);
													},
													reglages.gB)))))))))))
		]);
};
var $author$project$Components$Imports$Outil$API$WriteAPIModel$encoderLesRegles = function (regles) {
	var texte = F2(
		function (cle, valeur) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (v) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								cle,
								$elm$json$Json$Encode$string(v))
							]);
					},
					valeur));
		});
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			A2(texte, 'formatDeDate', regles.zQ),
			_Utils_ap(
				A2(texte, 'separateurDecimal', regles.IH),
				_Utils_ap(
					A2(texte, 'separateurDeListe', regles.IG),
					_Utils_ap(
						A2(texte, 'uniteDeLaColonne', regles.Ka),
						_Utils_ap(
							A2(texte, 'langue', regles.nn),
							_Utils_ap(
								A2(texte, 'usage', regles.sd),
								_List_fromArray(
									[
										_Utils_Tuple2(
										'valeurs',
										A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$json$Json$Encode$string, regles.Ki))
									]))))))));
};
var $author$project$Components$Imports$Outil$API$WriteAPIModel$encoderLesParts = $elm$json$Json$Encode$list(
	function (part) {
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'cle',
						$elm$json$Json$Encode$string(part.dy)),
						_Utils_Tuple2(
						'ligneDEnTete',
						$elm$json$Json$Encode$int(part.nT)),
						_Utils_Tuple2(
						'domaine',
						$elm$json$Json$Encode$string(part.cC)),
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string(part.r0)),
						_Utils_Tuple2(
						'colonnes',
						A2(
							$elm$json$Json$Encode$list,
							function (colonne) {
								return $elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'index',
											$elm$json$Json$Encode$int(colonne.AI)),
											_Utils_Tuple2(
											'champ',
											$elm$json$Json$Encode$string(colonne.uN)),
											_Utils_Tuple2(
											'regles',
											$author$project$Components$Imports$Outil$API$WriteAPIModel$encoderLesRegles(colonne.hJ))
										]));
							},
							part.j1)),
						_Utils_Tuple2(
						'siExiste',
						$elm$json$Json$Encode$string(part.IM))
					]),
				_Utils_ap(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (feuille) {
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'feuille',
										$elm$json$Json$Encode$string(feuille))
									]);
							},
							part.mx)),
					_Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (index) {
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'parColonne',
											$elm$json$Json$Encode$int(index))
										]);
								},
								part.o5)),
						$author$project$Components$Imports$Outil$API$WriteAPIModel$encoderLesReglages(part.qc)))));
	});
var $author$project$Components$Imports$Outil$API$WriteAPIModel$encoderUnGesteDeLigne = F5(
	function (processUid, lot, part, ligne, valeur) {
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'processUid',
						$author$project$API$ProcessUid$encode(processUid)),
						_Utils_Tuple2(
						'lot',
						$elm$json$Json$Encode$string(lot)),
						_Utils_Tuple2(
						'part',
						$elm$json$Json$Encode$int(part)),
						_Utils_Tuple2(
						'ligne',
						$elm$json$Json$Encode$int(ligne))
					]),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (v) {
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'valeur',
									$elm$json$Json$Encode$string(v))
								]);
						},
						valeur))));
	});
var $author$project$Components$Imports$Outil$API$WriteAPIModel$encoderUnModele = F2(
	function (processUid, modele) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
					_Utils_Tuple2(
					'nom',
					$elm$json$Json$Encode$string(modele.Dj)),
					_Utils_Tuple2(
					'domaine',
					$elm$json$Json$Encode$string(modele.cC)),
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string(modele.r0)),
					_Utils_Tuple2(
					'colonnes',
					A2(
						$elm$json$Json$Encode$list,
						function (colonne) {
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'entete',
										$elm$json$Json$Encode$string(colonne.l0)),
										_Utils_Tuple2(
										'champ',
										$elm$json$Json$Encode$string(colonne.uN)),
										_Utils_Tuple2(
										'regles',
										$author$project$Components$Imports$Outil$API$WriteAPIModel$encoderLesRegles(colonne.hJ))
									]));
						},
						modele.j1))
				]));
	});
var $author$project$Components$Imports$Outil$API$HttpAPI$geste = F2(
	function (requete, corps) {
		return $author$project$API$Requete$authentifiee(
			{
				f$: $elm$core$Maybe$Just(corps),
				gM: requete.gM,
				aQ: requete.nB.cM,
				sm: requete.nB.sm
			});
	});
var $author$project$API$ProcessUid$toString = function (_v0) {
	var valeur = _v0;
	return valeur;
};
var $author$project$Components$Imports$Outil$API$HttpAPI$envoyerReq = function (requete) {
	var _v0 = requete.vJ;
	switch (_v0.$) {
		case 0:
			var fichier = _v0.a;
			var parts = _v0.b;
			return A3(
				$author$project$Components$Imports$Outil$API$HttpAPI$multipart,
				requete.gM,
				requete.nB,
				_List_fromArray(
					[
						A2(
						$elm$http$Http$stringPart,
						'processUid',
						$author$project$API$ProcessUid$toString(requete.Gn)),
						A2(
						$elm$http$Http$stringPart,
						'parts',
						A2(
							$elm$json$Json$Encode$encode,
							0,
							$author$project$Components$Imports$Outil$API$WriteAPIModel$encoderLesParts(parts))),
						A2($elm$http$Http$filePart, 'fichier', fichier)
					]));
		case 1:
			var lot = _v0.a;
			return A2($author$project$Components$Imports$Outil$API$HttpAPI$commandeDeLot, requete, lot);
		case 2:
			var lot = _v0.a;
			return A2($author$project$Components$Imports$Outil$API$HttpAPI$commandeDeLot, requete, lot);
		case 3:
			var lot = _v0.a;
			var part = _v0.b;
			var ligne = _v0.c;
			var valeur = _v0.d;
			return A2(
				$author$project$Components$Imports$Outil$API$HttpAPI$geste,
				requete,
				A5(
					$author$project$Components$Imports$Outil$API$WriteAPIModel$encoderUnGesteDeLigne,
					requete.Gn,
					lot,
					part,
					ligne,
					$elm$core$Maybe$Just(valeur)));
		case 4:
			var lot = _v0.a;
			var part = _v0.b;
			var ligne = _v0.c;
			return A2(
				$author$project$Components$Imports$Outil$API$HttpAPI$geste,
				requete,
				A5($author$project$Components$Imports$Outil$API$WriteAPIModel$encoderUnGesteDeLigne, requete.Gn, lot, part, ligne, $elm$core$Maybe$Nothing));
		case 5:
			var lot = _v0.a;
			var part = _v0.b;
			var ligne = _v0.c;
			return A2(
				$author$project$Components$Imports$Outil$API$HttpAPI$geste,
				requete,
				A5($author$project$Components$Imports$Outil$API$WriteAPIModel$encoderUnGesteDeLigne, requete.Gn, lot, part, ligne, $elm$core$Maybe$Nothing));
		case 6:
			var lot = _v0.a;
			var part = _v0.b;
			var ligne = _v0.c;
			return A2(
				$author$project$Components$Imports$Outil$API$HttpAPI$geste,
				requete,
				A5($author$project$Components$Imports$Outil$API$WriteAPIModel$encoderUnGesteDeLigne, requete.Gn, lot, part, ligne, $elm$core$Maybe$Nothing));
		case 7:
			var lot = _v0.a;
			return A2($author$project$Components$Imports$Outil$API$HttpAPI$commandeDeLot, requete, lot);
		default:
			var modele = _v0.a;
			return $author$project$API$Requete$authentifiee(
				{
					f$: $elm$core$Maybe$Just(
						A2($author$project$Components$Imports$Outil$API$WriteAPIModel$encoderUnModele, requete.Gn, modele)),
					gM: requete.gM,
					aQ: requete.nB.cM,
					sm: requete.nB.sm
				});
	}
};
var $author$project$Components$Notifications$API$WriteAPIModel$encode = F2(
	function (processUid, _v0) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid))
				]));
	});
var $author$project$Components$Notifications$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Notifications$API$WriteAPIModel$encode, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$encodeRattachement = F2(
	function (processUid, r) {
		var partiePrenante = r.cC === 'parties-prenantes';
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'processUid',
						$author$project$API$ProcessUid$encode(processUid)),
						_Utils_Tuple2(
						partiePrenante ? 'type' : 'typeDeProduit',
						$elm$json$Json$Encode$string(r.HN)),
						_Utils_Tuple2(
						'champ',
						$elm$json$Json$Encode$string(r.uN)),
						_Utils_Tuple2(
						'exigence',
						$elm$json$Json$Encode$string(r.qc.mo)),
						_Utils_Tuple2(
						'niveauDeLecture',
						$elm$json$Json$Encode$string(r.qc.g4)),
						_Utils_Tuple2(
						'masque',
						$elm$json$Json$Encode$bool(r.qc.n4))
					]),
				partiePrenante ? _List_fromArray(
					[
						_Utils_Tuple2(
						'donneePersonnelle',
						$elm$json$Json$Encode$bool(r.qc.xD))
					]) : _List_Nil));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$encodeReglagesALaCreation = function (reglages) {
	return _Utils_ap(
		A3($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$facultatif, 'collection', $elm$json$Json$Encode$string, reglages.vD),
		_Utils_ap(
			_Utils_eq(reglages.yG, _List_Nil) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(
					'etages',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, reglages.yG))
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'filtrable',
					$elm$json$Json$Encode$bool(reglages.zG)),
					_Utils_Tuple2(
					'recherchable',
					$elm$json$Json$Encode$bool(reglages.G1))
				])));
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$encodeIssue = function (_v0) {
	var valeur = _v0.a;
	var issue = _v0.b;
	switch (issue.$) {
		case 0:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'valeur',
						$elm$json$Json$Encode$string(valeur)),
						_Utils_Tuple2(
						'issue',
						$elm$json$Json$Encode$string('ajouter'))
					]));
		case 2:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'valeur',
						$elm$json$Json$Encode$string(valeur)),
						_Utils_Tuple2(
						'issue',
						$elm$json$Json$Encode$string('laisser'))
					]));
		default:
			var avec = issue.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'valeur',
						$elm$json$Json$Encode$string(valeur)),
						_Utils_Tuple2(
						'issue',
						$elm$json$Json$Encode$string('rapprocher')),
						_Utils_Tuple2(
						'avec',
						$elm$json$Json$Encode$string(avec))
					]));
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$encodeReprise = F5(
	function (processUid, cle, nom, rattacherA, issues) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
					_Utils_Tuple2(
					'champs',
					A2(
						$elm$json$Json$Encode$list,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$elm$json$Json$Encode$object(
								_Utils_ap(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'cle',
											$elm$json$Json$Encode$string(cle)),
											_Utils_Tuple2(
											'nom',
											$elm$json$Json$Encode$string(nom))
										]),
									_Utils_ap(
										A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2(
												$elm$core$Maybe$map,
												function (id) {
													return _List_fromArray(
														[
															_Utils_Tuple2(
															'rattacherA',
															$elm$json$Json$Encode$string(id))
														]);
												},
												rattacherA)),
										_List_fromArray(
											[
												_Utils_Tuple2(
												'horsSchema',
												A2($elm$json$Json$Encode$list, $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$encodeIssue, issues))
											]))))
							])))
				]));
	});
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$encode = F2(
	function (processUid, commande) {
		encode:
		while (true) {
			switch (commande.$) {
				case 4:
					var nom = commande.a;
					var portee = commande.b;
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'processUid',
								$author$project$API$ProcessUid$encode(processUid)),
								_Utils_Tuple2(
								'nom',
								$elm$json$Json$Encode$string(nom)),
								_Utils_Tuple2(
								'portee',
								$elm$json$Json$Encode$string(portee))
							]));
				case 5:
					var liste = commande.a;
					var libelle = commande.b;
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'processUid',
								$author$project$API$ProcessUid$encode(processUid)),
								_Utils_Tuple2(
								'liste',
								$elm$json$Json$Encode$string(liste)),
								_Utils_Tuple2(
								'libelle',
								$elm$json$Json$Encode$string(libelle))
							]));
				case 0:
					var cle = commande.a;
					var nom = commande.b;
					var rattacherA = commande.c;
					var issues = commande.d;
					return A5($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$encodeReprise, processUid, cle, nom, rattacherA, issues);
				case 1:
					var nom = commande.a;
					var typeDeChamp = commande.b;
					var portee = commande.c;
					var cle = commande.d;
					var liste = commande.e;
					return $elm$json$Json$Encode$object(
						_Utils_ap(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'processUid',
									$author$project$API$ProcessUid$encode(processUid)),
									_Utils_Tuple2(
									'nom',
									$elm$json$Json$Encode$string(nom)),
									_Utils_Tuple2(
									'typeDeChamp',
									$elm$json$Json$Encode$string(typeDeChamp)),
									_Utils_Tuple2(
									'portee',
									$elm$json$Json$Encode$string(portee)),
									_Utils_Tuple2(
									'cle',
									$elm$json$Json$Encode$string(cle))
								]),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (l) {
										return _List_fromArray(
											[
												_Utils_Tuple2(
												'liste',
												$elm$json$Json$Encode$string(l))
											]);
									},
									liste))));
				case 2:
					var porteur = commande.a;
					var interne = commande.b;
					var _v1 = A2(
						$elm$json$Json$Decode$decodeValue,
						$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value),
						A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$encode, processUid, interne));
					if (!_v1.$) {
						var champs = _v1.a;
						return $elm$json$Json$Encode$object(
							_Utils_ap(
								A2(
									$elm$core$List$filter,
									function (_v2) {
										var cle = _v2.a;
										return cle !== 'portee';
									},
									champs),
								porteur));
					} else {
						var $temp$processUid = processUid,
							$temp$commande = interne;
						processUid = $temp$processUid;
						commande = $temp$commande;
						continue encode;
					}
				case 3:
					var porteur = commande.a;
					var champ = commande.b;
					return $elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'processUid',
								$author$project$API$ProcessUid$encode(processUid)),
							_Utils_ap(
								porteur,
								_List_fromArray(
									[
										_Utils_Tuple2(
										'champ',
										$elm$json$Json$Encode$string(champ))
									]))));
				case 6:
					var champ = commande.a;
					return $elm$json$Json$Encode$object(
						_Utils_ap(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'processUid',
									$author$project$API$ProcessUid$encode(processUid)),
									_Utils_Tuple2(
									'nom',
									$elm$json$Json$Encode$string(champ.Dj)),
									_Utils_Tuple2(
									'typeDeChamp',
									$elm$json$Json$Encode$string(champ.JR)),
									_Utils_Tuple2(
									'portee',
									$elm$json$Json$Encode$string(champ.F$))
								]),
							_Utils_ap(
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function (l) {
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'liste',
													$elm$json$Json$Encode$string(l))
												]);
										},
										champ.nW)),
								_Utils_ap(
									function () {
										var _v3 = _Utils_Tuple2(champ.o_, champ.r$);
										if (!_v3.a.$) {
											var options = _v3.a.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'options',
													$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$encodeOptions(options))
												]);
										} else {
											if (!_v3.b.$) {
												var _v4 = _v3.a;
												var t = _v3.b.a;
												return _List_fromArray(
													[
														_Utils_Tuple2(
														'options',
														$elm$json$Json$Encode$object(
															_List_fromArray(
																[
																	_Utils_Tuple2(
																	'typeVise',
																	$elm$json$Json$Encode$string(t))
																])))
													]);
											} else {
												var _v5 = _v3.a;
												var _v6 = _v3.b;
												return _List_Nil;
											}
										}
									}(),
									$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$encodeReglagesALaCreation(champ.qc)))));
				case 7:
					var groupe = commande.a;
					return $elm$json$Json$Encode$object(
						_Utils_ap(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'processUid',
									$author$project$API$ProcessUid$encode(processUid)),
									_Utils_Tuple2(
									'nom',
									$elm$json$Json$Encode$string(groupe.Dj)),
									_Utils_Tuple2(
									'typeDeChamp',
									$elm$json$Json$Encode$string('groupe')),
									_Utils_Tuple2(
									'portee',
									$elm$json$Json$Encode$string(groupe.F$)),
									_Utils_Tuple2(
									'options',
									$elm$json$Json$Encode$object(
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2(
												'sousChamps',
												A2($elm$json$Json$Encode$list, $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$encodeSousChamp, groupe.IX)),
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2(
													'repetable',
													$elm$json$Json$Encode$bool(groupe.HI)),
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													A2(
														$elm$core$Maybe$map,
														function (o) {
															return _List_fromArray(
																[
																	_Utils_Tuple2(
																	'libelleOccurrence',
																	$elm$json$Json$Encode$string(o.Bl)),
																	_Utils_Tuple2(
																	'genreOccurrence',
																	$elm$json$Json$Encode$string(
																		$author$project$Components$Shared$GenreDuNom$code(o.M)))
																]);
														},
														groupe.D$))))))
								]),
							$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$encodeReglagesALaCreation(groupe.qc)));
				case 16:
					var portee = commande.a;
					var champ = commande.b;
					var valeurs = commande.c;
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'processUid',
								$author$project$API$ProcessUid$encode(processUid)),
								_Utils_Tuple2(
								'portee',
								$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$encodePortee(portee)),
								_Utils_Tuple2(
								'champ',
								$elm$json$Json$Encode$string(champ)),
								_Utils_Tuple2(
								'valeurs',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, valeurs))
							]));
				case 17:
					var portee = commande.a;
					var champ = commande.b;
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'processUid',
								$author$project$API$ProcessUid$encode(processUid)),
								_Utils_Tuple2(
								'portee',
								$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$encodePortee(portee)),
								_Utils_Tuple2(
								'champ',
								$elm$json$Json$Encode$string(champ))
							]));
				case 18:
					var type_ = commande.a;
					var champ = commande.b;
					var valeurs = commande.c;
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'processUid',
								$author$project$API$ProcessUid$encode(processUid)),
								_Utils_Tuple2(
								'typeDeProduit',
								$elm$json$Json$Encode$string(type_)),
								_Utils_Tuple2(
								'champ',
								$elm$json$Json$Encode$string(champ)),
								_Utils_Tuple2(
								'valeurs',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, valeurs))
							]));
				case 19:
					var type_ = commande.a;
					var champ = commande.b;
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'processUid',
								$author$project$API$ProcessUid$encode(processUid)),
								_Utils_Tuple2(
								'typeDeProduit',
								$elm$json$Json$Encode$string(type_)),
								_Utils_Tuple2(
								'champ',
								$elm$json$Json$Encode$string(champ))
							]));
				case 8:
					var champ = commande.a;
					var filtrable = commande.b;
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'processUid',
								$author$project$API$ProcessUid$encode(processUid)),
								_Utils_Tuple2(
								'champ',
								$elm$json$Json$Encode$string(champ)),
								_Utils_Tuple2(
								'filtrable',
								$elm$json$Json$Encode$bool(filtrable))
							]));
				case 9:
					var champ = commande.a;
					var recherchable = commande.b;
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'processUid',
								$author$project$API$ProcessUid$encode(processUid)),
								_Utils_Tuple2(
								'champ',
								$elm$json$Json$Encode$string(champ)),
								_Utils_Tuple2(
								'recherchable',
								$elm$json$Json$Encode$bool(recherchable))
							]));
				case 11:
					var champ = commande.a;
					var collection = commande.b;
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'processUid',
								$author$project$API$ProcessUid$encode(processUid)),
								_Utils_Tuple2(
								'champ',
								$elm$json$Json$Encode$string(champ)),
								_Utils_Tuple2(
								'collection',
								$elm$json$Json$Encode$string(collection))
							]));
				case 12:
					var champ = commande.a;
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'processUid',
								$author$project$API$ProcessUid$encode(processUid)),
								_Utils_Tuple2(
								'champ',
								$elm$json$Json$Encode$string(champ))
							]));
				case 10:
					var champ = commande.a;
					var portee = commande.b;
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'processUid',
								$author$project$API$ProcessUid$encode(processUid)),
								_Utils_Tuple2(
								'champ',
								$elm$json$Json$Encode$string(champ)),
								_Utils_Tuple2(
								'portee',
								$elm$json$Json$Encode$string(portee))
							]));
				case 13:
					var champ = commande.a;
					var nom = commande.b;
					var aide = commande.c;
					var options = commande.d;
					var genre = commande.e;
					return $elm$json$Json$Encode$object(
						_Utils_ap(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'processUid',
									$author$project$API$ProcessUid$encode(processUid)),
									_Utils_Tuple2(
									'champ',
									$elm$json$Json$Encode$string(champ)),
									_Utils_Tuple2(
									'nom',
									$elm$json$Json$Encode$string(nom)),
									_Utils_Tuple2(
									'aide',
									$elm$json$Json$Encode$string(aide))
								]),
							_Utils_ap(
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function (o) {
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'options',
													$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$encodeOptions(o))
												]);
										},
										options)),
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function (g) {
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'genre',
													$elm$json$Json$Encode$string(
														$author$project$Components$Shared$GenreDuNom$code(g)))
												]);
										},
										genre)))));
				case 22:
					var r = commande.a;
					return A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$encodeRattachement, processUid, r);
				case 20:
					var champ = commande.a;
					var formule = commande.b;
					var recalcul = commande.c;
					var valeur = commande.d;
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'processUid',
								$author$project$API$ProcessUid$encode(processUid)),
								_Utils_Tuple2(
								'champ',
								$elm$json$Json$Encode$string(champ)),
								_Utils_Tuple2(
								'formule',
								$elm$json$Json$Encode$string(formule)),
								_Utils_Tuple2(
								'recalcul',
								$elm$json$Json$Encode$string(recalcul)),
								_Utils_Tuple2(
								'valeur',
								$elm$json$Json$Encode$string(valeur))
							]));
				case 21:
					var typeDeProduit = commande.a;
					var champ = commande.b;
					var geste = commande.c;
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'processUid',
								$author$project$API$ProcessUid$encode(processUid)),
								_Utils_Tuple2(
								'typeDeProduit',
								$elm$json$Json$Encode$string(typeDeProduit)),
								_Utils_Tuple2(
								'champ',
								$elm$json$Json$Encode$string(champ)),
								_Utils_Tuple2(
								'geste',
								$elm$json$Json$Encode$string(geste))
							]));
				case 15:
					var champ = commande.a;
					var sousChamp = commande.b;
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'processUid',
								$author$project$API$ProcessUid$encode(processUid)),
								_Utils_Tuple2(
								'champ',
								$elm$json$Json$Encode$string(champ)),
								_Utils_Tuple2(
								'sousChamp',
								$elm$json$Json$Encode$string(sousChamp))
							]));
				default:
					var champ = commande.a;
					var langue = commande.b;
					var libelle = commande.c;
					var aide = commande.d;
					return $elm$json$Json$Encode$object(
						_Utils_ap(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'processUid',
									$author$project$API$ProcessUid$encode(processUid)),
									_Utils_Tuple2(
									'champ',
									$elm$json$Json$Encode$string(champ)),
									_Utils_Tuple2(
									'langue',
									$elm$json$Json$Encode$string(langue))
								]),
							_Utils_ap(
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function (l) {
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'libelle',
													$elm$json$Json$Encode$string(l))
												]);
										},
										libelle)),
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function (a) {
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'aide',
													$elm$json$Json$Encode$string(a))
												]);
										},
										aide)))));
			}
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$encode, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIModel$codeDeLaPortee = function (portee) {
	if (!portee) {
		return 'catalogue';
	} else {
		return 'parties-prenantes';
	}
};
var $author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIModel$champs = function (commande) {
	switch (commande.$) {
		case 0:
			var libelle = commande.a;
			var cle = commande.b;
			var portee = commande.c;
			var choisis = commande.d;
			return A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'libelles',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'fr',
								$elm$json$Json$Encode$string(libelle))
							]))),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'portee',
						$elm$json$Json$Encode$string(
							$author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIModel$codeDeLaPortee(portee))),
					_Utils_ap(
						$elm$core$String$isEmpty(cle) ? _List_Nil : _List_fromArray(
							[
								_Utils_Tuple2(
								'cle',
								$elm$json$Json$Encode$string(cle))
							]),
						$elm$core$List$isEmpty(choisis) ? _List_Nil : _List_fromArray(
							[
								_Utils_Tuple2(
								'champs',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, choisis))
							]))));
		case 1:
			var uid = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'collection',
					$elm$json$Json$Encode$string(uid))
				]);
		case 2:
			var uid = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'collection',
					$elm$json$Json$Encode$string(uid)),
					_Utils_Tuple2(
					'retirerLesChamps',
					$elm$json$Json$Encode$bool(true))
				]);
		default:
			var uid = commande.a;
			var francais = commande.b;
			var anglais = commande.c;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'collection',
					$elm$json$Json$Encode$string(uid)),
					_Utils_Tuple2(
					'libelles',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'fr',
								$elm$json$Json$Encode$string(francais)),
							(anglais === '') ? _List_Nil : _List_fromArray(
								[
									_Utils_Tuple2(
									'en',
									$elm$json$Json$Encode$string(anglais))
								]))))
				]);
	}
};
var $author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIModel$encode = F2(
	function (processUid, commande) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
				$author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIModel$champs(commande)));
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIModel$encode, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIModel$champsDeLExpediteur = function (expediteur) {
	return _Utils_ap(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'expediteur',
				$elm$json$Json$Encode$string(expediteur.mr)),
				_Utils_Tuple2(
				'nomAffiche',
				$elm$json$Json$Encode$string(expediteur.ov))
			]),
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (a) {
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'reponseA',
							$elm$json$Json$Encode$string(a))
						]);
				},
				expediteur.qw)));
};
var $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIModel$encode = F2(
	function (processUid, commande) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
				function () {
					switch (commande.$) {
						case 0:
							var connexion = commande.a;
							return A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'cleApi',
									$elm$json$Json$Encode$string(connexion.jU)),
								$author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIModel$champsDeLExpediteur(
									{mr: connexion.mr, ov: connexion.ov, qw: connexion.qw}));
						case 1:
							var expediteur = commande.a;
							return $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIModel$champsDeLExpediteur(expediteur);
						case 2:
							return _List_Nil;
						case 3:
							return _List_Nil;
						case 4:
							return _List_Nil;
						default:
							return _List_Nil;
					}
				}()));
	});
var $author$project$Components$Parametrage$CompteDEnvoi$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIModel$encode, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Parametrage$CompteurDeCode$API$WriteAPIModel$encode = F2(
	function (processUid, commande) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
					_Utils_Tuple2(
					'portee',
					$elm$json$Json$Encode$string(commande.F$)),
					_Utils_Tuple2(
					'chiffres',
					$elm$json$Json$Encode$int(commande.vb)),
					_Utils_Tuple2(
					'premier',
					$elm$json$Json$Encode$int(commande.Ge))
				]));
	});
var $author$project$Components$Parametrage$CompteurDeCode$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Parametrage$CompteurDeCode$API$WriteAPIModel$encode, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Parametrage$Conservation$API$WriteAPIModel$codeDuMotif = function (motif) {
	switch (motif) {
		case 0:
			return 'ContentieuxEnCours';
		case 1:
			return 'NouvelleDemandeDeLaPersonne';
		case 2:
			return 'ObligationLegale';
		default:
			return 'Autre';
	}
};
var $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$cas = F2(
	function (nom, champs) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					nom,
					$elm$json$Json$Encode$object(champs))
				]));
	});
var $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$facultatif = function (champ) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$json$Json$Encode$null,
		A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, champ));
};
var $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$encodeIncoherence = function (incoherence) {
	switch (incoherence.$) {
		case 0:
			var detail = incoherence.a;
			return A2(
				$author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$cas,
				'ChampPlusCourtQueLeType',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'champ',
						$elm$json$Json$Encode$string(detail.uN)),
						_Utils_Tuple2(
						'duree',
						$elm$json$Json$Encode$int(detail.lG)),
						_Utils_Tuple2(
						'dureeDuType',
						$elm$json$Json$Encode$int(detail.lH))
					]));
		case 1:
			var detail = incoherence.a;
			return A2(
				$author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$cas,
				'DureeAuDelaDeLaReference',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'champ',
						$author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$facultatif(detail.uN)),
						_Utils_Tuple2(
						'duree',
						$elm$json$Json$Encode$int(detail.lG)),
						_Utils_Tuple2(
						'reference',
						$elm$json$Json$Encode$int(detail.Hc))
					]));
		case 2:
			var champ = incoherence.a;
			return A2(
				$author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$cas,
				'DonneePersonnelleSansDuree',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'champ',
						$elm$json$Json$Encode$string(champ))
					]));
		case 3:
			var detail = incoherence.a;
			return A2(
				$author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$cas,
				'AlertePlusLongueQueLaDuree',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'champ',
						$author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$facultatif(detail.uN)),
						_Utils_Tuple2(
						'alerte',
						$elm$json$Json$Encode$int(detail.iJ)),
						_Utils_Tuple2(
						'duree',
						$elm$json$Json$Encode$int(detail.lG))
					]));
		default:
			var champ = incoherence.a;
			return A2(
				$author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$cas,
				'NouvelleClasseSurChampRempli',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'champ',
						$elm$json$Json$Encode$string(champ))
					]));
	}
};
var $author$project$Components$Parametrage$Conservation$API$WriteAPIModel$champs = function (commande) {
	if (!commande.$) {
		var type_ = commande.a;
		var champ = commande.b;
		var duree = commande.c;
		var confirmees = commande.d;
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(type_)),
				_Utils_Tuple2(
				'champ',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, champ))),
				_Utils_Tuple2(
				'duree',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'mois',
							$elm$json$Json$Encode$int(duree.CQ)),
							_Utils_Tuple2(
							'alerte',
							$elm$json$Json$Encode$int(duree.iJ))
						]))),
				_Utils_Tuple2(
				'confirmees',
				A2($elm$json$Json$Encode$list, $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$encodeIncoherence, confirmees))
			]);
	} else {
		var prolongation = commande.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'entite',
				$elm$json$Json$Encode$string(prolongation.zo)),
				_Utils_Tuple2(
				'jusquA',
				$elm$json$Json$Encode$string(prolongation.A3)),
				_Utils_Tuple2(
				'motif',
				$elm$json$Json$Encode$string(
					$author$project$Components$Parametrage$Conservation$API$WriteAPIModel$codeDuMotif(prolongation.cX))),
				_Utils_Tuple2(
				'precision',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, prolongation.Gd))),
				_Utils_Tuple2(
				'classe',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.jT;
							},
							$elm$json$Json$Encode$string),
						prolongation.jT)))
			]);
	}
};
var $author$project$Components$Parametrage$Conservation$API$WriteAPIModel$encode = F2(
	function (processUid, commande) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
				$author$project$Components$Parametrage$Conservation$API$WriteAPIModel$champs(commande)));
	});
var $author$project$Components$Parametrage$Conservation$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Parametrage$Conservation$API$WriteAPIModel$encode, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Parametrage$Droits$API$WriteAPIModel$accesDuModule = function (acces) {
	switch (acces) {
		case 0:
			return 'Aucun';
		case 1:
			return 'Lecture';
		default:
			return 'Modification';
	}
};
var $author$project$Components$Parametrage$Droits$API$WriteAPIModel$accesDuChamp = function (acces) {
	switch (acces) {
		case 0:
			return 'Masque';
		case 1:
			return 'Lecture';
		default:
			return 'Modification';
	}
};
var $author$project$Components$Parametrage$Droits$API$WriteAPIModel$encodeType = function (droit) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'module',
				$elm$json$Json$Encode$string(droit.oe)),
				_Utils_Tuple2(
				'voir',
				$elm$json$Json$Encode$bool(droit.KT)),
				_Utils_Tuple2(
				'creer',
				$elm$json$Json$Encode$bool(droit.dC)),
				_Utils_Tuple2(
				'modifier',
				$elm$json$Json$Encode$bool(droit.ei)),
				_Utils_Tuple2(
				'perimetre',
				$elm$json$Json$Encode$string(droit.E9)),
				_Utils_Tuple2(
				'champs',
				A3(
					$elm$json$Json$Encode$dict,
					$elm$core$Basics$identity,
					A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$Droits$API$WriteAPIModel$accesDuChamp, $elm$json$Json$Encode$string),
					droit.dw))
			]));
};
var $author$project$Components$Parametrage$Droits$API$WriteAPIModel$encodeDroits = function (droits) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'modules',
				A3(
					$elm$json$Json$Encode$dict,
					$elm$core$Basics$identity,
					A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$Droits$API$WriteAPIModel$accesDuModule, $elm$json$Json$Encode$string),
					droits.of)),
				_Utils_Tuple2(
				'types',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$Components$Parametrage$Droits$API$WriteAPIModel$encodeType, droits.ib)),
				_Utils_Tuple2(
				'particuliers',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, droits.pa)),
				_Utils_Tuple2(
				'toutAvecLAvenir',
				$elm$json$Json$Encode$bool(droits.rM))
			]));
};
var $author$project$Components$Parametrage$Droits$API$WriteAPIModel$champs = function (commande) {
	switch (commande.$) {
		case 0:
			var nom = commande.a;
			var droits = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$elm$json$Json$Encode$string(nom)),
					_Utils_Tuple2(
					'droits',
					$author$project$Components$Parametrage$Droits$API$WriteAPIModel$encodeDroits(droits))
				]);
		case 1:
			var modele = commande.a;
			var nom = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'modele',
					$elm$json$Json$Encode$string(modele)),
					_Utils_Tuple2(
					'nom',
					$elm$json$Json$Encode$string(nom))
				]);
		case 2:
			var role = commande.a;
			var nom = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$elm$json$Json$Encode$string(role)),
					_Utils_Tuple2(
					'nom',
					$elm$json$Json$Encode$string(nom))
				]);
		case 3:
			var role = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$elm$json$Json$Encode$string(role))
				]);
		case 4:
			var role = commande.a;
			var droits = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$elm$json$Json$Encode$string(role)),
					_Utils_Tuple2(
					'droits',
					$author$project$Components$Parametrage$Droits$API$WriteAPIModel$encodeDroits(droits))
				]);
		case 5:
			var role = commande.a;
			var utilisateur = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$elm$json$Json$Encode$string(role)),
					_Utils_Tuple2(
					'utilisateur',
					$elm$json$Json$Encode$string(utilisateur))
				]);
		default:
			var role = commande.a;
			var utilisateur = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$elm$json$Json$Encode$string(role)),
					_Utils_Tuple2(
					'utilisateur',
					$elm$json$Json$Encode$string(utilisateur))
				]);
	}
};
var $author$project$Components$Parametrage$Droits$API$WriteAPIModel$encode = F2(
	function (processUid, commande) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
				$author$project$Components$Parametrage$Droits$API$WriteAPIModel$champs(commande)));
	});
var $author$project$Components$Parametrage$Droits$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Parametrage$Droits$API$WriteAPIModel$encode, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIModel$langueDe = function (commande) {
	switch (commande.$) {
		case 0:
			var code = commande.a;
			return code;
		case 1:
			var code = commande.a;
			return code;
		case 2:
			var code = commande.a;
			return code;
		case 3:
			var code = commande.a;
			return code;
		default:
			var code = commande.a;
			return code;
	}
};
var $author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIModel$encode = F2(
	function (processUid, commande) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
					_Utils_Tuple2(
					'langue',
					$elm$json$Json$Encode$string(
						$author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIModel$langueDe(commande)))
				]));
	});
var $author$project$Components$Parametrage$LanguesDuClient$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIModel$encode, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Parametrage$ModelesDeTache$API$WriteAPIModel$avecJours = F2(
	function (changes, objet) {
		var nouveaux = A2(
			$elm$core$List$filterMap,
			function (_v2) {
				var cle = _v2.a;
				var texte = _v2.b;
				var enListe = _v2.c;
				return A2(
					$elm$core$Maybe$map,
					function (n) {
						return _Utils_Tuple2(
							cle,
							enListe ? A2(
								$elm$json$Json$Encode$list,
								$elm$json$Json$Encode$int,
								_List_fromArray(
									[n])) : $elm$json$Json$Encode$int(n));
					},
					$elm$core$String$toInt(
						$elm$core$String$trim(texte)));
			},
			changes);
		var cles = A2(
			$elm$core$List$map,
			function (_v1) {
				var cle = _v1.a;
				return cle;
			},
			changes);
		var champs = A2(
			$elm$core$Result$withDefault,
			_List_Nil,
			A2(
				$elm$json$Json$Decode$decodeValue,
				$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value),
				objet));
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var cle = _v0.a;
						return !A2($elm$core$List$member, cle, cles);
					},
					champs),
				nouveaux));
	});
var $author$project$Components$Parametrage$ModelesDeTache$API$WriteAPIModel$fr = function (texte) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'fr',
				$elm$json$Json$Encode$string(texte))
			]));
};
var $author$project$Components$Parametrage$ModelesDeTache$API$WriteAPIModel$surLeModele = F2(
	function (processUid, modele) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
					_Utils_Tuple2(
					'modeleUid',
					$elm$json$Json$Encode$string(modele))
				]));
	});
var $author$project$Components$Parametrage$ModelesDeTache$API$WriteAPIModel$encode = F2(
	function (processUid, commande) {
		switch (commande.$) {
			case 0:
				var saisie = commande.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'processUid',
							$author$project$API$ProcessUid$encode(processUid)),
							_Utils_Tuple2(
							'modeleUid',
							$elm$json$Json$Encode$string(saisie.oa)),
							_Utils_Tuple2(
							'libelles',
							$author$project$Components$Parametrage$ModelesDeTache$API$WriteAPIModel$fr(saisie.Dj)),
							_Utils_Tuple2(
							'roleAttendu',
							$author$project$Components$Parametrage$ModelesDeTache$API$WriteAPIModel$fr(saisie.bi)),
							_Utils_Tuple2('reglage', saisie.eO),
							_Utils_Tuple2(
							'echeance',
							A2(
								$author$project$Components$Parametrage$ModelesDeTache$API$WriteAPIModel$avecJours,
								_List_fromArray(
									[
										_Utils_Tuple3('delaiEnJours', saisie.w2, false)
									]),
								saisie.xY)),
							_Utils_Tuple2(
							'relance',
							A2(
								$author$project$Components$Parametrage$ModelesDeTache$API$WriteAPIModel$avecJours,
								_List_fromArray(
									[
										_Utils_Tuple3('rappelsEnJoursAvant', saisie.GU, true),
										_Utils_Tuple3('delaiDeReponseEnJours', saisie.yy, false)
									]),
								saisie.Hq)),
							_Utils_Tuple2(
							'notesDeVersion',
							$elm$core$String$isEmpty(
								$elm$core$String$trim(saisie.oL)) ? $elm$json$Json$Encode$object(_List_Nil) : $author$project$Components$Parametrage$ModelesDeTache$API$WriteAPIModel$fr(saisie.oL))
						]));
			case 1:
				var modele = commande.a;
				return A2($author$project$Components$Parametrage$ModelesDeTache$API$WriteAPIModel$surLeModele, processUid, modele);
			case 2:
				var modele = commande.a;
				return A2($author$project$Components$Parametrage$ModelesDeTache$API$WriteAPIModel$surLeModele, processUid, modele);
			default:
				var modele = commande.a;
				return A2($author$project$Components$Parametrage$ModelesDeTache$API$WriteAPIModel$surLeModele, processUid, modele);
		}
	});
var $author$project$Components$Parametrage$ModelesDeTache$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Parametrage$ModelesDeTache$API$WriteAPIModel$encode, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Parametrage$PipeEtape1$API$LienModel$encodeLeLien = function (voulu) {
	if (!voulu.$) {
		var r = voulu.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('regroupement')),
				_Utils_Tuple2(
				'pipeRegroupeUid',
				$elm$json$Json$Encode$string(r.FI)),
				_Utils_Tuple2(
				'regleDeCreation',
				$elm$json$Json$Encode$object(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'mode',
							$elm$json$Json$Encode$string(r.hH.n9)),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (jour) {
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'jour',
											$elm$json$Json$Encode$int(jour))
										]);
								},
								r.hH.A_))))),
				_Utils_Tuple2(
				'critere',
				(r.km === 'champ') ? $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('champ')),
							_Utils_Tuple2(
							'champ',
							$elm$json$Json$Encode$string(r.uN))
						])) : $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('periode')),
							_Utils_Tuple2(
							'periode',
							$elm$json$Json$Encode$string(r.pi))
						])))
			]);
	} else {
		var e = voulu.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('enchainement')),
				_Utils_Tuple2(
				'pipeDeDepartUid',
				$elm$json$Json$Encode$string(e.Fw)),
				_Utils_Tuple2(
				'etapeDeDepartUid',
				$elm$json$Json$Encode$string(e.yK)),
				_Utils_Tuple2(
				'passageDeclencheurUid',
				$elm$json$Json$Encode$string(e.E4)),
				_Utils_Tuple2(
				'reprise',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'fiche',
							$elm$json$Json$Encode$bool(e.zo)),
							_Utils_Tuple2(
							'roles',
							$elm$json$Json$Encode$bool(e.eX)),
							_Utils_Tuple2(
							'champs',
							A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, e.dw))
						])))
			]);
	}
};
var $author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$evenement = function (lu) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(lu.r0)),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function (uid) {
							return _Utils_Tuple2(
								'pipeDOrigineUid',
								$elm$json$Json$Encode$string(uid));
						},
						lu.Fu),
						A2(
						$elm$core$Maybe$map,
						function (uid) {
							return _Utils_Tuple2(
								'etapeUid',
								$elm$json$Json$Encode$string(uid));
						},
						lu.me)
					]))));
};
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$libellesEncodes = A2($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$json$Json$Encode$string);
var $author$project$Components$Parametrage$Vocabulaire$natureMarque = 'marque';
var $author$project$Components$Parametrage$Vocabulaire$natureProduit = 'produit';
var $author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$objetVise_ = function (voulu) {
	return _Utils_eq(voulu.g1, $author$project$Components$Parametrage$Vocabulaire$natureProduit) ? _List_fromArray(
		[
			_Utils_Tuple2(
			'nature',
			$elm$json$Json$Encode$string(voulu.g1)),
			_Utils_Tuple2(
			'typesDeFiche',
			A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, _List_Nil)),
			_Utils_Tuple2(
			'typesDeProduit',
			A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, voulu.ib)),
			_Utils_Tuple2(
			'tous',
			$elm$json$Json$Encode$bool(voulu.rL))
		]) : (_Utils_eq(voulu.g1, $author$project$Components$Parametrage$Vocabulaire$natureMarque) ? _List_fromArray(
		[
			_Utils_Tuple2(
			'nature',
			$elm$json$Json$Encode$string(voulu.g1)),
			_Utils_Tuple2(
			'typesDeFiche',
			A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, _List_Nil))
		]) : ((voulu.g1 === 'partie-prenante') ? _List_fromArray(
		[
			_Utils_Tuple2(
			'nature',
			$elm$json$Json$Encode$string(voulu.g1)),
			_Utils_Tuple2(
			'typesDeFiche',
			A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, voulu.ib)),
			_Utils_Tuple2(
			'tous',
			$elm$json$Json$Encode$bool(voulu.rL))
		]) : _List_fromArray(
		[
			_Utils_Tuple2(
			'nature',
			$elm$json$Json$Encode$string('aucun'))
		])));
};
var $author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$ouvertureParUnTiers = F2(
	function (pipeUid, voulue) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'pipeUid',
				$elm$json$Json$Encode$string(pipeUid)),
				_Utils_Tuple2(
				'roleUid',
				$elm$json$Json$Encode$string(voulue.H6)),
				_Utils_Tuple2(
				'portail',
				$elm$json$Json$Encode$string(voulue.FY)),
				_Utils_Tuple2(
				'fiche',
				voulue.oU ? $elm$json$Json$Encode$object(
					_Utils_ap(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'cas',
								$elm$json$Json$Encode$string('nouvelle-fiche')),
								_Utils_Tuple2(
								'types',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, voulue.ib))
							]),
						function () {
							var _v0 = voulue.pm;
							if (!_v0.$) {
								var n = _v0.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'plafondDeFichesProposees',
										$elm$json$Json$Encode$int(n))
									]);
							} else {
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'sansPlafond',
										$elm$json$Json$Encode$bool(true))
									]);
							}
						}())) : $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'cas',
							$elm$json$Json$Encode$string('fiche-existante')),
							_Utils_Tuple2(
							'dansSonPerimetre',
							$elm$json$Json$Encode$bool(voulue.kq))
						])))
			]);
	});
var $author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$periode = function (voulue) {
	switch (voulue.$) {
		case 0:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('toujours'))
					]));
		case 1:
			var du = voulue.a;
			var au = voulue.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('entre-deux-dates')),
						_Utils_Tuple2(
						'du',
						$elm$json$Json$Encode$string(du)),
						_Utils_Tuple2(
						'au',
						$elm$json$Json$Encode$string(au))
					]));
		default:
			var r = voulue.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('recurrente')),
						_Utils_Tuple2(
						'rythme',
						$elm$json$Json$Encode$string(r.Ij)),
						_Utils_Tuple2(
						'ouverture',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'jour',
									$elm$json$Json$Encode$int(r.A$)),
									_Utils_Tuple2(
									'mois',
									$elm$json$Json$Encode$string(r.CR))
								]))),
						_Utils_Tuple2(
						'fermeture',
						$elm$json$Json$Encode$object(
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_List_fromArray(
									[
										A2(
										$elm$core$Maybe$map,
										function (jour) {
											return _Utils_Tuple2(
												'jour',
												$elm$json$Json$Encode$int(jour));
										},
										r.A0),
										$elm$core$Maybe$Just(
										_Utils_Tuple2(
											'mois',
											$elm$json$Json$Encode$string(r.oh)))
									]))))
					]));
	}
};
var $author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$source_ = function (source) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'nature',
			$elm$json$Json$Encode$string(source.g1)),
			_Utils_Tuple2(
			'elementUids',
			A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, source.lR)),
			_Utils_Tuple2(
			'minimum',
			$elm$json$Json$Encode$int(source.CD)),
			_Utils_Tuple2(
			'maximum',
			A2(
				$elm$core$Maybe$withDefault,
				$elm$json$Json$Encode$null,
				A2($elm$core$Maybe$map, $elm$json$Json$Encode$int, source.Cj)))
		]);
};
var $author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$corps = F2(
	function (pipeUid, commande) {
		switch (commande.$) {
			case 0:
				var libelles = commande.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'pipeUid',
						$elm$json$Json$Encode$string(pipeUid)),
						_Utils_Tuple2(
						'libelles',
						$author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$libellesEncodes(libelles))
					]);
			case 1:
				var libelles = commande.a;
				var pluriel = commande.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'pipeUid',
						$elm$json$Json$Encode$string(pipeUid)),
						_Utils_Tuple2(
						'libelles',
						$author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$libellesEncodes(libelles)),
						_Utils_Tuple2(
						'motDossierPluriel',
						$author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$libellesEncodes(pluriel))
					]);
			case 2:
				var source = commande.a;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'pipeUid',
						$elm$json$Json$Encode$string(pipeUid)),
					$author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$source_(source));
			case 3:
				var sourceUid = commande.a;
				var source = commande.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'sourceUid',
						$elm$json$Json$Encode$string(sourceUid)),
					$author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$source_(source));
			case 4:
				var sourceUid = commande.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'sourceUid',
						$elm$json$Json$Encode$string(sourceUid))
					]);
			case 6:
				var voulu = commande.a;
				return _Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'pipeUid',
							$elm$json$Json$Encode$string(pipeUid)),
							_Utils_Tuple2(
							'objetVise',
							$elm$json$Json$Encode$object(
								$author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$objetVise_(voulu)))
						]),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (libelles) {
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'libelleDuRole',
										A3(
											$elm$json$Json$Encode$dict,
											$elm$core$Basics$identity,
											$elm$json$Json$Encode$string,
											A2(
												$elm$core$Dict$filter,
												F2(
													function (_v1, texte) {
														return $elm$core$String$trim(texte) !== '';
													}),
												libelles)))
									]);
							},
							voulu.gR)));
			case 7:
				var nom = commande.a;
				var mot = commande.b;
				var lien = commande.c;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'libelles',
						$author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$libellesEncodes(nom)),
						_Utils_Tuple2(
						'motDossier',
						$author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$libellesEncodes(mot)),
						_Utils_Tuple2(
						'lien',
						A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Encode$null,
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$PipeEtape1$API$LienModel$encodeLeLien, $elm$json$Json$Encode$object),
								lien)))
					]);
			case 8:
				var lienUid = commande.a;
				var lien = commande.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'pipeUid',
						$elm$json$Json$Encode$string(pipeUid)),
					_Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (uid) {
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'lienUid',
											$elm$json$Json$Encode$string(uid))
										]);
								},
								lienUid)),
						_List_fromArray(
							[
								_Utils_Tuple2(
								function () {
									if (!lien.$) {
										return 'regroupement';
									} else {
										return 'enchainement';
									}
								}(),
								$elm$json$Json$Encode$object(
									$author$project$Components$Parametrage$PipeEtape1$API$LienModel$encodeLeLien(lien)))
							])));
			case 9:
				var voulue = commande.a;
				return A2($author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$ouvertureParUnTiers, pipeUid, voulue);
			case 10:
				var voulue = commande.a;
				return A2($author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$ouvertureParUnTiers, pipeUid, voulue);
			case 11:
				var roleUid = commande.a;
				var portail = commande.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'pipeUid',
						$elm$json$Json$Encode$string(pipeUid)),
						_Utils_Tuple2(
						'roleUid',
						$elm$json$Json$Encode$string(roleUid)),
						_Utils_Tuple2(
						'portail',
						$elm$json$Json$Encode$string(portail))
					]);
			default:
				var ouverture = commande.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'pipeUid',
						$elm$json$Json$Encode$string(pipeUid)),
						_Utils_Tuple2(
						'qui',
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, ouverture.GK)),
						_Utils_Tuple2(
						'evenements',
						A2($elm$json$Json$Encode$list, $author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$evenement, ouverture.mk)),
						_Utils_Tuple2(
						'periode',
						$author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$periode(ouverture.pi)),
						_Utils_Tuple2(
						'parPersonne',
						$elm$json$Json$Encode$string(ouverture.EU))
					]);
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$encode = F3(
	function (processUid, pipeUid, commande) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
				A2($author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$corps, pipeUid, commande)));
	});
var $author$project$Components$Parametrage$PipeEtape1$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A3($author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$encode, requete.Gn, requete.FK, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$libellesEncodes = A2($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$json$Json$Encode$string);
var $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$etape_ = function (etape) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'libelles',
			$author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$libellesEncodes(etape.R)),
			_Utils_Tuple2(
			'but',
			$author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$libellesEncodes(etape.uy)),
			_Utils_Tuple2(
			'delaiAttenduEnJours',
			A2(
				$elm$core$Maybe$withDefault,
				$elm$json$Json$Encode$null,
				A2($elm$core$Maybe$map, $elm$json$Json$Encode$int, etape.kB))),
			_Utils_Tuple2(
			'portail',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'visible',
						$elm$json$Json$Encode$bool(etape.ps)),
						_Utils_Tuple2(
						'libelles',
						$author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$libellesEncodes(etape.pr))
					]))),
			_Utils_Tuple2(
			'finale',
			A2(
				$elm$core$Maybe$withDefault,
				$elm$json$Json$Encode$null,
				A2(
					$elm$core$Maybe$map,
					function (resultat) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'resultat',
									$elm$json$Json$Encode$string(resultat))
								]));
					},
					etape.mK)))
		]);
};
var $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$terme = function (lu) {
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'sujet',
					$elm$json$Json$Encode$string(lu.I9)),
					_Utils_Tuple2(
					'comparaison',
					$elm$json$Json$Encode$string(lu.vP)),
					_Utils_Tuple2(
					'valeur',
					function () {
						var _v0 = lu.fm;
						switch (_v0.$) {
							case 0:
								var nombre = _v0.a;
								return $elm$json$Json$Encode$float(nombre);
							case 1:
								var texte = _v0.a;
								return $elm$json$Json$Encode$string(texte);
							default:
								return $elm$json$Json$Encode$null;
						}
					}())
				]),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (id) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'correspondance',
								$elm$json$Json$Encode$string(id))
							]);
					},
					lu.wg))));
};
var $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$condition = function (passage) {
	return (passage.n9 === 'si') ? $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'mode',
				$elm$json$Json$Encode$string('si')),
				_Utils_Tuple2(
				'liaison',
				$elm$json$Json$Encode$string(passage.Bk)),
				_Utils_Tuple2(
				'termes',
				A2($elm$json$Json$Encode$list, $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$terme, passage.rD))
			])) : $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'mode',
				$elm$json$Json$Encode$string(passage.n9))
			]));
};
var $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$declenchement = function (voulu) {
	switch (voulu.$) {
		case 0:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('automatique'))
					]));
		case 1:
			var roleUid = voulu.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('par-un-role')),
						_Utils_Tuple2(
						'roleUid',
						$elm$json$Json$Encode$string(roleUid))
					]));
		case 2:
			var jours = voulu.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('calcule-sla')),
						_Utils_Tuple2(
						'echeance',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'delaiEnJours',
									$elm$json$Json$Encode$int(jours)),
									_Utils_Tuple2(
									'apres',
									$elm$json$Json$Encode$string('arrivee-a-l-etape'))
								])))
					]));
		default:
			var actionUid = voulu.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('par-le-regroupement')),
						_Utils_Tuple2(
						'actionUid',
						$elm$json$Json$Encode$string(actionUid))
					]));
	}
};
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$passage_ = function (passage) {
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				$elm$core$Maybe$Just(
				_Utils_Tuple2(
					'deEtapeUid',
					$elm$json$Json$Encode$string(passage.kt))),
				$elm$core$Maybe$Just(
				_Utils_Tuple2(
					'versEtapeUid',
					$elm$json$Json$Encode$string(passage.so))),
				$elm$core$Dict$isEmpty(passage.Bl) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'libelle',
					$author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$libellesEncodes(passage.Bl))),
				$elm$core$Maybe$Just(
				_Utils_Tuple2(
					'condition',
					$author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$condition(passage))),
				$elm$core$Maybe$Just(
				_Utils_Tuple2(
					'declenchement',
					$author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$declenchement(passage.kw)))
			]));
};
var $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$corps = F2(
	function (pipeUid, commande) {
		switch (commande.$) {
			case 0:
				var etape = commande.a;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'pipeUid',
						$elm$json$Json$Encode$string(pipeUid)),
					$author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$etape_(etape));
			case 1:
				var etapeUid = commande.a;
				var etape = commande.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'etapeUid',
						$elm$json$Json$Encode$string(etapeUid)),
					$author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$etape_(etape));
			case 2:
				var passage = commande.a;
				return $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$passage_(passage);
			case 3:
				var passageUid = commande.a;
				var passage = commande.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'passageUid',
						$elm$json$Json$Encode$string(passageUid)),
					$author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$passage_(passage));
			case 4:
				var etapeUid = commande.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'etapeUid',
						$elm$json$Json$Encode$string(etapeUid))
					]);
			default:
				var passageUid = commande.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'passageUid',
						$elm$json$Json$Encode$string(passageUid))
					]);
		}
	});
var $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$encode = F3(
	function (processUid, pipeUid, commande) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
				A2($author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$corps, pipeUid, commande)));
	});
var $author$project$Components$Parametrage$PipeEtape2$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A3($author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$encode, requete.Gn, requete.FK, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$codeDeLaCardinalite = function (cardinalite) {
	if (!cardinalite) {
		return 'une-seule';
	} else {
		return 'plusieurs';
	}
};
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$codeDeLaNature = function (nature) {
	switch (nature) {
		case 0:
			return 'interne';
		case 1:
			return 'externe';
		default:
			return 'interne-ou-externe';
	}
};
var $author$project$Components$Parametrage$PipeEtape3$API$WriteAPIModel$peutEtre_ = function (lu) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'genre',
				$elm$json$Json$Encode$string(lu.M)),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (uid) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'uid',
								$elm$json$Json$Encode$string(uid))
							]);
					},
					lu.r8))));
};
var $author$project$Components$Parametrage$PipeEtape3$API$WriteAPIModel$tenue = function (role) {
	var poste = _Utils_Tuple2(
		'postesUid',
		A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, role.F7));
	var perimetre = _List_fromArray(
		[
			_Utils_Tuple2(
			'selonLePerimetre',
			$elm$json$Json$Encode$bool(role.IB)),
			_Utils_Tuple2(
			'aucunContactDansLePerimetre',
			$elm$json$Json$Encode$string(role.tZ))
		]);
	var _v0 = role.Js;
	switch (_v0.$) {
		case 0:
			var peutEtre = _v0.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'mode',
						$elm$json$Json$Encode$string('choisi-dans-chaque-dossier')),
						_Utils_Tuple2(
						'peutEtre',
						A2($elm$json$Json$Encode$list, $author$project$Components$Parametrage$PipeEtape3$API$WriteAPIModel$peutEtre_, peutEtre))
					]));
		case 2:
			var champ = _v0.a;
			return $elm$json$Json$Encode$object(
				_Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'mode',
							$elm$json$Json$Encode$string('par-un-champ')),
							_Utils_Tuple2(
							'champ',
							$elm$json$Json$Encode$string(champ.uN)),
							_Utils_Tuple2(
							'aucuneValeur',
							$elm$json$Json$Encode$string(champ.t_)),
							poste,
							_Utils_Tuple2(
							'espacePropre',
							$elm$json$Json$Encode$bool(champ.yB)),
							_Utils_Tuple2(
							'portailCode',
							A2(
								$elm$core$Maybe$withDefault,
								$elm$json$Json$Encode$null,
								A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, champ.FZ)))
						]),
					perimetre));
		default:
			var relation = _v0.a;
			return $elm$json$Json$Encode$object(
				_Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'mode',
							$elm$json$Json$Encode$string('par-une-relation')),
							_Utils_Tuple2(
							'typeDeRelationUid',
							$elm$json$Json$Encode$string(relation.JU)),
							_Utils_Tuple2(
							'sens',
							$elm$json$Json$Encode$string(relation.IC)),
							_Utils_Tuple2(
							'sPlusieursRelations',
							$elm$json$Json$Encode$string(relation.qT)),
							_Utils_Tuple2(
							'aucuneRelation',
							$elm$json$Json$Encode$string(relation.i9)),
							_Utils_Tuple2(
							'relationTerminee',
							$elm$json$Json$Encode$string(relation.qi)),
							poste,
							_Utils_Tuple2(
							'espacePropre',
							$elm$json$Json$Encode$bool(relation.yB)),
							_Utils_Tuple2(
							'portailCode',
							A2(
								$elm$core$Maybe$withDefault,
								$elm$json$Json$Encode$null,
								A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, relation.FZ)))
						]),
					perimetre));
	}
};
var $author$project$Components$Parametrage$PipeEtape3$API$WriteAPIModel$role_ = function (role) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'libelles',
			A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$json$Json$Encode$string, role.R)),
			_Utils_Tuple2(
			'description',
			A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$json$Json$Encode$string, role.dH)),
			_Utils_Tuple2(
			'nature',
			$elm$json$Json$Encode$string(
				$author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$codeDeLaNature(role.g1))),
			_Utils_Tuple2(
			'cardinalite',
			$elm$json$Json$Encode$string(
				$author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$codeDeLaCardinalite(role.jz))),
			_Utils_Tuple2(
			'tenue',
			$author$project$Components$Parametrage$PipeEtape3$API$WriteAPIModel$tenue(role))
		]);
};
var $author$project$Components$Parametrage$PipeEtape3$API$WriteAPIModel$corps = F2(
	function (pipeUid, commande) {
		switch (commande.$) {
			case 0:
				var role = commande.a;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'pipeUid',
						$elm$json$Json$Encode$string(pipeUid)),
					$author$project$Components$Parametrage$PipeEtape3$API$WriteAPIModel$role_(role));
			case 1:
				var roleUid = commande.a;
				var role = commande.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'roleUid',
						$elm$json$Json$Encode$string(roleUid)),
					$author$project$Components$Parametrage$PipeEtape3$API$WriteAPIModel$role_(role));
			default:
				var roleUid = commande.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'roleUid',
						$elm$json$Json$Encode$string(roleUid))
					]);
		}
	});
var $author$project$Components$Parametrage$PipeEtape3$API$WriteAPIModel$encode = F3(
	function (processUid, pipeUid, commande) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
				A2($author$project$Components$Parametrage$PipeEtape3$API$WriteAPIModel$corps, pipeUid, commande)));
	});
var $author$project$Components$Parametrage$PipeEtape3$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A3($author$project$Components$Parametrage$PipeEtape3$API$WriteAPIModel$encode, requete.Gn, requete.FK, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Parametrage$PipeEtape4$API$WriteAPIModel$quand = function (voulu) {
	var avecJours = F3(
		function (cle, jours, base) {
			return $elm$json$Json$Encode$object(
				_Utils_ap(
					base,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (n) {
								return _List_fromArray(
									[
										_Utils_Tuple2(
										cle,
										$elm$json$Json$Encode$int(n))
									]);
							},
							jours))));
		});
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'echeance',
				A3(
					avecJours,
					'delaiEnJours',
					voulu.kB,
					_List_fromArray(
						[
							_Utils_Tuple2(
							'mode',
							$elm$json$Json$Encode$string(voulu.xY))
						]))),
				_Utils_Tuple2(
				'relance',
				$elm$json$Json$Encode$object(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'mode',
							$elm$json$Json$Encode$string(voulu.Hq)),
						$elm$core$List$isEmpty(voulu.GV) ? _List_Nil : _List_fromArray(
							[
								_Utils_Tuple2(
								'rappelsEnJoursAvant',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, voulu.GV))
							])))),
				_Utils_Tuple2(
				'avecLesAutres',
				$elm$json$Json$Encode$string(voulu.jg)),
				_Utils_Tuple2(
				'obligatoire',
				$elm$json$Json$Encode$bool(voulu.he)),
				_Utils_Tuple2(
				'visibleSurLePortail',
				$elm$json$Json$Encode$bool(voulu.KS))
			]));
};
var $author$project$Components$Parametrage$PipeEtape4$API$WriteAPIModel$quandParDefaut = $elm$json$Json$Encode$object(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'echeance',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'mode',
						$elm$json$Json$Encode$string('aucune'))
					]))),
			_Utils_Tuple2(
			'relance',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'mode',
						$elm$json$Json$Encode$string('aucune'))
					]))),
			_Utils_Tuple2(
			'avecLesAutres',
			$elm$json$Json$Encode$string('en-meme-temps')),
			_Utils_Tuple2(
			'obligatoire',
			$elm$json$Json$Encode$bool(true)),
			_Utils_Tuple2(
			'visibleSurLePortail',
			$elm$json$Json$Encode$bool(false))
		]));
var $author$project$Components$Parametrage$PipeEtape4$API$WriteAPIModel$corps = function (commande) {
	switch (commande.$) {
		case 0:
			var tache = commande.a;
			return _Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'etapeUid',
						$elm$json$Json$Encode$string(tache.gs)),
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string(tache.r0)),
						_Utils_Tuple2(
						'libelles',
						A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$json$Json$Encode$string, tache.R))
					]),
				_Utils_ap(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (uid) {
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'roleUid',
										$elm$json$Json$Encode$string(uid))
									]);
							},
							tache.H6)),
					_Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (uid) {
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'formulaireUid',
											$elm$json$Json$Encode$string(uid))
										]);
								},
								tache.mR)),
						_List_fromArray(
							[
								_Utils_Tuple2(
								'parametres',
								$elm$json$Json$Encode$object(tache.EX)),
								_Utils_Tuple2('quand', $author$project$Components$Parametrage$PipeEtape4$API$WriteAPIModel$quandParDefaut)
							]))));
		case 2:
			var tache = commande.a;
			return A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'tacheUid',
					$elm$json$Json$Encode$string(tache.e8)),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'libelles',
						A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$json$Json$Encode$string, tache.R)),
					_Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (uid) {
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'roleUid',
											$elm$json$Json$Encode$string(uid))
										]);
								},
								tache.H6)),
						_Utils_ap(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (uid) {
										return _List_fromArray(
											[
												_Utils_Tuple2(
												'formulaireUid',
												$elm$json$Json$Encode$string(uid))
											]);
									},
									tache.mR)),
							_List_fromArray(
								[
									_Utils_Tuple2(
									'parametres',
									$elm$json$Json$Encode$object(tache.EX)),
									_Utils_Tuple2(
									'quand',
									$author$project$Components$Parametrage$PipeEtape4$API$WriteAPIModel$quand(tache.hz))
								])))));
		case 3:
			var changement = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'tacheUid',
					$elm$json$Json$Encode$string(changement.e8)),
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string(changement.r0)),
					_Utils_Tuple2(
					'parametres',
					$elm$json$Json$Encode$object(changement.EX))
				]);
		case 4:
			var tacheUid = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'tacheUid',
					$elm$json$Json$Encode$string(tacheUid))
				]);
		case 5:
			var application = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'tacheUid',
					$elm$json$Json$Encode$string(application.e8)),
					_Utils_Tuple2(
					'versionDuModele',
					$elm$json$Json$Encode$int(application.KI))
				]);
		default:
			var modele = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'etapeUid',
					$elm$json$Json$Encode$string(modele.gs)),
					_Utils_Tuple2(
					'modeleUid',
					$elm$json$Json$Encode$string(modele.CH)),
					_Utils_Tuple2(
					'roleUid',
					$elm$json$Json$Encode$string(modele.H6))
				]);
	}
};
var $author$project$Components$Parametrage$PipeEtape4$API$WriteAPIModel$encode = F2(
	function (processUid, commande) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
				$author$project$Components$Parametrage$PipeEtape4$API$WriteAPIModel$corps(commande)));
	});
var $author$project$Components$Parametrage$PipeEtape4$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Parametrage$PipeEtape4$API$WriteAPIModel$encode, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$bornes = function (b) {
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (v) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'minimum',
								$elm$json$Json$Encode$float(v))
							]);
					},
					b.CD)),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (v) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'maximum',
								$elm$json$Json$Encode$float(v))
							]);
					},
					b.Cj))));
};
var $author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$destination = function (champ) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(champ.xw)),
			_Utils_ap(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (uid) {
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'roleUid',
									$elm$json$Json$Encode$string(uid))
								]);
						},
						champ.H6)),
				_Utils_ap(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (uid) {
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'ressourceUid',
										$elm$json$Json$Encode$string(uid))
									]);
							},
							champ.qC)),
					_Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (c) {
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'champ',
											$elm$json$Json$Encode$string(c))
										]);
								},
								champ.du)),
						_List_fromArray(
							[
								_Utils_Tuple2(
								'dossier',
								$elm$json$Json$Encode$bool(champ.xI)),
								_Utils_Tuple2(
								'existant',
								$elm$json$Json$Encode$bool(champ.y0))
							]))))));
};
var $author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$poidsDUnChamp = function (champ) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'champUid',
				$elm$json$Json$Encode$string(champ.cr)),
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'poids',
					$elm$json$Json$Encode$int(champ.FV)),
				_Utils_ap(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (seuil) {
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'seuilDeCommentaire',
										$elm$json$Json$Encode$int(seuil))
									]);
							},
							champ.q7)),
					$elm$core$List$isEmpty(champ.f_) ? _List_Nil : _List_fromArray(
						[
							_Utils_Tuple2(
							'conversionDesNiveaux',
							$elm$json$Json$Encode$object(
								A2(
									$elm$core$List$map,
									$elm$core$Tuple$mapSecond($elm$json$Json$Encode$int),
									champ.f_)))
						])))));
};
var $author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$reglages = function (r) {
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'requisPourPasser',
					$elm$json$Json$Encode$bool(r.HM)),
					_Utils_Tuple2(
					'quandLaFicheARenseigne',
					$elm$json$Json$Encode$string(r.GH))
				]),
			_Utils_ap(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (d) {
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'depotDeFichiers',
									$elm$json$Json$Encode$string(d))
								]);
						},
						r.xd)),
				_Utils_ap(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (d) {
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'importDesLignes',
										$elm$json$Json$Encode$string(d))
									]);
							},
							r.Ay)),
					_Utils_ap(
						$elm$core$List$isEmpty(r.j1) ? _List_Nil : _List_fromArray(
							[
								_Utils_Tuple2(
								'colonnes',
								A2(
									$elm$json$Json$Encode$list,
									function (c) {
										return $elm$json$Json$Encode$object(
											_Utils_ap(
												(c.dy === '') ? _List_Nil : _List_fromArray(
													[
														_Utils_Tuple2(
														'cle',
														$elm$json$Json$Encode$string(c.dy))
													]),
												_Utils_ap(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'libelle',
															$elm$json$Json$Encode$string(c.Bl)),
															_Utils_Tuple2(
															'typeDeChamp',
															$elm$json$Json$Encode$string(c.JR))
														]),
													_Utils_ap(
														$elm$core$List$isEmpty(c.Ki) ? _List_Nil : _List_fromArray(
															[
																_Utils_Tuple2(
																'valeurs',
																A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, c.Ki))
															]),
														_Utils_ap(
															A2(
																$elm$core$Maybe$withDefault,
																_List_Nil,
																A2(
																	$elm$core$Maybe$map,
																	function (t) {
																		return _List_fromArray(
																			[
																				_Utils_Tuple2(
																				'typeVise',
																				$elm$json$Json$Encode$string(t))
																			]);
																	},
																	c.r$)),
															A2(
																$elm$core$Maybe$withDefault,
																_List_Nil,
																A2(
																	$elm$core$Maybe$map,
																	function (f) {
																		return _List_fromArray(
																			[
																				_Utils_Tuple2(
																				'formule',
																				$elm$json$Json$Encode$string(f))
																			]);
																	},
																	c.zU)))))));
									},
									r.j1))
							]),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (v) {
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'validationDuReport',
											$elm$json$Json$Encode$object(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'formulaire',
														$elm$json$Json$Encode$string(v.zT)),
														_Utils_Tuple2(
														'commentaire',
														$elm$json$Json$Encode$string(v.vM))
													])))
										]);
								},
								r.Kt)))))));
};
var $author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$corps = function (commande) {
	switch (commande.$) {
		case 0:
			var renommage = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'formulaireUid',
					$elm$json$Json$Encode$string(renommage.mR)),
					_Utils_Tuple2(
					'libelles',
					A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$json$Json$Encode$string, renommage.R))
				]);
		case 1:
			var champ = commande.a;
			return _Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'champUid',
						$elm$json$Json$Encode$string(champ.cr)),
						_Utils_Tuple2(
						'libelles',
						A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$json$Json$Encode$string, champ.R)),
						_Utils_Tuple2(
						'destination',
						$author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$destination(champ)),
						_Utils_Tuple2(
						'aValider',
						A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Encode$null,
							A2(
								$elm$core$Maybe$map,
								function (uid) {
									return $elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'roleUid',
												$elm$json$Json$Encode$string(uid))
											]));
								},
								champ.sI))),
						_Utils_Tuple2(
						'obligatoire',
						$elm$json$Json$Encode$bool(champ.he)),
						_Utils_Tuple2(
						'visibleSurLePortail',
						$elm$json$Json$Encode$bool(champ.KS))
					]),
				_Utils_ap(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (n) {
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'libelleDeLaFiche',
										$elm$json$Json$Encode$string(n))
									]);
							},
							champ.ny)),
					_Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (e) {
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'echelle',
											$elm$json$Json$Encode$string(e))
										]);
								},
								champ.lK)),
						_Utils_ap(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (b) {
										return _List_fromArray(
											[
												_Utils_Tuple2(
												'bornes',
												$author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$bornes(b))
											]);
									},
									champ.us)),
							_List_fromArray(
								[
									_Utils_Tuple2(
									'reglages',
									$author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$reglages(champ.qc))
								])))));
		case 8:
			var importation = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'formulaireUid',
					$elm$json$Json$Encode$string(importation.mR)),
					_Utils_Tuple2(
					'importDuFormulaire',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2(
							$elm$core$Maybe$map,
							function (i) {
								return $elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'uneLigneEst',
											$elm$json$Json$Encode$string(i.J7)),
											_Utils_Tuple2(
											'parLesPortails',
											$elm$json$Json$Encode$bool(i.ER))
										]));
							},
							importation.Az)))
				]);
		case 2:
			var notation = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'formulaireUid',
					$elm$json$Json$Encode$string(notation.mR)),
					_Utils_Tuple2(
					'noteDUneReponse',
					$elm$json$Json$Encode$string(notation.DS)),
					_Utils_Tuple2(
					'entreRepondants',
					$elm$json$Json$Encode$string(notation.yu)),
					_Utils_Tuple2(
					'champDuDossierAlimente',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, notation.uO))),
					_Utils_Tuple2(
					'unRepondantNeVoitPasLesAutres',
					$elm$json$Json$Encode$bool(notation.J6)),
					_Utils_Tuple2(
					'reponsesAnonymes',
					$elm$json$Json$Encode$bool(notation.HJ)),
					_Utils_Tuple2(
					'champs',
					A2($elm$json$Json$Encode$list, $author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$poidsDUnChamp, notation.dw))
				]);
		case 5:
			var champ = commande.a;
			return _Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'formulaireUid',
						$elm$json$Json$Encode$string(champ.mR)),
						_Utils_Tuple2(
						'libelles',
						A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$json$Json$Encode$string, champ.R)),
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string(champ.r0)),
						_Utils_Tuple2(
						'destination',
						function () {
							var _v1 = champ.du;
							if (!_v1.$) {
								var code = _v1.a;
								return $elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'type',
											$elm$json$Json$Encode$string('va-sur-la-fiche-visee')),
											_Utils_Tuple2(
											'champ',
											$elm$json$Json$Encode$string(code)),
											_Utils_Tuple2(
											'existant',
											$elm$json$Json$Encode$bool(true))
										]));
							} else {
								return $elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'type',
											$elm$json$Json$Encode$string('reste-dans-la-reponse'))
										]));
							}
						}()),
						_Utils_Tuple2(
						'obligatoire',
						$elm$json$Json$Encode$bool(false)),
						_Utils_Tuple2(
						'visibleSurLePortail',
						$elm$json$Json$Encode$bool(true)),
						_Utils_Tuple2(
						'remplissage',
						$elm$json$Json$Encode$string('personne')),
						_Utils_Tuple2(
						'lectureSeuleSurLePortail',
						$elm$json$Json$Encode$bool(false))
					]),
				_Utils_ap(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (b) {
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'bornes',
										$author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$bornes(b))
									]);
							},
							champ.us)),
					_Utils_ap(
						$elm$core$List$isEmpty(champ.Ki) ? _List_Nil : _List_fromArray(
							[
								_Utils_Tuple2(
								'valeurs',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, champ.Ki))
							]),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (c) {
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'calcul',
											$elm$json$Json$Encode$string(c))
										]);
								},
								champ.uB)))));
		case 6:
			var champUid = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'champUid',
					$elm$json$Json$Encode$string(champUid))
				]);
		case 7:
			var restauration = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'formulaireUid',
					$elm$json$Json$Encode$string(restauration.mR)),
					_Utils_Tuple2(
					'champUid',
					$elm$json$Json$Encode$string(restauration.cr))
				]);
		case 3:
			var formulaireUid = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'formulaireUid',
					$elm$json$Json$Encode$string(formulaireUid))
				]);
		default:
			var formulaireUid = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'formulaireUid',
					$elm$json$Json$Encode$string(formulaireUid))
				]);
	}
};
var $author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$encode = F2(
	function (processUid, commande) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
				$author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$corps(commande)));
	});
var $author$project$Components$Parametrage$PipeEtape5$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$encode, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Parametrage$PipeEtape6$API$WriteAPIModel$corps = function (commande) {
	switch (commande.$) {
		case 0:
			var droits = commande.a;
			return _Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'roleUid',
						$elm$json$Json$Encode$string(droits.H6)),
						_Utils_Tuple2(
						'etapeUid',
						$elm$json$Json$Encode$string(droits.gs)),
						_Utils_Tuple2(
						'droit',
						$elm$json$Json$Encode$string(droits.xP)),
						_Utils_Tuple2(
						'champs',
						A2(
							$elm$json$Json$Encode$list,
							function (champ) {
								return $elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'code',
											$elm$json$Json$Encode$string(champ.vx)),
											_Utils_Tuple2(
											'droit',
											$elm$json$Json$Encode$string(champ.xP))
										]));
							},
							droits.dw))
					]),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (voit) {
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'voitLesAutresRoles',
									$elm$json$Json$Encode$bool(voit))
								]);
						},
						droits.KU)));
		case 1:
			var options = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'etapeUid',
					$elm$json$Json$Encode$string(options.gs)),
					_Utils_Tuple2(
					'options',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'demandeurVoitLEtape',
								$elm$json$Json$Encode$bool(options.kF)),
								_Utils_Tuple2(
								'membresDuJuryVoientLesAutres',
								$elm$json$Json$Encode$bool(options.n6))
							])))
				]);
		default:
			var reprise = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'roleUid',
					$elm$json$Json$Encode$string(reprise.H6)),
					_Utils_Tuple2(
					'etapeUid',
					$elm$json$Json$Encode$string(reprise.gs)),
					_Utils_Tuple2(
					'depuisEtapeUid',
					$elm$json$Json$Encode$string(reprise.xf))
				]);
	}
};
var $author$project$Components$Parametrage$PipeEtape6$API$WriteAPIModel$encode = F2(
	function (processUid, commande) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
				$author$project$Components$Parametrage$PipeEtape6$API$WriteAPIModel$corps(commande)));
	});
var $author$project$Components$Parametrage$PipeEtape6$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Parametrage$PipeEtape6$API$WriteAPIModel$encode, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$alorsEnJson = function (alors) {
	switch (alors.$) {
		case 0:
			var vers = alors.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'action',
						$elm$json$Json$Encode$string('changer-le-role-de-la-fiche')),
						_Utils_Tuple2(
						'deVers',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'de',
									$elm$json$Json$Encode$string(vers.wC)),
									_Utils_Tuple2(
									'vers',
									$elm$json$Json$Encode$string(vers.sn))
								])))
					]));
		case 1:
			var etapeUid = alors.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'action',
						$elm$json$Json$Encode$string('passer-a-une-etape')),
						_Utils_Tuple2(
						'etapeUid',
						$elm$json$Json$Encode$string(etapeUid))
					]));
		case 2:
			var message = alors.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'action',
						$elm$json$Json$Encode$string('envoyer-une-communication')),
						_Utils_Tuple2(
						'communication',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'modeleUid',
									$elm$json$Json$Encode$string(message.CH)),
									_Utils_Tuple2(
									'destinataires',
									A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, message.xv)),
									_Utils_Tuple2(
									'siUnRoleEstVide',
									$elm$json$Json$Encode$string(message.ra))
								])))
					]));
		default:
			var brut = alors.b;
			return brut;
	}
};
var $author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$quandEnJson = function (q) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'declencheur',
				$elm$json$Json$Encode$string(q.wQ)),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function (uid) {
							return _Utils_Tuple2(
								'etapeUid',
								$elm$json$Json$Encode$string(uid));
						},
						q.gs),
						A2(
						$elm$core$Maybe$map,
						function (uid) {
							return _Utils_Tuple2(
								'tacheUid',
								$elm$json$Json$Encode$string(uid));
						},
						q.e8),
						A2(
						$elm$core$Maybe$map,
						function (jours) {
							return _Utils_Tuple2(
								'delaiEnJours',
								$elm$json$Json$Encode$int(jours));
						},
						q.kB),
						A2(
						$elm$core$Maybe$map,
						function (date) {
							return _Utils_Tuple2(
								'date',
								$elm$json$Json$Encode$string(date));
						},
						q.wv)
					]))));
};
var $author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$champs = function (c) {
	return _Utils_ap(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'quand',
				$author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$quandEnJson(c.hz))
			]),
		_Utils_ap(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (condition) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'condition',
								$elm$json$Json$Encode$string(condition))
							]);
					},
					c.j4)),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'alors',
					$author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$alorsEnJson(c.iM))
				])));
};
var $author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$corps = function (commande) {
	switch (commande.$) {
		case 0:
			var ajout = commande.a;
			return A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'pipeUid',
					$elm$json$Json$Encode$string(ajout.FK)),
				$author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$champs(ajout.f$));
		case 1:
			var modif = commande.a;
			return A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'automatismeUid',
					$elm$json$Json$Encode$string(modif.jc)),
				$author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$champs(modif.f$));
		case 2:
			var uid = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'automatismeUid',
					$elm$json$Json$Encode$string(uid))
				]);
		case 3:
			var uid = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'automatismeUid',
					$elm$json$Json$Encode$string(uid))
				]);
		case 4:
			var uid = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'automatismeUid',
					$elm$json$Json$Encode$string(uid))
				]);
		default:
			var reglage = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'automatismeUid',
					$elm$json$Json$Encode$string(reglage.jc)),
					_Utils_Tuple2(
					'delais',
					A2(
						$elm$json$Json$Encode$list,
						function (_v1) {
							var pays = _v1.a;
							var semaines = _v1.b;
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'paysCode',
										$elm$json$Json$Encode$string(pays)),
										_Utils_Tuple2(
										'delaiEnSemaines',
										$elm$json$Json$Encode$int(semaines))
									]));
						},
						reglage.w5))
				]);
	}
};
var $author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$encode = F2(
	function (processUid, commande) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
				$author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$corps(commande)));
	});
var $author$project$Components$Parametrage$PipeEtape7$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$encode, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Parametrage$PipeEtape8$API$WriteAPIModel$encode = F2(
	function (processUid, commande) {
		var pipeUid = commande;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
					_Utils_Tuple2(
					'pipeUid',
					$elm$json$Json$Encode$string(pipeUid))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape8$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Parametrage$PipeEtape8$API$WriteAPIModel$encode, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Parametrage$PipeVersions$API$WriteAPIModel$encode = F2(
	function (processUid, commande) {
		if (commande.$ === 1) {
			var pipeUid = commande.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'processUid',
						$author$project$API$ProcessUid$encode(processUid)),
						_Utils_Tuple2(
						'pipeUid',
						$elm$json$Json$Encode$string(pipeUid))
					]));
		} else {
			var pipeUid = commande.a;
			var numero = commande.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'processUid',
						$author$project$API$ProcessUid$encode(processUid)),
						_Utils_Tuple2(
						'pipeUid',
						$elm$json$Json$Encode$string(pipeUid)),
						_Utils_Tuple2(
						'numero',
						$elm$json$Json$Encode$int(numero))
					]));
		}
	});
var $author$project$Components$Parametrage$PipeVersions$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Parametrage$PipeVersions$API$WriteAPIModel$encode, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$champs = function (commande) {
	switch (commande.$) {
		case 0:
			var personne = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'prenom',
					$elm$json$Json$Encode$string(personne.Gg)),
					_Utils_Tuple2(
					'nom',
					$elm$json$Json$Encode$string(personne.Dj)),
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(personne.yb)),
					_Utils_Tuple2(
					'langue',
					$elm$json$Json$Encode$string(personne.nn))
				]);
		case 1:
			var role = commande.a;
			var utilisateur = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$elm$json$Json$Encode$string(role)),
					_Utils_Tuple2(
					'utilisateur',
					$elm$json$Json$Encode$string(utilisateur))
				]);
		case 2:
			var utilisateur = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'utilisateur',
					$elm$json$Json$Encode$string(utilisateur))
				]);
		case 3:
			var utilisateur = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'utilisateur',
					$elm$json$Json$Encode$string(utilisateur))
				]);
		case 4:
			var utilisateur = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'utilisateur',
					$elm$json$Json$Encode$string(utilisateur))
				]);
		case 5:
			var utilisateur = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'utilisateur',
					$elm$json$Json$Encode$string(utilisateur))
				]);
		case 6:
			var utilisateur = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'utilisateur',
					$elm$json$Json$Encode$string(utilisateur))
				]);
		case 7:
			var utilisateur = commande.a;
			var fiche = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'utilisateur',
					$elm$json$Json$Encode$string(utilisateur)),
					_Utils_Tuple2(
					'fiche',
					$elm$json$Json$Encode$string(fiche))
				]);
		case 8:
			var utilisateur = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'utilisateur',
					$elm$json$Json$Encode$string(utilisateur))
				]);
		case 9:
			return _List_Nil;
		case 10:
			return _List_Nil;
		case 11:
			var utilisateur = commande.a;
			var fermer = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'utilisateur',
					$elm$json$Json$Encode$string(utilisateur)),
					_Utils_Tuple2(
					'fermerLesSessions',
					$elm$json$Json$Encode$bool(fermer))
				]);
		case 12:
			var utilisateur = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'utilisateur',
					$elm$json$Json$Encode$string(utilisateur))
				]);
		default:
			var utilisateur = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'utilisateur',
					$elm$json$Json$Encode$string(utilisateur))
				]);
	}
};
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$encode = F2(
	function (processUid, commande) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
				$author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$champs(commande)));
	});
var $author$project$Components$Parametrage$Utilisateurs$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$encode, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Catalogue$API$WriteAPIModel$champChoisiEnJson = function (choisi) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'champ',
				$elm$json$Json$Encode$string(choisi.uN)),
			function () {
				var _v0 = choisi.g4;
				if (!_v0.$) {
					var niveau = _v0.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'niveauDeLecture',
							$elm$json$Json$Encode$string(niveau))
						]);
				} else {
					return _List_Nil;
				}
			}()));
};
var $author$project$Catalogue$Vocabulaire$champDeLaGamme = 'gamme';
var $author$project$Catalogue$Vocabulaire$champDeLaMarque = 'marque';
var $author$project$Catalogue$Vocabulaire$champDuProduit = 'produit';
var $author$project$Catalogue$API$WriteAPIModel$deLaGammeEtDeLaMarque = F2(
	function (gamme, marque) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Catalogue$Vocabulaire$champDeLaGamme,
				$author$project$Catalogue$Identifiants$elementIdEncode(gamme)),
				_Utils_Tuple2(
				$author$project$Catalogue$Vocabulaire$champDeLaMarque,
				$author$project$Catalogue$Identifiants$elementIdEncode(marque))
			]);
	});
var $author$project$Catalogue$Vocabulaire$champDeLaListeDePrix = 'liste';
var $author$project$Catalogue$Identifiants$listeDePrixIdEncode = function (_v0) {
	var valeur = _v0;
	return $elm$json$Json$Encode$string(valeur);
};
var $author$project$Catalogue$API$WriteAPIModel$deLaListeDePrix = function (id) {
	return _Utils_Tuple2(
		$author$project$Catalogue$Vocabulaire$champDeLaListeDePrix,
		$author$project$Catalogue$Identifiants$listeDePrixIdEncode(id));
};
var $author$project$Catalogue$Vocabulaire$champDeLaReference = 'reference';
var $author$project$Catalogue$API$WriteAPIModel$deLaReference = function (id) {
	return _Utils_Tuple2(
		$author$project$Catalogue$Vocabulaire$champDeLaReference,
		$author$project$Catalogue$Identifiants$referenceIdEncode(id));
};
var $author$project$Catalogue$API$WriteAPIModel$duNiveau = function (id) {
	return _Utils_Tuple2(
		'niveau',
		$author$project$Catalogue$Identifiants$niveauIdEncode(id));
};
var $author$project$Catalogue$API$WriteAPIModel$duType = function (id) {
	return _Utils_Tuple2(
		'typeDeProduit',
		$author$project$Catalogue$Identifiants$typeDeProduitIdEncode(id));
};
var $author$project$Catalogue$API$WriteAPIModel$encodeAttributs = function (valeurs) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$mapSecond($author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$encode),
			valeurs));
};
var $author$project$Catalogue$API$WriteAPIModel$encodeLibelles = function (libelles) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'fr',
				$elm$json$Json$Encode$string(libelles.zX)),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (en) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'en',
								$elm$json$Json$Encode$string(en))
							]);
					},
					libelles.yg))));
};
var $author$project$Catalogue$API$WriteAPIModel$encodeMillesime = function (millesime) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (annee) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'millesime',
						$elm$json$Json$Encode$string(annee))
					]);
			},
			millesime));
};
var $author$project$Catalogue$API$WriteAPIModel$encodeParent = function (parent) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (id) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'parent',
						$author$project$Catalogue$Identifiants$elementIdEncode(id))
					]);
			},
			parent));
};
var $author$project$Catalogue$API$PrixAPIModel$encodeRefDePublic = function (ref) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(ref.r0)),
				_Utils_Tuple2(
				'uid',
				$elm$json$Json$Encode$string(ref.r8))
			]));
};
var $author$project$Catalogue$Vocabulaire$taxesExonerees = 'exonerees';
var $author$project$Catalogue$Vocabulaire$taxesHorsTaxe = 'hors-taxe';
var $author$project$Catalogue$Vocabulaire$taxesToutesTaxesComprises = 'toutes-taxes-comprises';
var $author$project$Catalogue$API$PrixAPIModel$encodeTaxes = function (taxes) {
	switch (taxes.$) {
		case 0:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'regime',
						$elm$json$Json$Encode$string($author$project$Catalogue$Vocabulaire$taxesExonerees))
					]));
		case 1:
			var taux = taxes.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'regime',
						$elm$json$Json$Encode$string($author$project$Catalogue$Vocabulaire$taxesHorsTaxe)),
						_Utils_Tuple2(
						'taux',
						$elm$json$Json$Encode$string(taux))
					]));
		default:
			var taux = taxes.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'regime',
						$elm$json$Json$Encode$string($author$project$Catalogue$Vocabulaire$taxesToutesTaxesComprises)),
						_Utils_Tuple2(
						'taux',
						$elm$json$Json$Encode$string(taux))
					]));
	}
};
var $author$project$Catalogue$API$WriteAPIModel$encodeValeurDuDessus = function (valeur) {
	if (!valeur.$) {
		var id = valeur.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'Libre',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'valeur',
								$author$project$Catalogue$Identifiants$valeurIdEncode(id))
							])))
				]));
	} else {
		var id = valeur.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'Element',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'element',
								$author$project$Catalogue$Identifiants$elementIdEncode(id))
							])))
				]));
	}
};
var $author$project$Catalogue$API$PrixAPIModel$encodeValidite = function (validite) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'debut',
				$elm$json$Json$Encode$string(validite.ku)),
				_Utils_Tuple2(
				'fin',
				$elm$json$Json$Encode$string(validite.mI))
			]));
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$encoderLesValeursACreer = function (aCreer) {
	return $elm$core$List$isEmpty(aCreer) ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(
			'valeursACreer',
			$elm$json$Json$Encode$object(
				A2(
					$elm$core$List$map,
					function (valeur) {
						return _Utils_Tuple2(
							valeur.IW,
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'liste',
										$elm$json$Json$Encode$string(valeur.nW)),
										_Utils_Tuple2(
										'libelle',
										$elm$json$Json$Encode$string(valeur.Bl))
									])));
					},
					aCreer)))
		]);
};
var $author$project$Catalogue$API$WriteAPIModel$facultatif = F3(
	function (nom, encoder, valeur) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (donnee) {
					return _List_fromArray(
						[
							_Utils_Tuple2(
							nom,
							encoder(donnee))
						]);
				},
				valeur));
	});
var $author$project$Catalogue$API$WriteAPIModel$maybeEntier = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map($elm$json$Json$Encode$int),
	$elm$core$Maybe$withDefault($elm$json$Json$Encode$null));
var $author$project$Catalogue$Identifiants$noeudIdEncode = function (_v0) {
	var valeur = _v0;
	return $elm$json$Json$Encode$string(valeur);
};
var $author$project$Catalogue$API$WriteAPIModel$reglagesDuRattachementEnJson = function (reglages) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'exigence',
			$elm$json$Json$Encode$string(reglages.mo)),
			_Utils_Tuple2(
			'niveauDeLecture',
			$elm$json$Json$Encode$string(reglages.g4)),
			_Utils_Tuple2(
			'masque',
			$elm$json$Json$Encode$bool(reglages.n4))
		]);
};
var $author$project$Catalogue$API$WriteAPIModel$champs = function (commande) {
	switch (commande.$) {
		case 0:
			var marque = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$elm$json$Json$Encode$string(marque.Dj)),
					_Utils_Tuple2(
					'sousLicence',
					$elm$json$Json$Encode$bool(marque.IY))
				]);
		case 1:
			var id = commande.a;
			var marque = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Catalogue$Vocabulaire$champDeLaMarque,
					$author$project$Catalogue$Identifiants$elementIdEncode(id)),
					_Utils_Tuple2(
					'nom',
					$elm$json$Json$Encode$string(marque.Dj)),
					_Utils_Tuple2(
					'sousLicence',
					$elm$json$Json$Encode$bool(marque.IY))
				]);
		case 2:
			var id = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Catalogue$Vocabulaire$champDeLaMarque,
					$author$project$Catalogue$Identifiants$elementIdEncode(id))
				]);
		case 3:
			var id = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Catalogue$Vocabulaire$champDeLaMarque,
					$author$project$Catalogue$Identifiants$elementIdEncode(id))
				]);
		case 4:
			var gamme = commande.a;
			return A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'niveau',
					$author$project$Catalogue$Identifiants$niveauIdEncode(gamme.os)),
				_Utils_ap(
					A3($author$project$Catalogue$API$WriteAPIModel$facultatif, $author$project$Catalogue$Vocabulaire$champDeLaMarque, $author$project$Catalogue$Identifiants$elementIdEncode, gamme.gX),
					_Utils_ap(
						$author$project$Catalogue$API$WriteAPIModel$encodeParent(gamme.ey),
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'libelles',
								$author$project$Catalogue$API$WriteAPIModel$encodeLibelles(gamme.R)),
							$author$project$Catalogue$API$WriteAPIModel$encodeMillesime(gamme.n8)))));
		case 5:
			var id = commande.a;
			var gamme = commande.b;
			return A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$Catalogue$Vocabulaire$champDeLaGamme,
					$author$project$Catalogue$Identifiants$elementIdEncode(id)),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'libelles',
						$author$project$Catalogue$API$WriteAPIModel$encodeLibelles(gamme.R)),
					$author$project$Catalogue$API$WriteAPIModel$encodeMillesime(gamme.n8)));
		case 6:
			var id = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Catalogue$Vocabulaire$champDeLaGamme,
					$author$project$Catalogue$Identifiants$elementIdEncode(id))
				]);
		case 7:
			var gamme = commande.a;
			var marque = commande.b;
			return A2($author$project$Catalogue$API$WriteAPIModel$deLaGammeEtDeLaMarque, gamme, marque);
		case 8:
			var gamme = commande.a;
			var marque = commande.b;
			return A2($author$project$Catalogue$API$WriteAPIModel$deLaGammeEtDeLaMarque, gamme, marque);
		case 9:
			var id = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Catalogue$Vocabulaire$champDeLaGamme,
					$author$project$Catalogue$Identifiants$elementIdEncode(id))
				]);
		case 10:
			var voulu = commande.a;
			return A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'niveau',
					$author$project$Catalogue$Identifiants$niveauIdEncode(voulu.os)),
				_Utils_ap(
					$author$project$Catalogue$API$WriteAPIModel$encodeParent(voulu.ey),
					_List_fromArray(
						[
							_Utils_Tuple2(
							'ordre',
							A2($elm$json$Json$Encode$list, $author$project$Catalogue$Identifiants$elementIdEncode, voulu.El))
						])));
		case 11:
			var niveau = commande.a;
			var voulues = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'niveau',
					$author$project$Catalogue$Identifiants$niveauIdEncode(niveau)),
					_Utils_Tuple2(
					'ordre',
					A2($elm$json$Json$Encode$list, $author$project$Catalogue$Identifiants$elementIdEncode, voulues))
				]);
		case 12:
			var voulu = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$Catalogue$API$WriteAPIModel$encodeLibelles(voulu.Dj)),
					_Utils_Tuple2(
					'nature',
					$elm$json$Json$Encode$string(voulu.g1))
				]);
		case 13:
			var id = commande.a;
			var evolution = commande.b;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$duType(id),
					_Utils_Tuple2(
					'ajouts',
					A2($elm$json$Json$Encode$list, $author$project$Components$Shared$EditeurDeSchema$Champ$encode, evolution.fx)),
					_Utils_Tuple2(
					'modifications',
					A2($elm$json$Json$Encode$list, $author$project$Components$Shared$EditeurDeSchema$Champ$encode, evolution.g$))
				]);
		case 14:
			var id = commande.a;
			var definition = commande.b;
			var reglages = commande.c;
			return _Utils_ap(
				_List_fromArray(
					[
						$author$project$Catalogue$API$WriteAPIModel$duType(id),
						_Utils_Tuple2(
						'champ',
						$elm$json$Json$Encode$string(definition))
					]),
				$author$project$Catalogue$API$WriteAPIModel$reglagesDuRattachementEnJson(reglages));
		case 15:
			var id = commande.a;
			var voulu = commande.b;
			return _Utils_ap(
				_List_fromArray(
					[
						$author$project$Catalogue$API$WriteAPIModel$duType(id),
						_Utils_Tuple2(
						'collection',
						$elm$json$Json$Encode$string(voulu.vD))
					]),
				function () {
					var _v1 = voulu.dw;
					if (!_v1.$) {
						var choisis = _v1.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'champs',
								A2($elm$json$Json$Encode$list, $author$project$Catalogue$API$WriteAPIModel$champChoisiEnJson, choisis))
							]);
					} else {
						return _List_Nil;
					}
				}());
		case 16:
			var id = commande.a;
			var collection = commande.b;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$duType(id),
					_Utils_Tuple2(
					'collection',
					$elm$json$Json$Encode$string(collection))
				]);
		case 17:
			var porteur = commande.a;
			var voulu = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'porteur',
					$elm$json$Json$Encode$string(porteur)),
					_Utils_Tuple2(
					'ordre',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, voulu))
				]);
		case 18:
			var porteur = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'porteur',
					$elm$json$Json$Encode$string(porteur))
				]);
		case 19:
			var id = commande.a;
			var cle = commande.b;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$duType(id),
					_Utils_Tuple2(
					'champ',
					$elm$json$Json$Encode$string(cle))
				]);
		case 20:
			var champ = commande.a;
			var portee = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$elm$json$Json$Encode$string(champ)),
					_Utils_Tuple2(
					'portee',
					$elm$json$Json$Encode$string(portee))
				]);
		case 22:
			var id = commande.a;
			var cle = commande.b;
			var valeurs = commande.c;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$duType(id),
					_Utils_Tuple2(
					'champ',
					$elm$json$Json$Encode$string(cle)),
					_Utils_Tuple2(
					'valeurs',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, valeurs))
				]);
		case 23:
			var id = commande.a;
			var cle = commande.b;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$duType(id),
					_Utils_Tuple2(
					'champ',
					$elm$json$Json$Encode$string(cle))
				]);
		case 24:
			var id = commande.a;
			var segments = commande.b;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$duType(id),
					_Utils_Tuple2(
					'regle',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'segments',
								A2($elm$json$Json$Encode$list, $author$project$Catalogue$RegleDeCode$encodeSegment, segments))
							])))
				]);
		case 21:
			var id = commande.a;
			var cle = commande.b;
			var lecture = commande.c;
			var saisie = commande.d;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$duType(id),
					_Utils_Tuple2(
					'champ',
					$elm$json$Json$Encode$string(cle)),
					_Utils_Tuple2(
					'niveauDeLecture',
					$elm$json$Json$Encode$string(lecture)),
					_Utils_Tuple2(
					'niveauDeSaisie',
					$elm$json$Json$Encode$string(saisie))
				]);
		case 25:
			var champ = commande.a;
			var filtrable = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$elm$json$Json$Encode$string(champ)),
					_Utils_Tuple2(
					'filtrable',
					$elm$json$Json$Encode$bool(filtrable))
				]);
		case 26:
			var champ = commande.a;
			var recherchable = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$elm$json$Json$Encode$string(champ)),
					_Utils_Tuple2(
					'recherchable',
					$elm$json$Json$Encode$bool(recherchable))
				]);
		case 27:
			var id = commande.a;
			var cle = commande.b;
			var minima = commande.c;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$duType(id),
					_Utils_Tuple2(
					'champ',
					$elm$json$Json$Encode$string(cle)),
					_Utils_Tuple2(
					'largeurMinimale',
					$author$project$Catalogue$API$WriteAPIModel$maybeEntier(minima.Bd)),
					_Utils_Tuple2(
					'hauteurMinimale',
					$author$project$Catalogue$API$WriteAPIModel$maybeEntier(minima.Ae)),
					_Utils_Tuple2(
					'texteAlternatifExige',
					$elm$json$Json$Encode$bool(minima.Jz))
				]);
		case 28:
			var id = commande.a;
			var cle = commande.b;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$duType(id),
					_Utils_Tuple2(
					'champ',
					$elm$json$Json$Encode$string(cle))
				]);
		case 29:
			var id = commande.a;
			var cles = commande.b;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$duType(id),
					_Utils_Tuple2(
					'ordre',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, cles))
				]);
		case 30:
			var id = commande.a;
			var evolution = commande.b;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$duNiveau(id),
					_Utils_Tuple2(
					'ajouts',
					A2($elm$json$Json$Encode$list, $author$project$Components$Shared$EditeurDeSchema$Champ$encode, evolution.fx)),
					_Utils_Tuple2(
					'modifications',
					A2($elm$json$Json$Encode$list, $author$project$Components$Shared$EditeurDeSchema$Champ$encode, evolution.g$))
				]);
		case 31:
			var id = commande.a;
			var cle = commande.b;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$duNiveau(id),
					_Utils_Tuple2(
					'champ',
					$elm$json$Json$Encode$string(cle))
				]);
		case 32:
			var id = commande.a;
			var cle = commande.b;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$duNiveau(id),
					_Utils_Tuple2(
					'champ',
					$elm$json$Json$Encode$string(cle))
				]);
		case 33:
			var id = commande.a;
			var cles = commande.b;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$duNiveau(id),
					_Utils_Tuple2(
					'ordre',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, cles))
				]);
		case 34:
			var produit = commande.a;
			return A2(
				$elm$core$List$cons,
				$author$project$Catalogue$API$WriteAPIModel$duType(produit.fh),
				_Utils_ap(
					$author$project$Catalogue$API$WriteAPIModel$encodeParent(produit.ey),
					_Utils_ap(
						$elm$core$List$isEmpty(produit.Ki) ? _List_Nil : _List_fromArray(
							[
								_Utils_Tuple2(
								'valeurs',
								A2($elm$json$Json$Encode$list, $author$project$Catalogue$API$WriteAPIModel$encodeValeurDuDessus, produit.Ki))
							]),
						_List_fromArray(
							[
								_Utils_Tuple2(
								'libelles',
								$author$project$Catalogue$API$WriteAPIModel$encodeLibelles(produit.R))
							]))));
		case 36:
			var produit = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Catalogue$Vocabulaire$champDuProduit,
					$author$project$Catalogue$Identifiants$elementIdEncode(produit))
				]);
		case 35:
			var produit = commande.a;
			var valeurs = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Catalogue$Vocabulaire$champDuProduit,
					$author$project$Catalogue$Identifiants$elementIdEncode(produit)),
					_Utils_Tuple2(
					'valeurs',
					A2($elm$json$Json$Encode$list, $author$project$Catalogue$API$WriteAPIModel$encodeValeurDuDessus, valeurs))
				]);
		case 37:
			var reference = commande.a;
			return A2(
				$elm$core$List$cons,
				$author$project$Catalogue$API$WriteAPIModel$duType(reference.fh),
				_Utils_ap(
					A3($author$project$Catalogue$API$WriteAPIModel$facultatif, 'typologie', $author$project$Catalogue$Identifiants$classificationIdEncode, reference.r3),
					_Utils_ap(
						A3($author$project$Catalogue$API$WriteAPIModel$facultatif, 'rattachement', $author$project$Catalogue$Identifiants$elementIdEncode, reference.pN),
						_Utils_ap(
							$elm$core$List$isEmpty(reference.Ki) ? _List_Nil : _List_fromArray(
								[
									_Utils_Tuple2(
									'valeurs',
									A2($elm$json$Json$Encode$list, $author$project$Catalogue$API$WriteAPIModel$encodeValeurDuDessus, reference.Ki))
								]),
							_Utils_ap(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'nature',
										$elm$json$Json$Encode$string(reference.g1)),
										_Utils_Tuple2(
										'code',
										$elm$json$Json$Encode$string(reference.vx))
									]),
								_Utils_ap(
									A3($author$project$Catalogue$API$WriteAPIModel$facultatif, 'nom', $author$project$Catalogue$API$WriteAPIModel$encodeLibelles, reference.Dj),
									_Utils_ap(
										A3($author$project$Catalogue$API$WriteAPIModel$facultatif, 'ean', $elm$json$Json$Encode$string, reference.lI),
										_Utils_ap(
											$author$project$Catalogue$API$WriteAPIModel$encodeMillesime(reference.n8),
											_Utils_ap(
												A3($author$project$Catalogue$API$WriteAPIModel$facultatif, 'variante', $elm$json$Json$Encode$string, reference.sl),
												_Utils_ap(
													A3($author$project$Catalogue$API$WriteAPIModel$facultatif, 'origine', $author$project$Catalogue$Identifiants$referenceIdEncode, reference.o4),
													_List_fromArray(
														[
															_Utils_Tuple2(
															'etat',
															$author$project$Catalogue$Identifiants$etatCodeEncode(reference.gt)),
															_Utils_Tuple2(
															'attributs',
															$author$project$Catalogue$API$WriteAPIModel$encodeAttributs(reference.i8))
														])))))))))));
		case 39:
			var nom = commande.a;
			var filtre = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$elm$json$Json$Encode$string(nom)),
					_Utils_Tuple2(
					'filtre',
					A2(
						$elm$json$Json$Encode$list,
						function (_v2) {
							var champ = _v2.a;
							var valeur = _v2.b;
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'champ',
										$elm$json$Json$Encode$string(champ)),
										_Utils_Tuple2(
										'valeur',
										$elm$json$Json$Encode$string(valeur))
									]));
						},
						filtre))
				]);
		case 38:
			var id = commande.a;
			var valeurs = commande.b;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$deLaReference(id),
					_Utils_Tuple2(
					'valeurs',
					$author$project$Catalogue$API$WriteAPIModel$encodeAttributs(valeurs))
				]);
		case 40:
			var id = commande.a;
			var etat = commande.b;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$deLaReference(id),
					_Utils_Tuple2(
					'etat',
					$author$project$Catalogue$Identifiants$etatCodeEncode(etat))
				]);
		case 41:
			var id = commande.a;
			var code = commande.b;
			return A2(
				$elm$core$List$cons,
				$author$project$Catalogue$API$WriteAPIModel$deLaReference(id),
				A3($author$project$Catalogue$API$WriteAPIModel$facultatif, 'code', $elm$json$Json$Encode$string, code));
		case 42:
			var id = commande.a;
			var classification = commande.b;
			var valeurs = commande.c;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$deLaReference(id),
					_Utils_Tuple2(
					'classification',
					$author$project$Catalogue$Identifiants$classificationIdEncode(classification)),
					_Utils_Tuple2(
					'valeurs',
					A2($elm$json$Json$Encode$list, $author$project$Catalogue$Identifiants$valeurIdEncode, valeurs))
				]);
		case 43:
			var id = commande.a;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$deLaReference(id)
				]);
		case 44:
			var id = commande.a;
			var champ = commande.b;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$deLaReference(id),
					_Utils_Tuple2(
					'champ',
					$elm$json$Json$Encode$string(champ))
				]);
		case 45:
			var id = commande.a;
			var champ = commande.b;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$deLaReference(id),
					_Utils_Tuple2(
					'champ',
					$elm$json$Json$Encode$string(champ))
				]);
		case 46:
			var id = commande.a;
			var champ = commande.b;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$deLaReference(id),
					_Utils_Tuple2(
					'champ',
					$elm$json$Json$Encode$string(champ))
				]);
		case 47:
			var id = commande.a;
			var champ = commande.b;
			var fichier = commande.c;
			var texte = commande.d;
			return A2(
				$elm$core$List$cons,
				$author$project$Catalogue$API$WriteAPIModel$deLaReference(id),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'champ',
						$elm$json$Json$Encode$string(champ)),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'fichier',
							$elm$json$Json$Encode$string(fichier)),
						$elm$core$List$isEmpty(texte) ? _List_Nil : _List_fromArray(
							[
								_Utils_Tuple2(
								'texteAlternatif',
								$elm$json$Json$Encode$object(
									A2(
										$elm$core$List$map,
										$elm$core$Tuple$mapSecond($elm$json$Json$Encode$string),
										texte)))
							]))));
		case 48:
			var id = commande.a;
			var champ = commande.b;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$deLaReference(id),
					_Utils_Tuple2(
					'champ',
					$elm$json$Json$Encode$string(champ))
				]);
		case 49:
			var id = commande.a;
			var champ = commande.b;
			var valeurs = commande.c;
			var aCreer = commande.d;
			return _Utils_ap(
				_List_fromArray(
					[
						$author$project$Catalogue$API$WriteAPIModel$deLaReference(id),
						_Utils_Tuple2(
						'champ',
						$elm$json$Json$Encode$string(champ)),
						_Utils_Tuple2(
						'valeurs',
						$author$project$Catalogue$API$WriteAPIModel$encodeAttributs(valeurs))
					]),
				$author$project$Components$Shared$EditeurDeSchema$Groupe$encoderLesValeursACreer(aCreer));
		case 50:
			var id = commande.a;
			var champ = commande.b;
			var uid = commande.c;
			var valeurs = commande.d;
			var aCreer = commande.e;
			return _Utils_ap(
				_List_fromArray(
					[
						$author$project$Catalogue$API$WriteAPIModel$deLaReference(id),
						_Utils_Tuple2(
						'champ',
						$elm$json$Json$Encode$string(champ)),
						_Utils_Tuple2(
						'uid',
						$elm$json$Json$Encode$string(uid)),
						_Utils_Tuple2(
						'valeurs',
						$author$project$Catalogue$API$WriteAPIModel$encodeAttributs(valeurs))
					]),
				$author$project$Components$Shared$EditeurDeSchema$Groupe$encoderLesValeursACreer(aCreer));
		case 51:
			var id = commande.a;
			var champ = commande.b;
			var uid = commande.c;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$deLaReference(id),
					_Utils_Tuple2(
					'champ',
					$elm$json$Json$Encode$string(champ)),
					_Utils_Tuple2(
					'uid',
					$elm$json$Json$Encode$string(uid))
				]);
		case 53:
			var type_ = commande.a;
			var champ = commande.b;
			var geste = commande.c;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'typeDeProduit',
					$author$project$Catalogue$Identifiants$typeDeProduitIdEncode(type_)),
					_Utils_Tuple2(
					'champ',
					$elm$json$Json$Encode$string(champ)),
					_Utils_Tuple2(
					'geste',
					$elm$json$Json$Encode$string(geste))
				]);
		case 52:
			var id = commande.a;
			var valeurs = commande.b;
			var typologie = commande.c;
			return A2(
				$elm$core$List$cons,
				$author$project$Catalogue$API$WriteAPIModel$deLaReference(id),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'valeurs',
						A2($elm$json$Json$Encode$list, $author$project$Catalogue$API$WriteAPIModel$encodeValeurDuDessus, valeurs)),
					A3($author$project$Catalogue$API$WriteAPIModel$facultatif, 'typologie', $author$project$Catalogue$Identifiants$classificationIdEncode, typologie)));
		case 54:
			var id = commande.a;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$duType(id)
				]);
		case 55:
			var id = commande.a;
			var classification = commande.b;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$duType(id),
					_Utils_Tuple2(
					'classification',
					$author$project$Catalogue$Identifiants$classificationIdEncode(classification))
				]);
		case 56:
			var id = commande.a;
			var classification = commande.b;
			var sous = commande.c;
			return A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'categorie',
					$author$project$Catalogue$Identifiants$typeDeProduitIdEncode(id)),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'classification',
						$author$project$Catalogue$Identifiants$classificationIdEncode(classification)),
					A3($author$project$Catalogue$API$WriteAPIModel$facultatif, 'sous', $author$project$Catalogue$API$WriteAPIModel$encodeValeurDuDessus, sous)));
		case 57:
			var classification = commande.a;
			var noeud = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'classification',
					$author$project$Catalogue$Identifiants$classificationIdEncode(classification)),
					_Utils_Tuple2(
					'noeud',
					$author$project$Catalogue$Identifiants$noeudIdEncode(noeud))
				]);
		case 58:
			var id = commande.a;
			var nom = commande.b;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$duType(id),
					_Utils_Tuple2(
					'nom',
					$author$project$Catalogue$API$WriteAPIModel$encodeLibelles(nom))
				]);
		case 59:
			var liste = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$Catalogue$API$WriteAPIModel$encodeLibelles(liste.Dj)),
					_Utils_Tuple2(
					'publics',
					A2($elm$json$Json$Encode$list, $author$project$Catalogue$API$PrixAPIModel$encodeRefDePublic, liste.GA)),
					_Utils_Tuple2(
					'devise',
					$elm$json$Json$Encode$string(liste.kO)),
					_Utils_Tuple2(
					'taxes',
					$author$project$Catalogue$API$PrixAPIModel$encodeTaxes(liste.rB)),
					_Utils_Tuple2(
					'validite',
					$author$project$Catalogue$API$PrixAPIModel$encodeValidite(liste.sk))
				]);
		case 60:
			var id = commande.a;
			var prix = commande.b;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$deLaListeDePrix(id),
					$author$project$Catalogue$API$WriteAPIModel$deLaReference(prix.Hc),
					_Utils_Tuple2(
					'montant',
					$elm$json$Json$Encode$string(prix.oi)),
					_Utils_Tuple2(
					'unite',
					$elm$json$Json$Encode$string(prix.sa))
				]);
		case 61:
			var id = commande.a;
			var reference = commande.b;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$deLaListeDePrix(id),
					$author$project$Catalogue$API$WriteAPIModel$deLaReference(reference)
				]);
		case 62:
			var id = commande.a;
			var publics = commande.b;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$deLaListeDePrix(id),
					_Utils_Tuple2(
					'publics',
					A2($elm$json$Json$Encode$list, $author$project$Catalogue$API$PrixAPIModel$encodeRefDePublic, publics))
				]);
		case 63:
			var id = commande.a;
			var publique = commande.b;
			return _List_fromArray(
				[
					$author$project$Catalogue$API$WriteAPIModel$deLaListeDePrix(id),
					_Utils_Tuple2(
					'publique',
					$elm$json$Json$Encode$bool(publique))
				]);
		case 64:
			var portee = commande.a;
			var valeurs = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2('portee', portee),
					_Utils_Tuple2(
					'valeurs',
					A2(
						$elm$json$Json$Encode$list,
						function (_v3) {
							var champ = _v3.a;
							var valeur = _v3.b;
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'champ',
										$elm$json$Json$Encode$string(champ)),
										_Utils_Tuple2('valeur', valeur)
									]));
						},
						valeurs)),
					_Utils_Tuple2(
					'retraits',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, _List_Nil))
				]);
		default:
			var portee = commande.a;
			var champ = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2('portee', portee),
					_Utils_Tuple2(
					'champ',
					$elm$json$Json$Encode$string(champ))
				]);
	}
};
var $author$project$Catalogue$API$WriteAPIModel$encode = F2(
	function (processUid, commande) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
				$author$project$Catalogue$API$WriteAPIModel$champs(commande)));
	});
var $author$project$Components$Produits$Common$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Catalogue$API$WriteAPIModel$encode, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Produits$Correspondances$API$WriteAPIModel$deLaLigne = F3(
	function (correspondance, valeurDepart, cibles) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'correspondance',
				$elm$json$Json$Encode$string(correspondance)),
				_Utils_Tuple2(
				'valeurDepart',
				$elm$json$Json$Encode$string(valeurDepart)),
				_Utils_Tuple2(
				'cibles',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, cibles))
			]);
	});
var $author$project$Components$Produits$Correspondances$API$WriteAPIModel$champs = function (commande) {
	switch (commande.$) {
		case 0:
			var depart = commande.a;
			var cible = commande.b;
			var valeurDepart = commande.c;
			var cibles = commande.d;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'depart',
					$elm$json$Json$Encode$string(depart)),
					_Utils_Tuple2(
					'cible',
					$elm$json$Json$Encode$string(cible)),
					_Utils_Tuple2(
					'valeurDepart',
					$elm$json$Json$Encode$string(valeurDepart)),
					_Utils_Tuple2(
					'cibles',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, cibles))
				]);
		case 1:
			var correspondance = commande.a;
			var valeurDepart = commande.b;
			var cibles = commande.c;
			return A3($author$project$Components$Produits$Correspondances$API$WriteAPIModel$deLaLigne, correspondance, valeurDepart, cibles);
		case 2:
			var correspondance = commande.a;
			var valeurDepart = commande.b;
			var cibles = commande.c;
			return A3($author$project$Components$Produits$Correspondances$API$WriteAPIModel$deLaLigne, correspondance, valeurDepart, cibles);
		case 3:
			var correspondance = commande.a;
			var valeurDepart = commande.b;
			var cibles = commande.c;
			return A3($author$project$Components$Produits$Correspondances$API$WriteAPIModel$deLaLigne, correspondance, valeurDepart, cibles);
		case 4:
			var correspondance = commande.a;
			var valeurDepart = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'correspondance',
					$elm$json$Json$Encode$string(correspondance)),
					_Utils_Tuple2(
					'valeurDepart',
					$elm$json$Json$Encode$string(valeurDepart))
				]);
		case 5:
			var correspondance = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'correspondance',
					$elm$json$Json$Encode$string(correspondance))
				]);
		default:
			var correspondance = commande.a;
			var libelles = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'correspondance',
					$elm$json$Json$Encode$string(correspondance)),
					_Utils_Tuple2(
					'libelles',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$map,
							function (_v1) {
								var code = _v1.a;
								var texte = _v1.b;
								return _Utils_Tuple2(
									code,
									$elm$json$Json$Encode$string(texte));
							},
							libelles)))
				]);
	}
};
var $author$project$Components$Produits$Correspondances$API$WriteAPIModel$encode = F2(
	function (processUid, commande) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
				$author$project$Components$Produits$Correspondances$API$WriteAPIModel$champs(commande)));
	});
var $author$project$Components$Produits$Correspondances$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Produits$Correspondances$API$WriteAPIModel$encode, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Produits$Listes$API$WriteAPIModel$encodeAttribut = function (attribut) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(attribut.dy)),
				_Utils_Tuple2(
				'label',
				$elm$json$Json$Encode$string(attribut.Bl)),
				_Utils_Tuple2(
				'type',
				attribut.ho ? $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'Arr',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'of',
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'Country',
													$elm$json$Json$Encode$object(_List_Nil))
												])))
									])))
						])) : $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'Text',
							$elm$json$Json$Encode$object(_List_Nil))
						]))),
				_Utils_Tuple2(
				'required',
				$elm$json$Json$Encode$bool(false)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(''))
			]));
};
var $author$project$Components$Produits$Listes$API$WriteAPIModel$encodeSchema = F2(
	function (version, attributs) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'version',
					$elm$json$Json$Encode$int(version)),
					_Utils_Tuple2(
					'fields',
					A2($elm$json$Json$Encode$list, $author$project$Components$Produits$Listes$API$WriteAPIModel$encodeAttribut, attributs)),
					_Utils_Tuple2(
					'naturalKey',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, _List_Nil))
				]));
	});
var $author$project$Components$Produits$Listes$API$WriteAPIModel$encodeValeurs = F2(
	function (attributs, pays) {
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				A2(
					$elm$core$List$map,
					function (_v0) {
						var cle = _v0.a;
						var texte = _v0.b;
						return _Utils_Tuple2(
							cle,
							$elm$json$Json$Encode$string(texte));
					},
					attributs),
				A2(
					$elm$core$List$map,
					function (_v1) {
						var cle = _v1.a;
						var codes = _v1.b;
						return _Utils_Tuple2(
							cle,
							A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, codes));
					},
					pays)));
	});
var $author$project$Components$Produits$Listes$API$WriteAPIModel$champs = function (commande) {
	switch (commande.$) {
		case 0:
			var nom = commande.a;
			var portee = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$elm$json$Json$Encode$string(nom)),
					_Utils_Tuple2(
					'portee',
					$elm$json$Json$Encode$string(portee))
				]);
		case 1:
			var liste = commande.a;
			var libelle = commande.b;
			var attributs = commande.c;
			return _Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'liste',
						$elm$json$Json$Encode$string(liste)),
						_Utils_Tuple2(
						'libelle',
						$elm$json$Json$Encode$string(libelle))
					]),
				$elm$core$List$isEmpty(attributs) ? _List_Nil : _List_fromArray(
					[
						_Utils_Tuple2(
						'attributs',
						A2($author$project$Components$Produits$Listes$API$WriteAPIModel$encodeValeurs, attributs, _List_Nil))
					]));
		case 2:
			var liste = commande.a;
			var valeur = commande.b;
			var libelle = commande.c;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'liste',
					$elm$json$Json$Encode$string(liste)),
					_Utils_Tuple2(
					'valeur',
					$elm$json$Json$Encode$string(valeur)),
					_Utils_Tuple2(
					'libelle',
					$elm$json$Json$Encode$string(libelle))
				]);
		case 3:
			var liste = commande.a;
			var valeur = commande.b;
			var attributs = commande.c;
			var pays = commande.d;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'liste',
					$elm$json$Json$Encode$string(liste)),
					_Utils_Tuple2(
					'valeur',
					$elm$json$Json$Encode$string(valeur)),
					_Utils_Tuple2(
					'attributs',
					A2($author$project$Components$Produits$Listes$API$WriteAPIModel$encodeValeurs, attributs, pays))
				]);
		case 4:
			var liste = commande.a;
			var valeur = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'liste',
					$elm$json$Json$Encode$string(liste)),
					_Utils_Tuple2(
					'valeur',
					$elm$json$Json$Encode$string(valeur))
				]);
		case 5:
			var liste = commande.a;
			var valeur = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'liste',
					$elm$json$Json$Encode$string(liste)),
					_Utils_Tuple2(
					'valeur',
					$elm$json$Json$Encode$string(valeur))
				]);
		case 6:
			var liste = commande.a;
			var valeur = commande.b;
			var position = commande.c;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'liste',
					$elm$json$Json$Encode$string(liste)),
					_Utils_Tuple2(
					'valeur',
					$elm$json$Json$Encode$string(valeur)),
					_Utils_Tuple2(
					'position',
					$elm$json$Json$Encode$int(position))
				]);
		default:
			var liste = commande.a;
			var version = commande.b;
			var attributs = commande.c;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'liste',
					$elm$json$Json$Encode$string(liste)),
					_Utils_Tuple2(
					'schema',
					A2($author$project$Components$Produits$Listes$API$WriteAPIModel$encodeSchema, version, attributs))
				]);
	}
};
var $author$project$Components$Produits$Listes$API$WriteAPIModel$encode = F2(
	function (processUid, commande) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
				$author$project$Components$Produits$Listes$API$WriteAPIModel$champs(commande)));
	});
var $author$project$Components$Produits$Listes$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Produits$Listes$API$WriteAPIModel$encode, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$Perimetres$API$WriteAPIModel$champs = function (commande) {
	switch (commande.$) {
		case 0:
			var nom = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$elm$json$Json$Encode$string(nom))
				]);
		case 11:
			var perimetre = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'perimetreUid',
					$elm$json$Json$Encode$string(perimetre))
				]);
		case 12:
			var perimetre = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'perimetreUid',
					$elm$json$Json$Encode$string(perimetre))
				]);
		case 1:
			var perimetre = commande.a;
			var noms = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'perimetreUid',
					$elm$json$Json$Encode$string(perimetre)),
					_Utils_Tuple2(
					'noms',
					A3(
						$elm$json$Json$Encode$dict,
						$elm$core$Basics$identity,
						$elm$json$Json$Encode$string,
						A2(
							$elm$core$Dict$filter,
							F2(
								function (_v1, texte) {
									return $elm$core$String$trim(texte) !== '';
								}),
							noms)))
				]);
		case 2:
			var perimetre = commande.a;
			var criteres = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'perimetreUid',
					$elm$json$Json$Encode$string(perimetre)),
					_Utils_Tuple2(
					'criteres',
					A2(
						$elm$json$Json$Encode$list,
						function (_v2) {
							var cle = _v2.a;
							var valeurs = _v2.b;
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'cle',
										$elm$json$Json$Encode$string(cle)),
										_Utils_Tuple2(
										'valeurs',
										A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, valeurs))
									]));
						},
						criteres))
				]);
		case 3:
			var perimetre = commande.a;
			var combinaison = commande.b;
			return A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'perimetreUid',
					$elm$json$Json$Encode$string(perimetre)),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'attribut',
						$elm$json$Json$Encode$string(combinaison.tV)),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'nature',
							$elm$json$Json$Encode$string(combinaison.g1)),
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'champ',
								$elm$json$Json$Encode$string(combinaison.uN)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'comparaison',
									$elm$json$Json$Encode$string(combinaison.vP)),
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function (uid) {
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'correspondanceUid',
													$elm$json$Json$Encode$string(uid))
												]);
										},
										combinaison.ke)))))));
		case 4:
			var perimetre = commande.a;
			var critere = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'perimetreUid',
					$elm$json$Json$Encode$string(perimetre)),
					_Utils_Tuple2(
					'critereUid',
					$elm$json$Json$Encode$string(critere))
				]);
		case 5:
			var perimetre = commande.a;
			var reference = commande.b;
			var motif = commande.c;
			return A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'perimetreUid',
					$elm$json$Json$Encode$string(perimetre)),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'referenceUid',
						$elm$json$Json$Encode$string(reference)),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$andThen,
							function (texte) {
								return (texte === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'motif',
											$elm$json$Json$Encode$string(texte))
										]));
							},
							A2($elm$core$Maybe$map, $elm$core$String$trim, motif)))));
		case 6:
			var perimetre = commande.a;
			var reference = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'perimetreUid',
					$elm$json$Json$Encode$string(perimetre)),
					_Utils_Tuple2(
					'referenceUid',
					$elm$json$Json$Encode$string(reference))
				]);
		case 7:
			var perimetre = commande.a;
			var reference = commande.b;
			var motif = commande.c;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'perimetreUid',
					$elm$json$Json$Encode$string(perimetre)),
					_Utils_Tuple2(
					'referenceUid',
					$elm$json$Json$Encode$string(reference)),
					_Utils_Tuple2(
					'motif',
					$elm$json$Json$Encode$string(motif))
				]);
		case 8:
			var perimetre = commande.a;
			var reference = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'perimetreUid',
					$elm$json$Json$Encode$string(perimetre)),
					_Utils_Tuple2(
					'referenceUid',
					$elm$json$Json$Encode$string(reference))
				]);
		case 9:
			var perimetre = commande.a;
			var regle = commande.b;
			return A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'perimetreUid',
					$elm$json$Json$Encode$string(perimetre)),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'typeUid',
						$elm$json$Json$Encode$string(regle.JX)),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'valeur',
							$elm$json$Json$Encode$int(regle.fm)),
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'portee',
								$elm$json$Json$Encode$string(regle.F$)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'base',
									$elm$json$Json$Encode$string(regle.jo)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'remplacer',
										$elm$json$Json$Encode$bool(regle.ql)),
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											function (p) {
												return _List_fromArray(
													[
														_Utils_Tuple2(
														'periode',
														$elm$json$Json$Encode$string(p))
													]);
											},
											regle.pi))))))));
		default:
			var perimetre = commande.a;
			var regle = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'perimetreUid',
					$elm$json$Json$Encode$string(perimetre)),
					_Utils_Tuple2(
					'regleUid',
					$elm$json$Json$Encode$string(regle))
				]);
	}
};
var $author$project$Components$Produits$Perimetres$API$WriteAPIModel$encode = F2(
	function (processUid, commande) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
				$author$project$Components$Produits$Perimetres$API$WriteAPIModel$champs(commande)));
	});
var $author$project$Components$Produits$Perimetres$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Produits$Perimetres$API$WriteAPIModel$encode, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$champDuType = F2(
	function (type_, cle) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'typeDeProduit',
				$author$project$Catalogue$Identifiants$typeDeProduitIdEncode(type_)),
				_Utils_Tuple2(
				'champ',
				$elm$json$Json$Encode$string(cle))
			]);
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodePortee = function (portee) {
	switch (portee.$) {
		case 0:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'Catalogue',
						$elm$json$Json$Encode$object(_List_Nil))
					]));
		case 1:
			var classification = portee.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'Typologie',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'classification',
									$author$project$Catalogue$Identifiants$classificationIdEncode(classification))
								])))
					]));
		case 3:
			return $elm$json$Json$Encode$null;
		default:
			var classification = portee.a;
			var valeur = portee.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'Noeud',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'classification',
									$author$project$Catalogue$Identifiants$classificationIdEncode(classification)),
									_Utils_Tuple2(
									'valeur',
									$elm$json$Json$Encode$string(valeur))
								])))
					]));
	}
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeEtage = function (portee) {
	if (portee.$ === 3) {
		var type_ = portee.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'Categorie',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'typeDeProduit',
								$author$project$Catalogue$Identifiants$typeDeProduitIdEncode(type_))
							])))
				]));
	} else {
		return $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodePortee(portee);
	}
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeEtat = function (etat) {
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (code) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'code',
								$author$project$Catalogue$Identifiants$etatCodeEncode(code))
							]);
					},
					etat.vx)),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (libelles) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'libelles',
								$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeLibelles(libelles))
							]);
					},
					etat.R))));
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeParent = function (parent) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (id) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'parent',
						$author$project$Catalogue$Identifiants$valeurIdEncode(id))
					]);
			},
			parent));
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$maybeEntier = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map($elm$json$Json$Encode$int),
	$elm$core$Maybe$withDefault($elm$json$Json$Encode$null));
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$champs = function (commande) {
	switch (commande.$) {
		case 0:
			var niveau = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'niveau',
					$author$project$Catalogue$Identifiants$niveauIdEncode(niveau))
				]);
		case 1:
			var niveau = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'niveau',
					$author$project$Catalogue$Identifiants$niveauIdEncode(niveau))
				]);
		case 3:
			var niveau = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'niveau',
					$author$project$Catalogue$Identifiants$niveauIdEncode(niveau))
				]);
		case 6:
			var niveau = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'niveau',
					$author$project$Catalogue$Identifiants$niveauIdEncode(niveau))
				]);
		case 2:
			var niveau = commande.a;
			var libelles = commande.b;
			var formes = commande.c;
			return _Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'niveau',
						$author$project$Catalogue$Identifiants$niveauIdEncode(niveau)),
						_Utils_Tuple2(
						'libelles',
						$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeLibelles(libelles))
					]),
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeFormes(formes));
		case 4:
			var ordre = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'ordre',
					A2($elm$json$Json$Encode$list, $author$project$Catalogue$Identifiants$niveauIdEncode, ordre))
				]);
		case 5:
			var niveau = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'archetype',
					$elm$json$Json$Encode$string(niveau.fA)),
					_Utils_Tuple2(
					'libelles',
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeLibelles(niveau.R)),
					_Utils_Tuple2(
					'rang',
					$elm$json$Json$Encode$int(niveau.bY))
				]);
		case 7:
			var etats = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'etats',
					A2($elm$json$Json$Encode$list, $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeEtat, etats))
				]);
		case 8:
			var seuil = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'etat',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $author$project$Catalogue$Identifiants$etatCodeEncode, seuil)))
				]);
		case 10:
			var ordre = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'ordre',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, ordre))
				]);
		case 9:
			var nature = commande.a;
			var libelles = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'nature',
					$elm$json$Json$Encode$string(nature)),
					_Utils_Tuple2(
					'libelles',
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeLibelles(libelles))
				]);
		case 11:
			var libelles = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'libelles',
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeLibelles(libelles))
				]);
		case 12:
			var nom = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$elm$json$Json$Encode$string(nom)),
					_Utils_Tuple2(
					'portee',
					$elm$json$Json$Encode$string('catalogue'))
				]);
		case 13:
			var liste = commande.a;
			var libelle = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'liste',
					$elm$json$Json$Encode$string(liste)),
					_Utils_Tuple2(
					'libelle',
					$elm$json$Json$Encode$string(libelle))
				]);
		case 14:
			var libelles = commande.a;
			var formes = commande.b;
			return _Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'libelles',
						$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeLibelles(libelles)),
						_Utils_Tuple2(
						'deRangement',
						$elm$json$Json$Encode$bool(true))
					]),
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeFormes(formes));
		case 15:
			var classification = commande.a;
			var libelles = commande.b;
			var formes = commande.c;
			return _Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'classification',
						$author$project$Catalogue$Identifiants$classificationIdEncode(classification)),
						_Utils_Tuple2(
						'libelles',
						$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeLibelles(libelles))
					]),
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeFormes(formes));
		case 16:
			var classification = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'classification',
					$author$project$Catalogue$Identifiants$classificationIdEncode(classification))
				]);
		case 17:
			var classification = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'classification',
					$author$project$Catalogue$Identifiants$classificationIdEncode(classification))
				]);
		case 18:
			var classification = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'classification',
					$author$project$Catalogue$Identifiants$classificationIdEncode(classification))
				]);
		case 19:
			var classification = commande.a;
			var choix = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'classification',
					$author$project$Catalogue$Identifiants$classificationIdEncode(classification)),
					_Utils_Tuple2(
					'choix',
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeChoix(choix))
				]);
		case 20:
			var classification = commande.a;
			var valeur = commande.b;
			return A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'classification',
					$author$project$Catalogue$Identifiants$classificationIdEncode(classification)),
				_Utils_ap(
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeParent(valeur.ey),
					_List_fromArray(
						[
							_Utils_Tuple2(
							'libelles',
							$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeLibelles(valeur.R))
						])));
		case 21:
			var classification = commande.a;
			var place = commande.b;
			return _Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'classification',
						$author$project$Catalogue$Identifiants$classificationIdEncode(classification)),
						_Utils_Tuple2(
						'valeur',
						$author$project$Catalogue$Identifiants$valeurIdEncode(place.fm))
					]),
				_Utils_ap(
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeParent(place.ey),
					_List_fromArray(
						[
							_Utils_Tuple2(
							'rang',
							$elm$json$Json$Encode$int(place.bY))
						])));
		case 22:
			var classification = commande.a;
			var valeur = commande.b;
			var libelles = commande.c;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'classification',
					$author$project$Catalogue$Identifiants$classificationIdEncode(classification)),
					_Utils_Tuple2(
					'valeur',
					$author$project$Catalogue$Identifiants$valeurIdEncode(valeur)),
					_Utils_Tuple2(
					'libelles',
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeLibelles(libelles))
				]);
		case 23:
			var classification = commande.a;
			var valeur = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'classification',
					$author$project$Catalogue$Identifiants$classificationIdEncode(classification)),
					_Utils_Tuple2(
					'valeur',
					$author$project$Catalogue$Identifiants$valeurIdEncode(valeur))
				]);
		case 24:
			var classification = commande.a;
			var valeur = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'classification',
					$author$project$Catalogue$Identifiants$classificationIdEncode(classification)),
					_Utils_Tuple2(
					'valeur',
					$author$project$Catalogue$Identifiants$valeurIdEncode(valeur))
				]);
		case 25:
			var typologie = commande.a;
			var etage = commande.b;
			var libelles = commande.c;
			var formes = commande.d;
			return _Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'classification',
						$author$project$Catalogue$Identifiants$classificationIdEncode(typologie)),
						_Utils_Tuple2(
						'etage',
						$author$project$Catalogue$Identifiants$etageIdEncode(etage)),
						_Utils_Tuple2(
						'libelles',
						$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeLibelles(libelles))
					]),
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeFormes(formes));
		case 26:
			var geste = commande.a;
			var empreinte = commande.b;
			return _Utils_ap(
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$corpsDuGeste(geste),
				_List_fromArray(
					[
						_Utils_Tuple2(
						'apercu',
						$elm$json$Json$Encode$string(empreinte))
					]));
		case 27:
			var typologie = commande.a;
			var place = commande.b;
			return _Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'classification',
						$author$project$Catalogue$Identifiants$classificationIdEncode(typologie)),
						_Utils_Tuple2(
						'etage',
						$author$project$Catalogue$Identifiants$etageIdEncode(place.md)),
						_Utils_Tuple2(
						'valeur',
						$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeValeurDEtage(place.fm))
					]),
				A3($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$facultatif, 'parent', $author$project$Catalogue$Identifiants$noeudIdEncode, place.ey));
		case 28:
			var typologie = commande.a;
			var noeud = commande.b;
			var parent = commande.c;
			return _Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'classification',
						$author$project$Catalogue$Identifiants$classificationIdEncode(typologie)),
						_Utils_Tuple2(
						'noeud',
						$author$project$Catalogue$Identifiants$noeudIdEncode(noeud))
					]),
				A3($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$facultatif, 'parent', $author$project$Catalogue$Identifiants$noeudIdEncode, parent));
		case 29:
			var typologie = commande.a;
			var parent = commande.b;
			var ordre = commande.c;
			return _Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'classification',
						$author$project$Catalogue$Identifiants$classificationIdEncode(typologie))
					]),
				_Utils_ap(
					A3($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$facultatif, 'parent', $author$project$Catalogue$Identifiants$noeudIdEncode, parent),
					_List_fromArray(
						[
							_Utils_Tuple2(
							'ordre',
							A2($elm$json$Json$Encode$list, $author$project$Catalogue$Identifiants$noeudIdEncode, ordre))
						])));
		case 30:
			var typologie = commande.a;
			var noeud = commande.b;
			var valeurs = commande.c;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'classification',
					$author$project$Catalogue$Identifiants$classificationIdEncode(typologie)),
					_Utils_Tuple2(
					'noeud',
					$author$project$Catalogue$Identifiants$noeudIdEncode(noeud)),
					_Utils_Tuple2(
					'valeurs',
					A2($elm$json$Json$Encode$list, $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeValeurDEtage, valeurs))
				]);
		case 31:
			var typologie = commande.a;
			var ajout = commande.b;
			return _Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'classification',
						$author$project$Catalogue$Identifiants$classificationIdEncode(typologie)),
						_Utils_Tuple2(
						'etage',
						$author$project$Catalogue$Identifiants$etageIdEncode(ajout.md))
					]),
				_Utils_ap(
					A3($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$facultatif, 'sous', $author$project$Catalogue$Identifiants$noeudIdEncode, ajout.IV),
					_List_fromArray(
						[
							_Utils_Tuple2(
							'libelles',
							$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeLibelles(ajout.R))
						])));
		case 32:
			var typologie = commande.a;
			var etage = commande.b;
			var valeur = commande.c;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'classification',
					$author$project$Catalogue$Identifiants$classificationIdEncode(typologie)),
					_Utils_Tuple2(
					'etage',
					$author$project$Catalogue$Identifiants$etageIdEncode(etage)),
					_Utils_Tuple2(
					'valeur',
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeValeurDEtage(valeur))
				]);
		case 33:
			var typologie = commande.a;
			var noeud = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'classification',
					$author$project$Catalogue$Identifiants$classificationIdEncode(typologie)),
					_Utils_Tuple2(
					'noeud',
					$author$project$Catalogue$Identifiants$noeudIdEncode(noeud))
				]);
		case 34:
			var typologie = commande.a;
			var lue = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'classification',
					$author$project$Catalogue$Identifiants$classificationIdEncode(typologie)),
					_Utils_Tuple2(
					'portee',
					$author$project$Catalogue$Identifiants$noeudIdEncode(lue.F$)),
					_Utils_Tuple2(
					'parent',
					$author$project$Catalogue$Identifiants$noeudIdEncode(lue.ey))
				]);
		case 36:
			if (commande.a.$ === 3) {
				var type_ = commande.a.a;
				var champ = commande.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'typeDeProduit',
						$author$project$Catalogue$Identifiants$typeDeProduitIdEncode(type_)),
						_Utils_Tuple2(
						'champ',
						$elm$json$Json$Encode$string(champ))
					]);
			} else {
				var portee = commande.a;
				var champ = commande.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'portee',
						$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodePortee(portee)),
						_Utils_Tuple2(
						'champ',
						$elm$json$Json$Encode$string(champ))
					]);
			}
		case 35:
			if (commande.a.$ === 3) {
				var type_ = commande.a.a;
				var ajout = commande.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'typeDeProduit',
						$author$project$Catalogue$Identifiants$typeDeProduitIdEncode(type_)),
						_Utils_Tuple2(
						'libelles',
						$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeLibelles(ajout.R)),
						_Utils_Tuple2(
						'forme',
						$author$project$Components$Shared$EditeurDeSchema$Champ$encodeType(ajout.gB)),
						_Utils_Tuple2(
						'obligatoire',
						$elm$json$Json$Encode$bool(ajout.he))
					]);
			} else {
				var portee = commande.a;
				var ajout = commande.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'portee',
						$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodePortee(portee)),
						_Utils_Tuple2(
						'libelles',
						$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeLibelles(ajout.R)),
						_Utils_Tuple2(
						'forme',
						$author$project$Components$Shared$EditeurDeSchema$Champ$encodeType(ajout.gB)),
						_Utils_Tuple2(
						'obligatoire',
						$elm$json$Json$Encode$bool(ajout.he))
					]);
			}
		case 37:
			if (commande.a.$ === 3) {
				var type_ = commande.a.a;
				var information = commande.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'typeDeProduit',
						$author$project$Catalogue$Identifiants$typeDeProduitIdEncode(type_)),
						_Utils_Tuple2(
						'ajouts',
						A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, _List_Nil)),
						_Utils_Tuple2(
						'modifications',
						A2(
							$elm$json$Json$Encode$list,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									$author$project$Components$Shared$EditeurDeSchema$Champ$encode(information)
								])))
					]);
			} else {
				var portee = commande.a;
				var information = commande.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'portee',
						$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodePortee(portee)),
						_Utils_Tuple2(
						'information',
						$author$project$Components$Shared$EditeurDeSchema$Champ$encode(information))
					]);
			}
		case 38:
			if (commande.a.$ === 3) {
				var type_ = commande.a.a;
				var cle = commande.b;
				return A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$champDuType, type_, cle);
			} else {
				var portee = commande.a;
				var cle = commande.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'portee',
						$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodePortee(portee)),
						_Utils_Tuple2(
						'champ',
						$elm$json$Json$Encode$string(cle))
					]);
			}
		case 39:
			if (commande.a.$ === 3) {
				var type_ = commande.a.a;
				var cle = commande.b;
				return A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$champDuType, type_, cle);
			} else {
				var portee = commande.a;
				var cle = commande.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'portee',
						$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodePortee(portee)),
						_Utils_Tuple2(
						'champ',
						$elm$json$Json$Encode$string(cle))
					]);
			}
		case 40:
			if (commande.a.$ === 3) {
				var type_ = commande.a.a;
				var cle = commande.b;
				return A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$champDuType, type_, cle);
			} else {
				var portee = commande.a;
				var cle = commande.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'portee',
						$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodePortee(portee)),
						_Utils_Tuple2(
						'champ',
						$elm$json$Json$Encode$string(cle))
					]);
			}
		case 41:
			var de = commande.a;
			var cle = commande.b;
			var vers = commande.c;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$elm$json$Json$Encode$string(cle)),
					_Utils_Tuple2(
					'de',
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeEtage(de)),
					_Utils_Tuple2(
					'vers',
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodeEtage(vers))
				]);
		case 42:
			if (commande.a.$ === 3) {
				var type_ = commande.a.a;
				var ordre = commande.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'typeDeProduit',
						$author$project$Catalogue$Identifiants$typeDeProduitIdEncode(type_)),
						_Utils_Tuple2(
						'ordre',
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, ordre))
					]);
			} else {
				var portee = commande.a;
				var ordre = commande.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'portee',
						$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodePortee(portee)),
						_Utils_Tuple2(
						'ordre',
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, ordre))
					]);
			}
		case 44:
			var portee = commande.a;
			var cle = commande.b;
			var articles = commande.c;
			var perimetre = commande.d;
			return _Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'portee',
						$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodePortee(portee)),
						_Utils_Tuple2(
						'champ',
						$elm$json$Json$Encode$string(cle)),
						_Utils_Tuple2(
						'articles',
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, articles))
					]),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (id) {
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'perimetre',
									$elm$json$Json$Encode$string(id))
								]);
						},
						perimetre)));
		default:
			var portee = commande.a;
			var cle = commande.b;
			var minima = commande.c;
			return _Utils_ap(
				function () {
					if (portee.$ === 3) {
						var type_ = portee.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'typeDeProduit',
								$author$project$Catalogue$Identifiants$typeDeProduitIdEncode(type_))
							]);
					} else {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'portee',
								$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodePortee(portee))
							]);
					}
				}(),
				_List_fromArray(
					[
						_Utils_Tuple2(
						'champ',
						$elm$json$Json$Encode$string(cle)),
						_Utils_Tuple2(
						'largeurMinimale',
						$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$maybeEntier(minima.Bd)),
						_Utils_Tuple2(
						'hauteurMinimale',
						$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$maybeEntier(minima.Ae)),
						_Utils_Tuple2(
						'texteAlternatifExige',
						$elm$json$Json$Encode$bool(minima.Jz))
					]));
	}
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encode = F2(
	function (processUid, commande) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$champs(commande)));
	});
var $author$project$Components$Produits$StructureCatalogue$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encode, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIModel$encodeNoms = function (noms) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$map,
			function (_v1) {
				var code = _v1.a;
				var texte = _v1.b;
				return _Utils_Tuple2(
					code,
					$elm$json$Json$Encode$string(
						$elm$core$String$trim(texte)));
			},
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var texte = _v0.b;
					return $elm$core$String$trim(texte) !== '';
				},
				noms)));
};
var $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIModel$champs = function (commande) {
	switch (commande.$) {
		case 0:
			var noms = commande.a;
			var comportement = commande.b;
			var bases = commande.c;
			var periode = commande.d;
			return A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'noms',
					$author$project$Components$Produits$TypesDeQuantite$API$WriteAPIModel$encodeNoms(noms)),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'comportement',
						$elm$json$Json$Encode$string(comportement)),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'bases',
							A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, bases)),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (p) {
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'periodeParDefaut',
											$elm$json$Json$Encode$string(p))
										]);
								},
								periode)))));
		case 1:
			var type_ = commande.a;
			var noms = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'typeUid',
					$elm$json$Json$Encode$string(type_)),
					_Utils_Tuple2(
					'noms',
					$author$project$Components$Produits$TypesDeQuantite$API$WriteAPIModel$encodeNoms(noms))
				]);
		case 2:
			var type_ = commande.a;
			var base = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'typeUid',
					$elm$json$Json$Encode$string(type_)),
					_Utils_Tuple2(
					'base',
					$elm$json$Json$Encode$string(base))
				]);
		case 3:
			var type_ = commande.a;
			var base = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'typeUid',
					$elm$json$Json$Encode$string(type_)),
					_Utils_Tuple2(
					'base',
					$elm$json$Json$Encode$string(base))
				]);
		case 4:
			var type_ = commande.a;
			var periode = commande.b;
			return A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'typeUid',
					$elm$json$Json$Encode$string(type_)),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (p) {
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'periode',
									$elm$json$Json$Encode$string(p))
								]);
						},
						periode)));
		case 5:
			var type_ = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'typeUid',
					$elm$json$Json$Encode$string(type_))
				]);
		case 6:
			var type_ = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'typeUid',
					$elm$json$Json$Encode$string(type_))
				]);
		default:
			var ordre = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'ordre',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, ordre))
				]);
	}
};
var $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIModel$encode = F2(
	function (processUid, commande) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
				$author$project$Components$Produits$TypesDeQuantite$API$WriteAPIModel$champs(commande)));
	});
var $author$project$Components$Produits$TypesDeQuantite$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Produits$TypesDeQuantite$API$WriteAPIModel$encode, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Referentiel$Identifiants$groupeUidEncode = function (_v0) {
	var valeur = _v0;
	return $elm$json$Json$Encode$string(valeur);
};
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderAjouterDesMembres = F4(
	function (processUid, groupe, fiches, depuis) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
					_Utils_Tuple2(
					'groupe',
					$author$project$Components$Referentiel$Identifiants$groupeUidEncode(groupe)),
					_Utils_Tuple2(
					'fiches',
					A2(
						$elm$json$Json$Encode$list,
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Identifiants$entiteUidToString, $elm$json$Json$Encode$string),
						fiches)),
					_Utils_Tuple2(
					'depuis',
					$elm$json$Json$Encode$string(depuis))
				]));
	});
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderFiltreDeLaListe = function (filtre) {
	return $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$posees(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nature',
				A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, filtre.g1)),
				_Utils_Tuple2(
				'qualite',
				A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, filtre.hy)),
				_Utils_Tuple2(
				'pays',
				A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, filtre.ho)),
				_Utils_Tuple2(
				'archetype',
				A2($elm$core$Maybe$map, $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$archetype, filtre.fA)),
				_Utils_Tuple2(
				'types',
				A2($author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$listeNonVide, $elm$json$Json$Encode$string, filtre.ib)),
				_Utils_Tuple2(
				'terme',
				A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, filtre.h3))
			]));
};
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderPortee = function (portee) {
	switch (portee.$) {
		case 0:
			var fiches = portee.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'Fiches',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'fiches',
									A2(
										$elm$json$Json$Encode$list,
										A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Identifiants$entiteUidToString, $elm$json$Json$Encode$string),
										fiches))
								])))
					]));
		case 1:
			var filtre = portee.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'Filtre',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'filtre',
									$author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderFiltreDeLaListe(filtre))
								])))
					]));
		default:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'Toutes',
						$elm$json$Json$Encode$object(_List_Nil))
					]));
	}
};
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderAjouterEnLot = F4(
	function (processUid, groupe, portee, depuis) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
					_Utils_Tuple2(
					'groupe',
					$author$project$Components$Referentiel$Identifiants$groupeUidEncode(groupe)),
					_Utils_Tuple2(
					'portee',
					$author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderPortee(portee)),
					_Utils_Tuple2(
					'depuis',
					$elm$json$Json$Encode$string(depuis))
				]));
	});
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderArchiver = F2(
	function (processUid, groupe) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
					_Utils_Tuple2(
					'groupe',
					$author$project$Components$Referentiel$Identifiants$groupeUidEncode(groupe))
				]));
	});
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderChangerLeResponsable = F3(
	function (processUid, groupe, responsable) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
					_Utils_Tuple2(
					'groupe',
					$author$project$Components$Referentiel$Identifiants$groupeUidEncode(groupe)),
					_Utils_Tuple2(
					'responsable',
					$elm$json$Json$Encode$string(responsable))
				]));
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$identite = function (groupe) {
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2(
			'nom',
			$elm$json$Json$Encode$string(groupe.Dj)),
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					function (d) {
						return _Utils_Tuple2(
							'description',
							$elm$json$Json$Encode$string(d));
					},
					groupe.dH),
					A2(
					$elm$core$Maybe$map,
					function (r) {
						return _Utils_Tuple2(
							'responsable',
							$elm$json$Json$Encode$string(r));
					},
					groupe.qB)
				])));
};
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderCreerDynamique = F3(
	function (processUid, groupe, filtre) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
				_Utils_ap(
					A2(
						$elm$core$List$take,
						1,
						$author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$identite(groupe)),
					_Utils_ap(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'filtre',
								$author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderFiltre(filtre))
							]),
						A2(
							$elm$core$List$drop,
							1,
							$author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$identite(groupe))))));
	});
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderCreerDynamiqueDepuisLaListe = F4(
	function (processUid, groupe, filtre, ecartes) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
				_Utils_ap(
					A2(
						$elm$core$List$take,
						1,
						$author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$identite(groupe)),
					_Utils_ap(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'filtre',
								$author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderFiltre(filtre)),
								_Utils_Tuple2(
								'recherche',
								$elm$json$Json$Encode$bool(ecartes.hC)),
								_Utils_Tuple2(
								'etat',
								$elm$json$Json$Encode$bool(ecartes.gt)),
								_Utils_Tuple2(
								'dateDeCreation',
								$elm$json$Json$Encode$bool(ecartes.kr))
							]),
						A2(
							$elm$core$List$drop,
							1,
							$author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$identite(groupe))))));
	});
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderCreerStatique = F2(
	function (processUid, groupe) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
				$author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$identite(groupe)));
	});
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderModifierLeFiltre = F3(
	function (processUid, groupe, filtre) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
					_Utils_Tuple2(
					'groupe',
					$author$project$Components$Referentiel$Identifiants$groupeUidEncode(groupe)),
					_Utils_Tuple2(
					'filtre',
					$author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderFiltre(filtre))
				]));
	});
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderRenommer = F3(
	function (processUid, groupe, nom) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
					_Utils_Tuple2(
					'groupe',
					$author$project$Components$Referentiel$Identifiants$groupeUidEncode(groupe)),
					_Utils_Tuple2(
					'nom',
					$elm$json$Json$Encode$string(nom))
				]));
	});
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderRetirerUnMembre = F4(
	function (processUid, groupe, fiche, jusquAu) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
					_Utils_Tuple2(
					'groupe',
					$author$project$Components$Referentiel$Identifiants$groupeUidEncode(groupe)),
					_Utils_Tuple2(
					'fiche',
					$elm$json$Json$Encode$string(
						$author$project$Components$Referentiel$Identifiants$entiteUidToString(fiche))),
					_Utils_Tuple2(
					'jusquAu',
					$elm$json$Json$Encode$string(jusquAu))
				]));
	});
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderCommande = F2(
	function (processUid, commande) {
		switch (commande.$) {
			case 0:
				var groupe = commande.a;
				return A2($author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderCreerStatique, processUid, groupe);
			case 1:
				var groupe = commande.a;
				return A3(
					$author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderCreerDynamique,
					processUid,
					groupe,
					{g1: $elm$core$Maybe$Nothing, ho: $elm$core$Maybe$Nothing, hy: $elm$core$Maybe$Nothing, Ic: _List_Nil, Id: _List_Nil});
			case 2:
				var groupe = commande.a;
				var filtre = commande.b;
				var ecartes = commande.c;
				return A4($author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderCreerDynamiqueDepuisLaListe, processUid, groupe, filtre, ecartes);
			case 3:
				var groupe = commande.a;
				var portee = commande.b;
				var depuis = commande.c;
				return A4($author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderAjouterEnLot, processUid, groupe, portee, depuis);
			case 4:
				var groupe = commande.a;
				var fiches = commande.b;
				var depuis = commande.c;
				return A4($author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderAjouterDesMembres, processUid, groupe, fiches, depuis);
			case 5:
				var groupe = commande.a;
				var fiche = commande.b;
				var sortie = commande.c;
				return A4($author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderRetirerUnMembre, processUid, groupe, fiche, sortie);
			case 6:
				var groupe = commande.a;
				var nom = commande.b;
				return A3($author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderRenommer, processUid, groupe, nom);
			case 7:
				var groupe = commande.a;
				var filtre = commande.b;
				return A3($author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderModifierLeFiltre, processUid, groupe, filtre);
			case 8:
				var groupe = commande.a;
				return A2($author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderArchiver, processUid, groupe);
			default:
				var groupe = commande.a;
				var responsable = commande.b;
				return A3($author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderChangerLeResponsable, processUid, groupe, responsable);
		}
	});
var $author$project$Components$Referentiel$Common$API$Groupes$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$encoderCommande, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Referentiel$Identifiants$formeUidToString = function (_v0) {
	var valeur = _v0;
	return valeur;
};
var $author$project$Components$Referentiel$Formes$API$WriteAPIModel$identifiant = function (id) {
	return $elm$json$Json$Encode$string(
		$author$project$Components$Referentiel$Identifiants$formeUidToString(id));
};
var $author$project$Components$Referentiel$Formes$API$WriteAPIModel$libellesEncodes = function (l) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'fr',
				$elm$json$Json$Encode$string(l.zX)),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (en) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'en',
								$elm$json$Json$Encode$string(en))
							]);
					},
					l.yg))));
};
var $author$project$Components$Referentiel$Formes$API$WriteAPIModel$champs = function (commande) {
	switch (commande.$) {
		case 0:
			var libelles = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'libelles',
					$author$project$Components$Referentiel$Formes$API$WriteAPIModel$libellesEncodes(libelles))
				]);
		case 1:
			var id = commande.a;
			var libelles = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'forme',
					$author$project$Components$Referentiel$Formes$API$WriteAPIModel$identifiant(id)),
					_Utils_Tuple2(
					'libelles',
					$author$project$Components$Referentiel$Formes$API$WriteAPIModel$libellesEncodes(libelles))
				]);
		case 2:
			var id = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'forme',
					$author$project$Components$Referentiel$Formes$API$WriteAPIModel$identifiant(id))
				]);
		default:
			var id = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'forme',
					$author$project$Components$Referentiel$Formes$API$WriteAPIModel$identifiant(id))
				]);
	}
};
var $author$project$Components$Referentiel$Formes$API$WriteAPIModel$encode = F2(
	function (processUid, commande) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
				$author$project$Components$Referentiel$Formes$API$WriteAPIModel$champs(commande)));
	});
var $author$project$Components$Referentiel$Formes$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Referentiel$Formes$API$WriteAPIModel$encode, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Referentiel$Postes$API$WriteAPIModel$identifiant = function (id) {
	return $elm$json$Json$Encode$string(
		$author$project$Components$Referentiel$Identifiants$posteUidToString(id));
};
var $author$project$Components$Referentiel$Postes$API$WriteAPIModel$libellesEncodes = function (l) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'fr',
				$elm$json$Json$Encode$string(l.zX)),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (en) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'en',
								$elm$json$Json$Encode$string(en))
							]);
					},
					l.yg))));
};
var $author$project$Components$Referentiel$Postes$API$WriteAPIModel$champs = function (commande) {
	switch (commande.$) {
		case 0:
			var libelles = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'libelles',
					$author$project$Components$Referentiel$Postes$API$WriteAPIModel$libellesEncodes(libelles))
				]);
		case 1:
			var id = commande.a;
			var libelles = commande.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'poste',
					$author$project$Components$Referentiel$Postes$API$WriteAPIModel$identifiant(id)),
					_Utils_Tuple2(
					'libelles',
					$author$project$Components$Referentiel$Postes$API$WriteAPIModel$libellesEncodes(libelles))
				]);
		case 2:
			var id = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'poste',
					$author$project$Components$Referentiel$Postes$API$WriteAPIModel$identifiant(id))
				]);
		default:
			var id = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'poste',
					$author$project$Components$Referentiel$Postes$API$WriteAPIModel$identifiant(id))
				]);
	}
};
var $author$project$Components$Referentiel$Postes$API$WriteAPIModel$encode = F2(
	function (processUid, commande) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
				$author$project$Components$Referentiel$Postes$API$WriteAPIModel$champs(commande)));
	});
var $author$project$Components$Referentiel$Postes$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Referentiel$Postes$API$WriteAPIModel$encode, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$typeIdVersTexte = function (_v0) {
	var texte = _v0;
	return texte;
};
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$identifiant = function (id) {
	return $elm$json$Json$Encode$string(
		$author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$typeIdVersTexte(id));
};
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$libelles = function (l) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'fr',
				$elm$json$Json$Encode$string(l.zX)),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (en) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'en',
								$elm$json$Json$Encode$string(en))
							]);
					},
					l.yg))));
};
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$inverse = function (saisi) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (l) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'libelleInverse',
						$author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$libelles(l))
					]);
			},
			saisi));
};
var $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$formeIdVersTexte = function (_v0) {
	var texte = _v0;
	return texte;
};
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$organisations = function (choisies) {
	switch (choisies.$) {
		case 0:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'Aucune',
						$elm$json$Json$Encode$object(_List_Nil))
					]));
		case 1:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'Toutes',
						$elm$json$Json$Encode$object(_List_Nil))
					]));
		default:
			var formes = choisies.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'Certaines',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'formes',
									A2(
										$elm$json$Json$Encode$list,
										A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$formeIdVersTexte, $elm$json$Json$Encode$string),
										formes))
								])))
					]));
	}
};
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$cote = function (c) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'personnesPro',
				$elm$json$Json$Encode$bool(c.hs)),
				_Utils_Tuple2(
				'personnesParticulieres',
				$elm$json$Json$Encode$bool(c.hr)),
				_Utils_Tuple2(
				'organisations',
				$author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$organisations(c.o3))
			]));
};
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$perimetre = F2(
	function (source, cible) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'source',
					$author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$cote(source)),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (c) {
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'cible',
									$author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$cote(c))
								]);
						},
						cible))));
	});
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$champs = function (commande) {
	switch (commande.$) {
		case 0:
			var creation = commande.a;
			return _Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'libelleDirect',
						$author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$libelles(creation.xA))
					]),
				_Utils_ap(
					$author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$inverse(creation.ng),
					_List_fromArray(
						[
							_Utils_Tuple2(
							'reciproque',
							$elm$json$Json$Encode$bool(creation.G6)),
							_Utils_Tuple2(
							'perimetre',
							A2($author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$perimetre, creation.IR, creation.vf))
						])));
		case 1:
			var id = commande.a;
			var direct = commande.b;
			var inverseSaisi = commande.c;
			return _Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$identifiant(id)),
						_Utils_Tuple2(
						'libelleDirect',
						$author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$libelles(direct))
					]),
				$author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$inverse(inverseSaisi));
		case 2:
			var id = commande.a;
			var forme = commande.b;
			return _Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$identifiant(id))
					]),
				_Utils_ap(
					$author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$inverse(forme.ng),
					_List_fromArray(
						[
							_Utils_Tuple2(
							'reciproque',
							$elm$json$Json$Encode$bool(forme.G6)),
							_Utils_Tuple2(
							'perimetre',
							A2($author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$perimetre, forme.IR, forme.vf))
						])));
		case 3:
			var id = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$identifiant(id))
				]);
		default:
			var id = commande.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$identifiant(id))
				]);
	}
};
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$encode = F2(
	function (processUid, commande) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
				$author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$champs(commande)));
	});
var $author$project$Components$Referentiel$TypesDeRelation$API$HttpAPI$envoyerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$encode, requete.Gn, requete.vJ)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeGesteSurLaFiche = F2(
	function (processUid, entite) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
					_Utils_Tuple2(
					'entite',
					$elm$json$Json$Encode$string(
						$author$project$Components$Referentiel$Identifiants$entiteUidToString(entite)))
				]));
	});
var $author$project$Components$Referentiel$Fiche$API$HttpAPI$envoyerUnGesteReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeGesteSurLaFiche, requete.Gn, requete.yt)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeExporterLesDonnees = F4(
	function (processUid, entite, formats, demandeRecueLe) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
					_Utils_Tuple2(
					'entite',
					$elm$json$Json$Encode$string(
						$author$project$Components$Referentiel$Identifiants$entiteUidToString(entite))),
					_Utils_Tuple2(
					'formats',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, formats)),
					_Utils_Tuple2(
					'demandeRecueLe',
					$elm$json$Json$Encode$string(demandeRecueLe))
				]));
	});
var $author$project$Components$Referentiel$Fiche$API$HttpAPI$exporterLesDonneesReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A4($author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeExporterLesDonnees, requete.Gn, requete.yt, requete.zR, requete.w9)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $elm$file$File$Select$file = F2(
	function (mimes, toMsg) {
		return A2(
			$elm$core$Task$perform,
			toMsg,
			_File_uploadOne(mimes));
	});
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$I18n$Nombre$Fr = 0;
var $author$project$I18n$Traductions$Traductions = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$I18n$Traductions$francais = A2($author$project$I18n$Traductions$Traductions, 0, $elm$core$Dict$empty);
var $author$project$Components$Referentiel$Fusion$API$HttpAPI$corps = function (requete) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'fusion',
				$author$project$API$ProcessUid$encode(requete.z$)),
				_Utils_Tuple2(
				'gardee',
				$elm$json$Json$Encode$string(
					$author$project$Components$Referentiel$Identifiants$entiteUidToString(requete.z5))),
				_Utils_Tuple2(
				'absorbee',
				$elm$json$Json$Encode$string(
					$author$project$Components$Referentiel$Identifiants$entiteUidToString(requete.sK))),
				_Utils_Tuple2(
				'champsDeLAbsorbee',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, requete.dw))
			]));
};
var $author$project$Components$Referentiel$Fusion$API$HttpAPI$fusionnerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				$author$project$Components$Referentiel$Fusion$API$HttpAPI$corps(requete)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Ports$garderParcoursEtPartir = _Platform_outgoingPort('garderParcoursEtPartir', $elm$core$Basics$identity);
var $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$encodeOccurrence = F3(
	function (processUid, entite, geste) {
		var valeurs = function (lues) {
			return _Utils_Tuple2(
				'valeurs',
				$elm$json$Json$Encode$object(
					A2(
						$elm$core$List$map,
						function (_v1) {
							var cle = _v1.a;
							var valeur = _v1.b;
							return _Utils_Tuple2(
								cle,
								$author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$encode(valeur));
						},
						lues)));
		};
		var deLaFiche = function (champ) {
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
					_Utils_Tuple2(
					'entite',
					$elm$json$Json$Encode$string(
						$author$project$Components$Referentiel$Identifiants$entiteUidToString(entite))),
					_Utils_Tuple2(
					'champ',
					$elm$json$Json$Encode$string(champ))
				]);
		};
		return $elm$json$Json$Encode$object(
			function () {
				switch (geste.$) {
					case 0:
						var champ = geste.a;
						var lues = geste.b;
						var aCreer = geste.c;
						return _Utils_ap(
							deLaFiche(champ),
							_Utils_ap(
								_List_fromArray(
									[
										valeurs(lues)
									]),
								$author$project$Components$Shared$EditeurDeSchema$Groupe$encoderLesValeursACreer(aCreer)));
					case 1:
						var champ = geste.a;
						var uid = geste.b;
						var lues = geste.c;
						var aCreer = geste.d;
						return _Utils_ap(
							deLaFiche(champ),
							_Utils_ap(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'uid',
										$elm$json$Json$Encode$string(uid)),
										valeurs(lues)
									]),
								$author$project$Components$Shared$EditeurDeSchema$Groupe$encoderLesValeursACreer(aCreer)));
					default:
						var champ = geste.a;
						var uid = geste.b;
						return _Utils_ap(
							deLaFiche(champ),
							_List_fromArray(
								[
									_Utils_Tuple2(
									'uid',
									$elm$json$Json$Encode$string(uid))
								]));
				}
			}());
	});
var $author$project$Components$Referentiel$Fiche$API$HttpAPI$gererUneOccurrenceReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A3($author$project$Components$Referentiel$Fiche$API$WriteAPIModel$encodeOccurrence, requete.Gn, requete.yt, requete.mW)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $elm$browser$Browser$Dom$getViewport = _Browser_withWindow(_Browser_getViewport);
var $author$project$I18n$Traductions$Chaine = function (a) {
	return {$: 0, a: a};
};
var $author$project$I18n$Traductions$estUn = F2(
	function (lue, n) {
		if (!lue) {
			return (!n) || (n === 1);
		} else {
			return n === 1;
		}
	});
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $author$project$I18n$Nombre$grouper = function (chiffres) {
	return ($elm$core$String$length(chiffres) <= 3) ? _List_fromArray(
		[chiffres]) : _Utils_ap(
		$author$project$I18n$Nombre$grouper(
			A2($elm$core$String$dropRight, 3, chiffres)),
		_List_fromArray(
			[
				A2($elm$core$String$right, 3, chiffres)
			]));
};
var $author$project$I18n$Nombre$separateur = function (langue) {
	if (!langue) {
		return '\u202F';
	} else {
		return ',';
	}
};
var $author$project$I18n$Nombre$formater = F2(
	function (langue, nombre) {
		return (nombre < 0) ? ('-' + A2($author$project$I18n$Nombre$formater, langue, -nombre)) : A2(
			$elm$core$String$join,
			$author$project$I18n$Nombre$separateur(langue),
			$author$project$I18n$Nombre$grouper(
				$elm$core$String$fromInt(nombre)));
	});
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $author$project$I18n$Traductions$assembler = F3(
	function (lue, valeurs, nombre) {
		return A2(
			$elm$core$List$foldr,
			function (segment) {
				return A2(
					$elm$core$Maybe$map2,
					$elm$core$Basics$append,
					A4($author$project$I18n$Traductions$rendreSegment, lue, valeurs, nombre, segment));
			},
			$elm$core$Maybe$Just(''));
	});
var $author$project$I18n$Traductions$choisie = F5(
	function (lue, valeurs, nombre, forme, formes) {
		var _v6 = A2($elm$core$Dict$get, forme, formes);
		if (!_v6.$) {
			var lus = _v6.a;
			return A4($author$project$I18n$Traductions$assembler, lue, valeurs, nombre, lus);
		} else {
			return A2(
				$elm$core$Maybe$andThen,
				A3($author$project$I18n$Traductions$assembler, lue, valeurs, nombre),
				A2($elm$core$Dict$get, 'other', formes));
		}
	});
var $author$project$I18n$Traductions$rendreSegment = F4(
	function (lue, valeurs, nombre, segment) {
		switch (segment.$) {
			case 0:
				var lu = segment.a;
				return $elm$core$Maybe$Just(lu);
			case 6:
				return A2(
					$elm$core$Maybe$map,
					$author$project$I18n$Nombre$formater(lue),
					nombre);
			case 1:
				var nom = segment.a;
				var _v1 = A2($elm$core$Dict$get, nom, valeurs);
				if (!_v1.$) {
					switch (_v1.a.$) {
						case 0:
							var lu = _v1.a.a;
							return $elm$core$Maybe$Just(lu);
						case 1:
							var n = _v1.a.a;
							return $elm$core$Maybe$Just(
								A2($author$project$I18n$Nombre$formater, lue, n));
						case 2:
							return $elm$core$Maybe$Nothing;
						case 3:
							return $elm$core$Maybe$Nothing;
						default:
							return $elm$core$Maybe$Nothing;
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 5:
				var nom = segment.a;
				var formes = segment.b;
				var _v2 = A2($elm$core$Dict$get, nom, valeurs);
				_v2$2:
				while (true) {
					if (!_v2.$) {
						switch (_v2.a.$) {
							case 2:
								var forme = _v2.a.a;
								return A5($author$project$I18n$Traductions$choisie, lue, valeurs, nombre, forme, formes);
							case 0:
								var forme = _v2.a.a;
								return A5($author$project$I18n$Traductions$choisie, lue, valeurs, nombre, forme, formes);
							default:
								break _v2$2;
						}
					} else {
						break _v2$2;
					}
				}
				return $elm$core$Maybe$Nothing;
			case 2:
				var nom = segment.a;
				var _v3 = A2($elm$core$Dict$get, nom, valeurs);
				if ((!_v3.$) && (!_v3.a.$)) {
					var lu = _v3.a.a;
					return $elm$core$Maybe$Just(
						$elm$core$String$toLower(lu));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 3:
				var nom = segment.a;
				var _v4 = A2($elm$core$Dict$get, nom, valeurs);
				if ((!_v4.$) && (!_v4.a.$)) {
					var lu = _v4.a.a;
					return $elm$core$Maybe$Just(
						_Utils_ap(
							$elm$core$String$toLower(
								A2($elm$core$String$left, 1, lu)),
							A2($elm$core$String$dropLeft, 1, lu)));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			default:
				var nom = segment.a;
				var un = segment.b;
				var autre = segment.c;
				var _v5 = A2($elm$core$Dict$get, nom, valeurs);
				if ((!_v5.$) && (_v5.a.$ === 1)) {
					var n = _v5.a.a;
					return A4(
						$author$project$I18n$Traductions$assembler,
						lue,
						valeurs,
						$elm$core$Maybe$Just(n),
						A2($author$project$I18n$Traductions$estUn, lue, n) ? un : autre);
				} else {
					return $elm$core$Maybe$Nothing;
				}
		}
	});
var $author$project$I18n$Traductions$traduire = F3(
	function (cle, valeurs, _v0) {
		var lue = _v0.a;
		var libelles = _v0.b;
		return A2(
			$elm$core$Maybe$andThen,
			A3(
				$author$project$I18n$Traductions$assembler,
				lue,
				$elm$core$Dict$fromList(valeurs),
				$elm$core$Maybe$Nothing),
			A2($elm$core$Dict$get, cle, libelles));
	});
var $author$project$I18n$Cles$lire = F4(
	function (i18n, cle, valeurs, repli) {
		return A2(
			$elm$core$Maybe$withDefault,
			repli,
			A3($author$project$I18n$Traductions$traduire, cle, valeurs, i18n));
	});
var $author$project$I18n$Cles$sessionIncidentAction = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'session.incident.action',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rel',
					$author$project$I18n$Traductions$Chaine(p.eP))
				]),
			'Lien « ' + (p.eP + ' » reçu de l\'API : il ne mène pas à une action de l\'écran de connexion d\'Asria, il n\'est pas suivi.'));
	});
var $author$project$I18n$Cles$sessionIncidentEspaces = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'session.incident.espaces',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'statut',
					$author$project$I18n$Traductions$Chaine(p.ri))
				]),
			'Lecture des espaces de l\'utilisateur : réponse ' + (p.ri + '.'));
	});
var $author$project$I18n$Cles$sessionIncidentLien = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'session.incident.lien',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rel',
					$author$project$I18n$Traductions$Chaine(p.eP))
				]),
			'Lien « ' + (p.eP + ' » reçu de l\'API : son adresse n\'est pas sur l\'origine de l\'API, il n\'est pas suivi.'));
	});
var $author$project$I18n$Cles$sessionIncidentPreferences = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'session.incident.preferences',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'statut',
					$author$project$I18n$Traductions$Chaine(p.ri))
				]),
			'Lecture des préférences de l\'utilisateur : réponse ' + (p.ri + '.'));
	});
var $author$project$I18n$Cles$sessionIncidentRacine = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'session.incident.racine',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'statut',
					$author$project$I18n$Traductions$Chaine(p.ri))
				]),
			'Lecture de la ressource racine de l\'API : réponse ' + (p.ri + '.'));
	});
var $author$project$I18n$Cles$sessionIncidentTraductions = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'session.incident.traductions',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'langue',
					$author$project$I18n$Traductions$Chaine(p.nn)),
					_Utils_Tuple2(
					'statut',
					$author$project$I18n$Traductions$Chaine(p.ri))
				]),
			'Lecture du catalogue de traductions « ' + (p.nn + (' » : réponse ' + (p.ri + '.'))));
	});
var $author$project$Components$Socle$Session$View$incident = F2(
	function (i18n, signale) {
		switch (signale.$) {
			case 0:
				var statut = signale.a;
				return A2(
					$author$project$I18n$Cles$sessionIncidentRacine,
					i18n,
					{
						ri: $elm$core$String$fromInt(statut)
					});
			case 2:
				var rel = signale.a;
				return A2(
					$author$project$I18n$Cles$sessionIncidentLien,
					i18n,
					{eP: rel});
			case 3:
				var rel = signale.a;
				return A2(
					$author$project$I18n$Cles$sessionIncidentAction,
					i18n,
					{eP: rel});
			case 4:
				var statut = signale.a;
				return A2(
					$author$project$I18n$Cles$sessionIncidentPreferences,
					i18n,
					{
						ri: $elm$core$String$fromInt(statut)
					});
			case 5:
				var langue = signale.a;
				var statut = signale.b;
				return A2(
					$author$project$I18n$Cles$sessionIncidentTraductions,
					i18n,
					{
						nn: langue,
						ri: $elm$core$String$fromInt(statut)
					});
			default:
				var statut = signale.a;
				return A2(
					$author$project$I18n$Cles$sessionIncidentEspaces,
					i18n,
					{
						ri: $elm$core$String$fromInt(statut)
					});
		}
	});
var $elm$core$Basics$modBy = _Basics_modBy;
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $author$project$I18n$Nombre$formaterDecimal = F2(
	function (langue, nombre) {
		var virgule = function () {
			if (!langue) {
				return ',';
			} else {
				return '.';
			}
		}();
		var centiemes = $elm$core$Basics$round(nombre * 100);
		return _Utils_ap(
			A2($author$project$I18n$Nombre$formater, langue, (centiemes / 100) | 0),
			_Utils_ap(
				virgule,
				A3(
					$elm$core$String$padLeft,
					2,
					'0',
					$elm$core$String$fromInt(
						A2($elm$core$Basics$modBy, 100, centiemes)))));
	});
var $author$project$I18n$Traductions$langue = function (_v0) {
	var lue = _v0.a;
	return lue;
};
var $author$project$I18n$Cles$themeRaisonAlias = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'theme.raison.alias',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'alias reçu pour le token ' + p.Dj);
	});
var $author$project$I18n$Cles$themeRaisonAlpha = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'theme.raison.alpha',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'couleur translucide sur le token ' + (p.Dj + ', cité dans un couple de contraste'));
	});
var $author$project$I18n$Cles$themeRaisonJson = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'theme.raison.json', _List_Nil, 'JSON invalide');
};
var $author$project$I18n$Cles$themeRaisonMarque = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'theme.raison.marque',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'champ ' + (p.Dj + ' de la marque hors grammaire'));
	});
var $author$project$I18n$Cles$themeRaisonTokens = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'theme.raison.tokens', _List_Nil, 'champ tokens absent, ou qui n\'est pas un objet');
};
var $author$project$I18n$Cles$themeRaisonType = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'theme.raison.type',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'type inattendu pour le token ' + p.Dj);
	});
var $author$project$I18n$Cles$themeRaisonValeur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'theme.raison.valeur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'valeur hors grammaire pour le token ' + p.Dj);
	});
var $author$project$I18n$Cles$themeRaisonVersion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'theme.raison.version', _List_Nil, 'version absente ou différente de 1');
};
var $author$project$Components$Socle$Theme$View$raison = F2(
	function (i18n, illisible) {
		switch (illisible.$) {
			case 0:
				return $author$project$I18n$Cles$themeRaisonJson(i18n);
			case 1:
				return $author$project$I18n$Cles$themeRaisonVersion(i18n);
			case 2:
				return $author$project$I18n$Cles$themeRaisonTokens(i18n);
			case 3:
				var nom = illisible.a;
				return A2(
					$author$project$I18n$Cles$themeRaisonType,
					i18n,
					{Dj: nom});
			case 4:
				var nom = illisible.a;
				return A2(
					$author$project$I18n$Cles$themeRaisonValeur,
					i18n,
					{Dj: nom});
			case 5:
				var nom = illisible.a;
				return A2(
					$author$project$I18n$Cles$themeRaisonAlias,
					i18n,
					{Dj: nom});
			case 6:
				var nom = illisible.a;
				return A2(
					$author$project$I18n$Cles$themeRaisonAlpha,
					i18n,
					{Dj: nom});
			default:
				var nom = illisible.a;
				return A2(
					$author$project$I18n$Cles$themeRaisonMarque,
					i18n,
					{Dj: nom});
		}
	});
var $author$project$I18n$Cles$themeCauseDelai = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'theme.cause.delai', _List_Nil, 'Thème Asria appliqué : la route du thème de l\'instance n\'a pas répondu dans le délai.');
};
var $author$project$I18n$Cles$themeCauseErreur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'theme.cause.erreur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'statut',
					$author$project$I18n$Traductions$Chaine(p.ri))
				]),
			'Thème Asria appliqué : la route du thème de l\'instance a répondu ' + (p.ri + '.'));
	});
var $author$project$I18n$Cles$themeCauseIllisible = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'theme.cause.illisible',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'raison',
					$author$project$I18n$Traductions$Chaine(p.pH))
				]),
			'Thème Asria appliqué : le thème reçu de l\'instance est illisible (' + (p.pH + ').'));
	});
var $author$project$I18n$Cles$themeCauseInjoignable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'theme.cause.injoignable', _List_Nil, 'Thème Asria appliqué : la route du thème de l\'instance est injoignable.');
};
var $author$project$I18n$Cles$themeCauseNonConforme = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'theme.cause.non-conforme',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'ratio',
					$author$project$I18n$Traductions$Chaine(p.GW)),
					_Utils_Tuple2(
					'avant',
					$author$project$I18n$Traductions$Chaine(p.je)),
					_Utils_Tuple2(
					'fond',
					$author$project$I18n$Traductions$Chaine(p.mN)),
					_Utils_Tuple2(
					'seuil',
					$author$project$I18n$Traductions$Chaine(p.IL))
				]),
			'Thème de l\'instance refusé, thème Asria appliqué : contraste de ' + (p.GW + (' entre ' + (p.je + (' et ' + (p.mN + (', pour ' + (p.IL + ' attendu.'))))))));
	});
var $author$project$Components$Socle$Theme$View$cause = F2(
	function (i18n, ecarte) {
		switch (ecarte.$) {
			case 0:
				return $author$project$I18n$Cles$themeCauseInjoignable(i18n);
			case 1:
				return $author$project$I18n$Cles$themeCauseDelai(i18n);
			case 2:
				var statut = ecarte.a;
				return A2(
					$author$project$I18n$Cles$themeCauseErreur,
					i18n,
					{
						ri: $elm$core$String$fromInt(statut)
					});
			case 3:
				var illisible = ecarte.a;
				return A2(
					$author$project$I18n$Cles$themeCauseIllisible,
					i18n,
					{
						pH: A2($author$project$Components$Socle$Theme$View$raison, i18n, illisible)
					});
			default:
				var couple = ecarte.a;
				return A2(
					$author$project$I18n$Cles$themeCauseNonConforme,
					i18n,
					{
						je: couple.je,
						mN: couple.mN,
						GW: A2(
							$author$project$I18n$Nombre$formaterDecimal,
							$author$project$I18n$Traductions$langue(i18n),
							couple.GW),
						IL: A2(
							$author$project$I18n$Nombre$formaterDecimal,
							$author$project$I18n$Traductions$langue(i18n),
							couple.IL)
					});
		}
	});
var $author$project$I18n$Cles$themeTokensIgnores = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'theme.tokens-ignores',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'noms',
					$author$project$I18n$Traductions$Chaine(p.DG))
				]),
			'Tokens du thème ignorés, de nom inconnu : ' + (p.DG + '.'));
	});
var $author$project$Components$Socle$Theme$View$incident = F2(
	function (i18n, signale) {
		if (!signale.$) {
			var noms = signale.a;
			return A2(
				$author$project$I18n$Cles$themeTokensIgnores,
				i18n,
				{
					DG: A2($elm$core$String$join, ', ', noms)
				});
		} else {
			var ecarte = signale.a;
			return A2($author$project$Components$Socle$Theme$View$cause, i18n, ecarte);
		}
	});
var $author$project$Components$Imports$Outil$API$HttpAPI$lectureReq = function (requete) {
	var texte = F2(
		function (nom, valeur) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (v) {
						return _List_fromArray(
							[
								A2($elm$http$Http$stringPart, nom, v)
							]);
					},
					valeur));
		});
	var demande = requete.kC;
	return A3(
		$author$project$Components$Imports$Outil$API$HttpAPI$multipart,
		requete.gM,
		requete.nB,
		A2(
			$elm$core$List$cons,
			A2($elm$http$Http$filePart, 'fichier', requete.gw),
			A2(
				$elm$core$List$cons,
				A2($elm$http$Http$stringPart, 'ligneDEnTete', '1'),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$http$Http$stringPart,
						'colonne',
						$elm$core$String$fromInt(demande.j_)),
					_Utils_ap(
						A2(texte, 'feuille', demande.mx),
						_Utils_ap(
							A2(
								texte,
								'domaine',
								A2($elm$core$Maybe$map, $elm$core$Tuple$first, demande.vf)),
							_Utils_ap(
								A2(
									texte,
									'type',
									A2($elm$core$Maybe$map, $elm$core$Tuple$second, demande.vf)),
								_Utils_ap(
									A2(texte, 'champ', demande.uN),
									_Utils_ap(
										A2(texte, 'formatDeDate', demande.zQ),
										_Utils_ap(
											A2(texte, 'separateurDecimal', demande.IH),
											_Utils_ap(
												A2(texte, 'separateurDeListe', demande.IG),
												_Utils_ap(
													A2(texte, 'uniteDeLaColonne', demande.Ka),
													A2(texte, 'langue', demande.nn)))))))))))));
};
var $author$project$Components$Referentiel$NouvelleFiche$API$HttpAPI$lesFormesReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Referentiel$Fiche$API$HttpAPI$lireFicheReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Produits$StructureCatalogue$API$HttpAPI$lireLaStructureReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Produits$Common$API$HttpAPI$lireLeCodeProposeReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				$elm$json$Json$Encode$object(
					_Utils_ap(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'valeurs',
								A2($elm$json$Json$Encode$list, $author$project$Catalogue$API$WriteAPIModel$encodeValeurDuDessus, requete.Ki)),
								_Utils_Tuple2(
								'attributs',
								$author$project$Catalogue$API$WriteAPIModel$encodeAttributs(requete.i8))
							]),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (typologie) {
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'typologie',
											$author$project$Catalogue$Identifiants$classificationIdEncode(typologie))
										]);
								},
								requete.r3))))),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Produits$Common$API$HttpAPI$lireLeSchemaEffectifReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				$elm$json$Json$Encode$object(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'valeurs',
							A2($elm$json$Json$Encode$list, $author$project$Catalogue$API$WriteAPIModel$encodeValeurDuDessus, requete.Ki)),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (typologie) {
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'typologie',
											$author$project$Catalogue$Identifiants$classificationIdEncode(typologie))
										]);
								},
								requete.r3))))),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Referentiel$NouvelleFiche$API$HttpAPI$lireLesOffresReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Parametrage$Pipes$API$HttpAPI$lireLesPipesReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Referentiel$PartiesPrenantes$API$HttpAPI$lireLesPreferencesReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Referentiel$PartiesPrenantes$API$HttpAPI$lireLesTypesReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Referentiel$Fiche$API$HttpAPI$lirePostesReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Referentiel$NouvelleFiche$API$HttpAPI$lirePostesReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Accueil$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Comptes$MonCompte$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Comptes$Securite$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Imports$Outil$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Notifications$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Parametrage$CollectionsDeChamps$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Parametrage$CompteDEnvoi$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Parametrage$CompteurDeCode$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Parametrage$Conservation$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Parametrage$Droits$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Parametrage$LanguesDuClient$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Parametrage$ModelesDeTache$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Parametrage$PipeEtape1$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Parametrage$PipeEtape2$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Parametrage$PipeEtape3$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Parametrage$PipeEtape4$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Parametrage$PipeEtape5$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Parametrage$PipeEtape6$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Parametrage$PipeEtape7$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Parametrage$PipeEtape8$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Parametrage$PipeVersions$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Parametrage$Utilisateurs$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Produits$Alertes$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Produits$Common$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Produits$Correspondances$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Produits$Listes$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Produits$Perimetres$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Produits$TypesDeQuantite$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Referentiel$Alertes$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Referentiel$Common$API$Groupes$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Referentiel$Common$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Referentiel$Doublons$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Referentiel$Formes$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Referentiel$Fusion$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Referentiel$NouvelleFiche$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Referentiel$Postes$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Referentiel$TypesDeRelation$API$HttpAPI$lireReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Socle$Session$API$HttpAPI$lireReq = function (lecture) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: lecture.gM, aQ: lecture.aQ, sm: 'GET'});
};
var $author$project$Components$Socle$Theme$API$HttpAPI$lireThemeReq = function (requete) {
	return $elm$http$Http$request(
		{
			dr: $elm$http$Http$emptyBody,
			dU: $elm$http$Http$expectString($elm$core$Basics$identity),
			d$: _List_Nil,
			eg: 'GET',
			fb: $elm$core$Maybe$Just(requete.w4),
			fe: $elm$core$Maybe$Nothing,
			aQ: requete.aQ
		});
};
var $author$project$Components$Referentiel$Fiche$API$HttpAPI$lireTypesDeRelationReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Referentiel$NouvelleFiche$API$HttpAPI$lireTypesReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{f$: $elm$core$Maybe$Nothing, gM: requete.gM, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $elm$core$Platform$Cmd$map = _Platform_map;
var $elm$file$File$mime = _File_mime;
var $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$modification = function (fournie) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'champ',
				$elm$json$Json$Encode$string(fournie.uN)),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (valeur) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'valeur',
								$elm$json$Json$Encode$string(valeur))
							]);
					},
					fournie.fm))));
};
var $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$encodeModifierDesChamps = F4(
	function (processUid, entite, version, modifications) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
					_Utils_Tuple2(
					'entite',
					$elm$json$Json$Encode$string(
						$author$project$Components$Referentiel$Identifiants$entiteUidToString(entite))),
					_Utils_Tuple2(
					'version',
					$elm$json$Json$Encode$int(version)),
					_Utils_Tuple2(
					'modifications',
					A2($elm$json$Json$Encode$list, $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$modification, modifications))
				]));
	});
var $author$project$Components$Referentiel$Fiche$API$HttpAPI$modifierDesChampsReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A4($author$project$Components$Referentiel$Fiche$API$WriteAPIModel$encodeModifierDesChamps, requete.Gn, requete.yt, requete.sq, requete.g$)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$encodeModifierLeBloc = F5(
	function (processUid, entite, version, type_, champs) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
					_Utils_Tuple2(
					'entite',
					$elm$json$Json$Encode$string(
						$author$project$Components$Referentiel$Identifiants$entiteUidToString(entite))),
					_Utils_Tuple2(
					'version',
					$elm$json$Json$Encode$int(version)),
					_Utils_Tuple2(
					'champsDesTypes',
					A2(
						$elm$json$Json$Encode$list,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'type',
										$author$project$Components$Referentiel$Identifiants$typeUidEncode(type_)),
										_Utils_Tuple2(
										'champs',
										A2(
											$elm$json$Json$Encode$list,
											function (_v0) {
												var cle = _v0.a;
												var valeur = _v0.b;
												return $elm$json$Json$Encode$object(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'cle',
															$elm$json$Json$Encode$string(cle)),
															_Utils_Tuple2(
															'valeur',
															$author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$encode(valeur))
														]));
											},
											champs))
									]))
							])))
				]));
	});
var $author$project$Components$Referentiel$Fiche$API$HttpAPI$modifierLeBlocReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A5($author$project$Components$Referentiel$Fiche$API$WriteAPIModel$encodeModifierLeBloc, requete.Gn, requete.yt, requete.sq, requete.r0, requete.dw)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $elm$file$File$name = _File_name;
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Components$Socle$Session$Update$AccesDesactiveConstate = function (a) {
	return {$: 13, a: a};
};
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $author$project$Components$Socle$Session$API$QueryAPIModel$codesDErreur = function (corps) {
	return A2(
		$elm$core$Result$withDefault,
		_List_Nil,
		A2(
			$elm$core$Result$map,
			$elm$core$List$map($elm$core$Tuple$first),
			A2(
				$elm$json$Json$Decode$decodeString,
				A2(
					$elm$json$Json$Decode$field,
					'error',
					$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value)),
				corps)));
};
var $author$project$Components$Socle$Session$Update$accesDesactive = function (reponse) {
	return (reponse.ri === 403) && A2(
		$elm$core$List$member,
		'AccesDesactive',
		$author$project$Components$Socle$Session$API$QueryAPIModel$codesDErreur(reponse.f$));
};
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Socle$Session$Update$espaceDesactive = function (reponse) {
	return $elm$core$Result$toMaybe(
		A2(
			$elm$json$Json$Decode$decodeString,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['error', 'AccesDesactive', 'nomDuClient']),
				$elm$json$Json$Decode$string),
			reponse.f$));
};
var $author$project$Main$parLaSession = F2(
	function (versLEcran, reponse) {
		return $author$project$Components$Socle$Session$Update$accesDesactive(reponse) ? $author$project$Main$Update$SessionMsg(
			$author$project$Components$Socle$Session$Update$AccesDesactiveConstate(
				$author$project$Components$Socle$Session$Update$espaceDesactive(reponse))) : versLEcran(reponse);
	});
var $author$project$Ports$poserFavicon = _Platform_outgoingPort('poserFavicon', $elm$json$Json$Encode$string);
var $author$project$API$Requete$authentifieeEnOctets = function (requete) {
	return $elm$http$Http$request(
		{
			dr: A2($elm$http$Http$bytesBody, 'application/octet-stream', requete.oW),
			dU: A2(
				$elm$http$Http$expectStringResponse,
				$elm$core$Result$withDefault($author$project$API$Requete$sansReponse),
				A2($elm$core$Basics$composeR, $author$project$API$Requete$reponse, $elm$core$Result$Ok)),
			d$: _List_fromArray(
				[
					A2($elm$http$Http$header, 'Authorization', 'Bearer ' + requete.gM)
				]),
			eg: requete.sm,
			fb: $elm$core$Maybe$Nothing,
			fe: $elm$core$Maybe$Nothing,
			aQ: requete.aQ
		});
};
var $author$project$Components$Produits$Common$API$HttpAPI$poserUnMorceauReq = function (requete) {
	return $author$project$API$Requete$authentifieeEnOctets(
		{gM: requete.gM, oW: requete.oW, aQ: requete.nB.cM, sm: requete.nB.sm});
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeProgrammerLEffacement = F4(
	function (processUid, entite, motif, precision) {
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'processUid',
						$author$project$API$ProcessUid$encode(processUid)),
						_Utils_Tuple2(
						'entite',
						$elm$json$Json$Encode$string(
							$author$project$Components$Referentiel$Identifiants$entiteUidToString(entite))),
						_Utils_Tuple2(
						'motif',
						$elm$json$Json$Encode$string(motif))
					]),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (texte) {
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'precision',
									$elm$json$Json$Encode$string(texte))
								]);
						},
						precision))));
	});
var $author$project$Components$Referentiel$Fiche$API$HttpAPI$programmerLEffacementReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A4($author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeProgrammerLEffacement, requete.Gn, requete.yt, requete.cX, requete.Gd)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Produits$Common$API$HttpAPI$proposerLesCategoriesReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'valeurs',
							A2($elm$json$Json$Encode$list, $author$project$Catalogue$API$WriteAPIModel$encodeValeurDuDessus, requete.Ki))
						]))),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Produits$Common$API$HttpAPI$proposerLesPartiesPrenantesReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				$elm$json$Json$Encode$object(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'typeVise',
							$elm$json$Json$Encode$string(requete.r$)),
						($elm$core$String$trim(requete.h3) === '') ? _List_Nil : _List_fromArray(
							[
								_Utils_Tuple2(
								'terme',
								$elm$json$Json$Encode$string(requete.h3))
							])))),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$Components$Imports$Outil$API$WriteAPIModel$encoderLesEnTetes = function (enTetes) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'enTetes',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, enTetes))
			]));
};
var $author$project$Components$Imports$Outil$API$HttpAPI$reappliquerReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				$author$project$Components$Imports$Outil$API$WriteAPIModel$encoderLesEnTetes(requete.ym)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Produits$Common$API$HttpAPI$rechercherReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				$author$project$Catalogue$API$QueryAPIModel$encodeRecherche(requete.hC)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$encodeRelierLEtablissement = F2(
	function (processUid, relation) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$author$project$API$ProcessUid$encode(processUid)),
					_Utils_Tuple2(
					'entite',
					$elm$json$Json$Encode$string(
						$author$project$Components$Referentiel$Identifiants$entiteUidToString(relation.yt))),
					_Utils_Tuple2(
					'cible',
					$elm$json$Json$Encode$string(
						$author$project$Components$Referentiel$Identifiants$entiteUidToString(relation.vf))),
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string(
						$author$project$Components$Referentiel$Identifiants$typeRelationUidToString(relation.r0))),
					_Utils_Tuple2(
					'sens',
					$elm$json$Json$Encode$string('Direct'))
				]));
	});
var $author$project$Components$Referentiel$NouvelleFiche$API$HttpAPI$relierLEtablissementReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				A2($author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$encodeRelierLEtablissement, requete.Gn, requete.Ht)),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Components$Socle$Session$API$HttpAPI$renouvelerReq = function (demande) {
	return $elm$http$Http$post(
		{
			dr: A2(
				$elm$http$Http$stringBody,
				'application/x-www-form-urlencoded',
				A2(
					$elm$core$String$dropLeft,
					1,
					$elm$url$Url$Builder$toQuery(
						_List_fromArray(
							[
								A2($elm$url$Url$Builder$string, 'grant_type', 'refresh_token'),
								A2($elm$url$Url$Builder$string, 'client_id', demande.jW),
								A2($elm$url$Url$Builder$string, 'refresh_token', demande.gM),
								A2($elm$url$Url$Builder$string, 'scope', demande.Is)
							])))),
			dU: $elm$http$Http$expectString($elm$core$Basics$identity),
			aQ: demande.aQ
		});
};
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $author$project$Components$Referentiel$NouvelleFiche$API$HttpAPI$restaurerLaFicheReq = F2(
	function (restauration, jeton) {
		return $author$project$API$Requete$authentifiee(
			{
				f$: $elm$core$Maybe$Just(
					A2($author$project$Components$Referentiel$Common$API$WriteAPIModel$encodeGesteSurLaFiche, restauration.Gn, restauration.zo)),
				gM: jeton,
				aQ: restauration.nB.cM,
				sm: restauration.nB.sm
			});
	});
var $author$project$Components$Referentiel$Doublons$API$HttpAPI$rouvrirReq = function (requete) {
	return $author$project$API$Requete$authentifiee(
		{
			f$: $elm$core$Maybe$Just(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'processUid',
							$author$project$API$ProcessUid$encode(requete.Gn)),
							_Utils_Tuple2(
							'fiche',
							$elm$json$Json$Encode$string(
								$author$project$Components$Referentiel$Identifiants$entiteUidToString(requete.zo))),
							_Utils_Tuple2(
							'autre',
							$elm$json$Json$Encode$string(
								$author$project$Components$Referentiel$Identifiants$entiteUidToString(requete.t3)))
						]))),
			gM: requete.gM,
			aQ: requete.nB.cM,
			sm: requete.nB.sm
		});
};
var $author$project$Ports$signalerErreur = _Platform_outgoingPort('signalerErreur', $elm$json$Json$Encode$string);
var $elm$file$File$size = _File_size;
var $elm$core$Process$sleep = _Process_sleep;
var $elm$file$File$Download$string = F3(
	function (name, mime, content) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$never,
			A3(_File_download, name, mime, content));
	});
var $elm$file$File$toBytes = _File_toBytes;
var $author$project$Components$Imports$Outil$API$HttpAPI$valeursReq = function (requete) {
	var texte = F2(
		function (nom, valeur) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (v) {
						return _List_fromArray(
							[
								A2($elm$http$Http$stringPart, nom, v)
							]);
					},
					valeur));
		});
	var demande = requete.kC;
	return A3(
		$author$project$Components$Imports$Outil$API$HttpAPI$multipart,
		requete.gM,
		requete.nB,
		A2(
			$elm$core$List$cons,
			A2($elm$http$Http$filePart, 'fichier', requete.gw),
			A2(
				$elm$core$List$cons,
				A2($elm$http$Http$stringPart, 'ligneDEnTete', '1'),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$http$Http$stringPart,
						'colonne',
						$elm$core$String$fromInt(demande.j_)),
					_Utils_ap(
						A2(texte, 'feuille', demande.mx),
						_Utils_ap(
							A2(
								texte,
								'domaine',
								A2($elm$core$Maybe$map, $elm$core$Tuple$first, demande.vf)),
							_Utils_ap(
								A2(
									texte,
									'type',
									A2($elm$core$Maybe$map, $elm$core$Tuple$second, demande.vf)),
								_Utils_ap(
									A2(texte, 'champ', demande.uN),
									A2(texte, 'separateur', demande.IF)))))))));
};
var $author$project$Main$versLesCategories = A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Update$DesCategories, $author$project$Main$Update$StructureCatalogueMsg);
var $author$project$Main$versLesGammes = A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Update$DesGammes, $author$project$Main$Update$StructureCatalogueMsg);
var $author$project$Main$versLesMarques = A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Update$DesMarques, $author$project$Main$Update$StructureCatalogueMsg);
var $author$project$Main$versLesProduits = A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Update$DesProduits, $author$project$Main$Update$StructureCatalogueMsg);
var $author$project$Main$executer = F2(
	function (key, effet) {
		var i18n = $author$project$I18n$Traductions$francais;
		switch (effet.$) {
			case 0:
				var adresse = effet.a;
				return A2($elm$browser$Browser$Navigation$pushUrl, key, adresse);
			case 2:
				var adresse = effet.a;
				return $elm$browser$Browser$Navigation$load(adresse);
			case 3:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $author$project$Main$Update$ThemeMsg),
					$author$project$Components$Socle$Theme$API$HttpAPI$lireThemeReq(requete));
			case 4:
				var incident = effet.a;
				return $author$project$Ports$signalerErreur(
					A2($author$project$Components$Socle$Theme$View$incident, i18n, incident));
			case 5:
				var adresse = effet.a;
				return $author$project$Ports$poserFavicon(adresse);
			case 6:
				var cible = effet.a;
				return A2(
					$elm$core$Task$attempt,
					function (_v1) {
						return $author$project$Main$Update$FocusPlace;
					},
					$elm$browser$Browser$Dom$focus(cible));
			case 7:
				return A2(
					$elm$core$Task$perform,
					function (vue) {
						return $author$project$Main$Update$FicheMsg(
							$author$project$Components$Referentiel$Fiche$Update$DefilementLu(
								{Ad: vue.su.KZ, Ae: vue.Iq.m3, KR: vue.su.m3}));
					},
					$elm$browser$Browser$Dom$getViewport);
			case 8:
				var preferences = effet.a;
				return $author$project$Ports$ecrirePreferences(
					$author$project$Preferences$Model$encode(preferences));
			case 9:
				var nombre = effet.a;
				return $author$project$Ports$demanderAlea(nombre);
			case 10:
				var depart = effet.a;
				return $author$project$Ports$garderParcoursEtPartir(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'parcours',
								$author$project$Components$Socle$Session$Model$encoderParcours(depart.ex)),
								_Utils_Tuple2(
								'adresse',
								$elm$json$Json$Encode$string(depart.aa))
							])));
			case 11:
				var echange = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Socle$Session$Update$JetonRecu, $author$project$Main$Update$SessionMsg),
					$author$project$Components$Socle$Session$API$HttpAPI$echangerCodeReq(echange));
			case 12:
				return A2(
					$elm$core$Task$perform,
					A2($elm$core$Basics$composeR, $author$project$Components$Socle$Session$Update$HeureLue, $author$project$Main$Update$SessionMsg),
					$elm$time$Time$now);
			case 13:
				var demande = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Socle$Session$Update$JetonRenouvele, $author$project$Main$Update$SessionMsg),
					$author$project$Components$Socle$Session$API$HttpAPI$renouvelerReq(demande));
			case 14:
				var lecture = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Socle$Session$Update$RacineRecue, $author$project$Main$Update$SessionMsg)),
					$author$project$Components$Socle$Session$API$HttpAPI$lireReq(lecture));
			case 16:
				var lecture = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Socle$Session$Update$PreferencesRecues, $author$project$Main$Update$SessionMsg)),
					$author$project$Components$Socle$Session$API$HttpAPI$lireReq(lecture));
			case 17:
				var lecture = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Socle$Session$Update$TraductionsRecues(lecture.nn),
							$author$project$Main$Update$SessionMsg)),
					$author$project$Components$Socle$Session$API$HttpAPI$lireReq(
						{gM: lecture.gM, aQ: lecture.aQ}));
			case 15:
				var lecture = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Socle$Session$Update$EspacesRecus, $author$project$Main$Update$SessionMsg),
					$author$project$Components$Socle$Session$API$HttpAPI$lireReq(lecture));
			case 18:
				var adresse = effet.a;
				return A2($elm$browser$Browser$Navigation$replaceUrl, key, adresse);
			case 19:
				var incident = effet.a;
				return $author$project$Ports$signalerErreur(
					A2($author$project$Components$Socle$Session$View$incident, i18n, incident));
			case 20:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$NouvelleFiche$Update$TypesRecus, $author$project$Main$Update$NouvelleFicheMsg)),
					$author$project$Components$Referentiel$NouvelleFiche$API$HttpAPI$lireTypesReq(requete));
			case 21:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$NouvelleFiche$Update$OffresRecues, $author$project$Main$Update$NouvelleFicheMsg)),
					$author$project$Components$Referentiel$NouvelleFiche$API$HttpAPI$lireLesOffresReq(requete));
			case 22:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Referentiel$Fiche$Update$BlocRendu(requete.yt),
							$author$project$Main$Update$FicheMsg)),
					$author$project$Components$Referentiel$Fiche$API$HttpAPI$modifierLeBlocReq(
						{dw: requete.dw, yt: requete.yt, gM: requete.gM, nB: requete.nB, Gn: requete.Gn, r0: requete.r0, sq: requete.sq}));
			case 23:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Referentiel$Fiche$Update$OccurrenceRendue(requete.yt),
							$author$project$Main$Update$FicheMsg)),
					$author$project$Components$Referentiel$Fiche$API$HttpAPI$gererUneOccurrenceReq(
						{yt: requete.yt, mW: requete.mW, gM: requete.gM, nB: requete.nB, Gn: requete.Gn}));
			case 24:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$NouvelleFiche$Update$FicheCreee, $author$project$Main$Update$NouvelleFicheMsg)),
					$author$project$Components$Referentiel$NouvelleFiche$API$HttpAPI$creerLaFicheReq(requete));
			case 26:
				var demande = effet.a;
				var _v2 = demande.lO;
				switch (_v2.$) {
					case 1:
						var place = _v2.a;
						var lien = _v2.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2(
									$elm$core$Basics$composeR,
									$author$project$Components$Referentiel$Fusion$Update$FicheLue(
										(place === 1) ? 0 : 1),
									$author$project$Main$Update$FusionMsg)),
							$author$project$Components$Referentiel$Fusion$API$HttpAPI$lireReq(
								{gM: demande.gM, nB: lien}));
					case 2:
						var lien = _v2.a;
						var terme = _v2.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2(
									$elm$core$Basics$composeR,
									$author$project$Components$Referentiel$Fusion$Update$PropositionsLues(terme),
									$author$project$Main$Update$FusionMsg)),
							$author$project$Components$Referentiel$Fusion$API$HttpAPI$chercherReq(
								{gM: demande.gM, nB: lien, h3: terme}));
					case 3:
						var lien = _v2.a;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Fusion$Update$ApercuLu, $author$project$Main$Update$FusionMsg)),
							$author$project$Components$Referentiel$Fusion$API$HttpAPI$lireReq(
								{gM: demande.gM, nB: lien}));
					case 4:
						var lien = _v2.a;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Fusion$Update$AvancementLu, $author$project$Main$Update$FusionMsg)),
							$author$project$Components$Referentiel$Fusion$API$HttpAPI$lireReq(
								{gM: demande.gM, nB: lien}));
					case 5:
						var saisie = _v2.a;
						var delaiMs = _v2.b;
						return A2(
							$elm$core$Task$perform,
							function (_v3) {
								return $author$project$Main$Update$FusionMsg(
									$author$project$Components$Referentiel$Fusion$Update$DelaiDeRechercheEcoule(saisie));
							},
							$elm$core$Process$sleep(delaiMs));
					case 6:
						var lien = _v2.a;
						var commande = _v2.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Fusion$Update$FusionRepondue, $author$project$Main$Update$FusionMsg)),
							$author$project$Components$Referentiel$Fusion$API$HttpAPI$fusionnerReq(
								{sK: commande.sK, dw: commande.dw, z$: commande.z$, z5: commande.z5, gM: demande.gM, nB: lien}));
					default:
						return $elm$core$Platform$Cmd$none;
				}
			case 25:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Referentiel$Fiche$Update$FicheLue(requete.r8),
							$author$project$Main$Update$FicheMsg)),
					$author$project$Components$Referentiel$Fiche$API$HttpAPI$lireFicheReq(
						{gM: requete.gM, nB: requete.nB}));
			case 28:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Referentiel$Fiche$Update$ModificationRendue(requete.yt),
							$author$project$Main$Update$FicheMsg)),
					$author$project$Components$Referentiel$Fiche$API$HttpAPI$modifierDesChampsReq(
						{yt: requete.yt, gM: requete.gM, nB: requete.nB, g$: requete.g$, Gn: requete.Gn, sq: requete.sq}));
			case 30:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Referentiel$Fiche$Update$CommandeDeContactRendue(requete.yt),
							$author$project$Main$Update$FicheMsg)),
					$author$project$Components$Referentiel$Fiche$API$HttpAPI$envoyerAuContactReq(requete));
			case 31:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Referentiel$Fiche$Update$CommandeDeRoleRendue(requete.yt),
							$author$project$Main$Update$FicheMsg)),
					$author$project$Components$Referentiel$Fiche$API$HttpAPI$envoyerAuRoleReq(requete));
			case 32:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Fiche$Update$TypesLus, $author$project$Main$Update$FicheMsg)),
					$author$project$Components$Referentiel$Fiche$API$HttpAPI$lireFicheReq(requete));
			case 33:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Fiche$Update$OffresLues, $author$project$Main$Update$FicheMsg)),
					$author$project$Components$Referentiel$Fiche$API$HttpAPI$lireFicheReq(requete));
			case 34:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Referentiel$Fiche$Update$GesteRendu(requete.yt),
							$author$project$Main$Update$FicheMsg)),
					$author$project$Components$Referentiel$Fiche$API$HttpAPI$envoyerUnGesteReq(requete));
			case 35:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Referentiel$Fiche$Update$GesteRendu(requete.yt),
							$author$project$Main$Update$FicheMsg)),
					$author$project$Components$Referentiel$Fiche$API$HttpAPI$cloreLaFicheReq(requete));
			case 38:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Referentiel$Fiche$Update$ApercuDeLEffacementLu(requete.yt),
							$author$project$Main$Update$FicheMsg)),
					$author$project$Components$Referentiel$Fiche$API$HttpAPI$lireFicheReq(
						{gM: requete.gM, nB: requete.nB}));
			case 39:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Referentiel$Fiche$Update$ExportRendu(requete.yt),
							$author$project$Main$Update$FicheMsg)),
					$author$project$Components$Referentiel$Fiche$API$HttpAPI$exporterLesDonneesReq(requete));
			case 40:
				var fichiers = effet.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						function (fichier) {
							return A3($elm$file$File$Download$string, fichier.Dj, fichier.r0, fichier.fZ);
						},
						fichiers));
			case 42:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Referentiel$Fiche$Update$EffacementRendu(requete.yt),
							$author$project$Main$Update$FicheMsg)),
					$author$project$Components$Referentiel$Fiche$API$HttpAPI$programmerLEffacementReq(requete));
			case 41:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Referentiel$Fiche$Update$EffacementRendu(requete.yt),
							$author$project$Main$Update$FicheMsg)),
					$author$project$Components$Referentiel$Fiche$API$HttpAPI$effacerUnContactReq(requete));
			case 36:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Referentiel$Fiche$Update$ApercuDeLaClotureLu(requete.yt),
							$author$project$Main$Update$FicheMsg)),
					$author$project$Components$Referentiel$Fiche$API$HttpAPI$lireFicheReq(
						{gM: requete.gM, nB: requete.nB}));
			case 37:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							A2($author$project$Components$Referentiel$Fiche$Update$ApercuDeLExportLu, requete.yt, requete.kC),
							$author$project$Main$Update$FicheMsg)),
					$author$project$Components$Referentiel$Fiche$API$HttpAPI$lireFicheReq(
						{gM: requete.gM, nB: requete.nB}));
			case 43:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Referentiel$Fiche$Update$LiaisonRendue(requete.zo),
							$author$project$Main$Update$FicheMsg)),
					$author$project$Components$Referentiel$Fiche$API$HttpAPI$envoyerALaLiaisonReq(
						{vJ: requete.vJ, yt: requete.yt, gM: requete.gM, nB: requete.nB, Gn: requete.Gn}));
			case 44:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Fiche$Update$PostesLus, $author$project$Main$Update$FicheMsg)),
					$author$project$Components$Referentiel$Fiche$API$HttpAPI$lirePostesReq(requete));
			case 46:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Referentiel$Fiche$Update$DoublonRecu(requete.DX),
							$author$project$Main$Update$FicheMsg)),
					$author$project$Components$Referentiel$Fiche$API$HttpAPI$chercherUnDoublonReq(
						{gM: requete.gM, nB: requete.nB, ho: requete.ho, fm: requete.fm}));
			case 45:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Fiche$Update$FormesLues, $author$project$Main$Update$FicheMsg)),
					$author$project$Components$Referentiel$Fiche$API$HttpAPI$lirePostesReq(requete));
			case 50:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Fiche$Update$TypesDeRelationLus, $author$project$Main$Update$FicheMsg)),
					$author$project$Components$Referentiel$Fiche$API$HttpAPI$lireTypesDeRelationReq(requete));
			case 47:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Referentiel$Fiche$Update$PropositionsLues(
							A2($elm$core$Maybe$withDefault, '', requete.hC.h3)),
						$author$project$Main$Update$FicheMsg),
					$author$project$Components$Referentiel$Fiche$API$HttpAPI$chercherDesFichesReq(requete));
			case 48:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Referentiel$Common$ChoixDeLien$Recue(requete.kC.DX),
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Fiche$Update$LienDeChamp, $author$project$Main$Update$FicheMsg)),
					$author$project$Components$Referentiel$Common$API$HttpAPI$chercherDesNommeesReq(requete));
			case 49:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Referentiel$Common$ChoixDeLien$Recue(requete.kC.DX),
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$NouvelleFiche$Update$LienDeChamp, $author$project$Main$Update$NouvelleFicheMsg)),
					$author$project$Components$Referentiel$Common$API$HttpAPI$chercherDesNommeesReq(requete));
			case 51:
				var saisie = effet.a;
				var delaiMs = effet.b;
				return A2(
					$elm$core$Task$perform,
					function (_v4) {
						return $author$project$Main$Update$FicheMsg(
							$author$project$Components$Referentiel$Fiche$Update$DelaiDeRechercheEcoule(saisie));
					},
					$elm$core$Process$sleep(delaiMs));
			case 52:
				var numero = effet.a;
				var delaiMs = effet.b;
				return A2(
					$elm$core$Task$perform,
					function (_v5) {
						return $author$project$Main$Update$FicheMsg(
							$author$project$Components$Referentiel$Fiche$Update$DelaiDeDoublonEcoule(numero));
					},
					$elm$core$Process$sleep(delaiMs));
			case 53:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							A2($author$project$Components$Referentiel$Fiche$Update$ChronologieLue, requete.r8, requete.np),
							$author$project$Main$Update$FicheMsg)),
					$author$project$Components$Referentiel$Fiche$API$HttpAPI$lireFicheReq(
						{gM: requete.gM, nB: requete.nB}));
			case 54:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							A2($author$project$Components$Referentiel$Fiche$Update$HistoriqueDuChampLu, requete.r8, requete.np),
							$author$project$Main$Update$FicheMsg)),
					$author$project$Components$Referentiel$Fiche$API$HttpAPI$lireFicheReq(
						{gM: requete.gM, nB: requete.nB}));
			case 55:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Referentiel$NouvelleFiche$Update$FicheRejoueeLue(requete.r8),
							$author$project$Main$Update$NouvelleFicheMsg)),
					$author$project$Components$Referentiel$Fiche$API$HttpAPI$lireFicheReq(
						{gM: requete.gM, nB: requete.nB}));
			case 56:
				var uid = effet.a;
				var delaiMs = effet.b;
				return A2(
					$elm$core$Task$perform,
					function (_v6) {
						return $author$project$Main$Update$NouvelleFicheMsg(
							$author$project$Components$Referentiel$NouvelleFiche$Update$DelaiDeRelectureEcoule(uid));
					},
					$elm$core$Process$sleep(delaiMs));
			case 58:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$PartiesPrenantes$Update$TypesLus, $author$project$Main$Update$PartiesPrenantesMsg)),
					$author$project$Components$Referentiel$PartiesPrenantes$API$HttpAPI$lireLesTypesReq(requete));
			case 59:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$PartiesPrenantes$Update$GroupesLus, $author$project$Main$Update$PartiesPrenantesMsg)),
					$author$project$Components$Referentiel$Common$API$Groupes$HttpAPI$lireReq(requete));
			case 60:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$PartiesPrenantes$Update$GroupeChoisiLu, $author$project$Main$Update$PartiesPrenantesMsg)),
					$author$project$Components$Referentiel$Common$API$Groupes$HttpAPI$lireReq(requete));
			case 61:
				var etape = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Referentiel$PartiesPrenantes$Update$EquipeLue(etape),
							$author$project$Main$Update$PartiesPrenantesMsg)),
					$author$project$Components$Referentiel$Common$API$Groupes$HttpAPI$lireReq(requete));
			case 62:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$PartiesPrenantes$Update$CommandeDeGroupeRepondue, $author$project$Main$Update$PartiesPrenantesMsg)),
					$author$project$Components$Referentiel$Common$API$Groupes$HttpAPI$envoyerReq(requete));
			case 63:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$PartiesPrenantes$Update$PreferencesLues, $author$project$Main$Update$PartiesPrenantesMsg)),
					$author$project$Components$Referentiel$PartiesPrenantes$API$HttpAPI$lireLesPreferencesReq(requete));
			case 64:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$PartiesPrenantes$Update$PreferencesEnregistrees, $author$project$Main$Update$PartiesPrenantesMsg)),
					$author$project$Components$Referentiel$PartiesPrenantes$API$HttpAPI$enregistrerLesPreferencesReq(requete));
			case 57:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Referentiel$PartiesPrenantes$Update$ListeLue(requete.np),
							$author$project$Main$Update$PartiesPrenantesMsg)),
					$author$project$Components$Referentiel$PartiesPrenantes$API$HttpAPI$chercherLesFichesReq(
						{gM: requete.gM, nB: requete.nB, hC: requete.hC}));
			case 65:
				var saisie = effet.a;
				var delaiMs = effet.b;
				return A2(
					$elm$core$Task$perform,
					function (_v7) {
						return $author$project$Main$Update$PartiesPrenantesMsg(
							$author$project$Components$Referentiel$PartiesPrenantes$Update$DelaiDeSaisieEcoule(saisie));
					},
					$elm$core$Process$sleep(delaiMs));
			case 66:
				var saisie = effet.a;
				var delaiMs = effet.b;
				return A2(
					$elm$core$Task$perform,
					function (_v8) {
						return $author$project$Main$Update$NouvelleFicheMsg(
							$author$project$Components$Referentiel$NouvelleFiche$Update$DelaiDeRechercheEcoule(saisie));
					},
					$elm$core$Process$sleep(delaiMs));
			case 68:
				var ajout = effet.a;
				var jeton = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Referentiel$NouvelleFiche$Update$RoleAjoute(ajout.zo),
							$author$project$Main$Update$NouvelleFicheMsg)),
					A2($author$project$Components$Referentiel$NouvelleFiche$API$HttpAPI$ajouterLeRoleReq, ajout, jeton));
			case 70:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$NouvelleFiche$Update$TypesDeRelationLues, $author$project$Main$Update$NouvelleFicheMsg)),
					$author$project$Components$Referentiel$NouvelleFiche$API$HttpAPI$lireReq(requete));
			case 71:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$NouvelleFiche$Update$FicheCreeeLue, $author$project$Main$Update$NouvelleFicheMsg)),
					$author$project$Components$Referentiel$NouvelleFiche$API$HttpAPI$lireReq(requete));
			case 72:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$NouvelleFiche$Update$EtablissementRelie, $author$project$Main$Update$NouvelleFicheMsg)),
					$author$project$Components$Referentiel$NouvelleFiche$API$HttpAPI$relierLEtablissementReq(requete));
			case 69:
				var restauration = effet.a;
				var jeton = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Referentiel$NouvelleFiche$Update$FicheRestauree(restauration.zo),
							$author$project$Main$Update$NouvelleFicheMsg)),
					A2($author$project$Components$Referentiel$NouvelleFiche$API$HttpAPI$restaurerLaFicheReq, restauration, jeton));
			case 67:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Referentiel$NouvelleFiche$Update$DoublonsRecus(requete.hP),
							$author$project$Main$Update$NouvelleFicheMsg)),
					$author$project$Components$Referentiel$NouvelleFiche$API$HttpAPI$chercherLesDoublonsReq(
						{wp: requete.wp, gM: requete.gM, nB: requete.nB}));
			case 73:
				var frappe = effet.a;
				var delaiMs = effet.b;
				return A2(
					$elm$core$Task$perform,
					function (_v9) {
						return $author$project$Main$Update$NouvelleFicheMsg(
							$author$project$Components$Referentiel$NouvelleFiche$Update$DelaiDOrganisationEcoule(frappe));
					},
					$elm$core$Process$sleep(delaiMs));
			case 74:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Referentiel$NouvelleFiche$Update$OrganisationsLues(
							A2($elm$core$Maybe$withDefault, '', requete.hC.h3)),
						$author$project$Main$Update$NouvelleFicheMsg),
					$author$project$Components$Referentiel$NouvelleFiche$API$HttpAPI$chercherLOrganisationReq(requete));
			case 77:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$NouvelleFiche$Update$FormesLues, $author$project$Main$Update$NouvelleFicheMsg)),
					$author$project$Components$Referentiel$NouvelleFiche$API$HttpAPI$lesFormesReq(requete));
			case 76:
				var etape = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Referentiel$NouvelleFiche$Update$EquipeLue(etape),
						$author$project$Main$Update$NouvelleFicheMsg),
					$author$project$Components$Referentiel$Common$API$Groupes$HttpAPI$lireReq(requete));
			case 75:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$NouvelleFiche$Update$PostesLus, $author$project$Main$Update$NouvelleFicheMsg)),
					$author$project$Components$Referentiel$NouvelleFiche$API$HttpAPI$lirePostesReq(requete));
			case 78:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Update$StructureLue, $author$project$Main$Update$StructureCatalogueMsg)),
					$author$project$Components$Produits$StructureCatalogue$API$HttpAPI$lireLaStructureReq(requete));
			case 80:
				var source = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Accueil$Update$Lue(source),
							$author$project$Main$Update$AccueilMsg)),
					$author$project$Components$Accueil$API$HttpAPI$lireReq(requete));
			case 79:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$Pipes$Update$PipesLus, $author$project$Main$Update$PipesMsg)),
					$author$project$Components$Parametrage$Pipes$API$HttpAPI$lireLesPipesReq(requete));
			case 81:
				var lecture = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Parametrage$PipeEtape1$Update$Lue(lecture),
							$author$project$Main$Update$PipeEtape1Msg)),
					$author$project$Components$Parametrage$PipeEtape1$API$HttpAPI$lireReq(requete));
			case 82:
				var lecture = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Parametrage$PipeEtape2$Update$Lue(lecture),
							$author$project$Main$Update$PipeEtape2Msg)),
					$author$project$Components$Parametrage$PipeEtape2$API$HttpAPI$lireReq(requete));
			case 83:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$PipeEtape2$Update$CommandeRepondue, $author$project$Main$Update$PipeEtape2Msg)),
					$author$project$Components$Parametrage$PipeEtape2$API$HttpAPI$envoyerReq(requete));
			case 84:
				var lecture = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Parametrage$PipeEtape3$Update$Lue(lecture),
							$author$project$Main$Update$PipeEtape3Msg)),
					$author$project$Components$Parametrage$PipeEtape3$API$HttpAPI$lireReq(requete));
			case 85:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$PipeEtape3$Update$CommandeRepondue, $author$project$Main$Update$PipeEtape3Msg)),
					$author$project$Components$Parametrage$PipeEtape3$API$HttpAPI$envoyerReq(requete));
			case 91:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$PipeEtape4$Update$CommandeRepondue, $author$project$Main$Update$PipeEtape4Msg)),
					$author$project$Components$Parametrage$PipeEtape4$API$HttpAPI$envoyerReq(requete));
			case 92:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$PipeEtape5$Update$CommandeRepondue, $author$project$Main$Update$PipeEtape5Msg)),
					$author$project$Components$Parametrage$PipeEtape5$API$HttpAPI$envoyerReq(requete));
			case 93:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$PipeEtape6$Update$CommandeRepondue, $author$project$Main$Update$PipeEtape6Msg)),
					$author$project$Components$Parametrage$PipeEtape6$API$HttpAPI$envoyerReq(requete));
			case 94:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$PipeEtape7$Update$CommandeRepondue, $author$project$Main$Update$PipeEtape7Msg)),
					$author$project$Components$Parametrage$PipeEtape7$API$HttpAPI$envoyerReq(requete));
			case 89:
				var lecture = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Parametrage$PipeEtape7$Update$Lue(lecture),
							$author$project$Main$Update$PipeEtape7Msg)),
					$author$project$Components$Parametrage$PipeEtape7$API$HttpAPI$lireReq(requete));
			case 95:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$PipeEtape8$Update$CommandeRepondue, $author$project$Main$Update$PipeEtape8Msg)),
					$author$project$Components$Parametrage$PipeEtape8$API$HttpAPI$envoyerReq(requete));
			case 90:
				var lecture = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Parametrage$PipeEtape8$Update$Lue(lecture),
							$author$project$Main$Update$PipeEtape8Msg)),
					$author$project$Components$Parametrage$PipeEtape8$API$HttpAPI$lireReq(requete));
			case 86:
				var lecture = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Parametrage$PipeEtape4$Update$Lue(lecture),
							$author$project$Main$Update$PipeEtape4Msg)),
					$author$project$Components$Parametrage$PipeEtape4$API$HttpAPI$lireReq(requete));
			case 87:
				var lecture = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Parametrage$PipeEtape5$Update$Lue(lecture),
							$author$project$Main$Update$PipeEtape5Msg)),
					$author$project$Components$Parametrage$PipeEtape5$API$HttpAPI$lireReq(requete));
			case 88:
				var lecture = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Parametrage$PipeEtape6$Update$Lue(lecture),
							$author$project$Main$Update$PipeEtape6Msg)),
					$author$project$Components$Parametrage$PipeEtape6$API$HttpAPI$lireReq(requete));
			case 98:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$ModelesDeTache$Update$CommandeRepondue, $author$project$Main$Update$ModelesDeTacheMsg),
					$author$project$Components$Parametrage$ModelesDeTache$API$HttpAPI$envoyerReq(requete));
			case 97:
				var lecture = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Parametrage$ModelesDeTache$Update$Lue(lecture),
						$author$project$Main$Update$ModelesDeTacheMsg),
					$author$project$Components$Parametrage$ModelesDeTache$API$HttpAPI$lireReq(requete));
			case 99:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$PipeVersions$Update$CommandeRepondue, $author$project$Main$Update$PipeVersionsMsg)),
					$author$project$Components$Parametrage$PipeVersions$API$HttpAPI$envoyerReq(requete));
			case 96:
				var lecture = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Parametrage$PipeVersions$Update$Lue(lecture),
							$author$project$Main$Update$PipeVersionsMsg)),
					$author$project$Components$Parametrage$PipeVersions$API$HttpAPI$lireReq(requete));
			case 100:
				var lecture = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Parametrage$PipeOffreUsage$Update$Lue(lecture),
							$author$project$Main$Update$PipeOffreUsageMsg)),
					$author$project$Components$Parametrage$PipeEtape1$API$HttpAPI$lireReq(requete));
			case 101:
				var lecture = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Parametrage$PipeDestinations$Update$Lue(lecture),
							$author$project$Main$Update$PipeDestinationsMsg)),
					$author$project$Components$Parametrage$PipeEtape1$API$HttpAPI$lireReq(requete));
			case 102:
				var lecture = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Parametrage$PipeRelationsExigees$Update$Lue(lecture),
							$author$project$Main$Update$PipeRelationsExigeesMsg)),
					$author$project$Components$Parametrage$PipeEtape1$API$HttpAPI$lireReq(requete));
			case 103:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$PipeEtape1$Update$CommandeRepondue, $author$project$Main$Update$PipeEtape1Msg)),
					$author$project$Components$Parametrage$PipeEtape1$API$HttpAPI$envoyerReq(requete));
			case 104:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Update$InformationsLues, $author$project$Main$Update$StructureCatalogueMsg)),
					$author$project$Components$Produits$StructureCatalogue$API$HttpAPI$lireLaStructureReq(requete));
			case 105:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Update$ListesLues, $author$project$Main$Update$StructureCatalogueMsg)),
					$author$project$Components$Produits$StructureCatalogue$API$HttpAPI$lireLaStructureReq(requete));
			case 106:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Update$BibliothequeLue, $author$project$Main$Update$StructureCatalogueMsg)),
					$author$project$Components$Produits$StructureCatalogue$API$HttpAPI$lireLaStructureReq(requete));
			case 107:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Parametrage$NouveauChamp$Update$ListesLues,
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Update$DuNouveauChamp, $author$project$Main$Update$StructureCatalogueMsg)),
					$author$project$Components$Produits$StructureCatalogue$API$HttpAPI$lireLaStructureReq(requete));
			case 108:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Parametrage$NouveauChamp$Update$CommandeRepondue,
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Update$DuNouveauChamp, $author$project$Main$Update$StructureCatalogueMsg)),
					$author$project$Components$Parametrage$BibliothequeDeChamps$API$HttpAPI$envoyerReq(requete));
			case 109:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Update$CategorieLue, $author$project$Main$Update$StructureCatalogueMsg)),
					$author$project$Components$Produits$StructureCatalogue$API$HttpAPI$lireLaStructureReq(requete));
			case 111:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Update$CommandeRepondue, $author$project$Main$Update$StructureCatalogueMsg)),
					$author$project$Components$Produits$StructureCatalogue$API$HttpAPI$envoyerReq(requete));
			case 112:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Update$ApercuRecu, $author$project$Main$Update$StructureCatalogueMsg)),
					$author$project$Components$Produits$StructureCatalogue$API$HttpAPI$apercuReq(requete));
			case 113:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Update$ApercuDArchivageRecu, $author$project$Main$Update$StructureCatalogueMsg)),
					$author$project$Components$Produits$StructureCatalogue$API$HttpAPI$apercuDArchivageReq(requete));
			case 115:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$FicheType$Update$VersionsLues, $author$project$Main$Update$FicheTypeMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
			case 116:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$FicheType$Update$BibliothequeLue, $author$project$Main$Update$FicheTypeMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
			case 117:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$FicheType$Update$ListesLues, $author$project$Main$Update$FicheTypeMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
			case 118:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Parametrage$NouveauChamp$Update$ListesLues,
							A2($elm$core$Basics$composeR, $author$project$Components$Produits$FicheType$Update$DuNouveauChamp, $author$project$Main$Update$FicheTypeMsg))),
					$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
			case 119:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Parametrage$NouveauChamp$Update$CommandeRepondue,
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$FicheType$Update$DuNouveauChamp, $author$project$Main$Update$FicheTypeMsg)),
					$author$project$Components$Parametrage$BibliothequeDeChamps$API$HttpAPI$envoyerReq(requete));
			case 194:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Parametrage$NouveauChamp$Update$ListesLues,
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Types$Update$DuNouveauChamp, $author$project$Main$Update$TypesDePartiesPrenantesMsg)),
					$author$project$Components$Referentiel$Common$API$HttpAPI$lireReq(requete));
			case 195:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Parametrage$NouveauChamp$Update$CommandeRepondue,
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Types$Update$DuNouveauChamp, $author$project$Main$Update$TypesDePartiesPrenantesMsg)),
					$author$project$Components$Parametrage$BibliothequeDeChamps$API$HttpAPI$envoyerReq(requete));
			case 121:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Type$Update$CollectionsLues, $author$project$Main$Update$TypeDePartiePrenanteMsg),
					$author$project$Components$Parametrage$CollectionsDeChamps$API$HttpAPI$lireReq(requete));
			case 192:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Types$Update$CollectionsLues, $author$project$Main$Update$TypesDePartiesPrenantesMsg),
					$author$project$Components$Parametrage$CollectionsDeChamps$API$HttpAPI$lireReq(requete));
			case 120:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Type$Update$BibliothequeLue, $author$project$Main$Update$TypeDePartiePrenanteMsg),
					$author$project$Components$Referentiel$Common$API$HttpAPI$lireReq(requete));
			case 122:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Parametrage$NouveauChamp$Update$ListesLues,
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Type$Update$DuNouveauChamp, $author$project$Main$Update$TypeDePartiePrenanteMsg)),
					$author$project$Components$Referentiel$Common$API$HttpAPI$lireReq(requete));
			case 123:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Parametrage$NouveauChamp$Update$CommandeRepondue,
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Type$Update$DuNouveauChamp, $author$project$Main$Update$TypeDePartiePrenanteMsg)),
					$author$project$Components$Parametrage$BibliothequeDeChamps$API$HttpAPI$envoyerReq(requete));
			case 124:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$FicheType$Update$ApercuLu, $author$project$Main$Update$FicheTypeMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$apercuDuResserrageReq(requete));
			case 125:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$FicheType$Update$ListeDuChampLue, $author$project$Main$Update$FicheTypeMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
			case 126:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$FicheType$Update$ValeursPoseesLues, $author$project$Main$Update$FicheTypeMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
			case 127:
				switch (effet.a) {
					case 6:
						var _v35 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$FicheType$Update$OrdreLu, $author$project$Main$Update$FicheTypeMsg)),
							$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
					case 1:
						var _v36 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$FicheElement$Update$OrdreLu, $author$project$Main$Update$FicheElementMsg)),
							$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
					default:
						return $elm$core$Platform$Cmd$none;
				}
			case 128:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$FicheType$Update$ApercuDeLaRestrictionLu, $author$project$Main$Update$FicheTypeMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$apercuDeLaRestrictionReq(requete));
			case 129:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Produits$FicheType$Update$ApercuDeLaRegleLu(requete.Iy),
							$author$project$Main$Update$FicheTypeMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$apercuDeLaRegleDeCodeReq(requete));
			case 147:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Categories$Update$FicheLue, $author$project$Main$versLesCategories)),
					$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
			case 148:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$Reference$Update$ProduitLu, $author$project$Main$Update$ReferenceMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
			case 150:
				var numero = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Produits$Reference$Update$PerimetresLus(numero),
							$author$project$Main$Update$ReferenceMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
			case 149:
				var perimetre = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Produits$Reference$Update$ValeurDuPerimetreLue(perimetre),
							$author$project$Main$Update$ReferenceMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
			case 151:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$Reference$Update$ApercuLu, $author$project$Main$Update$ReferenceMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
			case 133:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$Catalogue$Update$StructureLue, $author$project$Main$Update$CatalogueMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
			case 134:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$Reference$Update$CatalogueDesFiltresLu, $author$project$Main$Update$ReferenceMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
			case 135:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$Reference$Update$StructureDesFiltresLue, $author$project$Main$Update$ReferenceMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
			case 140:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$Catalogue$Update$ARangerLue, $author$project$Main$Update$CatalogueMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
			case 141:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Produits$Catalogue$Update$ApercuDuLotLu(requete.uN),
							$author$project$Main$Update$CatalogueMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$lireReq(
						{gM: requete.gM, nB: requete.nB}));
			case 142:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Produits$Catalogue$Update$NombreARangerLu(requete.r3),
							$author$project$Main$Update$CatalogueMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$lireReq(
						{gM: requete.gM, nB: requete.nB}));
			case 143:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Produits$Catalogue$Update$CategoriesProposees(requete.Ki),
							$author$project$Main$Update$CatalogueMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$proposerLesCategoriesReq(requete));
			case 144:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							A2($author$project$Components$Produits$Catalogue$Update$ProduitsProposes, requete.r0, requete.Ki),
							$author$project$Main$Update$CatalogueMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$proposerLesCategoriesReq(
						{gM: requete.gM, nB: requete.nB, Ki: requete.Ki}));
			case 145:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							A2($author$project$Components$Produits$Catalogue$Update$SchemaLu, requete.r0, requete.Ki),
							$author$project$Main$Update$CatalogueMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$lireLeSchemaEffectifReq(
						{gM: requete.gM, nB: requete.nB, r3: requete.r3, Ki: requete.Ki}));
			case 146:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							A3($author$project$Components$Produits$Catalogue$Update$CodeProposeLu, requete.r0, requete.Ki, requete.i8),
							$author$project$Main$Update$CatalogueMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$lireLeCodeProposeReq(
						{i8: requete.i8, gM: requete.gM, nB: requete.nB, r3: requete.r3, Ki: requete.Ki}));
			case 130:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$SchemaDeNiveau$Update$StructureLue, $author$project$Main$Update$SchemaDeNiveauMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
			case 152:
				var types = effet.a;
				return A2($elm$file$File$Select$file, types, $author$project$Main$Update$FichierChoisi);
			case 153:
				var fichier = effet.a;
				return A2(
					$elm$core$Task$perform,
					function (octets) {
						return $author$project$Main$Update$ReferenceMsg(
							$author$project$Components$Produits$Reference$Update$OctetsLus(
								{
									Ck: $elm$file$File$mime(fichier),
									Dj: $elm$file$File$name(fichier),
									oW: octets,
									Jm: $elm$file$File$size(fichier)
								}));
					},
					$elm$file$File$toBytes(fichier));
			case 154:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$Reference$Update$MorceauPose, $author$project$Main$Update$ReferenceMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$poserUnMorceauReq(requete));
			case 155:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$Reference$Update$DepotClos, $author$project$Main$Update$ReferenceMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$deposerLeFichierReq(requete));
			case 156:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$Reference$Update$DocumentsLus, $author$project$Main$Update$ReferenceMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
			case 157:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$Reference$Update$ImageLue, $author$project$Main$Update$ReferenceMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
			case 158:
				var nom = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Produits$Reference$Update$ImageRepondue(nom),
							$author$project$Main$Update$ReferenceMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$envoyerJsonReq(requete));
			case 159:
				return $elm$http$Http$cancel($author$project$Components$Produits$Common$API$HttpAPI$traceurDeLImage);
			case 160:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Produits$Reference$Update$ImagePosee, $author$project$Main$Update$ReferenceMsg),
					$author$project$Components$Produits$Common$API$HttpAPI$deposerSurLAdresseReq(requete));
			case 161:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Produits$Reference$Update$PartiesPrenantesProposees(requete.r$),
							$author$project$Main$Update$ReferenceMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$proposerLesPartiesPrenantesReq(requete));
			case 162:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Produits$Reference$Update$HistoriqueLu(requete.EE),
							$author$project$Main$Update$ReferenceMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$lireReq(
						{gM: requete.gM, nB: requete.nB}));
			case 27:
				var demande = effet.a;
				var _v60 = demande.lO;
				switch (_v60.$) {
					case 1:
						var lien = _v60.a;
						return A2(
							$elm$core$Platform$Cmd$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Components$Referentiel$Doublons$Update$Lue(demande.kD),
								$author$project$Main$Update$DoublonsMsg),
							$author$project$Components$Referentiel$Doublons$API$HttpAPI$lireReq(
								{gM: demande.gM, nB: lien}));
					case 2:
						var lien = _v60.a;
						return A2(
							$elm$core$Platform$Cmd$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Components$Referentiel$Doublons$Update$Lue(demande.kD),
								$author$project$Main$Update$DoublonsMsg),
							$author$project$Components$Referentiel$Doublons$API$HttpAPI$lireReq(
								{gM: demande.gM, nB: lien}));
					case 3:
						var lien = _v60.a;
						return A2(
							$elm$core$Platform$Cmd$map,
							A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Doublons$Update$PaireLue, $author$project$Main$Update$DoublonsMsg),
							$author$project$Components$Referentiel$Doublons$API$HttpAPI$lireReq(
								{gM: demande.gM, nB: lien}));
					case 4:
						var lien = _v60.a;
						var processUid = _v60.b;
						var paires = _v60.c;
						return A2(
							$elm$core$Platform$Cmd$map,
							A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Doublons$Update$Ecartee, $author$project$Main$Update$DoublonsMsg),
							$author$project$Components$Referentiel$Doublons$API$HttpAPI$ecarterReq(
								{gM: demande.gM, nB: lien, EJ: paires, Gn: processUid}));
					case 5:
						var lien = _v60.a;
						var processUid = _v60.b;
						var paire = _v60.c;
						return A2(
							$elm$core$Platform$Cmd$map,
							A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Doublons$Update$Rouverte, $author$project$Main$Update$DoublonsMsg),
							$author$project$Components$Referentiel$Doublons$API$HttpAPI$rouvrirReq(
								{t3: paire.t3, zo: paire.zo, gM: demande.gM, nB: lien, Gn: processUid}));
					default:
						return $elm$core$Platform$Cmd$none;
				}
			case 131:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Produits$Alertes$Update$Lue(requete.kD),
							$author$project$Main$Update$AlertesMsg)),
					$author$project$Components$Produits$Alertes$API$HttpAPI$lireReq(
						{gM: requete.gM, nB: requete.nB}));
			case 132:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Referentiel$Alertes$Update$Lue(requete.kD),
							$author$project$Main$Update$AlertesPartiesPrenantesMsg)),
					$author$project$Components$Referentiel$Alertes$API$HttpAPI$lireReq(
						{gM: requete.gM, nB: requete.nB}));
			case 114:
				switch (effet.a) {
					case 0:
						var _v10 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$MarquesEtGammes$Update$AnnuaireLu, $author$project$Main$Update$MarquesEtGammesMsg)),
							$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
					case 1:
						var _v14 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$FicheElement$Update$FicheLue, $author$project$Main$Update$FicheElementMsg)),
							$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
					case 2:
						var _v18 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Categories$Update$AnnuaireLu, $author$project$Main$versLesCategories)),
							$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
					case 3:
						var _v22 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Marques$Update$AnnuaireLu, $author$project$Main$versLesMarques)),
							$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
					case 4:
						var _v26 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Gammes$Update$FicheLue, $author$project$Main$versLesGammes)),
							$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
					case 5:
						var _v30 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Produits$Update$LectureRevenue, $author$project$Main$versLesProduits)),
							$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
					case 6:
						var _v34 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$FicheType$Update$FicheLue, $author$project$Main$Update$FicheTypeMsg)),
							$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
					case 7:
						var _v40 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$SchemaDeNiveau$Update$SchemaLu, $author$project$Main$Update$SchemaDeNiveauMsg)),
							$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
					case 8:
						var _v44 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$Catalogue$Update$CatalogueLu, $author$project$Main$Update$CatalogueMsg)),
							$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
					case 9:
						var _v48 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$Reference$Update$FicheLue, $author$project$Main$Update$ReferenceMsg)),
							$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
					case 10:
						var _v52 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$Offres$Update$AnnuaireLu, $author$project$Main$Update$OffresMsg)),
							$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
					case 11:
						var _v56 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$Offre$Update$FicheLue, $author$project$Main$Update$OffreMsg)),
							$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
					case 12:
						var _v61 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$ListesDePrix$Update$AnnuaireLu, $author$project$Main$Update$ListesDePrixMsg)),
							$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
					default:
						var _v65 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$ListeDePrix$Update$FicheLue, $author$project$Main$Update$ListeDePrixMsg)),
							$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
				}
			case 171:
				switch (effet.a) {
					case 0:
						var _v11 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$MarquesEtGammes$Update$CommandeRepondue, $author$project$Main$Update$MarquesEtGammesMsg)),
							$author$project$Components$Produits$Common$API$HttpAPI$envoyerReq(requete));
					case 1:
						var _v15 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$FicheElement$Update$CommandeRepondue, $author$project$Main$Update$FicheElementMsg)),
							$author$project$Components$Produits$Common$API$HttpAPI$envoyerReq(requete));
					case 2:
						var _v19 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Categories$Update$CommandeRepondue, $author$project$Main$versLesCategories)),
							$author$project$Components$Produits$Common$API$HttpAPI$envoyerReq(requete));
					case 3:
						var _v23 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Marques$Update$CommandeRepondue, $author$project$Main$versLesMarques)),
							$author$project$Components$Produits$Common$API$HttpAPI$envoyerReq(requete));
					case 4:
						var _v27 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Gammes$Update$CommandeRepondue, $author$project$Main$versLesGammes)),
							$author$project$Components$Produits$Common$API$HttpAPI$envoyerReq(requete));
					case 5:
						var _v31 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Produits$Update$CommandeRepondue, $author$project$Main$versLesProduits)),
							$author$project$Components$Produits$Common$API$HttpAPI$envoyerReq(requete));
					case 6:
						var _v37 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$FicheType$Update$CommandeRepondue, $author$project$Main$Update$FicheTypeMsg)),
							$author$project$Components$Produits$Common$API$HttpAPI$envoyerReq(requete));
					case 7:
						var _v41 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$SchemaDeNiveau$Update$CommandeRepondue, $author$project$Main$Update$SchemaDeNiveauMsg)),
							$author$project$Components$Produits$Common$API$HttpAPI$envoyerReq(requete));
					case 8:
						var _v45 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$Catalogue$Update$CommandeRepondue, $author$project$Main$Update$CatalogueMsg)),
							$author$project$Components$Produits$Common$API$HttpAPI$envoyerReq(requete));
					case 9:
						var _v49 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$Reference$Update$CommandeRepondue, $author$project$Main$Update$ReferenceMsg)),
							$author$project$Components$Produits$Common$API$HttpAPI$envoyerReq(requete));
					case 10:
						var _v53 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$Offres$Update$CommandeRepondue, $author$project$Main$Update$OffresMsg)),
							$author$project$Components$Produits$Common$API$HttpAPI$envoyerReq(requete));
					case 11:
						var _v57 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$Offre$Update$CommandeRepondue, $author$project$Main$Update$OffreMsg)),
							$author$project$Components$Produits$Common$API$HttpAPI$envoyerReq(requete));
					case 12:
						var _v62 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$ListesDePrix$Update$CommandeRepondue, $author$project$Main$Update$ListesDePrixMsg)),
							$author$project$Components$Produits$Common$API$HttpAPI$envoyerReq(requete));
					default:
						var _v66 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$ListeDePrix$Update$CommandeRepondue, $author$project$Main$Update$ListeDePrixMsg)),
							$author$project$Components$Produits$Common$API$HttpAPI$envoyerReq(requete));
				}
			case 163:
				switch (effet.a) {
					case 0:
						var _v12 = effet.a;
						var delaiMs = effet.b;
						return A2(
							$elm$core$Task$perform,
							function (_v13) {
								return $author$project$Main$Update$MarquesEtGammesMsg($author$project$Components$Produits$MarquesEtGammes$Update$DelaiDeRelectureEcoule);
							},
							$elm$core$Process$sleep(delaiMs));
					case 1:
						var _v16 = effet.a;
						var delaiMs = effet.b;
						return A2(
							$elm$core$Task$perform,
							function (_v17) {
								return $author$project$Main$Update$FicheElementMsg($author$project$Components$Produits$FicheElement$Update$DelaiDeRelectureEcoule);
							},
							$elm$core$Process$sleep(delaiMs));
					case 2:
						var _v20 = effet.a;
						var delaiMs = effet.b;
						return A2(
							$elm$core$Task$perform,
							function (_v21) {
								return $author$project$Main$versLesCategories($author$project$Components$Produits$StructureCatalogue$Categories$Update$DelaiDeRelectureEcoule);
							},
							$elm$core$Process$sleep(delaiMs));
					case 3:
						var _v24 = effet.a;
						var delaiMs = effet.b;
						return A2(
							$elm$core$Task$perform,
							function (_v25) {
								return $author$project$Main$versLesMarques($author$project$Components$Produits$StructureCatalogue$Marques$Update$DelaiDeRelectureEcoule);
							},
							$elm$core$Process$sleep(delaiMs));
					case 4:
						var _v28 = effet.a;
						var delaiMs = effet.b;
						return A2(
							$elm$core$Task$perform,
							function (_v29) {
								return $author$project$Main$versLesGammes($author$project$Components$Produits$StructureCatalogue$Gammes$Update$DelaiDeRelectureEcoule);
							},
							$elm$core$Process$sleep(delaiMs));
					case 5:
						var _v32 = effet.a;
						var delaiMs = effet.b;
						return A2(
							$elm$core$Task$perform,
							function (_v33) {
								return $author$project$Main$versLesProduits($author$project$Components$Produits$StructureCatalogue$Produits$Update$DelaiDeRelectureEcoule);
							},
							$elm$core$Process$sleep(delaiMs));
					case 6:
						var _v38 = effet.a;
						var delaiMs = effet.b;
						return A2(
							$elm$core$Task$perform,
							function (_v39) {
								return $author$project$Main$Update$FicheTypeMsg($author$project$Components$Produits$FicheType$Update$DelaiDeRelectureEcoule);
							},
							$elm$core$Process$sleep(delaiMs));
					case 7:
						var _v42 = effet.a;
						var delaiMs = effet.b;
						return A2(
							$elm$core$Task$perform,
							function (_v43) {
								return $author$project$Main$Update$SchemaDeNiveauMsg($author$project$Components$Produits$SchemaDeNiveau$Update$DelaiDeRelectureEcoule);
							},
							$elm$core$Process$sleep(delaiMs));
					case 8:
						var _v46 = effet.a;
						var delaiMs = effet.b;
						return A2(
							$elm$core$Task$perform,
							function (_v47) {
								return $author$project$Main$Update$CatalogueMsg($author$project$Components$Produits$Catalogue$Update$DelaiDeRelectureEcoule);
							},
							$elm$core$Process$sleep(delaiMs));
					case 9:
						var _v50 = effet.a;
						var delaiMs = effet.b;
						return A2(
							$elm$core$Task$perform,
							function (_v51) {
								return $author$project$Main$Update$ReferenceMsg($author$project$Components$Produits$Reference$Update$DelaiDeRelectureEcoule);
							},
							$elm$core$Process$sleep(delaiMs));
					case 10:
						var _v54 = effet.a;
						var delaiMs = effet.b;
						return A2(
							$elm$core$Task$perform,
							function (_v55) {
								return $author$project$Main$Update$OffresMsg($author$project$Components$Produits$Offres$Update$DelaiDeRelectureEcoule);
							},
							$elm$core$Process$sleep(delaiMs));
					case 11:
						var _v58 = effet.a;
						var delaiMs = effet.b;
						return A2(
							$elm$core$Task$perform,
							function (_v59) {
								return $author$project$Main$Update$OffreMsg($author$project$Components$Produits$Offre$Update$DelaiDeRelectureEcoule);
							},
							$elm$core$Process$sleep(delaiMs));
					case 12:
						var _v63 = effet.a;
						var delaiMs = effet.b;
						return A2(
							$elm$core$Task$perform,
							function (_v64) {
								return $author$project$Main$Update$ListesDePrixMsg($author$project$Components$Produits$ListesDePrix$Update$DelaiDeRelectureEcoule);
							},
							$elm$core$Process$sleep(delaiMs));
					default:
						var _v67 = effet.a;
						var delaiMs = effet.b;
						return A2(
							$elm$core$Task$perform,
							function (_v68) {
								return $author$project$Main$Update$ListeDePrixMsg($author$project$Components$Produits$ListeDePrix$Update$DelaiDeRelectureEcoule);
							},
							$elm$core$Process$sleep(delaiMs));
				}
			case 136:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Update$CatalogueDesFiltresLu, $author$project$Main$Update$StructureCatalogueMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
			case 137:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Update$StructureDesFiltresLue, $author$project$Main$Update$StructureCatalogueMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
			case 138:
				var numero = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Produits$StructureCatalogue$Update$PerimetresLus(numero),
							$author$project$Main$Update$StructureCatalogueMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
			case 139:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Produits$StructureCatalogue$Update$ArticlesTrouves(requete.DX),
							$author$project$Main$Update$StructureCatalogueMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$rechercherReq(
						{gM: requete.gM, nB: requete.nB, hC: requete.hC}));
			case 168:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Produits$Reference$Update$ArticlesTrouves(requete.DX),
							$author$project$Main$Update$ReferenceMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$rechercherReq(
						{gM: requete.gM, nB: requete.nB, hC: requete.hC}));
			case 169:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Produits$ListeDePrix$Update$ReferencesTrouvees(requete.DX),
							$author$project$Main$Update$ListeDePrixMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$rechercherReq(
						{gM: requete.gM, nB: requete.nB, hC: requete.hC}));
			case 170:
				var numero = effet.a;
				var delaiMs = effet.b;
				return A2(
					$elm$core$Task$perform,
					function (_v69) {
						return $author$project$Main$Update$ListeDePrixMsg(
							$author$project$Components$Produits$ListeDePrix$Update$DelaiDeRechercheEcoule(numero));
					},
					$elm$core$Process$sleep(delaiMs));
			case 167:
				switch (effet.a) {
					case 10:
						var _v73 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$Offres$Update$ComptageLu, $author$project$Main$Update$OffresMsg)),
							$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
					case 11:
						var _v74 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$Offre$Update$ComptageLu, $author$project$Main$Update$OffreMsg)),
							$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
					default:
						return $elm$core$Platform$Cmd$none;
				}
			case 166:
				switch (effet.a) {
					case 10:
						var _v70 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$Offres$Update$PrixLus, $author$project$Main$Update$OffresMsg)),
							$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
					case 11:
						var _v71 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$Offre$Update$PrixLus, $author$project$Main$Update$OffreMsg)),
							$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
					case 9:
						var _v72 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$Reference$Update$PrixLus, $author$project$Main$Update$ReferenceMsg)),
							$author$project$Components$Produits$Common$API$HttpAPI$lireReq(requete));
					default:
						return $elm$core$Platform$Cmd$none;
				}
			case 164:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Produits$Catalogue$Update$ListeLue(requete.DX),
							$author$project$Main$Update$CatalogueMsg)),
					$author$project$Components$Produits$Common$API$HttpAPI$rechercherReq(
						{gM: requete.gM, nB: requete.nB, hC: requete.hC}));
			case 165:
				var numero = effet.a;
				var delaiMs = effet.b;
				return A2(
					$elm$core$Task$perform,
					function (_v75) {
						return $author$project$Main$Update$CatalogueMsg(
							$author$project$Components$Produits$Catalogue$Update$DelaiDeSaisieEcoule(numero));
					},
					$elm$core$Process$sleep(delaiMs));
			case 110:
				var delaiMs = effet.a;
				return A2(
					$elm$core$Task$perform,
					function (_v76) {
						return $author$project$Main$Update$StructureCatalogueMsg($author$project$Components$Produits$StructureCatalogue$Update$DelaiDeRelectureEcoule);
					},
					$elm$core$Process$sleep(delaiMs));
			case 174:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$PartiesPrenantes$Update$OffresLues, $author$project$Main$Update$PartiesPrenantesMsg)),
					$author$project$Components$Referentiel$Common$API$Groupes$HttpAPI$lireReq(requete));
			case 173:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Groupes$Update$AnnuaireLu, $author$project$Main$Update$GroupesMsg)),
					$author$project$Components$Referentiel$Common$API$Groupes$HttpAPI$lireReq(requete));
			case 181:
				var etape = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Referentiel$Groupes$Update$EquipeLue(etape),
							$author$project$Main$Update$GroupesMsg)),
					$author$project$Components$Referentiel$Common$API$Groupes$HttpAPI$lireReq(requete));
			case 182:
				var etape = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Referentiel$Groupe$Update$EquipeLue(etape),
							$author$project$Main$Update$GroupeMsg)),
					$author$project$Components$Referentiel$Common$API$Groupes$HttpAPI$lireReq(requete));
			case 175:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Groupe$Update$FicheLue, $author$project$Main$Update$GroupeMsg)),
					$author$project$Components$Referentiel$Common$API$Groupes$HttpAPI$lireReq(requete));
			case 176:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Groupe$Update$TraitementsLus, $author$project$Main$Update$GroupeMsg)),
					$author$project$Components$Referentiel$Common$API$Groupes$HttpAPI$lireReq(requete));
			case 177:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Groupe$Update$NotificationsDeFinLues, $author$project$Main$Update$GroupeMsg)),
					$author$project$Components$Referentiel$Common$API$Groupes$HttpAPI$lireReq(requete));
			case 178:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Groupe$Update$SuiviLu, $author$project$Main$Update$GroupeMsg)),
					$author$project$Components$Referentiel$Common$API$Groupes$HttpAPI$lireReq(requete));
			case 179:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Groupe$Update$NonAjouteesLues, $author$project$Main$Update$GroupeMsg)),
					$author$project$Components$Referentiel$Common$API$Groupes$HttpAPI$lireReq(requete));
			case 180:
				var delaiMs = effet.a;
				return A2(
					$elm$core$Task$perform,
					function (_v77) {
						return $author$project$Main$Update$GroupeMsg($author$project$Components$Referentiel$Groupe$Update$SuiviARelire);
					},
					$elm$core$Process$sleep(delaiMs));
			case 183:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Referentiel$Groupe$Update$PropositionsLues(
							A2($elm$core$Maybe$withDefault, '', requete.hC.h3)),
						$author$project$Main$Update$GroupeMsg),
					$author$project$Components$Referentiel$Fiche$API$HttpAPI$chercherDesFichesReq(requete));
			case 185:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Referentiel$Groupe$Update$NombreLu(requete.bY),
							$author$project$Main$Update$GroupeMsg)),
					$author$project$Components$Referentiel$Common$API$Groupes$HttpAPI$compterReq(
						{zH: requete.zH, gM: requete.gM, nB: requete.nB}));
			case 184:
				var saisie = effet.a;
				var delaiMs = effet.b;
				return A2(
					$elm$core$Task$perform,
					function (_v78) {
						return $author$project$Main$Update$GroupeMsg(
							$author$project$Components$Referentiel$Groupe$Update$DelaiDeRechercheEcoule(saisie));
					},
					$elm$core$Process$sleep(delaiMs));
			case 186:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Groupe$Update$CommandeRepondue, $author$project$Main$Update$GroupeMsg)),
					$author$project$Components$Referentiel$Common$API$Groupes$HttpAPI$envoyerReq(requete));
			case 187:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Groupes$Update$CreationRepondue, $author$project$Main$Update$GroupesMsg)),
					$author$project$Components$Referentiel$Common$API$Groupes$HttpAPI$envoyerReq(requete));
			case 188:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Types$Update$TypeLu, $author$project$Main$Update$TypesDePartiesPrenantesMsg)),
					$author$project$Components$Referentiel$Common$API$HttpAPI$lireReq(requete));
			case 189:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Types$Update$TypeRegleLu, $author$project$Main$Update$TypesDePartiesPrenantesMsg)),
					$author$project$Components$Referentiel$Common$API$HttpAPI$lireReq(requete));
			case 191:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Types$Update$BibliothequeLue, $author$project$Main$Update$TypesDePartiesPrenantesMsg)),
					$author$project$Components$Referentiel$Common$API$HttpAPI$lireReq(requete));
			case 193:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Types$Update$ListesLues, $author$project$Main$Update$TypesDePartiesPrenantesMsg)),
					$author$project$Components$Referentiel$Common$API$HttpAPI$lireReq(requete));
			case 190:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Types$Update$VersionsLues, $author$project$Main$Update$TypesDePartiesPrenantesMsg)),
					$author$project$Components$Referentiel$Common$API$HttpAPI$lireReq(requete));
			case 197:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Types$Update$ListeDuChampLue, $author$project$Main$Update$TypesDePartiesPrenantesMsg)),
					$author$project$Components$Referentiel$Common$API$HttpAPI$lireReq(requete));
			case 198:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Types$Update$OrdreLu, $author$project$Main$Update$TypesDePartiesPrenantesMsg)),
					$author$project$Components$Referentiel$Common$API$HttpAPI$lireReq(requete));
			case 199:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Types$Update$ApercuDeLaRestrictionLu, $author$project$Main$Update$TypesDePartiesPrenantesMsg)),
					$author$project$Components$Referentiel$Common$API$HttpAPI$apercuDeLaRestrictionReq(requete));
			case 196:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Types$Update$ApercuLu, $author$project$Main$Update$TypesDePartiesPrenantesMsg)),
					$author$project$Components$Referentiel$Common$API$HttpAPI$apercuDuResserrageReq(requete));
			case 201:
				var lecture = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Parametrage$Droits$Update$Lue(lecture),
							$author$project$Main$Update$DroitsMsg)),
					$author$project$Components$Parametrage$Droits$API$HttpAPI$lireReq(requete));
			case 207:
				var lecture = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Produits$Perimetres$Update$Lue(lecture),
							$author$project$Main$Update$PerimetresMsg)),
					$author$project$Components$Produits$Perimetres$API$HttpAPI$lireReq(requete));
			case 208:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$Perimetres$Update$CommandeRepondue, $author$project$Main$Update$PerimetresMsg)),
					$author$project$Components$Produits$Perimetres$API$HttpAPI$envoyerReq(requete));
			case 210:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$TypesDeQuantite$Update$Lue, $author$project$Main$Update$TypesDeQuantiteMsg)),
					$author$project$Components$Produits$TypesDeQuantite$API$HttpAPI$lireReq(requete));
			case 211:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$TypesDeQuantite$Update$CommandeRepondue, $author$project$Main$Update$TypesDeQuantiteMsg)),
					$author$project$Components$Produits$TypesDeQuantite$API$HttpAPI$envoyerReq(requete));
			case 212:
				var delaiMs = effet.a;
				return A2(
					$elm$core$Task$perform,
					function (_v83) {
						return $author$project$Main$Update$TypesDeQuantiteMsg($author$project$Components$Produits$TypesDeQuantite$Update$DelaiDeRelectureEcoule);
					},
					$elm$core$Process$sleep(delaiMs));
			case 209:
				var delaiMs = effet.a;
				return A2(
					$elm$core$Task$perform,
					function (_v84) {
						return $author$project$Main$Update$PerimetresMsg($author$project$Components$Produits$Perimetres$Update$DelaiDeRelectureEcoule);
					},
					$elm$core$Process$sleep(delaiMs));
			case 204:
				var lecture = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Produits$Correspondances$Update$Lue(lecture),
							$author$project$Main$Update$CorrespondancesMsg)),
					$author$project$Components$Produits$Correspondances$API$HttpAPI$lireReq(requete));
			case 205:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$Correspondances$Update$CommandeRepondue, $author$project$Main$Update$CorrespondancesMsg)),
					$author$project$Components$Produits$Correspondances$API$HttpAPI$envoyerReq(requete));
			case 206:
				var delaiMs = effet.a;
				return A2(
					$elm$core$Task$perform,
					function (_v85) {
						return $author$project$Main$Update$CorrespondancesMsg($author$project$Components$Produits$Correspondances$Update$DelaiDeRelectureEcoule);
					},
					$elm$core$Process$sleep(delaiMs));
			case 213:
				var lecture = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Produits$Listes$Update$Lue(lecture),
							$author$project$Main$Update$ListesMsg)),
					$author$project$Components$Produits$Listes$API$HttpAPI$lireReq(requete));
			case 214:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$Listes$Update$CommandeRepondue, $author$project$Main$Update$ListesMsg)),
					$author$project$Components$Produits$Listes$API$HttpAPI$envoyerReq(requete));
			case 219:
				var lecture = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Lue(lecture),
							$author$project$Main$Update$BibliothequeMsg)),
					$author$project$Components$Parametrage$BibliothequeDeChamps$API$HttpAPI$lireReq(requete));
			case 220:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$BibliothequeDeChamps$Update$CommandeRepondue, $author$project$Main$Update$BibliothequeMsg)),
					$author$project$Components$Parametrage$BibliothequeDeChamps$API$HttpAPI$envoyerReq(requete));
			case 221:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Lue($author$project$Components$Parametrage$BibliothequeDeChamps$Update$DeLApercu),
							$author$project$Main$Update$BibliothequeMsg)),
					$author$project$Components$Parametrage$BibliothequeDeChamps$API$HttpAPI$apercuReq(requete));
			case 222:
				var delaiMs = effet.a;
				return A2(
					$elm$core$Task$perform,
					function (_v86) {
						return $author$project$Main$Update$BibliothequeMsg($author$project$Components$Parametrage$BibliothequeDeChamps$Update$DelaiDeRelectureEcoule);
					},
					$elm$core$Process$sleep(delaiMs));
			case 215:
				var delaiMs = effet.a;
				return A2(
					$elm$core$Task$perform,
					function (_v87) {
						return $author$project$Main$Update$ListesMsg($author$project$Components$Produits$Listes$Update$DelaiDeRelectureEcoule);
					},
					$elm$core$Process$sleep(delaiMs));
			case 216:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$CollectionsDeChamps$Update$Lue, $author$project$Main$Update$CollectionsDeChampsMsg)),
					$author$project$Components$Parametrage$CollectionsDeChamps$API$HttpAPI$lireReq(requete));
			case 217:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$CollectionsDeChamps$Update$CommandeRepondue, $author$project$Main$Update$CollectionsDeChampsMsg)),
					$author$project$Components$Parametrage$CollectionsDeChamps$API$HttpAPI$envoyerReq(requete));
			case 218:
				var delaiMs = effet.a;
				return A2(
					$elm$core$Task$perform,
					function (_v88) {
						return $author$project$Main$Update$CollectionsDeChampsMsg($author$project$Components$Parametrage$CollectionsDeChamps$Update$DelaiDeRelectureEcoule);
					},
					$elm$core$Process$sleep(delaiMs));
			case 202:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$Droits$Update$CommandeRepondue, $author$project$Main$Update$DroitsMsg)),
					$author$project$Components$Parametrage$Droits$API$HttpAPI$envoyerReq(requete));
			case 269:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$TypesDeRelation$Update$AnnuaireLu, $author$project$Main$Update$TypesDeRelationMsg)),
					$author$project$Components$Referentiel$TypesDeRelation$API$HttpAPI$lireReq(requete));
			case 270:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$TypesDeRelation$Update$FormesLues, $author$project$Main$Update$TypesDeRelationMsg)),
					$author$project$Components$Referentiel$TypesDeRelation$API$HttpAPI$lireReq(requete));
			case 271:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$TypesDeRelation$Update$CommandeRepondue, $author$project$Main$Update$TypesDeRelationMsg)),
					$author$project$Components$Referentiel$TypesDeRelation$API$HttpAPI$envoyerReq(requete));
			case 272:
				var delaiMs = effet.a;
				return A2(
					$elm$core$Task$perform,
					function (_v89) {
						return $author$project$Main$Update$TypesDeRelationMsg($author$project$Components$Referentiel$TypesDeRelation$Update$DelaiDeRelectureEcoule);
					},
					$elm$core$Process$sleep(delaiMs));
			case 273:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Postes$Update$ListeLue, $author$project$Main$Update$PostesMsg)),
					$author$project$Components$Referentiel$Postes$API$HttpAPI$lireReq(requete));
			case 274:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Postes$Update$CommandeRepondue, $author$project$Main$Update$PostesMsg)),
					$author$project$Components$Referentiel$Postes$API$HttpAPI$envoyerReq(requete));
			case 275:
				var delaiMs = effet.a;
				return A2(
					$elm$core$Task$perform,
					function (_v90) {
						return $author$project$Main$Update$PostesMsg($author$project$Components$Referentiel$Postes$Update$DelaiDeRelectureEcoule);
					},
					$elm$core$Process$sleep(delaiMs));
			case 276:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Formes$Update$ListeLue, $author$project$Main$Update$FormesMsg),
					$author$project$Components$Referentiel$Formes$API$HttpAPI$lireReq(requete));
			case 277:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Formes$Update$CommandeRepondue, $author$project$Main$Update$FormesMsg),
					$author$project$Components$Referentiel$Formes$API$HttpAPI$envoyerReq(requete));
			case 278:
				var delaiMs = effet.a;
				return A2(
					$elm$core$Task$perform,
					function (_v91) {
						return $author$project$Main$Update$FormesMsg($author$project$Components$Referentiel$Formes$Update$DelaiDeRelectureEcoule);
					},
					$elm$core$Process$sleep(delaiMs));
			case 1:
				var norme = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						$author$project$Main$Update$NormesLues(norme)),
					$author$project$Components$Notifications$API$HttpAPI$lireReq(requete));
			case 262:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Notifications$Update$Lue, $author$project$Main$Update$NotificationsMsg)),
					$author$project$Components$Notifications$API$HttpAPI$lireReq(requete));
			case 263:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Notifications$Update$NouvellesRecues, $author$project$Main$Update$NotificationsMsg)),
					$author$project$Components$Notifications$API$HttpAPI$attendreReq(requete));
			case 264:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Notifications$Update$TraitementsLus, $author$project$Main$Update$NotificationsMsg)),
					$author$project$Components$Notifications$API$HttpAPI$lireReq(requete));
			case 265:
				var groupe = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Notifications$Update$GroupeLu(groupe),
							$author$project$Main$Update$NotificationsMsg)),
					$author$project$Components$Notifications$API$HttpAPI$lireReq(requete));
			case 266:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Notifications$Update$CommandeRepondue, $author$project$Main$Update$NotificationsMsg)),
					$author$project$Components$Notifications$API$HttpAPI$envoyerReq(requete));
			case 267:
				var delaiMs = effet.a;
				return A2(
					$elm$core$Task$perform,
					function (_v92) {
						return $author$project$Main$Update$NotificationsMsg($author$project$Components$Notifications$Update$DelaiDeRelectureEcoule);
					},
					$elm$core$Process$sleep(delaiMs));
			case 268:
				return A2(
					$elm$core$Task$perform,
					A2($elm$core$Basics$composeR, $author$project$Components$Notifications$Update$HeureLue, $author$project$Main$Update$NotificationsMsg),
					$elm$time$Time$now);
			case 223:
				var lecture = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Parametrage$Conservation$Update$Lue(lecture),
							$author$project$Main$Update$ConservationMsg)),
					$author$project$Components$Parametrage$Conservation$API$HttpAPI$lireReq(requete));
			case 224:
				var lecture = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Parametrage$LanguesDuClient$Update$Lue(lecture),
							$author$project$Main$Update$LanguesDuClientMsg)),
					$author$project$Components$Parametrage$LanguesDuClient$API$HttpAPI$lireReq(requete));
			case 225:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$LanguesDuClient$Update$CommandeRepondue, $author$project$Main$Update$LanguesDuClientMsg)),
					$author$project$Components$Parametrage$LanguesDuClient$API$HttpAPI$envoyerReq(requete));
			case 226:
				var delaiMs = effet.a;
				return A2(
					$elm$core$Task$perform,
					function (_v93) {
						return $author$project$Main$Update$LanguesDuClientMsg($author$project$Components$Parametrage$LanguesDuClient$Update$DelaiDeRelectureEcoule);
					},
					$elm$core$Process$sleep(delaiMs));
			case 227:
				var lecture = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Parametrage$Utilisateurs$Update$Lue(lecture),
							$author$project$Main$Update$UtilisateursMsg)),
					$author$project$Components$Parametrage$Utilisateurs$API$HttpAPI$lireReq(requete));
			case 228:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$Utilisateurs$Update$CommandeRepondue, $author$project$Main$Update$UtilisateursMsg)),
					$author$project$Components$Parametrage$Utilisateurs$API$HttpAPI$envoyerReq(requete));
			case 229:
				var delaiMs = effet.a;
				return A2(
					$elm$core$Task$perform,
					function (_v94) {
						return $author$project$Main$Update$UtilisateursMsg($author$project$Components$Parametrage$Utilisateurs$Update$DelaiDeRelectureEcoule);
					},
					$elm$core$Process$sleep(delaiMs));
			case 230:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$Lue, $author$project$Main$Update$ImportsMsg)),
					$author$project$Components$Imports$Outil$API$HttpAPI$lireReq(requete));
			case 231:
				var cle = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Imports$Outil$Update$ChampsLus(cle),
							$author$project$Main$Update$ImportsMsg)),
					$author$project$Components$Imports$Outil$API$HttpAPI$lireReq(requete));
			case 232:
				var cle = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Imports$Outil$Update$AdmisesLues(cle),
							$author$project$Main$Update$ImportsMsg)),
					$author$project$Components$Imports$Outil$API$HttpAPI$lireReq(requete));
			case 233:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$RolesLus, $author$project$Main$Update$ImportsMsg)),
					$author$project$Components$Imports$Outil$API$HttpAPI$lireReq(requete));
			case 234:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$OffresLues, $author$project$Main$Update$ImportsMsg)),
					$author$project$Components$Imports$Outil$API$HttpAPI$lireReq(requete));
			case 235:
				return A2(
					$elm$file$File$Select$file,
					_List_fromArray(
						['.xlsx', '.xls', '.xlsm', '.csv', 'text/csv']),
					A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$FichierChoisi, $author$project$Main$Update$ImportsMsg));
			case 236:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Imports$Outil$Update$ApercuLu(requete.mx),
							$author$project$Main$Update$ImportsMsg)),
					$author$project$Components$Imports$Outil$API$HttpAPI$apercevoirReq(
						{vf: requete.vf, gw: requete.gw, gM: requete.gM, nB: requete.nB}));
			case 237:
				var feuille = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Imports$Outil$Update$Reappliquee(feuille),
							$author$project$Main$Update$ImportsMsg)),
					$author$project$Components$Imports$Outil$API$HttpAPI$reappliquerReq(requete));
			case 238:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$LotLu, $author$project$Main$Update$ImportsMsg)),
					$author$project$Components$Imports$Outil$API$HttpAPI$lireReq(requete));
			case 239:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$SuiviLu, $author$project$Main$Update$ImportsMsg),
					$author$project$Components$Imports$Outil$API$HttpAPI$lireReq(requete));
			case 242:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$SimulationLue, $author$project$Main$Update$ImportsMsg),
					$author$project$Components$Imports$Outil$API$HttpAPI$lireReq(requete));
			case 243:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$HistoriqueLu, $author$project$Main$Update$ImportsMsg),
					$author$project$Components$Imports$Outil$API$HttpAPI$lireReq(requete));
			case 240:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$RapportLu, $author$project$Main$Update$ImportsMsg),
					$author$project$Components$Imports$Outil$API$HttpAPI$lireReq(requete));
			case 241:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$LignesRejeteesLues, $author$project$Main$Update$ImportsMsg),
					$author$project$Components$Imports$Outil$API$HttpAPI$lireReq(requete));
			case 244:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$LotsLus, $author$project$Main$Update$ImportsMsg)),
					$author$project$Components$Imports$Outil$API$HttpAPI$lireReq(requete));
			case 245:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$LectureLue, $author$project$Main$Update$ImportsMsg)),
					$author$project$Components$Imports$Outil$API$HttpAPI$lectureReq(requete));
			case 246:
				var destination = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Imports$Outil$Update$ValeursLuesPour(destination),
							$author$project$Main$Update$ImportsMsg)),
					$author$project$Components$Imports$Outil$API$HttpAPI$valeursReq(requete));
			case 247:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$CommandeRepondue, $author$project$Main$Update$ImportsMsg)),
					$author$project$Components$Imports$Outil$API$HttpAPI$envoyerReq(requete));
			case 248:
				var delaiMs = effet.a;
				return A2(
					$elm$core$Task$perform,
					function (_v95) {
						return $author$project$Main$Update$ImportsMsg($author$project$Components$Imports$Outil$Update$DelaiDeRelectureEcoule);
					},
					$elm$core$Process$sleep(delaiMs));
			case 249:
				var lecture = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Parametrage$CompteurDeCode$Update$Lue(lecture),
							$author$project$Main$Update$CompteurDeCodeMsg)),
					$author$project$Components$Parametrage$CompteurDeCode$API$HttpAPI$lireReq(requete));
			case 250:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$CompteurDeCode$Update$CommandeRepondue, $author$project$Main$Update$CompteurDeCodeMsg)),
					$author$project$Components$Parametrage$CompteurDeCode$API$HttpAPI$envoyerReq(requete));
			case 251:
				var delaiMs = effet.a;
				return A2(
					$elm$core$Task$perform,
					function (_v96) {
						return $author$project$Main$Update$CompteurDeCodeMsg($author$project$Components$Parametrage$CompteurDeCode$Update$DelaiDeRelectureEcoule);
					},
					$elm$core$Process$sleep(delaiMs));
			case 252:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$CompteDEnvoi$Update$Lu, $author$project$Main$Update$CompteDEnvoiMsg),
					$author$project$Components$Parametrage$CompteDEnvoi$API$HttpAPI$lireReq(requete));
			case 253:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$CompteDEnvoi$Update$CommandeRepondue, $author$project$Main$Update$CompteDEnvoiMsg),
					$author$project$Components$Parametrage$CompteDEnvoi$API$HttpAPI$envoyerReq(requete));
			case 254:
				var delaiMs = effet.a;
				return A2(
					$elm$core$Task$perform,
					function (_v97) {
						return $author$project$Main$Update$CompteDEnvoiMsg($author$project$Components$Parametrage$CompteDEnvoi$Update$DelaiDeRelectureEcoule);
					},
					$elm$core$Process$sleep(delaiMs));
			case 255:
				var lecture = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Comptes$MonCompte$Update$Lue(lecture),
							$author$project$Main$Update$MonCompteMsg)),
					$author$project$Components$Comptes$MonCompte$API$HttpAPI$lireReq(requete));
			case 256:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Comptes$MonCompte$Update$CommandeRepondue, $author$project$Main$Update$MonCompteMsg)),
					$author$project$Components$Comptes$MonCompte$API$HttpAPI$envoyerReq(requete));
			case 258:
				var lecture = effet.a;
				var requete = effet.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Comptes$Securite$Update$Lue(lecture),
							$author$project$Main$Update$SecuriteMsg)),
					$author$project$Components$Comptes$Securite$API$HttpAPI$lireReq(requete));
			case 259:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Comptes$Securite$Update$CommandeRepondue, $author$project$Main$Update$SecuriteMsg)),
					$author$project$Components$Comptes$Securite$API$HttpAPI$envoyerReq(requete));
			case 257:
				var delaiMs = effet.a;
				return A2(
					$elm$core$Task$perform,
					function (_v98) {
						return $author$project$Main$Update$MonCompteMsg($author$project$Components$Comptes$MonCompte$Update$DelaiDeRelectureEcoule);
					},
					$elm$core$Process$sleep(delaiMs));
			case 260:
				var requete = effet.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Main$parLaSession(
						A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$Conservation$Update$CommandeRepondue, $author$project$Main$Update$ConservationMsg)),
					$author$project$Components$Parametrage$Conservation$API$HttpAPI$envoyerReq(requete));
			case 261:
				var delaiMs = effet.a;
				return A2(
					$elm$core$Task$perform,
					function (_v99) {
						return $author$project$Main$Update$ConservationMsg($author$project$Components$Parametrage$Conservation$Update$DelaiDeRelectureEcoule);
					},
					$elm$core$Process$sleep(delaiMs));
			case 203:
				var delaiMs = effet.a;
				return A2(
					$elm$core$Task$perform,
					function (_v100) {
						return $author$project$Main$Update$DroitsMsg($author$project$Components$Parametrage$Droits$Update$DelaiDeRelectureEcoule);
					},
					$elm$core$Process$sleep(delaiMs));
			case 172:
				switch (effet.a) {
					case 0:
						var _v79 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Types$Update$AnnuaireLu, $author$project$Main$Update$TypesDePartiesPrenantesMsg)),
							$author$project$Components$Referentiel$Common$API$HttpAPI$lireReq(requete));
					case 1:
						var _v101 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Type$Update$FicheLue, $author$project$Main$Update$TypeDePartiePrenanteMsg)),
							$author$project$Components$Referentiel$Common$API$HttpAPI$lireReq(requete));
					case 2:
						var _v102 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Type$Update$OffresLues, $author$project$Main$Update$TypeDePartiePrenanteMsg)),
							$author$project$Components$Referentiel$Common$API$HttpAPI$lireReq(requete));
					case 3:
						var _v103 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Types$Update$OffresLues, $author$project$Main$Update$TypesDePartiesPrenantesMsg)),
							$author$project$Components$Referentiel$Common$API$HttpAPI$lireReq(requete));
					case 4:
						var _v104 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Types$Update$PerimetresLus, $author$project$Main$Update$TypesDePartiesPrenantesMsg)),
							$author$project$Components$Referentiel$Common$API$HttpAPI$lireReq(requete));
					default:
						var _v105 = effet.a;
						var requete = effet.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Main$parLaSession(
								A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Type$Update$ListeDePrixLue, $author$project$Main$Update$TypeDePartiePrenanteMsg)),
							$author$project$Components$Referentiel$Common$API$HttpAPI$lireReq(requete));
				}
			case 279:
				if (!effet.a) {
					var _v80 = effet.a;
					var requete = effet.b;
					return A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Main$parLaSession(
							A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Types$Update$CommandeRepondue, $author$project$Main$Update$TypesDePartiesPrenantesMsg)),
						$author$project$Components$Referentiel$Common$API$HttpAPI$envoyerAuTypeReq(requete));
				} else {
					var requete = effet.b;
					return A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Main$parLaSession(
							A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Type$Update$CommandeRepondue, $author$project$Main$Update$TypeDePartiePrenanteMsg)),
						$author$project$Components$Referentiel$Common$API$HttpAPI$envoyerAuTypeReq(requete));
				}
			case 200:
				if (!effet.a) {
					var _v81 = effet.a;
					var delaiMs = effet.b;
					return A2(
						$elm$core$Task$perform,
						function (_v82) {
							return $author$project$Main$Update$TypesDePartiesPrenantesMsg($author$project$Components$Referentiel$Types$Update$DelaiDeRelectureEcoule);
						},
						$elm$core$Process$sleep(delaiMs));
				} else {
					var delaiMs = effet.b;
					return A2(
						$elm$core$Task$perform,
						function (_v106) {
							return $author$project$Main$Update$TypeDePartiePrenanteMsg($author$project$Components$Referentiel$Type$Update$DelaiDeRelectureEcoule);
						},
						$elm$core$Process$sleep(delaiMs));
				}
			default:
				var uid = effet.a;
				var delaiMs = effet.b;
				return A2(
					$elm$core$Task$perform,
					function (_v107) {
						return $author$project$Main$Update$FicheMsg(
							$author$project$Components$Referentiel$Fiche$Update$DelaiEcoule(uid));
					},
					$elm$core$Process$sleep(delaiMs));
		}
	});
var $author$project$Main$executerTous = F2(
	function (key, effets) {
		return $elm$core$Platform$Cmd$batch(
			A2(
				$elm$core$List$map,
				$author$project$Main$executer(key),
				effets));
	});
var $author$project$Routes$Route$Alertes = {$: 33};
var $author$project$Main$Model$PourLaSession = 0;
var $author$project$Main$Update$aleaDeLaSession = function (effets) {
	return A2(
		$elm$core$List$filterMap,
		function (effet) {
			if (!effet.$) {
				return $elm$core$Maybe$Just(0);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		effets);
};
var $author$project$Main$Update$ChargerAdresse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Main$Update$DemanderAlea = function (a) {
	return {$: 9, a: a};
};
var $author$project$Main$Update$EchangerCode = function (a) {
	return {$: 11, a: a};
};
var $author$project$Main$Update$LireEspaces = function (a) {
	return {$: 15, a: a};
};
var $author$project$Main$Update$LireLHeureDeLaSession = {$: 12};
var $author$project$Main$Update$LireLesPreferencesDeLaSession = function (a) {
	return {$: 16, a: a};
};
var $author$project$Main$Update$LireLesTraductions = function (a) {
	return {$: 17, a: a};
};
var $author$project$Main$Update$LireRacine = function (a) {
	return {$: 14, a: a};
};
var $author$project$Main$Update$PartirVers = function (a) {
	return {$: 10, a: a};
};
var $author$project$Main$Update$RemplacerAdresse = function (a) {
	return {$: 18, a: a};
};
var $author$project$Main$Update$RenouvelerLeJetonDeLaSession = function (a) {
	return {$: 13, a: a};
};
var $author$project$Main$Update$SignalerIncidentDeSession = function (a) {
	return {$: 19, a: a};
};
var $author$project$Main$Update$EcrirePreferences = function (a) {
	return {$: 8, a: a};
};
var $author$project$Main$Update$garder = F2(
	function (preferences, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{eF: preferences}),
			_Utils_ap(
				effets,
				_List_fromArray(
					[
						$author$project$Main$Update$EcrirePreferences(preferences)
					])));
	});
var $author$project$Preferences$Model$setDernierEspace = F2(
	function (alias, preferences) {
		return _Utils_update(
			preferences,
			{
				xi: $elm$core$Maybe$Just(alias)
			});
	});
var $author$project$Main$Update$depuisLaSession = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		var puis = function (suivant) {
			return _Utils_Tuple2(
				model,
				_Utils_ap(
					effets,
					_List_fromArray(
						[suivant])));
		};
		switch (effet.$) {
			case 0:
				var nombre = effet.a;
				return puis(
					$author$project$Main$Update$DemanderAlea(nombre));
			case 1:
				var depart = effet.a;
				return puis(
					$author$project$Main$Update$PartirVers(depart));
			case 2:
				var adresse = effet.a;
				return puis(
					$author$project$Main$Update$ChargerAdresse(adresse));
			case 3:
				var echange = effet.a;
				return puis(
					$author$project$Main$Update$EchangerCode(echange));
			case 11:
				return puis($author$project$Main$Update$LireLHeureDeLaSession);
			case 12:
				var demande = effet.a;
				return puis(
					$author$project$Main$Update$RenouvelerLeJetonDeLaSession(demande));
			case 4:
				var lecture = effet.a;
				return puis(
					$author$project$Main$Update$LireRacine(lecture));
			case 5:
				var lecture = effet.a;
				return puis(
					$author$project$Main$Update$LireEspaces(lecture));
			case 7:
				var lecture = effet.a;
				return puis(
					$author$project$Main$Update$LireLesPreferencesDeLaSession(lecture));
			case 8:
				var lecture = effet.a;
				return puis(
					$author$project$Main$Update$LireLesTraductions(lecture));
			case 6:
				var alias = effet.a;
				return A2(
					$author$project$Main$Update$garder,
					A2($author$project$Preferences$Model$setDernierEspace, alias, model.eF),
					_Utils_Tuple2(model, effets));
			case 9:
				var adresse = effet.a;
				return puis(
					$author$project$Main$Update$RemplacerAdresse(adresse));
			default:
				var incident = effet.a;
				return puis(
					$author$project$Main$Update$SignalerIncidentDeSession(incident));
		}
	});
var $author$project$Main$Update$LireTheme = function (a) {
	return {$: 3, a: a};
};
var $author$project$Main$Update$PoserFavicon = function (a) {
	return {$: 5, a: a};
};
var $author$project$Main$Update$SignalerIncident = function (a) {
	return {$: 4, a: a};
};
var $author$project$Main$Update$depuisLeTheme = function (effet) {
	switch (effet.$) {
		case 0:
			var requete = effet.a;
			return $author$project$Main$Update$LireTheme(requete);
		case 1:
			var incident = effet.a;
			return $author$project$Main$Update$SignalerIncident(incident);
		default:
			var adresse = effet.a;
			return $author$project$Main$Update$PoserFavicon(adresse);
	}
};
var $author$project$Components$Imports$Outil$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Imports$Outil$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Parametrage$Droits$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Parametrage$Droits$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Parametrage$PipeEtape1$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Parametrage$PipeEtape1$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Parametrage$PipeEtape2$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Parametrage$PipeEtape2$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Parametrage$PipeEtape3$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Parametrage$PipeEtape3$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Parametrage$PipeEtape4$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Parametrage$PipeEtape4$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Parametrage$PipeEtape5$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Parametrage$PipeEtape5$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Parametrage$PipeEtape6$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Parametrage$PipeEtape6$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Parametrage$PipeEtape7$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Parametrage$PipeEtape7$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Parametrage$Utilisateurs$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Parametrage$Utilisateurs$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Produits$Catalogue$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Produits$Catalogue$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Produits$Correspondances$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Produits$Correspondances$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Produits$FicheElement$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Produits$FicheElement$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Produits$FicheType$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Produits$FicheType$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Produits$ListeDePrix$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Produits$ListeDePrix$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Produits$Listes$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Produits$Listes$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Produits$MarquesEtGammes$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Produits$MarquesEtGammes$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Produits$Offre$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Produits$Offre$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Produits$Offres$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Produits$Offres$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Produits$Perimetres$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Produits$Perimetres$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Produits$Reference$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Produits$Reference$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Produits$SchemaDeNiveau$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Produits$SchemaDeNiveau$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Produits$StructureCatalogue$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Produits$StructureCatalogue$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Produits$TypesDeQuantite$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Produits$TypesDeQuantite$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Referentiel$Doublons$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Referentiel$Doublons$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Referentiel$Fiche$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Referentiel$Fiche$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Referentiel$Groupe$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Referentiel$Groupe$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Referentiel$NouvelleFiche$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Referentiel$PartiesPrenantes$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Referentiel$PartiesPrenantes$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Referentiel$Type$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Referentiel$Type$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Referentiel$Types$Model$Enveloppe = $elm$core$Basics$identity;
var $author$project$Components$Referentiel$Types$Model$envelopper = function (model) {
	return model;
};
var $author$project$Components$Shared$Version$Model$Version = F2(
	function (commit, dateBuild) {
		return {vN: commit, ww: dateBuild};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Components$Shared$Version$Model$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'dateBuild',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'commit',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Components$Shared$Version$Model$Version)));
var $author$project$Components$Shared$Version$Model$fromFlags = $elm$json$Json$Decode$decodeValue(
	A2($elm$json$Json$Decode$field, 'version', $author$project$Components$Shared$Version$Model$decoder));
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $author$project$Preferences$Model$Preferences = F3(
	function (menuReplie, annuaires, dernierEspace) {
		return {aq: annuaires, xi: dernierEspace, Cr: menuReplie};
	});
var $author$project$Preferences$Model$Gardees = F2(
	function (vue, filtresMasques) {
		return {mH: filtresMasques, io: vue};
	});
var $author$project$Preferences$Model$champ = F3(
	function (nom, lecture, parDefaut) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2($elm$json$Json$Decode$field, nom, lecture),
					$elm$json$Json$Decode$succeed(parDefaut)
				]));
	});
var $author$project$Preferences$Model$Cartes = 0;
var $author$project$Preferences$Model$Tableau = 1;
var $author$project$Preferences$Model$vueFromString = function (vue) {
	return (vue === 'tableau') ? 1 : 0;
};
var $author$project$Preferences$Model$annuaireDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Preferences$Model$Gardees,
	A3(
		$author$project$Preferences$Model$champ,
		'vue',
		A2(
			$elm$json$Json$Decode$map,
			A2($elm$core$Basics$composeR, $author$project$Preferences$Model$vueFromString, $elm$core$Maybe$Just),
			$elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing),
	A3($author$project$Preferences$Model$champ, 'filtresMasques', $elm$json$Json$Decode$bool, false));
var $author$project$Preferences$Model$defaut = {aq: $elm$core$Dict$empty, xi: $elm$core$Maybe$Nothing, Cr: false};
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Preferences$Model$parVersion = function (version) {
	return (version === 1) ? A4(
		$elm$json$Json$Decode$map3,
		$author$project$Preferences$Model$Preferences,
		A3($author$project$Preferences$Model$champ, 'menuReplie', $elm$json$Json$Decode$bool, $author$project$Preferences$Model$defaut.Cr),
		A3(
			$author$project$Preferences$Model$champ,
			'annuaires',
			$elm$json$Json$Decode$dict($author$project$Preferences$Model$annuaireDecoder),
			$author$project$Preferences$Model$defaut.aq),
		A3(
			$author$project$Preferences$Model$champ,
			'dernierEspace',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$author$project$Preferences$Model$defaut.xi)) : $elm$json$Json$Decode$succeed($author$project$Preferences$Model$defaut);
};
var $author$project$Preferences$Model$decoder = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$Preferences$Model$parVersion,
	A2($elm$json$Json$Decode$field, 'version', $elm$json$Json$Decode$int));
var $author$project$Preferences$Model$fromFlags = function (flags) {
	return A2(
		$elm$core$Result$withDefault,
		$author$project$Preferences$Model$defaut,
		A2(
			$elm$core$Result$andThen,
			$elm$json$Json$Decode$decodeString($author$project$Preferences$Model$decoder),
			A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$field, 'preferences', $elm$json$Json$Decode$string),
				flags)));
};
var $author$project$Routes$Route$DemonstrationIntrouvable = {$: 74};
var $author$project$Routes$Route$ElementIntrouvable = {$: 24};
var $author$project$Routes$Route$FicheIntrouvable = {$: 5};
var $author$project$Routes$Route$ListeDePrixIntrouvable = {$: 39};
var $author$project$Routes$Route$OffreIntrouvable = {$: 32};
var $author$project$Routes$Route$ReferenceIntrouvable = {$: 29};
var $author$project$Routes$Route$TypeDePartiePrenanteIntrouvable = {$: 70};
var $author$project$Routes$Route$TypeIntrouvable = {$: 41};
var $author$project$Routes$Route$Version = {$: 0};
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {aZ: frag, ba: params, aP: unvisited, ap: value, bo: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.aP;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.ap);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.ap);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.E6),
					$elm$url$Url$Parser$prepareQuery(url.eI),
					url.zY,
					$elm$core$Basics$identity)));
	});
var $author$project$Routes$Route$ARangerDuCatalogue = function (a) {
	return {$: 26, a: a};
};
var $author$project$Routes$Route$Accueil = {$: 1};
var $author$project$Routes$Route$AlertesDePartiesPrenantes = {$: 34};
var $author$project$Routes$Route$BibliothequeDeChamps = function (a) {
	return {$: 51, a: a};
};
var $author$project$Routes$Route$Catalogue = function (a) {
	return {$: 25, a: a};
};
var $author$project$Routes$Route$ChampsDuNiveau = function (a) {
	return {$: 7, a: a};
};
var $author$project$Routes$Route$CompteDEnvoi = {$: 61};
var $author$project$Routes$Route$CompteurDeCode = {$: 60};
var $author$project$Routes$Route$Correspondances = {$: 46};
var $author$project$Routes$Route$Demonstration = {$: 71};
var $author$project$Routes$Route$Dossiers = 1;
var $author$project$Routes$Route$Doublons = {$: 35};
var $author$project$Routes$Route$DoublonsEcartees = {$: 36};
var $author$project$Routes$Route$EcheancesDeConservation = {$: 54};
var $author$project$Routes$Route$FicheCorrespondance = function (a) {
	return {$: 50, a: a};
};
var $author$project$Routes$Route$FicheDeGroupe = F2(
	function (a, b) {
		return {$: 52, a: a, b: b};
	});
var $author$project$Routes$Route$FicheElement = function (a) {
	return {$: 23, a: a};
};
var $author$project$Routes$Route$FicheListe = function (a) {
	return {$: 45, a: a};
};
var $author$project$Routes$Route$FicheListeDePrix = function (a) {
	return {$: 38, a: a};
};
var $author$project$Routes$Route$FicheOffre = function (a) {
	return {$: 31, a: a};
};
var $author$project$Routes$Route$FichePerimetre = function (a) {
	return {$: 48, a: a};
};
var $author$project$Routes$Route$FicheReference = function (a) {
	return {$: 28, a: a};
};
var $author$project$Routes$Route$FicheType = function (a) {
	return {$: 40, a: a};
};
var $author$project$Routes$Route$FicheTypeDePartiePrenante = F2(
	function (a, b) {
		return {$: 69, a: a, b: b};
	});
var $author$project$Routes$Route$FicheUtilisateur = function (a) {
	return {$: 58, a: a};
};
var $author$project$Routes$Route$Groupes = {$: 43};
var $author$project$Routes$Route$HistoriqueDesImports = {$: 67};
var $author$project$Routes$Route$Importer = F2(
	function (a, b) {
		return {$: 66, a: a, b: b};
	});
var $author$project$Routes$Route$Informations = 3;
var $author$project$Routes$Route$JournalDesConnexions = function (a) {
	return {$: 59, a: a};
};
var $author$project$Routes$Route$LanguesDuClient = {$: 55};
var $author$project$Routes$Route$Listes = {$: 44};
var $author$project$Routes$Route$ListesDePrix = {$: 37};
var $author$project$Routes$Route$LotDImport = function (a) {
	return {$: 68, a: a};
};
var $author$project$Routes$Route$MarquesEtGammes = {$: 8};
var $author$project$Routes$Route$ModelesDeTache = {$: 10};
var $author$project$Routes$Route$MonCompte = {$: 63};
var $author$project$Routes$Route$MonCompteSecurite = {$: 64};
var $author$project$Routes$Route$MonCompteSessions = {$: 65};
var $author$project$Routes$Route$Notifications = {$: 62};
var $author$project$Routes$Route$NouvelleReference = {$: 27};
var $author$project$Routes$Route$Offres = {$: 30};
var $author$project$Routes$Route$OngletChamps = 1;
var $author$project$Routes$Route$OngletGeneral = 0;
var $author$project$Routes$Route$ParametrageCatalogue = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Routes$Route$PartiesPrenantes = 0;
var $author$project$Routes$Route$PartiesPrenantesListe = function (a) {
	return {$: 2, a: a};
};
var $author$project$Routes$Route$Perimetres = {$: 47};
var $author$project$Routes$Route$PipeDestinations = F2(
	function (a, b) {
		return {$: 21, a: a, b: b};
	});
var $author$project$Routes$Route$PipeEtape1 = function (a) {
	return {$: 11, a: a};
};
var $author$project$Routes$Route$PipeEtape2 = function (a) {
	return {$: 12, a: a};
};
var $author$project$Routes$Route$PipeEtape3 = function (a) {
	return {$: 13, a: a};
};
var $author$project$Routes$Route$PipeEtape4 = function (a) {
	return {$: 14, a: a};
};
var $author$project$Routes$Route$PipeEtape5 = function (a) {
	return {$: 15, a: a};
};
var $author$project$Routes$Route$PipeEtape6 = function (a) {
	return {$: 16, a: a};
};
var $author$project$Routes$Route$PipeEtape7 = function (a) {
	return {$: 17, a: a};
};
var $author$project$Routes$Route$PipeEtape8 = function (a) {
	return {$: 18, a: a};
};
var $author$project$Routes$Route$PipeOffreUsage = function (a) {
	return {$: 20, a: a};
};
var $author$project$Routes$Route$PipeRelationsExigees = function (a) {
	return {$: 22, a: a};
};
var $author$project$Routes$Route$PipeVersions = function (a) {
	return {$: 19, a: a};
};
var $author$project$Routes$Route$Pipes = {$: 9};
var $author$project$Routes$Route$SecuriteDesUtilisateurs = {$: 57};
var $author$project$Routes$Route$TypesDeQuantite = {$: 49};
var $author$project$Routes$Route$Utilisateurs = {$: 56};
var $author$project$Catalogue$Identifiants$ClassificationId = $elm$core$Basics$identity;
var $author$project$Catalogue$Identifiants$classificationIdFromString = function (valeur) {
	return $elm$core$String$isEmpty(valeur) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(valeur);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.bo;
			var unvisited = _v0.aP;
			var params = _v0.ba;
			var frag = _v0.aZ;
			var value = _v0.ap;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$Internal$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return function (dict) {
			return func(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, key, dict)));
		};
	});
var $author$project$Catalogue$Identifiants$ElementId = $elm$core$Basics$identity;
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $elm$core$Char$isHexDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return ((48 <= code) && (code <= 57)) || (((65 <= code) && (code <= 70)) || ((97 <= code) && (code <= 102)));
};
var $author$project$Catalogue$Identifiants$uuid = function (valeur) {
	var groupes = A2($elm$core$String$split, '-', valeur);
	return (_Utils_eq(
		A2($elm$core$List$map, $elm$core$String$length, groupes),
		_List_fromArray(
			[8, 4, 4, 4, 12])) && A2(
		$elm$core$List$all,
		$elm$core$String$all($elm$core$Char$isHexDigit),
		groupes)) ? $elm$core$Maybe$Just(
		$elm$core$String$toLower(valeur)) : $elm$core$Maybe$Nothing;
};
var $author$project$Catalogue$Identifiants$elementIdFromString = A2(
	$elm$core$Basics$composeR,
	$author$project$Catalogue$Identifiants$uuid,
	$elm$core$Maybe$map($elm$core$Basics$identity));
var $author$project$Routes$Route$CeQueLeRolePeutFaire = 1;
var $author$project$Routes$Route$LesChampsVus = 3;
var $author$project$Routes$Route$LesFichesVues = 2;
var $author$project$Routes$Route$QuiALeRole = 4;
var $author$project$Routes$Route$VoirComme = 5;
var $author$project$Routes$Route$VosRoles = 0;
var $author$project$Routes$Route$etapesDesDroits = _List_fromArray(
	[0, 1, 2, 3, 4, 5]);
var $author$project$Routes$Route$AQuellesOffres = 2;
var $author$project$Routes$Route$FichePourVerifier = 7;
var $author$project$Routes$Route$InformationsADemander = 4;
var $author$project$Routes$Route$LaDureeDeConservation = 5;
var $author$project$Routes$Route$LesLiensEntreFiches = 6;
var $author$project$Routes$Route$QuiPeutPorterLeRole = 1;
var $author$project$Routes$Route$StatutsEtResultats = 3;
var $author$project$Routes$Route$VosTypes = 0;
var $author$project$Routes$Route$etapesDesTypes = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7]);
var $author$project$Routes$Route$Rangement = 1;
var $author$project$Routes$Route$Typologies = 0;
var $author$project$Routes$Route$Valeurs = 2;
var $author$project$Routes$Route$Verification = 4;
var $author$project$Routes$Route$etapesDuCatalogue = _List_fromArray(
	[0, 1, 2, 3, 4]);
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.bo;
		var unvisited = _v0.aP;
		var params = _v0.ba;
		var frag = _v0.aZ;
		var value = _v0.ap;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $author$project$Routes$Route$segmentParametrage = 'parametrage';
var $author$project$Routes$Route$segmentTypesDePartiesPrenantes = 'types-de-parties-prenantes';
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $author$project$Components$Referentiel$Identifiants$TypeUid = $elm$core$Basics$identity;
var $author$project$Components$Referentiel$Identifiants$EntiteUid = $elm$core$Basics$identity;
var $author$project$Components$Referentiel$Identifiants$entiteUidFromString = function (valeur) {
	var groupes = A2($elm$core$String$split, '-', valeur);
	return (_Utils_eq(
		A2($elm$core$List$map, $elm$core$String$length, groupes),
		_List_fromArray(
			[8, 4, 4, 4, 12])) && A2(
		$elm$core$List$all,
		$elm$core$String$all($elm$core$Char$isHexDigit),
		groupes)) ? $elm$core$Maybe$Just(
		$elm$core$String$toLower(valeur)) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$Referentiel$Identifiants$typeUidFromString = function (valeur) {
	return A2(
		$elm$core$Maybe$map,
		A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Identifiants$entiteUidToString, $elm$core$Basics$identity),
		$author$project$Components$Referentiel$Identifiants$entiteUidFromString(valeur));
};
var $author$project$Routes$Route$ficheDeType = A2(
	$elm$url$Url$Parser$slash,
	$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$s($author$project$Routes$Route$segmentTypesDePartiesPrenantes),
		A2($elm$url$Url$Parser$custom, 'TYPE', $author$project$Components$Referentiel$Identifiants$typeUidFromString)));
var $author$project$Components$Referentiel$Identifiants$GroupeUid = $elm$core$Basics$identity;
var $author$project$Components$Referentiel$Identifiants$groupeUidFromString = function (valeur) {
	return A2(
		$elm$core$Maybe$map,
		A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Identifiants$entiteUidToString, $elm$core$Basics$identity),
		$author$project$Components$Referentiel$Identifiants$entiteUidFromString(valeur));
};
var $elm$url$Url$Parser$Query$int = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$String$toInt(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $author$project$Catalogue$Identifiants$ListeDePrixId = $elm$core$Basics$identity;
var $author$project$Catalogue$Identifiants$listeDePrixIdFromString = A2(
	$elm$core$Basics$composeR,
	$author$project$Catalogue$Identifiants$uuid,
	$elm$core$Maybe$map($elm$core$Basics$identity));
var $author$project$Routes$Route$codeAdmis = function (code) {
	return (code !== '') && A2(
		$elm$core$String$all,
		function (c) {
			return $elm$core$Char$isAlphaNum(c) || ((c === '-') || (c === '_'));
		},
		code);
};
var $author$project$Routes$Route$champCoche = function (entree) {
	var _v0 = A2($elm$core$String$split, ':', entree);
	if (_v0.b && _v0.b.b) {
		var cle = _v0.a;
		var _v1 = _v0.b;
		var premier = _v1.a;
		var suite = _v1.b;
		var valeur = A2(
			$elm$core$String$join,
			':',
			A2($elm$core$List$cons, premier, suite));
		return ($author$project$Routes$Route$codeAdmis(cle) && (valeur !== '')) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(cle, valeur)) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Routes$Route$parmi = F2(
	function (connu, code) {
		return A2(
			$elm$core$Maybe$andThen,
			function (lu) {
				return connu(lu) ? $elm$core$Maybe$Just(lu) : $elm$core$Maybe$Nothing;
			},
			code);
	});
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $author$project$Routes$Route$plageLue = function (entree) {
	var cleAdmise = function (cle) {
		var _v3 = A2($elm$core$String$split, '.', cle);
		if ((_v3.b && _v3.b.b) && (!_v3.b.b.b)) {
			var groupe = _v3.a;
			var _v4 = _v3.b;
			var mesure = _v4.a;
			return $author$project$Routes$Route$codeAdmis(groupe) && $author$project$Routes$Route$codeAdmis(mesure);
		} else {
			return false;
		}
	};
	var borne = function (texte) {
		return (texte === '') ? $elm$core$Maybe$Just($elm$core$Maybe$Nothing) : A2(
			$elm$core$Maybe$andThen,
			function (nombre) {
				return ($elm$core$Basics$isNaN(nombre) || $elm$core$Basics$isInfinite(nombre)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$elm$core$Maybe$Just(nombre));
			},
			$elm$core$String$toFloat(texte));
	};
	var _v0 = A2($elm$core$String$split, ':', entree);
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
		var cle = _v0.a;
		var _v1 = _v0.b;
		var minimum = _v1.a;
		var _v2 = _v1.b;
		var maximum = _v2.a;
		return (cleAdmise(cle) && ((minimum !== '') || (maximum !== ''))) ? A3(
			$elm$core$Maybe$map2,
			F2(
				function (bas, haut) {
					return _Utils_Tuple2(
						cle,
						_Utils_Tuple2(bas, haut));
				}),
			borne(minimum),
			borne(maximum)) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Routes$Route$tailleParDefaut = 50;
var $author$project$Routes$Route$taillesPermises = _List_fromArray(
	[25, 50, 100]);
var $author$project$Routes$Route$triParDefautDesReferences = 'code';
var $author$project$Routes$Route$trisDesReferences = _List_fromArray(
	['code', '-code', 'nom', '-nom', 'etat', '-etat']);
var $author$project$Routes$Route$uniques = A2(
	$elm$core$List$foldl,
	F2(
		function (code, vus) {
			return A2($elm$core$List$member, code, vus) ? vus : _Utils_ap(
				vus,
				_List_fromArray(
					[code]));
		}),
	_List_Nil);
var $author$project$Routes$Route$valeurArretees = 'oui';
var $author$project$Routes$Route$listeDeReferencesLue = F3(
	function (_v0, _v1, _v6) {
		var page = _v0.a;
		var taille = _v0.b;
		var tri = _v0.c;
		var _v2 = _v1.a;
		var etats = _v2.a;
		var marques = _v2.b;
		var gammes = _v2.c;
		var _v3 = _v1.b;
		var _v4 = _v3.a;
		var typologies = _v4.a;
		var familles = _v4.b;
		var categories = _v4.c;
		var _v5 = _v3.b;
		var completude = _v5.a;
		var arretees = _v5.b;
		var champs = _v5.c;
		var typeDeProduit = _v6.a;
		var renseignes = _v6.b;
		var plages = _v6.c;
		var codes = A2(
			$elm$core$Basics$composeR,
			$elm$core$List$filter($author$project$Routes$Route$codeAdmis),
			$author$project$Routes$Route$uniques);
		return {
			i2: _Utils_eq(
				arretees,
				$elm$core$Maybe$Just($author$project$Routes$Route$valeurArretees)),
			dt: codes(categories),
			dw: $author$project$Routes$Route$uniques(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Routes$Route$champCoche,
						$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
					champs)),
			fU: A2(
				$author$project$Routes$Route$parmi,
				function (code) {
					return A2(
						$elm$core$List$member,
						code,
						_List_fromArray(
							['completes', 'incompletes']));
				},
				completude),
			mj: codes(etats),
			mu: codes(familles),
			gG: codes(gammes),
			cU: codes(marques),
			EE: A2(
				$elm$core$Basics$max,
				1,
				A2($elm$core$Maybe$withDefault, 1, page)),
			pn: $author$project$Routes$Route$uniques(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Routes$Route$plageLue,
						$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
					plages)),
			qs: codes(renseignes),
			Jm: A2(
				$elm$core$Maybe$withDefault,
				$author$project$Routes$Route$tailleParDefaut,
				A2(
					$elm$core$Maybe$andThen,
					function (demandee) {
						return A2($elm$core$List$member, demandee, $author$project$Routes$Route$taillesPermises) ? $elm$core$Maybe$Just(demandee) : $elm$core$Maybe$Nothing;
					},
					taille)),
			rS: A2(
				$elm$core$Maybe$withDefault,
				$author$project$Routes$Route$triParDefautDesReferences,
				A2(
					$elm$core$Maybe$andThen,
					function (demande) {
						return A2($elm$core$List$member, demande, $author$project$Routes$Route$trisDesReferences) ? $elm$core$Maybe$Just(demande) : $elm$core$Maybe$Nothing;
					},
					tri)),
			fh: A2(
				$elm$core$Maybe$andThen,
				function (code) {
					return $author$project$Routes$Route$codeAdmis(code) ? $elm$core$Maybe$Just(code) : $elm$core$Maybe$Nothing;
				},
				typeDeProduit),
			r7: codes(typologies)
		};
	});
var $author$project$Routes$Route$ParNom = 0;
var $author$project$Routes$Route$ValeurOuiNon = function (a) {
	return {$: 1, a: a};
};
var $author$project$Routes$Route$ValeurTexte = function (a) {
	return {$: 0, a: a};
};
var $author$project$Routes$Route$cleDeChampValide = function (cle) {
	var _v0 = $elm$core$String$uncons(cle);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var premier = _v1.a;
		var reste = _v1.b;
		return $elm$core$Char$isLower(premier) && A2(
			$elm$core$String$all,
			function (c) {
				return $elm$core$Char$isLower(c) || ($elm$core$Char$isDigit(c) || (c === '_'));
			},
			reste);
	} else {
		return false;
	}
};
var $author$project$Routes$Route$filtreDeChampDeLAdresse = function (entree) {
	var _v0 = A2($elm$core$String$split, '.', entree);
	if ((_v0.b && _v0.b.b) && _v0.b.b.b) {
		var type_ = _v0.a;
		var _v1 = _v0.b;
		var cle = _v1.a;
		var _v2 = _v1.b;
		var genre = _v2.a;
		var reste = _v2.b;
		if (_Utils_eq(
			$author$project$Components$Referentiel$Identifiants$typeUidFromString(type_),
			$elm$core$Maybe$Nothing) || (!$author$project$Routes$Route$cleDeChampValide(cle))) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v3 = _Utils_Tuple2(
				genre,
				A2($elm$core$String$join, '.', reste));
			_v3$3:
			while (true) {
				switch (_v3.a) {
					case 't':
						var texte = _v3.b;
						return A2(
							$elm$core$Maybe$andThen,
							function (decode) {
								return $elm$core$String$isEmpty(decode) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
									{
										dy: cle,
										r0: type_,
										fm: $author$project$Routes$Route$ValeurTexte(decode)
									});
							},
							$elm$url$Url$percentDecode(texte));
					case 'b':
						switch (_v3.b) {
							case 'true':
								return $elm$core$Maybe$Just(
									{
										dy: cle,
										r0: type_,
										fm: $author$project$Routes$Route$ValeurOuiNon(true)
									});
							case 'false':
								return $elm$core$Maybe$Just(
									{
										dy: cle,
										r0: type_,
										fm: $author$project$Routes$Route$ValeurOuiNon(false)
									});
							default:
								break _v3$3;
						}
					default:
						break _v3$3;
				}
			}
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Identifiants$typeUidToString = function (_v0) {
	var valeur = _v0;
	return valeur;
};
var $author$project$Routes$Route$normaliser = function (demandee) {
	return {
		mG: {
			dw: demandee.mG.dw,
			gt: A2(
				$author$project$Routes$Route$parmi,
				function (code) {
					return A2(
						$elm$core$List$member,
						code,
						_List_fromArray(
							['closes', 'supprimees']));
				},
				demandee.mG.gt),
			m2: A2(
				$author$project$Routes$Route$parmi,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Referentiel$Identifiants$groupeUidFromString,
					$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
				demandee.mG.m2),
			g1: A2(
				$author$project$Routes$Route$parmi,
				function (code) {
					return A2(
						$elm$core$List$member,
						code,
						_List_fromArray(
							['Personne', 'Organisation']));
				},
				demandee.mG.g1),
			D1: A2(
				$author$project$Routes$Route$parmi,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$trim,
					A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not)),
				demandee.mG.D1),
			ho: demandee.mG.ho,
			hy: A2(
				$author$project$Routes$Route$parmi,
				function (code) {
					return A2(
						$elm$core$List$member,
						code,
						_List_fromArray(
							['Particulier', 'Professionnel']));
				},
				demandee.mG.hy),
			qs: $author$project$Routes$Route$uniques(
				A2($elm$core$List$filter, $author$project$Routes$Route$codeAdmis, demandee.mG.qs)),
			ib: $author$project$Routes$Route$uniques(
				A2(
					$elm$core$List$filterMap,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Referentiel$Identifiants$typeUidFromString,
						$elm$core$Maybe$map($author$project$Components$Referentiel$Identifiants$typeUidToString)),
					demandee.mG.ib))
		},
		EE: A2($elm$core$Basics$max, 1, demandee.EE),
		Jm: A2($elm$core$List$member, demandee.Jm, $author$project$Routes$Route$taillesPermises) ? demandee.Jm : $author$project$Routes$Route$tailleParDefaut,
		rS: demandee.rS
	};
};
var $author$project$Routes$Route$ParNomDecroissant = 1;
var $author$project$Routes$Route$codeDuTri = function (tri) {
	if (!tri) {
		return 'nom';
	} else {
		return 'nom-desc';
	}
};
var $author$project$Routes$Route$triDuCode = function (code) {
	return _Utils_eq(
		code,
		$author$project$Routes$Route$codeDuTri(1)) ? 1 : 0;
};
var $author$project$Routes$Route$lue = function (page) {
	return function (taille) {
		return function (tri) {
			return function (nature) {
				return function (qualite) {
					return function (pays) {
						return function (types) {
							return function (etat) {
								return function (groupe) {
									return function (offre) {
										return function (champs) {
											return function (renseignes) {
												return $author$project$Routes$Route$normaliser(
													{
														mG: {
															dw: A2($elm$core$List$filterMap, $author$project$Routes$Route$filtreDeChampDeLAdresse, champs),
															gt: etat,
															m2: groupe,
															g1: nature,
															D1: offre,
															ho: pays,
															hy: qualite,
															qs: renseignes,
															ib: types
														},
														EE: A2($elm$core$Maybe$withDefault, 1, page),
														Jm: A2($elm$core$Maybe$withDefault, $author$project$Routes$Route$tailleParDefaut, taille),
														rS: A2(
															$elm$core$Maybe$withDefault,
															0,
															A2($elm$core$Maybe$map, $author$project$Routes$Route$triDuCode, tri))
													});
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.bo;
		var unvisited = _v0.aP;
		var params = _v0.ba;
		var frag = _v0.aZ;
		var value = _v0.ap;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.bo;
			var unvisited = _v1.aP;
			var params = _v1.ba;
			var frag = _v1.aZ;
			var value = _v1.ap;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$url$Url$Parser$Query$map2 = F3(
	function (func, _v0, _v1) {
		var a = _v0;
		var b = _v1;
		return function (dict) {
			return A2(
				func,
				a(dict),
				b(dict));
		};
	});
var $elm$url$Url$Parser$Query$map3 = F4(
	function (func, _v0, _v1, _v2) {
		var a = _v0;
		var b = _v1;
		var c = _v2;
		return function (dict) {
			return A3(
				func,
				a(dict),
				b(dict),
				c(dict));
		};
	});
var $elm$url$Url$Parser$Query$map8 = F9(
	function (func, _v0, _v1, _v2, _v3, _v4, _v5, _v6, _v7) {
		var a = _v0;
		var b = _v1;
		var c = _v2;
		var d = _v3;
		var e = _v4;
		var f = _v5;
		var g = _v6;
		var h = _v7;
		return function (dict) {
			return A8(
				func,
				a(dict),
				b(dict),
				c(dict),
				d(dict),
				e(dict),
				f(dict),
				g(dict),
				h(dict));
		};
	});
var $author$project$Catalogue$Identifiants$NiveauId = $elm$core$Basics$identity;
var $author$project$Catalogue$Identifiants$niveauIdFromString = function (valeur) {
	return ((!$elm$core$String$isEmpty(valeur)) && A2(
		$elm$core$String$all,
		function (lettre) {
			return $elm$core$Char$isLower(lettre) || ($elm$core$Char$isDigit(lettre) || (lettre === '-'));
		},
		valeur)) ? $elm$core$Maybe$Just(valeur) : $elm$core$Maybe$Nothing;
};
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $author$project$Routes$Route$OngletDonneesPersonnelles = 4;
var $author$project$Routes$Route$OngletHistorique = 3;
var $author$project$Routes$Route$OngletRattachements = 2;
var $author$project$Routes$Route$OngletResume = 0;
var $author$project$Routes$Route$OngletRoles = 1;
var $author$project$Routes$Route$ongletsDeFiche = _List_fromArray(
	[0, 1, 2, 3, 4]);
var $author$project$Routes$Route$parametreArretees = 'arretees';
var $author$project$Routes$Route$parametreCategorie = 'categories';
var $author$project$Routes$Route$parametreChamp = 'champ';
var $author$project$Routes$Route$parametreChampDeLaBibliotheque = 'champ';
var $author$project$Routes$Route$parametreChamps = 'champs';
var $author$project$Routes$Route$parametreCompletude = 'completude';
var $author$project$Routes$Route$parametreDate = 'date';
var $author$project$Routes$Route$parametreEtat = 'etat';
var $author$project$Routes$Route$parametreFamille = 'familles';
var $author$project$Routes$Route$parametreGamme = 'gammes';
var $author$project$Routes$Route$parametreGroupe = 'groupe';
var $author$project$Routes$Route$parametreMarque = 'marques';
var $author$project$Routes$Route$parametreNature = 'nature';
var $author$project$Routes$Route$parametreOffre = 'offre';
var $author$project$Routes$Route$parametrePage = 'page';
var $author$project$Routes$Route$parametrePays = 'pays';
var $author$project$Routes$Route$parametrePlages = 'plages';
var $author$project$Routes$Route$parametreQualite = 'qualite';
var $author$project$Routes$Route$parametreRenseignes = 'renseignes';
var $author$project$Routes$Route$parametreTaille = 'taille';
var $author$project$Routes$Route$parametreTri = 'tri';
var $author$project$Routes$Route$parametreType = 'type';
var $author$project$Routes$Route$parametreTypeDeProduit = 'type';
var $author$project$Routes$Route$parametreTypologie = 'typologie';
var $elm$url$Url$Parser$query = function (_v0) {
	var queryParser = _v0;
	return function (_v1) {
		var visited = _v1.bo;
		var unvisited = _v1.aP;
		var params = _v1.ba;
		var frag = _v1.aZ;
		var value = _v1.ap;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					queryParser(params)))
			]);
	};
};
var $elm$url$Url$Parser$questionMark = F2(
	function (parser, queryParser) {
		return A2(
			$elm$url$Url$Parser$slash,
			parser,
			$elm$url$Url$Parser$query(queryParser));
	});
var $author$project$Catalogue$Identifiants$ReferenceId = $elm$core$Basics$identity;
var $author$project$Catalogue$Identifiants$referenceIdFromString = A2(
	$elm$core$Basics$composeR,
	$author$project$Catalogue$Identifiants$uuid,
	$elm$core$Maybe$map($elm$core$Basics$identity));
var $author$project$Routes$Route$segmentCatalogue = 'catalogue';
var $author$project$Routes$Route$segmentDesTypologies = 'typologies';
var $author$project$Routes$Route$segmentDEtape = function (etape) {
	switch (etape) {
		case 0:
			return $elm$core$Maybe$Just($author$project$Routes$Route$segmentDesTypologies);
		case 1:
			return $elm$core$Maybe$Nothing;
		case 2:
			return $elm$core$Maybe$Just('valeurs');
		case 3:
			return $elm$core$Maybe$Just('informations');
		default:
			return $elm$core$Maybe$Just('verification');
	}
};
var $author$project$Routes$Route$typologieDeLAdresse = function (valeurs) {
	if (valeurs.b && (!valeurs.b.b)) {
		var texte = valeurs.a;
		return $author$project$Catalogue$Identifiants$classificationIdFromString(texte);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Routes$Route$routeDEtape = function (etape) {
	var parcours = A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
		$elm$url$Url$Parser$s($author$project$Routes$Route$segmentCatalogue));
	var _v0 = $author$project$Routes$Route$segmentDEtape(etape);
	if (_v0.$ === 1) {
		return A2(
			$elm$url$Url$Parser$map,
			$author$project$Routes$Route$ParametrageCatalogue(etape),
			A2(
				$elm$url$Url$Parser$questionMark,
				parcours,
				A2($elm$url$Url$Parser$Query$custom, $author$project$Routes$Route$parametreTypologie, $author$project$Routes$Route$typologieDeLAdresse)));
	} else {
		var segment = _v0.a;
		return A2(
			$elm$url$Url$Parser$map,
			$author$project$Routes$Route$ParametrageCatalogue(etape),
			A2(
				$elm$url$Url$Parser$slash,
				parcours,
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$s(segment),
					A2($elm$url$Url$Parser$Query$custom, $author$project$Routes$Route$parametreTypologie, $author$project$Routes$Route$typologieDeLAdresse))));
	}
};
var $author$project$Routes$Route$Droits = function (a) {
	return {$: 53, a: a};
};
var $author$project$Routes$Route$segmentDEtapeDesDroits = function (etape) {
	switch (etape) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Just('ce-que-le-role-peut-faire');
		case 2:
			return $elm$core$Maybe$Just('fiches-vues');
		case 3:
			return $elm$core$Maybe$Just('champs-vus');
		case 4:
			return $elm$core$Maybe$Just('qui-a-le-role');
		default:
			return $elm$core$Maybe$Just('verification');
	}
};
var $author$project$Routes$Route$segmentDroits = 'droits';
var $author$project$Routes$Route$routeDEtapeDesDroits = function (etape) {
	var parcours = A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
		$elm$url$Url$Parser$s($author$project$Routes$Route$segmentDroits));
	var _v0 = $author$project$Routes$Route$segmentDEtapeDesDroits(etape);
	if (_v0.$ === 1) {
		return A2(
			$elm$url$Url$Parser$map,
			$author$project$Routes$Route$Droits(etape),
			parcours);
	} else {
		var segment = _v0.a;
		return A2(
			$elm$url$Url$Parser$map,
			$author$project$Routes$Route$Droits(etape),
			A2(
				$elm$url$Url$Parser$slash,
				parcours,
				$elm$url$Url$Parser$s(segment)));
	}
};
var $author$project$Routes$Route$TypesDePartiesPrenantes = F2(
	function (a, b) {
		return {$: 42, a: a, b: b};
	});
var $author$project$Routes$Route$segmentDEtapeDesTypes = function (etape) {
	switch (etape) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Just('qui-peut-porter-le-role');
		case 2:
			return $elm$core$Maybe$Just('a-quelles-offres');
		case 3:
			return $elm$core$Maybe$Just('statuts-et-resultats');
		case 4:
			return $elm$core$Maybe$Just('informations');
		case 5:
			return $elm$core$Maybe$Just('conservation');
		case 6:
			return $elm$core$Maybe$Just('liens');
		default:
			return $elm$core$Maybe$Just('verification');
	}
};
var $author$project$Routes$Route$routeDEtapeDesTypes = function (etape) {
	var parcours = A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
		$elm$url$Url$Parser$s($author$project$Routes$Route$segmentTypesDePartiesPrenantes));
	var _v0 = $author$project$Routes$Route$segmentDEtapeDesTypes(etape);
	if (_v0.$ === 1) {
		return A2(
			$elm$url$Url$Parser$map,
			A2($author$project$Routes$Route$TypesDePartiesPrenantes, etape, $elm$core$Maybe$Nothing),
			parcours);
	} else {
		var segment = _v0.a;
		return $elm$url$Url$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$url$Url$Parser$map,
					function (uid) {
						return A2(
							$author$project$Routes$Route$TypesDePartiesPrenantes,
							etape,
							$elm$core$Maybe$Just(uid));
					},
					A2(
						$elm$url$Url$Parser$slash,
						parcours,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s(segment),
							A2($elm$url$Url$Parser$custom, 'TYPE', $author$project$Components$Referentiel$Identifiants$typeUidFromString)))),
					A2(
					$elm$url$Url$Parser$map,
					A2($author$project$Routes$Route$TypesDePartiesPrenantes, 0, $elm$core$Maybe$Nothing),
					A2(
						$elm$url$Url$Parser$slash,
						parcours,
						$elm$url$Url$Parser$s(segment)))
				]));
	}
};
var $author$project$Routes$Route$Fiche = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Routes$Route$segmentDOnglet = function (onglet) {
	switch (onglet) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Just('roles');
		case 2:
			return $elm$core$Maybe$Just('rattachements-et-relations');
		case 3:
			return $elm$core$Maybe$Just('historique');
		default:
			return $elm$core$Maybe$Just('donnees-personnelles');
	}
};
var $author$project$Routes$Route$segmentPartiesPrenantes = 'parties-prenantes';
var $author$project$Routes$Route$routeDeFiche = function (onglet) {
	var fiche = A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$s($author$project$Routes$Route$segmentPartiesPrenantes),
		A2($elm$url$Url$Parser$custom, 'ENTITE', $author$project$Components$Referentiel$Identifiants$entiteUidFromString));
	var _v0 = $author$project$Routes$Route$segmentDOnglet(onglet);
	if (_v0.$ === 1) {
		return A2(
			$elm$url$Url$Parser$map,
			function (uid) {
				return A2($author$project$Routes$Route$Fiche, uid, onglet);
			},
			fiche);
	} else {
		var segment = _v0.a;
		return A2(
			$elm$url$Url$Parser$map,
			function (uid) {
				return A2($author$project$Routes$Route$Fiche, uid, onglet);
			},
			A2(
				$elm$url$Url$Parser$slash,
				fiche,
				$elm$url$Url$Parser$s(segment)));
	}
};
var $author$project$Routes$Route$FusionDeFiches = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Routes$Route$segmentFusion = 'fusion';
var $author$project$Routes$Route$routeDeFusion = function () {
	var entite = A2($elm$url$Url$Parser$custom, 'ENTITE', $author$project$Components$Referentiel$Identifiants$entiteUidFromString);
	return A2(
		$elm$url$Url$Parser$map,
		$author$project$Routes$Route$FusionDeFiches,
		A2(
			$elm$url$Url$Parser$slash,
			$elm$url$Url$Parser$s($author$project$Routes$Route$segmentPartiesPrenantes),
			A2(
				$elm$url$Url$Parser$slash,
				entite,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentFusion),
					entite))));
}();
var $author$project$Routes$Route$DemonstrationAnnuaire = function (a) {
	return {$: 72, a: a};
};
var $author$project$Routes$Route$DemonstrationFiche = F3(
	function (a, b, c) {
		return {$: 73, a: a, b: b, c: c};
	});
var $author$project$Routes$Route$Historique = 1;
var $author$project$Routes$Route$Synthese = 0;
var $author$project$Routes$Route$segmentAnnuaire = function (annuaire) {
	if (!annuaire) {
		return 'parties-prenantes';
	} else {
		return 'dossiers';
	}
};
var $author$project$Routes$Route$segmentHistorique = 'historique';
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $author$project$Routes$Route$routesDUnAnnuaire = function (annuaire) {
	var segment = $elm$url$Url$Parser$s(
		$author$project$Routes$Route$segmentAnnuaire(annuaire));
	return _List_fromArray(
		[
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routes$Route$DemonstrationAnnuaire(annuaire),
			segment),
			A2(
			$elm$url$Url$Parser$map,
			function (id) {
				return A3($author$project$Routes$Route$DemonstrationFiche, annuaire, id, 0);
			},
			A2($elm$url$Url$Parser$slash, segment, $elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			function (id) {
				return A3($author$project$Routes$Route$DemonstrationFiche, annuaire, id, 1);
			},
			A2(
				$elm$url$Url$Parser$slash,
				segment,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$string,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentHistorique))))
		]);
};
var $author$project$Routes$Route$segmentARanger = 'a-ranger';
var $author$project$Routes$Route$segmentAccueil = 'accueil';
var $author$project$Routes$Route$segmentAlertes = 'alertes';
var $author$project$Routes$Route$segmentAutomatismes = 'automatismes';
var $author$project$Routes$Route$segmentBibliothequeDeChamps = 'bibliotheque-de-champs';
var $author$project$Routes$Route$segmentChamps = 'champs';
var $author$project$Routes$Route$segmentCompteDEnvoi = 'envoi-des-emails';
var $author$project$Routes$Route$segmentCompteurDeCode = 'compteur-de-code';
var $author$project$Routes$Route$segmentConnexions = 'connexions';
var $author$project$Routes$Route$segmentConservation = 'conservation';
var $author$project$Routes$Route$segmentCorrespondances = 'correspondances';
var $author$project$Routes$Route$segmentDemonstration = 'demonstration';
var $author$project$Routes$Route$segmentDestinations = 'destinations';
var $author$project$Routes$Route$segmentDoublons = 'doublons';
var $author$project$Routes$Route$segmentEcartees = 'ecartees';
var $author$project$Routes$Route$segmentEtapes = 'etapes';
var $author$project$Routes$Route$segmentFormulaires = 'formulaires';
var $author$project$Routes$Route$segmentGroupes = 'groupes';
var $author$project$Routes$Route$segmentHistoriqueDesImports = 'historique';
var $author$project$Routes$Route$segmentImporter = 'importer';
var $author$project$Routes$Route$segmentLangues = 'langues';
var $author$project$Routes$Route$segmentListes = 'listes';
var $author$project$Routes$Route$segmentListesDePrix = 'listes-de-prix';
var $author$project$Routes$Route$segmentLotDImport = 'lot';
var $author$project$Routes$Route$segmentMarquesEtGammes = 'marques-et-gammes';
var $author$project$Routes$Route$segmentModelesDeTache = 'modeles-de-taches';
var $author$project$Routes$Route$segmentMonCompte = 'mon-compte';
var $author$project$Routes$Route$segmentNiveaux = 'niveaux';
var $author$project$Routes$Route$segmentNotifications = 'notifications';
var $author$project$Routes$Route$segmentNouveauPipe = 'nouveau';
var $author$project$Routes$Route$segmentNouvelleReference = 'nouvelle-reference';
var $author$project$Routes$Route$segmentOffre = 'offre';
var $author$project$Routes$Route$segmentOffres = 'offres';
var $author$project$Routes$Route$segmentPerimetres = 'perimetres';
var $author$project$Routes$Route$segmentPipes = 'pipes';
var $author$project$Routes$Route$segmentProduits = 'produits';
var $author$project$Routes$Route$segmentReferences = 'references';
var $author$project$Routes$Route$segmentRelationsExigees = 'relations-exigees';
var $author$project$Routes$Route$segmentRoles = 'roles';
var $author$project$Routes$Route$segmentSecuriteDesUtilisateurs = 'securite';
var $author$project$Routes$Route$segmentTaches = 'taches';
var $author$project$Routes$Route$segmentTypesDeProduits = 'types-de-produits';
var $author$project$Routes$Route$segmentTypesDeQuantite = 'types-de-quantite';
var $author$project$Routes$Route$segmentUsages = 'usages';
var $author$project$Routes$Route$segmentUtilisateurs = 'utilisateurs';
var $author$project$Routes$Route$segmentVerificationDuPipe = 'verification';
var $author$project$Routes$Route$segmentVersions = 'versions';
var $author$project$Routes$Route$segmentVisibilite = 'visibilite';
var $elm$url$Url$Parser$Query$string = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$Maybe$Just(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Routes$Route$trois = F3(
	function (a, b, c) {
		return _Utils_Tuple3(a, b, c);
	});
var $author$project$Catalogue$Identifiants$TypeDeProduitId = $elm$core$Basics$identity;
var $author$project$Catalogue$Identifiants$typeDeProduitIdFromString = A2(
	$elm$core$Basics$composeR,
	$author$project$Catalogue$Identifiants$uuid,
	$elm$core$Maybe$map($elm$core$Basics$identity));
var $author$project$Routes$Route$parser = $elm$url$Url$Parser$oneOf(
	_Utils_ap(
		_List_fromArray(
			[
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$Accueil,
				$elm$url$Url$Parser$s($author$project$Routes$Route$segmentAccueil)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$PartiesPrenantesListe,
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentPartiesPrenantes),
					A9(
						$elm$url$Url$Parser$Query$map8,
						F8(
							function (page, taille, tri, nature, qualite, pays, types, _v0) {
								var _v1 = _v0.a;
								var etat = _v1.a;
								var groupe = _v1.b;
								var offre = _v1.c;
								var reste = _v0.b;
								return $author$project$Routes$Route$lue(page)(taille)(tri)(nature)(qualite)(pays)(types)(etat)(groupe)(offre)(reste.a)(reste.b);
							}),
						$elm$url$Url$Parser$Query$int($author$project$Routes$Route$parametrePage),
						$elm$url$Url$Parser$Query$int($author$project$Routes$Route$parametreTaille),
						$elm$url$Url$Parser$Query$string($author$project$Routes$Route$parametreTri),
						$elm$url$Url$Parser$Query$string($author$project$Routes$Route$parametreNature),
						$elm$url$Url$Parser$Query$string($author$project$Routes$Route$parametreQualite),
						$elm$url$Url$Parser$Query$string($author$project$Routes$Route$parametrePays),
						A2($elm$url$Url$Parser$Query$custom, $author$project$Routes$Route$parametreType, $elm$core$Basics$identity),
						A3(
							$elm$url$Url$Parser$Query$map2,
							$elm$core$Tuple$pair,
							A4(
								$elm$url$Url$Parser$Query$map3,
								F3(
									function (etat, groupe, offre) {
										return _Utils_Tuple3(etat, groupe, offre);
									}),
								$elm$url$Url$Parser$Query$string($author$project$Routes$Route$parametreEtat),
								$elm$url$Url$Parser$Query$string($author$project$Routes$Route$parametreGroupe),
								$elm$url$Url$Parser$Query$string($author$project$Routes$Route$parametreOffre)),
							A3(
								$elm$url$Url$Parser$Query$map2,
								$elm$core$Tuple$pair,
								A2($elm$url$Url$Parser$Query$custom, $author$project$Routes$Route$parametreChamp, $elm$core$Basics$identity),
								A2($elm$url$Url$Parser$Query$custom, $author$project$Routes$Route$parametreRenseignes, $elm$core$Basics$identity)))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$Groupes,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentGroupes))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$Listes,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentListes))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$FicheListe,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentListes),
						$elm$url$Url$Parser$string))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$Perimetres,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentPerimetres))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$FichePerimetre,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentPerimetres),
						$elm$url$Url$Parser$string))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$TypesDeQuantite,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentTypesDeQuantite))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$Correspondances,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentCorrespondances))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$FicheCorrespondance,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentCorrespondances),
						$elm$url$Url$Parser$string))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$BibliothequeDeChamps,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentBibliothequeDeChamps),
						$elm$url$Url$Parser$Query$string($author$project$Routes$Route$parametreChampDeLaBibliotheque)))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$FicheDeGroupe,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentGroupes),
						A2(
							$elm$url$Url$Parser$questionMark,
							A2($elm$url$Url$Parser$custom, 'GROUPE', $author$project$Components$Referentiel$Identifiants$groupeUidFromString),
							$elm$url$Url$Parser$Query$string($author$project$Routes$Route$parametreDate))))),
				A2(
				$elm$url$Url$Parser$map,
				A2($author$project$Routes$Route$ParametrageCatalogue, 3, $elm$core$Maybe$Nothing),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentTypesDeProduits))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$ChampsDuNiveau,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentCatalogue),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s($author$project$Routes$Route$segmentNiveaux),
							A2(
								$elm$url$Url$Parser$slash,
								A2($elm$url$Url$Parser$custom, 'NIVEAU', $author$project$Catalogue$Identifiants$niveauIdFromString),
								$elm$url$Url$Parser$s($author$project$Routes$Route$segmentChamps)))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$MarquesEtGammes,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentProduits),
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentMarquesEtGammes))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$Pipes,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentPipes))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$PipeEtape2,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentPipes),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s($author$project$Routes$Route$segmentEtapes))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$PipeEtape3,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentPipes),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s($author$project$Routes$Route$segmentRoles))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$PipeEtape4,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentPipes),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s($author$project$Routes$Route$segmentTaches))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$PipeEtape5,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentPipes),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s($author$project$Routes$Route$segmentFormulaires))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$PipeEtape6,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentPipes),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s($author$project$Routes$Route$segmentVisibilite))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$PipeEtape7,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentPipes),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s($author$project$Routes$Route$segmentAutomatismes))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$PipeEtape8,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentPipes),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s($author$project$Routes$Route$segmentVerificationDuPipe))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$PipeDestinations,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentPipes),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$s($author$project$Routes$Route$segmentFormulaires),
								A2(
									$elm$url$Url$Parser$slash,
									$elm$url$Url$Parser$string,
									$elm$url$Url$Parser$s($author$project$Routes$Route$segmentDestinations))))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$PipeVersions,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentPipes),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s($author$project$Routes$Route$segmentVersions))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$PipeOffreUsage,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentPipes),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$s($author$project$Routes$Route$segmentOffre),
								$elm$url$Url$Parser$s($author$project$Routes$Route$segmentUsages)))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$PipeRelationsExigees,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentPipes),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$s($author$project$Routes$Route$segmentRoles),
								$elm$url$Url$Parser$s($author$project$Routes$Route$segmentRelationsExigees)))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$PipeEtape1(''),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentPipes),
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentNouveauPipe)))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$ModelesDeTache,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentPipes),
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentModelesDeTache)))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$PipeEtape1,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentPipes),
						$elm$url$Url$Parser$string))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$FicheElement,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentProduits),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentMarquesEtGammes),
						A2($elm$url$Url$Parser$custom, 'ELEMENT', $author$project$Catalogue$Identifiants$elementIdFromString)))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$Catalogue,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentProduits),
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentCatalogue),
						A4(
							$elm$url$Url$Parser$Query$map3,
							$author$project$Routes$Route$listeDeReferencesLue,
							A4(
								$elm$url$Url$Parser$Query$map3,
								$author$project$Routes$Route$trois,
								$elm$url$Url$Parser$Query$int($author$project$Routes$Route$parametrePage),
								$elm$url$Url$Parser$Query$int($author$project$Routes$Route$parametreTaille),
								$elm$url$Url$Parser$Query$string($author$project$Routes$Route$parametreTri)),
							A3(
								$elm$url$Url$Parser$Query$map2,
								$elm$core$Tuple$pair,
								A4(
									$elm$url$Url$Parser$Query$map3,
									$author$project$Routes$Route$trois,
									A2($elm$url$Url$Parser$Query$custom, $author$project$Routes$Route$parametreEtat, $elm$core$Basics$identity),
									A2($elm$url$Url$Parser$Query$custom, $author$project$Routes$Route$parametreMarque, $elm$core$Basics$identity),
									A2($elm$url$Url$Parser$Query$custom, $author$project$Routes$Route$parametreGamme, $elm$core$Basics$identity)),
								A3(
									$elm$url$Url$Parser$Query$map2,
									$elm$core$Tuple$pair,
									A4(
										$elm$url$Url$Parser$Query$map3,
										$author$project$Routes$Route$trois,
										A2($elm$url$Url$Parser$Query$custom, $author$project$Routes$Route$parametreTypologie, $elm$core$Basics$identity),
										A2($elm$url$Url$Parser$Query$custom, $author$project$Routes$Route$parametreFamille, $elm$core$Basics$identity),
										A2($elm$url$Url$Parser$Query$custom, $author$project$Routes$Route$parametreCategorie, $elm$core$Basics$identity)),
									A4(
										$elm$url$Url$Parser$Query$map3,
										$author$project$Routes$Route$trois,
										$elm$url$Url$Parser$Query$string($author$project$Routes$Route$parametreCompletude),
										$elm$url$Url$Parser$Query$string($author$project$Routes$Route$parametreArretees),
										A2($elm$url$Url$Parser$Query$custom, $author$project$Routes$Route$parametreChamps, $elm$core$Basics$identity)))),
							A4(
								$elm$url$Url$Parser$Query$map3,
								$author$project$Routes$Route$trois,
								$elm$url$Url$Parser$Query$string($author$project$Routes$Route$parametreTypeDeProduit),
								A2($elm$url$Url$Parser$Query$custom, $author$project$Routes$Route$parametreRenseignes, $elm$core$Basics$identity),
								A2($elm$url$Url$Parser$Query$custom, $author$project$Routes$Route$parametrePlages, $elm$core$Basics$identity)))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$ARangerDuCatalogue,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentProduits),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentCatalogue),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s($author$project$Routes$Route$segmentDesTypologies),
							A2(
								$elm$url$Url$Parser$slash,
								A2($elm$url$Url$Parser$custom, 'TYPOLOGIE', $author$project$Catalogue$Identifiants$classificationIdFromString),
								$elm$url$Url$Parser$s($author$project$Routes$Route$segmentARanger)))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$NouvelleReference,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentProduits),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentCatalogue),
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentNouvelleReference)))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$FicheReference,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentProduits),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentReferences),
						A2($elm$url$Url$Parser$custom, 'REFERENCE', $author$project$Catalogue$Identifiants$referenceIdFromString)))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$Offres,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentProduits),
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentOffres))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$FicheOffre,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentProduits),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentOffres),
						A2($elm$url$Url$Parser$custom, 'OFFRE', $author$project$Catalogue$Identifiants$referenceIdFromString)))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$Alertes,
				$elm$url$Url$Parser$s($author$project$Routes$Route$segmentAlertes)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$AlertesDePartiesPrenantes,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentAlertes),
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentPartiesPrenantes))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$Doublons,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentPartiesPrenantes),
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentDoublons))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$DoublonsEcartees,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentPartiesPrenantes),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentDoublons),
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentEcartees)))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$ListesDePrix,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentProduits),
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentListesDePrix))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$FicheListeDePrix,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentProduits),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentListesDePrix),
						A2($elm$url$Url$Parser$custom, 'LISTE', $author$project$Catalogue$Identifiants$listeDePrixIdFromString)))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Routes$Route$FicheType,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentTypesDeProduits),
						A2($elm$url$Url$Parser$custom, 'TYPE', $author$project$Catalogue$Identifiants$typeDeProduitIdFromString)))),
				A2(
				$elm$url$Url$Parser$map,
				function (uid) {
					return A2($author$project$Routes$Route$FicheTypeDePartiePrenante, uid, 0);
				},
				$author$project$Routes$Route$ficheDeType),
				A2(
				$elm$url$Url$Parser$map,
				function (uid) {
					return A2($author$project$Routes$Route$FicheTypeDePartiePrenante, uid, 1);
				},
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$Routes$Route$ficheDeType,
					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentChamps))),
				A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Routes$Route$segmentDemonstration),
				$elm$url$Url$Parser$oneOf(
					A2(
						$elm$core$List$cons,
						A2($elm$url$Url$Parser$map, $author$project$Routes$Route$Demonstration, $elm$url$Url$Parser$top),
						A2(
							$elm$core$List$concatMap,
							$author$project$Routes$Route$routesDUnAnnuaire,
							_List_fromArray(
								[0, 1])))))
			]),
		_Utils_ap(
			A2($elm$core$List$map, $author$project$Routes$Route$routeDeFiche, $author$project$Routes$Route$ongletsDeFiche),
			_Utils_ap(
				_List_fromArray(
					[$author$project$Routes$Route$routeDeFusion]),
				_Utils_ap(
					A2($elm$core$List$map, $author$project$Routes$Route$routeDEtape, $author$project$Routes$Route$etapesDuCatalogue),
					_Utils_ap(
						A2($elm$core$List$map, $author$project$Routes$Route$routeDEtapeDesTypes, $author$project$Routes$Route$etapesDesTypes),
						_Utils_ap(
							A2($elm$core$List$map, $author$project$Routes$Route$routeDEtapeDesDroits, $author$project$Routes$Route$etapesDesDroits),
							_Utils_ap(
								_List_fromArray(
									[
										A2(
										$elm$url$Url$Parser$map,
										$author$project$Routes$Route$EcheancesDeConservation,
										A2(
											$elm$url$Url$Parser$slash,
											$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
											$elm$url$Url$Parser$s($author$project$Routes$Route$segmentConservation)))
									]),
								_Utils_ap(
									_List_fromArray(
										[
											A2(
											$elm$url$Url$Parser$map,
											$author$project$Routes$Route$LanguesDuClient,
											A2(
												$elm$url$Url$Parser$slash,
												$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
												$elm$url$Url$Parser$s($author$project$Routes$Route$segmentLangues)))
										]),
									_Utils_ap(
										_List_fromArray(
											[
												A2(
												$elm$url$Url$Parser$map,
												$author$project$Routes$Route$Utilisateurs,
												A2(
													$elm$url$Url$Parser$slash,
													$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
													$elm$url$Url$Parser$s($author$project$Routes$Route$segmentUtilisateurs))),
												A2(
												$elm$url$Url$Parser$map,
												$author$project$Routes$Route$JournalDesConnexions,
												A2(
													$elm$url$Url$Parser$slash,
													$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
													A2(
														$elm$url$Url$Parser$slash,
														$elm$url$Url$Parser$s($author$project$Routes$Route$segmentUtilisateurs),
														A2(
															$elm$url$Url$Parser$questionMark,
															$elm$url$Url$Parser$s($author$project$Routes$Route$segmentConnexions),
															$elm$url$Url$Parser$Query$string('utilisateur'))))),
												A2(
												$elm$url$Url$Parser$map,
												$author$project$Routes$Route$SecuriteDesUtilisateurs,
												A2(
													$elm$url$Url$Parser$slash,
													$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
													A2(
														$elm$url$Url$Parser$slash,
														$elm$url$Url$Parser$s($author$project$Routes$Route$segmentUtilisateurs),
														$elm$url$Url$Parser$s($author$project$Routes$Route$segmentSecuriteDesUtilisateurs)))),
												A2(
												$elm$url$Url$Parser$map,
												$author$project$Routes$Route$FicheUtilisateur,
												A2(
													$elm$url$Url$Parser$slash,
													$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
													A2(
														$elm$url$Url$Parser$slash,
														$elm$url$Url$Parser$s($author$project$Routes$Route$segmentUtilisateurs),
														$elm$url$Url$Parser$string)))
											]),
										_Utils_ap(
											_List_fromArray(
												[
													A2(
													$elm$url$Url$Parser$map,
													$author$project$Routes$Route$CompteurDeCode,
													A2(
														$elm$url$Url$Parser$slash,
														$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
														$elm$url$Url$Parser$s($author$project$Routes$Route$segmentCompteurDeCode)))
												]),
											_Utils_ap(
												_List_fromArray(
													[
														A2(
														$elm$url$Url$Parser$map,
														$author$project$Routes$Route$CompteDEnvoi,
														A2(
															$elm$url$Url$Parser$slash,
															$elm$url$Url$Parser$s($author$project$Routes$Route$segmentParametrage),
															$elm$url$Url$Parser$s($author$project$Routes$Route$segmentCompteDEnvoi)))
													]),
												_Utils_ap(
													_List_fromArray(
														[
															A2(
															$elm$url$Url$Parser$map,
															$author$project$Routes$Route$Notifications,
															$elm$url$Url$Parser$s($author$project$Routes$Route$segmentNotifications))
														]),
													_Utils_ap(
														_List_fromArray(
															[
																A2(
																$elm$url$Url$Parser$map,
																$author$project$Routes$Route$HistoriqueDesImports,
																A2(
																	$elm$url$Url$Parser$slash,
																	$elm$url$Url$Parser$s($author$project$Routes$Route$segmentImporter),
																	$elm$url$Url$Parser$s($author$project$Routes$Route$segmentHistoriqueDesImports)))
															]),
														_Utils_ap(
															_List_fromArray(
																[
																	A2(
																	$elm$url$Url$Parser$map,
																	$author$project$Routes$Route$LotDImport,
																	A2(
																		$elm$url$Url$Parser$slash,
																		$elm$url$Url$Parser$s($author$project$Routes$Route$segmentImporter),
																		A2(
																			$elm$url$Url$Parser$slash,
																			$elm$url$Url$Parser$s($author$project$Routes$Route$segmentLotDImport),
																			$elm$url$Url$Parser$string)))
																]),
															_Utils_ap(
																_List_fromArray(
																	[
																		A2(
																		$elm$url$Url$Parser$map,
																		$author$project$Routes$Route$MonCompte,
																		$elm$url$Url$Parser$s($author$project$Routes$Route$segmentMonCompte))
																	]),
																_Utils_ap(
																	_List_fromArray(
																		[
																			A2(
																			$elm$url$Url$Parser$map,
																			$author$project$Routes$Route$MonCompteSecurite,
																			A2(
																				$elm$url$Url$Parser$slash,
																				$elm$url$Url$Parser$s($author$project$Routes$Route$segmentMonCompte),
																				$elm$url$Url$Parser$s('securite')))
																		]),
																	_Utils_ap(
																		_List_fromArray(
																			[
																				A2(
																				$elm$url$Url$Parser$map,
																				$author$project$Routes$Route$MonCompteSessions,
																				A2(
																					$elm$url$Url$Parser$slash,
																					$elm$url$Url$Parser$s($author$project$Routes$Route$segmentMonCompte),
																					$elm$url$Url$Parser$s('sessions')))
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$elm$url$Url$Parser$map,
																				$author$project$Routes$Route$Importer,
																				A2(
																					$elm$url$Url$Parser$questionMark,
																					A2(
																						$elm$url$Url$Parser$questionMark,
																						$elm$url$Url$Parser$s($author$project$Routes$Route$segmentImporter),
																						$elm$url$Url$Parser$Query$string('domaine')),
																					$elm$url$Url$Parser$Query$string('type')))
																			])))))))))))))))))));
var $author$project$Routes$Route$segments = function (url) {
	return A2(
		$elm$core$List$filter,
		A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
		A2($elm$core$String$split, '/', url.E6));
};
var $author$project$Routes$Route$fromUrl = function (url) {
	var _v0 = _Utils_Tuple2(
		A2($elm$url$Url$Parser$parse, $author$project$Routes$Route$parser, url),
		$author$project$Routes$Route$segments(url));
	if (!_v0.a.$) {
		var route = _v0.a.a;
		return route;
	} else {
		if (_v0.b.b) {
			var _v1 = _v0.a;
			var _v2 = _v0.b;
			var premier = _v2.a;
			var suite = _v2.b;
			return (_Utils_eq(premier, $author$project$Routes$Route$segmentParametrage) && _Utils_eq(
				$elm$core$List$head(suite),
				$elm$core$Maybe$Just($author$project$Routes$Route$segmentTypesDeProduits))) ? $author$project$Routes$Route$TypeIntrouvable : ((_Utils_eq(premier, $author$project$Routes$Route$segmentParametrage) && _Utils_eq(
				$elm$core$List$head(suite),
				$elm$core$Maybe$Just($author$project$Routes$Route$segmentTypesDePartiesPrenantes))) ? $author$project$Routes$Route$TypeDePartiePrenanteIntrouvable : (_Utils_eq(premier, $author$project$Routes$Route$segmentDemonstration) ? $author$project$Routes$Route$DemonstrationIntrouvable : (_Utils_eq(premier, $author$project$Routes$Route$segmentPartiesPrenantes) ? $author$project$Routes$Route$FicheIntrouvable : ((_Utils_eq(premier, $author$project$Routes$Route$segmentProduits) && _Utils_eq(
				$elm$core$List$head(suite),
				$elm$core$Maybe$Just($author$project$Routes$Route$segmentReferences))) ? $author$project$Routes$Route$ReferenceIntrouvable : ((_Utils_eq(premier, $author$project$Routes$Route$segmentProduits) && _Utils_eq(
				$elm$core$List$head(suite),
				$elm$core$Maybe$Just($author$project$Routes$Route$segmentOffres))) ? $author$project$Routes$Route$OffreIntrouvable : ((_Utils_eq(premier, $author$project$Routes$Route$segmentProduits) && _Utils_eq(
				$elm$core$List$head(suite),
				$elm$core$Maybe$Just($author$project$Routes$Route$segmentListesDePrix))) ? $author$project$Routes$Route$ListeDePrixIntrouvable : (_Utils_eq(premier, $author$project$Routes$Route$segmentProduits) ? $author$project$Routes$Route$ElementIntrouvable : $author$project$Routes$Route$Version)))))));
		} else {
			var _v3 = _v0.a;
			return $author$project$Routes$Route$Version;
		}
	}
};
var $author$project$Components$Accueil$Model$init = {jB: $elm$core$Maybe$Nothing, x0: $elm$core$Maybe$Nothing, mF: $elm$core$Maybe$Nothing, bY: 0, rw: $elm$core$Maybe$Nothing};
var $author$project$API$Envoi$SansProcessUid = {$: 0};
var $author$project$Components$Comptes$MonCompte$Model$init = {l_: $elm$core$Maybe$Nothing, l2: $author$project$API$Envoi$SansProcessUid, zO: '', z_: '', gD: _List_Nil, nn: '', nJ: $elm$core$Maybe$Nothing, nO: $elm$core$Maybe$Nothing, Dj: '', eF: $elm$core$Maybe$Nothing, Gg: '', c2: $elm$core$Maybe$Nothing, hF: $elm$core$Maybe$Nothing, h_: $elm$core$Maybe$Nothing, Jp: ''};
var $author$project$Components$Comptes$Securite$Model$OngletSecurite = 0;
var $author$project$Components$Shared$Drawer$Model$init = function (nom) {
	return {wQ: $elm$core$Maybe$Nothing, gt: 0, Dj: nom};
};
var $author$project$Components$Comptes$Securite$Model$init = {
	iu: $elm$core$Maybe$Nothing,
	iA: $elm$core$Maybe$Nothing,
	j8: _List_Nil,
	kX: $author$project$Components$Shared$Drawer$Model$init('mon-compte-renommer'),
	l2: $author$project$API$Envoi$SansProcessUid,
	nQ: _List_Nil,
	Dj: '',
	oZ: 0,
	pZ: $elm$core$Maybe$Nothing,
	qx: $elm$core$Maybe$Nothing,
	qL: $elm$core$Maybe$Nothing,
	q1: $elm$core$Maybe$Nothing,
	IK: $elm$core$Maybe$Nothing
};
var $author$project$Preferences$Model$gardeesVides = {mH: false, io: $elm$core$Maybe$Nothing};
var $author$project$Preferences$Model$annuaire = F3(
	function (vueParDefaut, cle, preferences) {
		var gardees = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Preferences$Model$gardeesVides,
			A2($elm$core$Dict$get, cle, preferences.aq));
		return {
			mH: gardees.mH,
			io: A2($elm$core$Maybe$withDefault, vueParDefaut, gardees.io)
		};
	});
var $author$project$Components$Demonstration$Model$cleAnnuaire = function (choisi) {
	if (!choisi) {
		return 'demonstration.parties-prenantes';
	} else {
		return 'demonstration.dossiers';
	}
};
var $author$project$Components$Shared$Annuaire$Model$UneAUne = 0;
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $author$project$Components$Shared$Annuaire$Model$init = F2(
	function (cle, preferences) {
		return {dy: cle, vv: $elm$core$Set$empty, j1: $elm$core$Maybe$Nothing, aw: 0, mH: preferences.mH, io: preferences.io};
	});
var $author$project$Components$Demonstration$Model$init = function (preferences) {
	var annuaireGarde = function (choisi) {
		return A2(
			$author$project$Components$Shared$Annuaire$Model$init,
			$author$project$Components$Demonstration$Model$cleAnnuaire(choisi),
			A3(
				$author$project$Preferences$Model$annuaire,
				0,
				$author$project$Components$Demonstration$Model$cleAnnuaire(choisi),
				preferences));
	};
	return {
		xJ: annuaireGarde(1),
		mg: $elm$core$Maybe$Nothing,
		eh: $author$project$Components$Shared$Drawer$Model$init('demonstration-fiche-modifier'),
		eo: $author$project$Components$Shared$Drawer$Model$init('demonstration-dossier-creer'),
		ep: $author$project$Components$Shared$Drawer$Model$init('demonstration-partie-prenante-creer'),
		eA: annuaireGarde(0),
		c7: $elm$core$Dict$empty
	};
};
var $author$project$Components$Imports$Outil$Model$EtapeFichier = 0;
var $author$project$Components$Imports$Outil$Model$PageDeLOutil = 0;
var $author$project$Components$Imports$Outil$API$QueryAPIModel$reglesVides = {zQ: $elm$core$Maybe$Nothing, nn: $elm$core$Maybe$Nothing, IG: $elm$core$Maybe$Nothing, IH: $elm$core$Maybe$Nothing, Ka: $elm$core$Maybe$Nothing, sd: $elm$core$Maybe$Nothing, Ki: $elm$core$Dict$empty};
var $author$project$Components$Imports$Outil$Model$init = {
	fu: $elm$core$Dict$empty,
	tq: $elm$core$Maybe$Nothing,
	jb: _List_Nil,
	ua: $elm$core$Maybe$Nothing,
	uq: $elm$core$Maybe$Nothing,
	fK: $elm$core$Maybe$Nothing,
	dw: $elm$core$Dict$empty,
	jN: $elm$core$Maybe$Nothing,
	jP: $elm$core$Dict$empty,
	fS: $elm$core$Maybe$Nothing,
	j$: $elm$core$Maybe$Nothing,
	j0: $elm$core$Maybe$Nothing,
	bB: $elm$core$Maybe$Nothing,
	k0: $author$project$Components$Shared$Drawer$Model$init('imports-application'),
	k5: $author$project$Components$Shared$Drawer$Model$init('imports-cible'),
	k6: $author$project$Components$Shared$Drawer$Model$init('imports-confirmation'),
	k9: $author$project$Components$Shared$Drawer$Model$init('imports-historique'),
	lf: $author$project$Components$Shared$Drawer$Model$init('imports-repartition'),
	lk: $author$project$Components$Shared$Drawer$Model$init('imports-lignes'),
	ll: $author$project$Components$Shared$Drawer$Model$init('imports-reglages'),
	lm: $author$project$Components$Shared$Drawer$Model$init('imports-regles'),
	ln: $author$project$Components$Shared$Drawer$Model$init('imports-valeurs'),
	lt: $author$project$Components$Shared$Drawer$Model$init('imports-modele'),
	lu: $author$project$Components$Shared$Drawer$Model$init('imports-refus'),
	lv: $author$project$Components$Shared$Drawer$Model$init('imports-rejeu'),
	gd: false,
	lZ: false,
	l2: $author$project$API$Envoi$SansProcessUid,
	ma: 0,
	mb: 0,
	me: 0,
	gw: $elm$core$Maybe$Nothing,
	gx: '',
	gy: '',
	gz: '',
	m6: $elm$core$Maybe$Nothing,
	cN: $elm$core$Maybe$Nothing,
	np: $elm$core$Maybe$Nothing,
	nq: $elm$core$Maybe$Nothing,
	nF: $elm$core$Maybe$Nothing,
	nN: $elm$core$Maybe$Nothing,
	nU: $elm$core$Maybe$Nothing,
	gV: $elm$core$Maybe$Nothing,
	gW: 0,
	n0: $elm$core$Maybe$Nothing,
	n1: $elm$core$Maybe$Nothing,
	n2: $elm$core$Maybe$Nothing,
	B4: _List_Nil,
	ob: $elm$core$Maybe$Nothing,
	g6: '',
	oX: $elm$core$Maybe$Nothing,
	Et: $elm$core$Maybe$Nothing,
	EE: 0,
	pb: _List_Nil,
	hw: _List_Nil,
	pK: $elm$core$Maybe$Nothing,
	pQ: '',
	pU: '',
	pZ: $elm$core$Maybe$Nothing,
	p8: $elm$core$Maybe$Nothing,
	qa: false,
	hG: $author$project$Components$Imports$Outil$API$WriteAPIModel$reglagesVides,
	qe: _List_Nil,
	qf: $elm$core$Maybe$Nothing,
	qg: $author$project$Components$Imports$Outil$API$QueryAPIModel$reglesVides,
	q9: 'completer',
	rb: $elm$core$Maybe$Nothing,
	rm: $elm$core$Maybe$Nothing,
	rr: $elm$core$Maybe$Nothing,
	ie: $elm$core$Maybe$Nothing,
	sh: $elm$core$Maybe$Nothing,
	ii: $elm$core$Dict$empty
};
var $author$project$Components$Notifications$Model$init = {iw: $elm$core$Maybe$Nothing, gd: false, lU: false, l2: $author$project$API$Envoi$SansProcessUid, gF: _List_Nil, np: $elm$core$Maybe$Nothing, nW: $elm$core$Maybe$Nothing, B3: $elm$core$Maybe$Nothing, DG: $elm$core$Dict$empty, Es: false, GN: _List_Nil, h9: $elm$core$Maybe$Nothing};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$AutreNom = 1;
var $author$project$Components$Shared$Bibliotheque$Domaine$Catalogue = 0;
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$Toutes = 0;
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$init = {uN: '', jN: $elm$core$Maybe$Nothing, dy: '', zu: $elm$core$Maybe$Nothing, dZ: $elm$core$Maybe$Nothing, nQ: _List_Nil, Di: $elm$core$Maybe$Nothing, Es: $elm$core$Maybe$Nothing, F3: $elm$core$Maybe$Nothing, ib: _List_Nil, fn: $elm$core$Maybe$Nothing, Ki: $elm$core$Maybe$Nothing};
var $author$project$Components$Parametrage$NouveauChamp$Model$init = function (racine) {
	return {
		uw: $elm$core$Maybe$Nothing,
		cz: _List_Nil,
		lc: $author$project$Components$Shared$Drawer$Model$init(racine + '-nouvelle-liste'),
		lp: $author$project$Components$Shared$Drawer$Model$init(racine + '-nouveau-champ'),
		l2: $author$project$API$Envoi$SansProcessUid,
		nS: _List_Nil,
		nW: $elm$core$Maybe$Nothing,
		nX: $elm$core$Maybe$Nothing,
		n_: _List_Nil,
		ew: $elm$core$Maybe$Nothing
	};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$nomDuDrawer = 'bibliotheque-reprise';
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$init = {
	ix: $elm$core$Maybe$Nothing,
	dq: $elm$core$Maybe$Nothing,
	uB: $elm$core$Maybe$Nothing,
	jN: $elm$core$Dict$empty,
	dy: $elm$core$Maybe$Nothing,
	v2: false,
	wZ: $elm$core$Maybe$Nothing,
	cC: 0,
	kX: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Parametrage$BibliothequeDeChamps$Model$nomDuDrawer),
	dJ: $author$project$Components$Shared$Drawer$Model$init('bibliotheque-calcul'),
	kZ: $author$project$Components$Shared$Drawer$Model$init('bibliotheque-restriction-choix'),
	dO: $author$project$Components$Shared$Drawer$Model$init('bibliotheque-definition'),
	dP: $author$project$Components$Shared$Drawer$Model$init('bibliotheque-lot'),
	dQ: $author$project$Components$Shared$Drawer$Model$init('bibliotheque-rattachement'),
	lA: $author$project$Components$Shared$Drawer$Model$init('bibliotheque-reglages'),
	lC: $author$project$Components$Shared$Drawer$Model$init('bibliotheque-restriction'),
	dR: $author$project$Components$Shared$Drawer$Model$init('bibliotheque-traduction'),
	lN: $elm$core$Maybe$Nothing,
	l2: $author$project$API$Envoi$SansProcessUid,
	zo: $elm$core$Maybe$Nothing,
	cR: 1,
	np: $elm$core$Maybe$Nothing,
	n_: _List_Nil,
	n0: $elm$core$Maybe$Nothing,
	Dj: '',
	oP: $author$project$Components$Parametrage$NouveauChamp$Model$init('bibliotheque'),
	EE: $elm$core$Maybe$Nothing,
	F$: 0,
	GN: _List_Nil,
	pN: $elm$core$Maybe$Nothing,
	pZ: $elm$core$Maybe$Nothing,
	eO: $elm$core$Maybe$Nothing,
	eS: $elm$core$Maybe$Nothing,
	qF: $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$init,
	JK: $elm$core$Maybe$Nothing,
	ib: _List_Nil
};
var $author$project$Components$Parametrage$CollectionsDeChamps$API$QueryAPIModel$DuCatalogue = 0;
var $author$project$Components$Parametrage$CollectionsDeChamps$Model$init = {
	ir: $elm$core$Maybe$Nothing,
	fr: $elm$core$Maybe$Nothing,
	t: '',
	jD: _List_Nil,
	dy: '',
	vE: $elm$core$Maybe$Nothing,
	k7: $author$project$Components$Shared$Drawer$Model$init('collections-creation'),
	lj: $author$project$Components$Shared$Drawer$Model$init('collections-traduction'),
	gd: false,
	l2: $author$project$API$Envoi$SansProcessUid,
	dY: '',
	np: $elm$core$Maybe$Nothing,
	Bl: '',
	F$: 0,
	pZ: $elm$core$Maybe$Nothing
};
var $author$project$Components$Parametrage$CompteDEnvoi$Model$Connecter = 0;
var $author$project$Components$Parametrage$CompteDEnvoi$Model$saisieVide = {dy: '', mr: '', ov: '', qw: ''};
var $author$project$Components$Parametrage$CompteDEnvoi$Model$init = {
	ft: _List_Nil,
	fL: _List_Nil,
	vW: $elm$core$Maybe$Nothing,
	kX: $author$project$Components$Shared$Drawer$Model$init('compte-d-envoi-connecter'),
	k$: $author$project$Components$Shared$Drawer$Model$init('compte-d-envoi-annuler-le-remplacement'),
	k8: $author$project$Components$Shared$Drawer$Model$init('compte-d-envoi-deconnecter'),
	gd: false,
	lT: $elm$core$Maybe$Nothing,
	l2: $author$project$API$Envoi$SansProcessUid,
	nQ: _List_Nil,
	n9: 0,
	g5: $elm$core$Maybe$Nothing,
	pZ: $elm$core$Maybe$Nothing,
	qa: false,
	hP: $author$project$Components$Parametrage$CompteDEnvoi$Model$saisieVide,
	rK: false
};
var $author$project$Components$Parametrage$CompteurDeCode$Model$init = {
	vb: '',
	kX: $author$project$Components$Shared$Drawer$Model$init('compteur-de-code'),
	gd: false,
	l2: $author$project$API$Envoi$SansProcessUid,
	nQ: _List_Nil,
	F$: 'par-prefixe',
	Ge: '',
	pZ: $elm$core$Maybe$Nothing,
	qa: false,
	eO: $elm$core$Maybe$Nothing
};
var $author$project$Components$Parametrage$Conservation$Model$init = {
	fq: $elm$core$Maybe$Nothing,
	jO: false,
	v2: false,
	ld: $author$project$Components$Shared$Drawer$Model$init('conservation-prolonger'),
	lw: $author$project$Components$Shared$Drawer$Model$init('conservation-type'),
	x0: $elm$core$Maybe$Nothing,
	gd: false,
	l2: $author$project$API$Envoi$SansProcessUid,
	zH: $elm$core$Maybe$Nothing,
	A3: '',
	ns: $elm$core$Maybe$Nothing,
	nv: $elm$core$Maybe$Nothing,
	gV: _List_Nil,
	cX: $elm$core$Maybe$Nothing,
	Gd: '',
	pZ: $elm$core$Maybe$Nothing,
	hJ: $elm$core$Maybe$Nothing,
	qh: false,
	qD: _List_Nil,
	ia: $elm$core$Maybe$Nothing
};
var $author$project$Components$Parametrage$Droits$Model$init = {
	aS: $elm$core$Maybe$Nothing,
	tq: $elm$core$Maybe$Nothing,
	iS: false,
	iW: $elm$core$Maybe$Nothing,
	iX: false,
	uw: $elm$core$Maybe$Nothing,
	jL: _List_Nil,
	kX: $author$project$Components$Shared$Drawer$Model$init('parametrage-droits'),
	gd: false,
	l2: $author$project$API$Envoi$SansProcessUid,
	zo: $elm$core$Maybe$Nothing,
	mW: $elm$core$Maybe$Nothing,
	np: $elm$core$Maybe$Nothing,
	nD: $elm$core$Maybe$Nothing,
	Cm: $elm$core$Maybe$Nothing,
	oa: $elm$core$Maybe$Nothing,
	oc: $elm$core$Maybe$Nothing,
	Dj: '',
	hC: '',
	pZ: $elm$core$Maybe$Nothing,
	qa: false,
	hH: $elm$core$Maybe$Nothing,
	qh: false,
	rn: false,
	r_: $elm$core$Maybe$Nothing
};
var $author$project$Components$Parametrage$LanguesDuClient$Model$init = {
	dh: $elm$core$Maybe$Nothing,
	tq: $elm$core$Maybe$Nothing,
	ve: $elm$core$Maybe$Nothing,
	k_: $author$project$Components$Shared$Drawer$Model$init('langues-ajout'),
	lh: $author$project$Components$Shared$Drawer$Model$init('langues-retrait'),
	li: $author$project$Components$Shared$Drawer$Model$init('langues-suppression'),
	ls: $author$project$Components$Shared$Drawer$Model$init('langues-defaut'),
	gd: false,
	l2: $author$project$API$Envoi$SansProcessUid,
	Ba: $elm$core$Maybe$Nothing,
	np: $elm$core$Maybe$Nothing,
	Gw: _List_Nil,
	hC: '',
	pY: $elm$core$Maybe$Nothing,
	pZ: $elm$core$Maybe$Nothing,
	qa: false,
	rs: $elm$core$Maybe$Nothing
};
var $author$project$Components$Parametrage$ModelesDeTache$Model$idDuDrawer = 'modeles-de-tache-fiche';
var $author$project$Components$Parametrage$ModelesDeTache$Model$init = {
	i$: false,
	jo: $elm$core$Maybe$Nothing,
	kX: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Parametrage$ModelesDeTache$Model$idDuDrawer),
	l2: $author$project$API$Envoi$SansProcessUid,
	zo: $elm$core$Maybe$Nothing,
	M: '',
	nf: false,
	EE: $elm$core$Maybe$Nothing,
	hC: '',
	pZ: $elm$core$Maybe$Nothing,
	hP: {w2: '', yy: '', Dj: '', oL: '', GU: '', hH: '', bi: ''}
};
var $author$project$Components$Parametrage$PipeDestinations$Model$init = F2(
	function (code, formulaireUid) {
		return {vx: code, mR: formulaireUid, nf: false, Bl: '', EE: $elm$core$Maybe$Nothing};
	});
var $author$project$Components$Parametrage$PipeEtape1$Model$init = function (code) {
	return {
		aS: $elm$core$Maybe$Nothing,
		i0: _List_Nil,
		jy: _List_Nil,
		uT: $elm$core$Maybe$Nothing,
		vx: code,
		kX: $author$project$Components$Shared$Drawer$Model$init('pipe-etape-1'),
		ge: $elm$core$Maybe$Nothing,
		l2: $author$project$API$Envoi$SansProcessUid,
		mW: $elm$core$Maybe$Nothing,
		nf: false,
		Bs: $elm$core$Maybe$Nothing,
		nP: $elm$core$Maybe$Nothing,
		nR: _List_Nil,
		o_: $elm$core$Maybe$Nothing,
		o$: $elm$core$Maybe$Nothing,
		pZ: $elm$core$Maybe$Nothing,
		IR: $elm$core$Maybe$Nothing,
		rV: $elm$core$Maybe$Nothing,
		ic: _List_Nil,
		id: $elm$core$Maybe$Nothing,
		sr: false
	};
};
var $author$project$Components$Parametrage$PipeEtape2$Model$init = function (code) {
	return {
		aS: $elm$core$Maybe$Nothing,
		ve: $elm$core$Maybe$Nothing,
		vx: code,
		bB: false,
		kX: $author$project$Components$Shared$Drawer$Model$init('pipe-etape-2'),
		ge: $elm$core$Maybe$Nothing,
		l2: $author$project$API$Envoi$SansProcessUid,
		me: $elm$core$Maybe$Nothing,
		mW: $elm$core$Maybe$Nothing,
		nf: false,
		nR: _List_Nil,
		o_: $elm$core$Maybe$Nothing,
		ex: $elm$core$Maybe$Nothing,
		aH: $elm$core$Maybe$Nothing,
		pZ: $elm$core$Maybe$Nothing,
		rP: $elm$core$Maybe$Nothing,
		sr: false
	};
};
var $author$project$Components$Parametrage$PipeEtape3$Model$init = function (code) {
	return {
		aS: $elm$core$Maybe$Nothing,
		vx: code,
		kX: $author$project$Components$Shared$Drawer$Model$init('pipe-etape-3'),
		ge: $elm$core$Maybe$Nothing,
		l2: $author$project$API$Envoi$SansProcessUid,
		my: $elm$core$Maybe$Nothing,
		nf: false,
		nR: _List_Nil,
		o_: $elm$core$Maybe$Nothing,
		pZ: $elm$core$Maybe$Nothing,
		eW: false,
		bi: $elm$core$Maybe$Nothing,
		eX: $elm$core$Maybe$Nothing,
		hP: $elm$core$Maybe$Nothing,
		rP: false,
		sr: false
	};
};
var $author$project$Components$Parametrage$PipeEtape4$Model$init = function (code) {
	return {
		fw: $elm$core$Maybe$Nothing,
		aS: $elm$core$Maybe$Nothing,
		vx: code,
		kX: $author$project$Components$Shared$Drawer$Model$init('pipe-etape-4-tache'),
		ge: $elm$core$Maybe$Nothing,
		l2: $author$project$API$Envoi$SansProcessUid,
		aA: _List_Nil,
		nf: false,
		nR: _List_Nil,
		pZ: $elm$core$Maybe$Nothing,
		hP: $elm$core$Maybe$Nothing,
		Jk: $elm$core$Maybe$Nothing
	};
};
var $author$project$Components$Parametrage$PipeEtape5$Model$init = function (code) {
	return {
		aS: $elm$core$Maybe$Nothing,
		vx: code,
		kX: $author$project$Components$Shared$Drawer$Model$init('pipe-etape-5-formulaire'),
		ge: $elm$core$Maybe$Nothing,
		l2: $author$project$API$Envoi$SansProcessUid,
		aA: $elm$core$Maybe$Nothing,
		Ax: false,
		nf: false,
		nR: _List_Nil,
		pZ: $elm$core$Maybe$Nothing,
		qq: false,
		qE: false,
		hP: $elm$core$Maybe$Nothing
	};
};
var $author$project$Components$Parametrage$PipeEtape6$Model$init = function (code) {
	return {
		aS: $elm$core$Maybe$Nothing,
		vx: code,
		kX: $author$project$Components$Shared$Drawer$Model$init('pipe-etape-6-droits'),
		ge: $elm$core$Maybe$Nothing,
		l2: $author$project$API$Envoi$SansProcessUid,
		m1: $elm$core$Maybe$Nothing,
		Ax: false,
		nf: false,
		nR: _List_Nil,
		o_: $elm$core$Maybe$Nothing,
		o0: _List_Nil,
		pZ: $elm$core$Maybe$Nothing,
		hP: $elm$core$Maybe$Nothing
	};
};
var $author$project$Components$Parametrage$PipeEtape7$Model$init = function (code) {
	return {
		aS: $elm$core$Maybe$Nothing,
		vx: code,
		kX: $author$project$Components$Shared$Drawer$Model$init('pipe-etape-7-automatisme'),
		ge: $elm$core$Maybe$Nothing,
		l2: $author$project$API$Envoi$SansProcessUid,
		Ax: false,
		nf: false,
		nR: _List_Nil,
		nW: $elm$core$Maybe$Nothing,
		o_: $elm$core$Maybe$Nothing,
		pZ: $elm$core$Maybe$Nothing,
		hP: $elm$core$Maybe$Nothing
	};
};
var $author$project$Components$Parametrage$PipeEtape8$Model$init = function (code) {
	return {aS: $elm$core$Maybe$Nothing, vx: code, ge: $elm$core$Maybe$Nothing, l2: $author$project$API$Envoi$SansProcessUid, nf: false, nR: _List_Nil, pZ: $elm$core$Maybe$Nothing, ij: $elm$core$Maybe$Nothing, ss: _List_Nil};
};
var $author$project$Components$Parametrage$PipeOffreUsage$Model$init = function (code) {
	return {vx: code, nf: false, Bl: '', EE: $elm$core$Maybe$Nothing};
};
var $author$project$Components$Parametrage$PipeRelationsExigees$Model$init = function (code) {
	return {vx: code, nf: false, Bl: '', EE: $elm$core$Maybe$Nothing};
};
var $author$project$Components$Parametrage$PipeVersions$Model$idDuDrawer = function (nom) {
	return 'pipe-versions-' + nom;
};
var $author$project$Components$Parametrage$PipeVersions$Model$init = function (code) {
	return {
		dh: $elm$core$Maybe$Nothing,
		jv: $elm$core$Maybe$Nothing,
		vx: code,
		vP: $elm$core$Maybe$Nothing,
		kX: $author$project$Components$Shared$Drawer$Model$init(
			$author$project$Components$Parametrage$PipeVersions$Model$idDuDrawer('retirer')),
		l2: $author$project$API$Envoi$SansProcessUid,
		nf: false,
		Bl: '',
		nE: $elm$core$Maybe$Nothing,
		EE: $elm$core$Maybe$Nothing,
		FK: '',
		pZ: $elm$core$Maybe$Nothing
	};
};
var $author$project$Components$Parametrage$Pipes$Model$Tableau = 1;
var $author$project$Components$Parametrage$Pipes$Model$init = {iF: 1, nQ: _List_Nil, EE: 1, FM: $elm$core$Maybe$Nothing, Jm: 100, JE: 0};
var $author$project$Components$Parametrage$Utilisateurs$Model$OngletUtilisateurs = 0;
var $author$project$Components$Parametrage$Utilisateurs$Model$filtresVides = {kV: $elm$core$Maybe$Nothing, gt: $elm$core$Maybe$Nothing, bi: $elm$core$Maybe$Nothing};
var $author$project$Components$Parametrage$Utilisateurs$Model$PasDExport = {$: 0};
var $author$project$Components$Parametrage$Utilisateurs$Model$journalVide = {cm: '', cE: '', ms: $author$project$Components$Parametrage$Utilisateurs$Model$PasDExport, nB: $elm$core$Maybe$Nothing, B0: $elm$core$Maybe$Nothing, Es: false, EE: 1, hC: '', fl: $elm$core$Maybe$Nothing};
var $author$project$Components$Parametrage$Utilisateurs$Model$init = {
	ip: _List_Nil,
	iq: $elm$core$Maybe$Nothing,
	iu: $elm$core$Maybe$Nothing,
	tn: _List_Nil,
	aS: $elm$core$Maybe$Nothing,
	i7: $elm$core$Maybe$Nothing,
	ve: $elm$core$Maybe$Nothing,
	vf: $elm$core$Maybe$Nothing,
	xm: $elm$core$Maybe$Nothing,
	kX: $author$project$Components$Shared$Drawer$Model$init('utilisateurs-inviter'),
	xO: $author$project$Components$Shared$Drawer$Model$init('utilisateur-lier'),
	l2: $author$project$API$Envoi$SansProcessUid,
	zl: true,
	zo: $elm$core$Maybe$Nothing,
	mG: $author$project$Components$Parametrage$Utilisateurs$Model$filtresVides,
	nf: false,
	AU: $elm$core$Maybe$Nothing,
	a$: $author$project$Components$Parametrage$Utilisateurs$Model$journalVide,
	np: $elm$core$Maybe$Nothing,
	nr: $elm$core$Maybe$Nothing,
	nu: $elm$core$Maybe$Nothing,
	nw: $elm$core$Maybe$Nothing,
	BL: false,
	g5: $elm$core$Maybe$Nothing,
	oZ: 0,
	pE: $elm$core$Maybe$Nothing,
	hC: '',
	pZ: $elm$core$Maybe$Nothing,
	qa: false,
	eX: _List_Nil,
	hP: {yb: '', nn: 'fr', Dj: '', Gg: '', eX: _List_Nil},
	q1: $elm$core$Maybe$Nothing
};
var $author$project$Components$Produits$Alertes$Model$init = {lV: false, ys: $elm$core$Maybe$Nothing, dZ: $elm$core$Maybe$Nothing, AL: '', n3: $elm$core$Maybe$Nothing, EE: 1, fh: ''};
var $author$project$Components$Produits$Catalogue$Model$cleDAnnuaire = 'produits-catalogue';
var $author$project$Components$Produits$Catalogue$Model$colonnesProposees = _List_fromArray(
	['nom', 'colonne-marque', 'colonne-gamme', 'categorie', 'typologie', 'etat', 'completude']);
var $author$project$Components$Produits$Catalogue$Model$colonnesParDefaut = $author$project$Components$Produits$Catalogue$Model$colonnesProposees;
var $author$project$Components$Produits$Catalogue$Model$nomDuDrawer = 'produits-reference-creer';
var $author$project$Components$Produits$Catalogue$Model$nomDuVolet = 'produits-catalogue-filtres';
var $author$project$Components$Produits$Catalogue$Model$nomDuVoletDesColonnes = 'produits-catalogue-colonnes';
var $author$project$Routes$Route$premiereListeDeReferences = {i2: false, dt: _List_Nil, dw: _List_Nil, fU: $elm$core$Maybe$Nothing, mj: _List_Nil, mu: _List_Nil, gG: _List_Nil, cU: _List_Nil, EE: 1, pn: _List_Nil, qs: _List_Nil, Jm: $author$project$Routes$Route$tailleParDefaut, rS: $author$project$Routes$Route$triParDefautDesReferences, fh: $elm$core$Maybe$Nothing, r7: _List_Nil};
var $author$project$Components$Produits$Catalogue$Creation$AucunProduit = {$: 0};
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Choix = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Coche = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Ecrit = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$ParLangue = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Postale = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Vide = {$: 0};
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$adresseSaisie = function (lue) {
	var ligne = function (rang) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(
				A2($elm$core$List$drop, rang, lue.gV)));
	};
	return {
		vz: A2($elm$core$Maybe$withDefault, '', lue.vz),
		a3: ligne(0),
		a4: ligne(1),
		a5: A2(
			$elm$core$String$join,
			', ',
			A2($elm$core$List$drop, 2, lue.gV)),
		B_: lue.B_,
		ho: lue.ho,
		Hj: A2($elm$core$Maybe$withDefault, '', lue.Hj)
	};
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$articlesSaisis = F2(
	function (plusieurs, uids) {
		return plusieurs ? $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Choix(uids) : A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Vide,
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Ecrit,
				$elm$core$List$head(uids)));
	});
var $elm$core$String$fromFloat = _String_fromNumber;
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$ecrire = function (nombre) {
	return A3(
		$elm$core$String$replace,
		'.',
		',',
		$elm$core$String$fromFloat(nombre));
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$depuis = F2(
	function (fourni, lues) {
		var de = function (champ) {
			return _Utils_Tuple2(
				champ.dy,
				function () {
					var _v0 = A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$second,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Tuple$first,
									$elm$core$Basics$eq(champ.dy)),
								lues)));
					if (!_v0.$) {
						switch (_v0.a.$) {
							case 5:
								var textes = _v0.a.a;
								return $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$ParLangue(
									A2(
										$elm$core$List$map,
										$elm$core$Tuple$mapSecond(
											$elm$core$Maybe$withDefault('')),
										textes));
							case 1:
								var texte = _v0.a.a;
								return $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Ecrit(texte);
							case 2:
								var nombre = _v0.a.a;
								return $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Ecrit(
									$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$ecrire(nombre));
							case 3:
								var coche = _v0.a.a;
								return $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Coche(coche);
							case 4:
								var textes = _v0.a.a;
								return $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Choix(textes);
							case 0:
								var _v1 = _v0.a;
								return $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Vide;
							case 6:
								var _v2 = _v0.a;
								var plusieurs = _v2.a;
								var uids = _v2.b;
								return A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$articlesSaisis, plusieurs, uids);
							case 7:
								var _v3 = _v0.a;
								var plusieurs = _v3.a;
								var uids = _v3.b;
								return A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$articlesSaisis, plusieurs, uids);
							case 8:
								return $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Vide;
							default:
								var lue = _v0.a.a;
								return $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Postale(
									$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$adresseSaisie(lue));
						}
					} else {
						return $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Vide;
					}
				}());
		};
		var valeurs = A2($elm$core$List$map, de, fourni.dw);
		return {
			d1: _List_Nil,
			AP: valeurs,
			nn: A2(
				$elm$core$Maybe$withDefault,
				'',
				$elm$core$List$head(fourni.Ba)),
			aJ: _List_Nil,
			pZ: _List_Nil,
			eK: false,
			b5: false,
			Ki: valeurs
		};
	});
var $author$project$Components$Shared$LibellesParLangue$Model$vide = $elm$core$Dict$empty;
var $author$project$Components$Produits$Catalogue$Creation$vide = {
	i8: A2(
		$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$depuis,
		{dw: _List_Nil, Ba: _List_Nil},
		_List_Nil),
	dt: _List_Nil,
	cq: false,
	vx: '',
	cu: false,
	dz: $elm$core$Maybe$Nothing,
	lI: '',
	gt: $elm$core$Maybe$Nothing,
	n8: '',
	g1: '',
	Dj: $author$project$Components$Shared$LibellesParLangue$Model$vide,
	aF: $author$project$Components$Shared$LibellesParLangue$Model$vide,
	ey: $elm$core$Maybe$Nothing,
	Gp: $author$project$Components$Produits$Catalogue$Creation$AucunProduit,
	bd: false,
	c1: _List_Nil,
	pN: $elm$core$Maybe$Nothing,
	pZ: $elm$core$Maybe$Nothing,
	bf: $elm$core$Maybe$Nothing,
	hI: false,
	aN: $elm$core$Maybe$Nothing,
	b5: false,
	fh: $elm$core$Maybe$Nothing,
	r3: $elm$core$Maybe$Nothing,
	r7: _List_Nil,
	sl: ''
};
var $author$project$Referentiel$Normes$Normes = $elm$core$Basics$identity;
var $author$project$Referentiel$Normes$vide = {ga: _List_Nil, Ba: _List_Nil, ho: _List_Nil};
var $author$project$Components$Produits$Catalogue$Model$init = function (preferences) {
	return {
		iz: $elm$core$Maybe$Nothing,
		bs: _List_Nil,
		jB: $elm$core$Maybe$Nothing,
		dA: $author$project$Components$Produits$Catalogue$Model$colonnesParDefaut,
		f0: false,
		wo: _List_Nil,
		f1: 0,
		kC: $author$project$Routes$Route$premiereListeDeReferences,
		kX: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$Catalogue$Model$nomDuDrawer),
		dP: $author$project$Components$Shared$Drawer$Model$init('produits-catalogue-lot'),
		aV: _List_Nil,
		gg: false,
		gl: false,
		l2: $author$project$API$Envoi$SansProcessUid,
		gC: 0,
		np: $elm$core$Maybe$Nothing,
		nW: A2(
			$author$project$Components$Shared$Annuaire$Model$init,
			$author$project$Components$Produits$Catalogue$Model$cleDAnnuaire,
			A3($author$project$Preferences$Model$annuaire, 0, $author$project$Components$Produits$Catalogue$Model$cleDAnnuaire, preferences)),
		n0: $elm$core$Maybe$Nothing,
		gY: false,
		oo: _List_Nil,
		ha: _List_Nil,
		hd: $author$project$Referentiel$Normes$vide,
		DX: 0,
		hA: $elm$core$Maybe$Nothing,
		bh: $elm$core$Maybe$Nothing,
		hP: $author$project$Components$Produits$Catalogue$Creation$vide,
		q3: $elm$core$Dict$empty,
		h$: $elm$core$Maybe$Nothing,
		h3: '',
		r7: _List_Nil,
		im: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$Catalogue$Model$nomDuVolet),
		$9: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$Catalogue$Model$nomDuVoletDesColonnes)
	};
};
var $author$project$Components$Produits$Correspondances$Model$DesLignes = 0;
var $author$project$Components$Produits$Correspondances$Model$nomDuDrawer = 'correspondances-geste';
var $author$project$Components$Produits$Correspondances$Model$ouvert = F3(
	function (lecture, lienDesListes, cible) {
		return {
			aS: $elm$core$Maybe$Nothing,
			L: _List_Nil,
			vf: cible,
			dx: '',
			dG: '',
			kX: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$Correspondances$Model$nomDuDrawer),
			l2: $author$project$API$Envoi$SansProcessUid,
			zo: $elm$core$Maybe$Nothing,
			mW: $elm$core$Maybe$Nothing,
			nf: false,
			np: lecture,
			R: $author$project$Components$Shared$LibellesParLangue$Model$vide,
			BF: lienDesListes,
			n_: $elm$core$Maybe$Nothing,
			hC: '',
			pZ: $elm$core$Maybe$Nothing,
			b5: false,
			sg: '',
			ig: $elm$core$Dict$empty,
			io: 0
		};
	});
var $author$project$Components$Produits$Correspondances$Model$init = A3($author$project$Components$Produits$Correspondances$Model$ouvert, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
var $author$project$Components$Produits$FicheElement$Model$AucunGeste = {$: 0};
var $author$project$Components$Produits$FicheElement$Model$Creation = {$: 1};
var $author$project$Components$Shared$OrdreDesBlocs$Model$init = {
	Q: _List_Nil,
	kX: $author$project$Components$Shared$Drawer$Model$init('ordre-des-blocs'),
	m_: $elm$core$Maybe$Nothing,
	B0: $elm$core$Maybe$Nothing,
	El: _List_Nil,
	qx: false
};
var $author$project$Components$Produits$FicheElement$Model$nomDuDrawer = function (geste) {
	switch (geste.$) {
		case 2:
			return 'produits-element-modifier';
		case 3:
			return 'produits-gammes-ordonner';
		case 4:
			return 'produits-fiche-element-valeurs';
		default:
			return 'produits-element-creer';
	}
};
var $author$project$I18n$Traductions$Tel = function (a) {
	return {$: 1, a: a};
};
var $author$project$I18n$Traductions$tel = $author$project$I18n$Traductions$Tel;
var $author$project$Components$Produits$Common$Saisie$ouverte = function (depart) {
	return {cx: depart, gi: false, R: depart.R, n8: depart.n8, Dj: depart.Dj, pZ: $elm$core$Maybe$Nothing, IY: depart.IY, b5: false};
};
var $author$project$Components$Produits$Common$Saisie$vide = $author$project$Components$Produits$Common$Saisie$ouverte(
	{R: $author$project$Components$Shared$LibellesParLangue$Model$vide, n8: '', Dj: '', IY: false});
var $author$project$Components$Produits$FicheElement$Model$init = {
	ir: $elm$core$Maybe$Nothing,
	iP: $author$project$I18n$Traductions$tel(''),
	kX: $author$project$Components$Shared$Drawer$Model$init(
		$author$project$Components$Produits$FicheElement$Model$nomDuDrawer($author$project$Components$Produits$FicheElement$Model$Creation)),
	l2: $author$project$API$Envoi$SansProcessUid,
	zo: $elm$core$Maybe$Nothing,
	mS: $elm$core$Maybe$Nothing,
	mW: $author$project$Components$Produits$FicheElement$Model$AucunGeste,
	m_: $elm$core$Maybe$Nothing,
	nf: false,
	np: $elm$core$Maybe$Nothing,
	n7: $elm$core$Maybe$Nothing,
	hd: $author$project$Referentiel$Normes$vide,
	o1: $author$project$Components$Shared$OrdreDesBlocs$Model$init,
	o2: $elm$core$Maybe$Nothing,
	hP: $author$project$Components$Produits$Common$Saisie$vide,
	Ki: $elm$core$Maybe$Nothing
};
var $author$project$Components$Shared$Bibliotheque$Rattachement$Creer = 0;
var $author$project$Components$Shared$EditeurDeSchema$Resserrage$SansApercu = {$: 0};
var $author$project$Components$Shared$EditeurDeSchema$Model$TypeDeProduit = 0;
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceFacultative = 'facultatif';
var $author$project$Components$Shared$EditeurDeSchema$Model$Niveau = 1;
var $author$project$Components$Shared$EditeurDeSchema$Model$ouverte = F3(
	function (langues, enregistre, formulaire) {
		return {tq: $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Vide, cx: formulaire, xE: _List_Nil, lZ: enregistre, zT: formulaire, Ba: langues, CC: $elm$core$Maybe$Nothing, hd: $author$project$Referentiel$Normes$vide, F$: 1, pZ: $elm$core$Maybe$Nothing, b5: false};
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$ajout = function (langues) {
	return A3(
		$author$project$Components$Shared$EditeurDeSchema$Model$ouverte,
		langues,
		$elm$core$Maybe$Nothing,
		{bq: $elm$core$Dict$empty, dy: '', ct: false, mo: $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceFacultative, R: $elm$core$Dict$empty, o_: $elm$core$Dict$empty, IX: _List_Nil, JR: '', KQ: $author$project$Components$Shared$EditeurDeSchema$Champ$Toujours});
};
var $author$project$Components$Shared$EditeurDeSchema$Model$dansLaPortee = F2(
	function (portee, saisie) {
		return _Utils_update(
			saisie,
			{F$: portee});
	});
var $author$project$Components$Shared$Bibliotheque$Rattachement$init = function (domaine) {
	return {
		dq: $elm$core$Maybe$Nothing,
		vd: $elm$core$Maybe$Nothing,
		cC: domaine,
		hC: '',
		pZ: $elm$core$Maybe$Nothing,
		qc: {xD: false, mo: $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceFacultative, n4: false, g4: 'essentiel'}
	};
};
var $author$project$Components$Shared$CollectionsDuType$Model$init = {
	fw: $elm$core$Maybe$Nothing,
	kY: $author$project$Components$Shared$Drawer$Model$init('collections-type-ajout'),
	lD: $author$project$Components$Shared$Drawer$Model$init('collections-type-retrait'),
	eW: $elm$core$Maybe$Nothing
};
var $author$project$Components$Produits$FicheType$Model$nomDuDrawer = function (enregistre) {
	return enregistre ? 'produits-type-champ-modifier' : 'produits-type-champ-ajouter';
};
var $author$project$Components$Produits$FicheType$Reglages$nomDuDrawer = 'produits-type-champ-reglages';
var $author$project$Components$Produits$FicheType$Model$nomDuDrawerElargir = 'produits-type-champ-elargir';
var $author$project$Components$Produits$FicheType$Model$init = {
	ir: false,
	dh: $elm$core$Maybe$Nothing,
	iP: $author$project$I18n$Traductions$tel(''),
	tq: $author$project$Components$Shared$EditeurDeSchema$Resserrage$SansApercu,
	vE: $author$project$Components$Shared$CollectionsDuType$Model$init,
	wZ: {zG: false, G1: false},
	kz: $elm$core$Maybe$Nothing,
	kX: $author$project$Components$Shared$Drawer$Model$init(
		$author$project$Components$Produits$FicheType$Model$nomDuDrawer(false)),
	lx: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$FicheType$Model$nomDuDrawerElargir),
	lA: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$FicheType$Reglages$nomDuDrawer),
	lB: $author$project$Components$Shared$Drawer$Model$init('produits-type-regle-de-code'),
	lC: $author$project$Components$Shared$Drawer$Model$init('produits-type-champ-restreindre'),
	lE: $author$project$Components$Shared$Drawer$Model$init('produits-type-valeurs-posees'),
	lP: $elm$core$Maybe$Nothing,
	l2: $author$project$API$Envoi$SansProcessUid,
	zo: $elm$core$Maybe$Nothing,
	m_: $elm$core$Maybe$Nothing,
	nf: false,
	np: $elm$core$Maybe$Nothing,
	nC: $elm$core$Maybe$Nothing,
	BF: $elm$core$Maybe$Nothing,
	nM: $elm$core$Maybe$Nothing,
	n_: _List_Nil,
	n9: 0,
	hd: $author$project$Referentiel$Normes$vide,
	oP: $author$project$Components$Parametrage$NouveauChamp$Model$init('produits-type'),
	oR: false,
	o1: $author$project$Components$Shared$OrdreDesBlocs$Model$init,
	o2: $elm$core$Maybe$Nothing,
	pN: $author$project$Components$Shared$Bibliotheque$Rattachement$init(0),
	eO: $elm$core$Maybe$Nothing,
	qd: $elm$core$Maybe$Nothing,
	hI: $elm$core$Maybe$Nothing,
	al: $elm$core$Maybe$Nothing,
	eW: $author$project$Components$Shared$Drawer$Model$init('produits-type-retirer'),
	hP: A2(
		$author$project$Components$Shared$EditeurDeSchema$Model$dansLaPortee,
		0,
		$author$project$Components$Shared$EditeurDeSchema$Model$ajout(_List_Nil)),
	ro: _List_Nil,
	J_: _List_Nil,
	r2: _List_Nil,
	sc: _List_Nil,
	si: $elm$core$Maybe$Nothing,
	ss: $elm$core$Maybe$Nothing
};
var $author$project$Components$Produits$ListeDePrix$Model$init = {
	iv: _List_Nil,
	fw: $elm$core$Maybe$Nothing,
	kX: $author$project$Components$Shared$Drawer$Model$init('produits-liste-de-prix-publics-modifier'),
	l2: $author$project$API$Envoi$SansProcessUid,
	zo: $elm$core$Maybe$Nothing,
	nf: false,
	np: $elm$core$Maybe$Nothing,
	DV: _List_Nil,
	X: _List_Nil,
	b_: $elm$core$Maybe$Nothing,
	p3: $elm$core$Maybe$Nothing,
	p7: _List_Nil,
	c7: _List_Nil,
	b5: false
};
var $author$project$Components$Produits$Listes$Model$DuCatalogue = 0;
var $author$project$Components$Produits$Listes$Model$nomDuDrawer = 'listes-geste';
var $author$project$Components$Produits$Listes$Model$ouvert = F2(
	function (lecture, cible) {
		return {
			aS: $elm$core$Maybe$Nothing,
			i8: _List_Nil,
			fC: $elm$core$Dict$empty,
			fL: _List_Nil,
			vf: cible,
			kX: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$Listes$Model$nomDuDrawer),
			l2: $author$project$API$Envoi$SansProcessUid,
			mW: $elm$core$Maybe$Nothing,
			nf: false,
			np: lecture,
			nW: $elm$core$Maybe$Nothing,
			hd: $author$project$Referentiel$Normes$vide,
			hp: {jL: _List_Nil, hC: ''},
			F$: 0,
			pZ: $elm$core$Maybe$Nothing,
			hP: '',
			rn: $elm$core$Maybe$Nothing,
			b5: false
		};
	});
var $author$project$Components$Produits$Listes$Model$init = A2($author$project$Components$Produits$Listes$Model$ouvert, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
var $author$project$Components$Produits$ListesDePrix$Model$cleDAnnuaire = 'produits-listes-de-prix';
var $author$project$Components$Produits$ListesDePrix$Model$nomDuDrawer = 'produits-liste-de-prix-creer';
var $author$project$Components$Produits$ListesDePrix$Creation$vide = {ku: '', kO: '', mI: '', Dj: $author$project$Components$Shared$LibellesParLangue$Model$vide, GA: _List_Nil, pZ: _List_Nil, bf: $elm$core$Maybe$Nothing, c4: $author$project$Catalogue$Vocabulaire$taxesExonerees, rA: '', b5: false};
var $author$project$Components$Produits$ListesDePrix$Model$init = function (preferences) {
	return {
		aS: $elm$core$Maybe$Nothing,
		kX: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$ListesDePrix$Model$nomDuDrawer),
		l2: $author$project$API$Envoi$SansProcessUid,
		np: $elm$core$Maybe$Nothing,
		nW: A2(
			$author$project$Components$Shared$Annuaire$Model$init,
			$author$project$Components$Produits$ListesDePrix$Model$cleDAnnuaire,
			A3($author$project$Preferences$Model$annuaire, 0, $author$project$Components$Produits$ListesDePrix$Model$cleDAnnuaire, preferences)),
		hP: $author$project$Components$Produits$ListesDePrix$Creation$vide
	};
};
var $author$project$Components$Produits$MarquesEtGammes$Model$cleDAnnuaire = 'produits-marques-et-gammes';
var $author$project$Components$Produits$MarquesEtGammes$Model$nomDuDrawer = 'produits-element-creer';
var $author$project$Components$Produits$MarquesEtGammes$Model$init = function (preferences) {
	return {
		aS: $elm$core$Maybe$Nothing,
		kX: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$MarquesEtGammes$Model$nomDuDrawer),
		l2: $author$project$API$Envoi$SansProcessUid,
		np: $elm$core$Maybe$Nothing,
		nW: A2(
			$author$project$Components$Shared$Annuaire$Model$init,
			$author$project$Components$Produits$MarquesEtGammes$Model$cleDAnnuaire,
			A3($author$project$Preferences$Model$annuaire, 0, $author$project$Components$Produits$MarquesEtGammes$Model$cleDAnnuaire, preferences)),
		hP: $author$project$Components$Produits$Common$Saisie$vide
	};
};
var $author$project$Components$Produits$Common$Etat$nomDuDrawer = 'produits-reference-changer-etat';
var $author$project$Components$Produits$Offre$Model$nomDuDrawerDeLaFiche = 'produits-offre-modifier';
var $author$project$Components$Produits$Offre$Model$init = {
	is: false,
	kX: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$Common$Etat$nomDuDrawer),
	lb: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$Offre$Model$nomDuDrawerDeLaFiche),
	l2: $author$project$API$Envoi$SansProcessUid,
	mi: $elm$core$Maybe$Nothing,
	zo: $elm$core$Maybe$Nothing,
	nf: false,
	np: $elm$core$Maybe$Nothing,
	hd: $author$project$Referentiel$Normes$vide,
	py: $elm$core$Maybe$Nothing,
	p_: $elm$core$Maybe$Nothing,
	p$: $elm$core$Maybe$Nothing,
	hE: $elm$core$Maybe$Nothing,
	eX: $elm$core$Maybe$Nothing,
	hP: A2(
		$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$depuis,
		{dw: _List_Nil, Ba: _List_Nil},
		_List_Nil)
};
var $author$project$Components$Produits$Offres$Model$cleDAnnuaire = 'produits-offres';
var $author$project$Components$Produits$Offres$Model$nomDuDrawer = 'produits-offre-creer';
var $author$project$Components$Produits$Offres$Creation$vide = {vx: '', Dj: $author$project$Components$Shared$LibellesParLangue$Model$vide, pN: $elm$core$Maybe$Nothing, pZ: $elm$core$Maybe$Nothing, bf: $elm$core$Maybe$Nothing, b5: false, fh: $elm$core$Maybe$Nothing};
var $author$project$Components$Produits$Offres$Model$init = function (preferences) {
	return {
		aS: $elm$core$Maybe$Nothing,
		kX: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$Offres$Model$nomDuDrawer),
		l2: $author$project$API$Envoi$SansProcessUid,
		np: $elm$core$Maybe$Nothing,
		nW: A2(
			$author$project$Components$Shared$Annuaire$Model$init,
			$author$project$Components$Produits$Offres$Model$cleDAnnuaire,
			A3($author$project$Preferences$Model$annuaire, 0, $author$project$Components$Produits$Offres$Model$cleDAnnuaire, preferences)),
		py: $elm$core$Maybe$Nothing,
		eX: $elm$core$Maybe$Nothing,
		hP: $author$project$Components$Produits$Offres$Creation$vide
	};
};
var $author$project$Components$Produits$Perimetres$Model$choixVide = {tV: '', uN: '', wg: '', g1: ''};
var $author$project$Components$Produits$Perimetres$Model$ouvert = F3(
	function (lecture, lienDesTypes, cible) {
		return {
			dj: _List_Nil,
			aS: $elm$core$Maybe$Nothing,
			tq: $elm$core$Maybe$Nothing,
			iT: $elm$core$Maybe$Nothing,
			fy: $elm$core$Maybe$Nothing,
			jo: '',
			jL: $elm$core$Dict$empty,
			fP: $author$project$Components$Produits$Perimetres$Model$choixVide,
			vf: cible,
			vn: $elm$core$Maybe$Nothing,
			kx: $elm$core$Maybe$Nothing,
			kX: $author$project$Components$Shared$Drawer$Model$init('perimetres-geste'),
			l2: $author$project$API$Envoi$SansProcessUid,
			cI: $elm$core$Maybe$Nothing,
			zo: $elm$core$Maybe$Nothing,
			mW: $elm$core$Maybe$Nothing,
			nf: false,
			np: lecture,
			R: $author$project$Components$Shared$LibellesParLangue$Model$vide,
			nK: lienDesTypes,
			cX: '',
			ek: $elm$core$Maybe$Nothing,
			Dj: '',
			et: $elm$core$Maybe$Nothing,
			hh: $elm$core$Maybe$Nothing,
			pi: $elm$core$Maybe$Nothing,
			hq: false,
			F$: 'toutes-references',
			Gw: $elm$core$Maybe$Nothing,
			hC: '',
			pS: '',
			Hc: $elm$core$Maybe$Nothing,
			pZ: $elm$core$Maybe$Nothing,
			qJ: _List_Nil,
			b5: false,
			dc: $elm$core$Maybe$Nothing,
			ib: $elm$core$Maybe$Nothing,
			fm: ''
		};
	});
var $author$project$Components$Produits$Perimetres$Model$init = A3($author$project$Components$Produits$Perimetres$Model$ouvert, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
var $author$project$Components$Produits$Reference$Model$AucunGeste = {$: 0};
var $author$project$Components$Produits$Common$ChoixDArticles$nomDuDrawerDeChoix = 'produits-reference-articles-choisir';
var $author$project$Components$Produits$Common$ChoixDArticles$nomDuDrawerDeRetrait = 'produits-reference-articles-retirer';
var $author$project$Components$Produits$Reference$Model$nomDuDrawer = function (geste) {
	switch (geste.$) {
		case 2:
			return 'produits-reference-dupliquer';
		case 3:
			return 'produits-reference-modifier';
		case 4:
			return 'produits-reference-historique';
		case 5:
			return 'produits-reference-fichier';
		case 6:
			return 'produits-reference-image';
		case 7:
			return 'produits-reference-image-retirer';
		case 8:
			return 'produits-reference-articles-modifier';
		case 9:
			return 'produits-reference-perimetre-choisir';
		case 10:
			return 'produits-reference-perimetre-creer';
		case 11:
			return $author$project$Components$Produits$Common$ChoixDArticles$nomDuDrawerDeChoix;
		case 12:
			return $author$project$Components$Produits$Common$ChoixDArticles$nomDuDrawerDeRetrait;
		case 13:
			return 'produits-reference-produit';
		case 14:
			return 'produits-reference-occurrence';
		case 15:
			return 'produits-reference-occurrence-retirer';
		case 16:
			return 'produits-reference-utilisateur';
		case 17:
			return 'produits-reference-recalcul';
		case 18:
			return 'produits-reference-code';
		case 19:
			return 'produits-reference-code-recalcul';
		default:
			return $author$project$Components$Produits$Common$Etat$nomDuDrawer;
	}
};
var $author$project$Components$Produits$Reference$Model$varianteVide = function (etat) {
	return {vx: '', fR: $elm$core$Maybe$Nothing, gt: etat, b5: false, sl: ''};
};
var $author$project$Components$Produits$Reference$Model$init = {
	is: false,
	dh: $elm$core$Maybe$Nothing,
	cl: $elm$core$Maybe$Nothing,
	tq: $elm$core$Maybe$Nothing,
	tt: $elm$core$Maybe$Nothing,
	iV: $elm$core$Maybe$Nothing,
	tP: $elm$core$Maybe$Nothing,
	uw: $elm$core$Maybe$Nothing,
	jB: $elm$core$Maybe$Nothing,
	fO: $elm$core$Maybe$Nothing,
	jY: '',
	wl: $elm$core$Maybe$Nothing,
	wZ: $elm$core$Maybe$Nothing,
	xc: $elm$core$Maybe$Nothing,
	gb: _List_Nil,
	kT: false,
	kX: $author$project$Components$Shared$Drawer$Model$init(
		$author$project$Components$Produits$Reference$Model$nomDuDrawer($author$project$Components$Produits$Reference$Model$AucunGeste)),
	l2: $author$project$API$Envoi$SansProcessUid,
	zo: $elm$core$Maybe$Nothing,
	gF: _List_Nil,
	mW: $author$project$Components$Produits$Reference$Model$AucunGeste,
	m6: $elm$core$Maybe$Nothing,
	af: $elm$core$Maybe$Nothing,
	nf: false,
	np: $elm$core$Maybe$Nothing,
	nx: {jB: $elm$core$Maybe$Nothing, h$: $elm$core$Maybe$Nothing},
	d9: {kE: $elm$core$Maybe$Nothing, kI: $elm$core$Maybe$Nothing, ol: $elm$core$Maybe$Nothing},
	hd: $author$project$Referentiel$Normes$vide,
	D$: $elm$core$Maybe$Nothing,
	D0: $elm$core$Maybe$Nothing,
	py: $elm$core$Maybe$Nothing,
	pC: $elm$core$Maybe$Nothing,
	Gw: _List_Nil,
	pP: '',
	pZ: $elm$core$Maybe$Nothing,
	qx: $elm$core$Maybe$Nothing,
	eW: $elm$core$Maybe$Nothing,
	hP: A2(
		$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$depuis,
		{dw: _List_Nil, Ba: _List_Nil},
		_List_Nil),
	r7: _List_Nil,
	J8: false,
	ih: $elm$core$Dict$empty,
	sl: $author$project$Components$Produits$Reference$Model$varianteVide($elm$core$Maybe$Nothing)
};
var $author$project$Components$Produits$SchemaDeNiveau$Model$nomDuDrawer = function (enregistre) {
	return enregistre ? 'produits-niveau-champ-modifier' : 'produits-niveau-champ-ajouter';
};
var $author$project$Components$Produits$SchemaDeNiveau$Model$init = {
	iP: $author$project$I18n$Traductions$tel(''),
	kC: $elm$core$Maybe$Nothing,
	kX: $author$project$Components$Shared$Drawer$Model$init(
		$author$project$Components$Produits$SchemaDeNiveau$Model$nomDuDrawer(false)),
	l2: $author$project$API$Envoi$SansProcessUid,
	m_: $elm$core$Maybe$Nothing,
	nf: false,
	np: $elm$core$Maybe$Nothing,
	os: $elm$core$Maybe$Nothing,
	hd: $author$project$Referentiel$Normes$vide,
	o2: $elm$core$Maybe$Nothing,
	hP: $author$project$Components$Shared$EditeurDeSchema$Model$ajout(_List_Nil),
	aN: $elm$core$Maybe$Nothing,
	h$: $elm$core$Maybe$Nothing
};
var $author$project$Components$Produits$TypesDeQuantite$Model$ouvert = function (lecture) {
	return {
		aS: $elm$core$Maybe$Nothing,
		uo: _List_Nil,
		vV: 'minimum',
		kX: $author$project$Components$Shared$Drawer$Model$init('types-de-quantite-geste'),
		l2: $author$project$API$Envoi$SansProcessUid,
		mW: $elm$core$Maybe$Nothing,
		m_: $elm$core$Maybe$Nothing,
		np: lecture,
		R: $author$project$Components$Shared$LibellesParLangue$Model$vide,
		El: _List_Nil,
		ez: false,
		pi: $elm$core$Maybe$Nothing,
		pZ: $elm$core$Maybe$Nothing,
		qD: _List_Nil,
		b5: false
	};
};
var $author$project$Components$Produits$TypesDeQuantite$Model$init = $author$project$Components$Produits$TypesDeQuantite$Model$ouvert($elm$core$Maybe$Nothing);
var $author$project$Components$Referentiel$Alertes$Model$init = {lV: false, ys: $elm$core$Maybe$Nothing, dZ: $elm$core$Maybe$Nothing, AL: '', n3: $elm$core$Maybe$Nothing, EE: 1, JT: ''};
var $author$project$Components$Referentiel$Doublons$Model$AExaminer = 0;
var $author$project$Components$Referentiel$Doublons$Model$Aucun = {$: 0};
var $author$project$Components$Referentiel$Doublons$Model$taillePage = 25;
var $author$project$Components$Referentiel$Doublons$Model$init = {
	fV: $elm$core$Maybe$Nothing,
	j6: $elm$core$Maybe$Nothing,
	bB: $author$project$Components$Referentiel$Doublons$Model$Aucun,
	kX: $author$project$Components$Shared$Drawer$Model$init('referentiel-doublons'),
	xX: $elm$core$Maybe$Nothing,
	yj: false,
	lV: false,
	cK: $elm$core$Maybe$Nothing,
	d_: $elm$core$Maybe$Nothing,
	n3: $elm$core$Maybe$Nothing,
	cX: '',
	g1: '',
	hd: $author$project$Referentiel$Normes$vide,
	oM: $elm$core$Maybe$Nothing,
	oZ: 0,
	EE: 1,
	Gn: $elm$core$Maybe$Nothing,
	qa: false,
	q3: _List_Nil,
	Jm: $author$project$Components$Referentiel$Doublons$Model$taillePage,
	h3: ''
};
var $author$project$Components$Referentiel$Fiche$Model$EnLecture = {$: 0};
var $author$project$Components$Referentiel$Fiche$Model$Fermee = {$: 0};
var $author$project$Components$Referentiel$Fiche$Model$SansProcessUid = {$: 0};
var $author$project$Components$Referentiel$Fiche$Resume$aucuneDepliee = {wa: false, GY: false, Hu: false};
var $author$project$Components$Referentiel$Common$ChoixDeLien$etatInitial = {
	gF: {tP: $elm$core$Maybe$Nothing, eA: $elm$core$Maybe$Nothing, Kf: $elm$core$Maybe$Nothing},
	DX: 0,
	Et: $elm$core$Maybe$Nothing,
	hN: _List_Nil
};
var $author$project$Components$Referentiel$Fiche$Contacts$Ferme = {$: 0};
var $author$project$Components$Referentiel$Fiche$Contacts$init = {dl: false, ae: false, zT: $author$project$Components$Referentiel$Fiche$Contacts$Ferme, a7: $elm$core$Maybe$Nothing, pN: $elm$core$Maybe$Nothing};
var $author$project$Components$Referentiel$Fiche$Effacement$init = {
	tq: $elm$core$Maybe$Nothing,
	v8: $elm$core$Maybe$Nothing,
	kX: $author$project$Components$Shared$Drawer$Model$init('referentiel-fiche-effacer'),
	gS: _List_Nil,
	cX: $elm$core$Maybe$Nothing,
	Gd: '',
	hP: ''
};
var $author$project$Components$Referentiel$Fiche$Export$init = {
	tq: $elm$core$Maybe$Nothing,
	f3: false,
	wv: '',
	kX: $author$project$Components$Shared$Drawer$Model$init('referentiel-fiche-exporter'),
	gO: false
};
var $author$project$Components$Referentiel$Fiche$Historique$EnAttente = 0;
var $author$project$Components$Referentiel$Fiche$Historique$init = {u7: 0, zj: $elm$core$Maybe$Nothing, np: 0, gV: _List_Nil, c$: 0, bR: $elm$core$Maybe$Nothing, IR: $elm$core$Maybe$Nothing, an: false, c9: false, I6: $elm$core$Maybe$Nothing};
var $author$project$Components$Referentiel$Fiche$Liaisons$Aucun = {$: 0};
var $author$project$Components$Referentiel$Fiche$Liaisons$NonDemandee = {$: 0};
var $author$project$Components$Referentiel$Fiche$Liaisons$nomDuDrawerDeFin = 'referentiel-rattachement-terminer';
var $author$project$Components$Referentiel$Fiche$Liaisons$init = {
	j6: $author$project$Components$Referentiel$Fiche$Liaisons$NonDemandee,
	kX: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Referentiel$Fiche$Liaisons$nomDuDrawerDeFin),
	aX: false,
	mW: $author$project$Components$Referentiel$Fiche$Liaisons$Aucun,
	bU: false,
	bV: false,
	F6: _List_Nil,
	pZ: $elm$core$Maybe$Nothing,
	rn: _List_Nil,
	P: false,
	ib: _List_Nil
};
var $author$project$Components$Referentiel$Fiche$Occurrences$init = {
	dh: $elm$core$Maybe$Nothing,
	kX: $author$project$Components$Shared$Drawer$Model$init('referentiel-fiche-occurrence'),
	Et: $elm$core$Maybe$Nothing,
	J8: false
};
var $author$project$Components$Referentiel$Fiche$Roles$Ferme = {$: 0};
var $author$project$Components$Referentiel$Fiche$Roles$OffresNonLues = {$: 0};
var $author$project$Components$Referentiel$Fiche$Roles$init = {zT: $author$project$Components$Referentiel$Fiche$Roles$Ferme, D3: $author$project$Components$Referentiel$Fiche$Roles$OffresNonLues, ib: _List_Nil};
var $author$project$Components$Referentiel$Fiche$Model$init = {
	ts: $elm$core$Maybe$Nothing,
	tS: $elm$core$Maybe$Nothing,
	ji: false,
	jq: $elm$core$Maybe$Nothing,
	vp: false,
	fX: false,
	v8: $author$project$Components$Referentiel$Fiche$Contacts$init,
	kp: $elm$core$Maybe$Nothing,
	kD: $elm$core$Maybe$Nothing,
	kH: $author$project$Components$Referentiel$Fiche$Resume$aucuneDepliee,
	cD: $elm$core$Maybe$Nothing,
	dI: false,
	k1: $author$project$Components$Shared$Drawer$Model$init('referentiel-role-evoluer'),
	k2: $author$project$Components$Shared$Drawer$Model$init('referentiel-fiche-identite'),
	k4: $author$project$Components$Shared$Drawer$Model$init('referentiel-role-ouvrir'),
	k9: $author$project$Components$Shared$Drawer$Model$init('referentiel-champ-historique'),
	lo: $author$project$Components$Shared$Drawer$Model$init('referentiel-fiche-champs-du-type'),
	lq: $author$project$Components$Shared$Drawer$Model$init('referentiel-fiche-contact'),
	lr: $author$project$Components$Shared$Drawer$Model$init('referentiel-fiche-cycle'),
	ge: $author$project$Components$Referentiel$Fiche$Model$Fermee,
	x9: $author$project$Components$Referentiel$Fiche$Effacement$init,
	lW: $elm$core$Maybe$Nothing,
	l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid,
	gt: $author$project$Components$Referentiel$Fiche$Model$EnLecture,
	ms: $author$project$Components$Referentiel$Fiche$Export$init,
	zS: _List_Nil,
	mT: false,
	gF: _List_Nil,
	m6: $author$project$Components$Referentiel$Fiche$Historique$init,
	bI: false,
	gI: false,
	Bk: $author$project$Components$Referentiel$Fiche$Liaisons$init,
	nB: $elm$core$Maybe$Nothing,
	nH: $elm$core$Maybe$Nothing,
	nK: $elm$core$Maybe$Nothing,
	nQ: $author$project$Components$Referentiel$Common$ChoixDeLien$etatInitial,
	hd: $author$project$Referentiel$Normes$vide,
	oV: $author$project$Components$Referentiel$Fiche$Occurrences$init,
	GN: _List_Nil,
	pT: 0,
	Hv: 0,
	bi: $author$project$Components$Referentiel$Fiche$Roles$init,
	c7: _List_Nil,
	hR: _List_Nil,
	b2: false,
	b3: $elm$core$Maybe$Nothing,
	rt: false,
	rY: $elm$core$Maybe$Nothing
};
var $author$project$Components$Referentiel$Formes$Model$nomDuDrawer = 'referentiel-forme';
var $author$project$Components$Referentiel$Formes$Model$Creation = {$: 0};
var $author$project$Components$Referentiel$Formes$Model$saisieVide = {yg: '', zX: '', n9: $author$project$Components$Referentiel$Formes$Model$Creation, bO: false, pZ: $elm$core$Maybe$Nothing, b5: false};
var $author$project$Components$Referentiel$Formes$Model$init = {
	i$: false,
	fG: false,
	kX: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Referentiel$Formes$Model$nomDuDrawer),
	l2: $author$project$API$Envoi$SansProcessUid,
	np: $elm$core$Maybe$Nothing,
	nW: $elm$core$Maybe$Nothing,
	DG: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Referentiel$Formes$Model$nomDuDrawer + '-noms'),
	hP: $author$project$Components$Referentiel$Formes$Model$saisieVide
};
var $author$project$Components$Referentiel$Fusion$Model$EnAttente = {$: 0};
var $author$project$Components$Referentiel$Fusion$Model$EtapeFiche = 0;
var $author$project$Components$Referentiel$Fusion$Model$Libre = {$: 0};
var $author$project$Components$Referentiel$Fusion$Model$init = {
	tq: $elm$core$Maybe$Nothing,
	ua: $elm$core$Maybe$Nothing,
	ve: $elm$core$Maybe$Nothing,
	jN: $elm$core$Dict$empty,
	j6: false,
	l2: $author$project$Components$Referentiel$Fusion$Model$Libre,
	me: 0,
	z$: $elm$core$Maybe$Nothing,
	gF: _List_Nil,
	z5: 0,
	mU: false,
	hd: $author$project$Referentiel$Normes$vide,
	Gf: $author$project$Components$Referentiel$Fusion$Model$EnAttente,
	Gw: _List_Nil,
	G3: $elm$core$Maybe$Nothing,
	hP: 0,
	Iv: $author$project$Components$Referentiel$Fusion$Model$EnAttente,
	IR: $elm$core$Maybe$Nothing,
	h3: '',
	$8: $elm$core$Maybe$Nothing,
	fj: $elm$core$Maybe$Nothing,
	im: $author$project$Components$Shared$Drawer$Model$init('referentiel-fusion')
};
var $author$project$Components$Referentiel$Common$Equipe$Inconnue = {$: 0};
var $author$project$Components$Referentiel$Groupe$Model$init = {
	ir: false,
	fw: $elm$core$Maybe$Nothing,
	iH: $author$project$Components$Shared$Drawer$Model$init('referentiel-groupe-ajout'),
	cs: $elm$core$Maybe$Nothing,
	jH: $author$project$Components$Shared$Drawer$Model$init('referentiel-groupe-responsable'),
	wp: $elm$core$Maybe$Nothing,
	kn: $author$project$Components$Shared$Drawer$Model$init('referentiel-groupe-criteres'),
	kD: $elm$core$Maybe$Nothing,
	l2: $author$project$API$Envoi$SansProcessUid,
	l5: $author$project$Components$Referentiel$Common$Equipe$Inconnue,
	zo: $elm$core$Maybe$Nothing,
	gF: _List_Nil,
	nf: false,
	oD: $elm$core$Maybe$Nothing,
	oE: $author$project$Components$Shared$Drawer$Model$init('referentiel-groupe-non-ajoutees'),
	hd: $author$project$Referentiel$Normes$vide,
	oO: _List_Nil,
	pZ: $elm$core$Maybe$Nothing,
	hL: $elm$core$Maybe$Nothing,
	qp: $author$project$Components$Shared$Drawer$Model$init('referentiel-groupe-renommer'),
	eW: $elm$core$Maybe$Nothing,
	qN: $author$project$Components$Shared$Drawer$Model$init('referentiel-groupe-retrait'),
	rr: $elm$core$Maybe$Nothing
};
var $author$project$Components$Referentiel$Groupes$Model$init = {
	aS: $elm$core$Maybe$Nothing,
	fB: false,
	wl: $elm$core$Maybe$Nothing,
	kX: $author$project$Components$Shared$Drawer$Model$init('referentiel-groupes-nouveau'),
	l2: $author$project$API$Envoi$SansProcessUid,
	l5: $author$project$Components$Referentiel$Common$Equipe$Inconnue,
	pZ: $elm$core$Maybe$Nothing
};
var $author$project$Components$Referentiel$Common$Offres$NonLue = {$: 0};
var $author$project$Components$Referentiel$PartiesPrenantes$Model$SansLecture = 0;
var $author$project$Components$Referentiel$PartiesPrenantes$Model$cleDAnnuaire = 'referentiel.parties-prenantes';
var $author$project$Components$Referentiel$PartiesPrenantes$Model$colonnesParDefaut = _List_fromArray(
	['nature', 'qualite', 'types', 'pays']);
var $author$project$Routes$Route$aucunFiltre = {dw: _List_Nil, gt: $elm$core$Maybe$Nothing, m2: $elm$core$Maybe$Nothing, g1: $elm$core$Maybe$Nothing, D1: $elm$core$Maybe$Nothing, ho: $elm$core$Maybe$Nothing, hy: $elm$core$Maybe$Nothing, qs: _List_Nil, ib: _List_Nil};
var $author$project$Routes$Route$pageDe = F2(
	function (page, taille) {
		return {mG: $author$project$Routes$Route$aucunFiltre, EE: page, Jm: taille, rS: 0};
	});
var $author$project$Routes$Route$premierePage = A2($author$project$Routes$Route$pageDe, 1, $author$project$Routes$Route$tailleParDefaut);
var $author$project$Components$Referentiel$PartiesPrenantes$Model$init = function (preferences) {
	return {
		fw: $elm$core$Maybe$Nothing,
		iP: $elm$core$Maybe$Nothing,
		aS: A2(
			$author$project$Components$Shared$Annuaire$Model$init,
			$author$project$Components$Referentiel$PartiesPrenantes$Model$cleDAnnuaire,
			A3($author$project$Preferences$Model$annuaire, 1, $author$project$Components$Referentiel$PartiesPrenantes$Model$cleDAnnuaire, preferences)),
		iR: $elm$core$Maybe$Nothing,
		jk: $elm$core$Maybe$Nothing,
		dw: _List_Nil,
		dA: $author$project$Components$Referentiel$PartiesPrenantes$Model$colonnesParDefaut,
		kc: $elm$core$Maybe$Nothing,
		kC: $elm$core$Maybe$Nothing,
		l2: $author$project$API$Envoi$SansProcessUid,
		l3: $author$project$API$Envoi$SansProcessUid,
		l5: $author$project$Components$Referentiel$Common$Equipe$Inconnue,
		gt: 0,
		gF: _List_Nil,
		Ac: _List_Nil,
		np: 0,
		B1: $elm$core$Maybe$Nothing,
		gY: false,
		hd: $author$project$Referentiel$Normes$vide,
		D3: $author$project$Components$Referentiel$Common$Offres$NonLue,
		EE: $author$project$Routes$Route$premierePage,
		pu: false,
		GN: _List_Nil,
		p0: $elm$core$Maybe$Nothing,
		hP: 0,
		h3: '',
		ib: _List_Nil,
		im: $author$project$Components$Shared$Drawer$Model$init('referentiel-parties-prenantes-filtres'),
		sw: $author$project$Components$Shared$Drawer$Model$init('referentiel-parties-prenantes-ajout-au-groupe'),
		$9: $author$project$Components$Shared$Drawer$Model$init('referentiel-parties-prenantes-colonnes'),
		sx: $author$project$Components$Shared$Drawer$Model$init('referentiel-parties-prenantes-groupe-dynamique')
	};
};
var $author$project$Components$Referentiel$Postes$Model$nomDuDrawer = 'referentiel-poste';
var $author$project$Components$Referentiel$Postes$Model$Creation = {$: 0};
var $author$project$Components$Referentiel$Postes$Model$saisieVide = {yg: '', zX: '', n9: $author$project$Components$Referentiel$Postes$Model$Creation, bO: false, pZ: $elm$core$Maybe$Nothing, b5: false};
var $author$project$Components$Referentiel$Postes$Model$init = {
	i$: false,
	fG: false,
	kX: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Referentiel$Postes$Model$nomDuDrawer),
	l2: $author$project$API$Envoi$SansProcessUid,
	np: $elm$core$Maybe$Nothing,
	nW: $elm$core$Maybe$Nothing,
	DG: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Referentiel$Postes$Model$nomDuDrawer + '-noms'),
	hP: $author$project$Components$Referentiel$Postes$Model$saisieVide
};
var $author$project$Components$Referentiel$Type$Model$NonDemandee = {$: 0};
var $author$project$Components$Shared$Bibliotheque$Domaine$PartiesPrenantes = 1;
var $author$project$Components$Referentiel$Type$Model$idDuRattachement = 'referentiel-type-rattacher-un-champ';
var $author$project$Components$Referentiel$Common$RattacherUnChamp$init = F2(
	function (domaine, nomDuDrawerElargir) {
		return {
			kz: $elm$core$Maybe$Nothing,
			lx: $author$project$Components$Shared$Drawer$Model$init(nomDuDrawerElargir),
			lP: $elm$core$Maybe$Nothing,
			n9: 0,
			pN: $author$project$Components$Shared$Bibliotheque$Rattachement$init(domaine)
		};
	});
var $author$project$Components$Referentiel$Type$Model$nomDeLaLimite = 'referentiel-type-limiter-offres';
var $author$project$Components$Referentiel$Type$Model$nomDuRenommage = 'referentiel-type-renommer';
var $author$project$Components$Referentiel$Common$SaisieDeType$ouverte = function (depart) {
	return {fA: depart.fA, kf: depart.kf, cx: depart, aC: depart.aC, R: depart.R, bW: $elm$core$Maybe$Nothing, pZ: $elm$core$Maybe$Nothing, b5: false};
};
var $author$project$Components$Referentiel$Common$SaisieDeType$vide = $author$project$Components$Referentiel$Common$SaisieDeType$ouverte(
	{fA: '', kf: '', aC: '', R: $author$project$Components$Shared$LibellesParLangue$Model$vide});
var $author$project$Components$Referentiel$Type$Model$ouvertAvec = F3(
	function (demandee, lecture, listes) {
		return {
			ir: false,
			dq: _List_Nil,
			at: _List_Nil,
			jZ: $elm$core$Maybe$Nothing,
			fW: false,
			kD: demandee,
			lz: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Referentiel$Type$Model$idDuRattachement),
			l2: $author$project$API$Envoi$SansProcessUid,
			zo: $elm$core$Maybe$Nothing,
			nf: false,
			np: lecture,
			nC: $elm$core$Maybe$Nothing,
			nG: $elm$core$Maybe$Nothing,
			BF: $elm$core$Maybe$Nothing,
			nV: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Referentiel$Type$Model$nomDeLaLimite),
			nY: $author$project$Components$Referentiel$Type$Model$NonDemandee,
			BW: listes,
			oP: $author$project$Components$Parametrage$NouveauChamp$Model$init('referentiel-type'),
			oR: false,
			D3: $author$project$Components$Referentiel$Common$Offres$NonLue,
			GZ: A2($author$project$Components$Referentiel$Common$RattacherUnChamp$init, 1, 'referentiel-type-champ-elargir'),
			hC: '',
			pZ: $elm$core$Maybe$Nothing,
			p2: $elm$core$Maybe$Nothing,
			hL: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Referentiel$Type$Model$nomDuRenommage),
			hP: $author$project$Components$Referentiel$Common$SaisieDeType$vide,
			e2: false,
			J_: _List_Nil,
			sc: _List_Nil
		};
	});
var $author$project$Components$Referentiel$Type$Model$ouvert = F2(
	function (demandee, lecture) {
		return A3($author$project$Components$Referentiel$Type$Model$ouvertAvec, demandee, lecture, $elm$core$Maybe$Nothing);
	});
var $author$project$Components$Referentiel$Type$Model$init = A2($author$project$Components$Referentiel$Type$Model$ouvert, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
var $author$project$Components$Referentiel$Common$ChoixDUnPerimetre$NonLue = {$: 0};
var $author$project$Components$Shared$EditeurDeSchema$Model$TypeDePartiePrenante = 2;
var $author$project$Components$Referentiel$Types$Informations$nomDuDrawer = 'referentiel-type-information-ajouter';
var $author$project$Components$Referentiel$Types$Informations$nomDuDrawerElargir = 'referentiel-type-champ-elargir';
var $author$project$Components$Referentiel$Types$Informations$nomDuDrawerElargirLaListe = 'referentiel-type-liste-elargir';
var $author$project$Components$Referentiel$Types$Informations$init = {
	iP: $author$project$I18n$Traductions$tel(''),
	tq: $author$project$Components$Shared$EditeurDeSchema$Resserrage$SansApercu,
	jZ: $elm$core$Maybe$Nothing,
	wC: $elm$core$Maybe$Nothing,
	wZ: {zG: false, G1: false},
	kX: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Referentiel$Types$Informations$nomDuDrawer),
	ly: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Referentiel$Types$Informations$nomDuDrawerElargirLaListe),
	lC: $author$project$Components$Shared$Drawer$Model$init('referentiel-type-champ-restreindre'),
	ge: $elm$core$Maybe$Nothing,
	gf: $elm$core$Maybe$Nothing,
	zo: $author$project$Components$Shared$Drawer$Model$init('referentiel-type-information'),
	m_: $elm$core$Maybe$Nothing,
	m6: $elm$core$Maybe$Nothing,
	nC: $elm$core$Maybe$Nothing,
	nG: $elm$core$Maybe$Nothing,
	BF: $elm$core$Maybe$Nothing,
	n_: _List_Nil,
	Ca: $author$project$Components$Shared$Drawer$Model$init('referentiel-type-information-masquee'),
	oP: $author$project$Components$Parametrage$NouveauChamp$Model$init('referentiel-types'),
	oR: false,
	o2: $elm$core$Maybe$Nothing,
	GZ: A2($author$project$Components$Referentiel$Common$RattacherUnChamp$init, 1, $author$project$Components$Referentiel$Types$Informations$nomDuDrawerElargir),
	pZ: $elm$core$Maybe$Nothing,
	eO: $elm$core$Maybe$Nothing,
	qc: $author$project$Components$Shared$Drawer$Model$init('referentiel-type-champ-reglages'),
	qj: false,
	al: $elm$core$Maybe$Nothing,
	hP: A2(
		$author$project$Components$Shared$EditeurDeSchema$Model$dansLaPortee,
		2,
		$author$project$Components$Shared$EditeurDeSchema$Model$ajout(_List_Nil)),
	J_: _List_Nil,
	sb: _List_Nil,
	ss: $author$project$Components$Shared$Drawer$Model$init('referentiel-type-versions')
};
var $author$project$Components$Referentiel$Types$Model$nomDuDrawer = 'referentiel-type-creer';
var $author$project$Components$Referentiel$Types$Model$nomDuDrawerDuType = 'referentiel-type-consulter';
var $author$project$Components$Referentiel$Types$Model$init = {
	aS: $elm$core$Maybe$Nothing,
	fG: false,
	jh: false,
	jK: $author$project$Components$Shared$Drawer$Model$init('referentiel-type-chemin'),
	u8: $elm$core$Maybe$Nothing,
	vd: $elm$core$Maybe$Nothing,
	jQ: $author$project$Components$Shared$Drawer$Model$init('referentiel-types-offres'),
	jR: $author$project$Components$Shared$Drawer$Model$init('referentiel-types-perimetre'),
	jX: _List_Nil,
	vE: $author$project$Components$Shared$CollectionsDuType$Model$init,
	j9: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Referentiel$Types$Model$nomDuDrawerDuType),
	bA: $elm$core$Maybe$Nothing,
	ki: $elm$core$Maybe$Nothing,
	kX: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Referentiel$Types$Model$nomDuDrawer),
	x1: $elm$core$Maybe$Nothing,
	ge: $elm$core$Maybe$Nothing,
	l2: $author$project$API$Envoi$SansProcessUid,
	gv: $elm$core$Maybe$Nothing,
	mz: false,
	mM: false,
	AM: $author$project$Components$Referentiel$Types$Informations$init,
	np: $elm$core$Maybe$Nothing,
	hd: $author$project$Referentiel$Normes$vide,
	D4: $author$project$Components$Referentiel$Common$Offres$NonLue,
	o1: $author$project$Components$Shared$OrdreDesBlocs$Model$init,
	pf: $elm$core$Maybe$Nothing,
	ph: $author$project$Components$Referentiel$Common$ChoixDUnPerimetre$NonLue,
	pJ: $author$project$Components$Shared$Drawer$Model$init('referentiel-type-rapide'),
	hC: '',
	pR: '',
	pV: '',
	p5: $elm$core$Maybe$Nothing,
	p6: $elm$core$Maybe$Nothing,
	qa: false,
	Hv: 0,
	hL: $author$project$Components$Shared$Drawer$Model$init('referentiel-type-renommer'),
	hP: $author$project$Components$Referentiel$Common$SaisieDeType$vide,
	e2: false,
	rW: false
};
var $author$project$Components$Referentiel$TypesDeRelation$Model$nomDuDrawer = 'referentiel-type-de-relation';
var $author$project$Components$Referentiel$TypesDeRelation$Model$Creation = {$: 0};
var $author$project$Components$Referentiel$TypesDeRelation$Model$coteVide = {zS: _List_Nil, bS: false, bX: false, rO: false};
var $author$project$Components$Referentiel$TypesDeRelation$Model$saisieVide = {tN: $author$project$Components$Referentiel$TypesDeRelation$Model$coteVide, cx: $author$project$Components$Referentiel$TypesDeRelation$Model$coteVide, cA: '', cB: '', cP: '', cQ: '', n9: $author$project$Components$Referentiel$TypesDeRelation$Model$Creation, bO: $elm$core$Maybe$Nothing, eD: false, G6: false, pZ: $elm$core$Maybe$Nothing, b5: false};
var $author$project$Components$Referentiel$TypesDeRelation$Model$init = {
	aS: $elm$core$Maybe$Nothing,
	i$: false,
	fG: false,
	kX: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Referentiel$TypesDeRelation$Model$nomDuDrawer),
	l2: $author$project$API$Envoi$SansProcessUid,
	zS: _List_Nil,
	np: $elm$core$Maybe$Nothing,
	BE: $elm$core$Maybe$Nothing,
	DG: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Referentiel$TypesDeRelation$Model$nomDuDrawer + '-noms'),
	hC: '',
	hP: $author$project$Components$Referentiel$TypesDeRelation$Model$saisieVide,
	rn: _List_Nil
};
var $author$project$Components$Shared$Navigation$Model$init = function (menuReplie) {
	return {j3: false, kG: false, l9: false, qt: menuReplie, hU: $elm$core$Dict$empty};
};
var $author$project$Components$Socle$Session$Model$Inconnue = {$: 0};
var $author$project$Components$Socle$Session$Model$RetourInattendu = {$: 2};
var $author$project$Routes$Route$adresseAccueil = '/' + $author$project$Routes$Route$segmentAccueil;
var $author$project$Components$Socle$Session$Update$DemanderAlea = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Socle$Session$Model$SansConfiguration = {$: 0};
var $author$project$Components$Socle$Session$Model$EnErreur = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Socle$Session$Update$enErreur = F2(
	function (cause, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					gt: $author$project$Components$Socle$Session$Model$EnErreur(cause),
					GQ: $elm$core$Maybe$Nothing
				}),
			_List_Nil);
	});
var $author$project$Components$Socle$Session$Model$octetsDuState = 16;
var $author$project$Components$Socle$Session$Model$octetsDuVerifier = 32;
var $author$project$Components$Socle$Session$Model$octetsDemandes = $author$project$Components$Socle$Session$Model$octetsDuVerifier + $author$project$Components$Socle$Session$Model$octetsDuState;
var $author$project$Components$Socle$Session$Model$pageDe = function (url) {
	return _Utils_ap(
		url.E6,
		_Utils_ap(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$append('?'),
					url.eI)),
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$append('#'),
					url.zY))));
};
var $author$project$Routes$Route$protegee = function (route) {
	switch (route.$) {
		case 1:
			return true;
		case 2:
			return true;
		case 3:
			return true;
		case 4:
			return true;
		case 5:
			return true;
		case 6:
			return true;
		case 7:
			return true;
		case 8:
			return true;
		case 9:
			return true;
		case 10:
			return true;
		case 11:
			return true;
		case 12:
			return true;
		case 13:
			return true;
		case 14:
			return true;
		case 15:
			return true;
		case 16:
			return true;
		case 17:
			return true;
		case 18:
			return true;
		case 19:
			return true;
		case 20:
			return true;
		case 21:
			return true;
		case 22:
			return true;
		case 23:
			return true;
		case 24:
			return true;
		case 25:
			return true;
		case 26:
			return true;
		case 27:
			return true;
		case 28:
			return true;
		case 29:
			return true;
		case 30:
			return true;
		case 31:
			return true;
		case 32:
			return true;
		case 33:
			return true;
		case 34:
			return true;
		case 35:
			return true;
		case 36:
			return true;
		case 37:
			return true;
		case 38:
			return true;
		case 39:
			return true;
		case 40:
			return true;
		case 41:
			return true;
		case 42:
			return true;
		case 43:
			return true;
		case 44:
			return true;
		case 45:
			return true;
		case 46:
			return true;
		case 50:
			return true;
		case 47:
			return true;
		case 48:
			return true;
		case 49:
			return true;
		case 51:
			return true;
		case 52:
			return true;
		case 53:
			return true;
		case 54:
			return true;
		case 55:
			return true;
		case 56:
			return true;
		case 57:
			return true;
		case 58:
			return true;
		case 59:
			return true;
		case 60:
			return true;
		case 61:
			return true;
		case 62:
			return true;
		case 63:
			return true;
		case 64:
			return true;
		case 65:
			return true;
		case 66:
			return true;
		case 67:
			return true;
		case 68:
			return true;
		case 69:
			return true;
		case 70:
			return true;
		case 0:
			return false;
		case 71:
			return false;
		case 72:
			return false;
		case 73:
			return false;
		default:
			return false;
	}
};
var $author$project$Components$Socle$Session$Update$demarrer = F2(
	function (model, url) {
		demarrer:
		while (true) {
			var surLaPage = _Utils_update(
				model,
				{
					EE: $author$project$Components$Socle$Session$Model$pageDe(url)
				});
			if (!$author$project$Routes$Route$protegee(
				$author$project$Routes$Route$fromUrl(url))) {
				return _Utils_Tuple2(model, _List_Nil);
			} else {
				var _v0 = _Utils_Tuple2(model.gt, model.v1);
				switch (_v0.a.$) {
					case 0:
						if (_v0.b.$ === 1) {
							var _v1 = _v0.a;
							var _v2 = _v0.b;
							return A2($author$project$Components$Socle$Session$Update$enErreur, $author$project$Components$Socle$Session$Model$SansConfiguration, surLaPage);
						} else {
							var _v3 = _v0.a;
							return _Utils_Tuple2(
								surLaPage,
								_List_fromArray(
									[
										$author$project$Components$Socle$Session$Update$DemanderAlea($author$project$Components$Socle$Session$Model$octetsDemandes)
									]));
						}
					case 3:
						var _v4 = _v0.a;
						var $temp$model = _Utils_update(
							model,
							{gt: $author$project$Components$Socle$Session$Model$Inconnue}),
							$temp$url = url;
						model = $temp$model;
						url = $temp$url;
						continue demarrer;
					default:
						return _Utils_Tuple2(surLaPage, _List_Nil);
				}
			}
		}
	});
var $author$project$Components$Socle$Session$Update$RemplacerAdresse = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Socle$Session$Update$echouerAuRetour = F2(
	function (cause, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					gt: $author$project$Components$Socle$Session$Model$EnErreur(cause)
				}),
			_List_fromArray(
				[
					$author$project$Components$Socle$Session$Update$RemplacerAdresse($author$project$Routes$Route$adresseAccueil)
				]));
	});
var $elm$json$Json$Decode$map4 = _Json_map4;
var $elm$core$String$endsWith = _String_endsWith;
var $author$project$Components$Socle$Session$Model$sansBarreFinale = function (adresse) {
	return A2($elm$core$String$endsWith, '/', adresse) ? A2($elm$core$String$dropRight, 1, adresse) : adresse;
};
var $author$project$Components$Socle$Session$Model$lireConfiguration = function (flags) {
	return $elm$core$Result$toMaybe(
		A2(
			$elm$json$Json$Decode$decodeValue,
			A5(
				$elm$json$Json$Decode$map4,
				F4(
					function (keycloakUrl, realm, clientId, apiRacineUrl) {
						return {
							fz: apiRacineUrl,
							jW: clientId,
							gh: $author$project$Components$Socle$Session$Model$sansBarreFinale(keycloakUrl) + ('/realms/' + realm)
						};
					}),
				A2($elm$json$Json$Decode$field, 'keycloakUrl', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'keycloakRealm', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'keycloakClientId', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'apiRacineUrl', $elm$json$Json$Decode$string)),
			flags));
};
var $author$project$Components$Socle$Session$Model$Parcours = F6(
	function (state, codeVerifier, retour, espace, action, reprise) {
		return {fs: action, vB: codeVerifier, yz: espace, qx: reprise, qL: retour, e3: state};
	});
var $elm$json$Json$Decode$map6 = _Json_map6;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$Components$Socle$Session$Model$lireParcours = function (flags) {
	return $elm$core$Result$toMaybe(
		A2(
			$elm$json$Json$Decode$decodeValue,
			A2(
				$elm$json$Json$Decode$field,
				'connexion',
				A7(
					$elm$json$Json$Decode$map6,
					$author$project$Components$Socle$Session$Model$Parcours,
					A2($elm$json$Json$Decode$field, 'state', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'codeVerifier', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'retour', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$json$Json$Decode$field,
								'espace',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
								$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
							])),
					$elm$json$Json$Decode$maybe(
						A2($elm$json$Json$Decode$field, 'action', $elm$json$Json$Decode$string)),
					$elm$json$Json$Decode$maybe(
						A2($elm$json$Json$Decode$field, 'reprise', $elm$json$Json$Decode$string)))),
			flags));
};
var $author$project$Components$Socle$Theme$Model$origine = function (url) {
	var protocole = function () {
		var _v0 = url.Gy;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return _Utils_ap(
		protocole,
		_Utils_ap(
			url.d2,
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (numero) {
						return ':' + $elm$core$String$fromInt(numero);
					},
					url.FX))));
};
var $truqu$elm_oauth2$Internal$AuthorizationError = F4(
	function (error, errorDescription, errorUri, state) {
		return {l6: error, l7: errorDescription, l8: errorUri, e3: state};
	});
var $truqu$elm_oauth2$Internal$errorDescriptionParser = $elm$url$Url$Parser$Query$string('error_description');
var $truqu$elm_oauth2$Internal$errorUriParser = $elm$url$Url$Parser$Query$string('error_uri');
var $truqu$elm_oauth2$Internal$stateParser = $elm$url$Url$Parser$Query$string('state');
var $truqu$elm_oauth2$Internal$authorizationErrorParser = function (errorCode) {
	return A4(
		$elm$url$Url$Parser$Query$map3,
		$truqu$elm_oauth2$Internal$AuthorizationError(errorCode),
		$truqu$elm_oauth2$Internal$errorDescriptionParser,
		$truqu$elm_oauth2$Internal$errorUriParser,
		$truqu$elm_oauth2$Internal$stateParser);
};
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$defaultAuthorizationErrorParser = $truqu$elm_oauth2$Internal$authorizationErrorParser;
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$AuthorizationSuccess = F2(
	function (code, state) {
		return {vx: code, e3: state};
	});
var $elm$url$Url$Parser$Query$map = F2(
	function (func, _v0) {
		var a = _v0;
		return function (dict) {
			return func(
				a(dict));
		};
	});
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$defaultAuthorizationSuccessParser = function (code) {
	return A2(
		$elm$url$Url$Parser$Query$map,
		$truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$AuthorizationSuccess(code),
		$truqu$elm_oauth2$Internal$stateParser);
};
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$defaultCodeParser = $elm$url$Url$Parser$Query$string('code');
var $truqu$elm_oauth2$OAuth$AccessDenied = {$: 2};
var $truqu$elm_oauth2$OAuth$Custom = function (a) {
	return {$: 7, a: a};
};
var $truqu$elm_oauth2$OAuth$InvalidRequest = {$: 0};
var $truqu$elm_oauth2$OAuth$InvalidScope = {$: 4};
var $truqu$elm_oauth2$OAuth$ServerError = {$: 5};
var $truqu$elm_oauth2$OAuth$TemporarilyUnavailable = {$: 6};
var $truqu$elm_oauth2$OAuth$UnauthorizedClient = {$: 1};
var $truqu$elm_oauth2$OAuth$UnsupportedResponseType = {$: 3};
var $truqu$elm_oauth2$OAuth$errorCodeFromString = function (str) {
	switch (str) {
		case 'invalid_request':
			return $truqu$elm_oauth2$OAuth$InvalidRequest;
		case 'unauthorized_client':
			return $truqu$elm_oauth2$OAuth$UnauthorizedClient;
		case 'access_denied':
			return $truqu$elm_oauth2$OAuth$AccessDenied;
		case 'unsupported_response_type':
			return $truqu$elm_oauth2$OAuth$UnsupportedResponseType;
		case 'invalid_scope':
			return $truqu$elm_oauth2$OAuth$InvalidScope;
		case 'server_error':
			return $truqu$elm_oauth2$OAuth$ServerError;
		case 'temporarily_unavailable':
			return $truqu$elm_oauth2$OAuth$TemporarilyUnavailable;
		default:
			return $truqu$elm_oauth2$OAuth$Custom(str);
	}
};
var $truqu$elm_oauth2$Internal$errorParser = function (errorCodeFromString) {
	return A2(
		$elm$url$Url$Parser$Query$map,
		$elm$core$Maybe$map(errorCodeFromString),
		$elm$url$Url$Parser$Query$string('error'));
};
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$defaultErrorParser = $truqu$elm_oauth2$Internal$errorParser($truqu$elm_oauth2$OAuth$errorCodeFromString);
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$defaultParsers = {fD: $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$defaultAuthorizationErrorParser, fE: $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$defaultAuthorizationSuccessParser, fQ: $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$defaultCodeParser, gq: $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$defaultErrorParser};
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$Empty = {$: 0};
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$Error = function (a) {
	return {$: 1, a: a};
};
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$Success = function (a) {
	return {$: 2, a: a};
};
var $truqu$elm_oauth2$OAuth$AuthorizationCode$Empty = {$: 0};
var $truqu$elm_oauth2$OAuth$AuthorizationCode$Error = function (a) {
	return {$: 1, a: a};
};
var $truqu$elm_oauth2$OAuth$AuthorizationCode$Success = function (a) {
	return {$: 2, a: a};
};
var $truqu$elm_oauth2$Internal$parseUrlQuery = F3(
	function (url, def, parser) {
		return A2(
			$elm$core$Maybe$withDefault,
			def,
			A2(
				$elm$url$Url$Parser$parse,
				$elm$url$Url$Parser$query(parser),
				url));
	});
var $truqu$elm_oauth2$OAuth$AuthorizationCode$parseCodeWith = F2(
	function (_v0, url_) {
		var codeParser = _v0.fQ;
		var errorParser = _v0.gq;
		var authorizationSuccessParser = _v0.fE;
		var authorizationErrorParser = _v0.fD;
		var url = _Utils_update(
			url_,
			{E6: '/'});
		var _v1 = A2(
			$elm$url$Url$Parser$parse,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$top,
				A3($elm$url$Url$Parser$Query$map2, $elm$core$Tuple$pair, codeParser, errorParser)),
			url);
		_v1$2:
		while (true) {
			if (!_v1.$) {
				if (!_v1.a.a.$) {
					var _v2 = _v1.a;
					var code = _v2.a.a;
					return A3(
						$truqu$elm_oauth2$Internal$parseUrlQuery,
						url,
						$truqu$elm_oauth2$OAuth$AuthorizationCode$Empty,
						A2(
							$elm$url$Url$Parser$Query$map,
							$truqu$elm_oauth2$OAuth$AuthorizationCode$Success,
							authorizationSuccessParser(code)));
				} else {
					if (!_v1.a.b.$) {
						var _v3 = _v1.a;
						var error = _v3.b.a;
						return A3(
							$truqu$elm_oauth2$Internal$parseUrlQuery,
							url,
							$truqu$elm_oauth2$OAuth$AuthorizationCode$Empty,
							A2(
								$elm$url$Url$Parser$Query$map,
								$truqu$elm_oauth2$OAuth$AuthorizationCode$Error,
								authorizationErrorParser(error)));
					} else {
						break _v1$2;
					}
				}
			} else {
				break _v1$2;
			}
		}
		return $truqu$elm_oauth2$OAuth$AuthorizationCode$Empty;
	});
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$parseCodeWith = F2(
	function (parsers, url) {
		var _v0 = A2($truqu$elm_oauth2$OAuth$AuthorizationCode$parseCodeWith, parsers, url);
		switch (_v0.$) {
			case 0:
				return $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$Empty;
			case 2:
				var s = _v0.a;
				return $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$Success(s);
			default:
				var e = _v0.a;
				return $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$Error(e);
		}
	});
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$parseCode = $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$parseCodeWith($truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$defaultParsers);
var $author$project$Components$Socle$Session$Update$EchangerCode = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Socle$Session$Model$cheminDuBackOffice = function (retour) {
	return (A2($elm$core$String$startsWith, '/', retour) && ((!A2($elm$core$String$startsWith, '//', retour)) && (!A2($elm$core$String$contains, '\\', retour)))) ? retour : $author$project$Routes$Route$adresseAccueil;
};
var $author$project$Components$Socle$Session$Model$adresseDeRetour = function (origine) {
	return _Utils_ap(origine, $author$project$Routes$Route$adresseAccueil);
};
var $author$project$Components$Socle$Session$Model$pointDuRealm = F2(
	function (configuration, point) {
		return configuration.gh + ('/protocol/openid-connect/' + point);
	});
var $author$project$Components$Socle$Session$Model$echange = F4(
	function (configuration, origine, code, parcours) {
		return {
			jW: configuration.jW,
			vx: code,
			vB: parcours.vB,
			G9: $author$project$Components$Socle$Session$Model$adresseDeRetour(origine),
			aQ: A2($author$project$Components$Socle$Session$Model$pointDuRealm, configuration, 'token')
		};
	});
var $author$project$Components$Socle$Session$Update$revenir = F5(
	function (configuration, recu, statut, garde, model) {
		if (!garde.$) {
			var parcours = garde.a;
			return _Utils_eq(
				recu.e3,
				$elm$core$Maybe$Just(parcours.e3)) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{
						yA: parcours.yz,
						EE: $author$project$Components$Socle$Session$Model$cheminDuBackOffice(parcours.qL),
						qx: parcours.qx,
						H1: A3(
							$elm$core$Maybe$map2,
							F2(
								function (action, lu) {
									return {fs: action, ri: lu};
								}),
							parcours.fs,
							statut)
					}),
				_List_fromArray(
					[
						$author$project$Components$Socle$Session$Update$EchangerCode(
						A4($author$project$Components$Socle$Session$Model$echange, configuration, model.o4, recu.vx, parcours))
					])) : A2($author$project$Components$Socle$Session$Update$echouerAuRetour, $author$project$Components$Socle$Session$Model$RetourInattendu, model);
		} else {
			return A2($author$project$Components$Socle$Session$Update$echouerAuRetour, $author$project$Components$Socle$Session$Model$RetourInattendu, model);
		}
	});
var $author$project$Components$Socle$Session$Model$statutDAction = function (url) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filterMap,
			function (parametre) {
				var _v0 = A2($elm$core$String$split, '=', parametre);
				if (((_v0.b && (_v0.a === 'kc_action_status')) && _v0.b.b) && (!_v0.b.b.b)) {
					var _v1 = _v0.b;
					var valeur = _v1.a;
					return $elm$url$Url$percentDecode(valeur);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			A2(
				$elm$core$String$split,
				'&',
				A2($elm$core$Maybe$withDefault, '', url.eI))));
};
var $author$project$Components$Socle$Session$Update$init = F2(
	function (flags, url) {
		var model = {
			fs: $elm$core$Maybe$Nothing,
			v1: $author$project$Components$Socle$Session$Model$lireConfiguration(flags),
			yA: $elm$core$Maybe$Nothing,
			gt: $author$project$Components$Socle$Session$Model$Inconnue,
			o4: $author$project$Components$Socle$Theme$Model$origine(url),
			EE: $author$project$Routes$Route$adresseAccueil,
			GQ: $elm$core$Maybe$Nothing,
			qx: $elm$core$Maybe$Nothing,
			H1: $elm$core$Maybe$Nothing,
			JL: $author$project$I18n$Traductions$francais
		};
		var _v0 = _Utils_Tuple3(
			$author$project$Routes$Route$protegee(
				$author$project$Routes$Route$fromUrl(url)),
			model.v1,
			$truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$parseCode(
				_Utils_update(
					url,
					{E6: '/'})));
		_v0$2:
		while (true) {
			if (_v0.a && (!_v0.b.$)) {
				switch (_v0.c.$) {
					case 2:
						var configuration = _v0.b.a;
						var recu = _v0.c.a;
						return A5(
							$author$project$Components$Socle$Session$Update$revenir,
							configuration,
							recu,
							$author$project$Components$Socle$Session$Model$statutDAction(url),
							$author$project$Components$Socle$Session$Model$lireParcours(flags),
							model);
					case 1:
						return A2($author$project$Components$Socle$Session$Update$echouerAuRetour, $author$project$Components$Socle$Session$Model$RetourInattendu, model);
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return A2($author$project$Components$Socle$Session$Update$demarrer, model, url);
	});
var $author$project$Components$Socle$Theme$Model$EnAttente = {$: 1};
var $author$project$Components$Socle$Theme$Update$LireTheme = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Socle$Theme$Model$SansAdresse = {$: 0};
var $author$project$Components$Socle$Theme$Model$delaiMs = 2000;
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$Components$Socle$Theme$Update$init = F2(
	function (flags, backoffice) {
		var themeUrl = $elm$core$Result$toMaybe(
			A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$field, 'themeUrl', $elm$json$Json$Decode$string),
				flags));
		var originesMarque = A2(
			$elm$core$Result$withDefault,
			_List_Nil,
			A2(
				$elm$json$Json$Decode$decodeValue,
				A2(
					$elm$json$Json$Decode$field,
					'originesMarque',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
				flags));
		var origineDeLaRoute = A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Socle$Theme$Model$origine, $elm$core$List$singleton),
			A2($elm$core$Maybe$andThen, $elm$url$Url$fromString, themeUrl));
		var origines = A2(
			$elm$core$List$cons,
			$author$project$Components$Socle$Theme$Model$origine(backoffice),
			_Utils_ap(
				A2($elm$core$Maybe$withDefault, _List_Nil, origineDeLaRoute),
				originesMarque));
		if (themeUrl.$ === 1) {
			return _Utils_Tuple2(
				{gt: $author$project$Components$Socle$Theme$Model$SansAdresse, hj: origines},
				_List_Nil);
		} else {
			var url = themeUrl.a;
			return _Utils_Tuple2(
				{gt: $author$project$Components$Socle$Theme$Model$EnAttente, hj: origines},
				_List_fromArray(
					[
						$author$project$Components$Socle$Theme$Update$LireTheme(
						{w4: $author$project$Components$Socle$Theme$Model$delaiMs, aQ: url})
					]));
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$Catalogue = {$: 0};
var $author$project$Components$Produits$StructureCatalogue$Model$SansProcessUid = {$: 0};
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$SansReecriture = {$: 0};
var $author$project$Components$Produits$StructureCatalogue$Categories$Model$nomDuDrawer = 'produits-type-creer';
var $author$project$Components$Produits$StructureCatalogue$Categories$Model$saisieVide = function (nature) {
	return {gi: false, R: $author$project$Components$Shared$LibellesParLangue$Model$vide, g1: nature, g2: nature, pZ: $elm$core$Maybe$Nothing, b5: false};
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Model$init = {
	aS: $elm$core$Maybe$Nothing,
	uK: $elm$core$Maybe$Nothing,
	kk: $elm$core$Maybe$Nothing,
	kX: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$StructureCatalogue$Categories$Model$nomDuDrawer),
	la: $author$project$Components$Shared$Drawer$Model$init('produits-categorie-modifier'),
	l2: $author$project$API$Envoi$SansProcessUid,
	np: $elm$core$Maybe$Nothing,
	oo: _List_Nil,
	hA: $elm$core$Maybe$Nothing,
	hL: $author$project$Components$Shared$Drawer$Model$init('produits-categorie-renommer'),
	eW: $author$project$Components$Shared$Drawer$Model$init('produits-categorie-retirer'),
	hP: $author$project$Components$Produits$StructureCatalogue$Categories$Model$saisieVide('')
};
var $author$project$Components$Produits$StructureCatalogue$Gammes$Model$nomDuDrawer = 'produits-gamme-creer';
var $author$project$Components$Produits$StructureCatalogue$Gammes$Model$init = {
	iv: _List_Nil,
	fY: $elm$core$Maybe$Nothing,
	kX: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$StructureCatalogue$Gammes$Model$nomDuDrawer),
	l2: $author$project$API$Envoi$SansProcessUid,
	ew: $elm$core$Maybe$Nothing,
	hP: $author$project$Components$Produits$Common$Saisie$vide
};
var $author$project$Components$Produits$StructureCatalogue$Marques$Model$nomDuDrawer = 'produits-marque-creer';
var $author$project$Components$Produits$StructureCatalogue$Marques$Model$init = {
	aS: $elm$core$Maybe$Nothing,
	tI: $elm$core$Maybe$Nothing,
	kX: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$StructureCatalogue$Marques$Model$nomDuDrawer),
	l2: $author$project$API$Envoi$SansProcessUid,
	np: $elm$core$Maybe$Nothing,
	hP: $author$project$Components$Produits$Common$Saisie$vide
};
var $author$project$Components$Produits$StructureCatalogue$Produits$Model$nomDuDrawer = 'produits-produit-creer';
var $author$project$Components$Produits$StructureCatalogue$Produits$Model$nomDuDrawerDeRestriction = 'produits-produit-restreindre';
var $author$project$Components$Produits$StructureCatalogue$Produits$Model$init = {
	jB: $elm$core$Maybe$Nothing,
	kX: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$StructureCatalogue$Produits$Model$nomDuDrawer),
	lg: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$StructureCatalogue$Produits$Model$nomDuDrawerDeRestriction),
	l2: $author$project$API$Envoi$SansProcessUid,
	gF: $elm$core$Maybe$Nothing,
	ew: $elm$core$Maybe$Nothing,
	p4: $elm$core$Maybe$Nothing,
	al: $elm$core$Maybe$Nothing,
	hP: $author$project$Components$Produits$Common$Saisie$vide
};
var $author$project$Components$Produits$StructureCatalogue$Archivage$Model$ToutesLesReferences = 0;
var $author$project$Components$Produits$StructureCatalogue$Archivage$Model$nomDuDrawer = 'produits-typologie-archiver';
var $author$project$Components$Produits$StructureCatalogue$Archivage$Model$nomDuDrawerDeCorrespondance = 'produits-typologie-archiver-correspondance';
var $author$project$Components$Produits$StructureCatalogue$Archivage$Model$sansLots = {
	uq: {iz: 0, vf: $elm$core$Maybe$Nothing, vr: 0, Cw: 0},
	zi: 0,
	Aw: _List_Nil,
	d8: false,
	qD: $elm$core$Maybe$Nothing,
	JN: 0
};
var $author$project$Components$Produits$StructureCatalogue$Archivage$Model$initial = {
	it: _List_Nil,
	tq: $elm$core$Maybe$Nothing,
	vf: $elm$core$Maybe$Nothing,
	wg: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$StructureCatalogue$Archivage$Model$nomDuDrawerDeCorrespondance),
	kX: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$StructureCatalogue$Archivage$Model$nomDuDrawer),
	zH: $elm$core$Maybe$Nothing,
	a6: $author$project$Components$Produits$StructureCatalogue$Archivage$Model$sansLots,
	F$: 0,
	hD: _List_Nil,
	r3: $elm$core$Maybe$Nothing,
	Ki: _List_Nil
};
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$Aucun = {$: 0};
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nomDuDrawer = 'produits-valeur-saisir';
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$initiale = {
	iP: $author$project$I18n$Traductions$tel(''),
	kX: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$StructureCatalogue$Classifications$Model$nomDuDrawer),
	mW: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$Aucun,
	m_: $elm$core$Maybe$Nothing,
	Et: $elm$core$Maybe$Nothing,
	pt: $elm$core$Maybe$Nothing
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Etage$nomDuDrawer = 'produits-etage-modifier';
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$nomDuDrawerDAjout = 'produits-typologie-etage-ajouter';
var $author$project$Components$Produits$StructureCatalogue$Typologies$Model$nomDuDrawerDAjout = 'produits-typologie-ajouter';
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$nomDuDrawerDInformation = 'produits-information';
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$nomDuDrawerDeConsultation = 'produits-consultation';
var $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$nomDuDrawerDeListe = 'produits-information-nouvelle-liste';
var $author$project$Components$Produits$StructureCatalogue$Informations$Etage$nomDuDrawerDePerimetre = 'produits-reference-perimetre-choisir';
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$nomDuDrawerDeRangement = 'produits-typologie-rangement-modifier';
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$nomDuDrawerDeRattachement = 'produits-information-rattacher';
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$nomDuDrawerDeRenommage = 'produits-typologie-etage-renommer';
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$nomDuDrawerDeRenommage = 'produits-information-renommer';
var $author$project$Components$Produits$StructureCatalogue$Natures$Model$nomDuDrawerDeRenommage = 'produits-nature-renommer';
var $author$project$Components$Produits$StructureCatalogue$Typologies$Model$nomDuDrawerDeRenommage = 'produits-typologie-renommer';
var $author$project$Components$Produits$StructureCatalogue$Typologies$Model$nomDuDrawerDeRetrait = 'produits-typologie-retirer';
var $author$project$Catalogue$Formes$Masculin = 0;
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$formeVide = {av: false, M: 0, bT: ''};
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$sansFormes = {yg: $author$project$Components$Produits$StructureCatalogue$Etages$Model$formeVide, zX: $author$project$Components$Produits$StructureCatalogue$Etages$Model$formeVide};
var $author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$vide = function (portee) {
	return {vd: $elm$core$Maybe$Nothing, gB: '', F$: portee, hC: '', pZ: $elm$core$Maybe$Nothing};
};
var $author$project$Components$Produits$StructureCatalogue$Saisie$vide = {ck: false, R: $author$project$Components$Shared$LibellesParLangue$Model$vide, eJ: false, b5: false};
var $author$project$Components$Produits$StructureCatalogue$Model$initial = {
	cd: _List_Nil,
	iy: $elm$core$Maybe$Nothing,
	iA: $elm$core$Maybe$Nothing,
	y: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$StructureCatalogue$Etages$Model$nomDuDrawerDAjout),
	br: $author$project$Components$Shared$Drawer$Model$init('produits-etat-ajouter'),
	iG: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$StructureCatalogue$Typologies$Model$nomDuDrawerDAjout),
	tl: $author$project$I18n$Traductions$tel(''),
	cl: $elm$core$Maybe$Nothing,
	tD: $author$project$Components$Produits$StructureCatalogue$Archivage$Model$initial,
	i_: $elm$core$Maybe$Nothing,
	tP: $elm$core$Maybe$Nothing,
	bt: $elm$core$Dict$empty,
	dq: $elm$core$Maybe$Nothing,
	jB: $elm$core$Maybe$Nothing,
	dt: $author$project$Components$Produits$StructureCatalogue$Categories$Model$init,
	jC: _List_Nil,
	uQ: $elm$core$Maybe$Nothing,
	jN: _List_Nil,
	fO: $elm$core$Maybe$Nothing,
	vk: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$initiale,
	j9: $elm$core$Maybe$Nothing,
	cy: $elm$core$Maybe$Nothing,
	dK: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$StructureCatalogue$Informations$Etage$nomDuDrawer),
	dL: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$StructureCatalogue$Informations$Model$nomDuDrawerDInformation),
	k3: $author$project$Components$Shared$Drawer$Model$init('produits-valeur-ordonner'),
	dM: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$Common$ChoixDArticles$nomDuDrawerDeChoix),
	gc: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$StructureCatalogue$Informations$Model$nomDuDrawerDeConsultation),
	dN: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$StructureCatalogue$Informations$Etage$nomDuDrawerDePerimetre),
	le: $author$project$Components$Shared$Drawer$Model$init('produits-valeur-ranger-sous'),
	l2: $author$project$Components$Produits$StructureCatalogue$Model$SansProcessUid,
	gr: $elm$core$Maybe$Nothing,
	cG: $elm$core$Maybe$Nothing,
	s: $elm$core$Maybe$Nothing,
	dT: $elm$core$Maybe$Nothing,
	mL: _List_Nil,
	I: $author$project$Components$Produits$StructureCatalogue$Etages$Model$sansFormes,
	mP: $author$project$Components$Produits$StructureCatalogue$Etages$Model$sansFormes,
	mQ: $author$project$Components$Produits$StructureCatalogue$Etages$Model$sansFormes,
	mS: $elm$core$Maybe$Nothing,
	gF: _List_Nil,
	gG: $author$project$Components$Produits$StructureCatalogue$Gammes$Model$init,
	d5: $elm$core$Maybe$Nothing,
	AM: $elm$core$Maybe$Nothing,
	ag: false,
	np: $elm$core$Maybe$Nothing,
	nt: {jB: $elm$core$Maybe$Nothing, h$: $elm$core$Maybe$Nothing},
	nC: $elm$core$Maybe$Nothing,
	nI: $elm$core$Maybe$Nothing,
	BO: _List_Nil,
	nS: _List_Nil,
	ed: $elm$core$Maybe$Nothing,
	BX: $elm$core$Maybe$Nothing,
	cU: $author$project$Components$Produits$StructureCatalogue$Marques$Model$init,
	cV: $elm$core$Maybe$Nothing,
	on: $elm$core$Maybe$Nothing,
	g8: $author$project$Components$Produits$StructureCatalogue$Saisie$vide,
	oK: $elm$core$Maybe$Nothing,
	oP: $author$project$Components$Parametrage$NouveauChamp$Model$init('informations'),
	oQ: $elm$core$Maybe$Nothing,
	oR: false,
	a9: $author$project$Components$Produits$StructureCatalogue$Saisie$vide,
	T: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$nomDuDrawerDeListe),
	c_: false,
	El: $elm$core$Maybe$Nothing,
	pl: $elm$core$Maybe$Nothing,
	aK: $author$project$Components$Produits$StructureCatalogue$Produits$Model$init,
	hA: $elm$core$Maybe$Nothing,
	bZ: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$StructureCatalogue$Etages$Model$nomDuDrawerDeRangement),
	pN: $author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$vide($author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$Catalogue),
	pO: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$StructureCatalogue$Informations$Model$nomDuDrawerDeRattachement),
	q: $author$project$Components$Produits$StructureCatalogue$Etages$Model$SansReecriture,
	p1: $elm$core$Maybe$Nothing,
	aL: $elm$core$Maybe$Nothing,
	p9: $elm$core$Maybe$Nothing,
	Hv: 0,
	hL: $author$project$Components$Shared$Drawer$Model$init('produits-etage-renommer'),
	bg: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$StructureCatalogue$Etages$Model$nomDuDrawerDeRenommage),
	c5: $author$project$Components$Shared$Drawer$Model$init('produits-etat-renommer'),
	c6: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$StructureCatalogue$Informations$Model$nomDuDrawerDeRenommage),
	qn: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$StructureCatalogue$Natures$Model$nomDuDrawerDeRenommage),
	qo: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$StructureCatalogue$Typologies$Model$nomDuDrawerDeRenommage),
	qM: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$StructureCatalogue$Typologies$Model$nomDuDrawerDeRetrait),
	D: $author$project$Components$Produits$StructureCatalogue$Saisie$vide,
	aM: $author$project$Components$Produits$StructureCatalogue$Saisie$vide,
	am: $author$project$Components$Produits$StructureCatalogue$Saisie$vide,
	qU: $author$project$Components$Produits$StructureCatalogue$Saisie$vide,
	h$: $elm$core$Maybe$Nothing,
	bk: false,
	_: $elm$core$Maybe$Nothing,
	J_: _List_Nil,
	r4: $elm$core$Maybe$Nothing,
	r5: $elm$core$Maybe$Nothing,
	r6: $elm$core$Maybe$Nothing,
	r7: _List_Nil,
	sc: _List_Nil,
	df: ''
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$SansProcessUid = {$: 0};
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$aucunCritere = {yd: _List_Nil, m7: $elm$core$Maybe$Nothing, Fd: $elm$core$Maybe$Nothing, GR: $elm$core$Maybe$Nothing, Jq: _List_Nil};
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$init = function (lien) {
	return {fw: $elm$core$Maybe$Nothing, jy: _List_Nil, aU: $author$project$Components$Referentiel$NouvelleFiche$Doublons$aucunCritere, xX: _List_Nil, d0: false, a0: false, nB: lien, bb: $elm$core$Maybe$Nothing, pZ: $elm$core$Maybe$Nothing, eV: $elm$core$Maybe$Nothing, hP: 0, b2: false, b4: _List_Nil};
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$Particulier = 0;
var $author$project$Components$Referentiel$NouvelleFiche$Model$Personne = 0;
var $author$project$Components$Referentiel$Common$RechercheDeFiche$vide = {ve: $elm$core$Maybe$Nothing, Gw: _List_Nil, hP: 0, h3: ''};
var $author$project$Components$Referentiel$NouvelleFiche$Model$sansRattachement = {AS: '', BR: _List_Nil, F4: $elm$core$Maybe$Nothing, hC: $author$project$Components$Referentiel$Common$RechercheDeFiche$vide};
var $author$project$Components$Referentiel$NouvelleFiche$Model$init = {fI: $elm$core$Maybe$Nothing, vh: '', wa: _List_Nil, dE: '', gB: $elm$core$Maybe$Nothing, m7: '', nn: '', g1: 0, Dj: '', D1: '', ho: 'FR', Gg: '', hy: 0, GR: '', pN: $author$project$Components$Referentiel$NouvelleFiche$Model$sansRattachement, qB: '', r0: $elm$core$Maybe$Nothing};
var $author$project$Components$Referentiel$NouvelleFiche$Model$initial = {
	iB: $elm$core$Maybe$Nothing,
	iQ: $elm$core$Maybe$Nothing,
	jE: A2(
		$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$depuis,
		{dw: _List_Nil, Ba: _List_Nil},
		_List_Nil),
	kd: $elm$core$Maybe$Nothing,
	dC: $elm$core$Maybe$Nothing,
	cx: $elm$core$Maybe$Nothing,
	xM: $author$project$Components$Referentiel$NouvelleFiche$Doublons$init($elm$core$Maybe$Nothing),
	l2: $author$project$Components$Referentiel$NouvelleFiche$Model$SansProcessUid,
	gm: false,
	gn: $elm$core$Maybe$Nothing,
	l5: $author$project$Components$Referentiel$Common$Equipe$Inconnue,
	zS: _List_Nil,
	gF: _List_Nil,
	bI: false,
	BE: $elm$core$Maybe$Nothing,
	gT: $elm$core$Maybe$Nothing,
	nL: $elm$core$Maybe$Nothing,
	nQ: $author$project$Components$Referentiel$Common$ChoixDeLien$etatInitial,
	gU: $elm$core$Maybe$Nothing,
	eb: _List_Nil,
	oI: $elm$core$Maybe$Nothing,
	hd: $author$project$Referentiel$Normes$vide,
	D3: $author$project$Components$Referentiel$Common$Offres$NonLue,
	F6: _List_Nil,
	hP: $author$project$Components$Referentiel$NouvelleFiche$Model$init,
	qV: {Ba: _List_Nil, sb: _List_Nil},
	hQ: $elm$core$Maybe$Nothing,
	hX: $elm$core$Maybe$Nothing,
	ib: _List_Nil,
	im: $author$project$Components$Shared$Drawer$Model$init('referentiel-partie-prenante-creer')
};
var $author$project$Components$Produits$StructureCatalogue$Update$TypologieAdressee = function (a) {
	return {$: 158, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Boites$categoriesChoisies = function (colonnes) {
	return A2(
		$elm$core$List$filterMap,
		function (colonne) {
			var _v0 = colonne.ve;
			if ((!_v0.$) && (_v0.a.$ === 2)) {
				var type_ = _v0.a.a;
				return $elm$core$Maybe$Just(type_);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		colonnes);
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$enfants = F2(
	function (places, parents) {
		return A2(
			$elm$core$List$filter,
			function (noeud) {
				return A2(
					$elm$core$List$any,
					function (parent) {
						return _Utils_eq(
							noeud.ey,
							$elm$core$Maybe$Just(parent.Aq));
					},
					parents);
			},
			places);
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$lignesDe = F2(
	function (nommer, noeuds) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (noeud, lignes) {
					if (A2(
						$elm$core$List$any,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.fm;
							},
							$elm$core$Basics$eq(noeud.fm)),
						lignes)) {
						return A2(
							$elm$core$List$map,
							function (ligne) {
								return _Utils_eq(ligne.fm, noeud.fm) ? _Utils_update(
									ligne,
									{
										Di: _Utils_ap(
											ligne.Di,
											_List_fromArray(
												[noeud]))
									}) : ligne;
							},
							lignes);
					} else {
						var _v0 = nommer(noeud.fm);
						if (!_v0.$) {
							var nom = _v0.a;
							return _Utils_ap(
								lignes,
								_List_fromArray(
									[
										{
										vW: $elm$core$Maybe$Nothing,
										Di: _List_fromArray(
											[noeud]),
										Dj: nom,
										fm: noeud.fm
									}
									]));
						} else {
							return lignes;
						}
					}
				}),
			_List_Nil,
			noeuds);
	});
var $author$project$I18n$Traductions$Cle = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$I18n$Traductions$texte = $author$project$I18n$Traductions$Cle;
var $author$project$I18n$Textes$produitsArchetypeGamme = A3($author$project$I18n$Traductions$texte, 'produits.archetype.gamme', _List_Nil, 'Gamme');
var $author$project$I18n$Textes$produitsArchetypeGammeAnglais = A3($author$project$I18n$Traductions$texte, 'produits.archetype.gamme.anglais', _List_Nil, 'Range');
var $author$project$I18n$Traductions$Entier = function (a) {
	return {$: 1, a: a};
};
var $author$project$I18n$Textes$produitsArchetypeGammeElements = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.archetype.gamme.elements',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nombre',
				$author$project$I18n$Traductions$Entier(p.w))
			]),
		'{nombre, plural, one {# gamme. Archivez-la d\'abord.} other {# gammes. Archivez-les d\'abord.}}');
};
var $author$project$I18n$Textes$produitsArchetypeGammeRole = A3($author$project$I18n$Traductions$texte, 'produits.archetype.gamme.role', _List_Nil, 'Un ensemble de produits d\'une même marque. Exemple : la gamme encastrable.');
var $author$project$I18n$Textes$produitsArchetypeMarque = A3($author$project$I18n$Traductions$texte, 'produits.archetype.marque', _List_Nil, 'Marque');
var $author$project$I18n$Textes$produitsArchetypeMarqueAnglais = A3($author$project$I18n$Traductions$texte, 'produits.archetype.marque.anglais', _List_Nil, 'Brand');
var $author$project$I18n$Textes$produitsArchetypeMarqueElements = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.archetype.marque.elements',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nombre',
				$author$project$I18n$Traductions$Entier(p.w))
			]),
		'{nombre, plural, one {# marque. Archivez-la d\'abord.} other {# marques. Archivez-les d\'abord.}}');
};
var $author$project$I18n$Textes$produitsArchetypeMarqueRole = A3($author$project$I18n$Traductions$texte, 'produits.archetype.marque.role', _List_Nil, 'De quelle marque est le produit');
var $author$project$I18n$Textes$produitsArchetypeProduit = A3($author$project$I18n$Traductions$texte, 'produits.archetype.produit', _List_Nil, 'Produit');
var $author$project$I18n$Textes$produitsArchetypeProduitAnglais = A3($author$project$I18n$Traductions$texte, 'produits.archetype.produit.anglais', _List_Nil, 'Product');
var $author$project$I18n$Textes$produitsArchetypeProduitElements = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.archetype.produit.elements',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nombre',
				$author$project$I18n$Traductions$Entier(p.w))
			]),
		'{nombre, plural, one {# produit. Archivez-le d\'abord.} other {# produits. Archivez-les d\'abord.}}');
};
var $author$project$I18n$Textes$produitsArchetypeProduitRole = A3($author$project$I18n$Traductions$texte, 'produits.archetype.produit.role', _List_Nil, 'Un modèle, qui regroupe ses références. Exemple : un four décliné en deux couleurs.');
var $author$project$I18n$Textes$produitsArchetypeReference = A3($author$project$I18n$Traductions$texte, 'produits.archetype.reference', _List_Nil, 'Référence');
var $author$project$I18n$Textes$produitsArchetypeReferenceAnglais = A3($author$project$I18n$Traductions$texte, 'produits.archetype.reference.anglais', _List_Nil, 'Reference');
var $author$project$I18n$Textes$produitsArchetypeReferenceElements = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.archetype.reference.elements',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nombre',
				$author$project$I18n$Traductions$Entier(p.w))
			]),
		'{nombre, plural, one {# référence. Archivez-la d\'abord.} other {# références. Archivez-les d\'abord.}}');
};
var $author$project$I18n$Textes$produitsArchetypeReferenceRole = A3($author$project$I18n$Traductions$texte, 'produits.archetype.reference.role', _List_Nil, 'Ce qui se vend, avec son code : le four noir de 60 cm');
var $author$project$I18n$Textes$produitsArchetypeTypeDeProduit = A3($author$project$I18n$Traductions$texte, 'produits.archetype.type-de-produit', _List_Nil, 'Catégorie');
var $author$project$I18n$Textes$produitsArchetypeTypeDeProduitAnglais = A3($author$project$I18n$Traductions$texte, 'produits.archetype.type-de-produit.anglais', _List_Nil, 'Category');
var $author$project$I18n$Textes$produitsArchetypeTypeDeProduitElements = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.archetype.type-de-produit.elements',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nombre',
				$author$project$I18n$Traductions$Entier(p.w))
			]),
		'{nombre, plural, one {# catégorie. Archivez-la d\'abord.} other {# catégories. Archivez-les d\'abord.}}');
};
var $author$project$I18n$Textes$produitsArchetypeTypeDeProduitRole = A3($author$project$I18n$Traductions$texte, 'produits.archetype.type-de-produit.role', _List_Nil, 'Le dernier étage : c\'est lui qui décide de ce qu\'on saisit');
var $author$project$Catalogue$Vocabulaire$archetypes = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'marque',
			{t: $author$project$I18n$Textes$produitsArchetypeMarqueAnglais, aV: $author$project$I18n$Textes$produitsArchetypeMarqueElements, Dj: $author$project$I18n$Textes$produitsArchetypeMarque, bi: $author$project$I18n$Textes$produitsArchetypeMarqueRole}),
			_Utils_Tuple2(
			'gamme',
			{t: $author$project$I18n$Textes$produitsArchetypeGammeAnglais, aV: $author$project$I18n$Textes$produitsArchetypeGammeElements, Dj: $author$project$I18n$Textes$produitsArchetypeGamme, bi: $author$project$I18n$Textes$produitsArchetypeGammeRole}),
			_Utils_Tuple2(
			'type-de-produit',
			{t: $author$project$I18n$Textes$produitsArchetypeTypeDeProduitAnglais, aV: $author$project$I18n$Textes$produitsArchetypeTypeDeProduitElements, Dj: $author$project$I18n$Textes$produitsArchetypeTypeDeProduit, bi: $author$project$I18n$Textes$produitsArchetypeTypeDeProduitRole}),
			_Utils_Tuple2(
			'produit',
			{t: $author$project$I18n$Textes$produitsArchetypeProduitAnglais, aV: $author$project$I18n$Textes$produitsArchetypeProduitElements, Dj: $author$project$I18n$Textes$produitsArchetypeProduit, bi: $author$project$I18n$Textes$produitsArchetypeProduitRole}),
			_Utils_Tuple2(
			'reference',
			{t: $author$project$I18n$Textes$produitsArchetypeReferenceAnglais, aV: $author$project$I18n$Textes$produitsArchetypeReferenceElements, Dj: $author$project$I18n$Textes$produitsArchetypeReference, bi: $author$project$I18n$Textes$produitsArchetypeReferenceRole})
		]));
var $author$project$Catalogue$Vocabulaire$archetype = function (code) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$I18n$Traductions$tel(code),
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.Dj;
			},
			A2($elm$core$Dict$get, code, $author$project$Catalogue$Vocabulaire$archetypes)));
};
var $author$project$Catalogue$Identifiants$niveauIdToString = function (_v0) {
	var valeur = _v0;
	return valeur;
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$archetypeDe = F3(
	function (code, niveau, etage) {
		return etage.wL ? $author$project$Catalogue$Identifiants$niveauIdToString(niveau) : code;
	});
var $author$project$Catalogue$Niveau$libelleDuNiveau = function (niveau) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Catalogue$Vocabulaire$archetype(niveau.fA),
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.zX;
				},
				$author$project$I18n$Traductions$tel),
			niveau.R));
};
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Model$libelleDuNiveau = $author$project$Catalogue$Niveau$libelleDuNiveau;
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$nom = F2(
	function (niveaux, etage) {
		var _v0 = etage.xt;
		if (_v0.$ === 1) {
			var libelles = _v0.a;
			return $author$project$I18n$Traductions$tel(libelles.zX);
		} else {
			var code = _v0.a;
			var niveau = _v0.b;
			return A2(
				$elm$core$Maybe$withDefault,
				$author$project$Catalogue$Vocabulaire$archetype(
					A3($author$project$Components$Produits$StructureCatalogue$Etages$Model$archetypeDe, code, niveau, etage)),
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$libelleDuNiveau,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(niveau)),
							niveaux))));
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nomDeLaValeur = function (valeur) {
	return valeur.R.zX;
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$nomDuNoeud = F2(
	function (typologie, valeur) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.R;
					},
					$elm$core$Maybe$map(
						function ($) {
							return $.zX;
						})),
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.fm;
						},
						$elm$core$Basics$eq(valeur)),
					typologie.Di)));
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$valeurDe = F2(
	function (id, classification) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Aq;
					},
					$elm$core$Basics$eq(id)),
				classification.Ki));
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$nomDe = F3(
	function (noms, typologie, valeur) {
		switch (valeur.$) {
			case 0:
				var id = valeur.a;
				return A2(
					$elm$core$Maybe$andThen,
					function (lue) {
						return lue.tI ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							$author$project$Components$Produits$StructureCatalogue$Classifications$Model$nomDeLaValeur(lue));
					},
					A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$valeurDe, id, typologie));
			case 1:
				var id = valeur.a;
				var _v1 = A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$nomDuNoeud, typologie, valeur);
				if (!_v1.$) {
					var nom = _v1.a;
					return $elm$core$Maybe$Just(nom);
				} else {
					return A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.R;
							},
							function ($) {
								return $.zX;
							}),
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.Aq;
									},
									$elm$core$Basics$eq(id)),
								noms.cU)));
				}
			case 2:
				var id = valeur.a;
				return A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Dj;
						},
						function ($) {
							return $.zX;
						}),
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (categorie) {
								return _Utils_eq(categorie.Aq, id) && (!categorie.tE);
							},
							noms.dt)));
			default:
				return A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$nomDuNoeud, typologie, valeur);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$colonnes = F2(
	function (lu, typologie) {
		var suivants = _Utils_ap(
			A2(
				$elm$core$List$drop,
				1,
				A2($elm$core$List$map, $elm$core$Maybe$Just, typologie.yG)),
			_List_fromArray(
				[$elm$core$Maybe$Nothing]));
		var places = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Basics$not,
				function ($) {
					return $.iz;
				}),
			typologie.Di);
		var surLEtage = function (etage) {
			return A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.md;
					},
					$elm$core$Basics$eq(etage.Aq)),
				places);
		};
		var etape = F2(
			function (_v1, _v3) {
				var rang = _v1.a;
				var _v2 = _v1.b;
				var etage = _v2.a;
				var suivant = _v2.b;
				var faites = _v3.a;
				var avant = _v3.b;
				var voulue = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Basics$identity,
					$elm$core$List$head(
						A2($elm$core$List$drop, rang, lu.jN)));
				var nom = A2($author$project$Components$Produits$StructureCatalogue$Etages$Model$nom, lu.C9, etage);
				var candidats = function () {
					if (!avant.$) {
						var ligne = avant.a;
						return A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.md;
								},
								$elm$core$Basics$eq(etage.Aq)),
							A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$enfants, places, ligne.Di));
					} else {
						return surLEtage(etage);
					}
				}();
				var lignes = A2(
					$elm$core$List$map,
					function (ligne) {
						return _Utils_update(
							ligne,
							{
								vW: A2(
									$elm$core$Maybe$map,
									function (apres) {
										return function (nombre) {
											return {
												md: A2($author$project$Components$Produits$StructureCatalogue$Etages$Model$nom, lu.C9, apres),
												w: nombre
											};
										}(
											$elm$core$List$length(
												A2(
													$author$project$Components$Produits$StructureCatalogue$Valeurs$Model$lignesDe,
													A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$nomDe, lu.DG, typologie),
													A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$enfants, places, ligne.Di))));
									},
									suivant)
							});
					},
					A2(
						$author$project$Components$Produits$StructureCatalogue$Valeurs$Model$lignesDe,
						A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$nomDe, lu.DG, typologie),
						candidats));
				var choisie = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (ligne) {
							return _Utils_eq(
								$elm$core$Maybe$Just(ligne.fm),
								voulue);
						},
						lignes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						{
							ve: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.fm;
								},
								choisie),
							md: etage,
							gV: lignes,
							Dj: nom,
							bY: rang,
							IV: avant,
							h6: {
								md: nom,
								IV: A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.Dj;
									},
									avant)
							}
						},
						faites),
					choisie);
			});
		return $elm$core$List$reverse(
			A3(
				$elm$core$List$foldl,
				etape,
				_Utils_Tuple2(_List_Nil, $elm$core$Maybe$Nothing),
				A2(
					$elm$core$List$indexedMap,
					$elm$core$Tuple$pair,
					A3($elm$core$List$map2, $elm$core$Tuple$pair, typologie.yG, suivants))).a);
	});
var $author$project$Catalogue$Vocabulaire$etatArchive = 'archivee';
var $author$project$Components$Produits$Common$Elements$archive = function (element) {
	return _Utils_eq(element.gt, $author$project$Catalogue$Vocabulaire$etatArchive);
};
var $author$project$Catalogue$Vocabulaire$codeMarque = 'marque';
var $author$project$Components$Produits$StructureCatalogue$Marques$Model$marques = function (model) {
	var _v0 = model.aS;
	if (!_v0.$) {
		var annuaire = _v0.a;
		return _Utils_eq(
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.fA;
				},
				annuaire.os),
			$elm$core$Maybe$Just($author$project$Catalogue$Vocabulaire$codeMarque)) ? A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Components$Produits$Common$Elements$archive),
			annuaire.aV) : _List_Nil;
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Lecture$noms = function (model) {
	return {
		dt: A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ib;
				},
				model.dt.aS)),
		cU: $author$project$Components$Produits$StructureCatalogue$Marques$Model$marques(model.cU)
	};
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Lecture$colonnes = F2(
	function (model, structure) {
		return $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$colonnes(
			{
				jN: model.jN,
				C9: structure.C9,
				DG: $author$project$Components$Produits$StructureCatalogue$Valeurs$Lecture$noms(model)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Effet$LireLesCategories = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Commandes$parLots = F2(
	function (taille, liste) {
		return $elm$core$List$isEmpty(liste) ? _List_Nil : A2(
			$elm$core$List$cons,
			A2($elm$core$List$take, taille, liste),
			A2(
				$author$project$Components$Produits$StructureCatalogue$Commandes$parLots,
				taille,
				A2($elm$core$List$drop, taille, liste)));
	});
var $author$project$API$Liens$variable = function (nom) {
	return '{' + (nom + '}');
};
var $author$project$API$Liens$resoudre = F2(
	function (valeurs, _v0) {
		var lien = _v0;
		var remplacer = F2(
			function (_v1, href) {
				var nom = _v1.a;
				var valeur = _v1.b;
				return A2(
					$elm$core$Maybe$andThen,
					function (adresse) {
						return A2(
							$elm$core$String$contains,
							$author$project$API$Liens$variable(nom),
							adresse) ? $elm$core$Maybe$Just(
							A3(
								$elm$core$String$replace,
								$author$project$API$Liens$variable(nom),
								$elm$url$Url$percentEncode(valeur),
								adresse)) : $elm$core$Maybe$Nothing;
					},
					href);
			});
		return A2(
			$elm$core$Maybe$andThen,
			function (href) {
				return (A2($elm$core$String$contains, '{', href) || A2($elm$core$String$contains, '}', href)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					_Utils_update(
						lien,
						{cM: href}));
			},
			A3(
				$elm$core$List$foldl,
				remplacer,
				$elm$core$Maybe$Just(lien.cM),
				valeurs));
	});
var $author$project$Catalogue$Identifiants$typeDeProduitIdToString = function (_v0) {
	var valeur = _v0;
	return valeur;
};
var $author$project$Components$Produits$StructureCatalogue$Commandes$typesAuPlusParLecture = 100;
var $author$project$Components$Produits$StructureCatalogue$Commandes$lesCategories = F2(
	function (gabarit, types) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (lien) {
					return A2(
						$elm$core$List$map,
						$author$project$Components$Produits$StructureCatalogue$Effet$LireLesCategories,
						A2(
							$elm$core$List$filterMap,
							function (lot) {
								return A2(
									$author$project$API$Liens$resoudre,
									_List_fromArray(
										[
											_Utils_Tuple2(
											'types',
											A2($elm$core$String$join, ',', lot))
										]),
									lien);
							},
							A2(
								$author$project$Components$Produits$StructureCatalogue$Commandes$parLots,
								$author$project$Components$Produits$StructureCatalogue$Commandes$typesAuPlusParLecture,
								A2($elm$core$List$map, $author$project$Catalogue$Identifiants$typeDeProduitIdToString, types))));
				},
				gabarit));
	});
var $author$project$Components$Produits$StructureCatalogue$Typologies$Model$de = $elm$core$List$filter(
	function ($) {
		return $.wE;
	});
var $author$project$Components$Produits$StructureCatalogue$Typologies$Model$reglee = F2(
	function (choisie, classifications) {
		var typologies = $author$project$Components$Produits$StructureCatalogue$Typologies$Model$de(classifications);
		var servie = function (id) {
			return $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Aq;
						},
						$elm$core$Basics$eq(id)),
					typologies));
		};
		var _v0 = A2($elm$core$Maybe$andThen, servie, choisie);
		if (!_v0.$) {
			var trouvee = _v0.a;
			return $elm$core$Maybe$Just(trouvee);
		} else {
			return $elm$core$List$head(typologies);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Update$lireLesCategoriesChoisies = function (_v0) {
	var model = _v0.a;
	var effets = _v0.b;
	var _v1 = _Utils_Tuple3(model.h$, model.AM, model.dt.aS);
	if (((!_v1.a.$) && (!_v1.b.$)) && (!_v1.c.$)) {
		var structure = _v1.a.a;
		var informations = _v1.b.a;
		var annuaire = _v1.c.a;
		var choisies = A2(
			$elm$core$List$filter,
			function (type_) {
				return !A2($elm$core$List$member, type_, model.jC);
			},
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Lecture$colonnes, model, structure),
						$author$project$Components$Produits$StructureCatalogue$Informations$Boites$categoriesChoisies),
					A2($author$project$Components$Produits$StructureCatalogue$Typologies$Model$reglee, model.r6, structure.vk))));
		var connues = A2(
			$elm$core$List$filter,
			function (type_) {
				return A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Aq;
						},
						$elm$core$Basics$eq(type_)),
					annuaire.ib);
			},
			choisies);
		var effetsDesCategories = A2($author$project$Components$Produits$StructureCatalogue$Commandes$lesCategories, informations.BC, connues);
		return $elm$core$List$isEmpty(choisies) ? _Utils_Tuple2(model, effets) : _Utils_Tuple2(
			_Utils_update(
				model,
				{
					jC: _Utils_ap(model.jC, choisies)
				}),
			_Utils_ap(effets, effetsDesCategories));
	} else {
		return _Utils_Tuple2(model, effets);
	}
};
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ApercuPerime = {$: 56};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ArchiverUneTypologie = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ArchiverUneValeur = F2(
	function (a, b) {
		return {$: 23, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Archivage$Model$DesReferences = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Archivage$Model$DuFiltre = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$EtapeQuittee = {$: 9};
var $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Model$Pret = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$TraiterLArchivage = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Effet$TypologieChoisie = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Shared$Ordre$VersLeBas = 1;
var $author$project$Components$Shared$Ordre$VersLeHaut = 0;
var $author$project$Components$Produits$StructureCatalogue$Effet$AttendreAvantDeRelire = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Effet$DemanderProcessUid = {$: 0};
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$deClassification = function (commande) {
	switch (commande.$) {
		case 11:
			return true;
		case 20:
			return true;
		case 31:
			return true;
		case 27:
			return true;
		case 21:
			return true;
		case 22:
			return true;
		case 23:
			return true;
		case 24:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$resteOuvertePourOrdonner = F2(
	function (commande, model) {
		var _v0 = _Utils_Tuple2(commande, model.vk.mW);
		if ((_v0.a.$ === 21) && (_v0.b.$ === 7)) {
			var _v1 = _v0.a;
			return true;
		} else {
			return false;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$surLaClassification = F2(
	function (id, modifier) {
		return $elm$core$List$map(
			function (classification) {
				return _Utils_eq(classification.Aq, id) ? modifier(classification) : classification;
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Model$surLaClassification = F3(
	function (id, modifier, structure) {
		return _Utils_update(
			structure,
			{
				vk: A3($author$project$Components$Produits$StructureCatalogue$Classifications$Model$surLaClassification, id, modifier, structure.vk)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$surLaSection = F2(
	function (modifier, model) {
		return _Utils_update(
			model,
			{
				vk: modifier(model.vk)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$sansOrdreEnCours = function (model) {
	var _v0 = model.vk.pt;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var id = _v1.a;
		var precedentes = _v1.b;
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Classifications$Update$surLaSection,
			function (section) {
				return _Utils_update(
					section,
					{
						iP: $author$project$I18n$Traductions$tel(''),
						pt: $elm$core$Maybe$Nothing
					});
			},
			_Utils_update(
				model,
				{
					h$: A2(
						$elm$core$Maybe$map,
						A2(
							$author$project$Components$Produits$StructureCatalogue$Model$surLaClassification,
							id,
							function (affichee) {
								return _Utils_update(
									affichee,
									{Ki: precedentes});
							}),
						model.h$)
				}));
	} else {
		return model;
	}
};
var $author$project$Components$Shared$Drawer$Model$AbandonDemande = 2;
var $author$project$Components$Shared$Drawer$Model$Ouvert = 1;
var $author$project$Components$Shared$Drawer$Update$PlacerFocus = $elm$core$Basics$identity;
var $author$project$Components$Shared$Drawer$Update$fermer = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{wQ: $elm$core$Maybe$Nothing, gt: 0}),
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$core$List$singleton),
				model.wQ)));
};
var $author$project$Components$Shared$Drawer$Model$idConfirmation = function (model) {
	return $author$project$Components$Shared$Drawer$Model$idRacine(model) + '-confirmation';
};
var $author$project$Components$Shared$Drawer$Model$idRester = function (model) {
	return $author$project$Components$Shared$Drawer$Model$idConfirmation(model) + '-rester';
};
var $author$project$Components$Shared$Drawer$Update$update = F3(
	function (_v0, msg, model) {
		var saisieEnCours = _v0.Il;
		switch (msg.$) {
			case 0:
				var declencheur = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							wQ: $elm$core$Maybe$Just(declencheur),
							gt: 1
						}),
					_List_fromArray(
						[
							$author$project$Components$Shared$Drawer$Model$idTitre(model)
						]));
			case 1:
				return $author$project$Components$Shared$Drawer$Update$fermer(model);
			case 2:
				return saisieEnCours ? _Utils_Tuple2(
					_Utils_update(
						model,
						{gt: 2}),
					_List_fromArray(
						[
							$author$project$Components$Shared$Drawer$Model$idRester(model)
						])) : $author$project$Components$Shared$Drawer$Update$fermer(model);
			case 3:
				return $author$project$Components$Shared$Drawer$Update$fermer(model);
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gt: 1}),
					_List_fromArray(
						[
							$author$project$Components$Shared$Drawer$Model$idTitre(model)
						]));
			default:
				var cible = msg.a;
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[cible]));
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$aboutie = F4(
	function (commande, repondue, evenements, model) {
		return (!repondue) ? $author$project$Components$Produits$StructureCatalogue$Classifications$Update$sansOrdreEnCours(model) : ((!$author$project$Components$Produits$StructureCatalogue$Classifications$Update$deClassification(commande)) ? model : (A2($author$project$Components$Produits$StructureCatalogue$Classifications$Update$resteOuvertePourOrdonner, commande, model) ? A2(
			$author$project$Components$Produits$StructureCatalogue$Classifications$Update$surLaSection,
			function (ouverte) {
				return _Utils_update(
					ouverte,
					{pt: $elm$core$Maybe$Nothing});
			},
			model) : A2(
			$author$project$Components$Produits$StructureCatalogue$Classifications$Update$surLaSection,
			function (section) {
				return _Utils_update(
					section,
					{
						kX: A3(
							$author$project$Components$Shared$Drawer$Update$update,
							{Il: false},
							$author$project$Components$Shared$Drawer$Update$Fermer,
							section.kX).a,
						mW: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$Aucun,
						Et: A2(
							$elm$core$Maybe$withDefault,
							section.Et,
							A2(
								$elm$core$Maybe$map,
								$elm$core$Maybe$Just,
								$elm$core$List$head(
									A2(
										$elm$core$List$filterMap,
										function (evenement) {
											if (evenement.$ === 12) {
												var id = evenement.a;
												return $elm$core$Maybe$Just(id);
											} else {
												return $elm$core$Maybe$Nothing;
											}
										},
										evenements)))),
						pt: $elm$core$Maybe$Nothing
					});
			},
			model)));
	});
var $author$project$Catalogue$API$QueryAPIModel$DuNiveau = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Catalogue$API$QueryAPIModel$Libre = function (a) {
	return {$: 1, a: a};
};
var $elm$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _v0) {
				var trues = _v0.a;
				var falses = _v0.b;
				return pred(x) ? _Utils_Tuple2(
					A2($elm$core$List$cons, x, trues),
					falses) : _Utils_Tuple2(
					trues,
					A2($elm$core$List$cons, x, falses));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			list);
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$renumerotes = $elm$core$List$indexedMap(
	F2(
		function (rang, etage) {
			return _Utils_update(
				etage,
				{bY: rang});
		}));
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$ajoute = F3(
	function (codeDe, fait, typologie) {
		var nouveau = {
			wL: false,
			xt: function () {
				var _v1 = fait.xt;
				if (!_v1.$) {
					var niveau = _v1.a;
					return A2(
						$author$project$Catalogue$API$QueryAPIModel$DuNiveau,
						codeDe(niveau),
						niveau);
				} else {
					var libelles = _v1.a;
					return $author$project$Catalogue$API$QueryAPIModel$Libre(libelles);
				}
			}(),
			m$: function () {
				var _v2 = fait.xt;
				if (!_v2.$) {
					return $elm$core$Maybe$Nothing;
				} else {
					var formes = _v2.b;
					return formes;
				}
			}(),
			Aq: fait.md,
			nQ: _List_Nil,
			bY: fait.bY
		};
		var ecrits = typologie.yI ? A2(
			$elm$core$List$filter,
			function ($) {
				return $.wL;
			},
			typologie.yG) : typologie.yG;
		var _v0 = A2(
			$elm$core$List$partition,
			function ($) {
				return $.wL;
			},
			ecrits);
		var categorie = _v0.a;
		var autres = _v0.b;
		return A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Aq;
				},
				$elm$core$Basics$eq(fait.md)),
			ecrits) ? _Utils_update(
			typologie,
			{yG: ecrits, yI: false}) : _Utils_update(
			typologie,
			{
				yG: $author$project$Components$Produits$StructureCatalogue$Etages$Model$renumerotes(
					_Utils_ap(
						A2($elm$core$List$take, fait.bY, autres),
						A2(
							$elm$core$List$cons,
							nouveau,
							_Utils_ap(
								A2($elm$core$List$drop, fait.bY, autres),
								categorie)))),
				yI: false
			});
	});
var $author$project$Components$Shared$LibellesParLangue$Model$ecrire = F3(
	function (code, texte, saisie) {
		return $elm$core$String$isEmpty(texte) ? A2($elm$core$Dict$remove, code, saisie) : A3($elm$core$Dict$insert, code, texte, saisie);
	});
var $author$project$Components$Shared$LibellesParLangue$Model$depuis = A2(
	$elm$core$List$foldl,
	function (_v0) {
		var code = _v0.a;
		var texte = _v0.b;
		return A2($author$project$Components$Shared$LibellesParLangue$Model$ecrire, code, texte);
	},
	$author$project$Components$Shared$LibellesParLangue$Model$vide);
var $author$project$Components$Produits$Common$LibellesSaisis$enSaisie = function (affiches) {
	return $author$project$Components$Shared$LibellesParLangue$Model$depuis(
		_List_fromArray(
			[
				_Utils_Tuple2('fr', affiches.zX),
				_Utils_Tuple2('en', affiches.yg)
			]));
};
var $author$project$Components$Produits$StructureCatalogue$Saisie$affichee = function (libelles) {
	return _Utils_update(
		$author$project$Components$Produits$StructureCatalogue$Saisie$vide,
		{
			R: $author$project$Components$Produits$Common$LibellesSaisis$enSaisie(libelles)
		});
};
var $author$project$Catalogue$Vocabulaire$archetypeEnAnglais = function (code) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$I18n$Traductions$tel(code),
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.t;
			},
			A2($elm$core$Dict$get, code, $author$project$Catalogue$Vocabulaire$archetypes)));
};
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Model$libelleAnglaisDuNiveau = function (niveau) {
	var _v0 = niveau.R;
	if (!_v0.$) {
		var libelles = _v0.a;
		return $author$project$I18n$Traductions$tel(
			A2($elm$core$Maybe$withDefault, '', libelles.yg));
	} else {
		return $author$project$Catalogue$Vocabulaire$archetypeEnAnglais(niveau.fA);
	}
};
var $author$project$I18n$Traductions$Choix = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$I18n$Traductions$Diese = {$: 6};
var $author$project$I18n$Traductions$EnMinusculeInitiale = function (a) {
	return {$: 3, a: a};
};
var $author$project$I18n$Traductions$EnMinuscules = function (a) {
	return {$: 2, a: a};
};
var $author$project$I18n$Traductions$Litteral = function (a) {
	return {$: 0, a: a};
};
var $author$project$I18n$Traductions$Parametre = function (a) {
	return {$: 1, a: a};
};
var $author$project$I18n$Traductions$Pluriel = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$I18n$Traductions$jusqua = F2(
	function (arret, caracteres) {
		if (caracteres.b) {
			var c = caracteres.a;
			var reste = caracteres.b;
			return arret(c) ? _Utils_Tuple2(_List_Nil, caracteres) : A2(
				$elm$core$Tuple$mapFirst,
				$elm$core$List$cons(c),
				A2($author$project$I18n$Traductions$jusqua, arret, reste));
		} else {
			return _Utils_Tuple2(_List_Nil, _List_Nil);
		}
	});
var $elm$core$String$fromList = _String_fromList;
var $author$project$I18n$Traductions$mot = A2($elm$core$Basics$composeR, $elm$core$String$fromList, $elm$core$String$trim);
var $author$project$I18n$Traductions$accolade = F2(
	function (dansUnPluriel, caracteres) {
		var _v10 = A2(
			$author$project$I18n$Traductions$jusqua,
			function (c) {
				return (c === '}') || (c === ',');
			},
			caracteres);
		_v10$2:
		while (true) {
			if (_v10.b.b) {
				switch (_v10.b.a) {
					case '}':
						var nom = _v10.a;
						var _v11 = _v10.b;
						var apres = _v11.b;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(
								$author$project$I18n$Traductions$Parametre(
									$author$project$I18n$Traductions$mot(nom)),
								apres));
					case ',':
						var nom = _v10.a;
						var _v12 = _v10.b;
						var apres = _v12.b;
						var _v13 = A2(
							$author$project$I18n$Traductions$jusqua,
							function (c) {
								return (c === ',') || (c === '}');
							},
							apres);
						_v13$2:
						while (true) {
							if (_v13.b.b) {
								switch (_v13.b.a) {
									case '}':
										var sorte = _v13.a;
										var _v14 = _v13.b;
										var suite = _v14.b;
										var _v15 = $author$project$I18n$Traductions$mot(sorte);
										switch (_v15) {
											case 'lower':
												return $elm$core$Maybe$Just(
													_Utils_Tuple2(
														$author$project$I18n$Traductions$EnMinuscules(
															$author$project$I18n$Traductions$mot(nom)),
														suite));
											case 'lowerFirst':
												return $elm$core$Maybe$Just(
													_Utils_Tuple2(
														$author$project$I18n$Traductions$EnMinusculeInitiale(
															$author$project$I18n$Traductions$mot(nom)),
														suite));
											default:
												return $elm$core$Maybe$Nothing;
										}
									case ',':
										var sorte = _v13.a;
										var _v16 = _v13.b;
										var formes = _v16.b;
										var _v17 = $author$project$I18n$Traductions$mot(sorte);
										switch (_v17) {
											case 'plural':
												return A3(
													$author$project$I18n$Traductions$pluriel,
													$author$project$I18n$Traductions$mot(nom),
													formes,
													$elm$core$Dict$empty);
											case 'select':
												return A2(
													$elm$core$Maybe$map,
													function (_v18) {
														var lues = _v18.a;
														var suite = _v18.b;
														return _Utils_Tuple2(
															A2(
																$author$project$I18n$Traductions$Choix,
																$author$project$I18n$Traductions$mot(nom),
																lues),
															suite);
													},
													A3($author$project$I18n$Traductions$formesDUnChoix, dansUnPluriel, formes, $elm$core$Dict$empty));
											default:
												return $elm$core$Maybe$Nothing;
										}
									default:
										break _v13$2;
								}
							} else {
								break _v13$2;
							}
						}
						return $elm$core$Maybe$Nothing;
					default:
						break _v10$2;
				}
			} else {
				break _v10$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$I18n$Traductions$formesDUnChoix = F3(
	function (dansUnPluriel, caracteres, lues) {
		formesDUnChoix:
		while (true) {
			var _v3 = A2(
				$author$project$I18n$Traductions$jusqua,
				function (c) {
					return (c !== ' ') && (c !== '\n');
				},
				caracteres);
			if (_v3.b.b && ('}' === _v3.b.a)) {
				var _v4 = _v3.b;
				var apres = _v4.b;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(lues, apres));
			} else {
				var reste = _v3.b;
				var _v5 = A2(
					$author$project$I18n$Traductions$jusqua,
					$elm$core$Basics$eq('{'),
					reste);
				if (_v5.b.b && ('{' === _v5.b.a)) {
					var forme = _v5.a;
					var _v6 = _v5.b;
					var corps = _v6.b;
					var _v7 = A4($author$project$I18n$Traductions$segments, dansUnPluriel, corps, '', _List_Nil);
					if (((!_v7.$) && _v7.a.b.b) && ('}' === _v7.a.b.a)) {
						var _v8 = _v7.a;
						var lus = _v8.a;
						var _v9 = _v8.b;
						var suite = _v9.b;
						var $temp$dansUnPluriel = dansUnPluriel,
							$temp$caracteres = suite,
							$temp$lues = A3(
							$elm$core$Dict$insert,
							$author$project$I18n$Traductions$mot(forme),
							lus,
							lues);
						dansUnPluriel = $temp$dansUnPluriel;
						caracteres = $temp$caracteres;
						lues = $temp$lues;
						continue formesDUnChoix;
					} else {
						return $elm$core$Maybe$Nothing;
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $author$project$I18n$Traductions$pluriel = F3(
	function (nom, caracteres, lues) {
		return A2(
			$elm$core$Maybe$andThen,
			function (_v2) {
				var formes = _v2.a;
				var apres = _v2.b;
				return A3(
					$elm$core$Maybe$map2,
					F2(
						function (un, autre) {
							return _Utils_Tuple2(
								A3($author$project$I18n$Traductions$Pluriel, nom, un, autre),
								apres);
						}),
					A2($elm$core$Dict$get, 'one', formes),
					A2($elm$core$Dict$get, 'other', formes));
			},
			A3($author$project$I18n$Traductions$formesDUnChoix, true, caracteres, lues));
	});
var $author$project$I18n$Traductions$segments = F4(
	function (dansUnPluriel, caracteres, lu, lus) {
		segments:
		while (true) {
			var poses = (lu === '') ? lus : A2(
				$elm$core$List$cons,
				$author$project$I18n$Traductions$Litteral(lu),
				lus);
			if (!caracteres.b) {
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(
						$elm$core$List$reverse(poses),
						_List_Nil));
			} else {
				switch (caracteres.a) {
					case '}':
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(
								$elm$core$List$reverse(poses),
								caracteres));
					case '#':
						var reste = caracteres.b;
						if (dansUnPluriel) {
							var $temp$dansUnPluriel = dansUnPluriel,
								$temp$caracteres = reste,
								$temp$lu = '',
								$temp$lus = A2($elm$core$List$cons, $author$project$I18n$Traductions$Diese, poses);
							dansUnPluriel = $temp$dansUnPluriel;
							caracteres = $temp$caracteres;
							lu = $temp$lu;
							lus = $temp$lus;
							continue segments;
						} else {
							var $temp$dansUnPluriel = dansUnPluriel,
								$temp$caracteres = reste,
								$temp$lu = lu + '#',
								$temp$lus = lus;
							dansUnPluriel = $temp$dansUnPluriel;
							caracteres = $temp$caracteres;
							lu = $temp$lu;
							lus = $temp$lus;
							continue segments;
						}
					case '{':
						var reste = caracteres.b;
						return A2(
							$elm$core$Maybe$andThen,
							function (_v1) {
								var segment = _v1.a;
								var apres = _v1.b;
								return A4(
									$author$project$I18n$Traductions$segments,
									dansUnPluriel,
									apres,
									'',
									A2($elm$core$List$cons, segment, poses));
							},
							A2($author$project$I18n$Traductions$accolade, dansUnPluriel, reste));
					default:
						var caractere = caracteres.a;
						var reste = caracteres.b;
						var $temp$dansUnPluriel = dansUnPluriel,
							$temp$caracteres = reste,
							$temp$lu = _Utils_ap(
							lu,
							$elm$core$String$fromChar(caractere)),
							$temp$lus = lus;
						dansUnPluriel = $temp$dansUnPluriel;
						caracteres = $temp$caracteres;
						lu = $temp$lu;
						lus = $temp$lus;
						continue segments;
				}
			}
		}
	});
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $author$project$I18n$Traductions$rendre = F2(
	function (traductions, garde) {
		if (garde.$ === 1) {
			var lu = garde.a;
			return lu;
		} else {
			var cle = garde.a;
			var valeurs = garde.b;
			var gabarit = garde.c;
			var rendues = A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapSecond(
					$author$project$I18n$Traductions$rendreValeur(traductions)),
				valeurs);
			var _v2 = A3($author$project$I18n$Traductions$traduire, cle, rendues, traductions);
			if (!_v2.$) {
				var traduit = _v2.a;
				return traduit;
			} else {
				var _v3 = A4(
					$author$project$I18n$Traductions$segments,
					false,
					$elm$core$String$toList(gabarit),
					'',
					_List_Nil);
				if ((!_v3.$) && (!_v3.a.b.b)) {
					var _v4 = _v3.a;
					var lus = _v4.a;
					return A2(
						$elm$core$Maybe$withDefault,
						gabarit,
						A4(
							$author$project$I18n$Traductions$assembler,
							0,
							$elm$core$Dict$fromList(rendues),
							$elm$core$Maybe$Nothing,
							lus));
				} else {
					return gabarit;
				}
			}
		}
	});
var $author$project$I18n$Traductions$rendreValeur = F2(
	function (traductions, valeur) {
		switch (valeur.$) {
			case 3:
				var garde = valeur.a;
				return $author$project$I18n$Traductions$Chaine(
					A2($author$project$I18n$Traductions$rendre, traductions, garde));
			case 4:
				var garde = valeur.a;
				return $author$project$I18n$Traductions$Chaine(
					$elm$core$String$trim(
						A2($author$project$I18n$Traductions$rendre, traductions, garde)));
			default:
				return valeur;
		}
	});
var $author$project$I18n$Traductions$francaisDe = $author$project$I18n$Traductions$rendre($author$project$I18n$Traductions$francais);
var $author$project$Components$Produits$StructureCatalogue$Saisie$parDefaut = $author$project$I18n$Traductions$francaisDe;
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Model$saisieDuNiveau = function (niveau) {
	return $author$project$Components$Produits$StructureCatalogue$Saisie$affichee(
		{
			yg: $author$project$Components$Produits$StructureCatalogue$Saisie$parDefaut(
				$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$libelleAnglaisDuNiveau(niveau)),
			zX: $author$project$Components$Produits$StructureCatalogue$Saisie$parDefaut(
				$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$libelleDuNiveau(niveau))
		});
};
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Model$ajoute = function (evenement) {
	var sansSaisie = {
		fA: evenement.fA,
		aV: 0,
		m$: $elm$core$Maybe$Nothing,
		Aq: evenement.os,
		R: $elm$core$Maybe$Just(evenement.R),
		nQ: _List_Nil,
		o6: false,
		hP: $author$project$Components$Produits$StructureCatalogue$Saisie$vide,
		JH: false,
		Kg: true
	};
	return _Utils_update(
		sansSaisie,
		{
			hP: $author$project$Components$Produits$StructureCatalogue$Niveaux$Model$saisieDuNiveau(sansSaisie)
		});
};
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$ajoutee = F3(
	function (deRangement, id, libelles) {
		return {tB: false, tD: $elm$core$Maybe$Nothing, wE: deRangement, gi: false, yG: _List_Nil, yI: deRangement, yX: _List_Nil, m$: $elm$core$Maybe$Nothing, Aq: id, R: libelles, nQ: _List_Nil, Di: _List_Nil, hD: $elm$core$Maybe$Nothing, Ki: _List_Nil};
	});
var $elm$core$Basics$ge = _Utils_ge;
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$appliquerLaPlace = F2(
	function (place, valeurs) {
		var _v0 = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Aq;
					},
					$elm$core$Basics$eq(place.fm)),
				valeurs));
		if (_v0.$ === 1) {
			return valeurs;
		} else {
			var deplacee = _v0.a;
			return A2(
				$elm$core$List$map,
				function (valeur) {
					if (_Utils_eq(valeur.Aq, place.fm)) {
						return _Utils_update(
							valeur,
							{ey: place.ey, bY: place.bY});
					} else {
						var avancee = (_Utils_eq(valeur.ey, deplacee.ey) && (_Utils_cmp(valeur.bY, deplacee.bY) > 0)) ? _Utils_update(
							valeur,
							{bY: valeur.bY - 1}) : valeur;
						return (_Utils_eq(avancee.ey, place.ey) && (_Utils_cmp(avancee.bY, place.bY) > -1)) ? _Utils_update(
							avancee,
							{bY: avancee.bY + 1}) : avancee;
					}
				},
				valeurs);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Model$avecFormes = F2(
	function (formes, niveau) {
		return _Utils_update(
			niveau,
			{
				m$: _Utils_eq(formes, $elm$core$Maybe$Nothing) ? niveau.m$ : formes
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$classificationDe = function (id) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$filter(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Aq;
				},
				$elm$core$Basics$eq(id))),
		$elm$core$List$head);
};
var $author$project$Components$Produits$StructureCatalogue$Model$avecLaClassification = F2(
	function (ajoutee, structure) {
		return (!_Utils_eq(
			A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$classificationDe, ajoutee.Aq, structure.vk),
			$elm$core$Maybe$Nothing)) ? structure : _Utils_update(
			structure,
			{
				vk: _Utils_ap(
					structure.vk,
					_List_fromArray(
						[ajoutee]))
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Saisie$Inchange = {$: 0};
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Model$modifie = function (niveau) {
	return !_Utils_eq(
		niveau.hP.R,
		$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$saisieDuNiveau(niveau).R);
};
var $author$project$Components$Produits$StructureCatalogue$Saisie$ARenommer = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Saisie$FrancaisVide = {$: 1};
var $author$project$Components$Shared$LibellesParLangue$Model$lire = F2(
	function (code, saisie) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Dict$get, code, saisie));
	});
var $author$project$Components$Produits$Common$LibellesSaisis$nonVide = function (texte) {
	return $elm$core$String$isEmpty(
		$elm$core$String$trim(texte)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		$elm$core$String$trim(texte));
};
var $author$project$Components$Produits$Common$LibellesSaisis$versLApi = function (saisie) {
	return A2(
		$elm$core$Maybe$map,
		function (fr) {
			return {
				yg: $author$project$Components$Produits$Common$LibellesSaisis$nonVide(
					A2($author$project$Components$Shared$LibellesParLangue$Model$lire, 'en', saisie)),
				zX: fr
			};
		},
		$author$project$Components$Produits$Common$LibellesSaisis$nonVide(
			A2($author$project$Components$Shared$LibellesParLangue$Model$lire, 'fr', saisie)));
};
var $author$project$Components$Produits$StructureCatalogue$Saisie$renommer = F3(
	function (enregistres, _v0, saisie) {
		var francaisParDefaut = _v0.a;
		var anglaisParDefaut = _v0.b;
		var anglaisGarde = function (saisis) {
			return saisie.ck ? saisis : _Utils_update(
				saisis,
				{
					yg: A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.yg;
						},
						enregistres)
				});
		};
		var _v1 = _Utils_Tuple2(
			A2(
				$elm$core$Maybe$map,
				anglaisGarde,
				$author$project$Components$Produits$Common$LibellesSaisis$versLApi(saisie.R)),
			enregistres);
		if (_v1.a.$ === 1) {
			var _v2 = _v1.a;
			return $author$project$Components$Produits$StructureCatalogue$Saisie$FrancaisVide;
		} else {
			if (!_v1.b.$) {
				var saisis = _v1.a.a;
				var dejaLa = _v1.b.a;
				return _Utils_eq(saisis, dejaLa) ? $author$project$Components$Produits$StructureCatalogue$Saisie$Inchange : $author$project$Components$Produits$StructureCatalogue$Saisie$ARenommer(saisis);
			} else {
				var saisis = _v1.a.a;
				var _v3 = _v1.b;
				return (_Utils_eq(saisis.zX, francaisParDefaut) && (_Utils_eq(saisis.yg, $elm$core$Maybe$Nothing) || _Utils_eq(
					saisis.yg,
					$elm$core$Maybe$Just(anglaisParDefaut)))) ? $author$project$Components$Produits$StructureCatalogue$Saisie$Inchange : $author$project$Components$Produits$StructureCatalogue$Saisie$ARenommer(saisis);
			}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Model$renommage = function (niveau) {
	return A3(
		$author$project$Components$Produits$StructureCatalogue$Saisie$renommer,
		niveau.R,
		_Utils_Tuple2(
			$author$project$Components$Produits$StructureCatalogue$Saisie$parDefaut(
				$author$project$Catalogue$Vocabulaire$archetype(niveau.fA)),
			$author$project$Components$Produits$StructureCatalogue$Saisie$parDefaut(
				$author$project$Catalogue$Vocabulaire$archetypeEnAnglais(niveau.fA))),
		niveau.hP);
};
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Model$avecLibelles = F2(
	function (libelles, niveau) {
		var libelle = _Utils_update(
			niveau,
			{R: libelles});
		return ($author$project$Components$Produits$StructureCatalogue$Niveaux$Model$modifie(niveau) && (!_Utils_eq(
			$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$renommage(libelle),
			$author$project$Components$Produits$StructureCatalogue$Saisie$Inchange))) ? libelle : _Utils_update(
			libelle,
			{
				hP: $author$project$Components$Produits$StructureCatalogue$Niveaux$Model$saisieDuNiveau(libelle)
			});
	});
var $elm$core$List$sortBy = _List_sortBy;
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$fillesDe = F2(
	function (parent, valeurs) {
		return A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.bY;
			},
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ey;
					},
					$elm$core$Basics$eq(parent)),
				valeurs));
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$avecValeur = F2(
	function (evenement, classification) {
		return (!_Utils_eq(
			A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$valeurDe, evenement.fm, classification),
			$elm$core$Maybe$Nothing)) ? classification : _Utils_update(
			classification,
			{
				Ki: _Utils_ap(
					classification.Ki,
					_List_fromArray(
						[
							{
							tI: false,
							Aq: evenement.fm,
							R: evenement.R,
							nQ: _List_Nil,
							ey: evenement.ey,
							bY: $elm$core$List$length(
								A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$fillesDe, evenement.ey, classification.Ki))
						}
						]))
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Model$codeDuNiveau = F2(
	function (structure, id) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.fA;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(id)),
						structure.C9))));
	});
var $author$project$Catalogue$Identifiants$etatCodeToString = function (_v0) {
	var valeur = _v0;
	return valeur;
};
var $author$project$I18n$Textes$produitsEtatActif = A3($author$project$I18n$Traductions$texte, 'produits.etat.actif', _List_Nil, 'Actif');
var $author$project$I18n$Textes$produitsEtatActifAnglais = A3($author$project$I18n$Traductions$texte, 'produits.etat.actif.anglais', _List_Nil, 'Active');
var $author$project$I18n$Textes$produitsEtatArrete = A3($author$project$I18n$Traductions$texte, 'produits.etat.arrete', _List_Nil, 'Arrêté');
var $author$project$I18n$Textes$produitsEtatArreteAnglais = A3($author$project$I18n$Traductions$texte, 'produits.etat.arrete.anglais', _List_Nil, 'Discontinued');
var $author$project$I18n$Textes$produitsEtatConception = A3($author$project$I18n$Traductions$texte, 'produits.etat.conception', _List_Nil, 'Conception');
var $author$project$I18n$Textes$produitsEtatConceptionAnglais = A3($author$project$I18n$Traductions$texte, 'produits.etat.conception.anglais', _List_Nil, 'Design');
var $author$project$I18n$Textes$produitsEtatFinDeSerie = A3($author$project$I18n$Traductions$texte, 'produits.etat.fin-de-serie', _List_Nil, 'Fin de série');
var $author$project$I18n$Textes$produitsEtatFinDeSerieAnglais = A3($author$project$I18n$Traductions$texte, 'produits.etat.fin-de-serie.anglais', _List_Nil, 'End of life');
var $author$project$I18n$Textes$produitsEtatHomologation = A3($author$project$I18n$Traductions$texte, 'produits.etat.homologation', _List_Nil, 'Homologation');
var $author$project$I18n$Textes$produitsEtatHomologationAnglais = A3($author$project$I18n$Traductions$texte, 'produits.etat.homologation.anglais', _List_Nil, 'Approval');
var $author$project$I18n$Textes$produitsEtatIdee = A3($author$project$I18n$Traductions$texte, 'produits.etat.idee', _List_Nil, 'Idée');
var $author$project$I18n$Textes$produitsEtatIdeeAnglais = A3($author$project$I18n$Traductions$texte, 'produits.etat.idee.anglais', _List_Nil, 'Idea');
var $author$project$I18n$Textes$produitsEtatPrototype = A3($author$project$I18n$Traductions$texte, 'produits.etat.prototype', _List_Nil, 'Prototype');
var $author$project$I18n$Textes$produitsEtatPrototypeAnglais = A3($author$project$I18n$Traductions$texte, 'produits.etat.prototype.anglais', _List_Nil, 'Prototype');
var $author$project$Catalogue$Vocabulaire$etats = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'idee',
			{t: $author$project$I18n$Textes$produitsEtatIdeeAnglais, Dj: $author$project$I18n$Textes$produitsEtatIdee}),
			_Utils_Tuple2(
			'conception',
			{t: $author$project$I18n$Textes$produitsEtatConceptionAnglais, Dj: $author$project$I18n$Textes$produitsEtatConception}),
			_Utils_Tuple2(
			'prototype',
			{t: $author$project$I18n$Textes$produitsEtatPrototypeAnglais, Dj: $author$project$I18n$Textes$produitsEtatPrototype}),
			_Utils_Tuple2(
			'homologation',
			{t: $author$project$I18n$Textes$produitsEtatHomologationAnglais, Dj: $author$project$I18n$Textes$produitsEtatHomologation}),
			_Utils_Tuple2(
			'actif',
			{t: $author$project$I18n$Textes$produitsEtatActifAnglais, Dj: $author$project$I18n$Textes$produitsEtatActif}),
			_Utils_Tuple2(
			'fin-de-serie',
			{t: $author$project$I18n$Textes$produitsEtatFinDeSerieAnglais, Dj: $author$project$I18n$Textes$produitsEtatFinDeSerie}),
			_Utils_Tuple2(
			'arrete',
			{t: $author$project$I18n$Textes$produitsEtatArreteAnglais, Dj: $author$project$I18n$Textes$produitsEtatArrete})
		]));
var $author$project$Catalogue$Vocabulaire$etatEnAnglais = function (code) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$I18n$Traductions$tel(code),
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.t;
			},
			A2($elm$core$Dict$get, code, $author$project$Catalogue$Vocabulaire$etats)));
};
var $author$project$Components$Produits$StructureCatalogue$Etats$Model$libelleAnglaisDeLEtat = function (etat) {
	var _v0 = etat.R;
	if (!_v0.$) {
		var libelles = _v0.a;
		return $author$project$I18n$Traductions$tel(
			A2($elm$core$Maybe$withDefault, '', libelles.yg));
	} else {
		return $author$project$Catalogue$Vocabulaire$etatEnAnglais(
			$author$project$Catalogue$Identifiants$etatCodeToString(etat.vx));
	}
};
var $author$project$Catalogue$Vocabulaire$etat = function (code) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$I18n$Traductions$tel(code),
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.Dj;
			},
			A2($elm$core$Dict$get, code, $author$project$Catalogue$Vocabulaire$etats)));
};
var $author$project$Components$Produits$StructureCatalogue$Etats$Model$libelleDeLEtat = function (etat) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Catalogue$Vocabulaire$etat(
			$author$project$Catalogue$Identifiants$etatCodeToString(etat.vx)),
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.zX;
				},
				$author$project$I18n$Traductions$tel),
			etat.R));
};
var $author$project$Components$Produits$StructureCatalogue$Etats$Model$saisieDeLEtat = function (etat) {
	return $author$project$Components$Produits$StructureCatalogue$Saisie$affichee(
		{
			yg: $author$project$Components$Produits$StructureCatalogue$Saisie$parDefaut(
				$author$project$Components$Produits$StructureCatalogue$Etats$Model$libelleAnglaisDeLEtat(etat)),
			zX: $author$project$Components$Produits$StructureCatalogue$Saisie$parDefaut(
				$author$project$Components$Produits$StructureCatalogue$Etats$Model$libelleDeLEtat(etat))
		});
};
var $author$project$Components$Produits$StructureCatalogue$Etats$Model$etatModifie = function (etat) {
	return !_Utils_eq(
		etat.hP.R,
		$author$project$Components$Produits$StructureCatalogue$Etats$Model$saisieDeLEtat(etat).R);
};
var $author$project$Components$Produits$StructureCatalogue$Etats$Model$renommageDeLEtat = function (etat) {
	var code = $author$project$Catalogue$Identifiants$etatCodeToString(etat.vx);
	return A3(
		$author$project$Components$Produits$StructureCatalogue$Saisie$renommer,
		etat.R,
		_Utils_Tuple2(
			$author$project$Components$Produits$StructureCatalogue$Saisie$parDefaut(
				$author$project$Catalogue$Vocabulaire$etat(code)),
			$author$project$Components$Produits$StructureCatalogue$Saisie$parDefaut(
				$author$project$Catalogue$Vocabulaire$etatEnAnglais(code))),
		etat.hP);
};
var $author$project$Components$Produits$StructureCatalogue$Etats$Model$definis = F2(
	function (evenement, etats) {
		return A2(
			$elm$core$List$map,
			function (defini) {
				var connu = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.vx;
							},
							$elm$core$Basics$eq(defini.vx)),
						etats));
				var etat = {
					vx: defini.vx,
					R: defini.R,
					o6: A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.o6;
							},
							connu)),
					hP: $author$project$Components$Produits$StructureCatalogue$Saisie$vide,
					KA: A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.KA;
							},
							connu))
				};
				var enSaisie = A2(
					$elm$core$Maybe$andThen,
					function (garde) {
						return (A2(
							$elm$core$Maybe$withDefault,
							false,
							A2($elm$core$Maybe$map, $author$project$Components$Produits$StructureCatalogue$Etats$Model$etatModifie, connu)) && (!_Utils_eq(
							$author$project$Components$Produits$StructureCatalogue$Etats$Model$renommageDeLEtat(garde),
							$author$project$Components$Produits$StructureCatalogue$Saisie$Inchange))) ? $elm$core$Maybe$Just(garde) : $elm$core$Maybe$Nothing;
					},
					A2(
						$elm$core$Maybe$map,
						function (avant) {
							return _Utils_update(
								etat,
								{hP: avant.hP});
						},
						connu));
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_update(
						etat,
						{
							hP: $author$project$Components$Produits$StructureCatalogue$Etats$Model$saisieDeLEtat(etat)
						}),
					enSaisie);
			},
			evenement);
	});
var $author$project$Components$Produits$StructureCatalogue$Model$orElse = F2(
	function (ancien, nouveau) {
		return _Utils_eq(nouveau, $elm$core$Maybe$Nothing) ? ancien : nouveau;
	});
var $author$project$Components$Produits$StructureCatalogue$Natures$Model$ordonnees = F2(
	function (ordre, natures) {
		return A2(
			$elm$core$List$indexedMap,
			F2(
				function (rang, nature) {
					return _Utils_update(
						nature,
						{bY: rang});
				}),
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					function (code) {
						return $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.vx;
									},
									$elm$core$Basics$eq(code)),
								natures));
					},
					ordre),
				A2(
					$elm$core$List$filter,
					function (nature) {
						return !A2($elm$core$List$member, nature.vx, ordre);
					},
					natures)));
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$orElse = F2(
	function (garde, nouveau) {
		return _Utils_eq(nouveau, $elm$core$Maybe$Nothing) ? garde : nouveau;
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$renomme = F4(
	function (id, libelles, formes, typologie) {
		return _Utils_update(
			typologie,
			{
				yG: A2(
					$elm$core$List$map,
					function (etage) {
						var _v0 = _Utils_Tuple2(
							_Utils_eq(etage.Aq, id),
							etage.xt);
						if (_v0.a && (_v0.b.$ === 1)) {
							return _Utils_update(
								etage,
								{
									xt: $author$project$Catalogue$API$QueryAPIModel$Libre(libelles),
									m$: A2($author$project$Components$Produits$StructureCatalogue$Etages$Model$orElse, etage.m$, formes)
								});
						} else {
							return etage;
						}
					},
					typologie.yG)
			});
	});
var $author$project$I18n$Textes$produitsNatureConsommableAnglais = A3($author$project$I18n$Traductions$texte, 'produits.nature.consommable.anglais', _List_Nil, 'Consumable');
var $author$project$I18n$Textes$produitsNaturePieceAnglais = A3($author$project$I18n$Traductions$texte, 'produits.nature.piece.anglais', _List_Nil, 'Spare part');
var $author$project$I18n$Textes$produitsNatureProduitFiniAnglais = A3($author$project$I18n$Traductions$texte, 'produits.nature.produit-fini.anglais', _List_Nil, 'Finished product');
var $author$project$I18n$Textes$produitsNatureServiceAnglais = A3($author$project$I18n$Traductions$texte, 'produits.nature.service.anglais', _List_Nil, 'Service');
var $author$project$I18n$Textes$produitsNatureSousEnsembleAnglais = A3($author$project$I18n$Traductions$texte, 'produits.nature.sous-ensemble.anglais', _List_Nil, 'Subassembly');
var $author$project$Catalogue$Vocabulaire$natureEnAnglais = function (code) {
	switch (code) {
		case 'produit-fini':
			return $author$project$I18n$Textes$produitsNatureProduitFiniAnglais;
		case 'piece':
			return $author$project$I18n$Textes$produitsNaturePieceAnglais;
		case 'sous-ensemble':
			return $author$project$I18n$Textes$produitsNatureSousEnsembleAnglais;
		case 'consommable':
			return $author$project$I18n$Textes$produitsNatureConsommableAnglais;
		case 'service':
			return $author$project$I18n$Textes$produitsNatureServiceAnglais;
		default:
			return $author$project$I18n$Traductions$tel(code);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Natures$Model$libelleAnglaisDeLaNature = function (nature) {
	var _v0 = nature.R;
	if (!_v0.$) {
		var libelles = _v0.a;
		return $author$project$I18n$Traductions$tel(
			A2($elm$core$Maybe$withDefault, '', libelles.yg));
	} else {
		return $author$project$Catalogue$Vocabulaire$natureEnAnglais(nature.vx);
	}
};
var $author$project$I18n$Textes$produitsNatureConsommable = A3($author$project$I18n$Traductions$texte, 'produits.nature.consommable', _List_Nil, 'Consommable');
var $author$project$I18n$Textes$produitsNaturePiece = A3($author$project$I18n$Traductions$texte, 'produits.nature.piece', _List_Nil, 'Pièce');
var $author$project$I18n$Textes$produitsNatureProduitFini = A3($author$project$I18n$Traductions$texte, 'produits.nature.produit-fini', _List_Nil, 'Produit fini');
var $author$project$I18n$Textes$produitsNatureService = A3($author$project$I18n$Traductions$texte, 'produits.nature.service', _List_Nil, 'Service');
var $author$project$I18n$Textes$produitsNatureSousEnsemble = A3($author$project$I18n$Traductions$texte, 'produits.nature.sous-ensemble', _List_Nil, 'Sous-ensemble');
var $author$project$Catalogue$Vocabulaire$natures = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('produit-fini', $author$project$I18n$Textes$produitsNatureProduitFini),
			_Utils_Tuple2('piece', $author$project$I18n$Textes$produitsNaturePiece),
			_Utils_Tuple2('sous-ensemble', $author$project$I18n$Textes$produitsNatureSousEnsemble),
			_Utils_Tuple2('consommable', $author$project$I18n$Textes$produitsNatureConsommable),
			_Utils_Tuple2('service', $author$project$I18n$Textes$produitsNatureService)
		]));
var $author$project$Catalogue$Vocabulaire$nature = function (code) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$I18n$Traductions$tel(code),
		A2($elm$core$Dict$get, code, $author$project$Catalogue$Vocabulaire$natures));
};
var $author$project$Catalogue$Vocabulaire$natureNommee = F2(
	function (saisi, code) {
		var _v0 = A2($elm$core$Maybe$map, $elm$core$String$trim, saisi);
		if (!_v0.$) {
			var nom = _v0.a;
			return (nom === '') ? $author$project$Catalogue$Vocabulaire$nature(code) : $author$project$I18n$Traductions$tel(nom);
		} else {
			return $author$project$Catalogue$Vocabulaire$nature(code);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Natures$Model$libelleDeLaNature = function (nature) {
	return A2(
		$author$project$Catalogue$Vocabulaire$natureNommee,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.zX;
			},
			nature.R),
		nature.vx);
};
var $author$project$Components$Produits$StructureCatalogue$Natures$Model$saisieDeLaNature = function (nature) {
	return $author$project$Components$Produits$StructureCatalogue$Saisie$affichee(
		{
			yg: $author$project$Components$Produits$StructureCatalogue$Saisie$parDefaut(
				$author$project$Components$Produits$StructureCatalogue$Natures$Model$libelleAnglaisDeLaNature(nature)),
			zX: $author$project$Components$Produits$StructureCatalogue$Saisie$parDefaut(
				$author$project$Components$Produits$StructureCatalogue$Natures$Model$libelleDeLaNature(nature))
		});
};
var $author$project$Components$Produits$StructureCatalogue$Natures$Model$renommee = F2(
	function (libelles, nature) {
		var suivie = _Utils_update(
			nature,
			{
				R: $elm$core$Maybe$Just(libelles)
			});
		return _Utils_update(
			suivie,
			{
				hP: $author$project$Components$Produits$StructureCatalogue$Natures$Model$saisieDeLaNature(suivie)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$reordonnes = F2(
	function (ordre, typologie) {
		var _v0 = A2(
			$elm$core$List$partition,
			function ($) {
				return $.wL;
			},
			typologie.yG);
		var categorie = _v0.a;
		var autres = _v0.b;
		return _Utils_update(
			typologie,
			{
				yG: $author$project$Components$Produits$StructureCatalogue$Etages$Model$renumerotes(
					_Utils_ap(
						A2(
							$elm$core$List$filterMap,
							function (id) {
								return $elm$core$List$head(
									A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.Aq;
											},
											$elm$core$Basics$eq(id)),
										autres));
							},
							ordre),
						_Utils_ap(
							A2(
								$elm$core$List$filter,
								function (etage) {
									return !A2($elm$core$List$member, etage.Aq, ordre);
								},
								autres),
							categorie)))
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$retire = F2(
	function (id, typologie) {
		return _Utils_update(
			typologie,
			{
				yG: $author$project$Components$Produits$StructureCatalogue$Etages$Model$renumerotes(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$neq(id)),
						typologie.yG))
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$surLaValeur = F3(
	function (id, modifier, classification) {
		return _Utils_update(
			classification,
			{
				Ki: A2(
					$elm$core$List$map,
					function (valeur) {
						return _Utils_eq(valeur.Aq, id) ? modifier(valeur) : valeur;
					},
					classification.Ki)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Model$surLeNiveau = F3(
	function (id, modifier, structure) {
		return _Utils_update(
			structure,
			{
				C9: A2(
					$elm$core$List$map,
					function (niveau) {
						return _Utils_eq(niveau.Aq, id) ? modifier(niveau) : niveau;
					},
					structure.C9)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Model$appliquer = F2(
	function (evenement, structure) {
		switch (evenement.$) {
			case 0:
				var id = evenement.a;
				return A3(
					$author$project$Components$Produits$StructureCatalogue$Model$surLeNiveau,
					id,
					function (niveau) {
						return _Utils_update(
							niveau,
							{Kg: true});
					},
					structure);
			case 1:
				var id = evenement.a;
				return A3(
					$author$project$Components$Produits$StructureCatalogue$Model$surLeNiveau,
					id,
					function (niveau) {
						return _Utils_update(
							niveau,
							{Kg: false});
					},
					structure);
			case 2:
				var id = evenement.a;
				var libelles = evenement.b;
				var formes = evenement.c;
				return A3(
					$author$project$Components$Produits$StructureCatalogue$Model$surLeNiveau,
					id,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$avecLibelles(
							$elm$core$Maybe$Just(libelles)),
						$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$avecFormes(formes)),
					structure);
			case 3:
				var id = evenement.a;
				return A3(
					$author$project$Components$Produits$StructureCatalogue$Model$surLeNiveau,
					id,
					$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$avecLibelles($elm$core$Maybe$Nothing),
					structure);
			case 4:
				var ordre = evenement.a;
				return _Utils_update(
					structure,
					{
						C9: _Utils_ap(
							A2(
								$elm$core$List$filterMap,
								function (id) {
									return $elm$core$List$head(
										A2(
											$elm$core$List$filter,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.Aq;
												},
												$elm$core$Basics$eq(id)),
											structure.C9));
								},
								ordre),
							A2(
								$elm$core$List$filter,
								function (niveau) {
									return !A2($elm$core$List$member, niveau.Aq, ordre);
								},
								structure.C9))
					});
			case 5:
				var ajoute = evenement.a;
				return _Utils_update(
					structure,
					{
						C9: _Utils_ap(
							A2($elm$core$List$take, ajoute.bY, structure.C9),
							A2(
								$elm$core$List$cons,
								$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$ajoute(ajoute),
								A2($elm$core$List$drop, ajoute.bY, structure.C9)))
					});
			case 29:
				return structure;
			case 28:
				return structure;
			case 6:
				var id = evenement.a;
				return _Utils_update(
					structure,
					{
						C9: A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$neq(id)),
							structure.C9)
					});
			case 7:
				var definis = evenement.a;
				return _Utils_update(
					structure,
					{
						mj: A2($author$project$Components$Produits$StructureCatalogue$Etats$Model$definis, definis, structure.mj)
					});
			case 8:
				var code = evenement.a;
				return _Utils_update(
					structure,
					{
						Kz: $elm$core$Maybe$Just(code)
					});
			case 9:
				return _Utils_update(
					structure,
					{Kz: $elm$core$Maybe$Nothing});
			case 11:
				var ordre = evenement.a;
				return _Utils_update(
					structure,
					{
						oo: A2($author$project$Components$Produits$StructureCatalogue$Natures$Model$ordonnees, ordre, structure.oo)
					});
			case 10:
				var code = evenement.a;
				var libelles = evenement.b;
				return _Utils_update(
					structure,
					{
						oo: A2(
							$elm$core$List$map,
							function (nature) {
								return _Utils_eq(nature.vx, code) ? A2($author$project$Components$Produits$StructureCatalogue$Natures$Model$renommee, libelles, nature) : nature;
							},
							structure.oo)
					});
			case 12:
				var id = evenement.a;
				var libelles = evenement.b;
				return A2(
					$author$project$Components$Produits$StructureCatalogue$Model$avecLaClassification,
					A3($author$project$Components$Produits$StructureCatalogue$Classifications$Model$ajoutee, false, id, libelles),
					structure);
			case 13:
				var id = evenement.a;
				var libelles = evenement.b;
				var formes = evenement.c;
				return A2(
					$author$project$Components$Produits$StructureCatalogue$Model$avecLaClassification,
					function (lue) {
						return _Utils_update(
							lue,
							{m$: formes});
					}(
						A3($author$project$Components$Produits$StructureCatalogue$Classifications$Model$ajoutee, true, id, libelles)),
					structure);
			case 14:
				var id = evenement.a;
				var libelles = evenement.b;
				var formes = evenement.c;
				return A3(
					$author$project$Components$Produits$StructureCatalogue$Model$surLaClassification,
					id,
					function (lue) {
						return _Utils_update(
							lue,
							{
								m$: A2($author$project$Components$Produits$StructureCatalogue$Model$orElse, lue.m$, formes),
								R: libelles
							});
					},
					structure);
			case 15:
				var id = evenement.a;
				return _Utils_update(
					structure,
					{
						vk: A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$neq(id)),
							structure.vk)
					});
			case 16:
				return structure;
			case 17:
				return structure;
			case 18:
				var classification = evenement.a;
				var ajoutee = evenement.b;
				return A3(
					$author$project$Components$Produits$StructureCatalogue$Model$surLaClassification,
					classification,
					$author$project$Components$Produits$StructureCatalogue$Classifications$Model$avecValeur(ajoutee),
					structure);
			case 19:
				var classification = evenement.a;
				var place = evenement.b;
				return A3(
					$author$project$Components$Produits$StructureCatalogue$Model$surLaClassification,
					classification,
					function (lue) {
						return _Utils_update(
							lue,
							{
								Ki: A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$appliquerLaPlace, place, lue.Ki)
							});
					},
					structure);
			case 20:
				var classification = evenement.a;
				var ordre = evenement.c;
				return A3(
					$author$project$Components$Produits$StructureCatalogue$Model$surLaClassification,
					classification,
					function (lue) {
						return _Utils_update(
							lue,
							{
								Di: A2(
									$elm$core$List$map,
									function (noeud) {
										var _v1 = A2(
											$elm$core$List$filter,
											A2(
												$elm$core$Basics$composeR,
												$elm$core$Tuple$second,
												$elm$core$Basics$eq(noeud.Aq)),
											A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, ordre));
										if (_v1.b) {
											var _v2 = _v1.a;
											var rang = _v2.a;
											return _Utils_update(
												noeud,
												{bY: rang});
										} else {
											return noeud;
										}
									},
									lue.Di)
							});
					},
					structure);
			case 21:
				var classification = evenement.a;
				var valeur = evenement.b;
				var libelles = evenement.c;
				return A3(
					$author$project$Components$Produits$StructureCatalogue$Model$surLaClassification,
					classification,
					A2(
						$author$project$Components$Produits$StructureCatalogue$Classifications$Model$surLaValeur,
						valeur,
						function (lue) {
							return _Utils_update(
								lue,
								{R: libelles});
						}),
					structure);
			case 22:
				var classification = evenement.a;
				var valeur = evenement.b;
				return A3(
					$author$project$Components$Produits$StructureCatalogue$Model$surLaClassification,
					classification,
					A2(
						$author$project$Components$Produits$StructureCatalogue$Classifications$Model$surLaValeur,
						valeur,
						function (lue) {
							return _Utils_update(
								lue,
								{tI: true});
						}),
					structure);
			case 23:
				var classification = evenement.a;
				var valeur = evenement.b;
				return A3(
					$author$project$Components$Produits$StructureCatalogue$Model$surLaClassification,
					classification,
					A2(
						$author$project$Components$Produits$StructureCatalogue$Classifications$Model$surLaValeur,
						valeur,
						function (lue) {
							return _Utils_update(
								lue,
								{tI: false});
						}),
					structure);
			case 24:
				var typologie = evenement.a;
				var fait = evenement.b;
				return A3(
					$author$project$Components$Produits$StructureCatalogue$Model$surLaClassification,
					typologie,
					A2(
						$author$project$Components$Produits$StructureCatalogue$Etages$Model$ajoute,
						$author$project$Components$Produits$StructureCatalogue$Model$codeDuNiveau(structure),
						fait),
					structure);
			case 25:
				var typologie = evenement.a;
				var etage = evenement.b;
				var libelles = evenement.c;
				var formes = evenement.d;
				return A3(
					$author$project$Components$Produits$StructureCatalogue$Model$surLaClassification,
					typologie,
					A3($author$project$Components$Produits$StructureCatalogue$Etages$Model$renomme, etage, libelles, formes),
					structure);
			case 26:
				var typologie = evenement.a;
				var ordre = evenement.b;
				return A3(
					$author$project$Components$Produits$StructureCatalogue$Model$surLaClassification,
					typologie,
					$author$project$Components$Produits$StructureCatalogue$Etages$Model$reordonnes(ordre),
					structure);
			default:
				var typologie = evenement.a;
				var etage = evenement.b;
				return A3(
					$author$project$Components$Produits$StructureCatalogue$Model$surLaClassification,
					typologie,
					$author$project$Components$Produits$StructureCatalogue$Etages$Model$retire(etage),
					structure);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Model$delaiDeRelectureMs = 1000;
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$estUneCommande = function (commande) {
	switch (commande.$) {
		case 35:
			return true;
		case 36:
			return true;
		case 37:
			return true;
		case 38:
			return true;
		case 39:
			return true;
		case 40:
			return true;
		case 41:
			return true;
		case 42:
			return true;
		case 43:
			return true;
		case 44:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$EvenementInconnu = {$: 29};
var $author$project$Components$Produits$StructureCatalogue$Model$inconnus = $elm$core$List$member($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$EvenementInconnu);
var $author$project$Components$Produits$StructureCatalogue$Effet$LireLaStructure = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Commandes$relire = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Effet$LireLaStructure, $elm$core$List$singleton),
			model.np));
};
var $author$project$Components$Produits$StructureCatalogue$Effet$LireLesInformations = function (a) {
	return {$: 2, a: a};
};
var $author$project$API$NavLinksDictionary$self = 'self';
var $author$project$API$Liens$trouver = F2(
	function (rel, liens) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (lien) {
					return _Utils_eq(lien.eP, rel);
				},
				liens));
	});
var $author$project$Components$Produits$StructureCatalogue$Commandes$typeDeLaCategorie = function (portee) {
	if (portee.$ === 3) {
		var type_ = portee.a;
		return $elm$core$Maybe$Just(type_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Commandes$relireLesInformations = function (model) {
	return _Utils_ap(
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Effet$LireLesInformations, $elm$core$List$singleton),
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.nQ;
						},
						$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$self)),
					model.AM))),
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (informations) {
					return A2(
						$author$project$Components$Produits$StructureCatalogue$Commandes$lesCategories,
						informations.BC,
						A2(
							$elm$core$List$filterMap,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.F$;
								},
								$author$project$Components$Produits$StructureCatalogue$Commandes$typeDeLaCategorie),
							informations.F3));
				},
				model.AM)));
};
var $author$project$Components$Produits$StructureCatalogue$Model$defautEcrit = F2(
	function (typologie, evenement) {
		if (evenement.$ === 24) {
			var la = evenement.a;
			var fait = evenement.b;
			return _Utils_eq(la, typologie) && function () {
				var _v1 = fait.xt;
				if (!_v1.$) {
					return true;
				} else {
					return false;
				}
			}();
		} else {
			return false;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Model$laReecriture = function (evenement) {
	switch (evenement.$) {
		case 29:
			return true;
		case 22:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Model$sansAnglaisVide = function (formes) {
	return A2(
		$elm$core$Maybe$map,
		function (f) {
			return _Utils_update(
				f,
				{
					yg: A2(
						$elm$core$Maybe$andThen,
						function (en) {
							return ($elm$core$String$trim(en.bT) === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(en);
						},
						f.yg)
				});
		},
		formes);
};
var $author$project$Components$Produits$StructureCatalogue$Model$formesRendues = F2(
	function (voulues, rendues) {
		return _Utils_eq(voulues, $elm$core$Maybe$Nothing) || (_Utils_eq(
			$author$project$Components$Produits$StructureCatalogue$Model$sansAnglaisVide(voulues),
			$author$project$Components$Produits$StructureCatalogue$Model$sansAnglaisVide(rendues)) || _Utils_eq(
			A2($elm$core$Maybe$map, $author$project$Catalogue$Formes$sontVides, voulues),
			$elm$core$Maybe$Just(true)));
	});
var $author$project$Components$Produits$StructureCatalogue$Model$repond = F2(
	function (commande, evenement) {
		var _v0 = _Utils_Tuple2(commande, evenement);
		_v0$31:
		while (true) {
			switch (_v0.b.$) {
				case 0:
					if (!_v0.a.$) {
						var voulu = _v0.a.a;
						var fait = _v0.b.a;
						return _Utils_eq(voulu, fait);
					} else {
						break _v0$31;
					}
				case 1:
					if (_v0.a.$ === 1) {
						var voulu = _v0.a.a;
						var fait = _v0.b.a;
						return _Utils_eq(voulu, fait);
					} else {
						break _v0$31;
					}
				case 2:
					if (_v0.a.$ === 2) {
						var _v1 = _v0.a;
						var voulu = _v1.a;
						var libelles = _v1.b;
						var formes = _v1.c;
						var _v2 = _v0.b;
						var fait = _v2.a;
						var ecrits = _v2.b;
						var ecrites = _v2.c;
						return _Utils_eq(voulu, fait) && (_Utils_eq(libelles, ecrits) && A2($author$project$Components$Produits$StructureCatalogue$Model$formesRendues, formes, ecrites));
					} else {
						break _v0$31;
					}
				case 3:
					if (_v0.a.$ === 3) {
						var voulu = _v0.a.a;
						var fait = _v0.b.a;
						return _Utils_eq(voulu, fait);
					} else {
						break _v0$31;
					}
				case 4:
					if (_v0.a.$ === 4) {
						var voulu = _v0.a.a;
						var fait = _v0.b.a;
						return _Utils_eq(voulu, fait);
					} else {
						break _v0$31;
					}
				case 5:
					if (_v0.a.$ === 5) {
						var voulu = _v0.a.a;
						var fait = _v0.b.a;
						return _Utils_eq(
							voulu,
							{fA: fait.fA, R: fait.R, bY: fait.bY});
					} else {
						break _v0$31;
					}
				case 29:
					var _v3 = _v0.b;
					return true;
				case 6:
					if (_v0.a.$ === 6) {
						var voulu = _v0.a.a;
						var fait = _v0.b.a;
						return _Utils_eq(voulu, fait);
					} else {
						break _v0$31;
					}
				case 7:
					if (_v0.a.$ === 7) {
						var voulus = _v0.a.a;
						var faits = _v0.b.a;
						return _Utils_eq(
							$elm$core$List$length(voulus),
							$elm$core$List$length(faits)) && A2(
							$elm$core$List$all,
							$elm$core$Basics$identity,
							A3(
								$elm$core$List$map2,
								F2(
									function (voulu, fait) {
										return _Utils_eq(voulu.R, fait.R) && A2(
											$elm$core$Maybe$withDefault,
											true,
											A2(
												$elm$core$Maybe$map,
												$elm$core$Basics$eq(fait.vx),
												voulu.vx));
									}),
								voulus,
								faits));
					} else {
						break _v0$31;
					}
				case 8:
					if (_v0.a.$ === 8) {
						var voulu = _v0.a.a;
						var fait = _v0.b.a;
						return _Utils_eq(
							voulu,
							$elm$core$Maybe$Just(fait));
					} else {
						break _v0$31;
					}
				case 9:
					if (_v0.a.$ === 8) {
						var voulu = _v0.a.a;
						var _v4 = _v0.b;
						return _Utils_eq(voulu, $elm$core$Maybe$Nothing);
					} else {
						break _v0$31;
					}
				case 11:
					if (_v0.a.$ === 10) {
						var voulu = _v0.a.a;
						var fait = _v0.b.a;
						return _Utils_eq(voulu, fait);
					} else {
						break _v0$31;
					}
				case 10:
					if (_v0.a.$ === 9) {
						var _v5 = _v0.a;
						var voulue = _v5.a;
						var voulus = _v5.b;
						var _v6 = _v0.b;
						var faite = _v6.a;
						var faits = _v6.b;
						return _Utils_eq(voulue, faite) && _Utils_eq(voulus, faits);
					} else {
						break _v0$31;
					}
				case 12:
					if (_v0.a.$ === 11) {
						var voulus = _v0.a.a;
						var _v7 = _v0.b;
						var faits = _v7.b;
						return _Utils_eq(voulus, faits);
					} else {
						break _v0$31;
					}
				case 28:
					if (_v0.a.$ === 12) {
						return true;
					} else {
						break _v0$31;
					}
				case 13:
					if (_v0.a.$ === 14) {
						var _v8 = _v0.a;
						var voulus = _v8.a;
						var formes = _v8.b;
						var _v9 = _v0.b;
						var faits = _v9.b;
						var ecrites = _v9.c;
						return _Utils_eq(voulus, faits) && A2($author$project$Components$Produits$StructureCatalogue$Model$formesRendues, formes, ecrites);
					} else {
						break _v0$31;
					}
				case 14:
					if (_v0.a.$ === 15) {
						var _v10 = _v0.a;
						var ou = _v10.a;
						var voulus = _v10.b;
						var formes = _v10.c;
						var _v11 = _v0.b;
						var la = _v11.a;
						var faits = _v11.b;
						var ecrites = _v11.c;
						return _Utils_eq(ou, la) && (_Utils_eq(voulus, faits) && A2($author$project$Components$Produits$StructureCatalogue$Model$formesRendues, formes, ecrites));
					} else {
						break _v0$31;
					}
				case 15:
					if (_v0.a.$ === 16) {
						var ou = _v0.a.a;
						var la = _v0.b.a;
						return _Utils_eq(ou, la);
					} else {
						break _v0$31;
					}
				case 17:
					if (_v0.a.$ === 17) {
						var ou = _v0.a.a;
						var la = _v0.b.a;
						return _Utils_eq(ou, la);
					} else {
						break _v0$31;
					}
				case 16:
					if (_v0.a.$ === 18) {
						var ou = _v0.a.a;
						var la = _v0.b.a;
						return _Utils_eq(ou, la);
					} else {
						break _v0$31;
					}
				case 18:
					switch (_v0.a.$) {
						case 20:
							var _v12 = _v0.a;
							var ou = _v12.a;
							var voulue = _v12.b;
							var _v13 = _v0.b;
							var la = _v13.a;
							var faite = _v13.b;
							return _Utils_eq(ou, la) && _Utils_eq(
								voulue,
								{R: faite.R, ey: faite.ey});
						case 31:
							var _v14 = _v0.a;
							var ou = _v14.a;
							var voulue = _v14.b;
							var _v15 = _v0.b;
							var la = _v15.a;
							var faite = _v15.b;
							return _Utils_eq(ou, la) && _Utils_eq(voulue.R, faite.R);
						default:
							break _v0$31;
					}
				case 19:
					if (_v0.a.$ === 21) {
						var _v16 = _v0.a;
						var ou = _v16.a;
						var voulue = _v16.b;
						var _v17 = _v0.b;
						var la = _v17.a;
						var faite = _v17.b;
						return _Utils_eq(ou, la) && _Utils_eq(voulue, faite);
					} else {
						break _v0$31;
					}
				case 20:
					if (_v0.a.$ === 29) {
						var _v18 = _v0.a;
						var ou = _v18.a;
						var pere = _v18.b;
						var ordre = _v18.c;
						var _v19 = _v0.b;
						var la = _v19.a;
						var mere = _v19.b;
						var fait = _v19.c;
						return _Utils_eq(ou, la) && (_Utils_eq(pere, mere) && _Utils_eq(ordre, fait));
					} else {
						break _v0$31;
					}
				case 21:
					if (_v0.a.$ === 22) {
						var _v20 = _v0.a;
						var ou = _v20.a;
						var voulue = _v20.b;
						var libelles = _v20.c;
						var _v21 = _v0.b;
						var la = _v21.a;
						var faite = _v21.b;
						var ecrits = _v21.c;
						return _Utils_eq(ou, la) && (_Utils_eq(voulue, faite) && _Utils_eq(libelles, ecrits));
					} else {
						break _v0$31;
					}
				case 22:
					if (_v0.a.$ === 23) {
						var _v22 = _v0.a;
						var ou = _v22.a;
						var voulue = _v22.b;
						var _v23 = _v0.b;
						var la = _v23.a;
						var faite = _v23.b;
						return _Utils_eq(ou, la) && _Utils_eq(voulue, faite);
					} else {
						break _v0$31;
					}
				case 23:
					if (_v0.a.$ === 24) {
						var _v24 = _v0.a;
						var ou = _v24.a;
						var voulue = _v24.b;
						var _v25 = _v0.b;
						var la = _v25.a;
						var faite = _v25.b;
						return _Utils_eq(ou, la) && _Utils_eq(voulue, faite);
					} else {
						break _v0$31;
					}
				case 24:
					if ((_v0.a.$ === 26) && (!_v0.a.a.$)) {
						var _v26 = _v0.a;
						var _v27 = _v26.a;
						var ou = _v27.a;
						var voulue = _v27.b;
						var _v28 = _v0.b;
						var la = _v28.a;
						var fait = _v28.b;
						return _Utils_eq(ou, la) && _Utils_eq(voulue, fait.xt);
					} else {
						break _v0$31;
					}
				case 25:
					if (_v0.a.$ === 25) {
						var _v29 = _v0.a;
						var ou = _v29.a;
						var voulu = _v29.b;
						var libelles = _v29.c;
						var formes = _v29.d;
						var _v30 = _v0.b;
						var la = _v30.a;
						var fait = _v30.b;
						var ecrits = _v30.c;
						var ecrites = _v30.d;
						return _Utils_eq(ou, la) && (_Utils_eq(voulu, fait) && (_Utils_eq(libelles, ecrits) && A2($author$project$Components$Produits$StructureCatalogue$Model$formesRendues, formes, ecrites)));
					} else {
						break _v0$31;
					}
				case 26:
					if ((_v0.a.$ === 26) && (_v0.a.a.$ === 1)) {
						var _v31 = _v0.a;
						var _v32 = _v31.a;
						var ou = _v32.a;
						var voulu = _v32.b;
						var _v33 = _v0.b;
						var la = _v33.a;
						var fait = _v33.b;
						return _Utils_eq(ou, la) && _Utils_eq(voulu, fait);
					} else {
						break _v0$31;
					}
				default:
					if ((_v0.a.$ === 26) && (_v0.a.a.$ === 2)) {
						var _v34 = _v0.a;
						var _v35 = _v34.a;
						var ou = _v35.a;
						var voulu = _v35.b;
						var _v36 = _v0.b;
						var la = _v36.a;
						var fait = _v36.b;
						return _Utils_eq(ou, la) && _Utils_eq(voulu, fait);
					} else {
						break _v0$31;
					}
			}
		}
		return false;
	});
var $author$project$Components$Produits$StructureCatalogue$Model$typologieDeLArbre = function (commande) {
	switch (commande.$) {
		case 27:
			var typologie = commande.a;
			return $elm$core$Maybe$Just(typologie);
		case 28:
			var typologie = commande.a;
			return $elm$core$Maybe$Just(typologie);
		case 29:
			var typologie = commande.a;
			return $elm$core$Maybe$Just(typologie);
		case 30:
			var typologie = commande.a;
			return $elm$core$Maybe$Just(typologie);
		case 31:
			var typologie = commande.a;
			return $elm$core$Maybe$Just(typologie);
		case 32:
			var typologie = commande.a;
			return $elm$core$Maybe$Just(typologie);
		case 33:
			var typologie = commande.a;
			return $elm$core$Maybe$Just(typologie);
		case 34:
			var typologie = commande.a;
			return $elm$core$Maybe$Just(typologie);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$classificationDuGeste = function (geste) {
	switch (geste.$) {
		case 0:
			var typologie = geste.a;
			return typologie;
		case 1:
			var typologie = geste.a;
			return typologie;
		default:
			var typologie = geste.a;
			return typologie;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Model$typologieDuGeste = function (commande) {
	switch (commande.$) {
		case 25:
			var typologie = commande.a;
			return $elm$core$Maybe$Just(typologie);
		case 26:
			var geste = commande.a;
			return $elm$core$Maybe$Just(
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$classificationDuGeste(geste));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Model$repondA = F2(
	function (commande, rendus) {
		var evenements = function () {
			if (commande.$ === 26) {
				return A2(
					$elm$core$List$filter,
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Components$Produits$StructureCatalogue$Model$laReecriture),
					rendus);
			} else {
				return rendus;
			}
		}();
		var _v0 = _Utils_Tuple2(
			$author$project$Components$Produits$StructureCatalogue$Model$typologieDuGeste(commande),
			$elm$core$List$reverse(evenements));
		if ((!_v0.a.$) && _v0.b.b) {
			var typologie = _v0.a.a;
			var _v1 = _v0.b;
			var dernier = _v1.a;
			var avant = _v1.b;
			return A2(
				$elm$core$List$all,
				$author$project$Components$Produits$StructureCatalogue$Model$defautEcrit(typologie),
				avant) && A2($author$project$Components$Produits$StructureCatalogue$Model$repond, commande, dernier);
		} else {
			var _v2 = $author$project$Components$Produits$StructureCatalogue$Model$typologieDeLArbre(commande);
			if (!_v2.$) {
				var typologie = _v2.a;
				return A2(
					$elm$core$List$all,
					function (evenement) {
						return A2($author$project$Components$Produits$StructureCatalogue$Model$defautEcrit, typologie, evenement) || A2($author$project$Components$Produits$StructureCatalogue$Model$repond, commande, evenement);
					},
					evenements);
			} else {
				return A2(
					$elm$core$List$all,
					$author$project$Components$Produits$StructureCatalogue$Model$repond(commande),
					evenements);
			}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Update$aboutir = F3(
	function (commande, rendue, model) {
		var repondue = A2($author$project$Components$Produits$StructureCatalogue$Model$repondA, commande, rendue.mk);
		var etatsDefinis = function () {
			var _v0 = _Utils_Tuple2(
				commande,
				A2($author$project$Components$Produits$StructureCatalogue$Model$repondA, commande, rendue.mk));
			if ((_v0.a.$ === 7) && _v0.b) {
				return true;
			} else {
				return false;
			}
		}();
		var avant = A4($author$project$Components$Produits$StructureCatalogue$Classifications$Update$aboutie, commande, repondue, rendue.mk, model);
		var suivant = _Utils_update(
			avant,
			{
				l2: $author$project$Components$Produits$StructureCatalogue$Model$SansProcessUid,
				a9: etatsDefinis ? $author$project$Components$Produits$StructureCatalogue$Saisie$vide : avant.a9,
				h$: $author$project$Components$Produits$StructureCatalogue$Informations$Model$estUneCommande(commande) ? avant.h$ : A2(
					$elm$core$Maybe$map,
					function (structure) {
						return _Utils_update(
							structure,
							{nQ: rendue.nQ});
					},
					A2(
						$elm$core$Maybe$map,
						function (structure) {
							return A3($elm$core$List$foldl, $author$project$Components$Produits$StructureCatalogue$Model$appliquer, structure, rendue.mk);
						},
						avant.h$))
			});
		return _Utils_Tuple2(
			suivant,
			A2(
				$elm$core$List$cons,
				$author$project$Components$Produits$StructureCatalogue$Effet$DemanderProcessUid,
				$author$project$Components$Produits$StructureCatalogue$Informations$Model$estUneCommande(commande) ? (rendue.sy ? $author$project$Components$Produits$StructureCatalogue$Commandes$relireLesInformations(suivant) : _List_fromArray(
					[
						$author$project$Components$Produits$StructureCatalogue$Effet$AttendreAvantDeRelire($author$project$Components$Produits$StructureCatalogue$Model$delaiDeRelectureMs)
					])) : ((rendue.sy || ((!A2($author$project$Components$Produits$StructureCatalogue$Model$repondA, commande, rendue.mk)) || $author$project$Components$Produits$StructureCatalogue$Model$inconnus(rendue.mk))) ? $author$project$Components$Produits$StructureCatalogue$Commandes$relire(suivant) : _List_fromArray(
					[
						$author$project$Components$Produits$StructureCatalogue$Effet$AttendreAvantDeRelire($author$project$Components$Produits$StructureCatalogue$Model$delaiDeRelectureMs)
					]))));
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$DeCategorie = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$DeGamme = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$DeMarque = {$: 0};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$DeProduit = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$DeValeur = function (a) {
	return {$: 3, a: a};
};
var $author$project$API$NavLinksDictionary$ajouterUneCategorie = 'ajouter-une-categorie';
var $author$project$Catalogue$Vocabulaire$codeGamme = 'gamme';
var $author$project$Catalogue$Vocabulaire$codeProduit = 'produit';
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$reglee = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		function (structure) {
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$pair(structure),
				A2($author$project$Components$Produits$StructureCatalogue$Typologies$Model$reglee, model.r6, structure.vk));
		},
		model.h$);
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$colonne = F2(
	function (rang, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (_v0) {
				var structure = _v0.a;
				var typologie = _v0.b;
				var toutes = A3($author$project$Components$Produits$StructureCatalogue$Valeurs$Lecture$colonnes, model, structure, typologie);
				return A2(
					$elm$core$Maybe$map,
					function (trouvee) {
						return _Utils_Tuple3(toutes, typologie, trouvee);
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.bY;
								},
								$elm$core$Basics$eq(rang)),
							toutes)));
			},
			$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$reglee(model));
	});
var $author$project$Catalogue$API$QueryAPIModel$ValeurElement = function (a) {
	return {$: 1, a: a};
};
var $author$project$API$NavLinksDictionary$creerUneGamme = 'creer-une-gamme';
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$gammeAAjouter = F4(
	function (model, toutes, ajoutee, depuis) {
		var choisie = A2(
			$elm$core$Maybe$andThen,
			function (desMarques) {
				var _v4 = desMarques.ve;
				if ((!_v4.$) && (_v4.a.$ === 1)) {
					var id = _v4.a.a;
					return A2(
						$elm$core$Maybe$map,
						function (ligne) {
							return {Aq: id, Dj: ligne.Dj};
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.fm;
									},
									$elm$core$Basics$eq(
										$author$project$Catalogue$API$QueryAPIModel$ValeurElement(id))),
								desMarques.gV)));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (unePlace) {
						var _v3 = unePlace.md.xt;
						if (!_v3.$) {
							var code = _v3.a;
							return _Utils_eq(code, $author$project$Catalogue$Vocabulaire$codeMarque);
						} else {
							return false;
						}
					},
					toutes)));
		var annuaire = $author$project$Components$Produits$StructureCatalogue$Marques$Model$marques(model.cU);
		var deReference = function () {
			if (!choisie.$) {
				var marque = choisie.a;
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(marque.Aq)),
						annuaire));
			} else {
				return $elm$core$List$head(annuaire);
			}
		}();
		var _v0 = _Utils_Tuple2(
			ajoutee.md.xt,
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUneGamme, ajoutee.md.nQ));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var _v1 = _v0.a;
			var niveau = _v1.b;
			var lien = _v0.b.a;
			return $elm$core$Maybe$Just(
				{
					xe: depuis,
					md: ajoutee.Dj,
					zo: A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.nQ;
							},
							$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$self)),
						deReference),
					nB: lien,
					gX: choisie,
					os: niveau
				});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$idDeLAjout = function (rang) {
	return 'valeurs-ajouter-' + $elm$core$String$fromInt(rang);
};
var $author$project$API$NavLinksDictionary$creerUnProduit = 'creer-un-produit';
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$noeudDuProduit = function (colonne) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				A2(
					$elm$core$Basics$composeR,
					$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$creerUnProduit),
					$elm$core$Basics$neq($elm$core$Maybe$Nothing))),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Di;
					},
					colonne.IV))));
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$produitAAjouter = F3(
	function (toutes, ajoutee, depuis) {
		var _v0 = _Utils_Tuple2(
			ajoutee.IV,
			$author$project$Components$Produits$StructureCatalogue$Valeurs$Model$noeudDuProduit(ajoutee));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var categorie = _v0.a.a;
			var noeud = _v0.b.a;
			var _v1 = _Utils_Tuple2(
				categorie.fm,
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUnProduit, noeud.nQ));
			if ((_v1.a.$ === 2) && (!_v1.b.$)) {
				var type_ = _v1.a.a;
				var lien = _v1.b.a;
				return $elm$core$Maybe$Just(
					{
						uK: categorie.Dj,
						xe: depuis,
						md: ajoutee.Dj,
						nB: lien,
						C6: A2(
							$elm$core$Maybe$withDefault,
							$author$project$I18n$Traductions$tel(''),
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.Dj;
								},
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.bY;
											},
											$elm$core$Basics$eq(ajoutee.bY - 1)),
										toutes)))),
						fh: type_
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$I18n$Traductions$Sous = function (a) {
	return {$: 3, a: a};
};
var $author$project$I18n$Textes$produitsValeursAjouter = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.valeurs.ajouter',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'etage',
				$author$project$I18n$Traductions$Sous(p.md))
			]),
		'Ajouter : {etage}');
};
var $author$project$Catalogue$API$WriteAPIModel$ElementDuDessus = function (a) {
	return {$: 1, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$LibreDuDessus = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$valeurDuDessus = function (valeur) {
	switch (valeur.$) {
		case 0:
			var id = valeur.a;
			return $elm$core$Maybe$Just(
				$author$project$Catalogue$API$WriteAPIModel$LibreDuDessus(id));
		case 1:
			var id = valeur.a;
			return $elm$core$Maybe$Just(
				$author$project$Catalogue$API$WriteAPIModel$ElementDuDessus(id));
		case 2:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$ajoutDansLaColonne = F2(
	function (rang, model) {
		var _v0 = A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Update$colonne, rang, model);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var toutes = _v1.a;
			var typologie = _v1.b;
			var ajoutee = _v1.c;
			var parents = A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Di;
						},
						$elm$core$List$map(
							function ($) {
								return $.Aq;
							})),
					ajoutee.IV));
			var depuis = $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$idDeLAjout(rang);
			var aPlacer = {md: ajoutee.md.Aq, hl: parents, Ge: !rang, r3: typologie.Aq};
			var _v2 = ajoutee.md.xt;
			if (_v2.$ === 1) {
				var libelles = _v2.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{iy: $elm$core$Maybe$Nothing}),
					$elm$core$Maybe$Just(
						$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$DeValeur(
							{xe: depuis, md: ajoutee.md.Aq, Dj: libelles.zX, IV: parents, r3: typologie.Aq})));
			} else {
				var code = _v2.a;
				if (ajoutee.md.wL) {
					var _v3 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ajouterUneCategorie, ajoutee.md.nQ);
					if (!_v3.$) {
						var lien = _v3.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{iy: $elm$core$Maybe$Nothing}),
							$elm$core$Maybe$Just(
								$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$DeCategorie(
									{
										vj: typologie.Aq,
										xe: depuis,
										nB: lien,
										Dn: A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.Dj;
											},
											ajoutee.IV),
										IV: A2(
											$elm$core$Maybe$andThen,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.fm;
												},
												$author$project$Components$Produits$StructureCatalogue$Valeurs$Model$valeurDuDessus),
											ajoutee.IV),
										h6: $author$project$I18n$Textes$produitsValeursAjouter(
											{md: ajoutee.Dj})
									})));
					} else {
						return _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
					}
				} else {
					if (_Utils_eq(code, $author$project$Catalogue$Vocabulaire$codeMarque)) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									iy: $elm$core$Maybe$Just(aPlacer)
								}),
							$elm$core$Maybe$Just($author$project$Components$Produits$StructureCatalogue$Valeurs$Update$DeMarque));
					} else {
						if (_Utils_eq(code, $author$project$Catalogue$Vocabulaire$codeGamme)) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{iy: $elm$core$Maybe$Nothing}),
								A2(
									$elm$core$Maybe$map,
									$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$DeGamme,
									A4($author$project$Components$Produits$StructureCatalogue$Valeurs$Update$gammeAAjouter, model, toutes, ajoutee, depuis)));
						} else {
							if (_Utils_eq(code, $author$project$Catalogue$Vocabulaire$codeProduit)) {
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{iy: $elm$core$Maybe$Nothing}),
									A2(
										$elm$core$Maybe$map,
										$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$DeProduit,
										A3($author$project$Components$Produits$StructureCatalogue$Valeurs$Update$produitAAjouter, toutes, ajoutee, depuis)));
							} else {
								return _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
							}
						}
					}
				}
			}
		} else {
			return _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$AjouterUnEtage = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$EtageNomme = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$ApercuDemande = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Effet$DemanderUnApercu = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$apercuDeLaReecriture = 'apercu-de-la-reecriture';
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$reglee = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		function (structure) {
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$pair(structure),
				A2($author$project$Components$Produits$StructureCatalogue$Typologies$Model$reglee, model.r6, structure.vk));
		},
		model.h$);
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$demander = F4(
	function (geste, titre, retour, model) {
		var _v0 = _Utils_Tuple2(
			model.l2,
			A2(
				$elm$core$Maybe$andThen,
				function (_v1) {
					var t = _v1.b;
					return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$apercuDeLaReecriture, t.nQ);
				},
				$author$project$Components$Produits$StructureCatalogue$Etages$Update$reglee(model)));
		if ((_v0.a.$ === 1) && (!_v0.b.$)) {
			var lien = _v0.b.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						q: $author$project$Components$Produits$StructureCatalogue$Etages$Model$ApercuDemande(
							{mW: geste, eC: false, qL: retour, h6: titre})
					}),
				_List_fromArray(
					[
						A2($author$project$Components$Produits$StructureCatalogue$Effet$DemanderUnApercu, lien, geste)
					]));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Shared$LibellesParLangue$View$idDuChamp = F2(
	function (prefixe, code) {
		return prefixe + ('-' + code);
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$prefixeDeLAjout = 'ajout-etage-libelle';
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$idDuLibelleDeLAjout = A2($author$project$Components$Shared$LibellesParLangue$View$idDuChamp, $author$project$Components$Produits$StructureCatalogue$Etages$Model$prefixeDeLAjout, 'fr');
var $author$project$Components$Produits$StructureCatalogue$Saisie$libellesSaisis = function (saisie) {
	return $author$project$Components$Produits$Common$LibellesSaisis$versLApi(saisie.R);
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$sansRefus = function (model) {
	return _Utils_update(
		model,
		{aL: $elm$core$Maybe$Nothing});
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$tentee = function (model) {
	var saisie = model.D;
	return _Utils_update(
		model,
		{
			D: _Utils_update(
				saisie,
				{b5: true})
		});
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$AjoutDe = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$titreDeLAjout = $author$project$Components$Produits$StructureCatalogue$Etages$Model$AjoutDe;
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$ajoutDemande = function (model) {
	var _v0 = _Utils_Tuple3(
		$author$project$Components$Shared$Drawer$Model$estOuvert(model.y),
		$author$project$Components$Produits$StructureCatalogue$Etages$Update$reglee(model),
		$author$project$Components$Produits$StructureCatalogue$Saisie$libellesSaisis(model.D));
	if (_v0.a && (!_v0.b.$)) {
		if (!_v0.c.$) {
			var _v1 = _v0.b.a;
			var typologie = _v1.b;
			var libelles = _v0.c.a;
			return A4(
				$author$project$Components$Produits$StructureCatalogue$Etages$Update$demander,
				A3(
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$AjouterUnEtage,
					typologie.Aq,
					A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$EtageNomme, libelles, $elm$core$Maybe$Nothing),
					$elm$core$Maybe$Nothing),
				$author$project$Components$Produits$StructureCatalogue$Etages$Model$titreDeLAjout(
					$author$project$I18n$Traductions$tel(libelles.zX)),
				$elm$core$Maybe$Nothing,
				$author$project$Components$Produits$StructureCatalogue$Etages$Update$sansRefus(model));
		} else {
			var _v2 = _v0.c;
			return _Utils_Tuple2(
				$author$project$Components$Produits$StructureCatalogue$Etages$Update$tentee(model),
				_List_fromArray(
					[
						$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus($author$project$Components$Produits$StructureCatalogue$Etages$Model$idDuLibelleDeLAjout)
					]));
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$AjouterUneTypologie = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Model$EnCours = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Effet$Envoyer = F3(
	function (a, b, c) {
		return {$: 9, a: a, b: b, c: c};
	});
var $author$project$API$NavLinksDictionary$ajouterUneValeur = 'ajouter-une-valeur';
var $author$project$API$NavLinksDictionary$creerUneListe = 'creer-une-liste';
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$estUneListeACreer = function (commande) {
	if (commande.$ === 12) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$estUneValeurDeListe = function (commande) {
	if (commande.$ === 13) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$lienDuPorteur = F3(
	function (portee, rel, informations) {
		if (portee.$ === 3) {
			return A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nQ;
					},
					$author$project$API$Liens$trouver(rel)),
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.F3;
						},
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$filter(
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.F$;
									},
									$elm$core$Basics$eq(portee))),
							$elm$core$List$head)),
					informations));
		} else {
			return A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nQ;
					},
					$author$project$API$Liens$trouver(rel)),
				informations);
		}
	});
var $author$project$API$NavLinksDictionary$activerUnNiveau = 'activer-un-niveau';
var $author$project$API$NavLinksDictionary$afficherUnChamp = 'afficher-un-champ';
var $author$project$API$NavLinksDictionary$afficherUneInformation = 'afficher-une-information';
var $author$project$API$NavLinksDictionary$ajouterUnNiveau = 'ajouter-un-niveau';
var $author$project$API$NavLinksDictionary$ajouterUneClassification = 'ajouter-une-classification';
var $author$project$API$NavLinksDictionary$ajouterUneInformation = 'ajouter-une-information';
var $author$project$API$NavLinksDictionary$ajouterUneInformationAUneCategorie = 'ajouter-une-information-a-une-categorie';
var $author$project$API$NavLinksDictionary$ajouterUneValeurALEtage = 'ajouter-une-valeur-a-l-etage';
var $author$project$API$NavLinksDictionary$archiverLaClassification = 'archiver-la-classification';
var $author$project$API$NavLinksDictionary$archiverUneValeur = 'archiver-une-valeur';
var $author$project$API$NavLinksDictionary$definirLeVerrouillage = 'definir-le-verrouillage';
var $author$project$API$NavLinksDictionary$definirLesArticlesLiesDUnChampHerite = 'definir-les-articles-lies-d-un-champ-herite';
var $author$project$API$NavLinksDictionary$definirLesEtats = 'definir-les-etats';
var $author$project$API$NavLinksDictionary$definirLesMinimaDUnChampFichier = 'definir-les-minima-d-un-champ-fichier';
var $author$project$API$NavLinksDictionary$definirLesMinimaDUnChampHerite = 'definir-les-minima-d-un-champ-herite';
var $author$project$API$NavLinksDictionary$deplacerUnNoeud = 'deplacer-un-noeud';
var $author$project$API$NavLinksDictionary$deplacerUneInformation = 'deplacer-une-information';
var $author$project$API$NavLinksDictionary$deplacerUneValeur = 'deplacer-une-valeur';
var $author$project$API$NavLinksDictionary$desactiverUnNiveau = 'desactiver-un-niveau';
var $author$project$API$NavLinksDictionary$faireEvoluerLeSchema = 'faire-evoluer-le-schema';
var $author$project$API$NavLinksDictionary$libellerUnNiveau = 'libeller-un-niveau';
var $author$project$API$NavLinksDictionary$masquerUnChamp = 'masquer-un-champ';
var $author$project$API$NavLinksDictionary$masquerUneInformation = 'masquer-une-information';
var $author$project$API$NavLinksDictionary$modifierUneInformation = 'modifier-une-information';
var $author$project$API$NavLinksDictionary$ordonnerLesChamps = 'ordonner-les-champs';
var $author$project$API$NavLinksDictionary$ordonnerLesInformations = 'ordonner-les-informations';
var $author$project$API$NavLinksDictionary$ordonnerLesNatures = 'ordonner-les-natures';
var $author$project$API$NavLinksDictionary$ordonnerLesNiveaux = 'ordonner-les-niveaux';
var $author$project$API$NavLinksDictionary$ordonnerLesNoeuds = 'ordonner-les-noeuds';
var $author$project$API$NavLinksDictionary$placerSousChaqueValeurDeLEtage = 'placer-sous-chaque-valeur-de-l-etage';
var $author$project$API$NavLinksDictionary$placerUnNoeud = 'placer-un-noeud';
var $author$project$API$NavLinksDictionary$rangerSousUnNoeud = 'ranger-sous-un-noeud';
var $author$project$API$NavLinksDictionary$rattacherUnChampExistant = 'rattacher-un-champ-existant';
var $author$project$API$NavLinksDictionary$rattacherUnChampExistantACategorie = 'rattacher-un-champ-existant-a-une-categorie';
var $author$project$API$NavLinksDictionary$reactiverLaClassification = 'reactiver-la-classification';
var $author$project$API$NavLinksDictionary$reactiverUneValeur = 'reactiver-une-valeur';
var $author$project$API$NavLinksDictionary$readmettreUneValeur = 'readmettre-une-valeur';
var $author$project$API$NavLinksDictionary$ajouterUnEtage = 'ajouter-un-etage';
var $author$project$API$NavLinksDictionary$reordonnerLesEtages = 'reordonner-les-etages';
var $author$project$API$NavLinksDictionary$retirerUnEtage = 'retirer-un-etage';
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$relDuGeste = function (geste) {
	switch (geste.$) {
		case 0:
			return $author$project$API$NavLinksDictionary$ajouterUnEtage;
		case 1:
			return $author$project$API$NavLinksDictionary$reordonnerLesEtages;
		default:
			return $author$project$API$NavLinksDictionary$retirerUnEtage;
	}
};
var $author$project$API$NavLinksDictionary$renommerUnEtage = 'renommer-un-etage';
var $author$project$API$NavLinksDictionary$renommerUneClassification = 'renommer-une-classification';
var $author$project$API$NavLinksDictionary$renommerUneNature = 'renommer-une-nature';
var $author$project$API$NavLinksDictionary$retablirLeLibelleDUnNiveau = 'retablir-le-libelle-d-un-niveau';
var $author$project$API$NavLinksDictionary$retirerUnNiveau = 'retirer-un-niveau';
var $author$project$API$NavLinksDictionary$retirerUnNoeud = 'retirer-un-noeud';
var $author$project$API$NavLinksDictionary$retirerUneTypologie = 'retirer-une-typologie';
var $author$project$API$NavLinksDictionary$supprimerUnChamp = 'supprimer-un-champ';
var $author$project$API$NavLinksDictionary$supprimerUneInformation = 'supprimer-une-information';
var $author$project$API$NavLinksDictionary$traduireUneValeur = 'traduire-une-valeur';
var $author$project$API$NavLinksDictionary$traiterLArchivage = 'traiter-l-archivage';
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$rel = function (commande) {
	switch (commande.$) {
		case 0:
			return $author$project$API$NavLinksDictionary$activerUnNiveau;
		case 1:
			return $author$project$API$NavLinksDictionary$desactiverUnNiveau;
		case 2:
			return $author$project$API$NavLinksDictionary$libellerUnNiveau;
		case 3:
			return $author$project$API$NavLinksDictionary$retablirLeLibelleDUnNiveau;
		case 4:
			return $author$project$API$NavLinksDictionary$ordonnerLesNiveaux;
		case 5:
			return $author$project$API$NavLinksDictionary$ajouterUnNiveau;
		case 6:
			return $author$project$API$NavLinksDictionary$retirerUnNiveau;
		case 7:
			return $author$project$API$NavLinksDictionary$definirLesEtats;
		case 8:
			return $author$project$API$NavLinksDictionary$definirLeVerrouillage;
		case 9:
			return $author$project$API$NavLinksDictionary$renommerUneNature;
		case 10:
			return $author$project$API$NavLinksDictionary$ordonnerLesNatures;
		case 11:
			return $author$project$API$NavLinksDictionary$ajouterUneClassification;
		case 12:
			return $author$project$API$NavLinksDictionary$creerUneListe;
		case 13:
			return $author$project$API$NavLinksDictionary$ajouterUneValeur;
		case 14:
			return $author$project$API$NavLinksDictionary$ajouterUneClassification;
		case 15:
			return $author$project$API$NavLinksDictionary$renommerUneClassification;
		case 16:
			return $author$project$API$NavLinksDictionary$retirerUneTypologie;
		case 17:
			return $author$project$API$NavLinksDictionary$reactiverLaClassification;
		case 18:
			return $author$project$API$NavLinksDictionary$archiverLaClassification;
		case 19:
			return $author$project$API$NavLinksDictionary$traiterLArchivage;
		case 20:
			return $author$project$API$NavLinksDictionary$ajouterUneValeur;
		case 21:
			return $author$project$API$NavLinksDictionary$deplacerUneValeur;
		case 22:
			return $author$project$API$NavLinksDictionary$traduireUneValeur;
		case 23:
			return $author$project$API$NavLinksDictionary$archiverUneValeur;
		case 24:
			return $author$project$API$NavLinksDictionary$reactiverUneValeur;
		case 25:
			return $author$project$API$NavLinksDictionary$renommerUnEtage;
		case 26:
			var geste = commande.a;
			return $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$relDuGeste(geste);
		case 27:
			return $author$project$API$NavLinksDictionary$placerUnNoeud;
		case 28:
			return $author$project$API$NavLinksDictionary$deplacerUnNoeud;
		case 29:
			return $author$project$API$NavLinksDictionary$ordonnerLesNoeuds;
		case 30:
			return $author$project$API$NavLinksDictionary$rangerSousUnNoeud;
		case 31:
			return $author$project$API$NavLinksDictionary$ajouterUneValeurALEtage;
		case 32:
			return $author$project$API$NavLinksDictionary$placerSousChaqueValeurDeLEtage;
		case 33:
			return $author$project$API$NavLinksDictionary$retirerUnNoeud;
		case 34:
			return $author$project$API$NavLinksDictionary$readmettreUneValeur;
		case 35:
			if (commande.a.$ === 3) {
				return $author$project$API$NavLinksDictionary$ajouterUneInformationAUneCategorie;
			} else {
				return $author$project$API$NavLinksDictionary$ajouterUneInformation;
			}
		case 36:
			if (commande.a.$ === 3) {
				return $author$project$API$NavLinksDictionary$rattacherUnChampExistantACategorie;
			} else {
				return $author$project$API$NavLinksDictionary$rattacherUnChampExistant;
			}
		case 37:
			if (commande.a.$ === 3) {
				return $author$project$API$NavLinksDictionary$faireEvoluerLeSchema;
			} else {
				return $author$project$API$NavLinksDictionary$modifierUneInformation;
			}
		case 38:
			if (commande.a.$ === 3) {
				return $author$project$API$NavLinksDictionary$masquerUnChamp;
			} else {
				return $author$project$API$NavLinksDictionary$masquerUneInformation;
			}
		case 39:
			if (commande.a.$ === 3) {
				return $author$project$API$NavLinksDictionary$afficherUnChamp;
			} else {
				return $author$project$API$NavLinksDictionary$afficherUneInformation;
			}
		case 40:
			if (commande.a.$ === 3) {
				return $author$project$API$NavLinksDictionary$supprimerUnChamp;
			} else {
				return $author$project$API$NavLinksDictionary$supprimerUneInformation;
			}
		case 41:
			return $author$project$API$NavLinksDictionary$deplacerUneInformation;
		case 42:
			if (commande.a.$ === 3) {
				return $author$project$API$NavLinksDictionary$ordonnerLesChamps;
			} else {
				return $author$project$API$NavLinksDictionary$ordonnerLesInformations;
			}
		case 43:
			if (commande.a.$ === 3) {
				return $author$project$API$NavLinksDictionary$definirLesMinimaDUnChampFichier;
			} else {
				return $author$project$API$NavLinksDictionary$definirLesMinimaDUnChampHerite;
			}
		default:
			return $author$project$API$NavLinksDictionary$definirLesArticlesLiesDUnChampHerite;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$trouvee = F3(
	function (portee, cle, informations) {
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.dw;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$filter(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.uN;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.dy;
								},
								$elm$core$Basics$eq(cle)))),
					$elm$core$List$head)),
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.F3;
					},
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$filter(
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.F$;
								},
								$elm$core$Basics$eq(portee))),
						$elm$core$List$head)),
				informations));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$lienDe = F2(
	function (informations, commande) {
		var racine = function (portee) {
			return A3(
				$author$project$Components$Produits$StructureCatalogue$Informations$Model$lienDuPorteur,
				portee,
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$rel(commande),
				informations);
		};
		var duChamp = F2(
			function (portee, cle) {
				return A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.nQ;
						},
						$author$project$API$Liens$trouver(
							$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$rel(commande))),
					A3($author$project$Components$Produits$StructureCatalogue$Informations$Model$trouvee, portee, cle, informations));
			});
		switch (commande.$) {
			case 35:
				var portee = commande.a;
				return racine(portee);
			case 36:
				var portee = commande.a;
				return racine(portee);
			case 37:
				var portee = commande.a;
				return racine(portee);
			case 42:
				var portee = commande.a;
				return racine(portee);
			case 38:
				var portee = commande.a;
				var cle = commande.b;
				return A2(duChamp, portee, cle);
			case 39:
				var portee = commande.a;
				var cle = commande.b;
				return A2(duChamp, portee, cle);
			case 40:
				var portee = commande.a;
				var cle = commande.b;
				return A2(duChamp, portee, cle);
			case 41:
				var portee = commande.a;
				var cle = commande.b;
				return A2(duChamp, portee, cle);
			case 43:
				var portee = commande.a;
				var cle = commande.b;
				return A2(duChamp, portee, cle);
			case 44:
				var portee = commande.a;
				var cle = commande.b;
				return A2(duChamp, portee, cle);
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Model$lienDe = F2(
	function (structure, commande) {
		var duNoeud = F2(
			function (classification, id) {
				return A2(
					$author$project$API$Liens$trouver,
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$rel(commande),
					A2(
						$elm$core$List$concatMap,
						function ($) {
							return $.nQ;
						},
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(id)),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.Di;
									},
									A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$classificationDe, classification, structure.vk))))));
			});
		var duNiveau = function (id) {
			return A2(
				$author$project$API$Liens$trouver,
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$rel(commande),
				A2(
					$elm$core$List$concatMap,
					function ($) {
						return $.nQ;
					},
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(id)),
						structure.C9)));
		};
		var deLaValeur = F2(
			function (classification, id) {
				return A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.nQ;
						},
						$author$project$API$Liens$trouver(
							$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$rel(commande))),
					A2(
						$elm$core$Maybe$andThen,
						$author$project$Components$Produits$StructureCatalogue$Classifications$Model$valeurDe(id),
						A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$classificationDe, classification, structure.vk)));
			});
		var deLaClassification = function (id) {
			return A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nQ;
					},
					$author$project$API$Liens$trouver(
						$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$rel(commande))),
				A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$classificationDe, id, structure.vk));
		};
		var deLEtage = F2(
			function (classification, id) {
				return A2(
					$author$project$API$Liens$trouver,
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$rel(commande),
					A2(
						$elm$core$List$concatMap,
						function ($) {
							return $.nQ;
						},
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(id)),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.yG;
									},
									A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$classificationDe, classification, structure.vk))))));
			});
		switch (commande.$) {
			case 0:
				var id = commande.a;
				return duNiveau(id);
			case 1:
				var id = commande.a;
				return duNiveau(id);
			case 2:
				var id = commande.a;
				return duNiveau(id);
			case 3:
				var id = commande.a;
				return duNiveau(id);
			case 6:
				var id = commande.a;
				return duNiveau(id);
			case 4:
				return A2(
					$author$project$API$Liens$trouver,
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$rel(commande),
					structure.nQ);
			case 5:
				return A2(
					$author$project$API$Liens$trouver,
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$rel(commande),
					structure.nQ);
			case 7:
				return A2(
					$author$project$API$Liens$trouver,
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$rel(commande),
					structure.nQ);
			case 8:
				return A2(
					$author$project$API$Liens$trouver,
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$rel(commande),
					structure.nQ);
			case 9:
				return A2(
					$author$project$API$Liens$trouver,
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$rel(commande),
					structure.nQ);
			case 10:
				return A2(
					$author$project$API$Liens$trouver,
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$rel(commande),
					structure.nQ);
			case 11:
				return A2(
					$author$project$API$Liens$trouver,
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$rel(commande),
					structure.nQ);
			case 12:
				return $elm$core$Maybe$Nothing;
			case 13:
				return $elm$core$Maybe$Nothing;
			case 14:
				return A2(
					$author$project$API$Liens$trouver,
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$rel(commande),
					structure.nQ);
			case 15:
				var classification = commande.a;
				return deLaClassification(classification);
			case 16:
				var classification = commande.a;
				return deLaClassification(classification);
			case 17:
				var classification = commande.a;
				return deLaClassification(classification);
			case 18:
				var classification = commande.a;
				return deLaClassification(classification);
			case 19:
				var classification = commande.a;
				return deLaClassification(classification);
			case 20:
				var classification = commande.a;
				return deLaClassification(classification);
			case 21:
				var classification = commande.a;
				var place = commande.b;
				return A2(deLaValeur, classification, place.fm);
			case 22:
				var classification = commande.a;
				var valeur = commande.b;
				return A2(deLaValeur, classification, valeur);
			case 23:
				var classification = commande.a;
				var valeur = commande.b;
				return A2(deLaValeur, classification, valeur);
			case 24:
				var classification = commande.a;
				var valeur = commande.b;
				return A2(deLaValeur, classification, valeur);
			case 25:
				var typologie = commande.a;
				var etage = commande.b;
				return A2(deLEtage, typologie, etage);
			case 26:
				if (commande.a.$ === 2) {
					var _v1 = commande.a;
					var typologie = _v1.a;
					var etage = _v1.b;
					return A2(deLEtage, typologie, etage);
				} else {
					var geste = commande.a;
					return deLaClassification(
						$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$classificationDuGeste(geste));
				}
			case 27:
				var typologie = commande.a;
				var place = commande.b;
				return A2(deLEtage, typologie, place.md);
			case 28:
				var typologie = commande.a;
				var noeud = commande.b;
				return A2(duNoeud, typologie, noeud);
			case 29:
				var typologie = commande.a;
				return deLaClassification(typologie);
			case 30:
				var typologie = commande.a;
				var noeud = commande.b;
				return A2(duNoeud, typologie, noeud);
			case 31:
				var typologie = commande.a;
				var ajout = commande.b;
				return A2(deLEtage, typologie, ajout.md);
			case 32:
				var typologie = commande.a;
				var etage = commande.b;
				return A2(deLEtage, typologie, etage);
			case 33:
				var typologie = commande.a;
				var noeud = commande.b;
				return A2(duNoeud, typologie, noeud);
			case 34:
				var typologie = commande.a;
				var lue = commande.b;
				return A2(
					$author$project$API$Liens$trouver,
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$rel(commande),
					A2(
						$elm$core$List$concatMap,
						function ($) {
							return $.nQ;
						},
						A2(
							$elm$core$List$filter,
							function (exclusion) {
								return _Utils_eq(exclusion.F$, lue.F$) && _Utils_eq(exclusion.ey, lue.ey);
							},
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.yX;
									},
									A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$classificationDe, typologie, structure.vk))))));
			case 35:
				return $elm$core$Maybe$Nothing;
			case 36:
				return $elm$core$Maybe$Nothing;
			case 37:
				return $elm$core$Maybe$Nothing;
			case 38:
				return $elm$core$Maybe$Nothing;
			case 39:
				return $elm$core$Maybe$Nothing;
			case 40:
				return $elm$core$Maybe$Nothing;
			case 41:
				return $elm$core$Maybe$Nothing;
			case 42:
				return $elm$core$Maybe$Nothing;
			case 43:
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Commandes$lienDe = F2(
	function (commande, model) {
		return $author$project$Components$Produits$StructureCatalogue$Informations$Model$estUneListeACreer(commande) ? A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUneListe, model.nS) : ($author$project$Components$Produits$StructureCatalogue$Informations$Model$estUneValeurDeListe(commande) ? A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ajouterUneValeur, model.BO) : ($author$project$Components$Produits$StructureCatalogue$Informations$Model$estUneCommande(commande) ? A2($author$project$Components$Produits$StructureCatalogue$Informations$Model$lienDe, model.AM, commande) : A2(
			$elm$core$Maybe$andThen,
			function (structure) {
				return A2($author$project$Components$Produits$StructureCatalogue$Model$lienDe, structure, commande);
			},
			model.h$)));
	});
var $author$project$Components$Produits$StructureCatalogue$Commandes$envoyer = F2(
	function (commande, model) {
		var _v0 = _Utils_Tuple2(
			model.l2,
			A2($author$project$Components$Produits$StructureCatalogue$Commandes$lienDe, commande, model));
		if ((_v0.a.$ === 1) && (!_v0.b.$)) {
			var processUid = _v0.a.a;
			var lien = _v0.b.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: A2($author$project$Components$Produits$StructureCatalogue$Model$EnCours, processUid, commande)
					}),
				_List_fromArray(
					[
						A3($author$project$Components$Produits$StructureCatalogue$Effet$Envoyer, lien, processUid, commande)
					]));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$formesSaisiesDes = function (grammaire) {
	return {
		yg: A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$Produits$StructureCatalogue$Etages$Model$formeVide,
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.yg;
				},
				grammaire)),
		zX: A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$Produits$StructureCatalogue$Etages$Model$formeVide,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.zX;
				},
				grammaire))
	};
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$formesEcrites = F3(
	function (servies, libelles, saisies) {
		return _Utils_eq(
			saisies,
			$author$project$Components$Produits$StructureCatalogue$Etages$Model$formesSaisiesDes(servies)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			{
				yg: _Utils_eq(libelles.yg, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(saisies.yg),
				zX: saisies.zX
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Typologies$Model$prefixeDeLAjout = 'ajout-typologie-libelle';
var $author$project$Components$Produits$StructureCatalogue$Typologies$Model$idDuLibelleDeLAjout = A2($author$project$Components$Shared$LibellesParLangue$View$idDuChamp, $author$project$Components$Produits$StructureCatalogue$Typologies$Model$prefixeDeLAjout, 'fr');
var $author$project$Components$Produits$StructureCatalogue$Typologies$Update$sansRefus = function (model) {
	return _Utils_update(
		model,
		{aL: $elm$core$Maybe$Nothing});
};
var $author$project$Components$Produits$StructureCatalogue$Typologies$Update$tentee = function (model) {
	var saisie = model.qU;
	return _Utils_update(
		model,
		{
			qU: _Utils_update(
				saisie,
				{b5: true})
		});
};
var $author$project$Components$Produits$StructureCatalogue$Typologies$Update$ajoutDemande = function (model) {
	if (!$author$project$Components$Shared$Drawer$Model$estOuvert(model.iG)) {
		return _Utils_Tuple2(model, _List_Nil);
	} else {
		var _v0 = $author$project$Components$Produits$StructureCatalogue$Saisie$libellesSaisis(model.qU);
		if (!_v0.$) {
			var libelles = _v0.a;
			return A2(
				$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
				A2(
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$AjouterUneTypologie,
					libelles,
					A3($author$project$Components$Produits$StructureCatalogue$Etages$Model$formesEcrites, $elm$core$Maybe$Nothing, libelles, model.mQ)),
				$author$project$Components$Produits$StructureCatalogue$Typologies$Update$sansRefus(
					$author$project$Components$Produits$StructureCatalogue$Typologies$Update$tentee(model)));
		} else {
			return _Utils_Tuple2(
				$author$project$Components$Produits$StructureCatalogue$Typologies$Update$tentee(model),
				_List_fromArray(
					[
						$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus($author$project$Components$Produits$StructureCatalogue$Typologies$Model$idDuLibelleDeLAjout)
					]));
		}
	}
};
var $author$project$Components$Shared$Drawer$Update$Ouvrir = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$auRangement = function (id) {
	return id + '-au-rangement';
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$auRangementSiOuvert = F2(
	function (model, identifiant) {
		return $author$project$Components$Shared$Drawer$Model$estOuvert(model.bZ) ? $author$project$Components$Produits$StructureCatalogue$Etages$Model$auRangement(identifiant) : identifiant;
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$idDeLOuverture = function (proposition) {
	if (!proposition) {
		return 'etage-ouvrir-collection';
	} else {
		return 'etage-ouvrir-un-autre';
	}
};
var $author$project$I18n$Textes$produitsStructureAjoutCollection = A3($author$project$I18n$Traductions$texte, 'produits.structure.ajout.collection', _List_Nil, 'Collection');
var $author$project$I18n$Textes$produitsStructureAjoutCollectionAnglais = A3($author$project$I18n$Traductions$texte, 'produits.structure.ajout.collection.anglais', _List_Nil, 'Collection');
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$nomPropose = function (proposition) {
	if (!proposition) {
		return _Utils_Tuple2(
			$author$project$Components$Produits$StructureCatalogue$Saisie$parDefaut($author$project$I18n$Textes$produitsStructureAjoutCollection),
			$author$project$Components$Produits$StructureCatalogue$Saisie$parDefaut($author$project$I18n$Textes$produitsStructureAjoutCollectionAnglais));
	} else {
		return _Utils_Tuple2('', '');
	}
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$ferme = function (model) {
	var refermer = function (drawer) {
		return _Utils_update(
			drawer,
			{wQ: $elm$core$Maybe$Nothing, gt: 0});
	};
	return _Utils_update(
		model,
		{
			y: refermer(model.y),
			gr: $elm$core$Maybe$Nothing,
			I: $author$project$Components$Produits$StructureCatalogue$Etages$Model$sansFormes,
			g8: $author$project$Components$Produits$StructureCatalogue$Saisie$vide,
			aL: $elm$core$Maybe$Nothing,
			bg: refermer(model.bg),
			D: $author$project$Components$Produits$StructureCatalogue$Saisie$vide
		});
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$sansSaisie = function (model) {
	return ($author$project$Components$Shared$Drawer$Model$estOuvert(model.y) || $author$project$Components$Shared$Drawer$Model$estOuvert(model.bg)) ? $author$project$Components$Produits$StructureCatalogue$Etages$Update$ferme(model) : model;
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$versLAjout = F2(
	function (geste, model) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{
				Il: !_Utils_eq(model.D.R, model.g8.R)
			},
			geste,
			model.y);
		var drawer = _v0.a;
		var effets = _v0.b;
		var suivi = _Utils_update(
			model,
			{y: drawer});
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? suivi : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.y) ? $author$project$Components$Produits$StructureCatalogue$Etages$Update$ferme(
				_Utils_update(
					suivi,
					{q: $author$project$Components$Produits$StructureCatalogue$Etages$Model$SansReecriture})) : $author$project$Components$Produits$StructureCatalogue$Etages$Update$ferme(suivi)),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$ajoutOuvert = F2(
	function (proposition, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (_v1) {
				var t = _v1.b;
				return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ajouterUnEtage, t.nQ);
			},
			$author$project$Components$Produits$StructureCatalogue$Etages$Update$reglee(model));
		if (!_v0.$) {
			var _v2 = $author$project$Components$Produits$StructureCatalogue$Etages$Model$nomPropose(proposition);
			var fr = _v2.a;
			var en = _v2.b;
			var propose = $author$project$Components$Produits$StructureCatalogue$Saisie$affichee(
				{yg: en, zX: fr});
			return A2(
				$author$project$Components$Produits$StructureCatalogue$Etages$Update$versLAjout,
				$author$project$Components$Shared$Drawer$Update$Ouvrir(
					A2(
						$author$project$Components$Produits$StructureCatalogue$Etages$Update$auRangementSiOuvert,
						model,
						$author$project$Components$Produits$StructureCatalogue$Etages$Model$idDeLOuverture(proposition))),
				function (clos) {
					return _Utils_update(
						clos,
						{g8: propose, D: propose});
				}(
					$author$project$Components$Produits$StructureCatalogue$Etages$Update$sansSaisie(model)));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Etats$Update$definissable = function (model) {
	return !_Utils_eq(
		$elm$core$Maybe$Nothing,
		A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$definirLesEtats)),
			model.h$));
};
var $author$project$Components$Produits$StructureCatalogue$Etats$Model$idDeLOuvertureDeLAjout = 'ajout-etat-ouvrir';
var $author$project$Components$Produits$StructureCatalogue$Etats$Update$sansAjout = function (model) {
	var drawer = model.br;
	return _Utils_update(
		model,
		{
			br: _Utils_update(
				drawer,
				{wQ: $elm$core$Maybe$Nothing, gt: 0}),
			a9: $author$project$Components$Produits$StructureCatalogue$Saisie$vide,
			aL: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? $elm$core$Maybe$Nothing : model.aL
		});
};
var $author$project$Components$Produits$StructureCatalogue$Etats$Update$versLAjout = F2(
	function (geste, model) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{
				Il: !_Utils_eq(model.a9.R, $author$project$Components$Produits$StructureCatalogue$Saisie$vide.R)
			},
			geste,
			model.br);
		var drawer = _v0.a;
		var effets = _v0.b;
		var suivi = _Utils_update(
			model,
			{br: drawer});
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? suivi : $author$project$Components$Produits$StructureCatalogue$Etats$Update$sansAjout(suivi),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Produits$StructureCatalogue$Etats$Update$ajoutOuvert = function (model) {
	return $author$project$Components$Produits$StructureCatalogue$Etats$Update$definissable(model) ? A2(
		$author$project$Components$Produits$StructureCatalogue$Etats$Update$versLAjout,
		$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Produits$StructureCatalogue$Etats$Model$idDeLOuvertureDeLAjout),
		_Utils_update(
			model,
			{a9: $author$project$Components$Produits$StructureCatalogue$Saisie$vide, aL: $elm$core$Maybe$Nothing})) : _Utils_Tuple2(model, _List_Nil);
};
var $author$project$API$NavLinksDictionary$creerEtRattacherUnChamp = 'creer-et-rattacher-un-champ';
var $author$project$API$NavLinksDictionary$creerEtRattacherUnChampACategorie = 'creer-et-rattacher-un-champ-a-une-categorie';
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$lienDeCreation = F2(
	function (portee, informations) {
		return A3(
			$author$project$Components$Produits$StructureCatalogue$Informations$Model$lienDuPorteur,
			portee,
			function () {
				if (portee.$ === 3) {
					return $author$project$API$NavLinksDictionary$creerEtRattacherUnChampACategorie;
				} else {
					return $author$project$API$NavLinksDictionary$creerEtRattacherUnChamp;
				}
			}(),
			informations);
	});
var $author$project$Components$Produits$StructureCatalogue$Effet$LireLaBibliotheque = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$lireLaBibliotheque = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Effet$LireLaBibliotheque, $elm$core$List$singleton),
			model.nC));
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$ajoutOuvert = F2(
	function (portee, model) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$Components$Produits$StructureCatalogue$Informations$Model$lienDeCreation, portee, model.AM),
			model.nC);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						oQ: $elm$core$Maybe$Just(portee),
						oR: true
					}),
				$author$project$Components$Produits$StructureCatalogue$Informations$Update$lireLaBibliotheque(model));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Typologies$Update$ferme = function (model) {
	var refermer = function (drawer) {
		return _Utils_update(
			drawer,
			{wQ: $elm$core$Maybe$Nothing, gt: 0});
	};
	return _Utils_update(
		model,
		{
			iG: refermer(model.iG),
			mQ: $author$project$Components$Produits$StructureCatalogue$Etages$Model$sansFormes,
			aL: $elm$core$Maybe$Nothing,
			qo: refermer(model.qo),
			qM: refermer(model.qM),
			qU: $author$project$Components$Produits$StructureCatalogue$Saisie$vide,
			r4: $elm$core$Maybe$Nothing,
			r5: $elm$core$Maybe$Nothing
		});
};
var $author$project$Components$Produits$StructureCatalogue$Typologies$Update$aucunDrawer = function (model) {
	return ($author$project$Components$Shared$Drawer$Model$estOuvert(model.iG) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.qo) || $author$project$Components$Shared$Drawer$Model$estOuvert(model.qM))) ? $author$project$Components$Produits$StructureCatalogue$Typologies$Update$ferme(model) : model;
};
var $author$project$Components$Produits$StructureCatalogue$Typologies$Model$idDuBoutonAjouter = 'typologie-ajouter';
var $author$project$Components$Produits$StructureCatalogue$Typologies$Update$versLAjout = F2(
	function (geste, model) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{
				Il: (!_Utils_eq(model.qU.R, $author$project$Components$Produits$StructureCatalogue$Saisie$vide.R)) || (!_Utils_eq(model.mQ, $author$project$Components$Produits$StructureCatalogue$Etages$Model$sansFormes))
			},
			geste,
			model.iG);
		var drawer = _v0.a;
		var effets = _v0.b;
		var suivi = _Utils_update(
			model,
			{iG: drawer});
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? suivi : $author$project$Components$Produits$StructureCatalogue$Typologies$Update$ferme(suivi),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Produits$StructureCatalogue$Typologies$Update$ajoutOuvert = function (model) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.nQ;
			},
			$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$ajouterUneClassification)),
		model.h$);
	if (!_v0.$) {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Typologies$Update$versLAjout,
			$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Produits$StructureCatalogue$Typologies$Model$idDuBoutonAjouter),
			function (clos) {
				return _Utils_update(
					clos,
					{qU: $author$project$Components$Produits$StructureCatalogue$Saisie$vide});
			}(
				$author$project$Components$Produits$StructureCatalogue$Typologies$Update$aucunDrawer(model)));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Update$puis = F2(
	function (suivant, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Basics$append(effets),
			suivant(model));
	});
var $author$project$Components$Produits$StructureCatalogue$Commandes$enchainer = F2(
	function (commandes, model) {
		var _v0 = _Utils_Tuple3(commandes, model.l2, model.cd);
		if ((_v0.a.b && (_v0.b.$ === 1)) && (!_v0.c.b)) {
			var _v1 = _v0.a;
			var premiere = _v1.a;
			var suivantes = _v1.b;
			var _v2 = A2($author$project$Components$Produits$StructureCatalogue$Commandes$envoyer, premiere, model);
			if (!_v2.b.b) {
				var partie = _v2.a;
				return _Utils_Tuple2(partie, _List_Nil);
			} else {
				var partie = _v2.a;
				var effets = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						partie,
						{cd: suivantes}),
					effets);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$relancer = function (model) {
	var _v0 = _Utils_Tuple2(model.l2, model.cd);
	if ((_v0.a.$ === 1) && _v0.b.b) {
		var commandes = _v0.b;
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Commandes$enchainer,
			commandes,
			_Utils_update(
				model,
				{cd: _List_Nil}));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Update$rendreLeFocusAttendu = function (_v0) {
	var model = _v0.a;
	var effets = _v0.b;
	return ((!model.Hv) && (!_Utils_eq(model.l2, $author$project$Components$Produits$StructureCatalogue$Model$SansProcessUid))) ? _Utils_Tuple2(
		_Utils_update(
			model,
			{mL: _List_Nil}),
		_Utils_ap(
			effets,
			A2($elm$core$List$map, $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus, model.mL))) : _Utils_Tuple2(model, effets);
};
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Update$quitte = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.Aq;
		},
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.hP;
					},
					function ($) {
						return $.eJ;
					}),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.C9;
						},
						model.h$)))));
};
var $author$project$Components$Produits$StructureCatalogue$Etats$Update$quitteSansPartir = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.vx;
		},
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.hP;
					},
					function ($) {
						return $.eJ;
					}),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.mj;
						},
						model.h$)))));
};
var $author$project$Components$Produits$StructureCatalogue$Etats$Update$etatDe = F2(
	function (code, model) {
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.mj;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$filter(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.vx;
							},
							$elm$core$Basics$eq(code))),
					$elm$core$List$head)),
			model.h$);
	});
var $author$project$Components$Produits$StructureCatalogue$Etats$Update$aRenommer = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		function (code) {
			return A2($author$project$Components$Produits$StructureCatalogue$Etats$Update$etatDe, code, model);
		},
		model.dT);
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$DefinirLesEtats = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Etats$Model$etatsADefinir = $elm$core$List$map(
	function (etat) {
		return {
			vx: $elm$core$Maybe$Just(etat.vx),
			R: etat.R
		};
	});
var $author$project$Components$Produits$StructureCatalogue$Etats$Update$definir = F2(
	function (changer, model) {
		var _v0 = model.h$;
		if (!_v0.$) {
			var structure = _v0.a;
			return _Utils_eq(
				changer(structure.mj),
				structure.mj) ? _Utils_Tuple2(model, _List_Nil) : A2(
				$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$DefinirLesEtats(
					$author$project$Components$Produits$StructureCatalogue$Etats$Model$etatsADefinir(
						changer(structure.mj))),
				model);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Etats$Model$prefixeDuRenommage = 'renommage-etat-libelle';
var $author$project$Components$Produits$StructureCatalogue$Etats$Model$idDuLibelleDuRenommage = A2($author$project$Components$Shared$LibellesParLangue$View$idDuChamp, $author$project$Components$Produits$StructureCatalogue$Etats$Model$prefixeDuRenommage, 'fr');
var $author$project$Components$Produits$StructureCatalogue$Etats$Update$surLEtat = F3(
	function (code, modifier, model) {
		return _Utils_update(
			model,
			{
				h$: A2(
					$elm$core$Maybe$map,
					function (structure) {
						return _Utils_update(
							structure,
							{
								mj: A2(
									$elm$core$List$map,
									function (etat) {
										return _Utils_eq(etat.vx, code) ? modifier(etat) : etat;
									},
									structure.mj)
							});
					},
					model.h$)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Etats$Update$saisirSurLEtat = F2(
	function (code, saisir) {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Etats$Update$surLEtat,
			code,
			function (etat) {
				return _Utils_update(
					etat,
					{
						hP: saisir(etat.hP)
					});
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Commandes$sinonPlusTard = F2(
	function (retenir, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		return $elm$core$List$isEmpty(effets) ? _Utils_Tuple2(
			retenir(model),
			_List_Nil) : _Utils_Tuple2(model, effets);
	});
var $author$project$Components$Produits$StructureCatalogue$Etats$Update$sansRenommage = function (model) {
	var remise = A2(
		$elm$core$Maybe$withDefault,
		model,
		A2(
			$elm$core$Maybe$map,
			function (code) {
				return A3(
					$author$project$Components$Produits$StructureCatalogue$Etats$Update$surLEtat,
					code,
					function (etat) {
						return _Utils_update(
							etat,
							{
								hP: $author$project$Components$Produits$StructureCatalogue$Etats$Model$saisieDeLEtat(etat)
							});
					},
					model);
			},
			model.dT));
	var drawer = remise.c5;
	return _Utils_update(
		remise,
		{
			dT: $elm$core$Maybe$Nothing,
			aL: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? $elm$core$Maybe$Nothing : remise.aL,
			c5: _Utils_update(
				drawer,
				{wQ: $elm$core$Maybe$Nothing, gt: 0})
		});
};
var $author$project$Components$Produits$StructureCatalogue$Etats$Update$versLeRenommage = F2(
	function (geste, model) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{
				Il: A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$author$project$Components$Produits$StructureCatalogue$Etats$Model$etatModifie,
						$author$project$Components$Produits$StructureCatalogue$Etats$Update$aRenommer(model)))
			},
			geste,
			model.c5);
		var drawer = _v0.a;
		var effets = _v0.b;
		var suivi = _Utils_update(
			model,
			{c5: drawer});
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? suivi : $author$project$Components$Produits$StructureCatalogue$Etats$Update$sansRenommage(suivi),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Produits$StructureCatalogue$Etats$Update$renommageDemande = function (model) {
	var _v0 = A2(
		$elm$core$Maybe$map,
		function (etat) {
			return _Utils_Tuple2(
				etat.vx,
				$author$project$Components$Produits$StructureCatalogue$Etats$Model$renommageDeLEtat(etat));
		},
		$author$project$Components$Produits$StructureCatalogue$Etats$Update$aRenommer(model));
	if (!_v0.$) {
		switch (_v0.a.b.$) {
			case 2:
				var _v1 = _v0.a;
				var code = _v1.a;
				var libelles = _v1.b.a;
				return A2(
					$author$project$Components$Produits$StructureCatalogue$Commandes$sinonPlusTard,
					A2(
						$author$project$Components$Produits$StructureCatalogue$Etats$Update$saisirSurLEtat,
						code,
						function (saisie) {
							return _Utils_update(
								saisie,
								{eJ: true});
						}),
					A2(
						$author$project$Components$Produits$StructureCatalogue$Etats$Update$definir,
						$elm$core$List$map(
							function (etat) {
								return _Utils_eq(etat.vx, code) ? _Utils_update(
									etat,
									{
										R: $elm$core$Maybe$Just(libelles)
									}) : etat;
							}),
						A3(
							$author$project$Components$Produits$StructureCatalogue$Etats$Update$saisirSurLEtat,
							code,
							function (saisie) {
								return _Utils_update(
									saisie,
									{eJ: false});
							},
							_Utils_update(
								model,
								{aL: $elm$core$Maybe$Nothing}))));
			case 1:
				var _v2 = _v0.a;
				var code = _v2.a;
				var _v3 = _v2.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Components$Produits$StructureCatalogue$Etats$Update$saisirSurLEtat,
						code,
						function (saisie) {
							return _Utils_update(
								saisie,
								{eJ: false, b5: true});
						},
						model),
					_List_fromArray(
						[
							$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus($author$project$Components$Produits$StructureCatalogue$Etats$Model$idDuLibelleDuRenommage)
						]));
			default:
				var _v4 = _v0.a;
				var _v5 = _v4.b;
				return A2($author$project$Components$Produits$StructureCatalogue$Etats$Update$versLeRenommage, $author$project$Components$Shared$Drawer$Update$Fermer, model);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$LibellerUnNiveau = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Update$niveauDe = F2(
	function (id, model) {
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.C9;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$filter(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(id))),
					$elm$core$List$head)),
			model.h$);
	});
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Update$aRenommer = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		function (id) {
			return A2($author$project$Components$Produits$StructureCatalogue$Niveaux$Update$niveauDe, id, model);
		},
		model.iA);
};
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Update$formesAEnvoyer = F3(
	function (niveau, libelles, model) {
		return A3($author$project$Components$Produits$StructureCatalogue$Etages$Model$formesEcrites, niveau.m$, libelles, model.mP);
	});
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Model$prefixeDuRenommage = 'renommage-libelle';
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Model$idDuLibelleDuRenommage = A2($author$project$Components$Shared$LibellesParLangue$View$idDuChamp, $author$project$Components$Produits$StructureCatalogue$Niveaux$Model$prefixeDuRenommage, 'fr');
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Update$surLeNiveau = F3(
	function (id, modifier, model) {
		return _Utils_update(
			model,
			{
				h$: A2(
					$elm$core$Maybe$map,
					A2($author$project$Components$Produits$StructureCatalogue$Model$surLeNiveau, id, modifier),
					model.h$)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Update$saisirSurLeNiveau = F2(
	function (id, saisir) {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Niveaux$Update$surLeNiveau,
			id,
			function (niveau) {
				return _Utils_update(
					niveau,
					{
						hP: saisir(niveau.hP)
					});
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Update$sansRefus = function (model) {
	return _Utils_update(
		model,
		{aL: $elm$core$Maybe$Nothing});
};
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Update$modifie = F2(
	function (model, niveau) {
		return $author$project$Components$Produits$StructureCatalogue$Niveaux$Model$modifie(niveau) || (!_Utils_eq(
			model.mP,
			$author$project$Components$Produits$StructureCatalogue$Etages$Model$formesSaisiesDes(niveau.m$)));
	});
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Update$sansRenommage = function (model) {
	var sansSaisie = function (niveau) {
		return _Utils_update(
			niveau,
			{
				hP: $author$project$Components$Produits$StructureCatalogue$Niveaux$Model$saisieDuNiveau(niveau)
			});
	};
	var remise = A2(
		$elm$core$Maybe$withDefault,
		model,
		A2(
			$elm$core$Maybe$map,
			function (id) {
				return A3($author$project$Components$Produits$StructureCatalogue$Niveaux$Update$surLeNiveau, id, sansSaisie, model);
			},
			model.iA));
	var drawer = remise.hL;
	return _Utils_update(
		remise,
		{
			iA: $elm$core$Maybe$Nothing,
			mP: $author$project$Components$Produits$StructureCatalogue$Etages$Model$sansFormes,
			aL: $elm$core$Maybe$Nothing,
			hL: _Utils_update(
				drawer,
				{wQ: $elm$core$Maybe$Nothing, gt: 0})
		});
};
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Update$versLeRenommage = F2(
	function (geste, model) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{
				Il: A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$author$project$Components$Produits$StructureCatalogue$Niveaux$Update$modifie(model),
						$author$project$Components$Produits$StructureCatalogue$Niveaux$Update$aRenommer(model)))
			},
			geste,
			model.hL);
		var drawer = _v0.a;
		var effets = _v0.b;
		var suivi = _Utils_update(
			model,
			{hL: drawer});
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? suivi : $author$project$Components$Produits$StructureCatalogue$Niveaux$Update$sansRenommage(suivi),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Update$renommageDemande = function (model) {
	var _v0 = A2(
		$elm$core$Maybe$map,
		function (niveau) {
			return _Utils_Tuple2(
				niveau.Aq,
				$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$renommage(niveau));
		},
		$author$project$Components$Produits$StructureCatalogue$Niveaux$Update$aRenommer(model));
	if (!_v0.$) {
		switch (_v0.a.b.$) {
			case 2:
				var _v1 = _v0.a;
				var id = _v1.a;
				var libelles = _v1.b.a;
				return A2(
					$author$project$Components$Produits$StructureCatalogue$Commandes$sinonPlusTard,
					A2(
						$author$project$Components$Produits$StructureCatalogue$Niveaux$Update$saisirSurLeNiveau,
						id,
						function (saisie) {
							return _Utils_update(
								saisie,
								{eJ: true});
						}),
					A2(
						$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
						A3(
							$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$LibellerUnNiveau,
							id,
							libelles,
							A2(
								$elm$core$Maybe$andThen,
								function (niveau) {
									return A3($author$project$Components$Produits$StructureCatalogue$Niveaux$Update$formesAEnvoyer, niveau, libelles, model);
								},
								$author$project$Components$Produits$StructureCatalogue$Niveaux$Update$aRenommer(model))),
						$author$project$Components$Produits$StructureCatalogue$Niveaux$Update$sansRefus(
							A3(
								$author$project$Components$Produits$StructureCatalogue$Niveaux$Update$saisirSurLeNiveau,
								id,
								function (saisie) {
									return _Utils_update(
										saisie,
										{eJ: false});
								},
								model))));
			case 1:
				var _v2 = _v0.a;
				var id = _v2.a;
				var _v3 = _v2.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Components$Produits$StructureCatalogue$Niveaux$Update$saisirSurLeNiveau,
						id,
						function (saisie) {
							return _Utils_update(
								saisie,
								{eJ: false, b5: true});
						},
						model),
					_List_fromArray(
						[
							$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus($author$project$Components$Produits$StructureCatalogue$Niveaux$Model$idDuLibelleDuRenommage)
						]));
			default:
				var _v4 = _v0.a;
				var id = _v4.a;
				var _v5 = _v4.b;
				var _v6 = _Utils_Tuple2(
					$author$project$Components$Produits$StructureCatalogue$Niveaux$Update$aRenommer(model),
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.R;
						},
						$author$project$Components$Produits$StructureCatalogue$Niveaux$Update$aRenommer(model)));
				if ((!_v6.a.$) && (!_v6.b.$)) {
					var niveau = _v6.a.a;
					var libelles = _v6.b.a;
					var _v7 = A3($author$project$Components$Produits$StructureCatalogue$Niveaux$Update$formesAEnvoyer, niveau, libelles, model);
					if (!_v7.$) {
						var formes = _v7.a;
						return A2(
							$author$project$Components$Produits$StructureCatalogue$Commandes$sinonPlusTard,
							A2(
								$author$project$Components$Produits$StructureCatalogue$Niveaux$Update$saisirSurLeNiveau,
								id,
								function (saisie) {
									return _Utils_update(
										saisie,
										{eJ: true});
								}),
							A2(
								$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
								A3(
									$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$LibellerUnNiveau,
									id,
									libelles,
									$elm$core$Maybe$Just(formes)),
								$author$project$Components$Produits$StructureCatalogue$Niveaux$Update$sansRefus(
									A3(
										$author$project$Components$Produits$StructureCatalogue$Niveaux$Update$saisirSurLeNiveau,
										id,
										function (saisie) {
											return _Utils_update(
												saisie,
												{eJ: false});
										},
										model))));
					} else {
						return A2($author$project$Components$Produits$StructureCatalogue$Niveaux$Update$versLeRenommage, $author$project$Components$Shared$Drawer$Update$Fermer, model);
					}
				} else {
					return A2($author$project$Components$Produits$StructureCatalogue$Niveaux$Update$versLeRenommage, $author$project$Components$Shared$Drawer$Update$Fermer, model);
				}
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Update$reprendre = function (model) {
	var _v0 = _Utils_Tuple2(
		$author$project$Components$Produits$StructureCatalogue$Niveaux$Update$quitte(model),
		$author$project$Components$Produits$StructureCatalogue$Etats$Update$quitteSansPartir(model));
	if (!_v0.a.$) {
		return $author$project$Components$Produits$StructureCatalogue$Niveaux$Update$renommageDemande(model);
	} else {
		if (!_v0.b.$) {
			var _v1 = _v0.a;
			return $author$project$Components$Produits$StructureCatalogue$Etats$Update$renommageDemande(model);
		} else {
			var _v2 = _v0.a;
			var _v3 = _v0.b;
			return _Utils_Tuple2(model, _List_Nil);
		}
	}
};
var $author$project$Components$Produits$StructureCatalogue$Update$aleaRecu = function (model) {
	var _v0 = $author$project$Components$Produits$StructureCatalogue$Update$rendreLeFocusAttendu(
		_Utils_Tuple2(model, _List_Nil));
	var rendu = _v0.a;
	var focus = _v0.b;
	return A2(
		$author$project$Components$Produits$StructureCatalogue$Update$puis,
		$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$relancer,
		A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Basics$append(focus),
			$author$project$Components$Produits$StructureCatalogue$Update$reprendre(rendu)));
};
var $author$project$Components$Produits$Listes$API$QueryAPIModel$Annuaire = F3(
	function (listes, correspondances, liens) {
		return {wh: correspondances, nQ: liens, n_: listes};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (path, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					return A2(
						$elm$json$Json$Decode$at,
						path,
						nullOr(valDecoder));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				_List_fromArray(
					[key]),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$API$Liens$lu = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'templated',
	$elm$json$Json$Decode$bool,
	false,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'verbe',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'href',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'rel',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed(
					F4(
						function (rel, href, verbe, gabarit) {
							return _Utils_Tuple2(
								gabarit,
								{cM: href, eP: rel, sm: verbe});
						}))))));
var $author$project$API$Liens$LienAGabarit = $elm$core$Basics$identity;
var $author$project$API$Liens$repartir = function (lus) {
	return {
		gF: A2(
			$elm$core$List$map,
			A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$Basics$identity),
			A2($elm$core$List$filter, $elm$core$Tuple$first, lus)),
		h0: A2(
			$elm$core$List$map,
			$elm$core$Tuple$second,
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$Basics$not),
				lus))
	};
};
var $author$project$API$Liens$decoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$API$Liens$repartir,
	$elm$json$Json$Decode$list($author$project$API$Liens$lu));
var $author$project$API$Liens$deLaRessource = A2($elm$json$Json$Decode$field, '_links', $author$project$API$Liens$decoder);
var $author$project$Components$Produits$Listes$API$QueryAPIModel$ResumeDeListe = F9(
	function (id, nom, portee, valeurs, utiliseePar, champs, typesDePartiePrenante, correspondances, liens) {
		return {dw: champs, wh: correspondances, Aq: id, nQ: liens, Dj: nom, F$: portee, J$: typesDePartiePrenante, Kh: utiliseePar, Ki: valeurs};
	});
var $author$project$Components$Produits$Listes$API$QueryAPIModel$resumeDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$API$Liens$deLaRessource,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'correspondances',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'typesDePartiePrenante',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'champs',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'utiliseePar',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'valeurs',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'portee',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'nom',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Components$Produits$Listes$API$QueryAPIModel$ResumeDeListe))))))))));
var $author$project$Components$Produits$Listes$API$QueryAPIModel$annuaireDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$API$Liens$deLaRessource,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'correspondances',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'listes',
			$elm$json$Json$Decode$list($author$project$Components$Produits$Listes$API$QueryAPIModel$resumeDecoder),
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$Listes$API$QueryAPIModel$Annuaire))));
var $author$project$Components$Produits$StructureCatalogue$Model$SurLOrdreDeLEtage = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$StructureCatalogue$Model$SurLeControle = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$foyerDe = function (retour) {
	if (!retour.$) {
		var identifiant = retour.a;
		return $author$project$Components$Produits$StructureCatalogue$Model$SurLeControle(identifiant);
	} else {
		var typologie = retour.a;
		var etage = retour.b;
		var sens = retour.c;
		return A3($author$project$Components$Produits$StructureCatalogue$Model$SurLOrdreDeLEtage, typologie, etage, sens);
	}
};
var $author$project$Catalogue$Vocabulaire$natureDeService = 'service';
var $author$project$Components$Produits$StructureCatalogue$Natures$Model$deplacables = $elm$core$List$filter(
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.vx;
		},
		$elm$core$Basics$neq($author$project$Catalogue$Vocabulaire$natureDeService)));
var $author$project$Components$Shared$Ordre$suffixe = function (sens) {
	if (!sens) {
		return '-monter';
	} else {
		return '-descendre';
	}
};
var $author$project$Catalogue$Identifiants$valeurIdToString = function (_v0) {
	var valeur = _v0;
	return valeur;
};
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDuBoutonDOrdre = F2(
	function (valeur, sens) {
		return 'valeur-' + ($author$project$Catalogue$Identifiants$valeurIdToString(valeur) + $author$project$Components$Shared$Ordre$suffixe(sens));
	});
var $author$project$Catalogue$Identifiants$etageIdToString = function (_v0) {
	var valeur = _v0;
	return valeur;
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$idDuBoutonDOrdre = F2(
	function (id, sens) {
		return 'etage-' + ($author$project$Catalogue$Identifiants$etageIdToString(id) + $author$project$Components$Shared$Ordre$suffixe(sens));
	});
var $author$project$Components$Produits$StructureCatalogue$Natures$Model$idDuBoutonDOrdre = F2(
	function (code, sens) {
		return 'nature-' + (code + $author$project$Components$Shared$Ordre$suffixe(sens));
	});
var $author$project$Components$Produits$StructureCatalogue$Etats$Model$idDuBoutonDOrdreDeLEtat = F2(
	function (code, sens) {
		return 'etat-' + ($author$project$Catalogue$Identifiants$etatCodeToString(code) + $author$project$Components$Shared$Ordre$suffixe(sens));
	});
var $author$project$Components$Produits$StructureCatalogue$Model$idDuFoyer = F2(
	function (structure, foyer) {
		var place = F2(
			function (cherche, liste) {
				return _Utils_Tuple2(
					_Utils_eq(
						$elm$core$List$head(liste),
						$elm$core$Maybe$Just(cherche)),
					_Utils_eq(
						$elm$core$List$head(
							$elm$core$List$reverse(liste)),
						$elm$core$Maybe$Just(cherche)));
			});
		var actif = F3(
			function (sens, premier, dernier) {
				if (!sens) {
					return premier ? 1 : 0;
				} else {
					return dernier ? 0 : 1;
				}
			});
		switch (foyer.$) {
			case 0:
				var id = foyer.a;
				return id;
			case 1:
				var code = foyer.a;
				var sens = foyer.b;
				return function (_v1) {
					var premier = _v1.a;
					var dernier = _v1.b;
					return A2(
						$author$project$Components$Produits$StructureCatalogue$Etats$Model$idDuBoutonDOrdreDeLEtat,
						code,
						A3(actif, sens, premier, dernier));
				}(
					A2(
						place,
						code,
						A2(
							$elm$core$List$map,
							function ($) {
								return $.vx;
							},
							structure.mj)));
			case 2:
				var code = foyer.a;
				var sens = foyer.b;
				return function (_v2) {
					var premier = _v2.a;
					var dernier = _v2.b;
					return A2(
						$author$project$Components$Produits$StructureCatalogue$Natures$Model$idDuBoutonDOrdre,
						code,
						A3(actif, sens, premier, dernier));
				}(
					A2(
						place,
						code,
						A2(
							$elm$core$List$map,
							function ($) {
								return $.vx;
							},
							$author$project$Components$Produits$StructureCatalogue$Natures$Model$deplacables(structure.oo))));
			case 3:
				var classification = foyer.a;
				var id = foyer.b;
				var sens = foyer.c;
				var valeurs = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.Ki;
						},
						A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$classificationDe, classification, structure.vk)));
				var soeurs = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (valeur) {
							return A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$fillesDe, valeur.ey, valeurs);
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.Aq;
									},
									$elm$core$Basics$eq(id)),
								valeurs))));
				return function (_v3) {
					var premier = _v3.a;
					var dernier = _v3.b;
					return A2(
						$author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDuBoutonDOrdre,
						id,
						A3(actif, sens, premier, dernier));
				}(
					A2(
						place,
						id,
						A2(
							$elm$core$List$map,
							function ($) {
								return $.Aq;
							},
							soeurs)));
			default:
				var typologie = foyer.a;
				var id = foyer.b;
				var sens = foyer.c;
				return function (_v4) {
					var premier = _v4.a;
					var dernier = _v4.b;
					return A2(
						$author$project$Components$Produits$StructureCatalogue$Etages$Model$idDuBoutonDOrdre,
						id,
						A3(actif, sens, premier, dernier));
				}(
					A2(
						place,
						id,
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.yG;
									},
									A2(
										$elm$core$Basics$composeR,
										$elm$core$List$filter(
											A2(
												$elm$core$Basics$composeL,
												$elm$core$Basics$not,
												function ($) {
													return $.wL;
												})),
										$elm$core$List$map(
											function ($) {
												return $.Aq;
											}))),
								A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$classificationDe, typologie, structure.vk)))));
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$annulerSurLaPage = function (model) {
	var _v0 = _Utils_Tuple2(model.q, model.h$);
	if ((_v0.a.$ === 2) && (!_v0.b.$)) {
		var lu = _v0.a.a;
		var structure = _v0.b.a;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{q: $author$project$Components$Produits$StructureCatalogue$Etages$Model$SansReecriture}),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Produits$StructureCatalogue$Etages$Update$foyerDe,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Produits$StructureCatalogue$Model$idDuFoyer(structure),
							A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus, $elm$core$List$singleton))),
					lu.qL)));
	} else {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{q: $author$project$Components$Produits$StructureCatalogue$Etages$Model$SansReecriture}),
			_List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$annuler = function (model) {
	var _v0 = _Utils_Tuple2(model.q, model.h$);
	if ((_v0.a.$ === 2) && (!_v0.b.$)) {
		return $author$project$Components$Shared$Drawer$Model$estOuvert(model.y) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{q: $author$project$Components$Produits$StructureCatalogue$Etages$Model$SansReecriture}),
			_List_fromArray(
				[
					$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus($author$project$Components$Produits$StructureCatalogue$Etages$Model$idDuLibelleDeLAjout)
				])) : $author$project$Components$Produits$StructureCatalogue$Etages$Update$annulerSurLaPage(model);
	} else {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{q: $author$project$Components$Produits$StructureCatalogue$Etages$Model$SansReecriture}),
			_List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$API$ArchivageAPIModel$Apercu = F9(
	function (total, migrees, aRanger, cloturees, sansPlace, verrouillees, enConflit, parCategorie, referencesEnConflit) {
		return {iz: aRanger, vr: cloturees, yi: enConflit, Cw: migrees, EL: parCategorie, He: referencesEnConflit, Ip: sansPlace, JE: total, KC: verrouillees};
	});
var $author$project$Components$Produits$StructureCatalogue$API$ArchivageAPIModel$CategorieDeLApercu = F2(
	function (typeDeProduit, references) {
		return {hD: references, fh: typeDeProduit};
	});
var $author$project$Catalogue$Identifiants$typeDeProduitIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Components$Produits$StructureCatalogue$API$ArchivageAPIModel$categorieDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'references',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'typeDeProduit',
		$author$project$Catalogue$Identifiants$typeDeProduitIdDecoder,
		$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$API$ArchivageAPIModel$CategorieDeLApercu)));
var $author$project$Components$Produits$StructureCatalogue$API$ArchivageAPIModel$Conflit = F2(
	function (reference, code) {
		return {vx: code, Hc: reference};
	});
var $author$project$Catalogue$Identifiants$referenceIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Components$Produits$StructureCatalogue$API$ArchivageAPIModel$conflitDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'code',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		$author$project$Catalogue$Vocabulaire$champDeLaReference,
		$author$project$Catalogue$Identifiants$referenceIdDecoder,
		$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$API$ArchivageAPIModel$Conflit)));
var $author$project$Components$Produits$StructureCatalogue$API$ArchivageAPIModel$apercuDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'referencesEnConflit',
	$elm$json$Json$Decode$list($author$project$Components$Produits$StructureCatalogue$API$ArchivageAPIModel$conflitDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'parCategorie',
		$elm$json$Json$Decode$list($author$project$Components$Produits$StructureCatalogue$API$ArchivageAPIModel$categorieDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'enConflit',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'verrouillees',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'sansPlace',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'cloturees',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'aRanger',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'migrees',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'total',
									$elm$json$Json$Decode$int,
									$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$API$ArchivageAPIModel$Apercu))))))))));
var $author$project$Components$Produits$StructureCatalogue$Effet$Reconnecter = {$: 18};
var $author$project$Components$Produits$StructureCatalogue$Archivage$Update$apercuRecu = F2(
	function (lu, model) {
		var archivage = model.tD;
		if (!lu.$) {
			var apercu = lu.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						tD: _Utils_update(
							archivage,
							{
								tq: $elm$core$Maybe$Just(apercu)
							})
					}),
				_List_Nil);
		} else {
			if (lu.a.a === 401) {
				var _v1 = lu.a;
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[$author$project$Components$Produits$StructureCatalogue$Effet$Reconnecter]));
			} else {
				var _v2 = lu.a;
				var message = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aL: $elm$core$Maybe$Just(message)
						}),
					_List_Nil);
			}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$ApercuLu = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$ApercuAPIModel$Apercu = F5(
	function (aRanger, empreinte, gardentLeurPlace, redistribuees, nomsARanger) {
		return {iz: aRanger, yf: empreinte, z6: gardentLeurPlace, DH: nomsARanger, Ha: redistribuees};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$Empreinte = $elm$core$Basics$identity;
var $author$project$Catalogue$API$QueryAPIModel$Libelles = F2(
	function (fr, en) {
		return {yg: en, zX: fr};
	});
var $author$project$Catalogue$API$QueryAPIModel$libellesDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'en',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'fr',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Catalogue$API$QueryAPIModel$Libelles)));
var $author$project$Components$Produits$StructureCatalogue$API$ApercuAPIModel$Redistribuee = F4(
	function (etage, sous, avec, nombre) {
		return {ub: avec, md: etage, w: nombre, IV: sous};
	});
var $author$project$Catalogue$Identifiants$EtageId = $elm$core$Basics$identity;
var $author$project$Catalogue$Identifiants$etageIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Components$Produits$StructureCatalogue$API$ApercuAPIModel$redistribueeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'nombre',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'avec',
		$author$project$Catalogue$Identifiants$etageIdDecoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'sous',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Identifiants$etageIdDecoder),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'etage',
				$author$project$Catalogue$Identifiants$etageIdDecoder,
				$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$API$ApercuAPIModel$Redistribuee)))));
var $author$project$Components$Produits$StructureCatalogue$API$ApercuAPIModel$apercuDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'nomsARanger',
	$elm$json$Json$Decode$list(
		A2(
			$elm$json$Json$Decode$map,
			function ($) {
				return $.zX;
			},
			$author$project$Catalogue$API$QueryAPIModel$libellesDecoder)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'redistribuees',
		$elm$json$Json$Decode$list($author$project$Components$Produits$StructureCatalogue$API$ApercuAPIModel$redistribueeDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'gardentLeurPlace',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'empreinte',
				A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'aRanger',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$API$ApercuAPIModel$Apercu))))));
var $author$project$API$Reponse$ReponseIllisible = {$: 8};
var $author$project$I18n$Textes$erreurApiInjoignable = A3($author$project$I18n$Traductions$texte, 'erreur.api.injoignable', _List_Nil, 'Le serveur ne répond pas. Vérifiez votre connexion, puis réessayez.');
var $author$project$I18n$Textes$erreurApiInterdit = A3($author$project$I18n$Traductions$texte, 'erreur.api.interdit', _List_Nil, 'Vous n\'avez pas le droit de faire cette action.');
var $author$project$I18n$Textes$erreurApiReponseIllisible = A3($author$project$I18n$Traductions$texte, 'erreur.api.reponse-illisible', _List_Nil, 'La réponse du serveur n\'a pas pu être lue.');
var $author$project$I18n$Textes$erreurApiRequeteRefusee = A3($author$project$I18n$Traductions$texte, 'erreur.api.requete-refusee', _List_Nil, 'Les informations envoyées ont été refusées par le serveur.');
var $author$project$I18n$Textes$erreurApiTechnique = A3($author$project$I18n$Traductions$texte, 'erreur.api.technique', _List_Nil, 'Une erreur est survenue. Réessayez dans un instant.');
var $author$project$Components$Shared$Messages$Model$duRefus = function (refus) {
	return {
		Jx: _Utils_eq(refus.bB, $author$project$API$Reponse$ReponseIllisible) ? $author$project$I18n$Textes$erreurApiReponseIllisible : ((!refus.ri) ? $author$project$I18n$Textes$erreurApiInjoignable : ((refus.ri === 403) ? $author$project$I18n$Textes$erreurApiInterdit : ((refus.ri === 400) ? $author$project$I18n$Textes$erreurApiRequeteRefusee : $author$project$I18n$Textes$erreurApiTechnique))),
		b9: refus.b9
	};
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$idDeLApercu = 'etages-apercu';
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$idDeLApercuDeLAjout = 'ajout-' + $author$project$Components$Produits$StructureCatalogue$Etages$Model$idDeLApercu;
var $author$project$API$Reponse$SansDetail = {$: 0};
var $author$project$API$Reponse$DeType = function (a) {
	return {$: 7, a: a};
};
var $author$project$API$Reponse$Decodage = function (a) {
	return {$: 6, a: a};
};
var $author$project$API$Reponse$Metier = function (a) {
	return {$: 1, a: a};
};
var $author$project$API$Reponse$MetierAvecPrecisions = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$API$Reponse$MetierDesChamps = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$API$Reponse$MetierDesPassages = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$API$Reponse$MetierDuCote = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$API$Reponse$archivesDuRefus = A2(
	$elm$json$Json$Decode$field,
	'archives',
	$elm$json$Json$Decode$list(
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'le', $elm$json$Json$Decode$string))));
var $author$project$API$Reponse$defautsDuSchema = A2(
	$elm$json$Json$Decode$field,
	'defauts',
	$elm$json$Json$Decode$list(
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string))));
var $author$project$API$Reponse$cas = function (champs) {
	if (champs.b && (!champs.b.b)) {
		var _v1 = champs.a;
		var nom = _v1.a;
		var contenu = _v1.b;
		return $elm$json$Json$Decode$succeed(
			function () {
				var _v2 = A2(
					$elm$json$Json$Decode$decodeValue,
					A2($elm$json$Json$Decode$field, 'cote', $elm$json$Json$Decode$string),
					contenu);
				if (!_v2.$) {
					var cote = _v2.a;
					return A2($author$project$API$Reponse$MetierDuCote, nom, cote);
				} else {
					var _v3 = _Utils_Tuple2(
						nom,
						A2(
							$elm$json$Json$Decode$decodeValue,
							A2(
								$elm$json$Json$Decode$field,
								'champs',
								$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
							contenu));
					_v3$2:
					while (true) {
						switch (_v3.a) {
							case 'AttributsInvalides':
								if (!_v3.b.$) {
									var noms = _v3.b.a;
									return A2($author$project$API$Reponse$MetierDesChamps, nom, noms);
								} else {
									break _v3$2;
								}
							case 'RoleUtiliseParUnPassage':
								var _v4 = A2(
									$elm$json$Json$Decode$decodeValue,
									A2(
										$elm$json$Json$Decode$field,
										'passages',
										$elm$json$Json$Decode$list(
											A3(
												$elm$json$Json$Decode$map2,
												$elm$core$Tuple$pair,
												A2($elm$json$Json$Decode$field, 'de', $elm$json$Json$Decode$string),
												A2($elm$json$Json$Decode$field, 'vers', $elm$json$Json$Decode$string)))),
									contenu);
								if (!_v4.$) {
									var passages = _v4.a;
									return A2($author$project$API$Reponse$MetierDesPassages, nom, passages);
								} else {
									return $author$project$API$Reponse$Metier(nom);
								}
							default:
								break _v3$2;
						}
					}
					if (A2(
						$elm$core$List$member,
						nom,
						_List_fromArray(
							['OptionInvalide', 'EvolutionNonAdditive', 'FormuleRefusee', 'ChampDejaDansUneAutreCollection', 'ChampDejaDansLaBibliotheque', 'SousChampsEnDouble', 'SousChampNonAdmis', 'SousChampRetireAvecValeurs', 'NomDeTypeDejaPris', 'FormuleInvalide']))) {
						var _v5 = A2(
							$elm$json$Json$Decode$decodeValue,
							$elm$json$Json$Decode$keyValuePairs(
								$elm$json$Json$Decode$oneOf(
									_List_fromArray(
										[
											$elm$json$Json$Decode$string,
											A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int)
										]))),
							contenu);
						if (!_v5.$) {
							if (!_v5.a.b) {
								return $author$project$API$Reponse$Metier(nom);
							} else {
								var precisions = _v5.a;
								return A2($author$project$API$Reponse$MetierAvecPrecisions, nom, precisions);
							}
						} else {
							return $author$project$API$Reponse$Metier(nom);
						}
					} else {
						if (nom === 'ValeurNonTransmise') {
							var _v6 = A2(
								$elm$json$Json$Decode$decodeValue,
								A2($elm$json$Json$Decode$field, 'valeur', $elm$json$Json$Decode$string),
								contenu);
							if (!_v6.$) {
								var valeur = _v6.a;
								return A2(
									$author$project$API$Reponse$MetierAvecPrecisions,
									nom,
									_List_fromArray(
										[
											_Utils_Tuple2('valeur', valeur)
										]));
							} else {
								return $author$project$API$Reponse$Metier(nom);
							}
						} else {
							if (nom === 'TypeDeFicheInconnu') {
								var _v7 = A2($elm$json$Json$Decode$decodeValue, $author$project$API$Reponse$archivesDuRefus, contenu);
								if (!_v7.$) {
									var archives = _v7.a;
									return A2($author$project$API$Reponse$MetierAvecPrecisions, nom, archives);
								} else {
									return $author$project$API$Reponse$Metier(nom);
								}
							} else {
								if (nom === 'SchemaInvalide') {
									var _v8 = A2($elm$json$Json$Decode$decodeValue, $author$project$API$Reponse$defautsDuSchema, contenu);
									if (!_v8.$) {
										var defauts = _v8.a;
										return A2($author$project$API$Reponse$MetierAvecPrecisions, nom, defauts);
									} else {
										return $author$project$API$Reponse$Metier(nom);
									}
								} else {
									return $author$project$API$Reponse$Metier(nom);
								}
							}
						}
					}
				}
			}());
	} else {
		return $elm$json$Json$Decode$fail('error');
	}
};
var $author$project$API$Reponse$Invalide = F2(
	function (msg, path) {
		return {C$: msg, E6: path};
	});
var $author$project$API$Reponse$invalide = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'path',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'msg',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$API$Reponse$Invalide)));
var $author$project$API$Reponse$apiErrorsResponseDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$andThen,
				$author$project$API$Reponse$cas,
				A2(
					$elm$json$Json$Decode$field,
					'error',
					$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value))),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$API$Reponse$Decodage,
				A2(
					$elm$json$Json$Decode$field,
					'errors',
					$elm$json$Json$Decode$list($author$project$API$Reponse$invalide))),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$API$Reponse$DeType,
				A2($elm$json$Json$Decode$field, 'errorsType', $elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$succeed($author$project$API$Reponse$SansDetail)
			])),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'traceId',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed(
			F2(
				function (traceId, detail) {
					return {bB: detail, b9: traceId};
				}))));
var $author$project$API$Reponse$lire = F2(
	function (decoder, reponse) {
		return ((reponse.ri >= 200) && (reponse.ri < 300)) ? A2(
			$elm$core$Result$mapError,
			function (_v0) {
				return {bB: $author$project$API$Reponse$ReponseIllisible, ri: reponse.ri, b9: $elm$core$Maybe$Nothing};
			},
			A2($elm$json$Json$Decode$decodeString, decoder, reponse.f$)) : $elm$core$Result$Err(
			A2(
				$elm$core$Result$withDefault,
				{bB: $author$project$API$Reponse$SansDetail, ri: reponse.ri, b9: $elm$core$Maybe$Nothing},
				A2(
					$elm$core$Result$map,
					function (erreur) {
						return {
							bB: erreur.bB,
							ri: reponse.ri,
							b9: $elm$core$Maybe$Just(erreur.b9)
						};
					},
					A2($elm$json$Json$Decode$decodeString, $author$project$API$Reponse$apiErrorsResponseDecoder, reponse.f$))));
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$apercuRecu = F2(
	function (reponse, model) {
		var _v0 = model.q;
		if (_v0.$ === 1) {
			var demande = _v0.a;
			var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$StructureCatalogue$API$ApercuAPIModel$apercuDecoder, reponse);
			if (!_v1.$) {
				var apercu = _v1.a;
				var ajout = $author$project$Components$Shared$Drawer$Model$estOuvert(model.y);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							q: $author$project$Components$Produits$StructureCatalogue$Etages$Model$ApercuLu(
								{iz: apercu.iz, yf: apercu.yf, z6: apercu.z6, mW: demande.mW, DH: apercu.DH, eC: demande.eC, Ha: apercu.Ha, qL: demande.qL, h6: demande.h6}),
							aL: ajout ? $elm$core$Maybe$Nothing : model.aL
						}),
					_List_fromArray(
						[
							$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(
							ajout ? $author$project$Components$Produits$StructureCatalogue$Etages$Model$idDeLApercuDeLAjout : A2($author$project$Components$Produits$StructureCatalogue$Etages$Update$auRangementSiOuvert, model, $author$project$Components$Produits$StructureCatalogue$Etages$Model$idDeLApercu))
						]));
			} else {
				var refus = _v1.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							q: $author$project$Components$Produits$StructureCatalogue$Etages$Model$SansReecriture,
							aL: ($author$project$Components$Shared$Drawer$Model$estOuvert(model.y) && (refus.ri !== 401)) ? $elm$core$Maybe$Just(
								$author$project$Components$Shared$Messages$Model$duRefus(refus)) : model.aL
						}),
					(refus.ri === 401) ? _List_fromArray(
						[$author$project$Components$Produits$StructureCatalogue$Effet$Reconnecter]) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.y) ? _List_fromArray(
						[
							$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus($author$project$Components$Produits$StructureCatalogue$Etages$Model$idDuLibelleDeLAjout)
						]) : _List_Nil));
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Archivage$Model$archivable = function (archivage) {
	var _v0 = _Utils_Tuple2(archivage.a6.qD, archivage.tq);
	_v0$2:
	while (true) {
		if (!_v0.a.$) {
			if (!_v0.a.a) {
				return $elm$core$List$isEmpty(archivage.a6.Aw);
			} else {
				break _v0$2;
			}
		} else {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var apercu = _v0.b.a;
				return (!apercu.JE) && (!archivage.a6.d8);
			} else {
				break _v0$2;
			}
		}
	}
	return false;
};
var $author$project$Components$Produits$StructureCatalogue$Archivage$Update$archiverDemande = function (model) {
	var _v0 = model.tD.r3;
	if (!_v0.$) {
		var id = _v0.a;
		return $author$project$Components$Produits$StructureCatalogue$Archivage$Model$archivable(model.tD) ? A2(
			$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
			$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ArchiverUneTypologie(id),
			_Utils_update(
				model,
				{aL: $elm$core$Maybe$Nothing})) : _Utils_Tuple2(model, _List_Nil);
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Etage$retirer = F3(
	function (cle, article, ouvert) {
		return _Utils_update(
			ouvert,
			{
				uw: A3(
					$elm$core$Dict$update,
					cle,
					$elm$core$Maybe$map(
						$elm$core$List$filter(
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$neq(article)))),
					ouvert.uw)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$articleDEtageRetire = F3(
	function (cle, article, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					s: A2(
						$elm$core$Maybe$map,
						A2($author$project$Components$Produits$StructureCatalogue$Informations$Etage$retirer, cle, article),
						model.s)
				}),
			_List_Nil);
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Etage$articlesDe = F2(
	function (cle, ouvert) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Dict$get, cle, ouvert.uw));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Etage$ajouter = F3(
	function (cle, choisis, ouvert) {
		var deja = A2(
			$elm$core$List$map,
			function ($) {
				return $.Aq;
			},
			A2($author$project$Components$Produits$StructureCatalogue$Informations$Etage$articlesDe, cle, ouvert));
		var nouveaux = A2(
			$elm$core$List$filter,
			function (article) {
				return !A2($elm$core$List$member, article.Aq, deja);
			},
			choisis);
		return _Utils_update(
			ouvert,
			{
				uw: A3(
					$elm$core$Dict$insert,
					cle,
					_Utils_ap(
						A2($author$project$Components$Produits$StructureCatalogue$Informations$Etage$articlesDe, cle, ouvert),
						nouveaux),
					ouvert.uw)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$enArticleDEtage = function (trouvee) {
	return {
		vx: $elm$core$Maybe$Just(trouvee.vx),
		gt: trouvee.gt,
		Aq: trouvee.Aq,
		gX: $elm$core$Maybe$Nothing,
		Dj: trouvee.Dj
	};
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$inconnu = function (id) {
	return {vx: $elm$core$Maybe$Nothing, gt: '', Aq: id, gX: $elm$core$Maybe$Nothing, Dj: $elm$core$Maybe$Nothing};
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$versLeChoixDEtage = F2(
	function (geste, model) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{Il: false},
			geste,
			model.dM);
		var drawer = _v0.a;
		var effets = _v0.b;
		var suivi = _Utils_update(
			model,
			{dM: drawer});
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? suivi : _Utils_update(
				suivi,
				{tP: $elm$core$Maybe$Nothing}),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$articlesDEtageAjoutes = function (model) {
	var _v0 = _Utils_Tuple2(model.tP, model.s);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var choix = _v0.a.a;
		var ouvert = _v0.b.a;
		var choisis = A2(
			$elm$core$List$map,
			function (id) {
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Components$Produits$StructureCatalogue$Informations$Update$inconnu(id),
					A2(
						$elm$core$Maybe$map,
						$author$project$Components$Produits$StructureCatalogue$Informations$Update$enArticleDEtage,
						A2($elm$core$Dict$get, id, model.bt)));
			},
			choix.at);
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Informations$Update$versLeChoixDEtage,
			$author$project$Components$Shared$Drawer$Update$Fermer,
			_Utils_update(
				model,
				{
					s: $elm$core$Maybe$Just(
						A3($author$project$Components$Produits$StructureCatalogue$Informations$Etage$ajouter, choix.dy, choisis, ouvert))
				}));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Effet$ChercherDesArticles = F3(
	function (a, b, c) {
		return {$: 12, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$Common$ChoixDArticles$tailleDePage = 25;
var $author$project$API$NavLinksDictionary$rechercherDesReferences = 'rechercher-des-references';
var $author$project$API$Liens$trouverGabarit = F2(
	function (rel, gabarits) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var lien = _v0;
					return _Utils_eq(lien.eP, rel);
				},
				gabarits));
	});
var $author$project$API$NavLinksDictionary$variablePage = 'page';
var $author$project$API$NavLinksDictionary$variableTaille = 'taille';
var $author$project$Components$Produits$Liens$versLaRecherche = F2(
	function (demandee, gabarits) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$API$NavLinksDictionary$variablePage,
						$elm$core$String$fromInt(demandee.EE)),
						_Utils_Tuple2(
						$author$project$API$NavLinksDictionary$variableTaille,
						$elm$core$String$fromInt(demandee.Jm))
					])),
			A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$rechercherDesReferences, gabarits));
	});
var $author$project$Components$Produits$Common$ChoixDArticles$lienDuLot = F2(
	function (gabarits, page) {
		return A2(
			$author$project$Components$Produits$Liens$versLaRecherche,
			{EE: page, Jm: $author$project$Components$Produits$Common$ChoixDArticles$tailleDePage},
			gabarits);
	});
var $author$project$Catalogue$Identifiants$EtatCode = $elm$core$Basics$identity;
var $author$project$Catalogue$Identifiants$etatCodeFromString = function (valeur) {
	return $elm$core$String$isEmpty(valeur) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(valeur);
};
var $author$project$Catalogue$Identifiants$ValeurId = $elm$core$Basics$identity;
var $author$project$Catalogue$Identifiants$valeurIdFromString = function (valeur) {
	return $elm$core$String$isEmpty(valeur) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(valeur);
};
var $author$project$Components$Produits$Common$ChoixDArticles$recherche = function (choix) {
	return {
		i2: choix.i2,
		dt: A2($elm$core$List$filterMap, $author$project$Catalogue$Identifiants$valeurIdFromString, choix.dt),
		dw: _List_Nil,
		jF: _List_Nil,
		j2: $elm$core$Maybe$Nothing,
		gt: $elm$core$Maybe$Nothing,
		mj: A2($elm$core$List$filterMap, $author$project$Catalogue$Identifiants$etatCodeFromString, choix.mj),
		mu: A2($elm$core$List$filterMap, $author$project$Catalogue$Identifiants$valeurIdFromString, choix.mu),
		gG: A2($elm$core$List$filterMap, $author$project$Catalogue$Identifiants$elementIdFromString, choix.gG),
		cU: A2($elm$core$List$filterMap, $author$project$Catalogue$Identifiants$elementIdFromString, choix.cU),
		ou: $elm$core$Maybe$Nothing,
		pn: _List_Nil,
		h3: choix.h3,
		rS: $elm$core$Maybe$Nothing,
		fh: $elm$core$Maybe$Nothing,
		r7: A2($elm$core$List$filterMap, $author$project$Catalogue$Identifiants$classificationIdFromString, choix.r7)
	};
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$chercherDesArticles = function (_v0) {
	var model = _v0.a;
	var effets = _v0.b;
	var _v1 = model.tP;
	if (!_v1.$) {
		var choix = _v1.a;
		var suivant = _Utils_update(
			choix,
			{DX: choix.DX + 1});
		var _v2 = A2($author$project$Components$Produits$Common$ChoixDArticles$lienDuLot, model.gF, suivant.EE);
		if (!_v2.$) {
			var lien = _v2.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						tP: $elm$core$Maybe$Just(suivant)
					}),
				_Utils_ap(
					effets,
					_List_fromArray(
						[
							A3(
							$author$project$Components$Produits$StructureCatalogue$Effet$ChercherDesArticles,
							suivant.DX,
							lien,
							$author$project$Components$Produits$Common$ChoixDArticles$recherche(suivant))
						])));
		} else {
			return _Utils_Tuple2(model, effets);
		}
	} else {
		return _Utils_Tuple2(model, effets);
	}
};
var $author$project$Components$Produits$Common$ChoixDArticles$choixVide = function (cle) {
	return {i2: false, dt: _List_Nil, dy: cle, at: _List_Nil, mj: _List_Nil, mu: _List_Nil, gG: _List_Nil, AJ: false, cU: _List_Nil, DX: 0, EE: 1, h3: '', fg: $elm$core$Maybe$Nothing, r7: _List_Nil};
};
var $author$project$Components$Produits$Common$ChoixDArticles$idDuChoix = 'articles-a-lier';
var $author$project$Components$Produits$StructureCatalogue$Effet$LireLaStructureDesFiltres = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Effet$LireLeCatalogueDesFiltres = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$lireLesFiltres = function (model) {
	var _v0 = _Utils_Tuple3(model.jB, model.r7, model.nt);
	if (_v0.a.$ === 1) {
		var _v1 = _v0.a;
		var catalogue = _v0.c.jB;
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Effet$LireLeCatalogueDesFiltres, $elm$core$List$singleton),
				catalogue));
	} else {
		if (!_v0.b.b) {
			var structure = _v0.c.h$;
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Effet$LireLaStructureDesFiltres, $elm$core$List$singleton),
					structure));
		} else {
			return _List_Nil;
		}
	}
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$articlesDEtageDemandes = F2(
	function (cle, model) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{Il: false},
			$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Produits$Common$ChoixDArticles$idDuChoix + ('-' + cle)),
			model.dM);
		var drawer = _v0.a;
		var effets = _v0.b;
		return $author$project$Components$Produits$StructureCatalogue$Informations$Update$chercherDesArticles(
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						tP: $elm$core$Maybe$Just(
							$author$project$Components$Produits$Common$ChoixDArticles$choixVide(cle)),
						bt: $elm$core$Dict$empty,
						dM: drawer
					}),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						function (_v1) {
							var cible = _v1;
							return $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(cible);
						},
						effets),
					$author$project$Components$Produits$StructureCatalogue$Informations$Update$lireLesFiltres(model))));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$avecLeChoix = F2(
	function (modifier, model) {
		return _Utils_update(
			model,
			{
				tP: A2($elm$core$Maybe$map, modifier, model.tP)
			});
	});
var $author$project$Components$Produits$Common$ChoixDArticles$Trouvee = F7(
	function (id, code, nom, etat, arretee, marque, categorie) {
		return {tL: arretee, uK: categorie, vx: code, gt: etat, Aq: id, gX: marque, Dj: nom};
	});
var $author$project$Components$Produits$Common$ChoixDArticles$Trouvees = F2(
	function (references, total) {
		return {hD: references, JE: total};
	});
var $author$project$Components$Produits$Common$ChoixDArticles$decoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Produits$Common$ChoixDArticles$Trouvees,
	A2(
		$elm$json$Json$Decode$field,
		'references',
		$elm$json$Json$Decode$list(
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'categorie',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					$author$project$Catalogue$Vocabulaire$champDeLaMarque,
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'arretee',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'etat',
							$elm$json$Json$Decode$string,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								$author$project$Catalogue$Vocabulaire$codeProduit,
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'code',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Components$Produits$Common$ChoixDArticles$Trouvee)))))))))),
	A2($elm$json$Json$Decode$field, 'total', $elm$json$Json$Decode$int));
var $author$project$Components$Produits$Common$ChoixDArticles$recu = F3(
	function (numero, resultat, choix) {
		if (!_Utils_eq(numero, choix.DX)) {
			return choix;
		} else {
			if (!resultat.$) {
				var trouvees = resultat.a;
				return _Utils_update(
					choix,
					{
						AJ: false,
						fg: $elm$core$Maybe$Just(trouvees)
					});
			} else {
				return _Utils_update(
					choix,
					{AJ: true});
			}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$articlesTrouves = F3(
	function (numero, reponse, model) {
		var resultat = A2(
			$elm$core$Result$mapError,
			function (_v1) {
				return 0;
			},
			A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$ChoixDArticles$decoder, reponse));
		var vus = function () {
			var _v0 = _Utils_Tuple2(resultat, model.tP);
			if ((!_v0.a.$) && (!_v0.b.$)) {
				var trouvees = _v0.a.a;
				var choix = _v0.b.a;
				return _Utils_eq(choix.DX, numero) ? A3(
					$elm$core$List$foldl,
					function (t) {
						return A2($elm$core$Dict$insert, t.Aq, t);
					},
					model.bt,
					trouvees.hD) : model.bt;
			} else {
				return model.bt;
			}
		}();
		return _Utils_Tuple2(
			A2(
				$author$project$Components$Produits$StructureCatalogue$Informations$Update$avecLeChoix,
				A2($author$project$Components$Produits$Common$ChoixDArticles$recu, numero, resultat),
				_Utils_update(
					model,
					{bt: vus})),
			_List_Nil);
	});
var $author$project$Components$Produits$StructureCatalogue$Update$cibleDuFocus = function (effet) {
	if (effet.$ === 16) {
		var cible = effet.a;
		return $elm$core$Maybe$Just(cible);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Update$attendreLaRelecture = F2(
	function (commande, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		var relecture = function (effet) {
			switch (effet.$) {
				case 1:
					return true;
				case 8:
					return true;
				default:
					return false;
			}
		};
		var _v1 = A2(
			$elm$core$List$partition,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$Produits$StructureCatalogue$Update$cibleDuFocus,
				$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
			effets);
		var focus = _v1.a;
		var autres = _v1.b;
		var _v2 = _Utils_Tuple2(
			A2($elm$core$List$any, relecture, effets),
			commande);
		if (!_v2.a) {
			return _Utils_Tuple2(model, effets);
		} else {
			if (_v2.b.$ === 7) {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Hv: model.Hv + 1}),
					effets);
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							mL: A2($elm$core$List$filterMap, $author$project$Components$Produits$StructureCatalogue$Update$cibleDuFocus, focus),
							Hv: model.Hv + 1
						}),
					autres);
			}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$prefixeDuLibelleDeListe = 'nouvelle-liste-libelle';
var $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$idDuLibelleDeListe = A2($author$project$Components$Shared$LibellesParLangue$View$idDuChamp, $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$prefixeDuLibelleDeListe, 'fr');
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$autreNomDeListeVoulu = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{ed: $elm$core$Maybe$Nothing, aL: $elm$core$Maybe$Nothing}),
		_List_fromArray(
			[
				$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus($author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$idDuLibelleDeListe)
			]));
};
var $author$project$Components$Produits$StructureCatalogue$Update$avecLaCategorie = F2(
	function (porteur, informations) {
		return _Utils_update(
			informations,
			{
				F3: _Utils_ap(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.F$;
							},
							$elm$core$Basics$neq(porteur.F$)),
						informations.F3),
					_List_fromArray(
						[porteur]))
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Update$estUneCategorie = function (portee) {
	if (portee.$ === 3) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Update$avecLesCategories = F2(
	function (avant, servies) {
		var gardees = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.F3;
					},
					$elm$core$List$filter(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.F$;
							},
							$author$project$Components$Produits$StructureCatalogue$Update$estUneCategorie))),
				avant));
		return _Utils_update(
			servies,
			{
				F3: _Utils_ap(servies.F3, gardees)
			});
	});
var $author$project$Components$Shared$Bibliotheque$Champ$ChampDeLaBibliotheque = F9(
	function (id, cle, libelle, typeAffiche, portee, utilisePar, origine, etages, liens) {
		return {dy: cle, yG: etages, Aq: id, Bl: libelle, nQ: liens, o4: origine, F$: portee, rU: typeAffiche, sf: utilisePar};
	});
var $elm$json$Json$Decode$map8 = _Json_map8;
var $author$project$Components$Shared$Bibliotheque$Champ$origineDecoder = A4(
	$elm$json$Json$Decode$map3,
	F3(
		function (genre, id, nom) {
			return {M: genre, Aq: id, Dj: nom};
		}),
	A2($elm$json$Json$Decode$field, 'genre', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string));
var $author$project$Components$Shared$Bibliotheque$Champ$bibliothequeDecoder = A2(
	$elm$json$Json$Decode$field,
	'champs',
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$filterMap($elm$core$Basics$identity),
		$elm$json$Json$Decode$list(
			A2(
				$elm$json$Json$Decode$andThen,
				function (id) {
					return A9(
						$elm$json$Json$Decode$map8,
						F8(
							function (cle, libelle, typeAffiche, portee, utilisePar, origine, etages, liens) {
								return A2(
									$elm$core$Maybe$map,
									function (i) {
										return A9($author$project$Components$Shared$Bibliotheque$Champ$ChampDeLaBibliotheque, i, cle, libelle, typeAffiche, portee, utilisePar, origine, etages, liens);
									},
									id);
							}),
						A2($elm$json$Json$Decode$field, 'cle', $elm$json$Json$Decode$string),
						A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string),
						A2($elm$json$Json$Decode$field, 'typeAffiche', $elm$json$Json$Decode$string),
						A2($elm$json$Json$Decode$field, 'portee', $elm$json$Json$Decode$string),
						A2($elm$json$Json$Decode$field, 'utilisePar', $elm$json$Json$Decode$int),
						$elm$json$Json$Decode$maybe(
							A2($elm$json$Json$Decode$field, 'origine', $author$project$Components$Shared$Bibliotheque$Champ$origineDecoder)),
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$json$Json$Decode$field,
									'etages',
									$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
									$elm$json$Json$Decode$succeed(_List_Nil)
								])),
						A2($elm$json$Json$Decode$field, '_links', $author$project$API$Liens$decoder));
				},
				$elm$json$Json$Decode$maybe(
					A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string))))));
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$Catalogue = function (arbre) {
	return function (totaux) {
		return function (niveaux) {
			return function (etats) {
				return function (etatDeDepart) {
					return function (rattachement) {
						return function (types) {
							return function (produits) {
								return function (classifications) {
									return function (liens) {
										return function (gabarits) {
											return {tA: arbre, vk: classifications, yO: etatDeDepart, mj: etats, gF: gabarits, nQ: liens, C9: niveaux, aK: produits, pN: rattachement, rJ: totaux, ib: types};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$Classification = F3(
	function (id, libelles, valeurs) {
		return {Aq: id, R: libelles, Ki: valeurs};
	});
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$Niveau = F5(
	function (id, archetype, utilise, parDefaut, libelles) {
		return {fA: archetype, Aq: id, R: libelles, o6: parDefaut, Kg: utilise};
	});
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$Produit = F5(
	function (id, libelles, typeDeProduit, parent, chemin) {
		return {jK: chemin, Aq: id, R: libelles, ey: parent, fh: typeDeProduit};
	});
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$Rattachement = F3(
	function (attendu, admisPourUnService, parentDUnProduit) {
		return {sX: admisPourUnService, tR: attendu, EY: parentDUnProduit};
	});
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$Totaux = F3(
	function (references, nonPubliables, produits) {
		return {DM: nonPubliables, aK: produits, hD: references};
	});
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$TypePropose = F4(
	function (id, nom, nature, version) {
		return {Aq: id, g1: nature, Dj: nom, sq: version};
	});
var $author$project$Catalogue$Identifiants$classificationIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Catalogue$Identifiants$elementIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Catalogue$Identifiants$etatCodeDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Catalogue$API$QueryAPIModel$EtatDuClient = F4(
	function (code, parDefaut, libelles, rang) {
		return {vx: code, R: libelles, o6: parDefaut, bY: rang};
	});
var $author$project$Catalogue$API$QueryAPIModel$etatsDuClientDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$List$sortBy(
		function ($) {
			return $.bY;
		}),
	$elm$json$Json$Decode$list(
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'rang',
			$elm$json$Json$Decode$int,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'libelles',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'parDefaut',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'code',
						$author$project$Catalogue$Identifiants$etatCodeDecoder,
						$elm$json$Json$Decode$succeed($author$project$Catalogue$API$QueryAPIModel$EtatDuClient)))))));
var $author$project$Catalogue$Identifiants$niveauIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$Enfants = $elm$core$Basics$identity;
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$Noeud = F5(
	function (cible, niveau, libelles, references, enfants) {
		return {vf: cible, yp: enfants, R: libelles, os: niveau, hD: references};
	});
var $author$project$Catalogue$API$QueryAPIModel$Cible = F4(
	function (element, typeDeProduit, valeur, nature) {
		return {lQ: element, g1: nature, fh: typeDeProduit, fm: valeur};
	});
var $author$project$Catalogue$Identifiants$valeurIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Catalogue$API$QueryAPIModel$cibleDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'nature',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'valeur',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Identifiants$valeurIdDecoder),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'typeDeProduit',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Identifiants$typeDeProduitIdDecoder),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'element',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Identifiants$elementIdDecoder),
				$elm$core$Maybe$Nothing,
				$elm$json$Json$Decode$succeed($author$project$Catalogue$API$QueryAPIModel$Cible)))));
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
function $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$cyclic$noeudDecoder() {
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'enfants',
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Basics$identity,
			$elm$json$Json$Decode$list(
				$elm$json$Json$Decode$lazy(
					function (_v0) {
						return $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$cyclic$noeudDecoder();
					}))),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'references',
			$elm$json$Json$Decode$int,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'libelles',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'niveau',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Identifiants$niveauIdDecoder),
					$elm$core$Maybe$Nothing,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						$author$project$Catalogue$API$QueryAPIModel$cibleDecoder,
						$elm$json$Json$Decode$succeed($author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$Noeud))))));
}
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$noeudDecoder = $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$cyclic$noeudDecoder();
$author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$cyclic$noeudDecoder = function () {
	return $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$noeudDecoder;
};
var $author$project$Catalogue$API$WriteAPIModel$valeurDuDessusDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'Libre',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Catalogue$API$WriteAPIModel$LibreDuDessus,
				A2($elm$json$Json$Decode$field, 'valeur', $author$project$Catalogue$Identifiants$valeurIdDecoder))),
			A2(
			$elm$json$Json$Decode$field,
			'Element',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Catalogue$API$WriteAPIModel$ElementDuDessus,
				A2($elm$json$Json$Decode$field, 'element', $author$project$Catalogue$Identifiants$elementIdDecoder)))
		]));
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$catalogueDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.gF;
		},
		$author$project$API$Liens$deLaRessource),
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		A2(
			$elm$json$Json$Decode$map,
			function ($) {
				return $.h0;
			},
			$author$project$API$Liens$deLaRessource),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'classifications',
			$elm$json$Json$Decode$list(
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'valeurs',
					$elm$json$Json$Decode$list(
						A3(
							$elm$json$Json$Decode$map2,
							F2(
								function (id, libelles) {
									return {Aq: id, R: libelles};
								}),
							A2($elm$json$Json$Decode$field, 'id', $author$project$Catalogue$Identifiants$valeurIdDecoder),
							A2($elm$json$Json$Decode$field, 'libelles', $author$project$Catalogue$API$QueryAPIModel$libellesDecoder))),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'libelles',
						$author$project$Catalogue$API$QueryAPIModel$libellesDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$author$project$Catalogue$Identifiants$classificationIdDecoder,
							$elm$json$Json$Decode$succeed($author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$Classification))))),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'produits',
				$elm$json$Json$Decode$list(
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'chemin',
						A2(
							$elm$json$Json$Decode$map,
							$elm$core$Maybe$Just,
							$elm$json$Json$Decode$list($author$project$Catalogue$API$WriteAPIModel$valeurDuDessusDecoder)),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'parent',
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Identifiants$elementIdDecoder),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'typeDeProduit',
								$author$project$Catalogue$Identifiants$typeDeProduitIdDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'libelles',
									$author$project$Catalogue$API$QueryAPIModel$libellesDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$author$project$Catalogue$Identifiants$elementIdDecoder,
										$elm$json$Json$Decode$succeed($author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$Produit))))))),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'types',
					$elm$json$Json$Decode$list(
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'version',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'nature',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'nom',
									$author$project$Catalogue$API$QueryAPIModel$libellesDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$author$project$Catalogue$Identifiants$typeDeProduitIdDecoder,
										$elm$json$Json$Decode$succeed($author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$TypePropose)))))),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'rattachement',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'parentDUnProduit',
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Identifiants$niveauIdDecoder),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'admisPourUnService',
								$elm$json$Json$Decode$list($author$project$Catalogue$Identifiants$niveauIdDecoder),
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'attendu',
									A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Identifiants$niveauIdDecoder),
									$elm$core$Maybe$Nothing,
									$elm$json$Json$Decode$succeed($author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$Rattachement)))),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'etatDeDepart',
							$elm$json$Json$Decode$keyValuePairs($author$project$Catalogue$Identifiants$etatCodeDecoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'etats',
								$author$project$Catalogue$API$QueryAPIModel$etatsDuClientDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'niveaux',
									$elm$json$Json$Decode$list(
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'libelles',
											A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
											$elm$core$Maybe$Nothing,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'parDefaut',
												$elm$json$Json$Decode$bool,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'utilise',
													$elm$json$Json$Decode$bool,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'archetype',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'id',
															$author$project$Catalogue$Identifiants$niveauIdDecoder,
															$elm$json$Json$Decode$succeed($author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$Niveau))))))),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'totaux',
										A4(
											$elm$json$Json$Decode$map3,
											$author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$Totaux,
											A2($elm$json$Json$Decode$field, 'references', $elm$json$Json$Decode$int),
											A2($elm$json$Json$Decode$field, 'nonPubliables', $elm$json$Json$Decode$int),
											A2($elm$json$Json$Decode$field, 'produits', $elm$json$Json$Decode$int)),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'arbre',
											$elm$json$Json$Decode$list($author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$noeudDecoder),
											$elm$json$Json$Decode$succeed($author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$Catalogue))))))))))));
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$catalogueDesFiltresLu = F2(
	function (reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$catalogueDecoder, reponse);
		if (!_v0.$) {
			var catalogue = _v0.a;
			var lu = _Utils_update(
				model,
				{
					jB: $elm$core$Maybe$Just(catalogue)
				});
			return _Utils_Tuple2(
				lu,
				$author$project$Components$Produits$StructureCatalogue$Informations$Update$lireLesFiltres(lu));
		} else {
			var refus = _v0.a;
			return _Utils_Tuple2(
				model,
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Produits$StructureCatalogue$Effet$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Effet$DemanderLApercuDArchivage = F3(
	function (a, b, c) {
		return {$: 11, a: a, b: b, c: c};
	});
var $author$project$API$NavLinksDictionary$apercuDeLArchivage = 'apercu-de-l-archivage';
var $author$project$Components$Produits$StructureCatalogue$Archivage$Model$choix = function (archivage) {
	return {
		it: archivage.it,
		vf: archivage.vf,
		wg: archivage.Ki,
		zH: (!archivage.F$) ? $elm$core$Maybe$Nothing : A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.f$;
			},
			archivage.zH),
		hD: (!archivage.F$) ? _List_Nil : archivage.hD
	};
};
var $author$project$Components$Produits$StructureCatalogue$Archivage$Update$typologieDe = F2(
	function (id, model) {
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.vk;
				},
				$author$project$Components$Produits$StructureCatalogue$Classifications$Model$classificationDe(id)),
			model.h$);
	});
var $author$project$Components$Produits$StructureCatalogue$Archivage$Update$demanderLApercu = function (model) {
	var archivage = model.tD;
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		function (id) {
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$pair(id),
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.nQ;
						},
						$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$apercuDeLArchivage)),
					A2($author$project$Components$Produits$StructureCatalogue$Archivage$Update$typologieDe, id, model)));
		},
		archivage.r3);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var id = _v1.a;
		var lien = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					tD: _Utils_update(
						archivage,
						{tq: $elm$core$Maybe$Nothing})
				}),
			_List_fromArray(
				[
					A3(
					$author$project$Components$Produits$StructureCatalogue$Effet$DemanderLApercuDArchivage,
					lien,
					id,
					$author$project$Components$Produits$StructureCatalogue$Archivage$Model$choix(archivage))
				]));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Archivage$Update$changerLeChoix = F2(
	function (changer, model) {
		return (model.tD.a6.d8 || (!_Utils_eq(model.tD.a6.qD, $elm$core$Maybe$Nothing))) ? _Utils_Tuple2(model, _List_Nil) : $author$project$Components$Produits$StructureCatalogue$Archivage$Update$demanderLApercu(
			_Utils_update(
				model,
				{
					tD: changer(model.tD),
					aL: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Components$Produits$StructureCatalogue$Archivage$Update$categorieBasculee = F2(
	function (id, model) {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Archivage$Update$changerLeChoix,
			function (a) {
				return _Utils_update(
					a,
					{
						it: A2($elm$core$List$member, id, a.it) ? A2(
							$elm$core$List$filter,
							$elm$core$Basics$neq(id),
							a.it) : A2($elm$core$List$cons, id, a.it)
					});
			},
			model);
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$Categorie = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$Porteur = function (portee) {
	return function (version) {
		return function (champs) {
			return function (renseignees) {
				return function (minima) {
					return function (articles) {
						return function (fichesHeritieres) {
							return function (perimetres) {
								return function (restrictions) {
									return function (liens) {
										return {tP: articles, dw: champs, zy: fichesHeritieres, nQ: liens, CC: minima, pg: perimetres, F$: portee, qr: renseignees, qF: restrictions, sq: version};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$ChampDuPorteur = F4(
	function (champ, typeDeChamp, masque, liens) {
		return {uN: champ, nQ: liens, n4: masque, JR: typeDeChamp};
	});
var $author$project$Components$Shared$EditeurDeSchema$Champ$AutreType = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$AvecUnite = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$Champ = function (cle) {
	return function (libelle) {
		return function (type_) {
			return function (obligatoire) {
				return function (aide) {
					return function (regles) {
						return function (donneePersonnelle) {
							return function (conservationEnMois) {
								return function (libelles) {
									return function (aides) {
										return function (visibilite) {
											return function (formule) {
												return function (aLaPublication) {
													return function (traduisible) {
														return function (libellesDesValeurs) {
															return {sG: aLaPublication, bp: aide, bq: aides, dy: cle, v6: conservationEnMois, xD: donneePersonnelle, zU: formule, Bl: libelle, R: libelles, Bt: libellesDesValeurs, he: obligatoire, hJ: regles, h8: traduisible, r0: type_, KQ: visibilite};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$ChoixMultiples = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$Fichier = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$Groupe = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$Liste = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Shared$GenreDuNom$Masculin = 1;
var $author$project$Components$Shared$EditeurDeSchema$Champ$Mesure = F5(
	function (unite, affichage, decimales, min, max) {
		return {iF: affichage, kv: decimales, Cg: max, Cx: min, sa: unite};
	});
var $author$project$Components$Shared$EditeurDeSchema$Champ$Pays = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$brut = A2(
	$elm$json$Json$Decode$map,
	$elm$json$Json$Encode$encode(0),
	$elm$json$Json$Decode$value);
var $author$project$Components$Shared$EditeurDeSchema$Champ$ChoixDansUneListe = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$referenceDeListe = A2(
	$elm$json$Json$Decode$andThen,
	function (cible) {
		return A2($elm$core$String$startsWith, $author$project$Components$Shared$EditeurDeSchema$Champ$prefixeDeListe, cible) ? $elm$json$Json$Decode$succeed(
			A2(
				$elm$core$String$dropLeft,
				$elm$core$String$length($author$project$Components$Shared$EditeurDeSchema$Champ$prefixeDeListe),
				cible)) : $elm$json$Json$Decode$fail(cible);
	},
	A2(
		$elm$json$Json$Decode$field,
		'Ref',
		A2($elm$json$Json$Decode$field, 'target', $elm$json$Json$Decode$string)));
var $author$project$Components$Shared$EditeurDeSchema$Champ$choixDansUneListe = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$map,
			function (liste) {
				return $author$project$Components$Shared$EditeurDeSchema$Champ$ChoixDansUneListe(
					{nW: liste, FS: false});
			},
			$author$project$Components$Shared$EditeurDeSchema$Champ$referenceDeListe),
			A2(
			$elm$json$Json$Decode$field,
			'Arr',
			A2(
				$elm$json$Json$Decode$field,
				'of',
				A2(
					$elm$json$Json$Decode$map,
					function (liste) {
						return $author$project$Components$Shared$EditeurDeSchema$Champ$ChoixDansUneListe(
							{nW: liste, FS: true});
					},
					$author$project$Components$Shared$EditeurDeSchema$Champ$referenceDeListe)))
		]));
var $author$project$Components$Shared$EditeurDeSchema$Champ$ChoixDansUneListePartagee = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$option = F2(
	function (nom, lu) {
		return $elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, nom, lu));
	});
var $author$project$Components$Shared$EditeurDeSchema$Champ$choixDansUneListePartagee = A2(
	$elm$json$Json$Decode$field,
	'Choice',
	A5(
		$elm$json$Json$Decode$map4,
		F4(
			function (ensemble, plusieurs, min, max) {
				return $author$project$Components$Shared$EditeurDeSchema$Champ$ChoixDansUneListePartagee(
					{ys: ensemble, Cg: max, Cx: min, FS: plusieurs});
			}),
		A2($elm$json$Json$Decode$field, 'valueSet', $elm$json$Json$Decode$string),
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2($elm$json$Json$Decode$field, 'multiple', $elm$json$Json$Decode$bool),
					$elm$json$Json$Decode$succeed(false)
				])),
		A2($author$project$Components$Shared$EditeurDeSchema$Champ$option, 'min', $elm$json$Json$Decode$int),
		A2($author$project$Components$Shared$EditeurDeSchema$Champ$option, 'max', $elm$json$Json$Decode$int)));
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Components$Shared$GenreDuNom$Feminin = 0;
var $author$project$Components$Shared$GenreDuNom$deCode = function (texte) {
	switch (texte) {
		case 'feminin':
			return $elm$core$Maybe$Just(0);
		case 'masculin':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$genreDepuis = function (texte) {
	return A2(
		$elm$core$Maybe$withDefault,
		1,
		$author$project$Components$Shared$GenreDuNom$deCode(texte));
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$LienVersDesArticles = function (a) {
	return {$: 18, a: a};
};
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $author$project$Components$Shared$EditeurDeSchema$Champ$referenceDeRessource = A2(
	$elm$json$Json$Decode$andThen,
	function (cible) {
		return A2($elm$core$String$startsWith, $author$project$Components$Shared$EditeurDeSchema$Champ$prefixeDeRessource, cible) ? $elm$json$Json$Decode$succeed(
			A2(
				$elm$core$String$dropLeft,
				$elm$core$String$length($author$project$Components$Shared$EditeurDeSchema$Champ$prefixeDeRessource),
				cible)) : $elm$json$Json$Decode$fail(cible);
	},
	A2(
		$elm$json$Json$Decode$field,
		'Ref',
		A2($elm$json$Json$Decode$field, 'target', $elm$json$Json$Decode$string)));
function $author$project$Components$Shared$EditeurDeSchema$Champ$cyclic$lienVersDesArticles() {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				function (cible) {
					return $author$project$Components$Shared$EditeurDeSchema$Champ$LienVersDesArticles(
						{vf: cible, FS: false});
				},
				$author$project$Components$Shared$EditeurDeSchema$Champ$referenceDeRessource),
				A2(
				$elm$json$Json$Decode$field,
				'Arr',
				A2(
					$elm$json$Json$Decode$field,
					'of',
					A2(
						$elm$json$Json$Decode$map,
						function (cible) {
							return $author$project$Components$Shared$EditeurDeSchema$Champ$LienVersDesArticles(
								{vf: cible, FS: true});
						},
						$author$project$Components$Shared$EditeurDeSchema$Champ$referenceDeRessource))),
				A2(
				$elm$json$Json$Decode$field,
				'Obj',
				A2(
					$elm$json$Json$Decode$field,
					'fields',
					A2(
						$elm$json$Json$Decode$index,
						0,
						A2(
							$elm$json$Json$Decode$field,
							'type',
							$elm$json$Json$Decode$lazy(
								function (_v0) {
									return $author$project$Components$Shared$EditeurDeSchema$Champ$cyclic$lienVersDesArticles();
								})))))
			]));
}
var $author$project$Components$Shared$EditeurDeSchema$Champ$lienVersDesArticles = $author$project$Components$Shared$EditeurDeSchema$Champ$cyclic$lienVersDesArticles();
$author$project$Components$Shared$EditeurDeSchema$Champ$cyclic$lienVersDesArticles = function () {
	return $author$project$Components$Shared$EditeurDeSchema$Champ$lienVersDesArticles;
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$parCle = $elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$string);
var $author$project$Components$Shared$EditeurDeSchema$Champ$PartiePrenante = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$partiePrenante = A2(
	$elm$json$Json$Decode$andThen,
	function (cible) {
		return A2($elm$core$String$startsWith, $author$project$Components$Shared$EditeurDeSchema$Champ$prefixeDePartiePrenante, cible) ? $elm$json$Json$Decode$succeed(
			$author$project$Components$Shared$EditeurDeSchema$Champ$PartiePrenante(
				{
					r$: A2(
						$elm$core$String$dropLeft,
						$elm$core$String$length($author$project$Components$Shared$EditeurDeSchema$Champ$prefixeDePartiePrenante),
						cible)
				})) : $elm$json$Json$Decode$fail(cible);
	},
	A2(
		$elm$json$Json$Decode$field,
		'Ref',
		A2($elm$json$Json$Decode$field, 'target', $elm$json$Json$Decode$string)));
var $author$project$Components$Shared$EditeurDeSchema$Champ$AutreRegle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$Bornes = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Shared$EditeurDeSchema$Champ$Longueur = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Shared$EditeurDeSchema$Champ$Motif = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Shared$EditeurDeSchema$Champ$Unique = {$: 3};
var $author$project$Components$Shared$EditeurDeSchema$Champ$BorneAujourdhui = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$BorneJour = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$BorneNombre = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$borneDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'Nombre',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Shared$EditeurDeSchema$Champ$BorneNombre,
				A2($elm$json$Json$Decode$field, 'valeur', $elm$json$Json$Decode$float))),
			A2(
			$elm$json$Json$Decode$field,
			'Jour',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Shared$EditeurDeSchema$Champ$BorneJour,
				A2($elm$json$Json$Decode$field, 'date', $elm$json$Json$Decode$string))),
			A2(
			$elm$json$Json$Decode$field,
			'Aujourdhui',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Shared$EditeurDeSchema$Champ$BorneAujourdhui,
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							A2($elm$json$Json$Decode$field, 'inclus', $elm$json$Json$Decode$bool),
							$elm$json$Json$Decode$succeed(false)
						]))))
		]));
var $author$project$Components$Shared$EditeurDeSchema$Champ$regleDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'Bornes',
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Components$Shared$EditeurDeSchema$Champ$Bornes,
				A2($author$project$Components$Shared$EditeurDeSchema$Champ$option, 'min', $author$project$Components$Shared$EditeurDeSchema$Champ$borneDecoder),
				A2($author$project$Components$Shared$EditeurDeSchema$Champ$option, 'max', $author$project$Components$Shared$EditeurDeSchema$Champ$borneDecoder))),
			A2(
			$elm$json$Json$Decode$field,
			'Longueur',
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Components$Shared$EditeurDeSchema$Champ$Longueur,
				A2($author$project$Components$Shared$EditeurDeSchema$Champ$option, 'min', $elm$json$Json$Decode$int),
				A2($author$project$Components$Shared$EditeurDeSchema$Champ$option, 'max', $elm$json$Json$Decode$int))),
			A2(
			$elm$json$Json$Decode$field,
			'Motif',
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Components$Shared$EditeurDeSchema$Champ$Motif,
				A2($elm$json$Json$Decode$field, 'regex', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string))),
			A2(
			$elm$json$Json$Decode$field,
			'Unique',
			$elm$json$Json$Decode$succeed($author$project$Components$Shared$EditeurDeSchema$Champ$Unique)),
			A2($elm$json$Json$Decode$map, $author$project$Components$Shared$EditeurDeSchema$Champ$AutreRegle, $author$project$Components$Shared$EditeurDeSchema$Champ$brut)
		]));
var $author$project$Components$Shared$EditeurDeSchema$Champ$Utilisateur = {$: 20};
var $author$project$Components$Shared$EditeurDeSchema$Champ$utilisateur = A2(
	$elm$json$Json$Decode$andThen,
	function (cible) {
		return (cible === 'utilisateur') ? $elm$json$Json$Decode$succeed($author$project$Components$Shared$EditeurDeSchema$Champ$Utilisateur) : $elm$json$Json$Decode$fail(cible);
	},
	A2(
		$elm$json$Json$Decode$field,
		'Ref',
		A2($elm$json$Json$Decode$field, 'target', $elm$json$Json$Decode$string)));
var $author$project$Components$Shared$EditeurDeSchema$Champ$AutreCondition = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$SiRempli = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$visibiliteDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'Rempli',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Shared$EditeurDeSchema$Champ$SiRempli,
				A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string))),
			A2($elm$json$Json$Decode$map, $author$project$Components$Shared$EditeurDeSchema$Champ$AutreCondition, $author$project$Components$Shared$EditeurDeSchema$Champ$brut)
		]));
function $author$project$Components$Shared$EditeurDeSchema$Champ$cyclic$decoder() {
	return $author$project$Components$Shared$EditeurDeSchema$Champ$cyclic$champDecoder();
}
function $author$project$Components$Shared$EditeurDeSchema$Champ$cyclic$champDecoder() {
	return A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'libellesDesValeurs',
		$elm$json$Json$Decode$keyValuePairs($author$project$Components$Shared$EditeurDeSchema$Champ$parCle),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'traduisible',
			$elm$json$Json$Decode$bool,
			false,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'exigence',
				$elm$json$Json$Decode$succeed(true),
				false,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'formule',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'visibleSi',
						$author$project$Components$Shared$EditeurDeSchema$Champ$visibiliteDecoder,
						$author$project$Components$Shared$EditeurDeSchema$Champ$Toujours,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'aides',
							$author$project$Components$Shared$EditeurDeSchema$Champ$parCle,
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'libelles',
								$author$project$Components$Shared$EditeurDeSchema$Champ$parCle,
								_List_Nil,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'conservation',
									A2(
										$elm$json$Json$Decode$map,
										$elm$core$Maybe$Just,
										A2($elm$json$Json$Decode$field, 'mois', $elm$json$Json$Decode$int)),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'donneePersonnelle',
										$elm$json$Json$Decode$bool,
										false,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'regles',
											$elm$json$Json$Decode$list($author$project$Components$Shared$EditeurDeSchema$Champ$regleDecoder),
											_List_Nil,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'description',
												$elm$json$Json$Decode$string,
												'',
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'required',
													$elm$json$Json$Decode$bool,
													false,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'type',
														$author$project$Components$Shared$EditeurDeSchema$Champ$cyclic$typeDecoder(),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'label',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'name',
																$elm$json$Json$Decode$string,
																$elm$json$Json$Decode$succeed($author$project$Components$Shared$EditeurDeSchema$Champ$Champ))))))))))))))));
}
function $author$project$Components$Shared$EditeurDeSchema$Champ$cyclic$typeDecoder() {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$oneOf(
				A2(
					$elm$core$List$map,
					function (_v1) {
						var nom = _v1.a;
						var type_ = _v1.b;
						return A2(
							$elm$json$Json$Decode$field,
							nom,
							$elm$json$Json$Decode$succeed(type_));
					},
					$author$project$Components$Shared$EditeurDeSchema$Champ$typesSansAttribut)),
				A2(
				$elm$json$Json$Decode$field,
				'DecimalNumber',
				$elm$json$Json$Decode$succeed($author$project$Components$Shared$EditeurDeSchema$Champ$Nombre)),
				A2(
				$elm$json$Json$Decode$field,
				'Country',
				$elm$json$Json$Decode$succeed(
					$author$project$Components$Shared$EditeurDeSchema$Champ$Pays(
						{FS: false}))),
				A2(
				$elm$json$Json$Decode$field,
				'Arr',
				A2(
					$elm$json$Json$Decode$field,
					'of',
					A2(
						$elm$json$Json$Decode$field,
						'Country',
						$elm$json$Json$Decode$succeed(
							$author$project$Components$Shared$EditeurDeSchema$Champ$Pays(
								{FS: true}))))),
				A2(
				$elm$json$Json$Decode$field,
				'Enum',
				A2(
					$elm$json$Json$Decode$map,
					$author$project$Components$Shared$EditeurDeSchema$Champ$Liste,
					A2(
						$elm$json$Json$Decode$field,
						'values',
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string)))),
				A2(
				$elm$json$Json$Decode$field,
				'MultiEnum',
				A4(
					$elm$json$Json$Decode$map3,
					F3(
						function (valeurs, min, max) {
							return $author$project$Components$Shared$EditeurDeSchema$Champ$ChoixMultiples(
								{Cg: max, Cx: min, Ki: valeurs});
						}),
					A2(
						$elm$json$Json$Decode$field,
						'values',
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
					A2($author$project$Components$Shared$EditeurDeSchema$Champ$option, 'min', $elm$json$Json$Decode$int),
					A2($author$project$Components$Shared$EditeurDeSchema$Champ$option, 'max', $elm$json$Json$Decode$int))),
				A2(
				$elm$json$Json$Decode$field,
				'File',
				A3(
					$elm$json$Json$Decode$map2,
					F2(
						function (medias, taille) {
							return $author$project$Components$Shared$EditeurDeSchema$Champ$Fichier(
								{Jn: taille, r1: medias});
						}),
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$json$Json$Decode$field,
								'mediaTypes',
								$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
								$elm$json$Json$Decode$succeed(_List_Nil)
							])),
					A2($author$project$Components$Shared$EditeurDeSchema$Champ$option, 'maxBytes', $elm$json$Json$Decode$int))),
				A2(
				$elm$json$Json$Decode$field,
				'Measure',
				A2(
					$elm$json$Json$Decode$map,
					$author$project$Components$Shared$EditeurDeSchema$Champ$AvecUnite,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'max',
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$float),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'min',
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$float),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'decimales',
								$elm$json$Json$Decode$int,
								0,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'affichage',
									$author$project$Components$Shared$EditeurDeSchema$Champ$parCle,
									_List_Nil,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'unite',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Components$Shared$EditeurDeSchema$Champ$Mesure)))))))),
				$author$project$Components$Shared$EditeurDeSchema$Champ$choixDansUneListe,
				$author$project$Components$Shared$EditeurDeSchema$Champ$lienVersDesArticles,
				$author$project$Components$Shared$EditeurDeSchema$Champ$partiePrenante,
				$author$project$Components$Shared$EditeurDeSchema$Champ$utilisateur,
				$author$project$Components$Shared$EditeurDeSchema$Champ$choixDansUneListePartagee,
				$author$project$Components$Shared$EditeurDeSchema$Champ$cyclic$groupe(),
				A2($elm$json$Json$Decode$map, $author$project$Components$Shared$EditeurDeSchema$Champ$AutreType, $author$project$Components$Shared$EditeurDeSchema$Champ$brut)
			]));
}
function $author$project$Components$Shared$EditeurDeSchema$Champ$cyclic$groupe() {
	var occurrence = A2(
		$elm$json$Json$Decode$field,
		'Obj',
		A2(
			$elm$json$Json$Decode$field,
			'fields',
			$elm$json$Json$Decode$list(
				$elm$json$Json$Decode$lazy(
					function (_v0) {
						return $author$project$Components$Shared$EditeurDeSchema$Champ$cyclic$decoder();
					}))));
	var contenu = F2(
		function (repetable, champs) {
			return $author$project$Components$Shared$EditeurDeSchema$Champ$Groupe(
				{
					z9: A2(
						$elm$core$Maybe$withDefault,
						1,
						A2(
							$elm$core$Maybe$map,
							$author$project$Components$Shared$EditeurDeSchema$Champ$genreDepuis,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.bp;
								},
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.dy;
											},
											$elm$core$Basics$eq($author$project$Components$Shared$EditeurDeSchema$Champ$cleDeLOccurrence)),
										champs))))),
					Bq: A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.Bl;
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.dy;
										},
										$elm$core$Basics$eq($author$project$Components$Shared$EditeurDeSchema$Champ$cleDeLOccurrence)),
									champs)))),
					Cd: A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.bp;
								},
								A2(
									$elm$core$Basics$composeR,
									$elm$core$String$split(','),
									A2(
										$elm$core$Basics$composeR,
										$elm$core$List$map($elm$core$String$trim),
										$elm$core$List$filter(
											$elm$core$Basics$neq(''))))),
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.dy;
										},
										$elm$core$Basics$eq($author$project$Components$Shared$EditeurDeSchema$Champ$cleDesMasques)),
									champs)))),
					HI: repetable,
					IX: A2(
						$elm$core$List$filter,
						function (champ) {
							return (!_Utils_eq(champ.dy, $author$project$Components$Shared$EditeurDeSchema$Champ$cleDeLOccurrence)) && ((!_Utils_eq(champ.dy, $author$project$Components$Shared$EditeurDeSchema$Champ$cleDesMasques)) && (!_Utils_eq(champ.dy, $author$project$Components$Shared$EditeurDeSchema$Champ$cleDesUniques)));
						},
						champs),
					r9: A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.bp;
								},
								A2(
									$elm$core$Basics$composeR,
									$elm$core$String$split(','),
									A2(
										$elm$core$Basics$composeR,
										$elm$core$List$map($elm$core$String$trim),
										$elm$core$List$filter(
											$elm$core$Basics$neq(''))))),
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.dy;
										},
										$elm$core$Basics$eq($author$project$Components$Shared$EditeurDeSchema$Champ$cleDesUniques)),
									champs))))
				});
		});
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				contenu(false),
				occurrence),
				A2(
				$elm$json$Json$Decode$field,
				'Arr',
				A2(
					$elm$json$Json$Decode$field,
					'of',
					A2(
						$elm$json$Json$Decode$map,
						contenu(true),
						occurrence)))
			]));
}
var $author$project$Components$Shared$EditeurDeSchema$Champ$decoder = $author$project$Components$Shared$EditeurDeSchema$Champ$cyclic$decoder();
$author$project$Components$Shared$EditeurDeSchema$Champ$cyclic$decoder = function () {
	return $author$project$Components$Shared$EditeurDeSchema$Champ$decoder;
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$champDecoder = $author$project$Components$Shared$EditeurDeSchema$Champ$cyclic$champDecoder();
$author$project$Components$Shared$EditeurDeSchema$Champ$cyclic$champDecoder = function () {
	return $author$project$Components$Shared$EditeurDeSchema$Champ$champDecoder;
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$typeDecoder = $author$project$Components$Shared$EditeurDeSchema$Champ$cyclic$typeDecoder();
$author$project$Components$Shared$EditeurDeSchema$Champ$cyclic$typeDecoder = function () {
	return $author$project$Components$Shared$EditeurDeSchema$Champ$typeDecoder;
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$groupe = $author$project$Components$Shared$EditeurDeSchema$Champ$cyclic$groupe();
$author$project$Components$Shared$EditeurDeSchema$Champ$cyclic$groupe = function () {
	return $author$project$Components$Shared$EditeurDeSchema$Champ$groupe;
};
var $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$champDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'masque',
		$elm$json$Json$Decode$bool,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'typeDeChamp',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'champ',
				$author$project$Components$Shared$EditeurDeSchema$Champ$decoder,
				$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$ChampDuPorteur)))));
var $author$project$Components$Shared$EditeurDeSchema$Model$MinimaVoulus = F3(
	function (largeur, hauteur, texteAlternatifExige) {
		return {Ae: hauteur, Bd: largeur, Jz: texteAlternatifExige};
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$minimaDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Shared$EditeurDeSchema$Model$MinimaVoulus,
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'largeurMinimale', $elm$json$Json$Decode$int)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'hauteurMinimale', $elm$json$Json$Decode$int)),
	A2($elm$json$Json$Decode$field, 'texteAlternatifExige', $elm$json$Json$Decode$bool));
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt = F3(
	function (path, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$at, path, valDecoder),
			decoder);
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$ficheDeCategorieDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (id) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2(
				$elm$json$Json$Decode$map,
				function ($) {
					return $.h0;
				},
				$author$project$API$Liens$deLaRessource),
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'minima',
				$elm$json$Json$Decode$dict($author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$minimaDecoder),
				$elm$core$Dict$empty,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'champs',
					$elm$json$Json$Decode$list($author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$champDecoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['typeDeProduit', 'version']),
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed(
							F4(
								function (version, champs, minima, liens) {
									return $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$Porteur(
										$author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$Categorie(id))(version)(champs)($elm$core$Dict$empty)(minima)($elm$core$Dict$empty)(0)($elm$core$Dict$empty)($elm$core$Dict$empty)(liens);
								}))))));
	},
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['typeDeProduit', 'id']),
		$author$project$Catalogue$Identifiants$typeDeProduitIdDecoder));
var $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$categoriesDecoder = $elm$json$Json$Decode$list($author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$ficheDeCategorieDecoder);
var $author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$choisir = F2(
	function (id, rattachement) {
		return _Utils_update(
			rattachement,
			{
				vd: $elm$core$Maybe$Just(id),
				pZ: $elm$core$Maybe$Nothing
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$clesDuPorteur = F2(
	function (model, portee) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.dw;
					},
					$elm$core$List$map(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.uN;
							},
							function ($) {
								return $.dy;
							}))),
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.F3;
						},
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$filter(
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.F$;
									},
									$elm$core$Basics$eq(portee))),
							$elm$core$List$head)),
					model.AM)));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$dejaIci = F2(
	function (clesDuPorteur, lu) {
		return A2($elm$core$List$member, lu.dy, clesDuPorteur);
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$surLeRattachement = F2(
	function (changer, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					pN: changer(model.pN),
					aL: $elm$core$Maybe$Nothing
				}),
			_List_Nil);
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$champChoisi = F2(
	function (id, model) {
		var dejaPose = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$dejaIci(
					A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$clesDuPorteur, model, model.pN.F$)),
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$filter(
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(id))),
						$elm$core$List$head),
					model.dq)));
		return dejaPose ? _Utils_Tuple2(model, _List_Nil) : A2(
			$author$project$Components$Produits$StructureCatalogue$Informations$Update$surLeRattachement,
			$author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$choisir(id),
			model);
	});
var $author$project$Components$Produits$StructureCatalogue$Gammes$Model$modifierLaCase = F2(
	function (gamme, changees) {
		return A2($elm$core$List$member, gamme, changees) ? A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(gamme),
			changees) : _Utils_ap(
			changees,
			_List_fromArray(
				[gamme]));
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$changerLaCase = F2(
	function (gamme, rangement) {
		return _Utils_update(
			rangement,
			{
				gG: A2(
					$elm$core$Maybe$map,
					function (volet) {
						return _Utils_update(
							volet,
							{
								CP: A2($author$project$Components$Produits$StructureCatalogue$Gammes$Model$modifierLaCase, gamme, volet.CP)
							});
					},
					rangement.gG)
			});
	});
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$choisir = F3(
	function (rang, valeur, choix) {
		var avant = A2(
			$elm$core$List$take,
			rang,
			_Utils_ap(
				choix,
				A2($elm$core$List$repeat, rang, $elm$core$Maybe$Nothing)));
		return _Utils_eq(
			$elm$core$List$head(
				A2($elm$core$List$drop, rang, choix)),
			$elm$core$Maybe$Just(
				$elm$core$Maybe$Just(valeur))) ? avant : _Utils_ap(
			avant,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(valeur)
				]));
	});
var $author$project$Components$Produits$StructureCatalogue$Effet$LireLesPerimetres = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Etage$perimetreDe = F2(
	function (cle, ouvert) {
		return A2($elm$core$Dict$get, cle, ouvert.pg);
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$choixDUnPerimetreDemande = F2(
	function (cle, model) {
		var deja = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.Aq;
			},
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Components$Produits$StructureCatalogue$Informations$Etage$perimetreDe(cle),
				model.s));
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{Il: false},
			$author$project$Components$Shared$Drawer$Update$Ouvrir('perimetre-choisir'),
			model.dN);
		var drawer = _v0.a;
		var effets = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					cl: $elm$core$Maybe$Nothing,
					fO: $elm$core$Maybe$Just(
						{vd: deja, dy: cle, AJ: false, DX: 1, h3: ''}),
					dN: drawer
				}),
			_Utils_ap(
				A2(
					$elm$core$List$map,
					function (_v1) {
						var cible = _v1;
						return $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(cible);
					},
					effets),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Produits$StructureCatalogue$Effet$LireLesPerimetres(1),
							$elm$core$List$singleton),
						model.nI))));
	});
var $author$project$Catalogue$Identifiants$classificationIdToString = function (_v0) {
	var valeur = _v0;
	return valeur;
};
var $author$project$Components$Produits$StructureCatalogue$Archivage$Update$cibleChoisie = F2(
	function (texte, model) {
		var choisie = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.Aq;
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (c) {
						return _Utils_eq(
							$author$project$Catalogue$Identifiants$classificationIdToString(c.Aq),
							texte);
					},
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.vk;
							},
							model.h$)))));
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Archivage$Update$changerLeChoix,
			function (a) {
				return _Utils_update(
					a,
					{vf: choisie, Ki: _List_Nil});
			},
			model);
	});
var $author$project$Components$Produits$Common$ChoixDArticles$cocher = F3(
	function (id, voulue, choix) {
		return _Utils_update(
			choix,
			{
				at: voulue ? (A2($elm$core$List$member, id, choix.at) ? choix.at : _Utils_ap(
					choix.at,
					_List_fromArray(
						[id]))) : A2(
					$elm$core$List$filter,
					$elm$core$Basics$neq(id),
					choix.at)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$cocher = F3(
	function (valeur, cochee, rangement) {
		return _Utils_update(
			rangement,
			{
				vv: cochee ? (A2($elm$core$List$member, valeur, rangement.vv) ? rangement.vv : _Utils_ap(
					rangement.vv,
					_List_fromArray(
						[valeur]))) : A2(
					$elm$core$List$filter,
					$elm$core$Basics$neq(valeur),
					rangement.vv)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$cocherLaLicence = F2(
	function (cochee, rangement) {
		return _Utils_update(
			rangement,
			{IY: cochee});
	});
var $author$project$Components$Produits$StructureCatalogue$Archivage$Update$estUnLot = function (commande) {
	if (commande.$ === 19) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Archivage$Update$aucunDrawer = function (model) {
	if ($author$project$Components$Shared$Drawer$Model$estOuvert(model.tD.kX) || (!_Utils_eq(model.tD.r3, $elm$core$Maybe$Nothing))) {
		var initial = $author$project$Components$Produits$StructureCatalogue$Archivage$Model$initial;
		var ferme = function (drawer) {
			return _Utils_update(
				drawer,
				{wQ: $elm$core$Maybe$Nothing, gt: 0});
		};
		return _Utils_update(
			model,
			{
				cd: A2(
					$elm$core$List$filter,
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Components$Produits$StructureCatalogue$Archivage$Update$estUnLot),
					model.cd),
				tD: _Utils_update(
					initial,
					{
						wg: ferme(model.tD.wg),
						kX: ferme(model.tD.kX)
					}),
				aL: $elm$core$Maybe$Nothing
			});
	} else {
		return model;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Archivage$Update$conclure = F4(
	function (commande, refus, avant, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		var _v1 = _Utils_Tuple2(commande, refus);
		if (_v1.a.$ === 18) {
			if (!_v1.b.$) {
				var message = _v1.b.a;
				return $author$project$Components$Shared$Drawer$Model$estOuvert(avant.tD.kX) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aL: $elm$core$Maybe$Just(message)
						}),
					effets) : _Utils_Tuple2(model, effets);
			} else {
				var _v2 = _v1.b;
				return _Utils_Tuple2(
					$author$project$Components$Produits$StructureCatalogue$Archivage$Update$aucunDrawer(model),
					effets);
			}
		} else {
			return _Utils_Tuple2(model, effets);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$dansLeDrawer = F2(
	function (commande, model) {
		return $author$project$Components$Produits$StructureCatalogue$Classifications$Update$deClassification(commande) && $author$project$Components$Shared$Drawer$Model$estOuvert(model.vk.kX);
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$conclure = F4(
	function (commande, refus, avant, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		var _v1 = _Utils_Tuple2(
			A2($author$project$Components$Produits$StructureCatalogue$Classifications$Update$dansLeDrawer, commande, avant),
			refus);
		if (_v1.a && (!_v1.b.$)) {
			var message = _v1.b.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						aL: $elm$core$Maybe$Just(message)
					}),
				effets);
		} else {
			return _Utils_Tuple2(model, effets);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$dansUnDrawerDeSaisie = F2(
	function (commande, model) {
		switch (commande.$) {
			case 25:
				return $author$project$Components$Shared$Drawer$Model$estOuvert(model.bg);
			case 26:
				return $author$project$Components$Shared$Drawer$Model$estOuvert(model.y);
			default:
				return false;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$duRangement = function (commande) {
	if (commande.$ === 26) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$dansUnDrawer = F2(
	function (commande, model) {
		return A2($author$project$Components$Produits$StructureCatalogue$Etages$Update$dansUnDrawerDeSaisie, commande, model) || ($author$project$Components$Produits$StructureCatalogue$Etages$Update$duRangement(commande) && $author$project$Components$Shared$Drawer$Model$estOuvert(model.bZ));
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$prefixeDuRenommage = 'renommage-etage-libelle';
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$idDuLibelleDuRenommage = A2($author$project$Components$Shared$LibellesParLangue$View$idDuChamp, $author$project$Components$Produits$StructureCatalogue$Etages$Model$prefixeDuRenommage, 'fr');
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$etageDe = F2(
	function (id, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (_v0) {
				var t = _v0.b;
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(id)),
						t.yG));
			},
			$author$project$Components$Produits$StructureCatalogue$Etages$Update$reglee(model));
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$aRenommer = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		function (id) {
			return A2($author$project$Components$Produits$StructureCatalogue$Etages$Update$etageDe, id, model);
		},
		model.gr);
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$formesAEnvoyer = F3(
	function (etage, libelles, saisies) {
		return A3($author$project$Components$Produits$StructureCatalogue$Etages$Model$formesEcrites, etage.m$, libelles, saisies);
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$renommage = function (etage) {
	var _v0 = etage.xt;
	if (_v0.$ === 1) {
		var libelles = _v0.a;
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Saisie$renommer,
			$elm$core$Maybe$Just(libelles),
			_Utils_Tuple2('', ''));
	} else {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Saisie$renommer,
			$elm$core$Maybe$Nothing,
			_Utils_Tuple2('', ''));
	}
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$saisieDepuisLEnvoi = F2(
	function (commande, model) {
		var _v0 = _Utils_Tuple2(
			commande,
			$author$project$Components$Produits$StructureCatalogue$Etages$Update$aRenommer(model));
		if ((_v0.a.$ === 25) && (!_v0.b.$)) {
			var _v1 = _v0.a;
			var envoyes = _v1.c;
			var formes = _v1.d;
			var etage = _v0.b.a;
			var envoye = _Utils_update(
				etage,
				{
					xt: $author$project$Catalogue$API$QueryAPIModel$Libre(envoyes),
					m$: A2(
						$elm$core$Maybe$withDefault,
						etage.m$,
						A2(
							$elm$core$Maybe$map,
							function (ecrites) {
								return $author$project$Catalogue$Formes$sontVides(ecrites) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(ecrites);
							},
							formes))
				});
			return (!_Utils_eq(
				A2($author$project$Components$Produits$StructureCatalogue$Etages$Model$renommage, envoye, model.D),
				$author$project$Components$Produits$StructureCatalogue$Saisie$Inchange)) || (!_Utils_eq(
				A3($author$project$Components$Produits$StructureCatalogue$Etages$Model$formesAEnvoyer, envoye, envoyes, model.I),
				$elm$core$Maybe$Nothing));
		} else {
			return false;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$conclureLeDrawer = F4(
	function (commande, refus, avant, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		var ajout = $author$project$Components$Shared$Drawer$Model$estOuvert(avant.y);
		if (!A2($author$project$Components$Produits$StructureCatalogue$Etages$Update$dansUnDrawer, commande, avant)) {
			return _Utils_Tuple2(model, effets);
		} else {
			if (!A2($author$project$Components$Produits$StructureCatalogue$Etages$Update$dansUnDrawerDeSaisie, commande, avant)) {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aL: refus}),
					effets);
			} else {
				if (!refus.$) {
					var message = refus.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aL: $elm$core$Maybe$Just(message)
							}),
						_Utils_ap(
							effets,
							_List_fromArray(
								[
									$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(
									ajout ? $author$project$Components$Produits$StructureCatalogue$Etages$Model$idDuLibelleDeLAjout : $author$project$Components$Produits$StructureCatalogue$Etages$Model$idDuLibelleDuRenommage)
								])));
				} else {
					return ajout ? A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Produits$StructureCatalogue$Etages$Update$versLAjout,
							$author$project$Components$Shared$Drawer$Update$Fermer,
							_Utils_update(
								model,
								{D: $author$project$Components$Produits$StructureCatalogue$Saisie$vide}))) : (A2($author$project$Components$Produits$StructureCatalogue$Etages$Update$saisieDepuisLEnvoi, commande, model) ? _Utils_Tuple2(model, effets) : _Utils_Tuple2(
						$author$project$Components$Produits$StructureCatalogue$Etages$Update$ferme(model),
						_Utils_ap(
							effets,
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus, $elm$core$List$singleton),
									model.bg.wQ)))));
				}
			}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$conclure = F4(
	function (commande, refus, avant, pas) {
		return function () {
			if (commande.$ === 26) {
				return $elm$core$Tuple$mapFirst(
					function (model) {
						return _Utils_update(
							model,
							{q: $author$project$Components$Produits$StructureCatalogue$Etages$Model$SansReecriture});
					});
			} else {
				return $elm$core$Basics$identity;
			}
		}()(
			A4($author$project$Components$Produits$StructureCatalogue$Etages$Update$conclureLeDrawer, commande, refus, avant, pas));
	});
var $author$project$Components$Produits$StructureCatalogue$Etats$Update$dansUnDrawer = F2(
	function (commande, model) {
		if (commande.$ === 7) {
			return $author$project$Components$Shared$Drawer$Model$estOuvert(model.c5) || $author$project$Components$Shared$Drawer$Model$estOuvert(model.br);
		} else {
			return false;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Etats$Model$prefixeDuNouvelEtat = 'ajout-etat-libelle';
var $author$project$Components$Produits$StructureCatalogue$Etats$Model$idDuNouvelEtat = A2($author$project$Components$Shared$LibellesParLangue$View$idDuChamp, $author$project$Components$Produits$StructureCatalogue$Etats$Model$prefixeDuNouvelEtat, 'fr');
var $author$project$Components$Produits$StructureCatalogue$Etats$Update$conclure = F4(
	function (commande, refus, avant, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		var ajout = $author$project$Components$Shared$Drawer$Model$estOuvert(avant.br);
		if (!A2($author$project$Components$Produits$StructureCatalogue$Etats$Update$dansUnDrawer, commande, avant)) {
			return _Utils_Tuple2(model, effets);
		} else {
			if (!refus.$) {
				var message = refus.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aL: $elm$core$Maybe$Just(message)
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(
								ajout ? $author$project$Components$Produits$StructureCatalogue$Etats$Model$idDuNouvelEtat : $author$project$Components$Produits$StructureCatalogue$Etats$Model$idDuLibelleDuRenommage)
							])));
			} else {
				return ajout ? A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2(
						$author$project$Components$Produits$StructureCatalogue$Etats$Update$versLAjout,
						$author$project$Components$Shared$Drawer$Update$Fermer,
						_Utils_update(
							model,
							{a9: $author$project$Components$Produits$StructureCatalogue$Saisie$vide}))) : (A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$author$project$Components$Produits$StructureCatalogue$Etats$Model$etatModifie,
						$author$project$Components$Produits$StructureCatalogue$Etats$Update$aRenommer(model))) ? _Utils_Tuple2(model, effets) : A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Components$Produits$StructureCatalogue$Etats$Update$versLeRenommage, $author$project$Components$Shared$Drawer$Update$Fermer, model)));
			}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$versLaNouvelleListe = F2(
	function (geste, model) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{
				Il: (!_Utils_eq(model.am.R, $author$project$Components$Produits$StructureCatalogue$Saisie$vide.R)) || (model.df !== '')
			},
			geste,
			model.T);
		var drawer = _v0.a;
		var effets = _v0.b;
		var suivi = _Utils_update(
			model,
			{T: drawer});
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? suivi : _Utils_update(
				suivi,
				{ed: $elm$core$Maybe$Nothing, aL: $elm$core$Maybe$Nothing, am: $author$project$Components$Produits$StructureCatalogue$Saisie$vide, df: ''}),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$conclureLaListe = F2(
	function (refus, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		if (!refus.$) {
			var message = refus.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						cd: _List_Nil,
						aL: $elm$core$Maybe$Just(message)
					}),
				_Utils_ap(
					effets,
					_List_fromArray(
						[
							$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus($author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$idDuLibelleDeListe)
						])));
		} else {
			return $elm$core$List$isEmpty(model.cd) ? A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Basics$append(effets),
				A2(
					$author$project$Components$Produits$StructureCatalogue$Informations$Update$versLaNouvelleListe,
					$author$project$Components$Shared$Drawer$Update$Fermer,
					_Utils_update(
						model,
						{am: $author$project$Components$Produits$StructureCatalogue$Saisie$vide}))) : _Utils_Tuple2(model, effets);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$idDuRefus = 'rattachement-refus';
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$versLeRattachement = F2(
	function (geste, model) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{Il: false},
			geste,
			model.pO);
		var drawer = _v0.a;
		var effets = _v0.b;
		var suivi = _Utils_update(
			model,
			{pO: drawer});
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? suivi : _Utils_update(
				suivi,
				{
					pN: $author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$vide(model.pN.F$),
					aL: $elm$core$Maybe$Nothing
				}),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$conclureLeRattachement = F3(
	function (portee, refus, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		if (!refus.$) {
			var message = refus.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						aL: $elm$core$Maybe$Just(message)
					}),
				_Utils_ap(
					effets,
					_List_fromArray(
						[
							$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus($author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$idDuRefus)
						])));
		} else {
			return $author$project$Components$Shared$Drawer$Model$estOuvert(model.pO) ? A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Basics$append(effets),
				A2(
					$author$project$Components$Produits$StructureCatalogue$Informations$Update$versLeRattachement,
					$author$project$Components$Shared$Drawer$Update$Fermer,
					_Utils_update(
						model,
						{
							pN: $author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$vide(portee)
						}))) : _Utils_Tuple2(
				_Utils_update(
					model,
					{uQ: $elm$core$Maybe$Nothing}),
				effets);
		}
	});
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Etage$identifiants = $elm$core$Dict$map(
	function (_v0) {
		return $elm$core$List$map(
			function ($) {
				return $.Aq;
			});
	});
var $elm$core$Set$isEmpty = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$isEmpty(dict);
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Etage$aChange = function (ouvert) {
	return (!_Utils_eq(
		$author$project$Components$Produits$StructureCatalogue$Informations$Etage$identifiants(ouvert.uw),
		$author$project$Components$Produits$StructureCatalogue$Informations$Etage$identifiants(ouvert.ee))) || ((!$elm$core$Dict$isEmpty(ouvert.pg)) || (!$elm$core$Set$isEmpty(ouvert.qJ)));
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$versLEtage = F2(
	function (geste, model) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{
				Il: A2(
					$elm$core$Maybe$withDefault,
					false,
					A2($elm$core$Maybe$map, $author$project$Components$Produits$StructureCatalogue$Informations$Etage$aChange, model.s))
			},
			geste,
			model.dK);
		var drawer = _v0.a;
		var effets = _v0.b;
		var suivi = _Utils_update(
			model,
			{dK: drawer});
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? suivi : _Utils_update(
				suivi,
				{s: $elm$core$Maybe$Nothing, aL: $elm$core$Maybe$Nothing}),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$visee = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		function (ouvert) {
			return A2(
				$elm$core$Maybe$map,
				function (lue) {
					return _Utils_Tuple2(ouvert.F$, lue);
				},
				A3($author$project$Components$Produits$StructureCatalogue$Informations$Model$trouvee, ouvert.F$, ouvert.dy, model.AM));
		},
		model.d5);
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$obligationChangee = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (_v0) {
				var lue = _v0.b;
				return !_Utils_eq(lue.uN.he, model.c_);
			},
			$author$project$Components$Produits$StructureCatalogue$Informations$Update$visee(model)));
};
var $author$project$Catalogue$Vocabulaire$ressourceDesReferences = 'produits.reference';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeAdresse = 'adresse';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeDate = 'date';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeEmail = 'email';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeMontant = 'montant';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeNombre = 'nombre';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeOuiNon = 'oui-non';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeTelephone = 'telephone';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeTexte = 'texte';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeTexteLong = 'texte-long';
var $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$typesSimples = _List_fromArray(
	[
		_Utils_Tuple2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeTexte, $author$project$Components$Shared$EditeurDeSchema$Champ$Texte),
		_Utils_Tuple2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeTexteLong, $author$project$Components$Shared$EditeurDeSchema$Champ$TexteLong),
		_Utils_Tuple2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeNombre, $author$project$Components$Shared$EditeurDeSchema$Champ$Nombre),
		_Utils_Tuple2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeMontant, $author$project$Components$Shared$EditeurDeSchema$Champ$Montant),
		_Utils_Tuple2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeDate, $author$project$Components$Shared$EditeurDeSchema$Champ$Date),
		_Utils_Tuple2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeOuiNon, $author$project$Components$Shared$EditeurDeSchema$Champ$OuiNon),
		_Utils_Tuple2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeEmail, $author$project$Components$Shared$EditeurDeSchema$Champ$Email),
		_Utils_Tuple2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeTelephone, $author$project$Components$Shared$EditeurDeSchema$Champ$Telephone),
		_Utils_Tuple2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeAdresse, $author$project$Components$Shared$EditeurDeSchema$Champ$Adresse)
	]);
var $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$sansAttribut = function (code) {
	return A2(
		$elm$core$Maybe$map,
		$elm$core$Tuple$second,
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var nom = _v0.a;
					return _Utils_eq(nom, code);
				},
				$author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$typesSimples)));
};
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeFichier = 'fichier';
var $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$typeLienVersDesArticles = 'lien-vers-des-articles';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeListeUnique = 'choix-dans-une-liste';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeMesure = 'mesure';
var $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$forme = function (changement) {
	return _Utils_eq(changement.r0, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeMesure) ? ((changement.sa === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		$author$project$Components$Shared$EditeurDeSchema$Champ$AvecUnite(
			{iF: _List_Nil, kv: changement.kv, Cg: $elm$core$Maybe$Nothing, Cx: $elm$core$Maybe$Nothing, sa: changement.sa}))) : (_Utils_eq(changement.r0, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeListeUnique) ? ((changement.nW === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		$author$project$Components$Shared$EditeurDeSchema$Champ$ChoixDansUneListePartagee(
			{ys: changement.nW, Cg: $elm$core$Maybe$Nothing, Cx: $elm$core$Maybe$Nothing, FS: changement.FS}))) : (_Utils_eq(changement.r0, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeFichier) ? $elm$core$Maybe$Just(
		$author$project$Components$Shared$EditeurDeSchema$Champ$Fichier(
			{Jn: $elm$core$Maybe$Nothing, r1: _List_Nil})) : (_Utils_eq(changement.r0, $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$typeLienVersDesArticles) ? $elm$core$Maybe$Just(
		$author$project$Components$Shared$EditeurDeSchema$Champ$LienVersDesArticles(
			{vf: $author$project$Catalogue$Vocabulaire$ressourceDesReferences, FS: changement.FS})) : $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$sansAttribut(changement.r0))));
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$typeChange = function (model) {
	var _v0 = _Utils_Tuple2(
		model._,
		$author$project$Components$Produits$StructureCatalogue$Informations$Update$visee(model));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var edite = _v0.a.a;
		var _v1 = _v0.b.a;
		var lue = _v1.b;
		var _v2 = $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$forme(edite);
		if (!_v2.$) {
			var type_ = _v2.a;
			return !_Utils_eq(type_, lue.uN.r0);
		} else {
			return true;
		}
	} else {
		return false;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$aChange = function (model) {
	return $author$project$Components$Produits$StructureCatalogue$Informations$Update$obligationChangee(model) || $author$project$Components$Produits$StructureCatalogue$Informations$Update$typeChange(model);
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$versLInformation = F2(
	function (geste, model) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{
				Il: $author$project$Components$Produits$StructureCatalogue$Informations$Update$aChange(model)
			},
			geste,
			model.dL);
		var drawer = _v0.a;
		var effets = _v0.b;
		var suivi = _Utils_update(
			model,
			{dL: drawer});
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? suivi : _Utils_update(
				suivi,
				{cy: $elm$core$Maybe$Nothing, d5: $elm$core$Maybe$Nothing, ag: false, cV: $elm$core$Maybe$Nothing, aL: $elm$core$Maybe$Nothing, bk: false}),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$anglais = function (champ) {
	return A2(
		$elm$core$Maybe$map,
		$elm$core$Tuple$second,
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$first,
					$elm$core$Basics$eq('en')),
				champ.R)));
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$saisieDe = function (champ) {
	return $author$project$Components$Produits$StructureCatalogue$Saisie$affichee(
		{
			yg: A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Components$Produits$StructureCatalogue$Informations$Model$anglais(champ)),
			zX: champ.Bl
		});
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$versLeRenommage = F2(
	function (geste, model) {
		var modifiee = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (_v2) {
					var lue = _v2.b;
					return !_Utils_eq(
						model.aM.R,
						$author$project$Components$Produits$StructureCatalogue$Informations$Model$saisieDe(lue.uN).R);
				},
				$author$project$Components$Produits$StructureCatalogue$Informations$Update$visee(model)));
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{Il: modifiee},
			geste,
			model.c6);
		var drawer = _v0.a;
		var effets = _v0.b;
		var suivi = _Utils_update(
			model,
			{c6: drawer});
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? suivi : _Utils_update(
				suivi,
				{aL: $elm$core$Maybe$Nothing, aM: $author$project$Components$Produits$StructureCatalogue$Saisie$vide}),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$conclureUneInformation = F4(
	function (commande, refus, avant, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		if (!$author$project$Components$Produits$StructureCatalogue$Informations$Model$estUneCommande(commande)) {
			return _Utils_Tuple2(model, effets);
		} else {
			var _v1 = _Utils_Tuple2(refus, commande);
			if (!_v1.a.$) {
				var message = _v1.a.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aL: $elm$core$Maybe$Just(message)
						}),
					effets);
			} else {
				switch (_v1.b.$) {
					case 42:
						var _v2 = _v1.a;
						var _v3 = _v1.b;
						return _Utils_Tuple2(model, effets);
					case 44:
						var _v4 = _v1.a;
						var _v5 = _v1.b;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$versLEtage, $author$project$Components$Shared$Drawer$Update$Fermer, model));
					default:
						var _v6 = _v1.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							$author$project$Components$Shared$Drawer$Model$estOuvert(avant.c6) ? A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$versLeRenommage, $author$project$Components$Shared$Drawer$Update$Fermer, model) : A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$versLInformation, $author$project$Components$Shared$Drawer$Update$Fermer, model));
				}
			}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$conclure = F4(
	function (commande, refus, avant, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (commande.$) {
			case 12:
				return $author$project$Components$Shared$Drawer$Model$estOuvert(avant.T) ? A2(
					$author$project$Components$Produits$StructureCatalogue$Informations$Update$conclureLaListe,
					refus,
					_Utils_Tuple2(model, effets)) : _Utils_Tuple2(model, effets);
			case 13:
				return $author$project$Components$Shared$Drawer$Model$estOuvert(avant.T) ? A2(
					$author$project$Components$Produits$StructureCatalogue$Informations$Update$conclureLaListe,
					refus,
					_Utils_Tuple2(model, effets)) : _Utils_Tuple2(model, effets);
			case 36:
				var portee = commande.a;
				return A3(
					$author$project$Components$Produits$StructureCatalogue$Informations$Update$conclureLeRattachement,
					portee,
					refus,
					_Utils_Tuple2(model, effets));
			default:
				return A4(
					$author$project$Components$Produits$StructureCatalogue$Informations$Update$conclureUneInformation,
					commande,
					refus,
					avant,
					_Utils_Tuple2(model, effets));
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Natures$Update$natureDe = F2(
	function (code, model) {
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.oo;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$filter(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.vx;
							},
							$elm$core$Basics$eq(code))),
					$elm$core$List$head)),
			model.h$);
	});
var $author$project$Components$Produits$StructureCatalogue$Natures$Update$aRenommer = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		function (code) {
			return A2($author$project$Components$Produits$StructureCatalogue$Natures$Update$natureDe, code, model);
		},
		model.on);
};
var $author$project$Components$Produits$StructureCatalogue$Natures$Update$dansUnDrawer = F2(
	function (commande, model) {
		if (commande.$ === 9) {
			return $author$project$Components$Shared$Drawer$Model$estOuvert(model.qn);
		} else {
			return false;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Natures$Model$prefixeDuRenommage = 'renommage-nature-libelle';
var $author$project$Components$Produits$StructureCatalogue$Natures$Model$idDuLibelleDuRenommage = A2($author$project$Components$Shared$LibellesParLangue$View$idDuChamp, $author$project$Components$Produits$StructureCatalogue$Natures$Model$prefixeDuRenommage, 'fr');
var $author$project$Components$Produits$StructureCatalogue$Natures$Model$natureModifiee = function (nature) {
	return !_Utils_eq(
		nature.hP.R,
		$author$project$Components$Produits$StructureCatalogue$Natures$Model$saisieDeLaNature(nature).R);
};
var $author$project$Components$Produits$StructureCatalogue$Natures$Update$surLaNature = F3(
	function (code, modifier, model) {
		return _Utils_update(
			model,
			{
				h$: A2(
					$elm$core$Maybe$map,
					function (structure) {
						return _Utils_update(
							structure,
							{
								oo: A2(
									$elm$core$List$map,
									function (nature) {
										return _Utils_eq(nature.vx, code) ? modifier(nature) : nature;
									},
									structure.oo)
							});
					},
					model.h$)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Natures$Update$sansRenommage = function (model) {
	var remise = A2(
		$elm$core$Maybe$withDefault,
		model,
		A2(
			$elm$core$Maybe$map,
			function (code) {
				return A3(
					$author$project$Components$Produits$StructureCatalogue$Natures$Update$surLaNature,
					code,
					function (nature) {
						return _Utils_update(
							nature,
							{
								hP: $author$project$Components$Produits$StructureCatalogue$Natures$Model$saisieDeLaNature(nature)
							});
					},
					model);
			},
			model.on));
	var drawer = remise.qn;
	return _Utils_update(
		remise,
		{
			on: $elm$core$Maybe$Nothing,
			aL: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? $elm$core$Maybe$Nothing : remise.aL,
			qn: _Utils_update(
				drawer,
				{wQ: $elm$core$Maybe$Nothing, gt: 0})
		});
};
var $author$project$Components$Produits$StructureCatalogue$Natures$Update$versLeRenommage = F2(
	function (geste, model) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{
				Il: A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$author$project$Components$Produits$StructureCatalogue$Natures$Model$natureModifiee,
						$author$project$Components$Produits$StructureCatalogue$Natures$Update$aRenommer(model)))
			},
			geste,
			model.qn);
		var drawer = _v0.a;
		var effets = _v0.b;
		var suivi = _Utils_update(
			model,
			{qn: drawer});
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? suivi : $author$project$Components$Produits$StructureCatalogue$Natures$Update$sansRenommage(suivi),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Produits$StructureCatalogue$Natures$Update$conclure = F4(
	function (commande, refus, avant, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		if (!A2($author$project$Components$Produits$StructureCatalogue$Natures$Update$dansUnDrawer, commande, avant)) {
			return _Utils_Tuple2(model, effets);
		} else {
			if (!refus.$) {
				var message = refus.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aL: $elm$core$Maybe$Just(message)
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus($author$project$Components$Produits$StructureCatalogue$Natures$Model$idDuLibelleDuRenommage)
							])));
			} else {
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$author$project$Components$Produits$StructureCatalogue$Natures$Model$natureModifiee,
						$author$project$Components$Produits$StructureCatalogue$Natures$Update$aRenommer(model))) ? _Utils_Tuple2(model, effets) : A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Components$Produits$StructureCatalogue$Natures$Update$versLeRenommage, $author$project$Components$Shared$Drawer$Update$Fermer, model));
			}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Update$dansUnDrawer = F2(
	function (commande, model) {
		switch (commande.$) {
			case 2:
				return $author$project$Components$Shared$Drawer$Model$estOuvert(model.hL);
			case 3:
				return $author$project$Components$Shared$Drawer$Model$estOuvert(model.hL);
			default:
				return false;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Update$conclure = F4(
	function (commande, refus, avant, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		if (!A2($author$project$Components$Produits$StructureCatalogue$Niveaux$Update$dansUnDrawer, commande, avant)) {
			return _Utils_Tuple2(model, effets);
		} else {
			if (!refus.$) {
				var message = refus.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aL: $elm$core$Maybe$Just(message)
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus($author$project$Components$Produits$StructureCatalogue$Niveaux$Model$idDuLibelleDuRenommage)
							])));
			} else {
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$modifie,
						$author$project$Components$Produits$StructureCatalogue$Niveaux$Update$aRenommer(model))) ? _Utils_Tuple2(model, effets) : A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Components$Produits$StructureCatalogue$Niveaux$Update$versLeRenommage, $author$project$Components$Shared$Drawer$Update$Fermer, model));
			}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Typologies$Update$dansUnDrawer = F2(
	function (commande, model) {
		switch (commande.$) {
			case 14:
				return $author$project$Components$Shared$Drawer$Model$estOuvert(model.iG);
			case 15:
				return $author$project$Components$Shared$Drawer$Model$estOuvert(model.qo);
			case 16:
				return $author$project$Components$Shared$Drawer$Model$estOuvert(model.qM);
			default:
				return false;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Typologies$Model$prefixeDuRenommage = 'renommage-typologie-libelle';
var $author$project$Components$Produits$StructureCatalogue$Typologies$Model$idDuLibelleDuRenommage = A2($author$project$Components$Shared$LibellesParLangue$View$idDuChamp, $author$project$Components$Produits$StructureCatalogue$Typologies$Model$prefixeDuRenommage, 'fr');
var $author$project$Components$Produits$StructureCatalogue$Typologies$Update$typologieDe = F2(
	function (id, model) {
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.vk;
				},
				$author$project$Components$Produits$StructureCatalogue$Classifications$Model$classificationDe(id)),
			model.h$);
	});
var $author$project$Components$Produits$StructureCatalogue$Typologies$Update$aRenommer = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		function (id) {
			return A2($author$project$Components$Produits$StructureCatalogue$Typologies$Update$typologieDe, id, model);
		},
		model.r4);
};
var $author$project$Components$Produits$StructureCatalogue$Typologies$Model$renommage = function (typologie) {
	return A2(
		$author$project$Components$Produits$StructureCatalogue$Saisie$renommer,
		$elm$core$Maybe$Just(typologie.R),
		_Utils_Tuple2('', ''));
};
var $author$project$Components$Produits$StructureCatalogue$Typologies$Update$saisieDepuisLEnvoi = F2(
	function (commande, model) {
		var _v0 = _Utils_Tuple2(
			commande,
			$author$project$Components$Produits$StructureCatalogue$Typologies$Update$aRenommer(model));
		if ((_v0.a.$ === 15) && (!_v0.b.$)) {
			var _v1 = _v0.a;
			var envoyes = _v1.b;
			var typologie = _v0.b.a;
			return !_Utils_eq(
				A2(
					$author$project$Components$Produits$StructureCatalogue$Typologies$Model$renommage,
					_Utils_update(
						typologie,
						{R: envoyes}),
					model.qU),
				$author$project$Components$Produits$StructureCatalogue$Saisie$Inchange);
		} else {
			return false;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Typologies$Update$conclure = F4(
	function (commande, refus, avant, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		var retrait = $author$project$Components$Shared$Drawer$Model$estOuvert(avant.qM);
		var ajout = $author$project$Components$Shared$Drawer$Model$estOuvert(avant.iG);
		if (!A2($author$project$Components$Produits$StructureCatalogue$Typologies$Update$dansUnDrawer, commande, avant)) {
			return _Utils_Tuple2(model, effets);
		} else {
			if (!refus.$) {
				var message = refus.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aL: $elm$core$Maybe$Just(message)
						}),
					_Utils_ap(
						effets,
						retrait ? _List_Nil : _List_fromArray(
							[
								$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(
								ajout ? $author$project$Components$Produits$StructureCatalogue$Typologies$Model$idDuLibelleDeLAjout : $author$project$Components$Produits$StructureCatalogue$Typologies$Model$idDuLibelleDuRenommage)
							])));
			} else {
				return retrait ? _Utils_Tuple2(
					$author$project$Components$Produits$StructureCatalogue$Typologies$Update$ferme(model),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus($author$project$Components$Produits$StructureCatalogue$Typologies$Model$idDuBoutonAjouter)
							]))) : (ajout ? A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2(
						$author$project$Components$Produits$StructureCatalogue$Typologies$Update$versLAjout,
						$author$project$Components$Shared$Drawer$Update$Fermer,
						_Utils_update(
							model,
							{qU: $author$project$Components$Produits$StructureCatalogue$Saisie$vide}))) : (A2($author$project$Components$Produits$StructureCatalogue$Typologies$Update$saisieDepuisLEnvoi, commande, model) ? _Utils_Tuple2(model, effets) : _Utils_Tuple2(
					$author$project$Components$Produits$StructureCatalogue$Typologies$Update$ferme(model),
					_Utils_ap(
						effets,
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus, $elm$core$List$singleton),
								model.qo.wQ))))));
			}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$deLArbre = function (commande) {
	switch (commande.$) {
		case 27:
			return true;
		case 28:
			return true;
		case 30:
			return true;
		case 31:
			return true;
		case 32:
			return true;
		case 33:
			return true;
		case 34:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$dansLeDrawer = F2(
	function (commande, model) {
		return $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$deLArbre(commande) && ((!_Utils_eq(model.hA, $elm$core$Maybe$Nothing)) && $author$project$Components$Shared$Drawer$Model$estOuvert(model.le));
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$deLOrdre = F2(
	function (commande, model) {
		switch (commande.$) {
			case 21:
				return (!_Utils_eq(model.El, $elm$core$Maybe$Nothing)) && $author$project$Components$Shared$Drawer$Model$estOuvert(model.k3);
			case 29:
				return (!_Utils_eq(model.El, $elm$core$Maybe$Nothing)) && $author$project$Components$Shared$Drawer$Model$estOuvert(model.k3);
			default:
				return false;
		}
	});
var $elm$core$Tuple$mapBoth = F3(
	function (funcA, funcB, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			funcA(x),
			funcB(y));
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$versLeDrawerDOrdre = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? _Utils_update(
					model,
					{k3: drawer}) : _Utils_update(
					model,
					{k3: drawer, El: $elm$core$Maybe$Nothing, p1: $elm$core$Maybe$Nothing});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.k3));
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$licenceChangee = function (rangement) {
	return A2(
		$elm$core$Maybe$andThen,
		function (marque) {
			return (!_Utils_eq(
				A2($elm$core$Maybe$withDefault, false, marque.IY),
				rangement.IY)) ? $elm$core$Maybe$Just(
				_Utils_Tuple2(marque, rangement.IY)) : $elm$core$Maybe$Nothing;
		},
		rangement.gX);
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$memeEnsemble = F2(
	function (uns, autres) {
		return A2(
			$elm$core$List$all,
			function (valeur) {
				return A2($elm$core$List$member, valeur, autres);
			},
			uns) && A2(
			$elm$core$List$all,
			function (valeur) {
				return A2($elm$core$List$member, valeur, uns);
			},
			autres);
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$saisieEnCours = function (rangement) {
	return (!A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$memeEnsemble, rangement.vv, rangement.AP)) || ((!_Utils_eq(
		$author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$licenceChangee(rangement),
		$elm$core$Maybe$Nothing)) || A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.CP;
				},
				A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)),
			rangement.gG)));
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$versLeDrawerDeRangement = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? _Utils_update(
					model,
					{le: drawer}) : _Utils_update(
					model,
					{le: drawer, hA: $elm$core$Maybe$Nothing, p9: $elm$core$Maybe$Nothing});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: A2(
						$elm$core$Maybe$withDefault,
						false,
						A2($elm$core$Maybe$map, $author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$saisieEnCours, model.hA))
				},
				geste,
				model.le));
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$conclure = F4(
	function (commande, refus, avant, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		if (A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Update$deLOrdre, commande, avant)) {
			if (!refus.$) {
				var message = refus.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cd: _List_Nil,
							p1: $elm$core$Maybe$Just(message)
						}),
					effets);
			} else {
				return $elm$core$List$isEmpty(model.cd) ? A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2(
						$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$versLeDrawerDOrdre,
						$author$project$Components$Shared$Drawer$Update$Fermer,
						_Utils_update(
							model,
							{oK: avant.El}))) : _Utils_Tuple2(model, effets);
			}
		} else {
			if (!$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$deLArbre(commande)) {
				return _Utils_Tuple2(model, effets);
			} else {
				if (!refus.$) {
					var message = refus.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cd: _List_Nil,
								p9: A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Update$dansLeDrawer, commande, avant) ? $elm$core$Maybe$Just(message) : model.p9
							}),
						effets);
				} else {
					return ($elm$core$List$isEmpty(model.cd) && A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Update$dansLeDrawer, commande, avant)) ? A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Update$versLeDrawerDeRangement, $author$project$Components$Shared$Drawer$Update$Fermer, model)) : _Utils_Tuple2(model, effets);
				}
			}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ReecrireLArbre = F2(
	function (a, b) {
		return {$: 26, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Commandes$avecFoyer = F2(
	function (foyer, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		return $elm$core$List$isEmpty(effets) ? _Utils_Tuple2(model, effets) : _Utils_Tuple2(
			_Utils_update(
				model,
				{
					tl: $author$project$I18n$Traductions$tel(''),
					mS: $elm$core$Maybe$Just(foyer)
				}),
			effets);
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$confirmer = function (model) {
	var _v0 = model.q;
	if (_v0.$ === 2) {
		var lu = _v0.a;
		return function () {
			var _v1 = lu.qL;
			if (!_v1.$) {
				var retour = _v1.a;
				return $author$project$Components$Produits$StructureCatalogue$Commandes$avecFoyer(
					$author$project$Components$Produits$StructureCatalogue$Etages$Update$foyerDe(retour));
			} else {
				return $elm$core$Basics$identity;
			}
		}()(
			A2(
				$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
				A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ReecrireLArbre, lu.mW, lu.yf),
				$author$project$Components$Produits$StructureCatalogue$Etages$Update$sansRefus(model)));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$idDeLaPastille = F2(
	function (portee, cle) {
		return 'information-' + (function () {
			switch (portee.$) {
				case 0:
					return 'catalogue';
				case 1:
					var classification = portee.a;
					return 'typologie-' + $author$project$Catalogue$Identifiants$classificationIdToString(classification);
				case 2:
					var classification = portee.a;
					var valeur = portee.b;
					return 'noeud-' + ($author$project$Catalogue$Identifiants$classificationIdToString(classification) + ('-' + valeur));
				default:
					var type_ = portee.a;
					return 'categorie-' + $author$project$Catalogue$Identifiants$typeDeProduitIdToString(type_);
			}
		}() + ('-' + cle));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$idDeLaPastilleDeConsultation = function (consultation) {
	switch (consultation.$) {
		case 0:
			var id = consultation.a;
			return 'liste-' + $author$project$Catalogue$Identifiants$classificationIdToString(id);
		case 1:
			return 'pastille-etat';
		case 2:
			return 'pastille-nature';
		default:
			var portee = consultation.a;
			return A2($author$project$Components$Produits$StructureCatalogue$Informations$Model$idDeLaPastille, portee, 'masquees');
	}
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$versLaConsultation = F2(
	function (geste, model) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{Il: false},
			geste,
			model.gc);
		var drawer = _v0.a;
		var effets = _v0.b;
		var suivi = _Utils_update(
			model,
			{gc: drawer});
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? suivi : _Utils_update(
				suivi,
				{j9: $elm$core$Maybe$Nothing, aL: $elm$core$Maybe$Nothing}),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$consultationOuverte = F2(
	function (consultation, model) {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Informations$Update$versLaConsultation,
			$author$project$Components$Shared$Drawer$Update$Ouvrir(
				$author$project$Components$Produits$StructureCatalogue$Informations$Model$idDeLaPastilleDeConsultation(consultation)),
			_Utils_update(
				model,
				{
					j9: $elm$core$Maybe$Just(consultation),
					aL: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$deClassification = function (model) {
	var _v0 = model.l2;
	_v0$20:
	while (true) {
		if (_v0.$ === 2) {
			switch (_v0.b.$) {
				case 15:
					var _v1 = _v0.b;
					return true;
				case 16:
					return true;
				case 17:
					return true;
				case 18:
					return true;
				case 19:
					var _v2 = _v0.b;
					return true;
				case 20:
					var _v3 = _v0.b;
					return true;
				case 21:
					var _v4 = _v0.b;
					return true;
				case 22:
					var _v5 = _v0.b;
					return true;
				case 23:
					var _v6 = _v0.b;
					return true;
				case 24:
					var _v7 = _v0.b;
					return true;
				case 26:
					var _v8 = _v0.b;
					return true;
				case 25:
					var _v9 = _v0.b;
					return true;
				case 27:
					var _v10 = _v0.b;
					return true;
				case 28:
					var _v11 = _v0.b;
					return true;
				case 29:
					var _v12 = _v0.b;
					return true;
				case 30:
					var _v13 = _v0.b;
					return true;
				case 31:
					var _v14 = _v0.b;
					return true;
				case 32:
					var _v15 = _v0.b;
					return true;
				case 33:
					var _v16 = _v0.b;
					return true;
				case 34:
					var _v17 = _v0.b;
					return true;
				default:
					break _v0$20;
			}
		} else {
			break _v0$20;
		}
	}
	return false;
};
var $author$project$I18n$Textes$produitsElements = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.elements',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nombre',
				$author$project$I18n$Traductions$Entier(p.w))
			]),
		'{nombre, plural, one {# élément. Archivez-le d\'abord.} other {# éléments. Archivez-les d\'abord.}}');
};
var $author$project$Catalogue$Vocabulaire$elements = F2(
	function (code, nombre) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Textes$produitsElements(
				{w: nombre}),
			A2(
				$elm$core$Maybe$map,
				function (connu) {
					return connu.aV(
						{w: nombre});
				},
				A2($elm$core$Dict$get, code, $author$project$Catalogue$Vocabulaire$archetypes)));
	});
var $author$project$Components$Produits$StructureCatalogue$Typologies$Update$surUneTypologie = F2(
	function (commande, model) {
		switch (commande.$) {
			case 14:
				return true;
			case 16:
				return true;
			case 15:
				var id = commande.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_eq(
						model.r4,
						$elm$core$Maybe$Just(id)),
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.wE;
						},
						A2(
							$elm$core$Maybe$andThen,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.vk;
								},
								$author$project$Components$Produits$StructureCatalogue$Classifications$Model$classificationDe(id)),
							model.h$)));
			default:
				return !_Utils_eq(
					$author$project$Components$Produits$StructureCatalogue$Model$typologieDuGeste(commande),
					$elm$core$Maybe$Nothing);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Update$contexteDe = F2(
	function (commande, model) {
		return {
			C9: A2(
				$elm$core$List$map,
				function (niveau) {
					return {
						aV: _Utils_eq(niveau.R, $elm$core$Maybe$Nothing) ? $author$project$Catalogue$Vocabulaire$elements(niveau.fA) : function (nombre) {
							return $author$project$I18n$Textes$produitsElements(
								{w: nombre});
						},
						Aq: niveau.Aq,
						Dj: $author$project$Components$Produits$StructureCatalogue$Niveaux$Model$libelleDuNiveau(niveau)
					};
				},
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.C9;
						},
						model.h$))),
			ox: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.uN;
						},
						function ($) {
							return $.Bl;
						}),
					A2(
						$elm$core$Maybe$andThen,
						function (ouverte) {
							return A3($author$project$Components$Produits$StructureCatalogue$Informations$Model$trouvee, ouverte.F$, ouverte.dy, model.AM);
						},
						model.d5))),
			oz: function () {
				if (commande.$ === 12) {
					var nom = commande.a;
					return $elm$core$String$trim(nom);
				} else {
					return '';
				}
			}(),
			eW: function () {
				if (commande.$ === 6) {
					return true;
				} else {
					return false;
				}
			}(),
			ru: $author$project$Components$Produits$StructureCatalogue$Update$deClassification(model),
			da: A2($author$project$Components$Produits$StructureCatalogue$Typologies$Update$surUneTypologie, commande, model)
		};
	});
var $author$project$Components$Produits$StructureCatalogue$Archivage$Model$uniquesPar = F2(
	function (cle, liste) {
		return $elm$core$List$reverse(
			A3(
				$elm$core$List$foldl,
				F2(
					function (element, _v0) {
						var vus = _v0.a;
						var gardes = _v0.b;
						return A2(
							$elm$core$List$member,
							cle(element),
							vus) ? _Utils_Tuple2(vus, gardes) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								cle(element),
								vus),
							A2($elm$core$List$cons, element, gardes));
					}),
				_Utils_Tuple2(_List_Nil, _List_Nil),
				liste).b);
	});
var $author$project$Components$Produits$StructureCatalogue$Archivage$Model$groupes = F5(
	function (noms, niveaux, source, cible, aCloturer) {
		var valeursDe = F2(
			function (typologie, etage) {
				return A2(
					$author$project$Components$Produits$StructureCatalogue$Archivage$Model$uniquesPar,
					$elm$core$Tuple$first,
					A2(
						$elm$core$List$filterMap,
						function (noeud) {
							return A2(
								$elm$core$Maybe$map,
								$elm$core$Tuple$pair(noeud.fm),
								A3($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$nomDe, noms, typologie, noeud.fm));
						},
						A2(
							$elm$core$List$filter,
							function (noeud) {
								return _Utils_eq(noeud.md, etage.Aq) && (!noeud.iz);
							},
							typologie.Di)));
			});
		var cloturee = function (valeur) {
			if (valeur.$ === 2) {
				var id = valeur.a;
				return A2($elm$core$List$member, id, aCloturer);
			} else {
				return false;
			}
		};
		return A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.gV;
				},
				A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)),
			A2(
				$elm$core$List$filterMap,
				function (etage) {
					return A2(
						$elm$core$Maybe$map,
						function (autre) {
							return {
								md: A2($author$project$Components$Produits$StructureCatalogue$Etages$Model$nom, niveaux, etage),
								gV: A2(
									$elm$core$List$map,
									function (_v0) {
										var valeur = _v0.a;
										var nom = _v0.b;
										return {
											Dj: nom,
											o_: A2(valeursDe, cible, autre),
											IR: valeur
										};
									},
									A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$Tuple$first,
											A2($elm$core$Basics$composeR, cloturee, $elm$core$Basics$not)),
										A2(valeursDe, source, etage)))
							};
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (autre) {
									return _Utils_eq(autre.xt, etage.xt);
								},
								cible.yG)));
				},
				source.yG));
	});
var $author$project$Components$Produits$StructureCatalogue$Archivage$Update$groupesDe = function (model) {
	var _v0 = _Utils_Tuple3(model.h$, model.tD.r3, model.tD.vf);
	if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
		var structure = _v0.a.a;
		var source = _v0.b.a;
		var cible = _v0.c.a;
		var _v1 = _Utils_Tuple2(
			A2($author$project$Components$Produits$StructureCatalogue$Archivage$Update$typologieDe, source, model),
			A2($author$project$Components$Produits$StructureCatalogue$Archivage$Update$typologieDe, cible, model));
		if ((!_v1.a.$) && (!_v1.b.$)) {
			var deSource = _v1.a.a;
			var deCible = _v1.b.a;
			return A5(
				$author$project$Components$Produits$StructureCatalogue$Archivage$Model$groupes,
				$author$project$Components$Produits$StructureCatalogue$Valeurs$Lecture$noms(model),
				structure.C9,
				deSource,
				deCible,
				model.tD.it);
		} else {
			return _List_Nil;
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Archivage$Update$correspondanceChoisie = F3(
	function (source, rang, model) {
		var options = A2(
			$elm$core$List$concatMap,
			function ($) {
				return $.o_;
			},
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.IR;
					},
					$elm$core$Basics$eq(source)),
				A2(
					$elm$core$List$concatMap,
					function ($) {
						return $.gV;
					},
					$author$project$Components$Produits$StructureCatalogue$Archivage$Update$groupesDe(model))));
		var choisie = A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$first,
			A2(
				$elm$core$Maybe$andThen,
				function (i) {
					return $elm$core$List$head(
						A2($elm$core$List$drop, i, options));
				},
				$elm$core$String$toInt(rang)));
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Archivage$Update$changerLeChoix,
			function (a) {
				return _Utils_update(
					a,
					{
						Ki: _Utils_ap(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Tuple$first,
									$elm$core$Basics$neq(source)),
								a.Ki),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (cible) {
										return _List_fromArray(
											[
												_Utils_Tuple2(source, cible)
											]);
									},
									choisie)))
					});
			},
			model);
	});
var $author$project$Components$Produits$StructureCatalogue$Archivage$Model$idDuBoutonDeCorrespondance = 'archivage-correspondance';
var $author$project$Components$Produits$StructureCatalogue$Archivage$Update$versLaCorrespondance = F2(
	function (geste, model) {
		var archivage = model.tD;
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{Il: false},
			geste,
			archivage.wg);
		var drawer = _v0.a;
		var effets = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					tD: _Utils_update(
						archivage,
						{wg: drawer})
				}),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Produits$StructureCatalogue$Archivage$Update$correspondanceOuverte = function (model) {
	return _Utils_eq(model.tD.vf, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A2(
		$author$project$Components$Produits$StructureCatalogue$Archivage$Update$versLaCorrespondance,
		$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Produits$StructureCatalogue$Archivage$Model$idDuBoutonDeCorrespondance),
		model);
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$laListeSeCree = F2(
	function (commande, model) {
		switch (commande.$) {
			case 12:
				return $author$project$Components$Shared$Drawer$Model$estOuvert(model.T);
			case 13:
				return $author$project$Components$Shared$Drawer$Model$estOuvert(model.T);
			default:
				return false;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Update$dansUnDrawerDeSaisie = F2(
	function (commande, model) {
		return A2($author$project$Components$Produits$StructureCatalogue$Niveaux$Update$dansUnDrawer, commande, model) || (A2($author$project$Components$Produits$StructureCatalogue$Classifications$Update$dansLeDrawer, commande, model) || (A2($author$project$Components$Produits$StructureCatalogue$Etats$Update$dansUnDrawer, commande, model) || (A2($author$project$Components$Produits$StructureCatalogue$Natures$Update$dansUnDrawer, commande, model) || (A2($author$project$Components$Produits$StructureCatalogue$Typologies$Update$dansUnDrawer, commande, model) || (A2($author$project$Components$Produits$StructureCatalogue$Etages$Update$dansUnDrawerDeSaisie, commande, model) || (($author$project$Components$Produits$StructureCatalogue$Informations$Model$estUneCommande(commande) && $author$project$Components$Shared$Drawer$Model$estOuvert(model.dL)) || (($author$project$Components$Produits$StructureCatalogue$Informations$Model$estUneCommande(commande) && $author$project$Components$Shared$Drawer$Model$estOuvert(model.dK)) || (($author$project$Components$Produits$StructureCatalogue$Informations$Model$estUneCommande(commande) && $author$project$Components$Shared$Drawer$Model$estOuvert(model.pO)) || A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$laListeSeCree, commande, model)))))))));
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$OrdonnerLesInformations = F2(
	function (a, b) {
		return {$: 42, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$cles = F2(
	function (portee, informations) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.dw;
					},
					$elm$core$List$map(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.uN;
							},
							function ($) {
								return $.dy;
							}))),
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.F3;
						},
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$filter(
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.F$;
									},
									$elm$core$Basics$eq(portee))),
							$elm$core$List$head)),
					informations)));
	});
var $author$project$Components$Shared$Ordre$monter = F2(
	function (estLui, elements) {
		if (elements.b && elements.b.b) {
			var premier = elements.a;
			var _v1 = elements.b;
			var second = _v1.a;
			var reste = _v1.b;
			return estLui(second) ? A2(
				$elm$core$List$cons,
				second,
				A2($elm$core$List$cons, premier, reste)) : A2(
				$elm$core$List$cons,
				premier,
				A2(
					$author$project$Components$Shared$Ordre$monter,
					estLui,
					A2($elm$core$List$cons, second, reste)));
		} else {
			return elements;
		}
	});
var $author$project$Components$Shared$Ordre$descendre = F2(
	function (estLui, elements) {
		return $elm$core$List$reverse(
			A2(
				$author$project$Components$Shared$Ordre$monter,
				estLui,
				$elm$core$List$reverse(elements)));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$ordreApres = F3(
	function (sens, cle, ordre) {
		if (!sens) {
			return A2(
				$author$project$Components$Shared$Ordre$monter,
				$elm$core$Basics$eq(cle),
				ordre);
		} else {
			return A2(
				$author$project$Components$Shared$Ordre$descendre,
				$elm$core$Basics$eq(cle),
				ordre);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$deplacee = F3(
	function (cle, sens, model) {
		var _v0 = $author$project$Components$Produits$StructureCatalogue$Informations$Update$visee(model);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var portee = _v1.a;
			var lue = _v1.b;
			var cles = A2($author$project$Components$Produits$StructureCatalogue$Informations$Model$cles, portee, model.AM);
			var apres = A3($author$project$Components$Produits$StructureCatalogue$Informations$Model$ordreApres, sens, cle, cles);
			return _Utils_eq(apres, cles) ? _Utils_Tuple2(model, _List_Nil) : A2(
				$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
				A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$OrdonnerLesInformations, portee, apres),
				_Utils_update(
					model,
					{aL: $elm$core$Maybe$Nothing}));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$DeplacerUneInformation = F3(
	function (a, b, c) {
		return {$: 41, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$deplacementDemande = function (model) {
	var _v0 = _Utils_Tuple2(
		$author$project$Components$Produits$StructureCatalogue$Informations$Update$visee(model),
		model.cy);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var _v1 = _v0.a.a;
		var portee = _v1.a;
		var lue = _v1.b;
		var vers = _v0.b.a;
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
			A3($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$DeplacerUneInformation, portee, lue.uN.dy, vers),
			_Utils_update(
				model,
				{ag: false, aL: $elm$core$Maybe$Nothing}));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$AuBoutonDOrdre = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ReordonnerLesEtages = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$ordreApres = F3(
	function (sens, id, etages) {
		var ordre = A2(
			$elm$core$List$map,
			function ($) {
				return $.Aq;
			},
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Basics$not,
					function ($) {
						return $.wL;
					}),
				etages));
		var place = A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$first,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$second,
						$elm$core$Basics$eq(id)),
					A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, ordre))));
		var echanger = function (rang) {
			return _Utils_ap(
				A2($elm$core$List$take, rang, ordre),
				_Utils_ap(
					A2(
						$elm$core$List$take,
						1,
						A2($elm$core$List$drop, rang + 1, ordre)),
					_Utils_ap(
						A2(
							$elm$core$List$take,
							1,
							A2($elm$core$List$drop, rang, ordre)),
						A2($elm$core$List$drop, rang + 2, ordre))));
		};
		var _v0 = _Utils_Tuple2(sens, place);
		_v0$2:
		while (true) {
			if (!_v0.a) {
				if (!_v0.b.$) {
					var _v1 = _v0.a;
					var rang = _v0.b.a;
					return (!rang) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						echanger(rang - 1));
				} else {
					break _v0$2;
				}
			} else {
				if (!_v0.b.$) {
					var _v2 = _v0.a;
					var rang = _v0.b.a;
					return (_Utils_cmp(
						rang,
						$elm$core$List$length(ordre) - 1) > -1) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						echanger(rang));
				} else {
					break _v0$2;
				}
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$DescenteDe = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$MonteeDe = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$etageNomme = F4(
	function (_v0, niveaux, id, etages) {
		return A2(
			$elm$core$Maybe$map,
			$author$project$Components$Produits$StructureCatalogue$Etages$Model$nom(niveaux),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Aq;
						},
						$elm$core$Basics$eq(id)),
					etages)));
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$titreDuMouvement = F5(
	function (i18n, niveaux, sens, id, etages) {
		var ordre = A2(
			$elm$core$List$map,
			function ($) {
				return $.Aq;
			},
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Basics$not,
					function ($) {
						return $.wL;
					}),
				etages));
		var rang = A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$first,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$second,
						$elm$core$Basics$eq(id)),
					A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, ordre))));
		var voisin = function (place) {
			return A2(
				$elm$core$Maybe$andThen,
				function (autre) {
					return A4($author$project$Components$Produits$StructureCatalogue$Etages$Model$etageNomme, i18n, niveaux, autre, etages);
				},
				$elm$core$List$head(
					A2($elm$core$List$drop, place, ordre)));
		};
		var _v0 = _Utils_Tuple2(sens, rang);
		_v0$2:
		while (true) {
			if (!_v0.a) {
				if (!_v0.b.$) {
					var _v1 = _v0.a;
					var place = _v0.b.a;
					return (!place) ? $elm$core$Maybe$Nothing : A3(
						$elm$core$Maybe$map2,
						$author$project$Components$Produits$StructureCatalogue$Etages$Model$MonteeDe,
						A4($author$project$Components$Produits$StructureCatalogue$Etages$Model$etageNomme, i18n, niveaux, id, etages),
						voisin(place - 1));
				} else {
					break _v0$2;
				}
			} else {
				if (!_v0.b.$) {
					var _v2 = _v0.a;
					var place = _v0.b.a;
					return A3(
						$elm$core$Maybe$map2,
						$author$project$Components$Produits$StructureCatalogue$Etages$Model$DescenteDe,
						A4($author$project$Components$Produits$StructureCatalogue$Etages$Model$etageNomme, i18n, niveaux, id, etages),
						voisin(place + 1));
				} else {
					break _v0$2;
				}
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$deplacer = F4(
	function (i18n, sens, id, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (_v1) {
				var structure = _v1.a;
				var t = _v1.b;
				return A3(
					$elm$core$Maybe$map2,
					F2(
						function (ordre, titre) {
							return _Utils_Tuple3(t, ordre, titre);
						}),
					A3($author$project$Components$Produits$StructureCatalogue$Etages$Model$ordreApres, sens, id, t.yG),
					A5($author$project$Components$Produits$StructureCatalogue$Etages$Model$titreDuMouvement, i18n, structure.C9, sens, id, t.yG));
			},
			$author$project$Components$Produits$StructureCatalogue$Etages$Update$reglee(model));
		if (!_v0.$) {
			var _v2 = _v0.a;
			var typologie = _v2.a;
			var ordre = _v2.b;
			var titre = _v2.c;
			return A4(
				$author$project$Components$Produits$StructureCatalogue$Etages$Update$demander,
				A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ReordonnerLesEtages, typologie.Aq, ordre),
				titre,
				$elm$core$Maybe$Just(
					A3($author$project$Components$Produits$StructureCatalogue$Etages$Model$AuBoutonDOrdre, typologie.Aq, id, sens)),
				model);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$deposer = F3(
	function (glisse, cible, etages) {
		var ordre = A2(
			$elm$core$List$map,
			function ($) {
				return $.Aq;
			},
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Basics$not,
					function ($) {
						return $.wL;
					}),
				etages));
		var place = function (id) {
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$first,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$second,
							$elm$core$Basics$eq(id)),
						A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, ordre))));
		};
		var _v0 = _Utils_Tuple2(
			place(glisse),
			place(cible));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var rang = _v0.b.a;
			if (_Utils_eq(glisse, cible)) {
				return $elm$core$Maybe$Nothing;
			} else {
				var sans = A2(
					$elm$core$List$filter,
					$elm$core$Basics$neq(glisse),
					ordre);
				return $elm$core$Maybe$Just(
					_Utils_ap(
						A2($elm$core$List$take, rang, sans),
						A2(
							$elm$core$List$cons,
							glisse,
							A2($elm$core$List$drop, rang, sans))));
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$DeplacementDe = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$titreDuDepot = F5(
	function (i18n, niveaux, glisse, cible, etages) {
		return A3(
			$elm$core$Maybe$map2,
			$author$project$Components$Produits$StructureCatalogue$Etages$Model$DeplacementDe,
			A4($author$project$Components$Produits$StructureCatalogue$Etages$Model$etageNomme, i18n, niveaux, glisse, etages),
			A4($author$project$Components$Produits$StructureCatalogue$Etages$Model$etageNomme, i18n, niveaux, cible, etages));
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$depose = F3(
	function (i18n, cible, model) {
		var _v0 = _Utils_Tuple2(
			model.cG,
			$author$project$Components$Produits$StructureCatalogue$Etages$Update$reglee(model));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var glisse = _v0.a.a;
			var _v1 = _v0.b.a;
			var structure = _v1.a;
			var typologie = _v1.b;
			var _v2 = A3(
				$elm$core$Maybe$map2,
				$elm$core$Tuple$pair,
				A3($author$project$Components$Produits$StructureCatalogue$Etages$Model$deposer, glisse, cible, typologie.yG),
				A5($author$project$Components$Produits$StructureCatalogue$Etages$Model$titreDuDepot, i18n, structure.C9, glisse, cible, typologie.yG));
			if (!_v2.$) {
				var _v3 = _v2.a;
				var ordre = _v3.a;
				var titre = _v3.b;
				return A4(
					$author$project$Components$Produits$StructureCatalogue$Etages$Update$demander,
					A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ReordonnerLesEtages, typologie.Aq, ordre),
					titre,
					$elm$core$Maybe$Nothing,
					_Utils_update(
						model,
						{cG: $elm$core$Maybe$Nothing}));
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cG: $elm$core$Maybe$Nothing}),
					_List_Nil);
			}
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{cG: $elm$core$Maybe$Nothing}),
				_List_Nil);
		}
	});
var $author$project$API$ProcessUid$ProcessUid = $elm$core$Basics$identity;
var $author$project$API$ProcessUid$grouper = function (paires) {
	return A2(
		$elm$core$String$join,
		'-',
		A2(
			$elm$core$List$map,
			$elm$core$String$concat,
			_List_fromArray(
				[
					A2($elm$core$List$take, 4, paires),
					A2(
					$elm$core$List$take,
					2,
					A2($elm$core$List$drop, 4, paires)),
					A2(
					$elm$core$List$take,
					2,
					A2($elm$core$List$drop, 6, paires)),
					A2(
					$elm$core$List$take,
					2,
					A2($elm$core$List$drop, 8, paires)),
					A2($elm$core$List$drop, 10, paires)
				])));
};
var $elm$core$Char$fromCode = _Char_fromCode;
var $author$project$API$ProcessUid$hexadecimal = function (octet) {
	var chiffre = function (valeur) {
		return $elm$core$Char$fromCode(
			(valeur < 10) ? (48 + valeur) : (87 + valeur));
	};
	return $elm$core$String$fromList(
		_List_fromArray(
			[
				chiffre((octet / 16) | 0),
				chiffre(
				A2($elm$core$Basics$modBy, 16, octet))
			]));
};
var $author$project$API$ProcessUid$marquer = F2(
	function (rang, octet) {
		return (rang === 6) ? (64 + A2($elm$core$Basics$modBy, 16, octet)) : ((rang === 8) ? (128 + A2($elm$core$Basics$modBy, 64, octet)) : octet);
	});
var $author$project$API$ProcessUid$octetsDemandes = 16;
var $author$project$API$ProcessUid$depuisOctets = function (octets) {
	return (_Utils_eq(
		$elm$core$List$length(octets),
		$author$project$API$ProcessUid$octetsDemandes) && A2(
		$elm$core$List$all,
		function (octet) {
			return (octet >= 0) && (octet <= 255);
		},
		octets)) ? $elm$core$Maybe$Just(
		$author$project$API$ProcessUid$grouper(
			A2(
				$elm$core$List$map,
				$author$project$API$ProcessUid$hexadecimal,
				A2($elm$core$List$indexedMap, $author$project$API$ProcessUid$marquer, octets)))) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$DesactiverUnNiveau = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Update$auRangementSiOuvert = F2(
	function (model, identifiant) {
		return $author$project$Components$Shared$Drawer$Model$estOuvert(model.bZ) ? $author$project$Components$Produits$StructureCatalogue$Etages$Model$auRangement(identifiant) : identifiant;
	});
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Model$idDuBoutonDActivation = function (id) {
	return 'niveau-' + ($author$project$Catalogue$Identifiants$niveauIdToString(id) + '-reactiver');
};
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Update$desactiver = F2(
	function (niveau, model) {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Commandes$avecFoyer,
			$author$project$Components$Produits$StructureCatalogue$Model$SurLeControle(
				A2(
					$author$project$Components$Produits$StructureCatalogue$Niveaux$Update$auRangementSiOuvert,
					model,
					$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$idDuBoutonDActivation(niveau))),
			A2(
				$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$DesactiverUnNiveau(niveau),
				model));
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$descendre = F2(
	function (cle, ordre) {
		return _Utils_update(
			ordre,
			{
				gV: A2(
					$author$project$Components$Shared$Ordre$descendre,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dy;
						},
						$elm$core$Basics$eq(cle)),
					ordre.gV)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Model$SurLOrdreDeLEtat = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Etats$Update$descendu = F2(
	function (code, model) {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Commandes$avecFoyer,
			A2($author$project$Components$Produits$StructureCatalogue$Model$SurLOrdreDeLEtat, code, 1),
			A2(
				$author$project$Components$Produits$StructureCatalogue$Etats$Update$definir,
				$author$project$Components$Shared$Ordre$descendre(
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.vx;
						},
						$elm$core$Basics$eq(code))),
				model));
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$OrdonnerLesNatures = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Model$SurLOrdreDeLaNature = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Natures$Update$ordonner = F4(
	function (changer, code, sens, model) {
		var _v0 = model.h$;
		if (!_v0.$) {
			var structure = _v0.a;
			var deplacables = $author$project$Components$Produits$StructureCatalogue$Natures$Model$deplacables(structure.oo);
			var voulues = _Utils_ap(
				changer(deplacables),
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.vx;
						},
						$elm$core$Basics$eq($author$project$Catalogue$Vocabulaire$natureDeService)),
					structure.oo));
			return (_Utils_eq(code, $author$project$Catalogue$Vocabulaire$natureDeService) || _Utils_eq(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.vx;
					},
					voulues),
				A2(
					$elm$core$List$map,
					function ($) {
						return $.vx;
					},
					structure.oo))) ? _Utils_Tuple2(model, _List_Nil) : A2(
				$author$project$Components$Produits$StructureCatalogue$Commandes$avecFoyer,
				A2($author$project$Components$Produits$StructureCatalogue$Model$SurLOrdreDeLaNature, code, sens),
				A2(
					$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$OrdonnerLesNatures(
						A2(
							$elm$core$List$map,
							function ($) {
								return $.vx;
							},
							voulues)),
					model));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Natures$Update$descendue = F2(
	function (code, model) {
		return A4(
			$author$project$Components$Produits$StructureCatalogue$Natures$Update$ordonner,
			$author$project$Components$Shared$Ordre$descendre(
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.vx;
					},
					$elm$core$Basics$eq(code))),
			code,
			1,
			model);
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$destinationChoisie = F2(
	function (destination, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{cy: destination}),
			_List_Nil);
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$AutreRefus = {$: 78};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ClassificationIntrouvable = {$: 75};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ArticleIndisponible = function (a) {
	return {$: 37, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ChampDejaDansLaBibliotheque = function (a) {
	return {$: 30, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ChampLienAvecArticles = function (a) {
	return {$: 68, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EtageHorsDeLaPortee = function (a) {
	return {$: 31, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$InformationRenseignee = function (a) {
	return {$: 66, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$InformationUtiliseeParUnCalcul = function (a) {
	return {$: 74, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$NiveauUtilise = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$RenseigneeSeulementVersLeHaut = function (a) {
	return {$: 67, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ArbreTropProfond = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$TropDEtages = function (a) {
	return {$: 28, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$TropDeClassifications = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$TropDeNiveaux = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$TropDeNoeuds = function (a) {
	return {$: 62, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$TropDeValeurs = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$avecMaximum = _List_fromArray(
	[
		_Utils_Tuple2('TropDeNiveaux', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$TropDeNiveaux),
		_Utils_Tuple2('TropDeClassifications', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$TropDeClassifications),
		_Utils_Tuple2('TropDeValeurs', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$TropDeValeurs),
		_Utils_Tuple2('ArbreTropProfond', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ArbreTropProfond),
		_Utils_Tuple2('TropDEtages', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$TropDEtages),
		_Utils_Tuple2('TropDeNoeuds', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$TropDeNoeuds)
	]);
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ArbrePlusProfondQueLesEtages = function (a) {
	return {$: 53, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$CategoriesRangees = function (a) {
	return {$: 50, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EtatPorte = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$avecUnCompte = _List_fromArray(
	[
		_Utils_Tuple3('CategoriesRangees', 'categories', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$CategoriesRangees),
		_Utils_Tuple3('ArbrePlusProfondQueLesEtages', 'etagesLibres', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ArbrePlusProfondQueLesEtages),
		_Utils_Tuple3('EtatPorte', 'references', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EtatPorte)
	]);
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$Renseignement = F2(
	function (references, exemple) {
		return {yY: exemple, hD: references};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$renseignement = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$Renseignement,
	A2($elm$json$Json$Decode$field, 'references', $elm$json$Json$Decode$int),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'exemple', $elm$json$Json$Decode$string)));
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ArbreChange = {$: 55};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ArchetypeNonRepetable = {$: 17};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$CategorieNonModifiable = {$: 34};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ChampInconnu = {$: 71};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ChampNonLien = {$: 35};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ClassificationDeMemeNom = {$: 19};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ClassificationDeRangementRequise = {$: 47};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ClassificationDejaExistante = {$: 54};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$CommandeEnDouble = {$: 77};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$DejaAuMemeEndroit = {$: 69};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EcritureConcurrente = {$: 76};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EtageDeLaStructure = {$: 38};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EtageDejaExistant = {$: 40};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EtageDerive = {$: 64};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EtageInconnu = {$: 44};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EtageProduitDernier = {$: 42};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EtageProduitOccupe = {$: 43};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EtagesVerrouilles = {$: 33};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EtatDeDepartNonVerrouillable = {$: 11};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EtatEnDouble = {$: 8};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EtatInconnu = {$: 10};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EtatVerrouillant = {$: 12};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$GammeHorsDeLaMarque = {$: 63};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$GrammaireAnglaiseSansLibelle = {$: 65};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$InformationDejaPosee = {$: 70};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$LibelleDEtatRequis = {$: 9};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$LibelleDeNatureDejaPris = {$: 14};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ListeDEtatsVide = {$: 7};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ListeInconnue = {$: 48};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$NiveauDejaDesigne = {$: 39};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$NiveauDejaExistant = {$: 3};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$NiveauHorsOrdre = {$: 41};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$NiveauInconnu = {$: 4};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$NiveauParDefautNonRetirable = {$: 2};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$NiveauSansLibelleParDefaut = {$: 5};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$NiveauToujoursUtilise = {$: 1};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$NomDEtageDejaPris = {$: 29};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$NomDeListeDejaPris = {$: 49};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$NomDejaPoseAuDessus = {$: 32};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$OrdreDEtagesInvalide = {$: 45};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$OrdreDesNaturesInvalide = {$: 15};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$OrdreDesNiveauxInvalide = {$: 6};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ParentArchive = {$: 23};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ParentInconnu = {$: 25};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$PerimetreIndisponible = {$: 58};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$PerimetreSurUnChampUnSeul = {$: 57};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$RangDEtageInvalide = {$: 46};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$RangDeValeurInvalide = {$: 27};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ServiceNonDeplacable = {$: 16};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$TropDArticles = {$: 36};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$TypologieNonVide = {$: 51};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ValeurDEtageArchivee = {$: 59};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ValeurDejaExistante = {$: 52};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ValeurDejaSousLeParent = {$: 60};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ValeurInconnue = {$: 24};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ValeurSousElleMeme = {$: 26};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ValeurSurUnAutreEtage = {$: 61};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$sansContenu = _List_fromArray(
	[
		_Utils_Tuple2('NiveauToujoursUtilise', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$NiveauToujoursUtilise),
		_Utils_Tuple2('NiveauParDefautNonRetirable', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$NiveauParDefautNonRetirable),
		_Utils_Tuple2('NiveauDejaExistant', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$NiveauDejaExistant),
		_Utils_Tuple2('NiveauInconnu', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$NiveauInconnu),
		_Utils_Tuple2('NiveauSansLibelleParDefaut', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$NiveauSansLibelleParDefaut),
		_Utils_Tuple2('OrdreDesNiveauxInvalide', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$OrdreDesNiveauxInvalide),
		_Utils_Tuple2('ListeDEtatsVide', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ListeDEtatsVide),
		_Utils_Tuple2('EtatEnDouble', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EtatEnDouble),
		_Utils_Tuple2('LibelleDEtatRequis', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$LibelleDEtatRequis),
		_Utils_Tuple2('EtatInconnu', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EtatInconnu),
		_Utils_Tuple2('EtatDeDepartNonVerrouillable', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EtatDeDepartNonVerrouillable),
		_Utils_Tuple2('EtatVerrouillant', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EtatVerrouillant),
		_Utils_Tuple2('LibelleDeNatureDejaPris', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$LibelleDeNatureDejaPris),
		_Utils_Tuple2('OrdreDesNaturesInvalide', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$OrdreDesNaturesInvalide),
		_Utils_Tuple2('ServiceNonDeplacable', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ServiceNonDeplacable),
		_Utils_Tuple2('ArchetypeNonRepetable', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ArchetypeNonRepetable),
		_Utils_Tuple2('ClassificationDeMemeNom', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ClassificationDeMemeNom),
		_Utils_Tuple2('ParentArchive', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ParentArchive),
		_Utils_Tuple2('ValeurInconnue', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ValeurInconnue),
		_Utils_Tuple2('ParentInconnu', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ParentInconnu),
		_Utils_Tuple2('ValeurSousElleMeme', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ValeurSousElleMeme),
		_Utils_Tuple2('RangDeValeurInvalide', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$RangDeValeurInvalide),
		_Utils_Tuple2('NomDEtageDejaPris', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$NomDEtageDejaPris),
		_Utils_Tuple2('EtagesVerrouilles', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EtagesVerrouilles),
		_Utils_Tuple2('ApercuPerime', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ApercuPerime),
		_Utils_Tuple2('PerimetreSurUnChampUnSeul', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$PerimetreSurUnChampUnSeul),
		_Utils_Tuple2('PerimetreIndisponible', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$PerimetreIndisponible),
		_Utils_Tuple2('CategorieNonModifiable', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$CategorieNonModifiable),
		_Utils_Tuple2('ChampNonLien', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ChampNonLien),
		_Utils_Tuple2('TropDArticles', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$TropDArticles),
		_Utils_Tuple2('EtageDeLaStructure', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EtageDeLaStructure),
		_Utils_Tuple2('NiveauDejaDesigne', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$NiveauDejaDesigne),
		_Utils_Tuple2('EtageDejaExistant', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EtageDejaExistant),
		_Utils_Tuple2('NiveauHorsOrdre', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$NiveauHorsOrdre),
		_Utils_Tuple2('EtageProduitDernier', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EtageProduitDernier),
		_Utils_Tuple2('EtageProduitOccupe', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EtageProduitOccupe),
		_Utils_Tuple2('EtageInconnu', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EtageInconnu),
		_Utils_Tuple2('OrdreDEtagesInvalide', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$OrdreDEtagesInvalide),
		_Utils_Tuple2('RangDEtageInvalide', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$RangDEtageInvalide),
		_Utils_Tuple2('ClassificationDeRangementRequise', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ClassificationDeRangementRequise),
		_Utils_Tuple2('ListeInconnue', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ListeInconnue),
		_Utils_Tuple2('NomDeListeDejaPris', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$NomDeListeDejaPris),
		_Utils_Tuple2('TypologieNonVide', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$TypologieNonVide),
		_Utils_Tuple2('ValeurDejaExistante', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ValeurDejaExistante),
		_Utils_Tuple2('ClassificationDejaExistante', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ClassificationDejaExistante),
		_Utils_Tuple2('NoeudInconnu', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ArbreChange),
		_Utils_Tuple2('NoeudParentInconnu', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ArbreChange),
		_Utils_Tuple2('ParentHorsDeLEtageDuDessus', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ArbreChange),
		_Utils_Tuple2('ParentRequis', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ArbreChange),
		_Utils_Tuple2('SorteNonConforme', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ArbreChange),
		_Utils_Tuple2('ValeurDEtageInconnue', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ArbreChange),
		_Utils_Tuple2('EtageLibreRequis', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ArbreChange),
		_Utils_Tuple2('PremierEtage', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ArbreChange),
		_Utils_Tuple2('DernierEtage', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ArbreChange),
		_Utils_Tuple2('ValeurDEtageArchivee', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ValeurDEtageArchivee),
		_Utils_Tuple2('ValeurDejaSousLeParent', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ValeurDejaSousLeParent),
		_Utils_Tuple2('ValeurSurUnAutreEtage', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ValeurSurUnAutreEtage),
		_Utils_Tuple2('GammeHorsDeLaMarque', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$GammeHorsDeLaMarque),
		_Utils_Tuple2('EtageDerive', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EtageDerive),
		_Utils_Tuple2('GrammaireAnglaiseSansLibelle', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$GrammaireAnglaiseSansLibelle),
		_Utils_Tuple2('DejaAuMemeEndroit', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$DejaAuMemeEndroit),
		_Utils_Tuple2('NomDejaPose', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$NomDejaPoseAuDessus),
		_Utils_Tuple2('CleDejaPosee', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$InformationDejaPosee),
		_Utils_Tuple2('ChampInconnu', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ChampInconnu),
		_Utils_Tuple2('ConflictingCommand', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EcritureConcurrente),
		_Utils_Tuple2('DuplicateCommand', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$CommandeEnDouble)
	]);
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$SchemaInvalide = {$: 72};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$TypeNonPropose = {$: 73};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$schemaRefuse = function (codes) {
	return A2($elm$core$List$member, 'TypeNonPropose', codes) ? $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$TypeNonPropose : $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$SchemaInvalide;
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$Utilisation = F2(
	function (libelle, estUneCondition) {
		return {mc: estUneCondition, Bl: libelle};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$utilisation = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$Utilisation,
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['libelles', 'fr']),
				$elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'cle', $elm$json$Json$Decode$string)
			])),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Basics$eq('condition'),
		A2($elm$json$Json$Decode$field, 'nature', $elm$json$Json$Decode$string)));
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$duDomaine = $elm$json$Json$Decode$oneOf(
	A2(
		$elm$core$List$cons,
		A2(
			$elm$json$Json$Decode$field,
			'NiveauUtilise',
			A3(
				$elm$json$Json$Decode$map2,
				F2(
					function (niveau, elements) {
						return $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$NiveauUtilise(
							{aV: elements, os: niveau});
					}),
				A2($elm$json$Json$Decode$field, 'niveau', $author$project$Catalogue$Identifiants$niveauIdDecoder),
				A2($elm$json$Json$Decode$field, 'elements', $elm$json$Json$Decode$int))),
		A2(
			$elm$core$List$cons,
			A2(
				$elm$json$Json$Decode$field,
				'InformationRenseignee',
				A2($elm$json$Json$Decode$map, $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$InformationRenseignee, $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$renseignement)),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$json$Json$Decode$field,
					'ChampDejaDansLaBibliotheque',
					A2(
						$elm$json$Json$Decode$map,
						$author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ChampDejaDansLaBibliotheque,
						A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string))),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$json$Json$Decode$field,
						'EtageHorsDeLaPortee',
						A2(
							$elm$json$Json$Decode$map,
							$author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$EtageHorsDeLaPortee,
							A2($elm$json$Json$Decode$field, 'etage', $elm$json$Json$Decode$string))),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$json$Json$Decode$field,
							'ChampLienAvecArticles',
							A3(
								$elm$json$Json$Decode$map2,
								F2(
									function (champ, articles) {
										return $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ChampLienAvecArticles(
											{tP: articles, uN: champ});
									}),
								A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
								A2(
									$elm$json$Json$Decode$field,
									'articles',
									$elm$json$Json$Decode$list($elm$json$Json$Decode$string)))),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$json$Json$Decode$field,
								'ArticleIndisponible',
								A2(
									$elm$json$Json$Decode$map,
									$author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ArticleIndisponible,
									A2(
										$elm$json$Json$Decode$field,
										'articles',
										$elm$json$Json$Decode$list($elm$json$Json$Decode$string)))),
							A2(
								$elm$core$List$cons,
								A2(
									$elm$json$Json$Decode$field,
									'SchemaInvalide',
									A2(
										$elm$json$Json$Decode$map,
										$author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$schemaRefuse,
										A2(
											$elm$json$Json$Decode$field,
											'defauts',
											$elm$json$Json$Decode$list(
												A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string))))),
								A2(
									$elm$core$List$cons,
									A2(
										$elm$json$Json$Decode$field,
										'InformationUtiliseeParUnCalcul',
										A2(
											$elm$json$Json$Decode$map,
											$author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$InformationUtiliseeParUnCalcul,
											A2(
												$elm$json$Json$Decode$field,
												'utiliseePar',
												$elm$json$Json$Decode$list($author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$utilisation)))),
									A2(
										$elm$core$List$cons,
										A2(
											$elm$json$Json$Decode$field,
											'RenseigneeSeulementVersLeHaut',
											A2(
												$elm$json$Json$Decode$map,
												$author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$RenseigneeSeulementVersLeHaut,
												A2($elm$json$Json$Decode$field, 'renseignement', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$renseignement))),
										_Utils_ap(
											A2(
												$elm$core$List$map,
												function (_v0) {
													var nom = _v0.a;
													var erreur = _v0.b;
													return A2(
														$elm$json$Json$Decode$field,
														nom,
														A2(
															$elm$json$Json$Decode$map,
															erreur,
															A2($elm$json$Json$Decode$field, 'maximum', $elm$json$Json$Decode$int)));
												},
												$author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$avecMaximum),
											_Utils_ap(
												A2(
													$elm$core$List$map,
													function (_v1) {
														var nom = _v1.a;
														var champ = _v1.b;
														var erreur = _v1.c;
														return A2(
															$elm$json$Json$Decode$field,
															nom,
															A2(
																$elm$json$Json$Decode$map,
																erreur,
																A2($elm$json$Json$Decode$field, champ, $elm$json$Json$Decode$int)));
													},
													$author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$avecUnCompte),
												A2(
													$elm$core$List$map,
													function (_v2) {
														var nom = _v2.a;
														var erreur = _v2.b;
														return A2(
															$elm$json$Json$Decode$field,
															nom,
															$elm$json$Json$Decode$succeed(erreur));
													},
													$author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$sansContenu)))))))))))));
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$duRefus = function (reponse) {
	var _v0 = A2(
		$elm$json$Json$Decode$decodeString,
		A2($elm$json$Json$Decode$field, 'error', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$duDomaine),
		reponse.f$);
	if (!_v0.$) {
		var erreur = _v0.a;
		return erreur;
	} else {
		return (reponse.ri === 404) ? $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ClassificationIntrouvable : $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$AutreRefus;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$surLaForme = F3(
	function (langue, changer, saisies) {
		return (langue === 'en') ? _Utils_update(
			saisies,
			{
				yg: changer(saisies.yg)
			}) : _Utils_update(
			saisies,
			{
				zX: changer(saisies.zX)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$elisionBasculee = F2(
	function (langue, elision) {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Etages$Model$surLaForme,
			langue,
			function (forme) {
				return _Utils_update(
					forme,
					{av: elision});
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$elisionBasculee = F3(
	function (langue, elision, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					I: A3($author$project$Components$Produits$StructureCatalogue$Etages$Model$elisionBasculee, langue, elision, model.I)
				}),
			_List_Nil);
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ModifierUneInformation = F2(
	function (a, b) {
		return {$: 37, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$enregistree = function (model) {
	var _v0 = $author$project$Components$Produits$StructureCatalogue$Informations$Update$visee(model);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var portee = _v1.a;
		var lue = _v1.b;
		if ($author$project$Components$Produits$StructureCatalogue$Informations$Update$aChange(model)) {
			var champ = lue.uN;
			var type_ = A2(
				$elm$core$Maybe$withDefault,
				champ.r0,
				A2($elm$core$Maybe$andThen, $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$forme, model._));
			var _v2 = model._;
			if (!_v2.$) {
				var edite = _v2.a;
				return _Utils_eq(
					$author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$forme(edite),
					$elm$core$Maybe$Nothing) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							_: $elm$core$Maybe$Just(
								_Utils_update(
									edite,
									{b5: true}))
						}),
					_List_Nil) : A2(
					$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
					A2(
						$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ModifierUneInformation,
						portee,
						_Utils_update(
							champ,
							{he: model.c_, r0: type_})),
					_Utils_update(
						model,
						{aL: $elm$core$Maybe$Nothing}));
			} else {
				return A2(
					$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
					A2(
						$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ModifierUneInformation,
						portee,
						_Utils_update(
							champ,
							{he: model.c_})),
					_Utils_update(
						model,
						{aL: $elm$core$Maybe$Nothing}));
			}
		} else {
			return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$versLInformation, $author$project$Components$Shared$Drawer$Update$Fermer, model);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$DefinirLesArticlesLiesDUnChampHerite = F4(
	function (a, b, c, d) {
		return {$: 44, a: a, b: b, c: c, d: d};
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Etage$poseDe = F2(
	function (cle, ouvert) {
		return A2($elm$core$Set$member, cle, ouvert.qJ) ? $elm$core$Maybe$Nothing : A2($elm$core$Dict$get, cle, ouvert.hv);
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Etage$perimetreVoulu = F2(
	function (cle, ouvert) {
		var _v0 = A2($author$project$Components$Produits$StructureCatalogue$Informations$Etage$perimetreDe, cle, ouvert);
		if (!_v0.$) {
			var retenu = _v0.a;
			return $elm$core$Maybe$Just(retenu.Aq);
		} else {
			return A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Aq;
				},
				A2($author$project$Components$Produits$StructureCatalogue$Informations$Etage$poseDe, cle, ouvert));
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Etage$commandes = function (ouvert) {
	var changes = A2(
		$elm$core$List$map,
		$elm$core$Tuple$first,
		A2(
			$elm$core$List$filter,
			function (_v0) {
				var cle = _v0.a;
				var articles = _v0.b;
				return !_Utils_eq(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.Aq;
						},
						articles),
					A2(
						$elm$core$List$map,
						function ($) {
							return $.Aq;
						},
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2($elm$core$Dict$get, cle, ouvert.ee))));
			},
			$elm$core$Dict$toList(ouvert.uw)));
	var avecPerimetre = _Utils_ap(
		$elm$core$Dict$keys(ouvert.pg),
		$elm$core$Set$toList(ouvert.qJ));
	return A2(
		$elm$core$List$map,
		function (cle) {
			return A4(
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$DefinirLesArticlesLiesDUnChampHerite,
				ouvert.F$,
				cle,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.Aq;
					},
					A2($author$project$Components$Produits$StructureCatalogue$Informations$Etage$articlesDe, cle, ouvert)),
				A2($author$project$Components$Produits$StructureCatalogue$Informations$Etage$perimetreVoulu, cle, ouvert));
		},
		_Utils_ap(
			changes,
			A2(
				$elm$core$List$filter,
				function (cle) {
					return !A2($elm$core$List$member, cle, changes);
				},
				avecPerimetre)));
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$etageEnregistre = function (model) {
	var _v0 = A2($elm$core$Maybe$map, $author$project$Components$Produits$StructureCatalogue$Informations$Etage$commandes, model.s);
	if (!_v0.$) {
		var commandes = _v0.a;
		return $elm$core$List$isEmpty(commandes) ? A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$versLEtage, $author$project$Components$Shared$Drawer$Update$Fermer, model) : A2(
			$author$project$Components$Produits$StructureCatalogue$Commandes$enchainer,
			commandes,
			_Utils_update(
				model,
				{aL: $elm$core$Maybe$Nothing}));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Etage$idDuBoutonModifier = function (portee) {
	return 'etage-modifier-' + function () {
		switch (portee.$) {
			case 0:
				return 'catalogue';
			case 1:
				var classification = portee.a;
				return 'typologie-' + $author$project$Catalogue$Identifiants$classificationIdToString(classification);
			case 2:
				var classification = portee.a;
				var valeur = portee.b;
				return 'noeud-' + ($author$project$Catalogue$Identifiants$classificationIdToString(classification) + ('-' + valeur));
			default:
				var type_ = portee.a;
				return 'categorie-' + $author$project$Catalogue$Identifiants$typeDeProduitIdToString(type_);
		}
	}();
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Etage$ouvrir = F3(
	function (porteur, nom, kicker) {
		return {uw: porteur.tP, zu: porteur.zy, A6: kicker, ee: porteur.tP, Dj: nom, pg: $elm$core$Dict$empty, F$: porteur.F$, hv: porteur.pg, qJ: $elm$core$Set$empty};
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$etageOuvert = F4(
	function (portee, nom, kicker, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.F3;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$filter(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.F$;
							},
							$elm$core$Basics$eq(portee))),
					$elm$core$List$head)),
			model.AM);
		if (!_v0.$) {
			var porteur = _v0.a;
			return A2(
				$author$project$Components$Produits$StructureCatalogue$Informations$Update$versLEtage,
				$author$project$Components$Shared$Drawer$Update$Ouvrir(
					$author$project$Components$Produits$StructureCatalogue$Informations$Etage$idDuBoutonModifier(portee)),
				_Utils_update(
					model,
					{
						s: $elm$core$Maybe$Just(
							A3($author$project$Components$Produits$StructureCatalogue$Informations$Etage$ouvrir, porteur, nom, kicker)),
						aL: $elm$core$Maybe$Nothing
					}));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$Common$ChoixDArticles$basculer = F3(
	function (groupe, id, choix) {
		var bascule = function (valeurs) {
			return A2($elm$core$List$member, id, valeurs) ? A2(
				$elm$core$List$filter,
				$elm$core$Basics$neq(id),
				valeurs) : _Utils_ap(
				valeurs,
				_List_fromArray(
					[id]));
		};
		switch (groupe) {
			case 0:
				return _Utils_update(
					choix,
					{
						mu: bascule(choix.mu),
						EE: 1
					});
			case 1:
				return _Utils_update(
					choix,
					{
						dt: bascule(choix.dt),
						EE: 1
					});
			case 2:
				return _Utils_update(
					choix,
					{
						cU: bascule(choix.cU),
						EE: 1
					});
			case 3:
				return _Utils_update(
					choix,
					{
						gG: bascule(choix.gG),
						EE: 1
					});
			case 4:
				return _Utils_update(
					choix,
					{
						EE: 1,
						r7: bascule(choix.r7)
					});
			default:
				return _Utils_update(
					choix,
					{
						mj: bascule(choix.mj),
						EE: 1
					});
		}
	});
var $author$project$Components$Produits$Common$Facettes$fusionner = A2(
	$elm$core$List$foldl,
	F2(
		function (option, vues) {
			return A2(
				$elm$core$List$any,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Aq;
					},
					$elm$core$Basics$eq(option.Aq)),
				vues) ? A2(
				$elm$core$List$map,
				function (vue) {
					return _Utils_eq(vue.Aq, option.Aq) ? _Utils_update(
						vue,
						{
							hl: _Utils_ap(
								vue.hl,
								A2(
									$elm$core$List$filter,
									function (p) {
										return !A2($elm$core$List$member, p, vue.hl);
									},
									option.hl))
						}) : vue;
				},
				vues) : _Utils_ap(
				vues,
				_List_fromArray(
					[option]));
		}),
	_List_Nil);
var $author$project$I18n$Textes$produitsReferencesListeFamilleHomonyme = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.references.liste.famille-homonyme',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'famille',
				$author$project$I18n$Traductions$Sous(p.zj)),
				_Utils_Tuple2(
				'typologie',
				$author$project$I18n$Traductions$Sous(p.r3))
			]),
		'{famille} · {typologie}');
};
var $author$project$Components$Produits$Common$Facettes$idLibre = function (valeur) {
	if (!valeur.$) {
		var id = valeur.a;
		return $elm$core$Maybe$Just(
			$author$project$Catalogue$Identifiants$valeurIdToString(id));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$String$map = _String_map;
var $author$project$Components$Produits$Common$Facettes$sansAccent = function (lettre) {
	return ((lettre === '\u00E9') || (lettre === '\u00E8')) ? 'e' : lettre;
};
var $author$project$Components$Produits$Common$Facettes$simplifier = function (designation) {
	return A2(
		$elm$core$String$map,
		$author$project$Components$Produits$Common$Facettes$sansAccent,
		$elm$core$String$toLower(
			$elm$core$String$trim(designation)));
};
var $author$project$Catalogue$Chemin$tous = function (_v0) {
	var etages = _v0.a;
	var noeuds = _v0.b;
	return _Utils_Tuple2(etages, noeuds);
};
var $author$project$Components$Produits$Common$Facettes$valeursDe = F3(
	function (etage, dessus, typologies) {
		return $author$project$Components$Produits$Common$Facettes$fusionner(
			A2(
				$elm$core$List$concatMap,
				function (typologie) {
					var estDe = F2(
						function (nom, e) {
							return _Utils_eq(
								A2($elm$core$Maybe$map, $author$project$Components$Produits$Common$Facettes$simplifier, e.Bu),
								$elm$core$Maybe$Just(nom));
						});
					var _v0 = $author$project$Catalogue$Chemin$tous(typologie.jK);
					var etages = _v0.a;
					var noeuds = _v0.b;
					var parentDe = function (noeud) {
						return A2(
							$elm$core$List$filterMap,
							function (autre) {
								return $author$project$Components$Produits$Common$Facettes$idLibre(autre.fm);
							},
							A2(
								$elm$core$List$filter,
								function (autre) {
									return _Utils_eq(
										$elm$core$Maybe$Just(autre.Aq),
										noeud.ey);
								},
								noeuds));
					};
					return A2(
						$elm$core$List$filterMap,
						function (noeud) {
							return A2(
								$elm$core$Maybe$map,
								function (id) {
									return {
										Aq: id,
										Dj: $author$project$I18n$Traductions$tel(noeud.Dj),
										hl: _Utils_eq(dessus, $elm$core$Maybe$Nothing) ? _List_Nil : parentDe(noeud)
									};
								},
								$author$project$Components$Produits$Common$Facettes$idLibre(noeud.fm));
						},
						A2(
							$elm$core$List$filter,
							function (noeud) {
								return A2(
									$elm$core$List$any,
									function (e) {
										return _Utils_eq(e.Aq, noeud.md) && A2(estDe, etage, e);
									},
									etages);
							},
							noeuds));
				},
				typologies));
	});
var $author$project$Components$Produits$Common$Facettes$famillesDistinguees = function (typologies) {
	var parTypologie = A2(
		$elm$core$List$map,
		function (typologie) {
			return _Utils_Tuple2(
				typologie.Dj,
				A3(
					$author$project$Components$Produits$Common$Facettes$valeursDe,
					'famille',
					$elm$core$Maybe$Nothing,
					_List_fromArray(
						[typologie])));
		},
		typologies);
	var homonyme = function (nom) {
		return $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Dj;
					},
					$elm$core$Basics$eq(nom)),
				$author$project$Components$Produits$Common$Facettes$fusionner(
					A2($elm$core$List$concatMap, $elm$core$Tuple$second, parTypologie)))) > 1;
	};
	var deLaTypologie = function (option) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$first,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$second,
						$elm$core$List$any(
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(option.Aq)))),
					parTypologie)));
	};
	return A2(
		$elm$core$List$map,
		function (option) {
			var _v0 = _Utils_Tuple2(
				homonyme(option.Dj),
				deLaTypologie(option));
			if (_v0.a && (!_v0.b.$)) {
				var typologie = _v0.b.a;
				return _Utils_update(
					option,
					{
						Dj: $author$project$I18n$Textes$produitsReferencesListeFamilleHomonyme(
							{
								zj: option.Dj,
								r3: $author$project$I18n$Traductions$tel(typologie)
							})
					});
			} else {
				return option;
			}
		},
		$author$project$Components$Produits$Common$Facettes$fusionner(
			A2($elm$core$List$concatMap, $elm$core$Tuple$second, parTypologie)));
};
var $author$project$Catalogue$Identifiants$elementIdToString = function (_v0) {
	var valeur = _v0;
	return valeur;
};
var $author$project$Components$Produits$Common$Facettes$marquesEtGammes = F2(
	function (catalogue, racine) {
		var enfants = function (_v4) {
			var dessous = _v4;
			return dessous;
		};
		var element = function (noeud) {
			return A3(
				$elm$core$Maybe$map2,
				F2(
					function (id, libelles) {
						return _Utils_Tuple2(
							$author$project$Catalogue$Identifiants$elementIdToString(id),
							$author$project$I18n$Traductions$tel(libelles.zX));
					}),
				noeud.vf.lQ,
				noeud.R);
		};
		var archetypeDe = function (noeud) {
			return A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.fA;
				},
				A2(
					$elm$core$Maybe$andThen,
					function (niveau) {
						return $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.Aq;
									},
									$elm$core$Basics$eq(niveau)),
								catalogue.C9));
					},
					noeud.os));
		};
		var parcourir = F2(
			function (parents, noeud) {
				var suivants = function () {
					var _v2 = _Utils_Tuple2(
						element(noeud),
						archetypeDe(noeud));
					if ((!_v2.a.$) && (!_v2.b.$)) {
						var _v3 = _v2.a.a;
						var id = _v3.a;
						var archetype = _v2.b.a;
						return _Utils_eq(archetype, $author$project$Catalogue$Vocabulaire$codeMarque) ? _List_fromArray(
							[id]) : parents;
					} else {
						return parents;
					}
				}();
				var ici = function () {
					var _v0 = _Utils_Tuple2(
						element(noeud),
						archetypeDe(noeud));
					if ((!_v0.a.$) && (!_v0.b.$)) {
						var _v1 = _v0.a.a;
						var id = _v1.a;
						var nom = _v1.b;
						var archetype = _v0.b.a;
						return _Utils_eq(archetype, $author$project$Catalogue$Vocabulaire$codeMarque) ? _List_fromArray(
							[
								_Utils_Tuple2(
								true,
								{Aq: id, Dj: nom, hl: _List_Nil})
							]) : (_Utils_eq(archetype, $author$project$Catalogue$Vocabulaire$codeGamme) ? _List_fromArray(
							[
								_Utils_Tuple2(
								false,
								{Aq: id, Dj: nom, hl: parents})
							]) : _List_Nil);
					} else {
						return _List_Nil;
					}
				}();
				return _Utils_ap(
					ici,
					A2(
						$elm$core$List$concatMap,
						parcourir(suivants),
						enfants(noeud.yp)));
			});
		var tous = A2(
			$elm$core$List$concatMap,
			parcourir(_List_Nil),
			racine);
		return _Utils_Tuple2(
			$author$project$Components$Produits$Common$Facettes$fusionner(
				A2(
					$elm$core$List$map,
					$elm$core$Tuple$second,
					A2($elm$core$List$filter, $elm$core$Tuple$first, tous))),
			$author$project$Components$Produits$Common$Facettes$fusionner(
				A2(
					$elm$core$List$map,
					$elm$core$Tuple$second,
					A2(
						$elm$core$List$filter,
						A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$Basics$not),
						tous))));
	});
var $author$project$Components$Produits$Common$Facettes$toutesLesValeurs = function (typologies) {
	return $author$project$Components$Produits$Common$Facettes$fusionner(
		A2(
			$elm$core$List$concatMap,
			function (typologie) {
				return A2(
					$elm$core$List$filterMap,
					function (noeud) {
						return A2(
							$elm$core$Maybe$map,
							function (id) {
								return {
									Aq: id,
									Dj: $author$project$I18n$Traductions$tel(noeud.Dj),
									hl: _List_Nil
								};
							},
							$author$project$Components$Produits$Common$Facettes$idLibre(noeud.fm));
					},
					$author$project$Catalogue$Chemin$tous(typologie.jK).b);
			},
			typologies));
};
var $author$project$Components$Produits$Common$Facettes$depuis = F2(
	function (catalogue, typologies) {
		var _v0 = A2($author$project$Components$Produits$Common$Facettes$marquesEtGammes, catalogue, catalogue.tA);
		var marques = _v0.a;
		var gammes = _v0.b;
		return {
			dt: A3(
				$author$project$Components$Produits$Common$Facettes$valeursDe,
				'categorie',
				$elm$core$Maybe$Just('famille'),
				typologies),
			mu: $author$project$Components$Produits$Common$Facettes$famillesDistinguees(typologies),
			gG: gammes,
			cU: marques,
			r7: A2(
				$elm$core$List$map,
				function (typologie) {
					return {
						Aq: $author$project$Catalogue$Identifiants$classificationIdToString(typologie.Aq),
						Dj: $author$project$I18n$Traductions$tel(typologie.Dj),
						hl: _List_Nil
					};
				},
				typologies),
			Ki: $author$project$Components$Produits$Common$Facettes$toutesLesValeurs(typologies)
		};
	});
var $author$project$Components$Produits$Common$Facettes$sousLes = F2(
	function (cochees, options) {
		return $elm$core$List$isEmpty(cochees) ? options : A2(
			$elm$core$List$filter,
			function (option) {
				return $elm$core$List$isEmpty(option.hl) || A2(
					$elm$core$List$any,
					function (parent) {
						return A2($elm$core$List$member, parent, cochees);
					},
					option.hl);
			},
			options);
	});
var $author$project$Components$Produits$Common$Facettes$categoriesVisibles = F2(
	function (familles, facettes) {
		return A2($author$project$Components$Produits$Common$Facettes$sousLes, familles, facettes.dt);
	});
var $author$project$Components$Produits$Common$Facettes$gammesVisibles = F2(
	function (marques, facettes) {
		return A2($author$project$Components$Produits$Common$Facettes$sousLes, marques, facettes.gG);
	});
var $author$project$Components$Produits$Common$ChoixDArticles$retenir = F2(
	function (facettes, choix) {
		return _Utils_update(
			choix,
			{
				dt: A2(
					$elm$core$List$filter,
					function (id) {
						return A2(
							$elm$core$List$any,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(id)),
							A2($author$project$Components$Produits$Common$Facettes$categoriesVisibles, choix.mu, facettes));
					},
					choix.dt),
				gG: A2(
					$elm$core$List$filter,
					function (id) {
						return A2(
							$elm$core$List$any,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(id)),
							A2($author$project$Components$Produits$Common$Facettes$gammesVisibles, choix.cU, facettes));
					},
					choix.gG)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$retenirLesFiltres = F2(
	function (model, choix) {
		var _v0 = model.jB;
		if (!_v0.$) {
			var catalogue = _v0.a;
			return A2(
				$author$project$Components$Produits$Common$ChoixDArticles$retenir,
				A2($author$project$Components$Produits$Common$Facettes$depuis, catalogue, model.r7),
				choix);
		} else {
			return choix;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$filtreBascule = F3(
	function (groupe, id, model) {
		return $author$project$Components$Produits$StructureCatalogue$Informations$Update$chercherDesArticles(
			_Utils_Tuple2(
				A2(
					$author$project$Components$Produits$StructureCatalogue$Informations$Update$avecLeChoix,
					A2(
						$elm$core$Basics$composeR,
						A2($author$project$Components$Produits$Common$ChoixDArticles$basculer, groupe, id),
						$author$project$Components$Produits$StructureCatalogue$Informations$Update$retenirLesFiltres(model)),
					model),
				_List_Nil));
	});
var $author$project$Components$Produits$Common$ChoixDArticles$choisir = F3(
	function (groupe, id, choix) {
		var une = (id === '') ? _List_Nil : _List_fromArray(
			[id]);
		switch (groupe) {
			case 0:
				return _Utils_update(
					choix,
					{mu: une, EE: 1});
			case 1:
				return _Utils_update(
					choix,
					{dt: une, EE: 1});
			case 2:
				return _Utils_update(
					choix,
					{cU: une, EE: 1});
			case 3:
				return _Utils_update(
					choix,
					{gG: une, EE: 1});
			case 4:
				return _Utils_update(
					choix,
					{EE: 1, r7: une});
			default:
				return _Utils_update(
					choix,
					{mj: une, EE: 1});
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$filtreChoisi = F3(
	function (groupe, id, model) {
		return $author$project$Components$Produits$StructureCatalogue$Informations$Update$chercherDesArticles(
			_Utils_Tuple2(
				A2(
					$author$project$Components$Produits$StructureCatalogue$Informations$Update$avecLeChoix,
					A2(
						$elm$core$Basics$composeR,
						A2($author$project$Components$Produits$Common$ChoixDArticles$choisir, groupe, id),
						$author$project$Components$Produits$StructureCatalogue$Informations$Update$retenirLesFiltres(model)),
					model),
				_List_Nil));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$saisirLaForme = F2(
	function (forme, rattachement) {
		return _Utils_update(
			rattachement,
			{gB: forme});
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$formeChoisie = function (forme) {
	return $author$project$Components$Produits$StructureCatalogue$Informations$Update$surLeRattachement(
		$author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$saisirLaForme(forme));
};
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$deClassificationEnCours = function (model) {
	var _v0 = model.l2;
	if (_v0.$ === 2) {
		var commande = _v0.b;
		return $author$project$Components$Produits$StructureCatalogue$Classifications$Update$deClassification(commande);
	} else {
		return false;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDeLaConfirmation = 'archivage-confirmer';
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$prefixeDesLibelles = 'classifications-libelle';
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDuChampFrancais = A2($author$project$Components$Shared$LibellesParLangue$View$idDuChamp, $author$project$Components$Produits$StructureCatalogue$Classifications$Model$prefixeDesLibelles, 'fr');
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$foyerDuGesteOuvert = function (model) {
	var premierControle = function () {
		var _v1 = model.vk.mW;
		switch (_v1.$) {
			case 0:
				return $elm$core$Maybe$Nothing;
			case 1:
				return $elm$core$Maybe$Just($author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDuChampFrancais);
			case 2:
				return $elm$core$Maybe$Just($author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDuChampFrancais);
			case 3:
				return $elm$core$Maybe$Just($author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDuChampFrancais);
			case 4:
				return $elm$core$Maybe$Just($author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDuChampFrancais);
			case 5:
				return $elm$core$Maybe$Just($author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDeLaConfirmation);
			case 6:
				return $elm$core$Maybe$Just($author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDeLaConfirmation);
			default:
				return $elm$core$Maybe$Nothing;
		}
	}();
	var _v0 = _Utils_Tuple2(model.mS, premierControle);
	if (((!_v0.a.$) && (!_v0.a.a.$)) && (!_v0.b.$)) {
		var id = _v0.b.a;
		return $author$project$Components$Produits$StructureCatalogue$Classifications$Update$deClassificationEnCours(model) ? _Utils_update(
			model,
			{
				mS: $elm$core$Maybe$Just(
					$author$project$Components$Produits$StructureCatalogue$Model$SurLeControle(id))
			}) : model;
	} else {
		return model;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$genreChoisi = F2(
	function (langue, genre) {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Etages$Model$surLaForme,
			langue,
			function (forme) {
				return _Utils_update(
					forme,
					{M: genre});
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$genreChoisi = F3(
	function (langue, genre, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					I: A3($author$project$Components$Produits$StructureCatalogue$Etages$Model$genreChoisi, langue, genre, model.I)
				}),
			_List_Nil);
	});
var $author$project$Components$Shared$Parcours$Model$idDuTitre = function (nom) {
	return 'etape-' + (nom + '-titre');
};
var $author$project$Components$Produits$StructureCatalogue$Parcours$nom = function (etape) {
	switch (etape) {
		case 0:
			return 'typologies';
		case 1:
			return 'rangement';
		case 2:
			return 'valeurs';
		case 3:
			return 'informations';
		default:
			return 'verification';
	}
};
var $author$project$Components$Produits$StructureCatalogue$Parcours$idDuTitre = function (etape) {
	return $author$project$Components$Shared$Parcours$Model$idDuTitre(
		$author$project$Components$Produits$StructureCatalogue$Parcours$nom(etape));
};
var $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$Informations = F5(
	function (porteurs, categories, unites, liens, lienDesCategories) {
		return {dt: categories, BC: lienDesCategories, nQ: liens, F3: porteurs, sb: unites};
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$CategorieRenseignee = F2(
	function (typeDeProduit, renseignees) {
		return {qr: renseignees, fh: typeDeProduit};
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$categorieDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'renseignees',
	$elm$json$Json$Decode$dict($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'typeDeProduit',
		$author$project$Catalogue$Identifiants$typeDeProduitIdDecoder,
		$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$CategorieRenseignee)));
var $author$project$API$NavLinksDictionary$categoriesDeLEtape = 'categories';
var $author$project$Components$Shared$EditeurDeSchema$Propositions$Propositions = F7(
	function (typesDeChamp, unites, langues, exigences, clesReservees, donneePersonnelle, conservations) {
		return {vm: clesReservees, v7: conservations, xD: donneePersonnelle, y$: exigences, Ba: langues, J_: typesDeChamp, sb: unites};
	});
var $author$project$Components$Shared$EditeurDeSchema$Propositions$TypePropose = F2(
	function (code, options) {
		return {vx: code, o_: options};
	});
var $author$project$Components$Shared$EditeurDeSchema$Propositions$Unite = F3(
	function (code, symbole, grandeur) {
		return {vx: code, m0: grandeur, Jh: symbole};
	});
var $author$project$Components$Shared$EditeurDeSchema$Propositions$uniteDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Shared$EditeurDeSchema$Propositions$Unite,
	A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'symbole', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'grandeur', $elm$json$Json$Decode$string));
var $author$project$Components$Shared$EditeurDeSchema$Propositions$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'conservations',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'donneePersonnelle',
		A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (admise, cochees) {
					return {sY: admise, vu: cochees};
				}),
			A2($elm$json$Json$Decode$field, 'admise', $elm$json$Json$Decode$bool),
			A2(
				$elm$json$Json$Decode$field,
				'cocheeParDefaut',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string))),
		{sY: false, vu: _List_Nil},
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'clesReservees',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'exigences',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'langues',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'unites',
						$elm$json$Json$Decode$list($author$project$Components$Shared$EditeurDeSchema$Propositions$uniteDecoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'typesDeChamp',
							$elm$json$Json$Decode$list(
								A3(
									$elm$json$Json$Decode$map2,
									$author$project$Components$Shared$EditeurDeSchema$Propositions$TypePropose,
									A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
									A2(
										$elm$json$Json$Decode$field,
										'options',
										$elm$json$Json$Decode$list($elm$json$Json$Decode$string)))),
							$elm$json$Json$Decode$succeed($author$project$Components$Shared$EditeurDeSchema$Propositions$Propositions))))))));
var $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$ArticleDEtage = F5(
	function (id, code, nom, etat, marque) {
		return {vx: code, gt: etat, Aq: id, gX: marque, Dj: nom};
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$articleDEtageDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	$author$project$Catalogue$Vocabulaire$champDeLaMarque,
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'etat',
		$elm$json$Json$Decode$string,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'nom',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'code',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$ArticleDEtage))))));
var $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$PerimetreDuChamp = F4(
	function (id, nom, archive, indisponible) {
		return {tE: archive, Aq: id, AJ: indisponible, Dj: nom};
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$perimetreDuChampDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'etat',
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Basics$eq('indisponible'),
		$elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'archive',
		$elm$json$Json$Decode$bool,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'nom',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$PerimetreDuChamp)))));
var $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$Noeud = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$Typologie = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$porteeDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'Catalogue',
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$Catalogue)),
			A2(
			$elm$json$Json$Decode$field,
			'Typologie',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$Typologie,
				A2($elm$json$Json$Decode$field, 'classification', $author$project$Catalogue$Identifiants$classificationIdDecoder))),
			A2(
			$elm$json$Json$Decode$field,
			'Noeud',
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$Noeud,
				A2($elm$json$Json$Decode$field, 'classification', $author$project$Catalogue$Identifiants$classificationIdDecoder),
				A2($elm$json$Json$Decode$field, 'valeur', $elm$json$Json$Decode$string)))
		]));
var $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$porteurDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				function ($) {
					return $.h0;
				},
				$author$project$API$Liens$deLaRessource),
				$elm$json$Json$Decode$succeed(_List_Nil)
			])),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'restrictions',
		$elm$json$Json$Decode$dict(
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
		$elm$core$Dict$empty,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'perimetres',
			$elm$json$Json$Decode$dict($author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$perimetreDuChampDecoder),
			$elm$core$Dict$empty,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'fichesHeritieres',
				$elm$json$Json$Decode$int,
				0,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'articles',
					$elm$json$Json$Decode$dict(
						$elm$json$Json$Decode$list($author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$articleDEtageDecoder)),
					$elm$core$Dict$empty,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'minima',
						$elm$json$Json$Decode$dict($author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$minimaDecoder),
						$elm$core$Dict$empty,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'renseignees',
							$elm$json$Json$Decode$dict($elm$json$Json$Decode$int),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'champs',
								$elm$json$Json$Decode$list($author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$champDecoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'version',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'portee',
										$author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$porteeDecoder,
										$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$Porteur)))))))))));
var $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$informationsDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.gF;
			},
			$author$project$API$Liens$trouverGabarit($author$project$API$NavLinksDictionary$categoriesDeLEtape)),
		$author$project$API$Liens$deLaRessource),
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		A2(
			$elm$json$Json$Decode$map,
			function ($) {
				return $.h0;
			},
			$author$project$API$Liens$deLaRessource),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'editeur',
			A2(
				$elm$json$Json$Decode$map,
				function ($) {
					return $.sb;
				},
				$author$project$Components$Shared$EditeurDeSchema$Propositions$decoder),
			_List_Nil,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'categories',
				$elm$json$Json$Decode$list($author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$categorieDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'porteurs',
					$elm$json$Json$Decode$list($author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$porteurDecoder),
					$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$Informations))))));
var $author$project$Components$Produits$StructureCatalogue$Archivage$Update$interrompre = function (model) {
	var archivage = model.tD;
	var lots = archivage.a6;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{
				cd: A2(
					$elm$core$List$filter,
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Components$Produits$StructureCatalogue$Archivage$Update$estUnLot),
					model.cd),
				tD: _Utils_update(
					archivage,
					{
						a6: _Utils_update(
							lots,
							{d8: false, qD: $elm$core$Maybe$Nothing})
					})
			}),
		_List_Nil);
};
var $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$listesPartageesDuCatalogue = $elm$core$List$filter(
	function (liste) {
		return (liste.F$ === 'catalogue') || (liste.F$ === 'catalogue-et-parties-prenantes');
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$homonyme = F2(
	function (nom, model) {
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.Aq;
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (liste) {
						return _Utils_eq(
							$elm$core$String$toLower(liste.Dj),
							$elm$core$String$toLower(
								$elm$core$String$trim(nom)));
					},
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Maybe$map, $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$listesPartageesDuCatalogue, model.BX)))));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$HorsDeLaPortee = $elm$core$Basics$identity;
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$issueDUneInformation = F3(
	function (commande, erreur, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		if (!$author$project$Components$Produits$StructureCatalogue$Informations$Model$estUneCommande(commande)) {
			return _Utils_Tuple2(model, effets);
		} else {
			var rattachement_ = model.pN;
			switch (erreur.$) {
				case 66:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ag: true}),
						_Utils_ap(
							effets,
							$author$project$Components$Produits$StructureCatalogue$Commandes$relireLesInformations(model)));
				case 67:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ag: true}),
						_Utils_ap(
							effets,
							$author$project$Components$Produits$StructureCatalogue$Commandes$relireLesInformations(model)));
				case 74:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ag: true}),
						effets);
				case 30:
					var champ = erreur.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								uQ: $elm$core$Maybe$Just(champ)
							}),
						_Utils_ap(
							effets,
							$author$project$Components$Produits$StructureCatalogue$Informations$Update$lireLaBibliotheque(model)));
				case 31:
					var etage = erreur.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								pN: A2(
									$elm$core$Maybe$withDefault,
									rattachement_,
									A2(
										$elm$core$Maybe$map,
										function (champ) {
											return _Utils_update(
												rattachement_,
												{
													pZ: $elm$core$Maybe$Just(
														{uN: champ, md: etage})
												});
										},
										model.pN.vd))
							}),
						effets);
				case 71:
					return _Utils_Tuple2(
						model,
						_Utils_ap(
							effets,
							$author$project$Components$Produits$StructureCatalogue$Commandes$relireLesInformations(model)));
				default:
					return _Utils_Tuple2(model, effets);
			}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$issueDuRefus = F3(
	function (commande, erreur, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		var _v1 = _Utils_Tuple2(commande, erreur);
		if ((_v1.a.$ === 12) && (_v1.b.$ === 49)) {
			var nom = _v1.a.a;
			var _v2 = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						ed: A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$homonyme, nom, model)
					}),
				effets);
		} else {
			return A3(
				$author$project$Components$Produits$StructureCatalogue$Informations$Update$issueDUneInformation,
				commande,
				erreur,
				_Utils_Tuple2(model, effets));
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Archivage$Model$lancable = function (archivage) {
	var _v0 = archivage.tq;
	if (!_v0.$) {
		var apercu = _v0.a;
		return (!apercu.yi) && ((!archivage.a6.d8) && _Utils_eq(archivage.a6.qD, $elm$core$Maybe$Nothing));
	} else {
		return false;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Archivage$Update$miseEnRoute = function (model) {
	var archivage = model.tD;
	var lots = archivage.a6;
	return _Utils_update(
		model,
		{
			tD: _Utils_update(
				archivage,
				{
					a6: _Utils_update(
						lots,
						{d8: true})
				})
		});
};
var $author$project$Components$Produits$StructureCatalogue$Archivage$Update$lancer = function (model) {
	var _v0 = model.tD.r3;
	if (!_v0.$) {
		var id = _v0.a;
		return $author$project$Components$Produits$StructureCatalogue$Archivage$Model$lancable(model.tD) ? A2(
			$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
			A2(
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$TraiterLArchivage,
				id,
				$author$project$Components$Produits$StructureCatalogue$Archivage$Model$choix(model.tD)),
			$author$project$Components$Produits$StructureCatalogue$Archivage$Update$miseEnRoute(
				_Utils_update(
					model,
					{aL: $elm$core$Maybe$Nothing}))) : _Utils_Tuple2(model, _List_Nil);
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Saisie$saisir = F3(
	function (code, texte, saisie) {
		return _Utils_update(
			saisie,
			{
				ck: saisie.ck || (code === 'en'),
				R: A3($author$project$Components$Shared$LibellesParLangue$Model$ecrire, code, texte, saisie.R)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$libelleDeListeSaisi = F3(
	function (langue, texte, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					ed: $elm$core$Maybe$Nothing,
					am: A3($author$project$Components$Produits$StructureCatalogue$Saisie$saisir, langue, texte, model.am)
				}),
			_List_Nil);
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$libelleSaisi = F3(
	function (langue, texte, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					D: A3($author$project$Components$Produits$StructureCatalogue$Saisie$saisir, langue, texte, model.D)
				}),
			_List_Nil);
	});
var $author$project$Components$Produits$StructureCatalogue$Etats$Update$libelleSaisi = F4(
	function (langue, code, texte, model) {
		return _Utils_Tuple2(
			A3(
				$author$project$Components$Produits$StructureCatalogue$Etats$Update$saisirSurLEtat,
				code,
				A2($author$project$Components$Produits$StructureCatalogue$Saisie$saisir, langue, texte),
				model),
			_List_Nil);
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$libelleSaisi = F3(
	function (langue, texte, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					aM: A3($author$project$Components$Produits$StructureCatalogue$Saisie$saisir, langue, texte, model.aM)
				}),
			_List_Nil);
	});
var $author$project$Components$Produits$StructureCatalogue$Natures$Update$libelleSaisi = F4(
	function (langue, code, texte, model) {
		return _Utils_Tuple2(
			A3(
				$author$project$Components$Produits$StructureCatalogue$Natures$Update$surLaNature,
				code,
				function (nature) {
					return _Utils_update(
						nature,
						{
							hP: A3($author$project$Components$Produits$StructureCatalogue$Saisie$saisir, langue, texte, nature.hP)
						});
				},
				model),
			_List_Nil);
	});
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Update$libelleSaisi = F4(
	function (langue, id, texte, model) {
		return _Utils_Tuple2(
			A3(
				$author$project$Components$Produits$StructureCatalogue$Niveaux$Update$saisirSurLeNiveau,
				id,
				A2($author$project$Components$Produits$StructureCatalogue$Saisie$saisir, langue, texte),
				model),
			_List_Nil);
	});
var $author$project$Components$Produits$StructureCatalogue$Typologies$Update$libelleSaisi = F3(
	function (langue, texte, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					qU: A3($author$project$Components$Produits$StructureCatalogue$Saisie$saisir, langue, texte, model.qU)
				}),
			_List_Nil);
	});
var $author$project$API$NavLinksDictionary$catalogue = 'catalogue';
var $author$project$API$NavLinksDictionary$perimetres = 'perimetres';
var $author$project$API$NavLinksDictionary$structureDuCatalogue = 'structure-du-catalogue';
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$liensDesArticlesRecus = F3(
	function (suivables, gabarits, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					gF: gabarits,
					nt: {
						jB: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$catalogue, suivables),
						h$: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$structureDuCatalogue, suivables)
					},
					nI: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$perimetres, suivables)
				}),
			_List_Nil);
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$AjouterUneValeurALaListe = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Effet$LireLesListes = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$avecLaListe = F2(
	function (liste, changement) {
		return _Utils_update(
			changement,
			{nW: liste});
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$creee = function (evenement) {
	if (evenement.$ === 28) {
		var id = evenement.a;
		return $elm$core$Maybe$Just(id);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$String$lines = _String_lines;
var $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$lignesDeValeurs = function (texte) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (ligne, vues) {
				return A2(
					$elm$core$List$any,
					function (vue) {
						return _Utils_eq(
							$elm$core$String$toLower(vue),
							$elm$core$String$toLower(ligne));
					},
					vues) ? vues : _Utils_ap(
					vues,
					_List_fromArray(
						[ligne]));
			}),
		_List_Nil,
		A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
			A2(
				$elm$core$List$map,
				$elm$core$String$trim,
				$elm$core$String$lines(texte))));
};
var $author$project$API$NavLinksDictionary$listes = 'listes';
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$listeCreee = F3(
	function (commande, rendue, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		var _v1 = _Utils_Tuple2(
			commande,
			$author$project$Components$Shared$Drawer$Model$estOuvert(model.T));
		if ((_v1.a.$ === 12) && _v1.b) {
			var _v2 = $elm$core$List$head(
				A2($elm$core$List$filterMap, $author$project$Components$Produits$StructureCatalogue$Informations$Update$creee, rendue.mk));
			if (!_v2.$) {
				var choisie = _v2.a;
				var suite = _Utils_update(
					model,
					{
						cd: A2(
							$elm$core$List$map,
							$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$AjouterUneValeurALaListe(choisie),
							$author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$lignesDeValeurs(model.df)),
						BO: rendue.nQ
					});
				var relecture = A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Effet$LireLesListes, $elm$core$List$singleton),
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$listes, model.nS));
				var _v3 = model._;
				if (!_v3.$) {
					var edite = _v3.a;
					return _Utils_Tuple2(
						_Utils_update(
							suite,
							{
								_: $elm$core$Maybe$Just(
									A2($author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$avecLaListe, choisie, edite))
							}),
						_Utils_ap(
							effets,
							A2($elm$core$Maybe$withDefault, _List_Nil, relecture)));
				} else {
					return _Utils_Tuple2(
						suite,
						_Utils_ap(
							effets,
							A2($elm$core$Maybe$withDefault, _List_Nil, relecture)));
				}
			} else {
				return _Utils_Tuple2(model, effets);
			}
		} else {
			return _Utils_Tuple2(model, effets);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$listeExistanteChoisie = F2(
	function (liste, model) {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Informations$Update$versLaNouvelleListe,
			$author$project$Components$Shared$Drawer$Update$Fermer,
			function () {
				var _v0 = model._;
				if (!_v0.$) {
					var edite = _v0.a;
					return _Utils_update(
						model,
						{
							_: $elm$core$Maybe$Just(
								A2($author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$avecLaListe, liste, edite))
						});
				} else {
					return model;
				}
			}());
	});
var $author$project$Components$Produits$StructureCatalogue$Archivage$Update$cumul = F2(
	function (avant, lot) {
		return {
			iz: avant.iz + lot.iz,
			vf: _Utils_eq(avant.vf, $elm$core$Maybe$Nothing) ? lot.vf : avant.vf,
			vr: avant.vr + lot.vr,
			Cw: avant.Cw + lot.Cw
		};
	});
var $author$project$Components$Produits$StructureCatalogue$Archivage$Update$lotTraite = F4(
	function (typologie, choixEnvoye, traitement, model) {
		var _continue = (traitement.qD > 0) && ($elm$core$List$isEmpty(traitement.Aw) && (traitement.JN > 0));
		var archivage = model.tD;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					cd: _continue ? _List_fromArray(
						[
							A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$TraiterLArchivage, typologie, choixEnvoye)
						]) : _List_Nil,
					tD: _Utils_update(
						archivage,
						{
							a6: {
								uq: A2($author$project$Components$Produits$StructureCatalogue$Archivage$Update$cumul, archivage.a6.uq, traitement.uq),
								zi: archivage.a6.zi + 1,
								Aw: traitement.Aw,
								d8: _continue,
								qD: $elm$core$Maybe$Just(traitement.qD),
								JN: archivage.a6.JN + traitement.JN
							}
						}),
					l2: $author$project$Components$Produits$StructureCatalogue$Model$SansProcessUid
				}),
			_List_fromArray(
				[$author$project$Components$Produits$StructureCatalogue$Effet$DemanderProcessUid]));
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$MasquerUneInformation = F2(
	function (a, b) {
		return {$: 38, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$masquee = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_Utils_Tuple2(model, _List_Nil),
		A2(
			$elm$core$Maybe$map,
			function (_v0) {
				var portee = _v0.a;
				var lue = _v0.b;
				return A2(
					$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
					A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$MasquerUneInformation, portee, lue.uN.dy),
					_Utils_update(
						model,
						{aL: $elm$core$Maybe$Nothing}));
			},
			$author$project$Components$Produits$StructureCatalogue$Informations$Update$visee(model)));
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$AfficherUneInformation = F2(
	function (a, b) {
		return {$: 39, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$masqueeReaffichee = F3(
	function (portee, cle, model) {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
			A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$AfficherUneInformation, portee, cle),
			_Utils_update(
				model,
				{aL: $elm$core$Maybe$Nothing}));
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$plafondDesEtagesNommes = 6;
var $author$project$I18n$Textes$produitsArbreErreurArchivee = A3($author$project$I18n$Traductions$texte, 'produits.arbre.erreur.archivee', _List_Nil, 'Cette valeur est archivée : elle ne se range plus. L\'écran est mis à jour.');
var $author$project$I18n$Textes$produitsArbreErreurChange = A3($author$project$I18n$Traductions$texte, 'produits.arbre.erreur.change', _List_Nil, 'L\'arbre a changé entre-temps : l\'écran est mis à jour, refaites votre choix.');
var $author$project$I18n$Textes$produitsArbreErreurDejaSousLeParent = A3($author$project$I18n$Traductions$texte, 'produits.arbre.erreur.deja-sous-le-parent', _List_Nil, 'Cette valeur y est déjà rangée. L\'écran est mis à jour.');
var $author$project$I18n$Textes$produitsArbreErreurEtageDerive = A3($author$project$I18n$Traductions$texte, 'produits.arbre.erreur.etage-derive', _List_Nil, 'Les valeurs de cet étage viennent de l\'appartenance des gammes : elles ne se placent pas ici.');
var $author$project$I18n$Textes$produitsArbreErreurGammeHorsDeLaMarque = A3($author$project$I18n$Traductions$texte, 'produits.arbre.erreur.gamme-hors-de-la-marque', _List_Nil, 'Cette gamme n\'appartient pas à cette marque : l\'écran est mis à jour.');
var $author$project$I18n$Textes$produitsArbreErreurSurUnAutreEtage = A3($author$project$I18n$Traductions$texte, 'produits.arbre.erreur.sur-un-autre-etage', _List_Nil, 'Cette valeur est déjà rangée sur un autre étage.');
var $author$project$I18n$Textes$produitsArbreErreurTropDeNoeuds = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.arbre.erreur.trop-de-noeuds',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'maximum',
				$author$project$I18n$Traductions$Sous(p.Cj))
			]),
		'Cette typologie a atteint le maximum de {maximum} places dans son arbre.');
};
var $author$project$I18n$Textes$produitsClassificationsErreurArbrePlusProfondQueLesEtages = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.classifications.erreur.arbre-plus-profond-que-les-etages',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'etages',
				$author$project$I18n$Traductions$Entier(p.yG))
			]),
		'{etages, plural, one {Cette typologie a # étage nommé : la valeur ne se range pas plus bas. La structure vient d\'être relue.} other {Cette typologie a # étages nommés : la valeur ne se range pas plus bas. La structure vient d\'être relue.}}');
};
var $author$project$I18n$Textes$produitsClassificationsErreurArbreTropProfond = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.classifications.erreur.arbre-trop-profond',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'maximum',
				$author$project$I18n$Traductions$Sous(p.Cj))
			]),
		'L\'arbre des valeurs a {maximum} étages au plus : la valeur n\'a pas été placée.');
};
var $author$project$I18n$Textes$produitsClassificationsErreurDeMemeNom = A3($author$project$I18n$Traductions$texte, 'produits.classifications.erreur.de-meme-nom', _List_Nil, 'Une liste porte déjà ce nom.');
var $author$project$I18n$Textes$produitsClassificationsErreurDejaExistante = A3($author$project$I18n$Traductions$texte, 'produits.classifications.erreur.deja-existante', _List_Nil, 'Cette liste existe déjà : la structure vient d\'être relue.');
var $author$project$I18n$Textes$produitsClassificationsErreurIntrouvable = A3($author$project$I18n$Traductions$texte, 'produits.classifications.erreur.introuvable', _List_Nil, 'Cette liste n\'existe plus : la structure vient d\'être relue.');
var $author$project$I18n$Textes$produitsClassificationsErreurParentArchive = A3($author$project$I18n$Traductions$texte, 'produits.classifications.erreur.parent-archive', _List_Nil, 'Ce parent est archivé : aucune valeur ne s\'y ajoute ni ne s\'y déplace.');
var $author$project$I18n$Textes$produitsClassificationsErreurParentInconnu = A3($author$project$I18n$Traductions$texte, 'produits.classifications.erreur.parent-inconnu', _List_Nil, 'Ce parent n\'existe plus : la structure vient d\'être relue.');
var $author$project$I18n$Textes$produitsClassificationsErreurRangInvalide = A3($author$project$I18n$Traductions$texte, 'produits.classifications.erreur.rang-invalide', _List_Nil, 'Cette place n\'existe plus : la structure vient d\'être relue.');
var $author$project$I18n$Textes$produitsClassificationsErreurSousElleMeme = A3($author$project$I18n$Traductions$texte, 'produits.classifications.erreur.sous-elle-meme', _List_Nil, 'Une valeur ne se place ni sous elle-même ni sous l\'une de ses sous-valeurs.');
var $author$project$I18n$Textes$produitsClassificationsErreurTropDeClassifications = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.classifications.erreur.trop-de-classifications',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'maximum',
				$author$project$I18n$Traductions$Sous(p.Cj))
			]),
		'Vous avez déjà {maximum} listes, le maximum : la liste n\'a pas été ajoutée.');
};
var $author$project$I18n$Textes$produitsClassificationsErreurTropDeValeurs = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.classifications.erreur.trop-de-valeurs',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'maximum',
				$author$project$I18n$Traductions$Sous(p.Cj))
			]),
		'Cette liste a déjà {maximum} valeurs, le maximum : la valeur n\'a pas été ajoutée.');
};
var $author$project$I18n$Textes$produitsClassificationsErreurValeurDejaExistante = A3($author$project$I18n$Traductions$texte, 'produits.classifications.erreur.valeur-deja-existante', _List_Nil, 'Cette valeur existe déjà dans cette liste : la structure vient d\'être relue.');
var $author$project$I18n$Textes$produitsClassificationsErreurValeurInconnue = A3($author$project$I18n$Traductions$texte, 'produits.classifications.erreur.valeur-inconnue', _List_Nil, 'Cette valeur n\'existe plus : la structure vient d\'être relue.');
var $author$project$I18n$Textes$produitsEtagesApercuPerime = A3($author$project$I18n$Traductions$texte, 'produits.etages.apercu.perime', _List_Nil, 'L\'arbre a changé depuis l\'aperçu : voici le nouvel aperçu, à confirmer.');
var $author$project$I18n$Textes$produitsEtagesErreurCategorie = A3($author$project$I18n$Traductions$texte, 'produits.etages.erreur.categorie', _List_Nil, 'La catégorie est le dernier étage de chaque typologie : elle ne se renomme, ne se déplace ni ne se retire ici.');
var $author$project$I18n$Textes$produitsEtagesErreurCategoriesRangees = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.etages.erreur.categories-rangees',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'categories',
				$author$project$I18n$Traductions$Entier(p.dt))
			]),
		'{categories, plural, one {# catégorie est rangée dans cette typologie : ses étages nommés ne s\'ajoutent ni ne se retirent plus. La structure vient d\'être relue.} other {# catégories sont rangées dans cette typologie : ses étages nommés ne s\'ajoutent ni ne se retirent plus. La structure vient d\'être relue.}}');
};
var $author$project$I18n$Textes$produitsEtagesErreurDeLaStructure = A3($author$project$I18n$Traductions$texte, 'produits.etages.erreur.de-la-structure', _List_Nil, 'Cet étage porte le nom d\'un niveau du catalogue : il ne se renomme pas ici.');
var $author$project$I18n$Textes$produitsEtagesErreurDejaDesigne = A3($author$project$I18n$Traductions$texte, 'produits.etages.erreur.deja-designe', _List_Nil, 'Cet étage est déjà dans la liste de cette typologie.');
var $author$project$I18n$Textes$produitsEtagesErreurDejaExistant = A3($author$project$I18n$Traductions$texte, 'produits.etages.erreur.deja-existant', _List_Nil, 'Cet étage existe déjà dans cette typologie : la liste vient d\'être relue.');
var $author$project$I18n$Textes$produitsEtagesErreurHorsOrdre = A3($author$project$I18n$Traductions$texte, 'produits.etages.erreur.hors-ordre', _List_Nil, 'Cet ordre n\'est pas possible : les étages repris du catalogue gardent leur ordre, la marque avant la gamme.');
var $author$project$I18n$Textes$produitsEtagesErreurListeChangee = A3($author$project$I18n$Traductions$texte, 'produits.etages.erreur.liste-changee', _List_Nil, 'La liste des étages a changé entre-temps : elle vient d\'être relue.');
var $author$project$I18n$Textes$produitsEtagesErreurNomDejaPris = A3($author$project$I18n$Traductions$texte, 'produits.etages.erreur.nom-deja-pris', _List_Nil, 'Un étage de cette typologie porte déjà ce nom.');
var $author$project$I18n$Textes$produitsEtagesErreurPasUneTypologie = A3($author$project$I18n$Traductions$texte, 'produits.etages.erreur.pas-une-typologie', _List_Nil, 'Seule une typologie a des étages.');
var $author$project$I18n$Textes$produitsEtagesErreurProduitDernier = A3($author$project$I18n$Traductions$texte, 'produits.etages.erreur.produit-dernier', _List_Nil, 'L\'étage Produit est toujours le dernier, juste sous la catégorie.');
var $author$project$I18n$Textes$produitsEtagesErreurProduitOccupe = A3($author$project$I18n$Traductions$texte, 'produits.etages.erreur.produit-occupe', _List_Nil, 'Des produits sont rangés sous cet étage : archivez-les d\'abord, puis retirez l\'étage.');
var $author$project$I18n$Textes$produitsEtagesErreurTropDEtages = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.etages.erreur.trop-d-etages',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'maximum',
				$author$project$I18n$Traductions$Sous(p.Cj))
			]),
		'Cette typologie a déjà {maximum} étages, catégorie comprise : l\'étage n\'a pas été ajouté.');
};
var $author$project$I18n$Textes$produitsEtagesErreurTropDEtagesNommes = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.etages.erreur.trop-d-etages-nommes',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'maximum',
				$author$project$I18n$Traductions$Sous(p.Cj))
			]),
		'Cette typologie a déjà {maximum} étages que vous avez nommés : l\'étage n\'a pas été ajouté.');
};
var $author$project$I18n$Textes$produitsEtagesErreurVerrouilles = A3($author$project$I18n$Traductions$texte, 'produits.etages.erreur.verrouilles', _List_Nil, 'Des valeurs sont déjà rangées dans cette typologie : ses étages nommés se renomment encore, mais ne s\'ajoutent, ne se déplacent ni ne se retirent plus.');
var $author$project$I18n$Textes$produitsInformationsArticlesErreurArticleIndisponible = A3($author$project$I18n$Traductions$texte, 'produits.informations.articles.erreur-article-indisponible', _List_Nil, 'Un des articles choisis n\'est plus disponible : rien n\'a été enregistré. Rouvrez le choix et sélectionnez un article en service.');
var $author$project$I18n$Textes$produitsInformationsArticlesErreurChampNonLien = A3($author$project$I18n$Traductions$texte, 'produits.informations.articles.erreur-champ-non-lien', _List_Nil, 'Cette information n\'est pas un lien vers des articles : rien n\'a été enregistré. Rouvrez l\'étage pour relire ses informations.');
var $author$project$I18n$Textes$produitsInformationsArticlesErreurTropDArticles = A3($author$project$I18n$Traductions$texte, 'produits.informations.articles.erreur-trop-d-articles', _List_Nil, 'Cette information n\'accepte pas autant d\'articles : rien n\'a été enregistré. Gardez-en moins, ou un seul.');
var $author$project$I18n$Textes$produitsInformationsErreurChampDejaDansLaBibliotheque = A3($author$project$I18n$Traductions$texte, 'produits.informations.erreur.champ-deja-dans-la-bibliotheque', _List_Nil, 'Ce nom est déjà celui d\'un champ de la bibliothèque, qui n\'a pas la même forme : rien n\'a été enregistré. Choisissez un autre nom.');
var $author$project$I18n$Textes$produitsInformationsErreurEtageHorsDeLaPortee = A3($author$project$I18n$Traductions$texte, 'produits.informations.erreur.etage-hors-de-la-portee', _List_Nil, 'Ce champ n\'est pas admis à ce niveau : rien n\'a été enregistré.');
var $author$project$I18n$Textes$produitsInformationsErreurNomDejaPose = A3($author$project$I18n$Traductions$texte, 'produits.informations.erreur.nom-deja-pose', _List_Nil, 'Ce nom est déjà posé à un étage au-dessus ou à côté de celui-ci : rien n\'a été enregistré. Choisissez un autre nom.');
var $author$project$I18n$Textes$produitsParcoursInformationsErreurChampInconnu = A3($author$project$I18n$Traductions$texte, 'produits.parcours.informations.erreur.champ-inconnu', _List_Nil, 'Cette information n\'existe plus : la page vient d\'être relue.');
var $author$project$I18n$Textes$produitsParcoursInformationsErreurDejaAuMemeEndroit = A3($author$project$I18n$Traductions$texte, 'produits.parcours.informations.erreur.deja-au-meme-endroit', _List_Nil, 'L\'information est déjà à cet étage : choisissez-en un autre.');
var $author$project$I18n$Textes$produitsParcoursInformationsErreurDejaPosee = A3($author$project$I18n$Traductions$texte, 'produits.parcours.informations.erreur.deja-posee', _List_Nil, 'Une information de même nom ou de même clé existe déjà à l\'arrivée : renommez l\'une des deux, ou choisissez un autre étage.');
var $author$project$I18n$Textes$produitsParcoursInformationsErreurLienAvecArticles = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.parcours.informations.erreur.lien-avec-articles',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'champ',
				$author$project$I18n$Traductions$Sous(p.uN)),
				_Utils_Tuple2(
				'articles',
				$author$project$I18n$Traductions$Sous(p.tP))
			]),
		'« {champ} » est un lien vers des articles ({articles}) : il ne se déplace pas tant qu\'il en porte. Retirez d\'abord les articles liés (« Modifier » sur l\'étage), puis déplacez-le.');
};
var $author$project$I18n$Textes$produitsParcoursInformationsErreurRenseignee = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.parcours.informations.erreur.renseignee',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'references',
				$author$project$I18n$Traductions$Entier(p.hD)),
				_Utils_Tuple2(
				'exemple',
				$author$project$I18n$Traductions$Sous(p.yY))
			]),
		'Cette information est renseignée sur {references, plural, one {# référence} other {# références}} (par exemple {exemple}) : elle ne se supprime pas. Masquez-la à la place.');
};
var $author$project$I18n$Textes$produitsParcoursInformationsErreurRenseigneeSansExemple = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.parcours.informations.erreur.renseignee.sans-exemple',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'references',
				$author$project$I18n$Traductions$Entier(p.hD))
			]),
		'Cette information est renseignée sur {references, plural, one {# référence} other {# références}} : elle ne se supprime pas. Masquez-la à la place.');
};
var $author$project$I18n$Textes$produitsParcoursInformationsErreurSchemaInvalide = A3($author$project$I18n$Traductions$texte, 'produits.parcours.informations.erreur.schema-invalide', _List_Nil, 'Cette information est utilisée par un calcul ou une condition. Supprimez ou modifiez d\'abord ce calcul, ou masquez l\'information.');
var $author$project$I18n$Textes$produitsParcoursInformationsErreurTypeNonPropose = A3($author$project$I18n$Traductions$texte, 'produits.parcours.informations.erreur.type-non-propose', _List_Nil, 'Ce type d\'information n\'est pas proposé ici.');
var $author$project$I18n$Textes$produitsParcoursInformationsErreurVersLeHaut = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.parcours.informations.erreur.vers-le-haut',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'references',
				$author$project$I18n$Traductions$Entier(p.hD)),
				_Utils_Tuple2(
				'exemple',
				$author$project$I18n$Traductions$Sous(p.yY))
			]),
		'Cette information est renseignée sur {references, plural, one {# référence} other {# références}} (par exemple {exemple}) : elle ne se déplace que vers un étage plus haut. Choisissez-en un, ou masquez-la.');
};
var $author$project$I18n$Textes$produitsParcoursInformationsErreurVersLeHautSansExemple = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.parcours.informations.erreur.vers-le-haut.sans-exemple',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'references',
				$author$project$I18n$Traductions$Entier(p.hD))
			]),
		'Cette information est renseignée sur {references, plural, one {# référence} other {# références}} : elle ne se déplace que vers un étage plus haut. Choisissez-en un, ou masquez-la.');
};
var $author$project$I18n$Textes$produitsParcoursInformationsNouvelleListeNomPris = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.parcours.informations.nouvelle-liste.nom-pris',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nom',
				$author$project$I18n$Traductions$Sous(p.Dj))
			]),
		'La liste « {nom} » existe déjà.');
};
var $author$project$I18n$Textes$produitsReferenceLiensRefusPerimetreIndisponible = A3($author$project$I18n$Traductions$texte, 'produits.reference.liens.refus-perimetre-indisponible', _List_Nil, 'Ce périmètre n\'est plus disponible (supprimé ou archivé). Choisissez-en un autre. Rien n\'a été enregistré.');
var $author$project$I18n$Textes$produitsReferenceLiensRefusUnSeulArticle = A3($author$project$I18n$Traductions$texte, 'produits.reference.liens.refus-un-seul-article', _List_Nil, 'Ce champ n\'accepte qu\'un seul article. Un périmètre contient plusieurs articles. Choisissez un article, ou demandez à un administrateur de passer le champ à « plusieurs articles ». Rien n\'a été enregistré.');
var $author$project$I18n$Textes$produitsStructureErreurArchetypeNonRepetable = A3($author$project$I18n$Traductions$texte, 'produits.structure.erreur.archetype-non-repetable', _List_Nil, 'Ce type d\'étage n\'admet qu\'un seul étage : l\'étage n\'a pas été ajouté.');
var $author$project$I18n$Textes$produitsStructureErreurCommandeEnDouble = A3($author$project$I18n$Traductions$texte, 'produits.structure.erreur.commande-en-double', _List_Nil, 'Cette modification n\'a pas été appliquée : recommencez.');
var $author$project$I18n$Textes$produitsStructureErreurConcurrente = A3($author$project$I18n$Traductions$texte, 'produits.structure.erreur.concurrente', _List_Nil, 'La structure a été modifiée entre-temps : elle vient d\'être relue. Recommencez si nécessaire.');
var $author$project$I18n$Textes$produitsStructureErreurEtatEnDouble = A3($author$project$I18n$Traductions$texte, 'produits.structure.erreur.etat-en-double', _List_Nil, 'Un même état figure deux fois dans la liste : elle n\'a pas été enregistrée.');
var $author$project$I18n$Textes$produitsStructureErreurEtatInconnu = A3($author$project$I18n$Traductions$texte, 'produits.structure.erreur.etat-inconnu', _List_Nil, 'Un état de la liste n\'est pas connu du catalogue : elle n\'a pas été enregistrée.');
var $author$project$I18n$Textes$produitsStructureErreurEtatPorte = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.structure.erreur.etat-porte',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'references',
				$author$project$I18n$Traductions$Entier(p.hD))
			]),
		'{references, plural, one {# référence porte cet état : il ne se retire pas de la liste. La liste n\'a pas été enregistrée.} other {# références portent cet état : il ne se retire pas de la liste. La liste n\'a pas été enregistrée.}}');
};
var $author$project$I18n$Textes$produitsStructureErreurLibelleDEtatRequis = A3($author$project$I18n$Traductions$texte, 'produits.structure.erreur.libelle-d-etat-requis', _List_Nil, 'Un état ajouté doit porter un libellé français : la liste n\'a pas été enregistrée.');
var $author$project$I18n$Textes$produitsStructureErreurLibelleDeNatureDejaPris = A3($author$project$I18n$Traductions$texte, 'produits.structure.erreur.libelle-de-nature-deja-pris', _List_Nil, 'Une autre nature porte déjà ce nom : il n\'a pas été enregistré.');
var $author$project$I18n$Textes$produitsStructureErreurListeDEtatsVide = A3($author$project$I18n$Traductions$texte, 'produits.structure.erreur.liste-d-etats-vide', _List_Nil, 'La liste des états ne peut pas être vide.');
var $author$project$I18n$Textes$produitsStructureErreurListeInconnue = A3($author$project$I18n$Traductions$texte, 'produits.structure.erreur.liste-inconnue', _List_Nil, 'Cette liste de choix n\'existe pas : l\'information n\'a pas été enregistrée. Choisissez une liste de la section « Listes de choix ».');
var $author$project$I18n$Textes$produitsStructureErreurNiveauInconnu = A3($author$project$I18n$Traductions$texte, 'produits.structure.erreur.niveau-inconnu', _List_Nil, 'Cet étage n\'existe plus : la structure vient d\'être relue.');
var $author$project$I18n$Textes$produitsStructureErreurNiveauParDefautNonRetirable = A3($author$project$I18n$Traductions$texte, 'produits.structure.erreur.niveau-par-defaut-non-retirable', _List_Nil, 'Un étage par défaut ne se retire pas : désactivez-le.');
var $author$project$I18n$Textes$produitsStructureErreurNiveauSansLibelleParDefaut = A3($author$project$I18n$Traductions$texte, 'produits.structure.erreur.niveau-sans-libelle-par-defaut', _List_Nil, 'Cet étage n\'a pas de libellé par défaut : saisissez son libellé.');
var $author$project$I18n$Textes$produitsStructureErreurNiveauToujoursUtilise = A3($author$project$I18n$Traductions$texte, 'produits.structure.erreur.niveau-toujours-utilise', _List_Nil, 'Cet étage est toujours utilisé : il ne se désactive pas.');
var $author$project$I18n$Textes$produitsStructureErreurNiveauUtiliseDesactiver = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.structure.erreur.niveau-utilise.desactiver',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nom',
				$author$project$I18n$Traductions$Sous(p.Dj)),
				_Utils_Tuple2(
				'elements',
				$author$project$I18n$Traductions$Sous(p.aV))
			]),
		'« {nom} » ne peut pas être désactivé : cet étage porte {elements}');
};
var $author$project$I18n$Textes$produitsStructureErreurNiveauUtiliseRetirer = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.structure.erreur.niveau-utilise.retirer',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nom',
				$author$project$I18n$Traductions$Sous(p.Dj)),
				_Utils_Tuple2(
				'elements',
				$author$project$I18n$Traductions$Sous(p.aV))
			]),
		'« {nom} » ne peut pas être retiré : cet étage porte {elements}');
};
var $author$project$I18n$Textes$produitsStructureErreurOrdreDesNaturesInvalide = A3($author$project$I18n$Traductions$texte, 'produits.structure.erreur.ordre-des-natures-invalide', _List_Nil, 'La liste des natures a changé entre-temps : l\'ordre n\'a pas été enregistré.');
var $author$project$I18n$Textes$produitsStructureErreurOrdreInvalide = A3($author$project$I18n$Traductions$texte, 'produits.structure.erreur.ordre-invalide', _List_Nil, 'Cet ordre n\'est pas possible : il ne suit pas la hiérarchie du catalogue.');
var $author$project$I18n$Textes$produitsStructureErreurServiceNonDeplacable = A3($author$project$I18n$Traductions$texte, 'produits.structure.erreur.service-non-deplacable', _List_Nil, '« Service » reste la dernière nature : elle ne se déplace pas.');
var $author$project$I18n$Textes$produitsStructureErreurTropDeNiveaux = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.structure.erreur.trop-de-niveaux',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'maximum',
				$author$project$I18n$Traductions$Sous(p.Cj))
			]),
		'La structure a déjà {maximum} étages, le maximum. Retirez-en un pour en ajouter un autre.');
};
var $author$project$I18n$Textes$produitsStructureVerrouillageErreurDepart = A3($author$project$I18n$Traductions$texte, 'produits.structure.verrouillage.erreur-depart', _List_Nil, 'Le premier état est celui d\'une référence créée : il ne peut pas être le seuil du verrouillage. Choisissez un état suivant, ou « Jamais ».');
var $author$project$I18n$Textes$produitsStructureVerrouillageErreurVerrouillant = A3($author$project$I18n$Traductions$texte, 'produits.structure.verrouillage.erreur-verrouillant', _List_Nil, 'Cet état est le seuil du verrouillage de la fiche : choisissez d\'abord un autre seuil, ou « Jamais », avant de le retirer.');
var $author$project$I18n$Textes$produitsTypologiesErreurDeMemeNom = A3($author$project$I18n$Traductions$texte, 'produits.typologies.erreur.de-meme-nom', _List_Nil, 'Une typologie porte déjà ce nom.');
var $author$project$I18n$Textes$produitsTypologiesErreurDejaExistante = A3($author$project$I18n$Traductions$texte, 'produits.typologies.erreur.deja-existante', _List_Nil, 'Cette typologie existe déjà : la structure vient d\'être relue.');
var $author$project$I18n$Textes$produitsTypologiesErreurGrammaireAnglaise = A3($author$project$I18n$Traductions$texte, 'produits.typologies.erreur.grammaire-anglaise', _List_Nil, 'Les formes anglaises exigent un libellé anglais : renseignez-le, ou videz les formes anglaises, puis enregistrez de nouveau.');
var $author$project$I18n$Textes$produitsTypologiesErreurIntrouvable = A3($author$project$I18n$Traductions$texte, 'produits.typologies.erreur.introuvable', _List_Nil, 'Cette typologie n\'existe plus : la structure vient d\'être relue.');
var $author$project$I18n$Textes$produitsTypologiesErreurNonVide = A3($author$project$I18n$Traductions$texte, 'produits.typologies.erreur.non-vide', _List_Nil, 'Cette typologie porte encore des valeurs ou des catégories rangées : elle ne se retire que vide. La structure vient d\'être relue.');
var $author$project$I18n$Textes$produitsTypologiesErreurTropDeClassifications = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.typologies.erreur.trop-de-classifications',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'maximum',
				$author$project$I18n$Traductions$Sous(p.Cj))
			]),
		'Vous avez déjà {maximum} classifications, typologies comprises : la typologie n\'a pas été ajoutée.');
};
var $author$project$I18n$Textes$produitsParcoursInformationsErreurUtiliseeParUnCalcul = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.parcours.informations.erreur.utilisee-par-un-calcul',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nom',
				$author$project$I18n$Traductions$Sous(p.Dj)),
				_Utils_Tuple2(
				'calculs',
				$author$project$I18n$Traductions$Sous(p.uD))
			]),
		'« {nom} » est utilisée par le calcul de {calculs}. Supprimez ou modifiez d\'abord ce calcul, ou masquez l\'information.');
};
var $author$project$I18n$Textes$produitsParcoursInformationsErreurUtiliseeParUnCalculEtUneCondition = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.parcours.informations.erreur.utilisee-par-un-calcul-et-une-condition',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nom',
				$author$project$I18n$Traductions$Sous(p.Dj)),
				_Utils_Tuple2(
				'calculs',
				$author$project$I18n$Traductions$Sous(p.uD)),
				_Utils_Tuple2(
				'conditions',
				$author$project$I18n$Traductions$Sous(p.j5))
			]),
		'« {nom} » est utilisée par le calcul de {calculs} et par la condition de {conditions}. Supprimez ou modifiez d\'abord ce calcul et cette condition, ou masquez l\'information.');
};
var $author$project$I18n$Textes$produitsParcoursInformationsErreurUtiliseeParUneCondition = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.parcours.informations.erreur.utilisee-par-une-condition',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nom',
				$author$project$I18n$Traductions$Sous(p.Dj)),
				_Utils_Tuple2(
				'conditions',
				$author$project$I18n$Traductions$Sous(p.j5))
			]),
		'« {nom} » est utilisée par la condition de {conditions}. Supprimez ou modifiez d\'abord cette condition, ou masquez l\'information.');
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$texteDuCalcul = F2(
	function (nom, utilisations) {
		var de = function (condition) {
			return A2(
				$elm$core$String$join,
				', ',
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Bl;
						},
						function (libelle) {
							return '« ' + (libelle + ' »');
						}),
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.mc;
							},
							$elm$core$Basics$eq(condition)),
						utilisations)));
		};
		var _v0 = _Utils_Tuple2(
			de(false),
			de(true));
		if (_v0.b === '') {
			var calculs = _v0.a;
			return $author$project$I18n$Textes$produitsParcoursInformationsErreurUtiliseeParUnCalcul(
				{
					uD: $author$project$I18n$Traductions$tel(calculs),
					Dj: $author$project$I18n$Traductions$tel(nom)
				});
		} else {
			if (_v0.a === '') {
				var conditions = _v0.b;
				return $author$project$I18n$Textes$produitsParcoursInformationsErreurUtiliseeParUneCondition(
					{
						j5: $author$project$I18n$Traductions$tel(conditions),
						Dj: $author$project$I18n$Traductions$tel(nom)
					});
			} else {
				var calculs = _v0.a;
				var conditions = _v0.b;
				return $author$project$I18n$Textes$produitsParcoursInformationsErreurUtiliseeParUnCalculEtUneCondition(
					{
						uD: $author$project$I18n$Traductions$tel(calculs),
						j5: $author$project$I18n$Traductions$tel(conditions),
						Dj: $author$project$I18n$Traductions$tel(nom)
					});
			}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$message = F3(
	function (contexte, reponse, refus) {
		var plafond = function (maximum) {
			return {
				Cj: $author$project$I18n$Traductions$tel(
					$elm$core$String$fromInt(maximum))
			};
		};
		var dire = function (texte) {
			return {Jx: texte, b9: refus.b9};
		};
		var _v0 = $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$duRefus(reponse);
		switch (_v0.$) {
			case 0:
				var utilise = _v0.a;
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Components$Shared$Messages$Model$duRefus(refus),
					A2(
						$elm$core$Maybe$map,
						function (niveau) {
							return {
								Jx: (contexte.eW ? $author$project$I18n$Textes$produitsStructureErreurNiveauUtiliseRetirer : $author$project$I18n$Textes$produitsStructureErreurNiveauUtiliseDesactiver)(
									{
										aV: niveau.aV(utilise.aV),
										Dj: niveau.Dj
									}),
								b9: refus.b9
							};
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.Aq;
									},
									$elm$core$Basics$eq(utilise.os)),
								contexte.C9))));
			case 6:
				return {Jx: $author$project$I18n$Textes$produitsStructureErreurOrdreInvalide, b9: refus.b9};
			case 18:
				var maximum = _v0.a;
				return dire(
					$author$project$I18n$Textes$produitsStructureErreurTropDeNiveaux(
						plafond(maximum)));
			case 1:
				return dire($author$project$I18n$Textes$produitsStructureErreurNiveauToujoursUtilise);
			case 2:
				return dire($author$project$I18n$Textes$produitsStructureErreurNiveauParDefautNonRetirable);
			case 4:
				return dire($author$project$I18n$Textes$produitsStructureErreurNiveauInconnu);
			case 5:
				return dire($author$project$I18n$Textes$produitsStructureErreurNiveauSansLibelleParDefaut);
			case 76:
				return dire($author$project$I18n$Textes$produitsStructureErreurConcurrente);
			case 7:
				return {Jx: $author$project$I18n$Textes$produitsStructureErreurListeDEtatsVide, b9: refus.b9};
			case 8:
				return {Jx: $author$project$I18n$Textes$produitsStructureErreurEtatEnDouble, b9: refus.b9};
			case 9:
				return {Jx: $author$project$I18n$Textes$produitsStructureErreurLibelleDEtatRequis, b9: refus.b9};
			case 10:
				return dire($author$project$I18n$Textes$produitsStructureErreurEtatInconnu);
			case 11:
				return dire($author$project$I18n$Textes$produitsStructureVerrouillageErreurDepart);
			case 12:
				return dire($author$project$I18n$Textes$produitsStructureVerrouillageErreurVerrouillant);
			case 13:
				var references = _v0.a;
				return dire(
					$author$project$I18n$Textes$produitsStructureErreurEtatPorte(
						{hD: references}));
			case 14:
				return dire($author$project$I18n$Textes$produitsStructureErreurLibelleDeNatureDejaPris);
			case 15:
				return dire($author$project$I18n$Textes$produitsStructureErreurOrdreDesNaturesInvalide);
			case 16:
				return dire($author$project$I18n$Textes$produitsStructureErreurServiceNonDeplacable);
			case 17:
				return dire($author$project$I18n$Textes$produitsStructureErreurArchetypeNonRepetable);
			case 48:
				return dire($author$project$I18n$Textes$produitsStructureErreurListeInconnue);
			case 49:
				return {
					Jx: $author$project$I18n$Textes$produitsParcoursInformationsNouvelleListeNomPris(
						{
							Dj: $author$project$I18n$Traductions$tel(contexte.oz)
						}),
					b9: $elm$core$Maybe$Nothing
				};
			case 19:
				return dire(
					contexte.da ? $author$project$I18n$Textes$produitsTypologiesErreurDeMemeNom : $author$project$I18n$Textes$produitsClassificationsErreurDeMemeNom);
			case 20:
				var maximum = _v0.a;
				return dire(
					(contexte.da ? $author$project$I18n$Textes$produitsTypologiesErreurTropDeClassifications : $author$project$I18n$Textes$produitsClassificationsErreurTropDeClassifications)(
						plafond(maximum)));
			case 21:
				var maximum = _v0.a;
				return dire(
					$author$project$I18n$Textes$produitsClassificationsErreurTropDeValeurs(
						plafond(maximum)));
			case 22:
				var maximum = _v0.a;
				return dire(
					$author$project$I18n$Textes$produitsClassificationsErreurArbreTropProfond(
						plafond(maximum)));
			case 23:
				return dire($author$project$I18n$Textes$produitsClassificationsErreurParentArchive);
			case 24:
				return dire($author$project$I18n$Textes$produitsClassificationsErreurValeurInconnue);
			case 25:
				return dire($author$project$I18n$Textes$produitsClassificationsErreurParentInconnu);
			case 26:
				return dire($author$project$I18n$Textes$produitsClassificationsErreurSousElleMeme);
			case 27:
				return dire($author$project$I18n$Textes$produitsClassificationsErreurRangInvalide);
			case 75:
				return contexte.da ? dire($author$project$I18n$Textes$produitsTypologiesErreurIntrouvable) : (contexte.ru ? dire($author$project$I18n$Textes$produitsClassificationsErreurIntrouvable) : $author$project$Components$Shared$Messages$Model$duRefus(refus));
			case 28:
				var maximum = _v0.a;
				return dire(
					(_Utils_eq(maximum, $author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$plafondDesEtagesNommes) ? $author$project$I18n$Textes$produitsEtagesErreurTropDEtagesNommes : $author$project$I18n$Textes$produitsEtagesErreurTropDEtages)(
						plafond(maximum)));
			case 29:
				return dire($author$project$I18n$Textes$produitsEtagesErreurNomDejaPris);
			case 30:
				return dire($author$project$I18n$Textes$produitsInformationsErreurChampDejaDansLaBibliotheque);
			case 31:
				return dire($author$project$I18n$Textes$produitsInformationsErreurEtageHorsDeLaPortee);
			case 32:
				return dire($author$project$I18n$Textes$produitsInformationsErreurNomDejaPose);
			case 33:
				return dire($author$project$I18n$Textes$produitsEtagesErreurVerrouilles);
			case 34:
				return dire($author$project$I18n$Textes$produitsEtagesErreurCategorie);
			case 35:
				return dire($author$project$I18n$Textes$produitsInformationsArticlesErreurChampNonLien);
			case 36:
				return dire($author$project$I18n$Textes$produitsInformationsArticlesErreurTropDArticles);
			case 37:
				return dire($author$project$I18n$Textes$produitsInformationsArticlesErreurArticleIndisponible);
			case 38:
				return dire($author$project$I18n$Textes$produitsEtagesErreurDeLaStructure);
			case 39:
				return dire($author$project$I18n$Textes$produitsEtagesErreurDejaDesigne);
			case 40:
				return dire($author$project$I18n$Textes$produitsEtagesErreurDejaExistant);
			case 41:
				return dire($author$project$I18n$Textes$produitsEtagesErreurHorsOrdre);
			case 42:
				return dire($author$project$I18n$Textes$produitsEtagesErreurProduitDernier);
			case 43:
				return dire($author$project$I18n$Textes$produitsEtagesErreurProduitOccupe);
			case 44:
				return dire($author$project$I18n$Textes$produitsEtagesErreurListeChangee);
			case 45:
				return dire($author$project$I18n$Textes$produitsEtagesErreurListeChangee);
			case 46:
				return dire($author$project$I18n$Textes$produitsEtagesErreurListeChangee);
			case 47:
				return dire($author$project$I18n$Textes$produitsEtagesErreurPasUneTypologie);
			case 50:
				var categories = _v0.a;
				return dire(
					$author$project$I18n$Textes$produitsEtagesErreurCategoriesRangees(
						{dt: categories}));
			case 51:
				return dire($author$project$I18n$Textes$produitsTypologiesErreurNonVide);
			case 52:
				return dire($author$project$I18n$Textes$produitsClassificationsErreurValeurDejaExistante);
			case 53:
				var etages = _v0.a;
				return dire(
					$author$project$I18n$Textes$produitsClassificationsErreurArbrePlusProfondQueLesEtages(
						{yG: etages}));
			case 54:
				return dire(
					contexte.da ? $author$project$I18n$Textes$produitsTypologiesErreurDejaExistante : $author$project$I18n$Textes$produitsClassificationsErreurDejaExistante);
			case 55:
				return dire($author$project$I18n$Textes$produitsArbreErreurChange);
			case 56:
				return dire($author$project$I18n$Textes$produitsEtagesApercuPerime);
			case 57:
				return dire($author$project$I18n$Textes$produitsReferenceLiensRefusUnSeulArticle);
			case 58:
				return dire($author$project$I18n$Textes$produitsReferenceLiensRefusPerimetreIndisponible);
			case 59:
				return dire($author$project$I18n$Textes$produitsArbreErreurArchivee);
			case 60:
				return dire($author$project$I18n$Textes$produitsArbreErreurDejaSousLeParent);
			case 61:
				return dire($author$project$I18n$Textes$produitsArbreErreurSurUnAutreEtage);
			case 62:
				var maximum = _v0.a;
				return dire(
					$author$project$I18n$Textes$produitsArbreErreurTropDeNoeuds(
						plafond(maximum)));
			case 63:
				return dire($author$project$I18n$Textes$produitsArbreErreurGammeHorsDeLaMarque);
			case 64:
				return dire($author$project$I18n$Textes$produitsArbreErreurEtageDerive);
			case 65:
				return dire($author$project$I18n$Textes$produitsTypologiesErreurGrammaireAnglaise);
			case 66:
				var lu = _v0.a;
				return dire(
					function () {
						var _v1 = lu.yY;
						if (!_v1.$) {
							var exemple = _v1.a;
							return $author$project$I18n$Textes$produitsParcoursInformationsErreurRenseignee(
								{
									yY: $author$project$I18n$Traductions$tel(exemple),
									hD: lu.hD
								});
						} else {
							return $author$project$I18n$Textes$produitsParcoursInformationsErreurRenseigneeSansExemple(
								{hD: lu.hD});
						}
					}());
			case 68:
				var lu = _v0.a;
				return dire(
					$author$project$I18n$Textes$produitsParcoursInformationsErreurLienAvecArticles(
						{
							tP: $author$project$I18n$Traductions$tel(
								A2($elm$core$String$join, ', ', lu.tP)),
							uN: $author$project$I18n$Traductions$tel(lu.uN)
						}));
			case 67:
				var lu = _v0.a;
				return dire(
					function () {
						var _v2 = lu.yY;
						if (!_v2.$) {
							var exemple = _v2.a;
							return $author$project$I18n$Textes$produitsParcoursInformationsErreurVersLeHaut(
								{
									yY: $author$project$I18n$Traductions$tel(exemple),
									hD: lu.hD
								});
						} else {
							return $author$project$I18n$Textes$produitsParcoursInformationsErreurVersLeHautSansExemple(
								{hD: lu.hD});
						}
					}());
			case 69:
				return dire($author$project$I18n$Textes$produitsParcoursInformationsErreurDejaAuMemeEndroit);
			case 70:
				return dire($author$project$I18n$Textes$produitsParcoursInformationsErreurDejaPosee);
			case 71:
				return dire($author$project$I18n$Textes$produitsParcoursInformationsErreurChampInconnu);
			case 72:
				return dire($author$project$I18n$Textes$produitsParcoursInformationsErreurSchemaInvalide);
			case 73:
				return dire($author$project$I18n$Textes$produitsParcoursInformationsErreurTypeNonPropose);
			case 74:
				var utilisations = _v0.a;
				return dire(
					A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$texteDuCalcul, contexte.ox, utilisations));
			case 77:
				return dire($author$project$I18n$Textes$produitsStructureErreurCommandeEnDouble);
			case 3:
				return $author$project$Components$Shared$Messages$Model$duRefus(refus);
			default:
				return A2(
					$elm$core$List$member,
					reponse.ri,
					_List_fromArray(
						[409, 422])) ? dire($author$project$I18n$Textes$erreurApiRequeteRefusee) : $author$project$Components$Shared$Messages$Model$duRefus(refus);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$DefinirLesMinimaDUnChampHerite = F3(
	function (a, b, c) {
		return {$: 43, a: a, b: b, c: c};
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$minimaVoulus = function (saisie) {
	var dimension = function (texte) {
		var _v0 = $elm$core$String$trim(texte);
		if (_v0 === '') {
			return $elm$core$Maybe$Just($elm$core$Maybe$Nothing);
		} else {
			var nette = _v0;
			return A2(
				$elm$core$Maybe$andThen,
				function (n) {
					return (n > 0) ? $elm$core$Maybe$Just(
						$elm$core$Maybe$Just(n)) : $elm$core$Maybe$Nothing;
				},
				$elm$core$String$toInt(nette));
		}
	};
	return A2(
		$elm$core$Maybe$andThen,
		function (m) {
			return A3(
				$elm$core$Maybe$map2,
				F2(
					function (largeur, hauteur) {
						return {Ae: hauteur, Bd: largeur, Jz: m.Jz};
					}),
				dimension(m.Bd),
				dimension(m.Ae));
		},
		saisie.CC);
};
var $author$project$Components$Shared$EditeurDeSchema$Model$CleDejaUtilisee = {$: 0};
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$changer = F2(
	function (rang, transformer) {
		return $elm$core$List$indexedMap(
			F2(
				function (autre, sousChamp) {
					return _Utils_eq(autre, rang) ? transformer(sousChamp) : sousChamp;
				}));
	});
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$DeDate = 2;
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$DeDevise = 5;
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$DeMesure = 4;
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$DeMontant = 3;
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$DeNombre = 1;
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$DeTexte = 0;
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$DeUtilisateur = 8;
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$genreDuCode = function (code) {
	switch (code) {
		case 'nombre':
			return 1;
		case 'date':
			return 2;
		case 'montant':
			return 3;
		case 'mesure':
			return 4;
		case 'devise':
			return 5;
		case 'liste':
			return 6;
		case 'partie-prenante':
			return 7;
		case 'utilisateur':
			return 8;
		default:
			return 0;
	}
};
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$choisirLeType = F2(
	function (code, sousChamp) {
		var _v0 = A2($elm$core$String$split, ':', code);
		_v0$2:
		while (true) {
			if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
				switch (_v0.a) {
					case 'liste':
						var _v1 = _v0.b;
						var liste = _v1.a;
						return _Utils_update(
							sousChamp,
							{M: 6, nW: liste, r$: ''});
					case 'partie-prenante':
						var _v2 = _v0.b;
						var typeVise = _v2.a;
						return _Utils_update(
							sousChamp,
							{M: 7, nW: '', r$: typeVise});
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return _Utils_update(
			sousChamp,
			{
				M: $author$project$Components$Shared$EditeurDeSchema$SousChamps$genreDuCode(code),
				nW: '',
				r$: ''
			});
	});
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$echanger = F3(
	function (premier, second, sousChamps) {
		var _v0 = _Utils_Tuple2(
			$elm$core$List$head(
				A2($elm$core$List$drop, premier, sousChamps)),
			$elm$core$List$head(
				A2($elm$core$List$drop, second, sousChamps)));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var un = _v0.a.a;
			var autre = _v0.b.a;
			return ((premier < 0) || (!_Utils_eq(second, premier + 1))) ? sousChamps : _Utils_ap(
				A2($elm$core$List$take, premier, sousChamps),
				_Utils_ap(
					_List_fromArray(
						[autre, un]),
					A2($elm$core$List$drop, second + 1, sousChamps)));
		} else {
			return sousChamps;
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$reglerLOption = F2(
	function (reglage, sousChamp) {
		switch (reglage.$) {
			case 0:
				var unite = reglage.a;
				return _Utils_update(
					sousChamp,
					{sa: unite});
			case 1:
				var decimales = reglage.a;
				return _Utils_update(
					sousChamp,
					{kv: decimales});
			case 2:
				var min = reglage.a;
				return _Utils_update(
					sousChamp,
					{Cx: min});
			case 3:
				var max = reglage.a;
				return _Utils_update(
					sousChamp,
					{Cg: max});
			default:
				var oui = reglage.a;
				return _Utils_update(
					sousChamp,
					{J9: oui});
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$vide = {dy: $elm$core$Maybe$Nothing, kv: '0', M: 0, Bl: '', nW: '', n4: false, Cg: '', Cx: '', he: false, r$: '', J9: false, sa: 'mm'};
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$appliquer = F2(
	function (geste, sousChamps) {
		switch (geste.$) {
			case 0:
				return _Utils_ap(
					sousChamps,
					_List_fromArray(
						[$author$project$Components$Shared$EditeurDeSchema$SousChamps$vide]));
			case 1:
				var rang = geste.a;
				return A2(
					$elm$core$List$map,
					$elm$core$Tuple$second,
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$neq(rang)),
						A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, sousChamps)));
			case 2:
				var rang = geste.a;
				return A3($author$project$Components$Shared$EditeurDeSchema$SousChamps$echanger, rang - 1, rang, sousChamps);
			case 3:
				var rang = geste.a;
				return A3($author$project$Components$Shared$EditeurDeSchema$SousChamps$echanger, rang, rang + 1, sousChamps);
			case 4:
				var rang = geste.a;
				var texte = geste.b;
				return A3(
					$author$project$Components$Shared$EditeurDeSchema$SousChamps$changer,
					rang,
					function (sousChamp) {
						return _Utils_update(
							sousChamp,
							{Bl: texte});
					},
					sousChamps);
			case 5:
				var rang = geste.a;
				var genre = geste.b;
				return A3(
					$author$project$Components$Shared$EditeurDeSchema$SousChamps$changer,
					rang,
					function (sousChamp) {
						return _Utils_update(
							sousChamp,
							{M: genre, nW: '', r$: ''});
					},
					sousChamps);
			case 6:
				var rang = geste.a;
				var liste = geste.b;
				return A3(
					$author$project$Components$Shared$EditeurDeSchema$SousChamps$changer,
					rang,
					function (sousChamp) {
						return _Utils_update(
							sousChamp,
							{nW: liste});
					},
					sousChamps);
			case 8:
				var rang = geste.a;
				var code = geste.b;
				return A3(
					$author$project$Components$Shared$EditeurDeSchema$SousChamps$changer,
					rang,
					function (sousChamp) {
						return A2($author$project$Components$Shared$EditeurDeSchema$SousChamps$choisirLeType, code, sousChamp);
					},
					sousChamps);
			case 7:
				var rang = geste.a;
				var obligatoire = geste.b;
				return A3(
					$author$project$Components$Shared$EditeurDeSchema$SousChamps$changer,
					rang,
					function (sousChamp) {
						return _Utils_update(
							sousChamp,
							{he: obligatoire});
					},
					sousChamps);
			default:
				var rang = geste.a;
				var reglage = geste.b;
				return A3(
					$author$project$Components$Shared$EditeurDeSchema$SousChamps$changer,
					rang,
					$author$project$Components$Shared$EditeurDeSchema$SousChamps$reglerLOption(reglage),
					sousChamps);
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$donneePersonnelleCochable = function (saisie) {
	var _v0 = saisie.lZ;
	if (!_v0.$) {
		var champ = _v0.a;
		return champ.xD;
	} else {
		return true;
	}
};
var $author$project$Components$Shared$EditeurDeSchema$Model$sansAccent = function (lettre) {
	var code = $elm$core$Char$toCode(lettre);
	var entre = F2(
		function (debut, fin) {
			return (_Utils_cmp(code, debut) > -1) && (_Utils_cmp(code, fin) < 1);
		});
	return A2(entre, 224, 229) ? _List_fromArray(
		['a']) : ((code === 230) ? _List_fromArray(
		['a', 'e']) : ((code === 231) ? _List_fromArray(
		['c']) : (A2(entre, 232, 235) ? _List_fromArray(
		['e']) : (A2(entre, 236, 239) ? _List_fromArray(
		['i']) : ((code === 241) ? _List_fromArray(
		['n']) : (A2(entre, 242, 246) ? _List_fromArray(
		['o']) : (A2(entre, 249, 252) ? _List_fromArray(
		['u']) : (((code === 253) || (code === 255)) ? _List_fromArray(
		['y']) : ((code === 339) ? _List_fromArray(
		['o', 'e']) : _List_fromArray(
		[lettre]))))))))));
};
var $author$project$Components$Shared$EditeurDeSchema$Model$enCle = function (saisi) {
	return A2(
		$elm$core$String$left,
		63,
		$elm$core$String$fromList(
			A2(
				$elm$core$List$map,
				function (lettre) {
					return ($elm$core$Char$isLower(lettre) || $elm$core$Char$isDigit(lettre)) ? lettre : '_';
				},
				A2(
					$elm$core$List$concatMap,
					$author$project$Components$Shared$EditeurDeSchema$Model$sansAccent,
					$elm$core$String$toList(
						$elm$core$String$toLower(saisi))))));
};
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$nonRepetable = 'non';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionDonneePersonnelle = 'donnee-personnelle';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionPlusieursChoix = 'plusieurs-choix';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionRepetable = 'repetable';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionDecimales = 'decimales';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionTypeVise = 'type-vise';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionUnite = 'unite';
var $author$project$Components$Shared$EditeurDeSchema$Model$optionsFigees = _List_fromArray(
	[$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionUnite, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionDecimales, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionTypeVise]);
var $author$project$Components$Shared$EditeurDeSchema$Model$oui = 'oui';
var $author$project$Components$Shared$EditeurDeSchema$Model$depuisUneLettre = function (lettres) {
	depuisUneLettre:
	while (true) {
		if (lettres.b) {
			var premiere = lettres.a;
			var reste = lettres.b;
			if ($elm$core$Char$isLower(premiere)) {
				return lettres;
			} else {
				var $temp$lettres = reste;
				lettres = $temp$lettres;
				continue depuisUneLettre;
			}
		} else {
			return _List_Nil;
		}
	}
};
var $author$project$Components$Shared$EditeurDeSchema$Model$proposerCle = function (libelle) {
	return $elm$core$String$fromList(
		$author$project$Components$Shared$EditeurDeSchema$Model$depuisUneLettre(
			$elm$core$String$toList(
				A2(
					$elm$core$String$join,
					'_',
					A2(
						$elm$core$List$filter,
						A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
						A2(
							$elm$core$String$split,
							'_',
							$author$project$Components$Shared$EditeurDeSchema$Model$enCle(libelle)))))));
};
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeGroupe = 'groupe';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeLangue = 'langue';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typePays = 'pays';
var $author$project$Components$Shared$EditeurDeSchema$Model$saisir = F2(
	function (geste, saisie) {
		var nouveauChamp = _Utils_eq(saisie.lZ, $elm$core$Maybe$Nothing);
		var formulaire = saisie.zT;
		var avec = function (nouveau) {
			return _Utils_update(
				saisie,
				{zT: nouveau});
		};
		switch (geste.$) {
			case 0:
				var langue = geste.a;
				var texte = geste.b;
				return avec(
					_Utils_update(
						formulaire,
						{
							dy: (nouveauChamp && ((!formulaire.ct) && _Utils_eq(
								$elm$core$List$head(saisie.Ba),
								$elm$core$Maybe$Just(langue)))) ? $author$project$Components$Shared$EditeurDeSchema$Model$proposerCle(texte) : formulaire.dy,
							R: A3($elm$core$Dict$insert, langue, texte, formulaire.R)
						}));
			case 1:
				var langue = geste.a;
				var texte = geste.b;
				return avec(
					_Utils_update(
						formulaire,
						{
							bq: A3($elm$core$Dict$insert, langue, texte, formulaire.bq)
						}));
			case 2:
				var texte = geste.a;
				return nouveauChamp ? _Utils_update(
					saisie,
					{
						zT: _Utils_update(
							formulaire,
							{
								dy: $author$project$Components$Shared$EditeurDeSchema$Model$enCle(texte),
								ct: true
							}),
						pZ: _Utils_eq(
							saisie.pZ,
							$elm$core$Maybe$Just($author$project$Components$Shared$EditeurDeSchema$Model$CleDejaUtilisee)) ? $elm$core$Maybe$Nothing : saisie.pZ
					}) : saisie;
			case 13:
				var suite = geste.a;
				return nouveauChamp ? avec(
					_Utils_update(
						formulaire,
						{
							IX: A2($author$project$Components$Shared$EditeurDeSchema$SousChamps$appliquer, suite, formulaire.IX)
						})) : saisie;
			case 14:
				var choisi = geste.a;
				return nouveauChamp ? avec(
					_Utils_update(
						formulaire,
						{
							o_: A3(
								$elm$core$Dict$insert,
								$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionRepetable,
								choisi.HI ? 'oui' : $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$nonRepetable,
								formulaire.o_),
							IX: choisi.IX,
							JR: $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeGroupe
						})) : saisie;
			case 3:
				var code = geste.a;
				return nouveauChamp ? _Utils_update(
					saisie,
					{
						tq: $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Vide,
						zT: _Utils_update(
							formulaire,
							{
								o_: $elm$core$Dict$fromList(
									A2(
										$elm$core$List$filterMap,
										$elm$core$Basics$identity,
										_List_fromArray(
											[
												A2($elm$core$List$member, code, saisie.xE) ? $elm$core$Maybe$Just(
												_Utils_Tuple2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionDonneePersonnelle, $author$project$Components$Shared$EditeurDeSchema$Model$oui)) : $elm$core$Maybe$Nothing,
												(_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typePays) || _Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeLangue)) ? $elm$core$Maybe$Just(
												_Utils_Tuple2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionPlusieursChoix, $author$project$Components$Shared$EditeurDeSchema$Model$oui)) : $elm$core$Maybe$Nothing
											]))),
								IX: _List_Nil,
								JR: code
							})
					}) : saisie;
			case 4:
				var code = geste.a;
				var texte = geste.b;
				return ((!nouveauChamp) && A2($elm$core$List$member, code, $author$project$Components$Shared$EditeurDeSchema$Model$optionsFigees)) ? saisie : avec(
					_Utils_update(
						formulaire,
						{
							o_: A3($elm$core$Dict$insert, code, texte, formulaire.o_)
						}));
			case 5:
				if (geste.b) {
					var code = geste.a;
					return (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionDonneePersonnelle) && (!$author$project$Components$Shared$EditeurDeSchema$Model$donneePersonnelleCochable(saisie))) ? saisie : avec(
						_Utils_update(
							formulaire,
							{
								o_: A3($elm$core$Dict$insert, code, $author$project$Components$Shared$EditeurDeSchema$Model$oui, formulaire.o_)
							}));
				} else {
					var code = geste.a;
					var cochee = geste.b;
					return avec(
						_Utils_update(
							formulaire,
							{
								o_: cochee ? A3($elm$core$Dict$insert, code, $author$project$Components$Shared$EditeurDeSchema$Model$oui, formulaire.o_) : A2($elm$core$Dict$remove, code, formulaire.o_)
							}));
				}
			case 6:
				var code = geste.a;
				return avec(
					_Utils_update(
						formulaire,
						{mo: code}));
			case 7:
				var visibilite = geste.a;
				return avec(
					_Utils_update(
						formulaire,
						{KQ: visibilite}));
			case 8:
				var valeur = geste.a;
				return _Utils_update(
					saisie,
					{tq: valeur});
			case 9:
				var texte = geste.a;
				return _Utils_update(
					saisie,
					{
						CC: A2(
							$elm$core$Maybe$map,
							function (m) {
								return _Utils_update(
									m,
									{Bd: texte});
							},
							saisie.CC)
					});
			case 10:
				var texte = geste.a;
				return _Utils_update(
					saisie,
					{
						CC: A2(
							$elm$core$Maybe$map,
							function (m) {
								return _Utils_update(
									m,
									{Ae: texte});
							},
							saisie.CC)
					});
			case 11:
				var exige = geste.a;
				return _Utils_update(
					saisie,
					{
						CC: A2(
							$elm$core$Maybe$map,
							function (m) {
								return _Utils_update(
									m,
									{Jz: exige});
							},
							saisie.CC)
					});
			default:
				return saisie;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$minimaSaisis = F2(
	function (geste, model) {
		if (geste.$ === 12) {
			var _v1 = _Utils_Tuple2(
				$author$project$Components$Produits$StructureCatalogue$Informations$Update$visee(model),
				A2($elm$core$Maybe$andThen, $author$project$Components$Shared$EditeurDeSchema$Model$minimaVoulus, model.cV));
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var _v2 = _v1.a.a;
				var portee = _v2.a;
				var lue = _v2.b;
				var voulus = _v1.b.a;
				return A2(
					$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
					A3($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$DefinirLesMinimaDUnChampHerite, portee, lue.uN.dy, voulus),
					_Utils_update(
						model,
						{aL: $elm$core$Maybe$Nothing}));
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						cV: A2(
							$elm$core$Maybe$map,
							$author$project$Components$Shared$EditeurDeSchema$Model$saisir(geste),
							model.cV)
					}),
				_List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Etats$Update$monte = F2(
	function (code, model) {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Commandes$avecFoyer,
			A2($author$project$Components$Produits$StructureCatalogue$Model$SurLOrdreDeLEtat, code, 0),
			A2(
				$author$project$Components$Produits$StructureCatalogue$Etats$Update$definir,
				$author$project$Components$Shared$Ordre$monter(
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.vx;
						},
						$elm$core$Basics$eq(code))),
				model));
	});
var $author$project$Components$Produits$StructureCatalogue$Natures$Update$monte = F2(
	function (code, model) {
		return A4(
			$author$project$Components$Produits$StructureCatalogue$Natures$Update$ordonner,
			$author$project$Components$Shared$Ordre$monter(
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.vx;
					},
					$elm$core$Basics$eq(code))),
			code,
			0,
			model);
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$monter = F2(
	function (cle, ordre) {
		return _Utils_update(
			ordre,
			{
				gV: A2(
					$author$project$Components$Shared$Ordre$monter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dy;
						},
						$elm$core$Basics$eq(cle)),
					ordre.gV)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$AuControle = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$NiveauDesigne = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$UnAutre = 1;
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$nomDuNiveau = F2(
	function (niveaux, niveau) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Traductions$tel(
				$author$project$Catalogue$Identifiants$niveauIdToString(niveau)),
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$libelleDuNiveau,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(niveau)),
						niveaux))));
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$placeDuNiveau = F3(
	function (niveaux, etages, voulu) {
		var rangDansLaStructure = function (id) {
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$first,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$second,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(id))),
						A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, niveaux))));
		};
		var apres = function (etage) {
			var _v0 = _Utils_Tuple2(
				etage.xt,
				rangDansLaStructure(voulu));
			if ((!_v0.a.$) && (!_v0.b.$)) {
				var _v1 = _v0.a;
				var niveau = _v1.b;
				var rang = _v0.b.a;
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (autre) {
							return _Utils_cmp(autre, rang) > 0;
						},
						rangDansLaStructure(niveau)));
			} else {
				return false;
			}
		};
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$first,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2($elm$core$Basics$composeR, $elm$core$Tuple$second, apres),
					A2(
						$elm$core$List$indexedMap,
						$elm$core$Tuple$pair,
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeL,
								$elm$core$Basics$not,
								function ($) {
									return $.wL;
								}),
							etages)))));
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$niveauAjoute = F2(
	function (niveau, model) {
		var _v0 = $author$project$Components$Produits$StructureCatalogue$Etages$Update$reglee(model);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var structure = _v1.a;
			var typologie = _v1.b;
			return A4(
				$author$project$Components$Produits$StructureCatalogue$Etages$Update$demander,
				A3(
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$AjouterUnEtage,
					typologie.Aq,
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$NiveauDesigne(niveau),
					A3($author$project$Components$Produits$StructureCatalogue$Etages$Model$placeDuNiveau, structure.C9, typologie.yG, niveau)),
				$author$project$Components$Produits$StructureCatalogue$Etages$Model$titreDeLAjout(
					A2($author$project$Components$Produits$StructureCatalogue$Etages$Model$nomDuNiveau, structure.C9, niveau)),
				$elm$core$Maybe$Just(
					$author$project$Components$Produits$StructureCatalogue$Etages$Model$AuControle(
						A2(
							$author$project$Components$Produits$StructureCatalogue$Etages$Update$auRangementSiOuvert,
							model,
							$author$project$Components$Produits$StructureCatalogue$Etages$Model$idDeLOuverture(1)))),
				model);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$NouveauChamp$Update$Ouvert = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$lienDeRattachement = F2(
	function (portee, informations) {
		return A3(
			$author$project$Components$Produits$StructureCatalogue$Informations$Model$lienDuPorteur,
			portee,
			function () {
				if (portee.$ === 3) {
					return $author$project$API$NavLinksDictionary$rattacherUnChampExistantACategorie;
				} else {
					return $author$project$API$NavLinksDictionary$rattacherUnChampExistant;
				}
			}(),
			informations);
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$porteurDeCreation = function (portee) {
	if (portee.$ === 3) {
		var type_ = portee.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'typeDeProduit',
				$author$project$Catalogue$Identifiants$typeDeProduitIdEncode(type_))
			]);
	} else {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'porteur',
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodePortee(portee))
			]);
	}
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$porteurDeRattachement = function (portee) {
	if (portee.$ === 3) {
		var type_ = portee.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'typeDeProduit',
				$author$project$Catalogue$Identifiants$typeDeProduitIdEncode(type_))
			]);
	} else {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'portee',
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$encodePortee(portee))
			]);
	}
};
var $author$project$I18n$Textes$produitsParcoursInformationsCreerAction = A3($author$project$I18n$Traductions$texte, 'produits.parcours.informations.creer.action', _List_Nil, 'Créer');
var $author$project$I18n$Textes$produitsParcoursInformationsCreerNom = A3($author$project$I18n$Traductions$texte, 'produits.parcours.informations.creer.nom', _List_Nil, 'Nom');
var $author$project$I18n$Textes$produitsParcoursInformationsCreerTitre = A3($author$project$I18n$Traductions$texte, 'produits.parcours.informations.creer.titre', _List_Nil, 'Créer un champ');
var $author$project$I18n$Textes$produitsParcoursInformationsCreerType = A3($author$project$I18n$Traductions$texte, 'produits.parcours.informations.creer.type', _List_Nil, 'Type');
var $author$project$Components$Produits$StructureCatalogue$Effet$EnvoyerUnNouveauChamp = F3(
	function (a, b, c) {
		return {$: 7, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$StructureCatalogue$Effet$LireLesListesDuNouveauChamp = function (a) {
	return {$: 6, a: a};
};
var $author$project$API$Envoi$delaiDeRelectureMs = 1000;
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$depuisLeNouveauChamp = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[$author$project$Components$Produits$StructureCatalogue$Effet$DemanderProcessUid])));
			case 1:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Components$Produits$StructureCatalogue$Effet$LireLesListesDuNouveauChamp(lien)
							])));
			case 2:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								A3($author$project$Components$Produits$StructureCatalogue$Effet$EnvoyerUnNouveauChamp, lien, processUid, commande)
							])));
			case 3:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(cible)
							])));
			case 4:
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[$author$project$Components$Produits$StructureCatalogue$Effet$Reconnecter])));
			case 5:
				var vuesAJour = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						vuesAJour ? $author$project$Components$Produits$StructureCatalogue$Commandes$relireLesInformations(model) : _List_fromArray(
							[
								$author$project$Components$Produits$StructureCatalogue$Effet$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
							])));
			case 7:
				return _Utils_Tuple2(model, effets);
			default:
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Effet$LireLesListes, $elm$core$List$singleton),
								A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$listes, model.nS)))));
		}
	});
var $author$project$Components$Shared$Drawer$Update$AbandonConfirme = {$: 3};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$ListeChoisie = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Update$VersLeRattachement = {$: 7};
var $author$project$Components$Parametrage$NouveauChamp$Update$PlacerFocus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$idDuNom = 'champ-a-creer-nom';
var $author$project$Components$Parametrage$NouveauChamp$Update$autreNom = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{
				uw: A2(
					$elm$core$Maybe$map,
					function (b) {
						return _Utils_update(
							b,
							{pZ: $elm$core$Maybe$Nothing, b5: false});
					},
					model.uw)
			}),
		_List_fromArray(
			[
				$author$project$Components$Parametrage$NouveauChamp$Update$PlacerFocus($author$project$Components$Parametrage$NouveauChamp$Formulaire$idDuNom)
			]));
};
var $author$project$API$Envoi$Aboutie = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$API$Envoi$Pret = function (a) {
	return {$: 1, a: a};
};
var $author$project$API$Envoi$Refusee = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$API$Envoi$SessionEchue = {$: 2};
var $author$project$API$Envoi$conclure = F3(
	function (reglage, reponse, envoi) {
		if (envoi.$ === 2) {
			var processUid = envoi.a;
			var commande = envoi.b;
			var _v1 = A2($author$project$API$Reponse$lire, reglage.qv, reponse);
			if (!_v1.$) {
				var rendue = _v1.a;
				return $elm$core$Maybe$Just(
					_Utils_Tuple3(
						$author$project$API$Envoi$SansProcessUid,
						A3(
							$author$project$API$Envoi$Aboutie,
							commande,
							rendue,
							A2(reglage.qu, commande, rendue)),
						_List_fromArray(
							[reglage.f8])));
			} else {
				var refus = _v1.a;
				return (refus.ri === 401) ? $elm$core$Maybe$Just(
					_Utils_Tuple3(
						$author$project$API$Envoi$Pret(processUid),
						$author$project$API$Envoi$SessionEchue,
						_List_fromArray(
							[reglage.pW]))) : (A2(
					$elm$core$List$member,
					refus.ri,
					_List_fromArray(
						[400, 403, 409, 422])) ? $elm$core$Maybe$Just(
					_Utils_Tuple3(
						$author$project$API$Envoi$SansProcessUid,
						A3(
							$author$project$API$Envoi$Refusee,
							commande,
							refus,
							reglage.go(reponse)),
						_List_fromArray(
							[reglage.f8]))) : $elm$core$Maybe$Just(
					_Utils_Tuple3(
						$author$project$API$Envoi$Pret(processUid),
						A3(
							$author$project$API$Envoi$Refusee,
							commande,
							refus,
							reglage.go(reponse)),
						_List_Nil)));
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$lignesDeValeurs = function (texte) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (ligne, vues) {
				return A2(
					$elm$core$List$any,
					function (vue) {
						return _Utils_eq(
							$elm$core$String$toLower(vue),
							$elm$core$String$toLower(ligne));
					},
					vues) ? vues : _Utils_ap(
					vues,
					_List_fromArray(
						[ligne]));
			}),
		_List_Nil,
		A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
			A2(
				$elm$core$List$map,
				$elm$core$String$trim,
				$elm$core$String$lines(texte))));
};
var $author$project$Components$Parametrage$NouveauChamp$Update$Lire = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Update$ListesChangees = {$: 6};
var $author$project$Components$Parametrage$NouveauChamp$Update$versLeDrawerDeLaListe = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{
						lc: drawer,
						nW: A2(
							$elm$core$List$member,
							geste,
							_List_fromArray(
								[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$AbandonConfirme])) ? $elm$core$Maybe$Nothing : model.nW
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Parametrage$NouveauChamp$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.lc));
	});
var $author$project$Components$Parametrage$NouveauChamp$Update$listeConclue = F2(
	function (liste, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Basics$append(
				A2(
					$elm$core$List$cons,
					$author$project$Components$Parametrage$NouveauChamp$Update$ListesChangees,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$NouveauChamp$Update$Lire, $elm$core$List$singleton),
							A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.BF;
								},
								model.ew))))),
			A2(
				$author$project$Components$Parametrage$NouveauChamp$Update$versLeDrawerDeLaListe,
				$author$project$Components$Shared$Drawer$Update$Fermer,
				_Utils_update(
					model,
					{
						nX: $elm$core$Maybe$Just(
							$elm$core$String$trim(liste.Dj))
					})));
	});
var $author$project$Components$Parametrage$NouveauChamp$Update$conclureLaListe = F2(
	function (issue, model) {
		var _v0 = _Utils_Tuple2(issue, model.nW);
		_v0$3:
		while (true) {
			if (!_v0.b.$) {
				switch (_v0.a.$) {
					case 0:
						var _v1 = _v0.a;
						var rendue = _v1.b;
						var liste = _v0.b.a;
						var creee = liste.wm;
						var _v2 = _Utils_Tuple3(
							creee,
							rendue.uN,
							$author$project$Components$Parametrage$NouveauChamp$Formulaire$lignesDeValeurs(liste.Ki));
						if (_v2.a.$ === 1) {
							if ((!_v2.b.$) && _v2.c.b) {
								var _v3 = _v2.a;
								var id = _v2.b.a;
								var _v4 = _v2.c;
								var premiere = _v4.a;
								var suite = _v4.b;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											nW: $elm$core$Maybe$Just(
												_Utils_update(
													liste,
													{
														wm: $elm$core$Maybe$Just(
															{Aq: id, nQ: rendue.nQ}),
														rn: A2($elm$core$List$cons, premiere, suite)
													}))
										}),
									_List_Nil);
							} else {
								return A2($author$project$Components$Parametrage$NouveauChamp$Update$listeConclue, liste, model);
							}
						} else {
							return _Utils_eq(liste.rn, _List_Nil) ? A2($author$project$Components$Parametrage$NouveauChamp$Update$listeConclue, liste, model) : _Utils_Tuple2(model, _List_Nil);
						}
					case 1:
						if (!_v0.a.c.$) {
							var _v5 = _v0.a;
							var _v6 = _v5.c;
							var liste = _v0.b.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										nW: $elm$core$Maybe$Just(
											_Utils_update(
												liste,
												{g7: true, rn: _List_Nil}))
									}),
								_List_Nil);
						} else {
							var _v7 = _v0.a;
							var liste = _v0.b.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										nW: $elm$core$Maybe$Just(
											_Utils_update(
												liste,
												{qa: true, rn: _List_Nil}))
									}),
								_List_Nil);
						}
					default:
						break _v0$3;
				}
			} else {
				break _v0$3;
			}
		}
		return _Utils_Tuple2(model, _List_Nil);
	});
var $author$project$Components$Parametrage$NouveauChamp$Update$Cree = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$refuser = F3(
	function (cas, precisions, brouillon) {
		return _Utils_update(
			brouillon,
			{
				pZ: $elm$core$Maybe$Just(
					_Utils_Tuple2(cas, precisions)),
				b5: true
			});
	});
var $author$project$Components$Parametrage$NouveauChamp$Update$refuse = F3(
	function (cas, precisions, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					uw: A2(
						$elm$core$Maybe$map,
						A2($author$project$Components$Parametrage$NouveauChamp$Formulaire$refuser, cas, precisions),
						model.uw)
				}),
			_List_Nil);
	});
var $author$project$Components$Parametrage$NouveauChamp$Update$versLeDrawerDuChamp = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return A2(
					$elm$core$List$member,
					geste,
					_List_fromArray(
						[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$AbandonConfirme])) ? _Utils_update(
					model,
					{uw: $elm$core$Maybe$Nothing, lp: drawer, ew: $elm$core$Maybe$Nothing}) : _Utils_update(
					model,
					{lp: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Parametrage$NouveauChamp$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: !_Utils_eq(model.uw, $elm$core$Maybe$Nothing)
				},
				geste,
				model.lp));
	});
var $author$project$Components$Parametrage$NouveauChamp$Update$conclureLeChamp = F2(
	function (issue, model) {
		switch (issue.$) {
			case 0:
				var rendue = issue.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(
						_List_fromArray(
							[
								$author$project$Components$Parametrage$NouveauChamp$Update$Cree(rendue.sy)
							])),
					A2($author$project$Components$Parametrage$NouveauChamp$Update$versLeDrawerDuChamp, $author$project$Components$Shared$Drawer$Update$Fermer, model));
			case 1:
				switch (issue.c.$) {
					case 3:
						var _v1 = issue.c;
						var cas = _v1.a;
						var precisions = _v1.b;
						return A3($author$project$Components$Parametrage$NouveauChamp$Update$refuse, cas, precisions, model);
					case 2:
						if (!issue.c.a.$) {
							var champ = issue.c.a.a;
							return A3(
								$author$project$Components$Parametrage$NouveauChamp$Update$refuse,
								'ChampDejaDansLaBibliotheque',
								_List_fromArray(
									[
										_Utils_Tuple2('champ', champ)
									]),
								model);
						} else {
							var _v2 = issue.c.a;
							return A3($author$project$Components$Parametrage$NouveauChamp$Update$refuse, 'DejaDefini', _List_Nil, model);
						}
					default:
						return A3($author$project$Components$Parametrage$NouveauChamp$Update$refuse, 'Autre', _List_Nil, model);
				}
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$NouveauChamp$Update$conclure = F2(
	function (issue, model) {
		return (!_Utils_eq(model.nW, $elm$core$Maybe$Nothing)) ? A2($author$project$Components$Parametrage$NouveauChamp$Update$conclureLaListe, issue, model) : A2($author$project$Components$Parametrage$NouveauChamp$Update$conclureLeChamp, issue, model);
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$CreerUneListe = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$idDuNomDeListe = 'nouvelle-liste-nom';
var $author$project$API$Envoi$EnCours = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$API$Envoi$partir = F4(
	function (reglage, lien, commande, envoi) {
		var _v0 = _Utils_Tuple2(envoi, lien);
		if ((_v0.a.$ === 1) && (!_v0.b.$)) {
			var processUid = _v0.a.a;
			var porteur = _v0.b.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					A2($author$project$API$Envoi$EnCours, processUid, commande),
					_List_fromArray(
						[
							A3(reglage.l4, porteur, processUid, commande)
						])));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$Autre = {$: 9};
var $author$project$Components$Parametrage$NouveauChamp$Update$DemanderProcessUid = {$: 0};
var $author$project$Components$Parametrage$NouveauChamp$Update$Envoyer = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$NouveauChamp$Update$Reconnecter = {$: 4};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$ChampDejaDansUneAutreCollection = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$ChampPersonnel = {$: 1};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$DejaDefini = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$NomDejaPris = {$: 0};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$NonAppliqueeATous = {$: 4};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$OptionRefusee = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$TypeNonPropose = {$: 6};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$ValeurNonTransmise = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$VuesEnRetard = {$: 5};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$duRefus = function (refus) {
	var _v0 = refus.bB;
	_v0$29:
	while (true) {
		switch (_v0.$) {
			case 0:
				return $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$Autre;
			case 4:
				switch (_v0.a) {
					case 'ChampDejaDansLaBibliotheque':
						var precisions = _v0.b;
						return $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$DejaDefini(
							A2(
								$elm$core$Maybe$map,
								$elm$core$Tuple$second,
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$Tuple$first,
											$elm$core$Basics$eq('champ')),
										precisions))));
					case 'SchemaInvalide':
						var defauts = _v0.b;
						return A2(
							$elm$core$List$any,
							function (_v1) {
								var code = _v1.b;
								return code === 'TypeNonPropose';
							},
							defauts) ? $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$TypeNonPropose : $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$Autre;
					case 'ChampDejaDansUneAutreCollection':
						var precisions = _v0.b;
						return A2(
							$elm$core$Maybe$withDefault,
							$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$Autre,
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$ChampDejaDansUneAutreCollection),
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (_v2) {
											var cle = _v2.a;
											return cle === 'collection';
										},
										precisions))));
					case 'ValeurNonTransmise':
						var precisions = _v0.b;
						return A2(
							$elm$core$Maybe$withDefault,
							$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$Autre,
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$ValeurNonTransmise),
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$Tuple$first,
											$elm$core$Basics$eq('valeur')),
										precisions))));
					default:
						var cas = _v0.a;
						var precisions = _v0.b;
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$OptionRefusee, cas, precisions);
				}
			case 1:
				switch (_v0.a) {
					case 'NomDeListeDejaPris':
						return $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$NomDejaPris;
					case 'ChampPersonnel':
						return $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$ChampPersonnel;
					case 'ChampDejaDansLaBibliotheque':
						return $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$DejaDefini($elm$core$Maybe$Nothing);
					case 'NomVide':
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$OptionRefusee, 'NomVide', _List_Nil);
					case 'CollectionIntrouvable':
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$OptionRefusee, 'CollectionIntrouvable', _List_Nil);
					case 'ChampHorsDuCatalogue':
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$OptionRefusee, 'ChampHorsDuCatalogue', _List_Nil);
					case 'AucunEtage':
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$OptionRefusee, 'AucunEtage', _List_Nil);
					case 'FiltrableNonAdmis':
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$OptionRefusee, 'FiltrableNonAdmis', _List_Nil);
					case 'RecherchableNonAdmis':
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$OptionRefusee, 'RecherchableNonAdmis', _List_Nil);
					case 'GroupeSansSousChamp':
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$OptionRefusee, 'GroupeSansSousChamp', _List_Nil);
					case 'SousChampSansLibelle':
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$OptionRefusee, 'SousChampSansLibelle', _List_Nil);
					case 'ListeDeSousChampInadmise':
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$OptionRefusee, 'ListeDeSousChampInadmise', _List_Nil);
					case 'TypeDeChampNonModifiable':
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$OptionRefusee, 'TypeDeChampNonModifiable', _List_Nil);
					case 'GrandeurFigee':
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$OptionRefusee, 'GrandeurFigee', _List_Nil);
					case 'UniteHorsGrandeur':
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$OptionRefusee, 'UniteHorsGrandeur', _List_Nil);
					case 'LangueInconnue':
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$OptionRefusee, 'LangueInconnue', _List_Nil);
					case 'OptionInvalide':
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$OptionRefusee, 'OptionInvalide', _List_Nil);
					case 'EvolutionNonAdditive':
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$OptionRefusee, 'EvolutionNonAdditive', _List_Nil);
					case 'DefinitionNonAppliqueeATous':
						return $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$NonAppliqueeATous;
					case 'VuesEnRetard':
						return $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$VuesEnRetard;
					case 'ValeursPerdues':
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$OptionRefusee, 'ValeursPerdues', _List_Nil);
					case 'ConversionDejaEnCours':
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$OptionRefusee, 'ConversionDejaEnCours', _List_Nil);
					case 'ConversionEnCours':
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$OptionRefusee, 'ConversionEnCours', _List_Nil);
					default:
						break _v0$29;
				}
			default:
				break _v0$29;
		}
	}
	return $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$Autre;
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$Rendue = F4(
	function (champs, vuesAJour, champ, liens) {
		return {uN: champ, dw: champs, nQ: liens, sy: vuesAJour};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$rendueDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$author$project$API$Liens$deLaRessource,
					A2($elm$json$Json$Decode$field, 'liens', $author$project$API$Liens$decoder)
				]))),
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$Just,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['evenements']),
						A2(
							$elm$json$Json$Decode$index,
							0,
							A2($elm$json$Json$Decode$field, 'aggregateUid', $elm$json$Json$Decode$string)))),
					$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
				])),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'vuesAJour',
			$elm$json$Json$Decode$bool,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'champs',
				$elm$json$Json$Decode$list(
					A3(
						$elm$json$Json$Decode$map2,
						$elm$core$Tuple$pair,
						A2($elm$json$Json$Decode$field, 'cle', $elm$json$Json$Decode$string),
						A2($elm$json$Json$Decode$field, 'liste', $elm$json$Json$Decode$string))),
				_List_Nil,
				$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$Rendue)))));
var $author$project$Components$Parametrage$NouveauChamp$Update$reglageDEnvoi = {
	f8: $author$project$Components$Parametrage$NouveauChamp$Update$DemanderProcessUid,
	l4: $author$project$Components$Parametrage$NouveauChamp$Update$Envoyer,
	go: function (reponse) {
		var _v0 = A2(
			$author$project$API$Reponse$lire,
			$elm$json$Json$Decode$succeed(0),
			reponse);
		if (_v0.$ === 1) {
			var refus = _v0.a;
			return $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$duRefus(refus);
		} else {
			return $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$Autre;
		}
	},
	pW: $author$project$Components$Parametrage$NouveauChamp$Update$Reconnecter,
	qu: F2(
		function (_v1, _v2) {
			return true;
		}),
	qv: $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$rendueDecoder
};
var $author$project$Components$Parametrage$NouveauChamp$Update$creerLaListe = function (model) {
	var _v0 = _Utils_Tuple3(
		model.nW,
		model.uw,
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUneListe, model.nS));
	if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
		var liste = _v0.a.a;
		var brouillon = _v0.b.a;
		var lien = _v0.c.a;
		if ($elm$core$String$trim(liste.Dj) === '') {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						nW: $elm$core$Maybe$Just(
							_Utils_update(
								liste,
								{b5: true}))
					}),
				_List_fromArray(
					[
						$author$project$Components$Parametrage$NouveauChamp$Update$PlacerFocus($author$project$Components$Parametrage$NouveauChamp$Formulaire$idDuNomDeListe)
					]));
		} else {
			var _v1 = A4(
				$author$project$API$Envoi$partir,
				$author$project$Components$Parametrage$NouveauChamp$Update$reglageDEnvoi,
				$elm$core$Maybe$Just(lien),
				A2(
					$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$CreerUneListe,
					$elm$core$String$trim(liste.Dj),
					brouillon.F$),
				model.l2);
			if (!_v1.$) {
				var _v2 = _v1.a;
				var envoi = _v2.a;
				var effets = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{l2: envoi}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$API$Envoi$enCours = function (envoi) {
	if (envoi.$ === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$PourUnPorteur = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$CreerUnChampNeuf = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$CreerUnGroupe = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$estUnGroupe = function (brouillon) {
	return _Utils_eq(brouillon.JR, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeGroupe);
};
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeCalcule = 'calcule';
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$estUnCalcule = function (brouillon) {
	return _Utils_eq(brouillon.JR, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeCalcule);
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$listeUtile = function (brouillon) {
	return _Utils_eq(brouillon.JR, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeListeUnique) || ($author$project$Components$Parametrage$NouveauChamp$Formulaire$estUnCalcule(brouillon) && (brouillon.HW === 'liste'));
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$DeLaMesure = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$DuCalcule = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$DuChoix = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$decimalesLues = function (brouillon) {
	return A2(
		$elm$core$Maybe$andThen,
		function (n) {
			return (n >= 0) ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
		},
		$elm$core$String$toInt(
			$elm$core$String$trim(brouillon.kv)));
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$optionsDuType = function (brouillon) {
	return _Utils_eq(brouillon.JR, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeListeUnique) ? $elm$core$Maybe$Just(
		$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$DuChoix(
			{FS: brouillon.FT})) : (_Utils_eq(brouillon.JR, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeMesure) ? $elm$core$Maybe$Just(
		$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$DeLaMesure(
			{
				kv: A2(
					$elm$core$Maybe$withDefault,
					0,
					$author$project$Components$Parametrage$NouveauChamp$Formulaire$decimalesLues(brouillon)),
				m0: brouillon.m0,
				Cg: $elm$core$Maybe$Nothing,
				Cx: $elm$core$Maybe$Nothing,
				sa: brouillon.sa
			})) : ($author$project$Components$Parametrage$NouveauChamp$Formulaire$estUnCalcule(brouillon) ? $elm$core$Maybe$Just(
		$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$DuCalcule(
			{
				kv: A2(
					$elm$core$List$member,
					brouillon.HW,
					_List_fromArray(
						['nombre', 'mesure'])) ? $author$project$Components$Parametrage$NouveauChamp$Formulaire$decimalesLues(brouillon) : $elm$core$Maybe$Nothing,
				zU: $elm$core$String$trim(brouillon.zU),
				G$: brouillon.G$,
				HW: brouillon.HW,
				sa: (brouillon.HW === 'mesure') ? $elm$core$Maybe$Just(brouillon.sa) : $elm$core$Maybe$Nothing,
				fm: brouillon.fm
			})) : $elm$core$Maybe$Nothing));
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$reglages = function (brouillon) {
	return {
		vD: brouillon.vD,
		yG: brouillon.ao ? brouillon.yG : _List_Nil,
		zG: brouillon.zG,
		G1: brouillon.G1
	};
};
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typePartiePrenante = 'partie-prenante';
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$commande = function (brouillon) {
	return $author$project$Components$Parametrage$NouveauChamp$Formulaire$estUnGroupe(brouillon) ? $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$CreerUnGroupe(
		{
			Dj: $elm$core$String$trim(brouillon.Dj),
			D$: ($elm$core$String$trim(brouillon.Bq) === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				{
					M: brouillon.z9,
					Bl: $elm$core$String$trim(brouillon.Bq)
				}),
			F$: brouillon.F$,
			qc: $author$project$Components$Parametrage$NouveauChamp$Formulaire$reglages(brouillon),
			HI: brouillon.HI,
			IX: brouillon.IX
		}) : $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$CreerUnChampNeuf(
		{
			nW: ((brouillon.nW === '') || (!$author$project$Components$Parametrage$NouveauChamp$Formulaire$listeUtile(brouillon))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(brouillon.nW),
			Dj: $elm$core$String$trim(brouillon.Dj),
			o_: $author$project$Components$Parametrage$NouveauChamp$Formulaire$optionsDuType(brouillon),
			F$: brouillon.F$,
			qc: $author$project$Components$Parametrage$NouveauChamp$Formulaire$reglages(brouillon),
			JR: brouillon.JR,
			r$: ((brouillon.r$ === '') || (!_Utils_eq(brouillon.JR, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typePartiePrenante))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(brouillon.r$)
		});
};
var $author$project$Components$Parametrage$NouveauChamp$Update$commandeDe = F2(
	function (ouverture, brouillon) {
		return ouverture.F1 ? A2(
			$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$PourUnPorteur,
			_Utils_ap(
				ouverture.c0,
				brouillon.xD ? _List_fromArray(
					[
						_Utils_Tuple2(
						'donneePersonnelle',
						$elm$json$Json$Encode$bool(true))
					]) : _List_Nil),
			$author$project$Components$Parametrage$NouveauChamp$Formulaire$commande(brouillon)) : $author$project$Components$Parametrage$NouveauChamp$Formulaire$commande(brouillon);
	});
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$mesureComplete = function (brouillon) {
	return (brouillon.sa !== '') && (!_Utils_eq(
		$author$project$Components$Parametrage$NouveauChamp$Formulaire$decimalesLues(brouillon),
		$elm$core$Maybe$Nothing));
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$calculComplet = function (brouillon) {
	return ($elm$core$String$trim(brouillon.zU) !== '') && function () {
		var _v0 = brouillon.HW;
		switch (_v0) {
			case 'nombre':
				return !_Utils_eq(
					$author$project$Components$Parametrage$NouveauChamp$Formulaire$decimalesLues(brouillon),
					$elm$core$Maybe$Nothing);
			case 'mesure':
				return $author$project$Components$Parametrage$NouveauChamp$Formulaire$mesureComplete(brouillon);
			case 'liste':
				return brouillon.nW !== '';
			default:
				return true;
		}
	}();
};
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$manque = function (sousChamps) {
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2(
			$elm$core$List$indexedMap,
			F2(
				function (rang, sousChamp) {
					return (($elm$core$String$trim(sousChamp.Bl) === '') || (((sousChamp.M === 6) && (sousChamp.nW === '')) || ((sousChamp.M === 7) && (sousChamp.r$ === '')))) ? $elm$core$Maybe$Just(rang) : $elm$core$Maybe$Nothing;
				}),
			sousChamps));
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$enregistrable = function (brouillon) {
	return ($elm$core$String$trim(brouillon.Dj) !== '') && (((!brouillon.ao) || (!_Utils_eq(brouillon.yG, _List_Nil))) && ($author$project$Components$Parametrage$NouveauChamp$Formulaire$estUnGroupe(brouillon) ? ((!_Utils_eq(brouillon.IX, _List_Nil)) && _Utils_eq(
		$author$project$Components$Shared$EditeurDeSchema$SousChamps$manque(brouillon.IX),
		_List_Nil)) : (_Utils_eq(brouillon.JR, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeListeUnique) ? (brouillon.nW !== '') : (_Utils_eq(brouillon.JR, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typePartiePrenante) ? (brouillon.r$ !== '') : (_Utils_eq(brouillon.JR, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeMesure) ? $author$project$Components$Parametrage$NouveauChamp$Formulaire$mesureComplete(brouillon) : ($author$project$Components$Parametrage$NouveauChamp$Formulaire$estUnCalcule(brouillon) ? $author$project$Components$Parametrage$NouveauChamp$Formulaire$calculComplet(brouillon) : true))))));
};
var $author$project$Components$Parametrage$NouveauChamp$Update$enregistrer = function (model) {
	var _v0 = _Utils_Tuple2(model.uw, model.ew);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var brouillon = _v0.a.a;
		var ouverture = _v0.b.a;
		if ($author$project$Components$Parametrage$NouveauChamp$Formulaire$enregistrable(brouillon)) {
			var _v1 = A4(
				$author$project$API$Envoi$partir,
				$author$project$Components$Parametrage$NouveauChamp$Update$reglageDEnvoi,
				$elm$core$Maybe$Just(ouverture.Bz),
				A2($author$project$Components$Parametrage$NouveauChamp$Update$commandeDe, ouverture, brouillon),
				model.l2);
			if (!_v1.$) {
				var _v2 = _v1.a;
				var envoi = _v2.a;
				var effets = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{l2: envoi}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						uw: $elm$core$Maybe$Just(
							_Utils_update(
								brouillon,
								{b5: true}))
					}),
				_List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$AjouterUneValeur = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$Parametrage$NouveauChamp$Update$envoyerLaSuite = function (model) {
	var _v0 = model.nW;
	if (!_v0.$) {
		var liste = _v0.a;
		var creee = liste.wm;
		var suite = liste.rn;
		var _v1 = _Utils_Tuple2(creee, suite);
		if ((!_v1.a.$) && _v1.b.b) {
			var id = _v1.a.a.Aq;
			var liens = _v1.a.a.nQ;
			var _v2 = _v1.b;
			var valeur = _v2.a;
			var reste = _v2.b;
			var _v3 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ajouterUneValeur, liens);
			if (!_v3.$) {
				var lien = _v3.a;
				var _v4 = A4(
					$author$project$API$Envoi$partir,
					$author$project$Components$Parametrage$NouveauChamp$Update$reglageDEnvoi,
					$elm$core$Maybe$Just(lien),
					A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$AjouterUneValeur, id, valeur),
					model.l2);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var envoi = _v5.a;
					var effets = _v5.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l2: envoi,
								nW: $elm$core$Maybe$Just(
									_Utils_update(
										liste,
										{rn: reste}))
							}),
						effets);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$listeACreerVide = {wm: $elm$core$Maybe$Nothing, Dj: '', g7: false, qa: false, rn: _List_Nil, b5: false, Ki: ''};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$DetailDeListe = F5(
	function (id, portee, valeurs, utiliseePar, libelles) {
		return {Aq: id, R: libelles, F$: portee, Kh: utiliseePar, Ki: valeurs};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$detailsDeListesDecoder = A2(
	$elm$json$Json$Decode$field,
	'listes',
	$elm$json$Json$Decode$list(
		A6(
			$elm$json$Json$Decode$map5,
			$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$DetailDeListe,
			A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'portee', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'valeurs', $elm$json$Json$Decode$int),
			A2($elm$json$Json$Decode$field, 'utiliseePar', $elm$json$Json$Decode$int),
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$field,
						'libellesDesValeurs',
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
						$elm$json$Json$Decode$succeed(_List_Nil)
					])))));
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$Liste = F2(
	function (id, nom) {
		return {Aq: id, Dj: nom};
	});
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$listesDecoder = A2(
	$elm$json$Json$Decode$field,
	'listes',
	$elm$json$Json$Decode$list(
		A3(
			$elm$json$Json$Decode$map2,
			$author$project$Components$Shared$EditeurDeSchema$SousChamps$Liste,
			A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string))));
var $author$project$Components$Parametrage$NouveauChamp$Update$listesLues = F2(
	function (reponse, model) {
		var _v0 = A2(
			$author$project$API$Reponse$lire,
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (l, d, li) {
						return _Utils_Tuple3(l, d, li);
					}),
				$author$project$Components$Shared$EditeurDeSchema$SousChamps$listesDecoder,
				$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$detailsDeListesDecoder,
				$author$project$API$Liens$deLaRessource),
			reponse);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var listes = _v1.a;
			var details = _v1.b;
			var liens = _v1.c;
			var choisie = A2(
				$elm$core$Maybe$andThen,
				function (nom) {
					return $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (l) {
								return _Utils_eq(
									$elm$core$String$toLower(l.Dj),
									$elm$core$String$toLower(nom));
							},
							listes));
				},
				model.nX);
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						uw: function () {
							if (!choisie.$) {
								var liste = choisie.a;
								return A2(
									$elm$core$Maybe$map,
									function (b) {
										return _Utils_update(
											b,
											{nW: liste.Aq});
									},
									model.uw);
							} else {
								return model.uw;
							}
						}(),
						cz: details,
						nS: liens.h0,
						nX: _Utils_eq(choisie, $elm$core$Maybe$Nothing) ? model.nX : $elm$core$Maybe$Nothing,
						n_: listes
					}),
				_List_Nil);
		} else {
			var refus = _v0.a;
			return _Utils_Tuple2(
				model,
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Parametrage$NouveauChamp$Update$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Catalogue$Vocabulaire$etagesParDefautDuNouveauChamp = _List_fromArray(
	['marque', 'gamme']);
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$init = function (portee) {
	return {
		vD: $elm$core$Maybe$Nothing,
		kv: '0',
		xD: false,
		yG: $author$project$Catalogue$Vocabulaire$etagesParDefautDuNouveauChamp,
		zG: false,
		zU: '',
		z9: 1,
		m0: '',
		Bq: '',
		nW: '',
		Dj: '',
		FT: false,
		F$: (portee === 'parties-prenantes') ? portee : 'catalogue',
		G$: 'sur-changement',
		G1: false,
		pZ: $elm$core$Maybe$Nothing,
		HI: true,
		HW: 'texte',
		IX: _List_Nil,
		ao: false,
		b5: false,
		JR: $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeTexte,
		r$: '',
		sa: '',
		fm: 'proposee'
	};
};
var $author$project$Components$Parametrage$NouveauChamp$Update$ouvrir = F2(
	function (ouverture, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Basics$append(
				A2(
					$elm$core$List$cons,
					$author$project$Components$Parametrage$NouveauChamp$Update$DemanderProcessUid,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$NouveauChamp$Update$Lire, $elm$core$List$singleton),
							ouverture.BF)))),
			A2(
				$author$project$Components$Parametrage$NouveauChamp$Update$versLeDrawerDuChamp,
				$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Parametrage$NouveauChamp$Formulaire$idDuNom),
				_Utils_update(
					model,
					{
						uw: $elm$core$Maybe$Just(
							$author$project$Components$Parametrage$NouveauChamp$Formulaire$init(ouverture.F$)),
						nW: $elm$core$Maybe$Nothing,
						nX: $elm$core$Maybe$Nothing,
						ew: $elm$core$Maybe$Just(ouverture)
					})));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$RattacherLeChampExistant = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$champDuNomPris = function (brouillon) {
	var _v0 = brouillon.pZ;
	if ((!_v0.$) && (_v0.a.a === 'ChampDejaDansLaBibliotheque')) {
		var _v1 = _v0.a;
		var precisions = _v1.b;
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$eq('champ')),
					precisions)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$NouveauChamp$Update$champDuRefus = function (model) {
	return A2($elm$core$Maybe$andThen, $author$project$Components$Parametrage$NouveauChamp$Formulaire$champDuNomPris, model.uw);
};
var $author$project$Components$Parametrage$NouveauChamp$Update$rattacherLExistant = function (model) {
	var _v0 = _Utils_Tuple2(
		A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.pN;
			},
			model.ew),
		$author$project$Components$Parametrage$NouveauChamp$Update$champDuRefus(model));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var lien = _v0.a.a.nB;
		var corps = _v0.a.a.f$;
		var champ = _v0.b.a;
		var _v1 = A4(
			$author$project$API$Envoi$partir,
			$author$project$Components$Parametrage$NouveauChamp$Update$reglageDEnvoi,
			$elm$core$Maybe$Just(lien),
			A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$RattacherLeChampExistant, corps, champ),
			model.l2);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var envoi = _v2.a;
			var effets = _v2.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$API$Envoi$recevoir = F2(
	function (octets, envoi) {
		var _v0 = _Utils_Tuple2(
			envoi,
			$author$project$API$ProcessUid$depuisOctets(octets));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var _v1 = _v0.a;
			var processUid = _v0.b.a;
			return $author$project$API$Envoi$Pret(processUid);
		} else {
			return envoi;
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$Ajouter = {$: 0};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$duBack = F2(
	function (types, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			{zG: false, G1: false},
			A2(
				$elm$core$Maybe$map,
				function (t) {
					return {zG: t.zG, G1: t.G1};
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.vx;
							},
							$elm$core$Basics$eq(code)),
						types))));
	});
var $author$project$Catalogue$Vocabulaire$etagesDeLaBibliotheque = _List_fromArray(
	['marque', 'gamme', 'type']);
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$saisir = F3(
	function (typesDuBack, geste, brouillon) {
		var sansRefus = function (b) {
			return _Utils_update(
				b,
				{pZ: $elm$core$Maybe$Nothing});
		};
		return sansRefus(
			function () {
				switch (geste.$) {
					case 0:
						var nom = geste.a;
						return _Utils_update(
							brouillon,
							{Dj: nom});
					case 1:
						if (geste.a === 'etages') {
							return _Utils_update(
								brouillon,
								{vD: $elm$core$Maybe$Nothing, F$: 'catalogue', ao: true});
						} else {
							var portee = geste.a;
							return _Utils_update(
								brouillon,
								{vD: $elm$core$Maybe$Nothing, F$: portee, ao: false});
						}
					case 2:
						var collection = geste.a;
						return _Utils_update(
							brouillon,
							{vD: collection});
					case 3:
						var etage = geste.a;
						var oui = geste.b;
						return _Utils_update(
							brouillon,
							{
								yG: A2(
									$elm$core$List$filter,
									function (e) {
										return (_Utils_eq(e, etage) && oui) || ((!_Utils_eq(e, etage)) && A2($elm$core$List$member, e, brouillon.yG));
									},
									$author$project$Catalogue$Vocabulaire$etagesDeLaBibliotheque)
							});
					case 4:
						var code = geste.a;
						var admis = A2($author$project$Components$Parametrage$NouveauChamp$Formulaire$duBack, typesDuBack, code);
						return _Utils_update(
							brouillon,
							{
								zG: brouillon.zG && admis.zG,
								G1: brouillon.G1 && admis.G1,
								IX: (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeGroupe) && _Utils_eq(brouillon.IX, _List_Nil)) ? A2($author$project$Components$Shared$EditeurDeSchema$SousChamps$appliquer, $author$project$Components$Shared$EditeurDeSchema$SousChamps$Ajouter, _List_Nil) : brouillon.IX,
								JR: code
							});
					case 5:
						var liste = geste.a;
						return _Utils_update(
							brouillon,
							{nW: liste});
					case 6:
						var typeVise = geste.a;
						return _Utils_update(
							brouillon,
							{r$: typeVise});
					case 7:
						var oui = geste.a;
						return _Utils_update(
							brouillon,
							{zG: oui});
					case 8:
						var oui = geste.a;
						return _Utils_update(
							brouillon,
							{G1: oui});
					case 9:
						var oui = geste.a;
						return _Utils_update(
							brouillon,
							{xD: oui});
					case 10:
						var oui = geste.a;
						return _Utils_update(
							brouillon,
							{FT: oui});
					case 11:
						var grandeur = geste.a;
						return _Utils_update(
							brouillon,
							{m0: grandeur, sa: ''});
					case 12:
						var unite = geste.a;
						return _Utils_update(
							brouillon,
							{sa: unite});
					case 13:
						var decimales = geste.a;
						return _Utils_update(
							brouillon,
							{kv: decimales});
					case 14:
						var formule = geste.a;
						return _Utils_update(
							brouillon,
							{zU: formule});
					case 15:
						var resultat = geste.a;
						return _Utils_update(
							brouillon,
							{m0: '', HW: resultat, sa: ''});
					case 16:
						var recalcul = geste.a;
						return _Utils_update(
							brouillon,
							{G$: recalcul});
					case 17:
						var valeur = geste.a;
						return _Utils_update(
							brouillon,
							{fm: valeur});
					case 18:
						var oui = geste.a;
						return _Utils_update(
							brouillon,
							{HI: oui});
					case 19:
						var mot = geste.a;
						return _Utils_update(
							brouillon,
							{Bq: mot});
					case 20:
						var genre = geste.a;
						return _Utils_update(
							brouillon,
							{z9: genre});
					case 21:
						var choisi = geste.a;
						return _Utils_update(
							brouillon,
							{HI: choisi.HI, IX: choisi.IX});
					default:
						var suite = geste.a;
						return _Utils_update(
							brouillon,
							{
								IX: A2($author$project$Components$Shared$EditeurDeSchema$SousChamps$appliquer, suite, brouillon.IX)
							});
				}
			}());
	});
var $author$project$Components$Parametrage$NouveauChamp$Update$surLaListe = F2(
	function (geste, model) {
		var _v0 = _Utils_Tuple2(geste, model.nW);
		if (!_v0.b.$) {
			switch (_v0.a.$) {
				case 0:
					var nom = _v0.a.a;
					var liste = _v0.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								nW: $elm$core$Maybe$Just(
									_Utils_update(
										liste,
										{Dj: nom, g7: false, qa: false}))
							}),
						_List_Nil);
				case 1:
					var texte = _v0.a.a;
					var liste = _v0.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								nW: $elm$core$Maybe$Just(
									_Utils_update(
										liste,
										{Ki: texte}))
							}),
						_List_Nil);
				case 2:
					var _v1 = _v0.a;
					var liste = _v0.b.a;
					var existante = A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.Aq;
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (l) {
										return _Utils_eq(
											$elm$core$String$toLower(l.Dj),
											$elm$core$String$toLower(
												$elm$core$String$trim(liste.Dj)));
									},
									model.n_))));
					return A2(
						$author$project$Components$Parametrage$NouveauChamp$Update$versLeDrawerDeLaListe,
						$author$project$Components$Shared$Drawer$Update$Fermer,
						_Utils_update(
							model,
							{
								uw: A2(
									$elm$core$Maybe$map,
									function (b) {
										return _Utils_update(
											b,
											{nW: existante});
									},
									model.uw)
							}));
				default:
					var _v2 = _v0.a;
					var liste = _v0.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								nW: $elm$core$Maybe$Just(
									_Utils_update(
										liste,
										{Dj: '', g7: false}))
							}),
						_List_fromArray(
							[
								$author$project$Components$Parametrage$NouveauChamp$Update$PlacerFocus($author$project$Components$Parametrage$NouveauChamp$Formulaire$idDuNomDeListe)
							]));
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$NouveauChamp$Model$typesDuBack = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.J_;
			},
			model.ew));
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$valeurNouvelleListe = 'nouvelle-liste';
var $author$project$Components$Parametrage$NouveauChamp$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var ouverture = msg.a;
				return A2($author$project$Components$Parametrage$NouveauChamp$Update$ouvrir, ouverture, model);
			case 1:
				var octets = msg.a;
				return $author$project$Components$Parametrage$NouveauChamp$Update$envoyerLaSuite(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}));
			case 2:
				var reponse = msg.a;
				return A2($author$project$Components$Parametrage$NouveauChamp$Update$listesLues, reponse, model);
			case 3:
				var geste = msg.a;
				return ($author$project$API$Envoi$enCours(model.l2) && A2(
					$elm$core$List$member,
					geste,
					_List_fromArray(
						[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$SortieDemandee, $author$project$Components$Shared$Drawer$Update$AbandonConfirme]))) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Parametrage$NouveauChamp$Update$versLeDrawerDuChamp, geste, model);
			case 4:
				if (msg.a.$ === 5) {
					var choix = msg.a.a;
					return _Utils_eq(choix, $author$project$Components$Parametrage$NouveauChamp$Formulaire$valeurNouvelleListe) ? A2(
						$author$project$Components$Parametrage$NouveauChamp$Update$versLeDrawerDeLaListe,
						$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Parametrage$NouveauChamp$Formulaire$idDuNomDeListe),
						_Utils_update(
							model,
							{
								nW: $elm$core$Maybe$Just($author$project$Components$Parametrage$NouveauChamp$Formulaire$listeACreerVide)
							})) : _Utils_Tuple2(
						_Utils_update(
							model,
							{
								uw: A2(
									$elm$core$Maybe$map,
									A2(
										$author$project$Components$Parametrage$NouveauChamp$Formulaire$saisir,
										$author$project$Components$Parametrage$NouveauChamp$Model$typesDuBack(model),
										$author$project$Components$Parametrage$NouveauChamp$Formulaire$ListeChoisie(choix)),
									model.uw)
							}),
						_List_Nil);
				} else {
					var geste = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								uw: A2(
									$elm$core$Maybe$map,
									A2(
										$author$project$Components$Parametrage$NouveauChamp$Formulaire$saisir,
										$author$project$Components$Parametrage$NouveauChamp$Model$typesDuBack(model),
										geste),
									model.uw)
							}),
						_List_Nil);
				}
			case 5:
				return $author$project$Components$Parametrage$NouveauChamp$Update$enregistrer(model);
			case 6:
				return _Utils_Tuple2(model, _List_Nil);
			case 7:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(
						_List_fromArray(
							[$author$project$Components$Parametrage$NouveauChamp$Update$VersLeRattachement])),
					A2($author$project$Components$Parametrage$NouveauChamp$Update$versLeDrawerDuChamp, $author$project$Components$Shared$Drawer$Update$Fermer, model));
			case 8:
				return $author$project$Components$Parametrage$NouveauChamp$Update$autreNom(model);
			case 9:
				return $author$project$Components$Parametrage$NouveauChamp$Update$rattacherLExistant(model);
			case 10:
				var geste = msg.a;
				return A2($author$project$Components$Parametrage$NouveauChamp$Update$versLeDrawerDeLaListe, geste, model);
			case 11:
				var geste = msg.a;
				return A2($author$project$Components$Parametrage$NouveauChamp$Update$surLaListe, geste, model);
			case 12:
				return $author$project$Components$Parametrage$NouveauChamp$Update$creerLaListe(model);
			default:
				var reponse = msg.a;
				var _v1 = A3($author$project$API$Envoi$conclure, $author$project$Components$Parametrage$NouveauChamp$Update$reglageDEnvoi, reponse, model.l2);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var envoi = _v2.a;
					var issue = _v2.b;
					var effets = _v2.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Parametrage$NouveauChamp$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$surLeNouveauChamp = F2(
	function (geste, model) {
		return function (_v0) {
			var nouveauChamp = _v0.a;
			var effets = _v0.b;
			return A3(
				$elm$core$List$foldl,
				$author$project$Components$Produits$StructureCatalogue$Informations$Update$depuisLeNouveauChamp,
				_Utils_Tuple2(
					_Utils_update(
						model,
						{oP: nouveauChamp}),
					_List_Nil),
				effets);
		}(
			A2($author$project$Components$Parametrage$NouveauChamp$Update$update, geste, model.oP));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$nouveauChampPret = function (model) {
	var _v0 = _Utils_Tuple2(model.oR, model.oQ);
	if (_v0.a && (!_v0.b.$)) {
		var portee = _v0.b.a;
		var _v1 = A2($author$project$Components$Produits$StructureCatalogue$Informations$Model$lienDeCreation, portee, model.AM);
		if (!_v1.$) {
			var lien = _v1.a;
			return A2(
				$author$project$Components$Produits$StructureCatalogue$Informations$Update$surLeNouveauChamp,
				$author$project$Components$Parametrage$NouveauChamp$Update$Ouvert(
					{
						un: $elm$core$Maybe$Nothing,
						uY: A2($elm$core$Maybe$withDefault, _List_Nil, model.dq),
						vE: _List_Nil,
						R: {fs: $author$project$I18n$Textes$produitsParcoursInformationsCreerAction, Dj: $author$project$I18n$Textes$produitsParcoursInformationsCreerNom, JR: $author$project$I18n$Textes$produitsParcoursInformationsCreerType},
						Bz: lien,
						BF: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$listes, model.nS),
						F$: 'catalogue',
						F1: true,
						c0: $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$porteurDeCreation(portee),
						pN: A2(
							$elm$core$Maybe$map,
							function (lienDeRattachement) {
								return {
									f$: $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$porteurDeRattachement(portee),
									nB: lienDeRattachement
								};
							},
							A2($author$project$Components$Produits$StructureCatalogue$Informations$Model$lienDeRattachement, portee, model.AM)),
						aO: $author$project$I18n$Traductions$tel(''),
						h6: $author$project$I18n$Textes$produitsParcoursInformationsCreerTitre,
						ib: _List_Nil,
						J_: model.J_,
						sb: model.sc
					}),
				_Utils_update(
					model,
					{oR: false}));
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{oR: false}),
				_List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Etats$Model$nouvelEtatValide = function (saisie) {
	return A2(
		$elm$core$Maybe$map,
		function (libelles) {
			return {
				vx: $elm$core$Maybe$Nothing,
				R: $elm$core$Maybe$Just(libelles)
			};
		},
		$author$project$Components$Produits$StructureCatalogue$Saisie$libellesSaisis(saisie));
};
var $author$project$Components$Produits$StructureCatalogue$Etats$Update$saisirLeNouvelEtat = F2(
	function (saisir, model) {
		return _Utils_update(
			model,
			{
				a9: saisir(model.a9)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Etats$Update$nouvelDemande = function (model) {
	var _v0 = _Utils_Tuple2(
		$author$project$Components$Produits$StructureCatalogue$Etats$Model$nouvelEtatValide(model.a9),
		model.h$);
	_v0$2:
	while (true) {
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var nouveau = _v0.a.a;
				var structure = _v0.b.a;
				return A2(
					$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$DefinirLesEtats(
						_Utils_ap(
							$author$project$Components$Produits$StructureCatalogue$Etats$Model$etatsADefinir(structure.mj),
							_List_fromArray(
								[nouveau]))),
					_Utils_update(
						model,
						{aL: $elm$core$Maybe$Nothing}));
			} else {
				break _v0$2;
			}
		} else {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				return $author$project$Components$Produits$StructureCatalogue$Etats$Update$definissable(model) ? _Utils_Tuple2(
					A2(
						$author$project$Components$Produits$StructureCatalogue$Etats$Update$saisirLeNouvelEtat,
						function (saisie) {
							return _Utils_update(
								saisie,
								{b5: true});
						},
						model),
					_List_fromArray(
						[
							$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus($author$project$Components$Produits$StructureCatalogue$Etats$Model$idDuNouvelEtat)
						])) : _Utils_Tuple2(model, _List_Nil);
			} else {
				break _v0$2;
			}
		}
	}
	return _Utils_Tuple2(model, _List_Nil);
};
var $author$project$Components$Produits$StructureCatalogue$Etats$Update$nouvelLibelleSaisi = F3(
	function (langue, texte, model) {
		return _Utils_Tuple2(
			A2(
				$author$project$Components$Produits$StructureCatalogue$Etats$Update$saisirLeNouvelEtat,
				A2($author$project$Components$Produits$StructureCatalogue$Saisie$saisir, langue, texte),
				model),
			_List_Nil);
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$CreerUneListeDuChamp = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$nouvelleListeDemandee = function (model) {
	if (!$author$project$Components$Shared$Drawer$Model$estOuvert(model.T)) {
		return _Utils_Tuple2(model, _List_Nil);
	} else {
		var _v0 = $author$project$Components$Produits$StructureCatalogue$Saisie$libellesSaisis(model.am);
		if (!_v0.$) {
			var libelles = _v0.a;
			return A2(
				$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$CreerUneListeDuChamp(libelles.zX),
				_Utils_update(
					model,
					{aL: $elm$core$Maybe$Nothing}));
		} else {
			var saisie = model.am;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						am: _Utils_update(
							saisie,
							{b5: true})
					}),
				_List_fromArray(
					[
						$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus($author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$idDuLibelleDeListe)
					]));
		}
	}
};
var $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$idDuSelecteurDeListe = 'information-liste';
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$nouvelleListeOuverte = function (model) {
	var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUneListe, model.nS);
	if (!_v0.$) {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Informations$Update$versLaNouvelleListe,
			$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$idDuSelecteurDeListe),
			_Utils_update(
				model,
				{am: $author$project$Components$Produits$StructureCatalogue$Saisie$vide, df: ''}));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$obligationBasculee = F2(
	function (obligatoire, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{c_: obligatoire}),
			_List_Nil);
	});
var $author$project$Components$Produits$StructureCatalogue$Marques$Update$OrdreDemande = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Marques$Update$OrdreDesGammesDemande = F3(
	function (a, b, c) {
		return {$: 11, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$gammeDe = function (cle) {
	if (cle.$ === 3) {
		var id = cle.a;
		return $elm$core$Maybe$Just(id);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$gammesVoulues = function (ordre) {
	var _v0 = ordre.F$;
	if (_v0.$ === 3) {
		var niveau = _v0.a.os;
		var marque = _v0.a.gX;
		var freres = _v0.a.aB;
		var voulues = A2(
			$elm$core$List$filterMap,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.dy;
				},
				$author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$gammeDe),
			ordre.gV);
		return $elm$core$Maybe$Just(
			{
				yk: _Utils_eq(voulues, freres),
				gX: marque,
				os: niveau,
				KW: voulues
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$marqueDe = function (cle) {
	if (cle.$ === 2) {
		var id = cle.a;
		return $elm$core$Maybe$Just(id);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$remplir = F3(
	function (active, voulues, freres) {
		if (!freres.b) {
			return _List_Nil;
		} else {
			var frere = freres.a;
			var reste = freres.b;
			if (active(frere)) {
				if (voulues.b) {
					var prochaine = voulues.a;
					var suivantes = voulues.b;
					return A2(
						$elm$core$List$cons,
						prochaine,
						A3($author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$remplir, active, suivantes, reste));
				} else {
					return A2(
						$elm$core$List$cons,
						frere,
						A3($author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$remplir, active, _List_Nil, reste));
				}
			} else {
				return A2(
					$elm$core$List$cons,
					frere,
					A3($author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$remplir, active, voulues, reste));
			}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$marquesVoulues = function (ordre) {
	var _v0 = ordre.F$;
	if (_v0.$ === 2) {
		var freres = _v0.a.aB;
		var voulues = A2(
			$elm$core$List$filterMap,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.dy;
				},
				$author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$marqueDe),
			ordre.gV);
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(
				freres,
				A3(
					$author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$remplir,
					function (id) {
						return A2($elm$core$List$member, id, voulues);
					},
					voulues,
					freres)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$DeplacerUneValeur = F2(
	function (a, b) {
		return {$: 21, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$OrdonnerLesNoeuds = F3(
	function (a, b, c) {
		return {$: 29, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$parcourir = F4(
	function (parent, rang, cible, courant) {
		parcourir:
		while (true) {
			if (!cible.b) {
				return _List_Nil;
			} else {
				var voulue = cible.a;
				var suite = cible.b;
				if (_Utils_eq(
					$elm$core$List$head(
						A2($elm$core$List$drop, rang, courant)),
					$elm$core$Maybe$Just(voulue))) {
					var $temp$parent = parent,
						$temp$rang = rang + 1,
						$temp$cible = suite,
						$temp$courant = courant;
					parent = $temp$parent;
					rang = $temp$rang;
					cible = $temp$cible;
					courant = $temp$courant;
					continue parcourir;
				} else {
					return A2(
						$elm$core$List$cons,
						{ey: parent, bY: rang, fm: voulue},
						A4(
							$author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$parcourir,
							parent,
							rang + 1,
							suite,
							_Utils_ap(
								A2($elm$core$List$take, rang, courant),
								A2(
									$elm$core$List$cons,
									voulue,
									A2(
										$elm$core$List$filter,
										$elm$core$Basics$neq(voulue),
										A2($elm$core$List$drop, rang, courant))))));
				}
			}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$valeurDe = function (cle) {
	if (!cle.$) {
		var id = cle.a;
		return $elm$core$Maybe$Just(id);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$deplacements = F3(
	function (lignes, parent, freres) {
		var voulues = A2(
			$elm$core$List$filterMap,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.dy;
				},
				$author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$valeurDe),
			lignes);
		var cible = A3(
			$author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$remplir,
			function (id) {
				return A2($elm$core$List$member, id, voulues);
			},
			voulues,
			freres);
		return A4($author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$parcourir, parent, 0, cible, freres);
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$noeudDe = function (cle) {
	if (cle.$ === 1) {
		var id = cle.a;
		return $elm$core$Maybe$Just(id);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$commandes = function (ordre) {
	var _v0 = ordre.F$;
	switch (_v0.$) {
		case 0:
			var parent = _v0.a.ey;
			var freres = _v0.a.aB;
			return A2(
				$elm$core$List$map,
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$DeplacerUneValeur(ordre.vj),
				A3($author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$deplacements, ordre.gV, parent, freres));
		case 2:
			return _List_Nil;
		case 3:
			return _List_Nil;
		default:
			var parent = _v0.a.ey;
			var freres = _v0.a.aB;
			var voulus = A2(
				$elm$core$List$filterMap,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.dy;
					},
					$author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$noeudDe),
				ordre.gV);
			var cible = A3(
				$author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$remplir,
				function (id) {
					return A2($elm$core$List$member, id, voulus);
				},
				voulus,
				freres);
			return _Utils_eq(cible, freres) ? _List_Nil : _List_fromArray(
				[
					A3($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$OrdonnerLesNoeuds, ordre.vj, parent, cible)
				]);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$ordreDemande = function (model) {
	var _v0 = model.El;
	if (!_v0.$) {
		var ordre = _v0.a;
		var _v1 = $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$commandes(ordre);
		if (!_v1.b) {
			return A2(
				$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$versLeDrawerDOrdre,
				$author$project$Components$Shared$Drawer$Update$Fermer,
				_Utils_update(
					model,
					{oK: $elm$core$Maybe$Nothing}));
		} else {
			var places = _v1;
			return A2(
				$author$project$Components$Produits$StructureCatalogue$Commandes$enchainer,
				places,
				_Utils_update(
					model,
					{p1: $elm$core$Maybe$Nothing}));
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Effet$PourLesMarques = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$DepuisLaColonne = $elm$core$Basics$identity;
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$attendre = F3(
	function (valeur, cible, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					iy: $elm$core$Maybe$Nothing,
					pl: $elm$core$Maybe$Just(
						{vf: cible, fm: valeur})
				}),
			$author$project$Components$Produits$StructureCatalogue$Commandes$relire(model));
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$apresLaCreationDUneMarque = F2(
	function (marque, model) {
		var _v0 = model.iy;
		if (!_v0.$) {
			var aPlacer = _v0.a;
			return A3(
				$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$attendre,
				$author$project$Catalogue$API$QueryAPIModel$ValeurElement(marque),
				aPlacer,
				model);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$Common$Effet$DemanderProcessUid = {$: 0};
var $author$project$Components$Produits$Common$Effet$Envoyer = F3(
	function (a, b, c) {
		return {$: 16, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$Common$Effet$Reconnecter = {$: 19};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$AutreRefus = {$: 77};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ChampsInvalides = function (a) {
	return {$: 66, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$EcritureConcurrente = {$: 20};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$Introuvable = {$: 19};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$champsInvalides = function (reponse) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (champ, vus) {
				return A2($elm$core$List$member, champ, vus) ? vus : _Utils_ap(
					vus,
					_List_fromArray(
						[champ]));
			}),
		_List_Nil,
		A2(
			$elm$core$List$filterMap,
			$elm$core$List$head,
			A2(
				$elm$core$Result$withDefault,
				_List_Nil,
				A2(
					$elm$json$Json$Decode$decodeString,
					A2(
						$elm$json$Json$Decode$field,
						'errors',
						$elm$json$Json$Decode$list(
							A2(
								$elm$json$Json$Decode$field,
								'path',
								$elm$json$Json$Decode$list($elm$json$Json$Decode$string)))),
					reponse.f$))));
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$AttributsRefuses = function (a) {
	return {$: 36, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$AvecReferencesActives = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ChampDejaDansLaBibliotheque = function (a) {
	return {$: 25, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ChampHorsPortee = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ChampNonFichier = function (a) {
	return {$: 57, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$CheminIncomplet = function (a) {
	return {$: 42, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$CibleIntrouvable = function (a) {
	return {$: 55, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$CleDejaUtilisee = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$CodeDejaPris = function (a) {
	return {$: 31, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ConflitDePublic = F3(
	function (_public, liste, fin) {
		return {mI: fin, nW: liste, pF: _public};
	});
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ConversionEnCours = function (a) {
	return {$: 54, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$CritereDePerimetreInconnu = {$: 15};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$CritereRefuse = function (a) {
	return {$: 52, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$Defaut = F2(
	function (champ, code) {
		return {uN: champ, vx: code};
	});
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$DefautDeValeur = F3(
	function (champ, code, libelle) {
		return {uN: champ, vx: code, Bl: libelle};
	});
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$DefinitionDUnChampPartage = function (a) {
	return {$: 28, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$DeuxValeursPourUnEtage = function (a) {
	return {$: 46, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$EtageHorsDeLaPortee = function (a) {
	return {$: 74, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$EtageHorsPortee = function (a) {
	return {$: 29, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$EvolutionNonAdditive = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$FiltrableNonAdmis = function (a) {
	return {$: 27, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$FiltreDePerimetreNonConvertible = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$FiltreDePerimetreVide = {$: 13};
var $author$project$API$Liens$Lien = F3(
	function (rel, href, verbe) {
		return {cM: href, eP: rel, sm: verbe};
	});
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ListePubliqueDejaDefinie = function (a) {
	return {$: 61, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$MarqueArchiveeDeMemeNom = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$NiveauDeSaisieDifferent = function (a) {
	return {$: 75, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$NiveauDeSaisieFige = function (a) {
	return {$: 30, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$NomDePerimetrePris = {$: 12};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$OccurrenceInexistante = function (a) {
	return {$: 40, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$PlaceHorsDuDernierEtage = function (a) {
	return {$: 67, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$PorteDesElements = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ProduitAvecReferencesActives = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$PublicDejaCouvert = function (a) {
	return {$: 60, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$RefusDeChamp = F4(
	function (champ, code, langue, codeRefuse) {
		return {uN: champ, vx: code, vA: codeRefuse, nn: langue};
	});
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$RegleDeCodeRefusee = function (a) {
	return {$: 58, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$SchemaInvalide = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$TypeDeFichierRefuse = function (a) {
	return {$: 56, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$TypeEnDouble = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$UneSeuleOccurrence = function (a) {
	return {$: 37, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ValeurDeGroupeEnDouble = function (a) {
	return {$: 38, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ValeurNonCreee = function (a) {
	return {$: 39, a: a};
};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ValeurRefusee = function (a) {
	return {$: 76, a: a};
};
var $author$project$Catalogue$API$PrixAPIModel$ListeNommee = F2(
	function (id, nom) {
		return {Aq: id, Dj: nom};
	});
var $author$project$Catalogue$Identifiants$listeDePrixIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Catalogue$API$PrixAPIModel$listeNommeeDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Catalogue$API$PrixAPIModel$ListeNommee,
	A2($elm$json$Json$Decode$field, 'id', $author$project$Catalogue$Identifiants$listeDePrixIdDecoder),
	A2($elm$json$Json$Decode$field, 'nom', $author$project$Catalogue$API$QueryAPIModel$libellesDecoder));
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$OrigineDUnChamp = F3(
	function (genre, id, nom) {
		return {M: genre, Aq: id, Dj: nom};
	});
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$origineDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$OrigineDUnChamp,
	A2($elm$json$Json$Decode$field, 'genre', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string));
var $author$project$Catalogue$API$PrixAPIModel$RefDePublic = F2(
	function (type_, uid) {
		return {r0: type_, r8: uid};
	});
var $author$project$Catalogue$API$PrixAPIModel$refDePublicDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Catalogue$API$PrixAPIModel$RefDePublic,
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string));
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$AucuneCategorieChoisie = {$: 48};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$CategorieNonFabriquee = {$: 50};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$CategorieNonProposable = {$: 49};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ChampInconnu = {$: 24};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$CheminDifferentDuProduit = {$: 43};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$CheminInconnu = {$: 44};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$DejaArchive = {$: 17};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$DejaArretee = {$: 51};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$DejaExistant = {$: 18};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$EnDouble = {$: 0};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$EtatInconnu = {$: 33};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$FicheVerrouillee = {$: 53};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$FichierIndisponible = {$: 59};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$NiveauInconnu = {$: 9};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$NiveauNonUtilise = {$: 8};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$NomRequis = {$: 32};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$OrdreInvalide = {$: 16};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ParentArchive = {$: 6};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$PeriodeInvalide = {$: 63};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$PorteeInvalide = {$: 73};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$PublicRefuse = {$: 64};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$RattachementHorsHierarchie = {$: 11};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$RattachementRequis = {$: 10};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ReferenceArreteeALAjout = {$: 62};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ReferenceIntrouvable = {$: 65};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$SousUneMarqueArchivee = {$: 7};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$TypeDeProduitArchive = {$: 35};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$TypeDifferentDuProduit = {$: 34};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$TypeHorsDeLaTypologie = {$: 70};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$TypologieAChoisir = {$: 69};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$TypologieRequise = {$: 68};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ValeurArchivee = {$: 72};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ValeurDeCheminArchivee = {$: 47};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ValeurEnTrop = {$: 45};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ValeurInconnue = {$: 71};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ValeurNonProposable = {$: 41};
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$sansContenu = _List_fromArray(
	[
		_Utils_Tuple2('MarqueEnDouble', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$EnDouble),
		_Utils_Tuple2('GammeEnDouble', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$EnDouble),
		_Utils_Tuple2('ParentArchive', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ParentArchive),
		_Utils_Tuple2('MarqueArchivee', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$SousUneMarqueArchivee),
		_Utils_Tuple2('NiveauNonUtilise', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$NiveauNonUtilise),
		_Utils_Tuple2('NiveauInconnu', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$NiveauInconnu),
		_Utils_Tuple2('RattachementRequis', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$RattachementRequis),
		_Utils_Tuple2('RattachementHorsHierarchie', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$RattachementHorsHierarchie),
		_Utils_Tuple2('OrdreDesGammesInvalide', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$OrdreInvalide),
		_Utils_Tuple2('MarqueDejaArchivee', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$DejaArchive),
		_Utils_Tuple2('GammeDejaArchivee', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$DejaArchive),
		_Utils_Tuple2('MarqueDejaExistante', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$DejaExistant),
		_Utils_Tuple2('GammeDejaExistante', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$DejaExistant),
		_Utils_Tuple2('TypeEnDouble', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$EnDouble),
		_Utils_Tuple2('TypeDejaExistant', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$DejaExistant),
		_Utils_Tuple2('ChampInconnu', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ChampInconnu),
		_Utils_Tuple2('OrdreInvalide', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$OrdreInvalide),
		_Utils_Tuple2('NomRequis', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$NomRequis),
		_Utils_Tuple2('EtatInconnu', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$EtatInconnu),
		_Utils_Tuple2('TypeDifferentDuProduit', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$TypeDifferentDuProduit),
		_Utils_Tuple2('TypeDeProduitArchive', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$TypeDeProduitArchive),
		_Utils_Tuple2('RattachementArchive', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ParentArchive),
		_Utils_Tuple2('ValeurNonProposable', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ValeurNonProposable),
		_Utils_Tuple2('CheminInconnu', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$CheminInconnu),
		_Utils_Tuple2('ValeurEnTrop', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ValeurEnTrop),
		_Utils_Tuple2('CheminDifferentDuProduit', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$CheminDifferentDuProduit),
		_Utils_Tuple2('ValeurDeCheminArchivee', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ValeurDeCheminArchivee),
		_Utils_Tuple2('AucuneCategorieChoisie', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$AucuneCategorieChoisie),
		_Utils_Tuple2('CategorieNonProposable', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$CategorieNonProposable),
		_Utils_Tuple2('CategorieNonFabriquee', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$CategorieNonFabriquee),
		_Utils_Tuple2('ReferenceDejaArretee', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$DejaArretee),
		_Utils_Tuple2('FicheVerrouillee', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$FicheVerrouillee),
		_Utils_Tuple2('FichierIndisponible', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$FichierIndisponible),
		_Utils_Tuple2('TypeDejaArchive', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$DejaArchive),
		_Utils_Tuple2('ReferenceDejaExistante', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$DejaExistant),
		_Utils_Tuple2('ProduitDejaExistant', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$DejaExistant),
		_Utils_Tuple2('ListeDejaExistante', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$DejaExistant),
		_Utils_Tuple2('ReferenceArretee', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ReferenceArreteeALAjout),
		_Utils_Tuple2('PeriodeInvalide', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$PeriodeInvalide),
		_Utils_Tuple2('PublicRefuse', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$PublicRefuse),
		_Utils_Tuple2('ReferenceIntrouvable', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ReferenceIntrouvable),
		_Utils_Tuple2('TypologieRequise', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$TypologieRequise),
		_Utils_Tuple2('TypologieAChoisir', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$TypologieAChoisir),
		_Utils_Tuple2('TypeHorsDeLaTypologie', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$TypeHorsDeLaTypologie),
		_Utils_Tuple2('ValeurInconnue', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ValeurInconnue),
		_Utils_Tuple2('ValeurArchivee', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ValeurArchivee),
		_Utils_Tuple2('PorteeInvalide', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$PorteeInvalide),
		_Utils_Tuple2('ValeurDEtageInconnue', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ValeurInconnue),
		_Utils_Tuple2('ValeurDEtageArchivee', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ValeurArchivee)
	]);
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$duDomaine = $elm$json$Json$Decode$oneOf(
	A2(
		$elm$core$List$cons,
		A2(
			$elm$json$Json$Decode$field,
			'GammeAvecReferencesActives',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$AvecReferencesActives,
				A2($elm$json$Json$Decode$field, 'referencesActives', $elm$json$Json$Decode$int))),
		A2(
			$elm$core$List$cons,
			A2(
				$elm$json$Json$Decode$field,
				'ProduitAvecReferencesActives',
				A2(
					$elm$json$Json$Decode$map,
					$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ProduitAvecReferencesActives,
					A2($elm$json$Json$Decode$field, 'referencesActives', $elm$json$Json$Decode$int))),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$json$Json$Decode$field,
					'MarquePorteDesGammes',
					A2(
						$elm$json$Json$Decode$map,
						$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$PorteDesElements,
						A2($elm$json$Json$Decode$field, 'gammes', $elm$json$Json$Decode$int))),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$json$Json$Decode$field,
						'GammePorteDesGammes',
						A2(
							$elm$json$Json$Decode$map,
							$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$PorteDesElements,
							A2($elm$json$Json$Decode$field, 'gammes', $elm$json$Json$Decode$int))),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$json$Json$Decode$field,
							'MarqueArchiveeDeMemeNom',
							A6(
								$elm$json$Json$Decode$map5,
								F5(
									function (existante, archiveeLe, gammes, references, restaurer) {
										return $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$MarqueArchiveeDeMemeNom(
											{tJ: archiveeLe, y1: existante, gG: gammes, hD: references, HS: restaurer});
									}),
								A2($elm$json$Json$Decode$field, 'existante', $author$project$Catalogue$Identifiants$elementIdDecoder),
								$elm$json$Json$Decode$maybe(
									A2($elm$json$Json$Decode$field, 'archiveeLe', $elm$json$Json$Decode$string)),
								A2($elm$json$Json$Decode$field, 'gammes', $elm$json$Json$Decode$int),
								A2($elm$json$Json$Decode$field, 'references', $elm$json$Json$Decode$int),
								A2(
									$elm$json$Json$Decode$field,
									'restaurer',
									A4(
										$elm$json$Json$Decode$map3,
										$author$project$API$Liens$Lien,
										A2($elm$json$Json$Decode$field, 'rel', $elm$json$Json$Decode$string),
										A2($elm$json$Json$Decode$field, 'href', $elm$json$Json$Decode$string),
										A2($elm$json$Json$Decode$field, 'verbe', $elm$json$Json$Decode$string))))),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$json$Json$Decode$field,
								'TypeEnDouble',
								A3(
									$elm$json$Json$Decode$map2,
									F2(
										function (existant, archive) {
											return $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$TypeEnDouble(
												{tE: archive, y0: existant});
										}),
									A2($elm$json$Json$Decode$field, 'existant', $author$project$Catalogue$Identifiants$typeDeProduitIdDecoder),
									A2($elm$json$Json$Decode$field, 'archive', $elm$json$Json$Decode$bool))),
							A2(
								$elm$core$List$cons,
								A2(
									$elm$json$Json$Decode$field,
									'CleDejaUtilisee',
									A2(
										$elm$json$Json$Decode$map,
										$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$CleDejaUtilisee,
										A2($elm$json$Json$Decode$field, 'cle', $elm$json$Json$Decode$string))),
								A2(
									$elm$core$List$cons,
									A2(
										$elm$json$Json$Decode$field,
										'EvolutionNonAdditive',
										A3(
											$elm$json$Json$Decode$map2,
											F2(
												function (cle, raison) {
													return $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$EvolutionNonAdditive(
														{dy: cle, pH: raison});
												}),
											A2($elm$json$Json$Decode$field, 'cle', $elm$json$Json$Decode$string),
											A2($elm$json$Json$Decode$field, 'raison', $elm$json$Json$Decode$string))),
									A2(
										$elm$core$List$cons,
										A2(
											$elm$json$Json$Decode$field,
											'SchemaInvalide',
											A2(
												$elm$json$Json$Decode$map,
												$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$SchemaInvalide,
												A2(
													$elm$json$Json$Decode$field,
													'defauts',
													$elm$json$Json$Decode$list(
														A3(
															$elm$json$Json$Decode$map2,
															$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$Defaut,
															A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
															A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string)))))),
										A2(
											$elm$core$List$cons,
											A2(
												$elm$json$Json$Decode$field,
												'ReferenceEnDouble',
												A2(
													$elm$json$Json$Decode$map,
													$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$CodeDejaPris,
													$elm$json$Json$Decode$maybe(
														A2($elm$json$Json$Decode$field, $author$project$Catalogue$Vocabulaire$champDeLaMarque, $author$project$Catalogue$Identifiants$elementIdDecoder)))),
											A2(
												$elm$core$List$cons,
												A2(
													$elm$json$Json$Decode$field,
													'NomDePerimetreDejaUtilise',
													$elm$json$Json$Decode$succeed($author$project$Components$Produits$Common$API$WriteAPIErrorsModel$NomDePerimetrePris)),
												A2(
													$elm$core$List$cons,
													A2(
														$elm$json$Json$Decode$field,
														'FiltreVide',
														$elm$json$Json$Decode$succeed($author$project$Components$Produits$Common$API$WriteAPIErrorsModel$FiltreDePerimetreVide)),
													A2(
														$elm$core$List$cons,
														A2(
															$elm$json$Json$Decode$field,
															'FiltreNonConvertible',
															A2(
																$elm$json$Json$Decode$map,
																$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$FiltreDePerimetreNonConvertible,
																A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string))),
														A2(
															$elm$core$List$cons,
															A2(
																$elm$json$Json$Decode$field,
																'ValeurDeCritereInconnue',
																$elm$json$Json$Decode$succeed($author$project$Components$Produits$Common$API$WriteAPIErrorsModel$CritereDePerimetreInconnu)),
															A2(
																$elm$core$List$cons,
																A2(
																	$elm$json$Json$Decode$field,
																	'AttributsRefuses',
																	A2(
																		$elm$json$Json$Decode$map,
																		$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$AttributsRefuses,
																		A2(
																			$elm$json$Json$Decode$field,
																			'refus',
																			$elm$json$Json$Decode$list(
																				A5(
																					$elm$json$Json$Decode$map4,
																					$author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$RefusDeChamp,
																					A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
																					A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
																					$elm$json$Json$Decode$maybe(
																						A2($elm$json$Json$Decode$field, 'langue', $elm$json$Json$Decode$string)),
																					$elm$json$Json$Decode$maybe(
																						A2($elm$json$Json$Decode$field, 'codeRefuse', $elm$json$Json$Decode$string))))))),
																A2(
																	$elm$core$List$cons,
																	A2(
																		$elm$json$Json$Decode$field,
																		'UneSeuleOccurrence',
																		A2(
																			$elm$json$Json$Decode$map,
																			$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$UneSeuleOccurrence,
																			A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string))),
																	A2(
																		$elm$core$List$cons,
																		A2(
																			$elm$json$Json$Decode$field,
																			'CritereRefuse',
																			A2(
																				$elm$json$Json$Decode$map,
																				$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$CritereRefuse,
																				A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string))),
																		A2(
																			$elm$core$List$cons,
																			A2(
																				$elm$json$Json$Decode$field,
																				'ValeurDeGroupeEnDouble',
																				A4(
																					$elm$json$Json$Decode$map3,
																					F3(
																						function (champ, sousChamp, valeur) {
																							return $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ValeurDeGroupeEnDouble(
																								{uN: champ, IW: sousChamp, fm: valeur});
																						}),
																					A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
																					A2($elm$json$Json$Decode$field, 'sousChamp', $elm$json$Json$Decode$string),
																					A2($elm$json$Json$Decode$field, 'valeur', $elm$json$Json$Decode$string))),
																			A2(
																				$elm$core$List$cons,
																				A2(
																					$elm$json$Json$Decode$field,
																					'ValeurNonCreee',
																					A2(
																						$elm$json$Json$Decode$map,
																						$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ValeurNonCreee,
																						A2($elm$json$Json$Decode$field, 'liste', $elm$json$Json$Decode$string))),
																				A2(
																					$elm$core$List$cons,
																					A2(
																						$elm$json$Json$Decode$field,
																						'OccurrenceInexistante',
																						A2(
																							$elm$json$Json$Decode$map,
																							$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$OccurrenceInexistante,
																							A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string))),
																					A2(
																						$elm$core$List$cons,
																						A2(
																							$elm$json$Json$Decode$field,
																							'ChampDejaDansLaBibliotheque',
																							A2(
																								$elm$json$Json$Decode$map,
																								$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ChampDejaDansLaBibliotheque,
																								A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string))),
																						A2(
																							$elm$core$List$cons,
																							A2(
																								$elm$json$Json$Decode$field,
																								'ChampHorsPortee',
																								A4(
																									$elm$json$Json$Decode$map3,
																									F3(
																										function (champ, portee, origine) {
																											return $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ChampHorsPortee(
																												{uN: champ, o4: origine, F$: portee});
																										}),
																									A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
																									A2($elm$json$Json$Decode$field, 'portee', $elm$json$Json$Decode$string),
																									$elm$json$Json$Decode$maybe(
																										A2($elm$json$Json$Decode$field, 'origine', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$origineDecoder)))),
																							A2(
																								$elm$core$List$cons,
																								A2(
																									$elm$json$Json$Decode$field,
																									'FiltrableNonAdmis',
																									A2(
																										$elm$json$Json$Decode$map,
																										$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$FiltrableNonAdmis,
																										A2($elm$json$Json$Decode$field, 'typeDeChamp', $elm$json$Json$Decode$string))),
																								A2(
																									$elm$core$List$cons,
																									A2(
																										$elm$json$Json$Decode$field,
																										'DefinitionDUnChampPartage',
																										A2(
																											$elm$json$Json$Decode$map,
																											$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$DefinitionDUnChampPartage,
																											A2($elm$json$Json$Decode$field, 'cle', $elm$json$Json$Decode$string))),
																									A2(
																										$elm$core$List$cons,
																										A2(
																											$elm$json$Json$Decode$field,
																											'EtageHorsDeLaPortee',
																											A2(
																												$elm$json$Json$Decode$map,
																												$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$EtageHorsDeLaPortee,
																												A2($elm$json$Json$Decode$field, 'etage', $elm$json$Json$Decode$string))),
																										A2(
																											$elm$core$List$cons,
																											A2(
																												$elm$json$Json$Decode$field,
																												'NiveauDeSaisieDifferent',
																												A2(
																													$elm$json$Json$Decode$map,
																													$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$NiveauDeSaisieDifferent,
																													A2(
																														$elm$json$Json$Decode$field,
																														'niveaux',
																														$elm$json$Json$Decode$list($elm$json$Json$Decode$string)))),
																											A2(
																												$elm$core$List$cons,
																												A2(
																													$elm$json$Json$Decode$field,
																													'ValeurRefusee',
																													A2(
																														$elm$json$Json$Decode$map,
																														$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ValeurRefusee,
																														A2(
																															$elm$json$Json$Decode$field,
																															'refus',
																															$elm$json$Json$Decode$list(
																																A4(
																																	$elm$json$Json$Decode$map3,
																																	$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$DefautDeValeur,
																																	A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
																																	A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
																																	$elm$json$Json$Decode$maybe(
																																		A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string))))))),
																												A2(
																													$elm$core$List$cons,
																													A2(
																														$elm$json$Json$Decode$field,
																														'EtageHorsPortee',
																														A2(
																															$elm$json$Json$Decode$map,
																															$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$EtageHorsPortee,
																															A2($elm$json$Json$Decode$field, 'etage', $elm$json$Json$Decode$string))),
																													A2(
																														$elm$core$List$cons,
																														A2(
																															$elm$json$Json$Decode$field,
																															'NiveauDeSaisieFige',
																															A4(
																																$elm$json$Json$Decode$map3,
																																F3(
																																	function (etage, valeurs, exemple) {
																																		return $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$NiveauDeSaisieFige(
																																			{md: etage, yY: exemple, Ki: valeurs});
																																	}),
																																A2($elm$json$Json$Decode$field, 'etage', $elm$json$Json$Decode$string),
																																A2($elm$json$Json$Decode$field, 'valeurs', $elm$json$Json$Decode$int),
																																$elm$json$Json$Decode$maybe(
																																	A2($elm$json$Json$Decode$field, 'exemple', $elm$json$Json$Decode$string)))),
																														A2(
																															$elm$core$List$cons,
																															A2(
																																$elm$json$Json$Decode$field,
																																'ConversionEnCours',
																																A2(
																																	$elm$json$Json$Decode$map,
																																	$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ConversionEnCours,
																																	A2($elm$json$Json$Decode$field, 'cle', $elm$json$Json$Decode$string))),
																															A2(
																																$elm$core$List$cons,
																																A2(
																																	$elm$json$Json$Decode$field,
																																	'CibleIntrouvable',
																																	A2(
																																		$elm$json$Json$Decode$map,
																																		$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$CibleIntrouvable,
																																		A2($elm$json$Json$Decode$field, 'cible', $elm$json$Json$Decode$string))),
																																A2(
																																	$elm$core$List$cons,
																																	A2(
																																		$elm$json$Json$Decode$field,
																																		'TypeDeFichierRefuse',
																																		A2(
																																			$elm$json$Json$Decode$map,
																																			$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$TypeDeFichierRefuse,
																																			A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string))),
																																	A2(
																																		$elm$core$List$cons,
																																		A2(
																																			$elm$json$Json$Decode$field,
																																			'ChampNonFichier',
																																			A2(
																																				$elm$json$Json$Decode$map,
																																				$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ChampNonFichier,
																																				A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string))),
																																		A2(
																																			$elm$core$List$cons,
																																			A2(
																																				$elm$json$Json$Decode$field,
																																				'RegleDeCodeRefusee',
																																				A4(
																																					$elm$json$Json$Decode$map3,
																																					F3(
																																						function (segment, motif, champ) {
																																							return $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$RegleDeCodeRefusee(
																																								{uN: champ, cX: motif, Ix: segment});
																																						}),
																																					$elm$json$Json$Decode$maybe(
																																						A2($elm$json$Json$Decode$field, 'segment', $elm$json$Json$Decode$int)),
																																					A2($elm$json$Json$Decode$field, 'motif', $elm$json$Json$Decode$string),
																																					$elm$json$Json$Decode$maybe(
																																						A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string)))),
																																			A2(
																																				$elm$core$List$cons,
																																				A2(
																																					$elm$json$Json$Decode$field,
																																					'PublicDejaCouvert',
																																					A2(
																																						$elm$json$Json$Decode$map,
																																						$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$PublicDejaCouvert,
																																						A2(
																																							$elm$json$Json$Decode$field,
																																							'conflits',
																																							$elm$json$Json$Decode$list(
																																								A4(
																																									$elm$json$Json$Decode$map3,
																																									$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ConflitDePublic,
																																									A2($elm$json$Json$Decode$field, 'public', $author$project$Catalogue$API$PrixAPIModel$refDePublicDecoder),
																																									A2($elm$json$Json$Decode$field, 'liste', $author$project$Catalogue$API$PrixAPIModel$listeNommeeDecoder),
																																									A2($elm$json$Json$Decode$field, 'fin', $elm$json$Json$Decode$string)))))),
																																				A2(
																																					$elm$core$List$cons,
																																					A2(
																																						$elm$json$Json$Decode$field,
																																						'CheminIncomplet',
																																						A2(
																																							$elm$json$Json$Decode$map,
																																							$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$CheminIncomplet,
																																							A2(
																																								$elm$json$Json$Decode$field,
																																								'etagesManquants',
																																								$elm$json$Json$Decode$list($elm$json$Json$Decode$string)))),
																																					A2(
																																						$elm$core$List$cons,
																																						A2(
																																							$elm$json$Json$Decode$field,
																																							'DeuxValeursPourUnEtage',
																																							A2(
																																								$elm$json$Json$Decode$map,
																																								$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$DeuxValeursPourUnEtage,
																																								A2($elm$json$Json$Decode$field, 'etage', $elm$json$Json$Decode$string))),
																																						A2(
																																							$elm$core$List$cons,
																																							A2(
																																								$elm$json$Json$Decode$field,
																																								'PlaceHorsDuDernierEtage',
																																								A2(
																																									$elm$json$Json$Decode$map,
																																									$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$PlaceHorsDuDernierEtage,
																																									A2($elm$json$Json$Decode$field, 'etagesLibres', $elm$json$Json$Decode$int))),
																																							A2(
																																								$elm$core$List$cons,
																																								A2(
																																									$elm$json$Json$Decode$field,
																																									'ListePubliqueDejaDefinie',
																																									A3(
																																										$elm$json$Json$Decode$map2,
																																										F2(
																																											function (liste, fin) {
																																												return $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ListePubliqueDejaDefinie(
																																													{mI: fin, nW: liste});
																																											}),
																																										A2($elm$json$Json$Decode$field, 'liste', $author$project$Catalogue$API$PrixAPIModel$listeNommeeDecoder),
																																										A2($elm$json$Json$Decode$field, 'fin', $elm$json$Json$Decode$string))),
																																								A2(
																																									$elm$core$List$map,
																																									function (_v0) {
																																										var nom = _v0.a;
																																										var erreur = _v0.b;
																																										return A2(
																																											$elm$json$Json$Decode$field,
																																											nom,
																																											$elm$json$Json$Decode$succeed(erreur));
																																									},
																																									$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$sansContenu)))))))))))))))))))))))))))))))))))))))));
var $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$duRefus = function (reponse) {
	var _v0 = A2(
		$elm$json$Json$Decode$decodeString,
		A2($elm$json$Json$Decode$field, 'error', $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$duDomaine),
		reponse.f$);
	if (!_v0.$) {
		var erreur = _v0.a;
		return erreur;
	} else {
		return ((reponse.ri === 400) && (!_Utils_eq(
			$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$champsInvalides(reponse),
			_List_Nil))) ? $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ChampsInvalides(
			$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$champsInvalides(reponse)) : ((reponse.ri === 409) ? $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$EcritureConcurrente : ((reponse.ri === 404) ? $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$Introuvable : $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$AutreRefus));
	}
};
var $author$project$Components$Produits$Common$Envoi$memesValeurs = F2(
	function (voulues, faites) {
		return _Utils_eq(
			$elm$core$List$length(voulues),
			$elm$core$List$length(faites)) && A2(
			$elm$core$List$all,
			function (valeur) {
				return A2($elm$core$List$member, valeur, faites);
			},
			voulues);
	});
var $author$project$Components$Produits$Common$Envoi$porte = F2(
	function (cle, valeurs) {
		return A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$first,
				$elm$core$Basics$eq(cle)),
			valeurs);
	});
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$canonique = function (champ) {
	return _Utils_update(
		champ,
		{
			bq: $elm$core$List$sort(champ.bq),
			R: $elm$core$List$sort(champ.R),
			Bt: $elm$core$List$sort(
				A2(
					$elm$core$List$map,
					$elm$core$Tuple$mapSecond($elm$core$List$sort),
					champ.Bt)),
			r0: function () {
				var _v0 = champ.r0;
				if (_v0.$ === 10) {
					var mesure = _v0.a;
					return $author$project$Components$Shared$EditeurDeSchema$Champ$AvecUnite(
						_Utils_update(
							mesure,
							{
								iF: $elm$core$List$sort(mesure.iF)
							}));
				} else {
					var autre = _v0;
					return autre;
				}
			}()
		});
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$equivalents = F2(
	function (un, autre) {
		return _Utils_eq(
			$author$project$Components$Shared$EditeurDeSchema$Champ$canonique(un),
			$author$project$Components$Shared$EditeurDeSchema$Champ$canonique(autre));
	});
var $author$project$Components$Produits$Common$Envoi$repondALEvolution = F2(
	function (voulue, faite) {
		return _Utils_eq(
			$elm$core$List$length(voulue.fx),
			$elm$core$List$length(faite.fx)) && (A2(
			$elm$core$List$all,
			$elm$core$Basics$identity,
			A3($elm$core$List$map2, $author$project$Components$Shared$EditeurDeSchema$Champ$equivalents, voulue.fx, faite.fx)) && A2(
			$elm$core$List$all,
			function (modifie) {
				return A2(
					$elm$core$List$any,
					$author$project$Components$Shared$EditeurDeSchema$Champ$equivalents(modifie),
					voulue.g$);
			},
			faite.g$));
	});
var $author$project$Components$Produits$Common$Envoi$repond = F2(
	function (commande, evenement) {
		var _v0 = _Utils_Tuple2(commande, evenement);
		_v0$77:
		while (true) {
			_v0$78:
			while (true) {
				switch (_v0.a.$) {
					case 15:
						var _v1 = _v0.a;
						return true;
					case 16:
						var _v2 = _v0.a;
						return true;
					case 0:
						switch (_v0.b.$) {
							case 0:
								var voulue = _v0.a.a;
								var _v3 = _v0.b;
								var faite = _v3.b;
								return _Utils_eq(voulue, faite);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 1:
						switch (_v0.b.$) {
							case 1:
								var _v4 = _v0.a;
								var voulue = _v4.a;
								var marque = _v4.b;
								var _v5 = _v0.b;
								var faite = _v5.a;
								var nom = _v5.b;
								return _Utils_eq(voulue, faite) && _Utils_eq(marque.Dj, nom);
							case 2:
								var _v6 = _v0.a;
								var voulue = _v6.a;
								var marque = _v6.b;
								var _v7 = _v0.b;
								var faite = _v7.a;
								var sousLicence = _v7.b;
								return _Utils_eq(voulue, faite) && _Utils_eq(marque.IY, sousLicence);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 2:
						switch (_v0.b.$) {
							case 3:
								var voulue = _v0.a.a;
								var faite = _v0.b.a;
								return _Utils_eq(voulue, faite);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 3:
						switch (_v0.b.$) {
							case 4:
								var voulue = _v0.a.a;
								var faite = _v0.b.a;
								return _Utils_eq(voulue, faite);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 4:
						switch (_v0.b.$) {
							case 5:
								var voulue = _v0.a.a;
								var _v8 = _v0.b;
								var faite = _v8.b;
								return _Utils_eq(
									_Utils_update(
										voulue,
										{gX: $elm$core$Maybe$Nothing}),
									faite);
							case 9:
								var voulue = _v0.a.a;
								var _v9 = _v0.b;
								var marque = _v9.b;
								return _Utils_eq(
									voulue.gX,
									$elm$core$Maybe$Just(marque));
							case 11:
								var voulue = _v0.a.a;
								return _Utils_eq(voulue.gX, $elm$core$Maybe$Nothing);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 5:
						switch (_v0.b.$) {
							case 6:
								var _v10 = _v0.a;
								var voulue = _v10.a;
								var gamme = _v10.b;
								var _v11 = _v0.b;
								var faite = _v11.a;
								var libelles = _v11.b;
								return _Utils_eq(voulue, faite) && _Utils_eq(gamme.R, libelles);
							case 7:
								var _v12 = _v0.a;
								var voulue = _v12.a;
								var gamme = _v12.b;
								var _v13 = _v0.b;
								var faite = _v13.a;
								var millesime = _v13.b;
								return _Utils_eq(voulue, faite) && _Utils_eq(gamme.n8, millesime);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 6:
						switch (_v0.b.$) {
							case 8:
								var voulue = _v0.a.a;
								var faite = _v0.b.a;
								return _Utils_eq(voulue, faite);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 7:
						switch (_v0.b.$) {
							case 9:
								var _v14 = _v0.a;
								var voulue = _v14.a;
								var marque = _v14.b;
								var _v15 = _v0.b;
								var faite = _v15.a;
								var rattachee = _v15.b;
								return _Utils_eq(voulue, faite) && _Utils_eq(marque, rattachee);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 8:
						switch (_v0.b.$) {
							case 10:
								var _v16 = _v0.a;
								var voulue = _v16.a;
								var marque = _v16.b;
								var _v17 = _v0.b;
								var faite = _v17.a;
								var retiree = _v17.b;
								return _Utils_eq(voulue, faite) && _Utils_eq(marque, retiree);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 9:
						switch (_v0.b.$) {
							case 11:
								var voulue = _v0.a.a;
								var faite = _v0.b.a;
								return _Utils_eq(voulue, faite);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 10:
						switch (_v0.b.$) {
							case 12:
								var voulu = _v0.a.a;
								var fait = _v0.b.a;
								return _Utils_eq(voulu.os, fait.os) && (_Utils_eq(voulu.ey, fait.ey) && _Utils_eq(
									A2(
										$elm$core$List$filter,
										function (gamme) {
											return A2($elm$core$List$member, gamme, voulu.El);
										},
										fait.El),
									voulu.El));
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 11:
						switch (_v0.b.$) {
							case 13:
								var _v18 = _v0.a;
								var niveau = _v18.a;
								var voulu = _v18.b;
								var _v19 = _v0.b;
								var ceNiveau = _v19.a;
								var fait = _v19.b;
								return _Utils_eq(niveau, ceNiveau) && _Utils_eq(voulu, fait);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 12:
						switch (_v0.b.$) {
							case 14:
								var voulu = _v0.a.a;
								var _v20 = _v0.b;
								var fait = _v20.b;
								return _Utils_eq(voulu, fait);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 13:
						switch (_v0.b.$) {
							case 15:
								var _v21 = _v0.a;
								var voulue = _v21.b;
								var _v22 = _v0.b;
								var faite = _v22.b;
								return A2($author$project$Components$Produits$Common$Envoi$repondALEvolution, voulue, faite);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 14:
						switch (_v0.b.$) {
							case 15:
								var _v23 = _v0.a;
								var _v24 = _v0.b;
								return true;
							case 18:
								var _v25 = _v0.a;
								var reglages = _v25.c;
								var _v26 = _v0.b;
								var niveau = _v26.b;
								return _Utils_eq(niveau, reglages.g4);
							case 16:
								var _v27 = _v0.a;
								var reglages = _v27.c;
								return reglages.n4;
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 19:
						switch (_v0.b.$) {
							case 16:
								var _v28 = _v0.a;
								var voulu = _v28.b;
								var fait = _v0.b.a;
								return _Utils_eq(voulu, fait);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 20:
						switch (_v0.b.$) {
							case 17:
								var _v29 = _v0.a;
								var voulu = _v29.a;
								var portee = _v29.b;
								var _v30 = _v0.b;
								var fait = _v30.a;
								var faite = _v30.b;
								return _Utils_eq(voulu, fait) && _Utils_eq(portee, faite);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 21:
						switch (_v0.b.$) {
							case 18:
								var _v31 = _v0.a;
								var voulu = _v31.b;
								var lecture = _v31.c;
								var _v32 = _v0.b;
								var fait = _v32.a;
								var niveau = _v32.b;
								return _Utils_eq(voulu, fait) && _Utils_eq(lecture, niveau);
							case 21:
								var _v33 = _v0.a;
								var voulu = _v33.b;
								var saisie = _v33.d;
								var _v34 = _v0.b;
								var fait = _v34.a;
								var etage = _v34.b;
								return _Utils_eq(voulu, fait) && _Utils_eq(saisie, etage);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 22:
						switch (_v0.b.$) {
							case 24:
								var _v35 = _v0.a;
								var voulu = _v35.b;
								var valeurs = _v35.c;
								var _v36 = _v0.b;
								var fait = _v36.a;
								var faites = _v36.b;
								return _Utils_eq(voulu, fait) && _Utils_eq(
									$elm$core$List$sort(valeurs),
									$elm$core$List$sort(faites));
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 23:
						switch (_v0.b.$) {
							case 25:
								var _v37 = _v0.a;
								var voulu = _v37.b;
								var fait = _v0.b.a;
								return _Utils_eq(voulu, fait);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 24:
						switch (_v0.b.$) {
							case 26:
								var _v38 = _v0.a;
								var _v39 = _v0.b;
								return true;
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 25:
						switch (_v0.b.$) {
							case 27:
								var _v40 = _v0.a;
								var voulu = _v40.a;
								var filtrable = _v40.b;
								var _v41 = _v0.b;
								var fait = _v41.a;
								var regle = _v41.b;
								return _Utils_eq(voulu, fait) && _Utils_eq(filtrable, regle);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 26:
						switch (_v0.b.$) {
							case 28:
								var _v42 = _v0.a;
								var voulu = _v42.a;
								var recherchable = _v42.b;
								var _v43 = _v0.b;
								var fait = _v43.a;
								var regle = _v43.b;
								return _Utils_eq(voulu, fait) && _Utils_eq(recherchable, regle);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 27:
						switch (_v0.b.$) {
							case 29:
								var _v44 = _v0.a;
								var cle = _v44.b;
								var voulus = _v44.c;
								var _v45 = _v0.b;
								var fait = _v45.a;
								var faits = _v45.b;
								return _Utils_eq(cle, fait) && _Utils_eq(voulus, faits);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 28:
						switch (_v0.b.$) {
							case 30:
								var _v46 = _v0.a;
								var voulu = _v46.b;
								var fait = _v0.b.a;
								return _Utils_eq(voulu, fait);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 29:
						switch (_v0.b.$) {
							case 31:
								var _v47 = _v0.a;
								var voulu = _v47.b;
								var fait = _v0.b.a;
								return _Utils_eq(voulu, fait);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 30:
						switch (_v0.b.$) {
							case 32:
								var _v48 = _v0.a;
								var ou = _v48.a;
								var voulue = _v48.b;
								var _v49 = _v0.b;
								var la = _v49.a;
								var faite = _v49.c;
								return _Utils_eq(ou, la) && A2($author$project$Components$Produits$Common$Envoi$repondALEvolution, voulue, faite);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 31:
						switch (_v0.b.$) {
							case 33:
								var _v50 = _v0.a;
								var ou = _v50.a;
								var voulu = _v50.b;
								var _v51 = _v0.b;
								var la = _v51.a;
								var fait = _v51.b;
								return _Utils_eq(ou, la) && _Utils_eq(voulu, fait);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 32:
						switch (_v0.b.$) {
							case 34:
								var _v52 = _v0.a;
								var ou = _v52.a;
								var voulu = _v52.b;
								var _v53 = _v0.b;
								var la = _v53.a;
								var fait = _v53.b;
								return _Utils_eq(ou, la) && _Utils_eq(voulu, fait);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 33:
						switch (_v0.b.$) {
							case 35:
								var _v54 = _v0.a;
								var ou = _v54.a;
								var voulu = _v54.b;
								var _v55 = _v0.b;
								var la = _v55.a;
								var fait = _v55.b;
								return _Utils_eq(ou, la) && _Utils_eq(voulu, fait);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 34:
						switch (_v0.b.$) {
							case 36:
								var voulu = _v0.a.a;
								var _v56 = _v0.b;
								var fait = _v56.b;
								return _Utils_eq(
									_Utils_update(
										voulu,
										{Ki: _List_Nil}),
									fait);
							case 50:
								var voulu = _v0.a.a;
								var _v57 = _v0.b;
								var faites = _v57.b;
								return A2(
									$elm$core$List$all,
									function (valeur) {
										return A2($elm$core$List$member, valeur, faites);
									},
									voulu.Ki);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 35:
						switch (_v0.b.$) {
							case 50:
								var _v58 = _v0.a;
								var voulues = _v58.b;
								var _v59 = _v0.b;
								var faites = _v59.b;
								return A2($author$project$Components$Produits$Common$Envoi$memesValeurs, voulues, faites);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 36:
						switch (_v0.b.$) {
							case 51:
								var voulu = _v0.a.a;
								var fait = _v0.b.a;
								return _Utils_eq(voulu, fait);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 39:
						switch (_v0.b.$) {
							case 38:
								var _v60 = _v0.a;
								return true;
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 37:
						switch (_v0.b.$) {
							case 37:
								var voulue = _v0.a.a;
								var _v61 = _v0.b;
								var faite = _v61.b;
								return _Utils_eq(
									_Utils_update(
										voulue,
										{i8: _List_Nil, r3: $elm$core$Maybe$Nothing, Ki: _List_Nil}),
									faite);
							case 49:
								var voulue = _v0.a.a;
								var faites = _v0.b.a;
								return A2($author$project$Components$Produits$Common$Envoi$memesValeurs, voulue.Ki, faites);
							case 39:
								var voulue = _v0.a.a;
								var _v62 = _v0.b;
								var cle = _v62.a;
								return A2($author$project$Components$Produits$Common$Envoi$porte, cle, voulue.i8);
							case 40:
								var voulue = _v0.a.a;
								var _v63 = _v0.b;
								var cle = _v63.a;
								return A2($author$project$Components$Produits$Common$Envoi$porte, cle, voulue.i8);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 49:
						switch (_v0.b.$) {
							case 39:
								var _v66 = _v0.a;
								var champ = _v66.b;
								var _v67 = _v0.b;
								var cle = _v67.a;
								return _Utils_eq(champ, cle);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 50:
						switch (_v0.b.$) {
							case 39:
								var _v68 = _v0.a;
								var champ = _v68.b;
								var _v69 = _v0.b;
								var cle = _v69.a;
								return _Utils_eq(champ, cle);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 51:
						switch (_v0.b.$) {
							case 39:
								var _v70 = _v0.a;
								var champ = _v70.b;
								var _v71 = _v0.b;
								var cle = _v71.a;
								return _Utils_eq(champ, cle);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 44:
						switch (_v0.b.$) {
							case 39:
								var _v72 = _v0.a;
								var _v73 = _v0.b;
								return true;
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 45:
						switch (_v0.b.$) {
							case 39:
								var _v74 = _v0.a;
								var _v75 = _v0.b;
								return true;
							case 46:
								var _v76 = _v0.a;
								var champ = _v76.b;
								var cle = _v0.b.a;
								return _Utils_eq(champ, cle);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 46:
						switch (_v0.b.$) {
							case 45:
								var _v77 = _v0.a;
								var champ = _v77.b;
								var cle = _v0.b.a;
								return _Utils_eq(champ, cle);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 38:
						switch (_v0.b.$) {
							case 39:
								var _v64 = _v0.a;
								var voulus = _v64.b;
								var _v65 = _v0.b;
								var cle = _v65.a;
								return A2($author$project$Components$Produits$Common$Envoi$porte, cle, voulus);
							case 40:
								var _v78 = _v0.a;
								var voulus = _v78.b;
								var _v79 = _v0.b;
								var cle = _v79.a;
								return A2($author$project$Components$Produits$Common$Envoi$porte, cle, voulus);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 40:
						switch (_v0.b.$) {
							case 41:
								var _v80 = _v0.a;
								var voulu = _v80.b;
								var fait = _v0.b.a;
								return _Utils_eq(voulu, fait);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 41:
						switch (_v0.b.$) {
							case 42:
								var _v81 = _v0.a;
								var voulu = _v81.b;
								var fait = _v0.b.a;
								return _Utils_eq(voulu, $elm$core$Maybe$Nothing) || _Utils_eq(
									voulu,
									$elm$core$Maybe$Just(fait));
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 42:
						switch (_v0.b.$) {
							case 43:
								var _v82 = _v0.a;
								var voulue = _v82.b;
								var _v83 = _v0.b;
								var faite = _v83.a;
								return _Utils_eq(voulue, faite);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 43:
						switch (_v0.b.$) {
							case 44:
								var _v84 = _v0.b;
								return true;
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 47:
						switch (_v0.b.$) {
							case 47:
								var _v85 = _v0.a;
								var voulu = _v85.b;
								var fichier = _v85.c;
								var _v86 = _v0.b;
								var fait = _v86.a;
								var rattache = _v86.b;
								return _Utils_eq(voulu, fait) && _Utils_eq(fichier, rattache);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 48:
						switch (_v0.b.$) {
							case 48:
								var _v87 = _v0.a;
								var voulu = _v87.b;
								var fait = _v0.b.a;
								return _Utils_eq(voulu, fait);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 52:
						switch (_v0.b.$) {
							case 49:
								var _v88 = _v0.a;
								var voulues = _v88.b;
								var faites = _v0.b.a;
								return A2($author$project$Components$Produits$Common$Envoi$memesValeurs, voulues, faites);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 54:
						switch (_v0.b.$) {
							case 52:
								var _v89 = _v0.b;
								return true;
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 55:
						switch (_v0.b.$) {
							case 53:
								var _v90 = _v0.a;
								var voulue = _v90.b;
								var faite = _v0.b.a;
								return _Utils_eq(voulue, faite);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 58:
						switch (_v0.b.$) {
							case 55:
								var _v91 = _v0.a;
								var voulu = _v91.b;
								var fait = _v0.b.a;
								return _Utils_eq(voulu, fait);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 59:
						switch (_v0.b.$) {
							case 56:
								var voulue = _v0.a.a;
								var _v92 = _v0.b;
								var faite = _v92.b;
								return _Utils_eq(voulue, faite);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 60:
						switch (_v0.b.$) {
							case 57:
								var _v93 = _v0.a;
								var voulu = _v93.b;
								var fait = _v0.b.a;
								return _Utils_eq(voulu.Hc, fait.Hc) && (_Utils_eq(voulu.oi, fait.oi) && _Utils_eq(voulu.sa, fait.sa));
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 61:
						switch (_v0.b.$) {
							case 58:
								var _v94 = _v0.a;
								var voulue = _v94.b;
								var faite = _v0.b.a;
								return _Utils_eq(voulue, faite);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 62:
						switch (_v0.b.$) {
							case 59:
								var _v95 = _v0.a;
								var voulus = _v95.b;
								var faits = _v0.b.a;
								return A2(
									$elm$core$List$all,
									function (_public) {
										return A2($elm$core$List$member, _public, faits);
									},
									voulus) && _Utils_eq(
									$elm$core$List$length(voulus),
									$elm$core$List$length(faits));
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 64:
						switch (_v0.b.$) {
							case 22:
								var _v96 = _v0.a;
								var valeurs = _v96.b;
								var pose = _v0.b.a;
								return A2(
									$elm$core$List$any,
									function (_v97) {
										var champ = _v97.a;
										return _Utils_eq(champ, pose);
									},
									valeurs);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 65:
						switch (_v0.b.$) {
							case 23:
								var _v98 = _v0.a;
								var champ = _v98.b;
								var retire = _v0.b.a;
								return _Utils_eq(champ, retire);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 17:
						switch (_v0.b.$) {
							case 19:
								var _v99 = _v0.a;
								var voulu = _v99.b;
								var fait = _v0.b.a;
								return _Utils_eq(voulu, fait);
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 18:
						switch (_v0.b.$) {
							case 20:
								var _v100 = _v0.b;
								return true;
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					case 63:
						switch (_v0.b.$) {
							case 60:
								if (_v0.a.b) {
									var _v101 = _v0.a;
									var _v102 = _v0.b;
									return true;
								} else {
									break _v0$78;
								}
							case 61:
								if (!_v0.a.b) {
									var _v103 = _v0.a;
									var _v104 = _v0.b;
									return true;
								} else {
									break _v0$78;
								}
							case 62:
								break _v0$77;
							default:
								break _v0$78;
						}
					default:
						if (_v0.b.$ === 62) {
							break _v0$77;
						} else {
							break _v0$78;
						}
				}
			}
			return false;
		}
		var _v105 = _v0.b;
		return true;
	});
var $author$project$Components$Produits$Common$Envoi$legsDUneGamme = F3(
	function (commande, evenements, evenement) {
		var _v0 = _Utils_Tuple2(commande, evenement);
		_v0$4:
		while (true) {
			if (_v0.b.$ === 9) {
				switch (_v0.a.$) {
					case 4:
						var _v1 = _v0.b;
						return A2(
							$elm$core$List$any,
							$author$project$Components$Produits$Common$Envoi$repond(commande),
							evenements);
					case 7:
						var _v2 = _v0.a;
						var _v3 = _v0.b;
						return A2(
							$elm$core$List$any,
							$author$project$Components$Produits$Common$Envoi$repond(commande),
							evenements);
					case 8:
						var _v4 = _v0.a;
						var _v5 = _v0.b;
						return A2(
							$elm$core$List$any,
							$author$project$Components$Produits$Common$Envoi$repond(commande),
							evenements);
					case 9:
						var _v6 = _v0.b;
						return A2(
							$elm$core$List$any,
							$author$project$Components$Produits$Common$Envoi$repond(commande),
							evenements);
					default:
						break _v0$4;
				}
			} else {
				break _v0$4;
			}
		}
		return false;
	});
var $author$project$Components$Produits$Common$Envoi$repondA = F2(
	function (commande, evenements) {
		return A2(
			$elm$core$List$all,
			function (evenement) {
				return A2($author$project$Components$Produits$Common$Envoi$repond, commande, evenement) || A3($author$project$Components$Produits$Common$Envoi$legsDUneGamme, commande, evenements, evenement);
			},
			evenements);
	});
var $author$project$Catalogue$API$WriteAPIModel$ReponseDeCommande = F3(
	function (evenements, liens, vuesAJour) {
		return {mk: evenements, nQ: liens, sy: vuesAJour};
	});
var $author$project$Catalogue$API$WriteAPIModel$EvenementInconnu = {$: 62};
var $author$project$Catalogue$API$WriteAPIModel$GammesOrdonnees = function (a) {
	return {$: 12, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$MarquesOrdonnees = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$PerimetreCreeDepuisUnFiltre = function (a) {
	return {$: 38, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$PorteeChangee = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$GammeArchivee = function (a) {
	return {$: 8, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$GammeCreee = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$GammeDetachee = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$GammeOuverteAToutesLesMarques = function (a) {
	return {$: 11, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$GammeRattachee = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$GammeRenommee = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$MarqueArchivee = function (a) {
	return {$: 3, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$MarqueCreee = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$MarqueRenommee = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$MarqueRestauree = function (a) {
	return {$: 4, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$MillesimeDeLaGammeChange = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$NatureDeLaMarqueChangee = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$ProduitArchive = function (a) {
	return {$: 51, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$ProduitCree = F2(
	function (a, b) {
		return {$: 36, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$ProduitRestreint = F2(
	function (a, b) {
		return {$: 50, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$deLElement = function () {
	var millesime = $elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'millesime', $elm$json$Json$Decode$string));
	var libelles = A2($elm$json$Json$Decode$field, 'libelles', $author$project$Catalogue$API$QueryAPIModel$libellesDecoder);
	var deLaMarque = A2($elm$json$Json$Decode$field, $author$project$Catalogue$Vocabulaire$champDeLaMarque, $author$project$Catalogue$Identifiants$elementIdDecoder);
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'MarqueCreee',
				A3(
					$elm$json$Json$Decode$map2,
					F3(
						function (nom, sousLicence, id) {
							return A2(
								$author$project$Catalogue$API$WriteAPIModel$MarqueCreee,
								id,
								{Dj: nom, IY: sousLicence});
						}),
					A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'sousLicence', $elm$json$Json$Decode$bool))),
				A2(
				$elm$json$Json$Decode$field,
				'MarqueRenommee',
				A2(
					$elm$json$Json$Decode$map,
					F2(
						function (nom, id) {
							return A2($author$project$Catalogue$API$WriteAPIModel$MarqueRenommee, id, nom);
						}),
					A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string))),
				A2(
				$elm$json$Json$Decode$field,
				'NatureDeLaMarqueChangee',
				A2(
					$elm$json$Json$Decode$map,
					F2(
						function (sousLicence, id) {
							return A2($author$project$Catalogue$API$WriteAPIModel$NatureDeLaMarqueChangee, id, sousLicence);
						}),
					A2($elm$json$Json$Decode$field, 'sousLicence', $elm$json$Json$Decode$bool))),
				A2(
				$elm$json$Json$Decode$field,
				'MarqueArchivee',
				$elm$json$Json$Decode$succeed($author$project$Catalogue$API$WriteAPIModel$MarqueArchivee)),
				A2(
				$elm$json$Json$Decode$field,
				'MarqueRestauree',
				$elm$json$Json$Decode$succeed($author$project$Catalogue$API$WriteAPIModel$MarqueRestauree)),
				A2(
				$elm$json$Json$Decode$field,
				'GammeCreee',
				A5(
					$elm$json$Json$Decode$map4,
					F5(
						function (niveau, parent, lus, annee, id) {
							return A2(
								$author$project$Catalogue$API$WriteAPIModel$GammeCreee,
								id,
								{R: lus, gX: $elm$core$Maybe$Nothing, n8: annee, os: niveau, ey: parent});
						}),
					A2($elm$json$Json$Decode$field, 'niveau', $author$project$Catalogue$Identifiants$niveauIdDecoder),
					$elm$json$Json$Decode$maybe(
						A2($elm$json$Json$Decode$field, 'parent', $author$project$Catalogue$Identifiants$elementIdDecoder)),
					libelles,
					millesime)),
				A2(
				$elm$json$Json$Decode$field,
				'GammeRenommee',
				A2(
					$elm$json$Json$Decode$map,
					F2(
						function (lus, id) {
							return A2($author$project$Catalogue$API$WriteAPIModel$GammeRenommee, id, lus);
						}),
					libelles)),
				A2(
				$elm$json$Json$Decode$field,
				'MillesimeDeLaGammeChange',
				A2(
					$elm$json$Json$Decode$map,
					F2(
						function (annee, id) {
							return A2($author$project$Catalogue$API$WriteAPIModel$MillesimeDeLaGammeChange, id, annee);
						}),
					millesime)),
				A2(
				$elm$json$Json$Decode$field,
				'GammeArchivee',
				$elm$json$Json$Decode$succeed($author$project$Catalogue$API$WriteAPIModel$GammeArchivee)),
				A2(
				$elm$json$Json$Decode$field,
				'GammeRattachee',
				A2(
					$elm$json$Json$Decode$map,
					F2(
						function (marque, id) {
							return A2($author$project$Catalogue$API$WriteAPIModel$GammeRattachee, id, marque);
						}),
					deLaMarque)),
				A2(
				$elm$json$Json$Decode$field,
				'GammeDetachee',
				A2(
					$elm$json$Json$Decode$map,
					F2(
						function (marque, id) {
							return A2($author$project$Catalogue$API$WriteAPIModel$GammeDetachee, id, marque);
						}),
					deLaMarque)),
				A2(
				$elm$json$Json$Decode$field,
				'GammeOuverteAToutesLesMarques',
				$elm$json$Json$Decode$succeed($author$project$Catalogue$API$WriteAPIModel$GammeOuverteAToutesLesMarques)),
				A2(
				$elm$json$Json$Decode$field,
				'ProduitArchive',
				$elm$json$Json$Decode$succeed($author$project$Catalogue$API$WriteAPIModel$ProduitArchive)),
				A2(
				$elm$json$Json$Decode$field,
				'ProduitRestreint',
				A2(
					$elm$json$Json$Decode$map,
					F2(
						function (valeurs, id) {
							return A2($author$project$Catalogue$API$WriteAPIModel$ProduitRestreint, id, valeurs);
						}),
					A2(
						$elm$json$Json$Decode$field,
						'valeurs',
						$elm$json$Json$Decode$list($author$project$Catalogue$API$WriteAPIModel$valeurDuDessusDecoder)))),
				A2(
				$elm$json$Json$Decode$field,
				'ProduitCree',
				A4(
					$elm$json$Json$Decode$map3,
					F4(
						function (type_, parent, lus, id) {
							return A2(
								$author$project$Catalogue$API$WriteAPIModel$ProduitCree,
								id,
								{R: lus, ey: parent, fh: type_, Ki: _List_Nil});
						}),
					A2($elm$json$Json$Decode$field, 'typeDeProduit', $author$project$Catalogue$Identifiants$typeDeProduitIdDecoder),
					$elm$json$Json$Decode$maybe(
						A2($elm$json$Json$Decode$field, 'parent', $author$project$Catalogue$Identifiants$elementIdDecoder)),
					libelles))
			]));
}();
var $author$project$Catalogue$API$WriteAPIModel$ListeDePrixACreer = F5(
	function (nom, publics, devise, taxes, validite) {
		return {kO: devise, Dj: nom, GA: publics, rB: taxes, sk: validite};
	});
var $author$project$Catalogue$API$WriteAPIModel$ListeDePrixCreee = F2(
	function (a, b) {
		return {$: 56, a: a, b: b};
	});
var $author$project$Catalogue$API$PrixAPIModel$Exonerees = {$: 0};
var $author$project$Catalogue$API$PrixAPIModel$HorsTaxe = function (a) {
	return {$: 1, a: a};
};
var $author$project$Catalogue$API$PrixAPIModel$ToutesTaxesComprises = function (a) {
	return {$: 2, a: a};
};
var $author$project$Catalogue$API$PrixAPIModel$taxesDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (regime) {
		return _Utils_eq(regime, $author$project$Catalogue$Vocabulaire$taxesExonerees) ? $elm$json$Json$Decode$succeed($author$project$Catalogue$API$PrixAPIModel$Exonerees) : (_Utils_eq(regime, $author$project$Catalogue$Vocabulaire$taxesHorsTaxe) ? A2(
			$elm$json$Json$Decode$map,
			$author$project$Catalogue$API$PrixAPIModel$HorsTaxe,
			A2($elm$json$Json$Decode$field, 'taux', $elm$json$Json$Decode$string)) : (_Utils_eq(regime, $author$project$Catalogue$Vocabulaire$taxesToutesTaxesComprises) ? A2(
			$elm$json$Json$Decode$map,
			$author$project$Catalogue$API$PrixAPIModel$ToutesTaxesComprises,
			A2($elm$json$Json$Decode$field, 'taux', $elm$json$Json$Decode$string)) : $elm$json$Json$Decode$fail('taxes')));
	},
	A2($elm$json$Json$Decode$field, 'regime', $elm$json$Json$Decode$string));
var $author$project$Catalogue$API$PrixAPIModel$Validite = F2(
	function (debut, fin) {
		return {ku: debut, mI: fin};
	});
var $author$project$Catalogue$API$PrixAPIModel$validiteDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Catalogue$API$PrixAPIModel$Validite,
	A2($elm$json$Json$Decode$field, 'debut', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'fin', $elm$json$Json$Decode$string));
var $author$project$Catalogue$API$WriteAPIModel$deLaListeDePrixCreee = A2(
	$elm$json$Json$Decode$field,
	'ListeCreee',
	A2(
		$elm$json$Json$Decode$map,
		F2(
			function (creee, id) {
				return A2($author$project$Catalogue$API$WriteAPIModel$ListeDePrixCreee, id, creee);
			}),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'validite',
			$author$project$Catalogue$API$PrixAPIModel$validiteDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'taxes',
				$author$project$Catalogue$API$PrixAPIModel$taxesDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'devise',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'publics',
						$elm$json$Json$Decode$list($author$project$Catalogue$API$PrixAPIModel$refDePublicDecoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'nom',
							$author$project$Catalogue$API$QueryAPIModel$libellesDecoder,
							$elm$json$Json$Decode$succeed($author$project$Catalogue$API$WriteAPIModel$ListeDePrixACreer))))))));
var $author$project$Catalogue$API$WriteAPIModel$ListeRendueNonPublique = {$: 61};
var $author$project$Catalogue$API$WriteAPIModel$ListeRenduePublique = {$: 60};
var $author$project$Catalogue$API$WriteAPIModel$PrixFixe = function (a) {
	return {$: 57, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$PrixRetire = function (a) {
	return {$: 58, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$PublicsChanges = function (a) {
	return {$: 59, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$deLaListeDePrix_ = function () {
	var reference = A2(
		$elm$json$Json$Decode$field,
		$author$project$Catalogue$Vocabulaire$champDeLaReference,
		A2($elm$json$Json$Decode$field, 'uid', $author$project$Catalogue$Identifiants$referenceIdDecoder));
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'PrixFixe',
				A5(
					$elm$json$Json$Decode$map4,
					F4(
						function (id, montant, unite, taxes) {
							return $author$project$Catalogue$API$WriteAPIModel$PrixFixe(
								{oi: montant, Hc: id, rB: taxes, sa: unite});
						}),
					reference,
					A2($elm$json$Json$Decode$field, 'montant', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'unite', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'taxes', $author$project$Catalogue$API$PrixAPIModel$taxesDecoder))),
				A2(
				$elm$json$Json$Decode$field,
				'PrixRetire',
				A2($elm$json$Json$Decode$map, $author$project$Catalogue$API$WriteAPIModel$PrixRetire, reference)),
				A2(
				$elm$json$Json$Decode$field,
				'PublicsChanges',
				A2(
					$elm$json$Json$Decode$map,
					$author$project$Catalogue$API$WriteAPIModel$PublicsChanges,
					A2(
						$elm$json$Json$Decode$field,
						'publics',
						$elm$json$Json$Decode$list($author$project$Catalogue$API$PrixAPIModel$refDePublicDecoder)))),
				A2(
				$elm$json$Json$Decode$field,
				'ListeRenduePublique',
				$elm$json$Json$Decode$succeed($author$project$Catalogue$API$WriteAPIModel$ListeRenduePublique)),
				A2(
				$elm$json$Json$Decode$field,
				'ListeRendueNonPublique',
				$elm$json$Json$Decode$succeed($author$project$Catalogue$API$WriteAPIModel$ListeRendueNonPublique))
			]));
}();
var $author$project$Catalogue$API$WriteAPIModel$ReferenceACreer = function (typeDeProduit) {
	return function (rattachement) {
		return function (nature) {
			return function (code) {
				return function (nom) {
					return function (ean) {
						return function (millesime) {
							return function (variante) {
								return function (etat) {
									return function (valeurs) {
										return function (attributs) {
											return function (typologie) {
												return function (origine) {
													return {i8: attributs, vx: code, lI: ean, gt: etat, n8: millesime, g1: nature, Dj: nom, o4: origine, pN: rattachement, fh: typeDeProduit, r3: typologie, Ki: valeurs, sl: variante};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Catalogue$API$WriteAPIModel$ReferenceCreee = F2(
	function (a, b) {
		return {$: 37, a: a, b: b};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var $author$project$Catalogue$API$WriteAPIModel$deLaReferenceCreee = A2(
	$elm$json$Json$Decode$field,
	'ReferenceCreee',
	A2(
		$elm$json$Json$Decode$map,
		F2(
			function (creee, id) {
				return A2($author$project$Catalogue$API$WriteAPIModel$ReferenceCreee, id, creee);
			}),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'origine',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Identifiants$referenceIdDecoder),
			$elm$core$Maybe$Nothing,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				$elm$core$Maybe$Nothing,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
					_List_Nil,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
						_List_Nil,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'etat',
							$author$project$Catalogue$Identifiants$etatCodeDecoder,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'variante',
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'millesime',
									A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'ean',
										A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'nom',
											A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
											$elm$core$Maybe$Nothing,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'code',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'nature',
													$elm$json$Json$Decode$string,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'rattachement',
														A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Identifiants$elementIdDecoder),
														$elm$core$Maybe$Nothing,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'typeDeProduit',
															$author$project$Catalogue$Identifiants$typeDeProduitIdDecoder,
															$elm$json$Json$Decode$succeed($author$project$Catalogue$API$WriteAPIModel$ReferenceACreer))))))))))))))));
var $author$project$Catalogue$API$WriteAPIModel$AttributModifie = F3(
	function (a, b, c) {
		return {$: 39, a: a, b: b, c: c};
	});
var $author$project$Catalogue$API$WriteAPIModel$AttributTraduit = F4(
	function (a, b, c, d) {
		return {$: 40, a: a, b: b, c: c, d: d};
	});
var $author$project$Catalogue$API$WriteAPIModel$CalculDebraye = function (a) {
	return {$: 45, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$CalculRebranche = function (a) {
	return {$: 46, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$CodeChange = function (a) {
	return {$: 42, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$EtatChange = function (a) {
	return {$: 41, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$FichierRattache = F2(
	function (a, b) {
		return {$: 47, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$FichierRetire = function (a) {
	return {$: 48, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$PlaceDuTypeRetiree = function (a) {
	return {$: 53, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$ReferenceArretee = {$: 44};
var $author$project$Catalogue$API$WriteAPIModel$ReferenceClassee = F2(
	function (a, b) {
		return {$: 43, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$ReferenceRangee = function (a) {
	return {$: 49, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$TypeArchive = {$: 52};
var $author$project$Catalogue$API$WriteAPIModel$TypeRange = function (a) {
	return {$: 54, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$TypeRenomme = function (a) {
	return {$: 55, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Vide = {$: 0};
var $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Adresse = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Booleen = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Nombre = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Occurrence = F2(
	function (uid, valeurs) {
		return {r8: uid, Ki: valeurs};
	});
var $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Occurrences = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Texte = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Textes = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Traductions = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$AdresseDeValeur = F5(
	function (lignes, codePostal, localite, region, pays) {
		return {vz: codePostal, gV: lignes, B_: localite, ho: pays, Hj: region};
	});
var $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$adresse = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$AdresseDeValeur,
	A2(
		$elm$json$Json$Decode$field,
		'lignes',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'codePostal', $elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'localite', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'region', $elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'pays', $elm$json$Json$Decode$string));
var $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Articles = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$ArticlesEtPerimetre = F3(
	function (a, b, c) {
		return {$: 7, a: a, b: b, c: c};
	});
var $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$articles = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (_v0, perimetre) {
			var plusieurs = _v0.a;
			var uids = _v0.b;
			if (!perimetre.$) {
				var lu = perimetre.a;
				return A3($author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$ArticlesEtPerimetre, plusieurs, uids, lu);
			} else {
				return A2($author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Articles, plusieurs, uids);
			}
		}),
	A2(
		$elm$json$Json$Decode$field,
		'articles',
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					function (uid) {
						return _Utils_Tuple2(
							false,
							_List_fromArray(
								[uid]));
					},
					$elm$json$Json$Decode$string),
					A2(
					$elm$json$Json$Decode$map,
					$elm$core$Tuple$pair(true),
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string))
				]))),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'perimetre', $elm$json$Json$Decode$string)));
function $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$cyclic$decoder() {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Vide),
				A2($elm$json$Json$Decode$map, $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Texte, $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$map, $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Nombre, $elm$json$Json$Decode$float),
				A2($elm$json$Json$Decode$map, $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Booleen, $elm$json$Json$Decode$bool),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Textes,
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Occurrences,
				$elm$json$Json$Decode$list(
					$author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$cyclic$occurrence())),
				$author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$articles,
				A2($elm$json$Json$Decode$map, $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Adresse, $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$adresse),
				A2(
				$elm$json$Json$Decode$map,
				function (seule) {
					return $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Occurrences(
						_List_fromArray(
							[seule]));
				},
				$author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$cyclic$occurrence()),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Traductions,
				$elm$json$Json$Decode$keyValuePairs(
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)))
			]));
}
function $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$cyclic$occurrence() {
	return A3(
		$elm$json$Json$Decode$map2,
		$author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Occurrence,
		A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$List$filter(
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$first,
					$elm$core$Basics$neq('uid'))),
			$elm$json$Json$Decode$keyValuePairs(
				$elm$json$Json$Decode$lazy(
					function (_v0) {
						return $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$cyclic$decoder();
					}))));
}
var $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$decoder = $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$cyclic$decoder();
$author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$cyclic$decoder = function () {
	return $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$decoder;
};
var $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$occurrence = $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$cyclic$occurrence();
$author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$cyclic$occurrence = function () {
	return $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$occurrence;
};
var $author$project$Catalogue$API$QueryAPIModel$PlaceDuType = F2(
	function (classification, sous) {
		return {vj: classification, IV: sous};
	});
var $author$project$Catalogue$API$QueryAPIModel$placeDuTypeDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'sous',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Identifiants$valeurIdDecoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'classification',
		$author$project$Catalogue$Identifiants$classificationIdDecoder,
		$elm$json$Json$Decode$succeed($author$project$Catalogue$API$QueryAPIModel$PlaceDuType)));
var $author$project$Catalogue$API$WriteAPIModel$deLaReference_ = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'AttributModifie',
			A4(
				$elm$json$Json$Decode$map3,
				$author$project$Catalogue$API$WriteAPIModel$AttributModifie,
				A2($elm$json$Json$Decode$field, 'cle', $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							A2($elm$json$Json$Decode$field, 'valeur', $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$decoder),
							$elm$json$Json$Decode$succeed($author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Vide)
						])),
				A2($elm$json$Json$Decode$field, 'versionDuSchema', $elm$json$Json$Decode$int))),
			A2(
			$elm$json$Json$Decode$field,
			'AttributTraduit',
			A5(
				$elm$json$Json$Decode$map4,
				$author$project$Catalogue$API$WriteAPIModel$AttributTraduit,
				A2($elm$json$Json$Decode$field, 'cle', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'langue', $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$maybe(
					A2($elm$json$Json$Decode$field, 'texte', $elm$json$Json$Decode$string)),
				A2($elm$json$Json$Decode$field, 'versionDuSchema', $elm$json$Json$Decode$int))),
			A2(
			$elm$json$Json$Decode$field,
			'EtatChange',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Catalogue$API$WriteAPIModel$EtatChange,
				A2($elm$json$Json$Decode$field, 'etat', $author$project$Catalogue$Identifiants$etatCodeDecoder))),
			A2(
			$elm$json$Json$Decode$field,
			'CodeChange',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Catalogue$API$WriteAPIModel$CodeChange,
				A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string))),
			A2(
			$elm$json$Json$Decode$field,
			'ReferenceClassee',
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Catalogue$API$WriteAPIModel$ReferenceClassee,
				A2($elm$json$Json$Decode$field, 'classification', $author$project$Catalogue$Identifiants$classificationIdDecoder),
				A2(
					$elm$json$Json$Decode$field,
					'valeurs',
					$elm$json$Json$Decode$list($author$project$Catalogue$Identifiants$valeurIdDecoder)))),
			A2(
			$elm$json$Json$Decode$field,
			'ReferenceArretee',
			$elm$json$Json$Decode$succeed($author$project$Catalogue$API$WriteAPIModel$ReferenceArretee)),
			A2(
			$elm$json$Json$Decode$field,
			'CalculDebraye',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Catalogue$API$WriteAPIModel$CalculDebraye,
				A2($elm$json$Json$Decode$field, 'cle', $elm$json$Json$Decode$string))),
			A2(
			$elm$json$Json$Decode$field,
			'CalculRebranche',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Catalogue$API$WriteAPIModel$CalculRebranche,
				A2($elm$json$Json$Decode$field, 'cle', $elm$json$Json$Decode$string))),
			A2(
			$elm$json$Json$Decode$field,
			'FichierRattache',
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Catalogue$API$WriteAPIModel$FichierRattache,
				A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'fichier', $elm$json$Json$Decode$string))),
			A2(
			$elm$json$Json$Decode$field,
			'FichierRetire',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Catalogue$API$WriteAPIModel$FichierRetire,
				A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string))),
			A2(
			$elm$json$Json$Decode$field,
			'ReferenceRangee',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Catalogue$API$WriteAPIModel$ReferenceRangee,
				A2(
					$elm$json$Json$Decode$field,
					'valeurs',
					$elm$json$Json$Decode$list($author$project$Catalogue$API$WriteAPIModel$valeurDuDessusDecoder)))),
			A2(
			$elm$json$Json$Decode$field,
			'TypeArchive',
			$elm$json$Json$Decode$succeed($author$project$Catalogue$API$WriteAPIModel$TypeArchive)),
			A2(
			$elm$json$Json$Decode$field,
			'PlaceDuTypeRetiree',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Catalogue$API$WriteAPIModel$PlaceDuTypeRetiree,
				A2($elm$json$Json$Decode$field, 'classification', $author$project$Catalogue$Identifiants$classificationIdDecoder))),
			A2(
			$elm$json$Json$Decode$field,
			'TypeRange',
			A2($elm$json$Json$Decode$map, $author$project$Catalogue$API$WriteAPIModel$TypeRange, $author$project$Catalogue$API$QueryAPIModel$placeDuTypeDecoder)),
			A2(
			$elm$json$Json$Decode$field,
			'TypeRenomme',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Catalogue$API$WriteAPIModel$TypeRenomme,
				A2($elm$json$Json$Decode$field, 'nom', $author$project$Catalogue$API$QueryAPIModel$libellesDecoder)))
		]));
var $author$project$Catalogue$API$WriteAPIModel$FiltrableRegle = F2(
	function (a, b) {
		return {$: 27, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$RecherchableRegle = F2(
	function (a, b) {
		return {$: 28, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$duReglageDeRecherche = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'FiltrableRegle',
			A2(
				$elm$json$Json$Decode$map,
				F2(
					function (filtrable, champ) {
						return A2($author$project$Catalogue$API$WriteAPIModel$FiltrableRegle, champ, filtrable);
					}),
				A2($elm$json$Json$Decode$field, 'filtrable', $elm$json$Json$Decode$bool))),
			A2(
			$elm$json$Json$Decode$field,
			'RecherchableRegle',
			A2(
				$elm$json$Json$Decode$map,
				F2(
					function (recherchable, champ) {
						return A2($author$project$Catalogue$API$WriteAPIModel$RecherchableRegle, champ, recherchable);
					}),
				A2($elm$json$Json$Decode$field, 'recherchable', $elm$json$Json$Decode$bool)))
		]));
var $author$project$Catalogue$API$WriteAPIModel$BlocsOrdonnes = function (a) {
	return {$: 19, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$ChampAffiche = function (a) {
	return {$: 30, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$ChampMasque = function (a) {
	return {$: 16, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$ChampsOrdonnes = function (a) {
	return {$: 31, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$Evolution = F2(
	function (ajouts, modifications) {
		return {fx: ajouts, g$: modifications};
	});
var $author$project$Catalogue$API$WriteAPIModel$MinimaDeChampFichierDefinis = F2(
	function (a, b) {
		return {$: 29, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$NiveauDeLectureDefini = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$NiveauDeSaisieDefini = F2(
	function (a, b) {
		return {$: 21, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$OrdrePropreRepris = {$: 20};
var $author$project$Catalogue$API$WriteAPIModel$RegleDeCodeDefinie = {$: 26};
var $author$project$Catalogue$API$WriteAPIModel$RestrictionDuChampLevee = function (a) {
	return {$: 25, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$SchemaEvolue = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$ValeurDuChampHeritePosee = function (a) {
	return {$: 22, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$ValeurDuChampHeriteRetiree = function (a) {
	return {$: 23, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$ValeursDuChampRestreintes = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$duSchema = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'SchemaEvolue',
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (version, ajouts, modifications) {
						return A2(
							$author$project$Catalogue$API$WriteAPIModel$SchemaEvolue,
							version,
							A2($author$project$Catalogue$API$WriteAPIModel$Evolution, ajouts, modifications));
					}),
				A2($elm$json$Json$Decode$field, 'version', $elm$json$Json$Decode$int),
				A2(
					$elm$json$Json$Decode$field,
					'ajouts',
					$elm$json$Json$Decode$list($author$project$Components$Shared$EditeurDeSchema$Champ$decoder)),
				A2(
					$elm$json$Json$Decode$field,
					'modifications',
					$elm$json$Json$Decode$list($author$project$Components$Shared$EditeurDeSchema$Champ$decoder)))),
			A2(
			$elm$json$Json$Decode$field,
			'ChampMasque',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Catalogue$API$WriteAPIModel$ChampMasque,
				A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string))),
			A2(
			$elm$json$Json$Decode$field,
			'NiveauDeLectureDefini',
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Catalogue$API$WriteAPIModel$NiveauDeLectureDefini,
				A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'niveau', $elm$json$Json$Decode$string))),
			A2(
			$elm$json$Json$Decode$field,
			'BlocsOrdonnes',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Catalogue$API$WriteAPIModel$BlocsOrdonnes,
				A2(
					$elm$json$Json$Decode$field,
					'ordre',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string)))),
			A2(
			$elm$json$Json$Decode$field,
			'OrdrePropreRepris',
			$elm$json$Json$Decode$succeed($author$project$Catalogue$API$WriteAPIModel$OrdrePropreRepris)),
			A2(
			$elm$json$Json$Decode$field,
			'ValeurDuChampHeritePosee',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Catalogue$API$WriteAPIModel$ValeurDuChampHeritePosee,
				A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string))),
			A2(
			$elm$json$Json$Decode$field,
			'ValeurDuChampHeriteRetiree',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Catalogue$API$WriteAPIModel$ValeurDuChampHeriteRetiree,
				A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string))),
			A2(
			$elm$json$Json$Decode$field,
			'NiveauDeSaisieDefini',
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Catalogue$API$WriteAPIModel$NiveauDeSaisieDefini,
				A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'etage', $elm$json$Json$Decode$string))),
			A2(
			$elm$json$Json$Decode$field,
			'ValeursDuChampRestreintes',
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Catalogue$API$WriteAPIModel$ValeursDuChampRestreintes,
				A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
				A2(
					$elm$json$Json$Decode$field,
					'valeurs',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string)))),
			A2(
			$elm$json$Json$Decode$field,
			'RestrictionDuChampLevee',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Catalogue$API$WriteAPIModel$RestrictionDuChampLevee,
				A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string))),
			A2(
			$elm$json$Json$Decode$field,
			'RegleDeCodeDefinie',
			$elm$json$Json$Decode$succeed($author$project$Catalogue$API$WriteAPIModel$RegleDeCodeDefinie)),
			A2(
			$elm$json$Json$Decode$field,
			'MinimaDeChampFichierDefinis',
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Catalogue$API$WriteAPIModel$MinimaDeChampFichierDefinis,
				A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
				A2(
					$elm$json$Json$Decode$field,
					'minima',
					A4(
						$elm$json$Json$Decode$map3,
						$author$project$Components$Shared$EditeurDeSchema$Model$MinimaVoulus,
						$elm$json$Json$Decode$maybe(
							A2($elm$json$Json$Decode$field, 'largeurMinimale', $elm$json$Json$Decode$int)),
						$elm$json$Json$Decode$maybe(
							A2($elm$json$Json$Decode$field, 'hauteurMinimale', $elm$json$Json$Decode$int)),
						A2($elm$json$Json$Decode$field, 'texteAlternatifExige', $elm$json$Json$Decode$bool))))),
			A2(
			$elm$json$Json$Decode$field,
			'ChampAffiche',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Catalogue$API$WriteAPIModel$ChampAffiche,
				A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string))),
			A2(
			$elm$json$Json$Decode$field,
			'ChampsOrdonnes',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Catalogue$API$WriteAPIModel$ChampsOrdonnes,
				A2(
					$elm$json$Json$Decode$field,
					'ordre',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string))))
		]));
var $author$project$Catalogue$API$WriteAPIModel$ChampDuNiveauAffiche = F2(
	function (a, b) {
		return {$: 34, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$ChampDuNiveauMasque = F2(
	function (a, b) {
		return {$: 33, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$ChampsDuNiveauOrdonnes = F2(
	function (a, b) {
		return {$: 35, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$SchemaDuNiveauEvolue = F3(
	function (a, b, c) {
		return {$: 32, a: a, b: b, c: c};
	});
var $author$project$Catalogue$API$WriteAPIModel$duSchemaDUnNiveau = function () {
	var niveau = A2($elm$json$Json$Decode$field, 'niveau', $author$project$Catalogue$Identifiants$niveauIdDecoder);
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'SchemaDuNiveauEvolue',
				A5(
					$elm$json$Json$Decode$map4,
					F4(
						function (id, version, ajouts, modifications) {
							return A3(
								$author$project$Catalogue$API$WriteAPIModel$SchemaDuNiveauEvolue,
								id,
								version,
								A2($author$project$Catalogue$API$WriteAPIModel$Evolution, ajouts, modifications));
						}),
					niveau,
					A2($elm$json$Json$Decode$field, 'version', $elm$json$Json$Decode$int),
					A2(
						$elm$json$Json$Decode$field,
						'ajouts',
						$elm$json$Json$Decode$list($author$project$Components$Shared$EditeurDeSchema$Champ$decoder)),
					A2(
						$elm$json$Json$Decode$field,
						'modifications',
						$elm$json$Json$Decode$list($author$project$Components$Shared$EditeurDeSchema$Champ$decoder)))),
				A2(
				$elm$json$Json$Decode$field,
				'ChampDuNiveauMasque',
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$Catalogue$API$WriteAPIModel$ChampDuNiveauMasque,
					niveau,
					A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string))),
				A2(
				$elm$json$Json$Decode$field,
				'ChampDuNiveauAffiche',
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$Catalogue$API$WriteAPIModel$ChampDuNiveauAffiche,
					niveau,
					A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string))),
				A2(
				$elm$json$Json$Decode$field,
				'ChampsDuNiveauOrdonnes',
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$Catalogue$API$WriteAPIModel$ChampsDuNiveauOrdonnes,
					niveau,
					A2(
						$elm$json$Json$Decode$field,
						'ordre',
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string))))
			]));
}();
var $author$project$Catalogue$API$WriteAPIModel$TypeCree = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$duTypeCree = A2(
	$elm$json$Json$Decode$field,
	'TypeCree',
	A3(
		$elm$json$Json$Decode$map2,
		F3(
			function (nom, nature, id) {
				return A2(
					$author$project$Catalogue$API$WriteAPIModel$TypeCree,
					id,
					{g1: nature, Dj: nom});
			}),
		A2($elm$json$Json$Decode$field, 'nom', $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
		A2($elm$json$Json$Decode$field, 'nature', $elm$json$Json$Decode$string)));
var $author$project$Catalogue$API$WriteAPIModel$Ordre = F3(
	function (niveau, parent, ordre) {
		return {os: niveau, El: ordre, ey: parent};
	});
var $author$project$Catalogue$API$WriteAPIModel$ordre = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'ordre',
	$elm$json$Json$Decode$list($author$project$Catalogue$Identifiants$elementIdDecoder),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'parent',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Identifiants$elementIdDecoder),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'niveau',
			$author$project$Catalogue$Identifiants$niveauIdDecoder,
			$elm$json$Json$Decode$succeed($author$project$Catalogue$API$WriteAPIModel$Ordre))));
var $author$project$Catalogue$API$WriteAPIModel$enveloppe = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Basics$apR,
			A2($elm$json$Json$Decode$field, 'aggregateUid', $author$project$Catalogue$Identifiants$elementIdDecoder),
			A2($elm$json$Json$Decode$field, 'event', $author$project$Catalogue$API$WriteAPIModel$deLElement)),
			A2(
			$elm$json$Json$Decode$field,
			'event',
			A2(
				$elm$json$Json$Decode$field,
				'GammesOrdonnees',
				A2($elm$json$Json$Decode$map, $author$project$Catalogue$API$WriteAPIModel$GammesOrdonnees, $author$project$Catalogue$API$WriteAPIModel$ordre))),
			A2(
			$elm$json$Json$Decode$field,
			'event',
			A2(
				$elm$json$Json$Decode$field,
				'MarquesOrdonnees',
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$Catalogue$API$WriteAPIModel$MarquesOrdonnees,
					A2($elm$json$Json$Decode$field, 'niveau', $author$project$Catalogue$Identifiants$niveauIdDecoder),
					A2(
						$elm$json$Json$Decode$field,
						'ordre',
						$elm$json$Json$Decode$list($author$project$Catalogue$Identifiants$elementIdDecoder))))),
			A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Basics$apR,
			A2($elm$json$Json$Decode$field, 'aggregateUid', $author$project$Catalogue$Identifiants$typeDeProduitIdDecoder),
			A2($elm$json$Json$Decode$field, 'event', $author$project$Catalogue$API$WriteAPIModel$duTypeCree)),
			A2($elm$json$Json$Decode$field, 'event', $author$project$Catalogue$API$WriteAPIModel$duSchema),
			A2($elm$json$Json$Decode$field, 'event', $author$project$Catalogue$API$WriteAPIModel$duSchemaDUnNiveau),
			A3(
			$elm$json$Json$Decode$map2,
			$author$project$Catalogue$API$WriteAPIModel$PorteeChangee,
			A2($elm$json$Json$Decode$field, 'aggregateUid', $elm$json$Json$Decode$string),
			A2(
				$elm$json$Json$Decode$field,
				'event',
				A2(
					$elm$json$Json$Decode$field,
					'PorteeChangee',
					A2($elm$json$Json$Decode$field, 'portee', $elm$json$Json$Decode$string)))),
			A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Basics$apR,
			A2($elm$json$Json$Decode$field, 'aggregateUid', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'event', $author$project$Catalogue$API$WriteAPIModel$duReglageDeRecherche)),
			A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Basics$apR,
			A2($elm$json$Json$Decode$field, 'aggregateUid', $author$project$Catalogue$Identifiants$referenceIdDecoder),
			A2($elm$json$Json$Decode$field, 'event', $author$project$Catalogue$API$WriteAPIModel$deLaReferenceCreee)),
			A2($elm$json$Json$Decode$field, 'event', $author$project$Catalogue$API$WriteAPIModel$deLaReference_),
			A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Basics$apR,
			A2($elm$json$Json$Decode$field, 'aggregateUid', $author$project$Catalogue$Identifiants$listeDePrixIdDecoder),
			A2($elm$json$Json$Decode$field, 'event', $author$project$Catalogue$API$WriteAPIModel$deLaListeDePrixCreee)),
			A2($elm$json$Json$Decode$field, 'event', $author$project$Catalogue$API$WriteAPIModel$deLaListeDePrix_),
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Catalogue$API$WriteAPIModel$PerimetreCreeDepuisUnFiltre,
			A2(
				$elm$json$Json$Decode$andThen,
				function (uid) {
					return A2(
						$elm$json$Json$Decode$field,
						'event',
						A2(
							$elm$json$Json$Decode$field,
							'PerimetreCree',
							$elm$json$Json$Decode$succeed(uid)));
				},
				A2($elm$json$Json$Decode$field, 'aggregateUid', $elm$json$Json$Decode$string))),
			$elm$json$Json$Decode$succeed($author$project$Catalogue$API$WriteAPIModel$EvenementInconnu)
		]));
var $author$project$Catalogue$API$WriteAPIModel$reponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'vuesAJour',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'liens',
		A2(
			$elm$json$Json$Decode$map,
			function ($) {
				return $.h0;
			},
			$author$project$API$Liens$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'evenements',
			$elm$json$Json$Decode$list($author$project$Catalogue$API$WriteAPIModel$enveloppe),
			$elm$json$Json$Decode$succeed($author$project$Catalogue$API$WriteAPIModel$ReponseDeCommande))));
var $author$project$Components$Produits$Common$Envoi$reglage = {
	f8: $author$project$Components$Produits$Common$Effet$DemanderProcessUid,
	l4: $author$project$Components$Produits$Common$Effet$Envoyer,
	go: $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$duRefus,
	pW: $author$project$Components$Produits$Common$Effet$Reconnecter,
	qu: F2(
		function (commande, rendue) {
			return A2($author$project$Components$Produits$Common$Envoi$repondA, commande, rendue.mk);
		}),
	qv: $author$project$Catalogue$API$WriteAPIModel$reponseDecoder
};
var $author$project$Catalogue$API$WriteAPIModel$reponseDuLotDecoder = A2(
	$elm$json$Json$Decode$map,
	function (_v0) {
		return {mk: _List_Nil, nQ: _List_Nil, sy: true};
	},
	A2($elm$json$Json$Decode$field, 'references', $elm$json$Json$Decode$int));
var $author$project$Components$Produits$Common$Envoi$conclure = F2(
	function (reponse, envoi) {
		if ((envoi.$ === 2) && (envoi.b.$ === 53)) {
			var _v1 = envoi.b;
			return A3(
				$author$project$API$Envoi$conclure,
				_Utils_update(
					$author$project$Components$Produits$Common$Envoi$reglage,
					{qv: $author$project$Catalogue$API$WriteAPIModel$reponseDuLotDecoder}),
				reponse,
				envoi);
		} else {
			return A3($author$project$API$Envoi$conclure, $author$project$Components$Produits$Common$Envoi$reglage, reponse, envoi);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Marques$Update$creee = F2(
	function (avant, msg) {
		if (msg.$ === 13) {
			var reponse = msg.a;
			var _v1 = A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, avant.l2);
			if ((((!_v1.$) && (!_v1.a.b.$)) && (!_v1.a.b.a.$)) && _v1.a.b.c) {
				var _v2 = _v1.a;
				var _v3 = _v2.b;
				var rendue = _v3.b;
				return $elm$core$List$head(
					A2(
						$elm$core$List$filterMap,
						function (evenement) {
							if (!evenement.$) {
								var id = evenement.a;
								return $elm$core$Maybe$Just(id);
							} else {
								return $elm$core$Maybe$Nothing;
							}
						},
						rendue.mk));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$Common$Saisie$DeMarque = 0;
var $author$project$Components$Produits$Common$Saisie$nomSaisi = F2(
	function (forme, saisie) {
		switch (forme) {
			case 0:
				return $elm$core$String$trim(saisie.Dj);
			case 1:
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.zX;
						},
						$author$project$Components$Produits$Common$LibellesSaisis$versLApi(saisie.R)));
			default:
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.zX;
						},
						$author$project$Components$Produits$Common$LibellesSaisis$versLApi(saisie.R)));
		}
	});
var $author$project$I18n$Textes$produitsCatalogueInfoElements = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.info.elements', _List_Nil, 'Éléments');
var $author$project$I18n$Textes$produitsCatalogueNeutreArchiverQuestion = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.catalogue.neutre.archiver.question',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nom',
				$author$project$I18n$Traductions$Sous(p.Dj))
			]),
		'Archiver « {nom} » ? L\'élément restera dans la liste, marqué archivé.');
};
var $author$project$I18n$Textes$produitsCatalogueNeutreAucun = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.neutre.aucun', _List_Nil, 'Aucun élément pour l\'instant.');
var $author$project$I18n$Textes$produitsCatalogueNeutreCreer = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.neutre.creer', _List_Nil, 'Ajouter');
var $author$project$I18n$Textes$produitsCatalogueNeutreEnDouble = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.neutre.en-double', _List_Nil, 'Ce nom existe déjà.');
var $author$project$I18n$Textes$produitsCatalogueNeutreModifier = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.catalogue.neutre.modifier',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'niveau',
				$author$project$I18n$Traductions$Sous(p.os))
			]),
		'Modifier {niveau}');
};
var $author$project$I18n$Textes$produitsCatalogueNeutreNombre = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.catalogue.neutre.nombre',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nombre',
				$author$project$I18n$Traductions$Entier(p.w))
			]),
		'{nombre, plural, one {# élément} other {# éléments}}');
};
var $author$project$I18n$Textes$produitsCatalogueNeutreNoteDOrdre = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.neutre.note-d-ordre', _List_Nil, 'L\'ordre est propre à chaque élément ; il sert de base aux catalogues publiés.');
var $author$project$I18n$Textes$produitsCatalogueNeutreNouveau = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.catalogue.neutre.nouveau',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'niveau',
				$author$project$I18n$Traductions$Sous(p.os))
			]),
		'Ajouter {niveau}');
};
var $author$project$I18n$Textes$produitsCatalogueNeutreRefusPorte = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.catalogue.neutre.refus.porte',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nom',
				$author$project$I18n$Traductions$Sous(p.Dj)),
				_Utils_Tuple2(
				'elements',
				$author$project$I18n$Traductions$Sous(p.aV))
			]),
		'« {nom} » ne peut pas être archivé : il porte {elements}');
};
var $author$project$I18n$Textes$produitsCatalogueNeutreRefusReferencesActives = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.catalogue.neutre.refus.references-actives',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nom',
				$author$project$I18n$Traductions$Sous(p.Dj)),
				_Utils_Tuple2(
				'references',
				$author$project$I18n$Traductions$Sous(p.hD))
			]),
		'« {nom} » ne peut pas être archivé : il contient {references}');
};
var $author$project$I18n$Textes$produitsCatalogueNeutreRefusReferencesActivesNombre = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.catalogue.neutre.refus.references-actives.nombre',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nombre',
				$author$project$I18n$Traductions$Entier(p.w))
			]),
		'{nombre, plural, one {# référence active. Arrêtez-la ou rattachez-la ailleurs.} other {# références actives. Arrêtez-les ou rattachez-les ailleurs.}}');
};
var $author$project$Catalogue$Vocabulaire$tournuresNeutres = function (libelle) {
	return {
		$7: function (nom) {
			return $author$project$I18n$Textes$produitsCatalogueNeutreArchiverQuestion(
				{
					Dj: $author$project$I18n$Traductions$tel(nom)
				});
		},
		dp: $author$project$I18n$Textes$produitsCatalogueNeutreAucun,
		dC: $author$project$I18n$Textes$produitsCatalogueNeutreCreer,
		dH: $elm$core$Maybe$Nothing,
		gi: $author$project$I18n$Textes$produitsCatalogueNeutreEnDouble,
		yp: $author$project$I18n$Textes$produitsCatalogueInfoElements,
		ei: $author$project$I18n$Textes$produitsCatalogueNeutreModifier(
			{os: libelle}),
		g1: function (_v0) {
			return libelle;
		},
		Dj: libelle,
		w: function (nombre) {
			return $author$project$I18n$Textes$produitsCatalogueNeutreNombre(
				{w: nombre});
		},
		em: $author$project$I18n$Textes$produitsCatalogueNeutreNoteDOrdre,
		en: $author$project$I18n$Textes$produitsCatalogueNeutreNouveau(
			{os: libelle}),
		bT: libelle,
		eL: $author$project$I18n$Textes$produitsCatalogueNeutreRefusPorte,
		eM: function (refus) {
			return $author$project$I18n$Textes$produitsCatalogueNeutreRefusReferencesActives(
				{
					Dj: $author$project$I18n$Traductions$tel(refus.Dj),
					hD: $author$project$I18n$Textes$produitsCatalogueNeutreRefusReferencesActivesNombre(
						{w: refus.w})
				});
		}
	};
};
var $author$project$I18n$Textes$produitsCatalogueFemininArchiverQuestion = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.catalogue.feminin.archiver.question',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nom',
				$author$project$I18n$Traductions$Sous(p.Dj))
			]),
		'Archiver « {nom} » ? Elle restera dans la liste, marquée archivée.');
};
var $author$project$I18n$Textes$produitsCatalogueFemininRefusPorte = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.catalogue.feminin.refus.porte',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nom',
				$author$project$I18n$Traductions$Sous(p.Dj)),
				_Utils_Tuple2(
				'elements',
				$author$project$I18n$Traductions$Sous(p.aV))
			]),
		'« {nom} » ne peut pas être archivée : elle porte {elements}');
};
var $author$project$I18n$Textes$produitsCatalogueGammeAucun = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.gamme.aucun', _List_Nil, 'Aucune gamme pour l\'instant.');
var $author$project$I18n$Textes$produitsCatalogueGammeCreer = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.gamme.creer', _List_Nil, 'Créer la gamme');
var $author$project$I18n$Textes$produitsCatalogueGammeEnDouble = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.gamme.en-double', _List_Nil, 'Cette gamme existe déjà.');
var $author$project$I18n$Textes$produitsCatalogueGammeModifier = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.gamme.modifier', _List_Nil, 'Modifier la gamme');
var $author$project$I18n$Textes$produitsCatalogueGammeNombre = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.catalogue.gamme.nombre',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nombre',
				$author$project$I18n$Traductions$Entier(p.w))
			]),
		'{nombre, plural, one {# gamme} other {# gammes}}');
};
var $author$project$I18n$Textes$produitsCatalogueGammeNoteDOrdre = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.gamme.note-d-ordre', _List_Nil, 'L\'ordre est propre à chaque gamme ; il sert de base aux catalogues publiés.');
var $author$project$I18n$Textes$produitsCatalogueGammeNouveau = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.gamme.nouveau', _List_Nil, 'Nouvelle gamme');
var $author$project$I18n$Textes$produitsCatalogueGammePluriel = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.gamme.pluriel', _List_Nil, 'Gammes');
var $author$project$I18n$Textes$produitsCatalogueMarqueAucun = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.marque.aucun', _List_Nil, 'Aucune marque pour l\'instant.');
var $author$project$I18n$Textes$produitsCatalogueMarqueCreer = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.marque.creer', _List_Nil, 'Créer la marque');
var $author$project$I18n$Textes$produitsCatalogueMarqueDescription = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.marque.description', _List_Nil, 'Les marques, propres ou sous licence, et leurs gammes ordonnées.');
var $author$project$I18n$Textes$produitsCatalogueMarqueEnDouble = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.marque.en-double', _List_Nil, 'Cette marque existe déjà.');
var $author$project$I18n$Textes$produitsCatalogueMarqueModifier = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.marque.modifier', _List_Nil, 'Modifier la marque');
var $author$project$I18n$Textes$produitsCatalogueMarqueNombre = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.catalogue.marque.nombre',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nombre',
				$author$project$I18n$Traductions$Entier(p.w))
			]),
		'{nombre, plural, one {# marque} other {# marques}}');
};
var $author$project$I18n$Textes$produitsCatalogueMarqueNoteDOrdre = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.marque.note-d-ordre', _List_Nil, 'L\'ordre est propre à chaque marque ; il sert de base aux catalogues publiés.');
var $author$project$I18n$Textes$produitsCatalogueMarqueNouveau = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.marque.nouveau', _List_Nil, 'Nouvelle marque');
var $author$project$I18n$Textes$produitsCatalogueMarquePluriel = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.marque.pluriel', _List_Nil, 'Marques');
var $author$project$I18n$Textes$produitsCatalogueMarquePropre = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.marque.propre', _List_Nil, 'Marque propre');
var $author$project$I18n$Textes$produitsCatalogueMarqueSousLicence = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.marque.sous-licence', _List_Nil, 'Marque sous licence');
var $author$project$I18n$Textes$produitsCatalogueFemininRefusReferencesActives = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.catalogue.feminin.refus.references-actives',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nom',
				$author$project$I18n$Traductions$Sous(p.Dj)),
				_Utils_Tuple2(
				'references',
				$author$project$I18n$Traductions$Sous(p.hD))
			]),
		'« {nom} » ne peut pas être archivée : elle contient {references}');
};
var $author$project$I18n$Textes$produitsCatalogueFemininRefusReferencesActivesNombre = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.catalogue.feminin.refus.references-actives.nombre',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nombre',
				$author$project$I18n$Traductions$Entier(p.w))
			]),
		'{nombre, plural, one {# référence active. Arrêtez-la ou rattachez-la à une autre gamme.} other {# références actives. Arrêtez-les ou rattachez-les à une autre gamme.}}');
};
var $author$project$Catalogue$Vocabulaire$refusReferencesActivesAuFeminin = function (refus) {
	return $author$project$I18n$Textes$produitsCatalogueFemininRefusReferencesActives(
		{
			Dj: $author$project$I18n$Traductions$tel(refus.Dj),
			hD: $author$project$I18n$Textes$produitsCatalogueFemininRefusReferencesActivesNombre(
				{w: refus.w})
		});
};
var $author$project$Catalogue$Vocabulaire$tournuresParDefaut = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			$author$project$Catalogue$Vocabulaire$codeMarque,
			{
				$7: function (nom) {
					return $author$project$I18n$Textes$produitsCatalogueFemininArchiverQuestion(
						{
							Dj: $author$project$I18n$Traductions$tel(nom)
						});
				},
				dp: $author$project$I18n$Textes$produitsCatalogueMarqueAucun,
				dC: $author$project$I18n$Textes$produitsCatalogueMarqueCreer,
				dH: $elm$core$Maybe$Just($author$project$I18n$Textes$produitsCatalogueMarqueDescription),
				gi: $author$project$I18n$Textes$produitsCatalogueMarqueEnDouble,
				yp: $author$project$I18n$Textes$produitsCatalogueGammePluriel,
				ei: $author$project$I18n$Textes$produitsCatalogueMarqueModifier,
				g1: function (sousLicence) {
					return _Utils_eq(
						sousLicence,
						$elm$core$Maybe$Just(true)) ? $author$project$I18n$Textes$produitsCatalogueMarqueSousLicence : $author$project$I18n$Textes$produitsCatalogueMarquePropre;
				},
				Dj: $author$project$I18n$Textes$produitsArchetypeMarque,
				w: function (nombre) {
					return $author$project$I18n$Textes$produitsCatalogueMarqueNombre(
						{w: nombre});
				},
				em: $author$project$I18n$Textes$produitsCatalogueMarqueNoteDOrdre,
				en: $author$project$I18n$Textes$produitsCatalogueMarqueNouveau,
				bT: $author$project$I18n$Textes$produitsCatalogueMarquePluriel,
				eL: $author$project$I18n$Textes$produitsCatalogueFemininRefusPorte,
				eM: $author$project$Catalogue$Vocabulaire$refusReferencesActivesAuFeminin
			}),
			_Utils_Tuple2(
			$author$project$Catalogue$Vocabulaire$codeGamme,
			{
				$7: function (nom) {
					return $author$project$I18n$Textes$produitsCatalogueFemininArchiverQuestion(
						{
							Dj: $author$project$I18n$Traductions$tel(nom)
						});
				},
				dp: $author$project$I18n$Textes$produitsCatalogueGammeAucun,
				dC: $author$project$I18n$Textes$produitsCatalogueGammeCreer,
				dH: $elm$core$Maybe$Nothing,
				gi: $author$project$I18n$Textes$produitsCatalogueGammeEnDouble,
				yp: $author$project$I18n$Textes$produitsCatalogueInfoElements,
				ei: $author$project$I18n$Textes$produitsCatalogueGammeModifier,
				g1: function (_v0) {
					return $author$project$I18n$Textes$produitsArchetypeGamme;
				},
				Dj: $author$project$I18n$Textes$produitsArchetypeGamme,
				w: function (nombre) {
					return $author$project$I18n$Textes$produitsCatalogueGammeNombre(
						{w: nombre});
				},
				em: $author$project$I18n$Textes$produitsCatalogueGammeNoteDOrdre,
				en: $author$project$I18n$Textes$produitsCatalogueGammeNouveau,
				bT: $author$project$I18n$Textes$produitsCatalogueGammePluriel,
				eL: $author$project$I18n$Textes$produitsCatalogueFemininRefusPorte,
				eM: $author$project$Catalogue$Vocabulaire$refusReferencesActivesAuFeminin
			})
		]));
var $author$project$Catalogue$Vocabulaire$tournures = function (niveau) {
	var _v0 = _Utils_Tuple2(
		niveau.Bl,
		A2($elm$core$Dict$get, niveau.fA, $author$project$Catalogue$Vocabulaire$tournuresParDefaut));
	if (!_v0.a.$) {
		var libelle = _v0.a.a;
		return $author$project$Catalogue$Vocabulaire$tournuresNeutres(
			$author$project$I18n$Traductions$tel(libelle));
	} else {
		if (!_v0.b.$) {
			var _v1 = _v0.a;
			var parDefaut = _v0.b.a;
			return parDefaut;
		} else {
			var _v2 = _v0.a;
			var _v3 = _v0.b;
			return $author$project$Catalogue$Vocabulaire$tournuresNeutres(
				$author$project$Catalogue$Vocabulaire$archetype(niveau.fA));
		}
	}
};
var $author$project$Components$Produits$Common$Elements$niveau = function (servi) {
	return {
		fA: servi.fA,
		Bl: A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.zX;
			},
			servi.R)
	};
};
var $author$project$Components$Produits$Common$Elements$tournures = function (_v0) {
	return A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Elements$niveau, $author$project$Catalogue$Vocabulaire$tournures);
};
var $author$project$Components$Produits$StructureCatalogue$Marques$Update$contexte = F2(
	function (i18n, model) {
		var tournures = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Catalogue$Vocabulaire$tournures(
				{fA: $author$project$Catalogue$Vocabulaire$codeMarque, Bl: $elm$core$Maybe$Nothing}),
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$Produits$Common$Elements$tournures(i18n),
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.os;
					},
					model.aS)));
		return {
			aV: A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$I18n$Traductions$tel),
			gi: tournures.gi,
			Dj: A2($author$project$Components$Produits$Common$Saisie$nomSaisi, 0, model.hP),
			fd: tournures
		};
	});
var $author$project$I18n$Textes$produitsCatalogueErreurDejaArchive = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.erreur.deja-archive', _List_Nil, 'Cet élément est archivé : il ne peut plus changer. La page vient d\'être relue.');
var $author$project$I18n$Textes$produitsCatalogueErreurMarqueArchivee = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.erreur.marque-archivee', _List_Nil, 'Cette marque est archivée : aucune gamme ne s\'y range plus. La page vient d\'être relue.');
var $author$project$I18n$Textes$produitsCatalogueErreurOrdreInvalide = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.erreur.ordre-invalide', _List_Nil, 'Cet ordre n\'est plus possible : la liste vient d\'être relue.');
var $author$project$I18n$Textes$produitsCatalogueErreurPerime = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.erreur.perime', _List_Nil, 'Le catalogue a changé entre-temps : la page vient d\'être relue. Recommencez si nécessaire.');
var $author$project$I18n$Textes$produitsValeursArchivageRefusReferencesActives = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.valeurs.archivage.refus-references-actives',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nombre',
				$author$project$I18n$Traductions$Entier(p.w))
			]),
		'{nombre, plural, one {Ce produit a encore # référence active : arrêtez-la d\'abord.} other {Ce produit a encore # références actives : arrêtez-les d\'abord.}}');
};
var $author$project$I18n$Textes$produitsValeursRestrictionRefusPortee = A3($author$project$I18n$Traductions$texte, 'produits.valeurs.restriction.refus-portee', _List_Nil, 'Une catégorie ou un produit ne peut pas restreindre un produit. Fermez ce panneau et rouvrez-le : la liste est relue.');
var $author$project$Components$Produits$Common$Refus$message = F3(
	function (contexte, refus, erreur) {
		var dire = function (texte) {
			return {Jx: texte, b9: refus.b9};
		};
		switch (erreur.$) {
			case 0:
				return dire(contexte.gi);
			case 1:
				return dire(contexte.gi);
			case 2:
				return dire(contexte.gi);
			case 3:
				var nombre = erreur.a;
				return dire(
					contexte.fd.eM(
						{Dj: contexte.Dj, w: nombre}));
			case 4:
				var nombre = erreur.a;
				return dire(
					$author$project$I18n$Textes$produitsValeursArchivageRefusReferencesActives(
						{w: nombre}));
			case 5:
				var nombre = erreur.a;
				return dire(
					contexte.fd.eL(
						{
							aV: contexte.aV(nombre),
							Dj: $author$project$I18n$Traductions$tel(contexte.Dj)
						}));
			case 16:
				return dire($author$project$I18n$Textes$produitsCatalogueErreurOrdreInvalide);
			case 73:
				return dire($author$project$I18n$Textes$produitsValeursRestrictionRefusPortee);
			case 17:
				return dire($author$project$I18n$Textes$produitsCatalogueErreurDejaArchive);
			case 7:
				return dire($author$project$I18n$Textes$produitsCatalogueErreurMarqueArchivee);
			case 77:
				return $author$project$Components$Shared$Messages$Model$duRefus(refus);
			case 66:
				return $author$project$Components$Shared$Messages$Model$duRefus(refus);
			case 10:
				return $author$project$Components$Shared$Messages$Model$duRefus(refus);
			case 11:
				return $author$project$Components$Shared$Messages$Model$duRefus(refus);
			default:
				return dire($author$project$I18n$Textes$produitsCatalogueErreurPerime);
		}
	});
var $author$project$I18n$Textes$produitsCatalogueErreurRejeu = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.erreur.rejeu', _List_Nil, 'Une modification précédente avait déjà été enregistrée : votre dernière modification n\'a pas été appliquée. Vérifiez, puis recommencez.');
var $author$project$Components$Produits$Common$Refus$rejeu = {Jx: $author$project$I18n$Textes$produitsCatalogueErreurRejeu, b9: $elm$core$Maybe$Nothing};
var $author$project$Components$Produits$StructureCatalogue$Marques$Update$issueDeLOrdre = F3(
	function (i18n, avant, msg) {
		if (msg.$ === 13) {
			var reponse = msg.a;
			var _v1 = A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, avant.l2);
			_v1$6:
			while (true) {
				if (!_v1.$) {
					switch (_v1.a.b.$) {
						case 0:
							if (_v1.a.b.c) {
								switch (_v1.a.b.a.$) {
									case 11:
										var _v2 = _v1.a;
										var _v3 = _v2.b;
										var _v4 = _v3.a;
										return $elm$core$Maybe$Just(
											$elm$core$Result$Ok(0));
									case 10:
										var _v11 = _v1.a;
										var _v12 = _v11.b;
										return $elm$core$Maybe$Just(
											$elm$core$Result$Ok(0));
									default:
										break _v1$6;
								}
							} else {
								switch (_v1.a.b.a.$) {
									case 11:
										var _v5 = _v1.a;
										var _v6 = _v5.b;
										var _v7 = _v6.a;
										return $elm$core$Maybe$Just(
											$elm$core$Result$Err($author$project$Components$Produits$Common$Refus$rejeu));
									case 10:
										var _v13 = _v1.a;
										var _v14 = _v13.b;
										return $elm$core$Maybe$Just(
											$elm$core$Result$Err($author$project$Components$Produits$Common$Refus$rejeu));
									default:
										break _v1$6;
								}
							}
						case 1:
							switch (_v1.a.b.a.$) {
								case 11:
									var _v8 = _v1.a;
									var _v9 = _v8.b;
									var _v10 = _v9.a;
									var refus = _v9.b;
									var erreur = _v9.c;
									return $elm$core$Maybe$Just(
										$elm$core$Result$Err(
											A3(
												$author$project$Components$Produits$Common$Refus$message,
												A2($author$project$Components$Produits$StructureCatalogue$Marques$Update$contexte, i18n, avant),
												refus,
												erreur)));
								case 10:
									var _v15 = _v1.a;
									var _v16 = _v15.b;
									var refus = _v16.b;
									var erreur = _v16.c;
									return $elm$core$Maybe$Just(
										$elm$core$Result$Err(
											A3(
												$author$project$Components$Produits$Common$Refus$message,
												A2($author$project$Components$Produits$StructureCatalogue$Marques$Update$contexte, i18n, avant),
												refus,
												erreur)));
								default:
									break _v1$6;
							}
						default:
							break _v1$6;
					}
				} else {
					break _v1$6;
				}
			}
			return $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Update$ordreDesGammesEnCours = function (model) {
	return !_Utils_eq(
		A2($elm$core$Maybe$andThen, $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$gammesVoulues, model.El),
		$elm$core$Maybe$Nothing);
};
var $author$project$Components$Produits$StructureCatalogue$Update$ordreDesMarquesEnCours = function (model) {
	return !_Utils_eq(
		A2($elm$core$Maybe$andThen, $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$marquesVoulues, model.El),
		$elm$core$Maybe$Nothing);
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$ordreDesMarquesIssu = F2(
	function (issue, model) {
		if (!issue.$) {
			return A2(
				$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$versLeDrawerDOrdre,
				$author$project$Components$Shared$Drawer$Update$Fermer,
				_Utils_update(
					model,
					{oK: model.El}));
		} else {
			var message = issue.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						p1: $elm$core$Maybe$Just(message)
					}),
				_List_Nil);
		}
	});
var $author$project$Components$Produits$Common$Effet$Lire = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Marques$API$QueryAPIModel$Annuaire = F3(
	function (niveau, elements, liens) {
		return {aV: elements, nQ: liens, os: niveau};
	});
var $author$project$Catalogue$API$QueryAPIModel$Element = function (id) {
	return function (archetype) {
		return function (niveau) {
			return function (parent) {
				return function (libelles) {
					return function (sousLicence) {
						return function (millesime) {
							return function (rang) {
								return function (etat) {
									return function (enDouble) {
										return function (enfants) {
											return function (references) {
												return function (referencesActives) {
													return function (categories) {
														return function (appartenance) {
															return function (liens) {
																return {tw: appartenance, fA: archetype, dt: categories, gi: enDouble, yp: enfants, gt: etat, Aq: id, R: libelles, nQ: liens, n8: millesime, os: niveau, ey: parent, bY: rang, hD: references, Hd: referencesActives, IY: sousLicence};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Catalogue$API$QueryAPIModel$Appartenance = F3(
	function (toutes, marques, exclues) {
		return {mn: exclues, cU: marques, rO: toutes};
	});
var $author$project$Catalogue$API$QueryAPIModel$appartenanceDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'exclues',
	$elm$json$Json$Decode$list($author$project$Catalogue$Identifiants$elementIdDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'marques',
		$elm$json$Json$Decode$list($author$project$Catalogue$Identifiants$elementIdDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'toutes',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Catalogue$API$QueryAPIModel$Appartenance))));
var $author$project$Catalogue$API$QueryAPIModel$elementDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'appartenance',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$appartenanceDecoder),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'categories',
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				$elm$json$Json$Decode$list($author$project$Catalogue$Identifiants$typeDeProduitIdDecoder)),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'referencesActives',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'references',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'enfants',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'enDouble',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'etat',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'rang',
									$elm$json$Json$Decode$int,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'millesime',
										A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'sousLicence',
											A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$bool),
											$elm$core$Maybe$Nothing,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'libelles',
												$author$project$Catalogue$API$QueryAPIModel$libellesDecoder,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'parent',
													A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Identifiants$elementIdDecoder),
													$elm$core$Maybe$Nothing,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'niveau',
														$author$project$Catalogue$Identifiants$niveauIdDecoder,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'archetype',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'id',
																$author$project$Catalogue$Identifiants$elementIdDecoder,
																$elm$json$Json$Decode$succeed($author$project$Catalogue$API$QueryAPIModel$Element)))))))))))))))));
var $author$project$Catalogue$API$QueryAPIModel$NiveauDElement = F4(
	function (id, archetype, parDefaut, libelles) {
		return {fA: archetype, Aq: id, R: libelles, o6: parDefaut};
	});
var $author$project$Catalogue$API$QueryAPIModel$niveauDElementDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'libelles',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'parDefaut',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'archetype',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$author$project$Catalogue$Identifiants$niveauIdDecoder,
				$elm$json$Json$Decode$succeed($author$project$Catalogue$API$QueryAPIModel$NiveauDElement)))));
var $author$project$Components$Produits$StructureCatalogue$Marques$API$QueryAPIModel$annuaireDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'elements',
		$elm$json$Json$Decode$list($author$project$Catalogue$API$QueryAPIModel$elementDecoder),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'niveau',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$niveauDElementDecoder),
			$elm$core$Maybe$Nothing,
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$Marques$API$QueryAPIModel$Annuaire))));
var $author$project$Catalogue$API$WriteAPIModel$OrdonnerLesMarques = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$ordonnerLesMarques = 'ordonner-les-marques';
var $author$project$Components$Produits$StructureCatalogue$Marques$Model$commandeDOrdre = F2(
	function (model, voulues) {
		return A3(
			$elm$core$Maybe$map2,
			F2(
				function (niveau, lien) {
					return _Utils_Tuple2(
						A2($author$project$Catalogue$API$WriteAPIModel$OrdonnerLesMarques, niveau.Aq, voulues),
						lien);
				}),
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.os;
				},
				model.aS),
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nQ;
					},
					$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$ordonnerLesMarques)),
				model.aS));
	});
var $author$project$Catalogue$API$WriteAPIModel$OrdonnerLesGammes = function (a) {
	return {$: 10, a: a};
};
var $author$project$API$NavLinksDictionary$ordonnerLesGammes = 'ordonner-les-gammes';
var $author$project$Components$Produits$StructureCatalogue$Marques$Model$toutes = function (model) {
	var _v0 = model.aS;
	if (!_v0.$) {
		var annuaire = _v0.a;
		return _Utils_eq(
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.fA;
				},
				annuaire.os),
			$elm$core$Maybe$Just($author$project$Catalogue$Vocabulaire$codeMarque)) ? annuaire.aV : _List_Nil;
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Marques$Model$commandeDOrdreDesGammes = F4(
	function (model, marque, niveau, voulues) {
		return A2(
			$elm$core$Maybe$map,
			function (lien) {
				return _Utils_Tuple2(
					$author$project$Catalogue$API$WriteAPIModel$OrdonnerLesGammes(
						{
							os: niveau,
							El: voulues,
							ey: $elm$core$Maybe$Just(marque)
						}),
					lien);
			},
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nQ;
					},
					$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$ordonnerLesGammes)),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(marque)),
						$author$project$Components$Produits$StructureCatalogue$Marques$Model$toutes(model)))));
	});
var $author$project$Catalogue$API$WriteAPIModel$ModifierUneMarque = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$modifierUneMarque = 'modifier-une-marque';
var $author$project$Components$Produits$StructureCatalogue$Marques$Model$commandeDeNature = F2(
	function (marque, sousLicence) {
		return A2(
			$elm$core$Maybe$map,
			function (lien) {
				return _Utils_Tuple2(
					A2(
						$author$project$Catalogue$API$WriteAPIModel$ModifierUneMarque,
						marque.Aq,
						{Dj: marque.R.zX, IY: sousLicence}),
					lien);
			},
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierUneMarque, marque.nQ));
	});
var $author$project$Catalogue$API$WriteAPIModel$RestaurerUneMarque = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Marques$Model$commandeDeRestauration = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function (archivee) {
			return _Utils_Tuple2(
				$author$project$Catalogue$API$WriteAPIModel$RestaurerUneMarque(archivee.y1),
				archivee.nB);
		},
		model.tI);
};
var $author$project$Components$Produits$Common$Effet$AttendreAvantDeRelire = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Produits$Common$Effet$PlacerFocus = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Produits$Common$Envoi$delaiDeRelectureMs = $author$project$API$Envoi$delaiDeRelectureMs;
var $author$project$Referentiel$Langues$desLibelles = _List_fromArray(
	[
		{vx: 'fr', he: true},
		{vx: 'en', he: false}
	]);
var $author$project$Components$Produits$Common$LibellesSaisis$premiereObligatoire = A2(
	$elm$core$Maybe$map,
	function ($) {
		return $.vx;
	},
	$elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function ($) {
				return $.he;
			},
			$author$project$Referentiel$Langues$desLibelles)));
var $author$project$Components$Produits$Common$LibellesSaisis$idDuPremierChamp = function (prefixe) {
	return A2(
		$elm$core$Maybe$withDefault,
		prefixe,
		A2(
			$elm$core$Maybe$map,
			$author$project$Components$Shared$LibellesParLangue$View$idDuChamp(prefixe),
			$author$project$Components$Produits$Common$LibellesSaisis$premiereObligatoire));
};
var $author$project$Components$Produits$Common$Formulaire$idDuNom = F2(
	function (forme, prefixe) {
		switch (forme) {
			case 0:
				return prefixe + '-nom';
			case 1:
				return $author$project$Components$Produits$Common$LibellesSaisis$idDuPremierChamp(prefixe + '-nom');
			default:
				return $author$project$Components$Produits$Common$LibellesSaisis$idDuPremierChamp(prefixe + '-nom');
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Marques$Model$idDuNom = function (model) {
	return A2(
		$author$project$Components$Produits$Common$Formulaire$idDuNom,
		0,
		$author$project$Components$Shared$Drawer$Model$idRacine(model.kX));
};
var $author$project$Components$Produits$Common$Refus$perime = function (erreur) {
	switch (erreur.$) {
		case 0:
			return false;
		case 1:
			return false;
		case 2:
			return false;
		case 3:
			return false;
		case 4:
			return false;
		case 5:
			return false;
		case 10:
			return false;
		case 11:
			return false;
		case 73:
			return false;
		case 77:
			return false;
		case 66:
			return false;
		default:
			return true;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Marques$Update$relire = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$Lire, $elm$core$List$singleton),
			model.np));
};
var $author$project$Components$Produits$Common$Saisie$enCours = function (saisie) {
	return !_Utils_eq(
		{R: saisie.R, n8: saisie.n8, Dj: saisie.Dj, IY: saisie.IY},
		saisie.cx);
};
var $author$project$Components$Produits$StructureCatalogue$Marques$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{kX: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Produits$Common$Effet$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Produits$Common$Saisie$enCours(model.hP)
				},
				geste,
				model.kX));
	});
var $author$project$Components$Produits$StructureCatalogue$Marques$Update$conclure = F3(
	function (i18n, issue, model) {
		var saisie = model.hP;
		switch (issue.$) {
			case 0:
				switch (issue.a.$) {
					case 1:
						var _v1 = issue.a;
						return _Utils_Tuple2(
							model,
							$author$project$Components$Produits$StructureCatalogue$Marques$Update$relire(model));
					case 11:
						var _v2 = issue.a;
						return _Utils_Tuple2(
							model,
							$author$project$Components$Produits$StructureCatalogue$Marques$Update$relire(model));
					case 10:
						return _Utils_Tuple2(model, _List_Nil);
					default:
						if (issue.c) {
							var rendue = issue.b;
							return A2(
								$elm$core$Tuple$mapSecond,
								function (effets) {
									return _Utils_ap(
										effets,
										(rendue.sy && (!A2($elm$core$List$member, $author$project$Catalogue$API$WriteAPIModel$EvenementInconnu, rendue.mk))) ? $author$project$Components$Produits$StructureCatalogue$Marques$Update$relire(model) : _List_fromArray(
											[
												$author$project$Components$Produits$Common$Effet$AttendreAvantDeRelire($author$project$Components$Produits$Common$Envoi$delaiDeRelectureMs)
											]));
								},
								A2(
									$author$project$Components$Produits$StructureCatalogue$Marques$Update$versLeDrawer,
									$author$project$Components$Shared$Drawer$Update$Fermer,
									_Utils_update(
										model,
										{tI: $elm$core$Maybe$Nothing, hP: $author$project$Components$Produits$Common$Saisie$vide})));
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										hP: _Utils_update(
											saisie,
											{
												pZ: $elm$core$Maybe$Just($author$project$Components$Produits$Common$Refus$rejeu)
											})
									}),
								$author$project$Components$Produits$StructureCatalogue$Marques$Update$relire(model));
						}
				}
			case 1:
				switch (issue.a.$) {
					case 11:
						var _v3 = issue.a;
						return _Utils_Tuple2(
							model,
							$author$project$Components$Produits$StructureCatalogue$Marques$Update$relire(model));
					case 10:
						return _Utils_Tuple2(model, _List_Nil);
					case 1:
						var _v4 = issue.a;
						return _Utils_Tuple2(
							model,
							$author$project$Components$Produits$StructureCatalogue$Marques$Update$relire(model));
					default:
						switch (issue.c.$) {
							case 2:
								var archivee = issue.c.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											tI: $elm$core$Maybe$Just(
												{tJ: archivee.tJ, y1: archivee.y1, gG: archivee.gG, nB: archivee.HS, hD: archivee.hD})
										}),
									_List_fromArray(
										[
											$author$project$Components$Produits$Common$Effet$PlacerFocus(
											$author$project$Components$Produits$StructureCatalogue$Marques$Model$idDuNom(model))
										]));
							case 0:
								var _v5 = issue.c;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											hP: _Utils_update(
												saisie,
												{gi: true})
										}),
									_List_fromArray(
										[
											$author$project$Components$Produits$Common$Effet$PlacerFocus(
											$author$project$Components$Produits$StructureCatalogue$Marques$Model$idDuNom(model))
										]));
							default:
								var refus = issue.b;
								var erreur = issue.c;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											hP: _Utils_update(
												saisie,
												{
													pZ: $elm$core$Maybe$Just(
														A3(
															$author$project$Components$Produits$Common$Refus$message,
															A2($author$project$Components$Produits$StructureCatalogue$Marques$Update$contexte, i18n, model),
															refus,
															erreur))
												})
										}),
									$author$project$Components$Produits$Common$Refus$perime(erreur) ? $author$project$Components$Produits$StructureCatalogue$Marques$Update$relire(model) : _List_Nil);
						}
				}
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$creerUneMarque = 'creer-une-marque';
var $author$project$Components$Produits$StructureCatalogue$Marques$Model$creation = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.nQ;
			},
			$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$creerUneMarque)),
		model.aS);
};
var $author$project$Catalogue$API$WriteAPIModel$CreerUneMarque = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$Common$Saisie$GammeValide = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$Common$Saisie$MarqueValide = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$Common$Saisie$ProduitValide = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$Common$Saisie$millesimeValide = function (saisie) {
	var _v0 = $elm$core$String$length(saisie.n8);
	switch (_v0) {
		case 0:
			return $elm$core$Maybe$Just($elm$core$Maybe$Nothing);
		case 4:
			return $elm$core$Maybe$Just(
				$elm$core$Maybe$Just(saisie.n8));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$Common$Saisie$nonVide = function (texte) {
	return $elm$core$String$isEmpty(
		$elm$core$String$trim(texte)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		$elm$core$String$trim(texte));
};
var $author$project$Components$Produits$Common$Saisie$valide = F2(
	function (forme, saisie) {
		switch (forme) {
			case 0:
				return A2(
					$elm$core$Maybe$map,
					function (nom) {
						return $author$project$Components$Produits$Common$Saisie$MarqueValide(
							{Dj: nom, IY: saisie.IY});
					},
					$author$project$Components$Produits$Common$Saisie$nonVide(saisie.Dj));
			case 1:
				return A3(
					$elm$core$Maybe$map2,
					F2(
						function (libelles, millesime) {
							return $author$project$Components$Produits$Common$Saisie$GammeValide(
								{R: libelles, n8: millesime});
						}),
					$author$project$Components$Produits$Common$LibellesSaisis$versLApi(saisie.R),
					$author$project$Components$Produits$Common$Saisie$millesimeValide(saisie));
			default:
				return A2(
					$elm$core$Maybe$map,
					function (libelles) {
						return $author$project$Components$Produits$Common$Saisie$ProduitValide(
							{R: libelles});
					},
					$author$project$Components$Produits$Common$LibellesSaisis$versLApi(saisie.R));
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Marques$Model$commandeDeCreation = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		$elm$core$Basics$identity,
		A3(
			$elm$core$Maybe$map2,
			F2(
				function (lien, saisie) {
					switch (saisie.$) {
						case 0:
							var marque = saisie.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$author$project$Catalogue$API$WriteAPIModel$CreerUneMarque(marque),
									lien));
						case 1:
							return $elm$core$Maybe$Nothing;
						default:
							return $elm$core$Maybe$Nothing;
					}
				}),
			$author$project$Components$Produits$StructureCatalogue$Marques$Model$creation(model),
			A2($author$project$Components$Produits$Common$Saisie$valide, 0, model.hP)));
};
var $author$project$Components$Produits$Common$Envoi$partir = $author$project$API$Envoi$partir($author$project$Components$Produits$Common$Envoi$reglage);
var $author$project$Components$Produits$Common$Saisie$tenter = function (saisie) {
	return _Utils_update(
		saisie,
		{b5: true});
};
var $author$project$Components$Produits$StructureCatalogue$Marques$Update$creer = function (model) {
	var _v0 = $author$project$Components$Produits$StructureCatalogue$Marques$Model$commandeDeCreation(model);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var commande = _v1.a;
		var lien = _v1.b;
		var _v2 = A3(
			$author$project$Components$Produits$Common$Envoi$partir,
			$elm$core$Maybe$Just(lien),
			commande,
			model.l2);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var envoi = _v3.a;
			var effets = _v3.b;
			var saisie = model.hP;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						tI: $elm$core$Maybe$Nothing,
						l2: envoi,
						hP: _Utils_update(
							saisie,
							{gi: false, pZ: $elm$core$Maybe$Nothing})
					}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_eq(
			$author$project$Components$Produits$StructureCatalogue$Marques$Model$creation(model),
			$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : _Utils_Tuple2(
			_Utils_update(
				model,
				{
					hP: $author$project$Components$Produits$Common$Saisie$tenter(model.hP)
				}),
			_List_fromArray(
				[
					$author$project$Components$Produits$Common$Effet$PlacerFocus(
					$author$project$Components$Produits$StructureCatalogue$Marques$Model$idDuNom(model))
				]));
	}
};
var $author$project$Components$Produits$StructureCatalogue$Marques$Model$idDeLaCreation = 'valeurs-marque-ajouter';
var $author$project$API$NavLinksDictionary$marquesEtGammes = 'marques-et-gammes';
var $author$project$Components$Produits$StructureCatalogue$Marques$Model$ouvert = function (lecture) {
	return _Utils_update(
		$author$project$Components$Produits$StructureCatalogue$Marques$Model$init,
		{np: lecture});
};
var $author$project$Components$Produits$Common$Envoi$recevoir = $author$project$API$Envoi$recevoir;
var $author$project$Components$Produits$Common$Envoi$enCours = $author$project$API$Envoi$enCours;
var $author$project$Components$Produits$Common$Envoi$retientLeDrawer = F2(
	function (envoi, geste) {
		return $author$project$Components$Produits$Common$Envoi$enCours(envoi) && A2(
			$elm$core$List$member,
			geste,
			_List_fromArray(
				[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$SortieDemandee, $author$project$Components$Shared$Drawer$Update$AbandonConfirme]));
	});
var $elm$core$String$filter = _String_filter;
var $author$project$Components$Produits$Common$Saisie$saisir = F2(
	function (champ, saisie) {
		switch (champ.$) {
			case 0:
				var texte = champ.a;
				return _Utils_update(
					saisie,
					{gi: false, Dj: texte});
			case 1:
				var code = champ.a;
				var texte = champ.b;
				return _Utils_update(
					saisie,
					{
						gi: false,
						R: A3($author$project$Components$Shared$LibellesParLangue$Model$ecrire, code, texte, saisie.R)
					});
			case 2:
				var texte = champ.a;
				return _Utils_update(
					saisie,
					{
						n8: A2(
							$elm$core$String$left,
							4,
							A2($elm$core$String$filter, $elm$core$Char$isDigit, texte))
					});
			default:
				var cochee = champ.a;
				return _Utils_update(
					saisie,
					{IY: cochee});
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Marques$Update$update = F3(
	function (i18n, msg, model) {
		switch (msg.$) {
			case 0:
				var liens = msg.a;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$marquesEtGammes, liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						$author$project$Components$Produits$StructureCatalogue$Marques$Model$ouvert(
							$elm$core$Maybe$Just(lecture)),
						_List_fromArray(
							[
								$author$project$Components$Produits$Common$Effet$DemanderProcessUid,
								$author$project$Components$Produits$Common$Effet$Lire(lecture)
							]));
				} else {
					return _Utils_Tuple2(
						$author$project$Components$Produits$StructureCatalogue$Marques$Model$ouvert($elm$core$Maybe$Nothing),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$Components$Produits$Common$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 2:
				var reponse = msg.a;
				var _v2 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$StructureCatalogue$Marques$API$QueryAPIModel$annuaireDecoder, reponse);
				if (!_v2.$) {
					var annuaire = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aS: $elm$core$Maybe$Just(annuaire)
							}),
						_List_Nil);
				} else {
					var refus = _v2.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 3:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Produits$StructureCatalogue$Marques$Update$relire(model));
			case 4:
				var geste = msg.a;
				return A2($author$project$Components$Produits$Common$Envoi$retientLeDrawer, model.l2, geste) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Produits$StructureCatalogue$Marques$Update$versLeDrawer, geste, model);
			case 5:
				return _Utils_eq(
					$author$project$Components$Produits$StructureCatalogue$Marques$Model$creation(model),
					$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A2(
					$author$project$Components$Produits$StructureCatalogue$Marques$Update$versLeDrawer,
					$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Produits$StructureCatalogue$Marques$Model$idDeLaCreation),
					_Utils_update(
						model,
						{tI: $elm$core$Maybe$Nothing, hP: $author$project$Components$Produits$Common$Saisie$vide}));
			case 6:
				var champ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hP: A2($author$project$Components$Produits$Common$Saisie$saisir, champ, model.hP)
						}),
					_List_Nil);
			case 7:
				return $author$project$Components$Produits$StructureCatalogue$Marques$Update$creer(model);
			case 8:
				var _v3 = $author$project$Components$Produits$StructureCatalogue$Marques$Model$commandeDeRestauration(model);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var commande = _v4.a;
					var lien = _v4.b;
					return A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(model, _List_Nil),
						A2(
							$elm$core$Maybe$map,
							function (_v5) {
								var envoi = _v5.a;
								var effets = _v5.b;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{l2: envoi}),
									effets);
							},
							A3(
								$author$project$Components$Produits$Common$Envoi$partir,
								$elm$core$Maybe$Just(lien),
								commande,
								model.l2)));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 9:
				var marque = msg.a;
				var sousLicence = msg.b;
				var _v6 = A2($author$project$Components$Produits$StructureCatalogue$Marques$Model$commandeDeNature, marque, sousLicence);
				if (!_v6.$) {
					var _v7 = _v6.a;
					var commande = _v7.a;
					var lien = _v7.b;
					return A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(model, _List_Nil),
						A2(
							$elm$core$Maybe$map,
							function (_v8) {
								var envoi = _v8.a;
								var effets = _v8.b;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{l2: envoi}),
									effets);
							},
							A3(
								$author$project$Components$Produits$Common$Envoi$partir,
								$elm$core$Maybe$Just(lien),
								commande,
								model.l2)));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 10:
				var voulues = msg.a;
				var _v9 = A2($author$project$Components$Produits$StructureCatalogue$Marques$Model$commandeDOrdre, model, voulues);
				if (!_v9.$) {
					var _v10 = _v9.a;
					var commande = _v10.a;
					var lien = _v10.b;
					return A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(model, _List_Nil),
						A2(
							$elm$core$Maybe$map,
							function (_v11) {
								var envoi = _v11.a;
								var effets = _v11.b;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{l2: envoi}),
									effets);
							},
							A3(
								$author$project$Components$Produits$Common$Envoi$partir,
								$elm$core$Maybe$Just(lien),
								commande,
								model.l2)));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 11:
				var marque = msg.a;
				var niveau = msg.b;
				var voulues = msg.c;
				var _v12 = A4($author$project$Components$Produits$StructureCatalogue$Marques$Model$commandeDOrdreDesGammes, model, marque, niveau, voulues);
				if (!_v12.$) {
					var _v13 = _v12.a;
					var commande = _v13.a;
					var lien = _v13.b;
					return A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(model, _List_Nil),
						A2(
							$elm$core$Maybe$map,
							function (_v14) {
								var envoi = _v14.a;
								var effets = _v14.b;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{l2: envoi}),
									effets);
							},
							A3(
								$author$project$Components$Produits$Common$Envoi$partir,
								$elm$core$Maybe$Just(lien),
								commande,
								model.l2)));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 12:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							kX: A3(
								$author$project$Components$Shared$Drawer$Update$update,
								{Il: false},
								$author$project$Components$Shared$Drawer$Update$Fermer,
								model.kX).a
						}),
					_List_Nil);
			default:
				var reponse = msg.a;
				var _v15 = A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, model.l2);
				if (!_v15.$) {
					var _v16 = _v15.a;
					var envoi = _v16.a;
					var issue = _v16.b;
					var effets = _v16.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A3(
							$author$project$Components$Produits$StructureCatalogue$Marques$Update$conclure,
							i18n,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Update$versLesMarques = F3(
	function (i18n, geste, model) {
		return function () {
			var _v1 = A3($author$project$Components$Produits$StructureCatalogue$Marques$Update$issueDeLOrdre, i18n, model.cU, geste);
			if (!_v1.$) {
				var issue = _v1.a;
				return A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Produits$StructureCatalogue$Update$puis(
						$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$ordreDesMarquesIssu(issue)),
					(_Utils_eq(
						issue,
						$elm$core$Result$Ok(0)) && ($author$project$Components$Produits$StructureCatalogue$Update$ordreDesGammesEnCours(model) || $author$project$Components$Produits$StructureCatalogue$Update$ordreDesMarquesEnCours(model))) ? $author$project$Components$Produits$StructureCatalogue$Update$puis(
						function (suivant) {
							return _Utils_Tuple2(
								suivant,
								$author$project$Components$Produits$StructureCatalogue$Commandes$relire(suivant));
						}) : $elm$core$Basics$identity);
			} else {
				return $elm$core$Basics$identity;
			}
		}()(
			function () {
				var _v0 = A2($author$project$Components$Produits$StructureCatalogue$Marques$Update$creee, model.cU, geste);
				if (!_v0.$) {
					var marque = _v0.a;
					return $author$project$Components$Produits$StructureCatalogue$Update$puis(
						$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$apresLaCreationDUneMarque(marque));
				} else {
					return $elm$core$Basics$identity;
				}
			}()(
				A3(
					$elm$core$Tuple$mapBoth,
					function (marques) {
						return _Utils_update(
							model,
							{cU: marques});
					},
					$elm$core$List$map($author$project$Components$Produits$StructureCatalogue$Effet$PourLesMarques),
					A3($author$project$Components$Produits$StructureCatalogue$Marques$Update$update, i18n, geste, model.cU))));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$ordreDemande = F2(
	function (i18n, model) {
		var _v0 = A2($elm$core$Maybe$andThen, $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$marquesVoulues, model.El);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var freres = _v1.a;
			var voulues = _v1.b;
			return _Utils_eq(voulues, freres) ? A2(
				$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$versLeDrawerDOrdre,
				$author$project$Components$Shared$Drawer$Update$Fermer,
				_Utils_update(
					model,
					{oK: $elm$core$Maybe$Nothing})) : A3(
				$author$project$Components$Produits$StructureCatalogue$Update$versLesMarques,
				i18n,
				$author$project$Components$Produits$StructureCatalogue$Marques$Update$OrdreDemande(voulues),
				_Utils_update(
					model,
					{p1: $elm$core$Maybe$Nothing}));
		} else {
			var _v2 = A2($elm$core$Maybe$andThen, $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$gammesVoulues, model.El);
			if (!_v2.$) {
				var gammes = _v2.a;
				return gammes.yk ? A2(
					$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$versLeDrawerDOrdre,
					$author$project$Components$Shared$Drawer$Update$Fermer,
					_Utils_update(
						model,
						{oK: $elm$core$Maybe$Nothing})) : A3(
					$author$project$Components$Produits$StructureCatalogue$Update$versLesMarques,
					i18n,
					A3($author$project$Components$Produits$StructureCatalogue$Marques$Update$OrdreDesGammesDemande, gammes.gX, gammes.os, gammes.KW),
					_Utils_update(
						model,
						{p1: $elm$core$Maybe$Nothing}));
			} else {
				return $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$ordreDemande(model);
			}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$idDeLOrdre = function (rang) {
	return 'valeurs-ordonner-' + $elm$core$String$fromInt(rang);
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$desMarques = function (colonne) {
	var _v0 = colonne.md.xt;
	if (!_v0.$) {
		var code = _v0.a;
		return _Utils_eq(code, $author$project$Catalogue$Vocabulaire$codeMarque);
	} else {
		return false;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$DeGamme = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$DesGammes = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$ouvrirLesGammes = F3(
	function (marques, classification, colonne) {
		var lignes = A2(
			$elm$core$List$filterMap,
			function (ligne) {
				var _v2 = ligne.fm;
				if (_v2.$ === 1) {
					var id = _v2.a;
					return $elm$core$Maybe$Just(
						{
							dy: $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$DeGamme(id),
							vW: ligne.vW,
							Dj: ligne.Dj
						});
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			colonne.gV);
		var _v0 = _Utils_Tuple2(
			colonne.md.xt,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.fm;
				},
				colonne.IV));
		if (((!_v0.a.$) && (!_v0.b.$)) && (_v0.b.a.$ === 1)) {
			var _v1 = _v0.a;
			var code = _v1.a;
			var niveau = _v1.b;
			var marque = _v0.b.a.a;
			return (_Utils_eq(code, $author$project$Catalogue$Vocabulaire$codeGamme) && (_Utils_eq(
				$elm$core$List$length(lignes),
				$elm$core$List$length(colonne.gV)) && (($elm$core$List$length(lignes) >= 2) && (!_Utils_eq(
				A4($author$project$Components$Produits$StructureCatalogue$Marques$Model$commandeDOrdreDesGammes, marques, marque, niveau, _List_Nil),
				$elm$core$Maybe$Nothing))))) ? $elm$core$Maybe$Just(
				{
					vj: classification.Aq,
					md: {md: colonne.Dj, IV: $elm$core$Maybe$Nothing},
					gV: lignes,
					F$: $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$DesGammes(
						{
							aB: A2(
								$elm$core$List$filterMap,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.dy;
									},
									$author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$gammeDe),
								lignes),
							gX: marque,
							os: niveau
						})
				}) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$DeMarque = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$DesMarques = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$ouvrirLesMarques = F3(
	function (marques, classification, colonne) {
		var lignes = A2(
			$elm$core$List$filterMap,
			function (ligne) {
				var _v0 = ligne.fm;
				if (_v0.$ === 1) {
					var id = _v0.a;
					return $elm$core$Maybe$Just(
						{
							dy: $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$DeMarque(id),
							vW: ligne.vW,
							Dj: ligne.Dj
						});
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			colonne.gV);
		return (_Utils_eq(
			$elm$core$List$length(lignes),
			$elm$core$List$length(colonne.gV)) && (($elm$core$List$length(lignes) >= 2) && (!_Utils_eq(
			A2($author$project$Components$Produits$StructureCatalogue$Marques$Model$commandeDOrdre, marques, _List_Nil),
			$elm$core$Maybe$Nothing)))) ? $elm$core$Maybe$Just(
			{
				vj: classification.Aq,
				md: {md: colonne.Dj, IV: $elm$core$Maybe$Nothing},
				gV: lignes,
				F$: $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$DesMarques(
					{
						aB: A2(
							$elm$core$List$map,
							function ($) {
								return $.Aq;
							},
							$author$project$Components$Produits$StructureCatalogue$Marques$Model$toutes(marques))
					})
			}) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$DeValeur = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$DesValeurs = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$offre = function (liens) {
	return !_Utils_eq(
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$deplacerUneValeur, liens),
		$elm$core$Maybe$Nothing);
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$DeNoeud = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$DesNoeuds = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$ouvrirLesNoeuds = F2(
	function (classification, colonne) {
		var noeuds = A2(
			$elm$core$List$filterMap,
			function (ligne) {
				var _v4 = _Utils_Tuple2(ligne.fm, ligne.Di);
				if (!_v4.a.$) {
					return $elm$core$Maybe$Nothing;
				} else {
					if (_v4.b.b && (!_v4.b.b.b)) {
						var _v5 = _v4.b;
						var noeud = _v5.a;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(ligne, noeud));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}
			},
			colonne.gV);
		var memeParent = F2(
			function (premier, noeud) {
				return _Utils_eq(noeud.md, premier.md) && _Utils_eq(noeud.ey, premier.ey);
			});
		var ecrit = function (noeud) {
			return !_Utils_eq(
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$deplacerUnNoeud, noeud.nQ),
				$elm$core$Maybe$Nothing);
		};
		if (noeuds.b) {
			var _v1 = noeuds.a;
			var premier = _v1.b;
			return (_Utils_eq(
				$elm$core$List$length(noeuds),
				$elm$core$List$length(colonne.gV)) && (($elm$core$List$length(noeuds) >= 2) && (A2(
				$elm$core$List$all,
				function (_v2) {
					var noeud = _v2.b;
					return ecrit(noeud) && A2(memeParent, premier, noeud);
				},
				noeuds) && (!_Utils_eq(
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ordonnerLesNoeuds, classification.nQ),
				$elm$core$Maybe$Nothing))))) ? $elm$core$Maybe$Just(
				{
					vj: classification.Aq,
					md: {md: colonne.Dj, IV: $elm$core$Maybe$Nothing},
					gV: A2(
						$elm$core$List$map,
						function (_v3) {
							var ligne = _v3.a;
							var noeud = _v3.b;
							return {
								dy: $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$DeNoeud(noeud.Aq),
								vW: ligne.vW,
								Dj: ligne.Dj
							};
						},
						noeuds),
					F$: $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$DesNoeuds(
						{
							aB: A2(
								$elm$core$List$map,
								function ($) {
									return $.Aq;
								},
								A2(
									$elm$core$List$sortBy,
									function ($) {
										return $.bY;
									},
									A2(
										$elm$core$List$filter,
										function (noeud) {
											return A2(memeParent, premier, noeud) && ecrit(noeud);
										},
										classification.Di))),
							ey: premier.ey
						})
				}) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$ouvrirLesValeurs = F2(
	function (classification, colonne) {
		var lue = function (id) {
			return $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Aq;
						},
						$elm$core$Basics$eq(id)),
					classification.Ki));
		};
		var libres = A2(
			$elm$core$List$filterMap,
			function (ligne) {
				var _v1 = ligne.fm;
				if (!_v1.$) {
					var id = _v1.a;
					return $elm$core$Maybe$Just(
						{
							dy: $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$DeValeur(id),
							vW: ligne.vW,
							Dj: ligne.Dj,
							fm: id
						});
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			colonne.gV);
		var parents = A2(
			$elm$core$List$filterMap,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.fm;
				},
				A2(
					$elm$core$Basics$composeR,
					lue,
					$elm$core$Maybe$map(
						function ($) {
							return $.ey;
						}))),
			libres);
		if (parents.b) {
			var premier = parents.a;
			var reste = parents.b;
			return (_Utils_eq(
				$elm$core$List$length(libres),
				$elm$core$List$length(colonne.gV)) && (($elm$core$List$length(libres) >= 2) && (A2(
				$elm$core$List$all,
				$elm$core$Basics$eq(premier),
				reste) && A2(
				$elm$core$List$all,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.fm;
					},
					A2(
						$elm$core$Basics$composeR,
						lue,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$map(
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.nQ;
									},
									$author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$offre)),
							$elm$core$Maybe$withDefault(false)))),
				libres)))) ? $elm$core$Maybe$Just(
				{
					vj: classification.Aq,
					md: colonne.h6,
					gV: A2(
						$elm$core$List$map,
						function (libre) {
							return {dy: libre.dy, vW: libre.vW, Dj: libre.Dj};
						},
						libres),
					F$: $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$DesValeurs(
						{
							aB: A2(
								$elm$core$List$map,
								function ($) {
									return $.Aq;
								},
								A2(
									$elm$core$List$sortBy,
									function ($) {
										return $.bY;
									},
									A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.ey;
											},
											$elm$core$Basics$eq(premier)),
										classification.Ki))),
							ey: premier
						})
				}) : A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$ouvrirLesNoeuds, classification, colonne);
		} else {
			return A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$ouvrirLesNoeuds, classification, colonne);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$ouvrir = F3(
	function (marques, classification, colonne) {
		if ($author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$desMarques(colonne)) {
			return A3($author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$ouvrirLesMarques, marques, classification, colonne);
		} else {
			var _v0 = A3($author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$ouvrirLesGammes, marques, classification, colonne);
			if (!_v0.$) {
				var ordre = _v0.a;
				return $elm$core$Maybe$Just(ordre);
			} else {
				return A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$ouvrirLesValeurs, classification, colonne);
			}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$ordreOuvert = F2(
	function (rang, model) {
		var _v0 = A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Update$colonne, rang, model);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var typologie = _v1.b;
			var lue = _v1.c;
			var _v2 = A3($author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$ouvrir, model.cU, typologie, lue);
			if (!_v2.$) {
				var ordre = _v2.a;
				return A2(
					$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$versLeDrawerDOrdre,
					$author$project$Components$Shared$Drawer$Update$Ouvrir(
						$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$idDeLOrdre(rang)),
					_Utils_update(
						model,
						{
							oK: $elm$core$Maybe$Nothing,
							El: $elm$core$Maybe$Just(ordre),
							p1: $elm$core$Maybe$Nothing
						}));
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Archivage$Model$cibles = F2(
	function (source, classifications) {
		return A2(
			$elm$core$List$filter,
			function (c) {
				return c.wE && ((!_Utils_eq(c.Aq, source)) && _Utils_eq(
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reactiverLaClassification, c.nQ),
					$elm$core$Maybe$Nothing));
			},
			classifications);
	});
var $author$project$Components$Produits$StructureCatalogue$Typologies$Model$idDuBoutonArchiver = function (id) {
	return 'typologie-' + ($author$project$Catalogue$Identifiants$classificationIdToString(id) + '-archiver');
};
var $author$project$Components$Produits$StructureCatalogue$Archivage$Update$ouvertAvec = F3(
	function (choisir, id, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$archiverLaClassification)),
			A2($author$project$Components$Produits$StructureCatalogue$Archivage$Update$typologieDe, id, model));
		if (!_v0.$) {
			var initial = $author$project$Components$Produits$StructureCatalogue$Archivage$Model$initial;
			var cible = A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Aq;
				},
				A2(
					$elm$core$Maybe$andThen,
					$elm$core$List$head,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.vk;
							},
							$author$project$Components$Produits$StructureCatalogue$Archivage$Model$cibles(id)),
						model.h$)));
			var _v1 = A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				$author$project$Components$Shared$Drawer$Update$Ouvrir(
					$author$project$Components$Produits$StructureCatalogue$Typologies$Model$idDuBoutonArchiver(id)),
				$author$project$Components$Produits$StructureCatalogue$Archivage$Model$initial.kX);
			var drawer = _v1.a;
			var effets = _v1.b;
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Basics$append(
					A2(
						$elm$core$List$map,
						function (_v2) {
							var cible_ = _v2;
							return $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(cible_);
						},
						effets)),
				$author$project$Components$Produits$StructureCatalogue$Archivage$Update$demanderLApercu(
					_Utils_update(
						model,
						{
							tD: choisir(
								_Utils_update(
									initial,
									{
										vf: cible,
										kX: drawer,
										r3: $elm$core$Maybe$Just(id)
									})),
							aL: $elm$core$Maybe$Nothing
						})));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Archivage$Update$ouvert = F2(
	function (id, model) {
		return A3($author$project$Components$Produits$StructureCatalogue$Archivage$Update$ouvertAvec, $elm$core$Basics$identity, id, model);
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$avecDecimales = F2(
	function (decimales, changement) {
		return _Utils_update(
			changement,
			{
				kv: A3($elm$core$Basics$clamp, 0, 2, decimales)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$avecUnite = F2(
	function (unite, changement) {
		return _Utils_update(
			changement,
			{sa: unite});
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$vide = F2(
	function (portee, code) {
		return {kv: 0, nW: '', FS: false, F$: portee, b5: false, r0: code, sa: ''};
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$depuisLeType = F2(
	function (portee, type_) {
		var de = function (code) {
			return $elm$core$Maybe$Just(
				A2($author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$vide, portee, code));
		};
		switch (type_.$) {
			case 9:
				return de($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeFichier);
			case 10:
				var mesure = type_.a;
				return $elm$core$Maybe$Just(
					A2(
						$author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$avecDecimales,
						mesure.kv,
						A2(
							$author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$avecUnite,
							mesure.sa,
							A2($author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$vide, portee, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeMesure))));
			case 21:
				var choix = type_.a;
				return $elm$core$Maybe$Just(
					function (c) {
						return _Utils_update(
							c,
							{FS: choix.FS});
					}(
						A2(
							$author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$avecLaListe,
							choix.ys,
							A2($author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$vide, portee, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeListeUnique))));
			case 18:
				var lien = type_.a;
				return $elm$core$Maybe$Just(
					function (c) {
						return _Utils_update(
							c,
							{FS: lien.FS});
					}(
						A2($author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$vide, portee, $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$typeLienVersDesArticles)));
			default:
				return A2(
					$elm$core$Maybe$andThen,
					function (_v2) {
						var code = _v2.a;
						return de(code);
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (_v1) {
								var simple = _v1.b;
								return _Utils_eq(simple, type_);
							},
							$author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$typesSimples)));
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$avecLesMinima = F2(
	function (actuels, saisie) {
		var texte = A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$core$String$fromInt),
			$elm$core$Maybe$withDefault(''));
		return _Utils_update(
			saisie,
			{
				CC: $elm$core$Maybe$Just(
					{
						Ae: texte(
							A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.Ae;
								},
								actuels)),
						Bd: texte(
							A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.Bd;
								},
								actuels)),
						Jz: A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.Jz;
								},
								actuels))
					})
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$minimaDe = F3(
	function (portee, cle, informations) {
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.CC;
				},
				$elm$core$Dict$get(cle)),
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.F3;
					},
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$filter(
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.F$;
								},
								$elm$core$Basics$eq(portee))),
						$elm$core$List$head)),
				informations));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$minimaDeDepart = F3(
	function (portee, lue, model) {
		var lien = function () {
			if (portee.$ === 3) {
				return $author$project$API$NavLinksDictionary$definirLesMinimaDUnChampFichier;
			} else {
				return $author$project$API$NavLinksDictionary$definirLesMinimaDUnChampHerite;
			}
		}();
		return _Utils_eq(
			A2($author$project$API$Liens$trouver, lien, lue.nQ),
			$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A2(
				$author$project$Components$Shared$EditeurDeSchema$Model$avecLesMinima,
				A3($author$project$Components$Produits$StructureCatalogue$Informations$Model$minimaDe, portee, lue.uN.dy, model.AM),
				$author$project$Components$Shared$EditeurDeSchema$Model$ajout(_List_Nil)));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$renseigneesDuPorteur = F3(
	function (portee, informations, cle) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.qr;
					},
					$elm$core$Dict$get(cle)),
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.F3;
						},
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$filter(
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.F$;
									},
									$elm$core$Basics$eq(portee))),
							$elm$core$List$head)),
					informations)));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$renseignees = F3(
	function (portee, informations, cle) {
		if (portee.$ === 3) {
			var type_ = portee.a;
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.qr;
						},
						$elm$core$Dict$get(cle)),
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dt;
							},
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$filter(
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.fh;
										},
										$elm$core$Basics$eq(type_))),
								$elm$core$List$head)),
						informations)));
		} else {
			return A3($author$project$Components$Produits$StructureCatalogue$Informations$Model$renseigneesDuPorteur, portee, informations, cle);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$ouverte = F3(
	function (portee, cle, model) {
		var _v0 = A3($author$project$Components$Produits$StructureCatalogue$Informations$Model$trouvee, portee, cle, model.AM);
		if (!_v0.$) {
			var lue = _v0.a;
			return A2(
				$author$project$Components$Produits$StructureCatalogue$Informations$Update$versLInformation,
				$author$project$Components$Shared$Drawer$Update$Ouvrir(
					A2($author$project$Components$Produits$StructureCatalogue$Informations$Model$idDeLaPastille, portee, cle)),
				_Utils_update(
					model,
					{
						cy: $elm$core$Maybe$Nothing,
						d5: $elm$core$Maybe$Just(
							{dy: cle, F$: portee}),
						ag: false,
						cV: A3($author$project$Components$Produits$StructureCatalogue$Informations$Update$minimaDeDepart, portee, lue, model),
						c_: lue.uN.he,
						aL: $elm$core$Maybe$Nothing,
						bk: false,
						_: (!A3($author$project$Components$Produits$StructureCatalogue$Informations$Model$renseignees, portee, model.AM, cle)) ? A2($author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$depuisLeType, portee, lue.uN.r0) : $elm$core$Maybe$Nothing
					}));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$Ouverte = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Marques$Update$Ouverte = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$Ouverte = function (a) {
	return {$: 0, a: a};
};
var $author$project$API$NavLinksDictionary$bibliothequeDeChamps = 'bibliotheque-de-champs';
var $author$project$API$NavLinksDictionary$informations = 'informations';
var $author$project$Components$Produits$StructureCatalogue$Update$lectureDesInformations = function (liens) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Effet$LireLesInformations, $elm$core$List$singleton),
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$informations, liens)));
};
var $author$project$Components$Produits$StructureCatalogue$Update$lectureDesListes = function (liens) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Effet$LireLesListes, $elm$core$List$singleton),
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$listes, liens)));
};
var $author$project$Components$Produits$StructureCatalogue$Effet$PourLesCategories = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$changeLeRangement = function (commande) {
	switch (commande.$) {
		case 56:
			return true;
		case 57:
			return true;
		case 54:
			return true;
		case 55:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$structureARelire = F2(
	function (avant, msg) {
		switch (msg.$) {
			case 10:
				var reponse = msg.a;
				var _v1 = A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, avant.l2);
				_v1$2:
				while (true) {
					if (!_v1.$) {
						switch (_v1.a.b.$) {
							case 0:
								var _v2 = _v1.a;
								var _v3 = _v2.b;
								var commande = _v3.a;
								var rendue = _v3.b;
								return $author$project$Components$Produits$StructureCatalogue$Categories$Update$changeLeRangement(commande) && rendue.sy;
							case 1:
								var _v4 = _v1.a;
								var _v5 = _v4.b;
								var erreur = _v5.c;
								switch (erreur.$) {
									case 67:
										return true;
									case 71:
										return true;
									case 72:
										return true;
									default:
										return false;
								}
							default:
								break _v1$2;
						}
					} else {
						break _v1$2;
					}
				}
				return false;
			case 3:
				return _Utils_eq(avant.kk, $elm$core$Maybe$Nothing);
			default:
				return false;
		}
	});
var $author$project$Catalogue$API$WriteAPIModel$ArchiverUnTypeDeProduit = function (a) {
	return {$: 54, a: a};
};
var $author$project$Components$Produits$Common$Effet$LireLaFicheDUneCategorie = function (a) {
	return {$: 27, a: a};
};
var $author$project$Components$Produits$Common$Effet$OuvrirLeType = function (a) {
	return {$: 20, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$RenommerUnTypeDeProduit = F2(
	function (a, b) {
		return {$: 58, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$RetirerUnTypeDUneTypologie = F2(
	function (a, b) {
		return {$: 55, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$API$QueryAPIModel$Annuaire = F3(
	function (types, natures, liens) {
		return {nQ: liens, oo: natures, ib: types};
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$API$QueryAPIModel$naturesDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$sortBy($elm$core$Tuple$first),
		$elm$core$List$map($elm$core$Tuple$second)),
	$elm$json$Json$Decode$list(
		A4(
			$elm$json$Json$Decode$map3,
			F3(
				function (code, libelles, rang) {
					return _Utils_Tuple2(
						rang,
						_Utils_Tuple2(
							code,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.zX;
								},
								libelles)));
				}),
			A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
			$elm$json$Json$Decode$maybe(
				A2($elm$json$Json$Decode$field, 'libelles', $author$project$Catalogue$API$QueryAPIModel$libellesDecoder)),
			A2($elm$json$Json$Decode$field, 'rang', $elm$json$Json$Decode$int))));
var $author$project$Catalogue$API$QueryAPIModel$TypeDeProduit = function (id) {
	return function (nom) {
		return function (nature) {
			return function (version) {
				return function (champs) {
					return function (references) {
						return function (enDouble) {
							return function (archive) {
								return function (places) {
									return function (liens) {
										return {tE: archive, dw: champs, gi: enDouble, Aq: id, nQ: liens, g1: nature, Dj: nom, FP: places, hD: references, sq: version};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Catalogue$API$QueryAPIModel$typeDeProduitDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'places',
		$elm$json$Json$Decode$list($author$project$Catalogue$API$QueryAPIModel$placeDuTypeDecoder),
		_List_Nil,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'archive',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'enDouble',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'references',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'champs',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'version',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'nature',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'nom',
									$author$project$Catalogue$API$QueryAPIModel$libellesDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$author$project$Catalogue$Identifiants$typeDeProduitIdDecoder,
										$elm$json$Json$Decode$succeed($author$project$Catalogue$API$QueryAPIModel$TypeDeProduit)))))))))));
var $author$project$Components$Produits$StructureCatalogue$Categories$API$QueryAPIModel$annuaireDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'natures',
		$author$project$Components$Produits$StructureCatalogue$Categories$API$QueryAPIModel$naturesDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'types',
			$elm$json$Json$Decode$list($author$project$Catalogue$API$QueryAPIModel$typeDeProduitDecoder),
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$Categories$API$QueryAPIModel$Annuaire))));
var $author$project$API$NavLinksDictionary$archiverUnTypeDeProduit = 'archiver-un-type-de-produit';
var $author$project$I18n$Textes$produitsValeursCategorieRefusHorsDuDernierEtage = A3($author$project$I18n$Traductions$texte, 'produits.valeurs.categorie.refus.hors-du-dernier-etage', _List_Nil, 'Cette typologie range ses catégories sous une famille : choisissez-en une.');
var $author$project$I18n$Textes$produitsValeursCategorieRefusTypologieRequise = A3($author$project$I18n$Traductions$texte, 'produits.valeurs.categorie.refus.typologie-requise', _List_Nil, 'Choisissez la typologie où ranger cette catégorie.');
var $author$project$I18n$Textes$produitsValeursCategorieRefusValeurArchivee = A3($author$project$I18n$Traductions$texte, 'produits.valeurs.categorie.refus.valeur-archivee', _List_Nil, 'Cette famille est archivée : l\'écran est mis à jour, choisissez-en une autre.');
var $author$project$I18n$Textes$produitsValeursCategorieRefusValeurInconnue = A3($author$project$I18n$Traductions$texte, 'produits.valeurs.categorie.refus.valeur-inconnue', _List_Nil, 'Cette famille n\'existe plus : l\'écran est mis à jour, choisissez-en une autre.');
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$duRefus = F2(
	function (refus, erreur) {
		var dire = function (texte) {
			return {Jx: texte, b9: refus.b9};
		};
		switch (erreur.$) {
			case 67:
				return dire($author$project$I18n$Textes$produitsValeursCategorieRefusHorsDuDernierEtage);
			case 68:
				return dire($author$project$I18n$Textes$produitsValeursCategorieRefusTypologieRequise);
			case 71:
				return dire($author$project$I18n$Textes$produitsValeursCategorieRefusValeurInconnue);
			case 72:
				return dire($author$project$I18n$Textes$produitsValeursCategorieRefusValeurArchivee);
			default:
				return $author$project$Components$Shared$Messages$Model$duRefus(refus);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$Model$prefixeDuNom = function (model) {
	return $author$project$Components$Shared$Drawer$Model$idRacine(model.kX) + '-nom';
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Model$idDuNom = function (model) {
	return A2(
		$author$project$Components$Shared$LibellesParLangue$View$idDuChamp,
		$author$project$Components$Produits$StructureCatalogue$Categories$Model$prefixeDuNom(model),
		'fr');
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$relire = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$Lire, $elm$core$List$singleton),
			model.np));
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$conclureSansRangement = F2(
	function (issue, model) {
		var saisie = model.hP;
		var cree = A2(
			$elm$core$Basics$composeR,
			$elm$core$List$filterMap(
				function (evenement) {
					if (evenement.$ === 14) {
						var id = evenement.a;
						return $elm$core$Maybe$Just(id);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}),
			$elm$core$List$head);
		switch (issue.$) {
			case 0:
				if (issue.c) {
					var rendue = issue.b;
					var _v1 = _Utils_Tuple2(
						cree(rendue.mk),
						rendue.sy);
					if (!_v1.a.$) {
						if (_v1.b) {
							var id = _v1.a.a;
							return _Utils_Tuple2(
								model,
								_List_fromArray(
									[
										$author$project$Components$Produits$Common$Effet$OuvrirLeType(id)
									]));
						} else {
							var id = _v1.a.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										kk: $elm$core$Maybe$Just(id)
									}),
								_List_fromArray(
									[
										$author$project$Components$Produits$Common$Effet$AttendreAvantDeRelire($author$project$Components$Produits$Common$Envoi$delaiDeRelectureMs)
									]));
						}
					} else {
						var _v2 = _v1.a;
						return _Utils_Tuple2(
							model,
							$author$project$Components$Produits$StructureCatalogue$Categories$Update$relire(model));
					}
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								hP: _Utils_update(
									saisie,
									{
										pZ: $elm$core$Maybe$Just($author$project$Components$Produits$Common$Refus$rejeu)
									})
							}),
						$author$project$Components$Produits$StructureCatalogue$Categories$Update$relire(model));
				}
			case 1:
				switch (issue.c.$) {
					case 0:
						var _v3 = issue.c;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									hP: _Utils_update(
										saisie,
										{gi: true})
								}),
							_List_fromArray(
								[
									$author$project$Components$Produits$Common$Effet$PlacerFocus(
									$author$project$Components$Produits$StructureCatalogue$Categories$Model$idDuNom(model))
								]));
					case 1:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									hP: _Utils_update(
										saisie,
										{gi: true})
								}),
							_List_fromArray(
								[
									$author$project$Components$Produits$Common$Effet$PlacerFocus(
									$author$project$Components$Produits$StructureCatalogue$Categories$Model$idDuNom(model))
								]));
					default:
						var refus = issue.b;
						var erreur = issue.c;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									hP: _Utils_update(
										saisie,
										{
											pZ: $elm$core$Maybe$Just(
												A2($author$project$Components$Produits$StructureCatalogue$Categories$Update$duRefus, refus, erreur))
										})
								}),
							_List_Nil);
				}
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$Model$enCours = function (saisie) {
	return (!_Utils_eq(saisie.R, $author$project$Components$Shared$LibellesParLangue$Model$vide)) || (!_Utils_eq(saisie.g1, saisie.g2));
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{kX: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Produits$Common$Effet$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Produits$StructureCatalogue$Categories$Model$enCours(model.hP)
				},
				geste,
				model.kX));
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$fermer = F2(
	function (rendue, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			function (effets) {
				return _Utils_ap(
					effets,
					rendue.sy ? $author$project$Components$Produits$StructureCatalogue$Categories$Update$relire(model) : _List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$AttendreAvantDeRelire($author$project$Components$Produits$Common$Envoi$delaiDeRelectureMs)
						]));
			},
			A2(
				$author$project$Components$Produits$StructureCatalogue$Categories$Update$versLeDrawer,
				$author$project$Components$Shared$Drawer$Update$Fermer,
				_Utils_update(
					model,
					{hA: $elm$core$Maybe$Nothing})));
	});
var $author$project$I18n$Textes$produitsValeursCategorieExistanteArchivee = A3($author$project$I18n$Traductions$texte, 'produits.valeurs.categorie.existante-archivee', _List_Nil, 'Cette catégorie existe déjà, mais elle est archivée : elle sera restaurée, puis rangée ici.');
var $author$project$I18n$Textes$produitsValeursCategorieExistanteDejaRangee = A3($author$project$I18n$Traductions$texte, 'produits.valeurs.categorie.existante-deja-rangee', _List_Nil, 'Cette catégorie existait déjà et elle est déjà dans cette typologie : rien n\'a changé.');
var $author$project$I18n$Textes$produitsValeursCategorieExistanteRangee = A3($author$project$I18n$Traductions$texte, 'produits.valeurs.categorie.existante-rangee', _List_Nil, 'Cette catégorie existait déjà : elle est maintenant aussi dans cette typologie.');
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$relireLaFiche = function (ouverte) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$LireLaFicheDUneCategorie, $elm$core$List$singleton),
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nQ;
					},
					$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$self)),
				ouverte.zo)));
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$relirePlusTard = F2(
	function (rendue, model) {
		return rendue.sy ? $author$project$Components$Produits$StructureCatalogue$Categories$Update$relire(model) : _List_fromArray(
			[
				$author$project$Components$Produits$Common$Effet$AttendreAvantDeRelire($author$project$Components$Produits$Common$Envoi$delaiDeRelectureMs)
			]);
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$versLeDrawerDeLaCategorie = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{
						uK: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? model.uK : $elm$core$Maybe$Nothing,
						la: drawer
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Produits$Common$Effet$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.la));
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$suiteDuRangement = F3(
	function (rendue, ouverte, model) {
		return ($elm$core$List$isEmpty(ouverte.zF) && $elm$core$List$isEmpty(ouverte.H2)) ? A2(
			$elm$core$Tuple$mapSecond,
			function (effets) {
				return _Utils_ap(
					effets,
					A2($author$project$Components$Produits$StructureCatalogue$Categories$Update$relirePlusTard, rendue, model));
			},
			A2($author$project$Components$Produits$StructureCatalogue$Categories$Update$versLeDrawerDeLaCategorie, $author$project$Components$Shared$Drawer$Update$Fermer, model)) : _Utils_Tuple2(
			model,
			A2($author$project$Components$Produits$StructureCatalogue$Categories$Update$relirePlusTard, rendue, model));
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$surLaCategorie = F2(
	function (modifier, model) {
		return _Utils_update(
			model,
			{
				uK: A2($elm$core$Maybe$map, modifier, model.uK)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$nomEnSaisie = function (nom) {
	return $author$project$Components$Produits$Common$LibellesSaisis$enSaisie(
		{
			yg: A2($elm$core$Maybe$withDefault, '', nom.yg),
			zX: nom.zX
		});
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$versLeRenommage = F2(
	function (geste, model) {
		var enCours = function () {
			var _v1 = model.uK;
			if (!_v1.$) {
				var ouverte = _v1.a;
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (fiche) {
							return !_Utils_eq(
								$author$project$Components$Produits$StructureCatalogue$Categories$Update$nomEnSaisie(fiche.Dj),
								ouverte.Dj);
						},
						ouverte.zo));
			} else {
				return false;
			}
		}();
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{hL: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Produits$Common$Effet$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: enCours},
				geste,
				model.hL));
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$versLeRetrait = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{eW: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Produits$Common$Effet$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.eW));
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$conclure = F2(
	function (issue, model) {
		var cree = A2(
			$elm$core$Basics$composeR,
			$elm$core$List$filterMap(
				function (evenement) {
					if (evenement.$ === 14) {
						var id = evenement.a;
						return $elm$core$Maybe$Just(id);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}),
			$elm$core$List$head);
		var _v0 = _Utils_Tuple2(issue, model.hA);
		_v0$4:
		while (true) {
			if (!_v0.b.$) {
				switch (_v0.a.$) {
					case 0:
						if (_v0.a.c) {
							switch (_v0.a.a.$) {
								case 12:
									var _v1 = _v0.a;
									var rendue = _v1.b;
									var rangement = _v0.b.a;
									var _v2 = cree(rendue.mk);
									if (!_v2.$) {
										var id = _v2.a;
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{
													hA: $elm$core$Maybe$Just(
														_Utils_update(
															rangement,
															{
																iz: $elm$core$Maybe$Just(id),
																tY: true
															}))
												}),
											_List_Nil);
									} else {
										return A2($author$project$Components$Produits$StructureCatalogue$Categories$Update$fermer, rendue, model);
									}
								case 56:
									var _v3 = _v0.a;
									var _v4 = _v3.a;
									var rendue = _v3.b;
									var existante = _v0.b.a.y1;
									var archivee = _v0.b.a.tI;
									if (existante && (!archivee)) {
										var texte = $elm$core$List$isEmpty(rendue.mk) ? $author$project$I18n$Textes$produitsValeursCategorieExistanteDejaRangee : $author$project$I18n$Textes$produitsValeursCategorieExistanteRangee;
										var saisie = model.hP;
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{
													hP: _Utils_update(
														saisie,
														{
															pZ: $elm$core$Maybe$Just(
																{Jx: texte, b9: $elm$core$Maybe$Nothing})
														})
												}),
											A2($author$project$Components$Produits$StructureCatalogue$Categories$Update$relirePlusTard, rendue, model));
									} else {
										return A2($author$project$Components$Produits$StructureCatalogue$Categories$Update$fermer, rendue, model);
									}
								default:
									break _v0$4;
							}
						} else {
							break _v0$4;
						}
					case 1:
						if ((_v0.a.a.$ === 12) && (_v0.a.c.$ === 1)) {
							var _v5 = _v0.a;
							var homonyme = _v5.c.a;
							var rangement = _v0.b.a;
							var saisie = model.hP;
							return homonyme.tE ? _Utils_Tuple2(
								_Utils_update(
									model,
									{
										hA: $elm$core$Maybe$Just(
											_Utils_update(
												rangement,
												{
													iz: $elm$core$Maybe$Just(homonyme.y0),
													tI: true,
													tY: false,
													y1: true
												})),
										hP: _Utils_update(
											saisie,
											{
												gi: false,
												pZ: $elm$core$Maybe$Just(
													{Jx: $author$project$I18n$Textes$produitsValeursCategorieExistanteArchivee, b9: $elm$core$Maybe$Nothing})
											})
									}),
								_List_Nil) : _Utils_Tuple2(
								_Utils_update(
									model,
									{
										hA: $elm$core$Maybe$Just(
											_Utils_update(
												rangement,
												{
													iz: $elm$core$Maybe$Just(homonyme.y0),
													tY: true,
													y1: true
												}))
									}),
								_List_Nil);
						} else {
							break _v0$4;
						}
					default:
						break _v0$4;
				}
			} else {
				var _v6 = _v0.b;
				var _v7 = _Utils_Tuple2(issue, model.uK);
				_v7$7:
				while (true) {
					if (!_v7.b.$) {
						switch (_v7.a.$) {
							case 0:
								if (_v7.a.c) {
									switch (_v7.a.a.$) {
										case 58:
											var _v8 = _v7.a;
											var _v9 = _v8.a;
											var rendue = _v8.b;
											var ouverte = _v7.b.a;
											return A2(
												$elm$core$Tuple$mapSecond,
												function (effets) {
													return _Utils_ap(
														effets,
														_Utils_ap(
															A2($author$project$Components$Produits$StructureCatalogue$Categories$Update$relirePlusTard, rendue, model),
															$author$project$Components$Produits$StructureCatalogue$Categories$Update$relireLaFiche(ouverte)));
												},
												A2($author$project$Components$Produits$StructureCatalogue$Categories$Update$versLeRenommage, $author$project$Components$Shared$Drawer$Update$Fermer, model));
										case 56:
											var _v10 = _v7.a;
											var _v11 = _v10.a;
											var rendue = _v10.b;
											var ouverte = _v7.b.a;
											return A3($author$project$Components$Produits$StructureCatalogue$Categories$Update$suiteDuRangement, rendue, ouverte, model);
										case 57:
											var _v12 = _v7.a;
											var _v13 = _v12.a;
											var rendue = _v12.b;
											var ouverte = _v7.b.a;
											return A3($author$project$Components$Produits$StructureCatalogue$Categories$Update$suiteDuRangement, rendue, ouverte, model);
										case 55:
											var _v14 = _v7.a;
											var _v15 = _v14.a;
											var rendue = _v14.b;
											return A2(
												$elm$core$Tuple$mapSecond,
												function (effets) {
													return _Utils_ap(
														effets,
														A2($author$project$Components$Produits$StructureCatalogue$Categories$Update$relirePlusTard, rendue, model));
												},
												A2(
													$author$project$Components$Produits$StructureCatalogue$Categories$Update$versLeDrawerDeLaCategorie,
													$author$project$Components$Shared$Drawer$Update$Fermer,
													A2($author$project$Components$Produits$StructureCatalogue$Categories$Update$versLeRetrait, $author$project$Components$Shared$Drawer$Update$Fermer, model).a));
										case 54:
											var _v16 = _v7.a;
											var rendue = _v16.b;
											return A2(
												$elm$core$Tuple$mapSecond,
												function (effets) {
													return _Utils_ap(
														effets,
														A2($author$project$Components$Produits$StructureCatalogue$Categories$Update$relirePlusTard, rendue, model));
												},
												A2($author$project$Components$Produits$StructureCatalogue$Categories$Update$versLeDrawerDeLaCategorie, $author$project$Components$Shared$Drawer$Update$Fermer, model));
										default:
											break _v7$7;
									}
								} else {
									var _v17 = _v7.a;
									return _Utils_Tuple2(
										A2(
											$author$project$Components$Produits$StructureCatalogue$Categories$Update$surLaCategorie,
											function (ouverte) {
												return _Utils_update(
													ouverte,
													{
														zF: _List_Nil,
														pZ: $elm$core$Maybe$Just($author$project$Components$Produits$Common$Refus$rejeu),
														H2: _List_Nil
													});
											},
											model),
										_List_Nil);
								}
							case 1:
								var _v18 = _v7.a;
								var refus = _v18.b;
								var erreur = _v18.c;
								return _Utils_Tuple2(
									A2(
										$author$project$Components$Produits$StructureCatalogue$Categories$Update$surLaCategorie,
										function (ouverte) {
											return _Utils_update(
												ouverte,
												{
													zF: _List_Nil,
													pZ: $elm$core$Maybe$Just(
														A2($author$project$Components$Produits$StructureCatalogue$Categories$Update$duRefus, refus, erreur)),
													H2: _List_Nil
												});
										},
										model),
									_List_Nil);
							default:
								break _v7$7;
						}
					} else {
						break _v7$7;
					}
				}
				return A2($author$project$Components$Produits$StructureCatalogue$Categories$Update$conclureSansRangement, issue, model);
			}
		}
		return A2($author$project$Components$Produits$StructureCatalogue$Categories$Update$conclureSansRangement, issue, model);
	});
var $author$project$API$NavLinksDictionary$creerUnType = 'creer-un-type';
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$creation = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.nQ;
			},
			$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$creerUnType)),
		model.aS);
};
var $author$project$Catalogue$API$WriteAPIModel$CreerUnType = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Model$commandeDeCreation = F2(
	function (annuaire, saisie) {
		return A3(
			$elm$core$Maybe$map2,
			F2(
				function (lien, nom) {
					return _Utils_Tuple2(
						$author$project$Catalogue$API$WriteAPIModel$CreerUnType(
							{g1: saisie.g1, Dj: nom}),
						lien);
				}),
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUnType, annuaire.nQ),
			$author$project$Components$Produits$Common$LibellesSaisis$versLApi(saisie.R));
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$creerLaCategorie = F3(
	function (saisie, lue, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (annuaire) {
				return A2($author$project$Components$Produits$StructureCatalogue$Categories$Model$commandeDeCreation, annuaire, saisie);
			},
			lue);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var commande = _v1.a;
			var lien = _v1.b;
			var _v2 = A3(
				$author$project$Components$Produits$Common$Envoi$partir,
				$elm$core$Maybe$Just(lien),
				commande,
				model.l2);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var envoi = _v3.a;
				var effets = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: envoi,
							hP: _Utils_update(
								saisie,
								{gi: false, pZ: $elm$core$Maybe$Nothing})
						}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_eq(
				$author$project$Components$Produits$StructureCatalogue$Categories$Update$creation(model),
				$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : _Utils_Tuple2(
				_Utils_update(
					model,
					{
						hP: _Utils_update(
							saisie,
							{b5: true})
					}),
				_List_fromArray(
					[
						$author$project$Components$Produits$Common$Effet$PlacerFocus(
						$author$project$Components$Produits$StructureCatalogue$Categories$Model$idDuNom(model))
					]));
		}
	});
var $author$project$Catalogue$API$WriteAPIModel$AjouterUneCategorie = F3(
	function (a, b, c) {
		return {$: 56, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$ranger = function (model) {
	var _v0 = model.hA;
	if (!_v0.$) {
		var rangement = _v0.a;
		var _v1 = rangement.iz;
		if (!_v1.$) {
			var categorie = _v1.a;
			var ouverture = rangement.ew;
			var _v2 = A3(
				$author$project$Components$Produits$Common$Envoi$partir,
				$elm$core$Maybe$Just(ouverture.nB),
				A3($author$project$Catalogue$API$WriteAPIModel$AjouterUneCategorie, categorie, ouverture.vj, ouverture.IV),
				model.l2);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var envoi = _v3.a;
				var effets = _v3.b;
				var saisie = model.hP;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: envoi,
							hA: $elm$core$Maybe$Just(
								_Utils_update(
									rangement,
									{tY: false})),
							hP: _Utils_update(
								saisie,
								{pZ: $elm$core$Maybe$Nothing})
						}),
					effets);
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hA: $elm$core$Maybe$Just(
								_Utils_update(
									rangement,
									{tY: true}))
						}),
					_List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$creer = function (model) {
	var saisie = model.hP;
	var _v0 = _Utils_Tuple2(
		A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.iz;
			},
			model.hA),
		model.aS);
	if (!_v0.a.$) {
		return $author$project$Components$Produits$StructureCatalogue$Categories$Update$ranger(model);
	} else {
		var _v1 = _v0.a;
		var annuaire = _v0.b;
		return A3($author$project$Components$Produits$StructureCatalogue$Categories$Update$creerLaCategorie, saisie, annuaire, model);
	}
};
var $author$project$Catalogue$API$WriteAPIModel$RetirerUnNoeud = F2(
	function (a, b) {
		return {$: 57, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$retirerLeSuivant = F2(
	function (model, ouverte) {
		var _v0 = _Utils_Tuple2(ouverte.H2, ouverte.BI);
		if (_v0.a.b && (!_v0.b.$)) {
			var _v1 = _v0.a;
			var noeud = _v1.a;
			var reste = _v1.b;
			var lien = _v0.b.a;
			var _v2 = A3(
				$author$project$Components$Produits$Common$Envoi$partir,
				$elm$core$Maybe$Just(lien),
				A2($author$project$Catalogue$API$WriteAPIModel$RetirerUnNoeud, ouverte.r3, noeud),
				model.l2);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var envoi = _v3.a;
				var effets = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uK: $elm$core$Maybe$Just(
								_Utils_update(
									ouverte,
									{H2: reste})),
							l2: envoi
						}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$envoyerLaFile = function (model) {
	var _v0 = model.uK;
	if (!_v0.$) {
		var ouverte = _v0.a;
		var file = ouverte.zF;
		var lienDeLaFile = ouverte.BB;
		var _v1 = _Utils_Tuple2(file, lienDeLaFile);
		if (!_v1.a.b) {
			return A2($author$project$Components$Produits$StructureCatalogue$Categories$Update$retirerLeSuivant, model, ouverte);
		} else {
			if (!_v1.b.$) {
				var _v2 = _v1.a;
				var valeur = _v2.a;
				var reste = _v2.b;
				var lien = _v1.b.a;
				var _v3 = A3(
					$author$project$Components$Produits$Common$Envoi$partir,
					$elm$core$Maybe$Just(lien),
					A3(
						$author$project$Catalogue$API$WriteAPIModel$AjouterUneCategorie,
						ouverte.Aq,
						ouverte.r3,
						$elm$core$Maybe$Just(valeur)),
					model.l2);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var envoi = _v4.a;
					var effets = _v4.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								uK: $elm$core$Maybe$Just(
									_Utils_update(
										ouverte,
										{zF: reste})),
								l2: envoi
							}),
						effets);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$envoyerSurLaFiche = F3(
	function (rel, commande, model) {
		var _v0 = A3(
			$author$project$Components$Produits$Common$Envoi$partir,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nQ;
					},
					$author$project$API$Liens$trouver(rel)),
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.zo;
					},
					model.uK)),
			commande,
			model.l2);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var envoi = _v1.a;
			var effets = _v1.b;
			return _Utils_Tuple2(
				A2(
					$author$project$Components$Produits$StructureCatalogue$Categories$Update$surLaCategorie,
					function (ouverte) {
						return _Utils_update(
							ouverte,
							{pZ: $elm$core$Maybe$Nothing});
					},
					_Utils_update(
						model,
						{l2: envoi})),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$API$QueryAPIModel$ficheDecoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (categorie, liens) {
			return _Utils_update(
				categorie,
				{nQ: liens});
		}),
	A2($elm$json$Json$Decode$field, 'typeDeProduit', $author$project$Catalogue$API$QueryAPIModel$typeDeProduitDecoder),
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource));
var $author$project$Components$Produits$StructureCatalogue$Categories$Model$idDeLaCreation = 'types-creer';
var $author$project$Components$Produits$StructureCatalogue$Categories$Model$idDuRenommer = 'categorie-renommer';
var $author$project$Components$Produits$StructureCatalogue$Categories$Model$idDuRetirer = 'categorie-retirer-de-la-typologie';
var $author$project$Components$Produits$StructureCatalogue$Categories$Model$ouvert = function (lecture) {
	return _Utils_update(
		$author$project$Components$Produits$StructureCatalogue$Categories$Model$init,
		{np: lecture});
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Model$ouvrirLaSaisie = function (model) {
	return _Utils_update(
		model,
		{
			hP: $author$project$Components$Produits$StructureCatalogue$Categories$Model$saisieVide(
				function () {
					var _v0 = model.oo;
					if (_v0.b) {
						var _v1 = _v0.a;
						var code = _v1.a;
						return code;
					} else {
						return A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$andThen,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.oo;
									},
									A2(
										$elm$core$Basics$composeR,
										$elm$core$List$head,
										$elm$core$Maybe$map($elm$core$Tuple$first))),
								model.aS));
					}
				}())
		});
};
var $author$project$API$NavLinksDictionary$renommerUnTypeDeProduit = 'renommer-un-type-de-produit';
var $author$project$API$NavLinksDictionary$retirerUnTypeDUneTypologie = 'retirer-un-type-d-une-typologie';
var $author$project$Components$Shared$LibellesParLangue$Model$obligatoire = F2(
	function (langues, code) {
		return A2(
			$elm$core$List$any,
			function (langue) {
				return _Utils_eq(langue.vx, code) && langue.he;
			},
			langues);
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$Model$saisir = F2(
	function (champ, saisie) {
		if (!champ.$) {
			var langue = champ.a;
			var texte = champ.b;
			return _Utils_update(
				saisie,
				{
					gi: saisie.gi && (!A2($author$project$Components$Shared$LibellesParLangue$Model$obligatoire, $author$project$Referentiel$Langues$desLibelles, langue)),
					R: A3($author$project$Components$Shared$LibellesParLangue$Model$ecrire, langue, texte, saisie.R)
				});
		} else {
			var code = champ.a;
			return _Utils_update(
				saisie,
				{g1: code});
		}
	});
var $author$project$API$NavLinksDictionary$typesDeProduit = 'types-de-produit';
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var liens = msg.a;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$typesDeProduit, liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						$author$project$Components$Produits$StructureCatalogue$Categories$Model$ouvert(
							$elm$core$Maybe$Just(lecture)),
						_List_fromArray(
							[
								$author$project$Components$Produits$Common$Effet$DemanderProcessUid,
								$author$project$Components$Produits$Common$Effet$Lire(lecture)
							]));
				} else {
					return _Utils_Tuple2(
						$author$project$Components$Produits$StructureCatalogue$Categories$Model$ouvert($elm$core$Maybe$Nothing),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				var recu = _Utils_update(
					model,
					{
						l2: A2($author$project$Components$Produits$Common$Envoi$recevoir, octets, model.l2)
					});
				var _v2 = recu.hA;
				if (!_v2.$) {
					var auProcessUid = _v2.a.tY;
					return auProcessUid ? $author$project$Components$Produits$StructureCatalogue$Categories$Update$ranger(recu) : _Utils_Tuple2(recu, _List_Nil);
				} else {
					return $author$project$Components$Produits$StructureCatalogue$Categories$Update$envoyerLaFile(recu);
				}
			case 2:
				var reponse = msg.a;
				var _v3 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$StructureCatalogue$Categories$API$QueryAPIModel$annuaireDecoder, reponse);
				if (!_v3.$) {
					var annuaire = _v3.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aS: $elm$core$Maybe$Just(annuaire)
							}),
						_List_Nil);
				} else {
					var refus = _v3.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 3:
				var _v4 = model.kk;
				if (!_v4.$) {
					var id = _v4.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{kk: $elm$core$Maybe$Nothing}),
						_List_fromArray(
							[
								$author$project$Components$Produits$Common$Effet$OuvrirLeType(id)
							]));
				} else {
					return _Utils_Tuple2(
						model,
						$author$project$Components$Produits$StructureCatalogue$Categories$Update$relire(model));
				}
			case 4:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Categories$Update$versLeDrawer, geste, model);
			case 5:
				return _Utils_eq(
					$author$project$Components$Produits$StructureCatalogue$Categories$Update$creation(model),
					$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A2(
					$author$project$Components$Produits$StructureCatalogue$Categories$Update$versLeDrawer,
					$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Produits$StructureCatalogue$Categories$Model$idDeLaCreation),
					$author$project$Components$Produits$StructureCatalogue$Categories$Model$ouvrirLaSaisie(
						_Utils_update(
							model,
							{hA: $elm$core$Maybe$Nothing})));
			case 6:
				var ouverture = msg.a;
				return _Utils_eq(
					$author$project$Components$Produits$StructureCatalogue$Categories$Update$creation(model),
					$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A2(
					$author$project$Components$Produits$StructureCatalogue$Categories$Update$versLeDrawer,
					$author$project$Components$Shared$Drawer$Update$Ouvrir(ouverture.xe),
					$author$project$Components$Produits$StructureCatalogue$Categories$Model$ouvrirLaSaisie(
						_Utils_update(
							model,
							{
								hA: $elm$core$Maybe$Just(
									{iz: $elm$core$Maybe$Nothing, tI: false, tY: false, y1: false, ew: ouverture})
							})));
			case 7:
				var champ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hA: A2(
								$elm$core$Maybe$map,
								function (rangement) {
									return rangement.tI ? _Utils_update(
										rangement,
										{iz: $elm$core$Maybe$Nothing, tI: false, y1: false}) : rangement;
								},
								model.hA),
							hP: A2($author$project$Components$Produits$StructureCatalogue$Categories$Model$saisir, champ, model.hP)
						}),
					_List_Nil);
			case 8:
				return $author$project$Components$Produits$StructureCatalogue$Categories$Update$creer(model);
			case 9:
				var fermeture = function (drawer) {
					return A3(
						$author$project$Components$Shared$Drawer$Update$update,
						{Il: false},
						$author$project$Components$Shared$Drawer$Update$Fermer,
						drawer).a;
				};
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							kX: fermeture(model.kX),
							la: fermeture(model.la),
							hL: fermeture(model.hL)
						}),
					_List_Nil);
			case 11:
				var ouverture = msg.a;
				var _v5 = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(ouverture.uK)),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.ib;
								},
								model.aS))));
				if (!_v5.$) {
					var categorie = _v5.a;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$LireLaFicheDUneCategorie, $elm$core$List$singleton),
									A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$self, categorie.nQ)))),
						A2(
							$author$project$Components$Produits$StructureCatalogue$Categories$Update$versLeDrawerDeLaCategorie,
							$author$project$Components$Shared$Drawer$Update$Ouvrir(ouverture.xe),
							_Utils_update(
								model,
								{
									uK: $elm$core$Maybe$Just(
										{
											L: _List_Nil,
											zo: $elm$core$Maybe$Nothing,
											zF: _List_Nil,
											Aq: categorie.Aq,
											BB: $elm$core$Maybe$Nothing,
											BI: $elm$core$Maybe$Nothing,
											Dj: $author$project$Components$Produits$StructureCatalogue$Categories$Update$nomEnSaisie(categorie.Dj),
											pZ: $elm$core$Maybe$Nothing,
											H2: _List_Nil,
											r3: ouverture.r3
										})
								})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 12:
				var reponse = msg.a;
				var _v6 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$StructureCatalogue$Categories$API$QueryAPIModel$ficheDecoder, reponse);
				if (!_v6.$) {
					var fiche = _v6.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Produits$StructureCatalogue$Categories$Update$surLaCategorie,
							function (ouverte) {
								return _Utils_eq(ouverte.Aq, fiche.Aq) ? _Utils_update(
									ouverte,
									{
										zo: $elm$core$Maybe$Just(fiche),
										Dj: $author$project$Components$Produits$StructureCatalogue$Categories$Update$nomEnSaisie(fiche.Dj)
									}) : ouverte;
							},
							model),
						_List_Nil);
				} else {
					var refus = _v6.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 13:
				var geste = msg.a;
				return A2($author$project$Components$Produits$Common$Envoi$retientLeDrawer, model.l2, geste) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Produits$StructureCatalogue$Categories$Update$versLeDrawerDeLaCategorie, geste, model);
			case 14:
				var valeur = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Produits$StructureCatalogue$Categories$Update$surLaCategorie,
						function (ouverte) {
							return _Utils_update(
								ouverte,
								{
									L: A2($elm$core$List$member, valeur, ouverte.L) ? A2(
										$elm$core$List$filter,
										$elm$core$Basics$neq(valeur),
										ouverte.L) : _Utils_ap(
										ouverte.L,
										_List_fromArray(
											[valeur]))
								});
						},
						model),
					_List_Nil);
			case 15:
				var demande = msg.a;
				return $author$project$Components$Produits$StructureCatalogue$Categories$Update$envoyerLaFile(
					A2(
						$author$project$Components$Produits$StructureCatalogue$Categories$Update$surLaCategorie,
						function (ouverte) {
							return _Utils_update(
								ouverte,
								{zF: demande.fx, BB: demande.hA, BI: demande.eW, pZ: $elm$core$Maybe$Nothing, H2: demande.H2});
						},
						model));
			case 16:
				var _v7 = model.uK;
				if (!_v7.$) {
					var ouverte = _v7.a;
					return A3(
						$author$project$Components$Produits$StructureCatalogue$Categories$Update$envoyerSurLaFiche,
						$author$project$API$NavLinksDictionary$archiverUnTypeDeProduit,
						$author$project$Catalogue$API$WriteAPIModel$ArchiverUnTypeDeProduit(ouverte.Aq),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 17:
				return A2(
					$author$project$Components$Produits$StructureCatalogue$Categories$Update$versLeRenommage,
					$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Produits$StructureCatalogue$Categories$Model$idDuRenommer),
					A2(
						$author$project$Components$Produits$StructureCatalogue$Categories$Update$surLaCategorie,
						function (ouverte) {
							return _Utils_update(
								ouverte,
								{
									Dj: A2(
										$elm$core$Maybe$withDefault,
										ouverte.Dj,
										A2(
											$elm$core$Maybe$map,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.Dj;
												},
												$author$project$Components$Produits$StructureCatalogue$Categories$Update$nomEnSaisie),
											ouverte.zo))
								});
						},
						model));
			case 18:
				var geste = msg.a;
				return A2($author$project$Components$Produits$Common$Envoi$retientLeDrawer, model.l2, geste) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Produits$StructureCatalogue$Categories$Update$versLeRenommage, geste, model);
			case 19:
				var langue = msg.a;
				var texte = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Produits$StructureCatalogue$Categories$Update$surLaCategorie,
						function (ouverte) {
							return _Utils_update(
								ouverte,
								{
									Dj: A3($author$project$Components$Shared$LibellesParLangue$Model$ecrire, langue, texte, ouverte.Dj)
								});
						},
						model),
					_List_Nil);
			case 20:
				var _v8 = A2(
					$elm$core$Maybe$andThen,
					function (ouverte) {
						return A2(
							$elm$core$Maybe$map,
							$elm$core$Tuple$pair(ouverte),
							$author$project$Components$Produits$Common$LibellesSaisis$versLApi(ouverte.Dj));
					},
					model.uK);
				if (!_v8.$) {
					var _v9 = _v8.a;
					var ouverte = _v9.a;
					var nom = _v9.b;
					return A3(
						$author$project$Components$Produits$StructureCatalogue$Categories$Update$envoyerSurLaFiche,
						$author$project$API$NavLinksDictionary$renommerUnTypeDeProduit,
						A2($author$project$Catalogue$API$WriteAPIModel$RenommerUnTypeDeProduit, ouverte.Aq, nom),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 21:
				return _Utils_eq(
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.nQ;
							},
							$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$retirerUnTypeDUneTypologie)),
						A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.zo;
							},
							model.uK))) ? _Utils_Tuple2(model, _List_Nil) : A2(
					$author$project$Components$Produits$StructureCatalogue$Categories$Update$versLeRetrait,
					$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Produits$StructureCatalogue$Categories$Model$idDuRetirer),
					model);
			case 22:
				var geste = msg.a;
				return A2($author$project$Components$Produits$Common$Envoi$retientLeDrawer, model.l2, geste) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Produits$StructureCatalogue$Categories$Update$versLeRetrait, geste, model);
			case 23:
				var _v10 = model.uK;
				if (!_v10.$) {
					var ouverte = _v10.a;
					return A3(
						$author$project$Components$Produits$StructureCatalogue$Categories$Update$envoyerSurLaFiche,
						$author$project$API$NavLinksDictionary$retirerUnTypeDUneTypologie,
						A2($author$project$Catalogue$API$WriteAPIModel$RetirerUnTypeDUneTypologie, ouverte.Aq, ouverte.r3),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			default:
				var reponse = msg.a;
				var _v11 = A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, model.l2);
				if (!_v11.$) {
					var _v12 = _v11.a;
					var envoi = _v12.a;
					var issue = _v12.b;
					var effets = _v12.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Produits$StructureCatalogue$Categories$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Update$versLesCategories = F2(
	function (geste, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			function (effets) {
				return _Utils_ap(
					effets,
					A2($author$project$Components$Produits$StructureCatalogue$Categories$Update$structureARelire, model.dt, geste) ? $author$project$Components$Produits$StructureCatalogue$Commandes$relire(model) : _List_Nil);
			},
			A3(
				$elm$core$Tuple$mapBoth,
				function (categories) {
					return _Utils_update(
						model,
						{dt: categories});
				},
				$elm$core$List$map($author$project$Components$Produits$StructureCatalogue$Effet$PourLesCategories),
				A2($author$project$Components$Produits$StructureCatalogue$Categories$Update$update, geste, model.dt)));
	});
var $author$project$Components$Produits$StructureCatalogue$Effet$PourLesProduits = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$structureARelire = F2(
	function (avant, msg) {
		switch (msg.$) {
			case 16:
				var reponse = msg.a;
				var _v1 = A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, avant.l2);
				_v1$2:
				while (true) {
					if ((!_v1.$) && (!_v1.a.b.$)) {
						switch (_v1.a.b.a.$) {
							case 34:
								var _v2 = _v1.a;
								var _v3 = _v2.b;
								var rendue = _v3.b;
								var repondue = _v3.c;
								return repondue && (rendue.sy && (!$elm$core$List$isEmpty(rendue.mk)));
							case 36:
								var _v4 = _v1.a;
								var _v5 = _v4.b;
								var rendue = _v5.b;
								var repondue = _v5.c;
								return repondue && (rendue.sy && (!$elm$core$List$isEmpty(rendue.mk)));
							default:
								break _v1$2;
						}
					} else {
						break _v1$2;
					}
				}
				return false;
			case 10:
				return true;
			default:
				return false;
		}
	});
var $author$project$Catalogue$API$WriteAPIModel$ArchiverLeProduit = function (a) {
	return {$: 36, a: a};
};
var $author$project$Components$Produits$Common$ArchivageDuProduit$commande = F2(
	function (produit, archivage) {
		return archivage.aW ? A2(
			$elm$core$Maybe$map,
			function (lien) {
				return _Utils_Tuple2(
					$author$project$Catalogue$API$WriteAPIModel$ArchiverLeProduit(produit),
					lien);
			},
			archivage.nB) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$Produits$StructureCatalogue$Produits$Restriction$commandeDArchivage = function (restriction) {
	return A2($author$project$Components$Produits$Common$ArchivageDuProduit$commande, restriction.Gp, restriction.tD);
};
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$archiver = function (model) {
	var _v0 = A2($elm$core$Maybe$andThen, $author$project$Components$Produits$StructureCatalogue$Produits$Restriction$commandeDArchivage, model.al);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var commande = _v1.a;
		var lien = _v1.b;
		var _v2 = A3(
			$author$project$Components$Produits$Common$Envoi$partir,
			$elm$core$Maybe$Just(lien),
			commande,
			model.l2);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var envoi = _v3.a;
			var effets = _v3.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi, p4: $elm$core$Maybe$Nothing}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Produits$Restriction$cocher = F3(
	function (id, voulue, restriction) {
		return _Utils_update(
			restriction,
			{
				vv: voulue ? (A2($elm$core$List$member, id, restriction.vv) ? restriction.vv : _Utils_ap(
					restriction.vv,
					_List_fromArray(
						[id]))) : A2(
					$elm$core$List$filter,
					$elm$core$Basics$neq(id),
					restriction.vv)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Produits$Restriction$Archive = {$: 4};
var $author$project$Components$Produits$StructureCatalogue$Produits$Restriction$archivee = F2(
	function (archivage, restriction) {
		return _Utils_update(
			restriction,
			{
				tD: archivage,
				np: archivage.tE ? $author$project$Components$Produits$StructureCatalogue$Produits$Restriction$Archive : restriction.np
			});
	});
var $author$project$Components$Produits$Common$ArchivageDuProduit$renoncer = function (archivage) {
	return _Utils_update(
		archivage,
		{aW: false});
};
var $author$project$Components$Produits$Common$ArchivageDuProduit$conclure = F3(
	function (contexte, issue, archivage) {
		_v0$3:
		while (true) {
			switch (issue.$) {
				case 0:
					if (issue.a.$ === 36) {
						if (issue.c) {
							var rendue = issue.b;
							return $elm$core$Maybe$Just(
								{
									tD: _Utils_update(
										archivage,
										{tE: true, aW: false, nB: $elm$core$Maybe$Nothing}),
									pZ: $elm$core$Maybe$Nothing,
									eQ: !rendue.sy
								});
						} else {
							return $elm$core$Maybe$Just(
								{
									tD: $author$project$Components$Produits$Common$ArchivageDuProduit$renoncer(archivage),
									pZ: $elm$core$Maybe$Just($author$project$Components$Produits$Common$Refus$rejeu),
									eQ: false
								});
						}
					} else {
						break _v0$3;
					}
				case 1:
					if (issue.a.$ === 36) {
						var refus = issue.b;
						var erreur = issue.c;
						return $elm$core$Maybe$Just(
							{
								tD: $author$project$Components$Produits$Common$ArchivageDuProduit$renoncer(archivage),
								pZ: $elm$core$Maybe$Just(
									A3($author$project$Components$Produits$Common$Refus$message, contexte, refus, erreur)),
								eQ: false
							});
					} else {
						break _v0$3;
					}
				default:
					break _v0$3;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Components$Produits$Common$Saisie$DeProduit = 2;
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$contexte = function (model) {
	var tournures = $author$project$Catalogue$Vocabulaire$tournures(
		{fA: $author$project$Catalogue$Vocabulaire$codeProduit, Bl: $elm$core$Maybe$Nothing});
	return {
		aV: A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$I18n$Traductions$tel),
		gi: tournures.gi,
		Dj: A2($author$project$Components$Produits$Common$Saisie$nomSaisi, 2, model.hP),
		fd: tournures
	};
};
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$concluLArchivage = F2(
	function (issue, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (ouverte) {
				return A3(
					$author$project$Components$Produits$Common$ArchivageDuProduit$conclure,
					$author$project$Components$Produits$StructureCatalogue$Produits$Update$contexte(model),
					issue,
					ouverte.tD);
			},
			model.al);
		if (!_v0.$) {
			var conclusion = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						p4: conclusion.pZ,
						al: A2(
							$elm$core$Maybe$map,
							$author$project$Components$Produits$StructureCatalogue$Produits$Restriction$archivee(conclusion.tD),
							model.al)
					}),
				conclusion.eQ ? _List_fromArray(
					[
						$author$project$Components$Produits$Common$Effet$AttendreAvantDeRelire($author$project$Components$Produits$Common$Envoi$delaiDeRelectureMs)
					]) : _List_Nil);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$estUneCreation = function (evenement) {
	if (evenement.$ === 36) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$estUneExtension = function (evenement) {
	if (evenement.$ === 50) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{kX: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Produits$Common$Effet$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Produits$Common$Saisie$enCours(model.hP)
				},
				geste,
				model.kX));
	});
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$fermerApresCreation = F2(
	function (rendue, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			function (effets) {
				return _Utils_ap(
					effets,
					rendue.sy ? _List_Nil : _List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$AttendreAvantDeRelire($author$project$Components$Produits$Common$Envoi$delaiDeRelectureMs)
						]));
			},
			A2(
				$author$project$Components$Produits$StructureCatalogue$Produits$Update$versLeDrawer,
				$author$project$Components$Shared$Drawer$Update$Fermer,
				_Utils_update(
					model,
					{hP: $author$project$Components$Produits$Common$Saisie$vide})));
	});
var $author$project$Components$Produits$StructureCatalogue$Produits$Model$idDuNom = function (model) {
	return A2(
		$author$project$Components$Produits$Common$Formulaire$idDuNom,
		2,
		$author$project$Components$Shared$Drawer$Model$idRacine(model.kX));
};
var $author$project$I18n$Textes$produitsValeursProduitExistantDejaDans = A3($author$project$I18n$Traductions$texte, 'produits.valeurs.produit.existant-deja-dans', _List_Nil, 'Ce produit existait déjà et couvre déjà ces marques et ces gammes : rien n\'a changé.');
var $author$project$I18n$Textes$produitsValeursProduitExistantEtendu = A3($author$project$I18n$Traductions$texte, 'produits.valeurs.produit.existant-etendu', _List_Nil, 'Ce produit existait déjà : il couvre maintenant aussi ces marques et ces gammes.');
var $author$project$I18n$Textes$produitsValeursRestrictionInchangee = A3($author$project$I18n$Traductions$texte, 'produits.valeurs.restriction.inchangee', _List_Nil, 'Ce produit avait déjà cette portée : rien n\'a changé.');
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$versLeDrawerDeRestriction = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{lg: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Produits$Common$Effet$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.lg));
	});
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$conclure = F2(
	function (issue, model) {
		var saisie = model.hP;
		_v0$9:
		while (true) {
			switch (issue.$) {
				case 0:
					switch (issue.a.$) {
						case 36:
							return A2($author$project$Components$Produits$StructureCatalogue$Produits$Update$concluLArchivage, issue, model);
						case 35:
							if (issue.c) {
								var _v1 = issue.a;
								var rendue = issue.b;
								return $elm$core$List$isEmpty(rendue.mk) ? _Utils_Tuple2(
									_Utils_update(
										model,
										{
											p4: $elm$core$Maybe$Just(
												{Jx: $author$project$I18n$Textes$produitsValeursRestrictionInchangee, b9: $elm$core$Maybe$Nothing})
										}),
									_List_Nil) : A2(
									$author$project$Components$Produits$StructureCatalogue$Produits$Update$versLeDrawerDeRestriction,
									$author$project$Components$Shared$Drawer$Update$Fermer,
									_Utils_update(
										model,
										{p4: $elm$core$Maybe$Nothing, al: $elm$core$Maybe$Nothing}));
							} else {
								var _v2 = issue.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											p4: $elm$core$Maybe$Just($author$project$Components$Produits$Common$Refus$rejeu)
										}),
									_List_Nil);
							}
						case 34:
							if (issue.c) {
								var rendue = issue.b;
								return $elm$core$List$isEmpty(rendue.mk) ? _Utils_Tuple2(
									_Utils_update(
										model,
										{
											hP: _Utils_update(
												saisie,
												{
													pZ: $elm$core$Maybe$Just(
														{Jx: $author$project$I18n$Textes$produitsValeursProduitExistantDejaDans, b9: $elm$core$Maybe$Nothing})
												})
										}),
									_List_Nil) : ((A2($elm$core$List$any, $author$project$Components$Produits$StructureCatalogue$Produits$Update$estUneExtension, rendue.mk) && (!A2($elm$core$List$any, $author$project$Components$Produits$StructureCatalogue$Produits$Update$estUneCreation, rendue.mk))) ? _Utils_Tuple2(
									_Utils_update(
										model,
										{
											hP: _Utils_update(
												saisie,
												{
													pZ: $elm$core$Maybe$Just(
														{Jx: $author$project$I18n$Textes$produitsValeursProduitExistantEtendu, b9: $elm$core$Maybe$Nothing})
												})
										}),
									rendue.sy ? _List_Nil : _List_fromArray(
										[
											$author$project$Components$Produits$Common$Effet$AttendreAvantDeRelire($author$project$Components$Produits$Common$Envoi$delaiDeRelectureMs)
										])) : A2($author$project$Components$Produits$StructureCatalogue$Produits$Update$fermerApresCreation, rendue, model));
							} else {
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											hP: _Utils_update(
												saisie,
												{
													pZ: $elm$core$Maybe$Just($author$project$Components$Produits$Common$Refus$rejeu)
												})
										}),
									_List_Nil);
							}
						default:
							break _v0$9;
					}
				case 1:
					switch (issue.a.$) {
						case 36:
							return A2($author$project$Components$Produits$StructureCatalogue$Produits$Update$concluLArchivage, issue, model);
						case 35:
							var _v3 = issue.a;
							var refus = issue.b;
							var erreur = issue.c;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										p4: $elm$core$Maybe$Just(
											A3(
												$author$project$Components$Produits$Common$Refus$message,
												$author$project$Components$Produits$StructureCatalogue$Produits$Update$contexte(model),
												refus,
												erreur))
									}),
								_List_Nil);
						case 34:
							if (!issue.c.$) {
								var _v4 = issue.c;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											hP: _Utils_update(
												saisie,
												{gi: true})
										}),
									_List_fromArray(
										[
											$author$project$Components$Produits$Common$Effet$PlacerFocus(
											$author$project$Components$Produits$StructureCatalogue$Produits$Model$idDuNom(model))
										]));
							} else {
								var refus = issue.b;
								var erreur = issue.c;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											hP: _Utils_update(
												saisie,
												{
													pZ: $elm$core$Maybe$Just(
														A3(
															$author$project$Components$Produits$Common$Refus$message,
															$author$project$Components$Produits$StructureCatalogue$Produits$Update$contexte(model),
															refus,
															erreur))
												})
										}),
									_List_Nil);
							}
						default:
							break _v0$9;
					}
				default:
					break _v0$9;
			}
		}
		return _Utils_Tuple2(model, _List_Nil);
	});
var $author$project$Catalogue$API$WriteAPIModel$CreerUnProduit = function (a) {
	return {$: 34, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Produits$Model$commandeDeCreation = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		function (ouverture) {
			var _v0 = A2($author$project$Components$Produits$Common$Saisie$valide, 2, model.hP);
			if ((!_v0.$) && (_v0.a.$ === 2)) {
				var produit = _v0.a.a;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(
						$author$project$Catalogue$API$WriteAPIModel$CreerUnProduit(
							{R: produit.R, ey: $elm$core$Maybe$Nothing, fh: ouverture.fh, Ki: _List_Nil}),
						ouverture.nB));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		model.ew);
};
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$creer = function (model) {
	var _v0 = $author$project$Components$Produits$StructureCatalogue$Produits$Model$commandeDeCreation(model);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var commande = _v1.a;
		var lien = _v1.b;
		var _v2 = A3(
			$author$project$Components$Produits$Common$Envoi$partir,
			$elm$core$Maybe$Just(lien),
			commande,
			model.l2);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var envoi = _v3.a;
			var effets = _v3.b;
			var saisie = model.hP;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: envoi,
						hP: _Utils_update(
							saisie,
							{gi: false, pZ: $elm$core$Maybe$Nothing})
					}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_eq(model.ew, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : _Utils_Tuple2(
			_Utils_update(
				model,
				{
					hP: $author$project$Components$Produits$Common$Saisie$tenter(model.hP)
				}),
			_List_fromArray(
				[
					$author$project$Components$Produits$Common$Effet$PlacerFocus(
					$author$project$Components$Produits$StructureCatalogue$Produits$Model$idDuNom(model))
				]));
	}
};
var $author$project$Components$Produits$Common$ArchivageDuProduit$demander = function (archivage) {
	return _Utils_update(
		archivage,
		{
			aW: !_Utils_eq(archivage.nB, $elm$core$Maybe$Nothing)
		});
};
var $author$project$Components$Produits$StructureCatalogue$Produits$Restriction$DeLaFiche = {$: 1};
var $author$project$Components$Produits$StructureCatalogue$Produits$Restriction$Illisible = {$: 5};
var $author$project$Catalogue$API$QueryAPIModel$FicheDuProduit = F6(
	function (id, nom, marques, gammes, archive, liens) {
		return {tE: archive, gG: gammes, Aq: id, nQ: liens, cU: marques, Dj: nom};
	});
var $author$project$Catalogue$API$QueryAPIModel$ficheDuProduitDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'archive',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'gammes',
			$elm$json$Json$Decode$list($author$project$Catalogue$Identifiants$elementIdDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'marques',
				$elm$json$Json$Decode$list($author$project$Catalogue$Identifiants$elementIdDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'nom',
					$author$project$Catalogue$API$QueryAPIModel$libellesDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$author$project$Catalogue$Identifiants$elementIdDecoder,
						$elm$json$Json$Decode$succeed($author$project$Catalogue$API$QueryAPIModel$FicheDuProduit)))))));
var $author$project$Components$Produits$StructureCatalogue$Produits$Restriction$Lue = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Produits$Restriction$SansDroit = {$: 3};
var $author$project$API$NavLinksDictionary$archiverLeProduit = 'archiver-le-produit';
var $author$project$Components$Produits$Common$ArchivageDuProduit$depuisLaFiche = function (fiche) {
	return {
		tE: fiche.tE,
		aW: false,
		nB: fiche.tE ? $elm$core$Maybe$Nothing : A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$archiverLeProduit, fiche.nQ)
	};
};
var $author$project$API$NavLinksDictionary$restreindreUnProduit = 'restreindre-un-produit';
var $author$project$Components$Produits$StructureCatalogue$Produits$Restriction$lue = F2(
	function (fiche, restriction) {
		var retenues = F2(
			function (choix, portees) {
				return $elm$core$List$isEmpty(portees) ? A2(
					$elm$core$List$map,
					function ($) {
						return $.Aq;
					},
					choix) : A2(
					$elm$core$List$filter,
					function (id) {
						return A2($elm$core$List$member, id, portees);
					},
					A2(
						$elm$core$List$map,
						function ($) {
							return $.Aq;
						},
						choix));
			});
		return _Utils_update(
			restriction,
			{
				tD: $author$project$Components$Produits$Common$ArchivageDuProduit$depuisLaFiche(fiche),
				vv: _Utils_ap(
					A2(retenues, restriction.cU, fiche.cU),
					A2(retenues, restriction.gG, fiche.gG)),
				np: fiche.tE ? $author$project$Components$Produits$StructureCatalogue$Produits$Restriction$Archive : A2(
					$elm$core$Maybe$withDefault,
					$author$project$Components$Produits$StructureCatalogue$Produits$Restriction$SansDroit,
					A2(
						$elm$core$Maybe$map,
						$author$project$Components$Produits$StructureCatalogue$Produits$Restriction$Lue,
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$restreindreUnProduit, fiche.nQ)))
			});
	});
var $author$project$API$NavLinksDictionary$produitDuCatalogue = 'produit-du-catalogue';
var $author$project$API$NavLinksDictionary$variableUid = 'uid';
var $author$project$Components$Produits$Liens$versLaFicheDuProduit = F2(
	function (id, gabarits) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$API$NavLinksDictionary$variableUid,
						$author$project$Catalogue$Identifiants$elementIdToString(id))
					])),
			A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$produitDuCatalogue, gabarits));
	});
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$lireLaRestriction = F2(
	function (reponse, model) {
		var illisible = F2(
			function (restriction, refus) {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							al: $elm$core$Maybe$Just(
								_Utils_update(
									restriction,
									{np: $author$project$Components$Produits$StructureCatalogue$Produits$Restriction$Illisible}))
						}),
					(refus.ri === 401) ? _List_fromArray(
						[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
			});
		var _v0 = model.al;
		if (_v0.$ === 1) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var restriction = _v0.a;
			var _v1 = restriction.np;
			switch (_v1.$) {
				case 0:
					var _v2 = A2($author$project$API$Reponse$lire, $author$project$API$Liens$deLaRessource, reponse);
					if (!_v2.$) {
						var liens = _v2.a;
						var _v3 = A2($author$project$Components$Produits$Liens$versLaFicheDuProduit, restriction.Gp, liens.gF);
						if (!_v3.$) {
							var fiche = _v3.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										gF: $elm$core$Maybe$Just(liens.gF),
										al: $elm$core$Maybe$Just(
											_Utils_update(
												restriction,
												{np: $author$project$Components$Produits$StructureCatalogue$Produits$Restriction$DeLaFiche}))
									}),
								_List_fromArray(
									[
										$author$project$Components$Produits$Common$Effet$Lire(fiche)
									]));
						} else {
							return A2(
								illisible,
								restriction,
								{bB: $author$project$API$Reponse$ReponseIllisible, ri: 200, b9: $elm$core$Maybe$Nothing});
						}
					} else {
						var refus = _v2.a;
						return A2(illisible, restriction, refus);
					}
				case 1:
					var _v4 = A2($author$project$API$Reponse$lire, $author$project$Catalogue$API$QueryAPIModel$ficheDuProduitDecoder, reponse);
					if (!_v4.$) {
						var fiche = _v4.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									al: $elm$core$Maybe$Just(
										A2($author$project$Components$Produits$StructureCatalogue$Produits$Restriction$lue, fiche, restriction))
								}),
							_List_Nil);
					} else {
						var refus = _v4.a;
						return A2(illisible, restriction, refus);
					}
				default:
					return _Utils_Tuple2(model, _List_Nil);
			}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Produits$Restriction$DuCatalogue = {$: 0};
var $author$project$Components$Produits$Common$ArchivageDuProduit$aucun = {tE: false, aW: false, nB: $elm$core$Maybe$Nothing};
var $author$project$Components$Produits$StructureCatalogue$Produits$Restriction$ouvrir = F2(
	function (ouverture, lecture) {
		return {
			tD: $author$project$Components$Produits$Common$ArchivageDuProduit$aucun,
			vv: A2(
				$elm$core$List$map,
				function ($) {
					return $.Aq;
				},
				_Utils_ap(ouverture.cU, ouverture.gG)),
			xe: ouverture.xe,
			gG: ouverture.gG,
			np: lecture,
			cU: ouverture.cU,
			Dj: ouverture.Dj,
			Gp: ouverture.Gp
		};
	});
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$ouvrirLaRestriction = F2(
	function (ouverture, model) {
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(model.gF, model.jB);
			if (!_v1.a.$) {
				var gabarits = _v1.a.a;
				var _v2 = A2($author$project$Components$Produits$Liens$versLaFicheDuProduit, ouverture.Gp, gabarits);
				if (!_v2.$) {
					var fiche = _v2.a;
					return _Utils_Tuple2(
						$author$project$Components$Produits$StructureCatalogue$Produits$Restriction$DeLaFiche,
						_List_fromArray(
							[
								$author$project$Components$Produits$Common$Effet$Lire(fiche)
							]));
				} else {
					return _Utils_Tuple2($author$project$Components$Produits$StructureCatalogue$Produits$Restriction$Illisible, _List_Nil);
				}
			} else {
				if (!_v1.b.$) {
					var _v3 = _v1.a;
					var catalogue = _v1.b.a;
					return _Utils_Tuple2(
						$author$project$Components$Produits$StructureCatalogue$Produits$Restriction$DuCatalogue,
						_List_fromArray(
							[
								$author$project$Components$Produits$Common$Effet$Lire(catalogue)
							]));
				} else {
					var _v4 = _v1.a;
					var _v5 = _v1.b;
					return _Utils_Tuple2($author$project$Components$Produits$StructureCatalogue$Produits$Restriction$Illisible, _List_Nil);
				}
			}
		}();
		var lecture = _v0.a;
		var lectures = _v0.b;
		return A2(
			$elm$core$Tuple$mapSecond,
			function (focus) {
				return _Utils_ap(
					lectures,
					_Utils_ap(
						focus,
						_Utils_eq(model.l2, $author$project$API$Envoi$SansProcessUid) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$DemanderProcessUid]) : _List_Nil));
			},
			A2(
				$author$project$Components$Produits$StructureCatalogue$Produits$Update$versLeDrawerDeRestriction,
				$author$project$Components$Shared$Drawer$Update$Ouvrir(ouverture.xe),
				_Utils_update(
					model,
					{
						p4: $elm$core$Maybe$Nothing,
						al: $elm$core$Maybe$Just(
							A2($author$project$Components$Produits$StructureCatalogue$Produits$Restriction$ouvrir, ouverture, lecture))
					})));
	});
var $author$project$Catalogue$API$WriteAPIModel$RestreindreUnProduit = F2(
	function (a, b) {
		return {$: 35, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Produits$Restriction$cochee = F2(
	function (id, restriction) {
		return A2($elm$core$List$member, id, restriction.vv);
	});
var $author$project$Components$Produits$StructureCatalogue$Produits$Restriction$aucuneGamme = function (restriction) {
	return (!$elm$core$List$isEmpty(restriction.gG)) && A2(
		$elm$core$List$all,
		function (choix) {
			return !A2($author$project$Components$Produits$StructureCatalogue$Produits$Restriction$cochee, choix.Aq, restriction);
		},
		restriction.gG);
};
var $author$project$Components$Produits$StructureCatalogue$Produits$Restriction$aucuneMarque = function (restriction) {
	return (!$elm$core$List$isEmpty(restriction.cU)) && A2(
		$elm$core$List$all,
		function (choix) {
			return !A2($author$project$Components$Produits$StructureCatalogue$Produits$Restriction$cochee, choix.Aq, restriction);
		},
		restriction.cU);
};
var $author$project$Components$Produits$StructureCatalogue$Produits$Restriction$valeursDuGroupe = F2(
	function (restriction, choix) {
		return A2(
			$elm$core$List$all,
			function (c) {
				return A2($author$project$Components$Produits$StructureCatalogue$Produits$Restriction$cochee, c.Aq, restriction);
			},
			choix) ? _List_Nil : A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Aq;
				},
				$author$project$Catalogue$API$WriteAPIModel$ElementDuDessus),
			A2(
				$elm$core$List$filter,
				function (c) {
					return A2($author$project$Components$Produits$StructureCatalogue$Produits$Restriction$cochee, c.Aq, restriction);
				},
				choix));
	});
var $author$project$Components$Produits$StructureCatalogue$Produits$Restriction$commande = function (restriction) {
	var _v0 = restriction.np;
	if (_v0.$ === 2) {
		var lien = _v0.a;
		return ($author$project$Components$Produits$StructureCatalogue$Produits$Restriction$aucuneMarque(restriction) || $author$project$Components$Produits$StructureCatalogue$Produits$Restriction$aucuneGamme(restriction)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			_Utils_Tuple2(
				A2(
					$author$project$Catalogue$API$WriteAPIModel$RestreindreUnProduit,
					restriction.Gp,
					_Utils_ap(
						A2($author$project$Components$Produits$StructureCatalogue$Produits$Restriction$valeursDuGroupe, restriction, restriction.cU),
						A2($author$project$Components$Produits$StructureCatalogue$Produits$Restriction$valeursDuGroupe, restriction, restriction.gG))),
				lien));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$restreindre = function (model) {
	var _v0 = A2($elm$core$Maybe$andThen, $author$project$Components$Produits$StructureCatalogue$Produits$Restriction$commande, model.al);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var commande = _v1.a;
		var lien = _v1.b;
		var _v2 = A3(
			$author$project$Components$Produits$Common$Envoi$partir,
			$elm$core$Maybe$Just(lien),
			commande,
			model.l2);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var envoi = _v3.a;
			var effets = _v3.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi, p4: $elm$core$Maybe$Nothing}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Produits$Restriction$surLArchivage = F2(
	function (geste, restriction) {
		return _Utils_update(
			restriction,
			{
				tD: geste(restriction.tD)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var liens = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jB: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$catalogue, liens)
						}),
					_List_Nil);
			case 1:
				var ouverture = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Produits$Update$ouvrirLaRestriction, ouverture, model);
			case 2:
				var reponse = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Produits$Update$lireLaRestriction, reponse, model);
			case 3:
				var id = msg.a;
				var voulue = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							al: A2(
								$elm$core$Maybe$map,
								A2($author$project$Components$Produits$StructureCatalogue$Produits$Restriction$cocher, id, voulue),
								model.al)
						}),
					_List_Nil);
			case 4:
				return $author$project$Components$Produits$StructureCatalogue$Produits$Update$restreindre(model);
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							p4: $elm$core$Maybe$Nothing,
							al: A2(
								$elm$core$Maybe$map,
								$author$project$Components$Produits$StructureCatalogue$Produits$Restriction$surLArchivage($author$project$Components$Produits$Common$ArchivageDuProduit$demander),
								model.al)
						}),
					_List_Nil);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							al: A2(
								$elm$core$Maybe$map,
								$author$project$Components$Produits$StructureCatalogue$Produits$Restriction$surLArchivage($author$project$Components$Produits$Common$ArchivageDuProduit$renoncer),
								model.al)
						}),
					_List_Nil);
			case 7:
				return $author$project$Components$Produits$StructureCatalogue$Produits$Update$archiver(model);
			case 8:
				var geste = msg.a;
				return A2($author$project$Components$Produits$Common$Envoi$retientLeDrawer, model.l2, geste) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Produits$StructureCatalogue$Produits$Update$versLeDrawerDeRestriction, geste, model);
			case 9:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$Components$Produits$Common$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 10:
				return _Utils_Tuple2(model, _List_Nil);
			case 11:
				var geste = msg.a;
				return A2($author$project$Components$Produits$Common$Envoi$retientLeDrawer, model.l2, geste) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Produits$StructureCatalogue$Produits$Update$versLeDrawer, geste, model);
			case 12:
				var ouverture = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(
						_Utils_eq(model.l2, $author$project$API$Envoi$SansProcessUid) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$DemanderProcessUid]) : _List_Nil),
					A2(
						$author$project$Components$Produits$StructureCatalogue$Produits$Update$versLeDrawer,
						$author$project$Components$Shared$Drawer$Update$Ouvrir(ouverture.xe),
						_Utils_update(
							model,
							{
								ew: $elm$core$Maybe$Just(ouverture),
								hP: $author$project$Components$Produits$Common$Saisie$vide
							})));
			case 13:
				var champ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hP: A2($author$project$Components$Produits$Common$Saisie$saisir, champ, model.hP)
						}),
					_List_Nil);
			case 14:
				return $author$project$Components$Produits$StructureCatalogue$Produits$Update$creer(model);
			case 15:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							kX: A3(
								$author$project$Components$Shared$Drawer$Update$update,
								{Il: false},
								$author$project$Components$Shared$Drawer$Update$Fermer,
								model.kX).a,
							lg: A3(
								$author$project$Components$Shared$Drawer$Update$update,
								{Il: false},
								$author$project$Components$Shared$Drawer$Update$Fermer,
								model.lg).a
						}),
					_List_Nil);
			default:
				var reponse = msg.a;
				var _v1 = A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, model.l2);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var envoi = _v2.a;
					var issue = _v2.b;
					var effets = _v2.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Produits$StructureCatalogue$Produits$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Update$versLesProduits = F2(
	function (geste, model) {
		return (A2($author$project$Components$Produits$StructureCatalogue$Produits$Update$structureARelire, model.aK, geste) ? $author$project$Components$Produits$StructureCatalogue$Update$puis(
			function (suivant) {
				return _Utils_Tuple2(
					suivant,
					$author$project$Components$Produits$StructureCatalogue$Commandes$relire(suivant));
			}) : $elm$core$Basics$identity)(
			A3(
				$elm$core$Tuple$mapBoth,
				function (produits) {
					return _Utils_update(
						model,
						{aK: produits});
				},
				$elm$core$List$map($author$project$Components$Produits$StructureCatalogue$Effet$PourLesProduits),
				A2($author$project$Components$Produits$StructureCatalogue$Produits$Update$update, geste, model.aK)));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$ouvrir = F3(
	function (i18n, liens, demande) {
		var init_ = $author$project$Components$Produits$StructureCatalogue$Model$initial;
		var initial = _Utils_update(
			init_,
			{
				i_: demande,
				nC: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$bibliothequeDeChamps, liens)
			});
		var _v0 = function () {
			var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$structureDuCatalogue, liens);
			if (!_v1.$) {
				var lecture = _v1.a;
				return _Utils_Tuple2(
					_Utils_update(
						initial,
						{
							np: $elm$core$Maybe$Just(lecture),
							nS: A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									$elm$core$List$singleton,
									A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$listes, liens)))
						}),
					_List_fromArray(
						[
							$author$project$Components$Produits$StructureCatalogue$Effet$DemanderProcessUid,
							$author$project$Components$Produits$StructureCatalogue$Effet$LireLaStructure(lecture)
						]));
			} else {
				return _Utils_Tuple2(initial, _List_Nil);
			}
		}();
		var ouverte = _v0.a;
		var effets = _v0.b;
		return function (_v3) {
			var model = _v3.a;
			var avant = _v3.b;
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Basics$append(avant),
				A2(
					$author$project$Components$Produits$StructureCatalogue$Update$versLesProduits,
					$author$project$Components$Produits$StructureCatalogue$Produits$Update$Ouverte(liens),
					model));
		}(
			function (_v2) {
				var model = _v2.a;
				var avant = _v2.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(avant),
					A3(
						$author$project$Components$Produits$StructureCatalogue$Update$versLesMarques,
						i18n,
						$author$project$Components$Produits$StructureCatalogue$Marques$Update$Ouverte(liens),
						model));
			}(
				A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(
						_Utils_ap(
							effets,
							_Utils_ap(
								$author$project$Components$Produits$StructureCatalogue$Update$lectureDesInformations(liens),
								$author$project$Components$Produits$StructureCatalogue$Update$lectureDesListes(liens)))),
					A2(
						$author$project$Components$Produits$StructureCatalogue$Update$versLesCategories,
						$author$project$Components$Produits$StructureCatalogue$Categories$Update$Ouverte(liens),
						ouverte))));
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$AjoutALEtageOuvert = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Gammes$Update$CreationOuverte = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Marques$Update$CreationOuverte = {$: 5};
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$CreationOuverte = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$CreationOuverteSous = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$Archivage = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$NouvelleClassification = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$NouvelleValeur = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$NouvelleValeurDEtage = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$Ordonnance = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$Reactivation = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$ReactivationDemandee = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$Renommage = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$RenommageOuvert = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$classificationDe = F2(
	function (id, model) {
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.vk;
				},
				$author$project$Components$Produits$StructureCatalogue$Classifications$Model$classificationDe(id)),
			model.h$);
	});
var $author$project$Components$Produits$StructureCatalogue$Model$SurLOrdreDeLaValeur = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$I18n$Textes$produitsStructureOrdreAnnonce = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.structure.ordre.annonce',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nom',
				$author$project$I18n$Traductions$Sous(p.Dj)),
				_Utils_Tuple2(
				'rang',
				$author$project$I18n$Traductions$Sous(p.bY)),
				_Utils_Tuple2(
				'total',
				$author$project$I18n$Traductions$Sous(p.JE))
			]),
		'{nom} : position {rang} sur {total}.');
};
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$annonceDeLaPlace = F2(
	function (place, valeurs) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Traductions$tel(''),
			A2(
				$elm$core$Maybe$map,
				function (valeur) {
					return $author$project$I18n$Textes$produitsStructureOrdreAnnonce(
						{
							Dj: $author$project$I18n$Traductions$tel(
								$author$project$Components$Produits$StructureCatalogue$Classifications$Model$nomDeLaValeur(valeur)),
							bY: $author$project$I18n$Traductions$tel(
								$elm$core$String$fromInt(place.bY + 1)),
							JE: $author$project$I18n$Traductions$tel(
								$elm$core$String$fromInt(
									$elm$core$List$length(
										A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$fillesDe, place.ey, valeurs))))
						});
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(place.fm)),
						valeurs))));
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$ordonner = F3(
	function (id, place, model) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$Components$Produits$StructureCatalogue$Classifications$Update$classificationDe, id, model),
			A2(
				$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
				A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$DeplacerUneValeur, id, place),
				model));
		if ((!_v0.a.$) && _v0.b.b.b) {
			var classification = _v0.a.a;
			var _v1 = _v0.b;
			var parti = _v1.a;
			var _v2 = _v1.b;
			var effet = _v2.a;
			var effets = _v2.b;
			var voulues = A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$appliquerLaPlace, place, classification.Ki);
			return _Utils_Tuple2(
				A2(
					$author$project$Components$Produits$StructureCatalogue$Classifications$Update$surLaSection,
					function (section) {
						return _Utils_update(
							section,
							{
								iP: A2($author$project$Components$Produits$StructureCatalogue$Classifications$Update$annonceDeLaPlace, place, voulues),
								pt: $elm$core$Maybe$Just(
									_Utils_Tuple2(id, classification.Ki))
							});
					},
					_Utils_update(
						parti,
						{
							h$: A2(
								$elm$core$Maybe$map,
								A2(
									$author$project$Components$Produits$StructureCatalogue$Model$surLaClassification,
									id,
									function (affichee) {
										return _Utils_update(
											affichee,
											{Ki: voulues});
									}),
								parti.h$)
						})),
				A2($elm$core$List$cons, effet, effets));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$placeDe = F3(
	function (pas, valeur, valeurs) {
		var rang = valeur.bY + pas;
		return ((rang < 0) || (_Utils_cmp(
			rang,
			$elm$core$List$length(
				A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$fillesDe, valeur.ey, valeurs))) > -1)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			{ey: valeur.ey, bY: rang, fm: valeur.Aq});
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$valeurDe = F3(
	function (id, valeur, model) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$Components$Produits$StructureCatalogue$Classifications$Model$valeurDe(valeur),
			A2($author$project$Components$Produits$StructureCatalogue$Classifications$Update$classificationDe, id, model));
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$dUnCran = F5(
	function (pas, sens, id, valeur, model) {
		var _v0 = _Utils_Tuple2(
			A3($author$project$Components$Produits$StructureCatalogue$Classifications$Update$valeurDe, id, valeur, model),
			A2($author$project$Components$Produits$StructureCatalogue$Classifications$Update$classificationDe, id, model));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var trouvee = _v0.a.a;
			var classification = _v0.b.a;
			var _v1 = A3($author$project$Components$Produits$StructureCatalogue$Classifications$Model$placeDe, pas, trouvee, classification.Ki);
			if (!_v1.$) {
				var place = _v1.a;
				return A2(
					$author$project$Components$Produits$StructureCatalogue$Commandes$avecFoyer,
					A3($author$project$Components$Produits$StructureCatalogue$Model$SurLOrdreDeLaValeur, id, valeur, sens),
					A3($author$project$Components$Produits$StructureCatalogue$Classifications$Update$ordonner, id, place, model));
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$enDrawer = function (geste) {
	switch (geste.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return true;
		case 3:
			return true;
		case 4:
			return true;
		case 5:
			return true;
		case 6:
			return true;
		default:
			return true;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$entreSoeurs = F4(
	function (id, glissee, cible, model) {
		var _v0 = _Utils_Tuple2(
			A3($author$project$Components$Produits$StructureCatalogue$Classifications$Update$valeurDe, id, glissee, model),
			A3($author$project$Components$Produits$StructureCatalogue$Classifications$Update$valeurDe, id, cible, model));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var deplacee = _v0.a.a;
			var visee = _v0.b.a;
			return (_Utils_eq(deplacee.ey, visee.ey) && (!_Utils_eq(deplacee.Aq, visee.Aq))) ? A3(
				$author$project$Components$Produits$StructureCatalogue$Classifications$Update$ordonner,
				id,
				{ey: deplacee.ey, bY: visee.bY, fm: glissee},
				model) : _Utils_Tuple2(model, _List_Nil);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDeLOuvertureDeLAjout = 'ajout-classification-ouvrir';
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDuBouton = F2(
	function (action, valeur) {
		return 'valeur-' + ($author$project$Catalogue$Identifiants$valeurIdToString(valeur) + ('-' + action));
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDeLaLigne = $author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDuBouton('ouvrir');
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$idPourAjouterUneValeur = 'ajout-valeur-ouvrir';
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$idPourOrdonner = 'ordonner-les-valeurs';
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$idDeLOuverture = function (geste) {
	switch (geste.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Just($author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDeLOuvertureDeLAjout);
		case 2:
			return $elm$core$Maybe$Just($author$project$Components$Produits$StructureCatalogue$Classifications$Model$idPourAjouterUneValeur);
		case 3:
			var ajout = geste.a;
			return $elm$core$Maybe$Just(ajout.xe);
		case 4:
			var valeur = geste.b;
			return $elm$core$Maybe$Just(
				$author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDeLaLigne(valeur));
		case 5:
			var valeur = geste.b;
			return $elm$core$Maybe$Just(
				$author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDeLaLigne(valeur));
		case 6:
			var valeur = geste.b;
			return $elm$core$Maybe$Just(
				$author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDeLaLigne(valeur));
		default:
			return $elm$core$Maybe$Just($author$project$Components$Produits$StructureCatalogue$Classifications$Model$idPourOrdonner);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$lienDeLaStructure = F2(
	function (rel, model) {
		return !_Utils_eq(
			$elm$core$Maybe$Nothing,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nQ;
					},
					$author$project$API$Liens$trouver(rel)),
				model.h$));
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$offerte = F4(
	function (rel, id, valeur, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (trouvee) {
				return A2(
					$elm$core$Maybe$map,
					function (_v0) {
						return trouvee;
					},
					A2($author$project$API$Liens$trouver, rel, trouvee.nQ));
			},
			A3($author$project$Components$Produits$StructureCatalogue$Classifications$Update$valeurDe, id, valeur, model));
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$sansDrawer = function (model) {
	var section = model.vk;
	var drawer = section.kX;
	return ($author$project$Components$Produits$StructureCatalogue$Classifications$Model$enDrawer(section.mW) || $author$project$Components$Shared$Drawer$Model$estOuvert(drawer)) ? _Utils_update(
		model,
		{
			vk: _Utils_update(
				section,
				{
					kX: _Utils_update(
						drawer,
						{wQ: $elm$core$Maybe$Nothing, gt: 0}),
					mW: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$Aucun
				}),
			aL: $elm$core$Maybe$Nothing
		}) : model;
};
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$saisieDeLaValeur = function (valeur) {
	return $author$project$Components$Produits$StructureCatalogue$Saisie$affichee(
		{
			yg: A2($elm$core$Maybe$withDefault, '', valeur.R.yg),
			zX: valeur.R.zX
		});
};
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$saisieEnCours = F2(
	function (classifications, geste) {
		var deLaValeur = F3(
			function (id, valeur, lire) {
				return A2(
					$elm$core$Maybe$map,
					lire,
					A2(
						$elm$core$Maybe$andThen,
						$author$project$Components$Produits$StructureCatalogue$Classifications$Model$valeurDe(valeur),
						A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$classificationDe, id, classifications)));
			});
		switch (geste.$) {
			case 0:
				return false;
			case 1:
				var saisie = geste.a;
				return !_Utils_eq(saisie.R, $author$project$Components$Produits$StructureCatalogue$Saisie$vide.R);
			case 2:
				var saisie = geste.b;
				return !_Utils_eq(saisie.R, $author$project$Components$Produits$StructureCatalogue$Saisie$vide.R);
			case 3:
				var saisie = geste.b;
				return !_Utils_eq(saisie.R, $author$project$Components$Produits$StructureCatalogue$Saisie$vide.R);
			case 4:
				var id = geste.a;
				var valeur = geste.b;
				var saisie = geste.c;
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$neq(saisie.R),
						A3(
							deLaValeur,
							id,
							valeur,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Components$Produits$StructureCatalogue$Classifications$Model$saisieDeLaValeur,
								function ($) {
									return $.R;
								}))));
			case 5:
				return false;
			case 6:
				return false;
			default:
				return false;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$versLeDrawer = F2(
	function (geste, model) {
		var section = model.vk;
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{
				Il: A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.vk;
							},
							function (lues) {
								return A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$saisieEnCours, lues, section.mW);
							}),
						model.h$))
			},
			geste,
			section.kX);
		var drawer = _v0.a;
		var effets = _v0.b;
		var suivi = A2(
			$author$project$Components$Produits$StructureCatalogue$Classifications$Update$surLaSection,
			function (suivie) {
				return _Utils_update(
					suivie,
					{kX: drawer});
			},
			model);
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? suivi : $author$project$Components$Produits$StructureCatalogue$Classifications$Update$sansDrawer(suivi),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$ouvrir = F3(
	function (geste, premierControle, model) {
		var ouvert = A2(
			$author$project$Components$Produits$StructureCatalogue$Classifications$Update$surLaSection,
			function (section) {
				return _Utils_update(
					section,
					{mW: geste});
			},
			$author$project$Components$Produits$StructureCatalogue$Classifications$Update$sansDrawer(model));
		return $author$project$Components$Produits$StructureCatalogue$Classifications$Model$enDrawer(geste) ? A2(
			$author$project$Components$Produits$StructureCatalogue$Classifications$Update$versLeDrawer,
			$author$project$Components$Shared$Drawer$Update$Ouvrir(
				A2(
					$elm$core$Maybe$withDefault,
					'',
					$author$project$Components$Produits$StructureCatalogue$Classifications$Update$idDeLOuverture(geste))),
			ouvert) : _Utils_Tuple2(
			ouvert,
			_List_fromArray(
				[
					$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(premierControle)
				]));
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$saisir = function (modifier) {
	return $author$project$Components$Produits$StructureCatalogue$Classifications$Update$surLaSection(
		function (section) {
			return _Utils_update(
				section,
				{
					mW: function () {
						var _v0 = section.mW;
						switch (_v0.$) {
							case 1:
								var saisie = _v0.a;
								return $author$project$Components$Produits$StructureCatalogue$Classifications$Model$NouvelleClassification(
									modifier(saisie));
							case 2:
								var id = _v0.a;
								var saisie = _v0.b;
								return A2(
									$author$project$Components$Produits$StructureCatalogue$Classifications$Model$NouvelleValeur,
									id,
									modifier(saisie));
							case 3:
								var ajout = _v0.a;
								var saisie = _v0.b;
								return A2(
									$author$project$Components$Produits$StructureCatalogue$Classifications$Model$NouvelleValeurDEtage,
									ajout,
									modifier(saisie));
							case 4:
								var id = _v0.a;
								var valeur = _v0.b;
								var saisie = _v0.c;
								return A3(
									$author$project$Components$Produits$StructureCatalogue$Classifications$Model$Renommage,
									id,
									valeur,
									modifier(saisie));
							default:
								var autre = _v0;
								return autre;
						}
					}()
				});
		});
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$AjouterUneClassification = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$AjouterUneValeur = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$AjouterUneValeurALEtage = F2(
	function (a, b) {
		return {$: 31, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$PlacerUnNoeud = F2(
	function (a, b) {
		return {$: 27, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ReactiverUneValeur = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$TraduireUneValeur = F3(
	function (a, b, c) {
		return {$: 22, a: a, b: b, c: c};
	});
var $author$project$Catalogue$API$QueryAPIModel$ValeurLibre = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$renommage = function (valeur) {
	return A2(
		$author$project$Components$Produits$StructureCatalogue$Saisie$renommer,
		$elm$core$Maybe$Just(valeur.R),
		_Utils_Tuple2('', ''));
};
var $author$project$Catalogue$Identifiants$valeurIdDeLaCommande = function (processUid) {
	return $author$project$API$ProcessUid$toString(processUid);
};
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$valider = F2(
	function (geste, model) {
		var versLOuverture = $author$project$Components$Produits$StructureCatalogue$Commandes$avecFoyer(
			$author$project$Components$Produits$StructureCatalogue$Model$SurLeControle(
				A2(
					$elm$core$Maybe$withDefault,
					'',
					$author$project$Components$Produits$StructureCatalogue$Classifications$Update$idDeLOuverture(geste))));
		var tentee = A2(
			$author$project$Components$Produits$StructureCatalogue$Classifications$Update$saisir,
			function (saisie) {
				return _Utils_update(
					saisie,
					{b5: true});
			},
			_Utils_update(
				model,
				{aL: $elm$core$Maybe$Nothing}));
		var fermer = A2($author$project$Components$Produits$StructureCatalogue$Classifications$Update$versLeDrawer, $author$project$Components$Shared$Drawer$Update$Fermer, model);
		switch (geste.$) {
			case 0:
				return _Utils_Tuple2(model, _List_Nil);
			case 1:
				var saisie = geste.a;
				var _v1 = $author$project$Components$Produits$StructureCatalogue$Saisie$libellesSaisis(saisie);
				if (!_v1.$) {
					var libelles = _v1.a;
					return versLOuverture(
						A2(
							$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
							$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$AjouterUneClassification(libelles),
							tentee));
				} else {
					return _Utils_Tuple2(
						tentee,
						_List_fromArray(
							[
								$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus($author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDuChampFrancais)
							]));
				}
			case 2:
				var id = geste.a;
				var saisie = geste.b;
				var _v2 = $author$project$Components$Produits$StructureCatalogue$Saisie$libellesSaisis(saisie);
				if (!_v2.$) {
					var libelles = _v2.a;
					return versLOuverture(
						A2(
							$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
							A2(
								$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$AjouterUneValeur,
								id,
								{R: libelles, ey: $elm$core$Maybe$Nothing}),
							tentee));
				} else {
					return _Utils_Tuple2(
						tentee,
						_List_fromArray(
							[
								$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus($author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDuChampFrancais)
							]));
				}
			case 3:
				var ajout = geste.a;
				var saisie = geste.b;
				var _v3 = _Utils_Tuple2(
					$author$project$Components$Produits$StructureCatalogue$Saisie$libellesSaisis(saisie),
					model.l2);
				if (!_v3.a.$) {
					if (_v3.b.$ === 1) {
						var libelles = _v3.a.a;
						var processUid = _v3.b.a;
						return versLOuverture(
							A2(
								$author$project$Components$Produits$StructureCatalogue$Commandes$enchainer,
								A2(
									$elm$core$List$cons,
									A2(
										$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$AjouterUneValeurALEtage,
										ajout.r3,
										{
											md: ajout.md,
											R: libelles,
											IV: $elm$core$List$head(ajout.IV)
										}),
									A2(
										$elm$core$List$map,
										function (parent) {
											return A2(
												$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$PlacerUnNoeud,
												ajout.r3,
												{
													md: ajout.md,
													ey: $elm$core$Maybe$Just(parent),
													fm: $author$project$Catalogue$API$QueryAPIModel$ValeurLibre(
														$author$project$Catalogue$Identifiants$valeurIdDeLaCommande(processUid))
												});
										},
										A2($elm$core$List$drop, 1, ajout.IV))),
								tentee));
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				} else {
					var _v4 = _v3.a;
					return _Utils_Tuple2(
						tentee,
						_List_fromArray(
							[
								$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus($author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDuChampFrancais)
							]));
				}
			case 4:
				var id = geste.a;
				var valeur = geste.b;
				var saisie = geste.c;
				var _v5 = A2(
					$elm$core$Maybe$map,
					function (trouvee) {
						return A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$renommage, trouvee, saisie);
					},
					A3($author$project$Components$Produits$StructureCatalogue$Classifications$Update$valeurDe, id, valeur, model));
				if (!_v5.$) {
					switch (_v5.a.$) {
						case 2:
							var libelles = _v5.a.a;
							return versLOuverture(
								A2(
									$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
									A3($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$TraduireUneValeur, id, valeur, libelles),
									tentee));
						case 1:
							var _v6 = _v5.a;
							return _Utils_Tuple2(
								tentee,
								_List_fromArray(
									[
										$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus($author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDuChampFrancais)
									]));
						default:
							var _v7 = _v5.a;
							return fermer;
					}
				} else {
					return fermer;
				}
			case 5:
				var id = geste.a;
				var valeur = geste.b;
				return A2(
					$author$project$Components$Produits$StructureCatalogue$Commandes$avecFoyer,
					$author$project$Components$Produits$StructureCatalogue$Model$SurLeControle(
						$author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDeLaLigne(valeur)),
					A2(
						$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
						A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ArchiverUneValeur, id, valeur),
						_Utils_update(
							model,
							{aL: $elm$core$Maybe$Nothing})));
			case 6:
				var id = geste.a;
				var valeur = geste.b;
				return A2(
					$author$project$Components$Produits$StructureCatalogue$Commandes$avecFoyer,
					$author$project$Components$Produits$StructureCatalogue$Model$SurLeControle(
						$author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDeLaLigne(valeur)),
					A2(
						$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
						A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ReactiverUneValeur, id, valeur),
						_Utils_update(
							model,
							{aL: $elm$core$Maybe$Nothing})));
			default:
				return fermer;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$update = F2(
	function (msg, model) {
		update:
		while (true) {
			var section = model.vk;
			switch (msg.$) {
				case 0:
					var id = msg.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Produits$StructureCatalogue$Classifications$Update$surLaSection,
							function (ouverte) {
								return _Utils_update(
									ouverte,
									{
										Et: _Utils_eq(
											ouverte.Et,
											$elm$core$Maybe$Just(id)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(id)
									});
							},
							model),
						_List_Nil);
				case 1:
					return A2($author$project$Components$Produits$StructureCatalogue$Classifications$Update$lienDeLaStructure, $author$project$API$NavLinksDictionary$ajouterUneClassification, model) ? A3(
						$author$project$Components$Produits$StructureCatalogue$Classifications$Update$ouvrir,
						$author$project$Components$Produits$StructureCatalogue$Classifications$Model$NouvelleClassification($author$project$Components$Produits$StructureCatalogue$Saisie$vide),
						$author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDuChampFrancais,
						model) : _Utils_Tuple2(model, _List_Nil);
				case 2:
					var id = msg.a;
					var _v1 = A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.nQ;
							},
							$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$ajouterUneValeur)),
						A2($author$project$Components$Produits$StructureCatalogue$Classifications$Update$classificationDe, id, model));
					if (!_v1.$) {
						return A3(
							$author$project$Components$Produits$StructureCatalogue$Classifications$Update$ouvrir,
							A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$NouvelleValeur, id, $author$project$Components$Produits$StructureCatalogue$Saisie$vide),
							$author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDuChampFrancais,
							A2(
								$author$project$Components$Produits$StructureCatalogue$Classifications$Update$surLaSection,
								function (affichee) {
									return _Utils_update(
										affichee,
										{
											Et: $elm$core$Maybe$Just(id)
										});
								},
								model));
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 3:
					var ajout = msg.a;
					return A3(
						$author$project$Components$Produits$StructureCatalogue$Classifications$Update$ouvrir,
						A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$NouvelleValeurDEtage, ajout, $author$project$Components$Produits$StructureCatalogue$Saisie$vide),
						$author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDuChampFrancais,
						model);
				case 4:
					var id = msg.a;
					var valeur = msg.b;
					var _v2 = A3($author$project$Components$Produits$StructureCatalogue$Classifications$Update$valeurDe, id, valeur, model);
					if (!_v2.$) {
						var trouvee = _v2.a;
						if (trouvee.tI) {
							var $temp$msg = A2($author$project$Components$Produits$StructureCatalogue$Classifications$Update$ReactivationDemandee, id, valeur),
								$temp$model = model;
							msg = $temp$msg;
							model = $temp$model;
							continue update;
						} else {
							var $temp$msg = A2($author$project$Components$Produits$StructureCatalogue$Classifications$Update$RenommageOuvert, id, valeur),
								$temp$model = model;
							msg = $temp$msg;
							model = $temp$model;
							continue update;
						}
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 5:
					var id = msg.a;
					var _v3 = A2($author$project$Components$Produits$StructureCatalogue$Classifications$Update$classificationDe, id, model);
					if (!_v3.$) {
						return A3(
							$author$project$Components$Produits$StructureCatalogue$Classifications$Update$ouvrir,
							$author$project$Components$Produits$StructureCatalogue$Classifications$Model$Ordonnance(id),
							$author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDuChampFrancais,
							model);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 6:
					var id = msg.a;
					var valeur = msg.b;
					var _v4 = A4($author$project$Components$Produits$StructureCatalogue$Classifications$Update$offerte, $author$project$API$NavLinksDictionary$traduireUneValeur, id, valeur, model);
					if (!_v4.$) {
						var trouvee = _v4.a;
						return A3(
							$author$project$Components$Produits$StructureCatalogue$Classifications$Update$ouvrir,
							A3(
								$author$project$Components$Produits$StructureCatalogue$Classifications$Model$Renommage,
								id,
								valeur,
								$author$project$Components$Produits$StructureCatalogue$Classifications$Model$saisieDeLaValeur(trouvee)),
							$author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDuChampFrancais,
							model);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 7:
					var id = msg.a;
					var valeur = msg.b;
					var _v5 = A4($author$project$Components$Produits$StructureCatalogue$Classifications$Update$offerte, $author$project$API$NavLinksDictionary$archiverUneValeur, id, valeur, model);
					if (!_v5.$) {
						return A3(
							$author$project$Components$Produits$StructureCatalogue$Classifications$Update$ouvrir,
							A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$Archivage, id, valeur),
							$author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDeLaConfirmation,
							model);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 8:
					var id = msg.a;
					var valeur = msg.b;
					var _v6 = A4($author$project$Components$Produits$StructureCatalogue$Classifications$Update$offerte, $author$project$API$NavLinksDictionary$reactiverUneValeur, id, valeur, model);
					if (!_v6.$) {
						return A3(
							$author$project$Components$Produits$StructureCatalogue$Classifications$Update$ouvrir,
							A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$Reactivation, id, valeur),
							$author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDeLaConfirmation,
							model);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 9:
					var langue = msg.a;
					var texte = msg.b;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Produits$StructureCatalogue$Classifications$Update$saisir,
							A2($author$project$Components$Produits$StructureCatalogue$Saisie$saisir, langue, texte),
							model),
						_List_Nil);
				case 10:
					var geste = msg.a;
					return A2($author$project$Components$Produits$StructureCatalogue$Classifications$Update$versLeDrawer, geste, model);
				case 11:
					return $author$project$Components$Produits$StructureCatalogue$Classifications$Model$enDrawer(section.mW) ? A2($author$project$Components$Produits$StructureCatalogue$Classifications$Update$versLeDrawer, $author$project$Components$Shared$Drawer$Update$Fermer, model) : _Utils_Tuple2(
						A2(
							$author$project$Components$Produits$StructureCatalogue$Classifications$Update$surLaSection,
							function (fermee) {
								return _Utils_update(
									fermee,
									{mW: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$Aucun});
							},
							model),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus, $elm$core$List$singleton),
								$author$project$Components$Produits$StructureCatalogue$Classifications$Update$idDeLOuverture(section.mW))));
				case 12:
					return A2($author$project$Components$Produits$StructureCatalogue$Classifications$Update$valider, section.mW, model);
				case 13:
					var id = msg.a;
					var valeur = msg.b;
					return A5($author$project$Components$Produits$StructureCatalogue$Classifications$Update$dUnCran, -1, 0, id, valeur, model);
				case 14:
					var id = msg.a;
					var valeur = msg.b;
					return A5($author$project$Components$Produits$StructureCatalogue$Classifications$Update$dUnCran, 1, 1, id, valeur, model);
				case 15:
					var id = msg.a;
					var valeur = msg.b;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Produits$StructureCatalogue$Classifications$Update$surLaSection,
							function (glissee) {
								return _Utils_update(
									glissee,
									{
										m_: $elm$core$Maybe$Just(
											_Utils_Tuple2(id, valeur))
									});
							},
							model),
						_List_Nil);
				case 16:
					return _Utils_Tuple2(model, _List_Nil);
				case 17:
					var id = msg.a;
					var cible = msg.b;
					var sansGlisse = A2(
						$author$project$Components$Produits$StructureCatalogue$Classifications$Update$surLaSection,
						function (deposee) {
							return _Utils_update(
								deposee,
								{m_: $elm$core$Maybe$Nothing});
						},
						model);
					var _v7 = section.m_;
					if (!_v7.$) {
						var _v8 = _v7.a;
						var glisseeDe = _v8.a;
						var glissee = _v8.b;
						return _Utils_eq(glisseeDe, id) ? A4($author$project$Components$Produits$StructureCatalogue$Classifications$Update$entreSoeurs, id, glissee, cible, sansGlisse) : _Utils_Tuple2(sansGlisse, _List_Nil);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				default:
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Produits$StructureCatalogue$Classifications$Update$surLaSection,
							function (finie) {
								return _Utils_update(
									finie,
									{m_: $elm$core$Maybe$Nothing});
							},
							model),
						_List_Nil);
			}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Effet$PourLesGammes = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Gammes$Update$deLaMarque = function (commande) {
	switch (commande.$) {
		case 7:
			return true;
		case 8:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Gammes$Update$structureARelire = F2(
	function (avant, msg) {
		switch (msg.$) {
			case 10:
				var reponse = msg.a;
				var _v1 = A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, avant.l2);
				_v1$2:
				while (true) {
					if (!_v1.$) {
						switch (_v1.a.b.$) {
							case 0:
								var _v2 = _v1.a;
								var _v3 = _v2.b;
								var commande = _v3.a;
								var rendue = _v3.b;
								var repondue = _v3.c;
								return (rendue.sy || (!repondue)) && function () {
									if (commande.$ === 4) {
										return repondue;
									} else {
										return $author$project$Components$Produits$StructureCatalogue$Gammes$Update$deLaMarque(commande) && $elm$core$List$isEmpty(avant.iv);
									}
								}();
							case 1:
								var _v5 = _v1.a;
								var _v6 = _v5.b;
								var commande = _v6.a;
								var erreur = _v6.c;
								return $author$project$Components$Produits$StructureCatalogue$Gammes$Update$deLaMarque(commande) && $author$project$Components$Produits$Common$Refus$perime(erreur);
							default:
								break _v1$2;
						}
					} else {
						break _v1$2;
					}
				}
				return false;
			case 2:
				return true;
			default:
				return false;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Gammes$Update$aleaDemande = function (model) {
	return _Utils_eq(model.l2, $author$project$API$Envoi$SansProcessUid) ? _List_fromArray(
		[$author$project$Components$Produits$Common$Effet$DemanderProcessUid]) : _List_Nil;
};
var $author$project$Catalogue$API$WriteAPIModel$RattacherUneGamme = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$RetirerUneGammeDUneMarque = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$rattacherUneGammeAUneMarque = 'rattacher-une-gamme-a-une-marque';
var $author$project$API$NavLinksDictionary$retirerUneGammeDUneMarque = 'retirer-une-gamme-d-une-marque';
var $author$project$Components$Produits$StructureCatalogue$Gammes$Model$commandesDuVolet = F3(
	function (marque, changees, connues) {
		var changee = A2(
			$elm$core$List$filter,
			function (gamme) {
				return A2($elm$core$List$member, gamme.Aq, changees);
			},
			connues.gG);
		var rattachements = A2(
			$elm$core$List$filterMap,
			function (gamme) {
				return A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(
						A2($author$project$Catalogue$API$WriteAPIModel$RattacherUneGamme, gamme.Aq, marque)),
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rattacherUneGammeAUneMarque, gamme.nQ));
			},
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Basics$not,
					function ($) {
						return $.tx;
					}),
				changee));
		var retraits = A2(
			$elm$core$List$filterMap,
			function (gamme) {
				return A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(
						A2($author$project$Catalogue$API$WriteAPIModel$RetirerUneGammeDUneMarque, gamme.Aq, marque)),
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerUneGammeDUneMarque, gamme.nQ));
			},
			A2(
				$elm$core$List$filter,
				function ($) {
					return $.tx;
				},
				changee));
		return _Utils_ap(rattachements, retraits);
	});
var $author$project$Components$Produits$Common$Saisie$DeGamme = 1;
var $author$project$Components$Produits$StructureCatalogue$Gammes$Update$contexte = function (model) {
	var tournures = $author$project$Catalogue$Vocabulaire$tournures(
		{fA: $author$project$Catalogue$Vocabulaire$codeGamme, Bl: $elm$core$Maybe$Nothing});
	return {
		aV: A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$I18n$Traductions$tel),
		gi: tournures.gi,
		Dj: A2($author$project$Components$Produits$Common$Saisie$nomSaisi, 1, model.hP),
		fd: tournures
	};
};
var $author$project$Components$Produits$StructureCatalogue$Gammes$Model$idDuNom = function (model) {
	return A2(
		$author$project$Components$Produits$Common$Formulaire$idDuNom,
		1,
		$author$project$Components$Shared$Drawer$Model$idRacine(model.kX));
};
var $author$project$Components$Produits$StructureCatalogue$Gammes$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{kX: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Produits$Common$Effet$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Produits$Common$Saisie$enCours(model.hP)
				},
				geste,
				model.kX));
	});
var $author$project$Components$Produits$StructureCatalogue$Gammes$Update$conclure = F2(
	function (issue, model) {
		var saisie = model.hP;
		switch (issue.$) {
			case 0:
				if (issue.a.$ === 4) {
					if (issue.c) {
						var rendue = issue.b;
						return A2(
							$elm$core$Tuple$mapSecond,
							function (effets) {
								return _Utils_ap(
									effets,
									rendue.sy ? _List_Nil : _List_fromArray(
										[
											$author$project$Components$Produits$Common$Effet$AttendreAvantDeRelire($author$project$Components$Produits$Common$Envoi$delaiDeRelectureMs)
										]));
							},
							A2(
								$author$project$Components$Produits$StructureCatalogue$Gammes$Update$versLeDrawer,
								$author$project$Components$Shared$Drawer$Update$Fermer,
								_Utils_update(
									model,
									{hP: $author$project$Components$Produits$Common$Saisie$vide})));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									hP: _Utils_update(
										saisie,
										{
											pZ: $elm$core$Maybe$Just($author$project$Components$Produits$Common$Refus$rejeu)
										})
								}),
							_List_Nil);
					}
				} else {
					var commande = issue.a;
					var rendue = issue.b;
					var repondue = issue.c;
					return $author$project$Components$Produits$StructureCatalogue$Gammes$Update$deLaMarque(commande) ? _Utils_Tuple2(
						repondue ? model : _Utils_update(
							model,
							{iv: _List_Nil}),
						(rendue.sy || (!repondue)) ? _List_Nil : _List_fromArray(
							[
								$author$project$Components$Produits$Common$Effet$AttendreAvantDeRelire($author$project$Components$Produits$Common$Envoi$delaiDeRelectureMs)
							])) : _Utils_Tuple2(model, _List_Nil);
				}
			case 1:
				if (issue.a.$ === 4) {
					if (!issue.c.$) {
						var _v1 = issue.c;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									hP: _Utils_update(
										saisie,
										{gi: true})
								}),
							_List_fromArray(
								[
									$author$project$Components$Produits$Common$Effet$PlacerFocus(
									$author$project$Components$Produits$StructureCatalogue$Gammes$Model$idDuNom(model))
								]));
					} else {
						var refus = issue.b;
						var erreur = issue.c;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									hP: _Utils_update(
										saisie,
										{
											pZ: $elm$core$Maybe$Just(
												A3(
													$author$project$Components$Produits$Common$Refus$message,
													$author$project$Components$Produits$StructureCatalogue$Gammes$Update$contexte(model),
													refus,
													erreur))
										})
								}),
							_List_Nil);
					}
				} else {
					var commande = issue.a;
					return _Utils_Tuple2(
						$author$project$Components$Produits$StructureCatalogue$Gammes$Update$deLaMarque(commande) ? _Utils_update(
							model,
							{iv: _List_Nil}) : model,
						_List_Nil);
				}
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Catalogue$API$WriteAPIModel$CreerUneGamme = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Gammes$Model$commandeDeCreation = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		function (ouverture) {
			var _v0 = A2($author$project$Components$Produits$Common$Saisie$valide, 1, model.hP);
			if ((!_v0.$) && (_v0.a.$ === 1)) {
				var gamme = _v0.a.a;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(
						$author$project$Catalogue$API$WriteAPIModel$CreerUneGamme(
							{
								R: gamme.R,
								gX: A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.Aq;
									},
									ouverture.gX),
								n8: gamme.n8,
								os: ouverture.os,
								ey: $elm$core$Maybe$Nothing
							}),
						ouverture.nB));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		model.ew);
};
var $author$project$Components$Produits$StructureCatalogue$Gammes$Update$creer = function (model) {
	var _v0 = $author$project$Components$Produits$StructureCatalogue$Gammes$Model$commandeDeCreation(model);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var commande = _v1.a;
		var lien = _v1.b;
		var _v2 = A3(
			$author$project$Components$Produits$Common$Envoi$partir,
			$elm$core$Maybe$Just(lien),
			commande,
			model.l2);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var envoi = _v3.a;
			var effets = _v3.b;
			var saisie = model.hP;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: envoi,
						hP: _Utils_update(
							saisie,
							{gi: false, pZ: $elm$core$Maybe$Nothing})
					}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_eq(model.ew, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : _Utils_Tuple2(
			_Utils_update(
				model,
				{
					hP: $author$project$Components$Produits$Common$Saisie$tenter(model.hP)
				}),
			_List_fromArray(
				[
					$author$project$Components$Produits$Common$Effet$PlacerFocus(
					$author$project$Components$Produits$StructureCatalogue$Gammes$Model$idDuNom(model))
				]));
	}
};
var $author$project$Components$Produits$StructureCatalogue$Gammes$API$QueryAPIModel$FicheDeMarque = F3(
	function (marque, portees, gammes) {
		return {gG: gammes, gX: marque, hu: portees};
	});
var $author$project$Catalogue$API$QueryAPIModel$GammeDuClient = F8(
	function (id, libelles, millesime, appartient, toutes, marques, exclues, liens) {
		return {tx: appartient, mn: exclues, Aq: id, R: libelles, nQ: liens, cU: marques, n8: millesime, rO: toutes};
	});
var $author$project$Catalogue$API$QueryAPIModel$MarqueNommee = F2(
	function (id, libelles) {
		return {Aq: id, R: libelles};
	});
var $author$project$Catalogue$API$QueryAPIModel$marqueNommeeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'libelles',
	$author$project$Catalogue$API$QueryAPIModel$libellesDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$author$project$Catalogue$Identifiants$elementIdDecoder,
		$elm$json$Json$Decode$succeed($author$project$Catalogue$API$QueryAPIModel$MarqueNommee)));
var $author$project$Catalogue$API$QueryAPIModel$gammeDuClientDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'exclues',
		$elm$json$Json$Decode$list($author$project$Catalogue$API$QueryAPIModel$marqueNommeeDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'marques',
			$elm$json$Json$Decode$list($author$project$Catalogue$API$QueryAPIModel$marqueNommeeDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'toutes',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'appartient',
					$elm$json$Json$Decode$bool,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'millesime',
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'libelles',
							$author$project$Catalogue$API$QueryAPIModel$libellesDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$author$project$Catalogue$Identifiants$elementIdDecoder,
								$elm$json$Json$Decode$succeed($author$project$Catalogue$API$QueryAPIModel$GammeDuClient)))))))));
var $author$project$Catalogue$API$QueryAPIModel$gammesDuClientDecoder = $elm$json$Json$Decode$list($author$project$Catalogue$API$QueryAPIModel$gammeDuClientDecoder);
var $author$project$Components$Produits$StructureCatalogue$Gammes$API$QueryAPIModel$ficheDeMarqueDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'gammesDuClient',
	$author$project$Catalogue$API$QueryAPIModel$gammesDuClientDecoder,
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'enfants',
		$elm$json$Json$Decode$list($author$project$Catalogue$API$QueryAPIModel$elementDecoder),
		_List_Nil,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['element', 'id']),
			$author$project$Catalogue$Identifiants$elementIdDecoder,
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$Gammes$API$QueryAPIModel$FicheDeMarque))));
var $author$project$Components$Produits$StructureCatalogue$Gammes$Update$suivante = function (model) {
	var _v0 = model.iv;
	if (_v0.b) {
		var _v1 = _v0.a;
		var commande = _v1.a;
		var lien = _v1.b;
		var reste = _v0.b;
		var _v2 = A3(
			$author$project$Components$Produits$Common$Envoi$partir,
			$elm$core$Maybe$Just(lien),
			commande,
			model.l2);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var envoi = _v3.a;
			var effets = _v3.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{iv: reste, l2: envoi}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Gammes$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var octets = msg.a;
				return $author$project$Components$Produits$StructureCatalogue$Gammes$Update$suivante(
					_Utils_update(
						model,
						{
							l2: A2($author$project$Components$Produits$Common$Envoi$recevoir, octets, model.l2)
						}));
			case 1:
				var reponse = msg.a;
				var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$StructureCatalogue$Gammes$API$QueryAPIModel$ficheDeMarqueDecoder, reponse);
				if (!_v1.$) {
					var fiche = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								fY: $elm$core$Maybe$Just(
									{wD: fiche.gX, gG: fiche.gG, hu: fiche.hu})
							}),
						_List_Nil);
				} else {
					var refus = _v1.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 2:
				return _Utils_Tuple2(model, _List_Nil);
			case 3:
				var geste = msg.a;
				return A2($author$project$Components$Produits$Common$Envoi$retientLeDrawer, model.l2, geste) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Produits$StructureCatalogue$Gammes$Update$versLeDrawer, geste, model);
			case 4:
				var ouverture = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(
						_Utils_ap(
							$author$project$Components$Produits$StructureCatalogue$Gammes$Update$aleaDemande(model),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$Lire, $elm$core$List$singleton),
									ouverture.zo)))),
					A2(
						$author$project$Components$Produits$StructureCatalogue$Gammes$Update$versLeDrawer,
						$author$project$Components$Shared$Drawer$Update$Ouvrir(ouverture.xe),
						_Utils_update(
							model,
							{
								ew: $elm$core$Maybe$Just(ouverture),
								hP: $author$project$Components$Produits$Common$Saisie$vide
							})));
			case 5:
				var champ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hP: A2($author$project$Components$Produits$Common$Saisie$saisir, champ, model.hP)
						}),
					_List_Nil);
			case 6:
				return $author$project$Components$Produits$StructureCatalogue$Gammes$Update$creer(model);
			case 7:
				var lien = msg.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						$author$project$Components$Produits$StructureCatalogue$Gammes$Update$aleaDemande(model),
						_List_fromArray(
							[
								$author$project$Components$Produits$Common$Effet$Lire(lien)
							])));
			case 8:
				var marque = msg.a;
				var changees = msg.b;
				var _v2 = model.fY;
				if (!_v2.$) {
					var connues = _v2.a;
					var _v3 = A3($author$project$Components$Produits$StructureCatalogue$Gammes$Model$commandesDuVolet, marque, changees, connues);
					if (!_v3.b) {
						return _Utils_Tuple2(model, _List_Nil);
					} else {
						var commandes = _v3;
						return $author$project$Components$Produits$StructureCatalogue$Gammes$Update$suivante(
							_Utils_update(
								model,
								{iv: commandes}));
					}
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							iv: _List_Nil,
							kX: A3(
								$author$project$Components$Shared$Drawer$Update$update,
								{Il: false},
								$author$project$Components$Shared$Drawer$Update$Fermer,
								model.kX).a
						}),
					_List_Nil);
			default:
				var reponse = msg.a;
				var _v4 = A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, model.l2);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var envoi = _v5.a;
					var issue = _v5.b;
					var effets = _v5.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Produits$StructureCatalogue$Gammes$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Gammes$Update$voletRefuse = F2(
	function (avant, msg) {
		if (msg.$ === 10) {
			var reponse = msg.a;
			var _v1 = A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, avant.l2);
			_v1$2:
			while (true) {
				if (!_v1.$) {
					switch (_v1.a.b.$) {
						case 0:
							if (!_v1.a.b.c) {
								var _v2 = _v1.a;
								var _v3 = _v2.b;
								var commande = _v3.a;
								return $author$project$Components$Produits$StructureCatalogue$Gammes$Update$deLaMarque(commande) ? $elm$core$Maybe$Just($author$project$Components$Produits$Common$Refus$rejeu) : $elm$core$Maybe$Nothing;
							} else {
								break _v1$2;
							}
						case 1:
							var _v4 = _v1.a;
							var _v5 = _v4.b;
							var commande = _v5.a;
							var refus = _v5.b;
							var erreur = _v5.c;
							return $author$project$Components$Produits$StructureCatalogue$Gammes$Update$deLaMarque(commande) ? $elm$core$Maybe$Just(
								A3(
									$author$project$Components$Produits$Common$Refus$message,
									$author$project$Components$Produits$StructureCatalogue$Gammes$Update$contexte(avant),
									refus,
									erreur)) : $elm$core$Maybe$Nothing;
						default:
							break _v1$2;
					}
				} else {
					break _v1$2;
				}
			}
			return $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Gammes$Update$voletTermine = F2(
	function (avant, msg) {
		if (msg.$ === 10) {
			var reponse = msg.a;
			var _v1 = A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, avant.l2);
			if (((!_v1.$) && (!_v1.a.b.$)) && _v1.a.b.c) {
				var _v2 = _v1.a;
				var _v3 = _v2.b;
				var commande = _v3.a;
				return $author$project$Components$Produits$StructureCatalogue$Gammes$Update$deLaMarque(commande) && $elm$core$List$isEmpty(avant.iv);
			} else {
				return false;
			}
		} else {
			return false;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Update$versLesGammes = F2(
	function (geste, model) {
		return function () {
			var _v0 = A2($author$project$Components$Produits$StructureCatalogue$Gammes$Update$voletRefuse, model.gG, geste);
			if (!_v0.$) {
				var message = _v0.a;
				return $author$project$Components$Produits$StructureCatalogue$Update$puis(
					function (suivant) {
						return _Utils_Tuple2(
							_Utils_update(
								suivant,
								{
									p9: $elm$core$Maybe$Just(message)
								}),
							_List_Nil);
					});
			} else {
				return $elm$core$Basics$identity;
			}
		}()(
			(A2($author$project$Components$Produits$StructureCatalogue$Gammes$Update$voletTermine, model.gG, geste) ? $author$project$Components$Produits$StructureCatalogue$Update$puis(
				$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$versLeDrawerDeRangement($author$project$Components$Shared$Drawer$Update$Fermer)) : $elm$core$Basics$identity)(
				(A2($author$project$Components$Produits$StructureCatalogue$Gammes$Update$structureARelire, model.gG, geste) ? $author$project$Components$Produits$StructureCatalogue$Update$puis(
					function (suivant) {
						return _Utils_Tuple2(
							suivant,
							$author$project$Components$Produits$StructureCatalogue$Commandes$relire(suivant));
					}) : $elm$core$Basics$identity)(
					A3(
						$elm$core$Tuple$mapBoth,
						function (gammes) {
							return _Utils_update(
								model,
								{gG: gammes});
						},
						$elm$core$List$map($author$project$Components$Produits$StructureCatalogue$Effet$PourLesGammes),
						A2($author$project$Components$Produits$StructureCatalogue$Gammes$Update$update, geste, model.gG)))));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$ouvrirLAjout = F2(
	function (i18n, _v0) {
		var model = _v0.a;
		var ajout = _v0.b;
		if (!ajout.$) {
			switch (ajout.a.$) {
				case 0:
					var _v2 = ajout.a;
					return A3($author$project$Components$Produits$StructureCatalogue$Update$versLesMarques, i18n, $author$project$Components$Produits$StructureCatalogue$Marques$Update$CreationOuverte, model);
				case 1:
					var ouverture = ajout.a.a;
					return A2(
						$author$project$Components$Produits$StructureCatalogue$Update$versLesGammes,
						$author$project$Components$Produits$StructureCatalogue$Gammes$Update$CreationOuverte(ouverture),
						model);
				case 4:
					var ouverture = ajout.a.a;
					return A2(
						$author$project$Components$Produits$StructureCatalogue$Update$versLesProduits,
						$author$project$Components$Produits$StructureCatalogue$Produits$Update$CreationOuverte(ouverture),
						model);
				case 2:
					var ouverture = ajout.a.a;
					return A2(
						$author$project$Components$Produits$StructureCatalogue$Update$versLesCategories,
						$author$project$Components$Produits$StructureCatalogue$Categories$Update$CreationOuverteSous(ouverture),
						model);
				default:
					var valeur = ajout.a.a;
					return A2(
						$author$project$Components$Produits$StructureCatalogue$Classifications$Update$update,
						$author$project$Components$Produits$StructureCatalogue$Classifications$Update$AjoutALEtageOuvert(valeur),
						model);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Archivage$Model$FiltreesOuSelectionnees = 1;
var $author$project$Components$Produits$StructureCatalogue$Archivage$Update$ouvertSurLaSelection = F3(
	function (references, id, model) {
		return A3(
			$author$project$Components$Produits$StructureCatalogue$Archivage$Update$ouvertAvec,
			function (a) {
				return _Utils_update(
					a,
					{F$: 1, hD: references});
			},
			id,
			model);
	});
var $author$project$Components$Produits$StructureCatalogue$Archivage$Update$ouvertSurLeFiltre = F3(
	function (filtre, id, model) {
		return A3(
			$author$project$Components$Produits$StructureCatalogue$Archivage$Update$ouvertAvec,
			function (a) {
				return _Utils_update(
					a,
					{
						zH: $elm$core$Maybe$Just(filtre),
						F$: 1
					});
			},
			id,
			model);
	});
var $author$project$Components$Produits$StructureCatalogue$Update$ouvrirLArchivageDemande = function (model) {
	var _v0 = model.i_;
	if (!_v0.$) {
		if (!_v0.a.b.$) {
			var _v1 = _v0.a;
			var id = _v1.a;
			var filtre = _v1.b.a;
			return A3(
				$author$project$Components$Produits$StructureCatalogue$Archivage$Update$ouvertSurLeFiltre,
				filtre,
				id,
				_Utils_update(
					model,
					{i_: $elm$core$Maybe$Nothing}));
		} else {
			var _v2 = _v0.a;
			var id = _v2.a;
			var references = _v2.b.a;
			return A3(
				$author$project$Components$Produits$StructureCatalogue$Archivage$Update$ouvertSurLaSelection,
				references,
				id,
				_Utils_update(
					model,
					{i_: $elm$core$Maybe$Nothing}));
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Gammes$Update$VoletOuvert = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$ouvrirLeVolet = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_Utils_Tuple2(model, _List_Nil),
		A2(
			$elm$core$Maybe$map,
			function (lien) {
				return A2(
					$author$project$Components$Produits$StructureCatalogue$Update$versLesGammes,
					$author$project$Components$Produits$StructureCatalogue$Gammes$Update$VoletOuvert(lien),
					model);
			},
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.gX;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.nQ;
						},
						$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$self))),
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.gG;
					},
					model.hA))));
};
var $author$project$Components$Produits$Common$ChoixDArticles$pageDemandee = F2(
	function (page, choix) {
		return _Utils_update(
			choix,
			{
				DX: choix.DX + 1,
				EE: A2($elm$core$Basics$max, 1, page)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$pageDemandee = F2(
	function (page, model) {
		return $author$project$Components$Produits$StructureCatalogue$Informations$Update$chercherDesArticles(
			_Utils_Tuple2(
				A2(
					$author$project$Components$Produits$StructureCatalogue$Informations$Update$avecLeChoix,
					$author$project$Components$Produits$Common$ChoixDArticles$pageDemandee(page),
					model),
				_List_Nil));
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$perime = F4(
	function (commande, estPerime, avant, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		var lienDeLApercu = A2(
			$elm$core$Maybe$andThen,
			function (_v3) {
				var t = _v3.b;
				return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$apercuDeLaReecriture, t.nQ);
			},
			$author$project$Components$Produits$StructureCatalogue$Etages$Update$reglee(avant));
		var _v1 = _Utils_Tuple3(commande, avant.q, lienDeLApercu);
		if (((_v1.a.$ === 26) && (_v1.b.$ === 2)) && (!_v1.c.$)) {
			var _v2 = _v1.a;
			var lu = _v1.b.a;
			var lien = _v1.c.a;
			return estPerime ? _Utils_Tuple2(
				_Utils_update(
					model,
					{
						q: $author$project$Components$Produits$StructureCatalogue$Etages$Model$ApercuDemande(
							{mW: lu.mW, eC: true, qL: lu.qL, h6: lu.h6})
					}),
				_Utils_ap(
					effets,
					_List_fromArray(
						[
							A2($author$project$Components$Produits$StructureCatalogue$Effet$DemanderUnApercu, lien, lu.mW)
						]))) : _Utils_Tuple2(model, effets);
		} else {
			return _Utils_Tuple2(model, effets);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Etage$retirerLePerimetre = F2(
	function (cle, ouvert) {
		return _Utils_update(
			ouvert,
			{
				pg: A2($elm$core$Dict$remove, cle, ouvert.pg)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$perimetreDEtageRetire = F2(
	function (cle, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					s: A2(
						$elm$core$Maybe$map,
						$author$project$Components$Produits$StructureCatalogue$Informations$Etage$retirerLePerimetre(cle),
						model.s)
				}),
			_List_Nil);
	});
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Etage$retirerLaPose = F2(
	function (cle, ouvert) {
		return _Utils_update(
			ouvert,
			{
				qJ: A2($elm$core$Set$insert, cle, ouvert.qJ)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$perimetrePoseRetire = F2(
	function (cle, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					s: A2(
						$elm$core$Maybe$map,
						$author$project$Components$Produits$StructureCatalogue$Informations$Etage$retirerLaPose(cle),
						model.s)
				}),
			_List_Nil);
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Etage$retenirLePerimetre = F3(
	function (cle, retenu, ouvert) {
		return _Utils_update(
			ouvert,
			{
				pg: A3($elm$core$Dict$insert, cle, retenu, ouvert.pg)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$versLeChoixDePerimetre = F2(
	function (geste, model) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{Il: false},
			geste,
			model.dN);
		var drawer = _v0.a;
		var effets = _v0.b;
		var suivi = _Utils_update(
			model,
			{dN: drawer});
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? suivi : _Utils_update(
				suivi,
				{fO: $elm$core$Maybe$Nothing}),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$perimetreRetenu = function (model) {
	var _v0 = _Utils_Tuple2(model.fO, model.s);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var cle = _v0.a.a.dy;
		var choisi = _v0.a.a.vd;
		var ouvert = _v0.b.a;
		var retenu = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (p) {
					return _Utils_eq(
						$elm$core$Maybe$Just(p.Aq),
						choisi);
				},
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.pg;
						},
						model.cl))));
		if (!retenu.$) {
			var p = retenu.a;
			return A2(
				$author$project$Components$Produits$StructureCatalogue$Informations$Update$versLeChoixDePerimetre,
				$author$project$Components$Shared$Drawer$Update$Fermer,
				_Utils_update(
					model,
					{
						s: $elm$core$Maybe$Just(
							A3(
								$author$project$Components$Produits$StructureCatalogue$Informations$Etage$retenirLePerimetre,
								cle,
								{Aq: p.Aq, Dj: p.Dj},
								ouvert))
					}));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$perimetreSelectionne = F2(
	function (id, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					fO: A2(
						$elm$core$Maybe$map,
						function (choix) {
							return _Utils_update(
								choix,
								{
									vd: $elm$core$Maybe$Just(id)
								});
						},
						model.fO)
				}),
			_List_Nil);
	});
var $author$project$Components$Produits$Common$ChoixDUnPerimetre$Choisissable = F5(
	function (id, nom, archive, decompte, criteres) {
		return {tE: archive, wp: criteres, wT: decompte, Aq: id, Dj: nom};
	});
var $author$project$API$NavLinksDictionary$creerUnPerimetreDepuisUnFiltre = 'creer-un-perimetre-depuis-un-filtre';
var $author$project$API$NavLinksDictionary$rechercheDesPerimetres = 'recherche';
var $author$project$Components$Produits$Common$ChoixDUnPerimetre$Segment = F2(
	function (texte, fort) {
		return {dX: fort, Jx: texte};
	});
var $author$project$Components$Produits$Common$ChoixDUnPerimetre$segmentDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Produits$Common$ChoixDUnPerimetre$Segment,
	A2($elm$json$Json$Decode$field, 'texte', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'fort', $elm$json$Json$Decode$bool));
var $author$project$Components$Produits$Common$ChoixDUnPerimetre$annuaireDecoder = A4(
	$elm$json$Json$Decode$map3,
	F3(
		function (perimetres, archivesTrouvees, liens) {
			return {
				i1: archivesTrouvees,
				wl: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUnPerimetreDepuisUnFiltre, liens.h0),
				pg: perimetres,
				hC: A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$rechercheDesPerimetres, liens.gF)
			};
		}),
	A2(
		$elm$json$Json$Decode$field,
		'perimetres',
		$elm$json$Json$Decode$list(
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'criteresResumes',
				$elm$json$Json$Decode$list($author$project$Components$Produits$Common$ChoixDUnPerimetre$segmentDecoder),
				_List_Nil,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'decompte',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'archive',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'nom',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'uid',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Components$Produits$Common$ChoixDUnPerimetre$Choisissable)))))))),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'archivesTrouves', $elm$json$Json$Decode$int),
				$elm$json$Json$Decode$succeed(0)
			])),
	$author$project$API$Liens$deLaRessource);
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$perimetresLus = F3(
	function (numero, reponse, model) {
		if (!_Utils_eq(
			numero,
			A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.DX;
					},
					model.fO)))) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$ChoixDUnPerimetre$annuaireDecoder, reponse);
			if (!_v0.$) {
				var annuaire = _v0.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cl: $elm$core$Maybe$Just(annuaire),
							fO: A2(
								$elm$core$Maybe$map,
								function (choix) {
									return _Utils_update(
										choix,
										{AJ: false});
								},
								model.fO)
						}),
					_List_Nil);
			} else {
				var refus = _v0.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fO: A2(
								$elm$core$Maybe$map,
								function (choix) {
									return _Utils_update(
										choix,
										{AJ: true});
								},
								model.fO)
						}),
					(refus.ri === 401) ? _List_fromArray(
						[$author$project$Components$Produits$StructureCatalogue$Effet$Reconnecter]) : _List_Nil);
			}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$PlacerSousChaqueValeurDeLEtage = F3(
	function (a, b, c) {
		return {$: 32, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$commandesDuPlacement = F2(
	function (typologie, placement) {
		var siens = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.fm;
				},
				$elm$core$Basics$eq(placement.fm)),
			typologie.Di);
		var sousLeParent = function (parent) {
			return A2(
				$elm$core$List$any,
				function (noeud) {
					return _Utils_eq(
						noeud.ey,
						$elm$core$Maybe$Just(parent)) && (!noeud.iz);
				},
				siens);
		};
		var _v0 = placement.vf;
		var aPlacer = _v0;
		if (!_Utils_eq(aPlacer.r3, typologie.Aq)) {
			return _List_Nil;
		} else {
			var _v1 = _Utils_Tuple3(
				A2(
					$elm$core$List$filter,
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, sousLeParent),
					aPlacer.hl),
				aPlacer.hl,
				aPlacer.Ge);
			if ((!_v1.a.b) && (!_v1.b.b)) {
				if (_v1.c) {
					return A2(
						$elm$core$List$any,
						function (noeud) {
							return _Utils_eq(noeud.md, aPlacer.md) && (!noeud.iz);
						},
						siens) ? _List_Nil : _List_fromArray(
						[
							A2(
							$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$PlacerUnNoeud,
							typologie.Aq,
							{md: aPlacer.md, ey: $elm$core$Maybe$Nothing, fm: placement.fm})
						]);
				} else {
					return _List_fromArray(
						[
							A3($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$PlacerSousChaqueValeurDeLEtage, typologie.Aq, aPlacer.md, placement.fm)
						]);
				}
			} else {
				var parents = _v1.a;
				return A2(
					$elm$core$List$map,
					function (parent) {
						return A2(
							$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$PlacerUnNoeud,
							typologie.Aq,
							{
								md: aPlacer.md,
								ey: $elm$core$Maybe$Just(parent),
								fm: placement.fm
							});
					},
					parents);
			}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$placementsAttendus = function (model) {
	var typologieDe = function (placement) {
		var _v2 = placement.vf;
		var aPlacer = _v2;
		return aPlacer.r3;
	};
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		function (placement) {
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$pair(placement),
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.vk;
						},
						$author$project$Components$Produits$StructureCatalogue$Classifications$Model$classificationDe(
							typologieDe(placement))),
					model.h$));
		},
		model.pl);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var placement = _v1.a;
		var typologie = _v1.b;
		return $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$relancer(
			_Utils_update(
				model,
				{
					cd: _Utils_ap(
						model.cd,
						A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$commandesDuPlacement, typologie, placement)),
					pl: $elm$core$Maybe$Nothing
				}));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$plurielSaisi = F2(
	function (langue, texte) {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Etages$Model$surLaForme,
			langue,
			function (forme) {
				return _Utils_update(
					forme,
					{bT: texte});
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$plurielSaisi = F3(
	function (langue, texte, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					I: A3($author$project$Components$Produits$StructureCatalogue$Etages$Model$plurielSaisi, langue, texte, model.I)
				}),
			_List_Nil);
	});
var $author$project$Components$Produits$StructureCatalogue$Archivage$Update$porteeChoisie = F2(
	function (portee, model) {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Archivage$Update$changerLeChoix,
			function (a) {
				return _Utils_update(
					a,
					{F$: portee});
			},
			model);
	});
var $author$project$Components$Produits$StructureCatalogue$Archivage$Update$porteeRetiree = function (model) {
	return A2(
		$author$project$Components$Produits$StructureCatalogue$Archivage$Update$changerLeChoix,
		function (a) {
			return _Utils_update(
				a,
				{zH: $elm$core$Maybe$Nothing, F$: 0, hD: _List_Nil});
		},
		model);
};
var $author$project$Components$Produits$StructureCatalogue$Gammes$Update$VoletEnregistre = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Marques$Update$NatureDemandee = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Update$avecLaNature = F3(
	function (i18n, avant, pas) {
		var _v0 = A2($elm$core$Maybe$andThen, $author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$licenceChangee, avant.hA);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var marque = _v1.a;
			var sousLicence = _v1.b;
			return A2(
				$author$project$Components$Produits$StructureCatalogue$Update$puis,
				A2(
					$author$project$Components$Produits$StructureCatalogue$Update$versLesMarques,
					i18n,
					A2($author$project$Components$Produits$StructureCatalogue$Marques$Update$NatureDemandee, marque, sousLicence)),
				pas);
		} else {
			return pas;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Update$partDesGammes = function (effet) {
	if ((effet.$ === 21) && (effet.a.$ === 16)) {
		var _v1 = effet.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$DeplacerUnNoeud = F3(
	function (a, b, c) {
		return {$: 28, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$RangerSousUnNoeud = F3(
	function (a, b, c) {
		return {$: 30, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$RetirerUnNoeud = F2(
	function (a, b) {
		return {$: 33, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$estDerive = function (noeud) {
	return _Utils_eq(
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$deplacerUnNoeud, noeud.nQ),
		$elm$core$Maybe$Nothing) && (!_Utils_eq(
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerUnNoeud, noeud.nQ),
		$elm$core$Maybe$Nothing));
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$valeursDistinctes = A2(
	$elm$core$List$foldl,
	F2(
		function (noeud, vues) {
			return A2($elm$core$List$member, noeud.fm, vues) ? vues : _Utils_ap(
				vues,
				_List_fromArray(
					[noeud.fm]));
		}),
	_List_Nil);
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$valeursSous = F2(
	function (typologie, noeuds) {
		return $author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$valeursDistinctes(
			A2(
				$elm$core$List$filter,
				function (noeud) {
					return (!noeud.iz) && A2(
						$elm$core$List$any,
						function (parent) {
							return _Utils_eq(
								noeud.ey,
								$elm$core$Maybe$Just(parent.Aq));
						},
						noeuds);
				},
				typologie.Di));
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$commandes = F2(
	function (typologie, rangement) {
		var retirees = A2(
			$elm$core$List$filter,
			function (valeur) {
				return !A2($elm$core$List$member, valeur, rangement.vv);
			},
			rangement.AP);
		var premier = $elm$core$List$head(rangement.ea.Di);
		var derivesRetirees = function (noeud) {
			return A2(
				$elm$core$List$filter,
				function (fils) {
					return A2($elm$core$List$member, fils.fm, retirees);
				},
				A2(
					$elm$core$List$filter,
					function (fils) {
						return _Utils_eq(
							fils.ey,
							$elm$core$Maybe$Just(noeud.Aq)) && $author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$estDerive(fils);
					},
					typologie.Di));
		};
		var retraits = A2(
			$elm$core$List$map,
			function (derive) {
				return A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$RetirerUnNoeud, typologie.Aq, derive.Aq);
			},
			A2($elm$core$List$concatMap, derivesRetirees, rangement.ea.Di));
		var ajoutees = A2(
			$elm$core$List$filter,
			function (valeur) {
				return !A2($elm$core$List$member, valeur, rangement.AP);
			},
			rangement.vv);
		var deplacements = function () {
			if (!premier.$) {
				var parent = premier.a;
				return A2(
					$elm$core$List$filterMap,
					function (valeur) {
						return A2(
							$elm$core$Maybe$map,
							function (aRangerLa) {
								return A3(
									$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$DeplacerUnNoeud,
									typologie.Aq,
									aRangerLa.Aq,
									$elm$core$Maybe$Just(parent.Aq));
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (noeud) {
										return noeud.iz && (_Utils_eq(noeud.fm, valeur) && _Utils_eq(noeud.md, rangement.md.Aq));
									},
									typologie.Di)));
					},
					ajoutees);
			} else {
				return _List_Nil;
			}
		}();
		var ensembles = A2(
			$elm$core$List$filterMap,
			function (noeud) {
				var retiresDeLaPortee = A2(
					$elm$core$List$map,
					function ($) {
						return $.fm;
					},
					derivesRetirees(noeud));
				var presentes = A2(
					$elm$core$List$filter,
					function (valeur) {
						return !A2($elm$core$List$member, valeur, retiresDeLaPortee);
					},
					A2(
						$author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$valeursSous,
						typologie,
						_List_fromArray(
							[noeud])));
				var voulues = _Utils_ap(
					A2(
						$elm$core$List$filter,
						function (valeur) {
							return !A2($elm$core$List$member, valeur, retirees);
						},
						presentes),
					A2(
						$elm$core$List$filter,
						function (valeur) {
							return !A2($elm$core$List$member, valeur, presentes);
						},
						ajoutees));
				return A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$memeEnsemble, voulues, presentes) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					A3($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$RangerSousUnNoeud, typologie.Aq, noeud.Aq, voulues));
			},
			rangement.ea.Di);
		return _Utils_ap(
			deplacements,
			_Utils_ap(ensembles, retraits));
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$rangementDemande = function (model) {
	var _v0 = _Utils_Tuple2(
		model.hA,
		$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$reglee(model));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var rangement = _v0.a.a;
		var _v1 = _v0.b.a;
		var typologie = _v1.b;
		var _v2 = A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$commandes, typologie, rangement);
		if (!_v2.b) {
			return A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Update$versLeDrawerDeRangement, $author$project$Components$Shared$Drawer$Update$Fermer, model);
		} else {
			var commandes = _v2;
			return A2(
				$author$project$Components$Produits$StructureCatalogue$Commandes$enchainer,
				commandes,
				_Utils_update(
					model,
					{p9: $elm$core$Maybe$Nothing}));
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Update$rangementDemande = F2(
	function (i18n, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (rangement) {
				return A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(rangement),
					rangement.gG);
			},
			model.hA);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var volet = _v1.b;
			return A3(
				$author$project$Components$Produits$StructureCatalogue$Update$avecLaNature,
				i18n,
				model,
				function (_v2) {
					var suivant = _v2.a;
					var effets = _v2.b;
					return A2($elm$core$List$any, $author$project$Components$Produits$StructureCatalogue$Update$partDesGammes, effets) ? _Utils_Tuple2(suivant, effets) : A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Update$versLeDrawerDeRangement, $author$project$Components$Shared$Drawer$Update$Fermer, suivant));
				}(
					A2(
						$author$project$Components$Produits$StructureCatalogue$Update$versLesGammes,
						A2($author$project$Components$Produits$StructureCatalogue$Gammes$Update$VoletEnregistre, volet.gX.Aq, volet.CP),
						model)));
		} else {
			return A3(
				$author$project$Components$Produits$StructureCatalogue$Update$avecLaNature,
				i18n,
				model,
				$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$rangementDemande(model));
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$idDuLienDuRangement = 'rangement-de-typologie-ouvrir';
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$sansRangement = function (model) {
	var drawer = model.bZ;
	return _Utils_update(
		model,
		{
			cG: $elm$core$Maybe$Nothing,
			bZ: _Utils_update(
				drawer,
				{wQ: $elm$core$Maybe$Nothing, gt: 0}),
			aL: $elm$core$Maybe$Nothing
		});
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$versLeRangement = F2(
	function (geste, model) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{Il: false},
			geste,
			model.bZ);
		var drawer = _v0.a;
		var effets = _v0.b;
		var suivi = _Utils_update(
			model,
			{bZ: drawer});
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? suivi : $author$project$Components$Produits$StructureCatalogue$Etages$Update$sansRangement(suivi),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$rangementOuvert = function (model) {
	var _v0 = $author$project$Components$Produits$StructureCatalogue$Etages$Update$reglee(model);
	if (!_v0.$) {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Etages$Update$versLeRangement,
			$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Produits$StructureCatalogue$Etages$Model$idDuLienDuRangement),
			$author$project$Components$Produits$StructureCatalogue$Etages$Update$sansRefus(model));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$idDeModifier = 'valeurs-modifier';
var $author$project$Catalogue$API$QueryAPIModel$ValeurCategorie = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$aRanger = F2(
	function (noms, typologie) {
		var sansNoeud = A2(
			$elm$core$List$map,
			function (categorie) {
				return {
					vW: $elm$core$Maybe$Nothing,
					Di: _List_Nil,
					Dj: categorie.Dj.zX,
					fm: $author$project$Catalogue$API$QueryAPIModel$ValeurCategorie(categorie.Aq)
				};
			},
			A2(
				$elm$core$List$filter,
				function (categorie) {
					return (!categorie.tE) && ((!A2(
						$elm$core$List$any,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.fm;
							},
							$elm$core$Basics$eq(
								$author$project$Catalogue$API$QueryAPIModel$ValeurCategorie(categorie.Aq))),
						typologie.Di)) && ($elm$core$List$isEmpty(categorie.FP) || A2(
						$elm$core$List$any,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.vj;
							},
							$elm$core$Basics$eq(typologie.Aq)),
						categorie.FP)));
				},
				noms.dt));
		var dejaPlacee = function (noeud) {
			return A2(
				$elm$core$List$any,
				function (autre) {
					return (!autre.iz) && _Utils_eq(autre.fm, noeud.fm);
				},
				typologie.Di);
		};
		var noeuds = A2(
			$author$project$Components$Produits$StructureCatalogue$Valeurs$Model$lignesDe,
			A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$nomDe, noms, typologie),
			A2(
				$elm$core$List$filter,
				function (noeud) {
					return noeud.iz && (!dejaPlacee(noeud));
				},
				typologie.Di));
		return _Utils_ap(noeuds, sansNoeud);
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$rangeeDans = F3(
	function (typologie, noms, valeur) {
		if (valeur.$ === 2) {
			var id = valeur.a;
			return A2(
				$elm$core$List$any,
				function (categorie) {
					return _Utils_eq(categorie.Aq, id) && A2(
						$elm$core$List$any,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.vj;
							},
							$elm$core$Basics$eq(typologie.Aq)),
						categorie.FP);
				},
				noms.dt);
		} else {
			return true;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$voletDeGammes = F2(
	function (designation, marque) {
		var _v0 = _Utils_Tuple2(
			designation,
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$self, marque.nQ));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var _v1 = _v0.a;
			var code = _v1.a;
			return _Utils_eq(code, $author$project$Catalogue$Vocabulaire$codeGamme) ? $elm$core$Maybe$Just(
				{gX: marque, CP: _List_Nil}) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$ouvrir = F5(
	function (noms, toutes, typologie, colonne, ligne) {
		var suivante = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.bY;
					},
					$elm$core$Basics$eq(colonne.bY + 1)),
				toutes));
		var marque = function () {
			var _v1 = ligne.fm;
			if (_v1.$ === 1) {
				var id = _v1.a;
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(id)),
						noms.cU));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var initiales = A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$valeursSous, typologie, ligne.Di);
		var compteSous = function (noeuds) {
			var _v0 = _Utils_Tuple2(
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.bY;
							},
							$elm$core$Basics$eq(colonne.bY + 2)),
						toutes)),
				A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$valeursSous, typologie, noeuds));
			if ((!_v0.a.$) && _v0.b.b) {
				var apres = _v0.a.a;
				var dessous = _v0.b;
				return $elm$core$Maybe$Just(
					{
						md: apres.Dj,
						w: $elm$core$List$length(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$nomDe, noms, typologie),
									$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
								dessous))
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		return A2(
			$elm$core$Maybe$map,
			function (dessous) {
				var surLEtage = A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.md;
						},
						$elm$core$Basics$eq(dessous.md.Aq)),
					typologie.Di);
				var lues = A2(
					$elm$core$List$filterMap,
					function (valeur) {
						return A2(
							$elm$core$Maybe$map,
							function (nom) {
								var siens = A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.fm;
										},
										$elm$core$Basics$eq(valeur)),
									surLEtage);
								return {
									vW: compteSous(siens),
									Di: siens,
									Dj: nom,
									fm: valeur
								};
							},
							A3($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$nomDe, noms, typologie, valeur));
					},
					$author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$valeursDistinctes(surLEtage));
				var sansNoeud = A2(
					$elm$core$List$filter,
					function (autre) {
						return $elm$core$List$isEmpty(autre.Di) && (dessous.md.wL && ((!A2(
							$elm$core$List$any,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.fm;
								},
								$elm$core$Basics$eq(autre.fm)),
							lues)) && A3($author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$rangeeDans, typologie, noms, autre.fm)));
					},
					A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$aRanger, noms, typologie));
				return {
					vv: initiales,
					md: dessous.md,
					gG: A2(
						$elm$core$Maybe$andThen,
						$author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$voletDeGammes(dessous.md.xt),
						marque),
					AP: initiales,
					ea: ligne,
					gX: marque,
					o_: _Utils_ap(lues, sansNoeud),
					bY: colonne.bY,
					IY: A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.IY;
							},
							marque)),
					r3: typologie.Aq
				};
			},
			suivante);
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$rangementOuvert = F2(
	function (rang, model) {
		var _v0 = A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Update$colonne, rang, model);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var toutes = _v1.a;
			var typologie = _v1.b;
			var choisie = _v1.c;
			var _v2 = A2(
				$elm$core$Maybe$andThen,
				A4(
					$author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$ouvrir,
					$author$project$Components$Produits$StructureCatalogue$Valeurs$Lecture$noms(model),
					toutes,
					typologie,
					choisie),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (ligne) {
							return _Utils_eq(
								$elm$core$Maybe$Just(ligne.fm),
								choisie.ve);
						},
						choisie.gV)));
			if (!_v2.$) {
				var rangement = _v2.a;
				return A2(
					$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$versLeDrawerDeRangement,
					$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$idDeModifier),
					_Utils_update(
						model,
						{
							hA: $elm$core$Maybe$Just(rangement),
							p9: $elm$core$Maybe$Nothing
						}));
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$RattacherUnChampExistant = F2(
	function (a, b) {
		return {$: 36, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$rattachementDemande = function (model) {
	if (!$author$project$Components$Shared$Drawer$Model$estOuvert(model.pO)) {
		return _Utils_Tuple2(model, _List_Nil);
	} else {
		var _v0 = model.pN.vd;
		if (!_v0.$) {
			var champ = _v0.a;
			return A2(
				$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
				A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$RattacherUnChampExistant, model.pN.F$, champ),
				_Utils_update(
					model,
					{aL: $elm$core$Maybe$Nothing}));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	}
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$idDeLaRecherche = 'rattachement-recherche';
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$idDuBoutonRattacher = function (portee) {
	return A2($author$project$Components$Produits$StructureCatalogue$Informations$Model$idDeLaPastille, portee, 'rattacher');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$rattachementOuvert = F2(
	function (portee, model) {
		var _v0 = A2($author$project$Components$Produits$StructureCatalogue$Informations$Model$lienDeRattachement, portee, model.AM);
		if (!_v0.$) {
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Basics$append(
					_Utils_ap(
						$author$project$Components$Produits$StructureCatalogue$Informations$Update$lireLaBibliotheque(model),
						_List_fromArray(
							[
								$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus($author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$idDeLaRecherche)
							]))),
				A2(
					$author$project$Components$Produits$StructureCatalogue$Informations$Update$versLeRattachement,
					$author$project$Components$Shared$Drawer$Update$Ouvrir(
						$author$project$Components$Produits$StructureCatalogue$Informations$Model$idDuBoutonRattacher(portee)),
					_Utils_update(
						model,
						{
							pN: $author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$vide(portee),
							aL: $elm$core$Maybe$Nothing
						})));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ReactiverUneTypologie = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Typologies$Update$reactivationDemandee = F2(
	function (id, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$reactiverLaClassification)),
			A2($author$project$Components$Produits$StructureCatalogue$Typologies$Update$typologieDe, id, model));
		if (!_v0.$) {
			return A2(
				$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ReactiverUneTypologie(id),
				$author$project$Components$Produits$StructureCatalogue$Typologies$Update$sansRefus(model));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ActiverUnNiveau = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Model$idDuBoutonRenommer = function (id) {
	return 'niveau-' + ($author$project$Catalogue$Identifiants$niveauIdToString(id) + '-renommer');
};
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Update$idDuRenommer = F2(
	function (model, id) {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Niveaux$Update$auRangementSiOuvert,
			model,
			$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$idDuBoutonRenommer(id));
	});
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Update$reactiver = F2(
	function (niveau, model) {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Commandes$avecFoyer,
			$author$project$Components$Produits$StructureCatalogue$Model$SurLeControle(
				A2($author$project$Components$Produits$StructureCatalogue$Niveaux$Update$idDuRenommer, model, niveau)),
			A2(
				$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ActiverUnNiveau(niveau),
				model));
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ReadmettreUneValeur = F2(
	function (a, b) {
		return {$: 34, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$readmissionDemandee = F3(
	function (portee, parent, model) {
		var _v0 = $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$reglee(model);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var typologie = _v1.b;
			return A2(
				$author$project$Components$Produits$StructureCatalogue$Commandes$enchainer,
				_List_fromArray(
					[
						A2(
						$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ReadmettreUneValeur,
						typologie.Aq,
						{ey: parent, F$: portee})
					]),
				_Utils_update(
					model,
					{p9: $elm$core$Maybe$Nothing}));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$reaffichee = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_Utils_Tuple2(model, _List_Nil),
		A2(
			$elm$core$Maybe$map,
			function (_v0) {
				var portee = _v0.a;
				var lue = _v0.b;
				return A2(
					$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
					A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$AfficherUneInformation, portee, lue.uN.dy),
					_Utils_update(
						model,
						{aL: $elm$core$Maybe$Nothing}));
			},
			$author$project$Components$Produits$StructureCatalogue$Informations$Update$visee(model)));
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$saisirLaRecherche = F2(
	function (texte, rattachement) {
		return _Utils_update(
			rattachement,
			{hC: texte});
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$rechercheSaisie = function (texte) {
	return $author$project$Components$Produits$StructureCatalogue$Informations$Update$surLeRattachement(
		$author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$saisirLaRecherche(texte));
};
var $author$project$Components$Produits$StructureCatalogue$Update$reconnexion = function (refus) {
	return (refus.ri === 401) ? _List_fromArray(
		[$author$project$Components$Produits$StructureCatalogue$Effet$Reconnecter]) : _List_Nil;
};
var $author$project$Components$Produits$StructureCatalogue$Archivage$Update$refuse = F2(
	function (message, model) {
		var _v0 = $author$project$Components$Produits$StructureCatalogue$Archivage$Update$interrompre(model);
		var arrete = _v0.a;
		var effets = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				arrete,
				{
					aL: $elm$core$Maybe$Just(message)
				}),
			effets);
	});
var $author$project$Components$Produits$StructureCatalogue$Update$perimee = function (erreur) {
	switch (erreur.$) {
		case 76:
			return true;
		case 4:
			return true;
		case 24:
			return true;
		case 25:
			return true;
		case 27:
			return true;
		case 44:
			return true;
		case 40:
			return true;
		case 45:
			return true;
		case 46:
			return true;
		case 50:
			return true;
		case 51:
			return true;
		case 52:
			return true;
		case 53:
			return true;
		case 54:
			return true;
		case 55:
			return true;
		case 56:
			return true;
		case 57:
			return true;
		case 58:
			return true;
		case 59:
			return true;
		case 60:
			return true;
		case 61:
			return true;
		case 63:
			return true;
		case 64:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Update$refusNets = _List_fromArray(
	[400, 403, 409, 422]);
var $author$project$Components$Produits$StructureCatalogue$Update$refuser = F4(
	function (processUid, reponse, refus, affiche) {
		var model = $author$project$Components$Produits$StructureCatalogue$Classifications$Update$sansOrdreEnCours(affiche);
		return (refus.ri === 401) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{
					l2: $author$project$Components$Produits$StructureCatalogue$Model$Pret(processUid)
				}),
			_List_fromArray(
				[$author$project$Components$Produits$StructureCatalogue$Effet$Reconnecter])) : (A2($elm$core$List$member, refus.ri, $author$project$Components$Produits$StructureCatalogue$Update$refusNets) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{l2: $author$project$Components$Produits$StructureCatalogue$Model$SansProcessUid}),
			A2(
				$elm$core$List$cons,
				$author$project$Components$Produits$StructureCatalogue$Effet$DemanderProcessUid,
				$author$project$Components$Produits$StructureCatalogue$Update$perimee(
					$author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$duRefus(reponse)) ? $author$project$Components$Produits$StructureCatalogue$Commandes$relire(model) : _List_Nil)) : _Utils_Tuple2(
			_Utils_update(
				model,
				{
					l2: $author$project$Components$Produits$StructureCatalogue$Model$Pret(processUid)
				}),
			($author$project$Components$Produits$StructureCatalogue$Update$deClassification(affiche) && _Utils_eq(
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$duRefus(reponse),
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ClassificationIntrouvable)) ? $author$project$Components$Produits$StructureCatalogue$Commandes$relire(model) : _List_Nil));
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$regler = F2(
	function (id, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					r6: $elm$core$Maybe$Just(id)
				}),
			_List_fromArray(
				[
					$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(
					$author$project$Components$Produits$StructureCatalogue$Parcours$idDuTitre(1)),
					$author$project$Components$Produits$StructureCatalogue$Effet$TypologieChoisie(id)
				]));
	});
var $author$project$I18n$Textes$produitsStructureErreurRejeu = A3($author$project$I18n$Traductions$texte, 'produits.structure.erreur.rejeu', _List_Nil, 'Une modification précédente avait déjà été enregistrée : votre dernière modification n\'a pas été appliquée. Vérifiez la structure, puis recommencez.');
var $author$project$Components$Produits$StructureCatalogue$Update$rejeu = F2(
	function (commande, rendue) {
		return A2($author$project$Components$Produits$StructureCatalogue$Model$repondA, commande, rendue.mk) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			{Jx: $author$project$I18n$Textes$produitsStructureErreurRejeu, b9: $elm$core$Maybe$Nothing});
	});
var $author$project$Components$Produits$StructureCatalogue$Update$relectureRevenue = function (_v0) {
	var model = _v0.a;
	var effets = _v0.b;
	return (model.Hv > 1) ? _Utils_Tuple2(
		_Utils_update(
			model,
			{Hv: model.Hv - 1}),
		effets) : (A2($elm$core$List$member, $author$project$Components$Produits$StructureCatalogue$Effet$Reconnecter, effets) ? _Utils_Tuple2(
		_Utils_update(
			model,
			{mL: _List_Nil, Hv: 0}),
		effets) : $author$project$Components$Produits$StructureCatalogue$Update$rendreLeFocusAttendu(
		_Utils_Tuple2(
			_Utils_update(
				model,
				{Hv: 0}),
			effets)));
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$remettreATout = F2(
	function (rang, choix) {
		return A2($elm$core$List$take, rang, choix);
	});
var $author$project$Components$Produits$StructureCatalogue$Etats$Update$annonce = F2(
	function (code, etats) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Traductions$tel(''),
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var place = _v0.a;
					var etat = _v0.b;
					return $author$project$I18n$Textes$produitsStructureOrdreAnnonce(
						{
							Dj: $author$project$Components$Produits$StructureCatalogue$Etats$Model$libelleDeLEtat(etat),
							bY: $author$project$I18n$Traductions$tel(
								$elm$core$String$fromInt(place + 1)),
							JE: $author$project$I18n$Traductions$tel(
								$elm$core$String$fromInt(
									$elm$core$List$length(etats)))
						});
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$second,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.vx;
								},
								$elm$core$Basics$eq(code))),
						A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, etats)))));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$rendreLeFocus = function (_v0) {
	var model = _v0.a;
	var effets = _v0.b;
	var _v1 = _Utils_Tuple2(model.mS, model.h$);
	if ((!_v1.a.$) && (!_v1.b.$)) {
		var foyer = _v1.a.a;
		var structure = _v1.b.a;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					tl: function () {
						if (foyer.$ === 1) {
							var code = foyer.a;
							return A2($author$project$Components$Produits$StructureCatalogue$Etats$Update$annonce, code, structure.mj);
						} else {
							return $author$project$I18n$Traductions$tel('');
						}
					}(),
					mS: $elm$core$Maybe$Nothing
				}),
			A2($elm$core$List$member, $author$project$Components$Produits$StructureCatalogue$Effet$Reconnecter, effets) ? effets : _Utils_ap(
				effets,
				_List_fromArray(
					[
						$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(
						A2($author$project$Components$Produits$StructureCatalogue$Model$idDuFoyer, structure, foyer))
					])));
	} else {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{mS: $elm$core$Maybe$Nothing}),
			effets);
	}
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$RenommerUnEtage = F4(
	function (a, b, c, d) {
		return {$: 25, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$enregistres = function (etage) {
	var _v0 = etage.xt;
	if (_v0.$ === 1) {
		var libelles = _v0.a;
		return libelles;
	} else {
		return {yg: $elm$core$Maybe$Nothing, zX: ''};
	}
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$formesSaisiesDe = function (etage) {
	return $author$project$Components$Produits$StructureCatalogue$Etages$Model$formesSaisiesDes(etage.m$);
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$saisieDe = function (etage) {
	var _v0 = etage.xt;
	if (_v0.$ === 1) {
		var libelles = _v0.a;
		return $author$project$Components$Produits$StructureCatalogue$Saisie$affichee(
			{
				yg: A2($elm$core$Maybe$withDefault, '', libelles.yg),
				zX: libelles.zX
			});
	} else {
		return $author$project$Components$Produits$StructureCatalogue$Saisie$vide;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$modifiee = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (etage) {
				return (!_Utils_eq(
					model.D.R,
					$author$project$Components$Produits$StructureCatalogue$Etages$Model$saisieDe(etage).R)) || (!_Utils_eq(
					model.I,
					$author$project$Components$Produits$StructureCatalogue$Etages$Model$formesSaisiesDe(etage)));
			},
			$author$project$Components$Produits$StructureCatalogue$Etages$Update$aRenommer(model)));
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$versLeRenommage = F2(
	function (geste, model) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{
				Il: $author$project$Components$Produits$StructureCatalogue$Etages$Update$modifiee(model)
			},
			geste,
			model.bg);
		var drawer = _v0.a;
		var effets = _v0.b;
		var suivi = _Utils_update(
			model,
			{bg: drawer});
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? suivi : $author$project$Components$Produits$StructureCatalogue$Etages$Update$ferme(suivi),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$renommageDemande = function (model) {
	var _v0 = _Utils_Tuple2(
		$author$project$Components$Produits$StructureCatalogue$Etages$Update$reglee(model),
		$author$project$Components$Produits$StructureCatalogue$Etages$Update$aRenommer(model));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var _v1 = _v0.a.a;
		var typologie = _v1.b;
		var etage = _v0.b.a;
		var _v2 = _Utils_Tuple2(
			A2($author$project$Components$Produits$StructureCatalogue$Etages$Model$renommage, etage, model.D),
			$author$project$Components$Produits$StructureCatalogue$Etages$Update$enregistres(etage));
		switch (_v2.a.$) {
			case 1:
				var _v3 = _v2.a;
				return _Utils_Tuple2(
					$author$project$Components$Produits$StructureCatalogue$Etages$Update$tentee(model),
					_List_fromArray(
						[
							$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus($author$project$Components$Produits$StructureCatalogue$Etages$Model$idDuLibelleDuRenommage)
						]));
			case 2:
				var libelles = _v2.a.a;
				return A2(
					$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
					A4(
						$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$RenommerUnEtage,
						typologie.Aq,
						etage.Aq,
						libelles,
						A3($author$project$Components$Produits$StructureCatalogue$Etages$Model$formesAEnvoyer, etage, libelles, model.I)),
					$author$project$Components$Produits$StructureCatalogue$Etages$Update$sansRefus(model));
			default:
				var _v4 = _v2.a;
				var libelles = _v2.b;
				var _v5 = A3($author$project$Components$Produits$StructureCatalogue$Etages$Model$formesAEnvoyer, etage, libelles, model.I);
				if (!_v5.$) {
					var formes = _v5.a;
					return A2(
						$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
						A4(
							$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$RenommerUnEtage,
							typologie.Aq,
							etage.Aq,
							libelles,
							$elm$core$Maybe$Just(formes)),
						$author$project$Components$Produits$StructureCatalogue$Etages$Update$sansRefus(model));
				} else {
					return A2($author$project$Components$Produits$StructureCatalogue$Etages$Update$versLeRenommage, $author$project$Components$Shared$Drawer$Update$Fermer, model);
				}
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$prefixeDuRenommage = 'renommage-information-libelle';
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$idDuLibelleDuRenommage = A2($author$project$Components$Shared$LibellesParLangue$View$idDuChamp, $author$project$Components$Produits$StructureCatalogue$Informations$Model$prefixeDuRenommage, 'fr');
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$renommage = function (champ) {
	return A2(
		$author$project$Components$Produits$StructureCatalogue$Saisie$renommer,
		$elm$core$Maybe$Just(
			{
				yg: $author$project$Components$Produits$StructureCatalogue$Informations$Model$anglais(champ),
				zX: champ.Bl
			}),
		_Utils_Tuple2('', ''));
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$renomme = F2(
	function (libelles, champ) {
		var autres = A2(
			$elm$core$List$map,
			function (_v0) {
				var code = _v0.a;
				var texte = _v0.b;
				return (code === 'fr') ? _Utils_Tuple2(code, libelles.zX) : _Utils_Tuple2(code, texte);
			},
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$first,
					$elm$core$Basics$neq('en')),
				champ.R));
		return _Utils_update(
			champ,
			{
				Bl: libelles.zX,
				R: _Utils_ap(
					autres,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (en) {
								return _List_fromArray(
									[
										_Utils_Tuple2('en', en)
									]);
							},
							libelles.yg)))
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$renommageDemande = function (model) {
	var _v0 = $author$project$Components$Produits$StructureCatalogue$Informations$Update$visee(model);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var portee = _v1.a;
		var lue = _v1.b;
		var _v2 = A2($author$project$Components$Produits$StructureCatalogue$Informations$Model$renommage, lue.uN, model.aM);
		switch (_v2.$) {
			case 2:
				var libelles = _v2.a;
				return A2(
					$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
					A2(
						$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ModifierUneInformation,
						portee,
						A2($author$project$Components$Produits$StructureCatalogue$Informations$Model$renomme, libelles, lue.uN)),
					_Utils_update(
						model,
						{aL: $elm$core$Maybe$Nothing}));
			case 1:
				var saisie = model.aM;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aM: _Utils_update(
								saisie,
								{b5: true})
						}),
					_List_fromArray(
						[
							$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus($author$project$Components$Produits$StructureCatalogue$Informations$Model$idDuLibelleDuRenommage)
						]));
			default:
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$versLeRenommage, $author$project$Components$Shared$Drawer$Update$Fermer, model);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$RenommerUneNature = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Natures$Model$renommageDeLaNature = function (nature) {
	return A3(
		$author$project$Components$Produits$StructureCatalogue$Saisie$renommer,
		nature.R,
		_Utils_Tuple2(
			$author$project$Components$Produits$StructureCatalogue$Saisie$parDefaut(
				$author$project$Catalogue$Vocabulaire$nature(nature.vx)),
			$author$project$Components$Produits$StructureCatalogue$Saisie$parDefaut(
				$author$project$Catalogue$Vocabulaire$natureEnAnglais(nature.vx))),
		nature.hP);
};
var $author$project$Components$Produits$StructureCatalogue$Natures$Update$tentee = function (saisie) {
	return _Utils_update(
		saisie,
		{b5: true});
};
var $author$project$Components$Produits$StructureCatalogue$Natures$Update$renommageDemande = function (model) {
	var _v0 = A2(
		$elm$core$Maybe$map,
		function (nature) {
			return _Utils_Tuple2(
				nature.vx,
				$author$project$Components$Produits$StructureCatalogue$Natures$Model$renommageDeLaNature(nature));
		},
		$author$project$Components$Produits$StructureCatalogue$Natures$Update$aRenommer(model));
	if (!_v0.$) {
		switch (_v0.a.b.$) {
			case 2:
				var _v1 = _v0.a;
				var code = _v1.a;
				var libelles = _v1.b.a;
				return A2(
					$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
					A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$RenommerUneNature, code, libelles),
					_Utils_update(
						model,
						{aL: $elm$core$Maybe$Nothing}));
			case 1:
				var _v2 = _v0.a;
				var code = _v2.a;
				var _v3 = _v2.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Components$Produits$StructureCatalogue$Natures$Update$surLaNature,
						code,
						function (nature) {
							return _Utils_update(
								nature,
								{
									hP: $author$project$Components$Produits$StructureCatalogue$Natures$Update$tentee(nature.hP)
								});
						},
						model),
					_List_fromArray(
						[
							$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus($author$project$Components$Produits$StructureCatalogue$Natures$Model$idDuLibelleDuRenommage)
						]));
			default:
				var _v4 = _v0.a;
				var _v5 = _v4.b;
				return A2($author$project$Components$Produits$StructureCatalogue$Natures$Update$versLeRenommage, $author$project$Components$Shared$Drawer$Update$Fermer, model);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$RenommerUneClassification = F3(
	function (a, b, c) {
		return {$: 15, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$StructureCatalogue$Typologies$Update$formesAEnvoyer = F3(
	function (typologie, libelles, model) {
		return A3($author$project$Components$Produits$StructureCatalogue$Etages$Model$formesEcrites, typologie.m$, libelles, model.mQ);
	});
var $author$project$Components$Produits$StructureCatalogue$Typologies$Update$vautLaSaisie = F2(
	function (typologie, model) {
		return A2($author$project$Components$Produits$StructureCatalogue$Typologies$Model$renommage, typologie, model.qU);
	});
var $author$project$Components$Produits$StructureCatalogue$Typologies$Model$saisieDe = function (typologie) {
	return $author$project$Components$Produits$StructureCatalogue$Saisie$affichee(
		{
			yg: A2($elm$core$Maybe$withDefault, '', typologie.R.yg),
			zX: typologie.R.zX
		});
};
var $author$project$Components$Produits$StructureCatalogue$Typologies$Update$modifiee = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (typologie) {
				return (!_Utils_eq(
					model.qU.R,
					$author$project$Components$Produits$StructureCatalogue$Typologies$Model$saisieDe(typologie).R)) || (!_Utils_eq(
					model.mQ,
					$author$project$Components$Produits$StructureCatalogue$Etages$Model$formesSaisiesDes(typologie.m$)));
			},
			$author$project$Components$Produits$StructureCatalogue$Typologies$Update$aRenommer(model)));
};
var $author$project$Components$Produits$StructureCatalogue$Typologies$Update$versLeRenommage = F2(
	function (geste, model) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{
				Il: $author$project$Components$Produits$StructureCatalogue$Typologies$Update$modifiee(model)
			},
			geste,
			model.qo);
		var drawer = _v0.a;
		var effets = _v0.b;
		var suivi = _Utils_update(
			model,
			{qo: drawer});
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? suivi : $author$project$Components$Produits$StructureCatalogue$Typologies$Update$ferme(suivi),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Produits$StructureCatalogue$Typologies$Update$renommageDemande = function (model) {
	var _v0 = A2(
		$elm$core$Maybe$map,
		function (typologie) {
			return _Utils_Tuple2(
				typologie,
				A2($author$project$Components$Produits$StructureCatalogue$Typologies$Update$vautLaSaisie, typologie, model));
		},
		$author$project$Components$Produits$StructureCatalogue$Typologies$Update$aRenommer(model));
	if (!_v0.$) {
		switch (_v0.a.b.$) {
			case 2:
				var _v1 = _v0.a;
				var typologie = _v1.a;
				var libelles = _v1.b.a;
				return A2(
					$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
					A3(
						$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$RenommerUneClassification,
						typologie.Aq,
						libelles,
						A3($author$project$Components$Produits$StructureCatalogue$Typologies$Update$formesAEnvoyer, typologie, libelles, model)),
					$author$project$Components$Produits$StructureCatalogue$Typologies$Update$sansRefus(model));
			case 1:
				var _v2 = _v0.a;
				var _v3 = _v2.b;
				return _Utils_Tuple2(
					$author$project$Components$Produits$StructureCatalogue$Typologies$Update$tentee(model),
					_List_fromArray(
						[
							$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus($author$project$Components$Produits$StructureCatalogue$Typologies$Model$idDuLibelleDuRenommage)
						]));
			default:
				var _v4 = _v0.a;
				var typologie = _v4.a;
				var _v5 = _v4.b;
				var _v6 = A3($author$project$Components$Produits$StructureCatalogue$Typologies$Update$formesAEnvoyer, typologie, typologie.R, model);
				if (!_v6.$) {
					var formes = _v6.a;
					return A2(
						$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
						A3(
							$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$RenommerUneClassification,
							typologie.Aq,
							typologie.R,
							$elm$core$Maybe$Just(formes)),
						$author$project$Components$Produits$StructureCatalogue$Typologies$Update$sansRefus(model));
				} else {
					return A2($author$project$Components$Produits$StructureCatalogue$Typologies$Update$versLeRenommage, $author$project$Components$Shared$Drawer$Update$Fermer, model);
				}
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$idDuBoutonRenommer = function (id) {
	return 'etage-' + ($author$project$Catalogue$Identifiants$etageIdToString(id) + '-renommer');
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$renommable = function (etage) {
	return A2(
		$elm$core$Maybe$map,
		function (_v0) {
			return etage;
		},
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$renommerUnEtage, etage.nQ));
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$renommageOuvert = F2(
	function (id, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			$author$project$Components$Produits$StructureCatalogue$Etages$Update$renommable,
			A2($author$project$Components$Produits$StructureCatalogue$Etages$Update$etageDe, id, model));
		if (!_v0.$) {
			var etage = _v0.a;
			return A2(
				$author$project$Components$Produits$StructureCatalogue$Etages$Update$versLeRenommage,
				$author$project$Components$Shared$Drawer$Update$Ouvrir(
					$author$project$Components$Produits$StructureCatalogue$Etages$Model$idDuBoutonRenommer(id)),
				function (clos) {
					return _Utils_update(
						clos,
						{
							gr: $elm$core$Maybe$Just(id),
							I: $author$project$Components$Produits$StructureCatalogue$Etages$Model$formesSaisiesDe(etage),
							D: $author$project$Components$Produits$StructureCatalogue$Etages$Model$saisieDe(etage)
						});
				}(
					$author$project$Components$Produits$StructureCatalogue$Etages$Update$sansSaisie(model)));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Etats$Model$idDuBoutonRenommer = function (code) {
	return 'etat-' + ($author$project$Catalogue$Identifiants$etatCodeToString(code) + '-renommer');
};
var $author$project$Components$Produits$StructureCatalogue$Etats$Update$renommageOuvert = F2(
	function (code, model) {
		return ($author$project$Components$Produits$StructureCatalogue$Etats$Update$definissable(model) && (!_Utils_eq(
			A2($author$project$Components$Produits$StructureCatalogue$Etats$Update$etatDe, code, model),
			$elm$core$Maybe$Nothing))) ? A2(
			$author$project$Components$Produits$StructureCatalogue$Etats$Update$versLeRenommage,
			$author$project$Components$Shared$Drawer$Update$Ouvrir(
				$author$project$Components$Produits$StructureCatalogue$Etats$Model$idDuBoutonRenommer(code)),
			function (ferme) {
				return _Utils_update(
					ferme,
					{
						dT: $elm$core$Maybe$Just(code)
					});
			}(
				$author$project$Components$Produits$StructureCatalogue$Etats$Update$sansRenommage(model))) : _Utils_Tuple2(model, _List_Nil);
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$idDuRenommage = 'information-renommer';
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$lienDeModification = F2(
	function (portee, informations) {
		return A3(
			$author$project$Components$Produits$StructureCatalogue$Informations$Model$lienDuPorteur,
			portee,
			function () {
				if (portee.$ === 3) {
					return $author$project$API$NavLinksDictionary$faireEvoluerLeSchema;
				} else {
					return $author$project$API$NavLinksDictionary$modifierUneInformation;
				}
			}(),
			informations);
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$renommageOuvert = function (model) {
	var _v0 = $author$project$Components$Produits$StructureCatalogue$Informations$Update$visee(model);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var portee = _v1.a;
		var lue = _v1.b;
		return _Utils_eq(
			A2($author$project$Components$Produits$StructureCatalogue$Informations$Model$lienDeModification, portee, model.AM),
			$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A2(
			$author$project$Components$Produits$StructureCatalogue$Informations$Update$versLeRenommage,
			$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Produits$StructureCatalogue$Informations$Model$idDuRenommage),
			_Utils_update(
				model,
				{
					aL: $elm$core$Maybe$Nothing,
					aM: $author$project$Components$Produits$StructureCatalogue$Informations$Model$saisieDe(lue.uN)
				}));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Natures$Model$idDuBoutonRenommer = function (code) {
	return 'nature-' + (code + '-renommer');
};
var $author$project$Components$Produits$StructureCatalogue$Natures$Update$renommable = function (model) {
	return !_Utils_eq(
		$elm$core$Maybe$Nothing,
		A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$renommerUneNature)),
			model.h$));
};
var $author$project$Components$Produits$StructureCatalogue$Natures$Update$renommageOuvert = F2(
	function (code, model) {
		return ($author$project$Components$Produits$StructureCatalogue$Natures$Update$renommable(model) && (!_Utils_eq(
			A2($author$project$Components$Produits$StructureCatalogue$Natures$Update$natureDe, code, model),
			$elm$core$Maybe$Nothing))) ? A2(
			$author$project$Components$Produits$StructureCatalogue$Natures$Update$versLeRenommage,
			$author$project$Components$Shared$Drawer$Update$Ouvrir(
				$author$project$Components$Produits$StructureCatalogue$Natures$Model$idDuBoutonRenommer(code)),
			function (ferme) {
				return _Utils_update(
					ferme,
					{
						on: $elm$core$Maybe$Just(code)
					});
			}(
				$author$project$Components$Produits$StructureCatalogue$Natures$Update$sansRenommage(model))) : _Utils_Tuple2(model, _List_Nil);
	});
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Model$renommable = function (niveau) {
	return A2(
		$elm$core$List$any,
		function (rel) {
			return !_Utils_eq(
				A2($author$project$API$Liens$trouver, rel, niveau.nQ),
				$elm$core$Maybe$Nothing);
		},
		_List_fromArray(
			[$author$project$API$NavLinksDictionary$libellerUnNiveau, $author$project$API$NavLinksDictionary$retablirLeLibelleDUnNiveau]));
};
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Update$renommageOuvert = F2(
	function (id, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$renommable,
				A2($author$project$Components$Produits$StructureCatalogue$Niveaux$Update$niveauDe, id, model))) ? A2(
			$author$project$Components$Produits$StructureCatalogue$Niveaux$Update$versLeRenommage,
			$author$project$Components$Shared$Drawer$Update$Ouvrir(
				A2($author$project$Components$Produits$StructureCatalogue$Niveaux$Update$idDuRenommer, model, id)),
			function (ferme) {
				return _Utils_update(
					ferme,
					{
						iA: $elm$core$Maybe$Just(id),
						mP: A2(
							$elm$core$Maybe$withDefault,
							$author$project$Components$Produits$StructureCatalogue$Etages$Model$sansFormes,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.m$;
									},
									$author$project$Components$Produits$StructureCatalogue$Etages$Model$formesSaisiesDes),
								A2($author$project$Components$Produits$StructureCatalogue$Niveaux$Update$niveauDe, id, model)))
					});
			}(
				$author$project$Components$Produits$StructureCatalogue$Niveaux$Update$sansRenommage(model))) : _Utils_Tuple2(model, _List_Nil);
	});
var $author$project$Components$Produits$StructureCatalogue$Typologies$Model$idDuBoutonRenommer = function (id) {
	return 'typologie-' + ($author$project$Catalogue$Identifiants$classificationIdToString(id) + '-renommer');
};
var $author$project$Components$Produits$StructureCatalogue$Typologies$Update$renommable = function (typologie) {
	return A2(
		$elm$core$Maybe$map,
		function (_v0) {
			return 0;
		},
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$renommerUneClassification, typologie.nQ));
};
var $author$project$Components$Produits$StructureCatalogue$Typologies$Update$renommageOuvert = F2(
	function (id, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (typologie) {
				return A2(
					$elm$core$Maybe$map,
					function (_v1) {
						return typologie;
					},
					$author$project$Components$Produits$StructureCatalogue$Typologies$Update$renommable(typologie));
			},
			A2($author$project$Components$Produits$StructureCatalogue$Typologies$Update$typologieDe, id, model));
		if (!_v0.$) {
			var typologie = _v0.a;
			return A2(
				$author$project$Components$Produits$StructureCatalogue$Typologies$Update$versLeRenommage,
				$author$project$Components$Shared$Drawer$Update$Ouvrir(
					$author$project$Components$Produits$StructureCatalogue$Typologies$Model$idDuBoutonRenommer(id)),
				function (clos) {
					return _Utils_update(
						clos,
						{
							mQ: $author$project$Components$Produits$StructureCatalogue$Etages$Model$formesSaisiesDes(typologie.m$),
							qU: $author$project$Components$Produits$StructureCatalogue$Typologies$Model$saisieDe(typologie),
							r4: $elm$core$Maybe$Just(id)
						});
				}(
					$author$project$Components$Produits$StructureCatalogue$Typologies$Update$aucunDrawer(model)));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ReponseDeCommande = F3(
	function (evenements, liens, vuesAJour) {
		return {mk: evenements, nQ: liens, sy: vuesAJour};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ListeCreee = function (a) {
	return {$: 28, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ClassificationAjoutee = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ClassificationArchivee = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ClassificationReactivee = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ClassificationRenommee = F3(
	function (a, b, c) {
		return {$: 14, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ClassificationRetiree = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$EtageAjoute = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$EtageRenomme = F4(
	function (a, b, c, d) {
		return {$: 25, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$EtageRetire = F2(
	function (a, b) {
		return {$: 27, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$EtagesReordonnes = F2(
	function (a, b) {
		return {$: 26, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$NoeudsOrdonnes = F3(
	function (a, b, c) {
		return {$: 20, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$TypologieAjoutee = F3(
	function (a, b, c) {
		return {$: 13, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ValeurAjoutee = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ValeurArchivee = F2(
	function (a, b) {
		return {$: 22, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ValeurDeplacee = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ValeurReactivee = F2(
	function (a, b) {
		return {$: 23, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ValeurTraduite = F3(
	function (a, b, c) {
		return {$: 21, a: a, b: b, c: c};
	});
var $author$project$Catalogue$Formes$Formes = F2(
	function (fr, en) {
		return {yg: en, zX: fr};
	});
var $author$project$Catalogue$Formes$Forme = F3(
	function (pluriel, genre, elision) {
		return {av: elision, M: genre, bT: pluriel};
	});
var $author$project$Catalogue$Formes$Feminin = 1;
var $author$project$Catalogue$Formes$genreDecoder = function (code) {
	switch (code) {
		case 'masculin':
			return $elm$json$Json$Decode$succeed(0);
		case 'feminin':
			return $elm$json$Json$Decode$succeed(1);
		default:
			return $elm$json$Json$Decode$fail('genre');
	}
};
var $author$project$Catalogue$Formes$formeDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Catalogue$Formes$Forme,
	A2($elm$json$Json$Decode$field, 'pluriel', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$andThen,
		$author$project$Catalogue$Formes$genreDecoder,
		A2($elm$json$Json$Decode$field, 'genre', $elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'elision', $elm$json$Json$Decode$bool));
var $author$project$Catalogue$Formes$decoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Catalogue$Formes$Formes,
	A2($elm$json$Json$Decode$field, 'fr', $author$project$Catalogue$Formes$formeDecoder),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'en', $author$project$Catalogue$Formes$formeDecoder)));
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$designationDEtage = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'DeLaStructure',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$NiveauDesigne,
				A2($elm$json$Json$Decode$field, 'niveau', $author$project$Catalogue$Identifiants$niveauIdDecoder))),
			A2(
			$elm$json$Json$Decode$field,
			'Libre',
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$EtageNomme,
				A2($elm$json$Json$Decode$field, 'libelles', $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
				$elm$json$Json$Decode$maybe(
					A2($elm$json$Json$Decode$field, 'grammaire', $author$project$Catalogue$Formes$decoder))))
		]));
var $author$project$Catalogue$Identifiants$NoeudId = $elm$core$Basics$identity;
var $author$project$Catalogue$Identifiants$noeudIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$usageDeRangement = 'rangement';
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$deLaClassification = function () {
	var valeur = A2($elm$json$Json$Decode$field, 'valeur', $author$project$Catalogue$Identifiants$valeurIdDecoder);
	var parent = $elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'parent', $author$project$Catalogue$Identifiants$valeurIdDecoder));
	var libelles = A2($elm$json$Json$Decode$field, 'libelles', $author$project$Catalogue$API$QueryAPIModel$libellesDecoder);
	var grammaire = $elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'grammaire', $author$project$Catalogue$Formes$decoder));
	var etage = A2($elm$json$Json$Decode$field, 'etage', $author$project$Catalogue$Identifiants$etageIdDecoder);
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'ClassificationAjoutee',
				A4(
					$elm$json$Json$Decode$map3,
					F4(
						function (usage, lus, formes, id) {
							return _Utils_eq(
								usage,
								$elm$core$Maybe$Just($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$usageDeRangement)) ? A3($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$TypologieAjoutee, id, lus, formes) : A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ClassificationAjoutee, id, lus);
						}),
					$elm$json$Json$Decode$maybe(
						A2($elm$json$Json$Decode$field, 'usage', $elm$json$Json$Decode$string)),
					libelles,
					grammaire)),
				A2(
				$elm$json$Json$Decode$field,
				'ClassificationRenommee',
				A3(
					$elm$json$Json$Decode$map2,
					F3(
						function (lus, formes, id) {
							return A3($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ClassificationRenommee, id, lus, formes);
						}),
					libelles,
					grammaire)),
				A2(
				$elm$json$Json$Decode$field,
				'ClassificationRetiree',
				$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ClassificationRetiree)),
				A2(
				$elm$json$Json$Decode$field,
				'ClassificationArchivee',
				$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ClassificationArchivee)),
				A2(
				$elm$json$Json$Decode$field,
				'ClassificationReactivee',
				$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ClassificationReactivee)),
				A2(
				$elm$json$Json$Decode$field,
				'ValeurAjoutee',
				A4(
					$elm$json$Json$Decode$map3,
					F4(
						function (v, p, lus, id) {
							return A2(
								$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ValeurAjoutee,
								id,
								{R: lus, ey: p, fm: v});
						}),
					valeur,
					parent,
					libelles)),
				A2(
				$elm$json$Json$Decode$field,
				'ValeurDeplacee',
				A4(
					$elm$json$Json$Decode$map3,
					F4(
						function (v, p, rang, id) {
							return A2(
								$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ValeurDeplacee,
								id,
								{ey: p, bY: rang, fm: v});
						}),
					valeur,
					parent,
					A2($elm$json$Json$Decode$field, 'rang', $elm$json$Json$Decode$int))),
				A2(
				$elm$json$Json$Decode$field,
				'NoeudsOrdonnes',
				A3(
					$elm$json$Json$Decode$map2,
					F3(
						function (p, ordre, id) {
							return A3($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$NoeudsOrdonnes, id, p, ordre);
						}),
					$elm$json$Json$Decode$maybe(
						A2($elm$json$Json$Decode$field, 'parent', $author$project$Catalogue$Identifiants$noeudIdDecoder)),
					A2(
						$elm$json$Json$Decode$field,
						'ordre',
						$elm$json$Json$Decode$list($author$project$Catalogue$Identifiants$noeudIdDecoder)))),
				A2(
				$elm$json$Json$Decode$field,
				'ValeurTraduite',
				A3(
					$elm$json$Json$Decode$map2,
					F3(
						function (v, lus, id) {
							return A3($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ValeurTraduite, id, v, lus);
						}),
					valeur,
					libelles)),
				A2(
				$elm$json$Json$Decode$field,
				'ValeurArchivee',
				A2(
					$elm$json$Json$Decode$map,
					F2(
						function (v, id) {
							return A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ValeurArchivee, id, v);
						}),
					valeur)),
				A2(
				$elm$json$Json$Decode$field,
				'ValeurReactivee',
				A2(
					$elm$json$Json$Decode$map,
					F2(
						function (v, id) {
							return A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ValeurReactivee, id, v);
						}),
					valeur)),
				A2(
				$elm$json$Json$Decode$field,
				'EtageAjoute',
				A4(
					$elm$json$Json$Decode$map3,
					F4(
						function (e, d, rang, id) {
							return A2(
								$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$EtageAjoute,
								id,
								{xt: d, md: e, bY: rang});
						}),
					etage,
					A2($elm$json$Json$Decode$field, 'designation', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$designationDEtage),
					A2($elm$json$Json$Decode$field, 'rang', $elm$json$Json$Decode$int))),
				A2(
				$elm$json$Json$Decode$field,
				'EtageRenomme',
				A4(
					$elm$json$Json$Decode$map3,
					F4(
						function (e, lus, formes, id) {
							return A4($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$EtageRenomme, id, e, lus, formes);
						}),
					etage,
					libelles,
					grammaire)),
				A2(
				$elm$json$Json$Decode$field,
				'EtagesReordonnes',
				A2(
					$elm$json$Json$Decode$map,
					F2(
						function (ordre, id) {
							return A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$EtagesReordonnes, id, ordre);
						}),
					A2(
						$elm$json$Json$Decode$field,
						'ordre',
						$elm$json$Json$Decode$list($author$project$Catalogue$Identifiants$etageIdDecoder)))),
				A2(
				$elm$json$Json$Decode$field,
				'EtageRetire',
				A2(
					$elm$json$Json$Decode$map,
					F2(
						function (e, id) {
							return A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$EtageRetire, id, e);
						}),
					etage))
			]));
}();
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$EtatsDefinis = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$LibelleDuNiveauRetabli = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$NatureRenommee = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$NaturesOrdonnees = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$NiveauActive = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$NiveauAjoute = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$NiveauDesactive = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$NiveauLibelle = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$NiveauRetire = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$NiveauxOrdonnes = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$VerrouillageDefini = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$VerrouillageRetire = {$: 9};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$duNiveau = A2($elm$json$Json$Decode$field, 'niveau', $author$project$Catalogue$Identifiants$niveauIdDecoder);
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$EtatDefini = F2(
	function (code, libelles) {
		return {vx: code, R: libelles};
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$etatDefini = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'libelles',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'code',
		$author$project$Catalogue$Identifiants$etatCodeDecoder,
		$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$EtatDefini)));
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$evenement = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'NiveauActive',
			A2($elm$json$Json$Decode$map, $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$NiveauActive, $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$duNiveau)),
			A2(
			$elm$json$Json$Decode$field,
			'NiveauDesactive',
			A2($elm$json$Json$Decode$map, $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$NiveauDesactive, $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$duNiveau)),
			A2(
			$elm$json$Json$Decode$field,
			'NiveauLibelle',
			A4(
				$elm$json$Json$Decode$map3,
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$NiveauLibelle,
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$duNiveau,
				A2($elm$json$Json$Decode$field, 'libelles', $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
				$elm$json$Json$Decode$maybe(
					A2($elm$json$Json$Decode$field, 'grammaire', $author$project$Catalogue$Formes$decoder)))),
			A2(
			$elm$json$Json$Decode$field,
			'LibelleDuNiveauRetabli',
			A2($elm$json$Json$Decode$map, $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$LibelleDuNiveauRetabli, $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$duNiveau)),
			A2(
			$elm$json$Json$Decode$field,
			'NiveauxOrdonnes',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$NiveauxOrdonnes,
				A2(
					$elm$json$Json$Decode$field,
					'ordre',
					$elm$json$Json$Decode$list($author$project$Catalogue$Identifiants$niveauIdDecoder)))),
			A2(
			$elm$json$Json$Decode$field,
			'NiveauAjoute',
			A5(
				$elm$json$Json$Decode$map4,
				F4(
					function (id, archetype, libelles, rang) {
						return $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$NiveauAjoute(
							{fA: archetype, R: libelles, os: id, bY: rang});
					}),
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$duNiveau,
				A2($elm$json$Json$Decode$field, 'archetype', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'libelles', $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
				A2($elm$json$Json$Decode$field, 'rang', $elm$json$Json$Decode$int))),
			A2(
			$elm$json$Json$Decode$field,
			'NiveauRetire',
			A2($elm$json$Json$Decode$map, $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$NiveauRetire, $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$duNiveau)),
			A2(
			$elm$json$Json$Decode$field,
			'EtatsDefinis',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$EtatsDefinis,
				A2(
					$elm$json$Json$Decode$field,
					'etats',
					$elm$json$Json$Decode$list($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$etatDefini)))),
			A2(
			$elm$json$Json$Decode$field,
			'VerrouillageDefini',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$VerrouillageDefini,
				A2($elm$json$Json$Decode$field, 'etat', $author$project$Catalogue$Identifiants$etatCodeDecoder))),
			A2(
			$elm$json$Json$Decode$field,
			'VerrouillageRetire',
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$VerrouillageRetire)),
			A2(
			$elm$json$Json$Decode$field,
			'NaturesOrdonnees',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$NaturesOrdonnees,
				A2(
					$elm$json$Json$Decode$field,
					'ordre',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string)))),
			A2(
			$elm$json$Json$Decode$field,
			'NatureRenommee',
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$NatureRenommee,
				A2($elm$json$Json$Decode$field, 'nature', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'libelles', $author$project$Catalogue$API$QueryAPIModel$libellesDecoder))),
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$EvenementInconnu)
		]));
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$enveloppe = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Basics$apR,
			A2($elm$json$Json$Decode$field, 'aggregateUid', $author$project$Catalogue$Identifiants$classificationIdDecoder),
			A2($elm$json$Json$Decode$field, 'event', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$deLaClassification)),
			A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (id, _v0) {
					return $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ListeCreee(id);
				}),
			A2($elm$json$Json$Decode$field, 'aggregateUid', $elm$json$Json$Decode$string),
			A2(
				$elm$json$Json$Decode$field,
				'event',
				A2(
					$elm$json$Json$Decode$field,
					'EnsembleCree',
					$elm$json$Json$Decode$succeed(0)))),
			A2($elm$json$Json$Decode$field, 'event', $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$evenement)
		]));
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$reponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'vuesAJour',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'liens',
		A2(
			$elm$json$Json$Decode$map,
			function ($) {
				return $.h0;
			},
			$author$project$API$Liens$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'evenements',
			$elm$json$Json$Decode$list($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$enveloppe),
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ReponseDeCommande))));
var $author$project$Components$Produits$StructureCatalogue$Etats$Update$retabli = F2(
	function (code, model) {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Etats$Update$definir,
			$elm$core$List$map(
				function (etat) {
					return _Utils_eq(etat.vx, code) ? _Utils_update(
						etat,
						{R: $elm$core$Maybe$Nothing}) : etat;
				}),
			_Utils_update(
				model,
				{aL: $elm$core$Maybe$Nothing}));
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$RetablirLeLibelleDUnNiveau = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Update$retablissementDemande = F2(
	function (id, model) {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
			$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$RetablirLeLibelleDUnNiveau(id),
			$author$project$Components$Produits$StructureCatalogue$Niveaux$Update$sansRefus(model));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$retenirLeFocus = function (_v0) {
	var model = _v0.a;
	var effets = _v0.b;
	if (_Utils_eq(model.l2, $author$project$Components$Produits$StructureCatalogue$Model$SansProcessUid)) {
		var _v1 = A2(
			$elm$core$List$partition,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$Produits$StructureCatalogue$Update$cibleDuFocus,
				$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
			effets);
		var focus = _v1.a;
		var autres = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					mL: _Utils_ap(
						model.mL,
						A2($elm$core$List$filterMap, $author$project$Components$Produits$StructureCatalogue$Update$cibleDuFocus, focus))
				}),
			autres);
	} else {
		return _Utils_Tuple2(model, effets);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Etats$Update$retire = F2(
	function (code, model) {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Etats$Update$definir,
			function (etats) {
				return ($elm$core$List$length(etats) > 1) ? A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.vx;
						},
						$elm$core$Basics$neq(code)),
					etats) : etats;
			},
			model);
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$RetirerUnEtage = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$idDeLAjoutDuNiveau = function (id) {
	return 'etage-niveau-' + ($author$project$Catalogue$Identifiants$niveauIdToString(id) + '-ajouter');
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$RetraitDe = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$titreDuRetrait = F4(
	function (i18n, niveaux, id, etages) {
		return A2(
			$elm$core$Maybe$map,
			$author$project$Components$Produits$StructureCatalogue$Etages$Model$RetraitDe,
			A4($author$project$Components$Produits$StructureCatalogue$Etages$Model$etageNomme, i18n, niveaux, id, etages));
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$retirer = F3(
	function (i18n, id, model) {
		var _v0 = $author$project$Components$Produits$StructureCatalogue$Etages$Update$reglee(model);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var structure = _v1.a;
			var typologie = _v1.b;
			var cible = A2(
				$elm$core$Maybe$withDefault,
				$author$project$Components$Produits$StructureCatalogue$Etages$Model$idDeLOuverture(1),
				A2(
					$elm$core$Maybe$map,
					function (etage) {
						var _v3 = etage.xt;
						if (!_v3.$) {
							var niveau = _v3.b;
							return $author$project$Components$Produits$StructureCatalogue$Etages$Model$idDeLAjoutDuNiveau(niveau);
						} else {
							return $author$project$Components$Produits$StructureCatalogue$Etages$Model$idDeLOuverture(1);
						}
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(id)),
							typologie.yG))));
			var _v2 = A4($author$project$Components$Produits$StructureCatalogue$Etages$Model$titreDuRetrait, i18n, structure.C9, id, typologie.yG);
			if (!_v2.$) {
				var titre = _v2.a;
				return A4(
					$author$project$Components$Produits$StructureCatalogue$Etages$Update$demander,
					A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$RetirerUnEtage, typologie.Aq, id),
					titre,
					$elm$core$Maybe$Just(
						$author$project$Components$Produits$StructureCatalogue$Etages$Model$AuControle(
							A2($author$project$Components$Produits$StructureCatalogue$Etages$Update$auRangementSiOuvert, model, cible))),
					model);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$RetirerUneTypologie = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Typologies$Update$retraitDemande = function (model) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		function (id) {
			return A2($author$project$Components$Produits$StructureCatalogue$Typologies$Update$typologieDe, id, model);
		},
		model.r5);
	if (!_v0.$) {
		var typologie = _v0.a;
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
			$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$RetirerUneTypologie(typologie.Aq),
			$author$project$Components$Produits$StructureCatalogue$Typologies$Update$sansRefus(model));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Typologies$Model$idDuBoutonRetirer = function (id) {
	return 'typologie-' + ($author$project$Catalogue$Identifiants$classificationIdToString(id) + '-retirer');
};
var $author$project$Components$Produits$StructureCatalogue$Typologies$Update$retirable = function (typologie) {
	return A2(
		$elm$core$Maybe$map,
		function (_v0) {
			return 0;
		},
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerUneTypologie, typologie.nQ));
};
var $author$project$Components$Produits$StructureCatalogue$Typologies$Update$versLeRetrait = F2(
	function (geste, model) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{Il: false},
			geste,
			model.qM);
		var drawer = _v0.a;
		var effets = _v0.b;
		var suivi = _Utils_update(
			model,
			{qM: drawer});
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? suivi : $author$project$Components$Produits$StructureCatalogue$Typologies$Update$ferme(suivi),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Produits$StructureCatalogue$Typologies$Update$retraitOuvert = F2(
	function (id, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (typologie) {
				return A2(
					$elm$core$Maybe$map,
					function (_v1) {
						return typologie;
					},
					$author$project$Components$Produits$StructureCatalogue$Typologies$Update$retirable(typologie));
			},
			A2($author$project$Components$Produits$StructureCatalogue$Typologies$Update$typologieDe, id, model));
		if (!_v0.$) {
			return A2(
				$author$project$Components$Produits$StructureCatalogue$Typologies$Update$versLeRetrait,
				$author$project$Components$Shared$Drawer$Update$Ouvrir(
					$author$project$Components$Produits$StructureCatalogue$Typologies$Model$idDuBoutonRetirer(id)),
				function (clos) {
					return _Utils_update(
						clos,
						{
							r5: $elm$core$Maybe$Just(id)
						});
				}(
					$author$project$Components$Produits$StructureCatalogue$Typologies$Update$aucunDrawer(model)));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$aucunDrawer = A2(
	$elm$core$Basics$composeR,
	$author$project$Components$Produits$StructureCatalogue$Etages$Update$sansSaisie,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Components$Produits$StructureCatalogue$Etages$Update$sansRangement,
		function (model) {
			return _Utils_update(
				model,
				{q: $author$project$Components$Produits$StructureCatalogue$Etages$Model$SansReecriture});
		}));
var $author$project$Components$Produits$StructureCatalogue$Etats$Update$aucunDrawer = A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Etats$Update$sansRenommage, $author$project$Components$Produits$StructureCatalogue$Etats$Update$sansAjout);
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$aucunDrawer = function (model) {
	var fermer = function (drawer) {
		return A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{Il: false},
			$author$project$Components$Shared$Drawer$Update$Fermer,
			drawer).a;
	};
	return _Utils_update(
		model,
		{
			j9: $elm$core$Maybe$Nothing,
			cy: $elm$core$Maybe$Nothing,
			dK: fermer(model.dK),
			dL: fermer(model.dL),
			gc: fermer(model.gc),
			s: $elm$core$Maybe$Nothing,
			d5: $elm$core$Maybe$Nothing,
			ag: false,
			T: fermer(model.T),
			pO: fermer(model.pO),
			aL: $elm$core$Maybe$Nothing,
			c6: fermer(model.c6),
			bk: false
		});
};
var $author$project$Components$Produits$StructureCatalogue$Natures$Update$aucunDrawer = $author$project$Components$Produits$StructureCatalogue$Natures$Update$sansRenommage;
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Update$aucunDrawer = $author$project$Components$Produits$StructureCatalogue$Niveaux$Update$sansRenommage;
var $author$project$Components$Produits$StructureCatalogue$Gammes$Update$EtapeQuittee = {$: 9};
var $author$project$Components$Produits$StructureCatalogue$Marques$Update$EtapeQuittee = {$: 12};
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$EtapeQuittee = {$: 15};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$aucunDrawer = function (model) {
	return _Utils_update(
		model,
		{
			iy: $elm$core$Maybe$Nothing,
			k3: A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				$author$project$Components$Shared$Drawer$Update$Fermer,
				model.k3).a,
			le: A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				$author$project$Components$Shared$Drawer$Update$Fermer,
				model.le).a,
			oK: $elm$core$Maybe$Nothing,
			El: $elm$core$Maybe$Nothing,
			hA: $elm$core$Maybe$Nothing,
			p1: $elm$core$Maybe$Nothing,
			p9: $elm$core$Maybe$Nothing
		});
};
var $author$project$Components$Produits$StructureCatalogue$Update$marquesQuittees = F2(
	function (i18n, model) {
		return $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$aucunDrawer(
			_Utils_update(
				model,
				{
					gG: A2($author$project$Components$Produits$StructureCatalogue$Gammes$Update$update, $author$project$Components$Produits$StructureCatalogue$Gammes$Update$EtapeQuittee, model.gG).a,
					cU: A3($author$project$Components$Produits$StructureCatalogue$Marques$Update$update, i18n, $author$project$Components$Produits$StructureCatalogue$Marques$Update$EtapeQuittee, model.cU).a,
					aK: A2($author$project$Components$Produits$StructureCatalogue$Produits$Update$update, $author$project$Components$Produits$StructureCatalogue$Produits$Update$EtapeQuittee, model.aK).a
				}));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$sansAucunVolet = F2(
	function (i18n, model) {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Update$marquesQuittees,
			i18n,
			$author$project$Components$Produits$StructureCatalogue$Informations$Update$aucunDrawer(
				$author$project$Components$Produits$StructureCatalogue$Etages$Update$aucunDrawer(
					$author$project$Components$Produits$StructureCatalogue$Typologies$Update$aucunDrawer(
						$author$project$Components$Produits$StructureCatalogue$Natures$Update$aucunDrawer(
							$author$project$Components$Produits$StructureCatalogue$Etats$Update$aucunDrawer(
								$author$project$Components$Produits$StructureCatalogue$Classifications$Update$sansDrawer(
									$author$project$Components$Produits$StructureCatalogue$Niveaux$Update$aucunDrawer(model))))))));
	});
var $author$project$Components$Produits$StructureCatalogue$API$ToModel$avecSaSaisie = F3(
	function (identifiant, enSaisie, lue) {
		return A2(
			$elm$core$Maybe$withDefault,
			lue,
			A2(
				$elm$core$Maybe$map,
				function (modifiee) {
					return _Utils_update(
						lue,
						{hP: modifiee.hP});
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							identifiant,
							$elm$core$Basics$eq(
								identifiant(lue))),
						enSaisie))));
	});
var $author$project$Components$Produits$StructureCatalogue$API$ToModel$classification = function (servie) {
	return {tB: servie.tB, tD: servie.tD, wE: servie.wE, gi: servie.gi, yG: servie.yG, yI: servie.yI, yX: servie.yX, m$: servie.m$, Aq: servie.Aq, R: servie.R, nQ: servie.nQ, Di: servie.Di, hD: servie.hD, Ki: servie.Ki};
};
var $author$project$Components$Produits$StructureCatalogue$API$ToModel$etat = function (servi) {
	var lu = {vx: servi.vx, R: servi.R, o6: servi.o6, hP: $author$project$Components$Produits$StructureCatalogue$Saisie$vide, KA: servi.KA};
	return _Utils_update(
		lu,
		{
			hP: $author$project$Components$Produits$StructureCatalogue$Etats$Model$saisieDeLEtat(lu)
		});
};
var $author$project$Components$Produits$StructureCatalogue$Natures$Model$lue = function (servie) {
	var nature = {vx: servie.vx, R: servie.R, bY: servie.bY, hP: $author$project$Components$Produits$StructureCatalogue$Saisie$vide};
	return _Utils_update(
		nature,
		{
			hP: $author$project$Components$Produits$StructureCatalogue$Natures$Model$saisieDeLaNature(nature)
		});
};
var $author$project$Components$Produits$StructureCatalogue$API$ToModel$niveau = function (servi) {
	var lu = {fA: servi.fA, aV: servi.aV, m$: servi.m$, Aq: servi.Aq, R: servi.R, nQ: servi.nQ, o6: servi.o6, hP: $author$project$Components$Produits$StructureCatalogue$Saisie$vide, JH: servi.JH, Kg: servi.Kg};
	return _Utils_update(
		lu,
		{
			hP: $author$project$Components$Produits$StructureCatalogue$Niveaux$Model$saisieDuNiveau(lu)
		});
};
var $author$project$Components$Produits$StructureCatalogue$API$ToModel$structure = F2(
	function (precedente, servie) {
		var niveauxEnSaisie = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.C9;
					},
					$elm$core$List$filter($author$project$Components$Produits$StructureCatalogue$Niveaux$Model$modifie)),
				precedente));
		var etatsEnSaisie = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.mj;
					},
					$elm$core$List$filter($author$project$Components$Produits$StructureCatalogue$Etats$Model$etatModifie)),
				precedente));
		return {
			s5: servie.tC,
			vk: A2($elm$core$List$map, $author$project$Components$Produits$StructureCatalogue$API$ToModel$classification, servie.vk),
			mj: A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Produits$StructureCatalogue$API$ToModel$etat,
					A2(
						$author$project$Components$Produits$StructureCatalogue$API$ToModel$avecSaSaisie,
						function ($) {
							return $.vx;
						},
						etatsEnSaisie)),
				A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.bY;
					},
					servie.mj)),
			nQ: servie.nQ,
			oo: A2($elm$core$List$map, $author$project$Components$Produits$StructureCatalogue$Natures$Model$lue, servie.oo),
			C9: A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Produits$StructureCatalogue$API$ToModel$niveau,
					A2(
						$author$project$Components$Produits$StructureCatalogue$API$ToModel$avecSaSaisie,
						function ($) {
							return $.Aq;
						},
						niveauxEnSaisie)),
				A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.bY;
					},
					servie.C9)),
			Hf: servie.Hf,
			Kz: servie.Kz
		};
	});
var $author$project$Components$Produits$StructureCatalogue$API$QueryAPIModel$StructureServie = F8(
	function (niveaux, archetypesAjoutables, etats, verrouillageA, referencesVerrouillees, natures, classifications, liens) {
		return {tC: archetypesAjoutables, vk: classifications, mj: etats, nQ: liens, oo: natures, C9: niveaux, Hf: referencesVerrouillees, Kz: verrouillageA};
	});
var $author$project$Catalogue$API$QueryAPIModel$ClassificationServie = function (id) {
	return function (libelles) {
		return function (grammaire) {
			return function (enDouble) {
				return function (deRangement) {
					return function (valeurs) {
						return function (etages) {
							return function (etagesParDefaut) {
								return function (noeuds) {
									return function (arbreLegue) {
										return function (exclusions) {
											return function (archivage) {
												return function (references) {
													return function (liens) {
														return {tB: arbreLegue, tD: archivage, wE: deRangement, gi: enDouble, yG: etages, yI: etagesParDefaut, yX: exclusions, m$: grammaire, Aq: id, R: libelles, nQ: liens, Di: noeuds, hD: references, Ki: valeurs};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Catalogue$API$QueryAPIModel$ArchivageServi = F3(
	function (le, parNom, bilan) {
		return {uq: bilan, Bf: le, ET: parNom};
	});
var $author$project$Catalogue$API$QueryAPIModel$BilanDArchivage = F4(
	function (migrees, cloturees, aRanger, cible) {
		return {iz: aRanger, vf: cible, vr: cloturees, Cw: migrees};
	});
var $author$project$Catalogue$API$QueryAPIModel$CibleDArchivage = F2(
	function (id, libelles) {
		return {Aq: id, R: libelles};
	});
var $author$project$Catalogue$API$QueryAPIModel$cibleDArchivageDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'libelles',
	$author$project$Catalogue$API$QueryAPIModel$libellesDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Catalogue$API$QueryAPIModel$CibleDArchivage)));
var $author$project$Catalogue$API$QueryAPIModel$bilanDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'cible',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$cibleDArchivageDecoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'aRanger',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'cloturees',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'migrees',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Catalogue$API$QueryAPIModel$BilanDArchivage)))));
var $author$project$Catalogue$API$QueryAPIModel$archivageDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'bilan',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$bilanDecoder),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'parNom',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'le',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Catalogue$API$QueryAPIModel$ArchivageServi))));
var $author$project$Catalogue$API$QueryAPIModel$EtageServi = F6(
	function (id, designation, grammaire, rang, decide, liens) {
		return {wL: decide, xt: designation, m$: grammaire, Aq: id, nQ: liens, bY: rang};
	});
var $author$project$Catalogue$API$QueryAPIModel$designationLibre = 'libre';
var $author$project$Catalogue$API$QueryAPIModel$designationDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (code) {
		return _Utils_eq(code, $author$project$Catalogue$API$QueryAPIModel$designationLibre) ? A2(
			$elm$json$Json$Decode$map,
			$author$project$Catalogue$API$QueryAPIModel$Libre,
			A2($elm$json$Json$Decode$field, 'libelles', $author$project$Catalogue$API$QueryAPIModel$libellesDecoder)) : A2(
			$elm$json$Json$Decode$map,
			$author$project$Catalogue$API$QueryAPIModel$DuNiveau(code),
			A2($elm$json$Json$Decode$field, 'niveau', $author$project$Catalogue$Identifiants$niveauIdDecoder));
	},
	A2($elm$json$Json$Decode$field, 'designation', $elm$json$Json$Decode$string));
var $author$project$Catalogue$API$QueryAPIModel$etageDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'decide',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'rang',
			$elm$json$Json$Decode$int,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'grammaire',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Formes$decoder),
				$elm$core$Maybe$Nothing,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					$author$project$Catalogue$API$QueryAPIModel$designationDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$author$project$Catalogue$Identifiants$etageIdDecoder,
						$elm$json$Json$Decode$succeed($author$project$Catalogue$API$QueryAPIModel$EtageServi)))))));
var $author$project$Catalogue$API$QueryAPIModel$ExclusionServie = F5(
	function (portee, parent, etage, valeur, liens) {
		return {md: etage, nQ: liens, ey: parent, F$: portee, fm: valeur};
	});
var $author$project$Catalogue$API$QueryAPIModel$ValeurProduit = function (a) {
	return {$: 3, a: a};
};
var $author$project$Catalogue$API$QueryAPIModel$valeurDEtageDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'Libre',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Catalogue$API$QueryAPIModel$ValeurLibre,
				A2($elm$json$Json$Decode$field, 'valeur', $author$project$Catalogue$Identifiants$valeurIdDecoder))),
			A2(
			$elm$json$Json$Decode$field,
			'Element',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Catalogue$API$QueryAPIModel$ValeurElement,
				A2($elm$json$Json$Decode$field, 'element', $author$project$Catalogue$Identifiants$elementIdDecoder))),
			A2(
			$elm$json$Json$Decode$field,
			'Categorie',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Catalogue$API$QueryAPIModel$ValeurCategorie,
				A2($elm$json$Json$Decode$field, 'typeDeProduit', $author$project$Catalogue$Identifiants$typeDeProduitIdDecoder))),
			A2(
			$elm$json$Json$Decode$field,
			'Produit',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Catalogue$API$QueryAPIModel$ValeurProduit,
				A2($elm$json$Json$Decode$field, 'produit', $author$project$Catalogue$Identifiants$elementIdDecoder)))
		]));
var $author$project$Catalogue$API$QueryAPIModel$exclusionDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'valeur',
		$author$project$Catalogue$API$QueryAPIModel$valeurDEtageDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'etage',
			$author$project$Catalogue$Identifiants$etageIdDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'parent',
				$author$project$Catalogue$Identifiants$noeudIdDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'portee',
					$author$project$Catalogue$Identifiants$noeudIdDecoder,
					$elm$json$Json$Decode$succeed($author$project$Catalogue$API$QueryAPIModel$ExclusionServie))))));
var $author$project$Catalogue$API$QueryAPIModel$NoeudServi = F8(
	function (id, etage, valeur, parent, rang, aRanger, libelles, liens) {
		return {iz: aRanger, md: etage, Aq: id, R: libelles, nQ: liens, ey: parent, bY: rang, fm: valeur};
	});
var $author$project$Catalogue$API$QueryAPIModel$noeudDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'libelles',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'aRanger',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'rang',
				$elm$json$Json$Decode$int,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'parent',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Identifiants$noeudIdDecoder),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'valeur',
						$author$project$Catalogue$API$QueryAPIModel$valeurDEtageDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'etage',
							$author$project$Catalogue$Identifiants$etageIdDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$author$project$Catalogue$Identifiants$noeudIdDecoder,
								$elm$json$Json$Decode$succeed($author$project$Catalogue$API$QueryAPIModel$NoeudServi)))))))));
var $author$project$Catalogue$API$QueryAPIModel$ValeurServie = F6(
	function (id, parent, rang, libelles, archivee, liens) {
		return {tI: archivee, Aq: id, R: libelles, nQ: liens, ey: parent, bY: rang};
	});
var $author$project$Catalogue$API$QueryAPIModel$valeurDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'archivee',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'libelles',
			$author$project$Catalogue$API$QueryAPIModel$libellesDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'rang',
				$elm$json$Json$Decode$int,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'parent',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Identifiants$valeurIdDecoder),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$author$project$Catalogue$Identifiants$valeurIdDecoder,
						$elm$json$Json$Decode$succeed($author$project$Catalogue$API$QueryAPIModel$ValeurServie)))))));
var $author$project$Catalogue$API$QueryAPIModel$classificationDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'references',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'archivage',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$archivageDecoder),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'exclusions',
				$elm$json$Json$Decode$list($author$project$Catalogue$API$QueryAPIModel$exclusionDecoder),
				_List_Nil,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'arbreLegue',
					$elm$json$Json$Decode$bool,
					false,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'noeuds',
						$elm$json$Json$Decode$list($author$project$Catalogue$API$QueryAPIModel$noeudDecoder),
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'etagesParDefaut',
							$elm$json$Json$Decode$bool,
							false,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'etages',
								$elm$json$Json$Decode$list($author$project$Catalogue$API$QueryAPIModel$etageDecoder),
								_List_Nil,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'valeurs',
									$elm$json$Json$Decode$list($author$project$Catalogue$API$QueryAPIModel$valeurDecoder),
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'deRangement',
										$elm$json$Json$Decode$bool,
										false,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'enDouble',
											$elm$json$Json$Decode$bool,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'grammaire',
												A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Formes$decoder),
												$elm$core$Maybe$Nothing,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'libelles',
													$author$project$Catalogue$API$QueryAPIModel$libellesDecoder,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'id',
														$author$project$Catalogue$Identifiants$classificationIdDecoder,
														$elm$json$Json$Decode$succeed($author$project$Catalogue$API$QueryAPIModel$ClassificationServie)))))))))))))));
var $author$project$Components$Produits$StructureCatalogue$API$QueryAPIModel$EtatServi = F5(
	function (code, parDefaut, libelles, rang, verrouille) {
		return {vx: code, R: libelles, o6: parDefaut, bY: rang, KA: verrouille};
	});
var $author$project$Components$Produits$StructureCatalogue$API$QueryAPIModel$etatDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'verrouille',
	$elm$json$Json$Decode$bool,
	false,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'rang',
		$elm$json$Json$Decode$int,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'libelles',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'parDefaut',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'code',
					$author$project$Catalogue$Identifiants$etatCodeDecoder,
					$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$API$QueryAPIModel$EtatServi))))));
var $author$project$Components$Produits$StructureCatalogue$API$QueryAPIModel$NatureServie = F3(
	function (code, libelles, rang) {
		return {vx: code, R: libelles, bY: rang};
	});
var $author$project$Components$Produits$StructureCatalogue$API$QueryAPIModel$naturesDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$List$sortBy(
		function ($) {
			return $.bY;
		}),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$list(
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'rang',
					$elm$json$Json$Decode$int,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'libelles',
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'code',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$API$QueryAPIModel$NatureServie))))),
				A2(
				$elm$json$Json$Decode$map,
				$elm$core$List$indexedMap(
					F2(
						function (rang, code) {
							return {vx: code, R: $elm$core$Maybe$Nothing, bY: rang};
						})),
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string))
			])));
var $author$project$Components$Produits$StructureCatalogue$API$QueryAPIModel$NiveauServi = function (id) {
	return function (archetype) {
		return function (utilise) {
			return function (toujoursUtilise) {
				return function (parDefaut) {
					return function (libelles) {
						return function (grammaire) {
							return function (rang) {
								return function (elements) {
									return function (liens) {
										return {fA: archetype, aV: elements, m$: grammaire, Aq: id, R: libelles, nQ: liens, o6: parDefaut, bY: rang, JH: toujoursUtilise, Kg: utilise};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Produits$StructureCatalogue$API$QueryAPIModel$niveauDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'elements',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'rang',
			$elm$json$Json$Decode$int,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'grammaire',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Formes$decoder),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'libelles',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'parDefaut',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'toujoursUtilise',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'utilise',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'archetype',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$author$project$Catalogue$Identifiants$niveauIdDecoder,
										$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$API$QueryAPIModel$NiveauServi)))))))))));
var $author$project$Components$Produits$StructureCatalogue$API$QueryAPIModel$structureDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'classifications',
		$elm$json$Json$Decode$list($author$project$Catalogue$API$QueryAPIModel$classificationDecoder),
		_List_Nil,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'natures',
			$author$project$Components$Produits$StructureCatalogue$API$QueryAPIModel$naturesDecoder,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'referencesVerrouillees',
				$elm$json$Json$Decode$int,
				0,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'verrouillageA',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Identifiants$etatCodeDecoder),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'etats',
						$elm$json$Json$Decode$list($author$project$Components$Produits$StructureCatalogue$API$QueryAPIModel$etatDecoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'archetypesAjoutables',
							$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'niveaux',
								$elm$json$Json$Decode$list($author$project$Components$Produits$StructureCatalogue$API$QueryAPIModel$niveauDecoder),
								$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$API$QueryAPIModel$StructureServie)))))))));
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$classificationsDecoder = A2(
	$elm$json$Json$Decode$field,
	'classifications',
	$elm$json$Json$Decode$list($author$project$Catalogue$API$QueryAPIModel$classificationDecoder));
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$libelleDeLEtage = F2(
	function (catalogue, id) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Traductions$tel(
				$author$project$Catalogue$Identifiants$niveauIdToString(id)),
			A2(
				$elm$core$Maybe$map,
				$author$project$Catalogue$Niveau$libelleDuNiveau,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(id)),
						catalogue.C9))));
	});
var $author$project$Catalogue$Chemin$Chemin = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Catalogue$Chemin$depuis = F2(
	function (etages, noeuds) {
		return A3($author$project$Catalogue$Chemin$Chemin, etages, noeuds, _List_Nil);
	});
var $author$project$Catalogue$Identifiants$noeudIdToString = function (_v0) {
	var valeur = _v0;
	return valeur;
};
var $author$project$Catalogue$Typologies$typologieDe = F3(
	function (niveau, formesDuNiveau, classification) {
		var valeur = function (noeud) {
			var _v4 = noeud.fm;
			switch (_v4.$) {
				case 1:
					var id = _v4.a;
					return $elm$core$Maybe$Just(
						$author$project$Catalogue$API$WriteAPIModel$ElementDuDessus(id));
				case 0:
					var id = _v4.a;
					return $elm$core$Maybe$Just(
						$author$project$Catalogue$API$WriteAPIModel$LibreDuDessus(id));
				case 2:
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		};
		var nom = function (noeud) {
			var _v3 = noeud.fm;
			switch (_v3.$) {
				case 1:
					return A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.zX;
						},
						noeud.R);
				case 0:
					var id = _v3.a;
					return A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.R;
							},
							function ($) {
								return $.zX;
							}),
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.Aq;
									},
									$elm$core$Basics$eq(id)),
								classification.Ki)));
				case 2:
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		};
		var noeuds = A2(
			$elm$core$List$filterMap,
			function (noeud) {
				return A3(
					$elm$core$Maybe$map2,
					F2(
						function (v, n) {
							return {
								md: $author$project$Catalogue$Identifiants$etageIdToString(noeud.md),
								Aq: $author$project$Catalogue$Identifiants$noeudIdToString(noeud.Aq),
								Dj: n,
								ey: A2($elm$core$Maybe$map, $author$project$Catalogue$Identifiants$noeudIdToString, noeud.ey),
								fm: v
							};
						}),
					valeur(noeud),
					nom(noeud));
			},
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.iz;
					},
					$elm$core$Basics$not),
				classification.Di));
		var etages = A2(
			$elm$core$List$map,
			function (etage) {
				return {
					xt: function () {
						var _v0 = etage.xt;
						if (!_v0.$) {
							var id = _v0.b;
							return niveau(id);
						} else {
							var libelles = _v0.a;
							return $author$project$I18n$Traductions$tel(libelles.zX);
						}
					}(),
					dS: etage.wL,
					zS: function () {
						var _v1 = etage.xt;
						if (!_v1.$) {
							var id = _v1.b;
							return formesDuNiveau(id);
						} else {
							return etage.m$;
						}
					}(),
					Aq: $author$project$Catalogue$Identifiants$etageIdToString(etage.Aq),
					Bu: function () {
						var _v2 = etage.xt;
						if (!_v2.$) {
							return $elm$core$Maybe$Nothing;
						} else {
							var libelles = _v2.a;
							return $elm$core$Maybe$Just(libelles.zX);
						}
					}()
				};
			},
			A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.bY;
				},
				classification.yG));
		return {
			jK: A2($author$project$Catalogue$Chemin$depuis, etages, noeuds),
			Aq: classification.Aq,
			Dj: classification.R.zX
		};
	});
var $author$project$Catalogue$Typologies$typologiesDeAvecFormes = F3(
	function (niveau, formesDuNiveau, classifications) {
		return A2(
			$elm$core$List$map,
			A2($author$project$Catalogue$Typologies$typologieDe, niveau, formesDuNiveau),
			A2(
				$elm$core$List$filter,
				function ($) {
					return $.wE;
				},
				classifications));
	});
var $author$project$Catalogue$Typologies$typologiesDe = F2(
	function (niveau, classifications) {
		return A3(
			$author$project$Catalogue$Typologies$typologiesDeAvecFormes,
			niveau,
			function (_v0) {
				return $elm$core$Maybe$Nothing;
			},
			classifications);
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$structureDesFiltresLue = F2(
	function (reponse, model) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$classificationsDecoder, reponse),
			model.jB);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var classifications = _v0.a.a;
				var catalogue = _v0.b.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							r7: A2(
								$author$project$Catalogue$Typologies$typologiesDe,
								$author$project$Components$Produits$StructureCatalogue$Informations$Update$libelleDeLEtage(catalogue),
								classifications)
						}),
					_List_Nil);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			var refus = _v0.a.a;
			return _Utils_Tuple2(
				model,
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Produits$StructureCatalogue$Effet$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$suppressionAnnulee = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{bk: false}),
		_List_Nil);
};
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$SupprimerUneInformation = F2(
	function (a, b) {
		return {$: 40, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$suppressionConfirmee = function (model) {
	var _v0 = _Utils_Tuple2(
		model.bk,
		$author$project$Components$Produits$StructureCatalogue$Informations$Update$visee(model));
	if (_v0.a && (!_v0.b.$)) {
		var _v1 = _v0.b.a;
		var portee = _v1.a;
		var lue = _v1.b;
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
			A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$SupprimerUneInformation, portee, lue.uN.dy),
			_Utils_update(
				model,
				{ag: false, aL: $elm$core$Maybe$Nothing, bk: false}));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$relDeLaSuppression = function (portee) {
	if (portee.$ === 3) {
		return $author$project$API$NavLinksDictionary$supprimerUnChamp;
	} else {
		return $author$project$API$NavLinksDictionary$supprimerUneInformation;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$suppressionDemandee = function (model) {
	var _v0 = $author$project$Components$Produits$StructureCatalogue$Informations$Update$visee(model);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var portee = _v1.a;
		var lue = _v1.b;
		return _Utils_eq(
			A2(
				$author$project$API$Liens$trouver,
				$author$project$Components$Produits$StructureCatalogue$Informations$Model$relDeLaSuppression(portee),
				lue.nQ),
			$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : _Utils_Tuple2(
			_Utils_update(
				model,
				{ag: false, aL: $elm$core$Maybe$Nothing, bk: true}),
			_List_Nil);
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$surLOrdre = F2(
	function (modifier, model) {
		return _Utils_update(
			model,
			{
				El: A2($elm$core$Maybe$map, modifier, model.El)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$surLeRangement = F2(
	function (modifier, model) {
		return _Utils_update(
			model,
			{
				hA: A2($elm$core$Maybe$map, modifier, model.hA)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$termeDePerimetreSaisi = F2(
	function (terme, model) {
		var _v0 = model.fO;
		if (!_v0.$) {
			var choix = _v0.a;
			var suivant = _Utils_update(
				choix,
				{DX: choix.DX + 1, h3: terme});
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						fO: $elm$core$Maybe$Just(suivant)
					}),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Produits$StructureCatalogue$Effet$LireLesPerimetres(suivant.DX),
							$elm$core$List$singleton),
						A2(
							$elm$core$Maybe$andThen,
							$author$project$API$Liens$resoudre(
								_List_fromArray(
									[
										_Utils_Tuple2('recherche', terme)
									])),
							A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.hC;
								},
								model.cl)))));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$termeSaisi = F2(
	function (terme, model) {
		return $author$project$Components$Produits$StructureCatalogue$Informations$Update$chercherDesArticles(
			_Utils_Tuple2(
				A2(
					$author$project$Components$Produits$StructureCatalogue$Informations$Update$avecLeChoix,
					function (choix) {
						return _Utils_update(
							choix,
							{EE: 1, h3: terme});
					},
					model),
				_List_Nil));
	});
var $author$project$Components$Produits$StructureCatalogue$API$ArchivageAPIModel$Traitement = F5(
	function (traitees, restantes, vuesAJour, ignorees, bilan) {
		return {uq: bilan, Aw: ignorees, qD: restantes, JN: traitees, sy: vuesAJour};
	});
var $author$project$Components$Produits$StructureCatalogue$API$ArchivageAPIModel$Ignoree = F2(
	function (reference, refus) {
		return {Hc: reference, pZ: refus};
	});
var $author$project$Components$Produits$StructureCatalogue$API$ArchivageAPIModel$ignoreeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'refus',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		$author$project$Catalogue$Vocabulaire$champDeLaReference,
		$author$project$Catalogue$Identifiants$referenceIdDecoder,
		$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$API$ArchivageAPIModel$Ignoree)));
var $author$project$Components$Produits$StructureCatalogue$API$ArchivageAPIModel$traitementDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'bilan',
	$author$project$Catalogue$API$QueryAPIModel$bilanDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'ignorees',
		$elm$json$Json$Decode$list($author$project$Components$Produits$StructureCatalogue$API$ArchivageAPIModel$ignoreeDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'vuesAJour',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'restantes',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'traitees',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$API$ArchivageAPIModel$Traitement))))));
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$typeModifie = F2(
	function (type_, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					_: $elm$core$Maybe$Just(type_)
				}),
			_List_Nil);
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$TypeProposeParLeBack = F3(
	function (code, filtrable, recherchable) {
		return {vx: code, zG: filtrable, G1: recherchable};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$typesProposesDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Maybe$withDefault(_List_Nil),
	$elm$json$Json$Decode$maybe(
		A2(
			$elm$json$Json$Decode$field,
			'typesDeChamp',
			$elm$json$Json$Decode$list(
				A4(
					$elm$json$Json$Decode$map3,
					$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$TypeProposeParLeBack,
					A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'filtrable', $elm$json$Json$Decode$bool),
					A2($elm$json$Json$Decode$field, 'recherchable', $elm$json$Json$Decode$bool))))));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$UniteDeMesure = F4(
	function (code, symbole, grandeur, nom) {
		return {vx: code, m0: grandeur, Dj: nom, Jh: symbole};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$unitesDeMesureDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Maybe$withDefault(_List_Nil),
	$elm$json$Json$Decode$maybe(
		A2(
			$elm$json$Json$Decode$field,
			'unites',
			$elm$json$Json$Decode$list(
				A5(
					$elm$json$Json$Decode$map4,
					$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$UniteDeMesure,
					A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'symbole', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'grandeur', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string))))));
var $author$project$Components$Produits$StructureCatalogue$Informations$Update$valeursDeListeSaisies = F2(
	function (texte, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{df: texte}),
			_List_Nil);
	});
var $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$DefinirLeVerrouillage = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Etats$Update$verrouillageChoisi = F2(
	function (choix, model) {
		var _v0 = model.h$;
		if (!_v0.$) {
			var structure = _v0.a;
			var voulu = A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.vx;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.vx;
							},
							A2(
								$elm$core$Basics$composeR,
								$author$project$Catalogue$Identifiants$etatCodeToString,
								$elm$core$Basics$eq(choix))),
						structure.mj)));
			return (((choix !== '') && _Utils_eq(voulu, $elm$core$Maybe$Nothing)) || _Utils_eq(voulu, structure.Kz)) ? _Utils_Tuple2(model, _List_Nil) : A2(
				$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
				$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$DefinirLeVerrouillage(voulu),
				model);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Archivage$Update$versLArchivage = F2(
	function (geste, model) {
		var archivage = model.tD;
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{Il: archivage.a6.d8},
			geste,
			archivage.kX);
		var drawer = _v0.a;
		var effets = _v0.b;
		var suivi = _Utils_update(
			model,
			{
				tD: _Utils_update(
					archivage,
					{kX: drawer})
			});
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? suivi : $author$project$Components$Produits$StructureCatalogue$Archivage$Update$aucunDrawer(suivi),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$mettreAJour = F3(
	function (i18n, msg, model) {
		switch (msg.$) {
			case 0:
				var liens = msg.a;
				return A3($author$project$Components$Produits$StructureCatalogue$Update$ouvrir, i18n, liens, model.i_);
			case 1:
				var etape = msg.a;
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[
							$author$project$Components$Produits$StructureCatalogue$Effet$PlacerFocus(
							$author$project$Components$Produits$StructureCatalogue$Parcours$idDuTitre(etape))
						]));
			case 2:
				return A2(
					$author$project$Components$Produits$StructureCatalogue$Update$versLesCategories,
					$author$project$Components$Produits$StructureCatalogue$Categories$Update$EtapeQuittee,
					A2($author$project$Components$Produits$StructureCatalogue$Update$sansAucunVolet, i18n, model));
			case 3:
				var octets = msg.a;
				if ($author$project$Components$Parametrage$NouveauChamp$Model$ouvert(model.oP)) {
					return A2(
						$author$project$Components$Produits$StructureCatalogue$Informations$Update$surLeNouveauChamp,
						$author$project$Components$Parametrage$NouveauChamp$Update$ProcessUidRecu(octets),
						model);
				} else {
					var _v1 = _Utils_Tuple2(
						model.l2,
						$author$project$API$ProcessUid$depuisOctets(octets));
					if ((!_v1.a.$) && (!_v1.b.$)) {
						var _v2 = _v1.a;
						var processUid = _v1.b.a;
						return $author$project$Components$Produits$StructureCatalogue$Update$aleaRecu(
							_Utils_update(
								model,
								{
									l2: $author$project$Components$Produits$StructureCatalogue$Model$Pret(processUid)
								}));
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				}
			case 4:
				var reponse = msg.a;
				var _v3 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$StructureCatalogue$API$QueryAPIModel$structureDecoder, reponse);
				if (!_v3.$) {
					var servie = _v3.a;
					return A2(
						$author$project$Components$Produits$StructureCatalogue$Update$puis,
						$author$project$Components$Produits$StructureCatalogue$Update$ouvrirLArchivageDemande,
						A2(
							$author$project$Components$Produits$StructureCatalogue$Update$puis,
							$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$placementsAttendus,
							$author$project$Components$Produits$StructureCatalogue$Update$relectureRevenue(
								_Utils_Tuple2(
									_Utils_update(
										model,
										{
											h$: $elm$core$Maybe$Just(
												A2($author$project$Components$Produits$StructureCatalogue$API$ToModel$structure, model.h$, servie))
										}),
									_List_Nil))));
				} else {
					var refus = _v3.a;
					return $author$project$Components$Produits$StructureCatalogue$Update$relectureRevenue(
						_Utils_Tuple2(
							model,
							$author$project$Components$Produits$StructureCatalogue$Update$reconnexion(refus)));
				}
			case 5:
				var reponse = msg.a;
				var _v4 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$informationsDecoder, reponse);
				if (!_v4.$) {
					var servies = _v4.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								AM: $elm$core$Maybe$Just(
									A2($author$project$Components$Produits$StructureCatalogue$Update$avecLesCategories, model.AM, servies))
							}),
						_List_Nil);
				} else {
					var refus = _v4.a;
					return _Utils_Tuple2(
						model,
						$author$project$Components$Produits$StructureCatalogue$Update$reconnexion(refus));
				}
			case 6:
				var reponse = msg.a;
				var _v5 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Listes$API$QueryAPIModel$annuaireDecoder, reponse);
				if (!_v5.$) {
					var annuaire = _v5.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								nS: _Utils_ap(
									A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.eP;
											},
											$elm$core$Basics$eq($author$project$API$NavLinksDictionary$listes)),
										model.nS),
									annuaire.nQ.h0),
								BX: $elm$core$Maybe$Just(annuaire.n_)
							}),
						_List_Nil);
				} else {
					var refus = _v5.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{BX: $elm$core$Maybe$Nothing}),
						$author$project$Components$Produits$StructureCatalogue$Update$reconnexion(refus));
				}
			case 7:
				var reponse = msg.a;
				var _v6 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$categoriesDecoder, reponse);
				if (!_v6.$) {
					var porteurs = _v6.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								AM: A2(
									$elm$core$Maybe$map,
									function (lues) {
										return A3($elm$core$List$foldl, $author$project$Components$Produits$StructureCatalogue$Update$avecLaCategorie, lues, porteurs);
									},
									model.AM)
							}),
						_List_Nil);
				} else {
					var refus = _v6.a;
					return _Utils_Tuple2(
						model,
						$author$project$Components$Produits$StructureCatalogue$Update$reconnexion(refus));
				}
			case 8:
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						$author$project$Components$Produits$StructureCatalogue$Commandes$relire(model),
						$author$project$Components$Produits$StructureCatalogue$Commandes$relireLesInformations(model)));
			case 9:
				var niveau = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Niveaux$Update$reactiver, niveau, model);
			case 10:
				var niveau = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Niveaux$Update$desactiver, niveau, model);
			case 11:
				var langue = msg.a;
				var id = msg.b;
				var texte = msg.c;
				return A4($author$project$Components$Produits$StructureCatalogue$Niveaux$Update$libelleSaisi, langue, id, texte, model);
			case 12:
				var id = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Niveaux$Update$renommageOuvert, id, model);
			case 13:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Niveaux$Update$versLeRenommage, geste, model);
			case 14:
				return $author$project$Components$Produits$StructureCatalogue$Niveaux$Update$renommageDemande(model);
			case 15:
				var id = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Niveaux$Update$retablissementDemande, id, model);
			case 16:
				return _Utils_Tuple2(model, _List_Nil);
			case 17:
				var langue = msg.a;
				var code = msg.b;
				var texte = msg.c;
				return A4($author$project$Components$Produits$StructureCatalogue$Etats$Update$libelleSaisi, langue, code, texte, model);
			case 18:
				var code = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Etats$Update$renommageOuvert, code, model);
			case 19:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Etats$Update$versLeRenommage, geste, model);
			case 20:
				return $author$project$Components$Produits$StructureCatalogue$Etats$Update$renommageDemande(model);
			case 21:
				var code = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Etats$Update$retabli, code, model);
			case 22:
				var code = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Etats$Update$monte, code, model);
			case 23:
				var code = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Etats$Update$descendu, code, model);
			case 24:
				var code = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Etats$Update$retire, code, model);
			case 25:
				var choix = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Etats$Update$verrouillageChoisi, choix, model);
			case 26:
				var langue = msg.a;
				var code = msg.b;
				var texte = msg.c;
				return A4($author$project$Components$Produits$StructureCatalogue$Natures$Update$libelleSaisi, langue, code, texte, model);
			case 27:
				var code = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Natures$Update$renommageOuvert, code, model);
			case 28:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Natures$Update$versLeRenommage, geste, model);
			case 29:
				return $author$project$Components$Produits$StructureCatalogue$Natures$Update$renommageDemande(model);
			case 30:
				var code = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Natures$Update$monte, code, model);
			case 31:
				var code = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Natures$Update$descendue, code, model);
			case 32:
				return $author$project$Components$Produits$StructureCatalogue$Etats$Update$ajoutOuvert(model);
			case 33:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Etats$Update$versLAjout, geste, model);
			case 34:
				var langue = msg.a;
				var texte = msg.b;
				return A3($author$project$Components$Produits$StructureCatalogue$Etats$Update$nouvelLibelleSaisi, langue, texte, model);
			case 35:
				return $author$project$Components$Produits$StructureCatalogue$Etats$Update$nouvelDemande(model);
			case 36:
				return $author$project$Components$Produits$StructureCatalogue$Typologies$Update$ajoutOuvert(model);
			case 37:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Typologies$Update$versLAjout, geste, model);
			case 38:
				var langue = msg.a;
				var texte = msg.b;
				return A3($author$project$Components$Produits$StructureCatalogue$Typologies$Update$libelleSaisi, langue, texte, model);
			case 39:
				return $author$project$Components$Produits$StructureCatalogue$Typologies$Update$ajoutDemande(model);
			case 40:
				var id = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Typologies$Update$renommageOuvert, id, model);
			case 41:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Typologies$Update$versLeRenommage, geste, model);
			case 42:
				return $author$project$Components$Produits$StructureCatalogue$Typologies$Update$renommageDemande(model);
			case 43:
				var id = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Typologies$Update$retraitOuvert, id, model);
			case 44:
				var id = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Archivage$Update$ouvert, id, model);
			case 45:
				var id = msg.a;
				var filtre = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							i_: $elm$core$Maybe$Just(
								_Utils_Tuple2(
									id,
									$author$project$Components$Produits$StructureCatalogue$Archivage$Model$DuFiltre(filtre)))
						}),
					_List_Nil);
			case 46:
				var id = msg.a;
				var references = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							i_: $elm$core$Maybe$Just(
								_Utils_Tuple2(
									id,
									$author$project$Components$Produits$StructureCatalogue$Archivage$Model$DesReferences(references)))
						}),
					_List_Nil);
			case 47:
				return $author$project$Components$Produits$StructureCatalogue$Archivage$Update$porteeRetiree(model);
			case 48:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Archivage$Update$versLArchivage, geste, model);
			case 49:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Archivage$Update$versLaCorrespondance, geste, model);
			case 50:
				var texte = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Archivage$Update$cibleChoisie, texte, model);
			case 51:
				var portee = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Archivage$Update$porteeChoisie, portee, model);
			case 52:
				var id = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Archivage$Update$categorieBasculee, id, model);
			case 53:
				return $author$project$Components$Produits$StructureCatalogue$Archivage$Update$correspondanceOuverte(model);
			case 54:
				var source = msg.a;
				var rang = msg.b;
				return A3($author$project$Components$Produits$StructureCatalogue$Archivage$Update$correspondanceChoisie, source, rang, model);
			case 55:
				return $author$project$Components$Produits$StructureCatalogue$Archivage$Update$lancer(model);
			case 56:
				return $author$project$Components$Produits$StructureCatalogue$Archivage$Update$interrompre(model);
			case 57:
				return $author$project$Components$Produits$StructureCatalogue$Archivage$Update$archiverDemande(model);
			case 58:
				var reponse = msg.a;
				var _v7 = model.tD.r3;
				if (!_v7.$) {
					var id = _v7.a;
					return A2(
						$author$project$Components$Produits$StructureCatalogue$Archivage$Update$apercuRecu,
						A2(
							$elm$core$Result$mapError,
							function (refus) {
								return _Utils_Tuple2(
									refus.ri,
									A3(
										$author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$message,
										A2(
											$author$project$Components$Produits$StructureCatalogue$Update$contexteDe,
											$author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ArchiverUneTypologie(id),
											model),
										reponse,
										refus));
							},
							A2($author$project$API$Reponse$lire, $author$project$Components$Produits$StructureCatalogue$API$ArchivageAPIModel$apercuDecoder, reponse)),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 59:
				var id = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Typologies$Update$reactivationDemandee, id, model);
			case 60:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Typologies$Update$versLeRetrait, geste, model);
			case 61:
				return $author$project$Components$Produits$StructureCatalogue$Typologies$Update$retraitDemande(model);
			case 62:
				var id = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Etages$Update$regler, id, model);
			case 63:
				var niveau = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Etages$Update$niveauAjoute, niveau, model);
			case 64:
				var etage = msg.a;
				return A3($author$project$Components$Produits$StructureCatalogue$Etages$Update$retirer, i18n, etage, model);
			case 65:
				var etage = msg.a;
				return A4($author$project$Components$Produits$StructureCatalogue$Etages$Update$deplacer, i18n, 0, etage, model);
			case 66:
				var etage = msg.a;
				return A4($author$project$Components$Produits$StructureCatalogue$Etages$Update$deplacer, i18n, 1, etage, model);
			case 67:
				var proposition = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Etages$Update$ajoutOuvert, proposition, model);
			case 68:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Etages$Update$versLAjout, geste, model);
			case 69:
				var langue = msg.a;
				var texte = msg.b;
				return A3($author$project$Components$Produits$StructureCatalogue$Etages$Update$libelleSaisi, langue, texte, model);
			case 70:
				var langue = msg.a;
				var texte = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							mQ: A3($author$project$Components$Produits$StructureCatalogue$Etages$Model$plurielSaisi, langue, texte, model.mQ)
						}),
					_List_Nil);
			case 71:
				var langue = msg.a;
				var genre = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							mQ: A3($author$project$Components$Produits$StructureCatalogue$Etages$Model$genreChoisi, langue, genre, model.mQ)
						}),
					_List_Nil);
			case 72:
				var langue = msg.a;
				var elision = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							mQ: A3($author$project$Components$Produits$StructureCatalogue$Etages$Model$elisionBasculee, langue, elision, model.mQ)
						}),
					_List_Nil);
			case 73:
				var langue = msg.a;
				var texte = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							mP: A3($author$project$Components$Produits$StructureCatalogue$Etages$Model$plurielSaisi, langue, texte, model.mP)
						}),
					_List_Nil);
			case 74:
				var langue = msg.a;
				var genre = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							mP: A3($author$project$Components$Produits$StructureCatalogue$Etages$Model$genreChoisi, langue, genre, model.mP)
						}),
					_List_Nil);
			case 75:
				var langue = msg.a;
				var elision = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							mP: A3($author$project$Components$Produits$StructureCatalogue$Etages$Model$elisionBasculee, langue, elision, model.mP)
						}),
					_List_Nil);
			case 76:
				var langue = msg.a;
				var texte = msg.b;
				return A3($author$project$Components$Produits$StructureCatalogue$Etages$Update$plurielSaisi, langue, texte, model);
			case 77:
				var langue = msg.a;
				var genre = msg.b;
				return A3($author$project$Components$Produits$StructureCatalogue$Etages$Update$genreChoisi, langue, genre, model);
			case 78:
				var langue = msg.a;
				var elision = msg.b;
				return A3($author$project$Components$Produits$StructureCatalogue$Etages$Update$elisionBasculee, langue, elision, model);
			case 79:
				return $author$project$Components$Produits$StructureCatalogue$Etages$Update$ajoutDemande(model);
			case 80:
				var id = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Etages$Update$renommageOuvert, id, model);
			case 81:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Etages$Update$versLeRenommage, geste, model);
			case 82:
				return $author$project$Components$Produits$StructureCatalogue$Etages$Update$renommageDemande(model);
			case 83:
				return $author$project$Components$Produits$StructureCatalogue$Etages$Update$rangementOuvert(model);
			case 84:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Etages$Update$versLeRangement, geste, model);
			case 85:
				var etage = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cG: $elm$core$Maybe$Just(etage)
						}),
					_List_Nil);
			case 86:
				var cible = msg.a;
				return A3($author$project$Components$Produits$StructureCatalogue$Etages$Update$depose, i18n, cible, model);
			case 87:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cG: $elm$core$Maybe$Nothing}),
					_List_Nil);
			case 88:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Classifications$Update$update, geste, model);
			case 89:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Update$versLesCategories, geste, model);
			case 90:
				var geste = msg.a;
				return A3($author$project$Components$Produits$StructureCatalogue$Update$versLesMarques, i18n, geste, model);
			case 91:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Update$versLesGammes, geste, model);
			case 92:
				return _Utils_Tuple2(model, _List_Nil);
			case 93:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Update$versLesProduits, geste, model);
			case 94:
				var portee = msg.a;
				var cle = msg.b;
				return A3($author$project$Components$Produits$StructureCatalogue$Informations$Update$ouverte, portee, cle, model);
			case 97:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$versLInformation, geste, model);
			case 98:
				var portee = msg.a;
				var nom = msg.b;
				var kicker = msg.c;
				return A4($author$project$Components$Produits$StructureCatalogue$Informations$Update$etageOuvert, portee, nom, kicker, model);
			case 99:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$versLEtage, geste, model);
			case 100:
				var cle = msg.a;
				var article = msg.b;
				return A3($author$project$Components$Produits$StructureCatalogue$Informations$Update$articleDEtageRetire, cle, article, model);
			case 101:
				return $author$project$Components$Produits$StructureCatalogue$Informations$Update$etageEnregistre(model);
			case 102:
				var suivables = msg.a;
				var gabarits = msg.b;
				return A3($author$project$Components$Produits$StructureCatalogue$Informations$Update$liensDesArticlesRecus, suivables, gabarits, model);
			case 103:
				var cle = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$articlesDEtageDemandes, cle, model);
			case 104:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$versLeChoixDEtage, geste, model);
			case 105:
				return $author$project$Components$Produits$StructureCatalogue$Informations$Update$articlesDEtageAjoutes(model);
			case 106:
				var cle = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$choixDUnPerimetreDemande, cle, model);
			case 107:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$versLeChoixDePerimetre, geste, model);
			case 108:
				var terme = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$termeDePerimetreSaisi, terme, model);
			case 109:
				var numero = msg.a;
				var reponse = msg.b;
				return A3($author$project$Components$Produits$StructureCatalogue$Informations$Update$perimetresLus, numero, reponse, model);
			case 110:
				var id = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$perimetreSelectionne, id, model);
			case 111:
				return $author$project$Components$Produits$StructureCatalogue$Informations$Update$perimetreRetenu(model);
			case 112:
				var cle = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$perimetreDEtageRetire, cle, model);
			case 113:
				var cle = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$perimetrePoseRetire, cle, model);
			case 114:
				var terme = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$termeSaisi, terme, model);
			case 115:
				var page = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$pageDemandee, page, model);
			case 116:
				var id = msg.a;
				var voulue = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Produits$StructureCatalogue$Informations$Update$avecLeChoix,
						A2($author$project$Components$Produits$Common$ChoixDArticles$cocher, id, voulue),
						model),
					_List_Nil);
			case 117:
				var groupe = msg.a;
				var id = msg.b;
				return A3($author$project$Components$Produits$StructureCatalogue$Informations$Update$filtreBascule, groupe, id, model);
			case 118:
				var groupe = msg.a;
				var id = msg.b;
				return A3($author$project$Components$Produits$StructureCatalogue$Informations$Update$filtreChoisi, groupe, id, model);
			case 119:
				var numero = msg.a;
				var reponse = msg.b;
				return A3($author$project$Components$Produits$StructureCatalogue$Informations$Update$articlesTrouves, numero, reponse, model);
			case 120:
				var reponse = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$catalogueDesFiltresLu, reponse, model);
			case 121:
				var reponse = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$structureDesFiltresLue, reponse, model);
			case 95:
				var consultation = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$consultationOuverte, consultation, model);
			case 96:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$versLaConsultation, geste, model);
			case 122:
				var obligatoire = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$obligationBasculee, obligatoire, model);
			case 124:
				var type_ = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$typeModifie, type_, model);
			case 125:
				return $author$project$Components$Produits$StructureCatalogue$Informations$Update$enregistree(model);
			case 123:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$minimaSaisis, geste, model);
			case 126:
				return $author$project$Components$Produits$StructureCatalogue$Informations$Update$masquee(model);
			case 127:
				return $author$project$Components$Produits$StructureCatalogue$Informations$Update$reaffichee(model);
			case 128:
				return $author$project$Components$Produits$StructureCatalogue$Informations$Update$suppressionDemandee(model);
			case 129:
				return $author$project$Components$Produits$StructureCatalogue$Informations$Update$suppressionConfirmee(model);
			case 130:
				return $author$project$Components$Produits$StructureCatalogue$Informations$Update$suppressionAnnulee(model);
			case 131:
				var destination = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$destinationChoisie, destination, model);
			case 132:
				return $author$project$Components$Produits$StructureCatalogue$Informations$Update$deplacementDemande(model);
			case 133:
				var portee = msg.a;
				var cle = msg.b;
				return A3($author$project$Components$Produits$StructureCatalogue$Informations$Update$masqueeReaffichee, portee, cle, model);
			case 134:
				var cle = msg.a;
				var sens = msg.b;
				return A3($author$project$Components$Produits$StructureCatalogue$Informations$Update$deplacee, cle, sens, model);
			case 135:
				return $author$project$Components$Produits$StructureCatalogue$Informations$Update$renommageOuvert(model);
			case 136:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$versLeRenommage, geste, model);
			case 137:
				var langue = msg.a;
				var texte = msg.b;
				return A3($author$project$Components$Produits$StructureCatalogue$Informations$Update$libelleSaisi, langue, texte, model);
			case 138:
				return $author$project$Components$Produits$StructureCatalogue$Informations$Update$renommageDemande(model);
			case 139:
				var portee = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$rattachementOuvert, portee, model);
			case 140:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$versLeRattachement, geste, model);
			case 141:
				var texte = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$rechercheSaisie, texte, model);
			case 142:
				var forme = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$formeChoisie, forme, model);
			case 143:
				var id = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$champChoisi, id, model);
			case 144:
				return $author$project$Components$Produits$StructureCatalogue$Informations$Update$rattachementDemande(model);
			case 145:
				var reponse = msg.a;
				var _v8 = A2(
					$author$project$API$Reponse$lire,
					A4(
						$elm$json$Json$Decode$map3,
						F3(
							function (c, t, u) {
								return _Utils_Tuple3(c, t, u);
							}),
						$author$project$Components$Shared$Bibliotheque$Champ$bibliothequeDecoder,
						$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$typesProposesDecoder,
						$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$unitesDeMesureDecoder),
					reponse);
				if (!_v8.$) {
					var _v9 = _v8.a;
					var champs = _v9.a;
					var types = _v9.b;
					var unites = _v9.c;
					return $author$project$Components$Produits$StructureCatalogue$Informations$Update$nouveauChampPret(
						_Utils_update(
							model,
							{
								dq: $elm$core$Maybe$Just(champs),
								J_: types,
								sc: unites
							}));
				} else {
					var refus = _v8.a;
					return _Utils_Tuple2(
						model,
						$author$project$Components$Produits$StructureCatalogue$Update$reconnexion(refus));
				}
			case 146:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$surLeNouveauChamp, geste, model);
			case 147:
				var portee = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$ajoutOuvert, portee, model);
			case 148:
				return $author$project$Components$Produits$StructureCatalogue$Informations$Update$nouvelleListeOuverte(model);
			case 149:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$versLaNouvelleListe, geste, model);
			case 150:
				var langue = msg.a;
				var texte = msg.b;
				return A3($author$project$Components$Produits$StructureCatalogue$Informations$Update$libelleDeListeSaisi, langue, texte, model);
			case 151:
				var texte = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$valeursDeListeSaisies, texte, model);
			case 152:
				var liste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$listeExistanteChoisie, liste, model);
			case 153:
				return $author$project$Components$Produits$StructureCatalogue$Informations$Update$autreNomDeListeVoulu(model);
			case 154:
				return $author$project$Components$Produits$StructureCatalogue$Informations$Update$nouvelleListeDemandee(model);
			case 171:
				var gamme = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$surLeRangement,
						$author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$changerLaCase(gamme),
						model),
					_List_Nil);
			case 156:
				var rang = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jN: A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$remettreATout, rang, model.jN)
						}),
					_List_Nil);
			case 157:
				var id = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jN: _List_Nil,
							r6: $elm$core$Maybe$Just(id)
						}),
					_List_fromArray(
						[
							$author$project$Components$Produits$StructureCatalogue$Effet$TypologieChoisie(id)
						]));
			case 158:
				if (!msg.a.$) {
					var id = msg.a.a;
					return _Utils_eq(
						model.r6,
						$elm$core$Maybe$Just(id)) ? _Utils_Tuple2(model, _List_Nil) : _Utils_Tuple2(
						_Utils_update(
							model,
							{
								jN: _List_Nil,
								r6: $elm$core$Maybe$Just(id)
							}),
						_List_Nil);
				} else {
					var _v10 = msg.a;
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 155:
				var rang = msg.a;
				var valeur = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jN: A3($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$choisir, rang, valeur, model.jN)
						}),
					_List_Nil);
			case 159:
				var rang = msg.a;
				return A2(
					$author$project$Components$Produits$StructureCatalogue$Update$puis,
					$author$project$Components$Produits$StructureCatalogue$Update$ouvrirLeVolet,
					A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Update$rangementOuvert, rang, model));
			case 160:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Update$versLeDrawerDeRangement, geste, model);
			case 161:
				var valeur = msg.a;
				var cochee = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$surLeRangement,
						A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$cocher, valeur, cochee),
						model),
					_List_Nil);
			case 162:
				var cochee = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$surLeRangement,
						$author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$cocherLaLicence(cochee),
						model),
					_List_Nil);
			case 163:
				return A2($author$project$Components$Produits$StructureCatalogue$Update$rangementDemande, i18n, model);
			case 164:
				var rang = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Update$ordreOuvert, rang, model);
			case 165:
				var valeur = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$surLOrdre,
						$author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$monter(valeur),
						model),
					_List_Nil);
			case 166:
				var valeur = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$surLOrdre,
						$author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$descendre(valeur),
						model),
					_List_Nil);
			case 167:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Update$versLeDrawerDOrdre, geste, model);
			case 168:
				return A2($author$project$Components$Produits$StructureCatalogue$Update$ordreDemande, i18n, model);
			case 169:
				var portee = msg.a;
				var parent = msg.b;
				return A3($author$project$Components$Produits$StructureCatalogue$Valeurs$Update$readmissionDemandee, portee, parent, model);
			case 170:
				var rang = msg.a;
				return A2(
					$author$project$Components$Produits$StructureCatalogue$Update$ouvrirLAjout,
					i18n,
					A2(
						$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$ajoutDansLaColonne,
						rang,
						$author$project$Components$Shared$Drawer$Model$estOuvert(model.le) ? A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Update$versLeDrawerDeRangement, $author$project$Components$Shared$Drawer$Update$Fermer, model).a : model));
			case 172:
				var typologie = msg.a;
				var valeur = msg.b;
				return A2(
					$elm$core$Tuple$mapFirst,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$versLeDrawerDeRangement($author$project$Components$Shared$Drawer$Update$Fermer),
						$elm$core$Tuple$first),
					A2(
						$author$project$Components$Produits$StructureCatalogue$Commandes$envoyer,
						A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$ArchiverUneValeur, typologie, valeur),
						model));
			case 173:
				var reponse = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Etages$Update$apercuRecu, reponse, model);
			case 174:
				return $author$project$Components$Produits$StructureCatalogue$Etages$Update$confirmer(model);
			case 175:
				return $author$project$Components$Produits$StructureCatalogue$Etages$Update$annuler(model);
			default:
				var reponse = msg.a;
				var _v11 = model.l2;
				if (_v11.$ === 2) {
					if (_v11.b.$ === 19) {
						var processUid = _v11.a;
						var _v12 = _v11.b;
						var typologie = _v12.a;
						var choix = _v12.b;
						var _v13 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$StructureCatalogue$API$ArchivageAPIModel$traitementDecoder, reponse);
						if (!_v13.$) {
							var traitement = _v13.a;
							return A4($author$project$Components$Produits$StructureCatalogue$Archivage$Update$lotTraite, typologie, choix, traitement, model);
						} else {
							var refus = _v13.a;
							return ((refus.ri === 401) ? $elm$core$Basics$identity : $author$project$Components$Produits$StructureCatalogue$Update$puis(
								$author$project$Components$Produits$StructureCatalogue$Archivage$Update$refuse(
									A3(
										$author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$message,
										A2(
											$author$project$Components$Produits$StructureCatalogue$Update$contexteDe,
											A2($author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$TraiterLArchivage, typologie, choix),
											model),
										reponse,
										refus))))(
								A4($author$project$Components$Produits$StructureCatalogue$Update$refuser, processUid, reponse, refus, model));
						}
					} else {
						var processUid = _v11.a;
						var commande = _v11.b;
						return A2(
							$author$project$Components$Produits$StructureCatalogue$Update$attendreLaRelecture,
							commande,
							function () {
								var _v14 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$reponseDecoder, reponse);
								if (!_v14.$) {
									var rendue = _v14.a;
									return A4(
										$author$project$Components$Produits$StructureCatalogue$Informations$Update$conclure,
										commande,
										A2($author$project$Components$Produits$StructureCatalogue$Update$rejeu, commande, rendue),
										model,
										A3(
											$author$project$Components$Produits$StructureCatalogue$Informations$Update$listeCreee,
											commande,
											rendue,
											A4(
												$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$conclure,
												commande,
												A2($author$project$Components$Produits$StructureCatalogue$Update$rejeu, commande, rendue),
												model,
												A4(
													$author$project$Components$Produits$StructureCatalogue$Etages$Update$conclure,
													commande,
													A2($author$project$Components$Produits$StructureCatalogue$Update$rejeu, commande, rendue),
													model,
													A4(
														$author$project$Components$Produits$StructureCatalogue$Archivage$Update$conclure,
														commande,
														A2($author$project$Components$Produits$StructureCatalogue$Update$rejeu, commande, rendue),
														model,
														A4(
															$author$project$Components$Produits$StructureCatalogue$Typologies$Update$conclure,
															commande,
															A2($author$project$Components$Produits$StructureCatalogue$Update$rejeu, commande, rendue),
															model,
															A4(
																$author$project$Components$Produits$StructureCatalogue$Natures$Update$conclure,
																commande,
																A2($author$project$Components$Produits$StructureCatalogue$Update$rejeu, commande, rendue),
																model,
																A4(
																	$author$project$Components$Produits$StructureCatalogue$Etats$Update$conclure,
																	commande,
																	A2($author$project$Components$Produits$StructureCatalogue$Update$rejeu, commande, rendue),
																	model,
																	A4(
																		$author$project$Components$Produits$StructureCatalogue$Classifications$Update$conclure,
																		commande,
																		A2($author$project$Components$Produits$StructureCatalogue$Update$rejeu, commande, rendue),
																		model,
																		A4(
																			$author$project$Components$Produits$StructureCatalogue$Niveaux$Update$conclure,
																			commande,
																			A2($author$project$Components$Produits$StructureCatalogue$Update$rejeu, commande, rendue),
																			model,
																			$author$project$Components$Produits$StructureCatalogue$Update$rendreLeFocus(
																				A3($author$project$Components$Produits$StructureCatalogue$Update$aboutir, commande, rendue, model))))))))))));
								} else {
									var refus = _v14.a;
									return function () {
										if (refus.ri === 401) {
											return $elm$core$Basics$identity;
										} else {
											var message = $elm$core$Maybe$Just(
												A3(
													$author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$message,
													A2($author$project$Components$Produits$StructureCatalogue$Update$contexteDe, commande, model),
													reponse,
													refus));
											return A2(
												$elm$core$Basics$composeR,
												A3($author$project$Components$Produits$StructureCatalogue$Niveaux$Update$conclure, commande, message, model),
												A2(
													$elm$core$Basics$composeR,
													A3($author$project$Components$Produits$StructureCatalogue$Classifications$Update$conclure, commande, message, model),
													A2(
														$elm$core$Basics$composeR,
														A3($author$project$Components$Produits$StructureCatalogue$Etats$Update$conclure, commande, message, model),
														A2(
															$elm$core$Basics$composeR,
															A3($author$project$Components$Produits$StructureCatalogue$Natures$Update$conclure, commande, message, model),
															A2(
																$elm$core$Basics$composeR,
																A3($author$project$Components$Produits$StructureCatalogue$Typologies$Update$conclure, commande, message, model),
																A2(
																	$elm$core$Basics$composeR,
																	A3($author$project$Components$Produits$StructureCatalogue$Archivage$Update$conclure, commande, message, model),
																	A2(
																		$elm$core$Basics$composeR,
																		A3($author$project$Components$Produits$StructureCatalogue$Etages$Update$conclure, commande, message, model),
																		A2(
																			$elm$core$Basics$composeR,
																			A3($author$project$Components$Produits$StructureCatalogue$Valeurs$Update$conclure, commande, message, model),
																			A2(
																				$elm$core$Basics$composeR,
																				A3($author$project$Components$Produits$StructureCatalogue$Informations$Update$conclure, commande, message, model),
																				A2(
																					$elm$core$Basics$composeR,
																					A2(
																						$author$project$Components$Produits$StructureCatalogue$Informations$Update$issueDuRefus,
																						commande,
																						$author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$duRefus(reponse)),
																					A3(
																						$author$project$Components$Produits$StructureCatalogue$Etages$Update$perime,
																						commande,
																						_Utils_eq(
																							$author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$duRefus(reponse),
																							$author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$ApercuPerime),
																						model)))))))))));
										}
									}()(
										(A2($author$project$Components$Produits$StructureCatalogue$Update$dansUnDrawerDeSaisie, commande, model) ? $elm$core$Basics$identity : $author$project$Components$Produits$StructureCatalogue$Update$retenirLeFocus)(
											$author$project$Components$Produits$StructureCatalogue$Update$rendreLeFocus(
												A4(
													$author$project$Components$Produits$StructureCatalogue$Update$refuser,
													processUid,
													reponse,
													refus,
													$author$project$Components$Produits$StructureCatalogue$Classifications$Update$foyerDuGesteOuvert(model)))));
								}
							}());
					}
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Update$naturesAuxCategories = function (model) {
	var categories = model.dt;
	return _Utils_update(
		model,
		{
			dt: _Utils_update(
				categories,
				{
					oo: A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.oo;
								},
								$elm$core$List$map(
									function (nature) {
										return _Utils_Tuple2(
											nature.vx,
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.zX;
												},
												nature.R));
									})),
							model.h$))
				})
		});
};
var $author$project$Components$Produits$StructureCatalogue$Update$update = F3(
	function (i18n, msg, model) {
		return $author$project$Components$Produits$StructureCatalogue$Update$lireLesCategoriesChoisies(
			A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Components$Produits$StructureCatalogue$Update$naturesAuxCategories,
				A3($author$project$Components$Produits$StructureCatalogue$Update$mettreAJour, i18n, msg, model)));
	});
var $author$project$Main$Update$typologieDeLAdresse = F3(
	function (i18n, route, catalogue) {
		if (route.$ === 6) {
			var typologie = route.b;
			return $author$project$Components$Produits$StructureCatalogue$Model$envelopper(
				A3(
					$author$project$Components$Produits$StructureCatalogue$Update$update,
					i18n,
					$author$project$Components$Produits$StructureCatalogue$Update$TypologieAdressee(typologie),
					$author$project$Components$Produits$StructureCatalogue$Model$ouvrir(catalogue)).a);
		} else {
			return catalogue;
		}
	});
var $author$project$Main$Update$init = F2(
	function (flags, url) {
		var preferences = $author$project$Preferences$Model$fromFlags(flags);
		var _v0 = A2($author$project$Components$Socle$Theme$Update$init, flags, url);
		var theme = _v0.a;
		var effetsDuTheme = _v0.b;
		var _v1 = A2($author$project$Components$Socle$Session$Update$init, flags, url);
		var session = _v1.a;
		var effetsDeLaSession = _v1.b;
		var i18n = session.JL;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLaSession,
			_Utils_Tuple2(
				{
					sN: $author$project$Components$Accueil$Model$init,
					ta: $author$project$Main$Update$aleaDeLaSession(effetsDeLaSession),
					tb: $author$project$Components$Produits$Alertes$Model$init,
					tc: $author$project$Components$Referentiel$Alertes$Model$init,
					dq: $author$project$Components$Parametrage$BibliothequeDeChamps$Model$envelopper($author$project$Components$Parametrage$BibliothequeDeChamps$Model$init),
					jB: $author$project$Components$Produits$Catalogue$Model$envelopper(
						$author$project$Components$Produits$Catalogue$Model$init(preferences)),
					vF: $author$project$Components$Parametrage$CollectionsDeChamps$Model$init,
					vX: $author$project$Components$Parametrage$CompteDEnvoi$Model$init,
					v$: $author$project$Components$Parametrage$CompteurDeCode$Model$init,
					v5: $author$project$Components$Parametrage$Conservation$Model$init,
					wh: $author$project$Components$Produits$Correspondances$Model$envelopper($author$project$Components$Produits$Correspondances$Model$init),
					xa: $author$project$Components$Demonstration$Model$init(preferences),
					xM: $author$project$Components$Referentiel$Doublons$Model$envelopper($author$project$Components$Referentiel$Doublons$Model$init),
					xS: $author$project$Components$Parametrage$Droits$Model$envelopper($author$project$Components$Parametrage$Droits$Model$init),
					zo: $author$project$Components$Referentiel$Fiche$Model$envelopper($author$project$Components$Referentiel$Fiche$Model$init),
					zr: $author$project$Components$Produits$FicheElement$Model$envelopper($author$project$Components$Produits$FicheElement$Model$init),
					zs: $author$project$Components$Produits$FicheType$Model$envelopper($author$project$Components$Produits$FicheType$Model$init),
					zS: $author$project$Components$Referentiel$Formes$Model$init,
					z$: $author$project$Components$Referentiel$Fusion$Model$init,
					m2: $author$project$Components$Referentiel$Groupe$Model$envelopper($author$project$Components$Referentiel$Groupe$Model$init),
					Ac: $author$project$Components$Referentiel$Groupes$Model$init,
					AC: $author$project$Components$Imports$Outil$Model$envelopper($author$project$Components$Imports$Outil$Model$init),
					Bb: $author$project$Components$Parametrage$LanguesDuClient$Model$init,
					nY: $author$project$Components$Produits$ListeDePrix$Model$envelopper($author$project$Components$Produits$ListeDePrix$Model$init),
					n_: $author$project$Components$Produits$Listes$Model$envelopper($author$project$Components$Produits$Listes$Model$init),
					BW: $author$project$Components$Produits$ListesDePrix$Model$init(preferences),
					B7: $author$project$Components$Produits$MarquesEtGammes$Model$envelopper(
						$author$project$Components$Produits$MarquesEtGammes$Model$init(preferences)),
					Ct: _List_Nil,
					CL: $author$project$Components$Parametrage$ModelesDeTache$Model$init,
					CT: $author$project$Components$Comptes$MonCompte$Model$init,
					C5: $author$project$Components$Shared$Navigation$Model$init(preferences.Cr),
					hd: $author$project$Referentiel$Normes$vide,
					DP: false,
					oN: $author$project$Components$Notifications$Model$init,
					oU: $author$project$Components$Referentiel$NouvelleFiche$Model$envelopper($author$project$Components$Referentiel$NouvelleFiche$Model$initial),
					D1: $author$project$Components$Produits$Offre$Model$envelopper($author$project$Components$Produits$Offre$Model$init),
					D3: $author$project$Components$Produits$Offres$Model$envelopper(
						$author$project$Components$Produits$Offres$Model$init(preferences)),
					Ee: _Utils_eq(
						$author$project$Routes$Route$fromUrl(url),
						$author$project$Routes$Route$Alertes),
					eA: $author$project$Components$Referentiel$PartiesPrenantes$Model$envelopper(
						$author$project$Components$Referentiel$PartiesPrenantes$Model$init(preferences)),
					pg: $author$project$Components$Produits$Perimetres$Model$envelopper($author$project$Components$Produits$Perimetres$Model$init),
					Fx: A2($author$project$Components$Parametrage$PipeDestinations$Model$init, '', ''),
					Fy: $author$project$Components$Parametrage$PipeEtape1$Model$envelopper(
						$author$project$Components$Parametrage$PipeEtape1$Model$init('')),
					Fz: $author$project$Components$Parametrage$PipeEtape2$Model$envelopper(
						$author$project$Components$Parametrage$PipeEtape2$Model$init('')),
					FA: $author$project$Components$Parametrage$PipeEtape3$Model$envelopper(
						$author$project$Components$Parametrage$PipeEtape3$Model$init('')),
					FB: $author$project$Components$Parametrage$PipeEtape4$Model$envelopper(
						$author$project$Components$Parametrage$PipeEtape4$Model$init('')),
					FC: $author$project$Components$Parametrage$PipeEtape5$Model$envelopper(
						$author$project$Components$Parametrage$PipeEtape5$Model$init('')),
					FD: $author$project$Components$Parametrage$PipeEtape6$Model$envelopper(
						$author$project$Components$Parametrage$PipeEtape6$Model$init('')),
					FE: $author$project$Components$Parametrage$PipeEtape7$Model$envelopper(
						$author$project$Components$Parametrage$PipeEtape7$Model$init('')),
					FF: $author$project$Components$Parametrage$PipeEtape8$Model$init(''),
					FG: $author$project$Components$Parametrage$PipeOffreUsage$Model$init(''),
					FJ: $author$project$Components$Parametrage$PipeRelationsExigees$Model$init(''),
					FL: $author$project$Components$Parametrage$PipeVersions$Model$init(''),
					FM: $author$project$Components$Parametrage$Pipes$Model$init,
					F6: $author$project$Components$Referentiel$Postes$Model$init,
					eF: preferences,
					Hc: $author$project$Components$Produits$Reference$Model$envelopper($author$project$Components$Produits$Reference$Model$init),
					Ih: $author$project$Routes$Route$fromUrl(url),
					Ir: $author$project$Components$Produits$SchemaDeNiveau$Model$envelopper($author$project$Components$Produits$SchemaDeNiveau$Model$init),
					q1: $author$project$Components$Comptes$Securite$Model$init,
					e1: session,
					I3: A3(
						$author$project$Main$Update$typologieDeLAdresse,
						i18n,
						$author$project$Routes$Route$fromUrl(url),
						$author$project$Components$Produits$StructureCatalogue$Model$envelopper($author$project$Components$Produits$StructureCatalogue$Model$initial)),
					JA: theme,
					JT: $author$project$Components$Referentiel$Type$Model$envelopper($author$project$Components$Referentiel$Type$Model$init),
					J0: $author$project$Components$Referentiel$Types$Model$envelopper($author$project$Components$Referentiel$Types$Model$init),
					J1: $author$project$Components$Produits$TypesDeQuantite$Model$envelopper($author$project$Components$Produits$TypesDeQuantite$Model$init),
					J2: $author$project$Components$Referentiel$TypesDeRelation$Model$init,
					Kf: $author$project$Components$Parametrage$Utilisateurs$Model$envelopper($author$project$Components$Parametrage$Utilisateurs$Model$init),
					sq: $author$project$Components$Shared$Version$Model$fromFlags(flags)
				},
				A2($elm$core$List$map, $author$project$Main$Update$depuisLeTheme, effetsDuTheme)),
			effetsDeLaSession);
	});
var $author$project$Main$codeDeLaLangue = function (model) {
	var _v0 = $author$project$I18n$Traductions$langue(model.e1.JL);
	if (!_v0) {
		return 'fr';
	} else {
		return 'en';
	}
};
var $author$project$Ports$poserLangue = _Platform_outgoingPort('poserLangue', $elm$json$Json$Encode$string);
var $author$project$Main$suivreLaLangue = F2(
	function (avant, _v0) {
		var _v1 = _v0.a;
		var key = _v1.a;
		var apres = _v1.b;
		var commandes = _v0.b;
		return _Utils_eq(
			$author$project$I18n$Traductions$langue(avant.e1.JL),
			$author$project$I18n$Traductions$langue(apres.e1.JL)) ? _Utils_Tuple2(
			_Utils_Tuple2(key, apres),
			commandes) : _Utils_Tuple2(
			_Utils_Tuple2(key, apres),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						commandes,
						$author$project$Ports$poserLangue(
						$author$project$Main$codeDeLaLangue(apres))
					])));
	});
var $author$project$Components$Socle$Session$Update$AleaRecu = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$Update$AllerA = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$Update$LireLesOctetsDuFichier = function (a) {
	return {$: 153, a: a};
};
var $author$project$Components$Socle$Session$Update$PageChangee = function (a) {
	return {$: 8, a: a};
};
var $author$project$Main$Update$PlacerFocus = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$ProcessUidDeGroupeRecu = function (a) {
	return {$: 32, a: a};
};
var $author$project$Components$Comptes$MonCompte$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Comptes$Securite$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Imports$Outil$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Notifications$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$CompteDEnvoi$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$CompteurDeCode$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$Conservation$Update$ProcessUidRecu = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$Droits$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$LanguesDuClient$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$ModelesDeTache$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$PipeEtape2$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$PipeEtape3$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$PipeEtape6$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$PipeEtape7$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$PipeEtape8$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$PipeVersions$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Update$ProcessUidRecu = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Produits$Catalogue$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$Correspondances$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$FicheElement$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$FicheType$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$ListeDePrix$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$Listes$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$ListesDePrix$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$MarquesEtGammes$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$Offre$Update$ProcessUidRecu = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$Offres$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$Perimetres$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$Reference$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$SchemaDeNiveau$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Gammes$Update$ProcessUidRecu = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Marques$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$ProcessUidRecu = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$ProcessUidRecu = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$TypesDeQuantite$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Doublons$Update$ProcessUidRecu = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$ProcessUidRecu = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Referentiel$Formes$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Fusion$Update$ProcessUidRecu = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Referentiel$Groupe$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Groupes$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$ProcessUidRecu = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$ProcessUidRecu = function (a) {
	return {$: 29, a: a};
};
var $author$project$Components$Referentiel$Postes$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Type$Update$ProcessUidRecu = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Referentiel$Types$Update$ProcessUidRecu = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Referentiel$TypesDeRelation$Update$ProcessUidRecu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$Update$arriveeSurLesAlertes = F2(
	function (avant, apres) {
		return _Utils_eq(apres, $author$project$Routes$Route$Alertes) && ((!_Utils_eq(avant, $author$project$Routes$Route$Alertes)) && (!_Utils_eq(avant, $author$project$Routes$Route$AlertesDePartiesPrenantes)));
	});
var $author$project$Components$Parametrage$Droits$Update$EtapeAffichee = function (a) {
	return {$: 28, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$EtapeAffichee = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Formes$Update$Ouverte = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$Postes$Update$Ouverte = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$TypesDeRelation$Update$Ouverte = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$Conservation$Update$OuverteSurLesRegles = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$Update$AttendreAvantDeRelireLesFormes = function (a) {
	return {$: 278, a: a};
};
var $author$project$Main$Update$EnvoyerAuxFormes = function (a) {
	return {$: 277, a: a};
};
var $author$project$Components$Socle$Session$Update$JetonEchu = {$: 10};
var $author$project$Main$Update$LireLesFormes = function (a) {
	return {$: 276, a: a};
};
var $author$project$Main$Model$PourLesFormes = 54;
var $author$project$Components$Socle$Session$Model$LienHorsDeLApi = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Socle$Session$Model$origineDeLApi = function (configuration) {
	return A2(
		$elm$core$Maybe$map,
		function (url) {
			return _Utils_ap(
				(url.Gy === 1) ? 'https://' : 'http://',
				_Utils_ap(
					url.d2,
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function (port_) {
								return ':' + $elm$core$String$fromInt(port_);
							},
							url.FX))));
		},
		$elm$url$Url$fromString(configuration.fz));
};
var $author$project$Components$Socle$Session$Model$sansOrigine = function (href) {
	return A2($elm$core$String$startsWith, '/', href) && ((!A2($elm$core$String$startsWith, '//', href)) && (!A2($elm$core$String$contains, '\\', href)));
};
var $author$project$Components$Socle$Session$Model$adresseSurLApi = F2(
	function (configuration, href) {
		return A2(
			$elm$core$Maybe$andThen,
			function (origine) {
				return $author$project$Components$Socle$Session$Model$sansOrigine(href) ? $elm$core$Maybe$Just(
					_Utils_ap(origine, href)) : (A2($elm$core$String$startsWith, origine + '/', href) ? $elm$core$Maybe$Just(href) : $elm$core$Maybe$Nothing);
			},
			$author$project$Components$Socle$Session$Model$origineDeLApi(configuration));
	});
var $author$project$Main$Update$versLApi = F3(
	function (model, lien, requete) {
		var _v0 = _Utils_Tuple2(model.e1.gt, model.e1.v1);
		if ((_v0.a.$ === 1) && (!_v0.b.$)) {
			var connexion = _v0.a.a;
			var configuration = _v0.b.a;
			var _v1 = A2($author$project$Components$Socle$Session$Model$adresseSurLApi, configuration, lien.cM);
			if (!_v1.$) {
				var adresse = _v1.a;
				return _List_fromArray(
					[
						requete(
						{
							gM: connexion.ce,
							nB: _Utils_update(
								lien,
								{cM: adresse})
						})
					]);
			} else {
				return _List_fromArray(
					[
						$author$project$Main$Update$SignalerIncidentDeSession(
						$author$project$Components$Socle$Session$Model$LienHorsDeLApi(lien.eP))
					]);
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Socle$Session$Model$ActionHorsDuRealm = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Socle$Session$Model$EchangeRefuse = {$: 3};
var $author$project$Components$Socle$Session$Update$LireLHeure = {$: 11};
var $author$project$Components$Socle$Session$Update$Signaler = function (a) {
	return {$: 10, a: a};
};
var $author$project$API$Liens$parametre = F2(
	function (nom, lien) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (paire) {
					var _v0 = A2($elm$core$String$split, '=', paire);
					if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
						var cle = _v0.a;
						var _v1 = _v0.b;
						var valeur = _v1.a;
						return _Utils_eq(cle, nom) ? $elm$url$Url$percentDecode(valeur) : $elm$core$Maybe$Nothing;
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				A2(
					$elm$core$String$split,
					'&',
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(
							A2(
								$elm$core$List$drop,
								1,
								A2($elm$core$String$split, '?', lien.cM)))))));
	});
var $author$project$Components$Socle$Session$Model$parametresDuRealm = F2(
	function (configuration, lien) {
		return _Utils_eq(
			$elm$core$List$head(
				A2($elm$core$String$split, '?', lien.cM)),
			$elm$core$Maybe$Just(
				A2($author$project$Components$Socle$Session$Model$pointDuRealm, configuration, 'auth'))) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$List$filter,
				function (paire) {
					return A2(
						$elm$core$List$any,
						function (cle) {
							return A2($elm$core$String$startsWith, cle + '=', paire);
						},
						_List_fromArray(
							['kc_action', 'max_age']));
				},
				A2(
					$elm$core$String$split,
					'&',
					A2(
						$elm$core$String$join,
						'?',
						A2(
							$elm$core$List$drop,
							1,
							A2($elm$core$String$split, '?', lien.cM)))))) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$Socle$Session$Model$actionDuRealm = F2(
	function (configuration, lien) {
		return A2(
			$elm$core$Maybe$andThen,
			function (parametres) {
				return A2(
					$elm$core$Maybe$map,
					function (nom) {
						return {
							Dj: $elm$core$Maybe$Just(nom),
							EX: parametres,
							qx: $elm$core$Maybe$Nothing
						};
					},
					A2($author$project$API$Liens$parametre, 'kc_action', lien));
			},
			A2($author$project$Components$Socle$Session$Model$parametresDuRealm, configuration, lien));
	});
var $author$project$Components$Socle$Session$Update$GarderDernierEspace = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Socle$Session$Update$choisir = F3(
	function (alias, retour, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					yA: $elm$core$Maybe$Just(alias),
					gt: $author$project$Components$Socle$Session$Model$Inconnue,
					EE: retour,
					GQ: $elm$core$Maybe$Nothing
				}),
			_List_fromArray(
				[
					$author$project$Components$Socle$Session$Update$GarderDernierEspace(alias),
					$author$project$Components$Socle$Session$Update$DemanderAlea($author$project$Components$Socle$Session$Model$octetsDemandes)
				]));
	});
var $author$project$Components$Socle$Session$Update$LireTraductions = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Socle$Session$Update$application = 'backoffice';
var $author$project$Components$Socle$Session$Update$francais = 'fr';
var $author$project$Components$Socle$Session$Update$lire = F4(
	function (configuration, connexion, effet, lien) {
		var _v0 = A2($author$project$Components$Socle$Session$Model$adresseSurLApi, configuration, lien.cM);
		if (!_v0.$) {
			var url = _v0.a;
			return _List_fromArray(
				[
					effet(
					{gM: connexion.ce, aQ: url})
				]);
		} else {
			return _List_fromArray(
				[
					$author$project$Components$Socle$Session$Update$Signaler(
					$author$project$Components$Socle$Session$Model$LienHorsDeLApi(lien.eP))
				]);
		}
	});
var $author$project$API$NavLinksDictionary$traductions = 'traductions';
var $author$project$API$NavLinksDictionary$variableApplication = 'application';
var $author$project$API$NavLinksDictionary$variableLangue = 'langue';
var $author$project$Components$Socle$Session$Update$choisirLaLangue = F4(
	function (configuration, langue, connexion, model) {
		return _Utils_eq(langue, $author$project$Components$Socle$Session$Update$francais) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{JL: $author$project$I18n$Traductions$francais}),
			_List_Nil) : _Utils_Tuple2(
			model,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A3(
						$author$project$Components$Socle$Session$Update$lire,
						configuration,
						connexion,
						function (lecture) {
							return $author$project$Components$Socle$Session$Update$LireTraductions(
								{gM: lecture.gM, nn: langue, aQ: lecture.aQ});
						}),
					A2(
						$elm$core$Maybe$andThen,
						$author$project$API$Liens$resoudre(
							_List_fromArray(
								[
									_Utils_Tuple2($author$project$API$NavLinksDictionary$variableApplication, $author$project$Components$Socle$Session$Update$application),
									_Utils_Tuple2($author$project$API$NavLinksDictionary$variableLangue, langue)
								])),
						A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$traductions, connexion.gF)))));
	});
var $author$project$Components$Socle$Session$Update$ChargerAdresse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Socle$Session$Model$Deconnectee = {$: 3};
var $author$project$Components$Socle$Session$Model$finDeSession = F3(
	function (configuration, origine, identite) {
		return _Utils_ap(
			A2($author$project$Components$Socle$Session$Model$pointDuRealm, configuration, 'logout'),
			$elm$url$Url$Builder$toQuery(
				_List_fromArray(
					[
						A2($elm$url$Url$Builder$string, 'id_token_hint', identite),
						A2(
						$elm$url$Url$Builder$string,
						'post_logout_redirect_uri',
						$author$project$Components$Socle$Session$Model$adresseDeRetour(origine))
					])));
	});
var $author$project$Components$Socle$Session$Update$deconnecter = F3(
	function (configuration, identite, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{gt: $author$project$Components$Socle$Session$Model$Deconnectee, GQ: $elm$core$Maybe$Nothing, JL: $author$project$I18n$Traductions$francais}),
			_List_fromArray(
				[
					$author$project$Components$Socle$Session$Update$ChargerAdresse(
					A3($author$project$Components$Socle$Session$Model$finDeSession, configuration, model.o4, identite))
				]));
	});
var $author$project$Components$Socle$Session$Model$AccesDesactive = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Socle$Session$Update$desactiveDans = F2(
	function (espace, connexion) {
		return $author$project$Components$Socle$Session$Model$AccesDesactive(
			{
				yb: connexion.yb,
				yz: function () {
					if (!espace.$) {
						return espace;
					} else {
						return connexion.g5;
					}
				}(),
				Av: connexion.Av
			});
	});
var $author$project$Components$Socle$Session$Update$espaceDuJeton = function (organisation) {
	return (organisation === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(organisation);
};
var $author$project$Components$Socle$Session$Model$margeEnMillis = function (rafraichissement) {
	return A2($elm$core$Basics$max, 30000, rafraichissement.lG * 200);
};
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $author$project$Components$Socle$Session$Model$aRenouveler = F2(
	function (maintenant, rafraichissement) {
		var _v0 = rafraichissement.xY;
		if (!_v0.$) {
			var echeance = _v0.a;
			return (!rafraichissement.yj) && (_Utils_cmp(
				$elm$time$Time$posixToMillis(maintenant),
				$elm$time$Time$posixToMillis(echeance) - $author$project$Components$Socle$Session$Model$margeEnMillis(rafraichissement)) > -1);
		} else {
			return false;
		}
	});
var $author$project$Components$Socle$Session$Model$ancrer = F2(
	function (maintenant, rafraichissement) {
		return _Utils_update(
			rafraichissement,
			{
				xY: $elm$core$Maybe$Just(
					$elm$time$Time$millisToPosix(
						$elm$time$Time$posixToMillis(maintenant) + (rafraichissement.lG * 1000)))
			});
	});
var $author$project$Components$Socle$Session$Update$RenouvelerLeJeton = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Socle$Session$Model$scopeDeLEspace = function (alias) {
	return 'organization:' + alias;
};
var $author$project$Components$Socle$Session$Model$renouvellement = F3(
	function (configuration, organisation, rafraichissement) {
		return {
			jW: configuration.jW,
			gM: rafraichissement.gM,
			Is: A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$cons,
					'openid',
					(organisation === '') ? _List_Nil : _List_fromArray(
						[
							$author$project$Components$Socle$Session$Model$scopeDeLEspace(organisation)
						]))),
			aQ: A2($author$project$Components$Socle$Session$Model$pointDuRealm, configuration, 'token')
		};
	});
var $author$project$Components$Socle$Session$Update$demanderLeRenouvellement = F4(
	function (configuration, connexion, rafraichissement, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					GQ: $elm$core$Maybe$Just(
						_Utils_update(
							rafraichissement,
							{yj: true}))
				}),
			_List_fromArray(
				[
					$author$project$Components$Socle$Session$Update$RenouvelerLeJeton(
					A3($author$project$Components$Socle$Session$Model$renouvellement, configuration, connexion.En, rafraichissement))
				]));
	});
var $author$project$Components$Socle$Session$Update$lireLHeure = F4(
	function (configuration, maintenant, connexion, model) {
		var _v0 = model.GQ;
		if (!_v0.$) {
			var rafraichissement = _v0.a;
			return _Utils_eq(rafraichissement.xY, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{
						GQ: $elm$core$Maybe$Just(
							A2($author$project$Components$Socle$Session$Model$ancrer, maintenant, rafraichissement))
					}),
				_List_Nil) : (A2($author$project$Components$Socle$Session$Model$aRenouveler, maintenant, rafraichissement) ? A4($author$project$Components$Socle$Session$Update$demanderLeRenouvellement, configuration, connexion, rafraichissement, model) : _Utils_Tuple2(model, _List_Nil));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Socle$Session$Model$AChoisir = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Socle$Session$Model$Connectee = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Socle$Session$Model$EspaceIndisponible = {$: 6};
var $author$project$Components$Socle$Session$Model$JetonIllisible = {$: 4};
var $author$project$Components$Socle$Session$Update$LireRacine = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Socle$Session$API$QueryAPIModel$Jetons = F2(
	function (acces, identite) {
		return {ce: acces, Av: identite};
	});
var $author$project$Components$Socle$Session$API$QueryAPIModel$lireJetons = function (corps) {
	return $elm$core$Result$toMaybe(
		A2(
			$elm$json$Json$Decode$decodeString,
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Components$Socle$Session$API$QueryAPIModel$Jetons,
				A2($elm$json$Json$Decode$field, 'access_token', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'id_token', $elm$json$Json$Decode$string)),
			corps));
};
var $elm$bytes$Bytes$Encode$getWidth = function (builder) {
	switch (builder.$) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 4;
		case 3:
			return 1;
		case 4:
			return 2;
		case 5:
			return 4;
		case 6:
			return 4;
		case 7:
			return 8;
		case 8:
			var w = builder.a;
			return w;
		case 9:
			var w = builder.a;
			return w;
		default:
			var bs = builder.a;
			return _Bytes_width(bs);
	}
};
var $elm$bytes$Bytes$LE = 0;
var $elm$bytes$Bytes$Encode$write = F3(
	function (builder, mb, offset) {
		switch (builder.$) {
			case 0:
				var n = builder.a;
				return A3(_Bytes_write_i8, mb, offset, n);
			case 1:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i16, mb, offset, n, !e);
			case 2:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i32, mb, offset, n, !e);
			case 3:
				var n = builder.a;
				return A3(_Bytes_write_u8, mb, offset, n);
			case 4:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u16, mb, offset, n, !e);
			case 5:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u32, mb, offset, n, !e);
			case 6:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f32, mb, offset, n, !e);
			case 7:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f64, mb, offset, n, !e);
			case 8:
				var bs = builder.b;
				return A3($elm$bytes$Bytes$Encode$writeSequence, bs, mb, offset);
			case 9:
				var s = builder.b;
				return A3(_Bytes_write_string, mb, offset, s);
			default:
				var bs = builder.a;
				return A3(_Bytes_write_bytes, mb, offset, bs);
		}
	});
var $elm$bytes$Bytes$Encode$writeSequence = F3(
	function (builders, mb, offset) {
		writeSequence:
		while (true) {
			if (!builders.b) {
				return offset;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$builders = bs,
					$temp$mb = mb,
					$temp$offset = A3($elm$bytes$Bytes$Encode$write, b, mb, offset);
				builders = $temp$builders;
				mb = $temp$mb;
				offset = $temp$offset;
				continue writeSequence;
			}
		}
	});
var $elm$bytes$Bytes$Encode$encode = _Bytes_encode;
var $author$project$Components$Socle$Session$API$QueryAPIModel$octets = function (sextets) {
	if (sextets.b && sextets.b.b) {
		if (sextets.b.b.b) {
			if (sextets.b.b.b.b) {
				var a = sextets.a;
				var _v1 = sextets.b;
				var b = _v1.a;
				var _v2 = _v1.b;
				var c = _v2.a;
				var _v3 = _v2.b;
				var d = _v3.a;
				var suite = _v3.b;
				return A2(
					$elm$core$List$cons,
					(a * 4) + ((b / 16) | 0),
					A2(
						$elm$core$List$cons,
						(A2($elm$core$Basics$modBy, 16, b) * 16) + ((c / 4) | 0),
						A2(
							$elm$core$List$cons,
							(A2($elm$core$Basics$modBy, 4, c) * 64) + d,
							$author$project$Components$Socle$Session$API$QueryAPIModel$octets(suite))));
			} else {
				var a = sextets.a;
				var _v4 = sextets.b;
				var b = _v4.a;
				var _v5 = _v4.b;
				var c = _v5.a;
				return _List_fromArray(
					[
						(a * 4) + ((b / 16) | 0),
						(A2($elm$core$Basics$modBy, 16, b) * 16) + ((c / 4) | 0)
					]);
			}
		} else {
			var a = sextets.a;
			var _v6 = sextets.b;
			var b = _v6.a;
			return _List_fromArray(
				[(a * 4) + ((b / 16) | 0)]);
		}
	} else {
		return _List_Nil;
	}
};
var $elm$bytes$Bytes$Encode$Seq = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$getWidths = F2(
	function (width, builders) {
		getWidths:
		while (true) {
			if (!builders.b) {
				return width;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$width = width + $elm$bytes$Bytes$Encode$getWidth(b),
					$temp$builders = bs;
				width = $temp$width;
				builders = $temp$builders;
				continue getWidths;
			}
		}
	});
var $elm$bytes$Bytes$Encode$sequence = function (builders) {
	return A2(
		$elm$bytes$Bytes$Encode$Seq,
		A2($elm$bytes$Bytes$Encode$getWidths, 0, builders),
		builders);
};
var $author$project$Components$Socle$Session$API$QueryAPIModel$sextet = function (caractere) {
	var code = $elm$core$Char$toCode(caractere);
	return $elm$core$Char$isUpper(caractere) ? $elm$core$Maybe$Just(code - 65) : ($elm$core$Char$isLower(caractere) ? $elm$core$Maybe$Just(code - 71) : ($elm$core$Char$isDigit(caractere) ? $elm$core$Maybe$Just(code + 4) : ((caractere === '-') ? $elm$core$Maybe$Just(62) : ((caractere === '_') ? $elm$core$Maybe$Just(63) : $elm$core$Maybe$Nothing))));
};
var $elm$bytes$Bytes$Decode$decode = F2(
	function (_v0, bs) {
		var decoder = _v0;
		return A2(_Bytes_decode, decoder, bs);
	});
var $elm$bytes$Bytes$Decode$Decoder = $elm$core$Basics$identity;
var $elm$bytes$Bytes$Decode$string = function (n) {
	return _Bytes_read_string(n);
};
var $elm$bytes$Bytes$width = _Bytes_width;
var $author$project$Components$Socle$Session$API$QueryAPIModel$texte = function (recus) {
	return A2(
		$elm$bytes$Bytes$Decode$decode,
		$elm$bytes$Bytes$Decode$string(
			$elm$bytes$Bytes$width(recus)),
		recus);
};
var $elm$bytes$Bytes$Encode$U8 = function (a) {
	return {$: 3, a: a};
};
var $elm$bytes$Bytes$Encode$unsignedInt8 = $elm$bytes$Bytes$Encode$U8;
var $author$project$Components$Socle$Session$API$QueryAPIModel$decoderBase64Url = function (segment) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$Components$Socle$Session$API$QueryAPIModel$texte,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$Socle$Session$API$QueryAPIModel$octets,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map($elm$bytes$Bytes$Encode$unsignedInt8),
					A2($elm$core$Basics$composeR, $elm$bytes$Bytes$Encode$sequence, $elm$bytes$Bytes$Encode$encode))),
			A3(
				$elm$core$List$foldr,
				F2(
					function (caractere, sextets) {
						return A3(
							$elm$core$Maybe$map2,
							$elm$core$List$cons,
							$author$project$Components$Socle$Session$API$QueryAPIModel$sextet(caractere),
							sextets);
					}),
				$elm$core$Maybe$Just(_List_Nil),
				$elm$core$String$toList(segment))));
};
var $author$project$Components$Socle$Session$API$QueryAPIModel$Revendications = F3(
	function (nom, email, organisation) {
		return {yb: email, Dj: nom, En: organisation};
	});
var $author$project$Components$Socle$Session$API$QueryAPIModel$organisations = function () {
	var parAlias = A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$map($elm$core$Tuple$first),
		$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value));
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				parAlias,
				A2(
				$elm$json$Json$Decode$map,
				$elm$core$List$concat,
				$elm$json$Json$Decode$list(
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2($elm$json$Json$Decode$map, $elm$core$List$singleton, $elm$json$Json$Decode$string),
								parAlias
							]))))
			]));
}();
var $author$project$Components$Socle$Session$API$QueryAPIModel$revendications = A4(
	$elm$json$Json$Decode$map3,
	F3(
		function (nom, email, organisation) {
			return A3(
				$author$project$Components$Socle$Session$API$QueryAPIModel$Revendications,
				nom,
				A2($elm$core$Maybe$withDefault, nom, email),
				organisation);
		}),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'preferred_username', $elm$json$Json$Decode$string)
			])),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			$elm$core$Maybe$withDefault('')),
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2($elm$json$Json$Decode$field, 'organization', $author$project$Components$Socle$Session$API$QueryAPIModel$organisations),
					$elm$json$Json$Decode$succeed(_List_Nil)
				]))));
var $author$project$Components$Socle$Session$API$QueryAPIModel$lireRevendications = function (jeton) {
	var _v0 = A2($elm$core$String$split, '.', jeton);
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
		var _v1 = _v0.b;
		var charge = _v1.a;
		var _v2 = _v1.b;
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				$elm$json$Json$Decode$decodeString($author$project$Components$Socle$Session$API$QueryAPIModel$revendications),
				$elm$core$Result$toMaybe),
			$author$project$Components$Socle$Session$API$QueryAPIModel$decoderBase64Url(charge));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Socle$Session$API$QueryAPIModel$lireRafraichissement = function (corps) {
	return $elm$core$Result$toMaybe(
		A2(
			$elm$json$Json$Decode$decodeString,
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (acces, jeton, duree) {
						return {ce: acces, lG: duree, gM: jeton};
					}),
				A2($elm$json$Json$Decode$field, 'access_token', $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$maybe(
					A2($elm$json$Json$Decode$field, 'refresh_token', $elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							A2($elm$json$Json$Decode$field, 'expires_in', $elm$json$Json$Decode$int),
							$elm$json$Json$Decode$succeed(300)
						]))),
			corps));
};
var $author$project$Components$Socle$Session$Update$rafraichissementDe = function (corps) {
	return A2(
		$elm$core$Maybe$andThen,
		function (lu) {
			return A2(
				$elm$core$Maybe$map,
				function (jeton) {
					return {lG: lu.lG, xY: $elm$core$Maybe$Nothing, yj: false, gM: jeton};
				},
				lu.gM);
		},
		$author$project$Components$Socle$Session$API$QueryAPIModel$lireRafraichissement(corps));
};
var $author$project$Components$Socle$Session$Update$ouvrir = F3(
	function (configuration, corps, model) {
		var jetons = $author$project$Components$Socle$Session$API$QueryAPIModel$lireJetons(corps);
		var revendications = A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Av;
				},
				$author$project$Components$Socle$Session$API$QueryAPIModel$lireRevendications),
			jetons);
		var _v0 = A3($elm$core$Maybe$map2, $elm$core$Tuple$pair, jetons, revendications);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var lus = _v1.a;
			var compte = _v1.b;
			return ((!_Utils_eq(model.yA, $elm$core$Maybe$Nothing)) && (!_Utils_eq(
				model.yA,
				$elm$core$Maybe$Just(compte.En)))) ? A2($author$project$Components$Socle$Session$Update$echouerAuRetour, $author$project$Components$Socle$Session$Model$EspaceIndisponible, model) : _Utils_Tuple2(
				_Utils_update(
					model,
					{
						gt: (compte.En === '') ? $author$project$Components$Socle$Session$Model$AChoisir(
							{ce: lus.ce, yb: compte.yb, yC: $elm$core$Maybe$Nothing, Av: lus.Av}) : $author$project$Components$Socle$Session$Model$Connectee(
							{ce: lus.ce, yb: compte.yb, yl: false, yC: _List_Nil, gF: _List_Nil, Av: lus.Av, nQ: _List_Nil, Dj: compte.Dj, g5: $elm$core$Maybe$Nothing, En: compte.En, GO: false}),
						GQ: $author$project$Components$Socle$Session$Update$rafraichissementDe(corps)
					}),
				_List_fromArray(
					[
						$author$project$Components$Socle$Session$Update$RemplacerAdresse(model.EE),
						$author$project$Components$Socle$Session$Update$LireRacine(
						{gM: lus.ce, aQ: configuration.fz}),
						$author$project$Components$Socle$Session$Update$LireLHeure
					]));
		} else {
			return A2($author$project$Components$Socle$Session$Update$echouerAuRetour, $author$project$Components$Socle$Session$Model$JetonIllisible, model);
		}
	});
var $author$project$Components$Socle$Session$Model$AleaInsuffisant = {$: 1};
var $author$project$Components$Socle$Session$Update$PartirVers = function (a) {
	return {$: 1, a: a};
};
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$CodeVerifier = $elm$core$Basics$identity;
var $chelovek0v$bbase64$Base64$Encode$BytesEncoder = function (a) {
	return {$: 1, a: a};
};
var $chelovek0v$bbase64$Base64$Encode$bytes = function (input) {
	return $chelovek0v$bbase64$Base64$Encode$BytesEncoder(input);
};
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$codeVerifierFromBytes = function (bytes) {
	return (($elm$bytes$Bytes$width(bytes) < 32) || ($elm$bytes$Bytes$width(bytes) > 90)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		$chelovek0v$bbase64$Base64$Encode$bytes(bytes));
};
var $elm$bytes$Bytes$Encode$Utf8 = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$string = function (str) {
	return A2(
		$elm$bytes$Bytes$Encode$Utf8,
		_Bytes_getStringWidth(str),
		str);
};
var $elm$bytes$Bytes$Decode$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$bytes$Bytes$Decode$Loop = function (a) {
	return {$: 0, a: a};
};
var $chelovek0v$bbase64$Base64$Shift$Shift2 = 1;
var $chelovek0v$bbase64$Base64$Shift$Shift4 = 2;
var $chelovek0v$bbase64$Base64$Shift$Shift6 = 3;
var $chelovek0v$bbase64$Base64$Shift$and = F2(
	function (shift, value) {
		switch (shift) {
			case 0:
				return value;
			case 1:
				return 3 & value;
			case 2:
				return 15 & value;
			default:
				return 63 & value;
		}
	});
var $chelovek0v$bbase64$Base64$Table$codeToCharMap = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(0, 'A'),
			_Utils_Tuple2(1, 'B'),
			_Utils_Tuple2(2, 'C'),
			_Utils_Tuple2(3, 'D'),
			_Utils_Tuple2(4, 'E'),
			_Utils_Tuple2(5, 'F'),
			_Utils_Tuple2(6, 'G'),
			_Utils_Tuple2(7, 'H'),
			_Utils_Tuple2(8, 'I'),
			_Utils_Tuple2(9, 'J'),
			_Utils_Tuple2(10, 'K'),
			_Utils_Tuple2(11, 'L'),
			_Utils_Tuple2(12, 'M'),
			_Utils_Tuple2(13, 'N'),
			_Utils_Tuple2(14, 'O'),
			_Utils_Tuple2(15, 'P'),
			_Utils_Tuple2(16, 'Q'),
			_Utils_Tuple2(17, 'R'),
			_Utils_Tuple2(18, 'S'),
			_Utils_Tuple2(19, 'T'),
			_Utils_Tuple2(20, 'U'),
			_Utils_Tuple2(21, 'V'),
			_Utils_Tuple2(22, 'W'),
			_Utils_Tuple2(23, 'X'),
			_Utils_Tuple2(24, 'Y'),
			_Utils_Tuple2(25, 'Z'),
			_Utils_Tuple2(26, 'a'),
			_Utils_Tuple2(27, 'b'),
			_Utils_Tuple2(28, 'c'),
			_Utils_Tuple2(29, 'd'),
			_Utils_Tuple2(30, 'e'),
			_Utils_Tuple2(31, 'f'),
			_Utils_Tuple2(32, 'g'),
			_Utils_Tuple2(33, 'h'),
			_Utils_Tuple2(34, 'i'),
			_Utils_Tuple2(35, 'j'),
			_Utils_Tuple2(36, 'k'),
			_Utils_Tuple2(37, 'l'),
			_Utils_Tuple2(38, 'm'),
			_Utils_Tuple2(39, 'n'),
			_Utils_Tuple2(40, 'o'),
			_Utils_Tuple2(41, 'p'),
			_Utils_Tuple2(42, 'q'),
			_Utils_Tuple2(43, 'r'),
			_Utils_Tuple2(44, 's'),
			_Utils_Tuple2(45, 't'),
			_Utils_Tuple2(46, 'u'),
			_Utils_Tuple2(47, 'v'),
			_Utils_Tuple2(48, 'w'),
			_Utils_Tuple2(49, 'x'),
			_Utils_Tuple2(50, 'y'),
			_Utils_Tuple2(51, 'z'),
			_Utils_Tuple2(52, '0'),
			_Utils_Tuple2(53, '1'),
			_Utils_Tuple2(54, '2'),
			_Utils_Tuple2(55, '3'),
			_Utils_Tuple2(56, '4'),
			_Utils_Tuple2(57, '5'),
			_Utils_Tuple2(58, '6'),
			_Utils_Tuple2(59, '7'),
			_Utils_Tuple2(60, '8'),
			_Utils_Tuple2(61, '9'),
			_Utils_Tuple2(62, '+'),
			_Utils_Tuple2(63, '/')
		]));
var $chelovek0v$bbase64$Base64$Table$encode = function (code) {
	var _v0 = A2($elm$core$Dict$get, code, $chelovek0v$bbase64$Base64$Table$codeToCharMap);
	if (!_v0.$) {
		var char_ = _v0.a;
		return char_;
	} else {
		return '';
	}
};
var $chelovek0v$bbase64$Base64$Shift$next = function (shift) {
	switch (shift) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		default:
			return 1;
	}
};
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $chelovek0v$bbase64$Base64$Shift$toInt = function (shift) {
	switch (shift) {
		case 0:
			return 0;
		case 1:
			return 2;
		case 2:
			return 4;
		default:
			return 6;
	}
};
var $chelovek0v$bbase64$Base64$Shift$shiftRightZfBy = F2(
	function (shift, value) {
		return value >>> $chelovek0v$bbase64$Base64$Shift$toInt(shift);
	});
var $elm$core$Bitwise$or = _Bitwise_or;
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $chelovek0v$bbase64$Base64$Shift$shiftLeftBy = F2(
	function (shift, value) {
		return value << $chelovek0v$bbase64$Base64$Shift$toInt(shift);
	});
var $chelovek0v$bbase64$Base64$Encode$sixtet = F2(
	function (octet, _v0) {
		var shift = _v0.a;
		var sixtet_ = _v0.b;
		var strAcc = _v0.c;
		switch (shift) {
			case 0:
				return A2($chelovek0v$bbase64$Base64$Shift$shiftRightZfBy, 1, octet);
			case 1:
				return A2($chelovek0v$bbase64$Base64$Shift$shiftLeftBy, 2, sixtet_) | A2($chelovek0v$bbase64$Base64$Shift$shiftRightZfBy, 2, octet);
			case 2:
				return A2($chelovek0v$bbase64$Base64$Shift$shiftLeftBy, 1, sixtet_) | A2($chelovek0v$bbase64$Base64$Shift$shiftRightZfBy, 3, octet);
			default:
				return sixtet_;
		}
	});
var $chelovek0v$bbase64$Base64$Encode$encodeStep = F2(
	function (octet, encodeState) {
		var shift = encodeState.a;
		var strAcc = encodeState.c;
		var nextSixtet = function () {
			switch (shift) {
				case 0:
					return A2($chelovek0v$bbase64$Base64$Shift$and, 1, octet);
				case 1:
					return A2($chelovek0v$bbase64$Base64$Shift$and, 2, octet);
				case 2:
					return A2($chelovek0v$bbase64$Base64$Shift$and, 3, octet);
				default:
					return A2($chelovek0v$bbase64$Base64$Shift$and, 1, octet);
			}
		}();
		var currentSixtet = A2($chelovek0v$bbase64$Base64$Encode$sixtet, octet, encodeState);
		var base64Char = function () {
			if (shift === 3) {
				return _Utils_ap(
					$chelovek0v$bbase64$Base64$Table$encode(currentSixtet),
					$chelovek0v$bbase64$Base64$Table$encode(
						A2($chelovek0v$bbase64$Base64$Shift$shiftRightZfBy, 1, octet)));
			} else {
				return $chelovek0v$bbase64$Base64$Table$encode(currentSixtet);
			}
		}();
		return _Utils_Tuple3(
			$chelovek0v$bbase64$Base64$Shift$next(shift),
			nextSixtet,
			_Utils_ap(strAcc, base64Char));
	});
var $elm$bytes$Bytes$Decode$map = F2(
	function (func, _v0) {
		var decodeA = _v0;
		return F2(
			function (bites, offset) {
				var _v1 = A2(decodeA, bites, offset);
				var aOffset = _v1.a;
				var a = _v1.b;
				return _Utils_Tuple2(
					aOffset,
					func(a));
			});
	});
var $elm$bytes$Bytes$Decode$succeed = function (a) {
	return F2(
		function (_v0, offset) {
			return _Utils_Tuple2(offset, a);
		});
};
var $chelovek0v$bbase64$Base64$Encode$decodeStep = F2(
	function (octetDecoder, _v0) {
		var n = _v0.a;
		var encodeState = _v0.b;
		return (n <= 0) ? $elm$bytes$Bytes$Decode$succeed(
			$elm$bytes$Bytes$Decode$Done(encodeState)) : A2(
			$elm$bytes$Bytes$Decode$map,
			function (octet) {
				return $elm$bytes$Bytes$Decode$Loop(
					_Utils_Tuple2(
						n - 1,
						A2($chelovek0v$bbase64$Base64$Encode$encodeStep, octet, encodeState)));
			},
			octetDecoder);
	});
var $chelovek0v$bbase64$Base64$Encode$finalize = function (_v0) {
	var shift = _v0.a;
	var sixtet_ = _v0.b;
	var strAcc = _v0.c;
	switch (shift) {
		case 3:
			return _Utils_ap(
				strAcc,
				$chelovek0v$bbase64$Base64$Table$encode(sixtet_));
		case 2:
			return strAcc + ($chelovek0v$bbase64$Base64$Table$encode(
				A2($chelovek0v$bbase64$Base64$Shift$shiftLeftBy, 1, sixtet_)) + '=');
		case 1:
			return strAcc + ($chelovek0v$bbase64$Base64$Table$encode(
				A2($chelovek0v$bbase64$Base64$Shift$shiftLeftBy, 2, sixtet_)) + '==');
		default:
			return strAcc;
	}
};
var $chelovek0v$bbase64$Base64$Shift$Shift0 = 0;
var $chelovek0v$bbase64$Base64$Encode$initialEncodeState = _Utils_Tuple3(0, 0, '');
var $elm$bytes$Bytes$Decode$loopHelp = F4(
	function (state, callback, bites, offset) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var decoder = _v0;
			var _v1 = A2(decoder, bites, offset);
			var newOffset = _v1.a;
			var step = _v1.b;
			if (!step.$) {
				var newState = step.a;
				var $temp$state = newState,
					$temp$callback = callback,
					$temp$bites = bites,
					$temp$offset = newOffset;
				state = $temp$state;
				callback = $temp$callback;
				bites = $temp$bites;
				offset = $temp$offset;
				continue loopHelp;
			} else {
				var result = step.a;
				return _Utils_Tuple2(newOffset, result);
			}
		}
	});
var $elm$bytes$Bytes$Decode$loop = F2(
	function (state, callback) {
		return A2($elm$bytes$Bytes$Decode$loopHelp, state, callback);
	});
var $elm$bytes$Bytes$Decode$unsignedInt8 = _Bytes_read_u8;
var $chelovek0v$bbase64$Base64$Encode$tryEncode = function (input) {
	var decoderInitialState = _Utils_Tuple2(
		$elm$bytes$Bytes$width(input),
		$chelovek0v$bbase64$Base64$Encode$initialEncodeState);
	var base64Decoder = A2(
		$elm$bytes$Bytes$Decode$loop,
		decoderInitialState,
		$chelovek0v$bbase64$Base64$Encode$decodeStep($elm$bytes$Bytes$Decode$unsignedInt8));
	return A2(
		$elm$core$Maybe$map,
		$chelovek0v$bbase64$Base64$Encode$finalize,
		A2($elm$bytes$Bytes$Decode$decode, base64Decoder, input));
};
var $chelovek0v$bbase64$Base64$Encode$encode = function (encoder) {
	if (!encoder.$) {
		var input = encoder.a;
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			$chelovek0v$bbase64$Base64$Encode$tryEncode(
				$elm$bytes$Bytes$Encode$encode(
					$elm$bytes$Bytes$Encode$string(input))));
	} else {
		var input = encoder.a;
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			$chelovek0v$bbase64$Base64$Encode$tryEncode(input));
	}
};
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$base64UrlEncode = A2(
	$elm$core$Basics$composeR,
	$chelovek0v$bbase64$Base64$Encode$encode,
	A2(
		$elm$core$Basics$composeR,
		A2($elm$core$String$replace, '=', ''),
		A2(
			$elm$core$Basics$composeR,
			A2($elm$core$String$replace, '+', '-'),
			A2($elm$core$String$replace, '/', '_'))));
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$codeVerifierToString = function (_v0) {
	var str = _v0;
	return $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$base64UrlEncode(str);
};
var $author$project$Components$Socle$Session$Model$demanderLAction = F2(
	function (action, url) {
		if (!action.$) {
			var demandee = action.a;
			return _Utils_update(
				url,
				{
					eI: $elm$core$Maybe$Just(
						A2(
							$elm$core$String$join,
							'&',
							_Utils_ap(
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2($elm$core$Maybe$map, $elm$core$List$singleton, url.eI)),
								demandee.EX)))
				});
		} else {
			return url;
		}
	});
var $author$project$Components$Socle$Session$Model$hexadecimal = function (octets) {
	var chiffre = function (valeur) {
		return $elm$core$Char$fromCode(
			(valeur < 10) ? (48 + valeur) : (87 + valeur));
	};
	return $elm$core$String$fromList(
		A2(
			$elm$core$List$concatMap,
			function (octet) {
				return _List_fromArray(
					[
						chiffre(
						(A2($elm$core$Basics$modBy, 256, octet) / 16) | 0),
						chiffre(
						A2($elm$core$Basics$modBy, 16, octet))
					]);
			},
			octets));
};
var $truqu$elm_oauth2$OAuth$Code = {$: 0};
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$codeChallengeToString = function (_v0) {
	var str = _v0;
	return $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$base64UrlEncode(str);
};
var $truqu$elm_oauth2$Internal$protocolToString = function (protocol) {
	if (!protocol) {
		return 'http';
	} else {
		return 'https';
	}
};
var $truqu$elm_oauth2$Internal$makeRedirectUri = function (url) {
	return $elm$core$String$concat(
		_List_fromArray(
			[
				$truqu$elm_oauth2$Internal$protocolToString(url.Gy),
				'://',
				url.d2,
				A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (i) {
						return ':' + $elm$core$String$fromInt(i);
					},
					url.FX)),
				url.E6,
				A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (q) {
						return '?' + q;
					},
					url.eI))
			]));
};
var $truqu$elm_oauth2$OAuth$responseTypeToString = function (r) {
	switch (r.$) {
		case 0:
			return 'code';
		case 1:
			return 'token';
		default:
			var str = r.a;
			return str;
	}
};
var $truqu$elm_oauth2$Internal$urlAddExtraFields = F2(
	function (extraFields, zero) {
		return A3(
			$elm$core$Dict$foldr,
			F3(
				function (k, v, qs) {
					return A2(
						$elm$core$List$cons,
						A2($elm$url$Url$Builder$string, k, v),
						qs);
				}),
			zero,
			extraFields);
	});
var $truqu$elm_oauth2$Internal$urlAddList = F3(
	function (param, xs, qs) {
		return _Utils_ap(
			qs,
			function () {
				if (!xs.b) {
					return _List_Nil;
				} else {
					return _List_fromArray(
						[
							A2(
							$elm$url$Url$Builder$string,
							param,
							A2($elm$core$String$join, ' ', xs))
						]);
				}
			}());
	});
var $truqu$elm_oauth2$Internal$urlAddMaybe = F3(
	function (param, ms, qs) {
		return _Utils_ap(
			qs,
			function () {
				if (ms.$ === 1) {
					return _List_Nil;
				} else {
					var s = ms.a;
					return _List_fromArray(
						[
							A2($elm$url$Url$Builder$string, param, s)
						]);
				}
			}());
	});
var $truqu$elm_oauth2$Internal$makeAuthorizationUrl = F3(
	function (responseType, extraFields, _v0) {
		var clientId = _v0.jW;
		var url = _v0.aQ;
		var redirectUri = _v0.G9;
		var scope = _v0.Is;
		var state = _v0.e3;
		var query = A2(
			$elm$core$String$dropLeft,
			1,
			$elm$url$Url$Builder$toQuery(
				A2(
					$truqu$elm_oauth2$Internal$urlAddExtraFields,
					extraFields,
					A3(
						$truqu$elm_oauth2$Internal$urlAddMaybe,
						'state',
						state,
						A3(
							$truqu$elm_oauth2$Internal$urlAddList,
							'scope',
							scope,
							_List_fromArray(
								[
									A2($elm$url$Url$Builder$string, 'client_id', clientId),
									A2(
									$elm$url$Url$Builder$string,
									'redirect_uri',
									$truqu$elm_oauth2$Internal$makeRedirectUri(redirectUri)),
									A2(
									$elm$url$Url$Builder$string,
									'response_type',
									$truqu$elm_oauth2$OAuth$responseTypeToString(responseType))
								]))))));
		var _v1 = url.eI;
		if (_v1.$ === 1) {
			return _Utils_update(
				url,
				{
					eI: $elm$core$Maybe$Just(query)
				});
		} else {
			var baseQuery = _v1.a;
			return _Utils_update(
				url,
				{
					eI: $elm$core$Maybe$Just(baseQuery + ('&' + query))
				});
		}
	});
var $truqu$elm_oauth2$OAuth$AuthorizationCode$makeAuthorizationUrlWith = F3(
	function (responseType, extraFields, _v0) {
		var clientId = _v0.jW;
		var url = _v0.aQ;
		var redirectUri = _v0.G9;
		var scope = _v0.Is;
		var state = _v0.e3;
		return A3(
			$truqu$elm_oauth2$Internal$makeAuthorizationUrl,
			responseType,
			extraFields,
			{jW: clientId, G9: redirectUri, Is: scope, e3: state, aQ: url});
	});
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$makeAuthorizationUrlWith = F3(
	function (responseType, extraFields, _v0) {
		var clientId = _v0.jW;
		var url = _v0.aQ;
		var redirectUri = _v0.G9;
		var scope = _v0.Is;
		var state = _v0.e3;
		var codeChallenge = _v0.vy;
		var extraInternalFields = $elm$core$Dict$fromList(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'code_challenge',
					$truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$codeChallengeToString(codeChallenge)),
					_Utils_Tuple2('code_challenge_method', 'S256')
				]));
		return A3(
			$truqu$elm_oauth2$OAuth$AuthorizationCode$makeAuthorizationUrlWith,
			responseType,
			A2($elm$core$Dict$union, extraFields, extraInternalFields),
			{jW: clientId, G9: redirectUri, Is: scope, e3: state, aQ: url});
	});
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$makeAuthorizationUrl = A2($truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$makeAuthorizationUrlWith, $truqu$elm_oauth2$OAuth$Code, $elm$core$Dict$empty);
var $elm$core$Maybe$map3 = F4(
	function (func, ma, mb, mc) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					return $elm$core$Maybe$Just(
						A3(func, a, b, c));
				}
			}
		}
	});
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$CodeChallenge = $elm$core$Basics$identity;
var $folkertdev$elm_sha2$Internal$SHA256$Digest = $elm$core$Basics$identity;
var $folkertdev$elm_sha2$Internal$SHA256$Tuple8 = F8(
	function (a, b, c, d, e, f, g, h) {
		return {$: 0, a: a, b: b, c: c, d: d, e: e, f: f, g: g, h: h};
	});
var $folkertdev$elm_sha2$Internal$SHA256$loopHelp = F2(
	function (step, _v0) {
		var n = _v0.a;
		var state = _v0.b;
		return (n > 0) ? A2(
			$elm$bytes$Bytes$Decode$map,
			function (_new) {
				return $elm$bytes$Bytes$Decode$Loop(
					_Utils_Tuple2(n - 1, _new));
			},
			step(state)) : $elm$bytes$Bytes$Decode$succeed(
			$elm$bytes$Bytes$Decode$Done(state));
	});
var $folkertdev$elm_sha2$Internal$SHA256$iterate = F3(
	function (n, step, initial) {
		return A2(
			$elm$bytes$Bytes$Decode$loop,
			_Utils_Tuple2(n, initial),
			$folkertdev$elm_sha2$Internal$SHA256$loopHelp(step));
	});
var $elm$bytes$Bytes$Decode$map5 = F6(
	function (func, _v0, _v1, _v2, _v3, _v4) {
		var decodeA = _v0;
		var decodeB = _v1;
		var decodeC = _v2;
		var decodeD = _v3;
		var decodeE = _v4;
		return F2(
			function (bites, offset) {
				var _v5 = A2(decodeA, bites, offset);
				var aOffset = _v5.a;
				var a = _v5.b;
				var _v6 = A2(decodeB, bites, aOffset);
				var bOffset = _v6.a;
				var b = _v6.b;
				var _v7 = A2(decodeC, bites, bOffset);
				var cOffset = _v7.a;
				var c = _v7.b;
				var _v8 = A2(decodeD, bites, cOffset);
				var dOffset = _v8.a;
				var d = _v8.b;
				var _v9 = A2(decodeE, bites, dOffset);
				var eOffset = _v9.a;
				var e = _v9.b;
				return _Utils_Tuple2(
					eOffset,
					A5(func, a, b, c, d, e));
			});
	});
var $folkertdev$elm_sha2$Internal$SHA256$map16 = function (f) {
	return function (b1) {
		return function (b2) {
			return function (b3) {
				return function (b4) {
					return function (b5) {
						return function (b6) {
							return function (b7) {
								return function (b8) {
									return function (b9) {
										return function (b10) {
											return function (b11) {
												return function (b12) {
													return function (b13) {
														return function (b14) {
															return function (b15) {
																return function (b16) {
																	return A6(
																		$elm$bytes$Bytes$Decode$map5,
																		F5(
																			function (a, b, c, d, e) {
																				return A4(e, d, c, b, a);
																			}),
																		b16,
																		b15,
																		b14,
																		b13,
																		A6(
																			$elm$bytes$Bytes$Decode$map5,
																			F5(
																				function (a, b, c, d, e) {
																					return A4(e, d, c, b, a);
																				}),
																			b12,
																			b11,
																			b10,
																			b9,
																			A6(
																				$elm$bytes$Bytes$Decode$map5,
																				F5(
																					function (a, b, c, d, e) {
																						return A4(e, d, c, b, a);
																					}),
																				b8,
																				b7,
																				b6,
																				b5,
																				A6(
																					$elm$bytes$Bytes$Decode$map5,
																					F5(
																						function (a, b, c, d, e) {
																							return A4(e, d, c, b, a);
																						}),
																					b4,
																					b3,
																					b2,
																					b1,
																					$elm$bytes$Bytes$Decode$succeed(f)))));
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $folkertdev$elm_sha2$Internal$SHA256$DeltaState = $elm$core$Basics$identity;
var $folkertdev$elm_sha2$Internal$SHA256$State = $elm$core$Basics$identity;
var $elm$core$Bitwise$complement = _Bitwise_complement;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{p: nodeList, m: nodeListSize, o: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $folkertdev$elm_sha2$Internal$SHA256$ks = $elm$core$Array$fromList(
	_List_fromArray(
		[1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298]));
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas = F3(
	function (index, w, _v0) {
		var _v1 = _v0;
		var a = _v1.a;
		var b = _v1.b;
		var c = _v1.c;
		var d = _v1.d;
		var e = _v1.e;
		var f = _v1.f;
		var g = _v1.g;
		var h = _v1.h;
		var maj = (b & c) ^ (a & (b ^ c));
		var k = function () {
			var _v2 = A2($elm$core$Array$get, index, $folkertdev$elm_sha2$Internal$SHA256$ks);
			if (_v2.$ === 1) {
				return 0;
			} else {
				var v = _v2.a;
				return v;
			}
		}();
		var ch = (((~e) & g) ^ (e & f)) >>> 0;
		var bigSigma1 = ((e << (32 - 25)) | (e >>> 25)) ^ (((e << (32 - 11)) | (e >>> 11)) ^ ((e << (32 - 6)) | (e >>> 6)));
		var t1 = (((h + bigSigma1) + ch) + k) + w;
		var newE = (d + t1) >>> 0;
		var bigSigma0 = ((a << (32 - 22)) | (a >>> 22)) ^ (((a << (32 - 13)) | (a >>> 13)) ^ ((a << (32 - 2)) | (a >>> 2)));
		var t2 = bigSigma0 + maj;
		var newA = (t1 + t2) >>> 0;
		var result = A8($folkertdev$elm_sha2$Internal$SHA256$Tuple8, newA, a, b, c, newE, e, f, g);
		var alt = (e >>> 25) ^ ((e << (32 - 25)) ^ ((e >>> 11) ^ ((e << (32 - 11)) ^ ((e >>> 6) ^ (e << (32 - 6))))));
		return result;
	});
var $folkertdev$elm_sha2$Internal$SHA256$numberOfWords = 16;
var $folkertdev$elm_sha2$Internal$SHA256$reduceWordsHelp = function (i) {
	return function (deltaState) {
		return function (b16) {
			return function (b15) {
				return function (b14) {
					return function (b13) {
						return function (b12) {
							return function (b11) {
								return function (b10) {
									return function (b9) {
										return function (b8) {
											return function (b7) {
												return function (b6) {
													return function (b5) {
														return function (b4) {
															return function (b3) {
																return function (b2) {
																	return function (b1) {
																		reduceWordsHelp:
																		while (true) {
																			if (i < 48) {
																				var smallSigma1 = (b2 >>> 10) ^ (((b2 << (32 - 19)) | (b2 >>> 19)) ^ ((b2 << (32 - 17)) | (b2 >>> 17)));
																				var smallSigma0 = (b15 >>> 3) ^ (((b15 << (32 - 18)) | (b15 >>> 18)) ^ ((b15 << (32 - 7)) | (b15 >>> 7)));
																				var w = (((smallSigma1 + b7) + smallSigma0) + b16) >>> 0;
																				var $temp$i = i + 1,
																					$temp$deltaState = A3($folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas, i + $folkertdev$elm_sha2$Internal$SHA256$numberOfWords, w, deltaState),
																					$temp$b16 = b15,
																					$temp$b15 = b14,
																					$temp$b14 = b13,
																					$temp$b13 = b12,
																					$temp$b12 = b11,
																					$temp$b11 = b10,
																					$temp$b10 = b9,
																					$temp$b9 = b8,
																					$temp$b8 = b7,
																					$temp$b7 = b6,
																					$temp$b6 = b5,
																					$temp$b5 = b4,
																					$temp$b4 = b3,
																					$temp$b3 = b2,
																					$temp$b2 = b1,
																					$temp$b1 = w;
																				i = $temp$i;
																				deltaState = $temp$deltaState;
																				b16 = $temp$b16;
																				b15 = $temp$b15;
																				b14 = $temp$b14;
																				b13 = $temp$b13;
																				b12 = $temp$b12;
																				b11 = $temp$b11;
																				b10 = $temp$b10;
																				b9 = $temp$b9;
																				b8 = $temp$b8;
																				b7 = $temp$b7;
																				b6 = $temp$b6;
																				b5 = $temp$b5;
																				b4 = $temp$b4;
																				b3 = $temp$b3;
																				b2 = $temp$b2;
																				b1 = $temp$b1;
																				continue reduceWordsHelp;
																			} else {
																				return deltaState;
																			}
																		}
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $folkertdev$elm_sha2$Internal$SHA256$reduceMessage = function (_v0) {
	return function (b16) {
		return function (b15) {
			return function (b14) {
				return function (b13) {
					return function (b12) {
						return function (b11) {
							return function (b10) {
								return function (b9) {
									return function (b8) {
										return function (b7) {
											return function (b6) {
												return function (b5) {
													return function (b4) {
														return function (b3) {
															return function (b2) {
																return function (b1) {
																	var initial = _v0;
																	var h0 = initial.a;
																	var h1 = initial.b;
																	var h2 = initial.c;
																	var h3 = initial.d;
																	var h4 = initial.e;
																	var h5 = initial.f;
																	var h6 = initial.g;
																	var h7 = initial.h;
																	var initialDeltaState = A3(
																		$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																		15,
																		b16,
																		A3(
																			$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																			14,
																			b15,
																			A3(
																				$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																				13,
																				b14,
																				A3(
																					$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																					12,
																					b13,
																					A3(
																						$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																						11,
																						b12,
																						A3(
																							$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																							10,
																							b11,
																							A3(
																								$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																								9,
																								b10,
																								A3(
																									$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																									8,
																									b9,
																									A3(
																										$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																										7,
																										b8,
																										A3(
																											$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																											6,
																											b7,
																											A3(
																												$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																												5,
																												b6,
																												A3(
																													$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																													4,
																													b5,
																													A3(
																														$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																														3,
																														b4,
																														A3(
																															$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																															2,
																															b3,
																															A3(
																																$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																																1,
																																b2,
																																A3($folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas, 0, b1, initial))))))))))))))));
																	var _v1 = $folkertdev$elm_sha2$Internal$SHA256$reduceWordsHelp(0)(initialDeltaState)(b1)(b2)(b3)(b4)(b5)(b6)(b7)(b8)(b9)(b10)(b11)(b12)(b13)(b14)(b15)(b16);
																	var _v2 = _v1;
																	var a = _v2.a;
																	var b = _v2.b;
																	var c = _v2.c;
																	var d = _v2.d;
																	var e = _v2.e;
																	var f = _v2.f;
																	var g = _v2.g;
																	var h = _v2.h;
																	return A8($folkertdev$elm_sha2$Internal$SHA256$Tuple8, h0 + a, h1 + b, h2 + c, h3 + d, h4 + e, h5 + f, h6 + g, h7 + h);
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$bytes$Bytes$BE = 1;
var $elm$bytes$Bytes$Decode$unsignedInt32 = function (endianness) {
	return _Bytes_read_u32(!endianness);
};
var $folkertdev$elm_sha2$Internal$SHA256$u32 = $elm$bytes$Bytes$Decode$unsignedInt32(1);
var $folkertdev$elm_sha2$Internal$SHA256$reduceBytesMessage = function (state) {
	return $folkertdev$elm_sha2$Internal$SHA256$map16(
		$folkertdev$elm_sha2$Internal$SHA256$reduceMessage(state))($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32);
};
var $folkertdev$elm_sha2$Internal$SHA256$hashChunks = F2(
	function (message, state) {
		var numberOfChunks = ($elm$bytes$Bytes$width(message) / 64) | 0;
		var hashState = A3($folkertdev$elm_sha2$Internal$SHA256$iterate, numberOfChunks, $folkertdev$elm_sha2$Internal$SHA256$reduceBytesMessage, state);
		var _v0 = A2($elm$bytes$Bytes$Decode$decode, hashState, message);
		if (!_v0.$) {
			var newState = _v0.a;
			return newState;
		} else {
			return state;
		}
	});
var $folkertdev$elm_sha2$Internal$SHA256$maxSize = 2048 * 64;
var $elm$bytes$Bytes$Encode$Bytes = function (a) {
	return {$: 10, a: a};
};
var $elm$bytes$Bytes$Encode$bytes = $elm$bytes$Bytes$Encode$Bytes;
var $elm$bytes$Bytes$Encode$U32 = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$unsignedInt32 = $elm$bytes$Bytes$Encode$U32;
var $folkertdev$elm_sha2$Internal$SHA256$padBuffer = F2(
	function (byteCount, bytes) {
		var finalBlockSize = byteCount & 63;
		var paddingSize = (finalBlockSize < 56) ? ((55 - finalBlockSize) + 4) : ((119 - finalBlockSize) + 4);
		var message = $elm$bytes$Bytes$Encode$encode(
			$elm$bytes$Bytes$Encode$sequence(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$bytes(bytes),
						$elm$bytes$Bytes$Encode$unsignedInt8(128),
						$elm$bytes$Bytes$Encode$sequence(
						A2(
							$elm$core$List$repeat,
							paddingSize,
							$elm$bytes$Bytes$Encode$unsignedInt8(0))),
						A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, byteCount << 3)
					])));
		return message;
	});
var $elm$bytes$Bytes$Decode$bytes = function (n) {
	return _Bytes_read_bytes(n);
};
var $elm$bytes$Bytes$Decode$map2 = F3(
	function (func, _v0, _v1) {
		var decodeA = _v0;
		var decodeB = _v1;
		return F2(
			function (bites, offset) {
				var _v2 = A2(decodeA, bites, offset);
				var aOffset = _v2.a;
				var a = _v2.b;
				var _v3 = A2(decodeB, bites, aOffset);
				var bOffset = _v3.a;
				var b = _v3.b;
				return _Utils_Tuple2(
					bOffset,
					A2(func, a, b));
			});
	});
var $folkertdev$elm_sha2$Internal$SHA256$splitBytes = F2(
	function (n, buffer) {
		var decoder = A3(
			$elm$bytes$Bytes$Decode$map2,
			$elm$core$Tuple$pair,
			$elm$bytes$Bytes$Decode$bytes(n),
			$elm$bytes$Bytes$Decode$bytes(
				$elm$bytes$Bytes$width(buffer) - n));
		var _v0 = A2($elm$bytes$Bytes$Decode$decode, decoder, buffer);
		if (!_v0.$) {
			var v = _v0.a;
			return v;
		} else {
			return _Utils_Tuple2(
				buffer,
				$elm$bytes$Bytes$Encode$encode(
					$elm$bytes$Bytes$Encode$sequence(_List_Nil)));
		}
	});
var $folkertdev$elm_sha2$Internal$SHA256$hashBytesHelp = F4(
	function (fullSize, isLast, bytes, state) {
		hashBytesHelp:
		while (true) {
			if (_Utils_cmp(
				$elm$bytes$Bytes$width(bytes),
				$folkertdev$elm_sha2$Internal$SHA256$maxSize) > 0) {
				var _v0 = A2($folkertdev$elm_sha2$Internal$SHA256$splitBytes, $folkertdev$elm_sha2$Internal$SHA256$maxSize, bytes);
				var first = _v0.a;
				var rest = _v0.b;
				var $temp$fullSize = fullSize,
					$temp$isLast = true,
					$temp$bytes = rest,
					$temp$state = A4($folkertdev$elm_sha2$Internal$SHA256$hashBytesHelp, fullSize, false, first, state);
				fullSize = $temp$fullSize;
				isLast = $temp$isLast;
				bytes = $temp$bytes;
				state = $temp$state;
				continue hashBytesHelp;
			} else {
				if (isLast) {
					return A2(
						$folkertdev$elm_sha2$Internal$SHA256$hashChunks,
						A2($folkertdev$elm_sha2$Internal$SHA256$padBuffer, fullSize, bytes),
						state);
				} else {
					return A2($folkertdev$elm_sha2$Internal$SHA256$hashChunks, bytes, state);
				}
			}
		}
	});
var $folkertdev$elm_sha2$Internal$SHA256$hashBytes = F2(
	function (state, bytes) {
		var _v0 = A4(
			$folkertdev$elm_sha2$Internal$SHA256$hashBytesHelp,
			$elm$bytes$Bytes$width(bytes),
			true,
			bytes,
			state);
		var _v1 = _v0;
		var a = _v1.a;
		var b = _v1.b;
		var c = _v1.c;
		var d = _v1.d;
		var e = _v1.e;
		var f = _v1.f;
		var g = _v1.g;
		var h = _v1.h;
		return A8($folkertdev$elm_sha2$Internal$SHA256$Tuple8, a >>> 0, b >>> 0, c >>> 0, d >>> 0, e >>> 0, f >>> 0, g >>> 0, h >>> 0);
	});
var $folkertdev$elm_sha2$Internal$SHA256$fromString = function (state) {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$folkertdev$elm_sha2$Internal$SHA256$hashBytes(state),
			$elm$bytes$Bytes$Encode$encode),
		$elm$bytes$Bytes$Encode$string);
};
var $folkertdev$elm_sha2$SHA256$initialState = A8($folkertdev$elm_sha2$Internal$SHA256$Tuple8, 1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225);
var $folkertdev$elm_sha2$SHA256$fromString = $folkertdev$elm_sha2$Internal$SHA256$fromString($folkertdev$elm_sha2$SHA256$initialState);
var $folkertdev$elm_sha2$SHA256$toEncoder = function (_v0) {
	var _v1 = _v0;
	var a = _v1.a;
	var b = _v1.b;
	var c = _v1.c;
	var d = _v1.d;
	var e = _v1.e;
	var f = _v1.f;
	var g = _v1.g;
	var h = _v1.h;
	return $elm$bytes$Bytes$Encode$sequence(
		_List_fromArray(
			[
				A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, a),
				A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, b),
				A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, c),
				A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, d),
				A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, e),
				A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, f),
				A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, g),
				A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, h)
			]));
};
var $folkertdev$elm_sha2$SHA256$toBytes = A2($elm$core$Basics$composeL, $elm$bytes$Bytes$Encode$encode, $folkertdev$elm_sha2$SHA256$toEncoder);
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$mkCodeChallenge = A2(
	$elm$core$Basics$composeR,
	$truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$codeVerifierToString,
	A2(
		$elm$core$Basics$composeR,
		$folkertdev$elm_sha2$SHA256$fromString,
		A2(
			$elm$core$Basics$composeR,
			$folkertdev$elm_sha2$SHA256$toBytes,
			A2($elm$core$Basics$composeR, $chelovek0v$bbase64$Base64$Encode$bytes, $elm$core$Basics$identity))));
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.Gy;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.zY,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.eI,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.FX,
					_Utils_ap(http, url.d2)),
				url.E6)));
};
var $author$project$Components$Socle$Session$Model$depart = F6(
	function (configuration, origine, page, espace, action, octets) {
		return (_Utils_cmp(
			$elm$core$List$length(octets),
			$author$project$Components$Socle$Session$Model$octetsDemandes) < 0) ? $elm$core$Maybe$Nothing : A4(
			$elm$core$Maybe$map3,
			F3(
				function (codeVerifier, autorisation, retour) {
					var state = $author$project$Components$Socle$Session$Model$hexadecimal(
						A2(
							$elm$core$List$take,
							$author$project$Components$Socle$Session$Model$octetsDuState,
							A2($elm$core$List$drop, $author$project$Components$Socle$Session$Model$octetsDuVerifier, octets)));
					return {
						jd: $elm$url$Url$toString(
							A2(
								$author$project$Components$Socle$Session$Model$demanderLAction,
								action,
								$truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$makeAuthorizationUrl(
									{
										jW: configuration.jW,
										vy: $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$mkCodeChallenge(codeVerifier),
										G9: retour,
										Is: A2(
											$elm$core$List$cons,
											'openid',
											A2(
												$elm$core$Maybe$withDefault,
												_List_Nil,
												A2(
													$elm$core$Maybe$map,
													function (a) {
														return _List_fromArray(
															[
																$author$project$Components$Socle$Session$Model$scopeDeLEspace(a)
															]);
													},
													espace))),
										e3: $elm$core$Maybe$Just(state),
										aQ: autorisation
									}))),
						ex: {
							fs: A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.Dj;
								},
								action),
							vB: $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$codeVerifierToString(codeVerifier),
							yz: espace,
							qx: A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.qx;
								},
								action),
							qL: page,
							e3: state
						}
					};
				}),
			$truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$codeVerifierFromBytes(
				$elm$bytes$Bytes$Encode$encode(
					$elm$bytes$Bytes$Encode$sequence(
						A2(
							$elm$core$List$map,
							$elm$bytes$Bytes$Encode$unsignedInt8,
							A2($elm$core$List$take, $author$project$Components$Socle$Session$Model$octetsDuVerifier, octets))))),
			$elm$url$Url$fromString(
				A2($author$project$Components$Socle$Session$Model$pointDuRealm, configuration, 'auth')),
			$elm$url$Url$fromString(
				$author$project$Components$Socle$Session$Model$adresseDeRetour(origine)));
	});
var $author$project$Components$Socle$Session$Update$partir = F3(
	function (configuration, octets, model) {
		var _v0 = A6($author$project$Components$Socle$Session$Model$depart, configuration, model.o4, model.EE, model.yA, model.fs, octets);
		if (!_v0.$) {
			var depart = _v0.a;
			return _Utils_Tuple2(
				model,
				_List_fromArray(
					[
						$author$project$Components$Socle$Session$Update$PartirVers(
						{aa: depart.jd, ex: depart.ex})
					]));
		} else {
			return A2($author$project$Components$Socle$Session$Update$enErreur, $author$project$Components$Socle$Session$Model$AleaInsuffisant, model);
		}
	});
var $author$project$Components$Socle$Session$Update$LirePreferences = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Socle$Session$Model$RacineIllisible = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Socle$Session$Update$LireEspaces = function (a) {
	return {$: 5, a: a};
};
var $author$project$API$NavLinksDictionary$espaces = 'espaces';
var $author$project$Components$Socle$Session$Update$lireLesEspaces = F3(
	function (configuration, jeton, liens) {
		return A2(
			$elm$core$Maybe$map,
			function (lien) {
				var _v0 = A2($author$project$Components$Socle$Session$Model$adresseSurLApi, configuration, lien.cM);
				if (!_v0.$) {
					var url = _v0.a;
					return _List_fromArray(
						[
							$author$project$Components$Socle$Session$Update$LireEspaces(
							{gM: jeton, aQ: url})
						]);
				} else {
					return _List_fromArray(
						[
							$author$project$Components$Socle$Session$Update$Signaler(
							$author$project$Components$Socle$Session$Model$LienHorsDeLApi(lien.eP))
						]);
				}
			},
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$espaces, liens));
	});
var $author$project$API$NavLinksDictionary$monComptePreferences = 'mon-compte-preferences';
var $author$project$Components$Socle$Session$Model$CompteInconnu = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Socle$Session$Model$JetonRefuse = {$: 5};
var $author$project$Components$Socle$Session$Update$compteInconnu = 'CompteInconnu';
var $author$project$Components$Socle$Session$Update$refuserLaRacine = F3(
	function (reponse, identite, model) {
		return (reponse.ri === 401) ? A2($author$project$Components$Socle$Session$Update$enErreur, $author$project$Components$Socle$Session$Model$JetonRefuse, model) : (((reponse.ri === 403) && A2(
			$elm$core$List$member,
			$author$project$Components$Socle$Session$Update$compteInconnu,
			$author$project$Components$Socle$Session$API$QueryAPIModel$codesDErreur(reponse.f$))) ? A2(
			$author$project$Components$Socle$Session$Update$enErreur,
			$author$project$Components$Socle$Session$Model$CompteInconnu(identite),
			model) : _Utils_Tuple2(
			model,
			_List_fromArray(
				[
					$author$project$Components$Socle$Session$Update$Signaler(
					$author$project$Components$Socle$Session$Model$RacineIllisible(reponse.ri))
				])));
	});
var $author$project$Components$Socle$Session$Update$repartir = F2(
	function (espace, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{yA: espace, gt: $author$project$Components$Socle$Session$Model$Inconnue, GQ: $elm$core$Maybe$Nothing}),
			_List_fromArray(
				[
					$author$project$Components$Socle$Session$Update$DemanderAlea($author$project$Components$Socle$Session$Model$octetsDemandes)
				]));
	});
var $author$project$Components$Socle$Session$Update$renouveler = F3(
	function (configuration, connexion, model) {
		var _v0 = model.GQ;
		if (!_v0.$) {
			var rafraichissement = _v0.a;
			return rafraichissement.yj ? _Utils_Tuple2(model, _List_Nil) : A4($author$project$Components$Socle$Session$Update$demanderLeRenouvellement, configuration, connexion, rafraichissement, model);
		} else {
			return A2(
				$author$project$Components$Socle$Session$Update$repartir,
				$author$project$Components$Socle$Session$Update$espaceDuJeton(connexion.En),
				model);
		}
	});
var $author$project$Components$Socle$Session$Update$recevoirLaRacine = F4(
	function (configuration, reponse, connexion, model) {
		if ((reponse.ri >= 200) && (reponse.ri < 300)) {
			var _v0 = A2($elm$json$Json$Decode$decodeString, $author$project$API$Liens$deLaRessource, reponse.f$);
			if (!_v0.$) {
				var liens = _v0.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gt: $author$project$Components$Socle$Session$Model$Connectee(
								_Utils_update(
									connexion,
									{
										yl: A2(
											$elm$core$Result$withDefault,
											false,
											A2(
												$elm$json$Json$Decode$decodeString,
												A2($elm$json$Json$Decode$field, 'enPreparation', $elm$json$Json$Decode$bool),
												reponse.f$)),
										gF: liens.gF,
										nQ: liens.h0,
										g5: A2(
											$elm$core$Maybe$andThen,
											$elm$core$Basics$identity,
											$elm$core$Result$toMaybe(
												A2(
													$elm$json$Json$Decode$decodeString,
													$elm$json$Json$Decode$maybe(
														A2($elm$json$Json$Decode$field, 'nomDuClient', $elm$json$Json$Decode$string)),
													reponse.f$))),
										GO: true
									}))
						}),
					_Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A3($author$project$Components$Socle$Session$Update$lire, configuration, connexion, $author$project$Components$Socle$Session$Update$LirePreferences),
								A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$monComptePreferences, liens.h0))),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A3($author$project$Components$Socle$Session$Update$lireLesEspaces, configuration, connexion.ce, liens.h0))));
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gt: $author$project$Components$Socle$Session$Model$Connectee(
								_Utils_update(
									connexion,
									{gF: _List_Nil, nQ: _List_Nil, GO: true}))
						}),
					_List_fromArray(
						[
							$author$project$Components$Socle$Session$Update$Signaler(
							$author$project$Components$Socle$Session$Model$RacineIllisible(reponse.ri))
						]));
			}
		} else {
			if ((reponse.ri === 401) && connexion.GO) {
				return A3($author$project$Components$Socle$Session$Update$renouveler, configuration, connexion, model);
			} else {
				return A3($author$project$Components$Socle$Session$Update$refuserLaRacine, reponse, connexion.Av, model);
			}
		}
	});
var $author$project$Components$Socle$Session$Update$recevoirLaRacineSansEspace = F4(
	function (configuration, reponse, choix, model) {
		if ((reponse.ri >= 200) && (reponse.ri < 300)) {
			var _v0 = A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.h0;
					},
					A2($author$project$Components$Socle$Session$Update$lireLesEspaces, configuration, choix.ce)),
				$elm$core$Result$toMaybe(
					A2($elm$json$Json$Decode$decodeString, $author$project$API$Liens$deLaRessource, reponse.f$)));
			if (!_v0.$) {
				var effets = _v0.a;
				return _Utils_Tuple2(model, effets);
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gt: $author$project$Components$Socle$Session$Model$EnErreur($author$project$Components$Socle$Session$Model$EspaceIndisponible)
						}),
					_List_fromArray(
						[
							$author$project$Components$Socle$Session$Update$Signaler(
							$author$project$Components$Socle$Session$Model$RacineIllisible(reponse.ri))
						]));
			}
		} else {
			return A3($author$project$Components$Socle$Session$Update$refuserLaRacine, reponse, choix.Av, model);
		}
	});
var $author$project$Components$Socle$Session$Update$recevoirLeRenouvellement = F4(
	function (configuration, reponse, connexion, model) {
		var _v0 = _Utils_Tuple2(reponse, model.GQ);
		_v0$4:
		while (true) {
			if (!_v0.a.$) {
				if (!_v0.b.$) {
					var corps = _v0.a.a;
					var ancien = _v0.b.a;
					var _v1 = $author$project$Components$Socle$Session$API$QueryAPIModel$lireRafraichissement(corps);
					if (!_v1.$) {
						var lu = _v1.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									gt: $author$project$Components$Socle$Session$Model$Connectee(
										_Utils_update(
											connexion,
											{ce: lu.ce})),
									GQ: $elm$core$Maybe$Just(
										{
											lG: lu.lG,
											xY: $elm$core$Maybe$Nothing,
											yj: false,
											gM: A2($elm$core$Maybe$withDefault, ancien.gM, lu.gM)
										})
								}),
							_List_fromArray(
								[$author$project$Components$Socle$Session$Update$LireLHeure]));
					} else {
						return A2(
							$author$project$Components$Socle$Session$Update$repartir,
							$author$project$Components$Socle$Session$Update$espaceDuJeton(connexion.En),
							model);
					}
				} else {
					break _v0$4;
				}
			} else {
				switch (_v0.a.a.$) {
					case 3:
						return A2(
							$author$project$Components$Socle$Session$Update$repartir,
							$author$project$Components$Socle$Session$Update$espaceDuJeton(connexion.En),
							model);
					case 4:
						return A2(
							$author$project$Components$Socle$Session$Update$repartir,
							$author$project$Components$Socle$Session$Update$espaceDuJeton(connexion.En),
							model);
					default:
						if (!_v0.b.$) {
							var ancien = _v0.b.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										GQ: $elm$core$Maybe$Just(
											_Utils_update(
												ancien,
												{yj: false}))
									}),
								_List_Nil);
						} else {
							break _v0$4;
						}
				}
			}
		}
		return _Utils_Tuple2(model, _List_Nil);
	});
var $author$project$Components$Socle$Session$Model$EspacesIllisibles = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Socle$Session$Model$Espace = F4(
	function (alias, nom, logo, actif) {
		return {sO: actif, td: alias, n$: logo, Dj: nom};
	});
var $author$project$Components$Socle$Vocabulaire$espaceActif = 'actif';
var $author$project$Components$Socle$Session$API$QueryAPIModel$espace = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Components$Socle$Session$Model$Espace,
	A2($elm$json$Json$Decode$field, 'alias', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'logo',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			])),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Basics$eq($author$project$Components$Socle$Vocabulaire$espaceActif),
		A2($elm$json$Json$Decode$field, 'etat', $elm$json$Json$Decode$string)));
var $author$project$Components$Socle$Session$API$QueryAPIModel$lireEspaces = function (corps) {
	return $elm$core$Result$toMaybe(
		A2(
			$elm$json$Json$Decode$decodeString,
			A2(
				$elm$json$Json$Decode$field,
				'espaces',
				$elm$json$Json$Decode$list($author$project$Components$Socle$Session$API$QueryAPIModel$espace)),
			corps));
};
var $author$project$Components$Socle$Session$Update$espacesLus = function (reponse) {
	return ((reponse.ri >= 200) && (reponse.ri < 300)) ? $author$project$Components$Socle$Session$API$QueryAPIModel$lireEspaces(reponse.f$) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$Socle$Session$Update$recevoirLesEspaces = F3(
	function (reponse, connexion, model) {
		var _v0 = $author$project$Components$Socle$Session$Update$espacesLus(reponse);
		if (!_v0.$) {
			var espaces = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						gt: $author$project$Components$Socle$Session$Model$Connectee(
							_Utils_update(
								connexion,
								{yC: espaces}))
					}),
				_List_Nil);
		} else {
			return _Utils_Tuple2(
				model,
				_List_fromArray(
					[
						$author$project$Components$Socle$Session$Update$Signaler(
						$author$project$Components$Socle$Session$Model$EspacesIllisibles(reponse.ri))
					]));
		}
	});
var $author$project$Components$Socle$Session$Update$recevoirLesEspacesAChoisir = F3(
	function (reponse, choix, model) {
		var _v0 = $author$project$Components$Socle$Session$Update$espacesLus(reponse);
		if (!_v0.$) {
			var espaces = _v0.a;
			var _v1 = A2(
				$elm$core$List$filter,
				function ($) {
					return $.sO;
				},
				espaces);
			if (_v1.b && (!_v1.b.b)) {
				var seul = _v1.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							yA: $elm$core$Maybe$Just(seul.td),
							gt: $author$project$Components$Socle$Session$Model$Inconnue
						}),
					_List_fromArray(
						[
							$author$project$Components$Socle$Session$Update$DemanderAlea($author$project$Components$Socle$Session$Model$octetsDemandes)
						]));
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gt: $author$project$Components$Socle$Session$Model$AChoisir(
								_Utils_update(
									choix,
									{
										yC: $elm$core$Maybe$Just(espaces)
									}))
						}),
					_List_Nil);
			}
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						gt: $author$project$Components$Socle$Session$Model$EnErreur($author$project$Components$Socle$Session$Model$EspaceIndisponible)
					}),
				_List_fromArray(
					[
						$author$project$Components$Socle$Session$Update$Signaler(
						$author$project$Components$Socle$Session$Model$EspacesIllisibles(reponse.ri))
					]));
		}
	});
var $author$project$Components$Socle$Session$Model$PreferencesIllisibles = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Socle$Session$Update$langueDesPreferences = $elm$json$Json$Decode$maybe(
	A2($elm$json$Json$Decode$field, 'langue', $elm$json$Json$Decode$string));
var $author$project$Components$Socle$Session$Update$recevoirLesPreferences = F4(
	function (configuration, reponse, connexion, model) {
		var _v0 = _Utils_Tuple2(
			(reponse.ri >= 200) && (reponse.ri < 300),
			A2($elm$json$Json$Decode$decodeString, $author$project$Components$Socle$Session$Update$langueDesPreferences, reponse.f$));
		if (_v0.a && (!_v0.b.$)) {
			var langue = _v0.b.a;
			return A4(
				$author$project$Components$Socle$Session$Update$choisirLaLangue,
				configuration,
				A2($elm$core$Maybe$withDefault, $author$project$Components$Socle$Session$Update$francais, langue),
				connexion,
				model);
		} else {
			return _Utils_Tuple2(
				model,
				_List_fromArray(
					[
						$author$project$Components$Socle$Session$Update$Signaler(
						$author$project$Components$Socle$Session$Model$PreferencesIllisibles(reponse.ri))
					]));
		}
	});
var $author$project$Components$Socle$Session$Model$TraductionsIllisibles = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$I18n$Traductions$ajouter = F3(
	function (cle, lu, libelles) {
		var _v0 = A4(
			$author$project$I18n$Traductions$segments,
			false,
			$elm$core$String$toList(lu),
			'',
			_List_Nil);
		if ((!_v0.$) && (!_v0.a.b.b)) {
			var _v1 = _v0.a;
			var lus = _v1.a;
			return A3($elm$core$Dict$insert, cle, lus, libelles);
		} else {
			return libelles;
		}
	});
var $author$project$I18n$Nombre$En = 1;
var $author$project$I18n$Traductions$langueDecoder = function (code) {
	switch (code) {
		case 'fr':
			return $elm$json$Json$Decode$succeed(0);
		case 'en':
			return $elm$json$Json$Decode$succeed(1);
		default:
			return $elm$json$Json$Decode$fail(code);
	}
};
var $author$project$I18n$Traductions$decoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (lue, libelles) {
			return A2(
				$author$project$I18n$Traductions$Traductions,
				lue,
				A3($elm$core$Dict$foldl, $author$project$I18n$Traductions$ajouter, $elm$core$Dict$empty, libelles));
		}),
	A2(
		$elm$json$Json$Decode$andThen,
		$author$project$I18n$Traductions$langueDecoder,
		A2($elm$json$Json$Decode$field, 'langue', $elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$field,
		'libelles',
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)));
var $author$project$Components$Socle$Session$Update$recevoirLesTraductions = F3(
	function (langue, reponse, model) {
		var _v0 = _Utils_Tuple2(
			(reponse.ri >= 200) && (reponse.ri < 300),
			A2($elm$json$Json$Decode$decodeString, $author$project$I18n$Traductions$decoder, reponse.f$));
		if (_v0.a && (!_v0.b.$)) {
			var traductions = _v0.b.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{JL: traductions}),
				_List_Nil);
		} else {
			return _Utils_Tuple2(
				model,
				_List_fromArray(
					[
						$author$project$Components$Socle$Session$Update$Signaler(
						A2($author$project$Components$Socle$Session$Model$TraductionsIllisibles, langue, reponse.ri))
					]));
		}
	});
var $author$project$Components$Socle$Session$Model$reconnexionDuRealm = F3(
	function (configuration, lien, geste) {
		return A2(
			$elm$core$Maybe$andThen,
			function (parametres) {
				return A2(
					$elm$core$Maybe$map,
					function (_v0) {
						return {
							Dj: $elm$core$Maybe$Nothing,
							EX: A2(
								$elm$core$List$filter,
								$elm$core$String$startsWith('max_age='),
								parametres),
							qx: $elm$core$Maybe$Just(geste)
						};
					},
					A2($author$project$API$Liens$parametre, 'max_age', lien));
			},
			A2($author$project$Components$Socle$Session$Model$parametresDuRealm, configuration, lien));
	});
var $author$project$Components$Socle$Session$Update$update = F2(
	function (msg, model) {
		var _v0 = _Utils_Tuple3(msg, model.gt, model.v1);
		_v0$27:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if ((!_v0.b.$) && (!_v0.c.$)) {
						var octets = _v0.a.a;
						var _v1 = _v0.b;
						var configuration = _v0.c.a;
						return A3($author$project$Components$Socle$Session$Update$partir, configuration, octets, model);
					} else {
						break _v0$27;
					}
				case 1:
					if (!_v0.a.a.$) {
						if ((!_v0.b.$) && (!_v0.c.$)) {
							var corps = _v0.a.a.a;
							var _v2 = _v0.b;
							var configuration = _v0.c.a;
							return A3($author$project$Components$Socle$Session$Update$ouvrir, configuration, corps, model);
						} else {
							break _v0$27;
						}
					} else {
						if (!_v0.b.$) {
							var _v3 = _v0.b;
							return A2($author$project$Components$Socle$Session$Update$echouerAuRetour, $author$project$Components$Socle$Session$Model$EchangeRefuse, model);
						} else {
							break _v0$27;
						}
					}
				case 15:
					if ((_v0.b.$ === 1) && (!_v0.c.$)) {
						var maintenant = _v0.a.a;
						var connexion = _v0.b.a;
						var configuration = _v0.c.a;
						return A4($author$project$Components$Socle$Session$Update$lireLHeure, configuration, maintenant, connexion, model);
					} else {
						break _v0$27;
					}
				case 16:
					if (_v0.a.a && (_v0.b.$ === 1)) {
						return _Utils_Tuple2(
							model,
							_List_fromArray(
								[$author$project$Components$Socle$Session$Update$LireLHeure]));
					} else {
						break _v0$27;
					}
				case 17:
					if ((_v0.b.$ === 1) && (!_v0.c.$)) {
						var reponse = _v0.a.a;
						var connexion = _v0.b.a;
						var configuration = _v0.c.a;
						return A4($author$project$Components$Socle$Session$Update$recevoirLeRenouvellement, configuration, reponse, connexion, model);
					} else {
						break _v0$27;
					}
				case 5:
					if ((_v0.b.$ === 1) && (!_v0.c.$)) {
						var reponse = _v0.a.a;
						var connexion = _v0.b.a;
						var configuration = _v0.c.a;
						return A4($author$project$Components$Socle$Session$Update$recevoirLesPreferences, configuration, reponse, connexion, model);
					} else {
						break _v0$27;
					}
				case 6:
					if ((_v0.b.$ === 1) && (!_v0.c.$)) {
						var langue = _v0.a.a;
						var connexion = _v0.b.a;
						var configuration = _v0.c.a;
						return A4($author$project$Components$Socle$Session$Update$choisirLaLangue, configuration, langue, connexion, model);
					} else {
						break _v0$27;
					}
				case 7:
					if (_v0.b.$ === 1) {
						var _v4 = _v0.a;
						var langue = _v4.a;
						var reponse = _v4.b;
						return A3($author$project$Components$Socle$Session$Update$recevoirLesTraductions, langue, reponse, model);
					} else {
						break _v0$27;
					}
				case 2:
					if (!_v0.c.$) {
						switch (_v0.b.$) {
							case 1:
								var reponse = _v0.a.a;
								var connexion = _v0.b.a;
								var configuration = _v0.c.a;
								return A4($author$project$Components$Socle$Session$Update$recevoirLaRacine, configuration, reponse, connexion, model);
							case 2:
								var reponse = _v0.a.a;
								var choix = _v0.b.a;
								var configuration = _v0.c.a;
								return A4($author$project$Components$Socle$Session$Update$recevoirLaRacineSansEspace, configuration, reponse, choix, model);
							default:
								break _v0$27;
						}
					} else {
						break _v0$27;
					}
				case 3:
					switch (_v0.b.$) {
						case 2:
							var reponse = _v0.a.a;
							var choix = _v0.b.a;
							return A3($author$project$Components$Socle$Session$Update$recevoirLesEspacesAChoisir, reponse, choix, model);
						case 1:
							var reponse = _v0.a.a;
							var connexion = _v0.b.a;
							return A3($author$project$Components$Socle$Session$Update$recevoirLesEspaces, reponse, connexion, model);
						default:
							break _v0$27;
					}
				case 4:
					switch (_v0.b.$) {
						case 2:
							var alias = _v0.a.a;
							return A3($author$project$Components$Socle$Session$Update$choisir, alias, model.EE, model);
						case 1:
							var alias = _v0.a.a;
							return A3($author$project$Components$Socle$Session$Update$choisir, alias, $author$project$Routes$Route$adresseAccueil, model);
						default:
							break _v0$27;
					}
				case 9:
					if (!_v0.c.$) {
						switch (_v0.b.$) {
							case 1:
								var _v5 = _v0.a;
								var connexion = _v0.b.a;
								var configuration = _v0.c.a;
								return A3($author$project$Components$Socle$Session$Update$deconnecter, configuration, connexion.Av, model);
							case 4:
								switch (_v0.b.a.$) {
									case 7:
										var _v6 = _v0.a;
										var identite = _v0.b.a.a;
										var configuration = _v0.c.a;
										return A3($author$project$Components$Socle$Session$Update$deconnecter, configuration, identite, model);
									case 8:
										var _v7 = _v0.a;
										var desactive = _v0.b.a.a;
										var configuration = _v0.c.a;
										return A3($author$project$Components$Socle$Session$Update$deconnecter, configuration, desactive.Av, model);
									default:
										break _v0$27;
								}
							case 2:
								var _v8 = _v0.a;
								var choix = _v0.b.a;
								var configuration = _v0.c.a;
								return A3($author$project$Components$Socle$Session$Update$deconnecter, configuration, choix.Av, model);
							default:
								break _v0$27;
						}
					} else {
						break _v0$27;
					}
				case 13:
					if (_v0.b.$ === 1) {
						var espace = _v0.a.a;
						var connexion = _v0.b.a;
						return A2(
							$author$project$Components$Socle$Session$Update$enErreur,
							A2($author$project$Components$Socle$Session$Update$desactiveDans, espace, connexion),
							model);
					} else {
						break _v0$27;
					}
				case 14:
					if ((_v0.b.$ === 4) && (_v0.b.a.$ === 8)) {
						var _v9 = _v0.a;
						return A2(
							$author$project$Components$Socle$Session$Update$repartir,
							$elm$core$Maybe$Nothing,
							_Utils_update(
								model,
								{EE: $author$project$Routes$Route$adresseAccueil}));
					} else {
						break _v0$27;
					}
				case 8:
					var url = _v0.a.a;
					return A2($author$project$Components$Socle$Session$Update$demarrer, model, url);
				case 10:
					switch (_v0.b.$) {
						case 1:
							if (!_v0.c.$) {
								var _v10 = _v0.a;
								var connexion = _v0.b.a;
								var configuration = _v0.c.a;
								return A3($author$project$Components$Socle$Session$Update$renouveler, configuration, connexion, model);
							} else {
								var _v11 = _v0.a;
								var connexion = _v0.b.a;
								return A2(
									$author$project$Components$Socle$Session$Update$repartir,
									$author$project$Components$Socle$Session$Update$espaceDuJeton(connexion.En),
									model);
							}
						case 2:
							var _v12 = _v0.a;
							return A2($author$project$Components$Socle$Session$Update$repartir, $elm$core$Maybe$Nothing, model);
						default:
							break _v0$27;
					}
				case 11:
					if ((_v0.b.$ === 1) && (!_v0.c.$)) {
						var lien = _v0.a.a;
						var connexion = _v0.b.a;
						var configuration = _v0.c.a;
						var _v13 = A2($author$project$Components$Socle$Session$Model$actionDuRealm, configuration, lien);
						if (!_v13.$) {
							var action = _v13.a;
							return A2(
								$author$project$Components$Socle$Session$Update$repartir,
								$author$project$Components$Socle$Session$Update$espaceDuJeton(connexion.En),
								_Utils_update(
									model,
									{
										fs: $elm$core$Maybe$Just(action)
									}));
						} else {
							return _Utils_Tuple2(
								model,
								_List_fromArray(
									[
										$author$project$Components$Socle$Session$Update$Signaler(
										$author$project$Components$Socle$Session$Model$ActionHorsDuRealm(lien.eP))
									]));
						}
					} else {
						break _v0$27;
					}
				default:
					if ((_v0.b.$ === 1) && (!_v0.c.$)) {
						var _v14 = _v0.a;
						var lien = _v14.a;
						var geste = _v14.b;
						var connexion = _v0.b.a;
						var configuration = _v0.c.a;
						var _v15 = A3($author$project$Components$Socle$Session$Model$reconnexionDuRealm, configuration, lien, geste);
						if (!_v15.$) {
							var reconnexion = _v15.a;
							return A2(
								$author$project$Components$Socle$Session$Update$repartir,
								$author$project$Components$Socle$Session$Update$espaceDuJeton(connexion.En),
								_Utils_update(
									model,
									{
										fs: $elm$core$Maybe$Just(reconnexion)
									}));
						} else {
							return _Utils_Tuple2(
								model,
								_List_fromArray(
									[
										$author$project$Components$Socle$Session$Update$Signaler(
										$author$project$Components$Socle$Session$Model$ActionHorsDuRealm(lien.eP))
									]));
						}
					} else {
						break _v0$27;
					}
			}
		}
		return _Utils_Tuple2(model, _List_Nil);
	});
var $author$project$Main$Update$versLaSession = F2(
	function (msg, model) {
		var _v0 = A2($author$project$Components$Socle$Session$Update$update, msg, model.e1);
		var session = _v0.a;
		var effets = _v0.b;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLaSession,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						ta: _Utils_ap(
							model.ta,
							$author$project$Main$Update$aleaDeLaSession(effets)),
						e1: session
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$depuisLesFormes = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[54]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 1:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesFormes)));
			case 3:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerAuxFormes(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 2:
				var delaiMs = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AttendreAvantDeRelireLesFormes(delaiMs)
							])));
			case 4:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Referentiel$Formes$API$WriteAPIErrorsModel$FormeArchivee = 1;
var $author$project$Components$Referentiel$Formes$API$WriteAPIErrorsModel$FormeIntrouvable = 2;
var $author$project$Components$Referentiel$Formes$API$WriteAPIErrorsModel$LibelleDejaUtilise = 0;
var $author$project$Components$Referentiel$Formes$API$WriteAPIErrorsModel$AccesRefuse = 3;
var $author$project$Components$Referentiel$Formes$API$WriteAPIErrorsModel$AutreRefus = 4;
var $author$project$Components$Referentiel$Formes$API$WriteAPIErrorsModel$duRefus = function (reponse) {
	if (reponse.ri === 403) {
		return 3;
	} else {
		if (reponse.ri === 404) {
			return 2;
		} else {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeString,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['error']),
					$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value)),
				reponse.f$);
			_v0$2:
			while (true) {
				if ((!_v0.$) && _v0.a.b) {
					switch (_v0.a.a.a) {
						case 'LibelleDejaUtilise':
							var _v1 = _v0.a;
							var _v2 = _v1.a;
							return 0;
						case 'FormeEstArchivee':
							var _v3 = _v0.a;
							var _v4 = _v3.a;
							return 1;
						default:
							break _v0$2;
					}
				} else {
					break _v0$2;
				}
			}
			return 4;
		}
	}
};
var $author$project$Components$Referentiel$Formes$Update$duRefus = function (resultat) {
	if (resultat.$ === 1) {
		var refus = resultat.a;
		return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Components$Shared$Messages$Model$duRefus(refus));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Formes$API$QueryAPIModel$Liste = F2(
	function (formes, liens) {
		return {zS: formes, nQ: liens};
	});
var $author$project$Components$Referentiel$Formes$API$QueryAPIModel$Forme = F5(
	function (id, libelles, archivee, fiches, liens) {
		return {tI: archivee, zu: fiches, Aq: id, R: libelles, nQ: liens};
	});
var $author$project$Components$Referentiel$Identifiants$FormeUid = $elm$core$Basics$identity;
var $author$project$Components$Referentiel$Identifiants$formeUidDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Components$Referentiel$Formes$API$QueryAPIModel$Libelles = F2(
	function (fr, en) {
		return {yg: en, zX: fr};
	});
var $author$project$Components$Referentiel$Formes$API$QueryAPIModel$libellesDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'en',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'fr',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Formes$API$QueryAPIModel$Libelles)));
var $author$project$Components$Referentiel$Formes$API$QueryAPIModel$formeDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'fiches',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'archivee',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'libelles',
				$author$project$Components$Referentiel$Formes$API$QueryAPIModel$libellesDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'uid',
					$author$project$Components$Referentiel$Identifiants$formeUidDecoder,
					$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Formes$API$QueryAPIModel$Forme))))));
var $author$project$Components$Referentiel$Formes$API$QueryAPIModel$listeDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'formes',
		$elm$json$Json$Decode$list($author$project$Components$Referentiel$Formes$API$QueryAPIModel$formeDecoder),
		$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Formes$API$QueryAPIModel$Liste)));
var $author$project$Components$Referentiel$Formes$Update$popMessages = function (msg) {
	switch (msg.$) {
		case 2:
			var reponse = msg.a;
			return $author$project$Components$Referentiel$Formes$Update$duRefus(
				A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Formes$API$QueryAPIModel$listeDecoder, reponse));
		case 13:
			var reponse = msg.a;
			return A2(
				$elm$core$List$member,
				$author$project$Components$Referentiel$Formes$API$WriteAPIErrorsModel$duRefus(reponse),
				_List_fromArray(
					[0, 1, 2])) ? $elm$core$Maybe$Nothing : $author$project$Components$Referentiel$Formes$Update$duRefus(
				A2(
					$author$project$API$Reponse$lire,
					$elm$json$Json$Decode$succeed(0),
					reponse));
		case 1:
			var octets = msg.a;
			return _Utils_eq(
				$author$project$API$ProcessUid$depuisOctets(octets),
				$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
				{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Main$Update$remonter = F2(
	function (message, affiches) {
		return A2(
			$elm$core$Maybe$withDefault,
			affiches,
			A2($elm$core$Maybe$map, $elm$core$List$singleton, message));
	});
var $author$project$Main$Update$requeteSurLesFormes = function (effet) {
	switch (effet.$) {
		case 1:
			return true;
		case 3:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Referentiel$Formes$API$WriteAPIModel$ArchiverLaForme = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Formes$Update$DemanderProcessUid = {$: 0};
var $author$project$Components$Referentiel$Formes$Update$Lire = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Formes$Model$OuvrirNom = {$: 2};
var $author$project$Components$Referentiel$Formes$Update$Reconnecter = {$: 5};
var $author$project$Components$Referentiel$Formes$API$WriteAPIModel$RestaurerLaForme = function (a) {
	return {$: 3, a: a};
};
var $author$project$API$NavLinksDictionary$archiverLaForme = 'archiver-forme';
var $author$project$API$NavLinksDictionary$avecLesArchives = 'avec-les-archives';
var $author$project$Components$Referentiel$Formes$Update$AttendreAvantDeRelire = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Formes$Model$Doublon = {$: 0};
var $author$project$Components$Referentiel$Formes$Model$Libre = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Formes$Model$idDuNom = 'forme-nom';
var $author$project$Components$Referentiel$Formes$Model$retireLeDoublon = function (refus) {
	return _Utils_eq(
		refus,
		$elm$core$Maybe$Just($author$project$Components$Referentiel$Formes$Model$Doublon)) ? $elm$core$Maybe$Nothing : refus;
};
var $author$project$Components$Referentiel$Formes$Model$saisir = F2(
	function (champ, saisie) {
		switch (champ.$) {
			case 0:
				var texte = champ.a;
				return _Utils_update(
					saisie,
					{
						zX: texte,
						pZ: $author$project$Components$Referentiel$Formes$Model$retireLeDoublon(saisie.pZ)
					});
			case 1:
				var texte = champ.a;
				return _Utils_update(
					saisie,
					{
						yg: texte,
						pZ: $author$project$Components$Referentiel$Formes$Model$retireLeDoublon(saisie.pZ)
					});
			default:
				return _Utils_update(
					saisie,
					{bO: true});
		}
	});
var $author$project$Components$Referentiel$Formes$Update$PlacerFocus = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Referentiel$Formes$Update$versLesNoms = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				var saisie = model.hP;
				return _Utils_update(
					model,
					{
						DG: drawer,
						hP: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? saisie : _Utils_update(
							saisie,
							{bO: false})
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Referentiel$Formes$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.DG));
	});
var $author$project$Components$Referentiel$Formes$Update$doublonAuRenommage = function (model) {
	var saisie = model.hP;
	return A2(
		$author$project$Components$Referentiel$Formes$Update$versLesNoms,
		$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Referentiel$Formes$Model$idDuNom),
		_Utils_update(
			model,
			{
				hP: A2(
					$author$project$Components$Referentiel$Formes$Model$saisir,
					$author$project$Components$Referentiel$Formes$Model$OuvrirNom,
					_Utils_update(
						saisie,
						{
							pZ: $elm$core$Maybe$Just($author$project$Components$Referentiel$Formes$Model$Doublon)
						}))
			}));
};
var $author$project$I18n$Textes$formeRefusAcces = A3($author$project$I18n$Traductions$texte, 'forme.refus.acces', _List_Nil, 'Vous n\'avez pas le droit de paramétrer les formes.');
var $author$project$I18n$Textes$formeRefusArchive = A3($author$project$I18n$Traductions$texte, 'forme.refus.archive', _List_Nil, 'Cette forme est archivée : elle ne se renomme plus. Restaurez-la d\'abord.');
var $author$project$I18n$Textes$formeRefusAutre = A3($author$project$I18n$Traductions$texte, 'forme.refus.autre', _List_Nil, 'L\'enregistrement a échoué. Rien n\'a été modifié.');
var $author$project$I18n$Textes$formeRefusIntrouvable = A3($author$project$I18n$Traductions$texte, 'forme.refus.introuvable', _List_Nil, 'Cette forme n\'existe plus. La liste est relue.');
var $author$project$I18n$Textes$formeRefusRejeu = A3($author$project$I18n$Traductions$texte, 'forme.refus.rejeu', _List_Nil, 'Cette saisie n\'a pas été appliquée : ce geste avait déjà servi à une autre commande.');
var $author$project$Components$Referentiel$Formes$Model$lienDeLecture = function (model) {
	return model.fG ? function (avec) {
		return _Utils_eq(avec, $elm$core$Maybe$Nothing) ? model.np : avec;
	}(
		A2(
			$elm$core$Maybe$andThen,
			function (liste) {
				return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$avecLesArchives, liste.nQ);
			},
			model.nW)) : model.np;
};
var $author$project$Components$Referentiel$Formes$Update$relire = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Formes$Update$Lire, $elm$core$List$singleton),
			$author$project$Components$Referentiel$Formes$Model$lienDeLecture(model)));
};
var $author$project$Components$Referentiel$Formes$Model$Modification = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Formes$Model$saisieDe = function (forme) {
	return {
		yg: A2($elm$core$Maybe$withDefault, '', forme.R.yg),
		zX: forme.R.zX,
		n9: $author$project$Components$Referentiel$Formes$Model$Modification(forme),
		bO: false,
		pZ: $elm$core$Maybe$Nothing,
		b5: false
	};
};
var $author$project$Components$Referentiel$Formes$Model$enCours = function (saisie) {
	var _v0 = saisie.n9;
	if (!_v0.$) {
		return !_Utils_eq(
			_Utils_update(
				saisie,
				{bO: false, pZ: $elm$core$Maybe$Nothing, b5: false}),
			$author$project$Components$Referentiel$Formes$Model$saisieVide);
	} else {
		var forme = _v0.a;
		return !_Utils_eq(
			_Utils_update(
				saisie,
				{bO: false, pZ: $elm$core$Maybe$Nothing, b5: false}),
			$author$project$Components$Referentiel$Formes$Model$saisieDe(forme));
	}
};
var $author$project$Components$Referentiel$Formes$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{kX: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Referentiel$Formes$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Referentiel$Formes$Model$enCours(model.hP)
				},
				geste,
				model.kX));
	});
var $author$project$Components$Referentiel$Formes$Update$conclure = F2(
	function (issue, model) {
		var saisie = model.hP;
		var refuse = function (message) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						hP: _Utils_update(
							saisie,
							{
								pZ: $elm$core$Maybe$Just(
									$author$project$Components$Referentiel$Formes$Model$Libre(message))
							})
					}),
				_List_Nil);
		};
		switch (issue.$) {
			case 0:
				if (issue.c) {
					var rendue = issue.b;
					return A2(
						$elm$core$Tuple$mapSecond,
						function (effets) {
							return _Utils_ap(
								effets,
								rendue.sy ? $author$project$Components$Referentiel$Formes$Update$relire(model) : _List_fromArray(
									[
										$author$project$Components$Referentiel$Formes$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
									]));
						},
						A2(
							$author$project$Components$Referentiel$Formes$Update$versLeDrawer,
							$author$project$Components$Shared$Drawer$Update$Fermer,
							_Utils_update(
								model,
								{hP: $author$project$Components$Referentiel$Formes$Model$saisieVide})));
				} else {
					return A2(
						$elm$core$Tuple$mapSecond,
						function (_v1) {
							return $author$project$Components$Referentiel$Formes$Update$relire(model);
						},
						refuse($author$project$I18n$Textes$formeRefusRejeu));
				}
			case 1:
				switch (issue.c) {
					case 0:
						var _v2 = issue.c;
						var _v3 = saisie.n9;
						if (_v3.$ === 1) {
							return $author$project$Components$Referentiel$Formes$Update$doublonAuRenommage(model);
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										hP: _Utils_update(
											saisie,
											{
												pZ: $elm$core$Maybe$Just($author$project$Components$Referentiel$Formes$Model$Doublon)
											})
									}),
								_List_Nil);
						}
					case 1:
						var _v4 = issue.c;
						return A2(
							$elm$core$Tuple$mapSecond,
							function (_v5) {
								return $author$project$Components$Referentiel$Formes$Update$relire(model);
							},
							refuse($author$project$I18n$Textes$formeRefusArchive));
					case 2:
						var _v6 = issue.c;
						return A2(
							$elm$core$Tuple$mapSecond,
							function (_v7) {
								return $author$project$Components$Referentiel$Formes$Update$relire(model);
							},
							refuse($author$project$I18n$Textes$formeRefusIntrouvable));
					case 3:
						var _v8 = issue.c;
						return refuse($author$project$I18n$Textes$formeRefusAcces);
					default:
						var _v9 = issue.c;
						return refuse($author$project$I18n$Textes$formeRefusAutre);
				}
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$creerUneForme = 'creer-forme';
var $author$project$Components$Referentiel$Formes$Update$enCours = function (model) {
	return $author$project$API$Envoi$enCours(model.l2);
};
var $author$project$Components$Referentiel$Formes$API$WriteAPIModel$CreerUneForme = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$Formes$Model$nonVide = function (texte) {
	return $elm$core$String$isEmpty(
		$elm$core$String$trim(texte)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		$elm$core$String$trim(texte));
};
var $author$project$Components$Referentiel$Formes$Model$libelles = function (saisie) {
	return A2(
		$elm$core$Maybe$map,
		function (fr) {
			return {
				yg: $author$project$Components$Referentiel$Formes$Model$nonVide(saisie.yg),
				zX: fr
			};
		},
		$author$project$Components$Referentiel$Formes$Model$nonVide(saisie.zX));
};
var $author$project$Components$Referentiel$Formes$Model$commandeDeCreation = F2(
	function (liste, saisie) {
		return A3(
			$elm$core$Maybe$map2,
			F2(
				function (lien, saisis) {
					return _Utils_Tuple2(
						lien,
						$author$project$Components$Referentiel$Formes$API$WriteAPIModel$CreerUneForme(saisis));
				}),
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUneForme, liste.nQ),
			$author$project$Components$Referentiel$Formes$Model$libelles(saisie));
	});
var $author$project$Components$Referentiel$Formes$API$WriteAPIModel$RenommerLaForme = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$renommerLaForme = 'renommer-forme';
var $author$project$Components$Referentiel$Formes$Model$commandeDeModification = F2(
	function (forme, saisie) {
		return A2(
			$elm$core$Maybe$andThen,
			function (saisis) {
				return _Utils_eq(saisis, forme.R) ? $elm$core$Maybe$Nothing : A2(
					$elm$core$Maybe$map,
					function (lien) {
						return _Utils_Tuple2(
							lien,
							A2($author$project$Components$Referentiel$Formes$API$WriteAPIModel$RenommerLaForme, forme.Aq, saisis));
					},
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$renommerLaForme, forme.nQ));
			},
			$author$project$Components$Referentiel$Formes$Model$libelles(saisie));
	});
var $author$project$Components$Referentiel$Formes$Model$estValide = function (saisie) {
	return !_Utils_eq(
		$author$project$Components$Referentiel$Formes$Model$libelles(saisie),
		$elm$core$Maybe$Nothing);
};
var $author$project$Components$Referentiel$Formes$Update$Envoyer = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Formes$API$WriteAPIModel$attendu = F2(
	function (commande, evenement) {
		var _v0 = _Utils_Tuple2(commande, evenement);
		_v0$5:
		while (true) {
			switch (_v0.b) {
				case 0:
					if (!_v0.a.$) {
						var _v1 = _v0.b;
						return true;
					} else {
						break _v0$5;
					}
				case 1:
					if (_v0.a.$ === 1) {
						var _v2 = _v0.a;
						var _v3 = _v0.b;
						return true;
					} else {
						break _v0$5;
					}
				case 2:
					if (_v0.a.$ === 2) {
						var _v4 = _v0.b;
						return true;
					} else {
						break _v0$5;
					}
				case 3:
					if (_v0.a.$ === 3) {
						var _v5 = _v0.b;
						return true;
					} else {
						break _v0$5;
					}
				default:
					var _v6 = _v0.b;
					return true;
			}
		}
		return false;
	});
var $author$project$Components$Referentiel$Formes$API$WriteAPIModel$repondA = F2(
	function (commande, evenements) {
		return $elm$core$List$isEmpty(evenements) || A2(
			$elm$core$List$any,
			$author$project$Components$Referentiel$Formes$API$WriteAPIModel$attendu(commande),
			evenements);
	});
var $author$project$Components$Referentiel$Formes$API$WriteAPIModel$ReponseDeCommande = F3(
	function (evenements, liens, vuesAJour) {
		return {mk: evenements, nQ: liens, sy: vuesAJour};
	});
var $author$project$Components$Referentiel$Formes$API$WriteAPIModel$EvenementInconnu = 4;
var $author$project$Components$Referentiel$Formes$API$WriteAPIModel$FormeArchivee = 2;
var $author$project$Components$Referentiel$Formes$API$WriteAPIModel$FormeCree = 0;
var $author$project$Components$Referentiel$Formes$API$WriteAPIModel$FormeRestauree = 3;
var $author$project$Components$Referentiel$Formes$API$WriteAPIModel$LibelleRenomme = 1;
var $author$project$Components$Referentiel$Formes$API$WriteAPIModel$evenementDecoder = A2(
	$elm$json$Json$Decode$map,
	function (paires) {
		_v0$5:
		while (true) {
			if (paires.b) {
				switch (paires.a.a) {
					case 'FormeCree':
						var _v1 = paires.a;
						return 0;
					case 'LibelleFrancaisModifie':
						var _v2 = paires.a;
						return 1;
					case 'LibelleAnglaisModifie':
						var _v3 = paires.a;
						return 1;
					case 'FormeArchivee':
						var _v4 = paires.a;
						return 2;
					case 'FormeRestauree':
						var _v5 = paires.a;
						return 3;
					default:
						break _v0$5;
				}
			} else {
				break _v0$5;
			}
		}
		return 4;
	},
	$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value));
var $author$project$Components$Referentiel$Formes$API$WriteAPIModel$reponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Referentiel$Formes$API$WriteAPIModel$ReponseDeCommande,
	A2(
		$elm$json$Json$Decode$field,
		'evenements',
		$elm$json$Json$Decode$list(
			A2($elm$json$Json$Decode$field, 'event', $author$project$Components$Referentiel$Formes$API$WriteAPIModel$evenementDecoder))),
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		A2($elm$json$Json$Decode$field, 'liens', $author$project$API$Liens$decoder)),
	A2($elm$json$Json$Decode$field, 'vuesAJour', $elm$json$Json$Decode$bool));
var $author$project$Components$Referentiel$Formes$Update$reglage = {
	f8: $author$project$Components$Referentiel$Formes$Update$DemanderProcessUid,
	l4: $author$project$Components$Referentiel$Formes$Update$Envoyer,
	go: $author$project$Components$Referentiel$Formes$API$WriteAPIErrorsModel$duRefus,
	pW: $author$project$Components$Referentiel$Formes$Update$Reconnecter,
	qu: F2(
		function (commande, rendue) {
			return A2($author$project$Components$Referentiel$Formes$API$WriteAPIModel$repondA, commande, rendue.mk);
		}),
	qv: $author$project$Components$Referentiel$Formes$API$WriteAPIModel$reponseDecoder
};
var $author$project$Components$Referentiel$Formes$Update$partir = F2(
	function (_v0, model) {
		var lien = _v0.a;
		var commande = _v0.b;
		var _v1 = A4(
			$author$project$API$Envoi$partir,
			$author$project$Components$Referentiel$Formes$Update$reglage,
			$elm$core$Maybe$Just(lien),
			commande,
			model.l2);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var envoi = _v2.a;
			var effets = _v2.b;
			var saisie = model.hP;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: envoi,
						hP: _Utils_update(
							saisie,
							{pZ: $elm$core$Maybe$Nothing})
					}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Formes$Model$tenter = function (saisie) {
	return _Utils_update(
		saisie,
		{b5: true});
};
var $author$project$Components$Referentiel$Formes$Update$enregistrer = function (model) {
	var _v0 = _Utils_Tuple2(model.hP.n9, model.nW);
	if (!_v0.a.$) {
		if (!_v0.b.$) {
			var _v1 = _v0.a;
			var liste = _v0.b.a;
			var _v2 = A2($author$project$Components$Referentiel$Formes$Model$commandeDeCreation, liste, model.hP);
			if (!_v2.$) {
				var envoi = _v2.a;
				return A2($author$project$Components$Referentiel$Formes$Update$partir, envoi, model);
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hP: $author$project$Components$Referentiel$Formes$Model$tenter(model.hP)
						}),
					_List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		var forme = _v0.a.a;
		if (!$author$project$Components$Referentiel$Formes$Model$estValide(model.hP)) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						hP: $author$project$Components$Referentiel$Formes$Model$tenter(model.hP)
					}),
				_List_Nil);
		} else {
			var _v3 = A2($author$project$Components$Referentiel$Formes$Model$commandeDeModification, forme, model.hP);
			if (!_v3.$) {
				var envoi = _v3.a;
				return A2($author$project$Components$Referentiel$Formes$Update$partir, envoi, model);
			} else {
				return A2(
					$author$project$Components$Referentiel$Formes$Update$versLeDrawer,
					$author$project$Components$Shared$Drawer$Update$Fermer,
					_Utils_update(
						model,
						{hP: $author$project$Components$Referentiel$Formes$Model$saisieVide}));
			}
		}
	}
};
var $author$project$Components$Referentiel$Formes$Model$idDeLaCreation = 'formes-creer';
var $author$project$Components$Referentiel$Formes$Model$idDuModifier = function (id) {
	return 'forme-modifier-' + $author$project$Components$Referentiel$Identifiants$formeUidToString(id);
};
var $author$project$Components$Referentiel$Formes$Model$modifiable = function (forme) {
	return A2(
		$elm$core$List$any,
		function (rel) {
			return !_Utils_eq(
				A2($author$project$API$Liens$trouver, rel, forme.nQ),
				$elm$core$Maybe$Nothing);
		},
		_List_fromArray(
			[$author$project$API$NavLinksDictionary$renommerLaForme, $author$project$API$NavLinksDictionary$archiverLaForme]));
};
var $author$project$Components$Referentiel$Formes$Model$ouvert = function (lecture) {
	return _Utils_update(
		$author$project$Components$Referentiel$Formes$Model$init,
		{np: lecture});
};
var $author$project$API$NavLinksDictionary$parametrageDesFormes = 'parametrage-des-formes-d-organisation';
var $author$project$API$NavLinksDictionary$restaurerLaForme = 'restaurer-forme';
var $author$project$Components$Referentiel$Formes$Model$trouver = F2(
	function (id, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (liste) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (forme) {
							return _Utils_eq(forme.Aq, id);
						},
						liste.zS));
			},
			model.nW);
	});
var $author$project$Components$Referentiel$Formes$Update$surLeForme = F4(
	function (rel, commande, id, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (forme) {
				return A2($author$project$API$Liens$trouver, rel, forme.nQ);
			},
			A2($author$project$Components$Referentiel$Formes$Model$trouver, id, model));
		if (!_v0.$) {
			var lien = _v0.a;
			return A2(
				$author$project$Components$Referentiel$Formes$Update$partir,
				_Utils_Tuple2(
					lien,
					commande(id)),
				model);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Formes$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var liens = msg.a;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$parametrageDesFormes, liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						$author$project$Components$Referentiel$Formes$Model$ouvert(
							$elm$core$Maybe$Just(lecture)),
						_List_fromArray(
							[
								$author$project$Components$Referentiel$Formes$Update$DemanderProcessUid,
								$author$project$Components$Referentiel$Formes$Update$Lire(lecture)
							]));
				} else {
					return _Utils_Tuple2(
						$author$project$Components$Referentiel$Formes$Model$ouvert($elm$core$Maybe$Nothing),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 2:
				var reponse = msg.a;
				var _v2 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Formes$API$QueryAPIModel$listeDecoder, reponse);
				if (!_v2.$) {
					var liste = _v2.a;
					var _v3 = _Utils_Tuple2(
						model.fG,
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$avecLesArchives, liste.nQ));
					if ((!_v3.a) && (!_v3.b.$)) {
						var avec = _v3.b.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									fG: true,
									nW: $elm$core$Maybe$Just(liste)
								}),
							_List_fromArray(
								[
									$author$project$Components$Referentiel$Formes$Update$Lire(avec)
								]));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									nW: $elm$core$Maybe$Just(liste)
								}),
							_List_Nil);
					}
				} else {
					var refus = _v2.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Referentiel$Formes$Update$Reconnecter]) : _List_Nil);
				}
			case 3:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Referentiel$Formes$Update$relire(model));
			case 4:
				var choisies = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{i$: choisies}),
					_List_Nil);
			case 5:
				var geste = msg.a;
				return ($author$project$Components$Referentiel$Formes$Update$enCours(model) && A2(
					$elm$core$List$member,
					geste,
					_List_fromArray(
						[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$SortieDemandee, $author$project$Components$Shared$Drawer$Update$AbandonConfirme]))) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Referentiel$Formes$Update$versLeDrawer, geste, model);
			case 7:
				return _Utils_eq(
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.nQ;
							},
							$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$creerUneForme)),
						model.nW),
					$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A2(
					$author$project$Components$Referentiel$Formes$Update$versLeDrawer,
					$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Referentiel$Formes$Model$idDeLaCreation),
					_Utils_update(
						model,
						{hP: $author$project$Components$Referentiel$Formes$Model$saisieVide}));
			case 8:
				var id = msg.a;
				var _v4 = A2($author$project$Components$Referentiel$Formes$Model$trouver, id, model);
				if (!_v4.$) {
					var forme = _v4.a;
					return ($author$project$Components$Referentiel$Formes$Model$modifiable(forme) && (!forme.tI)) ? A2(
						$author$project$Components$Referentiel$Formes$Update$versLeDrawer,
						$author$project$Components$Shared$Drawer$Update$Ouvrir(
							$author$project$Components$Referentiel$Formes$Model$idDuModifier(id)),
						_Utils_update(
							model,
							{
								hP: $author$project$Components$Referentiel$Formes$Model$saisieDe(forme)
							})) : _Utils_Tuple2(model, _List_Nil);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 6:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Formes$Update$versLesNoms, geste, model);
			case 9:
				if (msg.a.$ === 2) {
					var _v5 = msg.a;
					return A2(
						$author$project$Components$Referentiel$Formes$Update$versLesNoms,
						$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Referentiel$Formes$Model$idDuNom),
						_Utils_update(
							model,
							{
								hP: A2($author$project$Components$Referentiel$Formes$Model$saisir, $author$project$Components$Referentiel$Formes$Model$OuvrirNom, model.hP)
							}));
				} else {
					var champ = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								hP: A2($author$project$Components$Referentiel$Formes$Model$saisir, champ, model.hP)
							}),
						_List_Nil);
				}
			case 10:
				return $author$project$Components$Referentiel$Formes$Update$enregistrer(model);
			case 11:
				var id = msg.a;
				return A4($author$project$Components$Referentiel$Formes$Update$surLeForme, $author$project$API$NavLinksDictionary$archiverLaForme, $author$project$Components$Referentiel$Formes$API$WriteAPIModel$ArchiverLaForme, id, model);
			case 12:
				var id = msg.a;
				return A4($author$project$Components$Referentiel$Formes$Update$surLeForme, $author$project$API$NavLinksDictionary$restaurerLaForme, $author$project$Components$Referentiel$Formes$API$WriteAPIModel$RestaurerLaForme, id, model);
			default:
				var reponse = msg.a;
				var _v6 = A3($author$project$API$Envoi$conclure, $author$project$Components$Referentiel$Formes$Update$reglage, reponse, model.l2);
				if (!_v6.$) {
					var _v7 = _v6.a;
					var envoi = _v7.a;
					var issue = _v7.b;
					var effets = _v7.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Referentiel$Formes$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Main$Update$versLesFormes = F3(
	function (i18n, msg, model) {
		var _v0 = A2($author$project$Components$Referentiel$Formes$Update$update, msg, model.zS);
		var formes = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLesFormes, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLesFormes,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						zS: formes,
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Referentiel$Formes$Update$popMessages(msg),
							gardes)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$andThenFormes = F3(
	function (i18n, msg, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Basics$append(effets),
			A3($author$project$Main$Update$versLesFormes, i18n, msg, model));
	});
var $author$project$Main$Update$AttendreAvantDeRelireLesPostes = function (a) {
	return {$: 275, a: a};
};
var $author$project$Main$Update$EnvoyerAuxPostes = function (a) {
	return {$: 274, a: a};
};
var $author$project$Main$Update$LireLesPostes = function (a) {
	return {$: 273, a: a};
};
var $author$project$Main$Model$PourLesPostes = 53;
var $author$project$Main$Update$depuisLesPostes = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[53]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 1:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesPostes)));
			case 3:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerAuxPostes(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 2:
				var delaiMs = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AttendreAvantDeRelireLesPostes(delaiMs)
							])));
			case 4:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Referentiel$Postes$API$WriteAPIErrorsModel$LibelleDejaUtilise = 0;
var $author$project$Components$Referentiel$Postes$API$WriteAPIErrorsModel$PosteArchive = 1;
var $author$project$Components$Referentiel$Postes$API$WriteAPIErrorsModel$PosteIntrouvable = 2;
var $author$project$Components$Referentiel$Postes$API$WriteAPIErrorsModel$AccesRefuse = 3;
var $author$project$Components$Referentiel$Postes$API$WriteAPIErrorsModel$AutreRefus = 4;
var $author$project$Components$Referentiel$Postes$API$WriteAPIErrorsModel$duRefus = function (reponse) {
	if (reponse.ri === 403) {
		return 3;
	} else {
		if (reponse.ri === 404) {
			return 2;
		} else {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeString,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['error']),
					$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value)),
				reponse.f$);
			_v0$2:
			while (true) {
				if ((!_v0.$) && _v0.a.b) {
					switch (_v0.a.a.a) {
						case 'LibelleDejaUtilise':
							var _v1 = _v0.a;
							var _v2 = _v1.a;
							return 0;
						case 'PosteEstArchive':
							var _v3 = _v0.a;
							var _v4 = _v3.a;
							return 1;
						default:
							break _v0$2;
					}
				} else {
					break _v0$2;
				}
			}
			return 4;
		}
	}
};
var $author$project$Components$Referentiel$Postes$Update$duRefus = function (resultat) {
	if (resultat.$ === 1) {
		var refus = resultat.a;
		return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Components$Shared$Messages$Model$duRefus(refus));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Postes$API$QueryAPIModel$Liste = F2(
	function (postes, liens) {
		return {nQ: liens, F6: postes};
	});
var $author$project$Components$Referentiel$Postes$API$QueryAPIModel$Poste = F5(
	function (id, libelles, archive, rattachements, liens) {
		return {tE: archive, Aq: id, R: libelles, nQ: liens, GY: rattachements};
	});
var $author$project$Components$Referentiel$Postes$API$QueryAPIModel$Libelles = F2(
	function (fr, en) {
		return {yg: en, zX: fr};
	});
var $author$project$Components$Referentiel$Postes$API$QueryAPIModel$libellesDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'en',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'fr',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Postes$API$QueryAPIModel$Libelles)));
var $author$project$Components$Referentiel$Identifiants$PosteUid = $elm$core$Basics$identity;
var $author$project$Components$Referentiel$Identifiants$posteUidDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Components$Referentiel$Postes$API$QueryAPIModel$posteDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'rattachements',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'archive',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'libelles',
				$author$project$Components$Referentiel$Postes$API$QueryAPIModel$libellesDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'uid',
					$author$project$Components$Referentiel$Identifiants$posteUidDecoder,
					$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Postes$API$QueryAPIModel$Poste))))));
var $author$project$Components$Referentiel$Postes$API$QueryAPIModel$listeDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'postes',
		$elm$json$Json$Decode$list($author$project$Components$Referentiel$Postes$API$QueryAPIModel$posteDecoder),
		$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Postes$API$QueryAPIModel$Liste)));
var $author$project$Components$Referentiel$Postes$Update$popMessages = function (msg) {
	switch (msg.$) {
		case 2:
			var reponse = msg.a;
			return $author$project$Components$Referentiel$Postes$Update$duRefus(
				A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Postes$API$QueryAPIModel$listeDecoder, reponse));
		case 13:
			var reponse = msg.a;
			return A2(
				$elm$core$List$member,
				$author$project$Components$Referentiel$Postes$API$WriteAPIErrorsModel$duRefus(reponse),
				_List_fromArray(
					[0, 1, 2])) ? $elm$core$Maybe$Nothing : $author$project$Components$Referentiel$Postes$Update$duRefus(
				A2(
					$author$project$API$Reponse$lire,
					$elm$json$Json$Decode$succeed(0),
					reponse));
		case 1:
			var octets = msg.a;
			return _Utils_eq(
				$author$project$API$ProcessUid$depuisOctets(octets),
				$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
				{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Main$Update$requeteSurLesPostes = function (effet) {
	switch (effet.$) {
		case 1:
			return true;
		case 3:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Referentiel$Postes$API$WriteAPIModel$ArchiverLePoste = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Postes$Update$DemanderProcessUid = {$: 0};
var $author$project$Components$Referentiel$Postes$Update$Lire = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Postes$Model$OuvrirNom = {$: 2};
var $author$project$Components$Referentiel$Postes$Update$Reconnecter = {$: 5};
var $author$project$Components$Referentiel$Postes$API$WriteAPIModel$RestaurerLePoste = function (a) {
	return {$: 3, a: a};
};
var $author$project$API$NavLinksDictionary$archiverLePoste = 'archiver-le-poste';
var $author$project$Components$Referentiel$Postes$Update$AttendreAvantDeRelire = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Postes$Model$Doublon = {$: 0};
var $author$project$Components$Referentiel$Postes$Model$Libre = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Postes$Model$idDuNom = 'poste-nom';
var $author$project$Components$Referentiel$Postes$Model$retireLeDoublon = function (refus) {
	return _Utils_eq(
		refus,
		$elm$core$Maybe$Just($author$project$Components$Referentiel$Postes$Model$Doublon)) ? $elm$core$Maybe$Nothing : refus;
};
var $author$project$Components$Referentiel$Postes$Model$saisir = F2(
	function (champ, saisie) {
		switch (champ.$) {
			case 0:
				var texte = champ.a;
				return _Utils_update(
					saisie,
					{
						zX: texte,
						pZ: $author$project$Components$Referentiel$Postes$Model$retireLeDoublon(saisie.pZ)
					});
			case 1:
				var texte = champ.a;
				return _Utils_update(
					saisie,
					{
						yg: texte,
						pZ: $author$project$Components$Referentiel$Postes$Model$retireLeDoublon(saisie.pZ)
					});
			default:
				return _Utils_update(
					saisie,
					{bO: true});
		}
	});
var $author$project$Components$Referentiel$Postes$Update$PlacerFocus = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Referentiel$Postes$Update$versLesNoms = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				var saisie = model.hP;
				return _Utils_update(
					model,
					{
						DG: drawer,
						hP: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? saisie : _Utils_update(
							saisie,
							{bO: false})
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Referentiel$Postes$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.DG));
	});
var $author$project$Components$Referentiel$Postes$Update$doublonAuRenommage = function (model) {
	var saisie = model.hP;
	return A2(
		$author$project$Components$Referentiel$Postes$Update$versLesNoms,
		$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Referentiel$Postes$Model$idDuNom),
		_Utils_update(
			model,
			{
				hP: A2(
					$author$project$Components$Referentiel$Postes$Model$saisir,
					$author$project$Components$Referentiel$Postes$Model$OuvrirNom,
					_Utils_update(
						saisie,
						{
							pZ: $elm$core$Maybe$Just($author$project$Components$Referentiel$Postes$Model$Doublon)
						}))
			}));
};
var $author$project$I18n$Textes$posteRefusAcces = A3($author$project$I18n$Traductions$texte, 'poste.refus.acces', _List_Nil, 'Vous n\'avez pas le droit de paramétrer les postes.');
var $author$project$I18n$Textes$posteRefusArchive = A3($author$project$I18n$Traductions$texte, 'poste.refus.archive', _List_Nil, 'Ce poste est archivé : il ne se renomme plus. Restaurez-le d\'abord.');
var $author$project$I18n$Textes$posteRefusAutre = A3($author$project$I18n$Traductions$texte, 'poste.refus.autre', _List_Nil, 'L\'enregistrement a échoué. Rien n\'a été modifié.');
var $author$project$I18n$Textes$posteRefusIntrouvable = A3($author$project$I18n$Traductions$texte, 'poste.refus.introuvable', _List_Nil, 'Ce poste n\'existe plus. La liste est relue.');
var $author$project$I18n$Textes$posteRefusRejeu = A3($author$project$I18n$Traductions$texte, 'poste.refus.rejeu', _List_Nil, 'Cette saisie n\'a pas été appliquée : ce geste avait déjà servi à une autre commande.');
var $author$project$Components$Referentiel$Postes$Model$lienDeLecture = function (model) {
	return model.fG ? function (avec) {
		return _Utils_eq(avec, $elm$core$Maybe$Nothing) ? model.np : avec;
	}(
		A2(
			$elm$core$Maybe$andThen,
			function (liste) {
				return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$avecLesArchives, liste.nQ);
			},
			model.nW)) : model.np;
};
var $author$project$Components$Referentiel$Postes$Update$relire = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Postes$Update$Lire, $elm$core$List$singleton),
			$author$project$Components$Referentiel$Postes$Model$lienDeLecture(model)));
};
var $author$project$Components$Referentiel$Postes$Model$Modification = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Postes$Model$saisieDe = function (poste) {
	return {
		yg: A2($elm$core$Maybe$withDefault, '', poste.R.yg),
		zX: poste.R.zX,
		n9: $author$project$Components$Referentiel$Postes$Model$Modification(poste),
		bO: false,
		pZ: $elm$core$Maybe$Nothing,
		b5: false
	};
};
var $author$project$Components$Referentiel$Postes$Model$enCours = function (saisie) {
	var _v0 = saisie.n9;
	if (!_v0.$) {
		return !_Utils_eq(
			_Utils_update(
				saisie,
				{bO: false, pZ: $elm$core$Maybe$Nothing, b5: false}),
			$author$project$Components$Referentiel$Postes$Model$saisieVide);
	} else {
		var poste = _v0.a;
		return !_Utils_eq(
			_Utils_update(
				saisie,
				{bO: false, pZ: $elm$core$Maybe$Nothing, b5: false}),
			$author$project$Components$Referentiel$Postes$Model$saisieDe(poste));
	}
};
var $author$project$Components$Referentiel$Postes$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{kX: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Referentiel$Postes$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Referentiel$Postes$Model$enCours(model.hP)
				},
				geste,
				model.kX));
	});
var $author$project$Components$Referentiel$Postes$Update$conclure = F2(
	function (issue, model) {
		var saisie = model.hP;
		var refuse = function (message) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						hP: _Utils_update(
							saisie,
							{
								pZ: $elm$core$Maybe$Just(
									$author$project$Components$Referentiel$Postes$Model$Libre(message))
							})
					}),
				_List_Nil);
		};
		switch (issue.$) {
			case 0:
				if (issue.c) {
					var rendue = issue.b;
					return A2(
						$elm$core$Tuple$mapSecond,
						function (effets) {
							return _Utils_ap(
								effets,
								rendue.sy ? $author$project$Components$Referentiel$Postes$Update$relire(model) : _List_fromArray(
									[
										$author$project$Components$Referentiel$Postes$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
									]));
						},
						A2(
							$author$project$Components$Referentiel$Postes$Update$versLeDrawer,
							$author$project$Components$Shared$Drawer$Update$Fermer,
							_Utils_update(
								model,
								{hP: $author$project$Components$Referentiel$Postes$Model$saisieVide})));
				} else {
					return A2(
						$elm$core$Tuple$mapSecond,
						function (_v1) {
							return $author$project$Components$Referentiel$Postes$Update$relire(model);
						},
						refuse($author$project$I18n$Textes$posteRefusRejeu));
				}
			case 1:
				switch (issue.c) {
					case 0:
						var _v2 = issue.c;
						var _v3 = saisie.n9;
						if (_v3.$ === 1) {
							return $author$project$Components$Referentiel$Postes$Update$doublonAuRenommage(model);
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										hP: _Utils_update(
											saisie,
											{
												pZ: $elm$core$Maybe$Just($author$project$Components$Referentiel$Postes$Model$Doublon)
											})
									}),
								_List_Nil);
						}
					case 1:
						var _v4 = issue.c;
						return A2(
							$elm$core$Tuple$mapSecond,
							function (_v5) {
								return $author$project$Components$Referentiel$Postes$Update$relire(model);
							},
							refuse($author$project$I18n$Textes$posteRefusArchive));
					case 2:
						var _v6 = issue.c;
						return A2(
							$elm$core$Tuple$mapSecond,
							function (_v7) {
								return $author$project$Components$Referentiel$Postes$Update$relire(model);
							},
							refuse($author$project$I18n$Textes$posteRefusIntrouvable));
					case 3:
						var _v8 = issue.c;
						return refuse($author$project$I18n$Textes$posteRefusAcces);
					default:
						var _v9 = issue.c;
						return refuse($author$project$I18n$Textes$posteRefusAutre);
				}
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$creerUnPoste = 'creer-un-poste';
var $author$project$Components$Referentiel$Postes$Update$enCours = function (model) {
	return $author$project$API$Envoi$enCours(model.l2);
};
var $author$project$Components$Referentiel$Postes$API$WriteAPIModel$CreerUnPoste = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$Postes$Model$nonVide = function (texte) {
	return $elm$core$String$isEmpty(
		$elm$core$String$trim(texte)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		$elm$core$String$trim(texte));
};
var $author$project$Components$Referentiel$Postes$Model$libelles = function (saisie) {
	return A2(
		$elm$core$Maybe$map,
		function (fr) {
			return {
				yg: $author$project$Components$Referentiel$Postes$Model$nonVide(saisie.yg),
				zX: fr
			};
		},
		$author$project$Components$Referentiel$Postes$Model$nonVide(saisie.zX));
};
var $author$project$Components$Referentiel$Postes$Model$commandeDeCreation = F2(
	function (liste, saisie) {
		return A3(
			$elm$core$Maybe$map2,
			F2(
				function (lien, saisis) {
					return _Utils_Tuple2(
						lien,
						$author$project$Components$Referentiel$Postes$API$WriteAPIModel$CreerUnPoste(saisis));
				}),
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUnPoste, liste.nQ),
			$author$project$Components$Referentiel$Postes$Model$libelles(saisie));
	});
var $author$project$Components$Referentiel$Postes$API$WriteAPIModel$RenommerLePoste = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$renommerLePoste = 'renommer-le-poste';
var $author$project$Components$Referentiel$Postes$Model$commandeDeModification = F2(
	function (poste, saisie) {
		return A2(
			$elm$core$Maybe$andThen,
			function (saisis) {
				return _Utils_eq(saisis, poste.R) ? $elm$core$Maybe$Nothing : A2(
					$elm$core$Maybe$map,
					function (lien) {
						return _Utils_Tuple2(
							lien,
							A2($author$project$Components$Referentiel$Postes$API$WriteAPIModel$RenommerLePoste, poste.Aq, saisis));
					},
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$renommerLePoste, poste.nQ));
			},
			$author$project$Components$Referentiel$Postes$Model$libelles(saisie));
	});
var $author$project$Components$Referentiel$Postes$Model$estValide = function (saisie) {
	return !_Utils_eq(
		$author$project$Components$Referentiel$Postes$Model$libelles(saisie),
		$elm$core$Maybe$Nothing);
};
var $author$project$Components$Referentiel$Postes$Update$Envoyer = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Postes$API$WriteAPIModel$attendu = F2(
	function (commande, evenement) {
		var _v0 = _Utils_Tuple2(commande, evenement);
		_v0$5:
		while (true) {
			switch (_v0.b) {
				case 0:
					if (!_v0.a.$) {
						var _v1 = _v0.b;
						return true;
					} else {
						break _v0$5;
					}
				case 1:
					if (_v0.a.$ === 1) {
						var _v2 = _v0.a;
						var _v3 = _v0.b;
						return true;
					} else {
						break _v0$5;
					}
				case 2:
					if (_v0.a.$ === 2) {
						var _v4 = _v0.b;
						return true;
					} else {
						break _v0$5;
					}
				case 3:
					if (_v0.a.$ === 3) {
						var _v5 = _v0.b;
						return true;
					} else {
						break _v0$5;
					}
				default:
					var _v6 = _v0.b;
					return true;
			}
		}
		return false;
	});
var $author$project$Components$Referentiel$Postes$API$WriteAPIModel$repondA = F2(
	function (commande, evenements) {
		return $elm$core$List$isEmpty(evenements) || A2(
			$elm$core$List$any,
			$author$project$Components$Referentiel$Postes$API$WriteAPIModel$attendu(commande),
			evenements);
	});
var $author$project$Components$Referentiel$Postes$API$WriteAPIModel$ReponseDeCommande = F3(
	function (evenements, liens, vuesAJour) {
		return {mk: evenements, nQ: liens, sy: vuesAJour};
	});
var $author$project$Components$Referentiel$Postes$API$WriteAPIModel$EvenementInconnu = 4;
var $author$project$Components$Referentiel$Postes$API$WriteAPIModel$LibelleRenomme = 1;
var $author$project$Components$Referentiel$Postes$API$WriteAPIModel$PosteArchive = 2;
var $author$project$Components$Referentiel$Postes$API$WriteAPIModel$PosteCree = 0;
var $author$project$Components$Referentiel$Postes$API$WriteAPIModel$PosteRestaure = 3;
var $author$project$Components$Referentiel$Postes$API$WriteAPIModel$evenementDecoder = A2(
	$elm$json$Json$Decode$map,
	function (paires) {
		_v0$5:
		while (true) {
			if (paires.b) {
				switch (paires.a.a) {
					case 'PosteCree':
						var _v1 = paires.a;
						return 0;
					case 'LibelleFrancaisDuPosteModifie':
						var _v2 = paires.a;
						return 1;
					case 'LibelleAnglaisDuPosteModifie':
						var _v3 = paires.a;
						return 1;
					case 'PosteArchive':
						var _v4 = paires.a;
						return 2;
					case 'PosteRestaure':
						var _v5 = paires.a;
						return 3;
					default:
						break _v0$5;
				}
			} else {
				break _v0$5;
			}
		}
		return 4;
	},
	$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value));
var $author$project$Components$Referentiel$Postes$API$WriteAPIModel$reponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Referentiel$Postes$API$WriteAPIModel$ReponseDeCommande,
	A2(
		$elm$json$Json$Decode$field,
		'evenements',
		$elm$json$Json$Decode$list(
			A2($elm$json$Json$Decode$field, 'event', $author$project$Components$Referentiel$Postes$API$WriteAPIModel$evenementDecoder))),
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		A2($elm$json$Json$Decode$field, 'liens', $author$project$API$Liens$decoder)),
	A2($elm$json$Json$Decode$field, 'vuesAJour', $elm$json$Json$Decode$bool));
var $author$project$Components$Referentiel$Postes$Update$reglage = {
	f8: $author$project$Components$Referentiel$Postes$Update$DemanderProcessUid,
	l4: $author$project$Components$Referentiel$Postes$Update$Envoyer,
	go: $author$project$Components$Referentiel$Postes$API$WriteAPIErrorsModel$duRefus,
	pW: $author$project$Components$Referentiel$Postes$Update$Reconnecter,
	qu: F2(
		function (commande, rendue) {
			return A2($author$project$Components$Referentiel$Postes$API$WriteAPIModel$repondA, commande, rendue.mk);
		}),
	qv: $author$project$Components$Referentiel$Postes$API$WriteAPIModel$reponseDecoder
};
var $author$project$Components$Referentiel$Postes$Update$partir = F2(
	function (_v0, model) {
		var lien = _v0.a;
		var commande = _v0.b;
		var _v1 = A4(
			$author$project$API$Envoi$partir,
			$author$project$Components$Referentiel$Postes$Update$reglage,
			$elm$core$Maybe$Just(lien),
			commande,
			model.l2);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var envoi = _v2.a;
			var effets = _v2.b;
			var saisie = model.hP;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: envoi,
						hP: _Utils_update(
							saisie,
							{pZ: $elm$core$Maybe$Nothing})
					}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Postes$Model$tenter = function (saisie) {
	return _Utils_update(
		saisie,
		{b5: true});
};
var $author$project$Components$Referentiel$Postes$Update$enregistrer = function (model) {
	var _v0 = _Utils_Tuple2(model.hP.n9, model.nW);
	if (!_v0.a.$) {
		if (!_v0.b.$) {
			var _v1 = _v0.a;
			var liste = _v0.b.a;
			var _v2 = A2($author$project$Components$Referentiel$Postes$Model$commandeDeCreation, liste, model.hP);
			if (!_v2.$) {
				var envoi = _v2.a;
				return A2($author$project$Components$Referentiel$Postes$Update$partir, envoi, model);
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hP: $author$project$Components$Referentiel$Postes$Model$tenter(model.hP)
						}),
					_List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		var poste = _v0.a.a;
		if (!$author$project$Components$Referentiel$Postes$Model$estValide(model.hP)) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						hP: $author$project$Components$Referentiel$Postes$Model$tenter(model.hP)
					}),
				_List_Nil);
		} else {
			var _v3 = A2($author$project$Components$Referentiel$Postes$Model$commandeDeModification, poste, model.hP);
			if (!_v3.$) {
				var envoi = _v3.a;
				return A2($author$project$Components$Referentiel$Postes$Update$partir, envoi, model);
			} else {
				return A2(
					$author$project$Components$Referentiel$Postes$Update$versLeDrawer,
					$author$project$Components$Shared$Drawer$Update$Fermer,
					_Utils_update(
						model,
						{hP: $author$project$Components$Referentiel$Postes$Model$saisieVide}));
			}
		}
	}
};
var $author$project$Components$Referentiel$Postes$Model$idDeLaCreation = 'postes-creer';
var $author$project$Components$Referentiel$Postes$Model$idDuModifier = function (id) {
	return 'poste-modifier-' + $author$project$Components$Referentiel$Identifiants$posteUidToString(id);
};
var $author$project$Components$Referentiel$Postes$Model$modifiable = function (poste) {
	return A2(
		$elm$core$List$any,
		function (rel) {
			return !_Utils_eq(
				A2($author$project$API$Liens$trouver, rel, poste.nQ),
				$elm$core$Maybe$Nothing);
		},
		_List_fromArray(
			[$author$project$API$NavLinksDictionary$renommerLePoste, $author$project$API$NavLinksDictionary$archiverLePoste]));
};
var $author$project$Components$Referentiel$Postes$Model$ouvert = function (lecture) {
	return _Utils_update(
		$author$project$Components$Referentiel$Postes$Model$init,
		{np: lecture});
};
var $author$project$API$NavLinksDictionary$parametrageDesPostes = 'parametrage-des-postes';
var $author$project$API$NavLinksDictionary$restaurerLePoste = 'restaurer-le-poste';
var $author$project$Components$Referentiel$Postes$Model$trouver = F2(
	function (id, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (liste) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (poste) {
							return _Utils_eq(poste.Aq, id);
						},
						liste.F6));
			},
			model.nW);
	});
var $author$project$Components$Referentiel$Postes$Update$surLePoste = F4(
	function (rel, commande, id, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (poste) {
				return A2($author$project$API$Liens$trouver, rel, poste.nQ);
			},
			A2($author$project$Components$Referentiel$Postes$Model$trouver, id, model));
		if (!_v0.$) {
			var lien = _v0.a;
			return A2(
				$author$project$Components$Referentiel$Postes$Update$partir,
				_Utils_Tuple2(
					lien,
					commande(id)),
				model);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Postes$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var liens = msg.a;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$parametrageDesPostes, liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						$author$project$Components$Referentiel$Postes$Model$ouvert(
							$elm$core$Maybe$Just(lecture)),
						_List_fromArray(
							[
								$author$project$Components$Referentiel$Postes$Update$DemanderProcessUid,
								$author$project$Components$Referentiel$Postes$Update$Lire(lecture)
							]));
				} else {
					return _Utils_Tuple2(
						$author$project$Components$Referentiel$Postes$Model$ouvert($elm$core$Maybe$Nothing),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 2:
				var reponse = msg.a;
				var _v2 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Postes$API$QueryAPIModel$listeDecoder, reponse);
				if (!_v2.$) {
					var liste = _v2.a;
					var _v3 = _Utils_Tuple2(
						model.fG,
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$avecLesArchives, liste.nQ));
					if ((!_v3.a) && (!_v3.b.$)) {
						var avec = _v3.b.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									fG: true,
									nW: $elm$core$Maybe$Just(liste)
								}),
							_List_fromArray(
								[
									$author$project$Components$Referentiel$Postes$Update$Lire(avec)
								]));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									nW: $elm$core$Maybe$Just(liste)
								}),
							_List_Nil);
					}
				} else {
					var refus = _v2.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Referentiel$Postes$Update$Reconnecter]) : _List_Nil);
				}
			case 3:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Referentiel$Postes$Update$relire(model));
			case 4:
				var choisies = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{i$: choisies}),
					_List_Nil);
			case 5:
				var geste = msg.a;
				return ($author$project$Components$Referentiel$Postes$Update$enCours(model) && A2(
					$elm$core$List$member,
					geste,
					_List_fromArray(
						[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$SortieDemandee, $author$project$Components$Shared$Drawer$Update$AbandonConfirme]))) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Referentiel$Postes$Update$versLeDrawer, geste, model);
			case 7:
				return _Utils_eq(
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.nQ;
							},
							$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$creerUnPoste)),
						model.nW),
					$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A2(
					$author$project$Components$Referentiel$Postes$Update$versLeDrawer,
					$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Referentiel$Postes$Model$idDeLaCreation),
					_Utils_update(
						model,
						{hP: $author$project$Components$Referentiel$Postes$Model$saisieVide}));
			case 8:
				var id = msg.a;
				var _v4 = A2($author$project$Components$Referentiel$Postes$Model$trouver, id, model);
				if (!_v4.$) {
					var poste = _v4.a;
					return ($author$project$Components$Referentiel$Postes$Model$modifiable(poste) && (!poste.tE)) ? A2(
						$author$project$Components$Referentiel$Postes$Update$versLeDrawer,
						$author$project$Components$Shared$Drawer$Update$Ouvrir(
							$author$project$Components$Referentiel$Postes$Model$idDuModifier(id)),
						_Utils_update(
							model,
							{
								hP: $author$project$Components$Referentiel$Postes$Model$saisieDe(poste)
							})) : _Utils_Tuple2(model, _List_Nil);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 6:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Postes$Update$versLesNoms, geste, model);
			case 9:
				if (msg.a.$ === 2) {
					var _v5 = msg.a;
					return A2(
						$author$project$Components$Referentiel$Postes$Update$versLesNoms,
						$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Referentiel$Postes$Model$idDuNom),
						_Utils_update(
							model,
							{
								hP: A2($author$project$Components$Referentiel$Postes$Model$saisir, $author$project$Components$Referentiel$Postes$Model$OuvrirNom, model.hP)
							}));
				} else {
					var champ = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								hP: A2($author$project$Components$Referentiel$Postes$Model$saisir, champ, model.hP)
							}),
						_List_Nil);
				}
			case 10:
				return $author$project$Components$Referentiel$Postes$Update$enregistrer(model);
			case 11:
				var id = msg.a;
				return A4($author$project$Components$Referentiel$Postes$Update$surLePoste, $author$project$API$NavLinksDictionary$archiverLePoste, $author$project$Components$Referentiel$Postes$API$WriteAPIModel$ArchiverLePoste, id, model);
			case 12:
				var id = msg.a;
				return A4($author$project$Components$Referentiel$Postes$Update$surLePoste, $author$project$API$NavLinksDictionary$restaurerLePoste, $author$project$Components$Referentiel$Postes$API$WriteAPIModel$RestaurerLePoste, id, model);
			default:
				var reponse = msg.a;
				var _v6 = A3($author$project$API$Envoi$conclure, $author$project$Components$Referentiel$Postes$Update$reglage, reponse, model.l2);
				if (!_v6.$) {
					var _v7 = _v6.a;
					var envoi = _v7.a;
					var issue = _v7.b;
					var effets = _v7.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Referentiel$Postes$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Main$Update$versLesPostes = F3(
	function (i18n, msg, model) {
		var _v0 = A2($author$project$Components$Referentiel$Postes$Update$update, msg, model.F6);
		var postes = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLesPostes, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLesPostes,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Referentiel$Postes$Update$popMessages(msg),
							gardes),
						F6: postes
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$andThenPostes = F3(
	function (i18n, msg, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Basics$append(effets),
			A3($author$project$Main$Update$versLesPostes, i18n, msg, model));
	});
var $author$project$Main$Update$liensDeLaRacine = function (model) {
	var _v0 = model.e1.gt;
	if (_v0.$ === 1) {
		var connexion = _v0.a;
		return connexion.GO ? $elm$core$Maybe$Just(
			{gF: connexion.gF, h0: connexion.nQ}) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$Catalogue$Update$FormulaireEmbarque = {$: 32};
var $author$project$Components$Produits$Catalogue$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Main$Update$CatalogueDesReferences = 8;
var $author$project$Main$Model$PourLeCatalogue = 13;
var $author$project$Main$Update$AnnulerLEnvoiDeLaReference = {$: 159};
var $author$project$Components$Produits$StructureCatalogue$Update$ArchivageSurLaSelectionDemande = F2(
	function (a, b) {
		return {$: 46, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Update$ArchivageSurLeFiltreDemande = F2(
	function (a, b) {
		return {$: 45, a: a, b: b};
	});
var $author$project$Main$Update$AttendreAvantDeChercherLesReferences = F2(
	function (a, b) {
		return {$: 165, a: a, b: b};
	});
var $author$project$Main$Update$AttendreAvantDeRelireLesElements = F2(
	function (a, b) {
		return {$: 163, a: a, b: b};
	});
var $author$project$Main$Update$ChercherLesReferences = function (a) {
	return {$: 164, a: a};
};
var $author$project$Main$Update$ChoisirUnFichierDuPoste = function (a) {
	return {$: 152, a: a};
};
var $author$project$Main$Update$CompterLesReferencesARangerDuCatalogue = function (a) {
	return {$: 142, a: a};
};
var $author$project$Main$Update$DeposerUnFichierDeLaReference = function (a) {
	return {$: 155, a: a};
};
var $author$project$Main$Update$EnvoyerAuxElements = F2(
	function (a, b) {
		return {$: 171, a: a, b: b};
	});
var $author$project$Main$Update$EnvoyerUnNouveauChampDeLaFicheType = function (a) {
	return {$: 119, a: a};
};
var $author$project$Main$Update$EnvoyerUneCommandeDImageDeLaReference = F2(
	function (a, b) {
		return {$: 158, a: a, b: b};
	});
var $author$project$Main$Update$LireLActiviteDUneReference = function (a) {
	return {$: 162, a: a};
};
var $author$project$Main$Update$LireLApercuDeLaRegleDeCode = function (a) {
	return {$: 129, a: a};
};
var $author$project$Main$Update$LireLApercuDeLaRestriction = function (a) {
	return {$: 128, a: a};
};
var $author$project$Main$Update$LireLApercuDuCalculEnLotDuCatalogue = function (a) {
	return {$: 141, a: a};
};
var $author$project$Main$Update$LireLApercuDuRecalculDeLaReference = function (a) {
	return {$: 151, a: a};
};
var $author$project$Main$Update$LireLApercuDuResserrage = function (a) {
	return {$: 124, a: a};
};
var $author$project$Main$Update$LireLImageDeLaReference = function (a) {
	return {$: 157, a: a};
};
var $author$project$Main$Update$LireLOrdreDesBlocs = F2(
	function (a, b) {
		return {$: 127, a: a, b: b};
	});
var $author$project$Main$Update$LireLaBibliothequeDeLaFicheType = function (a) {
	return {$: 116, a: a};
};
var $author$project$Main$Update$LireLaFicheDUnProduitDeLaReference = function (a) {
	return {$: 148, a: a};
};
var $author$project$Main$Update$LireLaFicheDUneCategorie = function (a) {
	return {$: 147, a: a};
};
var $author$project$Main$Update$LireLaListeDuChampDeLaFicheType = function (a) {
	return {$: 125, a: a};
};
var $author$project$Main$Update$LireLaStructureDUnNiveau = function (a) {
	return {$: 130, a: a};
};
var $author$project$Main$Update$LireLaStructureDesTypologies = function (a) {
	return {$: 133, a: a};
};
var $author$project$Main$Update$LireLaValeurDuPerimetreDeLaReference = F2(
	function (a, b) {
		return {$: 149, a: a, b: b};
	});
var $author$project$Main$Update$LireLeCodeProposeDuCatalogue = function (a) {
	return {$: 146, a: a};
};
var $author$project$Main$Update$LireLeComptageDesRolesDesElements = F2(
	function (a, b) {
		return {$: 167, a: a, b: b};
	});
var $author$project$Main$Update$LireLeSchemaEffectifDuCatalogue = function (a) {
	return {$: 145, a: a};
};
var $author$project$Main$Update$LireLesDocumentsDeLaReference = function (a) {
	return {$: 156, a: a};
};
var $author$project$Main$Update$LireLesElements = F2(
	function (a, b) {
		return {$: 114, a: a, b: b};
	});
var $author$project$Main$Update$LireLesListesDeLaFicheType = function (a) {
	return {$: 117, a: a};
};
var $author$project$Main$Update$LireLesListesDuNouveauChampDeLaFicheType = function (a) {
	return {$: 118, a: a};
};
var $author$project$Main$Update$LireLesPerimetresDeLaReference = F2(
	function (a, b) {
		return {$: 150, a: a, b: b};
	});
var $author$project$Main$Update$LireLesPrixDesElements = F2(
	function (a, b) {
		return {$: 166, a: a, b: b};
	});
var $author$project$Main$Update$LireLesReferencesARangerDuCatalogue = function (a) {
	return {$: 140, a: a};
};
var $author$project$Main$Update$LireLesValeursPoseesDeLaFicheType = function (a) {
	return {$: 126, a: a};
};
var $author$project$Main$Update$LireLesVersionsDUnType = function (a) {
	return {$: 115, a: a};
};
var $author$project$Main$Update$PoserSurLAdresseDeLaReference = function (a) {
	return {$: 160, a: a};
};
var $author$project$Main$Update$PoserUnMorceauDeFichier = function (a) {
	return {$: 154, a: a};
};
var $author$project$Main$Update$ProposerLesCategoriesDuCatalogue = function (a) {
	return {$: 143, a: a};
};
var $author$project$Main$Update$ProposerLesPartiesPrenantesDeLaReference = function (a) {
	return {$: 161, a: a};
};
var $author$project$Main$Update$ProposerLesProduitsDuCatalogue = function (a) {
	return {$: 144, a: a};
};
var $author$project$Preferences$Model$setAnnuaire = F3(
	function (cle, modifier, preferences) {
		var gardees = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Preferences$Model$gardeesVides,
			A2($elm$core$Dict$get, cle, preferences.aq));
		return _Utils_update(
			preferences,
			{
				aq: A3(
					$elm$core$Dict$insert,
					cle,
					modifier(gardees),
					preferences.aq)
			});
	});
var $author$project$Preferences$Model$setVue = F3(
	function (cle, vue, preferences) {
		return A3(
			$author$project$Preferences$Model$setAnnuaire,
			cle,
			function (gardees) {
				return _Utils_update(
					gardees,
					{
						io: $elm$core$Maybe$Just(vue)
					});
			},
			preferences);
	});
var $author$project$Routes$Route$adresseCatalogue = '/' + ($author$project$Routes$Route$segmentProduits + ('/' + $author$project$Routes$Route$segmentCatalogue));
var $author$project$Routes$Route$adresseARanger = function (id) {
	return $author$project$Routes$Route$adresseCatalogue + ('/' + ($author$project$Routes$Route$segmentDesTypologies + ('/' + ($author$project$Catalogue$Identifiants$classificationIdToString(id) + ('/' + $author$project$Routes$Route$segmentARanger)))));
};
var $author$project$Routes$Route$adresseAlertes = '/' + $author$project$Routes$Route$segmentAlertes;
var $author$project$Routes$Route$adresseAlertesDePartiesPrenantes = $author$project$Routes$Route$adresseAlertes + ('/' + $author$project$Routes$Route$segmentPartiesPrenantes);
var $author$project$Routes$Route$adresseBibliothequeDeChamps = '/' + ($author$project$Routes$Route$segmentParametrage + ('/' + $author$project$Routes$Route$segmentBibliothequeDeChamps));
var $author$project$Routes$Route$adresseCorrespondances = '/' + ($author$project$Routes$Route$segmentParametrage + ('/' + $author$project$Routes$Route$segmentCorrespondances));
var $author$project$Routes$Route$adresseDesUtilisateurs = '/' + ($author$project$Routes$Route$segmentParametrage + ('/' + $author$project$Routes$Route$segmentUtilisateurs));
var $author$project$Routes$Route$adresseDUnUtilisateur = function (uid) {
	return $author$project$Routes$Route$adresseDesUtilisateurs + ('/' + $elm$url$Url$percentEncode(uid));
};
var $author$project$Routes$Route$adresseDeLaCorrespondance = function (id) {
	return $author$project$Routes$Route$adresseCorrespondances + ('/' + id);
};
var $author$project$Routes$Route$adresseListes = '/' + ($author$project$Routes$Route$segmentParametrage + ('/' + $author$project$Routes$Route$segmentListes));
var $author$project$Routes$Route$adresseDeLaListe = function (id) {
	return $author$project$Routes$Route$adresseListes + ('/' + id);
};
var $author$project$Routes$Route$champEcrit = function (entree) {
	var _v0 = A2($elm$core$String$split, ':', entree);
	if (_v0.b && _v0.b.b) {
		var cle = _v0.a;
		var _v1 = _v0.b;
		var premier = _v1.a;
		var suite = _v1.b;
		return cle + (':' + $elm$url$Url$percentEncode(
			A2(
				$elm$core$String$join,
				':',
				A2($elm$core$List$cons, premier, suite))));
	} else {
		return entree;
	}
};
var $author$project$Routes$Route$adresseDeLaListeDesReferences = function (demandee) {
	var liste = F2(
		function (nom, codes) {
			return A2(
				$elm$core$List$map,
				function (code) {
					return nom + ('=' + code);
				},
				codes);
		});
	var ecrits = _Utils_ap(
		A2(liste, $author$project$Routes$Route$parametreEtat, demandee.mj),
		_Utils_ap(
			A2(liste, $author$project$Routes$Route$parametreMarque, demandee.cU),
			_Utils_ap(
				A2(liste, $author$project$Routes$Route$parametreGamme, demandee.gG),
				_Utils_ap(
					A2(liste, $author$project$Routes$Route$parametreTypologie, demandee.r7),
					_Utils_ap(
						A2(liste, $author$project$Routes$Route$parametreFamille, demandee.mu),
						_Utils_ap(
							A2(liste, $author$project$Routes$Route$parametreCategorie, demandee.dt),
							_Utils_ap(
								A2(
									liste,
									$author$project$Routes$Route$parametreChamps,
									A2($elm$core$List$map, $author$project$Routes$Route$champEcrit, demandee.dw)),
								_Utils_ap(
									A2(
										liste,
										$author$project$Routes$Route$parametreTypeDeProduit,
										A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2($elm$core$Maybe$map, $elm$core$List$singleton, demandee.fh))),
									_Utils_ap(
										A2(liste, $author$project$Routes$Route$parametreRenseignes, demandee.qs),
										_Utils_ap(
											A2(liste, $author$project$Routes$Route$parametrePlages, demandee.pn),
											_Utils_ap(
												A2(
													liste,
													$author$project$Routes$Route$parametreCompletude,
													A2(
														$elm$core$Maybe$withDefault,
														_List_Nil,
														A2($elm$core$Maybe$map, $elm$core$List$singleton, demandee.fU))),
												_Utils_ap(
													demandee.i2 ? _List_fromArray(
														[$author$project$Routes$Route$parametreArretees + ('=' + $author$project$Routes$Route$valeurArretees)]) : _List_Nil,
													_Utils_ap(
														(!_Utils_eq(demandee.rS, $author$project$Routes$Route$triParDefautDesReferences)) ? _List_fromArray(
															[$author$project$Routes$Route$parametreTri + ('=' + demandee.rS)]) : _List_Nil,
														_Utils_ap(
															(demandee.EE !== 1) ? _List_fromArray(
																[
																	$author$project$Routes$Route$parametrePage + ('=' + $elm$core$String$fromInt(demandee.EE))
																]) : _List_Nil,
															(!_Utils_eq(demandee.Jm, $author$project$Routes$Route$tailleParDefaut)) ? _List_fromArray(
																[
																	$author$project$Routes$Route$parametreTaille + ('=' + $elm$core$String$fromInt(demandee.Jm))
																]) : _List_Nil))))))))))))));
	return _Utils_ap(
		$author$project$Routes$Route$adresseCatalogue,
		$elm$core$List$isEmpty(ecrits) ? '' : ('?' + A2($elm$core$String$join, '&', ecrits)));
};
var $author$project$Routes$Route$adresseDeLaSecuriteDesUtilisateurs = $author$project$Routes$Route$adresseDesUtilisateurs + ('/' + $author$project$Routes$Route$segmentSecuriteDesUtilisateurs);
var $author$project$Routes$Route$adresseDeMonCompte = '/' + $author$project$Routes$Route$segmentMonCompte;
var $author$project$Routes$Route$adresseDeLaSecuriteDuCompte = $author$project$Routes$Route$adresseDeMonCompte + '/securite';
var $author$project$Routes$Route$adresseDemonstration = '/' + $author$project$Routes$Route$segmentDemonstration;
var $author$project$Routes$Route$adresseDesDroits = '/' + ($author$project$Routes$Route$segmentParametrage + ('/' + $author$project$Routes$Route$segmentDroits));
var $author$project$Routes$Route$adresseDesEcheancesDeConservation = '/' + ($author$project$Routes$Route$segmentParametrage + ('/' + $author$project$Routes$Route$segmentConservation));
var $author$project$Routes$Route$adresseDesLanguesDuClient = '/' + ($author$project$Routes$Route$segmentParametrage + ('/' + $author$project$Routes$Route$segmentLangues));
var $author$project$Routes$Route$adresseDesNotifications = '/' + $author$project$Routes$Route$segmentNotifications;
var $author$project$Routes$Route$adresseDesPerimetres = '/' + ($author$project$Routes$Route$segmentParametrage + ('/' + $author$project$Routes$Route$segmentPerimetres));
var $author$project$Routes$Route$adresseDesSessionsDuCompte = $author$project$Routes$Route$adresseDeMonCompte + '/sessions';
var $author$project$Routes$Route$adresseDesTypesDeQuantite = '/' + ($author$project$Routes$Route$segmentParametrage + ('/' + $author$project$Routes$Route$segmentTypesDeQuantite));
var $author$project$Routes$Route$adressePipes = '/' + ($author$project$Routes$Route$segmentParametrage + ('/' + $author$project$Routes$Route$segmentPipes));
var $author$project$Routes$Route$adresseNouveauPipe = $author$project$Routes$Route$adressePipes + ('/' + $author$project$Routes$Route$segmentNouveauPipe);
var $author$project$Routes$Route$adressePipeEtape1 = function (code) {
	return $elm$core$String$isEmpty(code) ? $author$project$Routes$Route$adresseNouveauPipe : ($author$project$Routes$Route$adressePipes + ('/' + $elm$url$Url$percentEncode(code)));
};
var $author$project$Routes$Route$adressePipeEtape5 = function (code) {
	return $author$project$Routes$Route$adressePipeEtape1(code) + ('/' + $author$project$Routes$Route$segmentFormulaires);
};
var $author$project$Routes$Route$adresseDestinationsDesChamps = F2(
	function (code, formulaire) {
		return $author$project$Routes$Route$adressePipeEtape5(code) + ('/' + ($elm$url$Url$percentEncode(formulaire) + ('/' + $author$project$Routes$Route$segmentDestinations)));
	});
var $author$project$Routes$Route$adressePartiesPrenantes = '/' + $author$project$Routes$Route$segmentPartiesPrenantes;
var $author$project$Routes$Route$adresseDoublons = $author$project$Routes$Route$adressePartiesPrenantes + ('/' + $author$project$Routes$Route$segmentDoublons);
var $author$project$Routes$Route$adresseDoublonsEcartees = $author$project$Routes$Route$adresseDoublons + ('/' + $author$project$Routes$Route$segmentEcartees);
var $author$project$Routes$Route$adresseDuChampDeLaBibliotheque = function (id) {
	return $author$project$Routes$Route$adresseBibliothequeDeChamps + ('?' + ($author$project$Routes$Route$parametreChampDeLaBibliotheque + ('=' + $elm$url$Url$percentEncode(id))));
};
var $author$project$Routes$Route$adresseDuCompteDEnvoi = '/' + ($author$project$Routes$Route$segmentParametrage + ('/' + $author$project$Routes$Route$segmentCompteDEnvoi));
var $author$project$Routes$Route$adresseDuCompteurDeCode = '/' + ($author$project$Routes$Route$segmentParametrage + ('/' + $author$project$Routes$Route$segmentCompteurDeCode));
var $author$project$Routes$Route$adresseDuJournalDesConnexions = function (utilisateur) {
	return $author$project$Routes$Route$adresseDesUtilisateurs + ('/' + ($author$project$Routes$Route$segmentConnexions + A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (uid) {
				return '?utilisateur=' + $elm$url$Url$percentEncode(uid);
			},
			utilisateur))));
};
var $author$project$Routes$Route$adresseImporter = '/' + $author$project$Routes$Route$segmentImporter;
var $author$project$Routes$Route$adresseDuLotDImport = function (lot) {
	return $author$project$Routes$Route$adresseImporter + ('/' + ($author$project$Routes$Route$segmentLotDImport + ('/' + lot)));
};
var $author$project$Routes$Route$adresseDuPerimetre = function (id) {
	return $author$project$Routes$Route$adresseDesPerimetres + ('/' + id);
};
var $author$project$Routes$Route$adresseGroupes = '/' + ($author$project$Routes$Route$segmentParametrage + ('/' + $author$project$Routes$Route$segmentGroupes));
var $author$project$Routes$Route$adresseHistoriqueDesImports = $author$project$Routes$Route$adresseImporter + ('/' + $author$project$Routes$Route$segmentHistoriqueDesImports);
var $author$project$Routes$Route$adresseImporterAvec = F2(
	function (domaine, type_) {
		return _Utils_ap(
			$author$project$Routes$Route$adresseImporter,
			function () {
				var _v0 = _Utils_Tuple2(domaine, type_);
				if (!_v0.a.$) {
					if (!_v0.b.$) {
						var d = _v0.a.a;
						var t = _v0.b.a;
						return '?domaine=' + (d + ('&type=' + t));
					} else {
						var d = _v0.a.a;
						var _v1 = _v0.b;
						return '?domaine=' + d;
					}
				} else {
					return '';
				}
			}());
	});
var $author$project$Routes$Route$adresseListesDePrix = '/' + ($author$project$Routes$Route$segmentProduits + ('/' + $author$project$Routes$Route$segmentListesDePrix));
var $author$project$Catalogue$Identifiants$listeDePrixIdToString = function (_v0) {
	var valeur = _v0;
	return valeur;
};
var $author$project$Routes$Route$adresseListeDePrix = function (id) {
	return $author$project$Routes$Route$adresseListesDePrix + ('/' + $author$project$Catalogue$Identifiants$listeDePrixIdToString(id));
};
var $author$project$Routes$Route$adresseMarquesEtGammes = '/' + ($author$project$Routes$Route$segmentProduits + ('/' + $author$project$Routes$Route$segmentMarquesEtGammes));
var $author$project$Routes$Route$adresseModelesDeTache = $author$project$Routes$Route$adressePipes + ('/' + $author$project$Routes$Route$segmentModelesDeTache);
var $author$project$Routes$Route$adresseNouvelleReference = $author$project$Routes$Route$adresseCatalogue + ('/' + $author$project$Routes$Route$segmentNouvelleReference);
var $author$project$Routes$Route$adresseOffres = '/' + ($author$project$Routes$Route$segmentProduits + ('/' + $author$project$Routes$Route$segmentOffres));
var $author$project$Routes$Route$adresseParametrageCatalogue = '/' + ($author$project$Routes$Route$segmentParametrage + ('/' + $author$project$Routes$Route$segmentCatalogue));
var $author$project$Routes$Route$adressePipeEtape2 = function (code) {
	return $author$project$Routes$Route$adressePipeEtape1(code) + ('/' + $author$project$Routes$Route$segmentEtapes);
};
var $author$project$Routes$Route$adressePipeEtape3 = function (code) {
	return $author$project$Routes$Route$adressePipeEtape1(code) + ('/' + $author$project$Routes$Route$segmentRoles);
};
var $author$project$Routes$Route$adressePipeEtape4 = function (code) {
	return $author$project$Routes$Route$adressePipeEtape1(code) + ('/' + $author$project$Routes$Route$segmentTaches);
};
var $author$project$Routes$Route$adressePipeEtape6 = function (code) {
	return $author$project$Routes$Route$adressePipeEtape1(code) + ('/' + $author$project$Routes$Route$segmentVisibilite);
};
var $author$project$Routes$Route$adressePipeEtape7 = function (code) {
	return $author$project$Routes$Route$adressePipeEtape1(code) + ('/' + $author$project$Routes$Route$segmentAutomatismes);
};
var $author$project$Routes$Route$adressePipeEtape8 = function (code) {
	return $author$project$Routes$Route$adressePipeEtape1(code) + ('/' + $author$project$Routes$Route$segmentVerificationDuPipe);
};
var $author$project$Routes$Route$adresseReferences = '/' + ($author$project$Routes$Route$segmentProduits + ('/' + $author$project$Routes$Route$segmentReferences));
var $author$project$Routes$Route$adresseRelationsExigees = function (code) {
	return $author$project$Routes$Route$adressePipeEtape1(code) + ('/' + ($author$project$Routes$Route$segmentRoles + ('/' + $author$project$Routes$Route$segmentRelationsExigees)));
};
var $author$project$Routes$Route$adresseTypesDePartiesPrenantes = '/' + ($author$project$Routes$Route$segmentParametrage + ('/' + $author$project$Routes$Route$segmentTypesDePartiesPrenantes));
var $author$project$Routes$Route$adresseTypesDeProduits = '/' + ($author$project$Routes$Route$segmentParametrage + ('/' + $author$project$Routes$Route$segmentTypesDeProduits));
var $author$project$Routes$Route$adresseUsagesDeLOffre = function (code) {
	return $author$project$Routes$Route$adressePipeEtape1(code) + ('/' + ($author$project$Routes$Route$segmentOffre + ('/' + $author$project$Routes$Route$segmentUsages)));
};
var $author$project$Routes$Route$adresseVersionsDuPipe = function (code) {
	return $author$project$Routes$Route$adressePipeEtape1(code) + ('/' + $author$project$Routes$Route$segmentVersions);
};
var $author$project$Components$Referentiel$Identifiants$groupeUidToString = function (_v0) {
	var valeur = _v0;
	return valeur;
};
var $author$project$Routes$Route$parametreDeDate = function (date) {
	if (!date.$) {
		var jour = date.a;
		return '?' + ($author$project$Routes$Route$parametreDate + ('=' + $elm$url$Url$percentEncode(jour)));
	} else {
		return '';
	}
};
var $author$project$Routes$Route$filtreDeChampPourLAdresse = function (filtre) {
	return filtre.r0 + ('.' + (filtre.dy + function () {
		var _v0 = filtre.fm;
		if (!_v0.$) {
			var texte = _v0.a;
			return '.t.' + $elm$url$Url$percentEncode(texte);
		} else {
			if (_v0.a) {
				return '.b.true';
			} else {
				return '.b.false';
			}
		}
	}()));
};
var $author$project$Routes$Route$parametres = function (demandee) {
	var filtre = F2(
		function (nom, valeur) {
			return A2(
				$elm$core$Maybe$map,
				function (code) {
					return nom + ('=' + code);
				},
				valeur);
		});
	var ecrits = _Utils_ap(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(filtre, $author$project$Routes$Route$parametreNature, demandee.mG.g1),
					A2(filtre, $author$project$Routes$Route$parametreQualite, demandee.mG.hy),
					A2(filtre, $author$project$Routes$Route$parametrePays, demandee.mG.ho),
					A2(filtre, $author$project$Routes$Route$parametreEtat, demandee.mG.gt),
					A2(filtre, $author$project$Routes$Route$parametreGroupe, demandee.mG.m2),
					A2(filtre, $author$project$Routes$Route$parametreOffre, demandee.mG.D1)
				])),
		_Utils_ap(
			A2(
				$elm$core$List$map,
				function (code) {
					return $author$project$Routes$Route$parametreType + ('=' + code);
				},
				demandee.mG.ib),
			_Utils_ap(
				A2(
					$elm$core$List$map,
					function (unFiltre) {
						return $author$project$Routes$Route$parametreChamp + ('=' + $author$project$Routes$Route$filtreDeChampPourLAdresse(unFiltre));
					},
					demandee.mG.dw),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						function (cle) {
							return $author$project$Routes$Route$parametreRenseignes + ('=' + cle);
						},
						demandee.mG.qs),
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								(!(!demandee.rS)) ? $elm$core$Maybe$Just(
								$author$project$Routes$Route$parametreTri + ('=' + $author$project$Routes$Route$codeDuTri(demandee.rS))) : $elm$core$Maybe$Nothing,
								(demandee.EE !== 1) ? $elm$core$Maybe$Just(
								$author$project$Routes$Route$parametrePage + ('=' + $elm$core$String$fromInt(demandee.EE))) : $elm$core$Maybe$Nothing,
								(!_Utils_eq(demandee.Jm, $author$project$Routes$Route$tailleParDefaut)) ? $elm$core$Maybe$Just(
								$author$project$Routes$Route$parametreTaille + ('=' + $elm$core$String$fromInt(demandee.Jm))) : $elm$core$Maybe$Nothing
							]))))));
	return $elm$core$List$isEmpty(ecrits) ? '' : ('?' + A2($elm$core$String$join, '&', ecrits));
};
var $author$project$Catalogue$Identifiants$referenceIdToString = function (_v0) {
	var valeur = _v0;
	return valeur;
};
var $author$project$Routes$Route$toString = function (route) {
	switch (route.$) {
		case 0:
			return '/';
		case 1:
			return $author$project$Routes$Route$adresseAccueil;
		case 2:
			var demandee = route.a;
			return _Utils_ap(
				$author$project$Routes$Route$adressePartiesPrenantes,
				$author$project$Routes$Route$parametres(
					$author$project$Routes$Route$normaliser(demandee)));
		case 3:
			var uid = route.a;
			var onglet = route.b;
			return A2(
				$elm$core$String$join,
				'/',
				A2(
					$elm$core$List$cons,
					$author$project$Routes$Route$adressePartiesPrenantes,
					A2(
						$elm$core$List$cons,
						$author$project$Components$Referentiel$Identifiants$entiteUidToString(uid),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								$elm$core$List$singleton,
								$author$project$Routes$Route$segmentDOnglet(onglet))))));
		case 4:
			var uid = route.a;
			var autre = route.b;
			return A2(
				$elm$core$String$join,
				'/',
				_List_fromArray(
					[
						$author$project$Routes$Route$adressePartiesPrenantes,
						$author$project$Components$Referentiel$Identifiants$entiteUidToString(uid),
						$author$project$Routes$Route$segmentFusion,
						$author$project$Components$Referentiel$Identifiants$entiteUidToString(autre)
					]));
		case 5:
			return $author$project$Routes$Route$adressePartiesPrenantes;
		case 6:
			var etape = route.a;
			var typologie = route.b;
			return _Utils_ap(
				A2(
					$elm$core$String$join,
					'/',
					A2(
						$elm$core$List$cons,
						$author$project$Routes$Route$adresseParametrageCatalogue,
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								$elm$core$List$singleton,
								$author$project$Routes$Route$segmentDEtape(etape))))),
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function (id) {
							return '?' + ($author$project$Routes$Route$parametreTypologie + ('=' + $elm$url$Url$percentEncode(
								$author$project$Catalogue$Identifiants$classificationIdToString(id))));
						},
						typologie)));
		case 7:
			var id = route.a;
			return A2(
				$elm$core$String$join,
				'/',
				_List_fromArray(
					[
						$author$project$Routes$Route$adresseParametrageCatalogue,
						$author$project$Routes$Route$segmentNiveaux,
						$author$project$Catalogue$Identifiants$niveauIdToString(id),
						$author$project$Routes$Route$segmentChamps
					]));
		case 8:
			return $author$project$Routes$Route$adresseMarquesEtGammes;
		case 9:
			return $author$project$Routes$Route$adressePipes;
		case 11:
			var code = route.a;
			return $author$project$Routes$Route$adressePipeEtape1(code);
		case 12:
			var code = route.a;
			return $author$project$Routes$Route$adressePipeEtape2(code);
		case 13:
			var code = route.a;
			return $author$project$Routes$Route$adressePipeEtape3(code);
		case 14:
			var code = route.a;
			return $author$project$Routes$Route$adressePipeEtape4(code);
		case 15:
			var code = route.a;
			return $author$project$Routes$Route$adressePipeEtape5(code);
		case 16:
			var code = route.a;
			return $author$project$Routes$Route$adressePipeEtape6(code);
		case 17:
			var code = route.a;
			return $author$project$Routes$Route$adressePipeEtape7(code);
		case 18:
			var code = route.a;
			return $author$project$Routes$Route$adressePipeEtape8(code);
		case 19:
			var code = route.a;
			return $author$project$Routes$Route$adresseVersionsDuPipe(code);
		case 10:
			return $author$project$Routes$Route$adresseModelesDeTache;
		case 20:
			var code = route.a;
			return $author$project$Routes$Route$adresseUsagesDeLOffre(code);
		case 21:
			var code = route.a;
			var formulaire = route.b;
			return A2($author$project$Routes$Route$adresseDestinationsDesChamps, code, formulaire);
		case 22:
			var code = route.a;
			return $author$project$Routes$Route$adresseRelationsExigees(code);
		case 23:
			var id = route.a;
			return $author$project$Routes$Route$adresseMarquesEtGammes + ('/' + $author$project$Catalogue$Identifiants$elementIdToString(id));
		case 24:
			return $author$project$Routes$Route$adresseMarquesEtGammes;
		case 25:
			var demandee = route.a;
			return $author$project$Routes$Route$adresseDeLaListeDesReferences(demandee);
		case 26:
			var id = route.a;
			return $author$project$Routes$Route$adresseARanger(id);
		case 27:
			return $author$project$Routes$Route$adresseNouvelleReference;
		case 28:
			var id = route.a;
			return $author$project$Routes$Route$adresseReferences + ('/' + $author$project$Catalogue$Identifiants$referenceIdToString(id));
		case 29:
			return $author$project$Routes$Route$adresseCatalogue;
		case 30:
			return $author$project$Routes$Route$adresseOffres;
		case 31:
			var id = route.a;
			return $author$project$Routes$Route$adresseOffres + ('/' + $author$project$Catalogue$Identifiants$referenceIdToString(id));
		case 32:
			return $author$project$Routes$Route$adresseOffres;
		case 33:
			return $author$project$Routes$Route$adresseAlertes;
		case 34:
			return $author$project$Routes$Route$adresseAlertesDePartiesPrenantes;
		case 35:
			return $author$project$Routes$Route$adresseDoublons;
		case 36:
			return $author$project$Routes$Route$adresseDoublonsEcartees;
		case 37:
			return $author$project$Routes$Route$adresseListesDePrix;
		case 38:
			var id = route.a;
			return $author$project$Routes$Route$adresseListeDePrix(id);
		case 39:
			return $author$project$Routes$Route$adresseListesDePrix;
		case 40:
			var id = route.a;
			return $author$project$Routes$Route$adresseTypesDeProduits + ('/' + $author$project$Catalogue$Identifiants$typeDeProduitIdToString(id));
		case 41:
			return $author$project$Routes$Route$adresseTypesDeProduits;
		case 42:
			var etape = route.a;
			var uid = route.b;
			return A2(
				$elm$core$String$join,
				'/',
				A2(
					$elm$core$List$cons,
					$author$project$Routes$Route$adresseTypesDePartiesPrenantes,
					function () {
						var _v1 = _Utils_Tuple2(
							$author$project$Routes$Route$segmentDEtapeDesTypes(etape),
							uid);
						if (!_v1.a.$) {
							if (!_v1.b.$) {
								var segment = _v1.a.a;
								var type_ = _v1.b.a;
								return _List_fromArray(
									[
										segment,
										$author$project$Components$Referentiel$Identifiants$typeUidToString(type_)
									]);
							} else {
								var segment = _v1.a.a;
								var _v2 = _v1.b;
								return _List_fromArray(
									[segment]);
							}
						} else {
							var _v3 = _v1.a;
							return _List_Nil;
						}
					}()));
		case 54:
			return $author$project$Routes$Route$adresseDesEcheancesDeConservation;
		case 55:
			return $author$project$Routes$Route$adresseDesLanguesDuClient;
		case 56:
			return $author$project$Routes$Route$adresseDesUtilisateurs;
		case 57:
			return $author$project$Routes$Route$adresseDeLaSecuriteDesUtilisateurs;
		case 58:
			var uid = route.a;
			return $author$project$Routes$Route$adresseDUnUtilisateur(uid);
		case 59:
			var utilisateur = route.a;
			return $author$project$Routes$Route$adresseDuJournalDesConnexions(utilisateur);
		case 60:
			return $author$project$Routes$Route$adresseDuCompteurDeCode;
		case 61:
			return $author$project$Routes$Route$adresseDuCompteDEnvoi;
		case 62:
			return $author$project$Routes$Route$adresseDesNotifications;
		case 63:
			return $author$project$Routes$Route$adresseDeMonCompte;
		case 64:
			return $author$project$Routes$Route$adresseDeLaSecuriteDuCompte;
		case 65:
			return $author$project$Routes$Route$adresseDesSessionsDuCompte;
		case 66:
			var domaine = route.a;
			var type_ = route.b;
			return A2($author$project$Routes$Route$adresseImporterAvec, domaine, type_);
		case 67:
			return $author$project$Routes$Route$adresseHistoriqueDesImports;
		case 68:
			var lot = route.a;
			return $author$project$Routes$Route$adresseDuLotDImport(lot);
		case 53:
			var etape = route.a;
			return A2(
				$elm$core$String$join,
				'/',
				A2(
					$elm$core$List$cons,
					$author$project$Routes$Route$adresseDesDroits,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							$elm$core$List$singleton,
							$author$project$Routes$Route$segmentDEtapeDesDroits(etape)))));
		case 69:
			if (!route.b) {
				var uid = route.a;
				var _v4 = route.b;
				return $author$project$Routes$Route$adresseTypesDePartiesPrenantes + ('/' + $author$project$Components$Referentiel$Identifiants$typeUidToString(uid));
			} else {
				var uid = route.a;
				var _v5 = route.b;
				return $author$project$Routes$Route$toString(
					A2($author$project$Routes$Route$FicheTypeDePartiePrenante, uid, 0)) + ('/' + $author$project$Routes$Route$segmentChamps);
			}
		case 70:
			return $author$project$Routes$Route$adresseTypesDePartiesPrenantes;
		case 43:
			return $author$project$Routes$Route$adresseGroupes;
		case 44:
			return $author$project$Routes$Route$adresseListes;
		case 45:
			var id = route.a;
			return $author$project$Routes$Route$adresseDeLaListe(id);
		case 47:
			return $author$project$Routes$Route$adresseDesPerimetres;
		case 48:
			var id = route.a;
			return $author$project$Routes$Route$adresseDuPerimetre(id);
		case 49:
			return $author$project$Routes$Route$adresseDesTypesDeQuantite;
		case 46:
			return $author$project$Routes$Route$adresseCorrespondances;
		case 50:
			var id = route.a;
			return $author$project$Routes$Route$adresseDeLaCorrespondance(id);
		case 51:
			var champ = route.a;
			return A2(
				$elm$core$Maybe$withDefault,
				$author$project$Routes$Route$adresseBibliothequeDeChamps,
				A2($elm$core$Maybe$map, $author$project$Routes$Route$adresseDuChampDeLaBibliotheque, champ));
		case 52:
			var uid = route.a;
			var date = route.b;
			return $author$project$Routes$Route$adresseGroupes + ('/' + ($author$project$Components$Referentiel$Identifiants$groupeUidToString(uid) + $author$project$Routes$Route$parametreDeDate(date)));
		case 71:
			return $author$project$Routes$Route$adresseDemonstration;
		case 74:
			return $author$project$Routes$Route$adresseDemonstration;
		case 72:
			var annuaire = route.a;
			return $author$project$Routes$Route$adresseDemonstration + ('/' + $author$project$Routes$Route$segmentAnnuaire(annuaire));
		default:
			if (!route.c) {
				var annuaire = route.a;
				var id = route.b;
				var _v6 = route.c;
				return $author$project$Routes$Route$toString(
					$author$project$Routes$Route$DemonstrationAnnuaire(annuaire)) + ('/' + id);
			} else {
				var annuaire = route.a;
				var id = route.b;
				var _v7 = route.c;
				return $author$project$Routes$Route$toString(
					A3($author$project$Routes$Route$DemonstrationFiche, annuaire, id, 0)) + ('/' + $author$project$Routes$Route$segmentHistorique);
			}
	}
};
var $author$project$Main$Update$depuisLesElements = F5(
	function (i18n, ecran, demandeur, effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[demandeur]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 1:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLesElements(ecran))));
			case 2:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesVersionsDUnType)));
			case 3:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLaBibliothequeDeLaFicheType)));
			case 4:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesListesDeLaFicheType)));
			case 5:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesListesDuNouveauChampDeLaFicheType)));
			case 6:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerUnNouveauChampDeLaFicheType(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 7:
				var lien = effet.a;
				var type_ = effet.b;
				var champ = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$LireLApercuDuResserrage(
									{
										uN: champ,
										gM: vers.gM,
										nB: vers.nB,
										fh: $author$project$Catalogue$Identifiants$typeDeProduitIdToString(type_)
									});
							})));
			case 8:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLaListeDuChampDeLaFicheType)));
			case 9:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesValeursPoseesDeLaFicheType)));
			case 10:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLOrdreDesBlocs(ecran))));
			case 11:
				var lien = effet.a;
				var type_ = effet.b;
				var champ = effet.c;
				var valeurs = effet.d;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$LireLApercuDeLaRestriction(
									{
										uN: champ,
										gM: vers.gM,
										nB: vers.nB,
										fh: $author$project$Catalogue$Identifiants$typeDeProduitIdToString(type_),
										Ki: valeurs
									});
							})));
			case 12:
				var lien = effet.a;
				var type_ = effet.b;
				var segments = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$LireLApercuDeLaRegleDeCode(
									{
										gM: vers.gM,
										nB: vers.nB,
										Iy: segments,
										fh: $author$project$Catalogue$Identifiants$typeDeProduitIdToString(type_)
									});
							})));
			case 14:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLesElements(ecran))));
			case 13:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function () {
								if (ecran === 8) {
									return $author$project$Main$Update$LireLaStructureDesTypologies;
								} else {
									return $author$project$Main$Update$LireLaStructureDUnNiveau;
								}
							}())));
			case 41:
				var champ = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$LireLApercuDuCalculEnLotDuCatalogue(
									{uN: champ, gM: vers.gM, nB: vers.nB});
							})));
			case 40:
				var typologie = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$CompterLesReferencesARangerDuCatalogue(
									{gM: vers.gM, nB: vers.nB, r3: typologie});
							})));
			case 36:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesReferencesARangerDuCatalogue)));
			case 32:
				var lien = effet.a;
				var valeurs = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$ProposerLesCategoriesDuCatalogue(
									{gM: vers.gM, nB: vers.nB, Ki: valeurs});
							})));
			case 33:
				var lien = effet.a;
				var type_ = effet.b;
				var valeurs = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$ProposerLesProduitsDuCatalogue(
									{gM: vers.gM, nB: vers.nB, r0: type_, Ki: valeurs});
							})));
			case 34:
				var lien = effet.a;
				var type_ = effet.b;
				var valeurs = effet.c;
				var typologie = effet.d;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$LireLeSchemaEffectifDuCatalogue(
									{gM: vers.gM, nB: vers.nB, r0: type_, r3: typologie, Ki: valeurs});
							})));
			case 35:
				var lien = effet.a;
				var type_ = effet.b;
				var valeurs = effet.c;
				var attributs = effet.d;
				var typologie = effet.e;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$LireLeCodeProposeDuCatalogue(
									{i8: attributs, gM: vers.gM, nB: vers.nB, r0: type_, r3: typologie, Ki: valeurs});
							})));
			case 27:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLaFicheDUneCategorie)));
			case 30:
				var numero = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLesPerimetresDeLaReference(numero))));
			case 29:
				var perimetre = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLaValeurDuPerimetreDeLaReference(perimetre))));
			case 28:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLaFicheDUnProduitDeLaReference)));
			case 31:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLApercuDuRecalculDeLaReference)));
			case 15:
				var delaiMs = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								A2($author$project$Main$Update$AttendreAvantDeRelireLesElements, ecran, delaiMs)
							])));
			case 16:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return A2(
									$author$project$Main$Update$EnvoyerAuxElements,
									ecran,
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 17:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			case 18:
				var cle = effet.a;
				var vue = effet.b;
				return A2(
					$author$project$Main$Update$garder,
					A3($author$project$Preferences$Model$setVue, cle, vue, model.eF),
					_Utils_Tuple2(model, effets));
			case 19:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
			case 20:
				var id = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AllerA(
								$author$project$Routes$Route$toString(
									$author$project$Routes$Route$FicheType(id)))
							])));
			case 21:
				var numero = effet.a;
				var lien = effet.b;
				var recherche = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$ChercherLesReferences(
									{gM: vers.gM, nB: vers.nB, DX: numero, hC: recherche});
							})));
			case 22:
				var numero = effet.a;
				var delaiMs = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								A2($author$project$Main$Update$AttendreAvantDeChercherLesReferences, numero, delaiMs)
							])));
			case 37:
				var adresse = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AllerA(adresse)
							])));
			case 38:
				var typologie = effet.a;
				var recherche = effet.b;
				var resume = effet.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							I3: $author$project$Components$Produits$StructureCatalogue$Model$envelopper(
								A3(
									$author$project$Components$Produits$StructureCatalogue$Update$update,
									i18n,
									A2(
										$author$project$Components$Produits$StructureCatalogue$Update$ArchivageSurLeFiltreDemande,
										typologie,
										{
											f$: $author$project$Catalogue$API$QueryAPIModel$encodeRecherche(recherche),
											HX: resume
										}),
									$author$project$Components$Produits$StructureCatalogue$Model$ouvrir(model.I3)).a)
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AllerA(
								$author$project$Routes$Route$toString(
									A2(
										$author$project$Routes$Route$ParametrageCatalogue,
										1,
										$elm$core$Maybe$Just(typologie))))
							])));
			case 39:
				var typologie = effet.a;
				var references = effet.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							I3: $author$project$Components$Produits$StructureCatalogue$Model$envelopper(
								A3(
									$author$project$Components$Produits$StructureCatalogue$Update$update,
									i18n,
									A2($author$project$Components$Produits$StructureCatalogue$Update$ArchivageSurLaSelectionDemande, typologie, references),
									$author$project$Components$Produits$StructureCatalogue$Model$ouvrir(model.I3)).a)
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AllerA(
								$author$project$Routes$Route$toString(
									A2(
										$author$project$Routes$Route$ParametrageCatalogue,
										1,
										$elm$core$Maybe$Just(typologie))))
							])));
			case 23:
				var id = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AllerA(
								$author$project$Routes$Route$toString(
									$author$project$Routes$Route$FicheReference(id)))
							])));
			case 24:
				var lien = effet.a;
				var page = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$LireLActiviteDUneReference(
									{gM: vers.gM, nB: vers.nB, EE: page});
							})));
			case 42:
				var types = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$ChoisirUnFichierDuPoste(types)
							])));
			case 43:
				var lien = effet.a;
				var octets = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$PoserUnMorceauDeFichier(
									{gM: vers.gM, nB: vers.nB, oW: octets});
							})));
			case 44:
				var lien = effet.a;
				var processUid = effet.b;
				var morceaux = effet.c;
				var taille = effet.d;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$DeposerUnFichierDeLaReference(
									{gM: vers.gM, nB: vers.nB, CU: morceaux, Gn: processUid, Jm: taille});
							})));
			case 50:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesDocumentsDeLaReference)));
			case 45:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLImageDeLaReference)));
			case 46:
				var nom = effet.a;
				var lien = effet.b;
				var corps = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return A2(
									$author$project$Main$Update$EnvoyerUneCommandeDImageDeLaReference,
									nom,
									{f$: corps, gM: vers.gM, nB: vers.nB});
							})));
			case 48:
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[$author$project$Main$Update$AnnulerLEnvoiDeLaReference])));
			case 49:
				var fichier = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$LireLesOctetsDuFichier(fichier)
							])));
			case 47:
				var verbe = effet.a;
				var url = effet.b;
				var media = effet.c;
				var octets = effet.d;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PoserSurLAdresseDeLaReference(
								{Ck: media, oW: octets, aQ: url, sm: verbe})
							])));
			case 51:
				var lien = effet.a;
				var typeVise = effet.b;
				var terme = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$ProposerLesPartiesPrenantesDeLaReference(
									{gM: vers.gM, nB: vers.nB, h3: terme, r$: typeVise});
							})));
			case 25:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLesPrixDesElements(ecran))));
			default:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLeComptageDesRolesDesElements(ecran))));
		}
	});
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$categoriesProposeesDecoder = A2(
	$elm$json$Json$Decode$field,
	'categories',
	$elm$json$Json$Decode$list(
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'nom',
			$author$project$Catalogue$API$QueryAPIModel$libellesDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$author$project$Catalogue$Identifiants$typeDeProduitIdDecoder,
				$elm$json$Json$Decode$succeed(
					F2(
						function (id, nom) {
							return {Aq: id, Dj: nom};
						}))))));
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$CodePropose = F2(
	function (regle, code) {
		return {vx: code, hH: regle};
	});
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$codeProposeDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$CodePropose,
	A2($elm$json$Json$Decode$field, 'regle', $elm$json$Json$Decode$bool),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string)));
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$ChampCalcule = F2(
	function (cle, nom) {
		return {dy: cle, Dj: nom};
	});
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$Liste = F8(
	function (references, total, facettes, totaux, plages, champsCalcules, nomDuType, liens) {
		return {uS: champsCalcules, mt: facettes, nQ: liens, Dp: nomDuType, pn: plages, hD: references, JE: total, rJ: totaux};
	});
var $author$project$API$Liens$aucun = {gF: _List_Nil, h0: _List_Nil};
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$Carte = function (id) {
	return function (code) {
		return function (produit) {
			return function (nom) {
				return function (variante) {
					return function (millesime) {
						return function (etat) {
							return function (completude) {
								return function (publication) {
									return function (arretee) {
										return function (marque) {
											return function (gamme) {
												return function (categorie) {
													return function (ouvrable) {
														return function (typologie) {
															return {tL: arretee, uK: categorie, vx: code, fU: completude, gt: etat, z3: gamme, Aq: id, gX: marque, n8: millesime, Dj: nom, Ex: ouvrable, Gp: produit, Gz: publication, r3: typologie, sl: variante};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Catalogue$API$QueryAPIModel$Completude = F2(
	function (remplis, total) {
		return {HB: remplis, JE: total};
	});
var $author$project$Catalogue$API$QueryAPIModel$completudeDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Catalogue$API$QueryAPIModel$Completude,
	A2($elm$json$Json$Decode$field, 'remplis', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'total', $elm$json$Json$Decode$int));
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$TypologieDeCarte = F2(
	function (id, nom) {
		return {Aq: id, Dj: nom};
	});
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$typologieDeCarteDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'nom',
	$author$project$Catalogue$API$QueryAPIModel$libellesDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$author$project$Catalogue$Identifiants$classificationIdDecoder,
		$elm$json$Json$Decode$succeed($author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$TypologieDeCarte)));
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$carteDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'typologie',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$typologieDeCarteDecoder),
	$elm$core$Maybe$Nothing,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		A2(
			$elm$json$Json$Decode$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.h0;
				},
				A2(
					$elm$core$Basics$composeR,
					$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$self),
					$elm$core$Basics$neq($elm$core$Maybe$Nothing))),
			$author$project$API$Liens$deLaRessource),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'categorie',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				$author$project$Catalogue$Vocabulaire$champDeLaGamme,
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Identifiants$elementIdDecoder),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					$author$project$Catalogue$Vocabulaire$champDeLaMarque,
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Identifiants$elementIdDecoder),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'arretee',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'publication',
							$elm$json$Json$Decode$string,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'completude',
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$completudeDecoder),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'etat',
									$author$project$Catalogue$Identifiants$etatCodeDecoder,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'millesime',
										A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'variante',
											A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
											$elm$core$Maybe$Nothing,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'nom',
												A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
												$elm$core$Maybe$Nothing,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													$author$project$Catalogue$Vocabulaire$champDuProduit,
													A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
													$elm$core$Maybe$Nothing,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'code',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'id',
															$author$project$Catalogue$Identifiants$referenceIdDecoder,
															$elm$json$Json$Decode$succeed($author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$Carte))))))))))))))));
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$FacettesServies = F8(
	function (typologies, marques, gammes, familles, categories, etats, completude, champs) {
		return {dt: categories, dw: champs, fU: completude, mj: etats, mu: familles, gG: gammes, cU: marques, r7: typologies};
	});
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$ValeurComptee = F2(
	function (valeur, nombre) {
		return {w: nombre, fm: valeur};
	});
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$FacetteDeChamp = F3(
	function (cle, libelle, valeurs) {
		return {dy: cle, Bl: libelle, Ki: valeurs};
	});
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$ValeurDeChamp = F4(
	function (valeur, libelles, nombre, norme) {
		return {R: libelles, w: nombre, DO: norme, fm: valeur};
	});
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$facetteDeChampDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'valeurs',
	$elm$json$Json$Decode$list(
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'norme',
			$elm$json$Json$Decode$bool,
			false,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'nombre',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'libelles',
					$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'valeur',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$ValeurDeChamp)))))),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'libelle',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'cle',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$FacetteDeChamp))));
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$facettesServiesDecoder = function () {
	var groupe = function (nom) {
		return A2(
			$elm$json$Json$Decode$field,
			nom,
			$elm$json$Json$Decode$list(
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$ValeurComptee,
					A2($elm$json$Json$Decode$field, 'valeur', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'nombre', $elm$json$Json$Decode$int))));
	};
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'champs',
		$elm$json$Json$Decode$list($author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$facetteDeChampDecoder),
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			groupe('completude'),
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				groupe('etats'),
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					groupe('categories'),
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						groupe('familles'),
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							groupe('gammes'),
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
								groupe('marques'),
								A2(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
									groupe('typologies'),
									$elm$json$Json$Decode$succeed($author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$FacettesServies)))))))));
}();
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$PlageOfferte = F4(
	function (cle, groupe, libelle, unite) {
		return {dy: cle, m2: groupe, Bl: libelle, sa: unite};
	});
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$plageOfferteDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'unite',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'libelle',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'groupe',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'cle',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$PlageOfferte)))));
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$TotauxDeLaListe = F5(
	function (references, affichees, completes, incompletes, derniereModification) {
		return {dk: affichees, vT: completes, xl: derniereModification, AG: incompletes, hD: references};
	});
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$totauxDeLaListeDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'derniereModification',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'incompletes',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'completes',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'affichees',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'references',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$TotauxDeLaListe))))));
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$listeDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'_links',
	$author$project$API$Liens$decoder,
	$author$project$API$Liens$aucun,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'nomDuType',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'champsCalcules',
			$elm$json$Json$Decode$list(
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$ChampCalcule,
					A2($elm$json$Json$Decode$field, 'cle', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string))),
			_List_Nil,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'plages',
				$elm$json$Json$Decode$list($author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$plageOfferteDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'totaux',
					$author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$totauxDeLaListeDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'facettes',
						$author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$facettesServiesDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'total',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'references',
								$elm$json$Json$Decode$list($author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$carteDecoder),
								$elm$json$Json$Decode$succeed($author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$Liste)))))))));
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$PageARanger = F2(
	function (references, total) {
		return {hD: references, JE: total};
	});
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$ReferenceARanger = F5(
	function (id, code, typeDeProduit, produit, liens) {
		return {vx: code, Aq: id, nQ: liens, Gp: produit, fh: typeDeProduit};
	});
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$pageARangerDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$PageARanger,
	A2(
		$elm$json$Json$Decode$field,
		'references',
		$elm$json$Json$Decode$list(
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A2(
					$elm$json$Json$Decode$map,
					function ($) {
						return $.h0;
					},
					$author$project$API$Liens$deLaRessource),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					$author$project$Catalogue$Vocabulaire$champDuProduit,
					$author$project$Catalogue$API$QueryAPIModel$libellesDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'typeDeProduit',
						$author$project$Catalogue$Identifiants$typeDeProduitIdDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'code',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$author$project$Catalogue$Identifiants$referenceIdDecoder,
								$elm$json$Json$Decode$succeed($author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$ReferenceARanger)))))))),
	A2($elm$json$Json$Decode$field, 'total', $elm$json$Json$Decode$int));
var $author$project$I18n$Textes$produitsReferencesListeCritereRefuse = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.references.liste.critere-refuse',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'critere',
				$author$project$I18n$Traductions$Sous(p.km))
			]),
		'Le filtre « {critere} » est refusé : cette mesure n\'est pas filtrable, ou son minimum dépasse son maximum. Retire-le ou efface les filtres.');
};
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$SchemaEffectif = F3(
	function (champs, choix, origines) {
		return {dw: champs, jN: choix, hj: origines};
	});
var $author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$ChoixDeListe = F8(
	function (cle, liste, plusieurs, masquee, proposees, portees, restriction, peutEnrichir) {
		return {dy: cle, nW: liste, Ca: masquee, Fk: peutEnrichir, FS: plusieurs, hu: portees, pE: proposees, al: restriction};
	});
var $author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$RestrictionDuChoix = F2(
	function (total, noeud) {
		return {ou: noeud, JE: total};
	});
var $author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$restrictionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'noeud',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'total',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$RestrictionDuChoix)));
var $author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$ValeurDeListe = F3(
	function (id, libelles, archivee) {
		return {tI: archivee, Aq: id, R: libelles};
	});
var $author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$valeurDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'archivee',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'libelles',
		$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$ValeurDeListe))));
var $author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'_links',
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$member('enrichir-la-liste'),
		$elm$json$Json$Decode$list(
			A2($elm$json$Json$Decode$field, 'rel', $elm$json$Json$Decode$string))),
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'restriction',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$restrictionDecoder),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'portees',
			$elm$json$Json$Decode$list($author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$valeurDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'proposees',
				$elm$json$Json$Decode$list($author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$valeurDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'masquee',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'plusieurs',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'liste',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'cle',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$ChoixDeListe)))))))));
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$schemaEffectifDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$SchemaEffectif,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['schema', 'fields']),
		$elm$json$Json$Decode$list($author$project$Components$Shared$EditeurDeSchema$Champ$decoder)),
	A2(
		$elm$json$Json$Decode$field,
		'choix',
		$elm$json$Json$Decode$list($author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$decoder)),
	A2(
		$elm$json$Json$Decode$field,
		'origines',
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)));
var $author$project$Components$Produits$Catalogue$Update$popMessages = function (msg) {
	var deLaLecture = function (lue) {
		if (lue.$ === 1) {
			var refus = lue.a;
			return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				$author$project$Components$Shared$Messages$Model$duRefus(refus));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	switch (msg.$) {
		case 2:
			var reponse = msg.a;
			return deLaLecture(
				A2(
					$elm$core$Result$map,
					function (_v1) {
						return 0;
					},
					A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$catalogueDecoder, reponse)));
		case 3:
			var reponse = msg.b;
			var lue = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$listeDecoder, reponse);
			var _v2 = _Utils_Tuple2(
				lue,
				$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$duRefus(reponse));
			if ((_v2.a.$ === 1) && (_v2.b.$ === 52)) {
				var refus = _v2.a.a;
				var critere = _v2.b.a;
				return $elm$core$Maybe$Just(
					{
						Jx: $author$project$I18n$Textes$produitsReferencesListeCritereRefuse(
							{
								km: $author$project$I18n$Traductions$tel(critere)
							}),
						b9: refus.b9
					});
			} else {
				return deLaLecture(
					A2(
						$elm$core$Result$map,
						function (_v3) {
							return 0;
						},
						lue));
			}
		case 1:
			var octets = msg.a;
			return _Utils_eq(
				$author$project$API$ProcessUid$depuisOctets(octets),
				$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
				{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
		case 36:
			var reponse = msg.a;
			return deLaLecture(
				A2(
					$elm$core$Result$map,
					function (_v4) {
						return 0;
					},
					A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$classificationsDecoder, reponse)));
		case 39:
			var reponse = msg.c;
			return deLaLecture(
				A2(
					$elm$core$Result$map,
					function (_v5) {
						return 0;
					},
					A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$schemaEffectifDecoder, reponse)));
		case 40:
			var reponse = msg.d;
			return deLaLecture(
				A2(
					$elm$core$Result$map,
					function (_v6) {
						return 0;
					},
					A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$codeProposeDecoder, reponse)));
		case 37:
			var reponse = msg.b;
			return deLaLecture(
				A2(
					$elm$core$Result$map,
					function (_v7) {
						return 0;
					},
					A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$categoriesProposeesDecoder, reponse)));
		case 43:
			var reponse = msg.b;
			return deLaLecture(
				A2(
					$elm$core$Result$map,
					function (_v8) {
						return 0;
					},
					A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$pageARangerDecoder, reponse)));
		case 42:
			var reponse = msg.a;
			return deLaLecture(
				A2(
					$elm$core$Result$map,
					function (_v9) {
						return 0;
					},
					A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$pageARangerDecoder, reponse)));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Referentiel$Normes$poser = F2(
	function (normes, modele) {
		return _Utils_update(
			modele,
			{hd: normes});
	});
var $author$project$Main$Update$requeteSurLesElements = function (effet) {
	switch (effet.$) {
		case 16:
			return true;
		case 1:
			return true;
		case 3:
			return true;
		case 4:
			return true;
		case 5:
			return true;
		case 6:
			return true;
		case 7:
			return true;
		case 8:
			return true;
		case 9:
			return true;
		case 10:
			return true;
		case 11:
			return true;
		case 12:
			return true;
		case 13:
			return true;
		case 14:
			return true;
		case 21:
			return true;
		case 32:
			return true;
		case 33:
			return true;
		case 51:
			return true;
		case 34:
			return true;
		case 35:
			return true;
		case 36:
			return true;
		case 40:
			return true;
		case 41:
			return true;
		case 45:
			return true;
		case 46:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Produits$Common$Effet$AllerA = function (a) {
	return {$: 37, a: a};
};
var $author$project$Components$Produits$Common$Effet$ArchiverLaSelection = F2(
	function (a, b) {
		return {$: 39, a: a, b: b};
	});
var $author$project$Components$Produits$Common$Effet$ArchiverLesReferences = F3(
	function (a, b, c) {
		return {$: 38, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$Common$Effet$AttendreAvantDeChercher = F2(
	function (a, b) {
		return {$: 22, a: a, b: b};
	});
var $author$project$Components$Shared$Annuaire$Update$ColonnesChoisies = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Shared$Annuaire$Update$FiltreEntierDemande = {$: 2};
var $author$project$Components$Produits$Catalogue$Update$allerA = F2(
	function (demande, model) {
		return _Utils_Tuple2(
			model,
			_List_fromArray(
				[
					$author$project$Components$Produits$Common$Effet$AllerA(
					$author$project$Routes$Route$toString(
						$author$project$Routes$Route$Catalogue(demande)))
				]));
	});
var $author$project$Components$Produits$Catalogue$Lot$Apercu = F2(
	function (references, debrayees) {
		return {wF: debrayees, hD: references};
	});
var $author$project$Components$Produits$Catalogue$Lot$apercuDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Produits$Catalogue$Lot$Apercu,
	A2($elm$json$Json$Decode$field, 'references', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'debrayees', $elm$json$Json$Decode$int));
var $author$project$Components$Produits$Catalogue$Lot$apercuIllisible = F2(
	function (cle, lot) {
		return _Utils_eq(lot.uN, cle) ? _Utils_update(
			lot,
			{Ax: true}) : lot;
	});
var $author$project$Components$Produits$Catalogue$Lot$apercuLu = F3(
	function (cle, apercu, lot) {
		return _Utils_eq(lot.uN, cle) ? _Utils_update(
			lot,
			{
				tq: $elm$core$Maybe$Just(apercu),
				Ax: false
			}) : lot;
	});
var $author$project$Catalogue$API$WriteAPIModel$CalculEnLotDUnType = F3(
	function (a, b, c) {
		return {$: 53, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$Catalogue$Lot$commande = F2(
	function (type_, lot) {
		return A3($author$project$Catalogue$API$WriteAPIModel$CalculEnLotDUnType, type_, lot.uN, lot.mW);
	});
var $author$project$API$NavLinksDictionary$calculEnLotDesReferences = 'calcul-en-lot-des-references';
var $author$project$Components$Produits$Catalogue$Lot$lienDeLaCommande = function (liste) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$calculEnLotDesReferences, liste.nQ.h0);
};
var $author$project$Components$Produits$Catalogue$Update$appliquerLeLot = function (model) {
	var _v0 = _Utils_Tuple3(
		model.n0,
		A2($elm$core$Maybe$andThen, $author$project$Components$Produits$Catalogue$Lot$lienDeLaCommande, model.bh),
		A2($elm$core$Maybe$andThen, $author$project$Catalogue$Identifiants$typeDeProduitIdFromString, model.kC.fh));
	if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
		var lot = _v0.a.a;
		var lien = _v0.b.a;
		var type_ = _v0.c.a;
		var _v1 = A3(
			$author$project$Components$Produits$Common$Envoi$partir,
			$elm$core$Maybe$Just(lien),
			A2($author$project$Components$Produits$Catalogue$Lot$commande, type_, lot),
			model.l2);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var envoi = _v2.a;
			var effets = _v2.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: envoi,
						n0: $elm$core$Maybe$Just(
							_Utils_update(
								lot,
								{pZ: false}))
					}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Catalogue$Typologies$archivables = function (classifications) {
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.Aq;
		},
		A2(
			$elm$core$List$filter,
			function (c) {
				return c.wE && (!_Utils_eq(
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$archiverLaClassification, c.nQ),
					$elm$core$Maybe$Nothing));
			},
			classifications));
};
var $author$project$Components$Produits$Catalogue$Model$ArchivageDe = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$Catalogue$Model$ArchivageImpossible = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$Catalogue$Model$SansArchivage = {$: 0};
var $author$project$Components$Produits$Catalogue$Model$archivageDesReferences = function (model) {
	var _v0 = A2($elm$core$List$filterMap, $author$project$Catalogue$Identifiants$classificationIdFromString, model.kC.r7);
	if (_v0.b && (!_v0.b.b)) {
		var seule = _v0.a;
		return A2($elm$core$List$member, seule, model.bs) ? $elm$core$Maybe$Just(seule) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Shared$Annuaire$Model$FiltreEntierSelectionne = 2;
var $author$project$Components$Shared$Annuaire$Model$FiltreEntierPropose = 1;
var $author$project$Components$Shared$Annuaire$Model$SansBandeau = 0;
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $elm$core$Set$size = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$size(dict);
};
var $author$project$Components$Shared$Annuaire$Model$bandeau = F2(
	function (total, model) {
		var _v0 = model.aw;
		switch (_v0) {
			case 0:
				return 0;
			case 1:
				return (_Utils_cmp(
					total,
					$elm$core$Set$size(model.vv)) > 0) ? 1 : 0;
			default:
				return 2;
		}
	});
var $author$project$Components$Produits$Catalogue$Model$selectionDuFiltreEntier = function (model) {
	return A2(
		$author$project$Components$Shared$Annuaire$Model$bandeau,
		A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.JE;
				},
				model.bh)),
		model.nW) === 2;
};
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Components$Produits$Catalogue$Model$archivageDeLaSelection = function (model) {
	var typologies = A3(
		$elm$core$List$foldl,
		F2(
			function (id, acc) {
				return A2($elm$core$List$member, id, acc) ? acc : _Utils_ap(
					acc,
					_List_fromArray(
						[id]));
			}),
		_List_Nil,
		A2(
			$elm$core$List$filterMap,
			$elm$core$Tuple$second,
			$elm$core$Dict$values(model.q3)));
	if ($author$project$Components$Produits$Catalogue$Model$selectionDuFiltreEntier(model)) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$Produits$Catalogue$Model$SansArchivage,
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$Produits$Catalogue$Model$ArchivageDe,
				$author$project$Components$Produits$Catalogue$Model$archivageDesReferences(model)));
	} else {
		if (!typologies.b) {
			return $author$project$Components$Produits$Catalogue$Model$SansArchivage;
		} else {
			if (!typologies.b.b) {
				var seule = typologies.a;
				return A2($elm$core$List$member, seule, model.bs) ? $author$project$Components$Produits$Catalogue$Model$ArchivageDe(seule) : $author$project$Components$Produits$Catalogue$Model$SansArchivage;
			} else {
				var plusieurs = typologies;
				return (!_Utils_eq(model.bs, _List_Nil)) ? $author$project$Components$Produits$Catalogue$Model$ArchivageImpossible(
					$elm$core$List$length(plusieurs)) : $author$project$Components$Produits$Catalogue$Model$SansArchivage;
			}
		}
	}
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$adresseBlanche = function (saisie) {
	return A2(
		$elm$core$List$all,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$trim,
			$elm$core$Basics$eq('')),
		_List_fromArray(
			[saisie.a3, saisie.a4, saisie.a5, saisie.vz, saisie.B_, saisie.Hj, saisie.ho]));
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$adresseDeValeur = function (saisie) {
	var facultatif = function (texte) {
		return ($elm$core$String$trim(texte) === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$elm$core$String$trim(texte));
	};
	return {
		vz: facultatif(saisie.vz),
		gV: A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(''),
			A2(
				$elm$core$List$map,
				$elm$core$String$trim,
				_List_fromArray(
					[saisie.a3, saisie.a4, saisie.a5]))),
		B_: $elm$core$String$trim(saisie.B_),
		ho: saisie.ho,
		Hj: facultatif(saisie.Hj)
	};
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$nombre = function (saisi) {
	return $elm$core$String$toFloat(
		A3(
			$elm$core$String$replace,
			',',
			'.',
			A3(
				$elm$core$List$foldl,
				F2(
					function (espace, texte) {
						return A3($elm$core$String$replace, espace, '', texte);
					}),
				$elm$core$String$trim(saisi),
				_List_fromArray(
					[' ', '\u00A0', '\u202F']))));
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$saisissable = function (champ) {
	var _v0 = _Utils_Tuple2(champ.zU, champ.r0);
	_v0$0:
	while (true) {
		switch (_v0.b.$) {
			case 9:
				if (!_v0.a.$) {
					break _v0$0;
				} else {
					return false;
				}
			case 22:
				if (!_v0.a.$) {
					break _v0$0;
				} else {
					return false;
				}
			case 23:
				if (!_v0.a.$) {
					break _v0$0;
				} else {
					return false;
				}
			default:
				if (!_v0.a.$) {
					break _v0$0;
				} else {
					return true;
				}
		}
	}
	return false;
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$textesDe = F2(
	function (code, textes) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$eq(code)),
					textes)));
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$valeurDe = F2(
	function (cle, valeurs) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Vide,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$eq(cle)),
						valeurs))));
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$modifications = F2(
	function (champs, saisie) {
		var vide = function (texte) {
			return $elm$core$String$trim(texte) === '';
		};
		var traductions = F2(
			function (avant, apres) {
				return A2(
					$elm$core$List$filterMap,
					function (code) {
						var _v9 = _Utils_Tuple2(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$textesDe, code, avant)),
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$textesDe, code, apres)));
						var ancien = _v9.a;
						var saisi = _v9.b;
						return (_Utils_eq(ancien, saisi) || (vide(ancien) && vide(saisi))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							_Utils_Tuple2(
								code,
								vide(saisi) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(saisi)));
					},
					A3(
						$elm$core$List$foldl,
						F2(
							function (code, vues) {
								return A2($elm$core$List$member, code, vues) ? vues : _Utils_ap(
									vues,
									_List_fromArray(
										[code]));
							}),
						_List_Nil,
						_Utils_ap(
							A2($elm$core$List$map, $elm$core$Tuple$first, avant),
							A2($elm$core$List$map, $elm$core$Tuple$first, apres))));
			});
		var numerique = function (champ) {
			var _v8 = champ.r0;
			switch (_v8.$) {
				case 3:
					return true;
				case 4:
					return true;
				case 10:
					return true;
				default:
					return false;
			}
		};
		var normale = function (valeur) {
			_v7$4:
			while (true) {
				switch (valeur.$) {
					case 1:
						var texte = valeur.a;
						return vide(texte) ? $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Vide : $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Ecrit(texte);
					case 2:
						if (!valeur.a.b) {
							return $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Vide;
						} else {
							break _v7$4;
						}
					case 5:
						var selection = valeur.a;
						return $elm$core$List$isEmpty(selection.jL) ? $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Vide : $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Choix(selection.jL);
					case 6:
						var tapee = valeur.a;
						return $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$adresseBlanche(tapee) ? $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Vide : $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Postale(tapee);
					default:
						break _v7$4;
				}
			}
			var autre = valeur;
			return autre;
		};
		var partant = function (champ) {
			var _v0 = _Utils_Tuple2(
				A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$valeurDe, champ.dy, saisie.AP),
				A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$valeurDe, champ.dy, saisie.Ki));
			_v0$2:
			while (true) {
				if (_v0.b.$ === 4) {
					switch (_v0.a.$) {
						case 4:
							var avant = _v0.a.a;
							var apres = _v0.b.a;
							var _v1 = A2(traductions, avant, apres);
							if (!_v1.b) {
								return $elm$core$Maybe$Nothing;
							} else {
								var changees = _v1;
								return $elm$core$Maybe$Just(
									$author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Traductions(changees));
							}
						case 0:
							var _v2 = _v0.a;
							var apres = _v0.b.a;
							var _v3 = A2(traductions, _List_Nil, apres);
							if (!_v3.b) {
								return $elm$core$Maybe$Nothing;
							} else {
								var changees = _v3;
								return $elm$core$Maybe$Just(
									$author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Traductions(changees));
							}
						default:
							break _v0$2;
					}
				} else {
					break _v0$2;
				}
			}
			var avant = _v0.a;
			var apres = _v0.b;
			return _Utils_eq(
				normale(avant),
				normale(apres)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				function () {
					var _v4 = normale(apres);
					switch (_v4.$) {
						case 1:
							var texte = _v4.a;
							if (numerique(champ)) {
								return A2(
									$elm$core$Maybe$withDefault,
									$author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Texte(texte),
									A2(
										$elm$core$Maybe$map,
										$author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Nombre,
										$author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$nombre(texte)));
							} else {
								var _v5 = champ.r0;
								if (_v5.$ === 18) {
									var lien = _v5.a;
									return A2(
										$author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Articles,
										lien.FS,
										_List_fromArray(
											[texte]));
								} else {
									return $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Texte(texte);
								}
							}
						case 2:
							var choisis = _v4.a;
							var _v6 = champ.r0;
							if (_v6.$ === 18) {
								var lien = _v6.a;
								return A2($author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Articles, lien.FS, choisis);
							} else {
								return $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Textes(choisis);
							}
						case 5:
							var selection = _v4.a;
							return $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Textes(selection.jL);
						case 6:
							var tapee = _v4.a;
							return $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Adresse(
								$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$adresseDeValeur(tapee));
						case 3:
							var coche = _v4.a;
							return $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Booleen(coche);
						case 4:
							var textes = _v4.a;
							return $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Traductions(
								A2(
									$elm$core$List$map,
									$elm$core$Tuple$mapSecond($elm$core$Maybe$Just),
									textes));
						default:
							return $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Vide;
					}
				}());
		};
		return A2(
			$elm$core$List$filterMap,
			function (champ) {
				return A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(champ.dy),
					partant(champ));
			},
			A2($elm$core$List$filter, $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$saisissable, champs));
	});
var $author$project$Components$Produits$Catalogue$Creation$informationsSaisies = function (saisie) {
	return A2(
		$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$modifications,
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.dw;
				},
				saisie.aN)),
		saisie.i8);
};
var $author$project$Catalogue$Vocabulaire$estUnService = function (code) {
	return _Utils_eq(code, $author$project$Catalogue$Vocabulaire$natureDeService);
};
var $author$project$Components$Produits$Catalogue$Creation$typeRetenu = F2(
	function (catalogue, saisie) {
		var _v0 = saisie.Gp;
		if (_v0.$ === 1) {
			var id = _v0.a;
			return A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.fh;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(id)),
						catalogue.aK)));
		} else {
			return saisie.fh;
		}
	});
var $author$project$Catalogue$Chemin$noeud = F2(
	function (_v0, id) {
		var noeuds = _v0.b;
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Aq;
					},
					$elm$core$Basics$eq(id)),
				noeuds));
	});
var $author$project$Catalogue$Chemin$choisiSur = F2(
	function (chemin, etage) {
		var ids = chemin.c;
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.md;
					},
					$elm$core$Basics$eq(etage.Aq)),
				A2(
					$elm$core$List$filterMap,
					$author$project$Catalogue$Chemin$noeud(chemin),
					ids)));
	});
var $author$project$Catalogue$Chemin$duChemin = function (etages) {
	if (!etages.b) {
		return _List_Nil;
	} else {
		var etage = etages.a;
		var suivants = etages.b;
		return etage.dS ? _List_Nil : A2(
			$elm$core$List$cons,
			etage,
			$author$project$Catalogue$Chemin$duChemin(suivants));
	}
};
var $author$project$Catalogue$Chemin$etagesManquants = function (chemin) {
	var etages = chemin.a;
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.xt;
		},
		A2(
			$elm$core$List$filter,
			function (etage) {
				return _Utils_eq(
					A2($author$project$Catalogue$Chemin$choisiSur, chemin, etage),
					$elm$core$Maybe$Nothing);
			},
			$author$project$Catalogue$Chemin$duChemin(etages)));
};
var $author$project$Catalogue$Chemin$complet = A2($elm$core$Basics$composeR, $author$project$Catalogue$Chemin$etagesManquants, $elm$core$List$isEmpty);
var $author$project$Catalogue$Chemin$valeurs = function (chemin) {
	var etages = chemin.a;
	return $author$project$Catalogue$Chemin$complet(chemin) ? $elm$core$Maybe$Just(
		A2(
			$elm$core$List$map,
			function ($) {
				return $.fm;
			},
			A2(
				$elm$core$List$filterMap,
				$author$project$Catalogue$Chemin$choisiSur(chemin),
				$author$project$Catalogue$Chemin$duChemin(etages)))) : $elm$core$Maybe$Nothing;
};
var $author$project$Catalogue$Chemin$valeursChoisies = function (chemin) {
	var etages = chemin.a;
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.fm;
		},
		A2(
			$elm$core$List$filterMap,
			$author$project$Catalogue$Chemin$choisiSur(chemin),
			$author$project$Catalogue$Chemin$duChemin(etages)));
};
var $author$project$Components$Produits$Catalogue$Creation$schemaDemande = F2(
	function (catalogue, saisie) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$Components$Produits$Catalogue$Creation$typeRetenu, catalogue, saisie),
			saisie.r3);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var type_ = _v0.a.a;
				var typologie = _v0.b.a;
				return $author$project$Catalogue$Vocabulaire$estUnService(saisie.g1) ? $elm$core$Maybe$Just(
					_Utils_Tuple2(
						type_,
						$author$project$Catalogue$Chemin$valeursChoisies(typologie.jK))) : A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(type_),
					$author$project$Catalogue$Chemin$valeurs(typologie.jK));
			} else {
				var type_ = _v0.a.a;
				var _v1 = _v0.b;
				return $elm$core$List$isEmpty(saisie.r7) ? $elm$core$Maybe$Just(
					_Utils_Tuple2(type_, _List_Nil)) : $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$Catalogue$Creation$codeDemande = F2(
	function (catalogue, saisie) {
		return A2(
			$elm$core$Maybe$map,
			function (_v0) {
				var type_ = _v0.a;
				var valeurs = _v0.b;
				return _Utils_Tuple3(
					type_,
					valeurs,
					$author$project$Components$Produits$Catalogue$Creation$informationsSaisies(saisie));
			},
			A2($author$project$Components$Produits$Catalogue$Creation$schemaDemande, catalogue, saisie));
	});
var $author$project$Components$Produits$Catalogue$Creation$avecLeCodePropose = F4(
	function (catalogue, lu, propose, saisie) {
		return _Utils_eq(
			A2($author$project$Components$Produits$Catalogue$Creation$codeDemande, catalogue, saisie),
			$elm$core$Maybe$Just(lu)) ? _Utils_update(
			saisie,
			{
				vx: saisie.cu ? saisie.vx : A2($elm$core$Maybe$withDefault, '', propose.vx),
				dz: propose.vx,
				hI: propose.hH
			}) : saisie;
	});
var $author$project$Components$Produits$Catalogue$Creation$attributsGardes = F2(
	function (champs, ancienne) {
		var neuve = A2(
			$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$depuis,
			{
				dw: champs,
				Ba: A2(
					$elm$core$List$map,
					function ($) {
						return $.vx;
					},
					$author$project$Referentiel$Langues$desLibelles)
			},
			_List_Nil);
		var garde = function (_v0) {
			var cle = _v0.a;
			var valeur = _v0.b;
			return _Utils_Tuple2(
				cle,
				A2(
					$elm$core$Maybe$withDefault,
					valeur,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$second,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Tuple$first,
									$elm$core$Basics$eq(cle)),
								ancienne.Ki)))));
		};
		return _Utils_update(
			neuve,
			{
				Ki: A2($elm$core$List$map, garde, neuve.Ki)
			});
	});
var $author$project$Components$Produits$Catalogue$Creation$avecLeSchema = F5(
	function (catalogue, type_, valeurs, lu, saisie) {
		return _Utils_eq(
			A2($author$project$Components$Produits$Catalogue$Creation$schemaDemande, catalogue, saisie),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(type_, valeurs))) ? _Utils_update(
			saisie,
			{
				i8: A2($author$project$Components$Produits$Catalogue$Creation$attributsGardes, lu.dw, saisie.i8),
				aN: $elm$core$Maybe$Just(
					{dw: lu.dw, jN: lu.jN, hj: lu.hj, r0: type_, Ki: valeurs})
			}) : saisie;
	});
var $author$project$Components$Produits$Catalogue$Creation$avecLesCategories = F2(
	function (categories, saisie) {
		return _Utils_update(
			saisie,
			{dt: categories, cq: true});
	});
var $author$project$Components$Produits$Catalogue$Model$avecLesCreees = F2(
	function (creees, liste) {
		var absentes = A2(
			$elm$core$List$filter,
			function (c) {
				return !A2(
					$elm$core$List$any,
					function (lue) {
						return _Utils_eq(lue.Aq, c.Aq);
					},
					liste.hD);
			},
			creees);
		return _Utils_update(
			liste,
			{
				hD: _Utils_ap(absentes, liste.hD),
				JE: liste.JE + $elm$core$List$length(absentes)
			});
	});
var $author$project$Components$Produits$Catalogue$Creation$memesValeurs = F2(
	function (voulues, lues) {
		return _Utils_eq(
			$elm$core$List$length(voulues),
			$elm$core$List$length(lues)) && A2(
			$elm$core$List$all,
			function (valeur) {
				return A2($elm$core$List$member, valeur, lues);
			},
			voulues);
	});
var $author$project$Components$Produits$Catalogue$Creation$valeursDuChemin = function (saisie) {
	return A2(
		$elm$core$Maybe$andThen,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.jK;
			},
			$author$project$Catalogue$Chemin$valeurs),
		saisie.r3);
};
var $author$project$Components$Produits$Catalogue$Creation$avecLesProduitsProposes = F4(
	function (type_, valeurs, produits, saisie) {
		return _Utils_eq(
			$author$project$Components$Produits$Catalogue$Creation$valeursDuChemin(saisie),
			$elm$core$Maybe$Just(valeurs)) ? _Utils_update(
			saisie,
			{
				c1: A2(
					$elm$core$List$cons,
					{aK: produits, r0: type_, Ki: valeurs},
					A2(
						$elm$core$List$filter,
						function (lus) {
							return (!_Utils_eq(lus.r0, type_)) || (!A2($author$project$Components$Produits$Catalogue$Creation$memesValeurs, lus.Ki, valeurs));
						},
						saisie.c1))
			}) : saisie;
	});
var $author$project$Components$Produits$Catalogue$Creation$avecLesTypologies = F2(
	function (typologies, saisie) {
		return _Utils_eq(typologies, saisie.r7) ? saisie : _Utils_update(
			saisie,
			{
				r3: function () {
					if (typologies.b && (!typologies.b.b)) {
						var seule = typologies.a;
						return $elm$core$Maybe$Just(seule);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}(),
				r7: typologies
			});
	});
var $author$project$Components$Produits$Catalogue$Update$basculeUnElement = F2(
	function (element, elements) {
		return A2($elm$core$List$member, element, elements) ? A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(element),
			elements) : _Utils_ap(
			elements,
			_List_fromArray(
				[element]));
	});
var $author$project$Components$Produits$Catalogue$Update$bascule = F3(
	function (groupe, valeur, demande) {
		var basculee = $author$project$Components$Produits$Catalogue$Update$basculeUnElement(valeur);
		switch (groupe.$) {
			case 0:
				return _Utils_update(
					demande,
					{
						mj: basculee(demande.mj)
					});
			case 1:
				return _Utils_update(
					demande,
					{
						cU: basculee(demande.cU)
					});
			case 2:
				return _Utils_update(
					demande,
					{
						gG: basculee(demande.gG)
					});
			case 3:
				return _Utils_update(
					demande,
					{
						r7: basculee(demande.r7)
					});
			case 4:
				return _Utils_update(
					demande,
					{
						mu: basculee(demande.mu)
					});
			case 5:
				return _Utils_update(
					demande,
					{
						dt: basculee(demande.dt)
					});
			case 6:
				var cle = groupe.a;
				return _Utils_update(
					demande,
					{
						dw: A2($author$project$Components$Produits$Catalogue$Update$basculeUnElement, cle + (':' + valeur), demande.dw)
					});
			default:
				return demande;
		}
	});
var $author$project$Components$Produits$Catalogue$Model$basculer = F2(
	function (colonne, cochees) {
		return A2($elm$core$List$member, colonne, cochees) ? A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(colonne),
			cochees) : _Utils_ap(
			cochees,
			_List_fromArray(
				[colonne]));
	});
var $author$project$Components$Produits$Common$Effet$ProposerLesCategories = F2(
	function (a, b) {
		return {$: 32, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$categoriesProposees = 'categories-proposees';
var $author$project$Components$Produits$Liens$versLesCategoriesProposees = F2(
	function (id, gabarits) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$API$NavLinksDictionary$variableUid,
						$author$project$Catalogue$Identifiants$classificationIdToString(id))
					])),
			A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$categoriesProposees, gabarits));
	});
var $author$project$Components$Produits$Catalogue$Update$proposer = F3(
	function (catalogue, typologie, valeurs) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (lien) {
					return _List_fromArray(
						[
							A2($author$project$Components$Produits$Common$Effet$ProposerLesCategories, lien, valeurs)
						]);
				},
				A2($author$project$Components$Produits$Liens$versLesCategoriesProposees, typologie, catalogue.gF)));
	});
var $author$project$Components$Produits$Catalogue$Update$categoriesDemandees = F3(
	function (catalogue, champ, saisie) {
		var _v0 = _Utils_Tuple3(
			champ,
			saisie.r3,
			$author$project$Components$Produits$Catalogue$Creation$valeursDuChemin(saisie));
		if (((_v0.a.$ === 7) && (!_v0.b.$)) && (!_v0.c.$)) {
			var typologie = _v0.b.a;
			var valeurs = _v0.c.a;
			return A3($author$project$Components$Produits$Catalogue$Update$proposer, catalogue, typologie.Aq, valeurs);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Produits$Catalogue$Lot$champChoisi = F2(
	function (cle, lot) {
		return _Utils_update(
			lot,
			{tq: $elm$core$Maybe$Nothing, uN: cle, Ax: false, pZ: false});
	});
var $author$project$Components$Produits$Common$Effet$Rechercher = F3(
	function (a, b, c) {
		return {$: 21, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$Catalogue$Model$completude = function (code) {
	_v0$2:
	while (true) {
		if (!code.$) {
			switch (code.a) {
				case 'completes':
					return $elm$core$Maybe$Just(true);
				case 'incompletes':
					return $elm$core$Maybe$Just(false);
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Components$Produits$Catalogue$Model$recherche = function (model) {
	var demande = model.kC;
	return {
		i2: demande.i2,
		dt: A2($elm$core$List$filterMap, $author$project$Catalogue$Identifiants$valeurIdFromString, demande.dt),
		dw: A2($elm$core$List$filterMap, $author$project$Routes$Route$champCoche, demande.dw),
		jF: demande.qs,
		j2: $author$project$Components$Produits$Catalogue$Model$completude(demande.fU),
		gt: $elm$core$Maybe$Nothing,
		mj: A2($elm$core$List$filterMap, $author$project$Catalogue$Identifiants$etatCodeFromString, demande.mj),
		mu: A2($elm$core$List$filterMap, $author$project$Catalogue$Identifiants$valeurIdFromString, demande.mu),
		gG: A2($elm$core$List$filterMap, $author$project$Catalogue$Identifiants$elementIdFromString, demande.gG),
		cU: A2($elm$core$List$filterMap, $author$project$Catalogue$Identifiants$elementIdFromString, demande.cU),
		ou: $elm$core$Maybe$Nothing,
		pn: A2($elm$core$List$filterMap, $author$project$Routes$Route$plageLue, demande.pn),
		h3: model.h3,
		rS: $elm$core$Maybe$Just(demande.rS),
		fh: A2($elm$core$Maybe$andThen, $author$project$Catalogue$Identifiants$typeDeProduitIdFromString, demande.fh),
		r7: A2($elm$core$List$filterMap, $author$project$Catalogue$Identifiants$classificationIdFromString, demande.r7)
	};
};
var $author$project$Components$Produits$Catalogue$Update$chercher = function (model) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		function (catalogue) {
			return A2(
				$author$project$Components$Produits$Liens$versLaRecherche,
				{EE: model.kC.EE, Jm: model.kC.Jm},
				catalogue.gF);
		},
		model.jB);
	if (!_v0.$) {
		var lien = _v0.a;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{DX: model.DX + 1}),
			_List_fromArray(
				[
					A3(
					$author$project$Components$Produits$Common$Effet$Rechercher,
					model.DX + 1,
					lien,
					$author$project$Components$Produits$Catalogue$Model$recherche(model))
				]));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$Common$Effet$LireLeCodePropose = F5(
	function (a, b, c, d, e) {
		return {$: 35, a: a, b: b, c: c, d: d, e: e};
	});
var $author$project$API$NavLinksDictionary$codePropose = 'code-propose';
var $author$project$Components$Produits$Liens$versLeCodePropose = F2(
	function (id, gabarits) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$API$NavLinksDictionary$variableUid,
						$author$project$Catalogue$Identifiants$typeDeProduitIdToString(id))
					])),
			A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$codePropose, gabarits));
	});
var $author$project$Components$Produits$Catalogue$Update$codeDemande = F3(
	function (catalogue, avant, apres) {
		var _v0 = A2($author$project$Components$Produits$Catalogue$Creation$codeDemande, catalogue, apres);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var type_ = _v1.a;
			var valeurs = _v1.b;
			var attributs = _v1.c;
			return _Utils_eq(
				A2($author$project$Components$Produits$Catalogue$Creation$codeDemande, catalogue, avant),
				$elm$core$Maybe$Just(
					_Utils_Tuple3(type_, valeurs, attributs))) ? _List_Nil : A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (lien) {
						return _List_fromArray(
							[
								A5(
								$author$project$Components$Produits$Common$Effet$LireLeCodePropose,
								lien,
								type_,
								valeurs,
								attributs,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.Aq;
									},
									apres.r3))
							]);
					},
					A2($author$project$Components$Produits$Liens$versLeCodePropose, type_, catalogue.gF)));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Produits$Catalogue$Update$colonnesMontrees = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Components$Produits$Catalogue$Model$colonnesParDefaut,
		A2(
			$elm$core$Maybe$map,
			$elm$core$List$filter(
				function (colonne) {
					return A2($elm$core$List$member, colonne, $author$project$Components$Produits$Catalogue$Model$colonnesProposees);
				}),
			model.nW.j1));
};
var $author$project$Components$Produits$Common$Effet$CompterLesReferencesARanger = F2(
	function (a, b) {
		return {$: 40, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$referencesARanger = 'references-a-ranger';
var $author$project$Components$Produits$Liens$versLesReferencesARanger = F3(
	function (id, demandee, gabarits) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$API$NavLinksDictionary$variableUid,
						$author$project$Catalogue$Identifiants$classificationIdToString(id)),
						_Utils_Tuple2(
						$author$project$API$NavLinksDictionary$variablePage,
						$elm$core$String$fromInt(demandee.EE)),
						_Utils_Tuple2(
						$author$project$API$NavLinksDictionary$variableTaille,
						$elm$core$String$fromInt(demandee.Jm))
					])),
			A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$referencesARanger, gabarits));
	});
var $author$project$Components$Produits$Catalogue$Update$compterLesARanger = F2(
	function (model, typologies) {
		var _v0 = model.jB;
		if (!_v0.$) {
			var catalogue = _v0.a;
			return A2(
				$elm$core$List$filterMap,
				function (typologie) {
					return A2(
						$elm$core$Maybe$map,
						$author$project$Components$Produits$Common$Effet$CompterLesReferencesARanger(typologie.Aq),
						A3(
							$author$project$Components$Produits$Liens$versLesReferencesARanger,
							typologie.Aq,
							{EE: 1, Jm: 25},
							catalogue.gF));
				},
				typologies);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Catalogue$Vocabulaire$publicationBrouillon = 'brouillon';
var $author$project$Components$Produits$Catalogue$Model$cartesCreees = F2(
	function (catalogue, rendue) {
		var carte = function (evenement) {
			if (evenement.$ === 37) {
				var id = evenement.a;
				var creee = evenement.b;
				return $elm$core$Maybe$Just(
					{
						tL: false,
						uK: $elm$core$Maybe$Nothing,
						vx: creee.vx,
						fU: $elm$core$Maybe$Nothing,
						gt: creee.gt,
						z3: $elm$core$Maybe$Nothing,
						Aq: id,
						gX: $elm$core$Maybe$Nothing,
						n8: creee.n8,
						Dj: creee.Dj,
						Ex: !_Utils_eq(
							A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$self, rendue.nQ),
							$elm$core$Maybe$Nothing),
						Gp: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.R;
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (produit) {
										return _Utils_eq(
											$elm$core$Maybe$Just(produit.Aq),
											creee.pN);
									},
									catalogue.aK))),
						Gz: $author$project$Catalogue$Vocabulaire$publicationBrouillon,
						r3: $elm$core$Maybe$Nothing,
						sl: creee.sl
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		return A2($elm$core$List$filterMap, carte, rendue.mk);
	});
var $author$project$Components$Produits$Catalogue$Model$appliquer = F3(
	function (catalogue, rendue, liste) {
		return A2(
			$author$project$Components$Produits$Catalogue$Model$avecLesCreees,
			A2($author$project$Components$Produits$Catalogue$Model$cartesCreees, catalogue, rendue),
			liste);
	});
var $author$project$Components$Produits$Catalogue$Creation$Existant = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$Catalogue$Creation$apresLeProduit = F2(
	function (id, saisie) {
		return _Utils_update(
			saisie,
			{
				Gp: $author$project$Components$Produits$Catalogue$Creation$Existant(id),
				bd: true
			});
	});
var $author$project$Components$Produits$Catalogue$Model$apresLeProduit = F3(
	function (id, cree, catalogue) {
		var chemin = $elm$core$List$isEmpty(cree.Ki) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(cree.Ki);
		return A2(
			$elm$core$List$any,
			function (produit) {
				return _Utils_eq(produit.Aq, id) && _Utils_eq(produit.jK, chemin);
			},
			catalogue.aK) ? catalogue : _Utils_update(
			catalogue,
			{
				aK: _Utils_ap(
					catalogue.aK,
					_List_fromArray(
						[
							{jK: chemin, Aq: id, R: cree.R, ey: cree.ey, fh: cree.fh}
						]))
			});
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$idDuChamp = F2(
	function (prefixe, cle) {
		return prefixe + ('-' + cle);
	});
var $author$project$Components$Produits$Catalogue$Creation$prefixeDesInformations = function (prefixe) {
	return prefixe + '-information';
};
var $author$project$Components$Produits$Catalogue$Creation$prefixeDesLangues = F2(
	function (prefixe, zone) {
		return prefixe + ('-' + function () {
			switch (zone.$) {
				case 0:
					return 'nature';
				case 1:
					return 'choix-du-produit';
				case 2:
					return 'nom-du-produit';
				case 3:
					return 'type';
				case 4:
					return 'parent';
				case 5:
					return 'rattachement';
				case 6:
					return 'rangement';
				case 7:
					return 'nom';
				case 8:
					return 'code';
				case 9:
					return 'ean';
				case 10:
					return 'millesime';
				case 11:
					return 'variante';
				case 12:
					return 'etat';
				default:
					var cle = zone.a;
					return 'information-' + cle;
			}
		}());
	});
var $author$project$Components$Produits$Catalogue$Creation$idDe = F2(
	function (prefixe, zone) {
		switch (zone.$) {
			case 2:
				return $author$project$Components$Produits$Common$LibellesSaisis$idDuPremierChamp(
					A2($author$project$Components$Produits$Catalogue$Creation$prefixeDesLangues, prefixe, zone));
			case 7:
				return $author$project$Components$Produits$Common$LibellesSaisis$idDuPremierChamp(
					A2($author$project$Components$Produits$Catalogue$Creation$prefixeDesLangues, prefixe, zone));
			case 13:
				var cle = zone.a;
				return A2(
					$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$idDuChamp,
					$author$project$Components$Produits$Catalogue$Creation$prefixeDesInformations(prefixe),
					cle);
			default:
				return A2($author$project$Components$Produits$Catalogue$Creation$prefixeDesLangues, prefixe, zone);
		}
	});
var $author$project$Components$Produits$Common$Effet$LireLesReferencesARanger = function (a) {
	return {$: 36, a: a};
};
var $author$project$Components$Produits$Catalogue$Model$tailleDePageARanger = 50;
var $author$project$Components$Produits$Catalogue$Update$lireARanger = function (model) {
	var _v0 = _Utils_Tuple2(model.iz, model.jB);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var aRanger = _v0.a.a;
		var catalogue = _v0.b.a;
		return _Utils_Tuple2(
			model,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$LireLesReferencesARanger, $elm$core$List$singleton),
					A3(
						$author$project$Components$Produits$Liens$versLesReferencesARanger,
						aRanger.r3,
						{EE: aRanger.EE, Jm: $author$project$Components$Produits$Catalogue$Model$tailleDePageARanger},
						catalogue.gF))));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$Catalogue$Update$perime = function (erreur) {
	return A2(
		$elm$core$List$member,
		erreur,
		_List_fromArray(
			[$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$EtatInconnu, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$TypeDeProduitArchive, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ParentArchive, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$NiveauNonUtilise, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$NiveauInconnu, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$DejaExistant, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$Introuvable, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$CheminInconnu, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ValeurDeCheminArchivee, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$CategorieNonProposable]));
};
var $author$project$Components$Produits$Catalogue$Creation$refuser = F3(
	function (enTete, sousUnChamp, saisie) {
		return _Utils_update(
			saisie,
			{pZ: enTete, bf: sousUnChamp});
	});
var $author$project$Components$Produits$Catalogue$Update$relire = function (model) {
	return A2(
		$elm$core$Tuple$mapSecond,
		$elm$core$Basics$append(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$Lire, $elm$core$List$singleton),
					model.np))),
		$author$project$Components$Produits$Catalogue$Update$chercher(model));
};
var $author$project$Components$Produits$Catalogue$Update$produitRetrouve = F3(
	function (voulu, rendue, model) {
		var nom = A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.R;
			},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.zX;
				},
				A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$String$toLower)));
		var estUneExtension = function (evenement) {
			if (evenement.$ === 50) {
				return true;
			} else {
				return false;
			}
		};
		var etendu = A2($elm$core$List$any, estUneExtension, rendue.mk);
		var connu = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (produit) {
					return _Utils_eq(
						nom(produit),
						nom(voulu)) && _Utils_eq(produit.fh, voulu.fh);
				},
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.aK;
						},
						model.jB))));
		var _v0 = _Utils_Tuple2(connu, model.jB);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var produit = _v0.a.a;
			var catalogue = _v0.b.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						jB: $elm$core$Maybe$Just(
							A3(
								$author$project$Components$Produits$Catalogue$Model$apresLeProduit,
								produit.Aq,
								_Utils_update(
									voulu,
									{R: produit.R, ey: produit.ey}),
								catalogue)),
						gl: true,
						hP: A3(
							$author$project$Components$Produits$Catalogue$Creation$refuser,
							$elm$core$Maybe$Just(
								{
									Jx: etendu ? $author$project$I18n$Textes$produitsValeursProduitExistantEtendu : $author$project$I18n$Textes$produitsValeursProduitExistantDejaDans,
									b9: $elm$core$Maybe$Nothing
								}),
							$elm$core$Maybe$Nothing,
							A2($author$project$Components$Produits$Catalogue$Creation$apresLeProduit, produit.Aq, model.hP))
					}),
				(etendu && (!rendue.sy)) ? _List_fromArray(
					[
						$author$project$Components$Produits$Common$Effet$AttendreAvantDeRelire($author$project$Components$Produits$Common$Envoi$delaiDeRelectureMs)
					]) : _List_Nil);
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						hP: A3(
							$author$project$Components$Produits$Catalogue$Creation$refuser,
							$elm$core$Maybe$Just($author$project$Components$Produits$Common$Refus$rejeu),
							$elm$core$Maybe$Nothing,
							model.hP)
					}),
				$author$project$Components$Produits$Catalogue$Update$relire(model).b);
		}
	});
var $author$project$Components$Produits$Catalogue$Creation$ZoneCode = {$: 8};
var $author$project$Components$Produits$Catalogue$Creation$ZoneEtat = {$: 12};
var $author$project$Components$Produits$Catalogue$Creation$ZoneNom = {$: 7};
var $author$project$Components$Produits$Catalogue$Creation$ZoneParent = {$: 4};
var $author$project$Components$Produits$Catalogue$Creation$ZoneProduit = {$: 1};
var $author$project$Components$Produits$Catalogue$Creation$ZoneRangement = {$: 6};
var $author$project$Components$Produits$Catalogue$Creation$ZoneRattachement = {$: 5};
var $author$project$Components$Produits$Catalogue$Creation$ZoneType = {$: 3};
var $author$project$I18n$Textes$produitsReferencesRefusCategorieNonProposable = A3($author$project$I18n$Traductions$texte, 'produits.references.refus.categorie-non-proposable', _List_Nil, 'Cette catégorie n\'est pas proposée pour ce rangement : la page vient d\'être relue.');
var $author$project$I18n$Textes$produitsReferencesRefusCategorieRequise = A3($author$project$I18n$Traductions$texte, 'produits.references.refus.categorie-requise', _List_Nil, 'La catégorie de la référence est obligatoire.');
var $author$project$I18n$Textes$produitsReferencesRefusCheminDifferent = A3($author$project$I18n$Traductions$texte, 'produits.references.refus.chemin-different', _List_Nil, 'Ce produit n\'est pas rangé sous le chemin choisi : choisissez un produit de ce chemin.');
var $author$project$I18n$Textes$produitsReferencesRefusCheminIncomplet = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.references.refus.chemin-incomplet',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'etages',
				$author$project$I18n$Traductions$Sous(p.yG))
			]),
		'Le rangement est incomplet : il manque {etages}.');
};
var $author$project$I18n$Textes$produitsReferencesRefusCheminInconnu = A3($author$project$I18n$Traductions$texte, 'produits.references.refus.chemin-inconnu', _List_Nil, 'Ce rangement n\'existe pas dans la typologie : la page vient d\'être relue.');
var $author$project$I18n$Textes$produitsReferencesRefusCodePris = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.references.refus.code-pris',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'code',
				$author$project$I18n$Traductions$Sous(p.vx)),
				_Utils_Tuple2(
				'marque',
				$author$project$I18n$Traductions$Sous(p.gX))
			]),
		'« {code} » existe déjà dans la marque {marque}.');
};
var $author$project$I18n$Textes$produitsReferencesRefusCodePrisSansMarque = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.references.refus.code-pris.sans-marque',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'code',
				$author$project$I18n$Traductions$Sous(p.vx))
			]),
		'« {code} » existe déjà dans le catalogue.');
};
var $author$project$I18n$Textes$produitsReferencesRefusDeuxValeurs = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.references.refus.deux-valeurs',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'etage',
				$author$project$I18n$Traductions$Sous(p.md))
			]),
		'L\'étage « {etage} » ne reçoit qu\'une valeur.');
};
var $author$project$I18n$Textes$produitsReferencesRefusEtatInconnu = A3($author$project$I18n$Traductions$texte, 'produits.references.refus.etat-inconnu', _List_Nil, 'Cet état n\'est plus proposé : la page vient d\'être relue.');
var $author$project$I18n$Textes$produitsReferencesRefusNomRequis = A3($author$project$I18n$Traductions$texte, 'produits.references.refus.nom-requis', _List_Nil, 'Sans produit, la référence porte son propre nom.');
var $author$project$I18n$Textes$produitsReferencesRefusRattachementHorsHierarchie = A3($author$project$I18n$Traductions$texte, 'produits.references.refus.rattachement-hors-hierarchie', _List_Nil, 'Ce rattachement ne suit pas la hiérarchie du catalogue.');
var $author$project$I18n$Textes$produitsReferencesRefusRattachementRequis = A3($author$project$I18n$Traductions$texte, 'produits.references.refus.rattachement-requis', _List_Nil, 'Ce rattachement est obligatoire.');
var $author$project$I18n$Textes$produitsReferencesRefusTypeArchive = A3($author$project$I18n$Traductions$texte, 'produits.references.refus.type-archive', _List_Nil, 'Cette catégorie est archivée : rien ne s\'y crée. La page vient d\'être relue.');
var $author$project$I18n$Textes$produitsReferencesRefusTypeDifferent = A3($author$project$I18n$Traductions$texte, 'produits.references.refus.type-different', _List_Nil, 'La catégorie de la référence n\'est pas celle de son produit.');
var $author$project$I18n$Textes$produitsReferencesRefusTypeHorsDeLaTypologie = A3($author$project$I18n$Traductions$texte, 'produits.references.refus.type-hors-de-la-typologie', _List_Nil, 'Ce type n\'a pas de place dans cette typologie : choisissez une typologie où il est rangé.');
var $author$project$I18n$Textes$produitsReferencesRefusTypologieAChoisir = A3($author$project$I18n$Traductions$texte, 'produits.references.refus.typologie-a-choisir', _List_Nil, 'Ce type est rangé dans plusieurs typologies : choisissez celle où ranger cette référence.');
var $author$project$I18n$Textes$produitsReferencesRefusTypologieRequise = A3($author$project$I18n$Traductions$texte, 'produits.references.refus.typologie-requise', _List_Nil, 'Le rangement d\'une référence nomme sa typologie.');
var $author$project$I18n$Textes$produitsReferencesRefusValeurArchivee = A3($author$project$I18n$Traductions$texte, 'produits.references.refus.valeur-archivee', _List_Nil, 'Une valeur du rangement est archivée : la page vient d\'être relue.');
var $author$project$I18n$Textes$produitsReferencesRefusValeurEnTrop = A3($author$project$I18n$Traductions$texte, 'produits.references.refus.valeur-en-trop', _List_Nil, 'Ce rangement porte une valeur de trop.');
var $author$project$Components$Produits$Catalogue$Update$refusDe = F4(
	function (model, commande, refus, erreur) {
		var sous = F2(
			function (zone, texte) {
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(
						_Utils_Tuple2(zone, texte)));
			});
		var enTete = function (texte) {
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(
					{Jx: texte, b9: refus.b9}),
				$elm$core$Maybe$Nothing);
		};
		var duRattachement = function () {
			var _v1 = _Utils_Tuple2(commande, model.hP.Gp);
			if (_v1.a.$ === 34) {
				return $author$project$Components$Produits$Catalogue$Creation$ZoneParent;
			} else {
				if (_v1.b.$ === 1) {
					return $author$project$Components$Produits$Catalogue$Creation$ZoneProduit;
				} else {
					return $author$project$Components$Produits$Catalogue$Creation$ZoneRattachement;
				}
			}
		}();
		var code = $elm$core$String$trim(model.hP.vx);
		switch (erreur.$) {
			case 31:
				var marque = erreur.a;
				return A2(
					sous,
					$author$project$Components$Produits$Catalogue$Creation$ZoneCode,
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$I18n$Textes$produitsReferencesRefusCodePrisSansMarque(
							{
								vx: $author$project$I18n$Traductions$tel(code)
							}),
						A2(
							$elm$core$Maybe$map,
							function (connue) {
								return $author$project$I18n$Textes$produitsReferencesRefusCodePris(
									{
										vx: $author$project$I18n$Traductions$tel(code),
										gX: $author$project$I18n$Traductions$tel(connue.Dj)
									});
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (element) {
										return _Utils_eq(
											$elm$core$Maybe$Just(element.Aq),
											marque);
									},
									model.aV)))));
			case 10:
				return A2(sous, duRattachement, $author$project$I18n$Textes$produitsReferencesRefusRattachementRequis);
			case 11:
				return A2(sous, duRattachement, $author$project$I18n$Textes$produitsReferencesRefusRattachementHorsHierarchie);
			case 34:
				return A2(sous, $author$project$Components$Produits$Catalogue$Creation$ZoneProduit, $author$project$I18n$Textes$produitsReferencesRefusTypeDifferent);
			case 43:
				return A2(sous, $author$project$Components$Produits$Catalogue$Creation$ZoneProduit, $author$project$I18n$Textes$produitsReferencesRefusCheminDifferent);
			case 32:
				return A2(sous, $author$project$Components$Produits$Catalogue$Creation$ZoneNom, $author$project$I18n$Textes$produitsReferencesRefusNomRequis);
			case 33:
				return A2(sous, $author$project$Components$Produits$Catalogue$Creation$ZoneEtat, $author$project$I18n$Textes$produitsReferencesRefusEtatInconnu);
			case 35:
				return enTete($author$project$I18n$Textes$produitsReferencesRefusTypeArchive);
			case 42:
				var etages = erreur.a;
				return A2(
					sous,
					$author$project$Components$Produits$Catalogue$Creation$ZoneRangement,
					$author$project$I18n$Textes$produitsReferencesRefusCheminIncomplet(
						{
							yG: $author$project$I18n$Traductions$tel(
								A2($elm$core$String$join, ', ', etages))
						}));
			case 46:
				var etage = erreur.a;
				return A2(
					sous,
					$author$project$Components$Produits$Catalogue$Creation$ZoneRangement,
					$author$project$I18n$Textes$produitsReferencesRefusDeuxValeurs(
						{
							md: $author$project$I18n$Traductions$tel(etage)
						}));
			case 45:
				return A2(sous, $author$project$Components$Produits$Catalogue$Creation$ZoneRangement, $author$project$I18n$Textes$produitsReferencesRefusValeurEnTrop);
			case 44:
				return A2(sous, $author$project$Components$Produits$Catalogue$Creation$ZoneRangement, $author$project$I18n$Textes$produitsReferencesRefusCheminInconnu);
			case 47:
				return A2(sous, $author$project$Components$Produits$Catalogue$Creation$ZoneRangement, $author$project$I18n$Textes$produitsReferencesRefusValeurArchivee);
			case 68:
				return A2(sous, $author$project$Components$Produits$Catalogue$Creation$ZoneRangement, $author$project$I18n$Textes$produitsReferencesRefusTypologieRequise);
			case 69:
				return A2(sous, $author$project$Components$Produits$Catalogue$Creation$ZoneRangement, $author$project$I18n$Textes$produitsReferencesRefusTypologieAChoisir);
			case 70:
				return A2(sous, $author$project$Components$Produits$Catalogue$Creation$ZoneRangement, $author$project$I18n$Textes$produitsReferencesRefusTypeHorsDeLaTypologie);
			case 48:
				return A2(sous, $author$project$Components$Produits$Catalogue$Creation$ZoneType, $author$project$I18n$Textes$produitsReferencesRefusCategorieRequise);
			case 49:
				return A2(sous, $author$project$Components$Produits$Catalogue$Creation$ZoneType, $author$project$I18n$Textes$produitsReferencesRefusCategorieNonProposable);
			default:
				return $author$project$Components$Produits$Catalogue$Update$perime(erreur) ? enTete($author$project$I18n$Textes$produitsCatalogueErreurPerime) : _Utils_Tuple2(
					$elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus)),
					$elm$core$Maybe$Nothing);
		}
	});
var $author$project$Components$Produits$Catalogue$Lot$refuse = function (lot) {
	return _Utils_update(
		lot,
		{pZ: true});
};
var $author$project$Components$Produits$Catalogue$Update$relecture = F2(
	function (rendue, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		return (rendue.sy && (!A2($elm$core$List$member, $author$project$Catalogue$API$WriteAPIModel$EvenementInconnu, rendue.mk))) ? A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Basics$append(effets),
			$author$project$Components$Produits$Catalogue$Update$relire(model)) : _Utils_Tuple2(
			model,
			_Utils_ap(
				effets,
				_List_fromArray(
					[
						$author$project$Components$Produits$Common$Effet$AttendreAvantDeRelire($author$project$Components$Produits$Common$Envoi$delaiDeRelectureMs)
					])));
	});
var $author$project$Components$Produits$Catalogue$Update$revenirALaListeSiFermee = F2(
	function (avant, _v0) {
		var apres = _v0.a;
		var effets = _v0.b;
		return (avant.f0 && ($author$project$Components$Shared$Drawer$Model$estOuvert(avant.kX) && (!$author$project$Components$Shared$Drawer$Model$estOuvert(apres.kX)))) ? _Utils_Tuple2(
			_Utils_update(
				apres,
				{f0: false}),
			_Utils_ap(
				effets,
				_List_fromArray(
					[
						$author$project$Components$Produits$Common$Effet$AllerA($author$project$Routes$Route$adresseCatalogue)
					]))) : _Utils_Tuple2(apres, effets);
	});
var $author$project$API$NavLinksDictionary$creerUneReference = 'creer-une-reference';
var $author$project$Components$Produits$Catalogue$Model$creation = function (catalogue) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUneReference, catalogue.nQ);
};
var $author$project$Components$Produits$Catalogue$Model$creable = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		function (catalogue) {
			return A2(
				$elm$core$Maybe$map,
				function (_v0) {
					return catalogue;
				},
				$author$project$Components$Produits$Catalogue$Model$creation(catalogue));
		},
		model.jB);
};
var $author$project$Components$Produits$Catalogue$Creation$etatDeDepart = F2(
	function (catalogue, nature) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$eq(nature)),
					catalogue.yO)));
	});
var $author$project$Catalogue$Vocabulaire$naturesDArticle = _List_fromArray(
	['produit-fini', 'piece', 'sous-ensemble', 'consommable', 'service']);
var $author$project$Components$Produits$Catalogue$Creation$parents = F2(
	function (catalogue, elements) {
		var _v0 = catalogue.pN.EY;
		if (!_v0.$) {
			var niveau = _v0.a;
			return A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.os;
					},
					$elm$core$Basics$eq(niveau)),
				elements);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Produits$Catalogue$Creation$depart = F3(
	function (catalogue, elements, noeud) {
		var nature = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head($author$project$Catalogue$Vocabulaire$naturesDArticle));
		return _Utils_update(
			$author$project$Components$Produits$Catalogue$Creation$vide,
			{
				gt: A2($author$project$Components$Produits$Catalogue$Creation$etatDeDepart, catalogue, nature),
				g1: nature,
				ey: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Aq;
					},
					A2(
						$elm$core$Maybe$andThen,
						function (id) {
							return $elm$core$List$head(
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.Aq;
										},
										$elm$core$Basics$eq(id)),
									A2($author$project$Components$Produits$Catalogue$Creation$parents, catalogue, elements)));
						},
						A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.lQ;
							},
							noeud))),
				fh: A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.fh;
					},
					noeud)
			});
	});
var $author$project$Components$Produits$Catalogue$Model$idDeLaCreation = 'references-creer';
var $author$project$Components$Produits$Common$Effet$LireLaStructure = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Produits$Catalogue$Update$lectureDeLaStructure = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$LireLaStructure, $elm$core$List$singleton),
			model.h$));
};
var $author$project$Components$Produits$Catalogue$Creation$enCours = function (saisie) {
	return A2(
		$elm$core$List$any,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$trim,
			$elm$core$Basics$neq('')),
		_List_fromArray(
			[saisie.vx, saisie.lI, saisie.n8, saisie.sl])) || A2(
		$elm$core$List$any,
		$elm$core$Basics$neq($author$project$Components$Shared$LibellesParLangue$Model$vide),
		_List_fromArray(
			[saisie.Dj, saisie.aF]));
};
var $author$project$Components$Produits$Catalogue$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{kX: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Produits$Common$Effet$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Produits$Catalogue$Creation$enCours(model.hP)
				},
				geste,
				model.kX));
	});
var $author$project$Components$Produits$Catalogue$Update$ouvrirLaCreation = function (model) {
	var _v0 = $author$project$Components$Produits$Catalogue$Model$creable(model);
	if (!_v0.$) {
		var catalogue = _v0.a;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Basics$append(
				$author$project$Components$Produits$Catalogue$Update$lectureDeLaStructure(model)),
			A2(
				$author$project$Components$Produits$Catalogue$Update$versLeDrawer,
				$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Produits$Catalogue$Model$idDeLaCreation),
				_Utils_update(
					model,
					{
						gl: false,
						hP: A3($author$project$Components$Produits$Catalogue$Creation$depart, catalogue, model.aV, $elm$core$Maybe$Nothing)
					})));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$Catalogue$Update$rouvrirLeFormulaireEmbarque = F2(
	function (avant, _v0) {
		var apres = _v0.a;
		var effets = _v0.b;
		return avant.gg ? A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Basics$append(effets),
			$author$project$Components$Produits$Catalogue$Update$ouvrirLaCreation(
				_Utils_update(
					apres,
					{f1: apres.f1 + 1}))) : _Utils_Tuple2(apres, effets);
	});
var $author$project$Components$Produits$Catalogue$Update$versLeDrawerDuLot = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{
						dP: drawer,
						n0: A2(
							$elm$core$List$member,
							geste,
							_List_fromArray(
								[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$AbandonConfirme])) ? $elm$core$Maybe$Nothing : model.n0
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Produits$Common$Effet$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.dP));
	});
var $author$project$Components$Produits$Catalogue$Update$conclure = F2(
	function (issue, model) {
		var produitCree = function (evenements) {
			return $elm$core$List$head(
				A2(
					$elm$core$List$filterMap,
					function (evenement) {
						if (evenement.$ === 36) {
							var id = evenement.a;
							var cree = evenement.b;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(id, cree));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					},
					evenements));
		};
		_v0$1:
		while (true) {
			switch (issue.$) {
				case 0:
					if (issue.c) {
						switch (issue.a.$) {
							case 34:
								var voulu = issue.a.a;
								var rendue = issue.b;
								var _v1 = produitCree(rendue.mk);
								if (!_v1.$) {
									var _v2 = _v1.a;
									var id = _v2.a;
									var lu = _v2.b;
									var cree = _Utils_update(
										lu,
										{Ki: voulu.Ki});
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												jB: A2(
													$elm$core$Maybe$map,
													A2($author$project$Components$Produits$Catalogue$Model$apresLeProduit, id, cree),
													model.jB),
												gl: true,
												hP: A2($author$project$Components$Produits$Catalogue$Creation$apresLeProduit, id, model.hP)
											}),
										_List_Nil);
								} else {
									return A3($author$project$Components$Produits$Catalogue$Update$produitRetrouve, voulu, rendue, model);
								}
							case 53:
								break _v0$1;
							case 52:
								var _v4 = issue.a;
								var rendue = issue.b;
								return function (_v5) {
									var rangee = _v5.a;
									var effets = _v5.b;
									return _Utils_Tuple2(
										rangee,
										_Utils_ap(
											effets,
											$author$project$Components$Produits$Catalogue$Update$lireARanger(rangee).b));
								}(
									A2(
										$author$project$Components$Produits$Catalogue$Update$relecture,
										rendue,
										A2(
											$author$project$Components$Produits$Catalogue$Update$versLeDrawer,
											$author$project$Components$Shared$Drawer$Update$Fermer,
											_Utils_update(
												model,
												{hA: $elm$core$Maybe$Nothing, hP: $author$project$Components$Produits$Catalogue$Creation$vide}))));
							default:
								var rendue = issue.b;
								return A2(
									$author$project$Components$Produits$Catalogue$Update$rouvrirLeFormulaireEmbarque,
									model,
									A2(
										$author$project$Components$Produits$Catalogue$Update$revenirALaListeSiFermee,
										model,
										A2(
											$author$project$Components$Produits$Catalogue$Update$relecture,
											rendue,
											A2(
												$author$project$Components$Produits$Catalogue$Update$versLeDrawer,
												$author$project$Components$Shared$Drawer$Update$Fermer,
												_Utils_update(
													model,
													{
														wo: A2(
															$elm$core$Maybe$withDefault,
															_List_Nil,
															A2(
																$elm$core$Maybe$map,
																function (c) {
																	return A2($author$project$Components$Produits$Catalogue$Model$cartesCreees, c, rendue);
																},
																model.jB)),
														bh: A3(
															$elm$core$Maybe$map2,
															F2(
																function (catalogue, liste) {
																	return A3($author$project$Components$Produits$Catalogue$Model$appliquer, catalogue, rendue, liste);
																}),
															model.jB,
															model.bh),
														hP: $author$project$Components$Produits$Catalogue$Creation$vide
													})))));
						}
					} else {
						if (issue.a.$ === 53) {
							break _v0$1;
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										hP: A3(
											$author$project$Components$Produits$Catalogue$Creation$refuser,
											$elm$core$Maybe$Just($author$project$Components$Produits$Common$Refus$rejeu),
											$elm$core$Maybe$Nothing,
											model.hP)
									}),
								$author$project$Components$Produits$Catalogue$Update$relire(model).b);
						}
					}
				case 1:
					if (issue.a.$ === 53) {
						var _v6 = issue.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									n0: A2($elm$core$Maybe$map, $author$project$Components$Produits$Catalogue$Lot$refuse, model.n0)
								}),
							_List_Nil);
					} else {
						var commande = issue.a;
						var refus = issue.b;
						var erreur = issue.c;
						var _v7 = A4($author$project$Components$Produits$Catalogue$Update$refusDe, model, commande, refus, erreur);
						var enTete = _v7.a;
						var sousUnChamp = _v7.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									hP: A3($author$project$Components$Produits$Catalogue$Creation$refuser, enTete, sousUnChamp, model.hP)
								}),
							_Utils_ap(
								(_Utils_eq(model.hA, $elm$core$Maybe$Nothing) || (!$author$project$Components$Produits$Catalogue$Update$perime(erreur))) ? _List_Nil : $author$project$Components$Produits$Catalogue$Update$lireARanger(model).b,
								_Utils_ap(
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											function (_v8) {
												var zone = _v8.a;
												return _List_fromArray(
													[
														$author$project$Components$Produits$Common$Effet$PlacerFocus(
														A2(
															$author$project$Components$Produits$Catalogue$Creation$idDe,
															$author$project$Components$Shared$Drawer$Model$idRacine(model.kX),
															zone))
													]);
											},
											sousUnChamp)),
									$author$project$Components$Produits$Catalogue$Update$perime(erreur) ? $author$project$Components$Produits$Catalogue$Update$relire(model).b : _List_Nil)));
					}
				default:
					return _Utils_Tuple2(model, _List_Nil);
			}
		}
		var _v3 = issue.a;
		return A2($author$project$Components$Produits$Catalogue$Update$versLeDrawerDuLot, $author$project$Components$Shared$Drawer$Update$Fermer, model);
	});
var $author$project$Catalogue$API$WriteAPIModel$CreerUneReference = function (a) {
	return {$: 37, a: a};
};
var $author$project$Components$Produits$Catalogue$Creation$Nouveau = {$: 2};
var $author$project$Components$Produits$Catalogue$Creation$UnProduit = {$: 0};
var $author$project$Components$Produits$Catalogue$Creation$ZoneEan = {$: 9};
var $author$project$Components$Produits$Catalogue$Creation$ZoneInformation = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Produits$Catalogue$Creation$ZoneMillesime = {$: 10};
var $author$project$Components$Produits$Catalogue$Creation$ZoneNomDuProduit = {$: 2};
var $author$project$Components$Produits$Catalogue$Creation$blanc = function (texte) {
	return $elm$core$String$trim(texte) === '';
};
var $author$project$Components$Produits$Catalogue$Creation$PourUnService = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$Catalogue$Creation$Rien = {$: 3};
var $author$project$Components$Produits$Catalogue$Creation$UnElement = function (a) {
	return {$: 1, a: a};
};
var $author$project$Catalogue$Vocabulaire$estUnProduit = function (code) {
	return code === 'produit';
};
var $author$project$Components$Produits$Catalogue$Creation$estLeNiveauProduit = F2(
	function (catalogue, niveau) {
		return A2(
			$elm$core$List$any,
			function (lu) {
				return _Utils_eq(lu.Aq, niveau) && $author$project$Catalogue$Vocabulaire$estUnProduit(lu.fA);
			},
			catalogue.C9);
	});
var $author$project$Components$Produits$Catalogue$Creation$demande = F2(
	function (catalogue, nature) {
		if ($author$project$Catalogue$Vocabulaire$estUnService(nature)) {
			return $author$project$Components$Produits$Catalogue$Creation$PourUnService(catalogue.pN.sX);
		} else {
			var _v0 = catalogue.pN.tR;
			if (_v0.$ === 1) {
				return $author$project$Components$Produits$Catalogue$Creation$Rien;
			} else {
				var niveau = _v0.a;
				return A2($author$project$Components$Produits$Catalogue$Creation$estLeNiveauProduit, catalogue, niveau) ? $author$project$Components$Produits$Catalogue$Creation$UnProduit : $author$project$Components$Produits$Catalogue$Creation$UnElement(niveau);
			}
		}
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $author$project$Components$Produits$Catalogue$Creation$eanValide = function (texte) {
	var chiffres = A2(
		$elm$core$List$filterMap,
		A2($elm$core$Basics$composeR, $elm$core$String$fromChar, $elm$core$String$toInt),
		$elm$core$String$toList(texte));
	var somme = $elm$core$List$sum(
		A2(
			$elm$core$List$indexedMap,
			F2(
				function (rang, chiffre) {
					return (!A2($elm$core$Basics$modBy, 2, rang)) ? chiffre : (3 * chiffre);
				}),
			A2($elm$core$List$take, 12, chiffres)));
	return ($elm$core$String$length(texte) === 13) && (($elm$core$List$length(chiffres) === 13) && _Utils_eq(
		A2($elm$core$List$drop, 12, chiffres),
		_List_fromArray(
			[
				A2(
				$elm$core$Basics$modBy,
				10,
				10 - A2($elm$core$Basics$modBy, 10, somme))
			])));
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Obligatoire = 0;
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$HorsListe = 7;
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$NombreDeChoix = 6;
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$HorsLongueur = 2;
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$deLongueur = F2(
	function (champ, saisi) {
		var hors = function (regle) {
			if (regle.$ === 1) {
				var min = regle.a;
				var max = regle.b;
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (borne) {
							return _Utils_cmp(
								$elm$core$String$length(saisi),
								borne) < 0;
						},
						min)) || A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (borne) {
							return _Utils_cmp(
								$elm$core$String$length(saisi),
								borne) > 0;
						},
						max));
			} else {
				return false;
			}
		};
		return A2($elm$core$List$any, hors, champ.hJ) ? _List_fromArray(
			[2]) : _List_Nil;
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Decimales = 4;
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Format = 1;
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$HorsBornesPlausibles = 5;
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$entre = F3(
	function (min, max, lu) {
		return A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function (borne) {
					return _Utils_cmp(lu, borne) > -1;
				},
				min)) && A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function (borne) {
					return _Utils_cmp(lu, borne) < 1;
				},
				max));
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$deMesure = F2(
	function (mesure, saisi) {
		var _v0 = $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$nombre(saisi);
		if (_v0.$ === 1) {
			return _List_fromArray(
				[1]);
		} else {
			var lu = _v0.a;
			var decimales = function () {
				var _v1 = A2(
					$elm$core$String$split,
					'.',
					A3(
						$elm$core$String$replace,
						',',
						'.',
						$elm$core$String$trim(saisi)));
				if ((_v1.b && _v1.b.b) && (!_v1.b.b.b)) {
					var _v2 = _v1.b;
					var apres = _v2.a;
					return $elm$core$String$length(apres);
				} else {
					return 0;
				}
			}();
			return (_Utils_cmp(decimales, mesure.kv) > 0) ? _List_fromArray(
				[4]) : (A3($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$entre, mesure.Cx, mesure.Cg, lu) ? _List_Nil : _List_fromArray(
				[5]));
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$HorsBornes = 3;
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$bornesDeNombre = function (champ) {
	var deBorne = function (borne) {
		if ((!borne.$) && (!borne.a.$)) {
			var lue = borne.a.a;
			return $elm$core$Maybe$Just(lue);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	return A2(
		$elm$core$Maybe$withDefault,
		_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
		$elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (regle) {
					if (!regle.$) {
						var min = regle.a;
						var max = regle.b;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(
								deBorne(min),
								deBorne(max)));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				champ.hJ)));
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$deNombre = F2(
	function (champ, saisi) {
		var _v0 = $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$nombre(saisi);
		if (_v0.$ === 1) {
			return _List_fromArray(
				[1]);
		} else {
			var lu = _v0.a;
			var _v1 = $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$bornesDeNombre(champ);
			var min = _v1.a;
			var max = _v1.b;
			return A3($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$entre, min, max, lu) ? _List_Nil : _List_fromArray(
				[3]);
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$estVide = function (valeur) {
	switch (valeur.$) {
		case 0:
			return true;
		case 1:
			var saisi = valeur.a;
			return $elm$core$String$trim(saisi) === '';
		case 2:
			var coches = valeur.a;
			return $elm$core$List$isEmpty(coches);
		case 3:
			return false;
		case 5:
			var selection = valeur.a;
			return $elm$core$List$isEmpty(selection.jL);
		case 6:
			var a = valeur.a;
			return A2(
				$elm$core$List$all,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$trim,
					$elm$core$Basics$eq('')),
				_List_fromArray(
					[a.a3, a.a4, a.a5, a.vz, a.B_, a.Hj, a.ho]));
		default:
			var textes = valeur.a;
			return A2(
				$elm$core$List$all,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$second,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$String$trim,
						$elm$core$Basics$eq(''))),
				textes);
	}
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$juger = F2(
	function (champ, valeur) {
		if ($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$estVide(valeur)) {
			return champ.he ? _List_fromArray(
				[0]) : _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(champ.r0, valeur);
			_v0$8:
			while (true) {
				switch (_v0.b.$) {
					case 1:
						switch (_v0.a.$) {
							case 0:
								var _v1 = _v0.a;
								var saisi = _v0.b.a;
								return A2($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$deLongueur, champ, saisi);
							case 1:
								var _v2 = _v0.a;
								var saisi = _v0.b.a;
								return A2($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$deLongueur, champ, saisi);
							case 2:
								var _v3 = _v0.a;
								var saisi = _v0.b.a;
								return A2($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$deLongueur, champ, saisi);
							case 3:
								var _v4 = _v0.a;
								var saisi = _v0.b.a;
								return A2($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$deNombre, champ, saisi);
							case 4:
								var _v5 = _v0.a;
								var saisi = _v0.b.a;
								return A2($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$deNombre, champ, saisi);
							case 10:
								var mesure = _v0.a.a;
								var saisi = _v0.b.a;
								return A2($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$deMesure, mesure, saisi);
							case 7:
								var valeurs = _v0.a.a;
								var saisi = _v0.b.a;
								return A2($elm$core$List$member, saisi, valeurs) ? _List_Nil : _List_fromArray(
									[7]);
							default:
								break _v0$8;
						}
					case 2:
						if (_v0.a.$ === 8) {
							var choix = _v0.a.a;
							var coches = _v0.b.a;
							return (A2(
								$elm$core$Maybe$withDefault,
								false,
								A2(
									$elm$core$Maybe$map,
									function (min) {
										return _Utils_cmp(
											$elm$core$List$length(coches),
											min) < 0;
									},
									choix.Cx)) || A2(
								$elm$core$Maybe$withDefault,
								false,
								A2(
									$elm$core$Maybe$map,
									function (max) {
										return _Utils_cmp(
											$elm$core$List$length(coches),
											max) > 0;
									},
									choix.Cg))) ? _List_fromArray(
								[6]) : _List_Nil;
						} else {
							break _v0$8;
						}
					default:
						break _v0$8;
				}
			}
			return _List_Nil;
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$fautes = F2(
	function (champs, saisie) {
		return A2(
			$elm$core$List$map,
			function ($) {
				return $.dy;
			},
			A2(
				$elm$core$List$filter,
				function (champ) {
					return $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$saisissable(champ) && A2(
						$elm$core$List$member,
						0,
						A2(
							$author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$juger,
							champ,
							A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$valeurDe, champ.dy, saisie.Ki)));
				},
				champs));
	});
var $author$project$Components$Produits$Catalogue$Creation$informationsFautives = function (saisie) {
	return A2(
		$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$fautes,
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.dw;
				},
				saisie.aN)),
		saisie.i8);
};
var $author$project$Components$Produits$Catalogue$Creation$millesimeValide = function (texte) {
	return ($elm$core$String$length(texte) === 4) && A2($elm$core$String$all, $elm$core$Char$isDigit, texte);
};
var $author$project$Components$Produits$Catalogue$Creation$fautes = F2(
	function (catalogue, saisie) {
		var sansProduit = !_Utils_eq(
			A2($author$project$Components$Produits$Catalogue$Creation$demande, catalogue, saisie.g1),
			$author$project$Components$Produits$Catalogue$Creation$UnProduit);
		return _Utils_ap(
			A2(
				$elm$core$List$filterMap,
				function (_v0) {
					var zone = _v0.a;
					var fautive = _v0.b;
					return fautive ? $elm$core$Maybe$Just(zone) : $elm$core$Maybe$Nothing;
				},
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Components$Produits$Catalogue$Creation$ZoneProduit,
						(!sansProduit) && _Utils_eq(saisie.Gp, $author$project$Components$Produits$Catalogue$Creation$AucunProduit)),
						_Utils_Tuple2(
						$author$project$Components$Produits$Catalogue$Creation$ZoneNomDuProduit,
						_Utils_eq(saisie.Gp, $author$project$Components$Produits$Catalogue$Creation$Nouveau) && _Utils_eq(
							$author$project$Components$Produits$Common$LibellesSaisis$versLApi(saisie.aF),
							$elm$core$Maybe$Nothing)),
						_Utils_Tuple2(
						$author$project$Components$Produits$Catalogue$Creation$ZoneType,
						(sansProduit || _Utils_eq(saisie.Gp, $author$project$Components$Produits$Catalogue$Creation$Nouveau)) && _Utils_eq(saisie.fh, $elm$core$Maybe$Nothing)),
						_Utils_Tuple2(
						$author$project$Components$Produits$Catalogue$Creation$ZoneNom,
						sansProduit && _Utils_eq(
							$author$project$Components$Produits$Common$LibellesSaisis$versLApi(saisie.Dj),
							$elm$core$Maybe$Nothing)),
						_Utils_Tuple2(
						$author$project$Components$Produits$Catalogue$Creation$ZoneRangement,
						(!$author$project$Catalogue$Vocabulaire$estUnService(saisie.g1)) && A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.jK;
									},
									A2($elm$core$Basics$composeR, $author$project$Catalogue$Chemin$complet, $elm$core$Basics$not)),
								saisie.r3))),
						_Utils_Tuple2(
						$author$project$Components$Produits$Catalogue$Creation$ZoneCode,
						$author$project$Components$Produits$Catalogue$Creation$blanc(saisie.vx)),
						_Utils_Tuple2(
						$author$project$Components$Produits$Catalogue$Creation$ZoneEan,
						(!$author$project$Components$Produits$Catalogue$Creation$blanc(saisie.lI)) && (!$author$project$Components$Produits$Catalogue$Creation$eanValide(
							$elm$core$String$trim(saisie.lI)))),
						_Utils_Tuple2(
						$author$project$Components$Produits$Catalogue$Creation$ZoneMillesime,
						(!$author$project$Components$Produits$Catalogue$Creation$blanc(saisie.n8)) && (!$author$project$Components$Produits$Catalogue$Creation$millesimeValide(
							$elm$core$String$trim(saisie.n8)))),
						_Utils_Tuple2(
						$author$project$Components$Produits$Catalogue$Creation$ZoneEtat,
						_Utils_eq(saisie.gt, $elm$core$Maybe$Nothing))
					])),
			A2(
				$elm$core$List$map,
				$author$project$Components$Produits$Catalogue$Creation$ZoneInformation,
				$author$project$Components$Produits$Catalogue$Creation$informationsFautives(saisie)));
	});
var $author$project$Components$Produits$Catalogue$Creation$produitACreer = F2(
	function (catalogue, saisie) {
		var _v0 = _Utils_Tuple3(
			_Utils_Tuple2(saisie.Gp, saisie.fh),
			A2($author$project$Components$Produits$Catalogue$Creation$fautes, catalogue, saisie),
			$author$project$Components$Produits$Common$LibellesSaisis$versLApi(saisie.aF));
		if ((((_v0.a.a.$ === 2) && (!_v0.a.b.$)) && (!_v0.b.b)) && (!_v0.c.$)) {
			var _v1 = _v0.a;
			var _v2 = _v1.a;
			var type_ = _v1.b.a;
			var libelles = _v0.c.a;
			return $elm$core$Maybe$Just(
				{
					R: libelles,
					ey: _Utils_eq(saisie.r3, $elm$core$Maybe$Nothing) ? saisie.ey : $elm$core$Maybe$Nothing,
					fh: type_,
					Ki: _List_Nil
				});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$Catalogue$Creation$valeursDeLaReference = function (saisie) {
	return $author$project$Catalogue$Vocabulaire$estUnService(saisie.g1) ? A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.jK;
				},
				$author$project$Catalogue$Chemin$valeursChoisies),
			saisie.r3)) : A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		$author$project$Components$Produits$Catalogue$Creation$valeursDuChemin(saisie));
};
var $author$project$Components$Produits$Catalogue$Creation$referenceACreer = F2(
	function (catalogue, saisie) {
		var sansProduit = !_Utils_eq(
			A2($author$project$Components$Produits$Catalogue$Creation$demande, catalogue, saisie.g1),
			$author$project$Components$Produits$Catalogue$Creation$UnProduit);
		var facultatif = function (texte) {
			return $author$project$Components$Produits$Catalogue$Creation$blanc(texte) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				$elm$core$String$trim(texte));
		};
		var _v0 = _Utils_Tuple3(
			_Utils_Tuple2(
				saisie.Gp,
				A2($author$project$Components$Produits$Catalogue$Creation$fautes, catalogue, saisie)),
			A2($author$project$Components$Produits$Catalogue$Creation$typeRetenu, catalogue, saisie),
			saisie.gt);
		if (_v0.a.a.$ === 2) {
			var _v1 = _v0.a;
			var _v2 = _v1.a;
			return $elm$core$Maybe$Nothing;
		} else {
			if (((!_v0.a.b.b) && (!_v0.b.$)) && (!_v0.c.$)) {
				var _v3 = _v0.a;
				var type_ = _v0.b.a;
				var etat = _v0.c.a;
				return $elm$core$Maybe$Just(
					{
						i8: $author$project$Components$Produits$Catalogue$Creation$informationsSaisies(saisie),
						vx: $elm$core$String$trim(saisie.vx),
						lI: facultatif(saisie.lI),
						gt: etat,
						n8: facultatif(saisie.n8),
						g1: saisie.g1,
						Dj: sansProduit ? $author$project$Components$Produits$Common$LibellesSaisis$versLApi(saisie.Dj) : $elm$core$Maybe$Nothing,
						o4: $elm$core$Maybe$Nothing,
						pN: function () {
							var _v4 = _Utils_Tuple2(saisie.Gp, saisie.r3);
							if (_v4.a.$ === 1) {
								var id = _v4.a.a;
								return $elm$core$Maybe$Just(id);
							} else {
								if (!_v4.b.$) {
									return $elm$core$Maybe$Nothing;
								} else {
									return saisie.pN;
								}
							}
						}(),
						fh: type_,
						r3: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.Aq;
							},
							saisie.r3),
						Ki: $author$project$Components$Produits$Catalogue$Creation$valeursDeLaReference(saisie),
						sl: facultatif(saisie.sl)
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$tenter = function (saisie) {
	return _Utils_update(
		saisie,
		{b5: true});
};
var $author$project$Components$Produits$Catalogue$Creation$tenter = function (saisie) {
	return _Utils_update(
		saisie,
		{
			i8: $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$tenter(saisie.i8),
			b5: true
		});
};
var $author$project$Components$Produits$Catalogue$Update$creer = function (model) {
	var partir = F2(
		function (lien, commande) {
			var _v8 = A3($author$project$Components$Produits$Common$Envoi$partir, lien, commande, model.l2);
			if (!_v8.$) {
				var _v9 = _v8.a;
				var envoi = _v9.a;
				var effets = _v9.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: envoi,
							hP: A3($author$project$Components$Produits$Catalogue$Creation$refuser, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, model.hP)
						}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		});
	var _v0 = _Utils_Tuple2(
		model.jB,
		$author$project$Components$Shared$Drawer$Model$estOuvert(model.kX));
	if ((!_v0.a.$) && _v0.b) {
		var catalogue = _v0.a.a;
		var _v1 = _Utils_Tuple3(
			A2($author$project$Components$Produits$Catalogue$Creation$produitACreer, catalogue, model.hP),
			A2($author$project$Components$Produits$Catalogue$Creation$referenceACreer, catalogue, model.hP),
			A2($author$project$Components$Produits$Catalogue$Creation$fautes, catalogue, model.hP));
		if (!_v1.a.$) {
			var produit = _v1.a.a;
			return A2(
				partir,
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUnProduit, catalogue.nQ),
				$author$project$Catalogue$API$WriteAPIModel$CreerUnProduit(produit));
		} else {
			if (!_v1.b.$) {
				var _v2 = _v1.a;
				var reference = _v1.b.a;
				return A2(
					partir,
					$author$project$Components$Produits$Catalogue$Model$creation(catalogue),
					$author$project$Catalogue$API$WriteAPIModel$CreerUneReference(reference));
			} else {
				if (_v1.c.b) {
					var _v3 = _v1.a;
					var _v4 = _v1.b;
					var _v5 = _v1.c;
					var fautive = _v5.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								hP: $author$project$Components$Produits$Catalogue$Creation$tenter(model.hP)
							}),
						_List_fromArray(
							[
								$author$project$Components$Produits$Common$Effet$PlacerFocus(
								A2(
									$author$project$Components$Produits$Catalogue$Creation$idDe,
									$author$project$Components$Shared$Drawer$Model$idRacine(model.kX),
									fautive))
							]));
				} else {
					var _v6 = _v1.a;
					var _v7 = _v1.b;
					return _Utils_Tuple2(model, _List_Nil);
				}
			}
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$Catalogue$Update$delaiDeSaisieMs = 300;
var $author$project$Components$Produits$Catalogue$Model$deplacer = F3(
	function (sens, colonne, cochees) {
		if (!sens) {
			return A2(
				$author$project$Components$Shared$Ordre$monter,
				$elm$core$Basics$eq(colonne),
				cochees);
		} else {
			return A2(
				$author$project$Components$Shared$Ordre$descendre,
				$elm$core$Basics$eq(colonne),
				cochees);
		}
	});
var $author$project$Components$Produits$Common$Effet$GarderVue = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Components$Produits$Catalogue$Update$depuisLaListe = function (effet) {
	if (!effet.$) {
		var cle = effet.a;
		var vue = effet.b;
		return _List_fromArray(
			[
				A2($author$project$Components$Produits$Common$Effet$GarderVue, cle, vue)
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Produits$Catalogue$Creation$elementsDe = function (catalogue) {
	var de = function (noeud) {
		var _v0 = noeud.yp;
		var enfants = _v0;
		return _Utils_ap(
			function () {
				var _v1 = _Utils_Tuple3(noeud.vf.lQ, noeud.os, noeud.R);
				if (((!_v1.a.$) && (!_v1.b.$)) && (!_v1.c.$)) {
					var id = _v1.a.a;
					var niveau = _v1.b.a;
					var libelles = _v1.c.a;
					return _List_fromArray(
						[
							{Aq: id, os: niveau, Dj: libelles.zX}
						]);
				} else {
					return _List_Nil;
				}
			}(),
			A2($elm$core$List$concatMap, de, enfants));
	};
	return A3(
		$elm$core$List$foldl,
		F2(
			function (element, vus) {
				return A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Aq;
						},
						$elm$core$Basics$eq(element.Aq)),
					vus) ? vus : _Utils_ap(
					vus,
					_List_fromArray(
						[element]));
			}),
		_List_Nil,
		A2($elm$core$List$concatMap, de, catalogue.tA));
};
var $author$project$Components$Produits$Common$Facettes$retenir = F2(
	function (facettes, demande) {
		return _Utils_update(
			demande,
			{
				dt: A2(
					$elm$core$List$filter,
					function (id) {
						return A2(
							$elm$core$List$any,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(id)),
							A2($author$project$Components$Produits$Common$Facettes$categoriesVisibles, demande.mu, facettes));
					},
					demande.dt),
				gG: A2(
					$elm$core$List$filter,
					function (id) {
						return A2(
							$elm$core$List$any,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(id)),
							A2($author$project$Components$Produits$Common$Facettes$gammesVisibles, demande.cU, facettes));
					},
					demande.gG)
			});
	});
var $author$project$Components$Produits$Catalogue$Update$retenir = F2(
	function (model, demande) {
		var _v0 = model.jB;
		if (!_v0.$) {
			var catalogue = _v0.a;
			return A2(
				$author$project$Components$Produits$Common$Facettes$retenir,
				A2($author$project$Components$Produits$Common$Facettes$depuis, catalogue, model.r7),
				demande);
		} else {
			return demande;
		}
	});
var $author$project$Components$Produits$Catalogue$Update$setPage = F2(
	function (page, demande) {
		return _Utils_update(
			demande,
			{EE: page});
	});
var $author$project$Components$Produits$Catalogue$Update$filtrer = F2(
	function (changer, model) {
		var demande = changer(
			A2($author$project$Components$Produits$Catalogue$Update$setPage, 1, model.kC));
		return A2(
			$author$project$Components$Produits$Catalogue$Update$allerA,
			A2($author$project$Components$Produits$Catalogue$Update$retenir, model, demande),
			model);
	});
var $author$project$Components$Produits$Catalogue$Lot$geste = F2(
	function (voulu, lot) {
		return _Utils_update(
			lot,
			{mW: voulu, pZ: false});
	});
var $author$project$Components$Produits$Catalogue$Model$idDeLOrdre = function (code) {
	return 'references-tri-' + code;
};
var $author$project$Components$Shared$Annuaire$Model$idDuDeclencheurDeColonnes = 'annuaire-colonnes';
var $author$project$Components$Produits$Catalogue$Model$idDuDeclencheurDeColonnes = $author$project$Components$Shared$Annuaire$Model$idDuDeclencheurDeColonnes;
var $author$project$Components$Produits$Catalogue$Model$idDuDeclencheurDeFiltres = 'references-filtres';
var $author$project$Components$Produits$Catalogue$Model$idDuDeclencheurDuTri = 'references-tri';
var $author$project$Components$Produits$Catalogue$Model$idDuRangement = 'references-ranger';
var $author$project$Components$Produits$Catalogue$Update$libelleDeLEtage = F2(
	function (model, id) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Traductions$tel(
				$author$project$Catalogue$Identifiants$niveauIdToString(id)),
			A2(
				$elm$core$Maybe$map,
				$author$project$Catalogue$Niveau$libelleDuNiveau,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(id)),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.C9;
								},
								model.jB))))));
	});
var $author$project$Components$Produits$Common$Effet$LireLApercuDuCalculEnLot = F2(
	function (a, b) {
		return {$: 41, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$apercuDuCalculEnLot = 'apercu-du-calcul-en-lot';
var $author$project$API$NavLinksDictionary$variableChamp = 'champ';
var $author$project$Components$Produits$Catalogue$Lot$lienDeLApercu = F2(
	function (liste, cle) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2($author$project$API$NavLinksDictionary$variableChamp, cle)
					])),
			A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$apercuDuCalculEnLot, liste.nQ.gF));
	});
var $author$project$Components$Produits$Catalogue$Update$lireLApercuDuLot = F2(
	function (cle, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Produits$Common$Effet$LireLApercuDuCalculEnLot(cle),
					$elm$core$List$singleton),
				A2(
					$elm$core$Maybe$andThen,
					function (liste) {
						return A2($author$project$Components$Produits$Catalogue$Lot$lienDeLApercu, liste, cle);
					},
					model.bh)));
	});
var $author$project$Components$Produits$Catalogue$Model$memeFiltre = F2(
	function (a, b) {
		return _Utils_eq(
			_Utils_update(
				a,
				{EE: 1, Jm: 0, rS: ''}),
			_Utils_update(
				b,
				{EE: 1, Jm: 0, rS: ''}));
	});
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$naturesDecoder = A2(
	$elm$json$Json$Decode$field,
	'natures',
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$sortBy($elm$core$Tuple$first),
					$elm$core$List$map($elm$core$Tuple$second)),
				$elm$json$Json$Decode$list(
					A4(
						$elm$json$Json$Decode$map3,
						F3(
							function (code, nom, rang) {
								return _Utils_Tuple2(
									rang,
									_Utils_Tuple2(code, nom));
							}),
						A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
						$elm$json$Json$Decode$maybe(
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['libelles', 'fr']),
								$elm$json$Json$Decode$string)),
						A2($elm$json$Json$Decode$field, 'rang', $elm$json$Json$Decode$int)))),
				A2(
				$elm$json$Json$Decode$map,
				$elm$core$List$map(
					function (code) {
						return _Utils_Tuple2(code, $elm$core$Maybe$Nothing);
					}),
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string))
			])));
var $author$project$Components$Shared$Annuaire$Model$deselectionner = function (model) {
	return _Utils_update(
		model,
		{vv: $elm$core$Set$empty, aw: 0});
};
var $author$project$Components$Produits$Catalogue$Model$ouvert = F3(
	function (demande, lecture, model) {
		return {
			iz: $elm$core$Maybe$Nothing,
			bs: _List_Nil,
			jB: $elm$core$Maybe$Nothing,
			dA: model.dA,
			f0: false,
			wo: model.wo,
			f1: 0,
			kC: demande,
			kX: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$Catalogue$Model$nomDuDrawer),
			dP: model.dP,
			aV: _List_Nil,
			gg: false,
			gl: false,
			l2: $author$project$API$Envoi$SansProcessUid,
			gC: 0,
			np: lecture,
			nW: $author$project$Components$Shared$Annuaire$Model$deselectionner(model.nW),
			n0: model.n0,
			gY: false,
			oo: _List_Nil,
			ha: _List_Nil,
			hd: $author$project$Referentiel$Normes$vide,
			DX: 0,
			hA: $elm$core$Maybe$Nothing,
			bh: $elm$core$Maybe$Nothing,
			hP: $author$project$Components$Produits$Catalogue$Creation$vide,
			q3: $elm$core$Dict$empty,
			h$: $elm$core$Maybe$Nothing,
			h3: '',
			r7: _List_Nil,
			im: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$Catalogue$Model$nomDuVolet),
			$9: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$Catalogue$Model$nomDuVoletDesColonnes)
		};
	});
var $author$project$Components$Produits$Catalogue$Model$idDuLot = 'references-debrayer-un-lot';
var $author$project$Components$Produits$Catalogue$Lot$ouvrir = function (liste) {
	return _Utils_eq(
		$author$project$Components$Produits$Catalogue$Lot$lienDeLaCommande(liste),
		$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Nothing : A2(
		$elm$core$Maybe$map,
		function (c) {
			return {tq: $elm$core$Maybe$Nothing, uN: c.dy, mW: 'debrayer', Ax: false, pZ: false};
		},
		$elm$core$List$head(liste.uS));
};
var $author$project$Components$Produits$Catalogue$Update$ouvrirLeLot = function (model) {
	var _v0 = A2($elm$core$Maybe$andThen, $author$project$Components$Produits$Catalogue$Lot$ouvrir, model.bh);
	if (!_v0.$) {
		var lot = _v0.a;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Basics$append(
				A2($author$project$Components$Produits$Catalogue$Update$lireLApercuDuLot, lot.uN, model)),
			A2(
				$author$project$Components$Produits$Catalogue$Update$versLeDrawerDuLot,
				$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Produits$Catalogue$Model$idDuLot),
				_Utils_update(
					model,
					{
						n0: $elm$core$Maybe$Just(lot)
					})));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Routes$Route$borneEcrite = function (borne) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $elm$core$String$fromFloat, borne));
};
var $author$project$Routes$Route$plageEcrite = F2(
	function (cle, _v0) {
		var minimum = _v0.a;
		var maximum = _v0.b;
		return (_Utils_eq(minimum, $elm$core$Maybe$Nothing) && _Utils_eq(maximum, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			cle + (':' + ($author$project$Routes$Route$borneEcrite(minimum) + (':' + $author$project$Routes$Route$borneEcrite(maximum)))));
	});
var $author$project$Components$Produits$Catalogue$Update$poserUneBorne = F4(
	function (cle, borne, saisie, demande) {
		var ecrite = A3(
			$elm$core$String$replace,
			',',
			'.',
			$elm$core$String$trim(saisie));
		var nouvelle = (ecrite === '') ? $elm$core$Maybe$Just($elm$core$Maybe$Nothing) : A2(
			$elm$core$Maybe$map,
			$elm$core$Maybe$Just,
			$elm$core$String$toFloat(ecrite));
		var autres = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$String$startsWith(cle + ':'),
				$elm$core$Basics$not),
			demande.pn);
		var actuelle = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$eq(cle)),
						A2($elm$core$List$filterMap, $author$project$Routes$Route$plageLue, demande.pn)))));
		if (nouvelle.$ === 1) {
			return demande;
		} else {
			var valeur = nouvelle.a;
			var posee = function () {
				if (!borne) {
					return _Utils_Tuple2(valeur, actuelle.b);
				} else {
					return _Utils_Tuple2(actuelle.a, valeur);
				}
			}();
			return _Utils_update(
				demande,
				{
					pn: _Utils_ap(
						autres,
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								$elm$core$List$singleton,
								A2($author$project$Routes$Route$plageEcrite, cle, posee))))
				});
		}
	});
var $author$project$Components$Produits$Catalogue$Creation$pourRanger = F2(
	function (typologie, type_) {
		return _Utils_update(
			$author$project$Components$Produits$Catalogue$Creation$vide,
			{
				fh: $elm$core$Maybe$Just(type_),
				r3: $elm$core$Maybe$Just(typologie),
				r7: _List_fromArray(
					[typologie])
			});
	});
var $author$project$Components$Produits$Catalogue$Update$premiere = $author$project$Routes$Route$premiereListeDeReferences;
var $author$project$Components$Produits$Common$Effet$ProposerLesProduits = F3(
	function (a, b, c) {
		return {$: 33, a: a, b: b, c: c};
	});
var $author$project$API$NavLinksDictionary$produitsProposes = 'produits-proposes';
var $author$project$Components$Produits$Liens$versLesProduitsProposes = F2(
	function (id, gabarits) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$API$NavLinksDictionary$variableUid,
						$author$project$Catalogue$Identifiants$typeDeProduitIdToString(id))
					])),
			A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$produitsProposes, gabarits));
	});
var $author$project$Components$Produits$Catalogue$Update$produitsDemandes = F3(
	function (catalogue, valeurs, categories) {
		return A2(
			$elm$core$List$filterMap,
			function (categorie) {
				return A2(
					$elm$core$Maybe$map,
					function (lien) {
						return A3($author$project$Components$Produits$Common$Effet$ProposerLesProduits, lien, categorie.Aq, valeurs);
					},
					A2($author$project$Components$Produits$Liens$versLesProduitsProposes, categorie.Aq, catalogue.gF));
			},
			categories);
	});
var $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$produitsProposesDecoder = A2(
	$elm$json$Json$Decode$field,
	'produits',
	$elm$json$Json$Decode$list(
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'nom',
			$author$project$Catalogue$API$QueryAPIModel$libellesDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'typeDeProduit',
				$author$project$Catalogue$Identifiants$typeDeProduitIdDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$author$project$Catalogue$Identifiants$elementIdDecoder,
					$elm$json$Json$Decode$succeed(
						F3(
							function (id, type_, nom) {
								return {jK: $elm$core$Maybe$Nothing, Aq: id, R: nom, ey: $elm$core$Maybe$Nothing, fh: type_};
							})))))));
var $author$project$Catalogue$API$WriteAPIModel$RangerUneReference = F3(
	function (a, b, c) {
		return {$: 52, a: a, b: b, c: c};
	});
var $author$project$API$NavLinksDictionary$rangerUneReference = 'ranger-une-reference';
var $author$project$Components$Produits$Catalogue$Update$ranger = function (model) {
	var _v0 = _Utils_Tuple2(
		_Utils_Tuple2(
			model.hA,
			$author$project$Components$Shared$Drawer$Model$estOuvert(model.kX)),
		$author$project$Components$Produits$Catalogue$Creation$valeursDuChemin(model.hP));
	if ((!_v0.a.a.$) && _v0.a.b) {
		if (!_v0.b.$) {
			var _v1 = _v0.a;
			var reference = _v1.a.a;
			var valeurs = _v0.b.a;
			var _v2 = A3(
				$author$project$Components$Produits$Common$Envoi$partir,
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rangerUneReference, reference.nQ),
				A3(
					$author$project$Catalogue$API$WriteAPIModel$RangerUneReference,
					reference.Aq,
					valeurs,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.r3;
						},
						model.iz)),
				model.l2);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var envoi = _v3.a;
				var effets = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: envoi,
							hP: A3($author$project$Components$Produits$Catalogue$Creation$refuser, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, model.hP)
						}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			var _v4 = _v0.a;
			var _v5 = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						hP: $author$project$Components$Produits$Catalogue$Creation$tenter(model.hP)
					}),
				_List_fromArray(
					[
						$author$project$Components$Produits$Common$Effet$PlacerFocus(
						A2(
							$author$project$Components$Produits$Catalogue$Creation$idDe,
							$author$project$Components$Shared$Drawer$Model$idRacine(model.kX),
							$author$project$Components$Produits$Catalogue$Creation$ZoneRangement))
					]));
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$Catalogue$Model$referencesCochees = function (model) {
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$first,
		$elm$core$Dict$values(model.q3));
};
var $author$project$Components$Produits$Catalogue$Update$refusSousLeRangement = function (texte) {
	return A2(
		$author$project$Components$Produits$Catalogue$Creation$refuser,
		$elm$core$Maybe$Nothing,
		$elm$core$Maybe$Just(
			_Utils_Tuple2($author$project$Components$Produits$Catalogue$Creation$ZoneRangement, texte)));
};
var $author$project$Components$Produits$Catalogue$Model$nombreDeFiltres = function (demande) {
	return (((((((((($elm$core$List$length(demande.mj) + $elm$core$List$length(demande.cU)) + $elm$core$List$length(demande.gG)) + $elm$core$List$length(demande.r7)) + $elm$core$List$length(demande.mu)) + $elm$core$List$length(demande.dt)) + $elm$core$List$length(demande.dw)) + $elm$core$List$length(demande.qs)) + $elm$core$List$length(demande.pn)) + (_Utils_eq(demande.fh, $elm$core$Maybe$Nothing) ? 0 : 1)) + (_Utils_eq(demande.fU, $elm$core$Maybe$Nothing) ? 0 : 1)) + (demande.i2 ? 1 : 0);
};
var $author$project$I18n$Textes$produitsReferencesArchivageResume = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.references.archivage.resume',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'typologie',
				$author$project$I18n$Traductions$Sous(p.r3)),
				_Utils_Tuple2(
				'autres',
				$author$project$I18n$Traductions$Entier(p.t7))
			]),
		'{typologie} · {autres, plural, one {# autre filtre} other {# autres filtres}}');
};
var $author$project$Components$Produits$Catalogue$Model$resumeDuFiltre = F2(
	function (model, typologie) {
		var nom = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.Dj;
					},
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(typologie)),
						model.r7))));
		var autres = ($author$project$Components$Produits$Catalogue$Model$nombreDeFiltres(model.kC) - 1) + (($elm$core$String$trim(model.h3) === '') ? 0 : 1);
		return (autres > 0) ? $author$project$I18n$Textes$produitsReferencesArchivageResume(
			{
				t7: autres,
				r3: $author$project$I18n$Traductions$tel(nom)
			}) : $author$project$I18n$Traductions$tel(nom);
	});
var $author$project$Components$Produits$Catalogue$Creation$ZoneNature = {$: 0};
var $author$project$Components$Produits$Catalogue$Creation$ZoneVariante = {$: 11};
var $author$project$Catalogue$Chemin$choisir = F2(
	function (id, chemin) {
		var etages = chemin.a;
		var noeuds = chemin.b;
		var ids = chemin.c;
		var _v0 = A2($author$project$Catalogue$Chemin$noeud, chemin, id);
		if (_v0.$ === 1) {
			return chemin;
		} else {
			var clique = _v0.a;
			var rang = function (etageId) {
				return A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$second,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Tuple$first,
									$elm$core$Basics$eq(etageId)),
								A2(
									$elm$core$List$indexedMap,
									F2(
										function (i, e) {
											return _Utils_Tuple2(e.Aq, i);
										}),
									etages)))));
			};
			var dessus = function (choisi) {
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (n) {
							return _Utils_cmp(
								rang(n.md),
								rang(clique.md)) < 0;
						},
						A2($author$project$Catalogue$Chemin$noeud, chemin, choisi)));
			};
			var garde = A2($elm$core$List$filter, dessus, ids);
			var ancetres = function (n) {
				var _v1 = A2(
					$elm$core$Maybe$andThen,
					$author$project$Catalogue$Chemin$noeud(chemin),
					n.ey);
				if (!_v1.$) {
					var parent = _v1.a;
					return _Utils_ap(
						ancetres(parent),
						_List_fromArray(
							[parent.Aq]));
				} else {
					return _List_Nil;
				}
			};
			return A2($elm$core$List$member, id, ids) ? A3($author$project$Catalogue$Chemin$Chemin, etages, noeuds, garde) : A3(
				$author$project$Catalogue$Chemin$Chemin,
				etages,
				noeuds,
				_Utils_ap(
					ancetres(clique),
					_List_fromArray(
						[id])));
		}
	});
var $author$project$Components$Produits$Catalogue$Creation$nouveauProduit = 'nouveau';
var $author$project$Components$Produits$Catalogue$Creation$produitsProposes = F2(
	function (catalogue, saisie) {
		var _v0 = saisie.r3;
		if (_v0.$ === 1) {
			return catalogue.aK;
		} else {
			var typologie = _v0.a;
			var _v1 = $author$project$Catalogue$Chemin$valeurs(typologie.jK);
			if (!_v1.$) {
				var chemin = _v1.a;
				var proposes = A2(
					$elm$core$List$concatMap,
					function ($) {
						return $.aK;
					},
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Ki;
							},
							$author$project$Components$Produits$Catalogue$Creation$memesValeurs(chemin)),
						saisie.c1));
				var cree = function () {
					var _v2 = saisie.Gp;
					if (_v2.$ === 1) {
						var id = _v2.a;
						return (saisie.bd && (!A2(
							$elm$core$List$any,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(id)),
							proposes))) ? A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(id)),
							catalogue.aK) : _List_Nil;
					} else {
						return _List_Nil;
					}
				}();
				return _Utils_ap(proposes, cree);
			} else {
				return _List_Nil;
			}
		}
	});
var $author$project$Components$Produits$Catalogue$Creation$produitRetenu = F2(
	function (catalogue, saisie) {
		var _v0 = saisie.Gp;
		if (_v0.$ === 1) {
			var id = _v0.a;
			return A2(
				$elm$core$List$any,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Aq;
					},
					$elm$core$Basics$eq(id)),
				A2($author$project$Components$Produits$Catalogue$Creation$produitsProposes, catalogue, saisie)) ? saisie : _Utils_update(
				saisie,
				{Gp: $author$project$Components$Produits$Catalogue$Creation$AucunProduit, bd: false});
		} else {
			return saisie;
		}
	});
var $author$project$Components$Produits$Catalogue$Creation$rattachables = F3(
	function (catalogue, elements, nature) {
		var _v0 = A2($author$project$Components$Produits$Catalogue$Creation$demande, catalogue, nature);
		switch (_v0.$) {
			case 1:
				var niveau = _v0.a;
				return A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.os;
						},
						$elm$core$Basics$eq(niveau)),
					elements);
			case 2:
				var admis = _v0.a;
				return _Utils_ap(
					A2(
						$elm$core$List$filter,
						function (element) {
							return A2($elm$core$List$member, element.os, admis);
						},
						elements),
					A2(
						$elm$core$List$concatMap,
						function (niveau) {
							return A2(
								$elm$core$List$map,
								function (produit) {
									return {Aq: produit.Aq, os: niveau, Dj: produit.R.zX};
								},
								catalogue.aK);
						},
						A2(
							$elm$core$List$filter,
							$author$project$Components$Produits$Catalogue$Creation$estLeNiveauProduit(catalogue),
							admis)));
			default:
				return _List_Nil;
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$saisir = F2(
	function (geste, saisie) {
		switch (geste.$) {
			case 1:
				var choisie = geste.a;
				return _Utils_update(
					saisie,
					{nn: choisie});
			case 2:
				return saisie;
			default:
				var cle = geste.a;
				var valeur = geste.b;
				var fusionnee = function () {
					var _v2 = _Utils_Tuple2(
						A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$valeurDe, cle, saisie.Ki),
						valeur);
					if ((_v2.a.$ === 4) && (_v2.b.$ === 4)) {
						var avant = _v2.a.a;
						var saisis = _v2.b.a;
						return $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$ParLangue(
							_Utils_ap(
								A2(
									$elm$core$List$map,
									function (_v3) {
										var code = _v3.a;
										var texte = _v3.b;
										return _Utils_Tuple2(
											code,
											A2(
												$elm$core$Maybe$withDefault,
												texte,
												A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$textesDe, code, saisis)));
									},
									avant),
								A2(
									$elm$core$List$filter,
									function (_v4) {
										var code = _v4.a;
										return _Utils_eq(
											A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$textesDe, code, avant),
											$elm$core$Maybe$Nothing);
									},
									saisis)));
					} else {
						return valeur;
					}
				}();
				return _Utils_update(
					saisie,
					{
						aJ: A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$first,
								$elm$core$Basics$neq(cle)),
							saisie.aJ),
						pZ: A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.uN;
								},
								$elm$core$Basics$neq(cle)),
							saisie.pZ),
						Ki: A2(
							$elm$core$List$any,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$first,
								$elm$core$Basics$eq(cle)),
							saisie.Ki) ? A2(
							$elm$core$List$map,
							function (_v1) {
								var autre = _v1.a;
								var garde = _v1.b;
								return _Utils_eq(autre, cle) ? _Utils_Tuple2(cle, fusionnee) : _Utils_Tuple2(autre, garde);
							},
							saisie.Ki) : _Utils_ap(
							saisie.Ki,
							_List_fromArray(
								[
									_Utils_Tuple2(cle, fusionnee)
								]))
					});
		}
	});
var $author$project$Components$Produits$Catalogue$Creation$saisir = F4(
	function (catalogue, elements, champ, saisie) {
		var sans = F2(
			function (zone, voulue) {
				return _Utils_update(
					voulue,
					{
						bf: function () {
							var _v1 = voulue.bf;
							if (!_v1.$) {
								var _v2 = _v1.a;
								var fautive = _v2.a;
								return _Utils_eq(fautive, zone) ? $elm$core$Maybe$Nothing : voulue.bf;
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}()
					});
			});
		var parmi = F3(
			function (versTexte, proposes, valeur) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							versTexte,
							$elm$core$Basics$eq(valeur)),
						proposes));
			});
		var element = A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.Aq;
			},
			$author$project$Catalogue$Identifiants$elementIdToString);
		switch (champ.$) {
			case 0:
				var code = champ.a;
				return A2($elm$core$List$member, code, $author$project$Catalogue$Vocabulaire$naturesDArticle) ? A2(
					sans,
					$author$project$Components$Produits$Catalogue$Creation$ZoneNature,
					_Utils_update(
						saisie,
						{
							gt: A2($author$project$Components$Produits$Catalogue$Creation$etatDeDepart, catalogue, code),
							g1: code,
							Gp: $author$project$Components$Produits$Catalogue$Creation$AucunProduit,
							bd: false,
							pN: $elm$core$Maybe$Nothing
						})) : saisie;
			case 1:
				var valeur = champ.a;
				return A2(
					sans,
					$author$project$Components$Produits$Catalogue$Creation$ZoneProduit,
					_Utils_update(
						saisie,
						{
							Gp: _Utils_eq(valeur, $author$project$Components$Produits$Catalogue$Creation$nouveauProduit) ? $author$project$Components$Produits$Catalogue$Creation$Nouveau : A2(
								$elm$core$Maybe$withDefault,
								$author$project$Components$Produits$Catalogue$Creation$AucunProduit,
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.Aq;
										},
										$author$project$Components$Produits$Catalogue$Creation$Existant),
									A3(parmi, element, catalogue.aK, valeur))),
							bd: false
						}));
			case 2:
				var code = champ.a;
				var texte = champ.b;
				return A2(
					sans,
					$author$project$Components$Produits$Catalogue$Creation$ZoneNomDuProduit,
					_Utils_update(
						saisie,
						{
							aF: A3($author$project$Components$Shared$LibellesParLangue$Model$ecrire, code, texte, saisie.aF)
						}));
			case 3:
				var valeur = champ.a;
				return A2(
					sans,
					$author$project$Components$Produits$Catalogue$Creation$ZoneType,
					_Utils_update(
						saisie,
						{
							fh: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.Aq;
								},
								A3(
									parmi,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.Aq;
										},
										$author$project$Catalogue$Identifiants$typeDeProduitIdToString),
									catalogue.ib,
									valeur))
						}));
			case 4:
				var valeur = champ.a;
				return A2(
					sans,
					$author$project$Components$Produits$Catalogue$Creation$ZoneParent,
					_Utils_update(
						saisie,
						{
							ey: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.Aq;
								},
								A3(
									parmi,
									element,
									A2($author$project$Components$Produits$Catalogue$Creation$parents, catalogue, elements),
									valeur))
						}));
			case 5:
				var valeur = champ.a;
				return A2(
					sans,
					$author$project$Components$Produits$Catalogue$Creation$ZoneRattachement,
					_Utils_update(
						saisie,
						{
							pN: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.Aq;
								},
								A3(
									parmi,
									element,
									A3($author$project$Components$Produits$Catalogue$Creation$rattachables, catalogue, elements, saisie.g1),
									valeur))
						}));
			case 6:
				var valeur = champ.a;
				return A2(
					$author$project$Components$Produits$Catalogue$Creation$produitRetenu,
					catalogue,
					A2(
						sans,
						$author$project$Components$Produits$Catalogue$Creation$ZoneRangement,
						_Utils_update(
							saisie,
							{
								dt: _List_Nil,
								cq: false,
								pN: $elm$core$Maybe$Nothing,
								fh: $elm$core$Maybe$Nothing,
								r3: $elm$core$List$head(
									A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.Aq;
											},
											A2(
												$elm$core$Basics$composeR,
												$author$project$Catalogue$Identifiants$classificationIdToString,
												$elm$core$Basics$eq(valeur))),
										saisie.r7))
							})));
			case 7:
				var id = champ.a;
				return A2(
					$author$project$Components$Produits$Catalogue$Creation$produitRetenu,
					catalogue,
					A2(
						sans,
						$author$project$Components$Produits$Catalogue$Creation$ZoneRangement,
						_Utils_update(
							saisie,
							{
								dt: _List_Nil,
								cq: false,
								fh: $elm$core$Maybe$Nothing,
								r3: A2(
									$elm$core$Maybe$map,
									function (typologie) {
										return _Utils_update(
											typologie,
											{
												jK: A2($author$project$Catalogue$Chemin$choisir, id, typologie.jK)
											});
									},
									saisie.r3)
							})));
			case 8:
				var valeur = champ.a;
				return A2(
					sans,
					$author$project$Components$Produits$Catalogue$Creation$ZoneType,
					_Utils_update(
						saisie,
						{
							fh: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.Aq;
								},
								A3(
									parmi,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.Aq;
										},
										$author$project$Catalogue$Identifiants$typeDeProduitIdToString),
									saisie.dt,
									valeur))
						}));
			case 9:
				var code = champ.a;
				var texte = champ.b;
				return A2(
					sans,
					$author$project$Components$Produits$Catalogue$Creation$ZoneNom,
					_Utils_update(
						saisie,
						{
							Dj: A3($author$project$Components$Shared$LibellesParLangue$Model$ecrire, code, texte, saisie.Dj)
						}));
			case 10:
				var texte = champ.a;
				return A2(
					sans,
					$author$project$Components$Produits$Catalogue$Creation$ZoneCode,
					_Utils_update(
						saisie,
						{vx: texte, cu: true}));
			case 11:
				return A2(
					sans,
					$author$project$Components$Produits$Catalogue$Creation$ZoneCode,
					_Utils_update(
						saisie,
						{
							vx: A2($elm$core$Maybe$withDefault, '', saisie.dz),
							cu: false
						}));
			case 12:
				var texte = champ.a;
				return A2(
					sans,
					$author$project$Components$Produits$Catalogue$Creation$ZoneEan,
					_Utils_update(
						saisie,
						{lI: texte}));
			case 13:
				var texte = champ.a;
				return A2(
					sans,
					$author$project$Components$Produits$Catalogue$Creation$ZoneMillesime,
					_Utils_update(
						saisie,
						{n8: texte}));
			case 14:
				var texte = champ.a;
				return A2(
					sans,
					$author$project$Components$Produits$Catalogue$Creation$ZoneVariante,
					_Utils_update(
						saisie,
						{sl: texte}));
			case 16:
				var geste = champ.a;
				return _Utils_update(
					saisie,
					{
						i8: A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$saisir, geste, saisie.i8)
					});
			default:
				var valeur = champ.a;
				return A2(
					sans,
					$author$project$Components$Produits$Catalogue$Creation$ZoneEtat,
					_Utils_update(
						saisie,
						{
							gt: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.vx;
								},
								A3(
									parmi,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.vx;
										},
										$author$project$Catalogue$Identifiants$etatCodeToString),
									catalogue.mj,
									valeur))
						}));
		}
	});
var $author$project$Components$Produits$Catalogue$Model$sansLesLues = function (liste) {
	return $elm$core$List$filter(
		function (c) {
			return !A2(
				$elm$core$List$any,
				function (lue) {
					return _Utils_eq(lue.Aq, c.Aq);
				},
				liste.hD);
		});
};
var $author$project$Components$Produits$Catalogue$Model$sansSelection = function (model) {
	return _Utils_update(
		model,
		{
			nW: $author$project$Components$Shared$Annuaire$Model$deselectionner(model.nW),
			q3: $elm$core$Dict$empty
		});
};
var $author$project$Components$Produits$Common$Effet$LireLeSchemaEffectif = F4(
	function (a, b, c, d) {
		return {$: 34, a: a, b: b, c: c, d: d};
	});
var $author$project$API$NavLinksDictionary$schemaEffectif = 'schema-effectif';
var $author$project$Components$Produits$Liens$versLeSchemaEffectif = F2(
	function (id, gabarits) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$API$NavLinksDictionary$variableUid,
						$author$project$Catalogue$Identifiants$typeDeProduitIdToString(id))
					])),
			A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$schemaEffectif, gabarits));
	});
var $author$project$Components$Produits$Catalogue$Update$schemaDemande = F3(
	function (catalogue, avant, apres) {
		var _v0 = A2($author$project$Components$Produits$Catalogue$Creation$schemaDemande, catalogue, apres);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var type_ = _v1.a;
			var valeurs = _v1.b;
			return _Utils_eq(
				A2($author$project$Components$Produits$Catalogue$Creation$schemaDemande, catalogue, avant),
				$elm$core$Maybe$Just(
					_Utils_Tuple2(type_, valeurs))) ? _List_Nil : A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (lien) {
						return _List_fromArray(
							[
								A4(
								$author$project$Components$Produits$Common$Effet$LireLeSchemaEffectif,
								lien,
								type_,
								valeurs,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.Aq;
									},
									apres.r3))
							]);
					},
					A2($author$project$Components$Produits$Liens$versLeSchemaEffectif, type_, catalogue.gF)));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Produits$Catalogue$Creation$schemaRetenu = F2(
	function (catalogue, saisie) {
		var _v0 = saisie.aN;
		if (!_v0.$) {
			var lu = _v0.a;
			return _Utils_eq(
				A2($author$project$Components$Produits$Catalogue$Creation$schemaDemande, catalogue, saisie),
				$elm$core$Maybe$Just(
					_Utils_Tuple2(lu.r0, lu.Ki))) ? saisie : _Utils_update(
				saisie,
				{aN: $elm$core$Maybe$Nothing});
		} else {
			return saisie;
		}
	});
var $author$project$Components$Produits$Catalogue$Model$selectionDuFiltreOfferte = function (model) {
	return $elm$core$List$length(model.kC.r7) === 1;
};
var $author$project$Components$Produits$Catalogue$Update$setTaille = F2(
	function (taille, demande) {
		return _Utils_update(
			demande,
			{Jm: taille});
	});
var $author$project$Components$Produits$Catalogue$Update$setTri = F2(
	function (code, demande) {
		return A2($elm$core$List$member, code, $author$project$Routes$Route$trisDesReferences) ? _Utils_update(
			demande,
			{EE: 1, rS: code}) : demande;
	});
var $author$project$Components$Produits$Catalogue$Update$surLeVolet = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (volet) {
				return _Utils_update(
					model,
					{im: volet});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Produits$Common$Effet$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.im));
	});
var $author$project$Components$Produits$Catalogue$Update$surLeVoletDesColonnes = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (volet) {
				return _Utils_update(
					model,
					{$9: volet});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Produits$Common$Effet$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.$9));
	});
var $author$project$Components$Produits$Catalogue$Model$adresseDeLaReference = function (id) {
	return $author$project$Routes$Route$toString(
		$author$project$Routes$Route$FicheReference(id));
};
var $author$project$Components$Produits$Catalogue$Model$synchroniserLaSelection = function (model) {
	var cartes = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.hD;
			},
			model.bh));
	var deLaPage = $elm$core$Dict$fromList(
		A2(
			$elm$core$List$map,
			function (carte) {
				return _Utils_Tuple2(
					$author$project$Components$Produits$Catalogue$Model$adresseDeLaReference(carte.Aq),
					_Utils_Tuple2(
						carte.Aq,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.Aq;
							},
							carte.r3)));
			},
			cartes));
	var gardee = function (id) {
		var _v0 = A2($elm$core$Dict$get, id, model.q3);
		if (!_v0.$) {
			var connue = _v0.a;
			return $elm$core$Maybe$Just(connue);
		} else {
			return A2($elm$core$Dict$get, id, deLaPage);
		}
	};
	return _Utils_update(
		model,
		{
			q3: $elm$core$Dict$fromList(
				A2(
					$elm$core$List$filterMap,
					function (id) {
						return A2(
							$elm$core$Maybe$map,
							$elm$core$Tuple$pair(id),
							gardee(id));
					},
					$elm$core$Set$toList(model.nW.vv)))
		});
};
var $author$project$Catalogue$Typologies$typologiesDeSaisie = F2(
	function (niveau, classifications) {
		return A2(
			$author$project$Catalogue$Typologies$typologiesDe,
			niveau,
			A2(
				$elm$core$List$filter,
				function (c) {
					return _Utils_eq(
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reactiverLaClassification, c.nQ),
						$elm$core$Maybe$Nothing);
				},
				classifications));
	});
var $author$project$Components$Shared$Annuaire$Update$GarderFiltresMasques = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Shared$Annuaire$Update$GarderVue = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Set$remove = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$remove, key, dict);
	});
var $author$project$Components$Shared$Annuaire$Model$cocher = F3(
	function (id, cochee, model) {
		return cochee ? _Utils_update(
			model,
			{
				vv: A2($elm$core$Set$insert, id, model.vv)
			}) : _Utils_update(
			model,
			{
				vv: A2($elm$core$Set$remove, id, model.vv),
				aw: 0
			});
	});
var $author$project$Components$Shared$Annuaire$Model$PageEntiere = 1;
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$Components$Shared$Annuaire$Model$selectionnerLaPage = F2(
	function (ids, model) {
		return _Utils_update(
			model,
			{
				vv: $elm$core$Set$fromList(ids),
				aw: 1
			});
	});
var $author$project$Components$Shared$Annuaire$Model$FiltreEntier = 2;
var $author$project$Components$Shared$Annuaire$Model$selectionnerLeFiltreEntier = function (model) {
	return _Utils_update(
		model,
		{aw: 2});
};
var $author$project$Components$Shared$Annuaire$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var id = msg.a;
				var cochee = msg.b;
				return _Utils_Tuple2(
					A3($author$project$Components$Shared$Annuaire$Model$cocher, id, cochee, model),
					_List_Nil);
			case 1:
				var ids = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Components$Shared$Annuaire$Model$selectionnerLaPage, ids, model),
					_List_Nil);
			case 2:
				return _Utils_Tuple2(
					$author$project$Components$Shared$Annuaire$Model$selectionnerLeFiltreEntier(model),
					_List_Nil);
			case 3:
				return _Utils_Tuple2(
					$author$project$Components$Shared$Annuaire$Model$deselectionner(model),
					_List_Nil);
			case 4:
				var vue = msg.a;
				return _Utils_eq(vue, model.io) ? _Utils_Tuple2(model, _List_Nil) : _Utils_Tuple2(
					_Utils_update(
						model,
						{io: vue}),
					_List_fromArray(
						[
							A2($author$project$Components$Shared$Annuaire$Update$GarderVue, model.dy, vue)
						]));
			case 6:
				var choisies = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{j1: choisies}),
					_List_Nil);
			default:
				var masques = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{mH: masques}),
					_List_fromArray(
						[
							A2($author$project$Components$Shared$Annuaire$Update$GarderFiltresMasques, model.dy, masques)
						]));
		}
	});
var $author$project$Components$Produits$Catalogue$Update$vider = F2(
	function (groupe, demande) {
		switch (groupe.$) {
			case 0:
				return _Utils_update(
					demande,
					{mj: _List_Nil});
			case 1:
				return _Utils_update(
					demande,
					{cU: _List_Nil});
			case 2:
				return _Utils_update(
					demande,
					{gG: _List_Nil});
			case 3:
				return _Utils_update(
					demande,
					{r7: _List_Nil});
			case 4:
				return _Utils_update(
					demande,
					{mu: _List_Nil});
			case 5:
				return _Utils_update(
					demande,
					{dt: _List_Nil});
			case 6:
				var cle = groupe.a;
				return _Utils_update(
					demande,
					{
						dw: A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$String$startsWith(cle + ':'),
								$elm$core$Basics$not),
							demande.dw)
					});
			default:
				var cle = groupe.a;
				return _Utils_update(
					demande,
					{
						pn: A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$String$startsWith(cle + ':'),
								$elm$core$Basics$not),
							demande.pn)
					});
		}
	});
var $author$project$Components$Produits$Catalogue$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var demande = msg.a;
				var liens = msg.b;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$catalogue, liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					if (_Utils_eq(
						model.np,
						$elm$core$Maybe$Just(lecture)) && ((!_Utils_eq(model.jB, $elm$core$Maybe$Nothing)) && (!_Utils_eq(model.kC, demande)))) {
						return $author$project$Components$Produits$Catalogue$Update$chercher(
							A2($author$project$Components$Produits$Catalogue$Model$memeFiltre, model.kC, demande) ? _Utils_update(
								model,
								{kC: demande}) : $author$project$Components$Produits$Catalogue$Model$sansSelection(
								_Utils_update(
									model,
									{kC: demande})));
					} else {
						var ouvert = A3(
							$author$project$Components$Produits$Catalogue$Model$ouvert,
							demande,
							$elm$core$Maybe$Just(lecture),
							model);
						return _Utils_Tuple2(
							_Utils_update(
								ouvert,
								{
									h$: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$structureDuCatalogue, liens)
								}),
							_List_fromArray(
								[
									$author$project$Components$Produits$Common$Effet$DemanderProcessUid,
									$author$project$Components$Produits$Common$Effet$Lire(lecture)
								]));
					}
				} else {
					return _Utils_Tuple2(
						A3($author$project$Components$Produits$Catalogue$Model$ouvert, demande, $elm$core$Maybe$Nothing, model),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				var recu = _Utils_update(
					model,
					{
						gl: false,
						l2: A2($author$project$Components$Produits$Common$Envoi$recevoir, octets, model.l2)
					});
				return model.gl ? $author$project$Components$Produits$Catalogue$Update$creer(recu) : _Utils_Tuple2(recu, _List_Nil);
			case 2:
				var reponse = msg.a;
				var _v2 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$catalogueDecoder, reponse);
				if (!_v2.$) {
					var catalogue = _v2.a;
					var lu = _Utils_update(
						model,
						{
							jB: $elm$core$Maybe$Just(catalogue),
							aV: $author$project$Components$Produits$Catalogue$Creation$elementsDe(catalogue)
						});
					return function (_v3) {
						var lue = _v3.a;
						var effets = _v3.b;
						return ((lue.f0 || lue.gg) && (!$author$project$Components$Shared$Drawer$Model$estOuvert(lue.kX))) ? A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							$author$project$Components$Produits$Catalogue$Update$ouvrirLaCreation(lue)) : _Utils_Tuple2(lue, effets);
					}(
						A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(
								_Utils_ap(
									$author$project$Components$Produits$Catalogue$Update$lireARanger(lu).b,
									_Utils_eq(model.r7, _List_Nil) ? $author$project$Components$Produits$Catalogue$Update$lectureDeLaStructure(model) : _List_Nil)),
							$author$project$Components$Produits$Catalogue$Update$chercher(lu)));
				} else {
					var refus = _v2.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 3:
				var numero = msg.a;
				var reponse = msg.b;
				if (!_Utils_eq(numero, model.DX)) {
					return _Utils_Tuple2(model, _List_Nil);
				} else {
					var _v4 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$listeDecoder, reponse);
					if (!_v4.$) {
						var liste = _v4.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									wo: A2($author$project$Components$Produits$Catalogue$Model$sansLesLues, liste, model.wo),
									bh: $elm$core$Maybe$Just(
										A2($author$project$Components$Produits$Catalogue$Model$avecLesCreees, model.wo, liste))
								}),
							_List_Nil);
					} else {
						var refus = _v4.a;
						return _Utils_Tuple2(
							model,
							(refus.ri === 401) ? _List_fromArray(
								[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
					}
				}
			case 4:
				var page = msg.a;
				return A2(
					$author$project$Components$Produits$Catalogue$Update$allerA,
					A2($author$project$Components$Produits$Catalogue$Update$setPage, page, model.kC),
					model);
			case 5:
				var taille = msg.a;
				return A2($elm$core$List$member, taille, $author$project$Routes$Route$taillesPermises) ? A2(
					$author$project$Components$Produits$Catalogue$Update$allerA,
					A2($author$project$Components$Produits$Catalogue$Update$setTaille, taille, model.kC),
					model) : _Utils_Tuple2(model, _List_Nil);
			case 26:
				return $author$project$Components$Produits$Catalogue$Update$relire(model);
			case 27:
				var frappe = msg.a;
				return _Utils_eq(frappe, model.gC) ? ((model.kC.EE !== 1) ? A2(
					$author$project$Components$Produits$Catalogue$Update$allerA,
					A2($author$project$Components$Produits$Catalogue$Update$setPage, 1, model.kC),
					model) : $author$project$Components$Produits$Catalogue$Update$chercher(model)) : _Utils_Tuple2(model, _List_Nil);
			case 7:
				var terme = msg.a;
				return _Utils_Tuple2(
					function (suivi) {
						return _Utils_update(
							suivi,
							{gC: model.gC + 1, h3: terme});
					}(
						_Utils_eq(terme, model.h3) ? model : $author$project$Components$Produits$Catalogue$Model$sansSelection(model)),
					_List_fromArray(
						[
							A2($author$project$Components$Produits$Common$Effet$AttendreAvantDeChercher, model.gC + 1, $author$project$Components$Produits$Catalogue$Update$delaiDeSaisieMs)
						]));
			case 8:
				var groupe = msg.a;
				var valeur = msg.b;
				return A2(
					$author$project$Components$Produits$Catalogue$Update$filtrer,
					function (demande) {
						return A3($author$project$Components$Produits$Catalogue$Update$bascule, groupe, valeur, demande);
					},
					model);
			case 9:
				var groupe = msg.a;
				return A2(
					$author$project$Components$Produits$Catalogue$Update$filtrer,
					$author$project$Components$Produits$Catalogue$Update$vider(groupe),
					model);
			case 10:
				var cle = msg.a;
				var borne = msg.b;
				var saisie = msg.c;
				return A2(
					$author$project$Components$Produits$Catalogue$Update$filtrer,
					A3($author$project$Components$Produits$Catalogue$Update$poserUneBorne, cle, borne, saisie),
					model);
			case 11:
				var code = msg.a;
				return A2(
					$author$project$Components$Produits$Catalogue$Update$filtrer,
					function (demande) {
						return _Utils_update(
							demande,
							{fU: code});
					},
					model);
			case 13:
				var _v5 = $author$project$Components$Produits$Catalogue$Model$archivageDeLaSelection(model);
				if (_v5.$ === 1) {
					var typologie = _v5.a;
					return _Utils_Tuple2(
						model,
						_List_fromArray(
							[
								$author$project$Components$Produits$Catalogue$Model$selectionDuFiltreEntier(model) ? A3(
								$author$project$Components$Produits$Common$Effet$ArchiverLesReferences,
								typologie,
								$author$project$Components$Produits$Catalogue$Model$recherche(model),
								A2($author$project$Components$Produits$Catalogue$Model$resumeDuFiltre, model, typologie)) : A2(
								$author$project$Components$Produits$Common$Effet$ArchiverLaSelection,
								typologie,
								$author$project$Components$Produits$Catalogue$Model$referencesCochees(model))
							]));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 12:
				var oui = msg.a;
				return A2(
					$author$project$Components$Produits$Catalogue$Update$filtrer,
					function (demande) {
						return _Utils_update(
							demande,
							{i2: oui});
					},
					model);
			case 14:
				return A2(
					$author$project$Components$Produits$Catalogue$Update$allerA,
					_Utils_update(
						$author$project$Components$Produits$Catalogue$Update$premiere,
						{Jm: model.kC.Jm, rS: model.kC.rS}),
					model);
			case 15:
				var code = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (effets) {
						return _Utils_ap(
							effets,
							_List_fromArray(
								[
									$author$project$Components$Produits$Common$Effet$PlacerFocus($author$project$Components$Produits$Catalogue$Model$idDuDeclencheurDuTri)
								]));
					},
					A2(
						$author$project$Components$Produits$Catalogue$Update$allerA,
						A2($author$project$Components$Produits$Catalogue$Update$setTri, code, model.kC),
						_Utils_update(
							model,
							{gY: false})));
			case 16:
				return model.gY ? _Utils_Tuple2(
					_Utils_update(
						model,
						{gY: false}),
					_List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$PlacerFocus($author$project$Components$Produits$Catalogue$Model$idDuDeclencheurDuTri)
						])) : _Utils_Tuple2(
					_Utils_update(
						model,
						{gY: true}),
					_List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$PlacerFocus(
							$author$project$Components$Produits$Catalogue$Model$idDeLOrdre(model.kC.rS))
						]));
			case 17:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gY: false}),
					_List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$PlacerFocus($author$project$Components$Produits$Catalogue$Model$idDuDeclencheurDuTri)
						]));
			case 18:
				return A2(
					$author$project$Components$Produits$Catalogue$Update$surLeVolet,
					$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Produits$Catalogue$Model$idDuDeclencheurDeFiltres),
					model);
			case 19:
				var geste = msg.a;
				return A2($author$project$Components$Produits$Catalogue$Update$surLeVolet, geste, model);
			case 20:
				return A2(
					$author$project$Components$Produits$Catalogue$Update$surLeVoletDesColonnes,
					$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Produits$Catalogue$Model$idDuDeclencheurDeColonnes),
					_Utils_update(
						model,
						{
							dA: $author$project$Components$Produits$Catalogue$Update$colonnesMontrees(model)
						}));
			case 21:
				var colonne = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dA: A2($author$project$Components$Produits$Catalogue$Model$basculer, colonne, model.dA)
						}),
					_List_Nil);
			case 22:
				var sens = msg.a;
				var colonne = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dA: A3($author$project$Components$Produits$Catalogue$Model$deplacer, sens, colonne, model.dA)
						}),
					_List_Nil);
			case 23:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dA: $author$project$Components$Produits$Catalogue$Model$colonnesParDefaut}),
					_List_Nil);
			case 24:
				var choix = _Utils_eq(model.dA, $author$project$Components$Produits$Catalogue$Model$colonnesParDefaut) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(model.dA);
				var _v6 = A2(
					$author$project$Components$Shared$Annuaire$Update$update,
					$author$project$Components$Shared$Annuaire$Update$ColonnesChoisies(choix),
					model.nW);
				var liste = _v6.a;
				return A2(
					$author$project$Components$Produits$Catalogue$Update$surLeVoletDesColonnes,
					$author$project$Components$Shared$Drawer$Update$Fermer,
					_Utils_update(
						model,
						{nW: liste}));
			case 25:
				var geste = msg.a;
				return A2($author$project$Components$Produits$Catalogue$Update$surLeVoletDesColonnes, geste, model);
			case 6:
				if (msg.a.$ === 2) {
					var _v7 = msg.a;
					return $author$project$Components$Produits$Catalogue$Model$selectionDuFiltreOfferte(model) ? A3(
						$elm$core$Tuple$mapBoth,
						function (liste) {
							return _Utils_update(
								model,
								{nW: liste});
						},
						$elm$core$List$concatMap($author$project$Components$Produits$Catalogue$Update$depuisLaListe),
						A2($author$project$Components$Shared$Annuaire$Update$update, $author$project$Components$Shared$Annuaire$Update$FiltreEntierDemande, model.nW)) : _Utils_Tuple2(model, _List_Nil);
				} else {
					var geste = msg.a;
					return A3(
						$elm$core$Tuple$mapBoth,
						function (liste) {
							return $author$project$Components$Produits$Catalogue$Model$synchroniserLaSelection(
								_Utils_update(
									model,
									{nW: liste}));
						},
						$elm$core$List$concatMap($author$project$Components$Produits$Catalogue$Update$depuisLaListe),
						A2($author$project$Components$Shared$Annuaire$Update$update, geste, model.nW));
				}
			case 28:
				var geste = msg.a;
				return A2($author$project$Components$Produits$Common$Envoi$retientLeDrawer, model.l2, geste) ? _Utils_Tuple2(model, _List_Nil) : A2(
					$author$project$Components$Produits$Catalogue$Update$revenirALaListeSiFermee,
					model,
					A2($author$project$Components$Produits$Catalogue$Update$versLeDrawer, geste, model));
			case 30:
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$AllerA($author$project$Routes$Route$adresseNouvelleReference)
						]));
			case 31:
				return $author$project$Components$Produits$Catalogue$Update$ouvrirLaCreation(
					_Utils_update(
						model,
						{f0: true}));
			case 32:
				return model.gg ? _Utils_Tuple2(model, _List_Nil) : $author$project$Components$Produits$Catalogue$Update$ouvrirLaCreation(
					_Utils_update(
						model,
						{gg: true}));
			case 29:
				return $author$project$Components$Produits$Catalogue$Update$ouvrirLaCreation(model);
			case 33:
				var champ = msg.a;
				var _v8 = model.jB;
				if (!_v8.$) {
					var catalogue = _v8.a;
					var saisie = A2(
						$author$project$Components$Produits$Catalogue$Creation$schemaRetenu,
						catalogue,
						A4($author$project$Components$Produits$Catalogue$Creation$saisir, catalogue, model.aV, champ, model.hP));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{hP: saisie}),
						_Utils_eq(model.hA, $elm$core$Maybe$Nothing) ? _Utils_ap(
							A3($author$project$Components$Produits$Catalogue$Update$categoriesDemandees, catalogue, champ, saisie),
							_Utils_ap(
								A3($author$project$Components$Produits$Catalogue$Update$schemaDemande, catalogue, model.hP, saisie),
								A3($author$project$Components$Produits$Catalogue$Update$codeDemande, catalogue, model.hP, saisie))) : _List_Nil);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 36:
				var reponse = msg.a;
				var _v9 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$classificationsDecoder, reponse);
				if (!_v9.$) {
					var classifications = _v9.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bs: $author$project$Catalogue$Typologies$archivables(classifications),
								oo: A2(
									$elm$core$Result$withDefault,
									model.oo,
									A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$naturesDecoder, reponse)),
								ha: _List_Nil,
								hP: A2(
									$author$project$Components$Produits$Catalogue$Creation$avecLesTypologies,
									A2(
										$author$project$Catalogue$Typologies$typologiesDeSaisie,
										$author$project$Components$Produits$Catalogue$Update$libelleDeLEtage(model),
										classifications),
									model.hP),
								r7: A2(
									$author$project$Catalogue$Typologies$typologiesDe,
									$author$project$Components$Produits$Catalogue$Update$libelleDeLEtage(model),
									classifications)
							}),
						A2(
							$author$project$Components$Produits$Catalogue$Update$compterLesARanger,
							model,
							A2(
								$author$project$Catalogue$Typologies$typologiesDe,
								$author$project$Components$Produits$Catalogue$Update$libelleDeLEtage(model),
								classifications)));
				} else {
					var refus = _v9.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 37:
				var valeurs = msg.a;
				var reponse = msg.b;
				var _v10 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$categoriesProposeesDecoder, reponse);
				if (!_v10.$) {
					var categories = _v10.a;
					return _Utils_eq(
						$author$project$Components$Produits$Catalogue$Creation$valeursDuChemin(model.hP),
						$elm$core$Maybe$Just(valeurs)) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{
								hP: A2($author$project$Components$Produits$Catalogue$Creation$avecLesCategories, categories, model.hP)
							}),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (catalogue) {
									return A3($author$project$Components$Produits$Catalogue$Update$produitsDemandes, catalogue, valeurs, categories);
								},
								model.jB))) : _Utils_Tuple2(model, _List_Nil);
				} else {
					var refus = _v10.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 38:
				var type_ = msg.a;
				var valeurs = msg.b;
				var reponse = msg.c;
				var _v11 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$produitsProposesDecoder, reponse);
				if (!_v11.$) {
					var produits = _v11.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								hP: A4($author$project$Components$Produits$Catalogue$Creation$avecLesProduitsProposes, type_, valeurs, produits, model.hP)
							}),
						_List_Nil);
				} else {
					var refus = _v11.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 39:
				var type_ = msg.a;
				var valeurs = msg.b;
				var reponse = msg.c;
				var _v12 = _Utils_Tuple2(
					model.jB,
					A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$schemaEffectifDecoder, reponse));
				if (_v12.b.$ === 1) {
					var refus = _v12.b.a;
					var _v13 = $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$duRefus(reponse);
					switch (_v13.$) {
						case 69:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										hP: A2($author$project$Components$Produits$Catalogue$Update$refusSousLeRangement, $author$project$I18n$Textes$produitsReferencesRefusTypologieAChoisir, model.hP)
									}),
								_List_Nil);
						case 70:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										hP: A2($author$project$Components$Produits$Catalogue$Update$refusSousLeRangement, $author$project$I18n$Textes$produitsReferencesRefusTypeHorsDeLaTypologie, model.hP)
									}),
								_List_Nil);
						default:
							return _Utils_Tuple2(
								model,
								(refus.ri === 401) ? _List_fromArray(
									[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
					}
				} else {
					if (!_v12.a.$) {
						var catalogue = _v12.a.a;
						var lu = _v12.b.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									hP: A5($author$project$Components$Produits$Catalogue$Creation$avecLeSchema, catalogue, type_, valeurs, lu, model.hP)
								}),
							_List_Nil);
					} else {
						var _v14 = _v12.a;
						return _Utils_Tuple2(model, _List_Nil);
					}
				}
			case 40:
				var type_ = msg.a;
				var valeurs = msg.b;
				var attributs = msg.c;
				var reponse = msg.d;
				var _v15 = _Utils_Tuple2(
					model.jB,
					A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$codeProposeDecoder, reponse));
				if (_v15.b.$ === 1) {
					var refus = _v15.b.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				} else {
					if (!_v15.a.$) {
						var catalogue = _v15.a.a;
						var propose = _v15.b.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									hP: A4(
										$author$project$Components$Produits$Catalogue$Creation$avecLeCodePropose,
										catalogue,
										_Utils_Tuple3(type_, valeurs, attributs),
										propose,
										model.hP)
								}),
							_List_Nil);
					} else {
						var _v16 = _v15.a;
						return _Utils_Tuple2(model, _List_Nil);
					}
				}
			case 41:
				var typologie = msg.a;
				return $author$project$Components$Produits$Catalogue$Update$lireARanger(
					_Utils_update(
						model,
						{
							iz: $elm$core$Maybe$Just(
								{n3: $elm$core$Maybe$Nothing, EE: 1, r3: typologie})
						}));
			case 42:
				var reponse = msg.a;
				var _v17 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$pageARangerDecoder, reponse);
				if (!_v17.$) {
					var lues = _v17.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iz: A2(
									$elm$core$Maybe$map,
									function (aRanger) {
										return _Utils_update(
											aRanger,
											{
												n3: $elm$core$Maybe$Just(lues)
											});
									},
									model.iz)
							}),
						_List_Nil);
				} else {
					var refus = _v17.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 43:
				var typologie = msg.a;
				var reponse = msg.b;
				var _v18 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$pageARangerDecoder, reponse);
				if (!_v18.$) {
					var lues = _v18.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ha: A2(
									$elm$core$List$cons,
									_Utils_Tuple2(typologie, lues.JE),
									A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$Tuple$first,
											$elm$core$Basics$neq(typologie)),
										model.ha))
							}),
						_List_Nil);
				} else {
					var refus = _v18.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 44:
				var id = msg.a;
				var _v19 = model.iz;
				if (!_v19.$) {
					var aRanger = _v19.a;
					var _v20 = _Utils_Tuple2(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(id)),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.hD;
									},
									aRanger.n3))),
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(aRanger.r3)),
							model.r7));
					if (_v20.a.b && _v20.b.b) {
						var _v21 = _v20.a;
						var reference = _v21.a;
						var _v22 = _v20.b;
						var typologie = _v22.a;
						return A2(
							$author$project$Components$Produits$Catalogue$Update$versLeDrawer,
							$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Produits$Catalogue$Model$idDuRangement),
							_Utils_update(
								model,
								{
									gl: false,
									hA: $elm$core$Maybe$Just(reference),
									hP: A2($author$project$Components$Produits$Catalogue$Creation$pourRanger, typologie, reference.fh)
								}));
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 45:
				return $author$project$Components$Produits$Catalogue$Update$ranger(model);
			case 46:
				var geste = msg.a;
				return ($author$project$Components$Produits$Common$Envoi$enCours(model.l2) && A2(
					$elm$core$List$member,
					geste,
					_List_fromArray(
						[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$SortieDemandee, $author$project$Components$Shared$Drawer$Update$AbandonConfirme]))) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Produits$Catalogue$Update$versLeDrawerDuLot, geste, model);
			case 47:
				return $author$project$Components$Produits$Catalogue$Update$ouvrirLeLot(model);
			case 48:
				var cle = msg.a;
				return function (_v23) {
					var modele = _v23.a;
					return _Utils_Tuple2(
						modele,
						A2($author$project$Components$Produits$Catalogue$Update$lireLApercuDuLot, cle, modele));
				}(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								n0: A2(
									$elm$core$Maybe$map,
									$author$project$Components$Produits$Catalogue$Lot$champChoisi(cle),
									model.n0)
							}),
						_List_Nil));
			case 49:
				var voulu = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							n0: A2(
								$elm$core$Maybe$map,
								$author$project$Components$Produits$Catalogue$Lot$geste(voulu),
								model.n0)
						}),
					_List_Nil);
			case 50:
				var cle = msg.a;
				var reponse = msg.b;
				var _v24 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Catalogue$Lot$apercuDecoder, reponse);
				if (!_v24.$) {
					var apercu = _v24.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								n0: A2(
									$elm$core$Maybe$map,
									A2($author$project$Components$Produits$Catalogue$Lot$apercuLu, cle, apercu),
									model.n0)
							}),
						_List_Nil);
				} else {
					var refus = _v24.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								n0: A2(
									$elm$core$Maybe$map,
									$author$project$Components$Produits$Catalogue$Lot$apercuIllisible(cle),
									model.n0)
							}),
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 51:
				return $author$project$Components$Produits$Catalogue$Update$appliquerLeLot(model);
			case 34:
				return $author$project$Components$Produits$Catalogue$Update$creer(model);
			default:
				var reponse = msg.a;
				var _v25 = A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, model.l2);
				if (!_v25.$) {
					var _v26 = _v25.a;
					var envoi = _v26.a;
					var issue = _v26.b;
					var effets = _v26.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Produits$Catalogue$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Main$Update$versLeCatalogue = F3(
	function (i18n, msg, model) {
		var _v0 = A2(
			$author$project$Components$Produits$Catalogue$Update$update,
			msg,
			A2(
				$author$project$Referentiel$Normes$poser,
				model.hd,
				$author$project$Components$Produits$Catalogue$Model$ouvrir(model.jB)));
		var catalogue = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLesElements, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			A3($author$project$Main$Update$depuisLesElements, i18n, 8, 13),
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						jB: $author$project$Components$Produits$Catalogue$Model$envelopper(catalogue),
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Produits$Catalogue$Update$popMessages(msg),
							gardes)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$ouvrirLeFormulaireDeReference = F3(
	function (i18n, etape, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		var _v1 = _Utils_Tuple2(
			etape,
			$author$project$Main$Update$liensDeLaRacine(model));
		if ((_v1.a === 4) && (!_v1.b.$)) {
			var _v2 = _v1.a;
			var liens = _v1.b.a;
			var _v3 = A3(
				$author$project$Main$Update$versLeCatalogue,
				i18n,
				A2($author$project$Components$Produits$Catalogue$Update$Ouverte, $author$project$Routes$Route$premiereListeDeReferences, liens.h0),
				model);
			var ouvert = _v3.a;
			var deLOuverture = _v3.b;
			var _v4 = A3($author$project$Main$Update$versLeCatalogue, i18n, $author$project$Components$Produits$Catalogue$Update$FormulaireEmbarque, ouvert);
			var formulaire = _v4.a;
			var deLaPage = _v4.b;
			return _Utils_Tuple2(
				formulaire,
				_Utils_ap(
					effets,
					_Utils_ap(deLOuverture, deLaPage)));
		} else {
			return _Utils_Tuple2(model, effets);
		}
	});
var $author$project$Components$Referentiel$Types$Update$TypeDeLAdresse = function (a) {
	return {$: 29, a: a};
};
var $author$project$Main$Update$AnnuaireDesTypesParametres = 0;
var $author$project$Main$Model$PourLesTypesDePartiesPrenantes = 29;
var $author$project$Main$Update$AttendreAvantDeRelireLesTypes = F2(
	function (a, b) {
		return {$: 200, a: a, b: b};
	});
var $author$project$Main$Update$EnvoyerAuType = F2(
	function (a, b) {
		return {$: 279, a: a, b: b};
	});
var $author$project$Main$Update$EnvoyerUnNouveauChampDuParcours = function (a) {
	return {$: 195, a: a};
};
var $author$project$Main$Update$EnvoyerUnNouveauChampDuTypeDePartiePrenante = function (a) {
	return {$: 123, a: a};
};
var $author$project$Main$Update$FicheDUnTypeParametre = 1;
var $author$project$Main$Update$LireLApercuDeLaRestrictionDuParcours = function (a) {
	return {$: 199, a: a};
};
var $author$project$Main$Update$LireLApercuDuTypeDuParcours = function (a) {
	return {$: 196, a: a};
};
var $author$project$Main$Update$LireLOrdreDesBlocsDuParcours = function (a) {
	return {$: 198, a: a};
};
var $author$project$Main$Update$LireLaBibliothequeDuParcours = function (a) {
	return {$: 191, a: a};
};
var $author$project$Main$Update$LireLaBibliothequeDuTypeDePartiePrenante = function (a) {
	return {$: 120, a: a};
};
var $author$project$Main$Update$LireLaListeDuChampDuParcours = function (a) {
	return {$: 197, a: a};
};
var $author$project$Main$Update$LireLeTypeDuParcours = function (a) {
	return {$: 188, a: a};
};
var $author$project$Main$Update$LireLeTypeRegleDuParcours = function (a) {
	return {$: 189, a: a};
};
var $author$project$Main$Update$LireLesCollectionsDuParcours = function (a) {
	return {$: 192, a: a};
};
var $author$project$Main$Update$LireLesCollectionsDuTypeDePartiePrenante = function (a) {
	return {$: 121, a: a};
};
var $author$project$Main$Update$LireLesListesDuNouveauChampDuParcours = function (a) {
	return {$: 194, a: a};
};
var $author$project$Main$Update$LireLesListesDuNouveauChampDuTypeDePartiePrenante = function (a) {
	return {$: 122, a: a};
};
var $author$project$Main$Update$LireLesListesDuParcours = function (a) {
	return {$: 193, a: a};
};
var $author$project$Main$Update$LireLesTypesParametres = F2(
	function (a, b) {
		return {$: 172, a: a, b: b};
	});
var $author$project$Main$Update$LireLesVersionsDuParcours = function (a) {
	return {$: 190, a: a};
};
var $author$project$Main$Update$ListeDePrixDUnTypeParametre = 5;
var $author$project$Main$Update$OffresDuParcours = 3;
var $author$project$Main$Update$OffresDuTypeParametre = 2;
var $author$project$Main$Update$PerimetresDuParcours = 4;
var $author$project$Main$Update$depuisLesTypes = F4(
	function (ecran, demandeur, effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[demandeur]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 1:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLesTypesParametres(ecran))));
			case 2:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLeTypeDuParcours)));
			case 3:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLeTypeRegleDuParcours)));
			case 4:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesVersionsDuParcours)));
			case 9:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							(ecran === 1) ? $author$project$Main$Update$LireLaBibliothequeDuTypeDePartiePrenante : $author$project$Main$Update$LireLaBibliothequeDuParcours)));
			case 10:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							(ecran === 1) ? $author$project$Main$Update$LireLesCollectionsDuTypeDePartiePrenante : $author$project$Main$Update$LireLesCollectionsDuParcours)));
			case 12:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							(ecran === 1) ? $author$project$Main$Update$LireLesListesDuNouveauChampDuTypeDePartiePrenante : $author$project$Main$Update$LireLesListesDuNouveauChampDuParcours)));
			case 13:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return ((ecran === 1) ? $author$project$Main$Update$EnvoyerUnNouveauChampDuTypeDePartiePrenante : $author$project$Main$Update$EnvoyerUnNouveauChampDuParcours)(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 11:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesListesDuParcours)));
			case 6:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLaListeDuChampDuParcours)));
			case 7:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLOrdreDesBlocsDuParcours)));
			case 8:
				var lien = effet.a;
				var type_ = effet.b;
				var champ = effet.c;
				var valeurs = effet.d;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$LireLApercuDeLaRestrictionDuParcours(
									{
										uN: champ,
										gM: vers.gM,
										nB: vers.nB,
										r0: $author$project$Components$Referentiel$Identifiants$typeUidToString(type_),
										Ki: valeurs
									});
							})));
			case 5:
				var lien = effet.a;
				var type_ = effet.b;
				var champ = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$LireLApercuDuTypeDuParcours(
									{
										uN: champ,
										gM: vers.gM,
										nB: vers.nB,
										r0: $author$project$Components$Referentiel$Identifiants$typeUidToString(type_)
									});
							})));
			case 14:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLesTypesParametres(
								(!ecran) ? 3 : 2))));
			case 15:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLesTypesParametres(4))));
			case 16:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLesTypesParametres(5))));
			case 17:
				var delaiMs = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								A2($author$project$Main$Update$AttendreAvantDeRelireLesTypes, ecran, delaiMs)
							])));
			case 18:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return A2(
									$author$project$Main$Update$EnvoyerAuType,
									ecran,
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 19:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Referentiel$Types$API$QueryAPIModel$Annuaire = F3(
	function (types, archives, liens) {
		return {i$: archives, nQ: liens, ib: types};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$TypeParametreAPIView = F9(
	function (uid, archetype, libelles, icone, couleur, archive, rolesOuverts, liens, gabarits) {
		return {fA: archetype, tE: archive, kf: couleur, gF: gabarits, aC: icone, R: libelles, nQ: liens, Id: rolesOuverts, r8: uid};
	});
var $author$project$Components$Referentiel$Archetype$Client = 2;
var $author$project$Components$Referentiel$Archetype$Collaborateur = 3;
var $author$project$Components$Referentiel$Archetype$Concurrent = 8;
var $author$project$Components$Referentiel$Archetype$Fournisseur = 4;
var $author$project$Components$Referentiel$Archetype$Partenaire = 5;
var $author$project$Components$Referentiel$Archetype$Prescripteur = 6;
var $author$project$Components$Referentiel$Archetype$Prospect = 1;
var $author$project$Components$Referentiel$Archetype$RelationPresse = 7;
var $author$project$Components$Referentiel$Archetype$Suspect = 0;
var $author$project$Components$Referentiel$Archetype$tous = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8]);
var $author$project$Components$Referentiel$Archetype$fromCode = function (lu) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (archetype) {
				return _Utils_eq(
					$author$project$Components$Referentiel$Archetype$code(archetype),
					lu);
			},
			$author$project$Components$Referentiel$Archetype$tous));
};
var $author$project$Components$Referentiel$Archetype$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (lu) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail(lu),
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Decode$succeed,
				$author$project$Components$Referentiel$Archetype$fromCode(lu)));
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$LibellesAPIView = F2(
	function (fr, en) {
		return {yg: en, zX: fr};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$libellesDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'en',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'fr',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$LibellesAPIView)));
var $author$project$Components$Referentiel$Identifiants$typeUidDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$typeParametreDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'_links',
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.gF;
		},
		$author$project$API$Liens$decoder),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'_links',
		A2(
			$elm$json$Json$Decode$map,
			function ($) {
				return $.h0;
			},
			$author$project$API$Liens$decoder),
		_List_Nil,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'rolesOuverts',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'archive',
				$elm$json$Json$Decode$bool,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'couleur',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'icone',
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'libelles',
							$author$project$Components$Referentiel$Common$API$QueryAPIModel$libellesDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'archetype',
								$author$project$Components$Referentiel$Archetype$decoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'uid',
									$author$project$Components$Referentiel$Identifiants$typeUidDecoder,
									$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$TypeParametreAPIView))))))))));
var $author$project$Components$Referentiel$Types$API$QueryAPIModel$annuaireDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'archives',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'types',
			$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$QueryAPIModel$typeParametreDecoder),
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Types$API$QueryAPIModel$Annuaire))));
var $author$project$Components$Shared$EditeurDeSchema$Resserrage$Resserrage = F2(
	function (nonConformes, auMoins) {
		return {tW: auMoins, oF: nonConformes};
	});
var $author$project$Components$Shared$EditeurDeSchema$Resserrage$decoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Shared$EditeurDeSchema$Resserrage$Resserrage,
	A2($elm$json$Json$Decode$field, 'nonConformes', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'auMoins', $elm$json$Json$Decode$bool));
var $author$project$Components$Referentiel$Types$Update$popMessages = function (msg) {
	switch (msg.$) {
		case 1:
			var reponse = msg.a;
			var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Types$API$QueryAPIModel$annuaireDecoder, reponse);
			if (_v1.$ === 1) {
				var refus = _v1.a;
				return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Components$Shared$Messages$Model$duRefus(refus));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 63:
			var reponse = msg.a;
			var _v2 = A2($author$project$API$Reponse$lire, $author$project$Components$Shared$EditeurDeSchema$Resserrage$decoder, reponse);
			if (_v2.$ === 1) {
				var refus = _v2.a;
				return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Components$Shared$Messages$Model$duRefus(refus));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 4:
			var octets = msg.a;
			return _Utils_eq(
				$author$project$API$ProcessUid$depuisOctets(octets),
				$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
				{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Main$Update$requeteSurLesTypes = function (effet) {
	switch (effet.$) {
		case 18:
			return true;
		case 1:
			return true;
		case 2:
			return true;
		case 3:
			return true;
		case 4:
			return true;
		case 5:
			return true;
		case 9:
			return true;
		case 11:
			return true;
		case 6:
			return true;
		case 7:
			return true;
		case 8:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Shared$EditeurDeSchema$View$AffichageDemande = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Referentiel$Common$EffetDeType$DemanderProcessUid = {$: 0};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$ElargirLaPorteeDUneListe = F2(
	function (a, b) {
		return {$: 21, a: a, b: b};
	});
var $author$project$Components$Referentiel$Common$ChoixDUnPerimetre$Illisible = {$: 2};
var $author$project$Components$Referentiel$Common$Offres$Illisible = {$: 2};
var $author$project$Components$Referentiel$Common$EffetDeType$Lire = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Common$EffetDeType$LireLesPerimetres = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Referentiel$Common$ChoixDUnPerimetre$Lue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Common$Offres$Lue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$View$MasquageDemande = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Referentiel$Common$EffetDeType$Reconnecter = {$: 20};
var $author$project$Components$Referentiel$Common$EffetDeType$LireLaBibliotheque = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Referentiel$Common$EffetDeType$LireLesCollectionsDeChamps = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Referentiel$Types$Update$avecLesInformations = F2(
	function (changer, model) {
		return _Utils_update(
			model,
			{
				AM: changer(model.AM)
			});
	});
var $author$project$Components$Referentiel$Types$Update$demanderLeNouveauChamp = function (model) {
	var _v0 = model.AM.nC;
	if (!_v0.$) {
		var lien = _v0.a;
		return _Utils_Tuple2(
			A2(
				$author$project$Components$Referentiel$Types$Update$avecLesInformations,
				function (etat) {
					return _Utils_update(
						etat,
						{oR: true});
				},
				model),
			A2(
				$elm$core$List$cons,
				$author$project$Components$Referentiel$Common$EffetDeType$LireLaBibliotheque(lien),
				function () {
					var _v1 = _Utils_Tuple2(model.AM.jZ, model.AM.nG);
					if ((_v1.a.$ === 1) && (!_v1.b.$)) {
						var _v2 = _v1.a;
						var lienDesCollections = _v1.b.a;
						return _List_fromArray(
							[
								$author$project$Components$Referentiel$Common$EffetDeType$LireLesCollectionsDeChamps(lienDesCollections)
							]);
					} else {
						return _List_Nil;
					}
				}()));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Types$Model$rangDeLArchetype = function (archetype) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$List$length($author$project$Components$Referentiel$Archetype$tous),
		A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$first,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var rangee = _v0.b;
						return _Utils_eq(rangee, archetype);
					},
					A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, $author$project$Components$Referentiel$Archetype$tous)))));
};
var $author$project$Components$Referentiel$Types$Model$types = function (model) {
	return A2(
		$elm$core$List$sortBy,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.fA;
			},
			$author$project$Components$Referentiel$Types$Model$rangDeLArchetype),
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ib;
				},
				model.aS)));
};
var $author$project$Components$Referentiel$Types$Model$typeRegle = function (model) {
	var actifs = A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeL,
			$elm$core$Basics$not,
			function ($) {
				return $.tE;
			}),
		$author$project$Components$Referentiel$Types$Model$types(model));
	var premier = function (garder) {
		return $elm$core$List$head(
			A2($elm$core$List$filter, garder, actifs));
	};
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		function (uid) {
			return premier(
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.r8;
					},
					$elm$core$Basics$eq(uid)));
		},
		model.vd);
	if (!_v0.$) {
		var choisi = _v0.a;
		return $elm$core$Maybe$Just(choisi);
	} else {
		var _v1 = premier(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.fA;
				},
				$elm$core$Basics$eq(4)));
		if (!_v1.$) {
			var fournisseur = _v1.a;
			return $elm$core$Maybe$Just(fournisseur);
		} else {
			return $elm$core$List$head(actifs);
		}
	}
};
var $author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle = function (model) {
	var _v0 = _Utils_Tuple2(
		$author$project$Components$Referentiel$Types$Model$typeRegle(model),
		model.gv);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var regle = _v0.a.a;
		var fiche = _v0.b.a;
		return _Utils_eq(fiche.r0.r8, regle.r8) ? $elm$core$Maybe$Just(fiche) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$API$NavLinksDictionary$creerEtRattacherUneDefinition = 'creer-et-rattacher-une-definition';
var $author$project$Components$Referentiel$Types$Model$lienDeCreationDUnChamp = function (fiche) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerEtRattacherUneDefinition, fiche.r0.nQ);
};
var $author$project$Components$Referentiel$Types$Update$offreLeNouveauChamp = function (model) {
	var _v0 = $author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model);
	if (!_v0.$) {
		var fiche = _v0.a;
		return (!_Utils_eq(
			$author$project$Components$Referentiel$Types$Model$lienDeCreationDUnChamp(fiche),
			$elm$core$Maybe$Nothing)) && (!_Utils_eq(model.AM.nC, $elm$core$Maybe$Nothing));
	} else {
		return false;
	}
};
var $author$project$Components$Referentiel$Common$EffetDeType$LireLesListes = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Referentiel$Types$Model$idDeLAjoutDUneInformation = 'informations-ajouter';
var $author$project$Components$Referentiel$Types$Model$lienDesInformations = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.r0;
			},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$faireEvoluerLeSchema))),
		$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model));
};
var $author$project$Components$Shared$EditeurDeSchema$Model$ajoutPour = function (fourni) {
	var vide = $author$project$Components$Shared$EditeurDeSchema$Model$ajout(fourni.Ba);
	return _Utils_update(
		vide,
		{xE: fourni.xE, hd: fourni.hd});
};
var $author$project$Components$Shared$EditeurDeSchema$Model$enCours = function (saisie) {
	return !_Utils_eq(saisie.zT, saisie.cx);
};
var $author$project$Components$Shared$EditeurDeSchema$Conduite$versLeDrawer = F3(
	function (reglage, geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{kX: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var vers = _v0;
					return reglage.FO(vers);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Shared$EditeurDeSchema$Model$enCours(model.hP)
				},
				geste,
				model.kX));
	});
var $author$project$Components$Shared$EditeurDeSchema$Conduite$ouvrir = F4(
	function (reglage, declencheur, saisie, model) {
		var drawer = model.kX;
		return A3(
			$author$project$Components$Shared$EditeurDeSchema$Conduite$versLeDrawer,
			reglage,
			$author$project$Components$Shared$Drawer$Update$Ouvrir(declencheur),
			_Utils_update(
				model,
				{
					kX: _Utils_update(
						drawer,
						{
							Dj: reglage.Do(
								!_Utils_eq(saisie.lZ, $elm$core$Maybe$Nothing))
						}),
					hP: saisie
				}));
	});
var $author$project$Components$Shared$EditeurDeSchema$Conduite$ouvrirLAjout = F3(
	function (reglage, declencheur, model) {
		return _Utils_eq(reglage.yW, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A4(
			$author$project$Components$Shared$EditeurDeSchema$Conduite$ouvrir,
			reglage,
			declencheur,
			A2(
				$author$project$Components$Shared$EditeurDeSchema$Model$dansLaPortee,
				reglage.F$,
				$author$project$Components$Shared$EditeurDeSchema$Model$ajoutPour(
					{xE: reglage.xE, Ba: reglage.Ba, hd: reglage.hd})),
			model);
	});
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$AfficherUnChampDUnType = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$FaireEvoluerLeSchemaDUnType = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$MasquerUnChampDUnType = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$OrdonnerLesChampsDUnType = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$Referentiel$Types$Update$commandeDuChamp = F4(
	function (rel, commande, model, cle) {
		return A2(
			$elm$core$Maybe$andThen,
			function (fiche) {
				return A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(
						A2(commande, fiche.r0.r8, cle)),
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.nQ;
							},
							$author$project$API$Liens$trouver(rel)),
						A2(
							$elm$core$Maybe$andThen,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.dw;
								},
								A2(
									$elm$core$Basics$composeR,
									$elm$core$List$filter(
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.uN;
											},
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.dy;
												},
												$elm$core$Basics$eq(cle)))),
									$elm$core$List$head)),
							fiche.aN)));
			},
			$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model));
	});
var $author$project$Components$Referentiel$Types$Model$ficheDesInformations = function (model) {
	var _v0 = _Utils_Tuple3(
		model.AM.wC,
		$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model),
		$author$project$Components$Referentiel$Types$Model$lienDesInformations(model));
	if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
		var lie = _v0.a.a;
		var fiche = _v0.b.a;
		return _Utils_eq(fiche.r0.r8, lie) ? $elm$core$Maybe$Just(fiche) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Types$Model$lienDOrdre = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.r0;
			},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$ordonnerLesChamps))),
		$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model));
};
var $author$project$Components$Referentiel$Types$Informations$parCle = function (cle) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$filter(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.uN;
				},
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.dy;
					},
					$elm$core$Basics$eq(cle)))),
		$elm$core$List$head);
};
var $author$project$Components$Referentiel$Common$EffetDeType$Envoyer = F3(
	function (a, b, c) {
		return {$: 18, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$AutreRefus = {$: 27};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$EcritureConcurrente = {$: 6};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$Introuvable = {$: 5};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$LibelleRefuse = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$Anglais = 1;
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$Francais = 0;
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$langueDuCode = function (code) {
	switch (code) {
		case 'fr':
			return $elm$core$Maybe$Just(0);
		case 'en':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$champFautif = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$concat,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$filterMap($author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$langueDuCode),
			$elm$core$List$head)),
	A2(
		$elm$json$Json$Decode$field,
		'errors',
		$elm$json$Json$Decode$list(
			A2(
				$elm$json$Json$Decode$field,
				'path',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string)))));
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$AucunResultatActif = {$: 8};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$AucunStatutActif = {$: 7};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$ChampDejaDansLaBibliotheque = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$ChampDontDependent = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$ChampHorsPortee = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$ChampInconnu = {$: 20};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$CleDejaUtilisee = {$: 15};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$DefinitionDUnChampPartage = function (a) {
	return {$: 25, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$EvolutionNonAdditive = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$LibelleDejaUtilise = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$ListeHorsPortee = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$OffreIntrouvable = {$: 22};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$OrdreInvalide = {$: 21};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$PerimetreAFicheVisee = {$: 3};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$PerimetreArchive = {$: 2};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$ResultatEnDouble = {$: 10};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$ResultatInconnu = {$: 12};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$ResultatSystemeReserve = {$: 14};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$SchemaInvalide = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$StatutEnDouble = {$: 9};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$StatutInconnu = {$: 11};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$StatutInitialRetire = {$: 13};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$TypeDejaArchive = {$: 1};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$ValeursEnDouble = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$langue = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$langueDuCode,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
			$elm$core$Maybe$withDefault(
				$elm$json$Json$Decode$fail('langue')))),
	$elm$json$Json$Decode$string);
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$lienDeLIssue = A4(
	$elm$json$Json$Decode$map3,
	$author$project$API$Liens$Lien,
	A2($elm$json$Json$Decode$field, 'rel', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'href', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'verbe', $elm$json$Json$Decode$string));
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$duDomaine = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'LibelleDejaUtilise',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$LibelleDejaUtilise,
				A2($elm$json$Json$Decode$field, 'langue', $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$langue))),
			A2(
			$elm$json$Json$Decode$field,
			'TypeEstArchive',
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$TypeDejaArchive)),
			A2(
			$elm$json$Json$Decode$field,
			'OffreIntrouvable',
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$OffreIntrouvable)),
			A2(
			$elm$json$Json$Decode$field,
			'PerimetreArchive',
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$PerimetreArchive)),
			A2(
			$elm$json$Json$Decode$field,
			'PerimetreAFicheVisee',
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$PerimetreAFicheVisee)),
			A2(
			$elm$json$Json$Decode$field,
			'AucunStatutActif',
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$AucunStatutActif)),
			A2(
			$elm$json$Json$Decode$field,
			'AucunResultatActif',
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$AucunResultatActif)),
			A2(
			$elm$json$Json$Decode$field,
			'StatutEnDouble',
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$StatutEnDouble)),
			A2(
			$elm$json$Json$Decode$field,
			'ResultatEnDouble',
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$ResultatEnDouble)),
			A2(
			$elm$json$Json$Decode$field,
			'StatutInconnu',
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$StatutInconnu)),
			A2(
			$elm$json$Json$Decode$field,
			'ResultatInconnu',
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$ResultatInconnu)),
			A2(
			$elm$json$Json$Decode$field,
			'StatutInitialRetire',
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$StatutInitialRetire)),
			A2(
			$elm$json$Json$Decode$field,
			'ResultatSystemeReserve',
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$ResultatSystemeReserve)),
			A2(
			$elm$json$Json$Decode$field,
			'CleDejaUtilisee',
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$CleDejaUtilisee)),
			A2(
			$elm$json$Json$Decode$field,
			'EvolutionNonAdditive',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$EvolutionNonAdditive,
				A2($elm$json$Json$Decode$field, 'raison', $elm$json$Json$Decode$string))),
			A2(
			$elm$json$Json$Decode$field,
			'SchemaInvalide',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$SchemaInvalide,
				A2(
					$elm$json$Json$Decode$field,
					'defauts',
					$elm$json$Json$Decode$list(
						A3(
							$elm$json$Json$Decode$map2,
							F2(
								function (champ, code) {
									return {uN: champ, vx: code};
								}),
							A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
							A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string)))))),
			A2(
			$elm$json$Json$Decode$field,
			'ValeursEnDouble',
			A3(
				$elm$json$Json$Decode$map2,
				F2(
					function (total, fiches) {
						return $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$ValeursEnDouble(
							{zu: fiches, JE: total});
					}),
				A2($elm$json$Json$Decode$field, 'total', $elm$json$Json$Decode$int),
				A2(
					$elm$json$Json$Decode$field,
					'fiches',
					$elm$json$Json$Decode$list(
						A3(
							$elm$json$Json$Decode$map2,
							F2(
								function (uid, liens) {
									return {nQ: liens, r8: uid};
								}),
							A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
							A2(
								$elm$json$Json$Decode$field,
								'_links',
								A2(
									$elm$json$Json$Decode$map,
									function ($) {
										return $.h0;
									},
									$author$project$API$Liens$decoder))))))),
			A2(
			$elm$json$Json$Decode$field,
			'ChampDontDependent',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$ChampDontDependent,
				A2(
					$elm$json$Json$Decode$field,
					'dependants',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string)))),
			A2(
			$elm$json$Json$Decode$field,
			'ChampInconnu',
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$ChampInconnu)),
			A2(
			$elm$json$Json$Decode$field,
			'OrdreInvalide',
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$OrdreInvalide)),
			A2(
			$elm$json$Json$Decode$field,
			'ChampDejaDansLaBibliotheque',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$ChampDejaDansLaBibliotheque,
				A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string))),
			A2(
			$elm$json$Json$Decode$field,
			'ChampHorsPortee',
			A3(
				$elm$json$Json$Decode$map2,
				F2(
					function (champ, portee) {
						return $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$ChampHorsPortee(
							{uN: champ, F$: portee});
					}),
				A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'portee', $elm$json$Json$Decode$string))),
			A2(
			$elm$json$Json$Decode$field,
			'DefinitionDUnChampPartage',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$DefinitionDUnChampPartage,
				A2($elm$json$Json$Decode$field, 'cle', $elm$json$Json$Decode$string))),
			A2(
			$elm$json$Json$Decode$field,
			'ListeHorsPortee',
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (liste, portee, issue) {
						return $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$ListeHorsPortee(
							{nh: issue, nW: liste, F$: portee});
					}),
				A2($elm$json$Json$Decode$field, 'liste', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'portee', $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$maybe(
					A2($elm$json$Json$Decode$field, 'issue', $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$lienDeLIssue))))
		]));
var $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$erreurDeType = function (reponse) {
	var _v0 = A2(
		$elm$json$Json$Decode$decodeString,
		A2($elm$json$Json$Decode$field, 'error', $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$duDomaine),
		reponse.f$);
	if (!_v0.$) {
		var erreur = _v0.a;
		return erreur;
	} else {
		return (reponse.ri === 409) ? $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$EcritureConcurrente : ((reponse.ri === 404) ? $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$Introuvable : ((reponse.ri === 422) ? $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$LibelleRefuse(
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$Basics$identity,
				$elm$core$Result$toMaybe(
					A2($elm$json$Json$Decode$decodeString, $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$champFautif, reponse.f$)))) : $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$AutreRefus));
	}
};
var $author$project$Components$Referentiel$Common$EnvoiDeType$ajoute = F2(
	function (voulus, libelles) {
		return A2(
			$elm$core$List$any,
			function (element) {
				return _Utils_eq(element.Aq, $elm$core$Maybe$Nothing) && _Utils_eq(element.R, libelles);
			},
			voulus);
	});
var $author$project$Components$Referentiel$Common$EnvoiDeType$estVoulu = F2(
	function (voulus, id) {
		return A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Aq;
				},
				$elm$core$Basics$eq(
					$elm$core$Maybe$Just(id))),
			voulus);
	});
var $author$project$Components$Referentiel$Common$EnvoiDeType$memes = F2(
	function (voulues, rendues) {
		return A2(
			$elm$core$List$all,
			function (une) {
				return A2($elm$core$List$member, une, rendues);
			},
			voulues) && A2(
			$elm$core$List$all,
			function (une) {
				return A2($elm$core$List$member, une, voulues);
			},
			rendues);
	});
var $author$project$Components$Referentiel$Common$EnvoiDeType$range = F2(
	function (voulus, ordre) {
		var connus = A2(
			$elm$core$List$filterMap,
			function ($) {
				return $.Aq;
			},
			voulus);
		return _Utils_eq(
			$elm$core$List$length(ordre),
			$elm$core$List$length(voulus)) && _Utils_eq(
			A2(
				$elm$core$List$filter,
				function (id) {
					return A2($elm$core$List$member, id, connus);
				},
				ordre),
			connus);
	});
var $author$project$Components$Referentiel$Common$EnvoiDeType$renomme = F3(
	function (voulus, id, libelles) {
		return A2(
			$elm$core$List$any,
			function (element) {
				return _Utils_eq(
					element.Aq,
					$elm$core$Maybe$Just(id)) && _Utils_eq(element.R, libelles);
			},
			voulus);
	});
var $author$project$Components$Referentiel$Common$EnvoiDeType$repondALEvolution = F2(
	function (voulue, faite) {
		return _Utils_eq(
			$elm$core$List$length(voulue.fx),
			$elm$core$List$length(faite.fx)) && (A2(
			$elm$core$List$all,
			$elm$core$Basics$identity,
			A3($elm$core$List$map2, $author$project$Components$Shared$EditeurDeSchema$Champ$equivalents, voulue.fx, faite.fx)) && A2(
			$elm$core$List$all,
			function (modifie) {
				return A2(
					$elm$core$List$any,
					$author$project$Components$Shared$EditeurDeSchema$Champ$equivalents(modifie),
					voulue.g$);
			},
			faite.g$));
	});
var $author$project$Components$Referentiel$Common$EnvoiDeType$repondA = F2(
	function (commande, evenements) {
		return A2(
			$elm$core$List$all,
			function (evenement) {
				var _v0 = _Utils_Tuple2(commande, evenement);
				_v0$37:
				while (true) {
					_v0$38:
					while (true) {
						switch (_v0.a.$) {
							case 1:
								switch (_v0.b.$) {
									case 1:
										var _v3 = _v0.a;
										var apparence = _v3.b;
										var fr = _v0.b.a;
										return _Utils_eq(apparence.R.zX, fr);
									case 2:
										var _v4 = _v0.a;
										var apparence = _v4.b;
										var en = _v0.b.a;
										return _Utils_eq(apparence.R.yg, en);
									case 3:
										var _v5 = _v0.a;
										var apparence = _v5.b;
										var icone = _v0.b.a;
										return _Utils_eq(apparence.aC, icone);
									case 4:
										var _v6 = _v0.a;
										var apparence = _v6.b;
										var couleur = _v0.b.a;
										return _Utils_eq(apparence.kf, couleur);
									case 30:
										break _v0$37;
									default:
										break _v0$38;
								}
							case 2:
								switch (_v0.b.$) {
									case 5:
										var _v7 = _v0.b;
										return true;
									case 30:
										break _v0$37;
									default:
										break _v0$38;
								}
							case 3:
								switch (_v0.b.$) {
									case 6:
										var _v8 = _v0.b;
										return true;
									case 30:
										break _v0$37;
									default:
										break _v0$38;
								}
							case 4:
								switch (_v0.b.$) {
									case 7:
										var _v9 = _v0.a;
										var voulues = _v9.b;
										var rendues = _v0.b.a;
										return A2($author$project$Components$Referentiel$Common$EnvoiDeType$memes, voulues, rendues);
									case 8:
										var _v10 = _v0.a;
										var voulues = _v10.c;
										var rendues = _v0.b.a;
										return A2($author$project$Components$Referentiel$Common$EnvoiDeType$memes, voulues, rendues);
									case 30:
										break _v0$37;
									default:
										break _v0$38;
								}
							case 5:
								switch (_v0.b.$) {
									case 9:
										var _v11 = _v0.a;
										var voulues = _v11.b;
										var perimetre = _v11.c;
										var _v12 = _v0.b;
										var rendues = _v12.a;
										var cite = _v12.b;
										return A2(
											$author$project$Components$Referentiel$Common$EnvoiDeType$memes,
											A2(
												$elm$core$List$map,
												function ($) {
													return $.Aq;
												},
												voulues),
											rendues) && _Utils_eq(perimetre, cite);
									case 30:
										break _v0$37;
									default:
										break _v0$38;
								}
							case 6:
								switch (_v0.b.$) {
									case 10:
										var _v13 = _v0.a;
										var voulue = _v13.b;
										var rendue = _v0.b.a;
										return _Utils_eq(voulue, rendue);
									case 30:
										break _v0$37;
									default:
										break _v0$38;
								}
							case 0:
								switch (_v0.b.$) {
									case 0:
										var _v1 = _v0.a;
										var voulu = _v1.a;
										var apparence = _v1.b;
										var _v2 = _v0.b;
										var fait = _v2.b;
										var rendue = _v2.c;
										return _Utils_eq(voulu, fait) && _Utils_eq(apparence, rendue);
									case 11:
										var _v14 = _v0.a;
										var _v15 = _v0.b;
										return true;
									case 16:
										var _v16 = _v0.a;
										return true;
									case 17:
										var _v17 = _v0.a;
										var _v18 = _v0.b;
										return true;
									case 30:
										break _v0$37;
									default:
										break _v0$38;
								}
							case 7:
								switch (_v0.b.$) {
									case 11:
										var _v19 = _v0.a;
										var voulus = _v19.b;
										var _v20 = _v0.b;
										var libelles = _v20.b;
										return A2($author$project$Components$Referentiel$Common$EnvoiDeType$ajoute, voulus, libelles);
									case 12:
										var _v21 = _v0.a;
										var voulus = _v21.b;
										var _v22 = _v0.b;
										var id = _v22.a;
										var libelles = _v22.b;
										return A3($author$project$Components$Referentiel$Common$EnvoiDeType$renomme, voulus, id, libelles);
									case 13:
										var _v23 = _v0.a;
										var voulus = _v23.b;
										var id = _v0.b.a;
										return !A2($author$project$Components$Referentiel$Common$EnvoiDeType$estVoulu, voulus, id);
									case 14:
										var _v24 = _v0.a;
										var voulus = _v24.b;
										var id = _v0.b.a;
										return A2($author$project$Components$Referentiel$Common$EnvoiDeType$estVoulu, voulus, id);
									case 15:
										var _v25 = _v0.a;
										var voulus = _v25.b;
										var ordre = _v0.b.a;
										return A2($author$project$Components$Referentiel$Common$EnvoiDeType$range, voulus, ordre);
									case 16:
										var _v26 = _v0.a;
										var voulus = _v26.b;
										var initial = _v26.c;
										var id = _v0.b.a;
										var _v27 = A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.Aq;
											},
											$elm$core$List$head(
												A2($elm$core$List$drop, initial, voulus)));
										if (!_v27.$) {
											if (!_v27.a.$) {
												var connu = _v27.a.a;
												return _Utils_eq(connu, id);
											} else {
												var _v28 = _v27.a;
												return true;
											}
										} else {
											return false;
										}
									case 30:
										break _v0$37;
									default:
										break _v0$38;
								}
							case 8:
								switch (_v0.b.$) {
									case 17:
										var _v29 = _v0.a;
										var voulus = _v29.b;
										var _v30 = _v0.b;
										var libelles = _v30.b;
										return A2($author$project$Components$Referentiel$Common$EnvoiDeType$ajoute, voulus, libelles);
									case 18:
										var _v31 = _v0.a;
										var voulus = _v31.b;
										var _v32 = _v0.b;
										var id = _v32.a;
										var libelles = _v32.b;
										return A3($author$project$Components$Referentiel$Common$EnvoiDeType$renomme, voulus, id, libelles);
									case 19:
										var _v33 = _v0.a;
										var voulus = _v33.b;
										var id = _v0.b.a;
										return !A2($author$project$Components$Referentiel$Common$EnvoiDeType$estVoulu, voulus, id);
									case 20:
										var _v34 = _v0.a;
										var voulus = _v34.b;
										var id = _v0.b.a;
										return A2($author$project$Components$Referentiel$Common$EnvoiDeType$estVoulu, voulus, id);
									case 21:
										var _v35 = _v0.a;
										var voulus = _v35.b;
										var ordre = _v0.b.a;
										return A2($author$project$Components$Referentiel$Common$EnvoiDeType$range, voulus, ordre);
									case 30:
										break _v0$37;
									default:
										break _v0$38;
								}
							case 9:
								switch (_v0.b.$) {
									case 22:
										var _v36 = _v0.a;
										var voulue = _v36.b;
										var _v37 = _v0.b;
										var faite = _v37.b;
										return A2($author$project$Components$Referentiel$Common$EnvoiDeType$repondALEvolution, voulue, faite);
									case 30:
										break _v0$37;
									default:
										break _v0$38;
								}
							case 10:
								switch (_v0.b.$) {
									case 23:
										var _v38 = _v0.a;
										var voulu = _v38.b;
										var fait = _v0.b.a;
										return _Utils_eq(voulu, fait);
									case 30:
										break _v0$37;
									default:
										break _v0$38;
								}
							case 11:
								switch (_v0.b.$) {
									case 24:
										var _v39 = _v0.a;
										var voulu = _v39.b;
										var fait = _v0.b.a;
										return _Utils_eq(voulu, fait);
									case 30:
										break _v0$37;
									default:
										break _v0$38;
								}
							case 12:
								switch (_v0.b.$) {
									case 25:
										var _v40 = _v0.a;
										var voulu = _v40.b;
										var fait = _v0.b.a;
										return _Utils_eq(voulu, fait);
									case 30:
										break _v0$37;
									default:
										break _v0$38;
								}
							case 19:
								switch (_v0.b.$) {
									case 26:
										var _v41 = _v0.a;
										var voulu = _v41.b;
										var fait = _v0.b.a;
										return _Utils_eq(voulu, fait);
									case 30:
										break _v0$37;
									default:
										break _v0$38;
								}
							case 13:
								switch (_v0.b.$) {
									case 27:
										var _v42 = _v0.a;
										var cle = _v42.b;
										var niveau = _v42.c;
										var _v43 = _v0.b;
										var faitCle = _v43.a;
										var faitNiveau = _v43.b;
										return _Utils_eq(cle, faitCle) && _Utils_eq(niveau, faitNiveau);
									case 30:
										break _v0$37;
									default:
										break _v0$38;
								}
							case 14:
								switch (_v0.b.$) {
									case 28:
										var _v44 = _v0.a;
										var cle = _v44.b;
										var voulues = _v44.c;
										var _v45 = _v0.b;
										var faitCle = _v45.a;
										var rendues = _v45.b;
										return _Utils_eq(cle, faitCle) && A2($author$project$Components$Referentiel$Common$EnvoiDeType$memes, voulues, rendues);
									case 30:
										break _v0$37;
									default:
										break _v0$38;
								}
							case 15:
								switch (_v0.b.$) {
									case 29:
										var _v46 = _v0.a;
										var voulu = _v46.b;
										var fait = _v0.b.a;
										return _Utils_eq(voulu, fait);
									case 30:
										break _v0$37;
									default:
										break _v0$38;
								}
							case 17:
								var _v49 = _v0.a;
								return true;
							case 18:
								var _v50 = _v0.a;
								return true;
							case 16:
								switch (_v0.b.$) {
									case 22:
										var _v47 = _v0.a;
										var _v48 = _v0.b;
										return true;
									case 27:
										var _v51 = _v0.a;
										var voulus = _v51.c;
										var _v52 = _v0.b;
										var niveau = _v52.b;
										return _Utils_eq(voulus.g4, niveau);
									case 30:
										break _v0$37;
									default:
										break _v0$38;
								}
							default:
								if (_v0.b.$ === 30) {
									break _v0$37;
								} else {
									break _v0$38;
								}
						}
					}
					return false;
				}
				var _v53 = _v0.b;
				return true;
			},
			evenements);
	});
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$ReponseDeCommandeDeType = F3(
	function (evenements, liens, vuesAJour) {
		return {mk: evenements, nQ: liens, sy: vuesAJour};
	});
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$AttributionSansOffreReglee = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$AutreEvenement = {$: 30};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$BlocsOrdonnes = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$ChampAffiche = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$ChampMasque = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$ChampsOrdonnes = function (a) {
	return {$: 25, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$CouleurModifiee = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$IconeModifiee = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$LibelleAnglaisModifie = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$LibelleFrancaisModifie = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$NaturesAdmisesDefinies = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$NiveauDeLectureDefini = F2(
	function (a, b) {
		return {$: 27, a: a, b: b};
	});
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$OffresLimitees = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$QualitesAdmisesDefinies = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$RestrictionDuChampLevee = function (a) {
	return {$: 29, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$ResultatAjoute = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$ResultatRenomme = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$ResultatRetabli = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$ResultatRetire = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$ResultatsOrdonnes = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$SchemaEvolue = F2(
	function (a, b) {
		return {$: 22, a: a, b: b};
	});
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$StatutAjoute = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$StatutInitialDesigne = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$StatutRenomme = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$StatutRetabli = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$StatutRetire = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$StatutsOrdonnes = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$TypeArchive = {$: 5};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$TypeCree = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$TypeRestaure = {$: 6};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$ValeursDuChampRestreintes = F2(
	function (a, b) {
		return {$: 28, a: a, b: b};
	});
var $author$project$Components$Referentiel$Admission$Organisation = 1;
var $author$project$Components$Referentiel$Admission$Personne = 0;
var $author$project$Components$Referentiel$Admission$natures = _List_fromArray(
	[0, 1]);
var $author$project$Components$Referentiel$Admission$parCode = F2(
	function (code, tous) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (lu) {
				var _v0 = A2(
					$elm$core$List$filter,
					function (un) {
						return _Utils_eq(
							code(un),
							lu);
					},
					tous);
				if (_v0.b) {
					var un = _v0.a;
					return $elm$json$Json$Decode$succeed(un);
				} else {
					return $elm$json$Json$Decode$fail(lu);
				}
			},
			$elm$json$Json$Decode$string);
	});
var $author$project$Components$Referentiel$Admission$natureDecoder = A2($author$project$Components$Referentiel$Admission$parCode, $author$project$Components$Referentiel$Admission$codeDeNature, $author$project$Components$Referentiel$Admission$natures);
var $author$project$Components$Referentiel$Admission$Particulier = 0;
var $author$project$Components$Referentiel$Admission$Professionnel = 1;
var $author$project$Components$Referentiel$Admission$qualites = _List_fromArray(
	[0, 1]);
var $author$project$Components$Referentiel$Admission$qualiteDecoder = A2($author$project$Components$Referentiel$Admission$parCode, $author$project$Components$Referentiel$Admission$codeDeQualite, $author$project$Components$Referentiel$Admission$qualites);
var $author$project$Components$Referentiel$Identifiants$ResultatId = $elm$core$Basics$identity;
var $author$project$Components$Referentiel$Identifiants$resultatIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Components$Referentiel$Identifiants$StatutId = $elm$core$Basics$identity;
var $author$project$Components$Referentiel$Identifiants$statutIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$evenementDeType = function () {
	var statut = A2($elm$json$Json$Decode$field, 'statut', $author$project$Components$Referentiel$Identifiants$statutIdDecoder);
	var resultat = A2($elm$json$Json$Decode$field, 'resultat', $author$project$Components$Referentiel$Identifiants$resultatIdDecoder);
	var libellesDeLElement = A2($elm$json$Json$Decode$field, 'libelles', $author$project$Components$Referentiel$Common$API$QueryAPIModel$libellesDecoder);
	var code = function (nom) {
		return $elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, nom, $elm$json$Json$Decode$string));
	};
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Basics$apR,
				A2($elm$json$Json$Decode$field, 'aggregateUid', $author$project$Components$Referentiel$Identifiants$typeUidDecoder),
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['event', 'TypeCree']),
					A5(
						$elm$json$Json$Decode$map4,
						F5(
							function (archetype, libelles, icone, couleur, uid) {
								return A3(
									$author$project$Components$Referentiel$Common$API$WriteAPIModel$TypeCree,
									uid,
									archetype,
									{kf: couleur, aC: icone, R: libelles});
							}),
						A2($elm$json$Json$Decode$field, 'archetype', $author$project$Components$Referentiel$Archetype$decoder),
						A2($elm$json$Json$Decode$field, 'libelles', $author$project$Components$Referentiel$Common$API$QueryAPIModel$libellesDecoder),
						code('icone'),
						code('couleur')))),
				A2(
				$elm$json$Json$Decode$field,
				'event',
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$json$Json$Decode$field,
							'LibelleFrancaisModifie',
							A2(
								$elm$json$Json$Decode$map,
								$author$project$Components$Referentiel$Common$API$WriteAPIModel$LibelleFrancaisModifie,
								A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string))),
							A2(
							$elm$json$Json$Decode$field,
							'LibelleAnglaisModifie',
							A2(
								$elm$json$Json$Decode$map,
								$author$project$Components$Referentiel$Common$API$WriteAPIModel$LibelleAnglaisModifie,
								code('libelle'))),
							A2(
							$elm$json$Json$Decode$field,
							'IconeModifiee',
							A2(
								$elm$json$Json$Decode$map,
								$author$project$Components$Referentiel$Common$API$WriteAPIModel$IconeModifiee,
								code('icone'))),
							A2(
							$elm$json$Json$Decode$field,
							'CouleurModifiee',
							A2(
								$elm$json$Json$Decode$map,
								$author$project$Components$Referentiel$Common$API$WriteAPIModel$CouleurModifiee,
								code('couleur'))),
							A2(
							$elm$json$Json$Decode$field,
							'TypeArchive',
							$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$WriteAPIModel$TypeArchive)),
							A2(
							$elm$json$Json$Decode$field,
							'TypeRestaure',
							$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$WriteAPIModel$TypeRestaure)),
							A2(
							$elm$json$Json$Decode$field,
							'NaturesAdmisesDefinies',
							A2(
								$elm$json$Json$Decode$map,
								$author$project$Components$Referentiel$Common$API$WriteAPIModel$NaturesAdmisesDefinies,
								A2(
									$elm$json$Json$Decode$field,
									'natures',
									$elm$json$Json$Decode$list($author$project$Components$Referentiel$Admission$natureDecoder)))),
							A2(
							$elm$json$Json$Decode$field,
							'QualitesAdmisesDefinies',
							A2(
								$elm$json$Json$Decode$map,
								$author$project$Components$Referentiel$Common$API$WriteAPIModel$QualitesAdmisesDefinies,
								A2(
									$elm$json$Json$Decode$field,
									'qualites',
									$elm$json$Json$Decode$list($author$project$Components$Referentiel$Admission$qualiteDecoder)))),
							A2(
							$elm$json$Json$Decode$field,
							'OffresLimitees',
							A3(
								$elm$json$Json$Decode$map2,
								$author$project$Components$Referentiel$Common$API$WriteAPIModel$OffresLimitees,
								A2(
									$elm$json$Json$Decode$field,
									'offres',
									$elm$json$Json$Decode$list(
										A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string))),
								$elm$json$Json$Decode$maybe(
									A2($elm$json$Json$Decode$field, 'perimetre', $elm$json$Json$Decode$string)))),
							A2(
							$elm$json$Json$Decode$field,
							'AttributionSansOffreReglee',
							A2(
								$elm$json$Json$Decode$map,
								$author$project$Components$Referentiel$Common$API$WriteAPIModel$AttributionSansOffreReglee,
								A2($elm$json$Json$Decode$field, 'interdite', $elm$json$Json$Decode$bool))),
							A2(
							$elm$json$Json$Decode$field,
							'StatutAjoute',
							A3($elm$json$Json$Decode$map2, $author$project$Components$Referentiel$Common$API$WriteAPIModel$StatutAjoute, statut, libellesDeLElement)),
							A2(
							$elm$json$Json$Decode$field,
							'StatutRenomme',
							A3($elm$json$Json$Decode$map2, $author$project$Components$Referentiel$Common$API$WriteAPIModel$StatutRenomme, statut, libellesDeLElement)),
							A2(
							$elm$json$Json$Decode$field,
							'StatutRetire',
							A2($elm$json$Json$Decode$map, $author$project$Components$Referentiel$Common$API$WriteAPIModel$StatutRetire, statut)),
							A2(
							$elm$json$Json$Decode$field,
							'StatutRetabli',
							A2($elm$json$Json$Decode$map, $author$project$Components$Referentiel$Common$API$WriteAPIModel$StatutRetabli, statut)),
							A2(
							$elm$json$Json$Decode$field,
							'StatutsOrdonnes',
							A2(
								$elm$json$Json$Decode$map,
								$author$project$Components$Referentiel$Common$API$WriteAPIModel$StatutsOrdonnes,
								A2(
									$elm$json$Json$Decode$field,
									'ordre',
									$elm$json$Json$Decode$list($author$project$Components$Referentiel$Identifiants$statutIdDecoder)))),
							A2(
							$elm$json$Json$Decode$field,
							'StatutInitialDesigne',
							A2($elm$json$Json$Decode$map, $author$project$Components$Referentiel$Common$API$WriteAPIModel$StatutInitialDesigne, statut)),
							A2(
							$elm$json$Json$Decode$field,
							'ResultatAjoute',
							A3($elm$json$Json$Decode$map2, $author$project$Components$Referentiel$Common$API$WriteAPIModel$ResultatAjoute, resultat, libellesDeLElement)),
							A2(
							$elm$json$Json$Decode$field,
							'ResultatRenomme',
							A3($elm$json$Json$Decode$map2, $author$project$Components$Referentiel$Common$API$WriteAPIModel$ResultatRenomme, resultat, libellesDeLElement)),
							A2(
							$elm$json$Json$Decode$field,
							'ResultatRetire',
							A2($elm$json$Json$Decode$map, $author$project$Components$Referentiel$Common$API$WriteAPIModel$ResultatRetire, resultat)),
							A2(
							$elm$json$Json$Decode$field,
							'ResultatRetabli',
							A2($elm$json$Json$Decode$map, $author$project$Components$Referentiel$Common$API$WriteAPIModel$ResultatRetabli, resultat)),
							A2(
							$elm$json$Json$Decode$field,
							'ResultatsOrdonnes',
							A2(
								$elm$json$Json$Decode$map,
								$author$project$Components$Referentiel$Common$API$WriteAPIModel$ResultatsOrdonnes,
								A2(
									$elm$json$Json$Decode$field,
									'ordre',
									$elm$json$Json$Decode$list($author$project$Components$Referentiel$Identifiants$resultatIdDecoder)))),
							A2(
							$elm$json$Json$Decode$field,
							'SchemaEvolue',
							A4(
								$elm$json$Json$Decode$map3,
								F3(
									function (version, ajouts, modifications) {
										return A2(
											$author$project$Components$Referentiel$Common$API$WriteAPIModel$SchemaEvolue,
											version,
											{fx: ajouts, g$: modifications});
									}),
								A2($elm$json$Json$Decode$field, 'version', $elm$json$Json$Decode$int),
								A2(
									$elm$json$Json$Decode$field,
									'ajouts',
									$elm$json$Json$Decode$list($author$project$Components$Shared$EditeurDeSchema$Champ$decoder)),
								A2(
									$elm$json$Json$Decode$field,
									'modifications',
									$elm$json$Json$Decode$list($author$project$Components$Shared$EditeurDeSchema$Champ$decoder)))),
							A2(
							$elm$json$Json$Decode$field,
							'ChampMasque',
							A2(
								$elm$json$Json$Decode$map,
								$author$project$Components$Referentiel$Common$API$WriteAPIModel$ChampMasque,
								A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string))),
							A2(
							$elm$json$Json$Decode$field,
							'ChampAffiche',
							A2(
								$elm$json$Json$Decode$map,
								$author$project$Components$Referentiel$Common$API$WriteAPIModel$ChampAffiche,
								A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string))),
							A2(
							$elm$json$Json$Decode$field,
							'ChampsOrdonnes',
							A2(
								$elm$json$Json$Decode$map,
								$author$project$Components$Referentiel$Common$API$WriteAPIModel$ChampsOrdonnes,
								A2(
									$elm$json$Json$Decode$field,
									'ordre',
									$elm$json$Json$Decode$list($elm$json$Json$Decode$string)))),
							A2(
							$elm$json$Json$Decode$field,
							'BlocsOrdonnes',
							A2(
								$elm$json$Json$Decode$map,
								$author$project$Components$Referentiel$Common$API$WriteAPIModel$BlocsOrdonnes,
								A2(
									$elm$json$Json$Decode$field,
									'ordre',
									$elm$json$Json$Decode$list($elm$json$Json$Decode$string)))),
							A2(
							$elm$json$Json$Decode$field,
							'ValeursDuChampRestreintes',
							A3(
								$elm$json$Json$Decode$map2,
								$author$project$Components$Referentiel$Common$API$WriteAPIModel$ValeursDuChampRestreintes,
								A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
								A2(
									$elm$json$Json$Decode$field,
									'valeurs',
									$elm$json$Json$Decode$list($elm$json$Json$Decode$string)))),
							A2(
							$elm$json$Json$Decode$field,
							'RestrictionDuChampLevee',
							A2(
								$elm$json$Json$Decode$map,
								$author$project$Components$Referentiel$Common$API$WriteAPIModel$RestrictionDuChampLevee,
								A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string))),
							A2(
							$elm$json$Json$Decode$field,
							'NiveauDeLectureDefini',
							A3(
								$elm$json$Json$Decode$map2,
								$author$project$Components$Referentiel$Common$API$WriteAPIModel$NiveauDeLectureDefini,
								A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
								A2($elm$json$Json$Decode$field, 'niveau', $elm$json$Json$Decode$string)))
						]))),
				$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$WriteAPIModel$AutreEvenement)
			]));
}();
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$reponseDeTypeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'vuesAJour',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'liens',
		A2(
			$elm$json$Json$Decode$map,
			function ($) {
				return $.h0;
			},
			$author$project$API$Liens$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'evenements',
			$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$WriteAPIModel$evenementDeType),
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$WriteAPIModel$ReponseDeCommandeDeType))));
var $author$project$Components$Referentiel$Common$EnvoiDeType$reglage = {
	f8: $author$project$Components$Referentiel$Common$EffetDeType$DemanderProcessUid,
	l4: $author$project$Components$Referentiel$Common$EffetDeType$Envoyer,
	go: $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$erreurDeType,
	pW: $author$project$Components$Referentiel$Common$EffetDeType$Reconnecter,
	qu: F2(
		function (commande, rendue) {
			return A2($author$project$Components$Referentiel$Common$EnvoiDeType$repondA, commande, rendue.mk);
		}),
	qv: $author$project$Components$Referentiel$Common$API$WriteAPIModel$reponseDeTypeDecoder
};
var $author$project$Components$Referentiel$Types$Update$conduite = function (model) {
	var schema = A2(
		$elm$core$Maybe$andThen,
		function ($) {
			return $.aN;
		},
		$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model));
	var editeur = A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.x5;
		},
		schema);
	return {
		s0: A3($author$project$Components$Referentiel$Types$Update$commandeDuChamp, $author$project$API$NavLinksDictionary$afficherUnChamp, $author$project$Components$Referentiel$Common$API$WriteAPIModel$AfficherUnChampDUnType, model),
		s1: F2(
			function (voulus, projection) {
				var page = projection.EE;
				return _Utils_update(
					projection,
					{
						EE: _Utils_update(
							page,
							{
								gv: A2(
									$elm$core$Maybe$map,
									function (fiche) {
										return _Utils_update(
											fiche,
											{
												aN: A2(
													$elm$core$Maybe$map,
													function (lu) {
														return _Utils_update(
															lu,
															{dw: voulus});
													},
													fiche.aN)
											});
									},
									page.gv)
							})
					});
			}),
		tm: F2(
			function (_v0, _v1) {
				return $author$project$I18n$Traductions$tel('');
			}),
		dw: A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.dw;
			},
			schema),
		dy: A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.uN;
			},
			function ($) {
				return $.dy;
			}),
		xE: function () {
			var _v2 = A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.xD;
				},
				editeur);
			if (!_v2.$) {
				var personnelle = _v2.a;
				return personnelle.sY ? personnelle.vu : _List_Nil;
			} else {
				return _List_Nil;
			}
		}(),
		l2: $author$project$Components$Referentiel$Common$EnvoiDeType$reglage,
		yW: A3(
			$elm$core$Maybe$map2,
			F2(
				function (fiche, lien) {
					return _Utils_Tuple2(
						$author$project$Components$Referentiel$Common$API$WriteAPIModel$FaireEvoluerLeSchemaDUnType(fiche.r0.r8),
						lien);
				}),
			$author$project$Components$Shared$Drawer$Model$estOuvert(model.AM.kX) ? $author$project$Components$Referentiel$Types$Model$ficheDesInformations(model) : $author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model),
			$author$project$Components$Referentiel$Types$Model$lienDesInformations(model)),
		Ba: A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Ba;
				},
				editeur)),
		Cc: A3($author$project$Components$Referentiel$Types$Update$commandeDuChamp, $author$project$API$NavLinksDictionary$masquerUnChamp, $author$project$Components$Referentiel$Common$API$WriteAPIModel$MasquerUnChampDUnType, model),
		CC: function (_v3) {
			return $elm$core$Maybe$Nothing;
		},
		g_: function (cle) {
			return A2(
				$elm$core$Maybe$andThen,
				function (lu) {
					return A2(
						$elm$core$Maybe$map,
						function (code) {
							return _Utils_Tuple2(code, lu.uN);
						},
						lu.JR);
				},
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dw;
						},
						$author$project$Components$Referentiel$Types$Informations$parCle(cle)),
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.aN;
						},
						$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model))));
		},
		Do: function (_v4) {
			return $author$project$Components$Referentiel$Types$Informations$nomDuDrawer;
		},
		hd: model.hd,
		Ek: function (voulus) {
			return A3(
				$elm$core$Maybe$map2,
				F2(
					function (fiche, lien) {
						return _Utils_Tuple2(
							A2(
								$author$project$Components$Referentiel$Common$API$WriteAPIModel$OrdonnerLesChampsDUnType,
								fiche.r0.r8,
								A2(
									$elm$core$List$map,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.uN;
										},
										function ($) {
											return $.dy;
										}),
									voulus)),
							lien);
					}),
				$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model),
				$author$project$Components$Referentiel$Types$Model$lienDOrdre(model));
		},
		FO: $author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus,
		F$: 2
	};
};
var $author$project$Components$Referentiel$Types$Update$parLaConduite = F2(
	function (geste, model) {
		var etat = model.AM;
		return A2(
			$elm$core$Tuple$mapFirst,
			function (apres) {
				var page = apres.EE;
				var avant = page.AM;
				return _Utils_update(
					page,
					{
						l2: apres.l2,
						AM: _Utils_update(
							avant,
							{
								iP: apres.iP,
								wC: $author$project$Components$Shared$Drawer$Model$estOuvert(apres.kX) ? avant.wC : $elm$core$Maybe$Nothing,
								kX: apres.kX,
								m_: apres.m_,
								o2: apres.o2,
								hP: apres.hP
							})
					});
			},
			A2(
				geste,
				$author$project$Components$Referentiel$Types$Update$conduite(model),
				{iP: etat.iP, kX: etat.kX, l2: model.l2, m_: etat.m_, o2: etat.o2, EE: model, hP: etat.hP}));
	});
var $author$project$Components$Referentiel$Common$RattacherUnChamp$reinitialiser = function (etat) {
	return _Utils_update(
		etat,
		{
			kz: $elm$core$Maybe$Nothing,
			n9: 0,
			pN: $author$project$Components$Shared$Bibliotheque$Rattachement$init(etat.pN.cC)
		});
};
var $author$project$Components$Referentiel$Types$Informations$reinitialiserLAjout = function (etat) {
	return _Utils_update(
		etat,
		{
			wZ: {zG: false, G1: false},
			gf: $elm$core$Maybe$Nothing,
			GZ: $author$project$Components$Referentiel$Common$RattacherUnChamp$reinitialiser(etat.GZ)
		});
};
var $author$project$Components$Referentiel$Types$Update$ouvrirUneInformation = function (model) {
	var _v0 = _Utils_Tuple2(
		$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model),
		$author$project$Components$Referentiel$Types$Model$lienDesInformations(model));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var fiche = _v0.a.a;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Basics$append(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$EffetDeType$LireLesListes, $elm$core$List$singleton),
						model.AM.BF))),
			A2(
				$author$project$Components$Referentiel$Types$Update$parLaConduite,
				function (reglage) {
					return A2($author$project$Components$Shared$EditeurDeSchema$Conduite$ouvrirLAjout, reglage, $author$project$Components$Referentiel$Types$Model$idDeLAjoutDUneInformation);
				},
				A2(
					$author$project$Components$Referentiel$Types$Update$avecLesInformations,
					function (etat) {
						return function (neuf) {
							return _Utils_update(
								neuf,
								{
									wC: $elm$core$Maybe$Just(fiche.r0.r8)
								});
						}(
							$author$project$Components$Referentiel$Types$Informations$reinitialiserLAjout(etat));
					},
					model)));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Types$Update$ajoutOuvert = function (model) {
	return $author$project$Components$Referentiel$Types$Update$offreLeNouveauChamp(model) ? $author$project$Components$Referentiel$Types$Update$demanderLeNouveauChamp(model) : $author$project$Components$Referentiel$Types$Update$ouvrirUneInformation(model);
};
var $author$project$Components$Referentiel$Common$ChoixDUnPerimetre$Choisissable = F5(
	function (id, nom, decompte, criteres, liee) {
		return {wp: criteres, wT: decompte, Aq: id, Bx: liee, Dj: nom};
	});
var $author$project$Components$Referentiel$Common$ChoixDUnPerimetre$Segment = F2(
	function (texte, fort) {
		return {dX: fort, Jx: texte};
	});
var $author$project$Components$Referentiel$Common$ChoixDUnPerimetre$segmentDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Referentiel$Common$ChoixDUnPerimetre$Segment,
	A2($elm$json$Json$Decode$field, 'texte', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'fort', $elm$json$Json$Decode$bool));
var $author$project$Components$Referentiel$Common$ChoixDUnPerimetre$annuaireDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$filter(
			A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$Basics$not)),
		$elm$core$List$map($elm$core$Tuple$second)),
	A2(
		$elm$json$Json$Decode$field,
		'perimetres',
		$elm$json$Json$Decode$list(
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'criteresLies',
				$elm$json$Json$Decode$int,
				0,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'criteresResumes',
					$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$ChoixDUnPerimetre$segmentDecoder),
					_List_Nil,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'decompte',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'archive',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'nom',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'uid',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed(
										F6(
											function (id, nom, archive, decompte, criteres, lies) {
												return _Utils_Tuple2(
													archive,
													A5($author$project$Components$Referentiel$Common$ChoixDUnPerimetre$Choisissable, id, nom, decompte, criteres, lies > 0));
											})))))))))));
var $author$project$Components$Shared$Bibliotheque$Restriction$avecLApercu = F2(
	function (horsChoix, restriction) {
		return _Utils_update(
			restriction,
			{
				gH: $elm$core$Maybe$Just(horsChoix)
			});
	});
var $author$project$Components$Referentiel$Types$RestrictionDuChamp$surLEtat = F2(
	function (changer, enCours) {
		return _Utils_update(
			enCours,
			{
				gt: A2($elm$core$Maybe$map, changer, enCours.gt)
			});
	});
var $author$project$Components$Referentiel$Types$RestrictionDuChamp$avecLApercu = function (horsChoix) {
	return $author$project$Components$Referentiel$Types$RestrictionDuChamp$surLEtat(
		$author$project$Components$Shared$Bibliotheque$Restriction$avecLApercu(horsChoix));
};
var $author$project$Components$Referentiel$Types$Update$apercuDeLaRestriction = F2(
	function (reponse, model) {
		var _v0 = _Utils_Tuple2(
			A2(
				$author$project$API$Reponse$lire,
				A2($elm$json$Json$Decode$field, 'fichesHorsChoix', $elm$json$Json$Decode$int),
				reponse),
			model.AM.al);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var nombre = _v0.a.a;
				var enCours = _v0.b.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Types$Update$avecLesInformations,
						function (etat) {
							return _Utils_update(
								etat,
								{
									al: $elm$core$Maybe$Just(
										A2($author$project$Components$Referentiel$Types$RestrictionDuChamp$avecLApercu, nombre, enCours))
								});
						},
						model),
					_List_Nil);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			var refus = _v0.a.a;
			return _Utils_Tuple2(
				model,
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Referentiel$Common$EffetDeType$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$Resserrage$ApercuDemande = {$: 1};
var $author$project$Components$Shared$EditeurDeSchema$Resserrage$Avertit = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Resserrage$idDeLApercu = function (prefixe) {
	return prefixe + '-resserrage';
};
var $author$project$Components$Referentiel$Types$Update$sansApercu = function (_v0) {
	var model = _v0.a;
	var effets = _v0.b;
	return _Utils_Tuple2(
		A2(
			$author$project$Components$Referentiel$Types$Update$avecLesInformations,
			function (etat) {
				return _Utils_update(
					etat,
					{tq: $author$project$Components$Shared$EditeurDeSchema$Resserrage$SansApercu});
			},
			model),
		effets);
};
var $author$project$Components$Shared$EditeurDeSchema$View$idDuLibelle = F2(
	function (prefixe, langue) {
		return prefixe + ('-libelle-' + langue);
	});
var $author$project$Components$Shared$EditeurDeSchema$Conduite$idDuPremierLibelle = function (model) {
	return A2(
		$author$project$Components$Shared$EditeurDeSchema$View$idDuLibelle,
		$author$project$Components$Shared$Drawer$Model$idRacine(model.kX),
		A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(model.hP.Ba)));
};
var $author$project$Components$Shared$EditeurDeSchema$Model$refuser = F2(
	function (refus, saisie) {
		return _Utils_update(
			saisie,
			{pZ: refus});
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$tenter = function (saisie) {
	return _Utils_update(
		saisie,
		{b5: true});
};
var $author$project$Components$Shared$EditeurDeSchema$Model$option = F2(
	function (code, formulaire) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Dict$get, code, formulaire.o_));
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$decimal = F2(
	function (code, formulaire) {
		return $elm$core$String$toFloat(
			A3(
				$elm$core$String$replace,
				',',
				'.',
				$elm$core$String$trim(
					A2($author$project$Components$Shared$EditeurDeSchema$Model$option, code, formulaire))));
	});
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionBornesPlausibles = 'bornes-plausibles';
var $author$project$Components$Shared$EditeurDeSchema$Model$sousOption = F2(
	function (code, suffixe) {
		return code + ('.' + suffixe);
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$borneResserree = F2(
	function (cote, saisie) {
		var voulue = A2(
			$author$project$Components$Shared$EditeurDeSchema$Model$decimal,
			A2($author$project$Components$Shared$EditeurDeSchema$Model$sousOption, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionBornesPlausibles, cote),
			saisie.zT);
		var resserree = F2(
			function (plusEtroite, enregistree) {
				var _v1 = _Utils_Tuple2(enregistree, voulue);
				if (_v1.b.$ === 1) {
					var _v2 = _v1.b;
					return false;
				} else {
					if (_v1.a.$ === 1) {
						var _v3 = _v1.a;
						return true;
					} else {
						var avant = _v1.a.a;
						var apres = _v1.b.a;
						return A2(plusEtroite, apres, avant);
					}
				}
			});
		var _v0 = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.r0;
			},
			saisie.lZ);
		if ((!_v0.$) && (_v0.a.$ === 10)) {
			var mesure = _v0.a.a;
			return (cote === 'min') ? A2(resserree, $elm$core$Basics$gt, mesure.Cx) : A2(resserree, $elm$core$Basics$lt, mesure.Cg);
		} else {
			return false;
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$aideSaisie = F2(
	function (langue, formulaire) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Dict$get, langue, formulaire.bq));
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$coche = F2(
	function (code, formulaire) {
		return A2($elm$core$Dict$member, code, formulaire.o_);
	});
var $author$project$Referentiel$Normes$codesDesLangues = function (_v0) {
	var normes = _v0;
	return $elm$core$List$sort(
		A2(
			$elm$core$List$map,
			function ($) {
				return $.vx;
			},
			normes.Ba));
};
var $author$project$Components$Shared$EditeurDeSchema$Model$entier = F2(
	function (code, formulaire) {
		return $elm$core$String$toInt(
			$elm$core$String$trim(
				A2($author$project$Components$Shared$EditeurDeSchema$Model$option, code, formulaire)));
	});
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceALEnregistrement = 'a-l-enregistrement';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceALaPublication = 'a-la-publication';
var $author$project$Components$Shared$EditeurDeSchema$Model$jour = function (borne) {
	if ((!borne.$) && (borne.a.$ === 1)) {
		var date = borne.a.a;
		return $elm$core$Maybe$Just(date);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Shared$EditeurDeSchema$Model$nombreDeBorne = function (borne) {
	if ((!borne.$) && (!borne.a.$)) {
		var valeur = borne.a.a;
		return $elm$core$Maybe$Just(valeur);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Shared$EditeurDeSchema$Model$horsFormulaire = function (regle) {
	var melee = F2(
		function (min, max) {
			return ((!_Utils_eq(
				$author$project$Components$Shared$EditeurDeSchema$Model$jour(min),
				$elm$core$Maybe$Nothing)) && (!_Utils_eq(
				$author$project$Components$Shared$EditeurDeSchema$Model$nombreDeBorne(max),
				$elm$core$Maybe$Nothing))) || ((!_Utils_eq(
				$author$project$Components$Shared$EditeurDeSchema$Model$nombreDeBorne(min),
				$elm$core$Maybe$Nothing)) && (!_Utils_eq(
				$author$project$Components$Shared$EditeurDeSchema$Model$jour(max),
				$elm$core$Maybe$Nothing)));
		});
	var duJour = function (borne) {
		if ((!borne.$) && (borne.a.$ === 2)) {
			return true;
		} else {
			return false;
		}
	};
	switch (regle.$) {
		case 4:
			return true;
		case 0:
			var min = regle.a;
			var max = regle.b;
			return duJour(min) || (duJour(max) || A2(melee, min, max));
		default:
			return false;
	}
};
var $author$project$Components$Shared$EditeurDeSchema$Model$languesDesLibelles = $elm$core$List$filter(
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Basics$not,
		$elm$core$String$contains('-')));
var $author$project$Components$Shared$EditeurDeSchema$Model$libelleSaisi = F2(
	function (langue, formulaire) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Dict$get, langue, formulaire.R));
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$libelleDe = F2(
	function (langue, saisie) {
		return $elm$core$String$trim(
			A2($author$project$Components$Shared$EditeurDeSchema$Model$libelleSaisi, langue, saisie.zT));
	});
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionLibellesDesValeurs = 'libelles-des-valeurs';
var $author$project$Components$Shared$EditeurDeSchema$Model$texteSaisi = F2(
	function (code, formulaire) {
		var saisi = $elm$core$String$trim(
			A2($author$project$Components$Shared$EditeurDeSchema$Model$option, code, formulaire));
		return (saisi === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(saisi);
	});
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionValeurs = 'valeurs';
var $author$project$Components$Shared$EditeurDeSchema$Model$valeursDeLaListe = function (formulaire) {
	return A2(
		$elm$core$List$filter,
		A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
		A2(
			$elm$core$List$map,
			$elm$core$String$trim,
			$elm$core$String$lines(
				A2($author$project$Components$Shared$EditeurDeSchema$Model$option, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionValeurs, formulaire))));
};
var $author$project$Components$Shared$EditeurDeSchema$Model$libellesDesValeursVoulus = function (saisie) {
	var parDefaut = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(saisie.Ba));
	var traduites = function (valeur) {
		return A2(
			$elm$core$List$filterMap,
			function (langue) {
				return A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(langue),
					A2(
						$author$project$Components$Shared$EditeurDeSchema$Model$texteSaisi,
						A2($author$project$Components$Shared$EditeurDeSchema$Model$sousOption, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionLibellesDesValeurs, langue + ('.' + valeur)),
						saisie.zT));
			},
			A2(
				$elm$core$List$filter,
				$elm$core$Basics$neq(parDefaut),
				$author$project$Components$Shared$EditeurDeSchema$Model$languesDesLibelles(saisie.Ba)));
	};
	return A2(
		$elm$core$List$filterMap,
		function (valeur) {
			return $elm$core$List$isEmpty(
				traduites(valeur)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				_Utils_Tuple2(
					valeur,
					traduites(valeur)));
		},
		$author$project$Components$Shared$EditeurDeSchema$Model$valeursDeLaListe(saisie.zT));
};
var $author$project$Components$Shared$EditeurDeSchema$Model$memesElements = F2(
	function (premiers, seconds) {
		return _Utils_eq(
			$elm$core$List$length(premiers),
			$elm$core$List$length(seconds)) && (A2(
			$elm$core$List$all,
			function (element) {
				return A2($elm$core$List$member, element, seconds);
			},
			premiers) && A2(
			$elm$core$List$all,
			function (element) {
				return A2($elm$core$List$member, element, premiers);
			},
			seconds));
	});
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionConservation = 'conservation';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionTraduisible = 'traduisible';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionBornes = 'bornes';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionBornesDeDate = 'bornes-de-date';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionLongueur = 'longueur';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionMotif = 'motif';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionUnique = 'unique';
var $author$project$Components$Shared$EditeurDeSchema$Model$reglesVoulues = function (formulaire) {
	var motif = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (regex) {
				return _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$EditeurDeSchema$Champ$Motif,
						regex,
						$elm$core$String$trim(
							A2(
								$author$project$Components$Shared$EditeurDeSchema$Model$option,
								A2($author$project$Components$Shared$EditeurDeSchema$Model$sousOption, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionMotif, 'message'),
								formulaire)))
					]);
			},
			A2($author$project$Components$Shared$EditeurDeSchema$Model$texteSaisi, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionMotif, formulaire)));
	var longueur = function () {
		var _v3 = _Utils_Tuple2(
			A2(
				$author$project$Components$Shared$EditeurDeSchema$Model$entier,
				A2($author$project$Components$Shared$EditeurDeSchema$Model$sousOption, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionLongueur, 'min'),
				formulaire),
			A2($author$project$Components$Shared$EditeurDeSchema$Model$entier, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionLongueur, formulaire));
		if ((_v3.a.$ === 1) && (_v3.b.$ === 1)) {
			var _v4 = _v3.a;
			var _v5 = _v3.b;
			return _List_Nil;
		} else {
			var min = _v3.a;
			var max = _v3.b;
			return _List_fromArray(
				[
					A2($author$project$Components$Shared$EditeurDeSchema$Champ$Longueur, min, max)
				]);
		}
	}();
	var bornee = F3(
		function (code, lire, construire) {
			var _v0 = _Utils_Tuple2(
				A2(
					lire,
					A2($author$project$Components$Shared$EditeurDeSchema$Model$sousOption, code, 'min'),
					formulaire),
				A2(
					lire,
					A2($author$project$Components$Shared$EditeurDeSchema$Model$sousOption, code, 'max'),
					formulaire));
			if ((_v0.a.$ === 1) && (_v0.b.$ === 1)) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return _List_Nil;
			} else {
				var min = _v0.a;
				var max = _v0.b;
				return _List_fromArray(
					[
						A2(construire, min, max)
					]);
			}
		});
	return $elm$core$List$concat(
		_List_fromArray(
			[
				longueur,
				motif,
				A2($author$project$Components$Shared$EditeurDeSchema$Model$coche, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionUnique, formulaire) ? _List_fromArray(
				[$author$project$Components$Shared$EditeurDeSchema$Champ$Unique]) : _List_Nil,
				A3(
				bornee,
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionBornes,
				$author$project$Components$Shared$EditeurDeSchema$Model$decimal,
				F2(
					function (min, max) {
						return A2(
							$author$project$Components$Shared$EditeurDeSchema$Champ$Bornes,
							A2($elm$core$Maybe$map, $author$project$Components$Shared$EditeurDeSchema$Champ$BorneNombre, min),
							A2($elm$core$Maybe$map, $author$project$Components$Shared$EditeurDeSchema$Champ$BorneNombre, max));
					})),
				A3(
				bornee,
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionBornesDeDate,
				$author$project$Components$Shared$EditeurDeSchema$Model$texteSaisi,
				F2(
					function (min, max) {
						return A2(
							$author$project$Components$Shared$EditeurDeSchema$Champ$Bornes,
							A2($elm$core$Maybe$map, $author$project$Components$Shared$EditeurDeSchema$Champ$BorneJour, min),
							A2($elm$core$Maybe$map, $author$project$Components$Shared$EditeurDeSchema$Champ$BorneJour, max));
					}))
			]));
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$Langue = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$genreFeminin = 'feminin';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionGenreOccurrence = 'genre';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionLibelleOccurrence = 'libelle-occurrence';
var $author$project$Components$Shared$EditeurDeSchema$Model$typeDuSousChamp = function (sousChamp) {
	var _v0 = sousChamp.M;
	switch (_v0) {
		case 0:
			return $author$project$Components$Shared$EditeurDeSchema$Champ$Texte;
		case 1:
			return $author$project$Components$Shared$EditeurDeSchema$Champ$Nombre;
		case 2:
			return $author$project$Components$Shared$EditeurDeSchema$Champ$Date;
		case 3:
			return $author$project$Components$Shared$EditeurDeSchema$Champ$Montant;
		case 4:
			return $author$project$Components$Shared$EditeurDeSchema$Champ$AvecUnite(
				{
					iF: _List_Nil,
					kv: A2(
						$elm$core$Maybe$withDefault,
						0,
						$elm$core$String$toInt(sousChamp.kv)),
					Cg: $elm$core$String$toFloat(sousChamp.Cg),
					Cx: $elm$core$String$toFloat(sousChamp.Cx),
					sa: sousChamp.sa
				});
		case 5:
			return $author$project$Components$Shared$EditeurDeSchema$Champ$Devise;
		case 7:
			return $author$project$Components$Shared$EditeurDeSchema$Champ$PartiePrenante(
				{r$: sousChamp.r$});
		case 8:
			return $author$project$Components$Shared$EditeurDeSchema$Champ$Utilisateur;
		default:
			return $author$project$Components$Shared$EditeurDeSchema$Champ$ChoixDansUneListePartagee(
				{ys: sousChamp.nW, Cg: $elm$core$Maybe$Nothing, Cx: $elm$core$Maybe$Nothing, FS: false});
	}
};
var $author$project$Components$Shared$EditeurDeSchema$Model$groupeVoulu = function (formulaire) {
	var unSousChamp = function (sousChamp) {
		var champ = $author$project$Components$Shared$EditeurDeSchema$Champ$nouveau(
			{
				dy: A2(
					$elm$core$Maybe$withDefault,
					$author$project$Components$Shared$EditeurDeSchema$Model$proposerCle(sousChamp.Bl),
					sousChamp.dy),
				Bl: $elm$core$String$trim(sousChamp.Bl),
				r0: $author$project$Components$Shared$EditeurDeSchema$Model$typeDuSousChamp(sousChamp)
			});
		return _Utils_update(
			champ,
			{he: sousChamp.he});
	};
	return $author$project$Components$Shared$EditeurDeSchema$Champ$Groupe(
		{
			z9: _Utils_eq(
				A2($author$project$Components$Shared$EditeurDeSchema$Model$option, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionGenreOccurrence, formulaire),
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$genreFeminin) ? 0 : 1,
			Bq: $elm$core$String$trim(
				A2($author$project$Components$Shared$EditeurDeSchema$Model$option, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionLibelleOccurrence, formulaire)),
			Cd: _List_Nil,
			HI: !_Utils_eq(
				A2($author$project$Components$Shared$EditeurDeSchema$Model$option, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionRepetable, formulaire),
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$nonRepetable),
			IX: A2($elm$core$List$map, unSousChamp, formulaire.IX),
			r9: _List_Nil
		});
};
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionAffichageParLangue = 'affichage-par-langue';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionFormule = 'formule';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionNombreDeChoix = 'nombre-de-choix';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionTailleMaximale = 'taille-maximale';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionTypeDuResultat = 'type-du-resultat';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionTypesDeMedia = 'types-de-media';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeChoixMultiples = 'choix-multiples';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeListe = 'liste';
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeUtilisateur = 'utilisateur';
var $author$project$Components$Shared$EditeurDeSchema$Model$typesSimples = _List_fromArray(
	[
		_Utils_Tuple2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeNombre, $author$project$Components$Shared$EditeurDeSchema$Champ$Nombre),
		_Utils_Tuple2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeMontant, $author$project$Components$Shared$EditeurDeSchema$Champ$Montant),
		_Utils_Tuple2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeTexte, $author$project$Components$Shared$EditeurDeSchema$Champ$Texte),
		_Utils_Tuple2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeTexteLong, $author$project$Components$Shared$EditeurDeSchema$Champ$TexteLong),
		_Utils_Tuple2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeDate, $author$project$Components$Shared$EditeurDeSchema$Champ$Date),
		_Utils_Tuple2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeOuiNon, $author$project$Components$Shared$EditeurDeSchema$Champ$OuiNon),
		_Utils_Tuple2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeEmail, $author$project$Components$Shared$EditeurDeSchema$Champ$Email),
		_Utils_Tuple2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeTelephone, $author$project$Components$Shared$EditeurDeSchema$Champ$Telephone),
		_Utils_Tuple2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeAdresse, $author$project$Components$Shared$EditeurDeSchema$Champ$Adresse),
		_Utils_Tuple2(
		$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typePays,
		$author$project$Components$Shared$EditeurDeSchema$Champ$Pays(
			{FS: false}))
	]);
var $author$project$Components$Shared$EditeurDeSchema$Model$typeVoulu = F4(
	function (base, formulaire, langues, languesIso) {
		var nombreDeChoix = function (suffixe) {
			return A2(
				$author$project$Components$Shared$EditeurDeSchema$Model$entier,
				A2($author$project$Components$Shared$EditeurDeSchema$Model$sousOption, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionNombreDeChoix, suffixe),
				formulaire);
		};
		var code = formulaire.JR;
		var simple = A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$eq(code)),
					$author$project$Components$Shared$EditeurDeSchema$Model$typesSimples)));
		return _Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeCalcule) ? _Utils_Tuple2(
			A2(
				$elm$core$Maybe$withDefault,
				$author$project$Components$Shared$EditeurDeSchema$Champ$Nombre,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$second,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$first,
								$elm$core$Basics$eq(
									A2($author$project$Components$Shared$EditeurDeSchema$Model$option, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionTypeDuResultat, formulaire))),
							$author$project$Components$Shared$EditeurDeSchema$Model$typesSimples)))),
			$elm$core$Maybe$Just(
				$elm$core$String$trim(
					A2($author$project$Components$Shared$EditeurDeSchema$Model$option, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionFormule, formulaire)))) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeListe) ? _Utils_Tuple2(
			$author$project$Components$Shared$EditeurDeSchema$Champ$Liste(
				$author$project$Components$Shared$EditeurDeSchema$Model$valeursDeLaListe(formulaire)),
			$elm$core$Maybe$Nothing) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeChoixMultiples) ? _Utils_Tuple2(
			$author$project$Components$Shared$EditeurDeSchema$Champ$ChoixMultiples(
				{
					Cg: nombreDeChoix('max'),
					Cx: nombreDeChoix('min'),
					Ki: $author$project$Components$Shared$EditeurDeSchema$Model$valeursDeLaListe(formulaire)
				}),
			$elm$core$Maybe$Nothing) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typePays) ? _Utils_Tuple2(
			$author$project$Components$Shared$EditeurDeSchema$Champ$Pays(
				{
					FS: _Utils_eq(
						A2($author$project$Components$Shared$EditeurDeSchema$Model$option, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionPlusieursChoix, formulaire),
						$author$project$Components$Shared$EditeurDeSchema$Model$oui)
				}),
			$elm$core$Maybe$Nothing) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeLangue) ? _Utils_Tuple2(
			$author$project$Components$Shared$EditeurDeSchema$Champ$Langue(
				{
					vC: function () {
						var _v0 = base.r0;
						if (_v0.$ === 16) {
							var enregistree = _v0.a;
							return enregistree.vC;
						} else {
							return languesIso;
						}
					}(),
					FS: _Utils_eq(
						A2($author$project$Components$Shared$EditeurDeSchema$Model$option, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionPlusieursChoix, formulaire),
						$author$project$Components$Shared$EditeurDeSchema$Model$oui)
				}),
			$elm$core$Maybe$Nothing) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeGroupe) ? _Utils_Tuple2(
			function () {
				var _v1 = base.r0;
				if (_v1.$ === 22) {
					return base.r0;
				} else {
					return $author$project$Components$Shared$EditeurDeSchema$Model$groupeVoulu(formulaire);
				}
			}(),
			$elm$core$Maybe$Nothing) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typePartiePrenante) ? _Utils_Tuple2(
			$author$project$Components$Shared$EditeurDeSchema$Champ$PartiePrenante(
				{
					r$: A2($author$project$Components$Shared$EditeurDeSchema$Model$option, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionTypeVise, formulaire)
				}),
			$elm$core$Maybe$Nothing) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeUtilisateur) ? _Utils_Tuple2($author$project$Components$Shared$EditeurDeSchema$Champ$Utilisateur, $elm$core$Maybe$Nothing) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeFichier) ? _Utils_Tuple2(
			$author$project$Components$Shared$EditeurDeSchema$Champ$Fichier(
				{
					Jn: A2($author$project$Components$Shared$EditeurDeSchema$Model$entier, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionTailleMaximale, formulaire),
					r1: A2(
						$elm$core$List$filter,
						A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
						A2(
							$elm$core$List$map,
							$elm$core$String$trim,
							A2(
								$elm$core$String$split,
								',',
								A2($author$project$Components$Shared$EditeurDeSchema$Model$option, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionTypesDeMedia, formulaire))))
				}),
			$elm$core$Maybe$Nothing) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeMesure) ? _Utils_Tuple2(
			$author$project$Components$Shared$EditeurDeSchema$Champ$AvecUnite(
				{
					iF: A2(
						$elm$core$List$filterMap,
						function (langue) {
							return A2(
								$elm$core$Maybe$map,
								$elm$core$Tuple$pair(langue),
								A2(
									$author$project$Components$Shared$EditeurDeSchema$Model$texteSaisi,
									A2($author$project$Components$Shared$EditeurDeSchema$Model$sousOption, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionAffichageParLangue, langue),
									formulaire));
						},
						langues),
					kv: A2(
						$elm$core$Maybe$withDefault,
						0,
						A2($author$project$Components$Shared$EditeurDeSchema$Model$entier, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionDecimales, formulaire)),
					Cg: A2(
						$author$project$Components$Shared$EditeurDeSchema$Model$decimal,
						A2($author$project$Components$Shared$EditeurDeSchema$Model$sousOption, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionBornesPlausibles, 'max'),
						formulaire),
					Cx: A2(
						$author$project$Components$Shared$EditeurDeSchema$Model$decimal,
						A2($author$project$Components$Shared$EditeurDeSchema$Model$sousOption, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionBornesPlausibles, 'min'),
						formulaire),
					sa: A2($author$project$Components$Shared$EditeurDeSchema$Model$option, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionUnite, formulaire)
				}),
			$elm$core$Maybe$Nothing) : _Utils_Tuple2(
			A2($elm$core$Maybe$withDefault, base.r0, simple),
			$elm$core$Maybe$Nothing))))))))));
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$champVoulu = function (saisie) {
	var parDefaut = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(saisie.Ba));
	var traduits = function (lire) {
		return A2(
			$elm$core$List$filterMap,
			function (langue) {
				return (lire(langue) === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					_Utils_Tuple2(
						langue,
						lire(langue)));
			},
			A2(
				$elm$core$List$filter,
				$elm$core$Basics$neq(parDefaut),
				$author$project$Components$Shared$EditeurDeSchema$Model$languesDesLibelles(saisie.Ba)));
	};
	var horsDesLangues = $elm$core$List$filter(
		function (_v1) {
			var langue = _v1.a;
			return !A2(
				$elm$core$List$member,
				langue,
				$author$project$Components$Shared$EditeurDeSchema$Model$languesDesLibelles(saisie.Ba));
		});
	var formulaire = saisie.zT;
	var saisies = $author$project$Components$Shared$EditeurDeSchema$Model$reglesVoulues(formulaire);
	var base = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Components$Shared$EditeurDeSchema$Champ$nouveau(
			{dy: formulaire.dy, Bl: '', r0: $author$project$Components$Shared$EditeurDeSchema$Champ$Texte}),
		saisie.lZ);
	var gardees = A2($elm$core$List$filter, $author$project$Components$Shared$EditeurDeSchema$Model$horsFormulaire, base.hJ);
	var regles = _Utils_ap(saisies, gardees);
	var aideDe = function (langue) {
		return $elm$core$String$trim(
			A2($author$project$Components$Shared$EditeurDeSchema$Model$aideSaisie, langue, formulaire));
	};
	var _v0 = A4(
		$author$project$Components$Shared$EditeurDeSchema$Model$typeVoulu,
		base,
		formulaire,
		saisie.Ba,
		$author$project$Referentiel$Normes$codesDesLangues(saisie.hd));
	var type_ = _v0.a;
	var formule = _v0.b;
	return _Utils_update(
		base,
		{
			sG: _Utils_eq(formulaire.mo, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceALaPublication),
			bp: aideDe(parDefaut),
			bq: _Utils_ap(
				traduits(aideDe),
				horsDesLangues(base.bq)),
			v6: A2($author$project$Components$Shared$EditeurDeSchema$Model$entier, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionConservation, formulaire),
			xD: A2($author$project$Components$Shared$EditeurDeSchema$Model$coche, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionDonneePersonnelle, formulaire),
			zU: formule,
			Bl: A2($author$project$Components$Shared$EditeurDeSchema$Model$libelleDe, parDefaut, saisie),
			R: _Utils_ap(
				traduits(
					function (langue) {
						return A2($author$project$Components$Shared$EditeurDeSchema$Model$libelleDe, langue, saisie);
					}),
				horsDesLangues(base.R)),
			Bt: $author$project$Components$Shared$EditeurDeSchema$Model$libellesDesValeursVoulus(saisie),
			he: _Utils_eq(formulaire.mo, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceALEnregistrement),
			hJ: A2($author$project$Components$Shared$EditeurDeSchema$Model$memesElements, regles, base.hJ) ? base.hJ : regles,
			h8: A2($author$project$Components$Shared$EditeurDeSchema$Model$coche, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionTraduisible, formulaire),
			r0: type_,
			KQ: formulaire.KQ
		});
};
var $author$project$Components$Shared$EditeurDeSchema$Model$groupeComplet = function (formulaire) {
	return ((!_Utils_eq(formulaire.JR, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeGroupe)) || ((!_Utils_eq(formulaire.IX, _List_Nil)) && _Utils_eq(
		$author$project$Components$Shared$EditeurDeSchema$SousChamps$manque(formulaire.IX),
		_List_Nil))) && ((!_Utils_eq(formulaire.JR, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typePartiePrenante)) || (A2($author$project$Components$Shared$EditeurDeSchema$Model$option, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionTypeVise, formulaire) !== ''));
};
var $author$project$Components$Shared$EditeurDeSchema$Model$resserrageRefuse = function (saisie) {
	var _v0 = saisie.F$;
	switch (_v0) {
		case 0:
			return false;
		case 1:
			return true;
		default:
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.xD;
					},
					saisie.lZ));
	}
};
var $author$project$Components$Shared$EditeurDeSchema$Model$valeursRetirees = function (saisie) {
	var gardees = function (enregistrees) {
		return A2(
			$elm$core$List$all,
			function (valeur) {
				return A2(
					$elm$core$List$member,
					valeur,
					$author$project$Components$Shared$EditeurDeSchema$Model$valeursDeLaListe(saisie.zT));
			},
			enregistrees);
	};
	var _v0 = A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.r0;
		},
		saisie.lZ);
	_v0$2:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a.$) {
				case 7:
					var valeurs = _v0.a.a;
					return !gardees(valeurs);
				case 8:
					var choix = _v0.a.a;
					return !gardees(choix.Ki);
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return false;
};
var $author$project$Components$Shared$EditeurDeSchema$Model$valide = function (saisie) {
	if (A2(
		$elm$core$List$all,
		function (langue) {
			return A2($author$project$Components$Shared$EditeurDeSchema$Model$libelleDe, langue, saisie) !== '';
		},
		A2($elm$core$List$take, 1, saisie.Ba)) && ((saisie.zT.dy !== '') && (((!_Utils_eq(saisie.lZ, $elm$core$Maybe$Nothing)) || (saisie.zT.JR !== '')) && (((!_Utils_eq(saisie.lZ, $elm$core$Maybe$Nothing)) || $author$project$Components$Shared$EditeurDeSchema$Model$groupeComplet(saisie.zT)) && (!($author$project$Components$Shared$EditeurDeSchema$Model$resserrageRefuse(saisie) && ($author$project$Components$Shared$EditeurDeSchema$Model$valeursRetirees(saisie) || (A2($author$project$Components$Shared$EditeurDeSchema$Model$borneResserree, 'min', saisie) || A2($author$project$Components$Shared$EditeurDeSchema$Model$borneResserree, 'max', saisie))))))))) {
		var champ = $author$project$Components$Shared$EditeurDeSchema$Model$champVoulu(saisie);
		var _v0 = champ.r0;
		if (_v0.$ === 16) {
			var codes = _v0.a.vC;
			return _Utils_eq(codes, _List_Nil) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(champ);
		} else {
			return $elm$core$Maybe$Just(champ);
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Shared$EditeurDeSchema$Conduite$valider = F2(
	function (reglage, model) {
		var _v0 = reglage.yW;
		if (!_v0.$) {
			var _v1 = _v0.a;
			var faireEvoluer = _v1.a;
			var lien = _v1.b;
			var _v2 = $author$project$Components$Shared$EditeurDeSchema$Model$valide(model.hP);
			if (!_v2.$) {
				var voulu = _v2.a;
				var evolution = _Utils_eq(model.hP.lZ, $elm$core$Maybe$Nothing) ? {
					fx: _List_fromArray(
						[voulu]),
					g$: _List_Nil
				} : {
					fx: _List_Nil,
					g$: _List_fromArray(
						[voulu])
				};
				var _v3 = A4(
					$author$project$API$Envoi$partir,
					reglage.l2,
					$elm$core$Maybe$Just(lien),
					faireEvoluer(evolution),
					model.l2);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var envoi = _v4.a;
					var effets = _v4.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l2: envoi,
								hP: A2($author$project$Components$Shared$EditeurDeSchema$Model$refuser, $elm$core$Maybe$Nothing, model.hP)
							}),
						effets);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			} else {
				return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hP: $author$project$Components$Shared$EditeurDeSchema$Model$tenter(model.hP)
						}),
					_List_fromArray(
						[
							reglage.FO(
							$author$project$Components$Shared$EditeurDeSchema$Conduite$idDuPremierLibelle(model))
						])) : _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Types$Update$apercuLu = F2(
	function (reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Shared$EditeurDeSchema$Resserrage$decoder, reponse);
		if (!_v0.$) {
			var resserrage = _v0.a;
			return (!_Utils_eq(model.AM.tq, $author$project$Components$Shared$EditeurDeSchema$Resserrage$ApercuDemande)) ? _Utils_Tuple2(model, _List_Nil) : (((!resserrage.oF) && (!resserrage.tW)) ? $author$project$Components$Referentiel$Types$Update$sansApercu(
				A2($author$project$Components$Referentiel$Types$Update$parLaConduite, $author$project$Components$Shared$EditeurDeSchema$Conduite$valider, model)) : _Utils_Tuple2(
				A2(
					$author$project$Components$Referentiel$Types$Update$avecLesInformations,
					function (etat) {
						return _Utils_update(
							etat,
							{
								tq: $author$project$Components$Shared$EditeurDeSchema$Resserrage$Avertit(resserrage)
							});
					},
					model),
				_List_fromArray(
					[
						$author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(
						$author$project$Components$Shared$EditeurDeSchema$Resserrage$idDeLApercu(
							$author$project$Components$Shared$Drawer$Model$idRacine(model.AM.kX)))
					])));
		} else {
			var refus = _v0.a;
			return _Utils_Tuple2(
				A2(
					$author$project$Components$Referentiel$Types$Update$avecLesInformations,
					function (etat) {
						return _Utils_update(
							etat,
							{tq: $author$project$Components$Shared$EditeurDeSchema$Resserrage$SansApercu});
					},
					model),
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Referentiel$Common$EffetDeType$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$ArchiverLeType = function (a) {
	return {$: 2, a: a};
};
var $author$project$API$NavLinksDictionary$archiver = 'archiver';
var $author$project$Components$Referentiel$Types$Model$typeConsulte = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		function ($) {
			return $.zo;
		},
		model.bA);
};
var $author$project$Components$Referentiel$Types$Model$archivage = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		function (fiche) {
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$pair(
					$author$project$Components$Referentiel$Common$API$WriteAPIModel$ArchiverLeType(fiche.r0.r8)),
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$archiver, fiche.r0.nQ));
		},
		$author$project$Components$Referentiel$Types$Model$typeConsulte(model));
};
var $author$project$Components$Referentiel$Types$Model$archives = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.nQ;
			},
			$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$avecLesArchives)),
		model.aS);
};
var $author$project$Components$Referentiel$Types$Update$avecLEditionDUneInformation = function (changer) {
	return $author$project$Components$Referentiel$Types$Update$avecLesInformations(
		function (etat) {
			return _Utils_update(
				etat,
				{
					ge: A2($elm$core$Maybe$map, changer, etat.ge)
				});
		});
};
var $author$project$Components$Referentiel$Types$Update$avecLaRapide = F2(
	function (changer, model) {
		return _Utils_update(
			model,
			{
				ki: A2($elm$core$Maybe$map, changer, model.ki)
			});
	});
var $author$project$Components$Referentiel$Types$Update$avecLeRattacher = function (changer) {
	return $author$project$Components$Referentiel$Types$Update$avecLesInformations(
		function (etat) {
			return _Utils_update(
				etat,
				{
					GZ: changer(etat.GZ)
				});
		});
};
var $author$project$Components$Referentiel$Types$Update$avecLeRattachement = function (changer) {
	return $author$project$Components$Referentiel$Types$Update$avecLeRattacher(
		function (r) {
			return _Utils_update(
				r,
				{
					pN: changer(r.pN)
				});
		});
};
var $author$project$Components$Referentiel$Types$Update$avecLeType = F2(
	function (changer, model) {
		return _Utils_update(
			model,
			{
				bA: A2($elm$core$Maybe$map, changer, model.bA)
			});
	});
var $author$project$Components$Referentiel$Common$EffetDeType$LireLeTypeRegle = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Referentiel$Types$Update$lectureDuTypeRegle = function (model) {
	var _v0 = _Utils_Tuple2(
		$author$project$Components$Referentiel$Types$Model$typeRegle(model),
		$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model));
	if ((!_v0.a.$) && (_v0.b.$ === 1)) {
		var regle = _v0.a.a;
		var _v1 = _v0.b;
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$EffetDeType$LireLeTypeRegle, $elm$core$List$singleton),
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$self, regle.nQ)));
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Referentiel$Types$Update$choisir = F2(
	function (uid, model) {
		var _v0 = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (lu) {
					return _Utils_eq(lu.r8, uid) && (!lu.tE);
				},
				$author$project$Components$Referentiel$Types$Model$types(model)));
		if (!_v0.$) {
			if (_Utils_eq(
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.r8;
					},
					$author$project$Components$Referentiel$Types$Model$typeRegle(model)),
				$elm$core$Maybe$Just(uid))) {
				return _Utils_Tuple2(model, _List_Nil);
			} else {
				var choisi = _Utils_update(
					model,
					{
						vd: $elm$core$Maybe$Just(uid),
						x1: $elm$core$Maybe$Nothing,
						gv: $elm$core$Maybe$Nothing
					});
				return _Utils_Tuple2(
					choisi,
					$author$project$Components$Referentiel$Types$Update$lectureDuTypeRegle(choisi));
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Common$RattacherUnChamp$ModeChoisi = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Types$Update$puisAvec = F2(
	function (suite, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Basics$append(effets),
			suite(model));
	});
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$ChangerLaPorteeDUnChamp = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $author$project$Components$Referentiel$Common$EnvoiDeType$partir = $author$project$API$Envoi$partir($author$project$Components$Referentiel$Common$EnvoiDeType$reglage);
var $author$project$Components$Referentiel$Types$Update$envoyerLaCommande = F3(
	function (lien, commande, model) {
		var _v0 = A3(
			$author$project$Components$Referentiel$Common$EnvoiDeType$partir,
			$elm$core$Maybe$Just(lien),
			commande,
			model.l2);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var envoi = _v1.a;
			var effets = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Types$Update$depuisLeRattachement = F2(
	function (model, _v0) {
		var rattacher = _v0.a;
		var effets = _v0.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (effet, _v1) {
					var courant = _v1.a;
					var faits = _v1.b;
					switch (effet.$) {
						case 0:
							var cible = effet.a;
							return _Utils_Tuple2(
								courant,
								_Utils_ap(
									faits,
									_List_fromArray(
										[
											$author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(cible)
										])));
						case 1:
							return _Utils_Tuple2(
								courant,
								_Utils_ap(
									faits,
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$EffetDeType$LireLaBibliotheque, $elm$core$List$singleton),
											courant.AM.nC))));
						default:
							var voulue = effet.a;
							return A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Basics$append(faits),
								A3(
									$author$project$Components$Referentiel$Types$Update$envoyerLaCommande,
									voulue.nB,
									A2($author$project$Components$Referentiel$Common$API$WriteAPIModel$ChangerLaPorteeDUnChamp, voulue.uN, voulue.F$),
									courant));
					}
				}),
			_Utils_Tuple2(
				A2(
					$author$project$Components$Referentiel$Types$Update$avecLeRattacher,
					$elm$core$Basics$always(rattacher),
					model),
				_List_Nil),
			effets);
	});
var $author$project$Components$Referentiel$Common$RattacherUnChamp$EnvoyerLaPortee = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Common$RattacherUnChamp$PlacerFocus = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Shared$Bibliotheque$Rattachement$Rattacher = 1;
var $author$project$Components$Referentiel$Common$RattacherUnChamp$avec = F2(
	function (changer, etat) {
		return _Utils_update(
			etat,
			{
				pN: changer(etat.pN)
			});
	});
var $author$project$Components$Shared$Bibliotheque$Rattachement$champ = F2(
	function (id, rattachement) {
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$filter(
					function (lu) {
						return _Utils_eq(lu.Aq, id);
					}),
				$elm$core$List$head),
			rattachement.dq);
	});
var $author$project$Components$Shared$Bibliotheque$Rattachement$choisir = F2(
	function (id, rattachement) {
		var _v0 = A2($author$project$Components$Shared$Bibliotheque$Rattachement$champ, id, rattachement);
		if (!_v0.$) {
			return _Utils_update(
				rattachement,
				{
					vd: _Utils_eq(
						rattachement.vd,
						$elm$core$Maybe$Just(id)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(id),
					pZ: $elm$core$Maybe$Nothing
				});
		} else {
			return rattachement;
		}
	});
var $author$project$Components$Referentiel$Common$RattacherUnChamp$LireLaBibliotheque = {$: 1};
var $author$project$Components$Shared$Bibliotheque$View$idDeLaRechercheDeLaBibliotheque = 'produits-type-rattachement-recherche';
var $author$project$Components$Referentiel$Common$RattacherUnChamp$choisirLeMode = F2(
	function (mode, etat) {
		return _Utils_Tuple2(
			_Utils_update(
				etat,
				{kz: $elm$core$Maybe$Nothing, n9: mode}),
			_Utils_ap(
				((mode === 1) && _Utils_eq(etat.pN.dq, $elm$core$Maybe$Nothing)) ? _List_fromArray(
					[$author$project$Components$Referentiel$Common$RattacherUnChamp$LireLaBibliotheque]) : _List_Nil,
				(mode === 1) ? _List_fromArray(
					[
						$author$project$Components$Referentiel$Common$RattacherUnChamp$PlacerFocus($author$project$Components$Shared$Bibliotheque$View$idDeLaRechercheDeLaBibliotheque)
					]) : _List_Nil));
	});
var $author$project$Components$Shared$Bibliotheque$Elargissement$confirmer = F2(
	function (confirme, elargissement) {
		return _Utils_update(
			elargissement,
			{dB: confirme, qa: false});
	});
var $author$project$API$NavLinksDictionary$changerLaPortee = 'changer-la-portee';
var $author$project$Components$Shared$Bibliotheque$Elargissement$lien = function (champ) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$changerLaPortee, champ.nQ.h0);
};
var $author$project$Components$Shared$Bibliotheque$Domaine$porteeProposee = F2(
	function (domaine, champ) {
		var _v0 = _Utils_Tuple3(champ.o4, domaine, champ.F$);
		_v0$4:
		while (true) {
			if (!_v0.a.$) {
				if (!_v0.b) {
					var _v1 = _v0.b;
					return 'catalogue';
				} else {
					var _v2 = _v0.b;
					return 'parties-prenantes';
				}
			} else {
				if (!_v0.b) {
					if (_v0.c === 'parties-prenantes') {
						var _v3 = _v0.a;
						var _v4 = _v0.b;
						return 'catalogue-et-parties-prenantes';
					} else {
						break _v0$4;
					}
				} else {
					if (_v0.c === 'catalogue') {
						var _v5 = _v0.a;
						var _v6 = _v0.b;
						return 'catalogue-et-parties-prenantes';
					} else {
						break _v0$4;
					}
				}
			}
		}
		var _v7 = _v0.a;
		var autre = _v0.c;
		return autre;
	});
var $author$project$Components$Shared$Bibliotheque$Elargissement$porteeProposee = $author$project$Components$Shared$Bibliotheque$Domaine$porteeProposee;
var $author$project$Components$Shared$Bibliotheque$Elargissement$demande = function (elargissement) {
	return elargissement.dB ? A2(
		$elm$core$Maybe$map,
		function (l) {
			return {
				uN: elargissement.uN.Aq,
				nB: l,
				F$: A2($author$project$Components$Shared$Bibliotheque$Elargissement$porteeProposee, elargissement.cC, elargissement.uN)
			};
		},
		$author$project$Components$Shared$Bibliotheque$Elargissement$lien(elargissement.uN)) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$Shared$Bibliotheque$Rattachement$exiger = F2(
	function (exigence, rattachement) {
		var reglages = rattachement.qc;
		return _Utils_update(
			rattachement,
			{
				qc: _Utils_update(
					reglages,
					{mo: exigence})
			});
	});
var $author$project$Components$Shared$Bibliotheque$Domaine$accepte = F2(
	function (domaine, portee) {
		if (!domaine) {
			return (portee === 'catalogue') || (portee === 'catalogue-et-parties-prenantes');
		} else {
			return (portee === 'parties-prenantes') || (portee === 'catalogue-et-parties-prenantes');
		}
	});
var $author$project$Components$Shared$Bibliotheque$Rattachement$rattachable = F2(
	function (domaine, lu) {
		return _Utils_eq(lu.o4, $elm$core$Maybe$Nothing) && A2($author$project$Components$Shared$Bibliotheque$Domaine$accepte, domaine, lu.F$);
	});
var $author$project$Components$Shared$Bibliotheque$Rattachement$choisiHorsPortee = function (rattachement) {
	return A2(
		$elm$core$Maybe$andThen,
		function (lu) {
			return A2($author$project$Components$Shared$Bibliotheque$Rattachement$rattachable, rattachement.cC, lu) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(lu);
		},
		A2(
			$elm$core$Maybe$andThen,
			function (id) {
				return A2($author$project$Components$Shared$Bibliotheque$Rattachement$champ, id, rattachement);
			},
			rattachement.vd));
};
var $author$project$Components$Shared$Bibliotheque$Rattachement$horsPortee = function (rattachement) {
	return (!_Utils_eq(
		$author$project$Components$Shared$Bibliotheque$Rattachement$choisiHorsPortee(rattachement),
		$elm$core$Maybe$Nothing)) || function () {
		var _v0 = rattachement.pZ;
		_v0$2:
		while (true) {
			if (!_v0.$) {
				switch (_v0.a.$) {
					case 0:
						return true;
					case 1:
						return true;
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return false;
	}();
};
var $author$project$Components$Shared$Bibliotheque$View$idDuRefusDeRattachement = 'produits-type-rattachement-refus';
var $author$project$Components$Shared$Bibliotheque$Rattachement$lire = F2(
	function (niveau, rattachement) {
		var reglages = rattachement.qc;
		return _Utils_update(
			rattachement,
			{
				qc: _Utils_update(
					reglages,
					{g4: niveau})
			});
	});
var $author$project$Components$Shared$Bibliotheque$Rattachement$masquer = F2(
	function (masque, rattachement) {
		var reglages = rattachement.qc;
		return _Utils_update(
			rattachement,
			{
				qc: _Utils_update(
					reglages,
					{n4: masque})
			});
	});
var $author$project$Components$Shared$Bibliotheque$Elargissement$peutElargir = function (champ) {
	return !_Utils_eq(
		$author$project$Components$Shared$Bibliotheque$Elargissement$lien(champ),
		$elm$core$Maybe$Nothing);
};
var $author$project$Components$Shared$Bibliotheque$Elargissement$ouvrir = F3(
	function (domaine, id, champs) {
		return A2(
			$elm$core$Maybe$map,
			function (champ) {
				return {uN: champ, dB: false, cC: domaine, qa: false};
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (champ) {
						return _Utils_eq(champ.Aq, id) && $author$project$Components$Shared$Bibliotheque$Elargissement$peutElargir(champ);
					},
					champs)));
	});
var $author$project$Components$Shared$Bibliotheque$Rattachement$personnelle = F2(
	function (donneePersonnelle, rattachement) {
		var reglages = rattachement.qc;
		return _Utils_update(
			rattachement,
			{
				qc: _Utils_update(
					reglages,
					{xD: donneePersonnelle})
			});
	});
var $author$project$Components$Shared$Bibliotheque$Rattachement$saisirLaRecherche = F2(
	function (texte, rattachement) {
		return _Utils_update(
			rattachement,
			{hC: texte});
	});
var $author$project$Components$Referentiel$Common$RattacherUnChamp$versLElargissement = F2(
	function (geste, etat) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					etat,
					{lx: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var vers = _v0;
					return $author$project$Components$Referentiel$Common$RattacherUnChamp$PlacerFocus(vers);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				etat.lx));
	});
var $author$project$Components$Referentiel$Common$RattacherUnChamp$update = F2(
	function (msg, etat) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(etat, _List_Nil);
			case 1:
				var mode = msg.a;
				return A2($author$project$Components$Referentiel$Common$RattacherUnChamp$choisirLeMode, mode, etat);
			case 2:
				var texte = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Common$RattacherUnChamp$avec,
						$author$project$Components$Shared$Bibliotheque$Rattachement$saisirLaRecherche(texte),
						etat),
					_List_Nil);
			case 3:
				var id = msg.a;
				var choisi = A2($author$project$Components$Shared$Bibliotheque$Rattachement$choisir, id, etat.pN);
				return _Utils_Tuple2(
					_Utils_update(
						etat,
						{pN: choisi}),
					$author$project$Components$Shared$Bibliotheque$Rattachement$horsPortee(choisi) ? _List_fromArray(
						[
							$author$project$Components$Referentiel$Common$RattacherUnChamp$PlacerFocus($author$project$Components$Shared$Bibliotheque$View$idDuRefusDeRattachement)
						]) : _List_Nil);
			case 4:
				var exigence = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Common$RattacherUnChamp$avec,
						$author$project$Components$Shared$Bibliotheque$Rattachement$exiger(exigence),
						etat),
					_List_Nil);
			case 5:
				var niveau = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Common$RattacherUnChamp$avec,
						$author$project$Components$Shared$Bibliotheque$Rattachement$lire(niveau),
						etat),
					_List_Nil);
			case 6:
				var masque = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Common$RattacherUnChamp$avec,
						$author$project$Components$Shared$Bibliotheque$Rattachement$masquer(masque),
						etat),
					_List_Nil);
			case 7:
				var personnelle = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Common$RattacherUnChamp$avec,
						$author$project$Components$Shared$Bibliotheque$Rattachement$personnelle(personnelle),
						etat),
					_List_Nil);
			case 8:
				var id = msg.a;
				return A2(
					$author$project$Components$Referentiel$Common$RattacherUnChamp$choisirLeMode,
					1,
					A2(
						$author$project$Components$Referentiel$Common$RattacherUnChamp$avec,
						function (r) {
							return _Utils_update(
								r,
								{
									vd: $elm$core$Maybe$Just(id),
									pZ: $elm$core$Maybe$Nothing
								});
						},
						etat));
			case 9:
				var champ = msg.a;
				var ouvreur = msg.b;
				var _v1 = A2(
					$elm$core$Maybe$andThen,
					A2($author$project$Components$Shared$Bibliotheque$Elargissement$ouvrir, etat.pN.cC, champ),
					etat.pN.dq);
				if (!_v1.$) {
					var elargissement = _v1.a;
					return A2(
						$author$project$Components$Referentiel$Common$RattacherUnChamp$versLElargissement,
						$author$project$Components$Shared$Drawer$Update$Ouvrir(ouvreur),
						_Utils_update(
							etat,
							{
								lP: $elm$core$Maybe$Just(elargissement)
							}));
				} else {
					return _Utils_Tuple2(etat, _List_Nil);
				}
			case 10:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Common$RattacherUnChamp$versLElargissement, geste, etat);
			case 11:
				var confirme = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						etat,
						{
							lP: A2(
								$elm$core$Maybe$map,
								$author$project$Components$Shared$Bibliotheque$Elargissement$confirmer(confirme),
								etat.lP)
						}),
					_List_Nil);
			default:
				var _v2 = A2($elm$core$Maybe$andThen, $author$project$Components$Shared$Bibliotheque$Elargissement$demande, etat.lP);
				if (!_v2.$) {
					var voulue = _v2.a;
					return _Utils_Tuple2(
						etat,
						_List_fromArray(
							[
								$author$project$Components$Referentiel$Common$RattacherUnChamp$EnvoyerLaPortee(voulue)
							]));
				} else {
					return _Utils_Tuple2(etat, _List_Nil);
				}
		}
	});
var $author$project$Components$Referentiel$Types$Update$surLeRattachement = F2(
	function (geste, model) {
		return A2(
			$author$project$Components$Referentiel$Types$Update$depuisLeRattachement,
			model,
			A2($author$project$Components$Referentiel$Common$RattacherUnChamp$update, geste, model.AM.GZ));
	});
var $author$project$Components$Referentiel$Types$Update$choisirLeModeDeLAjout = F2(
	function (mode, model) {
		return ((!mode) && $author$project$Components$Referentiel$Types$Update$offreLeNouveauChamp(model)) ? A2(
			$author$project$Components$Referentiel$Types$Update$puisAvec,
			$author$project$Components$Referentiel$Types$Update$demanderLeNouveauChamp,
			A2(
				$author$project$Components$Referentiel$Types$Update$parLaConduite,
				function (reglage) {
					return A2($author$project$Components$Shared$EditeurDeSchema$Conduite$versLeDrawer, reglage, $author$project$Components$Shared$Drawer$Update$Fermer);
				},
				model)) : A2(
			$author$project$Components$Referentiel$Types$Update$surLeRattachement,
			$author$project$Components$Referentiel$Common$RattacherUnChamp$ModeChoisi(mode),
			model);
	});
var $author$project$Components$Referentiel$Common$ChoixDesOffres$cocher = F3(
	function (offre, coche, coches) {
		return coche ? (A2($elm$core$List$member, offre, coches) ? coches : _Utils_ap(
			coches,
			_List_fromArray(
				[offre]))) : A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(offre),
			coches);
	});
var $author$project$Components$Referentiel$Types$CreationRapide$Creee = {$: 0};
var $author$project$Components$Referentiel$Types$CreationRapide$surLaLigne = F3(
	function (archetype, changer, etat) {
		return _Utils_update(
			etat,
			{
				gV: A2(
					$elm$core$List$map,
					function (ligne) {
						return _Utils_eq(ligne.fA, archetype) ? changer(ligne) : ligne;
					},
					etat.gV)
			});
	});
var $author$project$Components$Referentiel$Types$CreationRapide$cocher = F2(
	function (archetype, coche) {
		return A2(
			$author$project$Components$Referentiel$Types$CreationRapide$surLaLigne,
			archetype,
			function (ligne) {
				return _Utils_eq(
					ligne.nh,
					$elm$core$Maybe$Just($author$project$Components$Referentiel$Types$CreationRapide$Creee)) ? ligne : _Utils_update(
					ligne,
					{vt: coche});
			});
	});
var $author$project$Components$Shared$Bibliotheque$Restriction$transmise = F2(
	function (id, restriction) {
		return A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Set$member(id),
				restriction.JP));
	});
var $author$project$Components$Shared$Bibliotheque$Restriction$cocher = F3(
	function (id, oui, restriction) {
		return (!A2($author$project$Components$Shared$Bibliotheque$Restriction$transmise, id, restriction)) ? restriction : _Utils_update(
			restriction,
			{
				L: oui ? A2($elm$core$Set$insert, id, restriction.L) : A2($elm$core$Set$remove, id, restriction.L),
				gH: $elm$core$Maybe$Nothing,
				qa: false,
				eN: $elm$core$Maybe$Nothing,
				fo: $elm$core$Maybe$Nothing
			});
	});
var $author$project$Components$Referentiel$Types$RestrictionDuChamp$cocher = F2(
	function (id, oui) {
		return $author$project$Components$Referentiel$Types$RestrictionDuChamp$surLEtat(
			A2($author$project$Components$Shared$Bibliotheque$Restriction$cocher, id, oui));
	});
var $author$project$API$NavLinksDictionary$collectionsDeChamps = 'collections-de-champs';
var $author$project$Components$Parametrage$CollectionsDeChamps$API$QueryAPIModel$Collections = F2(
	function (collections, liens) {
		return {vE: collections, nQ: liens};
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$API$QueryAPIModel$Collection = F9(
	function (id, cle, libelle, libelles, portee, membres, typesPorteurs, champs, liens) {
		return {dw: champs, dy: cle, Aq: id, Bl: libelle, R: libelles, nQ: liens, Cm: membres, F$: portee, J3: typesPorteurs};
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$API$QueryAPIModel$ChampRange = F3(
	function (id, cle, libelle) {
		return {dy: cle, Aq: id, Bl: libelle};
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$API$QueryAPIModel$champDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'libelle',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'cle',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$CollectionsDeChamps$API$QueryAPIModel$ChampRange))));
var $author$project$Components$Parametrage$CollectionsDeChamps$API$QueryAPIModel$DesPartiesPrenantes = 1;
var $author$project$Components$Parametrage$CollectionsDeChamps$API$QueryAPIModel$porteeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (code) {
		switch (code) {
			case 'catalogue':
				return $elm$json$Json$Decode$succeed(0);
			case 'parties-prenantes':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail(code);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$Parametrage$CollectionsDeChamps$API$QueryAPIModel$collectionDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'champs',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$CollectionsDeChamps$API$QueryAPIModel$champDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'typesPorteurs',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'membres',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'portee',
					$author$project$Components$Parametrage$CollectionsDeChamps$API$QueryAPIModel$porteeDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'libelles',
						$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'libelle',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'cle',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$CollectionsDeChamps$API$QueryAPIModel$Collection))))))))));
var $author$project$Components$Parametrage$CollectionsDeChamps$API$QueryAPIModel$collectionsDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'collections',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$CollectionsDeChamps$API$QueryAPIModel$collectionDecoder),
		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$CollectionsDeChamps$API$QueryAPIModel$Collections)));
var $author$project$Components$Referentiel$Types$Model$cocher = F4(
	function (ordre, valeur, coche, cochees) {
		return coche ? A2(
			$elm$core$List$filter,
			function (une) {
				return _Utils_eq(une, valeur) || A2($elm$core$List$member, une, cochees);
			},
			ordre) : (_Utils_eq(
			cochees,
			_List_fromArray(
				[valeur])) ? cochees : A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(valeur),
			cochees));
	});
var $author$project$Components$Referentiel$Types$Model$cocherNature = F3(
	function (nature, coche, cases) {
		return _Utils_update(
			cases,
			{
				oo: A4($author$project$Components$Referentiel$Types$Model$cocher, $author$project$Components$Referentiel$Admission$natures, nature, coche, cases.oo)
			});
	});
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$RestreindreLaNature = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Types$Model$casesDuType = function (fiche) {
	return {
		oo: A2(
			$elm$core$List$filter,
			function (nature) {
				return A2($elm$core$List$member, nature, fiche.oo);
			},
			$author$project$Components$Referentiel$Admission$natures),
		GG: A2(
			$elm$core$List$filter,
			function (qualite) {
				return A2($elm$core$List$member, qualite, fiche.GG);
			},
			$author$project$Components$Referentiel$Admission$qualites)
	};
};
var $author$project$API$NavLinksDictionary$restreindreNature = 'restreindre-nature';
var $author$project$Components$Referentiel$Types$Model$restriction = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.r0;
			},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$restreindreNature))),
		$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model));
};
var $author$project$Components$Referentiel$Types$Model$commandeDesCases = F2(
	function (changer, model) {
		var _v0 = _Utils_Tuple2(
			$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model),
			$author$project$Components$Referentiel$Types$Model$restriction(model));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var fiche = _v0.a.a;
			var lien = _v0.b.a;
			var lues = $author$project$Components$Referentiel$Types$Model$casesDuType(fiche);
			var voulues = changer(lues);
			return _Utils_eq(voulues, lues) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				_Utils_Tuple2(
					A3($author$project$Components$Referentiel$Common$API$WriteAPIModel$RestreindreLaNature, fiche.r0.r8, voulues.oo, voulues.GG),
					lien));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Referentiel$Types$Model$commandeDeNature = F2(
	function (nature, coche) {
		return $author$project$Components$Referentiel$Types$Model$commandeDesCases(
			A2($author$project$Components$Referentiel$Types$Model$cocherNature, nature, coche));
	});
var $author$project$Components$Referentiel$Types$Model$cocherQualite = F3(
	function (qualite, coche, cases) {
		return _Utils_update(
			cases,
			{
				GG: A4($author$project$Components$Referentiel$Types$Model$cocher, $author$project$Components$Referentiel$Admission$qualites, qualite, coche, cases.GG)
			});
	});
var $author$project$Components$Referentiel$Types$Model$commandeDeQualite = F2(
	function (qualite, coche) {
		return $author$project$Components$Referentiel$Types$Model$commandeDesCases(
			A2($author$project$Components$Referentiel$Types$Model$cocherQualite, qualite, coche));
	});
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$LimiterAuxOffres = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$API$NavLinksDictionary$limiterAuxOffres = 'limiter-aux-offres';
var $author$project$Components$Referentiel$Types$Offres$lienDeLaLimite = function (fiche) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$limiterAuxOffres, fiche.r0.nQ);
};
var $author$project$Components$Referentiel$Common$Offres$toutes = function (lecture) {
	if (lecture.$ === 1) {
		var offres = lecture.a;
		return offres;
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Referentiel$Common$ChoixDesOffres$nouvelles = F2(
	function (saisie, choisies) {
		return A2(
			$elm$core$List$map,
			function (o) {
				return {tL: false, uK: o.uK, Aq: o.Aq, Dj: o.Dj};
			},
			A2(
				$elm$core$List$filter,
				function (o) {
					return !A2(
						$elm$core$List$any,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(o.Aq)),
						choisies);
				},
				A2(
					$elm$core$List$filter,
					function (o) {
						return A2($elm$core$List$member, o.Aq, saisie.at) && (!o.tL);
					},
					$author$project$Components$Referentiel$Common$Offres$toutes(saisie.D3))));
	});
var $author$project$Components$Referentiel$Common$ChoixDesOffres$voulues = F2(
	function (saisie, choisies) {
		return _Utils_ap(
			A2(
				$elm$core$List$filter,
				function (o) {
					return o.tL || A2($elm$core$List$member, o.Aq, saisie.at);
				},
				choisies),
			A2($author$project$Components$Referentiel$Common$ChoixDesOffres$nouvelles, saisie, choisies));
	});
var $author$project$Components$Referentiel$Types$Offres$commandeDesOffresVoulues = F2(
	function (choix, fiche) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$Components$Referentiel$Common$ChoixDesOffres$voulues, choix, fiche.D3),
			fiche.E9);
		if ((!_v0.a.b) && (_v0.b.$ === 1)) {
			var _v1 = _v0.b;
			return $elm$core$Maybe$Nothing;
		} else {
			var voulues = _v0.a;
			var perimetre = _v0.b;
			return A2(
				$elm$core$Maybe$map,
				function (lien) {
					return _Utils_Tuple2(
						A3(
							$author$project$Components$Referentiel$Common$API$WriteAPIModel$LimiterAuxOffres,
							fiche.r0.r8,
							voulues,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.r8;
								},
								perimetre)),
						lien);
				},
				$author$project$Components$Referentiel$Types$Offres$lienDeLaLimite(fiche));
		}
	});
var $author$project$Components$Referentiel$Types$Offres$commandeDuPerimetre = F2(
	function (perimetre, fiche) {
		return A2(
			$elm$core$Maybe$map,
			function (lien) {
				return _Utils_Tuple2(
					A3(
						$author$project$Components$Referentiel$Common$API$WriteAPIModel$LimiterAuxOffres,
						fiche.r0.r8,
						fiche.D3,
						$elm$core$Maybe$Just(perimetre)),
					lien);
			},
			$author$project$Components$Referentiel$Types$Offres$lienDeLaLimite(fiche));
	});
var $author$project$Components$Referentiel$Types$Offres$commandeSansPerimetre = function (fiche) {
	var _v0 = _Utils_Tuple2(fiche.D3, fiche.E9);
	if (_v0.a.b && (!_v0.b.$)) {
		var _v1 = _v0.a;
		return A2(
			$elm$core$Maybe$map,
			function (lien) {
				return _Utils_Tuple2(
					A3($author$project$Components$Referentiel$Common$API$WriteAPIModel$LimiterAuxOffres, fiche.r0.r8, fiche.D3, $elm$core$Maybe$Nothing),
					lien);
			},
			$author$project$Components$Referentiel$Types$Offres$lienDeLaLimite(fiche));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Common$EnvoiDeType$conclure = $author$project$API$Envoi$conclure($author$project$Components$Referentiel$Common$EnvoiDeType$reglage);
var $author$project$Components$Shared$EditeurDeSchema$Conduite$Aboutie = {$: 0};
var $author$project$Components$Shared$EditeurDeSchema$Model$AutreRefus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Conduite$Refusee = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Conduite$SessionEchue = {$: 2};
var $author$project$Components$Shared$OrdreDesBlocs$Model$abouti = function (model) {
	return _Utils_update(
		model,
		{Q: _List_Nil, B0: $elm$core$Maybe$Nothing, El: _List_Nil, qx: false});
};
var $author$project$Components$Referentiel$Common$RattacherUnChamp$champDejaDansLaBibliotheque = F2(
	function (id, etat) {
		return _Utils_Tuple2(
			_Utils_update(
				etat,
				{
					kz: $elm$core$Maybe$Just(id)
				}),
			_Utils_eq(etat.pN.dq, $elm$core$Maybe$Nothing) ? _List_fromArray(
				[$author$project$Components$Referentiel$Common$RattacherUnChamp$LireLaBibliotheque]) : _List_Nil);
	});
var $author$project$Components$Shared$Bibliotheque$Rattachement$HorsPortee = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$Common$RattacherUnChamp$horsPortee = F2(
	function (refuse, etat) {
		return _Utils_Tuple2(
			A2(
				$author$project$Components$Referentiel$Common$RattacherUnChamp$avec,
				function (r) {
					return _Utils_update(
						r,
						{
							vd: $elm$core$Maybe$Just(refuse.uN),
							pZ: $elm$core$Maybe$Just(
								$author$project$Components$Shared$Bibliotheque$Rattachement$HorsPortee(refuse))
						});
				},
				etat),
			_List_fromArray(
				[
					$author$project$Components$Referentiel$Common$RattacherUnChamp$PlacerFocus($author$project$Components$Shared$Bibliotheque$View$idDuRefusDeRattachement)
				]));
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$EvolutionNonAdditive = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Model$SchemaInvalide = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Shared$Bibliotheque$ElargissementDeListe$codeDeLaPortee = function (portee) {
	switch (portee) {
		case 'Catalogue':
			return 'catalogue';
		case 'PartiesPrenantes':
			return 'parties-prenantes';
		default:
			return 'catalogue-et-parties-prenantes';
	}
};
var $author$project$Components$Shared$Bibliotheque$ElargissementDeListe$depuisLeRefus = function (refus) {
	return A2(
		$elm$core$Maybe$map,
		function (lien) {
			return {
				dB: false,
				nB: lien,
				nW: refus.nW,
				F$: $author$project$Components$Shared$Bibliotheque$ElargissementDeListe$codeDeLaPortee(refus.F$),
				qa: false
			};
		},
		refus.nh);
};
var $author$project$Components$Referentiel$Types$Update$avecLaListeHorsPortee = F2(
	function (erreur, model) {
		return A2(
			$author$project$Components$Referentiel$Types$Update$avecLesInformations,
			function (etat) {
				return _Utils_update(
					etat,
					{
						gf: function () {
							if (erreur.$ === 26) {
								var refus = erreur.a;
								return $author$project$Components$Shared$Bibliotheque$ElargissementDeListe$depuisLeRefus(refus);
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}()
					});
			},
			model);
	});
var $author$project$I18n$Textes$bibliothequeListeElargirHorsPortee = A3($author$project$I18n$Traductions$texte, 'bibliotheque.liste.elargir.hors-portee', _List_Nil, 'Cette liste n\'est pas proposée aux types de partie prenante : sa portée ne les couvre pas. Élargissez sa portée, puis enregistrez de nouveau.');
var $author$project$Components$Shared$EditeurDeSchema$Model$avecLesNormes = F2(
	function (normes, saisie) {
		return _Utils_update(
			saisie,
			{hd: normes});
	});
var $author$project$Components$Shared$EditeurDeSchema$Conduite$defaire = F2(
	function (reglage, model) {
		var _v0 = model.o2;
		if (!_v0.$) {
			var precedents = _v0.a;
			return A2(
				reglage.s1,
				precedents,
				_Utils_update(
					model,
					{
						iP: $author$project$I18n$Traductions$tel(''),
						o2: $elm$core$Maybe$Nothing
					}));
		} else {
			return model;
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$View$idDuRefus = function (prefixe) {
	return prefixe + '-refus';
};
var $author$project$Components$Shared$EditeurDeSchema$Conduite$conclure = F3(
	function (reglage, issue, model) {
		var dansLeDrawer = $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX);
		switch (issue.$) {
			case 0:
				var apres = _Utils_update(
					model,
					{
						o2: $elm$core$Maybe$Nothing,
						hP: A2(
							$author$project$Components$Shared$EditeurDeSchema$Model$dansLaPortee,
							reglage.F$,
							A2(
								$author$project$Components$Shared$EditeurDeSchema$Model$avecLesNormes,
								reglage.hd,
								$author$project$Components$Shared$EditeurDeSchema$Model$ajout(_List_Nil)))
					});
				return dansLeDrawer ? A3($author$project$Components$Shared$EditeurDeSchema$Conduite$versLeDrawer, reglage, $author$project$Components$Shared$Drawer$Update$Fermer, apres) : _Utils_Tuple2(apres, _List_Nil);
			case 1:
				var refus = issue.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Shared$EditeurDeSchema$Conduite$defaire,
						reglage,
						dansLeDrawer ? _Utils_update(
							model,
							{
								hP: A2(
									$author$project$Components$Shared$EditeurDeSchema$Model$refuser,
									$elm$core$Maybe$Just(refus),
									model.hP)
							}) : model),
					(dansLeDrawer && (!_Utils_eq(refus, $author$project$Components$Shared$EditeurDeSchema$Model$CleDejaUtilisee))) ? _List_fromArray(
						[
							reglage.FO(
							$author$project$Components$Shared$EditeurDeSchema$View$idDuRefus(
								$author$project$Components$Shared$Drawer$Model$idRacine(model.kX)))
						]) : _List_Nil);
			default:
				return _Utils_Tuple2(
					A2($author$project$Components$Shared$EditeurDeSchema$Conduite$defaire, reglage, model),
					_List_Nil);
		}
	});
var $author$project$I18n$Textes$referentielTypeConcurrente = A3($author$project$I18n$Traductions$texte, 'referentiel.type.concurrente', _List_Nil, 'Ce type a été modifié.');
var $author$project$I18n$Textes$referentielTypeErreurArchive = A3($author$project$I18n$Traductions$texte, 'referentiel.type.erreur.archive', _List_Nil, 'Ce type est archivé : la fiche vient d\'être relue.');
var $author$project$I18n$Textes$referentielTypesErreurDefinitionPartagee = A3($author$project$I18n$Traductions$texte, 'referentiel.types.erreur.definition-partagee', _List_Nil, 'La définition de ce champ est partagée : elle se modifie dans la bibliothèque, pas depuis ce type.');
var $author$project$Components$Referentiel$Types$Update$relectureDuTypeRegle = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$EffetDeType$LireLeTypeRegle, $elm$core$List$singleton),
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nQ;
					},
					$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$self)),
				$author$project$Components$Referentiel$Types$Model$typeRegle(model))));
};
var $author$project$Components$Referentiel$Types$Update$relireLeTypeRegleApresLaCommande = function (model) {
	var _v0 = $author$project$Components$Referentiel$Types$Update$relectureDuTypeRegle(model);
	if (!_v0.b) {
		return _Utils_Tuple2(model, _List_Nil);
	} else {
		var effets = _v0;
		return model.mz ? _Utils_Tuple2(model, effets) : _Utils_Tuple2(
			_Utils_update(
				model,
				{mz: true, Hv: model.Hv + 1}),
			effets);
	}
};
var $author$project$Components$Referentiel$Types$Update$informationRefusee = F3(
	function (refus, erreur, model) {
		var perime = A2(
			$elm$core$List$member,
			erreur,
			_List_fromArray(
				[$author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$TypeDejaArchive, $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$EcritureConcurrente, $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$Introuvable, $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$ChampInconnu, $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$OrdreInvalide]));
		var message = function (texte) {
			return $author$project$Components$Shared$EditeurDeSchema$Model$AutreRefus(
				{Jx: texte, b9: refus.b9});
		};
		var refusDuDrawer = function () {
			switch (erreur.$) {
				case 15:
					return $author$project$Components$Shared$EditeurDeSchema$Model$CleDejaUtilisee;
				case 16:
					var raison = erreur.a;
					return $author$project$Components$Shared$EditeurDeSchema$Model$EvolutionNonAdditive(raison);
				case 17:
					var defauts = erreur.a;
					return $author$project$Components$Shared$EditeurDeSchema$Model$SchemaInvalide(defauts);
				case 1:
					return message($author$project$I18n$Textes$referentielTypeErreurArchive);
				case 6:
					return message($author$project$I18n$Textes$referentielTypeConcurrente);
				case 25:
					return message($author$project$I18n$Textes$referentielTypesErreurDefinitionPartagee);
				case 26:
					return message($author$project$I18n$Textes$bibliothequeListeElargirHorsPortee);
				default:
					return $author$project$Components$Shared$EditeurDeSchema$Model$AutreRefus(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
			}
		}();
		return A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$Referentiel$Types$Update$avecLaListeHorsPortee(erreur),
			A2(
				$author$project$Components$Referentiel$Types$Update$puisAvec,
				perime ? $author$project$Components$Referentiel$Types$Update$relireLeTypeRegleApresLaCommande : function (inchange) {
					return _Utils_Tuple2(inchange, _List_Nil);
				},
				A2(
					$author$project$Components$Referentiel$Types$Update$parLaConduite,
					function (reglage) {
						return A2(
							$author$project$Components$Shared$EditeurDeSchema$Conduite$conclure,
							reglage,
							$author$project$Components$Shared$EditeurDeSchema$Conduite$Refusee(refusDuDrawer));
					},
					model)));
	});
var $author$project$Components$Referentiel$Types$Update$ajoutRefuse = F3(
	function (refus, erreur, model) {
		switch (erreur.$) {
			case 23:
				var id = erreur.a;
				return A2(
					$author$project$Components$Referentiel$Types$Update$depuisLeRattachement,
					model,
					A2($author$project$Components$Referentiel$Common$RattacherUnChamp$champDejaDansLaBibliotheque, id, model.AM.GZ));
			case 24:
				var refuse = erreur.a;
				return A2(
					$author$project$Components$Referentiel$Types$Update$depuisLeRattachement,
					model,
					A2(
						$author$project$Components$Referentiel$Common$RattacherUnChamp$horsPortee,
						{uN: refuse.uN, F$: refuse.F$},
						model.AM.GZ));
			default:
				return A3($author$project$Components$Referentiel$Types$Update$informationRefusee, refus, erreur, model);
		}
	});
var $author$project$I18n$Textes$referentielTypesErreurRejeu = A3($author$project$I18n$Traductions$texte, 'referentiel.types.erreur.rejeu', _List_Nil, 'Une modification précédente avait déjà été enregistrée : votre dernière modification n\'a pas été appliquée. Vérifiez, puis recommencez.');
var $author$project$Components$Referentiel$Types$Update$ajoutRejoue = function (model) {
	return A2(
		$author$project$Components$Referentiel$Types$Update$puisAvec,
		$author$project$Components$Referentiel$Types$Update$relireLeTypeRegleApresLaCommande,
		A2(
			$author$project$Components$Referentiel$Types$Update$parLaConduite,
			function (reglage) {
				return A2(
					$author$project$Components$Shared$EditeurDeSchema$Conduite$conclure,
					reglage,
					$author$project$Components$Shared$EditeurDeSchema$Conduite$Refusee(
						$author$project$Components$Shared$EditeurDeSchema$Model$AutreRefus(
							{Jx: $author$project$I18n$Textes$referentielTypesErreurRejeu, b9: $elm$core$Maybe$Nothing})));
			},
			model));
};
var $author$project$Components$Referentiel$Types$Model$ajouter = F2(
	function (rendue, model) {
		var crees = A2(
			$elm$core$List$filterMap,
			function (evenement) {
				if (!evenement.$) {
					var uid = evenement.a;
					var archetype = evenement.b;
					var apparence = evenement.c;
					return $elm$core$Maybe$Just(
						{fA: archetype, tE: false, kf: apparence.kf, gF: _List_Nil, aC: apparence.aC, R: apparence.R, nQ: rendue.nQ, Id: 0, r8: uid});
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			rendue.mk);
		var nouveaux = function (annuaire) {
			return A2(
				$elm$core$List$filter,
				function (cree) {
					return !A2(
						$elm$core$List$any,
						function (lu) {
							return _Utils_eq(lu.r8, cree.r8);
						},
						annuaire.ib);
				},
				crees);
		};
		return _Utils_update(
			model,
			{
				aS: A2(
					$elm$core$Maybe$map,
					function (annuaire) {
						return _Utils_update(
							annuaire,
							{
								ib: _Utils_ap(
									annuaire.ib,
									nouveaux(annuaire))
							});
					},
					model.aS)
			});
	});
var $author$project$Components$Referentiel$Common$TypeApresCommande$changer = F2(
	function (evenement, lu) {
		var libelles = lu.R;
		switch (evenement.$) {
			case 1:
				var fr = evenement.a;
				return _Utils_update(
					lu,
					{
						R: _Utils_update(
							libelles,
							{zX: fr})
					});
			case 2:
				var en = evenement.a;
				return _Utils_update(
					lu,
					{
						R: _Utils_update(
							libelles,
							{yg: en})
					});
			case 3:
				var icone = evenement.a;
				return _Utils_update(
					lu,
					{aC: icone});
			case 4:
				var couleur = evenement.a;
				return _Utils_update(
					lu,
					{kf: couleur});
			case 5:
				return _Utils_update(
					lu,
					{tE: true});
			case 6:
				return _Utils_update(
					lu,
					{tE: false});
			default:
				return lu;
		}
	});
var $author$project$Components$Referentiel$Common$TypeApresCommande$appliquer = F2(
	function (evenements, lu) {
		return A3($elm$core$List$foldl, $author$project$Components$Referentiel$Common$TypeApresCommande$changer, lu, evenements);
	});
var $author$project$Components$Referentiel$Types$Model$appliquer = F2(
	function (rendue, model) {
		var uid = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.r8;
			},
			model.bA);
		var surLaPastille = function (lu) {
			return _Utils_eq(
				$elm$core$Maybe$Just(lu.r8),
				uid) ? A2($author$project$Components$Referentiel$Common$TypeApresCommande$appliquer, rendue.mk, lu) : lu;
		};
		var surLaFiche = function (fiche) {
			var lu = fiche.r0;
			return _Utils_update(
				fiche,
				{
					r0: A2(
						$author$project$Components$Referentiel$Common$TypeApresCommande$appliquer,
						rendue.mk,
						_Utils_update(
							lu,
							{nQ: rendue.nQ}))
				});
		};
		return _Utils_update(
			model,
			{
				aS: A2(
					$elm$core$Maybe$map,
					function (annuaire) {
						return _Utils_update(
							annuaire,
							{
								ib: A2($elm$core$List$map, surLaPastille, annuaire.ib)
							});
					},
					model.aS),
				bA: A2(
					$elm$core$Maybe$map,
					function (consulte) {
						return _Utils_update(
							consulte,
							{
								zo: A2($elm$core$Maybe$map, surLaFiche, consulte.zo)
							});
					},
					model.bA)
			});
	});
var $author$project$Components$Referentiel$Types$Update$apresLaCommande = F2(
	function (rendue, model) {
		return rendue.sy ? model : _Utils_update(
			model,
			{Hv: model.Hv + 1});
	});
var $author$project$Components$Referentiel$Types$Update$avecLEdition = F2(
	function (changer, model) {
		return _Utils_update(
			model,
			{
				ge: A2($elm$core$Maybe$map, changer, model.ge)
			});
	});
var $author$project$Components$Referentiel$Types$Chemin$appliquerAuResultat = F2(
	function (evenement, resultats) {
		var sur = F2(
			function (id, changer) {
				return A2(
					$elm$core$List$map,
					function (resultat) {
						return _Utils_eq(resultat.Aq, id) ? changer(resultat) : resultat;
					},
					resultats);
			});
		switch (evenement.$) {
			case 17:
				var id = evenement.a;
				var libelles = evenement.b;
				return _Utils_ap(
					resultats,
					_List_fromArray(
						[
							{
							Aq: id,
							R: $elm$core$Maybe$Just(libelles),
							HZ: false,
							rv: false
						}
						]));
			case 18:
				var id = evenement.a;
				var libelles = evenement.b;
				return A2(
					sur,
					id,
					function (resultat) {
						return _Utils_update(
							resultat,
							{
								R: $elm$core$Maybe$Just(libelles)
							});
					});
			case 19:
				var id = evenement.a;
				return A2(
					sur,
					id,
					function (resultat) {
						return _Utils_update(
							resultat,
							{HZ: true});
					});
			case 20:
				var id = evenement.a;
				return A2(
					sur,
					id,
					function (resultat) {
						return _Utils_update(
							resultat,
							{HZ: false});
					});
			default:
				return resultats;
		}
	});
var $author$project$Components$Referentiel$Types$Chemin$appliquerAuStatut = F2(
	function (evenement, statuts) {
		var sur = F2(
			function (id, changer) {
				return A2(
					$elm$core$List$map,
					function (statut) {
						return _Utils_eq(statut.Aq, id) ? changer(statut) : statut;
					},
					statuts);
			});
		switch (evenement.$) {
			case 11:
				var id = evenement.a;
				var libelles = evenement.b;
				return _Utils_ap(
					statuts,
					_List_fromArray(
						[
							{Aq: id, AO: false, R: libelles, HZ: false, Kg: 0}
						]));
			case 12:
				var id = evenement.a;
				var libelles = evenement.b;
				return A2(
					sur,
					id,
					function (statut) {
						return _Utils_update(
							statut,
							{R: libelles});
					});
			case 13:
				var id = evenement.a;
				return A2(
					sur,
					id,
					function (statut) {
						return _Utils_update(
							statut,
							{HZ: true});
					});
			case 14:
				var id = evenement.a;
				return A2(
					sur,
					id,
					function (statut) {
						return _Utils_update(
							statut,
							{HZ: false});
					});
			case 16:
				var id = evenement.a;
				return A2(
					$elm$core$List$map,
					function (statut) {
						return _Utils_update(
							statut,
							{
								AO: _Utils_eq(statut.Aq, id)
							});
					},
					statuts);
			default:
				return statuts;
		}
	});
var $author$project$Components$Referentiel$Types$Chemin$ranger = F3(
	function (voulusRanges, ajoutes, elements) {
		var trouver = function (id) {
			return A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Aq;
					},
					$elm$core$Basics$eq(id)),
				elements);
		};
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (voulu, _v1) {
					var faits = _v1.a;
					var restants = _v1.b;
					var _v2 = voulu.Aq;
					if (!_v2.$) {
						var id = _v2.a;
						return _Utils_Tuple2(
							_Utils_ap(
								faits,
								_List_fromArray(
									[id])),
							restants);
					} else {
						if (restants.b) {
							var tire = restants.a;
							var suivants = restants.b;
							return _Utils_Tuple2(
								_Utils_ap(
									faits,
									_List_fromArray(
										[tire])),
								suivants);
						} else {
							return _Utils_Tuple2(faits, _List_Nil);
						}
					}
				}),
			_Utils_Tuple2(_List_Nil, ajoutes),
			voulusRanges);
		var ordre = _v0.a;
		return _Utils_ap(
			A2($elm$core$List$concatMap, trouver, ordre),
			A2(
				$elm$core$List$filter,
				function (element) {
					return !A2($elm$core$List$member, element.Aq, ordre);
				},
				elements));
	});
var $author$project$Components$Referentiel$Types$Chemin$appliquer = F3(
	function (commandee, rendue, fiche) {
		var lu = fiche.r0;
		var avecLiens = _Utils_update(
			fiche,
			{
				r0: _Utils_update(
					lu,
					{nQ: rendue.nQ})
			});
		switch (commandee.$) {
			case 7:
				var statutsVoulus = commandee.b;
				var apres = A3($elm$core$List$foldl, $author$project$Components$Referentiel$Types$Chemin$appliquerAuStatut, avecLiens.I1, rendue.mk);
				var ajoutes = A2(
					$elm$core$List$filterMap,
					function (evenement) {
						if (evenement.$ === 11) {
							var id = evenement.a;
							return $elm$core$Maybe$Just(id);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					},
					rendue.mk);
				return _Utils_update(
					avecLiens,
					{
						I1: A3($author$project$Components$Referentiel$Types$Chemin$ranger, statutsVoulus, ajoutes, apres)
					});
			case 8:
				var resultatsVoulus = commandee.b;
				var apres = A3($elm$core$List$foldl, $author$project$Components$Referentiel$Types$Chemin$appliquerAuResultat, avecLiens.bh, rendue.mk);
				var ajoutes = A2(
					$elm$core$List$filterMap,
					function (evenement) {
						if (evenement.$ === 17) {
							var id = evenement.a;
							return $elm$core$Maybe$Just(id);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					},
					rendue.mk);
				var ranges = A3(
					$author$project$Components$Referentiel$Types$Chemin$ranger,
					resultatsVoulus,
					ajoutes,
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeL,
							$elm$core$Basics$not,
							function ($) {
								return $.rv;
							}),
						apres));
				return _Utils_update(
					avecLiens,
					{
						bh: _Utils_ap(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeL,
									$elm$core$Basics$not,
									function ($) {
										return $.HZ;
									}),
								ranges),
							_Utils_ap(
								A2(
									$elm$core$List$filter,
									function ($) {
										return $.rv;
									},
									apres),
								A2(
									$elm$core$List$filter,
									function ($) {
										return $.HZ;
									},
									ranges)))
					});
			default:
				return avecLiens;
		}
	});
var $author$project$Components$Referentiel$Types$Chemin$estUnStatut = function (element) {
	switch (element.$) {
		case 0:
			return true;
		case 2:
			return true;
		case 1:
			return false;
		default:
			return false;
	}
};
var $author$project$Components$Referentiel$Types$Chemin$proposesDesResultats = function (fiche) {
	return A2(
		$elm$core$List$filterMap,
		function (resultat) {
			return (resultat.HZ || resultat.rv) ? $elm$core$Maybe$Nothing : A2(
				$elm$core$Maybe$map,
				function (libelles) {
					return {Aq: resultat.Aq, R: libelles};
				},
				resultat.R);
		},
		fiche.bh);
};
var $author$project$Components$Referentiel$Types$Chemin$proposesDesStatuts = function (fiche) {
	return A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeL,
			$elm$core$Basics$not,
			function ($) {
				return $.HZ;
			}),
		fiche.I1);
};
var $author$project$Components$Referentiel$Types$Chemin$rangDuDepart = function (fiche) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$first,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$second,
						function ($) {
							return $.AO;
						}),
					A2(
						$elm$core$List$indexedMap,
						$elm$core$Tuple$pair,
						$author$project$Components$Referentiel$Types$Chemin$proposesDesStatuts(fiche))))));
};
var $author$project$Components$Referentiel$Types$Chemin$versVoulu = function (element) {
	return {
		Aq: $elm$core$Maybe$Just(element.Aq),
		R: element.R
	};
};
var $author$project$Components$Referentiel$Types$Chemin$libellesVoulus = function (saisie) {
	var nonVide = function (code) {
		var texte = $elm$core$String$trim(
			A2($author$project$Components$Shared$LibellesParLangue$Model$lire, code, saisie.R));
		return $elm$core$String$isEmpty(texte) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(texte);
	};
	return A2(
		$elm$core$Maybe$map,
		function (fr) {
			return {
				yg: nonVide('en'),
				zX: fr
			};
		},
		nonVide('fr'));
};
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $author$project$Components$Referentiel$Types$Chemin$sauf = function (id) {
	return $elm$core$List$filter(
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.Aq;
			},
			$elm$core$Basics$neq(
				$elm$core$Maybe$Just(id))));
};
var $author$project$Components$Referentiel$Types$Chemin$statutDeDepart = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$filter(
		function ($) {
			return $.AO;
		}),
	$elm$core$List$head);
var $author$project$Components$Referentiel$Types$Chemin$voulus = F2(
	function (fiche, saisie) {
		return A2(
			$elm$core$Maybe$map,
			function (libelles) {
				var placer = F2(
					function (id, autres) {
						return saisie.HZ ? autres : _Utils_ap(
							A2($elm$core$List$take, saisie.bc, autres),
							_Utils_ap(
								_List_fromArray(
									[
										{Aq: id, R: libelles}
									]),
								A2($elm$core$List$drop, saisie.bc, autres)));
					});
				var resultats = function () {
					var _v2 = saisie.lQ;
					switch (_v2.$) {
						case 1:
							var id = _v2.a;
							return A2(
								placer,
								$elm$core$Maybe$Just(id),
								A2(
									$author$project$Components$Referentiel$Types$Chemin$sauf,
									id,
									A2(
										$elm$core$List$map,
										$author$project$Components$Referentiel$Types$Chemin$versVoulu,
										$author$project$Components$Referentiel$Types$Chemin$proposesDesResultats(fiche))));
						case 3:
							return A2(
								placer,
								$elm$core$Maybe$Nothing,
								A2(
									$elm$core$List$map,
									$author$project$Components$Referentiel$Types$Chemin$versVoulu,
									$author$project$Components$Referentiel$Types$Chemin$proposesDesResultats(fiche)));
						default:
							return _List_Nil;
					}
				}();
				var statuts = function () {
					var _v1 = saisie.lQ;
					switch (_v1.$) {
						case 0:
							var id = _v1.a;
							return A2(
								placer,
								$elm$core$Maybe$Just(id),
								A2(
									$author$project$Components$Referentiel$Types$Chemin$sauf,
									id,
									A2(
										$elm$core$List$map,
										$author$project$Components$Referentiel$Types$Chemin$versVoulu,
										$author$project$Components$Referentiel$Types$Chemin$proposesDesStatuts(fiche))));
						case 2:
							return A2(
								placer,
								$elm$core$Maybe$Nothing,
								A2(
									$elm$core$List$map,
									$author$project$Components$Referentiel$Types$Chemin$versVoulu,
									$author$project$Components$Referentiel$Types$Chemin$proposesDesStatuts(fiche)));
						default:
							return _List_Nil;
					}
				}();
				var depart = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Aq;
					},
					$author$project$Components$Referentiel$Types$Chemin$statutDeDepart(
						$author$project$Components$Referentiel$Types$Chemin$proposesDesStatuts(fiche)));
				var initial = (saisie.cx && (!saisie.HZ)) ? A2(
					$elm$core$Basics$min,
					saisie.bc,
					$elm$core$List$length(statuts) - 1) : A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$first,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (_v0) {
									var voulu = _v0.b;
									return (!_Utils_eq(voulu.Aq, $elm$core$Maybe$Nothing)) && _Utils_eq(voulu.Aq, depart);
								},
								A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, statuts)))));
				return _Utils_Tuple3(statuts, resultats, initial);
			},
			$author$project$Components$Referentiel$Types$Chemin$libellesVoulus(saisie));
	});
var $author$project$Components$Referentiel$Types$Chemin$changee = F2(
	function (fiche, saisie) {
		var _v0 = A2($author$project$Components$Referentiel$Types$Chemin$voulus, fiche, saisie);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var statuts = _v1.a;
			var resultats = _v1.b;
			var initial = _v1.c;
			return $author$project$Components$Referentiel$Types$Chemin$estUnStatut(saisie.lQ) ? (!_Utils_eq(
				_Utils_Tuple2(statuts, initial),
				_Utils_Tuple2(
					A2(
						$elm$core$List$map,
						$author$project$Components$Referentiel$Types$Chemin$versVoulu,
						$author$project$Components$Referentiel$Types$Chemin$proposesDesStatuts(fiche)),
					$author$project$Components$Referentiel$Types$Chemin$rangDuDepart(fiche)))) : (!_Utils_eq(
				resultats,
				A2(
					$elm$core$List$map,
					$author$project$Components$Referentiel$Types$Chemin$versVoulu,
					$author$project$Components$Referentiel$Types$Chemin$proposesDesResultats(fiche))));
		} else {
			return A2(
				$elm$core$List$any,
				function (langue) {
					return A2($author$project$Components$Shared$LibellesParLangue$Model$lire, langue.vx, saisie.R) !== '';
				},
				$author$project$Referentiel$Langues$desLibelles);
		}
	});
var $author$project$Components$Referentiel$Types$Update$versLeChemin = F2(
	function (geste, model) {
		var enCours = function () {
			var _v1 = _Utils_Tuple2(
				model.ge,
				$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model));
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var saisie = _v1.a.a;
				var fiche = _v1.b.a;
				return A2($author$project$Components$Referentiel$Types$Chemin$changee, fiche, saisie);
			} else {
				return false;
			}
		}();
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? _Utils_update(
					model,
					{jK: drawer}) : _Utils_update(
					model,
					{jK: drawer, u8: $elm$core$Maybe$Nothing, ge: $elm$core$Maybe$Nothing});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: enCours},
				geste,
				model.jK));
	});
var $author$project$Components$Referentiel$Types$Update$cheminDefini = F4(
	function (commande, uid, rendue, model) {
		return A2(
			$author$project$Components$Referentiel$Types$Update$versLeChemin,
			$author$project$Components$Shared$Drawer$Update$Fermer,
			_Utils_update(
				model,
				{
					gv: A2(
						$elm$core$Maybe$map,
						function (fiche) {
							return _Utils_eq(fiche.r0.r8, uid) ? A3($author$project$Components$Referentiel$Types$Chemin$appliquer, commande, rendue, fiche) : fiche;
						},
						model.gv)
				}));
	});
var $author$project$I18n$Textes$referentielCheminErreurArchive = A3($author$project$I18n$Traductions$texte, 'referentiel.chemin.erreur.archive', _List_Nil, 'Ce type est archivé : la liste des types vient d\'être relue.');
var $author$project$I18n$Textes$referentielCheminErreurAucunResultat = A3($author$project$I18n$Traductions$texte, 'referentiel.chemin.erreur.aucun-resultat', _List_Nil, 'Le type doit garder au moins un résultat proposé.');
var $author$project$I18n$Textes$referentielCheminErreurAucunStatut = A3($author$project$I18n$Traductions$texte, 'referentiel.chemin.erreur.aucun-statut', _List_Nil, 'Le type doit garder au moins un statut proposé.');
var $author$project$I18n$Textes$referentielCheminErreurDepart = A3($author$project$I18n$Traductions$texte, 'referentiel.chemin.erreur.depart', _List_Nil, 'Le statut de départ doit être un statut proposé.');
var $author$project$I18n$Textes$referentielCheminErreurRelue = A3($author$project$I18n$Traductions$texte, 'referentiel.chemin.erreur.relue', _List_Nil, 'Ce type a changé : sa fiche vient d\'être relue.');
var $author$project$I18n$Textes$referentielCheminErreurSysteme = A3($author$project$I18n$Traductions$texte, 'referentiel.chemin.erreur.systeme', _List_Nil, 'L\'effacement RGPD est un résultat du système : il ne se règle pas.');
var $author$project$I18n$Textes$referentielTypesErreurLibelleRefuse = A3($author$project$I18n$Traductions$texte, 'referentiel.types.erreur.libelle-refuse', _List_Nil, 'Un libellé est vide ou trop long.');
var $author$project$Components$Referentiel$Types$Model$courante = function (model) {
	if (model.fG) {
		var _v0 = $author$project$Components$Referentiel$Types$Model$archives(model);
		if (!_v0.$) {
			var lien = _v0.a;
			return $elm$core$Maybe$Just(lien);
		} else {
			return model.np;
		}
	} else {
		return model.np;
	}
};
var $author$project$Components$Referentiel$Types$Update$relire = function (model) {
	return _Utils_Tuple2(
		model,
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$EffetDeType$Lire, $elm$core$List$singleton),
				$author$project$Components$Referentiel$Types$Model$courante(model))));
};
var $author$project$Components$Referentiel$Types$Update$relireApresLaCommande = function (model) {
	return _Utils_eq(
		$author$project$Components$Referentiel$Types$Model$courante(model),
		$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : $author$project$Components$Referentiel$Types$Update$relire(
		_Utils_update(
			model,
			{Hv: model.Hv + 1}));
};
var $author$project$Components$Referentiel$Types$Update$signaler = F2(
	function (message, saisie) {
		return _Utils_update(
			saisie,
			{
				pZ: $elm$core$Maybe$Just(message)
			});
	});
var $author$project$Components$Referentiel$Types$Update$cheminRefuse = F3(
	function (refus, erreur, model) {
		var message = function (texte) {
			return {Jx: texte, b9: refus.b9};
		};
		var relue = $author$project$Components$Referentiel$Types$Update$relireLeTypeRegleApresLaCommande(
			A2(
				$author$project$Components$Referentiel$Types$Update$avecLEdition,
				$author$project$Components$Referentiel$Types$Update$signaler(
					message($author$project$I18n$Textes$referentielCheminErreurRelue)),
				model));
		var rester = function (texte) {
			return _Utils_Tuple2(
				A2(
					$author$project$Components$Referentiel$Types$Update$avecLEdition,
					$author$project$Components$Referentiel$Types$Update$signaler(
						message(texte)),
					model),
				_List_Nil);
		};
		switch (erreur.$) {
			case 1:
				return $author$project$Components$Referentiel$Types$Update$relireApresLaCommande(
					A2(
						$author$project$Components$Referentiel$Types$Update$avecLEdition,
						$author$project$Components$Referentiel$Types$Update$signaler(
							message($author$project$I18n$Textes$referentielCheminErreurArchive)),
						model));
			case 6:
				return $author$project$Components$Referentiel$Types$Update$relireLeTypeRegleApresLaCommande(
					A2(
						$author$project$Components$Referentiel$Types$Update$avecLEdition,
						function (saisie) {
							return _Utils_update(
								saisie,
								{fW: true});
						},
						model));
			case 11:
				return relue;
			case 12:
				return relue;
			case 9:
				return relue;
			case 10:
				return relue;
			case 7:
				return rester($author$project$I18n$Textes$referentielCheminErreurAucunStatut);
			case 8:
				return rester($author$project$I18n$Textes$referentielCheminErreurAucunResultat);
			case 13:
				return rester($author$project$I18n$Textes$referentielCheminErreurDepart);
			case 14:
				return rester($author$project$I18n$Textes$referentielCheminErreurSysteme);
			case 4:
				return rester($author$project$I18n$Textes$referentielTypesErreurLibelleRefuse);
			default:
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Types$Update$avecLEdition,
						$author$project$Components$Referentiel$Types$Update$signaler(
							$author$project$Components$Shared$Messages$Model$duRefus(refus)),
						model),
					_List_Nil);
		}
	});
var $author$project$Components$Referentiel$Common$EffetDeType$AttendreAvantDeRelire = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Shared$CollectionsDuType$Model$closed = function (drawer) {
	return _Utils_update(
		drawer,
		{wQ: $elm$core$Maybe$Nothing, gt: 0});
};
var $author$project$Components$Shared$CollectionsDuType$Model$abouti = function (model) {
	return _Utils_update(
		model,
		{
			fw: $elm$core$Maybe$Nothing,
			kY: $author$project$Components$Shared$CollectionsDuType$Model$closed(model.kY),
			lD: $author$project$Components$Shared$CollectionsDuType$Model$closed(model.lD),
			eW: $elm$core$Maybe$Nothing
		});
};
var $author$project$Components$Referentiel$Common$EnvoiDeType$delaiDeRelectureMs = $author$project$API$Envoi$delaiDeRelectureMs;
var $author$project$Components$Referentiel$Types$Update$collectionsAbouties = F2(
	function (rendue, model) {
		var fermee = _Utils_update(
			model,
			{
				vE: $author$project$Components$Shared$CollectionsDuType$Model$abouti(model.vE)
			});
		return rendue.sy ? $author$project$Components$Referentiel$Types$Update$relireLeTypeRegleApresLaCommande(fermee) : _Utils_Tuple2(
			A2(
				$author$project$Components$Referentiel$Types$Update$avecLesInformations,
				function (etat) {
					return _Utils_update(
						etat,
						{qj: true});
				},
				fermee),
			_List_fromArray(
				[
					$author$project$Components$Referentiel$Common$EffetDeType$AttendreAvantDeRelire($author$project$Components$Referentiel$Common$EnvoiDeType$delaiDeRelectureMs)
				]));
	});
var $author$project$Components$Shared$CollectionsDuType$Model$refuserLAjout = function (model) {
	return _Utils_update(
		model,
		{
			fw: A2(
				$elm$core$Maybe$map,
				function (ajout) {
					return _Utils_update(
						ajout,
						{qa: true});
				},
				model.fw)
		});
};
var $author$project$Components$Referentiel$Types$Update$collectionsRefusees = function (model) {
	return $author$project$Components$Referentiel$Types$Update$relireLeTypeRegleApresLaCommande(
		_Utils_update(
			model,
			{
				vE: $author$project$Components$Shared$CollectionsDuType$Model$refuserLAjout(model.vE)
			}));
};
var $author$project$Components$Referentiel$Types$Update$duDrawerDuType = function (commande) {
	switch (commande.$) {
		case 2:
			return true;
		case 3:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Shared$Bibliotheque$Elargissement$refuser = function (elargissement) {
	return _Utils_update(
		elargissement,
		{qa: true});
};
var $author$project$Components$Referentiel$Common$RattacherUnChamp$elargissementRefuse = function (etat) {
	return _Utils_update(
		etat,
		{
			lP: A2($elm$core$Maybe$map, $author$project$Components$Shared$Bibliotheque$Elargissement$refuser, etat.lP)
		});
};
var $author$project$Components$Referentiel$Types$Informations$champModifie = F2(
	function (edition, lu) {
		var traductions = A2(
			$elm$core$List$filterMap,
			function (langue) {
				var _v0 = $elm$core$String$trim(
					A2($author$project$Components$Shared$LibellesParLangue$Model$lire, langue.vx, edition.R));
				if (_v0 === '') {
					return $elm$core$Maybe$Nothing;
				} else {
					var texte = _v0;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(langue.vx, texte));
				}
			},
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.vx;
					},
					$elm$core$Basics$neq('fr')),
				$author$project$Referentiel$Langues$desLibelles));
		var francais = $elm$core$String$trim(
			A2($author$project$Components$Shared$LibellesParLangue$Model$lire, 'fr', edition.R));
		var champ = lu.uN;
		var voulu = _Utils_update(
			champ,
			{xD: edition.Ff, Bl: francais, R: traductions, he: edition.he});
		return ((francais === '') || A2($author$project$Components$Shared$EditeurDeSchema$Champ$equivalents, voulu, champ)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(voulu);
	});
var $author$project$Components$Referentiel$Types$Model$informationModifiee = function (model) {
	var _v0 = _Utils_Tuple2(
		model.AM.ge,
		A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.aN;
			},
			$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model)));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var edition = _v0.a.a;
		var schema = _v0.b.a;
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$Components$Referentiel$Types$Informations$champModifie(edition),
			A2($author$project$Components$Referentiel$Types$Informations$parCle, edition.dy, schema.dw));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Types$Update$versLInformation = F2(
	function (geste, model) {
		var etat = model.AM;
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{
						AM: _Utils_update(
							etat,
							{
								ge: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? etat.ge : $elm$core$Maybe$Nothing,
								zo: drawer
							})
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var vers = _v0;
					return $author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(vers);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: !_Utils_eq(
						$author$project$Components$Referentiel$Types$Model$informationModifiee(model),
						$elm$core$Maybe$Nothing)
				},
				geste,
				etat.zo));
	});
var $author$project$Components$Referentiel$Types$Update$versLaRestriction = F2(
	function (geste, model) {
		var etat = model.AM;
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{
						AM: _Utils_update(
							etat,
							{
								lC: drawer,
								al: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? etat.al : $elm$core$Maybe$Nothing
							})
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var vers = _v0;
					return $author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(vers);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				etat.lC));
	});
var $author$project$Components$Referentiel$Types$Update$fermerLInformationEtLaRestriction = F2(
	function (geste, model) {
		return A2(
			$author$project$Components$Referentiel$Types$Update$puisAvec,
			function (apres) {
				return _Utils_eq(apres.AM.al, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(apres, _List_Nil) : A2($author$project$Components$Referentiel$Types$Update$versLaRestriction, geste, apres);
			},
			A2($author$project$Components$Referentiel$Types$Update$versLInformation, geste, model));
	});
var $author$project$Components$Referentiel$Common$EffetDeType$LireLOrdreDesBlocs = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$OrdonnerLesBlocsDUnType = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$ordonnerLesBlocs = 'ordonner-les-blocs';
var $author$project$Components$Shared$OrdreDesBlocs$Update$Lire = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Shared$OrdreDesBlocs$Update$Ordonner = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Shared$OrdreDesBlocs$Update$Reprendre = {$: 3};
var $author$project$Components$Shared$OrdreDesBlocs$Update$Rien = {$: 0};
var $author$project$Components$Shared$OrdreDesBlocs$Model$voulu = function (model) {
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.dy;
		},
		model.El);
};
var $author$project$Components$Shared$OrdreDesBlocs$Model$bouge = F3(
	function (cle, ordre, model) {
		return _Utils_eq(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.dy;
				},
				ordre),
			$author$project$Components$Shared$OrdreDesBlocs$Model$voulu(model)) ? model : _Utils_update(
			model,
			{
				Q: A2($elm$core$List$member, cle, model.Q) ? model.Q : _Utils_ap(
					model.Q,
					_List_fromArray(
						[cle])),
				El: ordre,
				qx: false
			});
	});
var $author$project$Components$Shared$Ordre$deposer = F3(
	function (estGlisse, estCible, elements) {
		var sans = A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, estGlisse),
			elements);
		var place = A2(
			$elm$core$List$map,
			$elm$core$Tuple$first,
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeR, $elm$core$Tuple$second, estCible),
				A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, elements)));
		var _v0 = _Utils_Tuple2(
			A2($elm$core$List$filter, estGlisse, elements),
			place);
		if (((_v0.a.b && (!_v0.a.b.b)) && _v0.b.b) && (!_v0.b.b.b)) {
			var _v1 = _v0.a;
			var glisse = _v1.a;
			var _v2 = _v0.b;
			var rang = _v2.a;
			return _Utils_ap(
				A2($elm$core$List$take, rang, sans),
				A2(
					$elm$core$List$cons,
					glisse,
					A2($elm$core$List$drop, rang, sans)));
		} else {
			return elements;
		}
	});
var $author$project$Components$Shared$OrdreDesBlocs$Model$deposer = F3(
	function (glisse, cible, model) {
		return A3(
			$author$project$Components$Shared$OrdreDesBlocs$Model$bouge,
			glisse,
			A3(
				$author$project$Components$Shared$Ordre$deposer,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.dy;
					},
					$elm$core$Basics$eq(glisse)),
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.dy;
					},
					$elm$core$Basics$eq(cible)),
				model.El),
			model);
	});
var $author$project$Components$Shared$OrdreDesBlocs$Model$descendre = F2(
	function (cle, model) {
		return A3(
			$author$project$Components$Shared$OrdreDesBlocs$Model$bouge,
			cle,
			A2(
				$author$project$Components$Shared$Ordre$descendre,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.dy;
					},
					$elm$core$Basics$eq(cle)),
				model.El),
			model);
	});
var $author$project$Components$Shared$OrdreDesBlocs$Model$idDuDeclencheur = 'ordre-des-blocs-ouvrir';
var $author$project$Components$Shared$OrdreDesBlocs$Model$modifie = function (model) {
	return model.qx || (!_Utils_eq(
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.js;
					},
					$elm$core$List$map(
						function ($) {
							return $.dy;
						})),
				model.B0)),
		$author$project$Components$Shared$OrdreDesBlocs$Model$voulu(model)));
};
var $author$project$Components$Shared$OrdreDesBlocs$Model$monter = F2(
	function (cle, model) {
		return A3(
			$author$project$Components$Shared$OrdreDesBlocs$Model$bouge,
			cle,
			A2(
				$author$project$Components$Shared$Ordre$monter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.dy;
					},
					$elm$core$Basics$eq(cle)),
				model.El),
			model);
	});
var $author$project$Components$Shared$OrdreDesBlocs$Model$ouvrir = F2(
	function (lu, model) {
		return _Utils_update(
			model,
			{
				Q: _List_Nil,
				B0: $elm$core$Maybe$Just(lu),
				El: lu.js,
				qx: false
			});
	});
var $author$project$Components$Shared$OrdreDesBlocs$Model$reprendre = function (model) {
	return _Utils_update(
		model,
		{
			Q: _List_Nil,
			El: A2(
				$elm$core$Maybe$withDefault,
				model.El,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.js;
					},
					model.B0)),
			qx: true
		});
};
var $author$project$Components$Shared$OrdreDesBlocs$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var lien = msg.a;
				return _Utils_Tuple3(
					model,
					_List_Nil,
					$author$project$Components$Shared$OrdreDesBlocs$Update$Lire(lien));
			case 1:
				var lu = msg.a;
				var ouvert = A2($author$project$Components$Shared$OrdreDesBlocs$Model$ouvrir, lu, model);
				var _v1 = A3(
					$author$project$Components$Shared$Drawer$Update$update,
					{Il: false},
					$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Shared$OrdreDesBlocs$Model$idDuDeclencheur),
					ouvert.kX);
				var drawer = _v1.a;
				var effets = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						ouvert,
						{kX: drawer}),
					effets,
					$author$project$Components$Shared$OrdreDesBlocs$Update$Rien);
			case 2:
				var geste = msg.a;
				var _v2 = A3(
					$author$project$Components$Shared$Drawer$Update$update,
					{
						Il: $author$project$Components$Shared$OrdreDesBlocs$Model$modifie(model)
					},
					geste,
					model.kX);
				var drawer = _v2.a;
				var effets = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							kX: drawer,
							B0: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? model.B0 : $elm$core$Maybe$Nothing
						}),
					effets,
					$author$project$Components$Shared$OrdreDesBlocs$Update$Rien);
			case 3:
				var cle = msg.a;
				return _Utils_Tuple3(
					A2($author$project$Components$Shared$OrdreDesBlocs$Model$monter, cle, model),
					_List_Nil,
					$author$project$Components$Shared$OrdreDesBlocs$Update$Rien);
			case 4:
				var cle = msg.a;
				return _Utils_Tuple3(
					A2($author$project$Components$Shared$OrdreDesBlocs$Model$descendre, cle, model),
					_List_Nil,
					$author$project$Components$Shared$OrdreDesBlocs$Update$Rien);
			case 5:
				var cle = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							m_: $elm$core$Maybe$Just(cle)
						}),
					_List_Nil,
					$author$project$Components$Shared$OrdreDesBlocs$Update$Rien);
			case 6:
				var cible = msg.a;
				return _Utils_Tuple3(
					function (suivant) {
						return _Utils_update(
							suivant,
							{m_: $elm$core$Maybe$Nothing});
					}(
						A2(
							$elm$core$Maybe$withDefault,
							model,
							A2(
								$elm$core$Maybe$map,
								function (cle) {
									return A3($author$project$Components$Shared$OrdreDesBlocs$Model$deposer, cle, cible, model);
								},
								model.m_))),
					_List_Nil,
					$author$project$Components$Shared$OrdreDesBlocs$Update$Rien);
			case 7:
				return _Utils_Tuple3(model, _List_Nil, $author$project$Components$Shared$OrdreDesBlocs$Update$Rien);
			case 8:
				return _Utils_Tuple3(
					$author$project$Components$Shared$OrdreDesBlocs$Model$reprendre(model),
					_List_Nil,
					$author$project$Components$Shared$OrdreDesBlocs$Update$Rien);
			default:
				return (!$author$project$Components$Shared$OrdreDesBlocs$Model$modifie(model)) ? _Utils_Tuple3(model, _List_Nil, $author$project$Components$Shared$OrdreDesBlocs$Update$Rien) : (model.qx ? _Utils_Tuple3(model, _List_Nil, $author$project$Components$Shared$OrdreDesBlocs$Update$Reprendre) : _Utils_Tuple3(
					model,
					_List_Nil,
					$author$project$Components$Shared$OrdreDesBlocs$Update$Ordonner(
						$author$project$Components$Shared$OrdreDesBlocs$Model$voulu(model))));
		}
	});
var $author$project$Components$Referentiel$Types$Update$versLesBlocs = F2(
	function (geste, model) {
		var _v0 = $author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model);
		if (!_v0.$) {
			var fiche = _v0.a;
			var _v1 = A2($author$project$Components$Shared$OrdreDesBlocs$Update$update, geste, model.o1);
			var ordre = _v1.a;
			var effets = _v1.b;
			var sortie = _v1.c;
			var focus = A2(
				$elm$core$List$map,
				function (_v4) {
					var cible = _v4;
					return $author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(cible);
				},
				effets);
			var suivant = _Utils_update(
				model,
				{o1: ordre});
			switch (sortie.$) {
				case 0:
					return _Utils_Tuple2(suivant, focus);
				case 1:
					var lien = sortie.a;
					return _Utils_Tuple2(
						suivant,
						_Utils_ap(
							focus,
							_List_fromArray(
								[
									$author$project$Components$Referentiel$Common$EffetDeType$LireLOrdreDesBlocs(lien)
								])));
				case 2:
					var voulu = sortie.a;
					var _v3 = A2(
						$elm$core$Maybe$andThen,
						function (lu) {
							return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ordonnerLesBlocs, lu.nQ);
						},
						ordre.B0);
					if (!_v3.$) {
						var lien = _v3.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							function (partis) {
								return _Utils_ap(focus, partis);
							},
							A3(
								$author$project$Components$Referentiel$Types$Update$envoyerLaCommande,
								lien,
								A2($author$project$Components$Referentiel$Common$API$WriteAPIModel$OrdonnerLesBlocsDUnType, fiche.r0.r8, voulu),
								suivant));
					} else {
						return _Utils_Tuple2(suivant, focus);
					}
				default:
					return _Utils_Tuple2(suivant, focus);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Types$Update$fermerLOrdre = function (_v0) {
	var model = _v0.a;
	var effets = _v0.b;
	return A2(
		$elm$core$Tuple$mapSecond,
		function (focus) {
			return _Utils_ap(focus, effets);
		},
		A2(
			$author$project$Components$Referentiel$Types$Update$versLesBlocs,
			$author$project$Components$Shared$OrdreDesBlocs$Update$DuDrawer($author$project$Components$Shared$Drawer$Update$Fermer),
			model));
};
var $author$project$Components$Referentiel$Types$Model$idDeLArchivage = 'type-archiver';
var $author$project$Components$Referentiel$Types$Model$idDeLaRestauration = 'type-restaurer';
var $author$project$Components$Referentiel$Types$Update$foyer = function (commande) {
	if (commande.$ === 3) {
		return $author$project$Components$Referentiel$Types$Model$idDeLaRestauration;
	} else {
		return $author$project$Components$Referentiel$Types$Model$idDeLArchivage;
	}
};
var $author$project$Components$Referentiel$Types$Update$gesteAbouti = F2(
	function (fermer, model) {
		return A2(
			$author$project$Components$Referentiel$Types$Update$puisAvec,
			$author$project$Components$Referentiel$Types$Update$relireLeTypeRegleApresLaCommande,
			A2(
				$author$project$Components$Referentiel$Types$Update$puisAvec,
				fermer($author$project$Components$Shared$Drawer$Update$Fermer),
				A2(
					$author$project$Components$Referentiel$Types$Update$parLaConduite,
					function (reglage) {
						return A2($author$project$Components$Shared$EditeurDeSchema$Conduite$conclure, reglage, $author$project$Components$Shared$EditeurDeSchema$Conduite$Aboutie);
					},
					model)));
	});
var $author$project$Components$Referentiel$Types$Update$gesteRefuse = F2(
	function (message, model) {
		return A2(
			$author$project$Components$Referentiel$Types$Update$puisAvec,
			$author$project$Components$Referentiel$Types$Update$relireLeTypeRegleApresLaCommande,
			A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Components$Referentiel$Types$Update$avecLesInformations(
					function (etat) {
						return _Utils_update(
							etat,
							{
								pZ: $elm$core$Maybe$Just(message)
							});
					}),
				A2(
					$author$project$Components$Referentiel$Types$Update$parLaConduite,
					function (reglage) {
						return A2($author$project$Components$Shared$EditeurDeSchema$Conduite$conclure, reglage, $author$project$Components$Shared$EditeurDeSchema$Conduite$SessionEchue);
					},
					model)));
	});
var $author$project$Components$Referentiel$Types$Model$idDuRechargement = 'type-recharger';
var $author$project$Components$Referentiel$Types$Update$schemaEvolue = F3(
	function (typeAjoute, rendue, fiche) {
		var lu = fiche.r0;
		var evoluer = F2(
			function (evenement, schema) {
				if (evenement.$ === 22) {
					var version = evenement.a;
					var evolution = evenement.b;
					return _Utils_update(
						schema,
						{
							dw: _Utils_ap(
								schema.dw,
								A2(
									$elm$core$List$map,
									function (ajoute) {
										return {uN: ajoute, zu: 0, AZ: true, nQ: _List_Nil, n4: false, B9: $elm$core$Maybe$Nothing, g4: 'essentiel', al: _List_Nil, JR: typeAjoute};
									},
									evolution.fx)),
							sq: version
						});
				} else {
					return schema;
				}
			});
		return _Utils_update(
			fiche,
			{
				aN: A2(
					$elm$core$Maybe$map,
					function (schema) {
						return A3($elm$core$List$foldl, evoluer, schema, rendue.mk);
					},
					fiche.aN),
				r0: _Utils_update(
					lu,
					{nQ: rendue.nQ})
			});
	});
var $author$project$Components$Referentiel$Types$Update$informationAjoutee = F3(
	function (uid, rendue, model) {
		var typeAjoute = (model.AM.hP.zT.JR === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(model.AM.hP.zT.JR);
		var appliquee = _Utils_update(
			model,
			{
				gv: A2(
					$elm$core$Maybe$map,
					function (fiche) {
						return _Utils_eq(fiche.r0.r8, uid) ? A3($author$project$Components$Referentiel$Types$Update$schemaEvolue, typeAjoute, rendue, fiche) : fiche;
					},
					model.gv)
			});
		return A2(
			$author$project$Components$Referentiel$Types$Update$puisAvec,
			function (fermee) {
				return rendue.sy ? $author$project$Components$Referentiel$Types$Update$relireLeTypeRegleApresLaCommande(fermee) : _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Types$Update$avecLesInformations,
						function (etat) {
							return _Utils_update(
								etat,
								{qj: true});
						},
						fermee),
					_List_fromArray(
						[
							$author$project$Components$Referentiel$Common$EffetDeType$AttendreAvantDeRelire($author$project$Components$Referentiel$Common$EnvoiDeType$delaiDeRelectureMs)
						]));
			},
			A2(
				$author$project$Components$Referentiel$Types$Update$parLaConduite,
				function (reglage) {
					return A2($author$project$Components$Shared$EditeurDeSchema$Conduite$conclure, reglage, $author$project$Components$Shared$EditeurDeSchema$Conduite$Aboutie);
				},
				appliquee));
	});
var $author$project$Components$Referentiel$Types$Update$versLElargissementDeLaListe = F2(
	function (geste, model) {
		var etat = model.AM;
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{
						AM: _Utils_update(
							etat,
							{ly: drawer})
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var vers = _v0;
					return $author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(vers);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				etat.ly));
	});
var $author$project$Components$Referentiel$Types$Update$listeElargie = function (model) {
	return A2(
		$elm$core$Tuple$mapFirst,
		$author$project$Components$Referentiel$Types$Update$avecLesInformations(
			function (etat) {
				return _Utils_update(
					etat,
					{
						gf: $elm$core$Maybe$Nothing,
						hP: A2($author$project$Components$Shared$EditeurDeSchema$Model$refuser, $elm$core$Maybe$Nothing, etat.hP)
					});
			}),
		A2($author$project$Components$Referentiel$Types$Update$versLElargissementDeLaListe, $author$project$Components$Shared$Drawer$Update$Fermer, model));
};
var $author$project$I18n$Textes$editeurDeSchemaErreurEvolutionNonAdditive = A3($author$project$I18n$Traductions$texte, 'editeur-de-schema.erreur.evolution-non-additive', _List_Nil, 'Modification refusée : elle changerait la forme des valeurs déjà saisies dans ce champ.');
var $author$project$I18n$Textes$editeurDeSchemaErreurEvolutionNonAdditiveDecimalesChangees = A3($author$project$I18n$Traductions$texte, 'editeur-de-schema.erreur.evolution-non-additive.decimales-changees', _List_Nil, 'Le nombre de décimales d\'une mesure enregistrée ne change pas : les valeurs déjà saisies en dépendent.');
var $author$project$I18n$Textes$editeurDeSchemaErreurEvolutionNonAdditiveLongueurResserree = A3($author$project$I18n$Traductions$texte, 'editeur-de-schema.erreur.evolution-non-additive.longueur-resserree', _List_Nil, 'La longueur d\'un texte enregistré s\'élargit ou se retire, elle ne se resserre pas : des valeurs déjà saisies pourraient en sortir.');
var $author$project$I18n$Textes$editeurDeSchemaErreurEvolutionNonAdditiveMotifResserre = A3($author$project$I18n$Traductions$texte, 'editeur-de-schema.erreur.evolution-non-additive.motif-resserre', _List_Nil, 'Le format d\'un champ enregistré se retire, il ne se pose pas et ne change pas : des valeurs déjà saisies pourraient ne plus le respecter.');
var $author$project$I18n$Textes$editeurDeSchemaErreurEvolutionNonAdditiveTypeChange = A3($author$project$I18n$Traductions$texte, 'editeur-de-schema.erreur.evolution-non-additive.type-change', _List_Nil, 'Un champ ne change pas de type');
var $author$project$I18n$Textes$editeurDeSchemaErreurEvolutionNonAdditiveUniteChangee = A3($author$project$I18n$Traductions$texte, 'editeur-de-schema.erreur.evolution-non-additive.unite-changee', _List_Nil, 'L\'unité de saisie d\'une mesure enregistrée ne change pas : les valeurs déjà saisies sont dans cette unité.');
var $author$project$I18n$Textes$editeurDeSchemaOptionBornesPlausiblesResserree = A3($author$project$I18n$Traductions$texte, 'editeur-de-schema.option.bornes-plausibles.resserree', _List_Nil, 'Une borne enregistrée s\'élargit ou se retire, elle ne se resserre pas : des valeurs déjà saisies pourraient en sortir.');
var $author$project$I18n$Textes$editeurDeSchemaOptionValeursRetiree = A3($author$project$I18n$Traductions$texte, 'editeur-de-schema.option.valeurs.retiree', _List_Nil, 'Une valeur enregistrée ne se retire pas et ne se renomme pas : des fiches peuvent déjà la porter. Vous pouvez en ajouter.');
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$raisonsNonAdditives = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('TypeChange', $author$project$I18n$Textes$editeurDeSchemaErreurEvolutionNonAdditiveTypeChange),
			_Utils_Tuple2('ValeurRetiree', $author$project$I18n$Textes$editeurDeSchemaOptionValeursRetiree),
			_Utils_Tuple2('BorneResserree', $author$project$I18n$Textes$editeurDeSchemaOptionBornesPlausiblesResserree),
			_Utils_Tuple2('UniteChangee', $author$project$I18n$Textes$editeurDeSchemaErreurEvolutionNonAdditiveUniteChangee),
			_Utils_Tuple2('DecimalesChangees', $author$project$I18n$Textes$editeurDeSchemaErreurEvolutionNonAdditiveDecimalesChangees),
			_Utils_Tuple2('LongueurResserree', $author$project$I18n$Textes$editeurDeSchemaErreurEvolutionNonAdditiveLongueurResserree),
			_Utils_Tuple2('MotifResserre', $author$project$I18n$Textes$editeurDeSchemaErreurEvolutionNonAdditiveMotifResserre),
			_Utils_Tuple2('FormeChangee', $author$project$I18n$Textes$editeurDeSchemaErreurEvolutionNonAdditive)
		]));
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$raisonNonAdditive = function (code) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$I18n$Textes$editeurDeSchemaErreurEvolutionNonAdditive,
		A2($elm$core$Dict$get, code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$raisonsNonAdditives));
};
var $author$project$Components$Referentiel$Types$Update$messageDuGeste = F2(
	function (refus, erreur) {
		var dire = function (texte) {
			return {Jx: texte, b9: refus.b9};
		};
		switch (erreur.$) {
			case 16:
				var raison = erreur.a;
				return dire(
					$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$raisonNonAdditive(raison));
			case 1:
				return dire($author$project$I18n$Textes$referentielTypeErreurArchive);
			case 6:
				return dire($author$project$I18n$Textes$referentielTypeConcurrente);
			case 25:
				return dire($author$project$I18n$Textes$referentielTypesErreurDefinitionPartagee);
			default:
				return $author$project$Components$Shared$Messages$Model$duRefus(refus);
		}
	});
var $author$project$Components$Referentiel$Types$Update$refuserLesOffres = F2(
	function (message, model) {
		return _Utils_update(
			model,
			{
				p5: $elm$core$Maybe$Just(message)
			});
	});
var $author$project$Components$Referentiel$Types$Update$offresConcurrentes = F2(
	function (refus, model) {
		return $author$project$Components$Referentiel$Types$Update$relireLeTypeRegleApresLaCommande(
			A2(
				$author$project$Components$Referentiel$Types$Update$refuserLesOffres,
				{Jx: $author$project$I18n$Textes$referentielTypeConcurrente, b9: refus.b9},
				model));
	});
var $author$project$Components$Referentiel$Types$Update$offresRefusees = F2(
	function (refus, model) {
		return $author$project$Components$Referentiel$Types$Update$relireApresLaCommande(
			A2(
				$author$project$Components$Referentiel$Types$Update$refuserLesOffres,
				{Jx: $author$project$I18n$Textes$referentielTypeErreurArchive, b9: refus.b9},
				model));
	});
var $author$project$Components$Referentiel$Types$Offres$appliquer = F2(
	function (rendue, fiche) {
		var lu = fiche.r0;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (evenement, avant) {
					_v0$2:
					while (true) {
						switch (evenement.$) {
							case 10:
								var interdite = evenement.a;
								return _Utils_update(
									avant,
									{AR: interdite});
							case 9:
								if ((!evenement.a.b) && (evenement.b.$ === 1)) {
									var _v1 = evenement.b;
									return _Utils_update(
										avant,
										{D3: _List_Nil, E9: $elm$core$Maybe$Nothing});
								} else {
									break _v0$2;
								}
							default:
								break _v0$2;
						}
					}
					return avant;
				}),
			_Utils_update(
				fiche,
				{
					r0: _Utils_update(
						lu,
						{nQ: rendue.nQ})
				}),
			rendue.mk);
	});
var $author$project$Components$Referentiel$Types$Update$versLeChoixDesOffres = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{jQ: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.jQ));
	});
var $author$project$Components$Referentiel$Types$Update$versLeChoixDuPerimetre = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{jR: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.jR));
	});
var $author$project$Components$Referentiel$Types$Update$offresReglees = F3(
	function (uid, rendue, model) {
		var _v0 = A2($author$project$Components$Referentiel$Types$Update$versLeChoixDuPerimetre, $author$project$Components$Shared$Drawer$Update$Fermer, model);
		var sansPerimetre = _v0.a;
		var effetsDuPerimetre = _v0.b;
		var _v1 = A2($author$project$Components$Referentiel$Types$Update$versLeChoixDesOffres, $author$project$Components$Shared$Drawer$Update$Fermer, sansPerimetre);
		var sansOffres = _v1.a;
		var effetsDesOffres = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				sansOffres,
				{
					gv: A2(
						$elm$core$Maybe$map,
						function (fiche) {
							return _Utils_eq(fiche.r0.r8, uid) ? A2($author$project$Components$Referentiel$Types$Offres$appliquer, rendue, fiche) : fiche;
						},
						sansOffres.gv),
					e2: false
				}),
			_Utils_ap(
				effetsDuPerimetre,
				_Utils_ap(
					effetsDesOffres,
					$author$project$Components$Referentiel$Types$Update$relectureDuTypeRegle(sansOffres))));
	});
var $author$project$Components$Referentiel$Common$RattacherUnChamp$porteeElargie = F3(
	function (champ, portee, etat) {
		var elargi = function (lu) {
			return _Utils_eq(lu.Aq, champ) ? _Utils_update(
				lu,
				{o4: $elm$core$Maybe$Nothing, F$: portee}) : lu;
		};
		return A2(
			$elm$core$Tuple$mapFirst,
			function (fermee) {
				return _Utils_update(
					fermee,
					{lP: $elm$core$Maybe$Nothing});
			},
			A2(
				$author$project$Components$Referentiel$Common$RattacherUnChamp$versLElargissement,
				$author$project$Components$Shared$Drawer$Update$Fermer,
				A2(
					$author$project$Components$Referentiel$Common$RattacherUnChamp$avec,
					function (r) {
						return _Utils_update(
							r,
							{
								dq: A2(
									$elm$core$Maybe$map,
									$elm$core$List$map(elargi),
									r.dq),
								pZ: $elm$core$Maybe$Nothing
							});
					},
					etat)));
	});
var $author$project$Components$Referentiel$Types$Update$porteeElargie = F3(
	function (champ, portee, model) {
		return A2(
			$author$project$Components$Referentiel$Types$Update$depuisLeRattachement,
			model,
			A3($author$project$Components$Referentiel$Common$RattacherUnChamp$porteeElargie, champ, portee, model.AM.GZ));
	});
var $author$project$I18n$Textes$referentielParcoursOffresPerimetreRefusArchive = A3($author$project$I18n$Traductions$texte, 'referentiel.parcours.offres.perimetre.refus.archive', _List_Nil, 'Périmètre refusé. Ce périmètre est archivé : choisissez un autre périmètre.');
var $author$project$I18n$Textes$referentielParcoursOffresPerimetreRefusLiee = A3($author$project$I18n$Traductions$texte, 'referentiel.parcours.offres.perimetre.refus.liee', _List_Nil, 'Périmètre refusé. Ce périmètre dépend de la fiche visée : il ne peut pas limiter les offres d\'un type de partie prenante. Choisissez un autre périmètre.');
var $author$project$Components$Referentiel$Common$SaisieDeType$codeDeLaLangue = function (langue) {
	if (!langue) {
		return 'fr';
	} else {
		return 'en';
	}
};
var $author$project$Components$Referentiel$Common$SaisieDeType$prefixeDesLibelles = function (prefixe) {
	return prefixe + '-libelle';
};
var $author$project$Components$Referentiel$Common$SaisieDeType$idDuLibelle = F2(
	function (prefixe, code) {
		return A2(
			$author$project$Components$Shared$LibellesParLangue$View$idDuChamp,
			$author$project$Components$Referentiel$Common$SaisieDeType$prefixeDesLibelles(prefixe),
			code);
	});
var $author$project$Components$Referentiel$Types$Model$prefixe = function (model) {
	return $author$project$Components$Shared$Drawer$Model$idRacine(model.kX);
};
var $author$project$Components$Referentiel$Types$Model$prefixeDuRenommage = function (model) {
	return $author$project$Components$Shared$Drawer$Model$idRacine(model.hL);
};
var $author$project$Components$Referentiel$Types$Update$prefixeDe = F2(
	function (commande, model) {
		if (commande.$ === 1) {
			return $author$project$Components$Referentiel$Types$Model$prefixeDuRenommage(model);
		} else {
			return $author$project$Components$Referentiel$Types$Model$prefixe(model);
		}
	});
var $author$project$Components$Referentiel$Common$SaisieDeType$prendre = F2(
	function (langue, saisie) {
		return _Utils_update(
			saisie,
			{
				bW: $elm$core$Maybe$Just(
					$author$project$Components$Referentiel$Common$SaisieDeType$codeDeLaLangue(langue))
			});
	});
var $author$project$Components$Referentiel$Types$Update$refuser = F4(
	function (commande, refus, erreur, model) {
		var saisie = model.hP;
		var dire = function (message) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						hP: _Utils_update(
							saisie,
							{
								pZ: $elm$core$Maybe$Just(message)
							})
					}),
				_List_Nil);
		};
		switch (erreur.$) {
			case 0:
				var langue = erreur.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hP: A2($author$project$Components$Referentiel$Common$SaisieDeType$prendre, langue, saisie)
						}),
					_List_fromArray(
						[
							$author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(
							A2(
								$author$project$Components$Referentiel$Common$SaisieDeType$idDuLibelle,
								A2($author$project$Components$Referentiel$Types$Update$prefixeDe, commande, model),
								$author$project$Components$Referentiel$Common$SaisieDeType$codeDeLaLangue(langue)))
						]));
			case 4:
				return dire(
					{Jx: $author$project$I18n$Textes$referentielTypesErreurLibelleRefuse, b9: refus.b9});
			default:
				return dire(
					$author$project$Components$Shared$Messages$Model$duRefus(refus));
		}
	});
var $author$project$Components$Shared$Bibliotheque$ElargissementDeListe$refuser = function (elargissement) {
	return _Utils_update(
		elargissement,
		{qa: true});
};
var $author$project$Components$Referentiel$Types$Model$DesNatures = 0;
var $author$project$Components$Referentiel$Types$Model$DesQualites = 1;
var $author$project$Components$Referentiel$Types$Update$refuserLesPorteurs = F3(
	function (natures, message, model) {
		var groupe = function () {
			var _v0 = $author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model);
			if (!_v0.$) {
				var fiche = _v0.a;
				return (!_Utils_eq(
					$author$project$Components$Referentiel$Types$Model$casesDuType(fiche).oo,
					natures)) ? 0 : 1;
			} else {
				return 0;
			}
		}();
		return _Utils_update(
			model,
			{
				p6: $elm$core$Maybe$Just(
					_Utils_Tuple2(groupe, message))
			});
	});
var $author$project$Components$Referentiel$Types$Update$relectureDiffereeSiBesoin = function (rendue) {
	return rendue.sy ? _List_Nil : _List_fromArray(
		[
			$author$project$Components$Referentiel$Common$EffetDeType$AttendreAvantDeRelire($author$project$Components$Referentiel$Common$EnvoiDeType$delaiDeRelectureMs)
		]);
};
var $author$project$Components$Referentiel$Types$Update$relireApresLaCommandeQuandLaVueSuit = F2(
	function (rendue, model) {
		return rendue.sy ? $author$project$Components$Referentiel$Types$Update$relireApresLaCommande(model) : _Utils_Tuple2(
			A2($author$project$Components$Referentiel$Types$Update$apresLaCommande, rendue, model),
			$author$project$Components$Referentiel$Types$Update$relectureDiffereeSiBesoin(rendue));
	});
var $author$project$Components$Referentiel$Common$EffetDeType$LireLeType = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Types$Update$relectureDuType = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$EffetDeType$LireLeType, $elm$core$List$singleton),
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.r0;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.nQ;
						},
						$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$self))),
				$author$project$Components$Referentiel$Types$Model$typeConsulte(model))));
};
var $author$project$Components$Referentiel$Types$Update$relireLeTypeApresLaCommande = function (model) {
	var _v0 = $author$project$Components$Referentiel$Types$Update$relectureDuType(model);
	if (!_v0.b) {
		return _Utils_Tuple2(model, _List_Nil);
	} else {
		var effets = _v0;
		return model.rW ? _Utils_Tuple2(model, effets) : _Utils_Tuple2(
			_Utils_update(
				model,
				{Hv: model.Hv + 1, rW: true}),
			effets);
	}
};
var $author$project$Components$Referentiel$Types$Update$restreinte = F2(
	function (rendue, fiche) {
		var lu = fiche.r0;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (evenement, avant) {
					switch (evenement.$) {
						case 7:
							var natures = evenement.a;
							return _Utils_update(
								avant,
								{oo: natures});
						case 8:
							var qualites = evenement.a;
							return _Utils_update(
								avant,
								{GG: qualites});
						default:
							return avant;
					}
				}),
			_Utils_update(
				fiche,
				{
					r0: _Utils_update(
						lu,
						{nQ: rendue.nQ})
				}),
			rendue.mk);
	});
var $author$project$Components$Shared$Bibliotheque$Restriction$refuser = function (restriction) {
	return _Utils_update(
		restriction,
		{qa: true});
};
var $author$project$Components$Referentiel$Types$RestrictionDuChamp$refuser = $author$project$Components$Referentiel$Types$RestrictionDuChamp$surLEtat($author$project$Components$Shared$Bibliotheque$Restriction$refuser);
var $author$project$Components$Referentiel$Types$Update$restrictionRefusee = function (model) {
	return $author$project$Components$Referentiel$Types$Update$relireLeTypeRegleApresLaCommande(
		A2(
			$author$project$Components$Referentiel$Types$Update$avecLesInformations,
			function (etat) {
				return _Utils_update(
					etat,
					{
						al: A2($elm$core$Maybe$map, $author$project$Components$Referentiel$Types$RestrictionDuChamp$refuser, etat.al)
					});
			},
			model));
};
var $author$project$Components$Referentiel$Types$Update$versLaMasquee = F2(
	function (geste, model) {
		var etat = model.AM;
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{
						AM: _Utils_update(
							etat,
							{
								ge: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? etat.ge : $elm$core$Maybe$Nothing,
								Ca: drawer
							})
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var vers = _v0;
					return $author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(vers);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				etat.Ca));
	});
var $author$project$Components$Referentiel$Common$SaisieDeType$enCours = function (saisie) {
	return !_Utils_eq(
		{fA: saisie.fA, kf: saisie.kf, aC: saisie.aC, R: saisie.R},
		saisie.cx);
};
var $author$project$Components$Referentiel$Types$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{kX: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Referentiel$Common$SaisieDeType$enCours(model.hP)
				},
				geste,
				model.kX));
	});
var $author$project$Components$Referentiel$Types$Update$versLeRenommage = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{
						hL: drawer,
						hP: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? model.hP : $author$project$Components$Referentiel$Common$SaisieDeType$vide
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Referentiel$Common$SaisieDeType$enCours(model.hP)
				},
				geste,
				model.hL));
	});
var $author$project$Components$Referentiel$Types$Update$versLesReglages = F2(
	function (geste, model) {
		var etat = model.AM;
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{
						AM: _Utils_update(
							etat,
							{
								eO: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? etat.eO : $elm$core$Maybe$Nothing,
								qc: drawer
							})
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var vers = _v0;
					return $author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(vers);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				etat.qc));
	});
var $author$project$Components$Referentiel$Types$Update$conclureUnGeste = F2(
	function (issue, model) {
		var saisie = model.hP;
		var rejeu = {Jx: $author$project$I18n$Textes$referentielTypesErreurRejeu, b9: $elm$core$Maybe$Nothing};
		_v0$63:
		while (true) {
			switch (issue.$) {
				case 2:
					return A2(
						$author$project$Components$Referentiel$Types$Update$parLaConduite,
						function (reglage) {
							return A2($author$project$Components$Shared$EditeurDeSchema$Conduite$conclure, reglage, $author$project$Components$Shared$EditeurDeSchema$Conduite$SessionEchue);
						},
						model);
				case 0:
					switch (issue.a.$) {
						case 0:
							if (issue.c) {
								var _v1 = issue.a;
								var rendue = issue.b;
								return A2(
									$elm$core$Tuple$mapSecond,
									function (effets) {
										return _Utils_ap(
											effets,
											$author$project$Components$Referentiel$Types$Update$relectureDiffereeSiBesoin(rendue));
									},
									A2(
										$author$project$Components$Referentiel$Types$Update$versLeDrawer,
										$author$project$Components$Shared$Drawer$Update$Fermer,
										A2(
											$author$project$Components$Referentiel$Types$Model$ajouter,
											rendue,
											A2(
												$author$project$Components$Referentiel$Types$Update$apresLaCommande,
												rendue,
												_Utils_update(
													model,
													{hP: $author$project$Components$Referentiel$Common$SaisieDeType$vide})))));
							} else {
								break _v0$63;
							}
						case 1:
							if (issue.c) {
								var _v2 = issue.a;
								var rendue = issue.b;
								return A2(
									$elm$core$Tuple$mapSecond,
									function (effets) {
										return _Utils_ap(
											effets,
											$author$project$Components$Referentiel$Types$Update$relectureDiffereeSiBesoin(rendue));
									},
									A2(
										$author$project$Components$Referentiel$Types$Update$versLeRenommage,
										$author$project$Components$Shared$Drawer$Update$Fermer,
										A2(
											$author$project$Components$Referentiel$Types$Model$appliquer,
											rendue,
											A2($author$project$Components$Referentiel$Types$Update$apresLaCommande, rendue, model))));
							} else {
								break _v0$63;
							}
						case 2:
							if (issue.c) {
								var rendue = issue.b;
								return A2(
									$elm$core$Tuple$mapSecond,
									function (effets) {
										return _Utils_ap(
											effets,
											_List_fromArray(
												[
													$author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus($author$project$Components$Referentiel$Types$Model$idDeLaRestauration)
												]));
									},
									A2(
										$author$project$Components$Referentiel$Types$Update$relireApresLaCommandeQuandLaVueSuit,
										rendue,
										A2($author$project$Components$Referentiel$Types$Model$appliquer, rendue, model)));
							} else {
								break _v0$63;
							}
						case 3:
							if (issue.c) {
								var rendue = issue.b;
								return A2(
									$elm$core$Tuple$mapSecond,
									function (effets) {
										return _Utils_ap(
											effets,
											_List_fromArray(
												[
													$author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus($author$project$Components$Referentiel$Types$Model$idDeLArchivage)
												]));
									},
									A2(
										$author$project$Components$Referentiel$Types$Update$relireApresLaCommandeQuandLaVueSuit,
										rendue,
										A2($author$project$Components$Referentiel$Types$Model$appliquer, rendue, model)));
							} else {
								break _v0$63;
							}
						case 7:
							if (issue.c) {
								var commande = issue.a;
								var uid = commande.a;
								var rendue = issue.b;
								return A4($author$project$Components$Referentiel$Types$Update$cheminDefini, commande, uid, rendue, model);
							} else {
								var _v4 = issue.a;
								return $author$project$Components$Referentiel$Types$Update$relireLeTypeRegleApresLaCommande(
									A2(
										$author$project$Components$Referentiel$Types$Update$avecLEdition,
										$author$project$Components$Referentiel$Types$Update$signaler(rejeu),
										model));
							}
						case 8:
							if (issue.c) {
								var commande = issue.a;
								var uid = commande.a;
								var rendue = issue.b;
								return A4($author$project$Components$Referentiel$Types$Update$cheminDefini, commande, uid, rendue, model);
							} else {
								var _v5 = issue.a;
								return $author$project$Components$Referentiel$Types$Update$relireLeTypeRegleApresLaCommande(
									A2(
										$author$project$Components$Referentiel$Types$Update$avecLEdition,
										$author$project$Components$Referentiel$Types$Update$signaler(rejeu),
										model));
							}
						case 19:
							if (issue.c) {
								var _v9 = issue.a;
								var rendue = issue.b;
								return $author$project$Components$Referentiel$Types$Update$fermerLOrdre(
									A2(
										$author$project$Components$Referentiel$Types$Update$relireApresLaCommandeQuandLaVueSuit,
										rendue,
										_Utils_update(
											model,
											{
												o1: $author$project$Components$Shared$OrdreDesBlocs$Model$abouti(model.o1)
											})));
							} else {
								var _v10 = issue.a;
								return $author$project$Components$Referentiel$Types$Update$relireLeTypeRegleApresLaCommande(model);
							}
						case 17:
							if (issue.c) {
								var _v12 = issue.a;
								var rendue = issue.b;
								return A2($author$project$Components$Referentiel$Types$Update$collectionsAbouties, rendue, model);
							} else {
								var _v14 = issue.a;
								return $author$project$Components$Referentiel$Types$Update$collectionsRefusees(model);
							}
						case 18:
							if (issue.c) {
								var _v13 = issue.a;
								var rendue = issue.b;
								return A2($author$project$Components$Referentiel$Types$Update$collectionsAbouties, rendue, model);
							} else {
								var _v15 = issue.a;
								return $author$project$Components$Referentiel$Types$Update$collectionsRefusees(model);
							}
						case 10:
							if (issue.c) {
								var _v18 = issue.a;
								return A2($author$project$Components$Referentiel$Types$Update$gesteAbouti, $author$project$Components$Referentiel$Types$Update$fermerLInformationEtLaRestriction, model);
							} else {
								var _v21 = issue.a;
								return A2($author$project$Components$Referentiel$Types$Update$gesteRefuse, rejeu, model);
							}
						case 11:
							if (issue.c) {
								var _v19 = issue.a;
								return A2($author$project$Components$Referentiel$Types$Update$gesteAbouti, $author$project$Components$Referentiel$Types$Update$versLaMasquee, model);
							} else {
								var _v22 = issue.a;
								return A2($author$project$Components$Referentiel$Types$Update$gesteRefuse, rejeu, model);
							}
						case 12:
							if (issue.c) {
								var _v20 = issue.a;
								return A2(
									$author$project$Components$Referentiel$Types$Update$puisAvec,
									$author$project$Components$Referentiel$Types$Update$relireLeTypeRegleApresLaCommande,
									A2(
										$author$project$Components$Referentiel$Types$Update$parLaConduite,
										function (reglage) {
											return A2($author$project$Components$Shared$EditeurDeSchema$Conduite$conclure, reglage, $author$project$Components$Shared$EditeurDeSchema$Conduite$Aboutie);
										},
										model));
							} else {
								var _v23 = issue.a;
								return A2($author$project$Components$Referentiel$Types$Update$gesteRefuse, rejeu, model);
							}
						case 16:
							if (issue.c) {
								var _v27 = issue.a;
								var uid = _v27.a;
								var rendue = issue.b;
								return A3($author$project$Components$Referentiel$Types$Update$informationAjoutee, uid, rendue, model);
							} else {
								var _v28 = issue.a;
								return $author$project$Components$Referentiel$Types$Update$ajoutRejoue(model);
							}
						case 20:
							var _v30 = issue.a;
							var champ = _v30.a;
							var portee = _v30.b;
							return A3($author$project$Components$Referentiel$Types$Update$porteeElargie, champ, portee, model);
						case 21:
							var _v32 = issue.a;
							return $author$project$Components$Referentiel$Types$Update$listeElargie(model);
						case 14:
							var _v34 = issue.a;
							return A2($author$project$Components$Referentiel$Types$Update$gesteAbouti, $author$project$Components$Referentiel$Types$Update$versLaRestriction, model);
						case 15:
							var _v35 = issue.a;
							return A2($author$project$Components$Referentiel$Types$Update$gesteAbouti, $author$project$Components$Referentiel$Types$Update$versLaRestriction, model);
						case 13:
							if (issue.c) {
								var _v38 = issue.a;
								return A2($author$project$Components$Referentiel$Types$Update$gesteAbouti, $author$project$Components$Referentiel$Types$Update$versLesReglages, model);
							} else {
								var _v39 = issue.a;
								return A2($author$project$Components$Referentiel$Types$Update$gesteRefuse, rejeu, model);
							}
						case 5:
							if (issue.c) {
								var _v41 = issue.a;
								var uid = _v41.a;
								var rendue = issue.b;
								return A3($author$project$Components$Referentiel$Types$Update$offresReglees, uid, rendue, model);
							} else {
								var _v43 = issue.a;
								return $author$project$Components$Referentiel$Types$Update$relireLeTypeRegleApresLaCommande(
									A2($author$project$Components$Referentiel$Types$Update$refuserLesOffres, rejeu, model));
							}
						case 6:
							if (issue.c) {
								var _v42 = issue.a;
								var uid = _v42.a;
								var rendue = issue.b;
								return A3($author$project$Components$Referentiel$Types$Update$offresReglees, uid, rendue, model);
							} else {
								var _v44 = issue.a;
								return $author$project$Components$Referentiel$Types$Update$relireLeTypeRegleApresLaCommande(
									A2($author$project$Components$Referentiel$Types$Update$refuserLesOffres, rejeu, model));
							}
						case 9:
							if (issue.c) {
								var _v8 = issue.a;
								var uid = _v8.a;
								var evolution = _v8.b;
								var rendue = issue.b;
								return $elm$core$List$isEmpty(evolution.fx) ? A2($author$project$Components$Referentiel$Types$Update$gesteAbouti, $author$project$Components$Referentiel$Types$Update$versLInformation, model) : A3($author$project$Components$Referentiel$Types$Update$informationAjoutee, uid, rendue, model);
							} else {
								var _v59 = issue.a;
								var evolution = _v59.b;
								return $elm$core$List$isEmpty(evolution.fx) ? A2($author$project$Components$Referentiel$Types$Update$gesteRefuse, rejeu, model) : A2(
									$author$project$Components$Referentiel$Types$Update$puisAvec,
									$author$project$Components$Referentiel$Types$Update$relireLeTypeRegleApresLaCommande,
									A2(
										$author$project$Components$Referentiel$Types$Update$parLaConduite,
										function (reglage) {
											return A2(
												$author$project$Components$Shared$EditeurDeSchema$Conduite$conclure,
												reglage,
												$author$project$Components$Shared$EditeurDeSchema$Conduite$Refusee(
													$author$project$Components$Shared$EditeurDeSchema$Model$AutreRefus(rejeu)));
										},
										model));
							}
						default:
							if (issue.c) {
								var _v3 = issue.a;
								var uid = _v3.a;
								var rendue = issue.b;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											gv: A2(
												$elm$core$Maybe$map,
												function (fiche) {
													return _Utils_eq(fiche.r0.r8, uid) ? A2($author$project$Components$Referentiel$Types$Update$restreinte, rendue, fiche) : fiche;
												},
												model.gv)
										}),
									_List_Nil);
							} else {
								var _v61 = issue.a;
								var natures = _v61.b;
								return $author$project$Components$Referentiel$Types$Update$relireLeTypeRegleApresLaCommande(
									A3($author$project$Components$Referentiel$Types$Update$refuserLesPorteurs, natures, rejeu, model));
							}
					}
				default:
					switch (issue.a.$) {
						case 7:
							var _v6 = issue.a;
							var refus = issue.b;
							var erreur = issue.c;
							return A3($author$project$Components$Referentiel$Types$Update$cheminRefuse, refus, erreur, model);
						case 8:
							var _v7 = issue.a;
							var refus = issue.b;
							var erreur = issue.c;
							return A3($author$project$Components$Referentiel$Types$Update$cheminRefuse, refus, erreur, model);
						case 19:
							var _v11 = issue.a;
							return $author$project$Components$Referentiel$Types$Update$relireLeTypeRegleApresLaCommande(model);
						case 17:
							var _v16 = issue.a;
							return $author$project$Components$Referentiel$Types$Update$collectionsRefusees(model);
						case 18:
							var _v17 = issue.a;
							return $author$project$Components$Referentiel$Types$Update$collectionsRefusees(model);
						case 10:
							var _v24 = issue.a;
							var refus = issue.b;
							var erreur = issue.c;
							return A2(
								$author$project$Components$Referentiel$Types$Update$gesteRefuse,
								A2($author$project$Components$Referentiel$Types$Update$messageDuGeste, refus, erreur),
								model);
						case 11:
							var _v25 = issue.a;
							var refus = issue.b;
							var erreur = issue.c;
							return A2(
								$author$project$Components$Referentiel$Types$Update$gesteRefuse,
								A2($author$project$Components$Referentiel$Types$Update$messageDuGeste, refus, erreur),
								model);
						case 12:
							var _v26 = issue.a;
							var refus = issue.b;
							var erreur = issue.c;
							return A2(
								$author$project$Components$Referentiel$Types$Update$gesteRefuse,
								A2($author$project$Components$Referentiel$Types$Update$messageDuGeste, refus, erreur),
								model);
						case 16:
							var _v29 = issue.a;
							var refus = issue.b;
							var erreur = issue.c;
							return A3($author$project$Components$Referentiel$Types$Update$ajoutRefuse, refus, erreur, model);
						case 20:
							var _v31 = issue.a;
							return _Utils_Tuple2(
								A2($author$project$Components$Referentiel$Types$Update$avecLeRattacher, $author$project$Components$Referentiel$Common$RattacherUnChamp$elargissementRefuse, model),
								_List_Nil);
						case 21:
							var _v33 = issue.a;
							return _Utils_Tuple2(
								A2(
									$author$project$Components$Referentiel$Types$Update$avecLesInformations,
									function (etat) {
										return _Utils_update(
											etat,
											{
												gf: A2($elm$core$Maybe$map, $author$project$Components$Shared$Bibliotheque$ElargissementDeListe$refuser, etat.gf)
											});
									},
									model),
								_List_Nil);
						case 14:
							var _v36 = issue.a;
							return $author$project$Components$Referentiel$Types$Update$restrictionRefusee(model);
						case 15:
							var _v37 = issue.a;
							return $author$project$Components$Referentiel$Types$Update$restrictionRefusee(model);
						case 13:
							var _v40 = issue.a;
							var refus = issue.b;
							var erreur = issue.c;
							return A2(
								$author$project$Components$Referentiel$Types$Update$gesteRefuse,
								A2($author$project$Components$Referentiel$Types$Update$messageDuGeste, refus, erreur),
								model);
						case 5:
							switch (issue.c.$) {
								case 3:
									var _v53 = issue.a;
									var refus = issue.b;
									var _v54 = issue.c;
									return _Utils_Tuple2(
										A2(
											$author$project$Components$Referentiel$Types$Update$refuserLesOffres,
											{Jx: $author$project$I18n$Textes$referentielParcoursOffresPerimetreRefusLiee, b9: refus.b9},
											model),
										_List_Nil);
								case 2:
									var _v55 = issue.a;
									var refus = issue.b;
									var _v56 = issue.c;
									return _Utils_Tuple2(
										A2(
											$author$project$Components$Referentiel$Types$Update$refuserLesOffres,
											{Jx: $author$project$I18n$Textes$referentielParcoursOffresPerimetreRefusArchive, b9: refus.b9},
											model),
										_List_Nil);
								case 1:
									var _v45 = issue.a;
									var refus = issue.b;
									var _v46 = issue.c;
									return A2($author$project$Components$Referentiel$Types$Update$offresRefusees, refus, model);
								case 6:
									var _v49 = issue.a;
									var refus = issue.b;
									var _v50 = issue.c;
									return A2($author$project$Components$Referentiel$Types$Update$offresConcurrentes, refus, model);
								default:
									var _v57 = issue.a;
									var refus = issue.b;
									return _Utils_Tuple2(
										A2(
											$author$project$Components$Referentiel$Types$Update$refuserLesOffres,
											$author$project$Components$Shared$Messages$Model$duRefus(refus),
											model),
										_List_Nil);
							}
						case 6:
							switch (issue.c.$) {
								case 1:
									var _v47 = issue.a;
									var refus = issue.b;
									var _v48 = issue.c;
									return A2($author$project$Components$Referentiel$Types$Update$offresRefusees, refus, model);
								case 6:
									var _v51 = issue.a;
									var refus = issue.b;
									var _v52 = issue.c;
									return A2($author$project$Components$Referentiel$Types$Update$offresConcurrentes, refus, model);
								default:
									var _v58 = issue.a;
									var refus = issue.b;
									return _Utils_Tuple2(
										A2(
											$author$project$Components$Referentiel$Types$Update$refuserLesOffres,
											$author$project$Components$Shared$Messages$Model$duRefus(refus),
											model),
										_List_Nil);
							}
						case 9:
							var _v60 = issue.a;
							var evolution = _v60.b;
							var refus = issue.b;
							var erreur = issue.c;
							return ($elm$core$List$isEmpty(evolution.fx) && _Utils_eq(model.AM.wC, $elm$core$Maybe$Nothing)) ? A2(
								$author$project$Components$Referentiel$Types$Update$gesteRefuse,
								A2($author$project$Components$Referentiel$Types$Update$messageDuGeste, refus, erreur),
								model) : A3($author$project$Components$Referentiel$Types$Update$informationRefusee, refus, erreur, model);
						case 4:
							switch (issue.c.$) {
								case 1:
									var _v62 = issue.a;
									var natures = _v62.b;
									var refus = issue.b;
									var _v63 = issue.c;
									return $author$project$Components$Referentiel$Types$Update$relireApresLaCommande(
										A3(
											$author$project$Components$Referentiel$Types$Update$refuserLesPorteurs,
											natures,
											{Jx: $author$project$I18n$Textes$referentielTypeErreurArchive, b9: refus.b9},
											model));
								case 6:
									var _v64 = issue.a;
									var natures = _v64.b;
									var refus = issue.b;
									var _v65 = issue.c;
									return $author$project$Components$Referentiel$Types$Update$relireLeTypeRegleApresLaCommande(
										A3(
											$author$project$Components$Referentiel$Types$Update$refuserLesPorteurs,
											natures,
											{Jx: $author$project$I18n$Textes$referentielTypeConcurrente, b9: refus.b9},
											model));
								default:
									var _v66 = issue.a;
									var natures = _v66.b;
									var refus = issue.b;
									return _Utils_Tuple2(
										A3(
											$author$project$Components$Referentiel$Types$Update$refuserLesPorteurs,
											natures,
											$author$project$Components$Shared$Messages$Model$duRefus(refus),
											model),
										_List_Nil);
							}
						default:
							switch (issue.c.$) {
								case 1:
									var commande = issue.a;
									var refus = issue.b;
									var _v67 = issue.c;
									return $author$project$Components$Referentiel$Types$Update$duDrawerDuType(commande) ? $author$project$Components$Referentiel$Types$Update$relireLeTypeApresLaCommande(
										A2(
											$author$project$Components$Referentiel$Types$Update$avecLeType,
											function (consulte) {
												return _Utils_update(
													consulte,
													{
														pZ: $elm$core$Maybe$Just(
															{Jx: $author$project$I18n$Textes$referentielTypeErreurArchive, b9: refus.b9})
													});
											},
											model)) : A4($author$project$Components$Referentiel$Types$Update$refuser, commande, refus, $author$project$Components$Referentiel$Common$API$WriteAPIErrorsModel$TypeDejaArchive, model);
								case 6:
									var commande = issue.a;
									var _v68 = issue.c;
									return $author$project$Components$Referentiel$Types$Update$duDrawerDuType(commande) ? _Utils_Tuple2(
										A2(
											$author$project$Components$Referentiel$Types$Update$avecLeType,
											function (consulte) {
												return _Utils_update(
													consulte,
													{fW: true});
											},
											model),
										_List_fromArray(
											[
												$author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus($author$project$Components$Referentiel$Types$Model$idDuRechargement)
											])) : _Utils_Tuple2(
										A2(
											$author$project$Components$Referentiel$Types$Update$avecLeType,
											function (consulte) {
												return _Utils_update(
													consulte,
													{fW: true});
											},
											_Utils_update(
												model,
												{
													hP: _Utils_update(
														saisie,
														{
															pZ: $elm$core$Maybe$Just(
																{Jx: $author$project$I18n$Textes$referentielTypeConcurrente, b9: $elm$core$Maybe$Nothing})
														})
												})),
										_List_Nil);
								default:
									var commande = issue.a;
									var refus = issue.b;
									var erreur = issue.c;
									return $author$project$Components$Referentiel$Types$Update$duDrawerDuType(commande) ? _Utils_Tuple2(
										A2(
											$author$project$Components$Referentiel$Types$Update$avecLeType,
											function (consulte) {
												return _Utils_update(
													consulte,
													{
														pZ: $elm$core$Maybe$Just(
															$author$project$Components$Shared$Messages$Model$duRefus(refus))
													});
											},
											model),
										_List_fromArray(
											[
												$author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(
												$author$project$Components$Referentiel$Types$Update$foyer(commande))
											])) : A4($author$project$Components$Referentiel$Types$Update$refuser, commande, refus, erreur, model);
							}
					}
			}
		}
		var commande = issue.a;
		return A2(
			$author$project$Components$Referentiel$Types$Update$puisAvec,
			$author$project$Components$Referentiel$Types$Update$relireLeTypeApresLaCommande,
			$author$project$Components$Referentiel$Types$Update$relireApresLaCommande(
				$author$project$Components$Referentiel$Types$Update$duDrawerDuType(commande) ? A2(
					$author$project$Components$Referentiel$Types$Update$avecLeType,
					function (consulte) {
						return _Utils_update(
							consulte,
							{
								pZ: $elm$core$Maybe$Just(rejeu)
							});
					},
					model) : _Utils_update(
					model,
					{
						hP: _Utils_update(
							saisie,
							{
								pZ: $elm$core$Maybe$Just(rejeu)
							})
					})));
	});
var $author$project$Components$Referentiel$Types$CreationRapide$Refusee = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Types$Model$idDeLaCreationRapide = 'types-creation-rapide';
var $author$project$Components$Referentiel$Types$CreationRapide$prefixe = 'drawer-referentiel-type-rapide';
var $author$project$Components$Referentiel$Types$CreationRapide$idDuNom = function (archetype) {
	return $author$project$Components$Referentiel$Types$CreationRapide$prefixe + ('-' + ($elm$core$String$toLower(
		$author$project$Components$Referentiel$Archetype$code(archetype)) + '-nom'));
};
var $author$project$Components$Referentiel$Types$CreationRapide$idDuPremierRefus = function (etat) {
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.fA;
			},
			$author$project$Components$Referentiel$Types$CreationRapide$idDuNom),
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (ligne) {
					return (!_Utils_eq(ligne.nh, $elm$core$Maybe$Nothing)) && (!_Utils_eq(
						ligne.nh,
						$elm$core$Maybe$Just($author$project$Components$Referentiel$Types$CreationRapide$Creee)));
				},
				etat.gV)));
};
var $author$project$Components$Shared$Parcours$Model$enAttente = function (attente) {
	return attente.cF || ((attente.Hw > 0) || (!attente.Go));
};
var $author$project$Components$Referentiel$Common$EnvoiDeType$enCours = $author$project$API$Envoi$enCours;
var $author$project$Components$Referentiel$Types$Model$enAttente = function (model) {
	return $author$project$Components$Shared$Parcours$Model$enAttente(
		{
			cF: $author$project$Components$Referentiel$Common$EnvoiDeType$enCours(model.l2),
			Go: !_Utils_eq(model.l2, $author$project$API$Envoi$SansProcessUid),
			Hw: model.Hv
		});
};
var $author$project$Components$Referentiel$Types$Update$puisAvecLeFocusDeLaRapide = function (_v0) {
	var model = _v0.a;
	var effets = _v0.b;
	return (model.mM && (!$author$project$Components$Referentiel$Types$Model$enAttente(model))) ? _Utils_Tuple2(
		_Utils_update(
			model,
			{mM: false}),
		_Utils_ap(
			effets,
			_List_fromArray(
				[
					$author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus($author$project$Components$Referentiel$Types$Model$idDeLaCreationRapide)
				]))) : _Utils_Tuple2(model, effets);
};
var $author$project$Components$Referentiel$Types$CreationRapide$termine = function (etat) {
	return $elm$core$List$isEmpty(etat.zF) && _Utils_eq(etat.gn, $elm$core$Maybe$Nothing);
};
var $author$project$Components$Referentiel$Types$CreationRapide$aCreer = function (etat) {
	return A2(
		$elm$core$List$filter,
		function (ligne) {
			return ligne.vt && (!_Utils_eq(
				ligne.nh,
				$elm$core$Maybe$Just($author$project$Components$Referentiel$Types$CreationRapide$Creee)));
		},
		etat.gV);
};
var $author$project$Components$Referentiel$Types$CreationRapide$nombreCrees = function (etat) {
	return $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			function (ligne) {
				return _Utils_eq(
					ligne.nh,
					$elm$core$Maybe$Just($author$project$Components$Referentiel$Types$CreationRapide$Creee));
			},
			etat.gV));
};
var $author$project$Components$Referentiel$Types$CreationRapide$nombreRefuses = function (etat) {
	return $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			function (ligne) {
				return (!_Utils_eq(ligne.nh, $elm$core$Maybe$Nothing)) && (!_Utils_eq(
					ligne.nh,
					$elm$core$Maybe$Just($author$project$Components$Referentiel$Types$CreationRapide$Creee)));
			},
			etat.gV));
};
var $author$project$Components$Referentiel$Types$CreationRapide$toutEstCree = function (etat) {
	return ($author$project$Components$Referentiel$Types$CreationRapide$nombreCrees(etat) > 0) && ((!$author$project$Components$Referentiel$Types$CreationRapide$nombreRefuses(etat)) && $elm$core$List$isEmpty(
		$author$project$Components$Referentiel$Types$CreationRapide$aCreer(etat)));
};
var $author$project$Components$Referentiel$Types$CreationRapide$nombreACreer = A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Types$CreationRapide$aCreer, $elm$core$List$length);
var $author$project$Components$Referentiel$Types$Update$versLaRapide = F2(
	function (geste, model) {
		var enCours = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (etat) {
					return $author$project$Components$Referentiel$Types$CreationRapide$nombreACreer(etat) > 0;
				},
				model.ki));
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? _Utils_update(
					model,
					{pJ: drawer}) : _Utils_update(
					model,
					{
						ki: A2(
							$elm$core$Maybe$andThen,
							function (etat) {
								return _Utils_eq(etat.gn, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
									_Utils_update(
										etat,
										{zF: _List_Nil}));
							},
							model.ki),
						pJ: drawer
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: enCours},
				geste,
				model.pJ));
	});
var $author$project$Components$Referentiel$Types$Update$finDeLaRapide = function (model) {
	var _v0 = model.ki;
	if (!_v0.$) {
		var etat = _v0.a;
		return (!$author$project$Components$Referentiel$Types$CreationRapide$termine(etat)) ? _Utils_Tuple2(model, _List_Nil) : ((!$author$project$Components$Shared$Drawer$Model$estOuvert(model.pJ)) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{ki: $elm$core$Maybe$Nothing}),
			_List_Nil) : ($author$project$Components$Referentiel$Types$CreationRapide$toutEstCree(etat) ? $author$project$Components$Referentiel$Types$Update$puisAvecLeFocusDeLaRapide(
			A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$List$filter(
					$elm$core$Basics$neq(
						$author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus($author$project$Components$Referentiel$Types$Model$idDeLaCreationRapide))),
				A2(
					$author$project$Components$Referentiel$Types$Update$versLaRapide,
					$author$project$Components$Shared$Drawer$Update$Fermer,
					_Utils_update(
						model,
						{mM: true})))) : _Utils_Tuple2(
			model,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus, $elm$core$List$singleton),
					$author$project$Components$Referentiel$Types$CreationRapide$idDuPremierRefus(etat))))));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Types$CreationRapide$terminer = F3(
	function (archetype, issue, etat) {
		return A3(
			$author$project$Components$Referentiel$Types$CreationRapide$surLaLigne,
			archetype,
			function (ligne) {
				return _Utils_update(
					ligne,
					{
						nh: $elm$core$Maybe$Just(issue)
					});
			},
			_Utils_update(
				etat,
				{gn: $elm$core$Maybe$Nothing}));
	});
var $author$project$Components$Referentiel$Types$Update$creeeParLaRapide = F4(
	function (archetype, rendue, conforme, model) {
		return conforme ? A2(
			$elm$core$Tuple$mapSecond,
			function (effets) {
				return _Utils_ap(
					effets,
					$author$project$Components$Referentiel$Types$Update$relectureDiffereeSiBesoin(rendue));
			},
			$author$project$Components$Referentiel$Types$Update$finDeLaRapide(
				A2(
					$author$project$Components$Referentiel$Types$Update$avecLaRapide,
					A2($author$project$Components$Referentiel$Types$CreationRapide$terminer, archetype, $author$project$Components$Referentiel$Types$CreationRapide$Creee),
					A2(
						$author$project$Components$Referentiel$Types$Model$ajouter,
						rendue,
						A2($author$project$Components$Referentiel$Types$Update$apresLaCommande, rendue, model))))) : $author$project$Components$Referentiel$Types$Update$finDeLaRapide(
			A2(
				$author$project$Components$Referentiel$Types$Update$avecLaRapide,
				A2(
					$author$project$Components$Referentiel$Types$CreationRapide$terminer,
					archetype,
					$author$project$Components$Referentiel$Types$CreationRapide$Refusee(
						{Jx: $author$project$I18n$Textes$referentielTypesErreurRejeu, b9: $elm$core$Maybe$Nothing})),
				model));
	});
var $author$project$Components$Referentiel$Types$Update$estEnVol = F2(
	function (archetype, model) {
		return _Utils_eq(
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.gn;
				},
				model.ki),
			$elm$core$Maybe$Just(archetype));
	});
var $author$project$Components$Referentiel$Types$CreationRapide$interrompre = function (etat) {
	return _Utils_update(
		etat,
		{gn: $elm$core$Maybe$Nothing, zF: _List_Nil});
};
var $author$project$Components$Referentiel$Types$CreationRapide$NomPris = {$: 1};
var $author$project$Components$Referentiel$Types$CreationRapide$abandonnerLaFile = function (etat) {
	return _Utils_update(
		etat,
		{zF: _List_Nil});
};
var $author$project$Components$Referentiel$Types$Update$refuseeParLaRapide = F4(
	function (archetype, refus, erreur, model) {
		var issue = function () {
			switch (erreur.$) {
				case 0:
					return $author$project$Components$Referentiel$Types$CreationRapide$NomPris;
				case 4:
					return $author$project$Components$Referentiel$Types$CreationRapide$Refusee(
						{Jx: $author$project$I18n$Textes$referentielTypesErreurLibelleRefuse, b9: refus.b9});
				default:
					return $author$project$Components$Referentiel$Types$CreationRapide$Refusee(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
			}
		}();
		var termine = A2(
			$author$project$Components$Referentiel$Types$Update$avecLaRapide,
			A2($author$project$Components$Referentiel$Types$CreationRapide$terminer, archetype, issue),
			model);
		return $author$project$Components$Referentiel$Types$Update$finDeLaRapide(
			_Utils_eq(model.l2, $author$project$API$Envoi$SansProcessUid) ? termine : A2($author$project$Components$Referentiel$Types$Update$avecLaRapide, $author$project$Components$Referentiel$Types$CreationRapide$abandonnerLaFile, termine));
	});
var $author$project$Components$Referentiel$Types$Update$conclure = F2(
	function (issue, model) {
		_v0$3:
		while (true) {
			switch (issue.$) {
				case 0:
					if (!issue.a.$) {
						var _v1 = issue.a;
						var archetype = _v1.a;
						var rendue = issue.b;
						var conforme = issue.c;
						return A2($author$project$Components$Referentiel$Types$Update$estEnVol, archetype, model) ? A4($author$project$Components$Referentiel$Types$Update$creeeParLaRapide, archetype, rendue, conforme, model) : A2($author$project$Components$Referentiel$Types$Update$conclureUnGeste, issue, model);
					} else {
						break _v0$3;
					}
				case 1:
					if (!issue.a.$) {
						var _v2 = issue.a;
						var archetype = _v2.a;
						var refus = issue.b;
						var erreur = issue.c;
						return A2($author$project$Components$Referentiel$Types$Update$estEnVol, archetype, model) ? A4($author$project$Components$Referentiel$Types$Update$refuseeParLaRapide, archetype, refus, erreur, model) : A2($author$project$Components$Referentiel$Types$Update$conclureUnGeste, issue, model);
					} else {
						break _v0$3;
					}
				default:
					return A2(
						$author$project$Components$Referentiel$Types$Update$conclureUnGeste,
						issue,
						A2($author$project$Components$Referentiel$Types$Update$avecLaRapide, $author$project$Components$Referentiel$Types$CreationRapide$interrompre, model));
			}
		}
		return A2($author$project$Components$Referentiel$Types$Update$conclureUnGeste, issue, model);
	});
var $author$project$Components$Shared$Bibliotheque$ElargissementDeListe$confirmer = F2(
	function (confirme, elargissement) {
		return _Utils_update(
			elargissement,
			{dB: confirme, qa: false});
	});
var $author$project$Components$Referentiel$Types$Model$idDeLaPastille = function (uid) {
	return 'type-' + $author$project$Components$Referentiel$Identifiants$typeUidToString(uid);
};
var $author$project$API$NavLinksDictionary$creerType = 'creer-type';
var $author$project$Components$Referentiel$Types$Model$creation = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.nQ;
			},
			$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$creerType)),
		model.aS);
};
var $author$project$Components$Referentiel$Types$Model$idDeLaCreation = 'types-creer';
var $author$project$Components$Referentiel$Types$Parcours$nom = function (etape) {
	switch (etape) {
		case 0:
			return 'vos-types';
		case 1:
			return 'porteurs';
		case 2:
			return 'offres';
		case 3:
			return 'statuts';
		case 4:
			return 'informations';
		case 5:
			return 'conservation';
		case 6:
			return 'liens';
		default:
			return 'verification';
	}
};
var $author$project$Components$Referentiel$Types$Parcours$idDuTitre = function (etape) {
	return $author$project$Components$Shared$Parcours$Model$idDuTitre(
		$author$project$Components$Referentiel$Types$Parcours$nom(etape));
};
var $author$project$Components$Referentiel$Types$Model$typesAffiches = function (model) {
	var terme = $elm$core$String$toLower(
		$elm$core$String$trim(model.hC));
	var porte = function (libelle) {
		return A2(
			$elm$core$String$contains,
			terme,
			$elm$core$String$toLower(libelle));
	};
	return A2(
		$elm$core$List$filter,
		function (lu) {
			return porte(lu.R.zX) || A2(
				$elm$core$Maybe$withDefault,
				false,
				A2($elm$core$Maybe$map, porte, lu.R.yg));
		},
		$author$project$Components$Referentiel$Types$Model$types(model));
};
var $author$project$Components$Referentiel$Types$Update$focusAffiche = F2(
	function (cible, model) {
		var pastilles = A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.r8;
				},
				$author$project$Components$Referentiel$Types$Model$idDeLaPastille),
			$author$project$Components$Referentiel$Types$Model$typesAffiches(model));
		var pastilleAbsente = _Utils_eq(
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.r8;
					},
					$author$project$Components$Referentiel$Types$Model$idDeLaPastille),
				model.bA),
			$elm$core$Maybe$Just(cible)) && (!A2($elm$core$List$member, cible, pastilles));
		return (!pastilleAbsente) ? cible : ((!_Utils_eq(
			$author$project$Components$Referentiel$Types$Model$creation(model),
			$elm$core$Maybe$Nothing)) ? $author$project$Components$Referentiel$Types$Model$idDeLaCreation : $author$project$Components$Referentiel$Types$Parcours$idDuTitre(0));
	});
var $author$project$Components$Referentiel$Types$Update$versLaConsultation = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{
						j9: drawer,
						bA: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? model.bA : $elm$core$Maybe$Nothing
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(
						A2($author$project$Components$Referentiel$Types$Update$focusAffiche, cible, model));
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.j9));
	});
var $author$project$Components$Referentiel$Types$Update$consulter = F2(
	function (uid, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$self)),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.r8;
						},
						$elm$core$Basics$eq(uid)),
					$author$project$Components$Referentiel$Types$Model$types(model))));
		if (!_v0.$) {
			var lien = _v0.a;
			return A2(
				$elm$core$Tuple$mapSecond,
				function (effets) {
					return _Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Components$Referentiel$Common$EffetDeType$LireLeType(lien)
							]));
				},
				A2(
					$author$project$Components$Referentiel$Types$Update$versLaConsultation,
					$author$project$Components$Shared$Drawer$Update$Ouvrir(
						$author$project$Components$Referentiel$Types$Model$idDeLaPastille(uid)),
					_Utils_update(
						model,
						{
							bA: $elm$core$Maybe$Just(
								{ir: false, fW: false, zo: $elm$core$Maybe$Nothing, pZ: $elm$core$Maybe$Nothing, r8: uid})
						})));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Types$Informations$editer = function (lu) {
	return {
		dy: lu.uN.dy,
		R: $author$project$Components$Shared$LibellesParLangue$Model$depuis(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2('fr', lu.uN.Bl),
				lu.uN.R)),
		he: lu.uN.he,
		Ff: lu.uN.xD,
		hL: false
	};
};
var $author$project$Components$Referentiel$Types$Model$idDUneInformation = function (cle) {
	return 'information-' + cle;
};
var $author$project$Components$Referentiel$Types$Update$consulterUneInformation = F2(
	function (cle, model) {
		var lue = A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.dw;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$filter(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.uN;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.dy;
								},
								$elm$core$Basics$eq(cle)))),
					$elm$core$List$head)),
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.aN;
				},
				$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model)));
		var ouverte = function (etat) {
			return _Utils_update(
				etat,
				{
					ge: A2($elm$core$Maybe$map, $author$project$Components$Referentiel$Types$Informations$editer, lue),
					pZ: $elm$core$Maybe$Nothing
				});
		};
		if (!lue.$) {
			var champ = lue.a;
			return champ.n4 ? (_Utils_eq(
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$afficherUnChamp, champ.nQ),
				$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A2(
				$author$project$Components$Referentiel$Types$Update$versLaMasquee,
				$author$project$Components$Shared$Drawer$Update$Ouvrir(
					$author$project$Components$Referentiel$Types$Model$idDUneInformation(cle)),
				A2($author$project$Components$Referentiel$Types$Update$avecLesInformations, ouverte, model))) : (_Utils_eq(
				$author$project$Components$Referentiel$Types$Model$lienDesInformations(model),
				$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A2(
				$author$project$Components$Referentiel$Types$Update$versLInformation,
				$author$project$Components$Shared$Drawer$Update$Ouvrir(
					$author$project$Components$Referentiel$Types$Model$idDUneInformation(cle)),
				A2($author$project$Components$Referentiel$Types$Update$avecLesInformations, ouverte, model)));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$CreerUnType = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Referentiel$Common$SaisieDeType$nonVide = function (texte) {
	return $elm$core$String$isEmpty(
		$elm$core$String$trim(texte)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		$elm$core$String$trim(texte));
};
var $author$project$Components$Referentiel$Common$SaisieDeType$apparence = function (saisie) {
	return A2(
		$elm$core$Maybe$map,
		function (fr) {
			return {
				kf: $author$project$Components$Referentiel$Common$SaisieDeType$nonVide(saisie.kf),
				aC: $author$project$Components$Referentiel$Common$SaisieDeType$nonVide(saisie.aC),
				R: {
					yg: $author$project$Components$Referentiel$Common$SaisieDeType$nonVide(
						A2($author$project$Components$Shared$LibellesParLangue$Model$lire, 'en', saisie.R)),
					zX: fr
				}
			};
		},
		$author$project$Components$Referentiel$Common$SaisieDeType$nonVide(
			A2($author$project$Components$Shared$LibellesParLangue$Model$lire, 'fr', saisie.R)));
};
var $author$project$Components$Referentiel$Common$SaisieDeType$archetype = function (saisie) {
	return $author$project$Components$Referentiel$Archetype$fromCode(saisie.fA);
};
var $author$project$Components$Referentiel$Types$Model$commandeDeCreation = function (model) {
	return A4(
		$elm$core$Maybe$map3,
		F3(
			function (lien, archetype, apparence) {
				return _Utils_Tuple2(
					A2($author$project$Components$Referentiel$Common$API$WriteAPIModel$CreerUnType, archetype, apparence),
					lien);
			}),
		$author$project$Components$Referentiel$Types$Model$creation(model),
		$author$project$Components$Referentiel$Common$SaisieDeType$archetype(model.hP),
		$author$project$Components$Referentiel$Common$SaisieDeType$apparence(model.hP));
};
var $author$project$Components$Referentiel$Common$SaisieDeType$idDeLArchetype = function (prefixe) {
	return prefixe + '-archetype';
};
var $author$project$Components$Shared$LibellesParLangue$Model$manquantes = F2(
	function (langues, saisie) {
		return A2(
			$elm$core$List$map,
			function ($) {
				return $.vx;
			},
			A2(
				$elm$core$List$filter,
				function (langue) {
					return langue.he && $elm$core$String$isEmpty(
						$elm$core$String$trim(
							A2($author$project$Components$Shared$LibellesParLangue$Model$lire, langue.vx, saisie)));
				},
				langues));
	});
var $author$project$Components$Referentiel$Common$SaisieDeType$idDuPremierDefaut = F3(
	function (_v0, prefixe, saisie) {
		var avecArchetype = _v0.uc;
		var _v1 = $elm$core$List$head(
			A2($author$project$Components$Shared$LibellesParLangue$Model$manquantes, $author$project$Referentiel$Langues$desLibelles, saisie.R));
		if (!_v1.$) {
			var code = _v1.a;
			return $elm$core$Maybe$Just(
				A2($author$project$Components$Referentiel$Common$SaisieDeType$idDuLibelle, prefixe, code));
		} else {
			return (avecArchetype && _Utils_eq(
				$author$project$Components$Referentiel$Common$SaisieDeType$archetype(saisie),
				$elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(
				$author$project$Components$Referentiel$Common$SaisieDeType$idDeLArchetype(prefixe)) : $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Referentiel$Common$SaisieDeType$tenter = function (saisie) {
	return _Utils_update(
		saisie,
		{b5: true});
};
var $author$project$Components$Referentiel$Types$Update$creer = function (model) {
	var saisie = model.hP;
	var _v0 = $author$project$Components$Referentiel$Types$Model$commandeDeCreation(model);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var commande = _v1.a;
		var lien = _v1.b;
		var _v2 = A3(
			$author$project$Components$Referentiel$Common$EnvoiDeType$partir,
			$elm$core$Maybe$Just(lien),
			commande,
			model.l2);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var envoi = _v3.a;
			var effets = _v3.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: envoi,
						hP: _Utils_update(
							saisie,
							{pZ: $elm$core$Maybe$Nothing})
					}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_eq(
			$author$project$Components$Referentiel$Types$Model$creation(model),
			$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : _Utils_Tuple2(
			_Utils_update(
				model,
				{
					hP: $author$project$Components$Referentiel$Common$SaisieDeType$tenter(saisie)
				}),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus, $elm$core$List$singleton),
					A3(
						$author$project$Components$Referentiel$Common$SaisieDeType$idDuPremierDefaut,
						{uc: true},
						$author$project$Components$Referentiel$Types$Model$prefixe(model),
						saisie))));
	}
};
var $author$project$Components$Referentiel$Types$Chemin$depuis = function (libelles) {
	return $author$project$Components$Shared$LibellesParLangue$Model$depuis(
		_List_fromArray(
			[
				_Utils_Tuple2('fr', libelles.zX),
				_Utils_Tuple2(
				'en',
				A2($elm$core$Maybe$withDefault, '', libelles.yg))
			]));
};
var $author$project$Components$Referentiel$Types$Chemin$edition = F2(
	function (fiche, element) {
		var statuts = $author$project$Components$Referentiel$Types$Chemin$proposesDesStatuts(fiche);
		var resultats = $author$project$Components$Referentiel$Types$Chemin$proposesDesResultats(fiche);
		var rang = F2(
			function (id, liste) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$second,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(id))),
						A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, liste)));
			});
		var ouverte = F4(
			function (libelles, position, depart, retire) {
				return {
					fW: false,
					cx: depart,
					lQ: element,
					R: libelles,
					Dj: A2($author$project$Components$Shared$LibellesParLangue$Model$lire, 'fr', libelles),
					bc: position,
					pZ: $elm$core$Maybe$Nothing,
					HZ: retire,
					b5: false
				};
			});
		switch (element.$) {
			case 2:
				return $elm$core$Maybe$Just(
					A4(
						ouverte,
						$author$project$Components$Shared$LibellesParLangue$Model$vide,
						$elm$core$List$length(statuts),
						_Utils_eq(
							$author$project$Components$Referentiel$Types$Chemin$statutDeDepart(statuts),
							$elm$core$Maybe$Nothing),
						false));
			case 3:
				return $elm$core$Maybe$Just(
					A4(
						ouverte,
						$author$project$Components$Shared$LibellesParLangue$Model$vide,
						$elm$core$List$length(resultats),
						false,
						false));
			case 0:
				var id = element.a;
				return A2(
					$elm$core$Maybe$map,
					function (lu) {
						return A4(
							ouverte,
							$author$project$Components$Referentiel$Types$Chemin$depuis(lu.R),
							A2(
								$elm$core$Maybe$withDefault,
								$elm$core$List$length(statuts),
								A2(
									$elm$core$Maybe$map,
									$elm$core$Tuple$first,
									A2(rang, id, statuts))),
							lu.AO,
							lu.HZ);
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(id)),
							fiche.I1)));
			default:
				var id = element.a;
				return A2(
					$elm$core$Maybe$andThen,
					function (lu) {
						return A2(
							$elm$core$Maybe$map,
							function (libelles) {
								return A4(
									ouverte,
									$author$project$Components$Referentiel$Types$Chemin$depuis(libelles),
									A2(
										$elm$core$Maybe$withDefault,
										$elm$core$List$length(resultats),
										A2(
											$elm$core$Maybe$map,
											$elm$core$Tuple$first,
											A2(rang, id, resultats))),
									false,
									lu.HZ);
							},
							lu.R);
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (lu) {
								return _Utils_eq(lu.Aq, id) && (!lu.rv);
							},
							fiche.bh)));
		}
	});
var $author$project$API$NavLinksDictionary$definirResultats = 'definir-resultats';
var $author$project$API$NavLinksDictionary$definirStatuts = 'definir-statuts';
var $author$project$Components$Referentiel$Types$Model$lienDuChemin = F2(
	function (element, model) {
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.r0;
				},
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nQ;
					},
					$author$project$API$Liens$trouver(
						$author$project$Components$Referentiel$Types$Chemin$estUnStatut(element) ? $author$project$API$NavLinksDictionary$definirStatuts : $author$project$API$NavLinksDictionary$definirResultats))),
			$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model));
	});
var $author$project$Components$Referentiel$Types$Model$ficheDuChemin = function (model) {
	var _v0 = _Utils_Tuple3(
		model.u8,
		model.ge,
		$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model));
	if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
		var lie = _v0.a.a;
		var saisie = _v0.b.a;
		var fiche = _v0.c.a;
		return (_Utils_eq(fiche.r0.r8, lie.r8) && ((!_Utils_eq(
			A2($author$project$Components$Referentiel$Types$Model$lienDuChemin, saisie.lQ, model),
			$elm$core$Maybe$Nothing)) && (!_Utils_eq(
			A2($author$project$Components$Referentiel$Types$Chemin$edition, fiche, saisie.lQ),
			$elm$core$Maybe$Nothing)))) ? $elm$core$Maybe$Just(fiche) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Types$Model$cheminPerime = function (model) {
	return (!_Utils_eq(model.u8, $elm$core$Maybe$Nothing)) && _Utils_eq(
		$author$project$Components$Referentiel$Types$Model$ficheDuChemin(model),
		$elm$core$Maybe$Nothing);
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$DefinirLesResultats = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$DefinirLesStatuts = F3(
	function (a, b, c) {
		return {$: 7, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Types$Chemin$commande = F3(
	function (uid, fiche, saisie) {
		return A2(
			$elm$core$Maybe$map,
			function (_v0) {
				var statuts = _v0.a;
				var resultats = _v0.b;
				var initial = _v0.c;
				return $author$project$Components$Referentiel$Types$Chemin$estUnStatut(saisie.lQ) ? A3($author$project$Components$Referentiel$Common$API$WriteAPIModel$DefinirLesStatuts, uid, statuts, initial) : A2($author$project$Components$Referentiel$Common$API$WriteAPIModel$DefinirLesResultats, uid, resultats);
			},
			A2($author$project$Components$Referentiel$Types$Chemin$voulus, fiche, saisie));
	});
var $author$project$Components$Referentiel$Types$Model$commandeDuChemin = function (model) {
	var _v0 = _Utils_Tuple3(
		model.u8,
		model.ge,
		$author$project$Components$Referentiel$Types$Model$ficheDuChemin(model));
	if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
		var lie = _v0.a.a;
		var saisie = _v0.b.a;
		var fiche = _v0.c.a;
		return A2(
			$elm$core$Maybe$map,
			function (commande) {
				return _Utils_Tuple2(commande, lie.nB);
			},
			A3($author$project$Components$Referentiel$Types$Chemin$commande, lie.r8, fiche, saisie));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Types$Chemin$idDuLibelle = F2(
	function (prefixe, code) {
		return A2($author$project$Components$Shared$LibellesParLangue$View$idDuChamp, prefixe + '-libelle', code);
	});
var $author$project$Components$Referentiel$Types$Chemin$libelleManquant = function (saisie) {
	return saisie.b5 ? $elm$core$List$head(
		A2($author$project$Components$Shared$LibellesParLangue$Model$manquantes, $author$project$Referentiel$Langues$desLibelles, saisie.R)) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$Referentiel$Types$Model$prefixeDuChemin = function (model) {
	return $author$project$Components$Shared$Drawer$Model$idRacine(model.jK);
};
var $author$project$Components$Referentiel$Types$Chemin$tenter = function (saisie) {
	return _Utils_update(
		saisie,
		{b5: true});
};
var $author$project$Components$Referentiel$Types$Update$definirLeChemin = function (model) {
	var _v0 = _Utils_Tuple2(
		model.ge,
		$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var saisie = _v0.a.a;
		var fiche = _v0.b.a;
		if ((!$author$project$Components$Shared$Drawer$Model$estOuvert(model.jK)) || $author$project$Components$Referentiel$Types$Model$cheminPerime(model)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v1 = $author$project$Components$Referentiel$Types$Model$commandeDuChemin(model);
			if (!_v1.$) {
				var _v2 = _v1.a;
				var commande = _v2.a;
				var lien = _v2.b;
				if (!A2($author$project$Components$Referentiel$Types$Chemin$changee, fiche, saisie)) {
					return A2($author$project$Components$Referentiel$Types$Update$versLeChemin, $author$project$Components$Shared$Drawer$Update$Fermer, model);
				} else {
					var _v3 = A3(
						$author$project$Components$Referentiel$Common$EnvoiDeType$partir,
						$elm$core$Maybe$Just(lien),
						commande,
						model.l2);
					if (!_v3.$) {
						var _v4 = _v3.a;
						var envoi = _v4.a;
						var effets = _v4.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									ge: $elm$core$Maybe$Just(
										_Utils_update(
											saisie,
											{fW: false, pZ: $elm$core$Maybe$Nothing})),
									l2: envoi
								}),
							effets);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				}
			} else {
				var tentee = $author$project$Components$Referentiel$Types$Chemin$tenter(saisie);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ge: $elm$core$Maybe$Just(tentee)
						}),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Components$Referentiel$Types$Chemin$idDuLibelle(
									$author$project$Components$Referentiel$Types$Model$prefixeDuChemin(model)),
								A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus, $elm$core$List$singleton)),
							$author$project$Components$Referentiel$Types$Chemin$libelleManquant(tentee))));
			}
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Shared$Bibliotheque$ElargissementDeListe$demande = function (elargissement) {
	return elargissement.dB ? $elm$core$Maybe$Just(
		{nB: elargissement.nB, nW: elargissement.nW, sn: 'catalogue-et-parties-prenantes'}) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$Referentiel$Common$EffetDeType$LireLesVersions = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Referentiel$Types$Model$idDeLHistorique = 'informations-historique';
var $author$project$Components$Referentiel$Types$Update$versLesVersions = F2(
	function (geste, model) {
		var etat = model.AM;
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{
						AM: _Utils_update(
							etat,
							{ss: drawer})
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var vers = _v0;
					return $author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(vers);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				etat.ss));
	});
var $author$project$API$NavLinksDictionary$versionsDuSchema = 'versions-du-schema';
var $author$project$Components$Referentiel$Types$Update$demanderLHistorique = function (model) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.r0;
			},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$versionsDuSchema))),
		$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model));
	if (!_v0.$) {
		var lien = _v0.a;
		return A2(
			$elm$core$Tuple$mapSecond,
			function (effets) {
				return _Utils_ap(
					effets,
					_List_fromArray(
						[
							$author$project$Components$Referentiel$Common$EffetDeType$LireLesVersions(lien)
						]));
			},
			A2(
				$author$project$Components$Referentiel$Types$Update$versLesVersions,
				$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Referentiel$Types$Model$idDeLHistorique),
				A2(
					$author$project$Components$Referentiel$Types$Update$avecLesInformations,
					function (etat) {
						return _Utils_update(
							etat,
							{m6: $elm$core$Maybe$Nothing, pZ: $elm$core$Maybe$Nothing});
					},
					model)));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Types$CreationRapide$demander = function (etat) {
	var voulues = A2(
		$elm$core$List$map,
		function ($) {
			return $.fA;
		},
		$author$project$Components$Referentiel$Types$CreationRapide$aCreer(etat));
	return _Utils_update(
		etat,
		{
			zF: voulues,
			gV: A2(
				$elm$core$List$map,
				function (ligne) {
					return A2($elm$core$List$member, ligne.fA, voulues) ? _Utils_update(
						ligne,
						{nh: $elm$core$Maybe$Nothing}) : ligne;
				},
				etat.gV),
			b5: false
		});
};
var $author$project$Components$Referentiel$Types$CreationRapide$commande = F2(
	function (archetype, etat) {
		return A2(
			$elm$core$Maybe$map,
			function (ligne) {
				return A2(
					$author$project$Components$Referentiel$Common$API$WriteAPIModel$CreerUnType,
					archetype,
					{
						kf: $elm$core$Maybe$Nothing,
						aC: $elm$core$Maybe$Nothing,
						R: {
							yg: $elm$core$Maybe$Nothing,
							zX: $elm$core$String$trim(ligne.Dj)
						}
					});
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.fA;
						},
						$elm$core$Basics$eq(archetype)),
					etat.gV)));
	});
var $author$project$Components$Referentiel$Types$CreationRapide$envoyer = function (etat) {
	var _v0 = etat.zF;
	if (_v0.b) {
		var prochain = _v0.a;
		var reste = _v0.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(
				prochain,
				_Utils_update(
					etat,
					{
						gn: $elm$core$Maybe$Just(prochain),
						zF: reste
					})));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Types$Update$envoyerLaSuivante = function (model) {
	var _v0 = _Utils_Tuple2(
		model.ki,
		$author$project$Components$Referentiel$Types$Model$creation(model));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var etat = _v0.a.a;
		var lien = _v0.b.a;
		if (!_Utils_eq(etat.gn, $elm$core$Maybe$Nothing)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v1 = $author$project$Components$Referentiel$Types$CreationRapide$envoyer(etat);
			if (!_v1.$) {
				var _v2 = _v1.a;
				var archetype = _v2.a;
				var suivi = _v2.b;
				var _v3 = A2(
					$elm$core$Maybe$andThen,
					function (commande) {
						return A3(
							$author$project$Components$Referentiel$Common$EnvoiDeType$partir,
							$elm$core$Maybe$Just(lien),
							commande,
							model.l2);
					},
					A2($author$project$Components$Referentiel$Types$CreationRapide$commande, archetype, etat));
				if (!_v3.$) {
					var _v4 = _v3.a;
					var envoi = _v4.a;
					var effets = _v4.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ki: $elm$core$Maybe$Just(suivi),
								l2: envoi
							}),
						effets);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Types$CreationRapide$premierNomManquant = function (etat) {
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.fA;
		},
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Dj;
					},
					A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$String$isEmpty)),
				$author$project$Components$Referentiel$Types$CreationRapide$aCreer(etat))));
};
var $author$project$Components$Referentiel$Types$CreationRapide$tenter = function (etat) {
	return _Utils_update(
		etat,
		{b5: true});
};
var $author$project$Components$Referentiel$Types$Update$demanderLaRapide = function (model) {
	var _v0 = model.ki;
	if (!_v0.$) {
		var etat = _v0.a;
		if ((!$author$project$Components$Shared$Drawer$Model$estOuvert(model.pJ)) || ($author$project$Components$Referentiel$Types$Model$enAttente(model) || (!$author$project$Components$Referentiel$Types$CreationRapide$nombreACreer(etat)))) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v1 = $author$project$Components$Referentiel$Types$CreationRapide$premierNomManquant(etat);
			if (!_v1.$) {
				var manquant = _v1.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ki: $elm$core$Maybe$Just(
								$author$project$Components$Referentiel$Types$CreationRapide$tenter(etat))
						}),
					_List_fromArray(
						[
							$author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(
							$author$project$Components$Referentiel$Types$CreationRapide$idDuNom(manquant))
						]));
			} else {
				return $author$project$Components$Referentiel$Types$Update$envoyerLaSuivante(
					_Utils_update(
						model,
						{
							ki: $elm$core$Maybe$Just(
								$author$project$Components$Referentiel$Types$CreationRapide$demander(etat))
						}));
			}
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Common$EffetDeType$LireLaListeDuChamp = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Referentiel$Types$RestrictionDuChamp$champDe = F2(
	function (cle, fiche) {
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.dw;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$filter(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.uN;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.dy;
								},
								$elm$core$Basics$eq(cle)))),
					$elm$core$List$head)),
			fiche.aN);
	});
var $author$project$API$NavLinksDictionary$listeDuChamp = 'liste-du-champ';
var $author$project$API$NavLinksDictionary$restreindreLesValeurs = 'restreindre-les-valeurs';
var $author$project$Components$Referentiel$Types$RestrictionDuChamp$demander = F2(
	function (cle, fiche) {
		return A2(
			$elm$core$Maybe$andThen,
			function (lu) {
				var _v0 = _Utils_Tuple2(
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$restreindreLesValeurs, lu.nQ),
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$listeDuChamp, lu.nQ));
				if ((!_v0.a.$) && (!_v0.b.$)) {
					var liste = _v0.b.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							{dy: cle, gt: $elm$core$Maybe$Nothing},
							liste));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			A2($author$project$Components$Referentiel$Types$RestrictionDuChamp$champDe, cle, fiche));
	});
var $author$project$Components$Referentiel$Types$Update$demanderLaRestriction = F2(
	function (cle, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			$author$project$Components$Referentiel$Types$RestrictionDuChamp$demander(cle),
			$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model));
		if (!_v0.$) {
			var _v1 = _v0.a;
			var enCours = _v1.a;
			var lien = _v1.b;
			return _Utils_Tuple2(
				A2(
					$author$project$Components$Referentiel$Types$Update$avecLesInformations,
					function (etat) {
						return _Utils_update(
							etat,
							{
								al: $elm$core$Maybe$Just(enCours)
							});
					},
					model),
				_List_fromArray(
					[
						$author$project$Components$Referentiel$Common$EffetDeType$LireLaListeDuChamp(lien)
					]));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Common$Offres$depuis = $elm$core$List$map(
	function (offre) {
		return {tL: offre.tL, uK: offre.uK, Aq: offre.Aq, Dj: offre.Dj};
	});
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$RestreindreLesValeursDUnType = F3(
	function (a, b, c) {
		return {$: 14, a: a, b: b, c: c};
	});
var $author$project$Components$Shared$Bibliotheque$Restriction$estVide = function (restriction) {
	return $elm$core$Set$isEmpty(restriction.L);
};
var $author$project$Components$Shared$Bibliotheque$Restriction$nombreRetenues = function (restriction) {
	return $elm$core$Set$size(restriction.L);
};
var $author$project$Components$Shared$Bibliotheque$Restriction$total = function (restriction) {
	return $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			function (valeur) {
				return A2($author$project$Components$Shared$Bibliotheque$Restriction$transmise, valeur.Aq, restriction);
			},
			restriction.Ki));
};
var $author$project$Components$Shared$Bibliotheque$Restriction$enregistrable = function (restriction) {
	return (!$author$project$Components$Shared$Bibliotheque$Restriction$estVide(restriction)) && ((!_Utils_eq(restriction.L, restriction.AP)) && (!($elm$core$Set$isEmpty(restriction.AP) && _Utils_eq(
		$author$project$Components$Shared$Bibliotheque$Restriction$nombreRetenues(restriction),
		$author$project$Components$Shared$Bibliotheque$Restriction$total(restriction)))));
};
var $author$project$Components$Shared$Bibliotheque$Restriction$retenues = function (restriction) {
	return A2(
		$elm$core$List$filter,
		function (id) {
			return A2($elm$core$Set$member, id, restriction.L);
		},
		A2(
			$elm$core$List$map,
			function ($) {
				return $.Aq;
			},
			restriction.Ki));
};
var $author$project$Components$Referentiel$Types$RestrictionDuChamp$enregistrer = F2(
	function (enCours, fiche) {
		var _v0 = _Utils_Tuple2(
			enCours.gt,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nQ;
					},
					$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$restreindreLesValeurs)),
				A2($author$project$Components$Referentiel$Types$RestrictionDuChamp$champDe, enCours.dy, fiche)));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var etat = _v0.a.a;
			var lien = _v0.b.a;
			return $author$project$Components$Shared$Bibliotheque$Restriction$enregistrable(etat) ? $elm$core$Maybe$Just(
				_Utils_Tuple2(
					A3(
						$author$project$Components$Referentiel$Common$API$WriteAPIModel$RestreindreLesValeursDUnType,
						fiche.r0.r8,
						enCours.dy,
						$author$project$Components$Shared$Bibliotheque$Restriction$retenues(etat)),
					lien)) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Referentiel$Types$Update$enregistrerLInformation = function (model) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		function (_v1) {
			var voulu = _v1.a;
			var fiche = _v1.b;
			return A3(
				$author$project$Components$Referentiel$Common$EnvoiDeType$partir,
				$author$project$Components$Referentiel$Types$Model$lienDesInformations(model),
				A2(
					$author$project$Components$Referentiel$Common$API$WriteAPIModel$FaireEvoluerLeSchemaDUnType,
					fiche.r0.r8,
					{
						fx: _List_Nil,
						g$: _List_fromArray(
							[voulu])
					}),
				model.l2);
		},
		A3(
			$elm$core$Maybe$map2,
			$elm$core$Tuple$pair,
			$author$project$Components$Referentiel$Types$Model$informationModifiee(model),
			$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model)));
	if (!_v0.$) {
		var _v2 = _v0.a;
		var envoi = _v2.a;
		var effets = _v2.b;
		return _Utils_Tuple2(
			A2(
				$author$project$Components$Referentiel$Types$Update$avecLesInformations,
				function (etat) {
					return _Utils_update(
						etat,
						{pZ: $elm$core$Maybe$Nothing});
				},
				_Utils_update(
					model,
					{l2: envoi})),
			effets);
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Types$Update$envoyerLesOffres = F2(
	function (_v0, model) {
		var commande = _v0.a;
		var lien = _v0.b;
		if ($author$project$Components$Referentiel$Types$Model$enAttente(model)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v1 = A3(
				$author$project$Components$Referentiel$Common$EnvoiDeType$partir,
				$elm$core$Maybe$Just(lien),
				commande,
				model.l2);
			if (!_v1.$) {
				var _v2 = _v1.a;
				var envoi = _v2.a;
				var effets = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{l2: envoi, p5: $elm$core$Maybe$Nothing}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		}
	});
var $author$project$I18n$Textes$referentielTypeLimiteErreurVide = A3($author$project$I18n$Traductions$texte, 'referentiel.type.limite.erreur.vide', _List_Nil, 'Choisissez au moins une offre, ou revenez à « Toutes les offres ».');
var $author$project$Components$Referentiel$Types$Update$enregistrerLesOffres = F2(
	function (commande, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			commande,
			$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model));
		if (!_v0.$) {
			var envoi = _v0.a;
			return A2($author$project$Components$Referentiel$Types$Update$envoyerLesOffres, envoi, model);
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						p5: $elm$core$Maybe$Just(
							{Jx: $author$project$I18n$Textes$referentielTypeLimiteErreurVide, b9: $elm$core$Maybe$Nothing})
					}),
				_List_Nil);
		}
	});
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$ReglerLeNiveauDeLecture = F3(
	function (a, b, c) {
		return {$: 13, a: a, b: b, c: c};
	});
var $author$project$API$NavLinksDictionary$reglerLeRattachement = 'regler-le-rattachement';
var $author$project$Components$Referentiel$Types$Update$enregistrerLesReglages = function (model) {
	var _v0 = model.AM.eO;
	if (!_v0.$) {
		var reglage = _v0.a;
		var actuel = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.g4;
			},
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.dw;
					},
					$author$project$Components$Referentiel$Types$Informations$parCle(reglage.dy)),
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.aN;
					},
					$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model))));
		if (_Utils_eq(
			actuel,
			$elm$core$Maybe$Just(reglage.np))) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v1 = A4(
				$author$project$Components$Referentiel$Types$Update$commandeDuChamp,
				$author$project$API$NavLinksDictionary$reglerLeRattachement,
				F2(
					function (uid, champ) {
						return A3($author$project$Components$Referentiel$Common$API$WriteAPIModel$ReglerLeNiveauDeLecture, uid, champ, reglage.np);
					}),
				model,
				reglage.dy);
			if (!_v1.$) {
				var _v2 = _v1.a;
				var commande = _v2.a;
				var lien = _v2.b;
				var _v3 = A3(
					$author$project$Components$Referentiel$Common$EnvoiDeType$partir,
					$elm$core$Maybe$Just(lien),
					commande,
					model.l2);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var envoi = _v4.a;
					var effets = _v4.b;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Types$Update$avecLesInformations,
							function (etat) {
								return _Utils_update(
									etat,
									{pZ: $elm$core$Maybe$Nothing});
							},
							_Utils_update(
								model,
								{l2: envoi})),
						effets);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Types$Update$envoyerLaRestriction = F2(
	function (commande, model) {
		var _v0 = _Utils_Tuple2(
			model.AM.al,
			$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var enCours = _v0.a.a;
			var fiche = _v0.b.a;
			var _v1 = A2(
				$elm$core$Maybe$andThen,
				function (_v2) {
					var voulue = _v2.a;
					var lien = _v2.b;
					return A3(
						$author$project$Components$Referentiel$Common$EnvoiDeType$partir,
						$elm$core$Maybe$Just(lien),
						voulue,
						model.l2);
				},
				A2(commande, enCours, fiche));
			if (!_v1.$) {
				var _v3 = _v1.a;
				var envoi = _v3.a;
				var effets = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{l2: envoi}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Types$Update$ficheRegleeRevenue = function (model) {
	return model.mz ? _Utils_update(
		model,
		{
			mz: false,
			Hv: A2($elm$core$Basics$max, 0, model.Hv - 1)
		}) : model;
};
var $author$project$Components$Referentiel$Types$Model$idsDeLaConfirmation = {to: 'type-archivage-annuler', j7: 'type-archivage-confirmer'};
var $author$project$Components$Referentiel$Types$Model$indicateurRetirable = F2(
	function (cle, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.AZ;
				},
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dw;
						},
						$author$project$Components$Referentiel$Types$Informations$parCle(cle)),
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.aN;
						},
						$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model)))));
	});
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$ReglerLAttributionSansOffre = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$reglerLAttributionSansOffre = 'regler-l-attribution-sans-offre';
var $author$project$Components$Referentiel$Types$Offres$lienDeLInterdiction = function (fiche) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reglerLAttributionSansOffre, fiche.r0.nQ);
};
var $author$project$Components$Referentiel$Types$Offres$commandeDeLInterdiction = F2(
	function (interdite, fiche) {
		return _Utils_eq(fiche.AR, interdite) ? $elm$core$Maybe$Nothing : A2(
			$elm$core$Maybe$map,
			function (lien) {
				return _Utils_Tuple2(
					A2($author$project$Components$Referentiel$Common$API$WriteAPIModel$ReglerLAttributionSansOffre, fiche.r0.r8, interdite),
					lien);
			},
			$author$project$Components$Referentiel$Types$Offres$lienDeLInterdiction(fiche));
	});
var $author$project$Components$Referentiel$Types$Update$interdire = F2(
	function (interdite, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			$author$project$Components$Referentiel$Types$Offres$commandeDeLInterdiction(interdite),
			$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model));
		if (!_v0.$) {
			var commande = _v0.a;
			return A2($author$project$Components$Referentiel$Types$Update$envoyerLesOffres, commande, model);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Common$EffetDeType$LireLesOffres = function (a) {
	return {$: 14, a: a};
};
var $author$project$API$NavLinksDictionary$offresPourLaLimite = 'offres-pour-la-limite';
var $author$project$Components$Referentiel$Types$Offres$lienDesOffresProposees = function (fiche) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$offresPourLaLimite, fiche.r0.nQ);
};
var $author$project$Components$Referentiel$Types$Update$lectureDuCatalogueDesOffres = function (model) {
	var _v0 = _Utils_Tuple2(
		model.D4,
		A2(
			$elm$core$Maybe$andThen,
			$author$project$Components$Referentiel$Types$Offres$lienDesOffresProposees,
			$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model)));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var _v1 = _v0.a;
		var lien = _v0.b.a;
		return _List_fromArray(
			[
				$author$project$Components$Referentiel$Common$EffetDeType$LireLesOffres(lien)
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$LeverLaRestrictionDUnType = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$leverLaRestriction = 'lever-la-restriction';
var $author$project$Components$Referentiel$Types$RestrictionDuChamp$lever = F2(
	function (enCours, fiche) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair(
				A2($author$project$Components$Referentiel$Common$API$WriteAPIModel$LeverLaRestrictionDUnType, fiche.r0.r8, enCours.dy)),
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nQ;
					},
					$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$leverLaRestriction)),
				A2($author$project$Components$Referentiel$Types$RestrictionDuChamp$champDe, enCours.dy, fiche)));
	});
var $author$project$Components$Referentiel$Types$Offres$lienDesPerimetres = F2(
	function (terme, fiche) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2('recherche', terme)
					])),
			A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$perimetres, fiche.r0.gF));
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$VersionDuSchemaAPIView = F7(
	function (version, date, moi, ajouts, modifications, changements, gestes) {
		return {fx: ajouts, u3: changements, wv: date, Ab: gestes, g$: modifications, og: moi, sq: version};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$VersionsDuSchemaAPIView = F2(
	function (versions, liens) {
		return {nQ: liens, ss: versions};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$Ajoute = 0;
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$ChangementAPIView = F4(
	function (champ, nature, donneePersonnelle, details) {
		return {uN: champ, cz: details, xD: donneePersonnelle, g1: nature};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$Modifie = 1;
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$changementDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'details',
	$elm$json$Json$Decode$list(
		A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (quoi, valeur) {
					return {GM: quoi, fm: valeur};
				}),
			A2($elm$json$Json$Decode$field, 'quoi', $elm$json$Json$Decode$string),
			$elm$json$Json$Decode$maybe(
				A2($elm$json$Json$Decode$field, 'valeur', $elm$json$Json$Decode$string)))),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'donneePersonnelle',
		$elm$json$Json$Decode$bool,
		false,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'nature',
			A2(
				$elm$json$Json$Decode$andThen,
				function (nature) {
					switch (nature) {
						case 'ajoute':
							return $elm$json$Json$Decode$succeed(0);
						case 'modifie':
							return $elm$json$Json$Decode$succeed(1);
						default:
							return $elm$json$Json$Decode$fail(nature);
					}
				},
				$elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'champ',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$ChangementAPIView)))));
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$GesteAPIView = F4(
	function (nature, champ, date, moi) {
		return {uN: champ, wv: date, og: moi, g1: nature};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$Masque = 0;
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$Ordonne = 2;
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$Reaffiche = 1;
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$gesteDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
	_List_fromArray(
		['auteur', 'moi']),
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'date',
		$elm$json$Json$Decode$string,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'champ',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'nature',
				A2(
					$elm$json$Json$Decode$andThen,
					function (nature) {
						switch (nature) {
							case 'masque':
								return $elm$json$Json$Decode$succeed(0);
							case 'reaffiche':
								return $elm$json$Json$Decode$succeed(1);
							case 'ordonne':
								return $elm$json$Json$Decode$succeed(2);
							default:
								return $elm$json$Json$Decode$fail(nature);
						}
					},
					$elm$json$Json$Decode$string),
				$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$GesteAPIView)))));
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$versionsDuSchemaDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'_links',
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$decoder),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'versions',
		$elm$json$Json$Decode$list(
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'gestes',
				$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$QueryAPIModel$gesteDecoder),
				_List_Nil,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'changements',
					$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$QueryAPIModel$changementDecoder),
					_List_Nil,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'modifications',
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'ajouts',
							$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['auteur', 'moi']),
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'date',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'version',
										$elm$json$Json$Decode$int,
										$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$VersionDuSchemaAPIView))))))))),
		$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$VersionsDuSchemaAPIView)));
var $author$project$Components$Referentiel$Types$Update$lireLHistorique = F2(
	function (reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$API$QueryAPIModel$versionsDuSchemaDecoder, reponse);
		if (!_v0.$) {
			var historique = _v0.a;
			return _Utils_Tuple2(
				A2(
					$author$project$Components$Referentiel$Types$Update$avecLesInformations,
					function (etat) {
						return _Utils_update(
							etat,
							{
								m6: $elm$core$Maybe$Just(historique)
							});
					},
					model),
				_List_Nil);
		} else {
			var refus = _v0.a;
			return (refus.ri === 401) ? _Utils_Tuple2(
				model,
				_List_fromArray(
					[$author$project$Components$Referentiel$Common$EffetDeType$Reconnecter])) : _Utils_Tuple2(
				A2(
					$author$project$Components$Referentiel$Types$Update$avecLesInformations,
					function (etat) {
						return _Utils_update(
							etat,
							{
								pZ: $elm$core$Maybe$Just(
									$author$project$Components$Shared$Messages$Model$duRefus(refus))
							});
					},
					model),
				_List_Nil);
		}
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$FicheDeTypeAPIView = function (type_) {
	return function (modifieLe) {
		return function (natures) {
			return function (qualites) {
				return function (statuts) {
					return function (resultats) {
						return function (schema) {
							return function (offres) {
								return function (perimetre) {
									return function (interdireSansOffre) {
										return function (bibliotheque) {
											return function (collections) {
												return {dq: bibliotheque, vE: collections, AR: interdireSansOffre, CN: modifieLe, oo: natures, D3: offres, E9: perimetre, GG: qualites, bh: resultats, aN: schema, I1: statuts, r0: type_};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$ResultatAPIView = F4(
	function (id, libelles, retire, systeme) {
		return {Aq: id, R: libelles, HZ: retire, rv: systeme};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$StatutAPIView = F5(
	function (id, libelles, initial, retire, utilise) {
		return {Aq: id, AO: initial, R: libelles, HZ: retire, Kg: utilise};
	});
var $author$project$Components$Shared$Bibliotheque$Champ$ChampDeLaFiche = F6(
	function (id, partage, utilisePar, filtrable, recherchable, liens) {
		return {zG: filtrable, Aq: id, nQ: liens, hm: partage, G1: recherchable, sf: utilisePar};
	});
var $author$project$Components$Shared$Bibliotheque$Champ$champDeLaFicheDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'recherchable',
		$elm$json$Json$Decode$bool,
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'filtrable',
			$elm$json$Json$Decode$bool,
			false,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'utilisePar',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'partage',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Components$Shared$Bibliotheque$Champ$ChampDeLaFiche)))))));
var $author$project$Components$Shared$CollectionsDuType$Model$Collection = F5(
	function (id, cle, libelle, surLeType, champs) {
		return {dw: champs, dy: cle, Aq: id, Bl: libelle, e6: surLeType};
	});
var $author$project$Components$Shared$CollectionsDuType$Model$ChampDeCollection = F5(
	function (id, cle, libelle, surLeType, valeurs) {
		return {dy: cle, Aq: id, Bl: libelle, e6: surLeType, Ki: valeurs};
	});
var $author$project$Components$Shared$CollectionsDuType$Model$champDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'valeurs',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'surLeType',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'libelle',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'cle',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Shared$CollectionsDuType$Model$ChampDeCollection))))));
var $author$project$Components$Shared$CollectionsDuType$Model$decoder = $elm$json$Json$Decode$list(
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'champs',
		$elm$json$Json$Decode$list($author$project$Components$Shared$CollectionsDuType$Model$champDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'surLeType',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'libelle',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'cle',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Components$Shared$CollectionsDuType$Model$Collection)))))));
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$OffreProposeeAPIView = F4(
	function (id, nom, arretee, categorie) {
		return {tL: arretee, uK: categorie, Aq: id, Dj: nom};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$offreDuTypeDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'arretee',
		$elm$json$Json$Decode$bool,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'nom',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['offre', 'uid']),
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$OffreProposeeAPIView)))));
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$PerimetreDeLaLimiteAPIView = F4(
	function (uid, nom, decompte, archive) {
		return {tE: archive, wT: decompte, Dj: nom, r8: uid};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$perimetreDeLaLimiteDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'archive',
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'decompte',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'nom',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'uid',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$PerimetreDeLaLimiteAPIView)))));
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$ChampDuTypeAPIView = F9(
	function (champ, typeDeChamp, masque, liens, masqueDepuis, fiches, jamaisSaisi, niveauDeLecture, restriction) {
		return {uN: champ, zu: fiches, AZ: jamaisSaisi, nQ: liens, n4: masque, B9: masqueDepuis, g4: niveauDeLecture, al: restriction, JR: typeDeChamp};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$SchemaDuTypeAPIView = F3(
	function (version, champs, editeur) {
		return {dw: champs, x5: editeur, sq: version};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$schemaDuTypeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'editeur',
	$author$project$Components$Shared$EditeurDeSchema$Propositions$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'champs',
		$elm$json$Json$Decode$list(
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'restriction',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				_List_Nil,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'niveauDeLecture',
					$elm$json$Json$Decode$string,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'jamaisSaisi',
						$elm$json$Json$Decode$bool,
						false,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'fiches',
							$elm$json$Json$Decode$int,
							0,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'masqueDepuis',
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'_links',
									A2(
										$elm$json$Json$Decode$map,
										function ($) {
											return $.h0;
										},
										$author$project$API$Liens$decoder),
									_List_Nil,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'masque',
										$elm$json$Json$Decode$bool,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'typeDeChamp',
											A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
											$elm$core$Maybe$Nothing,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'champ',
												$author$project$Components$Shared$EditeurDeSchema$Champ$decoder,
												$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$ChampDuTypeAPIView))))))))))),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'version',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$SchemaDuTypeAPIView))));
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$ficheDeTypeDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'collections',
	$author$project$Components$Shared$CollectionsDuType$Model$decoder,
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'bibliotheque',
		$elm$json$Json$Decode$dict($author$project$Components$Shared$Bibliotheque$Champ$champDeLaFicheDecoder),
		$elm$core$Dict$empty,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'attributionSansOffreInterdite',
			$elm$json$Json$Decode$bool,
			false,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'perimetre',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Referentiel$Common$API$QueryAPIModel$perimetreDeLaLimiteDecoder),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'offres',
					$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$QueryAPIModel$offreDuTypeDecoder),
					_List_Nil,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'schema',
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Referentiel$Common$API$QueryAPIModel$schemaDuTypeDecoder),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'resultats',
							$elm$json$Json$Decode$list(
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'systeme',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'retire',
										$elm$json$Json$Decode$bool,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'libelles',
											A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Referentiel$Common$API$QueryAPIModel$libellesDecoder),
											$elm$core$Maybe$Nothing,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'id',
												$author$project$Components$Referentiel$Identifiants$resultatIdDecoder,
												$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$ResultatAPIView)))))),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'statuts',
								$elm$json$Json$Decode$list(
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'utilise',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'retire',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'initial',
												$elm$json$Json$Decode$bool,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'libelles',
													$author$project$Components$Referentiel$Common$API$QueryAPIModel$libellesDecoder,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'id',
														$author$project$Components$Referentiel$Identifiants$statutIdDecoder,
														$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$StatutAPIView))))))),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'qualites',
									$elm$json$Json$Decode$list($author$project$Components$Referentiel$Admission$qualiteDecoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'natures',
										$elm$json$Json$Decode$list($author$project$Components$Referentiel$Admission$natureDecoder),
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'modifieLe',
											A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
											$elm$core$Maybe$Nothing,
											A2(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
												$author$project$Components$Referentiel$Common$API$QueryAPIModel$typeParametreDecoder,
												$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$FicheDeTypeAPIView)))))))))))));
var $author$project$Components$Referentiel$Types$Update$lireLeType = F2(
	function (reponse, model) {
		var _v0 = _Utils_Tuple2(
			model.bA,
			A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$API$QueryAPIModel$ficheDeTypeDecoder, reponse));
		if (_v0.b.$ === 1) {
			var refus = _v0.b.a;
			return (refus.ri === 401) ? _Utils_Tuple2(
				model,
				_List_fromArray(
					[$author$project$Components$Referentiel$Common$EffetDeType$Reconnecter])) : _Utils_Tuple2(
				A2(
					$author$project$Components$Referentiel$Types$Update$avecLeType,
					function (consulte) {
						return _Utils_update(
							consulte,
							{
								pZ: $elm$core$Maybe$Just(
									$author$project$Components$Shared$Messages$Model$duRefus(refus))
							});
					},
					model),
				_List_Nil);
		} else {
			if (!_v0.a.$) {
				var consulte = _v0.a.a;
				var fiche = _v0.b.a;
				return _Utils_eq(fiche.r0.r8, consulte.r8) ? _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Types$Update$avecLeType,
						function (_v1) {
							return _Utils_update(
								consulte,
								{
									fW: false,
									zo: $elm$core$Maybe$Just(fiche)
								});
						},
						model),
					_List_Nil) : _Utils_Tuple2(model, _List_Nil);
			} else {
				var _v2 = _v0.a;
				return _Utils_Tuple2(model, _List_Nil);
			}
		}
	});
var $author$project$Components$Referentiel$Types$Offres$limitee = function (fiche) {
	return (!$elm$core$List$isEmpty(fiche.D3)) || (!_Utils_eq(fiche.E9, $elm$core$Maybe$Nothing));
};
var $author$project$Components$Referentiel$Types$Update$lireLeTypeRegle = F2(
	function (reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$API$QueryAPIModel$ficheDeTypeDecoder, reponse);
		if (!_v0.$) {
			var fiche = _v0.a;
			return _Utils_eq(
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.r8;
					},
					$author$project$Components$Referentiel$Types$Model$typeRegle(model)),
				$elm$core$Maybe$Just(fiche.r0.r8)) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{
						x1: $elm$core$Maybe$Nothing,
						gv: $elm$core$Maybe$Just(fiche)
					}),
				$author$project$Components$Referentiel$Types$Offres$limitee(fiche) ? $author$project$Components$Referentiel$Types$Update$lectureDuCatalogueDesOffres(
					_Utils_update(
						model,
						{
							gv: $elm$core$Maybe$Just(fiche)
						})) : _List_Nil) : _Utils_Tuple2(model, _List_Nil);
		} else {
			var refus = _v0.a;
			return (refus.ri === 401) ? _Utils_Tuple2(
				model,
				_List_fromArray(
					[$author$project$Components$Referentiel$Common$EffetDeType$Reconnecter])) : _Utils_Tuple2(
				_Utils_update(
					model,
					{
						x1: $elm$core$Maybe$Just(
							$author$project$Components$Shared$Messages$Model$duRefus(refus))
					}),
				_List_Nil);
		}
	});
var $author$project$Components$Referentiel$Types$RestrictionDuChamp$masquer = F2(
	function (enCours, fiche) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair(
				A2($author$project$Components$Referentiel$Common$API$WriteAPIModel$MasquerUnChampDUnType, fiche.r0.r8, enCours.dy)),
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nQ;
					},
					$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$masquerUnChamp)),
				A2($author$project$Components$Referentiel$Types$RestrictionDuChamp$champDe, enCours.dy, fiche)));
	});
var $author$project$Components$Shared$EditeurDeSchema$View$ModificationDemandee = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Conduite$envoyer = F3(
	function (reglage, commande, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (_v1) {
				var voulue = _v1.a;
				var lien = _v1.b;
				return A4(
					$author$project$API$Envoi$partir,
					reglage.l2,
					$elm$core$Maybe$Just(lien),
					voulue,
					model.l2);
			},
			commande);
		if (!_v0.$) {
			var _v2 = _v0.a;
			var envoi = _v2.a;
			var effets = _v2.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$View$idDeLaModification = function (cle) {
	return 'champ-' + (cle + '-modifier');
};
var $author$project$Components$Shared$EditeurDeSchema$Model$exigenceDe = function (champ) {
	return champ.he ? $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceALEnregistrement : (champ.sG ? $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceALaPublication : $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceFacultative);
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$langueDeLaFiche = function (champ) {
	var _v0 = champ.r0;
	switch (_v0.$) {
		case 7:
			var valeurs = _v0.a;
			return _Utils_update(
				champ,
				{
					r0: $author$project$Components$Shared$EditeurDeSchema$Champ$Langue(
						{vC: valeurs, FS: false})
				});
		case 8:
			var valeurs = _v0.a.Ki;
			return _Utils_update(
				champ,
				{
					r0: $author$project$Components$Shared$EditeurDeSchema$Champ$Langue(
						{vC: valeurs, FS: true})
				});
		default:
			return champ;
	}
};
var $author$project$Components$Shared$EditeurDeSchema$Model$codeDuTypeSimple = function (type_) {
	return A2(
		$elm$core$Maybe$map,
		$elm$core$Tuple$first,
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$second,
					$elm$core$Basics$eq(type_)),
				$author$project$Components$Shared$EditeurDeSchema$Model$typesSimples)));
};
var $author$project$Components$Shared$EditeurDeSchema$Model$optionsDe = function (champ) {
	var siVrai = F2(
		function (code, vrai) {
			return vrai ? _List_fromArray(
				[
					_Utils_Tuple2(code, $author$project$Components$Shared$EditeurDeSchema$Model$oui)
				]) : _List_Nil;
		});
	var present = F2(
		function (code, valeur) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (fournie) {
						return _List_fromArray(
							[
								_Utils_Tuple2(code, fournie)
							]);
					},
					valeur));
		});
	var desValeurs = A2(
		$elm$core$List$concatMap,
		function (_v4) {
			var valeur = _v4.a;
			var parLangue = _v4.b;
			return A2(
				$elm$core$List$map,
				function (_v5) {
					var langue = _v5.a;
					var libelle = _v5.b;
					return _Utils_Tuple2(
						A2($author$project$Components$Shared$EditeurDeSchema$Model$sousOption, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionLibellesDesValeurs, langue + ('.' + valeur)),
						libelle);
				},
				parLangue);
		},
		champ.Bt);
	var deLaFormule = function () {
		var _v3 = champ.zU;
		if (!_v3.$) {
			var formule = _v3.a;
			return A2(
				$elm$core$List$cons,
				_Utils_Tuple2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionFormule, formule),
				A2(
					present,
					$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionTypeDuResultat,
					$author$project$Components$Shared$EditeurDeSchema$Model$codeDuTypeSimple(champ.r0)));
		} else {
			return _List_Nil;
		}
	}();
	var bornes = F3(
		function (code, min, max) {
			return _Utils_ap(
				A2(
					present,
					A2($author$project$Components$Shared$EditeurDeSchema$Model$sousOption, code, 'min'),
					min),
				A2(
					present,
					A2($author$project$Components$Shared$EditeurDeSchema$Model$sousOption, code, 'max'),
					max));
		});
	var deLaRegle = function (regle) {
		switch (regle.$) {
			case 1:
				var min = regle.a;
				var max = regle.b;
				return _Utils_ap(
					A2(
						present,
						A2($author$project$Components$Shared$EditeurDeSchema$Model$sousOption, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionLongueur, 'min'),
						A2($elm$core$Maybe$map, $elm$core$String$fromInt, min)),
					A2(
						present,
						$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionLongueur,
						A2($elm$core$Maybe$map, $elm$core$String$fromInt, max)));
			case 2:
				var regex = regle.a;
				var dit = regle.b;
				return _List_fromArray(
					[
						_Utils_Tuple2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionMotif, regex),
						_Utils_Tuple2(
						A2($author$project$Components$Shared$EditeurDeSchema$Model$sousOption, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionMotif, 'message'),
						dit)
					]);
			case 3:
				return _List_fromArray(
					[
						_Utils_Tuple2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionUnique, $author$project$Components$Shared$EditeurDeSchema$Model$oui)
					]);
			case 0:
				var min = regle.a;
				var max = regle.b;
				if ($author$project$Components$Shared$EditeurDeSchema$Model$horsFormulaire(regle)) {
					return _List_Nil;
				} else {
					var _v2 = _Utils_Tuple2(min, max);
					if ((!_v2.a.$) && (_v2.a.a.$ === 1)) {
						return A3(
							bornes,
							$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionBornesDeDate,
							$author$project$Components$Shared$EditeurDeSchema$Model$jour(min),
							$author$project$Components$Shared$EditeurDeSchema$Model$jour(max));
					} else {
						if ((!_v2.b.$) && (_v2.b.a.$ === 1)) {
							return A3(
								bornes,
								$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionBornesDeDate,
								$author$project$Components$Shared$EditeurDeSchema$Model$jour(min),
								$author$project$Components$Shared$EditeurDeSchema$Model$jour(max));
						} else {
							return A3(
								bornes,
								$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionBornes,
								A2(
									$elm$core$Maybe$map,
									$elm$core$String$fromFloat,
									$author$project$Components$Shared$EditeurDeSchema$Model$nombreDeBorne(min)),
								A2(
									$elm$core$Maybe$map,
									$elm$core$String$fromFloat,
									$author$project$Components$Shared$EditeurDeSchema$Model$nombreDeBorne(max)));
						}
					}
				}
			default:
				return _List_Nil;
		}
	};
	var duType = function () {
		var _v0 = champ.r0;
		switch (_v0.$) {
			case 7:
				var valeurs = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionValeurs,
						A2($elm$core$String$join, '\n', valeurs))
					]);
			case 8:
				var choix = _v0.a;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionValeurs,
						A2($elm$core$String$join, '\n', choix.Ki)),
					A3(
						bornes,
						$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionNombreDeChoix,
						A2($elm$core$Maybe$map, $elm$core$String$fromInt, choix.Cx),
						A2($elm$core$Maybe$map, $elm$core$String$fromInt, choix.Cg)));
			case 15:
				var choix = _v0.a;
				return A2(siVrai, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionPlusieursChoix, choix.FS);
			case 16:
				var choix = _v0.a;
				return A2(siVrai, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionPlusieursChoix, choix.FS);
			case 9:
				var fichier = _v0.a;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionTypesDeMedia,
						A2($elm$core$String$join, ', ', fichier.r1)),
					A2(
						present,
						$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionTailleMaximale,
						A2($elm$core$Maybe$map, $elm$core$String$fromInt, fichier.Jn)));
			case 10:
				var mesure = _v0.a;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionUnite, mesure.sa),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionDecimales,
							$elm$core$String$fromInt(mesure.kv)),
						_Utils_ap(
							A3(
								bornes,
								$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionBornesPlausibles,
								A2($elm$core$Maybe$map, $elm$core$String$fromFloat, mesure.Cx),
								A2($elm$core$Maybe$map, $elm$core$String$fromFloat, mesure.Cg)),
							A2(
								$elm$core$List$map,
								$elm$core$Tuple$mapFirst(
									$author$project$Components$Shared$EditeurDeSchema$Model$sousOption($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionAffichageParLangue)),
								mesure.iF))));
			case 19:
				var fiche = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionTypeVise, fiche.r$)
					]);
			default:
				return _List_Nil;
		}
	}();
	return $elm$core$Dict$fromList(
		$elm$core$List$concat(
			_List_fromArray(
				[
					duType,
					deLaFormule,
					A2($elm$core$List$concatMap, deLaRegle, champ.hJ),
					A2(siVrai, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionTraduisible, champ.h8),
					A2(siVrai, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionDonneePersonnelle, champ.xD),
					A2(
					present,
					$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionConservation,
					A2($elm$core$Maybe$map, $elm$core$String$fromInt, champ.v6)),
					desValeurs
				])));
};
var $author$project$Components$Shared$EditeurDeSchema$Model$modification = F3(
	function (langues, typeDeChamp, champDeLaFiche) {
		var champ = _Utils_eq(
			typeDeChamp,
			$elm$core$Maybe$Just($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeLangue)) ? $author$project$Components$Shared$EditeurDeSchema$Champ$langueDeLaFiche(champDeLaFiche) : champDeLaFiche;
		return A3(
			$author$project$Components$Shared$EditeurDeSchema$Model$ouverte,
			langues,
			$elm$core$Maybe$Just(champ),
			{
				bq: $elm$core$Dict$fromList(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								$elm$core$List$head(langues)),
							champ.bp),
						champ.bq)),
				dy: champ.dy,
				ct: true,
				mo: $author$project$Components$Shared$EditeurDeSchema$Model$exigenceDe(champ),
				R: $elm$core$Dict$fromList(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								$elm$core$List$head(langues)),
							champ.Bl),
						champ.R)),
				o_: $author$project$Components$Shared$EditeurDeSchema$Model$optionsDe(champ),
				IX: _List_Nil,
				JR: A2($elm$core$Maybe$withDefault, '', typeDeChamp),
				KQ: champ.KQ
			});
	});
var $author$project$Components$Shared$EditeurDeSchema$Conduite$ordonner = F4(
	function (reglage, deplace, deplacer, model) {
		var _v0 = reglage.dw;
		if (!_v0.$) {
			var champs = _v0.a;
			var voulus = deplacer(champs);
			if (_Utils_eq(voulus, champs)) {
				return _Utils_Tuple2(model, _List_Nil);
			} else {
				var _v1 = A2(
					$elm$core$Maybe$andThen,
					function (_v2) {
						var commande = _v2.a;
						var lien = _v2.b;
						return A4(
							$author$project$API$Envoi$partir,
							reglage.l2,
							$elm$core$Maybe$Just(lien),
							commande,
							model.l2);
					},
					reglage.Ek(voulus));
				if (!_v1.$) {
					var _v3 = _v1.a;
					var envoi = _v3.a;
					var effets = _v3.b;
					return _Utils_Tuple2(
						A2(
							reglage.s1,
							voulus,
							_Utils_update(
								model,
								{
									iP: A2(reglage.tm, deplace, voulus),
									l2: envoi,
									o2: $elm$core$Maybe$Just(champs)
								})),
						effets);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$Conduite$surLeTableau = F3(
	function (reglage, geste, model) {
		var est = F2(
			function (cle, lu) {
				return _Utils_eq(
					reglage.dy(lu),
					cle);
			});
		switch (geste.$) {
			case 9:
				return _Utils_Tuple2(model, _List_Nil);
			case 8:
				var cle = geste.a;
				var _v1 = _Utils_Tuple2(
					reglage.yW,
					reglage.g_(cle));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var _v2 = _v1.b.a;
					var code = _v2.a;
					var champ = _v2.b;
					return A4(
						$author$project$Components$Shared$EditeurDeSchema$Conduite$ouvrir,
						reglage,
						$author$project$Components$Shared$EditeurDeSchema$View$idDeLaModification(cle),
						function (saisie) {
							var _v3 = reglage.CC(cle);
							if (!_v3.$) {
								var definition = _v3.a;
								return A2($author$project$Components$Shared$EditeurDeSchema$Model$avecLesMinima, definition.sW, saisie);
							} else {
								return saisie;
							}
						}(
							A2(
								$author$project$Components$Shared$EditeurDeSchema$Model$dansLaPortee,
								reglage.F$,
								A2(
									$author$project$Components$Shared$EditeurDeSchema$Model$avecLesNormes,
									reglage.hd,
									A3(
										$author$project$Components$Shared$EditeurDeSchema$Model$modification,
										reglage.Ba,
										$elm$core$Maybe$Just(code),
										champ)))),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 6:
				var cle = geste.a;
				return A3(
					$author$project$Components$Shared$EditeurDeSchema$Conduite$envoyer,
					reglage,
					reglage.Cc(cle),
					model);
			case 7:
				var cle = geste.a;
				return A3(
					$author$project$Components$Shared$EditeurDeSchema$Conduite$envoyer,
					reglage,
					reglage.s0(cle),
					model);
			case 0:
				var cle = geste.a;
				return A4(
					$author$project$Components$Shared$EditeurDeSchema$Conduite$ordonner,
					reglage,
					cle,
					$author$project$Components$Shared$Ordre$monter(
						est(cle)),
					model);
			case 1:
				var cle = geste.a;
				return A4(
					$author$project$Components$Shared$EditeurDeSchema$Conduite$ordonner,
					reglage,
					cle,
					$author$project$Components$Shared$Ordre$descendre(
						est(cle)),
					model);
			case 2:
				var cle = geste.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							m_: $elm$core$Maybe$Just(cle)
						}),
					_List_Nil);
			case 3:
				return _Utils_Tuple2(model, _List_Nil);
			case 4:
				var surLui = geste.a;
				var _v4 = model.m_;
				if (!_v4.$) {
					var glisse = _v4.a;
					return A4(
						$author$project$Components$Shared$EditeurDeSchema$Conduite$ordonner,
						reglage,
						glisse,
						A2(
							$author$project$Components$Shared$Ordre$deposer,
							est(glisse),
							est(surLui)),
						_Utils_update(
							model,
							{m_: $elm$core$Maybe$Nothing}));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{m_: $elm$core$Maybe$Nothing}),
					_List_Nil);
		}
	});
var $author$project$Components$Referentiel$Types$Update$modifierLaDefinition = F2(
	function (cle, model) {
		var _v0 = $author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model);
		if (!_v0.$) {
			var fiche = _v0.a;
			return A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Components$Referentiel$Types$Update$avecLesInformations(
					function (etat) {
						return _Utils_update(
							etat,
							{
								kX: function (drawer) {
									return _Utils_update(
										drawer,
										{
											wQ: $elm$core$Maybe$Just(
												$author$project$Components$Referentiel$Types$Model$idDUneInformation(cle))
										});
								}(etat.kX)
							});
					}),
				A2(
					$author$project$Components$Referentiel$Types$Update$parLaConduite,
					function (reglage) {
						return A2(
							$author$project$Components$Shared$EditeurDeSchema$Conduite$surLeTableau,
							reglage,
							$author$project$Components$Shared$EditeurDeSchema$View$ModificationDemandee(cle));
					},
					A2(
						$author$project$Components$Referentiel$Types$Update$avecLesInformations,
						function (etat) {
							return _Utils_update(
								etat,
								{
									wC: $elm$core$Maybe$Just(fiche.r0.r8),
									pZ: $elm$core$Maybe$Nothing
								});
						},
						A2($author$project$Components$Referentiel$Types$Update$versLInformation, $author$project$Components$Shared$Drawer$Update$Fermer, model).a)));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Types$CreationRapide$nommer = F2(
	function (archetype, nom) {
		return A2(
			$author$project$Components$Referentiel$Types$CreationRapide$surLaLigne,
			archetype,
			function (ligne) {
				return _Utils_eq(
					ligne.nh,
					$elm$core$Maybe$Just($author$project$Components$Referentiel$Types$CreationRapide$Creee)) ? ligne : _Utils_update(
					ligne,
					{Dj: nom});
			});
	});
var $author$project$I18n$Textes$editeurDeSchemaAjouterTitre = A3($author$project$I18n$Traductions$texte, 'editeur-de-schema.ajouter.titre', _List_Nil, 'Ajouter un champ');
var $author$project$I18n$Textes$editeurDeSchemaAjouterValider = A3($author$project$I18n$Traductions$texte, 'editeur-de-schema.ajouter.valider', _List_Nil, 'Ajouter le champ');
var $author$project$I18n$Textes$editeurDeSchemaChampNom = A3($author$project$I18n$Traductions$texte, 'editeur-de-schema.champ.nom', _List_Nil, 'Nom du champ');
var $author$project$I18n$Textes$editeurDeSchemaChampTypeDeChamp = A3($author$project$I18n$Traductions$texte, 'editeur-de-schema.champ.type-de-champ', _List_Nil, 'Type de champ');
var $author$project$API$NavLinksDictionary$rattacherUnChamp = 'rattacher-un-champ';
var $author$project$Components$Referentiel$Types$Model$lienDeRattachementDUnChamp = function (fiche) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rattacherUnChamp, fiche.r0.nQ);
};
var $author$project$I18n$Textes$referentielTypesAjoutBandeauDetail = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'referentiel.types.ajout.bandeau.detail',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nomDuType',
				$author$project$I18n$Traductions$Sous(p.Dp))
			]),
		'Sa portée est limitée au type « {nomDuType} ».');
};
var $author$project$I18n$Textes$referentielTypesAjoutSousTitre = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'referentiel.types.ajout.sous-titre',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nomDuType',
				$author$project$I18n$Traductions$Sous(p.Dp))
			]),
		'Type de partie prenante « {nomDuType} »');
};
var $author$project$Components$Referentiel$Common$EffetDeType$EnvoyerUnNouveauChamp = F3(
	function (a, b, c) {
		return {$: 13, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Common$EffetDeType$LireLesListesDuNouveauChamp = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Referentiel$Types$Update$depuisLeNouveauChamp = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[$author$project$Components$Referentiel$Common$EffetDeType$DemanderProcessUid])));
			case 1:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Components$Referentiel$Common$EffetDeType$LireLesListesDuNouveauChamp(lien)
							])));
			case 2:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								A3($author$project$Components$Referentiel$Common$EffetDeType$EnvoyerUnNouveauChamp, lien, processUid, commande)
							])));
			case 3:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(cible)
							])));
			case 4:
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[$author$project$Components$Referentiel$Common$EffetDeType$Reconnecter])));
			case 5:
				var vuesAJour = effet.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Basics$append(effets),
						function (suite) {
							return vuesAJour ? suite : _Utils_ap(
								suite,
								_List_fromArray(
									[
										$author$project$Components$Referentiel$Common$EffetDeType$AttendreAvantDeRelire($author$project$Components$Referentiel$Common$EnvoiDeType$delaiDeRelectureMs)
									]));
						}),
					$author$project$Components$Referentiel$Types$Update$relireLeTypeRegleApresLaCommande(model));
			case 6:
				return _Utils_Tuple2(model, effets);
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2(
						$author$project$Components$Referentiel$Types$Update$puisAvec,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Referentiel$Types$Update$avecLeRattachement(
								function (r) {
									return _Utils_update(
										r,
										{dq: model.AM.GZ.pN.dq});
								}),
							$author$project$Components$Referentiel$Types$Update$surLeRattachement(
								$author$project$Components$Referentiel$Common$RattacherUnChamp$ModeChoisi(1))),
						$author$project$Components$Referentiel$Types$Update$ouvrirUneInformation(model)));
		}
	});
var $author$project$Components$Referentiel$Types$Update$surLeNouveauChamp = F2(
	function (geste, model) {
		return function (_v0) {
			var nouveauChamp = _v0.a;
			var effets = _v0.b;
			return A3(
				$elm$core$List$foldl,
				$author$project$Components$Referentiel$Types$Update$depuisLeNouveauChamp,
				_Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Types$Update$avecLesInformations,
						function (etat) {
							return _Utils_update(
								etat,
								{oP: nouveauChamp});
						},
						model),
					_List_Nil),
				effets);
		}(
			A2($author$project$Components$Parametrage$NouveauChamp$Update$update, geste, model.AM.oP));
	});
var $author$project$Components$Referentiel$Types$Update$nouveauChampPret = function (model) {
	var etat = model.AM;
	var _v0 = _Utils_Tuple2(
		etat.oR,
		A2(
			$elm$core$Maybe$andThen,
			function (fiche) {
				return A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(fiche),
					$author$project$Components$Referentiel$Types$Model$lienDeCreationDUnChamp(fiche));
			},
			$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model)));
	if (_v0.a && (!_v0.b.$)) {
		var _v1 = _v0.b.a;
		var fiche = _v1.a;
		var lien = _v1.b;
		return ((!_Utils_eq(etat.nG, $elm$core$Maybe$Nothing)) && _Utils_eq(etat.jZ, $elm$core$Maybe$Nothing)) ? _Utils_Tuple2(model, _List_Nil) : A2(
			$author$project$Components$Referentiel$Types$Update$surLeNouveauChamp,
			$author$project$Components$Parametrage$NouveauChamp$Update$Ouvert(
				{
					un: (!_Utils_eq(
						$author$project$Components$Referentiel$Types$Model$lienDeRattachementDUnChamp(fiche),
						$elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(
						{
							bB: $author$project$I18n$Textes$referentielTypesAjoutBandeauDetail(
								{
									Dp: $author$project$I18n$Traductions$tel(fiche.r0.R.zX)
								})
						}) : $elm$core$Maybe$Nothing,
					uY: A2($elm$core$Maybe$withDefault, _List_Nil, etat.GZ.pN.dq),
					vE: A2($elm$core$Maybe$withDefault, _List_Nil, etat.jZ),
					R: {fs: $author$project$I18n$Textes$editeurDeSchemaAjouterValider, Dj: $author$project$I18n$Textes$editeurDeSchemaChampNom, JR: $author$project$I18n$Textes$editeurDeSchemaChampTypeDeChamp},
					Bz: lien,
					BF: etat.BF,
					F$: 'parties-prenantes',
					F1: true,
					c0: _List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$author$project$Components$Referentiel$Identifiants$typeUidEncode(fiche.r0.r8))
						]),
					pN: $elm$core$Maybe$Nothing,
					aO: $author$project$I18n$Textes$referentielTypesAjoutSousTitre(
						{
							Dp: $author$project$I18n$Traductions$tel(fiche.r0.R.zX)
						}),
					h6: $author$project$I18n$Textes$editeurDeSchemaAjouterTitre,
					ib: _List_Nil,
					J_: etat.J_,
					sb: etat.sb
				}),
			A2(
				$author$project$Components$Referentiel$Types$Update$avecLesInformations,
				function (e) {
					return _Utils_update(
						e,
						{oR: false});
				},
				model));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$offreProposeeDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'categorie',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'arretee',
		$elm$json$Json$Decode$bool,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'nom',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$OffreProposeeAPIView)))));
var $author$project$Components$Shared$OrdreDesBlocs$Update$OrdreLu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Shared$OrdreDesBlocs$Model$Lu = F7(
	function (porteur, ordre, source, sourceLibelle, parentLibelle, blocs, liens) {
		return {js: blocs, nQ: liens, El: ordre, EZ: parentLibelle, c0: porteur, IR: source, IS: sourceLibelle};
	});
var $author$project$Components$Shared$OrdreDesBlocs$Model$Bloc = F3(
	function (cle, libelle, champs) {
		return {dw: champs, dy: cle, Bl: libelle};
	});
var $author$project$Components$Shared$OrdreDesBlocs$Model$blocDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'champs',
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$length,
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'libelle',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'cle',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Components$Shared$OrdreDesBlocs$Model$Bloc))));
var $author$project$Components$Shared$OrdreDesBlocs$Model$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		A2($elm$json$Json$Decode$field, '_links', $author$project$API$Liens$decoder)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'blocs',
		$elm$json$Json$Decode$list($author$project$Components$Shared$OrdreDesBlocs$Model$blocDecoder),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'parentLibelle',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'sourceLibelle',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'source',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'ordre',
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'porteur',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Components$Shared$OrdreDesBlocs$Model$Lu))))))));
var $author$project$Components$Referentiel$Types$Update$ordreLu = F2(
	function (reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Shared$OrdreDesBlocs$Model$decoder, reponse);
		if (!_v0.$) {
			var lu = _v0.a;
			return A2(
				$author$project$Components$Referentiel$Types$Update$versLesBlocs,
				$author$project$Components$Shared$OrdreDesBlocs$Update$OrdreLu(lu),
				model);
		} else {
			var refus = _v0.a;
			return _Utils_Tuple2(
				model,
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Referentiel$Common$EffetDeType$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Types$Model$ouvert = function (lecture) {
	return _Utils_update(
		$author$project$Components$Referentiel$Types$Model$init,
		{np: lecture});
};
var $author$project$I18n$Textes$referentielArchetypeClient = A3($author$project$I18n$Traductions$texte, 'referentiel.archetype.client', _List_Nil, 'Client');
var $author$project$I18n$Textes$referentielArchetypeCollaborateur = A3($author$project$I18n$Traductions$texte, 'referentiel.archetype.collaborateur', _List_Nil, 'Collaborateur');
var $author$project$I18n$Textes$referentielArchetypeConcurrent = A3($author$project$I18n$Traductions$texte, 'referentiel.archetype.concurrent', _List_Nil, 'Concurrent');
var $author$project$I18n$Textes$referentielArchetypeFournisseur = A3($author$project$I18n$Traductions$texte, 'referentiel.archetype.fournisseur', _List_Nil, 'Fournisseur');
var $author$project$I18n$Textes$referentielArchetypePartenaire = A3($author$project$I18n$Traductions$texte, 'referentiel.archetype.partenaire', _List_Nil, 'Partenaire');
var $author$project$I18n$Textes$referentielArchetypePrescripteur = A3($author$project$I18n$Traductions$texte, 'referentiel.archetype.prescripteur', _List_Nil, 'Prescripteur');
var $author$project$I18n$Textes$referentielArchetypeProspect = A3($author$project$I18n$Traductions$texte, 'referentiel.archetype.prospect', _List_Nil, 'Prospect');
var $author$project$I18n$Textes$referentielArchetypeRelationPresse = A3($author$project$I18n$Traductions$texte, 'referentiel.archetype.relation-presse', _List_Nil, 'Contact presse');
var $author$project$I18n$Textes$referentielArchetypeSuspect = A3($author$project$I18n$Traductions$texte, 'referentiel.archetype.suspect', _List_Nil, 'Suspect');
var $author$project$Components$Referentiel$Archetype$libelle = function (archetype) {
	switch (archetype) {
		case 0:
			return $author$project$I18n$Textes$referentielArchetypeSuspect;
		case 1:
			return $author$project$I18n$Textes$referentielArchetypeProspect;
		case 2:
			return $author$project$I18n$Textes$referentielArchetypeClient;
		case 3:
			return $author$project$I18n$Textes$referentielArchetypeCollaborateur;
		case 4:
			return $author$project$I18n$Textes$referentielArchetypeFournisseur;
		case 5:
			return $author$project$I18n$Textes$referentielArchetypePartenaire;
		case 6:
			return $author$project$I18n$Textes$referentielArchetypePrescripteur;
		case 7:
			return $author$project$I18n$Textes$referentielArchetypeRelationPresse;
		default:
			return $author$project$I18n$Textes$referentielArchetypeConcurrent;
	}
};
var $author$project$Components$Referentiel$Types$CreationRapide$ligneVierge = function (archetype) {
	return {
		fA: archetype,
		vt: false,
		nh: $elm$core$Maybe$Nothing,
		Dj: $author$project$I18n$Traductions$francaisDe(
			$author$project$Components$Referentiel$Archetype$libelle(archetype))
	};
};
var $author$project$Components$Referentiel$Types$CreationRapide$ordre = _List_fromArray(
	[2, 1, 0, 4, 5, 6, 3, 7, 8]);
var $author$project$Components$Referentiel$Types$CreationRapide$ouverte = {
	gn: $elm$core$Maybe$Nothing,
	zF: _List_Nil,
	gV: A2($elm$core$List$map, $author$project$Components$Referentiel$Types$CreationRapide$ligneVierge, $author$project$Components$Referentiel$Types$CreationRapide$ordre),
	b5: false
};
var $author$project$Components$Shared$Bibliotheque$Restriction$ouvrirSousUnParent = function (lu) {
	var transmises = A2($elm$core$Maybe$map, $elm$core$Set$fromList, lu.JP);
	var laissees = function (id) {
		return A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Set$member(id),
				transmises));
	};
	var initiales = $elm$core$Set$fromList(lu.hN);
	return {
		th: lu.th,
		uN: lu.uN,
		L: $elm$core$Set$isEmpty(initiales) ? $elm$core$Set$fromList(
			A2(
				$elm$core$List$filter,
				laissees,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.Aq;
					},
					lu.Ki))) : initiales,
		md: lu.md,
		gH: $elm$core$Maybe$Nothing,
		AP: initiales,
		ey: lu.ey,
		qa: false,
		eN: $elm$core$Maybe$Nothing,
		I9: lu.I9,
		rD: lu.rD,
		JP: transmises,
		fo: $elm$core$Maybe$Nothing,
		Ki: lu.Ki
	};
};
var $author$project$Components$Shared$Bibliotheque$Restriction$ouvrir = function (lu) {
	return $author$project$Components$Shared$Bibliotheque$Restriction$ouvrirSousUnParent(
		{th: _List_Nil, uN: lu.uN, md: $elm$core$Maybe$Nothing, ey: $elm$core$Maybe$Nothing, hN: lu.hN, I9: lu.I9, rD: $elm$core$Maybe$Nothing, JP: $elm$core$Maybe$Nothing, Ki: lu.Ki});
};
var $author$project$Components$Referentiel$Types$RestrictionDuChamp$retenuesDe = F2(
	function (cle, fiche) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.al;
				},
				A2($author$project$Components$Referentiel$Types$RestrictionDuChamp$champDe, cle, fiche)));
	});
var $author$project$Components$Referentiel$Types$RestrictionDuChamp$avecLaListe = F3(
	function (valeurs, fiche, enCours) {
		var _v0 = A2($author$project$Components$Referentiel$Types$RestrictionDuChamp$champDe, enCours.dy, fiche);
		if (!_v0.$) {
			var lu = _v0.a;
			return _Utils_update(
				enCours,
				{
					gt: $elm$core$Maybe$Just(
						$author$project$Components$Shared$Bibliotheque$Restriction$ouvrir(
							{
								uN: lu.uN.Bl,
								hN: A2($author$project$Components$Referentiel$Types$RestrictionDuChamp$retenuesDe, enCours.dy, fiche),
								I9: fiche.r0.R.zX,
								Ki: valeurs
							}))
				});
		} else {
			return enCours;
		}
	});
var $author$project$Components$Shared$Bibliotheque$Restriction$listeDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$filter(
			A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$Basics$not)),
		$elm$core$List$map($elm$core$Tuple$second)),
	A2(
		$elm$json$Json$Decode$field,
		'valeurs',
		$elm$json$Json$Decode$list(
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'masquee',
				$elm$json$Json$Decode$bool,
				false,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'libelle',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed(
							F3(
								function (id, libelle, masquee) {
									return _Utils_Tuple2(
										masquee,
										{Aq: id, Bl: libelle});
								}))))))));
var $author$project$Components$Referentiel$Types$Update$ouvrirLaRestriction = F2(
	function (reponse, model) {
		var _v0 = _Utils_Tuple3(
			A2($author$project$API$Reponse$lire, $author$project$Components$Shared$Bibliotheque$Restriction$listeDecoder, reponse),
			model.AM.al,
			$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model));
		if (!_v0.a.$) {
			if ((!_v0.b.$) && (!_v0.c.$)) {
				var valeurs = _v0.a.a;
				var enCours = _v0.b.a;
				var fiche = _v0.c.a;
				return A2(
					$author$project$Components$Referentiel$Types$Update$versLaRestriction,
					$author$project$Components$Shared$Drawer$Update$Ouvrir(
						$author$project$Components$Referentiel$Types$Model$idDUneInformation(enCours.dy)),
					A2(
						$author$project$Components$Referentiel$Types$Update$avecLesInformations,
						function (etat) {
							return _Utils_update(
								etat,
								{
									al: $elm$core$Maybe$Just(
										A3($author$project$Components$Referentiel$Types$RestrictionDuChamp$avecLaListe, valeurs, fiche, enCours))
								});
						},
						A2($author$project$Components$Referentiel$Types$Update$versLesReglages, $author$project$Components$Shared$Drawer$Update$Fermer, model).a));
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			var refus = _v0.a.a;
			return _Utils_Tuple2(
				A2(
					$author$project$Components$Referentiel$Types$Update$avecLesInformations,
					function (etat) {
						return _Utils_update(
							etat,
							{al: $elm$core$Maybe$Nothing});
					},
					model),
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Referentiel$Common$EffetDeType$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Types$Model$ouvrirLaSaisie = function (model) {
	return _Utils_update(
		model,
		{hP: $author$project$Components$Referentiel$Common$SaisieDeType$vide});
};
var $author$project$Components$Referentiel$Identifiants$resultatIdToString = function (_v0) {
	var valeur = _v0;
	return valeur;
};
var $author$project$Components$Referentiel$Identifiants$statutIdToString = function (_v0) {
	var valeur = _v0;
	return valeur;
};
var $author$project$Components$Referentiel$Types$Model$idDuDeclencheurDuChemin = function (element) {
	switch (element.$) {
		case 0:
			var id = element.a;
			return 'statut-' + $author$project$Components$Referentiel$Identifiants$statutIdToString(id);
		case 1:
			var id = element.a;
			return 'resultat-' + $author$project$Components$Referentiel$Identifiants$resultatIdToString(id);
		case 2:
			return 'chemin-ajouter-statut';
		default:
			return 'chemin-ajouter-resultat';
	}
};
var $author$project$Components$Referentiel$Types$Update$ouvrirLeChemin = F2(
	function (element, model) {
		var _v0 = _Utils_Tuple3(
			$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model),
			A2($author$project$Components$Referentiel$Types$Model$lienDuChemin, element, model),
			A2(
				$elm$core$Maybe$andThen,
				function (fiche) {
					return A2($author$project$Components$Referentiel$Types$Chemin$edition, fiche, element);
				},
				$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model)));
		if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
			var fiche = _v0.a.a;
			var lien = _v0.b.a;
			var saisie = _v0.c.a;
			return A2(
				$author$project$Components$Referentiel$Types$Update$versLeChemin,
				$author$project$Components$Shared$Drawer$Update$Ouvrir(
					$author$project$Components$Referentiel$Types$Model$idDuDeclencheurDuChemin(element)),
				_Utils_update(
					model,
					{
						u8: $elm$core$Maybe$Just(
							{Bl: fiche.r0.R.zX, nB: lien, r8: fiche.r0.r8}),
						ge: $elm$core$Maybe$Just(saisie)
					}));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Types$Update$ouvrirLeChoixDesOffres = function (model) {
	var _v0 = $author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model);
	if (!_v0.$) {
		var fiche = _v0.a;
		var lecture = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$EffetDeType$LireLesOffres, $elm$core$List$singleton),
				$author$project$Components$Referentiel$Types$Offres$lienDesOffresProposees(fiche)));
		var _v1 = A2(
			$author$project$Components$Referentiel$Types$Update$versLeChoixDesOffres,
			$author$project$Components$Shared$Drawer$Update$Ouvrir('referentiel-types-offres'),
			_Utils_update(
				model,
				{
					jX: A2(
						$elm$core$List$map,
						function ($) {
							return $.Aq;
						},
						fiche.D3),
					pR: '',
					p5: $elm$core$Maybe$Nothing
				}));
		var ouvert = _v1.a;
		var effets = _v1.b;
		return _Utils_Tuple2(
			ouvert,
			_Utils_ap(effets, lecture));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Types$Update$ouvrirLeChoixDuPerimetre = function (model) {
	var _v0 = $author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model);
	if (!_v0.$) {
		var fiche = _v0.a;
		var _v1 = A2(
			$author$project$Components$Referentiel$Types$Update$versLeChoixDuPerimetre,
			$author$project$Components$Shared$Drawer$Update$Ouvrir('referentiel-types-perimetre'),
			_Utils_update(
				model,
				{
					pf: A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.r8;
						},
						fiche.E9),
					pV: '',
					p5: $elm$core$Maybe$Nothing
				}));
		var ouvert = _v1.a;
		var effets = _v1.b;
		return _Utils_Tuple2(
			ouvert,
			_Utils_ap(
				effets,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$EffetDeType$LireLesPerimetres, $elm$core$List$singleton),
						A2($author$project$Components$Referentiel$Types$Offres$lienDesPerimetres, '', fiche)))));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Types$Update$ouvrirLesReglages = F2(
	function (cle, model) {
		var _v0 = A4(
			$author$project$Components$Referentiel$Types$Update$commandeDuChamp,
			$author$project$API$NavLinksDictionary$reglerLeRattachement,
			F2(
				function (uid, champ) {
					return A3($author$project$Components$Referentiel$Common$API$WriteAPIModel$ReglerLeNiveauDeLecture, uid, champ, '');
				}),
			model,
			cle);
		if (!_v0.$) {
			var lecture = A2(
				$elm$core$Maybe$withDefault,
				'essentiel',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.g4;
					},
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dw;
							},
							$author$project$Components$Referentiel$Types$Informations$parCle(cle)),
						A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.aN;
							},
							$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model)))));
			return A2(
				$author$project$Components$Referentiel$Types$Update$versLesReglages,
				$author$project$Components$Shared$Drawer$Update$Ouvrir(
					$author$project$Components$Referentiel$Types$Model$idDUneInformation(cle)),
				A2(
					$author$project$Components$Referentiel$Types$Update$avecLesInformations,
					function (etat) {
						return _Utils_update(
							etat,
							{
								pZ: $elm$core$Maybe$Nothing,
								eO: $elm$core$Maybe$Just(
									{dy: cle, np: lecture})
							});
					},
					A2($author$project$Components$Referentiel$Types$Update$versLInformation, $author$project$Components$Shared$Drawer$Update$Fermer, model).a));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$parametrageDesTypesDePartiePrenante = 'parametrage-des-types-de-partie-prenante';
var $author$project$API$NavLinksDictionary$parametrageDesTypesDeRelation = 'parametrage-des-types-de-relation';
var $author$project$Components$Referentiel$Types$Update$partirDuDrawer = F2(
	function (geste, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (_v1) {
				var commande = _v1.a;
				var lien = _v1.b;
				return A3(
					$author$project$Components$Referentiel$Common$EnvoiDeType$partir,
					$elm$core$Maybe$Just(lien),
					commande,
					model.l2);
			},
			geste);
		if (!_v0.$) {
			var _v2 = _v0.a;
			var envoi = _v2.a;
			var effets = _v2.b;
			return _Utils_Tuple2(
				A2(
					$author$project$Components$Referentiel$Types$Update$avecLeType,
					function (consulte) {
						return _Utils_update(
							consulte,
							{pZ: $elm$core$Maybe$Nothing});
					},
					_Utils_update(
						model,
						{l2: envoi})),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$API$QueryAPIModel$pourLeDrawer = function (lues) {
	return A2(
		$elm$core$List$map,
		function (c) {
			return {
				dy: c.dy,
				Bl: c.Bl,
				F$: function () {
					var _v0 = c.F$;
					if (!_v0) {
						return 'catalogue';
					} else {
						return 'parties-prenantes';
					}
				}()
			};
		},
		lues.vE);
};
var $author$project$Components$Referentiel$Common$EnvoiDeType$recevoir = $author$project$API$Envoi$recevoir;
var $author$project$Components$Referentiel$Types$Update$reglerLeTypeDeLAdresse = F2(
	function (uid, model) {
		if (_Utils_eq(
			model.vd,
			$elm$core$Maybe$Just(uid))) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var regle = _Utils_update(
				model,
				{
					vd: $elm$core$Maybe$Just(uid),
					x1: $elm$core$Maybe$Nothing,
					gv: $elm$core$Maybe$Nothing
				});
			return _Utils_Tuple2(
				regle,
				$author$project$Components$Referentiel$Types$Update$lectureDuTypeRegle(regle));
		}
	});
var $author$project$Components$Referentiel$Common$SaisieDeType$duType = function (lu) {
	return $author$project$Components$Referentiel$Common$SaisieDeType$ouverte(
		{
			fA: $author$project$Components$Referentiel$Archetype$code(lu.fA),
			kf: A2($elm$core$Maybe$withDefault, '', lu.kf),
			aC: A2($elm$core$Maybe$withDefault, '', lu.aC),
			R: $author$project$Components$Shared$LibellesParLangue$Model$depuis(
				_List_fromArray(
					[
						_Utils_Tuple2('fr', lu.R.zX),
						_Utils_Tuple2(
						'en',
						A2($elm$core$Maybe$withDefault, '', lu.R.yg))
					]))
		});
};
var $author$project$Components$Referentiel$Types$Model$idDuRenommer = 'type-renommer';
var $author$project$API$NavLinksDictionary$modifierApparence = 'modifier-apparence';
var $author$project$Components$Referentiel$Types$Model$modification = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.r0;
			},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$modifierApparence))),
		$author$project$Components$Referentiel$Types$Model$typeConsulte(model));
};
var $author$project$Components$Referentiel$Types$Update$renommageOuvert = function (model) {
	var _v0 = _Utils_Tuple2(
		$author$project$Components$Referentiel$Types$Model$typeConsulte(model),
		$author$project$Components$Referentiel$Types$Model$modification(model));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var fiche = _v0.a.a;
		return A2(
			$author$project$Components$Referentiel$Types$Update$versLeRenommage,
			$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Referentiel$Types$Model$idDuRenommer),
			_Utils_update(
				model,
				{
					hP: $author$project$Components$Referentiel$Common$SaisieDeType$duType(fiche.r0)
				}));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$ModifierLApparence = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Referentiel$Types$Model$commandeDeRenommage = function (model) {
	return A4(
		$elm$core$Maybe$map3,
		F3(
			function (fiche, lien, apparence) {
				return _Utils_Tuple2(
					A2($author$project$Components$Referentiel$Common$API$WriteAPIModel$ModifierLApparence, fiche.r0.r8, apparence),
					lien);
			}),
		$author$project$Components$Referentiel$Types$Model$typeConsulte(model),
		$author$project$Components$Referentiel$Types$Model$modification(model),
		$author$project$Components$Referentiel$Common$SaisieDeType$apparence(model.hP));
};
var $author$project$Components$Referentiel$Types$Update$renommer = function (model) {
	var saisie = model.hP;
	if (!$author$project$Components$Shared$Drawer$Model$estOuvert(model.hL)) {
		return _Utils_Tuple2(model, _List_Nil);
	} else {
		if (!$author$project$Components$Referentiel$Common$SaisieDeType$enCours(saisie)) {
			return A2($author$project$Components$Referentiel$Types$Update$versLeRenommage, $author$project$Components$Shared$Drawer$Update$Fermer, model);
		} else {
			var _v0 = $author$project$Components$Referentiel$Types$Model$commandeDeRenommage(model);
			if (!_v0.$) {
				var _v1 = _v0.a;
				var commande = _v1.a;
				var lien = _v1.b;
				var _v2 = A3(
					$author$project$Components$Referentiel$Common$EnvoiDeType$partir,
					$elm$core$Maybe$Just(lien),
					commande,
					model.l2);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var envoi = _v3.a;
					var effets = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l2: envoi,
								hP: _Utils_update(
									saisie,
									{pZ: $elm$core$Maybe$Nothing})
							}),
						effets);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hP: $author$project$Components$Referentiel$Common$SaisieDeType$tenter(saisie)
						}),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus, $elm$core$List$singleton),
							A3(
								$author$project$Components$Referentiel$Common$SaisieDeType$idDuPremierDefaut,
								{uc: false},
								$author$project$Components$Referentiel$Types$Model$prefixeDuRenommage(model),
								saisie))));
			}
		}
	}
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$RestaurerLeType = function (a) {
	return {$: 3, a: a};
};
var $author$project$API$NavLinksDictionary$restaurer = 'restaurer';
var $author$project$Components$Referentiel$Types$Model$restauration = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		function (fiche) {
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$pair(
					$author$project$Components$Referentiel$Common$API$WriteAPIModel$RestaurerLeType(fiche.r0.r8)),
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$restaurer, fiche.r0.nQ));
		},
		$author$project$Components$Referentiel$Types$Model$typeConsulte(model));
};
var $author$project$Components$Referentiel$Types$Update$restreindre = F2(
	function (commande, model) {
		if ($author$project$Components$Referentiel$Types$Model$enAttente(model)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v0 = A2(
				$elm$core$Maybe$andThen,
				function (_v1) {
					var voulue = _v1.a;
					var lien = _v1.b;
					return A3(
						$author$project$Components$Referentiel$Common$EnvoiDeType$partir,
						$elm$core$Maybe$Just(lien),
						voulue,
						model.l2);
				},
				commande);
			if (!_v0.$) {
				var _v2 = _v0.a;
				var envoi = _v2.a;
				var effets = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{l2: envoi, p6: $elm$core$Maybe$Nothing}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		}
	});
var $author$project$Components$Referentiel$Types$Offres$saisie = function (model) {
	return {at: model.jX, D3: model.D4, hC: model.pR};
};
var $author$project$Components$Referentiel$Common$SaisieDeType$sauf = F2(
	function (code, pris) {
		return _Utils_eq(
			pris,
			$elm$core$Maybe$Just(code)) ? $elm$core$Maybe$Nothing : pris;
	});
var $author$project$Components$Referentiel$Common$SaisieDeType$saisir = F2(
	function (champ, saisie) {
		switch (champ.$) {
			case 0:
				var code = champ.a;
				return _Utils_update(
					saisie,
					{fA: code});
			case 1:
				var code = champ.a;
				var texte = champ.b;
				return _Utils_update(
					saisie,
					{
						R: A3($author$project$Components$Shared$LibellesParLangue$Model$ecrire, code, texte, saisie.R),
						bW: A2($author$project$Components$Referentiel$Common$SaisieDeType$sauf, code, saisie.bW)
					});
			case 2:
				var code = champ.a;
				return _Utils_update(
					saisie,
					{aC: code});
			default:
				var code = champ.a;
				return _Utils_update(
					saisie,
					{kf: code});
		}
	});
var $author$project$Components$Referentiel$Types$Chemin$saisir = F2(
	function (champ, saisie) {
		switch (champ.$) {
			case 0:
				var code = champ.a;
				var texte = champ.b;
				return _Utils_update(
					saisie,
					{
						R: A3($author$project$Components$Shared$LibellesParLangue$Model$ecrire, code, texte, saisie.R)
					});
			case 1:
				var texte = champ.a;
				return _Utils_update(
					saisie,
					{
						bc: A2(
							$elm$core$Maybe$withDefault,
							saisie.bc,
							$elm$core$String$toInt(texte))
					});
			case 2:
				var coche = champ.a;
				return _Utils_update(
					saisie,
					{cx: coche});
			default:
				var coche = champ.a;
				return _Utils_update(
					saisie,
					{HZ: coche});
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$Conduite$saisir = F2(
	function (geste, model) {
		return _Utils_update(
			model,
			{
				hP: A2($author$project$Components$Shared$EditeurDeSchema$Model$saisir, geste, model.hP)
			});
	});
var $author$project$Components$Referentiel$Types$Update$surLaConsultee = F2(
	function (geste, model) {
		var _v0 = model.AM.ge;
		if (!_v0.$) {
			var edition = _v0.a;
			return A2(
				$author$project$Components$Referentiel$Types$Update$parLaConduite,
				function (reglage) {
					return A2(
						$author$project$Components$Shared$EditeurDeSchema$Conduite$surLeTableau,
						reglage,
						geste(edition.dy));
				},
				A2(
					$author$project$Components$Referentiel$Types$Update$avecLesInformations,
					function (etat) {
						return _Utils_update(
							etat,
							{pZ: $elm$core$Maybe$Nothing});
					},
					model));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Common$EffetDeType$LireLApercuDeLaRestriction = F4(
	function (a, b, c, d) {
		return {$: 8, a: a, b: b, c: c, d: d};
	});
var $author$project$API$NavLinksDictionary$apercuRestriction = 'apercu-restriction';
var $author$project$Components$Referentiel$Types$RestrictionDuChamp$apercu = F2(
	function (enCours, fiche) {
		var _v0 = _Utils_Tuple2(
			enCours.gt,
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$apercuRestriction, fiche.r0.nQ));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var etat = _v0.a.a;
			var lien = _v0.b.a;
			return $author$project$Components$Shared$Bibliotheque$Restriction$enregistrable(etat) ? $elm$core$Maybe$Just(
				{
					uN: enCours.dy,
					nB: lien,
					r0: fiche.r0.r8,
					Ki: $author$project$Components$Shared$Bibliotheque$Restriction$retenues(etat)
				}) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Referentiel$Types$Update$surLaRestriction = F2(
	function (changer, model) {
		var _v0 = _Utils_Tuple2(
			A2($elm$core$Maybe$map, changer, model.AM.al),
			$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var change = _v0.a.a;
			var fiche = _v0.b.a;
			return _Utils_Tuple2(
				A2(
					$author$project$Components$Referentiel$Types$Update$avecLesInformations,
					function (etat) {
						return _Utils_update(
							etat,
							{
								al: $elm$core$Maybe$Just(change)
							});
					},
					model),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (demande) {
							return _List_fromArray(
								[
									A4($author$project$Components$Referentiel$Common$EffetDeType$LireLApercuDeLaRestriction, demande.nB, demande.r0, demande.uN, demande.Ki)
								]);
						},
						A2($author$project$Components$Referentiel$Types$RestrictionDuChamp$apercu, change, fiche))));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Shared$Bibliotheque$Restriction$toutCocher = function (restriction) {
	return _Utils_update(
		restriction,
		{
			L: $elm$core$Set$fromList(
				A2(
					$elm$core$List$filter,
					function (id) {
						return A2($author$project$Components$Shared$Bibliotheque$Restriction$transmise, id, restriction);
					},
					A2(
						$elm$core$List$map,
						function ($) {
							return $.Aq;
						},
						restriction.Ki))),
			gH: $elm$core$Maybe$Nothing,
			qa: false
		});
};
var $author$project$Components$Referentiel$Types$RestrictionDuChamp$toutCocher = $author$project$Components$Referentiel$Types$RestrictionDuChamp$surLEtat($author$project$Components$Shared$Bibliotheque$Restriction$toutCocher);
var $author$project$Components$Shared$Bibliotheque$Restriction$toutDecocher = function (restriction) {
	return _Utils_update(
		restriction,
		{L: $elm$core$Set$empty, gH: $elm$core$Maybe$Nothing, qa: false});
};
var $author$project$Components$Referentiel$Types$RestrictionDuChamp$toutDecocher = $author$project$Components$Referentiel$Types$RestrictionDuChamp$surLEtat($author$project$Components$Shared$Bibliotheque$Restriction$toutDecocher);
var $author$project$Components$Referentiel$Types$Offres$commandeToutes = function (fiche) {
	return $author$project$Components$Referentiel$Types$Offres$limitee(fiche) ? A2(
		$elm$core$Maybe$map,
		function (lien) {
			return _Utils_Tuple2(
				A3($author$project$Components$Referentiel$Common$API$WriteAPIModel$LimiterAuxOffres, fiche.r0.r8, _List_Nil, $elm$core$Maybe$Nothing),
				lien);
		},
		$author$project$Components$Referentiel$Types$Offres$lienDeLaLimite(fiche)) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$Referentiel$Types$Update$toutesLesOffres = function (model) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		$author$project$Components$Referentiel$Types$Offres$commandeToutes,
		$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model));
	if (!_v0.$) {
		var commande = _v0.a;
		return A2($author$project$Components$Referentiel$Types$Update$envoyerLesOffres, commande, model);
	} else {
		return $author$project$Components$Referentiel$Types$Model$enAttente(model) ? _Utils_Tuple2(model, _List_Nil) : _Utils_Tuple2(
			_Utils_update(
				model,
				{e2: false}),
			_List_Nil);
	}
};
var $author$project$Components$Referentiel$Types$Update$typeConsulteRevenu = function (model) {
	return model.rW ? _Utils_update(
		model,
		{
			Hv: A2($elm$core$Basics$max, 0, model.Hv - 1),
			rW: false
		}) : model;
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$RattacherUnChampAUnType = F3(
	function (a, b, c) {
		return {$: 16, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Common$EffetDeType$LireLApercuDuResserrage = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$API$NavLinksDictionary$apercuResserrage = 'apercu-resserrage';
var $author$project$Components$Referentiel$Types$Model$lienDApercu = function (fiche) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$apercuResserrage, fiche.r0.nQ);
};
var $author$project$Components$Shared$EditeurDeSchema$Model$reglesResserrees = F2(
	function (avant, apres) {
		var sansLimite = _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
		var premier = function (liste) {
			return A2(
				$elm$core$Maybe$withDefault,
				sansLimite,
				$elm$core$List$head(liste));
		};
		var plusHaut = F2(
			function (avantLimite, apresLimite) {
				var _v10 = _Utils_Tuple2(avantLimite, apresLimite);
				if (_v10.b.$ === 1) {
					var _v11 = _v10.b;
					return false;
				} else {
					if (_v10.a.$ === 1) {
						var _v12 = _v10.a;
						return true;
					} else {
						var a = _v10.a.a;
						var b = _v10.b.a;
						return _Utils_cmp(b, a) > 0;
					}
				}
			});
		var plusBas = F2(
			function (avantLimite, apresLimite) {
				var _v7 = _Utils_Tuple2(avantLimite, apresLimite);
				if (_v7.b.$ === 1) {
					var _v8 = _v7.b;
					return false;
				} else {
					if (_v7.a.$ === 1) {
						var _v9 = _v7.a;
						return true;
					} else {
						var a = _v7.a.a;
						var b = _v7.b.a;
						return _Utils_cmp(b, a) < 0;
					}
				}
			});
		var plusEtroit = F2(
			function (_v5, _v6) {
				var minAvant = _v5.a;
				var maxAvant = _v5.b;
				var minApres = _v6.a;
				var maxApres = _v6.b;
				return A2(plusHaut, minAvant, minApres) || A2(plusBas, maxAvant, maxApres);
			});
		var nombre = function (borne) {
			if (!borne.$) {
				var valeur = borne.a;
				return $elm$core$Maybe$Just(valeur);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		var motif = function (regles) {
			return A2(
				$elm$core$List$filterMap,
				function (regle) {
					if (regle.$ === 2) {
						var expression = regle.a;
						return $elm$core$Maybe$Just(expression);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				regles);
		};
		var longueur = function (regles) {
			return A2(
				$elm$core$List$filterMap,
				function (regle) {
					if (regle.$ === 1) {
						var min = regle.a;
						var max = regle.b;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(min, max));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				regles);
		};
		var bornes = function (regles) {
			return A2(
				$elm$core$List$filterMap,
				function (regle) {
					if (!regle.$) {
						var min = regle.a;
						var max = regle.b;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(
								A2($elm$core$Maybe$andThen, nombre, min),
								A2($elm$core$Maybe$andThen, nombre, max)));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				regles);
		};
		return A2(
			plusEtroit,
			premier(
				longueur(avant)),
			premier(
				longueur(apres))) || (A2(
			plusEtroit,
			premier(
				bornes(avant)),
			premier(
				bornes(apres))) || function () {
			var _v0 = motif(apres);
			if (!_v0.b) {
				return false;
			} else {
				var expressions = _v0;
				return !_Utils_eq(
					expressions,
					motif(avant));
			}
		}());
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$resserre = function (saisie) {
	var _v0 = _Utils_Tuple2(
		$author$project$Components$Shared$EditeurDeSchema$Model$resserrageRefuse(saisie),
		saisie.lZ);
	if ((!_v0.a) && (!_v0.b.$)) {
		var avant = _v0.b.a;
		return $author$project$Components$Shared$EditeurDeSchema$Model$valeursRetirees(saisie) || (A2($author$project$Components$Shared$EditeurDeSchema$Model$borneResserree, 'min', saisie) || (A2($author$project$Components$Shared$EditeurDeSchema$Model$borneResserree, 'max', saisie) || A2(
			$author$project$Components$Shared$EditeurDeSchema$Model$reglesResserrees,
			avant.hJ,
			$author$project$Components$Shared$EditeurDeSchema$Model$champVoulu(saisie).hJ)));
	} else {
		return false;
	}
};
var $author$project$Components$Referentiel$Types$Update$demandeDApercu = function (model) {
	var _v0 = _Utils_Tuple2(
		$author$project$Components$Referentiel$Types$Model$ficheDesInformations(model),
		$author$project$Components$Shared$EditeurDeSchema$Model$valide(model.AM.hP));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var fiche = _v0.a.a;
		var champ = _v0.b.a;
		return $author$project$Components$Shared$EditeurDeSchema$Model$resserre(model.AM.hP) ? A2(
			$elm$core$Maybe$map,
			function (lien) {
				return A3($author$project$Components$Referentiel$Common$EffetDeType$LireLApercuDuResserrage, lien, fiche.r0.r8, champ);
			},
			$author$project$Components$Referentiel$Types$Model$lienDApercu(fiche)) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Types$Update$validerOuAvertir = function (model) {
	var _v0 = _Utils_Tuple2(
		model.AM.tq,
		$author$project$Components$Referentiel$Types$Update$demandeDApercu(model));
	_v0$2:
	while (true) {
		switch (_v0.a.$) {
			case 0:
				if (!_v0.b.$) {
					var _v1 = _v0.a;
					var effet = _v0.b.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Types$Update$avecLesInformations,
							function (etat) {
								return _Utils_update(
									etat,
									{tq: $author$project$Components$Shared$EditeurDeSchema$Resserrage$ApercuDemande});
							},
							model),
						_List_fromArray(
							[effet]));
				} else {
					break _v0$2;
				}
			case 1:
				var _v2 = _v0.a;
				return _Utils_Tuple2(model, _List_Nil);
			default:
				break _v0$2;
		}
	}
	return $author$project$Components$Referentiel$Types$Update$sansApercu(
		A2($author$project$Components$Referentiel$Types$Update$parLaConduite, $author$project$Components$Shared$EditeurDeSchema$Conduite$valider, model));
};
var $author$project$Components$Referentiel$Types$Update$validerLAjout = function (model) {
	var etat = model.AM;
	var _v0 = _Utils_Tuple2(
		$author$project$Components$Referentiel$Types$Model$ficheDesInformations(model),
		etat.hP.lZ);
	if ((!_v0.a.$) && (_v0.b.$ === 1)) {
		var fiche = _v0.a.a;
		var _v1 = _v0.b;
		var _v2 = etat.GZ.n9;
		if (_v2 === 1) {
			var _v3 = _Utils_Tuple2(
				etat.GZ.pN.vd,
				$author$project$Components$Referentiel$Types$Model$lienDeRattachementDUnChamp(fiche));
			if ((!_v3.a.$) && (!_v3.b.$)) {
				var id = _v3.a.a;
				var lien = _v3.b.a;
				return A3(
					$author$project$Components$Referentiel$Types$Update$envoyerLaCommande,
					lien,
					A3($author$project$Components$Referentiel$Common$API$WriteAPIModel$RattacherUnChampAUnType, fiche.r0.r8, id, etat.GZ.pN.qc),
					A2(
						$author$project$Components$Referentiel$Types$Update$avecLeRattachement,
						function (r) {
							return _Utils_update(
								r,
								{pZ: $elm$core$Maybe$Nothing});
						},
						model));
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return $author$project$Components$Referentiel$Types$Update$validerOuAvertir(model);
		}
	} else {
		return $author$project$Components$Referentiel$Types$Update$validerOuAvertir(model);
	}
};
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$AjouterUneCollectionAUnType = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Components$Referentiel$Common$API$WriteAPIModel$RetirerUneCollectionDUnType = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$ajouterUneCollectionAUnType = 'ajouter-une-collection-a-un-type';
var $author$project$API$NavLinksDictionary$retirerUneCollectionDUnType = 'retirer-une-collection-d-un-type';
var $author$project$Components$Shared$CollectionsDuType$Update$Ajouter = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Shared$CollectionsDuType$Model$Partie = 1;
var $author$project$Components$Shared$CollectionsDuType$Update$Retirer = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Shared$CollectionsDuType$Update$Rien = {$: 0};
var $author$project$Components$Shared$CollectionsDuType$Model$Toute = 0;
var $author$project$Components$Shared$CollectionsDuType$Update$basculer = F2(
	function (id, choisis) {
		return A2($elm$core$List$member, id, choisis) ? A2(
			$elm$core$List$filter,
			function (autre) {
				return !_Utils_eq(autre, id);
			},
			choisis) : _Utils_ap(
			choisis,
			_List_fromArray(
				[id]));
	});
var $author$project$Components$Shared$CollectionsDuType$Model$collectionDeLAjout = F2(
	function (collections, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (cle) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (c) {
							return _Utils_eq(c.dy, cle);
						},
						collections));
			},
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.vD;
				},
				model.fw));
	});
var $author$project$Components$Shared$CollectionsDuType$Model$manquants = function (collection) {
	return A2(
		$elm$core$List$filter,
		function (champ) {
			return !champ.e6;
		},
		collection.dw);
};
var $author$project$Components$Shared$CollectionsDuType$Model$champsAAjouter = F2(
	function (collections, model) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$Components$Shared$CollectionsDuType$Model$collectionDeLAjout, collections, model),
			model.fw);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var collection = _v0.a.a;
			var ajout = _v0.b.a;
			var _v1 = ajout.n9;
			if (!_v1) {
				return $author$project$Components$Shared$CollectionsDuType$Model$manquants(collection);
			} else {
				return A2(
					$elm$core$List$filter,
					function (champ) {
						return A2($elm$core$List$member, champ.Aq, ajout.jL);
					},
					$author$project$Components$Shared$CollectionsDuType$Model$manquants(collection));
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Shared$CollectionsDuType$Model$commandeDAjout = F2(
	function (collections, model) {
		var _v0 = _Utils_Tuple3(
			A2($author$project$Components$Shared$CollectionsDuType$Model$collectionDeLAjout, collections, model),
			model.fw,
			A2($author$project$Components$Shared$CollectionsDuType$Model$champsAAjouter, collections, model));
		if (((!_v0.a.$) && (!_v0.b.$)) && _v0.c.b) {
			var collection = _v0.a.a;
			var ajout = _v0.b.a;
			var aAjouter = _v0.c;
			var choisis = A2(
				$elm$core$List$map,
				function (champ) {
					return {
						uN: champ.Aq,
						g4: A2($elm$core$Dict$get, champ.Aq, ajout.C9)
					};
				},
				aAjouter);
			return $elm$core$Maybe$Just(
				{
					dw: ((!ajout.n9) && $elm$core$Dict$isEmpty(ajout.C9)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(choisis),
					vD: collection.dy
				});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Shared$CollectionsDuType$Model$idDeLAjout = 'collections-type-ajouter';
var $author$project$Components$Shared$CollectionsDuType$Model$idDuRetrait = function (cle) {
	return 'collections-type-retirer-' + cle;
};
var $author$project$Components$Shared$CollectionsDuType$Update$orElse = F2(
	function (defaut, choisie) {
		if (!choisie.$) {
			return choisie;
		} else {
			return defaut;
		}
	});
var $author$project$Components$Shared$CollectionsDuType$Update$premiereACompleter = function (collections) {
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.dy;
		},
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (collection) {
					return !$elm$core$List$isEmpty(
						$author$project$Components$Shared$CollectionsDuType$Model$manquants(collection));
				},
				collections)));
};
var $author$project$Components$Shared$CollectionsDuType$Model$collectionDuRetrait = F2(
	function (collections, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (retrait) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (c) {
							return _Utils_eq(c.dy, retrait.vD);
						},
						collections));
			},
			model.eW);
	});
var $author$project$Components$Shared$CollectionsDuType$Model$valeursDuRetrait = F2(
	function (collections, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function (collection) {
					return $elm$core$List$sum(
						A2(
							$elm$core$List$map,
							function ($) {
								return $.Ki;
							},
							A2(
								$elm$core$List$filter,
								function ($) {
									return $.e6;
								},
								collection.dw)));
				},
				A2($author$project$Components$Shared$CollectionsDuType$Model$collectionDuRetrait, collections, model)));
	});
var $author$project$Components$Shared$CollectionsDuType$Model$retraitPossible = F2(
	function (collections, model) {
		return (!_Utils_eq(
			A2($author$project$Components$Shared$CollectionsDuType$Model$collectionDuRetrait, collections, model),
			$elm$core$Maybe$Nothing)) && (!A2($author$project$Components$Shared$CollectionsDuType$Model$valeursDuRetrait, collections, model));
	});
var $author$project$Components$Shared$CollectionsDuType$Model$saisieEnCours = function (model) {
	var _v0 = model.fw;
	if (!_v0.$) {
		var ajout = _v0.a;
		return (!$elm$core$List$isEmpty(ajout.jL)) || (!$elm$core$Dict$isEmpty(ajout.C9));
	} else {
		return false;
	}
};
var $author$project$Components$Shared$CollectionsDuType$Update$surLAjout = F2(
	function (geste, model) {
		return _Utils_update(
			model,
			{
				fw: A2(
					$elm$core$Maybe$map,
					function (ajout) {
						return geste(
							_Utils_update(
								ajout,
								{qa: false}));
					},
					model.fw)
			});
	});
var $author$project$Components$Shared$CollectionsDuType$Update$update = F3(
	function (collections, msg, model) {
		switch (msg.$) {
			case 0:
				var cle = msg.a;
				var ouvert = _Utils_update(
					model,
					{
						fw: $elm$core$Maybe$Just(
							{
								jL: _List_Nil,
								vD: A2(
									$author$project$Components$Shared$CollectionsDuType$Update$orElse,
									$author$project$Components$Shared$CollectionsDuType$Update$premiereACompleter(collections),
									cle),
								n9: 0,
								C9: $elm$core$Dict$empty,
								qa: false
							})
					});
				var _v1 = A3(
					$author$project$Components$Shared$Drawer$Update$update,
					{Il: false},
					$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Shared$CollectionsDuType$Model$idDeLAjout),
					ouvert.kY);
				var drawer = _v1.a;
				var effets = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						ouvert,
						{kY: drawer}),
					effets,
					$author$project$Components$Shared$CollectionsDuType$Update$Rien);
			case 1:
				var cle = msg.a;
				var _v2 = A3(
					$author$project$Components$Shared$Drawer$Update$update,
					{Il: false},
					$author$project$Components$Shared$Drawer$Update$Ouvrir(
						$author$project$Components$Shared$CollectionsDuType$Model$idDuRetrait(cle)),
					model.lD);
				var drawer = _v2.a;
				var effets = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							lD: drawer,
							eW: $elm$core$Maybe$Just(
								{vD: cle})
						}),
					effets,
					$author$project$Components$Shared$CollectionsDuType$Update$Rien);
			case 2:
				var geste = msg.a;
				var _v3 = A3(
					$author$project$Components$Shared$Drawer$Update$update,
					{
						Il: $author$project$Components$Shared$CollectionsDuType$Model$saisieEnCours(model)
					},
					geste,
					model.kY);
				var drawer = _v3.a;
				var effets = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fw: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? model.fw : $elm$core$Maybe$Nothing,
							kY: drawer
						}),
					effets,
					$author$project$Components$Shared$CollectionsDuType$Update$Rien);
			case 3:
				var geste = msg.a;
				var _v4 = A3(
					$author$project$Components$Shared$Drawer$Update$update,
					{Il: false},
					geste,
					model.lD);
				var drawer = _v4.a;
				var effets = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							lD: drawer,
							eW: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? model.eW : $elm$core$Maybe$Nothing
						}),
					effets,
					$author$project$Components$Shared$CollectionsDuType$Update$Rien);
			case 4:
				var cle = msg.a;
				return _Utils_Tuple3(
					A2(
						$author$project$Components$Shared$CollectionsDuType$Update$surLAjout,
						function (ajout) {
							return _Utils_update(
								ajout,
								{
									jL: _List_Nil,
									vD: $elm$core$Maybe$Just(cle),
									C9: $elm$core$Dict$empty
								});
						},
						model),
					_List_Nil,
					$author$project$Components$Shared$CollectionsDuType$Update$Rien);
			case 5:
				var code = msg.a;
				return _Utils_Tuple3(
					A2(
						$author$project$Components$Shared$CollectionsDuType$Update$surLAjout,
						function (ajout) {
							return _Utils_update(
								ajout,
								{
									n9: (code === 'partie') ? 1 : 0
								});
						},
						model),
					_List_Nil,
					$author$project$Components$Shared$CollectionsDuType$Update$Rien);
			case 6:
				var id = msg.a;
				return _Utils_Tuple3(
					A2(
						$author$project$Components$Shared$CollectionsDuType$Update$surLAjout,
						function (ajout) {
							return _Utils_update(
								ajout,
								{
									jL: A2($author$project$Components$Shared$CollectionsDuType$Update$basculer, id, ajout.jL)
								});
						},
						model),
					_List_Nil,
					$author$project$Components$Shared$CollectionsDuType$Update$Rien);
			case 7:
				var id = msg.a;
				var niveau = msg.b;
				return _Utils_Tuple3(
					A2(
						$author$project$Components$Shared$CollectionsDuType$Update$surLAjout,
						function (ajout) {
							return _Utils_update(
								ajout,
								{
									C9: A3($elm$core$Dict$insert, id, niveau, ajout.C9)
								});
						},
						model),
					_List_Nil,
					$author$project$Components$Shared$CollectionsDuType$Update$Rien);
			case 8:
				return _Utils_Tuple3(
					model,
					_List_Nil,
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Components$Shared$CollectionsDuType$Update$Rien,
						A2(
							$elm$core$Maybe$map,
							$author$project$Components$Shared$CollectionsDuType$Update$Ajouter,
							A2($author$project$Components$Shared$CollectionsDuType$Model$commandeDAjout, collections, model))));
			default:
				var _v5 = _Utils_Tuple2(
					A2($author$project$Components$Shared$CollectionsDuType$Model$retraitPossible, collections, model),
					model.eW);
				if (_v5.a && (!_v5.b.$)) {
					var retrait = _v5.b.a;
					return _Utils_Tuple3(
						model,
						_List_Nil,
						$author$project$Components$Shared$CollectionsDuType$Update$Retirer(retrait.vD));
				} else {
					return _Utils_Tuple3(model, _List_Nil, $author$project$Components$Shared$CollectionsDuType$Update$Rien);
				}
		}
	});
var $author$project$Components$Referentiel$Types$Update$versLesCollections = F2(
	function (geste, model) {
		var _v0 = $author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model);
		if (!_v0.$) {
			var fiche = _v0.a;
			var _v1 = A3($author$project$Components$Shared$CollectionsDuType$Update$update, fiche.vE, geste, model.vE);
			var collections = _v1.a;
			var effets = _v1.b;
			var sortie = _v1.c;
			var suivant = _Utils_update(
				model,
				{vE: collections});
			var focus = A2(
				$elm$core$List$map,
				function (_v4) {
					var cible = _v4;
					return $author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(cible);
				},
				effets);
			var lancer = F2(
				function (commande, rel) {
					var _v3 = A2($author$project$API$Liens$trouver, rel, fiche.r0.nQ);
					if (!_v3.$) {
						var lien = _v3.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							function (partis) {
								return _Utils_ap(focus, partis);
							},
							A3($author$project$Components$Referentiel$Types$Update$envoyerLaCommande, lien, commande, suivant));
					} else {
						return _Utils_Tuple2(suivant, focus);
					}
				});
			switch (sortie.$) {
				case 0:
					return _Utils_Tuple2(suivant, focus);
				case 1:
					var voulu = sortie.a;
					return A2(
						lancer,
						A2($author$project$Components$Referentiel$Common$API$WriteAPIModel$AjouterUneCollectionAUnType, fiche.r0.r8, voulu),
						$author$project$API$NavLinksDictionary$ajouterUneCollectionAUnType);
				default:
					var cle = sortie.a;
					return A2(
						lancer,
						A2($author$project$Components$Referentiel$Common$API$WriteAPIModel$RetirerUneCollectionDUnType, fiche.r0.r8, cle),
						$author$project$API$NavLinksDictionary$retirerUneCollectionDUnType);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Types$Update$aiguiller = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var liens = msg.a;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$parametrageDesTypesDePartiePrenante, liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						function (ouvert) {
							return _Utils_update(
								ouvert,
								{
									jh: !_Utils_eq(
										A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$parametrageDesTypesDeRelation, liens),
										$elm$core$Maybe$Nothing),
									AM: function (etat) {
										return _Utils_update(
											etat,
											{
												nC: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$bibliothequeDeChamps, liens),
												nG: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$collectionsDeChamps, liens),
												BF: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$listes, liens)
											});
									}(ouvert.AM)
								});
						}(
							$author$project$Components$Referentiel$Types$Model$ouvert(
								$elm$core$Maybe$Just(lecture))),
						_List_fromArray(
							[
								$author$project$Components$Referentiel$Common$EffetDeType$DemanderProcessUid,
								$author$project$Components$Referentiel$Common$EffetDeType$Lire(lecture)
							]));
				} else {
					return _Utils_Tuple2(
						function (ferme) {
							return _Utils_update(
								ferme,
								{qa: true});
						}(
							$author$project$Components$Referentiel$Types$Model$ouvert($elm$core$Maybe$Nothing)),
						_List_Nil);
				}
			case 1:
				var reponse = msg.a;
				var revenu = _Utils_update(
					model,
					{
						Hv: A2($elm$core$Basics$max, 0, model.Hv - 1)
					});
				var _v2 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Types$API$QueryAPIModel$annuaireDecoder, reponse);
				if (!_v2.$) {
					var annuaire = _v2.a;
					var servi = _Utils_update(
						revenu,
						{
							aS: $elm$core$Maybe$Just(annuaire)
						});
					var lecture = $author$project$Components$Referentiel$Types$Update$lectureDuTypeRegle(servi);
					return _Utils_Tuple2(
						$elm$core$List$isEmpty(lecture) ? servi : _Utils_update(
							servi,
							{x1: $elm$core$Maybe$Nothing}),
						lecture);
				} else {
					var refus = _v2.a;
					return _Utils_Tuple2(
						revenu,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Referentiel$Common$EffetDeType$Reconnecter]) : _List_Nil);
				}
			case 2:
				var terme = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{hC: terme}),
					_List_Nil);
			case 3:
				if (msg.a) {
					var _v3 = $author$project$Components$Referentiel$Types$Model$archives(model);
					if (!_v3.$) {
						var lien = _v3.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{fG: true}),
							_List_fromArray(
								[
									$author$project$Components$Referentiel$Common$EffetDeType$Lire(lien)
								]));
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				} else {
					return $author$project$Components$Referentiel$Types$Update$relire(
						_Utils_update(
							model,
							{fG: false}));
				}
			case 4:
				var octets = msg.a;
				return $author$project$Components$Parametrage$NouveauChamp$Model$ouvert(model.AM.oP) ? A2(
					$author$project$Components$Referentiel$Types$Update$surLeNouveauChamp,
					$author$project$Components$Parametrage$NouveauChamp$Update$ProcessUidRecu(octets),
					model) : $author$project$Components$Referentiel$Types$Update$envoyerLaSuivante(
					_Utils_update(
						model,
						{
							l2: A2($author$project$Components$Referentiel$Common$EnvoiDeType$recevoir, octets, model.l2)
						}));
			case 5:
				return model.AM.qj ? A2(
					$author$project$Components$Referentiel$Types$Update$puisAvec,
					$author$project$Components$Referentiel$Types$Update$relireLeTypeRegleApresLaCommande,
					$author$project$Components$Referentiel$Types$Update$relire(
						A2(
							$author$project$Components$Referentiel$Types$Update$avecLesInformations,
							function (etat) {
								return _Utils_update(
									etat,
									{qj: false});
							},
							model))) : $author$project$Components$Referentiel$Types$Update$relire(model);
			case 6:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$versLeDrawer, geste, model);
			case 7:
				return _Utils_eq(
					$author$project$Components$Referentiel$Types$Model$creation(model),
					$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A2(
					$author$project$Components$Referentiel$Types$Update$versLeDrawer,
					$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Referentiel$Types$Model$idDeLaCreation),
					$author$project$Components$Referentiel$Types$Model$ouvrirLaSaisie(model));
			case 10:
				return _Utils_eq(
					$author$project$Components$Referentiel$Types$Model$creation(model),
					$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A2(
					$author$project$Components$Referentiel$Types$Update$versLaRapide,
					$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Referentiel$Types$Model$idDeLaCreationRapide),
					_Utils_update(
						model,
						{
							ki: $elm$core$Maybe$Just($author$project$Components$Referentiel$Types$CreationRapide$ouverte)
						}));
			case 11:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$versLaRapide, geste, model);
			case 12:
				var archetype = msg.a;
				var coche = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Types$Update$avecLaRapide,
						A2($author$project$Components$Referentiel$Types$CreationRapide$cocher, archetype, coche),
						model),
					_List_Nil);
			case 13:
				var archetype = msg.a;
				var nom = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Types$Update$avecLaRapide,
						A2($author$project$Components$Referentiel$Types$CreationRapide$nommer, archetype, nom),
						model),
					_List_Nil);
			case 14:
				return $author$project$Components$Referentiel$Types$Update$demanderLaRapide(model);
			case 8:
				var champ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hP: A2($author$project$Components$Referentiel$Common$SaisieDeType$saisir, champ, model.hP)
						}),
					_List_Nil);
			case 9:
				return $author$project$Components$Referentiel$Types$Update$creer(model);
			case 15:
				var reponse = msg.a;
				var _v4 = A2($author$project$Components$Referentiel$Common$EnvoiDeType$conclure, reponse, model.l2);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var envoi = _v5.a;
					var issue = _v5.b;
					var effets = _v5.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Referentiel$Types$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 16:
				var etape = msg.a;
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[
							$author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(
							$author$project$Components$Referentiel$Types$Parcours$idDuTitre(etape))
						]));
			case 17:
				var uid = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$consulter, uid, model);
			case 18:
				var reponse = msg.a;
				return A2(
					$author$project$Components$Referentiel$Types$Update$lireLeType,
					reponse,
					$author$project$Components$Referentiel$Types$Update$typeConsulteRevenu(model));
			case 19:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$versLaConsultation, geste, model);
			case 20:
				return $author$project$Components$Referentiel$Types$Update$renommageOuvert(model);
			case 21:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$versLeRenommage, geste, model);
			case 22:
				return $author$project$Components$Referentiel$Types$Update$renommer(model);
			case 23:
				return _Utils_eq(
					$author$project$Components$Referentiel$Types$Model$archivage(model),
					$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Types$Update$avecLeType,
						function (consulte) {
							return _Utils_update(
								consulte,
								{ir: true});
						},
						model),
					_List_fromArray(
						[
							$author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus($author$project$Components$Referentiel$Types$Model$idsDeLaConfirmation.to)
						]));
			case 24:
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Types$Update$avecLeType,
						function (consulte) {
							return _Utils_update(
								consulte,
								{ir: false});
						},
						model),
					_List_fromArray(
						[
							$author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus($author$project$Components$Referentiel$Types$Model$idDeLArchivage)
						]));
			case 25:
				return _Utils_eq(
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.ir;
						},
						model.bA),
					$elm$core$Maybe$Just(true)) ? A2(
					$author$project$Components$Referentiel$Types$Update$partirDuDrawer,
					$author$project$Components$Referentiel$Types$Model$archivage(model),
					A2(
						$author$project$Components$Referentiel$Types$Update$avecLeType,
						function (consulte) {
							return _Utils_update(
								consulte,
								{ir: false});
						},
						model)) : _Utils_Tuple2(model, _List_Nil);
			case 26:
				return A2(
					$author$project$Components$Referentiel$Types$Update$partirDuDrawer,
					$author$project$Components$Referentiel$Types$Model$restauration(model),
					model);
			case 27:
				return A2(
					$author$project$Components$Referentiel$Types$Update$puisAvec,
					$author$project$Components$Referentiel$Types$Update$relire,
					$author$project$Components$Referentiel$Types$Update$relireLeTypeApresLaCommande(model));
			case 28:
				var uid = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$choisir, uid, model);
			case 29:
				var uid = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$reglerLeTypeDeLAdresse, uid, model);
			case 30:
				var reponse = msg.a;
				return A2(
					$author$project$Components$Referentiel$Types$Update$lireLeTypeRegle,
					reponse,
					$author$project$Components$Referentiel$Types$Update$ficheRegleeRevenue(model));
			case 31:
				var nature = msg.a;
				var coche = msg.b;
				return A2(
					$author$project$Components$Referentiel$Types$Update$restreindre,
					A3($author$project$Components$Referentiel$Types$Model$commandeDeNature, nature, coche, model),
					model);
			case 32:
				var qualite = msg.a;
				var coche = msg.b;
				return A2(
					$author$project$Components$Referentiel$Types$Update$restreindre,
					A3($author$project$Components$Referentiel$Types$Model$commandeDeQualite, qualite, coche, model),
					model);
			case 33:
				return $author$project$Components$Referentiel$Types$Update$toutesLesOffres(model);
			case 34:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{p5: $elm$core$Maybe$Nothing, e2: true}),
					$author$project$Components$Referentiel$Types$Update$lectureDuCatalogueDesOffres(model));
			case 35:
				var interdite = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$interdire, interdite, model);
			case 36:
				return $author$project$Components$Referentiel$Types$Update$ouvrirLeChoixDesOffres(model);
			case 37:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$versLeChoixDesOffres, geste, model);
			case 38:
				var offre = msg.a;
				var coche = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jX: A3($author$project$Components$Referentiel$Common$ChoixDesOffres$cocher, offre, coche, model.jX),
							p5: $elm$core$Maybe$Nothing
						}),
					_List_Nil);
			case 39:
				var texte = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pR: texte}),
					_List_Nil);
			case 40:
				return A2(
					$author$project$Components$Referentiel$Types$Update$enregistrerLesOffres,
					function (fiche) {
						return A2(
							$author$project$Components$Referentiel$Types$Offres$commandeDesOffresVoulues,
							$author$project$Components$Referentiel$Types$Offres$saisie(model),
							fiche);
					},
					model);
			case 42:
				return $author$project$Components$Referentiel$Types$Update$ouvrirLeChoixDuPerimetre(model);
			case 43:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$versLeChoixDuPerimetre, geste, model);
			case 45:
				var perimetre = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							pf: $elm$core$Maybe$Just(perimetre),
							p5: $elm$core$Maybe$Nothing
						}),
					_List_Nil);
			case 44:
				var terme = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pV: terme}),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$EffetDeType$LireLesPerimetres, $elm$core$List$singleton),
							A2(
								$elm$core$Maybe$andThen,
								$author$project$Components$Referentiel$Types$Offres$lienDesPerimetres(terme),
								$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model)))));
			case 46:
				var _v6 = _Utils_Tuple2(
					model.pf,
					$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model));
				if ((!_v6.a.$) && (!_v6.b.$)) {
					var choisi = _v6.a.a;
					var fiche = _v6.b.a;
					var _v7 = A2($author$project$Components$Referentiel$Types$Offres$commandeDuPerimetre, choisi, fiche);
					if (!_v7.$) {
						var envoi = _v7.a;
						return A2($author$project$Components$Referentiel$Types$Update$envoyerLesOffres, envoi, model);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 47:
				var _v8 = A2(
					$elm$core$Maybe$andThen,
					$author$project$Components$Referentiel$Types$Offres$commandeSansPerimetre,
					$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model));
				if (!_v8.$) {
					var envoi = _v8.a;
					return A2($author$project$Components$Referentiel$Types$Update$envoyerLesOffres, envoi, model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 48:
				var reponse = msg.a;
				var _v9 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$ChoixDUnPerimetre$annuaireDecoder, reponse);
				if (!_v9.$) {
					var lus = _v9.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ph: $author$project$Components$Referentiel$Common$ChoixDUnPerimetre$Lue(lus)
							}),
						_List_Nil);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ph: $author$project$Components$Referentiel$Common$ChoixDUnPerimetre$Illisible}),
						_List_Nil);
				}
			case 41:
				var reponse = msg.a;
				var _v10 = A2(
					$author$project$API$Reponse$lire,
					$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$QueryAPIModel$offreProposeeDecoder),
					reponse);
				if (!_v10.$) {
					var lues = _v10.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								D4: $author$project$Components$Referentiel$Common$Offres$Lue(
									$author$project$Components$Referentiel$Common$Offres$depuis(lues))
							}),
						_List_Nil);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{D4: $author$project$Components$Referentiel$Common$Offres$Illisible}),
						_List_Nil);
				}
			case 49:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{x1: $elm$core$Maybe$Nothing}),
					$author$project$Components$Referentiel$Types$Update$relectureDuTypeRegle(model));
			case 50:
				var element = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$ouvrirLeChemin, element, model);
			case 51:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$versLeChemin, geste, model);
			case 52:
				var champ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ge: A2(
								$elm$core$Maybe$map,
								$author$project$Components$Referentiel$Types$Chemin$saisir(champ),
								model.ge)
						}),
					_List_Nil);
			case 53:
				return $author$project$Components$Referentiel$Types$Update$definirLeChemin(model);
			case 54:
				return $author$project$Components$Referentiel$Types$Update$sansApercu(
					$author$project$Components$Referentiel$Types$Update$ajoutOuvert(model));
			case 55:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$surLeNouveauChamp, geste, model);
			case 57:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$versLesCollections, geste, model);
			case 58:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$versLesBlocs, geste, model);
			case 59:
				var reponse = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$ordreLu, reponse, model);
			case 56:
				var geste = msg.a;
				return $author$project$Components$Referentiel$Types$Update$sansApercu(
					A2(
						$author$project$Components$Referentiel$Types$Update$parLaConduite,
						function (reglage) {
							return A2($author$project$Components$Shared$EditeurDeSchema$Conduite$versLeDrawer, reglage, geste);
						},
						model));
			case 60:
				var geste = msg.a;
				return $author$project$Components$Referentiel$Types$Update$sansApercu(
					A2(
						$author$project$Components$Referentiel$Types$Update$parLaConduite,
						F2(
							function (_v11, projection) {
								return _Utils_Tuple2(
									A2($author$project$Components$Shared$EditeurDeSchema$Conduite$saisir, geste, projection),
									_List_Nil);
							}),
						model));
			case 61:
				return $author$project$Components$Referentiel$Types$Update$validerLAjout(model);
			case 63:
				var reponse = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$apercuLu, reponse, model);
			case 62:
				var cle = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$consulterUneInformation, cle, model);
			case 64:
				var cle = msg.a;
				return $author$project$Components$Referentiel$Types$Update$sansApercu(
					A2($author$project$Components$Referentiel$Types$Update$modifierLaDefinition, cle, model));
			case 65:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$versLInformation, geste, model);
			case 66:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$versLaMasquee, geste, model);
			case 67:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$versLesVersions, geste, model);
			case 68:
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Types$Update$avecLEditionDUneInformation,
						function (e) {
							return _Utils_update(
								e,
								{hL: true});
						},
						model),
					_List_Nil);
			case 69:
				var code = msg.a;
				var texte = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Types$Update$avecLEditionDUneInformation,
						function (e) {
							return _Utils_update(
								e,
								{
									R: A3($author$project$Components$Shared$LibellesParLangue$Model$ecrire, code, texte, e.R)
								});
						},
						model),
					_List_Nil);
			case 70:
				var coche = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Types$Update$avecLEditionDUneInformation,
						function (e) {
							return _Utils_update(
								e,
								{he: coche});
						},
						model),
					_List_Nil);
			case 71:
				var coche = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Types$Update$avecLEditionDUneInformation,
						function (e) {
							return _Utils_update(
								e,
								{
									Ff: e.Ff && (coche || (!A2($author$project$Components$Referentiel$Types$Model$indicateurRetirable, e.dy, model)))
								});
						},
						model),
					_List_Nil);
			case 72:
				return $author$project$Components$Referentiel$Types$Update$enregistrerLInformation(model);
			case 73:
				return A2($author$project$Components$Referentiel$Types$Update$surLaConsultee, $author$project$Components$Shared$EditeurDeSchema$View$MasquageDemande, model);
			case 74:
				return A2($author$project$Components$Referentiel$Types$Update$surLaConsultee, $author$project$Components$Shared$EditeurDeSchema$View$AffichageDemande, model);
			case 75:
				var geste = msg.a;
				return A2(
					$author$project$Components$Referentiel$Types$Update$parLaConduite,
					function (reglage) {
						return A2($author$project$Components$Shared$EditeurDeSchema$Conduite$surLeTableau, reglage, geste);
					},
					model);
			case 76:
				return $author$project$Components$Referentiel$Types$Update$demanderLHistorique(model);
			case 77:
				var reponse = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$lireLHistorique, reponse, model);
			case 78:
				var cle = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$ouvrirLesReglages, cle, model);
			case 79:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$versLesReglages, geste, model);
			case 80:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Types$Update$avecLesInformations,
						function (etat) {
							return _Utils_update(
								etat,
								{
									eO: A2(
										$elm$core$Maybe$map,
										function (r) {
											return _Utils_update(
												r,
												{np: code});
										},
										etat.eO)
								});
						},
						model),
					_List_Nil);
			case 81:
				return $author$project$Components$Referentiel$Types$Update$enregistrerLesReglages(model);
			case 82:
				var cle = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$demanderLaRestriction, cle, model);
			case 83:
				var reponse = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$ouvrirLaRestriction, reponse, model);
			case 84:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$versLaRestriction, geste, model);
			case 85:
				var id = msg.a;
				var oui = msg.b;
				return A2(
					$author$project$Components$Referentiel$Types$Update$surLaRestriction,
					A2($author$project$Components$Referentiel$Types$RestrictionDuChamp$cocher, id, oui),
					model);
			case 86:
				return A2($author$project$Components$Referentiel$Types$Update$surLaRestriction, $author$project$Components$Referentiel$Types$RestrictionDuChamp$toutCocher, model);
			case 87:
				return A2($author$project$Components$Referentiel$Types$Update$surLaRestriction, $author$project$Components$Referentiel$Types$RestrictionDuChamp$toutDecocher, model);
			case 88:
				return A2($author$project$Components$Referentiel$Types$Update$envoyerLaRestriction, $author$project$Components$Referentiel$Types$RestrictionDuChamp$enregistrer, model);
			case 89:
				return A2($author$project$Components$Referentiel$Types$Update$envoyerLaRestriction, $author$project$Components$Referentiel$Types$RestrictionDuChamp$lever, model);
			case 90:
				return A2($author$project$Components$Referentiel$Types$Update$envoyerLaRestriction, $author$project$Components$Referentiel$Types$RestrictionDuChamp$masquer, model);
			case 91:
				var reponse = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$apercuDeLaRestriction, reponse, model);
			case 93:
				if (msg.a.$ === 1) {
					var mode = msg.a.a;
					return A2($author$project$Components$Referentiel$Types$Update$choisirLeModeDeLAjout, mode, model);
				} else {
					var geste = msg.a;
					return A2($author$project$Components$Referentiel$Types$Update$surLeRattachement, geste, model);
				}
			case 95:
				var reponse = msg.a;
				var _v12 = A2($author$project$API$Reponse$lire, $author$project$Components$Shared$EditeurDeSchema$SousChamps$listesDecoder, reponse);
				if (!_v12.$) {
					var listes = _v12.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Types$Update$avecLesInformations,
							function (etat) {
								return _Utils_update(
									etat,
									{n_: listes});
							},
							model),
						_List_Nil);
				} else {
					var refus = _v12.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Referentiel$Common$EffetDeType$Reconnecter]) : _List_Nil);
				}
			case 94:
				var reponse = msg.a;
				var _v13 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$CollectionsDeChamps$API$QueryAPIModel$collectionsDecoder, reponse);
				if (!_v13.$) {
					var lues = _v13.a;
					return $author$project$Components$Referentiel$Types$Update$nouveauChampPret(
						A2(
							$author$project$Components$Referentiel$Types$Update$avecLesInformations,
							function (etat) {
								return _Utils_update(
									etat,
									{
										jZ: $elm$core$Maybe$Just(
											$author$project$Components$Parametrage$CollectionsDeChamps$API$QueryAPIModel$pourLeDrawer(lues))
									});
							},
							model));
				} else {
					var refus = _v13.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Referentiel$Common$EffetDeType$Reconnecter]) : _List_Nil);
				}
			case 92:
				var reponse = msg.a;
				var _v14 = A2(
					$author$project$API$Reponse$lire,
					A4(
						$elm$json$Json$Decode$map3,
						F3(
							function (c, t, u) {
								return _Utils_Tuple3(c, t, u);
							}),
						$author$project$Components$Shared$Bibliotheque$Champ$bibliothequeDecoder,
						$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$typesProposesDecoder,
						$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$unitesDeMesureDecoder),
					reponse);
				if (!_v14.$) {
					var _v15 = _v14.a;
					var champs = _v15.a;
					var types = _v15.b;
					var unites = _v15.c;
					return $author$project$Components$Referentiel$Types$Update$nouveauChampPret(
						A2(
							$author$project$Components$Referentiel$Types$Update$avecLesInformations,
							function (etat) {
								return _Utils_update(
									etat,
									{J_: types, sb: unites});
							},
							A2(
								$author$project$Components$Referentiel$Types$Update$avecLeRattachement,
								function (r) {
									return _Utils_update(
										r,
										{
											dq: $elm$core$Maybe$Just(champs)
										});
								},
								model)));
				} else {
					var refus = _v14.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Referentiel$Common$EffetDeType$Reconnecter]) : _List_Nil);
				}
			case 96:
				var coche = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Types$Update$avecLesInformations,
						function (etat) {
							return _Utils_update(
								etat,
								{
									wZ: {zG: coche, G1: etat.wZ.G1}
								});
						},
						model),
					_List_Nil);
			case 97:
				var coche = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Types$Update$avecLesInformations,
						function (etat) {
							return _Utils_update(
								etat,
								{
									wZ: {zG: etat.wZ.zG, G1: coche}
								});
						},
						model),
					_List_Nil);
			case 98:
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Types$Update$avecLeRattacher,
						function (r) {
							return _Utils_update(
								r,
								{kz: $elm$core$Maybe$Nothing});
						},
						model),
					_List_fromArray(
						[
							$author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(
							A2(
								$author$project$Components$Shared$EditeurDeSchema$View$idDuLibelle,
								$author$project$Components$Shared$Drawer$Model$idRacine(model.AM.kX),
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$elm$core$List$head(model.AM.hP.Ba))))
						]));
			case 99:
				var ouvreur = msg.a;
				return _Utils_eq(model.AM.gf, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A2(
					$author$project$Components$Referentiel$Types$Update$versLElargissementDeLaListe,
					$author$project$Components$Shared$Drawer$Update$Ouvrir(ouvreur),
					model);
			case 100:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Types$Update$versLElargissementDeLaListe, geste, model);
			case 101:
				var confirme = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Types$Update$avecLesInformations,
						function (etat) {
							return _Utils_update(
								etat,
								{
									gf: A2(
										$elm$core$Maybe$map,
										$author$project$Components$Shared$Bibliotheque$ElargissementDeListe$confirmer(confirme),
										etat.gf)
								});
						},
						model),
					_List_Nil);
			default:
				var _v16 = A2($elm$core$Maybe$andThen, $author$project$Components$Shared$Bibliotheque$ElargissementDeListe$demande, model.AM.gf);
				if (!_v16.$) {
					var voulue = _v16.a;
					return A3(
						$author$project$Components$Referentiel$Types$Update$envoyerLaCommande,
						voulue.nB,
						A2($author$project$Components$Referentiel$Common$API$WriteAPIModel$ElargirLaPorteeDUneListe, voulue.nW, voulue.sn),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Components$Referentiel$Types$Update$update = F2(
	function (msg, model) {
		return $author$project$Components$Referentiel$Types$Update$puisAvecLeFocusDeLaRapide(
			A2($author$project$Components$Referentiel$Types$Update$aiguiller, msg, model));
	});
var $author$project$Main$Update$versLesTypesDePartiesPrenantes = F3(
	function (i18n, msg, model) {
		var _v0 = A2(
			$author$project$Components$Referentiel$Types$Update$update,
			msg,
			A2(
				$author$project$Referentiel$Normes$poser,
				model.hd,
				$author$project$Components$Referentiel$Types$Model$ouvrir(model.J0)));
		var typesDePartiesPrenantes = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLesTypes, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			A2($author$project$Main$Update$depuisLesTypes, 0, 29),
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Referentiel$Types$Update$popMessages(msg),
							gardes),
						J0: $author$project$Components$Referentiel$Types$Model$envelopper(typesDePartiesPrenantes)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$reglerLeTypeDeLAdresse = F3(
	function (i18n, uid, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		if (!uid.$) {
			var type_ = uid.a;
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Basics$append(effets),
				A3(
					$author$project$Main$Update$versLesTypesDePartiesPrenantes,
					i18n,
					$author$project$Components$Referentiel$Types$Update$TypeDeLAdresse(type_),
					model));
		} else {
			return _Utils_Tuple2(model, effets);
		}
	});
var $author$project$Main$Update$AttendreAvantDeRelireLaConservation = function (a) {
	return {$: 261, a: a};
};
var $author$project$Main$Update$EnvoyerALaConservation = function (a) {
	return {$: 260, a: a};
};
var $author$project$Main$Update$LireLaConservation = F2(
	function (a, b) {
		return {$: 223, a: a, b: b};
	});
var $author$project$Main$Model$PourLaConservation = 43;
var $author$project$Main$Update$depuisLaConservation = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[43]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 1:
				var lecture = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLaConservation(lecture))));
			case 2:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerALaConservation(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 3:
				var delaiMs = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AttendreAvantDeRelireLaConservation(delaiMs)
							])));
			case 4:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Parametrage$Conservation$Update$popMessages = function (_v0) {
	return $elm$core$Maybe$Nothing;
};
var $author$project$Main$Update$requeteSurLaConservation = function (effet) {
	switch (effet.$) {
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Parametrage$Conservation$Update$DemanderProcessUid = {$: 0};
var $author$project$Components$Parametrage$Conservation$Update$DesEcheances = 1;
var $author$project$Components$Parametrage$Conservation$Update$DesRegles = 0;
var $author$project$Components$Parametrage$Conservation$Update$Lire = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Parametrage$Conservation$Update$PlacerFocus = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$Conservation$Update$idDuDeclencheur = 'page-parametrage-conservation';
var $author$project$Components$Parametrage$Conservation$Model$reglageDuType = function (regle) {
	var duree = A2(
		$elm$core$Maybe$withDefault,
		{iJ: 30, CQ: 36},
		regle.lG);
	return A2(
		$elm$core$List$cons,
		{uN: $elm$core$Maybe$Nothing, cx: duree, lG: duree, Bl: '', oS: false},
		A2(
			$elm$core$List$map,
			function (champ) {
				return {
					uN: $elm$core$Maybe$Just(champ.uN),
					cx: champ.lG,
					lG: champ.lG,
					Bl: champ.Bl,
					oS: false
				};
			},
			regle.dw));
};
var $author$project$Components$Parametrage$Conservation$Model$regleDuType = F2(
	function (model, uid) {
		return A2(
			$elm$core$Maybe$andThen,
			function (regles) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (regle) {
							return _Utils_eq(regle.r8, uid);
						},
						regles.ib));
			},
			model.hJ);
	});
var $author$project$Components$Parametrage$Conservation$Update$saisieDuType = function (model) {
	return A2(
		$elm$core$List$any,
		function (ligne) {
			return (!_Utils_eq(ligne.lG, ligne.cx)) || ligne.oS;
		},
		model.gV);
};
var $author$project$Components$Parametrage$Conservation$Update$versLeDrawerDuType = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{lw: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Parametrage$Conservation$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Parametrage$Conservation$Update$saisieDuType(model)
				},
				geste,
				model.lw));
	});
var $author$project$Components$Parametrage$Conservation$Update$ouvrirLeType = F2(
	function (uid, model) {
		var _v0 = A2($author$project$Components$Parametrage$Conservation$Model$regleDuType, model, uid);
		if (!_v0.$) {
			var regle = _v0.a;
			return A2(
				$author$project$Components$Parametrage$Conservation$Update$versLeDrawerDuType,
				$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Parametrage$Conservation$Update$idDuDeclencheur),
				_Utils_update(
					model,
					{
						jO: false,
						v2: false,
						gV: $author$project$Components$Parametrage$Conservation$Model$reglageDuType(regle),
						pZ: $elm$core$Maybe$Nothing,
						qD: _List_Nil,
						ia: $elm$core$Maybe$Just(uid)
					}));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$Conservation$Model$typeEnCours = function (model) {
	var _v0 = model.ia;
	if (!_v0.$) {
		var uid = _v0.a;
		return $elm$core$Maybe$Just(uid);
	} else {
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.r8;
			},
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ib;
					},
					$elm$core$List$head),
				model.hJ));
	}
};
var $author$project$Components$Parametrage$Conservation$Update$ajoutDemande = function (model) {
	var _v0 = $author$project$Components$Parametrage$Conservation$Model$typeEnCours(model);
	if (!_v0.$) {
		var uid = _v0.a;
		return A2(
			$elm$core$Tuple$mapFirst,
			function (ouvert) {
				return _Utils_update(
					ouvert,
					{jO: true});
			},
			A2($author$project$Components$Parametrage$Conservation$Update$ouvrirLeType, uid, model));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$Conservation$Model$avecLeChamp = F2(
	function (possible, lignes) {
		var duree = A2(
			$elm$core$Maybe$withDefault,
			{iJ: 30, CQ: 36},
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.lG;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (ligne) {
							return _Utils_eq(ligne.uN, $elm$core$Maybe$Nothing);
						},
						lignes))));
		return _Utils_ap(
			lignes,
			_List_fromArray(
				[
					{
					uN: $elm$core$Maybe$Just(possible.uN),
					cx: duree,
					lG: duree,
					Bl: possible.Bl,
					oS: true
				}
				]));
	});
var $author$project$Components$Parametrage$Conservation$Model$champsAAjouter = F2(
	function (regle, lignes) {
		return A2(
			$elm$core$List$filter,
			function (possible) {
				return !A2(
					$elm$core$List$any,
					function (ligne) {
						return _Utils_eq(
							ligne.uN,
							$elm$core$Maybe$Just(possible.uN));
					},
					lignes);
			},
			regle.u$);
	});
var $author$project$Components$Parametrage$Conservation$Update$ajouterLeChamp = F2(
	function (champ, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			$author$project$Components$Parametrage$Conservation$Model$regleDuType(model),
			model.ia);
		if (!_v0.$) {
			var regle = _v0.a;
			var _v1 = A2(
				$elm$core$List$filter,
				function (possible) {
					return _Utils_eq(possible.uN, champ);
				},
				A2($author$project$Components$Parametrage$Conservation$Model$champsAAjouter, regle, model.gV));
			if (_v1.b) {
				var possible = _v1.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jO: false,
							v2: false,
							gV: A2($author$project$Components$Parametrage$Conservation$Model$avecLeChamp, possible, model.gV),
							pZ: $elm$core$Maybe$Nothing
						}),
					_List_Nil);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$Conservation$Update$avecAlerte = F2(
	function (jours, duree) {
		return _Utils_update(
			duree,
			{iJ: jours});
	});
var $author$project$Components$Parametrage$Conservation$Update$avecMois = F2(
	function (mois, duree) {
		return _Utils_update(
			duree,
			{CQ: mois});
	});
var $author$project$Components$Parametrage$Conservation$Update$AttendreAvantDeRelire = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$Conservation$Update$filtre = F2(
	function (type_, lien) {
		if (!type_.$) {
			var uid = type_.a;
			return _Utils_update(
				lien,
				{
					cM: lien.cM + ('?type=' + $elm$url$Url$percentEncode(uid))
				});
		} else {
			return lien;
		}
	});
var $author$project$Components$Parametrage$Conservation$Update$relire = function (model) {
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$map,
				$author$project$Components$Parametrage$Conservation$Update$Lire(0),
				model.nv),
				A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Parametrage$Conservation$Update$filtre(model.zH),
					$author$project$Components$Parametrage$Conservation$Update$Lire(1)),
				model.ns)
			]));
};
var $author$project$Components$Parametrage$Conservation$Update$saisieDeProlongation = function (model) {
	return (model.A3 !== '') || ((!_Utils_eq(model.cX, $elm$core$Maybe$Nothing)) || ($elm$core$String$trim(model.Gd) !== ''));
};
var $author$project$Components$Parametrage$Conservation$Update$versLeDrawerDeProlongation = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{ld: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Parametrage$Conservation$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Parametrage$Conservation$Update$saisieDeProlongation(model)
				},
				geste,
				model.ld));
	});
var $author$project$Components$Parametrage$Conservation$Update$conclure = F2(
	function (issue, model) {
		switch (issue.$) {
			case 0:
				if (issue.c) {
					var commande = issue.a;
					var rendue = issue.b;
					var _v1 = function () {
						if (commande.$ === 1) {
							return A2($author$project$Components$Parametrage$Conservation$Update$versLeDrawerDeProlongation, $author$project$Components$Shared$Drawer$Update$Fermer, model);
						} else {
							return $elm$core$List$isEmpty(model.qD) ? A2($author$project$Components$Parametrage$Conservation$Update$versLeDrawerDuType, $author$project$Components$Shared$Drawer$Update$Fermer, model) : _Utils_Tuple2(model, _List_Nil);
						}
					}();
					var ferme = _v1.a;
					var effetsDuDrawer = _v1.b;
					return _Utils_Tuple2(
						ferme,
						_Utils_ap(
							effetsDuDrawer,
							rendue.sy ? $author$project$Components$Parametrage$Conservation$Update$relire(ferme) : _List_fromArray(
								[
									$author$project$Components$Parametrage$Conservation$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
								])));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{qh: true, qD: _List_Nil}),
						$author$project$Components$Parametrage$Conservation$Update$relire(model));
				}
			case 1:
				var erreur = issue.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							v2: false,
							pZ: $elm$core$Maybe$Just(erreur),
							qD: _List_Nil
						}),
					_List_Nil);
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$Conservation$Update$drawerDeProlongation = F2(
	function (geste, model) {
		return A2($author$project$Components$Parametrage$Conservation$Update$versLeDrawerDeProlongation, geste, model);
	});
var $author$project$Components$Parametrage$Conservation$Update$drawerDuType = F2(
	function (geste, model) {
		return A2($author$project$Components$Parametrage$Conservation$Update$versLeDrawerDuType, geste, model);
	});
var $author$project$Components$Parametrage$Conservation$Update$aConfirmer = function (model) {
	var _v0 = model.pZ;
	if ((!_v0.$) && (_v0.a.$ === 1)) {
		var incoherences = _v0.a.a;
		return model.v2 ? incoherences : _List_Nil;
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Parametrage$Conservation$API$WriteAPIModel$FixerLaConservation = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Parametrage$Conservation$Model$champDeLIncoherence = function (incoherence) {
	switch (incoherence.$) {
		case 0:
			var detail = incoherence.a;
			return $elm$core$Maybe$Just(detail.uN);
		case 1:
			var detail = incoherence.a;
			return detail.uN;
		case 2:
			var champ = incoherence.a;
			return $elm$core$Maybe$Just(champ);
		case 3:
			var detail = incoherence.a;
			return detail.uN;
		default:
			var champ = incoherence.a;
			return $elm$core$Maybe$Just(champ);
	}
};
var $author$project$Components$Parametrage$Conservation$Model$commandesDuReglage = F3(
	function (regle, lignes, confirmees) {
		return A2(
			$elm$core$List$map,
			function (ligne) {
				return A4(
					$author$project$Components$Parametrage$Conservation$API$WriteAPIModel$FixerLaConservation,
					regle.r8,
					ligne.uN,
					ligne.lG,
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Parametrage$Conservation$Model$champDeLIncoherence,
							$elm$core$Basics$eq(ligne.uN)),
						confirmees));
			},
			A2(
				$elm$core$List$filter,
				function (ligne) {
					return (!_Utils_eq(ligne.lG, ligne.cx)) || (ligne.oS || (_Utils_eq(ligne.uN, $elm$core$Maybe$Nothing) && _Utils_eq(regle.lG, $elm$core$Maybe$Nothing)));
				},
				lignes));
	});
var $author$project$Components$Parametrage$Conservation$Update$Envoyer = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$Conservation$Update$Reconnecter = {$: 5};
var $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$AccesRefuse = {$: 2};
var $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$AutreRefus = {$: 4};
var $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$FicheEffacee = {$: 3};
var $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$IncoherenceNonConfirmee = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$AlertePlusLongueQueLaDuree = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$ChampPlusCourtQueLeType = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$DonneePersonnelleSansDuree = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$DureeAuDelaDeLaReference = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$NouvelleClasseSurChampRempli = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$incoherenceDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'ChampPlusCourtQueLeType',
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (champ, duree, dureeDuType) {
						return $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$ChampPlusCourtQueLeType(
							{uN: champ, lG: duree, lH: dureeDuType});
					}),
				A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'duree', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'dureeDuType', $elm$json$Json$Decode$int))),
			A2(
			$elm$json$Json$Decode$field,
			'DureeAuDelaDeLaReference',
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (champ, duree, reference) {
						return $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$DureeAuDelaDeLaReference(
							{uN: champ, lG: duree, Hc: reference});
					}),
				$elm$json$Json$Decode$maybe(
					A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string)),
				A2($elm$json$Json$Decode$field, 'duree', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'reference', $elm$json$Json$Decode$int))),
			A2(
			$elm$json$Json$Decode$field,
			'DonneePersonnelleSansDuree',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$DonneePersonnelleSansDuree,
				A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string))),
			A2(
			$elm$json$Json$Decode$field,
			'AlertePlusLongueQueLaDuree',
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (champ, alerte, duree) {
						return $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$AlertePlusLongueQueLaDuree(
							{iJ: alerte, uN: champ, lG: duree});
					}),
				$elm$json$Json$Decode$maybe(
					A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string)),
				A2($elm$json$Json$Decode$field, 'alerte', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'duree', $elm$json$Json$Decode$int))),
			A2(
			$elm$json$Json$Decode$field,
			'NouvelleClasseSurChampRempli',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$NouvelleClasseSurChampRempli,
				A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string)))
		]));
var $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$DureePropreSuperieureALaFiche = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$refusNomme = A4(
	$elm$json$Json$Decode$map3,
	F3(
		function (champ, mois, moisDuType) {
			return $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$DureePropreSuperieureALaFiche(
				{uN: champ, CQ: mois, CS: moisDuType});
		}),
	A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'mois', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'moisDuType', $elm$json$Json$Decode$int));
var $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$duRefus = function (reponse) {
	var _v0 = A2(
		$elm$json$Json$Decode$decodeString,
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['error']),
			$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value)),
		reponse.f$);
	_v0$4:
	while (true) {
		if ((!_v0.$) && _v0.a.b) {
			switch (_v0.a.a.a) {
				case 'DureePropreSuperieureALaFiche':
					var _v1 = _v0.a;
					var _v2 = _v1.a;
					var contenu = _v2.b;
					var _v3 = A2($elm$json$Json$Decode$decodeValue, $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$refusNomme, contenu);
					if (!_v3.$) {
						var erreur = _v3.a;
						return erreur;
					} else {
						return $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$AutreRefus;
					}
				case 'IncoherenceNonConfirmee':
					var _v4 = _v0.a;
					var _v5 = _v4.a;
					var contenu = _v5.b;
					var _v6 = A2(
						$elm$json$Json$Decode$decodeValue,
						A2(
							$elm$json$Json$Decode$field,
							'incoherences',
							$elm$json$Json$Decode$list($author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$incoherenceDecoder)),
						contenu);
					if (!_v6.$) {
						var incoherences = _v6.a;
						return $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$IncoherenceNonConfirmee(incoherences);
					} else {
						return $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$AutreRefus;
					}
				case 'AccesRefuse':
					var _v7 = _v0.a;
					var _v8 = _v7.a;
					return $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$AccesRefuse;
				case 'FicheEffacee':
					var _v9 = _v0.a;
					var _v10 = _v9.a;
					return $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$FicheEffacee;
				default:
					break _v0$4;
			}
		} else {
			break _v0$4;
		}
	}
	return $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$AutreRefus;
};
var $author$project$Components$Parametrage$Conservation$API$WriteAPIModel$Rendue = F2(
	function (vuesAJour, liens) {
		return {nQ: liens, sy: vuesAJour};
	});
var $author$project$Components$Parametrage$Conservation$API$WriteAPIModel$rendueDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'liens',
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vuesAJour',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Conservation$API$WriteAPIModel$Rendue)));
var $author$project$Components$Parametrage$Conservation$Update$reglage = {
	f8: $author$project$Components$Parametrage$Conservation$Update$DemanderProcessUid,
	l4: $author$project$Components$Parametrage$Conservation$Update$Envoyer,
	go: $author$project$Components$Parametrage$Conservation$API$WriteAPIErrorsModel$duRefus,
	pW: $author$project$Components$Parametrage$Conservation$Update$Reconnecter,
	qu: F2(
		function (_v0, _v1) {
			return true;
		}),
	qv: $author$project$Components$Parametrage$Conservation$API$WriteAPIModel$rendueDecoder
};
var $author$project$Components$Parametrage$Conservation$Update$envoyer = F3(
	function (lien, commande, model) {
		var _v0 = A4($author$project$API$Envoi$partir, $author$project$Components$Parametrage$Conservation$Update$reglage, lien, commande, model.l2);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var envoi = _v1.a;
			var effets = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi, pZ: $elm$core$Maybe$Nothing, qh: false}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$modifierLesRegles = 'modifier-les-regles';
var $author$project$Components$Parametrage$Conservation$Model$lienDuTypeEnregistre = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		function (regles) {
			return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierLesRegles, regles.nQ);
		},
		model.hJ);
};
var $author$project$Components$Parametrage$Conservation$Update$enregistrer = function (model) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		$author$project$Components$Parametrage$Conservation$Model$regleDuType(model),
		model.ia);
	if (!_v0.$) {
		var regle = _v0.a;
		var _v1 = A3(
			$author$project$Components$Parametrage$Conservation$Model$commandesDuReglage,
			regle,
			model.gV,
			$author$project$Components$Parametrage$Conservation$Update$aConfirmer(model));
		if (!_v1.b) {
			return A2($author$project$Components$Parametrage$Conservation$Update$versLeDrawerDuType, $author$project$Components$Shared$Drawer$Update$Fermer, model);
		} else {
			var premiere = _v1.a;
			var reste = _v1.b;
			return A3(
				$author$project$Components$Parametrage$Conservation$Update$envoyer,
				$author$project$Components$Parametrage$Conservation$Model$lienDuTypeEnregistre(model),
				premiere,
				_Utils_update(
					model,
					{qD: reste}));
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$API$NavLinksDictionary$echeancesDeConservation = 'echeances-de-conservation';
var $author$project$Components$Parametrage$Conservation$Model$lienDesEcheances = $author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$echeancesDeConservation);
var $author$project$API$NavLinksDictionary$reglesDeConservation = 'regles-de-conservation';
var $author$project$Components$Parametrage$Conservation$Model$lienDesRegles = $author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$reglesDeConservation);
var $author$project$Components$Parametrage$Conservation$Update$lire = F2(
	function (defaut, saisie) {
		return A2(
			$elm$core$Maybe$withDefault,
			defaut,
			$elm$core$String$toInt(saisie));
	});
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$Echeances = F5(
	function (nombre, heureDuTraitement, fuseau, echeances, liens) {
		return {x0: echeances, z_: fuseau, Ai: heureDuTraitement, nQ: liens, w: nombre};
	});
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$Echeance = function (fiche) {
	return function (nom) {
		return function (accessible) {
			return function (types) {
				return function (echeance) {
					return function (prolongationProposee) {
						return function (etat) {
							return function (prolongation) {
								return function (classe) {
									return function (liens) {
										return {sM: accessible, jT: classe, xY: echeance, gt: etat, zo: fiche, nQ: liens, Dj: nom, Gs: prolongation, Gt: prolongationProposee, ib: types};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$Classe = F3(
	function (type_, champ, classe) {
		return {uN: champ, jT: classe, r0: type_};
	});
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$classeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'classe',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'champ',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Conservation$API$QueryAPIModel$Classe))));
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$Due = {$: 2};
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$EnAlerte = {$: 1};
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$Prevue = {$: 0};
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$Prolongee = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$etatDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'Prevue',
			$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Conservation$API$QueryAPIModel$Prevue)),
			A2(
			$elm$json$Json$Decode$field,
			'EnAlerte',
			$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Conservation$API$QueryAPIModel$EnAlerte)),
			A2(
			$elm$json$Json$Decode$field,
			'Due',
			$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Conservation$API$QueryAPIModel$Due)),
			A2(
			$elm$json$Json$Decode$field,
			'Prolongee',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Parametrage$Conservation$API$QueryAPIModel$Prolongee,
				A2($elm$json$Json$Decode$field, 'jusquA', $elm$json$Json$Decode$string)))
		]));
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$Prolongation = F2(
	function (jusquA, motif) {
		return {A3: jusquA, cX: motif};
	});
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$Autre = 3;
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$ContentieuxEnCours = 0;
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$NouvelleDemandeDeLaPersonne = 1;
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$ObligationLegale = 2;
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$motifDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (code) {
		switch (code) {
			case 'ContentieuxEnCours':
				return $elm$json$Json$Decode$succeed(0);
			case 'NouvelleDemandeDeLaPersonne':
				return $elm$json$Json$Decode$succeed(1);
			case 'ObligationLegale':
				return $elm$json$Json$Decode$succeed(2);
			case 'Autre':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail(code);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$prolongationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'motif',
	$author$project$Components$Parametrage$Conservation$API$QueryAPIModel$motifDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'jusquA',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Conservation$API$QueryAPIModel$Prolongation)));
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$echeanceDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'classe',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$classeDecoder),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'prolongation',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$prolongationDecoder),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'etat',
				$author$project$Components$Parametrage$Conservation$API$QueryAPIModel$etatDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'prolongationProposee',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'echeance',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'types',
							$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'ficheAccessible',
								$elm$json$Json$Decode$bool,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'nom',
									A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'fiche',
										A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
										$elm$core$Maybe$Nothing,
										$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Conservation$API$QueryAPIModel$Echeance)))))))))));
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$echeancesDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'echeances',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$Conservation$API$QueryAPIModel$echeanceDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'fuseau',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'heureDuTraitement',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'nombre',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Conservation$API$QueryAPIModel$Echeances))))));
var $author$project$Components$Parametrage$Conservation$Update$echec = F2(
	function (refus, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{gd: true}),
			(refus.ri === 401) ? _List_fromArray(
				[$author$project$Components$Parametrage$Conservation$Update$Reconnecter]) : _List_Nil);
	});
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$Regles = F2(
	function (types, liens) {
		return {nQ: liens, ib: types};
	});
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$RegleDuType = F8(
	function (uid, archetype, libelle, pasDeDuree, duree, champs, reference, champsPossibles) {
		return {fA: archetype, dw: champs, u$: champsPossibles, lG: duree, Bl: libelle, E2: pasDeDuree, Hc: reference, r8: uid};
	});
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$ChampPossible = F2(
	function (champ, libelle) {
		return {uN: champ, Bl: libelle};
	});
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$champPossibleDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'libelle',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'champ',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Conservation$API$QueryAPIModel$ChampPossible)));
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$Duree = F2(
	function (mois, alerte) {
		return {iJ: alerte, CQ: mois};
	});
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$dureeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'alerte',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'mois',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Conservation$API$QueryAPIModel$Duree)));
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$Reference = F3(
	function (mois, source, mention) {
		return {Cq: mention, CQ: mois, IR: source};
	});
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$referenceDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'mention',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'source',
		$elm$json$Json$Decode$string,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'mois',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$int),
			$elm$core$Maybe$Nothing,
			$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Conservation$API$QueryAPIModel$Reference))));
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$RegleDeChamp = F3(
	function (champ, libelle, duree) {
		return {uN: champ, lG: duree, Bl: libelle};
	});
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$regleDeChampDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'duree',
	$author$project$Components$Parametrage$Conservation$API$QueryAPIModel$dureeDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'libelle',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'champ',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Conservation$API$QueryAPIModel$RegleDeChamp))));
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$regleDuTypeDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'champsPossibles',
	$elm$json$Json$Decode$list($author$project$Components$Parametrage$Conservation$API$QueryAPIModel$champPossibleDecoder),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'reference',
		$author$project$Components$Parametrage$Conservation$API$QueryAPIModel$referenceDecoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'champs',
			$elm$json$Json$Decode$list($author$project$Components$Parametrage$Conservation$API$QueryAPIModel$regleDeChampDecoder),
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'duree',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$dureeDecoder),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'pasDeDuree',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'libelleFr',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'archetype',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'uid',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Conservation$API$QueryAPIModel$RegleDuType)))))))));
var $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$reglesDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'types',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$Conservation$API$QueryAPIModel$regleDuTypeDecoder),
		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Conservation$API$QueryAPIModel$Regles)));
var $author$project$Components$Parametrage$Conservation$Update$lue = F3(
	function (lecture, reponse, model) {
		if (!lecture) {
			var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$reglesDecoder, reponse);
			if (!_v1.$) {
				var regles = _v1.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gd: false,
							hJ: $elm$core$Maybe$Just(regles)
						}),
					_List_Nil);
			} else {
				var refus = _v1.a;
				return A2($author$project$Components$Parametrage$Conservation$Update$echec, refus, model);
			}
		} else {
			var _v2 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Conservation$API$QueryAPIModel$echeancesDecoder, reponse);
			if (!_v2.$) {
				var echeances = _v2.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							x0: $elm$core$Maybe$Just(echeances),
							gd: false
						}),
					_List_Nil);
			} else {
				var refus = _v2.a;
				return A2($author$project$Components$Parametrage$Conservation$Update$echec, refus, model);
			}
		}
	});
var $author$project$API$NavLinksDictionary$prolongerLaConservation = 'prolonger-la-conservation';
var $author$project$Components$Parametrage$Conservation$Model$lienDeLaLigne = function (ligne) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$prolongerLaConservation, ligne.nQ);
};
var $author$project$Components$Parametrage$Conservation$Update$ouvrirLaProlongation = F2(
	function (ligne, model) {
		var _v0 = $author$project$Components$Parametrage$Conservation$Model$lienDeLaLigne(ligne);
		if (!_v0.$) {
			return A2(
				$author$project$Components$Parametrage$Conservation$Update$versLeDrawerDeProlongation,
				$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Parametrage$Conservation$Update$idDuDeclencheur),
				_Utils_update(
					model,
					{
						fq: $elm$core$Maybe$Just(ligne),
						A3: ligne.Gt,
						cX: $elm$core$Maybe$Just(0),
						Gd: '',
						pZ: $elm$core$Maybe$Nothing,
						qh: false
					}));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$Conservation$API$WriteAPIModel$Prolonger = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$Conservation$Model$etatDeLaPrecision = function (model) {
	var texte = $elm$core$String$trim(model.Gd);
	var obligatoire = _Utils_eq(
		model.cX,
		$elm$core$Maybe$Just(3));
	return {
		he: obligatoire,
		sj: ((!obligatoire) || (texte !== '')) && ($elm$core$String$length(texte) <= 500)
	};
};
var $author$project$Components$Parametrage$Conservation$Model$precisionDonnee = function (saisie) {
	return ($elm$core$String$trim(saisie) === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		$elm$core$String$trim(saisie));
};
var $author$project$Components$Parametrage$Conservation$Model$prolongationPrete = function (model) {
	var _v0 = _Utils_Tuple2(model.fq, model.cX);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var ligne = _v0.a.a;
		var motif = _v0.b.a;
		var _v1 = ligne.zo;
		if (!_v1.$) {
			var fiche = _v1.a;
			return ((model.A3 !== '') && $author$project$Components$Parametrage$Conservation$Model$etatDeLaPrecision(model).sj) ? $elm$core$Maybe$Just(
				$author$project$Components$Parametrage$Conservation$API$WriteAPIModel$Prolonger(
					{
						jT: ligne.jT,
						zo: fiche,
						A3: model.A3,
						cX: motif,
						Gd: $author$project$Components$Parametrage$Conservation$Model$precisionDonnee(model.Gd)
					})) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$Conservation$Update$prolonger = function (model) {
	var _v0 = _Utils_Tuple2(
		A2($elm$core$Maybe$andThen, $author$project$Components$Parametrage$Conservation$Model$lienDeLaLigne, model.fq),
		$author$project$Components$Parametrage$Conservation$Model$prolongationPrete(model));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var lien = _v0.a.a;
		var commande = _v0.b.a;
		return A3(
			$author$project$Components$Parametrage$Conservation$Update$envoyer,
			$elm$core$Maybe$Just(lien),
			commande,
			model);
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$Conservation$Update$regler = F3(
	function (champ, changer, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					v2: false,
					gV: A2(
						$elm$core$List$map,
						function (ligne) {
							return _Utils_eq(ligne.uN, champ) ? changer(ligne) : ligne;
						},
						model.gV),
					pZ: $elm$core$Maybe$Nothing
				}),
			_List_Nil);
	});
var $author$project$Components$Parametrage$Conservation$Update$suivante = function (model) {
	var _v0 = model.qD;
	if (_v0.b) {
		var prochaine = _v0.a;
		var reste = _v0.b;
		return A3(
			$author$project$Components$Parametrage$Conservation$Update$envoyer,
			$author$project$Components$Parametrage$Conservation$Model$lienDuTypeEnregistre(model),
			prochaine,
			_Utils_update(
				model,
				{qD: reste}));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$Conservation$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var liens = msg.a;
				var _v1 = $author$project$Components$Parametrage$Conservation$Model$lienDesRegles(liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								gd: false,
								ns: $author$project$Components$Parametrage$Conservation$Model$lienDesEcheances(liens),
								nv: $elm$core$Maybe$Just(lecture)
							}),
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Components$Parametrage$Conservation$Update$DemanderProcessUid,
									A2($author$project$Components$Parametrage$Conservation$Update$Lire, 0, lecture)
								]),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Components$Parametrage$Conservation$Update$Lire(1),
										$elm$core$List$singleton),
									$author$project$Components$Parametrage$Conservation$Model$lienDesEcheances(liens)))));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{nv: $elm$core$Maybe$Nothing, hJ: $elm$core$Maybe$Nothing}),
						_List_Nil);
				}
			case 1:
				var liens = msg.a;
				var _v2 = _Utils_Tuple2(
					$author$project$Components$Parametrage$Conservation$Model$lienDesRegles(liens),
					$author$project$Components$Parametrage$Conservation$Model$lienDesEcheances(liens));
				if ((!_v2.a.$) && (!_v2.b.$)) {
					var regles = _v2.a.a;
					var echeances = _v2.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								gd: false,
								ns: $elm$core$Maybe$Just(echeances),
								nv: $elm$core$Maybe$Just(regles)
							}),
						_List_fromArray(
							[
								$author$project$Components$Parametrage$Conservation$Update$DemanderProcessUid,
								A2($author$project$Components$Parametrage$Conservation$Update$Lire, 0, regles),
								A2(
								$author$project$Components$Parametrage$Conservation$Update$Lire,
								1,
								A2($author$project$Components$Parametrage$Conservation$Update$filtre, model.zH, echeances))
							]));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{x0: $elm$core$Maybe$Nothing, ns: $elm$core$Maybe$Nothing}),
						_List_Nil);
				}
			case 2:
				var octets = msg.a;
				return $author$project$Components$Parametrage$Conservation$Update$suivante(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}));
			case 3:
				var lecture = msg.a;
				var reponse = msg.b;
				return A3($author$project$Components$Parametrage$Conservation$Update$lue, lecture, reponse, model);
			case 4:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Parametrage$Conservation$Update$relire(model));
			case 5:
				var cible = msg.a;
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[
							$author$project$Components$Parametrage$Conservation$Update$PlacerFocus(cible)
						]));
			case 6:
				var geste = msg.a;
				return $author$project$API$Envoi$enCours(model.l2) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Parametrage$Conservation$Update$drawerDuType, geste, model);
			case 7:
				var geste = msg.a;
				return $author$project$API$Envoi$enCours(model.l2) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Parametrage$Conservation$Update$drawerDeProlongation, geste, model);
			case 8:
				var uid = msg.a;
				return A2($author$project$Components$Parametrage$Conservation$Update$ouvrirLeType, uid, model);
			case 10:
				return $author$project$Components$Parametrage$Conservation$Update$ajoutDemande(model);
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{jO: !model.jO}),
					_List_Nil);
			case 11:
				var champ = msg.a;
				return A2($author$project$Components$Parametrage$Conservation$Update$ajouterLeChamp, champ, model);
			case 12:
				var cochee = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{v2: cochee}),
					_List_Nil);
			case 13:
				var champ = msg.a;
				var mois = msg.b;
				return A3(
					$author$project$Components$Parametrage$Conservation$Update$regler,
					champ,
					function (ligne) {
						return _Utils_update(
							ligne,
							{
								lG: A2(
									$author$project$Components$Parametrage$Conservation$Update$avecMois,
									A2($author$project$Components$Parametrage$Conservation$Update$lire, ligne.lG.CQ, mois),
									ligne.lG)
							});
					},
					model);
			case 14:
				var champ = msg.a;
				var jours = msg.b;
				return A3(
					$author$project$Components$Parametrage$Conservation$Update$regler,
					champ,
					function (ligne) {
						return _Utils_update(
							ligne,
							{
								lG: A2(
									$author$project$Components$Parametrage$Conservation$Update$avecAlerte,
									A2($author$project$Components$Parametrage$Conservation$Update$lire, ligne.lG.iJ, jours),
									ligne.lG)
							});
					},
					model);
			case 15:
				return $author$project$Components$Parametrage$Conservation$Update$enregistrer(model);
			case 16:
				var uid = msg.a;
				var choisi = _Utils_update(
					model,
					{
						zH: (uid === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(uid)
					});
				return _Utils_Tuple2(
					choisi,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Components$Parametrage$Conservation$Update$filtre(choisi.zH),
								A2(
									$elm$core$Basics$composeR,
									$author$project$Components$Parametrage$Conservation$Update$Lire(1),
									$elm$core$List$singleton)),
							model.ns)));
			case 17:
				var ligne = msg.a;
				return A2($author$project$Components$Parametrage$Conservation$Update$ouvrirLaProlongation, ligne, model);
			case 18:
				var jour = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{A3: jour, pZ: $elm$core$Maybe$Nothing}),
					_List_Nil);
			case 19:
				var motif = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cX: $elm$core$Maybe$Just(motif),
							pZ: $elm$core$Maybe$Nothing
						}),
					_List_Nil);
			case 20:
				var texte = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Gd: texte, pZ: $elm$core$Maybe$Nothing}),
					_List_Nil);
			case 21:
				return $author$project$Components$Parametrage$Conservation$Update$prolonger(model);
			default:
				var reponse = msg.a;
				var _v3 = A3($author$project$API$Envoi$conclure, $author$project$Components$Parametrage$Conservation$Update$reglage, reponse, model.l2);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var envoi = _v4.a;
					var issue = _v4.b;
					var effets = _v4.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Parametrage$Conservation$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Main$Update$versLaConservation = F2(
	function (msg, model) {
		var _v0 = A2($author$project$Components$Parametrage$Conservation$Update$update, msg, model.v5);
		var conservation = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLaConservation, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLaConservation,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						v5: conservation,
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Parametrage$Conservation$Update$popMessages(msg),
							gardes)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$commandeDuCatalogue = function (effet) {
	_v0$8:
	while (true) {
		switch (effet.$) {
			case 9:
				return true;
			case 7:
				return true;
			case 10:
				return true;
			case 11:
				return false;
			case 19:
				if (effet.a.$ === 16) {
					var _v1 = effet.a;
					return true;
				} else {
					break _v0$8;
				}
			case 20:
				if (effet.a.$ === 16) {
					var _v2 = effet.a;
					return true;
				} else {
					break _v0$8;
				}
			case 21:
				if (effet.a.$ === 16) {
					var _v3 = effet.a;
					return true;
				} else {
					break _v0$8;
				}
			case 22:
				if (effet.a.$ === 16) {
					var _v4 = effet.a;
					return true;
				} else {
					break _v0$8;
				}
			default:
				break _v0$8;
		}
	}
	return false;
};
var $author$project$Main$Update$AnnuaireDesTypes = 2;
var $author$project$Main$Update$AttendreAvantDeRelireLaStructure = function (a) {
	return {$: 110, a: a};
};
var $author$project$Main$Update$ChercherLesArticlesDeLEtage = function (a) {
	return {$: 139, a: a};
};
var $author$project$Main$Update$DemanderLApercuDArchivage = function (a) {
	return {$: 113, a: a};
};
var $author$project$Main$Update$DemanderLApercuDuCatalogue = function (a) {
	return {$: 112, a: a};
};
var $author$project$Main$Update$EnvoyerAuCatalogue = function (a) {
	return {$: 111, a: a};
};
var $author$project$Main$Update$EnvoyerUnNouveauChampDuCatalogue = function (a) {
	return {$: 108, a: a};
};
var $author$project$Main$Update$GammesDuCatalogue = 4;
var $author$project$Main$Update$LireLaBibliothequeDuCatalogue = function (a) {
	return {$: 106, a: a};
};
var $author$project$Main$Update$LireLaStructure = function (a) {
	return {$: 78, a: a};
};
var $author$project$Main$Update$LireLaStructureDesFiltresDeLEtage = function (a) {
	return {$: 137, a: a};
};
var $author$project$Main$Update$LireLeCatalogueDesFiltresDeLEtage = function (a) {
	return {$: 136, a: a};
};
var $author$project$Main$Update$LireLesCategories = function (a) {
	return {$: 109, a: a};
};
var $author$project$Main$Update$LireLesInformations = function (a) {
	return {$: 104, a: a};
};
var $author$project$Main$Update$LireLesListesDuCatalogue = function (a) {
	return {$: 105, a: a};
};
var $author$project$Main$Update$LireLesListesDuNouveauChampDuCatalogue = function (a) {
	return {$: 107, a: a};
};
var $author$project$Main$Update$LireLesPerimetresDeLEtage = F2(
	function (a, b) {
		return {$: 138, a: a, b: b};
	});
var $author$project$Main$Update$MarquesDuCatalogue = 3;
var $author$project$Main$Model$PourLaStructureDuCatalogue = 4;
var $author$project$Main$Model$PourLesGammesDuCatalogue = 9;
var $author$project$Main$Model$PourLesMarquesDuCatalogue = 8;
var $author$project$Main$Model$PourLesProduitsDuCatalogue = 10;
var $author$project$Main$Model$PourLesTypesDeProduits = 7;
var $author$project$Main$Update$ProduitsDuCatalogue = 5;
var $author$project$Main$Update$depuisLaStructureDuCatalogue = F3(
	function (i18n, effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[4]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 1:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLaStructure)));
			case 2:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesInformations)));
			case 4:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesListesDuCatalogue)));
			case 5:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLaBibliothequeDuCatalogue)));
			case 6:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesListesDuNouveauChampDuCatalogue)));
			case 7:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerUnNouveauChampDuCatalogue(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 3:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesCategories)));
			case 8:
				var delaiMs = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AttendreAvantDeRelireLaStructure(delaiMs)
							])));
			case 9:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerAuCatalogue(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 10:
				var lien = effet.a;
				var geste = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$DemanderLApercuDuCatalogue(
									{mW: geste, gM: vers.gM, nB: vers.nB});
							})));
			case 11:
				var lien = effet.a;
				var typologie = effet.b;
				var choix = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$DemanderLApercuDArchivage(
									{jN: choix, gM: vers.gM, nB: vers.nB, r3: typologie});
							})));
			case 12:
				var numero = effet.a;
				var lien = effet.b;
				var recherche = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$ChercherLesArticlesDeLEtage(
									{gM: vers.gM, nB: vers.nB, DX: numero, hC: recherche});
							})));
			case 13:
				var numero = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLesPerimetresDeLEtage(numero))));
			case 14:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLeCatalogueDesFiltresDeLEtage)));
			case 15:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLaStructureDesFiltresDeLEtage)));
			case 16:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			case 17:
				var id = effet.a;
				var _v2 = model.Ih;
				if (_v2.$ === 6) {
					var etape = _v2.a;
					return _Utils_Tuple2(
						model,
						_Utils_ap(
							effets,
							_List_fromArray(
								[
									$author$project$Main$Update$RemplacerAdresse(
									$author$project$Routes$Route$toString(
										A2(
											$author$project$Routes$Route$ParametrageCatalogue,
											etape,
											$elm$core$Maybe$Just(id))))
								])));
				} else {
					return _Utils_Tuple2(model, effets);
				}
			case 18:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
			case 19:
				var desCategories = effet.a;
				return A5(
					$author$project$Main$Update$depuisLesElements,
					i18n,
					2,
					7,
					desCategories,
					_Utils_Tuple2(model, effets));
			case 20:
				var desMarques = effet.a;
				return A5(
					$author$project$Main$Update$depuisLesElements,
					i18n,
					3,
					8,
					desMarques,
					_Utils_Tuple2(model, effets));
			case 21:
				var desGammes = effet.a;
				return A5(
					$author$project$Main$Update$depuisLesElements,
					i18n,
					4,
					9,
					desGammes,
					_Utils_Tuple2(model, effets));
			default:
				var desProduits = effet.a;
				return A5(
					$author$project$Main$Update$depuisLesElements,
					i18n,
					5,
					10,
					desProduits,
					_Utils_Tuple2(model, effets));
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$popMessages = function (msg) {
	switch (msg.$) {
		case 2:
			var reponse = msg.a;
			var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$StructureCatalogue$Categories$API$QueryAPIModel$annuaireDecoder, reponse);
			if (_v1.$ === 1) {
				var refus = _v1.a;
				return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Components$Shared$Messages$Model$duRefus(refus));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 12:
			var reponse = msg.a;
			var _v2 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$StructureCatalogue$Categories$API$QueryAPIModel$ficheDecoder, reponse);
			if (_v2.$ === 1) {
				var refus = _v2.a;
				return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Components$Shared$Messages$Model$duRefus(refus));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 1:
			var octets = msg.a;
			return _Utils_eq(
				$author$project$API$ProcessUid$depuisOctets(octets),
				$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
				{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$Common$Gammes$estUneCreation = function (evenement) {
	if (evenement.$ === 5) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Produits$Common$Gammes$etendue = F2(
	function (demandee, rendue) {
		if (demandee.$ === 4) {
			return !A2($elm$core$List$any, $author$project$Components$Produits$Common$Gammes$estUneCreation, rendue.mk);
		} else {
			return false;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Gammes$Model$gammesConnues = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.gG;
			},
			model.fY));
};
var $author$project$Components$Produits$Common$Gammes$nomDeLaGammeEtendue = F3(
	function (gammes, saisi, rendue) {
		return A2(
			$elm$core$Maybe$withDefault,
			saisi,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.R;
					},
					function ($) {
						return $.zX;
					}),
				A2(
					$elm$core$Maybe$andThen,
					function (id) {
						return $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.Aq;
									},
									$elm$core$Basics$eq(id)),
								gammes));
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filterMap,
							function (evenement) {
								switch (evenement.$) {
									case 9:
										var id = evenement.a;
										return $elm$core$Maybe$Just(id);
									case 11:
										var id = evenement.a;
										return $elm$core$Maybe$Just(id);
									default:
										return $elm$core$Maybe$Nothing;
								}
							},
							rendue.mk)))));
	});
var $author$project$I18n$Textes$produitsCatalogueGammeEtendue = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.catalogue.gamme.etendue',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nom',
				$author$project$I18n$Traductions$Sous(p.Dj)),
				_Utils_Tuple2(
				'marque',
				$author$project$I18n$Traductions$Sous(p.gX))
			]),
		'« {nom} » existait déjà : c\'est la même gamme, aussi rangée sous {marque}. Rien n\'est créé en double.');
};
var $author$project$I18n$Textes$produitsCatalogueGammeEtendueToutes = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.catalogue.gamme.etendue.toutes',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nom',
				$author$project$I18n$Traductions$Sous(p.Dj))
			]),
		'« {nom} » existait déjà : c\'est la même gamme, ouverte à toutes les marques. Rien n\'est créé en double.');
};
var $author$project$Components$Produits$StructureCatalogue$Gammes$Update$popMessages = F2(
	function (avant, msg) {
		switch (msg.$) {
			case 1:
				var reponse = msg.a;
				var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$StructureCatalogue$Gammes$API$QueryAPIModel$ficheDeMarqueDecoder, reponse);
				if (_v1.$ === 1) {
					var refus = _v1.a;
					return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 10:
				var reponse = msg.a;
				var _v2 = _Utils_Tuple2(
					A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, avant.l2),
					avant.ew);
				if (((((!_v2.a.$) && (!_v2.a.a.b.$)) && (_v2.a.a.b.a.$ === 4)) && _v2.a.a.b.c) && (!_v2.b.$)) {
					var _v3 = _v2.a.a;
					var _v4 = _v3.b;
					var gamme = _v4.a.a;
					var rendue = _v4.b;
					var ouverture = _v2.b.a;
					if (A2(
						$author$project$Components$Produits$Common$Gammes$etendue,
						$author$project$Catalogue$API$WriteAPIModel$CreerUneGamme(gamme),
						rendue)) {
						var nom = A3(
							$author$project$Components$Produits$Common$Gammes$nomDeLaGammeEtendue,
							$author$project$Components$Produits$StructureCatalogue$Gammes$Model$gammesConnues(avant),
							gamme.R.zX,
							rendue);
						return $elm$core$Maybe$Just(
							{
								Jx: function () {
									var _v5 = ouverture.gX;
									if (!_v5.$) {
										var marque = _v5.a;
										return $author$project$I18n$Textes$produitsCatalogueGammeEtendue(
											{
												gX: $author$project$I18n$Traductions$tel(marque.Dj),
												Dj: $author$project$I18n$Traductions$tel(nom)
											});
									} else {
										return $author$project$I18n$Textes$produitsCatalogueGammeEtendueToutes(
											{
												Dj: $author$project$I18n$Traductions$tel(nom)
											});
									}
								}(),
								b9: $elm$core$Maybe$Nothing
							});
					} else {
						return $elm$core$Maybe$Nothing;
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 0:
				var octets = msg.a;
				return _Utils_eq(
					$author$project$API$ProcessUid$depuisOctets(octets),
					$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
					{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Marques$Update$popMessages = function (msg) {
	switch (msg.$) {
		case 2:
			var reponse = msg.a;
			var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$StructureCatalogue$Marques$API$QueryAPIModel$annuaireDecoder, reponse);
			if (_v1.$ === 1) {
				var refus = _v1.a;
				return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Components$Shared$Messages$Model$duRefus(refus));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 1:
			var octets = msg.a;
			return _Utils_eq(
				$author$project$API$ProcessUid$depuisOctets(octets),
				$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
				{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$popMessages = function (msg) {
	if (msg.$ === 9) {
		var octets = msg.a;
		return _Utils_eq(
			$author$project$API$ProcessUid$depuisOctets(octets),
			$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
			{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Update$refusDe = function (lue) {
	if (lue.$ === 1) {
		var refus = lue.a;
		return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(refus);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Update$refusDeLApercu = F2(
	function (model, reponse) {
		var _v0 = _Utils_Tuple2(
			model.q,
			A2($author$project$API$Reponse$lire, $author$project$Components$Produits$StructureCatalogue$API$ApercuAPIModel$apercuDecoder, reponse));
		if ((_v0.a.$ === 1) && (_v0.b.$ === 1)) {
			var refus = _v0.b.a;
			return ((refus.ri === 401) || $author$project$Components$Shared$Drawer$Model$estOuvert(model.y)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(refus);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Update$popMessages = F2(
	function (model, msg) {
		switch (msg.$) {
			case 176:
				var reponse = msg.a;
				var _v1 = model.l2;
				if (_v1.$ === 2) {
					var commande = _v1.b;
					if (A2($author$project$Components$Produits$StructureCatalogue$Niveaux$Update$dansUnDrawer, commande, model) || (A2($author$project$Components$Produits$StructureCatalogue$Classifications$Update$dansLeDrawer, commande, model) || (A2($author$project$Components$Produits$StructureCatalogue$Etats$Update$dansUnDrawer, commande, model) || (A2($author$project$Components$Produits$StructureCatalogue$Natures$Update$dansUnDrawer, commande, model) || (A2($author$project$Components$Produits$StructureCatalogue$Typologies$Update$dansUnDrawer, commande, model) || (A2($author$project$Components$Produits$StructureCatalogue$Etages$Update$dansUnDrawer, commande, model) || (A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Update$dansLeDrawer, commande, model) || (A2($author$project$Components$Produits$StructureCatalogue$Informations$Update$laListeSeCree, commande, model) || (($author$project$Components$Produits$StructureCatalogue$Informations$Model$estUneCommande(commande) && $author$project$Components$Shared$Drawer$Model$estOuvert(model.dL)) || ($author$project$Components$Produits$StructureCatalogue$Informations$Model$estUneCommande(commande) && $author$project$Components$Shared$Drawer$Model$estOuvert(model.dK))))))))))) {
						return $elm$core$Maybe$Nothing;
					} else {
						var _v2 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$StructureCatalogue$API$WriteAPIModel$reponseDecoder, reponse);
						if (!_v2.$) {
							var rendue = _v2.a;
							return A2($author$project$Components$Produits$StructureCatalogue$Update$rejeu, commande, rendue);
						} else {
							var refus = _v2.a;
							return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
								A3(
									$author$project$Components$Produits$StructureCatalogue$API$WriteAPIErrorsModel$message,
									A2($author$project$Components$Produits$StructureCatalogue$Update$contexteDe, commande, model),
									reponse,
									refus));
						}
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 173:
				var reponse = msg.a;
				return A2(
					$elm$core$Maybe$map,
					$author$project$Components$Shared$Messages$Model$duRefus,
					A2($author$project$Components$Produits$StructureCatalogue$Etages$Update$refusDeLApercu, model, reponse));
			case 4:
				var reponse = msg.a;
				return A2(
					$elm$core$Maybe$map,
					$author$project$Components$Shared$Messages$Model$duRefus,
					$author$project$Components$Produits$StructureCatalogue$Update$refusDe(
						A2($author$project$API$Reponse$lire, $author$project$Components$Produits$StructureCatalogue$API$QueryAPIModel$structureDecoder, reponse)));
			case 5:
				var reponse = msg.a;
				return A2(
					$elm$core$Maybe$map,
					$author$project$Components$Shared$Messages$Model$duRefus,
					$author$project$Components$Produits$StructureCatalogue$Update$refusDe(
						A2($author$project$API$Reponse$lire, $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$informationsDecoder, reponse)));
			case 6:
				var reponse = msg.a;
				return A2(
					$elm$core$Maybe$map,
					$author$project$Components$Shared$Messages$Model$duRefus,
					A2(
						$elm$core$Maybe$andThen,
						function (refus) {
							return (refus.ri === 403) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(refus);
						},
						$author$project$Components$Produits$StructureCatalogue$Update$refusDe(
							A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Listes$API$QueryAPIModel$annuaireDecoder, reponse))));
			case 7:
				var reponse = msg.a;
				return A2(
					$elm$core$Maybe$map,
					$author$project$Components$Shared$Messages$Model$duRefus,
					$author$project$Components$Produits$StructureCatalogue$Update$refusDe(
						A2($author$project$API$Reponse$lire, $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$categoriesDecoder, reponse)));
			case 3:
				var octets = msg.a;
				return _Utils_eq(
					$author$project$API$ProcessUid$depuisOctets(octets),
					$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
					{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
			case 89:
				var geste = msg.a;
				return $author$project$Components$Produits$StructureCatalogue$Categories$Update$popMessages(geste);
			case 90:
				var geste = msg.a;
				return $author$project$Components$Produits$StructureCatalogue$Marques$Update$popMessages(geste);
			case 91:
				var geste = msg.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Gammes$Update$popMessages, model.gG, geste);
			case 93:
				var geste = msg.a;
				return $author$project$Components$Produits$StructureCatalogue$Produits$Update$popMessages(geste);
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Main$Update$versLaStructureDuCatalogue = F3(
	function (i18n, msg, model) {
		var _v0 = A3(
			$author$project$Components$Produits$StructureCatalogue$Update$update,
			i18n,
			msg,
			$author$project$Components$Produits$StructureCatalogue$Model$ouvrir(model.I3));
		var structureCatalogue = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$commandeDuCatalogue, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLaStructureDuCatalogue(i18n),
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							A2(
								$author$project$Components$Produits$StructureCatalogue$Update$popMessages,
								$author$project$Components$Produits$StructureCatalogue$Model$ouvrir(model.I3),
								msg),
							gardes),
						I3: $author$project$Components$Produits$StructureCatalogue$Model$envelopper(structureCatalogue)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$AttendreAvantDeRelireLesDroits = function (a) {
	return {$: 203, a: a};
};
var $author$project$Main$Update$EnvoyerAuxDroits = function (a) {
	return {$: 202, a: a};
};
var $author$project$Main$Update$LireLesDroits = F2(
	function (a, b) {
		return {$: 201, a: a, b: b};
	});
var $author$project$Main$Model$PourLesDroits = 36;
var $author$project$Main$Update$depuisLesDroits = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[36]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 1:
				var lecture = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLesDroits(lecture))));
			case 2:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerAuxDroits(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 3:
				var delaiMs = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AttendreAvantDeRelireLesDroits(delaiMs)
							])));
			case 4:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			case 5:
				var etape = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AllerA(
								$author$project$Routes$Route$toString(
									$author$project$Routes$Route$Droits(etape)))
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$Annuaire = F2(
	function (roles, liens) {
		return {nQ: liens, eX: roles};
	});
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$liensDe = A2(
	$elm$json$Json$Decode$map,
	function ($) {
		return $.h0;
	},
	A2($elm$json$Json$Decode$field, '_links', $author$project$API$Liens$decoder));
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$Role = F5(
	function (id, nom, systeme, utilisateurs, liens) {
		return {Aq: id, nQ: liens, Dj: nom, rv: systeme, Kf: utilisateurs};
	});
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$roleDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Parametrage$Droits$API$QueryAPIModel$liensDe,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'utilisateurs',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'systeme',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'nom',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Droits$API$QueryAPIModel$Role))))));
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$annuaireDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Parametrage$Droits$API$QueryAPIModel$liensDe,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'roles',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$Droits$API$QueryAPIModel$roleDecoder),
		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Droits$API$QueryAPIModel$Annuaire)));
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$ApercuDeLAnnuaire = F2(
	function (role, fiches) {
		return {zu: fiches, bi: role};
	});
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$FicheDeLAnnuaire = F6(
	function (uid, nature, nom, lien, responsable, types) {
		return {nB: lien, g1: nature, Dj: nom, qB: responsable, ib: types, r8: uid};
	});
var $author$project$API$NavLinksDictionary$apercuDeLaFiche = 'apercu-de-la-fiche';
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$libelleDeTypeDecoder = $elm$json$Json$Decode$maybe(
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['libelles', 'fr']),
		$elm$json$Json$Decode$string));
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$FicheOrganisation = 1;
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$FichePersonne = 0;
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$natureDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (texte) {
		switch (texte) {
			case 'Personne':
				return $elm$json$Json$Decode$succeed(0);
			case 'Organisation':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('nature-de-fiche-inconnue');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$nomAffiche = F4(
	function (nature, prenom, nom, raison) {
		if (nature === 1) {
			return raison;
		} else {
			var _v1 = A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[prenom, nom]));
			if (!_v1.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var morceaux = _v1;
				return $elm$core$Maybe$Just(
					A2($elm$core$String$join, ' ', morceaux));
			}
		}
	});
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$Responsable = F2(
	function (nom, vous) {
		return {Dj: nom, KX: vous};
	});
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$responsableDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$Droits$API$QueryAPIModel$Responsable,
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'vous', $elm$json$Json$Decode$bool));
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$uniques = function (libelles) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (libelle, vus) {
				if (!libelle.$) {
					var texte = libelle.a;
					return A2($elm$core$List$member, texte, vus) ? vus : _Utils_ap(
						vus,
						_List_fromArray(
							[texte]));
				} else {
					return vus;
				}
			}),
		_List_Nil,
		libelles);
};
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$ficheDeLAnnuaireDecoder = A9(
	$elm$json$Json$Decode$map8,
	F8(
		function (uid, nature, nom, prenom, raison, lien, responsable, types) {
			return A6(
				$author$project$Components$Parametrage$Droits$API$QueryAPIModel$FicheDeLAnnuaire,
				uid,
				nature,
				A4($author$project$Components$Parametrage$Droits$API$QueryAPIModel$nomAffiche, nature, prenom, nom, raison),
				lien,
				responsable,
				types);
		}),
	A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'nature', $author$project$Components$Parametrage$Droits$API$QueryAPIModel$natureDecoder),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'prenom', $elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'raisonSociale', $elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.h0;
			},
			$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$apercuDeLaFiche)),
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2($elm$json$Json$Decode$field, '_links', $author$project$API$Liens$decoder),
					$elm$json$Json$Decode$succeed($author$project$API$Liens$aucun)
				]))),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'responsable', $author$project$Components$Parametrage$Droits$API$QueryAPIModel$responsableDecoder)),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'roles',
				A2(
					$elm$json$Json$Decode$map,
					$author$project$Components$Parametrage$Droits$API$QueryAPIModel$uniques,
					$elm$json$Json$Decode$list($author$project$Components$Parametrage$Droits$API$QueryAPIModel$libelleDeTypeDecoder))),
				$elm$json$Json$Decode$succeed(_List_Nil)
			])));
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$apercuDeLAnnuaireDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
	_List_fromArray(
		['annuaire', 'fiches']),
	$elm$json$Json$Decode$list($author$project$Components$Parametrage$Droits$API$QueryAPIModel$ficheDeLAnnuaireDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'role',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Droits$API$QueryAPIModel$ApercuDeLAnnuaire)));
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$ApercuDeLaFiche = function (role) {
	return function (uid) {
		return function (nature) {
			return function (nom) {
				return function (prenom) {
					return function (civilite) {
						return function (raisonSociale) {
							return function (responsable) {
								return function (blocs) {
									return function (contacts) {
										return function (champsLus) {
											return function (champsModifiables) {
												return {js: blocs, uZ: champsLus, u_: champsModifiables, vh: civilite, wa: contacts, g1: nature, Dj: nom, Gg: prenom, GR: raisonSociale, qB: responsable, bi: role, r8: uid};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$BlocDeChamps = F3(
	function (typeUid, libelle, champs) {
		return {dw: champs, Bl: libelle, JX: typeUid};
	});
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$ChampLu = F2(
	function (champ, valeur) {
		return {uN: champ, fm: valeur};
	});
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$boolEnTexte = function (vrai) {
	return vrai ? 'true' : 'false';
};
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$champLuDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$Droits$API$QueryAPIModel$ChampLu,
	A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$maybe(
		A2(
			$elm$json$Json$Decode$field,
			'valeur',
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						$elm$json$Json$Decode$string,
						A2($elm$json$Json$Decode$map, $elm$core$String$fromFloat, $elm$json$Json$Decode$float),
						A2($elm$json$Json$Decode$map, $author$project$Components$Parametrage$Droits$API$QueryAPIModel$boolEnTexte, $elm$json$Json$Decode$bool)
					])))));
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$blocDeChampsDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Parametrage$Droits$API$QueryAPIModel$BlocDeChamps,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['type', 'uid']),
		$elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['type', 'libelles', 'fr']),
		$elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'champs',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$Droits$API$QueryAPIModel$champLuDecoder)));
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$ContactLu = F2(
	function (canal, valeur) {
		return {uF: canal, fm: valeur};
	});
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$contactLuDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$Droits$API$QueryAPIModel$ContactLu,
	A2($elm$json$Json$Decode$field, 'canal', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'valeur', $elm$json$Json$Decode$string)));
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$apercuDeLaFicheDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'champsModifiables',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'champsLus',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		_List_Nil,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['fiche', 'contacts']),
						$elm$json$Json$Decode$list($author$project$Components$Parametrage$Droits$API$QueryAPIModel$contactLuDecoder)),
						$elm$json$Json$Decode$succeed(_List_Nil)
					])),
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['fiche', 'champsDesTypes']),
							$elm$json$Json$Decode$list($author$project$Components$Parametrage$Droits$API$QueryAPIModel$blocDeChampsDecoder)),
							$elm$json$Json$Decode$succeed(_List_Nil)
						])),
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					$elm$json$Json$Decode$maybe(
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['fiche', 'responsable']),
							$author$project$Components$Parametrage$Droits$API$QueryAPIModel$responsableDecoder)),
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						$elm$json$Json$Decode$maybe(
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['fiche', 'raisonSociale']),
								$elm$json$Json$Decode$string)),
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							$elm$json$Json$Decode$maybe(
								A2(
									$elm$json$Json$Decode$at,
									_List_fromArray(
										['fiche', 'civilite']),
									$elm$json$Json$Decode$string)),
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
								$elm$json$Json$Decode$maybe(
									A2(
										$elm$json$Json$Decode$at,
										_List_fromArray(
											['fiche', 'prenom']),
										$elm$json$Json$Decode$string)),
								A2(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
									$elm$json$Json$Decode$maybe(
										A2(
											$elm$json$Json$Decode$at,
											_List_fromArray(
												['fiche', 'nom']),
											$elm$json$Json$Decode$string)),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
										_List_fromArray(
											['fiche', 'nature']),
										$author$project$Components$Parametrage$Droits$API$QueryAPIModel$natureDecoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
											_List_fromArray(
												['fiche', 'uid']),
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'role',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Droits$API$QueryAPIModel$ApercuDeLaFiche)))))))))))));
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$Fiche = F7(
	function (id, nom, systeme, droits, reglables, personnes, liens) {
		return {xS: droits, Aq: id, nQ: liens, Dj: nom, Fg: personnes, Hl: reglables, rv: systeme};
	});
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$Droits = F4(
	function (modules, types, particuliers, toutAvecLAvenir) {
		return {of: modules, pa: particuliers, rM: toutAvecLAvenir, ib: types};
	});
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$Aucun = 0;
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$Lecture = 1;
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$Modification = 2;
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$accesDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (texte) {
		switch (texte) {
			case 'Aucun':
				return $elm$json$Json$Decode$succeed(0);
			case 'Lecture':
				return $elm$json$Json$Decode$succeed(1);
			case 'Modification':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('acces-module-inconnu');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$DroitsDeType = F6(
	function (module_, voir, creer, modifier, perimetre, champs) {
		return {dw: champs, dC: creer, ei: modifier, oe: module_, E9: perimetre, KT: voir};
	});
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$LectureDuChamp = 1;
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$Masque = 0;
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$ModificationDuChamp = 2;
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$accesChampDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (texte) {
		switch (texte) {
			case 'Masque':
				return $elm$json$Json$Decode$succeed(0);
			case 'Lecture':
				return $elm$json$Json$Decode$succeed(1);
			case 'Modification':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('acces-champ-inconnu');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$droitsDeTypeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'champs',
	$elm$json$Json$Decode$dict($author$project$Components$Parametrage$Droits$API$QueryAPIModel$accesChampDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'perimetre',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'modifier',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'creer',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'voir',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'module',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Droits$API$QueryAPIModel$DroitsDeType)))))));
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$droitsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'toutAvecLAvenir',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'particuliers',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'types',
			$elm$json$Json$Decode$dict($author$project$Components$Parametrage$Droits$API$QueryAPIModel$droitsDeTypeDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'modules',
				$elm$json$Json$Decode$dict($author$project$Components$Parametrage$Droits$API$QueryAPIModel$accesDecoder),
				$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Droits$API$QueryAPIModel$Droits)))));
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$Personne = F4(
	function (uid, nom, courriel, compteInconnu) {
		return {vY: compteInconnu, kh: courriel, Dj: nom, r8: uid};
	});
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$personneDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'compteInconnu',
	$elm$json$Json$Decode$bool,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'courriel',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'nom',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'uid',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Droits$API$QueryAPIModel$Personne)))));
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$Reglable = F5(
	function (typeRef, module_, libelle, nouveau, champs) {
		return {dw: champs, Bl: libelle, oe: module_, en: nouveau, JW: typeRef};
	});
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$ChampReglable = F5(
	function (champ, libelle, personnel, standard, nouveau) {
		return {uN: champ, Bl: libelle, en: nouveau, Fe: personnel, IZ: standard};
	});
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$champReglableDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'nouveau',
	$elm$json$Json$Decode$bool,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'standard',
		$elm$json$Json$Decode$bool,
		false,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'personnel',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'libelle',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'champ',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Droits$API$QueryAPIModel$ChampReglable))))));
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$reglableDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'champs',
	$elm$json$Json$Decode$list($author$project$Components$Parametrage$Droits$API$QueryAPIModel$champReglableDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'nouveau',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'libelle',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'module',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'typeRef',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Droits$API$QueryAPIModel$Reglable))))));
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$ficheDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Parametrage$Droits$API$QueryAPIModel$liensDe,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'personnes',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$Droits$API$QueryAPIModel$personneDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'reglables',
			$elm$json$Json$Decode$list($author$project$Components$Parametrage$Droits$API$QueryAPIModel$reglableDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'droits',
				$author$project$Components$Parametrage$Droits$API$QueryAPIModel$droitsDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'systeme',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'nom',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Droits$API$QueryAPIModel$Fiche))))))));
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$Membre = F4(
	function (uid, nom, courriel, roles) {
		return {kh: courriel, Dj: nom, eX: roles, r8: uid};
	});
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$membresDecoder = A2(
	$elm$json$Json$Decode$field,
	'membres',
	$elm$json$Json$Decode$list(
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'roles',
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'courriel',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'nom',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'uid',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Droits$API$QueryAPIModel$Membre)))))));
var $author$project$Components$Parametrage$Droits$Update$messageDeLaLecture = F2(
	function (lecture, reponse) {
		var refus = function (resultat) {
			if (resultat.$ === 1) {
				var r = resultat.a;
				return (r.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Components$Shared$Messages$Model$duRefus(r));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		switch (lecture) {
			case 0:
				return refus(
					A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Droits$API$QueryAPIModel$annuaireDecoder, reponse));
			case 1:
				return refus(
					A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Droits$API$QueryAPIModel$ficheDecoder, reponse));
			case 2:
				return refus(
					A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Droits$API$QueryAPIModel$membresDecoder, reponse));
			case 3:
				return refus(
					A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Droits$API$QueryAPIModel$ficheDecoder, reponse));
			case 4:
				return refus(
					A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Droits$API$QueryAPIModel$apercuDeLAnnuaireDecoder, reponse));
			default:
				var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Droits$API$QueryAPIModel$apercuDeLaFicheDecoder, reponse);
				if (_v1.$ === 1) {
					var r = _v1.a;
					return (r.ri === 404) ? $elm$core$Maybe$Nothing : refus(
						$elm$core$Result$Err(r));
				} else {
					return $elm$core$Maybe$Nothing;
				}
		}
	});
var $author$project$Components$Parametrage$Droits$Update$popMessages = function (msg) {
	switch (msg.$) {
		case 2:
			var lecture = msg.a;
			var reponse = msg.b;
			return A2($author$project$Components$Parametrage$Droits$Update$messageDeLaLecture, lecture, reponse);
		case 1:
			var octets = msg.a;
			return _Utils_eq(
				$author$project$API$ProcessUid$depuisOctets(octets),
				$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
				{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Main$Update$requeteSurLesDroits = function (effet) {
	switch (effet.$) {
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Parametrage$Droits$Model$Creation = {$: 0};
var $author$project$Components$Parametrage$Droits$Update$DeLAnnuaire = 0;
var $author$project$Components$Parametrage$Droits$Update$DemanderProcessUid = {$: 0};
var $author$project$Components$Parametrage$Droits$Update$Lire = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Parametrage$Droits$Update$PlacerFocus = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$Droits$Model$Renommage = {$: 1};
var $author$project$Components$Parametrage$Droits$API$WriteAPIModel$AttribuerUnRole = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$attribuerUnRole = 'attribuer-un-role';
var $author$project$Components$Parametrage$Droits$API$WriteAPIErrorsModel$Autre = 8;
var $author$project$Components$Parametrage$Droits$Update$Envoyer = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$Droits$Update$Reconnecter = {$: 6};
var $author$project$Components$Parametrage$Droits$API$WriteAPIErrorsModel$DernierAdministrateur = 3;
var $author$project$Components$Parametrage$Droits$API$WriteAPIErrorsModel$DroitsEnCoursDeRecalcul = 7;
var $author$project$Components$Parametrage$Droits$API$WriteAPIErrorsModel$DroitsIncoherents = 5;
var $author$project$Components$Parametrage$Droits$API$WriteAPIErrorsModel$NomDejaPris = 0;
var $author$project$Components$Parametrage$Droits$API$WriteAPIErrorsModel$NomInvalide = 1;
var $author$project$Components$Parametrage$Droits$API$WriteAPIErrorsModel$RoleEncoreAttribue = 2;
var $author$project$Components$Parametrage$Droits$API$WriteAPIErrorsModel$RoleSysteme = 4;
var $author$project$Components$Parametrage$Droits$API$WriteAPIErrorsModel$UtilisateurInconnu = 6;
var $author$project$Components$Parametrage$Droits$API$WriteAPIErrorsModel$duRefus = function (refus) {
	var _v0 = refus.bB;
	_v0$8:
	while (true) {
		if (_v0.$ === 1) {
			switch (_v0.a) {
				case 'NomDeRoleDejaPris':
					return 0;
				case 'NomInvalide':
					return 1;
				case 'RoleEncoreAttribue':
					return 2;
				case 'DernierAdministrateur':
					return 3;
				case 'RoleSystemeIntangible':
					return 4;
				case 'DroitsIncoherents':
					return 5;
				case 'UtilisateurInconnu':
					return 6;
				case 'DroitsEnCoursDeRecalcul':
					return 7;
				default:
					break _v0$8;
			}
		} else {
			break _v0$8;
		}
	}
	return 8;
};
var $author$project$Components$Parametrage$Droits$API$WriteAPIModel$Rendue = F2(
	function (vuesAJour, liens) {
		return {nQ: liens, sy: vuesAJour};
	});
var $author$project$Components$Parametrage$Droits$API$WriteAPIModel$rendueDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'liens',
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vuesAJour',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Droits$API$WriteAPIModel$Rendue)));
var $author$project$Components$Parametrage$Droits$Update$reglage = {
	f8: $author$project$Components$Parametrage$Droits$Update$DemanderProcessUid,
	l4: $author$project$Components$Parametrage$Droits$Update$Envoyer,
	go: function (reponse) {
		var _v0 = A2(
			$author$project$API$Reponse$lire,
			$elm$json$Json$Decode$succeed(0),
			reponse);
		if (_v0.$ === 1) {
			var refus = _v0.a;
			return $author$project$Components$Parametrage$Droits$API$WriteAPIErrorsModel$duRefus(refus);
		} else {
			return 8;
		}
	},
	pW: $author$project$Components$Parametrage$Droits$Update$Reconnecter,
	qu: F2(
		function (_v1, _v2) {
			return true;
		}),
	qv: $author$project$Components$Parametrage$Droits$API$WriteAPIModel$rendueDecoder
};
var $author$project$Components$Parametrage$Droits$Update$envoyer = F3(
	function (lien, commande, model) {
		var _v0 = A4($author$project$API$Envoi$partir, $author$project$Components$Parametrage$Droits$Update$reglage, lien, commande, model.l2);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var envoi = _v1.a;
			var effets = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi, pZ: $elm$core$Maybe$Nothing, qh: false}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$Droits$Model$trouver = F2(
	function (rel, liens) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (lien) {
					return _Utils_eq(lien.eP, rel);
				},
				liens));
	});
var $author$project$Components$Parametrage$Droits$Model$lienDeCommande = F2(
	function (rel, model) {
		return A2(
			$author$project$Components$Parametrage$Droits$Model$trouver,
			rel,
			_Utils_ap(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.nQ;
						},
						model.zo)),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.nQ;
						},
						model.aS))));
	});
var $author$project$Components$Parametrage$Droits$Update$attribuer = function (model) {
	var _v0 = _Utils_Tuple2(model.hH, model.jL);
	if ((!_v0.a.$) && _v0.b.b) {
		var role = _v0.a.a;
		var _v1 = _v0.b;
		var uid = _v1.a;
		return A3(
			$author$project$Components$Parametrage$Droits$Update$envoyer,
			A2($author$project$Components$Parametrage$Droits$Model$lienDeCommande, $author$project$API$NavLinksDictionary$attribuerUnRole, model),
			A2($author$project$Components$Parametrage$Droits$API$WriteAPIModel$AttribuerUnRole, role, uid),
			model);
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$Droits$Model$droitParDefaut = function (module_) {
	return {dw: $elm$core$Dict$empty, dC: false, ei: false, oe: module_, E9: 'Siennes', KT: false};
};
var $author$project$Components$Parametrage$Droits$Model$droitsDuRole = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.xS;
		},
		model.zo);
};
var $author$project$Components$Parametrage$Droits$Model$reglableDe = F2(
	function (cle, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (fiche) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (r) {
							return _Utils_eq(r.JW, cle);
						},
						fiche.Hl));
			},
			model.zo);
	});
var $author$project$Components$Parametrage$Droits$Model$brouillonPour = F2(
	function (geste, model) {
		var avec = F2(
			function (cle, droits) {
				var _v1 = _Utils_Tuple2(
					A2($elm$core$Dict$get, cle, droits.ib),
					A2($author$project$Components$Parametrage$Droits$Model$reglableDe, cle, model));
				if ((_v1.a.$ === 1) && (!_v1.b.$)) {
					var _v2 = _v1.a;
					var reglable = _v1.b.a;
					return _Utils_update(
						droits,
						{
							ib: A3(
								$elm$core$Dict$insert,
								cle,
								$author$project$Components$Parametrage$Droits$Model$droitParDefaut(reglable.oe),
								droits.ib)
						});
				} else {
					return droits;
				}
			});
		switch (geste.$) {
			case 5:
				var cle = geste.a;
				return A2(
					$elm$core$Maybe$map,
					avec(cle),
					$author$project$Components$Parametrage$Droits$Model$droitsDuRole(model));
			case 6:
				var cle = geste.a;
				return A2(
					$elm$core$Maybe$map,
					avec(cle),
					$author$project$Components$Parametrage$Droits$Model$droitsDuRole(model));
			default:
				return $author$project$Components$Parametrage$Droits$Model$droitsDuRole(model);
		}
	});
var $author$project$Components$Parametrage$Droits$Update$DeLaFiche = 1;
var $author$project$API$NavLinksDictionary$reglerUnRole = 'regler-un-role';
var $author$project$API$NavLinksDictionary$roleInterne = 'role';
var $author$project$Components$Parametrage$Droits$Update$choisirLeRole = F2(
	function (id, model) {
		var lien = A2(
			$elm$core$Maybe$andThen,
			function (role) {
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reglerUnRole, role.nQ);
				if (!_v1.$) {
					var lienDeReglage = _v1.a;
					return $elm$core$Maybe$Just(lienDeReglage);
				} else {
					return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$roleInterne, role.nQ);
				}
			},
			A2(
				$elm$core$Maybe$andThen,
				function (annuaire) {
					return $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (role) {
								return _Utils_eq(role.Aq, id);
							},
							annuaire.eX));
				},
				model.aS));
		if (!lien.$) {
			var porteur = lien.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						zo: $elm$core$Maybe$Nothing,
						nD: $elm$core$Maybe$Just(porteur),
						hH: $elm$core$Maybe$Just(id),
						r_: $elm$core$Maybe$Nothing
					}),
				_List_fromArray(
					[
						A2($author$project$Components$Parametrage$Droits$Update$Lire, 1, porteur)
					]));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$Droits$Update$AttendreAvantDeRelire = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$Droits$Model$roleRegle = function (model) {
	var _v0 = _Utils_Tuple2(model.aS, model.hH);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var annuaire = _v0.a.a;
		var id = _v0.b.a;
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (role) {
					return _Utils_eq(role.Aq, id);
				},
				annuaire.eX));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$Droits$Update$saisieEnCours = function (model) {
	var _v0 = model.mW;
	_v0$3:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a.$) {
				case 0:
					var _v1 = _v0.a;
					return ($elm$core$String$trim(model.Dj) !== '') || (!_Utils_eq(model.oa, $elm$core$Maybe$Nothing));
				case 1:
					var _v2 = _v0.a;
					return !_Utils_eq(
						$elm$core$String$trim(model.Dj),
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.Dj;
								},
								$author$project$Components$Parametrage$Droits$Model$roleRegle(model))));
				case 2:
					var _v3 = _v0.a;
					return !_Utils_eq(model.jL, _List_Nil);
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return false;
};
var $author$project$Components$Parametrage$Droits$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{kX: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Parametrage$Droits$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Parametrage$Droits$Update$saisieEnCours(model)
				},
				geste,
				model.kX));
	});
var $author$project$Components$Parametrage$Droits$Update$ouvrirLeRoleCree = F2(
	function (rendue, model) {
		var _v0 = A2($author$project$Components$Parametrage$Droits$Update$versLeDrawer, $author$project$Components$Shared$Drawer$Update$Fermer, model);
		var ferme = _v0.a;
		var effets = _v0.b;
		var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$roleInterne, rendue.nQ);
		if (!_v1.$) {
			var lien = _v1.a;
			return _Utils_Tuple2(
				_Utils_update(
					ferme,
					{
						zo: $elm$core$Maybe$Nothing,
						nD: $elm$core$Maybe$Just(lien),
						r_: $elm$core$Maybe$Nothing
					}),
				effets);
		} else {
			return _Utils_Tuple2(ferme, effets);
		}
	});
var $author$project$Components$Parametrage$Droits$Update$apresLaCommande = F3(
	function (commande, rendue, model) {
		switch (commande.$) {
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{zo: $elm$core$Maybe$Nothing, nD: $elm$core$Maybe$Nothing, hH: $elm$core$Maybe$Nothing, r_: $elm$core$Maybe$Nothing}),
					_List_Nil);
			case 5:
				var _v1 = A2($elm$core$List$drop, 1, model.jL);
				if (!_v1.b) {
					return A2(
						$author$project$Components$Parametrage$Droits$Update$versLeDrawer,
						$author$project$Components$Shared$Drawer$Update$Fermer,
						_Utils_update(
							model,
							{jL: _List_Nil}));
				} else {
					var reste = _v1;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{jL: reste, rn: true}),
						_List_Nil);
				}
			case 0:
				return A2($author$project$Components$Parametrage$Droits$Update$ouvrirLeRoleCree, rendue, model);
			case 1:
				return A2($author$project$Components$Parametrage$Droits$Update$ouvrirLeRoleCree, rendue, model);
			default:
				return A2(
					$author$project$Components$Parametrage$Droits$Update$versLeDrawer,
					$author$project$Components$Shared$Drawer$Update$Fermer,
					_Utils_update(
						model,
						{
							zo: A2(
								$elm$core$Maybe$map,
								function (fiche) {
									return _Utils_update(
										fiche,
										{nQ: rendue.nQ});
								},
								model.zo)
						}));
		}
	});
var $author$project$Components$Parametrage$Droits$Update$relire = function (model) {
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$map,
				$author$project$Components$Parametrage$Droits$Update$Lire(0),
				model.np),
				A2(
				$elm$core$Maybe$map,
				$author$project$Components$Parametrage$Droits$Update$Lire(1),
				model.nD)
			]));
};
var $author$project$Components$Parametrage$Droits$Update$conclure = F2(
	function (issue, model) {
		switch (issue.$) {
			case 0:
				if (issue.c) {
					var commande = issue.a;
					var rendue = issue.b;
					var suite = A3($author$project$Components$Parametrage$Droits$Update$apresLaCommande, commande, rendue, model);
					return A2(
						$elm$core$Tuple$mapSecond,
						function (effets) {
							return _Utils_ap(
								effets,
								rendue.sy ? $author$project$Components$Parametrage$Droits$Update$relire(suite.a) : _List_fromArray(
									[
										$author$project$Components$Parametrage$Droits$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
									]));
						},
						suite);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{qh: true}),
						$author$project$Components$Parametrage$Droits$Update$relire(model));
				}
			case 1:
				var erreur = issue.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							pZ: $elm$core$Maybe$Just(erreur)
						}),
					_List_Nil);
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$Droits$API$WriteAPIModel$CreerUnRole = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$Droits$API$WriteAPIModel$DupliquerUnRole = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$creerUnRole = 'creer-un-role';
var $author$project$Components$Parametrage$Droits$API$QueryAPIModel$droitsVides = {of: $elm$core$Dict$empty, pa: _List_Nil, rM: false, ib: $elm$core$Dict$empty};
var $author$project$Components$Parametrage$Droits$Model$lienDeDuplication = function (model) {
	return A2(
		$author$project$Components$Parametrage$Droits$Model$trouver,
		'dupliquer-un-role',
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.eX;
					},
					$elm$core$List$concatMap(
						function ($) {
							return $.nQ;
						})),
				model.aS)));
};
var $author$project$Components$Parametrage$Droits$Update$creer = function (model) {
	var nom = $elm$core$String$trim(model.Dj);
	if (nom === '') {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					pZ: $elm$core$Maybe$Just(1)
				}),
			_List_fromArray(
				[
					$author$project$Components$Parametrage$Droits$Update$PlacerFocus(
					$author$project$Components$Shared$Drawer$Model$idTitre(model.kX))
				]));
	} else {
		var _v0 = model.oa;
		if (!_v0.$) {
			var modele = _v0.a;
			return A3(
				$author$project$Components$Parametrage$Droits$Update$envoyer,
				$author$project$Components$Parametrage$Droits$Model$lienDeDuplication(model),
				A2($author$project$Components$Parametrage$Droits$API$WriteAPIModel$DupliquerUnRole, modele, nom),
				model);
		} else {
			return A3(
				$author$project$Components$Parametrage$Droits$Update$envoyer,
				A2($author$project$Components$Parametrage$Droits$Model$lienDeCommande, $author$project$API$NavLinksDictionary$creerUnRole, model),
				A2($author$project$Components$Parametrage$Droits$API$WriteAPIModel$CreerUnRole, nom, $author$project$Components$Parametrage$Droits$API$QueryAPIModel$droitsVides),
				model);
		}
	}
};
var $author$project$Components$Parametrage$Droits$Update$AllerALEtape = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Parametrage$Droits$Update$DeLApercu = 4;
var $author$project$API$NavLinksDictionary$apercuDuRole = 'apercu-du-role';
var $author$project$Components$Parametrage$Droits$Model$lienDeLApercu = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.nQ;
			},
			$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$apercuDuRole)),
		model.zo);
};
var $author$project$Components$Parametrage$Droits$Update$etapeAfficheeAvecRole = F2(
	function (etape, model) {
		var _v0 = _Utils_Tuple2(
			etape,
			$author$project$Components$Parametrage$Droits$Model$lienDeLApercu(model));
		if ((_v0.a === 5) && (!_v0.b.$)) {
			var _v1 = _v0.a;
			var lien = _v0.b.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{tq: $elm$core$Maybe$Nothing, iW: $elm$core$Maybe$Nothing, iX: false}),
				_List_fromArray(
					[
						A2($author$project$Components$Parametrage$Droits$Update$Lire, 4, lien)
					]));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$Droits$Update$etapeAffichee = F2(
	function (etape, model) {
		return ((!(!etape)) && ((etape !== 4) && _Utils_eq(model.hH, $elm$core$Maybe$Nothing))) ? _Utils_Tuple2(
			model,
			_List_fromArray(
				[
					$author$project$Components$Parametrage$Droits$Update$AllerALEtape(0)
				])) : A2($author$project$Components$Parametrage$Droits$Update$etapeAfficheeAvecRole, etape, model);
	});
var $author$project$Components$Parametrage$Droits$API$WriteAPIModel$FixerLesDroits = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$fixerLesDroits = 'fixer-les-droits';
var $author$project$Components$Parametrage$Droits$Update$fixerLesDroits = function (model) {
	var _v0 = _Utils_Tuple2(model.hH, model.uw);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var role = _v0.a.a;
		var droits = _v0.b.a;
		return A3(
			$author$project$Components$Parametrage$Droits$Update$envoyer,
			A2($author$project$Components$Parametrage$Droits$Model$lienDeCommande, $author$project$API$NavLinksDictionary$fixerLesDroits, model),
			A2($author$project$Components$Parametrage$Droits$API$WriteAPIModel$FixerLesDroits, role, droits),
			model);
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$Droits$Parcours$nom = function (etape) {
	switch (etape) {
		case 0:
			return 'vos-roles';
		case 1:
			return 'modules';
		case 2:
			return 'fiches';
		case 3:
			return 'champs';
		case 4:
			return 'personnes';
		default:
			return 'verification';
	}
};
var $author$project$Components$Parametrage$Droits$Parcours$idDuTitre = function (etape) {
	return $author$project$Components$Shared$Parcours$Model$idDuTitre(
		$author$project$Components$Parametrage$Droits$Parcours$nom(etape));
};
var $author$project$Components$Parametrage$Droits$Update$DuModele = 3;
var $author$project$Components$Parametrage$Droits$Update$lireLeModele = F2(
	function (modele, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (lien) {
					return _List_fromArray(
						[
							A2($author$project$Components$Parametrage$Droits$Update$Lire, 3, lien)
						]);
				},
				A2(
					$elm$core$Maybe$andThen,
					function (id) {
						return A2(
							$elm$core$Maybe$andThen,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.nQ;
								},
								$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$roleInterne)),
							A2(
								$elm$core$Maybe$andThen,
								function (annuaire) {
									return $elm$core$List$head(
										A2(
											$elm$core$List$filter,
											function (role) {
												return _Utils_eq(role.Aq, id);
											},
											annuaire.eX));
								},
								model.aS));
					},
					modele)));
	});
var $author$project$Components$Parametrage$Droits$Update$echec = F2(
	function (refus, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{gd: true}),
			(refus.ri === 401) ? _List_fromArray(
				[$author$project$Components$Parametrage$Droits$Update$Reconnecter]) : _List_Nil);
	});
var $author$project$Components$Parametrage$Droits$Update$lue = F3(
	function (lecture, reponse, model) {
		switch (lecture) {
			case 0:
				var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Droits$API$QueryAPIModel$annuaireDecoder, reponse);
				if (!_v1.$) {
					var annuaire = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aS: $elm$core$Maybe$Just(annuaire),
								gd: false
							}),
						_List_Nil);
				} else {
					var refus = _v1.a;
					return A2($author$project$Components$Parametrage$Droits$Update$echec, refus, model);
				}
			case 1:
				var _v2 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Droits$API$QueryAPIModel$ficheDecoder, reponse);
				if (!_v2.$) {
					var fiche = _v2.a;
					var reglee = _Utils_update(
						model,
						{
							iS: false,
							gd: false,
							zo: $elm$core$Maybe$Just(fiche),
							hH: $elm$core$Maybe$Just(fiche.Aq)
						});
					return model.iS ? A2($author$project$Components$Parametrage$Droits$Update$etapeAfficheeAvecRole, 5, reglee) : _Utils_Tuple2(reglee, _List_Nil);
				} else {
					var refus = _v2.a;
					return A2($author$project$Components$Parametrage$Droits$Update$echec, refus, model);
				}
			case 3:
				var _v3 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Droits$API$QueryAPIModel$ficheDecoder, reponse);
				if (!_v3.$) {
					var fiche = _v3.a;
					return _Utils_eq(
						$elm$core$Maybe$Just(fiche.Aq),
						model.oa) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{
								oc: $elm$core$Maybe$Just(fiche)
							}),
						_List_Nil) : _Utils_Tuple2(model, _List_Nil);
				} else {
					var refus = _v3.a;
					return A2($author$project$Components$Parametrage$Droits$Update$echec, refus, model);
				}
			case 2:
				var _v4 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Droits$API$QueryAPIModel$membresDecoder, reponse);
				if (!_v4.$) {
					var membres = _v4.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								Cm: $elm$core$Maybe$Just(membres)
							}),
						_List_Nil);
				} else {
					var refus = _v4.a;
					return A2($author$project$Components$Parametrage$Droits$Update$echec, refus, model);
				}
			case 4:
				var _v5 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Droits$API$QueryAPIModel$apercuDeLAnnuaireDecoder, reponse);
				if (!_v5.$) {
					var apercu = _v5.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								tq: $elm$core$Maybe$Just(apercu),
								gd: false
							}),
						_List_Nil);
				} else {
					var refus = _v5.a;
					return A2($author$project$Components$Parametrage$Droits$Update$echec, refus, model);
				}
			default:
				var _v6 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Droits$API$QueryAPIModel$apercuDeLaFicheDecoder, reponse);
				if (!_v6.$) {
					var fiche = _v6.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: $elm$core$Maybe$Just(fiche),
								iX: false
							}),
						_List_Nil);
				} else {
					var refus = _v6.a;
					return (refus.ri === 404) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: $elm$core$Maybe$Nothing, iX: true}),
						_List_Nil) : A2($author$project$Components$Parametrage$Droits$Update$echec, refus, model);
				}
		}
	});
var $author$project$I18n$Cles$droitsCreerCopieNom = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.creer.copie.nom',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.Dj + ' (copie)');
	});
var $author$project$Components$Parametrage$Droits$Update$nomDeCopie = F3(
	function (i18n, modele, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (role) {
					return A2(
						$author$project$I18n$Cles$droitsCreerCopieNom,
						i18n,
						{Dj: role.Dj});
				},
				A2(
					$elm$core$Maybe$andThen,
					function (id) {
						return A2(
							$elm$core$Maybe$andThen,
							function (annuaire) {
								return $elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (role) {
											return _Utils_eq(role.Aq, id);
										},
										annuaire.eX));
							},
							model.aS);
					},
					modele)));
	});
var $author$project$Components$Parametrage$Droits$Update$idDuDeclencheur = 'page-droits';
var $author$project$Components$Parametrage$Droits$Update$ouvrir = F2(
	function (geste, model) {
		return A2(
			$author$project$Components$Parametrage$Droits$Update$versLeDrawer,
			$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Parametrage$Droits$Update$idDuDeclencheur),
			_Utils_update(
				model,
				{
					mW: $elm$core$Maybe$Just(geste)
				}));
	});
var $author$project$Components$Parametrage$Droits$Model$Attribution = {$: 2};
var $author$project$Components$Parametrage$Droits$Update$DesMembres = 2;
var $author$project$API$NavLinksDictionary$membresDuClient = 'membres';
var $author$project$Components$Parametrage$Droits$Update$ouvrirLAttribution = function (model) {
	var lien = A2(
		$elm$core$Maybe$andThen,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.nQ;
			},
			$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$membresDuClient)),
		model.zo);
	var _v0 = A2(
		$author$project$Components$Parametrage$Droits$Update$ouvrir,
		$author$project$Components$Parametrage$Droits$Model$Attribution,
		_Utils_update(
			model,
			{jL: _List_Nil, hC: '', pZ: $elm$core$Maybe$Nothing, qh: false}));
	var ouvert = _v0.a;
	var effets = _v0.b;
	return _Utils_Tuple2(
		ouvert,
		_Utils_ap(
			effets,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Parametrage$Droits$Update$Lire(2),
						$elm$core$List$singleton),
					lien))));
};
var $author$project$Components$Parametrage$Droits$Update$DeLaFicheApercue = 5;
var $author$project$Components$Parametrage$Droits$Model$lienDeLaFicheApercue = F2(
	function (model, uid) {
		return A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.nB;
			},
			A2(
				$elm$core$Maybe$andThen,
				function (lu) {
					return $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (fiche) {
								return _Utils_eq(fiche.r8, uid);
							},
							lu.zu));
				},
				model.tq));
	});
var $author$project$Components$Parametrage$Droits$Update$ouvrirLaFicheApercue = F2(
	function (uid, model) {
		var _v0 = A2($author$project$Components$Parametrage$Droits$Model$lienDeLaFicheApercue, model, uid);
		if (!_v0.$) {
			var lien = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{iW: $elm$core$Maybe$Nothing, iX: false}),
				_List_fromArray(
					[
						A2($author$project$Components$Parametrage$Droits$Update$Lire, 5, lien)
					]));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$Droits$Update$reglerLeBrouillon = F2(
	function (regler, model) {
		var cle = function () {
			var _v1 = model.mW;
			_v1$3:
			while (true) {
				if (!_v1.$) {
					switch (_v1.a.$) {
						case 3:
							var cle_ = _v1.a.a;
							return $elm$core$Maybe$Just(cle_);
						case 4:
							var cle_ = _v1.a.a;
							return $elm$core$Maybe$Just(cle_);
						case 5:
							var cle_ = _v1.a.a;
							return $elm$core$Maybe$Just(cle_);
						default:
							break _v1$3;
					}
				} else {
					break _v1$3;
				}
			}
			return $elm$core$Maybe$Nothing;
		}();
		var _v0 = _Utils_Tuple2(cle, model.uw);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var porteur = _v0.a.a;
			var brouillon = _v0.b.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						uw: $elm$core$Maybe$Just(
							A2(regler, porteur, brouillon))
					}),
				_List_Nil);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$Droits$Model$reglerLeChamp = F4(
	function (cle, champ, acces, droits) {
		var _v0 = A2($elm$core$Dict$get, cle, droits.ib);
		if (_v0.$ === 1) {
			return droits;
		} else {
			var droit = _v0.a;
			var permis = (!droit.KT) ? 0 : (((acces === 2) && (!droit.ei)) ? 1 : acces);
			return _Utils_update(
				droits,
				{
					ib: A3(
						$elm$core$Dict$insert,
						cle,
						_Utils_update(
							droit,
							{
								dw: A3($elm$core$Dict$insert, champ, permis, droit.dw)
							}),
						droits.ib)
				});
		}
	});
var $author$project$Components$Parametrage$Droits$Model$reglerLaCreation = F2(
	function (creer, droit) {
		return _Utils_update(
			droit,
			{dC: creer});
	});
var $author$project$Components$Parametrage$Droits$Model$bornerLesChamps = function (droit) {
	return _Utils_update(
		droit,
		{
			dw: A2(
				$elm$core$Dict$map,
				F2(
					function (_v0, acces) {
						var _v1 = _Utils_Tuple2(acces, droit.ei);
						if ((_v1.a === 2) && (!_v1.b)) {
							var _v2 = _v1.a;
							return 1;
						} else {
							return acces;
						}
					}),
				droit.dw)
		});
};
var $author$project$Components$Parametrage$Droits$Model$reglerLaModification = F2(
	function (modifier, droit) {
		return $author$project$Components$Parametrage$Droits$Model$bornerLesChamps(
			_Utils_update(
				droit,
				{ei: modifier}));
	});
var $author$project$Components$Parametrage$Droits$Model$sansDroit = function (droit) {
	return _Utils_update(
		droit,
		{
			dw: A2(
				$elm$core$Dict$map,
				F2(
					function (_v0, _v1) {
						return 0;
					}),
				droit.dw),
			dC: false,
			ei: false,
			KT: false
		});
};
var $author$project$Components$Parametrage$Droits$Model$borner = F3(
	function (cle, acces, droit) {
		if (!_Utils_eq(droit.oe, cle)) {
			return droit;
		} else {
			switch (acces) {
				case 0:
					return $author$project$Components$Parametrage$Droits$Model$sansDroit(droit);
				case 1:
					return A2(
						$author$project$Components$Parametrage$Droits$Model$reglerLaModification,
						false,
						A2($author$project$Components$Parametrage$Droits$Model$reglerLaCreation, false, droit));
				default:
					return droit;
			}
		}
	});
var $author$project$Components$Parametrage$Droits$Model$reglerLeModule = F3(
	function (cle, acces, droits) {
		return _Utils_update(
			droits,
			{
				of: A3($elm$core$Dict$insert, cle, acces, droits.of),
				ib: A2(
					$elm$core$Dict$map,
					F2(
						function (_v0, droit) {
							return A3($author$project$Components$Parametrage$Droits$Model$borner, cle, acces, droit);
						}),
					droits.ib)
			});
	});
var $author$project$Components$Parametrage$Droits$Model$reglerLeParticulier = F3(
	function (cle, donne, droits) {
		return _Utils_update(
			droits,
			{
				pa: donne ? (A2($elm$core$List$member, cle, droits.pa) ? droits.pa : _Utils_ap(
					droits.pa,
					_List_fromArray(
						[cle]))) : A2(
					$elm$core$List$filter,
					function (autre) {
						return !_Utils_eq(autre, cle);
					},
					droits.pa)
			});
	});
var $author$project$Components$Parametrage$Droits$Update$reglerLeRole = F2(
	function (id, model) {
		var seRegle = !_Utils_eq(
			$elm$core$Maybe$Nothing,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nQ;
					},
					$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$reglerUnRole)),
				A2(
					$elm$core$Maybe$andThen,
					function (annuaire) {
						return $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (role) {
									return _Utils_eq(role.Aq, id);
								},
								annuaire.eX));
					},
					model.aS)));
		if (!seRegle) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v0 = A2($author$project$Components$Parametrage$Droits$Update$choisirLeRole, id, model);
			if (!_v0.b.b) {
				return _Utils_Tuple2(model, _List_Nil);
			} else {
				var choisi = _v0.a;
				var effets = _v0.b;
				return _Utils_Tuple2(
					choisi,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Components$Parametrage$Droits$Update$AllerALEtape(1)
							])));
			}
		}
	});
var $author$project$Components$Parametrage$Droits$Model$reglerLeType = F3(
	function (cle, voulu, droits) {
		var _v0 = A2($elm$core$Dict$get, cle, droits.ib);
		if (_v0.$ === 1) {
			return droits;
		} else {
			var droit = _v0.a;
			var voit = voulu.KT || (voulu.dC || voulu.ei);
			var regle = voit ? _Utils_update(
				droit,
				{dC: voulu.dC, ei: voulu.ei, E9: voulu.E9, KT: true}) : $author$project$Components$Parametrage$Droits$Model$sansDroit(droit);
			var acces = A2(
				$elm$core$Maybe$withDefault,
				0,
				A2($elm$core$Dict$get, droit.oe, droits.of));
			return _Utils_update(
				droits,
				{
					ib: A3(
						$elm$core$Dict$insert,
						cle,
						$author$project$Components$Parametrage$Droits$Model$bornerLesChamps(
							A3($author$project$Components$Parametrage$Droits$Model$borner, droit.oe, acces, regle)),
						droits.ib)
				});
		}
	});
var $author$project$Components$Parametrage$Droits$API$WriteAPIModel$RenommerUnRole = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Parametrage$Droits$Model$lienDeLaLigne = F3(
	function (role, rel, model) {
		return A2(
			$author$project$Components$Parametrage$Droits$Model$trouver,
			rel,
			A2(
				$elm$core$List$concatMap,
				function ($) {
					return $.nQ;
				},
				A2(
					$elm$core$List$filter,
					function (ligne) {
						return _Utils_eq(ligne.Aq, role);
					},
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.eX;
							},
							model.aS)))));
	});
var $author$project$API$NavLinksDictionary$renommerUnRole = 'renommer-un-role';
var $author$project$Components$Parametrage$Droits$Update$renommer = function (model) {
	var _v0 = _Utils_Tuple2(
		model.hH,
		$elm$core$String$trim(model.Dj));
	if (!_v0.a.$) {
		var role = _v0.a.a;
		var nom = _v0.b;
		return (nom === '') ? _Utils_Tuple2(
			_Utils_update(
				model,
				{
					pZ: $elm$core$Maybe$Just(1)
				}),
			_List_Nil) : A3(
			$author$project$Components$Parametrage$Droits$Update$envoyer,
			A3($author$project$Components$Parametrage$Droits$Model$lienDeLaLigne, role, $author$project$API$NavLinksDictionary$renommerUnRole, model),
			A2($author$project$Components$Parametrage$Droits$API$WriteAPIModel$RenommerUnRole, role, nom),
			model);
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$Droits$API$WriteAPIModel$RetirerUnRole = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$retirerUnRole = 'retirer-un-role';
var $author$project$Components$Parametrage$Droits$Update$retirer = F2(
	function (uid, model) {
		var _v0 = model.hH;
		if (!_v0.$) {
			var role = _v0.a;
			return A3(
				$author$project$Components$Parametrage$Droits$Update$envoyer,
				A2($author$project$Components$Parametrage$Droits$Model$lienDeCommande, $author$project$API$NavLinksDictionary$retirerUnRole, model),
				A2($author$project$Components$Parametrage$Droits$API$WriteAPIModel$RetirerUnRole, role, uid),
				model);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$rolesInternes = 'roles';
var $author$project$Components$Parametrage$Droits$API$WriteAPIModel$SupprimerUnRole = function (a) {
	return {$: 3, a: a};
};
var $author$project$API$NavLinksDictionary$supprimerUnRole = 'supprimer-un-role';
var $author$project$Components$Parametrage$Droits$Update$supprimer = F2(
	function (id, model) {
		return A3(
			$author$project$Components$Parametrage$Droits$Update$envoyer,
			A3($author$project$Components$Parametrage$Droits$Model$lienDeLaLigne, id, $author$project$API$NavLinksDictionary$supprimerUnRole, model),
			$author$project$Components$Parametrage$Droits$API$WriteAPIModel$SupprimerUnRole(id),
			_Utils_update(
				model,
				{mW: $elm$core$Maybe$Nothing}));
	});
var $author$project$Components$Parametrage$Droits$Update$update = F3(
	function (i18n, msg, model) {
		switch (msg.$) {
			case 0:
				var liens = msg.a;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rolesInternes, liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								np: $elm$core$Maybe$Just(lecture),
								qa: false
							}),
						_List_fromArray(
							[
								$author$project$Components$Parametrage$Droits$Update$DemanderProcessUid,
								A2($author$project$Components$Parametrage$Droits$Update$Lire, 0, lecture)
							]));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aS: $elm$core$Maybe$Nothing, np: $elm$core$Maybe$Nothing, qa: true}),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				return model.rn ? $author$project$Components$Parametrage$Droits$Update$attribuer(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2),
							rn: false
						})) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 2:
				var lecture = msg.a;
				var reponse = msg.b;
				return A3($author$project$Components$Parametrage$Droits$Update$lue, lecture, reponse, model);
			case 3:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Parametrage$Droits$Update$relire(model));
			case 4:
				var id = msg.a;
				return A2($author$project$Components$Parametrage$Droits$Update$choisirLeRole, id, model);
			case 5:
				var id = msg.a;
				return A2(
					$author$project$Components$Parametrage$Droits$Update$choisirLeRole,
					id,
					_Utils_update(
						model,
						{iS: true}));
			case 6:
				var id = msg.a;
				return A2($author$project$Components$Parametrage$Droits$Update$reglerLeRole, id, model);
			case 7:
				var cle = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							r_: $elm$core$Maybe$Just(cle)
						}),
					_List_Nil);
			case 8:
				var etape = msg.a;
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[
							$author$project$Components$Parametrage$Droits$Update$PlacerFocus(
							$author$project$Components$Parametrage$Droits$Parcours$idDuTitre(etape))
						]));
			case 9:
				var geste = msg.a;
				return $author$project$API$Envoi$enCours(model.l2) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Parametrage$Droits$Update$versLeDrawer, geste, model);
			case 10:
				var modele = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (effets) {
						return _Utils_ap(
							effets,
							A2($author$project$Components$Parametrage$Droits$Update$lireLeModele, modele, model));
					},
					A2(
						$author$project$Components$Parametrage$Droits$Update$ouvrir,
						$author$project$Components$Parametrage$Droits$Model$Creation,
						_Utils_update(
							model,
							{
								oa: modele,
								oc: $elm$core$Maybe$Nothing,
								Dj: A3($author$project$Components$Parametrage$Droits$Update$nomDeCopie, i18n, modele, model),
								pZ: $elm$core$Maybe$Nothing,
								qh: false
							})));
			case 11:
				var nom = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Dj: nom, pZ: $elm$core$Maybe$Nothing}),
					_List_Nil);
			case 12:
				var modele = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							oa: modele,
							oc: $elm$core$Maybe$Nothing,
							Dj: A3($author$project$Components$Parametrage$Droits$Update$nomDeCopie, i18n, modele, model),
							pZ: $elm$core$Maybe$Nothing
						}),
					A2($author$project$Components$Parametrage$Droits$Update$lireLeModele, modele, model));
			case 13:
				return $author$project$Components$Parametrage$Droits$Update$creer(model);
			case 14:
				var id = msg.a;
				var choisi = _Utils_update(
					model,
					{
						hH: $elm$core$Maybe$Just(id)
					});
				return A2(
					$author$project$Components$Parametrage$Droits$Update$ouvrir,
					$author$project$Components$Parametrage$Droits$Model$Renommage,
					_Utils_update(
						choisi,
						{
							Dj: A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.Dj;
									},
									$author$project$Components$Parametrage$Droits$Model$roleRegle(choisi))),
							pZ: $elm$core$Maybe$Nothing,
							qh: false
						}));
			case 15:
				return $author$project$Components$Parametrage$Droits$Update$renommer(model);
			case 16:
				var id = msg.a;
				return A2($author$project$Components$Parametrage$Droits$Update$supprimer, id, model);
			case 17:
				return $author$project$Components$Parametrage$Droits$Update$ouvrirLAttribution(model);
			case 18:
				var recherche = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{hC: recherche}),
					_List_Nil);
			case 19:
				var uid = msg.a;
				var coche = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jL: coche ? (A2($elm$core$List$member, uid, model.jL) ? model.jL : _Utils_ap(
								model.jL,
								_List_fromArray(
									[uid]))) : A2(
								$elm$core$List$filter,
								function (autre) {
									return !_Utils_eq(autre, uid);
								},
								model.jL)
						}),
					_List_Nil);
			case 20:
				return $author$project$Components$Parametrage$Droits$Update$attribuer(model);
			case 21:
				var uid = msg.a;
				return A2($author$project$Components$Parametrage$Droits$Update$retirer, uid, model);
			case 22:
				var geste = msg.a;
				return A2(
					$author$project$Components$Parametrage$Droits$Update$ouvrir,
					geste,
					_Utils_update(
						model,
						{
							uw: A2($author$project$Components$Parametrage$Droits$Model$brouillonPour, geste, model),
							pZ: $elm$core$Maybe$Nothing,
							qh: false
						}));
			case 23:
				var acces = msg.a;
				return A2(
					$author$project$Components$Parametrage$Droits$Update$reglerLeBrouillon,
					function (cle) {
						return A2($author$project$Components$Parametrage$Droits$Model$reglerLeModule, cle, acces);
					},
					model);
			case 24:
				var donne = msg.a;
				return A2(
					$author$project$Components$Parametrage$Droits$Update$reglerLeBrouillon,
					function (cle) {
						return A2($author$project$Components$Parametrage$Droits$Model$reglerLeParticulier, cle, donne);
					},
					model);
			case 25:
				var voulu = msg.a;
				return A2(
					$author$project$Components$Parametrage$Droits$Update$reglerLeBrouillon,
					function (cle) {
						return A2($author$project$Components$Parametrage$Droits$Model$reglerLeType, cle, voulu);
					},
					model);
			case 26:
				var acces = msg.a;
				var _v2 = model.mW;
				if ((!_v2.$) && (_v2.a.$ === 6)) {
					var _v3 = _v2.a;
					var cle = _v3.a;
					var champ = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								uw: A2(
									$elm$core$Maybe$map,
									A3($author$project$Components$Parametrage$Droits$Model$reglerLeChamp, cle, champ, acces),
									model.uw)
							}),
						_List_Nil);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 27:
				return $author$project$Components$Parametrage$Droits$Update$fixerLesDroits(model);
			case 28:
				var etape = msg.a;
				return A2($author$project$Components$Parametrage$Droits$Update$etapeAffichee, etape, model);
			case 29:
				var uid = msg.a;
				return A2($author$project$Components$Parametrage$Droits$Update$ouvrirLaFicheApercue, uid, model);
			default:
				var reponse = msg.a;
				var _v4 = A3($author$project$API$Envoi$conclure, $author$project$Components$Parametrage$Droits$Update$reglage, reponse, model.l2);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var envoi = _v5.a;
					var issue = _v5.b;
					var effets = _v5.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Parametrage$Droits$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Main$Update$versLesDroits = F3(
	function (i18n, msg, model) {
		var _v0 = A3(
			$author$project$Components$Parametrage$Droits$Update$update,
			i18n,
			msg,
			$author$project$Components$Parametrage$Droits$Model$ouvrir(model.xS));
		var droits = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLesDroits, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLesDroits,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						xS: $author$project$Components$Parametrage$Droits$Model$envelopper(droits),
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Parametrage$Droits$Update$popMessages(msg),
							gardes)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$AttendreAvantDeRelireLesTypesDeRelation = function (a) {
	return {$: 272, a: a};
};
var $author$project$Main$Update$EnvoyerAuxTypesDeRelation = function (a) {
	return {$: 271, a: a};
};
var $author$project$Main$Update$LireLesFormesDesTypesDeRelation = function (a) {
	return {$: 270, a: a};
};
var $author$project$Main$Update$LireLesTypesDeRelation = function (a) {
	return {$: 269, a: a};
};
var $author$project$Main$Model$PourLesTypesDeRelation = 52;
var $author$project$Main$Update$depuisLesTypesDeRelation = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[52]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 1:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesTypesDeRelation)));
			case 2:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesFormesDesTypesDeRelation)));
			case 4:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerAuxTypesDeRelation(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 3:
				var delaiMs = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AttendreAvantDeRelireLesTypesDeRelation(delaiMs)
							])));
			case 5:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIErrorsModel$LibelleDejaUtilise = 0;
var $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$Annuaire = F2(
	function (types, liens) {
		return {nQ: liens, ib: types};
	});
var $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$TypeDeRelation = function (id) {
	return function (reciproque) {
		return function (libelleDirect) {
			return function (libelleInverse) {
				return function (source) {
					return function (cible) {
						return function (formes) {
							return function (archive) {
								return function (utilise) {
									return function (liens) {
										return {tE: archive, vf: cible, zS: formes, Aq: id, Bn: libelleDirect, Bo: libelleInverse, nQ: liens, G6: reciproque, IR: source, Kg: utilise};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$TypeDeRelationId = $elm$core$Basics$identity;
var $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$Cote = F3(
	function (personnesPro, personnesParticulieres, organisations) {
		return {o3: organisations, hr: personnesParticulieres, hs: personnesPro};
	});
var $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$Aucune = {$: 0};
var $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$Certaines = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$FormeId = $elm$core$Basics$identity;
var $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$Toutes = {$: 1};
var $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$organisationsDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'Toutes',
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$Toutes)),
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$Certaines,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['Certaines', 'formes']),
				$elm$json$Json$Decode$list(
					A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string)))),
			A2(
			$elm$json$Json$Decode$field,
			'Aucune',
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$Aucune))
		]));
var $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$coteDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'organisations',
	$author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$organisationsDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'personnesParticulieres',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'personnesPro',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$Cote))));
var $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$Forme = F3(
	function (id, libelles, archivee) {
		return {tI: archivee, Aq: id, R: libelles};
	});
var $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$Libelles = F2(
	function (fr, en) {
		return {yg: en, zX: fr};
	});
var $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$libellesDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'en',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'fr',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$Libelles)));
var $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$formeDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'archivee',
	$elm$json$Json$Decode$bool,
	false,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'libelles',
		$author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$libellesDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'uid',
			A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string),
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$Forme))));
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt = F4(
	function (path, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder, path, valDecoder, fallback),
			decoder);
	});
var $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$typeDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'utilise',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'archive',
			$elm$json$Json$Decode$bool,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'formes',
				$elm$json$Json$Decode$list($author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$formeDecoder),
				_List_Nil,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
					_List_fromArray(
						['perimetre', 'cible']),
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$coteDecoder),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['perimetre', 'source']),
						$author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$coteDecoder,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'libelleInverse',
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$libellesDecoder),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'libelleDirect',
								$author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$libellesDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'reciproque',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'uid',
										A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string),
										$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$TypeDeRelation)))))))))));
var $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$annuaireDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'types',
		$elm$json$Json$Decode$list($author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$typeDecoder),
		$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$Annuaire)));
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIErrorsModel$AccesRefuse = 4;
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIErrorsModel$AutreRefus = 5;
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIErrorsModel$LibelleInverseObligatoire = 2;
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIErrorsModel$TypeArchiveOuInconnu = 3;
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIErrorsModel$TypeUtilise = 1;
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIErrorsModel$duRefus = function (reponse) {
	if (reponse.ri === 403) {
		return 4;
	} else {
		if (reponse.ri === 404) {
			return 3;
		} else {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeString,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['error']),
					$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value)),
				reponse.f$);
			_v0$5:
			while (true) {
				if ((!_v0.$) && _v0.a.b) {
					switch (_v0.a.a.a) {
						case 'LibelleDejaUtilise':
							var _v1 = _v0.a;
							var _v2 = _v1.a;
							return 0;
						case 'TypeDeRelationUtilise':
							var _v3 = _v0.a;
							var _v4 = _v3.a;
							return 1;
						case 'LibelleInverseObligatoire':
							var _v5 = _v0.a;
							var _v6 = _v5.a;
							return 2;
						case 'TypeDeRelationEstArchive':
							var _v7 = _v0.a;
							var _v8 = _v7.a;
							return 3;
						case 'TypeDeRelationInexistant':
							var _v9 = _v0.a;
							var _v10 = _v9.a;
							return 3;
						default:
							break _v0$5;
					}
				} else {
					break _v0$5;
				}
			}
			return 5;
		}
	}
};
var $author$project$Components$Referentiel$TypesDeRelation$Update$duRefus = function (resultat) {
	if (resultat.$ === 1) {
		var refus = resultat.a;
		return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Components$Shared$Messages$Model$duRefus(refus));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$formesDecoder = A2(
	$elm$json$Json$Decode$field,
	'formes',
	$elm$json$Json$Decode$list($author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$formeDecoder));
var $author$project$Components$Referentiel$TypesDeRelation$Update$popMessages = function (msg) {
	switch (msg.$) {
		case 2:
			var reponse = msg.a;
			return $author$project$Components$Referentiel$TypesDeRelation$Update$duRefus(
				A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$annuaireDecoder, reponse));
		case 3:
			var reponse = msg.a;
			return $author$project$Components$Referentiel$TypesDeRelation$Update$duRefus(
				A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$formesDecoder, reponse));
		case 15:
			var reponse = msg.a;
			return (!$author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIErrorsModel$duRefus(reponse)) ? $elm$core$Maybe$Nothing : $author$project$Components$Referentiel$TypesDeRelation$Update$duRefus(
				A2(
					$author$project$API$Reponse$lire,
					$elm$json$Json$Decode$succeed(0),
					reponse));
		case 1:
			var octets = msg.a;
			return _Utils_eq(
				$author$project$API$ProcessUid$depuisOctets(octets),
				$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
				{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Main$Update$requeteSurLesTypesDeRelation = function (effet) {
	switch (effet.$) {
		case 1:
			return true;
		case 4:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$ArchiverLeType = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Referentiel$TypesDeRelation$Update$DemanderProcessUid = {$: 0};
var $author$project$Components$Referentiel$TypesDeRelation$Update$Lire = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$TypesDeRelation$Update$LireLesFormes = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$TypesDeRelation$Model$OuvrirNom = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Referentiel$TypesDeRelation$Update$PlacerFocus = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Referentiel$TypesDeRelation$Update$Reconnecter = {$: 6};
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$RestaurerLeType = function (a) {
	return {$: 4, a: a};
};
var $author$project$API$NavLinksDictionary$archiverLeTypeDeRelation = 'archiver-le-type-de-relation';
var $author$project$Components$Referentiel$TypesDeRelation$Update$AttendreAvantDeRelire = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Referentiel$TypesDeRelation$Model$Doublon = {$: 0};
var $author$project$Components$Referentiel$TypesDeRelation$Model$Libre = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$TypesDeRelation$Model$SensDirect = 0;
var $author$project$Components$Referentiel$TypesDeRelation$Model$SensInverse = 1;
var $author$project$Components$Referentiel$TypesDeRelation$Model$idDuNom = function (sens) {
	if (!sens) {
		return 'type-de-relation-nom-direct';
	} else {
		return 'type-de-relation-nom-inverse';
	}
};
var $author$project$Components$Referentiel$TypesDeRelation$Model$retireLeDoublon = function (refus) {
	return _Utils_eq(
		refus,
		$elm$core$Maybe$Just($author$project$Components$Referentiel$TypesDeRelation$Model$Doublon)) ? $elm$core$Maybe$Nothing : refus;
};
var $author$project$Components$Referentiel$TypesDeRelation$Model$surLeCote = F3(
	function (cote, changer, saisie) {
		if (!cote) {
			return _Utils_update(
				saisie,
				{
					cx: changer(saisie.cx)
				});
		} else {
			return _Utils_update(
				saisie,
				{
					tN: changer(saisie.tN)
				});
		}
	});
var $author$project$Components$Referentiel$TypesDeRelation$Model$saisir = F2(
	function (champ, saisie) {
		switch (champ.$) {
			case 0:
				var reciproque = champ.a;
				return _Utils_update(
					saisie,
					{G6: reciproque});
			case 9:
				var sens = champ.a;
				return _Utils_update(
					saisie,
					{
						bO: $elm$core$Maybe$Just(sens)
					});
			case 10:
				return _Utils_update(
					saisie,
					{eD: true});
			case 1:
				var texte = champ.a;
				return _Utils_update(
					saisie,
					{
						cB: texte,
						pZ: $author$project$Components$Referentiel$TypesDeRelation$Model$retireLeDoublon(saisie.pZ)
					});
			case 2:
				var texte = champ.a;
				return _Utils_update(
					saisie,
					{
						cA: texte,
						pZ: $author$project$Components$Referentiel$TypesDeRelation$Model$retireLeDoublon(saisie.pZ)
					});
			case 3:
				var texte = champ.a;
				return _Utils_update(
					saisie,
					{
						cQ: texte,
						pZ: $author$project$Components$Referentiel$TypesDeRelation$Model$retireLeDoublon(saisie.pZ)
					});
			case 4:
				var texte = champ.a;
				return _Utils_update(
					saisie,
					{
						cP: texte,
						pZ: $author$project$Components$Referentiel$TypesDeRelation$Model$retireLeDoublon(saisie.pZ)
					});
			case 5:
				var cote = champ.a;
				var coche = champ.b;
				return A3(
					$author$project$Components$Referentiel$TypesDeRelation$Model$surLeCote,
					cote,
					function (c) {
						return _Utils_update(
							c,
							{bX: coche});
					},
					saisie);
			case 6:
				var cote = champ.a;
				var coche = champ.b;
				return A3(
					$author$project$Components$Referentiel$TypesDeRelation$Model$surLeCote,
					cote,
					function (c) {
						return _Utils_update(
							c,
							{bS: coche});
					},
					saisie);
			case 7:
				var cote = champ.a;
				var coche = champ.b;
				return A3(
					$author$project$Components$Referentiel$TypesDeRelation$Model$surLeCote,
					cote,
					function (c) {
						return coche ? _Utils_update(
							c,
							{zS: _List_Nil, rO: true}) : _Utils_update(
							c,
							{rO: false});
					},
					saisie);
			default:
				var cote = champ.a;
				var forme = champ.b;
				var coche = champ.c;
				return A3(
					$author$project$Components$Referentiel$TypesDeRelation$Model$surLeCote,
					cote,
					function (c) {
						return _Utils_update(
							c,
							{
								zS: coche ? (A2($elm$core$List$member, forme, c.zS) ? c.zS : _Utils_ap(
									c.zS,
									_List_fromArray(
										[forme]))) : A2(
									$elm$core$List$filter,
									$elm$core$Basics$neq(forme),
									c.zS),
								rO: false
							});
					},
					saisie);
		}
	});
var $author$project$Components$Referentiel$TypesDeRelation$Update$versLesNoms = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				var saisie = model.hP;
				return _Utils_update(
					model,
					{
						DG: drawer,
						hP: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? saisie : _Utils_update(
							saisie,
							{bO: $elm$core$Maybe$Nothing})
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Referentiel$TypesDeRelation$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.DG));
	});
var $author$project$Components$Referentiel$TypesDeRelation$Update$doublonAuRenommage = F2(
	function (type_, model) {
		var saisie = model.hP;
		var sens = (!_Utils_eq(saisie.cB, type_.Bn.zX)) ? 0 : 1;
		return A2(
			$author$project$Components$Referentiel$TypesDeRelation$Update$versLesNoms,
			$author$project$Components$Shared$Drawer$Update$Ouvrir(
				$author$project$Components$Referentiel$TypesDeRelation$Model$idDuNom(sens)),
			_Utils_update(
				model,
				{
					hP: A2(
						$author$project$Components$Referentiel$TypesDeRelation$Model$saisir,
						$author$project$Components$Referentiel$TypesDeRelation$Model$OuvrirNom(sens),
						_Utils_update(
							saisie,
							{
								pZ: $elm$core$Maybe$Just($author$project$Components$Referentiel$TypesDeRelation$Model$Doublon)
							}))
				}));
	});
var $author$project$I18n$Textes$relationRefusAcces = A3($author$project$I18n$Traductions$texte, 'relation.refus.acces', _List_Nil, 'Vous n\'avez pas le droit de paramétrer les types de relation.');
var $author$project$I18n$Textes$relationRefusAutre = A3($author$project$I18n$Traductions$texte, 'relation.refus.autre', _List_Nil, 'L\'enregistrement a échoué. Rien n\'a été modifié.');
var $author$project$I18n$Textes$relationRefusInverseObligatoire = A3($author$project$I18n$Traductions$texte, 'relation.refus.inverse-obligatoire', _List_Nil, 'Ce type s\'exprime dans les deux sens : indiquez le libellé du sens inverse, en français et en anglais, puis enregistrez de nouveau.');
var $author$project$I18n$Textes$relationRefusRejeu = A3($author$project$I18n$Traductions$texte, 'relation.refus.rejeu', _List_Nil, 'Cette saisie n\'a pas été appliquée : ce geste avait déjà servi à une autre commande.');
var $author$project$I18n$Textes$relationRefusUtilise = A3($author$project$I18n$Traductions$texte, 'relation.refus.utilise', _List_Nil, 'Ce type porte des relations : sa réciprocité ne change plus.');
var $author$project$Components$Referentiel$TypesDeRelation$Model$lienDeLecture = function (model) {
	return model.fG ? function (avec) {
		return _Utils_eq(avec, $elm$core$Maybe$Nothing) ? model.np : avec;
	}(
		A2(
			$elm$core$Maybe$andThen,
			function (annuaire) {
				return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$avecLesArchives, annuaire.nQ);
			},
			model.aS)) : model.np;
};
var $author$project$Components$Referentiel$TypesDeRelation$Update$relire = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$TypesDeRelation$Update$Lire, $elm$core$List$singleton),
			$author$project$Components$Referentiel$TypesDeRelation$Model$lienDeLecture(model)));
};
var $author$project$Components$Referentiel$TypesDeRelation$Model$Modification = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$TypesDeRelation$Model$coteSaisi = function (cote) {
	return {
		zS: function () {
			var _v0 = cote.o3;
			if (_v0.$ === 2) {
				var formes = _v0.a;
				return formes;
			} else {
				return _List_Nil;
			}
		}(),
		bS: cote.hr,
		bX: cote.hs,
		rO: _Utils_eq(cote.o3, $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$Toutes)
	};
};
var $author$project$Components$Referentiel$TypesDeRelation$Model$saisieDe = function (type_) {
	var depart = $author$project$Components$Referentiel$TypesDeRelation$Model$coteSaisi(type_.IR);
	return {
		tN: A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$Referentiel$TypesDeRelation$Model$coteVide,
			A2($elm$core$Maybe$map, $author$project$Components$Referentiel$TypesDeRelation$Model$coteSaisi, type_.vf)),
		cx: depart,
		cA: A2($elm$core$Maybe$withDefault, '', type_.Bn.yg),
		cB: type_.Bn.zX,
		cP: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.yg;
				},
				type_.Bo)),
		cQ: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.zX;
				},
				type_.Bo)),
		n9: $author$project$Components$Referentiel$TypesDeRelation$Model$Modification(type_),
		bO: $elm$core$Maybe$Nothing,
		eD: false,
		G6: type_.G6,
		pZ: $elm$core$Maybe$Nothing,
		b5: false
	};
};
var $author$project$Components$Referentiel$TypesDeRelation$Model$enCours = function (saisie) {
	var _v0 = saisie.n9;
	if (!_v0.$) {
		return !_Utils_eq(
			_Utils_update(
				saisie,
				{pZ: $elm$core$Maybe$Nothing, b5: false}),
			$author$project$Components$Referentiel$TypesDeRelation$Model$saisieVide);
	} else {
		var type_ = _v0.a;
		return !_Utils_eq(
			_Utils_update(
				saisie,
				{pZ: $elm$core$Maybe$Nothing, b5: false}),
			$author$project$Components$Referentiel$TypesDeRelation$Model$saisieDe(type_));
	}
};
var $author$project$Components$Referentiel$TypesDeRelation$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{kX: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Referentiel$TypesDeRelation$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Referentiel$TypesDeRelation$Model$enCours(model.hP)
				},
				geste,
				model.kX));
	});
var $author$project$Components$Referentiel$TypesDeRelation$Update$conclure = F2(
	function (issue, model) {
		var saisie = model.hP;
		var refuse = function (message) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						hP: _Utils_update(
							saisie,
							{
								pZ: $elm$core$Maybe$Just(
									$author$project$Components$Referentiel$TypesDeRelation$Model$Libre(message))
							}),
						rn: _List_Nil
					}),
				_List_Nil);
		};
		switch (issue.$) {
			case 0:
				if (issue.c) {
					var rendue = issue.b;
					return $elm$core$List$isEmpty(model.rn) ? A2(
						$elm$core$Tuple$mapSecond,
						function (effets) {
							return _Utils_ap(
								effets,
								rendue.sy ? $author$project$Components$Referentiel$TypesDeRelation$Update$relire(model) : _List_fromArray(
									[
										$author$project$Components$Referentiel$TypesDeRelation$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
									]));
						},
						A2(
							$author$project$Components$Referentiel$TypesDeRelation$Update$versLeDrawer,
							$author$project$Components$Shared$Drawer$Update$Fermer,
							_Utils_update(
								model,
								{hP: $author$project$Components$Referentiel$TypesDeRelation$Model$saisieVide}))) : _Utils_Tuple2(model, _List_Nil);
				} else {
					return A2(
						$elm$core$Tuple$mapSecond,
						function (_v1) {
							return $author$project$Components$Referentiel$TypesDeRelation$Update$relire(model);
						},
						refuse($author$project$I18n$Textes$relationRefusRejeu));
				}
			case 1:
				switch (issue.c) {
					case 0:
						var _v2 = issue.c;
						var _v3 = saisie.n9;
						if (_v3.$ === 1) {
							var type_ = _v3.a;
							return A2(
								$author$project$Components$Referentiel$TypesDeRelation$Update$doublonAuRenommage,
								type_,
								_Utils_update(
									model,
									{rn: _List_Nil}));
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										hP: _Utils_update(
											saisie,
											{
												pZ: $elm$core$Maybe$Just($author$project$Components$Referentiel$TypesDeRelation$Model$Doublon)
											}),
										rn: _List_Nil
									}),
								_List_Nil);
						}
					case 1:
						var _v4 = issue.c;
						return A2(
							$elm$core$Tuple$mapSecond,
							function (_v5) {
								return $author$project$Components$Referentiel$TypesDeRelation$Update$relire(model);
							},
							refuse($author$project$I18n$Textes$relationRefusUtilise));
					case 2:
						var _v6 = issue.c;
						return refuse($author$project$I18n$Textes$relationRefusInverseObligatoire);
					case 3:
						var _v7 = issue.c;
						return A2(
							$elm$core$Tuple$mapSecond,
							function (_v8) {
								return $author$project$Components$Referentiel$TypesDeRelation$Update$relire(model);
							},
							refuse($author$project$I18n$Textes$relationRefusAutre));
					case 4:
						var _v9 = issue.c;
						return refuse($author$project$I18n$Textes$relationRefusAcces);
					default:
						var _v10 = issue.c;
						return refuse($author$project$I18n$Textes$relationRefusAutre);
				}
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$creerUnTypeDeRelation = 'creer-un-type-de-relation';
var $author$project$Components$Referentiel$TypesDeRelation$Update$enCours = function (model) {
	return $author$project$API$Envoi$enCours(model.l2);
};
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$CreerUnTypeDeRelation = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$TypesDeRelation$Model$nonVide = function (texte) {
	return $elm$core$String$isEmpty(
		$elm$core$String$trim(texte)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		$elm$core$String$trim(texte));
};
var $author$project$Components$Referentiel$TypesDeRelation$Model$libelles = F2(
	function (fr, en) {
		return $elm$core$String$isEmpty(
			$elm$core$String$trim(fr)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			{
				yg: $author$project$Components$Referentiel$TypesDeRelation$Model$nonVide(en),
				zX: $elm$core$String$trim(fr)
			});
	});
var $author$project$Components$Referentiel$TypesDeRelation$Model$versLeCote = function (c) {
	return {
		o3: c.rO ? $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$Toutes : ($elm$core$List$isEmpty(c.zS) ? $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$Aucune : $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$Certaines(
			A2($elm$core$List$sortBy, $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$formeIdVersTexte, c.zS))),
		hr: c.bS,
		hs: c.bX
	};
};
var $author$project$Components$Referentiel$TypesDeRelation$Model$vide = function (c) {
	return (!c.bX) && ((!c.bS) && ((!c.rO) && $elm$core$List$isEmpty(c.zS)));
};
var $author$project$Components$Referentiel$TypesDeRelation$Model$valide = function (saisie) {
	var _v0 = _Utils_Tuple2(
		A2($author$project$Components$Referentiel$TypesDeRelation$Model$libelles, saisie.cB, saisie.cA),
		A2($author$project$Components$Referentiel$TypesDeRelation$Model$libelles, saisie.cQ, saisie.cP));
	if (!_v0.a.$) {
		var direct = _v0.a.a;
		var inverse = _v0.b;
		return $author$project$Components$Referentiel$TypesDeRelation$Model$vide(saisie.cx) ? $elm$core$Maybe$Nothing : (saisie.G6 ? $elm$core$Maybe$Just(
			{
				vf: $elm$core$Maybe$Nothing,
				xA: direct,
				ng: $elm$core$Maybe$Nothing,
				IR: $author$project$Components$Referentiel$TypesDeRelation$Model$versLeCote(saisie.cx)
			}) : ((_Utils_eq(inverse, $elm$core$Maybe$Nothing) || $author$project$Components$Referentiel$TypesDeRelation$Model$vide(saisie.tN)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			{
				vf: $elm$core$Maybe$Just(
					$author$project$Components$Referentiel$TypesDeRelation$Model$versLeCote(saisie.tN)),
				xA: direct,
				ng: inverse,
				IR: $author$project$Components$Referentiel$TypesDeRelation$Model$versLeCote(saisie.cx)
			})));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$TypesDeRelation$Model$commandeDeCreation = F2(
	function (annuaire, saisie) {
		return A3(
			$elm$core$Maybe$map2,
			F2(
				function (lien, saisi) {
					return _Utils_Tuple2(
						lien,
						$author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$CreerUnTypeDeRelation(
							{vf: saisi.vf, xA: saisi.xA, ng: saisi.ng, G6: saisie.G6, IR: saisi.IR}));
				}),
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUnTypeDeRelation, annuaire.nQ),
			$author$project$Components$Referentiel$TypesDeRelation$Model$valide(saisie));
	});
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$ModifierLaForme = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$RenommerLeType = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$API$NavLinksDictionary$modifierLaFormeDuTypeDeRelation = 'modifier-la-forme-du-type-de-relation';
var $author$project$Components$Referentiel$TypesDeRelation$Model$normalise = function (cote) {
	return _Utils_update(
		cote,
		{
			o3: function () {
				var _v0 = cote.o3;
				if (_v0.$ === 2) {
					var formes = _v0.a;
					return $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$Certaines(
						A2($elm$core$List$sortBy, $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$formeIdVersTexte, formes));
				} else {
					var autre = _v0;
					return autre;
				}
			}()
		});
};
var $author$project$API$NavLinksDictionary$renommerLeTypeDeRelation = 'renommer-le-type-de-relation';
var $author$project$Components$Referentiel$TypesDeRelation$Model$commandesDeModification = F2(
	function (type_, saisie) {
		var _v0 = $author$project$Components$Referentiel$TypesDeRelation$Model$valide(saisie);
		if (_v0.$ === 1) {
			return _List_Nil;
		} else {
			var saisi = _v0.a;
			var renommage = ((!_Utils_eq(saisi.xA, type_.Bn)) || (!_Utils_eq(saisi.ng, type_.Bo))) ? A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					$elm$core$List$singleton,
					A2(
						$elm$core$Maybe$map,
						function (lien) {
							return _Utils_Tuple2(
								lien,
								A3($author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$RenommerLeType, type_.Aq, saisi.xA, saisi.ng));
						},
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$renommerLeTypeDeRelation, type_.nQ)))) : _List_Nil;
			var forme = ((!_Utils_eq(saisie.G6, type_.G6)) || ((!_Utils_eq(
				saisi.IR,
				$author$project$Components$Referentiel$TypesDeRelation$Model$normalise(type_.IR))) || (!_Utils_eq(
				saisi.vf,
				A2($elm$core$Maybe$map, $author$project$Components$Referentiel$TypesDeRelation$Model$normalise, type_.vf))))) ? A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					$elm$core$List$singleton,
					A2(
						$elm$core$Maybe$map,
						function (lien) {
							return _Utils_Tuple2(
								lien,
								A2(
									$author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$ModifierLaForme,
									type_.Aq,
									{vf: saisi.vf, ng: saisi.ng, G6: saisie.G6, IR: saisi.IR}));
						},
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierLaFormeDuTypeDeRelation, type_.nQ)))) : _List_Nil;
			return _Utils_ap(renommage, forme);
		}
	});
var $author$project$Components$Referentiel$TypesDeRelation$Model$estValide = function (saisie) {
	return !_Utils_eq(
		$author$project$Components$Referentiel$TypesDeRelation$Model$valide(saisie),
		$elm$core$Maybe$Nothing);
};
var $author$project$Components$Referentiel$TypesDeRelation$Update$Envoyer = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$attendu = F2(
	function (commande, evenement) {
		var _v0 = _Utils_Tuple2(commande, evenement);
		_v0$6:
		while (true) {
			switch (_v0.b) {
				case 0:
					if (!_v0.a.$) {
						var _v1 = _v0.b;
						return true;
					} else {
						break _v0$6;
					}
				case 1:
					if (_v0.a.$ === 1) {
						var _v2 = _v0.a;
						var _v3 = _v0.b;
						return true;
					} else {
						break _v0$6;
					}
				case 2:
					if (_v0.a.$ === 2) {
						var _v4 = _v0.a;
						var _v5 = _v0.b;
						return true;
					} else {
						break _v0$6;
					}
				case 3:
					if (_v0.a.$ === 3) {
						var _v6 = _v0.b;
						return true;
					} else {
						break _v0$6;
					}
				case 4:
					if (_v0.a.$ === 4) {
						var _v7 = _v0.b;
						return true;
					} else {
						break _v0$6;
					}
				default:
					var _v8 = _v0.b;
					return true;
			}
		}
		return false;
	});
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$repondA = F2(
	function (commande, evenements) {
		return $elm$core$List$isEmpty(evenements) || A2(
			$elm$core$List$any,
			$author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$attendu(commande),
			evenements);
	});
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$ReponseDeCommande = F3(
	function (evenements, liens, vuesAJour) {
		return {mk: evenements, nQ: liens, sy: vuesAJour};
	});
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$EvenementInconnu = 5;
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$FormeChangee = 2;
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$LibelleRenomme = 1;
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$TypeArchive = 3;
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$TypeCree = 0;
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$TypeRestaure = 4;
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$evenementDecoder = A2(
	$elm$json$Json$Decode$map,
	function (paires) {
		_v0$7:
		while (true) {
			if (paires.b) {
				switch (paires.a.a) {
					case 'TypeDeRelationCree':
						var _v1 = paires.a;
						return 0;
					case 'LibelleDirectRenomme':
						var _v2 = paires.a;
						return 1;
					case 'LibelleInverseRenomme':
						var _v3 = paires.a;
						return 1;
					case 'ReciprociteChangee':
						var _v4 = paires.a;
						return 2;
					case 'PerimetreDuTypeDefini':
						var _v5 = paires.a;
						return 2;
					case 'TypeDeRelationArchive':
						var _v6 = paires.a;
						return 3;
					case 'TypeDeRelationRestaure':
						var _v7 = paires.a;
						return 4;
					default:
						break _v0$7;
				}
			} else {
				break _v0$7;
			}
		}
		return 5;
	},
	$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value));
var $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$reponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$ReponseDeCommande,
	A2(
		$elm$json$Json$Decode$field,
		'evenements',
		$elm$json$Json$Decode$list(
			A2($elm$json$Json$Decode$field, 'event', $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$evenementDecoder))),
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		A2($elm$json$Json$Decode$field, 'liens', $author$project$API$Liens$decoder)),
	A2($elm$json$Json$Decode$field, 'vuesAJour', $elm$json$Json$Decode$bool));
var $author$project$Components$Referentiel$TypesDeRelation$Update$reglage = {
	f8: $author$project$Components$Referentiel$TypesDeRelation$Update$DemanderProcessUid,
	l4: $author$project$Components$Referentiel$TypesDeRelation$Update$Envoyer,
	go: $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIErrorsModel$duRefus,
	pW: $author$project$Components$Referentiel$TypesDeRelation$Update$Reconnecter,
	qu: F2(
		function (commande, rendue) {
			return A2($author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$repondA, commande, rendue.mk);
		}),
	qv: $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$reponseDecoder
};
var $author$project$Components$Referentiel$TypesDeRelation$Update$partir = F2(
	function (_v0, model) {
		var lien = _v0.a;
		var commande = _v0.b;
		var _v1 = A4(
			$author$project$API$Envoi$partir,
			$author$project$Components$Referentiel$TypesDeRelation$Update$reglage,
			$elm$core$Maybe$Just(lien),
			commande,
			model.l2);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var envoi = _v2.a;
			var effets = _v2.b;
			var saisie = model.hP;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: envoi,
						hP: _Utils_update(
							saisie,
							{pZ: $elm$core$Maybe$Nothing})
					}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$TypesDeRelation$Model$tenter = function (saisie) {
	return _Utils_update(
		saisie,
		{b5: true});
};
var $author$project$Components$Referentiel$TypesDeRelation$Update$enregistrer = function (model) {
	var envois = function () {
		var _v2 = _Utils_Tuple2(model.hP.n9, model.aS);
		if (!_v2.a.$) {
			if (!_v2.b.$) {
				var _v3 = _v2.a;
				var annuaire = _v2.b.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$elm$core$List$singleton,
						A2($author$project$Components$Referentiel$TypesDeRelation$Model$commandeDeCreation, annuaire, model.hP)));
			} else {
				return _List_Nil;
			}
		} else {
			var type_ = _v2.a.a;
			return A2($author$project$Components$Referentiel$TypesDeRelation$Model$commandesDeModification, type_, model.hP);
		}
	}();
	if (envois.b) {
		var premier = envois.a;
		var reste = envois.b;
		return A2(
			$author$project$Components$Referentiel$TypesDeRelation$Update$partir,
			premier,
			_Utils_update(
				model,
				{rn: reste}));
	} else {
		var _v1 = _Utils_Tuple2(
			model.hP.n9,
			$author$project$Components$Referentiel$TypesDeRelation$Model$estValide(model.hP));
		if ((_v1.a.$ === 1) && _v1.b) {
			return A2(
				$author$project$Components$Referentiel$TypesDeRelation$Update$versLeDrawer,
				$author$project$Components$Shared$Drawer$Update$Fermer,
				_Utils_update(
					model,
					{hP: $author$project$Components$Referentiel$TypesDeRelation$Model$saisieVide}));
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						hP: $author$project$Components$Referentiel$TypesDeRelation$Model$tenter(model.hP)
					}),
				_List_Nil);
		}
	}
};
var $author$project$Components$Referentiel$TypesDeRelation$Update$envoyerLaSuite = function (model) {
	var _v0 = model.rn;
	if (_v0.b) {
		var prochaine = _v0.a;
		var reste = _v0.b;
		var _v1 = model.l2;
		if (_v1.$ === 1) {
			return A2(
				$author$project$Components$Referentiel$TypesDeRelation$Update$partir,
				prochaine,
				_Utils_update(
					model,
					{rn: reste}));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$API$NavLinksDictionary$formesDOrganisation = 'formes-d-organisation';
var $author$project$Components$Referentiel$TypesDeRelation$Model$idDeLaCreation = 'types-de-relation-creer';
var $author$project$Components$Referentiel$TypesDeRelation$Model$idDuModifier = function (id) {
	return 'type-de-relation-modifier-' + $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$typeIdVersTexte(id);
};
var $author$project$Components$Referentiel$TypesDeRelation$Model$modifiable = function (type_) {
	return A2(
		$elm$core$List$any,
		function (rel) {
			return !_Utils_eq(
				A2($author$project$API$Liens$trouver, rel, type_.nQ),
				$elm$core$Maybe$Nothing);
		},
		_List_fromArray(
			[$author$project$API$NavLinksDictionary$renommerLeTypeDeRelation, $author$project$API$NavLinksDictionary$modifierLaFormeDuTypeDeRelation]));
};
var $author$project$Components$Referentiel$TypesDeRelation$Model$ouvert = F2(
	function (lecture, lienDesFormes) {
		return _Utils_update(
			$author$project$Components$Referentiel$TypesDeRelation$Model$init,
			{np: lecture, BE: lienDesFormes});
	});
var $author$project$Components$Referentiel$TypesDeRelation$Update$recevoir = $author$project$API$Envoi$recevoir;
var $author$project$API$NavLinksDictionary$restaurerLeTypeDeRelation = 'restaurer-le-type-de-relation';
var $author$project$Components$Referentiel$TypesDeRelation$Model$trouver = F2(
	function (id, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (annuaire) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (type_) {
							return _Utils_eq(type_.Aq, id);
						},
						annuaire.ib));
			},
			model.aS);
	});
var $author$project$Components$Referentiel$TypesDeRelation$Update$surLeType = F4(
	function (rel, commande, id, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (type_) {
				return A2($author$project$API$Liens$trouver, rel, type_.nQ);
			},
			A2($author$project$Components$Referentiel$TypesDeRelation$Model$trouver, id, model));
		if (!_v0.$) {
			var lien = _v0.a;
			return A2(
				$author$project$Components$Referentiel$TypesDeRelation$Update$partir,
				_Utils_Tuple2(
					lien,
					commande(id)),
				_Utils_update(
					model,
					{rn: _List_Nil}));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$TypesDeRelation$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var liens = msg.a;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$parametrageDesTypesDeRelation, liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					var formes = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$formesDOrganisation, liens);
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$TypesDeRelation$Model$ouvert,
							$elm$core$Maybe$Just(lecture),
							formes),
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Components$Referentiel$TypesDeRelation$Update$DemanderProcessUid,
									$author$project$Components$Referentiel$TypesDeRelation$Update$Lire(lecture)
								]),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$TypesDeRelation$Update$LireLesFormes, $elm$core$List$singleton),
									formes))));
				} else {
					return _Utils_Tuple2(
						A2($author$project$Components$Referentiel$TypesDeRelation$Model$ouvert, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				return $author$project$Components$Referentiel$TypesDeRelation$Update$envoyerLaSuite(
					_Utils_update(
						model,
						{
							l2: A2($author$project$Components$Referentiel$TypesDeRelation$Update$recevoir, octets, model.l2)
						}));
			case 2:
				var reponse = msg.a;
				var _v2 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$annuaireDecoder, reponse);
				if (!_v2.$) {
					var annuaire = _v2.a;
					var _v3 = _Utils_Tuple2(
						model.fG,
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$avecLesArchives, annuaire.nQ));
					if ((!_v3.a) && (!_v3.b.$)) {
						var avec = _v3.b.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									aS: $elm$core$Maybe$Just(annuaire),
									fG: true
								}),
							_List_fromArray(
								[
									$author$project$Components$Referentiel$TypesDeRelation$Update$Lire(avec)
								]));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									aS: $elm$core$Maybe$Just(annuaire)
								}),
							_List_Nil);
					}
				} else {
					var refus = _v2.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Referentiel$TypesDeRelation$Update$Reconnecter]) : _List_Nil);
				}
			case 3:
				var reponse = msg.a;
				var _v4 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$formesDecoder, reponse);
				if (!_v4.$) {
					var formes = _v4.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								zS: A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.tI;
										},
										$elm$core$Basics$not),
									formes)
							}),
						_List_Nil);
				} else {
					var refus = _v4.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Referentiel$TypesDeRelation$Update$Reconnecter]) : _List_Nil);
				}
			case 4:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Referentiel$TypesDeRelation$Update$relire(model));
			case 16:
				var cible = msg.a;
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[
							$author$project$Components$Referentiel$TypesDeRelation$Update$PlacerFocus(cible)
						]));
			case 5:
				var choisies = msg.a;
				var change = _Utils_update(
					model,
					{i$: choisies});
				return _Utils_Tuple2(change, _List_Nil);
			case 6:
				var terme = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{hC: terme}),
					_List_Nil);
			case 7:
				var geste = msg.a;
				return ($author$project$Components$Referentiel$TypesDeRelation$Update$enCours(model) && A2(
					$elm$core$List$member,
					geste,
					_List_fromArray(
						[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$SortieDemandee, $author$project$Components$Shared$Drawer$Update$AbandonConfirme]))) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Referentiel$TypesDeRelation$Update$versLeDrawer, geste, model);
			case 9:
				return _Utils_eq(
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.nQ;
							},
							$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$creerUnTypeDeRelation)),
						model.aS),
					$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A2(
					$author$project$Components$Referentiel$TypesDeRelation$Update$versLeDrawer,
					$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Referentiel$TypesDeRelation$Model$idDeLaCreation),
					_Utils_update(
						model,
						{hP: $author$project$Components$Referentiel$TypesDeRelation$Model$saisieVide}));
			case 10:
				var id = msg.a;
				var _v5 = A2($author$project$Components$Referentiel$TypesDeRelation$Model$trouver, id, model);
				if (!_v5.$) {
					var type_ = _v5.a;
					return $author$project$Components$Referentiel$TypesDeRelation$Model$modifiable(type_) ? A2(
						$author$project$Components$Referentiel$TypesDeRelation$Update$versLeDrawer,
						$author$project$Components$Shared$Drawer$Update$Ouvrir(
							$author$project$Components$Referentiel$TypesDeRelation$Model$idDuModifier(id)),
						_Utils_update(
							model,
							{
								hP: $author$project$Components$Referentiel$TypesDeRelation$Model$saisieDe(type_)
							})) : _Utils_Tuple2(model, _List_Nil);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 8:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$TypesDeRelation$Update$versLesNoms, geste, model);
			case 11:
				if (msg.a.$ === 9) {
					var sens = msg.a.a;
					return A2(
						$author$project$Components$Referentiel$TypesDeRelation$Update$versLesNoms,
						$author$project$Components$Shared$Drawer$Update$Ouvrir(
							$author$project$Components$Referentiel$TypesDeRelation$Model$idDuNom(sens)),
						_Utils_update(
							model,
							{
								hP: A2(
									$author$project$Components$Referentiel$TypesDeRelation$Model$saisir,
									$author$project$Components$Referentiel$TypesDeRelation$Model$OuvrirNom(sens),
									model.hP)
							}));
				} else {
					var champ = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								hP: A2($author$project$Components$Referentiel$TypesDeRelation$Model$saisir, champ, model.hP)
							}),
						_List_Nil);
				}
			case 12:
				return $author$project$Components$Referentiel$TypesDeRelation$Update$enregistrer(model);
			case 13:
				var id = msg.a;
				return A4($author$project$Components$Referentiel$TypesDeRelation$Update$surLeType, $author$project$API$NavLinksDictionary$archiverLeTypeDeRelation, $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$ArchiverLeType, id, model);
			case 14:
				var id = msg.a;
				return A4($author$project$Components$Referentiel$TypesDeRelation$Update$surLeType, $author$project$API$NavLinksDictionary$restaurerLeTypeDeRelation, $author$project$Components$Referentiel$TypesDeRelation$API$WriteAPIModel$RestaurerLeType, id, model);
			default:
				var reponse = msg.a;
				var _v6 = A3($author$project$API$Envoi$conclure, $author$project$Components$Referentiel$TypesDeRelation$Update$reglage, reponse, model.l2);
				if (!_v6.$) {
					var _v7 = _v6.a;
					var envoi = _v7.a;
					var issue = _v7.b;
					var effets = _v7.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Referentiel$TypesDeRelation$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Main$Update$versLesTypesDeRelation = F3(
	function (i18n, msg, model) {
		var _v0 = A2($author$project$Components$Referentiel$TypesDeRelation$Update$update, msg, model.J2);
		var typesDeRelation = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLesTypesDeRelation, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLesTypesDeRelation,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Referentiel$TypesDeRelation$Update$popMessages(msg),
							gardes),
						J2: typesDeRelation
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$changerDEtape = F2(
	function (i18n, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		var _v1 = model.Ih;
		switch (_v1.$) {
			case 6:
				var etape = _v1.a;
				return A3(
					$author$project$Main$Update$ouvrirLeFormulaireDeReference,
					i18n,
					etape,
					A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A3(
							$author$project$Main$Update$versLaStructureDuCatalogue,
							i18n,
							$author$project$Components$Produits$StructureCatalogue$Update$EtapeAffichee(etape),
							model)));
			case 53:
				var etape = _v1.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A3(
						$author$project$Main$Update$versLesDroits,
						i18n,
						$author$project$Components$Parametrage$Droits$Update$EtapeAffichee(etape),
						model));
			case 42:
				switch (_v1.a) {
					case 5:
						var _v2 = _v1.a;
						var uid = _v1.b;
						return A3(
							$author$project$Main$Update$reglerLeTypeDeLAdresse,
							i18n,
							uid,
							function () {
								var _v3 = $author$project$Main$Update$liensDeLaRacine(model);
								if (!_v3.$) {
									var liens = _v3.a;
									return A2(
										$elm$core$Tuple$mapSecond,
										$elm$core$Basics$append(effets),
										A2(
											$author$project$Main$Update$versLaConservation,
											$author$project$Components$Parametrage$Conservation$Update$OuverteSurLesRegles(liens.h0),
											model));
								} else {
									return _Utils_Tuple2(model, effets);
								}
							}());
					case 6:
						var _v4 = _v1.a;
						var uid = _v1.b;
						return A3(
							$author$project$Main$Update$reglerLeTypeDeLAdresse,
							i18n,
							uid,
							function () {
								var _v5 = $author$project$Main$Update$liensDeLaRacine(model);
								if (!_v5.$) {
									var liens = _v5.a;
									return A2(
										$elm$core$Tuple$mapSecond,
										$elm$core$Basics$append(effets),
										A3(
											$author$project$Main$Update$andThenFormes,
											i18n,
											$author$project$Components$Referentiel$Formes$Update$Ouverte(liens.h0),
											A3(
												$author$project$Main$Update$andThenPostes,
												i18n,
												$author$project$Components$Referentiel$Postes$Update$Ouverte(liens.h0),
												A3(
													$author$project$Main$Update$versLesTypesDeRelation,
													i18n,
													$author$project$Components$Referentiel$TypesDeRelation$Update$Ouverte(liens.h0),
													model))));
								} else {
									return _Utils_Tuple2(model, effets);
								}
							}());
					default:
						var uid = _v1.b;
						return A3(
							$author$project$Main$Update$reglerLeTypeDeLAdresse,
							i18n,
							uid,
							_Utils_Tuple2(model, effets));
				}
			default:
				return _Utils_Tuple2(model, effets);
		}
	});
var $author$project$Preferences$Model$setFiltresMasques = F3(
	function (cle, filtresMasques, preferences) {
		return A3(
			$author$project$Preferences$Model$setAnnuaire,
			cle,
			function (gardees) {
				return _Utils_update(
					gardees,
					{mH: filtresMasques});
			},
			preferences);
	});
var $author$project$Main$Update$depuisLaDemonstration = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 2:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			case 0:
				var cle = effet.a;
				var vue = effet.b;
				return A2(
					$author$project$Main$Update$garder,
					A3($author$project$Preferences$Model$setVue, cle, vue, model.eF),
					_Utils_Tuple2(model, effets));
			default:
				var cle = effet.a;
				var masques = effet.b;
				return A2(
					$author$project$Main$Update$garder,
					A3($author$project$Preferences$Model$setFiltresMasques, cle, masques, model.eF),
					_Utils_Tuple2(model, effets));
		}
	});
var $author$project$Components$Socle$Session$Update$DeconnexionDemandee = {$: 9};
var $author$project$Components$Socle$Session$Update$EspaceChoisi = function (a) {
	return {$: 4, a: a};
};
var $author$project$Preferences$Model$setMenuReplie = F2(
	function (menuReplie, preferences) {
		return _Utils_update(
			preferences,
			{Cr: menuReplie});
	});
var $author$project$Main$Update$depuisLaNavigation = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			case 1:
				var replie = effet.a;
				return A2(
					$author$project$Main$Update$garder,
					A2($author$project$Preferences$Model$setMenuReplie, replie, model.eF),
					_Utils_Tuple2(model, effets));
			case 2:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$DeconnexionDemandee, model));
			default:
				var cle = effet.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2(
						$author$project$Main$Update$versLaSession,
						$author$project$Components$Socle$Session$Update$EspaceChoisi(cle),
						model));
		}
	});
var $author$project$Main$Update$memeParcours = F2(
	function (model, arrivee) {
		var _v0 = _Utils_Tuple3(
			model.Ih,
			arrivee,
			$author$project$Main$Update$liensDeLaRacine(model));
		_v0$3:
		while (true) {
			if (!_v0.c.$) {
				switch (_v0.a.$) {
					case 6:
						if (_v0.b.$ === 6) {
							var _v1 = _v0.a;
							var _v2 = _v0.b;
							return true;
						} else {
							break _v0$3;
						}
					case 42:
						if (_v0.b.$ === 42) {
							var _v3 = _v0.a;
							var _v4 = _v0.b;
							return true;
						} else {
							break _v0$3;
						}
					case 53:
						if (_v0.b.$ === 53) {
							return true;
						} else {
							break _v0$3;
						}
					default:
						break _v0$3;
				}
			} else {
				break _v0$3;
			}
		}
		return false;
	});
var $author$project$Referentiel$Normes$accents = _List_fromArray(
	[
		_Utils_Tuple2(
		'a',
		_List_fromArray(
			['\u00E0', '\u00E1', '\u00E2', '\u00E3', '\u00E4', '\u00E5'])),
		_Utils_Tuple2(
		'c',
		_List_fromArray(
			['\u00E7'])),
		_Utils_Tuple2(
		'e',
		_List_fromArray(
			['\u00E8', '\u00E9', '\u00EA', '\u00EB'])),
		_Utils_Tuple2(
		'i',
		_List_fromArray(
			['\u00EC', '\u00ED', '\u00EE', '\u00EF'])),
		_Utils_Tuple2(
		'n',
		_List_fromArray(
			['\u00F1'])),
		_Utils_Tuple2(
		'o',
		_List_fromArray(
			['\u00F2', '\u00F3', '\u00F4', '\u00F5', '\u00F6'])),
		_Utils_Tuple2(
		'u',
		_List_fromArray(
			['\u00F9', '\u00FA', '\u00FB', '\u00FC'])),
		_Utils_Tuple2(
		'y',
		_List_fromArray(
			['\u00FF']))
	]);
var $author$project$Referentiel$Normes$sansAccent = function (lettre) {
	return A2(
		$elm$core$Maybe$withDefault,
		lettre,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$first,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var avec = _v0.b;
						return A2($elm$core$List$member, lettre, avec);
					},
					$author$project$Referentiel$Normes$accents))));
};
var $author$project$Referentiel$Normes$plier = function (texte) {
	return A2(
		$elm$core$String$map,
		$author$project$Referentiel$Normes$sansAccent,
		$elm$core$String$toLower(texte));
};
var $author$project$Referentiel$Normes$trier = $elm$core$List$sortBy(
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.Dj;
		},
		$author$project$Referentiel$Normes$plier));
var $author$project$Referentiel$Normes$avecDevises = F2(
	function (lus, _v0) {
		var normes = _v0;
		return _Utils_update(
			normes,
			{
				ga: $author$project$Referentiel$Normes$trier(
					A2(
						$elm$core$List$map,
						function (devise) {
							return _Utils_update(
								devise,
								{Dj: devise.Dj + (' \u00B7 ' + devise.vx)});
						},
						lus))
			});
	});
var $author$project$Referentiel$Normes$avecLangues = F2(
	function (lus, _v0) {
		var normes = _v0;
		return _Utils_update(
			normes,
			{
				Ba: $author$project$Referentiel$Normes$trier(lus)
			});
	});
var $author$project$Referentiel$Normes$avecPays = F2(
	function (lus, _v0) {
		var normes = _v0;
		return _Utils_update(
			normes,
			{
				ho: $author$project$Referentiel$Normes$trier(lus)
			});
	});
var $author$project$Referentiel$Normes$Entree = F2(
	function (code, nom) {
		return {vx: code, Dj: nom};
	});
var $author$project$Referentiel$Normes$entreesDecoder = A2(
	$elm$json$Json$Decode$field,
	'entrees',
	$elm$json$Json$Decode$list(
		A3(
			$elm$json$Json$Decode$map2,
			$author$project$Referentiel$Normes$Entree,
			A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string))));
var $author$project$Main$Update$normesLues = F4(
	function (i18n, norme, reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Referentiel$Normes$entreesDecoder, reponse);
		if (!_v0.$) {
			var entrees = _v0.a;
			switch (norme) {
				case 0:
					return _Utils_update(
						model,
						{
							hd: A2($author$project$Referentiel$Normes$avecPays, entrees, model.hd)
						});
				case 1:
					return _Utils_update(
						model,
						{
							hd: A2($author$project$Referentiel$Normes$avecLangues, entrees, model.hd)
						});
				default:
					return _Utils_update(
						model,
						{
							hd: A2($author$project$Referentiel$Normes$avecDevises, entrees, model.hd)
						});
			}
		} else {
			var refus = _v0.a;
			return _Utils_update(
				model,
				{
					Ct: A2(
						$author$project$Main$Update$remonter,
						$elm$core$Maybe$Just(
							$author$project$Components$Shared$Messages$Model$duRefus(refus)),
						model.Ct),
					DP: false
				});
		}
	});
var $author$project$Components$Notifications$Update$GabaritsConnus = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Notifications$Update$RacineConnue = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$Alertes$Update$RacineConnue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Alertes$Update$RacineConnue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Doublons$Update$RacineConnue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$Alertes$Effet$Reconnecter = {$: 1};
var $author$project$Main$Update$choisirLOngletDesAlertes = function (_v0) {
	var model = _v0.a;
	var effets = _v0.b;
	if (model.Ee && _Utils_eq(model.Ih, $author$project$Routes$Route$Alertes)) {
		var _v1 = _Utils_Tuple2(model.tb.ys, model.tc.ys);
		if ((!_v1.a.$) && (!_v1.b.$)) {
			var produits = _v1.a.a;
			var partiesPrenantes = _v1.b.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{Ee: false}),
				((!produits) && (partiesPrenantes > 0)) ? _Utils_ap(
					effets,
					_List_fromArray(
						[
							$author$project$Main$Update$RemplacerAdresse($author$project$Routes$Route$adresseAlertesDePartiesPrenantes)
						])) : effets);
		} else {
			return _Utils_Tuple2(model, effets);
		}
	} else {
		return _Utils_Tuple2(model, effets);
	}
};
var $author$project$Main$Update$LireLesAlertes = function (a) {
	return {$: 131, a: a};
};
var $author$project$Main$Update$depuisLesAlertes = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		if (!effet.$) {
			var lien = effet.a;
			return _Utils_Tuple2(
				model,
				_Utils_ap(
					effets,
					A3(
						$author$project$Main$Update$versLApi,
						model,
						lien,
						function (requete) {
							return $author$project$Main$Update$LireLesAlertes(
								{kD: lien.cM, gM: requete.gM, nB: requete.nB});
						})));
		} else {
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Basics$append(effets),
				A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Produits$Alertes$API$QueryAPIModel$Alertes = F6(
	function (alertes, total, ensemble, informations, types, auMoins) {
		return {tb: alertes, tW: auMoins, ys: ensemble, AM: informations, JE: total, ib: types};
	});
var $author$project$Components$Produits$Alertes$API$QueryAPIModel$Alerte = function (reference) {
	return function (code) {
		return function (nom) {
			return function (champ) {
				return function (valeurs) {
					return function (etat) {
						return function (etatLibelle) {
							return function (verrouillee) {
								return function (depuis) {
									return function (liens) {
										return {uN: champ, vx: code, xe: depuis, gt: etat, yR: etatLibelle, nQ: liens, Dj: nom, Hc: reference, Ki: valeurs, KB: verrouillee};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Produits$Alertes$API$QueryAPIModel$alerteDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'depuis',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'verrouillee',
			$elm$json$Json$Decode$bool,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'etatLibelles',
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$Just,
					A2($elm$json$Json$Decode$field, 'fr', $elm$json$Json$Decode$string)),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'etat',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'valeurs',
						$elm$json$Json$Decode$keyValuePairs($author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'champ',
							$author$project$Components$Shared$EditeurDeSchema$Champ$decoder,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'nom',
								A2(
									$elm$json$Json$Decode$map,
									$elm$core$Maybe$Just,
									A2($elm$json$Json$Decode$field, 'fr', $elm$json$Json$Decode$string)),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'code',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Components$Produits$Alertes$API$QueryAPIModel$Alerte)))))))))));
var $author$project$Components$Produits$Alertes$API$QueryAPIModel$Information = F3(
	function (cle, libelle, nombre) {
		return {dy: cle, Bl: libelle, w: nombre};
	});
var $author$project$Components$Produits$Alertes$API$QueryAPIModel$informationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'nombre',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'libelle',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'cle',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$Alertes$API$QueryAPIModel$Information))));
var $author$project$Components$Produits$Alertes$API$QueryAPIModel$TypeEnAlerte = F3(
	function (id, libelle, nombre) {
		return {Aq: id, Bl: libelle, w: nombre};
	});
var $author$project$Components$Produits$Alertes$API$QueryAPIModel$typeEnAlerteDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'nombre',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'libelle',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$Alertes$API$QueryAPIModel$TypeEnAlerte))));
var $author$project$Components$Produits$Alertes$API$QueryAPIModel$alertesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'auMoins',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'types',
		$elm$json$Json$Decode$list($author$project$Components$Produits$Alertes$API$QueryAPIModel$typeEnAlerteDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'informations',
			$elm$json$Json$Decode$list($author$project$Components$Produits$Alertes$API$QueryAPIModel$informationDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'ensemble',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'total',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'alertes',
						$elm$json$Json$Decode$list($author$project$Components$Produits$Alertes$API$QueryAPIModel$alerteDecoder),
						$elm$json$Json$Decode$succeed($author$project$Components$Produits$Alertes$API$QueryAPIModel$Alertes)))))));
var $author$project$Components$Produits$Alertes$Update$popMessages = function (msg) {
	if (msg.$ === 2) {
		var reponse = msg.b;
		var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Alertes$API$QueryAPIModel$alertesDecoder, reponse);
		if (_v1.$ === 1) {
			var refus = _v1.a;
			return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				$author$project$Components$Shared$Messages$Model$duRefus(refus));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$API$NavLinksDictionary$alertesDeProduits = 'alertes-de-produits';
var $author$project$Components$Produits$Alertes$Model$taillePage = 25;
var $author$project$Components$Produits$Alertes$Model$aVoir = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$API$Liens$resoudre(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'page',
					$elm$core$String$fromInt(model.EE)),
					_Utils_Tuple2(
					'taille',
					$elm$core$String$fromInt($author$project$Components$Produits$Alertes$Model$taillePage)),
					_Utils_Tuple2('information', model.AL),
					_Utils_Tuple2('type', model.fh)
				])),
		model.dZ);
};
var $author$project$Components$Produits$Alertes$Model$estCourante = F2(
	function (demandee, model) {
		return _Utils_eq(
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.cM;
				},
				$author$project$Components$Produits$Alertes$Model$aVoir(model)),
			$elm$core$Maybe$Just(demandee));
	});
var $author$project$Components$Produits$Alertes$Effet$Lire = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$Alertes$Update$lire = function (model) {
	var _v0 = $author$project$Components$Produits$Alertes$Model$aVoir(model);
	if (!_v0.$) {
		var lien = _v0.a;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{lV: false}),
			_List_fromArray(
				[
					$author$project$Components$Produits$Alertes$Effet$Lire(lien)
				]));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$Alertes$Update$lueCourante = F2(
	function (reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Alertes$API$QueryAPIModel$alertesDecoder, reponse);
		if (!_v0.$) {
			var lues = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						lV: false,
						ys: $elm$core$Maybe$Just(lues.ys),
						n3: $elm$core$Maybe$Just(lues)
					}),
				_List_Nil);
		} else {
			var refus = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{lV: true}),
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Produits$Alertes$Effet$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Produits$Alertes$Model$ouvert = F2(
	function (gabarit, model) {
		return _Utils_update(
			$author$project$Components$Produits$Alertes$Model$init,
			{ys: model.ys, dZ: gabarit});
	});
var $author$project$Components$Produits$Alertes$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var gabarits = msg.a;
				return $author$project$Components$Produits$Alertes$Update$lire(
					A2(
						$author$project$Components$Produits$Alertes$Model$ouvert,
						A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$alertesDeProduits, gabarits),
						model));
			case 1:
				var gabarits = msg.a;
				return (_Utils_eq(model.dZ, $elm$core$Maybe$Nothing) && _Utils_eq(model.ys, $elm$core$Maybe$Nothing)) ? $author$project$Components$Produits$Alertes$Update$lire(
					_Utils_update(
						model,
						{
							dZ: A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$alertesDeProduits, gabarits)
						})) : _Utils_Tuple2(model, _List_Nil);
			case 2:
				var demandee = msg.a;
				var reponse = msg.b;
				return A2($author$project$Components$Produits$Alertes$Model$estCourante, demandee, model) ? A2($author$project$Components$Produits$Alertes$Update$lueCourante, reponse, model) : _Utils_Tuple2(model, _List_Nil);
			case 3:
				var cle = msg.a;
				return $author$project$Components$Produits$Alertes$Update$lire(
					_Utils_update(
						model,
						{AL: cle, EE: 1}));
			case 4:
				var id = msg.a;
				return $author$project$Components$Produits$Alertes$Update$lire(
					_Utils_update(
						model,
						{EE: 1, fh: id}));
			case 5:
				var page = msg.a;
				return $author$project$Components$Produits$Alertes$Update$lire(
					_Utils_update(
						model,
						{
							EE: A2($elm$core$Basics$max, 1, page)
						}));
			default:
				return $author$project$Components$Produits$Alertes$Update$lire(model);
		}
	});
var $author$project$Main$Update$versLesAlertes = F3(
	function (i18n, msg, model) {
		var _v0 = A2($author$project$Components$Produits$Alertes$Update$update, msg, model.tb);
		var alertes = _v0.a;
		var effets = _v0.b;
		var gardes = A2(
			$elm$core$List$any,
			$elm$core$Basics$neq($author$project$Components$Produits$Alertes$Effet$Reconnecter),
			effets) ? _List_Nil : model.Ct;
		return $author$project$Main$Update$choisirLOngletDesAlertes(
			A3(
				$elm$core$List$foldl,
				$author$project$Main$Update$depuisLesAlertes,
				_Utils_Tuple2(
					_Utils_update(
						model,
						{
							tb: alertes,
							Ct: A2(
								$author$project$Main$Update$remonter,
								$author$project$Components$Produits$Alertes$Update$popMessages(msg),
								gardes)
						}),
					_List_Nil),
				effets));
	});
var $author$project$Main$Update$andThenAlertes = F3(
	function (i18n, msg, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Basics$append(effets),
			A3($author$project$Main$Update$versLesAlertes, i18n, msg, model));
	});
var $author$project$Components$Referentiel$Alertes$Effet$Reconnecter = {$: 1};
var $author$project$Main$Update$LireLesAlertesDePartiesPrenantes = function (a) {
	return {$: 132, a: a};
};
var $author$project$Main$Update$depuisLesAlertesDePartiesPrenantes = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		if (!effet.$) {
			var lien = effet.a;
			return _Utils_Tuple2(
				model,
				_Utils_ap(
					effets,
					A3(
						$author$project$Main$Update$versLApi,
						model,
						lien,
						function (requete) {
							return $author$project$Main$Update$LireLesAlertesDePartiesPrenantes(
								{kD: lien.cM, gM: requete.gM, nB: requete.nB});
						})));
		} else {
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Basics$append(effets),
				A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Referentiel$Alertes$API$QueryAPIModel$Alertes = F6(
	function (alertes, total, ensemble, informations, types, auMoins) {
		return {tb: alertes, tW: auMoins, ys: ensemble, AM: informations, JE: total, ib: types};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$Active = 0;
var $author$project$Components$Referentiel$Alertes$API$QueryAPIModel$Alerte = F9(
	function (fiche, etat, nom, typeDePartiePrenante, libelleDuType, champ, valeurs, depuis, liens) {
		return {uN: champ, xe: depuis, gt: etat, zo: fiche, nA: libelleDuType, nQ: liens, Dj: nom, JT: typeDePartiePrenante, Ki: valeurs};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$Close = 1;
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$EffacementProgramme = 3;
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$FicheEffacee = 4;
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$Fusionnee = 5;
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$Supprimee = 2;
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$etatDeFiche = function (code) {
	switch (code) {
		case 'Active':
			return $elm$json$Json$Decode$succeed(0);
		case 'Close':
			return $elm$json$Json$Decode$succeed(1);
		case 'Supprimee':
			return $elm$json$Json$Decode$succeed(2);
		case 'EffacementProgramme':
			return $elm$json$Json$Decode$succeed(3);
		case 'Effacee':
			return $elm$json$Json$Decode$succeed(4);
		case 'Fusionnee':
			return $elm$json$Json$Decode$succeed(5);
		default:
			var autre = code;
			return $elm$json$Json$Decode$fail(autre);
	}
};
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$etatDecoder = A2($elm$json$Json$Decode$andThen, $author$project$Components$Referentiel$Common$API$QueryAPIModel$etatDeFiche, $elm$json$Json$Decode$string);
var $author$project$Components$Referentiel$Alertes$API$QueryAPIModel$alerteDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'depuis',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'valeurs',
			$elm$json$Json$Decode$keyValuePairs($author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'champ',
				$author$project$Components$Shared$EditeurDeSchema$Champ$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'libelleDuType',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'typeDePartiePrenante',
						$elm$json$Json$Decode$string,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'nom',
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'etat',
								$author$project$Components$Referentiel$Common$API$QueryAPIModel$etatDecoder,
								0,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'fiche',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Alertes$API$QueryAPIModel$Alerte))))))))));
var $author$project$Components$Referentiel$Alertes$API$QueryAPIModel$Information = F3(
	function (cle, libelle, nombre) {
		return {dy: cle, Bl: libelle, w: nombre};
	});
var $author$project$Components$Referentiel$Alertes$API$QueryAPIModel$informationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'nombre',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'libelle',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'cle',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Alertes$API$QueryAPIModel$Information))));
var $author$project$Components$Referentiel$Alertes$API$QueryAPIModel$TypeEnAlerte = F3(
	function (id, libelle, nombre) {
		return {Aq: id, Bl: libelle, w: nombre};
	});
var $author$project$Components$Referentiel$Alertes$API$QueryAPIModel$typeEnAlerteDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'nombre',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'libelle',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Alertes$API$QueryAPIModel$TypeEnAlerte))));
var $author$project$Components$Referentiel$Alertes$API$QueryAPIModel$alertesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'auMoins',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'types',
		$elm$json$Json$Decode$list($author$project$Components$Referentiel$Alertes$API$QueryAPIModel$typeEnAlerteDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'informations',
			$elm$json$Json$Decode$list($author$project$Components$Referentiel$Alertes$API$QueryAPIModel$informationDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'ensemble',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'total',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'alertes',
						$elm$json$Json$Decode$list($author$project$Components$Referentiel$Alertes$API$QueryAPIModel$alerteDecoder),
						$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Alertes$API$QueryAPIModel$Alertes)))))));
var $author$project$Components$Referentiel$Alertes$Update$popMessages = function (msg) {
	if (msg.$ === 2) {
		var reponse = msg.b;
		var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Alertes$API$QueryAPIModel$alertesDecoder, reponse);
		if (_v1.$ === 1) {
			var refus = _v1.a;
			return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				$author$project$Components$Shared$Messages$Model$duRefus(refus));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$API$NavLinksDictionary$alertesDePartiesPrenantes = 'alertes-de-parties-prenantes';
var $author$project$Components$Referentiel$Alertes$Model$taillePage = 25;
var $author$project$Components$Referentiel$Alertes$Model$aVoir = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$API$Liens$resoudre(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'page',
					$elm$core$String$fromInt(model.EE)),
					_Utils_Tuple2(
					'taille',
					$elm$core$String$fromInt($author$project$Components$Referentiel$Alertes$Model$taillePage)),
					_Utils_Tuple2('information', model.AL),
					_Utils_Tuple2('type', model.JT)
				])),
		model.dZ);
};
var $author$project$Components$Referentiel$Alertes$Model$estCourante = F2(
	function (demandee, model) {
		return _Utils_eq(
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.cM;
				},
				$author$project$Components$Referentiel$Alertes$Model$aVoir(model)),
			$elm$core$Maybe$Just(demandee));
	});
var $author$project$Components$Referentiel$Alertes$Effet$Lire = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$Alertes$Update$lire = function (model) {
	var _v0 = $author$project$Components$Referentiel$Alertes$Model$aVoir(model);
	if (!_v0.$) {
		var lien = _v0.a;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{lV: false}),
			_List_fromArray(
				[
					$author$project$Components$Referentiel$Alertes$Effet$Lire(lien)
				]));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Alertes$Update$lueCourante = F2(
	function (reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Alertes$API$QueryAPIModel$alertesDecoder, reponse);
		if (!_v0.$) {
			var lues = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						lV: false,
						ys: $elm$core$Maybe$Just(lues.ys),
						n3: $elm$core$Maybe$Just(lues)
					}),
				_List_Nil);
		} else {
			var refus = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{lV: true}),
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Referentiel$Alertes$Effet$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Alertes$Model$ouvert = F2(
	function (gabarit, model) {
		return _Utils_update(
			$author$project$Components$Referentiel$Alertes$Model$init,
			{ys: model.ys, dZ: gabarit});
	});
var $author$project$Components$Referentiel$Alertes$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var gabarits = msg.a;
				return $author$project$Components$Referentiel$Alertes$Update$lire(
					A2(
						$author$project$Components$Referentiel$Alertes$Model$ouvert,
						A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$alertesDePartiesPrenantes, gabarits),
						model));
			case 1:
				var gabarits = msg.a;
				return (_Utils_eq(model.dZ, $elm$core$Maybe$Nothing) && _Utils_eq(model.ys, $elm$core$Maybe$Nothing)) ? $author$project$Components$Referentiel$Alertes$Update$lire(
					_Utils_update(
						model,
						{
							dZ: A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$alertesDePartiesPrenantes, gabarits)
						})) : _Utils_Tuple2(model, _List_Nil);
			case 2:
				var demandee = msg.a;
				var reponse = msg.b;
				return A2($author$project$Components$Referentiel$Alertes$Model$estCourante, demandee, model) ? A2($author$project$Components$Referentiel$Alertes$Update$lueCourante, reponse, model) : _Utils_Tuple2(model, _List_Nil);
			case 3:
				var cle = msg.a;
				return $author$project$Components$Referentiel$Alertes$Update$lire(
					_Utils_update(
						model,
						{AL: cle, EE: 1}));
			case 4:
				var id = msg.a;
				return $author$project$Components$Referentiel$Alertes$Update$lire(
					_Utils_update(
						model,
						{EE: 1, JT: id}));
			case 5:
				var page = msg.a;
				return $author$project$Components$Referentiel$Alertes$Update$lire(
					_Utils_update(
						model,
						{
							EE: A2($elm$core$Basics$max, 1, page)
						}));
			default:
				return $author$project$Components$Referentiel$Alertes$Update$lire(model);
		}
	});
var $author$project$Main$Update$versLesAlertesDePartiesPrenantes = F3(
	function (i18n, msg, model) {
		var _v0 = A2($author$project$Components$Referentiel$Alertes$Update$update, msg, model.tc);
		var alertes = _v0.a;
		var effets = _v0.b;
		var gardes = A2(
			$elm$core$List$any,
			$elm$core$Basics$neq($author$project$Components$Referentiel$Alertes$Effet$Reconnecter),
			effets) ? _List_Nil : model.Ct;
		return $author$project$Main$Update$choisirLOngletDesAlertes(
			A3(
				$elm$core$List$foldl,
				$author$project$Main$Update$depuisLesAlertesDePartiesPrenantes,
				_Utils_Tuple2(
					_Utils_update(
						model,
						{
							tc: alertes,
							Ct: A2(
								$author$project$Main$Update$remonter,
								$author$project$Components$Referentiel$Alertes$Update$popMessages(msg),
								gardes)
						}),
					_List_Nil),
				effets));
	});
var $author$project$Main$Update$andThenAlertesDePartiesPrenantes = F3(
	function (i18n, msg, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Basics$append(effets),
			A3($author$project$Main$Update$versLesAlertesDePartiesPrenantes, i18n, msg, model));
	});
var $author$project$Components$Referentiel$Doublons$Effet$Ecarter = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$Main$Update$ExecuterDoublons = function (a) {
	return {$: 27, a: a};
};
var $author$project$Components$Referentiel$Doublons$Effet$LireLaFile = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Doublons$Effet$LireLaPaire = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Referentiel$Doublons$Effet$LireLesEcartees = function (a) {
	return {$: 2, a: a};
};
var $author$project$Main$Model$PourLesDoublons = 34;
var $author$project$Components$Referentiel$Doublons$Effet$Rouvrir = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Main$Update$depuisLesDoublons = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		var sur = F2(
			function (lien, faire) {
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$ExecuterDoublons(
									{
										kD: lien.cM,
										lO: faire(vers.nB),
										gM: vers.gM
									});
							})));
			});
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[34]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 1:
				var lien = effet.a;
				return A2(sur, lien, $author$project$Components$Referentiel$Doublons$Effet$LireLaFile);
			case 2:
				var lien = effet.a;
				return A2(sur, lien, $author$project$Components$Referentiel$Doublons$Effet$LireLesEcartees);
			case 3:
				var lien = effet.a;
				return A2(sur, lien, $author$project$Components$Referentiel$Doublons$Effet$LireLaPaire);
			case 4:
				var lien = effet.a;
				var processUid = effet.b;
				var paires = effet.c;
				return A2(
					sur,
					lien,
					function (resolu) {
						return A3($author$project$Components$Referentiel$Doublons$Effet$Ecarter, resolu, processUid, paires);
					});
			case 5:
				var lien = effet.a;
				var processUid = effet.b;
				var paire = effet.c;
				return A2(
					sur,
					lien,
					function (resolu) {
						return A3($author$project$Components$Referentiel$Doublons$Effet$Rouvrir, resolu, processUid, paire);
					});
			case 6:
				var adresse = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AllerA(adresse)
							])));
			case 7:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Referentiel$Doublons$API$QueryAPIModel$Paires = F5(
	function (paires, total, groupes, ecartees, liens) {
		return {xX: ecartees, Ac: groupes, nQ: liens, EJ: paires, JE: total};
	});
var $author$project$Components$Referentiel$Doublons$API$QueryAPIModel$Groupe = F2(
	function (motif, nombre) {
		return {cX: motif, w: nombre};
	});
var $author$project$Components$Referentiel$Doublons$API$QueryAPIModel$groupe = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Referentiel$Doublons$API$QueryAPIModel$Groupe,
	A2($elm$json$Json$Decode$field, 'motif', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'nombre', $elm$json$Json$Decode$int));
var $author$project$Components$Referentiel$Doublons$API$QueryAPIModel$Paire = F4(
	function (premiere, seconde, motifs, liens) {
		return {nQ: liens, CY: motifs, Gf: premiere, Iv: seconde};
	});
var $author$project$Components$Referentiel$Doublons$API$QueryAPIModel$FicheDeLaPaire = F9(
	function (uid, nature, pays, nom, prenom, raisonSociale, roles, creeeLe, liens) {
		return {wn: creeeLe, nQ: liens, g1: nature, Dj: nom, ho: pays, Gg: prenom, GR: raisonSociale, eX: roles, r8: uid};
	});
var $author$project$Components$Referentiel$Identifiants$entiteUidDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Components$Referentiel$Doublons$API$QueryAPIModel$fiche = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'creeeLe',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'roles',
			$elm$json$Json$Decode$list(
				A2($elm$json$Json$Decode$field, 'libelles', $author$project$Components$Referentiel$Common$API$QueryAPIModel$libellesDecoder)),
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'raisonSociale',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'prenom',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'nom',
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'pays',
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'nature',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'uid',
									$author$project$Components$Referentiel$Identifiants$entiteUidDecoder,
									$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Doublons$API$QueryAPIModel$FicheDeLaPaire))))))))));
var $author$project$Components$Referentiel$Doublons$API$QueryAPIModel$Motif = F2(
	function (motif, valeur) {
		return {cX: motif, fm: valeur};
	});
var $author$project$Components$Referentiel$Doublons$API$QueryAPIModel$motif = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'valeur',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'motif',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Doublons$API$QueryAPIModel$Motif)));
var $author$project$Components$Referentiel$Doublons$API$QueryAPIModel$paire = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'motifs',
		$elm$json$Json$Decode$list($author$project$Components$Referentiel$Doublons$API$QueryAPIModel$motif),
		_List_Nil,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'seconde',
			$author$project$Components$Referentiel$Doublons$API$QueryAPIModel$fiche,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'premiere',
				$author$project$Components$Referentiel$Doublons$API$QueryAPIModel$fiche,
				$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Doublons$API$QueryAPIModel$Paire)))));
var $author$project$Components$Referentiel$Doublons$API$QueryAPIModel$pairesDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'ecartees',
		$elm$json$Json$Decode$int,
		0,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'groupes',
			$elm$json$Json$Decode$list($author$project$Components$Referentiel$Doublons$API$QueryAPIModel$groupe),
			_List_Nil,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'total',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'paires',
					$elm$json$Json$Decode$list($author$project$Components$Referentiel$Doublons$API$QueryAPIModel$paire),
					$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Doublons$API$QueryAPIModel$Paires))))));
var $author$project$Components$Referentiel$Doublons$Update$refusDe = function (resultat) {
	if (resultat.$ === 1) {
		var refus = resultat.a;
		return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Components$Shared$Messages$Model$duRefus(refus));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Doublons$Update$refusDeCommande = function (reponse) {
	var _v0 = A2(
		$author$project$API$Reponse$lire,
		$elm$json$Json$Decode$succeed(0),
		reponse);
	if (_v0.$ === 1) {
		var refus = _v0.a;
		return A2(
			$elm$core$List$member,
			refus.ri,
			_List_fromArray(
				[401, 404, 409])) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Components$Shared$Messages$Model$duRefus(refus));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Doublons$Update$popMessages = function (msg) {
	switch (msg.$) {
		case 2:
			var reponse = msg.b;
			return $author$project$Components$Referentiel$Doublons$Update$refusDe(
				A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Doublons$API$QueryAPIModel$pairesDecoder, reponse));
		case 15:
			var reponse = msg.a;
			return $author$project$Components$Referentiel$Doublons$Update$refusDeCommande(reponse);
		case 17:
			var reponse = msg.a;
			return $author$project$Components$Referentiel$Doublons$Update$refusDeCommande(reponse);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Doublons$Model$Comparee = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Doublons$Effet$DemanderProcessUid = {$: 0};
var $author$project$Components$Referentiel$Doublons$Model$Lecture = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Doublons$Effet$Naviguer = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Referentiel$Doublons$Model$PaireEcartee = 0;
var $author$project$Components$Referentiel$Doublons$Model$PaireRouverte = 2;
var $author$project$Components$Referentiel$Doublons$Model$PairesEcartees = 1;
var $author$project$Components$Referentiel$Doublons$Effet$PlacerFocus = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Referentiel$Doublons$Model$Traitee = {$: 3};
var $author$project$Components$Referentiel$Doublons$Effet$Reconnecter = {$: 8};
var $author$project$Components$Referentiel$Doublons$Update$reconnexion = function (refus) {
	return (refus.ri === 401) ? _List_fromArray(
		[$author$project$Components$Referentiel$Doublons$Effet$Reconnecter]) : _List_Nil;
};
var $author$project$Components$Referentiel$Doublons$Update$compteurLu = F2(
	function (reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Doublons$API$QueryAPIModel$pairesDecoder, reponse);
		if (!_v0.$) {
			var lues = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						fV: $elm$core$Maybe$Just(lues.JE)
					}),
				_List_Nil);
		} else {
			var refus = _v0.a;
			return _Utils_Tuple2(
				model,
				$author$project$Components$Referentiel$Doublons$Update$reconnexion(refus));
		}
	});
var $author$project$API$NavLinksDictionary$ecarterDesPaires = 'ecarter-des-paires';
var $author$project$Components$Referentiel$Doublons$Update$ecrire = F2(
	function (rel, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (lues) {
				return A2($author$project$API$Liens$trouver, rel, lues.nQ);
			},
			model.n3);
	});
var $author$project$Components$Referentiel$Doublons$Model$aVoir = function (model) {
	var _v0 = model.oZ;
	if (!_v0) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'page',
						$elm$core$String$fromInt(model.EE)),
						_Utils_Tuple2(
						'taille',
						$elm$core$String$fromInt(model.Jm)),
						_Utils_Tuple2('motif', model.cX),
						_Utils_Tuple2('nature', model.g1),
						_Utils_Tuple2('terme', model.h3)
					])),
			model.cK);
	} else {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'page',
						$elm$core$String$fromInt(model.EE)),
						_Utils_Tuple2(
						'taille',
						$elm$core$String$fromInt(model.Jm))
					])),
			model.d_);
	}
};
var $author$project$Components$Referentiel$Doublons$Model$estCourante = F2(
	function (demandee, model) {
		return _Utils_eq(
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.cM;
				},
				$author$project$Components$Referentiel$Doublons$Model$aVoir(model)),
			$elm$core$Maybe$Just(demandee));
	});
var $author$project$Components$Referentiel$Doublons$Update$fermer = function (drawer) {
	return _Utils_update(
		drawer,
		{wQ: $elm$core$Maybe$Nothing, gt: 0});
};
var $author$project$Components$Referentiel$Doublons$Update$focus = function (_v0) {
	var cible = _v0;
	return $author$project$Components$Referentiel$Doublons$Effet$PlacerFocus(cible);
};
var $author$project$Components$Referentiel$Doublons$Model$lienDuCompteur = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$API$Liens$resoudre(
			_List_fromArray(
				[
					_Utils_Tuple2('page', '1'),
					_Utils_Tuple2('taille', '25'),
					_Utils_Tuple2('motif', ''),
					_Utils_Tuple2('nature', ''),
					_Utils_Tuple2('terme', '')
				])),
		model.cK);
};
var $author$project$Components$Referentiel$Doublons$Update$lire = function (model) {
	var _v0 = $author$project$Components$Referentiel$Doublons$Model$aVoir(model);
	if (!_v0.$) {
		var lien = _v0.a;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{lV: false}),
			_List_fromArray(
				[
					(!model.oZ) ? $author$project$Components$Referentiel$Doublons$Effet$LireLaFile(lien) : $author$project$Components$Referentiel$Doublons$Effet$LireLesEcartees(lien)
				]));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Doublons$Update$lireEtTirer = function (model) {
	var _v0 = $author$project$Components$Referentiel$Doublons$Update$lire(model);
	var lu = _v0.a;
	var effets = _v0.b;
	return _Utils_Tuple2(
		lu,
		_Utils_ap(
			effets,
			_Utils_eq(model.Gn, $elm$core$Maybe$Nothing) ? _List_fromArray(
				[$author$project$Components$Referentiel$Doublons$Effet$DemanderProcessUid]) : _List_Nil));
};
var $author$project$Components$Referentiel$Doublons$Update$lireLeCompteur = function (model) {
	var _v0 = _Utils_Tuple3(
		model.oZ,
		model.fV,
		$author$project$Components$Referentiel$Doublons$Model$lienDuCompteur(model));
	if (((_v0.a === 1) && (_v0.b.$ === 1)) && (!_v0.c.$)) {
		var _v1 = _v0.a;
		var _v2 = _v0.b;
		var lien = _v0.c.a;
		return _List_fromArray(
			[
				$author$project$Components$Referentiel$Doublons$Effet$LireLaFile(lien)
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Referentiel$Doublons$Update$lireLeRefus = function (model) {
	var _v0 = $author$project$Components$Referentiel$Doublons$Model$aVoir(model);
	if (!_v0.$) {
		var lien = _v0.a;
		return (!model.oZ) ? _List_fromArray(
			[
				$author$project$Components$Referentiel$Doublons$Effet$LireLaFile(lien)
			]) : _List_fromArray(
			[
				$author$project$Components$Referentiel$Doublons$Effet$LireLesEcartees(lien)
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Referentiel$Doublons$Update$sansFiltre = function (model) {
	return (model.cX === '') && ((model.g1 === '') && (model.h3 === ''));
};
var $author$project$Components$Referentiel$Doublons$Update$lueCourante = F2(
	function (reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Doublons$API$QueryAPIModel$pairesDecoder, reponse);
		if (!_v0.$) {
			var lues = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						fV: ((!model.oZ) && $author$project$Components$Referentiel$Doublons$Update$sansFiltre(model)) ? $elm$core$Maybe$Just(lues.JE) : model.fV,
						xX: (!model.oZ) ? $elm$core$Maybe$Just(lues.xX) : $elm$core$Maybe$Just(lues.JE),
						lV: false,
						n3: $elm$core$Maybe$Just(lues)
					}),
				_List_Nil);
		} else {
			var refus = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{lV: true}),
				$author$project$Components$Referentiel$Doublons$Update$reconnexion(refus));
		}
	});
var $author$project$API$NavLinksDictionary$fileDesDoublons = 'file-des-doublons';
var $author$project$API$NavLinksDictionary$pairesEcartees = 'paires-ecartees';
var $author$project$Components$Referentiel$Doublons$Model$ouvert = F3(
	function (onglet, gabarits, model) {
		return _Utils_update(
			$author$project$Components$Referentiel$Doublons$Model$init,
			{
				fV: model.fV,
				xX: model.xX,
				cK: A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$fileDesDoublons, gabarits),
				d_: A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$pairesEcartees, gabarits),
				hd: model.hd,
				oZ: onglet,
				Gn: model.Gn,
				qa: _Utils_eq(
					A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$fileDesDoublons, gabarits),
					$elm$core$Maybe$Nothing)
			});
	});
var $author$project$Components$Referentiel$Doublons$Update$ouvrir = function (drawer) {
	return _Utils_update(
		drawer,
		{gt: 1});
};
var $author$project$API$NavLinksDictionary$paireDeDoublons = 'paire';
var $author$project$Components$Referentiel$Doublons$API$QueryAPIModel$PaireDetaillee = F4(
	function (etat, paire, premiere, seconde) {
		return {gt: etat, EI: paire, Gf: premiere, Iv: seconde};
	});
var $author$project$Components$Referentiel$Doublons$API$QueryAPIModel$Coordonnees = F2(
	function (emails, telephones) {
		return {yd: emails, Jq: telephones};
	});
var $author$project$Components$Referentiel$Doublons$API$QueryAPIModel$coordonnees = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Referentiel$Doublons$API$QueryAPIModel$Coordonnees,
	A2(
		$elm$json$Json$Decode$field,
		'emails',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$field,
		'telephones',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
var $author$project$Components$Referentiel$Doublons$API$QueryAPIModel$paireDetailleeDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Components$Referentiel$Doublons$API$QueryAPIModel$PaireDetaillee,
	A2($elm$json$Json$Decode$field, 'etat', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'paire', $author$project$Components$Referentiel$Doublons$API$QueryAPIModel$paire),
	A2($elm$json$Json$Decode$field, 'premiere', $author$project$Components$Referentiel$Doublons$API$QueryAPIModel$coordonnees),
	A2($elm$json$Json$Decode$field, 'seconde', $author$project$Components$Referentiel$Doublons$API$QueryAPIModel$coordonnees));
var $author$project$API$NavLinksDictionary$rouvrirUnePaire = 'rouvrir-une-paire';
var $author$project$Components$Referentiel$Doublons$Model$Ecartees = 1;
var $author$project$Components$Referentiel$Doublons$Update$suiteDeCommande = F2(
	function (notice, model) {
		var _v0 = $author$project$Components$Referentiel$Doublons$Update$lire(
			_Utils_update(
				model,
				{
					fV: (model.oZ === 1) ? $elm$core$Maybe$Nothing : model.fV,
					j6: $elm$core$Maybe$Nothing,
					bB: $author$project$Components$Referentiel$Doublons$Model$Aucun,
					kX: $author$project$Components$Referentiel$Doublons$Update$fermer(model.kX),
					yj: false,
					Gn: $elm$core$Maybe$Nothing,
					q3: _List_Nil
				}));
		var relu = _v0.a;
		var effets = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				relu,
				{
					oM: $elm$core$Maybe$Just(notice)
				}),
			A2(
				$elm$core$List$cons,
				$author$project$Components$Referentiel$Doublons$Effet$DemanderProcessUid,
				_Utils_ap(
					effets,
					$author$project$Components$Referentiel$Doublons$Update$lireLeCompteur(
						_Utils_update(
							relu,
							{fV: $elm$core$Maybe$Nothing})))));
	});
var $author$project$Components$Referentiel$Doublons$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var onglet = msg.a;
				var gabarits = msg.b;
				var ouverte = A3($author$project$Components$Referentiel$Doublons$Model$ouvert, onglet, gabarits, model);
				return A2(
					$elm$core$Tuple$mapSecond,
					function (effets) {
						return _Utils_ap(
							effets,
							$author$project$Components$Referentiel$Doublons$Update$lireLeCompteur(ouverte));
					},
					$author$project$Components$Referentiel$Doublons$Update$lireEtTirer(ouverte));
			case 1:
				var gabarits = msg.a;
				return (_Utils_eq(model.cK, $elm$core$Maybe$Nothing) && _Utils_eq(model.fV, $elm$core$Maybe$Nothing)) ? $author$project$Components$Referentiel$Doublons$Update$lire(
					A3($author$project$Components$Referentiel$Doublons$Model$ouvert, 0, gabarits, model)) : _Utils_Tuple2(model, _List_Nil);
			case 2:
				var demandee = msg.a;
				var reponse = msg.b;
				return A2($author$project$Components$Referentiel$Doublons$Model$estCourante, demandee, model) ? A2($author$project$Components$Referentiel$Doublons$Update$lueCourante, reponse, model) : (_Utils_eq(
					$elm$core$Maybe$Just(demandee),
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.cM;
						},
						$author$project$Components$Referentiel$Doublons$Model$lienDuCompteur(model))) ? A2($author$project$Components$Referentiel$Doublons$Update$compteurLu, reponse, model) : _Utils_Tuple2(model, _List_Nil));
			case 3:
				var motif = msg.a;
				return $author$project$Components$Referentiel$Doublons$Update$lire(
					_Utils_update(
						model,
						{cX: motif, EE: 1, q3: _List_Nil}));
			case 4:
				var nature = msg.a;
				return $author$project$Components$Referentiel$Doublons$Update$lire(
					_Utils_update(
						model,
						{g1: nature, EE: 1, q3: _List_Nil}));
			case 5:
				var terme = msg.a;
				return $author$project$Components$Referentiel$Doublons$Update$lire(
					_Utils_update(
						model,
						{EE: 1, q3: _List_Nil, h3: terme}));
			case 6:
				var page = msg.a;
				return $author$project$Components$Referentiel$Doublons$Update$lire(
					_Utils_update(
						model,
						{
							EE: A2($elm$core$Basics$max, 1, page),
							q3: _List_Nil
						}));
			case 7:
				var taille = msg.a;
				return $author$project$Components$Referentiel$Doublons$Update$lire(
					_Utils_update(
						model,
						{EE: 1, q3: _List_Nil, Jm: taille}));
			case 8:
				var cle = msg.a;
				var cochee = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							q3: cochee ? A2(
								$elm$core$List$cons,
								cle,
								A2(
									$elm$core$List$filter,
									$elm$core$Basics$neq(cle),
									model.q3)) : A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(cle),
								model.q3)
						}),
					_List_Nil);
			case 9:
				var paire = msg.a;
				var _v1 = A3(
					$author$project$Components$Shared$Drawer$Update$update,
					{Il: false},
					$author$project$Components$Shared$Drawer$Update$Ouvrir(''),
					model.kX);
				var drawer = _v1.a;
				var effetsDuDrawer = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bB: $author$project$Components$Referentiel$Doublons$Model$Lecture(paire),
							kX: drawer,
							oM: $elm$core$Maybe$Nothing
						}),
					_Utils_ap(
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$map,
									$author$project$Components$Referentiel$Doublons$Effet$LireLaPaire,
									A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$paireDeDoublons, paire.nQ))
								])),
						A2($elm$core$List$map, $author$project$Components$Referentiel$Doublons$Update$focus, effetsDuDrawer)));
			case 10:
				var reponse = msg.a;
				var _v2 = _Utils_Tuple2(
					model.bB,
					A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Doublons$API$QueryAPIModel$paireDetailleeDecoder, reponse));
				if (_v2.a.$ === 1) {
					if (!_v2.b.$) {
						var lue = _v2.b.a;
						return ((lue.gt === 'Traitee') || ((lue.gt === 'Ecartee') && (!model.oZ))) ? _Utils_Tuple2(
							_Utils_update(
								model,
								{bB: $author$project$Components$Referentiel$Doublons$Model$Traitee}),
							_List_Nil) : _Utils_Tuple2(
							_Utils_update(
								model,
								{
									bB: A3($author$project$Components$Referentiel$Doublons$Model$Comparee, lue.EI, lue.Gf, lue.Iv)
								}),
							_List_Nil);
					} else {
						var refus = _v2.b.a;
						return ((refus.ri === 404) || (refus.ri === 409)) ? _Utils_Tuple2(
							_Utils_update(
								model,
								{bB: $author$project$Components$Referentiel$Doublons$Model$Traitee}),
							_List_Nil) : _Utils_Tuple2(
							_Utils_update(
								model,
								{
									bB: $author$project$Components$Referentiel$Doublons$Model$Aucun,
									kX: $author$project$Components$Referentiel$Doublons$Update$fermer(model.kX)
								}),
							$author$project$Components$Referentiel$Doublons$Update$reconnexion(refus));
					}
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 11:
				var drawerMsg = msg.a;
				var _v3 = A3(
					$author$project$Components$Shared$Drawer$Update$update,
					{Il: false},
					drawerMsg,
					model.kX);
				var drawer = _v3.a;
				var effetsDuDrawer = _v3.b;
				var detail = (!drawer.gt) ? $author$project$Components$Referentiel$Doublons$Model$Aucun : model.bB;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bB: detail, kX: drawer}),
					A2($elm$core$List$map, $author$project$Components$Referentiel$Doublons$Update$focus, effetsDuDrawer));
			case 12:
				var paires = msg.a;
				return $elm$core$List$isEmpty(paires) ? _Utils_Tuple2(model, _List_Nil) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j6: $elm$core$Maybe$Just(paires)
						}),
					_List_fromArray(
						[
							$author$project$Components$Referentiel$Doublons$Effet$PlacerFocus('confirmation-ecart-confirmer')
						]));
			case 13:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{j6: $elm$core$Maybe$Nothing}),
					_List_Nil);
			case 14:
				var _v4 = _Utils_Tuple3(
					model.j6,
					model.Gn,
					A2($author$project$Components$Referentiel$Doublons$Update$ecrire, $author$project$API$NavLinksDictionary$ecarterDesPaires, model));
				if (((!_v4.a.$) && (!_v4.b.$)) && (!_v4.c.$)) {
					var paires = _v4.a.a;
					var processUid = _v4.b.a;
					var lien = _v4.c.a;
					return model.yj ? _Utils_Tuple2(model, _List_Nil) : _Utils_Tuple2(
						_Utils_update(
							model,
							{yj: true}),
						_List_fromArray(
							[
								A3(
								$author$project$Components$Referentiel$Doublons$Effet$Ecarter,
								lien,
								processUid,
								A2(
									$elm$core$List$map,
									function (p) {
										return {t3: p.Iv.r8, zo: p.Gf.r8};
									},
									paires))
							]));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 15:
				var reponse = msg.a;
				var _v5 = A2(
					$author$project$API$Reponse$lire,
					$elm$json$Json$Decode$succeed(0),
					reponse);
				if (!_v5.$) {
					return A2(
						$author$project$Components$Referentiel$Doublons$Update$suiteDeCommande,
						($elm$core$List$length(
							A2($elm$core$Maybe$withDefault, _List_Nil, model.j6)) > 1) ? 1 : 0,
						model);
				} else {
					var refus = _v5.a;
					return ((refus.ri === 409) || (refus.ri === 404)) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{
								j6: $elm$core$Maybe$Nothing,
								bB: $author$project$Components$Referentiel$Doublons$Model$Traitee,
								kX: $author$project$Components$Referentiel$Doublons$Update$ouvrir(model.kX),
								yj: false,
								Gn: $elm$core$Maybe$Nothing
							}),
						A2(
							$elm$core$List$cons,
							$author$project$Components$Referentiel$Doublons$Effet$DemanderProcessUid,
							$author$project$Components$Referentiel$Doublons$Update$lireLeRefus(model))) : _Utils_Tuple2(
						_Utils_update(
							model,
							{yj: false}),
						$author$project$Components$Referentiel$Doublons$Update$reconnexion(refus));
				}
			case 16:
				var paire = msg.a;
				var _v6 = _Utils_Tuple2(
					model.Gn,
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rouvrirUnePaire, paire.nQ));
				if ((!_v6.a.$) && (!_v6.b.$)) {
					var processUid = _v6.a.a;
					var lien = _v6.b.a;
					return model.yj ? _Utils_Tuple2(model, _List_Nil) : _Utils_Tuple2(
						_Utils_update(
							model,
							{yj: true}),
						_List_fromArray(
							[
								A3(
								$author$project$Components$Referentiel$Doublons$Effet$Rouvrir,
								lien,
								processUid,
								{t3: paire.Iv.r8, zo: paire.Gf.r8})
							]));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 17:
				var reponse = msg.a;
				var _v7 = A2(
					$author$project$API$Reponse$lire,
					$elm$json$Json$Decode$succeed(0),
					reponse);
				if (!_v7.$) {
					return A2($author$project$Components$Referentiel$Doublons$Update$suiteDeCommande, 2, model);
				} else {
					var refus = _v7.a;
					return ((refus.ri === 409) || (refus.ri === 404)) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{j6: $elm$core$Maybe$Nothing, yj: false, Gn: $elm$core$Maybe$Nothing}),
						A2(
							$elm$core$List$cons,
							$author$project$Components$Referentiel$Doublons$Effet$DemanderProcessUid,
							$author$project$Components$Referentiel$Doublons$Update$lireLeRefus(model))) : _Utils_Tuple2(
						_Utils_update(
							model,
							{j6: $elm$core$Maybe$Nothing, yj: false}),
						$author$project$Components$Referentiel$Doublons$Update$reconnexion(refus));
				}
			case 18:
				var paire = msg.a;
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[
							$author$project$Components$Referentiel$Doublons$Effet$Naviguer(
							$author$project$Routes$Route$toString(
								A2($author$project$Routes$Route$FusionDeFiches, paire.Gf.r8, paire.Iv.r8)))
						]));
			case 19:
				var _v8 = $author$project$Components$Referentiel$Doublons$Update$lire(
					_Utils_update(
						model,
						{
							bB: $author$project$Components$Referentiel$Doublons$Model$Aucun,
							kX: $author$project$Components$Referentiel$Doublons$Update$fermer(model.kX),
							q3: _List_Nil
						}));
				var relu = _v8.a;
				var effets = _v8.b;
				return _Utils_Tuple2(relu, effets);
			default:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Gn: $author$project$API$ProcessUid$depuisOctets(octets)
						}),
					_List_Nil);
		}
	});
var $author$project$Main$Update$versLesDoublons = F2(
	function (msg, model) {
		var _v0 = A2(
			$author$project$Components$Referentiel$Doublons$Update$update,
			msg,
			A2(
				$author$project$Referentiel$Normes$poser,
				model.hd,
				$author$project$Components$Referentiel$Doublons$Model$ouvrir(model.xM)));
		var doublons = _v0.a;
		var effets = _v0.b;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLesDoublons,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						xM: $author$project$Components$Referentiel$Doublons$Model$envelopper(doublons),
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Referentiel$Doublons$Update$popMessages(msg),
							model.Ct)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$andThenDoublons = F2(
	function (msg, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Basics$append(effets),
			A2($author$project$Main$Update$versLesDoublons, msg, model));
	});
var $author$project$Main$Update$AttendreAvantDeRelireLesNotifications = function (a) {
	return {$: 267, a: a};
};
var $author$project$Main$Update$AttendreLesNotifications = function (a) {
	return {$: 263, a: a};
};
var $author$project$Main$Update$EnvoyerAuxNotifications = function (a) {
	return {$: 266, a: a};
};
var $author$project$Main$Update$LireLHeureDeLaCloche = {$: 268};
var $author$project$Main$Update$LireLesNotifications = function (a) {
	return {$: 262, a: a};
};
var $author$project$Main$Update$LireLesNotificationsDeFinPourLeGroupe = function (a) {
	return {$: 177, a: a};
};
var $author$project$Main$Update$LireLesTraitementsPourLaCloche = function (a) {
	return {$: 264, a: a};
};
var $author$project$Main$Update$LireUnGroupePourLaCloche = F2(
	function (a, b) {
		return {$: 265, a: a, b: b};
	});
var $author$project$Main$Model$PourLesNotifications = 51;
var $author$project$API$NavLinksDictionary$notifications = 'notifications';
var $author$project$Main$Update$depuisLesNotifications = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[51]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 1:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesNotifications)));
			case 2:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$AttendreLesNotifications)));
			case 6:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesTraitementsPourLaCloche)));
			case 7:
				var groupe = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireUnGroupePourLaCloche(groupe))));
			case 3:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerAuxNotifications(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 8:
				var _v2 = _Utils_Tuple2(
					model.Ih,
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$notifications, model.oN.GN));
				if ((_v2.a.$ === 52) && (!_v2.b.$)) {
					var _v3 = _v2.a;
					var lien = _v2.b.a;
					return _Utils_Tuple2(
						model,
						_Utils_ap(
							effets,
							A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesNotificationsDeFinPourLeGroupe)));
				} else {
					return _Utils_Tuple2(model, effets);
				}
			case 9:
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[$author$project$Main$Update$LireLHeureDeLaCloche])));
			case 4:
				var delaiMs = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AttendreAvantDeRelireLesNotifications(delaiMs)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Notifications$Update$DemanderProcessUid = {$: 0};
var $author$project$Components$Notifications$Update$Lire = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Notifications$Update$Reconnecter = {$: 5};
var $author$project$Components$Notifications$Update$AttendreAvantDeRelire = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Notifications$Update$NotificationLue = {$: 8};
var $author$project$Components$Notifications$Update$relire = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Notifications$Update$Lire, $elm$core$List$singleton),
			model.np));
};
var $author$project$Components$Notifications$Update$conclure = F2(
	function (issue, model) {
		switch (issue.$) {
			case 0:
				var rendue = issue.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{iw: $elm$core$Maybe$Nothing}),
					A2(
						$elm$core$List$cons,
						$author$project$Components$Notifications$Update$NotificationLue,
						rendue.sy ? $author$project$Components$Notifications$Update$relire(model) : _List_fromArray(
							[
								$author$project$Components$Notifications$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
							])));
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{iw: $elm$core$Maybe$Nothing}),
					$author$project$Components$Notifications$Update$relire(model));
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$FicheDeGroupeAPIView = function (uid) {
	return function (nom) {
		return function (description) {
			return function (responsable) {
				return function (sorte) {
					return function (archive) {
						return function (date) {
							return function (membresActifs) {
								return function (membres) {
									return function (filtre) {
										return function (liens) {
											return function (gabarits) {
												return {tE: archive, wv: date, dH: description, zH: filtre, gF: gabarits, nQ: liens, Cm: membres, n5: membresActifs, Dj: nom, qB: responsable, rg: sorte, r8: uid};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$FiltreAPIView = F5(
	function (nature, qualite, pays, rolesOuverts, rolesNonOuverts) {
		return {g1: nature, ho: pays, hy: qualite, Ic: rolesNonOuverts, Id: rolesOuverts};
	});
var $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$filtre = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'rolesNonOuverts',
	$elm$json$Json$Decode$list($author$project$Components$Referentiel$Archetype$decoder),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'rolesOuverts',
		$elm$json$Json$Decode$list($author$project$Components$Referentiel$Archetype$decoder),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'pays',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'qualite',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'nature',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$FiltreAPIView))))));
var $author$project$Components$Referentiel$Identifiants$groupeUidDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$MembreAPIView = F8(
	function (fiche, identite, qualite, pays, depuis, jusquAu, actif, liens) {
		return {sO: actif, xe: depuis, zo: fiche, Av: identite, A4: jusquAu, nQ: liens, ho: pays, hy: qualite};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$FicheLieeAPIView = F4(
	function (uid, identite, etat, types) {
		return {gt: etat, Av: identite, ib: types, r8: uid};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$OrganisationLieeAPIView = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$PersonneLieeAPIView = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$identiteLiee = function (nature) {
	switch (nature) {
		case 'Personne':
			return A3(
				$elm$json$Json$Decode$map2,
				F2(
					function (nom, prenom) {
						return $author$project$Components$Referentiel$Common$API$QueryAPIModel$PersonneLieeAPIView(
							{Dj: nom, Gg: prenom});
					}),
				$elm$json$Json$Decode$maybe(
					A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$maybe(
					A2($elm$json$Json$Decode$field, 'prenom', $elm$json$Json$Decode$string)));
		case 'Organisation':
			return A2(
				$elm$json$Json$Decode$map,
				function (raisonSociale) {
					return $author$project$Components$Referentiel$Common$API$QueryAPIModel$OrganisationLieeAPIView(
						{GR: raisonSociale});
				},
				$elm$json$Json$Decode$maybe(
					A2($elm$json$Json$Decode$field, 'raisonSociale', $elm$json$Json$Decode$string)));
		default:
			return $elm$json$Json$Decode$fail(nature);
	}
};
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$TypeLieAPIView = F4(
	function (uid, libelle, icone, couleur) {
		return {kf: couleur, aC: icone, Bl: libelle, r8: uid};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$typeLie = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'couleur',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'icone',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['libelles', 'fr']),
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'uid',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$TypeLieAPIView)))));
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$ficheLieeDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'types',
	$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$QueryAPIModel$typeLie),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'etat',
		A2($elm$json$Json$Decode$andThen, $author$project$Components$Referentiel$Common$API$QueryAPIModel$etatDeFiche, $elm$json$Json$Decode$string),
		0,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2(
				$elm$json$Json$Decode$andThen,
				$author$project$Components$Referentiel$Common$API$QueryAPIModel$identiteLiee,
				A2($elm$json$Json$Decode$field, 'nature', $elm$json$Json$Decode$string)),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'uid',
				$author$project$Components$Referentiel$Identifiants$entiteUidDecoder,
				$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$FicheLieeAPIView)))));
var $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$membre = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'membreActif',
		$elm$json$Json$Decode$bool,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'jusquAu',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'depuis',
				$elm$json$Json$Decode$string,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'pays',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'qualite',
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'identite',
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Referentiel$Common$API$QueryAPIModel$ficheLieeDecoder),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'fiche',
								$author$project$Components$Referentiel$Identifiants$entiteUidDecoder,
								$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$MembreAPIView)))))))));
var $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$Dynamique = 1;
var $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$Statique = 0;
var $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$sorte = A2(
	$elm$json$Json$Decode$andThen,
	function (code) {
		switch (code) {
			case 'statique':
				return $elm$json$Json$Decode$succeed(0);
			case 'dynamique':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail(code);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$ficheDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.gF;
		},
		$author$project$API$Liens$deLaRessource),
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		A2(
			$elm$json$Json$Decode$map,
			function ($) {
				return $.h0;
			},
			$author$project$API$Liens$deLaRessource),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'filtre',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$filtre),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'membres',
				$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$membre),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'membresActifs',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'date',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'archive',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'sorte',
								$author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$sorte,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'responsable',
									$elm$json$Json$Decode$string,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'description',
										A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
										$elm$core$Maybe$Nothing,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'nom',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'uid',
												$author$project$Components$Referentiel$Identifiants$groupeUidDecoder,
												$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$FicheDeGroupeAPIView)))))))))))));
var $author$project$Components$Notifications$Model$lienDeLecture = $author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$notifications);
var $author$project$Components$Notifications$Update$Attendre = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Notifications$Update$LireUnGroupe = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$groupe = 'groupe';
var $author$project$Components$Notifications$API$QueryAPIModel$TraitementTermine = {$: 1};
var $author$project$Components$Notifications$Model$groupesALire = function (model) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (groupe, vus) {
				return A2($elm$core$List$member, groupe, vus) ? vus : _Utils_ap(
					vus,
					_List_fromArray(
						[groupe]));
			}),
		_List_Nil,
		A2(
			$elm$core$List$filter,
			function (groupe) {
				return !A2($elm$core$Dict$member, groupe, model.DG);
			},
			A2(
				$elm$core$List$map,
				function ($) {
					return $.zo;
				},
				A2(
					$elm$core$List$filter,
					function (notification) {
						return _Utils_eq(notification.g1, $author$project$Components$Notifications$API$QueryAPIModel$TraitementTermine);
					},
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.oN;
							},
							model.nW))))));
};
var $author$project$API$NavLinksDictionary$variableDate = 'date';
var $author$project$Components$Notifications$Update$lireLesNoms = function (model) {
	return A2(
		$elm$core$List$filterMap,
		function (groupe) {
			return A2(
				$elm$core$Maybe$map,
				$author$project$Components$Notifications$Update$LireUnGroupe(groupe),
				A2(
					$elm$core$Maybe$andThen,
					$author$project$API$Liens$resoudre(
						_List_fromArray(
							[
								_Utils_Tuple2($author$project$API$NavLinksDictionary$variableUid, groupe),
								_Utils_Tuple2($author$project$API$NavLinksDictionary$variableDate, '')
							])),
					A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$groupe, model.gF)));
		},
		$author$project$Components$Notifications$Model$groupesALire(model));
};
var $author$project$Components$Notifications$API$QueryAPIModel$Liste = F3(
	function (notifications, nonLues, nouvelles) {
		return {oG: nonLues, oN: notifications, DV: nouvelles};
	});
var $author$project$API$NavLinksDictionary$nouvelles = 'nouvelles';
var $author$project$Components$Notifications$API$QueryAPIModel$lienDesNouvelles = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$nouvelles)),
	$author$project$API$Liens$decoder);
var $author$project$Components$Notifications$API$QueryAPIModel$Notification = F6(
	function (uid, nature, fiche, echeance, lue, liens) {
		return {xY: echeance, zo: fiche, nQ: liens, B1: lue, g1: nature, r8: uid};
	});
var $author$project$Components$Notifications$API$QueryAPIModel$AlerteDeConservation = {$: 0};
var $author$project$Components$Notifications$API$QueryAPIModel$NatureInconnue = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Notifications$API$QueryAPIModel$nature = function (code) {
	switch (code) {
		case 'alerte-de-conservation':
			return $author$project$Components$Notifications$API$QueryAPIModel$AlerteDeConservation;
		case 'traitement-termine':
			return $author$project$Components$Notifications$API$QueryAPIModel$TraitementTermine;
		default:
			var autre = code;
			return $author$project$Components$Notifications$API$QueryAPIModel$NatureInconnue(autre);
	}
};
var $author$project$Components$Notifications$API$QueryAPIModel$notificationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'_links',
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'lue',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'echeance',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'fiche',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'nature',
					A2($elm$json$Json$Decode$map, $author$project$Components$Notifications$API$QueryAPIModel$nature, $elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'uid',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Components$Notifications$API$QueryAPIModel$Notification)))))));
var $author$project$Components$Notifications$API$QueryAPIModel$listeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'_links',
	$author$project$Components$Notifications$API$QueryAPIModel$lienDesNouvelles,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'nonLues',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'notifications',
			$elm$json$Json$Decode$list($author$project$Components$Notifications$API$QueryAPIModel$notificationDecoder),
			$elm$json$Json$Decode$succeed($author$project$Components$Notifications$API$QueryAPIModel$Liste))));
var $author$project$Components$Notifications$Update$lue = F2(
	function (reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Notifications$API$QueryAPIModel$listeDecoder, reponse);
		if (!_v0.$) {
			var liste = _v0.a;
			var attendre = model.lU ? $elm$core$Maybe$Nothing : liste.DV;
			var relue = _Utils_update(
				model,
				{
					gd: false,
					lU: model.lU || (!_Utils_eq(attendre, $elm$core$Maybe$Nothing)),
					nW: $elm$core$Maybe$Just(liste)
				});
			return _Utils_Tuple2(
				relue,
				_Utils_ap(
					model.Es ? $author$project$Components$Notifications$Update$lireLesNoms(relue) : _List_Nil,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $author$project$Components$Notifications$Update$Attendre, $elm$core$List$singleton),
							attendre))));
		} else {
			var refus = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{gd: true}),
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Notifications$Update$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Notifications$API$WriteAPIModel$MarquerCommeLue = 0;
var $author$project$API$NavLinksDictionary$marquerCommeLue = 'marquer-comme-lue';
var $author$project$Components$Notifications$Model$lienDeLaNotification = F2(
	function (model, uid) {
		return A2(
			$elm$core$Maybe$andThen,
			function (notification) {
				return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$marquerCommeLue, notification.nQ);
			},
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.oN;
					},
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$filter(
							function (notification) {
								return _Utils_eq(notification.r8, uid);
							}),
						$elm$core$List$head)),
				model.nW));
	});
var $author$project$Components$Notifications$Update$Envoyer = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Components$Notifications$API$WriteAPIModel$Rendue = F2(
	function (vuesAJour, liens) {
		return {nQ: liens, sy: vuesAJour};
	});
var $author$project$Components$Notifications$API$WriteAPIModel$rendueDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'liens',
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vuesAJour',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Components$Notifications$API$WriteAPIModel$Rendue)));
var $author$project$Components$Notifications$Update$reglage = {
	f8: $author$project$Components$Notifications$Update$DemanderProcessUid,
	l4: $author$project$Components$Notifications$Update$Envoyer,
	go: function (_v0) {
		return 0;
	},
	pW: $author$project$Components$Notifications$Update$Reconnecter,
	qu: F2(
		function (_v1, _v2) {
			return true;
		}),
	qv: $author$project$Components$Notifications$API$WriteAPIModel$rendueDecoder
};
var $author$project$Components$Notifications$Update$marquer = F2(
	function (uid, model) {
		var _v0 = A4(
			$author$project$API$Envoi$partir,
			$author$project$Components$Notifications$Update$reglage,
			A2($author$project$Components$Notifications$Model$lienDeLaNotification, model, uid),
			0,
			model.l2);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var envoi = _v1.a;
			var effets = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						iw: $elm$core$Maybe$Just(uid),
						l2: envoi
					}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Notifications$API$QueryAPIModel$Nouvelles = F3(
	function (notifications, nonLues, suivante) {
		return {oG: nonLues, oN: notifications, I7: suivante};
	});
var $author$project$Components$Notifications$API$QueryAPIModel$nouvellesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'_links',
	$author$project$Components$Notifications$API$QueryAPIModel$lienDesNouvelles,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'nonLues',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'notifications',
			$elm$json$Json$Decode$list($author$project$Components$Notifications$API$QueryAPIModel$notificationDecoder),
			$elm$json$Json$Decode$succeed($author$project$Components$Notifications$API$QueryAPIModel$Nouvelles))));
var $author$project$Components$Notifications$Update$nouvelles = F2(
	function (reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Notifications$API$QueryAPIModel$nouvellesDecoder, reponse);
		if (!_v0.$) {
			var arrivees = _v0.a;
			var arrivee = function (deja) {
				return A2(
					$elm$core$List$any,
					function (nouvelle) {
						return _Utils_eq(nouvelle.r8, deja.r8);
					},
					arrivees.oN);
			};
			var ajoutee = function (liste) {
				return _Utils_update(
					liste,
					{
						oG: arrivees.oG,
						oN: _Utils_ap(
							$elm$core$List$reverse(arrivees.oN),
							A2(
								$elm$core$List$filter,
								A2($elm$core$Basics$composeL, $elm$core$Basics$not, arrivee),
								liste.oN))
					});
			};
			var avecArrivees = _Utils_update(
				model,
				{
					lU: !_Utils_eq(arrivees.I7, $elm$core$Maybe$Nothing),
					nW: A2($elm$core$Maybe$map, ajoutee, model.nW)
				});
			return _Utils_Tuple2(
				avecArrivees,
				_Utils_ap(
					(model.Es && (!$elm$core$List$isEmpty(arrivees.oN))) ? $author$project$Components$Notifications$Update$lireLesNoms(avecArrivees) : _List_Nil,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $author$project$Components$Notifications$Update$Attendre, $elm$core$List$singleton),
							arrivees.I7))));
		} else {
			var refus = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{lU: false}),
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Notifications$Update$Reconnecter]) : _List_fromArray(
					[
						$author$project$Components$Notifications$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
					]));
		}
	});
var $author$project$Components$Notifications$Update$LireLHeure = {$: 9};
var $author$project$Components$Notifications$Update$LireLesTraitements = function (a) {
	return {$: 6, a: a};
};
var $author$project$API$NavLinksDictionary$traitements = 'traitements';
var $author$project$Components$Notifications$Model$lienDesTraitements = function (model) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$traitements, model.GN);
};
var $author$project$Components$Notifications$Update$ouvrir = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{Es: true}),
		A2(
			$elm$core$List$cons,
			$author$project$Components$Notifications$Update$LireLHeure,
			_Utils_ap(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $author$project$Components$Notifications$Update$LireLesTraitements, $elm$core$List$singleton),
						$author$project$Components$Notifications$Model$lienDesTraitements(model))),
				_Utils_ap(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $author$project$Components$Notifications$Update$Lire, $elm$core$List$singleton),
							model.np)),
					$author$project$Components$Notifications$Update$lireLesNoms(model)))));
};
var $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$Traitement = function (uid) {
	return function (etat) {
		return function (groupe) {
			return function (total) {
				return function (traitees) {
					return function (echecs) {
						return function (issue) {
							return function (demandeLe) {
								return function (termineLe) {
									return function (liens) {
										return {w8: demandeLe, x2: echecs, gt: etat, m2: groupe, nh: issue, nQ: liens, Ju: termineLe, JE: total, JN: traitees, r8: uid};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$Demande = 0;
var $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$EnCours = 1;
var $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$Termine = 2;
var $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$etat = A2(
	$elm$json$Json$Decode$andThen,
	function (code) {
		switch (code) {
			case 'demande':
				return $elm$json$Json$Decode$succeed(0);
			case 'en-cours':
				return $elm$json$Json$Decode$succeed(1);
			case 'termine':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail(code);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$EchecPartiel = 1;
var $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$Reussite = 0;
var $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$issue = A2(
	$elm$json$Json$Decode$andThen,
	function (code) {
		switch (code) {
			case 'reussite':
				return $elm$json$Json$Decode$succeed(0);
			case 'echec-partiel':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail(code);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$traitementDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'termineLe',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'demandeLe',
			$elm$json$Json$Decode$string,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'issue',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$issue),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'echecs',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'traitees',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'total',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'groupe',
								$author$project$Components$Referentiel$Identifiants$groupeUidDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'etat',
									$author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$etat,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'uid',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$Traitement)))))))))));
var $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$traitementsDecoder = A2(
	$elm$json$Json$Decode$field,
	'traitements',
	$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$traitementDecoder));
var $author$project$Components$Notifications$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var liens = msg.a;
				var _v1 = $author$project$Components$Notifications$Model$lienDeLecture(liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								gd: false,
								np: $elm$core$Maybe$Just(lecture),
								GN: liens
							}),
						_Utils_ap(
							_Utils_eq(model.l2, $author$project$API$Envoi$SansProcessUid) ? _List_fromArray(
								[$author$project$Components$Notifications$Update$DemanderProcessUid]) : _List_Nil,
							_List_fromArray(
								[
									$author$project$Components$Notifications$Update$Lire(lecture)
								])));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{np: $elm$core$Maybe$Nothing, nW: $elm$core$Maybe$Nothing, GN: liens}),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 2:
				var reponse = msg.a;
				return A2($author$project$Components$Notifications$Update$lue, reponse, model);
			case 3:
				var reponse = msg.a;
				return A2($author$project$Components$Notifications$Update$nouvelles, reponse, model);
			case 4:
				var uid = msg.a;
				return A2($author$project$Components$Notifications$Update$marquer, uid, model);
			case 5:
				var reponse = msg.a;
				var _v2 = A3($author$project$API$Envoi$conclure, $author$project$Components$Notifications$Update$reglage, reponse, model.l2);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var envoi = _v3.a;
					var issue = _v3.b;
					var effets = _v3.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Notifications$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 6:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Notifications$Update$relire(model));
			case 7:
				var gabarits = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gF: gabarits}),
					_List_Nil);
			case 8:
				return model.Es ? _Utils_Tuple2(
					_Utils_update(
						model,
						{Es: false}),
					_List_Nil) : $author$project$Components$Notifications$Update$ouvrir(model);
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Es: false}),
					_List_Nil);
			case 10:
				var uid = msg.a;
				return A2(
					$author$project$Components$Notifications$Update$marquer,
					uid,
					_Utils_update(
						model,
						{Es: false}));
			case 11:
				var reponse = msg.a;
				var _v4 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$traitementsDecoder, reponse);
				if (!_v4.$) {
					var traitements = _v4.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								h9: $elm$core$Maybe$Just(traitements)
							}),
						_List_Nil);
				} else {
					var refus = _v4.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{h9: $elm$core$Maybe$Nothing}),
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Notifications$Update$Reconnecter]) : _List_Nil);
				}
			case 13:
				var maintenant = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							B3: $elm$core$Maybe$Just(maintenant)
						}),
					_List_Nil);
			default:
				var groupe = msg.a;
				var reponse = msg.b;
				var _v5 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$ficheDecoder, reponse);
				if (!_v5.$) {
					var fiche = _v5.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								DG: A3($elm$core$Dict$insert, groupe, fiche.Dj, model.DG)
							}),
						_List_Nil);
				} else {
					var refus = _v5.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Notifications$Update$Reconnecter]) : _List_Nil);
				}
		}
	});
var $author$project$Main$Update$versLesNotifications = F2(
	function (msg, model) {
		var _v0 = A2($author$project$Components$Notifications$Update$update, msg, model.oN);
		var notifications = _v0.a;
		var effets = _v0.b;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLesNotifications,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{oN: notifications}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$andThenNotifications = F2(
	function (msg, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Basics$append(effets),
			A2($author$project$Main$Update$versLesNotifications, msg, model));
	});
var $author$project$Main$Update$LesDevises = 2;
var $author$project$Main$Update$LesLangues = 1;
var $author$project$Main$Update$LesPays = 0;
var $author$project$Main$Update$LireLesNormes = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$referentielNormeDuSysteme = 'referentiel';
var $author$project$Main$Update$demanderLesNormes = F3(
	function (i18n, gabarits, model) {
		if (model.DP) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			if (_Utils_eq(
				A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$referentielNormeDuSysteme, gabarits),
				$elm$core$Maybe$Nothing)) {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Ct: A2(
								$author$project$Main$Update$remonter,
								$elm$core$Maybe$Just(
									{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}),
								model.Ct)
						}),
					_List_Nil);
			} else {
				var lire = F2(
					function (norme, code) {
						return A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (lien) {
									return A3(
										$author$project$Main$Update$versLApi,
										model,
										lien,
										$author$project$Main$Update$LireLesNormes(norme));
								},
								A2(
									$elm$core$Maybe$andThen,
									$author$project$API$Liens$resoudre(
										_List_fromArray(
											[
												_Utils_Tuple2('referentiel', code)
											])),
									A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$referentielNormeDuSysteme, gabarits))));
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{DP: true}),
					_Utils_ap(
						A2(lire, 0, 'pays'),
						_Utils_ap(
							A2(lire, 1, 'langues'),
							A2(lire, 2, 'devises'))));
			}
		}
	});
var $author$project$Components$Produits$Catalogue$Update$ARangerOuverte = function (a) {
	return {$: 41, a: a};
};
var $author$project$Components$Referentiel$Groupe$Update$EquipeOuverte = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Referentiel$Groupes$Update$EquipeOuverte = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$FicheDuChampDemandee = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Update$FicheOuverte = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Fusion$Update$GabaritsConnus = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Update$JournalOuvert = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$FicheType$Update$LienDeLaBibliotheque = function (a) {
	return {$: 49, a: a};
};
var $author$project$Components$Referentiel$Type$Update$LienDeLaBibliotheque = function (a) {
	return {$: 25, a: a};
};
var $author$project$Components$Referentiel$Type$Update$LienDesCollections = function (a) {
	return {$: 27, a: a};
};
var $author$project$Components$Produits$FicheType$Update$LienDesListes = function (a) {
	return {$: 50, a: a};
};
var $author$project$Components$Referentiel$Type$Update$LienDesListes = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$Produits$FicheType$Update$LienDesTypesVises = function (a) {
	return {$: 51, a: a};
};
var $author$project$Components$Produits$Reference$Update$LiensDeDepotRecus = F2(
	function (a, b) {
		return {$: 63, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Update$LiensDesArticlesRecus = F2(
	function (a, b) {
		return {$: 102, a: a, b: b};
	});
var $author$project$Components$Produits$Catalogue$Update$NouvelleReferenceOuverte = {$: 31};
var $author$project$Components$Comptes$Securite$Model$OngletSessions = 1;
var $author$project$Components$Accueil$Update$Ouverte = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Comptes$MonCompte$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Imports$Outil$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$Ouverte = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$Ouverte = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$CompteDEnvoi$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$CompteurDeCode$Update$Ouverte = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$Droits$Update$Ouverte = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$LanguesDuClient$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$ModelesDeTache$Update$Ouverte = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$PipeDestinations$Update$Ouverte = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape3$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape6$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape7$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape8$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeOffreUsage$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeRelationsExigees$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeVersions$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$Pipes$Update$Ouverte = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Produits$Alertes$Update$Ouverte = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$Correspondances$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Produits$FicheElement$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Produits$FicheType$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Produits$ListeDePrix$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Produits$Listes$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Produits$ListesDePrix$Update$Ouverte = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$MarquesEtGammes$Update$Ouverte = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$Offre$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Produits$Offres$Update$Ouverte = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$Perimetres$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Produits$Reference$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Produits$SchemaDeNiveau$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Update$Ouverte = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$TypesDeQuantite$Update$Ouverte = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$Alertes$Update$Ouverte = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$Doublons$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Update$Ouverte = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fusion$Update$Ouverte = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Groupe$Update$Ouverte = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Groupes$Update$Ouverte = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$Ouverte = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Referentiel$Type$Update$Ouverte = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Types$Update$Ouverte = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Imports$Outil$Update$OuverteHistorique = function (a) {
	return {$: 74, a: a};
};
var $author$project$Components$Parametrage$Conservation$Update$OuverteSurLesEcheances = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Imports$Outil$Update$OuverteSurUnLot = F2(
	function (a, b) {
		return {$: 75, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Update$RacineConnue = function (a) {
	return {$: 64, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$RacineConnue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$Offre$Update$RacineLue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$RacineLue = function (a) {
	return {$: 35, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Update$SecuriteOuverte = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Comptes$MonCompte$Update$actionChangerLEmail = 'UPDATE_EMAIL';
var $author$project$Main$Update$enchainer = F2(
	function (suite, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Basics$append(effets),
			suite(model));
	});
var $author$project$API$NavLinksDictionary$groupes = 'groupes';
var $author$project$Components$Referentiel$PartiesPrenantes$Model$idDuDeclencheurDeCreation = 'parties-prenantes-nouvelle-fiche';
var $author$project$Main$Update$nomDuClient = function (model) {
	var _v0 = model.e1.gt;
	if (_v0.$ === 1) {
		var connexion = _v0.a;
		return connexion.g5;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$GabaritsConnus = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$Ouverte = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$VoletOuvert = function (a) {
	return {$: 57, a: a};
};
var $author$project$Main$Update$AjouterLeRoleAuDoublon = F2(
	function (a, b) {
		return {$: 68, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Update$Annoncee = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Fusion$Effet$AttendreAvantDeChercher = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Main$Update$AttendreAvantDeChercherLOrganisation = F2(
	function (a, b) {
		return {$: 73, a: a, b: b};
	});
var $author$project$Main$Update$AttendreAvantDeChercherLesDoublons = F2(
	function (a, b) {
		return {$: 66, a: a, b: b};
	});
var $author$project$Main$Update$AttendreAvantDeChercherPourLaFiche = F2(
	function (a, b) {
		return {$: 51, a: a, b: b};
	});
var $author$project$Main$Update$AttendreAvantDeChercherUnDoublonDeLaFiche = F2(
	function (a, b) {
		return {$: 52, a: a, b: b};
	});
var $author$project$Main$Update$AttendreAvantDeRelire = F2(
	function (a, b) {
		return {$: 29, a: a, b: b};
	});
var $author$project$Main$Update$AttendreAvantDeRelireLaFicheRejouee = F2(
	function (a, b) {
		return {$: 56, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fusion$Effet$ChercherDesFiches = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Main$Update$ChercherDesNommeesDeLaFiche = function (a) {
	return {$: 48, a: a};
};
var $author$project$Main$Update$ChercherDesNommeesDeLaNouvelleFiche = function (a) {
	return {$: 49, a: a};
};
var $author$project$Main$Update$ChercherLOrganisation = function (a) {
	return {$: 74, a: a};
};
var $author$project$Main$Update$ChercherLesDoublons = function (a) {
	return {$: 67, a: a};
};
var $author$project$Main$Update$ChercherPourLaFiche = function (a) {
	return {$: 47, a: a};
};
var $author$project$Main$Update$ChercherUnDoublonDeLaFiche = function (a) {
	return {$: 46, a: a};
};
var $author$project$Main$Update$CloreLaFicheDeLaFiche = function (a) {
	return {$: 35, a: a};
};
var $author$project$Main$Update$CreerLaFiche = function (a) {
	return {$: 24, a: a};
};
var $author$project$Main$Update$EffacerUnContactDeLaFiche = function (a) {
	return {$: 41, a: a};
};
var $author$project$Main$Update$EnvoyerALaLiaisonDeLaFiche = function (a) {
	return {$: 43, a: a};
};
var $author$project$Main$Update$EnvoyerAuContactDeLaFiche = function (a) {
	return {$: 30, a: a};
};
var $author$project$Main$Update$EnvoyerAuRoleDeLaFiche = function (a) {
	return {$: 31, a: a};
};
var $author$project$Main$Update$EnvoyerUnGesteDeLaFiche = function (a) {
	return {$: 34, a: a};
};
var $author$project$Main$Update$ExecuterFusion = function (a) {
	return {$: 26, a: a};
};
var $author$project$Main$Update$ExporterLesDonneesDeLaFiche = function (a) {
	return {$: 39, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$FusionAnnoncee = {$: 1};
var $author$project$Components$Referentiel$Fusion$Effet$Fusionner = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Main$Update$GererUneOccurrenceDeLaFiche = function (a) {
	return {$: 23, a: a};
};
var $author$project$Main$Update$LesFormesDeLaNouvelleFiche = function (a) {
	return {$: 77, a: a};
};
var $author$project$Components$Referentiel$Fusion$Effet$LireFiche = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Main$Update$LireFiche = function (a) {
	return {$: 25, a: a};
};
var $author$project$Main$Update$LireFicheRejouee = function (a) {
	return {$: 55, a: a};
};
var $author$project$Components$Referentiel$Fusion$Effet$LireLApercu = function (a) {
	return {$: 3, a: a};
};
var $author$project$Main$Update$LireLApercuDeLEffacementDeLaFiche = function (a) {
	return {$: 38, a: a};
};
var $author$project$Main$Update$LireLApercuDeLExportDeLaFiche = function (a) {
	return {$: 37, a: a};
};
var $author$project$Main$Update$LireLApercuDeLaClotureDeLaFiche = function (a) {
	return {$: 36, a: a};
};
var $author$project$Components$Referentiel$Fusion$Effet$LireLAvancement = function (a) {
	return {$: 4, a: a};
};
var $author$project$Main$Update$LireLEquipeDeLaNouvelleFiche = F2(
	function (a, b) {
		return {$: 76, a: a, b: b};
	});
var $author$project$Main$Update$LireLHistoriqueDuChampDeLaFiche = function (a) {
	return {$: 54, a: a};
};
var $author$project$Main$Update$LireLaChronologieDeLaFiche = function (a) {
	return {$: 53, a: a};
};
var $author$project$Main$Update$LireLaFicheDeLEtablissement = function (a) {
	return {$: 71, a: a};
};
var $author$project$Main$Update$LireLeDefilementDeLaFiche = {$: 7};
var $author$project$Main$Update$LireLesFormesDeLaFiche = function (a) {
	return {$: 45, a: a};
};
var $author$project$Main$Update$LireLesOffresDeLaCreation = function (a) {
	return {$: 21, a: a};
};
var $author$project$Main$Update$LireLesOffresDeLaFiche = function (a) {
	return {$: 33, a: a};
};
var $author$project$Main$Update$LireLesTypesDeRelationDeLEtablissement = function (a) {
	return {$: 70, a: a};
};
var $author$project$Main$Update$LirePostesDeLaFiche = function (a) {
	return {$: 44, a: a};
};
var $author$project$Main$Update$LirePostesDeLaNouvelleFiche = function (a) {
	return {$: 75, a: a};
};
var $author$project$Main$Update$LireTypes = function (a) {
	return {$: 20, a: a};
};
var $author$project$Main$Update$LireTypesDeLaFiche = function (a) {
	return {$: 32, a: a};
};
var $author$project$Main$Update$LireTypesDeRelationDeLaFiche = function (a) {
	return {$: 50, a: a};
};
var $author$project$Main$Update$ModifierLaFiche = function (a) {
	return {$: 28, a: a};
};
var $author$project$Main$Update$ModifierLeBlocDeLaFiche = function (a) {
	return {$: 22, a: a};
};
var $author$project$Main$Model$PourLaFiche = 3;
var $author$project$Main$Model$PourLaFusion = 33;
var $author$project$Main$Model$PourLaNouvelleFiche = 1;
var $author$project$Main$Update$ProgrammerLEffacementDeLaFiche = function (a) {
	return {$: 42, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$RattachementAnnonce = function (a) {
	return {$: 3, a: a};
};
var $author$project$Main$Update$RelierLEtablissementACreer = function (a) {
	return {$: 72, a: a};
};
var $author$project$Main$Update$RestaurerLaFicheDuDoublon = F2(
	function (a, b) {
		return {$: 69, a: a, b: b};
	});
var $author$project$Main$Update$TelechargerLesFichiers = function (a) {
	return {$: 40, a: a};
};
var $author$project$Components$Referentiel$Fusion$Update$VoletOuvert = F4(
	function (a, b, c, d) {
		return {$: 1, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Referentiel$Common$Rejeu$OrganisationAttendue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Common$Rejeu$PersonneAttendue = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$attendue = function (valide) {
	return {
		vh: valide.vh,
		wa: valide.wa,
		Av: function () {
			var _v0 = valide.Av;
			if (!_v0.$) {
				var saisie = _v0.a;
				return $author$project$Components$Referentiel$Common$Rejeu$PersonneAttendue(
					{
						fI: $author$project$Components$Referentiel$NouvelleFiche$Model$baseLegaleCode(saisie.fI),
						Dj: saisie.Dj,
						ho: saisie.ho,
						Gg: saisie.Gg
					});
			} else {
				var saisie = _v0.a;
				return $author$project$Components$Referentiel$Common$Rejeu$OrganisationAttendue(
					{ho: saisie.ho, GR: saisie.GR});
			}
		}(),
		nn: valide.nn,
		pw: valide.pw,
		hy: A2($elm$core$Maybe$map, $author$project$Components$Referentiel$NouvelleFiche$Model$qualiteCode, valide.hy)
	};
};
var $author$project$Main$Update$modificationDeFiche = function (effet) {
	switch (effet.$) {
		case 8:
			return true;
		case 11:
			return true;
		case 12:
			return true;
		case 17:
			return true;
		case 18:
			return true;
		case 19:
			return true;
		case 23:
			return true;
		case 24:
			return true;
		case 25:
			return true;
		default:
			return false;
	}
};
var $author$project$Main$Update$natureDeLaFiche = function (nature) {
	if (!nature) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$FicheModifieeEntreTemps = {$: 0};
var $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$IdentifiantLegalInvalide = {$: 3};
var $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$PosteArchive = {$: 11};
var $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$RattachementDejaActifSurCePoste = {$: 12};
var $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$RelationDejaExistante = {$: 4};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$CoordonneeLieeAPIView = F3(
	function (organisation, contact, nom) {
		return {v8: contact, Dj: nom, En: organisation};
	});
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$coordonneesLieesDecoder = $elm$json$Json$Decode$list(
	A4(
		$elm$json$Json$Decode$map3,
		$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$CoordonneeLieeAPIView,
		A2($elm$json$Json$Decode$field, 'organisation', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'contact', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string)));
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$apercuDeLEffacementDUnContactDecoder = A2($elm$json$Json$Decode$field, 'coordonneesLiees', $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$coordonneesLieesDecoder);
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ApercuDeLEffacementAPIView = F6(
	function (dateDeLaDemande, delaiEnJours, dateDEffet, seraEfface, restera, coordonneesLiees) {
		return {we: coordonneesLiees, wx: dateDEffet, wy: dateDeLaDemande, kB: delaiEnJours, HU: restera, II: seraEfface};
	});
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$apercuDeLEffacementDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'coordonneesLiees',
	$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$coordonneesLieesDecoder,
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'restera',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'seraEfface',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'dateDEffet',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'delaiEnJours',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'dateDeLaDemande',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ApercuDeLEffacementAPIView)))))));
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ApercuDeLExportAPIView = F2(
	function (dateParDefaut, echeance) {
		return {wB: dateParDefaut, xY: echeance};
	});
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$apercuDeLExportDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ApercuDeLExportAPIView,
	A2($elm$json$Json$Decode$field, 'dateParDefaut', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'echeance', $elm$json$Json$Decode$string));
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ApercuDeLaClotureAPIView = F2(
	function (personnesRattachees, personnesACloreAussi) {
		return {Fh: personnesACloreAussi, Fi: personnesRattachees};
	});
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$apercuDeLaClotureDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ApercuDeLaClotureAPIView,
	A2($elm$json$Json$Decode$field, 'personnesRattachees', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'personnesACloreAussi', $elm$json$Json$Decode$int));
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$AutreFicheAPIView = F2(
	function (uid, nom) {
		return {Dj: nom, r8: uid};
	});
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$autreFiche = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$AutreFicheAPIView,
	A2($elm$json$Json$Decode$field, 'uid', $author$project$Components$Referentiel$Identifiants$entiteUidDecoder),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'raisonSociale', $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$succeed('')
			])));
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$autresFichesDeLIdentifiantDecoder = A2(
	$elm$json$Json$Decode$field,
	'candidats',
	$elm$json$Json$Decode$list($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$autreFiche));
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ChronologieAPIView = F2(
	function (lignes, suivant) {
		return {gV: lignes, I6: suivant};
	});
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$lienDe = function (rel) {
	return A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.h0;
			},
			$author$project$API$Liens$trouver(rel)),
		$author$project$API$Liens$deLaRessource);
};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ChampCiteAPIView = F4(
	function (type_, cle, libelle, retire) {
		return {dy: cle, Bl: libelle, HZ: retire, r0: type_};
	});
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$LigneAPIView = function (date) {
	return function (jour) {
		return function (heure) {
			return function (auteur) {
				return function (source) {
					return function (evenement) {
						return function (champ) {
							return function (champDuType) {
								return function (valeurs) {
									return function (historiqueDuChamp) {
										return function (ficheCitee) {
											return function (offre) {
												return {t1: auteur, uN: champ, uP: champDuType, wv: date, yT: evenement, zp: ficheCitee, Ah: heure, Ak: historiqueDuChamp, A_: jour, D1: offre, IR: source, Ki: valeurs};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$AuteurAPIView = F4(
	function (forme, moi, nom, retire) {
		return {gB: forme, og: moi, Dj: nom, HZ: retire};
	});
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$auteur = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'retire',
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'nom',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'moi',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'forme',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$AuteurAPIView)))));
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$AncienneVersionSupprimee = {$: 32};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ChampModifie = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ClasseExpiree = {$: 35};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ContactAjoute = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ContactEfface = function (a) {
	return {$: 31, a: a};
};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ContactMarque = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ContactPrincipalDesigne = {$: 18};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ContactPrincipalRetire = {$: 19};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ContactRenduPrincipal = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$DonneesExportees = {$: 33};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$DoublonEcarte = {$: 12};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$EffacementAnnule = {$: 29};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$EffacementPlanifie = {$: 28};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$EmpreinteLeveeSurDemande = {$: 34};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$FicheClose = {$: 24};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$FicheCreee = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$FicheRestauree = {$: 27};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$FicheRouverte = {$: 25};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$FicheSupprimee = {$: 26};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$FinDuRattachementModifiee = {$: 15};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$FinDuRoleModifiee = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$FormeDefinie = {$: 23};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$IntituleChange = {$: 17};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$NatureInconnue = function (a) {
	return {$: 36, a: a};
};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$PersonneEffacee = {$: 30};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$PosteChange = {$: 16};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ProspectionReglee = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$RattachementCree = {$: 13};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$RattachementTermine = {$: 14};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$RelationCreee = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$RelationSupprimee = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ResponsableChange = {$: 22};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$RoleFerme = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$RoleOuvert = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$StatutDuRoleChange = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$UsageDuContactModifie = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ValeurDuContactModifiee = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$RelationCiteeAPIView = F4(
	function (relation, type_, direct, libelle) {
		return {xA: direct, Bl: libelle, Ht: relation, r0: type_};
	});
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$facultatif = F2(
	function (nom, decodeur) {
		return A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			nom,
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decodeur),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Components$Referentiel$Identifiants$RelationUid = $elm$core$Basics$identity;
var $author$project$Components$Referentiel$Identifiants$relationUidDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Components$Referentiel$Identifiants$TypeRelationUid = $elm$core$Basics$identity;
var $author$project$Components$Referentiel$Identifiants$typeRelationUidDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$relationCitee = function () {
	var direct = function (sens) {
		switch (sens) {
			case 'Direct':
				return $elm$json$Json$Decode$succeed(true);
			case 'Inverse':
				return $elm$json$Json$Decode$succeed(false);
			default:
				return $elm$json$Json$Decode$fail('sens');
		}
	};
	return A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (citee, libelle) {
				return _Utils_update(
					citee,
					{Bl: libelle});
			}),
		A2(
			$elm$json$Json$Decode$field,
			'objets',
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				$elm$core$Maybe$Nothing,
				A3(
					$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$facultatif,
					'sens',
					A2($elm$json$Json$Decode$andThen, direct, $elm$json$Json$Decode$string),
					A3(
						$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$facultatif,
						'typeDeRelation',
						$author$project$Components$Referentiel$Identifiants$typeRelationUidDecoder,
						A3(
							$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$facultatif,
							'relation',
							$author$project$Components$Referentiel$Identifiants$relationUidDecoder,
							$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$RelationCiteeAPIView)))))),
		$elm$json$Json$Decode$maybe(
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['libelleDeRelation', 'fr']),
				$elm$json$Json$Decode$string)));
}();
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$evenement = function () {
	var cite = F2(
		function (nom, decodeur) {
			return A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['objets', nom]),
				decodeur);
		});
	return A2(
		$elm$json$Json$Decode$andThen,
		function (nature) {
			switch (nature) {
				case 'fiche-creee':
					return A3(
						$elm$json$Json$Decode$map2,
						$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$FicheCreee,
						$elm$json$Json$Decode$maybe(
							A2(cite, 'archetype', $elm$json$Json$Decode$string)),
						$elm$json$Json$Decode$maybe(
							A2(cite, 'typeDeRole', $elm$json$Json$Decode$string)));
				case 'champ-modifie':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ChampModifie,
						A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string));
				case 'contact-ajoute':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ContactAjoute,
						A2(cite, 'canal', $elm$json$Json$Decode$string));
				case 'valeur-du-contact-modifiee':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ValeurDuContactModifiee,
						A2(cite, 'canal', $elm$json$Json$Decode$string));
				case 'usage-du-contact-modifie':
					return A3(
						$elm$json$Json$Decode$map2,
						$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$UsageDuContactModifie,
						A2(cite, 'contact', $elm$json$Json$Decode$string),
						A2(cite, 'usage', $elm$json$Json$Decode$string));
				case 'contact-rendu-principal':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ContactRenduPrincipal,
						A2(cite, 'contact', $elm$json$Json$Decode$string));
				case 'contact-marque':
					return A3(
						$elm$json$Json$Decode$map2,
						$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ContactMarque,
						A2(cite, 'contact', $elm$json$Json$Decode$string),
						A2(cite, 'statut', $elm$json$Json$Decode$string));
				case 'prospection-reglee':
					return A3(
						$elm$json$Json$Decode$map2,
						$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ProspectionReglee,
						A2(cite, 'contact', $elm$json$Json$Decode$string),
						A2(cite, 'prospection', $elm$json$Json$Decode$bool));
				case 'role-ouvert':
					return A3(
						$elm$json$Json$Decode$map2,
						$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$RoleOuvert,
						A2(cite, 'archetype', $elm$json$Json$Decode$string),
						$elm$json$Json$Decode$maybe(
							A2(cite, 'role', $elm$json$Json$Decode$string)));
				case 'role-ferme':
					return A3(
						$elm$json$Json$Decode$map2,
						$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$RoleFerme,
						$elm$json$Json$Decode$maybe(
							A2(cite, 'role', $elm$json$Json$Decode$string)),
						$elm$json$Json$Decode$maybe(
							A2(cite, 'resultat', $elm$json$Json$Decode$string)));
				case 'fin-du-role-modifiee':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$FinDuRoleModifiee,
						$elm$json$Json$Decode$maybe(
							A2(cite, 'role', $elm$json$Json$Decode$string)));
				case 'statut-du-role-change':
					return A3(
						$elm$json$Json$Decode$map2,
						$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$StatutDuRoleChange,
						$elm$json$Json$Decode$maybe(
							A2(cite, 'role', $elm$json$Json$Decode$string)),
						A2(cite, 'statutDuRole', $elm$json$Json$Decode$string));
				case 'doublon-ecarte':
					return $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$DoublonEcarte);
				case 'rattachement-cree':
					return $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$RattachementCree);
				case 'rattachement-termine':
					return $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$RattachementTermine);
				case 'fin-du-rattachement-modifiee':
					return $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$FinDuRattachementModifiee);
				case 'poste-change':
					return $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$PosteChange);
				case 'intitule-change':
					return $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$IntituleChange);
				case 'contact-principal-designe':
					return $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ContactPrincipalDesigne);
				case 'contact-principal-retire':
					return $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ContactPrincipalRetire);
				case 'relation-creee':
					return A2($elm$json$Json$Decode$map, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$RelationCreee, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$relationCitee);
				case 'relation-supprimee':
					return A2($elm$json$Json$Decode$map, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$RelationSupprimee, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$relationCitee);
				case 'responsable-change':
					return $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ResponsableChange);
				case 'forme-definie':
					return $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$FormeDefinie);
				case 'fiche-close':
					return $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$FicheClose);
				case 'fiche-rouverte':
					return $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$FicheRouverte);
				case 'fiche-supprimee':
					return $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$FicheSupprimee);
				case 'fiche-restauree':
					return $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$FicheRestauree);
				case 'effacement-programme':
					return $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$EffacementPlanifie);
				case 'effacement-annule':
					return $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$EffacementAnnule);
				case 'personne-effacee':
					return $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$PersonneEffacee);
				case 'contact-efface':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ContactEfface,
						$elm$json$Json$Decode$maybe(
							A2(cite, 'contact', $elm$json$Json$Decode$string)));
				case 'ancienne-version-supprimee':
					return $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$AncienneVersionSupprimee);
				case 'donnees-exportees':
					return $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$DonneesExportees);
				case 'empreinte-levee-sur-demande':
					return $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$EmpreinteLeveeSurDemande);
				case 'classe-expiree':
					return $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ClasseExpiree);
				default:
					return $elm$json$Json$Decode$succeed(
						$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$NatureInconnue(nature));
			}
		},
		A2($elm$json$Json$Decode$field, 'nature', $elm$json$Json$Decode$string));
}();
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$FicheCiteeAPIView = F5(
	function (uid, nom, prenom, raisonSociale, self) {
		return {Dj: nom, Gg: prenom, GR: raisonSociale, IA: self, r8: uid};
	});
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ficheCitee = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$lienDe($author$project$API$NavLinksDictionary$self),
	A3(
		$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$facultatif,
		'raisonSociale',
		$elm$json$Json$Decode$string,
		A3(
			$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$facultatif,
			'prenom',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$facultatif,
				'nom',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'uid',
					$author$project$Components$Referentiel$Identifiants$entiteUidDecoder,
					$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$FicheCiteeAPIView))))));
var $author$project$API$NavLinksDictionary$historiqueDuChamp = 'historique-du-champ';
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$OffreDuRoleAPIView = F3(
	function (id, nom, arretee) {
		return {tL: arretee, Aq: id, Dj: nom};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$offreDuRoleDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'arretee',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$bool),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'nom',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$OffreDuRoleAPIView))));
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ValeursAPIView = F5(
	function (disponibles, personnel, canal, avant, apres) {
		return {iY: apres, je: avant, uF: canal, xB: disponibles, Fe: personnel};
	});
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$AdresseConnue = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$Citees = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$Connue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$Effacee = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$Vide = {$: 0};
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$AdresseAPIView = F5(
	function (lignes, codePostal, localite, region, pays) {
		return {vz: codePostal, gV: lignes, B_: localite, ho: pays, Hj: region};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$adresseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'pays',
	$elm$json$Json$Decode$string,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'region',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'localite',
			$elm$json$Json$Decode$string,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'codePostal',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'lignes',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
					$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$AdresseAPIView))))));
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$valeur = A2(
	$elm$json$Json$Decode$andThen,
	function (etat) {
		switch (etat) {
			case 'vide':
				return $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$Vide);
			case 'connue':
				return $elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$json$Json$Decode$map,
							$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$Connue,
							A2($elm$json$Json$Decode$field, 'valeur', $elm$json$Json$Decode$string)),
							A2(
							$elm$json$Json$Decode$map,
							$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$AdresseConnue,
							A2($elm$json$Json$Decode$field, 'adresse', $author$project$Components$Referentiel$Common$API$QueryAPIModel$adresseDecoder))
						]));
			case 'effacee':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$Effacee,
					A2($elm$json$Json$Decode$field, 'motif', $elm$json$Json$Decode$string));
			case 'citees':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$Citees,
					A2(
						$elm$json$Json$Decode$field,
						'citees',
						$elm$json$Json$Decode$list(
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string))));
			default:
				return $elm$json$Json$Decode$fail('etat');
		}
	},
	A2($elm$json$Json$Decode$field, 'etat', $elm$json$Json$Decode$string));
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$valeurs = A3(
	$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$facultatif,
	'apres',
	$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$valeur,
	A3(
		$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$facultatif,
		'avant',
		$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$valeur,
		A3(
			$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$facultatif,
			'canal',
			$elm$json$Json$Decode$string,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'personnel',
				$elm$json$Json$Decode$bool,
				false,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'disponibles',
					$elm$json$Json$Decode$bool,
					$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ValeursAPIView))))));
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ligne = A3(
	$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$facultatif,
	'offre',
	$author$project$Components$Referentiel$Common$API$QueryAPIModel$offreDuRoleDecoder,
	A3(
		$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$facultatif,
		'ficheCitee',
		$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ficheCitee,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$lienDe($author$project$API$NavLinksDictionary$historiqueDuChamp),
			A3(
				$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$facultatif,
				'valeurs',
				$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$valeurs,
				A3(
					$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$facultatif,
					'champDuType',
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'retire',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'libelle',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'cle',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'type',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ChampCiteAPIView))))),
					A3(
						$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$facultatif,
						'champ',
						$elm$json$Json$Decode$string,
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$evenement,
							A3(
								$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$facultatif,
								'source',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'auteur',
									$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$auteur,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'heure',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'jour',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'date',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$LigneAPIView)))))))))))));
var $author$project$API$NavLinksDictionary$suivant = 'suivant';
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$chronologieDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$lienDe($author$project$API$NavLinksDictionary$suivant),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'lignes',
		$elm$json$Json$Decode$list($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ligne),
		$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ChronologieAPIView)));
var $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$commandeDeContactDecoder = A2($elm$json$Json$Decode$field, 'vuesAJour', $elm$json$Json$Decode$bool);
var $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$commandeDeLiaisonDecoder = A2($elm$json$Json$Decode$field, 'vuesAJour', $elm$json$Json$Decode$bool);
var $author$project$Components$Referentiel$Common$Rejeu$champsRelus = function (adresse) {
	return _Utils_ap(
		adresse.gV,
		_List_fromArray(
			[
				A2($elm$core$Maybe$withDefault, '', adresse.vz),
				adresse.B_,
				A2($elm$core$Maybe$withDefault, '', adresse.Hj),
				adresse.ho
			]));
};
var $author$project$Components$Referentiel$Common$Rejeu$relu = function (contact) {
	return _Utils_Tuple2(
		_Utils_Tuple3(
			contact.uF,
			_Utils_eq(
				contact.uF,
				$author$project$Components$Referentiel$Common$Contact$canalCode(2)) ? A2($elm$core$Maybe$map, $author$project$Components$Referentiel$Common$Rejeu$champsRelus, contact.aa) : A2($elm$core$Maybe$map, $elm$core$List$singleton, contact.fm),
			contact.sd),
		_Utils_Tuple2(contact.px, contact.Gx));
};
var $author$project$Components$Referentiel$Common$Rejeu$saisi = function (contact) {
	return _Utils_Tuple2(
		_Utils_Tuple3(
			$author$project$Components$Referentiel$Common$Contact$canalCode(contact.uF),
			$elm$core$Maybe$Just(
				(contact.uF === 2) ? _Utils_ap(
					$author$project$Components$Referentiel$Common$Contact$lignesDAdresse(contact.aa),
					_List_fromArray(
						[contact.aa.vz, contact.aa.B_, contact.aa.Hj, contact.aa.ho])) : _List_fromArray(
					[contact.fm])),
			$author$project$Components$Referentiel$Common$Contact$usageCode(contact.sd)),
		_Utils_Tuple2(contact.px, contact.Gx));
};
var $author$project$Components$Referentiel$Common$Rejeu$confirme = F2(
	function (attendue, vue) {
		return _Utils_eq(attendue.hy, vue.hy) && (_Utils_eq(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.r0;
				},
				vue.eX),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $elm$core$List$singleton, attendue.pw))) && (_Utils_eq(
			A2($elm$core$List$map, $author$project$Components$Referentiel$Common$Rejeu$saisi, attendue.wa),
			A2($elm$core$List$map, $author$project$Components$Referentiel$Common$Rejeu$relu, vue.wa)) && (_Utils_eq(attendue.nn, vue.nn) && function () {
			var _v0 = _Utils_Tuple2(attendue.Av, vue.Av);
			_v0$2:
			while (true) {
				if (!_v0.a.$) {
					if (!_v0.b.$) {
						var saisie = _v0.a.a;
						var lue = _v0.b.a;
						return _Utils_eq(
							$elm$core$Maybe$Just(saisie.Dj),
							lue.Dj) && (_Utils_eq(saisie.Gg, lue.Gg) && (_Utils_eq(attendue.vh, lue.vh) && (_Utils_eq(
							$elm$core$Maybe$Just(saisie.ho),
							vue.ho) && _Utils_eq(saisie.fI, lue.fI))));
					} else {
						break _v0$2;
					}
				} else {
					if (_v0.b.$ === 1) {
						var saisie = _v0.a.a;
						var lue = _v0.b.a;
						return _Utils_eq(
							$elm$core$Maybe$Just(saisie.GR),
							lue.GR) && _Utils_eq(
							$elm$core$Maybe$Just(saisie.ho),
							vue.ho);
					} else {
						break _v0$2;
					}
				}
			}
			return false;
		}())));
	});
var $author$project$I18n$Textes$referentielFicheRejeuCorrectionsPerdues = A3($author$project$I18n$Traductions$texte, 'referentiel.fiche.rejeu.corrections-perdues', _List_Nil, 'Cette fiche avait déjà été créée avec votre première saisie. Vos corrections n\'ont pas été appliquées : modifiez la fiche.');
var $author$project$Components$Referentiel$Fiche$Update$correctionsPerdues = F3(
	function (uid, vue, _v0) {
		var de = _v0.a;
		var saisie = _v0.b;
		return (_Utils_eq(de, uid) && (!A2($author$project$Components$Referentiel$Common$Rejeu$confirme, saisie, vue))) ? $elm$core$Maybe$Just(
			{Jx: $author$project$I18n$Textes$referentielFicheRejeuCorrectionsPerdues, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$Autre = {$: 13};
var $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$CategorieHorsPerimetre = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$ChampInconnu = {$: 2};
var $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$Cible = 1;
var $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$EtablissementDejaRattache = {$: 8};
var $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$QualiteDeLaFicheInconnue = {$: 7};
var $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$SirenDifferentDeLaSociete = {$: 10};
var $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$SocieteDejaEtablissement = {$: 9};
var $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$Source = 0;
var $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$TypeDeRelationArchive = {$: 6};
var $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$ValeurInvalide = {$: 1};
var $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$duRefus = function (refus) {
	var _v0 = _Utils_Tuple2(refus.ri, refus.bB);
	_v0$14:
	while (true) {
		switch (_v0.a) {
			case 422:
				switch (_v0.b.$) {
					case 1:
						switch (_v0.b.a) {
							case 'ValeurInvalide':
								return $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$ValeurInvalide;
							case 'ChampInconnu':
								return $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$ChampInconnu;
							case 'IdentifiantLegalInvalide':
								return $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$IdentifiantLegalInvalide;
							default:
								break _v0$14;
						}
					case 2:
						if (_v0.b.a === 'CategorieHorsPerimetre') {
							switch (_v0.b.b) {
								case 'Source':
									var _v1 = _v0.b;
									return $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$CategorieHorsPerimetre(0);
								case 'Cible':
									var _v2 = _v0.b;
									return $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$CategorieHorsPerimetre(1);
								default:
									break _v0$14;
							}
						} else {
							break _v0$14;
						}
					default:
						break _v0$14;
				}
			case 409:
				if (_v0.b.$ === 1) {
					switch (_v0.b.a) {
						case 'FicheModifieeEntreTemps':
							return $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$FicheModifieeEntreTemps;
						case 'RelationDejaExistante':
							return $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$RelationDejaExistante;
						case 'TypeDeRelationArchive':
							return $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$TypeDeRelationArchive;
						case 'QualiteDeLaFicheInconnue':
							return $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$QualiteDeLaFicheInconnue;
						case 'EtablissementDejaRattache':
							return $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$EtablissementDejaRattache;
						case 'SocieteDejaEtablissement':
							return $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$SocieteDejaEtablissement;
						case 'SirenDifferentDeLaSociete':
							return $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$SirenDifferentDeLaSociete;
						case 'PosteArchive':
							return $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$PosteArchive;
						case 'RattachementDejaActifSurCePoste':
							return $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$RattachementDejaActifSurCePoste;
						default:
							break _v0$14;
					}
				} else {
					break _v0$14;
				}
			default:
				break _v0$14;
		}
	}
	return $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$Autre;
};
var $author$project$Components$Referentiel$Fiche$Update$emailDejaSurLaFiche = function (refus) {
	return (refus.ri === 422) && _Utils_eq(
		refus.bB,
		$author$project$API$Reponse$Metier('EmailDejaSurLaFiche'));
};
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$FicheAPIView = function (uid) {
	return function (qualite) {
		return function (forme) {
			return function (pays) {
				return function (identite) {
					return function (langue) {
						return function (identifiantLegal) {
							return function (creeeLe) {
								return function (version) {
									return function (etat) {
										return function (etatLe) {
											return function (roles) {
												return function (contacts) {
													return function (rolesClos) {
														return function (rattachements) {
															return function (relations) {
																return function (decompte) {
																	return function (effacement) {
																		return function (effacee) {
																			return function (champsDesTypes) {
																				return function (doublonsPossibles) {
																					return function (champsModifiables) {
																						return function (fusionneeDans) {
																							return function (fichesFusionnees) {
																								return function (compteUtilisateur) {
																									return function (liens) {
																										return {uW: champsDesTypes, u_: champsModifiables, vZ: compteUtilisateur, wa: contacts, wn: creeeLe, wT: decompte, kW: doublonsPossibles, x6: effacee, x9: effacement, gt: etat, yQ: etatLe, zx: fichesFusionnees, gB: forme, z1: fusionneeDans, m7: identifiantLegal, Av: identite, nn: langue, nQ: liens, ho: pays, hy: qualite, GY: rattachements, Hu: relations, eX: roles, H7: rolesClos, r8: uid, sq: version};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$BlocDesChampsDuTypeAPIView = F6(
	function (type_, versionDuSchema, enCours, champs, choix, collections) {
		return {dw: champs, jN: choix, vE: collections, yj: enCours, r0: type_, KK: versionDuSchema};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$ValeurDeChampDuTypeAPIView = F8(
	function (champ, typeDeChamp, valeur, calcule, horsLimitesDepuis, liens, horsChoix, nommees) {
		return {uC: calcule, uN: champ, gH: horsChoix, Am: horsLimitesDepuis, nQ: liens, DF: nommees, JR: typeDeChamp, fm: valeur};
	});
var $author$project$Components$Shared$CollectionDeLaFiche$CollectionDeLaFiche = F4(
	function (cle, libelle, champs, details) {
		return {dw: champs, dy: cle, cz: details, Bl: libelle};
	});
var $author$project$Components$Shared$CollectionDeLaFiche$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'details',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'champs',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'libelle',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'cle',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Shared$CollectionDeLaFiche$CollectionDeLaFiche)))));
var $author$project$Components$Referentiel$Common$ChoixDeLien$Nommee = F2(
	function (uid, nom) {
		return {Dj: nom, r8: uid};
	});
var $author$project$Components$Referentiel$Common$ChoixDeLien$nommeeDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'nom',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'uid',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$ChoixDeLien$Nommee)));
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$blocDesChampsDuType = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'collections',
	$elm$json$Json$Decode$list($author$project$Components$Shared$CollectionDeLaFiche$decoder),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'choix',
		$elm$json$Json$Decode$list($author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$decoder),
		_List_Nil,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'champs',
			$elm$json$Json$Decode$list(
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'nommees',
					$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$ChoixDeLien$nommeeDecoder),
					_List_Nil,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'horsChoix',
						$elm$json$Json$Decode$bool,
						false,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'_links',
							A2(
								$elm$json$Json$Decode$map,
								function ($) {
									return $.h0;
								},
								$author$project$API$Liens$decoder),
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'horsLimitesDepuis',
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'calcule',
									$elm$json$Json$Decode$bool,
									false,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'valeur',
										$elm$json$Json$Decode$oneOf(
											_List_fromArray(
												[
													A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$decoder),
													$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
												])),
										$elm$core$Maybe$Nothing,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'typeDeChamp',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'champ',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$ValeurDeChampDuTypeAPIView)))))))))),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'enCours',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'versionDuSchema',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'type',
						A3(
							$elm$json$Json$Decode$map2,
							F2(
								function (uid, libelles) {
									return {R: libelles, r8: uid};
								}),
							A2($elm$json$Json$Decode$field, 'uid', $author$project$Components$Referentiel$Identifiants$typeUidDecoder),
							A2($elm$json$Json$Decode$field, 'libelles', $author$project$Components$Referentiel$Common$API$QueryAPIModel$libellesDecoder)),
						$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$BlocDesChampsDuTypeAPIView)))))));
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$CompteUtilisateurAPIView = F5(
	function (utilisateur, courriel, etat, roles, liens) {
		return {kh: courriel, gt: etat, nQ: liens, eX: roles, fl: utilisateur};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$compteUtilisateurDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'roles',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'etat',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'courriel',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'utilisateur',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$CompteUtilisateurAPIView))))));
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$ContactAPIView = function (contact) {
	return function (canal) {
		return function (valeur) {
			return function (adresse) {
				return function (usage) {
					return function (principal) {
						return function (prospection) {
							return function (statut) {
								return function (statutLe) {
									return function (rattachement) {
										return function (liens) {
											return {aa: adresse, uF: canal, v8: contact, nQ: liens, px: principal, Gx: prospection, pN: rattachement, ri: statut, I0: statutLe, sd: usage, fm: valeur};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Referentiel$Identifiants$RattachementUid = $elm$core$Basics$identity;
var $author$project$Components$Referentiel$Identifiants$rattachementUidDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$contact = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'_links',
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$decoder),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'rattachement',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Referentiel$Identifiants$rattachementUidDecoder),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'statutLe',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'statut',
				$elm$json$Json$Decode$string,
				'Actif',
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'prospection',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'principal',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'usage',
							$elm$json$Json$Decode$string,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'adresse',
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Referentiel$Common$API$QueryAPIModel$adresseDecoder),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'valeur',
									A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
									$elm$core$Maybe$Nothing,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'canal',
										$elm$json$Json$Decode$string,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'contact',
											$elm$json$Json$Decode$string,
											'',
											$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$ContactAPIView))))))))))));
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$DecompteAPIView = F4(
	function (personnesRattachees, dontCloses, dontSupprimees, dontEffacees) {
		return {xF: dontCloses, xG: dontEffacees, xH: dontSupprimees, Fi: personnesRattachees};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$decompteDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (total) {
		if (total.$ === 1) {
			return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
		} else {
			var personnesRattachees = total.a;
			return A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				A4(
					$elm$json$Json$Decode$map3,
					$author$project$Components$Referentiel$Common$API$QueryAPIModel$DecompteAPIView(personnesRattachees),
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2($elm$json$Json$Decode$field, 'dontCloses', $elm$json$Json$Decode$int),
								$elm$json$Json$Decode$succeed(0)
							])),
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2($elm$json$Json$Decode$field, 'dontSupprimees', $elm$json$Json$Decode$int),
								$elm$json$Json$Decode$succeed(0)
							])),
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2($elm$json$Json$Decode$field, 'dontEffacees', $elm$json$Json$Decode$int),
								$elm$json$Json$Decode$succeed(0)
							]))));
		}
	},
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'personnesRattachees', $elm$json$Json$Decode$int)));
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$DoublonPossibleAPIView = F5(
	function (uid, identite, motifs, entite, roles) {
		return {yt: entite, Av: identite, CY: motifs, eX: roles, r8: uid};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$RoleDuDoublonAPIView = F3(
	function (type_, archetype, offre) {
		return {fA: archetype, D1: offre, r0: type_};
	});
var $author$project$API$NavLinksDictionary$entite = 'entite';
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$doublonPossible = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'roles',
	$elm$json$Json$Decode$list(
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'offre',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Referentiel$Common$API$QueryAPIModel$offreDuRoleDecoder),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'archetype',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'type',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$RoleDuDoublonAPIView))))),
	_List_Nil,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		A2(
			$elm$json$Json$Decode$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.h0;
				},
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$entite)),
			$author$project$API$Liens$deLaRessource),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'motifs',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			_List_Nil,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A2(
					$elm$json$Json$Decode$andThen,
					$author$project$Components$Referentiel$Common$API$QueryAPIModel$identiteLiee,
					A2($elm$json$Json$Decode$field, 'nature', $elm$json$Json$Decode$string)),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'uid',
					$author$project$Components$Referentiel$Identifiants$entiteUidDecoder,
					$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$DoublonPossibleAPIView))))));
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$EffaceeAPIView = F5(
	function (effaceeLe, motif, precision, programmeLe, programmePar) {
		return {x7: effaceeLe, cX: motif, Gd: precision, Gq: programmeLe, Gr: programmePar};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$effaceeDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Components$Referentiel$Common$API$QueryAPIModel$EffaceeAPIView,
	A2($elm$json$Json$Decode$field, 'effaceeLe', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'motif', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'precision', $elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'programmeLe', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'programmePar', $elm$json$Json$Decode$string)));
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$EffacementAPIView = F3(
	function (echeance, motif, etatAvant) {
		return {xY: echeance, yN: etatAvant, cX: motif};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$effacementDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Referentiel$Common$API$QueryAPIModel$EffacementAPIView,
	A2($elm$json$Json$Decode$field, 'echeance', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'motif', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'etatAvant',
		A2($elm$json$Json$Decode$andThen, $author$project$Components$Referentiel$Common$API$QueryAPIModel$etatDeFiche, $elm$json$Json$Decode$string)));
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$FusionAPIView = F5(
	function (uid, fiche, le, par, lien) {
		return {zo: fiche, Bf: le, nB: lien, EK: par, r8: uid};
	});
var $author$project$API$NavLinksDictionary$ficheFusionnee = 'fiche-fusionnee';
var $author$project$API$NavLinksDictionary$ficheGardee = 'fiche-gardee';
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$fusionDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Components$Referentiel$Common$API$QueryAPIModel$FusionAPIView,
	A2($elm$json$Json$Decode$field, 'uid', $author$project$Components$Referentiel$Identifiants$entiteUidDecoder),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'fiche', $author$project$Components$Referentiel$Common$API$QueryAPIModel$ficheLieeDecoder)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'le', $elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'par', $elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$map,
		function (liens) {
			return $elm$core$List$head(
				A2(
					$elm$core$List$filterMap,
					function (rel) {
						return A2($author$project$API$Liens$trouver, rel, liens.h0);
					},
					_List_fromArray(
						[$author$project$API$NavLinksDictionary$ficheGardee, $author$project$API$NavLinksDictionary$ficheFusionnee])));
		},
		$author$project$API$Liens$deLaRessource));
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$OrganisationAPIView = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$PersonneAPIView = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$identite = function (nature) {
	switch (nature) {
		case 'Personne':
			return A5(
				$elm$json$Json$Decode$map4,
				F4(
					function (nom, prenom, civilite, baseLegale) {
						return $author$project$Components$Referentiel$Common$API$QueryAPIModel$PersonneAPIView(
							{fI: baseLegale, vh: civilite, Dj: nom, Gg: prenom});
					}),
				$elm$json$Json$Decode$maybe(
					A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$maybe(
					A2($elm$json$Json$Decode$field, 'prenom', $elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$maybe(
					A2($elm$json$Json$Decode$field, 'civilite', $elm$json$Json$Decode$string)),
				A2($elm$json$Json$Decode$field, 'baseLegale', $elm$json$Json$Decode$string));
		case 'Organisation':
			return A2(
				$elm$json$Json$Decode$map,
				function (raisonSociale) {
					return $author$project$Components$Referentiel$Common$API$QueryAPIModel$OrganisationAPIView(
						{GR: raisonSociale});
				},
				$elm$json$Json$Decode$maybe(
					A2($elm$json$Json$Decode$field, 'raisonSociale', $elm$json$Json$Decode$string)));
		default:
			return $elm$json$Json$Decode$fail(nature);
	}
};
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$RattachementAPIView = function (rattachement) {
	return function (personne) {
		return function (organisation) {
			return function (autre) {
				return function (poste) {
					return function (intitule) {
						return function (departement) {
							return function (debut) {
								return function (fin) {
									return function (etat) {
										return function (principal) {
											return function (organisationAUnContactPrincipal) {
												return function (doublonPossible) {
													return function (contacts) {
														return function (liens) {
															return {t3: autre, wa: contacts, ku: debut, xb: departement, xL: doublonPossible, gt: etat, mI: fin, AS: intitule, nQ: liens, En: organisation, Eo: organisationAUnContactPrincipal, Fd: personne, F4: poste, px: principal, pN: rattachement};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$AVenirAPIView = 0;
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$ActifAPIView = 1;
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$TermineAPIView = 2;
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$etatDeRattachement = function (code) {
	switch (code) {
		case 'AVenir':
			return $elm$json$Json$Decode$succeed(0);
		case 'Actif':
			return $elm$json$Json$Decode$succeed(1);
		case 'Termine':
			return $elm$json$Json$Decode$succeed(2);
		default:
			return $elm$json$Json$Decode$fail(code);
	}
};
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$PosteAPIView = F3(
	function (uid, code, libelle) {
		return {vx: code, Bl: libelle, r8: uid};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$posteDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['libelles', 'fr']),
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'code',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'uid',
			$author$project$Components$Referentiel$Identifiants$posteUidDecoder,
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$PosteAPIView))));
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$rattachement = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'_links',
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$decoder),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'contacts',
		$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$QueryAPIModel$contact),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'doublonPossible',
			$elm$json$Json$Decode$bool,
			false,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'organisationAUnContactPrincipal',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'principal',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'etat',
						A2($elm$json$Json$Decode$andThen, $author$project$Components$Referentiel$Common$API$QueryAPIModel$etatDeRattachement, $elm$json$Json$Decode$string),
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'fin',
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'debut',
								$elm$json$Json$Decode$string,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'departement',
									A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'intitule',
										A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'poste',
											A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Referentiel$Common$API$QueryAPIModel$posteDecoder),
											$elm$core$Maybe$Nothing,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'autre',
												$author$project$Components$Referentiel$Common$API$QueryAPIModel$ficheLieeDecoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'organisation',
													$author$project$Components$Referentiel$Identifiants$entiteUidDecoder,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'personne',
														$author$project$Components$Referentiel$Identifiants$entiteUidDecoder,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'rattachement',
															$author$project$Components$Referentiel$Identifiants$rattachementUidDecoder,
															$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$RattachementAPIView))))))))))))))));
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$RelationAPIView = function (relation) {
	return function (code) {
		return function (libelle) {
			return function (sens) {
				return function (autre) {
					return function (horsPerimetre) {
						return function (identifiantLegal) {
							return function (pays) {
								return function (incoherent) {
									return function (liens) {
										return {t3: autre, vx: code, An: horsPerimetre, m7: identifiantLegal, AF: incoherent, Bl: libelle, nQ: liens, ho: pays, Ht: relation, IC: sens};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$DirectAPIView = 0;
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$InverseAPIView = 1;
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$sensDeRelation = function (code) {
	switch (code) {
		case 'Direct':
			return $elm$json$Json$Decode$succeed(0);
		case 'Inverse':
			return $elm$json$Json$Decode$succeed(1);
		default:
			return $elm$json$Json$Decode$fail(code);
	}
};
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$relation = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'_links',
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$decoder),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'incoherent',
		$elm$json$Json$Decode$bool,
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'pays',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'identifiantLegal',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'horsPerimetre',
					$elm$json$Json$Decode$bool,
					false,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'autre',
						$author$project$Components$Referentiel$Common$API$QueryAPIModel$ficheLieeDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'sens',
							A2($elm$json$Json$Decode$andThen, $author$project$Components$Referentiel$Common$API$QueryAPIModel$sensDeRelation, $elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['libelle', 'fr']),
								$elm$json$Json$Decode$string,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'code',
									$elm$json$Json$Decode$string,
									'',
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'relation',
										$author$project$Components$Referentiel$Identifiants$relationUidDecoder,
										$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$RelationAPIView)))))))))));
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$RoleAPIView = function (role) {
	return function (type_) {
		return function (archetype) {
			return function (debut) {
				return function (statut) {
					return function (fin) {
						return function (resultat) {
							return function (etat) {
								return function (liens) {
									return function (offre) {
										return {fA: archetype, ku: debut, gt: etat, mI: fin, nQ: liens, D1: offre, HW: resultat, bi: role, ri: statut, r0: type_};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$role = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'offre',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Referentiel$Common$API$QueryAPIModel$offreDuRoleDecoder),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'_links',
		A2(
			$elm$json$Json$Decode$map,
			function ($) {
				return $.h0;
			},
			$author$project$API$Liens$decoder),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'etat',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'resultat',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'fin',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'statut',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'debut',
							$elm$json$Json$Decode$string,
							'',
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'archetype',
								$author$project$Components$Referentiel$Archetype$decoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'type',
									$author$project$Components$Referentiel$Identifiants$typeUidDecoder,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'role',
										$elm$json$Json$Decode$string,
										'',
										$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$RoleAPIView)))))))))));
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$ficheDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$API$Liens$deLaRessource,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'compteUtilisateur',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Referentiel$Common$API$QueryAPIModel$compteUtilisateurDecoder),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'fichesFusionnees',
			$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$QueryAPIModel$fusionDecoder),
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'fusionneeDans',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Referentiel$Common$API$QueryAPIModel$fusionDecoder),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'champsModifiables',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
					_List_Nil,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'doublonsPossibles',
						$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$QueryAPIModel$doublonPossible),
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'champsDesTypes',
							$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$QueryAPIModel$blocDesChampsDuType),
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'effacee',
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Referentiel$Common$API$QueryAPIModel$effaceeDecoder),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'effacement',
									A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Referentiel$Common$API$QueryAPIModel$effacementDecoder),
									$elm$core$Maybe$Nothing,
									A2(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
										$author$project$Components$Referentiel$Common$API$QueryAPIModel$decompteDecoder,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'relations',
											$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$QueryAPIModel$relation),
											_List_Nil,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'rattachements',
												$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$QueryAPIModel$rattachement),
												_List_Nil,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'rolesClos',
													$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$QueryAPIModel$role),
													_List_Nil,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'contacts',
														$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$QueryAPIModel$contact),
														_List_Nil,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'roles',
															$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$QueryAPIModel$role),
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'etatLe',
																A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
																$elm$core$Maybe$Nothing,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'etat',
																	$author$project$Components$Referentiel$Common$API$QueryAPIModel$etatDecoder,
																	0,
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'version',
																		$elm$json$Json$Decode$int,
																		0,
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'creeeLe',
																			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
																			$elm$core$Maybe$Nothing,
																			A4(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																				'identifiantLegal',
																				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
																				$elm$core$Maybe$Nothing,
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'langue',
																					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
																					$elm$core$Maybe$Nothing,
																					A2(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
																						A2(
																							$elm$json$Json$Decode$andThen,
																							$author$project$Components$Referentiel$Common$API$QueryAPIModel$identite,
																							A2($elm$json$Json$Decode$field, 'nature', $elm$json$Json$Decode$string)),
																						A4(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																							'pays',
																							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
																							$elm$core$Maybe$Nothing,
																							A4(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																								'forme',
																								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Referentiel$Identifiants$formeUidDecoder),
																								$elm$core$Maybe$Nothing,
																								A4(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																									'qualite',
																									A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
																									$elm$core$Maybe$Nothing,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'uid',
																										$author$project$Components$Referentiel$Identifiants$entiteUidDecoder,
																										$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$FicheAPIView)))))))))))))))))))))))))));
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$formesDecoder = A2(
	$elm$json$Json$Decode$field,
	'formes',
	$elm$json$Json$Decode$list(
		A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (uid, libelle) {
					return {Bl: libelle, r8: uid};
				}),
			A2($elm$json$Json$Decode$field, 'uid', $author$project$Components$Referentiel$Identifiants$formeUidDecoder),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['libelles', 'fr']),
				$elm$json$Json$Decode$string))));
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$HistoriqueDuChampAPIView = F4(
	function (champ, personnel, canal, valeurs) {
		return {uF: canal, uN: champ, Fe: personnel, Ki: valeurs};
	});
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ValeurDeChampAPIView = F7(
	function (valeur, auteur, source, jour, heure, actuelle, expiree) {
		return {sV: actuelle, t1: auteur, y4: expiree, Ah: heure, A_: jour, IR: source, fm: valeur};
	});
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$valeurDeChamp = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'expiree',
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$Just,
		A2($elm$json$Json$Decode$field, 'le', $elm$json$Json$Decode$string)),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'actuelle',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'heure',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'jour',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$facultatif,
					'source',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'auteur',
						$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$auteur,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'valeur',
							$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$valeur,
							$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$ValeurDeChampAPIView))))))));
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$historiqueDuChampDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'valeurs',
	$elm$json$Json$Decode$list($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$valeurDeChamp),
	A3(
		$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$facultatif,
		'canal',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'personnel',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'champ',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$HistoriqueDuChampAPIView)))));
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$postesDecoder = A2(
	$elm$json$Json$Decode$field,
	'postes',
	$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$QueryAPIModel$posteDecoder));
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$propositionsDecoder = A2(
	$elm$json$Json$Decode$field,
	'fiches',
	$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$QueryAPIModel$ficheLieeDecoder));
var $author$project$Components$Referentiel$Fiche$Update$refusALire = function (lue) {
	if (lue.$ === 1) {
		var refus = lue.a;
		return A2(
			$elm$core$List$member,
			refus.ri,
			_List_fromArray(
				[401, 404])) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Components$Shared$Messages$Model$duRefus(refus));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Fiche$Liaisons$DejaRattache = {$: 3};
var $author$project$Components$Referentiel$Fiche$Liaisons$HorsPerimetre = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$Fiche$Liaisons$QualiteInconnue = {$: 2};
var $author$project$Components$Referentiel$Fiche$Liaisons$SirenDifferent = {$: 5};
var $author$project$Components$Referentiel$Fiche$Liaisons$SocieteDejaEtablie = {$: 4};
var $author$project$Components$Referentiel$Fiche$Liaisons$TypeArchive = {$: 1};
var $author$project$Components$Referentiel$Fiche$Update$refusDeLaRelation = function (erreur) {
	switch (erreur.$) {
		case 5:
			var cote = erreur.a;
			return $elm$core$Maybe$Just(
				$author$project$Components$Referentiel$Fiche$Liaisons$HorsPerimetre(cote));
		case 6:
			return $elm$core$Maybe$Just($author$project$Components$Referentiel$Fiche$Liaisons$TypeArchive);
		case 7:
			return $elm$core$Maybe$Just($author$project$Components$Referentiel$Fiche$Liaisons$QualiteInconnue);
		case 8:
			return $elm$core$Maybe$Just($author$project$Components$Referentiel$Fiche$Liaisons$DejaRattache);
		case 9:
			return $elm$core$Maybe$Just($author$project$Components$Referentiel$Fiche$Liaisons$SocieteDejaEtablie);
		case 10:
			return $elm$core$Maybe$Just($author$project$Components$Referentiel$Fiche$Liaisons$SirenDifferent);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Fiche$Roles$FinAvantDebut = 2;
var $author$project$Components$Referentiel$Fiche$Roles$NatureNonAdmise = 6;
var $author$project$Components$Referentiel$Fiche$Roles$OffreNonAutorisee = 3;
var $author$project$Components$Referentiel$Fiche$Roles$OffreRefusee = 5;
var $author$project$Components$Referentiel$Fiche$Roles$OffreRequise = 4;
var $author$project$Components$Referentiel$Fiche$Roles$QualiteNonAdmise = 7;
var $author$project$Components$Referentiel$Fiche$Roles$Recouvrement = 1;
var $author$project$Components$Referentiel$Fiche$Roles$TypeDejaOuvert = 0;
var $author$project$Components$Referentiel$Fiche$Update$refusDeRole = function (refus) {
	var _v0 = _Utils_Tuple2(refus.ri, refus.bB);
	_v0$8:
	while (true) {
		if (_v0.b.$ === 1) {
			switch (_v0.a) {
				case 409:
					switch (_v0.b.a) {
						case 'RoleDejaOuvertPourCetteOffre':
							return $elm$core$Maybe$Just(0);
						case 'DateDeFinAvantDebut':
							return $elm$core$Maybe$Just(2);
						case 'RecouvrementDeRoles':
							return $elm$core$Maybe$Just(1);
						default:
							break _v0$8;
					}
				case 422:
					switch (_v0.b.a) {
						case 'OffreNonAutoriseePourCeType':
							return $elm$core$Maybe$Just(3);
						case 'OffreRequisePourCeType':
							return $elm$core$Maybe$Just(4);
						case 'OffreRefusee':
							return $elm$core$Maybe$Just(5);
						case 'NatureNonAdmise':
							return $elm$core$Maybe$Just(6);
						case 'QualiteNonAdmise':
							return $elm$core$Maybe$Just(7);
						default:
							break _v0$8;
					}
				default:
					break _v0$8;
			}
		} else {
			break _v0$8;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$ReponseDeCommande = F3(
	function (evenements, liens, vuesAJour) {
		return {mk: evenements, nQ: liens, sy: vuesAJour};
	});
var $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$ChampModifie = F3(
	function (champ, valeur, version) {
		return {uN: champ, fm: valeur, sq: version};
	});
var $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$EnClair = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$Personnelle = {$: 2};
var $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$Videe = {$: 1};
var $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$valeurModifiee = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Components$Referentiel$Fiche$API$WriteAPIModel$EnClair,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['valeur', 'Texte']),
				$elm$json$Json$Decode$string)),
			A2(
			$elm$json$Json$Decode$map,
			function (_v0) {
				return $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$Personnelle;
			},
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['valeur', 'Personnelle']),
				$elm$json$Json$Decode$string)),
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$WriteAPIModel$Videe)
		]));
var $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$evenement = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'aggregateVersion',
	$elm$json$Json$Decode$int,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['event', 'ChampModifie']),
			$author$project$Components$Referentiel$Fiche$API$WriteAPIModel$valeurModifiee),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['event', 'ChampModifie', 'champ']),
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$WriteAPIModel$ChampModifie))));
var $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$reponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'vuesAJour',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'liens',
		A2(
			$elm$json$Json$Decode$map,
			function ($) {
				return $.h0;
			},
			$author$project$API$Liens$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'evenements',
			$elm$json$Json$Decode$list($author$project$Components$Referentiel$Fiche$API$WriteAPIModel$evenement),
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$WriteAPIModel$ReponseDeCommande))));
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$TypeDeRelationAPIView = F5(
	function (uid, libelleDirect, libelleInverse, reciproque, perimetre) {
		return {Bn: libelleDirect, Bo: libelleInverse, E9: perimetre, G6: reciproque, r8: uid};
	});
var $author$project$Components$Referentiel$Fiche$PerimetreDeRelation$Cote = F3(
	function (personnesPro, personnesParticulieres, organisations) {
		return {o3: organisations, hr: personnesParticulieres, hs: personnesPro};
	});
var $author$project$Components$Referentiel$Fiche$PerimetreDeRelation$AucuneOrganisation = {$: 0};
var $author$project$Components$Referentiel$Fiche$PerimetreDeRelation$CertainesFormes = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Fiche$PerimetreDeRelation$ToutesLesOrganisations = {$: 1};
var $author$project$Components$Referentiel$Fiche$PerimetreDeRelation$organisationsDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'Toutes',
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$PerimetreDeRelation$ToutesLesOrganisations)),
			A2(
			$elm$json$Json$Decode$field,
			'Aucune',
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$PerimetreDeRelation$AucuneOrganisation)),
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Components$Referentiel$Fiche$PerimetreDeRelation$CertainesFormes,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['Certaines', 'formes']),
				$elm$json$Json$Decode$list($author$project$Components$Referentiel$Identifiants$formeUidDecoder)))
		]));
var $author$project$Components$Referentiel$Fiche$PerimetreDeRelation$coteDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'organisations',
	$author$project$Components$Referentiel$Fiche$PerimetreDeRelation$organisationsDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'personnesParticulieres',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'personnesPro',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$PerimetreDeRelation$Cote))));
var $author$project$Components$Referentiel$Fiche$PerimetreDeRelation$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (source) {
		return A2(
			$elm$json$Json$Decode$map,
			function (cible) {
				return {vf: cible, IR: source};
			},
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2($elm$json$Json$Decode$field, 'cible', $author$project$Components$Referentiel$Fiche$PerimetreDeRelation$coteDecoder),
						$elm$json$Json$Decode$succeed(source)
					])));
	},
	A2($elm$json$Json$Decode$field, 'source', $author$project$Components$Referentiel$Fiche$PerimetreDeRelation$coteDecoder));
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$typesDeRelationDecoder = A2(
	$elm$json$Json$Decode$field,
	'types',
	$elm$json$Json$Decode$list(
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'perimetre',
			$author$project$Components$Referentiel$Fiche$PerimetreDeRelation$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'reciproque',
				$elm$json$Json$Decode$bool,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
					_List_fromArray(
						['libelleInverse', 'fr']),
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['libelleDirect', 'fr']),
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'uid',
							$author$project$Components$Referentiel$Identifiants$typeRelationUidDecoder,
							$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$TypeDeRelationAPIView))))))));
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$nomsDesElements = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$filterMap($elm$core$Basics$identity),
		$elm$core$Dict$fromList),
	$elm$json$Json$Decode$list(
		A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (code, libelles) {
					return A2(
						$elm$core$Maybe$map,
						function (nommes) {
							return _Utils_Tuple2(code, nommes.zX);
						},
						libelles);
				}),
			A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
			$elm$json$Json$Decode$maybe(
				A2($elm$json$Json$Decode$field, 'libelles', $author$project$Components$Referentiel$Common$API$QueryAPIModel$libellesDecoder)))));
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$typeDeRole = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'libellesDesResultats',
	$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$nomsDesElements,
	$elm$core$Dict$empty,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'libellesDesStatuts',
		$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$nomsDesElements,
		$elm$core$Dict$empty,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'resultats',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'statuts',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				_List_Nil,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'archive',
					$elm$json$Json$Decode$bool,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'couleur',
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'icone',
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'libelles',
								$author$project$Components$Referentiel$Common$API$QueryAPIModel$libellesDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'archetype',
									A2($elm$json$Json$Decode$map, $author$project$Components$Referentiel$Archetype$libelle, $author$project$Components$Referentiel$Archetype$decoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'uid',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed(
											function (uid) {
												return function (archetype) {
													return function (libelles) {
														return function (icone) {
															return function (couleur) {
																return function (archive) {
																	return function (statuts) {
																		return function (resultats) {
																			return function (nomsDesStatuts) {
																				return function (nomsDesResultats) {
																					return {fA: archetype, tE: archive, kf: couleur, aC: icone, Bl: libelles.zX, DI: nomsDesResultats, DJ: nomsDesStatuts, bh: resultats, I1: statuts, r8: uid};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											})))))))))));
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$typesDecoder = A2(
	$elm$json$Json$Decode$field,
	'types',
	$elm$json$Json$Decode$list($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$typeDeRole));
var $author$project$Components$Referentiel$Fiche$Update$popMessages = F2(
	function (model, msg) {
		switch (msg.$) {
			case 3:
				var uid = msg.a;
				var reponse = msg.b;
				if (!_Utils_eq(
					model.kD,
					$elm$core$Maybe$Just(uid))) {
					return $elm$core$Maybe$Nothing;
				} else {
					var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$API$QueryAPIModel$ficheDecoder, reponse);
					if (_v1.$ === 1) {
						var refus = _v1.a;
						return A2(
							$elm$core$List$member,
							refus.ri,
							_List_fromArray(
								[401, 404])) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							$author$project$Components$Shared$Messages$Model$duRefus(refus));
					} else {
						var vue = _v1.a;
						return A2(
							$elm$core$Maybe$andThen,
							A2($author$project$Components$Referentiel$Fiche$Update$correctionsPerdues, uid, vue),
							model.tS);
					}
				}
			case 34:
				var uid = msg.a;
				var reponse = msg.b;
				var _v2 = _Utils_Tuple3(
					_Utils_eq(
						model.kD,
						$elm$core$Maybe$Just(uid)),
					model.l2,
					A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$commandeDeContactDecoder, reponse));
				if ((_v2.a && (_v2.b.$ === 2)) && (_v2.c.$ === 1)) {
					var refus = _v2.c.a;
					return (A2(
						$elm$core$List$member,
						refus.ri,
						_List_fromArray(
							[401, 404])) || $author$project$Components$Referentiel$Fiche$Update$emailDejaSurLaFiche(refus)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 51:
				var uid = msg.a;
				var reponse = msg.b;
				var _v3 = _Utils_Tuple3(
					_Utils_eq(
						model.kD,
						$elm$core$Maybe$Just(uid)),
					model.l2,
					A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$commandeDeContactDecoder, reponse));
				if ((_v3.a && (_v3.b.$ === 2)) && (_v3.c.$ === 1)) {
					var refus = _v3.c.a;
					return (A2(
						$elm$core$List$member,
						refus.ri,
						_List_fromArray(
							[401, 404])) || (!_Utils_eq(
						$author$project$Components$Referentiel$Fiche$Update$refusDeRole(refus),
						$elm$core$Maybe$Nothing))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 96:
				var uid = msg.a;
				var reponse = msg.b;
				var _v4 = _Utils_Tuple2(
					_Utils_eq(
						model.kD,
						$elm$core$Maybe$Just(uid)),
					A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$apercuDeLaClotureDecoder, reponse));
				if (_v4.a && (_v4.b.$ === 1)) {
					var refus = _v4.b.a;
					return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 102:
				var uid = msg.a;
				var reponse = msg.b;
				var refus = (!_Utils_eq(model.x9.v8, $elm$core$Maybe$Nothing)) ? A2(
					$elm$core$Result$map,
					$elm$core$Basics$always(0),
					A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$apercuDeLEffacementDUnContactDecoder, reponse)) : A2(
					$elm$core$Result$map,
					$elm$core$Basics$always(0),
					A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$apercuDeLEffacementDecoder, reponse));
				var _v5 = _Utils_Tuple2(
					_Utils_eq(
						model.kD,
						$elm$core$Maybe$Just(uid)),
					refus);
				if (_v5.a && (_v5.b.$ === 1)) {
					var erreur = _v5.b.a;
					return (erreur.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(erreur));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 97:
				var uid = msg.a;
				var demande = msg.b;
				var reponse = msg.c;
				var _v6 = _Utils_Tuple3(
					_Utils_eq(
						model.kD,
						$elm$core$Maybe$Just(uid)),
					_Utils_eq(demande, $elm$core$Maybe$Nothing),
					A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$apercuDeLExportDecoder, reponse));
				if ((_v6.a && _v6.b) && (_v6.c.$ === 1)) {
					var refus = _v6.c.a;
					return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 108:
				var uid = msg.a;
				var reponse = msg.b;
				var _v7 = _Utils_Tuple3(
					_Utils_eq(
						model.kD,
						$elm$core$Maybe$Just(uid)),
					model.l2,
					A2(
						$author$project$API$Reponse$lire,
						$elm$json$Json$Decode$succeed(0),
						reponse));
				if ((_v7.a && (_v7.b.$ === 2)) && (_v7.c.$ === 1)) {
					var refus = _v7.c.a;
					return A2(
						$elm$core$List$member,
						refus.ri,
						_List_fromArray(
							[401, 404])) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 115:
				var uid = msg.a;
				var reponse = msg.b;
				var _v8 = _Utils_Tuple3(
					_Utils_eq(
						model.kD,
						$elm$core$Maybe$Just(uid)),
					model.l2,
					A2(
						$author$project$API$Reponse$lire,
						$elm$json$Json$Decode$succeed(0),
						reponse));
				if ((_v8.a && (_v8.b.$ === 2)) && (_v8.c.$ === 1)) {
					var refus = _v8.c.a;
					return A2(
						$elm$core$List$member,
						refus.ri,
						_List_fromArray(
							[401, 404])) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 36:
				var reponse = msg.a;
				var _v9 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$typesDecoder, reponse);
				if (_v9.$ === 1) {
					var refus = _v9.a;
					return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 69:
				var reponse = msg.a;
				var _v10 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$postesDecoder, reponse);
				if (_v10.$ === 1) {
					var refus = _v10.a;
					return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 70:
				var reponse = msg.a;
				var _v11 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$formesDecoder, reponse);
				if (_v11.$ === 1) {
					var refus = _v11.a;
					return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 16:
				var reponse = msg.b;
				var _v12 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$autresFichesDeLIdentifiantDecoder, reponse);
				if (_v12.$ === 1) {
					var refus = _v12.a;
					return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 74:
				var reponse = msg.b;
				var _v13 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$propositionsDecoder, reponse);
				if (_v13.$ === 1) {
					var refus = _v13.a;
					return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 83:
				var reponse = msg.a;
				var _v14 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$typesDeRelationDecoder, reponse);
				if (_v14.$ === 1) {
					var refus = _v14.a;
					return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 57:
				var uid = msg.a;
				var reponse = msg.b;
				var _v15 = _Utils_Tuple3(
					_Utils_eq(
						model.kD,
						$elm$core$Maybe$Just(uid)),
					model.l2,
					A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$commandeDeLiaisonDecoder, reponse));
				if ((_v15.a && (_v15.b.$ === 2)) && (_v15.c.$ === 1)) {
					var refus = _v15.c.a;
					return A2(
						$elm$core$List$member,
						refus.ri,
						_List_fromArray(
							[401, 404])) ? $elm$core$Maybe$Nothing : ((_Utils_eq(
						$author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$duRefus(refus),
						$author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$RelationDejaExistante) || (_Utils_eq(
						$author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$duRefus(refus),
						$author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$PosteArchive) || (_Utils_eq(
						$author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$duRefus(refus),
						$author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$RattachementDejaActifSurCePoste) || (!_Utils_eq(
						$author$project$Components$Referentiel$Fiche$Update$refusDeLaRelation(
							$author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$duRefus(refus)),
						$elm$core$Maybe$Nothing))))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus)));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 12:
				var uid = msg.a;
				var reponse = msg.b;
				var _v16 = _Utils_Tuple3(
					_Utils_eq(
						model.kD,
						$elm$core$Maybe$Just(uid)),
					model.l2,
					A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$reponseDecoder, reponse));
				if ((_v16.a && (_v16.b.$ === 2)) && (_v16.c.$ === 1)) {
					var refus = _v16.c.a;
					return (A2(
						$elm$core$List$member,
						refus.ri,
						_List_fromArray(
							[401, 404])) || A2(
						$elm$core$List$member,
						$author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$duRefus(refus),
						_List_fromArray(
							[$author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$FicheModifieeEntreTemps, $author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$IdentifiantLegalInvalide]))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 91:
				var uid = msg.a;
				var numero = msg.b;
				var reponse = msg.c;
				return ((!_Utils_eq(
					model.kD,
					$elm$core$Maybe$Just(uid))) || (!_Utils_eq(numero, model.m6.np))) ? $elm$core$Maybe$Nothing : $author$project$Components$Referentiel$Fiche$Update$refusALire(
					A2(
						$elm$core$Result$map,
						function (_v17) {
							return 0;
						},
						A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$chronologieDecoder, reponse)));
			case 93:
				var uid = msg.a;
				var numero = msg.b;
				var reponse = msg.c;
				return ((!_Utils_eq(
					model.kD,
					$elm$core$Maybe$Just(uid))) || (!_Utils_eq(
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.np;
						},
						model.m6.bR),
					$elm$core$Maybe$Just(numero)))) ? $elm$core$Maybe$Nothing : $author$project$Components$Referentiel$Fiche$Update$refusALire(
					A2(
						$elm$core$Result$map,
						function (_v18) {
							return 0;
						},
						A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$historiqueDuChampDecoder, reponse)));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Referentiel$Fusion$Update$popMessages = function (msg) {
	return $elm$core$Maybe$Nothing;
};
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$IdentifiantLegalInvalide = 12;
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$AutreMotif = 5;
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$MemeEmail = 0;
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$MemeIdentifiantLegal = 4;
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$MemeNom = 2;
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$MemeRaisonSociale = 3;
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$MemeTelephone = 1;
var $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$motif = A2(
	$elm$json$Json$Decode$map,
	function (code) {
		switch (code) {
			case 'MemeEmail':
				return 0;
			case 'MemeTelephone':
				return 1;
			case 'MemeNom':
				return 2;
			case 'MemeRaisonSociale':
				return 3;
			case 'MemeIdentifiantLegal':
				return 4;
			default:
				return 5;
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$Fort = 0;
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$Faible = 1;
var $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$niveauDeSignal = A2(
	$elm$json$Json$Decode$andThen,
	function (code) {
		switch (code) {
			case 'Fort':
				return $elm$json$Json$Decode$succeed(0);
			case 'Faible':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('niveau');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$niveauDuCandidat = function (etat) {
	return (etat === 2) ? A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'niveau', $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$niveauDeSignal, 0) : A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'niveau', $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$niveauDeSignal);
};
var $author$project$API$NavLinksDictionary$ouvrirRole = 'ouvrir-role';
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$RoleDeCandidat = F3(
	function (type_, archetype, offre) {
		return {fA: archetype, D1: offre, r0: type_};
	});
var $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$role = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'offre',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Referentiel$Common$API$QueryAPIModel$offreDuRoleDecoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'archetype',
		$author$project$Components$Referentiel$Archetype$decoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'type',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Referentiel$Identifiants$typeUidDecoder),
			$elm$core$Maybe$Nothing,
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$NouvelleFiche$Doublons$RoleDeCandidat))));
var $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$candidatEnEtat = function (etatLu) {
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'_links',
		$author$project$API$Liens$decoder,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			etatLu,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'roles',
				$elm$json$Json$Decode$list($author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$role),
				A2(
					$author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$niveauDuCandidat,
					etatLu,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'motifs',
						$elm$json$Json$Decode$list($author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$motif),
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'pays',
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'raisonSociale',
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'nom',
									A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'prenom',
										A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
										$elm$core$Maybe$Nothing,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'uid',
											$author$project$Components$Referentiel$Identifiants$entiteUidDecoder,
											$elm$json$Json$Decode$succeed(
												function (uid) {
													return function (prenom) {
														return function (nom) {
															return function (raisonSociale) {
																return function (pays) {
																	return function (motifs) {
																		return function (niveau) {
																			return function (roles) {
																				return function (etat) {
																					return function (liens) {
																						return {
																							s9: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ouvrirRole, liens.h0),
																							gt: etat,
																							CY: motifs,
																							os: niveau,
																							Dj: function () {
																								var _v0 = _Utils_Tuple2(
																									raisonSociale,
																									A2(
																										$elm$core$List$filterMap,
																										$elm$core$Basics$identity,
																										_List_fromArray(
																											[prenom, nom])));
																								if (!_v0.a.$) {
																									var raison = _v0.a.a;
																									return $elm$core$Maybe$Just(raison);
																								} else {
																									if (!_v0.b.b) {
																										var _v1 = _v0.a;
																										return $elm$core$Maybe$Nothing;
																									} else {
																										var _v2 = _v0.a;
																										var parties = _v0.b;
																										return $elm$core$Maybe$Just(
																											A2($elm$core$String$join, ' ', parties));
																									}
																								}
																							}(),
																							Ex: !_Utils_eq(
																								A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$entite, liens.h0),
																								$elm$core$Maybe$Nothing),
																							ho: pays,
																							HS: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$restaurer, liens.h0),
																							eX: roles,
																							r8: uid
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												})))))))))));
};
var $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$candidat = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$withDefault(0),
		$author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$candidatEnEtat),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'etat', $author$project$Components$Referentiel$Common$API$QueryAPIModel$etatDecoder)));
var $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$doublonsDecoder = A2(
	$elm$json$Json$Decode$field,
	'candidats',
	$elm$json$Json$Decode$list($author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$candidat));
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$AutreRefus = 14;
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$CommandeEnDouble = 2;
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$ContactEnDouble = 5;
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$FicheDejaCreee = 1;
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$NatureNonAdmise = 11;
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$OffreNonAutoriseePourCeType = 8;
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$OffreRefusee = 10;
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$OffreRequisePourCeType = 9;
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$PersonneEffaceeALaDemande = 13;
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$PlusieursPrincipauxSurUnCanal = 4;
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$PosteArchive = 7;
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$PrenomOuEmailRequis = 3;
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$ProspectionHorsEmailEtTelephone = 6;
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$TypeDePartiePrenanteInconnu = 0;
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$duRefus = function (refus) {
	var _v0 = _Utils_Tuple2(refus.ri, refus.bB);
	_v0$13:
	while (true) {
		_v0$14:
		while (true) {
			switch (_v0.a) {
				case 422:
					if (_v0.b.$ === 1) {
						switch (_v0.b.a) {
							case 'TypeDePartiePrenanteInconnu':
								return 0;
							case 'PrenomOuEmailRequis':
								return 3;
							case 'PlusieursPrincipauxSurUnCanal':
								return 4;
							case 'ContactEnDouble':
								return 5;
							case 'ProspectionHorsEmailEtTelephone':
								return 6;
							case 'NatureNonAdmise':
								return 11;
							case 'IdentifiantLegalInvalide':
								return 12;
							case 'OffreNonAutoriseePourCeType':
								return 8;
							case 'OffreRequisePourCeType':
								return 9;
							case 'OffreRefusee':
								return 10;
							default:
								break _v0$14;
						}
					} else {
						break _v0$14;
					}
				case 409:
					if (_v0.b.$ === 1) {
						switch (_v0.b.a) {
							case 'EntiteDejaCreee':
								return 1;
							case 'PosteArchive':
								return 7;
							case 'PersonneEffaceeALaDemande':
								return 13;
							default:
								break _v0$13;
						}
					} else {
						break _v0$13;
					}
				default:
					break _v0$14;
			}
		}
		return 14;
	}
	return 2;
};
var $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$FormeServie = F3(
	function (uid, libelle, archivee) {
		return {tI: archivee, Bl: libelle, r8: uid};
	});
var $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$formeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'archivee',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['libelles', 'fr']),
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'uid',
			$author$project$Components$Referentiel$Identifiants$formeUidDecoder,
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$FormeServie))));
var $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$formesDecoder = A2(
	$elm$json$Json$Decode$field,
	'formes',
	$elm$json$Json$Decode$list($author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$formeDecoder));
var $author$project$I18n$Textes$posteRattachementRefusArchive = A3($author$project$I18n$Traductions$texte, 'poste.rattachement.refus-archive', _List_Nil, 'Ce poste n\'est plus proposé : il a été archivé. Les postes proposés sont relus ; choisissez-en un autre ou laissez le poste vide.');
var $author$project$I18n$Textes$referentielCreationErreurContactEnDouble = A3($author$project$I18n$Traductions$texte, 'referentiel.creation.erreur.contact-en-double', _List_Nil, 'Le même email est saisi sur deux lignes.');
var $author$project$I18n$Textes$referentielCreationErreurDejaCreee = A3($author$project$I18n$Traductions$texte, 'referentiel.creation.erreur.deja-creee', _List_Nil, 'Cette fiche a déjà été créée.');
var $author$project$I18n$Textes$referentielCreationErreurEnDouble = A3($author$project$I18n$Traductions$texte, 'referentiel.creation.erreur.en-double', _List_Nil, 'Cette demande a déjà été envoyée : la fiche a peut-être déjà été créée. La renvoyer créerait une nouvelle fiche.');
var $author$project$I18n$Textes$referentielCreationErreurNatureNonAdmise = A3($author$project$I18n$Traductions$texte, 'referentiel.creation.erreur.nature-non-admise', _List_Nil, 'Ce type de partie prenante n\'admet pas cette nature de fiche (personne ou organisation). Choisissez un autre type.');
var $author$project$I18n$Textes$referentielCreationErreurPersonneEffacee = A3($author$project$I18n$Traductions$texte, 'referentiel.creation.erreur.personne-effacee', _List_Nil, 'Cette personne a demandé l\'effacement de ses données. L\'avertissement sous la saisie dit si sa fiche peut être recréée.');
var $author$project$I18n$Textes$referentielCreationErreurPlusieursPrincipaux = A3($author$project$I18n$Traductions$texte, 'referentiel.creation.erreur.plusieurs-principaux', _List_Nil, 'Un seul contact principal est permis par canal.');
var $author$project$I18n$Textes$referentielCreationErreurProspectionHorsEmailEtTelephone = A3($author$project$I18n$Traductions$texte, 'referentiel.creation.erreur.prospection-hors-email-et-telephone', _List_Nil, 'La prospection ne s\'accepte que sur un email ou un téléphone.');
var $author$project$I18n$Textes$referentielCreationErreurTypeInconnu = A3($author$project$I18n$Traductions$texte, 'referentiel.creation.erreur.type-inconnu', _List_Nil, 'Ce type de partie prenante n\'existe pas. La fiche n\'a pas été créée.');
var $author$project$I18n$Textes$referentielCreationIdentifiantLegalInvalide = A3($author$project$I18n$Traductions$texte, 'referentiel.creation.identifiant-legal-invalide', _List_Nil, 'Identifiant légal invalide : ce n\'est ni un SIREN ni un SIRET valide. Vérifiez les chiffres.');
var $author$project$I18n$Textes$referentielCreationPrenomOuEmail = A3($author$project$I18n$Traductions$texte, 'referentiel.creation.prenom-ou-email', _List_Nil, 'Saisissez un prénom ou un email.');
var $author$project$I18n$Textes$referentielRoleErreurOffreNonAutorisee = A3($author$project$I18n$Traductions$texte, 'referentiel.role.erreur.offre-non-autorisee', _List_Nil, 'Ce type ne s\'ouvre que pour certaines offres. Choisissez une des offres autorisées pour ce type.');
var $author$project$I18n$Textes$referentielRoleErreurOffreRefusee = A3($author$project$I18n$Traductions$texte, 'referentiel.role.erreur.offre-refusee', _List_Nil, 'Cette offre n\'est plus proposée. Choisissez-en une autre.');
var $author$project$I18n$Textes$referentielRoleErreurOffreRequise = A3($author$project$I18n$Traductions$texte, 'referentiel.role.erreur.offre-requise', _List_Nil, 'Ce type demande une offre. Choisissez une des offres autorisées pour ce type.');
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$message = function (refus) {
	var _v0 = $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$duRefus(refus);
	switch (_v0) {
		case 0:
			return {Jx: $author$project$I18n$Textes$referentielCreationErreurTypeInconnu, b9: refus.b9};
		case 1:
			return {Jx: $author$project$I18n$Textes$referentielCreationErreurDejaCreee, b9: refus.b9};
		case 2:
			return {Jx: $author$project$I18n$Textes$referentielCreationErreurEnDouble, b9: refus.b9};
		case 3:
			return {Jx: $author$project$I18n$Textes$referentielCreationPrenomOuEmail, b9: refus.b9};
		case 4:
			return {Jx: $author$project$I18n$Textes$referentielCreationErreurPlusieursPrincipaux, b9: refus.b9};
		case 5:
			return {Jx: $author$project$I18n$Textes$referentielCreationErreurContactEnDouble, b9: refus.b9};
		case 6:
			return {Jx: $author$project$I18n$Textes$referentielCreationErreurProspectionHorsEmailEtTelephone, b9: refus.b9};
		case 7:
			return {Jx: $author$project$I18n$Textes$posteRattachementRefusArchive, b9: refus.b9};
		case 8:
			return {Jx: $author$project$I18n$Textes$referentielRoleErreurOffreNonAutorisee, b9: refus.b9};
		case 9:
			return {Jx: $author$project$I18n$Textes$referentielRoleErreurOffreRequise, b9: refus.b9};
		case 10:
			return {Jx: $author$project$I18n$Textes$referentielRoleErreurOffreRefusee, b9: refus.b9};
		case 11:
			return {Jx: $author$project$I18n$Textes$referentielCreationErreurNatureNonAdmise, b9: refus.b9};
		case 13:
			return {Jx: $author$project$I18n$Textes$referentielCreationErreurPersonneEffacee, b9: refus.b9};
		case 12:
			return {Jx: $author$project$I18n$Textes$referentielCreationIdentifiantLegalInvalide, b9: refus.b9};
		default:
			return $author$project$Components$Shared$Messages$Model$duRefus(refus);
	}
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$messageDeLAjout = function (refus) {
	var _v0 = $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$duRefus(refus);
	switch (_v0) {
		case 8:
			return $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$message(refus);
		case 9:
			return $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$message(refus);
		case 10:
			return $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$message(refus);
		case 11:
			return $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$message(refus);
		default:
			return $author$project$Components$Shared$Messages$Model$duRefus(refus);
	}
};
var $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$organisationsDecoder = A2(
	$elm$json$Json$Decode$field,
	'fiches',
	$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$QueryAPIModel$ficheLieeDecoder));
var $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$postesDecoder = A2(
	$elm$json$Json$Decode$field,
	'postes',
	$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$QueryAPIModel$posteDecoder));
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$RoleDejaOuvert = 0;
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$RoleQuiRecouvre = 1;
var $author$project$Components$Referentiel$NouvelleFiche$Update$refusDAjout = function (refus) {
	var _v0 = _Utils_Tuple2(refus.ri, refus.bB);
	_v0$2:
	while (true) {
		if ((_v0.a === 409) && (_v0.b.$ === 1)) {
			switch (_v0.b.a) {
				case 'RoleDejaOuvertPourCetteOffre':
					return $elm$core$Maybe$Just(0);
				case 'RecouvrementDeRoles':
					return $elm$core$Maybe$Just(1);
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$refusDe = function (lue) {
	if (lue.$ === 1) {
		var refus = lue.a;
		return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(refus);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$ReponseDeCommande = F4(
	function (entite, evenements, liens, vuesAJour) {
		return {yt: entite, mk: evenements, nQ: liens, sy: vuesAJour};
	});
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$entiteDuLienSelf = function (liens) {
	return A2(
		$elm$core$Maybe$andThen,
		function (lien) {
			return A2(
				$elm$core$Maybe$andThen,
				$author$project$Components$Referentiel$Identifiants$entiteUidFromString,
				$elm$core$List$head(
					$elm$core$List$reverse(
						A2($elm$core$String$split, '/', lien.cM))));
		},
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$self, liens));
};
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$AutreEvenement = 2;
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$EntiteCreee = 0;
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$RoleOuvert = 1;
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$evenement = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'EntiteCreee',
			$elm$json$Json$Decode$succeed(0)),
			A2(
			$elm$json$Json$Decode$field,
			'RoleOuvert',
			$elm$json$Json$Decode$succeed(1)),
			$elm$json$Json$Decode$succeed(2)
		]));
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$reponseDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (liens) {
		var _v0 = $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$entiteDuLienSelf(liens);
		if (!_v0.$) {
			var entite = _v0.a;
			return A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'vuesAJour',
				$elm$json$Json$Decode$bool,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
					liens,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'evenements',
						$elm$json$Json$Decode$list(
							A2($elm$json$Json$Decode$field, 'event', $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$evenement)),
						$elm$json$Json$Decode$succeed(
							$author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$ReponseDeCommande(entite)))));
		} else {
			return $elm$json$Json$Decode$fail('lien-self-absent');
		}
	},
	A2(
		$elm$json$Json$Decode$field,
		'liens',
		A2(
			$elm$json$Json$Decode$map,
			function ($) {
				return $.h0;
			},
			$author$project$API$Liens$decoder)));
var $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$SansAvis = {$: 0};
var $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$creables = F2(
	function (droits, types) {
		return A2(
			$elm$core$List$filterMap,
			function (servi) {
				var _v0 = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$SansAvis,
					A2(
						$elm$core$Dict$get,
						$author$project$Components$Referentiel$Identifiants$typeUidToString(servi.r8),
						droits));
				switch (_v0.$) {
					case 0:
						return $elm$core$Maybe$Just(servi);
					case 1:
						return $elm$core$Maybe$Nothing;
					default:
						var cles = _v0.a;
						return $elm$core$Maybe$Just(
							_Utils_update(
								servi,
								{
									dw: A2(
										$elm$core$List$filter,
										function (champ) {
											return A2($elm$core$List$member, champ.dy, cles);
										},
										servi.dw)
								}));
				}
			},
			types);
	});
var $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$Refuse = {$: 1};
var $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$Saisit = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$droitsDeCreationDecoder = A2(
	$elm$json$Json$Decode$field,
	'types',
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
				A2(
					$elm$json$Json$Decode$andThen,
					function (creable) {
						if (creable.$ === 1) {
							return $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$SansAvis);
						} else {
							if (!creable.a) {
								return $elm$json$Json$Decode$succeed($author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$Refuse);
							} else {
								return A2(
									$elm$json$Json$Decode$map,
									$author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$Saisit,
									A2(
										$elm$json$Json$Decode$field,
										'champsSaisissables',
										$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
							}
						}
					},
					$elm$json$Json$Decode$maybe(
						A2($elm$json$Json$Decode$field, 'creable', $elm$json$Json$Decode$bool)))))));
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$SaisieDesTypesAPIView = F2(
	function (langues, unites) {
		return {Ba: langues, sb: unites};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$saisieDesTypesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'unites',
	$elm$json$Json$Decode$list($author$project$Components$Shared$EditeurDeSchema$Propositions$uniteDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'langues',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$SaisieDesTypesAPIView)));
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$TypeServiAPIView = F6(
	function (uid, archetype, libelles, archive, champs, choix) {
		return {fA: archetype, tE: archive, dw: champs, jN: choix, R: libelles, r8: uid};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$ChampServiAPIView = F3(
	function (cle, champ, filtrable) {
		return {uN: champ, dy: cle, zG: filtrable};
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$champServiDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'filtrable',
	$elm$json$Json$Decode$bool,
	false,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'definition',
		$author$project$Components$Shared$EditeurDeSchema$Champ$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'champ',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$ChampServiAPIView))));
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$typesServisDecoder = A2(
	$elm$json$Json$Decode$field,
	'types',
	$elm$json$Json$Decode$list(
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'choix',
			$elm$json$Json$Decode$list($author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$decoder),
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'champs',
				$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$QueryAPIModel$champServiDecoder),
				_List_Nil,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'archive',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'libelles',
						$author$project$Components$Referentiel$Common$API$QueryAPIModel$libellesDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'archetype',
							$author$project$Components$Referentiel$Archetype$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'uid',
								$author$project$Components$Referentiel$Identifiants$typeUidDecoder,
								$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$QueryAPIModel$TypeServiAPIView)))))))));
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$typesAvecSaisieDecoder = A3($elm$json$Json$Decode$map2, $elm$core$Tuple$pair, $author$project$Components$Referentiel$Common$API$QueryAPIModel$typesServisDecoder, $author$project$Components$Referentiel$Common$API$QueryAPIModel$saisieDesTypesDecoder);
var $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$typesAvecSaisieDecoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (_v0, droits) {
			var types = _v0.a;
			var saisie = _v0.b;
			return _Utils_Tuple2(
				A2($author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$creables, droits, types),
				saisie);
		}),
	$author$project$Components$Referentiel$Common$API$QueryAPIModel$typesAvecSaisieDecoder,
	$author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$droitsDeCreationDecoder);
var $author$project$Components$Referentiel$NouvelleFiche$Update$popMessages = function (msg) {
	switch (msg.$) {
		case 51:
			var reponse = msg.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Components$Shared$Messages$Model$duRefus,
				$author$project$Components$Referentiel$NouvelleFiche$Update$refusDe(
					A2(
						$author$project$API$Reponse$lire,
						A2($elm$json$Json$Decode$field, 'vuesAJour', $elm$json$Json$Decode$bool),
						reponse)));
		case 41:
			var reponse = msg.a;
			return A2(
				$elm$core$Maybe$andThen,
				function (refus) {
					return ($author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$duRefus(refus) === 12) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$message(refus));
				},
				$author$project$Components$Referentiel$NouvelleFiche$Update$refusDe(
					A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$reponseDecoder, reponse)));
		case 12:
			var reponse = msg.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Components$Shared$Messages$Model$duRefus,
				$author$project$Components$Referentiel$NouvelleFiche$Update$refusDe(
					A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$typesAvecSaisieDecoder, reponse)));
		case 45:
			var reponse = msg.b;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Components$Shared$Messages$Model$duRefus,
				$author$project$Components$Referentiel$NouvelleFiche$Update$refusDe(
					A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$doublonsDecoder, reponse)));
		case 54:
			var reponse = msg.b;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Components$Referentiel$NouvelleFiche$Update$messageDeLAjout,
				A2(
					$elm$core$Maybe$andThen,
					function (refus) {
						return _Utils_eq(
							$author$project$Components$Referentiel$NouvelleFiche$Update$refusDAjout(refus),
							$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(refus) : $elm$core$Maybe$Nothing;
					},
					$author$project$Components$Referentiel$NouvelleFiche$Update$refusDe(
						A2(
							$author$project$API$Reponse$lire,
							A2($elm$json$Json$Decode$field, 'vuesAJour', $elm$json$Json$Decode$bool),
							reponse))));
		case 6:
			var reponse = msg.b;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Components$Shared$Messages$Model$duRefus,
				$author$project$Components$Referentiel$NouvelleFiche$Update$refusDe(
					A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$organisationsDecoder, reponse)));
		case 8:
			var reponse = msg.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Components$Shared$Messages$Model$duRefus,
				$author$project$Components$Referentiel$NouvelleFiche$Update$refusDe(
					A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$postesDecoder, reponse)));
		case 14:
			var reponse = msg.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Components$Shared$Messages$Model$duRefus,
				$author$project$Components$Referentiel$NouvelleFiche$Update$refusDe(
					A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$formesDecoder, reponse)));
		case 11:
			var octets = msg.a;
			return _Utils_eq(
				$author$project$API$ProcessUid$depuisOctets(octets),
				$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
				{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Fiche$Update$CreerUnePersonneRattachee = F2(
	function (a, b) {
		return {$: 32, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid = {$: 7};
var $author$project$Components$Referentiel$Fiche$Model$Introuvable = {$: 2};
var $author$project$Components$Referentiel$Fiche$Update$LireFiche = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Update$LireLaChronologie = F3(
	function (a, b, c) {
		return {$: 33, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Fiche$Update$LireLeDefilement = {$: 16};
var $author$project$Components$Referentiel$Fiche$Update$LireLesFormes = function (a) {
	return {$: 28, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$LireLesOffres = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$LireTypes = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Referentiel$Fiche$Model$Lue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Fiche$Contacts$Marquer = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Model$Organisation = 1;
var $author$project$Components$Referentiel$Fiche$Update$OuvrirLaFusion = F4(
	function (a, b, c, d) {
		return {$: 6, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Referentiel$Fiche$Update$PlacerFocus = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$Reconnecter = {$: 5};
var $author$project$Components$Referentiel$Fiche$Contacts$ReglerLaProspection = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Contacts$RendrePrincipal = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$SuiteDeLaChronologieDemandee = {$: 88};
var $author$project$Components$Referentiel$Common$Contact$Email = 0;
var $author$project$Components$Referentiel$Common$Contact$UsageProfessionnel = 1;
var $author$project$Components$Referentiel$Common$Contact$UsagePersonnel = 0;
var $author$project$Components$Referentiel$Common$Contact$adresseVide = {vz: '', a3: '', a4: '', a5: '', B_: '', ho: '', Hj: ''};
var $author$project$Components$Referentiel$Common$Contact$maximum = 20;
var $author$project$Components$Referentiel$Common$Contact$complet = function (lignes) {
	return _Utils_cmp(
		$elm$core$List$length(lignes),
		$author$project$Components$Referentiel$Common$Contact$maximum) > -1;
};
var $author$project$Components$Referentiel$Common$Contact$Reseau = 4;
var $author$project$Components$Referentiel$Common$Contact$SiteWeb = 3;
var $author$project$Components$Referentiel$Common$Contact$Telephone = 1;
var $author$project$Components$Referentiel$Common$Contact$canaux = _List_fromArray(
	[0, 1, 2, 3, 4]);
var $author$project$Components$Referentiel$Common$Contact$unPrincipalParCanal = function (lignes) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (canal, traitees) {
				var principal = A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$first,
					$elm$core$List$head(
						function (duCanal) {
							return _Utils_ap(
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Tuple$second,
										function ($) {
											return $.px;
										}),
									duCanal),
								duCanal);
						}(
							A2(
								$elm$core$List$filter,
								function (_v0) {
									var ligne = _v0.b;
									return _Utils_eq(ligne.uF, canal);
								},
								A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, traitees)))));
				return A2(
					$elm$core$List$indexedMap,
					F2(
						function (rang, ligne) {
							return _Utils_eq(ligne.uF, canal) ? _Utils_update(
								ligne,
								{
									px: _Utils_eq(
										$elm$core$Maybe$Just(rang),
										principal)
								}) : ligne;
						}),
					traitees);
			}),
		lignes,
		$author$project$Components$Referentiel$Common$Contact$canaux);
};
var $author$project$Components$Referentiel$Common$Contact$ajouter = function (lignes) {
	return $author$project$Components$Referentiel$Common$Contact$complet(lignes) ? lignes : $author$project$Components$Referentiel$Common$Contact$unPrincipalParCanal(
		_Utils_ap(
			lignes,
			_List_fromArray(
				[
					{aa: $author$project$Components$Referentiel$Common$Contact$adresseVide, uF: 0, px: false, Gx: false, sd: 0, fm: ''}
				])));
};
var $author$project$Components$Referentiel$Common$Contact$surLaLigne = F2(
	function (rang, modifier) {
		return $elm$core$List$indexedMap(
			F2(
				function (courant, ligne) {
					return _Utils_eq(courant, rang) ? modifier(ligne) : ligne;
				}));
	});
var $author$project$Components$Referentiel$Common$Contact$setCanal = F3(
	function (rang, code, lignes) {
		var _v0 = A2(
			$elm$core$List$filter,
			function (canal) {
				return _Utils_eq(
					$author$project$Components$Referentiel$Common$Contact$canalCode(canal),
					code);
			},
			$author$project$Components$Referentiel$Common$Contact$canaux);
		if (_v0.b) {
			var canal = _v0.a;
			return $author$project$Components$Referentiel$Common$Contact$unPrincipalParCanal(
				A3(
					$author$project$Components$Referentiel$Common$Contact$surLaLigne,
					rang,
					function (ligne) {
						return _Utils_eq(ligne.uF, canal) ? ligne : _Utils_update(
							ligne,
							{uF: canal, px: false});
					},
					lignes));
		} else {
			return lignes;
		}
	});
var $author$project$Components$Referentiel$Common$Contact$UsageAutre = 5;
var $author$project$Components$Referentiel$Common$Contact$UsageFacturation = 2;
var $author$project$Components$Referentiel$Common$Contact$UsageLivraison = 3;
var $author$project$Components$Referentiel$Common$Contact$UsageSiege = 4;
var $author$project$Components$Referentiel$Common$Contact$usages = _List_fromArray(
	[0, 1, 2, 3, 4, 5]);
var $author$project$Components$Referentiel$Common$Contact$setUsage = F3(
	function (rang, code, lignes) {
		var _v0 = A2(
			$elm$core$List$filter,
			function (usage) {
				return _Utils_eq(
					$author$project$Components$Referentiel$Common$Contact$usageCode(usage),
					code);
			},
			$author$project$Components$Referentiel$Common$Contact$usages);
		if (_v0.b) {
			var usage = _v0.a;
			return A3(
				$author$project$Components$Referentiel$Common$Contact$surLaLigne,
				rang,
				function (ligne) {
					return _Utils_update(
						ligne,
						{sd: usage});
				},
				lignes);
		} else {
			return lignes;
		}
	});
var $author$project$Components$Referentiel$Fiche$Rattacher$ajouterUneLigne = F2(
	function (canal, lignes) {
		var rang = $elm$core$List$length(lignes);
		return A3(
			$author$project$Components$Referentiel$Common$Contact$setUsage,
			rang,
			$author$project$Components$Referentiel$Common$Contact$usageCode(1),
			A3(
				$author$project$Components$Referentiel$Common$Contact$setCanal,
				rang,
				$author$project$Components$Referentiel$Common$Contact$canalCode(canal),
				$author$project$Components$Referentiel$Common$Contact$ajouter(lignes)));
	});
var $author$project$Components$Referentiel$Fiche$Rattacher$maximum = 10;
var $author$project$Components$Referentiel$Fiche$Rattacher$complet = function (saisie) {
	return _Utils_cmp(
		$elm$core$List$length(saisie.wa),
		$author$project$Components$Referentiel$Fiche$Rattacher$maximum) > -1;
};
var $author$project$Components$Referentiel$Fiche$Rattacher$ajouterUnContact = function (saisie) {
	return $author$project$Components$Referentiel$Fiche$Rattacher$complet(saisie) ? saisie : _Utils_update(
		saisie,
		{
			wa: A2($author$project$Components$Referentiel$Fiche$Rattacher$ajouterUneLigne, 0, saisie.wa)
		});
};
var $author$project$Components$Referentiel$Fiche$Contacts$annuler = function (etat) {
	return _Utils_update(
		etat,
		{ae: false, zT: $author$project$Components$Referentiel$Fiche$Contacts$Ferme, a7: $elm$core$Maybe$Nothing, pN: $elm$core$Maybe$Nothing});
};
var $author$project$Components$Referentiel$Fiche$Model$annulerLEdition = function (model) {
	return _Utils_update(
		model,
		{fX: false, cD: $elm$core$Maybe$Nothing, dI: false, ge: $author$project$Components$Referentiel$Fiche$Model$Fermee, bI: false, c7: _List_Nil, b2: false, b3: $elm$core$Maybe$Nothing});
};
var $author$project$Components$Referentiel$Fiche$Liaisons$fermer = function (etat) {
	return _Utils_update(
		etat,
		{j6: $author$project$Components$Referentiel$Fiche$Liaisons$NonDemandee, aX: false, mW: $author$project$Components$Referentiel$Fiche$Liaisons$Aucun, bU: false, bV: false, pZ: $elm$core$Maybe$Nothing, rn: _List_Nil, P: false});
};
var $author$project$Components$Referentiel$Fiche$Liaisons$annulerLaConfirmation = function (etat) {
	var _v0 = etat.mW;
	if (_v0.$ === 2) {
		return $author$project$Components$Referentiel$Fiche$Liaisons$fermer(etat);
	} else {
		return _Utils_update(
			etat,
			{j6: $author$project$Components$Referentiel$Fiche$Liaisons$NonDemandee});
	}
};
var $author$project$Components$Referentiel$Fiche$Update$AttendreAvantDeChercherUnDoublon = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Model$DansLeDrawerDIdentite = {$: 3};
var $author$project$Components$Referentiel$Fiche$Model$IdentifiantLegal = 7;
var $author$project$Components$Referentiel$Fiche$Model$Pays = 5;
var $author$project$Components$Referentiel$Fiche$Model$criteresDeLIdentifiant = F2(
	function (pays, saisie) {
		var valeur = $elm$core$String$trim(saisie);
		return ((pays === '') || (valeur === '')) ? $elm$core$Maybe$Nothing : (((pays === 'FR') && (!A2(
			$elm$core$List$member,
			$elm$core$String$length(
				A2($elm$core$String$filter, $elm$core$Char$isDigit, valeur)),
			_List_fromArray(
				[9, 14])))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			{ho: pays, fm: valeur}));
	});
var $author$project$Components$Referentiel$Common$RechercheDeFiche$delaiMs = 300;
var $author$project$Components$Referentiel$Fiche$Model$saisieDe = F2(
	function (cle, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var de = _v0.a;
							return _Utils_eq(de, cle);
						},
						model.c7))));
	});
var $author$project$Components$Referentiel$Fiche$Update$apresLaSaisie = F2(
	function (cle, model) {
		if (_Utils_eq(model.ge, $author$project$Components$Referentiel$Fiche$Model$DansLeDrawerDIdentite) && ((cle === 7) || (cle === 5))) {
			var numero = model.pT + 1;
			var suivant = _Utils_update(
				model,
				{cD: $elm$core$Maybe$Nothing, dI: false, pT: numero, b3: $elm$core$Maybe$Nothing});
			return _Utils_Tuple2(
				suivant,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (_v0) {
							return _List_fromArray(
								[
									A2($author$project$Components$Referentiel$Fiche$Update$AttendreAvantDeChercherUnDoublon, numero, $author$project$Components$Referentiel$Common$RechercheDeFiche$delaiMs)
								]);
						},
						A2(
							$author$project$Components$Referentiel$Fiche$Model$criteresDeLIdentifiant,
							A2($author$project$Components$Referentiel$Fiche$Model$saisieDe, 5, model),
							A2($author$project$Components$Referentiel$Fiche$Model$saisieDe, 7, model)))));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$AttendreAvantDeChercher = F2(
	function (a, b) {
		return {$: 31, a: a, b: b};
	});
var $author$project$Components$Referentiel$Common$RechercheDeFiche$aChercher = function (recherche) {
	var terme = $elm$core$String$trim(recherche.h3);
	return (_Utils_eq(recherche.ve, $elm$core$Maybe$Nothing) && ($elm$core$String$length(terme) >= 2)) ? $elm$core$Maybe$Just(terme) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$Referentiel$Fiche$Liaisons$saisieDeLaRecherche = function (etat) {
	var _v0 = etat.mW;
	switch (_v0.$) {
		case 4:
			var saisie = _v0.b;
			return $elm$core$Maybe$Just(saisie.hC);
		case 5:
			var saisie = _v0.b;
			return $elm$core$Maybe$Just(saisie.hC);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Fiche$Update$attendre = function (model) {
	var _v0 = $author$project$Components$Referentiel$Fiche$Liaisons$saisieDeLaRecherche(model.Bk);
	if (!_v0.$) {
		var recherche = _v0.a;
		return _Utils_Tuple2(
			model,
			_Utils_eq(
				$author$project$Components$Referentiel$Common$RechercheDeFiche$aChercher(recherche),
				$elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
				[
					A2($author$project$Components$Referentiel$Fiche$Update$AttendreAvantDeChercher, recherche.hP, $author$project$Components$Referentiel$Common$RechercheDeFiche$delaiMs)
				]));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Fiche$Resume$basculer = F2(
	function (liste, depliees) {
		switch (liste) {
			case 0:
				return _Utils_update(
					depliees,
					{wa: !depliees.wa});
			case 1:
				return _Utils_update(
					depliees,
					{GY: !depliees.GY});
			default:
				return _Utils_update(
					depliees,
					{Hu: !depliees.Hu});
		}
	});
var $author$project$Components$Referentiel$Fiche$Contacts$basculerLeMenu = F2(
	function (uid, etat) {
		return _Utils_update(
			etat,
			{
				a7: _Utils_eq(
					etat.a7,
					$elm$core$Maybe$Just(uid)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(uid)
			});
	});
var $author$project$Components$Referentiel$Fiche$Contacts$basculerLesAnciens = function (etat) {
	return _Utils_update(
		etat,
		{dl: !etat.dl});
};
var $author$project$Components$Referentiel$Fiche$Update$ChercherDesFiches = F2(
	function (a, b) {
		return {$: 29, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$contexteDeLaRecherche = function (etat) {
	var _v0 = etat.mW;
	switch (_v0.$) {
		case 4:
			var contexte = _v0.a;
			return $elm$core$Maybe$Just(contexte);
		case 5:
			var contexte = _v0.a;
			return $elm$core$Maybe$Just(contexte);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Common$RechercheDeFiche$corps = F2(
	function (cherchee, terme) {
		return {
			dw: _List_Nil,
			jF: _List_Nil,
			gt: $elm$core$Maybe$Nothing,
			m2: $elm$core$Maybe$Nothing,
			g1: function () {
				switch (cherchee) {
					case 0:
						return $elm$core$Maybe$Just('Personne');
					case 1:
						return $elm$core$Maybe$Just('Organisation');
					default:
						return $elm$core$Maybe$Nothing;
				}
			}(),
			D1: $elm$core$Maybe$Nothing,
			ho: $elm$core$Maybe$Nothing,
			hy: $elm$core$Maybe$Nothing,
			h3: $elm$core$Maybe$Just(terme),
			ib: _List_Nil
		};
	});
var $author$project$Components$Referentiel$Common$RechercheDeFiche$delaiEcoule = F2(
	function (saisie, recherche) {
		return _Utils_eq(saisie, recherche.hP) ? $author$project$Components$Referentiel$Common$RechercheDeFiche$aChercher(recherche) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$Referentiel$Fiche$PerimetreDeRelation$autreCote = F2(
	function (direct, perimetre) {
		return direct ? perimetre.vf : perimetre.IR;
	});
var $author$project$Components$Referentiel$Fiche$PerimetreDeRelation$filtreDeRecherche = function (cote) {
	var organisations = !_Utils_eq(cote.o3, $author$project$Components$Referentiel$Fiche$PerimetreDeRelation$AucuneOrganisation);
	var _v0 = _Utils_Tuple3(organisations, cote.hs, cote.hr);
	_v0$4:
	while (true) {
		if (_v0.a) {
			if ((!_v0.b) && (!_v0.c)) {
				return {
					g1: $elm$core$Maybe$Just('Organisation'),
					hy: $elm$core$Maybe$Nothing
				};
			} else {
				break _v0$4;
			}
		} else {
			if (_v0.b) {
				if (_v0.c) {
					return {
						g1: $elm$core$Maybe$Just('Personne'),
						hy: $elm$core$Maybe$Nothing
					};
				} else {
					return {
						g1: $elm$core$Maybe$Just('Personne'),
						hy: $elm$core$Maybe$Just('Professionnel')
					};
				}
			} else {
				if (_v0.c) {
					return {
						g1: $elm$core$Maybe$Just('Personne'),
						hy: $elm$core$Maybe$Just('Particulier')
					};
				} else {
					break _v0$4;
				}
			}
		}
	}
	return {g1: $elm$core$Maybe$Nothing, hy: $elm$core$Maybe$Nothing};
};
var $author$project$Components$Referentiel$Fiche$PerimetreDeRelation$admet = F2(
	function (categorie, cote) {
		switch (categorie.$) {
			case 0:
				return cote.hs;
			case 1:
				return cote.hr;
			default:
				var forme = categorie.a;
				var _v1 = cote.o3;
				switch (_v1.$) {
					case 0:
						return false;
					case 1:
						return true;
					default:
						var formes = _v1.a;
						return A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$map,
								function (f) {
									return A2($elm$core$List$member, f, formes);
								},
								forme));
				}
		}
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$admisePour = F2(
	function (categorie, phrase) {
		if (!categorie.$) {
			var connue = categorie.a;
			return A2(
				$author$project$Components$Referentiel$Fiche$PerimetreDeRelation$admet,
				connue,
				A2($author$project$Components$Referentiel$Fiche$PerimetreDeRelation$autreCote, !phrase.xA, phrase.E9));
		} else {
			return true;
		}
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$ouverteDe = function (etat) {
	var _v0 = etat.mW;
	if (_v0.$ === 5) {
		var contexte = _v0.a;
		return contexte.uK;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Fiche$Liaisons$phrases = function (etat) {
	return A2(
		$elm$core$List$concatMap,
		function (connu) {
			var dans = F2(
				function (direct, libelle) {
					return {
						xA: direct,
						Bl: libelle,
						E9: connu.E9,
						r0: connu.r8,
						fm: _Utils_ap(
							$author$project$Components$Referentiel$Identifiants$typeRelationUidToString(connu.r8),
							direct ? ':direct' : ':inverse')
					};
				});
			return A2(
				$elm$core$List$filter,
				$author$project$Components$Referentiel$Fiche$Liaisons$admisePour(
					$author$project$Components$Referentiel$Fiche$Liaisons$ouverteDe(etat)),
				function () {
					var _v0 = _Utils_Tuple2(connu.G6, connu.Bo);
					if ((!_v0.a) && (!_v0.b.$)) {
						var inverse = _v0.b.a;
						return _List_fromArray(
							[
								A2(dans, true, connu.Bn),
								A2(dans, false, inverse)
							]);
					} else {
						return _List_fromArray(
							[
								A2(dans, true, connu.Bn)
							]);
					}
				}());
		},
		etat.ib);
};
var $author$project$Components$Referentiel$Fiche$Liaisons$filtrerLaRelation = F2(
	function (etat, recherche) {
		var _v0 = etat.mW;
		if (_v0.$ === 5) {
			var saisie = _v0.b;
			var _v1 = A2(
				$elm$core$List$filter,
				function (proposee) {
					return _Utils_eq(proposee.fm, saisie.Fp);
				},
				$author$project$Components$Referentiel$Fiche$Liaisons$phrases(etat));
			if (_v1.b) {
				var choisie = _v1.a;
				var filtre = $author$project$Components$Referentiel$Fiche$PerimetreDeRelation$filtreDeRecherche(
					A2($author$project$Components$Referentiel$Fiche$PerimetreDeRelation$autreCote, choisie.xA, choisie.E9));
				return _Utils_update(
					recherche,
					{g1: filtre.g1, hy: filtre.hy});
			} else {
				return recherche;
			}
		} else {
			return recherche;
		}
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$rechercheAEnvoyer = F2(
	function (saisie, etat) {
		return A3(
			$elm$core$Maybe$map2,
			F2(
				function (contexte, terme) {
					return A2(
						$author$project$Components$Referentiel$Fiche$Liaisons$filtrerLaRelation,
						etat,
						A2($author$project$Components$Referentiel$Common$RechercheDeFiche$corps, contexte.fN, terme));
				}),
			$author$project$Components$Referentiel$Fiche$Liaisons$contexteDeLaRecherche(etat),
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Components$Referentiel$Common$RechercheDeFiche$delaiEcoule(saisie),
				$author$project$Components$Referentiel$Fiche$Liaisons$saisieDeLaRecherche(etat)));
	});
var $author$project$API$NavLinksDictionary$entites = 'entites';
var $author$project$API$NavLinksDictionary$variableTri = 'tri';
var $author$project$Components$Referentiel$Liens$versEntites = F2(
	function (demandee, gabarits) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$API$NavLinksDictionary$variablePage,
						$elm$core$String$fromInt(demandee.EE)),
						_Utils_Tuple2(
						$author$project$API$NavLinksDictionary$variableTaille,
						$elm$core$String$fromInt(demandee.Jm)),
						_Utils_Tuple2($author$project$API$NavLinksDictionary$variableTri, demandee.rS)
					])),
			A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$entites, gabarits));
	});
var $author$project$Components$Referentiel$Fiche$Update$chercher = F2(
	function (saisie, model) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$Components$Referentiel$Fiche$Liaisons$rechercheAEnvoyer, saisie, model.Bk),
			A2(
				$author$project$Components$Referentiel$Liens$versEntites,
				{
					EE: 1,
					Jm: $author$project$Routes$Route$premierePage.Jm,
					rS: $author$project$Routes$Route$codeDuTri(0)
				},
				model.gF));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var recherche = _v0.a.a;
			var lien = _v0.b.a;
			return _Utils_Tuple2(
				model,
				_List_fromArray(
					[
						A2($author$project$Components$Referentiel$Fiche$Update$ChercherDesFiches, lien, recherche)
					]));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$ChercherUnDoublon = F4(
	function (a, b, c, d) {
		return {$: 2, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Referentiel$Fiche$Update$chercherLeDoublon = F2(
	function (numero, model) {
		return _Utils_eq(numero, model.pT) ? _Utils_Tuple2(
			model,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A3(
					$elm$core$Maybe$map2,
					F2(
						function (lien, criteres) {
							return _List_fromArray(
								[
									A4($author$project$Components$Referentiel$Fiche$Update$ChercherUnDoublon, lien, numero, criteres.ho, criteres.fm)
								]);
						}),
					model.nH,
					A2(
						$author$project$Components$Referentiel$Fiche$Model$criteresDeLIdentifiant,
						A2($author$project$Components$Referentiel$Fiche$Model$saisieDe, 5, model),
						A2($author$project$Components$Referentiel$Fiche$Model$saisieDe, 7, model))))) : _Utils_Tuple2(model, _List_Nil);
	});
var $author$project$Components$Referentiel$Common$RechercheDeFiche$choisir = F2(
	function (uid, recherche) {
		var _v0 = A2(
			$elm$core$List$filter,
			function (proposition) {
				return _Utils_eq(proposition.r8, uid);
			},
			recherche.Gw);
		if (_v0.b) {
			var proposition = _v0.a;
			return _Utils_update(
				recherche,
				{
					ve: $elm$core$Maybe$Just(proposition),
					Gw: _List_Nil
				});
		} else {
			return recherche;
		}
	});
var $author$project$Components$Referentiel$Fiche$Historique$Dossiers = 2;
var $author$project$Components$Referentiel$Fiche$Historique$Echanges = 3;
var $author$project$Components$Referentiel$Fiche$Historique$estActive = function (famille) {
	return (famille !== 2) && (famille !== 3);
};
var $author$project$Components$Referentiel$Fiche$Historique$EnCours = 1;
var $author$project$Components$Referentiel$Fiche$Historique$relire = function (etat) {
	return _Utils_update(
		etat,
		{u7: 1, np: etat.np + 1, an: false, I6: $elm$core$Maybe$Nothing});
};
var $author$project$Components$Referentiel$Fiche$Historique$choisirLaFamille = F2(
	function (famille, etat) {
		return (_Utils_eq(famille, etat.zj) || (!A2(
			$elm$core$Maybe$withDefault,
			true,
			A2($elm$core$Maybe$map, $author$project$Components$Referentiel$Fiche$Historique$estActive, famille)))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Components$Referentiel$Fiche$Historique$relire(
				_Utils_update(
					etat,
					{zj: famille, gV: _List_Nil})));
	});
var $author$project$Components$Referentiel$Fiche$Historique$choisirLaSource = F2(
	function (source, etat) {
		return _Utils_eq(source, etat.IR) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Components$Referentiel$Fiche$Historique$relire(
				_Utils_update(
					etat,
					{gV: _List_Nil, IR: source})));
	});
var $author$project$Components$Referentiel$Fiche$Roles$ChangerLeStatut = 0;
var $author$project$Components$Referentiel$Fiche$Roles$Clore = 2;
var $author$project$Components$Referentiel$Fiche$Roles$ModifierLaFin = 3;
var $author$project$Components$Referentiel$Fiche$Roles$Remplacer = 1;
var $author$project$Components$Referentiel$Fiche$Roles$choixOfferts = function (role) {
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$first,
		A2(
			$elm$core$List$filter,
			function (_v0) {
				var lien = _v0.b;
				return !_Utils_eq(lien, $elm$core$Maybe$Nothing);
			},
			_List_fromArray(
				[
					_Utils_Tuple2(0, role.u6),
					_Utils_Tuple2(1, role.ql),
					_Utils_Tuple2(2, role.zk),
					_Utils_Tuple2(3, role.od)
				])));
};
var $author$project$Components$Referentiel$Fiche$Historique$Indisponibles = {$: 1};
var $author$project$Components$Referentiel$Fiche$Historique$Paire = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Historique$SansValeurs = {$: 0};
var $author$project$Components$Referentiel$Fiche$Historique$AgentIA = {$: 4};
var $author$project$Components$Referentiel$Fiche$Historique$LaPersonne = {$: 3};
var $author$project$Components$Referentiel$Fiche$Historique$ParApi = {$: 6};
var $author$project$Components$Referentiel$Fiche$Historique$ParImport = {$: 5};
var $author$project$Components$Referentiel$Fiche$Historique$Systeme = {$: 7};
var $author$project$Components$Referentiel$Fiche$Historique$UtilisateurInterne = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Fiche$Historique$UtilisateurRetire = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Fiche$Historique$Vous = {$: 0};
var $author$project$Components$Referentiel$Fiche$API$ToModel$auteur = function (vue) {
	var _v0 = _Utils_Tuple2(vue.gB, vue.og);
	switch (_v0.a) {
		case 'Utilisateur':
			if (_v0.b) {
				return $author$project$Components$Referentiel$Fiche$Historique$Vous;
			} else {
				return vue.HZ ? $author$project$Components$Referentiel$Fiche$Historique$UtilisateurRetire(vue.Dj) : $author$project$Components$Referentiel$Fiche$Historique$UtilisateurInterne(vue.Dj);
			}
		case 'Visiteur':
			return $author$project$Components$Referentiel$Fiche$Historique$LaPersonne;
		case 'Agent':
			return $author$project$Components$Referentiel$Fiche$Historique$AgentIA;
		case 'Import':
			return $author$project$Components$Referentiel$Fiche$Historique$ParImport;
		case 'Api':
			return $author$project$Components$Referentiel$Fiche$Historique$ParApi;
		default:
			return $author$project$Components$Referentiel$Fiche$Historique$Systeme;
	}
};
var $author$project$Components$Referentiel$Fiche$API$ToModel$ficheCitee = function (vue) {
	return {
		Dj: function () {
			var _v0 = A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[vue.GR, vue.Gg, vue.Dj]));
			if (!_v0.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var presents = _v0;
				return $elm$core$Maybe$Just(
					A2($elm$core$String$join, ' ', presents));
			}
		}(),
		rp: !_Utils_eq(vue.IA, $elm$core$Maybe$Nothing),
		r8: vue.r8
	};
};
var $author$project$I18n$Textes$referentielRoleOffreIndisponible = A3($author$project$I18n$Traductions$texte, 'referentiel.role.offre-indisponible', _List_Nil, 'Offre non disponible');
var $author$project$Components$Referentiel$Fiche$API$ToModel$nomDOffre = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map($author$project$I18n$Traductions$tel),
	$elm$core$Maybe$withDefault($author$project$I18n$Textes$referentielRoleOffreIndisponible));
var $author$project$I18n$Textes$jourEnClair = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'jour.en-clair',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'jour',
				$author$project$I18n$Traductions$Sous(p.A_)),
				_Utils_Tuple2(
				'mois',
				$author$project$I18n$Traductions$Sous(p.CQ)),
				_Utils_Tuple2(
				'annee',
				$author$project$I18n$Traductions$Sous(p.tk))
			]),
		'{jour} {mois} {annee}');
};
var $author$project$Texte$Jour$lire = F2(
	function (noms, jour) {
		var _v0 = A2($elm$core$String$split, '-', jour);
		if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
			var annee = _v0.a;
			var _v1 = _v0.b;
			var rang = _v1.a;
			var _v2 = _v1.b;
			var numero = _v2.a;
			var _v3 = _Utils_Tuple3(
				A2(
					$elm$core$Maybe$andThen,
					function (lu) {
						return A2($elm$core$Array$get, lu - 1, noms);
					},
					$elm$core$String$toInt(rang)),
				$elm$core$String$toInt(numero),
				($elm$core$String$length(annee) === 4) && A2($elm$core$String$all, $elm$core$Char$isDigit, annee));
			if (((!_v3.a.$) && (!_v3.b.$)) && _v3.c) {
				var nom = _v3.a.a;
				var quantieme = _v3.b.a;
				return $elm$core$Maybe$Just(
					_Utils_Tuple3(
						$elm$core$String$fromInt(quantieme),
						nom,
						annee));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$I18n$Textes$jourMois01 = A3($author$project$I18n$Traductions$texte, 'jour.mois.01', _List_Nil, 'janv.');
var $author$project$I18n$Textes$jourMois02 = A3($author$project$I18n$Traductions$texte, 'jour.mois.02', _List_Nil, 'févr.');
var $author$project$I18n$Textes$jourMois03 = A3($author$project$I18n$Traductions$texte, 'jour.mois.03', _List_Nil, 'mars');
var $author$project$I18n$Textes$jourMois04 = A3($author$project$I18n$Traductions$texte, 'jour.mois.04', _List_Nil, 'avr.');
var $author$project$I18n$Textes$jourMois05 = A3($author$project$I18n$Traductions$texte, 'jour.mois.05', _List_Nil, 'mai');
var $author$project$I18n$Textes$jourMois06 = A3($author$project$I18n$Traductions$texte, 'jour.mois.06', _List_Nil, 'juin');
var $author$project$I18n$Textes$jourMois07 = A3($author$project$I18n$Traductions$texte, 'jour.mois.07', _List_Nil, 'juil.');
var $author$project$I18n$Textes$jourMois08 = A3($author$project$I18n$Traductions$texte, 'jour.mois.08', _List_Nil, 'août');
var $author$project$I18n$Textes$jourMois09 = A3($author$project$I18n$Traductions$texte, 'jour.mois.09', _List_Nil, 'sept.');
var $author$project$I18n$Textes$jourMois10 = A3($author$project$I18n$Traductions$texte, 'jour.mois.10', _List_Nil, 'oct.');
var $author$project$I18n$Textes$jourMois11 = A3($author$project$I18n$Traductions$texte, 'jour.mois.11', _List_Nil, 'nov.');
var $author$project$I18n$Textes$jourMois12 = A3($author$project$I18n$Traductions$texte, 'jour.mois.12', _List_Nil, 'déc.');
var $author$project$Texte$Jour$mois = $elm$core$Array$fromList(
	_List_fromArray(
		[$author$project$I18n$Textes$jourMois01, $author$project$I18n$Textes$jourMois02, $author$project$I18n$Textes$jourMois03, $author$project$I18n$Textes$jourMois04, $author$project$I18n$Textes$jourMois05, $author$project$I18n$Textes$jourMois06, $author$project$I18n$Textes$jourMois07, $author$project$I18n$Textes$jourMois08, $author$project$I18n$Textes$jourMois09, $author$project$I18n$Textes$jourMois10, $author$project$I18n$Textes$jourMois11, $author$project$I18n$Textes$jourMois12]));
var $author$project$Texte$Jour$enClair = function (jour) {
	var _v0 = A2($author$project$Texte$Jour$lire, $author$project$Texte$Jour$mois, jour);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var quantieme = _v1.a;
		var nom = _v1.b;
		var annee = _v1.c;
		return $author$project$I18n$Textes$jourEnClair(
			{
				tk: $author$project$I18n$Traductions$tel(annee),
				A_: $author$project$I18n$Traductions$tel(quantieme),
				CQ: nom
			});
	} else {
		return $author$project$I18n$Traductions$tel(jour);
	}
};
var $author$project$I18n$Textes$referentielFicheHistoriqueDate = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'referentiel.fiche.historique.date',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'jour',
				$author$project$I18n$Traductions$Sous(p.A_)),
				_Utils_Tuple2(
				'heure',
				$author$project$I18n$Traductions$Sous(p.Ah))
			]),
		'{jour} à {heure}');
};
var $author$project$Components$Referentiel$Fiche$API$ToModel$quand = F2(
	function (jour, heure) {
		return $author$project$I18n$Textes$referentielFicheHistoriqueDate(
			{
				Ah: $author$project$I18n$Traductions$tel(heure),
				A_: $author$project$Texte$Jour$enClair(jour)
			});
	});
var $author$project$Components$Referentiel$Fiche$Historique$Agent = 2;
var $author$project$Components$Referentiel$Fiche$Historique$Api = 4;
var $author$project$Components$Referentiel$Fiche$Historique$Import = 3;
var $author$project$Components$Referentiel$Fiche$Historique$Interface = 0;
var $author$project$Components$Referentiel$Fiche$Historique$Portail = 1;
var $author$project$Components$Referentiel$Fiche$API$ToModel$source = function (code) {
	switch (code) {
		case 'Interface':
			return $elm$core$Maybe$Just(0);
		case 'Portail':
			return $elm$core$Maybe$Just(1);
		case 'Agent':
			return $elm$core$Maybe$Just(2);
		case 'Import':
			return $elm$core$Maybe$Just(3);
		case 'Api':
			return $elm$core$Maybe$Just(4);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Fiche$Historique$Citees = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Referentiel$Fiche$Historique$Connue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Fiche$Historique$Effacee = {$: 2};
var $author$project$Components$Referentiel$Fiche$Historique$Expiree = {$: 3};
var $author$project$Components$Referentiel$Fiche$Historique$Vide = {$: 0};
var $author$project$Referentiel$Normes$nomDePays = F2(
	function (_v0, code) {
		var normes = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			code,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Dj;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.vx;
							},
							$elm$core$Basics$eq(code)),
						normes.ho))));
	});
var $author$project$Components$Referentiel$Fiche$API$ToModel$adresseSurUneLigne = F2(
	function (normes, adresse) {
		var pays = A2($author$project$Referentiel$Normes$nomDePays, normes, adresse.ho);
		return A2(
			$elm$core$String$join,
			', ',
			_Utils_ap(
				adresse.gV,
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_List_fromArray(
									[
										adresse.vz,
										$elm$core$Maybe$Just(adresse.B_)
									])))
						]),
					_Utils_ap(
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[adresse.Hj])),
						_List_fromArray(
							[pays])))));
	});
var $author$project$Components$Referentiel$Fiche$API$ToModel$valeur = F2(
	function (normes, vue) {
		switch (vue.$) {
			case 0:
				return $author$project$Components$Referentiel$Fiche$Historique$Vide;
			case 1:
				var texte = vue.a;
				return $author$project$Components$Referentiel$Fiche$Historique$Connue(texte);
			case 2:
				var postale = vue.a;
				return $author$project$Components$Referentiel$Fiche$Historique$Connue(
					A2($author$project$Components$Referentiel$Fiche$API$ToModel$adresseSurUneLigne, normes, postale));
			case 4:
				var noms = vue.a;
				return $author$project$Components$Referentiel$Fiche$Historique$Citees(noms);
			default:
				var motif = vue.a;
				return A2($elm$core$String$startsWith, 'echeance', motif) ? $author$project$Components$Referentiel$Fiche$Historique$Expiree : $author$project$Components$Referentiel$Fiche$Historique$Effacee;
		}
	});
var $author$project$Components$Referentiel$Fiche$API$ToModel$ligneDeChronologie = F2(
	function (normes, vue) {
		return {
			t1: $author$project$Components$Referentiel$Fiche$API$ToModel$auteur(vue.t1),
			uN: A3(
				$elm$core$Maybe$map2,
				F2(
					function (nom, lien) {
						return {nB: lien, Dj: nom};
					}),
				vue.uN,
				vue.Ak),
			uP: A2(
				$elm$core$Maybe$map,
				function (cite) {
					return {Bl: cite.Bl, HZ: cite.HZ};
				},
				vue.uP),
			yT: vue.yT,
			zp: A2($elm$core$Maybe$map, $author$project$Components$Referentiel$Fiche$API$ToModel$ficheCitee, vue.zp),
			D1: A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Dj;
					},
					$author$project$Components$Referentiel$Fiche$API$ToModel$nomDOffre),
				vue.D1),
			hz: A2($author$project$Components$Referentiel$Fiche$API$ToModel$quand, vue.A_, vue.Ah),
			IR: A2($elm$core$Maybe$andThen, $author$project$Components$Referentiel$Fiche$API$ToModel$source, vue.IR),
			Ki: function () {
				var _v0 = vue.Ki;
				if (_v0.$ === 1) {
					return $author$project$Components$Referentiel$Fiche$Historique$SansValeurs;
				} else {
					var recues = _v0.a;
					var _v1 = _Utils_Tuple2(recues.xB, recues.iY);
					if (_v1.a && (!_v1.b.$)) {
						var apres = _v1.b.a;
						return A2(
							$author$project$Components$Referentiel$Fiche$Historique$Paire,
							A2(
								$elm$core$Maybe$map,
								$author$project$Components$Referentiel$Fiche$API$ToModel$valeur(normes),
								recues.je),
							A2($author$project$Components$Referentiel$Fiche$API$ToModel$valeur, normes, apres));
					} else {
						return $author$project$Components$Referentiel$Fiche$Historique$Indisponibles;
					}
				}
			}()
		};
	});
var $author$project$Components$Referentiel$Fiche$API$ToModel$chronologie = F2(
	function (normes, vue) {
		return {
			gV: A2(
				$elm$core$List$map,
				$author$project$Components$Referentiel$Fiche$API$ToModel$ligneDeChronologie(normes),
				vue.gV),
			I6: vue.I6
		};
	});
var $author$project$Components$Referentiel$Fiche$Update$EffacerUnContact = F4(
	function (a, b, c, d) {
		return {$: 24, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Referentiel$Fiche$Model$EnCours = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$ProgrammerLEffacement = F5(
	function (a, b, c, d, e) {
		return {$: 23, a: a, b: b, c: c, d: d, e: e};
	});
var $author$project$Components$Referentiel$Fiche$Effacement$codeDuMotif = function (motif) {
	if (!motif) {
		return 'demande';
	} else {
		return 'autre';
	}
};
var $author$project$Components$Referentiel$Fiche$Effacement$borneDeLaPrecision = 500;
var $author$project$Components$Referentiel$Fiche$Effacement$peutConfirmer = function (etat) {
	return (etat.hP === 'EFFACER') && function () {
		var _v0 = _Utils_Tuple2(etat.v8, etat.cX);
		if (!_v0.a.$) {
			return true;
		} else {
			if (_v0.b.$ === 1) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return false;
			} else {
				if (!_v0.b.a) {
					var _v3 = _v0.a;
					var _v4 = _v0.b.a;
					return true;
				} else {
					var _v5 = _v0.a;
					var _v6 = _v0.b.a;
					var precision = $elm$core$String$trim(etat.Gd);
					return (precision !== '') && (_Utils_cmp(
						$elm$core$String$length(precision),
						$author$project$Components$Referentiel$Fiche$Effacement$borneDeLaPrecision) < 1);
				}
			}
		}
	}();
};
var $author$project$Components$Referentiel$Fiche$Effacement$Autre = 1;
var $author$project$Components$Referentiel$Fiche$Effacement$motifPrecise = function (etat) {
	return _Utils_eq(
		etat.cX,
		$elm$core$Maybe$Just(1));
};
var $author$project$Components$Referentiel$Fiche$Effacement$precisionAEnvoyer = function (etat) {
	return $author$project$Components$Referentiel$Fiche$Effacement$motifPrecise(etat) ? $elm$core$Maybe$Just(
		$elm$core$String$trim(etat.Gd)) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$Referentiel$Fiche$Update$confirmerLEffacement = function (model) {
	var _v0 = _Utils_Tuple3(
		model.gt,
		model.l2,
		$author$project$Components$Referentiel$Fiche$Effacement$peutConfirmer(model.x9));
	if (((_v0.a.$ === 1) && (_v0.b.$ === 1)) && _v0.c) {
		var fiche = _v0.a.a;
		var processUid = _v0.b.a;
		var _v1 = _Utils_Tuple2(model.x9.v8, model.x9.cX);
		if (!_v1.a.$) {
			var contact = _v1.a.a;
			var _v2 = contact.lM;
			if (!_v2.$) {
				var lien = _v2.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: $author$project$Components$Referentiel$Fiche$Model$EnCours(processUid)
						}),
					_List_fromArray(
						[
							A4($author$project$Components$Referentiel$Fiche$Update$EffacerUnContact, lien, processUid, fiche.r8, contact.r8)
						]));
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			if (!_v1.b.$) {
				var _v3 = _v1.a;
				var motif = _v1.b.a;
				var _v4 = fiche.lM;
				if (!_v4.$) {
					var lien = _v4.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l2: $author$project$Components$Referentiel$Fiche$Model$EnCours(processUid)
							}),
						_List_fromArray(
							[
								A5(
								$author$project$Components$Referentiel$Fiche$Update$ProgrammerLEffacement,
								lien,
								processUid,
								fiche.r8,
								$author$project$Components$Referentiel$Fiche$Effacement$codeDuMotif(motif),
								$author$project$Components$Referentiel$Fiche$Effacement$precisionAEnvoyer(model.x9))
							]));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			} else {
				var _v5 = _v1.a;
				var _v6 = _v1.b;
				return _Utils_Tuple2(model, _List_Nil);
			}
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Fiche$Update$ExporterLesDonnees = F5(
	function (a, b, c, d, e) {
		return {$: 25, a: a, b: b, c: c, d: d, e: e};
	});
var $author$project$Components$Referentiel$Fiche$Export$formatsChoisis = function (etat) {
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				etat.gO ? $elm$core$Maybe$Just('json') : $elm$core$Maybe$Nothing,
				etat.f3 ? $elm$core$Maybe$Just('csv') : $elm$core$Maybe$Nothing
			]));
};
var $author$project$Components$Referentiel$Fiche$Export$peutConfirmer = function (etat) {
	return (etat.wv !== '') && ((!_Utils_eq(etat.tq, $elm$core$Maybe$Nothing)) && (!$elm$core$List$isEmpty(
		$author$project$Components$Referentiel$Fiche$Export$formatsChoisis(etat))));
};
var $author$project$Components$Referentiel$Fiche$Update$confirmerLExport = function (model) {
	var _v0 = _Utils_Tuple2(model.gt, model.l2);
	if ((_v0.a.$ === 1) && (_v0.b.$ === 1)) {
		var fiche = _v0.a.a;
		var processUid = _v0.b.a;
		var _v1 = _Utils_Tuple2(
			fiche.za,
			$author$project$Components$Referentiel$Fiche$Export$peutConfirmer(model.ms));
		if ((!_v1.a.$) && _v1.b) {
			var lien = _v1.a.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: $author$project$Components$Referentiel$Fiche$Model$EnCours(processUid)
					}),
				_List_fromArray(
					[
						A5(
						$author$project$Components$Referentiel$Fiche$Update$ExporterLesDonnees,
						lien,
						processUid,
						fiche.r8,
						$author$project$Components$Referentiel$Fiche$Export$formatsChoisis(model.ms),
						model.ms.wv)
					]));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Fiche$CycleDeVie$Clore = 0;
var $author$project$Components$Referentiel$Fiche$Update$CloreLaFiche = F4(
	function (a, b, c, d) {
		return {$: 19, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Referentiel$Fiche$Update$EnvoyerUnGeste = F3(
	function (a, b, c) {
		return {$: 18, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Fiche$Update$caseCochee = function (model) {
	return model.vp && A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (apercu) {
				return apercu.Fh > 0;
			},
			model.ts));
};
var $author$project$Components$Referentiel$Fiche$CycleDeVie$lienDe = F2(
	function (geste, fiche) {
		switch (geste) {
			case 0:
				return fiche.vo;
			case 1:
				return fiche.Ii;
			case 2:
				return fiche.Jc;
			case 3:
				return fiche.HS;
			default:
				return fiche.tp;
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$envoyerLeGeste = F2(
	function (geste, model) {
		var _v0 = _Utils_Tuple2(model.gt, model.l2);
		if ((_v0.a.$ === 1) && (_v0.b.$ === 1)) {
			var fiche = _v0.a.a;
			var processUid = _v0.b.a;
			var _v1 = A2($author$project$Components$Referentiel$Fiche$CycleDeVie$lienDe, geste, fiche);
			if (!_v1.$) {
				var lien = _v1.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: $author$project$Components$Referentiel$Fiche$Model$EnCours(processUid)
						}),
					_List_fromArray(
						[
							(!geste) ? A4(
							$author$project$Components$Referentiel$Fiche$Update$CloreLaFiche,
							lien,
							processUid,
							fiche.r8,
							$author$project$Components$Referentiel$Fiche$Update$caseCochee(model)) : A3($author$project$Components$Referentiel$Fiche$Update$EnvoyerUnGeste, lien, processUid, fiche.r8)
						]));
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$confirmerLeGeste = function (model) {
	var _v0 = model.kp;
	if (!_v0.$) {
		var geste = _v0.a;
		return A2($author$project$Components$Referentiel$Fiche$Update$envoyerLeGeste, geste, model);
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Fiche$Update$contactDe = F2(
	function (uid, model) {
		var _v0 = model.gt;
		if (_v0.$ === 1) {
			var fiche = _v0.a;
			return $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (contact) {
						return _Utils_eq(contact.r8, uid);
					},
					fiche.wa));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Referentiel$Common$RechercheDeFiche$Toutes = 2;
var $author$project$Components$Referentiel$Fiche$PerimetreDeRelation$Particulier = {$: 1};
var $author$project$Components$Referentiel$Fiche$PerimetreDeRelation$Professionnel = {$: 0};
var $author$project$Components$Referentiel$Fiche$Model$Qualite = 4;
var $author$project$Components$Referentiel$Fiche$PerimetreDeRelation$UneOrganisation = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$categorieDeLaFiche = function (fiche) {
	var _v0 = fiche.g1;
	if (_v0 === 1) {
		return $elm$core$Maybe$Just(
			$author$project$Components$Referentiel$Fiche$PerimetreDeRelation$UneOrganisation(fiche.gB));
	} else {
		var _v1 = A2(
			$elm$core$Maybe$andThen,
			$elm$core$Tuple$second,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v2) {
						var cle = _v2.a;
						return cle === 4;
					},
					fiche.dw)));
		_v1$2:
		while (true) {
			if (!_v1.$) {
				switch (_v1.a) {
					case 'Professionnel':
						return $elm$core$Maybe$Just($author$project$Components$Referentiel$Fiche$PerimetreDeRelation$Professionnel);
					case 'Particulier':
						return $elm$core$Maybe$Just($author$project$Components$Referentiel$Fiche$PerimetreDeRelation$Particulier);
					default:
						break _v1$2;
				}
			} else {
				break _v1$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$I18n$Textes$referentielFicheTitreEffacee = A3($author$project$I18n$Traductions$texte, 'referentiel.fiche.titre-effacee', _List_Nil, 'Personne effacée');
var $author$project$Components$Referentiel$Fiche$Model$Civilite = 0;
var $author$project$Components$Referentiel$Fiche$Model$Nom = 2;
var $author$project$Components$Referentiel$Fiche$Model$Personne = 0;
var $author$project$Components$Referentiel$Fiche$Model$Prenom = 1;
var $author$project$I18n$Textes$referentielCiviliteMadame = A3($author$project$I18n$Traductions$texte, 'referentiel.civilite.madame', _List_Nil, 'Madame');
var $author$project$I18n$Textes$referentielCiviliteMonsieur = A3($author$project$I18n$Traductions$texte, 'referentiel.civilite.monsieur', _List_Nil, 'Monsieur');
var $author$project$Referentiel$Civilites$nom = function (code) {
	switch (code) {
		case 'Madame':
			return $author$project$I18n$Textes$referentielCiviliteMadame;
		case 'Monsieur':
			return $author$project$I18n$Textes$referentielCiviliteMonsieur;
		default:
			return $author$project$I18n$Traductions$tel(code);
	}
};
var $author$project$Components$Referentiel$Fiche$Model$RaisonSociale = 3;
var $author$project$I18n$Textes$referentielFicheNomMasque = A3($author$project$I18n$Traductions$texte, 'referentiel.fiche.nom-masque', _List_Nil, 'Nom masqué');
var $author$project$Components$Referentiel$Fiche$Model$nomDe = F2(
	function (nature, champs) {
		var valeur = function (cle) {
			return A2(
				$elm$core$Maybe$andThen,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v1) {
							var de = _v1.a;
							return _Utils_eq(de, cle);
						},
						champs)));
		};
		var lus = function () {
			if (!nature) {
				return A2(
					$elm$core$List$filterMap,
					valeur,
					_List_fromArray(
						[1, 2]));
			} else {
				return A2(
					$elm$core$List$filterMap,
					valeur,
					_List_fromArray(
						[3]));
			}
		}();
		return $elm$core$List$isEmpty(lus) ? $author$project$I18n$Textes$referentielFicheNomMasque : $author$project$I18n$Traductions$tel(
			A2($elm$core$String$join, ' ', lus));
	});
var $author$project$Components$Referentiel$Fiche$Model$titreDe = F2(
	function (nature, champs) {
		var valeur = function (cle) {
			return A2(
				$elm$core$Maybe$andThen,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var de = _v0.a;
							return _Utils_eq(de, cle);
						},
						champs)));
		};
		var civilite = ((!nature) && A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				valeur,
				$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
			_List_fromArray(
				[1, 2]))) ? A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $author$project$Referentiel$Civilites$nom, $elm$core$List$singleton),
				valeur(0))) : _List_Nil;
		return _Utils_ap(
			civilite,
			_List_fromArray(
				[
					A2($author$project$Components$Referentiel$Fiche$Model$nomDe, nature, champs)
				]));
	});
var $author$project$Components$Referentiel$Fiche$Model$titre = function (fiche) {
	return (fiche.gt === 4) ? _List_fromArray(
		[$author$project$I18n$Textes$referentielFicheTitreEffacee]) : A2($author$project$Components$Referentiel$Fiche$Model$titreDe, fiche.g1, fiche.dw);
};
var $author$project$Components$Referentiel$Fiche$Update$contexteDeLaRelation = function (model) {
	var _v0 = model.gt;
	if (_v0.$ === 1) {
		var fiche = _v0.a;
		return A2(
			$elm$core$Maybe$map,
			function (lien) {
				return {
					uK: $author$project$Components$Referentiel$Fiche$Update$categorieDeLaFiche(fiche),
					fN: 2,
					nB: lien,
					Dj: $author$project$Components$Referentiel$Fiche$Model$titre(fiche),
					Et: fiche.r8
				};
			},
			fiche.Hy);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Common$RechercheDeFiche$Organisations = 1;
var $author$project$Components$Referentiel$Common$RechercheDeFiche$Personnes = 0;
var $author$project$Components$Referentiel$Fiche$Update$contexteDuRattachement = function (model) {
	var _v0 = model.gt;
	if (_v0.$ === 1) {
		var fiche = _v0.a;
		return A2(
			$elm$core$Maybe$map,
			function (lien) {
				return {
					uK: $elm$core$Maybe$Nothing,
					fN: (fiche.g1 === 1) ? 0 : 1,
					nB: lien,
					Dj: $author$project$Components$Referentiel$Fiche$Model$titre(fiche),
					Et: fiche.r8
				};
			},
			fiche.GZ);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Fiche$Historique$demanderLaSuite = function (etat) {
	var _v0 = _Utils_Tuple3(etat.I6, etat.an || etat.c9, etat.u7);
	if (((!_v0.a.$) && (!_v0.b)) && (_v0.c === 2)) {
		var lien = _v0.a.a;
		var _v1 = _v0.c;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(
				_Utils_update(
					etat,
					{an: true}),
				lien));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$ARetirer = F3(
	function (contexte, champ, occurrence) {
		return {uN: champ, ka: contexte, D$: occurrence};
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$aRetirer = $author$project$Components$Shared$EditeurDeSchema$Groupe$ARetirer;
var $author$project$Components$Referentiel$Fiche$Occurrences$champDe = F2(
	function (schema, cle) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.dy;
					},
					$elm$core$Basics$eq(cle)),
				schema.dw));
	});
var $author$project$Components$Referentiel$Fiche$Model$schemaDuType = F2(
	function (type_, model) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$eq(type_)),
					model.hR)));
	});
var $author$project$Components$Referentiel$Fiche$Update$leGroupe = F3(
	function (type_, cle, model) {
		var _v0 = _Utils_Tuple2(
			model.gt,
			A2($author$project$Components$Referentiel$Fiche$Model$schemaDuType, type_, model));
		if ((_v0.a.$ === 1) && (!_v0.b.$)) {
			var fiche = _v0.a.a;
			var schema = _v0.b.a;
			return A3(
				$elm$core$Maybe$map2,
				F2(
					function (bloc, champ) {
						return {fJ: bloc, uN: champ, zo: fiche, aN: schema};
					}),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.r0;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.r8;
								},
								$elm$core$Basics$eq(type_))),
						fiche.uW)),
				A2($author$project$Components$Referentiel$Fiche$Occurrences$champDe, schema, cle));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Referentiel$Fiche$Occurrences$liensDe = F2(
	function (bloc, cle) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.nQ;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.uN;
							},
							$elm$core$Basics$eq(cle)),
						bloc.dw))));
	});
var $author$project$Components$Referentiel$Fiche$Occurrences$lienDe = F3(
	function (rel, bloc, cle) {
		return A2(
			$author$project$API$Liens$trouver,
			rel,
			A2($author$project$Components$Referentiel$Fiche$Occurrences$liensDe, bloc, cle));
	});
var $author$project$I18n$Choix$GenreFeminin = 0;
var $author$project$I18n$Choix$GenreMasculin = 1;
var $author$project$I18n$Traductions$Option = function (a) {
	return {$: 2, a: a};
};
var $author$project$I18n$Choix$codeGenre = function (choix) {
	if (!choix) {
		return 'feminin';
	} else {
		return 'masculin';
	}
};
var $author$project$I18n$Textes$groupeDeSousChampsOccurrenceIndefinie = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'groupe-de-sous-champs.occurrence-indefinie',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'genre',
				$author$project$I18n$Traductions$Option(
					$author$project$I18n$Choix$codeGenre(p.M))),
				_Utils_Tuple2(
				'occurrence',
				$author$project$I18n$Traductions$Sous(p.D$))
			]),
		'{genre, select, feminin {une {occurrence}} masculin {un {occurrence}}}');
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$avecArticle = F2(
	function (genre, libelle) {
		return $author$project$I18n$Textes$groupeDeSousChampsOccurrenceIndefinie(
			{
				M: function () {
					if (!genre) {
						return 0;
					} else {
						return 1;
					}
				}(),
				D$: $author$project$I18n$Traductions$tel(libelle)
			});
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$occurrenceAvecArticle = function (contenu) {
	return A2($author$project$Components$Shared$EditeurDeSchema$Groupe$avecArticle, contenu.z9, contenu.Bq);
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$occurrences = function (valeur) {
	if (valeur.$ === 8) {
		var lues = valeur.a;
		return lues;
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Referentiel$Fiche$Update$surLesOccurrences = F2(
	function (change, model) {
		return _Utils_update(
			model,
			{
				oV: change(model.oV)
			});
	});
var $author$project$Components$Referentiel$Fiche$Update$ouvrirLeDrawerDesOccurrences = F3(
	function (declencheur, change, model) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{Il: false},
			$author$project$Components$Shared$Drawer$Update$Ouvrir(declencheur),
			model.oV.kX);
		var drawer = _v0.a;
		var effets = _v0.b;
		return _Utils_Tuple2(
			A2(
				$author$project$Components$Referentiel$Fiche$Update$surLesOccurrences,
				function (etat) {
					return change(
						_Utils_update(
							etat,
							{kX: drawer}));
				},
				model),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Referentiel$Fiche$Update$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$API$NavLinksDictionary$retirerUneOccurrence = 'retirer-une-occurrence';
var $author$project$Components$Shared$EditeurDeSchema$Groupe$sousChampsDe = function (champ) {
	var _v0 = champ.r0;
	if (_v0.$ === 22) {
		var contenu = _v0.a;
		return $elm$core$Maybe$Just(contenu);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Fiche$Occurrences$valeurDe = F2(
	function (bloc, cle) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Occurrences(_List_Nil),
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.fm;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.uN;
							},
							$elm$core$Basics$eq(cle)),
						bloc.dw))));
	});
var $author$project$Components$Referentiel$Fiche$Update$demanderLeRetraitDUneOccurrence = F4(
	function (type_, cle, uid, model) {
		var _v0 = A3($author$project$Components$Referentiel$Fiche$Update$leGroupe, type_, cle, model);
		if (!_v0.$) {
			var bloc = _v0.a.fJ;
			var champ = _v0.a.uN;
			var contexte = {jN: _List_Nil, zu: _List_Nil, nn: 'fr', R: _List_Nil, hd: model.hd};
			var _v1 = _Utils_Tuple2(
				A3($author$project$Components$Referentiel$Fiche$Occurrences$lienDe, $author$project$API$NavLinksDictionary$retirerUneOccurrence, bloc, cle),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.r8;
							},
							$elm$core$Basics$eq(uid)),
						$author$project$Components$Shared$EditeurDeSchema$Groupe$occurrences(
							A2($author$project$Components$Referentiel$Fiche$Occurrences$valeurDe, bloc, cle)))));
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var lue = _v1.b.a;
				return A3(
					$author$project$Components$Referentiel$Fiche$Update$ouvrirLeDrawerDesOccurrences,
					'groupe-' + cle,
					function (etat) {
						return _Utils_update(
							etat,
							{
								dh: $elm$core$Maybe$Just(
									{
										uN: cle,
										Dj: A3($author$project$Components$Shared$EditeurDeSchema$Groupe$aRetirer, contexte, champ, lue),
										D$: A2(
											$elm$core$Maybe$withDefault,
											$author$project$I18n$Traductions$tel(champ.Bl),
											A2(
												$elm$core$Maybe$map,
												$author$project$Components$Shared$EditeurDeSchema$Groupe$occurrenceAvecArticle,
												$author$project$Components$Shared$EditeurDeSchema$Groupe$sousChampsDe(champ))),
										r0: type_,
										r8: uid
									}),
								Et: $elm$core$Maybe$Nothing,
								J8: false
							});
					},
					model);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$LireLApercuDeLaCloture = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$CycleDeVie$idDeLaBoite = 'fiche-cycle-de-vie';
var $author$project$Components$Referentiel$Fiche$CycleDeVie$idDuDeclencheur = function (geste) {
	switch (geste) {
		case 0:
			return $author$project$Components$Referentiel$Fiche$CycleDeVie$idDeLaBoite + '-clore';
		case 1:
			return $author$project$Components$Referentiel$Fiche$CycleDeVie$idDeLaBoite + '-rouvrir';
		case 2:
			return $author$project$Components$Referentiel$Fiche$CycleDeVie$idDeLaBoite + '-supprimer';
		case 3:
			return $author$project$Components$Referentiel$Fiche$CycleDeVie$idDeLaBoite + '-restaurer';
		default:
			return $author$project$Components$Referentiel$Fiche$CycleDeVie$idDeLaBoite + '-annuler-l-effacement';
	}
};
var $author$project$Components$Referentiel$Fiche$Update$ouvrirLeCycle = F3(
	function (geste, fiche, model) {
		var aLire = function () {
			var _v2 = _Utils_Tuple2(geste, fiche.ts);
			if ((!_v2.a) && (!_v2.b.$)) {
				var _v3 = _v2.a;
				var lien = _v2.b.a;
				return _List_fromArray(
					[
						A2($author$project$Components$Referentiel$Fiche$Update$LireLApercuDeLaCloture, fiche.r8, lien)
					]);
			} else {
				return _List_Nil;
			}
		}();
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{Il: false},
			$author$project$Components$Shared$Drawer$Update$Ouvrir(
				$author$project$Components$Referentiel$Fiche$CycleDeVie$idDuDeclencheur(geste)),
			model.lr);
		var drawer = _v0.a;
		var effets = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					ts: $elm$core$Maybe$Nothing,
					vp: false,
					kp: $elm$core$Maybe$Just(geste),
					lr: drawer
				}),
			_Utils_ap(
				aLire,
				A2(
					$elm$core$List$map,
					function (_v1) {
						var cible = _v1;
						return $author$project$Components$Referentiel$Fiche$Update$PlacerFocus(cible);
					},
					effets)));
	});
var $author$project$Components$Referentiel$Fiche$CycleDeVie$AnnulerLEffacement = 4;
var $author$project$Components$Referentiel$Fiche$CycleDeVie$Supprimer = 2;
var $author$project$Components$Referentiel$Fiche$CycleDeVie$requiertUneConfirmation = function (geste) {
	return (!geste) || ((geste === 2) || (geste === 4));
};
var $author$project$Components$Referentiel$Fiche$Update$demanderUnGeste = F2(
	function (geste, model) {
		var _v0 = _Utils_Tuple2(model.gt, model.l2);
		if ((_v0.a.$ === 1) && (_v0.b.$ === 1)) {
			var fiche = _v0.a.a;
			var _v1 = A2($author$project$Components$Referentiel$Fiche$CycleDeVie$lienDe, geste, fiche);
			if (_v1.$ === 1) {
				return _Utils_Tuple2(model, _List_Nil);
			} else {
				return $author$project$Components$Referentiel$Fiche$CycleDeVie$requiertUneConfirmation(geste) ? A3($author$project$Components$Referentiel$Fiche$Update$ouvrirLeCycle, geste, fiche, model) : A2($author$project$Components$Referentiel$Fiche$Update$envoyerLeGeste, geste, model);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Fiche$Model$setDoublonDuDrawer = F2(
	function (doublon, model) {
		return _Utils_update(
			model,
			{cD: doublon});
	});
var $author$project$Components$Referentiel$Fiche$Model$setSocieteDuDrawer = F2(
	function (societe, model) {
		return _Utils_update(
			model,
			{
				b2: model.b2 && _Utils_eq(societe, model.b3),
				b3: societe
			});
	});
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$societesDeLIdentifiantDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'societesARattacher',
			$elm$json$Json$Decode$list($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$autreFiche)),
			$elm$json$Json$Decode$succeed(_List_Nil)
		]));
var $author$project$Components$Referentiel$Fiche$Update$doublonRecu = F3(
	function (numero, reponse, model) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$autresFichesDeLIdentifiantDecoder, reponse),
			model.gt);
		if (!_v0.a.$) {
			if (_v0.b.$ === 1) {
				var candidats = _v0.a.a;
				var fiche = _v0.b.a;
				var autre = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (candidat) {
							return !_Utils_eq(candidat.r8, fiche.r8);
						},
						candidats));
				return _Utils_Tuple2(
					_Utils_eq(numero, model.pT) ? A2(
						$author$project$Components$Referentiel$Fiche$Model$setSocieteDuDrawer,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (societe) {
									return !_Utils_eq(societe.r8, fiche.r8);
								},
								A2(
									$elm$core$Result$withDefault,
									_List_Nil,
									A2($elm$json$Json$Decode$decodeString, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$societesDeLIdentifiantDecoder, reponse.f$)))),
						A2($author$project$Components$Referentiel$Fiche$Model$setDoublonDuDrawer, autre, model)) : model,
					_List_Nil);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			var refus = _v0.a.a;
			return _Utils_Tuple2(
				model,
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Referentiel$Fiche$Update$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Fiche$Historique$EnErreur = 3;
var $author$project$Components$Referentiel$Fiche$Historique$echouer = F2(
	function (lecture, etat) {
		return (!_Utils_eq(lecture, etat.np)) ? etat : (etat.an ? _Utils_update(
			etat,
			{an: false, c9: true}) : _Utils_update(
			etat,
			{u7: 3}));
	});
var $author$project$Components$Referentiel$Fiche$Historique$surLePanneau = F3(
	function (lecture, change, etat) {
		var _v0 = etat.bR;
		if (!_v0.$) {
			var panneau = _v0.a;
			return _Utils_eq(panneau.np, lecture) ? _Utils_update(
				etat,
				{
					bR: $elm$core$Maybe$Just(
						change(panneau))
				}) : etat;
		} else {
			return etat;
		}
	});
var $author$project$Components$Referentiel$Fiche$Historique$echouerLePanneau = F2(
	function (lecture, etat) {
		return A3(
			$author$project$Components$Referentiel$Fiche$Historique$surLePanneau,
			lecture,
			function (panneau) {
				return _Utils_update(
					panneau,
					{u7: 3});
			},
			etat);
	});
var $author$project$Components$Referentiel$Fiche$Historique$codeDeLaFamille = function (famille) {
	if (famille.$ === 1) {
		return '';
	} else {
		switch (famille.a) {
			case 0:
				var _v1 = famille.a;
				return 'modifications';
			case 1:
				var _v2 = famille.a;
				return 'roles';
			case 2:
				var _v3 = famille.a;
				return 'dossiers';
			case 3:
				var _v4 = famille.a;
				return 'echanges';
			default:
				var _v5 = famille.a;
				return 'donnees-personnelles';
		}
	}
};
var $author$project$Components$Referentiel$Fiche$Historique$codeDeLaSource = function (source) {
	if (source.$ === 1) {
		return '';
	} else {
		switch (source.a) {
			case 0:
				var _v1 = source.a;
				return 'interface';
			case 1:
				var _v2 = source.a;
				return 'portail';
			case 2:
				var _v3 = source.a;
				return 'agent';
			case 3:
				var _v4 = source.a;
				return 'import';
			default:
				var _v5 = source.a;
				return 'api';
		}
	}
};
var $author$project$API$NavLinksDictionary$variableFamille = 'famille';
var $author$project$API$NavLinksDictionary$variableSource = 'source';
var $author$project$Components$Referentiel$Fiche$Update$lienDeLaChronologie = F2(
	function (fiche, historique) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$API$NavLinksDictionary$variableFamille,
						$author$project$Components$Referentiel$Fiche$Historique$codeDeLaFamille(historique.zj)),
						_Utils_Tuple2(
						$author$project$API$NavLinksDictionary$variableSource,
						$author$project$Components$Referentiel$Fiche$Historique$codeDeLaSource(historique.IR))
					])),
			fiche.m6);
	});
var $author$project$Components$Referentiel$Fiche$Update$lireLaChronologie = F2(
	function (historique, model) {
		var _v0 = _Utils_Tuple2(model.gt, model.kD);
		if ((_v0.a.$ === 1) && (!_v0.b.$)) {
			var fiche = _v0.a.a;
			var uid = _v0.b.a;
			var _v1 = A2($author$project$Components$Referentiel$Fiche$Update$lienDeLaChronologie, fiche, historique);
			if (!_v1.$) {
				var lien = _v1.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{m6: historique}),
					_List_fromArray(
						[
							A3($author$project$Components$Referentiel$Fiche$Update$LireLaChronologie, uid, historique.np, lien)
						]));
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$filtrer = F2(
	function (choisir, model) {
		var _v0 = choisir(model.m6);
		if (!_v0.$) {
			var historique = _v0.a;
			return A2($author$project$Components$Referentiel$Fiche$Update$lireLaChronologie, historique, model);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Fiche$API$ToModel$historiqueDuChamp = F2(
	function (normes, vue) {
		return {
			Fe: vue.Fe,
			Ki: A2(
				$elm$core$List$map,
				function (recue) {
					return {
						sV: recue.sV,
						t1: $author$project$Components$Referentiel$Fiche$API$ToModel$auteur(recue.t1),
						y5: A2($elm$core$Maybe$map, $author$project$Texte$Jour$enClair, recue.y4),
						hz: A2($author$project$Components$Referentiel$Fiche$API$ToModel$quand, recue.A_, recue.Ah),
						IR: A2($elm$core$Maybe$andThen, $author$project$Components$Referentiel$Fiche$API$ToModel$source, recue.IR),
						fm: A2($author$project$Components$Referentiel$Fiche$API$ToModel$valeur, normes, recue.fm)
					};
				},
				vue.Ki)
		};
	});
var $author$project$Components$Referentiel$Fiche$Update$idDeLAjoutDeContact = 'fiche-contact-ajouter';
var $author$project$Components$Referentiel$Fiche$Update$idDesGestesDeContact = function (uid) {
	return 'fiche-contact-gerer-' + uid;
};
var $author$project$Components$Referentiel$Fiche$Liaisons$idDuDeclencheurDeFin = function (uid) {
	return 'rattachement-fin-' + $author$project$Components$Referentiel$Identifiants$rattachementUidToString(uid);
};
var $author$project$Components$Referentiel$Fiche$Liaisons$idDuDeclencheurDeModification = function (uid) {
	return 'rattachement-modifier-' + $author$project$Components$Referentiel$Identifiants$rattachementUidToString(uid);
};
var $author$project$Components$Referentiel$Fiche$Liaisons$idDuDeclencheurDeRattachement = 'rattachement-rattacher';
var $author$project$Components$Referentiel$Fiche$Liaisons$idDuDeclencheurDeRelation = 'relation-ajouter';
var $author$project$Components$Referentiel$Fiche$Liaisons$idDuPrincipal = 'rattachement-principal';
var $author$project$Components$Referentiel$Fiche$Liaisons$idDeLaBoite = function (etat) {
	var _v0 = etat.mW;
	switch (_v0.$) {
		case 3:
			return $author$project$Components$Referentiel$Fiche$Liaisons$idDuPrincipal + '-confirmation';
		case 4:
			return $author$project$Components$Referentiel$Fiche$Liaisons$idDuPrincipal + '-confirmation';
		default:
			return $author$project$Components$Referentiel$Fiche$Liaisons$idDeLaConfirmation;
	}
};
var $author$project$Components$Referentiel$Fiche$Liaisons$idDuRenoncement = function (etat) {
	return $author$project$Components$Referentiel$Fiche$Liaisons$idDeLaBoite(etat) + '-renoncer';
};
var $author$project$I18n$Textes$referentielPosteAchats = A3($author$project$I18n$Traductions$texte, 'referentiel.poste.achats', _List_Nil, 'Achats');
var $author$project$I18n$Textes$referentielPosteAutre = A3($author$project$I18n$Traductions$texte, 'referentiel.poste.autre', _List_Nil, 'Autre');
var $author$project$I18n$Textes$referentielPosteCommercial = A3($author$project$I18n$Traductions$texte, 'referentiel.poste.commercial', _List_Nil, 'Commercial');
var $author$project$I18n$Textes$referentielPosteDirectionAdministrativeEtFinanciere = A3($author$project$I18n$Traductions$texte, 'referentiel.poste.direction-administrative-et-financiere', _List_Nil, 'Direction administrative et financière');
var $author$project$I18n$Textes$referentielPosteDirectionGenerale = A3($author$project$I18n$Traductions$texte, 'referentiel.poste.direction-generale', _List_Nil, 'Direction générale');
var $author$project$I18n$Textes$referentielPosteMarketing = A3($author$project$I18n$Traductions$texte, 'referentiel.poste.marketing', _List_Nil, 'Marketing');
var $author$project$I18n$Textes$referentielPosteQualite = A3($author$project$I18n$Traductions$texte, 'referentiel.poste.qualite', _List_Nil, 'Qualité');
var $author$project$I18n$Textes$referentielPosteRelationsEcoles = A3($author$project$I18n$Traductions$texte, 'referentiel.poste.relations-ecoles', _List_Nil, 'Relations écoles');
var $author$project$I18n$Textes$referentielPosteRessourcesHumaines = A3($author$project$I18n$Traductions$texte, 'referentiel.poste.ressources-humaines', _List_Nil, 'Ressources humaines');
var $author$project$Components$Referentiel$Vocabulaire$postes = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('direction-generale', $author$project$I18n$Textes$referentielPosteDirectionGenerale),
			_Utils_Tuple2('direction-administrative-et-financiere', $author$project$I18n$Textes$referentielPosteDirectionAdministrativeEtFinanciere),
			_Utils_Tuple2('achats', $author$project$I18n$Textes$referentielPosteAchats),
			_Utils_Tuple2('qualite', $author$project$I18n$Textes$referentielPosteQualite),
			_Utils_Tuple2('commercial', $author$project$I18n$Textes$referentielPosteCommercial),
			_Utils_Tuple2('marketing', $author$project$I18n$Textes$referentielPosteMarketing),
			_Utils_Tuple2('ressources-humaines', $author$project$I18n$Textes$referentielPosteRessourcesHumaines),
			_Utils_Tuple2('relations-ecoles', $author$project$I18n$Textes$referentielPosteRelationsEcoles),
			_Utils_Tuple2('autre', $author$project$I18n$Textes$referentielPosteAutre)
		]));
var $author$project$Components$Referentiel$Vocabulaire$poste = function (code) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$I18n$Traductions$tel(code),
		A2($elm$core$Dict$get, code, $author$project$Components$Referentiel$Vocabulaire$postes));
};
var $author$project$Components$Referentiel$Vocabulaire$libelleDuPoste = function (vue) {
	var _v0 = _Utils_Tuple2(vue.Bl, vue.vx);
	if (!_v0.a.$) {
		var libelle = _v0.a.a;
		return $author$project$I18n$Traductions$tel(libelle);
	} else {
		if (!_v0.b.$) {
			var _v1 = _v0.a;
			var code = _v0.b.a;
			return $author$project$Components$Referentiel$Vocabulaire$poste(code);
		} else {
			var _v2 = _v0.a;
			var _v3 = _v0.b;
			return $author$project$I18n$Traductions$tel('');
		}
	}
};
var $author$project$Components$Referentiel$Fiche$Contacts$Ajout = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Contacts$Correction = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Fiche$Contacts$surLaLigne = F2(
	function (change, etat) {
		var changee = function (saisie) {
			return A2(
				$elm$core$Maybe$withDefault,
				saisie,
				$elm$core$List$head(
					change(
						_List_fromArray(
							[saisie]))));
		};
		var _v0 = etat.zT;
		switch (_v0.$) {
			case 0:
				return etat;
			case 1:
				var saisie = _v0.a;
				var tente = _v0.b;
				return _Utils_update(
					etat,
					{
						ae: false,
						zT: A2(
							$author$project$Components$Referentiel$Fiche$Contacts$Ajout,
							changee(saisie),
							tente)
					});
			default:
				var uid = _v0.a;
				var saisie = _v0.b;
				var tente = _v0.c;
				return _Utils_update(
					etat,
					{
						ae: false,
						zT: A3(
							$author$project$Components$Referentiel$Fiche$Contacts$Correction,
							uid,
							changee(saisie),
							tente)
					});
		}
	});
var $author$project$Components$Referentiel$Fiche$Contacts$lier = F2(
	function (uid, etat) {
		var _v0 = etat.zT;
		if (_v0.$ === 1) {
			var saisie = _v0.a;
			return A2(
				$elm$core$List$member,
				saisie.uF,
				_List_fromArray(
					[0, 1])) ? function (liee) {
				return _Utils_update(
					liee,
					{
						pN: $elm$core$Maybe$Just(uid)
					});
			}(
				A2(
					$author$project$Components$Referentiel$Fiche$Contacts$surLaLigne,
					A2(
						$author$project$Components$Referentiel$Common$Contact$setUsage,
						0,
						$author$project$Components$Referentiel$Common$Contact$usageCode(1)),
					etat)) : etat;
		} else {
			return etat;
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$lireLApercu = $author$project$API$Reponse$lire($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$apercuDeLEffacementDecoder);
var $author$project$Components$Referentiel$Fiche$Update$lireLesLiees = $author$project$API$Reponse$lire($author$project$Components$Referentiel$Fiche$API$QueryAPIModel$apercuDeLEffacementDUnContactDecoder);
var $author$project$Components$Referentiel$Fiche$Update$LirePostes = function (a) {
	return {$: 27, a: a};
};
var $author$project$API$NavLinksDictionary$postes = 'postes';
var $author$project$Components$Referentiel$Fiche$Update$lireLesPostes = function (_v0) {
	var model = _v0.a;
	var effets = _v0.b;
	var _v1 = _Utils_Tuple2(
		model.Bk.F6,
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$postes, model.GN));
	if ((!_v1.a.b) && (!_v1.b.$)) {
		var lien = _v1.b.a;
		return $elm$core$List$isEmpty(effets) ? _Utils_Tuple2(model, effets) : _Utils_Tuple2(
			model,
			_Utils_ap(
				effets,
				_List_fromArray(
					[
						$author$project$Components$Referentiel$Fiche$Update$LirePostes(lien)
					])));
	} else {
		return _Utils_Tuple2(model, effets);
	}
};
var $author$project$Components$Referentiel$Fiche$Update$LireTypesDeRelation = function (a) {
	return {$: 30, a: a};
};
var $author$project$API$NavLinksDictionary$typesDeRelation = 'types-de-relation';
var $author$project$Components$Referentiel$Fiche$Update$lireLesTypes = function (_v0) {
	var model = _v0.a;
	var effets = _v0.b;
	var _v1 = _Utils_Tuple2(
		model.Bk.ib,
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$typesDeRelation, model.GN));
	if ((!_v1.a.b) && (!_v1.b.$)) {
		var lien = _v1.b.a;
		return $elm$core$List$isEmpty(effets) ? _Utils_Tuple2(model, effets) : _Utils_Tuple2(
			model,
			_Utils_ap(
				effets,
				_List_fromArray(
					[
						$author$project$Components$Referentiel$Fiche$Update$LireTypesDeRelation(lien)
					])));
	} else {
		return _Utils_Tuple2(model, effets);
	}
};
var $author$project$Components$Referentiel$Fiche$Effacement$Demande = 0;
var $author$project$Components$Referentiel$Fiche$Effacement$motifDeCode = function (code) {
	switch (code) {
		case 'demande':
			return $elm$core$Maybe$Just(0);
		case 'autre':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Fiche$Roles$nommer = F2(
	function (types, role) {
		return A2(
			$elm$core$Maybe$withDefault,
			role,
			A2(
				$elm$core$Maybe$map,
				function (fourni) {
					return _Utils_update(
						role,
						{
							kf: fourni.kf,
							aC: fourni.aC,
							Bl: $author$project$I18n$Traductions$tel(fourni.Bl)
						});
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (fourni) {
							return _Utils_eq(fourni.r8, role.r0);
						},
						types))));
	});
var $author$project$Components$Referentiel$Fiche$Update$nommerLeDoublon = F2(
	function (types, doublon) {
		return _Utils_update(
			doublon,
			{
				eX: A2(
					$elm$core$List$map,
					function (role) {
						return A2(
							$elm$core$Maybe$withDefault,
							role,
							A2(
								$elm$core$Maybe$map,
								function (fourni) {
									return _Utils_update(
										role,
										{
											Bl: $author$project$I18n$Traductions$tel(fourni.Bl)
										});
								},
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (fourni) {
											return _Utils_eq(fourni.r8, role.r0);
										},
										types))));
					},
					doublon.eX)
			});
	});
var $author$project$Components$Referentiel$Fiche$Update$nommerLaFiche = F2(
	function (types, fiche) {
		return _Utils_update(
			fiche,
			{
				kW: A2(
					$elm$core$List$map,
					$author$project$Components$Referentiel$Fiche$Update$nommerLeDoublon(types),
					fiche.kW),
				eX: A2(
					$elm$core$List$map,
					$author$project$Components$Referentiel$Fiche$Roles$nommer(types),
					fiche.eX),
				H7: A2(
					$elm$core$List$map,
					$author$project$Components$Referentiel$Fiche$Roles$nommer(types),
					fiche.H7)
			});
	});
var $author$project$Components$Referentiel$Fiche$Update$nommerLesRoles = function (model) {
	var _v0 = model.gt;
	if (_v0.$ === 1) {
		var fiche = _v0.a;
		return _Utils_update(
			model,
			{
				gt: $author$project$Components$Referentiel$Fiche$Model$Lue(
					A2($author$project$Components$Referentiel$Fiche$Update$nommerLaFiche, model.bi.ib, fiche))
			});
	} else {
		return model;
	}
};
var $author$project$Components$Referentiel$Fiche$Roles$OffresIllisibles = {$: 2};
var $author$project$Components$Referentiel$Fiche$Roles$offresIllisibles = function (etat) {
	return _Utils_update(
		etat,
		{D3: $author$project$Components$Referentiel$Fiche$Roles$OffresIllisibles});
};
var $author$project$Components$Referentiel$Fiche$Roles$OffresLues = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Fiche$Roles$offresRecues = F2(
	function (offres, etat) {
		return _Utils_update(
			etat,
			{
				D3: $author$project$Components$Referentiel$Fiche$Roles$OffresLues(offres)
			});
	});
var $author$project$Components$Referentiel$Fiche$Roles$typesRecus = F2(
	function (types, etat) {
		return _Utils_update(
			etat,
			{ib: types});
	});
var $author$project$Components$Referentiel$Liens$versEntite = F2(
	function (uid, gabarits) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$API$NavLinksDictionary$variableUid,
						$author$project$Components$Referentiel$Identifiants$entiteUidToString(uid))
					])),
			A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$entite, gabarits));
	});
var $author$project$Components$Referentiel$Fiche$Update$ouvrir = F3(
	function (uid, gabarits, model) {
		var initial = $author$project$Components$Referentiel$Fiche$Model$init;
		var enRetard = _Utils_eq(
			model.lW,
			$elm$core$Maybe$Just(uid)) ? model.lW : $elm$core$Maybe$Nothing;
		var attendue = A2(
			$elm$core$Maybe$andThen,
			function (_v2) {
				var de = _v2.a;
				var saisie = _v2.b;
				return _Utils_eq(de, uid) ? $elm$core$Maybe$Just(
					_Utils_Tuple2(de, saisie)) : $elm$core$Maybe$Nothing;
			},
			model.tS);
		var _v0 = _Utils_Tuple3(
			model.gt,
			_Utils_eq(
				model.kD,
				$elm$core$Maybe$Just(uid)),
			A2($author$project$Components$Referentiel$Liens$versEntite, uid, gabarits));
		if (!_v0.c.$) {
			if ((_v0.a.$ === 1) && _v0.b) {
				return _Utils_Tuple2(model, _List_Nil);
			} else {
				var lien = _v0.c.a;
				return _Utils_Tuple2(
					_Utils_update(
						initial,
						{
							tS: attendue,
							kD: $elm$core$Maybe$Just(uid),
							lW: enRetard,
							l2: model.l2,
							mT: model.mT,
							gF: gabarits,
							nB: $elm$core$Maybe$Just(lien),
							nK: model.nK,
							GN: model.GN,
							bi: A2($author$project$Components$Referentiel$Fiche$Roles$typesRecus, model.bi.ib, $author$project$Components$Referentiel$Fiche$Roles$init)
						}),
					A2(
						$elm$core$List$cons,
						A2($author$project$Components$Referentiel$Fiche$Update$LireFiche, uid, lien),
						_Utils_eq(model.l2, $author$project$Components$Referentiel$Fiche$Model$SansProcessUid) ? _List_fromArray(
							[$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid]) : _List_Nil));
			}
		} else {
			var _v1 = _v0.c;
			return _Utils_Tuple2(
				_Utils_update(
					initial,
					{
						kD: $elm$core$Maybe$Just(uid),
						gt: $author$project$Components$Referentiel$Fiche$Model$Introuvable,
						GN: model.GN
					}),
				_List_Nil);
		}
	});
var $author$project$Components$Referentiel$Fiche$Contacts$adresseVide = {vz: '', a3: '', a4: '', a5: '', B_: '', ho: '', Hj: ''};
var $author$project$Components$Referentiel$Fiche$Contacts$ligneVide = {aa: $author$project$Components$Referentiel$Fiche$Contacts$adresseVide, uF: 0, px: false, Gx: false, sd: 0, fm: ''};
var $author$project$Components$Referentiel$Fiche$Contacts$ouvrirLAjout = function (etat) {
	return _Utils_update(
		etat,
		{
			ae: false,
			zT: A2($author$project$Components$Referentiel$Fiche$Contacts$Ajout, $author$project$Components$Referentiel$Fiche$Contacts$ligneVide, false),
			a7: $elm$core$Maybe$Nothing,
			pN: $elm$core$Maybe$Nothing
		});
};
var $author$project$Components$Referentiel$Fiche$Update$LireLApercuDeLEffacement = F2(
	function (a, b) {
		return {$: 21, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Effacement$idDuDeclencheur = 'fiche-effacer';
var $author$project$Components$Referentiel$Fiche$Update$ouvrirLEffacement = function (model) {
	var _v0 = _Utils_Tuple2(model.gt, model.l2);
	if ((_v0.a.$ === 1) && (_v0.b.$ === 1)) {
		var fiche = _v0.a.a;
		var _v1 = fiche.lM;
		if (_v1.$ === 1) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var init_ = $author$project$Components$Referentiel$Fiche$Effacement$init;
			var _v2 = A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Referentiel$Fiche$Effacement$idDuDeclencheur),
				model.x9.kX);
			var drawer = _v2.a;
			var effets = _v2.b;
			var ouvert = _Utils_update(
				model,
				{
					x9: _Utils_update(
						init_,
						{kX: drawer})
				});
			return _Utils_Tuple2(
				ouvert,
				_Utils_ap(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (lien) {
								return _List_fromArray(
									[
										A2($author$project$Components$Referentiel$Fiche$Update$LireLApercuDeLEffacement, fiche.r8, lien)
									]);
							},
							fiche.iU)),
					A2(
						$elm$core$List$map,
						function (_v3) {
							var cible = _v3;
							return $author$project$Components$Referentiel$Fiche$Update$PlacerFocus(cible);
						},
						effets)));
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Fiche$Effacement$idDuDeclencheurDuContact = function (uid) {
	return 'fiche-contact-effacer-' + uid;
};
var $author$project$Components$Referentiel$Fiche$Update$ouvrirLEffacementDUnContact = F2(
	function (uid, model) {
		var _v0 = _Utils_Tuple3(
			model.gt,
			model.l2,
			A2($author$project$Components$Referentiel$Fiche$Update$contactDe, uid, model));
		if (((_v0.a.$ === 1) && (_v0.b.$ === 1)) && (!_v0.c.$)) {
			var fiche = _v0.a.a;
			var contact = _v0.c.a;
			var _v1 = contact.lM;
			if (_v1.$ === 1) {
				return _Utils_Tuple2(model, _List_Nil);
			} else {
				var init = $author$project$Components$Referentiel$Fiche$Effacement$init;
				var _v2 = A3(
					$author$project$Components$Shared$Drawer$Update$update,
					{Il: false},
					$author$project$Components$Shared$Drawer$Update$Ouvrir(
						$author$project$Components$Referentiel$Fiche$Effacement$idDuDeclencheurDuContact(uid)),
					model.x9.kX);
				var drawer = _v2.a;
				var effets = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							x9: _Utils_update(
								init,
								{
									v8: $elm$core$Maybe$Just(contact),
									kX: drawer
								})
						}),
					_Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (lien) {
									return _List_fromArray(
										[
											A2($author$project$Components$Referentiel$Fiche$Update$LireLApercuDeLEffacement, fiche.r8, lien)
										]);
								},
								contact.iU)),
						A2(
							$elm$core$List$map,
							function (_v3) {
								var cible = _v3;
								return $author$project$Components$Referentiel$Fiche$Update$PlacerFocus(cible);
							},
							effets)));
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Fiche$Roles$Evolution = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Fiche$Roles$saisieVide = {vM: '', wv: '', D1: '', pZ: $elm$core$Maybe$Nothing, HW: '', b$: false, ri: '', P: false, r0: ''};
var $author$project$Components$Referentiel$Fiche$Roles$ouvrirLEvolution = F2(
	function (role, etat) {
		var _v0 = $author$project$Components$Referentiel$Fiche$Roles$choixOfferts(role);
		if (_v0.b) {
			var premier = _v0.a;
			return _Utils_update(
				etat,
				{
					zT: A3($author$project$Components$Referentiel$Fiche$Roles$Evolution, role.r8, premier, $author$project$Components$Referentiel$Fiche$Roles$saisieVide)
				});
		} else {
			return etat;
		}
	});
var $author$project$Components$Referentiel$Fiche$Export$idDuDeclencheur = 'fiche-exporter-declencheur';
var $author$project$Components$Referentiel$Fiche$Update$LireLApercuDeLExport = F3(
	function (a, b, c) {
		return {$: 22, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Fiche$Export$lienDeLApercu = F2(
	function (demande, lien) {
		if (!demande.$) {
			var date = demande.a;
			return _Utils_update(
				lien,
				{
					cM: lien.cM + ((A2($elm$core$String$contains, '?', lien.cM) ? '&' : '?') + ('demande=' + date))
				});
		} else {
			return lien;
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$lireLApercuDeLExport = F2(
	function (fiche, demande) {
		var _v0 = fiche.tr;
		if (!_v0.$) {
			var lien = _v0.a;
			return _List_fromArray(
				[
					A3(
					$author$project$Components$Referentiel$Fiche$Update$LireLApercuDeLExport,
					fiche.r8,
					A2($author$project$Components$Referentiel$Fiche$Export$lienDeLApercu, demande, lien),
					demande)
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$ouvrirLExport = function (model) {
	var _v0 = _Utils_Tuple2(model.gt, model.l2);
	if ((_v0.a.$ === 1) && (_v0.b.$ === 1)) {
		var fiche = _v0.a.a;
		var _v1 = fiche.za;
		if (_v1.$ === 1) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var init_ = $author$project$Components$Referentiel$Fiche$Export$init;
			var _v2 = A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Referentiel$Fiche$Export$idDuDeclencheur),
				model.ms.kX);
			var drawer = _v2.a;
			var effets = _v2.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						ms: _Utils_update(
							init_,
							{kX: drawer})
					}),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						function (_v3) {
							var cible = _v3;
							return $author$project$Components$Referentiel$Fiche$Update$PlacerFocus(cible);
						},
						effets),
					A2($author$project$Components$Referentiel$Fiche$Update$lireLApercuDeLExport, fiche, $elm$core$Maybe$Nothing)));
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Fiche$Update$LireLHistoriqueDuChamp = F3(
	function (a, b, c) {
		return {$: 34, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Fiche$Historique$ouvrirLePanneau = F2(
	function (champ, etat) {
		return _Utils_update(
			etat,
			{
				c$: etat.c$ + 1,
				bR: $elm$core$Maybe$Just(
					{uN: champ, u7: 1, np: etat.c$ + 1, Fe: false, Ki: _List_Nil})
			});
	});
var $author$project$Components$Referentiel$Fiche$Historique$fermerLePanneau = function (etat) {
	return _Utils_update(
		etat,
		{bR: $elm$core$Maybe$Nothing});
};
var $author$project$Components$Referentiel$Fiche$Update$surLHistorique = F2(
	function (change, model) {
		return _Utils_update(
			model,
			{
				m6: change(model.m6)
			});
	});
var $author$project$Components$Referentiel$Fiche$Update$surLeDrawerDeLHistorique = F2(
	function (msg, model) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{Il: false},
			msg,
			model.k9);
		var drawer = _v0.a;
		var effets = _v0.b;
		var suivant = _Utils_update(
			model,
			{k9: drawer});
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? suivant : A2($author$project$Components$Referentiel$Fiche$Update$surLHistorique, $author$project$Components$Referentiel$Fiche$Historique$fermerLePanneau, suivant),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Referentiel$Fiche$Update$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Referentiel$Fiche$Update$ouvrirLHistoriqueDuChamp = F3(
	function (champ, declencheur, model) {
		var _v0 = _Utils_Tuple2(model.gt, model.kD);
		if ((_v0.a.$ === 1) && (!_v0.b.$)) {
			var fiche = _v0.a.a;
			var uid = _v0.b.a;
			var _v1 = A2(
				$elm$core$Maybe$andThen,
				$author$project$API$Liens$resoudre(
					_List_fromArray(
						[
							_Utils_Tuple2($author$project$API$NavLinksDictionary$variableChamp, champ)
						])),
				fiche.Ak);
			if (!_v1.$) {
				var lien = _v1.a;
				var historique = A2($author$project$Components$Referentiel$Fiche$Historique$ouvrirLePanneau, champ, model.m6);
				var _v2 = A2(
					$author$project$Components$Referentiel$Fiche$Update$surLeDrawerDeLHistorique,
					$author$project$Components$Shared$Drawer$Update$Ouvrir(declencheur),
					_Utils_update(
						model,
						{m6: historique}));
				var ouvert = _v2.a;
				var effets = _v2.b;
				return _Utils_Tuple2(
					ouvert,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								A3($author$project$Components$Referentiel$Fiche$Update$LireLHistoriqueDuChamp, uid, historique.c$, lien)
							])));
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Fiche$Model$idDuDeclencheurDIdentite = 'fiche-identite-modifier';
var $author$project$Components$Referentiel$Fiche$Model$champsDeLIdentite = _List_fromArray(
	[3, 5, 7]);
var $author$project$Components$Referentiel$Fiche$Model$nomAuContrat = function (cle) {
	switch (cle) {
		case 0:
			return 'crm.entite.civilite';
		case 1:
			return 'crm.entite.prenom';
		case 2:
			return 'crm.entite.nom';
		case 3:
			return 'crm.entite.raisonSociale';
		case 4:
			return 'crm.entite.qualite';
		case 5:
			return 'crm.entite.pays';
		case 6:
			return 'crm.entite.langue';
		default:
			return 'crm.entite.identifiantLegal';
	}
};
var $author$project$Components$Referentiel$Fiche$Model$peutModifier = function (fiche) {
	return !_Utils_eq(fiche.ei, $elm$core$Maybe$Nothing);
};
var $author$project$Components$Referentiel$Fiche$Model$peutModifierLeChamp = F2(
	function (fiche, cle) {
		return $author$project$Components$Referentiel$Fiche$Model$peutModifier(fiche) && A2(
			$elm$core$List$member,
			$author$project$Components$Referentiel$Fiche$Model$nomAuContrat(cle),
			fiche.u_);
	});
var $author$project$Components$Referentiel$Common$IdentifiantLegal$groupe = function (chiffres) {
	return (($elm$core$String$length(chiffres) === 9) || ($elm$core$String$length(chiffres) === 14)) ? A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$filter,
			function (bloc) {
				return bloc !== '';
			},
			_List_fromArray(
				[
					A3($elm$core$String$slice, 0, 3, chiffres),
					A3($elm$core$String$slice, 3, 6, chiffres),
					A3($elm$core$String$slice, 6, 9, chiffres),
					A2($elm$core$String$dropLeft, 9, chiffres)
				]))) : chiffres;
};
var $author$project$Components$Referentiel$Fiche$Model$groupe = $author$project$Components$Referentiel$Common$IdentifiantLegal$groupe;
var $author$project$Components$Referentiel$Fiche$Model$valeurDe = F2(
	function (cle, fiche) {
		return A2(
			$elm$core$Maybe$andThen,
			$elm$core$Tuple$second,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var de = _v0.a;
						return _Utils_eq(de, cle);
					},
					fiche.dw)));
	});
var $author$project$Components$Referentiel$Fiche$Model$saisieInitiale = F2(
	function (fiche, cle) {
		var _v0 = _Utils_Tuple2(
			cle,
			A2($author$project$Components$Referentiel$Fiche$Model$valeurDe, 5, fiche));
		if (((_v0.a === 7) && (!_v0.b.$)) && (_v0.b.a === 'FR')) {
			var _v1 = _v0.a;
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$Referentiel$Fiche$Model$groupe,
					A2($author$project$Components$Referentiel$Fiche$Model$valeurDe, cle, fiche)));
		} else {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($author$project$Components$Referentiel$Fiche$Model$valeurDe, cle, fiche));
		}
	});
var $author$project$Components$Referentiel$Fiche$Model$ouvrirLIdentite = function (model) {
	var _v0 = _Utils_Tuple2(model.gt, model.ge);
	if ((_v0.a.$ === 1) && (!_v0.b.$)) {
		var fiche = _v0.a.a;
		var _v1 = _v0.b;
		return ((fiche.g1 === 1) && A2(
			$elm$core$List$any,
			$author$project$Components$Referentiel$Fiche$Model$peutModifierLeChamp(fiche),
			$author$project$Components$Referentiel$Fiche$Model$champsDeLIdentite)) ? _Utils_update(
			model,
			{
				cD: $elm$core$Maybe$Nothing,
				dI: false,
				ge: $author$project$Components$Referentiel$Fiche$Model$DansLeDrawerDIdentite,
				gI: false,
				c7: A2(
					$elm$core$List$map,
					function (cle) {
						return _Utils_Tuple2(
							cle,
							A2($author$project$Components$Referentiel$Fiche$Model$saisieInitiale, fiche, cle));
					},
					A2(
						$elm$core$List$filter,
						$author$project$Components$Referentiel$Fiche$Model$peutModifierLeChamp(fiche),
						$author$project$Components$Referentiel$Fiche$Model$champsDeLIdentite)),
				b2: false,
				b3: $elm$core$Maybe$Nothing
			}) : model;
	} else {
		return model;
	}
};
var $author$project$Components$Referentiel$Fiche$Update$ouvrirLIdentite = function (model) {
	var ouvert = $author$project$Components$Referentiel$Fiche$Model$ouvrirLIdentite(model);
	if (_Utils_eq(ouvert.ge, $author$project$Components$Referentiel$Fiche$Model$DansLeDrawerDIdentite)) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{Il: false},
			$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Referentiel$Fiche$Model$idDuDeclencheurDIdentite),
			model.k2);
		var drawer = _v0.a;
		var effets = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				ouvert,
				{k2: drawer}),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Referentiel$Fiche$Update$PlacerFocus(cible);
				},
				effets));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Fiche$Roles$Ouverture = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Fiche$Roles$ouvrirLOuverture = function (etat) {
	return _Utils_update(
		etat,
		{
			zT: $author$project$Components$Referentiel$Fiche$Roles$Ouverture($author$project$Components$Referentiel$Fiche$Roles$saisieVide)
		});
};
var $author$project$Components$Referentiel$Fiche$Liaisons$Fin = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$lienDeLaFin = function (rattachement) {
	var _v0 = rattachement.zK;
	if (_v0.$ === 1) {
		return rattachement.Jw;
	} else {
		return rattachement.od;
	}
};
var $author$project$Components$Referentiel$Fiche$Liaisons$nomDuDrawer = function (geste) {
	switch (geste.$) {
		case 3:
			return 'referentiel-rattachement-modifier';
		case 4:
			return 'referentiel-rattachement-rattacher';
		case 5:
			return 'referentiel-relation-ajouter';
		default:
			return $author$project$Components$Referentiel$Fiche$Liaisons$nomDuDrawerDeFin;
	}
};
var $author$project$Components$Referentiel$Fiche$Liaisons$ouvrirLaFin = F2(
	function (rattachement, etat) {
		var _v0 = _Utils_Tuple2(
			etat.mW,
			$author$project$Components$Referentiel$Fiche$Liaisons$lienDeLaFin(rattachement));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var _v1 = _v0.a;
			var geste = A2(
				$author$project$Components$Referentiel$Fiche$Liaisons$Fin,
				rattachement,
				A2($elm$core$Maybe$withDefault, '', rattachement.zK));
			var drawer = etat.kX;
			return _Utils_update(
				etat,
				{
					kX: _Utils_update(
						drawer,
						{
							Dj: $author$project$Components$Referentiel$Fiche$Liaisons$nomDuDrawer(geste)
						}),
					mW: geste,
					P: false
				});
		} else {
			return etat;
		}
	});
var $author$project$Components$Referentiel$Fiche$Contacts$ouvrirLaModification = F2(
	function (contact, etat) {
		return _Utils_update(
			etat,
			{
				ae: false,
				zT: A3($author$project$Components$Referentiel$Fiche$Contacts$Correction, contact.r8, contact.hP, false),
				a7: $elm$core$Maybe$Nothing
			});
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$Modification = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$saisieInitiale = function (rattachement) {
	return {
		AS: A2($elm$core$Maybe$withDefault, '', rattachement.AS),
		F4: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Maybe$map, $author$project$Components$Referentiel$Identifiants$posteUidToString, rattachement.F5)),
		px: rattachement.px
	};
};
var $author$project$Components$Referentiel$Fiche$Liaisons$ouvrirLaModification = F2(
	function (rattachement, etat) {
		var _v0 = _Utils_Tuple2(etat.mW, rattachement.u5);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var _v1 = _v0.a;
			var geste = A2(
				$author$project$Components$Referentiel$Fiche$Liaisons$Modification,
				rattachement,
				$author$project$Components$Referentiel$Fiche$Liaisons$saisieInitiale(rattachement));
			var drawer = etat.kX;
			return _Utils_update(
				etat,
				{
					kX: _Utils_update(
						drawer,
						{
							Dj: $author$project$Components$Referentiel$Fiche$Liaisons$nomDuDrawer(geste)
						}),
					mW: geste,
					P: false
				});
		} else {
			return etat;
		}
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$NouvelleRelation = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$ouvrirLaRelation = F2(
	function (contexte, etat) {
		var _v0 = etat.mW;
		if (!_v0.$) {
			var geste = A2(
				$author$project$Components$Referentiel$Fiche$Liaisons$NouvelleRelation,
				contexte,
				{Fp: '', hC: $author$project$Components$Referentiel$Common$RechercheDeFiche$vide});
			var drawer = etat.kX;
			return _Utils_update(
				etat,
				{
					kX: _Utils_update(
						drawer,
						{
							Dj: $author$project$Components$Referentiel$Fiche$Liaisons$nomDuDrawer(geste)
						}),
					mW: geste,
					P: false
				});
		} else {
			return etat;
		}
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$Suppression = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Fiche$Liaisons$ouvrirLaSuppression = F2(
	function (relation, etat) {
		var _v0 = _Utils_Tuple2(etat.mW, relation.w6);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var _v1 = _v0.a;
			return _Utils_update(
				etat,
				{
					mW: $author$project$Components$Referentiel$Fiche$Liaisons$Suppression(relation)
				});
		} else {
			return etat;
		}
	});
var $author$project$Components$Referentiel$Fiche$Model$DuBloc = {$: 2};
var $author$project$Components$Referentiel$Fiche$Model$Langue = 6;
var $author$project$Components$Referentiel$Fiche$Model$champsDe = function (nature) {
	if (!nature) {
		return _List_fromArray(
			[0, 1, 2, 4, 5, 6]);
	} else {
		return _List_fromArray(
			[3, 4, 5, 7, 6]);
	}
};
var $author$project$Components$Referentiel$Fiche$Model$peutModifierUnChamp = function (fiche) {
	return A2(
		$elm$core$List$any,
		$author$project$Components$Referentiel$Fiche$Model$peutModifierLeChamp(fiche),
		$author$project$Components$Referentiel$Fiche$Model$champsDe(fiche.g1));
};
var $author$project$Components$Referentiel$Fiche$Model$ouvrirLeBloc = function (model) {
	var _v0 = _Utils_Tuple2(model.gt, model.ge);
	if ((_v0.a.$ === 1) && (!_v0.b.$)) {
		var fiche = _v0.a.a;
		var _v1 = _v0.b;
		return $author$project$Components$Referentiel$Fiche$Model$peutModifierUnChamp(fiche) ? _Utils_update(
			model,
			{
				ge: $author$project$Components$Referentiel$Fiche$Model$DuBloc,
				c7: A2(
					$elm$core$List$map,
					function (cle) {
						return _Utils_Tuple2(
							cle,
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($author$project$Components$Referentiel$Fiche$Model$valeurDe, cle, fiche)));
					},
					A2(
						$elm$core$List$filter,
						$author$project$Components$Referentiel$Fiche$Model$peutModifierLeChamp(fiche),
						$author$project$Components$Referentiel$Fiche$Model$champsDe(fiche.g1)))
			}) : model;
	} else {
		return model;
	}
};
var $author$project$Components$Referentiel$Common$ChampsDuType$deLaFiche = function (bloc) {
	return A2(
		$elm$core$List$filterMap,
		function (lu) {
			return A2(
				$elm$core$Maybe$map,
				function (valeur) {
					return _Utils_Tuple2(lu.uN, valeur);
				},
				lu.fm);
		},
		bloc.dw);
};
var $author$project$Components$Referentiel$Common$ChampsDuType$tousLesChamps = function (schema) {
	return A2(
		$elm$core$List$filter,
		function (champ) {
			return _Utils_eq(champ.zU, $elm$core$Maybe$Nothing);
		},
		schema.dw);
};
var $author$project$Components$Referentiel$Common$ChampsDuType$saisieDeDepart = F2(
	function (schema, lues) {
		return A2(
			$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$depuis,
			{
				dw: $author$project$Components$Referentiel$Common$ChampsDuType$tousLesChamps(schema),
				Ba: schema.Ba
			},
			lues);
	});
var $author$project$Components$Referentiel$Fiche$Update$ouvrirLeBloc = F3(
	function (type_, declencheur, model) {
		var _v0 = _Utils_Tuple2(
			model.gt,
			A2($author$project$Components$Referentiel$Fiche$Model$schemaDuType, type_, model));
		if ((_v0.a.$ === 1) && (!_v0.b.$)) {
			var fiche = _v0.a.a;
			var schema = _v0.b.a;
			var _v1 = _Utils_Tuple2(
				fiche.ei,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.r0;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.r8;
								},
								$elm$core$Basics$eq(type_))),
						fiche.uW)));
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var bloc = _v1.b.a;
				var _v2 = A3(
					$author$project$Components$Shared$Drawer$Update$update,
					{Il: false},
					$author$project$Components$Shared$Drawer$Update$Ouvrir(declencheur),
					model.lo);
				var drawer = _v2.a;
				var effets = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jq: $elm$core$Maybe$Just(
								{
									hP: A2(
										$author$project$Components$Referentiel$Common$ChampsDuType$saisieDeDepart,
										schema,
										$author$project$Components$Referentiel$Common$ChampsDuType$deLaFiche(bloc)),
									r0: type_
								}),
							lo: drawer,
							nQ: function (vide) {
								return _Utils_update(
									vide,
									{gF: fiche.G5});
							}($author$project$Components$Referentiel$Common$ChoixDeLien$etatInitial)
						}),
					A2(
						$elm$core$List$map,
						function (_v3) {
							var cible = _v3;
							return $author$project$Components$Referentiel$Fiche$Update$PlacerFocus(cible);
						},
						effets));
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Fiche$Rattacher$init = {
	wa: A2(
		$author$project$Components$Referentiel$Fiche$Rattacher$ajouterUneLigne,
		1,
		A2($author$project$Components$Referentiel$Fiche$Rattacher$ajouterUneLigne, 0, _List_Nil)),
	ku: '',
	xb: '',
	AS: '',
	F4: '',
	px: false,
	hC: $author$project$Components$Referentiel$Common$RechercheDeFiche$vide
};
var $author$project$Components$Referentiel$Common$RechercheDeFiche$sansSaisie = function (recherche) {
	return _Utils_eq(
		_Utils_update(
			recherche,
			{hP: 0}),
		$author$project$Components$Referentiel$Common$RechercheDeFiche$vide);
};
var $author$project$Components$Referentiel$Fiche$Liaisons$saisieEnCours = function (etat) {
	var _v0 = etat.mW;
	switch (_v0.$) {
		case 1:
			var rattachement = _v0.a;
			var saisie = _v0.b;
			return !_Utils_eq(
				saisie,
				A2($elm$core$Maybe$withDefault, '', rattachement.zK));
		case 3:
			var rattachement = _v0.a;
			var saisie = _v0.b;
			return !_Utils_eq(
				saisie,
				$author$project$Components$Referentiel$Fiche$Liaisons$saisieInitiale(rattachement));
		case 4:
			var saisie = _v0.b;
			return (!_Utils_eq(
				_Utils_update(
					saisie,
					{hC: $author$project$Components$Referentiel$Common$RechercheDeFiche$vide}),
				$author$project$Components$Referentiel$Fiche$Rattacher$init)) || (!$author$project$Components$Referentiel$Common$RechercheDeFiche$sansSaisie(saisie.hC));
		case 5:
			var saisie = _v0.b;
			return (saisie.Fp !== '') || (!$author$project$Components$Referentiel$Common$RechercheDeFiche$sansSaisie(saisie.hC));
		default:
			return false;
	}
};
var $author$project$Components$Referentiel$Fiche$Update$surLaLiaison = F2(
	function (change, model) {
		return _Utils_update(
			model,
			{
				Bk: change(model.Bk)
			});
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$surLeDrawer = F2(
	function (drawer, etat) {
		return $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? _Utils_update(
			etat,
			{kX: drawer}) : $author$project$Components$Referentiel$Fiche$Liaisons$fermer(
			_Utils_update(
				etat,
				{kX: drawer}));
	});
var $author$project$Components$Referentiel$Fiche$Update$versLeDrawer = F2(
	function (msg, model) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{
				Il: $author$project$Components$Referentiel$Fiche$Liaisons$saisieEnCours(model.Bk)
			},
			msg,
			model.Bk.kX);
		var drawer = _v0.a;
		var effets = _v0.b;
		return _Utils_Tuple2(
			A2(
				$author$project$Components$Referentiel$Fiche$Update$surLaLiaison,
				$author$project$Components$Referentiel$Fiche$Liaisons$surLeDrawer(drawer),
				model),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Referentiel$Fiche$Update$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Referentiel$Fiche$Update$ouvrirLeDrawer = F3(
	function (declencheur, ouvrir_, model) {
		var ouverte = ouvrir_(model.Bk);
		return _Utils_eq(ouverte.mW, model.Bk.mW) ? _Utils_Tuple2(model, _List_Nil) : A2(
			$author$project$Components$Referentiel$Fiche$Update$versLeDrawer,
			$author$project$Components$Shared$Drawer$Update$Ouvrir(declencheur),
			_Utils_update(
				model,
				{Bk: ouverte}));
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$NouveauRattachement = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$ouvrirLeRattachement = F2(
	function (contexte, etat) {
		var _v0 = etat.mW;
		if (!_v0.$) {
			var geste = A2($author$project$Components$Referentiel$Fiche$Liaisons$NouveauRattachement, contexte, $author$project$Components$Referentiel$Fiche$Rattacher$init);
			var drawer = etat.kX;
			return _Utils_update(
				etat,
				{
					kX: _Utils_update(
						drawer,
						{
							Dj: $author$project$Components$Referentiel$Fiche$Liaisons$nomDuDrawer(geste)
						}),
					mW: geste,
					P: false
				});
		} else {
			return etat;
		}
	});
var $author$project$Components$Referentiel$Fiche$Model$DUnChamp = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Fiche$Model$ouvrirUnChamp = F2(
	function (cle, model) {
		var _v0 = _Utils_Tuple2(model.gt, model.ge);
		if ((_v0.a.$ === 1) && (!_v0.b.$)) {
			var fiche = _v0.a.a;
			var _v1 = _v0.b;
			return (A2($author$project$Components$Referentiel$Fiche$Model$peutModifierLeChamp, fiche, cle) && A2(
				$elm$core$List$member,
				cle,
				$author$project$Components$Referentiel$Fiche$Model$champsDe(fiche.g1))) ? _Utils_update(
				model,
				{
					ge: $author$project$Components$Referentiel$Fiche$Model$DUnChamp(cle),
					c7: _List_fromArray(
						[
							_Utils_Tuple2(
							cle,
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($author$project$Components$Referentiel$Fiche$Model$valeurDe, cle, fiche)))
						])
				}) : model;
		} else {
			return model;
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$ChercherDesNommees = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Common$ChoixDeLien$gabaritDe = F2(
	function (genre, gabarits) {
		switch (genre.$) {
			case 0:
				return gabarits.eA;
			case 1:
				return gabarits.Kf;
			default:
				return gabarits.tP;
		}
	});
var $author$project$Components$Referentiel$Common$ChoixDeLien$tailleDePage = 25;
var $author$project$Components$Referentiel$Common$ChoixDeLien$demander = F2(
	function (recherche, etat) {
		var numero = etat.DX + 1;
		var suivante = _Utils_update(
			recherche,
			{DX: numero});
		return _Utils_Tuple2(
			_Utils_update(
				etat,
				{
					DX: numero,
					Et: $elm$core$Maybe$Just(suivante)
				}),
			A2(
				$elm$core$Maybe$map,
				function (lien) {
					return {M: recherche.M, nB: lien, DX: numero, h3: recherche.h3};
				},
				A2(
					$elm$core$Maybe$andThen,
					$author$project$API$Liens$resoudre(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'page',
								$elm$core$String$fromInt(recherche.EE)),
								_Utils_Tuple2(
								'taille',
								$elm$core$String$fromInt($author$project$Components$Referentiel$Common$ChoixDeLien$tailleDePage))
							])),
					A2($author$project$Components$Referentiel$Common$ChoixDeLien$gabaritDe, recherche.M, etat.gF))));
	});
var $author$project$Components$Referentiel$Common$ChoixDeLien$DArticles = {$: 2};
var $author$project$Components$Referentiel$Common$ChoixDeLien$DUtilisateur = {$: 1};
var $author$project$Components$Referentiel$Common$ChoixDeLien$DePartiePrenante = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$Common$ChoixDeLien$genreDe = function (champ) {
	var _v0 = champ.r0;
	switch (_v0.$) {
		case 19:
			var visee = _v0.a;
			return $elm$core$Maybe$Just(
				$author$project$Components$Referentiel$Common$ChoixDeLien$DePartiePrenante(visee.r$));
		case 20:
			return $elm$core$Maybe$Just($author$project$Components$Referentiel$Common$ChoixDeLien$DUtilisateur);
		case 18:
			return $elm$core$Maybe$Just($author$project$Components$Referentiel$Common$ChoixDeLien$DArticles);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Common$ChoixDeLien$plusieursDe = function (champ) {
	var _v0 = champ.r0;
	if (_v0.$ === 18) {
		var lien = _v0.a;
		return lien.FS;
	} else {
		return false;
	}
};
var $author$project$Components$Referentiel$Common$ChoixDeLien$ouvrir = F3(
	function (champ, actuelles, etat) {
		var _v0 = $author$project$Components$Referentiel$Common$ChoixDeLien$genreDe(champ);
		if (!_v0.$) {
			var genre = _v0.a;
			return A2(
				$author$project$Components$Referentiel$Common$ChoixDeLien$demander,
				{
					dy: champ.dy,
					at: actuelles,
					fY: _List_Nil,
					M: genre,
					AJ: false,
					Bl: champ.Bl,
					DX: 0,
					EE: 1,
					FS: $author$project$Components$Referentiel$Common$ChoixDeLien$plusieursDe(champ),
					h3: '',
					fg: $elm$core$Maybe$Nothing
				},
				etat);
		} else {
			return _Utils_Tuple2(etat, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$ouvrirUnLien = F2(
	function (cle, model) {
		var _v0 = _Utils_Tuple2(
			model.jq,
			A2(
				$elm$core$Maybe$andThen,
				function (bloc) {
					return A2($author$project$Components$Referentiel$Fiche$Model$schemaDuType, bloc.r0, model);
				},
				model.jq));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var bloc = _v0.a.a;
			var schema = _v0.b.a;
			var _v1 = $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dy;
						},
						$elm$core$Basics$eq(cle)),
					schema.dw));
			if (!_v1.$) {
				var champ = _v1.a;
				var actuelles = function () {
					var _v3 = A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$second,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Tuple$first,
									$elm$core$Basics$eq(cle)),
								bloc.hP.Ki)));
					_v3$2:
					while (true) {
						if (!_v3.$) {
							switch (_v3.a.$) {
								case 2:
									var choisis = _v3.a.a;
									return choisis;
								case 1:
									var texte = _v3.a.a;
									return (texte === '') ? _List_Nil : _List_fromArray(
										[texte]);
								default:
									break _v3$2;
							}
						} else {
							break _v3$2;
						}
					}
					return _List_Nil;
				}();
				var _v2 = A3($author$project$Components$Referentiel$Common$ChoixDeLien$ouvrir, champ, actuelles, model.nQ);
				var liens = _v2.a;
				var demande = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{nQ: liens}),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Fiche$Update$ChercherDesNommees, $elm$core$List$singleton),
							demande)));
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$jugerApresLaTentative = function (saisie) {
	return _Utils_update(
		saisie,
		{eK: true});
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$depuis = F4(
	function (fourni, uid, lues, contenu) {
		var offerts = A2(
			$elm$core$List$filter,
			function (champ) {
				return !A2($elm$core$List$member, champ.dy, contenu.Cd);
			},
			contenu.IX);
		return {
			uN: fourni.uN.dy,
			cv: false,
			mp: fourni.mp,
			z9: contenu.z9,
			Ba: fourni.Ba,
			Bq: contenu.Bq,
			Dj: fourni.uN.Bl,
			pZ: _List_Nil,
			HI: contenu.HI,
			hP: $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$jugerApresLaTentative(
				A2(
					$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$depuis,
					{dw: offerts, Ba: fourni.Ba},
					lues)),
			IX: offerts,
			Z: _List_Nil,
			b5: false,
			r2: _List_Nil,
			r8: uid
		};
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$ajouter = function (fourni) {
	return A2(
		$elm$core$Maybe$map,
		A3($author$project$Components$Shared$EditeurDeSchema$Groupe$depuis, fourni, $elm$core$Maybe$Nothing, _List_Nil),
		$author$project$Components$Shared$EditeurDeSchema$Groupe$sousChampsDe(fourni.uN));
};
var $author$project$API$NavLinksDictionary$ajouterUneOccurrence = 'ajouter-une-occurrence';
var $author$project$Components$Shared$EditeurDeSchema$Groupe$avecCreationALaVolee = function (brouillon) {
	return _Utils_update(
		brouillon,
		{cv: true});
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$modifier = F2(
	function (fourni, lue) {
		return A2(
			$elm$core$Maybe$map,
			A3(
				$author$project$Components$Shared$EditeurDeSchema$Groupe$depuis,
				fourni,
				$elm$core$Maybe$Just(lue.r8),
				lue.Ki),
			$author$project$Components$Shared$EditeurDeSchema$Groupe$sousChampsDe(fourni.uN));
	});
var $author$project$API$NavLinksDictionary$modifierUneOccurrence = 'modifier-une-occurrence';
var $author$project$Components$Referentiel$Fiche$Update$ouvrirUneOccurrence = F4(
	function (type_, cle, uid, model) {
		var _v0 = A3($author$project$Components$Referentiel$Fiche$Update$leGroupe, type_, cle, model);
		if (!_v0.$) {
			var bloc = _v0.a.fJ;
			var schema = _v0.a.aN;
			var champ = _v0.a.uN;
			var rel = _Utils_eq(uid, $elm$core$Maybe$Nothing) ? $author$project$API$NavLinksDictionary$ajouterUneOccurrence : $author$project$API$NavLinksDictionary$modifierUneOccurrence;
			var existantes = $author$project$Components$Shared$EditeurDeSchema$Groupe$occurrences(
				A2($author$project$Components$Referentiel$Fiche$Occurrences$valeurDe, bloc, cle));
			var brouillon = function () {
				if (uid.$ === 1) {
					return $author$project$Components$Shared$EditeurDeSchema$Groupe$ajouter(
						{uN: champ, mp: existantes, Ba: schema.Ba});
				} else {
					var lu = uid.a;
					return A2(
						$elm$core$Maybe$andThen,
						$author$project$Components$Shared$EditeurDeSchema$Groupe$modifier(
							{uN: champ, mp: existantes, Ba: schema.Ba}),
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.r8;
									},
									$elm$core$Basics$eq(lu)),
								existantes)));
				}
			}();
			var _v1 = _Utils_Tuple2(
				A3($author$project$Components$Referentiel$Fiche$Occurrences$lienDe, rel, bloc, cle),
				brouillon);
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var ouvert = _v1.b.a;
				return A3(
					$author$project$Components$Referentiel$Fiche$Update$ouvrirLeDrawerDesOccurrences,
					'groupe-' + cle,
					function (etat) {
						return _Utils_update(
							etat,
							{
								dh: $elm$core$Maybe$Nothing,
								Et: $elm$core$Maybe$Just(
									{
										uw: $author$project$Components$Shared$EditeurDeSchema$Groupe$avecCreationALaVolee(ouvert),
										r0: type_
									}),
								J8: false
							});
					},
					model);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Fiche$Historique$Introuvable = 4;
var $author$project$Components$Referentiel$Fiche$Historique$panneauIntrouvable = F2(
	function (lecture, etat) {
		return A3(
			$author$project$Components$Referentiel$Fiche$Historique$surLePanneau,
			lecture,
			function (panneau) {
				return _Utils_update(
					panneau,
					{u7: 4});
			},
			etat);
	});
var $author$project$API$NavLinksDictionary$creerEntite = 'creer-entite';
var $author$project$Components$Referentiel$Fiche$Liaisons$saisieDuRattachement = function (etat) {
	var _v0 = etat.mW;
	if (_v0.$ === 4) {
		var contexte = _v0.a;
		var saisie = _v0.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(contexte, saisie));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Fiche$Model$personneACreer = function (model) {
	var _v0 = $author$project$Components$Referentiel$Fiche$Liaisons$saisieDuRattachement(model.Bk);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var contexte = _v1.a;
		return (!contexte.fN) && (!_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerEntite, model.GN),
			$elm$core$Maybe$Nothing));
	} else {
		return false;
	}
};
var $author$project$Components$Referentiel$Fiche$Update$EnvoyerALaLiaison = F4(
	function (a, b, c, d) {
		return {$: 17, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Referentiel$Fiche$Model$Pret = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Fiche$Liaisons$prendreLaSuite = function (etat) {
	return _Utils_Tuple2(
		$elm$core$List$head(etat.rn),
		_Utils_update(
			etat,
			{
				rn: A2($elm$core$List$drop, 1, etat.rn)
			}));
};
var $author$project$Components$Referentiel$Fiche$Update$poursuivre = F2(
	function (processUid, model) {
		var _v0 = $author$project$Components$Referentiel$Fiche$Liaisons$prendreLaSuite(model.Bk);
		if (!_v0.a.$) {
			var _v1 = _v0.a.a;
			var lien = _v1.a;
			var entite = _v1.b;
			var commande = _v1.c;
			var reste = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: $author$project$Components$Referentiel$Fiche$Model$EnCours(processUid),
						Bk: reste
					}),
				_List_fromArray(
					[
						A4($author$project$Components$Referentiel$Fiche$Update$EnvoyerALaLiaison, lien, processUid, entite, commande)
					]));
		} else {
			var _v2 = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: $author$project$Components$Referentiel$Fiche$Model$Pret(processUid)
					}),
				_List_Nil);
		}
	});
var $author$project$Components$Referentiel$Fiche$Contacts$prefixeDUsageLie = 'Professionnel:';
var $author$project$Components$Referentiel$Common$RechercheDeFiche$nomDe = function (liee) {
	if (liee.gt === 4) {
		return $author$project$I18n$Textes$referentielFicheTitreEffacee;
	} else {
		var _v0 = liee.Av;
		if (!_v0.$) {
			var personne = _v0.a;
			var _v1 = A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[personne.Gg, personne.Dj]));
			if (!_v1.b) {
				return $author$project$I18n$Textes$referentielFicheNomMasque;
			} else {
				var presents = _v1;
				return $author$project$I18n$Traductions$tel(
					A2($elm$core$String$join, ' ', presents));
			}
		} else {
			var organisation = _v0.a;
			return A2(
				$elm$core$Maybe$withDefault,
				$author$project$I18n$Textes$referentielFicheNomMasque,
				A2($elm$core$Maybe$map, $author$project$I18n$Traductions$tel, organisation.GR));
		}
	}
};
var $author$project$I18n$Textes$referentielNatureOrganisation = A3($author$project$I18n$Traductions$texte, 'referentiel.nature.organisation', _List_Nil, 'Organisation');
var $author$project$I18n$Textes$referentielNaturePersonne = A3($author$project$I18n$Traductions$texte, 'referentiel.nature.personne', _List_Nil, 'Personne');
var $author$project$Components$Referentiel$Common$RechercheDeFiche$propositions = F3(
	function (cherchee, ouverte, liees) {
		var attendue = function (liee) {
			var _v1 = _Utils_Tuple2(cherchee, liee.Av);
			_v1$3:
			while (true) {
				switch (_v1.a) {
					case 0:
						if (!_v1.b.$) {
							var _v2 = _v1.a;
							return true;
						} else {
							break _v1$3;
						}
					case 1:
						if (_v1.b.$ === 1) {
							var _v3 = _v1.a;
							return true;
						} else {
							break _v1$3;
						}
					default:
						var _v4 = _v1.a;
						return true;
				}
			}
			return false;
		};
		return A2(
			$elm$core$List$map,
			function (liee) {
				return {
					g1: function () {
						var _v0 = liee.Av;
						if (!_v0.$) {
							return $author$project$I18n$Textes$referentielNaturePersonne;
						} else {
							return $author$project$I18n$Textes$referentielNatureOrganisation;
						}
					}(),
					Dj: $author$project$Components$Referentiel$Common$RechercheDeFiche$nomDe(liee),
					r8: liee.r8
				};
			},
			A2(
				$elm$core$List$filter,
				function (liee) {
					return attendue(liee) && (!_Utils_eq(
						$elm$core$Maybe$Just(liee.r8),
						ouverte));
				},
				liees));
	});
var $author$project$Components$Referentiel$Fiche$Historique$quitterLeBas = function (etat) {
	return _Utils_update(
		etat,
		{c9: false});
};
var $author$project$Components$Referentiel$Fiche$Update$rattachementDe = F2(
	function (uid, model) {
		var _v0 = model.gt;
		if (_v0.$ === 1) {
			var fiche = _v0.a;
			return $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (rattachement) {
						return _Utils_eq(rattachement.r8, uid);
					},
					fiche.GY));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Referentiel$Fiche$Rattachements$Termine = 2;
var $author$project$Components$Referentiel$Fiche$Model$rattachementsLiables = function (model) {
	var _v0 = model.gt;
	if (_v0.$ === 1) {
		var fiche = _v0.a;
		return (!fiche.g1) ? A2(
			$elm$core$List$filter,
			function (porte) {
				return porte.gt !== 2;
			},
			fiche.GY) : _List_Nil;
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Referentiel$Common$RechercheDeFiche$recevoir = F3(
	function (terme, recues, recherche) {
		return _Utils_eq(
			$author$project$Components$Referentiel$Common$RechercheDeFiche$aChercher(recherche),
			$elm$core$Maybe$Just(terme)) ? _Utils_update(
			recherche,
			{Gw: recues}) : recherche;
	});
var $author$project$Components$Referentiel$Fiche$Historique$Charge = 2;
var $author$project$Components$Referentiel$Fiche$Historique$recevoir = F3(
	function (lecture, page, etat) {
		return (!_Utils_eq(lecture, etat.np)) ? etat : _Utils_update(
			etat,
			{
				u7: 2,
				gV: etat.an ? _Utils_ap(etat.gV, page.gV) : page.gV,
				an: false,
				I6: page.I6
			});
	});
var $author$project$Components$Referentiel$Fiche$Historique$recevoirLePanneau = F3(
	function (lecture, recu, etat) {
		return A3(
			$author$project$Components$Referentiel$Fiche$Historique$surLePanneau,
			lecture,
			function (panneau) {
				return _Utils_update(
					panneau,
					{u7: 2, Fe: recu.Fe, Ki: recu.Ki});
			},
			etat);
	});
var $author$project$API$NavLinksDictionary$rechercherDoublons = 'rechercher-doublons';
var $author$project$Components$Referentiel$Fiche$Update$AttendreAvantDeRelire = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Model$EnErreur = {$: 4};
var $author$project$Components$Referentiel$Fiche$Model$EnRetard = {$: 3};
var $author$project$Components$Referentiel$Common$Relecture$delaiMs = 1000;
var $author$project$Components$Referentiel$Common$Relecture$max = 3;
var $author$project$Components$Referentiel$Fiche$Update$refuser = F3(
	function (uid, refus, model) {
		return (refus.ri === 401) ? _Utils_Tuple2(
			model,
			_List_fromArray(
				[$author$project$Components$Referentiel$Fiche$Update$Reconnecter])) : (((refus.ri === 404) && (!_Utils_eq(model.lW, $elm$core$Maybe$Nothing))) ? ((_Utils_cmp(model.Hv, $author$project$Components$Referentiel$Common$Relecture$max) < 0) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{gt: $author$project$Components$Referentiel$Fiche$Model$EnRetard, Hv: model.Hv + 1}),
			_List_fromArray(
				[
					A2($author$project$Components$Referentiel$Fiche$Update$AttendreAvantDeRelire, uid, $author$project$Components$Referentiel$Common$Relecture$delaiMs)
				])) : _Utils_Tuple2(
			_Utils_update(
				model,
				{gt: $author$project$Components$Referentiel$Fiche$Model$EnRetard}),
			_List_Nil)) : ((refus.ri === 404) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{gt: $author$project$Components$Referentiel$Fiche$Model$Introuvable}),
			_List_Nil) : _Utils_Tuple2(
			_Utils_update(
				model,
				{gt: $author$project$Components$Referentiel$Fiche$Model$EnErreur}),
			_List_Nil)));
	});
var $author$project$Components$Referentiel$Fiche$Update$relationDe = F2(
	function (uid, model) {
		var _v0 = model.gt;
		if (_v0.$ === 1) {
			var fiche = _v0.a;
			return $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (relation) {
						return _Utils_eq(relation.r8, uid);
					},
					fiche.Hu));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$relire = function (model) {
	var _v0 = _Utils_Tuple3(model.gt, model.kD, model.nB);
	if (((_v0.a.$ === 3) && (!_v0.b.$)) && (!_v0.c.$)) {
		var _v1 = _v0.a;
		var uid = _v0.b.a;
		var lien = _v0.c.a;
		return _Utils_Tuple2(
			model,
			_List_fromArray(
				[
					A2($author$project$Components$Referentiel$Fiche$Update$LireFiche, uid, lien)
				]));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Fiche$Update$relireLaChronologie = function (model) {
	return A2(
		$author$project$Components$Referentiel$Fiche$Update$lireLaChronologie,
		$author$project$Components$Referentiel$Fiche$Historique$relire(model.m6),
		model);
};
var $author$project$Components$Referentiel$Fiche$Update$aRelire = F2(
	function (fiche, rendue) {
		return $elm$core$List$isEmpty(rendue.mk) || (A2(
			$elm$core$List$any,
			function (evenement) {
				return _Utils_eq(evenement.fm, $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$Personnelle);
			},
			rendue.mk) || ((fiche.g1 === 1) && A2(
			$elm$core$List$any,
			function (evenement) {
				return A2(
					$elm$core$List$member,
					evenement.uN,
					_List_fromArray(
						[
							$author$project$Components$Referentiel$Fiche$Model$nomAuContrat(7),
							$author$project$Components$Referentiel$Fiche$Model$nomAuContrat(5)
						]));
			},
			rendue.mk)));
	});
var $author$project$Components$Referentiel$Fiche$Model$cleDuContrat = function (nom) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (cle) {
				return _Utils_eq(
					$author$project$Components$Referentiel$Fiche$Model$nomAuContrat(cle),
					nom);
			},
			_List_fromArray(
				[0, 1, 2, 3, 4, 5, 6, 7])));
};
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$API$NavLinksDictionary$modifier = 'modifier';
var $author$project$Components$Referentiel$Fiche$Model$poser = F3(
	function (cle, valeur, champs) {
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var de = _v0.a;
				var avant = _v0.b;
				return _Utils_eq(de, cle) ? _Utils_Tuple2(de, valeur) : _Utils_Tuple2(de, avant);
			},
			champs);
	});
var $author$project$Components$Referentiel$Fiche$Model$appliquer = F3(
	function (evenements, liens, fiche) {
		var champs = A3(
			$elm$core$List$foldl,
			F2(
				function (evenement, courants) {
					var _v0 = _Utils_Tuple2(
						$author$project$Components$Referentiel$Fiche$Model$cleDuContrat(evenement.uN),
						evenement.fm);
					_v0$2:
					while (true) {
						if (!_v0.a.$) {
							switch (_v0.b.$) {
								case 0:
									var cle = _v0.a.a;
									var valeur = _v0.b.a;
									return A3(
										$author$project$Components$Referentiel$Fiche$Model$poser,
										cle,
										$elm$core$Maybe$Just(valeur),
										courants);
								case 1:
									var cle = _v0.a.a;
									var _v1 = _v0.b;
									return A3($author$project$Components$Referentiel$Fiche$Model$poser, cle, $elm$core$Maybe$Nothing, courants);
								default:
									break _v0$2;
							}
						} else {
							break _v0$2;
						}
					}
					return courants;
				}),
			fiche.dw,
			evenements);
		return _Utils_update(
			fiche,
			{
				dw: champs,
				ei: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifier, liens),
				sq: A2(
					$elm$core$Maybe$withDefault,
					fiche.sq,
					$elm$core$List$maximum(
						A2(
							$elm$core$List$map,
							function ($) {
								return $.sq;
							},
							evenements)))
			});
	});
var $author$project$Components$Referentiel$Fiche$Update$fermeLeDrawerDIdentite = function (drawer) {
	return A3(
		$author$project$Components$Shared$Drawer$Update$update,
		{Il: false},
		$author$project$Components$Shared$Drawer$Update$Fermer,
		drawer).a;
};
var $author$project$Components$Referentiel$Fiche$Update$lecture = F2(
	function (uid, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (lien) {
					return _List_fromArray(
						[
							A2($author$project$Components$Referentiel$Fiche$Update$LireFiche, uid, lien)
						]);
				},
				model.nB));
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$Relier = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Referentiel$Fiche$Liaisons$garderLaSuite = F2(
	function (suite, etat) {
		return _Utils_update(
			etat,
			{rn: suite});
	});
var $author$project$Components$Referentiel$Fiche$Update$rattacherALaSociete = F3(
	function (fiche, model, appliquee) {
		var _v0 = _Utils_Tuple3(
			_Utils_Tuple2(model.ge, model.b2),
			model.b3,
			_Utils_Tuple2(fiche.Hy, model.rY));
		if (((((_v0.a.a.$ === 3) && (!_v0.a.b)) && (!_v0.b.$)) && (!_v0.c.a.$)) && (!_v0.c.b.$)) {
			var _v1 = _v0.a;
			var _v2 = _v1.a;
			var societe = _v0.b.a;
			var _v3 = _v0.c;
			var lien = _v3.a.a;
			var leType = _v3.b.a;
			return _Utils_update(
				appliquee,
				{
					Bk: A2(
						$author$project$Components$Referentiel$Fiche$Liaisons$garderLaSuite,
						_List_fromArray(
							[
								_Utils_Tuple3(
								lien,
								fiche.r8,
								$author$project$Components$Referentiel$Fiche$Liaisons$Relier(
									{vf: societe.r8, xA: true, r0: leType}))
							]),
						appliquee.Bk)
				});
		} else {
			return appliquee;
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$refusNets = _List_fromArray(
	[400, 403, 409, 422]);
var $author$project$Components$Referentiel$Fiche$Update$rendre = F4(
	function (uid, processUid, reponse, model) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$reponseDecoder, reponse),
			model.gt);
		if (!_v0.a.$) {
			if (_v0.b.$ === 1) {
				var rendue = _v0.a.a;
				var fiche = _v0.b.a;
				var appliquee = _Utils_update(
					model,
					{
						fX: false,
						cD: $elm$core$Maybe$Nothing,
						dI: false,
						k2: $author$project$Components$Referentiel$Fiche$Update$fermeLeDrawerDIdentite(model.k2),
						ge: $author$project$Components$Referentiel$Fiche$Model$Fermee,
						l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid,
						gt: $author$project$Components$Referentiel$Fiche$Model$Lue(
							A3($author$project$Components$Referentiel$Fiche$Model$appliquer, rendue.mk, rendue.nQ, fiche)),
						gI: _Utils_eq(model.ge, $author$project$Components$Referentiel$Fiche$Model$DansLeDrawerDIdentite),
						c7: _List_Nil,
						b2: false,
						b3: $elm$core$Maybe$Nothing
					});
				return A2($author$project$Components$Referentiel$Fiche$Update$aRelire, fiche, rendue) ? _Utils_Tuple2(
					A3($author$project$Components$Referentiel$Fiche$Update$rattacherALaSociete, fiche, model, appliquee),
					A2(
						$elm$core$List$cons,
						$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid,
						A2($author$project$Components$Referentiel$Fiche$Update$lecture, uid, model))) : A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$List$cons($author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid),
					$author$project$Components$Referentiel$Fiche$Update$relireLaChronologie(
						A3($author$project$Components$Referentiel$Fiche$Update$rattacherALaSociete, fiche, model, appliquee)));
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid}),
					_List_fromArray(
						[$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid]));
			}
		} else {
			var refus = _v0.a.a;
			return (refus.ri === 401) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: $author$project$Components$Referentiel$Fiche$Model$Pret(processUid)
					}),
				_List_fromArray(
					[$author$project$Components$Referentiel$Fiche$Update$Reconnecter])) : ((refus.ri === 404) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid, gt: $author$project$Components$Referentiel$Fiche$Model$Introuvable}),
				_List_fromArray(
					[$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid])) : (_Utils_eq(
				$author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$duRefus(refus),
				$author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$FicheModifieeEntreTemps) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{fX: true, l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid}),
				_List_fromArray(
					[$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid])) : (_Utils_eq(
				$author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$duRefus(refus),
				$author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$IdentifiantLegalInvalide) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid, bI: true}),
				_List_fromArray(
					[$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid])) : (A2($elm$core$List$member, refus.ri, $author$project$Components$Referentiel$Fiche$Update$refusNets) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid}),
				_List_fromArray(
					[$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid])) : _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: $author$project$Components$Referentiel$Fiche$Model$Pret(processUid)
					}),
				_List_Nil)))));
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$surLExport = F2(
	function (change, model) {
		return _Utils_update(
			model,
			{
				ms: change(model.ms)
			});
	});
var $author$project$Components$Referentiel$Fiche$Update$rendreLApercuDeLExport = F4(
	function (uid, demande, reponse, model) {
		var _v0 = _Utils_Tuple2(
			_Utils_eq(
				model.kD,
				$elm$core$Maybe$Just(uid)),
			A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$apercuDeLExportDecoder, reponse));
		if (_v0.a) {
			if (!_v0.b.$) {
				var apercu = _v0.b.a;
				if (demande.$ === 1) {
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLExport,
							function (etat) {
								return (etat.wv === '') ? _Utils_update(
									etat,
									{
										tq: $elm$core$Maybe$Just(apercu),
										wv: apercu.wB
									}) : etat;
							},
							model),
						_List_Nil);
				} else {
					var date = demande.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLExport,
							function (etat) {
								return _Utils_eq(etat.wv, date) ? _Utils_update(
									etat,
									{
										tq: $elm$core$Maybe$Just(apercu)
									}) : etat;
							},
							model),
						_List_Nil);
				}
			} else {
				var refus = _v0.b.a;
				return (refus.ri === 401) ? _Utils_Tuple2(
					model,
					_List_fromArray(
						[$author$project$Components$Referentiel$Fiche$Update$Reconnecter])) : _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$idDuTitreDesContacts = 'fiche-contacts-titre';
var $author$project$Components$Referentiel$Fiche$Update$rendreLEffacement = F4(
	function (uid, processUid, reponse, model) {
		var ferme = _Utils_update(
			model,
			{x9: $author$project$Components$Referentiel$Fiche$Effacement$init, l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid});
		var _v0 = A2(
			$author$project$API$Reponse$lire,
			$elm$json$Json$Decode$succeed(0),
			reponse);
		if (!_v0.$) {
			return _Utils_Tuple2(
				ferme,
				A2(
					$elm$core$List$cons,
					$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid,
					_Utils_ap(
						A2($author$project$Components$Referentiel$Fiche$Update$lecture, uid, model),
						_Utils_eq(model.x9.v8, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
							[
								$author$project$Components$Referentiel$Fiche$Update$PlacerFocus($author$project$Components$Referentiel$Fiche$Update$idDuTitreDesContacts)
							]))));
		} else {
			var refus = _v0.a;
			return (refus.ri === 401) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: $author$project$Components$Referentiel$Fiche$Model$Pret(processUid)
					}),
				_List_fromArray(
					[$author$project$Components$Referentiel$Fiche$Update$Reconnecter])) : ((refus.ri === 404) ? _Utils_Tuple2(
				_Utils_update(
					ferme,
					{gt: $author$project$Components$Referentiel$Fiche$Model$Introuvable}),
				_List_fromArray(
					[$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid])) : ((refus.ri === 409) ? _Utils_Tuple2(
				ferme,
				A2(
					$elm$core$List$cons,
					$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid,
					A2($author$project$Components$Referentiel$Fiche$Update$lecture, uid, model))) : (A2($elm$core$List$member, refus.ri, $author$project$Components$Referentiel$Fiche$Update$refusNets) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid}),
				_List_fromArray(
					[$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid])) : _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: $author$project$Components$Referentiel$Fiche$Model$Pret(processUid)
					}),
				_List_Nil))));
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$TelechargerLesFichiers = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$FichierExporteAPIView = F3(
	function (nom, type_, contenu) {
		return {fZ: contenu, Dj: nom, r0: type_};
	});
var $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$fichiersExportesDecoder = A2(
	$elm$json$Json$Decode$field,
	'fichiers',
	$elm$json$Json$Decode$list(
		A4(
			$elm$json$Json$Decode$map3,
			$author$project$Components$Referentiel$Fiche$API$QueryAPIModel$FichierExporteAPIView,
			A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'contenu', $elm$json$Json$Decode$string))));
var $author$project$Components$Referentiel$Fiche$Update$rendreLExport = F4(
	function (uid, processUid, reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$fichiersExportesDecoder, reponse);
		if (!_v0.$) {
			var fichiers = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid, ms: $author$project$Components$Referentiel$Fiche$Export$init}),
				_List_fromArray(
					[
						$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid,
						$author$project$Components$Referentiel$Fiche$Update$TelechargerLesFichiers(fichiers)
					]));
		} else {
			var refus = _v0.a;
			return (refus.ri === 401) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: $author$project$Components$Referentiel$Fiche$Model$Pret(processUid)
					}),
				_List_fromArray(
					[$author$project$Components$Referentiel$Fiche$Update$Reconnecter])) : ((refus.ri === 404) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid, gt: $author$project$Components$Referentiel$Fiche$Model$Introuvable, ms: $author$project$Components$Referentiel$Fiche$Export$init}),
				_List_fromArray(
					[$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid])) : ((refus.ri === 409) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid, ms: $author$project$Components$Referentiel$Fiche$Export$init}),
				A2(
					$elm$core$List$cons,
					$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid,
					A2($author$project$Components$Referentiel$Fiche$Update$lecture, uid, model))) : (A2($elm$core$List$member, refus.ri, $author$project$Components$Referentiel$Fiche$Update$refusNets) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid}),
				_List_fromArray(
					[$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid])) : _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: $author$project$Components$Referentiel$Fiche$Model$Pret(processUid)
					}),
				_List_Nil))));
		}
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$existeDeja = function (etat) {
	return _Utils_update(
		etat,
		{aX: true});
};
var $author$project$Components$Referentiel$Fiche$Liaisons$idDeLaPhrase = 'relation-phrase';
var $author$project$Components$Referentiel$Fiche$Liaisons$idDeLaRecherche = 'liaison-recherche';
var $author$project$Components$Referentiel$Fiche$Liaisons$idDuPoste = 'rattachement-poste';
var $author$project$Components$Referentiel$Fiche$Liaisons$refuser = F2(
	function (raison, etat) {
		var phrase = function () {
			var _v0 = etat.mW;
			if (_v0.$ === 5) {
				var saisie = _v0.b;
				return saisie.Fp;
			} else {
				return '';
			}
		}();
		return _Utils_update(
			etat,
			{
				pZ: $elm$core$Maybe$Just(
					{
						xA: A2($elm$core$String$endsWith, ':direct', phrase),
						Bl: A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.Bl;
								},
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (proposee) {
											return _Utils_eq(proposee.fm, phrase);
										},
										$author$project$Components$Referentiel$Fiche$Liaisons$phrases(etat))))),
						pH: raison
					})
			});
	});
var $author$project$Components$Referentiel$Fiche$Rattacher$setPoste = F2(
	function (poste, saisie) {
		return _Utils_update(
			saisie,
			{F4: poste});
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$surLaModification = F2(
	function (change, etat) {
		var _v0 = etat.mW;
		if (_v0.$ === 3) {
			var rattachement = _v0.a;
			var saisie = _v0.b;
			return _Utils_update(
				etat,
				{
					mW: A2(
						$author$project$Components$Referentiel$Fiche$Liaisons$Modification,
						rattachement,
						change(saisie))
				});
		} else {
			return etat;
		}
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$surLeRattachement = F2(
	function (change, etat) {
		var _v0 = etat.mW;
		if (_v0.$ === 4) {
			var contexte = _v0.a;
			var saisie = _v0.b;
			return _Utils_update(
				etat,
				{
					mW: A2(
						$author$project$Components$Referentiel$Fiche$Liaisons$NouveauRattachement,
						contexte,
						change(saisie))
				});
		} else {
			return etat;
		}
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$setPoste = function (poste) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Components$Referentiel$Fiche$Liaisons$surLaModification(
			function (saisie) {
				return _Utils_update(
					saisie,
					{F4: poste});
			}),
		A2(
			$elm$core$Basics$composeR,
			$author$project$Components$Referentiel$Fiche$Liaisons$surLeRattachement(
				$author$project$Components$Referentiel$Fiche$Rattacher$setPoste(poste)),
			function (etat) {
				return _Utils_update(
					etat,
					{bU: false, bV: false});
			}));
};
var $author$project$Components$Referentiel$Fiche$Liaisons$refuserLePoste = function (etat) {
	var vide = function () {
		var _v0 = etat.mW;
		if (_v0.$ === 3) {
			var rattachement = _v0.a;
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $author$project$Components$Referentiel$Identifiants$posteUidToString, rattachement.F5));
		} else {
			return '';
		}
	}();
	return function (apres) {
		return _Utils_update(
			apres,
			{bU: true});
	}(
		A2($author$project$Components$Referentiel$Fiche$Liaisons$setPoste, vide, etat));
};
var $author$project$Components$Referentiel$Fiche$Liaisons$refuserLePosteDejaPris = function (etat) {
	return _Utils_update(
		etat,
		{bV: true});
};
var $author$project$Components$Referentiel$Fiche$Update$rendreLaLiaison = F4(
	function (uid, processUid, reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$commandeDeLiaisonDecoder, reponse);
		if (!_v0.$) {
			return $elm$core$List$isEmpty(model.Bk.rn) ? A2(
				$elm$core$Tuple$mapSecond,
				function (effets) {
					return A2(
						$elm$core$List$cons,
						$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid,
						_Utils_ap(
							A2($author$project$Components$Referentiel$Fiche$Update$lecture, uid, model),
							effets));
				},
				A2(
					$author$project$Components$Referentiel$Fiche$Update$versLeDrawer,
					$author$project$Components$Shared$Drawer$Update$Fermer,
					_Utils_update(
						model,
						{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid}))) : _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid}),
				_List_fromArray(
					[$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid]));
		} else {
			var refus = _v0.a;
			var sansSuite = A2(
				$author$project$Components$Referentiel$Fiche$Update$surLaLiaison,
				$author$project$Components$Referentiel$Fiche$Liaisons$garderLaSuite(_List_Nil),
				model);
			if (refus.ri === 401) {
				return _Utils_Tuple2(
					_Utils_update(
						sansSuite,
						{
							l2: $author$project$Components$Referentiel$Fiche$Model$Pret(processUid)
						}),
					_List_fromArray(
						[$author$project$Components$Referentiel$Fiche$Update$Reconnecter]));
			} else {
				if (refus.ri === 404) {
					return _Utils_Tuple2(
						_Utils_update(
							sansSuite,
							{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid, gt: $author$project$Components$Referentiel$Fiche$Model$Introuvable}),
						_List_fromArray(
							[$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid]));
				} else {
					if (_Utils_eq(
						$author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$duRefus(refus),
						$author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$RelationDejaExistante)) {
						return _Utils_Tuple2(
							A2(
								$author$project$Components$Referentiel$Fiche$Update$surLaLiaison,
								$author$project$Components$Referentiel$Fiche$Liaisons$existeDeja,
								_Utils_update(
									sansSuite,
									{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid})),
							A2(
								$elm$core$List$cons,
								$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid,
								_Utils_ap(
									A2($author$project$Components$Referentiel$Fiche$Update$lecture, uid, model),
									_List_fromArray(
										[
											$author$project$Components$Referentiel$Fiche$Update$PlacerFocus($author$project$Components$Referentiel$Fiche$Liaisons$idDeLaRecherche)
										]))));
					} else {
						if (!_Utils_eq(
							$author$project$Components$Referentiel$Fiche$Update$refusDeLaRelation(
								$author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$duRefus(refus)),
							$elm$core$Maybe$Nothing)) {
							var relireLesTypes = function () {
								var _v1 = _Utils_Tuple2(
									$author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$duRefus(refus),
									A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$typesDeRelation, model.GN));
								if ((_v1.a.$ === 6) && (!_v1.b.$)) {
									var _v2 = _v1.a;
									var lien = _v1.b.a;
									return _List_fromArray(
										[
											$author$project$Components$Referentiel$Fiche$Update$LireTypesDeRelation(lien)
										]);
								} else {
									return _List_Nil;
								}
							}();
							var dit = A2(
								$elm$core$Maybe$withDefault,
								sansSuite,
								A2(
									$elm$core$Maybe$map,
									function (raison) {
										return A2(
											$author$project$Components$Referentiel$Fiche$Update$surLaLiaison,
											$author$project$Components$Referentiel$Fiche$Liaisons$refuser(raison),
											sansSuite);
									},
									$author$project$Components$Referentiel$Fiche$Update$refusDeLaRelation(
										$author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$duRefus(refus))));
							return _Utils_Tuple2(
								_Utils_update(
									dit,
									{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid}),
								A2(
									$elm$core$List$cons,
									$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid,
									_Utils_ap(
										(refus.ri === 409) ? A2($author$project$Components$Referentiel$Fiche$Update$lecture, uid, model) : _List_Nil,
										_Utils_ap(
											relireLesTypes,
											_List_fromArray(
												[
													$author$project$Components$Referentiel$Fiche$Update$PlacerFocus($author$project$Components$Referentiel$Fiche$Liaisons$idDeLaPhrase)
												])))));
						} else {
							if (_Utils_eq(
								$author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$duRefus(refus),
								$author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$PosteArchive)) {
								return _Utils_Tuple2(
									A2(
										$author$project$Components$Referentiel$Fiche$Update$surLaLiaison,
										$author$project$Components$Referentiel$Fiche$Liaisons$refuserLePoste,
										_Utils_update(
											sansSuite,
											{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid})),
									A2(
										$elm$core$List$cons,
										$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid,
										_Utils_ap(
											A2(
												$elm$core$Maybe$withDefault,
												_List_Nil,
												A2(
													$elm$core$Maybe$map,
													A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Fiche$Update$LirePostes, $elm$core$List$singleton),
													A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$postes, model.GN))),
											_List_fromArray(
												[
													$author$project$Components$Referentiel$Fiche$Update$PlacerFocus($author$project$Components$Referentiel$Fiche$Liaisons$idDuPoste)
												]))));
							} else {
								if (_Utils_eq(
									$author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$duRefus(refus),
									$author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$RattachementDejaActifSurCePoste)) {
									return _Utils_Tuple2(
										A2(
											$author$project$Components$Referentiel$Fiche$Update$surLaLiaison,
											$author$project$Components$Referentiel$Fiche$Liaisons$refuserLePosteDejaPris,
											_Utils_update(
												sansSuite,
												{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid})),
										A2(
											$elm$core$List$cons,
											$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid,
											_Utils_ap(
												A2($author$project$Components$Referentiel$Fiche$Update$lecture, uid, model),
												_List_fromArray(
													[
														$author$project$Components$Referentiel$Fiche$Update$PlacerFocus($author$project$Components$Referentiel$Fiche$Liaisons$idDuPoste)
													]))));
								} else {
									if (refus.ri === 409) {
										return _Utils_Tuple2(
											_Utils_update(
												sansSuite,
												{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid}),
											A2(
												$elm$core$List$cons,
												$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid,
												A2($author$project$Components$Referentiel$Fiche$Update$lecture, uid, model)));
									} else {
										if (A2($elm$core$List$member, refus.ri, $author$project$Components$Referentiel$Fiche$Update$refusNets)) {
											return _Utils_Tuple2(
												_Utils_update(
													sansSuite,
													{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid}),
												_List_fromArray(
													[$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid]));
										} else {
											return _Utils_Tuple2(
												_Utils_update(
													sansSuite,
													{
														l2: $author$project$Components$Referentiel$Fiche$Model$Pret(processUid)
													}),
												_List_Nil);
										}
									}
								}
							}
						}
					}
				}
			}
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$refuser = F2(
	function (refus, saisie) {
		return _Utils_update(
			saisie,
			{aJ: _List_Nil, pZ: refus});
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$codeDeLaValeurPrise = 'ValeurDejaPrise';
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$refuserLaValeurPrise = F2(
	function (prise, saisie) {
		return _Utils_update(
			saisie,
			{
				aJ: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (adresse) {
							return _List_fromArray(
								[
									_Utils_Tuple2(prise.uN, adresse)
								]);
						},
						prise.aa)),
				pZ: _List_fromArray(
					[
						{uN: prise.uN, vx: $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$codeDeLaValeurPrise, vA: $elm$core$Maybe$Nothing, nn: $elm$core$Maybe$Nothing}
					])
			});
	});
var $author$project$Components$Referentiel$Common$ChampsDuType$dire = F2(
	function (refus, saisie) {
		switch (refus.$) {
			case 0:
				var defauts = refus.a;
				return A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$refuser, defauts, saisie);
			case 1:
				var prise = refus.a;
				return A2(
					$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$refuserLaValeurPrise,
					{
						aa: A2(
							$elm$core$Maybe$map,
							function (uid) {
								return $author$project$Routes$Route$toString(
									A2($author$project$Routes$Route$Fiche, uid, 0));
							},
							prise.zo),
						uN: prise.uN
					},
					saisie);
			default:
				return saisie;
		}
	});
var $author$project$Components$Referentiel$Common$ChampsDuType$SansRefusDeChamp = {$: 2};
var $author$project$Components$Referentiel$Common$ChampsDuType$ValeurDejaPrise = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Common$ChampsDuType$ValeursInvalides = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$Common$ChampsDuType$cleDe = function (nom) {
	return A2(
		$elm$core$Maybe$withDefault,
		nom,
		$elm$core$List$head(
			$elm$core$List$reverse(
				A2($elm$core$String$split, '.', nom))));
};
var $author$project$Components$Referentiel$Common$ChampsDuType$decoder = A2(
	$elm$json$Json$Decode$field,
	'error',
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Referentiel$Common$ChampsDuType$ValeursInvalides,
				A2(
					$elm$json$Json$Decode$field,
					'ValeursInvalides',
					A2(
						$elm$json$Json$Decode$field,
						'defauts',
						$elm$json$Json$Decode$list(
							A4(
								$elm$json$Json$Decode$map3,
								F3(
									function (champ, code, codeRefuse) {
										return {
											uN: $author$project$Components$Referentiel$Common$ChampsDuType$cleDe(champ),
											vx: code,
											vA: codeRefuse,
											nn: $elm$core$Maybe$Nothing
										};
									}),
								A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
								A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
								$elm$json$Json$Decode$maybe(
									A2($elm$json$Json$Decode$field, 'codeRefuse', $elm$json$Json$Decode$string))))))),
				A2(
				$elm$json$Json$Decode$field,
				'ValeurDejaPrise',
				A3(
					$elm$json$Json$Decode$map2,
					F2(
						function (champ, fiche) {
							return $author$project$Components$Referentiel$Common$ChampsDuType$ValeurDejaPrise(
								{
									uN: $author$project$Components$Referentiel$Common$ChampsDuType$cleDe(champ),
									zo: fiche
								});
						}),
					A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$maybe(
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['fiche', 'uid']),
							$author$project$Components$Referentiel$Identifiants$entiteUidDecoder))))
			])));
var $author$project$Components$Referentiel$Common$ChampsDuType$lireLeRefus = function (reponse) {
	return A2(
		$elm$core$Result$withDefault,
		$author$project$Components$Referentiel$Common$ChampsDuType$SansRefusDeChamp,
		A2($elm$json$Json$Decode$decodeString, $author$project$Components$Referentiel$Common$ChampsDuType$decoder, reponse.f$));
};
var $author$project$Components$Referentiel$Common$ChampsDuType$prefixe = function (page) {
	return page + '-champ-du-type';
};
var $author$project$Components$Referentiel$Fiche$Update$prefixeDuBloc = $author$project$Components$Referentiel$Common$ChampsDuType$prefixe('referentiel-fiche');
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$enCours = F2(
	function (champs, saisie) {
		return !$elm$core$List$isEmpty(
			A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$modifications, champs, saisie));
	});
var $author$project$Components$Referentiel$Fiche$Update$surLeDrawerDuBloc = F2(
	function (msg, model) {
		var enCours = function () {
			var _v2 = _Utils_Tuple2(
				model.jq,
				A2(
					$elm$core$Maybe$andThen,
					function (bloc) {
						return A2($author$project$Components$Referentiel$Fiche$Model$schemaDuType, bloc.r0, model);
					},
					model.jq));
			if ((!_v2.a.$) && (!_v2.b.$)) {
				var bloc = _v2.a.a;
				var schema = _v2.b.a;
				return A2(
					$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$enCours,
					$author$project$Components$Referentiel$Common$ChampsDuType$tousLesChamps(schema),
					bloc.hP);
			} else {
				return false;
			}
		}();
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{Il: enCours},
			msg,
			model.lo);
		var drawer = _v0.a;
		var effets = _v0.b;
		var suivant = _Utils_update(
			model,
			{lo: drawer});
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? suivant : _Utils_update(
				suivant,
				{jq: $elm$core$Maybe$Nothing}),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Referentiel$Fiche$Update$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Referentiel$Fiche$Update$rendreLeBloc = F4(
	function (uid, processUid, reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$reponseDecoder, reponse);
		if (!_v0.$) {
			return A2(
				$elm$core$Tuple$mapSecond,
				function (effets) {
					return A2(
						$elm$core$List$cons,
						$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid,
						_Utils_ap(
							A2($author$project$Components$Referentiel$Fiche$Update$lecture, uid, model),
							effets));
				},
				A2(
					$author$project$Components$Referentiel$Fiche$Update$surLeDrawerDuBloc,
					$author$project$Components$Shared$Drawer$Update$Fermer,
					_Utils_update(
						model,
						{jq: $elm$core$Maybe$Nothing, fX: false, l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid})));
		} else {
			var refus = _v0.a;
			if (refus.ri === 401) {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: $author$project$Components$Referentiel$Fiche$Model$Pret(processUid)
						}),
					_List_fromArray(
						[$author$project$Components$Referentiel$Fiche$Update$Reconnecter]));
			} else {
				if (_Utils_eq(
					$author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$duRefus(refus),
					$author$project$Components$Referentiel$Fiche$API$WriteAPIErrorsModel$FicheModifieeEntreTemps)) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{fX: true, l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid}),
						_List_fromArray(
							[$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid]));
				} else {
					if (A2($elm$core$List$member, refus.ri, $author$project$Components$Referentiel$Fiche$Update$refusNets)) {
						var dit = $author$project$Components$Referentiel$Common$ChampsDuType$lireLeRefus(reponse);
						var champRefuse = function () {
							switch (dit.$) {
								case 0:
									var champs = dit.a;
									return A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.uN;
										},
										$elm$core$List$head(champs));
								case 1:
									var pris = dit.a;
									return $elm$core$Maybe$Just(pris.uN);
								default:
									return $elm$core$Maybe$Nothing;
							}
						}();
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									jq: A2(
										$elm$core$Maybe$map,
										function (bloc) {
											return _Utils_update(
												bloc,
												{
													hP: A2($author$project$Components$Referentiel$Common$ChampsDuType$dire, dit, bloc.hP)
												});
										},
										model.jq),
									l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid
								}),
							A2(
								$elm$core$List$cons,
								$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid,
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function (champ) {
											return _List_fromArray(
												[
													$author$project$Components$Referentiel$Fiche$Update$PlacerFocus(
													A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$idDuChamp, $author$project$Components$Referentiel$Fiche$Update$prefixeDuBloc, champ))
												]);
										},
										champRefuse))));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									l2: $author$project$Components$Referentiel$Fiche$Model$Pret(processUid)
								}),
							_List_Nil);
					}
				}
			}
		}
	});
var $author$project$Components$Referentiel$Fiche$Contacts$dejaPresent = function (etat) {
	return _Utils_update(
		etat,
		{ae: true});
};
var $author$project$Components$Referentiel$Fiche$Update$surLeContact = F2(
	function (change, model) {
		return _Utils_update(
			model,
			{
				v8: change(model.v8)
			});
	});
var $author$project$Components$Referentiel$Fiche$Update$synchroniserLeDrawerDuContact = F2(
	function (declencheur, model) {
		var voulu = (!_Utils_eq(model.v8.zT, $author$project$Components$Referentiel$Fiche$Contacts$Ferme)) || (!_Utils_eq(model.v8.a7, $elm$core$Maybe$Nothing));
		var ouvert = $author$project$Components$Shared$Drawer$Model$estOuvert(model.lq);
		var geste = function (msg) {
			return A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				msg,
				model.lq);
		};
		if (voulu && (!ouvert)) {
			var _v0 = geste(
				$author$project$Components$Shared$Drawer$Update$Ouvrir(declencheur));
			var drawer = _v0.a;
			var effets = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{lq: drawer}),
				A2(
					$elm$core$List$map,
					function (_v1) {
						var cible = _v1;
						return $author$project$Components$Referentiel$Fiche$Update$PlacerFocus(cible);
					},
					effets));
		} else {
			if ((!voulu) && ouvert) {
				var _v2 = geste($author$project$Components$Shared$Drawer$Update$Fermer);
				var drawer = _v2.a;
				var effets = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{lq: drawer}),
					A2(
						$elm$core$List$map,
						function (_v3) {
							var cible = _v3;
							return $author$project$Components$Referentiel$Fiche$Update$PlacerFocus(cible);
						},
						effets));
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$rendreLeContact = F4(
	function (uid, processUid, reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$commandeDeContactDecoder, reponse);
		if (!_v0.$) {
			var _v1 = A2(
				$author$project$Components$Referentiel$Fiche$Update$synchroniserLeDrawerDuContact,
				'',
				A2(
					$author$project$Components$Referentiel$Fiche$Update$surLeContact,
					$author$project$Components$Referentiel$Fiche$Contacts$annuler,
					_Utils_update(
						model,
						{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid})));
			var ferme = _v1.a;
			var effets = _v1.b;
			return _Utils_Tuple2(
				ferme,
				A2(
					$elm$core$List$cons,
					$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid,
					_Utils_ap(
						A2($author$project$Components$Referentiel$Fiche$Update$lecture, uid, model),
						effets)));
		} else {
			var refus = _v0.a;
			return (refus.ri === 401) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: $author$project$Components$Referentiel$Fiche$Model$Pret(processUid)
					}),
				_List_fromArray(
					[$author$project$Components$Referentiel$Fiche$Update$Reconnecter])) : ((refus.ri === 404) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid, gt: $author$project$Components$Referentiel$Fiche$Model$Introuvable}),
				_List_fromArray(
					[$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid])) : ((refus.ri === 409) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid}),
				A2(
					$elm$core$List$cons,
					$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid,
					A2($author$project$Components$Referentiel$Fiche$Update$lecture, uid, model))) : ($author$project$Components$Referentiel$Fiche$Update$emailDejaSurLaFiche(refus) ? _Utils_Tuple2(
				A2(
					$author$project$Components$Referentiel$Fiche$Update$surLeContact,
					$author$project$Components$Referentiel$Fiche$Contacts$dejaPresent,
					_Utils_update(
						model,
						{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid})),
				_List_fromArray(
					[$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid])) : (A2($elm$core$List$member, refus.ri, $author$project$Components$Referentiel$Fiche$Update$refusNets) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid}),
				_List_fromArray(
					[$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid])) : _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: $author$project$Components$Referentiel$Fiche$Model$Pret(processUid)
					}),
				_List_Nil)))));
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$fermerLeCycle = function (model) {
	return _Utils_update(
		model,
		{
			ts: $elm$core$Maybe$Nothing,
			vp: false,
			kp: $elm$core$Maybe$Nothing,
			lr: $author$project$Components$Shared$Drawer$Model$init('referentiel-fiche-cycle')
		});
};
var $author$project$Components$Referentiel$Fiche$Update$rendreLeGeste = F4(
	function (uid, processUid, reponse, model) {
		var _v0 = A2(
			$author$project$API$Reponse$lire,
			$elm$json$Json$Decode$succeed(0),
			reponse);
		if (!_v0.$) {
			return _Utils_Tuple2(
				$author$project$Components$Referentiel$Fiche$Update$fermerLeCycle(
					_Utils_update(
						model,
						{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid})),
				A2(
					$elm$core$List$cons,
					$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid,
					A2($author$project$Components$Referentiel$Fiche$Update$lecture, uid, model)));
		} else {
			var refus = _v0.a;
			return (refus.ri === 401) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: $author$project$Components$Referentiel$Fiche$Model$Pret(processUid)
					}),
				_List_fromArray(
					[$author$project$Components$Referentiel$Fiche$Update$Reconnecter])) : ((refus.ri === 404) ? _Utils_Tuple2(
				$author$project$Components$Referentiel$Fiche$Update$fermerLeCycle(
					_Utils_update(
						model,
						{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid, gt: $author$project$Components$Referentiel$Fiche$Model$Introuvable})),
				_List_fromArray(
					[$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid])) : ((refus.ri === 409) ? _Utils_Tuple2(
				$author$project$Components$Referentiel$Fiche$Update$fermerLeCycle(
					_Utils_update(
						model,
						{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid})),
				A2(
					$elm$core$List$cons,
					$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid,
					A2($author$project$Components$Referentiel$Fiche$Update$lecture, uid, model))) : (A2($elm$core$List$member, refus.ri, $author$project$Components$Referentiel$Fiche$Update$refusNets) ? _Utils_Tuple2(
				$author$project$Components$Referentiel$Fiche$Update$fermerLeCycle(
					_Utils_update(
						model,
						{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid})),
				_List_fromArray(
					[$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid])) : _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: $author$project$Components$Referentiel$Fiche$Model$Pret(processUid)
					}),
				_List_Nil))));
		}
	});
var $author$project$Components$Referentiel$Fiche$Roles$fermer = function (etat) {
	return _Utils_update(
		etat,
		{zT: $author$project$Components$Referentiel$Fiche$Roles$Ferme});
};
var $author$project$Components$Referentiel$Fiche$Roles$saisie = function (etat) {
	var _v0 = etat.zT;
	switch (_v0.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var enCours = _v0.a;
			return $elm$core$Maybe$Just(enCours);
		default:
			var enCours = _v0.c;
			return $elm$core$Maybe$Just(enCours);
	}
};
var $author$project$Components$Referentiel$Fiche$Roles$saisieEnCours = function (etat) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (enCours) {
				return !_Utils_eq(
					_Utils_update(
						enCours,
						{pZ: $elm$core$Maybe$Nothing, P: false}),
					$author$project$Components$Referentiel$Fiche$Roles$saisieVide);
			},
			$author$project$Components$Referentiel$Fiche$Roles$saisie(etat)));
};
var $author$project$Components$Referentiel$Fiche$Update$surLeRole = F2(
	function (change, model) {
		return _Utils_update(
			model,
			{
				bi: change(model.bi)
			});
	});
var $author$project$Components$Referentiel$Fiche$Update$surLeDrawer = F4(
	function (lire, ecrire, msg, model) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{
				Il: $author$project$Components$Referentiel$Fiche$Roles$saisieEnCours(model.bi)
			},
			msg,
			lire(model));
		var drawer = _v0.a;
		var effets = _v0.b;
		var suivant = A2(ecrire, drawer, model);
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? suivant : A2($author$project$Components$Referentiel$Fiche$Update$surLeRole, $author$project$Components$Referentiel$Fiche$Roles$fermer, suivant),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Referentiel$Fiche$Update$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Referentiel$Fiche$Update$surLeDrawerDEvolution = A2(
	$author$project$Components$Referentiel$Fiche$Update$surLeDrawer,
	function ($) {
		return $.k1;
	},
	F2(
		function (drawer, model) {
			return _Utils_update(
				model,
				{k1: drawer});
		}));
var $author$project$Components$Referentiel$Fiche$Update$surLeDrawerDOuverture = A2(
	$author$project$Components$Referentiel$Fiche$Update$surLeDrawer,
	function ($) {
		return $.k4;
	},
	F2(
		function (drawer, model) {
			return _Utils_update(
				model,
				{k4: drawer});
		}));
var $author$project$Components$Referentiel$Fiche$Update$fermerLesDrawers = function (model) {
	var _v0 = $author$project$Components$Shared$Drawer$Model$estOuvert(model.k4) ? A2($author$project$Components$Referentiel$Fiche$Update$surLeDrawerDOuverture, $author$project$Components$Shared$Drawer$Update$Fermer, model) : _Utils_Tuple2(model, _List_Nil);
	var sansOuverture = _v0.a;
	var focusDOuverture = _v0.b;
	var _v1 = $author$project$Components$Shared$Drawer$Model$estOuvert(sansOuverture.k1) ? A2($author$project$Components$Referentiel$Fiche$Update$surLeDrawerDEvolution, $author$project$Components$Shared$Drawer$Update$Fermer, sansOuverture) : _Utils_Tuple2(sansOuverture, _List_Nil);
	var sansEvolution = _v1.a;
	var focusDEvolution = _v1.b;
	return _Utils_Tuple2(
		A2($author$project$Components$Referentiel$Fiche$Update$surLeRole, $author$project$Components$Referentiel$Fiche$Roles$fermer, sansEvolution),
		_Utils_ap(focusDOuverture, focusDEvolution));
};
var $author$project$Components$Referentiel$Fiche$Roles$refuser = F2(
	function (refus, etat) {
		var _v0 = etat.zT;
		switch (_v0.$) {
			case 0:
				return etat;
			case 1:
				var enCours = _v0.a;
				return _Utils_update(
					etat,
					{
						zT: $author$project$Components$Referentiel$Fiche$Roles$Ouverture(
							_Utils_update(
								enCours,
								{
									pZ: $elm$core$Maybe$Just(refus)
								}))
					});
			default:
				var uid = _v0.a;
				var choix = _v0.b;
				var enCours = _v0.c;
				return _Utils_update(
					etat,
					{
						zT: A3(
							$author$project$Components$Referentiel$Fiche$Roles$Evolution,
							uid,
							choix,
							_Utils_update(
								enCours,
								{
									pZ: $elm$core$Maybe$Just(refus)
								}))
					});
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$rendreLeRole = F4(
	function (uid, processUid, reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$commandeDeContactDecoder, reponse);
		if (!_v0.$) {
			var _v1 = $author$project$Components$Referentiel$Fiche$Update$fermerLesDrawers(
				_Utils_update(
					model,
					{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid}));
			var ferme = _v1.a;
			var focus = _v1.b;
			return _Utils_Tuple2(
				ferme,
				_Utils_ap(
					focus,
					A2(
						$elm$core$List$cons,
						$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid,
						A2($author$project$Components$Referentiel$Fiche$Update$lecture, uid, model))));
		} else {
			var refus = _v0.a;
			var _v2 = _Utils_Tuple2(
				refus.ri,
				$author$project$Components$Referentiel$Fiche$Update$refusDeRole(refus));
			_v2$0:
			while (true) {
				_v2$1:
				while (true) {
					if (!_v2.b.$) {
						switch (_v2.a) {
							case 401:
								break _v2$0;
							case 404:
								break _v2$1;
							default:
								var statut = _v2.a;
								var dit = _v2.b.a;
								return _Utils_Tuple2(
									A2(
										$author$project$Components$Referentiel$Fiche$Update$surLeRole,
										$author$project$Components$Referentiel$Fiche$Roles$refuser(dit),
										_Utils_update(
											model,
											{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid})),
									A2(
										$elm$core$List$cons,
										$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid,
										(statut === 409) ? A2($author$project$Components$Referentiel$Fiche$Update$lecture, uid, model) : _List_Nil));
						}
					} else {
						switch (_v2.a) {
							case 401:
								break _v2$0;
							case 404:
								break _v2$1;
							case 409:
								var _v4 = _v2.b;
								var _v5 = $author$project$Components$Referentiel$Fiche$Update$fermerLesDrawers(
									_Utils_update(
										model,
										{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid}));
								var ferme = _v5.a;
								var focus = _v5.b;
								return _Utils_Tuple2(
									ferme,
									_Utils_ap(
										focus,
										A2(
											$elm$core$List$cons,
											$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid,
											A2($author$project$Components$Referentiel$Fiche$Update$lecture, uid, model))));
							default:
								var statut = _v2.a;
								var _v6 = _v2.b;
								return A2($elm$core$List$member, statut, $author$project$Components$Referentiel$Fiche$Update$refusNets) ? _Utils_Tuple2(
									_Utils_update(
										model,
										{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid}),
									_List_fromArray(
										[$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid])) : _Utils_Tuple2(
									_Utils_update(
										model,
										{
											l2: $author$project$Components$Referentiel$Fiche$Model$Pret(processUid)
										}),
									_List_Nil);
						}
					}
				}
				var _v3 = $author$project$Components$Referentiel$Fiche$Update$fermerLesDrawers(
					_Utils_update(
						model,
						{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid, gt: $author$project$Components$Referentiel$Fiche$Model$Introuvable}));
				var ferme = _v3.a;
				var focus = _v3.b;
				return _Utils_Tuple2(
					ferme,
					_Utils_ap(
						focus,
						_List_fromArray(
							[$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid])));
			}
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: $author$project$Components$Referentiel$Fiche$Model$Pret(processUid)
					}),
				_List_fromArray(
					[$author$project$Components$Referentiel$Fiche$Update$Reconnecter]));
		}
	});
var $author$project$Components$Referentiel$Fiche$Occurrences$ferme = function (etat) {
	return _Utils_update(
		etat,
		{dh: $elm$core$Maybe$Nothing, Et: $elm$core$Maybe$Nothing, J8: false});
};
var $author$project$Components$Referentiel$Fiche$Occurrences$dernierMot = function (chemin) {
	return A2(
		$elm$core$Maybe$withDefault,
		chemin,
		$elm$core$List$head(
			$elm$core$List$reverse(
				A2($elm$core$String$split, '.', chemin))));
};
var $author$project$Components$Referentiel$Fiche$Occurrences$lireLeRefus = function (reponse) {
	var defaut = A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (sousChamp, code) {
				return {
					vx: code,
					IW: $author$project$Components$Referentiel$Fiche$Occurrences$dernierMot(sousChamp)
				};
			}),
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2($elm$json$Json$Decode$field, 'sousChamp', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$succeed('')
				])),
		A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string));
	return A2(
		$elm$core$Result$withDefault,
		_List_Nil,
		A2(
			$elm$json$Json$Decode$decodeString,
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['error', 'ValeursInvalides', 'defauts']),
						$elm$json$Json$Decode$list(defaut)),
						A2(
						$elm$json$Json$Decode$map,
						$elm$core$List$map(
							function (_v0) {
								var nom = _v0.a;
								return {vx: nom, IW: ''};
							}),
						A2(
							$elm$json$Json$Decode$field,
							'error',
							$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value)))
					])),
			reponse.f$));
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$refuser = F2(
	function (refus, brouillon) {
		return _Utils_update(
			brouillon,
			{pZ: refus});
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$tapeesRetenues = function (brouillon) {
	return A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Tuple$second,
			$elm$core$Basics$neq('')),
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$mapSecond($elm$core$String$trim),
			brouillon.Z));
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$modifie = function (brouillon) {
	return A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$enCours, brouillon.IX, brouillon.hP) || (!$elm$core$List$isEmpty(
		$author$project$Components$Shared$EditeurDeSchema$Groupe$tapeesRetenues(brouillon)));
};
var $author$project$Components$Referentiel$Fiche$Update$surLeDrawerDeLOccurrence = F2(
	function (msg, model) {
		var enCours = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.uw;
					},
					$author$project$Components$Shared$EditeurDeSchema$Groupe$modifie),
				model.oV.Et));
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{Il: enCours},
			msg,
			model.oV.kX);
		var drawer = _v0.a;
		var effets = _v0.b;
		var suivant = A2(
			$author$project$Components$Referentiel$Fiche$Update$surLesOccurrences,
			function (etat) {
				return _Utils_update(
					etat,
					{kX: drawer});
			},
			model);
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? suivant : A2($author$project$Components$Referentiel$Fiche$Update$surLesOccurrences, $author$project$Components$Referentiel$Fiche$Occurrences$ferme, suivant),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Referentiel$Fiche$Update$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Referentiel$Fiche$Update$rendreUneOccurrence = F4(
	function (uid, processUid, reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$reponseDecoder, reponse);
		if (!_v0.$) {
			return A2(
				$elm$core$Tuple$mapSecond,
				function (effets) {
					return A2(
						$elm$core$List$cons,
						$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid,
						_Utils_ap(
							A2($author$project$Components$Referentiel$Fiche$Update$lecture, uid, model),
							effets));
				},
				A2(
					$author$project$Components$Referentiel$Fiche$Update$surLeDrawerDeLOccurrence,
					$author$project$Components$Shared$Drawer$Update$Fermer,
					A2(
						$author$project$Components$Referentiel$Fiche$Update$surLesOccurrences,
						$author$project$Components$Referentiel$Fiche$Occurrences$ferme,
						_Utils_update(
							model,
							{fX: false, l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid}))));
		} else {
			var refus = _v0.a;
			if (refus.ri === 401) {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: $author$project$Components$Referentiel$Fiche$Model$Pret(processUid)
						}),
					_List_fromArray(
						[$author$project$Components$Referentiel$Fiche$Update$Reconnecter]));
			} else {
				if (A2($elm$core$List$member, refus.ri, $author$project$Components$Referentiel$Fiche$Update$refusNets)) {
					var defauts = $author$project$Components$Referentiel$Fiche$Occurrences$lireLeRefus(reponse);
					var nommes = A2(
						$elm$core$List$filter,
						function (defaut) {
							return (defaut.IW !== '') || (defaut.vx !== 'UneSeuleOccurrence');
						},
						defauts);
					var uneSeule = A2(
						$elm$core$List$any,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.vx;
							},
							$elm$core$Basics$eq('UneSeuleOccurrence')),
						defauts);
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLesOccurrences,
							function (etat) {
								return _Utils_update(
									etat,
									{
										Et: A2(
											$elm$core$Maybe$map,
											function (ouverte) {
												return _Utils_update(
													ouverte,
													{
														uw: A2($author$project$Components$Shared$EditeurDeSchema$Groupe$refuser, nommes, ouverte.uw)
													});
											},
											etat.Et),
										J8: uneSeule
									});
							},
							_Utils_update(
								model,
								{l2: $author$project$Components$Referentiel$Fiche$Model$SansProcessUid})),
						_List_fromArray(
							[$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid]));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l2: $author$project$Components$Referentiel$Fiche$Model$Pret(processUid)
							}),
						_List_Nil);
				}
			}
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$rolesDe = function (model) {
	var _v0 = model.gt;
	if (_v0.$ === 1) {
		var fiche = _v0.a;
		return _Utils_ap(fiche.eX, fiche.H7);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Referentiel$Fiche$Update$roleDe = F2(
	function (uid, model) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (role) {
					return _Utils_eq(role.r8, uid);
				},
				$author$project$Components$Referentiel$Fiche$Update$rolesDe(model)));
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$Saisi = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$saisir = F2(
	function (geste, brouillon) {
		switch (geste.$) {
			case 0:
				if (!geste.a.$) {
					var _v1 = geste.a;
					var cle = _v1.a;
					var valeur = _v1.b;
					return _Utils_update(
						brouillon,
						{
							hP: A2(
								$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$saisir,
								A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$Saisi, cle, valeur),
								brouillon.hP),
							Z: A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Tuple$first,
									$elm$core$Basics$neq(cle)),
								brouillon.Z)
						});
				} else {
					var autre = geste.a;
					return _Utils_update(
						brouillon,
						{
							hP: A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$saisir, autre, brouillon.hP)
						});
				}
			case 2:
				var uid = geste.a;
				var _v2 = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.r8;
							},
							$elm$core$Basics$eq(uid)),
						brouillon.mp));
				if (!_v2.$) {
					var lue = _v2.a;
					return _Utils_update(
						brouillon,
						{
							pZ: _List_Nil,
							hP: $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$jugerApresLaTentative(
								A2(
									$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$depuis,
									{dw: brouillon.IX, Ba: brouillon.Ba},
									lue.Ki)),
							Z: _List_Nil,
							b5: false,
							r8: $elm$core$Maybe$Just(uid)
						});
				} else {
					return brouillon;
				}
			default:
				var cle = geste.a;
				var libelle = geste.b;
				return _Utils_update(
					brouillon,
					{
						pZ: A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.vx;
								},
								$elm$core$Basics$neq('ValeurNonCreee')),
							brouillon.pZ),
						Z: _Utils_ap(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Tuple$first,
									$elm$core$Basics$neq(cle)),
								brouillon.Z),
							_List_fromArray(
								[
									_Utils_Tuple2(cle, libelle)
								]))
					});
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$saisirLaDateDExport = F2(
	function (texte, model) {
		var date = A2($elm$core$String$left, 10, texte);
		var modifie = A2(
			$author$project$Components$Referentiel$Fiche$Update$surLExport,
			function (etat) {
				return _Utils_update(
					etat,
					{tq: $elm$core$Maybe$Nothing, wv: date});
			},
			model);
		var _v0 = model.gt;
		if (_v0.$ === 1) {
			var fiche = _v0.a;
			return _Utils_Tuple2(
				modifie,
				($elm$core$String$length(date) === 10) ? A2(
					$author$project$Components$Referentiel$Fiche$Update$lireLApercuDeLExport,
					fiche,
					$elm$core$Maybe$Just(date)) : _List_Nil);
		} else {
			return _Utils_Tuple2(modifie, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Common$ChampsDuType$schemaDe = F2(
	function (saisie, champs) {
		return {dw: champs, Ba: saisie.Ba, sb: saisie.sb};
	});
var $author$project$Components$Referentiel$Fiche$Update$schemasLus = F2(
	function (reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$API$QueryAPIModel$typesAvecSaisieDecoder, reponse);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var types = _v1.a;
			var saisie = _v1.b;
			return _Utils_update(
				model,
				{
					hR: A2(
						$elm$core$List$map,
						function (type_) {
							return _Utils_Tuple2(
								type_.r8,
								A2(
									$author$project$Components$Referentiel$Common$ChampsDuType$schemaDe,
									saisie,
									A2(
										$elm$core$List$map,
										function ($) {
											return $.uN;
										},
										type_.dw)));
						},
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.dw;
								},
								A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)),
							types))
				});
		} else {
			return model;
		}
	});
var $author$project$Components$Referentiel$Common$Contact$setChampDAdresse = F3(
	function (champ, valeur, adresse) {
		switch (champ) {
			case 0:
				return _Utils_update(
					adresse,
					{a3: valeur});
			case 1:
				return _Utils_update(
					adresse,
					{a4: valeur});
			case 2:
				return _Utils_update(
					adresse,
					{a5: valeur});
			case 3:
				return _Utils_update(
					adresse,
					{vz: valeur});
			case 4:
				return _Utils_update(
					adresse,
					{B_: valeur});
			case 5:
				return _Utils_update(
					adresse,
					{Hj: valeur});
			default:
				return _Utils_update(
					adresse,
					{ho: valeur});
		}
	});
var $author$project$Components$Referentiel$Common$Contact$setAdresse = F3(
	function (rang, champ, valeur) {
		return A2(
			$author$project$Components$Referentiel$Common$Contact$surLaLigne,
			rang,
			function (ligne) {
				return _Utils_update(
					ligne,
					{
						aa: A3($author$project$Components$Referentiel$Common$Contact$setChampDAdresse, champ, valeur, ligne.aa)
					});
			});
	});
var $author$project$Components$Referentiel$Fiche$Contacts$setAdresse = F2(
	function (champ, valeur) {
		return $author$project$Components$Referentiel$Fiche$Contacts$surLaLigne(
			A3($author$project$Components$Referentiel$Common$Contact$setAdresse, 0, champ, valeur));
	});
var $author$project$Components$Referentiel$Fiche$Contacts$ligne = function (etat) {
	var _v0 = etat.zT;
	switch (_v0.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var saisie = _v0.a;
			return $elm$core$Maybe$Just(saisie);
		default:
			var saisie = _v0.b;
			return $elm$core$Maybe$Just(saisie);
	}
};
var $author$project$Components$Referentiel$Fiche$Contacts$setCanal = F2(
	function (code, etat) {
		var _v0 = etat.zT;
		if (_v0.$ === 1) {
			return function (change) {
				var _v1 = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.uF;
					},
					$author$project$Components$Referentiel$Fiche$Contacts$ligne(change));
				_v1$2:
				while (true) {
					if (!_v1.$) {
						switch (_v1.a) {
							case 0:
								var _v2 = _v1.a;
								return change;
							case 1:
								var _v3 = _v1.a;
								return change;
							default:
								break _v1$2;
						}
					} else {
						break _v1$2;
					}
				}
				return _Utils_update(
					change,
					{pN: $elm$core$Maybe$Nothing});
			}(
				A2(
					$author$project$Components$Referentiel$Fiche$Contacts$surLaLigne,
					A2($author$project$Components$Referentiel$Common$Contact$setCanal, 0, code),
					etat));
		} else {
			return etat;
		}
	});
var $author$project$Components$Referentiel$Fiche$Rattacher$setCanalDuContact = F3(
	function (rang, code, saisie) {
		return A2(
			$elm$core$List$member,
			code,
			_List_fromArray(
				[
					$author$project$Components$Referentiel$Common$Contact$canalCode(0),
					$author$project$Components$Referentiel$Common$Contact$canalCode(1)
				])) ? _Utils_update(
			saisie,
			{
				wa: A3($author$project$Components$Referentiel$Common$Contact$setCanal, rang, code, saisie.wa)
			}) : saisie;
	});
var $author$project$Components$Referentiel$Fiche$Roles$choixCode = function (choix) {
	switch (choix) {
		case 0:
			return 'statut';
		case 1:
			return 'remplacer';
		case 2:
			return 'clore';
		default:
			return 'fin';
	}
};
var $author$project$Components$Referentiel$Fiche$Roles$setChoix = F2(
	function (code, etat) {
		var choisi = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (choix) {
					return _Utils_eq(
						$author$project$Components$Referentiel$Fiche$Roles$choixCode(choix),
						code);
				},
				_List_fromArray(
					[0, 1, 2, 3])));
		var _v0 = _Utils_Tuple2(etat.zT, choisi);
		if ((_v0.a.$ === 2) && (!_v0.b.$)) {
			var _v1 = _v0.a;
			var uid = _v1.a;
			var enCours = _v1.c;
			var choix = _v0.b.a;
			return _Utils_update(
				etat,
				{
					zT: A3(
						$author$project$Components$Referentiel$Fiche$Roles$Evolution,
						uid,
						choix,
						_Utils_update(
							enCours,
							{pZ: $elm$core$Maybe$Nothing, P: false}))
				});
		} else {
			return etat;
		}
	});
var $author$project$Components$Referentiel$Fiche$Roles$surLaSaisie = F2(
	function (change, etat) {
		var changee = function (enCours) {
			return change(
				_Utils_update(
					enCours,
					{pZ: $elm$core$Maybe$Nothing}));
		};
		var _v0 = etat.zT;
		switch (_v0.$) {
			case 0:
				return etat;
			case 1:
				var enCours = _v0.a;
				return _Utils_update(
					etat,
					{
						zT: $author$project$Components$Referentiel$Fiche$Roles$Ouverture(
							changee(enCours))
					});
			default:
				var uid = _v0.a;
				var choix = _v0.b;
				var enCours = _v0.c;
				return _Utils_update(
					etat,
					{
						zT: A3(
							$author$project$Components$Referentiel$Fiche$Roles$Evolution,
							uid,
							choix,
							changee(enCours))
					});
		}
	});
var $author$project$Components$Referentiel$Fiche$Roles$setCommentaire = function (texte) {
	return $author$project$Components$Referentiel$Fiche$Roles$surLaSaisie(
		function (enCours) {
			return _Utils_update(
				enCours,
				{vM: texte});
		});
};
var $author$project$Components$Referentiel$Fiche$Roles$setDate = function (date) {
	return $author$project$Components$Referentiel$Fiche$Roles$surLaSaisie(
		function (enCours) {
			return _Utils_update(
				enCours,
				{wv: date});
		});
};
var $author$project$Components$Referentiel$Fiche$Rattacher$setDebut = F2(
	function (debut, saisie) {
		return _Utils_update(
			saisie,
			{ku: debut});
	});
var $author$project$Components$Referentiel$Fiche$Rattacher$setDepartement = F2(
	function (departement, saisie) {
		return _Utils_update(
			saisie,
			{
				xb: A2($elm$core$String$left, 200, departement)
			});
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$setFin = F2(
	function (saisie, etat) {
		var _v0 = etat.mW;
		if (_v0.$ === 1) {
			var rattachement = _v0.a;
			return _Utils_update(
				etat,
				{
					mW: A2($author$project$Components$Referentiel$Fiche$Liaisons$Fin, rattachement, saisie)
				});
		} else {
			return etat;
		}
	});
var $author$project$Components$Referentiel$Fiche$Rattacher$setIntitule = F2(
	function (intitule, saisie) {
		return _Utils_update(
			saisie,
			{
				AS: A2($elm$core$String$left, 200, intitule)
			});
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$setIntitule = function (intitule) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Components$Referentiel$Fiche$Liaisons$surLaModification(
			function (saisie) {
				return _Utils_update(
					saisie,
					{
						AS: A2($elm$core$String$left, 200, intitule)
					});
			}),
		$author$project$Components$Referentiel$Fiche$Liaisons$surLeRattachement(
			$author$project$Components$Referentiel$Fiche$Rattacher$setIntitule(intitule)));
};
var $author$project$Components$Referentiel$Fiche$Roles$setOffre = function (id) {
	return $author$project$Components$Referentiel$Fiche$Roles$surLaSaisie(
		function (enCours) {
			return _Utils_update(
				enCours,
				{D1: id});
		});
};
var $author$project$Components$Referentiel$Fiche$Liaisons$setPhrase = F2(
	function (phrase, etat) {
		var _v0 = etat.mW;
		if (_v0.$ === 5) {
			var contexte = _v0.a;
			var saisie = _v0.b;
			return _Utils_update(
				etat,
				{
					aX: false,
					mW: A2(
						$author$project$Components$Referentiel$Fiche$Liaisons$NouvelleRelation,
						contexte,
						_Utils_update(
							saisie,
							{Fp: phrase})),
					pZ: $elm$core$Maybe$Nothing
				});
		} else {
			return etat;
		}
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$setPostes = F2(
	function (postes, etat) {
		return _Utils_update(
			etat,
			{F6: postes});
	});
var $author$project$Components$Referentiel$Fiche$Rattacher$setPrincipal = F2(
	function (principal, saisie) {
		return _Utils_update(
			saisie,
			{px: principal});
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$setPrincipal = function (principal) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Components$Referentiel$Fiche$Liaisons$surLaModification(
			function (saisie) {
				return _Utils_update(
					saisie,
					{px: principal});
			}),
		A2(
			$elm$core$Basics$composeR,
			$author$project$Components$Referentiel$Fiche$Liaisons$surLeRattachement(
				$author$project$Components$Referentiel$Fiche$Rattacher$setPrincipal(principal)),
			function (etat) {
				return _Utils_update(
					etat,
					{j6: $author$project$Components$Referentiel$Fiche$Liaisons$NonDemandee});
			}));
};
var $author$project$Components$Referentiel$Common$Contact$setProspection = F2(
	function (rang, prospection) {
		return A2(
			$author$project$Components$Referentiel$Common$Contact$surLaLigne,
			rang,
			function (ligne) {
				return _Utils_update(
					ligne,
					{Gx: prospection});
			});
	});
var $author$project$Components$Referentiel$Fiche$Contacts$setProspection = function (acceptee) {
	return $author$project$Components$Referentiel$Fiche$Contacts$surLaLigne(
		A2($author$project$Components$Referentiel$Common$Contact$setProspection, 0, acceptee));
};
var $author$project$Components$Referentiel$Fiche$Roles$setResultat = function (code) {
	return $author$project$Components$Referentiel$Fiche$Roles$surLaSaisie(
		function (enCours) {
			return _Utils_update(
				enCours,
				{HW: code});
		});
};
var $author$project$Components$Referentiel$Fiche$Roles$setRetirerLaFin = function (retiree) {
	return $author$project$Components$Referentiel$Fiche$Roles$surLaSaisie(
		function (enCours) {
			return _Utils_update(
				enCours,
				{b$: retiree});
		});
};
var $author$project$Components$Referentiel$Fiche$Model$setSaisie = F3(
	function (cle, saisie, model) {
		return _Utils_update(
			model,
			{
				bI: model.bI && ((cle !== 7) && (cle !== 5)),
				c7: A2(
					$elm$core$List$map,
					function (_v0) {
						var de = _v0.a;
						var avant = _v0.b;
						return _Utils_eq(de, cle) ? _Utils_Tuple2(de, saisie) : _Utils_Tuple2(de, avant);
					},
					model.c7)
			});
	});
var $author$project$Components$Referentiel$Fiche$Roles$setStatut = function (code) {
	return $author$project$Components$Referentiel$Fiche$Roles$surLaSaisie(
		function (enCours) {
			return _Utils_update(
				enCours,
				{ri: code});
		});
};
var $author$project$Components$Referentiel$Common$RechercheDeFiche$setTerme = F2(
	function (terme, recherche) {
		var saisie = _Utils_update(
			recherche,
			{ve: $elm$core$Maybe$Nothing, hP: recherche.hP + 1, h3: terme});
		return _Utils_eq(
			$author$project$Components$Referentiel$Common$RechercheDeFiche$aChercher(saisie),
			$elm$core$Maybe$Nothing) ? _Utils_update(
			saisie,
			{Gw: _List_Nil}) : saisie;
	});
var $author$project$Components$Referentiel$Fiche$Roles$setType = function (uid) {
	return $author$project$Components$Referentiel$Fiche$Roles$surLaSaisie(
		function (enCours) {
			return _Utils_update(
				enCours,
				{r0: uid});
		});
};
var $author$project$Components$Referentiel$Fiche$Liaisons$setTypes = F2(
	function (types, etat) {
		return _Utils_update(
			etat,
			{ib: types});
	});
var $author$project$Components$Referentiel$Fiche$Contacts$setUsage = function (code) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Components$Referentiel$Fiche$Contacts$surLaLigne(
			A2($author$project$Components$Referentiel$Common$Contact$setUsage, 0, code)),
		function (etat) {
			return _Utils_update(
				etat,
				{pN: $elm$core$Maybe$Nothing});
		});
};
var $author$project$Components$Referentiel$Common$Contact$setValeur = F2(
	function (rang, valeur) {
		return A2(
			$author$project$Components$Referentiel$Common$Contact$surLaLigne,
			rang,
			function (ligne) {
				return _Utils_update(
					ligne,
					{fm: valeur});
			});
	});
var $author$project$Components$Referentiel$Fiche$Contacts$setValeur = function (valeur) {
	return $author$project$Components$Referentiel$Fiche$Contacts$surLaLigne(
		A2($author$project$Components$Referentiel$Common$Contact$setValeur, 0, valeur));
};
var $author$project$Components$Referentiel$Fiche$Rattacher$setValeurDuContact = F3(
	function (rang, valeur, saisie) {
		return _Utils_update(
			saisie,
			{
				wa: A3($author$project$Components$Referentiel$Common$Contact$setValeur, rang, valeur, saisie.wa)
			});
	});
var $author$project$Components$Referentiel$Fiche$Update$surLEffacement = F2(
	function (change, model) {
		return _Utils_update(
			model,
			{
				x9: change(model.x9)
			});
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$surLaRecherche = F2(
	function (change, etat) {
		var _v0 = etat.mW;
		switch (_v0.$) {
			case 4:
				var contexte = _v0.a;
				var saisie = _v0.b;
				return _Utils_update(
					etat,
					{
						mW: A2(
							$author$project$Components$Referentiel$Fiche$Liaisons$NouveauRattachement,
							contexte,
							_Utils_update(
								saisie,
								{
									hC: change(saisie.hC)
								}))
					});
			case 5:
				var contexte = _v0.a;
				var saisie = _v0.b;
				return _Utils_update(
					etat,
					{
						aX: false,
						mW: A2(
							$author$project$Components$Referentiel$Fiche$Liaisons$NouvelleRelation,
							contexte,
							_Utils_update(
								saisie,
								{
									hC: change(saisie.hC)
								})),
						pZ: $elm$core$Maybe$Nothing
					});
			default:
				return etat;
		}
	});
var $author$project$Components$Referentiel$Fiche$Model$enEdition = F2(
	function (cle, model) {
		return A2(
			$elm$core$List$any,
			function (_v0) {
				var de = _v0.a;
				return _Utils_eq(de, cle);
			},
			model.c7);
	});
var $author$project$Components$Referentiel$Fiche$Model$paysModifie = F2(
	function (fiche, model) {
		return A2($author$project$Components$Referentiel$Fiche$Model$enEdition, 5, model) && (!_Utils_eq(
			$elm$core$Maybe$Just(
				A2($author$project$Components$Referentiel$Fiche$Model$saisieDe, 5, model)),
			A2($author$project$Components$Referentiel$Fiche$Model$valeurDe, 5, fiche)));
	});
var $author$project$I18n$Textes$referentielFicheChampIdentifiantLegalInvalide = A3($author$project$I18n$Traductions$texte, 'referentiel.fiche.champ.identifiant-legal-invalide', _List_Nil, 'Identifiant légal invalide : ce n\'est ni un SIREN ni un SIRET valide. Vérifiez les chiffres.');
var $author$project$I18n$Textes$referentielFicheChampObligatoire = A3($author$project$I18n$Traductions$texte, 'referentiel.fiche.champ.obligatoire', _List_Nil, 'Ce champ est obligatoire.');
var $author$project$I18n$Textes$referentielFicheIdentiteDrawerIdentifiantInvalidePaysModifie = A3($author$project$I18n$Traductions$texte, 'referentiel.fiche.identite.drawer.identifiant-invalide-pays-modifie', _List_Nil, 'Cet identifiant n\'est ni un SIREN ni un SIRET valide : le pays est maintenant la France. Corrigez-le ou gardez le pays précédent.');
var $author$project$Components$Referentiel$Fiche$Model$seVide = function (cle) {
	return (cle === 6) || ((!cle) || (cle === 7));
};
var $author$project$Components$Referentiel$Fiche$Model$vide = function (saisie) {
	return $elm$core$String$trim(saisie) === '';
};
var $author$project$Components$Referentiel$Fiche$Model$erreurDe = F2(
	function (cle, model) {
		var _v0 = model.gt;
		if (_v0.$ === 1) {
			var fiche = _v0.a;
			return (A2($author$project$Components$Referentiel$Fiche$Model$enEdition, cle, model) && ($author$project$Components$Referentiel$Fiche$Model$vide(
				A2($author$project$Components$Referentiel$Fiche$Model$saisieDe, cle, model)) && (!$author$project$Components$Referentiel$Fiche$Model$seVide(cle)))) ? $elm$core$Maybe$Just($author$project$I18n$Textes$referentielFicheChampObligatoire) : (((cle === 7) && (model.bI && A2($author$project$Components$Referentiel$Fiche$Model$enEdition, cle, model))) ? (A2($author$project$Components$Referentiel$Fiche$Model$paysModifie, fiche, model) ? $elm$core$Maybe$Just($author$project$I18n$Textes$referentielFicheIdentiteDrawerIdentifiantInvalidePaysModifie) : $elm$core$Maybe$Just($author$project$I18n$Textes$referentielFicheChampIdentifiantLegalInvalide)) : $elm$core$Maybe$Nothing);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Referentiel$Fiche$Model$modifications = function (model) {
	var _v0 = model.gt;
	if (_v0.$ === 1) {
		var fiche = _v0.a;
		return A2(
			$elm$core$List$any,
			function (_v1) {
				var cle = _v1.a;
				return !_Utils_eq(
					A2($author$project$Components$Referentiel$Fiche$Model$erreurDe, cle, model),
					$elm$core$Maybe$Nothing);
			},
			model.c7) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A2(
				$elm$core$List$filterMap,
				function (_v2) {
					var cle = _v2.a;
					var saisie = _v2.b;
					var voulue = $author$project$Components$Referentiel$Fiche$Model$vide(saisie) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$elm$core$String$trim(saisie));
					return (_Utils_eq(
						voulue,
						A2($author$project$Components$Referentiel$Fiche$Model$valeurDe, cle, fiche)) || ((cle === 7) && _Utils_eq(
						voulue,
						$elm$core$Maybe$Just(
							A2($author$project$Components$Referentiel$Fiche$Model$saisieInitiale, fiche, cle))))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						{
							uN: $author$project$Components$Referentiel$Fiche$Model$nomAuContrat(cle),
							fm: voulue
						});
				},
				model.c7));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Fiche$Model$sansSaisieEnCours = function (model) {
	return _Utils_eq(
		$author$project$Components$Referentiel$Fiche$Model$modifications(model),
		$elm$core$Maybe$Just(_List_Nil));
};
var $author$project$Components$Referentiel$Fiche$Update$surLeDrawerDIdentite = F2(
	function (msg, model) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{
				Il: !$author$project$Components$Referentiel$Fiche$Model$sansSaisieEnCours(model)
			},
			msg,
			model.k2);
		var drawer = _v0.a;
		var effets = _v0.b;
		var suivant = _Utils_update(
			model,
			{k2: drawer});
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? suivant : $author$project$Components$Referentiel$Fiche$Model$annulerLEdition(suivant),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Referentiel$Fiche$Update$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Referentiel$Fiche$Update$surLeDrawerDuContact = F2(
	function (msg, model) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{
				Il: !_Utils_eq(model.v8.zT, $author$project$Components$Referentiel$Fiche$Contacts$Ferme)
			},
			msg,
			model.lq);
		var drawer = _v0.a;
		var effets = _v0.b;
		var suivant = _Utils_update(
			model,
			{lq: drawer});
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? suivant : A2($author$project$Components$Referentiel$Fiche$Update$surLeContact, $author$project$Components$Referentiel$Fiche$Contacts$annuler, suivant),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Referentiel$Fiche$Update$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Referentiel$Common$ChoixDeLien$Trouvees = F2(
	function (nommees, total) {
		return {DF: nommees, JE: total};
	});
var $author$project$Components$Referentiel$Common$ChoixDeLien$nommeesDecoder = function (genre) {
	var nomme = $author$project$Components$Referentiel$Common$ChoixDeLien$nommeeDecoder;
	var article = A4(
		$elm$json$Json$Decode$map3,
		F3(
			function (id, code, nom) {
				return {
					Dj: $elm$core$Maybe$Just(
						A2(
							$elm$core$Maybe$withDefault,
							code,
							A2(
								$elm$core$Maybe$map,
								function (n) {
									return code + (' — ' + n);
								},
								nom))),
					r8: id
				};
			}),
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
		$elm$json$Json$Decode$maybe(
			A2(
				$elm$json$Json$Decode$field,
				$author$project$Catalogue$Vocabulaire$codeProduit,
				A2($elm$json$Json$Decode$field, 'fr', $elm$json$Json$Decode$string))));
	switch (genre.$) {
		case 0:
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$Components$Referentiel$Common$ChoixDeLien$Trouvees,
				A2(
					$elm$json$Json$Decode$field,
					'fiches',
					$elm$json$Json$Decode$list(nomme)),
				A2($elm$json$Json$Decode$field, 'total', $elm$json$Json$Decode$int));
		case 1:
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$Components$Referentiel$Common$ChoixDeLien$Trouvees,
				A2(
					$elm$json$Json$Decode$field,
					'utilisateurs',
					$elm$json$Json$Decode$list(nomme)),
				A2($elm$json$Json$Decode$field, 'total', $elm$json$Json$Decode$int));
		default:
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$Components$Referentiel$Common$ChoixDeLien$Trouvees,
				A2(
					$elm$json$Json$Decode$field,
					'references',
					$elm$json$Json$Decode$list(article)),
				A2($elm$json$Json$Decode$field, 'total', $elm$json$Json$Decode$int));
	}
};
var $author$project$Components$Referentiel$Common$ChoixDeLien$retenir = F3(
	function (cle, nouvelles, retenues) {
		var deja = A2(
			$elm$core$List$concatMap,
			$elm$core$Tuple$second,
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$first,
					$elm$core$Basics$eq(cle)),
				retenues));
		return A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				cle,
				_Utils_ap(
					deja,
					A2(
						$elm$core$List$filter,
						function (une) {
							return !A2(
								$elm$core$List$any,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.r8;
									},
									$elm$core$Basics$eq(une.r8)),
								deja);
						},
						nouvelles))),
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$first,
					$elm$core$Basics$neq(cle)),
				retenues));
	});
var $author$project$Components$Referentiel$Common$ChoixDeLien$sansValeur = function (_v0) {
	var etat = _v0.a;
	var demande = _v0.b;
	return _Utils_Tuple3(etat, demande, $elm$core$Maybe$Nothing);
};
var $author$project$Components$Referentiel$Common$ChoixDeLien$update = F2(
	function (msg, etat) {
		var _v0 = _Utils_Tuple2(msg, etat.Et);
		_v0$7:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (!_v0.b.$) {
						var terme = _v0.a.a;
						var recherche = _v0.b.a;
						return $author$project$Components$Referentiel$Common$ChoixDeLien$sansValeur(
							A2(
								$author$project$Components$Referentiel$Common$ChoixDeLien$demander,
								_Utils_update(
									recherche,
									{EE: 1, h3: terme}),
								etat));
					} else {
						break _v0$7;
					}
				case 1:
					if (!_v0.b.$) {
						var page = _v0.a.a;
						var recherche = _v0.b.a;
						return $author$project$Components$Referentiel$Common$ChoixDeLien$sansValeur(
							A2(
								$author$project$Components$Referentiel$Common$ChoixDeLien$demander,
								_Utils_update(
									recherche,
									{
										EE: A2($elm$core$Basics$max, 1, page)
									}),
								etat));
					} else {
						break _v0$7;
					}
				case 2:
					if (!_v0.b.$) {
						var _v1 = _v0.a;
						var uid = _v1.a;
						var voulue = _v1.b;
						var recherche = _v0.b.a;
						return _Utils_Tuple3(
							_Utils_update(
								etat,
								{
									Et: $elm$core$Maybe$Just(
										_Utils_update(
											recherche,
											{
												at: voulue ? _Utils_ap(
													recherche.at,
													A2(
														$elm$core$List$filter,
														function (autre) {
															return !_Utils_eq(autre, uid);
														},
														_List_fromArray(
															[uid]))) : A2(
													$elm$core$List$filter,
													$elm$core$Basics$neq(uid),
													recherche.at)
											}))
								}),
							$elm$core$Maybe$Nothing,
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$7;
					}
				case 3:
					if (!_v0.b.$) {
						var nommee = _v0.a.a;
						var recherche = _v0.b.a;
						return _Utils_Tuple3(
							_Utils_update(
								etat,
								{
									Et: $elm$core$Maybe$Nothing,
									hN: A3(
										$author$project$Components$Referentiel$Common$ChoixDeLien$retenir,
										recherche.dy,
										_List_fromArray(
											[nommee]),
										etat.hN)
								}),
							$elm$core$Maybe$Nothing,
							$elm$core$Maybe$Just(
								_Utils_Tuple3(
									recherche.dy,
									$author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Ecrit(nommee.r8),
									_List_Nil)));
					} else {
						break _v0$7;
					}
				case 4:
					if (!_v0.b.$) {
						var _v2 = _v0.a;
						var recherche = _v0.b.a;
						var trouvees = A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.DF;
								},
								recherche.fg));
						return _Utils_Tuple3(
							_Utils_update(
								etat,
								{
									Et: $elm$core$Maybe$Nothing,
									hN: A3(
										$author$project$Components$Referentiel$Common$ChoixDeLien$retenir,
										recherche.dy,
										A2(
											$elm$core$List$filter,
											function (une) {
												return A2($elm$core$List$member, une.r8, recherche.at);
											},
											_Utils_ap(recherche.fY, trouvees)),
										etat.hN)
								}),
							$elm$core$Maybe$Nothing,
							$elm$core$Maybe$Just(
								_Utils_Tuple3(
									recherche.dy,
									$author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Choix(recherche.at),
									_List_Nil)));
					} else {
						break _v0$7;
					}
				case 5:
					var _v3 = _v0.a;
					return _Utils_Tuple3(
						_Utils_update(
							etat,
							{Et: $elm$core$Maybe$Nothing}),
						$elm$core$Maybe$Nothing,
						$elm$core$Maybe$Nothing);
				default:
					if (!_v0.b.$) {
						var _v4 = _v0.a;
						var numero = _v4.a;
						var reponse = _v4.b;
						var recherche = _v0.b.a;
						if (!_Utils_eq(numero, recherche.DX)) {
							return _Utils_Tuple3(etat, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
						} else {
							var _v5 = A2(
								$author$project$API$Reponse$lire,
								$author$project$Components$Referentiel$Common$ChoixDeLien$nommeesDecoder(recherche.M),
								reponse);
							if (!_v5.$) {
								var trouvees = _v5.a;
								return _Utils_Tuple3(
									_Utils_update(
										etat,
										{
											Et: $elm$core$Maybe$Just(
												_Utils_update(
													recherche,
													{
														fY: _Utils_ap(recherche.fY, trouvees.DF),
														AJ: false,
														fg: $elm$core$Maybe$Just(trouvees)
													}))
										}),
									$elm$core$Maybe$Nothing,
									$elm$core$Maybe$Nothing);
							} else {
								return _Utils_Tuple3(
									_Utils_update(
										etat,
										{
											Et: $elm$core$Maybe$Just(
												_Utils_update(
													recherche,
													{AJ: true}))
										}),
									$elm$core$Maybe$Nothing,
									$elm$core$Maybe$Nothing);
							}
						}
					} else {
						break _v0$7;
					}
			}
		}
		return _Utils_Tuple3(etat, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
	});
var $author$project$Components$Referentiel$Fiche$Update$surLeLien = F2(
	function (msg, model) {
		var _v0 = A2($author$project$Components$Referentiel$Common$ChoixDeLien$update, msg, model.nQ);
		var liens = _v0.a;
		var demande = _v0.b;
		var valeur = _v0.c;
		var suivant = _Utils_update(
			model,
			{nQ: liens});
		return _Utils_Tuple2(
			function () {
				var _v1 = _Utils_Tuple2(valeur, model.jq);
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var _v2 = _v1.a.a;
					var cle = _v2.a;
					var choisie = _v2.b;
					var bloc = _v1.b.a;
					return _Utils_update(
						suivant,
						{
							jq: $elm$core$Maybe$Just(
								_Utils_update(
									bloc,
									{
										hP: A2(
											$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$saisir,
											A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$Saisi, cle, choisie),
											bloc.hP)
									}))
						});
				} else {
					return suivant;
				}
			}(),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Fiche$Update$ChercherDesNommees, $elm$core$List$singleton),
					demande)));
	});
var $author$project$Components$Referentiel$Fiche$Update$EnvoyerAuContact = F4(
	function (a, b, c, d) {
		return {$: 11, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Referentiel$Fiche$Update$envoyerAuContact = F3(
	function (lien, commande, model) {
		var _v0 = _Utils_Tuple2(model.gt, model.l2);
		if ((_v0.a.$ === 1) && (_v0.b.$ === 1)) {
			var fiche = _v0.a.a;
			var processUid = _v0.b.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: $author$project$Components$Referentiel$Fiche$Model$EnCours(processUid)
					}),
				_List_fromArray(
					[
						A4($author$project$Components$Referentiel$Fiche$Update$EnvoyerAuContact, lien, processUid, fiche.r8, commande)
					]));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$surLeMenu = F4(
	function (uid, lienDe, commande, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			lienDe,
			A2($author$project$Components$Referentiel$Fiche$Update$contactDe, uid, model));
		if (!_v0.$) {
			var lien = _v0.a;
			return A3($author$project$Components$Referentiel$Fiche$Update$envoyerAuContact, lien, commande, model);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$afficherLesFichesSupprimees = 'afficher-les-fiches-supprimees';
var $author$project$API$NavLinksDictionary$ajouterContact = 'ajouter-contact';
var $author$project$API$NavLinksDictionary$annulerLEffacement = 'annuler-l-effacement';
var $author$project$API$NavLinksDictionary$apercuDeLEffacement = 'apercu-de-l-effacement';
var $author$project$API$NavLinksDictionary$apercuDeLExport = 'apercu-de-l-export';
var $author$project$API$NavLinksDictionary$apercuDeLaCloture = 'apercu-de-la-cloture';
var $author$project$API$NavLinksDictionary$clore = 'clore';
var $author$project$API$NavLinksDictionary$ficheUtilisateur = 'fiche-utilisateur';
var $author$project$Components$Referentiel$Fiche$API$ToModel$compteUtilisateur = function (vue) {
	return {
		kh: vue.kh,
		xo: vue.gt === 'Desactive',
		eX: vue.eX,
		fl: A2(
			$elm$core$Maybe$map,
			function (_v0) {
				return vue.fl;
			},
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ficheUtilisateur, vue.nQ))
	};
};
var $author$project$Components$Referentiel$Fiche$Contacts$Actif = 0;
var $author$project$Components$Referentiel$Fiche$Contacts$Ancien = 2;
var $author$project$Components$Referentiel$Fiche$Contacts$Invalide = 1;
var $author$project$Components$Referentiel$Fiche$API$ToModel$adresseSaisie = function (adresse) {
	var ligneDe = function (rang) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(
				A2($elm$core$List$drop, rang, adresse.gV)));
	};
	return {
		vz: A2($elm$core$Maybe$withDefault, '', adresse.vz),
		a3: ligneDe(0),
		a4: ligneDe(1),
		a5: ligneDe(2),
		B_: adresse.B_,
		ho: adresse.ho,
		Hj: A2($elm$core$Maybe$withDefault, '', adresse.Hj)
	};
};
var $author$project$API$NavLinksDictionary$apercuDeLEffacementDuContact = 'apercu-de-l-effacement-du-contact';
var $author$project$API$NavLinksDictionary$effacerContact = 'effacer-contact';
var $author$project$I18n$Textes$referentielContactUsageAutre = A3($author$project$I18n$Traductions$texte, 'referentiel.contact.usage.autre', _List_Nil, 'Autre');
var $author$project$I18n$Textes$referentielContactUsageFacturation = A3($author$project$I18n$Traductions$texte, 'referentiel.contact.usage.facturation', _List_Nil, 'Facturation');
var $author$project$I18n$Textes$referentielContactUsageLivraison = A3($author$project$I18n$Traductions$texte, 'referentiel.contact.usage.livraison', _List_Nil, 'Livraison');
var $author$project$I18n$Textes$referentielContactUsagePersonnel = A3($author$project$I18n$Traductions$texte, 'referentiel.contact.usage.personnel', _List_Nil, 'Personnel');
var $author$project$I18n$Textes$referentielContactUsageProfessionnel = A3($author$project$I18n$Traductions$texte, 'referentiel.contact.usage.professionnel', _List_Nil, 'Professionnel');
var $author$project$I18n$Textes$referentielContactUsageSiege = A3($author$project$I18n$Traductions$texte, 'referentiel.contact.usage.siege', _List_Nil, 'Siège');
var $author$project$Components$Referentiel$Fiche$Contacts$libelleDeLUsage = function (usage) {
	switch (usage) {
		case 0:
			return $author$project$I18n$Textes$referentielContactUsagePersonnel;
		case 1:
			return $author$project$I18n$Textes$referentielContactUsageProfessionnel;
		case 2:
			return $author$project$I18n$Textes$referentielContactUsageFacturation;
		case 3:
			return $author$project$I18n$Textes$referentielContactUsageLivraison;
		case 4:
			return $author$project$I18n$Textes$referentielContactUsageSiege;
		default:
			return $author$project$I18n$Textes$referentielContactUsageAutre;
	}
};
var $author$project$I18n$Textes$referentielContactCanalAdresse = A3($author$project$I18n$Traductions$texte, 'referentiel.contact.canal.adresse', _List_Nil, 'Adresse postale');
var $author$project$I18n$Textes$referentielContactCanalEmail = A3($author$project$I18n$Traductions$texte, 'referentiel.contact.canal.email', _List_Nil, 'Email');
var $author$project$I18n$Textes$referentielContactCanalReseau = A3($author$project$I18n$Traductions$texte, 'referentiel.contact.canal.reseau', _List_Nil, 'Réseau');
var $author$project$I18n$Textes$referentielContactCanalSiteWeb = A3($author$project$I18n$Traductions$texte, 'referentiel.contact.canal.site-web', _List_Nil, 'Site web');
var $author$project$I18n$Textes$referentielContactCanalTelephone = A3($author$project$I18n$Traductions$texte, 'referentiel.contact.canal.telephone', _List_Nil, 'Téléphone');
var $author$project$Components$Referentiel$Fiche$Contacts$libelleDuCanal = function (canal) {
	switch (canal) {
		case 0:
			return $author$project$I18n$Textes$referentielContactCanalEmail;
		case 1:
			return $author$project$I18n$Textes$referentielContactCanalTelephone;
		case 2:
			return $author$project$I18n$Textes$referentielContactCanalAdresse;
		case 3:
			return $author$project$I18n$Textes$referentielContactCanalSiteWeb;
		default:
			return $author$project$I18n$Textes$referentielContactCanalReseau;
	}
};
var $author$project$API$NavLinksDictionary$marquerContact = 'marquer-contact';
var $author$project$API$NavLinksDictionary$modifierContact = 'modifier-contact';
var $author$project$I18n$Textes$referentielFicheContactValeurEffacee = A3($author$project$I18n$Traductions$texte, 'referentiel.fiche.contact.valeur-effacee', _List_Nil, 'Valeur effacée');
var $author$project$API$NavLinksDictionary$reglerProspection = 'regler-prospection';
var $author$project$API$NavLinksDictionary$rendrePrincipal = 'rendre-principal';
var $author$project$Components$Referentiel$Fiche$API$ToModel$contact = F3(
	function (normes, rattachements, vue) {
		var lie = A2(
			$elm$core$Maybe$andThen,
			function (uid) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (porte) {
							return _Utils_eq(porte.pN, uid);
						},
						rattachements));
			},
			vue.pN);
		return A4(
			$elm$core$Maybe$map3,
			F3(
				function (canal, usage, statut) {
					return {
						iU: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$apercuDeLEffacementDuContact, vue.nQ),
						uF: $author$project$Components$Referentiel$Fiche$Contacts$libelleDuCanal(canal),
						lM: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$effacerContact, vue.nQ),
						zI: A2(
							$elm$core$Maybe$andThen,
							function (porte) {
								return (porte.gt === 2) ? A2($elm$core$Maybe$map, $author$project$Texte$Jour$enClair, porte.mI) : $elm$core$Maybe$Nothing;
							},
							lie),
						B6: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$marquerContact, vue.nQ),
						ei: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierContact, vue.nQ),
						En: A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.t3;
								},
								$author$project$Components$Referentiel$Common$RechercheDeFiche$nomDe),
							lie),
						px: vue.px,
						Gx: vue.Gx,
						Hn: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reglerProspection, vue.nQ),
						HE: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rendrePrincipal, vue.nQ),
						hP: {
							aa: A2(
								$elm$core$Maybe$withDefault,
								$author$project$Components$Referentiel$Fiche$Contacts$adresseVide,
								A2($elm$core$Maybe$map, $author$project$Components$Referentiel$Fiche$API$ToModel$adresseSaisie, vue.aa)),
							uF: canal,
							px: vue.px,
							Gx: vue.Gx,
							sd: usage,
							fm: A2($elm$core$Maybe$withDefault, '', vue.fm)
						},
						ri: statut,
						I0: A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$String$left(10),
								$author$project$Texte$Jour$enClair),
							vue.I0),
						r8: vue.v8,
						sd: $author$project$Components$Referentiel$Fiche$Contacts$libelleDeLUsage(usage),
						fm: A2(
							$elm$core$Maybe$withDefault,
							$author$project$I18n$Textes$referentielFicheContactValeurEffacee,
							A2(
								$elm$core$Maybe$map,
								$author$project$I18n$Traductions$tel,
								(canal === 2) ? A2(
									$elm$core$Maybe$map,
									$author$project$Components$Referentiel$Fiche$API$ToModel$adresseSurUneLigne(normes),
									vue.aa) : vue.fm))
					};
				}),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (canal) {
						return _Utils_eq(
							$author$project$Components$Referentiel$Common$Contact$canalCode(canal),
							vue.uF);
					},
					$author$project$Components$Referentiel$Common$Contact$canaux)),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (usage) {
						return _Utils_eq(
							$author$project$Components$Referentiel$Common$Contact$usageCode(usage),
							vue.sd);
					},
					$author$project$Components$Referentiel$Common$Contact$usages)),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (statut) {
						return _Utils_eq(
							$author$project$Components$Referentiel$Fiche$Contacts$statutCode(statut),
							vue.ri);
					},
					_List_fromArray(
						[0, 1, 2]))));
	});
var $author$project$API$NavLinksDictionary$effacer = 'effacer';
var $author$project$API$NavLinksDictionary$exporterLesDonnees = 'exporter';
var $author$project$Components$Referentiel$Fiche$API$ToModel$fusion = function (vue) {
	return {
		Bf: vue.Bf,
		nB: vue.nB,
		Dj: A2($elm$core$Maybe$map, $author$project$Components$Referentiel$Common$RechercheDeFiche$nomDe, vue.zo),
		EK: vue.EK,
		r8: vue.r8
	};
};
var $author$project$API$NavLinksDictionary$fusionner = 'fusionner';
var $author$project$API$NavLinksDictionary$rechercherDesArticles = 'rechercher-des-articles';
var $author$project$API$NavLinksDictionary$rechercherDesPartiesPrenantes = 'rechercher-des-parties-prenantes';
var $author$project$API$NavLinksDictionary$rechercherDesUtilisateurs = 'rechercher-des-utilisateurs';
var $author$project$Components$Referentiel$Common$ChoixDeLien$gabaritsDe = function (gabarits) {
	return {
		tP: A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$rechercherDesArticles, gabarits),
		eA: A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$rechercherDesPartiesPrenantes, gabarits),
		Kf: A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$rechercherDesUtilisateurs, gabarits)
	};
};
var $author$project$API$NavLinksDictionary$historique = 'historique';
var $author$project$I18n$Textes$referentielBaseLegaleConsentement = A3($author$project$I18n$Traductions$texte, 'referentiel.base-legale.consentement', _List_Nil, 'Consentement');
var $author$project$I18n$Textes$referentielBaseLegaleContrat = A3($author$project$I18n$Traductions$texte, 'referentiel.base-legale.contrat', _List_Nil, 'Contrat');
var $author$project$I18n$Textes$referentielBaseLegaleInteretLegitime = A3($author$project$I18n$Traductions$texte, 'referentiel.base-legale.interet-legitime', _List_Nil, 'Intérêt légitime');
var $author$project$I18n$Textes$referentielBaseLegaleObligationLegale = A3($author$project$I18n$Traductions$texte, 'referentiel.base-legale.obligation-legale', _List_Nil, 'Obligation légale');
var $author$project$Components$Referentiel$Fiche$API$ToModel$libelleDeBaseLegale = function (code) {
	switch (code) {
		case 'Consentement':
			return $author$project$I18n$Textes$referentielBaseLegaleConsentement;
		case 'InteretLegitime':
			return $author$project$I18n$Textes$referentielBaseLegaleInteretLegitime;
		case 'Contrat':
			return $author$project$I18n$Textes$referentielBaseLegaleContrat;
		case 'ObligationLegale':
			return $author$project$I18n$Textes$referentielBaseLegaleObligationLegale;
		default:
			return $author$project$I18n$Traductions$tel(code);
	}
};
var $author$project$API$NavLinksDictionary$offresPourUnRole = 'offres-pour-un-role';
var $author$project$Components$Referentiel$Fiche$Rattachements$AVenir = 0;
var $author$project$Components$Referentiel$Fiche$Rattachements$Actif = 1;
var $author$project$API$NavLinksDictionary$changerPoste = 'changer-poste';
var $author$project$API$NavLinksDictionary$designerContactPrincipal = 'designer-contact-principal';
var $author$project$API$NavLinksDictionary$modifierFinRattachement = 'modifier-fin-rattachement';
var $author$project$API$NavLinksDictionary$terminerRattachement = 'terminer-rattachement';
var $author$project$Components$Referentiel$Fiche$API$ToModel$rattachement = function (vue) {
	return {
		u5: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$changerPoste, vue.nQ),
		wa: A2(
			$elm$core$List$filterMap,
			function (porte) {
				return A3(
					$elm$core$Maybe$map2,
					F2(
						function (canalLu, texte) {
							return {uF: canalLu, fm: texte};
						}),
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (canal) {
								return _Utils_eq(
									$author$project$Components$Referentiel$Common$Contact$canalCode(canal),
									porte.uF);
							},
							$author$project$Components$Referentiel$Common$Contact$canaux)),
					porte.fm);
			},
			vue.wa),
		ku: $author$project$Texte$Jour$enClair(vue.ku),
		wI: vue.ku,
		xb: vue.xb,
		xu: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$designerContactPrincipal, vue.nQ),
		xL: vue.xL,
		gt: function () {
			var _v0 = vue.gt;
			switch (_v0) {
				case 0:
					return 0;
				case 1:
					return 1;
				default:
					return 2;
			}
		}(),
		yP: vue.t3.gt,
		zo: vue.t3.r8,
		mI: A2($elm$core$Maybe$map, $author$project$Texte$Jour$enClair, vue.mI),
		zK: vue.mI,
		AS: vue.AS,
		od: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierFinRattachement, vue.nQ),
		Dj: $author$project$Components$Referentiel$Common$RechercheDeFiche$nomDe(vue.t3),
		Eo: vue.Eo,
		Fd: vue.Fd,
		F4: A2($elm$core$Maybe$map, $author$project$Components$Referentiel$Vocabulaire$libelleDuPoste, vue.F4),
		F5: A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.r8;
			},
			vue.F4),
		px: vue.px,
		Jw: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$terminerRattachement, vue.nQ),
		ib: vue.t3.ib,
		r8: vue.pN
	};
};
var $author$project$API$NavLinksDictionary$rattacher = 'rattacher';
var $author$project$API$NavLinksDictionary$rechercherLAutreFiche = 'rechercher-l-autre-fiche';
var $author$project$API$NavLinksDictionary$delier = 'delier';
var $author$project$Components$Referentiel$Fiche$API$ToModel$relation = function (vue) {
	return {
		vx: vue.vx,
		w6: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$delier, vue.nQ),
		xA: !vue.IC,
		zo: vue.t3.r8,
		An: vue.An,
		m7: vue.m7,
		AF: vue.AF,
		Bl: vue.Bl,
		Dj: $author$project$Components$Referentiel$Common$RechercheDeFiche$nomDe(vue.t3),
		ho: vue.ho,
		r8: vue.Ht
	};
};
var $author$project$API$NavLinksDictionary$relier = 'relier';
var $author$project$API$NavLinksDictionary$changerStatutRole = 'changer-statut-role';
var $author$project$Components$Referentiel$Fiche$API$ToModel$classeDArchetype = function (archetype) {
	switch (archetype) {
		case 0:
			return 'archetype-suspect';
		case 1:
			return 'archetype-prospect';
		case 2:
			return 'archetype-client';
		case 3:
			return 'archetype-collaborateur';
		case 4:
			return 'archetype-fournisseur';
		case 5:
			return 'archetype-partenaire';
		case 6:
			return 'archetype-prescripteur';
		case 7:
			return 'archetype-relation-presse';
		default:
			return 'archetype-concurrent';
	}
};
var $author$project$Components$Referentiel$Fiche$Roles$AVenir = 0;
var $author$project$Components$Referentiel$Fiche$Roles$Effectif = 1;
var $author$project$Components$Referentiel$Fiche$Roles$Termine = 2;
var $author$project$Components$Referentiel$Fiche$API$ToModel$etatDe = function (vue) {
	var _v0 = _Utils_Tuple2(vue.gt, vue.mI);
	switch (_v0.a) {
		case 'AVenir':
			return 0;
		case 'Effectif':
			return 1;
		case 'Termine':
			return 2;
		default:
			if (_v0.b.$ === 1) {
				var _v1 = _v0.b;
				return 1;
			} else {
				return 2;
			}
	}
};
var $author$project$API$NavLinksDictionary$fermerRole = 'fermer-role';
var $author$project$API$NavLinksDictionary$modifierFinRole = 'modifier-fin-role';
var $author$project$API$NavLinksDictionary$remplacerRole = 'remplacer-role';
var $author$project$Components$Referentiel$Fiche$API$ToModel$role = function (vue) {
	return {
		fA: $author$project$Components$Referentiel$Archetype$libelle(vue.fA),
		u6: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$changerStatutRole, vue.nQ),
		jT: $author$project$Components$Referentiel$Fiche$API$ToModel$classeDArchetype(vue.fA),
		vq: A2(
			$elm$core$Maybe$map,
			function (fin) {
				return {
					mI: $author$project$Texte$Jour$enClair(fin),
					zJ: fin,
					HW: vue.HW
				};
			},
			vue.mI),
		kf: $elm$core$Maybe$Nothing,
		ku: (vue.ku === '') ? $author$project$I18n$Traductions$tel('') : $author$project$Texte$Jour$enClair(vue.ku),
		wH: vue.ku,
		gt: $author$project$Components$Referentiel$Fiche$API$ToModel$etatDe(vue),
		zk: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$fermerRole, vue.nQ),
		aC: $elm$core$Maybe$Nothing,
		Bl: $author$project$Components$Referentiel$Archetype$libelle(vue.fA),
		od: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierFinRole, vue.nQ),
		D1: A2(
			$elm$core$Maybe$map,
			function (offre) {
				return {
					tL: _Utils_eq(
						offre.tL,
						$elm$core$Maybe$Just(true)),
					Aq: offre.Aq,
					Dj: offre.Dj
				};
			},
			vue.D1),
		ql: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$remplacerRole, vue.nQ),
		ri: vue.ri,
		r0: $author$project$Components$Referentiel$Identifiants$typeUidToString(vue.r0),
		r8: vue.bi
	};
};
var $author$project$Components$Referentiel$Fiche$API$ToModel$roleDuDoublon = function (ouvert) {
	return {
		Bl: A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Traductions$tel(ouvert.fA),
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$Referentiel$Archetype$libelle,
				$author$project$Components$Referentiel$Archetype$fromCode(ouvert.fA))),
		D1: A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Dj;
				},
				$author$project$Components$Referentiel$Fiche$API$ToModel$nomDOffre),
			ouvert.D1),
		r0: ouvert.r0
	};
};
var $author$project$API$NavLinksDictionary$rouvrir = 'rouvrir';
var $author$project$API$NavLinksDictionary$supprimer = 'supprimer';
var $author$project$Components$Referentiel$Fiche$API$ToModel$toModel = F2(
	function (normes, vue) {
		var _v0 = function () {
			var _v1 = vue.Av;
			if (!_v1.$) {
				var personne = _v1.a;
				return _Utils_Tuple3(
					0,
					_List_fromArray(
						[
							_Utils_Tuple2(0, personne.vh),
							_Utils_Tuple2(1, personne.Gg),
							_Utils_Tuple2(2, personne.Dj)
						]),
					$elm$core$Maybe$Just(
						$author$project$Components$Referentiel$Fiche$API$ToModel$libelleDeBaseLegale(personne.fI)));
			} else {
				var organisation = _v1.a;
				return _Utils_Tuple3(
					1,
					_List_fromArray(
						[
							_Utils_Tuple2(3, organisation.GR)
						]),
					$elm$core$Maybe$Nothing);
			}
		}();
		var nature = _v0.a;
		var propres = _v0.b;
		var baseLegale = _v0.c;
		var champs = _Utils_ap(
			propres,
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(4, vue.hy),
						_Utils_Tuple2(5, vue.ho),
						_Utils_Tuple2(6, vue.nn)
					]),
				function () {
					if (nature === 1) {
						return _List_fromArray(
							[
								_Utils_Tuple2(7, vue.m7)
							]);
					} else {
						return _List_Nil;
					}
				}()));
		return {
			s2: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$afficherLesFichesSupprimees, vue.nQ.h0),
			s8: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ajouterContact, vue.nQ.h0),
			tp: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$annulerLEffacement, vue.nQ.h0),
			iU: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$apercuDeLEffacement, vue.nQ.h0),
			tr: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$apercuDeLExport, vue.nQ.h0),
			ts: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$apercuDeLaCloture, vue.nQ.h0),
			fI: baseLegale,
			dw: champs,
			uW: vue.uW,
			u_: vue.u_,
			vo: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$clore, vue.nQ.h0),
			vZ: A2($elm$core$Maybe$map, $author$project$Components$Referentiel$Fiche$API$ToModel$compteUtilisateur, vue.vZ),
			wa: A2(
				$elm$core$List$filterMap,
				A2(
					$author$project$Components$Referentiel$Fiche$API$ToModel$contact,
					normes,
					(!nature) ? vue.GY : _List_Nil),
				vue.wa),
			wn: A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$left(10),
					$author$project$Texte$Jour$enClair),
				vue.wn),
			wT: vue.wT,
			kW: A2(
				$elm$core$List$map,
				function (doublon) {
					return {
						CY: doublon.CY,
						Dj: $author$project$Components$Referentiel$Common$RechercheDeFiche$nomDe(
							{gt: 0, Av: doublon.Av, ib: _List_Nil, r8: doublon.r8}),
						eX: A2($elm$core$List$map, $author$project$Components$Referentiel$Fiche$API$ToModel$roleDuDoublon, doublon.eX),
						rp: !_Utils_eq(doublon.yt, $elm$core$Maybe$Nothing),
						r8: doublon.r8
					};
				},
				vue.kW),
			x6: A2(
				$elm$core$Maybe$map,
				function (effacee) {
					return {
						x7: $author$project$Texte$Jour$enClair(
							A2($elm$core$String$left, 10, effacee.x7)),
						cX: effacee.cX,
						Gd: effacee.Gd,
						Gq: $author$project$Texte$Jour$enClair(
							A2($elm$core$String$left, 10, effacee.Gq)),
						Gr: effacee.Gr
					};
				},
				vue.x6),
			x9: A2(
				$elm$core$Maybe$map,
				function (effacement) {
					return {
						xY: $author$project$Texte$Jour$enClair(
							A2($elm$core$String$left, 10, effacement.xY)),
						yN: effacement.yN,
						cX: effacement.cX
					};
				},
				vue.x9),
			lM: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$effacer, vue.nQ.h0),
			gt: vue.gt,
			yQ: A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$left(10),
					$author$project$Texte$Jour$enClair),
				vue.yQ),
			za: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$exporterLesDonnees, vue.nQ.h0),
			zx: A2($elm$core$List$map, $author$project$Components$Referentiel$Fiche$API$ToModel$fusion, vue.zx),
			gB: vue.gB,
			z1: A2($elm$core$Maybe$map, $author$project$Components$Referentiel$Fiche$API$ToModel$fusion, vue.z1),
			z2: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$fusionner, vue.nQ.h0),
			m6: A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$historique, vue.nQ.gF),
			Ak: A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$historiqueDuChamp, vue.nQ.gF),
			ei: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifier, vue.nQ.h0),
			g1: nature,
			D6: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$offresPourUnRole, vue.nQ.h0),
			EC: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ouvrirRole, vue.nQ.h0),
			GY: A2($elm$core$List$map, $author$project$Components$Referentiel$Fiche$API$ToModel$rattachement, vue.GY),
			GZ: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rattacher, vue.nQ.h0),
			G4: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rechercherLAutreFiche, vue.nQ.h0),
			G5: $author$project$Components$Referentiel$Common$ChoixDeLien$gabaritsDe(vue.nQ.gF),
			Hu: A2($elm$core$List$map, $author$project$Components$Referentiel$Fiche$API$ToModel$relation, vue.Hu),
			Hy: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$relier, vue.nQ.h0),
			HS: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$restaurer, vue.nQ.h0),
			eX: A2($elm$core$List$map, $author$project$Components$Referentiel$Fiche$API$ToModel$role, vue.eX),
			H7: A2($elm$core$List$map, $author$project$Components$Referentiel$Fiche$API$ToModel$role, vue.H7),
			Ii: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rouvrir, vue.nQ.h0),
			Jc: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$supprimer, vue.nQ.h0),
			r8: vue.r8,
			sq: vue.sq
		};
	});
var $author$project$Components$Referentiel$Fiche$Historique$sansFiltre = function (etat) {
	return _Utils_eq(etat.zj, $elm$core$Maybe$Nothing) && _Utils_eq(etat.IR, $elm$core$Maybe$Nothing);
};
var $author$project$Components$Referentiel$Fiche$Historique$toutAfficher = function (etat) {
	return $author$project$Components$Referentiel$Fiche$Historique$sansFiltre(etat) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		$author$project$Components$Referentiel$Fiche$Historique$relire(
			_Utils_update(
				etat,
				{zj: $elm$core$Maybe$Nothing, gV: _List_Nil, IR: $elm$core$Maybe$Nothing})));
};
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$typeEtablissementDecoder = A2(
	$elm$json$Json$Decode$map,
	function (types) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var code = _v0.a;
						return _Utils_eq(
							code,
							$elm$core$Maybe$Just('etablissement-de'));
					},
					types)));
	},
	A2(
		$elm$json$Json$Decode$field,
		'types',
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				$elm$json$Json$Decode$maybe(
					A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string)),
				A2($elm$json$Json$Decode$field, 'uid', $author$project$Components$Referentiel$Identifiants$typeRelationUidDecoder)))));
var $author$project$API$NavLinksDictionary$typesDePartiePrenante = 'types-de-partie-prenante';
var $author$project$Components$Referentiel$Fiche$Update$ModifierLesChamps = F5(
	function (a, b, c, d, e) {
		return {$: 8, a: a, b: b, c: c, d: d, e: e};
	});
var $author$project$Components$Referentiel$Fiche$Update$valider = function (model) {
	var _v0 = _Utils_Tuple3(
		model.gt,
		model.l2,
		$author$project$Components$Referentiel$Fiche$Model$modifications(model));
	_v0$2:
	while (true) {
		if ((_v0.a.$ === 1) && (!_v0.c.$)) {
			if (!_v0.c.a.b) {
				return _Utils_Tuple2(
					$author$project$Components$Referentiel$Fiche$Model$annulerLEdition(model),
					_List_Nil);
			} else {
				if (_v0.b.$ === 1) {
					var fiche = _v0.a.a;
					var processUid = _v0.b.a;
					var aEnvoyer = _v0.c.a;
					var _v1 = fiche.ei;
					if (!_v1.$) {
						var lien = _v1.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									l2: $author$project$Components$Referentiel$Fiche$Model$EnCours(processUid)
								}),
							_List_fromArray(
								[
									A5($author$project$Components$Referentiel$Fiche$Update$ModifierLesChamps, lien, processUid, fiche.r8, fiche.sq, aEnvoyer)
								]));
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return _Utils_Tuple2(model, _List_Nil);
};
var $author$project$Components$Referentiel$Fiche$Update$validerLIdentite = function (model) {
	return $author$project$Components$Referentiel$Fiche$Model$sansSaisieEnCours(model) ? A2($author$project$Components$Referentiel$Fiche$Update$surLeDrawerDIdentite, $author$project$Components$Shared$Drawer$Update$Fermer, model) : $author$project$Components$Referentiel$Fiche$Update$valider(model);
};
var $author$project$Components$Referentiel$Fiche$Liaisons$confirmationRequise = F2(
	function (enPlace, etat) {
		var coche = function () {
			var _v0 = etat.mW;
			switch (_v0.$) {
				case 3:
					var rattachement = _v0.a;
					var saisie = _v0.b;
					return saisie.px && (!rattachement.px);
				case 4:
					var saisie = _v0.b;
					return saisie.px;
				default:
					return false;
			}
		}();
		return (coche && _Utils_eq(etat.j6, $author$project$Components$Referentiel$Fiche$Liaisons$NonDemandee)) ? enPlace : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$Donnee = {$: 2};
var $author$project$Components$Referentiel$Fiche$Liaisons$confirmer = function (etat) {
	var _v0 = etat.j6;
	if (_v0.$ === 1) {
		return _Utils_update(
			etat,
			{j6: $author$project$Components$Referentiel$Fiche$Liaisons$Donnee});
	} else {
		return etat;
	}
};
var $author$project$Components$Referentiel$Fiche$Liaisons$Demandee = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Fiche$Liaisons$demanderLaConfirmation = F2(
	function (nom, etat) {
		return _Utils_update(
			etat,
			{
				j6: $author$project$Components$Referentiel$Fiche$Liaisons$Demandee(nom)
			});
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$ChangerLePoste = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$Delier = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Fiche$Liaisons$DesignerLeContactPrincipal = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$ModifierLaFin = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$Rattacher = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Referentiel$Fiche$Liaisons$Terminer = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$I18n$Textes$referentielRattachementFinAvantLeDebut = A3($author$project$I18n$Traductions$texte, 'referentiel.rattachement.fin-avant-le-debut', _List_Nil, 'La fin précède le début');
var $author$project$Components$Referentiel$Fiche$Liaisons$erreurDeLaSaisie = function (geste) {
	if (geste.$ === 1) {
		var rattachement = geste.a;
		var saisie = geste.b;
		return ((saisie === '') && _Utils_eq(rattachement.zK, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just($author$project$I18n$Textes$referentielFicheChampObligatoire) : (((saisie !== '') && (_Utils_cmp(saisie, rattachement.wI) < 0)) ? $elm$core$Maybe$Just($author$project$I18n$Textes$referentielRattachementFinAvantLeDebut) : $elm$core$Maybe$Nothing);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Fiche$Rattacher$remplies = function (saisie) {
	return A2(
		$elm$core$List$filter,
		function (_v0) {
			var ligne = _v0.b;
			return $elm$core$String$trim(ligne.fm) !== '';
		},
		A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, saisie.wa));
};
var $author$project$Components$Referentiel$Common$Contact$EmailEnDouble = {$: 4};
var $author$project$Components$Referentiel$Common$Contact$FormatDAdresseWebInvalide = {$: 3};
var $author$project$Components$Referentiel$Common$Contact$FormatDEmailInvalide = {$: 1};
var $author$project$Components$Referentiel$Common$Contact$FormatDeTelephoneInvalide = {$: 2};
var $author$project$Components$Referentiel$Common$Contact$ValeurObligatoire = {$: 0};
var $elm$core$String$any = _String_any;
var $author$project$Components$Referentiel$Common$Contact$estUnBlancDuBack = function (caractere) {
	return A2(
		$elm$core$List$member,
		caractere,
		_List_fromArray(
			[' ', '\t', '\n', '\u000B', '\u000C', '\u000D']));
};
var $author$project$Components$Referentiel$Common$Contact$interdits = _List_fromArray(
	['\"', '<', '>', '\\', '^', '`', '{', '|', '}', '\u00A0']);
var $author$project$Components$Referentiel$Common$Contact$schemaEnMinuscules = function (adresse) {
	var _v0 = A2($elm$core$String$indexes, '://', adresse);
	if (_v0.b) {
		var position = _v0.a;
		return _Utils_ap(
			$elm$core$String$toLower(
				A2($elm$core$String$left, position, adresse)),
			A2($elm$core$String$dropLeft, position, adresse));
	} else {
		return adresse;
	}
};
var $author$project$Components$Referentiel$Common$Contact$adresseWebValide = function (saisie) {
	var dUnHote = function (caractere) {
		return $elm$core$Char$isAlphaNum(caractere) || ((caractere === '-') || (caractere === '.'));
	};
	var adresse = $elm$core$String$trim(saisie);
	return ($elm$core$String$length(adresse) <= 2048) && ((!A2(
		$elm$core$String$any,
		function (caractere) {
			return $author$project$Components$Referentiel$Common$Contact$estUnBlancDuBack(caractere) || A2($elm$core$List$member, caractere, $author$project$Components$Referentiel$Common$Contact$interdits);
		},
		adresse)) && A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (lue) {
				return A2($elm$core$String$contains, '.', lue.d2) && (A2($elm$core$String$all, dUnHote, lue.d2) && ((!A2($elm$core$String$startsWith, '.', lue.d2)) && (!A2($elm$core$String$endsWith, '.', lue.d2))));
			},
			$elm$url$Url$fromString(
				$author$project$Components$Referentiel$Common$Contact$schemaEnMinuscules(adresse)))));
};
var $author$project$Components$Referentiel$Common$Contact$emailValide = function (saisi) {
	var email = $elm$core$String$trim(saisi);
	var _v0 = A2($elm$core$String$split, '@', email);
	if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
		var local = _v0.a;
		var _v1 = _v0.b;
		var domaine = _v1.a;
		return ($elm$core$String$length(email) <= 254) && ((!A2($elm$core$String$any, $author$project$Components$Referentiel$Common$Contact$estUnBlancDuBack, email)) && ((local !== '') && (($elm$core$List$length(
			A2($elm$core$String$split, '.', domaine)) >= 2) && A2(
			$elm$core$List$all,
			$elm$core$Basics$neq(''),
			A2($elm$core$String$split, '.', domaine)))));
	} else {
		return false;
	}
};
var $author$project$Components$Referentiel$Common$Contact$AdresseIncomplete = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Referentiel$Common$Contact$AdresseTropLongue = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Referentiel$Common$Contact$CodePostal = 3;
var $author$project$Components$Referentiel$Common$Contact$Ligne1 = 0;
var $author$project$Components$Referentiel$Common$Contact$Localite = 4;
var $author$project$Components$Referentiel$Common$Contact$PaysDAdresse = 6;
var $author$project$Components$Referentiel$Common$Contact$champDAdresse = F2(
	function (champ, adresse) {
		switch (champ) {
			case 0:
				return adresse.a3;
			case 1:
				return adresse.a4;
			case 2:
				return adresse.a5;
			case 3:
				return adresse.vz;
			case 4:
				return adresse.B_;
			case 5:
				return adresse.Hj;
			default:
				return adresse.ho;
		}
	});
var $author$project$Components$Referentiel$Common$Contact$Ligne2 = 1;
var $author$project$Components$Referentiel$Common$Contact$Ligne3 = 2;
var $author$project$Components$Referentiel$Common$Contact$Region = 5;
var $author$project$Components$Referentiel$Common$Contact$champsDAdresse = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6]);
var $author$project$Components$Referentiel$Common$Contact$erreurDeLAdresse = function (adresse) {
	var vide = function (champ) {
		return $elm$core$String$trim(
			A2($author$project$Components$Referentiel$Common$Contact$champDAdresse, champ, adresse)) === '';
	};
	var tropLong = function (champ) {
		return _Utils_cmp(
			$elm$core$String$length(
				$elm$core$String$trim(
					A2($author$project$Components$Referentiel$Common$Contact$champDAdresse, champ, adresse))),
			(champ === 3) ? 20 : 200) > 0;
	};
	var _v0 = A2(
		$elm$core$List$filter,
		vide,
		_List_fromArray(
			[0, 4, 6]));
	if (_v0.b) {
		var manquant = _v0.a;
		return $elm$core$Maybe$Just(
			$author$project$Components$Referentiel$Common$Contact$AdresseIncomplete(manquant));
	} else {
		return A2(
			$elm$core$Maybe$map,
			$author$project$Components$Referentiel$Common$Contact$AdresseTropLongue,
			$elm$core$List$head(
				A2($elm$core$List$filter, tropLong, $author$project$Components$Referentiel$Common$Contact$champsDAdresse)));
	}
};
var $author$project$Components$Referentiel$Common$Contact$memeEmail = F2(
	function (ligne, autre) {
		return (!autre.uF) && _Utils_eq(
			$elm$core$String$toLower(
				$elm$core$String$trim(autre.fm)),
			$elm$core$String$toLower(
				$elm$core$String$trim(ligne.fm)));
	});
var $author$project$Components$Referentiel$Common$Contact$estUnBlanc = function (caractere) {
	return A2(
		$elm$core$List$member,
		caractere,
		_List_fromArray(
			[' ', '\t', '\n', '\u000D', '\u00A0', '\u202F']));
};
var $author$project$Components$Referentiel$Common$Contact$telephoneNormalise = function (saisi) {
	return A2(
		$elm$core$String$filter,
		function (caractere) {
			return (!$author$project$Components$Referentiel$Common$Contact$estUnBlanc(caractere)) && ((caractere !== '.') && (caractere !== '-'));
		},
		saisi);
};
var $author$project$Components$Referentiel$Common$Contact$telephoneValide = function (saisi) {
	var _v0 = $elm$core$String$toList(
		$author$project$Components$Referentiel$Common$Contact$telephoneNormalise(saisi));
	if ((_v0.b && ('+' === _v0.a)) && _v0.b.b) {
		var _v1 = _v0.b;
		var premier = _v1.a;
		var suite = _v1.b;
		return (premier !== '0') && ($elm$core$Char$isDigit(premier) && (A2($elm$core$List$all, $elm$core$Char$isDigit, suite) && (($elm$core$List$length(suite) >= 6) && ($elm$core$List$length(suite) <= 14))));
	} else {
		return false;
	}
};
var $author$project$Components$Referentiel$Common$Contact$erreurDeLaLigne = F2(
	function (precedentes, ligne) {
		if (ligne.uF === 2) {
			return $author$project$Components$Referentiel$Common$Contact$erreurDeLAdresse(ligne.aa);
		} else {
			if ($elm$core$String$trim(ligne.fm) === '') {
				return $elm$core$Maybe$Just($author$project$Components$Referentiel$Common$Contact$ValeurObligatoire);
			} else {
				var _v0 = ligne.uF;
				switch (_v0) {
					case 0:
						return (!$author$project$Components$Referentiel$Common$Contact$emailValide(ligne.fm)) ? $elm$core$Maybe$Just($author$project$Components$Referentiel$Common$Contact$FormatDEmailInvalide) : (A2(
							$elm$core$List$any,
							$author$project$Components$Referentiel$Common$Contact$memeEmail(ligne),
							precedentes) ? $elm$core$Maybe$Just($author$project$Components$Referentiel$Common$Contact$EmailEnDouble) : $elm$core$Maybe$Nothing);
					case 1:
						return $author$project$Components$Referentiel$Common$Contact$telephoneValide(ligne.fm) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($author$project$Components$Referentiel$Common$Contact$FormatDeTelephoneInvalide);
					case 3:
						return $author$project$Components$Referentiel$Common$Contact$adresseWebValide(ligne.fm) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($author$project$Components$Referentiel$Common$Contact$FormatDAdresseWebInvalide);
					case 4:
						return $author$project$Components$Referentiel$Common$Contact$adresseWebValide(ligne.fm) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($author$project$Components$Referentiel$Common$Contact$FormatDAdresseWebInvalide);
					default:
						return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $author$project$Components$Referentiel$Common$Contact$erreurs = function (lignes) {
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2(
			$elm$core$List$indexedMap,
			F2(
				function (rang, ligne) {
					return A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$pair(rang),
						A2(
							$author$project$Components$Referentiel$Common$Contact$erreurDeLaLigne,
							A2($elm$core$List$take, rang, lignes),
							ligne));
				}),
			lignes));
};
var $author$project$Components$Referentiel$Common$Contact$accepteLaProspection = function (canal) {
	return (!canal) || (canal === 1);
};
var $author$project$Components$Referentiel$Common$Contact$adresseNormalisee = function (adresse) {
	return {
		vz: $elm$core$String$trim(adresse.vz),
		a3: $elm$core$String$trim(adresse.a3),
		a4: $elm$core$String$trim(adresse.a4),
		a5: $elm$core$String$trim(adresse.a5),
		B_: $elm$core$String$trim(adresse.B_),
		ho: adresse.ho,
		Hj: $elm$core$String$trim(adresse.Hj)
	};
};
var $author$project$Components$Referentiel$Common$Contact$normaliser = function (ligne) {
	return _Utils_update(
		ligne,
		{
			aa: (ligne.uF === 2) ? $author$project$Components$Referentiel$Common$Contact$adresseNormalisee(ligne.aa) : $author$project$Components$Referentiel$Common$Contact$adresseVide,
			Gx: ligne.Gx && $author$project$Components$Referentiel$Common$Contact$accepteLaProspection(ligne.uF),
			fm: function () {
				var _v0 = ligne.uF;
				switch (_v0) {
					case 0:
						return $elm$core$String$trim(ligne.fm);
					case 1:
						return $author$project$Components$Referentiel$Common$Contact$telephoneNormalise(ligne.fm);
					case 3:
						return $elm$core$String$trim(ligne.fm);
					case 4:
						return $elm$core$String$trim(ligne.fm);
					default:
						return '';
				}
			}()
		});
};
var $author$project$Components$Referentiel$Common$Contact$valides = function (lignes) {
	var _v0 = $author$project$Components$Referentiel$Common$Contact$erreurs(lignes);
	if (!_v0.b) {
		return $elm$core$Result$Ok(
			A2($elm$core$List$map, $author$project$Components$Referentiel$Common$Contact$normaliser, lignes));
	} else {
		var fautives = _v0;
		return $elm$core$Result$Err(fautives);
	}
};
var $author$project$Components$Referentiel$Fiche$Rattacher$valide = function (saisie) {
	var pose = function (texte) {
		return ($elm$core$String$trim(texte) === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$elm$core$String$trim(texte));
	};
	var _v0 = _Utils_Tuple2(
		saisie.hC.ve,
		$author$project$Components$Referentiel$Common$Contact$valides(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$second,
				$author$project$Components$Referentiel$Fiche$Rattacher$remplies(saisie))));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var choisie = _v0.a.a;
		var contacts = _v0.b.a;
		return $elm$core$Maybe$Just(
			{
				t3: choisie.r8,
				wa: contacts,
				ku: pose(saisie.ku),
				xb: pose(saisie.xb),
				AS: pose(saisie.AS),
				F4: saisie.F4,
				px: saisie.px
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Fiche$Liaisons$departs = F2(
	function (ouverte, etat) {
		var _v0 = _Utils_Tuple2(
			etat.mW,
			$author$project$Components$Referentiel$Fiche$Liaisons$erreurDeLaSaisie(etat.mW));
		_v0$5:
		while (true) {
			switch (_v0.a.$) {
				case 2:
					var relation = _v0.a.a;
					return A2(
						$elm$core$Maybe$map,
						function (lien) {
							return _List_fromArray(
								[
									_Utils_Tuple3(
									lien,
									ouverte,
									$author$project$Components$Referentiel$Fiche$Liaisons$Delier(relation.r8))
								]);
						},
						relation.w6);
				case 1:
					if (_v0.b.$ === 1) {
						var _v1 = _v0.a;
						var rattachement = _v1.a;
						var saisie = _v1.b;
						var _v2 = _v0.b;
						return A2(
							$elm$core$Maybe$map,
							function (lien) {
								return _List_fromArray(
									[
										_Utils_Tuple3(
										lien,
										rattachement.Fd,
										function () {
											var _v3 = rattachement.zK;
											if (_v3.$ === 1) {
												return A2($author$project$Components$Referentiel$Fiche$Liaisons$Terminer, rattachement.r8, saisie);
											} else {
												return A2(
													$author$project$Components$Referentiel$Fiche$Liaisons$ModifierLaFin,
													rattachement.r8,
													(saisie === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(saisie));
											}
										}())
									]);
							},
							$author$project$Components$Referentiel$Fiche$Liaisons$lienDeLaFin(rattachement));
					} else {
						break _v0$5;
					}
				case 3:
					var _v4 = _v0.a;
					var rattachement = _v4.a;
					var saisie = _v4.b;
					var poste = $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (uid) {
								return _Utils_eq(
									$author$project$Components$Referentiel$Identifiants$posteUidToString(uid),
									saisie.F4);
							},
							_Utils_ap(
								A2(
									$elm$core$List$map,
									function ($) {
										return $.r8;
									},
									etat.F6),
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2($elm$core$Maybe$map, $elm$core$List$singleton, rattachement.F5)))));
					var intitule = ($elm$core$String$trim(saisie.AS) === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$elm$core$String$trim(saisie.AS));
					var initiale = $author$project$Components$Referentiel$Fiche$Liaisons$saisieInitiale(rattachement);
					return $elm$core$Maybe$Just(
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									((!_Utils_eq(saisie.F4, initiale.F4)) || (!_Utils_eq(intitule, rattachement.AS))) ? A2(
									$elm$core$Maybe$map,
									function (lien) {
										return _Utils_Tuple3(
											lien,
											rattachement.Fd,
											A3($author$project$Components$Referentiel$Fiche$Liaisons$ChangerLePoste, rattachement.r8, poste, intitule));
									},
									rattachement.u5) : $elm$core$Maybe$Nothing,
									(!_Utils_eq(saisie.px, rattachement.px)) ? A2(
									$elm$core$Maybe$map,
									function (lien) {
										return _Utils_Tuple3(
											lien,
											rattachement.Fd,
											A2($author$project$Components$Referentiel$Fiche$Liaisons$DesignerLeContactPrincipal, rattachement.r8, saisie.px));
									},
									rattachement.xu) : $elm$core$Maybe$Nothing
								])));
				case 5:
					var _v5 = _v0.a;
					var contexte = _v5.a;
					var saisie = _v5.b;
					return A3(
						$elm$core$Maybe$map2,
						F2(
							function (choisie, proposee) {
								return _List_fromArray(
									[
										_Utils_Tuple3(
										contexte.nB,
										contexte.Et,
										$author$project$Components$Referentiel$Fiche$Liaisons$Relier(
											{vf: choisie.r8, xA: proposee.xA, r0: proposee.r0}))
									]);
							}),
						saisie.hC.ve,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (proposee) {
									return _Utils_eq(proposee.fm, saisie.Fp);
								},
								$author$project$Components$Referentiel$Fiche$Liaisons$phrases(etat))));
				case 4:
					var _v6 = _v0.a;
					var contexte = _v6.a;
					var saisie = _v6.b;
					return A2(
						$elm$core$Maybe$map,
						function (valide) {
							var _v7 = (!contexte.fN) ? _Utils_Tuple2(valide.t3, contexte.Et) : _Utils_Tuple2(contexte.Et, valide.t3);
							var personne = _v7.a;
							var organisation = _v7.b;
							return _List_fromArray(
								[
									_Utils_Tuple3(
									contexte.nB,
									personne,
									$author$project$Components$Referentiel$Fiche$Liaisons$Rattacher(
										{
											v9: valide.px,
											wa: valide.wa,
											ku: valide.ku,
											xb: valide.xb,
											AS: valide.AS,
											En: organisation,
											F4: $elm$core$List$head(
												A2(
													$elm$core$List$filter,
													function (uid) {
														return _Utils_eq(
															$author$project$Components$Referentiel$Identifiants$posteUidToString(uid),
															valide.F4);
													},
													A2(
														$elm$core$List$map,
														function ($) {
															return $.r8;
														},
														etat.F6)))
										}))
								]);
						},
						$author$project$Components$Referentiel$Fiche$Rattacher$valide(saisie));
				default:
					break _v0$5;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Components$Referentiel$Fiche$Update$principalEnPlace = function (model) {
	var _v0 = _Utils_Tuple2(model.gt, model.Bk.mW);
	_v0$2:
	while (true) {
		if (_v0.a.$ === 1) {
			switch (_v0.b.$) {
				case 3:
					var fiche = _v0.a.a;
					var _v1 = _v0.b;
					var rattachement = _v1.a;
					var nomme = (fiche.g1 === 1) ? A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.Dj;
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (autre) {
									return autre.px && (!_Utils_eq(autre.r8, rattachement.r8));
								},
								fiche.GY))) : $elm$core$Maybe$Nothing;
					if (!nomme.$) {
						var nom = nomme.a;
						return $elm$core$Maybe$Just(
							$elm$core$Maybe$Just(nom));
					} else {
						return (rattachement.Eo && (!rattachement.px)) ? $elm$core$Maybe$Just($elm$core$Maybe$Nothing) : $elm$core$Maybe$Nothing;
					}
				case 4:
					var fiche = _v0.a.a;
					var _v3 = _v0.b;
					var saisie = _v3.b;
					return (fiche.g1 === 1) ? A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Dj;
							},
							$elm$core$Maybe$Just),
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function ($) {
									return $.px;
								},
								fiche.GY))) : (A2(
						$elm$core$List$any,
						function (porte) {
							return porte.Eo && _Utils_eq(
								$elm$core$Maybe$Just(porte.zo),
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.r8;
									},
									saisie.hC.ve));
						},
						fiche.GY) ? $elm$core$Maybe$Just($elm$core$Maybe$Nothing) : $elm$core$Maybe$Nothing);
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Components$Referentiel$Fiche$Liaisons$tenter = function (etat) {
	return _Utils_update(
		etat,
		{P: true});
};
var $author$project$Components$Referentiel$Fiche$Update$validerLaLiaison = function (model) {
	var tentee = A2($author$project$Components$Referentiel$Fiche$Update$surLaLiaison, $author$project$Components$Referentiel$Fiche$Liaisons$tenter, model);
	var _v0 = _Utils_Tuple3(
		A2(
			$elm$core$Maybe$andThen,
			function (ouverte) {
				return A2($author$project$Components$Referentiel$Fiche$Liaisons$departs, ouverte, model.Bk);
			},
			model.kD),
		model.l2,
		A2(
			$author$project$Components$Referentiel$Fiche$Liaisons$confirmationRequise,
			$author$project$Components$Referentiel$Fiche$Update$principalEnPlace(model),
			model.Bk));
	_v0$3:
	while (true) {
		if (!_v0.a.$) {
			if (!_v0.a.a.b) {
				return A2($author$project$Components$Referentiel$Fiche$Update$versLeDrawer, $author$project$Components$Shared$Drawer$Update$Fermer, model);
			} else {
				if (_v0.b.$ === 1) {
					if (!_v0.c.$) {
						var enPlace = _v0.c.a;
						var demandee = A2($author$project$Components$Referentiel$Fiche$Liaisons$demanderLaConfirmation, enPlace, model.Bk);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{Bk: demandee}),
							_List_fromArray(
								[
									$author$project$Components$Referentiel$Fiche$Update$PlacerFocus(
									$author$project$Components$Referentiel$Fiche$Liaisons$idDuRenoncement(demandee))
								]));
					} else {
						var _v1 = _v0.a.a;
						var _v2 = _v1.a;
						var lien = _v2.a;
						var entite = _v2.b;
						var commande = _v2.c;
						var suite = _v1.b;
						var processUid = _v0.b.a;
						var _v3 = _v0.c;
						return _Utils_Tuple2(
							_Utils_update(
								tentee,
								{
									l2: $author$project$Components$Referentiel$Fiche$Model$EnCours(processUid),
									Bk: A2(
										$author$project$Components$Referentiel$Fiche$Liaisons$garderLaSuite,
										suite,
										$author$project$Components$Referentiel$Fiche$Liaisons$confirmer(tentee.Bk))
								}),
							_List_fromArray(
								[
									A4($author$project$Components$Referentiel$Fiche$Update$EnvoyerALaLiaison, lien, processUid, entite, commande)
								]));
					}
				} else {
					break _v0$3;
				}
			}
		} else {
			break _v0$3;
		}
	}
	return _Utils_Tuple2(tentee, _List_Nil);
};
var $author$project$Components$Referentiel$Fiche$Update$ModifierLeBloc = F6(
	function (a, b, c, d, e, f) {
		return {$: 9, a: a, b: b, c: c, d: d, e: e, f: f};
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$adresseVide = {vz: '', a3: '', a4: '', a5: '', B_: '', ho: '', Hj: ''};
var $author$project$Components$Referentiel$Common$ChampsDuType$rempli = function (valeur) {
	switch (valeur.$) {
		case 0:
			return false;
		case 1:
			var texte = valeur.a;
			return $elm$core$String$trim(texte) !== '';
		case 2:
			var choix = valeur.a;
			return !$elm$core$List$isEmpty(choix);
		case 5:
			var selection = valeur.a;
			return !$elm$core$List$isEmpty(selection.jL);
		case 3:
			var coche = valeur.a;
			return coche;
		case 4:
			var textes = valeur.a;
			return A2(
				$elm$core$List$any,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$second,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$String$trim,
						$elm$core$Basics$neq(''))),
				textes);
		default:
			var adresse = valeur.a;
			return !_Utils_eq(adresse, $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$adresseVide);
	}
};
var $author$project$Components$Referentiel$Common$ChampsDuType$valeurDe = F2(
	function (cle, saisie) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Vide,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$eq(cle)),
						saisie.Ki))));
	});
var $author$project$Components$Referentiel$Common$ChampsDuType$visible = F2(
	function (saisie, champ) {
		var _v0 = champ.KQ;
		if (_v0.$ === 1) {
			var autre = _v0.a;
			return $author$project$Components$Referentiel$Common$ChampsDuType$rempli(
				A2($author$project$Components$Referentiel$Common$ChampsDuType$valeurDe, autre, saisie));
		} else {
			return true;
		}
	});
var $author$project$Components$Referentiel$Common$ChampsDuType$champsAPresenter = F2(
	function (champs, saisie) {
		return A2(
			$elm$core$List$filter,
			$author$project$Components$Referentiel$Common$ChampsDuType$visible(saisie),
			champs);
	});
var $author$project$Components$Referentiel$Common$ChampsDuType$champsAEnvoyer = F2(
	function (schema, saisie) {
		return A2(
			$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$modifications,
			A2(
				$author$project$Components$Referentiel$Common$ChampsDuType$champsAPresenter,
				$author$project$Components$Referentiel$Common$ChampsDuType$tousLesChamps(schema),
				saisie),
			saisie);
	});
var $author$project$Components$Referentiel$Fiche$Update$validerLeBloc = function (model) {
	var _v0 = _Utils_Tuple3(model.gt, model.l2, model.jq);
	if (((_v0.a.$ === 1) && (_v0.b.$ === 1)) && (!_v0.c.$)) {
		var fiche = _v0.a.a;
		var processUid = _v0.b.a;
		var bloc = _v0.c.a;
		var _v1 = _Utils_Tuple2(
			fiche.ei,
			A2($author$project$Components$Referentiel$Fiche$Model$schemaDuType, bloc.r0, model));
		if ((!_v1.a.$) && (!_v1.b.$)) {
			var lien = _v1.a.a;
			var schema = _v1.b.a;
			var presentes = A2(
				$author$project$Components$Referentiel$Common$ChampsDuType$champsAPresenter,
				$author$project$Components$Referentiel$Common$ChampsDuType$tousLesChamps(schema),
				bloc.hP);
			var _v2 = A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$fautes, presentes, bloc.hP);
			if (_v2.b) {
				var fautif = _v2.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jq: $elm$core$Maybe$Just(
								_Utils_update(
									bloc,
									{
										hP: $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$tenter(bloc.hP)
									}))
						}),
					_List_fromArray(
						[
							$author$project$Components$Referentiel$Fiche$Update$PlacerFocus(
							A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$idDuChamp, $author$project$Components$Referentiel$Fiche$Update$prefixeDuBloc, fautif))
						]));
			} else {
				var _v3 = A2($author$project$Components$Referentiel$Common$ChampsDuType$champsAEnvoyer, schema, bloc.hP);
				if (!_v3.b) {
					return A2(
						$author$project$Components$Referentiel$Fiche$Update$surLeDrawerDuBloc,
						$author$project$Components$Shared$Drawer$Update$Fermer,
						_Utils_update(
							model,
							{jq: $elm$core$Maybe$Nothing}));
				} else {
					var champs = _v3;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l2: $author$project$Components$Referentiel$Fiche$Model$EnCours(processUid)
							}),
						_List_fromArray(
							[
								A6($author$project$Components$Referentiel$Fiche$Update$ModifierLeBloc, lien, processUid, fiche.r8, fiche.sq, bloc.r0, champs)
							]));
				}
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Fiche$Contacts$Ajouter = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$Fiche$Contacts$AjouterAuRattachement = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Contacts$Modifier = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Contacts$contactValide = function (etat) {
	return A2(
		$elm$core$Maybe$andThen,
		function (saisie) {
			return A2(
				$elm$core$Maybe$andThen,
				$elm$core$List$head,
				$elm$core$Result$toMaybe(
					$author$project$Components$Referentiel$Common$Contact$valides(
						_List_fromArray(
							[saisie]))));
		},
		$author$project$Components$Referentiel$Fiche$Contacts$ligne(etat));
};
var $author$project$Components$Referentiel$Fiche$Contacts$tenter = function (etat) {
	var _v0 = etat.zT;
	switch (_v0.$) {
		case 0:
			return etat;
		case 1:
			var saisie = _v0.a;
			return _Utils_update(
				etat,
				{
					zT: A2($author$project$Components$Referentiel$Fiche$Contacts$Ajout, saisie, true)
				});
		default:
			var uid = _v0.a;
			var saisie = _v0.b;
			return _Utils_update(
				etat,
				{
					zT: A3($author$project$Components$Referentiel$Fiche$Contacts$Correction, uid, saisie, true)
				});
	}
};
var $author$project$Components$Referentiel$Fiche$Update$validerLeContact = function (model) {
	var tente = A2($author$project$Components$Referentiel$Fiche$Update$surLeContact, $author$project$Components$Referentiel$Fiche$Contacts$tenter, model);
	var commande = function () {
		var _v2 = _Utils_Tuple3(
			model.v8.zT,
			$author$project$Components$Referentiel$Fiche$Contacts$contactValide(model.v8),
			model.gt);
		_v2$2:
		while (true) {
			if (!_v2.b.$) {
				switch (_v2.a.$) {
					case 1:
						if (_v2.c.$ === 1) {
							var _v3 = _v2.a;
							var saisie = _v2.b.a;
							var fiche = _v2.c.a;
							return A2(
								$elm$core$Maybe$map,
								function (lien) {
									return _Utils_Tuple2(
										lien,
										A2(
											$elm$core$Maybe$withDefault,
											$author$project$Components$Referentiel$Fiche$Contacts$Ajouter(saisie),
											A2(
												$elm$core$Maybe$map,
												function (uid) {
													return A2($author$project$Components$Referentiel$Fiche$Contacts$AjouterAuRattachement, uid, saisie);
												},
												model.v8.pN)));
								},
								fiche.s8);
						} else {
							break _v2$2;
						}
					case 2:
						var _v4 = _v2.a;
						var uid = _v4.a;
						var saisie = _v2.b.a;
						return A2(
							$elm$core$Maybe$map,
							function (lien) {
								return _Utils_Tuple2(
									lien,
									A2($author$project$Components$Referentiel$Fiche$Contacts$Modifier, uid, saisie));
							},
							A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.ei;
								},
								A2($author$project$Components$Referentiel$Fiche$Update$contactDe, uid, model)));
					default:
						break _v2$2;
				}
			} else {
				break _v2$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	}();
	if (!commande.$) {
		var _v1 = commande.a;
		var lien = _v1.a;
		var aEnvoyer = _v1.b;
		return A3($author$project$Components$Referentiel$Fiche$Update$envoyerAuContact, lien, aEnvoyer, tente);
	} else {
		return _Utils_Tuple2(tente, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Fiche$Update$EnvoyerAuRole = F4(
	function (a, b, c, d) {
		return {$: 12, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Referentiel$Fiche$Roles$ChangerLeStatutDe = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Roles$Fermer = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Roles$ModifierLaFinDe = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Roles$Ouvrir = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$Fiche$Roles$RemplacerPar = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Fiche$Roles$attendLaCloture = function (etat) {
	var _v0 = etat.zT;
	_v0$2:
	while (true) {
		if (_v0.$ === 2) {
			switch (_v0.b) {
				case 1:
					var _v1 = _v0.b;
					return true;
				case 2:
					var _v2 = _v0.b;
					return true;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return false;
};
var $author$project$Components$Referentiel$Fiche$Roles$attendLaDate = function (etat) {
	var _v0 = etat.zT;
	_v0$2:
	while (true) {
		switch (_v0.$) {
			case 1:
				return true;
			case 2:
				if (_v0.b === 3) {
					var _v1 = _v0.b;
					return true;
				} else {
					break _v0$2;
				}
			default:
				break _v0$2;
		}
	}
	return $author$project$Components$Referentiel$Fiche$Roles$attendLaCloture(etat);
};
var $author$project$Components$Referentiel$Fiche$Roles$vide = function (texte) {
	return $elm$core$String$trim(texte) === '';
};
var $author$project$Components$Referentiel$Fiche$Roles$avantLeDebut = F2(
	function (vise, enCours) {
		if (!vise.$) {
			var role = vise.a;
			return (!enCours.b$) && ((!$author$project$Components$Referentiel$Fiche$Roles$vide(enCours.wv)) && (_Utils_cmp(enCours.wv, role.wH) < 0));
		} else {
			return false;
		}
	});
var $author$project$Components$Referentiel$Fiche$Roles$dateObligatoire = function (etat) {
	var _v0 = etat.zT;
	if ((_v0.$ === 2) && (_v0.b === 3)) {
		var _v1 = _v0.b;
		var enCours = _v0.c;
		return !enCours.b$;
	} else {
		return $author$project$Components$Referentiel$Fiche$Roles$attendLaCloture(etat);
	}
};
var $author$project$Components$Referentiel$Fiche$Roles$montrees = function (etat) {
	return A2(
		$elm$core$Maybe$andThen,
		function (enCours) {
			return (enCours.P || (!_Utils_eq(enCours.pZ, $elm$core$Maybe$Nothing))) ? $elm$core$Maybe$Just(enCours) : $elm$core$Maybe$Nothing;
		},
		$author$project$Components$Referentiel$Fiche$Roles$saisie(etat));
};
var $author$project$I18n$Textes$referentielRoleErreurDateAvantDebut = A3($author$project$I18n$Traductions$texte, 'referentiel.role.erreur.date-avant-debut', _List_Nil, 'Date de fin avant la date de début');
var $author$project$I18n$Textes$referentielRoleErreurRecouvrement = A3($author$project$I18n$Traductions$texte, 'referentiel.role.erreur.recouvrement', _List_Nil, 'Un rôle de ce type couvre déjà cette période');
var $author$project$Components$Referentiel$Fiche$Roles$erreurDeLaDate = F2(
	function (vise, etat) {
		return A2(
			$elm$core$Maybe$andThen,
			function (enCours) {
				return (!$author$project$Components$Referentiel$Fiche$Roles$attendLaDate(etat)) ? $elm$core$Maybe$Nothing : (_Utils_eq(
					enCours.pZ,
					$elm$core$Maybe$Just(1)) ? $elm$core$Maybe$Just($author$project$I18n$Textes$referentielRoleErreurRecouvrement) : ((_Utils_eq(
					enCours.pZ,
					$elm$core$Maybe$Just(2)) || A2($author$project$Components$Referentiel$Fiche$Roles$avantLeDebut, vise, enCours)) ? $elm$core$Maybe$Just($author$project$I18n$Textes$referentielRoleErreurDateAvantDebut) : ((enCours.P && ($author$project$Components$Referentiel$Fiche$Roles$dateObligatoire(etat) && $author$project$Components$Referentiel$Fiche$Roles$vide(enCours.wv))) ? $elm$core$Maybe$Just($author$project$I18n$Textes$referentielFicheChampObligatoire) : $elm$core$Maybe$Nothing)));
			},
			$author$project$Components$Referentiel$Fiche$Roles$montrees(etat));
	});
var $author$project$Components$Referentiel$Fiche$Roles$commentaireMax = 2000;
var $author$project$I18n$Textes$referentielRoleErreurCommentaireTropLong = A3($author$project$I18n$Traductions$texte, 'referentiel.role.erreur.commentaire-trop-long', _List_Nil, 'Le commentaire fait 2 000 caractères au plus');
var $author$project$Components$Referentiel$Fiche$Roles$erreurDuCommentaire = function (etat) {
	return A2(
		$elm$core$Maybe$andThen,
		function (enCours) {
			return ($author$project$Components$Referentiel$Fiche$Roles$attendLaCloture(etat) && (_Utils_cmp(
				$elm$core$String$length(enCours.vM),
				$author$project$Components$Referentiel$Fiche$Roles$commentaireMax) > 0)) ? $elm$core$Maybe$Just($author$project$I18n$Textes$referentielRoleErreurCommentaireTropLong) : $elm$core$Maybe$Nothing;
		},
		$author$project$Components$Referentiel$Fiche$Roles$saisie(etat));
};
var $author$project$Components$Referentiel$Fiche$Roles$erreurDuResultat = function (etat) {
	return A2(
		$elm$core$Maybe$andThen,
		function (enCours) {
			return ($author$project$Components$Referentiel$Fiche$Roles$attendLaCloture(etat) && (enCours.P && $author$project$Components$Referentiel$Fiche$Roles$vide(enCours.HW))) ? $elm$core$Maybe$Just($author$project$I18n$Textes$referentielFicheChampObligatoire) : $elm$core$Maybe$Nothing;
		},
		$author$project$Components$Referentiel$Fiche$Roles$montrees(etat));
};
var $author$project$Components$Referentiel$Fiche$Roles$erreurDuStatut = function (etat) {
	var _v0 = _Utils_Tuple2(
		etat.zT,
		$author$project$Components$Referentiel$Fiche$Roles$montrees(etat));
	if (((_v0.a.$ === 2) && (!_v0.a.b)) && (!_v0.b.$)) {
		var _v1 = _v0.a;
		var _v2 = _v1.b;
		var enCours = _v0.b.a;
		return (enCours.P && $author$project$Components$Referentiel$Fiche$Roles$vide(enCours.ri)) ? $elm$core$Maybe$Just($author$project$I18n$Textes$referentielFicheChampObligatoire) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Fiche$Roles$attendLeType = function (etat) {
	var _v0 = etat.zT;
	_v0$2:
	while (true) {
		switch (_v0.$) {
			case 1:
				return true;
			case 2:
				if (_v0.b === 1) {
					var _v1 = _v0.b;
					return true;
				} else {
					break _v0$2;
				}
			default:
				break _v0$2;
		}
	}
	return false;
};
var $author$project$I18n$Textes$referentielRoleRelationGenerale = A3($author$project$I18n$Traductions$texte, 'referentiel.role.relation-generale', _List_Nil, 'Relation générale');
var $author$project$Components$Referentiel$Fiche$Roles$nomDeLOffre = function (role) {
	var _v0 = role.D1;
	if (_v0.$ === 1) {
		return $author$project$I18n$Textes$referentielRoleRelationGenerale;
	} else {
		var offre = _v0.a;
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Textes$referentielRoleOffreIndisponible,
			A2($elm$core$Maybe$map, $author$project$I18n$Traductions$tel, offre.Dj));
	}
};
var $author$project$Components$Referentiel$Fiche$Roles$offresProposees = function (etat) {
	var _v0 = etat.D3;
	if (_v0.$ === 1) {
		var offres = _v0.a;
		return offres;
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Referentiel$Fiche$Roles$nomDeLOffreSaisie = F2(
	function (vise, etat) {
		var _v0 = _Utils_Tuple2(etat.zT, vise);
		_v0$2:
		while (true) {
			switch (_v0.a.$) {
				case 2:
					if (!_v0.b.$) {
						var _v1 = _v0.a;
						var role = _v0.b.a;
						return $author$project$Components$Referentiel$Fiche$Roles$nomDeLOffre(role);
					} else {
						break _v0$2;
					}
				case 1:
					var enCours = _v0.a.a;
					return (enCours.D1 === '') ? $author$project$I18n$Textes$referentielRoleRelationGenerale : A2(
						$elm$core$Maybe$withDefault,
						$author$project$I18n$Textes$referentielRoleOffreIndisponible,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.Dj;
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (proposee) {
										return _Utils_eq(proposee.Aq, enCours.D1);
									},
									$author$project$Components$Referentiel$Fiche$Roles$offresProposees(etat)))));
				default:
					break _v0$2;
			}
		}
		return $author$project$I18n$Textes$referentielRoleRelationGenerale;
	});
var $author$project$I18n$Textes$referentielRoleErreurDejaOuvert = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'referentiel.role.erreur.deja-ouvert',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'typeDeRole',
				$author$project$I18n$Traductions$Sous(p.rX)),
				_Utils_Tuple2(
				'offre',
				$author$project$I18n$Traductions$Sous(p.D1))
			]),
		'Un rôle {typeDeRole} est déjà ouvert pour {offre}');
};
var $author$project$I18n$Textes$referentielRoleErreurNatureNonAdmise = A3($author$project$I18n$Traductions$texte, 'referentiel.role.erreur.nature-non-admise', _List_Nil, 'Ce type ne s\'ouvre pas pour la nature de cette fiche (personne ou organisation). Choisissez un autre type.');
var $author$project$I18n$Textes$referentielRoleErreurQualiteNonAdmise = A3($author$project$I18n$Traductions$texte, 'referentiel.role.erreur.qualite-non-admise', _List_Nil, 'Ce type ne s\'ouvre pas pour la qualité de cette fiche (particulier ou professionnel). Choisissez un autre type.');
var $author$project$Components$Referentiel$Fiche$Roles$typeDe = F2(
	function (uid, etat) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (fourni) {
					return _Utils_eq(fourni.r8, uid);
				},
				etat.ib));
	});
var $author$project$Components$Referentiel$Fiche$Roles$erreurDuType = F2(
	function (vise, etat) {
		return A2(
			$elm$core$Maybe$andThen,
			function (enCours) {
				return (!$author$project$Components$Referentiel$Fiche$Roles$attendLeType(etat)) ? $elm$core$Maybe$Nothing : (_Utils_eq(
					enCours.pZ,
					$elm$core$Maybe$Just(0)) ? A2(
					$elm$core$Maybe$map,
					function (fourni) {
						return $author$project$I18n$Textes$referentielRoleErreurDejaOuvert(
							{
								D1: A2($author$project$Components$Referentiel$Fiche$Roles$nomDeLOffreSaisie, vise, etat),
								rX: $author$project$I18n$Traductions$tel(fourni.Bl)
							});
					},
					A2($author$project$Components$Referentiel$Fiche$Roles$typeDe, enCours.r0, etat)) : (_Utils_eq(
					enCours.pZ,
					$elm$core$Maybe$Just(6)) ? $elm$core$Maybe$Just($author$project$I18n$Textes$referentielRoleErreurNatureNonAdmise) : (_Utils_eq(
					enCours.pZ,
					$elm$core$Maybe$Just(7)) ? $elm$core$Maybe$Just($author$project$I18n$Textes$referentielRoleErreurQualiteNonAdmise) : ((enCours.P && $author$project$Components$Referentiel$Fiche$Roles$vide(enCours.r0)) ? $elm$core$Maybe$Just($author$project$I18n$Textes$referentielFicheChampObligatoire) : $elm$core$Maybe$Nothing))));
			},
			$author$project$Components$Referentiel$Fiche$Roles$montrees(etat));
	});
var $author$project$Components$Referentiel$Fiche$Roles$roleVise = F2(
	function (roles, etat) {
		var _v0 = etat.zT;
		if (_v0.$ === 2) {
			var uid = _v0.a;
			return $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (role) {
						return _Utils_eq(role.r8, uid);
					},
					roles));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Referentiel$Fiche$Roles$tenter = function (etat) {
	var _v0 = etat.zT;
	switch (_v0.$) {
		case 0:
			return etat;
		case 1:
			var enCours = _v0.a;
			return _Utils_update(
				etat,
				{
					zT: $author$project$Components$Referentiel$Fiche$Roles$Ouverture(
						_Utils_update(
							enCours,
							{P: true}))
				});
		default:
			var uid = _v0.a;
			var choix = _v0.b;
			var enCours = _v0.c;
			return _Utils_update(
				etat,
				{
					zT: A3(
						$author$project$Components$Referentiel$Fiche$Roles$Evolution,
						uid,
						choix,
						_Utils_update(
							enCours,
							{P: true}))
				});
	}
};
var $author$project$Components$Referentiel$Fiche$Roles$commande = F2(
	function (roles, etat) {
		var vise = A2($author$project$Components$Referentiel$Fiche$Roles$roleVise, roles, etat);
		var tentee = $author$project$Components$Referentiel$Fiche$Roles$tenter(etat);
		var sansErreur = A2(
			$elm$core$List$all,
			$elm$core$Basics$eq($elm$core$Maybe$Nothing),
			_List_fromArray(
				[
					A2($author$project$Components$Referentiel$Fiche$Roles$erreurDuType, vise, tentee),
					A2($author$project$Components$Referentiel$Fiche$Roles$erreurDeLaDate, vise, tentee),
					$author$project$Components$Referentiel$Fiche$Roles$erreurDuResultat(tentee),
					$author$project$Components$Referentiel$Fiche$Roles$erreurDuStatut(tentee),
					$author$project$Components$Referentiel$Fiche$Roles$erreurDuCommentaire(tentee)
				]));
		var cloturee = function (enCours) {
			return {
				vM: $author$project$Components$Referentiel$Fiche$Roles$vide(enCours.vM) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$elm$core$String$trim(enCours.vM)),
				wv: enCours.wv,
				HW: enCours.HW
			};
		};
		if (!sansErreur) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = _Utils_Tuple2(etat.zT, vise);
			_v0$5:
			while (true) {
				switch (_v0.a.$) {
					case 1:
						var enCours = _v0.a.a;
						return $elm$core$Maybe$Just(
							$author$project$Components$Referentiel$Fiche$Roles$Ouvrir(
								{
									ku: $author$project$Components$Referentiel$Fiche$Roles$vide(enCours.wv) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(enCours.wv),
									D1: $author$project$Components$Referentiel$Fiche$Roles$vide(enCours.D1) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(enCours.D1),
									r0: enCours.r0
								}));
					case 2:
						if (!_v0.b.$) {
							switch (_v0.a.b) {
								case 0:
									var _v1 = _v0.a;
									var uid = _v1.a;
									var _v2 = _v1.b;
									var enCours = _v1.c;
									return $elm$core$Maybe$Just(
										A2($author$project$Components$Referentiel$Fiche$Roles$ChangerLeStatutDe, uid, enCours.ri));
								case 2:
									var _v3 = _v0.a;
									var uid = _v3.a;
									var _v4 = _v3.b;
									var enCours = _v3.c;
									return $elm$core$Maybe$Just(
										A2(
											$author$project$Components$Referentiel$Fiche$Roles$Fermer,
											uid,
											cloturee(enCours)));
								case 1:
									var _v5 = _v0.a;
									var uid = _v5.a;
									var _v6 = _v5.b;
									var enCours = _v5.c;
									return $elm$core$Maybe$Just(
										A3(
											$author$project$Components$Referentiel$Fiche$Roles$RemplacerPar,
											uid,
											enCours.r0,
											cloturee(enCours)));
								default:
									var _v7 = _v0.a;
									var uid = _v7.a;
									var _v8 = _v7.b;
									var enCours = _v7.c;
									return $elm$core$Maybe$Just(
										A2(
											$author$project$Components$Referentiel$Fiche$Roles$ModifierLaFinDe,
											uid,
											enCours.b$ ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(enCours.wv)));
							}
						} else {
							break _v0$5;
						}
					default:
						break _v0$5;
				}
			}
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Referentiel$Fiche$Roles$lienDe = F3(
	function (ouvrirRole, roles, aEnvoyer) {
		var duRole = F2(
			function (uid, lien) {
				return A2(
					$elm$core$Maybe$andThen,
					lien,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (role) {
								return _Utils_eq(role.r8, uid);
							},
							roles)));
			});
		switch (aEnvoyer.$) {
			case 0:
				return ouvrirRole;
			case 1:
				var uid = aEnvoyer.a;
				return A2(
					duRole,
					uid,
					function ($) {
						return $.u6;
					});
			case 2:
				var uid = aEnvoyer.a;
				return A2(
					duRole,
					uid,
					function ($) {
						return $.zk;
					});
			case 3:
				var uid = aEnvoyer.a;
				return A2(
					duRole,
					uid,
					function ($) {
						return $.ql;
					});
			default:
				var uid = aEnvoyer.a;
				return A2(
					duRole,
					uid,
					function ($) {
						return $.od;
					});
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$validerLeRole = function (model) {
	var _v0 = _Utils_Tuple2(model.gt, model.l2);
	_v0$2:
	while (true) {
		switch (_v0.b.$) {
			case 1:
				if (_v0.a.$ === 1) {
					var fiche = _v0.a.a;
					var processUid = _v0.b.a;
					var tous = _Utils_ap(fiche.eX, fiche.H7);
					var tente = A2($author$project$Components$Referentiel$Fiche$Update$surLeRole, $author$project$Components$Referentiel$Fiche$Roles$tenter, model);
					var aEnvoyer = A2(
						$elm$core$Maybe$andThen,
						function (commande) {
							return A2(
								$elm$core$Maybe$map,
								$elm$core$Tuple$pair(commande),
								A3($author$project$Components$Referentiel$Fiche$Roles$lienDe, fiche.EC, tous, commande));
						},
						A2($author$project$Components$Referentiel$Fiche$Roles$commande, tous, model.bi));
					if (!aEnvoyer.$) {
						var _v2 = aEnvoyer.a;
						var commande = _v2.a;
						var lien = _v2.b;
						return _Utils_Tuple2(
							_Utils_update(
								tente,
								{
									l2: $author$project$Components$Referentiel$Fiche$Model$EnCours(processUid)
								}),
							_List_fromArray(
								[
									A4($author$project$Components$Referentiel$Fiche$Update$EnvoyerAuRole, lien, processUid, fiche.r8, commande)
								]));
					} else {
						return _Utils_Tuple2(tente, _List_Nil);
					}
				} else {
					break _v0$2;
				}
			case 2:
				return _Utils_Tuple2(model, _List_Nil);
			default:
				break _v0$2;
		}
	}
	return _Utils_Tuple2(
		A2($author$project$Components$Referentiel$Fiche$Update$surLeRole, $author$project$Components$Referentiel$Fiche$Roles$tenter, model),
		_List_Nil);
};
var $author$project$Components$Referentiel$Fiche$Update$GererUneOccurrence = F4(
	function (a, b, c, d) {
		return {$: 10, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$RetirerUneOccurrence = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Occurrences$referenceDuChamp = F2(
	function (type_, cle) {
		return 'crm.entite.type.' + ($author$project$Components$Referentiel$Identifiants$typeUidToString(type_) + ('.' + cle));
	});
var $author$project$Components$Referentiel$Fiche$Update$envoyerUnRetrait = F4(
	function (fiche, processUid, retrait, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (bloc) {
				return A3($author$project$Components$Referentiel$Fiche$Occurrences$lienDe, $author$project$API$NavLinksDictionary$retirerUneOccurrence, bloc, retrait.uN);
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.r0;
						},
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.r8;
							},
							$elm$core$Basics$eq(retrait.r0))),
					fiche.uW)));
		if (!_v0.$) {
			var lien = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: $author$project$Components$Referentiel$Fiche$Model$EnCours(processUid)
					}),
				_List_fromArray(
					[
						A4(
						$author$project$Components$Referentiel$Fiche$Update$GererUneOccurrence,
						lien,
						processUid,
						fiche.r8,
						A2(
							$author$project$Components$Referentiel$Fiche$API$WriteAPIModel$RetirerUneOccurrence,
							A2($author$project$Components$Referentiel$Fiche$Occurrences$referenceDuChamp, retrait.r0, retrait.uN),
							retrait.r8))
					]));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$AjouterUneOccurrence = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Fiche$API$WriteAPIModel$ModifierUneOccurrence = F4(
	function (a, b, c, d) {
		return {$: 1, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$obligatoiresManquants = function (brouillon) {
	return A2(
		$elm$core$List$filterMap,
		function (cle) {
			return A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dy;
							},
							$elm$core$Basics$eq(cle)),
						brouillon.IX)));
		},
		A2(
			$elm$core$List$filter,
			function (cle) {
				return !A2(
					$elm$core$List$member,
					cle,
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$first,
						$author$project$Components$Shared$EditeurDeSchema$Groupe$tapeesRetenues(brouillon)));
			},
			A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$fautes, brouillon.IX, brouillon.hP)));
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$partantDeRien = function (saisie) {
	return _Utils_update(
		saisie,
		{AP: _List_Nil});
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$envoyable = function (brouillon) {
	return ($elm$core$List$isEmpty(
		$author$project$Components$Shared$EditeurDeSchema$Groupe$obligatoiresManquants(brouillon)) && $author$project$Components$Shared$EditeurDeSchema$Groupe$modifie(brouillon)) ? $elm$core$Maybe$Just(
		A2(
			$elm$core$List$filter,
			function (_v0) {
				var cle = _v0.a;
				return !A2(
					$elm$core$List$member,
					cle,
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$first,
						$author$project$Components$Shared$EditeurDeSchema$Groupe$tapeesRetenues(brouillon)));
			},
			A2(
				$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$modifications,
				brouillon.IX,
				$author$project$Components$Shared$EditeurDeSchema$Groupe$partantDeRien(brouillon.hP)))) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$Referentiel$Fiche$Update$prefixeDesOccurrences = 'referentiel-fiche-occurrence';
var $author$project$Components$Shared$EditeurDeSchema$Groupe$tenter = function (brouillon) {
	return _Utils_update(
		brouillon,
		{
			hP: $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$tenter(brouillon.hP),
			b5: true
		});
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$choixDuGroupe = F2(
	function (groupe, choix) {
		var prefixe = groupe + '.';
		return A2(
			$elm$core$List$map,
			function (liste) {
				return _Utils_update(
					liste,
					{
						dy: A2(
							$elm$core$String$dropLeft,
							$elm$core$String$length(prefixe),
							liste.dy)
					});
			},
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.dy;
					},
					$elm$core$String$startsWith(prefixe)),
				choix));
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$valeursACreer = F2(
	function (choix, brouillon) {
		return A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var cle = _v0.a;
				var libelle = _v0.b;
				return A2(
					$elm$core$Maybe$map,
					function (liste) {
						return {Bl: libelle, nW: liste.nW, IW: cle};
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.dy;
								},
								$elm$core$Basics$eq(cle)),
							A2($author$project$Components$Shared$EditeurDeSchema$Groupe$choixDuGroupe, brouillon.uN, choix))));
			},
			$author$project$Components$Shared$EditeurDeSchema$Groupe$tapeesRetenues(brouillon));
	});
var $author$project$Components$Referentiel$Fiche$Update$envoyerUneOccurrence = F4(
	function (fiche, processUid, ouverte, model) {
		var brouillon = ouverte.uw;
		var rel = _Utils_eq(brouillon.r8, $elm$core$Maybe$Nothing) ? $author$project$API$NavLinksDictionary$ajouterUneOccurrence : $author$project$API$NavLinksDictionary$modifierUneOccurrence;
		var lien = A2(
			$elm$core$Maybe$andThen,
			function (bloc) {
				return A3($author$project$Components$Referentiel$Fiche$Occurrences$lienDe, rel, bloc, brouillon.uN);
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.r0;
						},
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.r8;
							},
							$elm$core$Basics$eq(ouverte.r0))),
					fiche.uW)));
		var _v0 = _Utils_Tuple2(
			$author$project$Components$Shared$EditeurDeSchema$Groupe$envoyable(brouillon),
			lien);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var valeurs = _v0.a.a;
				var servi = _v0.b.a;
				var choix = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.jN;
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.r0;
									},
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.r8;
										},
										$elm$core$Basics$eq(ouverte.r0))),
								fiche.uW))));
				var aCreer = A2($author$project$Components$Shared$EditeurDeSchema$Groupe$valeursACreer, choix, brouillon);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: $author$project$Components$Referentiel$Fiche$Model$EnCours(processUid)
						}),
					_List_fromArray(
						[
							A4(
							$author$project$Components$Referentiel$Fiche$Update$GererUneOccurrence,
							servi,
							processUid,
							fiche.r8,
							function () {
								var _v1 = brouillon.r8;
								if (_v1.$ === 1) {
									return A3(
										$author$project$Components$Referentiel$Fiche$API$WriteAPIModel$AjouterUneOccurrence,
										A2($author$project$Components$Referentiel$Fiche$Occurrences$referenceDuChamp, ouverte.r0, brouillon.uN),
										valeurs,
										aCreer);
								} else {
									var uid = _v1.a;
									return A4(
										$author$project$Components$Referentiel$Fiche$API$WriteAPIModel$ModifierUneOccurrence,
										A2($author$project$Components$Referentiel$Fiche$Occurrences$referenceDuChamp, ouverte.r0, brouillon.uN),
										uid,
										valeurs,
										aCreer);
								}
							}())
						]));
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			var _v2 = _v0.a;
			return _Utils_Tuple2(
				A2(
					$author$project$Components$Referentiel$Fiche$Update$surLesOccurrences,
					function (etat) {
						return _Utils_update(
							etat,
							{
								Et: $elm$core$Maybe$Just(
									_Utils_update(
										ouverte,
										{
											uw: $author$project$Components$Shared$EditeurDeSchema$Groupe$tenter(brouillon)
										}))
							});
					},
					model),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (fautif) {
							return _List_fromArray(
								[
									$author$project$Components$Referentiel$Fiche$Update$PlacerFocus(
									A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$idDuChamp, $author$project$Components$Referentiel$Fiche$Update$prefixeDesOccurrences, fautif))
								]);
						},
						$elm$core$List$head(
							$author$project$Components$Shared$EditeurDeSchema$Groupe$obligatoiresManquants(brouillon)))));
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$validerUneOccurrence = function (model) {
	var _v0 = _Utils_Tuple2(model.gt, model.l2);
	if ((_v0.a.$ === 1) && (_v0.b.$ === 1)) {
		var fiche = _v0.a.a;
		var processUid = _v0.b.a;
		var _v1 = _Utils_Tuple2(model.oV.Et, model.oV.dh);
		if (!_v1.a.$) {
			var ouverte = _v1.a.a;
			return A4($author$project$Components$Referentiel$Fiche$Update$envoyerUneOccurrence, fiche, processUid, ouverte, model);
		} else {
			if (!_v1.b.$) {
				var _v2 = _v1.a;
				var retrait = _v1.b.a;
				return A4($author$project$Components$Referentiel$Fiche$Update$envoyerUnRetrait, fiche, processUid, retrait, model);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Fiche$Update$versLeDrawerDEffacement = F2(
	function (msg, model) {
		var etat = model.x9;
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{
				Il: (etat.hP !== '') || ((etat.Gd !== '') || (!_Utils_eq(etat.cX, $elm$core$Maybe$Nothing)))
			},
			msg,
			etat.kX);
		var drawer = _v0.a;
		var effets = _v0.b;
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? _Utils_update(
				model,
				{
					x9: _Utils_update(
						etat,
						{kX: drawer})
				}) : _Utils_update(
				model,
				{x9: $author$project$Components$Referentiel$Fiche$Effacement$init}),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Referentiel$Fiche$Update$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Referentiel$Fiche$Update$versLeDrawerDExport = F2(
	function (msg, model) {
		var etat = model.ms;
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{Il: etat.gO || etat.f3},
			msg,
			etat.kX);
		var drawer = _v0.a;
		var effets = _v0.b;
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? _Utils_update(
				model,
				{
					ms: _Utils_update(
						etat,
						{kX: drawer})
				}) : _Utils_update(
				model,
				{ms: $author$project$Components$Referentiel$Fiche$Export$init}),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Referentiel$Fiche$Update$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Referentiel$Fiche$Update$versLeDrawerDuCycle = F2(
	function (msg, model) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{Il: false},
			msg,
			model.lr);
		var drawer = _v0.a;
		var effets = _v0.b;
		var suivant = _Utils_update(
			model,
			{lr: drawer});
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? suivant : $author$project$Components$Referentiel$Fiche$Update$fermerLeCycle(suivant),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Referentiel$Fiche$Update$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Referentiel$Fiche$Update$update = F2(
	function (msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 1:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{mT: true}),
						_List_Nil);
				case 0:
					var uid = msg.a;
					var vuesAJour = msg.b;
					var rejouee = msg.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								tS: A2(
									$elm$core$Maybe$map,
									$elm$core$Tuple$pair(uid),
									rejouee),
								lW: vuesAJour ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(uid)
							}),
						_List_Nil);
				case 2:
					var uid = msg.a;
					var gabarits = msg.b;
					return A3($author$project$Components$Referentiel$Fiche$Update$ouvrir, uid, gabarits, model);
				case 3:
					var uid = msg.a;
					var reponse = msg.b;
					if (!_Utils_eq(
						model.kD,
						$elm$core$Maybe$Just(uid))) {
						return _Utils_Tuple2(model, _List_Nil);
					} else {
						var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$API$QueryAPIModel$ficheDecoder, reponse);
						if (!_v1.$) {
							var vue = _v1.a;
							return $author$project$Components$Referentiel$Fiche$Update$relireLaChronologie(
								_Utils_update(
									model,
									{
										tS: $elm$core$Maybe$Nothing,
										fX: false,
										lW: $elm$core$Maybe$Nothing,
										gt: $author$project$Components$Referentiel$Fiche$Model$Lue(
											A2(
												$author$project$Components$Referentiel$Fiche$Update$nommerLaFiche,
												model.bi.ib,
												A2($author$project$Components$Referentiel$Fiche$API$ToModel$toModel, model.hd, vue)))
									}));
						} else {
							var refus = _v1.a;
							return A3($author$project$Components$Referentiel$Fiche$Update$refuser, uid, refus, model);
						}
					}
				case 4:
					var uid = msg.a;
					return _Utils_eq(
						model.kD,
						$elm$core$Maybe$Just(uid)) ? $author$project$Components$Referentiel$Fiche$Update$relire(model) : _Utils_Tuple2(model, _List_Nil);
				case 5:
					return $author$project$Components$Referentiel$Fiche$Update$relire(model);
				case 6:
					var octets = msg.a;
					var _v2 = _Utils_Tuple2(
						model.l2,
						$author$project$API$ProcessUid$depuisOctets(octets));
					if (!_v2.a.$) {
						if (!_v2.b.$) {
							var _v3 = _v2.a;
							var processUid = _v2.b.a;
							return A2($author$project$Components$Referentiel$Fiche$Update$poursuivre, processUid, model);
						} else {
							var _v4 = _v2.a;
							var _v5 = _v2.b;
							return _Utils_Tuple2(
								model,
								_List_fromArray(
									[$author$project$Components$Referentiel$Fiche$Update$DemanderProcessUid]));
						}
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 7:
					var cle = msg.a;
					return _Utils_Tuple2(
						A2($author$project$Components$Referentiel$Fiche$Model$ouvrirUnChamp, cle, model),
						_List_Nil);
				case 8:
					var _v6 = model.gt;
					if (_v6.$ === 1) {
						var nature = _v6.a.g1;
						return (nature === 1) ? $author$project$Components$Referentiel$Fiche$Update$lireLesTypes(
							$author$project$Components$Referentiel$Fiche$Update$ouvrirLIdentite(model)) : _Utils_Tuple2(
							$author$project$Components$Referentiel$Fiche$Model$ouvrirLeBloc(model),
							_List_Nil);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 9:
					var cle = msg.a;
					var saisie = msg.b;
					return A2(
						$author$project$Components$Referentiel$Fiche$Update$apresLaSaisie,
						cle,
						A3($author$project$Components$Referentiel$Fiche$Model$setSaisie, cle, saisie, model));
				case 13:
					var drawerMsg = msg.a;
					return A2($author$project$Components$Referentiel$Fiche$Update$surLeDrawerDIdentite, drawerMsg, model);
				case 14:
					return $author$project$Components$Referentiel$Fiche$Update$validerLIdentite(model);
				case 17:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{dI: true}),
						_List_Nil);
				case 18:
					var coche = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b2: !coche}),
						_List_Nil);
				case 15:
					var numero = msg.a;
					return A2($author$project$Components$Referentiel$Fiche$Update$chercherLeDoublon, numero, model);
				case 16:
					var numero = msg.a;
					var reponse = msg.b;
					return A3($author$project$Components$Referentiel$Fiche$Update$doublonRecu, numero, reponse, model);
				case 10:
					return _Utils_Tuple2(
						$author$project$Components$Referentiel$Fiche$Model$annulerLEdition(model),
						_List_Nil);
				case 11:
					return $author$project$Components$Referentiel$Fiche$Update$valider(model);
				case 12:
					var uid = msg.a;
					var reponse = msg.b;
					var _v7 = _Utils_Tuple2(
						_Utils_eq(
							model.kD,
							$elm$core$Maybe$Just(uid)),
						model.l2);
					if (_v7.a && (_v7.b.$ === 2)) {
						var processUid = _v7.b.a;
						return A4($author$project$Components$Referentiel$Fiche$Update$rendre, uid, processUid, reponse, model);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 19:
					var _v8 = _Utils_Tuple3(model.gt, model.kD, model.nB);
					if (((_v8.a.$ === 1) && (!_v8.b.$)) && (!_v8.c.$)) {
						var uid = _v8.b.a;
						var lien = _v8.c.a;
						return _Utils_Tuple2(
							model,
							_List_fromArray(
								[
									A2($author$project$Components$Referentiel$Fiche$Update$LireFiche, uid, lien)
								]));
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 20:
					var _v9 = model.gt;
					if (_v9.$ === 1) {
						var fiche = _v9.a;
						return (!_Utils_eq(fiche.s8, $elm$core$Maybe$Nothing)) ? A2(
							$author$project$Components$Referentiel$Fiche$Update$synchroniserLeDrawerDuContact,
							$author$project$Components$Referentiel$Fiche$Update$idDeLAjoutDeContact,
							A2($author$project$Components$Referentiel$Fiche$Update$surLeContact, $author$project$Components$Referentiel$Fiche$Contacts$ouvrirLAjout, model)) : _Utils_Tuple2(model, _List_Nil);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 21:
					var uid = msg.a;
					var _v10 = A2(
						$elm$core$Maybe$andThen,
						function (contact) {
							return A2(
								$elm$core$Maybe$map,
								function (_v11) {
									return contact;
								},
								contact.ei);
						},
						A2($author$project$Components$Referentiel$Fiche$Update$contactDe, uid, model));
					if (!_v10.$) {
						var contact = _v10.a;
						return A2(
							$author$project$Components$Referentiel$Fiche$Update$synchroniserLeDrawerDuContact,
							$author$project$Components$Referentiel$Fiche$Update$idDesGestesDeContact(uid),
							A2(
								$author$project$Components$Referentiel$Fiche$Update$surLeContact,
								$author$project$Components$Referentiel$Fiche$Contacts$ouvrirLaModification(contact),
								model));
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 22:
					var code = msg.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLeContact,
							$author$project$Components$Referentiel$Fiche$Contacts$setCanal(code),
							model),
						_List_Nil);
				case 23:
					var valeur = msg.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLeContact,
							$author$project$Components$Referentiel$Fiche$Contacts$setValeur(valeur),
							model),
						_List_Nil);
				case 24:
					var champ = msg.a;
					var valeur = msg.b;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLeContact,
							A2($author$project$Components$Referentiel$Fiche$Contacts$setAdresse, champ, valeur),
							model),
						_List_Nil);
				case 25:
					var code = msg.a;
					return A2($elm$core$String$startsWith, $author$project$Components$Referentiel$Fiche$Contacts$prefixeDUsageLie, code) ? _Utils_Tuple2(
						A2(
							$elm$core$Maybe$withDefault,
							model,
							A2(
								$elm$core$Maybe$map,
								function (uid) {
									return A2(
										$author$project$Components$Referentiel$Fiche$Update$surLeContact,
										$author$project$Components$Referentiel$Fiche$Contacts$lier(uid),
										model);
								},
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (uid) {
											return _Utils_eq(
												_Utils_ap(
													$author$project$Components$Referentiel$Fiche$Contacts$prefixeDUsageLie,
													$author$project$Components$Referentiel$Identifiants$rattachementUidToString(uid)),
												code);
										},
										A2(
											$elm$core$List$map,
											function ($) {
												return $.r8;
											},
											$author$project$Components$Referentiel$Fiche$Model$rattachementsLiables(model)))))),
						_List_Nil) : _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLeContact,
							$author$project$Components$Referentiel$Fiche$Contacts$setUsage(code),
							model),
						_List_Nil);
				case 26:
					var acceptee = msg.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLeContact,
							$author$project$Components$Referentiel$Fiche$Contacts$setProspection(acceptee),
							model),
						_List_Nil);
				case 27:
					return A2(
						$author$project$Components$Referentiel$Fiche$Update$synchroniserLeDrawerDuContact,
						'',
						A2($author$project$Components$Referentiel$Fiche$Update$surLeContact, $author$project$Components$Referentiel$Fiche$Contacts$annuler, model));
				case 28:
					return $author$project$Components$Referentiel$Fiche$Update$validerLeContact(model);
				case 29:
					var uid = msg.a;
					return A2(
						$author$project$Components$Referentiel$Fiche$Update$synchroniserLeDrawerDuContact,
						$author$project$Components$Referentiel$Fiche$Update$idDesGestesDeContact(uid),
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLeContact,
							$author$project$Components$Referentiel$Fiche$Contacts$basculerLeMenu(uid),
							model));
				case 128:
					var drawerMsg = msg.a;
					return A2($author$project$Components$Referentiel$Fiche$Update$surLeDrawerDuContact, drawerMsg, model);
				case 130:
					var cible = msg.a;
					return _Utils_Tuple2(
						model,
						_List_fromArray(
							[
								$author$project$Components$Referentiel$Fiche$Update$PlacerFocus(cible)
							]));
				case 129:
					var liste = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								kH: A2($author$project$Components$Referentiel$Fiche$Resume$basculer, liste, model.kH)
							}),
						_List_Nil);
				case 30:
					var uid = msg.a;
					return A4(
						$author$project$Components$Referentiel$Fiche$Update$surLeMenu,
						uid,
						function ($) {
							return $.HE;
						},
						$author$project$Components$Referentiel$Fiche$Contacts$RendrePrincipal(uid),
						model);
				case 31:
					var uid = msg.a;
					var statut = msg.b;
					return A4(
						$author$project$Components$Referentiel$Fiche$Update$surLeMenu,
						uid,
						function ($) {
							return $.B6;
						},
						A2($author$project$Components$Referentiel$Fiche$Contacts$Marquer, uid, statut),
						model);
				case 32:
					var uid = msg.a;
					var acceptee = msg.b;
					return A4(
						$author$project$Components$Referentiel$Fiche$Update$surLeMenu,
						uid,
						function ($) {
							return $.Hn;
						},
						A2($author$project$Components$Referentiel$Fiche$Contacts$ReglerLaProspection, uid, acceptee),
						model);
				case 33:
					return _Utils_Tuple2(
						A2($author$project$Components$Referentiel$Fiche$Update$surLeContact, $author$project$Components$Referentiel$Fiche$Contacts$basculerLesAnciens, model),
						_List_Nil);
				case 34:
					var uid = msg.a;
					var reponse = msg.b;
					var _v12 = _Utils_Tuple2(
						_Utils_eq(
							model.kD,
							$elm$core$Maybe$Just(uid)),
						model.l2);
					if (_v12.a && (_v12.b.$ === 2)) {
						var processUid = _v12.b.a;
						return A4($author$project$Components$Referentiel$Fiche$Update$rendreLeContact, uid, processUid, reponse, model);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 35:
					var liens = msg.a;
					var lien = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$typesDePartiePrenante, liens);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								nH: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rechercherDoublons, liens),
								nK: lien
							}),
						_Utils_ap(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Fiche$Update$LireTypes, $elm$core$List$singleton),
									lien)),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Fiche$Update$LireLesFormes, $elm$core$List$singleton),
									A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$formesDOrganisation, liens)))));
				case 70:
					var reponse = msg.a;
					var _v13 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$formesDecoder, reponse);
					if (!_v13.$) {
						var formes = _v13.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{zS: formes}),
							_List_Nil);
					} else {
						var refus = _v13.a;
						return _Utils_Tuple2(
							model,
							(refus.ri === 401) ? _List_fromArray(
								[$author$project$Components$Referentiel$Fiche$Update$Reconnecter]) : _List_Nil);
					}
				case 36:
					var reponse = msg.a;
					var _v14 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$typesDecoder, reponse);
					if (!_v14.$) {
						var types = _v14.a;
						return _Utils_Tuple2(
							$author$project$Components$Referentiel$Fiche$Update$nommerLesRoles(
								A2(
									$author$project$Components$Referentiel$Fiche$Update$surLeRole,
									$author$project$Components$Referentiel$Fiche$Roles$typesRecus(types),
									A2($author$project$Components$Referentiel$Fiche$Update$schemasLus, reponse, model))),
							_List_Nil);
					} else {
						var refus = _v14.a;
						return _Utils_Tuple2(
							model,
							(refus.ri === 401) ? _List_fromArray(
								[$author$project$Components$Referentiel$Fiche$Update$Reconnecter]) : _List_Nil);
					}
				case 39:
					var declencheur = msg.a;
					var _v15 = model.gt;
					if (_v15.$ === 1) {
						var fiche = _v15.a;
						return (!_Utils_eq(fiche.EC, $elm$core$Maybe$Nothing)) ? A2(
							$elm$core$Tuple$mapSecond,
							function (effets) {
								return _Utils_ap(
									effets,
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Fiche$Update$LireLesOffres, $elm$core$List$singleton),
											fiche.D6)));
							},
							A2(
								$author$project$Components$Referentiel$Fiche$Update$surLeDrawerDOuverture,
								$author$project$Components$Shared$Drawer$Update$Ouvrir(declencheur),
								A2($author$project$Components$Referentiel$Fiche$Update$surLeRole, $author$project$Components$Referentiel$Fiche$Roles$ouvrirLOuverture, model))) : _Utils_Tuple2(model, _List_Nil);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 40:
					var uid = msg.a;
					var declencheur = msg.b;
					var _v16 = A2($author$project$Components$Referentiel$Fiche$Update$roleDe, uid, model);
					if (!_v16.$) {
						var role = _v16.a;
						return (!$elm$core$List$isEmpty(
							$author$project$Components$Referentiel$Fiche$Roles$choixOfferts(role))) ? A2(
							$author$project$Components$Referentiel$Fiche$Update$surLeDrawerDEvolution,
							$author$project$Components$Shared$Drawer$Update$Ouvrir(declencheur),
							A2(
								$author$project$Components$Referentiel$Fiche$Update$surLeRole,
								$author$project$Components$Referentiel$Fiche$Roles$ouvrirLEvolution(role),
								model)) : _Utils_Tuple2(model, _List_Nil);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 41:
					var code = msg.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLeRole,
							$author$project$Components$Referentiel$Fiche$Roles$setChoix(code),
							model),
						_List_Nil);
				case 42:
					var uid = msg.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLeRole,
							$author$project$Components$Referentiel$Fiche$Roles$setType(uid),
							model),
						_List_Nil);
				case 38:
					var id = msg.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLeRole,
							$author$project$Components$Referentiel$Fiche$Roles$setOffre(id),
							model),
						_List_Nil);
				case 37:
					var reponse = msg.a;
					var _v17 = A2(
						$author$project$API$Reponse$lire,
						$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$QueryAPIModel$offreProposeeDecoder),
						reponse);
					if (!_v17.$) {
						var offres = _v17.a;
						return _Utils_Tuple2(
							A2(
								$author$project$Components$Referentiel$Fiche$Update$surLeRole,
								$author$project$Components$Referentiel$Fiche$Roles$offresRecues(
									A2(
										$elm$core$List$map,
										function (offre) {
											return {
												Aq: offre.Aq,
												Dj: A2(
													$elm$core$Maybe$withDefault,
													$author$project$I18n$Textes$referentielRoleOffreIndisponible,
													A2($elm$core$Maybe$map, $author$project$I18n$Traductions$tel, offre.Dj))
											};
										},
										A2(
											$elm$core$List$filter,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.tL;
												},
												$elm$core$Basics$not),
											offres))),
								model),
							_List_Nil);
					} else {
						var refus = _v17.a;
						return _Utils_Tuple2(
							A2($author$project$Components$Referentiel$Fiche$Update$surLeRole, $author$project$Components$Referentiel$Fiche$Roles$offresIllisibles, model),
							(refus.ri === 401) ? _List_fromArray(
								[$author$project$Components$Referentiel$Fiche$Update$Reconnecter]) : _List_Nil);
					}
				case 43:
					var date = msg.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLeRole,
							$author$project$Components$Referentiel$Fiche$Roles$setDate(date),
							model),
						_List_Nil);
				case 44:
					var retiree = msg.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLeRole,
							$author$project$Components$Referentiel$Fiche$Roles$setRetirerLaFin(retiree),
							model),
						_List_Nil);
				case 45:
					var code = msg.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLeRole,
							$author$project$Components$Referentiel$Fiche$Roles$setStatut(code),
							model),
						_List_Nil);
				case 46:
					var code = msg.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLeRole,
							$author$project$Components$Referentiel$Fiche$Roles$setResultat(code),
							model),
						_List_Nil);
				case 47:
					var texte = msg.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLeRole,
							$author$project$Components$Referentiel$Fiche$Roles$setCommentaire(texte),
							model),
						_List_Nil);
				case 48:
					return $author$project$Components$Referentiel$Fiche$Update$validerLeRole(model);
				case 49:
					var drawerMsg = msg.a;
					return A2($author$project$Components$Referentiel$Fiche$Update$surLeDrawerDOuverture, drawerMsg, model);
				case 50:
					var drawerMsg = msg.a;
					return A2($author$project$Components$Referentiel$Fiche$Update$surLeDrawerDEvolution, drawerMsg, model);
				case 51:
					var uid = msg.a;
					var reponse = msg.b;
					var _v18 = _Utils_Tuple2(
						_Utils_eq(
							model.kD,
							$elm$core$Maybe$Just(uid)),
						model.l2);
					if (_v18.a && (_v18.b.$ === 2)) {
						var processUid = _v18.b.a;
						return A4($author$project$Components$Referentiel$Fiche$Update$rendreLeRole, uid, processUid, reponse, model);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 52:
					var affiches = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ji: affiches}),
						_List_Nil);
				case 53:
					var uid = msg.a;
					var _v19 = A2($author$project$Components$Referentiel$Fiche$Update$rattachementDe, uid, model);
					if (!_v19.$) {
						var rattachement = _v19.a;
						return A3(
							$author$project$Components$Referentiel$Fiche$Update$ouvrirLeDrawer,
							$author$project$Components$Referentiel$Fiche$Liaisons$idDuDeclencheurDeFin(uid),
							$author$project$Components$Referentiel$Fiche$Liaisons$ouvrirLaFin(rattachement),
							model);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 54:
					var saisie = msg.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLaLiaison,
							$author$project$Components$Referentiel$Fiche$Liaisons$setFin(saisie),
							model),
						_List_Nil);
				case 55:
					var drawerMsg = msg.a;
					return A2($author$project$Components$Referentiel$Fiche$Update$versLeDrawer, drawerMsg, model);
				case 56:
					return $author$project$Components$Referentiel$Fiche$Update$validerLaLiaison(model);
				case 57:
					var uid = msg.a;
					var reponse = msg.b;
					var _v20 = _Utils_Tuple2(
						_Utils_eq(
							model.kD,
							$elm$core$Maybe$Just(uid)),
						model.l2);
					if (_v20.a && (_v20.b.$ === 2)) {
						var processUid = _v20.b.a;
						return A4($author$project$Components$Referentiel$Fiche$Update$rendreLaLiaison, uid, processUid, reponse, model);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 58:
					var uid = msg.a;
					var ouverte = A2(
						$elm$core$Maybe$withDefault,
						model.Bk,
						A2(
							$elm$core$Maybe$map,
							function (relation) {
								return A2($author$project$Components$Referentiel$Fiche$Liaisons$ouvrirLaSuppression, relation, model.Bk);
							},
							A2($author$project$Components$Referentiel$Fiche$Update$relationDe, uid, model)));
					return _Utils_eq(ouverte.mW, model.Bk.mW) ? _Utils_Tuple2(model, _List_Nil) : _Utils_Tuple2(
						_Utils_update(
							model,
							{Bk: ouverte}),
						_List_fromArray(
							[
								$author$project$Components$Referentiel$Fiche$Update$PlacerFocus(
								$author$project$Components$Referentiel$Fiche$Liaisons$idDuRenoncement(ouverte))
							]));
				case 60:
					var geste = msg.a;
					return A2($author$project$Components$Referentiel$Fiche$Update$demanderUnGeste, geste, model);
				case 61:
					return $author$project$Components$Referentiel$Fiche$Update$confirmerLeGeste(model);
				case 62:
					return A2($author$project$Components$Referentiel$Fiche$Update$versLeDrawerDuCycle, $author$project$Components$Shared$Drawer$Update$Fermer, model);
				case 95:
					var drawerMsg = msg.a;
					return A2($author$project$Components$Referentiel$Fiche$Update$versLeDrawerDuCycle, drawerMsg, model);
				case 100:
					return $author$project$Components$Referentiel$Fiche$Update$ouvrirLEffacement(model);
				case 101:
					var uid = msg.a;
					var _v21 = A2($author$project$Components$Referentiel$Fiche$Update$ouvrirLEffacementDUnContact, uid, model);
					var ouvert = _v21.a;
					var effets = _v21.b;
					return $author$project$Components$Shared$Drawer$Model$estOuvert(ouvert.x9.kX) ? function (_v22) {
						var ferme = _v22.a;
						var rendu = _v22.b;
						return _Utils_Tuple2(
							ferme,
							_Utils_ap(rendu, effets));
					}(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$synchroniserLeDrawerDuContact,
							'',
							A2($author$project$Components$Referentiel$Fiche$Update$surLeContact, $author$project$Components$Referentiel$Fiche$Contacts$annuler, ouvert))) : _Utils_Tuple2(ouvert, effets);
				case 102:
					var uid = msg.a;
					var reponse = msg.b;
					if (!_Utils_eq(model.x9.v8, $elm$core$Maybe$Nothing)) {
						var _v23 = _Utils_Tuple2(
							_Utils_eq(
								model.kD,
								$elm$core$Maybe$Just(uid)),
							$author$project$Components$Referentiel$Fiche$Update$lireLesLiees(reponse));
						if (_v23.a) {
							if (!_v23.b.$) {
								var liees = _v23.b.a;
								return _Utils_Tuple2(
									A2(
										$author$project$Components$Referentiel$Fiche$Update$surLEffacement,
										function (etat) {
											return _Utils_update(
												etat,
												{gS: liees});
										},
										model),
									_List_Nil);
							} else {
								var refus = _v23.b.a;
								return _Utils_Tuple2(
									model,
									(refus.ri === 401) ? _List_fromArray(
										[$author$project$Components$Referentiel$Fiche$Update$Reconnecter]) : _List_Nil);
							}
						} else {
							return _Utils_Tuple2(model, _List_Nil);
						}
					} else {
						var _v24 = _Utils_Tuple2(
							_Utils_eq(
								model.kD,
								$elm$core$Maybe$Just(uid)),
							$author$project$Components$Referentiel$Fiche$Update$lireLApercu(reponse));
						if (_v24.a) {
							if (!_v24.b.$) {
								var apercu = _v24.b.a;
								return _Utils_Tuple2(
									A2(
										$author$project$Components$Referentiel$Fiche$Update$surLEffacement,
										function (etat) {
											return _Utils_update(
												etat,
												{
													tq: $elm$core$Maybe$Just(apercu)
												});
										},
										model),
									_List_Nil);
							} else {
								var refus = _v24.b.a;
								return _Utils_Tuple2(
									model,
									(refus.ri === 401) ? _List_fromArray(
										[$author$project$Components$Referentiel$Fiche$Update$Reconnecter]) : _List_Nil);
							}
						} else {
							return _Utils_Tuple2(model, _List_Nil);
						}
					}
				case 103:
					var code = msg.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLEffacement,
							function (etat) {
								return _Utils_update(
									etat,
									{
										cX: $author$project$Components$Referentiel$Fiche$Effacement$motifDeCode(code)
									});
							},
							model),
						_List_Nil);
				case 104:
					var texte = msg.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLEffacement,
							function (etat) {
								return _Utils_update(
									etat,
									{
										Gd: A2($elm$core$String$left, 600, texte)
									});
							},
							model),
						_List_Nil);
				case 105:
					var texte = msg.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLEffacement,
							function (etat) {
								return _Utils_update(
									etat,
									{hP: texte});
							},
							model),
						_List_Nil);
				case 106:
					return $author$project$Components$Referentiel$Fiche$Update$confirmerLEffacement(model);
				case 107:
					var drawerMsg = msg.a;
					return A2($author$project$Components$Referentiel$Fiche$Update$versLeDrawerDEffacement, drawerMsg, model);
				case 108:
					var uid = msg.a;
					var reponse = msg.b;
					var _v25 = _Utils_Tuple2(
						_Utils_eq(
							model.kD,
							$elm$core$Maybe$Just(uid)),
						model.l2);
					if (_v25.a && (_v25.b.$ === 2)) {
						var processUid = _v25.b.a;
						return A4($author$project$Components$Referentiel$Fiche$Update$rendreLEffacement, uid, processUid, reponse, model);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 109:
					return $author$project$Components$Referentiel$Fiche$Update$ouvrirLExport(model);
				case 110:
					var _v26 = model.gt;
					if (_v26.$ === 1) {
						var fiche = _v26.a;
						return _Utils_Tuple2(
							model,
							_List_fromArray(
								[
									A4($author$project$Components$Referentiel$Fiche$Update$OuvrirLaFusion, fiche.r8, fiche.g1, 'fusion-declencheur', fiche.G4)
								]));
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 111:
					var texte = msg.a;
					return A2($author$project$Components$Referentiel$Fiche$Update$saisirLaDateDExport, texte, model);
				case 97:
					var uid = msg.a;
					var demande = msg.b;
					var reponse = msg.c;
					return A4($author$project$Components$Referentiel$Fiche$Update$rendreLApercuDeLExport, uid, demande, reponse, model);
				case 112:
					var format = msg.a;
					var coche = msg.b;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLExport,
							function (etat) {
								switch (format) {
									case 'json':
										return _Utils_update(
											etat,
											{gO: coche});
									case 'csv':
										return _Utils_update(
											etat,
											{f3: coche});
									default:
										return etat;
								}
							},
							model),
						_List_Nil);
				case 113:
					return $author$project$Components$Referentiel$Fiche$Update$confirmerLExport(model);
				case 114:
					var drawerMsg = msg.a;
					return A2($author$project$Components$Referentiel$Fiche$Update$versLeDrawerDExport, drawerMsg, model);
				case 115:
					var uid = msg.a;
					var reponse = msg.b;
					var _v28 = _Utils_Tuple2(
						_Utils_eq(
							model.kD,
							$elm$core$Maybe$Just(uid)),
						model.l2);
					if (_v28.a && (_v28.b.$ === 2)) {
						var processUid = _v28.b.a;
						return A4($author$project$Components$Referentiel$Fiche$Update$rendreLExport, uid, processUid, reponse, model);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 99:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{rt: !model.rt}),
						_List_Nil);
				case 98:
					var cochee = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{vp: cochee}),
						_List_Nil);
				case 96:
					var uid = msg.a;
					var reponse = msg.b;
					var _v29 = _Utils_Tuple2(
						_Utils_eq(
							model.kD,
							$elm$core$Maybe$Just(uid)),
						A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$apercuDeLaClotureDecoder, reponse));
					if (_v29.a) {
						if (!_v29.b.$) {
							var apercu = _v29.b.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										ts: $elm$core$Maybe$Just(apercu)
									}),
								_List_Nil);
						} else {
							var refus = _v29.b.a;
							return _Utils_Tuple2(
								model,
								(refus.ri === 401) ? _List_fromArray(
									[$author$project$Components$Referentiel$Fiche$Update$Reconnecter]) : _List_Nil);
						}
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 63:
					var uid = msg.a;
					var reponse = msg.b;
					var _v30 = _Utils_Tuple2(
						_Utils_eq(
							model.kD,
							$elm$core$Maybe$Just(uid)),
						model.l2);
					if (_v30.a && (_v30.b.$ === 2)) {
						var processUid = _v30.b.a;
						return A4($author$project$Components$Referentiel$Fiche$Update$rendreLeGeste, uid, processUid, reponse, model);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 59:
					return _Utils_Tuple2(
						A2($author$project$Components$Referentiel$Fiche$Update$surLaLiaison, $author$project$Components$Referentiel$Fiche$Liaisons$annulerLaConfirmation, model),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Fiche$Update$PlacerFocus, $elm$core$List$singleton),
								$author$project$Components$Referentiel$Fiche$Liaisons$declencheurDeLaConfirmation(model.Bk))));
				case 64:
					var liens = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{GN: liens}),
						_List_Nil);
				case 65:
					var uid = msg.a;
					var _v31 = A2($author$project$Components$Referentiel$Fiche$Update$rattachementDe, uid, model);
					if (!_v31.$) {
						var rattachement = _v31.a;
						return $author$project$Components$Referentiel$Fiche$Update$lireLesPostes(
							A3(
								$author$project$Components$Referentiel$Fiche$Update$ouvrirLeDrawer,
								$author$project$Components$Referentiel$Fiche$Liaisons$idDuDeclencheurDeModification(uid),
								$author$project$Components$Referentiel$Fiche$Liaisons$ouvrirLaModification(rattachement),
								model));
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 66:
					var poste = msg.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLaLiaison,
							$author$project$Components$Referentiel$Fiche$Liaisons$setPoste(poste),
							model),
						_List_Nil);
				case 67:
					var intitule = msg.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLaLiaison,
							$author$project$Components$Referentiel$Fiche$Liaisons$setIntitule(intitule),
							model),
						_List_Nil);
				case 68:
					var principal = msg.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLaLiaison,
							$author$project$Components$Referentiel$Fiche$Liaisons$setPrincipal(principal),
							model),
						_List_Nil);
				case 69:
					var reponse = msg.a;
					var _v32 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$postesDecoder, reponse);
					if (!_v32.$) {
						var postes = _v32.a;
						return _Utils_Tuple2(
							A2(
								$author$project$Components$Referentiel$Fiche$Update$surLaLiaison,
								$author$project$Components$Referentiel$Fiche$Liaisons$setPostes(
									A2(
										$elm$core$List$map,
										function (poste) {
											return {
												Bl: $author$project$Components$Referentiel$Vocabulaire$libelleDuPoste(poste),
												r8: poste.r8
											};
										},
										postes)),
								model),
							_List_Nil);
					} else {
						var refus = _v32.a;
						return _Utils_Tuple2(
							model,
							(refus.ri === 401) ? _List_fromArray(
								[$author$project$Components$Referentiel$Fiche$Update$Reconnecter]) : _List_Nil);
					}
				case 71:
					var _v33 = $author$project$Components$Referentiel$Fiche$Update$contexteDuRattachement(model);
					if (!_v33.$) {
						var contexte = _v33.a;
						return $author$project$Components$Referentiel$Fiche$Update$lireLesPostes(
							A3(
								$author$project$Components$Referentiel$Fiche$Update$ouvrirLeDrawer,
								$author$project$Components$Referentiel$Fiche$Liaisons$idDuDeclencheurDeRattachement,
								$author$project$Components$Referentiel$Fiche$Liaisons$ouvrirLeRattachement(contexte),
								model));
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 72:
					var terme = msg.a;
					return $author$project$Components$Referentiel$Fiche$Update$attendre(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLaLiaison,
							$author$project$Components$Referentiel$Fiche$Liaisons$surLaRecherche(
								$author$project$Components$Referentiel$Common$RechercheDeFiche$setTerme(terme)),
							model));
				case 73:
					var saisie = msg.a;
					return A2($author$project$Components$Referentiel$Fiche$Update$chercher, saisie, model);
				case 74:
					var terme = msg.a;
					var reponse = msg.b;
					var _v34 = _Utils_Tuple2(
						A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$propositionsDecoder, reponse),
						$author$project$Components$Referentiel$Fiche$Liaisons$contexteDeLaRecherche(model.Bk));
					if (!_v34.a.$) {
						if (!_v34.b.$) {
							var liees = _v34.a.a;
							var contexte = _v34.b.a;
							return _Utils_Tuple2(
								A2(
									$author$project$Components$Referentiel$Fiche$Update$surLaLiaison,
									$author$project$Components$Referentiel$Fiche$Liaisons$surLaRecherche(
										A2(
											$author$project$Components$Referentiel$Common$RechercheDeFiche$recevoir,
											terme,
											A3(
												$author$project$Components$Referentiel$Common$RechercheDeFiche$propositions,
												contexte.fN,
												$elm$core$Maybe$Just(contexte.Et),
												liees))),
									model),
								_List_Nil);
						} else {
							return _Utils_Tuple2(model, _List_Nil);
						}
					} else {
						var refus = _v34.a.a;
						return _Utils_Tuple2(
							model,
							(refus.ri === 401) ? _List_fromArray(
								[$author$project$Components$Referentiel$Fiche$Update$Reconnecter]) : _List_Nil);
					}
				case 75:
					var uid = msg.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLaLiaison,
							$author$project$Components$Referentiel$Fiche$Liaisons$surLaRecherche(
								$author$project$Components$Referentiel$Common$RechercheDeFiche$choisir(uid)),
							model),
						_List_Nil);
				case 76:
					var departement = msg.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLaLiaison,
							$author$project$Components$Referentiel$Fiche$Liaisons$surLeRattachement(
								$author$project$Components$Referentiel$Fiche$Rattacher$setDepartement(departement)),
							model),
						_List_Nil);
				case 77:
					var debut = msg.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLaLiaison,
							$author$project$Components$Referentiel$Fiche$Liaisons$surLeRattachement(
								$author$project$Components$Referentiel$Fiche$Rattacher$setDebut(debut)),
							model),
						_List_Nil);
				case 78:
					var rang = msg.a;
					var valeur = msg.b;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLaLiaison,
							$author$project$Components$Referentiel$Fiche$Liaisons$surLeRattachement(
								A2($author$project$Components$Referentiel$Fiche$Rattacher$setValeurDuContact, rang, valeur)),
							model),
						_List_Nil);
				case 79:
					var rang = msg.a;
					var code = msg.b;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLaLiaison,
							$author$project$Components$Referentiel$Fiche$Liaisons$surLeRattachement(
								A2($author$project$Components$Referentiel$Fiche$Rattacher$setCanalDuContact, rang, code)),
							model),
						_List_Nil);
				case 80:
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLaLiaison,
							$author$project$Components$Referentiel$Fiche$Liaisons$surLeRattachement($author$project$Components$Referentiel$Fiche$Rattacher$ajouterUnContact),
							model),
						_List_Nil);
				case 81:
					var _v35 = $author$project$Components$Referentiel$Fiche$Update$contexteDeLaRelation(model);
					if (!_v35.$) {
						var contexte = _v35.a;
						return $author$project$Components$Referentiel$Fiche$Update$lireLesTypes(
							A3(
								$author$project$Components$Referentiel$Fiche$Update$ouvrirLeDrawer,
								$author$project$Components$Referentiel$Fiche$Liaisons$idDuDeclencheurDeRelation,
								$author$project$Components$Referentiel$Fiche$Liaisons$ouvrirLaRelation(contexte),
								model));
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 82:
					var phrase = msg.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLaLiaison,
							$author$project$Components$Referentiel$Fiche$Liaisons$setPhrase(phrase),
							model),
						_List_Nil);
				case 83:
					var reponse = msg.a;
					var _v36 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$typesDeRelationDecoder, reponse);
					if (!_v36.$) {
						var types = _v36.a;
						var lu = A2(
							$author$project$Components$Referentiel$Fiche$Update$surLaLiaison,
							$author$project$Components$Referentiel$Fiche$Liaisons$setTypes(types),
							model);
						return _Utils_Tuple2(
							_Utils_update(
								lu,
								{
									rY: A2(
										$elm$core$Maybe$andThen,
										$elm$core$Basics$identity,
										$elm$core$Result$toMaybe(
											A2($elm$json$Json$Decode$decodeString, $author$project$Components$Referentiel$Common$API$QueryAPIModel$typeEtablissementDecoder, reponse.f$)))
								}),
							_List_Nil);
					} else {
						var refus = _v36.a;
						return _Utils_Tuple2(
							model,
							(refus.ri === 401) ? _List_fromArray(
								[$author$project$Components$Referentiel$Fiche$Update$Reconnecter]) : _List_Nil);
					}
				case 84:
					return _Utils_Tuple2(
						model,
						function () {
							if ($author$project$Components$Referentiel$Fiche$Model$personneACreer(model)) {
								var _v37 = _Utils_Tuple2(
									$author$project$Components$Referentiel$Fiche$Liaisons$saisieDuRattachement(model.Bk),
									model.gt);
								if ((!_v37.a.$) && (_v37.b.$ === 1)) {
									var _v38 = _v37.a.a;
									var contexte = _v38.a;
									var fiche = _v37.b.a;
									return _List_fromArray(
										[
											A2(
											$author$project$Components$Referentiel$Fiche$Update$CreerUnePersonneRattachee,
											contexte.Et,
											A2($author$project$Components$Referentiel$Fiche$Model$nomDe, fiche.g1, fiche.dw))
										]);
								} else {
									return _List_Nil;
								}
							} else {
								return _List_Nil;
							}
						}());
				case 85:
					var famille = msg.a;
					return A2(
						$author$project$Components$Referentiel$Fiche$Update$filtrer,
						$author$project$Components$Referentiel$Fiche$Historique$choisirLaFamille(famille),
						model);
				case 86:
					var source = msg.a;
					return A2(
						$author$project$Components$Referentiel$Fiche$Update$filtrer,
						$author$project$Components$Referentiel$Fiche$Historique$choisirLaSource(source),
						model);
				case 87:
					return A2($author$project$Components$Referentiel$Fiche$Update$filtrer, $author$project$Components$Referentiel$Fiche$Historique$toutAfficher, model);
				case 88:
					var _v39 = _Utils_Tuple2(
						$author$project$Components$Referentiel$Fiche$Historique$demanderLaSuite(model.m6),
						model.kD);
					if ((!_v39.a.$) && (!_v39.b.$)) {
						var _v40 = _v39.a.a;
						var historique = _v40.a;
						var lien = _v40.b;
						var uid = _v39.b.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{m6: historique}),
							_List_fromArray(
								[
									A3($author$project$Components$Referentiel$Fiche$Update$LireLaChronologie, uid, historique.np, lien)
								]));
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 89:
					return _Utils_Tuple2(
						model,
						_List_fromArray(
							[$author$project$Components$Referentiel$Fiche$Update$LireLeDefilement]));
				case 90:
					var defilement = msg.a;
					if (((defilement.Ae - defilement.Ad) - defilement.KR) < 240) {
						var $temp$msg = $author$project$Components$Referentiel$Fiche$Update$SuiteDeLaChronologieDemandee,
							$temp$model = model;
						msg = $temp$msg;
						model = $temp$model;
						continue update;
					} else {
						return _Utils_Tuple2(
							A2($author$project$Components$Referentiel$Fiche$Update$surLHistorique, $author$project$Components$Referentiel$Fiche$Historique$quitterLeBas, model),
							_List_Nil);
					}
				case 91:
					var uid = msg.a;
					var numero = msg.b;
					var reponse = msg.c;
					if ((!_Utils_eq(
						model.kD,
						$elm$core$Maybe$Just(uid))) || (!_Utils_eq(numero, model.m6.np))) {
						return _Utils_Tuple2(model, _List_Nil);
					} else {
						var _v41 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$chronologieDecoder, reponse);
						if (!_v41.$) {
							var vue = _v41.a;
							return _Utils_Tuple2(
								A2(
									$author$project$Components$Referentiel$Fiche$Update$surLHistorique,
									A2(
										$author$project$Components$Referentiel$Fiche$Historique$recevoir,
										numero,
										A2($author$project$Components$Referentiel$Fiche$API$ToModel$chronologie, model.hd, vue)),
									model),
								_List_Nil);
						} else {
							var refus = _v41.a;
							return (refus.ri === 401) ? _Utils_Tuple2(
								model,
								_List_fromArray(
									[$author$project$Components$Referentiel$Fiche$Update$Reconnecter])) : ((refus.ri === 404) ? _Utils_Tuple2(
								_Utils_update(
									model,
									{gt: $author$project$Components$Referentiel$Fiche$Model$Introuvable}),
								_List_Nil) : _Utils_Tuple2(
								A2(
									$author$project$Components$Referentiel$Fiche$Update$surLHistorique,
									$author$project$Components$Referentiel$Fiche$Historique$echouer(numero),
									model),
								_List_Nil));
						}
					}
				case 92:
					var champ = msg.a;
					var declencheur = msg.b;
					return A3($author$project$Components$Referentiel$Fiche$Update$ouvrirLHistoriqueDuChamp, champ, declencheur, model);
				case 93:
					var uid = msg.a;
					var numero = msg.b;
					var reponse = msg.c;
					if (!_Utils_eq(
						model.kD,
						$elm$core$Maybe$Just(uid))) {
						return _Utils_Tuple2(model, _List_Nil);
					} else {
						var _v42 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fiche$API$QueryAPIModel$historiqueDuChampDecoder, reponse);
						if (!_v42.$) {
							var vue = _v42.a;
							return _Utils_Tuple2(
								A2(
									$author$project$Components$Referentiel$Fiche$Update$surLHistorique,
									A2(
										$author$project$Components$Referentiel$Fiche$Historique$recevoirLePanneau,
										numero,
										A2($author$project$Components$Referentiel$Fiche$API$ToModel$historiqueDuChamp, model.hd, vue)),
									model),
								_List_Nil);
						} else {
							var refus = _v42.a;
							return (refus.ri === 404) ? _Utils_Tuple2(
								A2(
									$author$project$Components$Referentiel$Fiche$Update$surLHistorique,
									$author$project$Components$Referentiel$Fiche$Historique$panneauIntrouvable(numero),
									model),
								_List_Nil) : _Utils_Tuple2(
								A2(
									$author$project$Components$Referentiel$Fiche$Update$surLHistorique,
									$author$project$Components$Referentiel$Fiche$Historique$echouerLePanneau(numero),
									model),
								(refus.ri === 401) ? _List_fromArray(
									[$author$project$Components$Referentiel$Fiche$Update$Reconnecter]) : _List_Nil);
						}
					}
				case 94:
					var drawerMsg = msg.a;
					return A2($author$project$Components$Referentiel$Fiche$Update$surLeDrawerDeLHistorique, drawerMsg, model);
				case 116:
					var type_ = msg.a;
					var declencheur = msg.b;
					return A3($author$project$Components$Referentiel$Fiche$Update$ouvrirLeBloc, type_, declencheur, model);
				case 127:
					var geste = msg.a;
					return A2($author$project$Components$Referentiel$Fiche$Update$surLeLien, geste, model);
				case 117:
					if (msg.a.$ === 2) {
						var cle = msg.a.a;
						return A2($author$project$Components$Referentiel$Fiche$Update$ouvrirUnLien, cle, model);
					} else {
						var geste = msg.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									jq: A2(
										$elm$core$Maybe$map,
										function (bloc) {
											return _Utils_update(
												bloc,
												{
													hP: A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$saisir, geste, bloc.hP)
												});
										},
										model.jq)
								}),
							_List_Nil);
					}
				case 118:
					return $author$project$Components$Referentiel$Fiche$Update$validerLeBloc(model);
				case 119:
					var uid = msg.a;
					var reponse = msg.b;
					var _v43 = _Utils_Tuple2(
						_Utils_eq(
							model.kD,
							$elm$core$Maybe$Just(uid)),
						model.l2);
					if (_v43.a && (_v43.b.$ === 2)) {
						var processUid = _v43.b.a;
						return A4($author$project$Components$Referentiel$Fiche$Update$rendreLeBloc, uid, processUid, reponse, model);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 126:
					var drawerMsg = msg.a;
					return A2($author$project$Components$Referentiel$Fiche$Update$surLeDrawerDuBloc, drawerMsg, model);
				case 120:
					var type_ = msg.a;
					var champ = msg.b;
					var uid = msg.c;
					return A4($author$project$Components$Referentiel$Fiche$Update$ouvrirUneOccurrence, type_, champ, uid, model);
				case 121:
					var geste = msg.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$surLesOccurrences,
							function (etat) {
								return _Utils_update(
									etat,
									{
										Et: A2(
											$elm$core$Maybe$map,
											function (ouverte) {
												return _Utils_update(
													ouverte,
													{
														uw: A2($author$project$Components$Shared$EditeurDeSchema$Groupe$saisir, geste, ouverte.uw)
													});
											},
											etat.Et)
									});
							},
							model),
						_List_Nil);
				case 122:
					var type_ = msg.a;
					var champ = msg.b;
					var uid = msg.c;
					return A4($author$project$Components$Referentiel$Fiche$Update$demanderLeRetraitDUneOccurrence, type_, champ, uid, model);
				case 123:
					return $author$project$Components$Referentiel$Fiche$Update$validerUneOccurrence(model);
				case 124:
					var uid = msg.a;
					var reponse = msg.b;
					var _v44 = _Utils_Tuple2(
						_Utils_eq(
							model.kD,
							$elm$core$Maybe$Just(uid)),
						model.l2);
					if (_v44.a && (_v44.b.$ === 2)) {
						var processUid = _v44.b.a;
						return A4($author$project$Components$Referentiel$Fiche$Update$rendreUneOccurrence, uid, processUid, reponse, model);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				default:
					var drawerMsg = msg.a;
					return A2($author$project$Components$Referentiel$Fiche$Update$surLeDrawerDeLOccurrence, drawerMsg, model);
			}
		}
	});
var $author$project$Components$Referentiel$Fusion$Effet$DemanderProcessUid = {$: 0};
var $author$project$Components$Referentiel$Fusion$Effet$FusionTerminee = {$: 8};
var $author$project$Components$Referentiel$Fusion$Model$Illisible = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Fusion$Model$Interrompue = {$: 2};
var $author$project$Components$Referentiel$Fusion$Effet$Naviguer = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Referentiel$Fusion$Effet$PlacerFocus = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Referentiel$Fusion$Effet$Reconnecter = {$: 10};
var $author$project$Components$Referentiel$Fusion$Model$Refusee = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Referentiel$Fusion$API$QueryAPIModel$ApercuAPIView = F5(
	function (plusAncienne, echeanceDeLaFiche, echeanceDeLAutre, consentements, echeanceRetenue) {
		return {v4: consentements, xZ: echeanceDeLAutre, x_: echeanceDeLaFiche, x$: echeanceRetenue, FR: plusAncienne};
	});
var $author$project$Components$Referentiel$Fusion$API$QueryAPIModel$ConsentementAPIView = F5(
	function (canal, valeur, fiche, autre, retenu) {
		return {t3: autre, uF: canal, zo: fiche, HY: retenu, fm: valeur};
	});
var $author$project$Components$Referentiel$Fusion$API$QueryAPIModel$consentement = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'retenu',
	$elm$json$Json$Decode$bool,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'autre',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$bool),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'fiche',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$bool),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'valeur',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'canal',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fusion$API$QueryAPIModel$ConsentementAPIView))))));
var $author$project$Components$Referentiel$Fusion$API$QueryAPIModel$apercuDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'echeanceRetenue',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'consentements',
		$elm$json$Json$Decode$list($author$project$Components$Referentiel$Fusion$API$QueryAPIModel$consentement),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
			_List_fromArray(
				['autre', 'echeanceDeConservation']),
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
				_List_fromArray(
					['fiche', 'echeanceDeConservation']),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'plusAncienne',
					$author$project$Components$Referentiel$Identifiants$entiteUidDecoder,
					$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fusion$API$QueryAPIModel$ApercuAPIView))))));
var $author$project$Components$Referentiel$Fusion$API$QueryAPIModel$AvancementAPIView = F2(
	function (etapes, terminee) {
		return {yL: etapes, Jv: terminee};
	});
var $author$project$Components$Referentiel$Fusion$API$QueryAPIModel$avancementDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Referentiel$Fusion$API$QueryAPIModel$AvancementAPIView,
	A2(
		$elm$json$Json$Decode$field,
		'etapes',
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				F2(
					function (code, faite) {
						return {vx: code, zg: faite};
					}),
				A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'faite', $elm$json$Json$Decode$bool)))),
	A2($elm$json$Json$Decode$field, 'terminee', $elm$json$Json$Decode$bool));
var $author$project$Components$Referentiel$Fusion$Model$AutreNature = {$: 0};
var $author$project$Components$Referentiel$Fusion$Model$DejaFusionnee = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Referentiel$Fusion$Model$RefusClose = {$: 2};
var $author$project$Components$Referentiel$Fusion$Model$RefusEffacee = {$: 4};
var $author$project$Components$Referentiel$Fusion$Model$RefusSupprimee = {$: 3};
var $author$project$Components$Referentiel$Fusion$Model$SocieteEtEtablissement = {$: 1};
var $author$project$Components$Referentiel$Fusion$Model$candidates = F2(
	function (ouverte, resultats) {
		var refusDe = function (resultat) {
			var _v1 = _Utils_Tuple2(resultat.z0, resultat.pZ);
			_v1$6:
			while (true) {
				if (_v1.a) {
					return $elm$core$Maybe$Nothing;
				} else {
					if (!_v1.b.$) {
						switch (_v1.b.a) {
							case 'AutreNature':
								return $elm$core$Maybe$Just($author$project$Components$Referentiel$Fusion$Model$AutreNature);
							case 'SocieteEtEtablissement':
								return $elm$core$Maybe$Just($author$project$Components$Referentiel$Fusion$Model$SocieteEtEtablissement);
							case 'Close':
								return $elm$core$Maybe$Just($author$project$Components$Referentiel$Fusion$Model$RefusClose);
							case 'Supprimee':
								return $elm$core$Maybe$Just($author$project$Components$Referentiel$Fusion$Model$RefusSupprimee);
							case 'DejaAbsorbee':
								return $elm$core$Maybe$Just(
									$author$project$Components$Referentiel$Fusion$Model$DejaFusionnee(
										A2(
											$elm$core$Maybe$map,
											$author$project$Components$Referentiel$Common$RechercheDeFiche$nomDe,
											A2(
												$elm$core$Maybe$andThen,
												function ($) {
													return $.zo;
												},
												resultat.z1))));
							default:
								break _v1$6;
						}
					} else {
						break _v1$6;
					}
				}
			}
			return $elm$core$Maybe$Just($author$project$Components$Referentiel$Fusion$Model$RefusEffacee);
		};
		var natureDe = function (liee) {
			var _v0 = liee.Av;
			if (!_v0.$) {
				return 0;
			} else {
				return 1;
			}
		};
		return A2(
			$elm$core$List$map,
			function (resultat) {
				return {
					wn: resultat.wn,
					gt: resultat.zo.gt,
					g1: natureDe(resultat.zo),
					Dj: $author$project$Components$Referentiel$Common$RechercheDeFiche$nomDe(resultat.zo),
					ho: resultat.ho,
					pZ: refusDe(resultat),
					r8: resultat.zo.r8
				};
			},
			A2(
				$elm$core$List$filter,
				function (resultat) {
					return !_Utils_eq(resultat.zo.r8, ouverte);
				},
				resultats));
	});
var $author$project$Components$Referentiel$Fusion$Update$deposer = F3(
	function (place, lecture, model) {
		if (!place) {
			return _Utils_update(
				model,
				{Gf: lecture});
		} else {
			return _Utils_update(
				model,
				{Iv: lecture});
		}
	});
var $author$project$Components$Referentiel$Fusion$Model$EnCours = {$: 1};
var $author$project$Components$Referentiel$Fusion$Model$autre = function (place) {
	if (!place) {
		return 1;
	} else {
		return 0;
	}
};
var $author$project$Components$Referentiel$Fusion$Model$lue = F2(
	function (place, model) {
		var _v0 = _Utils_Tuple3(place, model.Gf, model.Iv);
		_v0$2:
		while (true) {
			if (!_v0.a) {
				if (_v0.b.$ === 1) {
					var _v1 = _v0.a;
					var fiche = _v0.b.a;
					return $elm$core$Maybe$Just(fiche);
				} else {
					break _v0$2;
				}
			} else {
				if (_v0.c.$ === 1) {
					var _v2 = _v0.a;
					var fiche = _v0.c.a;
					return $elm$core$Maybe$Just(fiche);
				} else {
					break _v0$2;
				}
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Components$Referentiel$Fusion$Model$absorbee = function (model) {
	return A2(
		$author$project$Components$Referentiel$Fusion$Model$lue,
		$author$project$Components$Referentiel$Fusion$Model$autre(model.z5),
		model);
};
var $author$project$Components$Referentiel$Fusion$Model$priseSurAbsorbee = F2(
	function (choix, ligne) {
		return (_Utils_eq(ligne.z5, ligne.sK) || ((!ligne.g_) || _Utils_eq(ligne.sK, $elm$core$Maybe$Nothing))) ? false : A2(
			$elm$core$Maybe$withDefault,
			_Utils_eq(ligne.z5, $elm$core$Maybe$Nothing),
			A2($elm$core$Dict$get, ligne.dy, choix));
	});
var $author$project$Components$Referentiel$Fusion$Model$champsPris = F2(
	function (choix, lignes) {
		return A2(
			$elm$core$List$map,
			function ($) {
				return $.dy;
			},
			A2(
				$elm$core$List$filter,
				$author$project$Components$Referentiel$Fusion$Model$priseSurAbsorbee(choix),
				lignes));
	});
var $author$project$Components$Referentiel$Fusion$Model$gardee = function (model) {
	return A2($author$project$Components$Referentiel$Fusion$Model$lue, model.z5, model);
};
var $author$project$Components$Referentiel$Fusion$Update$lienDeFusion = function (model) {
	var _v0 = model.Gf;
	if (_v0.$ === 1) {
		var fiche = _v0.a;
		return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$fusionner, fiche.nQ.h0);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Fusion$Model$lignesDeChamps = F2(
	function (gardeeFiche, absorbeeFiche) {
		var valeurs = function (fiche) {
			var _v1 = fiche.Av;
			if (!_v1.$) {
				var p = _v1.a;
				return _List_fromArray(
					[
						_Utils_Tuple2('civilite', p.vh),
						_Utils_Tuple2('prenom', p.Gg),
						_Utils_Tuple2('nom', p.Dj),
						_Utils_Tuple2('pays', fiche.ho),
						_Utils_Tuple2('langue', fiche.nn)
					]);
			} else {
				var o = _v1.a;
				return _List_fromArray(
					[
						_Utils_Tuple2('raisonSociale', o.GR),
						_Utils_Tuple2('pays', fiche.ho),
						_Utils_Tuple2('langue', fiche.nn)
					]);
			}
		};
		var deLAbsorbee = $elm$core$Dict$fromList(
			valeurs(absorbeeFiche));
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var champ = _v0.a;
				var valeur = _v0.b;
				return {
					sK: A2(
						$elm$core$Maybe$andThen,
						$elm$core$Basics$identity,
						A2($elm$core$Dict$get, champ, deLAbsorbee)),
					dy: 'crm.entite.' + champ,
					z5: valeur,
					g_: A2($elm$core$List$member, 'crm.entite.' + champ, gardeeFiche.u_)
				};
			},
			valeurs(gardeeFiche));
	});
var $author$project$Components$Referentiel$Fusion$Update$envoyer = function (model) {
	var _v0 = _Utils_Tuple2(
		_Utils_Tuple3(
			model.l2,
			model.z$,
			$author$project$Components$Referentiel$Fusion$Update$lienDeFusion(model)),
		_Utils_Tuple2(
			$author$project$Components$Referentiel$Fusion$Model$gardee(model),
			$author$project$Components$Referentiel$Fusion$Model$absorbee(model)));
	if (_v0.a.a.$ === 1) {
		var _v1 = _v0.a;
		var _v2 = _v1.a;
		return _Utils_Tuple2(model, _List_Nil);
	} else {
		if ((((!_v0.a.b.$) && (!_v0.a.c.$)) && (!_v0.b.a.$)) && (!_v0.b.b.$)) {
			var _v3 = _v0.a;
			var fusion = _v3.b.a;
			var lien = _v3.c.a;
			var _v4 = _v0.b;
			var gardeeFiche = _v4.a.a;
			var absorbeeFiche = _v4.b.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: $author$project$Components$Referentiel$Fusion$Model$EnCours}),
				_List_fromArray(
					[
						A2(
						$author$project$Components$Referentiel$Fusion$Effet$Fusionner,
						lien,
						{
							sK: absorbeeFiche.r8,
							dw: A2(
								$author$project$Components$Referentiel$Fusion$Model$champsPris,
								model.jN,
								A2($author$project$Components$Referentiel$Fusion$Model$lignesDeChamps, gardeeFiche, absorbeeFiche)),
							z$: fusion,
							z5: gardeeFiche.r8
						})
					]));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	}
};
var $author$project$API$NavLinksDictionary$apercuDeLaFusion = 'apercu-de-la-fusion';
var $author$project$Components$Referentiel$Fusion$Update$lireLApercu = function (model) {
	var _v0 = _Utils_Tuple3(model.Gf, model.Iv, model.tq);
	if (((_v0.a.$ === 1) && (_v0.b.$ === 1)) && (_v0.c.$ === 1)) {
		var premiere = _v0.a.a;
		var seconde = _v0.b.a;
		var _v1 = _v0.c;
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Fusion$Effet$LireLApercu, $elm$core$List$singleton),
				A2(
					$elm$core$Maybe$andThen,
					$author$project$API$Liens$resoudre(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'autre',
								$author$project$Components$Referentiel$Identifiants$entiteUidToString(seconde.r8))
							])),
					A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$apercuDeLaFusion, premiere.nQ.gF))));
	} else {
		return _List_Nil;
	}
};
var $author$project$API$NavLinksDictionary$avancementDeLaFusion = 'avancement-de-la-fusion';
var $author$project$Components$Referentiel$Fusion$Update$lireLAvancement = function (model) {
	var _v0 = _Utils_Tuple2(model.Gf, model.z$);
	if ((_v0.a.$ === 1) && (!_v0.b.$)) {
		var premiere = _v0.a.a;
		var fusion = _v0.b.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Components$Referentiel$Fusion$Effet$LireLAvancement,
			A2(
				$elm$core$Maybe$andThen,
				$author$project$API$Liens$resoudre(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'fusion',
							$author$project$API$ProcessUid$toString(fusion))
						])),
				A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$avancementDeLaFusion, premiere.nQ.gF)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Fusion$Model$Lue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Fusion$Update$lue = F3(
	function (place, fiche, model) {
		return A3(
			$author$project$Components$Referentiel$Fusion$Update$deposer,
			place,
			$author$project$Components$Referentiel$Fusion$Model$Lue(fiche),
			model);
	});
var $author$project$Components$Referentiel$Fusion$Update$numero = function (place) {
	if (!place) {
		return 1;
	} else {
		return 2;
	}
};
var $author$project$Components$Referentiel$Fusion$Model$pleinePage = F4(
	function (premiere, seconde, gabarits, model) {
		return _Utils_update(
			$author$project$Components$Referentiel$Fusion$Model$init,
			{
				z$: model.z$,
				gF: gabarits,
				hd: model.hd,
				$8: $elm$core$Maybe$Just(premiere),
				fj: $elm$core$Maybe$Just(seconde),
				im: model.im
			});
	});
var $author$project$Components$Referentiel$Fusion$Model$plusAncienne = function (model) {
	var _v0 = _Utils_Tuple2(model.tq, model.fj);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var apercu = _v0.a.a;
		var seconde = _v0.b.a;
		return _Utils_eq(apercu.FR, seconde) ? 1 : 0;
	} else {
		return 0;
	}
};
var $author$project$Components$Referentiel$Fusion$Update$relireLesDeuxFiches = function (model) {
	var _v0 = _Utils_Tuple2(model.Gf, model.Iv);
	if ((_v0.a.$ === 1) && (_v0.b.$ === 1)) {
		var premiere = _v0.a.a;
		var seconde = _v0.b.a;
		return A2(
			$elm$core$List$filterMap,
			function (_v1) {
				var place = _v1.a;
				var uid = _v1.b;
				return A2(
					$elm$core$Maybe$map,
					$author$project$Components$Referentiel$Fusion$Effet$LireFiche(
						$author$project$Components$Referentiel$Fusion$Update$numero(place)),
					A2($author$project$Components$Referentiel$Liens$versEntite, uid, model.gF));
			},
			_List_fromArray(
				[
					_Utils_Tuple2(0, premiere.r8),
					_Utils_Tuple2(1, seconde.r8)
				]));
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Referentiel$Fusion$API$QueryAPIModel$ResultatAPIView = F6(
	function (fiche, pays, creeeLe, fusionnable, refus, fusionneeDans) {
		return {wn: creeeLe, zo: fiche, z0: fusionnable, z1: fusionneeDans, ho: pays, pZ: refus};
	});
var $author$project$Components$Referentiel$Fusion$API$QueryAPIModel$resultat = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'fusionneeDans',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Referentiel$Common$API$QueryAPIModel$fusionDecoder),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'refus',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'fusionnable',
			$elm$json$Json$Decode$bool,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
				_List_fromArray(
					['fiche', 'creeeLe']),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
					_List_fromArray(
						['fiche', 'pays']),
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'fiche',
						$author$project$Components$Referentiel$Common$API$QueryAPIModel$ficheLieeDecoder,
						$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Fusion$API$QueryAPIModel$ResultatAPIView)))))));
var $author$project$Components$Referentiel$Fusion$API$QueryAPIModel$resultatsDecoder = A2(
	$elm$json$Json$Decode$field,
	'resultats',
	$elm$json$Json$Decode$list($author$project$Components$Referentiel$Fusion$API$QueryAPIModel$resultat));
var $author$project$Components$Referentiel$Fusion$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var gabarits = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gF: gabarits}),
					_List_Nil);
			case 1:
				var uid = msg.a;
				var nature = msg.b;
				var declencheur = msg.c;
				var recherche = msg.d;
				var _v1 = A3(
					$author$project$Components$Shared$Drawer$Update$update,
					{Il: false},
					$author$project$Components$Shared$Drawer$Update$Ouvrir(declencheur),
					model.im);
				var volet = _v1.a;
				var effets = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ve: $elm$core$Maybe$Nothing,
							Gw: _List_Nil,
							G3: recherche,
							IR: $elm$core$Maybe$Just(
								{g1: nature, r8: uid}),
							h3: '',
							im: volet
						}),
					A2(
						$elm$core$List$map,
						function (_v2) {
							var cible = _v2;
							return $author$project$Components$Referentiel$Fusion$Effet$PlacerFocus(cible);
						},
						effets));
			case 2:
				var drawerMsg = msg.a;
				var _v3 = A3(
					$author$project$Components$Shared$Drawer$Update$update,
					{Il: false},
					drawerMsg,
					model.im);
				var volet = _v3.a;
				var effets = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: volet}),
					A2(
						$elm$core$List$map,
						function (_v4) {
							var cible = _v4;
							return $author$project$Components$Referentiel$Fusion$Effet$PlacerFocus(cible);
						},
						effets));
			case 3:
				var terme = msg.a;
				var saisie = model.hP + 1;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ve: $elm$core$Maybe$Nothing, Gw: _List_Nil, hP: saisie, h3: terme}),
					($elm$core$String$length(
						$elm$core$String$trim(terme)) >= 2) ? _List_fromArray(
						[
							A2($author$project$Components$Referentiel$Fusion$Effet$AttendreAvantDeChercher, saisie, $author$project$Components$Referentiel$Common$RechercheDeFiche$delaiMs)
						]) : _List_Nil);
			case 4:
				var saisie = msg.a;
				var _v5 = _Utils_Tuple2(
					_Utils_eq(saisie, model.hP),
					model.G3);
				if (_v5.a && (!_v5.b.$)) {
					var lien = _v5.b.a;
					return _Utils_Tuple2(
						model,
						_List_fromArray(
							[
								A2(
								$author$project$Components$Referentiel$Fusion$Effet$ChercherDesFiches,
								lien,
								$elm$core$String$trim(model.h3))
							]));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 5:
				var terme = msg.a;
				var reponse = msg.b;
				var _v6 = _Utils_Tuple2(
					A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fusion$API$QueryAPIModel$resultatsDecoder, reponse),
					model.IR);
				if (!_v6.a.$) {
					if (!_v6.b.$) {
						var resultats = _v6.a.a;
						var source = _v6.b.a;
						return _Utils_eq(
							$elm$core$String$trim(model.h3),
							terme) ? _Utils_Tuple2(
							_Utils_update(
								model,
								{
									Gw: A2($author$project$Components$Referentiel$Fusion$Model$candidates, source.r8, resultats)
								}),
							_List_Nil) : _Utils_Tuple2(model, _List_Nil);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				} else {
					var refus = _v6.a.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Referentiel$Fusion$Effet$Reconnecter]) : _List_Nil);
				}
			case 6:
				var uid = msg.a;
				return A2(
					$elm$core$List$any,
					function (c) {
						return _Utils_eq(c.r8, uid) && _Utils_eq(c.pZ, $elm$core$Maybe$Nothing);
					},
					model.Gw) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ve: $elm$core$Maybe$Just(uid)
						}),
					_List_Nil) : _Utils_Tuple2(model, _List_Nil);
			case 7:
				var _v7 = _Utils_Tuple2(model.IR, model.ve);
				if ((!_v7.a.$) && (!_v7.b.$)) {
					var source = _v7.a.a;
					var autre = _v7.b.a;
					var _v8 = A3(
						$author$project$Components$Shared$Drawer$Update$update,
						{Il: false},
						$author$project$Components$Shared$Drawer$Update$Fermer,
						model.im);
					var volet = _v8.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{im: volet}),
						_List_fromArray(
							[
								$author$project$Components$Referentiel$Fusion$Effet$Naviguer(
								$author$project$Routes$Route$toString(
									A2($author$project$Routes$Route$FusionDeFiches, source.r8, autre)))
							]));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 8:
				var premiere = msg.a;
				var seconde = msg.b;
				var gabarits = msg.c;
				var ouverte = A4($author$project$Components$Referentiel$Fusion$Model$pleinePage, premiere, seconde, gabarits, model);
				var lire = F2(
					function (place, uid) {
						return A2(
							$elm$core$Maybe$map,
							$author$project$Components$Referentiel$Fusion$Effet$LireFiche(
								$author$project$Components$Referentiel$Fusion$Update$numero(place)),
							A2($author$project$Components$Referentiel$Liens$versEntite, uid, gabarits));
					});
				return _Utils_Tuple2(
					ouverte,
					_Utils_ap(
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									A2(lire, 0, premiere),
									A2(lire, 1, seconde)
								])),
						_Utils_eq(model.z$, $elm$core$Maybe$Nothing) ? _List_fromArray(
							[$author$project$Components$Referentiel$Fusion$Effet$DemanderProcessUid]) : _List_Nil));
			case 9:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							z$: $author$project$API$ProcessUid$depuisOctets(octets)
						}),
					_List_Nil);
			case 10:
				var place = msg.a;
				var reponse = msg.b;
				var _v9 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$API$QueryAPIModel$ficheDecoder, reponse);
				if (!_v9.$) {
					var fiche = _v9.a;
					var deposee = A3($author$project$Components$Referentiel$Fusion$Update$lue, place, fiche, model);
					return _Utils_Tuple2(
						deposee,
						$author$project$Components$Referentiel$Fusion$Update$lireLApercu(deposee));
				} else {
					var refus = _v9.a;
					return (refus.ri === 401) ? _Utils_Tuple2(
						model,
						_List_fromArray(
							[$author$project$Components$Referentiel$Fusion$Effet$Reconnecter])) : _Utils_Tuple2(
						A3(
							$author$project$Components$Referentiel$Fusion$Update$deposer,
							place,
							$author$project$Components$Referentiel$Fusion$Model$Illisible(refus.ri),
							model),
						_List_Nil);
				}
			case 11:
				var reponse = msg.a;
				var _v10 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fusion$API$QueryAPIModel$apercuDecoder, reponse);
				if (!_v10.$) {
					var apercu = _v10.a;
					var avecApercu = _Utils_update(
						model,
						{
							tq: $elm$core$Maybe$Just(apercu)
						});
					return _Utils_Tuple2(
						model.mU ? avecApercu : _Utils_update(
							avecApercu,
							{
								z5: $author$project$Components$Referentiel$Fusion$Model$plusAncienne(avecApercu)
							}),
						_List_Nil);
				} else {
					var refus = _v10.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Referentiel$Fusion$Effet$Reconnecter]) : _List_Nil);
				}
			case 12:
				var reponse = msg.a;
				var _v11 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Fusion$API$QueryAPIModel$avancementDecoder, reponse);
				if (!_v11.$) {
					var avancement = _v11.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ua: $elm$core$Maybe$Just(avancement)
							}),
						_List_Nil);
				} else {
					var refus = _v11.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Referentiel$Fusion$Effet$Reconnecter]) : _List_Nil);
				}
			case 13:
				var place = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{jN: $elm$core$Dict$empty, z5: place, mU: true}),
					_List_Nil);
			case 14:
				var cle = msg.a;
				var absorbee = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jN: A3($elm$core$Dict$insert, cle, absorbee, model.jN)
						}),
					_List_Nil);
			case 15:
				var etape = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{me: etape}),
					_List_Nil);
			case 16:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{j6: true}),
					_List_fromArray(
						[
							$author$project$Components$Referentiel$Fusion$Effet$PlacerFocus('confirmation-fusion-renoncer')
						]));
			case 17:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{j6: false}),
					_List_Nil);
			case 18:
				return $author$project$Components$Referentiel$Fusion$Update$envoyer(model);
			default:
				var reponse = msg.a;
				var _v12 = A2(
					$author$project$API$Reponse$lire,
					$elm$json$Json$Decode$succeed(0),
					reponse);
				if (!_v12.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{j6: false, l2: $author$project$Components$Referentiel$Fusion$Model$Libre}),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (fiche) {
									return _List_fromArray(
										[
											$author$project$Components$Referentiel$Fusion$Effet$FusionTerminee,
											$author$project$Components$Referentiel$Fusion$Effet$Naviguer(
											$author$project$Routes$Route$toString(
												A2($author$project$Routes$Route$Fiche, fiche.r8, 0)))
										]);
								},
								$author$project$Components$Referentiel$Fusion$Model$gardee(model))));
				} else {
					var refus = _v12.a;
					return (refus.ri === 401) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{j6: false, l2: $author$project$Components$Referentiel$Fusion$Model$Libre}),
						_List_fromArray(
							[$author$project$Components$Referentiel$Fusion$Effet$Reconnecter])) : (A2(
						$elm$core$List$member,
						refus.ri,
						_List_fromArray(
							[400, 403, 404, 409, 410, 422])) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{
								j6: false,
								l2: $author$project$Components$Referentiel$Fusion$Model$Refusee(refus.ri),
								z$: $elm$core$Maybe$Nothing
							}),
						A2(
							$elm$core$List$cons,
							$author$project$Components$Referentiel$Fusion$Effet$DemanderProcessUid,
							$author$project$Components$Referentiel$Fusion$Update$relireLesDeuxFiches(model))) : _Utils_Tuple2(
						_Utils_update(
							model,
							{j6: false, l2: $author$project$Components$Referentiel$Fusion$Model$Interrompue}),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								$elm$core$List$singleton,
								$author$project$Components$Referentiel$Fusion$Update$lireLAvancement(model)))));
				}
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$AttendreAvantDeChercherLesDoublons = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$estVide = function (criteres) {
	return _Utils_eq(criteres, $author$project$Components$Referentiel$NouvelleFiche$Doublons$aucunCritere);
};
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$apresLaSaisie = F2(
	function (criteres, doublons) {
		return (_Utils_eq(doublons.nB, $elm$core$Maybe$Nothing) || _Utils_eq(criteres, doublons.aU)) ? _Utils_Tuple2(doublons, $elm$core$Maybe$Nothing) : ($author$project$Components$Referentiel$NouvelleFiche$Doublons$estVide(criteres) ? _Utils_Tuple2(
			_Utils_update(
				doublons,
				{jy: _List_Nil, aU: criteres, a0: false, bb: $elm$core$Maybe$Nothing, hP: doublons.hP + 1, b4: _List_Nil}),
			$elm$core$Maybe$Nothing) : _Utils_Tuple2(
			_Utils_update(
				doublons,
				{aU: criteres, hP: doublons.hP + 1}),
			$elm$core$Maybe$Just(doublons.hP + 1)));
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$Organisation = 1;
var $author$project$Components$Referentiel$NouvelleFiche$Model$identifiantLegalCherche = function (saisie) {
	var valeur = $elm$core$String$trim(saisie.m7);
	var chiffres = A2($elm$core$String$filter, $elm$core$Char$isDigit, valeur);
	return ((saisie.g1 !== 1) || ((saisie.ho === '') || (valeur === ''))) ? $elm$core$Maybe$Nothing : (((saisie.ho === 'FR') && (!A2(
		$elm$core$List$member,
		$elm$core$String$length(chiffres),
		_List_fromArray(
			[9, 14])))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		{ho: saisie.ho, fm: valeur}));
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$uneFois = function (valeurs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (valeur, vues) {
				return A2($elm$core$List$member, valeur, vues) ? vues : _Utils_ap(
					vues,
					_List_fromArray(
						[valeur]));
			}),
		_List_Nil,
		valeurs);
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$criteresDeDoublon = function (saisie) {
	var valeursDe = F3(
		function (canal, estValide, normaliser) {
			return $author$project$Components$Referentiel$NouvelleFiche$Model$uneFois(
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.fm;
						},
						normaliser),
					A2(
						$elm$core$List$filter,
						function (ligne) {
							return _Utils_eq(ligne.uF, canal) && estValide(ligne.fm);
						},
						saisie.wa)));
		});
	var raisonSociale = $elm$core$String$trim(saisie.GR);
	var prenom = $elm$core$String$trim(saisie.Gg);
	var nom = $elm$core$String$trim(saisie.Dj);
	return {
		yd: A3(valeursDe, 0, $author$project$Components$Referentiel$Common$Contact$emailValide, $elm$core$String$trim),
		m7: $author$project$Components$Referentiel$NouvelleFiche$Model$identifiantLegalCherche(saisie),
		Fd: ((!saisie.g1) && ((nom !== '') && (prenom !== ''))) ? $elm$core$Maybe$Just(
			{Dj: nom, Gg: prenom}) : $elm$core$Maybe$Nothing,
		GR: ((saisie.g1 === 1) && (raisonSociale !== '')) ? $elm$core$Maybe$Just(raisonSociale) : $elm$core$Maybe$Nothing,
		Jq: A3(valeursDe, 1, $author$project$Components$Referentiel$Common$Contact$telephoneValide, $author$project$Components$Referentiel$Common$Contact$telephoneNormalise)
	};
};
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$delaiDeRechercheMs = 300;
var $author$project$Components$Referentiel$NouvelleFiche$Update$AjouterLeRole = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$AttendreAvantDeChercherLOrganisation = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$ChercherLOrganisation = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$ChercherLesDoublons = F3(
	function (a, b, c) {
		return {$: 12, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$LireLaFicheRejouee = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Referentiel$Common$Equipe$Lue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$Reconnecter = {$: 8};
var $author$project$Components$Referentiel$NouvelleFiche$Update$RestaurerLaFiche = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$offerts = function (doublons) {
	return _Utils_eq(doublons.nB, $elm$core$Maybe$Nothing) ? _List_Nil : A2(
		$elm$core$List$filter,
		function (candidat) {
			return (!A2($elm$core$List$member, candidat.r8, doublons.xX)) && ((candidat.gt !== 2) || (!_Utils_eq(candidat.HS, $elm$core$Maybe$Nothing)));
		},
		doublons.jy);
};
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$ajouterLeRole = F5(
	function (uid, type_, offre, processUid, doublons) {
		var _v0 = _Utils_Tuple3(
			doublons.fw,
			type_,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (candidat) {
						return _Utils_eq(candidat.r8, uid);
					},
					$author$project$Components$Referentiel$NouvelleFiche$Doublons$offerts(doublons))));
		if (((_v0.a.$ === 1) && (!_v0.b.$)) && (!_v0.c.$)) {
			var _v1 = _v0.a;
			var choisi = _v0.b.a;
			var candidat = _v0.c.a;
			return A2(
				$elm$core$Maybe$map,
				function (lien) {
					return {zo: uid, nB: lien, D1: offre, Gn: processUid, r0: choisi};
				},
				(candidat.gt === 1) ? $elm$core$Maybe$Nothing : candidat.s9);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$PlacerFocus = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$idDuContact = F2(
	function (rang, partie) {
		return 'nouvelle-fiche-contact-' + ($elm$core$String$fromInt(rang) + ('-' + partie));
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$setContacts = F2(
	function (operation, saisie) {
		return _Utils_update(
			saisie,
			{
				wa: operation(saisie.wa)
			});
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$retoucher = F2(
	function (operation, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					gU: $elm$core$Maybe$Nothing,
					eb: _List_Nil,
					hP: A2($author$project$Components$Referentiel$NouvelleFiche$Model$setContacts, operation, model.hP)
				}),
			_List_Nil);
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$ajouterUnContact = function (model) {
	return $author$project$Components$Referentiel$Common$Contact$complet(model.hP.wa) ? _Utils_Tuple2(model, _List_Nil) : A2(
		$elm$core$Tuple$mapSecond,
		function (_v0) {
			return _List_fromArray(
				[
					$author$project$Components$Referentiel$NouvelleFiche$Update$PlacerFocus(
					A2(
						$author$project$Components$Referentiel$NouvelleFiche$Model$idDuContact,
						$elm$core$List$length(model.hP.wa),
						'canal'))
				]);
		},
		A2($author$project$Components$Referentiel$NouvelleFiche$Update$retoucher, $author$project$Components$Referentiel$Common$Contact$ajouter, model));
};
var $author$project$Components$Referentiel$Common$Equipe$Abandonnee = {$: 1};
var $author$project$Components$Referentiel$Common$Equipe$Terminee = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$Common$Equipe$Candidat = F3(
	function (uid, nom, moi) {
		return {og: moi, Dj: nom, r8: uid};
	});
var $author$project$Components$Referentiel$Common$Equipe$equipeDecoder = A2(
	$elm$json$Json$Decode$field,
	'equipe',
	$elm$json$Json$Decode$list(
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'moi',
			$elm$json$Json$Decode$bool,
			false,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'nom',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'uid',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$Equipe$Candidat))))));
var $author$project$Components$Referentiel$Common$Equipe$avancer = F2(
	function (_v0, reponse) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$Referentiel$Common$Equipe$Abandonnee,
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$Referentiel$Common$Equipe$Terminee,
				$elm$core$Result$toMaybe(
					A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$Equipe$equipeDecoder, reponse))));
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$avecLesRecherches = F2(
	function (reponse, etat) {
		var _v0 = A2(
			$author$project$API$Reponse$lire,
			A2(
				$elm$json$Json$Decode$field,
				'_links',
				A2(
					$elm$json$Json$Decode$map,
					function ($) {
						return $.gF;
					},
					$author$project$API$Liens$decoder)),
			reponse);
		if (!_v0.$) {
			var gabarits = _v0.a;
			return _Utils_update(
				etat,
				{
					gF: $author$project$Components$Referentiel$Common$ChoixDeLien$gabaritsDe(gabarits)
				});
		} else {
			return etat;
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$basculerLesHomonymes = function (doublons) {
	return _Utils_update(
		doublons,
		{d0: !doublons.d0});
};
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$caseCochee = F2(
	function (coche, doublons) {
		return _Utils_eq(
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.f2;
				},
				doublons.bb),
			$elm$core$Maybe$Nothing) ? doublons : _Utils_update(
			doublons,
			{a0: coche});
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$surLeRattachement = F2(
	function (change, saisie) {
		return _Utils_update(
			saisie,
			{
				pN: change(saisie.pN)
			});
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$setRecherche = function (change) {
	return $author$project$Components$Referentiel$NouvelleFiche$Model$surLeRattachement(
		function (rattachement) {
			return _Utils_update(
				rattachement,
				{
					hC: change(rattachement.hC)
				});
		});
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$choisirLOrganisation = function (uid) {
	return $author$project$Components$Referentiel$NouvelleFiche$Model$setRecherche(
		$author$project$Components$Referentiel$Common$RechercheDeFiche$choisir(uid));
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$surLaSaisie = F2(
	function (setter, model) {
		return _Utils_update(
			model,
			{
				hP: setter(model.hP)
			});
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$saisir = F2(
	function (setter, model) {
		return _Utils_Tuple2(
			A2($author$project$Components$Referentiel$NouvelleFiche$Update$surLaSaisie, setter, model),
			_List_Nil);
	});
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$sansRefus = function (doublons) {
	return _Utils_update(
		doublons,
		{pZ: $elm$core$Maybe$Nothing});
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$setType = F3(
	function (types, valeur, saisie) {
		return _Utils_update(
			saisie,
			{
				r0: $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (uid) {
							return _Utils_eq(
								$author$project$Components$Referentiel$Identifiants$typeUidToString(uid),
								valeur);
						},
						A2(
							$elm$core$List$map,
							function ($) {
								return $.r8;
							},
							types)))
			});
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$choisirLeType = F2(
	function (valeur, model) {
		var _v0 = A2(
			$author$project$Components$Referentiel$NouvelleFiche$Update$saisir,
			A2($author$project$Components$Referentiel$NouvelleFiche$Model$setType, model.ib, valeur),
			_Utils_update(
				model,
				{
					xM: $author$project$Components$Referentiel$NouvelleFiche$Doublons$sansRefus(model.xM)
				}));
		var suivant = _v0.a;
		var effets = _v0.b;
		var schema = A2(
			$elm$core$Maybe$andThen,
			function (uid) {
				return A2(
					$elm$core$Maybe$map,
					function (type_) {
						return {
							aN: A2(
								$author$project$Components$Referentiel$Common$ChampsDuType$schemaDe,
								suivant.qV,
								A2(
									$elm$core$List$map,
									function ($) {
										return $.uN;
									},
									type_.dw)),
							r0: uid
						};
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.r8;
								},
								$elm$core$Basics$eq(uid)),
							suivant.ib)));
			},
			suivant.hP.r0);
		return _Utils_Tuple2(
			_Utils_update(
				suivant,
				{
					jE: A2(
						$elm$core$Maybe$withDefault,
						A2(
							$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$depuis,
							{dw: _List_Nil, Ba: _List_Nil},
							_List_Nil),
						A2(
							$elm$core$Maybe$map,
							function (lu) {
								return A2($author$project$Components$Referentiel$Common$ChampsDuType$saisieDeDepart, lu.aN, _List_Nil);
							},
							schema)),
					hQ: schema
				}),
			effets);
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$codeDUsageLie = 'Professionnel:rattachement';
var $author$project$Components$Referentiel$NouvelleFiche$Update$OuvrirLaFiche = F3(
	function (a, b, c) {
		return {$: 6, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$RevenirALOrganisation = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$ouverture = F3(
	function (model, creee, rejouee) {
		var _v0 = model.cx;
		if (!_v0.$) {
			var organisation = _v0.a;
			return A2($author$project$Components$Referentiel$NouvelleFiche$Update$RevenirALOrganisation, organisation, creee.sy);
		} else {
			return A3($author$project$Components$Referentiel$NouvelleFiche$Update$OuvrirLaFiche, creee.yt, creee.sy, rejouee);
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$DemanderProcessUid = {$: 0};
var $author$project$Components$Referentiel$NouvelleFiche$Model$partieDAdresse = function (champ) {
	switch (champ) {
		case 0:
			return 'adresse-ligne1';
		case 1:
			return 'adresse-ligne2';
		case 2:
			return 'adresse-ligne3';
		case 3:
			return 'adresse-code-postal';
		case 4:
			return 'adresse-localite';
		case 5:
			return 'adresse-region';
		default:
			return 'adresse-pays';
	}
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$idDuChamp = function (champ) {
	switch (champ.$) {
		case 0:
			return 'nouvelle-fiche-prenom';
		case 1:
			return 'nouvelle-fiche-nom';
		case 2:
			return 'nouvelle-fiche-raison-sociale';
		case 3:
			return 'nouvelle-fiche-forme';
		case 4:
			return 'nouvelle-fiche-pays';
		case 5:
			return 'nouvelle-fiche-type';
		case 6:
			return 'nouvelle-fiche-identifiant-legal';
		case 10:
			return 'nouvelle-fiche-base-legale';
		case 9:
			return 'nouvelle-fiche-poste';
		case 7:
			var rang = champ.a;
			return A2($author$project$Components$Referentiel$NouvelleFiche$Model$idDuContact, rang, 'valeur');
		default:
			var rang = champ.a;
			var partie = champ.b;
			return A2(
				$author$project$Components$Referentiel$NouvelleFiche$Model$idDuContact,
				rang,
				$author$project$Components$Referentiel$NouvelleFiche$Model$partieDAdresse(partie));
	}
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$ChampPrenom = {$: 0};
var $author$project$Components$Referentiel$NouvelleFiche$Model$ChampRaisonSociale = {$: 2};
var $author$project$Components$Referentiel$NouvelleFiche$Model$premierChampDeSaisie = function (nature) {
	if (!nature) {
		return $author$project$Components$Referentiel$NouvelleFiche$Model$ChampPrenom;
	} else {
		return $author$project$Components$Referentiel$NouvelleFiche$Model$ChampRaisonSociale;
	}
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$auPremierChamp = function (vide) {
	return $author$project$Components$Referentiel$NouvelleFiche$Update$PlacerFocus(
		$author$project$Components$Referentiel$NouvelleFiche$Model$idDuChamp(
			$author$project$Components$Referentiel$NouvelleFiche$Model$premierChampDeSaisie(vide.hP.g1)));
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$suivante = function (creee) {
	return _Utils_update(
		$author$project$Components$Referentiel$NouvelleFiche$Model$init,
		{
			gB: function () {
				var _v0 = creee.Av;
				if (!_v0.$) {
					return $elm$core$Maybe$Nothing;
				} else {
					var organisation = _v0.a;
					return $elm$core$Maybe$Just(organisation.gB);
				}
			}(),
			g1: function () {
				var _v1 = creee.Av;
				if (!_v1.$) {
					return 0;
				} else {
					return 1;
				}
			}(),
			hy: A2($elm$core$Maybe$withDefault, $author$project$Components$Referentiel$NouvelleFiche$Model$init.hy, creee.hy)
		});
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$vider = function (model) {
	return _Utils_update(
		model,
		{
			iB: $elm$core$Maybe$Nothing,
			jE: A2(
				$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$depuis,
				{dw: _List_Nil, Ba: _List_Nil},
				_List_Nil),
			kd: $elm$core$Maybe$Nothing,
			l2: $author$project$Components$Referentiel$NouvelleFiche$Model$SansProcessUid,
			gm: false,
			gn: $elm$core$Maybe$Nothing,
			gU: $elm$core$Maybe$Nothing,
			eb: _List_Nil,
			oI: $elm$core$Maybe$Nothing,
			hP: A2(
				$elm$core$Maybe$withDefault,
				$author$project$Components$Referentiel$NouvelleFiche$Model$init,
				A2($elm$core$Maybe$map, $author$project$Components$Referentiel$NouvelleFiche$Model$suivante, model.gn)),
			hQ: $elm$core$Maybe$Nothing
		});
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$pourLaSuivante = function (model) {
	var vide = $author$project$Components$Referentiel$NouvelleFiche$Update$vider(model);
	return _Utils_Tuple2(
		vide,
		_List_fromArray(
			[
				$author$project$Components$Referentiel$NouvelleFiche$Update$DemanderProcessUid,
				$author$project$Components$Referentiel$NouvelleFiche$Update$auPremierChamp(vide)
			]));
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$poursuivreSansSociete = F3(
	function (suite, creee, model) {
		if (!suite) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: $author$project$Components$Referentiel$NouvelleFiche$Model$SansProcessUid, gn: $elm$core$Maybe$Nothing}),
				_List_fromArray(
					[
						A3($author$project$Components$Referentiel$NouvelleFiche$Update$ouverture, model, creee, $elm$core$Maybe$Nothing)
					]));
		} else {
			return $author$project$Components$Referentiel$NouvelleFiche$Update$pourLaSuivante(model);
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$conclureLeRattachement = function (model) {
	var _v0 = model.hX;
	if (!_v0.$) {
		var suite = _v0.a.rn;
		var creee = _v0.a.wm;
		var rendue = {yt: creee.yt, mk: _List_Nil, nQ: _List_Nil, sy: creee.sy};
		return A3(
			$author$project$Components$Referentiel$NouvelleFiche$Update$poursuivreSansSociete,
			suite,
			rendue,
			_Utils_update(
				model,
				{hX: $elm$core$Maybe$Nothing}));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$delaiEcoule = F2(
	function (saisie, doublons) {
		return (_Utils_eq(saisie, doublons.hP) && (!$author$project$Components$Referentiel$NouvelleFiche$Doublons$estVide(doublons.aU))) ? A2(
			$elm$core$Maybe$map,
			function (lien) {
				return _Utils_Tuple2(lien, doublons.aU);
			},
			doublons.nB) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$delier = function (rang) {
	return $author$project$Components$Referentiel$NouvelleFiche$Model$surLeRattachement(
		function (rattachement) {
			return _Utils_update(
				rattachement,
				{
					BR: A2(
						$elm$core$List$filter,
						$elm$core$Basics$neq(rang),
						rattachement.BR)
				});
		});
};
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$demandeDeLaPersonne = function (doublons) {
	return doublons.a0 && (!_Utils_eq(
		A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.f2;
			},
			doublons.bb),
		$elm$core$Maybe$Nothing));
};
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$creationRetenue = function (doublons) {
	return (!_Utils_eq(doublons.bb, $elm$core$Maybe$Nothing)) && (!$author$project$Components$Referentiel$NouvelleFiche$Doublons$demandeDeLaPersonne(doublons));
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$CreerLaFiche = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$EnCours = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$champsAEnvoyer = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (lu) {
				return A2($author$project$Components$Referentiel$Common$ChampsDuType$champsAEnvoyer, lu.aN, model.jE);
			},
			model.hQ));
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$fautesDuType = function (model) {
	var _v0 = model.hQ;
	if (!_v0.$) {
		var lu = _v0.a;
		return A2(
			$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$fautes,
			A2(
				$author$project$Components$Referentiel$Common$ChampsDuType$champsAPresenter,
				$author$project$Components$Referentiel$Common$ChampsDuType$tousLesChamps(lu.aN),
				model.jE),
			model.jE);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$ChampBaseLegale = {$: 10};
var $author$project$Components$Referentiel$NouvelleFiche$Model$ChampForme = {$: 3};
var $author$project$Components$Referentiel$NouvelleFiche$Model$IdentiteOrganisation = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$facultatif = function (choisi) {
	return (choisi === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(choisi);
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$debutDuPremierRole = function (saisie) {
	return A2(
		$elm$core$Maybe$andThen,
		function (_v0) {
			return $author$project$Components$Referentiel$NouvelleFiche$Model$facultatif(saisie.dE);
		},
		saisie.r0);
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$ChampNom = {$: 1};
var $author$project$Components$Referentiel$NouvelleFiche$Model$ChampPays = {$: 4};
var $author$project$Components$Referentiel$NouvelleFiche$Model$ChampPoste = {$: 9};
var $author$project$Components$Referentiel$NouvelleFiche$Model$ChampType = {$: 5};
var $author$project$Components$Referentiel$NouvelleFiche$Model$ChampAdresse = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$ChampContact = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$champDUneLigne = function (_v0) {
	var rang = _v0.a;
	var erreur = _v0.b;
	switch (erreur.$) {
		case 5:
			var champ = erreur.a;
			return A2($author$project$Components$Referentiel$NouvelleFiche$Model$ChampAdresse, rang, champ);
		case 6:
			var champ = erreur.a;
			return A2($author$project$Components$Referentiel$NouvelleFiche$Model$ChampAdresse, rang, champ);
		default:
			return $author$project$Components$Referentiel$NouvelleFiche$Model$ChampContact(rang);
	}
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$organisationChoisie = function (saisie) {
	return saisie.pN.hC.ve;
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$prenomFacultatif = function (saisie) {
	return (!saisie.g1) && A2(
		$elm$core$List$any,
		function (ligne) {
			return (!ligne.uF) && $author$project$Components$Referentiel$Common$Contact$emailValide(ligne.fm);
		},
		saisie.wa);
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$enErreur = function (saisie) {
	var dUnePersonne = !saisie.g1;
	return _Utils_ap(
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$first,
			A2(
				$elm$core$List$filter,
				$elm$core$Tuple$second,
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Components$Referentiel$NouvelleFiche$Model$ChampPrenom,
						dUnePersonne && (($elm$core$String$trim(saisie.Gg) === '') && (!$author$project$Components$Referentiel$NouvelleFiche$Model$prenomFacultatif(saisie)))),
						_Utils_Tuple2(
						$author$project$Components$Referentiel$NouvelleFiche$Model$ChampNom,
						dUnePersonne && ($elm$core$String$trim(saisie.Dj) === '')),
						_Utils_Tuple2(
						$author$project$Components$Referentiel$NouvelleFiche$Model$ChampRaisonSociale,
						(!dUnePersonne) && ($elm$core$String$trim(saisie.GR) === '')),
						_Utils_Tuple2(
						$author$project$Components$Referentiel$NouvelleFiche$Model$ChampForme,
						(!dUnePersonne) && _Utils_eq(saisie.gB, $elm$core$Maybe$Nothing)),
						_Utils_Tuple2($author$project$Components$Referentiel$NouvelleFiche$Model$ChampPays, saisie.ho === ''),
						_Utils_Tuple2(
						$author$project$Components$Referentiel$NouvelleFiche$Model$ChampType,
						_Utils_eq(saisie.r0, $elm$core$Maybe$Nothing))
					]))),
		_Utils_ap(
			A2(
				$elm$core$List$map,
				$author$project$Components$Referentiel$NouvelleFiche$Model$champDUneLigne,
				$author$project$Components$Referentiel$Common$Contact$erreurs(saisie.wa)),
			_Utils_ap(
				(dUnePersonne && ((!_Utils_eq(
					$author$project$Components$Referentiel$NouvelleFiche$Model$organisationChoisie(saisie),
					$elm$core$Maybe$Nothing)) && _Utils_eq(saisie.pN.F4, $elm$core$Maybe$Nothing))) ? _List_fromArray(
					[$author$project$Components$Referentiel$NouvelleFiche$Model$ChampPoste]) : _List_Nil,
				(dUnePersonne && _Utils_eq(saisie.fI, $elm$core$Maybe$Nothing)) ? _List_fromArray(
					[$author$project$Components$Referentiel$NouvelleFiche$Model$ChampBaseLegale]) : _List_Nil)));
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$offreDuPremierRole = function (saisie) {
	return A2(
		$elm$core$Maybe$andThen,
		function (_v0) {
			return $author$project$Components$Referentiel$NouvelleFiche$Model$facultatif(saisie.D1);
		},
		saisie.r0);
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$IdentitePersonne = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$personne = F2(
	function (baseLegale, saisie) {
		return $author$project$Components$Referentiel$NouvelleFiche$Model$IdentitePersonne(
			{
				fI: baseLegale,
				Dj: $elm$core$String$trim(saisie.Dj),
				ho: saisie.ho,
				Gg: ($elm$core$String$trim(saisie.Gg) === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$elm$core$String$trim(saisie.Gg))
			});
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$liable = F2(
	function (rang, saisie) {
		return (!_Utils_eq(
			$author$project$Components$Referentiel$NouvelleFiche$Model$organisationChoisie(saisie),
			$elm$core$Maybe$Nothing)) && A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (ligne) {
					return A2(
						$elm$core$List$member,
						ligne.uF,
						_List_fromArray(
							[0, 1]));
				},
				$elm$core$List$head(
					A2($elm$core$List$drop, rang, saisie.wa))));
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$estLie = F2(
	function (rang, saisie) {
		return A2($elm$core$List$member, rang, saisie.pN.BR) && A2($author$project$Components$Referentiel$NouvelleFiche$Model$liable, rang, saisie);
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$rattachementValide = function (saisie) {
	return A3(
		$elm$core$Maybe$map2,
		F2(
			function (organisation, poste) {
				return {
					AS: $author$project$Components$Referentiel$NouvelleFiche$Model$facultatif(
						$elm$core$String$trim(saisie.pN.AS)),
					BR: A2(
						$elm$core$List$filter,
						function (rang) {
							return A2($author$project$Components$Referentiel$NouvelleFiche$Model$estLie, rang, saisie);
						},
						saisie.pN.BR),
					En: organisation.r8,
					F4: poste
				};
			}),
		$author$project$Components$Referentiel$NouvelleFiche$Model$organisationChoisie(saisie),
		saisie.pN.F4);
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$isValidForm = function (saisie) {
	var _v0 = _Utils_Tuple2(
		$author$project$Components$Referentiel$NouvelleFiche$Model$enErreur(saisie),
		$author$project$Components$Referentiel$Common$Contact$valides(saisie.wa));
	if ((!_v0.a.b) && (!_v0.b.$)) {
		var contacts = _v0.b.a;
		var _v1 = _Utils_Tuple3(saisie.g1, saisie.fI, saisie.gB);
		if (!_v1.a) {
			if (!_v1.b.$) {
				var _v2 = _v1.a;
				var baseLegale = _v1.b.a;
				return $elm$core$Result$Ok(
					{
						jE: _List_Nil,
						vh: $author$project$Components$Referentiel$NouvelleFiche$Model$facultatif(saisie.vh),
						wa: contacts,
						wG: $author$project$Components$Referentiel$NouvelleFiche$Model$debutDuPremierRole(saisie),
						w7: false,
						mA: _List_Nil,
						m7: $elm$core$Maybe$Nothing,
						Av: A2($author$project$Components$Referentiel$NouvelleFiche$Model$personne, baseLegale, saisie),
						nn: $author$project$Components$Referentiel$NouvelleFiche$Model$facultatif(saisie.nn),
						D2: $author$project$Components$Referentiel$NouvelleFiche$Model$offreDuPremierRole(saisie),
						pw: saisie.r0,
						hy: $elm$core$Maybe$Just(saisie.hy),
						pN: $author$project$Components$Referentiel$NouvelleFiche$Model$rattachementValide(saisie),
						qB: $author$project$Components$Referentiel$NouvelleFiche$Model$facultatif(saisie.qB)
					});
			} else {
				var _v4 = _v1.a;
				var _v5 = _v1.b;
				return $elm$core$Result$Err(
					_List_fromArray(
						[$author$project$Components$Referentiel$NouvelleFiche$Model$ChampBaseLegale]));
			}
		} else {
			if (!_v1.c.$) {
				var _v3 = _v1.a;
				var forme = _v1.c.a;
				return $elm$core$Result$Ok(
					{
						jE: _List_Nil,
						vh: $elm$core$Maybe$Nothing,
						wa: contacts,
						wG: $author$project$Components$Referentiel$NouvelleFiche$Model$debutDuPremierRole(saisie),
						w7: false,
						mA: _List_Nil,
						m7: $author$project$Components$Referentiel$NouvelleFiche$Model$facultatif(
							$elm$core$String$trim(saisie.m7)),
						Av: $author$project$Components$Referentiel$NouvelleFiche$Model$IdentiteOrganisation(
							{
								gB: forme,
								ho: saisie.ho,
								GR: $elm$core$String$trim(saisie.GR)
							}),
						nn: $author$project$Components$Referentiel$NouvelleFiche$Model$facultatif(saisie.nn),
						D2: $author$project$Components$Referentiel$NouvelleFiche$Model$offreDuPremierRole(saisie),
						pw: saisie.r0,
						hy: $elm$core$Maybe$Nothing,
						pN: $elm$core$Maybe$Nothing,
						qB: $author$project$Components$Referentiel$NouvelleFiche$Model$facultatif(saisie.qB)
					});
			} else {
				var _v6 = _v1.a;
				var _v7 = _v1.c;
				return $elm$core$Result$Err(
					_List_fromArray(
						[$author$project$Components$Referentiel$NouvelleFiche$Model$ChampForme]));
			}
		}
	} else {
		var champs = _v0.a;
		return $elm$core$Result$Err(champs);
	}
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$prefixeDesChamps = $author$project$Components$Referentiel$Common$ChampsDuType$prefixe('referentiel-nouvelle-fiche');
var $author$project$Components$Referentiel$NouvelleFiche$Update$demanderSansRetenue = F2(
	function (suite, model) {
		var _v0 = _Utils_Tuple3(
			$author$project$Components$Referentiel$NouvelleFiche$Model$isValidForm(model.hP),
			model.l2,
			model.dC);
		if (_v0.a.$ === 1) {
			var champs = _v0.a.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{gm: true}),
				A2(
					$elm$core$List$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$NouvelleFiche$Model$idDuChamp, $author$project$Components$Referentiel$NouvelleFiche$Update$PlacerFocus),
					A2($elm$core$List$take, 1, champs)));
		} else {
			if ((_v0.b.$ === 1) && (!_v0.c.$)) {
				var saisie = _v0.a.a;
				var processUid = _v0.b.a;
				var creer = _v0.c.a;
				var _v1 = $author$project$Components$Referentiel$NouvelleFiche$Update$fautesDuType(model);
				if (_v1.b) {
					var fautif = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								jE: $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$tenter(model.jE),
								gm: true
							}),
						_List_fromArray(
							[
								$author$project$Components$Referentiel$NouvelleFiche$Update$PlacerFocus(
								A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$idDuChamp, $author$project$Components$Referentiel$NouvelleFiche$Update$prefixeDesChamps, fautif))
							]));
				} else {
					var fiche = _Utils_update(
						saisie,
						{
							jE: $author$project$Components$Referentiel$NouvelleFiche$Update$champsAEnvoyer(model),
							w7: $author$project$Components$Referentiel$NouvelleFiche$Doublons$demandeDeLaPersonne(model.xM),
							mA: model.xM.xX
						});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								jE: A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$refuser, _List_Nil, model.jE),
								l2: A2($author$project$Components$Referentiel$NouvelleFiche$Model$EnCours, processUid, suite),
								gm: true,
								gn: $elm$core$Maybe$Just(fiche),
								gU: $elm$core$Maybe$Nothing,
								eb: _List_Nil
							}),
						_List_fromArray(
							[
								A3($author$project$Components$Referentiel$NouvelleFiche$Update$CreerLaFiche, creer, processUid, fiche)
							]));
				}
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gm: true}),
					_List_Nil);
			}
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$demander = F2(
	function (suite, model) {
		return $author$project$Components$Referentiel$NouvelleFiche$Doublons$creationRetenue(model.xM) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Referentiel$NouvelleFiche$Update$demanderSansRetenue, suite, model);
	});
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$ecarter = F2(
	function (uid, doublons) {
		return A2($elm$core$List$member, uid, doublons.xX) ? doublons : _Utils_update(
			doublons,
			{
				xX: _Utils_ap(
					doublons.xX,
					_List_fromArray(
						[uid]))
			});
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$Pret = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$refusNets = _List_fromArray(
	[400, 403, 409, 422]);
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$restaurationRendue = function (doublons) {
	return _Utils_update(
		doublons,
		{eV: $elm$core$Maybe$Nothing});
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$ficheRestauree = F3(
	function (restauration, reponse, model) {
		var rendu = _Utils_update(
			model,
			{
				xM: $author$project$Components$Referentiel$NouvelleFiche$Doublons$restaurationRendue(model.xM)
			});
		var _v0 = A2(
			$author$project$API$Reponse$lire,
			A2($elm$json$Json$Decode$field, 'vuesAJour', $elm$json$Json$Decode$bool),
			reponse);
		if (!_v0.$) {
			var vuesAJour = _v0.a;
			return _Utils_Tuple2(
				rendu,
				_List_fromArray(
					[
						A3($author$project$Components$Referentiel$NouvelleFiche$Update$OuvrirLaFiche, restauration.zo, vuesAJour, $elm$core$Maybe$Nothing),
						$author$project$Components$Referentiel$NouvelleFiche$Update$DemanderProcessUid
					]));
		} else {
			var refus = _v0.a;
			return (refus.ri === 401) ? _Utils_Tuple2(
				_Utils_update(
					rendu,
					{
						l2: $author$project$Components$Referentiel$NouvelleFiche$Model$Pret(restauration.Gn)
					}),
				_List_fromArray(
					[$author$project$Components$Referentiel$NouvelleFiche$Update$Reconnecter])) : (A2($elm$core$List$member, refus.ri, $author$project$Components$Referentiel$NouvelleFiche$Update$refusNets) ? _Utils_Tuple2(
				rendu,
				_List_fromArray(
					[$author$project$Components$Referentiel$NouvelleFiche$Update$DemanderProcessUid])) : _Utils_Tuple2(
				_Utils_update(
					rendu,
					{
						l2: $author$project$Components$Referentiel$NouvelleFiche$Model$Pret(restauration.Gn)
					}),
				_List_Nil));
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$focusDuRefus = F2(
	function (reponse, model) {
		var _v0 = $author$project$Components$Referentiel$Common$ChampsDuType$lireLeRefus(reponse);
		_v0$2:
		while (true) {
			switch (_v0.$) {
				case 0:
					if (_v0.a.b) {
						var _v1 = _v0.a;
						var premier = _v1.a;
						return _List_fromArray(
							[
								$author$project$Components$Referentiel$NouvelleFiche$Update$PlacerFocus(
								A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$idDuChamp, $author$project$Components$Referentiel$NouvelleFiche$Update$prefixeDesChamps, premier.uN))
							]);
					} else {
						break _v0$2;
					}
				case 1:
					var pris = _v0.a;
					return _List_fromArray(
						[
							$author$project$Components$Referentiel$NouvelleFiche$Update$PlacerFocus(
							A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$idDuChamp, $author$project$Components$Referentiel$NouvelleFiche$Update$prefixeDesChamps, pris.uN))
						]);
				default:
					break _v0$2;
			}
		}
		return _List_Nil;
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$lienDeLaRecherche = function (model) {
	return A2(
		$author$project$Components$Referentiel$Liens$versEntites,
		{
			EE: 1,
			Jm: $author$project$Routes$Route$premierePage.Jm,
			rS: $author$project$Routes$Route$codeDuTri(0)
		},
		model.gF);
};
var $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$lienRelierDecoder = A2(
	$elm$json$Json$Decode$map,
	function (liens) {
		return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$relier, liens.h0);
	},
	A2($elm$json$Json$Decode$field, '_links', $author$project$API$Liens$decoder));
var $author$project$Components$Referentiel$NouvelleFiche$Model$lier = F2(
	function (rang, saisie) {
		return A2($author$project$Components$Referentiel$NouvelleFiche$Model$liable, rang, saisie) ? A2(
			$author$project$Components$Referentiel$NouvelleFiche$Model$surLeRattachement,
			function (rattachement) {
				return _Utils_update(
					rattachement,
					{
						BR: A2(
							$elm$core$List$cons,
							rang,
							A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(rang),
								rattachement.BR))
					});
			},
			A2(
				$author$project$Components$Referentiel$NouvelleFiche$Model$setContacts,
				A2(
					$author$project$Components$Referentiel$Common$Contact$setUsage,
					rang,
					$author$project$Components$Referentiel$Common$Contact$usageCode(1)),
				saisie)) : saisie;
	});
var $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$ligneEnDouble = function (corps) {
	return $elm$core$Result$toMaybe(
		A2(
			$elm$json$Json$Decode$decodeString,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['error', 'ContactEnDouble', 'ligne']),
				$elm$json$Json$Decode$int),
			corps));
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$ligneEnDouble = F2(
	function (refus, corps) {
		return ($author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$duRefus(refus) === 5) ? $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$ligneEnDouble(corps) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$RelierLEtablissement = F3(
	function (a, b, c) {
		return {$: 17, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$avancerLeRattachement = function (model) {
	var _v0 = _Utils_Tuple2(model.hX, model.l2);
	if ((!_v0.a.$) && (_v0.b.$ === 1)) {
		var type_ = _v0.a.a.r0;
		var relier = _v0.a.a.Hy;
		var societe = _v0.a.a.hX;
		var creee = _v0.a.a.wm;
		var suite = _v0.a.a.rn;
		var processUid = _v0.b.a;
		var _v1 = _Utils_Tuple2(type_, relier);
		if ((!_v1.a.$) && (!_v1.b.$)) {
			var leType = _v1.a.a;
			var lien = _v1.b.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: A2($author$project$Components$Referentiel$NouvelleFiche$Model$EnCours, processUid, suite)
					}),
				_List_fromArray(
					[
						A3(
						$author$project$Components$Referentiel$NouvelleFiche$Update$RelierLEtablissement,
						lien,
						processUid,
						{vf: societe, yt: creee.yt, r0: leType})
					]));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$lireLeRattachement = F3(
	function (pose, reponse, model) {
		var _v0 = model.hX;
		if (!_v0.$) {
			var societe = _v0.a;
			return (reponse.ri >= 400) ? $author$project$Components$Referentiel$NouvelleFiche$Update$conclureLeRattachement(model) : $author$project$Components$Referentiel$NouvelleFiche$Update$avancerLeRattachement(
				_Utils_update(
					model,
					{
						hX: $elm$core$Maybe$Just(
							pose(societe))
					}));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$LirePostes = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$lireLesPostes = function (_v0) {
	var model = _v0.a;
	var effets = _v0.b;
	var _v1 = _Utils_Tuple3(
		$author$project$Components$Referentiel$NouvelleFiche$Model$organisationChoisie(model.hP),
		model.F6,
		model.gT);
	if (((!_v1.a.$) && (!_v1.b.b)) && (!_v1.c.$)) {
		var lien = _v1.c.a;
		return _Utils_Tuple2(
			model,
			_Utils_ap(
				effets,
				_List_fromArray(
					[
						$author$project$Components$Referentiel$NouvelleFiche$Update$LirePostes(lien)
					])));
	} else {
		return _Utils_Tuple2(model, effets);
	}
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$LireLesFormes = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$LireLesOffres = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$LireTypes = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$annoncer = function (organisation) {
	return $author$project$Components$Referentiel$NouvelleFiche$Model$setRecherche(
		function (recherche) {
			return _Utils_update(
				recherche,
				{
					ve: $elm$core$Maybe$Just(
						{g1: $author$project$I18n$Textes$referentielNatureOrganisation, Dj: organisation.Dj, r8: organisation.r8})
				});
		});
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$LireLEquipe = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Referentiel$Common$Equipe$DeLEquipe = 0;
var $author$project$API$NavLinksDictionary$equipeProposee = 'equipe-proposee';
var $author$project$Components$Referentiel$Common$Equipe$premiereEtape = function (liens) {
	return A2(
		$elm$core$Maybe$map,
		$elm$core$Tuple$pair(0),
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$equipeProposee, liens));
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$lireLEquipe = F2(
	function (equipe, liens) {
		if (equipe.$ === 1) {
			return _List_Nil;
		} else {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (_v1) {
						var etape = _v1.a;
						var lien = _v1.b;
						return _List_fromArray(
							[
								A2($author$project$Components$Referentiel$NouvelleFiche$Update$LireLEquipe, etape, lien)
							]);
					},
					$author$project$Components$Referentiel$Common$Equipe$premiereEtape(liens)));
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$ouvrir = F2(
	function (liens, model) {
		var initial = $author$project$Components$Referentiel$NouvelleFiche$Model$initial;
		var vide = _Utils_update(
			initial,
			{l5: model.l5, gF: model.gF, im: model.im});
		var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerEntite, liens);
		if (!_v0.$) {
			var creer = _v0.a;
			return $author$project$Components$Referentiel$NouvelleFiche$Update$lireLesPostes(
				_Utils_Tuple2(
					_Utils_update(
						vide,
						{
							dC: $elm$core$Maybe$Just(creer),
							cx: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.r8;
								},
								model.iQ),
							xM: $author$project$Components$Referentiel$NouvelleFiche$Doublons$init(
								A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rechercherDoublons, liens)),
							BE: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$formesDOrganisation, liens),
							gT: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$postes, liens),
							nL: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$typesDeRelation, liens),
							hP: A2(
								$elm$core$Maybe$withDefault,
								vide.hP,
								A2(
									$elm$core$Maybe$map,
									function (annoncee) {
										return A2($author$project$Components$Referentiel$NouvelleFiche$Model$annoncer, annoncee, vide.hP);
									},
									model.iQ))
						}),
					A2(
						$elm$core$List$cons,
						$author$project$Components$Referentiel$NouvelleFiche$Update$DemanderProcessUid,
						_Utils_ap(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$NouvelleFiche$Update$LireTypes, $elm$core$List$singleton),
									A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$typesDePartiePrenante, liens))),
							_Utils_ap(
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$NouvelleFiche$Update$LireLesFormes, $elm$core$List$singleton),
										A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$formesDOrganisation, liens))),
								_Utils_ap(
									A2($author$project$Components$Referentiel$NouvelleFiche$Update$lireLEquipe, model.l5, liens),
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$NouvelleFiche$Update$LireLesOffres, $elm$core$List$singleton),
											A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$offresPourUnRole, liens)))))))));
		} else {
			return _Utils_Tuple2(vide, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$ChercherDesNommees = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$champsDuTypeASaisir = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.aN;
				},
				$author$project$Components$Referentiel$Common$ChampsDuType$tousLesChamps),
			model.hQ));
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$ouvrirUnLien = F2(
	function (cle, model) {
		var _v0 = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.dy;
					},
					$elm$core$Basics$eq(cle)),
				$author$project$Components$Referentiel$NouvelleFiche$Model$champsDuTypeASaisir(model)));
		if (!_v0.$) {
			var champ = _v0.a;
			var actuelles = function () {
				var _v2 = A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$second,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$first,
								$elm$core$Basics$eq(cle)),
							model.jE.Ki)));
				_v2$2:
				while (true) {
					if (!_v2.$) {
						switch (_v2.a.$) {
							case 2:
								var choisis = _v2.a.a;
								return choisis;
							case 1:
								var texte = _v2.a.a;
								return (texte === '') ? _List_Nil : _List_fromArray(
									[texte]);
							default:
								break _v2$2;
						}
					} else {
						break _v2$2;
					}
				}
				return _List_Nil;
			}();
			var _v1 = A3($author$project$Components$Referentiel$Common$ChoixDeLien$ouvrir, champ, actuelles, model.nQ);
			var liens = _v1.a;
			var demande = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{nQ: liens}),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$NouvelleFiche$Update$ChercherDesNommees, $elm$core$List$singleton),
						demande)));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$PersonneEffacee = F2(
	function (inscriteLe, creerMalgre) {
		return {f2: creerMalgre, AQ: inscriteLe};
	});
var $author$project$API$NavLinksDictionary$creerMalgreLEffacement = 'creer-malgre-l-effacement';
var $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$personneEffaceeDecoder = $elm$json$Json$Decode$maybe(
	A2(
		$elm$json$Json$Decode$field,
		'personneEffacee',
		A3(
			$elm$json$Json$Decode$map2,
			$author$project$Components$Referentiel$NouvelleFiche$Doublons$PersonneEffacee,
			A2($elm$json$Json$Decode$field, 'inscriteLe', $elm$json$Json$Decode$string),
			A2(
				$elm$json$Json$Decode$map,
				function (liens) {
					return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerMalgreLEffacement, liens.h0);
				},
				A2($elm$json$Json$Decode$field, '_links', $author$project$API$Liens$decoder)))));
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$personneEffaceeRecue = F3(
	function (saisie, reconnue, doublons) {
		return (!_Utils_eq(saisie, doublons.hP)) ? doublons : _Utils_update(
			doublons,
			{
				a0: doublons.a0 && (!_Utils_eq(reconnue, $elm$core$Maybe$Nothing)),
				bb: reconnue
			});
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$LireLaFicheCreee = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$LireLesTypesDeRelation = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$societeProposee = function (doublons) {
	return _Utils_eq(doublons.nB, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Nothing : $elm$core$List$head(doublons.b4);
};
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$societeARattacher = function (doublons) {
	return doublons.b2 ? $elm$core$Maybe$Nothing : A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.r8;
		},
		$author$project$Components$Referentiel$NouvelleFiche$Doublons$societeProposee(doublons));
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$poursuivre = F3(
	function (suite, creee, model) {
		var _v0 = _Utils_Tuple3(
			$author$project$Components$Referentiel$NouvelleFiche$Doublons$societeARattacher(model.xM),
			model.nL,
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$self, creee.nQ));
		if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
			var societe = _v0.a.a;
			var types = _v0.b.a;
			var fiche = _v0.c.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: $author$project$Components$Referentiel$NouvelleFiche$Model$SansProcessUid,
						hX: $elm$core$Maybe$Just(
							{
								wm: {yt: creee.yt, sy: creee.sy},
								Hy: $elm$core$Maybe$Nothing,
								hX: societe,
								rn: suite,
								r0: $elm$core$Maybe$Nothing
							})
					}),
				_List_fromArray(
					[
						$author$project$Components$Referentiel$NouvelleFiche$Update$DemanderProcessUid,
						$author$project$Components$Referentiel$NouvelleFiche$Update$LireLesTypesDeRelation(types),
						$author$project$Components$Referentiel$NouvelleFiche$Update$LireLaFicheCreee(fiche)
					]));
		} else {
			return A3($author$project$Components$Referentiel$NouvelleFiche$Update$poursuivreSansSociete, suite, creee, model);
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$rattacherALaSociete = F2(
	function (coche, doublons) {
		return _Utils_update(
			doublons,
			{b2: !coche});
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$recevoirLeProcessUid = F2(
	function (octets, model) {
		var _v0 = _Utils_Tuple2(
			model.l2,
			$author$project$API$ProcessUid$depuisOctets(octets));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var _v1 = _v0.a;
			var processUid = _v0.b.a;
			return $author$project$Components$Referentiel$NouvelleFiche$Update$avancerLeRattachement(
				_Utils_update(
					model,
					{
						l2: $author$project$Components$Referentiel$NouvelleFiche$Model$Pret(processUid)
					}));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$reconnexion = function (refus) {
	return (refus.ri === 401) ? _List_fromArray(
		[$author$project$Components$Referentiel$NouvelleFiche$Update$Reconnecter]) : _List_Nil;
};
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$recus = F3(
	function (saisie, candidats, doublons) {
		return _Utils_eq(saisie, doublons.hP) ? _Utils_update(
			doublons,
			{jy: candidats}) : doublons;
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$refusDesChamps = F2(
	function (reponse, saisie) {
		return A2(
			$author$project$Components$Referentiel$Common$ChampsDuType$dire,
			$author$project$Components$Referentiel$Common$ChampsDuType$lireLeRefus(reponse),
			saisie);
	});
var $author$project$Components$Referentiel$Common$Contact$rangEcrit = function (segment) {
	var chiffres = $elm$core$String$fromList(
		$elm$core$List$reverse(
			A3(
				$elm$core$List$foldl,
				F2(
					function (caractere, _v0) {
						var lus = _v0.a;
						var fini = _v0.b;
						return (fini || (!$elm$core$Char$isDigit(caractere))) ? _Utils_Tuple2(lus, true) : _Utils_Tuple2(
							A2($elm$core$List$cons, caractere, lus),
							false);
					}),
				_Utils_Tuple2(_List_Nil, false),
				A2(
					$elm$core$List$filter,
					function (caractere) {
						return caractere !== '[';
					},
					$elm$core$String$toList(segment))).a));
	return (chiffres === '') ? $elm$core$Maybe$Nothing : $elm$core$String$toInt(chiffres);
};
var $author$project$Components$Referentiel$Common$Contact$ligneDesignee = function (chemin) {
	if (chemin.b) {
		var segment = chemin.a;
		var suite = chemin.b;
		if (A2($elm$core$String$startsWith, 'contacts', segment)) {
			var _v1 = $author$project$Components$Referentiel$Common$Contact$rangEcrit(
				A2(
					$elm$core$String$dropLeft,
					$elm$core$String$length('contacts'),
					segment));
			if (!_v1.$) {
				var rang = _v1.a;
				return $elm$core$Maybe$Just(rang);
			} else {
				return A2(
					$elm$core$Maybe$andThen,
					$author$project$Components$Referentiel$Common$Contact$rangEcrit,
					$elm$core$List$head(suite));
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Common$Contact$lignesDesignees = function (chemins) {
	return $elm$core$List$sort(
		A3(
			$elm$core$List$foldl,
			F2(
				function (rang, vus) {
					return A2($elm$core$List$member, rang, vus) ? vus : A2($elm$core$List$cons, rang, vus);
				}),
			_List_Nil,
			A2($elm$core$List$filterMap, $author$project$Components$Referentiel$Common$Contact$ligneDesignee, chemins)));
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$lignesRefusees = function (refus) {
	var _v0 = refus.bB;
	if (_v0.$ === 6) {
		var invalides = _v0.a;
		return $author$project$Components$Referentiel$Common$Contact$lignesDesignees(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.E6;
				},
				invalides));
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$refuser = F3(
	function (processUid, refus, model) {
		return (refus.ri === 401) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{
					l2: $author$project$Components$Referentiel$NouvelleFiche$Model$Pret(processUid)
				}),
			_List_fromArray(
				[$author$project$Components$Referentiel$NouvelleFiche$Update$Reconnecter])) : (A2($elm$core$List$member, refus.ri, $author$project$Components$Referentiel$NouvelleFiche$Update$refusNets) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{
					l2: $author$project$Components$Referentiel$NouvelleFiche$Model$SansProcessUid,
					eb: $author$project$Components$Referentiel$NouvelleFiche$Update$lignesRefusees(refus)
				}),
			_List_fromArray(
				[$author$project$Components$Referentiel$NouvelleFiche$Update$DemanderProcessUid])) : _Utils_Tuple2(
			_Utils_update(
				model,
				{
					l2: $author$project$Components$Referentiel$NouvelleFiche$Model$Pret(processUid)
				}),
			_List_Nil));
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$rejouer = F3(
	function (suite, creee, model) {
		var _v0 = _Utils_Tuple2(suite, model.gn);
		if (_v0.a === 1) {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var envoyee = _v0.b.a;
				var _v2 = $author$project$Components$Referentiel$NouvelleFiche$Update$pourLaSuivante(model);
				var vide = _v2.a;
				var effets = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						vide,
						{
							iB: $elm$core$Maybe$Just(
								{yt: creee.yt, gn: envoyee, Hv: 0})
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Components$Referentiel$NouvelleFiche$Update$LireLaFicheRejouee(creee.yt)
							])));
			} else {
				var _v3 = _v0.a;
				var _v4 = _v0.b;
				return $author$project$Components$Referentiel$NouvelleFiche$Update$pourLaSuivante(model);
			}
		} else {
			var _v5 = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: $author$project$Components$Referentiel$NouvelleFiche$Model$SansProcessUid, gn: $elm$core$Maybe$Nothing}),
				_List_fromArray(
					[
						A3($author$project$Components$Referentiel$NouvelleFiche$Update$ouverture, model, creee, model.gn)
					]));
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$setPoste = F2(
	function (postes, valeur) {
		return $author$project$Components$Referentiel$NouvelleFiche$Model$surLeRattachement(
			function (rattachement) {
				return _Utils_update(
					rattachement,
					{
						F4: $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (uid) {
									return _Utils_eq(
										$author$project$Components$Referentiel$Identifiants$posteUidToString(uid),
										valeur);
								},
								A2(
									$elm$core$List$map,
									function ($) {
										return $.r8;
									},
									postes)))
					});
			});
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$relireLesPostesSiArchive = F2(
	function (refus, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		return ($author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$duRefus(refus) === 7) ? _Utils_Tuple2(
			A2(
				$author$project$Components$Referentiel$NouvelleFiche$Update$surLaSaisie,
				A2($author$project$Components$Referentiel$NouvelleFiche$Model$setPoste, _List_Nil, ''),
				model),
			_Utils_ap(
				effets,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$NouvelleFiche$Update$LirePostes, $elm$core$List$singleton),
						model.gT)))) : _Utils_Tuple2(model, effets);
	});
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$restaurerLaFiche = F3(
	function (uid, processUid, doublons) {
		var _v0 = _Utils_Tuple2(
			doublons.eV,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (candidat) {
						return _Utils_eq(candidat.r8, uid);
					},
					$author$project$Components$Referentiel$NouvelleFiche$Doublons$offerts(doublons))));
		if ((_v0.a.$ === 1) && (!_v0.b.$)) {
			var _v1 = _v0.a;
			var candidat = _v0.b.a;
			return A2(
				$elm$core$Maybe$map,
				function (lien) {
					return {zo: uid, nB: lien, Gn: processUid};
				},
				candidat.HS);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$apresLeRetrait = function (rang) {
	return $author$project$Components$Referentiel$NouvelleFiche$Model$surLeRattachement(
		function (rattachement) {
			return _Utils_update(
				rattachement,
				{
					BR: A2(
						$elm$core$List$map,
						function (lie) {
							return (_Utils_cmp(lie, rang) > 0) ? (lie - 1) : lie;
						},
						A2(
							$elm$core$List$filter,
							$elm$core$Basics$neq(rang),
							rattachement.BR))
				});
		});
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$idDeLAjoutDeContact = 'nouvelle-fiche-contact-ajouter';
var $author$project$Components$Referentiel$Common$Contact$retirer = F2(
	function (rang, lignes) {
		return $author$project$Components$Referentiel$Common$Contact$unPrincipalParCanal(
			_Utils_ap(
				A2($elm$core$List$take, rang, lignes),
				A2($elm$core$List$drop, rang + 1, lignes)));
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$retirerUnContact = F2(
	function (rang, model) {
		var restantes = $elm$core$List$length(model.hP.wa) - 1;
		return ((rang < 0) || (_Utils_cmp(rang, restantes) > 0)) ? _Utils_Tuple2(model, _List_Nil) : A2(
			$elm$core$Tuple$mapSecond,
			function (_v0) {
				return _List_fromArray(
					[
						$author$project$Components$Referentiel$NouvelleFiche$Update$PlacerFocus(
						(!restantes) ? $author$project$Components$Referentiel$NouvelleFiche$Model$idDeLAjoutDeContact : A2(
							$author$project$Components$Referentiel$NouvelleFiche$Model$idDuContact,
							A2($elm$core$Basics$min, rang, restantes - 1),
							'retirer'))
					]);
			},
			A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Components$Referentiel$NouvelleFiche$Update$surLaSaisie(
					$author$project$Components$Referentiel$NouvelleFiche$Model$apresLeRetrait(rang)),
				A2(
					$author$project$Components$Referentiel$NouvelleFiche$Update$retoucher,
					$author$project$Components$Referentiel$Common$Contact$retirer(rang),
					model)));
	});
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$ajoutRefuse = F3(
	function (fiche, refus, doublons) {
		return _Utils_update(
			doublons,
			{
				fw: $elm$core$Maybe$Nothing,
				pZ: $elm$core$Maybe$Just(
					_Utils_Tuple2(fiche, refus))
			});
	});
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$ajoutRendu = function (doublons) {
	return _Utils_update(
		doublons,
		{fw: $elm$core$Maybe$Nothing});
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$roleAjoute = F3(
	function (ajout, reponse, model) {
		var rendu = _Utils_update(
			model,
			{
				xM: $author$project$Components$Referentiel$NouvelleFiche$Doublons$ajoutRendu(model.xM)
			});
		var _v0 = A2(
			$author$project$API$Reponse$lire,
			A2($elm$json$Json$Decode$field, 'vuesAJour', $elm$json$Json$Decode$bool),
			reponse);
		if (!_v0.$) {
			var vuesAJour = _v0.a;
			return _Utils_Tuple2(
				rendu,
				_List_fromArray(
					[
						A3($author$project$Components$Referentiel$NouvelleFiche$Update$OuvrirLaFiche, ajout.zo, vuesAJour, $elm$core$Maybe$Nothing),
						$author$project$Components$Referentiel$NouvelleFiche$Update$DemanderProcessUid
					]));
		} else {
			var refus = _v0.a;
			return (refus.ri === 401) ? _Utils_Tuple2(
				_Utils_update(
					rendu,
					{
						l2: $author$project$Components$Referentiel$NouvelleFiche$Model$Pret(ajout.Gn)
					}),
				_List_fromArray(
					[$author$project$Components$Referentiel$NouvelleFiche$Update$Reconnecter])) : (A2($elm$core$List$member, refus.ri, $author$project$Components$Referentiel$NouvelleFiche$Update$refusNets) ? _Utils_Tuple2(
				function () {
					var _v1 = $author$project$Components$Referentiel$NouvelleFiche$Update$refusDAjout(refus);
					if (!_v1.$) {
						var dit = _v1.a;
						return _Utils_update(
							rendu,
							{
								xM: A3($author$project$Components$Referentiel$NouvelleFiche$Doublons$ajoutRefuse, ajout.zo, dit, rendu.xM)
							});
					} else {
						return rendu;
					}
				}(),
				_List_fromArray(
					[$author$project$Components$Referentiel$NouvelleFiche$Update$DemanderProcessUid])) : _Utils_Tuple2(
				_Utils_update(
					rendu,
					{
						l2: $author$project$Components$Referentiel$NouvelleFiche$Model$Pret(ajout.Gn)
					}),
				_List_Nil));
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$sansReponse = F2(
	function (saisie, doublons) {
		return A3($author$project$Components$Referentiel$NouvelleFiche$Doublons$recus, saisie, _List_Nil, doublons);
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$Consentement = 0;
var $author$project$Components$Referentiel$NouvelleFiche$Model$Contrat = 2;
var $author$project$Components$Referentiel$NouvelleFiche$Model$InteretLegitime = 1;
var $author$project$Components$Referentiel$NouvelleFiche$Model$ObligationLegale = 3;
var $author$project$Components$Referentiel$NouvelleFiche$Model$basesLegales = _List_fromArray(
	[0, 1, 2, 3]);
var $author$project$Components$Referentiel$NouvelleFiche$Model$setBaseLegale = F2(
	function (code, saisie) {
		return _Utils_update(
			saisie,
			{
				fI: $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (base) {
							return _Utils_eq(
								$author$project$Components$Referentiel$NouvelleFiche$Model$baseLegaleCode(base),
								code);
						},
						$author$project$Components$Referentiel$NouvelleFiche$Model$basesLegales))
			});
	});
var $author$project$Referentiel$Civilites$toutes = _List_fromArray(
	['Madame', 'Monsieur']);
var $author$project$Components$Referentiel$NouvelleFiche$Model$setCivilite = F2(
	function (code, saisie) {
		return _Utils_update(
			saisie,
			{
				vh: A2($elm$core$List$member, code, $author$project$Referentiel$Civilites$toutes) ? code : ''
			});
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$setDebutDuRole = F2(
	function (date, saisie) {
		return _Utils_update(
			saisie,
			{dE: date});
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$setForme = F3(
	function (formes, valeur, saisie) {
		return _Utils_update(
			saisie,
			{
				gB: $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (uid) {
							return _Utils_eq(
								$author$project$Components$Referentiel$Identifiants$formeUidToString(uid),
								valeur);
						},
						A2(
							$elm$core$List$map,
							function ($) {
								return $.r8;
							},
							formes)))
			});
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$setIdentifiantLegal = F2(
	function (valeur, saisie) {
		return _Utils_update(
			saisie,
			{m7: valeur});
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$setIntitule = function (intitule) {
	return $author$project$Components$Referentiel$NouvelleFiche$Model$surLeRattachement(
		function (rattachement) {
			return _Utils_update(
				rattachement,
				{
					AS: A2($elm$core$String$left, 200, intitule)
				});
		});
};
var $author$project$I18n$Textes$langueAr = A3($author$project$I18n$Traductions$texte, 'langue.ar', _List_Nil, 'Arabe');
var $author$project$I18n$Textes$langueDe = A3($author$project$I18n$Traductions$texte, 'langue.de', _List_Nil, 'Allemand');
var $author$project$I18n$Textes$langueEn = A3($author$project$I18n$Traductions$texte, 'langue.en', _List_Nil, 'Anglais');
var $author$project$I18n$Textes$langueEs = A3($author$project$I18n$Traductions$texte, 'langue.es', _List_Nil, 'Espagnol');
var $author$project$I18n$Textes$langueFr = A3($author$project$I18n$Traductions$texte, 'langue.fr', _List_Nil, 'Français');
var $author$project$I18n$Textes$langueIt = A3($author$project$I18n$Traductions$texte, 'langue.it', _List_Nil, 'Italien');
var $author$project$I18n$Textes$langueJa = A3($author$project$I18n$Traductions$texte, 'langue.ja', _List_Nil, 'Japonais');
var $author$project$I18n$Textes$langueNl = A3($author$project$I18n$Traductions$texte, 'langue.nl', _List_Nil, 'Néerlandais');
var $author$project$I18n$Textes$languePl = A3($author$project$I18n$Traductions$texte, 'langue.pl', _List_Nil, 'Polonais');
var $author$project$I18n$Textes$languePt = A3($author$project$I18n$Traductions$texte, 'langue.pt', _List_Nil, 'Portugais');
var $author$project$I18n$Textes$langueRu = A3($author$project$I18n$Traductions$texte, 'langue.ru', _List_Nil, 'Russe');
var $author$project$I18n$Textes$langueZh = A3($author$project$I18n$Traductions$texte, 'langue.zh', _List_Nil, 'Chinois');
var $author$project$Referentiel$Langues$toutes = _List_fromArray(
	[
		{vx: 'fr', Bl: $author$project$I18n$Textes$langueFr},
		{vx: 'en', Bl: $author$project$I18n$Textes$langueEn},
		{vx: 'de', Bl: $author$project$I18n$Textes$langueDe},
		{vx: 'es', Bl: $author$project$I18n$Textes$langueEs},
		{vx: 'it', Bl: $author$project$I18n$Textes$langueIt},
		{vx: 'pt', Bl: $author$project$I18n$Textes$languePt},
		{vx: 'nl', Bl: $author$project$I18n$Textes$langueNl},
		{vx: 'pl', Bl: $author$project$I18n$Textes$languePl},
		{vx: 'ar', Bl: $author$project$I18n$Textes$langueAr},
		{vx: 'zh', Bl: $author$project$I18n$Textes$langueZh},
		{vx: 'ja', Bl: $author$project$I18n$Textes$langueJa},
		{vx: 'ru', Bl: $author$project$I18n$Textes$langueRu}
	]);
var $author$project$Components$Referentiel$NouvelleFiche$Model$setLangue = F2(
	function (code, saisie) {
		return _Utils_update(
			saisie,
			{
				nn: A2(
					$elm$core$List$any,
					function (langue) {
						return _Utils_eq(langue.vx, code);
					},
					$author$project$Referentiel$Langues$toutes) ? code : ''
			});
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$setNature = F2(
	function (nature, saisie) {
		return _Utils_update(
			saisie,
			{g1: nature});
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$setNom = F2(
	function (nom, saisie) {
		return _Utils_update(
			saisie,
			{Dj: nom});
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$setOffre = F2(
	function (id, saisie) {
		return _Utils_update(
			saisie,
			{D1: id});
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$setOrganisation = function (terme) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Components$Referentiel$NouvelleFiche$Model$setRecherche(
			$author$project$Components$Referentiel$Common$RechercheDeFiche$setTerme(terme)),
		$author$project$Components$Referentiel$NouvelleFiche$Model$surLeRattachement(
			function (rattachement) {
				return _Utils_update(
					rattachement,
					{BR: _List_Nil});
			}));
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$setPays = F2(
	function (code, saisie) {
		return _Utils_update(
			saisie,
			{ho: code});
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$setPrenom = F2(
	function (prenom, saisie) {
		return _Utils_update(
			saisie,
			{Gg: prenom});
	});
var $author$project$Components$Referentiel$Common$Contact$setPrincipal = F2(
	function (rang, lignes) {
		var _v0 = A2($elm$core$List$drop, rang, lignes);
		if (_v0.b) {
			var choisie = _v0.a;
			return A2(
				$elm$core$List$indexedMap,
				F2(
					function (courant, ligne) {
						return _Utils_eq(ligne.uF, choisie.uF) ? _Utils_update(
							ligne,
							{
								px: _Utils_eq(courant, rang)
							}) : ligne;
					}),
				lignes);
		} else {
			return lignes;
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$setQualite = F2(
	function (qualite, saisie) {
		return _Utils_update(
			saisie,
			{hy: qualite});
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$setRaisonSociale = F2(
	function (raisonSociale, saisie) {
		return _Utils_update(
			saisie,
			{GR: raisonSociale});
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$setResponsable = F2(
	function (uid, saisie) {
		return _Utils_update(
			saisie,
			{qB: uid});
	});
var $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$societesDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'societesARattacher',
			$elm$json$Json$Decode$list($author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$candidat)),
			$elm$json$Json$Decode$succeed(_List_Nil)
		]));
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$societeDecochee = F2(
	function (doublons, societes) {
		return doublons.b2 && _Utils_eq(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.r8;
				},
				societes),
			A2(
				$elm$core$List$map,
				function ($) {
					return $.r8;
				},
				doublons.b4));
	});
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$societesRecues = F3(
	function (saisie, societes, doublons) {
		return _Utils_eq(saisie, doublons.hP) ? _Utils_update(
			doublons,
			{
				b2: A2($author$project$Components$Referentiel$NouvelleFiche$Doublons$societeDecochee, doublons, societes),
				b4: societes
			}) : doublons;
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$surLeLien = F2(
	function (msg, model) {
		var _v0 = A2($author$project$Components$Referentiel$Common$ChoixDeLien$update, msg, model.nQ);
		var liens = _v0.a;
		var demande = _v0.b;
		var valeur = _v0.c;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					jE: function () {
						if (!valeur.$) {
							var _v2 = valeur.a;
							var cle = _v2.a;
							var choisie = _v2.b;
							return A2(
								$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$saisir,
								A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$Saisi, cle, choisie),
								model.jE);
						} else {
							return model.jE;
						}
					}(),
					nQ: liens
				}),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$NouvelleFiche$Update$ChercherDesNommees, $elm$core$List$singleton),
					demande)));
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$saisieEnCours = function (model) {
	return !_Utils_eq(model.hP, $author$project$Components$Referentiel$NouvelleFiche$Model$init);
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$surLeVolet = F2(
	function (voletMsg, model) {
		var initial = $author$project$Components$Referentiel$NouvelleFiche$Model$initial;
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{
				Il: $author$project$Components$Referentiel$NouvelleFiche$Model$saisieEnCours(model)
			},
			voletMsg,
			model.im);
		var volet = _v0.a;
		var effets = _v0.b;
		var vide = _Utils_update(
			initial,
			{gF: model.gF, im: volet});
		return _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(volet) ? _Utils_update(
				model,
				{im: volet}) : vide,
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Referentiel$NouvelleFiche$Update$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$typeLu = function (reponse) {
	return A2(
		$elm$core$Maybe$andThen,
		$elm$core$Basics$identity,
		$elm$core$Result$toMaybe(
			A2($elm$json$Json$Decode$decodeString, $author$project$Components$Referentiel$Common$API$QueryAPIModel$typeEtablissementDecoder, reponse.f$)));
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$AttendreAvantDeRelireLaFicheRejouee = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$verifier = F3(
	function (entite, reponse, model) {
		var _v0 = model.iB;
		if (!_v0.$) {
			var attendue = _v0.a;
			if (!_Utils_eq(attendue.yt, entite)) {
				return _Utils_Tuple2(model, _List_Nil);
			} else {
				var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$API$QueryAPIModel$ficheDecoder, reponse);
				if (!_v1.$) {
					var vue = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iB: $elm$core$Maybe$Nothing,
								kd: A2(
									$author$project$Components$Referentiel$Common$Rejeu$confirme,
									$author$project$Components$Referentiel$NouvelleFiche$Model$attendue(attendue.gn),
									vue) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(entite)
							}),
						_List_Nil);
				} else {
					var refus = _v1.a;
					return ((refus.ri === 404) && (_Utils_cmp(attendue.Hv, $author$project$Components$Referentiel$Common$Relecture$max) < 0)) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iB: $elm$core$Maybe$Just(
									_Utils_update(
										attendue,
										{Hv: attendue.Hv + 1}))
							}),
						_List_fromArray(
							[
								A2($author$project$Components$Referentiel$NouvelleFiche$Update$AttendreAvantDeRelireLaFicheRejouee, entite, $author$project$Components$Referentiel$Common$Relecture$delaiMs)
							])) : _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iB: $elm$core$Maybe$Nothing,
								oI: $elm$core$Maybe$Just(entite)
							}),
						_List_Nil);
				}
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$traiter = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var liens = msg.a;
				return A2($author$project$Components$Referentiel$NouvelleFiche$Update$ouvrir, liens, model);
			case 57:
				var declencheur = msg.a;
				return A2(
					$author$project$Components$Referentiel$NouvelleFiche$Update$surLeVolet,
					$author$project$Components$Shared$Drawer$Update$Ouvrir(declencheur),
					model);
			case 58:
				var voletMsg = msg.a;
				return A2($author$project$Components$Referentiel$NouvelleFiche$Update$surLeVolet, voletMsg, model);
			case 1:
				var gabarits = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gF: gabarits}),
					_List_Nil);
			case 3:
				var organisation = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							iQ: $elm$core$Maybe$Just(organisation)
						}),
					_List_Nil);
			case 4:
				var terme = msg.a;
				var saisie = A2($author$project$Components$Referentiel$NouvelleFiche$Model$setOrganisation, terme, model.hP);
				var cherchee = saisie.pN.hC;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{hP: saisie}),
					_Utils_eq(
						$author$project$Components$Referentiel$Common$RechercheDeFiche$aChercher(cherchee),
						$elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
						[
							A2($author$project$Components$Referentiel$NouvelleFiche$Update$AttendreAvantDeChercherLOrganisation, cherchee.hP, $author$project$Components$Referentiel$Common$RechercheDeFiche$delaiMs)
						]));
			case 5:
				var frappe = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A3(
							$elm$core$Maybe$map2,
							F2(
								function (terme, lien) {
									return _List_fromArray(
										[
											A2(
											$author$project$Components$Referentiel$NouvelleFiche$Update$ChercherLOrganisation,
											lien,
											A2($author$project$Components$Referentiel$Common$RechercheDeFiche$corps, 1, terme))
										]);
								}),
							A2($author$project$Components$Referentiel$Common$RechercheDeFiche$delaiEcoule, frappe, model.hP.pN.hC),
							$author$project$Components$Referentiel$NouvelleFiche$Model$lienDeLaRecherche(model))));
			case 6:
				var terme = msg.a;
				var reponse = msg.b;
				var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$organisationsDecoder, reponse);
				if (!_v1.$) {
					var liees = _v1.a;
					return A2(
						$author$project$Components$Referentiel$NouvelleFiche$Update$saisir,
						$author$project$Components$Referentiel$NouvelleFiche$Model$setRecherche(
							A2(
								$author$project$Components$Referentiel$Common$RechercheDeFiche$recevoir,
								terme,
								A3($author$project$Components$Referentiel$Common$RechercheDeFiche$propositions, 1, $elm$core$Maybe$Nothing, liees))),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 7:
				var uid = msg.a;
				return $author$project$Components$Referentiel$NouvelleFiche$Update$lireLesPostes(
					A2(
						$author$project$Components$Referentiel$NouvelleFiche$Update$saisir,
						$author$project$Components$Referentiel$NouvelleFiche$Model$choisirLOrganisation(uid),
						model));
			case 8:
				var reponse = msg.a;
				var _v2 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$postesDecoder, reponse);
				if (!_v2.$) {
					var postes = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{F6: postes}),
						_List_Nil);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 9:
				var valeur = msg.a;
				return A2(
					$author$project$Components$Referentiel$NouvelleFiche$Update$saisir,
					A2($author$project$Components$Referentiel$NouvelleFiche$Model$setPoste, model.F6, valeur),
					model);
			case 10:
				var intitule = msg.a;
				return A2(
					$author$project$Components$Referentiel$NouvelleFiche$Update$saisir,
					$author$project$Components$Referentiel$NouvelleFiche$Model$setIntitule(intitule),
					model);
			case 11:
				var octets = msg.a;
				return A2($author$project$Components$Referentiel$NouvelleFiche$Update$recevoirLeProcessUid, octets, model);
			case 12:
				var reponse = msg.a;
				var _v3 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$typesAvecSaisieDecoder, reponse);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var types = _v4.a;
					var saisie = _v4.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								nQ: A2($author$project$Components$Referentiel$NouvelleFiche$Update$avecLesRecherches, reponse, model.nQ),
								qV: saisie,
								ib: types
							}),
						_List_Nil);
				} else {
					var refus = _v3.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{qV: $author$project$Components$Referentiel$NouvelleFiche$Model$initial.qV, ib: _List_Nil}),
						$author$project$Components$Referentiel$NouvelleFiche$Update$reconnexion(refus));
				}
			case 14:
				var reponse = msg.a;
				var _v5 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$formesDecoder, reponse);
				if (!_v5.$) {
					var formes = _v5.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{zS: formes}),
						_List_Nil);
				} else {
					var refus = _v5.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{zS: _List_Nil}),
						$author$project$Components$Referentiel$NouvelleFiche$Update$reconnexion(refus));
				}
			case 15:
				var valeur = msg.a;
				return A2(
					$author$project$Components$Referentiel$NouvelleFiche$Update$saisir,
					A2($author$project$Components$Referentiel$NouvelleFiche$Model$setForme, model.zS, valeur),
					model);
			case 17:
				var nature = msg.a;
				return A2(
					$author$project$Components$Referentiel$NouvelleFiche$Update$saisir,
					$author$project$Components$Referentiel$NouvelleFiche$Model$setNature(nature),
					model);
			case 18:
				var qualite = msg.a;
				return A2(
					$author$project$Components$Referentiel$NouvelleFiche$Update$saisir,
					$author$project$Components$Referentiel$NouvelleFiche$Model$setQualite(qualite),
					model);
			case 19:
				var prenom = msg.a;
				return A2(
					$author$project$Components$Referentiel$NouvelleFiche$Update$saisir,
					$author$project$Components$Referentiel$NouvelleFiche$Model$setPrenom(prenom),
					model);
			case 20:
				var nom = msg.a;
				return A2(
					$author$project$Components$Referentiel$NouvelleFiche$Update$saisir,
					$author$project$Components$Referentiel$NouvelleFiche$Model$setNom(nom),
					model);
			case 21:
				var raisonSociale = msg.a;
				return A2(
					$author$project$Components$Referentiel$NouvelleFiche$Update$saisir,
					$author$project$Components$Referentiel$NouvelleFiche$Model$setRaisonSociale(raisonSociale),
					model);
			case 22:
				var valeur = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bI: false,
							hP: A2($author$project$Components$Referentiel$NouvelleFiche$Model$setIdentifiantLegal, valeur, model.hP)
						}),
					_List_Nil);
			case 23:
				var code = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bI: false,
							hP: A2($author$project$Components$Referentiel$NouvelleFiche$Model$setPays, code, model.hP)
						}),
					_List_Nil);
			case 24:
				var code = msg.a;
				return A2(
					$author$project$Components$Referentiel$NouvelleFiche$Update$saisir,
					$author$project$Components$Referentiel$NouvelleFiche$Model$setCivilite(code),
					model);
			case 25:
				var code = msg.a;
				return A2(
					$author$project$Components$Referentiel$NouvelleFiche$Update$saisir,
					$author$project$Components$Referentiel$NouvelleFiche$Model$setLangue(code),
					model);
			case 26:
				var uid = msg.a;
				return A2(
					$author$project$Components$Referentiel$NouvelleFiche$Update$saisir,
					$author$project$Components$Referentiel$NouvelleFiche$Model$setResponsable(uid),
					model);
			case 27:
				var etape = msg.a;
				var reponse = msg.b;
				var _v6 = A2($author$project$Components$Referentiel$Common$Equipe$avancer, etape, reponse);
				if (!_v6.$) {
					var membres = _v6.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l5: $author$project$Components$Referentiel$Common$Equipe$Lue(membres)
							}),
						_List_Nil);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 28:
				var code = msg.a;
				return A2(
					$author$project$Components$Referentiel$NouvelleFiche$Update$saisir,
					$author$project$Components$Referentiel$NouvelleFiche$Model$setBaseLegale(code),
					model);
			case 29:
				var valeur = msg.a;
				return A2($author$project$Components$Referentiel$NouvelleFiche$Update$choisirLeType, valeur, model);
			case 30:
				var id = msg.a;
				return A2(
					$author$project$Components$Referentiel$NouvelleFiche$Update$saisir,
					$author$project$Components$Referentiel$NouvelleFiche$Model$setOffre(id),
					_Utils_update(
						model,
						{
							xM: $author$project$Components$Referentiel$NouvelleFiche$Doublons$sansRefus(model.xM)
						}));
			case 13:
				var reponse = msg.a;
				var _v7 = A2(
					$author$project$API$Reponse$lire,
					$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$QueryAPIModel$offreProposeeDecoder),
					reponse);
				if (!_v7.$) {
					var offres = _v7.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								D3: $author$project$Components$Referentiel$Common$Offres$Lue(
									$author$project$Components$Referentiel$Common$Offres$depuis(offres))
							}),
						_List_Nil);
				} else {
					var refus = _v7.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{D3: $author$project$Components$Referentiel$Common$Offres$Illisible}),
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Referentiel$NouvelleFiche$Update$Reconnecter]) : _List_Nil);
				}
			case 2:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$NouvelleFiche$Update$surLeLien, geste, model);
			case 16:
				if (msg.a.$ === 2) {
					var cle = msg.a.a;
					return A2($author$project$Components$Referentiel$NouvelleFiche$Update$ouvrirUnLien, cle, model);
				} else {
					var geste = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								jE: A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$saisir, geste, model.jE)
							}),
						_List_Nil);
				}
			case 31:
				var date = msg.a;
				return A2(
					$author$project$Components$Referentiel$NouvelleFiche$Update$saisir,
					$author$project$Components$Referentiel$NouvelleFiche$Model$setDebutDuRole(date),
					model);
			case 32:
				return $author$project$Components$Referentiel$NouvelleFiche$Update$ajouterUnContact(model);
			case 33:
				var rang = msg.a;
				return A2($author$project$Components$Referentiel$NouvelleFiche$Update$retirerUnContact, rang, model);
			case 34:
				var rang = msg.a;
				var code = msg.b;
				return A2(
					$author$project$Components$Referentiel$NouvelleFiche$Update$retoucher,
					A2($author$project$Components$Referentiel$Common$Contact$setCanal, rang, code),
					model);
			case 35:
				var rang = msg.a;
				var valeur = msg.b;
				return A2(
					$author$project$Components$Referentiel$NouvelleFiche$Update$retoucher,
					A2($author$project$Components$Referentiel$Common$Contact$setValeur, rang, valeur),
					model);
			case 36:
				var rang = msg.a;
				var champ = msg.b;
				var valeur = msg.c;
				return A2(
					$author$project$Components$Referentiel$NouvelleFiche$Update$retoucher,
					A3($author$project$Components$Referentiel$Common$Contact$setAdresse, rang, champ, valeur),
					model);
			case 37:
				var rang = msg.a;
				var code = msg.b;
				return _Utils_eq(code, $author$project$Components$Referentiel$NouvelleFiche$Model$codeDUsageLie) ? A2(
					$author$project$Components$Referentiel$NouvelleFiche$Update$saisir,
					$author$project$Components$Referentiel$NouvelleFiche$Model$lier(rang),
					model) : A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Components$Referentiel$NouvelleFiche$Update$surLaSaisie(
						$author$project$Components$Referentiel$NouvelleFiche$Model$delier(rang)),
					A2(
						$author$project$Components$Referentiel$NouvelleFiche$Update$retoucher,
						A2($author$project$Components$Referentiel$Common$Contact$setUsage, rang, code),
						model));
			case 38:
				var rang = msg.a;
				return A2(
					$author$project$Components$Referentiel$NouvelleFiche$Update$retoucher,
					$author$project$Components$Referentiel$Common$Contact$setPrincipal(rang),
					model);
			case 39:
				var rang = msg.a;
				var accord = msg.b;
				return A2(
					$author$project$Components$Referentiel$NouvelleFiche$Update$retoucher,
					A2($author$project$Components$Referentiel$Common$Contact$setProspection, rang, accord),
					model);
			case 40:
				var suite = msg.a;
				return A2($author$project$Components$Referentiel$NouvelleFiche$Update$demander, suite, model);
			case 42:
				var entite = msg.a;
				var reponse = msg.b;
				return A3($author$project$Components$Referentiel$NouvelleFiche$Update$verifier, entite, reponse, model);
			case 43:
				var entite = msg.a;
				var _v8 = model.iB;
				if (!_v8.$) {
					var attendue = _v8.a;
					return _Utils_Tuple2(
						model,
						_Utils_eq(attendue.yt, entite) ? _List_fromArray(
							[
								$author$project$Components$Referentiel$NouvelleFiche$Update$LireLaFicheRejouee(entite)
							]) : _List_Nil);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 44:
				var saisie = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (_v9) {
								var lien = _v9.a;
								var criteres = _v9.b;
								return _List_fromArray(
									[
										A3($author$project$Components$Referentiel$NouvelleFiche$Update$ChercherLesDoublons, lien, saisie, criteres)
									]);
							},
							A2($author$project$Components$Referentiel$NouvelleFiche$Doublons$delaiEcoule, saisie, model.xM))));
			case 45:
				var saisie = msg.a;
				var reponse = msg.b;
				var _v10 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$doublonsDecoder, reponse);
				if (!_v10.$) {
					var candidats = _v10.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								xM: A3(
									$author$project$Components$Referentiel$NouvelleFiche$Doublons$personneEffaceeRecue,
									saisie,
									A2(
										$elm$core$Maybe$andThen,
										$elm$core$Basics$identity,
										$elm$core$Result$toMaybe(
											A2($elm$json$Json$Decode$decodeString, $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$personneEffaceeDecoder, reponse.f$))),
									A3(
										$author$project$Components$Referentiel$NouvelleFiche$Doublons$societesRecues,
										saisie,
										A2(
											$elm$core$Result$withDefault,
											_List_Nil,
											A2($elm$json$Json$Decode$decodeString, $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$societesDecoder, reponse.f$)),
										A3($author$project$Components$Referentiel$NouvelleFiche$Doublons$recus, saisie, candidats, model.xM)))
							}),
						_List_Nil);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								xM: A2($author$project$Components$Referentiel$NouvelleFiche$Doublons$sansReponse, saisie, model.xM)
							}),
						_List_Nil);
				}
			case 48:
				var coche = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							xM: A2($author$project$Components$Referentiel$NouvelleFiche$Doublons$rattacherALaSociete, coche, model.xM)
						}),
					_List_Nil);
			case 49:
				var reponse = msg.a;
				return A3(
					$author$project$Components$Referentiel$NouvelleFiche$Update$lireLeRattachement,
					function (societe) {
						return _Utils_update(
							societe,
							{
								r0: $author$project$Components$Referentiel$NouvelleFiche$Update$typeLu(reponse)
							});
					},
					reponse,
					model);
			case 50:
				var reponse = msg.a;
				return A3(
					$author$project$Components$Referentiel$NouvelleFiche$Update$lireLeRattachement,
					function (societe) {
						return _Utils_update(
							societe,
							{
								Hy: A2(
									$elm$core$Maybe$andThen,
									$elm$core$Basics$identity,
									$elm$core$Result$toMaybe(
										A2($elm$json$Json$Decode$decodeString, $author$project$Components$Referentiel$NouvelleFiche$API$QueryAPIModel$lienRelierDecoder, reponse.f$)))
							});
					},
					reponse,
					model);
			case 51:
				return $author$project$Components$Referentiel$NouvelleFiche$Update$conclureLeRattachement(model);
			case 47:
				var coche = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							xM: A2($author$project$Components$Referentiel$NouvelleFiche$Doublons$caseCochee, coche, model.xM)
						}),
					_List_Nil);
			case 46:
				var uid = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							xM: A2($author$project$Components$Referentiel$NouvelleFiche$Doublons$ecarter, uid, model.xM)
						}),
					_List_Nil);
			case 52:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							xM: $author$project$Components$Referentiel$NouvelleFiche$Doublons$basculerLesHomonymes(model.xM)
						}),
					_List_Nil);
			case 53:
				var uid = msg.a;
				var _v11 = model.l2;
				if (_v11.$ === 1) {
					var processUid = _v11.a;
					var _v12 = A5(
						$author$project$Components$Referentiel$NouvelleFiche$Doublons$ajouterLeRole,
						uid,
						model.hP.r0,
						$author$project$Components$Referentiel$NouvelleFiche$Model$offreDuPremierRole(model.hP),
						processUid,
						model.xM);
					if (!_v12.$) {
						var ajout = _v12.a;
						var doublons = model.xM;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									xM: _Utils_update(
										doublons,
										{
											fw: $elm$core$Maybe$Just(ajout),
											pZ: $elm$core$Maybe$Nothing
										}),
									l2: $author$project$Components$Referentiel$NouvelleFiche$Model$SansProcessUid
								}),
							_List_fromArray(
								[
									$author$project$Components$Referentiel$NouvelleFiche$Update$AjouterLeRole(ajout)
								]));
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 54:
				var uid = msg.a;
				var reponse = msg.b;
				var _v13 = model.xM.fw;
				if (!_v13.$) {
					var ajout = _v13.a;
					return _Utils_eq(ajout.zo, uid) ? A3($author$project$Components$Referentiel$NouvelleFiche$Update$roleAjoute, ajout, reponse, model) : _Utils_Tuple2(model, _List_Nil);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 55:
				var uid = msg.a;
				var _v14 = model.l2;
				if (_v14.$ === 1) {
					var processUid = _v14.a;
					var _v15 = A3($author$project$Components$Referentiel$NouvelleFiche$Doublons$restaurerLaFiche, uid, processUid, model.xM);
					if (!_v15.$) {
						var restauration = _v15.a;
						var doublons = model.xM;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									xM: _Utils_update(
										doublons,
										{
											eV: $elm$core$Maybe$Just(restauration)
										}),
									l2: $author$project$Components$Referentiel$NouvelleFiche$Model$SansProcessUid
								}),
							_List_fromArray(
								[
									$author$project$Components$Referentiel$NouvelleFiche$Update$RestaurerLaFiche(restauration)
								]));
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 56:
				var uid = msg.a;
				var reponse = msg.b;
				var _v16 = model.xM.eV;
				if (!_v16.$) {
					var restauration = _v16.a;
					return _Utils_eq(restauration.zo, uid) ? A3($author$project$Components$Referentiel$NouvelleFiche$Update$ficheRestauree, restauration, reponse, model) : _Utils_Tuple2(model, _List_Nil);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			default:
				var reponse = msg.a;
				var _v17 = _Utils_Tuple2(
					model.l2,
					A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIModel$reponseDecoder, reponse));
				if (_v17.a.$ === 2) {
					if (!_v17.b.$) {
						var _v18 = _v17.a;
						var suite = _v18.b;
						var creee = _v17.b.a;
						return (reponse.ri === 200) ? A3($author$project$Components$Referentiel$NouvelleFiche$Update$rejouer, suite, creee, model) : A3($author$project$Components$Referentiel$NouvelleFiche$Update$poursuivre, suite, creee, model);
					} else {
						var _v19 = _v17.a;
						var processUid = _v19.a;
						var refus = _v17.b.a;
						return A2(
							$author$project$Components$Referentiel$NouvelleFiche$Update$relireLesPostesSiArchive,
							refus,
							A2(
								$elm$core$Tuple$mapSecond,
								function (effets) {
									return _Utils_ap(
										effets,
										A2($author$project$Components$Referentiel$NouvelleFiche$Update$focusDuRefus, reponse, model));
								},
								A2(
									$elm$core$Tuple$mapFirst,
									function (refuse) {
										return _Utils_update(
											refuse,
											{
												jE: A2($author$project$Components$Referentiel$NouvelleFiche$Update$refusDesChamps, reponse, refuse.jE),
												bI: $author$project$Components$Referentiel$NouvelleFiche$API$WriteAPIErrorsModel$duRefus(refus) === 12,
												gU: A2($author$project$Components$Referentiel$NouvelleFiche$Update$ligneEnDouble, refus, reponse.f$)
											});
									},
									A3($author$project$Components$Referentiel$NouvelleFiche$Update$refuser, processUid, refus, model))));
					}
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$estOuvertureDeFiche = function (effet) {
	switch (effet.$) {
		case 6:
			return true;
		case 7:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$voletApres = F2(
	function (effets, volet) {
		return A2($elm$core$List$any, $author$project$Components$Referentiel$NouvelleFiche$Update$estOuvertureDeFiche, effets) ? _Utils_update(
			volet,
			{wQ: $elm$core$Maybe$Nothing, gt: 0}) : volet;
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$update = F2(
	function (msg, model) {
		var _v0 = A2($author$project$Components$Referentiel$NouvelleFiche$Update$traiter, msg, model);
		var suivant = _v0.a;
		var effets = _v0.b;
		var _v1 = A2(
			$author$project$Components$Referentiel$NouvelleFiche$Doublons$apresLaSaisie,
			$author$project$Components$Referentiel$NouvelleFiche$Model$criteresDeDoublon(suivant.hP),
			suivant.xM);
		var doublons = _v1.a;
		var aChercher = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				suivant,
				{
					xM: doublons,
					im: A2($author$project$Components$Referentiel$NouvelleFiche$Update$voletApres, effets, suivant.im)
				}),
			_Utils_ap(
				effets,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (saisie) {
							return _List_fromArray(
								[
									A2($author$project$Components$Referentiel$NouvelleFiche$Update$AttendreAvantDeChercherLesDoublons, saisie, $author$project$Components$Referentiel$NouvelleFiche$Doublons$delaiDeRechercheMs)
								]);
						},
						aChercher))));
	});
var $author$project$Main$Update$depuisLaFiche = F3(
	function (i18n, effet, _v8) {
		var model = _v8.a;
		var effets = _v8.b;
		switch (effet.$) {
			case 0:
				var uid = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$LireFiche(
									{gM: vers.gM, nB: vers.nB, r8: uid});
							})));
			case 4:
				var uid = effet.a;
				var delaiMs = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								A2($author$project$Main$Update$AttendreAvantDeRelire, uid, delaiMs)
							])));
			case 33:
				var uid = effet.a;
				var lecture = effet.b;
				var lien = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$LireLaChronologieDeLaFiche(
									{gM: vers.gM, np: lecture, nB: vers.nB, r8: uid});
							})));
			case 34:
				var uid = effet.a;
				var lecture = effet.b;
				var lien = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$LireLHistoriqueDuChampDeLaFiche(
									{gM: vers.gM, np: lecture, nB: vers.nB, r8: uid});
							})));
			case 5:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
			case 6:
				var uid = effet.a;
				var nature = effet.b;
				var declencheur = effet.c;
				var recherche = effet.d;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A3(
						$author$project$Main$Update$versLaFusion,
						i18n,
						A4(
							$author$project$Components$Referentiel$Fusion$Update$VoletOuvert,
							uid,
							$author$project$Main$Update$natureDeLaFiche(nature),
							declencheur,
							recherche),
						model));
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[3]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 15:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			case 16:
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[$author$project$Main$Update$LireLeDefilementDeLaFiche])));
			case 9:
				var lien = effet.a;
				var processUid = effet.b;
				var entite = effet.c;
				var version = effet.d;
				var type_ = effet.e;
				var champs = effet.f;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$ModifierLeBlocDeLaFiche(
									{dw: champs, yt: entite, gM: vers.gM, nB: vers.nB, Gn: processUid, r0: type_, sq: version});
							})));
			case 10:
				var lien = effet.a;
				var processUid = effet.b;
				var entite = effet.c;
				var geste = effet.d;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$GererUneOccurrenceDeLaFiche(
									{yt: entite, mW: geste, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 13:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$LireTypesDeLaFiche(
									{gM: vers.gM, nB: vers.nB});
							})));
			case 14:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$LireLesOffresDeLaFiche(
									{gM: vers.gM, nB: vers.nB});
							})));
			case 12:
				var lien = effet.a;
				var processUid = effet.b;
				var entite = effet.c;
				var commande = effet.d;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerAuRoleDeLaFiche(
									{vJ: commande, yt: entite, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 11:
				var lien = effet.a;
				var processUid = effet.b;
				var entite = effet.c;
				var commande = effet.d;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerAuContactDeLaFiche(
									{vJ: commande, yt: entite, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 17:
				var lien = effet.a;
				var processUid = effet.b;
				var entite = effet.c;
				var commande = effet.d;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerALaLiaisonDeLaFiche(
									{
										vJ: commande,
										yt: entite,
										zo: A2(
											$elm$core$Maybe$withDefault,
											entite,
											$author$project$Components$Referentiel$Fiche$Model$ouvrir(model.zo).kD),
										gM: vers.gM,
										nB: vers.nB,
										Gn: processUid
									});
							})));
			case 18:
				var lien = effet.a;
				var processUid = effet.b;
				var entite = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerUnGesteDeLaFiche(
									{yt: entite, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 19:
				var lien = effet.a;
				var processUid = effet.b;
				var entite = effet.c;
				var cloreAussi = effet.d;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$CloreLaFicheDeLaFiche(
									{vp: cloreAussi, yt: entite, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 21:
				var entite = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$LireLApercuDeLEffacementDeLaFiche(
									{yt: entite, gM: vers.gM, nB: vers.nB});
							})));
			case 24:
				var lien = effet.a;
				var processUid = effet.b;
				var entite = effet.c;
				var contact = effet.d;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EffacerUnContactDeLaFiche(
									{v8: contact, yt: entite, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 23:
				var lien = effet.a;
				var processUid = effet.b;
				var entite = effet.c;
				var motif = effet.d;
				var precision = effet.e;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$ProgrammerLEffacementDeLaFiche(
									{yt: entite, gM: vers.gM, nB: vers.nB, cX: motif, Gd: precision, Gn: processUid});
							})));
			case 25:
				var lien = effet.a;
				var processUid = effet.b;
				var entite = effet.c;
				var formats = effet.d;
				var demandeRecueLe = effet.e;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$ExporterLesDonneesDeLaFiche(
									{w9: demandeRecueLe, yt: entite, zR: formats, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 26:
				var fichiers = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$TelechargerLesFichiers(fichiers)
							])));
			case 20:
				var entite = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$LireLApercuDeLaClotureDeLaFiche(
									{yt: entite, gM: vers.gM, nB: vers.nB});
							})));
			case 22:
				var entite = effet.a;
				var lien = effet.b;
				var demande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$LireLApercuDeLExportDeLaFiche(
									{kC: demande, yt: entite, gM: vers.gM, nB: vers.nB});
							})));
			case 27:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$LirePostesDeLaFiche(
									{gM: vers.gM, nB: vers.nB});
							})));
			case 3:
				var numero = effet.a;
				var delaiMs = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								A2($author$project$Main$Update$AttendreAvantDeChercherUnDoublonDeLaFiche, numero, delaiMs)
							])));
			case 2:
				var lien = effet.a;
				var numero = effet.b;
				var pays = effet.c;
				var valeur = effet.d;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$ChercherUnDoublonDeLaFiche(
									{gM: vers.gM, nB: vers.nB, DX: numero, ho: pays, fm: valeur});
							})));
			case 28:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$LireLesFormesDeLaFiche(
									{gM: vers.gM, nB: vers.nB});
							})));
			case 30:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$LireTypesDeRelationDeLaFiche(
									{gM: vers.gM, nB: vers.nB});
							})));
			case 1:
				var demande = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							demande.nB,
							function (vers) {
								return $author$project$Main$Update$ChercherDesNommeesDeLaFiche(
									{
										kC: _Utils_update(
											demande,
											{nB: vers.nB}),
										gM: vers.gM
									});
							})));
			case 29:
				var lien = effet.a;
				var recherche = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$ChercherPourLaFiche(
									{gM: vers.gM, nB: vers.nB, hC: recherche});
							})));
			case 32:
				var uid = effet.a;
				var nom = effet.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (deLaCreation) {
						return _Utils_ap(
							effets,
							_Utils_ap(
								deLaCreation,
								_List_fromArray(
									[
										$author$project$Main$Update$AllerA($author$project$Routes$Route$adressePartiesPrenantes)
									])));
					},
					A3(
						$author$project$Main$Update$versLaNouvelleFiche,
						i18n,
						$author$project$Components$Referentiel$NouvelleFiche$Update$RattachementAnnonce(
							{Dj: nom, r8: uid}),
						model));
			case 31:
				var saisie = effet.a;
				var delaiMs = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								A2($author$project$Main$Update$AttendreAvantDeChercherPourLaFiche, saisie, delaiMs)
							])));
			default:
				var lien = effet.a;
				var processUid = effet.b;
				var entite = effet.c;
				var version = effet.d;
				var modifications = effet.e;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$ModifierLaFiche(
									{yt: entite, gM: vers.gM, nB: vers.nB, g$: modifications, Gn: processUid, sq: version});
							})));
		}
	});
var $author$project$Main$Update$depuisLaFusion = F3(
	function (i18n, effet, _v6) {
		var model = _v6.a;
		var effets = _v6.b;
		var sur = F2(
			function (lien, faire) {
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$ExecuterFusion(
									{
										lO: faire(vers.nB),
										gM: vers.gM
									});
							})));
			});
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[33]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 1:
				var place = effet.a;
				var lien = effet.b;
				return A2(
					sur,
					lien,
					$author$project$Components$Referentiel$Fusion$Effet$LireFiche(place));
			case 2:
				var lien = effet.a;
				var terme = effet.b;
				return A2(
					sur,
					lien,
					function (resolu) {
						return A2($author$project$Components$Referentiel$Fusion$Effet$ChercherDesFiches, resolu, terme);
					});
			case 3:
				var lien = effet.a;
				return A2(sur, lien, $author$project$Components$Referentiel$Fusion$Effet$LireLApercu);
			case 4:
				var lien = effet.a;
				return A2(sur, lien, $author$project$Components$Referentiel$Fusion$Effet$LireLAvancement);
			case 6:
				var lien = effet.a;
				var commande = effet.b;
				return A2(
					sur,
					lien,
					function (resolu) {
						return A2($author$project$Components$Referentiel$Fusion$Effet$Fusionner, resolu, commande);
					});
			case 5:
				var saisie = effet.a;
				var delaiMs = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$ExecuterFusion(
								{
									lO: A2($author$project$Components$Referentiel$Fusion$Effet$AttendreAvantDeChercher, saisie, delaiMs),
									gM: ''
								})
							])));
			case 7:
				var adresse = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AllerA(adresse)
							])));
			case 8:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A3($author$project$Main$Update$versLaFiche, i18n, $author$project$Components$Referentiel$Fiche$Update$FusionAnnoncee, model));
			case 9:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Main$Update$depuisLaNouvelleFiche = F3(
	function (i18n, effet, _v4) {
		var model = _v4.a;
		var effets = _v4.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[1]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 1:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireTypes)));
			case 2:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesOffresDeLaCreation)));
			case 5:
				var lien = effet.a;
				var processUid = effet.b;
				var fiche = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$CreerLaFiche(
									{zo: fiche, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 18:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			case 6:
				var uid = effet.a;
				var vuesAJour = effet.b;
				var rejouee = effet.c;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (deLaFiche) {
						return _Utils_ap(
							effets,
							_Utils_ap(
								deLaFiche,
								_List_fromArray(
									[
										$author$project$Main$Update$AllerA(
										$author$project$Routes$Route$toString(
											A2($author$project$Routes$Route$Fiche, uid, 0)))
									])));
					},
					A3(
						$author$project$Main$Update$versLaFiche,
						i18n,
						A3(
							$author$project$Components$Referentiel$Fiche$Update$Annoncee,
							uid,
							vuesAJour,
							A2($elm$core$Maybe$map, $author$project$Components$Referentiel$NouvelleFiche$Model$attendue, rejouee)),
						model));
			case 7:
				var organisation = effet.a;
				var vuesAJour = effet.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (deLaFiche) {
						return _Utils_ap(
							effets,
							_Utils_ap(
								deLaFiche,
								_List_fromArray(
									[
										$author$project$Main$Update$AllerA(
										$author$project$Routes$Route$toString(
											A2($author$project$Routes$Route$Fiche, organisation, 2)))
									])));
					},
					A3(
						$author$project$Main$Update$versLaFiche,
						i18n,
						A3($author$project$Components$Referentiel$Fiche$Update$Annoncee, organisation, vuesAJour, $elm$core$Maybe$Nothing),
						model));
			case 8:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
			case 9:
				var uid = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (lien) {
									return A3(
										$author$project$Main$Update$versLApi,
										model,
										lien,
										function (vers) {
											return $author$project$Main$Update$LireFicheRejouee(
												{gM: vers.gM, nB: vers.nB, r8: uid});
										});
								},
								A2(
									$elm$core$Maybe$andThen,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.gF;
										},
										$author$project$Components$Referentiel$Liens$versEntite(uid)),
									$author$project$Main$Update$liensDeLaRacine(model))))));
			case 10:
				var uid = effet.a;
				var delaiMs = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								A2($author$project$Main$Update$AttendreAvantDeRelireLaFicheRejouee, uid, delaiMs)
							])));
			case 13:
				var ajout = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							ajout.nB,
							function (vers) {
								return A2(
									$author$project$Main$Update$AjouterLeRoleAuDoublon,
									_Utils_update(
										ajout,
										{nB: vers.nB}),
									vers.gM);
							})));
			case 15:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$LireLesTypesDeRelationDeLEtablissement(vers);
							})));
			case 16:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$LireLaFicheDeLEtablissement(vers);
							})));
			case 17:
				var lien = effet.a;
				var processUid = effet.b;
				var relation = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$RelierLEtablissementACreer(
									{gM: vers.gM, nB: vers.nB, Gn: processUid, Ht: relation});
							})));
			case 14:
				var restauration = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							restauration.nB,
							function (vers) {
								return A2(
									$author$project$Main$Update$RestaurerLaFicheDuDoublon,
									_Utils_update(
										restauration,
										{nB: vers.nB}),
									vers.gM);
							})));
			case 11:
				var saisie = effet.a;
				var delaiMs = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								A2($author$project$Main$Update$AttendreAvantDeChercherLesDoublons, saisie, delaiMs)
							])));
			case 19:
				var frappe = effet.a;
				var delaiMs = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								A2($author$project$Main$Update$AttendreAvantDeChercherLOrganisation, frappe, delaiMs)
							])));
			case 20:
				var lien = effet.a;
				var recherche = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$ChercherLOrganisation(
									{gM: vers.gM, nB: vers.nB, hC: recherche});
							})));
			case 22:
				var demande = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							demande.nB,
							function (vers) {
								return $author$project$Main$Update$ChercherDesNommeesDeLaNouvelleFiche(
									{
										kC: _Utils_update(
											demande,
											{nB: vers.nB}),
										gM: vers.gM
									});
							})));
			case 3:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$LesFormesDeLaNouvelleFiche(
									{gM: vers.gM, nB: vers.nB});
							})));
			case 4:
				var etape = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLEquipeDeLaNouvelleFiche(etape))));
			case 21:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$LirePostesDeLaNouvelleFiche(
									{gM: vers.gM, nB: vers.nB});
							})));
			default:
				var lien = effet.a;
				var saisie = effet.b;
				var criteres = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$ChercherLesDoublons(
									{wp: criteres, gM: vers.gM, nB: vers.nB, hP: saisie});
							})));
		}
	});
var $author$project$Main$Update$versLaFiche = F3(
	function (i18n, msg, model) {
		var _v3 = A2(
			$author$project$Components$Referentiel$Fiche$Update$update,
			msg,
			A2(
				$author$project$Referentiel$Normes$poser,
				model.hd,
				$author$project$Components$Referentiel$Fiche$Model$ouvrir(model.zo)));
		var fiche = _v3.a;
		var effets = _v3.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$modificationDeFiche, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLaFiche(i18n),
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						zo: $author$project$Components$Referentiel$Fiche$Model$envelopper(fiche),
						Ct: A2(
							$author$project$Main$Update$remonter,
							A2(
								$author$project$Components$Referentiel$Fiche$Update$popMessages,
								$author$project$Components$Referentiel$Fiche$Model$ouvrir(model.zo),
								msg),
							gardes)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$versLaFusion = F3(
	function (i18n, msg, model) {
		var _v2 = A2(
			$author$project$Components$Referentiel$Fusion$Update$update,
			msg,
			A2($author$project$Referentiel$Normes$poser, model.hd, model.z$));
		var fusion = _v2.a;
		var effets = _v2.b;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLaFusion(i18n),
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						z$: fusion,
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Referentiel$Fusion$Update$popMessages(msg),
							model.Ct)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$versLaNouvelleFiche = F3(
	function (i18n, msg, model) {
		var gardes = function () {
			if (msg.$ === 40) {
				return _List_Nil;
			} else {
				return model.Ct;
			}
		}();
		var _v0 = A2(
			$author$project$Components$Referentiel$NouvelleFiche$Update$update,
			msg,
			A2(
				$author$project$Referentiel$Normes$poser,
				model.hd,
				$author$project$Components$Referentiel$NouvelleFiche$Model$ouvrir(model.oU)));
		var nouvelleFiche = _v0.a;
		var effets = _v0.b;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLaNouvelleFiche(i18n),
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Referentiel$NouvelleFiche$Update$popMessages(msg),
							gardes),
						oU: $author$project$Components$Referentiel$NouvelleFiche$Model$envelopper(nouvelleFiche)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$ouvrirLaCreation = F3(
	function (i18n, declencheur, model) {
		var _v0 = $author$project$Main$Update$liensDeLaRacine(model);
		if (!_v0.$) {
			var liens = _v0.a;
			var offresPourOuvrir = A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					$elm$core$List$singleton,
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.D5;
						},
						$author$project$Components$Referentiel$PartiesPrenantes$Model$ouvrir(model.eA).B1)));
			var _v1 = A3(
				$author$project$Main$Update$versLaNouvelleFiche,
				i18n,
				$author$project$Components$Referentiel$NouvelleFiche$Update$GabaritsConnus(liens.gF),
				model);
			var connu = _v1.a;
			var _v2 = A3(
				$author$project$Main$Update$versLaNouvelleFiche,
				i18n,
				$author$project$Components$Referentiel$NouvelleFiche$Update$Ouverte(
					_Utils_ap(liens.h0, offresPourOuvrir)),
				connu);
			var ouverte = _v2.a;
			var deLOuverture = _v2.b;
			var _v3 = A3(
				$author$project$Main$Update$versLaNouvelleFiche,
				i18n,
				$author$project$Components$Referentiel$NouvelleFiche$Update$VoletOuvert(declencheur),
				ouverte);
			var volet = _v3.a;
			var deLaFenetre = _v3.b;
			return _Utils_Tuple2(
				volet,
				_Utils_ap(deLOuverture, deLaFenetre));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Comptes$Securite$Update$Ouverte = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Components$Socle$Session$Update$ActionDemandee = function (a) {
	return {$: 11, a: a};
};
var $author$project$Main$Update$EnvoyerALaSecurite = function (a) {
	return {$: 259, a: a};
};
var $author$project$Main$Update$LireLaSecurite = F2(
	function (a, b) {
		return {$: 258, a: a, b: b};
	});
var $author$project$Main$Model$PourLaSecurite = 50;
var $author$project$Components$Socle$Session$Update$ReconnexionDemandee = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Main$Update$depuisLaSecurite = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[50]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 1:
				var lecture = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLaSecurite(lecture))));
			case 2:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerALaSecurite(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 3:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
			case 4:
				var action = effet.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2(
						$author$project$Main$Update$versLaSession,
						$author$project$Components$Socle$Session$Update$ActionDemandee(action),
						model));
			case 5:
				var lien = effet.a;
				var geste = effet.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2(
						$author$project$Main$Update$versLaSession,
						A2($author$project$Components$Socle$Session$Update$ReconnexionDemandee, lien, geste),
						model));
			default:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
		}
	});
var $author$project$Components$Comptes$Securite$API$WriteAPIErrorsModel$AutreRefus = 4;
var $author$project$Components$Comptes$Securite$API$QueryAPIModel$Connexion = F2(
	function (le, navigateur) {
		return {Bf: le, C4: navigateur};
	});
var $author$project$Components$Comptes$Securite$API$QueryAPIModel$connexionsDecoder = A2(
	$elm$json$Json$Decode$field,
	'connexions',
	$elm$json$Json$Decode$list(
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'navigateur',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'le',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Comptes$Securite$API$QueryAPIModel$Connexion)))));
var $author$project$Components$Comptes$Securite$API$WriteAPIErrorsModel$DernierMoyenImpose = 1;
var $author$project$Components$Comptes$Securite$API$WriteAPIErrorsModel$NomInvalide = 3;
var $author$project$Components$Comptes$Securite$API$WriteAPIErrorsModel$ReconnexionRequise = 0;
var $author$project$Components$Comptes$Securite$API$WriteAPIErrorsModel$SessionCourante = 2;
var $author$project$Components$Comptes$Securite$API$WriteAPIErrorsModel$duRefus = function (reponse) {
	var nomme = F2(
		function (nom, erreur) {
			return A2(
				$elm$json$Json$Decode$map,
				function (_v0) {
					return erreur;
				},
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['error', nom]),
					$elm$json$Json$Decode$value));
		});
	return A2(
		$elm$core$Result$withDefault,
		4,
		A2(
			$elm$json$Json$Decode$decodeString,
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(nomme, 'ReconnexionRequise', 0),
						A2(nomme, 'DernierMoyenImpose', 1),
						A2(nomme, 'SessionCourante', 2),
						A2(nomme, 'NomInvalide', 3)
					])),
			reponse.f$));
};
var $author$project$Components$Comptes$Securite$Update$refus = function (resultat) {
	if (resultat.$ === 1) {
		var lu = resultat.a;
		return (lu.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Components$Shared$Messages$Model$duRefus(lu));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Comptes$Securite$API$QueryAPIModel$Securite = F4(
	function (motDePasseModifieLe, imposee, moyens, liens) {
		return {AD: imposee, nQ: liens, CV: motDePasseModifieLe, C_: moyens};
	});
var $author$project$Components$Comptes$Securite$API$QueryAPIModel$Moyen = F5(
	function (id, type_, nom, ajouteLe, liens) {
		return {s6: ajouteLe, Aq: id, nQ: liens, Dj: nom, r0: type_};
	});
var $author$project$Components$Comptes$Securite$API$QueryAPIModel$Application = 0;
var $author$project$Components$Comptes$Securite$API$QueryAPIModel$AutreMoyen = 2;
var $author$project$Components$Comptes$Securite$API$QueryAPIModel$CleDeSecurite = 1;
var $author$project$Components$Comptes$Securite$API$QueryAPIModel$typeDeMoyen = function (code) {
	switch (code) {
		case 'application':
			return 0;
		case 'cle-de-securite':
			return 1;
		default:
			return 2;
	}
};
var $author$project$Components$Comptes$Securite$API$QueryAPIModel$moyenDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'ajouteLe',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'nom',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'type',
				A2($elm$json$Json$Decode$map, $author$project$Components$Comptes$Securite$API$QueryAPIModel$typeDeMoyen, $elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Comptes$Securite$API$QueryAPIModel$Moyen))))));
var $author$project$Components$Comptes$Securite$API$QueryAPIModel$securiteDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'moyens',
		$elm$json$Json$Decode$list($author$project$Components$Comptes$Securite$API$QueryAPIModel$moyenDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'doubleAuthentificationImposee',
			$elm$json$Json$Decode$bool,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'motDePasseModifieLe',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				$elm$json$Json$Decode$succeed($author$project$Components$Comptes$Securite$API$QueryAPIModel$Securite)))));
var $author$project$Components$Comptes$Securite$API$QueryAPIModel$SessionOuverte = F6(
	function (id, appareil, applications, derniereActivite, courante, liens) {
		return {tv: appareil, tz: applications, wj: courante, xk: derniereActivite, Aq: id, nQ: liens};
	});
var $author$project$Components$Comptes$Securite$API$QueryAPIModel$Sessions = F2(
	function (sessions, liens) {
		return {nQ: liens, IK: sessions};
	});
var $author$project$Components$Comptes$Securite$API$QueryAPIModel$sessionsDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sessions',
		$elm$json$Json$Decode$list(
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A2(
					$elm$json$Json$Decode$map,
					function ($) {
						return $.h0;
					},
					$author$project$API$Liens$deLaRessource),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'courante',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'derniereActivite',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'applications',
							$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'appareil',
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Components$Comptes$Securite$API$QueryAPIModel$SessionOuverte)))))))),
		$elm$json$Json$Decode$succeed($author$project$Components$Comptes$Securite$API$QueryAPIModel$Sessions)));
var $author$project$Components$Comptes$Securite$Update$popMessages = function (msg) {
	switch (msg.$) {
		case 2:
			switch (msg.a) {
				case 0:
					var _v1 = msg.a;
					var reponse = msg.b;
					return $author$project$Components$Comptes$Securite$Update$refus(
						A2($author$project$API$Reponse$lire, $author$project$Components$Comptes$Securite$API$QueryAPIModel$securiteDecoder, reponse));
				case 1:
					var _v2 = msg.a;
					var reponse = msg.b;
					return $author$project$Components$Comptes$Securite$Update$refus(
						A2($author$project$API$Reponse$lire, $author$project$Components$Comptes$Securite$API$QueryAPIModel$sessionsDecoder, reponse));
				default:
					var _v3 = msg.a;
					var reponse = msg.b;
					return $author$project$Components$Comptes$Securite$Update$refus(
						A2($author$project$API$Reponse$lire, $author$project$Components$Comptes$Securite$API$QueryAPIModel$connexionsDecoder, reponse));
			}
		case 11:
			var reponse = msg.a;
			return ($author$project$Components$Comptes$Securite$API$WriteAPIErrorsModel$duRefus(reponse) === 4) ? $author$project$Components$Comptes$Securite$Update$refus(
				A2(
					$author$project$API$Reponse$lire,
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$json$Json$Decode$map,
								function (_v4) {
									return 0;
								},
								$author$project$Components$Comptes$Securite$API$QueryAPIModel$securiteDecoder),
								A2(
								$elm$json$Json$Decode$map,
								function (_v5) {
									return 0;
								},
								$author$project$Components$Comptes$Securite$API$QueryAPIModel$sessionsDecoder)
							])),
					reponse)) : $elm$core$Maybe$Nothing;
		case 1:
			var octets = msg.a;
			return _Utils_eq(
				$author$project$API$ProcessUid$depuisOctets(octets),
				$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
				{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Main$Update$requeteSurLaSecurite = function (effet) {
	switch (effet.$) {
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Comptes$Securite$Update$DemanderLaReconnexion = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$Comptes$Securite$Update$DemanderProcessUid = {$: 0};
var $author$project$Components$Comptes$Securite$API$WriteAPIModel$FermerUneSession = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Comptes$Securite$Update$LancerLActionKeycloak = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Comptes$Securite$Update$PlacerFocus = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Comptes$Securite$API$WriteAPIModel$RenommerUnMoyen = function (a) {
	return {$: 0, a: a};
};
var $author$project$API$NavLinksDictionary$fermerUneSession = 'fermer-une-session';
var $author$project$Components$Shared$Confirmation$Clavier$ids = function (geste) {
	return {to: geste + '-annuler', j7: geste + '-confirmer', Cs: geste + '-message', GN: geste, h6: geste + '-titre'};
};
var $author$project$Components$Comptes$Securite$Model$idsDeLaConfirmation = $author$project$Components$Shared$Confirmation$Clavier$ids('mon-compte-confirmation');
var $author$project$Components$Comptes$Securite$Update$ids = $author$project$Components$Comptes$Securite$Model$idsDeLaConfirmation;
var $author$project$API$NavLinksDictionary$reconnexionRecente = 'reconnexion-recente';
var $author$project$Components$Comptes$Securite$Update$lienDeReconnexion = function (model) {
	var _v0 = model.oZ;
	if (!_v0) {
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$reconnexionRecente)),
			model.q1);
	} else {
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$reconnexionRecente)),
			model.IK);
	}
};
var $author$project$Components$Comptes$Securite$Update$Reconnecter = {$: 3};
var $author$project$Components$Comptes$Securite$API$WriteAPIModel$FermerLesAutresSessions = {$: 3};
var $author$project$Components$Comptes$Securite$API$WriteAPIModel$RetirerUnMoyen = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Comptes$Securite$Model$prefixeDuRetrait = 'retirer-un-moyen:';
var $author$project$Components$Comptes$Securite$Model$repriseDesAutres = 'fermer-les-autres-sessions';
var $author$project$Components$Comptes$Securite$Model$commandeDeLaReprise = function (reprise) {
	return _Utils_eq(reprise, $author$project$Components$Comptes$Securite$Model$repriseDesAutres) ? $elm$core$Maybe$Just($author$project$Components$Comptes$Securite$API$WriteAPIModel$FermerLesAutresSessions) : ((A2($elm$core$String$startsWith, $author$project$Components$Comptes$Securite$Model$prefixeDuRetrait, reprise) && (_Utils_cmp(
		$elm$core$String$length(reprise),
		$elm$core$String$length($author$project$Components$Comptes$Securite$Model$prefixeDuRetrait)) > 0)) ? $elm$core$Maybe$Just(
		$author$project$Components$Comptes$Securite$API$WriteAPIModel$RetirerUnMoyen(
			A2(
				$elm$core$String$dropLeft,
				$elm$core$String$length($author$project$Components$Comptes$Securite$Model$prefixeDuRetrait),
				reprise))) : $elm$core$Maybe$Nothing);
};
var $author$project$API$NavLinksDictionary$fermerLesAutresSessions = 'fermer-les-autres-sessions';
var $author$project$Components$Comptes$Securite$Update$Envoyer = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$Comptes$Securite$Update$reglage = function (decoder) {
	return {
		f8: $author$project$Components$Comptes$Securite$Update$DemanderProcessUid,
		l4: $author$project$Components$Comptes$Securite$Update$Envoyer,
		go: $author$project$Components$Comptes$Securite$API$WriteAPIErrorsModel$duRefus,
		pW: $author$project$Components$Comptes$Securite$Update$Reconnecter,
		qu: F2(
			function (_v0, _v1) {
				return true;
			}),
		qv: decoder
	};
};
var $author$project$Components$Comptes$Securite$Update$partir = F3(
	function (lien, commande, model) {
		var _v0 = A4(
			$author$project$API$Envoi$partir,
			$author$project$Components$Comptes$Securite$Update$reglage(
				$elm$json$Json$Decode$succeed(0)),
			lien,
			commande,
			model.l2);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var envoi = _v1.a;
			var effets = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi, pZ: $elm$core$Maybe$Nothing, qL: $elm$core$Maybe$Nothing}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Comptes$Securite$Update$repartir = F3(
	function (commande, model, lien) {
		var _v0 = _Utils_Tuple2(lien, model.l2);
		if (_v0.a.$ === 1) {
			var _v1 = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{qx: $elm$core$Maybe$Nothing}),
				_List_Nil);
		} else {
			if (_v0.b.$ === 1) {
				return A3(
					$author$project$Components$Comptes$Securite$Update$partir,
					lien,
					commande,
					_Utils_update(
						model,
						{qx: $elm$core$Maybe$Nothing}));
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		}
	});
var $author$project$API$NavLinksDictionary$retirerUnMoyen = 'retirer-un-moyen';
var $author$project$Components$Comptes$Securite$Update$reprendre = function (model) {
	var _v0 = A2($elm$core$Maybe$andThen, $author$project$Components$Comptes$Securite$Model$commandeDeLaReprise, model.qx);
	_v0$2:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a.$) {
				case 1:
					var commande = _v0.a;
					var moyen = commande.a;
					var _v1 = model.q1;
					if (!_v1.$) {
						var securite = _v1.a;
						return A3(
							$author$project$Components$Comptes$Securite$Update$repartir,
							commande,
							model,
							A2(
								$elm$core$Maybe$andThen,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.nQ;
									},
									$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$retirerUnMoyen)),
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (lu) {
											return _Utils_eq(lu.Aq, moyen);
										},
										securite.C_))));
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 3:
					var _v2 = _v0.a;
					var _v3 = model.IK;
					if (!_v3.$) {
						var sessions = _v3.a;
						return A3(
							$author$project$Components$Comptes$Securite$Update$repartir,
							$author$project$Components$Comptes$Securite$API$WriteAPIModel$FermerLesAutresSessions,
							model,
							A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$fermerLesAutresSessions, sessions.nQ));
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{qx: $elm$core$Maybe$Nothing}),
		_List_Nil);
};
var $author$project$Components$Comptes$Securite$Update$lue = F3(
	function (lecture, reponse, model) {
		var recu = F2(
			function (decoder, recevoir) {
				var _v1 = A2($author$project$API$Reponse$lire, decoder, reponse);
				if (!_v1.$) {
					var lu = _v1.a;
					return $author$project$Components$Comptes$Securite$Update$reprendre(
						A2(recevoir, lu, model));
				} else {
					var refuse = _v1.a;
					return _Utils_Tuple2(
						model,
						(refuse.ri === 401) ? _List_fromArray(
							[$author$project$Components$Comptes$Securite$Update$Reconnecter]) : _List_Nil);
				}
			});
		switch (lecture) {
			case 0:
				return A2(
					recu,
					$author$project$Components$Comptes$Securite$API$QueryAPIModel$securiteDecoder,
					F2(
						function (lu, m) {
							return _Utils_update(
								m,
								{
									q1: $elm$core$Maybe$Just(lu)
								});
						}));
			case 1:
				return A2(
					recu,
					$author$project$Components$Comptes$Securite$API$QueryAPIModel$sessionsDecoder,
					F2(
						function (lu, m) {
							return _Utils_update(
								m,
								{
									IK: $elm$core$Maybe$Just(lu)
								});
						}));
			default:
				return A2(
					recu,
					$author$project$Components$Comptes$Securite$API$QueryAPIModel$connexionsDecoder,
					F2(
						function (lu, m) {
							return _Utils_update(
								m,
								{j8: lu});
						}));
		}
	});
var $author$project$Components$Comptes$Securite$Update$LaSecurite = 0;
var $author$project$Components$Comptes$Securite$Update$LesConnexions = 2;
var $author$project$Components$Comptes$Securite$Update$LesSessions = 1;
var $author$project$Components$Comptes$Securite$Update$Lire = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Comptes$Securite$Update$lire = F3(
	function (lecture, rel, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Comptes$Securite$Update$Lire(lecture),
					$elm$core$List$singleton),
				A2($author$project$API$Liens$trouver, rel, model.nQ)));
	});
var $author$project$API$NavLinksDictionary$monCompteConnexions = 'mon-compte-connexions';
var $author$project$API$NavLinksDictionary$monCompteSecurite = 'mon-compte-securite';
var $author$project$API$NavLinksDictionary$monCompteSessions = 'mon-compte-sessions';
var $author$project$Components$Comptes$Securite$Update$relire = function (model) {
	var _v0 = model.oZ;
	if (!_v0) {
		return A3($author$project$Components$Comptes$Securite$Update$lire, 0, $author$project$API$NavLinksDictionary$monCompteSecurite, model);
	} else {
		return _Utils_ap(
			A3($author$project$Components$Comptes$Securite$Update$lire, 1, $author$project$API$NavLinksDictionary$monCompteSessions, model),
			A3($author$project$Components$Comptes$Securite$Update$lire, 2, $author$project$API$NavLinksDictionary$monCompteConnexions, model));
	}
};
var $author$project$API$NavLinksDictionary$renommerUnMoyen = 'renommer-un-moyen';
var $author$project$Components$Comptes$Securite$Model$MoyenRenomme = {$: 6};
var $author$project$Components$Comptes$Securite$Model$MoyenRetire = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Comptes$Securite$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{
						iA: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? model.iA : $elm$core$Maybe$Nothing,
						kX: drawer
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Comptes$Securite$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.kX));
	});
var $author$project$Components$Comptes$Securite$Update$securiteRelue = F3(
	function (commande, securite, model) {
		switch (commande.$) {
			case 0:
				return A2(
					$author$project$Components$Comptes$Securite$Update$versLeDrawer,
					$author$project$Components$Shared$Drawer$Update$Fermer,
					_Utils_update(
						model,
						{
							qL: $elm$core$Maybe$Just($author$project$Components$Comptes$Securite$Model$MoyenRenomme),
							q1: $elm$core$Maybe$Just(securite)
						}));
			case 1:
				var moyen = commande.a;
				var type_ = A2(
					$elm$core$Maybe$withDefault,
					2,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.r0;
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (lu) {
									return _Utils_eq(lu.Aq, moyen);
								},
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.C_;
										},
										model.q1))))));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							qL: $elm$core$Maybe$Just(
								$author$project$Components$Comptes$Securite$Model$MoyenRetire(type_)),
							q1: $elm$core$Maybe$Just(securite)
						}),
					_List_Nil);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							q1: $elm$core$Maybe$Just(securite)
						}),
					_List_Nil);
		}
	});
var $author$project$Components$Comptes$Securite$Model$AutresSessionsFermees = {$: 8};
var $author$project$Components$Comptes$Securite$Model$SessionFermee = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Comptes$Securite$Update$sessionsRelues = F3(
	function (commande, sessions, model) {
		if (commande.$ === 2) {
			var session = commande.a;
			var appareil = A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.tv;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (ouverte) {
							return _Utils_eq(ouverte.Aq, session);
						},
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.IK;
								},
								model.IK)))));
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						qL: $elm$core$Maybe$Just(
							$author$project$Components$Comptes$Securite$Model$SessionFermee(appareil)),
						IK: $elm$core$Maybe$Just(sessions)
					}),
				_List_Nil);
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						qL: $elm$core$Maybe$Just($author$project$Components$Comptes$Securite$Model$AutresSessionsFermees),
						IK: $elm$core$Maybe$Just(sessions)
					}),
				_List_Nil);
		}
	});
var $author$project$Components$Comptes$Securite$Update$sur = F4(
	function (decoder, recevoir, reponse, model) {
		var _v0 = A3(
			$author$project$API$Envoi$conclure,
			$author$project$Components$Comptes$Securite$Update$reglage(decoder),
			reponse,
			model.l2);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var envoi = _v1.a;
			var issue = _v1.b;
			var effets = _v1.c;
			var conclu = _Utils_update(
				model,
				{l2: envoi});
			return A2(
				$elm$core$Tuple$mapSecond,
				function (suite) {
					return _Utils_ap(effets, suite);
				},
				function () {
					switch (issue.$) {
						case 0:
							var lu = issue.b;
							return A2(recevoir, lu, conclu);
						case 1:
							var erreur = issue.c;
							return _Utils_Tuple2(
								_Utils_update(
									conclu,
									{
										pZ: $elm$core$Maybe$Just(erreur)
									}),
								_List_Nil);
						default:
							return _Utils_Tuple2(conclu, _List_Nil);
					}
				}());
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Comptes$Securite$Update$repondue = F2(
	function (reponse, model) {
		var _v0 = model.l2;
		if (_v0.$ === 2) {
			var commande = _v0.b;
			switch (commande.$) {
				case 0:
					return A4(
						$author$project$Components$Comptes$Securite$Update$sur,
						$author$project$Components$Comptes$Securite$API$QueryAPIModel$securiteDecoder,
						$author$project$Components$Comptes$Securite$Update$securiteRelue(commande),
						reponse,
						model);
				case 1:
					return A4(
						$author$project$Components$Comptes$Securite$Update$sur,
						$author$project$Components$Comptes$Securite$API$QueryAPIModel$securiteDecoder,
						$author$project$Components$Comptes$Securite$Update$securiteRelue(commande),
						reponse,
						model);
				case 2:
					return A4(
						$author$project$Components$Comptes$Securite$Update$sur,
						$author$project$Components$Comptes$Securite$API$QueryAPIModel$sessionsDecoder,
						$author$project$Components$Comptes$Securite$Update$sessionsRelues(commande),
						reponse,
						model);
				default:
					return A4(
						$author$project$Components$Comptes$Securite$Update$sur,
						$author$project$Components$Comptes$Securite$API$QueryAPIModel$sessionsDecoder,
						$author$project$Components$Comptes$Securite$Update$sessionsRelues(commande),
						reponse,
						model);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Comptes$Securite$Model$repriseDuGeste = function (geste) {
	switch (geste.$) {
		case 0:
			var moyen = geste.a;
			return $elm$core$Maybe$Just(
				_Utils_ap($author$project$Components$Comptes$Securite$Model$prefixeDuRetrait, moyen.Aq));
		case 2:
			return $elm$core$Maybe$Just($author$project$Components$Comptes$Securite$Model$repriseDesAutres);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Comptes$Securite$Model$ActionEchouee = {$: 4};
var $author$project$Components$Comptes$Securite$Model$ApplicationAjoutee = {$: 1};
var $author$project$Components$Comptes$Securite$Model$AucuneModification = {$: 3};
var $author$project$Components$Comptes$Securite$Model$CleAjoutee = {$: 2};
var $author$project$Components$Comptes$Securite$Model$MotDePasseModifie = {$: 0};
var $author$project$Components$Comptes$Securite$Model$actionDeLaSecurite = function (action) {
	return A2(
		$elm$core$List$member,
		action,
		_List_fromArray(
			['UPDATE_PASSWORD', 'CONFIGURE_TOTP', 'webauthn-register']));
};
var $author$project$Components$Comptes$Securite$Model$retourDeKeycloak = function (retour) {
	var _v0 = _Utils_Tuple2(retour.fs, retour.ri);
	_v0$5:
	while (true) {
		switch (_v0.b) {
			case 'cancelled':
				return $author$project$Components$Comptes$Securite$Model$actionDeLaSecurite(retour.fs) ? $elm$core$Maybe$Just($author$project$Components$Comptes$Securite$Model$AucuneModification) : $elm$core$Maybe$Nothing;
			case 'error':
				return $author$project$Components$Comptes$Securite$Model$actionDeLaSecurite(retour.fs) ? $elm$core$Maybe$Just($author$project$Components$Comptes$Securite$Model$ActionEchouee) : $elm$core$Maybe$Nothing;
			case 'success':
				switch (_v0.a) {
					case 'UPDATE_PASSWORD':
						return $elm$core$Maybe$Just($author$project$Components$Comptes$Securite$Model$MotDePasseModifie);
					case 'CONFIGURE_TOTP':
						return $elm$core$Maybe$Just($author$project$Components$Comptes$Securite$Model$ApplicationAjoutee);
					case 'webauthn-register':
						return $elm$core$Maybe$Just($author$project$Components$Comptes$Securite$Model$CleAjoutee);
					default:
						break _v0$5;
				}
			default:
				break _v0$5;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Components$Comptes$Securite$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var onglet = msg.a;
				var liens = msg.b;
				var ouverture = msg.c;
				var ouvert = _Utils_update(
					model,
					{
						iu: $elm$core$Maybe$Nothing,
						nQ: liens,
						oZ: onglet,
						pZ: $elm$core$Maybe$Nothing,
						qx: ouverture.qx,
						qL: A2($elm$core$Maybe$andThen, $author$project$Components$Comptes$Securite$Model$retourDeKeycloak, ouverture.qL)
					});
				return _Utils_Tuple2(
					ouvert,
					A2(
						$elm$core$List$cons,
						$author$project$Components$Comptes$Securite$Update$DemanderProcessUid,
						$author$project$Components$Comptes$Securite$Update$relire(ouvert)));
			case 1:
				var octets = msg.a;
				return $author$project$Components$Comptes$Securite$Update$reprendre(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}));
			case 2:
				var lecture = msg.a;
				var reponse = msg.b;
				return A3($author$project$Components$Comptes$Securite$Update$lue, lecture, reponse, model);
			case 3:
				var lien = msg.a;
				return $author$project$API$Envoi$enCours(model.l2) ? _Utils_Tuple2(model, _List_Nil) : _Utils_Tuple2(
					model,
					_List_fromArray(
						[
							$author$project$Components$Comptes$Securite$Update$LancerLActionKeycloak(lien)
						]));
			case 4:
				var geste = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							iu: $elm$core$Maybe$Just(geste),
							pZ: $elm$core$Maybe$Nothing
						}),
					_List_fromArray(
						[
							$author$project$Components$Comptes$Securite$Update$PlacerFocus($author$project$Components$Comptes$Securite$Update$ids.to)
						]));
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{iu: $elm$core$Maybe$Nothing}),
					_List_Nil);
			case 6:
				var _v1 = model.iu;
				if (!_v1.$) {
					if (_v1.a.$ === 1) {
						var session = _v1.a.a;
						return A3(
							$author$project$Components$Comptes$Securite$Update$partir,
							A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$fermerUneSession, session.nQ),
							$author$project$Components$Comptes$Securite$API$WriteAPIModel$FermerUneSession(session.Aq),
							_Utils_update(
								model,
								{iu: $elm$core$Maybe$Nothing}));
					} else {
						var geste = _v1.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{iu: $elm$core$Maybe$Nothing}),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									$elm$core$List$singleton,
									A3(
										$elm$core$Maybe$map2,
										$author$project$Components$Comptes$Securite$Update$DemanderLaReconnexion,
										$author$project$Components$Comptes$Securite$Update$lienDeReconnexion(model),
										$author$project$Components$Comptes$Securite$Model$repriseDuGeste(geste)))));
					}
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 7:
				var moyen = msg.a;
				return A2(
					$author$project$Components$Comptes$Securite$Update$versLeDrawer,
					$author$project$Components$Shared$Drawer$Update$Ouvrir('mon-compte-renommer-nom'),
					_Utils_update(
						model,
						{
							iA: $elm$core$Maybe$Just(moyen),
							Dj: A2($elm$core$Maybe$withDefault, '', moyen.Dj),
							pZ: $elm$core$Maybe$Nothing
						}));
			case 8:
				var nom = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Dj: nom}),
					_List_Nil);
			case 9:
				var _v2 = model.iA;
				if (!_v2.$) {
					var moyen = _v2.a;
					return $elm$core$String$isEmpty(
						$elm$core$String$trim(model.Dj)) ? _Utils_Tuple2(model, _List_Nil) : A3(
						$author$project$Components$Comptes$Securite$Update$partir,
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$renommerUnMoyen, moyen.nQ),
						$author$project$Components$Comptes$Securite$API$WriteAPIModel$RenommerUnMoyen(
							{
								CZ: moyen.Aq,
								Dj: $elm$core$String$trim(model.Dj)
							}),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 10:
				var geste = msg.a;
				return A2($author$project$Components$Comptes$Securite$Update$versLeDrawer, geste, model);
			case 11:
				var reponse = msg.a;
				return A2($author$project$Components$Comptes$Securite$Update$repondue, reponse, model);
			default:
				var cible = msg.a;
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[
							$author$project$Components$Comptes$Securite$Update$PlacerFocus(cible)
						]));
		}
	});
var $author$project$Main$Update$versLaSecurite = F2(
	function (msg, model) {
		var _v0 = A2($author$project$Components$Comptes$Securite$Update$update, msg, model.q1);
		var securite = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLaSecurite, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLaSecurite,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Comptes$Securite$Update$popMessages(msg),
							gardes),
						q1: securite
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$ouvrirLaSecurite = F3(
	function (onglet, liens, model) {
		var session = model.e1;
		return A2(
			$author$project$Main$Update$versLaSecurite,
			A3(
				$author$project$Components$Comptes$Securite$Update$Ouverte,
				onglet,
				liens,
				{qx: session.qx, qL: session.H1}),
			_Utils_update(
				model,
				{
					e1: _Utils_update(
						session,
						{qx: $elm$core$Maybe$Nothing, H1: $elm$core$Maybe$Nothing})
				}));
	});
var $author$project$Main$Update$LireLAccueil = F2(
	function (a, b) {
		return {$: 80, a: a, b: b};
	});
var $author$project$Main$Update$depuisLAccueil = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		if (!effet.$) {
			var source = effet.a;
			var lien = effet.b;
			return _Utils_Tuple2(
				model,
				_Utils_ap(
					effets,
					A3(
						$author$project$Main$Update$versLApi,
						model,
						lien,
						$author$project$Main$Update$LireLAccueil(source))));
		} else {
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Basics$append(effets),
				A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Accueil$API$QueryAPIModel$catalogueDecoder = A2(
	$elm$json$Json$Decode$field,
	'totaux',
	A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (r, n) {
				return {vT: r - n, hD: r};
			}),
		A2($elm$json$Json$Decode$field, 'references', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'nonPubliables', $elm$json$Json$Decode$int)));
var $author$project$Components$Accueil$API$QueryAPIModel$echeancesDecoder = A2($elm$json$Json$Decode$field, 'nombre', $elm$json$Json$Decode$int);
var $author$project$Components$Accueil$API$QueryAPIModel$Tableau = function (date) {
	return function (organisation) {
		return function (campagnes) {
			return function (compteurs) {
				return function (dossiers) {
					return function (taches) {
						return function (messages) {
							return function (doublons) {
								return function (incompletes) {
									return function (echeances) {
										return function (sansContact) {
											return function (publication) {
												return function (journee) {
													return {uE: campagnes, v0: compteurs, wv: date, xJ: dossiers, xM: doublons, x0: echeances, AG: incompletes, A1: journee, Ct: messages, En: organisation, Gz: publication, In: sansContact, Jk: taches};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Accueil$API$QueryAPIModel$Campagne = function (nom) {
	return function (nomCourt) {
		return function (pipe) {
			return function (etape) {
				return function (etat) {
					return function (tonalite) {
						return function (engagees) {
							return function (moq) {
								return function (pourcentage) {
									return function (licencies) {
										return function (cloture) {
											return function (semaine) {
												return function (joursAvantCloture) {
													return function (commandesAValider) {
														return function (references) {
															return function (autres) {
																return function (ca) {
																	return {t7: autres, uA: ca, vq: cloture, vK: commandesAValider, lY: engagees, me: etape, gt: etat, A2: joursAvantCloture, Bw: licencies, ok: moq, Dj: nom, Dl: nomCourt, Fs: pipe, Gb: pourcentage, hD: references, q6: semaine, rI: tonalite};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Accueil$API$QueryAPIModel$ReferenceDeCampagne = F4(
	function (code, nom, engagees, moq) {
		return {vx: code, lY: engagees, ok: moq, Dj: nom};
	});
var $author$project$Components$Accueil$API$QueryAPIModel$referenceDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Components$Accueil$API$QueryAPIModel$ReferenceDeCampagne,
	A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'engagees', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'moq', $elm$json$Json$Decode$int));
var $author$project$Components$Accueil$API$QueryAPIModel$Alerte = 1;
var $author$project$Components$Accueil$API$QueryAPIModel$Bon = 0;
var $author$project$Components$Accueil$API$QueryAPIModel$Neutre = 2;
var $author$project$Components$Accueil$API$QueryAPIModel$tonaliteDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (code) {
		switch (code) {
			case 'bon':
				return $elm$json$Json$Decode$succeed(0);
			case 'alerte':
				return $elm$json$Json$Decode$succeed(1);
			case 'neutre':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('tonalite:' + code);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$Accueil$API$QueryAPIModel$campagneDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'ca',
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$Just,
		A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (e, p) {
					return {yq: e, Gl: p};
				}),
			A2($elm$json$Json$Decode$field, 'engage', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'prevu', $elm$json$Json$Decode$string))),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'autres',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'references',
			$elm$json$Json$Decode$list($author$project$Components$Accueil$API$QueryAPIModel$referenceDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'commandesAValider',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'joursAvantCloture',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'semaine',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'cloture',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'licencies',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'pourcentage',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'moq',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'engagees',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'tonalite',
												$author$project$Components$Accueil$API$QueryAPIModel$tonaliteDecoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'etat',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'etape',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'pipe',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'nomCourt',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'nom',
																	$elm$json$Json$Decode$string,
																	$elm$json$Json$Decode$succeed($author$project$Components$Accueil$API$QueryAPIModel$Campagne))))))))))))))))));
var $author$project$Components$Accueil$API$QueryAPIModel$CompteurDeBord = F5(
	function (id, valeur, variation, periode, tonalite) {
		return {Aq: id, pi: periode, rI: tonalite, fm: valeur, Kx: variation};
	});
var $author$project$Components$Accueil$API$QueryAPIModel$compteurDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'tonalite',
	$author$project$Components$Accueil$API$QueryAPIModel$tonaliteDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'periode',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'variation',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'valeur',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Accueil$API$QueryAPIModel$CompteurDeBord))))));
var $author$project$Components$Accueil$API$QueryAPIModel$incompletesDecoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (n, s) {
			return {w: n, h1: s};
		}),
	A2($elm$json$Json$Decode$field, 'nombre', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'sur', $elm$json$Json$Decode$int));
var $author$project$Components$Accueil$API$QueryAPIModel$Journee = F2(
	function (maintenant, evenements) {
		return {mk: evenements, B3: maintenant};
	});
var $author$project$Components$Accueil$API$QueryAPIModel$Moment = F4(
	function (heure, titre, detail, nature) {
		return {bB: detail, Ah: heure, g1: nature, h6: titre};
	});
var $author$project$Components$Accueil$API$QueryAPIModel$journeeDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Accueil$API$QueryAPIModel$Journee,
	A2($elm$json$Json$Decode$field, 'maintenant', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'evenements',
		$elm$json$Json$Decode$list(
			A5(
				$elm$json$Json$Decode$map4,
				$author$project$Components$Accueil$API$QueryAPIModel$Moment,
				A2($elm$json$Json$Decode$field, 'heure', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'titre', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'detail', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'nature', $elm$json$Json$Decode$string)))));
var $author$project$Components$Accueil$API$QueryAPIModel$Messages = F3(
	function (total, nonLus, canaux) {
		return {uG: canaux, DL: nonLus, JE: total};
	});
var $author$project$Components$Accueil$API$QueryAPIModel$messagesDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Accueil$API$QueryAPIModel$Messages,
	A2($elm$json$Json$Decode$field, 'total', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'nonLus', $elm$json$Json$Decode$int),
	A2(
		$elm$json$Json$Decode$field,
		'canaux',
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$int)))));
var $author$project$Components$Accueil$API$QueryAPIModel$Etape = F2(
	function (nom, nombre) {
		return {Dj: nom, w: nombre};
	});
var $author$project$Components$Accueil$API$QueryAPIModel$PipeEnCours = F3(
	function (nom, enRetard, etapes) {
		return {lW: enRetard, yL: etapes, Dj: nom};
	});
var $author$project$Components$Accueil$API$QueryAPIModel$pipeDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Accueil$API$QueryAPIModel$PipeEnCours,
	A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'enRetard', $elm$json$Json$Decode$int),
	A2(
		$elm$json$Json$Decode$field,
		'etapes',
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Components$Accueil$API$QueryAPIModel$Etape,
				A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$int)))));
var $author$project$Components$Accueil$API$QueryAPIModel$Publication = F9(
	function (complete, total, typologie, completudeMoyenne, parEtat, etats, creees, modifiees, aRanger) {
		return {iz: aRanger, j2: complete, vU: completudeMoyenne, wo: creees, mj: etats, CP: modifiees, EP: parEtat, JE: total, r3: typologie};
	});
var $author$project$Components$Accueil$API$QueryAPIModel$publicationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'aRanger',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'modifiees',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'creees',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'etats',
				$elm$json$Json$Decode$list(
					A3(
						$elm$json$Json$Decode$map2,
						$elm$core$Tuple$pair,
						A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string),
						A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$int))),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'parEtat',
					$elm$json$Json$Decode$list(
						A3(
							$elm$json$Json$Decode$map2,
							$elm$core$Tuple$pair,
							A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string),
							A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$int))),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'completudeMoyenne',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'typologie',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'total',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'complete',
									$elm$json$Json$Decode$int,
									$elm$json$Json$Decode$succeed($author$project$Components$Accueil$API$QueryAPIModel$Publication))))))))));
var $author$project$Components$Accueil$API$QueryAPIModel$JourDeTaches = F3(
	function (jour, nombre, retard) {
		return {A_: jour, w: nombre, qH: retard};
	});
var $author$project$Components$Accueil$API$QueryAPIModel$Taches = F7(
	function (ouvertes, enRetard, aujourdhui, semaine, urgente, parJour, liste) {
		return {t$: aujourdhui, lW: enRetard, nW: liste, Eu: ouvertes, EQ: parJour, q6: semaine, Kd: urgente};
	});
var $elm$json$Json$Decode$map7 = _Json_map7;
var $author$project$Components$Accueil$API$QueryAPIModel$Tache = F6(
	function (titre, dossier, etape, echeance, retard, periode) {
		return {xI: dossier, xY: echeance, me: etape, pi: periode, qH: retard, h6: titre};
	});
var $author$project$Components$Accueil$API$QueryAPIModel$Aujourdhui = 1;
var $author$project$Components$Accueil$API$QueryAPIModel$EnRetard = 0;
var $author$project$Components$Accueil$API$QueryAPIModel$Semaine = 2;
var $author$project$Components$Accueil$API$QueryAPIModel$periodeDecoder = function (code) {
	switch (code) {
		case 'retard':
			return $elm$json$Json$Decode$succeed(0);
		case 'aujourdhui':
			return $elm$json$Json$Decode$succeed(1);
		case 'semaine':
			return $elm$json$Json$Decode$succeed(2);
		default:
			return $elm$json$Json$Decode$fail(code);
	}
};
var $author$project$Components$Accueil$API$QueryAPIModel$tacheDecoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Components$Accueil$API$QueryAPIModel$Tache,
	A2($elm$json$Json$Decode$field, 'titre', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'dossier', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'etape', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'echeance', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'retard', $elm$json$Json$Decode$bool),
	A2(
		$elm$json$Json$Decode$andThen,
		$author$project$Components$Accueil$API$QueryAPIModel$periodeDecoder,
		A2($elm$json$Json$Decode$field, 'periode', $elm$json$Json$Decode$string)));
var $author$project$Components$Accueil$API$QueryAPIModel$tachesDecoder = A8(
	$elm$json$Json$Decode$map7,
	$author$project$Components$Accueil$API$QueryAPIModel$Taches,
	A2($elm$json$Json$Decode$field, 'ouvertes', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'enRetard', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'aujourdhui', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'semaine', $elm$json$Json$Decode$int),
	A2(
		$elm$json$Json$Decode$field,
		'urgente',
		A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (t, d) {
					return {xe: d, h6: t};
				}),
			A2($elm$json$Json$Decode$field, 'titre', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'depuis', $elm$json$Json$Decode$string))),
	A2(
		$elm$json$Json$Decode$field,
		'parJour',
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				$author$project$Components$Accueil$API$QueryAPIModel$JourDeTaches,
				A2($elm$json$Json$Decode$field, 'jour', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'nombre', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'retard', $elm$json$Json$Decode$bool)))),
	A2(
		$elm$json$Json$Decode$field,
		'liste',
		$elm$json$Json$Decode$list($author$project$Components$Accueil$API$QueryAPIModel$tacheDecoder)));
var $author$project$Components$Accueil$API$QueryAPIModel$tableauDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'journee',
	$author$project$Components$Accueil$API$QueryAPIModel$journeeDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'publication',
		$author$project$Components$Accueil$API$QueryAPIModel$publicationDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'sansContact',
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (n, s, noms) {
						return {w: n, DG: noms, h1: s};
					}),
				A2($elm$json$Json$Decode$field, 'nombre', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'sur', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'noms', $elm$json$Json$Decode$string)),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['echeances', 'nombre']),
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'incompletes',
					$author$project$Components$Accueil$API$QueryAPIModel$incompletesDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'doublons',
						A4(
							$elm$json$Json$Decode$map3,
							F3(
								function (n, s, e) {
									return {yY: e, w: n, h1: s};
								}),
							A2($elm$json$Json$Decode$field, 'nombre', $elm$json$Json$Decode$int),
							A2($elm$json$Json$Decode$field, 'sur', $elm$json$Json$Decode$int),
							A2($elm$json$Json$Decode$field, 'exemple', $elm$json$Json$Decode$string)),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'messages',
							$author$project$Components$Accueil$API$QueryAPIModel$messagesDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'taches',
								$author$project$Components$Accueil$API$QueryAPIModel$tachesDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'dossiers',
									$elm$json$Json$Decode$list($author$project$Components$Accueil$API$QueryAPIModel$pipeDecoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'compteurs',
										$elm$json$Json$Decode$list($author$project$Components$Accueil$API$QueryAPIModel$compteurDecoder),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'campagnes',
											$elm$json$Json$Decode$list($author$project$Components$Accueil$API$QueryAPIModel$campagneDecoder),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'organisation',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'date',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Components$Accueil$API$QueryAPIModel$Tableau))))))))))))));
var $author$project$Components$Accueil$Update$corpsAttendu = function (source) {
	switch (source) {
		case 0:
			return A2(
				$elm$json$Json$Decode$map,
				function (_v1) {
					return 0;
				},
				$author$project$Components$Accueil$API$QueryAPIModel$tableauDecoder);
		case 1:
			return A2(
				$elm$json$Json$Decode$map,
				function (_v2) {
					return 0;
				},
				$author$project$Components$Accueil$API$QueryAPIModel$catalogueDecoder);
		default:
			return A2(
				$elm$json$Json$Decode$map,
				function (_v3) {
					return 0;
				},
				$author$project$Components$Accueil$API$QueryAPIModel$echeancesDecoder);
	}
};
var $author$project$Components$Accueil$Update$popMessages = function (msg) {
	if (msg.$ === 1) {
		var source = msg.a;
		var reponse = msg.b;
		var _v1 = A2(
			$author$project$API$Reponse$lire,
			$author$project$Components$Accueil$Update$corpsAttendu(source),
			reponse);
		if (_v1.$ === 1) {
			var refus = _v1.a;
			return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				$author$project$Components$Shared$Messages$Model$duRefus(refus));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Accueil$Update$Catalogue = 1;
var $author$project$Components$Accueil$Update$Echeances = 2;
var $author$project$Components$Accueil$Update$Lire = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Accueil$Update$Simulee = 0;
var $author$project$API$NavLinksDictionary$accueilTableauDeBord = 'accueil-tableau-de-bord';
var $author$project$Components$Accueil$Update$avecRang = F2(
	function (rang, model) {
		var derniere = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.uE;
					},
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$length,
						function (n) {
							return n - 1;
						})),
				model.rw));
		return _Utils_update(
			model,
			{
				bY: A3(
					$elm$core$Basics$clamp,
					0,
					A2($elm$core$Basics$max, 0, derniere),
					rang)
			});
	});
var $author$project$Components$Accueil$Update$Reconnecter = {$: 1};
var $author$project$Components$Accueil$Update$lu = F4(
	function (decoder, pose, model, reponse) {
		var _v0 = A2($author$project$API$Reponse$lire, decoder, reponse);
		if (!_v0.$) {
			var valeur = _v0.a;
			return _Utils_Tuple2(
				pose(valeur),
				_List_Nil);
		} else {
			var refus = _v0.a;
			return _Utils_Tuple2(
				model,
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Accueil$Update$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Accueil$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var liens = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{jB: $elm$core$Maybe$Nothing, x0: $elm$core$Maybe$Nothing, mF: $elm$core$Maybe$Nothing, bY: 0, rw: $elm$core$Maybe$Nothing}),
					A2(
						$elm$core$List$filterMap,
						function (_v1) {
							var source = _v1.a;
							var rel = _v1.b;
							return A2(
								$elm$core$Maybe$map,
								$author$project$Components$Accueil$Update$Lire(source),
								A2($author$project$API$Liens$trouver, rel, liens));
						},
						_List_fromArray(
							[
								_Utils_Tuple2(0, $author$project$API$NavLinksDictionary$accueilTableauDeBord),
								_Utils_Tuple2(1, $author$project$API$NavLinksDictionary$catalogue),
								_Utils_Tuple2(2, $author$project$API$NavLinksDictionary$echeancesDeConservation)
							])));
			case 2:
				return _Utils_Tuple2(
					A2($author$project$Components$Accueil$Update$avecRang, model.bY - 1, model),
					_List_Nil);
			case 3:
				return _Utils_Tuple2(
					A2($author$project$Components$Accueil$Update$avecRang, model.bY + 1, model),
					_List_Nil);
			case 4:
				var rang = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Components$Accueil$Update$avecRang, rang, model),
					_List_Nil);
			case 5:
				var periode = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							mF: _Utils_eq(
								model.mF,
								$elm$core$Maybe$Just(periode)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(periode)
						}),
					_List_Nil);
			default:
				var source = msg.a;
				var reponse = msg.b;
				switch (source) {
					case 0:
						return A4(
							$author$project$Components$Accueil$Update$lu,
							$author$project$Components$Accueil$API$QueryAPIModel$tableauDecoder,
							function (v) {
								return _Utils_update(
									model,
									{
										rw: $elm$core$Maybe$Just(v)
									});
							},
							model,
							reponse);
					case 1:
						return A4(
							$author$project$Components$Accueil$Update$lu,
							$author$project$Components$Accueil$API$QueryAPIModel$catalogueDecoder,
							function (v) {
								return _Utils_update(
									model,
									{
										jB: $elm$core$Maybe$Just(v)
									});
							},
							model,
							reponse);
					default:
						return A4(
							$author$project$Components$Accueil$Update$lu,
							$author$project$Components$Accueil$API$QueryAPIModel$echeancesDecoder,
							function (v) {
								return _Utils_update(
									model,
									{
										x0: $elm$core$Maybe$Just(v)
									});
							},
							model,
							reponse);
				}
		}
	});
var $author$project$Main$Update$versLAccueil = F3(
	function (i18n, msg, model) {
		var _v0 = A2($author$project$Components$Accueil$Update$update, msg, model.sN);
		var accueil = _v0.a;
		var effets = _v0.b;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLAccueil,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						sN: accueil,
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Accueil$Update$popMessages(msg),
							model.Ct)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$EnvoyerALEtape1DUnPipe = function (a) {
	return {$: 103, a: a};
};
var $author$project$Main$Update$LireLEtape1DUnPipe = F2(
	function (a, b) {
		return {$: 81, a: a, b: b};
	});
var $author$project$Main$Model$PourLEtape1DUnPipe = 17;
var $author$project$Main$Update$depuisLEtape1DUnPipe = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				var lecture = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLEtape1DUnPipe(lecture))));
			case 1:
				var lien = effet.a;
				var processUid = effet.b;
				var pipeUid = effet.c;
				var commande = effet.d;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerALEtape1DUnPipe(
									{vJ: commande, gM: vers.gM, nB: vers.nB, FK: pipeUid, Gn: processUid});
							})));
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[17]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 3:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			case 4:
				var code = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AllerA(
								$author$project$Routes$Route$adressePipeEtape1(code))
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Parametrage$Common$API$QueryAPIModel$PipeResume = function (uid) {
	return function (code) {
		return function (libelles) {
			return function (motDossier) {
				return function (nombreDEtapes) {
					return function (nombrePassages) {
						return function (versionPubliee) {
							return function (versionBrouillon) {
								return function (etat) {
									return function (lien) {
										return function (cible) {
											return function (dossiersEnCours) {
												return function (portails) {
													return function (lecture) {
														return function (sources) {
															return {vf: cible, vx: code, xK: dossiersEnCours, gt: etat, np: lecture, R: libelles, nB: lien, CW: motDossier, Dt: nombreDEtapes, DE: nombrePassages, F_: portails, IT: sources, r8: uid, KE: versionBrouillon, KM: versionPubliee};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle = function (libelles) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Dict$get, 'fr', libelles));
};
var $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelleDuType = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle,
			A2(
				$elm$json$Json$Decode$field,
				'libelles',
				$elm$json$Json$Decode$dict($elm$json$Json$Decode$string))),
			A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string)
		]));
var $author$project$Components$Parametrage$Common$API$QueryAPIModel$LienEntrePipes = F3(
	function (type_, sens, autrePipe) {
		return {t5: autrePipe, IC: sens, r0: type_};
	});
var $author$project$Components$Parametrage$Common$API$QueryAPIModel$lienDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'autrePipe',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sens',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Common$API$QueryAPIModel$LienEntrePipes))));
var $author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$map,
			function ($) {
				return $.h0;
			},
			A2($elm$json$Json$Decode$field, '_links', $author$project$API$Liens$decoder)),
			$elm$json$Json$Decode$succeed(_List_Nil)
		]));
var $author$project$API$NavLinksDictionary$pipe = 'pipe';
var $author$project$Components$Parametrage$Common$API$QueryAPIModel$SourceResume = F5(
	function (uid, nature, elements, minimum, maximum) {
		return {aV: elements, Cj: maximum, CD: minimum, g1: nature, r8: uid};
	});
var $author$project$Components$Parametrage$Common$API$QueryAPIModel$elementResumeDecoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (uid, nomme) {
			return A2($elm$core$Maybe$withDefault, uid, nomme);
		}),
	A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string)));
var $author$project$Components$Parametrage$Common$API$QueryAPIModel$sourceResumeDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'maximum',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'minimum',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'elements',
			$elm$json$Json$Decode$list($author$project$Components$Parametrage$Common$API$QueryAPIModel$elementResumeDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'nature',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'uid',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Common$API$QueryAPIModel$SourceResume))))));
var $author$project$Components$Parametrage$Common$API$QueryAPIModel$resumeDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'sources',
	$elm$json$Json$Decode$list($author$project$Components$Parametrage$Common$API$QueryAPIModel$sourceResumeDecoder),
	_List_Nil,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		A2(
			$elm$json$Json$Decode$map,
			$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$pipe),
			$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'portails',
			$elm$json$Json$Decode$list(
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							$elm$json$Json$Decode$string,
							A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string)
						]))),
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'dossiersEnCours',
				$elm$json$Json$Decode$int,
				0,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
					_List_fromArray(
						['objetVise', 'typesDeFiche']),
					A2(
						$elm$json$Json$Decode$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$head,
							$elm$core$Maybe$withDefault('')),
						$elm$json$Json$Decode$list($author$project$Components$Parametrage$Common$API$QueryAPIModel$libelleDuType)),
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'lien',
						$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$Common$API$QueryAPIModel$lienDecoder),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'etat',
							$elm$json$Json$Decode$string,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'versionBrouillon',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'versionPubliee',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
									$elm$core$Maybe$Nothing,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'nombrePassages',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'nombreDEtapes',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'motDossier',
												$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'libelles',
													$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'code',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'uid',
															$elm$json$Json$Decode$string,
															$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Common$API$QueryAPIModel$PipeResume))))))))))))))));
var $author$project$Components$Parametrage$Common$API$QueryAPIModel$annuaireDecoder = A2(
	$elm$json$Json$Decode$field,
	'pipes',
	$elm$json$Json$Decode$list($author$project$Components$Parametrage$Common$API$QueryAPIModel$resumeDecoder));
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$Element = F3(
	function (uid, libelle, detail) {
		return {bB: detail, Bl: libelle, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$elementDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'detail',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'libelle',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'uid',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$Element)))),
			A2(
			$elm$json$Json$Decode$map,
			function (uid) {
				return {bB: $elm$core$Maybe$Nothing, Bl: uid, r8: uid};
			},
			$elm$json$Json$Decode$string)
		]));
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$candidatsDecoder = A2(
	$elm$json$Json$Decode$field,
	'candidats',
	$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$elementDecoder));
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$Edition = function (uid) {
	return function (code) {
		return function (libelles) {
			return function (motDossier) {
				return function (motDossierPluriel) {
					return function (numero) {
						return function (statut) {
							return function (versionPubliee) {
								return function (nombreDEtapes) {
									return function (nombrePassages) {
										return function (sources) {
											return function (ouverture) {
												return function (lienDeLOuverture) {
													return function (lienDApercu) {
														return function (lienDesOptionsChoisies) {
															return function (objetVise) {
																return function (liens) {
																	return function (liensDeLEdition) {
																		return function (pageDuPortail) {
																			return function (exemple) {
																				return function (intituleCourt) {
																					return function (descriptionDuDossier) {
																						return function (nomGrammatical) {
																							return function (ouverturesParUnTiers) {
																								return function (optionsDesOuvertures) {
																									return function (exemples) {
																										return function (fichesCreeesProposees) {
																											return function (aUneTacheDeValidation) {
																												return {sH: aUneTacheDeValidation, vx: code, xr: descriptionDuDossier, yY: exemple, y_: exemples, zv: fichesCreeesProposees, AT: intituleCourt, R: libelles, By: lienDApercu, BA: lienDeLOuverture, BH: lienDesOptionsChoisies, nQ: liens, BN: liensDeLEdition, CW: motDossier, CX: motDossierPluriel, Dr: nomGrammatical, Dt: nombreDEtapes, DE: nombrePassages, DX: numero, D_: objetVise, Ei: optionsDesOuvertures, ew: ouverture, Ew: ouverturesParUnTiers, EF: pageDuPortail, IT: sources, ri: statut, r8: uid, KM: versionPubliee};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$ExemplesDOffre = F2(
	function (avecOffre, sansOffre) {
		return {jj: avecOffre, qZ: sansOffre};
	});
var $author$project$API$NavLinksDictionary$apercuDeLObjetVise = 'apercu-de-l-objet-vise';
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$ExempleDeDossier = F2(
	function (personne, offre) {
		return {D1: offre, Fd: personne};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$exempleDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$ExempleDeDossier,
	A2($elm$json$Json$Decode$field, 'personne', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'offre', $elm$json$Json$Decode$string)));
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$LienDuPipe = F4(
	function (type_, sens, autrePipe, lecture) {
		return {t5: autrePipe, np: lecture, IC: sens, r0: type_};
	});
var $author$project$API$NavLinksDictionary$lienDuPipe = 'lien';
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$sensDuLien = function (type_) {
	return (type_ === 'enchainement') ? 'est-declenche-par' : 'regroupe';
};
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$lienDuPipeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		return A4(
			$elm$json$Json$Decode$map3,
			$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$LienDuPipe(type_),
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2($elm$json$Json$Decode$field, 'sens', $elm$json$Json$Decode$string),
						$elm$json$Json$Decode$succeed(
						$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$sensDuLien(type_))
					])),
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['autrePipe', 'libelle']),
						$elm$json$Json$Decode$string),
						A2($elm$json$Json$Decode$field, 'pipeLie', $elm$json$Json$Decode$string)
					])),
			A2(
				$elm$json$Json$Decode$map,
				function (liens) {
					return $elm$core$List$head(
						A2(
							$elm$core$List$filterMap,
							function (rel) {
								return A2($author$project$API$Liens$trouver, rel, liens);
							},
							_List_fromArray(
								[$author$project$API$NavLinksDictionary$lienDuPipe, $author$project$API$NavLinksDictionary$self])));
				},
				$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder));
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$Forme = F4(
	function (singulier, pluriel, genre, elision) {
		return {av: elision, M: genre, bT: pluriel, IN: singulier};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$Feminin = 1;
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$Masculin = 0;
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$genreDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (genre) {
		switch (genre) {
			case 'masculin':
				return $elm$json$Json$Decode$succeed(0);
			case 'feminin':
				return $elm$json$Json$Decode$succeed(1);
			default:
				var autre = genre;
				return $elm$json$Json$Decode$fail('genre ' + autre);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$formeDecoder = A4(
	$elm$json$Json$Decode$map3,
	F4(
		function (pluriel, genre, elision, singulier) {
			return A4($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$Forme, singulier, pluriel, genre, elision);
		}),
	A2($elm$json$Json$Decode$field, 'pluriel', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'genre', $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$genreDecoder),
	A2($elm$json$Json$Decode$field, 'elision', $elm$json$Json$Decode$bool));
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$nomGrammaticalDecoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (libelles, formes) {
			return $elm$core$Dict$fromList(
				A2(
					$elm$core$List$filterMap,
					function (_v0) {
						var langue = _v0.a;
						var forme = _v0.b;
						return A2(
							$elm$core$Maybe$map,
							function (singulier) {
								return _Utils_Tuple2(
									langue,
									forme(singulier));
							},
							A2($elm$core$Dict$get, langue, libelles));
					},
					$elm$core$Dict$toList(formes)));
		}),
	A2(
		$elm$json$Json$Decode$field,
		'libelles',
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$field,
		'grammaire',
		$elm$json$Json$Decode$dict($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$formeDecoder)));
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$ObjetVise = F8(
	function (nature, types, libelle, rolePersonne, roleParLangue, libelleDuRole, tous, typesDeProduit) {
		return {Bl: libelle, gR: libelleDuRole, g1: nature, qQ: roleParLangue, qR: rolePersonne, rL: tous, ib: types, id: typesDeProduit};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$TypeDeFiche = F4(
	function (code, libelle, qualite, archetype) {
		return {fA: archetype, vx: code, Bl: libelle, hy: qualite};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$typeDeFicheDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$TypeDeFiche,
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string)
			])),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle,
				A2(
					$elm$json$Json$Decode$field,
					'libelles',
					$elm$json$Json$Decode$dict($elm$json$Json$Decode$string))),
				A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string)
			])),
	$elm$json$Json$Decode$maybe(
		A2(
			$elm$json$Json$Decode$field,
			'qualite',
			$elm$json$Json$Decode$dict($elm$json$Json$Decode$string))),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'archetype', $elm$json$Json$Decode$string)));
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$objetViseDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'typesDeProduit',
	$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$typeDeFicheDecoder),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'tous',
		$elm$json$Json$Decode$bool,
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'libelleDuRole',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$elm$json$Json$Decode$maybe(
					A2(
						$elm$json$Json$Decode$field,
						'rolePersonne',
						$elm$json$Json$Decode$dict($elm$json$Json$Decode$string))),
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'rolePersonne',
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$nomGrammaticalDecoder),
								$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
							])),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'libelle',
						$elm$json$Json$Decode$string,
						'',
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'typesDeFiche',
							$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$typeDeFicheDecoder),
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'nature',
								$elm$json$Json$Decode$string,
								'',
								$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$ObjetVise)))))))));
var $author$project$API$NavLinksDictionary$optionsDeLObjetVise = 'options-de-l-objet-vise';
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$OptionsDesOuvertures = F2(
	function (roles, portails) {
		return {F_: portails, eX: roles};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$OptionDeRole = F2(
	function (uid, libelles) {
		return {R: libelles, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$optionDeRoleDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$OptionDeRole,
	A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'libelles',
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)));
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$Portail = F2(
	function (code, libelle) {
		return {vx: code, Bl: libelle};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$portailDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$Portail,
	A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string));
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$optionsDesOuverturesDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$OptionsDesOuvertures,
	A2(
		$elm$json$Json$Decode$field,
		'roles',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$optionDeRoleDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'portails',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$portailDecoder)));
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$Ouverture = F4(
	function (qui, evenements, periode, parPersonne) {
		return {mk: evenements, EU: parPersonne, pi: periode, GK: qui};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$EvenementOuvreur = F3(
	function (type_, pipeDOrigine, etape) {
		return {me: etape, Fu: pipeDOrigine, r0: type_};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$evenementDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'etapeUid',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'pipeDOrigineUid',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$EvenementOuvreur))));
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$EntreDeuxDates = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$Toujours = {$: 0};
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$Recurrente = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$recurrenteDecoder = A6(
	$elm$json$Json$Decode$map5,
	F5(
		function (rythme, jourDOuverture, moisDOuverture, jourDeFermeture, moisDeFermeture) {
			return $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$Recurrente(
				{A$: jourDOuverture, A0: jourDeFermeture, CR: moisDOuverture, oh: moisDeFermeture, Ij: rythme});
		}),
	A2($elm$json$Json$Decode$field, 'rythme', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['ouverture', 'jour']),
		$elm$json$Json$Decode$int),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['ouverture', 'mois']),
		$elm$json$Json$Decode$string),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['fermeture', 'jour']),
					$elm$json$Json$Decode$int)),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			])),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['fermeture', 'mois']),
		$elm$json$Json$Decode$string));
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$periodeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		switch (type_) {
			case 'toujours':
				return $elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$Toujours);
			case 'entre-deux-dates':
				return A3(
					$elm$json$Json$Decode$map2,
					$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$EntreDeuxDates,
					A2($elm$json$Json$Decode$field, 'du', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'au', $elm$json$Json$Decode$string));
			case 'recurrente':
				return $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$recurrenteDecoder;
			default:
				var autre = type_;
				return $elm$json$Json$Decode$fail('periode ' + autre);
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$ouvertureDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'parPersonne',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'periode',
		$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$periodeDecoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'evenements',
			$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$evenementDecoder),
			_List_Nil,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'qui',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$Ouverture)))));
var $author$project$API$NavLinksDictionary$ouvertureDuPipe = 'ouverture';
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$OuvertureParUnTiers = F3(
	function (role, portail, fiche) {
		return {zo: fiche, FY: portail, bi: role};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$FicheExistante = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$NouvelleFiche = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$ficheOuverteDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (cas) {
		return (cas === 'nouvelle-fiche') ? A3(
			$elm$json$Json$Decode$map2,
			$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$NouvelleFiche,
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$field,
						'types',
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
						$elm$json$Json$Decode$succeed(_List_Nil)
					])),
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$andThen,
						function (sans) {
							return sans ? $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing) : $elm$json$Json$Decode$fail('');
						},
						A2($elm$json$Json$Decode$field, 'sansPlafond', $elm$json$Json$Decode$bool)),
						A2(
						$elm$json$Json$Decode$map,
						$elm$core$Maybe$Just,
						A2($elm$json$Json$Decode$field, 'plafondDeFichesProposees', $elm$json$Json$Decode$int)),
						$elm$json$Json$Decode$succeed(
						$elm$core$Maybe$Just(20))
					]))) : A2(
			$elm$json$Json$Decode$map,
			$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$FicheExistante,
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2($elm$json$Json$Decode$field, 'dansSonPerimetre', $elm$json$Json$Decode$bool),
						$elm$json$Json$Decode$succeed(false)
					])));
	},
	A2($elm$json$Json$Decode$field, 'cas', $elm$json$Json$Decode$string));
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$ouvertureParUnTiersDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$OuvertureParUnTiers,
	A2($elm$json$Json$Decode$field, 'role', $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$optionDeRoleDecoder),
	A2($elm$json$Json$Decode$field, 'portail', $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$portailDecoder),
	A2($elm$json$Json$Decode$field, 'fiche', $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$ficheOuverteDecoder));
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$Source = F9(
	function (uid, nature, elements, minimum, maximum, lecture, modification, retrait, nomDesElements) {
		return {aV: elements, np: lecture, Cj: maximum, CD: minimum, CM: modification, g1: nature, Dm: nomDesElements, eW: retrait, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$elementsDeLaSourceDecoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (uids, nommes) {
			return A2(
				$elm$core$List$map,
				function (element) {
					return A2(
						$elm$core$Maybe$withDefault,
						element,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (nomme) {
									return _Utils_eq(nomme.r8, element.r8);
								},
								nommes)));
				},
				uids);
		}),
	A2(
		$elm$json$Json$Decode$field,
		'elements',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$elementDecoder)),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'elementsNommes',
				$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$elementDecoder)),
				$elm$json$Json$Decode$succeed(_List_Nil)
			])));
var $author$project$API$NavLinksDictionary$modifierUneSourceDOffre = 'modifier-une-source-d-offre';
var $author$project$API$NavLinksDictionary$retirerUneSourceDOffre = 'retirer-une-source-d-offre';
var $author$project$API$NavLinksDictionary$sourceDOffre = 'source-d-offre';
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$sourceDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'nomDesElements',
	$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$nomGrammaticalDecoder),
	$elm$core$Maybe$Nothing,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		A2(
			$elm$json$Json$Decode$map,
			$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$retirerUneSourceDOffre),
			$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder),
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2(
				$elm$json$Json$Decode$map,
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$modifierUneSourceDOffre),
				$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder),
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A2(
					$elm$json$Json$Decode$map,
					$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$sourceDOffre),
					$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder),
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'maximum',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'minimum',
						$elm$json$Json$Decode$int,
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$elementsDeLaSourceDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'nature',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'uid',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$Source))))))))));
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$editionDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'aUneTacheDeValidation',
	$elm$json$Json$Decode$bool,
	true,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'fichesCreeesProposees',
		$elm$json$Json$Decode$bool,
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'exemplesDOffre',
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$ExemplesDOffre,
				A2(
					$elm$json$Json$Decode$field,
					'avecOffre',
					$elm$json$Json$Decode$list($author$project$Components$Parametrage$Common$API$QueryAPIModel$resumeDecoder)),
				A2(
					$elm$json$Json$Decode$field,
					'sansOffre',
					$elm$json$Json$Decode$list($author$project$Components$Parametrage$Common$API$QueryAPIModel$resumeDecoder))),
			{jj: _List_Nil, qZ: _List_Nil},
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'optionsDesOuvertures',
				$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$optionsDesOuverturesDecoder,
				{F_: _List_Nil, eX: _List_Nil},
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'ouverturesParUnTiers',
					$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$ouvertureParUnTiersDecoder),
					_List_Nil,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
						_List_fromArray(
							['pipe', 'nomGrammatical']),
						$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$nomGrammaticalDecoder),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
							_List_fromArray(
								['pipe', 'descriptionDuDossier']),
							$elm$json$Json$Decode$nullable(
								$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
								_List_fromArray(
									['pipe', 'intituleCourt']),
								$elm$json$Json$Decode$nullable(
									$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'exempleDeDossier',
									$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$exempleDecoder),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
										_List_fromArray(
											['ouverture', 'pageDuPortail']),
										$elm$json$Json$Decode$nullable(
											A2(
												$elm$json$Json$Decode$field,
												'libelles',
												$elm$json$Json$Decode$dict($elm$json$Json$Decode$string))),
										$elm$core$Maybe$Nothing,
										A2(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
											$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'liens',
												$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$lienDuPipeDecoder),
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'objetVise',
													$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$objetViseDecoder,
													{Bl: '', gR: $elm$core$Maybe$Nothing, g1: 'aucun', qQ: $elm$core$Maybe$Nothing, qR: $elm$core$Maybe$Nothing, rL: false, ib: _List_Nil, id: _List_Nil},
													A2(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
														A2(
															$elm$json$Json$Decode$map,
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.gF;
																},
																$author$project$API$Liens$trouverGabarit($author$project$API$NavLinksDictionary$optionsDeLObjetVise)),
															$elm$json$Json$Decode$oneOf(
																_List_fromArray(
																	[
																		$author$project$API$Liens$deLaRessource,
																		$elm$json$Json$Decode$succeed($author$project$API$Liens$aucun)
																	]))),
														A2(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
															A2(
																$elm$json$Json$Decode$map,
																A2(
																	$elm$core$Basics$composeR,
																	function ($) {
																		return $.gF;
																	},
																	$author$project$API$Liens$trouverGabarit($author$project$API$NavLinksDictionary$apercuDeLObjetVise)),
																$elm$json$Json$Decode$oneOf(
																	_List_fromArray(
																		[
																			$author$project$API$Liens$deLaRessource,
																			$elm$json$Json$Decode$succeed($author$project$API$Liens$aucun)
																		]))),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
																_List_fromArray(
																	['ouverture']),
																A2(
																	$elm$json$Json$Decode$map,
																	$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$ouvertureDuPipe),
																	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'ouverture',
																	$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$ouvertureDecoder,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
																		_List_fromArray(
																			['offre', 'sources']),
																		$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$sourceDecoder),
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
																			_List_fromArray(
																				['resume', 'nombrePassages']),
																			$elm$json$Json$Decode$int,
																			0,
																			A4(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
																				_List_fromArray(
																					['resume', 'nombreDEtapes']),
																				$elm$json$Json$Decode$int,
																				0,
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
																					_List_fromArray(
																						['version', 'versionPubliee']),
																					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																					$elm$core$Maybe$Nothing,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
																						_List_fromArray(
																							['version', 'statut']),
																						$elm$json$Json$Decode$string,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
																							_List_fromArray(
																								['version', 'numero']),
																							$elm$json$Json$Decode$int,
																							A4(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
																								_List_fromArray(
																									['pipe', 'motDossierPluriel']),
																								$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
																								$elm$core$Dict$empty,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
																									_List_fromArray(
																										['pipe', 'motDossier']),
																									$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
																										_List_fromArray(
																											['pipe', 'libelles']),
																										$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
																											_List_fromArray(
																												['pipe', 'code']),
																											$elm$json$Json$Decode$string,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
																												_List_fromArray(
																													['pipe', 'uid']),
																												$elm$json$Json$Decode$string,
																												$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$Edition)))))))))))))))))))))))))))));
var $author$project$Components$Parametrage$PipeEtape1$API$LienModel$LienLu = F6(
	function (uid, type_, regroupement, enchainement, modification, options) {
		return {yn: enchainement, CM: modification, o_: options, Ho: regroupement, r0: type_, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$LienModel$Enchainement = F6(
	function (pipeDeDepart, etapeDeDepart, passageDeclencheur, fiche, roles, champs) {
		return {dw: champs, yJ: etapeDeDepart, zo: fiche, E3: passageDeclencheur, Fv: pipeDeDepart, eX: roles};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$LienModel$enchainementDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
	_List_fromArray(
		['reprise', 'champs']),
	$elm$json$Json$Decode$list(
		A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['reprise', 'roles']),
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['reprise', 'fiche']),
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['passageDeclencheur', 'uid']),
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['etapeDeDepart', 'uid']),
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['pipeDeDepart', 'uid']),
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape1$API$LienModel$Enchainement)))))));
var $author$project$API$NavLinksDictionary$modifierLeLien = 'modifier-le-lien';
var $author$project$API$NavLinksDictionary$optionsDeLien = 'options';
var $author$project$Components$Parametrage$PipeEtape1$API$LienModel$Agregat = F2(
	function (libelle, description) {
		return {dH: description, Bl: libelle};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$LienModel$Regroupement = F7(
	function (pipeRegroupe, regle, jour, critere, periode, champ, agregats) {
		return {s4: agregats, uN: champ, km: critere, A_: jour, pi: periode, FH: pipeRegroupe, hH: regle};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$LienModel$regroupementDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'agregats',
	$elm$json$Json$Decode$list(
		A3(
			$elm$json$Json$Decode$map2,
			$author$project$Components$Parametrage$PipeEtape1$API$LienModel$Agregat,
			A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string),
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string),
						$elm$json$Json$Decode$succeed('')
					])))),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			['critere', 'champ']),
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
			_List_fromArray(
				['critere', 'periode']),
			$elm$json$Json$Decode$string,
			'',
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['critere', 'type']),
				$elm$json$Json$Decode$string,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
					_List_fromArray(
						['regleDeCreation', 'jour']),
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['regleDeCreation', 'mode']),
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['pipeRegroupe', 'uid']),
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape1$API$LienModel$Regroupement))))))));
var $author$project$Components$Parametrage$PipeEtape1$API$LienModel$lienLuDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$optionsDeLien),
		$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder),
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		A2(
			$elm$json$Json$Decode$map,
			$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$modifierLeLien),
			$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'enchainement',
			$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeEtape1$API$LienModel$enchainementDecoder),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'regroupement',
				$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeEtape1$API$LienModel$regroupementDecoder),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'type',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'uid',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape1$API$LienModel$LienLu)))))));
var $author$project$Components$Parametrage$PipeEtape1$API$LienModel$ChampReprenable = F3(
	function (champ, libelle, origine) {
		return {uN: champ, Bl: libelle, o4: origine};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$LienModel$EtapeProposee = F2(
	function (uid, libelle) {
		return {Bl: libelle, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$LienModel$OptionsDeLien = F5(
	function (pipesLiables, etapes, passages, champsReprenables, suivante) {
		return {u0: champsReprenables, yL: etapes, E5: passages, eE: pipesLiables, I7: suivante};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$LienModel$PassagePropose = F2(
	function (uid, libelle) {
		return {Bl: libelle, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$LienModel$PipeLiable = F3(
	function (uid, libelle, motDossier) {
		return {Bl: libelle, CW: motDossier, r8: uid};
	});
var $author$project$API$NavLinksDictionary$pageSuivante = 'page-suivante';
var $author$project$Components$Parametrage$PipeEtape1$API$LienModel$optionsDeLienDecoder = function () {
	var uidLibelle = function (make) {
		return A3(
			$elm$json$Json$Decode$map2,
			make,
			A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string));
	};
	var groupe = F2(
		function (cle, decodeur) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$map,
						$elm$core$Dict$toList,
						$elm$json$Json$Decode$dict(
							$elm$json$Json$Decode$list(decodeur))),
						$elm$json$Json$Decode$list(
						A3(
							$elm$json$Json$Decode$map2,
							$elm$core$Tuple$pair,
							A2($elm$json$Json$Decode$field, cle, $elm$json$Json$Decode$string),
							A2(
								$elm$json$Json$Decode$field,
								(cle === 'pipeUid') ? 'etapes' : 'passages',
								$elm$json$Json$Decode$list(decodeur))))
					]));
		});
	return A6(
		$elm$json$Json$Decode$map5,
		$author$project$Components$Parametrage$PipeEtape1$API$LienModel$OptionsDeLien,
		A2(
			$elm$json$Json$Decode$field,
			'pipesLiables',
			$elm$json$Json$Decode$list(
				A4(
					$elm$json$Json$Decode$map3,
					$author$project$Components$Parametrage$PipeEtape1$API$LienModel$PipeLiable,
					A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$json$Json$Decode$field,
								'motDossier',
								$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$nomGrammaticalDecoder)),
								$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
							]))))),
		A2(
			$elm$json$Json$Decode$field,
			'etapesParPipe',
			A2(
				groupe,
				'pipeUid',
				uidLibelle($author$project$Components$Parametrage$PipeEtape1$API$LienModel$EtapeProposee))),
		A2(
			$elm$json$Json$Decode$field,
			'passagesParEtape',
			A2(
				groupe,
				'etapeUid',
				uidLibelle($author$project$Components$Parametrage$PipeEtape1$API$LienModel$PassagePropose))),
		A2(
			$elm$json$Json$Decode$field,
			'champsReprenables',
			$elm$json$Json$Decode$list(
				A4(
					$elm$json$Json$Decode$map3,
					$author$project$Components$Parametrage$PipeEtape1$API$LienModel$ChampReprenable,
					A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2($elm$json$Json$Decode$field, 'origine', $elm$json$Json$Decode$string),
								$elm$json$Json$Decode$succeed('')
							]))))),
		A2(
			$elm$json$Json$Decode$map,
			$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$pageSuivante),
			$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder));
}();
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$OuvertureLue = F8(
	function (ouverture, quiPossibles, evenementsPossibles, pipesDOrigine, rythmes, moisDeFermeture, parPersonnePossibles, suivante) {
		return {yU: evenementsPossibles, oh: moisDeFermeture, ew: ouverture, EV: parPersonnePossibles, FN: pipesDOrigine, GL: quiPossibles, Ik: rythmes, I7: suivante};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$PipeDOrigine = F3(
	function (code, libelle, etapes) {
		return {vx: code, yL: etapes, Bl: libelle};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$etapeDecoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (uid, libelle) {
			return {Bl: libelle, r8: uid};
		}),
	A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string));
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$pipeDOrigineDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$PipeDOrigine,
	A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'etapes',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$etapeDecoder)));
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$ouvertureLueDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$pageSuivante),
		$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['options', 'parPersonne']),
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['options', 'moisFermeture']),
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['options', 'rythmes']),
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['options', 'pipesDOrigine']),
					$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$pipeDOrigineDecoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['options', 'evenements']),
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['options', 'qui']),
							$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
								$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$ouvertureDecoder,
								$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$OuvertureLue)))))))));
var $author$project$API$NavLinksDictionary$edition = 'edition';
var $author$project$Components$Parametrage$Common$API$QueryAPIModel$racineDuPipeDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$edition),
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder);
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$LibellesDesRoles = F3(
	function (partiePrenante, produit, marque) {
		return {gX: marque, E$: partiePrenante, Gp: produit};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$OptionDeType = F4(
	function (code, libelle, archetype, nombreDeFiches) {
		return {fA: archetype, vx: code, Bl: libelle, oC: nombreDeFiches};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$OptionsDeLObjetVise = F4(
	function (types, typesDeProduit, libellesDesRoles, champsCommuns) {
		return {uT: champsCommuns, Bs: libellesDesRoles, ib: types, id: typesDeProduit};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$typesDeFicheDecoder = function () {
	var options = $elm$json$Json$Decode$list(
		A5(
			$elm$json$Json$Decode$map4,
			$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$OptionDeType,
			A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle,
				A2(
					$elm$json$Json$Decode$field,
					'libelles',
					$elm$json$Json$Decode$dict($elm$json$Json$Decode$string))),
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2($elm$json$Json$Decode$field, 'archetype', $elm$json$Json$Decode$string),
						$elm$json$Json$Decode$succeed('')
					])),
			A2($elm$json$Json$Decode$field, 'nombreDeFiches', $elm$json$Json$Decode$int)));
	return A5(
		$elm$json$Json$Decode$map4,
		$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$OptionsDeLObjetVise,
		A2($elm$json$Json$Decode$field, 'types', options),
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'typesDeProduit', options)),
		$elm$json$Json$Decode$maybe(
			A2(
				$elm$json$Json$Decode$field,
				'libellesDesRoles',
				A4(
					$elm$json$Json$Decode$map3,
					$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$LibellesDesRoles,
					A2(
						$elm$json$Json$Decode$field,
						'partiePrenante',
						$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)),
					A2(
						$elm$json$Json$Decode$field,
						$author$project$Components$Parametrage$Vocabulaire$natureProduit,
						$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)),
					A2(
						$elm$json$Json$Decode$field,
						$author$project$Components$Parametrage$Vocabulaire$natureMarque,
						$elm$json$Json$Decode$dict($elm$json$Json$Decode$string))))),
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'champsCommuns', $elm$json$Json$Decode$int)));
}();
var $author$project$Components$Parametrage$PipeEtape1$Update$refusDeLecture = F2(
	function (lecture, reponse) {
		var refuse = function (decodeur) {
			var _v1 = A2($author$project$API$Reponse$lire, decodeur, reponse);
			if (_v1.$ === 1) {
				var refus = _v1.a;
				return ((refus.ri === 401) || (refus.ri === 404)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Components$Shared$Messages$Model$duRefus(refus));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		switch (lecture) {
			case 0:
				return refuse($author$project$Components$Parametrage$Common$API$QueryAPIModel$annuaireDecoder);
			case 1:
				return refuse($author$project$Components$Parametrage$Common$API$QueryAPIModel$racineDuPipeDecoder);
			case 2:
				return refuse($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$editionDecoder);
			case 3:
				return refuse($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$sourceDecoder);
			case 4:
				return refuse($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$candidatsDecoder);
			case 5:
				return refuse($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$ouvertureLueDecoder);
			case 6:
				return refuse($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$typesDeFicheDecoder);
			case 7:
				return refuse($author$project$Components$Parametrage$PipeEtape1$API$LienModel$lienLuDecoder);
			case 8:
				return refuse($author$project$Components$Parametrage$PipeEtape1$API$LienModel$optionsDeLienDecoder);
			case 9:
				return refuse($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$ouvertureLueDecoder);
			default:
				return refuse($author$project$Components$Parametrage$PipeEtape1$API$LienModel$optionsDeLienDecoder);
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$popMessages = function (msg) {
	if (msg.$ === 2) {
		var lecture = msg.a;
		var reponse = msg.b;
		return A2($author$project$Components$Parametrage$PipeEtape1$Update$refusDeLecture, lecture, reponse);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$PipeEtape1$Update$Annuaire = 0;
var $author$project$Components$Parametrage$PipeEtape1$Update$Candidats = 4;
var $author$project$Components$Parametrage$PipeEtape1$Update$DemanderProcessUid = {$: 2};
var $author$project$Components$Parametrage$PipeEtape1$Update$LienDetail = 7;
var $author$project$Components$Parametrage$PipeEtape1$Update$Lire = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape1$Model$MotEnSaisie = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$Model$NomEnSaisie = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$Model$ObjetViseEnSaisie = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$Model$OffreEnSaisie = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$Update$Options = 5;
var $author$project$Components$Parametrage$PipeEtape1$Update$OptionsDeLien = 8;
var $author$project$Components$Parametrage$PipeEtape1$Model$OuvertureEnSaisie = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$Model$OuvertureParUnTiersEnSaisie = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$Update$PageDesOrigines = 9;
var $author$project$Components$Parametrage$PipeEtape1$Update$PageDesPipesLiables = 10;
var $author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$RetirerUneOuvertureParUnTiers = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$TypesDeFiche = 6;
var $author$project$Components$Parametrage$PipeEtape1$Lien$Ajout = {$: 1};
var $author$project$Components$Parametrage$PipeEtape1$Lien$Creation = {$: 0};
var $author$project$Components$Parametrage$PipeEtape1$Lien$creation = {s4: _List_Nil, uN: '', jD: false, K: _List_Nil, km: 'periode', yJ: '', zo: true, A_: '8', n9: $author$project$Components$Parametrage$PipeEtape1$Lien$Creation, ej: $elm$core$Dict$empty, Dj: $elm$core$Dict$empty, aH: '', pi: 'mois-civil', Fv: '', FH: '', hH: 'un-par-mois', eX: true, r0: ''};
var $author$project$Components$Parametrage$PipeEtape1$Lien$ajout = _Utils_update(
	$author$project$Components$Parametrage$PipeEtape1$Lien$creation,
	{n9: $author$project$Components$Parametrage$PipeEtape1$Lien$Ajout});
var $author$project$API$NavLinksDictionary$ajouterUnTypeDeDossier = 'ajouter-un-type-de-dossier';
var $author$project$API$NavLinksDictionary$ajouterUneOuvertureParUnTiers = 'ajouter-une-ouverture-par-un-tiers';
var $author$project$Components$Parametrage$PipeEtape1$Lien$basculer = F3(
	function (coche, coche_, saisie) {
		switch (coche.$) {
			case 0:
				return _Utils_update(
					saisie,
					{zo: coche_});
			case 1:
				return _Utils_update(
					saisie,
					{eX: coche_});
			case 2:
				return _Utils_update(
					saisie,
					{
						jD: coche_,
						K: coche_ ? saisie.K : _List_Nil
					});
			default:
				var champ = coche.a;
				return _Utils_update(
					saisie,
					{
						K: coche_ ? (A2($elm$core$List$member, champ, saisie.K) ? saisie.K : _Utils_ap(
							saisie.K,
							_List_fromArray(
								[champ]))) : A2(
							$elm$core$List$filter,
							$elm$core$Basics$neq(champ),
							saisie.K)
					});
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$Model$basculer = F3(
	function (valeur, coche, valeurs) {
		return coche ? (A2($elm$core$List$member, valeur, valeurs) ? valeurs : _Utils_ap(
			valeurs,
			_List_fromArray(
				[valeur]))) : A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(valeur),
			valeurs);
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$basculerLElement = F4(
	function (candidats, uid, coche, source) {
		if (coche) {
			var _v0 = $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (element) {
						return _Utils_eq(element.r8, uid);
					},
					candidats));
			if (!_v0.$) {
				var element = _v0.a;
				return A2(
					$elm$core$List$any,
					function (deja) {
						return _Utils_eq(deja.r8, uid);
					},
					source.aV) ? source : _Utils_update(
					source,
					{
						aV: _Utils_ap(
							source.aV,
							_List_fromArray(
								[element]))
					});
			} else {
				return source;
			}
		} else {
			return _Utils_update(
				source,
				{
					aV: A2(
						$elm$core$List$filter,
						function (element) {
							return !_Utils_eq(element.r8, uid);
						},
						source.aV)
				});
		}
	});
var $author$project$API$NavLinksDictionary$candidatsDOffre = 'candidats';
var $author$project$Components$Parametrage$PipeEtape1$Update$champDeLOuverture = F3(
	function (champ, texte, saisie) {
		switch (champ) {
			case 0:
				return _Utils_update(
					saisie,
					{me: '', Fu: texte});
			case 1:
				return _Utils_update(
					saisie,
					{me: texte});
			case 2:
				return _Utils_update(
					saisie,
					{pi: texte});
			case 3:
				return _Utils_update(
					saisie,
					{cE: texte});
			case 4:
				return _Utils_update(
					saisie,
					{cm: texte});
			case 5:
				return _Utils_update(
					saisie,
					{Ij: texte});
			case 6:
				return _Utils_update(
					saisie,
					{A$: texte});
			case 7:
				return _Utils_update(
					saisie,
					{CR: texte});
			case 8:
				return _Utils_update(
					saisie,
					{A0: texte});
			case 9:
				return _Utils_update(
					saisie,
					{oh: texte});
			default:
				return _Utils_update(
					saisie,
					{EU: texte});
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$Lien$choisir = F3(
	function (reglage, texte, saisie) {
		switch (reglage.$) {
			case 0:
				var langue = reglage.a;
				return _Utils_update(
					saisie,
					{
						Dj: A3($elm$core$Dict$insert, langue, texte, saisie.Dj)
					});
			case 1:
				var langue = reglage.a;
				return _Utils_update(
					saisie,
					{
						ej: A3($elm$core$Dict$insert, langue, texte, saisie.ej)
					});
			case 2:
				return _Utils_update(
					saisie,
					{r0: texte});
			case 3:
				return _Utils_update(
					saisie,
					{FH: texte});
			case 4:
				return _Utils_update(
					saisie,
					{hH: texte});
			case 5:
				return _Utils_update(
					saisie,
					{
						A_: A2($elm$core$String$filter, $elm$core$Char$isDigit, texte)
					});
			case 6:
				return _Utils_update(
					saisie,
					{km: texte});
			case 7:
				return _Utils_update(
					saisie,
					{pi: texte});
			case 8:
				return _Utils_update(
					saisie,
					{uN: texte});
			case 9:
				return _Utils_update(
					saisie,
					{yJ: '', aH: '', Fv: texte});
			case 10:
				return _Utils_update(
					saisie,
					{yJ: texte, aH: ''});
			default:
				return _Utils_update(
					saisie,
					{aH: texte});
		}
	});
var $author$project$API$NavLinksDictionary$definirLObjetVise = 'definir-l-objet-vise';
var $author$project$Components$Parametrage$PipeEtape1$Update$enOffre = F2(
	function (source, model) {
		var _v0 = model.mW;
		if ((!_v0.$) && (_v0.a.$ === 2)) {
			return $elm$core$Maybe$Just(
				$author$project$Components$Parametrage$PipeEtape1$Model$OffreEnSaisie(source));
		} else {
			var autre = _v0;
			return autre;
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$AjouterUnTypeDeDossier = F3(
	function (a, b, c) {
		return {$: 7, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$AjouterUneOuvertureParUnTiers = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$AjouterUneSource = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$DefinirLObjetVise = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$ModifierLeLien = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$ModifierLeMotEmploye = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$ModifierUneOuvertureParUnTiers = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$ModifierUneSource = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$ReglerLOuverture = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$RenommerLePipe = function (a) {
	return {$: 0, a: a};
};
var $author$project$API$NavLinksDictionary$ajouterUneSourceDOffre = 'ajouter-une-source-d-offre';
var $author$project$Components$Parametrage$PipeEtape1$Model$libellesVoulus = function (libelles) {
	return $elm$core$String$isEmpty(
		$elm$core$String$trim(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Dict$get, 'fr', libelles)))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		A2(
			$elm$core$Dict$filter,
			F2(
				function (_v0, texte) {
					return !$elm$core$String$isEmpty(
						$elm$core$String$trim(texte));
				}),
			libelles));
};
var $author$project$Components$Parametrage$PipeEtape1$Update$lienDe = F2(
	function (rel, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (edition) {
				return A2($author$project$API$Liens$trouver, rel, edition.BN);
			},
			model.ge);
	});
var $author$project$API$NavLinksDictionary$modifierLeMotEmploye = 'modifier-le-mot-employe';
var $author$project$API$NavLinksDictionary$modifierUneOuvertureParUnTiers = 'modifier-une-ouverture-par-un-tiers';
var $author$project$Components$Parametrage$PipeEtape1$Model$motVoulu = function (saisie) {
	return A2(
		$elm$core$Maybe$map,
		function (singulier) {
			return _Utils_Tuple2(
				singulier,
				A2(
					$elm$core$Dict$filter,
					F2(
						function (_v0, texte) {
							return !$elm$core$String$isEmpty(
								$elm$core$String$trim(texte));
						}),
					saisie.bT));
		},
		$author$project$Components$Parametrage$PipeEtape1$Model$libellesVoulus(saisie.IN));
};
var $author$project$Components$Parametrage$PipeEtape1$Model$plafondVoulu = function (saisie) {
	if (saisie.e$) {
		return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
	} else {
		var _v0 = $elm$core$String$toInt(
			$elm$core$String$trim(saisie.pm));
		if (!_v0.$) {
			var n = _v0.a;
			return (n >= 1) ? $elm$core$Result$Ok(
				$elm$core$Maybe$Just(n)) : $elm$core$Result$Err(0);
		} else {
			return $elm$core$Result$Err(0);
		}
	}
};
var $author$project$Components$Parametrage$PipeEtape1$Model$ouvertureParUnTiersVoulue = function (saisie) {
	return ((saisie.H6 === '') || ((saisie.FY === '') || ((saisie.oU && $elm$core$List$isEmpty(saisie.ib)) || (saisie.oU && _Utils_eq(
		$author$project$Components$Parametrage$PipeEtape1$Model$plafondVoulu(saisie),
		$elm$core$Result$Err(0)))))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		{
			kq: true,
			oU: saisie.oU,
			pm: A2(
				$elm$core$Result$withDefault,
				$elm$core$Maybe$Nothing,
				$author$project$Components$Parametrage$PipeEtape1$Model$plafondVoulu(saisie)),
			FY: saisie.FY,
			H6: saisie.H6,
			ib: saisie.oU ? saisie.ib : _List_Nil
		});
};
var $author$project$Components$Parametrage$PipeEtape1$Model$finDuDossierPrecedent = 'fin-du-dossier-precedent';
var $author$project$Components$Parametrage$PipeEtape1$Model$nonVide = function (texte) {
	return $elm$core$String$isEmpty(texte) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(texte);
};
var $author$project$Components$Parametrage$PipeEtape1$Model$onlyIf = F2(
	function (condition, valeur) {
		return condition ? valeur : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$Parametrage$PipeEtape1$Model$jour = function (texte) {
	return A2(
		$elm$core$Maybe$andThen,
		function (n) {
			return ((n >= 1) && (n <= 31)) ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
		},
		$elm$core$String$toInt(
			$elm$core$String$trim(texte)));
};
var $author$project$Components$Parametrage$PipeEtape1$Model$recurrenceDe = F3(
	function (saisie, ouverture, fermeture) {
		return {A$: ouverture, A0: fermeture, CR: saisie.CR, oh: saisie.oh, Ij: saisie.Ij};
	});
var $author$project$Components$Parametrage$PipeEtape1$Model$recurrente = function (saisie) {
	var _v0 = _Utils_Tuple3(
		$author$project$Components$Parametrage$PipeEtape1$Model$jour(saisie.A$),
		saisie.oh === 'aucune',
		$author$project$Components$Parametrage$PipeEtape1$Model$jour(saisie.A0));
	_v0$2:
	while (true) {
		if (!_v0.a.$) {
			if (_v0.b) {
				var ouverture = _v0.a.a;
				return $elm$core$Maybe$Just(
					$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$Recurrente(
						A3($author$project$Components$Parametrage$PipeEtape1$Model$recurrenceDe, saisie, ouverture, $elm$core$Maybe$Nothing)));
			} else {
				if (!_v0.c.$) {
					var ouverture = _v0.a.a;
					var fermeture = _v0.c.a;
					return $elm$core$Maybe$Just(
						$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$Recurrente(
							A3(
								$author$project$Components$Parametrage$PipeEtape1$Model$recurrenceDe,
								saisie,
								ouverture,
								$elm$core$Maybe$Just(fermeture))));
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Components$Parametrage$PipeEtape1$Model$ouvertureVoulue = function (saisie) {
	var evenements = A2(
		$elm$core$List$map,
		function (type_) {
			return {
				me: A2(
					$author$project$Components$Parametrage$PipeEtape1$Model$onlyIf,
					_Utils_eq(type_, $author$project$Components$Parametrage$PipeEtape1$Model$finDuDossierPrecedent),
					$author$project$Components$Parametrage$PipeEtape1$Model$nonVide(saisie.me)),
				Fu: A2(
					$author$project$Components$Parametrage$PipeEtape1$Model$onlyIf,
					_Utils_eq(type_, $author$project$Components$Parametrage$PipeEtape1$Model$finDuDossierPrecedent),
					$author$project$Components$Parametrage$PipeEtape1$Model$nonVide(saisie.Fu)),
				r0: type_
			};
		},
		saisie.mk);
	var ouverture = function (periode) {
		return $elm$core$Maybe$Just(
			{
				mk: A2($elm$core$List$member, 'evenement', saisie.GK) ? evenements : _List_Nil,
				EU: saisie.EU,
				pi: periode,
				GK: saisie.GK
			});
	};
	if ($elm$core$List$isEmpty(saisie.GK) || (A2($elm$core$List$member, 'evenement', saisie.GK) && $elm$core$List$isEmpty(saisie.mk))) {
		return $elm$core$Maybe$Nothing;
	} else {
		var _v0 = saisie.pi;
		switch (_v0) {
			case 'toujours':
				return ouverture($author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$Toujours);
			case 'entre-deux-dates':
				return ($elm$core$String$isEmpty(
					$elm$core$String$trim(saisie.cE)) || $elm$core$String$isEmpty(
					$elm$core$String$trim(saisie.cm))) ? $elm$core$Maybe$Nothing : ouverture(
					A2(
						$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$EntreDeuxDates,
						$elm$core$String$trim(saisie.cE),
						$elm$core$String$trim(saisie.cm)));
			case 'recurrente':
				return A2(
					$elm$core$Maybe$andThen,
					ouverture,
					$author$project$Components$Parametrage$PipeEtape1$Model$recurrente(saisie));
			default:
				return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$API$NavLinksDictionary$reglerLOuverture = 'regler-l-ouverture';
var $author$project$API$NavLinksDictionary$renommerLePipe = 'renommer-le-pipe';
var $author$project$Components$Parametrage$PipeEtape1$Model$sourceVoulue = function (saisie) {
	var _v0 = _Utils_Tuple2(
		$elm$core$String$toInt(
			$elm$core$String$trim(saisie.CD)),
		$elm$core$String$trim(saisie.Cj));
	if (!_v0.a.$) {
		if (_v0.b === '') {
			var minimum = _v0.a.a;
			return ((minimum >= 0) && (!$elm$core$List$isEmpty(saisie.aV))) ? $elm$core$Maybe$Just(
				{
					lR: A2(
						$elm$core$List$map,
						function ($) {
							return $.r8;
						},
						saisie.aV),
					Cj: $elm$core$Maybe$Nothing,
					CD: minimum,
					g1: saisie.g1
				}) : $elm$core$Maybe$Nothing;
		} else {
			var minimum = _v0.a.a;
			var texte = _v0.b;
			var _v1 = $elm$core$String$toInt(texte);
			if (!_v1.$) {
				var maximum = _v1.a;
				return ((minimum >= 0) && ((_Utils_cmp(maximum, minimum) > -1) && (!$elm$core$List$isEmpty(saisie.aV)))) ? $elm$core$Maybe$Just(
					{
						lR: A2(
							$elm$core$List$map,
							function ($) {
								return $.r8;
							},
							saisie.aV),
						Cj: $elm$core$Maybe$Just(maximum),
						CD: minimum,
						g1: saisie.g1
					}) : $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$PipeEtape1$Update$Envoyer = F4(
	function (a, b, c, d) {
		return {$: 1, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$avecLePipe = F2(
	function (pipeUid, effet) {
		if (effet.$ === 1) {
			var lien = effet.a;
			var processUid = effet.b;
			var commande = effet.d;
			return A4($author$project$Components$Parametrage$PipeEtape1$Update$Envoyer, lien, processUid, pipeUid, commande);
		} else {
			var autre = effet;
			return autre;
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$Reconnecter = {$: 5};
var $author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$ReponseDeCommande = F2(
	function (vuesAJour, pipeCree) {
		return {Ft: pipeCree, sy: vuesAJour};
	});
var $author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$reponseDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$ReponseDeCommande,
	A2($elm$json$Json$Decode$field, 'vuesAJour', $elm$json$Json$Decode$bool),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$filterMap($elm$core$Basics$identity),
					$elm$core$List$head),
				A2(
					$elm$json$Json$Decode$field,
					'evenements',
					$elm$json$Json$Decode$list(
						$elm$json$Json$Decode$maybe(
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['event', 'PipeCree', 'code']),
								$elm$json$Json$Decode$string))))),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			])));
var $author$project$Components$Parametrage$PipeEtape1$Update$reglage = {
	f8: $author$project$Components$Parametrage$PipeEtape1$Update$DemanderProcessUid,
	l4: F3(
		function (lien, processUid, commande) {
			return A4($author$project$Components$Parametrage$PipeEtape1$Update$Envoyer, lien, processUid, '', commande);
		}),
	go: $elm$core$Basics$identity,
	pW: $author$project$Components$Parametrage$PipeEtape1$Update$Reconnecter,
	qu: F2(
		function (_v0, _v1) {
			return true;
		}),
	qv: $author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$reponseDecoder
};
var $author$project$Components$Parametrage$PipeEtape1$Update$envoyer = F3(
	function (lien, commande, model) {
		var _v0 = A4($author$project$API$Envoi$partir, $author$project$Components$Parametrage$PipeEtape1$Update$reglage, lien, commande, model.l2);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var envoi = _v1.a;
			var effets = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi, pZ: $elm$core$Maybe$Nothing, sr: false}),
				A2(
					$elm$core$List$map,
					$author$project$Components$Parametrage$PipeEtape1$Update$avecLePipe(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.r8;
								},
								model.ge))),
					effets));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$versLApi = F3(
	function (lien, model, commande) {
		if (!commande.$) {
			var voulue = commande.a;
			return A3($author$project$Components$Parametrage$PipeEtape1$Update$envoyer, lien, voulue, model);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$API$LienModel$EnchainementVoulu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$API$LienModel$RegroupementVoulu = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$Lien$critereComplet = function (saisie) {
	return (saisie.km === 'champ') ? (saisie.uN !== '') : (saisie.pi !== '');
};
var $author$project$Components$Parametrage$PipeEtape1$Lien$reglePossible = function (saisie) {
	var _v0 = saisie.hH;
	switch (_v0) {
		case 'un-par-mois':
			return A2(
				$elm$core$Maybe$andThen,
				function (jour) {
					return ((jour >= 1) && (jour <= 31)) ? $elm$core$Maybe$Just(
						{
							A_: $elm$core$Maybe$Just(jour),
							n9: 'un-par-mois'
						}) : $elm$core$Maybe$Nothing;
				},
				$elm$core$String$toInt(saisie.A_));
		case 'un-par-semaine':
			return $elm$core$Maybe$Just(
				{A_: $elm$core$Maybe$Nothing, n9: 'un-par-semaine'});
		case 'a-la-main':
			return $elm$core$Maybe$Just(
				{A_: $elm$core$Maybe$Nothing, n9: 'a-la-main'});
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$PipeEtape1$Lien$voulu = function (saisie) {
	var _v0 = saisie.r0;
	switch (_v0) {
		case '':
			return _Utils_eq(saisie.n9, $author$project$Components$Parametrage$PipeEtape1$Lien$Creation) ? $elm$core$Maybe$Just($elm$core$Maybe$Nothing) : $elm$core$Maybe$Nothing;
		case 'regroupement':
			return A2(
				$elm$core$Maybe$map,
				function (regle) {
					return $elm$core$Maybe$Just(
						$author$project$Components$Parametrage$PipeEtape1$API$LienModel$RegroupementVoulu(
							{uN: saisie.uN, km: saisie.km, pi: saisie.pi, FI: saisie.FH, hH: regle}));
				},
				A2(
					$elm$core$Maybe$andThen,
					function (regle) {
						return ((saisie.FH !== '') && $author$project$Components$Parametrage$PipeEtape1$Lien$critereComplet(saisie)) ? $elm$core$Maybe$Just(regle) : $elm$core$Maybe$Nothing;
					},
					$author$project$Components$Parametrage$PipeEtape1$Lien$reglePossible(saisie)));
		case 'enchainement':
			return ((saisie.Fv !== '') && ((saisie.yJ !== '') && (saisie.aH !== ''))) ? $elm$core$Maybe$Just(
				$elm$core$Maybe$Just(
					$author$project$Components$Parametrage$PipeEtape1$API$LienModel$EnchainementVoulu(
						{dw: saisie.K, yK: saisie.yJ, zo: saisie.zo, E4: saisie.aH, Fw: saisie.Fv, eX: saisie.eX}))) : $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$PipeEtape1$Update$enregistrer = function (model) {
	var _v0 = model.mW;
	_v0$7:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a.$) {
				case 0:
					var libelles = _v0.a.a;
					return A3(
						$author$project$Components$Parametrage$PipeEtape1$Update$versLApi,
						A2($author$project$Components$Parametrage$PipeEtape1$Update$lienDe, $author$project$API$NavLinksDictionary$renommerLePipe, model),
						model,
						A2(
							$elm$core$Maybe$map,
							$author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$RenommerLePipe,
							$author$project$Components$Parametrage$PipeEtape1$Model$libellesVoulus(libelles)));
				case 1:
					var saisie = _v0.a.a;
					return A3(
						$author$project$Components$Parametrage$PipeEtape1$Update$versLApi,
						A2($author$project$Components$Parametrage$PipeEtape1$Update$lienDe, $author$project$API$NavLinksDictionary$modifierLeMotEmploye, model),
						model,
						A2(
							$elm$core$Maybe$map,
							function (_v1) {
								var singulier = _v1.a;
								var pluriel = _v1.b;
								return A2($author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$ModifierLeMotEmploye, singulier, pluriel);
							},
							$author$project$Components$Parametrage$PipeEtape1$Model$motVoulu(saisie)));
				case 2:
					if (!_v0.a.a.$) {
						var source = _v0.a.a.a;
						var _v2 = _Utils_Tuple2(
							source.r8,
							$author$project$Components$Parametrage$PipeEtape1$Model$sourceVoulue(source));
						if (_v2.a.$ === 1) {
							var _v3 = _v2.a;
							var voulue = _v2.b;
							return A3(
								$author$project$Components$Parametrage$PipeEtape1$Update$versLApi,
								A2($author$project$Components$Parametrage$PipeEtape1$Update$lienDe, $author$project$API$NavLinksDictionary$ajouterUneSourceDOffre, model),
								model,
								A2($elm$core$Maybe$map, $author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$AjouterUneSource, voulue));
						} else {
							var uid = _v2.a.a;
							var voulue = _v2.b;
							return A3(
								$author$project$Components$Parametrage$PipeEtape1$Update$versLApi,
								A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.CM;
									},
									model.IR),
								model,
								A2(
									$elm$core$Maybe$map,
									$author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$ModifierUneSource(uid),
									voulue));
						}
					} else {
						break _v0$7;
					}
				case 4:
					var saisie = _v0.a.a;
					return A3(
						$author$project$Components$Parametrage$PipeEtape1$Update$versLApi,
						A2($author$project$Components$Parametrage$PipeEtape1$Update$lienDe, $author$project$API$NavLinksDictionary$definirLObjetVise, model),
						model,
						$elm$core$Maybe$Just(
							$author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$DefinirLObjetVise(
								{gR: saisie.hL, g1: saisie.g1, rL: saisie.rL, ib: saisie.ib})));
				case 5:
					var saisie = _v0.a.a;
					return A3(
						$author$project$Components$Parametrage$PipeEtape1$Update$versLApi,
						A2(
							$author$project$Components$Parametrage$PipeEtape1$Update$lienDe,
							_Utils_eq(saisie.iN, $elm$core$Maybe$Nothing) ? $author$project$API$NavLinksDictionary$ajouterUneOuvertureParUnTiers : $author$project$API$NavLinksDictionary$modifierUneOuvertureParUnTiers,
							model),
						model,
						A2(
							$elm$core$Maybe$map,
							_Utils_eq(saisie.iN, $elm$core$Maybe$Nothing) ? $author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$AjouterUneOuvertureParUnTiers : $author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$ModifierUneOuvertureParUnTiers,
							$author$project$Components$Parametrage$PipeEtape1$Model$ouvertureParUnTiersVoulue(saisie)));
				case 3:
					var saisie = _v0.a.a;
					return A3(
						$author$project$Components$Parametrage$PipeEtape1$Update$versLApi,
						A2($author$project$Components$Parametrage$PipeEtape1$Update$lienDe, $author$project$API$NavLinksDictionary$reglerLOuverture, model),
						model,
						A2(
							$elm$core$Maybe$map,
							$author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$ReglerLOuverture,
							$author$project$Components$Parametrage$PipeEtape1$Model$ouvertureVoulue(saisie)));
				default:
					var saisie = _v0.a.a;
					var _v4 = _Utils_Tuple2(
						saisie.n9,
						$author$project$Components$Parametrage$PipeEtape1$Lien$voulu(saisie));
					_v4$3:
					while (true) {
						if (!_v4.b.$) {
							switch (_v4.a.$) {
								case 0:
									var _v5 = _v4.a;
									var lien = _v4.b.a;
									return A3(
										$author$project$Components$Parametrage$PipeEtape1$Update$versLApi,
										A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ajouterUnTypeDeDossier, model.nR),
										model,
										A3(
											$elm$core$Maybe$map2,
											F2(
												function (nom, mot) {
													return A3($author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$AjouterUnTypeDeDossier, nom, mot, lien);
												}),
											$author$project$Components$Parametrage$PipeEtape1$Model$libellesVoulus(saisie.Dj),
											$author$project$Components$Parametrage$PipeEtape1$Model$libellesVoulus(saisie.ej)));
								case 2:
									if (!_v4.b.a.$) {
										var uid = _v4.a.a;
										var lien = _v4.b.a.a;
										return A3(
											$author$project$Components$Parametrage$PipeEtape1$Update$versLApi,
											A2(
												$elm$core$Maybe$andThen,
												function ($) {
													return $.CM;
												},
												model.nP),
											model,
											$elm$core$Maybe$Just(
												A2(
													$author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$ModifierLeLien,
													$elm$core$Maybe$Just(uid),
													lien)));
									} else {
										break _v4$3;
									}
								default:
									if (!_v4.b.a.$) {
										var _v6 = _v4.a;
										var lien = _v4.b.a.a;
										return A3(
											$author$project$Components$Parametrage$PipeEtape1$Update$versLApi,
											A2($author$project$Components$Parametrage$PipeEtape1$Update$lienDe, $author$project$API$NavLinksDictionary$modifierLeLien, model),
											model,
											$elm$core$Maybe$Just(
												A2($author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$ModifierLeLien, $elm$core$Maybe$Nothing, lien)));
									} else {
										break _v4$3;
									}
							}
						} else {
							break _v4$3;
						}
					}
					return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			break _v0$7;
		}
	}
	return _Utils_Tuple2(model, _List_Nil);
};
var $author$project$Components$Parametrage$PipeEtape1$Model$saisieDeLObjetVise = function (edition) {
	return {
		g1: function (n) {
			return (n === '') ? 'aucun' : n;
		}(edition.D_.g1),
		hL: $elm$core$Maybe$Nothing,
		rL: edition.D_.rL,
		ib: A2(
			$elm$core$List$map,
			function ($) {
				return $.vx;
			},
			_Utils_eq(edition.D_.g1, $author$project$Components$Parametrage$Vocabulaire$natureProduit) ? edition.D_.id : edition.D_.ib)
	};
};
var $elm$core$Dict$singleton = F2(
	function (key, value) {
		return A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
	});
var $author$project$Components$Parametrage$PipeEtape1$Model$libelleDuRole = F2(
	function (model, saisie) {
		var nomme = F2(
			function (options, generique) {
				var _v2 = _Utils_Tuple2(saisie.rL, saisie.ib);
				if (((!_v2.a) && _v2.b.b) && (!_v2.b.b.b)) {
					var _v3 = _v2.b;
					var seul = _v3.a;
					return A2(
						$elm$core$Maybe$withDefault,
						generique,
						A2(
							$elm$core$Maybe$map,
							function (o) {
								return A2($elm$core$Dict$singleton, 'fr', o.Bl);
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (o) {
										return _Utils_eq(o.vx, seul);
									},
									options))));
				} else {
					return generique;
				}
			});
		var memeObjet = function (autre) {
			return _Utils_eq(autre.g1, saisie.g1) && (_Utils_eq(autre.rL, saisie.rL) && _Utils_eq(
				$elm$core$List$sort(autre.ib),
				$elm$core$List$sort(saisie.ib)));
		};
		var generiques = A2(
			$elm$core$Maybe$withDefault,
			{gX: $elm$core$Dict$empty, E$: $elm$core$Dict$empty, Gp: $elm$core$Dict$empty},
			model.Bs);
		var duBrouillon = A2(
			$elm$core$Maybe$andThen,
			function (edition) {
				return memeObjet(
					$author$project$Components$Parametrage$PipeEtape1$Model$saisieDeLObjetVise(edition)) ? edition.D_.qQ : $elm$core$Maybe$Nothing;
			},
			model.ge);
		var _v0 = saisie.hL;
		if (!_v0.$) {
			var saisi = _v0.a;
			return saisi;
		} else {
			if (!duBrouillon.$) {
				var libelles = duBrouillon.a;
				return libelles;
			} else {
				return (saisie.g1 === 'partie-prenante') ? A2(nomme, model.ic, generiques.E$) : (_Utils_eq(saisie.g1, $author$project$Components$Parametrage$Vocabulaire$natureProduit) ? A2(
					nomme,
					A2($elm$core$Maybe$withDefault, _List_Nil, model.id),
					generiques.Gp) : (_Utils_eq(saisie.g1, $author$project$Components$Parametrage$Vocabulaire$natureMarque) ? generiques.gX : $elm$core$Dict$empty));
			}
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$Source = 3;
var $author$project$Components$Parametrage$PipeEtape1$Update$lireLaSource = F2(
	function (uid, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$Parametrage$PipeEtape1$Update$Lire(3),
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.np;
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (source) {
									return _Utils_eq(source.r8, uid);
								},
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.IT;
										},
										model.ge))))))));
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$lireLesChampsCommuns = function (model) {
	var _v0 = model.mW;
	if ((!_v0.$) && (_v0.a.$ === 4)) {
		var saisie = _v0.a.a;
		if ($elm$core$List$length(saisie.ib) > 1) {
			var _v1 = A2(
				$elm$core$Maybe$andThen,
				$author$project$API$Liens$resoudre(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'choisis',
							A2($elm$core$String$join, ',', saisie.ib))
						])),
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.BH;
					},
					model.ge));
			if (!_v1.$) {
				var lien = _v1.a;
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[
							A2($author$project$Components$Parametrage$PipeEtape1$Update$Lire, 6, lien)
						]));
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{uT: $elm$core$Maybe$Nothing}),
				_List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$PipeEtape1$Update$lireSi = F2(
	function (lecture, lien) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$Parametrage$PipeEtape1$Update$Lire(lecture),
					lien)));
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$Edition = 2;
var $author$project$Components$Parametrage$PipeEtape1$Update$Racine = 1;
var $author$project$Components$Parametrage$PipeEtape1$API$LienModel$ajouterLaPageDesPipesLiables = F2(
	function (page, actuelles) {
		return _Utils_update(
			actuelles,
			{
				yL: _Utils_ap(actuelles.yL, page.yL),
				E5: _Utils_ap(actuelles.E5, page.E5),
				eE: _Utils_ap(actuelles.eE, page.eE),
				I7: page.I7
			});
	});
var $author$project$Components$Parametrage$PipeEtape1$Lien$Modification = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$Lien$depuis = function (lu) {
	var base = _Utils_update(
		$author$project$Components$Parametrage$PipeEtape1$Lien$creation,
		{
			n9: $author$project$Components$Parametrage$PipeEtape1$Lien$Modification(lu.r8),
			r0: lu.r0
		});
	var _v0 = _Utils_Tuple2(lu.Ho, lu.yn);
	if (!_v0.a.$) {
		var r = _v0.a.a;
		return _Utils_update(
			base,
			{
				s4: r.s4,
				uN: r.uN,
				km: r.km,
				A_: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Maybe$map, $elm$core$String$fromInt, r.A_)),
				pi: r.pi,
				FH: r.FH,
				hH: r.hH
			});
	} else {
		if (!_v0.b.$) {
			var _v1 = _v0.a;
			var e = _v0.b.a;
			return _Utils_update(
				base,
				{
					jD: !$elm$core$List$isEmpty(e.dw),
					K: e.dw,
					yJ: e.yJ,
					zo: e.zo,
					aH: e.E3,
					Fv: e.Fv,
					eX: e.eX
				});
		} else {
			var _v2 = _v0.a;
			var _v3 = _v0.b;
			return base;
		}
	}
};
var $author$project$API$NavLinksDictionary$pipeParCode = 'pipe-par-code';
var $author$project$Components$Parametrage$Common$API$QueryAPIModel$lienDuPipeDecoder = function (code) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.gF;
					},
					A2(
						$elm$core$Basics$composeR,
						$author$project$API$Liens$trouverGabarit($author$project$API$NavLinksDictionary$pipeParCode),
						$elm$core$Maybe$andThen(
							$author$project$API$Liens$resoudre(
								_List_fromArray(
									[
										_Utils_Tuple2('code', code)
									]))))),
				A2($elm$json$Json$Decode$field, '_links', $author$project$API$Liens$decoder)),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$Components$Parametrage$PipeEtape1$Model$LienEnSaisie = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$Update$PlacerFocus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$Model$idDuDeclencheur = function (nom) {
	return 'pipe-etape-1-ligne-' + nom;
};
var $author$project$Components$Parametrage$PipeEtape1$Model$idDuDrawer = function (nom) {
	return 'pipe-etape-1-' + nom;
};
var $author$project$Components$Parametrage$PipeEtape1$Update$ouvrirLeLien = F4(
	function (declencheur, saisie, lectures, model) {
		if ($author$project$API$Envoi$enCours(model.l2)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v0 = A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				$author$project$Components$Shared$Drawer$Update$Ouvrir(
					$author$project$Components$Parametrage$PipeEtape1$Model$idDuDeclencheur(declencheur)),
				$author$project$Components$Shared$Drawer$Model$init(
					$author$project$Components$Parametrage$PipeEtape1$Model$idDuDrawer('lien')));
			var drawer = _v0.a;
			var effets = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						kX: drawer,
						mW: $elm$core$Maybe$Just(
							$author$project$Components$Parametrage$PipeEtape1$Model$LienEnSaisie(saisie)),
						o$: $elm$core$Maybe$Nothing,
						pZ: $elm$core$Maybe$Nothing,
						IR: $elm$core$Maybe$Nothing,
						rV: $elm$core$Maybe$Nothing,
						sr: false
					}),
				_Utils_ap(
					lectures,
					A2(
						$elm$core$List$map,
						function (_v1) {
							var cible = _v1;
							return $author$project$Components$Parametrage$PipeEtape1$Update$PlacerFocus(cible);
						},
						effets)));
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$Model$saisieDeLaSource = function (source) {
	return {
		aV: source.aV,
		Cj: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Maybe$map, $elm$core$String$fromInt, source.Cj)),
		CD: $elm$core$String$fromInt(source.CD),
		g1: source.g1,
		r8: $elm$core$Maybe$Just(source.r8)
	};
};
var $author$project$Components$Parametrage$PipeEtape1$Update$sansPipeChoisi = F2(
	function (model, lectures) {
		var _v0 = _Utils_Tuple2(
			model.vx,
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ajouterUnTypeDeDossier, model.nR));
		if ((_v0.a === '') && (!_v0.b.$)) {
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Basics$append(lectures),
				A4(
					$author$project$Components$Parametrage$PipeEtape1$Update$ouvrirLeLien,
					'type-de-dossier',
					$author$project$Components$Parametrage$PipeEtape1$Lien$creation,
					A2(
						$author$project$Components$Parametrage$PipeEtape1$Update$lireSi,
						8,
						A2($author$project$Components$Parametrage$PipeEtape1$Update$lienDe, $author$project$API$NavLinksDictionary$optionsDeLien, model)),
					model));
		} else {
			return _Utils_Tuple2(model, lectures);
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$sous = F4(
	function (decodeur, reponse, model, suite) {
		var _v0 = A2($author$project$API$Reponse$lire, decodeur, reponse);
		if (!_v0.$) {
			var lue = _v0.a;
			return suite(lue);
		} else {
			var refus = _v0.a;
			return (refus.ri === 401) ? _Utils_Tuple2(
				model,
				_List_fromArray(
					[$author$project$Components$Parametrage$PipeEtape1$Update$Reconnecter])) : _Utils_Tuple2(
				_Utils_update(
					model,
					{nf: model.nf || (refus.ri === 404)}),
				_List_Nil);
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$lu = F3(
	function (lecture, reponse, model) {
		switch (lecture) {
			case 0:
				return A4(
					$author$project$Components$Parametrage$PipeEtape1$Update$sous,
					A4(
						$elm$json$Json$Decode$map3,
						F3(
							function (a, b, c) {
								return _Utils_Tuple3(a, b, c);
							}),
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$annuaireDecoder,
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$lienDuPipeDecoder(model.vx)),
					reponse,
					model,
					function (_v1) {
						var pipes = _v1.a;
						var liensDeLAnnuaire = _v1.b;
						var visee = _v1.c;
						var lu_ = _Utils_update(
							model,
							{
								aS: $elm$core$Maybe$Just(pipes),
								nf: _Utils_eq(visee, $elm$core$Maybe$Nothing) && (model.vx !== ''),
								nR: liensDeLAnnuaire
							});
						return A2(
							$author$project$Components$Parametrage$PipeEtape1$Update$sansPipeChoisi,
							lu_,
							A2($author$project$Components$Parametrage$PipeEtape1$Update$lireSi, 1, visee));
					});
			case 1:
				return A4(
					$author$project$Components$Parametrage$PipeEtape1$Update$sous,
					$author$project$Components$Parametrage$Common$API$QueryAPIModel$racineDuPipeDecoder,
					reponse,
					model,
					function (edition) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									nf: _Utils_eq(edition, $elm$core$Maybe$Nothing)
								}),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									$elm$core$List$singleton,
									A2(
										$elm$core$Maybe$map,
										$author$project$Components$Parametrage$PipeEtape1$Update$Lire(2),
										edition))));
					});
			case 2:
				return A4(
					$author$project$Components$Parametrage$PipeEtape1$Update$sous,
					$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$editionDecoder,
					reponse,
					model,
					function (edition) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									ge: $elm$core$Maybe$Just(edition)
								}),
							_List_Nil);
					});
			case 6:
				return A4(
					$author$project$Components$Parametrage$PipeEtape1$Update$sous,
					$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$typesDeFicheDecoder,
					reponse,
					model,
					function (options) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{uT: options.uT, Bs: options.Bs, ic: options.ib, id: options.id}),
							_List_Nil);
					});
			case 3:
				return A4(
					$author$project$Components$Parametrage$PipeEtape1$Update$sous,
					$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$sourceDecoder,
					reponse,
					model,
					function (source) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									mW: A2(
										$author$project$Components$Parametrage$PipeEtape1$Update$enOffre,
										$elm$core$Maybe$Just(
											$author$project$Components$Parametrage$PipeEtape1$Model$saisieDeLaSource(source)),
										model),
									IR: $elm$core$Maybe$Just(source)
								}),
							_List_Nil);
					});
			case 7:
				return A4(
					$author$project$Components$Parametrage$PipeEtape1$Update$sous,
					$author$project$Components$Parametrage$PipeEtape1$API$LienModel$lienLuDecoder,
					reponse,
					model,
					function (lien) {
						return A4(
							$author$project$Components$Parametrage$PipeEtape1$Update$ouvrirLeLien,
							'lien',
							$author$project$Components$Parametrage$PipeEtape1$Lien$depuis(lien),
							A2(
								$author$project$Components$Parametrage$PipeEtape1$Update$lireSi,
								8,
								A2($author$project$Components$Parametrage$PipeEtape1$Update$lienDe, $author$project$API$NavLinksDictionary$optionsDeLien, model)),
							_Utils_update(
								model,
								{
									nP: $elm$core$Maybe$Just(lien)
								}));
					});
			case 8:
				return A4(
					$author$project$Components$Parametrage$PipeEtape1$Update$sous,
					$author$project$Components$Parametrage$PipeEtape1$API$LienModel$optionsDeLienDecoder,
					reponse,
					model,
					function (options) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									o$: $elm$core$Maybe$Just(options)
								}),
							_List_Nil);
					});
			case 9:
				return A4(
					$author$project$Components$Parametrage$PipeEtape1$Update$sous,
					$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$ouvertureLueDecoder,
					reponse,
					model,
					function (page) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									o_: A2(
										$elm$core$Maybe$map,
										function (actuelles) {
											return _Utils_update(
												actuelles,
												{
													FN: _Utils_ap(actuelles.FN, page.FN),
													I7: page.I7
												});
										},
										model.o_)
								}),
							_List_Nil);
					});
			case 10:
				return A4(
					$author$project$Components$Parametrage$PipeEtape1$Update$sous,
					$author$project$Components$Parametrage$PipeEtape1$API$LienModel$optionsDeLienDecoder,
					reponse,
					model,
					function (page) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									o$: A2(
										$elm$core$Maybe$map,
										$author$project$Components$Parametrage$PipeEtape1$API$LienModel$ajouterLaPageDesPipesLiables(page),
										model.o$)
								}),
							_List_Nil);
					});
			case 4:
				return A4(
					$author$project$Components$Parametrage$PipeEtape1$Update$sous,
					$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$candidatsDecoder,
					reponse,
					model,
					function (candidats) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{jy: candidats}),
							_List_Nil);
					});
			default:
				return A4(
					$author$project$Components$Parametrage$PipeEtape1$Update$sous,
					$author$project$Components$Parametrage$PipeEtape1$API$QueryAPIModel$ouvertureLueDecoder,
					reponse,
					model,
					function (options) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									o_: $elm$core$Maybe$Just(options)
								}),
							_List_Nil);
					});
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$Model$nouvelleSource = {aV: _List_Nil, Cj: '', CD: '1', g1: 'liste-d-offres', r8: $elm$core$Maybe$Nothing};
var $author$project$Components$Parametrage$PipeEtape1$Update$declencheurDe = function (nom) {
	return (nom === 'offre') ? 'offre-ajout' : nom;
};
var $author$project$Components$Parametrage$PipeEtape1$Update$ouvrirSi = F5(
	function (rel, model, nom, geste, lectures) {
		var _v0 = _Utils_Tuple3(
			model.ge,
			A2($author$project$Components$Parametrage$PipeEtape1$Update$lienDe, rel, model),
			$author$project$API$Envoi$enCours(model.l2));
		if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c)) {
			var edition = _v0.a.a;
			var _v1 = A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				$author$project$Components$Shared$Drawer$Update$Ouvrir(
					$author$project$Components$Parametrage$PipeEtape1$Model$idDuDeclencheur(
						$author$project$Components$Parametrage$PipeEtape1$Update$declencheurDe(nom))),
				$author$project$Components$Shared$Drawer$Model$init(
					$author$project$Components$Parametrage$PipeEtape1$Model$idDuDrawer(nom)));
			var drawer = _v1.a;
			var effets = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						kX: drawer,
						mW: $elm$core$Maybe$Just(
							geste(edition)),
						o_: $elm$core$Maybe$Nothing,
						pZ: $elm$core$Maybe$Nothing,
						IR: $elm$core$Maybe$Nothing,
						rV: $elm$core$Maybe$Nothing,
						sr: false
					}),
				_Utils_ap(
					lectures,
					A2(
						$elm$core$List$map,
						function (_v2) {
							var cible = _v2;
							return $author$project$Components$Parametrage$PipeEtape1$Update$PlacerFocus(cible);
						},
						effets)));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$pipes = 'pipes';
var $author$project$Components$Parametrage$PipeEtape1$Update$recharger = function (model) {
	var _v0 = A3(
		$author$project$Components$Shared$Drawer$Update$update,
		{Il: false},
		$author$project$Components$Shared$Drawer$Update$Fermer,
		model.kX);
	var drawer = _v0.a;
	var deDrawer = _v0.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{kX: drawer, mW: $elm$core$Maybe$Nothing, pZ: $elm$core$Maybe$Nothing, rV: $elm$core$Maybe$Nothing, sr: false}),
		_Utils_ap(
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Parametrage$PipeEtape1$Update$PlacerFocus(cible);
				},
				deDrawer),
			A2(
				$author$project$Components$Parametrage$PipeEtape1$Update$lireSi,
				2,
				A2($author$project$Components$Parametrage$PipeEtape1$Update$lienDe, $author$project$API$NavLinksDictionary$self, model))));
};
var $author$project$Components$Parametrage$PipeEtape1$Update$AllerAuPipe = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$Update$archivesDuRefus = function (detail) {
	if ((detail.$ === 4) && (detail.a === 'TypeDeFicheInconnu')) {
		var archives = detail.b;
		return archives;
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Parametrage$PipeEtape1$Update$creeUnPipe = function (geste) {
	if ((!geste.$) && (geste.a.$ === 6)) {
		var saisie = geste.a.a;
		return _Utils_eq(saisie.n9, $author$project$Components$Parametrage$PipeEtape1$Lien$Creation);
	} else {
		return false;
	}
};
var $author$project$Components$Parametrage$PipeEtape1$Update$estTypeInconnu = function (detail) {
	_v0$3:
	while (true) {
		switch (detail.$) {
			case 3:
				if (detail.a === 'TypeDeFicheInconnu') {
					return true;
				} else {
					break _v0$3;
				}
			case 4:
				if (detail.a === 'TypeDeFicheInconnu') {
					return true;
				} else {
					break _v0$3;
				}
			case 1:
				if (detail.a === 'TypeDeFicheInconnu') {
					return true;
				} else {
					break _v0$3;
				}
			default:
				break _v0$3;
		}
	}
	return false;
};
var $author$project$Texte$Jour$joursDepuis1970 = F3(
	function (annee, rang, numero) {
		var jourDeLAnnee = (((((153 * ((rang > 2) ? (rang - 3) : (rang + 9))) + 2) / 5) | 0) + numero) - 1;
		var a = (rang <= 2) ? (annee - 1) : annee;
		var ere = (a / 400) | 0;
		var anneeDeLEre = a - (ere * 400);
		var jourDeLEre = (((anneeDeLEre * 365) + ((anneeDeLEre / 4) | 0)) - ((anneeDeLEre / 100) | 0)) + jourDeLAnnee;
		return ((ere * 146097) + jourDeLEre) - 719468;
	});
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.hZ, posixMinutes) < 0) {
					return posixMinutes + era.oY;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return 3;
			case 1:
				return 4;
			case 2:
				return 5;
			case 3:
				return 6;
			case 4:
				return 0;
			case 5:
				return 1;
			default:
				return 2;
		}
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Texte$Jour$dernierDimancheA1hUtc = F2(
	function (annee, rang) {
		var dernierJour = A3($author$project$Texte$Jour$joursDepuis1970, annee, rang, 31);
		var recul = function () {
			var _v0 = A2(
				$elm$time$Time$toWeekday,
				$elm$time$Time$utc,
				$elm$time$Time$millisToPosix(dernierJour * 86400000));
			switch (_v0) {
				case 6:
					return 0;
				case 0:
					return 1;
				case 1:
					return 2;
				case 2:
					return 3;
				case 3:
					return 4;
				case 4:
					return 5;
				default:
					return 6;
			}
		}();
		return ((dernierJour - recul) * 86400000) + 3600000;
	});
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		ks: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		oj: month,
		sC: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).sC;
	});
var $author$project$Texte$Jour$decalageDeParis = function (instant) {
	var millis = $elm$time$Time$posixToMillis(instant);
	var annee = A2($elm$time$Time$toYear, $elm$time$Time$utc, instant);
	return ((_Utils_cmp(
		millis,
		A2($author$project$Texte$Jour$dernierDimancheA1hUtc, annee, 3)) > -1) && (_Utils_cmp(
		millis,
		A2($author$project$Texte$Jour$dernierDimancheA1hUtc, annee, 10)) < 0)) ? 120 : 60;
};
var $author$project$Texte$Jour$numeroDuMois = function (mois_) {
	switch (mois_) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $author$project$Texte$Jour$posixDe = function (instant) {
	var _v0 = A2(
		$elm$core$String$split,
		'T',
		A3($elm$core$String$replace, 'Z', '', instant));
	if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
		var jour = _v0.a;
		var _v1 = _v0.b;
		var heure = _v1.a;
		var _v2 = _Utils_Tuple2(
			A2(
				$elm$core$List$map,
				$elm$core$String$toInt,
				A2($elm$core$String$split, '-', jour)),
			A2($elm$core$String$split, ':', heure));
		if ((((((((_v2.a.b && (!_v2.a.a.$)) && _v2.a.b.b) && (!_v2.a.b.a.$)) && _v2.a.b.b.b) && (!_v2.a.b.b.a.$)) && (!_v2.a.b.b.b.b)) && _v2.b.b) && _v2.b.b.b) {
			var _v3 = _v2.a;
			var annee = _v3.a.a;
			var _v4 = _v3.b;
			var rang = _v4.a.a;
			var _v5 = _v4.b;
			var numero = _v5.a.a;
			var _v6 = _v2.b;
			var h = _v6.a;
			var _v7 = _v6.b;
			var m = _v7.a;
			var reste = _v7.b;
			var _v8 = _Utils_Tuple3(
				$elm$core$String$toInt(h),
				$elm$core$String$toInt(m),
				A2($elm$core$String$endsWith, 'Z', instant));
			if (((!_v8.a.$) && (!_v8.b.$)) && _v8.c) {
				var heures = _v8.a.a;
				var minutes = _v8.b.a;
				var secondes = A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$floor,
						A2(
							$elm$core$Maybe$andThen,
							$elm$core$String$toFloat,
							$elm$core$List$head(reste))));
				var minutesDepuis1970 = (((A3($author$project$Texte$Jour$joursDepuis1970, annee, rang, numero) * 24) + heures) * 60) + minutes;
				return $elm$core$Maybe$Just(
					$elm$time$Time$millisToPosix((minutesDepuis1970 * 60000) + (secondes * 1000)));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).ks;
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).oj;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $author$project$Texte$Jour$instantDeParis = function (instant) {
	var _v0 = $author$project$Texte$Jour$posixDe(instant);
	if (_v0.$ === 1) {
		return instant;
	} else {
		var lu = _v0.a;
		var zone = A2(
			$elm$time$Time$customZone,
			$author$project$Texte$Jour$decalageDeParis(lu),
			_List_Nil);
		var deux = function (nombre) {
			return A3(
				$elm$core$String$padLeft,
				2,
				'0',
				$elm$core$String$fromInt(nombre));
		};
		return $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, zone, lu)) + ('-' + (deux(
			$author$project$Texte$Jour$numeroDuMois(
				A2($elm$time$Time$toMonth, zone, lu))) + ('-' + (deux(
			A2($elm$time$Time$toDay, zone, lu)) + ('T' + (deux(
			A2($elm$time$Time$toHour, zone, lu)) + (':' + deux(
			A2($elm$time$Time$toMinute, zone, lu)))))))));
	}
};
var $author$project$Texte$Jour$jourDeParis = function (instant) {
	return A2(
		$elm$core$String$left,
		10,
		$author$project$Texte$Jour$instantDeParis(instant));
};
var $author$project$Components$Parametrage$PipeEtape1$Model$dateDArchivage = F2(
	function (archives, code) {
		return A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$Texte$Jour$jourDeParis),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var uid = _v0.a;
						return _Utils_eq(uid, code);
					},
					archives)));
	});
var $author$project$I18n$Textes$pipeEtape1RefusBornes = A3($author$project$I18n$Traductions$texte, 'pipe-etape-1.refus.bornes', _List_Nil, 'Le maximum doit être supérieur ou égal au minimum.');
var $author$project$I18n$Textes$pipeEtape1RefusNomDejaPris = A3($author$project$I18n$Traductions$texte, 'pipe-etape-1.refus.nom-deja-pris', _List_Nil, 'Ce nom est déjà pris par un autre pipe de l\'espace. Choisissez un autre nom.');
var $author$project$I18n$Textes$pipeEtape1RefusPipeLieInconnu = A3($author$project$I18n$Traductions$texte, 'pipe-etape-1.refus.pipe-lie-inconnu', _List_Nil, 'Le pipe lié n\'existe plus. Choisissez-en un autre.');
var $author$project$I18n$Textes$pipeEtape1RefusSansLibelleFrancais = A3($author$project$I18n$Traductions$texte, 'pipe-etape-1.refus.sans-libelle-francais', _List_Nil, 'Le nom et le mot employé doivent être donnés en français.');
var $author$project$I18n$Textes$pipeEtape1RefusTypeArchive = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'pipe-etape-1.refus.type-archive',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'typeDeFiche',
				$author$project$I18n$Traductions$Sous(p.ca))
			]),
		'Ce type de fiche n\'est plus proposé. « {typeDeFiche} » a été archivé. Rien n\'est enregistré : choisissez un autre type de fiche.');
};
var $author$project$I18n$Textes$pipeEtape1RefusTypeArchiveLe = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'pipe-etape-1.refus.type-archive-le',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'typeDeFiche',
				$author$project$I18n$Traductions$Sous(p.ca)),
				_Utils_Tuple2(
				'date',
				$author$project$I18n$Traductions$Sous(p.wv))
			]),
		'Ce type de fiche n\'est plus proposé. « {typeDeFiche} » a été archivé le {date}. Rien n\'est enregistré : choisissez un autre type de fiche.');
};
var $author$project$I18n$Textes$pipeEtape1RefusTypeInconnu = A3($author$project$I18n$Traductions$texte, 'pipe-etape-1.refus.type-inconnu', _List_Nil, 'Ce type de fiche n\'existe plus ou est archivé. Choisissez-en un autre.');
var $author$project$I18n$Textes$pipeEtape1RefusUnSeulType = A3($author$project$I18n$Traductions$texte, 'pipe-etape-1.refus.un-seul-type', _List_Nil, 'Un pipe ne vise qu\'un seul type de fiche pour l\'instant.');
var $author$project$I18n$Textes$pipeEtape1RefusVersionNonModifiable = A3($author$project$I18n$Traductions$texte, 'pipe-etape-1.refus.version-non-modifiable', _List_Nil, 'Ce pipe n\'a plus de brouillon modifiable : rechargez pour voir son état.');
var $author$project$Components$Parametrage$PipeEtape1$Update$refusDuPipe = F3(
	function (model, refus, typeRefuse) {
		var dit = function (texte) {
			return {Jx: texte, b9: refus.b9};
		};
		var typeInconnu = function () {
			var _v1 = A2(
				$elm$core$Maybe$andThen,
				function (code) {
					return $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (o) {
								return _Utils_eq(o.vx, code);
							},
							model.ic));
				},
				typeRefuse);
			if (!_v1.$) {
				var option = _v1.a;
				var _v2 = A2(
					$author$project$Components$Parametrage$PipeEtape1$Model$dateDArchivage,
					$author$project$Components$Parametrage$PipeEtape1$Update$archivesDuRefus(refus.bB),
					option.vx);
				if (!_v2.$) {
					var jour = _v2.a;
					return dit(
						$author$project$I18n$Textes$pipeEtape1RefusTypeArchiveLe(
							{
								wv: $author$project$Texte$Jour$enClair(jour),
								ca: $author$project$I18n$Traductions$tel(option.Bl)
							}));
				} else {
					return dit(
						$author$project$I18n$Textes$pipeEtape1RefusTypeArchive(
							{
								ca: $author$project$I18n$Traductions$tel(option.Bl)
							}));
				}
			} else {
				return dit($author$project$I18n$Textes$pipeEtape1RefusTypeInconnu);
			}
		}();
		var _v0 = refus.bB;
		_v0$9:
		while (true) {
			switch (_v0.$) {
				case 3:
					if (_v0.a === 'TypeDeFicheInconnu') {
						return typeInconnu;
					} else {
						break _v0$9;
					}
				case 4:
					if (_v0.a === 'TypeDeFicheInconnu') {
						return typeInconnu;
					} else {
						break _v0$9;
					}
				case 1:
					switch (_v0.a) {
						case 'NomDePipeDejaPris':
							return dit($author$project$I18n$Textes$pipeEtape1RefusNomDejaPris);
						case 'LibelleParDefautRequis':
							return dit($author$project$I18n$Textes$pipeEtape1RefusSansLibelleFrancais);
						case 'PipeLieInconnu':
							return dit($author$project$I18n$Textes$pipeEtape1RefusPipeLieInconnu);
						case 'VersionNonModifiable':
							return dit($author$project$I18n$Textes$pipeEtape1RefusVersionNonModifiable);
						case 'UnSeulTypeDeFiche':
							return dit($author$project$I18n$Textes$pipeEtape1RefusUnSeulType);
						case 'BornesDeSourceIncoherentes':
							return dit($author$project$I18n$Textes$pipeEtape1RefusBornes);
						case 'TypeDeFicheInconnu':
							return typeInconnu;
						default:
							break _v0$9;
					}
				default:
					break _v0$9;
			}
		}
		return $author$project$Components$Shared$Messages$Model$duRefus(refus);
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$repondue = F2(
	function (reponse, model) {
		var _v0 = A3($author$project$API$Envoi$conclure, $author$project$Components$Parametrage$PipeEtape1$Update$reglage, reponse, model.l2);
		if (!_v0.$) {
			switch (_v0.a.b.$) {
				case 0:
					var _v1 = _v0.a;
					var envoi = _v1.a;
					var _v2 = _v1.b;
					var rendue = _v2.b;
					var effets = _v1.c;
					var _v3 = A3(
						$author$project$Components$Shared$Drawer$Update$update,
						{Il: false},
						$author$project$Components$Shared$Drawer$Update$Fermer,
						model.kX);
					var drawer = _v3.a;
					var deDrawer = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{kX: drawer, l2: envoi, mW: $elm$core$Maybe$Nothing, pZ: $elm$core$Maybe$Nothing, rV: $elm$core$Maybe$Nothing, sr: false}),
						_Utils_ap(
							effets,
							_Utils_ap(
								A2(
									$elm$core$List$map,
									function (_v4) {
										var cible = _v4;
										return $author$project$Components$Parametrage$PipeEtape1$Update$PlacerFocus(cible);
									},
									deDrawer),
								_Utils_ap(
									A2(
										$author$project$Components$Parametrage$PipeEtape1$Update$lireSi,
										2,
										A2($author$project$Components$Parametrage$PipeEtape1$Update$lienDe, $author$project$API$NavLinksDictionary$self, model)),
									_Utils_ap(
										$author$project$Components$Parametrage$PipeEtape1$Update$creeUnPipe(model.mW) ? A2(
											$author$project$Components$Parametrage$PipeEtape1$Update$lireSi,
											0,
											A2($author$project$Components$Parametrage$PipeEtape1$Update$lienDe, $author$project$API$NavLinksDictionary$pipes, model)) : _List_Nil,
										function () {
											var _v5 = _Utils_Tuple2(
												$author$project$Components$Parametrage$PipeEtape1$Update$creeUnPipe(model.mW),
												rendue.Ft);
											if (_v5.a && (!_v5.b.$)) {
												var code = _v5.b.a;
												return _List_fromArray(
													[
														$author$project$Components$Parametrage$PipeEtape1$Update$AllerAuPipe(code)
													]);
											} else {
												return _List_Nil;
											}
										}())))));
				case 1:
					var _v6 = _v0.a;
					var envoi = _v6.a;
					var _v7 = _v6.b;
					var refus = _v7.b;
					var effets = _v6.c;
					var typeRefuse = function () {
						var _v8 = _Utils_Tuple2(
							model.mW,
							$author$project$Components$Parametrage$PipeEtape1$Update$estTypeInconnu(refus.bB));
						if (((!_v8.a.$) && (_v8.a.a.$ === 4)) && _v8.b) {
							var saisie = _v8.a.a.a;
							return $elm$core$List$head(saisie.ib);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								i0: $author$project$Components$Parametrage$PipeEtape1$Update$archivesDuRefus(refus.bB),
								l2: envoi,
								pZ: $elm$core$Maybe$Just(
									A3($author$project$Components$Parametrage$PipeEtape1$Update$refusDuPipe, model, refus, typeRefuse)),
								rV: typeRefuse,
								sr: _Utils_eq(
									refus.bB,
									$author$project$API$Reponse$Metier('VersionNonModifiable'))
							}),
						effets);
				default:
					var _v9 = _v0.a;
					var envoi = _v9.a;
					var _v10 = _v9.b;
					var effets = _v9.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{l2: envoi}),
						effets);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$RetirerUneSource = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$Update$retirer = F2(
	function (uid, model) {
		var retrait = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.eW;
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (source) {
						return _Utils_eq(source.r8, uid);
					},
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.IT;
							},
							model.ge)))));
		return A3(
			$author$project$Components$Parametrage$PipeEtape1$Update$envoyer,
			retrait,
			$author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$RetirerUneSource(uid),
			model);
	});
var $author$project$API$NavLinksDictionary$retirerUneOuvertureParUnTiers = 'retirer-une-ouverture-par-un-tiers';
var $author$project$Components$Parametrage$PipeEtape1$Model$saisieDeLOuverture = function (ouverture) {
	var evenement = function (type_) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (lu) {
					return _Utils_eq(lu.r0, type_);
				},
				ouverture.mk));
	};
	var origine = evenement($author$project$Components$Parametrage$PipeEtape1$Model$finDuDossierPrecedent);
	var vide = {
		cm: '',
		cE: '',
		me: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.me;
				},
				origine)),
		mk: A2(
			$elm$core$List$map,
			function ($) {
				return $.r0;
			},
			ouverture.mk),
		A$: '',
		A0: '',
		CR: 'n',
		oh: 'n+1',
		EU: ouverture.EU,
		pi: 'toujours',
		Fu: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.Fu;
				},
				origine)),
		GK: ouverture.GK,
		Ij: 'mois'
	};
	var _v0 = ouverture.pi;
	switch (_v0.$) {
		case 0:
			return vide;
		case 1:
			var du = _v0.a;
			var au = _v0.b;
			return _Utils_update(
				vide,
				{cm: au, cE: du, pi: 'entre-deux-dates'});
		default:
			var r = _v0.a;
			return _Utils_update(
				vide,
				{
					A$: $elm$core$String$fromInt(r.A$),
					A0: A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $elm$core$String$fromInt, r.A0)),
					CR: r.CR,
					oh: r.oh,
					pi: 'recurrente',
					Ij: r.Ij
				});
	}
};
var $author$project$Components$Parametrage$PipeEtape1$Model$plurielPropre = function (edition) {
	return A2(
		$elm$core$Dict$filter,
		F2(
			function (langue, texte) {
				return !_Utils_eq(
					texte,
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Dict$get, langue, edition.CW)));
			}),
		edition.CX);
};
var $author$project$Components$Parametrage$PipeEtape1$Model$saisieDuMot = function (edition) {
	return {
		bT: $author$project$Components$Parametrage$PipeEtape1$Model$plurielPropre(edition),
		IN: edition.CW
	};
};
var $author$project$Components$Parametrage$PipeEtape1$Model$saisieOuvertureParUnTiers = F2(
	function (edition, lue) {
		if (!lue.$) {
			var ouverture = lue.a;
			return {
				iN: $elm$core$Maybe$Just(
					_Utils_Tuple2(ouverture.bi.r8, ouverture.FY.vx)),
				oU: function () {
					var _v1 = ouverture.zo;
					if (_v1.$ === 1) {
						return true;
					} else {
						return false;
					}
				}(),
				pm: function () {
					var _v2 = ouverture.zo;
					if ((_v2.$ === 1) && (!_v2.b.$)) {
						var n = _v2.b.a;
						return $elm$core$String$fromInt(n);
					} else {
						return '20';
					}
				}(),
				FY: ouverture.FY.vx,
				H6: ouverture.bi.r8,
				e$: function () {
					var _v3 = ouverture.zo;
					if ((_v3.$ === 1) && (_v3.b.$ === 1)) {
						var _v4 = _v3.b;
						return true;
					} else {
						return false;
					}
				}(),
				ib: function () {
					var _v5 = ouverture.zo;
					if (_v5.$ === 1) {
						var types = _v5.a;
						return types;
					} else {
						return _List_Nil;
					}
				}()
			};
		} else {
			return {
				iN: $elm$core$Maybe$Nothing,
				oU: false,
				pm: '20',
				FY: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.vx;
						},
						$elm$core$List$head(edition.Ei.F_))),
				H6: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.r8;
						},
						$elm$core$List$head(edition.Ei.eX))),
				e$: false,
				ib: _List_Nil
			};
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$ecrire = F3(
	function (langue, texte, libelles) {
		return A3($elm$core$Dict$insert, langue, texte, libelles);
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$saisirLeLibelle = F3(
	function (langue, texte, model) {
		var _v0 = model.mW;
		_v0$3:
		while (true) {
			if (!_v0.$) {
				switch (_v0.a.$) {
					case 4:
						var saisie = _v0.a.a;
						return _Utils_update(
							model,
							{
								mW: $elm$core$Maybe$Just(
									$author$project$Components$Parametrage$PipeEtape1$Model$ObjetViseEnSaisie(
										_Utils_update(
											saisie,
											{
												hL: A2(
													$elm$core$Maybe$map,
													A2($author$project$Components$Parametrage$PipeEtape1$Update$ecrire, langue, texte),
													saisie.hL)
											})))
							});
					case 0:
						var libelles = _v0.a.a;
						return _Utils_update(
							model,
							{
								mW: $elm$core$Maybe$Just(
									$author$project$Components$Parametrage$PipeEtape1$Model$NomEnSaisie(
										A3($author$project$Components$Parametrage$PipeEtape1$Update$ecrire, langue, texte, libelles)))
							});
					case 1:
						var saisie = _v0.a.a;
						return _Utils_update(
							model,
							{
								mW: $elm$core$Maybe$Just(
									$author$project$Components$Parametrage$PipeEtape1$Model$MotEnSaisie(
										_Utils_update(
											saisie,
											{
												IN: A3($author$project$Components$Parametrage$PipeEtape1$Update$ecrire, langue, texte, saisie.IN)
											})))
							});
					default:
						break _v0$3;
				}
			} else {
				break _v0$3;
			}
		}
		return model;
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$saisirLePluriel = F3(
	function (langue, texte, model) {
		var _v0 = model.mW;
		if ((!_v0.$) && (_v0.a.$ === 1)) {
			var saisie = _v0.a.a;
			return _Utils_update(
				model,
				{
					mW: $elm$core$Maybe$Just(
						$author$project$Components$Parametrage$PipeEtape1$Model$MotEnSaisie(
							_Utils_update(
								saisie,
								{
									bT: A3($author$project$Components$Parametrage$PipeEtape1$Update$ecrire, langue, texte, saisie.bT)
								})))
				});
		} else {
			return model;
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$surLObjetVise = F2(
	function (f, model) {
		var _v0 = model.mW;
		if ((!_v0.$) && (_v0.a.$ === 4)) {
			var saisie = _v0.a.a;
			return _Utils_update(
				model,
				{
					mW: $elm$core$Maybe$Just(
						$author$project$Components$Parametrage$PipeEtape1$Model$ObjetViseEnSaisie(
							f(saisie)))
				});
		} else {
			return model;
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$surLOuverture = F2(
	function (f, model) {
		var _v0 = model.mW;
		if ((!_v0.$) && (_v0.a.$ === 3)) {
			var saisie = _v0.a.a;
			return _Utils_update(
				model,
				{
					mW: $elm$core$Maybe$Just(
						$author$project$Components$Parametrage$PipeEtape1$Model$OuvertureEnSaisie(
							f(saisie)))
				});
		} else {
			return model;
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$surLOuvertureParUnTiers = F2(
	function (f, model) {
		var _v0 = model.mW;
		if ((!_v0.$) && (_v0.a.$ === 5)) {
			var saisie = _v0.a.a;
			return _Utils_update(
				model,
				{
					mW: $elm$core$Maybe$Just(
						$author$project$Components$Parametrage$PipeEtape1$Model$OuvertureParUnTiersEnSaisie(
							f(saisie)))
				});
		} else {
			return model;
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$surLaSource = F2(
	function (f, model) {
		var _v0 = model.mW;
		if (((!_v0.$) && (_v0.a.$ === 2)) && (!_v0.a.a.$)) {
			var source = _v0.a.a.a;
			return _Utils_update(
				model,
				{
					mW: $elm$core$Maybe$Just(
						$author$project$Components$Parametrage$PipeEtape1$Model$OffreEnSaisie(
							$elm$core$Maybe$Just(
								f(source))))
				});
		} else {
			return model;
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$surLeLien = F2(
	function (f, model) {
		var _v0 = model.mW;
		if ((!_v0.$) && (_v0.a.$ === 6)) {
			var saisie = _v0.a.a;
			return _Utils_update(
				model,
				{
					mW: $elm$core$Maybe$Just(
						$author$project$Components$Parametrage$PipeEtape1$Model$LienEnSaisie(
							f(saisie)))
				});
		} else {
			return model;
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$sortiesDuDrawer = _List_fromArray(
	[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$SortieDemandee, $author$project$Components$Shared$Drawer$Update$AbandonConfirme]);
var $author$project$Components$Parametrage$PipeEtape1$Update$versLeDrawer = F2(
	function (geste, model) {
		if ($author$project$API$Envoi$enCours(model.l2) && A2($elm$core$List$member, geste, $author$project$Components$Parametrage$PipeEtape1$Update$sortiesDuDrawer)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v0 = A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.kX);
			var drawer = _v0.a;
			var effets = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						kX: drawer,
						mW: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? model.mW : $elm$core$Maybe$Nothing
					}),
				A2(
					$elm$core$List$map,
					function (_v1) {
						var cible = _v1;
						return $author$project$Components$Parametrage$PipeEtape1$Update$PlacerFocus(cible);
					},
					effets));
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var code = msg.a;
				var liens = msg.b;
				var init_ = $author$project$Components$Parametrage$PipeEtape1$Model$init(code);
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$pipes, liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						init_,
						_List_fromArray(
							[
								$author$project$Components$Parametrage$PipeEtape1$Update$DemanderProcessUid,
								A2($author$project$Components$Parametrage$PipeEtape1$Update$Lire, 0, lecture)
							]));
				} else {
					return _Utils_Tuple2(init_, _List_Nil);
				}
			case 1:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 5:
				return $author$project$Components$Parametrage$PipeEtape1$Update$recharger(model);
			case 2:
				var lecture = msg.a;
				var reponse = msg.b;
				return A3($author$project$Components$Parametrage$PipeEtape1$Update$lu, lecture, reponse, model);
			case 3:
				var reponse = msg.a;
				return A2($author$project$Components$Parametrage$PipeEtape1$Update$repondue, reponse, model);
			case 4:
				var geste = msg.a;
				return A2($author$project$Components$Parametrage$PipeEtape1$Update$versLeDrawer, geste, model);
			case 6:
				return A5(
					$author$project$Components$Parametrage$PipeEtape1$Update$ouvrirSi,
					'renommer-le-pipe',
					model,
					'nom',
					function (edition) {
						return $author$project$Components$Parametrage$PipeEtape1$Model$NomEnSaisie(edition.R);
					},
					_List_Nil);
			case 7:
				return A5(
					$author$project$Components$Parametrage$PipeEtape1$Update$ouvrirSi,
					'modifier-le-mot-employe',
					model,
					'mot',
					function (edition) {
						return $author$project$Components$Parametrage$PipeEtape1$Model$MotEnSaisie(
							$author$project$Components$Parametrage$PipeEtape1$Model$saisieDuMot(edition));
					},
					_List_Nil);
			case 8:
				return A5(
					$author$project$Components$Parametrage$PipeEtape1$Update$ouvrirSi,
					'ajouter-une-source-d-offre',
					model,
					'offre',
					function (_v2) {
						return $author$project$Components$Parametrage$PipeEtape1$Model$OffreEnSaisie($elm$core$Maybe$Nothing);
					},
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							$elm$core$List$singleton,
							A2(
								$elm$core$Maybe$map,
								$author$project$Components$Parametrage$PipeEtape1$Update$Lire(4),
								A2($author$project$Components$Parametrage$PipeEtape1$Update$lienDe, $author$project$API$NavLinksDictionary$candidatsDOffre, model)))));
			case 12:
				return A5(
					$author$project$Components$Parametrage$PipeEtape1$Update$ouvrirSi,
					$author$project$API$NavLinksDictionary$definirLObjetVise,
					model,
					'objet-vise',
					function (edition) {
						return $author$project$Components$Parametrage$PipeEtape1$Model$ObjetViseEnSaisie(
							$author$project$Components$Parametrage$PipeEtape1$Model$saisieDeLObjetVise(edition));
					},
					A2(
						$author$project$Components$Parametrage$PipeEtape1$Update$lireSi,
						6,
						A2($author$project$Components$Parametrage$PipeEtape1$Update$lienDe, $author$project$API$NavLinksDictionary$optionsDeLObjetVise, model)));
			case 13:
				var lue = msg.a;
				return A5(
					$author$project$Components$Parametrage$PipeEtape1$Update$ouvrirSi,
					_Utils_eq(lue, $elm$core$Maybe$Nothing) ? $author$project$API$NavLinksDictionary$ajouterUneOuvertureParUnTiers : $author$project$API$NavLinksDictionary$modifierUneOuvertureParUnTiers,
					model,
					'ouverture-tiers',
					function (edition) {
						return $author$project$Components$Parametrage$PipeEtape1$Model$OuvertureParUnTiersEnSaisie(
							A2($author$project$Components$Parametrage$PipeEtape1$Model$saisieOuvertureParUnTiers, edition, lue));
					},
					A2(
						$author$project$Components$Parametrage$PipeEtape1$Update$lireSi,
						6,
						A2($author$project$Components$Parametrage$PipeEtape1$Update$lienDe, $author$project$API$NavLinksDictionary$optionsDeLObjetVise, model)));
			case 14:
				var uid = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape1$Update$surLOuvertureParUnTiers,
						function (saisie) {
							return _Utils_update(
								saisie,
								{H6: uid});
						},
						model),
					_List_Nil);
			case 15:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape1$Update$surLOuvertureParUnTiers,
						function (saisie) {
							return _Utils_update(
								saisie,
								{FY: code});
						},
						model),
					_List_Nil);
			case 16:
				var nouvelle = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape1$Update$surLOuvertureParUnTiers,
						function (saisie) {
							return _Utils_update(
								saisie,
								{oU: nouvelle, ib: _List_Nil});
						},
						model),
					_List_Nil);
			case 18:
				var texte = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape1$Update$surLOuvertureParUnTiers,
						function (saisie) {
							return _Utils_update(
								saisie,
								{pm: texte});
						},
						model),
					_List_Nil);
			case 19:
				var sans = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape1$Update$surLOuvertureParUnTiers,
						function (saisie) {
							return _Utils_update(
								saisie,
								{e$: sans});
						},
						model),
					_List_Nil);
			case 17:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape1$Update$surLOuvertureParUnTiers,
						function (saisie) {
							return _Utils_update(
								saisie,
								{
									ib: A3(
										$author$project$Components$Parametrage$PipeEtape1$Model$basculer,
										code,
										!A2($elm$core$List$member, code, saisie.ib),
										saisie.ib)
								});
						},
						model),
					_List_Nil);
			case 20:
				var roleUid = msg.a;
				var portail = msg.b;
				return A3(
					$author$project$Components$Parametrage$PipeEtape1$Update$envoyer,
					A2($author$project$Components$Parametrage$PipeEtape1$Update$lienDe, $author$project$API$NavLinksDictionary$retirerUneOuvertureParUnTiers, model),
					A2($author$project$Components$Parametrage$PipeEtape1$API$WriteAPIModel$RetirerUneOuvertureParUnTiers, roleUid, portail),
					model);
			case 21:
				var nature = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape1$Update$surLObjetVise,
						function (saisie) {
							return _Utils_update(
								saisie,
								{g1: nature, hL: $elm$core$Maybe$Nothing, rL: false, ib: _List_Nil});
						},
						model),
					_List_Nil);
			case 22:
				var code = msg.a;
				var bascule = function (saisie) {
					return _Utils_update(
						saisie,
						{
							rL: false,
							ib: A2($elm$core$List$member, code, saisie.ib) ? A2(
								$elm$core$List$filter,
								function (t) {
									return !_Utils_eq(t, code);
								},
								saisie.ib) : _Utils_ap(
								saisie.ib,
								_List_fromArray(
									[code]))
						});
				};
				return $author$project$Components$Parametrage$PipeEtape1$Update$lireLesChampsCommuns(
					A2($author$project$Components$Parametrage$PipeEtape1$Update$surLObjetVise, bascule, model));
			case 23:
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape1$Update$surLObjetVise,
						function (saisie) {
							return _Utils_update(
								saisie,
								{rL: !saisie.rL, ib: _List_Nil});
						},
						model),
					_List_Nil);
			case 24:
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape1$Update$surLObjetVise,
						function (saisie) {
							return _Utils_update(
								saisie,
								{
									hL: $elm$core$Maybe$Just(
										A2($author$project$Components$Parametrage$PipeEtape1$Model$libelleDuRole, model, saisie))
								});
						},
						model),
					_List_Nil);
			case 10:
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$Components$Parametrage$PipeEtape1$Update$lireSi,
						9,
						A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.I7;
							},
							model.o_)));
			case 11:
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$Components$Parametrage$PipeEtape1$Update$lireSi,
						10,
						A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.I7;
							},
							model.o$)));
			case 9:
				return A5(
					$author$project$Components$Parametrage$PipeEtape1$Update$ouvrirSi,
					'regler-l-ouverture',
					model,
					'ouverture',
					function (edition) {
						return $author$project$Components$Parametrage$PipeEtape1$Model$OuvertureEnSaisie(
							$author$project$Components$Parametrage$PipeEtape1$Model$saisieDeLOuverture(edition.ew));
					},
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							$elm$core$List$singleton,
							A2(
								$elm$core$Maybe$map,
								$author$project$Components$Parametrage$PipeEtape1$Update$Lire(5),
								A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.BA;
									},
									model.ge)))));
			case 25:
				var langue = msg.a;
				var texte = msg.b;
				return _Utils_Tuple2(
					A3($author$project$Components$Parametrage$PipeEtape1$Update$saisirLeLibelle, langue, texte, model),
					_List_Nil);
			case 26:
				var langue = msg.a;
				var texte = msg.b;
				return _Utils_Tuple2(
					A3($author$project$Components$Parametrage$PipeEtape1$Update$saisirLePluriel, langue, texte, model),
					_List_Nil);
			case 27:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							mW: A2(
								$author$project$Components$Parametrage$PipeEtape1$Update$enOffre,
								$elm$core$Maybe$Just($author$project$Components$Parametrage$PipeEtape1$Model$nouvelleSource),
								model),
							IR: $elm$core$Maybe$Nothing
						}),
					_List_Nil);
			case 28:
				var uid = msg.a;
				return _Utils_Tuple2(
					model,
					A2($author$project$Components$Parametrage$PipeEtape1$Update$lireLaSource, uid, model));
			case 29:
				var uid = msg.a;
				return A2($author$project$Components$Parametrage$PipeEtape1$Update$retirer, uid, model);
			case 30:
				var nature = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape1$Update$surLaSource,
						function (source) {
							return _Utils_update(
								source,
								{aV: _List_Nil, g1: nature});
						},
						model),
					_List_Nil);
			case 31:
				var uid = msg.a;
				var coche = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape1$Update$surLaSource,
						A3($author$project$Components$Parametrage$PipeEtape1$Update$basculerLElement, model.jy, uid, coche),
						model),
					_List_Nil);
			case 32:
				var texte = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape1$Update$surLaSource,
						function (source) {
							return _Utils_update(
								source,
								{CD: texte});
						},
						model),
					_List_Nil);
			case 33:
				var texte = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape1$Update$surLaSource,
						function (source) {
							return _Utils_update(
								source,
								{Cj: texte});
						},
						model),
					_List_Nil);
			case 34:
				var code = msg.a;
				var coche = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape1$Update$surLOuverture,
						function (saisie) {
							return _Utils_update(
								saisie,
								{
									GK: A3($author$project$Components$Parametrage$PipeEtape1$Model$basculer, code, coche, saisie.GK)
								});
						},
						model),
					_List_Nil);
			case 35:
				var code = msg.a;
				var coche = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape1$Update$surLOuverture,
						function (saisie) {
							return _Utils_update(
								saisie,
								{
									mk: A3($author$project$Components$Parametrage$PipeEtape1$Model$basculer, code, coche, saisie.mk)
								});
						},
						model),
					_List_Nil);
			case 36:
				var champ = msg.a;
				var texte = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape1$Update$surLOuverture,
						A2($author$project$Components$Parametrage$PipeEtape1$Update$champDeLOuverture, champ, texte),
						model),
					_List_Nil);
			case 37:
				var _v3 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ajouterUnTypeDeDossier, model.nR);
				if (!_v3.$) {
					return A4(
						$author$project$Components$Parametrage$PipeEtape1$Update$ouvrirLeLien,
						'type-de-dossier',
						$author$project$Components$Parametrage$PipeEtape1$Lien$creation,
						A2(
							$author$project$Components$Parametrage$PipeEtape1$Update$lireSi,
							8,
							A2($author$project$Components$Parametrage$PipeEtape1$Update$lienDe, $author$project$API$NavLinksDictionary$optionsDeLien, model)),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 38:
				var lecture = msg.a;
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[
							A2($author$project$Components$Parametrage$PipeEtape1$Update$Lire, 7, lecture)
						]));
			case 39:
				var _v4 = A2($author$project$Components$Parametrage$PipeEtape1$Update$lienDe, $author$project$API$NavLinksDictionary$modifierLeLien, model);
				if (!_v4.$) {
					return A4(
						$author$project$Components$Parametrage$PipeEtape1$Update$ouvrirLeLien,
						'lien',
						$author$project$Components$Parametrage$PipeEtape1$Lien$ajout,
						A2(
							$author$project$Components$Parametrage$PipeEtape1$Update$lireSi,
							8,
							A2($author$project$Components$Parametrage$PipeEtape1$Update$lienDe, $author$project$API$NavLinksDictionary$optionsDeLien, model)),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 40:
				var reglage_ = msg.a;
				var texte = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape1$Update$surLeLien,
						A2($author$project$Components$Parametrage$PipeEtape1$Lien$choisir, reglage_, texte),
						model),
					_List_Nil);
			case 41:
				var coche = msg.a;
				var coche_ = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape1$Update$surLeLien,
						A2($author$project$Components$Parametrage$PipeEtape1$Lien$basculer, coche, coche_),
						model),
					_List_Nil);
			default:
				return $author$project$Components$Parametrage$PipeEtape1$Update$enregistrer(model);
		}
	});
var $author$project$Main$Update$versLEtape1DUnPipe = F3(
	function (i18n, msg, model) {
		var _v0 = A2(
			$author$project$Components$Parametrage$PipeEtape1$Update$update,
			msg,
			$author$project$Components$Parametrage$PipeEtape1$Model$ouvrir(model.Fy));
		var etape1 = _v0.a;
		var effets = _v0.b;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLEtape1DUnPipe,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Parametrage$PipeEtape1$Update$popMessages(msg),
							model.Ct),
						Fy: $author$project$Components$Parametrage$PipeEtape1$Model$envelopper(etape1)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$EnvoyerALEtape2DUnPipe = function (a) {
	return {$: 83, a: a};
};
var $author$project$Main$Update$LireLEtape2DUnPipe = F2(
	function (a, b) {
		return {$: 82, a: a, b: b};
	});
var $author$project$Main$Model$PourLEtape2DUnPipe = 18;
var $author$project$Main$Update$depuisLEtape2DUnPipe = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				var lecture = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLEtape2DUnPipe(lecture))));
			case 1:
				var lien = effet.a;
				var processUid = effet.b;
				var pipeUid = effet.c;
				var commande = effet.d;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerALEtape2DUnPipe(
									{vJ: commande, gM: vers.gM, nB: vers.nB, FK: pipeUid, Gn: processUid});
							})));
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[18]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 3:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Edition = F3(
	function (uid, libelles, liens) {
		return {R: libelles, nQ: liens, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$libellesDecoder = $elm$json$Json$Decode$dict($elm$json$Json$Decode$string);
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$editionDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['pipe', 'libelles']),
		$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$libellesDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['pipe', 'uid']),
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Edition))));
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Etape = function (uid) {
	return function (rang) {
		return function (libelles) {
			return function (but) {
				return function (delaiEnJours) {
					return function (portail) {
						return function (passagesSortants) {
							return function (finale) {
								return function (resultatsPossibles) {
									return function (liens) {
										return {uy: but, kB: delaiEnJours, mK: finale, R: libelles, nQ: liens, pc: passagesSortants, FY: portail, bY: rang, qG: resultatsPossibles, r8: uid};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$PassageSortant = F5(
	function (uid, ordre, vers, parDefaut, libelle) {
		return {Bl: libelle, El: ordre, o6: parDefaut, r8: uid, sn: vers};
	});
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Nommee = F8(
	function (uid, libelle, grammaire, nomCourt, aide, objetVise, avecArticle, defini) {
		return {bp: aide, ud: avecArticle, wY: defini, m$: grammaire, Bl: libelle, Dl: nomCourt, D_: objetVise, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$nommeeDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'defini',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'avecArticle',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'objetVise',
			$elm$json$Json$Decode$bool,
			false,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'aide',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'nomCourt',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'grammaire',
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Formes$decoder),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'libelle',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'uid',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Nommee)))))))));
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$passageSortantDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$PassageSortant,
	A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'ordre', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'vers', $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$nommeeDecoder),
	A2($elm$json$Json$Decode$field, 'parDefaut', $elm$json$Json$Decode$bool),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'libelle', $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$libellesDecoder),
				$elm$json$Json$Decode$succeed($elm$core$Dict$empty)
			])));
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Portail = F2(
	function (visible, libelles) {
		return {R: libelles, KR: visible};
	});
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$portailDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Portail,
	A2($elm$json$Json$Decode$field, 'visible', $elm$json$Json$Decode$bool),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'libelles', $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$libellesDecoder),
				$elm$json$Json$Decode$succeed($elm$core$Dict$empty)
			])));
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$resultatDecoder = A2($elm$json$Json$Decode$field, 'resultat', $elm$json$Json$Decode$string);
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$etapeDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'resultatsPossibles',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'finale',
			$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$resultatDecoder),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'passagesSortants',
				$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$passageSortantDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'portail',
					$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$portailDecoder,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'delaiAttenduEnJours',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'but',
							$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$libellesDecoder,
							$elm$core$Dict$empty,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'libelles',
								$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$libellesDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'rang',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'uid',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Etape)))))))))));
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Options = F6(
	function (etapes, sujets, comparaisons, declenchements, rolesDeclencheurs, resultatsPossibles) {
		return {vQ: comparaisons, wP: declenchements, yL: etapes, qG: resultatsPossibles, H9: rolesDeclencheurs, Ja: sujets};
	});
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Sujet = F4(
	function (code, libelle, genre, correspondances) {
		return {vx: code, wh: correspondances, M: genre, Bl: libelle};
	});
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Correspondance = F4(
	function (id, libelle, cible, valeurs) {
		return {vf: cible, Aq: id, Bl: libelle, Ki: valeurs};
	});
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$ValeurDEchelle = F2(
	function (id, libelle) {
		return {Aq: id, Bl: libelle};
	});
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$correspondanceDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Correspondance,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'cible', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'valeurs',
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$ValeurDEchelle,
				A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string)))));
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$sujetDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Sujet,
	A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'genre', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'correspondances',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$correspondanceDecoder)));
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$optionsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'resultatsPossibles',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'rolesDeclencheurs',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$nommeeDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'declenchements',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'comparaisons',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'sujets',
					$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$sujetDecoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'etapes',
						$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$nommeeDecoder),
						$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Options)))))));
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Parcours = F4(
	function (resume, etapes, passages, liens) {
		return {yL: etapes, nQ: liens, E5: passages, HX: resume};
	});
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$EtapeDuParcours = function (uid) {
	return function (rang) {
		return function (libelles) {
			return function (grammaire) {
				return function (nomCourt) {
					return function (nature) {
						return function (delaiEnJours) {
							return function (roles) {
								return function (nombreDeTaches) {
									return function (taches) {
										return function (finale) {
											return function (pilotee) {
												return function (passagesSortants) {
													return function (arriveDepuis) {
														return function (lecture) {
															return {tM: arriveDepuis, kB: delaiEnJours, mK: finale, m$: grammaire, np: lecture, R: libelles, g1: nature, Dl: nomCourt, DD: nombreDeTaches, pc: passagesSortants, Fr: pilotee, bY: rang, eX: roles, Jk: taches, r8: uid};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$API$NavLinksDictionary$etapeDuPipe = 'etape';
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$lienDe = function (rel) {
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$API$Liens$trouver(rel),
		$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder);
};
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Chemin = 1;
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Debut = 0;
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Fin = 2;
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$FinHorsChemin = 3;
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$natureDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (code) {
		switch (code) {
			case 'debut':
				return $elm$json$Json$Decode$succeed(0);
			case 'chemin':
				return $elm$json$Json$Decode$succeed(1);
			case 'fin':
				return $elm$json$Json$Decode$succeed(2);
			case 'fin-hors-chemin':
				return $elm$json$Json$Decode$succeed(3);
			default:
				var autre = code;
				return $elm$json$Json$Decode$fail(autre);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Tache = F3(
	function (uid, libelle, type_) {
		return {Bl: libelle, r0: type_, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$tacheDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Tache,
	A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$etapeDuParcoursDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$lienDe($author$project$API$NavLinksDictionary$etapeDuPipe),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'arriveDepuis',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'passagesSortants',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'pilotee',
				$elm$json$Json$Decode$bool,
				false,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'finale',
					$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$resultatDecoder),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'taches',
						$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$tacheDecoder),
						_List_Nil,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'nombreDeTaches',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'roles',
								$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$nommeeDecoder),
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'delaiAttenduEnJours',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
									$elm$core$Maybe$Nothing,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'nature',
										$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$natureDecoder,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'nomCourt',
											A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
											$elm$core$Maybe$Nothing,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'grammaire',
												A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Formes$decoder),
												$elm$core$Maybe$Nothing,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'libelles',
													$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$libellesDecoder,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'rang',
														$elm$json$Json$Decode$int,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'uid',
															$elm$json$Json$Decode$string,
															$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$EtapeDuParcours))))))))))))))));
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$PassageDuParcours = function (uid) {
	return function (de) {
		return function (vers) {
			return function (ordre) {
				return function (sens) {
					return function (parDefaut) {
						return function (libelle) {
							return function (condition) {
								return function (declenchement) {
									return function (lecture) {
										return {j4: condition, wC: de, kw: declenchement, np: lecture, Bl: libelle, El: ordre, o6: parDefaut, IC: sens, r8: uid, sn: vers};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Condition = F3(
	function (mode, liaison, termes) {
		return {Bk: liaison, n9: mode, rD: termes};
	});
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Et = 0;
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Ou = 1;
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$liaisonDecoder = function (code) {
	switch (code) {
		case 'et':
			return $elm$json$Json$Decode$succeed(0);
		case 'ou':
			return $elm$json$Json$Decode$succeed(1);
		default:
			var autre = code;
			return $elm$json$Json$Decode$fail(autre);
	}
};
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Si = 1;
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Sinon = 2;
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Toujours = 0;
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$modeDecoder = function (code) {
	switch (code) {
		case 'toujours':
			return $elm$json$Json$Decode$succeed(0);
		case 'si':
			return $elm$json$Json$Decode$succeed(1);
		case 'sinon':
			return $elm$json$Json$Decode$succeed(2);
		default:
			var autre = code;
			return $elm$json$Json$Decode$fail(autre);
	}
};
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Terme = F4(
	function (sujet, comparaison, valeur, correspondance) {
		return {vP: comparaison, wg: correspondance, I9: sujet, fm: valeur};
	});
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$termeDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Terme,
	A2($elm$json$Json$Decode$field, 'sujet', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'comparaison', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'valeur',
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$elm$json$Json$Decode$string,
					A2($elm$json$Json$Decode$map, $elm$core$String$fromFloat, $elm$json$Json$Decode$float),
					$elm$json$Json$Decode$null('')
				]))),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'correspondance', $elm$json$Json$Decode$string)));
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$conditionDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Condition,
	A2(
		$elm$json$Json$Decode$andThen,
		$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$modeDecoder,
		A2($elm$json$Json$Decode$field, 'mode', $elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$andThen,
				$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$liaisonDecoder,
				A2($elm$json$Json$Decode$field, 'liaison', $elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$succeed(0)
			])),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'termes',
				$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$termeDecoder)),
				$elm$json$Json$Decode$succeed(_List_Nil)
			])));
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Automatique = {$: 0};
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$CalculeSla = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$ParLeRegroupement = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$ParUnRole = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$declenchementDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		switch (type_) {
			case 'automatique':
				return $elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Automatique);
			case 'par-un-role':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$ParUnRole,
					A2($elm$json$Json$Decode$field, 'roleUid', $elm$json$Json$Decode$string));
			case 'calcule-sla':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$CalculeSla,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['echeance', 'delaiEnJours']),
						$elm$json$Json$Decode$int));
			case 'par-le-regroupement':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$ParLeRegroupement,
					A2($elm$json$Json$Decode$field, 'actionUid', $elm$json$Json$Decode$string));
			default:
				var autre = type_;
				return $elm$json$Json$Decode$fail(autre);
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$API$NavLinksDictionary$passageDuPipe = 'passage';
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Avant = 0;
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Branche = 1;
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Retour = 2;
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$sensDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (code) {
		switch (code) {
			case 'avant':
				return $elm$json$Json$Decode$succeed(0);
			case 'branche':
				return $elm$json$Json$Decode$succeed(1);
			case 'retour':
				return $elm$json$Json$Decode$succeed(2);
			default:
				var autre = code;
				return $elm$json$Json$Decode$fail(autre);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$passageDuParcoursDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$lienDe($author$project$API$NavLinksDictionary$passageDuPipe),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'declenchement',
		$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$declenchementDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'condition',
			$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$conditionDecoder,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'libelle',
				$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$libellesDecoder,
				$elm$core$Dict$empty,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'parDefaut',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'sens',
						$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$sensDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'ordre',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'vers',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'de',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'uid',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$PassageDuParcours)))))))))));
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Resume = F4(
	function (nombreDEtapes, nombrePassages, nombreDeFins, nombreDeRetours) {
		return {Dt: nombreDEtapes, Dz: nombreDeFins, DC: nombreDeRetours, DE: nombrePassages};
	});
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$resumeDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Resume,
	A2($elm$json$Json$Decode$field, 'nombreDEtapes', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'nombrePassages', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'nombreDeFins', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'nombreDeRetours', $elm$json$Json$Decode$int));
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$parcoursDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'passages',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$passageDuParcoursDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'etapes',
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$List$sortBy(
					function ($) {
						return $.bY;
					}),
				$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$etapeDuParcoursDecoder)),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'resume',
				$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$resumeDecoder,
				$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Parcours)))));
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Passage = function (uid) {
	return function (de) {
		return function (vers) {
			return function (sens) {
				return function (ordre) {
					return function (parDefaut) {
						return function (libelle) {
							return function (condition) {
								return function (declenchement) {
									return function (options) {
										return function (liens) {
											return {j4: condition, wC: de, kw: declenchement, Bl: libelle, nQ: liens, o_: options, El: ordre, o6: parDefaut, IC: sens, r8: uid, sn: vers};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$passageDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'options',
		$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$optionsDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'declenchement',
			$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$declenchementDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'condition',
				$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$conditionDecoder,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'libelle',
					$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$libellesDecoder,
					$elm$core$Dict$empty,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'parDefaut',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'ordre',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'sens',
								$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$sensDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'vers',
									$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$nommeeDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'de',
										$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$nommeeDecoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'uid',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Passage))))))))))));
var $author$project$Components$Parametrage$PipeEtape2$Update$refusDeLecture = F2(
	function (lecture, reponse) {
		var refuse = function (decodeur) {
			var _v1 = A2($author$project$API$Reponse$lire, decodeur, reponse);
			if (_v1.$ === 1) {
				var refus = _v1.a;
				return ((refus.ri === 401) || (refus.ri === 404)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Components$Shared$Messages$Model$duRefus(refus));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		switch (lecture) {
			case 0:
				return refuse($author$project$Components$Parametrage$Common$API$QueryAPIModel$annuaireDecoder);
			case 1:
				return refuse($author$project$Components$Parametrage$Common$API$QueryAPIModel$racineDuPipeDecoder);
			case 2:
				return refuse($author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$editionDecoder);
			case 3:
				return refuse($author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$parcoursDecoder);
			case 4:
				return refuse($author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$optionsDecoder);
			case 5:
				return refuse($author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$etapeDecoder);
			default:
				return refuse($author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$passageDecoder);
		}
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$popMessages = function (msg) {
	if (msg.$ === 2) {
		var lecture = msg.a;
		var reponse = msg.b;
		return A2($author$project$Components$Parametrage$PipeEtape2$Update$refusDeLecture, lecture, reponse);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$PipeEtape2$Update$Annuaire = 0;
var $author$project$Components$Parametrage$PipeEtape2$Update$DemanderProcessUid = {$: 2};
var $author$project$Components$Parametrage$PipeEtape2$Model$EtapeEnSaisie = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$PipeEtape2$Update$Lire = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape2$Model$PassageEnSaisie = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$PipeEtape2$Update$UnPassage = 6;
var $author$project$Components$Parametrage$PipeEtape2$Update$UneEtape = 5;
var $author$project$API$NavLinksDictionary$ajouterUnPassage = 'ajouter-un-passage';
var $author$project$Components$Parametrage$PipeEtape2$Update$ajouterUnTerme = F2(
	function (options, saisie) {
		if (!options.$) {
			var lues = options.a;
			return _Utils_update(
				saisie,
				{
					rD: _Utils_ap(
						saisie.rD,
						_List_fromArray(
							[
								{
								vP: A2(
									$elm$core$Maybe$withDefault,
									'',
									$elm$core$List$head(lues.vQ)),
								wg: '',
								I9: A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.vx;
										},
										$elm$core$List$head(lues.Ja))),
								fm: ''
							}
							]))
				});
		} else {
			return saisie;
		}
	});
var $author$project$API$NavLinksDictionary$ajouterUneEtape = 'ajouter-une-etape';
var $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$AjouterUnPassage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$AjouterUneEtape = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$ModifierUnPassage = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$ModifierUneEtape = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape2$Model$delaiVoulu = function (texte) {
	var _v0 = $elm$core$String$trim(texte);
	if (_v0 === '') {
		return $elm$core$Maybe$Just($elm$core$Maybe$Nothing);
	} else {
		var saisi = _v0;
		var _v1 = $elm$core$String$toInt(saisi);
		if (!_v1.$) {
			var jours = _v1.a;
			return (jours > 0) ? $elm$core$Maybe$Just(
				$elm$core$Maybe$Just(jours)) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$Components$Parametrage$PipeEtape2$Model$libellesFacultatifs = function (libelles) {
	return A2(
		$elm$core$Dict$filter,
		F2(
			function (_v1, texte) {
				return texte !== '';
			}),
		A2(
			$elm$core$Dict$map,
			F2(
				function (_v0, texte) {
					return $elm$core$String$trim(texte);
				}),
			libelles));
};
var $author$project$Components$Parametrage$PipeEtape2$Model$libellesVoulus = function (libelles) {
	var gardes = A2(
		$elm$core$Dict$filter,
		F2(
			function (_v1, texte) {
				return texte !== '';
			}),
		A2(
			$elm$core$Dict$map,
			F2(
				function (_v0, texte) {
					return $elm$core$String$trim(texte);
				}),
			libelles));
	return A2($elm$core$Dict$member, 'fr', gardes) ? $elm$core$Maybe$Just(gardes) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$Parametrage$PipeEtape2$Model$etapeVoulue = function (saisie) {
	return A2(
		$elm$core$Maybe$andThen,
		function (voulue) {
			return (saisie.mK && _Utils_eq(voulue.mK, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(voulue);
		},
		A3(
			$elm$core$Maybe$map2,
			F2(
				function (libelles, delai) {
					return {
						uy: $author$project$Components$Parametrage$PipeEtape2$Model$libellesFacultatifs(saisie.uy),
						kB: delai,
						mK: (saisie.mK && (saisie.HW !== '')) ? $elm$core$Maybe$Just(saisie.HW) : $elm$core$Maybe$Nothing,
						R: libelles,
						pr: $author$project$Components$Parametrage$PipeEtape2$Model$libellesFacultatifs(saisie.pr),
						ps: saisie.ps
					};
				}),
			$author$project$Components$Parametrage$PipeEtape2$Model$libellesVoulus(saisie.R),
			$author$project$Components$Parametrage$PipeEtape2$Model$delaiVoulu(saisie.w2)));
};
var $author$project$Components$Parametrage$PipeEtape2$Update$lienDuParcours = F2(
	function (rel, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (parcours) {
				return A2($author$project$API$Liens$trouver, rel, parcours.nQ);
			},
			model.ex);
	});
var $author$project$API$NavLinksDictionary$modifierUnPassage = 'modifier-un-passage';
var $author$project$API$NavLinksDictionary$modifierUneEtape = 'modifier-une-etape';
var $author$project$Components$Parametrage$PipeEtape2$Model$declenchementVoulu = function (saisie) {
	var _v0 = saisie.kw;
	switch (_v0) {
		case 'automatique':
			return $elm$core$Maybe$Just($author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$Automatique);
		case 'par-un-role':
			return (saisie.H6 === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$ParUnRole(saisie.H6));
		case 'calcule-sla':
			return A2(
				$elm$core$Maybe$andThen,
				function (jours) {
					return (jours > 0) ? $elm$core$Maybe$Just(
						$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$CalculeSla(jours)) : $elm$core$Maybe$Nothing;
				},
				$elm$core$String$toInt(
					$elm$core$String$trim(saisie.ni)));
		case 'par-le-regroupement':
			return $elm$core$Maybe$Just(
				$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$ParLeRegroupement(saisie.cf));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$Nul = {$: 2};
var $author$project$Components$Parametrage$PipeEtape2$Model$sansValeur = function (comparaison) {
	return (comparaison === 'renseigne') || (comparaison === 'non-renseigne');
};
var $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$Nombre = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$Texte = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$PipeEtape2$Model$champOptionnel = function (texte) {
	return (texte === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(texte);
};
var $author$project$Components$Parametrage$PipeEtape2$Model$termeAvecValeur = F3(
	function (terme, genre, valeurTrim) {
		var _v0 = _Utils_Tuple2(genre, valeurTrim);
		if (_v0.a.$ === 1) {
			var _v1 = _v0.a;
			return $elm$core$Maybe$Nothing;
		} else {
			if (_v0.b === '') {
				return $elm$core$Maybe$Nothing;
			} else {
				if (_v0.a.a === 'nombre') {
					var texte = _v0.b;
					return A2(
						$elm$core$Maybe$map,
						function (nombre) {
							return {
								vP: terme.vP,
								wg: $elm$core$Maybe$Nothing,
								I9: terme.I9,
								fm: $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$Nombre(nombre)
							};
						},
						$elm$core$String$toFloat(texte));
				} else {
					var texte = _v0.b;
					return $elm$core$Maybe$Just(
						{
							vP: terme.vP,
							wg: $author$project$Components$Parametrage$PipeEtape2$Model$champOptionnel(terme.wg),
							I9: terme.I9,
							fm: $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$Texte(texte)
						});
				}
			}
		}
	});
var $author$project$Components$Parametrage$PipeEtape2$Model$termeVoulu = F2(
	function (options, terme) {
		var genre = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.M;
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (sujet) {
						return _Utils_eq(sujet.vx, terme.I9);
					},
					options.Ja)));
		var _v0 = _Utils_Tuple2(
			genre,
			$elm$core$String$trim(terme.fm));
		if (_v0.a.$ === 1) {
			var _v1 = _v0.a;
			return $elm$core$Maybe$Nothing;
		} else {
			return $author$project$Components$Parametrage$PipeEtape2$Model$sansValeur(terme.vP) ? $elm$core$Maybe$Just(
				{vP: terme.vP, wg: $elm$core$Maybe$Nothing, I9: terme.I9, fm: $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$Nul}) : A3(
				$author$project$Components$Parametrage$PipeEtape2$Model$termeAvecValeur,
				terme,
				genre,
				$elm$core$String$trim(terme.fm));
		}
	});
var $author$project$Components$Parametrage$PipeEtape2$Model$termesVoulus = F2(
	function (options, saisie) {
		return (saisie.n9 !== 'si') ? $elm$core$Maybe$Just(_List_Nil) : ($elm$core$List$isEmpty(saisie.rD) ? $elm$core$Maybe$Nothing : A3(
			$elm$core$List$foldr,
			$elm$core$Maybe$map2($elm$core$List$cons),
			$elm$core$Maybe$Just(_List_Nil),
			A2(
				$elm$core$List$map,
				$author$project$Components$Parametrage$PipeEtape2$Model$termeVoulu(options),
				saisie.rD)));
	});
var $author$project$Components$Parametrage$PipeEtape2$Model$passageVoulu = F2(
	function (options, saisie) {
		return A2(
			$elm$core$Maybe$andThen,
			function (voulu) {
				return ((saisie.wC === '') || (saisie.sn === '')) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(voulu);
			},
			A3(
				$elm$core$Maybe$map2,
				F2(
					function (termes, declenchement) {
						return {
							kt: saisie.wC,
							kw: declenchement,
							Bk: saisie.Bk,
							Bl: $author$project$Components$Parametrage$PipeEtape2$Model$libellesFacultatifs(saisie.Bl),
							n9: saisie.n9,
							rD: termes,
							so: saisie.sn
						};
					}),
				A2($author$project$Components$Parametrage$PipeEtape2$Model$termesVoulus, options, saisie),
				$author$project$Components$Parametrage$PipeEtape2$Model$declenchementVoulu(saisie)));
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$Envoyer = F4(
	function (a, b, c, d) {
		return {$: 1, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$avecLePipe = F2(
	function (pipeUid, effet) {
		if (effet.$ === 1) {
			var lien = effet.a;
			var processUid = effet.b;
			var commande = effet.d;
			return A4($author$project$Components$Parametrage$PipeEtape2$Update$Envoyer, lien, processUid, pipeUid, commande);
		} else {
			var autre = effet;
			return autre;
		}
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$Reconnecter = {$: 4};
var $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$ReponseDeCommande = function (vuesAJour) {
	return {sy: vuesAJour};
};
var $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$reponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$ReponseDeCommande,
	A2($elm$json$Json$Decode$field, 'vuesAJour', $elm$json$Json$Decode$bool));
var $author$project$Components$Parametrage$PipeEtape2$Update$reglage = {
	f8: $author$project$Components$Parametrage$PipeEtape2$Update$DemanderProcessUid,
	l4: F3(
		function (lien, processUid, commande) {
			return A4($author$project$Components$Parametrage$PipeEtape2$Update$Envoyer, lien, processUid, '', commande);
		}),
	go: $elm$core$Basics$identity,
	pW: $author$project$Components$Parametrage$PipeEtape2$Update$Reconnecter,
	qu: F2(
		function (_v0, _v1) {
			return true;
		}),
	qv: $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$reponseDecoder
};
var $author$project$Components$Parametrage$PipeEtape2$Update$envoyer = F3(
	function (lien, commande, model) {
		var _v0 = A4($author$project$API$Envoi$partir, $author$project$Components$Parametrage$PipeEtape2$Update$reglage, lien, commande, model.l2);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var envoi = _v1.a;
			var effets = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi, pZ: $elm$core$Maybe$Nothing}),
				A2(
					$elm$core$List$map,
					$author$project$Components$Parametrage$PipeEtape2$Update$avecLePipe(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.r8;
								},
								model.ge))),
					effets));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$versLApi = F3(
	function (lien, model, commande) {
		if (!commande.$) {
			var voulue = commande.a;
			return A3($author$project$Components$Parametrage$PipeEtape2$Update$envoyer, lien, voulue, model);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$enregistrer = function (model) {
	var _v0 = model.mW;
	_v0$2:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a.$) {
				case 0:
					var saisie = _v0.a.a;
					var _v1 = saisie.r8;
					if (_v1.$ === 1) {
						return A3(
							$author$project$Components$Parametrage$PipeEtape2$Update$versLApi,
							A2($author$project$Components$Parametrage$PipeEtape2$Update$lienDuParcours, $author$project$API$NavLinksDictionary$ajouterUneEtape, model),
							model,
							A2(
								$elm$core$Maybe$map,
								$author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$AjouterUneEtape,
								$author$project$Components$Parametrage$PipeEtape2$Model$etapeVoulue(saisie)));
					} else {
						var uid = _v1.a;
						return A3(
							$author$project$Components$Parametrage$PipeEtape2$Update$versLApi,
							A2(
								$elm$core$Maybe$andThen,
								function (etape) {
									return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierUneEtape, etape.nQ);
								},
								model.me),
							model,
							A2(
								$elm$core$Maybe$map,
								$author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$ModifierUneEtape(uid),
								$author$project$Components$Parametrage$PipeEtape2$Model$etapeVoulue(saisie)));
					}
				case 1:
					var saisie = _v0.a.a;
					var voulu = A2(
						$elm$core$Maybe$andThen,
						function (options) {
							return A2($author$project$Components$Parametrage$PipeEtape2$Model$passageVoulu, options, saisie);
						},
						model.o_);
					var _v2 = saisie.r8;
					if (_v2.$ === 1) {
						return A3(
							$author$project$Components$Parametrage$PipeEtape2$Update$versLApi,
							A2($author$project$Components$Parametrage$PipeEtape2$Update$lienDuParcours, $author$project$API$NavLinksDictionary$ajouterUnPassage, model),
							model,
							A2($elm$core$Maybe$map, $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$AjouterUnPassage, voulu));
					} else {
						var uid = _v2.a;
						return A3(
							$author$project$Components$Parametrage$PipeEtape2$Update$versLApi,
							A2(
								$elm$core$Maybe$andThen,
								function (passage) {
									return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierUnPassage, passage.nQ);
								},
								model.aH),
							model,
							A2(
								$elm$core$Maybe$map,
								$author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$ModifierUnPassage(uid),
								voulu));
					}
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return _Utils_Tuple2(model, _List_Nil);
};
var $author$project$Components$Parametrage$PipeEtape2$Model$etapeNeuve = function (options) {
	return {
		uy: $elm$core$Dict$empty,
		w2: '',
		mK: false,
		R: $elm$core$Dict$empty,
		pc: _List_Nil,
		pr: $elm$core$Dict$empty,
		ps: true,
		HW: A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(options.qG)),
		qG: options.qG,
		r8: $elm$core$Maybe$Nothing
	};
};
var $author$project$Components$Parametrage$PipeEtape2$Update$lectureDeLEtape = F2(
	function (uid, parcours) {
		return A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.np;
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (etape) {
						return _Utils_eq(etape.r8, uid);
					},
					parcours.yL)));
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$lectureDuPassage = F2(
	function (uid, parcours) {
		return A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.np;
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (passage) {
						return _Utils_eq(passage.r8, uid);
					},
					parcours.E5)));
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$lireSi = F2(
	function (lecture, lien) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$Parametrage$PipeEtape2$Update$Lire(lecture),
					lien)));
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$Edition = 2;
var $author$project$Components$Parametrage$PipeEtape2$Update$LeParcours = 3;
var $author$project$Components$Parametrage$PipeEtape2$Update$LesOptions = 4;
var $author$project$Components$Parametrage$PipeEtape2$Update$Racine = 1;
var $author$project$API$NavLinksDictionary$etapesDuPipe = 'etapes';
var $author$project$API$NavLinksDictionary$optionsDuParcours = 'options';
var $author$project$Components$Parametrage$PipeEtape2$Update$PlacerFocus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$PipeEtape2$Update$declencheurDe = F2(
	function (declencheur, geste) {
		var _v0 = _Utils_Tuple2(
			geste,
			A2($elm$core$String$endsWith, '-', declencheur));
		if (_v0.b) {
			switch (_v0.a.$) {
				case 0:
					var uid = _v0.a.a.r8;
					return _Utils_ap(
						declencheur,
						A2($elm$core$Maybe$withDefault, '', uid));
				case 1:
					var uid = _v0.a.a.r8;
					return _Utils_ap(
						declencheur,
						A2($elm$core$Maybe$withDefault, '', uid));
				case 2:
					var uid = _v0.a.a.r8;
					return _Utils_ap(
						declencheur,
						A2($elm$core$Maybe$withDefault, '', uid));
				default:
					var uid = _v0.a.a.r8;
					return _Utils_ap(
						declencheur,
						A2($elm$core$Maybe$withDefault, '', uid));
			}
		} else {
			return declencheur;
		}
	});
var $author$project$Components$Parametrage$PipeEtape2$Model$idDuDeclencheur = function (nom) {
	return 'pipe-etape-2-' + nom;
};
var $author$project$Components$Parametrage$PipeEtape2$Model$idDuDrawer = function (nom) {
	return 'pipe-etape-2-' + nom;
};
var $author$project$Components$Parametrage$PipeEtape2$Update$ouvrir = F3(
	function (declencheur, geste, model) {
		if ($author$project$API$Envoi$enCours(model.l2)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var nom = function () {
				switch (geste.$) {
					case 0:
						return 'etape';
					case 1:
						return 'passage';
					case 2:
						return 'etape';
					default:
						return 'passage';
				}
			}();
			var _v0 = A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				$author$project$Components$Shared$Drawer$Update$Ouvrir(
					$author$project$Components$Parametrage$PipeEtape2$Model$idDuDeclencheur(
						A2($author$project$Components$Parametrage$PipeEtape2$Update$declencheurDe, declencheur, geste))),
				$author$project$Components$Shared$Drawer$Model$init(
					$author$project$Components$Parametrage$PipeEtape2$Model$idDuDrawer(nom)));
			var drawer = _v0.a;
			var effets = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						kX: drawer,
						mW: $elm$core$Maybe$Just(geste),
						pZ: $elm$core$Maybe$Nothing,
						rP: $elm$core$Maybe$Nothing
					}),
				A2(
					$elm$core$List$map,
					function (_v1) {
						var cible = _v1;
						return $author$project$Components$Parametrage$PipeEtape2$Update$PlacerFocus(cible);
					},
					effets));
		}
	});
var $author$project$Components$Parametrage$PipeEtape2$Model$saisieDeLEtape = function (etape) {
	return {
		uy: etape.uy,
		w2: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Maybe$map, $elm$core$String$fromInt, etape.kB)),
		mK: !_Utils_eq(etape.mK, $elm$core$Maybe$Nothing),
		R: etape.R,
		pc: etape.pc,
		pr: etape.FY.R,
		ps: etape.FY.KR,
		HW: A2(
			$elm$core$Maybe$withDefault,
			A2(
				$elm$core$Maybe$withDefault,
				'',
				$elm$core$List$head(etape.qG)),
			etape.mK),
		qG: etape.qG,
		r8: $elm$core$Maybe$Just(etape.r8)
	};
};
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$codeDeLaLiaison = function (liaison) {
	if (!liaison) {
		return 'et';
	} else {
		return 'ou';
	}
};
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$codeDuMode = function (mode) {
	switch (mode) {
		case 0:
			return 'toujours';
		case 1:
			return 'si';
		default:
			return 'sinon';
	}
};
var $author$project$Components$Parametrage$PipeEtape2$Model$saisieDuPassage = function (passage) {
	var base = {
		cf: '',
		wC: passage.wC.r8,
		kw: 'automatique',
		ni: '',
		Bk: $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$codeDeLaLiaison(passage.j4.Bk),
		Bl: passage.Bl,
		n9: $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$codeDuMode(passage.j4.n9),
		H6: '',
		rD: A2(
			$elm$core$List$map,
			function (terme) {
				return {
					vP: terme.vP,
					wg: A2($elm$core$Maybe$withDefault, '', terme.wg),
					I9: terme.I9,
					fm: terme.fm
				};
			},
			passage.j4.rD),
		r8: $elm$core$Maybe$Just(passage.r8),
		sn: passage.sn.r8
	};
	var _v0 = passage.kw;
	switch (_v0.$) {
		case 0:
			return base;
		case 1:
			var roleUid = _v0.a;
			return _Utils_update(
				base,
				{kw: 'par-un-role', H6: roleUid});
		case 2:
			var jours = _v0.a;
			return _Utils_update(
				base,
				{
					kw: 'calcule-sla',
					ni: $elm$core$String$fromInt(jours)
				});
		default:
			var actionUid = _v0.a;
			return _Utils_update(
				base,
				{cf: actionUid, kw: 'par-le-regroupement'});
	}
};
var $author$project$Components$Parametrage$PipeEtape2$Update$sous = F4(
	function (decodeur, reponse, model, suite) {
		var _v0 = A2($author$project$API$Reponse$lire, decodeur, reponse);
		if (!_v0.$) {
			var lue = _v0.a;
			return suite(lue);
		} else {
			var refus = _v0.a;
			return (refus.ri === 401) ? _Utils_Tuple2(
				model,
				_List_fromArray(
					[$author$project$Components$Parametrage$PipeEtape2$Update$Reconnecter])) : _Utils_Tuple2(
				_Utils_update(
					model,
					{nf: model.nf || (refus.ri === 404)}),
				_List_Nil);
		}
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$lu = F3(
	function (lecture, reponse, model) {
		switch (lecture) {
			case 0:
				return A4(
					$author$project$Components$Parametrage$PipeEtape2$Update$sous,
					A4(
						$elm$json$Json$Decode$map3,
						F3(
							function (a, b, c) {
								return _Utils_Tuple3(a, b, c);
							}),
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$annuaireDecoder,
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$lienDuPipeDecoder(model.vx)),
					reponse,
					model,
					function (_v1) {
						var pipes = _v1.a;
						var liens = _v1.b;
						var visee = _v1.c;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									aS: $elm$core$Maybe$Just(pipes),
									nf: _Utils_eq(visee, $elm$core$Maybe$Nothing),
									nR: liens
								}),
							A2($author$project$Components$Parametrage$PipeEtape2$Update$lireSi, 1, visee));
					});
			case 1:
				return A4(
					$author$project$Components$Parametrage$PipeEtape2$Update$sous,
					$author$project$Components$Parametrage$Common$API$QueryAPIModel$racineDuPipeDecoder,
					reponse,
					model,
					function (edition) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									nf: _Utils_eq(edition, $elm$core$Maybe$Nothing)
								}),
							A2($author$project$Components$Parametrage$PipeEtape2$Update$lireSi, 2, edition));
					});
			case 2:
				return A4(
					$author$project$Components$Parametrage$PipeEtape2$Update$sous,
					$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$editionDecoder,
					reponse,
					model,
					function (edition) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									ge: $elm$core$Maybe$Just(edition)
								}),
							A2(
								$author$project$Components$Parametrage$PipeEtape2$Update$lireSi,
								3,
								A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$etapesDuPipe, edition.nQ)));
					});
			case 3:
				return A4(
					$author$project$Components$Parametrage$PipeEtape2$Update$sous,
					$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$parcoursDecoder,
					reponse,
					model,
					function (parcours) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									ex: $elm$core$Maybe$Just(parcours)
								}),
							A2(
								$author$project$Components$Parametrage$PipeEtape2$Update$lireSi,
								4,
								A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$optionsDuParcours, parcours.nQ)));
					});
			case 4:
				return A4(
					$author$project$Components$Parametrage$PipeEtape2$Update$sous,
					$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$optionsDecoder,
					reponse,
					model,
					function (options) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									o_: $elm$core$Maybe$Just(options)
								}),
							_List_Nil);
					});
			case 5:
				return A4(
					$author$project$Components$Parametrage$PipeEtape2$Update$sous,
					$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$etapeDecoder,
					reponse,
					model,
					function (etape) {
						return A3(
							$author$project$Components$Parametrage$PipeEtape2$Update$ouvrir,
							'etape-',
							$author$project$Components$Parametrage$PipeEtape2$Model$EtapeEnSaisie(
								$author$project$Components$Parametrage$PipeEtape2$Model$saisieDeLEtape(etape)),
							_Utils_update(
								model,
								{
									me: $elm$core$Maybe$Just(etape)
								}));
					});
			default:
				return A4(
					$author$project$Components$Parametrage$PipeEtape2$Update$sous,
					$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$passageDecoder,
					reponse,
					model,
					function (passage) {
						return A3(
							$author$project$Components$Parametrage$PipeEtape2$Update$ouvrir,
							'passage-',
							$author$project$Components$Parametrage$PipeEtape2$Model$PassageEnSaisie(
								$author$project$Components$Parametrage$PipeEtape2$Model$saisieDuPassage(passage)),
							_Utils_update(
								model,
								{
									o_: $elm$core$Maybe$Just(passage.o_),
									aH: $elm$core$Maybe$Just(passage)
								}));
					});
		}
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$modifierLeTerme = F4(
	function (position, champ, texte, saisie) {
		var modifie = F2(
			function (index, terme) {
				if (!_Utils_eq(index, position)) {
					return terme;
				} else {
					switch (champ) {
						case 0:
							return _Utils_update(
								terme,
								{wg: '', I9: texte, fm: ''});
						case 1:
							return _Utils_update(
								terme,
								{vP: texte});
						case 2:
							return _Utils_update(
								terme,
								{fm: texte});
						default:
							return _Utils_update(
								terme,
								{wg: texte, fm: ''});
					}
				}
			});
		return _Utils_update(
			saisie,
			{
				rD: A2($elm$core$List$indexedMap, modifie, saisie.rD)
			});
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$parcoursDe = function (model) {
	return model.ex;
};
var $author$project$Components$Parametrage$PipeEtape2$Model$termeNeuf = function (options) {
	return {
		vP: A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(options.vQ)),
		wg: '',
		I9: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.vx;
				},
				$elm$core$List$head(options.Ja))),
		fm: ''
	};
};
var $author$project$Components$Parametrage$PipeEtape2$Model$passageNeuf = F2(
	function (options, de) {
		return {
			cf: '',
			wC: de,
			kw: 'automatique',
			ni: '',
			Bk: 'et',
			Bl: $elm$core$Dict$empty,
			n9: 'toujours',
			H6: '',
			rD: _List_fromArray(
				[
					$author$project$Components$Parametrage$PipeEtape2$Model$termeNeuf(options)
				]),
			r8: $elm$core$Maybe$Nothing,
			sn: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.r8;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (etape) {
								return !_Utils_eq(etape.r8, de);
							},
							options.yL))))
		};
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$recharger = function (model) {
	var _v0 = A3(
		$author$project$Components$Shared$Drawer$Update$update,
		{Il: false},
		$author$project$Components$Shared$Drawer$Update$Fermer,
		model.kX);
	var drawer = _v0.a;
	var deDrawer = _v0.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{kX: drawer, mW: $elm$core$Maybe$Nothing, pZ: $elm$core$Maybe$Nothing, rP: $elm$core$Maybe$Nothing, sr: false}),
		_Utils_ap(
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Parametrage$PipeEtape2$Update$PlacerFocus(cible);
				},
				deDrawer),
			A2(
				$author$project$Components$Parametrage$PipeEtape2$Update$lireSi,
				3,
				A2($author$project$Components$Parametrage$PipeEtape2$Update$lienDuParcours, $author$project$API$NavLinksDictionary$self, model))));
};
var $author$project$Components$Parametrage$Common$RefusDuParcours$nom = function (detail) {
	switch (detail.$) {
		case 1:
			var cas = detail.a;
			return $elm$core$Maybe$Just(cas);
		case 2:
			var cas = detail.a;
			return $elm$core$Maybe$Just(cas);
		case 3:
			var cas = detail.a;
			return $elm$core$Maybe$Just(cas);
		case 4:
			var cas = detail.a;
			return $elm$core$Maybe$Just(cas);
		case 5:
			var cas = detail.a;
			return $elm$core$Maybe$Just(cas);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$I18n$Textes$pipeParcoursRefusConditionVide = A3($author$project$I18n$Traductions$texte, 'pipe-parcours.refus.condition-vide', _List_Nil, 'La condition « Si » n\'a aucun terme. Ajoutez-en un, ou choisissez « Toujours ». Rien n\'est enregistré.');
var $author$project$I18n$Textes$pipeParcoursRefusDelaiInvalide = A3($author$project$I18n$Traductions$texte, 'pipe-parcours.refus.delai-invalide', _List_Nil, 'Le délai doit être un entier positif.');
var $author$project$I18n$Textes$pipeParcoursRefusFormuleInvalide = A3($author$project$I18n$Traductions$texte, 'pipe-parcours.refus.formule-invalide', _List_Nil, 'La condition ne peut pas se lire telle qu\'elle est composée. Corrigez-la. Rien n\'est enregistré.');
var $author$project$I18n$Textes$pipeParcoursRefusJoursInvalides = A3($author$project$I18n$Traductions$texte, 'pipe-parcours.refus.jours-invalides', _List_Nil, 'Le nombre de jours doit être un entier positif.');
var $author$project$I18n$Textes$pipeParcoursRefusLibelleParDefautRequis = A3($author$project$I18n$Traductions$texte, 'pipe-parcours.refus.libelle-par-defaut-requis', _List_Nil, 'Le nom doit être donné en français.');
var $author$project$I18n$Textes$pipeParcoursRefusNomDEtapeDejaPris = A3($author$project$I18n$Traductions$texte, 'pipe-parcours.refus.nom-d-etape-deja-pris', _List_Nil, 'Ce nom est déjà pris par une autre étape du pipe. Choisissez un autre nom.');
var $author$project$I18n$Textes$pipeParcoursRefusNomDeRoleDejaPris = A3($author$project$I18n$Traductions$texte, 'pipe-parcours.refus.nom-de-role-deja-pris', _List_Nil, 'Ce nom est déjà pris par un autre rôle du pipe. Choisissez un autre nom.');
var $author$project$I18n$Textes$pipeParcoursRefusPassageParDefautDejaPresent = A3($author$project$I18n$Traductions$texte, 'pipe-parcours.refus.passage-par-defaut-deja-present', _List_Nil, 'Cette étape a déjà un passage par défaut (« Sinon »). Une étape n\'en a qu\'un : modifiez-le, ou donnez une condition à celui-ci.');
var $author$project$I18n$Textes$pipeParcoursRefusRoleDeLObjetViseNonRetirable = A3($author$project$I18n$Traductions$texte, 'pipe-parcours.refus.role-de-l-objet-vise-non-retirable', _List_Nil, 'Le rôle de l\'objet visé est créé avec lui : il ne peut pas être retiré, seul son libellé se modifie.');
var $author$project$I18n$Textes$pipeParcoursRefusRoleUtiliseParUnPassage = A3($author$project$I18n$Traductions$texte, 'pipe-parcours.refus.role-utilise-par-un-passage', _List_Nil, 'Ce rôle déclenche un passage du parcours : changez le déclenchement de ce passage, puis retirez le rôle. Rien n\'est retiré.');
var $author$project$I18n$Textes$pipeParcoursRefusRoleUtiliseParUnPassageNomme = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'pipe-parcours.refus.role-utilise-par-un-passage-nomme',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'origine',
				$author$project$I18n$Traductions$Sous(p.o4)),
				_Utils_Tuple2(
				'vers',
				$author$project$I18n$Traductions$Sous(p.sn))
			]),
		'Ce rôle déclenche le passage de « {origine} » vers « {vers} » : changez le déclenchement de ce passage, puis retirez le rôle. Rien n\'est retiré.');
};
var $author$project$I18n$Textes$pipeParcoursRefusSujetDeConditionInconnu = A3($author$project$I18n$Traductions$texte, 'pipe-parcours.refus.sujet-de-condition-inconnu', _List_Nil, 'Ce que la condition compare n\'existe pas. Choisissez-en un autre. Rien n\'est enregistré.');
var $author$project$I18n$Textes$pipeParcoursRefusValeurDeConditionInvalide = A3($author$project$I18n$Traductions$texte, 'pipe-parcours.refus.valeur-de-condition-invalide', _List_Nil, 'La valeur comparée ne convient pas à ce que la condition compare. Corrigez-la. Rien n\'est enregistré.');
var $author$project$I18n$Textes$pipeParcoursRefusVersionNonModifiable = A3($author$project$I18n$Traductions$texte, 'pipe-parcours.refus.version-non-modifiable', _List_Nil, 'Ce pipe n\'a plus de brouillon modifiable : rechargez pour voir son état.');
var $author$project$Components$Parametrage$Common$RefusDuParcours$dit = function (refus) {
	var texte = function (cle) {
		return {Jx: cle, b9: refus.b9};
	};
	var _v0 = $author$project$Components$Parametrage$Common$RefusDuParcours$nom(refus.bB);
	_v0$13:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'NomDEtapeDejaPris':
					return texte($author$project$I18n$Textes$pipeParcoursRefusNomDEtapeDejaPris);
				case 'PassageParDefautDejaPresent':
					return texte($author$project$I18n$Textes$pipeParcoursRefusPassageParDefautDejaPresent);
				case 'NomDeRoleDejaPris':
					return texte($author$project$I18n$Textes$pipeParcoursRefusNomDeRoleDejaPris);
				case 'VersionNonModifiable':
					return texte($author$project$I18n$Textes$pipeParcoursRefusVersionNonModifiable);
				case 'ConditionVide':
					return texte($author$project$I18n$Textes$pipeParcoursRefusConditionVide);
				case 'SujetDeConditionInconnu':
					return texte($author$project$I18n$Textes$pipeParcoursRefusSujetDeConditionInconnu);
				case 'ValeurDeConditionInvalide':
					return texte($author$project$I18n$Textes$pipeParcoursRefusValeurDeConditionInvalide);
				case 'FormuleInvalide':
					return texte($author$project$I18n$Textes$pipeParcoursRefusFormuleInvalide);
				case 'JoursInvalides':
					return texte($author$project$I18n$Textes$pipeParcoursRefusJoursInvalides);
				case 'LibelleParDefautRequis':
					return texte($author$project$I18n$Textes$pipeParcoursRefusLibelleParDefautRequis);
				case 'DelaiInvalide':
					return texte($author$project$I18n$Textes$pipeParcoursRefusDelaiInvalide);
				case 'RoleUtiliseParUnPassage':
					var _v1 = refus.bB;
					if ((_v1.$ === 5) && _v1.b.b) {
						var _v2 = _v1.b;
						var _v3 = _v2.a;
						var de = _v3.a;
						var vers = _v3.b;
						return texte(
							$author$project$I18n$Textes$pipeParcoursRefusRoleUtiliseParUnPassageNomme(
								{
									o4: $author$project$I18n$Traductions$tel(de),
									sn: $author$project$I18n$Traductions$tel(vers)
								}));
					} else {
						return texte($author$project$I18n$Textes$pipeParcoursRefusRoleUtiliseParUnPassage);
					}
				case 'RoleDeLObjetViseNonRetirable':
					return texte($author$project$I18n$Textes$pipeParcoursRefusRoleDeLObjetViseNonRetirable);
				default:
					break _v0$13;
			}
		} else {
			break _v0$13;
		}
	}
	return $author$project$Components$Shared$Messages$Model$duRefus(refus);
};
var $author$project$Components$Parametrage$Common$RefusDuParcours$estVersionFigee = function (refus) {
	return _Utils_eq(
		$author$project$Components$Parametrage$Common$RefusDuParcours$nom(refus.bB),
		$elm$core$Maybe$Just('VersionNonModifiable'));
};
var $author$project$Components$Parametrage$PipeEtape2$Update$repondue = F2(
	function (reponse, model) {
		var _v0 = A3($author$project$API$Envoi$conclure, $author$project$Components$Parametrage$PipeEtape2$Update$reglage, reponse, model.l2);
		if (!_v0.$) {
			switch (_v0.a.b.$) {
				case 0:
					var _v1 = _v0.a;
					var envoi = _v1.a;
					var _v2 = _v1.b;
					var effets = _v1.c;
					var _v3 = A3(
						$author$project$Components$Shared$Drawer$Update$update,
						{Il: false},
						$author$project$Components$Shared$Drawer$Update$Fermer,
						model.kX);
					var drawer = _v3.a;
					var deDrawer = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{kX: drawer, l2: envoi, mW: $elm$core$Maybe$Nothing, pZ: $elm$core$Maybe$Nothing, rP: $elm$core$Maybe$Nothing, sr: false}),
						_Utils_ap(
							effets,
							_Utils_ap(
								A2(
									$elm$core$List$map,
									function (_v4) {
										var cible = _v4;
										return $author$project$Components$Parametrage$PipeEtape2$Update$PlacerFocus(cible);
									},
									deDrawer),
								A2(
									$author$project$Components$Parametrage$PipeEtape2$Update$lireSi,
									3,
									A2($author$project$Components$Parametrage$PipeEtape2$Update$lienDuParcours, $author$project$API$NavLinksDictionary$self, model)))));
				case 1:
					var _v5 = _v0.a;
					var envoi = _v5.a;
					var _v6 = _v5.b;
					var refus = _v6.b;
					var effets = _v5.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l2: envoi,
								pZ: $elm$core$Maybe$Just(
									$author$project$Components$Parametrage$Common$RefusDuParcours$dit(refus)),
								sr: $author$project$Components$Parametrage$Common$RefusDuParcours$estVersionFigee(refus)
							}),
						effets);
				default:
					var _v7 = _v0.a;
					var envoi = _v7.a;
					var _v8 = _v7.b;
					var effets = _v7.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{l2: envoi}),
						effets);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$RetirerUnPassage = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$RetirerUneEtape = function (a) {
	return {$: 4, a: a};
};
var $author$project$API$NavLinksDictionary$retirerUnPassage = 'retirer-un-passage';
var $author$project$API$NavLinksDictionary$retirerUneEtape = 'retirer-une-etape';
var $author$project$Components$Parametrage$PipeEtape2$Update$retirer = function (model) {
	var _v0 = model.mW;
	_v0$2:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a.$) {
				case 2:
					var uid = _v0.a.a.r8;
					return A3(
						$author$project$Components$Parametrage$PipeEtape2$Update$versLApi,
						A2(
							$elm$core$Maybe$andThen,
							function (etape) {
								return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerUneEtape, etape.nQ);
							},
							model.me),
						model,
						A2($elm$core$Maybe$map, $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$RetirerUneEtape, uid));
				case 3:
					var uid = _v0.a.a.r8;
					return A3(
						$author$project$Components$Parametrage$PipeEtape2$Update$versLApi,
						A2(
							$elm$core$Maybe$andThen,
							function (passage) {
								return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerUnPassage, passage.nQ);
							},
							model.aH),
						model,
						A2($elm$core$Maybe$map, $author$project$Components$Parametrage$PipeEtape2$API$WriteAPIModel$RetirerUnPassage, uid));
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return _Utils_Tuple2(model, _List_Nil);
};
var $author$project$Components$Parametrage$PipeEtape2$Update$retirerUnTerme = F2(
	function (position, saisie) {
		return _Utils_update(
			saisie,
			{
				rD: A2(
					$elm$core$List$map,
					$elm$core$Tuple$second,
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var i = _v0.a;
							return !_Utils_eq(i, position);
						},
						A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, saisie.rD)))
			});
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$saisirLeLibelle = F4(
	function (champ, langue, texte, saisie) {
		switch (champ) {
			case 0:
				return _Utils_update(
					saisie,
					{
						R: A3($elm$core$Dict$insert, langue, texte, saisie.R)
					});
			case 1:
				return _Utils_update(
					saisie,
					{
						uy: A3($elm$core$Dict$insert, langue, texte, saisie.uy)
					});
			case 2:
				return _Utils_update(
					saisie,
					{
						pr: A3($elm$core$Dict$insert, langue, texte, saisie.pr)
					});
			default:
				return saisie;
		}
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$saisirLeNom = F3(
	function (champ, texte, saisie) {
		if (champ === 3) {
			return _Utils_update(
				saisie,
				{
					Bl: A3($elm$core$Dict$insert, 'fr', texte, saisie.Bl)
				});
		} else {
			return saisie;
		}
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$surLEtape = F2(
	function (f, model) {
		var _v0 = model.mW;
		if ((!_v0.$) && (!_v0.a.$)) {
			var saisie = _v0.a.a;
			return _Utils_update(
				model,
				{
					mW: $elm$core$Maybe$Just(
						$author$project$Components$Parametrage$PipeEtape2$Model$EtapeEnSaisie(
							f(saisie)))
				});
		} else {
			return model;
		}
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$surLePassage = F2(
	function (f, model) {
		var _v0 = model.mW;
		if ((!_v0.$) && (_v0.a.$ === 1)) {
			var saisie = _v0.a.a;
			return _Utils_update(
				model,
				{
					mW: $elm$core$Maybe$Just(
						$author$project$Components$Parametrage$PipeEtape2$Model$PassageEnSaisie(
							f(saisie)))
				});
		} else {
			return model;
		}
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$sortiesDuDrawer = _List_fromArray(
	[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$SortieDemandee, $author$project$Components$Shared$Drawer$Update$AbandonConfirme]);
var $author$project$Components$Parametrage$PipeEtape2$Update$versLeDrawer = F2(
	function (geste, model) {
		if ($author$project$API$Envoi$enCours(model.l2) && A2($elm$core$List$member, geste, $author$project$Components$Parametrage$PipeEtape2$Update$sortiesDuDrawer)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v0 = A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.kX);
			var drawer = _v0.a;
			var effets = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						kX: drawer,
						mW: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? model.mW : $elm$core$Maybe$Nothing,
						rP: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? model.rP : $elm$core$Maybe$Nothing
					}),
				A2(
					$elm$core$List$map,
					function (_v1) {
						var cible = _v1;
						return $author$project$Components$Parametrage$PipeEtape2$Update$PlacerFocus(cible);
					},
					effets));
		}
	});
var $author$project$Components$Parametrage$PipeEtape2$Model$EtapeARetirer = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$PipeEtape2$Model$PassageARetirer = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$PipeEtape2$Update$versLeRetrait = function (model) {
	var _v0 = model.mW;
	_v0$2:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a.$) {
				case 0:
					var saisie = _v0.a.a;
					return _Utils_update(
						model,
						{
							mW: $elm$core$Maybe$Just(
								$author$project$Components$Parametrage$PipeEtape2$Model$EtapeARetirer(saisie)),
							pZ: $elm$core$Maybe$Nothing
						});
				case 1:
					var saisie = _v0.a.a;
					return _Utils_update(
						model,
						{
							mW: $elm$core$Maybe$Just(
								$author$project$Components$Parametrage$PipeEtape2$Model$PassageARetirer(saisie)),
							pZ: $elm$core$Maybe$Nothing
						});
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return model;
};
var $author$project$Components$Parametrage$PipeEtape2$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var code = msg.a;
				var liens = msg.b;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$pipes, liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						$author$project$Components$Parametrage$PipeEtape2$Model$init(code),
						_List_fromArray(
							[
								$author$project$Components$Parametrage$PipeEtape2$Update$DemanderProcessUid,
								A2($author$project$Components$Parametrage$PipeEtape2$Update$Lire, 0, lecture)
							]));
				} else {
					return _Utils_Tuple2(
						$author$project$Components$Parametrage$PipeEtape2$Model$init(code),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 2:
				var lecture = msg.a;
				var reponse = msg.b;
				return A3($author$project$Components$Parametrage$PipeEtape2$Update$lu, lecture, reponse, model);
			case 3:
				var reponse = msg.a;
				return A2($author$project$Components$Parametrage$PipeEtape2$Update$repondue, reponse, model);
			case 4:
				var geste = msg.a;
				return A2($author$project$Components$Parametrage$PipeEtape2$Update$versLeDrawer, geste, model);
			case 5:
				var uid = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$Components$Parametrage$PipeEtape2$Update$lireSi,
						5,
						A2(
							$elm$core$Maybe$andThen,
							function (parcours) {
								return A2($author$project$Components$Parametrage$PipeEtape2$Update$lectureDeLEtape, uid, parcours);
							},
							$author$project$Components$Parametrage$PipeEtape2$Update$parcoursDe(model))));
			case 6:
				var _v2 = _Utils_Tuple2(
					A2($author$project$Components$Parametrage$PipeEtape2$Update$lienDuParcours, $author$project$API$NavLinksDictionary$ajouterUneEtape, model),
					model.o_);
				if ((!_v2.a.$) && (!_v2.b.$)) {
					var options = _v2.b.a;
					return A3(
						$author$project$Components$Parametrage$PipeEtape2$Update$ouvrir,
						'etape-ajout',
						$author$project$Components$Parametrage$PipeEtape2$Model$EtapeEnSaisie(
							$author$project$Components$Parametrage$PipeEtape2$Model$etapeNeuve(options)),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 7:
				var uid = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$Components$Parametrage$PipeEtape2$Update$lireSi,
						6,
						A2(
							$elm$core$Maybe$andThen,
							function (parcours) {
								return A2($author$project$Components$Parametrage$PipeEtape2$Update$lectureDuPassage, uid, parcours);
							},
							$author$project$Components$Parametrage$PipeEtape2$Update$parcoursDe(model))));
			case 8:
				var de = msg.a;
				var _v3 = _Utils_Tuple2(
					A2($author$project$Components$Parametrage$PipeEtape2$Update$lienDuParcours, $author$project$API$NavLinksDictionary$ajouterUnPassage, model),
					model.o_);
				if ((!_v3.a.$) && (!_v3.b.$)) {
					var options = _v3.b.a;
					return A3(
						$author$project$Components$Parametrage$PipeEtape2$Update$ouvrir,
						'passage-ajout',
						$author$project$Components$Parametrage$PipeEtape2$Model$PassageEnSaisie(
							A2($author$project$Components$Parametrage$PipeEtape2$Model$passageNeuf, options, de)),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 9:
				var champ = msg.a;
				var langue = msg.b;
				var texte = msg.c;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape2$Update$surLePassage,
						A2($author$project$Components$Parametrage$PipeEtape2$Update$saisirLeNom, champ, texte),
						A2(
							$author$project$Components$Parametrage$PipeEtape2$Update$surLEtape,
							A3($author$project$Components$Parametrage$PipeEtape2$Update$saisirLeLibelle, champ, langue, texte),
							model)),
					_List_Nil);
			case 11:
				var champ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							rP: $elm$core$Maybe$Just(champ)
						}),
					_List_Nil);
			case 12:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{rP: $elm$core$Maybe$Nothing}),
					_List_Nil);
			case 10:
				var texte = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape2$Update$surLEtape,
						function (saisie) {
							return _Utils_update(
								saisie,
								{w2: texte});
						},
						model),
					_List_Nil);
			case 13:
				var visible = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape2$Update$surLEtape,
						function (saisie) {
							return _Utils_update(
								saisie,
								{ps: visible});
						},
						model),
					_List_Nil);
			case 14:
				var finale = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape2$Update$surLEtape,
						function (saisie) {
							return _Utils_update(
								saisie,
								{mK: finale});
						},
						model),
					_List_Nil);
			case 15:
				var resultat = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape2$Update$surLEtape,
						function (saisie) {
							return _Utils_update(
								saisie,
								{HW: resultat});
						},
						model),
					_List_Nil);
			case 16:
				var uid = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape2$Update$surLePassage,
						function (saisie) {
							return _Utils_update(
								saisie,
								{wC: uid});
						},
						model),
					_List_Nil);
			case 17:
				var uid = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape2$Update$surLePassage,
						function (saisie) {
							return _Utils_update(
								saisie,
								{sn: uid});
						},
						model),
					_List_Nil);
			case 18:
				var mode = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape2$Update$surLePassage,
						function (saisie) {
							return _Utils_update(
								saisie,
								{n9: mode});
						},
						model),
					_List_Nil);
			case 19:
				var liaison = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape2$Update$surLePassage,
						function (saisie) {
							return _Utils_update(
								saisie,
								{Bk: liaison});
						},
						model),
					_List_Nil);
			case 20:
				var position = msg.a;
				var champ = msg.b;
				var texte = msg.c;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape2$Update$surLePassage,
						A3($author$project$Components$Parametrage$PipeEtape2$Update$modifierLeTerme, position, champ, texte),
						model),
					_List_Nil);
			case 21:
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape2$Update$surLePassage,
						$author$project$Components$Parametrage$PipeEtape2$Update$ajouterUnTerme(model.o_),
						model),
					_List_Nil);
			case 22:
				var position = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape2$Update$surLePassage,
						$author$project$Components$Parametrage$PipeEtape2$Update$retirerUnTerme(position),
						model),
					_List_Nil);
			case 23:
				var type_ = msg.a;
				var roleUid = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape2$Update$surLePassage,
						function (saisie) {
							return _Utils_update(
								saisie,
								{kw: type_, H6: roleUid});
						},
						model),
					_List_Nil);
			case 24:
				var texte = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape2$Update$surLePassage,
						function (saisie) {
							return _Utils_update(
								saisie,
								{ni: texte});
						},
						model),
					_List_Nil);
			case 25:
				return $author$project$Components$Parametrage$PipeEtape2$Update$enregistrer(model);
			case 26:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ve: $elm$core$Maybe$Nothing, bB: true}),
					_List_Nil);
			case 27:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ve: $elm$core$Maybe$Nothing, bB: false}),
					_List_Nil);
			case 28:
				var uid = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ve: uid}),
					_List_Nil);
			case 29:
				return _Utils_Tuple2(
					$author$project$Components$Parametrage$PipeEtape2$Update$versLeRetrait(model),
					_List_Nil);
			case 30:
				return $author$project$Components$Parametrage$PipeEtape2$Update$retirer(model);
			default:
				return $author$project$Components$Parametrage$PipeEtape2$Update$recharger(model);
		}
	});
var $author$project$Main$Update$versLEtape2DUnPipe = F3(
	function (i18n, msg, model) {
		var _v0 = A2(
			$author$project$Components$Parametrage$PipeEtape2$Update$update,
			msg,
			$author$project$Components$Parametrage$PipeEtape2$Model$ouvrir(model.Fz));
		var etape2 = _v0.a;
		var effets = _v0.b;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLEtape2DUnPipe,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Parametrage$PipeEtape2$Update$popMessages(msg),
							model.Ct),
						Fz: $author$project$Components$Parametrage$PipeEtape2$Model$envelopper(etape2)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$EnvoyerALEtape3DUnPipe = function (a) {
	return {$: 85, a: a};
};
var $author$project$Main$Update$LireLEtape3DUnPipe = F2(
	function (a, b) {
		return {$: 84, a: a, b: b};
	});
var $author$project$Main$Model$PourLEtape3DUnPipe = 19;
var $author$project$Main$Update$depuisLEtape3DUnPipe = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				var lecture = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLEtape3DUnPipe(lecture))));
			case 1:
				var lien = effet.a;
				var processUid = effet.b;
				var pipeUid = effet.c;
				var commande = effet.d;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerALEtape3DUnPipe(
									{vJ: commande, gM: vers.gM, nB: vers.nB, FK: pipeUid, Gn: processUid});
							})));
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[19]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 3:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$Edition = F4(
	function (uid, libelles, personne, liens) {
		return {R: libelles, nQ: liens, Fd: personne, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$editionDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['exempleDeDossier', 'personne']),
					$elm$json$Json$Decode$string),
					$elm$json$Json$Decode$succeed('')
				])),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['pipe', 'libelles']),
			$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['pipe', 'uid']),
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$Edition)))));
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$OptionDEquipe = F4(
	function (uid, libelle, nombreDePersonnes, grammaire) {
		return {m$: grammaire, Bl: libelle, DB: nombreDePersonnes, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$OptionDeRelation = F6(
	function (uid, code, libelle, sensPossibles, tenuPar, archive) {
		return {tE: archive, vx: code, Bl: libelle, ID: sensPossibles, e9: tenuPar, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$Options = function (rolesDEquipe) {
	return function (typesDePartiePrenante) {
		return function (groupes) {
			return function (postes) {
				return function (typesDeRelation) {
					return function (portails) {
						return function (fichesDExemple) {
							return function (organisationExemple) {
								return function (roleAvecEspacePropre) {
									return function (champs) {
										return {dw: champs, zw: fichesDExemple, Ac: groupes, Ep: organisationExemple, F_: portails, F6: postes, H5: roleAvecEspacePropre, H8: rolesDEquipe, J$: typesDePartiePrenante, J2: typesDeRelation};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$Poste = F5(
	function (uid, libelle, grammaire, nombreDeContacts, chez) {
		return {va: chez, m$: grammaire, Bl: libelle, Dy: nombreDeContacts, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$grammaireDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'grammaire',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Formes$decoder)),
			$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
		]));
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$NomAvecFormes = F2(
	function (libelle, grammaire) {
		return {m$: grammaire, Bl: libelle};
	});
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$nomAvecFormesDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$NomAvecFormes,
	A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string),
	$author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$grammaireDecoder);
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$OptionNommee = F2(
	function (uid, libelle) {
		return {Bl: libelle, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$nommeeDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$OptionNommee,
	A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string));
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$OrganisationExemple = F3(
	function (nom, type_, nature) {
		return {g1: nature, Dj: nom, r0: type_};
	});
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$organisationExempleDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$OrganisationExemple,
	A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'type', $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$nomAvecFormesDecoder)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'nature', $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$nomAvecFormesDecoder)));
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$optionsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'champsPartiePrenante',
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault(_List_Nil),
		$elm$json$Json$Decode$nullable(
			$elm$json$Json$Decode$list(
				A3(
					$elm$json$Json$Decode$map2,
					$elm$core$Tuple$pair,
					A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string))))),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'roleAvecEspacePropre',
		$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$nomAvecFormesDecoder),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'organisationExemple',
			$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$organisationExempleDecoder),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'fichesDExemple',
				$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$nommeeDecoder),
				_List_Nil,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'portails',
					$elm$json$Json$Decode$list(
						A3(
							$elm$json$Json$Decode$map2,
							$elm$core$Tuple$pair,
							A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
							A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string))),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'typesDeRelation',
						$elm$json$Json$Decode$list(
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'archive',
								$elm$json$Json$Decode$bool,
								false,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'tenuPar',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'sensPossibles',
										$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'libelle',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'code',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'uid',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$OptionDeRelation)))))))),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'postes',
							$elm$json$Json$Decode$list(
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'chez',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'nombreDeContacts',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
										$elm$core$Maybe$Nothing,
										A2(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
											$author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$grammaireDecoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'libelle',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'uid',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$Poste))))))),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'groupes',
								$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$nommeeDecoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'typesDePartiePrenante',
									$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$nommeeDecoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'rolesDEquipe',
										$elm$json$Json$Decode$list(
											A2(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
												$author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$grammaireDecoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'nombreDePersonnes',
													$elm$json$Json$Decode$int,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'libelle',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'uid',
															$elm$json$Json$Decode$string,
															$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$OptionDEquipe)))))),
										$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$Options)))))))))));
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$Role = function (uid) {
	return function (libelles) {
		return function (description) {
			return function (nature) {
				return function (cardinalite) {
					return function (grammaire) {
						return function (modeParRelation) {
							return function (peutEtre) {
								return function (relation) {
									return function (postesUid) {
										return function (espacePropre) {
											return function (portailCode) {
												return function (parChamp) {
													return function (champ) {
														return function (aucuneValeur) {
															return function (selonLePerimetre) {
																return function (aucunContact) {
																	return function (liens) {
																		return {tZ: aucunContact, t_: aucuneValeur, jz: cardinalite, uN: champ, dH: description, yB: espacePropre, m$: grammaire, R: libelles, nQ: liens, CG: modeParRelation, g1: nature, EM: parChamp, Fl: peutEtre, FZ: portailCode, F7: postesUid, Ht: relation, IB: selonLePerimetre, r8: uid};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$Plusieurs = 1;
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$UneSeule = 0;
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$cardinaliteDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (code) {
		switch (code) {
			case 'une-seule':
				return $elm$json$Json$Decode$succeed(0);
			case 'plusieurs':
				return $elm$json$Json$Decode$succeed(1);
			default:
				var autre = code;
				return $elm$json$Json$Decode$fail(autre);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$Externe = 1;
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$Interne = 0;
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$InterneOuExterne = 2;
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$natureDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (code) {
		switch (code) {
			case 'interne':
				return $elm$json$Json$Decode$succeed(0);
			case 'externe':
				return $elm$json$Json$Decode$succeed(1);
			case 'interne-ou-externe':
				return $elm$json$Json$Decode$succeed(2);
			default:
				var autre = code;
				return $elm$json$Json$Decode$fail(autre);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$PeutEtre = F3(
	function (genre, uid, libelle) {
		return {M: genre, Bl: libelle, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$peutEtreDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'libelle',
	$elm$json$Json$Decode$string,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'uid',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'genre',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$PeutEtre))));
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$Relation = F8(
	function (typeUid, code, libelle, sens, tenuPar, sPlusieursRelations, aucuneRelation, relationTerminee) {
		return {i9: aucuneRelation, vx: code, Bl: libelle, qi: relationTerminee, qT: sPlusieursRelations, IC: sens, e9: tenuPar, JX: typeUid};
	});
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$relationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'relationTerminee',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'aucuneRelation',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'sPlusieursRelations',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'tenuPar',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'sens',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'libelle',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'code',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'typeUid',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$Relation)))))))));
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$relationVide = {i9: 'le-dossier-s-ouvre-et-le-role-reste-a-remplir', vx: '', Bl: '', qi: 'le-gestionnaire-valide-le-retrait-et-designe-le-repreneur', qT: 'le-gestionnaire-choisit', IC: 'vers-celui-lie', e9: '', JX: ''};
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$roleDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['organisation', 'aucunContactDansLePerimetre']),
					$elm$json$Json$Decode$string),
					$elm$json$Json$Decode$succeed('contact-principal')
				])),
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['organisation', 'selonLePerimetre']),
						$elm$json$Json$Decode$bool),
						$elm$json$Json$Decode$succeed(false)
					])),
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['tenue', 'champ', 'aucuneValeur']),
							$elm$json$Json$Decode$string),
							$elm$json$Json$Decode$succeed('le-dossier-s-ouvre-et-le-role-reste-a-remplir')
						])),
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['tenue', 'champ', 'code']),
								$elm$json$Json$Decode$string),
								$elm$json$Json$Decode$succeed('')
							])),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['tenue', 'mode']),
						A2(
							$elm$json$Json$Decode$map,
							function (mode) {
								return mode === 'par-un-champ';
							},
							$elm$json$Json$Decode$string),
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							$elm$json$Json$Decode$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$json$Json$Decode$at,
										_List_fromArray(
											['portail', 'portail', 'code']),
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
										$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
									])),
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
								$elm$json$Json$Decode$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$json$Json$Decode$at,
											_List_fromArray(
												['portail', 'espacePropre']),
											$elm$json$Json$Decode$bool),
											$elm$json$Json$Decode$succeed(false)
										])),
								A2(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
									$elm$json$Json$Decode$oneOf(
										_List_fromArray(
											[
												A2(
												$elm$json$Json$Decode$at,
												_List_fromArray(
													['organisation', 'postes']),
												$elm$json$Json$Decode$list(
													A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string))),
												$elm$json$Json$Decode$succeed(_List_Nil)
											])),
									A2(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
										$elm$json$Json$Decode$oneOf(
											_List_fromArray(
												[
													A2(
													$elm$json$Json$Decode$at,
													_List_fromArray(
														['tenue', 'relation']),
													$author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$relationDecoder),
													$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$relationVide)
												])),
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'peutEtre',
											$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$peutEtreDecoder),
											_List_Nil,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
												_List_fromArray(
													['tenue', 'mode']),
												A2(
													$elm$json$Json$Decode$map,
													function (mode) {
														return mode === 'par-une-relation';
													},
													$elm$json$Json$Decode$string),
												A2(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
													$author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$grammaireDecoder,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'cardinalite',
														$author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$cardinaliteDecoder,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'nature',
															$author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$natureDecoder,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'description',
																$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
																$elm$core$Dict$empty,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'libelles',
																	$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'uid',
																		$elm$json$Json$Decode$string,
																		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$Role)))))))))))))))))));
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$Roles = F4(
	function (roles, apercu, liens, gabarits) {
		return {tq: apercu, gF: gabarits, nQ: liens, eX: roles};
	});
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$Apercu = F2(
	function (titre, lignes) {
		return {gV: lignes, h6: titre};
	});
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$apercuDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'lignes',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'titre',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$Apercu)));
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$RoleDeLaListe = F9(
	function (uid, libelles, description, nature, cardinalite, grammaire, objetVise, tenue, lecture) {
		return {jz: cardinalite, dH: description, m$: grammaire, np: lecture, R: libelles, g1: nature, D_: objetVise, Js: tenue, r8: uid};
	});
var $author$project$API$NavLinksDictionary$roleDuPipe = 'role';
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$ChoisiDansChaqueDossier = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$ParUnChamp = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$ParUneRelation = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$RelationDeLaListe = F4(
	function (code, libelle, tenuPar, poste) {
		return {vx: code, Bl: libelle, F4: poste, e9: tenuPar};
	});
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$tenueDeLaListeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (mode) {
		switch (mode) {
			case 'choisi-dans-chaque-dossier':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$ChoisiDansChaqueDossier,
					A2(
						$elm$json$Json$Decode$field,
						'peutEtre',
						$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$peutEtreDecoder)));
			case 'par-une-relation':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$ParUneRelation,
					A2(
						$elm$json$Json$Decode$field,
						'relation',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'poste',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'tenuPar',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'libelle',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'code',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$RelationDeLaListe)))))));
			case 'par-un-champ':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$ParUnChamp,
					A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string));
			default:
				var autre = mode;
				return $elm$json$Json$Decode$fail(autre);
		}
	},
	A2($elm$json$Json$Decode$field, 'mode', $elm$json$Json$Decode$string));
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$roleDeLaListeDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$roleDuPipe),
		$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'tenuPar',
		$author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$tenueDeLaListeDecoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'objetVise',
			$elm$json$Json$Decode$bool,
			false,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$grammaireDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'cardinalite',
					$author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$cardinaliteDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'nature',
						$author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$natureDecoder,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'description',
							$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
							$elm$core$Dict$empty,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'libelles',
								$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'uid',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$RoleDeLaListe))))))))));
var $author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$rolesDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				function ($) {
					return $.gF;
				},
				A2($elm$json$Json$Decode$field, '_links', $author$project$API$Liens$decoder)),
				$elm$json$Json$Decode$succeed(_List_Nil)
			])),
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'apercu',
			$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$apercuDecoder),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'roles',
				$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$roleDeLaListeDecoder),
				$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$Roles)))));
var $author$project$Components$Parametrage$PipeEtape3$Update$refusDeLecture = F2(
	function (lecture, reponse) {
		var refuse = function (decodeur) {
			var _v1 = A2($author$project$API$Reponse$lire, decodeur, reponse);
			if (_v1.$ === 1) {
				var refus = _v1.a;
				return ((refus.ri === 401) || (refus.ri === 404)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Components$Shared$Messages$Model$duRefus(refus));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		switch (lecture) {
			case 0:
				return refuse($author$project$Components$Parametrage$Common$API$QueryAPIModel$annuaireDecoder);
			case 1:
				return refuse($author$project$Components$Parametrage$Common$API$QueryAPIModel$racineDuPipeDecoder);
			case 2:
				return refuse($author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$editionDecoder);
			case 3:
				return refuse($author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$rolesDecoder);
			case 4:
				return refuse($author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$optionsDecoder);
			default:
				return refuse($author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$roleDecoder);
		}
	});
var $author$project$Components$Parametrage$PipeEtape3$Update$popMessages = function (msg) {
	if (msg.$ === 2) {
		var lecture = msg.a;
		var reponse = msg.b;
		return A2($author$project$Components$Parametrage$PipeEtape3$Update$refusDeLecture, lecture, reponse);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$PipeEtape3$Update$Annuaire = 0;
var $author$project$Components$Parametrage$PipeEtape3$Update$DemanderProcessUid = {$: 2};
var $author$project$Components$Parametrage$PipeEtape3$Update$LesRoles = 3;
var $author$project$Components$Parametrage$PipeEtape3$Update$Lire = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape3$Update$UnRole = 5;
var $author$project$API$NavLinksDictionary$ajouterUnRoleDuPipe = 'ajouter-un-role';
var $author$project$API$NavLinksDictionary$apercuDesRoles = 'apercu-des-roles';
var $author$project$Components$Parametrage$PipeEtape3$Model$estCoche = F3(
	function (genre, uid, peutEtre) {
		return A2(
			$elm$core$List$any,
			function (lu) {
				return _Utils_eq(lu.M, genre) && _Utils_eq(lu.r8, uid);
			},
			peutEtre);
	});
var $author$project$Components$Parametrage$PipeEtape3$Model$basculerPeutEtre = F2(
	function (case_, saisie) {
		return A3($author$project$Components$Parametrage$PipeEtape3$Model$estCoche, case_.M, case_.r8, saisie.Fl) ? _Utils_update(
			saisie,
			{
				Fl: A2(
					$elm$core$List$filter,
					function (lu) {
						return !(_Utils_eq(lu.M, case_.M) && _Utils_eq(lu.r8, case_.r8));
					},
					saisie.Fl)
			}) : _Utils_update(
			saisie,
			{
				Fl: _Utils_ap(
					saisie.Fl,
					_List_fromArray(
						[case_]))
			});
	});
var $author$project$Components$Parametrage$PipeEtape3$Update$choisirLeType = F3(
	function (options, uid, saisie) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (lues) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (type_) {
							return _Utils_eq(type_.r8, uid);
						},
						lues.J2));
			},
			options);
		if (!_v0.$) {
			var type_ = _v0.a;
			var relation = saisie.Ht;
			return _Utils_update(
				saisie,
				{
					Ht: _Utils_update(
						relation,
						{
							vx: type_.vx,
							Bl: type_.Bl,
							IC: A2($elm$core$List$member, relation.IC, type_.ID) ? relation.IC : A2(
								$elm$core$Maybe$withDefault,
								relation.IC,
								$elm$core$List$head(type_.ID)),
							e9: type_.e9,
							JX: type_.r8
						})
				});
		} else {
			return saisie;
		}
	});
var $author$project$Components$Parametrage$PipeEtape3$API$WriteAPIModel$AjouterUnRole = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$PipeEtape3$API$WriteAPIModel$ModifierUnRole = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape3$Update$lienDesRoles = F2(
	function (rel, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (roles) {
				return A2($author$project$API$Liens$trouver, rel, roles.nQ);
			},
			model.eX);
	});
var $author$project$API$NavLinksDictionary$modifierUnRoleDuPipe = 'modifier-un-role';
var $author$project$Components$Parametrage$PipeEtape3$API$WriteAPIModel$ChoisiDansChaqueDossier = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$PipeEtape3$API$WriteAPIModel$ParUnChamp = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$PipeEtape3$API$WriteAPIModel$ParUneRelation = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$PipeEtape3$Model$libellesVoulus = function (libelles) {
	var gardes = A2(
		$elm$core$Dict$map,
		F2(
			function (_v1, texte) {
				return $elm$core$String$trim(texte);
			}),
		A2(
			$elm$core$Dict$filter,
			F2(
				function (_v0, texte) {
					return $elm$core$String$trim(texte) !== '';
				}),
			libelles));
	return A2($elm$core$Dict$member, 'fr', gardes) ? $elm$core$Maybe$Just(gardes) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$Parametrage$PipeEtape3$Model$roleVoulu = F2(
	function (options, saisie) {
		return A2(
			$elm$core$Maybe$andThen,
			function (libelles) {
				return ((saisie.EW && (saisie.Ht.JX === '')) || (saisie.EM && (saisie.uN === ''))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					{
						tZ: saisie.tZ,
						jz: saisie.jz,
						dH: saisie.dH,
						R: libelles,
						g1: saisie.g1,
						F7: A2(
							$elm$core$List$filter,
							function (uid) {
								return A2(
									$elm$core$List$any,
									function (poste) {
										return _Utils_eq(poste.r8, uid);
									},
									options.F6);
							},
							saisie.F7),
						IB: saisie.IB,
						Js: saisie.EW ? $author$project$Components$Parametrage$PipeEtape3$API$WriteAPIModel$ParUneRelation(
							{
								i9: saisie.Ht.i9,
								yB: saisie.yB,
								FZ: (saisie.yB && (saisie.FZ !== '')) ? $elm$core$Maybe$Just(saisie.FZ) : $elm$core$Maybe$Nothing,
								qi: saisie.Ht.qi,
								qT: saisie.Ht.qT,
								IC: saisie.Ht.IC,
								JU: saisie.Ht.JX
							}) : (saisie.EM ? $author$project$Components$Parametrage$PipeEtape3$API$WriteAPIModel$ParUnChamp(
							{
								t_: saisie.t_,
								uN: saisie.uN,
								yB: saisie.yB,
								FZ: (saisie.yB && (saisie.FZ !== '')) ? $elm$core$Maybe$Just(saisie.FZ) : $elm$core$Maybe$Nothing
							}) : $author$project$Components$Parametrage$PipeEtape3$API$WriteAPIModel$ChoisiDansChaqueDossier(saisie.Fl))
					});
			},
			$author$project$Components$Parametrage$PipeEtape3$Model$libellesVoulus(saisie.R));
	});
var $author$project$Components$Parametrage$PipeEtape3$Update$Envoyer = F4(
	function (a, b, c, d) {
		return {$: 1, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Parametrage$PipeEtape3$Update$avecLePipe = F2(
	function (pipeUid, effet) {
		if (effet.$ === 1) {
			var lien = effet.a;
			var processUid = effet.b;
			var commande = effet.d;
			return A4($author$project$Components$Parametrage$PipeEtape3$Update$Envoyer, lien, processUid, pipeUid, commande);
		} else {
			var autre = effet;
			return autre;
		}
	});
var $author$project$Components$Parametrage$PipeEtape3$Update$Reconnecter = {$: 4};
var $author$project$Components$Parametrage$PipeEtape3$API$WriteAPIModel$ReponseDeCommande = function (vuesAJour) {
	return {sy: vuesAJour};
};
var $author$project$Components$Parametrage$PipeEtape3$API$WriteAPIModel$reponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Components$Parametrage$PipeEtape3$API$WriteAPIModel$ReponseDeCommande,
	A2($elm$json$Json$Decode$field, 'vuesAJour', $elm$json$Json$Decode$bool));
var $author$project$Components$Parametrage$PipeEtape3$Update$reglage = {
	f8: $author$project$Components$Parametrage$PipeEtape3$Update$DemanderProcessUid,
	l4: F3(
		function (lien, processUid, commande) {
			return A4($author$project$Components$Parametrage$PipeEtape3$Update$Envoyer, lien, processUid, '', commande);
		}),
	go: $elm$core$Basics$identity,
	pW: $author$project$Components$Parametrage$PipeEtape3$Update$Reconnecter,
	qu: F2(
		function (_v0, _v1) {
			return true;
		}),
	qv: $author$project$Components$Parametrage$PipeEtape3$API$WriteAPIModel$reponseDecoder
};
var $author$project$Components$Parametrage$PipeEtape3$Update$envoyer = F3(
	function (lien, commande, model) {
		var _v0 = A4($author$project$API$Envoi$partir, $author$project$Components$Parametrage$PipeEtape3$Update$reglage, lien, commande, model.l2);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var envoi = _v1.a;
			var effets = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi, pZ: $elm$core$Maybe$Nothing}),
				A2(
					$elm$core$List$map,
					$author$project$Components$Parametrage$PipeEtape3$Update$avecLePipe(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.r8;
								},
								model.ge))),
					effets));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$PipeEtape3$Update$versLApi = F3(
	function (lien, model, commande) {
		if (!commande.$) {
			var voulue = commande.a;
			return A3($author$project$Components$Parametrage$PipeEtape3$Update$envoyer, lien, voulue, model);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$PipeEtape3$Update$enregistrer = function (model) {
	var _v0 = _Utils_Tuple2(model.hP, model.o_);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var saisie = _v0.a.a;
		var options = _v0.b.a;
		var voulu = A2($author$project$Components$Parametrage$PipeEtape3$Model$roleVoulu, options, saisie);
		var _v1 = saisie.r8;
		if (_v1.$ === 1) {
			return A3(
				$author$project$Components$Parametrage$PipeEtape3$Update$versLApi,
				A2($author$project$Components$Parametrage$PipeEtape3$Update$lienDesRoles, $author$project$API$NavLinksDictionary$ajouterUnRoleDuPipe, model),
				model,
				A2($elm$core$Maybe$map, $author$project$Components$Parametrage$PipeEtape3$API$WriteAPIModel$AjouterUnRole, voulu));
		} else {
			var uid = _v1.a;
			return A3(
				$author$project$Components$Parametrage$PipeEtape3$Update$versLApi,
				A2(
					$elm$core$Maybe$andThen,
					function (role) {
						return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierUnRoleDuPipe, role.nQ);
					},
					model.bi),
				model,
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$Parametrage$PipeEtape3$API$WriteAPIModel$ModifierUnRole(uid),
					voulu));
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$PipeEtape3$Update$lectureDuRole = F2(
	function (uid, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.np;
			},
			A2(
				$elm$core$Maybe$andThen,
				function (roles) {
					return $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (role) {
								return _Utils_eq(role.r8, uid);
							},
							roles.eX));
				},
				model.eX));
	});
var $author$project$Components$Parametrage$PipeEtape3$Update$lireSi = F2(
	function (lecture, lien) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$Parametrage$PipeEtape3$Update$Lire(lecture),
					lien)));
	});
var $author$project$Components$Parametrage$PipeEtape3$Update$Edition = 2;
var $author$project$Components$Parametrage$PipeEtape3$Update$LesOptions = 4;
var $author$project$Components$Parametrage$PipeEtape3$Update$Racine = 1;
var $author$project$API$NavLinksDictionary$optionsDesRolesDuPipe = 'options';
var $author$project$Components$Parametrage$PipeEtape3$Update$PlacerFocus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$PipeEtape3$Model$idDuDeclencheur = function (nom) {
	return 'pipe-etape-3-' + nom;
};
var $author$project$Components$Parametrage$PipeEtape3$Model$idDuDrawer = function (nom) {
	return 'pipe-etape-3-' + nom;
};
var $author$project$Components$Parametrage$PipeEtape3$Update$ouvrir = F3(
	function (declencheur, saisie, model) {
		if ($author$project$API$Envoi$enCours(model.l2)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var nom = A2($elm$core$String$endsWith, '-', declencheur) ? _Utils_ap(
				declencheur,
				A2($elm$core$Maybe$withDefault, '', saisie.r8)) : declencheur;
			var _v0 = A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				$author$project$Components$Shared$Drawer$Update$Ouvrir(
					$author$project$Components$Parametrage$PipeEtape3$Model$idDuDeclencheur(nom)),
				$author$project$Components$Shared$Drawer$Model$init(
					$author$project$Components$Parametrage$PipeEtape3$Model$idDuDrawer('role')));
			var drawer = _v0.a;
			var effets = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						kX: drawer,
						pZ: $elm$core$Maybe$Nothing,
						eW: false,
						hP: $elm$core$Maybe$Just(saisie),
						rP: false
					}),
				A2(
					$elm$core$List$map,
					function (_v1) {
						var cible = _v1;
						return $author$project$Components$Parametrage$PipeEtape3$Update$PlacerFocus(cible);
					},
					effets));
		}
	});
var $author$project$API$NavLinksDictionary$rolesDuPipe = 'roles';
var $author$project$Components$Parametrage$PipeEtape3$Model$saisieDuRole = F2(
	function (options, role) {
		return {
			tZ: role.tZ,
			t_: role.t_,
			jz: role.jz,
			uN: role.uN,
			dH: role.dH,
			yB: role.yB,
			R: role.R,
			B0: $elm$core$Maybe$Just(role),
			g1: role.g1,
			EM: role.EM,
			EW: role.CG,
			Fl: role.Fl,
			FZ: A2(
				$elm$core$Maybe$withDefault,
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$first,
						$elm$core$List$head(options.F_))),
				role.FZ),
			F7: role.F7,
			Ht: role.Ht,
			IB: role.IB,
			r8: $elm$core$Maybe$Just(role.r8)
		};
	});
var $author$project$Components$Parametrage$PipeEtape3$Update$sous = F4(
	function (decodeur, reponse, model, suite) {
		var _v0 = A2($author$project$API$Reponse$lire, decodeur, reponse);
		if (!_v0.$) {
			var lue = _v0.a;
			return suite(lue);
		} else {
			var refus = _v0.a;
			return (refus.ri === 401) ? _Utils_Tuple2(
				model,
				_List_fromArray(
					[$author$project$Components$Parametrage$PipeEtape3$Update$Reconnecter])) : _Utils_Tuple2(
				_Utils_update(
					model,
					{nf: model.nf || (refus.ri === 404)}),
				_List_Nil);
		}
	});
var $author$project$Components$Parametrage$PipeEtape3$Update$lu = F3(
	function (lecture, reponse, model) {
		switch (lecture) {
			case 0:
				return A4(
					$author$project$Components$Parametrage$PipeEtape3$Update$sous,
					A4(
						$elm$json$Json$Decode$map3,
						F3(
							function (a, b, c) {
								return _Utils_Tuple3(a, b, c);
							}),
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$annuaireDecoder,
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$lienDuPipeDecoder(model.vx)),
					reponse,
					model,
					function (_v1) {
						var pipes = _v1.a;
						var liens = _v1.b;
						var visee = _v1.c;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									aS: $elm$core$Maybe$Just(pipes),
									nf: _Utils_eq(visee, $elm$core$Maybe$Nothing),
									nR: liens
								}),
							A2($author$project$Components$Parametrage$PipeEtape3$Update$lireSi, 1, visee));
					});
			case 1:
				return A4(
					$author$project$Components$Parametrage$PipeEtape3$Update$sous,
					$author$project$Components$Parametrage$Common$API$QueryAPIModel$racineDuPipeDecoder,
					reponse,
					model,
					function (edition) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									nf: _Utils_eq(edition, $elm$core$Maybe$Nothing)
								}),
							A2($author$project$Components$Parametrage$PipeEtape3$Update$lireSi, 2, edition));
					});
			case 2:
				return A4(
					$author$project$Components$Parametrage$PipeEtape3$Update$sous,
					$author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$editionDecoder,
					reponse,
					model,
					function (edition) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									ge: $elm$core$Maybe$Just(edition)
								}),
							A2(
								$author$project$Components$Parametrage$PipeEtape3$Update$lireSi,
								3,
								A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rolesDuPipe, edition.nQ)));
					});
			case 3:
				return A4(
					$author$project$Components$Parametrage$PipeEtape3$Update$sous,
					$author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$rolesDecoder,
					reponse,
					model,
					function (roles) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									eX: $elm$core$Maybe$Just(roles)
								}),
							_Utils_eq(model.o_, $elm$core$Maybe$Nothing) ? A2(
								$author$project$Components$Parametrage$PipeEtape3$Update$lireSi,
								4,
								A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$optionsDesRolesDuPipe, roles.nQ)) : _List_Nil);
					});
			case 4:
				return A4(
					$author$project$Components$Parametrage$PipeEtape3$Update$sous,
					$author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$optionsDecoder,
					reponse,
					model,
					function (options) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									o_: $elm$core$Maybe$Just(options)
								}),
							_List_Nil);
					});
			default:
				return A4(
					$author$project$Components$Parametrage$PipeEtape3$Update$sous,
					$author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$roleDecoder,
					reponse,
					model,
					function (role) {
						var _v2 = model.o_;
						if (!_v2.$) {
							var options = _v2.a;
							return A3(
								$author$project$Components$Parametrage$PipeEtape3$Update$ouvrir,
								'role-',
								A2($author$project$Components$Parametrage$PipeEtape3$Model$saisieDuRole, options, role),
								_Utils_update(
									model,
									{
										bi: $elm$core$Maybe$Just(role)
									}));
						} else {
							return _Utils_Tuple2(model, _List_Nil);
						}
					});
		}
	});
var $author$project$Components$Parametrage$PipeEtape3$Update$recharger = function (model) {
	var _v0 = A3(
		$author$project$Components$Shared$Drawer$Update$update,
		{Il: false},
		$author$project$Components$Shared$Drawer$Update$Fermer,
		model.kX);
	var drawer = _v0.a;
	var deDrawer = _v0.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{kX: drawer, pZ: $elm$core$Maybe$Nothing, eW: false, hP: $elm$core$Maybe$Nothing, rP: false, sr: false}),
		_Utils_ap(
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Parametrage$PipeEtape3$Update$PlacerFocus(cible);
				},
				deDrawer),
			A2(
				$author$project$Components$Parametrage$PipeEtape3$Update$lireSi,
				3,
				A2($author$project$Components$Parametrage$PipeEtape3$Update$lienDesRoles, $author$project$API$NavLinksDictionary$self, model))));
};
var $author$project$Components$Parametrage$PipeEtape3$Update$repondue = F2(
	function (reponse, model) {
		var _v0 = A3($author$project$API$Envoi$conclure, $author$project$Components$Parametrage$PipeEtape3$Update$reglage, reponse, model.l2);
		if (!_v0.$) {
			switch (_v0.a.b.$) {
				case 0:
					var _v1 = _v0.a;
					var envoi = _v1.a;
					var _v2 = _v1.b;
					var effets = _v1.c;
					var _v3 = A3(
						$author$project$Components$Shared$Drawer$Update$update,
						{Il: false},
						$author$project$Components$Shared$Drawer$Update$Fermer,
						model.kX);
					var drawer = _v3.a;
					var deDrawer = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{kX: drawer, l2: envoi, pZ: $elm$core$Maybe$Nothing, eW: false, hP: $elm$core$Maybe$Nothing, rP: false, sr: false}),
						_Utils_ap(
							effets,
							_Utils_ap(
								A2(
									$elm$core$List$map,
									function (_v4) {
										var cible = _v4;
										return $author$project$Components$Parametrage$PipeEtape3$Update$PlacerFocus(cible);
									},
									deDrawer),
								A2(
									$author$project$Components$Parametrage$PipeEtape3$Update$lireSi,
									3,
									A2($author$project$Components$Parametrage$PipeEtape3$Update$lienDesRoles, $author$project$API$NavLinksDictionary$self, model)))));
				case 1:
					var _v5 = _v0.a;
					var envoi = _v5.a;
					var _v6 = _v5.b;
					var refus = _v6.b;
					var effets = _v5.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l2: envoi,
								pZ: $elm$core$Maybe$Just(
									$author$project$Components$Parametrage$Common$RefusDuParcours$dit(refus)),
								sr: $author$project$Components$Parametrage$Common$RefusDuParcours$estVersionFigee(refus)
							}),
						effets);
				default:
					var _v7 = _v0.a;
					var envoi = _v7.a;
					var _v8 = _v7.b;
					var effets = _v7.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{l2: envoi}),
						effets);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$PipeEtape3$API$WriteAPIModel$RetirerUnRole = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$PipeEtape3$Update$retirer = function (model) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		function ($) {
			return $.r8;
		},
		model.hP);
	if (!_v0.$) {
		var uid = _v0.a;
		return A3(
			$author$project$Components$Parametrage$PipeEtape3$Update$versLApi,
			A2(
				$elm$core$Maybe$andThen,
				function (role) {
					return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerUnRole, role.nQ);
				},
				model.bi),
			model,
			$elm$core$Maybe$Just(
				$author$project$Components$Parametrage$PipeEtape3$API$WriteAPIModel$RetirerUnRole(uid)));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$PipeEtape3$Model$roleNeuf = function (options) {
	var relation = $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (lu) {
				return !lu.tE;
			},
			options.J2));
	return {
		tZ: 'contact-principal',
		t_: 'le-dossier-s-ouvre-et-le-role-reste-a-remplir',
		jz: 0,
		uN: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$first,
				$elm$core$List$head(options.dw))),
		dH: $elm$core$Dict$empty,
		yB: false,
		R: $elm$core$Dict$empty,
		B0: $elm$core$Maybe$Nothing,
		g1: 0,
		EM: false,
		EW: false,
		Fl: _List_Nil,
		FZ: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$first,
				$elm$core$List$head(options.F_))),
		F7: _List_Nil,
		Ht: {
			i9: 'le-dossier-s-ouvre-et-le-role-reste-a-remplir',
			vx: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.vx;
					},
					relation)),
			Bl: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Bl;
					},
					relation)),
			qi: 'le-gestionnaire-valide-le-retrait-et-designe-le-repreneur',
			qT: 'le-gestionnaire-choisit',
			IC: A2(
				$elm$core$Maybe$withDefault,
				'vers-celui-lie',
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.ID;
						},
						$elm$core$List$head),
					relation)),
			e9: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.e9;
					},
					relation)),
			JX: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.r8;
					},
					relation))
		},
		IB: false,
		r8: $elm$core$Maybe$Nothing
	};
};
var $author$project$Components$Parametrage$PipeEtape3$Update$surLeRole = F2(
	function (f, model) {
		return _Utils_update(
			model,
			{
				hP: A2($elm$core$Maybe$map, f, model.hP)
			});
	});
var $author$project$Components$Parametrage$PipeEtape3$Update$surLaRelation = function (f) {
	return $author$project$Components$Parametrage$PipeEtape3$Update$surLeRole(
		function (saisie) {
			return _Utils_update(
				saisie,
				{
					Ht: f(saisie.Ht)
				});
		});
};
var $author$project$API$NavLinksDictionary$variableFiche = 'fiche';
var $author$project$Components$Parametrage$PipeEtape3$Update$sortiesDuDrawer = _List_fromArray(
	[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$SortieDemandee, $author$project$Components$Shared$Drawer$Update$AbandonConfirme]);
var $author$project$Components$Parametrage$PipeEtape3$Update$versLeDrawer = F2(
	function (geste, model) {
		if ($author$project$API$Envoi$enCours(model.l2) && A2($elm$core$List$member, geste, $author$project$Components$Parametrage$PipeEtape3$Update$sortiesDuDrawer)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v0 = A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.kX);
			var drawer = _v0.a;
			var effets = _v0.b;
			var ouvert = $author$project$Components$Shared$Drawer$Model$estOuvert(drawer);
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						kX: drawer,
						hP: ouvert ? model.hP : $elm$core$Maybe$Nothing,
						rP: ouvert && model.rP
					}),
				A2(
					$elm$core$List$map,
					function (_v1) {
						var cible = _v1;
						return $author$project$Components$Parametrage$PipeEtape3$Update$PlacerFocus(cible);
					},
					effets));
		}
	});
var $author$project$Components$Parametrage$PipeEtape3$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var code = msg.a;
				var liens = msg.b;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$pipes, liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						$author$project$Components$Parametrage$PipeEtape3$Model$init(code),
						_List_fromArray(
							[
								$author$project$Components$Parametrage$PipeEtape3$Update$DemanderProcessUid,
								A2($author$project$Components$Parametrage$PipeEtape3$Update$Lire, 0, lecture)
							]));
				} else {
					return _Utils_Tuple2(
						$author$project$Components$Parametrage$PipeEtape3$Model$init(code),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 2:
				var lecture = msg.a;
				var reponse = msg.b;
				return A3($author$project$Components$Parametrage$PipeEtape3$Update$lu, lecture, reponse, model);
			case 3:
				var reponse = msg.a;
				return A2($author$project$Components$Parametrage$PipeEtape3$Update$repondue, reponse, model);
			case 4:
				var geste = msg.a;
				return A2($author$project$Components$Parametrage$PipeEtape3$Update$versLeDrawer, geste, model);
			case 9:
				var uid = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$Components$Parametrage$PipeEtape3$Update$lireSi,
						5,
						A2($author$project$Components$Parametrage$PipeEtape3$Update$lectureDuRole, uid, model)));
			case 10:
				var _v2 = _Utils_Tuple2(
					A2($author$project$Components$Parametrage$PipeEtape3$Update$lienDesRoles, $author$project$API$NavLinksDictionary$ajouterUnRoleDuPipe, model),
					model.o_);
				if ((!_v2.a.$) && (!_v2.b.$)) {
					var options = _v2.b.a;
					return A3(
						$author$project$Components$Parametrage$PipeEtape3$Update$ouvrir,
						'role-ajout',
						$author$project$Components$Parametrage$PipeEtape3$Model$roleNeuf(options),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 11:
				var langue = msg.a;
				var texte = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape3$Update$surLeRole,
						function (saisie) {
							return _Utils_update(
								saisie,
								{
									R: A3($elm$core$Dict$insert, langue, texte, saisie.R)
								});
						},
						model),
					_List_Nil);
			case 12:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{rP: true}),
					_List_Nil);
			case 13:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{rP: false}),
					_List_Nil);
			case 14:
				var nature = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape3$Update$surLeRole,
						function (saisie) {
							return _Utils_update(
								saisie,
								{g1: nature});
						},
						model),
					_List_Nil);
			case 15:
				var cardinalite = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape3$Update$surLeRole,
						function (saisie) {
							return _Utils_update(
								saisie,
								{jz: cardinalite});
						},
						model),
					_List_Nil);
			case 16:
				var case_ = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape3$Update$surLeRole,
						$author$project$Components$Parametrage$PipeEtape3$Model$basculerPeutEtre(case_),
						model),
					_List_Nil);
			case 17:
				var uid = msg.a;
				var coche = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape3$Update$surLeRole,
						function (saisie) {
							return _Utils_update(
								saisie,
								{
									F7: coche ? _Utils_ap(
										A2(
											$elm$core$List$filter,
											$elm$core$Basics$neq(uid),
											saisie.F7),
										_List_fromArray(
											[uid])) : A2(
										$elm$core$List$filter,
										$elm$core$Basics$neq(uid),
										saisie.F7)
								});
						},
						model),
					_List_Nil);
			case 23:
				var parRelation = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape3$Update$surLeRole,
						function (saisie) {
							return _Utils_update(
								saisie,
								{EM: false, EW: parRelation});
						},
						model),
					_List_Nil);
			case 18:
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape3$Update$surLeRole,
						function (saisie) {
							return _Utils_update(
								saisie,
								{EM: true, EW: false});
						},
						model),
					_List_Nil);
			case 19:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape3$Update$surLeRole,
						function (saisie) {
							return _Utils_update(
								saisie,
								{uN: code});
						},
						model),
					_List_Nil);
			case 20:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape3$Update$surLeRole,
						function (saisie) {
							return _Utils_update(
								saisie,
								{t_: code});
						},
						model),
					_List_Nil);
			case 21:
				var coche = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape3$Update$surLeRole,
						function (saisie) {
							return _Utils_update(
								saisie,
								{IB: coche});
						},
						model),
					_List_Nil);
			case 22:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape3$Update$surLeRole,
						function (saisie) {
							return _Utils_update(
								saisie,
								{tZ: code});
						},
						model),
					_List_Nil);
			case 24:
				var uid = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape3$Update$surLeRole,
						A2($author$project$Components$Parametrage$PipeEtape3$Update$choisirLeType, model.o_, uid),
						model),
					_List_Nil);
			case 25:
				var sens = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape3$Update$surLaRelation,
						function (relation) {
							return _Utils_update(
								relation,
								{IC: sens});
						},
						model),
					_List_Nil);
			case 26:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape3$Update$surLaRelation,
						function (relation) {
							return _Utils_update(
								relation,
								{qT: code});
						},
						model),
					_List_Nil);
			case 27:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape3$Update$surLaRelation,
						function (relation) {
							return _Utils_update(
								relation,
								{i9: code});
						},
						model),
					_List_Nil);
			case 28:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape3$Update$surLaRelation,
						function (relation) {
							return _Utils_update(
								relation,
								{qi: code});
						},
						model),
					_List_Nil);
			case 29:
				var oui = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape3$Update$surLeRole,
						function (saisie) {
							return _Utils_update(
								saisie,
								{yB: oui});
						},
						model),
					_List_Nil);
			case 30:
				return $author$project$Components$Parametrage$PipeEtape3$Update$enregistrer(model);
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pZ: $elm$core$Maybe$Nothing, eW: true}),
					_List_Nil);
			case 6:
				var uid = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							my: $elm$core$Maybe$Just(uid)
						}),
					A2(
						$author$project$Components$Parametrage$PipeEtape3$Update$lireSi,
						3,
						A2(
							$elm$core$Maybe$andThen,
							$author$project$API$Liens$resoudre(
								_List_fromArray(
									[
										_Utils_Tuple2($author$project$API$NavLinksDictionary$variableFiche, uid)
									])),
							A2(
								$elm$core$Maybe$andThen,
								function (roles) {
									return A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$apercuDesRoles, roles.gF);
								},
								model.eX))));
			case 7:
				return $author$project$Components$Parametrage$PipeEtape3$Update$retirer(model);
			default:
				return $author$project$Components$Parametrage$PipeEtape3$Update$recharger(model);
		}
	});
var $author$project$Main$Update$versLEtape3DUnPipe = F3(
	function (i18n, msg, model) {
		var _v0 = A2(
			$author$project$Components$Parametrage$PipeEtape3$Update$update,
			msg,
			$author$project$Components$Parametrage$PipeEtape3$Model$ouvrir(model.FA));
		var etape3 = _v0.a;
		var effets = _v0.b;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLEtape3DUnPipe,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Parametrage$PipeEtape3$Update$popMessages(msg),
							model.Ct),
						FA: $author$project$Components$Parametrage$PipeEtape3$Model$envelopper(etape3)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$EnvoyerALEtape4DUnPipe = function (a) {
	return {$: 91, a: a};
};
var $author$project$Main$Update$LireLEtape4DUnPipe = F2(
	function (a, b) {
		return {$: 86, a: a, b: b};
	});
var $author$project$Main$Model$PourLEtape4DUnPipe = 20;
var $author$project$Main$Update$depuisLEtape4DUnPipe = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				var lecture = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLEtape4DUnPipe(lecture))));
			case 1:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerALEtape4DUnPipe(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[20]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 3:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$Choix = F4(
	function (types, modeles, roles, liens) {
		return {nQ: liens, CI: modeles, eX: roles, ib: types};
	});
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$ModeleDeTache = F7(
	function (uid, libelles, type_, version, roleAttendu, disponible, utilisePar) {
		return {kR: disponible, R: libelles, qP: roleAttendu, r0: type_, r8: uid, sf: utilisePar, sq: version};
	});
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$modeleDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'utilisePar',
	$elm$json$Json$Decode$int,
	0,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'disponible',
		$elm$json$Json$Decode$bool,
		true,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['roleAttendu', 'libelle']),
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'version',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'type',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'libelles',
						$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'uid',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$ModeleDeTache))))))));
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$RoleCarte = F3(
	function (uid, libelle, parRelation) {
		return {Bl: libelle, EW: parRelation, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$roleDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'parRelation',
	$elm$json$Json$Decode$bool,
	false,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'libelle',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'uid',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$RoleCarte))));
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$TypeDeTache = F4(
	function (code, module_, disponible, description) {
		return {vx: code, dH: description, kR: disponible, oe: module_};
	});
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$typeDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'description',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'disponible',
		$elm$json$Json$Decode$bool,
		true,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'module',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'code',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$TypeDeTache)))));
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$choixDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'roles',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$roleDecoder),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'modeles',
			$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$modeleDecoder),
			_List_Nil,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'types',
				$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$typeDecoder),
				$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$Choix)))));
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$Difference = F3(
	function (champ, dansLeModele, dansLaTache) {
		return {uN: champ, wr: dansLaTache, wt: dansLeModele};
	});
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$Differences = F2(
	function (versionComparee, elements) {
		return {aV: elements, KF: versionComparee};
	});
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$differencesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'elements',
	$elm$json$Json$Decode$list(
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'dansLaTache',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'dansLeModele',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'champ',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$Difference))))),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'versionComparee',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$Differences)));
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$Edition = F3(
	function (uid, libelles, liens) {
		return {R: libelles, nQ: liens, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$editionDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['pipe', 'libelles']),
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['pipe', 'uid']),
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$Edition))));
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$FormulaireOption = F3(
	function (uid, libelles, type_) {
		return {R: libelles, r0: type_, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$formulairesDecoder = A2(
	$elm$json$Json$Decode$field,
	'formulaires',
	$elm$json$Json$Decode$list(
		A4(
			$elm$json$Json$Decode$map3,
			$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$FormulaireOption,
			A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
			A2(
				$elm$json$Json$Decode$field,
				'libelles',
				$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)),
			A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string))));
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$Taches = F4(
	function (etapes, resume, apercu, liens) {
		return {tq: apercu, yL: etapes, nQ: liens, HX: resume};
	});
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$Apercu = function (etapes) {
	return {yL: etapes};
};
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$ApercuDEtape = F2(
	function (libelle, lignes) {
		return {Bl: libelle, gV: lignes};
	});
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$apercuDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$Apercu,
	A2(
		$elm$json$Json$Decode$field,
		'etapes',
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$ApercuDEtape,
				A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string),
				A2(
					$elm$json$Json$Decode$field,
					'lignes',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string))))));
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$Etape = F7(
	function (uid, rang, libelles, but, branche, taches, liens) {
		return {uu: branche, uy: but, R: libelles, nQ: liens, bY: rang, Jk: taches, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$Tache = F6(
	function (uid, libelles, type_, role, echeance, lecture) {
		return {xY: echeance, np: lecture, R: libelles, bi: role, r0: type_, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$Echeance = F2(
	function (mode, delaiEnJours) {
		return {kB: delaiEnJours, n9: mode};
	});
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$echeanceDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'delaiEnJours',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'mode',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$Echeance)));
var $author$project$API$NavLinksDictionary$tacheDuPipe = 'tache';
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$tacheDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$tacheDuPipe),
		$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'echeance',
		$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$echeanceDecoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'role',
			$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$roleDecoder),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'type',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'libelles',
					$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'uid',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$Tache)))))));
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$etapeDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'taches',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$tacheDecoder),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'branche',
			$elm$json$Json$Decode$bool,
			false,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'but',
				$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
				$elm$core$Dict$empty,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'libelles',
					$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'rang',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'uid',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$Etape))))))));
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$Resume = F3(
	function (nombreDEtapes, nombreDeTaches, nombreDeBranchesSansTache) {
		return {Dt: nombreDEtapes, Du: nombreDeBranchesSansTache, DD: nombreDeTaches};
	});
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$resumeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'nombreDeBranchesSansTache',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'nombreDeTaches',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'nombreDEtapes',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$Resume))));
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$tachesDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'apercu',
		$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$apercuDecoder),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'resume',
			$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$resumeDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'etapes',
				$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$etapeDecoder),
				$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$Taches)))));
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$TacheLue = function (uid) {
	return function (etape) {
		return function (type_) {
			return function (libelles) {
				return function (role) {
					return function (formulaire) {
						return function (parametres) {
							return function (quand) {
								return function (modele) {
									return function (sortie) {
										return function (options) {
											return function (liens) {
												return {me: etape, zT: formulaire, R: libelles, nQ: liens, oa: modele, o_: options, EX: parametres, hz: quand, bi: role, IQ: sortie, r0: type_, r8: uid};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$FormulaireCarte = F4(
	function (uid, libelles, nombreDeChamps, nombreDeChampsNotes) {
		return {R: libelles, Dv: nombreDeChamps, Dw: nombreDeChampsNotes, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$formulaireDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'nombreDeChampsNotes',
	$elm$json$Json$Decode$int,
	0,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'nombreDeChamps',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'libelles',
			$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'uid',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$FormulaireCarte)))));
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$ModeleLu = F5(
	function (libelle, version, versionDisponible, modifiee, noteDeVersion) {
		return {Bl: libelle, CO: modifiee, DT: noteDeVersion, sq: version, KH: versionDisponible};
	});
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$modeleLuDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'notesDeVersion',
	$elm$json$Json$Decode$nullable(
		A2($elm$json$Json$Decode$field, 'fr', $elm$json$Json$Decode$string)),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'modifiee',
		$elm$json$Json$Decode$bool,
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'versionDisponible',
			$elm$json$Json$Decode$int,
			0,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'version',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'libelle',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$ModeleLu))))));
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$ChampDeDate = F3(
	function (valeur, libelle, dansUnePhrase) {
		return {wu: dansUnePhrase, Bl: libelle, fm: valeur};
	});
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$ExempleDeDossier = F2(
	function (personne, organisation) {
		return {En: organisation, Fd: personne};
	});
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$OptionsDeTache = function (roles) {
	return function (rolesProposes) {
		return function (organisateursProposes) {
			return function (reponsesAttenduesProposees) {
				return function (exempleDeDossier) {
					return function (echeances) {
						return function (relances) {
							return function (relancesDeValidation) {
								return function (avecLesAutres) {
									return function (modelesDeCommunication) {
										return function (modelesDeDocument) {
											return function (listesDePrix) {
												return function (postes) {
													return function (champsDeDate) {
														return function (evenements) {
															return function (personnes) {
																return function (groupes) {
																	return {jg: avecLesAutres, uU: champsDeDate, x0: echeances, mk: evenements, yZ: exempleDeDossier, Ac: groupes, BW: listesDePrix, CJ: modelesDeCommunication, CK: modelesDeDocument, Em: organisateursProposes, Fg: personnes, F6: postes, Hr: relances, Hs: relancesDeValidation, HK: reponsesAttenduesProposees, eX: roles, If: rolesProposes};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$Reference = F2(
	function (valeur, libelle) {
		return {Bl: libelle, fm: valeur};
	});
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$designesDecoder = $elm$json$Json$Decode$list(
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$Reference,
		A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string)));
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$LigneDePrix = F2(
	function (_public, montant) {
		return {oi: montant, pF: _public};
	});
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$ListeDePrix = F4(
	function (valeur, libelle, lignes, pourCeDossier) {
		return {Bl: libelle, gV: lignes, F9: pourCeDossier, fm: valeur};
	});
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$TarifDuDossier = F3(
	function (offre, _public, montant) {
		return {oi: montant, D1: offre, pF: _public};
	});
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$listeDePrixDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'pourCeDossier',
	$elm$json$Json$Decode$nullable(
		A4(
			$elm$json$Json$Decode$map3,
			$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$TarifDuDossier,
			A2($elm$json$Json$Decode$field, 'offre', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'public', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'montant', $elm$json$Json$Decode$string))),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'lignes',
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$LigneDePrix,
				A2($elm$json$Json$Decode$field, 'public', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'montant', $elm$json$Json$Decode$string))),
		_List_Nil,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'libelle',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'uid',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$ListeDePrix)))));
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$referencesDecoder = $elm$json$Json$Decode$list(
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$Reference,
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string)
				])),
		A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string)));
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$RoleDOption = F6(
	function (uid, libelle, parRelation, relation, grammaire, objetVise) {
		return {m$: grammaire, Bl: libelle, D_: objetVise, EW: parRelation, Ht: relation, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$roleDOptionDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'objetVise',
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'grammaire',
		$elm$json$Json$Decode$nullable($author$project$Catalogue$Formes$decoder),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'relation',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'parRelation',
				$elm$json$Json$Decode$bool,
				false,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'libelle',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'uid',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$RoleDOption)))))));
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$RoleDuDossier = function (uid) {
	return function (libelle) {
		return function (parRelation) {
			return function (relation) {
				return function (personne) {
					return function (poste) {
						return function (organisation) {
							return function (facultatif) {
								return function (plusieursPossibles) {
									return function (droitParDefaut) {
										return {xQ: droitParDefaut, ze: facultatif, Bl: libelle, En: organisation, EW: parRelation, Fd: personne, FU: plusieursPossibles, F4: poste, Ht: relation, r8: uid};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$roleDuDossierDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'droitParDefaut',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'plusieursPossibles',
		$elm$json$Json$Decode$bool,
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'facultatif',
			$elm$json$Json$Decode$bool,
			false,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'organisation',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'poste',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'personne',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'relation',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'parRelation',
								$elm$json$Json$Decode$bool,
								false,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'libelle',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'uid',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$RoleDuDossier)))))))))));
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$optionsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'groupes',
	$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$designesDecoder,
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'personnes',
		$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$designesDecoder,
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'evenements',
			$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$referencesDecoder,
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'champsDeDate',
				$elm$json$Json$Decode$list(
					A4(
						$elm$json$Json$Decode$map3,
						$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$ChampDeDate,
						A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
						A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string),
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[
									A2($elm$json$Json$Decode$field, 'dansUnePhrase', $elm$json$Json$Decode$string),
									A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string)
								])))),
				_List_Nil,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'postes',
					$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$referencesDecoder,
					_List_Nil,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'listesDePrix',
						$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$listeDePrixDecoder),
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'modelesDeDocument',
							$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$referencesDecoder,
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'modelesDeCommunication',
								$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$referencesDecoder,
								_List_Nil,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'avecLesAutres',
									$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'relancesDeValidation',
										$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
										_List_Nil,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'relances',
											$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'echeances',
												$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'exempleDeDossier',
													$elm$json$Json$Decode$nullable(
														A3(
															$elm$json$Json$Decode$map2,
															$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$ExempleDeDossier,
															A2($elm$json$Json$Decode$field, 'personne', $elm$json$Json$Decode$string),
															A2($elm$json$Json$Decode$field, 'organisation', $elm$json$Json$Decode$string))),
													$elm$core$Maybe$Nothing,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'reponsesAttenduesProposees',
														$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$roleDOptionDecoder),
														_List_Nil,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'organisateursProposes',
															$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$roleDOptionDecoder),
															_List_Nil,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'rolesProposes',
																$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$roleDuDossierDecoder),
																_List_Nil,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'roles',
																	$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$roleDOptionDecoder),
																	$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$OptionsDeTache))))))))))))))))));
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$QuandLu = F5(
	function (echeance, relance, avecLesAutres, obligatoire, visibleSurLePortail) {
		return {jg: avecLesAutres, xY: echeance, he: obligatoire, Hq: relance, KS: visibleSurLePortail};
	});
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$Relance = F2(
	function (mode, rappelsEnJoursAvant) {
		return {n9: mode, GV: rappelsEnJoursAvant};
	});
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$relanceDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'rappelsEnJoursAvant',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$int),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'mode',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$Relance)));
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$quandDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'visibleSurLePortail',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'obligatoire',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'avecLesAutres',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'relance',
				$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$relanceDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'echeance',
					$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$echeanceDecoder,
					$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$QuandLu))))));
var $author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$uneTacheDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'options',
		$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$optionsDecoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'sortie',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'modele',
				$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$modeleLuDecoder),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'quand',
					$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$quandDecoder,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'parametres',
						$elm$json$Json$Decode$dict($elm$json$Json$Decode$value),
						$elm$core$Dict$empty,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'formulaire',
							$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$formulaireDecoder),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'role',
								$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$roleDecoder),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'libelles',
									$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'type',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
											_List_fromArray(
												['etape', 'libelle']),
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'uid',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$TacheLue)))))))))))));
var $author$project$Components$Parametrage$PipeEtape4$Update$refusDeLecture = F2(
	function (lecture, reponse) {
		var refuse = function (decodeur) {
			var _v1 = A2($author$project$API$Reponse$lire, decodeur, reponse);
			if (_v1.$ === 1) {
				var refus = _v1.a;
				return ((refus.ri === 401) || (refus.ri === 404)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Components$Shared$Messages$Model$duRefus(refus));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		switch (lecture.$) {
			case 0:
				return refuse($author$project$Components$Parametrage$Common$API$QueryAPIModel$annuaireDecoder);
			case 1:
				return refuse($author$project$Components$Parametrage$Common$API$QueryAPIModel$racineDuPipeDecoder);
			case 2:
				return refuse($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$editionDecoder);
			case 3:
				return refuse($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$tachesDecoder);
			case 4:
				return refuse($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$formulairesDecoder);
			case 5:
				return refuse($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$choixDecoder);
			case 6:
				return refuse($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$uneTacheDecoder);
			case 7:
				return refuse($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$choixDecoder);
			case 8:
				return refuse($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$choixDecoder);
			default:
				return refuse($author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$differencesDecoder);
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$popMessages = function (msg) {
	if (msg.$ === 2) {
		var lecture = msg.a;
		var reponse = msg.b;
		return A2($author$project$Components$Parametrage$PipeEtape4$Update$refusDeLecture, lecture, reponse);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$PipeEtape4$Update$Annuaire = {$: 0};
var $author$project$Components$Parametrage$PipeEtape4$API$WriteAPIModel$AppliquerLaVersion = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$Update$DemanderProcessUid = {$: 2};
var $author$project$Components$Parametrage$PipeEtape4$Update$LeChoix = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$Update$LeChoixDuType = {$: 7};
var $author$project$Components$Parametrage$PipeEtape4$Update$LesDifferences = {$: 9};
var $author$project$Components$Parametrage$PipeEtape4$Update$Lire = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape4$API$WriteAPIModel$RetirerUneTache = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$Update$UneTache = {$: 6};
var $author$project$Components$Parametrage$PipeEtape4$API$WriteAPIModel$ChangerLeType = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$API$WriteAPIModel$AjouterUneTache = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$Model$formulaireSeChoisit = function (type_) {
	return (type_ === 'saisie') || (type_ === 'evaluation');
};
var $author$project$Components$Parametrage$PipeEtape4$Model$nonVide = function (texte) {
	return (texte === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(texte);
};
var $author$project$Components$Parametrage$PipeEtape4$Model$ajoutDUneTache = F2(
	function (nomDuType, ajout) {
		var _v0 = A2(
			$elm$core$List$filter,
			function (type_) {
				return _Utils_eq(type_.vx, ajout.r0) && type_.kR;
			},
			ajout.jN.ib);
		if (!_v0.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			return (ajout.r0 === 'action-manuelle') ? ((ajout.H6 === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				$author$project$Components$Parametrage$PipeEtape4$API$WriteAPIModel$AjouterUneTache(
					{
						gs: ajout.gs,
						mR: $elm$core$Maybe$Nothing,
						R: A2($elm$core$Dict$singleton, 'fr', nomDuType),
						EX: _List_fromArray(
							[
								_Utils_Tuple2(
								'roleUid',
								$elm$json$Json$Encode$string(ajout.H6)),
								_Utils_Tuple2(
								'preuve',
								$elm$json$Json$Encode$string(ajout.eG))
							]),
						H6: $elm$core$Maybe$Just(ajout.H6),
						r0: ajout.r0
					}))) : $elm$core$Maybe$Just(
				$author$project$Components$Parametrage$PipeEtape4$API$WriteAPIModel$AjouterUneTache(
					{
						gs: ajout.gs,
						mR: $author$project$Components$Parametrage$PipeEtape4$Model$formulaireSeChoisit(ajout.r0) ? $author$project$Components$Parametrage$PipeEtape4$Model$nonVide(ajout.mR) : $elm$core$Maybe$Nothing,
						R: A2($elm$core$Dict$singleton, 'fr', nomDuType),
						EX: _List_Nil,
						H6: $elm$core$Maybe$Nothing,
						r0: ajout.r0
					}));
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$reglageDuType = function (ajout) {
	return (ajout.r0 === 'action-manuelle') ? _List_fromArray(
		[
			_Utils_Tuple2(
			'roleUid',
			$elm$json$Json$Encode$string(ajout.H6)),
			_Utils_Tuple2(
			'preuve',
			$elm$json$Json$Encode$string(ajout.eG))
		]) : _List_Nil;
};
var $author$project$Components$Parametrage$PipeEtape4$Model$ajoutVoulu = F2(
	function (nomDuType, ajout) {
		var _v0 = ajout.cs;
		if (!_v0.$) {
			var changement = _v0.a;
			return _Utils_eq(ajout.r0, changement.rT) ? $elm$core$Maybe$Nothing : A2(
				$elm$core$Maybe$map,
				function (_v1) {
					return $author$project$Components$Parametrage$PipeEtape4$API$WriteAPIModel$ChangerLeType(
						{
							EX: $author$project$Components$Parametrage$PipeEtape4$Model$reglageDuType(ajout),
							e8: changement.e8,
							r0: ajout.r0
						});
				},
				A2(
					$author$project$Components$Parametrage$PipeEtape4$Model$ajoutVoulu,
					nomDuType,
					_Utils_update(
						ajout,
						{cs: $elm$core$Maybe$Nothing})));
		} else {
			return A2($author$project$Components$Parametrage$PipeEtape4$Model$ajoutDUneTache, nomDuType, ajout);
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$orElse = F2(
	function (autre, premier) {
		if (!premier.$) {
			return premier;
		} else {
			return autre;
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$lireChemin = F3(
	function (decodeur, chemin, saisie) {
		return $elm$core$Result$toMaybe(
			A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$at, chemin, decodeur),
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$core$Basics$identity, saisie.EX)));
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$signatairesDe = function (saisie) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A3(
			$author$project$Components$Parametrage$PipeEtape4$Model$lireChemin,
			$elm$json$Json$Decode$list(
				A4(
					$elm$json$Json$Decode$map3,
					F3(
						function (roleUid, action, condition) {
							return {fs: action, j4: condition, H6: roleUid};
						}),
					A2($elm$json$Json$Decode$field, 'roleUid', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'action', $elm$json$Json$Decode$string),
					A2(
						$elm$json$Json$Decode$field,
						'condition',
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[
									$elm$json$Json$Decode$string,
									A2($elm$json$Json$Decode$field, 'formule', $elm$json$Json$Decode$string)
								]))))),
			_List_fromArray(
				['signataires']),
			saisie));
};
var $author$project$Components$Parametrage$PipeEtape4$Model$ajouterUnSignataire = function (saisie) {
	var roles = A2(
		$elm$core$List$map,
		function ($) {
			return $.r8;
		},
		saisie.B1.o_.eX);
	var pris = A2(
		$elm$core$List$map,
		function ($) {
			return $.H6;
		},
		$author$project$Components$Parametrage$PipeEtape4$Model$signatairesDe(saisie));
	var choisi = A2(
		$author$project$Components$Parametrage$PipeEtape4$Model$orElse,
		$elm$core$List$head(roles),
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (uid) {
					return !A2($elm$core$List$member, uid, pris);
				},
				roles)));
	if (!choisi.$) {
		var roleUid = choisi.a;
		return _Utils_update(
			saisie,
			{
				EX: A3(
					$elm$core$Dict$insert,
					'signataires',
					A2(
						$elm$json$Json$Encode$list,
						$elm$core$Basics$identity,
						A2(
							$elm$core$List$map,
							function (lu) {
								return $elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'roleUid',
											$elm$json$Json$Encode$string(lu.H6)),
											_Utils_Tuple2(
											'action',
											$elm$json$Json$Encode$string(lu.fs)),
											_Utils_Tuple2(
											'condition',
											$elm$json$Json$Encode$string(lu.j4))
										]));
							},
							_Utils_ap(
								$author$project$Components$Parametrage$PipeEtape4$Model$signatairesDe(saisie),
								_List_fromArray(
									[
										{fs: 'signe', j4: 'toujours', H6: roleUid}
									])))),
					saisie.EX)
			});
	} else {
		return saisie;
	}
};
var $author$project$API$NavLinksDictionary$ajouterUneTache = 'ajouter-une-tache';
var $author$project$API$NavLinksDictionary$appliquerLaVersionDuModele = 'appliquer-la-version-du-modele';
var $author$project$Components$Parametrage$PipeEtape4$Update$apresEnJours = F2(
	function (texte, escalade) {
		var _v0 = $elm$core$String$toInt(
			$elm$core$String$trim(texte));
		if (!_v0.$) {
			var n = _v0.a;
			return A3(
				$elm$core$Dict$insert,
				'apresEnJours',
				$elm$json$Json$Encode$int(n),
				escalade);
		} else {
			return A2($elm$core$Dict$remove, 'apresEnJours', escalade);
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$listeDe = F2(
	function (chemin, saisie) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A3(
				$author$project$Components$Parametrage$PipeEtape4$Model$lireChemin,
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				chemin,
				saisie));
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$basculerDansListe = F4(
	function (cle, code, cochee, saisie) {
		var gardees = A2(
			$elm$core$List$filter,
			function (lue) {
				return !_Utils_eq(lue, code);
			},
			A2(
				$author$project$Components$Parametrage$PipeEtape4$Model$listeDe,
				_List_fromArray(
					[cle]),
				saisie));
		return _Utils_update(
			saisie,
			{
				EX: A3(
					$elm$core$Dict$insert,
					cle,
					A2(
						$elm$json$Json$Encode$list,
						$elm$json$Json$Encode$string,
						cochee ? _Utils_ap(
							gardees,
							_List_fromArray(
								[code])) : gardees),
					saisie.EX)
			});
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$basculerDecision = F3(
	function (code, cochee, saisie) {
		return A4($author$project$Components$Parametrage$PipeEtape4$Model$basculerDansListe, 'decisions', code, cochee, saisie);
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$participantsDe = function (saisie) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A3(
			$author$project$Components$Parametrage$PipeEtape4$Model$lireChemin,
			$elm$json$Json$Decode$list(
				A3(
					$elm$json$Json$Decode$map2,
					$elm$core$Tuple$pair,
					A2($elm$json$Json$Decode$field, 'roleUid', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'droit', $elm$json$Json$Decode$string))),
			_List_fromArray(
				['participants']),
			saisie));
};
var $author$project$Components$Parametrage$PipeEtape4$Model$droitDuParticipant = F2(
	function (roleUid, saisie) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var uid = _v0.a;
						return _Utils_eq(uid, roleUid);
					},
					$author$project$Components$Parametrage$PipeEtape4$Model$participantsDe(saisie))));
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$basculerParticipant = F3(
	function (roleUid, cochee, saisie) {
		var gardes = A2(
			$elm$core$List$filter,
			function (_v1) {
				var uid = _v1.a;
				return !_Utils_eq(uid, roleUid);
			},
			$author$project$Components$Parametrage$PipeEtape4$Model$participantsDe(saisie));
		var voulus = cochee ? _Utils_ap(
			gardes,
			_List_fromArray(
				[
					_Utils_Tuple2(
					roleUid,
					A2(
						$elm$core$Maybe$withDefault,
						'ecrit-et-lit',
						A2($author$project$Components$Parametrage$PipeEtape4$Model$droitDuParticipant, roleUid, saisie)))
				])) : gardes;
		return _Utils_update(
			saisie,
			{
				EX: A3(
					$elm$core$Dict$insert,
					'participants',
					A2(
						$elm$json$Json$Encode$list,
						function (_v0) {
							var uid = _v0.a;
							var droit = _v0.b;
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'roleUid',
										$elm$json$Json$Encode$string(uid)),
										_Utils_Tuple2(
										'droit',
										$elm$json$Json$Encode$string(droit))
									]));
						},
						voulus),
					saisie.EX)
			});
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$modifierImbrique = F3(
	function (cle, f, saisie) {
		var actuel = A2(
			$elm$core$Result$withDefault,
			$elm$core$Dict$empty,
			A2(
				$elm$json$Json$Decode$decodeValue,
				A2(
					$elm$json$Json$Decode$field,
					cle,
					$elm$json$Json$Decode$dict($elm$json$Json$Decode$value)),
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$core$Basics$identity, saisie.EX)));
		return _Utils_update(
			saisie,
			{
				EX: A3(
					$elm$core$Dict$insert,
					cle,
					A3(
						$elm$json$Json$Encode$dict,
						$elm$core$Basics$identity,
						$elm$core$Basics$identity,
						f(actuel)),
					saisie.EX)
			});
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$poserTexte = F3(
	function (cle, texte, saisie) {
		return _Utils_update(
			saisie,
			{
				EX: A3(
					$elm$core$Dict$insert,
					cle,
					$elm$json$Json$Encode$string(texte),
					saisie.EX)
			});
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$choisirLeRole = F2(
	function (uid, saisie) {
		var _v0 = saisie.B1.r0;
		switch (_v0) {
			case 'validation':
				return A3(
					$author$project$Components$Parametrage$PipeEtape4$Model$modifierImbrique,
					'quiValide',
					A2(
						$elm$core$Dict$insert,
						'roleUid',
						$elm$json$Json$Encode$string(uid)),
					_Utils_update(
						saisie,
						{H6: uid}));
			case 'action-manuelle':
				return A3(
					$author$project$Components$Parametrage$PipeEtape4$Model$poserTexte,
					'roleUid',
					uid,
					_Utils_update(
						saisie,
						{H6: uid}));
			default:
				return _Utils_update(
					saisie,
					{H6: uid});
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$LaBibliotheque = {$: 8};
var $author$project$Components$Parametrage$PipeEtape4$Update$lireSi = F2(
	function (lecture, lien) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$Parametrage$PipeEtape4$Update$Lire(lecture),
					lien)));
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$surLAjout = F2(
	function (f, model) {
		return _Utils_update(
			model,
			{
				fw: A2($elm$core$Maybe$map, f, model.fw)
			});
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$filtrerLaBibliotheque = F2(
	function (change, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (ajout) {
				return A2(
					$elm$core$Maybe$map,
					function (b) {
						return _Utils_Tuple2(
							ajout,
							change(b));
					},
					ajout.dq);
			},
			model.fw);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var ajout = _v1.a;
			var filtre = _v1.b;
			return _Utils_Tuple2(
				A2(
					$author$project$Components$Parametrage$PipeEtape4$Update$surLAjout,
					function (a) {
						return _Utils_update(
							a,
							{
								dq: $elm$core$Maybe$Just(filtre)
							});
					},
					model),
				A2(
					$author$project$Components$Parametrage$PipeEtape4$Update$lireSi,
					$author$project$Components$Parametrage$PipeEtape4$Update$LaBibliotheque,
					A2(
						$elm$core$Maybe$map,
						function (lien) {
							return _Utils_update(
								lien,
								{
									cM: _Utils_ap(
										lien.cM,
										_Utils_ap(
											(filtre.hC === '') ? '' : ('&recherche=' + $elm$url$Url$percentEncode(filtre.hC)),
											(filtre.M === '') ? '' : ('&type=' + $elm$url$Url$percentEncode(filtre.M))))
								});
						},
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$self, ajout.jN.nQ))));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$insererUnModeleDeTache = 'inserer-un-modele-de-tache';
var $author$project$Components$Parametrage$PipeEtape4$API$WriteAPIModel$InsererUnModele = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$Model$roleDuModele = F2(
	function (ajout, modele) {
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.r8;
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (role) {
						return _Utils_eq(role.Bl, modele.qP);
					},
					ajout.jN.eX)));
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$insertionVoulue = F2(
	function (ajout, modele) {
		return $author$project$Components$Parametrage$PipeEtape4$API$WriteAPIModel$InsererUnModele(
			{
				gs: ajout.gs,
				CH: modele.r8,
				H6: A2(
					$elm$core$Maybe$withDefault,
					'00000000-0000-0000-0000-000000000000',
					A2($author$project$Components$Parametrage$PipeEtape4$Model$roleDuModele, ajout, modele))
			});
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$lectureDeLaTache = F2(
	function (uid, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.np;
			},
			A2(
				$elm$core$Maybe$andThen,
				function (taches) {
					return $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (tache) {
								return _Utils_eq(tache.r8, uid);
							},
							A2(
								$elm$core$List$concatMap,
								function ($) {
									return $.Jk;
								},
								taches.yL)));
				},
				model.Jk));
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$lienDeLAjout = F2(
	function (rel, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (ajout) {
				var _v0 = ajout.cs;
				if (!_v0.$) {
					var changement = _v0.a;
					return changement.nB;
				} else {
					return A2($author$project$API$Liens$trouver, rel, ajout.jN.nQ);
				}
			},
			model.fw);
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$lienDeLaTache = F2(
	function (rel, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (saisie) {
				return A2($author$project$API$Liens$trouver, rel, saisie.B1.nQ);
			},
			model.hP);
	});
var $author$project$API$NavLinksDictionary$choixDeLaTache = 'choix-de-la-tache';
var $author$project$Components$Parametrage$PipeEtape4$Update$etapeDe = F2(
	function (uid, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (taches) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (etape) {
							return _Utils_eq(etape.r8, uid);
						},
						taches.yL));
			},
			model.Jk);
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$lienDuChoix = F2(
	function (etapeUid, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (etape) {
				return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$choixDeLaTache, etape.nQ);
			},
			A2($author$project$Components$Parametrage$PipeEtape4$Update$etapeDe, etapeUid, model));
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$etapeDeLaTache = F2(
	function (saisie, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (taches) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (etape) {
							return A2(
								$elm$core$List$any,
								function (carte) {
									return _Utils_eq(carte.r8, saisie.B1.r8);
								},
								etape.Jk);
						},
						taches.yL));
			},
			model.Jk);
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$lienDuChoixDeLaTache = F2(
	function (saisie, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (etape) {
				return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$choixDeLaTache, etape.nQ);
			},
			A2($author$project$Components$Parametrage$PipeEtape4$Update$etapeDeLaTache, saisie, model));
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$Edition = {$: 2};
var $author$project$Components$Parametrage$PipeEtape4$Update$LesFormulaires = {$: 4};
var $author$project$Components$Parametrage$PipeEtape4$Update$LesTaches = {$: 3};
var $author$project$Components$Parametrage$PipeEtape4$Update$Racine = {$: 1};
var $author$project$Components$Parametrage$PipeEtape4$Model$ajoutNeuf = F2(
	function (etape, choix) {
		return {
			dq: $elm$core$Maybe$Nothing,
			cs: $elm$core$Maybe$Nothing,
			jN: choix,
			mh: etape.Bl,
			gs: etape.r8,
			mR: '',
			aA: _List_Nil,
			eG: 'aucune',
			H6: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.r8;
					},
					$elm$core$List$head(choix.eX))),
			r0: ''
		};
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$avecLesFormulaires = F2(
	function (formulaires, ajout) {
		return _Utils_update(
			ajout,
			{aA: formulaires});
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$changementNeuf = F3(
	function (changement, etape, choix) {
		var neuf = A2($author$project$Components$Parametrage$PipeEtape4$Model$ajoutNeuf, etape, choix);
		return _Utils_update(
			neuf,
			{
				cs: $elm$core$Maybe$Just(changement)
			});
	});
var $author$project$API$NavLinksDictionary$changerLeTypeDUneTache = 'changer-le-type-d-une-tache';
var $author$project$API$NavLinksDictionary$formulairesDuPipe = 'formulaires';
var $author$project$Components$Parametrage$PipeEtape4$Update$PlacerFocus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$Model$idDuDeclencheur = function (nom) {
	return 'pipe-etape-4-' + nom;
};
var $author$project$Components$Parametrage$PipeEtape4$Model$idDuDrawer = function (nom) {
	return 'pipe-etape-4-' + nom;
};
var $author$project$Components$Parametrage$PipeEtape4$Update$ouvrir = F3(
	function (declencheur, remplir, model) {
		if ($author$project$API$Envoi$enCours(model.l2)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v0 = A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				$author$project$Components$Shared$Drawer$Update$Ouvrir(
					$author$project$Components$Parametrage$PipeEtape4$Model$idDuDeclencheur(declencheur)),
				$author$project$Components$Shared$Drawer$Model$init(
					$author$project$Components$Parametrage$PipeEtape4$Model$idDuDrawer('tache')));
			var drawer = _v0.a;
			var effets = _v0.b;
			return _Utils_Tuple2(
				remplir(
					_Utils_update(
						model,
						{kX: drawer, pZ: $elm$core$Maybe$Nothing})),
				A2(
					$elm$core$List$map,
					function (_v1) {
						var cible = _v1;
						return $author$project$Components$Parametrage$PipeEtape4$Update$PlacerFocus(cible);
					},
					effets));
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$saisieDeLaTache = function (lue) {
	return {
		jg: lue.hz.jg,
		cp: $elm$core$Dict$empty,
		jI: false,
		w2: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Maybe$map, $elm$core$String$fromInt, lue.hz.xY.kB)),
		kQ: $elm$core$Maybe$Nothing,
		xY: lue.hz.xY.n9,
		mR: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.r8;
				},
				lue.zT)),
		aA: _List_Nil,
		gN: lue.hz.Hq.GV,
		R: lue.R,
		B1: lue,
		he: lue.hz.he,
		EX: lue.EX,
		Hq: lue.hz.Hq.n9,
		H6: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.r8;
				},
				lue.bi)),
		KS: lue.hz.KS
	};
};
var $author$project$Components$Parametrage$PipeEtape4$Update$Reconnecter = {$: 4};
var $author$project$Components$Parametrage$PipeEtape4$Update$sous = F4(
	function (decodeur, reponse, model, suite) {
		var _v0 = A2($author$project$API$Reponse$lire, decodeur, reponse);
		if (!_v0.$) {
			var lue = _v0.a;
			return suite(lue);
		} else {
			var refus = _v0.a;
			return (refus.ri === 401) ? _Utils_Tuple2(
				model,
				_List_fromArray(
					[$author$project$Components$Parametrage$PipeEtape4$Update$Reconnecter])) : _Utils_Tuple2(
				_Utils_update(
					model,
					{nf: model.nf || (refus.ri === 404)}),
				_List_Nil);
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$surLaTache = F2(
	function (f, model) {
		return _Utils_update(
			model,
			{
				hP: A2($elm$core$Maybe$map, f, model.hP)
			});
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$tacheAvecLesFormulaires = F2(
	function (formulaires, saisie) {
		return _Utils_update(
			saisie,
			{aA: formulaires});
	});
var $author$project$API$NavLinksDictionary$tachesDuPipe = 'taches';
var $author$project$Components$Parametrage$PipeEtape4$Update$lu = F3(
	function (lecture, reponse, model) {
		switch (lecture.$) {
			case 0:
				return A4(
					$author$project$Components$Parametrage$PipeEtape4$Update$sous,
					A4(
						$elm$json$Json$Decode$map3,
						F3(
							function (a, b, c) {
								return _Utils_Tuple3(a, b, c);
							}),
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$annuaireDecoder,
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$lienDuPipeDecoder(model.vx)),
					reponse,
					model,
					function (_v1) {
						var pipes = _v1.a;
						var liens = _v1.b;
						var visee = _v1.c;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									aS: $elm$core$Maybe$Just(pipes),
									nf: _Utils_eq(visee, $elm$core$Maybe$Nothing),
									nR: liens
								}),
							A2($author$project$Components$Parametrage$PipeEtape4$Update$lireSi, $author$project$Components$Parametrage$PipeEtape4$Update$Racine, visee));
					});
			case 1:
				return A4(
					$author$project$Components$Parametrage$PipeEtape4$Update$sous,
					$author$project$Components$Parametrage$Common$API$QueryAPIModel$racineDuPipeDecoder,
					reponse,
					model,
					function (edition) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									nf: _Utils_eq(edition, $elm$core$Maybe$Nothing)
								}),
							A2($author$project$Components$Parametrage$PipeEtape4$Update$lireSi, $author$project$Components$Parametrage$PipeEtape4$Update$Edition, edition));
					});
			case 2:
				return A4(
					$author$project$Components$Parametrage$PipeEtape4$Update$sous,
					$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$editionDecoder,
					reponse,
					model,
					function (edition) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									ge: $elm$core$Maybe$Just(edition)
								}),
							_Utils_ap(
								A2(
									$author$project$Components$Parametrage$PipeEtape4$Update$lireSi,
									$author$project$Components$Parametrage$PipeEtape4$Update$LesTaches,
									A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$tachesDuPipe, edition.nQ)),
								A2(
									$author$project$Components$Parametrage$PipeEtape4$Update$lireSi,
									$author$project$Components$Parametrage$PipeEtape4$Update$LesFormulaires,
									A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$formulairesDuPipe, edition.nQ))));
					});
			case 9:
				return A4(
					$author$project$Components$Parametrage$PipeEtape4$Update$sous,
					$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$differencesDecoder,
					reponse,
					model,
					function (differences) {
						return _Utils_Tuple2(
							A2(
								$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
								function (saisie) {
									return _Utils_update(
										saisie,
										{
											kQ: $elm$core$Maybe$Just(differences)
										});
								},
								model),
							_List_Nil);
					});
			case 3:
				return A4(
					$author$project$Components$Parametrage$PipeEtape4$Update$sous,
					$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$tachesDecoder,
					reponse,
					model,
					function (taches) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									Jk: $elm$core$Maybe$Just(taches)
								}),
							_List_Nil);
					});
			case 4:
				return A4(
					$author$project$Components$Parametrage$PipeEtape4$Update$sous,
					$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$formulairesDecoder,
					reponse,
					model,
					function (formulaires) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{aA: formulaires}),
							_List_Nil);
					});
			case 5:
				var etapeUid = lecture.a;
				return A4(
					$author$project$Components$Parametrage$PipeEtape4$Update$sous,
					$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$choixDecoder,
					reponse,
					model,
					function (choix) {
						var _v2 = A2($author$project$Components$Parametrage$PipeEtape4$Update$etapeDe, etapeUid, model);
						if (!_v2.$) {
							var etape = _v2.a;
							return A3(
								$author$project$Components$Parametrage$PipeEtape4$Update$ouvrir,
								'ajout-' + etapeUid,
								function (ouvert) {
									return _Utils_update(
										ouvert,
										{
											fw: $elm$core$Maybe$Just(
												A2(
													$author$project$Components$Parametrage$PipeEtape4$Model$avecLesFormulaires,
													model.aA,
													A2(
														$author$project$Components$Parametrage$PipeEtape4$Model$ajoutNeuf,
														{
															Bl: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(etape.R),
															r8: etape.r8
														},
														choix))),
											hP: $elm$core$Maybe$Nothing
										});
								},
								model);
						} else {
							return _Utils_Tuple2(model, _List_Nil);
						}
					});
			case 8:
				return A4(
					$author$project$Components$Parametrage$PipeEtape4$Update$sous,
					$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$choixDecoder,
					reponse,
					model,
					function (choix) {
						return _Utils_Tuple2(
							A2(
								$author$project$Components$Parametrage$PipeEtape4$Update$surLAjout,
								function (ajout) {
									return _Utils_update(
										ajout,
										{
											dq: A2(
												$elm$core$Maybe$map,
												function (b) {
													return _Utils_update(
														b,
														{
															vd: A2(
																$elm$core$Maybe$andThen,
																function (uid) {
																	return A2(
																		$elm$core$List$any,
																		function (m) {
																			return _Utils_eq(m.r8, uid);
																		},
																		choix.CI) ? $elm$core$Maybe$Just(uid) : $elm$core$Maybe$Nothing;
																},
																b.vd)
														});
												},
												ajout.dq),
											jN: _Utils_update(
												choix,
												{eX: ajout.jN.eX, ib: ajout.jN.ib})
										});
								},
								model),
							_List_Nil);
					});
			case 7:
				return A4(
					$author$project$Components$Parametrage$PipeEtape4$Update$sous,
					$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$choixDecoder,
					reponse,
					model,
					function (choix) {
						var _v3 = A2(
							$elm$core$Maybe$andThen,
							function (saisie) {
								return A2(
									$elm$core$Maybe$map,
									$elm$core$Tuple$pair(saisie),
									A2($author$project$Components$Parametrage$PipeEtape4$Update$etapeDeLaTache, saisie, model));
							},
							model.hP);
						if (!_v3.$) {
							var _v4 = _v3.a;
							var saisie = _v4.a;
							var etape = _v4.b;
							return A3(
								$author$project$Components$Parametrage$PipeEtape4$Update$ouvrir,
								'tache-' + saisie.B1.r8,
								function (ouvert) {
									return _Utils_update(
										ouvert,
										{
											fw: $elm$core$Maybe$Just(
												A3(
													$author$project$Components$Parametrage$PipeEtape4$Model$changementNeuf,
													{
														nB: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$changerLeTypeDUneTache, saisie.B1.nQ),
														e8: saisie.B1.r8,
														rT: saisie.B1.r0
													},
													{
														Bl: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(etape.R),
														r8: etape.r8
													},
													choix)),
											hP: $elm$core$Maybe$Nothing
										});
								},
								model);
						} else {
							return _Utils_Tuple2(model, _List_Nil);
						}
					});
			default:
				return A4(
					$author$project$Components$Parametrage$PipeEtape4$Update$sous,
					$author$project$Components$Parametrage$PipeEtape4$API$QueryAPIModel$uneTacheDecoder,
					reponse,
					model,
					function (tache) {
						return A3(
							$author$project$Components$Parametrage$PipeEtape4$Update$ouvrir,
							'tache-' + tache.r8,
							function (ouvert) {
								return _Utils_update(
									ouvert,
									{
										fw: $elm$core$Maybe$Nothing,
										hP: $elm$core$Maybe$Just(
											A2(
												$author$project$Components$Parametrage$PipeEtape4$Model$tacheAvecLesFormulaires,
												model.aA,
												$author$project$Components$Parametrage$PipeEtape4$Model$saisieDeLaTache(tache)))
									});
							},
							model);
					});
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$modeleVoulu = F2(
	function (ajout, modele) {
		return A2(
			$elm$core$Maybe$map,
			function (roleUid) {
				return $author$project$Components$Parametrage$PipeEtape4$API$WriteAPIModel$InsererUnModele(
					{gs: ajout.gs, CH: modele.r8, H6: roleUid});
			},
			A2($author$project$Components$Parametrage$PipeEtape4$Model$roleDuModele, ajout, modele));
	});
var $author$project$API$NavLinksDictionary$modifierUneTache = 'modifier-une-tache';
var $author$project$Components$Parametrage$PipeEtape4$Model$poserBooleen = F3(
	function (cle, oui, saisie) {
		return _Utils_update(
			saisie,
			{
				EX: A3(
					$elm$core$Dict$insert,
					cle,
					$elm$json$Json$Encode$bool(oui),
					saisie.EX)
			});
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$poserBooleenImbrique = F4(
	function (objet, champ, oui, saisie) {
		return A3(
			$author$project$Components$Parametrage$PipeEtape4$Model$modifierImbrique,
			objet,
			A2(
				$elm$core$Dict$insert,
				champ,
				$elm$json$Json$Encode$bool(oui)),
			saisie);
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$poserEntier = F3(
	function (cle, texte, saisie) {
		var _v0 = $elm$core$String$toInt(
			$elm$core$String$trim(texte));
		if (!_v0.$) {
			var n = _v0.a;
			return _Utils_update(
				saisie,
				{
					EX: A3(
						$elm$core$Dict$insert,
						cle,
						$elm$json$Json$Encode$int(n),
						saisie.EX)
				});
		} else {
			return _Utils_update(
				saisie,
				{
					EX: A2($elm$core$Dict$remove, cle, saisie.EX)
				});
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$poserEntierImbrique = F4(
	function (objet, champ, texte, saisie) {
		var _v0 = $elm$core$String$toInt(
			$elm$core$String$trim(texte));
		if (!_v0.$) {
			var n = _v0.a;
			return A3(
				$author$project$Components$Parametrage$PipeEtape4$Model$modifierImbrique,
				objet,
				A2(
					$elm$core$Dict$insert,
					champ,
					$elm$json$Json$Encode$int(n)),
				saisie);
		} else {
			return A3(
				$author$project$Components$Parametrage$PipeEtape4$Model$modifierImbrique,
				objet,
				$elm$core$Dict$remove(champ),
				saisie);
		}
	});
var $elm$core$String$words = _String_words;
var $author$project$Components$Parametrage$PipeEtape4$Model$poserListeDEntiersImbriquee = F4(
	function (objet, champ, texte, saisie) {
		var nombres = A2(
			$elm$core$List$filterMap,
			$elm$core$String$toInt,
			$elm$core$String$words(
				A2(
					$elm$core$String$map,
					function (c) {
						return $elm$core$Char$isDigit(c) ? c : ' ';
					},
					texte)));
		return function (modifiee) {
			return _Utils_update(
				modifiee,
				{
					cp: A3($elm$core$Dict$insert, objet + ('.' + champ), texte, modifiee.cp)
				});
		}(
			A3(
				$author$project$Components$Parametrage$PipeEtape4$Model$modifierImbrique,
				objet,
				A2(
					$elm$core$Dict$insert,
					champ,
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, nombres)),
				saisie));
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$poserListeUnique = F3(
	function (cle, code, saisie) {
		return _Utils_update(
			saisie,
			{
				EX: A3(
					$elm$core$Dict$insert,
					cle,
					A2(
						$elm$json$Json$Encode$list,
						$elm$json$Json$Encode$string,
						(code === '') ? _List_Nil : _List_fromArray(
							[code])),
					saisie.EX)
			});
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$poserRappelSansReponse = F2(
	function (oui, saisie) {
		return A3(
			$author$project$Components$Parametrage$PipeEtape4$Model$modifierImbrique,
			'prevenir',
			A2(
				$elm$core$Dict$insert,
				'rappelSansReponseEnJours',
				oui ? $elm$json$Json$Encode$int(3) : $elm$json$Json$Encode$null),
			saisie);
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$poserTexteImbrique = F4(
	function (objet, champ, texte, saisie) {
		return A3(
			$author$project$Components$Parametrage$PipeEtape4$Model$modifierImbrique,
			objet,
			A2(
				$elm$core$Dict$insert,
				champ,
				$elm$json$Json$Encode$string(texte)),
			saisie);
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$poserTexteOuNul = F3(
	function (cle, texte, saisie) {
		return _Utils_update(
			saisie,
			{
				EX: A3(
					$elm$core$Dict$insert,
					cle,
					(texte === '') ? $elm$json$Json$Encode$null : $elm$json$Json$Encode$string(texte),
					saisie.EX)
			});
	});
var $author$project$I18n$Textes$modeleTacheRefusArchive = A3($author$project$I18n$Traductions$texte, 'modele-tache.refus.archive', _List_Nil, 'Ce modèle est archivé : restaurez-le avant de le modifier.');
var $author$project$I18n$Textes$modeleTacheRefusFormulaireFige = A3($author$project$I18n$Traductions$texte, 'modele-tache.refus.formulaire-fige', _List_Nil, 'Le formulaire de ce modèle est figé par une version publiée : rien n\'a été inséré.');
var $author$project$I18n$Textes$modeleTacheRefusLibelle = A3($author$project$I18n$Traductions$texte, 'modele-tache.refus.libelle', _List_Nil, 'Le nom du modèle est obligatoire.');
var $author$project$I18n$Textes$modeleTacheRefusNomPris = A3($author$project$I18n$Traductions$texte, 'modele-tache.refus.nom-pris', _List_Nil, 'Un autre modèle de la bibliothèque porte déjà ce nom.');
var $author$project$I18n$Textes$modeleTacheRefusRoleNonAssocie = A3($author$project$I18n$Traductions$texte, 'modele-tache.refus.role-non-associe', _List_Nil, 'Le rôle attendu par ce modèle n\'est associé à aucun rôle de ce pipe : rien n\'a été inséré.');
var $author$project$Components$Parametrage$Vocabulaire$messageDuRefusDeModele = function (refus) {
	var _v0 = refus.bB;
	_v0$5:
	while (true) {
		if (_v0.$ === 1) {
			switch (_v0.a) {
				case 'NomDeModeleDejaPris':
					return {Jx: $author$project$I18n$Textes$modeleTacheRefusNomPris, b9: refus.b9};
				case 'ModeleArchive':
					return {Jx: $author$project$I18n$Textes$modeleTacheRefusArchive, b9: refus.b9};
				case 'RoleAttenduNonAssocie':
					return {Jx: $author$project$I18n$Textes$modeleTacheRefusRoleNonAssocie, b9: refus.b9};
				case 'FormulaireFige':
					return {Jx: $author$project$I18n$Textes$modeleTacheRefusFormulaireFige, b9: refus.b9};
				case 'LibelleParDefautRequis':
					return {Jx: $author$project$I18n$Textes$modeleTacheRefusLibelle, b9: refus.b9};
				default:
					break _v0$5;
			}
		} else {
			break _v0$5;
		}
	}
	return $author$project$Components$Shared$Messages$Model$duRefus(refus);
};
var $author$project$Components$Parametrage$PipeEtape4$Update$Envoyer = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$PipeEtape4$API$WriteAPIModel$ReponseDeCommande = function (vuesAJour) {
	return {sy: vuesAJour};
};
var $author$project$Components$Parametrage$PipeEtape4$API$WriteAPIModel$reponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Components$Parametrage$PipeEtape4$API$WriteAPIModel$ReponseDeCommande,
	A2($elm$json$Json$Decode$field, 'vuesAJour', $elm$json$Json$Decode$bool));
var $author$project$Components$Parametrage$PipeEtape4$Update$reglage = {
	f8: $author$project$Components$Parametrage$PipeEtape4$Update$DemanderProcessUid,
	l4: $author$project$Components$Parametrage$PipeEtape4$Update$Envoyer,
	go: $elm$core$Basics$identity,
	pW: $author$project$Components$Parametrage$PipeEtape4$Update$Reconnecter,
	qu: F2(
		function (_v0, _v1) {
			return true;
		}),
	qv: $author$project$Components$Parametrage$PipeEtape4$API$WriteAPIModel$reponseDecoder
};
var $author$project$Components$Parametrage$PipeEtape4$Update$repondue = F2(
	function (reponse, model) {
		var _v0 = A3($author$project$API$Envoi$conclure, $author$project$Components$Parametrage$PipeEtape4$Update$reglage, reponse, model.l2);
		if (!_v0.$) {
			switch (_v0.a.b.$) {
				case 0:
					var _v1 = _v0.a;
					var envoi = _v1.a;
					var _v2 = _v1.b;
					var effets = _v1.c;
					var _v3 = A3(
						$author$project$Components$Shared$Drawer$Update$update,
						{Il: false},
						$author$project$Components$Shared$Drawer$Update$Fermer,
						model.kX);
					var drawer = _v3.a;
					var deDrawer = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{fw: $elm$core$Maybe$Nothing, kX: drawer, l2: envoi, pZ: $elm$core$Maybe$Nothing, hP: $elm$core$Maybe$Nothing}),
						_Utils_ap(
							effets,
							_Utils_ap(
								A2(
									$elm$core$List$map,
									function (_v4) {
										var cible = _v4;
										return $author$project$Components$Parametrage$PipeEtape4$Update$PlacerFocus(cible);
									},
									deDrawer),
								A2(
									$author$project$Components$Parametrage$PipeEtape4$Update$lireSi,
									$author$project$Components$Parametrage$PipeEtape4$Update$LesTaches,
									A2(
										$elm$core$Maybe$andThen,
										function (taches) {
											return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$self, taches.nQ);
										},
										model.Jk)))));
				case 1:
					var _v5 = _v0.a;
					var envoi = _v5.a;
					var _v6 = _v5.b;
					var refus = _v6.b;
					var effets = _v5.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l2: envoi,
								pZ: $elm$core$Maybe$Just(
									$author$project$Components$Parametrage$Vocabulaire$messageDuRefusDeModele(refus))
							}),
						effets);
				default:
					var _v7 = _v0.a;
					var envoi = _v7.a;
					var _v8 = _v7.b;
					var effets = _v7.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{l2: envoi}),
						effets);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$retirerUneTache = 'retirer-une-tache';
var $author$project$Components$Parametrage$PipeEtape4$API$WriteAPIModel$ModifierUneTache = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$Model$libellesVoulus = function (libelles) {
	var gardes = A2(
		$elm$core$Dict$map,
		F2(
			function (_v1, texte) {
				return $elm$core$String$trim(texte);
			}),
		A2(
			$elm$core$Dict$filter,
			F2(
				function (_v0, texte) {
					return $elm$core$String$trim(texte) !== '';
				}),
			libelles));
	return A2($elm$core$Dict$member, 'fr', gardes) ? $elm$core$Maybe$Just(gardes) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$Parametrage$PipeEtape4$Model$roleDeLaTache = function (saisie) {
	return (saisie.H6 === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(saisie.H6);
};
var $author$project$Components$Parametrage$PipeEtape4$Model$tacheVoulue = function (saisie) {
	return A2(
		$elm$core$Maybe$map,
		function (libelles) {
			return $author$project$Components$Parametrage$PipeEtape4$API$WriteAPIModel$ModifierUneTache(
				{
					mR: $author$project$Components$Parametrage$PipeEtape4$Model$nonVide(saisie.mR),
					R: libelles,
					EX: $elm$core$Dict$toList(saisie.EX),
					hz: {
						jg: saisie.jg,
						kB: (saisie.xY === 'apres-l-arrivee-a-l-etape') ? $elm$core$String$toInt(
							$elm$core$String$trim(saisie.w2)) : $elm$core$Maybe$Nothing,
						xY: saisie.xY,
						he: saisie.he,
						GV: (saisie.Hq === 'rappel-avant') ? saisie.gN : _List_Nil,
						Hq: saisie.Hq,
						KS: saisie.KS
					},
					H6: $author$project$Components$Parametrage$PipeEtape4$Model$roleDeLaTache(saisie),
					e8: saisie.B1.r8
				});
		},
		$author$project$Components$Parametrage$PipeEtape4$Model$libellesVoulus(saisie.R));
};
var $author$project$Components$Parametrage$PipeEtape4$Update$versLApi = F3(
	function (lien, model, commande) {
		if (!commande.$) {
			var voulue = commande.a;
			var _v1 = A4($author$project$API$Envoi$partir, $author$project$Components$Parametrage$PipeEtape4$Update$reglage, lien, voulue, model.l2);
			if (!_v1.$) {
				var _v2 = _v1.a;
				var envoi = _v2.a;
				var effets = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{l2: envoi, pZ: $elm$core$Maybe$Nothing}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$sortiesDuDrawer = _List_fromArray(
	[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$SortieDemandee, $author$project$Components$Shared$Drawer$Update$AbandonConfirme]);
var $author$project$Components$Parametrage$PipeEtape4$Update$versLeDrawer = F2(
	function (geste, model) {
		if ($author$project$API$Envoi$enCours(model.l2) && A2($elm$core$List$member, geste, $author$project$Components$Parametrage$PipeEtape4$Update$sortiesDuDrawer)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v0 = A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.kX);
			var drawer = _v0.a;
			var effets = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						fw: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? model.fw : $elm$core$Maybe$Nothing,
						kX: drawer,
						hP: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? model.hP : $elm$core$Maybe$Nothing
					}),
				A2(
					$elm$core$List$map,
					function (_v1) {
						var cible = _v1;
						return $author$project$Components$Parametrage$PipeEtape4$Update$PlacerFocus(cible);
					},
					effets));
		}
	});
var $author$project$API$NavLinksDictionary$voirLesDifferencesAvecLeModele = 'voir-les-differences-avec-le-modele';
var $author$project$Components$Parametrage$PipeEtape4$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var code = msg.a;
				var liens = msg.b;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$pipes, liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						$author$project$Components$Parametrage$PipeEtape4$Model$init(code),
						_List_fromArray(
							[
								$author$project$Components$Parametrage$PipeEtape4$Update$DemanderProcessUid,
								A2($author$project$Components$Parametrage$PipeEtape4$Update$Lire, $author$project$Components$Parametrage$PipeEtape4$Update$Annuaire, lecture)
							]));
				} else {
					return _Utils_Tuple2(
						$author$project$Components$Parametrage$PipeEtape4$Model$init(code),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 2:
				var lecture = msg.a;
				var reponse = msg.b;
				return A3($author$project$Components$Parametrage$PipeEtape4$Update$lu, lecture, reponse, model);
			case 3:
				var reponse = msg.a;
				return A2($author$project$Components$Parametrage$PipeEtape4$Update$repondue, reponse, model);
			case 4:
				var geste = msg.a;
				return A2($author$project$Components$Parametrage$PipeEtape4$Update$versLeDrawer, geste, model);
			case 5:
				var etapeUid = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$lireSi,
						$author$project$Components$Parametrage$PipeEtape4$Update$LeChoix(etapeUid),
						A2($author$project$Components$Parametrage$PipeEtape4$Update$lienDuChoix, etapeUid, model)));
			case 6:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLAjout,
						function (ajout) {
							return _Utils_update(
								ajout,
								{mR: '', r0: code});
						},
						model),
					_List_Nil);
			case 7:
				var uid = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLAjout,
						function (ajout) {
							return _Utils_update(
								ajout,
								{mR: uid});
						},
						model),
					_List_Nil);
			case 8:
				var uid = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						function (saisie) {
							return _Utils_update(
								saisie,
								{mR: uid});
						},
						model),
					_List_Nil);
			case 9:
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						function (saisie) {
							return _Utils_update(
								saisie,
								{jI: !saisie.jI});
						},
						model),
					_List_Nil);
			case 10:
				var uid = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLAjout,
						function (ajout) {
							return _Utils_update(
								ajout,
								{H6: uid});
						},
						model),
					_List_Nil);
			case 11:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLAjout,
						function (ajout) {
							return _Utils_update(
								ajout,
								{eG: code});
						},
						model),
					_List_Nil);
			case 12:
				var nomDuType = msg.a;
				return A3(
					$author$project$Components$Parametrage$PipeEtape4$Update$versLApi,
					A2($author$project$Components$Parametrage$PipeEtape4$Update$lienDeLAjout, $author$project$API$NavLinksDictionary$ajouterUneTache, model),
					model,
					A2(
						$elm$core$Maybe$andThen,
						$author$project$Components$Parametrage$PipeEtape4$Model$ajoutVoulu(nomDuType),
						model.fw));
			case 13:
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$lireSi,
						$author$project$Components$Parametrage$PipeEtape4$Update$LeChoixDuType,
						A2(
							$elm$core$Maybe$andThen,
							function (saisie) {
								return A2($author$project$Components$Parametrage$PipeEtape4$Update$lienDuChoixDeLaTache, saisie, model);
							},
							model.hP)));
			case 14:
				return _Utils_Tuple2(
					A2($author$project$Components$Parametrage$PipeEtape4$Update$surLaTache, $author$project$Components$Parametrage$PipeEtape4$Model$ajouterUnSignataire, model),
					_List_Nil);
			case 52:
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$lireSi,
						$author$project$Components$Parametrage$PipeEtape4$Update$LesDifferences,
						A2(
							$elm$core$Maybe$andThen,
							function (saisie) {
								return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$voirLesDifferencesAvecLeModele, saisie.B1.nQ);
							},
							model.hP)));
			case 21:
				var uid = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$lireSi,
						$author$project$Components$Parametrage$PipeEtape4$Update$UneTache,
						A2($author$project$Components$Parametrage$PipeEtape4$Update$lectureDeLaTache, uid, model)));
			case 22:
				var langue = msg.a;
				var texte = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						function (saisie) {
							return _Utils_update(
								saisie,
								{
									R: A3($elm$core$Dict$insert, langue, texte, saisie.R)
								});
						},
						model),
					_List_Nil);
			case 23:
				var uid = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						$author$project$Components$Parametrage$PipeEtape4$Update$choisirLeRole(uid),
						model),
					_List_Nil);
			case 24:
				var cle = msg.a;
				var valeur = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						A2($author$project$Components$Parametrage$PipeEtape4$Model$poserTexte, cle, valeur),
						model),
					_List_Nil);
			case 25:
				var cle = msg.a;
				var texte = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						A2($author$project$Components$Parametrage$PipeEtape4$Model$poserEntier, cle, texte),
						model),
					_List_Nil);
			case 26:
				var cle = msg.a;
				var valeur = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						A2($author$project$Components$Parametrage$PipeEtape4$Model$poserTexteOuNul, cle, valeur),
						model),
					_List_Nil);
			case 28:
				var cle = msg.a;
				var code = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						A2($author$project$Components$Parametrage$PipeEtape4$Model$poserListeUnique, cle, code),
						model),
					_List_Nil);
			case 27:
				var cle = msg.a;
				var oui = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						A2($author$project$Components$Parametrage$PipeEtape4$Model$poserBooleen, cle, oui),
						model),
					_List_Nil);
			case 29:
				var cle = msg.a;
				var code = msg.b;
				var oui = msg.c;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						A3($author$project$Components$Parametrage$PipeEtape4$Model$basculerDansListe, cle, code, oui),
						model),
					_List_Nil);
			case 30:
				var objet = msg.a;
				var champ = msg.b;
				var valeur = msg.c;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						A3($author$project$Components$Parametrage$PipeEtape4$Model$poserTexteImbrique, objet, champ, valeur),
						model),
					_List_Nil);
			case 31:
				var objet = msg.a;
				var champ = msg.b;
				var texte = msg.c;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						A3($author$project$Components$Parametrage$PipeEtape4$Model$poserEntierImbrique, objet, champ, texte),
						model),
					_List_Nil);
			case 32:
				var objet = msg.a;
				var champ = msg.b;
				var oui = msg.c;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						A3($author$project$Components$Parametrage$PipeEtape4$Model$poserBooleenImbrique, objet, champ, oui),
						model),
					_List_Nil);
			case 33:
				var objet = msg.a;
				var champ = msg.b;
				var texte = msg.c;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						A3($author$project$Components$Parametrage$PipeEtape4$Model$poserListeDEntiersImbriquee, objet, champ, texte),
						model),
					_List_Nil);
			case 34:
				var oui = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						$author$project$Components$Parametrage$PipeEtape4$Model$poserRappelSansReponse(oui),
						model),
					_List_Nil);
			case 35:
				var roleUid = msg.a;
				var oui = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						A2($author$project$Components$Parametrage$PipeEtape4$Model$basculerParticipant, roleUid, oui),
						model),
					_List_Nil);
			case 36:
				var genre = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$modifierImbrique,
							'quiValide',
							A2(
								$elm$core$Dict$insert,
								'genre',
								$elm$json$Json$Encode$string(genre))),
						model),
					_List_Nil);
			case 37:
				var cle = msg.a;
				var uid = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$modifierImbrique,
							'quiValide',
							A2(
								$elm$core$Dict$insert,
								cle,
								$elm$json$Json$Encode$string(uid))),
						model),
					_List_Nil);
			case 38:
				var mode = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$modifierImbrique,
							'relance',
							A2(
								$elm$core$Dict$insert,
								'mode',
								$elm$json$Json$Encode$string(mode))),
						model),
					_List_Nil);
			case 39:
				var texte = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$modifierImbrique,
							'escalade',
							$author$project$Components$Parametrage$PipeEtape4$Update$apresEnJours(texte)),
						model),
					_List_Nil);
			case 40:
				var uid = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$modifierImbrique,
							'escalade',
							A2(
								$elm$core$Dict$insert,
								'vers',
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'roleUid',
											$elm$json$Json$Encode$string(uid))
										])))),
						model),
					_List_Nil);
			case 41:
				var code = msg.a;
				var cochee = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						A2($author$project$Components$Parametrage$PipeEtape4$Model$basculerDecision, code, cochee),
						model),
					_List_Nil);
			case 42:
				var oui = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						function (saisie) {
							return _Utils_update(
								saisie,
								{
									EX: A3(
										$elm$core$Dict$insert,
										'commentaireObligatoireSiRefusOuReprise',
										$elm$json$Json$Encode$bool(oui),
										saisie.EX)
								});
						},
						model),
					_List_Nil);
			case 43:
				var mode = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						function (saisie) {
							return _Utils_update(
								saisie,
								{xY: mode});
						},
						model),
					_List_Nil);
			case 44:
				var texte = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						function (saisie) {
							return _Utils_update(
								saisie,
								{w2: texte});
						},
						model),
					_List_Nil);
			case 45:
				var mode = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						function (saisie) {
							return _Utils_update(
								saisie,
								{Hq: mode});
						},
						model),
					_List_Nil);
			case 46:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						function (saisie) {
							return _Utils_update(
								saisie,
								{jg: code});
						},
						model),
					_List_Nil);
			case 47:
				var oui = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						function (saisie) {
							return _Utils_update(
								saisie,
								{he: oui});
						},
						model),
					_List_Nil);
			case 48:
				var oui = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLaTache,
						function (saisie) {
							return _Utils_update(
								saisie,
								{KS: oui});
						},
						model),
					_List_Nil);
			case 49:
				return A3(
					$author$project$Components$Parametrage$PipeEtape4$Update$versLApi,
					A2($author$project$Components$Parametrage$PipeEtape4$Update$lienDeLaTache, $author$project$API$NavLinksDictionary$modifierUneTache, model),
					model,
					A2($elm$core$Maybe$andThen, $author$project$Components$Parametrage$PipeEtape4$Model$tacheVoulue, model.hP));
			case 50:
				return A3(
					$author$project$Components$Parametrage$PipeEtape4$Update$versLApi,
					A2($author$project$Components$Parametrage$PipeEtape4$Update$lienDeLaTache, $author$project$API$NavLinksDictionary$retirerUneTache, model),
					model,
					A2(
						$elm$core$Maybe$map,
						function (saisie) {
							return $author$project$Components$Parametrage$PipeEtape4$API$WriteAPIModel$RetirerUneTache(saisie.B1.r8);
						},
						model.hP));
			case 51:
				return A3(
					$author$project$Components$Parametrage$PipeEtape4$Update$versLApi,
					A2($author$project$Components$Parametrage$PipeEtape4$Update$lienDeLaTache, $author$project$API$NavLinksDictionary$appliquerLaVersionDuModele, model),
					model,
					A2(
						$elm$core$Maybe$andThen,
						function (saisie) {
							return A2(
								$elm$core$Maybe$map,
								function (modele) {
									return $author$project$Components$Parametrage$PipeEtape4$API$WriteAPIModel$AppliquerLaVersion(
										{e8: saisie.B1.r8, KI: modele.KH});
								},
								saisie.B1.oa);
						},
						model.hP));
			case 16:
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLAjout,
						function (ajout) {
							return _Utils_update(
								ajout,
								{
									dq: $elm$core$Maybe$Just(
										{vd: $elm$core$Maybe$Nothing, M: '', hC: ''})
								});
						},
						model),
					_List_Nil);
			case 17:
				var recherche = msg.a;
				return A2(
					$author$project$Components$Parametrage$PipeEtape4$Update$filtrerLaBibliotheque,
					function (b) {
						return _Utils_update(
							b,
							{hC: recherche});
					},
					model);
			case 18:
				var genre = msg.a;
				return A2(
					$author$project$Components$Parametrage$PipeEtape4$Update$filtrerLaBibliotheque,
					function (b) {
						return _Utils_update(
							b,
							{M: genre});
					},
					model);
			case 19:
				var uid = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Update$surLAjout,
						function (ajout) {
							return _Utils_update(
								ajout,
								{
									dq: A2(
										$elm$core$Maybe$map,
										function (b) {
											return _Utils_update(
												b,
												{
													vd: $elm$core$Maybe$Just(uid)
												});
										},
										ajout.dq)
								});
						},
						model),
					_List_Nil);
			case 20:
				return A3(
					$author$project$Components$Parametrage$PipeEtape4$Update$versLApi,
					A2($author$project$Components$Parametrage$PipeEtape4$Update$lienDeLAjout, $author$project$API$NavLinksDictionary$insererUnModeleDeTache, model),
					model,
					A2(
						$elm$core$Maybe$andThen,
						function (ajout) {
							return A2(
								$elm$core$Maybe$andThen,
								function (uid) {
									return A2(
										$elm$core$Maybe$map,
										$author$project$Components$Parametrage$PipeEtape4$Model$insertionVoulue(ajout),
										$elm$core$List$head(
											A2(
												$elm$core$List$filter,
												function (modele) {
													return _Utils_eq(modele.r8, uid);
												},
												ajout.jN.CI)));
								},
								A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.vd;
									},
									ajout.dq));
						},
						model.fw));
			default:
				var uid = msg.a;
				return A3(
					$author$project$Components$Parametrage$PipeEtape4$Update$versLApi,
					A2($author$project$Components$Parametrage$PipeEtape4$Update$lienDeLAjout, $author$project$API$NavLinksDictionary$insererUnModeleDeTache, model),
					model,
					A2(
						$elm$core$Maybe$andThen,
						function (ajout) {
							return A2(
								$elm$core$Maybe$andThen,
								$author$project$Components$Parametrage$PipeEtape4$Model$modeleVoulu(ajout),
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (modele) {
											return _Utils_eq(modele.r8, uid);
										},
										ajout.jN.CI)));
						},
						model.fw));
		}
	});
var $author$project$Main$Update$versLEtape4DUnPipe = F3(
	function (i18n, msg, model) {
		var _v0 = A2(
			$author$project$Components$Parametrage$PipeEtape4$Update$update,
			msg,
			$author$project$Components$Parametrage$PipeEtape4$Model$ouvrir(model.FB));
		var etape4 = _v0.a;
		var effets = _v0.b;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLEtape4DUnPipe,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Parametrage$PipeEtape4$Update$popMessages(msg),
							model.Ct),
						FB: $author$project$Components$Parametrage$PipeEtape4$Model$envelopper(etape4)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$EnvoyerALEtape5DUnPipe = function (a) {
	return {$: 92, a: a};
};
var $author$project$Main$Update$LireLEtape5DUnPipe = F2(
	function (a, b) {
		return {$: 87, a: a, b: b};
	});
var $author$project$Main$Model$PourLEtape5DUnPipe = 21;
var $author$project$Main$Update$depuisLEtape5DUnPipe = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				var lecture = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLEtape5DUnPipe(lecture))));
			case 1:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerALEtape5DUnPipe(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[21]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 3:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$Edition = F3(
	function (uid, libelles, liens) {
		return {R: libelles, nQ: liens, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$editionDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['pipe', 'libelles']),
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['pipe', 'uid']),
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$Edition))));
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$FormulaireLu = function (uid) {
	return function (libelles) {
		return function (type_) {
			return function (etat) {
				return function (modifiable) {
					return function (figeParLaVersion) {
						return function (sertPour) {
							return function (ficheVisee) {
								return function (natureDeLaFicheVisee) {
									return function (motDossier) {
										return function (champs) {
											return function (champsRetires) {
												return function (notation) {
													return function (options) {
														return function (importDuFormulaire) {
															return function (requisDeLEtape) {
																return function (liens) {
																	return function (destinations) {
																		return {dw: champs, u1: champsRetires, kM: destinations, gt: etat, zt: ficheVisee, mB: figeParLaVersion, Az: importDuFormulaire, R: libelles, nQ: liens, g_: modifiable, CW: motDossier, C3: natureDeLaFicheVisee, DQ: notation, o_: options, HL: requisDeLEtape, IJ: sertPour, r0: type_, r8: uid};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$Champ = function (uid) {
	return function (libelles) {
		return function (type_) {
			return function (destination) {
				return function (aValider) {
					return function (obligatoire) {
						return function (visibleSurLePortail) {
							return function (remplissage) {
								return function (prerempli) {
									return function (controle) {
										return function (note) {
											return function (bornes) {
												return function (echelle) {
													return function (retireLe) {
														return function (retirePar) {
															return function (requisPourPasser) {
																return function (quandLaFicheARenseigne) {
																	return function (depotDeFichiers) {
																		return function (importDesLignes) {
																			return function (colonnes) {
																				return function (validationDuReport) {
																					return {sI: aValider, us: bornes, j1: colonnes, wb: controle, xd: depotDeFichiers, xw: destination, lK: echelle, Ay: importDesLignes, R: libelles, oJ: note, he: obligatoire, Gi: prerempli, GH: quandLaFicheARenseigne, HC: remplissage, HM: requisPourPasser, H_: retireLe, H$: retirePar, r0: type_, r8: uid, Kt: validationDuReport, KS: visibleSurLePortail};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$Bornes = F2(
	function (minimum, maximum) {
		return {Cj: maximum, CD: minimum};
	});
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$bornesDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$Bornes,
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'minimum', $elm$json$Json$Decode$float)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'maximum', $elm$json$Json$Decode$float)));
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$ChampNote = F5(
	function (poids, seuil, echelle, niveaux, conversion) {
		return {wd: conversion, lK: echelle, C9: niveaux, FV: poids, IL: seuil};
	});
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$echelleDecoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (min, max) {
			return {Cg: max, Cx: min};
		}),
	A2($elm$json$Json$Decode$field, 'min', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'max', $elm$json$Json$Decode$int));
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$champNoteDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (poids) {
		if (!poids.$) {
			var p = poids.a;
			return A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'conversion',
					A2(
						$elm$json$Json$Decode$map,
						$elm$core$Dict$toList,
						$elm$json$Json$Decode$dict($elm$json$Json$Decode$int)),
					_List_Nil,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'niveaux',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'note',
							$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$echelleDecoder),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'commentaireObligatoireSousLeSeuil',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
								$elm$core$Maybe$Nothing,
								$elm$json$Json$Decode$succeed(
									$author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$ChampNote(p)))))));
		} else {
			return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
		}
	},
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'poids', $elm$json$Json$Decode$int)));
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$Colonne = F6(
	function (cle, libelle, typeDeChamp, valeurs, typeVise, formule) {
		return {dy: cle, zU: formule, Bl: libelle, JR: typeDeChamp, r$: typeVise, Ki: valeurs};
	});
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$colonneDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'formule',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'typeVise',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'valeurs',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			_List_Nil,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'typeDeChamp',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'libelle',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'cle',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$Colonne)))))));
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$Controle = F4(
	function (bloque, role, etape, visibilite) {
		return {ur: bloque, me: etape, bi: role, KQ: visibilite};
	});
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$RoleFormes = F4(
	function (uid, libelle, grammaire, parRelation) {
		return {m$: grammaire, Bl: libelle, EW: parRelation, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$roleFormesDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'parRelation',
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'grammaire',
		$elm$json$Json$Decode$nullable($author$project$Catalogue$Formes$decoder),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'libelle',
			$elm$json$Json$Decode$string,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'uid',
				$elm$json$Json$Decode$string,
				'',
				$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$RoleFormes)))));
var $author$project$API$NavLinksDictionary$visibiliteDeLEtape = 'visibilite-de-l-etape';
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$controleDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$visibiliteDeLEtape),
		$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'controleDetail',
		$elm$json$Json$Decode$nullable(
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['etape', 'libelle']),
				$elm$json$Json$Decode$string)),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'controleDetail',
			$elm$json$Json$Decode$nullable(
				A2($elm$json$Json$Decode$field, 'role', $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$roleFormesDecoder)),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'controle',
				A2(
					$elm$json$Json$Decode$map,
					function (code) {
						return code === 'bloque-la-publication';
					},
					$elm$json$Json$Decode$string),
				false,
				$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$Controle)))));
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$Destination = F7(
	function (type_, roleUid, champ, libelle, ressource, dossier, existant) {
		return {uN: champ, xI: dossier, y0: existant, Bl: libelle, HN: ressource, H6: roleUid, r0: type_};
	});
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$destinationDecoder = A8(
	$elm$json$Json$Decode$map7,
	$author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$Destination,
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'roleUid', $elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$maybe(
		A2(
			$elm$json$Json$Decode$field,
			'ressource',
			A3(
				$elm$json$Json$Decode$map2,
				F2(
					function (uid, libelle) {
						return {Bl: libelle, r8: uid};
					}),
				A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string)))),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'dossier', $elm$json$Json$Decode$bool),
				$elm$json$Json$Decode$succeed(false)
			])),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'existant', $elm$json$Json$Decode$bool),
				$elm$json$Json$Decode$succeed(false)
			])));
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$ValidationDuReport = F2(
	function (formulaire, commentaire) {
		return {vM: commentaire, zT: formulaire};
	});
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$validationDuReportDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$ValidationDuReport,
	A2($elm$json$Json$Decode$field, 'formulaire', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'commentaire', $elm$json$Json$Decode$string));
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$champDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'validationDuReport',
	$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$validationDuReportDecoder),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'colonnes',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$colonneDecoder),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'importDesLignes',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'depotDeFichiers',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'quandLaFicheARenseigne',
					$elm$json$Json$Decode$string,
					'toujours-demander',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'requisPourPasser',
						$elm$json$Json$Decode$bool,
						false,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'retirePar',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'retireLe',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'echelle',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'bornes',
										$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$bornesDecoder),
										$elm$core$Maybe$Nothing,
										A2(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
											$author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$champNoteDecoder,
											A2(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
												$author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$controleDecoder,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'prerempli',
													$elm$json$Json$Decode$bool,
													false,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'remplissage',
														$elm$json$Json$Decode$string,
														'personne',
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'visibleSurLePortail',
															$elm$json$Json$Decode$bool,
															false,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'obligatoire',
																$elm$json$Json$Decode$bool,
																false,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'aValider',
																	$elm$json$Json$Decode$nullable(
																		A2($elm$json$Json$Decode$field, 'roleUid', $elm$json$Json$Decode$string)),
																	$elm$core$Maybe$Nothing,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'destination',
																		$author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$destinationDecoder,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'type',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'libelles',
																				$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'uid',
																					$elm$json$Json$Decode$string,
																					$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$Champ))))))))))))))))))))));
var $author$project$API$NavLinksDictionary$destinationsDesChamps = 'destinations-des-champs';
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$ImportDuFormulaire = F2(
	function (uneLigneEst, parLesPortails) {
		return {ER: parLesPortails, J7: uneLigneEst};
	});
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$importDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$ImportDuFormulaire,
	A2($elm$json$Json$Decode$field, 'uneLigneEst', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'parLesPortails', $elm$json$Json$Decode$bool));
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$Notation = F9(
	function (noteDUneReponse, entreRepondants, champDuDossierAlimente, unRepondantNeVoitPasLesAutres, reponsesAnonymes, statistiquesAPartirDe, quandLaNoteEstEcrite, apercu, sommeDesPoids) {
		return {tq: apercu, uO: champDuDossierAlimente, yu: entreRepondants, DS: noteDUneReponse, GI: quandLaNoteEstEcrite, HJ: reponsesAnonymes, IP: sommeDesPoids, I_: statistiquesAPartirDe, J6: unRepondantNeVoitPasLesAutres};
	});
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$notationDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'sommeDesPoids',
	$elm$json$Json$Decode$int,
	100,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'apercu',
		A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (texte, noteCalculee) {
					return {DR: noteCalculee, Jx: texte};
				}),
			A2($elm$json$Json$Decode$field, 'texte', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'noteCalculee', $elm$json$Json$Decode$string)),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'quandLaNoteEstEcrite',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'statistiquesAPartirDe',
				$elm$json$Json$Decode$int,
				5,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'reponsesAnonymes',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'unRepondantNeVoitPasLesAutres',
						$elm$json$Json$Decode$bool,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'champDuDossierAlimente',
							$elm$json$Json$Decode$nullable(
								A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string)),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'entreRepondants',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'noteDUneReponse',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$Notation))))))))));
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$ChampDeLaFiche = F4(
	function (code, libelle, type_, plusieurs) {
		return {vx: code, Bl: libelle, FS: plusieurs, r0: type_};
	});
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$ChampDuDossier = F2(
	function (code, libelle) {
		return {vx: code, Bl: libelle};
	});
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$Options = F8(
	function (destinations, validateurs, roles, champsDuDossier, ressourcesLiees, types, champsDeLaFiche, typesCreablesSurLaFiche) {
		return {uV: champsDeLaFiche, uX: champsDuDossier, kM: destinations, HP: ressourcesLiees, eX: roles, ib: types, JZ: typesCreablesSurLaFiche, Kr: validateurs};
	});
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$RessourceLiee = F3(
	function (uid, libelle, champs) {
		return {dw: champs, Bl: libelle, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$ressourceLieeDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$RessourceLiee,
	A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'champs',
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$ChampDuDossier,
				A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string)))));
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$optionsDecoder = A9(
	$elm$json$Json$Decode$map8,
	$author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$Options,
	A2(
		$elm$json$Json$Decode$field,
		'destinations',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$field,
		'validateurs',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$roleFormesDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'roles',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$roleFormesDecoder)),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'champsDuDossier',
				$elm$json$Json$Decode$list(
					A3(
						$elm$json$Json$Decode$map2,
						$author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$ChampDuDossier,
						A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
						A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string)))),
				$elm$json$Json$Decode$succeed(_List_Nil)
			])),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'ressourcesLiees',
				$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$ressourceLieeDecoder)),
				$elm$json$Json$Decode$succeed(_List_Nil)
			])),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'types',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$succeed(_List_Nil)
			])),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'champsDeLaFiche',
				$elm$json$Json$Decode$nullable(
					$elm$json$Json$Decode$list(
						A5(
							$elm$json$Json$Decode$map4,
							$author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$ChampDeLaFiche,
							A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
							A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string),
							$elm$json$Json$Decode$maybe(
								A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string)),
							$elm$json$Json$Decode$oneOf(
								_List_fromArray(
									[
										A2($elm$json$Json$Decode$field, 'plusieurs', $elm$json$Json$Decode$bool),
										$elm$json$Json$Decode$succeed(false)
									])))))),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			])),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'typesCreablesSurLaFiche',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$succeed(_List_Nil)
			])));
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$RequisDeLEtape = F2(
	function (etape, champs) {
		return {dw: champs, me: etape};
	});
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$requisDeLEtapeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'champs',
	$elm$json$Json$Decode$list(
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'etape',
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$RequisDeLEtape)));
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$SertPour = F2(
	function (etape, tache) {
		return {me: etape, Jj: tache};
	});
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$sertPourDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$SertPour,
	A2($elm$json$Json$Decode$field, 'etape', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'tache', $elm$json$Json$Decode$string));
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$formulaireDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$destinationsDesChamps),
		$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder),
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'requisDeLEtape',
			$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$requisDeLEtapeDecoder),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'importDuFormulaire',
				$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$importDecoder),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'options',
					$author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$optionsDecoder,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'notation',
						$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$notationDecoder),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'champsRetires',
							$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$champDecoder),
							_List_Nil,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'champs',
								$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$champDecoder),
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'motDossier',
									$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$roleFormesDecoder),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'natureDeLaFicheVisee',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'ficheVisee',
											$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$roleFormesDecoder),
											$elm$core$Maybe$Nothing,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'sertPour',
												$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$sertPourDecoder),
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'figeParLaVersion',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
													$elm$core$Maybe$Nothing,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'modifiable',
														$elm$json$Json$Decode$bool,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'etat',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'type',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'libelles',
																	$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'uid',
																		$elm$json$Json$Decode$string,
																		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$FormulaireLu)))))))))))))))))));
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$Formulaires = F4(
	function (formulaires, resume, apercu, liens) {
		return {tq: apercu, aA: formulaires, nQ: liens, HX: resume};
	});
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$Apercu = F2(
	function (pour, formulaires) {
		return {aA: formulaires, F8: pour};
	});
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$apercuDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$Apercu,
	A2($elm$json$Json$Decode$field, 'pour', $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$roleFormesDecoder),
	A2(
		$elm$json$Json$Decode$field,
		'formulaires',
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				F2(
					function (libelle, champs) {
						return {dw: champs, Bl: libelle};
					}),
				A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'champs', $elm$json$Json$Decode$string)))));
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$Carte = function (uid) {
	return function (libelles) {
		return function (type_) {
			return function (sertPour) {
				return function (nombreDeChamps) {
					return function (nombreDeChampsNotes) {
						return function (portee) {
							return function (etat) {
								return function (figeParLaVersion) {
									return function (lecture) {
										return function (destinations) {
											return {kM: destinations, gt: etat, mB: figeParLaVersion, np: lecture, R: libelles, Dv: nombreDeChamps, Dw: nombreDeChampsNotes, F$: portee, IJ: sertPour, r0: type_, r8: uid};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$API$NavLinksDictionary$formulaireDuPipe = 'formulaire';
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$Portee = F2(
	function (type_, avecNPipes) {
		return {ug: avecNPipes, r0: type_};
	});
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$porteeDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$Portee,
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'avecNPipes', $elm$json$Json$Decode$int)));
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$carteDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$destinationsDesChamps),
		$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder),
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		A2(
			$elm$json$Json$Decode$map,
			$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$formulaireDuPipe),
			$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'figeParLaVersion',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'etat',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'portee',
					$author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$porteeDecoder,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'nombreDeChampsNotes',
						$elm$json$Json$Decode$int,
						0,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'nombreDeChamps',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'sertPour',
								$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$sertPourDecoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'type',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'libelles',
										$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'uid',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$Carte))))))))))));
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$Resume = F2(
	function (nombreDeFormulaires, nombreDeChamps) {
		return {Dv: nombreDeChamps, DA: nombreDeFormulaires};
	});
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$resumeDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$Resume,
	A2($elm$json$Json$Decode$field, 'nombreDeFormulaires', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'nombreDeChamps', $elm$json$Json$Decode$int));
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$formulairesDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'apercu',
		$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$apercuDecoder),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'resume',
			$author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$resumeDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'formulaires',
				$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$carteDecoder),
				$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$Formulaires)))));
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$TypeDePartiePrenante = F2(
	function (uid, libelle) {
		return {Bl: libelle, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$typesDePartiePrenanteDecoder = A2(
	$elm$json$Json$Decode$field,
	'typesDePartiePrenante',
	$elm$json$Json$Decode$list(
		A3(
			$elm$json$Json$Decode$map2,
			$author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$TypeDePartiePrenante,
			A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string))));
var $author$project$Components$Parametrage$PipeEtape5$Update$refusDeLecture = F2(
	function (lecture, reponse) {
		var refuse = function (decodeur) {
			var _v1 = A2($author$project$API$Reponse$lire, decodeur, reponse);
			if (_v1.$ === 1) {
				var refus = _v1.a;
				return ((refus.ri === 401) || (refus.ri === 404)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Components$Shared$Messages$Model$duRefus(refus));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		switch (lecture) {
			case 0:
				return refuse($author$project$Components$Parametrage$Common$API$QueryAPIModel$annuaireDecoder);
			case 1:
				return refuse($author$project$Components$Parametrage$Common$API$QueryAPIModel$racineDuPipeDecoder);
			case 2:
				return refuse($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$editionDecoder);
			case 3:
				return refuse($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$formulairesDecoder);
			case 4:
				return refuse($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$formulaireDecoder);
			default:
				return refuse($author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$typesDePartiePrenanteDecoder);
		}
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$popMessages = function (msg) {
	if (msg.$ === 2) {
		var lecture = msg.a;
		var reponse = msg.b;
		return A2($author$project$Components$Parametrage$PipeEtape5$Update$refusDeLecture, lecture, reponse);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$PipeEtape5$Update$Annuaire = 0;
var $author$project$Components$Parametrage$PipeEtape5$Update$DemanderProcessUid = {$: 2};
var $author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$DupliquerUnFormulaire = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$Lire = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$RestaurerUnChamp = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$RetirerUnChamp = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$RetirerUnFormulaire = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$UnFormulaire = 4;
var $author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$AjouterUnChamp = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Model$bornesTapees = F3(
	function (type_, minimum, maximum) {
		var lue = function (texte) {
			return ($elm$core$String$trim(texte) === '') ? $elm$core$Maybe$Just($elm$core$Maybe$Nothing) : A2(
				$elm$core$Maybe$map,
				$elm$core$Maybe$Just,
				$elm$core$String$toFloat(
					$elm$core$String$trim(
						A3($elm$core$String$replace, ',', '.', texte))));
		};
		if (type_ !== 'nombre') {
			return $elm$core$Maybe$Just($elm$core$Maybe$Nothing);
		} else {
			var _v0 = _Utils_Tuple2(
				lue(minimum),
				lue(maximum));
			if ((!_v0.a.$) && (!_v0.b.$)) {
				if ((_v0.a.a.$ === 1) && (_v0.b.a.$ === 1)) {
					var _v1 = _v0.a.a;
					var _v2 = _v0.b.a;
					return $elm$core$Maybe$Just($elm$core$Maybe$Nothing);
				} else {
					var mini = _v0.a.a;
					var maxi = _v0.b.a;
					return $elm$core$Maybe$Just(
						$elm$core$Maybe$Just(
							{Cj: maxi, CD: mini}));
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$ajoutVoulu = function (saisie) {
	return A2(
		$elm$core$Maybe$andThen,
		function (a) {
			var valeurs = A2(
				$elm$core$List$filter,
				function (v) {
					return v !== '';
				},
				A2(
					$elm$core$List$map,
					$elm$core$String$trim,
					$elm$core$String$lines(a.Ki)));
			var choix = (a.r0 === 'choix-unique') || (a.r0 === 'choix-multiple');
			var _v0 = A3($author$project$Components$Parametrage$PipeEtape5$Model$bornesTapees, a.r0, a.CD, a.Cj);
			if (_v0.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var bornes = _v0.a;
				return (($elm$core$String$trim(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Dict$get, 'fr', a.R))) === '') || ((choix && $elm$core$List$isEmpty(valeurs)) || (a.cW && _Utils_eq(a.du, $elm$core$Maybe$Nothing)))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$AjouterUnChamp(
						{
							us: bornes,
							uB: ((a.r0 === 'calcule') && ($elm$core$String$trim(a.uB) !== '')) ? $elm$core$Maybe$Just(
								$elm$core$String$trim(a.uB)) : $elm$core$Maybe$Nothing,
							du: a.cW ? a.du : $elm$core$Maybe$Nothing,
							mR: saisie.B1.r8,
							R: A2(
								$elm$core$Dict$filter,
								F2(
									function (_v1, v) {
										return $elm$core$String$trim(v) !== '';
									}),
								a.R),
							r0: a.r0,
							Ki: valeurs
						}));
			}
		},
		saisie.fw);
};
var $author$project$API$NavLinksDictionary$ajouterUnChampDeFormulaire = 'ajouter-un-champ-de-formulaire';
var $author$project$Components$Parametrage$PipeEtape5$Model$surLaNotation = F2(
	function (f, saisie) {
		return _Utils_update(
			saisie,
			{
				DQ: A2($elm$core$Maybe$map, f, saisie.DQ)
			});
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$basculerAnonymes = function (oui) {
	return $author$project$Components$Parametrage$PipeEtape5$Model$surLaNotation(
		function (notation) {
			return _Utils_update(
				notation,
				{dn: oui});
		});
};
var $author$project$Components$Parametrage$PipeEtape5$Model$surLeReglage = F2(
	function (uid, f) {
		return $author$project$Components$Parametrage$PipeEtape5$Model$surLaNotation(
			function (notation) {
				return _Utils_update(
					notation,
					{
						qc: A3(
							$elm$core$Dict$update,
							uid,
							$elm$core$Maybe$map(f),
							notation.qc)
					});
			});
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$basculerCommentaire = F2(
	function (uid, oui) {
		return A2(
			$author$project$Components$Parametrage$PipeEtape5$Model$surLeReglage,
			uid,
			function (reglage) {
				return _Utils_update(
					reglage,
					{
						IL: oui ? $elm$core$Maybe$Just('') : $elm$core$Maybe$Nothing
					});
			});
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$surLeChamp = F2(
	function (f, saisie) {
		return _Utils_update(
			saisie,
			{
				uN: A2($elm$core$Maybe$map, f, saisie.uN)
			});
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$basculerDossier = F2(
	function (oui, saisie) {
		return A2(
			$author$project$Components$Parametrage$PipeEtape5$Model$surLeChamp,
			function (champ) {
				return _Utils_update(
					champ,
					{xI: oui});
			},
			saisie);
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$creableSurLaFiche = function (saisie) {
	var _v0 = saisie.uN;
	if (!_v0.$) {
		var champ = _v0.a;
		return A2($elm$core$List$member, champ.B0.r0, saisie.B1.o_.JZ);
	} else {
		return false;
	}
};
var $author$project$Components$Parametrage$PipeEtape5$Model$sansAccent = function (c) {
	switch (c) {
		case 'à':
			return 'a';
		case 'â':
			return 'a';
		case 'ä':
			return 'a';
		case 'é':
			return 'e';
		case 'è':
			return 'e';
		case 'ê':
			return 'e';
		case 'ë':
			return 'e';
		case 'î':
			return 'i';
		case 'ï':
			return 'i';
		case 'ô':
			return 'o';
		case 'ö':
			return 'o';
		case 'ù':
			return 'u';
		case 'û':
			return 'u';
		case 'ü':
			return 'u';
		case 'ç':
			return 'c';
		default:
			return c;
	}
};
var $author$project$Components$Parametrage$PipeEtape5$Model$codeDuNom = function (nom) {
	return A2(
		$elm$core$String$join,
		'-',
		A2(
			$elm$core$List$filter,
			function (mot) {
				return mot !== '';
			},
			A2(
				$elm$core$List$map,
				$elm$core$String$filter($elm$core$Char$isAlphaNum),
				A2(
					$elm$core$List$concatMap,
					$elm$core$String$split(' '),
					A2(
						$elm$core$String$split,
						'-',
						$elm$core$String$fromList(
							A2(
								$elm$core$List$map,
								$author$project$Components$Parametrage$PipeEtape5$Model$sansAccent,
								$elm$core$String$toList(
									$elm$core$String$toLower(nom)))))))));
};
var $author$project$Components$Parametrage$PipeEtape5$Model$laRessourceLiee = 'va-sur-la-ressource-liee';
var $author$project$Components$Parametrage$PipeEtape5$Model$ressourceDe = F2(
	function (saisie, uid) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (r) {
					return _Utils_eq(r.r8, uid);
				},
				saisie.B1.o_.HP));
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$sUneFiche = function (code) {
	return (code === 'va-sur-la-fiche-visee') || (code === 'va-sur-la-fiche-d-un-autre-role');
};
var $author$project$Components$Parametrage$PipeEtape5$Model$poserDestination = F2(
	function (code, saisie) {
		var ressource = function () {
			if (_Utils_eq(code, $author$project$Components$Parametrage$PipeEtape5$Model$laRessourceLiee)) {
				var _v1 = A2(
					$elm$core$Maybe$andThen,
					$author$project$Components$Parametrage$PipeEtape5$Model$ressourceDe(saisie),
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.qC;
						},
						saisie.uN));
				if (!_v1.$) {
					var deja = _v1.a;
					return $elm$core$Maybe$Just(deja);
				} else {
					return $elm$core$List$head(saisie.B1.o_.HP);
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return A2(
			$author$project$Components$Parametrage$PipeEtape5$Model$surLeChamp,
			function (champ) {
				return _Utils_update(
					champ,
					{
						sI: $author$project$Components$Parametrage$PipeEtape5$Model$sUneFiche(code) ? champ.sI : $elm$core$Maybe$Nothing,
						du: $author$project$Components$Parametrage$PipeEtape5$Model$sUneFiche(code) ? $elm$core$Maybe$Just(
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$Components$Parametrage$PipeEtape5$Model$codeDuNom(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2($elm$core$Dict$get, 'fr', champ.R))),
								champ.du)) : $elm$core$Maybe$Nothing,
						bx: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.vx;
							},
							A2(
								$elm$core$Maybe$andThen,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.dw;
									},
									$elm$core$List$head),
								ressource)),
						xw: code,
						y0: (code === 'va-sur-la-fiche-visee') && champ.y0,
						qC: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.r8;
							},
							ressource),
						H6: function () {
							if (code === 'va-sur-la-fiche-d-un-autre-role') {
								var _v0 = champ.H6;
								if (!_v0.$) {
									var uid = _v0.a;
									return $elm$core$Maybe$Just(uid);
								} else {
									return A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.r8;
										},
										$elm$core$List$head(saisie.B1.o_.eX));
								}
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}()
					});
			},
			saisie);
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$poserModeDeLaFiche = F2(
	function (existant, saisie) {
		return A2(
			$author$project$Components$Parametrage$PipeEtape5$Model$surLeChamp,
			function (champ) {
				return _Utils_update(
					champ,
					{
						du: $elm$core$Maybe$Just(
							existant ? '' : $author$project$Components$Parametrage$PipeEtape5$Model$codeDuNom(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Dict$get, 'fr', champ.R)))),
						y0: existant
					});
			},
			saisie);
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$basculerFiche = F2(
	function (oui, saisie) {
		var cochee = A2(
			$author$project$Components$Parametrage$PipeEtape5$Model$poserDestination,
			oui ? 'va-sur-la-fiche-visee' : 'reste-dans-la-reponse',
			saisie);
		return (oui && (!$author$project$Components$Parametrage$PipeEtape5$Model$creableSurLaFiche(saisie))) ? A2($author$project$Components$Parametrage$PipeEtape5$Model$poserModeDeLaFiche, true, cochee) : cochee;
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$basculerNonVu = function (oui) {
	return $author$project$Components$Parametrage$PipeEtape5$Model$surLaNotation(
		function (notation) {
			return _Utils_update(
				notation,
				{el: oui});
		});
};
var $author$project$Components$Parametrage$PipeEtape5$Model$basculerValidation = F2(
	function (oui, saisie) {
		return A2(
			$author$project$Components$Parametrage$PipeEtape5$Model$surLeChamp,
			function (champ) {
				return _Utils_update(
					champ,
					{
						sI: oui ? A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.r8;
							},
							$elm$core$List$head(saisie.B1.o_.Kr)) : $elm$core$Maybe$Nothing,
						qc: function () {
							var r = champ.qc;
							return _Utils_update(
								r,
								{
									Kt: oui ? $elm$core$Maybe$Just(
										{
											vM: 'facultatif',
											zT: A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													$elm$core$Tuple$first,
													$elm$core$List$head(saisie.fF)))
										}) : $elm$core$Maybe$Nothing
								});
						}()
					});
			},
			saisie);
	});
var $author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$ModifierUnChamp = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Model$champSaisi = function (champ) {
	return {
		sI: champ.sI,
		du: $author$project$Components$Parametrage$PipeEtape5$Model$sUneFiche(champ.xw.r0) ? champ.xw.uN : $elm$core$Maybe$Nothing,
		bx: (champ.xw.r0 === 'va-sur-la-ressource-liee') ? champ.xw.uN : $elm$core$Maybe$Nothing,
		xw: (champ.xw.r0 === 'reste-sur-le-dossier') ? 'reste-dans-la-reponse' : champ.xw.r0,
		xI: champ.xw.xI,
		y0: champ.xw.y0,
		R: champ.R,
		B0: champ,
		Cj: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$fromFloat,
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.Cj;
					},
					champ.us))),
		CD: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$fromFloat,
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.CD;
					},
					champ.us))),
		cZ: '',
		he: champ.he,
		hC: '',
		qc: {j1: champ.j1, xd: champ.xd, Ay: champ.Ay, GH: champ.GH, HM: champ.HM, Kt: champ.Kt},
		qC: A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.r8;
			},
			champ.xw.HN),
		H6: champ.xw.H6,
		KS: champ.KS
	};
};
var $author$project$Components$Parametrage$PipeEtape5$Model$champVoulu = function (saisie) {
	return A2(
		$elm$core$Maybe$andThen,
		function (champ) {
			return (saisie.B1.g_ && (!_Utils_eq(
				champ,
				$author$project$Components$Parametrage$PipeEtape5$Model$champSaisi(champ.B0)))) ? A2(
				$elm$core$Maybe$map,
				function (bornes) {
					return $author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$ModifierUnChamp(
						{
							sI: champ.sI,
							us: bornes,
							du: $author$project$Components$Parametrage$PipeEtape5$Model$sUneFiche(champ.xw) ? champ.du : (_Utils_eq(champ.xw, $author$project$Components$Parametrage$PipeEtape5$Model$laRessourceLiee) ? champ.bx : $elm$core$Maybe$Nothing),
							cr: champ.B0.r8,
							xw: champ.xw,
							xI: champ.xI,
							lK: champ.B0.lK,
							y0: champ.y0,
							ny: ((champ.xw === 'va-sur-la-fiche-visee') && ((!champ.y0) && ($elm$core$String$trim(champ.cZ) !== ''))) ? $elm$core$Maybe$Just(champ.cZ) : $elm$core$Maybe$Nothing,
							R: champ.R,
							he: champ.he,
							qc: champ.qc,
							qC: champ.qC,
							H6: champ.H6,
							KS: champ.KS
						});
				},
				A3($author$project$Components$Parametrage$PipeEtape5$Model$bornesTapees, champ.B0.r0, champ.CD, champ.Cj)) : $elm$core$Maybe$Nothing;
		},
		saisie.uN);
};
var $author$project$Components$Parametrage$PipeEtape5$Model$choisirUnChamp = F2(
	function (uid, saisie) {
		var _v0 = A2(
			$elm$core$List$filter,
			function (champ) {
				return _Utils_eq(champ.r8, uid);
			},
			saisie.B1.dw);
		if (_v0.b) {
			var champ = _v0.a;
			return _Utils_update(
				saisie,
				{
					uN: $elm$core$Maybe$Just(
						$author$project$Components$Parametrage$PipeEtape5$Model$champSaisi(champ))
				});
		} else {
			return saisie;
		}
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$colonneAjoutee = function (colonnes) {
	return _Utils_ap(
		colonnes,
		_List_fromArray(
			[
				{dy: '', zU: $elm$core$Maybe$Nothing, Bl: '', JR: 'texte', r$: $elm$core$Maybe$Nothing, Ki: _List_Nil}
			]));
};
var $author$project$Components$Parametrage$PipeEtape5$Model$colonneDeplacee = F3(
	function (rang, sens, colonnes) {
		var autre = rang + sens;
		var _v0 = _Utils_Tuple2(
			$elm$core$List$head(
				A2($elm$core$List$drop, rang, colonnes)),
			$elm$core$List$head(
				A2($elm$core$List$drop, autre, colonnes)));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var a = _v0.a.a;
			var b = _v0.b.a;
			return A2(
				$elm$core$List$indexedMap,
				F2(
					function (i, c) {
						return _Utils_eq(i, rang) ? b : (_Utils_eq(i, autre) ? a : c);
					}),
				colonnes);
		} else {
			return colonnes;
		}
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$colonneModifiee = F3(
	function (rang, f, colonnes) {
		return A2(
			$elm$core$List$indexedMap,
			F2(
				function (i, c) {
					return _Utils_eq(i, rang) ? f(c) : c;
				}),
			colonnes);
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$colonneRetiree = F2(
	function (rang, colonnes) {
		return A2(
			$elm$core$List$map,
			$elm$core$Tuple$second,
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var i = _v0.a;
					return !_Utils_eq(i, rang);
				},
				A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, colonnes)));
	});
var $author$project$API$NavLinksDictionary$dupliquerUnFormulaire = 'dupliquer-un-formulaire';
var $author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$ReglerLImport = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Model$importVoulu = function (saisie) {
	return (saisie.B1.g_ && (!_Utils_eq(saisie.bJ, saisie.B1.Az))) ? $elm$core$Maybe$Just(
		$author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$ReglerLImport(
			{mR: saisie.B1.r8, Az: saisie.bJ})) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$Parametrage$PipeEtape5$Update$lienDeLaCarte = F2(
	function (uid, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.np;
			},
			A2(
				$elm$core$Maybe$andThen,
				function (formulaires) {
					return $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (carte) {
								return _Utils_eq(carte.r8, uid);
							},
							formulaires.aA));
				},
				model.aA));
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$lienDuFormulaire = F2(
	function (rel, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (saisie) {
				return A2($author$project$API$Liens$trouver, rel, saisie.B1.nQ);
			},
			model.hP);
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$lireSi = F2(
	function (lecture, lien) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$Parametrage$PipeEtape5$Update$Lire(lecture),
					lien)));
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$Edition = 2;
var $author$project$Components$Parametrage$PipeEtape5$Update$LesFormulaires = 3;
var $author$project$Components$Parametrage$PipeEtape5$Update$Racine = 1;
var $author$project$Components$Parametrage$PipeEtape5$Update$TypesDePartiePrenante = 5;
var $author$project$Components$Parametrage$PipeEtape5$Update$PlacerFocus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$autresFormulairesDuPipe = F2(
	function (saisie, model) {
		return A2(
			$elm$core$List$map,
			function (carte) {
				return _Utils_Tuple2(carte.r8, carte.R);
			},
			A2(
				$elm$core$List$filter,
				function (carte) {
					return !_Utils_eq(carte.r8, saisie.B1.r8);
				},
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.aA;
						},
						model.aA))));
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$idDuDeclencheur = function (nom) {
	return 'pipe-etape-5-' + nom;
};
var $author$project$Components$Parametrage$PipeEtape5$Model$idDuDrawer = function (nom) {
	return 'pipe-etape-5-' + nom;
};
var $author$project$Components$Parametrage$PipeEtape5$Update$ouvrir = F3(
	function (declencheur, saisie, model) {
		if ($author$project$API$Envoi$enCours(model.l2)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v0 = A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				$author$project$Components$Shared$Drawer$Update$Ouvrir(
					$author$project$Components$Parametrage$PipeEtape5$Model$idDuDeclencheur(declencheur)),
				$author$project$Components$Shared$Drawer$Model$init(
					$author$project$Components$Parametrage$PipeEtape5$Model$idDuDrawer('formulaire')));
			var drawer = _v0.a;
			var effets = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						kX: drawer,
						pZ: $elm$core$Maybe$Nothing,
						qq: false,
						hP: $elm$core$Maybe$Just(
							_Utils_update(
								saisie,
								{
									fF: A2($author$project$Components$Parametrage$PipeEtape5$Update$autresFormulairesDuPipe, saisie, model)
								}))
					}),
				A2(
					$elm$core$List$map,
					function (_v1) {
						var cible = _v1;
						return $author$project$Components$Parametrage$PipeEtape5$Update$PlacerFocus(cible);
					},
					effets));
		}
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$notationSaisie = F2(
	function (lue, notation) {
		return {
			dn: notation.HJ,
			dv: notation.uO,
			yu: notation.yu,
			el: notation.J6,
			DS: notation.DS,
			qc: $elm$core$Dict$fromList(
				A2(
					$elm$core$List$filterMap,
					function (champ) {
						return A2(
							$elm$core$Maybe$map,
							function (note) {
								return _Utils_Tuple2(
									champ.r8,
									{
										FV: $elm$core$String$fromInt(note.FV),
										IL: A2($elm$core$Maybe$map, $elm$core$String$fromInt, note.IL)
									});
							},
							champ.oJ);
					},
					lue.dw))
		};
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$premierChampExigeantUnCommentaire = function (lue) {
	var notes = A2(
		$elm$core$List$filter,
		function (champ) {
			return !_Utils_eq(champ.oJ, $elm$core$Maybe$Nothing);
		},
		lue.dw);
	var _v0 = A2(
		$elm$core$List$filter,
		function (champ) {
			return !_Utils_eq(
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.IL;
					},
					champ.oJ),
				$elm$core$Maybe$Nothing);
		},
		notes);
	if (_v0.b) {
		var premier = _v0.a;
		return $elm$core$Maybe$Just(premier);
	} else {
		return $elm$core$List$head(notes);
	}
};
var $author$project$Components$Parametrage$PipeEtape5$Model$saisieDuFormulaire = function (lue) {
	var reglables = A2(
		$elm$core$List$filter,
		function (champ) {
			return champ.r0 !== 'calcule';
		},
		lue.dw);
	var ouvert = function () {
		var _v0 = lue.DQ;
		if (!_v0.$) {
			return $author$project$Components$Parametrage$PipeEtape5$Model$premierChampExigeantUnCommentaire(lue);
		} else {
			var _v1 = A2(
				$elm$core$List$filter,
				function (champ) {
					return !_Utils_eq(champ.sI, $elm$core$Maybe$Nothing);
				},
				reglables);
			if (_v1.b) {
				var premier = _v1.a;
				return $elm$core$Maybe$Just(premier);
			} else {
				return $elm$core$List$head(reglables);
			}
		}
	}();
	return {
		fw: $elm$core$Maybe$Nothing,
		fF: _List_Nil,
		uN: A2($elm$core$Maybe$map, $author$project$Components$Parametrage$PipeEtape5$Model$champSaisi, ouvert),
		bJ: lue.Az,
		R: lue.R,
		B1: lue,
		DQ: A2(
			$elm$core$Maybe$map,
			$author$project$Components$Parametrage$PipeEtape5$Model$notationSaisie(lue),
			lue.DQ),
		qK: false,
		eW: $elm$core$Maybe$Nothing,
		J$: _List_Nil
	};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$Reconnecter = {$: 4};
var $author$project$Components$Parametrage$PipeEtape5$Update$sous = F4(
	function (decodeur, reponse, model, suite) {
		var _v0 = A2($author$project$API$Reponse$lire, decodeur, reponse);
		if (!_v0.$) {
			var lue = _v0.a;
			return suite(lue);
		} else {
			var refus = _v0.a;
			return (refus.ri === 401) ? _Utils_Tuple2(
				model,
				_List_fromArray(
					[$author$project$Components$Parametrage$PipeEtape5$Update$Reconnecter])) : _Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ax: model.Ax || ((refus.ri !== 404) || (!_Utils_eq(model.ge, $elm$core$Maybe$Nothing))),
						nf: model.nf || ((refus.ri === 404) && _Utils_eq(model.ge, $elm$core$Maybe$Nothing))
					}),
				_List_Nil);
		}
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie = F2(
	function (f, model) {
		return _Utils_update(
			model,
			{
				hP: A2($elm$core$Maybe$map, f, model.hP)
			});
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$lu = F3(
	function (lecture, reponse, model) {
		switch (lecture) {
			case 0:
				return A4(
					$author$project$Components$Parametrage$PipeEtape5$Update$sous,
					A4(
						$elm$json$Json$Decode$map3,
						F3(
							function (a, b, c) {
								return _Utils_Tuple3(a, b, c);
							}),
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$annuaireDecoder,
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$lienDuPipeDecoder(model.vx)),
					reponse,
					model,
					function (_v1) {
						var pipes = _v1.a;
						var liens = _v1.b;
						var visee = _v1.c;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									aS: $elm$core$Maybe$Just(pipes),
									nf: _Utils_eq(visee, $elm$core$Maybe$Nothing),
									nR: liens
								}),
							A2($author$project$Components$Parametrage$PipeEtape5$Update$lireSi, 1, visee));
					});
			case 1:
				return A4(
					$author$project$Components$Parametrage$PipeEtape5$Update$sous,
					$author$project$Components$Parametrage$Common$API$QueryAPIModel$racineDuPipeDecoder,
					reponse,
					model,
					function (edition) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									nf: _Utils_eq(edition, $elm$core$Maybe$Nothing)
								}),
							A2($author$project$Components$Parametrage$PipeEtape5$Update$lireSi, 2, edition));
					});
			case 2:
				return A4(
					$author$project$Components$Parametrage$PipeEtape5$Update$sous,
					$author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$editionDecoder,
					reponse,
					model,
					function (edition) {
						var _v2 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$formulairesDuPipe, edition.nQ);
						if (!_v2.$) {
							var lien = _v2.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										ge: $elm$core$Maybe$Just(edition)
									}),
								_List_fromArray(
									[
										A2($author$project$Components$Parametrage$PipeEtape5$Update$Lire, 3, lien)
									]));
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										ge: $elm$core$Maybe$Just(edition),
										Ax: true
									}),
								_List_Nil);
						}
					});
			case 3:
				return A4(
					$author$project$Components$Parametrage$PipeEtape5$Update$sous,
					$author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$formulairesDecoder,
					reponse,
					model,
					function (formulaires) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									aA: $elm$core$Maybe$Just(formulaires)
								}),
							_List_Nil);
					});
			case 4:
				return A4(
					$author$project$Components$Parametrage$PipeEtape5$Update$sous,
					$author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$formulaireDecoder,
					reponse,
					model,
					function (formulaire) {
						var _v3 = A3(
							$author$project$Components$Parametrage$PipeEtape5$Update$ouvrir,
							'formulaire-' + formulaire.r8,
							$author$project$Components$Parametrage$PipeEtape5$Model$saisieDuFormulaire(formulaire),
							model);
						var ouvert = _v3.a;
						var effets = _v3.b;
						return _Utils_Tuple2(
							ouvert,
							_Utils_ap(
								effets,
								A2(
									$author$project$Components$Parametrage$PipeEtape5$Update$lireSi,
									5,
									A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$optionsDesRolesDuPipe, formulaire.nQ))));
					});
			default:
				return A4(
					$author$project$Components$Parametrage$PipeEtape5$Update$sous,
					$author$project$Components$Parametrage$PipeEtape5$API$QueryAPIModel$typesDePartiePrenanteDecoder,
					reponse,
					model,
					function (types) {
						return _Utils_Tuple2(
							A2(
								$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
								function (saisie) {
									return _Utils_update(
										saisie,
										{J$: types});
								},
								model),
							_List_Nil);
					});
		}
	});
var $author$project$API$NavLinksDictionary$modifierUnChampDeFormulaire = 'modifier-un-champ-de-formulaire';
var $author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$ReglerLaNotation = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Model$allOrNothing = function (liste) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Maybe$map2($elm$core$List$cons),
		$elm$core$Maybe$Just(_List_Nil),
		liste);
};
var $author$project$Components$Parametrage$PipeEtape5$Model$notationLue = function (saisie) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Components$Parametrage$PipeEtape5$Model$notationSaisie(saisie.B1),
		saisie.B1.DQ);
};
var $author$project$Components$Parametrage$PipeEtape5$Model$poidsDuChamp = F2(
	function (notation, champ) {
		var _v0 = _Utils_Tuple2(
			champ.oJ,
			A2($elm$core$Dict$get, champ.r8, notation.qc));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var note = _v0.a.a;
			var reglage = _v0.b.a;
			var seuil = function () {
				var _v1 = reglage.IL;
				if (_v1.$ === 1) {
					return $elm$core$Maybe$Just($elm$core$Maybe$Nothing);
				} else {
					var texte = _v1.a;
					return A2(
						$elm$core$Maybe$map,
						$elm$core$Maybe$Just,
						$elm$core$String$toInt(texte));
				}
			}();
			return $elm$core$Maybe$Just(
				A3(
					$elm$core$Maybe$map2,
					F2(
						function (poids, seuil_) {
							return {cr: champ.r8, f_: note.wd, FV: poids, q7: seuil_};
						}),
					$elm$core$String$toInt(reglage.FV),
					seuil));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$notationVoulue = function (saisie) {
	return A2(
		$elm$core$Maybe$andThen,
		function (notation) {
			return (saisie.B1.g_ && (!_Utils_eq(
				$elm$core$Maybe$Just(notation),
				$author$project$Components$Parametrage$PipeEtape5$Model$notationLue(saisie)))) ? A2(
				$elm$core$Maybe$map,
				function (champs) {
					return $author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$ReglerLaNotation(
						{uO: notation.dv, dw: champs, yu: notation.yu, mR: saisie.B1.r8, DS: notation.DS, HJ: notation.dn, J6: notation.el});
				},
				$author$project$Components$Parametrage$PipeEtape5$Model$allOrNothing(
					A2(
						$elm$core$List$filterMap,
						$author$project$Components$Parametrage$PipeEtape5$Model$poidsDuChamp(notation),
						saisie.B1.dw))) : $elm$core$Maybe$Nothing;
		},
		saisie.DQ);
};
var $author$project$Components$Parametrage$PipeEtape5$Model$ouvrirLAjout = function (saisie) {
	return _Utils_update(
		saisie,
		{
			fw: $elm$core$Maybe$Just(
				{uB: '', du: $elm$core$Maybe$Nothing, R: $elm$core$Dict$empty, Cj: '', CD: '', cW: false, r0: 'texte', Ki: ''})
		});
};
var $author$project$Components$Parametrage$PipeEtape5$Model$poserAjoutCalcul = F2(
	function (texte, saisie) {
		return _Utils_update(
			saisie,
			{
				fw: A2(
					$elm$core$Maybe$map,
					function (a) {
						return _Utils_update(
							a,
							{uB: texte});
					},
					saisie.fw)
			});
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$poserAjoutChampDeLaFiche = F3(
	function (code, libelle, saisie) {
		return _Utils_update(
			saisie,
			{
				fw: A2(
					$elm$core$Maybe$map,
					function (a) {
						return _Utils_update(
							a,
							{
								du: $elm$core$Maybe$Just(code),
								R: ($elm$core$String$trim(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2($elm$core$Dict$get, 'fr', a.R))) === '') ? A3($elm$core$Dict$insert, 'fr', libelle, a.R) : a.R
							});
					},
					saisie.fw)
			});
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$poserAjoutMode = F2(
	function (choisir, saisie) {
		return _Utils_update(
			saisie,
			{
				fw: A2(
					$elm$core$Maybe$map,
					function (a) {
						return _Utils_update(
							a,
							{du: $elm$core$Maybe$Nothing, cW: choisir});
					},
					saisie.fw)
			});
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$poserBorne = F3(
	function (maximum, texte, saisie) {
		return A2(
			$author$project$Components$Parametrage$PipeEtape5$Model$surLeChamp,
			function (champ) {
				return maximum ? _Utils_update(
					champ,
					{Cj: texte}) : _Utils_update(
					champ,
					{CD: texte});
			},
			saisie);
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$poserBorneAjout = F3(
	function (maximum, texte, saisie) {
		return _Utils_update(
			saisie,
			{
				fw: A2(
					$elm$core$Maybe$map,
					function (a) {
						return maximum ? _Utils_update(
							a,
							{Cj: texte}) : _Utils_update(
							a,
							{CD: texte});
					},
					saisie.fw)
			});
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$poserChampDeLaFiche = F2(
	function (code, saisie) {
		return A2(
			$author$project$Components$Parametrage$PipeEtape5$Model$surLeChamp,
			function (champ) {
				return _Utils_update(
					champ,
					{
						du: $elm$core$Maybe$Just(code),
						y0: true
					});
			},
			saisie);
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$poserChampDeLaRessource = F2(
	function (code, saisie) {
		return A2(
			$author$project$Components$Parametrage$PipeEtape5$Model$surLeChamp,
			function (champ) {
				return _Utils_update(
					champ,
					{
						bx: $elm$core$Maybe$Just(code)
					});
			},
			saisie);
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$poserChampDuDossier = function (code) {
	return $author$project$Components$Parametrage$PipeEtape5$Model$surLaNotation(
		function (notation) {
			return _Utils_update(
				notation,
				{
					dv: (code === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(code)
				});
		});
};
var $author$project$Components$Parametrage$PipeEtape5$Model$poserEntreRepondants = function (code) {
	return $author$project$Components$Parametrage$PipeEtape5$Model$surLaNotation(
		function (notation) {
			return _Utils_update(
				notation,
				{yu: code});
		});
};
var $author$project$Components$Parametrage$PipeEtape5$Model$poserImport = F2(
	function (f, saisie) {
		return _Utils_update(
			saisie,
			{
				bJ: f(saisie.bJ)
			});
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$poserTypeAjout = F2(
	function (code, saisie) {
		return _Utils_update(
			saisie,
			{
				fw: A2(
					$elm$core$Maybe$map,
					function (a) {
						return _Utils_update(
							a,
							{r0: code});
					},
					saisie.fw)
			});
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$retiresDeMemeNom = function (saisie) {
	var nom = $elm$core$String$toLower(
		$elm$core$String$trim(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$andThen,
					function (a) {
						return A2($elm$core$Dict$get, 'fr', a.R);
					},
					saisie.fw))));
	return (nom === '') ? _List_Nil : A2(
		$elm$core$List$filter,
		function (c) {
			return _Utils_eq(
				$elm$core$String$toLower(
					$elm$core$String$trim(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Dict$get, 'fr', c.R)))),
				nom);
		},
		saisie.B1.u1);
};
var $author$project$Components$Parametrage$PipeEtape5$Model$poserNomAjout = F3(
	function (langue, texte, saisie) {
		var nomme = _Utils_update(
			saisie,
			{
				fw: A2(
					$elm$core$Maybe$map,
					function (a) {
						return _Utils_update(
							a,
							{
								R: A3($elm$core$Dict$insert, langue, texte, a.R)
							});
					},
					saisie.fw)
			});
		var _v0 = _Utils_Tuple2(
			langue,
			$author$project$Components$Parametrage$PipeEtape5$Model$retiresDeMemeNom(nomme));
		if ((_v0.a === 'fr') && _v0.b.b) {
			var _v1 = _v0.b;
			var retire = _v1.a;
			return A2($author$project$Components$Parametrage$PipeEtape5$Model$poserTypeAjout, retire.r0, nomme);
		} else {
			return nomme;
		}
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$poserNomDeLaFiche = F2(
	function (nom, saisie) {
		return A2(
			$author$project$Components$Parametrage$PipeEtape5$Model$surLeChamp,
			function (champ) {
				return _Utils_update(
					champ,
					{
						du: $elm$core$Maybe$Just(
							$author$project$Components$Parametrage$PipeEtape5$Model$codeDuNom(nom)),
						cZ: nom
					});
			},
			saisie);
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$poserNoteDUneReponse = function (code) {
	return $author$project$Components$Parametrage$PipeEtape5$Model$surLaNotation(
		function (notation) {
			return _Utils_update(
				notation,
				{DS: code});
		});
};
var $author$project$Components$Parametrage$PipeEtape5$Model$poserPoids = F2(
	function (uid, texte) {
		return A2(
			$author$project$Components$Parametrage$PipeEtape5$Model$surLeReglage,
			uid,
			function (reglage) {
				return _Utils_update(
					reglage,
					{FV: texte});
			});
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$poserRecherche = F2(
	function (texte, saisie) {
		return A2(
			$author$project$Components$Parametrage$PipeEtape5$Model$surLeChamp,
			function (champ) {
				return _Utils_update(
					champ,
					{hC: texte});
			},
			saisie);
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$poserRessource = F2(
	function (uid, saisie) {
		return A2(
			$author$project$Components$Parametrage$PipeEtape5$Model$surLeChamp,
			function (champ) {
				return _Utils_update(
					champ,
					{
						bx: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.vx;
							},
							A2(
								$elm$core$Maybe$andThen,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.dw;
									},
									$elm$core$List$head),
								A2($author$project$Components$Parametrage$PipeEtape5$Model$ressourceDe, saisie, uid))),
						qC: $elm$core$Maybe$Just(uid)
					});
			},
			saisie);
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$poserRoleDeLaFiche = F2(
	function (uid, saisie) {
		return A2(
			$author$project$Components$Parametrage$PipeEtape5$Model$surLeChamp,
			function (champ) {
				return _Utils_update(
					champ,
					{
						H6: $elm$core$Maybe$Just(uid)
					});
			},
			saisie);
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$poserSeuil = F2(
	function (uid, texte) {
		return A2(
			$author$project$Components$Parametrage$PipeEtape5$Model$surLeReglage,
			uid,
			function (reglage) {
				return _Utils_update(
					reglage,
					{
						IL: $elm$core$Maybe$Just(texte)
					});
			});
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$poserValeursAjout = F2(
	function (texte, saisie) {
		return _Utils_update(
			saisie,
			{
				fw: A2(
					$elm$core$Maybe$map,
					function (a) {
						return _Utils_update(
							a,
							{Ki: texte});
					},
					saisie.fw)
			});
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$poserValidateur = F2(
	function (uid, saisie) {
		return A2(
			$author$project$Components$Parametrage$PipeEtape5$Model$surLeChamp,
			function (champ) {
				return _Utils_update(
					champ,
					{
						sI: $elm$core$Maybe$Just(uid)
					});
			},
			saisie);
	});
var $author$project$API$NavLinksDictionary$reglerLImport = 'regler-l-import-du-formulaire';
var $author$project$API$NavLinksDictionary$reglerLaNotation = 'regler-la-notation';
var $author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$RenommerUnFormulaire = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Model$renommageVoulu = function (saisie) {
	return (saisie.B1.g_ && ($elm$core$String$trim(
		A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Dict$get, 'fr', saisie.R))) !== '')) ? $elm$core$Maybe$Just(
		$author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$RenommerUnFormulaire(
			{mR: saisie.B1.r8, R: saisie.R})) : $elm$core$Maybe$Nothing;
};
var $author$project$API$NavLinksDictionary$renommerUnFormulaire = 'renommer-un-formulaire';
var $author$project$I18n$Textes$pipeEtape5RefusAnonymesEtDossier = A3($author$project$I18n$Traductions$texte, 'pipe-etape-5.refus.anonymes-et-dossier', _List_Nil, 'Une grille d\'évaluation reste nominative : elle ne peut pas alimenter un champ du dossier en réponses anonymes.');
var $author$project$I18n$Textes$pipeEtape5RefusFormuleInvalide = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'pipe-etape-5.refus.formule-invalide',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'cause',
				$author$project$I18n$Traductions$Sous(p.bw))
			]),
		'La formule est refusée : {cause}');
};
var $author$project$I18n$Textes$pipeEtape5RefusNomDeChampPris = A3($author$project$I18n$Traductions$texte, 'pipe-etape-5.refus.nom-de-champ-pris', _List_Nil, 'Ce nom est déjà pris par un autre champ du formulaire. Choisissez un autre nom.');
var $author$project$I18n$Textes$pipeEtape5RefusPoidsInvalides = A3($author$project$I18n$Traductions$texte, 'pipe-etape-5.refus.poids-invalides', _List_Nil, 'Les poids ne totalisent pas 100 %.');
var $author$project$I18n$Textes$pipeEtape5RefusReglagesRequis = A3($author$project$I18n$Traductions$texte, 'pipe-etape-5.refus.reglages-requis', _List_Nil, 'Ce type demande ses réglages : ajoutez au moins une valeur proposée.');
var $author$project$I18n$Textes$pipeEtape5RefusValidationSansFiche = A3($author$project$I18n$Traductions$texte, 'pipe-etape-5.refus.validation-sans-fiche', _List_Nil, 'Rien à valider : ce champ ne va pas sur une fiche.');
var $author$project$I18n$Textes$pipeEtape6RefusAutresRoles = A3($author$project$I18n$Traductions$texte, 'pipe-etape-6.refus.autres-roles', _List_Nil, '« Voit les autres rôles du dossier » ne se règle que pour un rôle tenu par une relation.');
var $author$project$I18n$Textes$pipeEtape6RefusChampInconnu = A3($author$project$I18n$Traductions$texte, 'pipe-etape-6.refus.champ-inconnu', _List_Nil, 'Un champ de la liste n\'existe plus à cette étape : fermez ce volet et rouvrez la case.');
var $author$project$I18n$Textes$pipeEtape6RefusEtapeSource = A3($author$project$I18n$Traductions$texte, 'pipe-etape-6.refus.etape-source', _List_Nil, 'Choisissez une autre étape que celle-ci.');
var $author$project$I18n$Textes$pipeEtape6RefusPlafond = A3($author$project$I18n$Traductions$texte, 'pipe-etape-6.refus.plafond', _List_Nil, 'Un champ ne peut pas avoir plus de droit que la case du rôle à cette étape. Baissez le champ ou montez la case.');
var $author$project$I18n$Textes$pipeEtape7RefusAlorsIncomplet = A3($author$project$I18n$Traductions$texte, 'pipe-etape-7.refus.alors-incomplet', _List_Nil, 'Complétez ce que fait l\'automatisme : un champ de la section « Alors » est vide.');
var $author$project$I18n$Textes$pipeEtape7RefusDejaSuspendu = A3($author$project$I18n$Traductions$texte, 'pipe-etape-7.refus.deja-suspendu', _List_Nil, 'Cet automatisme est déjà suspendu.');
var $author$project$I18n$Textes$pipeEtape7RefusFormuleInvalide = A3($author$project$I18n$Traductions$texte, 'pipe-etape-7.refus.formule-invalide', _List_Nil, 'La condition n\'est pas lisible : vérifiez les guillemets et les parenthèses.');
var $author$project$I18n$Textes$pipeEtape7RefusInconnu = A3($author$project$I18n$Traductions$texte, 'pipe-etape-7.refus.inconnu', _List_Nil, 'Cet automatisme n\'existe plus : fermez ce volet et relisez la liste.');
var $author$project$I18n$Textes$pipeEtape7RefusNonSuspendu = A3($author$project$I18n$Traductions$texte, 'pipe-etape-7.refus.non-suspendu', _List_Nil, 'Cet automatisme n\'est pas suspendu.');
var $author$project$I18n$Textes$pipeEtape7RefusPaysEnDouble = A3($author$project$I18n$Traductions$texte, 'pipe-etape-7.refus.pays-en-double', _List_Nil, 'Un pays ne peut figurer qu\'une fois.');
var $author$project$I18n$Textes$pipeEtape7RefusPaysInconnu = A3($author$project$I18n$Traductions$texte, 'pipe-etape-7.refus.pays-inconnu', _List_Nil, 'Ce pays n\'est pas dans la bibliothèque.');
var $author$project$I18n$Textes$pipeEtape7RefusPipeInconnu = A3($author$project$I18n$Traductions$texte, 'pipe-etape-7.refus.pipe-inconnu', _List_Nil, 'Ce pipe n\'existe pas pour ce client.');
var $author$project$I18n$Textes$pipeEtape7RefusSansDelais = A3($author$project$I18n$Traductions$texte, 'pipe-etape-7.refus.sans-delais', _List_Nil, 'Cet automatisme ne calcule pas de délai par pays.');
var $author$project$I18n$Textes$pipeEtape8RefusPublicationBloquee = A3($author$project$I18n$Traductions$texte, 'pipe-etape-8.refus.publication-bloquee', _List_Nil, 'La publication est refusée : il reste une erreur à corriger. Relancez la vérification.');
var $author$project$I18n$Textes$pipeEtape8RefusVersionNonModifiable = A3($author$project$I18n$Traductions$texte, 'pipe-etape-8.refus.version-non-modifiable', _List_Nil, 'Cette version est déjà publiée.');
var $author$project$I18n$Textes$pipeVersionsRefusVersionNonRetirable = A3($author$project$I18n$Traductions$texte, 'pipe-versions.refus.version-non-retirable', _List_Nil, 'Seule la version publiée se retire.');
var $author$project$I18n$Textes$pipeVersionsRefusVersionPortantDesDossiers = A3($author$project$I18n$Traductions$texte, 'pipe-versions.refus.version-portant-des-dossiers', _List_Nil, 'Une version qui porte encore des dossiers ne se retire pas : on migre d\'abord ses dossiers.');
var $author$project$Components$Parametrage$Vocabulaire$messageDuRefus = function (refus) {
	var _v0 = refus.bB;
	_v0$24:
	while (true) {
		switch (_v0.$) {
			case 4:
				switch (_v0.a) {
					case 'NomDeChampPrisParUnChampRetire':
						return {Jx: $author$project$I18n$Textes$pipeEtape5RefusNomDeChampPris, b9: refus.b9};
					case 'FormuleInvalide':
						var precisions = _v0.b;
						return {
							Jx: $author$project$I18n$Textes$pipeEtape5RefusFormuleInvalide(
								{
									bw: $author$project$I18n$Traductions$tel(
										A2(
											$elm$core$String$join,
											' ',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$second,
												A2(
													$elm$core$List$filter,
													function (_v1) {
														var cle = _v1.a;
														return cle === 'cause';
													},
													precisions))))
								}),
							b9: refus.b9
						};
					default:
						break _v0$24;
				}
			case 1:
				switch (_v0.a) {
					case 'NomDeChampDejaPris':
						return {Jx: $author$project$I18n$Textes$pipeEtape5RefusNomDeChampPris, b9: refus.b9};
					case 'ReglagesDeTypeRequis':
						return {Jx: $author$project$I18n$Textes$pipeEtape5RefusReglagesRequis, b9: refus.b9};
					case 'PoidsInvalides':
						return {Jx: $author$project$I18n$Textes$pipeEtape5RefusPoidsInvalides, b9: refus.b9};
					case 'ReponsesAnonymesIncompatiblesAvecLeChampDuDossier':
						return {Jx: $author$project$I18n$Textes$pipeEtape5RefusAnonymesEtDossier, b9: refus.b9};
					case 'ValidationSansDestinationSurUneFiche':
						return {Jx: $author$project$I18n$Textes$pipeEtape5RefusValidationSansFiche, b9: refus.b9};
					case 'DroitDeChampSuperieurAuDroitDeLaCase':
						return {Jx: $author$project$I18n$Textes$pipeEtape6RefusPlafond, b9: refus.b9};
					case 'VisibiliteDesAutresRolesReserveeAuxRolesParRelation':
						return {Jx: $author$project$I18n$Textes$pipeEtape6RefusAutresRoles, b9: refus.b9};
					case 'EtapeSourceIdentique':
						return {Jx: $author$project$I18n$Textes$pipeEtape6RefusEtapeSource, b9: refus.b9};
					case 'ChampInconnu':
						return {Jx: $author$project$I18n$Textes$pipeEtape6RefusChampInconnu, b9: refus.b9};
					case 'PublicationBloquee':
						return {Jx: $author$project$I18n$Textes$pipeEtape8RefusPublicationBloquee, b9: refus.b9};
					case 'VersionPortantDesDossiers':
						return {Jx: $author$project$I18n$Textes$pipeVersionsRefusVersionPortantDesDossiers, b9: refus.b9};
					case 'VersionNonRetirable':
						return {Jx: $author$project$I18n$Textes$pipeVersionsRefusVersionNonRetirable, b9: refus.b9};
					case 'VersionNonModifiable':
						return {Jx: $author$project$I18n$Textes$pipeEtape8RefusVersionNonModifiable, b9: refus.b9};
					case 'AlorsIncomplet':
						return {Jx: $author$project$I18n$Textes$pipeEtape7RefusAlorsIncomplet, b9: refus.b9};
					case 'FormuleInvalide':
						return {Jx: $author$project$I18n$Textes$pipeEtape7RefusFormuleInvalide, b9: refus.b9};
					case 'AutomatismeDejaSuspendu':
						return {Jx: $author$project$I18n$Textes$pipeEtape7RefusDejaSuspendu, b9: refus.b9};
					case 'AutomatismeNonSuspendu':
						return {Jx: $author$project$I18n$Textes$pipeEtape7RefusNonSuspendu, b9: refus.b9};
					case 'AutomatismeSansDelaisParPays':
						return {Jx: $author$project$I18n$Textes$pipeEtape7RefusSansDelais, b9: refus.b9};
					case 'PaysInconnu':
						return {Jx: $author$project$I18n$Textes$pipeEtape7RefusPaysInconnu, b9: refus.b9};
					case 'PaysEnDouble':
						return {Jx: $author$project$I18n$Textes$pipeEtape7RefusPaysEnDouble, b9: refus.b9};
					case 'PipeLancableInconnu':
						return {Jx: $author$project$I18n$Textes$pipeEtape7RefusPipeInconnu, b9: refus.b9};
					case 'AutomatismeInconnu':
						return {Jx: $author$project$I18n$Textes$pipeEtape7RefusInconnu, b9: refus.b9};
					default:
						break _v0$24;
				}
			default:
				break _v0$24;
		}
	}
	return $author$project$Components$Shared$Messages$Model$duRefus(refus);
};
var $author$project$Components$Parametrage$PipeEtape5$Update$Envoyer = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$ReponseDeCommande = function (vuesAJour) {
	return {sy: vuesAJour};
};
var $author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$reponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$ReponseDeCommande,
	A2($elm$json$Json$Decode$field, 'vuesAJour', $elm$json$Json$Decode$bool));
var $author$project$Components$Parametrage$PipeEtape5$Update$reglage = {
	f8: $author$project$Components$Parametrage$PipeEtape5$Update$DemanderProcessUid,
	l4: $author$project$Components$Parametrage$PipeEtape5$Update$Envoyer,
	go: $elm$core$Basics$identity,
	pW: $author$project$Components$Parametrage$PipeEtape5$Update$Reconnecter,
	qu: F2(
		function (_v0, _v1) {
			return true;
		}),
	qv: $author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$reponseDecoder
};
var $author$project$Components$Parametrage$PipeEtape5$Update$repondue = F2(
	function (reponse, model) {
		var _v0 = A3($author$project$API$Envoi$conclure, $author$project$Components$Parametrage$PipeEtape5$Update$reglage, reponse, model.l2);
		if (!_v0.$) {
			switch (_v0.a.b.$) {
				case 0:
					var _v1 = _v0.a;
					var envoi = _v1.a;
					var _v2 = _v1.b;
					var effets = _v1.c;
					var _v3 = A3(
						$author$project$Components$Shared$Drawer$Update$update,
						{Il: false},
						$author$project$Components$Shared$Drawer$Update$Fermer,
						model.kX);
					var drawer = _v3.a;
					var deDrawer = _v3.b;
					return model.qE ? _Utils_Tuple2(
						_Utils_update(
							model,
							{l2: envoi, pZ: $elm$core$Maybe$Nothing, qE: false}),
						_Utils_ap(
							effets,
							_Utils_ap(
								A2(
									$author$project$Components$Parametrage$PipeEtape5$Update$lireSi,
									4,
									A2(
										$elm$core$Maybe$andThen,
										function (saisie) {
											return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$self, saisie.B1.nQ);
										},
										model.hP)),
								A2(
									$author$project$Components$Parametrage$PipeEtape5$Update$lireSi,
									3,
									A2(
										$elm$core$Maybe$andThen,
										function (formulaires) {
											return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$self, formulaires.nQ);
										},
										model.aA))))) : _Utils_Tuple2(
						_Utils_update(
							model,
							{kX: drawer, l2: envoi, pZ: $elm$core$Maybe$Nothing, qq: false, hP: $elm$core$Maybe$Nothing}),
						_Utils_ap(
							effets,
							_Utils_ap(
								A2(
									$elm$core$List$map,
									function (_v4) {
										var cible = _v4;
										return $author$project$Components$Parametrage$PipeEtape5$Update$PlacerFocus(cible);
									},
									deDrawer),
								A2(
									$author$project$Components$Parametrage$PipeEtape5$Update$lireSi,
									3,
									A2(
										$elm$core$Maybe$andThen,
										function (formulaires) {
											return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$self, formulaires.nQ);
										},
										model.aA)))));
				case 1:
					var _v5 = _v0.a;
					var envoi = _v5.a;
					var _v6 = _v5.b;
					var refus = _v6.b;
					var effets = _v5.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l2: envoi,
								pZ: $elm$core$Maybe$Just(
									$author$project$Components$Parametrage$Vocabulaire$messageDuRefus(refus)),
								qE: false
							}),
						effets);
				default:
					var _v7 = _v0.a;
					var envoi = _v7.a;
					var _v8 = _v7.b;
					var effets = _v7.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{l2: envoi}),
						effets);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$restaurerUnChampDeFormulaire = 'restaurer-un-champ-de-formulaire';
var $author$project$API$NavLinksDictionary$retirerUnChampDeFormulaire = 'retirer-un-champ-de-formulaire';
var $author$project$API$NavLinksDictionary$retirerUnFormulaire = 'retirer-un-formulaire';
var $author$project$Components$Parametrage$PipeEtape5$Update$surLeChamp = F2(
	function (f, model) {
		return A2(
			$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
			function (saisie) {
				return _Utils_update(
					saisie,
					{
						uN: A2($elm$core$Maybe$map, f, saisie.uN)
					});
			},
			model);
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$surLesReglages = F2(
	function (f, saisie) {
		return A2(
			$author$project$Components$Parametrage$PipeEtape5$Model$surLeChamp,
			function (champ) {
				return _Utils_update(
					champ,
					{
						qc: f(champ.qc)
					});
			},
			saisie);
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$surLesColonnes = F2(
	function (f, model) {
		return A2(
			$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
			$author$project$Components$Parametrage$PipeEtape5$Model$surLesReglages(
				function (r) {
					return _Utils_update(
						r,
						{
							j1: f(r.j1)
						});
				}),
			model);
	});
var $elm$core$String$trimLeft = _String_trimLeft;
var $author$project$Components$Parametrage$PipeEtape5$Update$versLApi = F3(
	function (lien, model, commande) {
		if (!commande.$) {
			var voulue = commande.a;
			var _v1 = A4($author$project$API$Envoi$partir, $author$project$Components$Parametrage$PipeEtape5$Update$reglage, lien, voulue, model.l2);
			if (!_v1.$) {
				var _v2 = _v1.a;
				var envoi = _v2.a;
				var effets = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{l2: envoi, pZ: $elm$core$Maybe$Nothing}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$sortiesDuDrawer = _List_fromArray(
	[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$SortieDemandee, $author$project$Components$Shared$Drawer$Update$AbandonConfirme]);
var $author$project$Components$Parametrage$PipeEtape5$Update$versLeDrawer = F2(
	function (geste, model) {
		if ($author$project$API$Envoi$enCours(model.l2) && A2($elm$core$List$member, geste, $author$project$Components$Parametrage$PipeEtape5$Update$sortiesDuDrawer)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v0 = A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.kX);
			var drawer = _v0.a;
			var effets = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						kX: drawer,
						qq: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) && model.qq,
						hP: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? model.hP : $elm$core$Maybe$Nothing
					}),
				A2(
					$elm$core$List$map,
					function (_v1) {
						var cible = _v1;
						return $author$project$Components$Parametrage$PipeEtape5$Update$PlacerFocus(cible);
					},
					effets));
		}
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var code = msg.a;
				var liens = msg.b;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$pipes, liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						$author$project$Components$Parametrage$PipeEtape5$Model$init(code),
						_List_fromArray(
							[
								$author$project$Components$Parametrage$PipeEtape5$Update$DemanderProcessUid,
								A2($author$project$Components$Parametrage$PipeEtape5$Update$Lire, 0, lecture)
							]));
				} else {
					return _Utils_Tuple2(
						$author$project$Components$Parametrage$PipeEtape5$Model$init(code),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 2:
				var lecture = msg.a;
				var reponse = msg.b;
				return A3($author$project$Components$Parametrage$PipeEtape5$Update$lu, lecture, reponse, model);
			case 3:
				var reponse = msg.a;
				return A2($author$project$Components$Parametrage$PipeEtape5$Update$repondue, reponse, model);
			case 4:
				var geste = msg.a;
				return A2($author$project$Components$Parametrage$PipeEtape5$Update$versLeDrawer, geste, model);
			case 5:
				var uid = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$lireSi,
						4,
						A2($author$project$Components$Parametrage$PipeEtape5$Update$lienDeLaCarte, uid, model)));
			case 6:
				var langue = msg.a;
				var texte = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						function (saisie) {
							return _Utils_update(
								saisie,
								{
									R: A3($elm$core$Dict$insert, langue, texte, saisie.R)
								});
						},
						model),
					_List_Nil);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{qq: true}),
					_List_Nil);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{qq: false}),
					_List_Nil);
			case 9:
				return A3(
					$author$project$Components$Parametrage$PipeEtape5$Update$versLApi,
					A2($author$project$Components$Parametrage$PipeEtape5$Update$lienDuFormulaire, $author$project$API$NavLinksDictionary$renommerUnFormulaire, model),
					model,
					A2($elm$core$Maybe$andThen, $author$project$Components$Parametrage$PipeEtape5$Model$renommageVoulu, model.hP));
			case 10:
				var uid = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$choisirUnChamp(uid),
						model),
					_List_Nil);
			case 11:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$poserDestination(code),
						model),
					_List_Nil);
			case 12:
				var oui = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$basculerFiche(oui),
						model),
					_List_Nil);
			case 13:
				var oui = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$basculerDossier(oui),
						model),
					_List_Nil);
			case 14:
				var existant = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$poserModeDeLaFiche(existant),
						model),
					_List_Nil);
			case 16:
				var texte = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$poserRecherche(texte),
						model),
					_List_Nil);
			case 17:
				var maximum = msg.a;
				var texte = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						A2($author$project$Components$Parametrage$PipeEtape5$Model$poserBorne, maximum, texte),
						model),
					_List_Nil);
			case 18:
				var maximum = msg.a;
				var texte = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						A2($author$project$Components$Parametrage$PipeEtape5$Model$poserBorneAjout, maximum, texte),
						model),
					_List_Nil);
			case 19:
				var nom = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$poserNomDeLaFiche(nom),
						model),
					_List_Nil);
			case 15:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$poserChampDeLaFiche(code),
						model),
					_List_Nil);
			case 20:
				var choisir = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$poserAjoutMode(choisir),
						model),
					_List_Nil);
			case 21:
				var code = msg.a;
				var libelle = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						A2($author$project$Components$Parametrage$PipeEtape5$Model$poserAjoutChampDeLaFiche, code, libelle),
						model),
					_List_Nil);
			case 22:
				var texte = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$poserAjoutCalcul(texte),
						model),
					_List_Nil);
			case 24:
				var uid = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$poserRessource(uid),
						model),
					_List_Nil);
			case 25:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$poserChampDeLaRessource(code),
						model),
					_List_Nil);
			case 23:
				var uid = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$poserRoleDeLaFiche(uid),
						model),
					_List_Nil);
			case 26:
				var oui = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$basculerValidation(oui),
						model),
					_List_Nil);
			case 27:
				var uid = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$poserValidateur(uid),
						model),
					_List_Nil);
			case 28:
				var oui = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLeChamp,
						function (champ) {
							return _Utils_update(
								champ,
								{he: oui});
						},
						model),
					_List_Nil);
			case 29:
				var oui = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$surLesReglages(
							function (r) {
								return _Utils_update(
									r,
									{HM: oui});
							}),
						model),
					_List_Nil);
			case 30:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$surLesReglages(
							function (r) {
								return _Utils_update(
									r,
									{GH: code});
							}),
						model),
					_List_Nil);
			case 31:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$surLesReglages(
							function (r) {
								return _Utils_update(
									r,
									{
										xd: $elm$core$Maybe$Just(code)
									});
							}),
						model),
					_List_Nil);
			case 32:
				var oui = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$surLesReglages(
							function (r) {
								return _Utils_update(
									r,
									{
										Ay: oui ? $elm$core$Maybe$Just('ajouter') : $elm$core$Maybe$Nothing
									});
							}),
						model),
					_List_Nil);
			case 33:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$surLesReglages(
							function (r) {
								return _Utils_update(
									r,
									{
										Ay: $elm$core$Maybe$Just(code)
									});
							}),
						model),
					_List_Nil);
			case 34:
				return _Utils_Tuple2(
					A2($author$project$Components$Parametrage$PipeEtape5$Update$surLesColonnes, $author$project$Components$Parametrage$PipeEtape5$Model$colonneAjoutee, model),
					_List_Nil);
			case 35:
				var rang = msg.a;
				var libelle = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLesColonnes,
						A2(
							$author$project$Components$Parametrage$PipeEtape5$Model$colonneModifiee,
							rang,
							function (c) {
								return _Utils_update(
									c,
									{Bl: libelle});
							}),
						model),
					_List_Nil);
			case 36:
				var rang = msg.a;
				var code = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLesColonnes,
						A2(
							$author$project$Components$Parametrage$PipeEtape5$Model$colonneModifiee,
							rang,
							function (c) {
								return _Utils_update(
									c,
									{zU: $elm$core$Maybe$Nothing, JR: code, r$: $elm$core$Maybe$Nothing, Ki: _List_Nil});
							}),
						model),
					_List_Nil);
			case 37:
				var rang = msg.a;
				var texte = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLesColonnes,
						A2(
							$author$project$Components$Parametrage$PipeEtape5$Model$colonneModifiee,
							rang,
							function (c) {
								return _Utils_update(
									c,
									{
										Ki: A2(
											$elm$core$List$map,
											$elm$core$String$trimLeft,
											A2($elm$core$String$split, ';', texte))
									});
							}),
						model),
					_List_Nil);
			case 38:
				var rang = msg.a;
				var uid = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLesColonnes,
						A2(
							$author$project$Components$Parametrage$PipeEtape5$Model$colonneModifiee,
							rang,
							function (c) {
								return _Utils_update(
									c,
									{
										r$: (uid === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(uid)
									});
							}),
						model),
					_List_Nil);
			case 39:
				var rang = msg.a;
				var formule = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLesColonnes,
						A2(
							$author$project$Components$Parametrage$PipeEtape5$Model$colonneModifiee,
							rang,
							function (c) {
								return _Utils_update(
									c,
									{
										zU: (formule === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(formule)
									});
							}),
						model),
					_List_Nil);
			case 40:
				var rang = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLesColonnes,
						$author$project$Components$Parametrage$PipeEtape5$Model$colonneRetiree(rang),
						model),
					_List_Nil);
			case 41:
				var rang = msg.a;
				var sens = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLesColonnes,
						A2($author$project$Components$Parametrage$PipeEtape5$Model$colonneDeplacee, rang, sens),
						model),
					_List_Nil);
			case 42:
				var uid = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$surLesReglages(
							function (r) {
								return _Utils_update(
									r,
									{
										Kt: $elm$core$Maybe$Just(
											{
												vM: A2(
													$elm$core$Maybe$withDefault,
													'facultatif',
													A2(
														$elm$core$Maybe$map,
														function ($) {
															return $.vM;
														},
														r.Kt)),
												zT: uid
											})
									});
							}),
						model),
					_List_Nil);
			case 43:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$surLesReglages(
							function (r) {
								return _Utils_update(
									r,
									{
										Kt: A2(
											$elm$core$Maybe$map,
											function (v) {
												return _Utils_update(
													v,
													{vM: code});
											},
											r.Kt)
									});
							}),
						model),
					_List_Nil);
			case 44:
				var oui = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$poserImport(
							function (_v2) {
								return oui ? $elm$core$Maybe$Just(
									{ER: false, J7: 'nouveau-dossier'}) : $elm$core$Maybe$Nothing;
							}),
						model),
					_List_Nil);
			case 45:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$poserImport(
							$elm$core$Maybe$map(
								function (i) {
									return _Utils_update(
										i,
										{J7: code});
								})),
						model),
					_List_Nil);
			case 46:
				var oui = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$poserImport(
							$elm$core$Maybe$map(
								function (i) {
									return _Utils_update(
										i,
										{ER: oui});
								})),
						model),
					_List_Nil);
			case 47:
				var oui = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLeChamp,
						function (champ) {
							return _Utils_update(
								champ,
								{KS: oui});
						},
						model),
					_List_Nil);
			case 48:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$poserNoteDUneReponse(code),
						model),
					_List_Nil);
			case 49:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$poserEntreRepondants(code),
						model),
					_List_Nil);
			case 50:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$poserChampDuDossier(code),
						model),
					_List_Nil);
			case 51:
				var oui = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$basculerNonVu(oui),
						model),
					_List_Nil);
			case 52:
				var oui = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$basculerAnonymes(oui),
						model),
					_List_Nil);
			case 53:
				var uid = msg.a;
				var texte = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						A2($author$project$Components$Parametrage$PipeEtape5$Model$poserPoids, uid, texte),
						model),
					_List_Nil);
			case 54:
				var uid = msg.a;
				var oui = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						A2($author$project$Components$Parametrage$PipeEtape5$Model$basculerCommentaire, uid, oui),
						model),
					_List_Nil);
			case 55:
				var uid = msg.a;
				var texte = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						A2($author$project$Components$Parametrage$PipeEtape5$Model$poserSeuil, uid, texte),
						model),
					_List_Nil);
			case 56:
				return (!_Utils_eq(
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.DQ;
						},
						model.hP),
					$elm$core$Maybe$Nothing)) ? A3(
					$author$project$Components$Parametrage$PipeEtape5$Update$versLApi,
					A2($author$project$Components$Parametrage$PipeEtape5$Update$lienDuFormulaire, $author$project$API$NavLinksDictionary$reglerLaNotation, model),
					model,
					A2($elm$core$Maybe$andThen, $author$project$Components$Parametrage$PipeEtape5$Model$notationVoulue, model.hP)) : ((!_Utils_eq(
					A2($elm$core$Maybe$andThen, $author$project$Components$Parametrage$PipeEtape5$Model$champVoulu, model.hP),
					$elm$core$Maybe$Nothing)) ? A3(
					$author$project$Components$Parametrage$PipeEtape5$Update$versLApi,
					A2($author$project$Components$Parametrage$PipeEtape5$Update$lienDuFormulaire, $author$project$API$NavLinksDictionary$modifierUnChampDeFormulaire, model),
					model,
					A2($elm$core$Maybe$andThen, $author$project$Components$Parametrage$PipeEtape5$Model$champVoulu, model.hP)) : A3(
					$author$project$Components$Parametrage$PipeEtape5$Update$versLApi,
					A2($author$project$Components$Parametrage$PipeEtape5$Update$lienDuFormulaire, $author$project$API$NavLinksDictionary$reglerLImport, model),
					model,
					A2($elm$core$Maybe$andThen, $author$project$Components$Parametrage$PipeEtape5$Model$importVoulu, model.hP)));
			case 57:
				return A3(
					$author$project$Components$Parametrage$PipeEtape5$Update$versLApi,
					A2($author$project$Components$Parametrage$PipeEtape5$Update$lienDuFormulaire, $author$project$API$NavLinksDictionary$dupliquerUnFormulaire, model),
					model,
					A2(
						$elm$core$Maybe$map,
						function (saisie) {
							return $author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$DupliquerUnFormulaire(saisie.B1.r8);
						},
						model.hP));
			case 59:
				return _Utils_Tuple2(
					A2($author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie, $author$project$Components$Parametrage$PipeEtape5$Model$ouvrirLAjout, model),
					_List_Nil);
			case 60:
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						function (saisie) {
							return _Utils_update(
								saisie,
								{fw: $elm$core$Maybe$Nothing});
						},
						_Utils_update(
							model,
							{pZ: $elm$core$Maybe$Nothing})),
					_List_Nil);
			case 61:
				var langue = msg.a;
				var texte = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						A2($author$project$Components$Parametrage$PipeEtape5$Model$poserNomAjout, langue, texte),
						model),
					_List_Nil);
			case 62:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$poserTypeAjout(code),
						model),
					_List_Nil);
			case 63:
				var texte = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape5$Model$poserValeursAjout(texte),
						model),
					_List_Nil);
			case 64:
				return A3(
					$author$project$Components$Parametrage$PipeEtape5$Update$versLApi,
					A2($author$project$Components$Parametrage$PipeEtape5$Update$lienDuFormulaire, $author$project$API$NavLinksDictionary$ajouterUnChampDeFormulaire, model),
					_Utils_update(
						model,
						{qE: true}),
					A2($elm$core$Maybe$andThen, $author$project$Components$Parametrage$PipeEtape5$Model$ajoutVoulu, model.hP));
			case 65:
				var uid = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						function (saisie) {
							return _Utils_update(
								saisie,
								{
									eW: $elm$core$Maybe$Just(uid)
								});
						},
						model),
					_List_Nil);
			case 66:
				return A3(
					$author$project$Components$Parametrage$PipeEtape5$Update$versLApi,
					A2($author$project$Components$Parametrage$PipeEtape5$Update$lienDuFormulaire, $author$project$API$NavLinksDictionary$retirerUnChampDeFormulaire, model),
					_Utils_update(
						model,
						{qE: true}),
					A2(
						$elm$core$Maybe$map,
						$author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$RetirerUnChamp,
						A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.eW;
							},
							model.hP)));
			case 67:
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape5$Update$surLaSaisie,
						function (saisie) {
							return _Utils_update(
								saisie,
								{qK: !saisie.qK});
						},
						model),
					_List_Nil);
			case 68:
				var uid = msg.a;
				return A3(
					$author$project$Components$Parametrage$PipeEtape5$Update$versLApi,
					A2($author$project$Components$Parametrage$PipeEtape5$Update$lienDuFormulaire, $author$project$API$NavLinksDictionary$restaurerUnChampDeFormulaire, model),
					_Utils_update(
						model,
						{qE: true}),
					A2(
						$elm$core$Maybe$map,
						function (saisie) {
							return $author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$RestaurerUnChamp(
								{cr: uid, mR: saisie.B1.r8});
						},
						model.hP));
			default:
				return A3(
					$author$project$Components$Parametrage$PipeEtape5$Update$versLApi,
					A2($author$project$Components$Parametrage$PipeEtape5$Update$lienDuFormulaire, $author$project$API$NavLinksDictionary$retirerUnFormulaire, model),
					model,
					A2(
						$elm$core$Maybe$map,
						function (saisie) {
							return $author$project$Components$Parametrage$PipeEtape5$API$WriteAPIModel$RetirerUnFormulaire(saisie.B1.r8);
						},
						model.hP));
		}
	});
var $author$project$Main$Update$versLEtape5DUnPipe = F3(
	function (i18n, msg, model) {
		var _v0 = A2(
			$author$project$Components$Parametrage$PipeEtape5$Update$update,
			msg,
			$author$project$Components$Parametrage$PipeEtape5$Model$ouvrir(model.FC));
		var etape5 = _v0.a;
		var effets = _v0.b;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLEtape5DUnPipe,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Parametrage$PipeEtape5$Update$popMessages(msg),
							model.Ct),
						FC: $author$project$Components$Parametrage$PipeEtape5$Model$envelopper(etape5)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$EnvoyerALEtape6DUnPipe = function (a) {
	return {$: 93, a: a};
};
var $author$project$Main$Update$LireLEtape6DUnPipe = F2(
	function (a, b) {
		return {$: 88, a: a, b: b};
	});
var $author$project$Main$Model$PourLEtape6DUnPipe = 22;
var $author$project$Main$Update$depuisLEtape6DUnPipe = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				var lecture = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLEtape6DUnPipe(lecture))));
			case 1:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerALEtape6DUnPipe(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[22]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 3:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$Droits = F8(
	function (role, etape, droit, champs, voitLesAutresRoles, autresRoles, etapesACopier, liens) {
		return {t9: autresRoles, dw: champs, xP: droit, me: etape, yM: etapesACopier, nQ: liens, bi: role, KU: voitLesAutresRoles};
	});
var $author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$ChampDeLaCase = F6(
	function (code, libelle, droit, calcule, personnelle, avertissement) {
		return {uj: avertissement, uC: calcule, vx: code, xP: droit, Bl: libelle, Ff: personnelle};
	});
var $author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$champDeLaCaseDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'avertissement',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'personnelle',
		$elm$json$Json$Decode$bool,
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'calcule',
			$elm$json$Json$Decode$bool,
			false,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'droit',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'libelle',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'code',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$ChampDeLaCase)))))));
var $author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$RoleDeLaCase = F5(
	function (uid, libelle, grammaire, parRelation, tenuPar) {
		return {m$: grammaire, Bl: libelle, EW: parRelation, e9: tenuPar, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$TenuPar = F3(
	function (relation, poste, phrase) {
		return {Fp: phrase, F4: poste, Ht: relation};
	});
var $author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$tenuParDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'phrase',
	$elm$json$Json$Decode$string,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'poste',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['relation', 'libelle']),
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$TenuPar))));
var $author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$roleDeLaCaseDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'tenuPar',
	$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$tenuParDecoder),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'parRelation',
		$elm$json$Json$Decode$bool,
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'grammaire',
			$elm$json$Json$Decode$nullable($author$project$Catalogue$Formes$decoder),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'libelle',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'uid',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$RoleDeLaCase))))));
var $author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$uidEtLibelle = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (uid, libelle) {
			return {Bl: libelle, r8: uid};
		}),
	A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string));
var $author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$droitsDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'etapesACopier',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$uidEtLibelle),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'autresRoles',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'voitLesAutresRoles',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'champs',
					$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$champDeLaCaseDecoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'droit',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'etape',
							$author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$uidEtLibelle,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'role',
								$author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$roleDeLaCaseDecoder,
								$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$Droits)))))))));
var $author$project$Components$Parametrage$PipeEtape6$Model$Edition = F2(
	function (libelles, liens) {
		return {R: libelles, nQ: liens};
	});
var $author$project$Components$Parametrage$PipeEtape6$Update$editionDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$PipeEtape6$Model$Edition,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['pipe', 'libelles']),
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)),
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder);
var $author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$Grille = F6(
	function (roles, etapes, cases, champsMasques, apercu, liens) {
		return {tq: apercu, uJ: cases, fM: champsMasques, yL: etapes, nQ: liens, eX: roles};
	});
var $author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$Apercu = F4(
	function (titre, etapes, rolesParRelation, champsMasques) {
		return {fM: champsMasques, yL: etapes, Ie: rolesParRelation, h6: titre};
	});
var $author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$apercuDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'champsMasques',
	$elm$json$Json$Decode$nullable(
		A2($elm$json$Json$Decode$field, 'phrase', $elm$json$Json$Decode$string)),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'rolesParRelation',
		$elm$json$Json$Decode$nullable(
			A2($elm$json$Json$Decode$field, 'phrase', $elm$json$Json$Decode$string)),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'etapes',
			$elm$json$Json$Decode$list(
				A3(
					$elm$json$Json$Decode$map2,
					F2(
						function (libelle, phrase) {
							return {Bl: libelle, Fp: phrase};
						}),
					A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'phrase', $elm$json$Json$Decode$string))),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'titre',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$Apercu)))));
var $author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$Case = F4(
	function (etapeUid, roleUid, droit, lecture) {
		return {xP: droit, gs: etapeUid, np: lecture, H6: roleUid};
	});
var $author$project$API$NavLinksDictionary$droitsDUnRoleAUneEtape = 'droits-d-un-role-a-une-etape';
var $author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$caseDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$droitsDUnRoleAUneEtape),
		$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'droit',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'roleUid',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'etapeUid',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$Case)))));
var $author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$ChampMasque = F4(
	function (uid, libelle, regleLibelle, roles) {
		return {Bl: libelle, Hm: regleLibelle, eX: roles, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$champMasqueDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'roles',
	$elm$json$Json$Decode$list(
		A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (uid, libelle) {
					return {Bl: libelle, r8: uid};
				}),
			A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string))),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'regleLibelle',
		$elm$json$Json$Decode$string,
		'',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['champ', 'libelle']),
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'uid',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$ChampMasque)))));
var $author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$Etape = F4(
	function (uid, rang, libelle, options) {
		return {Bl: libelle, o_: options, bY: rang, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$OptionsDEtape = F2(
	function (demandeurVoitLEtape, membresDuJuryVoientLesAutres) {
		return {kF: demandeurVoitLEtape, n6: membresDuJuryVoientLesAutres};
	});
var $author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$optionsDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$OptionsDEtape,
	A2($elm$json$Json$Decode$field, 'demandeurVoitLEtape', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'membresDuJuryVoientLesAutres', $elm$json$Json$Decode$bool));
var $author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$etapeDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'options',
	$author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$optionsDecoder,
	{kF: false, n6: false},
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'libelle',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'rang',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'uid',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$Etape)))));
var $author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$Role = F5(
	function (uid, libelle, nature, parRelation, grammaire) {
		return {m$: grammaire, Bl: libelle, g1: nature, EW: parRelation, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$roleDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'grammaire',
	$elm$json$Json$Decode$nullable($author$project$Catalogue$Formes$decoder),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'parRelation',
		$elm$json$Json$Decode$bool,
		false,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'nature',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'libelle',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'uid',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$Role))))));
var $author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$grilleDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'apercu',
		$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$apercuDecoder),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'champsMasques',
			$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$champMasqueDecoder),
			_List_Nil,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'cases',
				$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$caseDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'etapes',
					$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$etapeDecoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'roles',
						$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$roleDecoder),
						$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$Grille)))))));
var $author$project$Components$Parametrage$PipeEtape6$Update$refusDeLecture = F2(
	function (lecture, reponse) {
		var refuse = function (decodeur) {
			var _v1 = A2($author$project$API$Reponse$lire, decodeur, reponse);
			if (_v1.$ === 1) {
				var refus = _v1.a;
				return ((refus.ri === 401) || (refus.ri === 404)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Components$Shared$Messages$Model$duRefus(refus));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		switch (lecture) {
			case 0:
				return refuse($author$project$Components$Parametrage$Common$API$QueryAPIModel$annuaireDecoder);
			case 1:
				return refuse($author$project$Components$Parametrage$Common$API$QueryAPIModel$racineDuPipeDecoder);
			case 2:
				return refuse($author$project$Components$Parametrage$PipeEtape6$Update$editionDecoder);
			case 3:
				return refuse($author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$grilleDecoder);
			default:
				return refuse($author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$droitsDecoder);
		}
	});
var $author$project$Components$Parametrage$PipeEtape6$Update$popMessages = function (msg) {
	if (msg.$ === 2) {
		var lecture = msg.a;
		var reponse = msg.b;
		return A2($author$project$Components$Parametrage$PipeEtape6$Update$refusDeLecture, lecture, reponse);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$PipeEtape6$Update$Annuaire = 0;
var $author$project$Components$Parametrage$PipeEtape6$Update$DemanderProcessUid = {$: 2};
var $author$project$Components$Parametrage$PipeEtape6$Update$Lire = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape6$API$WriteAPIModel$ReglerLesDroits = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$PipeEtape6$API$WriteAPIModel$ReprendreLesDroits = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$PipeEtape6$Update$UneCase = 4;
var $author$project$Components$Parametrage$PipeEtape6$Model$basculerVoitLesAutresRoles = F2(
	function (voit, saisie) {
		return saisie.B1.bi.EW ? _Utils_update(
			saisie,
			{KU: voit}) : saisie;
	});
var $author$project$Components$Parametrage$PipeEtape6$Model$droitDuChamp = F2(
	function (saisie, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			'rien',
			A2($elm$core$Dict$get, code, saisie.dw));
	});
var $author$project$Components$Parametrage$PipeEtape6$Model$saisieDesDroits = function (droits) {
	return {
		dw: $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (champ) {
					return _Utils_Tuple2(champ.vx, champ.xP);
				},
				droits.dw)),
		xP: droits.xP,
		B1: droits,
		KU: A2($elm$core$Maybe$withDefault, false, droits.KU)
	};
};
var $author$project$Components$Parametrage$PipeEtape6$Model$droitsVoulus = function (saisie) {
	var champs = A2(
		$elm$core$List$map,
		function (champ) {
			return {
				vx: champ.vx,
				xP: A2($author$project$Components$Parametrage$PipeEtape6$Model$droitDuChamp, saisie, champ.vx)
			};
		},
		saisie.B1.dw);
	var inchange = _Utils_eq(saisie.xP, saisie.B1.xP) && (A2(
		$elm$core$List$all,
		function (champ) {
			return _Utils_eq(
				champ.xP,
				A2(
					$author$project$Components$Parametrage$PipeEtape6$Model$droitDuChamp,
					$author$project$Components$Parametrage$PipeEtape6$Model$saisieDesDroits(saisie.B1),
					champ.vx));
		},
		champs) && _Utils_eq(
		saisie.KU,
		A2($elm$core$Maybe$withDefault, false, saisie.B1.KU)));
	return inchange ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		{
			dw: champs,
			xP: saisie.xP,
			gs: saisie.B1.me.r8,
			H6: saisie.B1.bi.r8,
			KU: saisie.B1.bi.EW ? $elm$core$Maybe$Just(saisie.KU) : $elm$core$Maybe$Nothing
		});
};
var $author$project$Components$Parametrage$PipeEtape6$API$WriteAPIModel$ReglerLesOptions = function (a) {
	return {$: 1, a: a};
};
var $author$project$API$NavLinksDictionary$reglerLesOptionsDeLEtape = 'regler-les-options-de-l-etape';
var $author$project$Components$Parametrage$PipeEtape6$Update$Envoyer = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$PipeEtape6$Update$Reconnecter = {$: 4};
var $author$project$Components$Parametrage$PipeEtape6$API$WriteAPIModel$ReponseDeCommande = function (vuesAJour) {
	return {sy: vuesAJour};
};
var $author$project$Components$Parametrage$PipeEtape6$API$WriteAPIModel$reponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Components$Parametrage$PipeEtape6$API$WriteAPIModel$ReponseDeCommande,
	A2($elm$json$Json$Decode$field, 'vuesAJour', $elm$json$Json$Decode$bool));
var $author$project$Components$Parametrage$PipeEtape6$Update$reglage = {
	f8: $author$project$Components$Parametrage$PipeEtape6$Update$DemanderProcessUid,
	l4: $author$project$Components$Parametrage$PipeEtape6$Update$Envoyer,
	go: $elm$core$Basics$identity,
	pW: $author$project$Components$Parametrage$PipeEtape6$Update$Reconnecter,
	qu: F2(
		function (_v0, _v1) {
			return true;
		}),
	qv: $author$project$Components$Parametrage$PipeEtape6$API$WriteAPIModel$reponseDecoder
};
var $author$project$Components$Parametrage$PipeEtape6$Update$versLApi = F3(
	function (lien, model, commande) {
		if (!commande.$) {
			var voulue = commande.a;
			var _v1 = A4($author$project$API$Envoi$partir, $author$project$Components$Parametrage$PipeEtape6$Update$reglage, lien, voulue, model.l2);
			if (!_v1.$) {
				var _v2 = _v1.a;
				var envoi = _v2.a;
				var effets = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{l2: envoi, pZ: $elm$core$Maybe$Nothing}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$PipeEtape6$Update$envoyerLesOptions = F2(
	function (_v0, model) {
		var etapeUid = _v0.a;
		var options = _v0.b;
		return A3(
			$author$project$Components$Parametrage$PipeEtape6$Update$versLApi,
			A2(
				$elm$core$Maybe$andThen,
				function (grille) {
					return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reglerLesOptionsDeLEtape, grille.nQ);
				},
				model.m1),
			model,
			$elm$core$Maybe$Just(
				$author$project$Components$Parametrage$PipeEtape6$API$WriteAPIModel$ReglerLesOptions(
					{kF: options.kF, gs: etapeUid, n6: options.n6})));
	});
var $author$project$Components$Parametrage$PipeEtape6$Update$PlacerFocus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$PipeEtape6$Update$fermerLesOptions = function (model) {
	var _v0 = A3(
		$author$project$Components$Shared$Drawer$Update$update,
		{Il: false},
		$author$project$Components$Shared$Drawer$Update$Fermer,
		model.kX);
	var drawer = _v0.a;
	var effets = _v0.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{kX: drawer, o_: $elm$core$Maybe$Nothing, o0: _List_Nil}),
		A2(
			$elm$core$List$map,
			function (_v1) {
				var cible = _v1;
				return $author$project$Components$Parametrage$PipeEtape6$Update$PlacerFocus(cible);
			},
			effets));
};
var $author$project$Components$Parametrage$PipeEtape6$Model$caseDe = F3(
	function (grille, roleUid, etapeUid) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (c) {
					return _Utils_eq(c.H6, roleUid) && _Utils_eq(c.gs, etapeUid);
				},
				grille.uJ));
	});
var $author$project$Components$Parametrage$PipeEtape6$Update$lienDeLaCase = F3(
	function (roleUid, etapeUid, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.np;
			},
			A2(
				$elm$core$Maybe$andThen,
				function (grille) {
					return A3($author$project$Components$Parametrage$PipeEtape6$Model$caseDe, grille, roleUid, etapeUid);
				},
				model.m1));
	});
var $author$project$Components$Parametrage$PipeEtape6$Update$lienDeLaSaisie = F2(
	function (rel, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (saisie) {
				return A2($author$project$API$Liens$trouver, rel, saisie.B1.nQ);
			},
			model.hP);
	});
var $author$project$Components$Parametrage$PipeEtape6$Update$lireSi = F2(
	function (lecture, lien) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$Parametrage$PipeEtape6$Update$Lire(lecture),
					lien)));
	});
var $author$project$Components$Parametrage$PipeEtape6$Update$Edition = 2;
var $author$project$Components$Parametrage$PipeEtape6$Update$LaGrille = 3;
var $author$project$Components$Parametrage$PipeEtape6$Update$Racine = 1;
var $author$project$Components$Parametrage$PipeEtape6$Model$idDuDeclencheur = function (nom) {
	return 'pipe-etape-6-' + nom;
};
var $author$project$Components$Parametrage$PipeEtape6$Model$idDuDrawer = function (nom) {
	return 'pipe-etape-6-' + nom;
};
var $author$project$Components$Parametrage$PipeEtape6$Update$ouvrir = F3(
	function (declencheur, saisie, model) {
		if ($author$project$API$Envoi$enCours(model.l2)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v0 = A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				$author$project$Components$Shared$Drawer$Update$Ouvrir(
					$author$project$Components$Parametrage$PipeEtape6$Model$idDuDeclencheur(declencheur)),
				$author$project$Components$Shared$Drawer$Model$init(
					$author$project$Components$Parametrage$PipeEtape6$Model$idDuDrawer('droits')));
			var drawer = _v0.a;
			var effets = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						kX: drawer,
						pZ: $elm$core$Maybe$Nothing,
						hP: $elm$core$Maybe$Just(saisie)
					}),
				A2(
					$elm$core$List$map,
					function (_v1) {
						var cible = _v1;
						return $author$project$Components$Parametrage$PipeEtape6$Update$PlacerFocus(cible);
					},
					effets));
		}
	});
var $author$project$Components$Parametrage$PipeEtape6$Update$sous = F4(
	function (decodeur, reponse, model, suite) {
		var _v0 = A2($author$project$API$Reponse$lire, decodeur, reponse);
		if (!_v0.$) {
			var lue = _v0.a;
			return suite(lue);
		} else {
			var refus = _v0.a;
			return (refus.ri === 401) ? _Utils_Tuple2(
				model,
				_List_fromArray(
					[$author$project$Components$Parametrage$PipeEtape6$Update$Reconnecter])) : _Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ax: model.Ax || ((refus.ri !== 404) || (!_Utils_eq(model.ge, $elm$core$Maybe$Nothing))),
						nf: model.nf || ((refus.ri === 404) && _Utils_eq(model.ge, $elm$core$Maybe$Nothing))
					}),
				_List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$visibiliteDuPipe = 'visibilite';
var $author$project$Components$Parametrage$PipeEtape6$Update$lu = F3(
	function (lecture, reponse, model) {
		switch (lecture) {
			case 0:
				return A4(
					$author$project$Components$Parametrage$PipeEtape6$Update$sous,
					A4(
						$elm$json$Json$Decode$map3,
						F3(
							function (a, b, c) {
								return _Utils_Tuple3(a, b, c);
							}),
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$annuaireDecoder,
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$lienDuPipeDecoder(model.vx)),
					reponse,
					model,
					function (_v1) {
						var pipes = _v1.a;
						var liens = _v1.b;
						var visee = _v1.c;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									aS: $elm$core$Maybe$Just(pipes),
									nf: _Utils_eq(visee, $elm$core$Maybe$Nothing),
									nR: liens
								}),
							A2($author$project$Components$Parametrage$PipeEtape6$Update$lireSi, 1, visee));
					});
			case 1:
				return A4(
					$author$project$Components$Parametrage$PipeEtape6$Update$sous,
					$author$project$Components$Parametrage$Common$API$QueryAPIModel$racineDuPipeDecoder,
					reponse,
					model,
					function (edition) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									nf: _Utils_eq(edition, $elm$core$Maybe$Nothing)
								}),
							A2($author$project$Components$Parametrage$PipeEtape6$Update$lireSi, 2, edition));
					});
			case 2:
				return A4(
					$author$project$Components$Parametrage$PipeEtape6$Update$sous,
					$author$project$Components$Parametrage$PipeEtape6$Update$editionDecoder,
					reponse,
					model,
					function (edition) {
						var _v2 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$visibiliteDuPipe, edition.nQ);
						if (!_v2.$) {
							var lien = _v2.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										ge: $elm$core$Maybe$Just(edition)
									}),
								_List_fromArray(
									[
										A2($author$project$Components$Parametrage$PipeEtape6$Update$Lire, 3, lien)
									]));
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										ge: $elm$core$Maybe$Just(edition),
										Ax: true
									}),
								_List_Nil);
						}
					});
			case 3:
				return A4(
					$author$project$Components$Parametrage$PipeEtape6$Update$sous,
					$author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$grilleDecoder,
					reponse,
					model,
					function (grille) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									m1: $elm$core$Maybe$Just(grille)
								}),
							_List_Nil);
					});
			default:
				return A4(
					$author$project$Components$Parametrage$PipeEtape6$Update$sous,
					$author$project$Components$Parametrage$PipeEtape6$API$QueryAPIModel$droitsDecoder,
					reponse,
					model,
					function (droits) {
						return A3(
							$author$project$Components$Parametrage$PipeEtape6$Update$ouvrir,
							'case-' + (droits.bi.r8 + ('-' + droits.me.r8)),
							$author$project$Components$Parametrage$PipeEtape6$Model$saisieDesDroits(droits),
							model);
					});
		}
	});
var $author$project$Components$Parametrage$PipeEtape6$Model$optionsChangees = F2(
	function (grille, saisies) {
		return A2(
			$elm$core$List$filterMap,
			function (etape) {
				return A2(
					$elm$core$Maybe$andThen,
					function (voulues) {
						return (!_Utils_eq(voulues, etape.o_)) ? $elm$core$Maybe$Just(
							_Utils_Tuple2(etape.r8, voulues)) : $elm$core$Maybe$Nothing;
					},
					A2($elm$core$Dict$get, etape.r8, saisies));
			},
			grille.yL);
	});
var $author$project$Components$Parametrage$PipeEtape6$Model$optionsLues = function (grille) {
	return $elm$core$Dict$fromList(
		A2(
			$elm$core$List$map,
			function (etape) {
				return _Utils_Tuple2(etape.r8, etape.o_);
			},
			grille.yL));
};
var $author$project$Components$Parametrage$PipeEtape6$Update$ouvrirLesOptions = F2(
	function (saisies, model) {
		if ($author$project$API$Envoi$enCours(model.l2)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v0 = A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				$author$project$Components$Shared$Drawer$Update$Ouvrir(
					$author$project$Components$Parametrage$PipeEtape6$Model$idDuDeclencheur('options')),
				$author$project$Components$Shared$Drawer$Model$init(
					$author$project$Components$Parametrage$PipeEtape6$Model$idDuDrawer('options')));
			var drawer = _v0.a;
			var effets = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						kX: drawer,
						o_: $elm$core$Maybe$Just(saisies),
						o0: _List_Nil,
						pZ: $elm$core$Maybe$Nothing
					}),
				A2(
					$elm$core$List$map,
					function (_v1) {
						var cible = _v1;
						return $author$project$Components$Parametrage$PipeEtape6$Update$PlacerFocus(cible);
					},
					effets));
		}
	});
var $author$project$Components$Parametrage$PipeEtape6$Model$estCalcule = F2(
	function (saisie, code) {
		return A2(
			$elm$core$List$any,
			function (champ) {
				return _Utils_eq(champ.vx, code) && champ.uC;
			},
			saisie.B1.dw);
	});
var $author$project$Components$Parametrage$PipeEtape6$Model$droitsPossibles = _List_fromArray(
	['rien', 'voit', 'saisit']);
var $author$project$Components$Parametrage$PipeEtape6$Model$rang = function (droit) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$first,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var autre = _v0.b;
						return _Utils_eq(autre, droit);
					},
					A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, $author$project$Components$Parametrage$PipeEtape6$Model$droitsPossibles)))));
};
var $author$project$Components$Parametrage$PipeEtape6$Model$plafondDuChamp = F3(
	function (saisie, code, case_) {
		return (A2($author$project$Components$Parametrage$PipeEtape6$Model$estCalcule, saisie, code) && (_Utils_cmp(
			$author$project$Components$Parametrage$PipeEtape6$Model$rang(case_),
			$author$project$Components$Parametrage$PipeEtape6$Model$rang('voit')) > 0)) ? 'voit' : case_;
	});
var $author$project$Components$Parametrage$PipeEtape6$Model$plafonne = F2(
	function (case_, champ) {
		return (_Utils_cmp(
			$author$project$Components$Parametrage$PipeEtape6$Model$rang(champ),
			$author$project$Components$Parametrage$PipeEtape6$Model$rang(case_)) > 0) ? case_ : champ;
	});
var $author$project$Components$Parametrage$PipeEtape6$Model$poserDroitDeLaCase = F2(
	function (droit, saisie) {
		return _Utils_update(
			saisie,
			{
				dw: A2(
					$elm$core$Dict$map,
					F2(
						function (code, champ) {
							return A2(
								$author$project$Components$Parametrage$PipeEtape6$Model$plafonne,
								A3($author$project$Components$Parametrage$PipeEtape6$Model$plafondDuChamp, saisie, code, droit),
								champ);
						}),
					saisie.dw),
				xP: droit
			});
	});
var $author$project$Components$Parametrage$PipeEtape6$Model$poserDroitDuChamp = F3(
	function (code, droit, saisie) {
		return (_Utils_cmp(
			$author$project$Components$Parametrage$PipeEtape6$Model$rang(droit),
			$author$project$Components$Parametrage$PipeEtape6$Model$rang(
				A3($author$project$Components$Parametrage$PipeEtape6$Model$plafondDuChamp, saisie, code, saisie.xP))) > 0) ? saisie : _Utils_update(
			saisie,
			{
				dw: A3($elm$core$Dict$insert, code, droit, saisie.dw)
			});
	});
var $author$project$API$NavLinksDictionary$reglerLesDroitsDUnRoleAUneEtape = 'regler-les-droits-d-un-role-a-une-etape';
var $author$project$Components$Parametrage$PipeEtape6$Update$repondue = F2(
	function (reponse, model) {
		var _v0 = A3($author$project$API$Envoi$conclure, $author$project$Components$Parametrage$PipeEtape6$Update$reglage, reponse, model.l2);
		if (!_v0.$) {
			switch (_v0.a.b.$) {
				case 0:
					var _v1 = _v0.a;
					var envoi = _v1.a;
					var _v2 = _v1.b;
					var effets = _v1.c;
					if (!$elm$core$List$isEmpty(model.o0)) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{l2: envoi}),
							effets);
					} else {
						var _v3 = A3(
							$author$project$Components$Shared$Drawer$Update$update,
							{Il: false},
							$author$project$Components$Shared$Drawer$Update$Fermer,
							model.kX);
						var drawer = _v3.a;
						var deDrawer = _v3.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{kX: drawer, l2: envoi, o_: $elm$core$Maybe$Nothing, pZ: $elm$core$Maybe$Nothing, hP: $elm$core$Maybe$Nothing}),
							_Utils_ap(
								effets,
								_Utils_ap(
									A2(
										$elm$core$List$map,
										function (_v4) {
											var cible = _v4;
											return $author$project$Components$Parametrage$PipeEtape6$Update$PlacerFocus(cible);
										},
										deDrawer),
									A2(
										$author$project$Components$Parametrage$PipeEtape6$Update$lireSi,
										3,
										A2(
											$elm$core$Maybe$andThen,
											function (grille) {
												return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$self, grille.nQ);
											},
											model.m1)))));
					}
				case 1:
					var _v5 = _v0.a;
					var envoi = _v5.a;
					var _v6 = _v5.b;
					var refus = _v6.b;
					var effets = _v5.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l2: envoi,
								o0: _List_Nil,
								pZ: $elm$core$Maybe$Just(
									$author$project$Components$Parametrage$Vocabulaire$messageDuRefus(refus))
							}),
						effets);
				default:
					var _v7 = _v0.a;
					var envoi = _v7.a;
					var _v8 = _v7.b;
					var effets = _v7.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{l2: envoi}),
						effets);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$reprendreLesDroitsDUneAutreEtape = 'reprendre-les-droits-d-une-autre-etape';
var $author$project$Components$Parametrage$PipeEtape6$Update$suiteDesOptions = function (model) {
	var _v0 = model.o0;
	if (_v0.b) {
		var suivante = _v0.a;
		var reste = _v0.b;
		return A2(
			$author$project$Components$Parametrage$PipeEtape6$Update$envoyerLesOptions,
			suivante,
			_Utils_update(
				model,
				{o0: reste}));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$PipeEtape6$Update$surLaSaisie = F2(
	function (f, model) {
		return _Utils_update(
			model,
			{
				hP: A2($elm$core$Maybe$map, f, model.hP)
			});
	});
var $author$project$Components$Parametrage$PipeEtape6$Update$sortiesDuDrawer = _List_fromArray(
	[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$SortieDemandee, $author$project$Components$Shared$Drawer$Update$AbandonConfirme]);
var $author$project$Components$Parametrage$PipeEtape6$Update$versLeDrawer = F2(
	function (geste, model) {
		if ($author$project$API$Envoi$enCours(model.l2) && A2($elm$core$List$member, geste, $author$project$Components$Parametrage$PipeEtape6$Update$sortiesDuDrawer)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v0 = A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.kX);
			var drawer = _v0.a;
			var effets = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						kX: drawer,
						o_: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? model.o_ : $elm$core$Maybe$Nothing,
						hP: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? model.hP : $elm$core$Maybe$Nothing
					}),
				A2(
					$elm$core$List$map,
					function (_v1) {
						var cible = _v1;
						return $author$project$Components$Parametrage$PipeEtape6$Update$PlacerFocus(cible);
					},
					effets));
		}
	});
var $author$project$Components$Parametrage$PipeEtape6$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var code = msg.a;
				var liens = msg.b;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$pipes, liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						$author$project$Components$Parametrage$PipeEtape6$Model$init(code),
						_List_fromArray(
							[
								$author$project$Components$Parametrage$PipeEtape6$Update$DemanderProcessUid,
								A2($author$project$Components$Parametrage$PipeEtape6$Update$Lire, 0, lecture)
							]));
				} else {
					return _Utils_Tuple2(
						$author$project$Components$Parametrage$PipeEtape6$Model$init(code),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				return $author$project$Components$Parametrage$PipeEtape6$Update$suiteDesOptions(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}));
			case 2:
				var lecture = msg.a;
				var reponse = msg.b;
				return A3($author$project$Components$Parametrage$PipeEtape6$Update$lu, lecture, reponse, model);
			case 3:
				var reponse = msg.a;
				return A2($author$project$Components$Parametrage$PipeEtape6$Update$repondue, reponse, model);
			case 4:
				var geste = msg.a;
				return A2($author$project$Components$Parametrage$PipeEtape6$Update$versLeDrawer, geste, model);
			case 5:
				var roleUid = msg.a;
				var etapeUid = msg.b;
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$Components$Parametrage$PipeEtape6$Update$lireSi,
						4,
						A3($author$project$Components$Parametrage$PipeEtape6$Update$lienDeLaCase, roleUid, etapeUid, model)));
			case 6:
				var droit = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape6$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape6$Model$poserDroitDeLaCase(droit),
						model),
					_List_Nil);
			case 7:
				var code = msg.a;
				var droit = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape6$Update$surLaSaisie,
						A2($author$project$Components$Parametrage$PipeEtape6$Model$poserDroitDuChamp, code, droit),
						model),
					_List_Nil);
			case 8:
				var voit = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape6$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape6$Model$basculerVoitLesAutresRoles(voit),
						model),
					_List_Nil);
			case 9:
				var depuisEtapeUid = msg.a;
				return (depuisEtapeUid === '') ? _Utils_Tuple2(model, _List_Nil) : A3(
					$author$project$Components$Parametrage$PipeEtape6$Update$versLApi,
					A2($author$project$Components$Parametrage$PipeEtape6$Update$lienDeLaSaisie, $author$project$API$NavLinksDictionary$reprendreLesDroitsDUneAutreEtape, model),
					model,
					A2(
						$elm$core$Maybe$map,
						function (saisie) {
							return $author$project$Components$Parametrage$PipeEtape6$API$WriteAPIModel$ReprendreLesDroits(
								{xf: depuisEtapeUid, gs: saisie.B1.me.r8, H6: saisie.B1.bi.r8});
						},
						model.hP));
			case 10:
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, _List_Nil),
					A2(
						$elm$core$Maybe$map,
						function (grille) {
							return A2(
								$author$project$Components$Parametrage$PipeEtape6$Update$ouvrirLesOptions,
								$author$project$Components$Parametrage$PipeEtape6$Model$optionsLues(grille),
								model);
						},
						model.m1));
			case 11:
				var etapeUid = msg.a;
				var options = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							o_: A2(
								$elm$core$Maybe$map,
								A2($elm$core$Dict$insert, etapeUid, options),
								model.o_)
						}),
					_List_Nil);
			case 12:
				var _v2 = _Utils_Tuple2(model.m1, model.o_);
				if ((!_v2.a.$) && (!_v2.b.$)) {
					var grille = _v2.a.a;
					var saisies = _v2.b.a;
					var _v3 = A2($author$project$Components$Parametrage$PipeEtape6$Model$optionsChangees, grille, saisies);
					if (!_v3.b) {
						return $author$project$Components$Parametrage$PipeEtape6$Update$fermerLesOptions(model);
					} else {
						var premiere = _v3.a;
						var suite = _v3.b;
						return A2(
							$author$project$Components$Parametrage$PipeEtape6$Update$envoyerLesOptions,
							premiere,
							_Utils_update(
								model,
								{o0: suite}));
					}
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			default:
				return A3(
					$author$project$Components$Parametrage$PipeEtape6$Update$versLApi,
					A2($author$project$Components$Parametrage$PipeEtape6$Update$lienDeLaSaisie, $author$project$API$NavLinksDictionary$reglerLesDroitsDUnRoleAUneEtape, model),
					model,
					A2(
						$elm$core$Maybe$map,
						$author$project$Components$Parametrage$PipeEtape6$API$WriteAPIModel$ReglerLesDroits,
						A2($elm$core$Maybe$andThen, $author$project$Components$Parametrage$PipeEtape6$Model$droitsVoulus, model.hP)));
		}
	});
var $author$project$Main$Update$versLEtape6DUnPipe = F3(
	function (i18n, msg, model) {
		var _v0 = A2(
			$author$project$Components$Parametrage$PipeEtape6$Update$update,
			msg,
			$author$project$Components$Parametrage$PipeEtape6$Model$ouvrir(model.FD));
		var etape6 = _v0.a;
		var effets = _v0.b;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLEtape6DUnPipe,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Parametrage$PipeEtape6$Update$popMessages(msg),
							model.Ct),
						FD: $author$project$Components$Parametrage$PipeEtape6$Model$envelopper(etape6)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$EnvoyerALEtape7DUnPipe = function (a) {
	return {$: 94, a: a};
};
var $author$project$Main$Update$LireLEtape7DUnPipe = F2(
	function (a, b) {
		return {$: 89, a: a, b: b};
	});
var $author$project$Main$Model$PourLEtape7DUnPipe = 23;
var $author$project$Main$Update$depuisLEtape7DUnPipe = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				var lecture = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLEtape7DUnPipe(lecture))));
			case 1:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerALEtape7DUnPipe(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[23]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 3:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Detail = F8(
	function (uid, type_, etat, quand, condition, alors, enClair, liens) {
		return {iM: alors, j4: condition, yh: enClair, gt: etat, nQ: liens, hz: quand, r0: type_, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Alors = F8(
	function (action, de, vers, etapeUid, communication, delais, ecriture, brut) {
		return {fs: action, ux: brut, vO: communication, wC: de, w5: delais, x4: ecriture, gs: etapeUid, sn: vers};
	});
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Communication = F5(
	function (modeleUid, libelle, destinataires, siUnRoleEstVide, note) {
		return {xv: destinataires, Bl: libelle, CH: modeleUid, oJ: note, ra: siUnRoleEstVide};
	});
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Destinataire = F3(
	function (roleUid, libelle, parRelation) {
		return {Bl: libelle, EW: parRelation, H6: roleUid};
	});
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Segment = F2(
	function (texte, fort) {
		return {dX: fort, Jx: texte};
	});
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$segmentDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'fort',
	$elm$json$Json$Decode$bool,
	false,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'texte',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Segment)));
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$communicationDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'note',
	$elm$json$Json$Decode$nullable(
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$segmentDecoder)),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'siUnRoleEstVide',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'destinataires',
			$elm$json$Json$Decode$list(
				A4(
					$elm$json$Json$Decode$map3,
					$author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Destinataire,
					A2($elm$json$Json$Decode$field, 'roleUid', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2($elm$json$Json$Decode$field, 'parRelation', $elm$json$Json$Decode$bool),
								$elm$json$Json$Decode$succeed(false)
							])))),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'libelle',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'modeleUid',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Communication))))));
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$DelaiDePays = F2(
	function (pays, delaiEnSemaines) {
		return {w3: delaiEnSemaines, ho: pays};
	});
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Pays = F2(
	function (code, libelle) {
		return {vx: code, Bl: libelle};
	});
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$paysDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Pays,
	A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string));
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$delaiDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$DelaiDePays,
	A2($elm$json$Json$Decode$field, 'pays', $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$paysDecoder),
	A2($elm$json$Json$Decode$field, 'delaiEnSemaines', $elm$json$Json$Decode$int));
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Ecriture = F5(
	function (champ, champLibelle, pour, valeur, origineDesDelais) {
		return {uN: champ, uR: champLibelle, Eq: origineDesDelais, F8: pour, fm: valeur};
	});
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$ecritureDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Ecriture,
	A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'champLibelle', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'pour', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'valeur', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'origineDesDelais', $elm$json$Json$Decode$string)));
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Reference = F2(
	function (uid, libelle) {
		return {Bl: libelle, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$referenceDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Reference,
	A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string));
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$alorsDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$elm$json$Json$Decode$value,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'ecriture',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$ecritureDecoder),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'delaisParPays',
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$delaiDecoder)),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'communication',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$communicationDecoder),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'etapeUid',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						$elm$json$Json$Decode$maybe(
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['deVers', 'vers']),
								$author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$referenceDecoder)),
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							$elm$json$Json$Decode$maybe(
								A2(
									$elm$json$Json$Decode$at,
									_List_fromArray(
										['deVers', 'de']),
									$author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$referenceDecoder)),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'action',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Alors)))))))));
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Quand = F5(
	function (declencheur, etapeUid, tacheUid, delaiEnJours, date) {
		return {wv: date, wQ: declencheur, kB: delaiEnJours, gs: etapeUid, e8: tacheUid};
	});
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$quandDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'date',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'delaiEnJours',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'tacheUid',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'etapeUid',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'declencheur',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Quand))))));
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$detailDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'enClair',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$segmentDecoder),
		_List_Nil,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'alors',
			$author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$alorsDecoder,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'condition',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'quand',
					$author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$quandDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'etat',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'type',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'uid',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Detail)))))))));
var $author$project$Components$Parametrage$PipeEtape7$Model$Edition = F3(
	function (pipeUid, libelles, liens) {
		return {R: libelles, nQ: liens, FK: pipeUid};
	});
var $author$project$Components$Parametrage$PipeEtape7$Update$editionDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Parametrage$PipeEtape7$Model$Edition,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['pipe', 'uid']),
		$elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['pipe', 'libelles']),
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)),
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder);
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Liste = F3(
	function (lignes, apercu, liens) {
		return {tq: apercu, nQ: liens, gV: lignes};
	});
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Apercu = F3(
	function (titre, lignes, bilan) {
		return {uq: bilan, gV: lignes, h6: titre};
	});
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$apercuDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'bilan',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'lignes',
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				F2(
					function (titre, phrases) {
						return {Fq: phrases, h6: titre};
					}),
				A2($elm$json$Json$Decode$field, 'titre', $elm$json$Json$Decode$string),
				A2(
					$elm$json$Json$Decode$field,
					'phrases',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string)))),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'titre',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Apercu))));
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Ligne = F5(
	function (uid, type_, etat, phrase, liens) {
		return {gt: etat, nQ: liens, Fp: phrase, r0: type_, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$ligneDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'phrase',
		A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (q, a) {
					return {iM: a, hz: q};
				}),
			A2(
				$elm$json$Json$Decode$field,
				'quand',
				$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$segmentDecoder)),
			A2(
				$elm$json$Json$Decode$field,
				'alors',
				$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$segmentDecoder))),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'etat',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'type',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'uid',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Ligne))))));
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$listeDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'apercu',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$apercuDecoder),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'automatismes',
			$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$ligneDecoder),
			$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Liste))));
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$ActionProposee = F3(
	function (action, module_, etat) {
		return {fs: action, gt: etat, oe: module_};
	});
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Options = F9(
	function (declencheurs, etapes, taches, actions, modeles, rolesSurOffre, rolesDestinataires, siUnRoleEstVide, pays) {
		return {ft: actions, wR: declencheurs, yL: etapes, CI: modeles, ho: pays, Ib: rolesDestinataires, Ig: rolesSurOffre, ra: siUnRoleEstVide, Jk: taches};
	});
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$RoleDestinataire = F5(
	function (roleUid, libelle, parRelation, precision, parDefaut) {
		return {Bl: libelle, o6: parDefaut, EW: parRelation, Gd: precision, H6: roleUid};
	});
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Tache = F3(
	function (uid, libelle, etapeUid) {
		return {gs: etapeUid, Bl: libelle, r8: uid};
	});
var $author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$optionsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'pays',
	$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$paysDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'siUnRoleEstVide',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'rolesDestinataires',
			$elm$json$Json$Decode$list(
				A6(
					$elm$json$Json$Decode$map5,
					$author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$RoleDestinataire,
					A2($elm$json$Json$Decode$field, 'roleUid', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'parRelation', $elm$json$Json$Decode$bool),
					A2($elm$json$Json$Decode$field, 'precision', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'parDefaut', $elm$json$Json$Decode$bool))),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'rolesSurOffre',
				$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$referenceDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'modelesDeCommunication',
					$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$referenceDecoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'actions',
						$elm$json$Json$Decode$list(
							A4(
								$elm$json$Json$Decode$map3,
								$author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$ActionProposee,
								A2($elm$json$Json$Decode$field, 'action', $elm$json$Json$Decode$string),
								A2($elm$json$Json$Decode$field, 'module', $elm$json$Json$Decode$string),
								A2($elm$json$Json$Decode$field, 'etat', $elm$json$Json$Decode$string))),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'taches',
							$elm$json$Json$Decode$list(
								A4(
									$elm$json$Json$Decode$map3,
									$author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Tache,
									A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
									A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string),
									A2($elm$json$Json$Decode$field, 'etapeUid', $elm$json$Json$Decode$string))),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'etapes',
								$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$referenceDecoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'declencheurs',
									$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
									$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$Options))))))))));
var $author$project$Components$Parametrage$PipeEtape7$Update$refusDeLecture = F2(
	function (lecture, reponse) {
		var refuse = function (decodeur) {
			var _v1 = A2($author$project$API$Reponse$lire, decodeur, reponse);
			if (_v1.$ === 1) {
				var refus = _v1.a;
				return ((refus.ri === 401) || (refus.ri === 404)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Components$Shared$Messages$Model$duRefus(refus));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		switch (lecture) {
			case 0:
				return refuse($author$project$Components$Parametrage$Common$API$QueryAPIModel$annuaireDecoder);
			case 1:
				return refuse($author$project$Components$Parametrage$Common$API$QueryAPIModel$racineDuPipeDecoder);
			case 2:
				return refuse($author$project$Components$Parametrage$PipeEtape7$Update$editionDecoder);
			case 3:
				return refuse($author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$listeDecoder);
			case 4:
				return refuse($author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$optionsDecoder);
			default:
				return refuse($author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$detailDecoder);
		}
	});
var $author$project$Components$Parametrage$PipeEtape7$Update$popMessages = function (msg) {
	if (msg.$ === 2) {
		var lecture = msg.a;
		var reponse = msg.b;
		return A2($author$project$Components$Parametrage$PipeEtape7$Update$refusDeLecture, lecture, reponse);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$PipeEtape7$Update$Annuaire = 0;
var $author$project$Components$Parametrage$PipeEtape7$Update$DemanderProcessUid = {$: 2};
var $author$project$Components$Parametrage$PipeEtape7$Update$Lire = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$ReglerDelais = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$Supprimer = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$PipeEtape7$Update$UneFiche = 5;
var $author$project$Components$Parametrage$PipeEtape7$Model$ajouterUnPays = F3(
	function (options, code, saisie) {
		var _v0 = _Utils_Tuple2(
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (p) {
						return _Utils_eq(p.vx, code);
					},
					options.ho)),
			saisie.w5);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var pays = _v0.a.a;
			var delais = _v0.b.a;
			return A2(
				$elm$core$List$any,
				function (d) {
					return _Utils_eq(d.ho.vx, code);
				},
				delais) ? saisie : _Utils_update(
				saisie,
				{
					w5: $elm$core$Maybe$Just(
						_Utils_ap(
							delais,
							_List_fromArray(
								[
									{w3: 1, ho: pays}
								])))
				});
		} else {
			return saisie;
		}
	});
var $author$project$API$NavLinksDictionary$automatisme = 'automatisme';
var $author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$Reprendre = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$Suspendre = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$PipeEtape7$Update$lienDeLaLigne = F3(
	function (rel, uid, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (ligne) {
				return A2($author$project$API$Liens$trouver, rel, ligne.nQ);
			},
			A2(
				$elm$core$Maybe$andThen,
				function (liste) {
					return $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (ligne) {
								return _Utils_eq(ligne.r8, uid);
							},
							liste.gV));
				},
				model.nW));
	});
var $author$project$API$NavLinksDictionary$reprendreUnAutomatisme = 'reprendre-un-automatisme';
var $author$project$API$NavLinksDictionary$suspendreUnAutomatisme = 'suspendre-un-automatisme';
var $author$project$Components$Parametrage$PipeEtape7$Update$Envoyer = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$PipeEtape7$Update$Reconnecter = {$: 4};
var $author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$ReponseDeCommande = function (vuesAJour) {
	return {sy: vuesAJour};
};
var $author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$reponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$ReponseDeCommande,
	A2($elm$json$Json$Decode$field, 'vuesAJour', $elm$json$Json$Decode$bool));
var $author$project$Components$Parametrage$PipeEtape7$Update$reglage = {
	f8: $author$project$Components$Parametrage$PipeEtape7$Update$DemanderProcessUid,
	l4: $author$project$Components$Parametrage$PipeEtape7$Update$Envoyer,
	go: $elm$core$Basics$identity,
	pW: $author$project$Components$Parametrage$PipeEtape7$Update$Reconnecter,
	qu: F2(
		function (_v0, _v1) {
			return true;
		}),
	qv: $author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$reponseDecoder
};
var $author$project$Components$Parametrage$PipeEtape7$Update$versLApi = F3(
	function (lien, model, commande) {
		if (!commande.$) {
			var voulue = commande.a;
			var _v1 = A4($author$project$API$Envoi$partir, $author$project$Components$Parametrage$PipeEtape7$Update$reglage, lien, voulue, model.l2);
			if (!_v1.$) {
				var _v2 = _v1.a;
				var envoi = _v2.a;
				var effets = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{l2: envoi, pZ: $elm$core$Maybe$Nothing}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$PipeEtape7$Update$basculer = F2(
	function (uid, model) {
		var _v0 = A3($author$project$Components$Parametrage$PipeEtape7$Update$lienDeLaLigne, $author$project$API$NavLinksDictionary$suspendreUnAutomatisme, uid, model);
		if (!_v0.$) {
			var lien = _v0.a;
			return A3(
				$author$project$Components$Parametrage$PipeEtape7$Update$versLApi,
				$elm$core$Maybe$Just(lien),
				model,
				$elm$core$Maybe$Just(
					$author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$Suspendre(uid)));
		} else {
			return A3(
				$author$project$Components$Parametrage$PipeEtape7$Update$versLApi,
				A3($author$project$Components$Parametrage$PipeEtape7$Update$lienDeLaLigne, $author$project$API$NavLinksDictionary$reprendreUnAutomatisme, uid, model),
				model,
				$elm$core$Maybe$Just(
					$author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$Reprendre(uid)));
		}
	});
var $author$project$Components$Parametrage$PipeEtape7$Model$uniques = A2(
	$elm$core$List$foldl,
	F2(
		function (x, acc) {
			return A2($elm$core$List$member, x, acc) ? acc : _Utils_ap(
				acc,
				_List_fromArray(
					[x]));
		}),
	_List_Nil);
var $author$project$Components$Parametrage$PipeEtape7$Model$basculerDestinataire = F3(
	function (roleUid, coche, saisie) {
		return _Utils_update(
			saisie,
			{
				xv: coche ? $author$project$Components$Parametrage$PipeEtape7$Model$uniques(
					_Utils_ap(
						saisie.xv,
						_List_fromArray(
							[roleUid]))) : A2(
					$elm$core$List$filter,
					$elm$core$Basics$neq(roleUid),
					saisie.xv)
			});
	});
var $author$project$Components$Parametrage$PipeEtape7$Model$delaisAEnregistrer = function (saisie) {
	return A2(
		$elm$core$Maybe$map,
		$elm$core$List$map(
			function (d) {
				return _Utils_Tuple2(d.ho.vx, d.w3);
			}),
		saisie.w5);
};
var $author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$Ajouter = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$Modifier = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$ChangerLeRole = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$Communiquer = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$Inchangee = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$PasserA = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$PipeEtape7$Model$plein = function (valeur) {
	return ($elm$core$String$trim(valeur) === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(valeur);
};
var $author$project$Components$Parametrage$PipeEtape7$Model$alors = function (saisie) {
	var _v0 = saisie.fs;
	switch (_v0) {
		case 'changer-le-role-de-la-fiche':
			return A3(
				$elm$core$Maybe$map2,
				F2(
					function (de, vers) {
						return $author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$ChangerLeRole(
							{wC: de, sn: vers});
					}),
				$author$project$Components$Parametrage$PipeEtape7$Model$plein(saisie.wC),
				$author$project$Components$Parametrage$PipeEtape7$Model$plein(saisie.sn));
		case 'passer-a-une-etape':
			return A2(
				$elm$core$Maybe$map,
				$author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$PasserA,
				$author$project$Components$Parametrage$PipeEtape7$Model$plein(saisie.cH));
		case 'envoyer-une-communication':
			return $elm$core$List$isEmpty(saisie.xv) ? $elm$core$Maybe$Nothing : A2(
				$elm$core$Maybe$map,
				function (modele) {
					return $author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$Communiquer(
						{xv: saisie.xv, CH: modele, ra: saisie.c8});
				},
				$author$project$Components$Parametrage$PipeEtape7$Model$plein(saisie.oa));
		default:
			var autre = _v0;
			return _Utils_eq(saisie.r8, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A2($author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$Inchangee, autre, saisie.ux));
	}
};
var $author$project$Components$Parametrage$PipeEtape7$Model$quand = function (saisie) {
	var sans = {wv: $elm$core$Maybe$Nothing, wQ: saisie.wQ, kB: $elm$core$Maybe$Nothing, gs: $elm$core$Maybe$Nothing, e8: $elm$core$Maybe$Nothing};
	var _v0 = saisie.wQ;
	switch (_v0) {
		case 'une-tache-est-terminee':
			return A2(
				$elm$core$Maybe$map,
				function (tache) {
					return _Utils_update(
						sans,
						{
							e8: $elm$core$Maybe$Just(tache)
						});
				},
				$author$project$Components$Parametrage$PipeEtape7$Model$plein(saisie.Jj));
		case 'une-date-est-atteinte':
			return A2(
				$elm$core$Maybe$map,
				function (date) {
					return _Utils_update(
						sans,
						{
							wv: $elm$core$Maybe$Just(date)
						});
				},
				$author$project$Components$Parametrage$PipeEtape7$Model$plein(saisie.wv));
		case 'reste-sans-action':
			return A3(
				$elm$core$Maybe$map2,
				F2(
					function (etape, jours) {
						return _Utils_update(
							sans,
							{
								kB: $elm$core$Maybe$Just(jours),
								gs: $elm$core$Maybe$Just(etape)
							});
					}),
				$author$project$Components$Parametrage$PipeEtape7$Model$plein(saisie.me),
				A2(
					$elm$core$Maybe$andThen,
					function (jours) {
						return (jours > 0) ? $elm$core$Maybe$Just(jours) : $elm$core$Maybe$Nothing;
					},
					$elm$core$String$toInt(saisie.w2)));
		default:
			return A2(
				$elm$core$Maybe$map,
				function (etape) {
					return _Utils_update(
						sans,
						{
							gs: $elm$core$Maybe$Just(etape)
						});
				},
				$author$project$Components$Parametrage$PipeEtape7$Model$plein(saisie.me));
	}
};
var $author$project$Components$Parametrage$PipeEtape7$Model$corps = function (saisie) {
	return A3(
		$elm$core$Maybe$map2,
		F2(
			function (q, a) {
				return {
					iM: a,
					j4: $author$project$Components$Parametrage$PipeEtape7$Model$plein(saisie.j4),
					hz: q
				};
			}),
		$author$project$Components$Parametrage$PipeEtape7$Model$quand(saisie),
		$author$project$Components$Parametrage$PipeEtape7$Model$alors(saisie));
};
var $author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$corpsEnJson = A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$champs, $elm$json$Json$Encode$object);
var $author$project$Components$Parametrage$PipeEtape7$Model$aEnregistrer = function (saisie) {
	return A2(
		$elm$core$Maybe$andThen,
		function (voulu) {
			return _Utils_eq(
				saisie.cx,
				$elm$core$Maybe$Just(
					A2(
						$elm$json$Json$Encode$encode,
						0,
						$author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$corpsEnJson(voulu)))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(voulu);
		},
		$author$project$Components$Parametrage$PipeEtape7$Model$corps(saisie));
};
var $author$project$API$NavLinksDictionary$ajouterUnAutomatisme = 'ajouter-un-automatisme';
var $author$project$API$NavLinksDictionary$modifierUnAutomatisme = 'modifier-un-automatisme';
var $author$project$Components$Parametrage$PipeEtape7$Update$enregistrer = function (model) {
	var _v0 = model.hP;
	if (_v0.$ === 1) {
		return _Utils_Tuple2(model, _List_Nil);
	} else {
		var saisie = _v0.a;
		var _v1 = _Utils_Tuple2(
			saisie.r8,
			$author$project$Components$Parametrage$PipeEtape7$Model$aEnregistrer(saisie));
		_v1$2:
		while (true) {
			if (!_v1.a.$) {
				if (!_v1.b.$) {
					var uid = _v1.a.a;
					var corps = _v1.b.a;
					return A3(
						$author$project$Components$Parametrage$PipeEtape7$Update$versLApi,
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierUnAutomatisme, saisie.nQ),
						model,
						$elm$core$Maybe$Just(
							$author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$Modifier(
								{jc: uid, f$: corps})));
				} else {
					break _v1$2;
				}
			} else {
				if (!_v1.b.$) {
					var _v2 = _v1.a;
					var corps = _v1.b.a;
					return A3(
						$author$project$Components$Parametrage$PipeEtape7$Update$versLApi,
						A2(
							$elm$core$Maybe$andThen,
							function (liste) {
								return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ajouterUnAutomatisme, liste.nQ);
							},
							model.nW),
						model,
						A2(
							$elm$core$Maybe$map,
							function (edition) {
								return $author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$Ajouter(
									{f$: corps, FK: edition.FK});
							},
							model.ge));
				} else {
					break _v1$2;
				}
			}
		}
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$PipeEtape7$Update$lireSi = F2(
	function (lecture, lien) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$Parametrage$PipeEtape7$Update$Lire(lecture),
					lien)));
	});
var $author$project$Components$Parametrage$PipeEtape7$Update$Edition = 2;
var $author$project$Components$Parametrage$PipeEtape7$Update$LaListe = 3;
var $author$project$Components$Parametrage$PipeEtape7$Update$LesOptions = 4;
var $author$project$Components$Parametrage$PipeEtape7$Update$Racine = 1;
var $author$project$API$NavLinksDictionary$automatismes = 'automatismes';
var $author$project$API$NavLinksDictionary$optionsDesAutomatismes = 'options';
var $author$project$Components$Parametrage$PipeEtape7$Update$PlacerFocus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$PipeEtape7$Model$idDuDeclencheur = function (nom) {
	return 'pipe-etape-7-' + nom;
};
var $author$project$Components$Parametrage$PipeEtape7$Model$idDuDrawer = function (nom) {
	return 'pipe-etape-7-' + nom;
};
var $author$project$Components$Parametrage$PipeEtape7$Update$ouvrir = F3(
	function (declencheur, saisie, model) {
		if ($author$project$API$Envoi$enCours(model.l2)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v0 = A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				$author$project$Components$Shared$Drawer$Update$Ouvrir(
					$author$project$Components$Parametrage$PipeEtape7$Model$idDuDeclencheur(declencheur)),
				$author$project$Components$Shared$Drawer$Model$init(
					$author$project$Components$Parametrage$PipeEtape7$Model$idDuDrawer('automatisme')));
			var drawer = _v0.a;
			var effets = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						kX: drawer,
						pZ: $elm$core$Maybe$Nothing,
						hP: $elm$core$Maybe$Just(saisie)
					}),
				A2(
					$elm$core$List$map,
					function (_v1) {
						var cible = _v1;
						return $author$project$Components$Parametrage$PipeEtape7$Update$PlacerFocus(cible);
					},
					effets));
		}
	});
var $author$project$Components$Parametrage$PipeEtape7$Model$saisieDe = function (detail) {
	var communication = detail.iM.vO;
	var lue = {
		fs: detail.iM.fs,
		ux: detail.iM.ux,
		j4: A2($elm$core$Maybe$withDefault, '', detail.j4),
		wv: A2($elm$core$Maybe$withDefault, '', detail.hz.wv),
		wC: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.r8;
				},
				detail.iM.wC)),
		wQ: detail.hz.wQ,
		w2: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Maybe$map, $elm$core$String$fromInt, detail.hz.kB)),
		w5: detail.iM.w5,
		cx: $elm$core$Maybe$Nothing,
		xv: A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.xv;
					},
					$elm$core$List$map(
						function ($) {
							return $.H6;
						})),
				communication)),
		x4: detail.iM.x4,
		yh: detail.yh,
		me: A2($elm$core$Maybe$withDefault, '', detail.hz.gs),
		cH: A2($elm$core$Maybe$withDefault, '', detail.iM.gs),
		nQ: detail.nQ,
		oa: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.CH;
				},
				communication)),
		oJ: A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.oJ;
			},
			communication),
		c8: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ra;
				},
				communication)),
		Jj: A2($elm$core$Maybe$withDefault, '', detail.hz.e8),
		r0: detail.r0,
		r8: $elm$core$Maybe$Just(detail.r8),
		sn: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.r8;
				},
				detail.iM.sn))
	};
	return _Utils_update(
		lue,
		{
			cx: A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$corpsEnJson,
					$elm$json$Json$Encode$encode(0)),
				$author$project$Components$Parametrage$PipeEtape7$Model$corps(lue))
		});
};
var $author$project$Components$Parametrage$PipeEtape7$Update$sous = F4(
	function (decodeur, reponse, model, suite) {
		var _v0 = A2($author$project$API$Reponse$lire, decodeur, reponse);
		if (!_v0.$) {
			var lue = _v0.a;
			return suite(lue);
		} else {
			var refus = _v0.a;
			return (refus.ri === 401) ? _Utils_Tuple2(
				model,
				_List_fromArray(
					[$author$project$Components$Parametrage$PipeEtape7$Update$Reconnecter])) : _Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ax: model.Ax || ((refus.ri !== 404) || (!_Utils_eq(model.ge, $elm$core$Maybe$Nothing))),
						nf: model.nf || ((refus.ri === 404) && _Utils_eq(model.ge, $elm$core$Maybe$Nothing))
					}),
				_List_Nil);
		}
	});
var $author$project$Components$Parametrage$PipeEtape7$Update$lu = F3(
	function (lecture, reponse, model) {
		switch (lecture) {
			case 0:
				return A4(
					$author$project$Components$Parametrage$PipeEtape7$Update$sous,
					A4(
						$elm$json$Json$Decode$map3,
						F3(
							function (a, b, c) {
								return _Utils_Tuple3(a, b, c);
							}),
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$annuaireDecoder,
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$lienDuPipeDecoder(model.vx)),
					reponse,
					model,
					function (_v1) {
						var pipes = _v1.a;
						var liens = _v1.b;
						var visee = _v1.c;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									aS: $elm$core$Maybe$Just(pipes),
									nf: _Utils_eq(visee, $elm$core$Maybe$Nothing),
									nR: liens
								}),
							A2($author$project$Components$Parametrage$PipeEtape7$Update$lireSi, 1, visee));
					});
			case 1:
				return A4(
					$author$project$Components$Parametrage$PipeEtape7$Update$sous,
					$author$project$Components$Parametrage$Common$API$QueryAPIModel$racineDuPipeDecoder,
					reponse,
					model,
					function (edition) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									nf: _Utils_eq(edition, $elm$core$Maybe$Nothing)
								}),
							A2($author$project$Components$Parametrage$PipeEtape7$Update$lireSi, 2, edition));
					});
			case 2:
				return A4(
					$author$project$Components$Parametrage$PipeEtape7$Update$sous,
					$author$project$Components$Parametrage$PipeEtape7$Update$editionDecoder,
					reponse,
					model,
					function (edition) {
						var _v2 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$automatismes, edition.nQ);
						if (!_v2.$) {
							var lien = _v2.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										ge: $elm$core$Maybe$Just(edition)
									}),
								_List_fromArray(
									[
										A2($author$project$Components$Parametrage$PipeEtape7$Update$Lire, 3, lien)
									]));
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										ge: $elm$core$Maybe$Just(edition),
										Ax: true
									}),
								_List_Nil);
						}
					});
			case 3:
				return A4(
					$author$project$Components$Parametrage$PipeEtape7$Update$sous,
					$author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$listeDecoder,
					reponse,
					model,
					function (liste) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									nW: $elm$core$Maybe$Just(liste)
								}),
							A2(
								$author$project$Components$Parametrage$PipeEtape7$Update$lireSi,
								4,
								A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$optionsDesAutomatismes, liste.nQ)));
					});
			case 4:
				return A4(
					$author$project$Components$Parametrage$PipeEtape7$Update$sous,
					$author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$optionsDecoder,
					reponse,
					model,
					function (options) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									o_: $elm$core$Maybe$Just(options)
								}),
							_List_Nil);
					});
			default:
				return A4(
					$author$project$Components$Parametrage$PipeEtape7$Update$sous,
					$author$project$Components$Parametrage$PipeEtape7$API$QueryAPIModel$detailDecoder,
					reponse,
					model,
					function (detail) {
						return A3(
							$author$project$Components$Parametrage$PipeEtape7$Update$ouvrir,
							'ligne-' + detail.r8,
							$author$project$Components$Parametrage$PipeEtape7$Model$saisieDe(detail),
							model);
					});
		}
	});
var $author$project$Components$Parametrage$PipeEtape7$Model$poserAction = F2(
	function (valeur, saisie) {
		return _Utils_update(
			saisie,
			{fs: valeur});
	});
var $author$project$Components$Parametrage$PipeEtape7$Model$poserCondition = F2(
	function (valeur, saisie) {
		return _Utils_update(
			saisie,
			{j4: valeur});
	});
var $author$project$Components$Parametrage$PipeEtape7$Model$poserDate = F2(
	function (valeur, saisie) {
		return _Utils_update(
			saisie,
			{wv: valeur});
	});
var $author$project$Components$Parametrage$PipeEtape7$Model$poserDe = F2(
	function (valeur, saisie) {
		return _Utils_update(
			saisie,
			{wC: valeur});
	});
var $author$project$Components$Parametrage$PipeEtape7$Model$poserDeclencheur = F2(
	function (valeur, saisie) {
		return _Utils_update(
			saisie,
			{wQ: valeur});
	});
var $author$project$Components$Parametrage$PipeEtape7$Model$poserDelai = F2(
	function (valeur, saisie) {
		return _Utils_update(
			saisie,
			{
				w2: A2($elm$core$String$filter, $elm$core$Char$isDigit, valeur)
			});
	});
var $author$project$Components$Parametrage$PipeEtape7$Model$poserDelaiDePays = F3(
	function (code, valeur, saisie) {
		var semaines = A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$String$toInt(
				A2($elm$core$String$filter, $elm$core$Char$isDigit, valeur)));
		return _Utils_update(
			saisie,
			{
				w5: A2(
					$elm$core$Maybe$map,
					$elm$core$List$map(
						function (d) {
							return _Utils_eq(d.ho.vx, code) ? _Utils_update(
								d,
								{w3: semaines}) : d;
						}),
					saisie.w5)
			});
	});
var $author$project$Components$Parametrage$PipeEtape7$Model$poserEtape = F2(
	function (valeur, saisie) {
		return _Utils_update(
			saisie,
			{me: valeur});
	});
var $author$project$Components$Parametrage$PipeEtape7$Model$poserEtapeCible = F2(
	function (valeur, saisie) {
		return _Utils_update(
			saisie,
			{cH: valeur});
	});
var $author$project$Components$Parametrage$PipeEtape7$Model$poserModele = F2(
	function (valeur, saisie) {
		return _Utils_update(
			saisie,
			{oa: valeur});
	});
var $author$project$Components$Parametrage$PipeEtape7$Model$poserSiVide = F2(
	function (valeur, saisie) {
		return _Utils_update(
			saisie,
			{c8: valeur});
	});
var $author$project$Components$Parametrage$PipeEtape7$Model$poserTache = F2(
	function (valeur, saisie) {
		return _Utils_update(
			saisie,
			{Jj: valeur});
	});
var $author$project$Components$Parametrage$PipeEtape7$Model$poserVers = F2(
	function (valeur, saisie) {
		return _Utils_update(
			saisie,
			{sn: valeur});
	});
var $author$project$API$NavLinksDictionary$reglerLesDelaisParPays = 'regler-les-delais-par-pays';
var $author$project$Components$Parametrage$PipeEtape7$Update$repondue = F2(
	function (reponse, model) {
		var _v0 = A3($author$project$API$Envoi$conclure, $author$project$Components$Parametrage$PipeEtape7$Update$reglage, reponse, model.l2);
		if (!_v0.$) {
			switch (_v0.a.b.$) {
				case 0:
					var _v1 = _v0.a;
					var envoi = _v1.a;
					var _v2 = _v1.b;
					var effets = _v1.c;
					var _v3 = A3(
						$author$project$Components$Shared$Drawer$Update$update,
						{Il: false},
						$author$project$Components$Shared$Drawer$Update$Fermer,
						model.kX);
					var drawer = _v3.a;
					var deDrawer = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{kX: drawer, l2: envoi, pZ: $elm$core$Maybe$Nothing, hP: $elm$core$Maybe$Nothing}),
						_Utils_ap(
							effets,
							_Utils_ap(
								A2(
									$elm$core$List$map,
									function (_v4) {
										var cible = _v4;
										return $author$project$Components$Parametrage$PipeEtape7$Update$PlacerFocus(cible);
									},
									deDrawer),
								A2(
									$author$project$Components$Parametrage$PipeEtape7$Update$lireSi,
									3,
									A2(
										$elm$core$Maybe$andThen,
										function (liste) {
											return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$self, liste.nQ);
										},
										model.nW)))));
				case 1:
					var _v5 = _v0.a;
					var envoi = _v5.a;
					var _v6 = _v5.b;
					var refus = _v6.b;
					var effets = _v5.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l2: envoi,
								pZ: $elm$core$Maybe$Just(
									$author$project$Components$Parametrage$Vocabulaire$messageDuRefus(refus))
							}),
						effets);
				default:
					var _v7 = _v0.a;
					var envoi = _v7.a;
					var _v8 = _v7.b;
					var effets = _v7.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{l2: envoi}),
						effets);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$PipeEtape7$Model$retirerUnPays = F2(
	function (code, saisie) {
		return _Utils_update(
			saisie,
			{
				w5: A2(
					$elm$core$Maybe$map,
					$elm$core$List$filter(
						function (d) {
							return !_Utils_eq(d.ho.vx, code);
						}),
					saisie.w5)
			});
	});
var $author$project$Components$Parametrage$PipeEtape7$Model$actionReglable = function (action) {
	return A2(
		$elm$core$List$member,
		action,
		_List_fromArray(
			['changer-le-role-de-la-fiche', 'passer-a-une-etape', 'envoyer-une-communication']));
};
var $author$project$Components$Parametrage$PipeEtape7$Model$saisieNeuve = function (options) {
	return {
		fs: A2(
			$elm$core$Maybe$withDefault,
			'changer-le-role-de-la-fiche',
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					$author$project$Components$Parametrage$PipeEtape7$Model$actionReglable,
					A2(
						$elm$core$List$map,
						function ($) {
							return $.fs;
						},
						options.ft)))),
		ux: $elm$json$Json$Encode$null,
		j4: '',
		wv: '',
		wC: '',
		wQ: A2(
			$elm$core$Maybe$withDefault,
			'arrive-a-une-etape',
			$elm$core$List$head(options.wR)),
		w2: '',
		w5: $elm$core$Maybe$Nothing,
		cx: $elm$core$Maybe$Nothing,
		xv: A2(
			$elm$core$List$map,
			function ($) {
				return $.H6;
			},
			A2(
				$elm$core$List$filter,
				function ($) {
					return $.o6;
				},
				options.Ib)),
		x4: $elm$core$Maybe$Nothing,
		yh: _List_Nil,
		me: '',
		cH: '',
		nQ: _List_Nil,
		oa: '',
		oJ: $elm$core$Maybe$Nothing,
		c8: A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(options.ra)),
		Jj: '',
		r0: '',
		r8: $elm$core$Maybe$Nothing,
		sn: ''
	};
};
var $author$project$API$NavLinksDictionary$supprimerUnAutomatisme = 'supprimer-un-automatisme';
var $author$project$Components$Parametrage$PipeEtape7$Update$surLaSaisie = F2(
	function (f, model) {
		return _Utils_update(
			model,
			{
				hP: A2($elm$core$Maybe$map, f, model.hP)
			});
	});
var $author$project$Components$Parametrage$PipeEtape7$Update$sortiesDuDrawer = _List_fromArray(
	[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$SortieDemandee, $author$project$Components$Shared$Drawer$Update$AbandonConfirme]);
var $author$project$Components$Parametrage$PipeEtape7$Update$versLeDrawer = F2(
	function (geste, model) {
		if ($author$project$API$Envoi$enCours(model.l2) && A2($elm$core$List$member, geste, $author$project$Components$Parametrage$PipeEtape7$Update$sortiesDuDrawer)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v0 = A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.kX);
			var drawer = _v0.a;
			var effets = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						kX: drawer,
						hP: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? model.hP : $elm$core$Maybe$Nothing
					}),
				A2(
					$elm$core$List$map,
					function (_v1) {
						var cible = _v1;
						return $author$project$Components$Parametrage$PipeEtape7$Update$PlacerFocus(cible);
					},
					effets));
		}
	});
var $author$project$Components$Parametrage$PipeEtape7$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var code = msg.a;
				var liens = msg.b;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$pipes, liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						$author$project$Components$Parametrage$PipeEtape7$Model$init(code),
						_List_fromArray(
							[
								$author$project$Components$Parametrage$PipeEtape7$Update$DemanderProcessUid,
								A2($author$project$Components$Parametrage$PipeEtape7$Update$Lire, 0, lecture)
							]));
				} else {
					return _Utils_Tuple2(
						$author$project$Components$Parametrage$PipeEtape7$Model$init(code),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 2:
				var lecture = msg.a;
				var reponse = msg.b;
				return A3($author$project$Components$Parametrage$PipeEtape7$Update$lu, lecture, reponse, model);
			case 3:
				var reponse = msg.a;
				return A2($author$project$Components$Parametrage$PipeEtape7$Update$repondue, reponse, model);
			case 4:
				var geste = msg.a;
				return A2($author$project$Components$Parametrage$PipeEtape7$Update$versLeDrawer, geste, model);
			case 5:
				var uid = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$Components$Parametrage$PipeEtape7$Update$lireSi,
						5,
						A3($author$project$Components$Parametrage$PipeEtape7$Update$lienDeLaLigne, $author$project$API$NavLinksDictionary$automatisme, uid, model)));
			case 6:
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, _List_Nil),
					A2(
						$elm$core$Maybe$map,
						function (options) {
							return A3(
								$author$project$Components$Parametrage$PipeEtape7$Update$ouvrir,
								'ajouter',
								$author$project$Components$Parametrage$PipeEtape7$Model$saisieNeuve(options),
								model);
						},
						model.o_));
			case 7:
				var uid = msg.a;
				return A2($author$project$Components$Parametrage$PipeEtape7$Update$basculer, uid, model);
			case 8:
				var valeur = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape7$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape7$Model$poserDeclencheur(valeur),
						model),
					_List_Nil);
			case 9:
				var valeur = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape7$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape7$Model$poserEtape(valeur),
						model),
					_List_Nil);
			case 10:
				var valeur = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape7$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape7$Model$poserTache(valeur),
						model),
					_List_Nil);
			case 11:
				var valeur = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape7$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape7$Model$poserDelai(valeur),
						model),
					_List_Nil);
			case 12:
				var valeur = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape7$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape7$Model$poserDate(valeur),
						model),
					_List_Nil);
			case 13:
				var valeur = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape7$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape7$Model$poserCondition(valeur),
						model),
					_List_Nil);
			case 14:
				var valeur = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape7$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape7$Model$poserAction(valeur),
						model),
					_List_Nil);
			case 15:
				var valeur = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape7$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape7$Model$poserDe(valeur),
						model),
					_List_Nil);
			case 16:
				var valeur = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape7$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape7$Model$poserVers(valeur),
						model),
					_List_Nil);
			case 17:
				var valeur = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape7$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape7$Model$poserEtapeCible(valeur),
						model),
					_List_Nil);
			case 18:
				var valeur = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape7$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape7$Model$poserModele(valeur),
						model),
					_List_Nil);
			case 19:
				var roleUid = msg.a;
				var coche = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape7$Update$surLaSaisie,
						A2($author$project$Components$Parametrage$PipeEtape7$Model$basculerDestinataire, roleUid, coche),
						model),
					_List_Nil);
			case 20:
				var valeur = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape7$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape7$Model$poserSiVide(valeur),
						model),
					_List_Nil);
			case 21:
				return $author$project$Components$Parametrage$PipeEtape7$Update$enregistrer(model);
			case 23:
				var code = msg.a;
				var valeur = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape7$Update$surLaSaisie,
						A2($author$project$Components$Parametrage$PipeEtape7$Model$poserDelaiDePays, code, valeur),
						model),
					_List_Nil);
			case 24:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$Maybe$withDefault,
						model,
						A2(
							$elm$core$Maybe$map,
							function (options) {
								return A2(
									$author$project$Components$Parametrage$PipeEtape7$Update$surLaSaisie,
									A2($author$project$Components$Parametrage$PipeEtape7$Model$ajouterUnPays, options, code),
									model);
							},
							model.o_)),
					_List_Nil);
			case 25:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$PipeEtape7$Update$surLaSaisie,
						$author$project$Components$Parametrage$PipeEtape7$Model$retirerUnPays(code),
						model),
					_List_Nil);
			case 26:
				var _v2 = model.hP;
				if (!_v2.$) {
					var saisie = _v2.a;
					var _v3 = _Utils_Tuple2(
						saisie.r8,
						$author$project$Components$Parametrage$PipeEtape7$Model$delaisAEnregistrer(saisie));
					if ((!_v3.a.$) && (!_v3.b.$)) {
						var uid = _v3.a.a;
						var delais = _v3.b.a;
						return A3(
							$author$project$Components$Parametrage$PipeEtape7$Update$versLApi,
							A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reglerLesDelaisParPays, saisie.nQ),
							model,
							$elm$core$Maybe$Just(
								$author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$ReglerDelais(
									{jc: uid, w5: delais})));
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			default:
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, _List_Nil),
					A2(
						$elm$core$Maybe$map,
						function (_v4) {
							var saisie = _v4.a;
							var uid = _v4.b;
							return A3(
								$author$project$Components$Parametrage$PipeEtape7$Update$versLApi,
								A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$supprimerUnAutomatisme, saisie.nQ),
								model,
								$elm$core$Maybe$Just(
									$author$project$Components$Parametrage$PipeEtape7$API$WriteAPIModel$Supprimer(uid)));
						},
						A2(
							$elm$core$Maybe$andThen,
							function (saisie) {
								return A2(
									$elm$core$Maybe$map,
									function (uid) {
										return _Utils_Tuple2(saisie, uid);
									},
									saisie.r8);
							},
							model.hP)));
		}
	});
var $author$project$Main$Update$versLEtape7DUnPipe = F3(
	function (i18n, msg, model) {
		var _v0 = A2(
			$author$project$Components$Parametrage$PipeEtape7$Update$update,
			msg,
			$author$project$Components$Parametrage$PipeEtape7$Model$ouvrir(model.FE));
		var etape7 = _v0.a;
		var effets = _v0.b;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLEtape7DUnPipe,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Parametrage$PipeEtape7$Update$popMessages(msg),
							model.Ct),
						FE: $author$project$Components$Parametrage$PipeEtape7$Model$envelopper(etape7)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$EnvoyerALEtape8DUnPipe = function (a) {
	return {$: 95, a: a};
};
var $author$project$Main$Update$LireLEtape8DUnPipe = F2(
	function (a, b) {
		return {$: 90, a: a, b: b};
	});
var $author$project$Main$Model$PourLEtape8DUnPipe = 24;
var $author$project$Main$Update$depuisLEtape8DUnPipe = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				var lecture = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLEtape8DUnPipe(lecture))));
			case 1:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerALEtape8DUnPipe(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[24]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Parametrage$PipeEtape8$Model$Edition = F3(
	function (pipeUid, libelles, liens) {
		return {R: libelles, nQ: liens, FK: pipeUid};
	});
var $author$project$Components$Parametrage$PipeEtape8$Update$editionDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Parametrage$PipeEtape8$Model$Edition,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['pipe', 'uid']),
		$elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['pipe', 'libelles']),
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)),
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder);
var $author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$Changement = function (texte) {
	return {Jx: texte};
};
var $author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$Verification = F9(
	function (numero, statut, baseeSur, controles, bilan, versionComparee, changements, dossiers, liens) {
		return {jp: baseeSur, uq: bilan, u3: changements, wc: controles, xJ: dossiers, nQ: liens, DX: numero, ri: statut, KF: versionComparee};
	});
var $author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$Bilan = F3(
	function (erreurs, avertissements, ok) {
		return {uk: avertissements, gp: erreurs, D7: ok};
	});
var $author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$bilanDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$Bilan,
	A2($elm$json$Json$Decode$field, 'erreurs', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'avertissements', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'ok', $elm$json$Json$Decode$int));
var $author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$Controle = F5(
	function (niveau, code, texte, etape, liens) {
		return {vx: code, me: etape, nQ: liens, os: niveau, Jx: texte};
	});
var $author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$Avertissement = 1;
var $author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$Conforme = 2;
var $author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$Erreur = 0;
var $author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$niveauDecoder = function (niveau) {
	switch (niveau) {
		case 'erreur':
			return $elm$json$Json$Decode$succeed(0);
		case 'avertissement':
			return $elm$json$Json$Decode$succeed(1);
		case 'ok':
			return $elm$json$Json$Decode$succeed(2);
		default:
			var autre = niveau;
			return $elm$json$Json$Decode$fail(autre);
	}
};
var $author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$controleDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'etape',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'texte',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'code',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'niveau',
					A2($elm$json$Json$Decode$andThen, $author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$niveauDecoder, $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$Controle))))));
var $author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$Dossiers = F3(
	function (versionDeReference, parEtape, total) {
		return {EO: parEtape, JE: total, KG: versionDeReference};
	});
var $author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$dossiersDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$Dossiers,
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'versionDeReference', $elm$json$Json$Decode$int)),
	A2(
		$elm$json$Json$Decode$field,
		'parEtape',
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				F2(
					function (libelle, nombre) {
						return {Bl: libelle, w: nombre};
					}),
				A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'nombre', $elm$json$Json$Decode$int)))),
	A2($elm$json$Json$Decode$field, 'total', $elm$json$Json$Decode$int));
var $author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$verificationDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'dossiersEnCours',
		$author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$dossiersDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['changementsDepuis', 'elements']),
			$elm$json$Json$Decode$list(
				A2(
					$elm$json$Json$Decode$map,
					$author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$Changement,
					A2($elm$json$Json$Decode$field, 'texte', $elm$json$Json$Decode$string))),
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
				_List_fromArray(
					['changementsDepuis', 'versionDeReference']),
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'bilan',
					$author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$bilanDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'controles',
						$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$controleDecoder),
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
							_List_fromArray(
								['version', 'baseeSur']),
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['version', 'statut']),
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
									_List_fromArray(
										['version', 'numero']),
									$elm$json$Json$Decode$int,
									$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$Verification))))))))));
var $author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$Version = F5(
	function (numero, statut, baseeSur, publieePar, dossiersEnCours) {
		return {jp: baseeSur, xK: dossiersEnCours, DX: numero, GE: publieePar, ri: statut};
	});
var $author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$versionsDecoder = A2(
	$elm$json$Json$Decode$field,
	'versions',
	$elm$json$Json$Decode$list(
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'dossiersEnCours',
			$elm$json$Json$Decode$int,
			0,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
				_List_fromArray(
					['publieePar', 'libelle']),
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'baseeSur',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'statut',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'numero',
							$elm$json$Json$Decode$int,
							$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$Version))))))));
var $author$project$Components$Parametrage$PipeEtape8$Update$refusDeLecture = F2(
	function (lecture, reponse) {
		var refuse = function (decodeur) {
			var _v1 = A2($author$project$API$Reponse$lire, decodeur, reponse);
			if (_v1.$ === 1) {
				var refus = _v1.a;
				return ((refus.ri === 401) || (refus.ri === 404)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Components$Shared$Messages$Model$duRefus(refus));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		switch (lecture) {
			case 0:
				return refuse($author$project$Components$Parametrage$Common$API$QueryAPIModel$annuaireDecoder);
			case 1:
				return refuse($author$project$Components$Parametrage$Common$API$QueryAPIModel$racineDuPipeDecoder);
			case 2:
				return refuse($author$project$Components$Parametrage$PipeEtape8$Update$editionDecoder);
			case 3:
				return refuse($author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$verificationDecoder);
			default:
				return refuse($author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$versionsDecoder);
		}
	});
var $author$project$Components$Parametrage$PipeEtape8$Update$popMessages = function (msg) {
	if (msg.$ === 2) {
		var lecture = msg.a;
		var reponse = msg.b;
		return A2($author$project$Components$Parametrage$PipeEtape8$Update$refusDeLecture, lecture, reponse);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$PipeEtape8$Update$Annuaire = 0;
var $author$project$Components$Parametrage$PipeEtape8$Update$DemanderProcessUid = {$: 2};
var $author$project$Components$Parametrage$PipeEtape8$Update$LaVerification = 3;
var $author$project$Components$Parametrage$PipeEtape8$Update$Lire = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape8$Update$Edition = 2;
var $author$project$Components$Parametrage$PipeEtape8$Update$LesVersions = 4;
var $author$project$Components$Parametrage$PipeEtape8$Update$Racine = 1;
var $author$project$Components$Parametrage$PipeEtape8$Update$lireSi = F2(
	function (lecture, lien) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$Parametrage$PipeEtape8$Update$Lire(lecture),
					lien)));
	});
var $author$project$Components$Parametrage$PipeEtape8$Update$Reconnecter = {$: 3};
var $author$project$Components$Parametrage$PipeEtape8$Update$sous = F4(
	function (decodeur, reponse, model, suite) {
		var _v0 = A2($author$project$API$Reponse$lire, decodeur, reponse);
		if (!_v0.$) {
			var lue = _v0.a;
			return suite(lue);
		} else {
			var refus = _v0.a;
			return (refus.ri === 401) ? _Utils_Tuple2(
				model,
				_List_fromArray(
					[$author$project$Components$Parametrage$PipeEtape8$Update$Reconnecter])) : _Utils_Tuple2(
				_Utils_update(
					model,
					{nf: model.nf || (refus.ri === 404)}),
				_List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$verification = 'verification';
var $author$project$API$NavLinksDictionary$versionsDuPipe = 'versions';
var $author$project$Components$Parametrage$PipeEtape8$Update$lu = F3(
	function (lecture, reponse, model) {
		switch (lecture) {
			case 0:
				return A4(
					$author$project$Components$Parametrage$PipeEtape8$Update$sous,
					A4(
						$elm$json$Json$Decode$map3,
						F3(
							function (a, b, c) {
								return _Utils_Tuple3(a, b, c);
							}),
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$annuaireDecoder,
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$lienDuPipeDecoder(model.vx)),
					reponse,
					model,
					function (_v1) {
						var pipes = _v1.a;
						var liens = _v1.b;
						var visee = _v1.c;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									aS: $elm$core$Maybe$Just(pipes),
									nf: _Utils_eq(visee, $elm$core$Maybe$Nothing),
									nR: liens
								}),
							A2($author$project$Components$Parametrage$PipeEtape8$Update$lireSi, 1, visee));
					});
			case 1:
				return A4(
					$author$project$Components$Parametrage$PipeEtape8$Update$sous,
					$author$project$Components$Parametrage$Common$API$QueryAPIModel$racineDuPipeDecoder,
					reponse,
					model,
					function (edition) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									nf: _Utils_eq(edition, $elm$core$Maybe$Nothing)
								}),
							A2($author$project$Components$Parametrage$PipeEtape8$Update$lireSi, 2, edition));
					});
			case 2:
				return A4(
					$author$project$Components$Parametrage$PipeEtape8$Update$sous,
					$author$project$Components$Parametrage$PipeEtape8$Update$editionDecoder,
					reponse,
					model,
					function (edition) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									ge: $elm$core$Maybe$Just(edition)
								}),
							_Utils_ap(
								A2(
									$author$project$Components$Parametrage$PipeEtape8$Update$lireSi,
									3,
									A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$verification, edition.nQ)),
								A2(
									$author$project$Components$Parametrage$PipeEtape8$Update$lireSi,
									4,
									A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$versionsDuPipe, edition.nQ))));
					});
			case 3:
				return A4(
					$author$project$Components$Parametrage$PipeEtape8$Update$sous,
					$author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$verificationDecoder,
					reponse,
					model,
					function (verification) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									ij: $elm$core$Maybe$Just(verification)
								}),
							_List_Nil);
					});
			default:
				return A4(
					$author$project$Components$Parametrage$PipeEtape8$Update$sous,
					$author$project$Components$Parametrage$PipeEtape8$API$QueryAPIModel$versionsDecoder,
					reponse,
					model,
					function (versions) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{ss: versions}),
							_List_Nil);
					});
		}
	});
var $author$project$Components$Parametrage$PipeEtape8$API$WriteAPIModel$Publier = $elm$core$Basics$identity;
var $author$project$API$NavLinksDictionary$publierLaVersion = 'publier-la-version';
var $author$project$Components$Parametrage$PipeEtape8$Update$Envoyer = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$PipeEtape8$API$WriteAPIModel$ReponseDeCommande = function (vuesAJour) {
	return {sy: vuesAJour};
};
var $author$project$Components$Parametrage$PipeEtape8$API$WriteAPIModel$reponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Components$Parametrage$PipeEtape8$API$WriteAPIModel$ReponseDeCommande,
	A2($elm$json$Json$Decode$field, 'vuesAJour', $elm$json$Json$Decode$bool));
var $author$project$Components$Parametrage$PipeEtape8$Update$reglage = {
	f8: $author$project$Components$Parametrage$PipeEtape8$Update$DemanderProcessUid,
	l4: $author$project$Components$Parametrage$PipeEtape8$Update$Envoyer,
	go: $elm$core$Basics$identity,
	pW: $author$project$Components$Parametrage$PipeEtape8$Update$Reconnecter,
	qu: F2(
		function (_v0, _v1) {
			return true;
		}),
	qv: $author$project$Components$Parametrage$PipeEtape8$API$WriteAPIModel$reponseDecoder
};
var $author$project$Components$Parametrage$PipeEtape8$Update$publier = function (model) {
	var lien = A2(
		$elm$core$Maybe$andThen,
		function (verification) {
			return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$publierLaVersion, verification.nQ);
		},
		model.ij);
	var _v0 = _Utils_Tuple2(lien, model.ge);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var vers = _v0.a.a;
		var edition = _v0.b.a;
		var _v1 = A4(
			$author$project$API$Envoi$partir,
			$author$project$Components$Parametrage$PipeEtape8$Update$reglage,
			$elm$core$Maybe$Just(vers),
			edition.FK,
			model.l2);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var envoi = _v2.a;
			var effets = _v2.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi, pZ: $elm$core$Maybe$Nothing}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$API$NavLinksDictionary$relancerLaVerification = 'relancer-la-verification';
var $author$project$Components$Parametrage$PipeEtape8$Update$relire = F3(
	function (rel, lecture, model) {
		return A2(
			$author$project$Components$Parametrage$PipeEtape8$Update$lireSi,
			lecture,
			A2(
				$elm$core$Maybe$andThen,
				function (verification) {
					return A2($author$project$API$Liens$trouver, rel, verification.nQ);
				},
				model.ij));
	});
var $author$project$Components$Parametrage$PipeEtape8$Update$repondue = F2(
	function (reponse, model) {
		var _v0 = A3($author$project$API$Envoi$conclure, $author$project$Components$Parametrage$PipeEtape8$Update$reglage, reponse, model.l2);
		if (!_v0.$) {
			switch (_v0.a.b.$) {
				case 0:
					var _v1 = _v0.a;
					var envoi = _v1.a;
					var _v2 = _v1.b;
					var effets = _v1.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{l2: envoi, pZ: $elm$core$Maybe$Nothing}),
						_Utils_ap(
							effets,
							_Utils_ap(
								A3($author$project$Components$Parametrage$PipeEtape8$Update$relire, $author$project$API$NavLinksDictionary$self, 3, model),
								A2(
									$author$project$Components$Parametrage$PipeEtape8$Update$lireSi,
									4,
									A2(
										$elm$core$Maybe$andThen,
										function (edition) {
											return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$versionsDuPipe, edition.nQ);
										},
										model.ge)))));
				case 1:
					var _v3 = _v0.a;
					var envoi = _v3.a;
					var _v4 = _v3.b;
					var refus = _v4.b;
					var effets = _v3.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l2: envoi,
								pZ: $elm$core$Maybe$Just(
									$author$project$Components$Parametrage$Vocabulaire$messageDuRefus(refus))
							}),
						effets);
				default:
					var _v5 = _v0.a;
					var envoi = _v5.a;
					var _v6 = _v5.b;
					var effets = _v5.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{l2: envoi}),
						effets);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$PipeEtape8$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var code = msg.a;
				var liens = msg.b;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$pipes, liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						$author$project$Components$Parametrage$PipeEtape8$Model$init(code),
						_List_fromArray(
							[
								$author$project$Components$Parametrage$PipeEtape8$Update$DemanderProcessUid,
								A2($author$project$Components$Parametrage$PipeEtape8$Update$Lire, 0, lecture)
							]));
				} else {
					return _Utils_Tuple2(
						$author$project$Components$Parametrage$PipeEtape8$Model$init(code),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 2:
				var lecture = msg.a;
				var reponse = msg.b;
				return A3($author$project$Components$Parametrage$PipeEtape8$Update$lu, lecture, reponse, model);
			case 3:
				var reponse = msg.a;
				return A2($author$project$Components$Parametrage$PipeEtape8$Update$repondue, reponse, model);
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pZ: $elm$core$Maybe$Nothing}),
					A3($author$project$Components$Parametrage$PipeEtape8$Update$relire, $author$project$API$NavLinksDictionary$relancerLaVerification, 3, model));
			default:
				return $author$project$Components$Parametrage$PipeEtape8$Update$publier(model);
		}
	});
var $author$project$Main$Update$versLEtape8DUnPipe = F3(
	function (i18n, msg, model) {
		var _v0 = A2($author$project$Components$Parametrage$PipeEtape8$Update$update, msg, model.FF);
		var etape8 = _v0.a;
		var effets = _v0.b;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLEtape8DUnPipe,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Parametrage$PipeEtape8$Update$popMessages(msg),
							model.Ct),
						FF: etape8
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$FicheDUneOffre = 11;
var $author$project$Main$Model$PourLOffre = 16;
var $author$project$Components$Produits$Offre$Update$dansUnDialogue = function (model) {
	return model.is || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) || $author$project$Components$Shared$Drawer$Model$estOuvert(model.lb));
};
var $author$project$Components$Produits$Offre$API$QueryAPIModel$Fiche = function (id) {
	return function (code) {
		return function (nom) {
			return function (rattachement) {
				return function (etat) {
					return function (arretee) {
						return function (type_) {
							return function (valeurs) {
								return function (etats) {
									return function (unites) {
										return function (langues) {
											return function (liens) {
												return {tL: arretee, vx: code, gt: etat, mj: etats, Aq: id, Ba: langues, nQ: liens, Dj: nom, pN: rattachement, r0: type_, sb: unites, Ki: valeurs};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Catalogue$API$QueryAPIModel$ElementDeRattachement = F3(
	function (id, niveau, libelles) {
		return {Aq: id, R: libelles, os: niveau};
	});
var $author$project$Catalogue$API$QueryAPIModel$elementDeRattachementDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'libelles',
	$author$project$Catalogue$API$QueryAPIModel$libellesDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'niveau',
		$author$project$Catalogue$Identifiants$niveauIdDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$author$project$Catalogue$Identifiants$elementIdDecoder,
			$elm$json$Json$Decode$succeed($author$project$Catalogue$API$QueryAPIModel$ElementDeRattachement))));
var $author$project$Catalogue$API$QueryAPIModel$TypeAvecSchema = F6(
	function (id, nom, version, champs, masques, ordre) {
		return {dw: champs, Aq: id, Cd: masques, Dj: nom, El: ordre, sq: version};
	});
var $author$project$Catalogue$API$QueryAPIModel$typeAvecSchemaDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'ordre',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'masques',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['schema', 'fields']),
			$elm$json$Json$Decode$list($author$project$Components$Shared$EditeurDeSchema$Champ$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'version',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'nom',
					$author$project$Catalogue$API$QueryAPIModel$libellesDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$author$project$Catalogue$Identifiants$typeDeProduitIdDecoder,
						$elm$json$Json$Decode$succeed($author$project$Catalogue$API$QueryAPIModel$TypeAvecSchema)))))));
var $author$project$Catalogue$API$QueryAPIModel$unitesDecoder = $elm$json$Json$Decode$list(
	A4(
		$elm$json$Json$Decode$map3,
		$author$project$Components$Shared$EditeurDeSchema$Propositions$Unite,
		A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'symbole', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'grandeur', $elm$json$Json$Decode$string)));
var $author$project$Components$Produits$Offre$API$QueryAPIModel$ficheDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'langues',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'unites',
			$author$project$Catalogue$API$QueryAPIModel$unitesDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'etats',
				$author$project$Catalogue$API$QueryAPIModel$etatsDuClientDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'valeurs',
					$elm$json$Json$Decode$keyValuePairs($author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'type',
						$author$project$Catalogue$API$QueryAPIModel$typeAvecSchemaDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'arretee',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'etat',
								$author$project$Catalogue$Identifiants$etatCodeDecoder,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'rattachement',
									A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$elementDeRattachementDecoder),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'nom',
										A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
										$elm$core$Maybe$Nothing,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'code',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'id',
												$author$project$Catalogue$Identifiants$referenceIdDecoder,
												$elm$json$Json$Decode$succeed($author$project$Components$Produits$Offre$API$QueryAPIModel$Fiche)))))))))))));
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$champsMontres = function (type_) {
	var ordonnes = A2(
		$elm$core$List$filterMap,
		function (cle) {
			return $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dy;
						},
						$elm$core$Basics$eq(cle)),
					type_.dw));
		},
		type_.El);
	return A2(
		$elm$core$List$filter,
		function (champ) {
			return !A2($elm$core$List$member, champ.dy, type_.Cd);
		},
		_Utils_ap(
			ordonnes,
			A2(
				$elm$core$List$filter,
				function (champ) {
					return !A2($elm$core$List$member, champ.dy, type_.El);
				},
				type_.dw)));
};
var $author$project$Components$Produits$Offre$Model$champs = function (fiche) {
	return $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$champsMontres(fiche.r0);
};
var $author$project$Components$Produits$Offre$Update$horsFiche = F2(
	function (model, refus) {
		var montres = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Produits$Offre$Model$champs,
					$elm$core$List$map(
						function ($) {
							return $.dy;
						})),
				model.zo));
		return A2(
			$elm$core$List$filter,
			function (refuse) {
				return !A2($elm$core$List$member, refuse.uN, montres);
			},
			refus);
	});
var $author$project$Components$Produits$Offre$Update$perime = function (erreur) {
	return A2(
		$elm$core$List$member,
		erreur,
		_List_fromArray(
			[$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$DejaArretee, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$Introuvable, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$EcritureConcurrente, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$EtatInconnu, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ValeurNonProposable]));
};
var $author$project$Components$Produits$Common$Etat$refusDEtatInconnu = function (refus) {
	return {Jx: $author$project$I18n$Textes$produitsReferencesRefusEtatInconnu, b9: refus.b9};
};
var $author$project$Components$Produits$Offre$Update$message = F2(
	function (refus, erreur) {
		return _Utils_eq(erreur, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$EtatInconnu) ? $author$project$Components$Produits$Common$Etat$refusDEtatInconnu(refus) : ($author$project$Components$Produits$Offre$Update$perime(erreur) ? {Jx: $author$project$I18n$Textes$produitsCatalogueErreurPerime, b9: refus.b9} : $author$project$Components$Shared$Messages$Model$duRefus(refus));
	});
var $author$project$Catalogue$API$PrixAPIModel$PrixDUneReference = F3(
	function (parListe, publicsSansPrix, liens) {
		return {nQ: liens, ES: parListe, GC: publicsSansPrix};
	});
var $author$project$Catalogue$API$PrixAPIModel$Public = F4(
	function (ref, libelle, archive, indisponible) {
		return {tE: archive, AJ: indisponible, Bl: libelle, Hb: ref};
	});
var $author$project$Catalogue$API$PrixAPIModel$publicDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (indisponible) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			indisponible,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'archive',
				$elm$json$Json$Decode$bool,
				(indisponible ? $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded('') : A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'libelle', $elm$json$Json$Decode$string))(
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						$author$project$Catalogue$API$PrixAPIModel$refDePublicDecoder,
						$elm$json$Json$Decode$succeed($author$project$Catalogue$API$PrixAPIModel$Public)))));
	},
	A2($elm$json$Json$Decode$field, 'indisponible', $elm$json$Json$Decode$bool));
var $author$project$Catalogue$API$PrixAPIModel$typeProposeDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
	false,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
		false,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'libelle',
			$elm$json$Json$Decode$string,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$author$project$Catalogue$API$PrixAPIModel$refDePublicDecoder,
				$elm$json$Json$Decode$succeed($author$project$Catalogue$API$PrixAPIModel$Public)))));
var $author$project$Catalogue$API$PrixAPIModel$prixDUneReferenceDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'publicsSansPrix',
		$elm$json$Json$Decode$list($author$project$Catalogue$API$PrixAPIModel$typeProposeDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'parListe',
			$elm$json$Json$Decode$list(
				A5(
					$elm$json$Json$Decode$map4,
					F4(
						function (liste, publics, publique, prix) {
							return {nW: liste, py: prix, GA: publics, GF: publique};
						}),
					A2($elm$json$Json$Decode$field, 'liste', $author$project$Catalogue$API$PrixAPIModel$listeNommeeDecoder),
					A2(
						$elm$json$Json$Decode$field,
						'publics',
						$elm$json$Json$Decode$list($author$project$Catalogue$API$PrixAPIModel$publicDecoder)),
					A2($elm$json$Json$Decode$field, 'publique', $elm$json$Json$Decode$bool),
					A2(
						$elm$json$Json$Decode$field,
						'prix',
						A5(
							$elm$json$Json$Decode$map4,
							F4(
								function (montant, devise, unite, taxes) {
									return {kO: devise, oi: montant, rB: taxes, sa: unite};
								}),
							A2($elm$json$Json$Decode$field, 'montant', $elm$json$Json$Decode$string),
							A2($elm$json$Json$Decode$field, 'devise', $elm$json$Json$Decode$string),
							A2($elm$json$Json$Decode$field, 'unite', $elm$json$Json$Decode$string),
							A2($elm$json$Json$Decode$field, 'taxes', $author$project$Catalogue$API$PrixAPIModel$taxesDecoder))))),
			$elm$json$Json$Decode$succeed($author$project$Catalogue$API$PrixAPIModel$PrixDUneReference))));
var $author$project$Catalogue$API$QueryAPIModel$RolesSurUneOffre = F5(
	function (offre, type_, nomDuType, archetype, ouverts) {
		return {fA: archetype, Dp: nomDuType, D1: offre, Ev: ouverts, r0: type_};
	});
var $author$project$Catalogue$API$QueryAPIModel$rolesSurUneOffreDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'ouverts',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'archetype',
		$elm$json$Json$Decode$string,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
			_List_fromArray(
				['libelles', 'fr']),
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'type',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'offre',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Catalogue$API$QueryAPIModel$RolesSurUneOffre))))));
var $author$project$Components$Produits$Offre$Update$popMessages = F2(
	function (model, msg) {
		switch (msg.$) {
			case 19:
				var reponse = msg.a;
				var _v1 = A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, model.l2);
				_v1$3:
				while (true) {
					if (!_v1.$) {
						switch (_v1.a.b.$) {
							case 0:
								if (!_v1.a.b.c) {
									var _v2 = _v1.a;
									var _v3 = _v2.b;
									return $author$project$Components$Produits$Offre$Update$dansUnDialogue(model) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($author$project$Components$Produits$Common$Refus$rejeu);
								} else {
									break _v1$3;
								}
							case 1:
								if (_v1.a.b.c.$ === 36) {
									var _v4 = _v1.a;
									var _v5 = _v4.b;
									var refus = _v5.b;
									var refuses = _v5.c.a;
									return ($elm$core$List$isEmpty(
										A2($author$project$Components$Produits$Offre$Update$horsFiche, model, refuses)) || $author$project$Components$Produits$Offre$Update$dansUnDialogue(model)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
										{Jx: $author$project$I18n$Textes$produitsCatalogueErreurPerime, b9: refus.b9});
								} else {
									var _v6 = _v1.a;
									var _v7 = _v6.b;
									var refus = _v7.b;
									var erreur = _v7.c;
									return $author$project$Components$Produits$Offre$Update$dansUnDialogue(model) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
										A2($author$project$Components$Produits$Offre$Update$message, refus, erreur));
								}
							default:
								break _v1$3;
						}
					} else {
						break _v1$3;
					}
				}
				return $elm$core$Maybe$Nothing;
			case 4:
				var reponse = msg.a;
				var _v8 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Offre$API$QueryAPIModel$ficheDecoder, reponse);
				if (_v8.$ === 1) {
					var refus = _v8.a;
					return A2(
						$elm$core$List$member,
						refus.ri,
						_List_fromArray(
							[401, 404])) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 5:
				var reponse = msg.a;
				var _v9 = A2($author$project$API$Reponse$lire, $author$project$Catalogue$API$PrixAPIModel$prixDUneReferenceDecoder, reponse);
				if (_v9.$ === 1) {
					var refus = _v9.a;
					return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 2:
				var reponse = msg.a;
				var _v10 = A2(
					$author$project$API$Reponse$lire,
					$elm$json$Json$Decode$list($author$project$Catalogue$API$QueryAPIModel$rolesSurUneOffreDecoder),
					reponse);
				if (_v10.$ === 1) {
					var refus = _v10.a;
					return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 3:
				var octets = msg.a;
				return _Utils_eq(
					$author$project$API$ProcessUid$depuisOctets(octets),
					$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
					{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$Common$Effet$LireLeComptageDesRoles = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$Produits$Common$Effet$LireLesPrix = function (a) {
	return {$: 25, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$ChangerLEtatDUneReference = F2(
	function (a, b) {
		return {$: 40, a: a, b: b};
	});
var $author$project$Components$Produits$Common$Etat$Fermer = {$: 1};
var $author$project$Components$Produits$Common$Etat$Partir = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$changerLEtatDUneReference = 'changer-l-etat-d-une-reference';
var $author$project$Components$Produits$Common$Etat$lien = function (porteur) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$changerLEtatDUneReference, porteur.nQ);
};
var $author$project$Components$Produits$Common$Etat$decider = F2(
	function (voulu, porteur) {
		return _Utils_eq(voulu, porteur.gt) ? $elm$core$Maybe$Just($author$project$Components$Produits$Common$Etat$Fermer) : A2(
			$elm$core$Maybe$map,
			$author$project$Components$Produits$Common$Etat$Partir(
				A2($author$project$Catalogue$API$WriteAPIModel$ChangerLEtatDUneReference, porteur.Aq, voulu)),
			$author$project$Components$Produits$Common$Etat$lien(porteur));
	});
var $author$project$Components$Produits$Offre$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{kX: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Produits$Common$Effet$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.kX));
	});
var $author$project$Components$Produits$Offre$Update$changerLEtat = function (model) {
	var _v0 = _Utils_Tuple3(
		$author$project$Components$Shared$Drawer$Model$estOuvert(model.kX),
		model.mi,
		model.zo);
	if ((_v0.a && (!_v0.b.$)) && (!_v0.c.$)) {
		var voulu = _v0.b.a;
		var fiche = _v0.c.a;
		var _v1 = A2($author$project$Components$Produits$Common$Etat$decider, voulu, fiche);
		if (!_v1.$) {
			if (_v1.a.$ === 1) {
				var _v2 = _v1.a;
				return A2($author$project$Components$Produits$Offre$Update$versLeDrawer, $author$project$Components$Shared$Drawer$Update$Fermer, model);
			} else {
				var _v3 = _v1.a;
				var commande = _v3.a;
				var lien = _v3.b;
				var _v4 = A3(
					$author$project$Components$Produits$Common$Envoi$partir,
					$elm$core$Maybe$Just(lien),
					commande,
					model.l2);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var envoi = _v5.a;
					var effets = _v5.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{l2: envoi, p$: $elm$core$Maybe$Nothing}),
						effets);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$Common$Etat$choisir = F2(
	function (porteur, code) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Catalogue$Identifiants$etatCodeToString,
					$elm$core$Basics$eq(code)),
				A2(
					$elm$core$List$cons,
					porteur.gt,
					A2(
						$elm$core$List$map,
						function ($) {
							return $.vx;
						},
						porteur.mj))));
	});
var $author$project$Catalogue$API$WriteAPIModel$ArreterUneReference = function (a) {
	return {$: 43, a: a};
};
var $author$project$API$NavLinksDictionary$arreterUneReference = 'arreter-une-reference';
var $author$project$Components$Produits$Offre$Model$commandeDArret = function (fiche) {
	return A2(
		$elm$core$Maybe$map,
		$elm$core$Tuple$pair(
			$author$project$Catalogue$API$WriteAPIModel$ArreterUneReference(fiche.Aq)),
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$arreterUneReference, fiche.nQ));
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$acceptee = function (saisie) {
	return _Utils_update(
		saisie,
		{AP: saisie.Ki, aJ: _List_Nil, pZ: _List_Nil, b5: false});
};
var $author$project$Components$Produits$Common$Etat$apres = F2(
	function (evenements, porteur) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (evenement, courant) {
					if (evenement.$ === 41) {
						var etat = evenement.a;
						return _Utils_update(
							courant,
							{gt: etat});
					} else {
						return courant;
					}
				}),
			porteur,
			evenements);
	});
var $author$project$Components$Produits$Offre$Model$enregistree = F2(
	function (envoyees, fiche) {
		var gardees = A2(
			$elm$core$List$filter,
			function (_v4) {
				var cle = _v4.a;
				return !A2(
					$elm$core$List$member,
					cle,
					A2($elm$core$List$map, $elm$core$Tuple$first, envoyees));
			},
			fiche.Ki);
		var fusionnee = F2(
			function (cle, envoyee) {
				var _v1 = _Utils_Tuple2(
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$first,
								$elm$core$Basics$eq(cle)),
							fiche.Ki)),
					envoyee);
				if (((!_v1.a.$) && (_v1.a.a.b.$ === 5)) && (_v1.b.$ === 5)) {
					var _v2 = _v1.a.a;
					var lues = _v2.b.a;
					var changees = _v1.b.a;
					return $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Traductions(
						_Utils_ap(
							A2(
								$elm$core$List$filter,
								function (_v3) {
									var code = _v3.a;
									return !A2(
										$elm$core$List$member,
										code,
										A2($elm$core$List$map, $elm$core$Tuple$first, changees));
								},
								lues),
							changees));
				} else {
					return envoyee;
				}
			});
		return _Utils_update(
			fiche,
			{
				Ki: _Utils_ap(
					gardees,
					A2(
						$elm$core$List$map,
						function (_v0) {
							var cle = _v0.a;
							var envoyee = _v0.b;
							return _Utils_Tuple2(
								cle,
								A2(fusionnee, cle, envoyee));
						},
						envoyees))
			});
	});
var $author$project$Components$Produits$Offre$Update$fermerApresEnregistrement = function (model) {
	return A3(
		$elm$core$Tuple$mapBoth,
		function (drawer) {
			return _Utils_update(
				model,
				{lb: drawer, hE: $elm$core$Maybe$Nothing});
		},
		$elm$core$List$map(
			function (_v0) {
				var cible = _v0;
				return $author$project$Components$Produits$Common$Effet$PlacerFocus(cible);
			}),
		A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{Il: false},
			$author$project$Components$Shared$Drawer$Update$Fermer,
			model.lb));
};
var $author$project$Components$Produits$Offre$Model$idDeLaSection = 'fiche-de-l-offre';
var $author$project$API$NavLinksDictionary$modifierLesAttributsDUneReference = 'modifier-les-attributs-d-une-reference';
var $author$project$Components$Produits$Offre$Model$liensApres = F2(
	function (rendus, fiche) {
		var action = function (lien) {
			return A2(
				$elm$core$List$member,
				lien.eP,
				_List_fromArray(
					[$author$project$API$NavLinksDictionary$modifierLesAttributsDUneReference, $author$project$API$NavLinksDictionary$changerLEtatDUneReference, $author$project$API$NavLinksDictionary$arreterUneReference]));
		};
		return _Utils_ap(
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, action),
				fiche.nQ),
			A2($elm$core$List$filter, action, rendus));
	});
var $author$project$Components$Produits$Offre$Model$prefixeDesChamps = 'champ-de-l-offre';
var $author$project$Components$Produits$Offre$Update$relire = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$Lire, $elm$core$List$singleton),
			model.np));
};
var $author$project$Components$Produits$Offre$Update$relecture = F2(
	function (rendue, model) {
		return (rendue.sy && (!A2($elm$core$List$member, $author$project$Catalogue$API$WriteAPIModel$EvenementInconnu, rendue.mk))) ? $author$project$Components$Produits$Offre$Update$relire(model) : _List_fromArray(
			[
				$author$project$Components$Produits$Common$Effet$AttendreAvantDeRelire($author$project$Components$Produits$Common$Envoi$delaiDeRelectureMs)
			]);
	});
var $author$project$Components$Produits$Offre$Update$conclure = F2(
	function (issue, model) {
		var avecLesLiens = function (rendue) {
			return A2(
				$elm$core$Maybe$map,
				function (fiche) {
					return _Utils_update(
						fiche,
						{
							nQ: A2($author$project$Components$Produits$Offre$Model$liensApres, rendue.nQ, fiche)
						});
				},
				model.zo);
		};
		switch (issue.$) {
			case 0:
				if (issue.c) {
					switch (issue.a.$) {
						case 38:
							var _v1 = issue.a;
							var envoyees = _v1.b;
							var rendue = issue.b;
							return A2(
								$elm$core$Tuple$mapSecond,
								function (effets) {
									return _Utils_ap(
										effets,
										A2($author$project$Components$Produits$Offre$Update$relecture, rendue, model));
								},
								$author$project$Components$Produits$Offre$Update$fermerApresEnregistrement(
									_Utils_update(
										model,
										{
											zo: A2(
												$elm$core$Maybe$map,
												$author$project$Components$Produits$Offre$Model$enregistree(envoyees),
												avecLesLiens(rendue)),
											hP: $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$acceptee(model.hP)
										})));
						case 43:
							var rendue = issue.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										is: false,
										zo: A2(
											$elm$core$Maybe$map,
											function (fiche) {
												return _Utils_update(
													fiche,
													{tL: true});
											},
											avecLesLiens(rendue)),
										p_: $elm$core$Maybe$Nothing
									}),
								A2(
									$elm$core$List$cons,
									$author$project$Components$Produits$Common$Effet$PlacerFocus($author$project$Components$Produits$Offre$Model$idDeLaSection),
									A2($author$project$Components$Produits$Offre$Update$relecture, rendue, model)));
						case 40:
							var _v2 = issue.a;
							var rendue = issue.b;
							return A2(
								$elm$core$Tuple$mapSecond,
								function (effets) {
									return _Utils_ap(
										effets,
										A2($author$project$Components$Produits$Offre$Update$relecture, rendue, model));
								},
								A2(
									$author$project$Components$Produits$Offre$Update$versLeDrawer,
									$author$project$Components$Shared$Drawer$Update$Fermer,
									_Utils_update(
										model,
										{
											zo: A2(
												$elm$core$Maybe$map,
												$author$project$Components$Produits$Common$Etat$apres(rendue.mk),
												avecLesLiens(rendue))
										})));
						default:
							var rendue = issue.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										zo: avecLesLiens(rendue)
									}),
								A2($author$project$Components$Produits$Offre$Update$relecture, rendue, model));
					}
				} else {
					return _Utils_Tuple2(
						model.is ? _Utils_update(
							model,
							{
								p_: $elm$core$Maybe$Just($author$project$Components$Produits$Common$Refus$rejeu)
							}) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) ? _Utils_update(
							model,
							{
								p$: $elm$core$Maybe$Just($author$project$Components$Produits$Common$Refus$rejeu)
							}) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.lb) ? _Utils_update(
							model,
							{
								hE: $elm$core$Maybe$Just($author$project$Components$Produits$Common$Refus$rejeu)
							}) : model)),
						$author$project$Components$Produits$Offre$Update$relire(model));
				}
			case 1:
				if (issue.c.$ === 36) {
					var requete = issue.b;
					var refus = issue.c.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								hE: $elm$core$List$isEmpty(
									A2($author$project$Components$Produits$Offre$Update$horsFiche, model, refus)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
									{Jx: $author$project$I18n$Textes$produitsCatalogueErreurPerime, b9: requete.b9}),
								hP: A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$refuser, refus, model.hP)
							}),
						_Utils_ap(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (premier) {
										return _List_fromArray(
											[
												$author$project$Components$Produits$Common$Effet$PlacerFocus(
												A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$idDuChamp, $author$project$Components$Produits$Offre$Model$prefixeDesChamps, premier.uN))
											]);
									},
									$elm$core$List$head(
										A2(
											$elm$core$List$filter,
											function (refuse) {
												return !A2(
													$elm$core$List$member,
													refuse,
													A2($author$project$Components$Produits$Offre$Update$horsFiche, model, refus));
											},
											refus)))),
							$elm$core$List$isEmpty(
								A2($author$project$Components$Produits$Offre$Update$horsFiche, model, refus)) ? _List_Nil : $author$project$Components$Produits$Offre$Update$relire(model)));
				} else {
					var refus = issue.b;
					var erreur = issue.c;
					return _Utils_Tuple2(
						model.is ? _Utils_update(
							model,
							{
								p_: $elm$core$Maybe$Just(
									A2($author$project$Components$Produits$Offre$Update$message, refus, erreur))
							}) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) ? _Utils_update(
							model,
							{
								p$: $elm$core$Maybe$Just(
									A2($author$project$Components$Produits$Offre$Update$message, refus, erreur))
							}) : ($author$project$Components$Shared$Drawer$Model$estOuvert(model.lb) ? _Utils_update(
							model,
							{
								hE: $elm$core$Maybe$Just(
									A2($author$project$Components$Produits$Offre$Update$message, refus, erreur))
							}) : model)),
						$author$project$Components$Produits$Offre$Update$perime(erreur) ? $author$project$Components$Produits$Offre$Update$relire(model) : _List_Nil);
				}
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Catalogue$API$WriteAPIModel$ModifierLesAttributsDUneReference = F2(
	function (a, b) {
		return {$: 38, a: a, b: b};
	});
var $author$project$Components$Produits$Offre$Model$commandeDeSaisie = F2(
	function (model, fiche) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierLesAttributsDUneReference, fiche.nQ),
			A2(
				$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$modifications,
				$author$project$Components$Produits$Offre$Model$champs(fiche),
				model.hP));
		if ((!_v0.a.$) && _v0.b.b) {
			var lien = _v0.a.a;
			var _v1 = _v0.b;
			var premiere = _v1.a;
			var suite = _v1.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					A2(
						$author$project$Catalogue$API$WriteAPIModel$ModifierLesAttributsDUneReference,
						fiche.Aq,
						A2($elm$core$List$cons, premiere, suite)),
					lien));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$Offre$Model$saisissable = function (fiche) {
	return !_Utils_eq(
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierLesAttributsDUneReference, fiche.nQ),
		$elm$core$Maybe$Nothing);
};
var $author$project$Components$Produits$Offre$Update$enregistrer = function (model) {
	var _v0 = model.zo;
	if (!_v0.$) {
		var fiche = _v0.a;
		if (!$author$project$Components$Produits$Offre$Model$saisissable(fiche)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v1 = A2(
				$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$fautes,
				$author$project$Components$Produits$Offre$Model$champs(fiche),
				model.hP);
			if (_v1.b) {
				var fautif = _v1.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hP: $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$tenter(model.hP)
						}),
					_List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$PlacerFocus(
							A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$idDuChamp, $author$project$Components$Produits$Offre$Model$prefixeDesChamps, fautif))
						]));
			} else {
				var _v2 = A2(
					$elm$core$Maybe$andThen,
					function (_v3) {
						var commande = _v3.a;
						var lien = _v3.b;
						return A3(
							$author$project$Components$Produits$Common$Envoi$partir,
							$elm$core$Maybe$Just(lien),
							commande,
							model.l2);
					},
					A2($author$project$Components$Produits$Offre$Model$commandeDeSaisie, model, fiche));
				if (!_v2.$) {
					var _v4 = _v2.a;
					var envoi = _v4.a;
					var effets = _v4.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l2: envoi,
								hE: $elm$core$Maybe$Nothing,
								hP: A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$refuser, _List_Nil, model.hP)
							}),
						effets);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			}
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$Offre$Model$idDeLArret = 'offre-arreter';
var $author$project$Components$Produits$Offre$Model$idDeLEtat = 'offre-changer-l-etat';
var $author$project$Components$Produits$Offre$Model$idDeLaModification = 'offre-modifier-la-fiche';
var $author$project$Components$Produits$Offre$Model$idsDeLArret = $author$project$Components$Shared$Confirmation$Clavier$ids('arret-de-l-offre');
var $author$project$API$NavLinksDictionary$comptageDesRolesParOffre = 'comptage-des-roles-par-offre';
var $author$project$Catalogue$API$QueryAPIModel$lienDuComptageDesRoles = $author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$comptageDesRolesParOffre);
var $author$project$Components$Produits$Offre$Model$retablie = F2(
	function (fiche, model) {
		var lue = A2(
			$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$depuis,
			{
				dw: $author$project$Components$Produits$Offre$Model$champs(fiche),
				Ba: fiche.Ba
			},
			fiche.Ki);
		return _Utils_update(
			model,
			{
				hE: $elm$core$Maybe$Nothing,
				hP: A2($elm$core$List$member, model.hP.nn, fiche.Ba) ? _Utils_update(
					lue,
					{nn: model.hP.nn}) : lue
			});
	});
var $author$project$Components$Produits$Offre$Model$servie = F2(
	function (fiche, model) {
		var memeOffre = _Utils_eq(
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Aq;
				},
				model.zo),
			$elm$core$Maybe$Just(fiche.Aq));
		var lue = A2(
			$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$depuis,
			{
				dw: $author$project$Components$Produits$Offre$Model$champs(fiche),
				Ba: fiche.Ba
			},
			fiche.Ki);
		return _Utils_update(
			model,
			{
				zo: $elm$core$Maybe$Just(fiche),
				nf: false,
				hP: (memeOffre && A2(
					$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$enCours,
					$author$project$Components$Produits$Offre$Model$champs(fiche),
					model.hP)) ? model.hP : ((memeOffre && A2($elm$core$List$member, model.hP.nn, fiche.Ba)) ? _Utils_update(
					lue,
					{nn: model.hP.nn}) : lue)
			});
	});
var $author$project$Components$Produits$Offre$Update$versLeDrawerDeLaFiche = F2(
	function (geste, model) {
		var enCours = A2(
			$elm$core$Maybe$map,
			function (fiche) {
				return A2(
					$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$enCours,
					$author$project$Components$Produits$Offre$Model$champs(fiche),
					model.hP);
			},
			model.zo);
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{
				Il: _Utils_eq(
					enCours,
					$elm$core$Maybe$Just(true))
			},
			geste,
			model.lb);
		var drawer = _v0.a;
		var effets = _v0.b;
		var apres = _Utils_update(
			model,
			{lb: drawer});
		return _Utils_Tuple2(
			function () {
				var _v1 = _Utils_Tuple2(
					$author$project$Components$Shared$Drawer$Model$estOuvert(drawer),
					model.zo);
				if ((!_v1.a) && (!_v1.b.$)) {
					var fiche = _v1.b.a;
					return A2($author$project$Components$Produits$Offre$Model$retablie, fiche, apres);
				} else {
					return apres;
				}
			}(),
			A2(
				$elm$core$List$map,
				function (_v2) {
					var cible = _v2;
					return $author$project$Components$Produits$Common$Effet$PlacerFocus(cible);
				},
				effets));
	});
var $author$project$API$NavLinksDictionary$prixDUneReference = 'prix-d-une-reference';
var $author$project$Components$Produits$Liens$versLesPrix = F2(
	function (id, gabarits) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$API$NavLinksDictionary$variableUid,
						$author$project$Catalogue$Identifiants$referenceIdToString(id))
					])),
			A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$prixDUneReference, gabarits));
	});
var $author$project$API$NavLinksDictionary$offreDeService = 'offre-de-service';
var $author$project$Components$Produits$Liens$versOffre = F2(
	function (id, gabarits) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$API$NavLinksDictionary$variableUid,
						$author$project$Catalogue$Identifiants$referenceIdToString(id))
					])),
			A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$offreDeService, gabarits));
	});
var $author$project$Components$Produits$Offre$Update$update = F2(
	function (msg, model) {
		var initial = $author$project$Components$Produits$Offre$Model$init;
		switch (msg.$) {
			case 0:
				var id = msg.a;
				var gabarits = msg.b;
				var _v1 = A2($author$project$Components$Produits$Liens$versOffre, id, gabarits);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							initial,
							{
								np: $elm$core$Maybe$Just(lecture)
							}),
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Components$Produits$Common$Effet$DemanderProcessUid,
									$author$project$Components$Produits$Common$Effet$Lire(lecture)
								]),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$LireLesPrix, $elm$core$List$singleton),
									A2($author$project$Components$Produits$Liens$versLesPrix, id, gabarits)))));
				} else {
					return _Utils_Tuple2(initial, _List_Nil);
				}
			case 1:
				var liens = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$LireLeComptageDesRoles, $elm$core$List$singleton),
							$author$project$Catalogue$API$QueryAPIModel$lienDuComptageDesRoles(liens))));
			case 2:
				var reponse = msg.a;
				var _v2 = A2(
					$author$project$API$Reponse$lire,
					$elm$json$Json$Decode$list($author$project$Catalogue$API$QueryAPIModel$rolesSurUneOffreDecoder),
					reponse);
				if (!_v2.$) {
					var comptage = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								eX: $elm$core$Maybe$Just(comptage)
							}),
						_List_Nil);
				} else {
					var refus = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{eX: $elm$core$Maybe$Nothing}),
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 3:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$Components$Produits$Common$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 4:
				var reponse = msg.a;
				var _v3 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Offre$API$QueryAPIModel$ficheDecoder, reponse);
				if (!_v3.$) {
					var fiche = _v3.a;
					return _Utils_Tuple2(
						A2($author$project$Components$Produits$Offre$Model$servie, fiche, model),
						_List_Nil);
				} else {
					var refus = _v3.a;
					return (refus.ri === 401) ? _Utils_Tuple2(
						model,
						_List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter])) : _Utils_Tuple2(
						_Utils_update(
							model,
							{nf: refus.ri === 404}),
						_List_Nil);
				}
			case 5:
				var reponse = msg.a;
				var _v4 = A2($author$project$API$Reponse$lire, $author$project$Catalogue$API$PrixAPIModel$prixDUneReferenceDecoder, reponse);
				if (!_v4.$) {
					var prix = _v4.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								py: $elm$core$Maybe$Just(prix)
							}),
						_List_Nil);
				} else {
					var refus = _v4.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{py: $elm$core$Maybe$Nothing}),
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 6:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Produits$Offre$Update$relire(model));
			case 7:
				var geste = msg.a;
				if (geste.$ === 1) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								hP: A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$saisir, geste, model.hP)
							}),
						_List_Nil);
				} else {
					return $author$project$Components$Shared$Drawer$Model$estOuvert(model.lb) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{
								hP: A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$saisir, geste, model.hP)
							}),
						_List_Nil) : _Utils_Tuple2(model, _List_Nil);
				}
			case 8:
				var _v6 = model.zo;
				if (!_v6.$) {
					var fiche = _v6.a;
					return ($author$project$Components$Produits$Offre$Model$saisissable(fiche) && (!$author$project$Components$Produits$Common$Envoi$enCours(model.l2))) ? A2(
						$author$project$Components$Produits$Offre$Update$versLeDrawerDeLaFiche,
						$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Produits$Offre$Model$idDeLaModification),
						A2($author$project$Components$Produits$Offre$Model$retablie, fiche, model)) : _Utils_Tuple2(model, _List_Nil);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 9:
				var geste = msg.a;
				return A2($author$project$Components$Produits$Common$Envoi$retientLeDrawer, model.l2, geste) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Produits$Offre$Update$versLeDrawerDeLaFiche, geste, model);
			case 10:
				return $author$project$Components$Shared$Drawer$Model$estOuvert(model.lb) ? $author$project$Components$Produits$Offre$Update$enregistrer(model) : _Utils_Tuple2(model, _List_Nil);
			case 11:
				var geste = msg.a;
				return A2($author$project$Components$Produits$Common$Envoi$retientLeDrawer, model.l2, geste) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Produits$Offre$Update$versLeDrawer, geste, model);
			case 12:
				var _v7 = A2(
					$elm$core$Maybe$andThen,
					function (fiche) {
						return A2(
							$elm$core$Maybe$map,
							function (_v8) {
								return fiche;
							},
							$author$project$Components$Produits$Common$Etat$lien(fiche));
					},
					model.zo);
				if (!_v7.$) {
					var fiche = _v7.a;
					return A2(
						$author$project$Components$Produits$Offre$Update$versLeDrawer,
						$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Produits$Offre$Model$idDeLEtat),
						_Utils_update(
							model,
							{
								mi: $elm$core$Maybe$Just(fiche.gt),
								p$: $elm$core$Maybe$Nothing
							}));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 13:
				var code = msg.a;
				var _v9 = A2(
					$elm$core$Maybe$andThen,
					function (fiche) {
						return A2($author$project$Components$Produits$Common$Etat$choisir, fiche, code);
					},
					model.zo);
				if (!_v9.$) {
					var connu = _v9.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								mi: $elm$core$Maybe$Just(connu)
							}),
						_List_Nil);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 14:
				return $author$project$Components$Produits$Offre$Update$changerLEtat(model);
			case 15:
				return _Utils_eq(
					A2($elm$core$Maybe$andThen, $author$project$Components$Produits$Offre$Model$commandeDArret, model.zo),
					$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : _Utils_Tuple2(
					_Utils_update(
						model,
						{is: true, p_: $elm$core$Maybe$Nothing}),
					_List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$PlacerFocus($author$project$Components$Produits$Offre$Model$idsDeLArret.to)
						]));
			case 16:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{is: false, p_: $elm$core$Maybe$Nothing}),
					_List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$PlacerFocus($author$project$Components$Produits$Offre$Model$idDeLArret)
						]));
			case 17:
				var _v10 = _Utils_Tuple2(
					model.is,
					A2(
						$elm$core$Maybe$andThen,
						function (_v11) {
							var commande = _v11.a;
							var lien = _v11.b;
							return A3(
								$author$project$Components$Produits$Common$Envoi$partir,
								$elm$core$Maybe$Just(lien),
								commande,
								model.l2);
						},
						A2($elm$core$Maybe$andThen, $author$project$Components$Produits$Offre$Model$commandeDArret, model.zo)));
				if (_v10.a && (!_v10.b.$)) {
					var _v12 = _v10.b.a;
					var envoi = _v12.a;
					var effets = _v12.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{l2: envoi, p_: $elm$core$Maybe$Nothing}),
						effets);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 18:
				var vers = msg.a;
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$PlacerFocus(vers)
						]));
			default:
				var reponse = msg.a;
				var _v13 = A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, model.l2);
				if (!_v13.$) {
					var _v14 = _v13.a;
					var envoi = _v14.a;
					var issue = _v14.b;
					var effets = _v14.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Produits$Offre$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Main$Update$versLOffre = F3(
	function (i18n, msg, model) {
		var _v0 = A2(
			$author$project$Components$Produits$Offre$Update$update,
			msg,
			A2(
				$author$project$Referentiel$Normes$poser,
				model.hd,
				$author$project$Components$Produits$Offre$Model$ouvrir(model.D1)));
		var offre = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLesElements, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			A3($author$project$Main$Update$depuisLesElements, i18n, 11, 16),
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							A2(
								$author$project$Components$Produits$Offre$Update$popMessages,
								$author$project$Components$Produits$Offre$Model$ouvrir(model.D1),
								msg),
							gardes),
						D1: $author$project$Components$Produits$Offre$Model$envelopper(offre)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$LireLUsageDeLOffre = F2(
	function (a, b) {
		return {$: 100, a: a, b: b};
	});
var $author$project$Main$Update$depuisLUsageDeLOffre = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		if (!effet.$) {
			var lecture = effet.a;
			var lien = effet.b;
			return _Utils_Tuple2(
				model,
				_Utils_ap(
					effets,
					A3(
						$author$project$Main$Update$versLApi,
						model,
						lien,
						$author$project$Main$Update$LireLUsageDeLOffre(lecture))));
		} else {
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Basics$append(effets),
				A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Parametrage$PipeOffreUsage$Update$dit = function (resultat) {
	if (resultat.$ === 1) {
		var erreur = resultat.a;
		return ((erreur.ri === 401) || (erreur.ri === 404)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Components$Shared$Messages$Model$duRefus(erreur));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$PipeOffreUsage$API$QueryAPIModel$Usage = F8(
	function (etape, objet, nom, ceQuiEstUtilise, montant, source, payeur, payeurParRelation) {
		return {uL: ceQuiEstUtilise, me: etape, oi: montant, Dj: nom, DZ: objet, E7: payeur, E8: payeurParRelation, IR: source};
	});
var $author$project$Components$Parametrage$PipeOffreUsage$API$QueryAPIModel$usageDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['payeur', 'parRelation']),
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			['payeur', 'libelle']),
		$elm$json$Json$Decode$string,
		'',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'source',
			$elm$json$Json$Decode$string,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
				_List_fromArray(
					['ceQuiEstUtilise', 'montant']),
				$elm$json$Json$Decode$string,
				'',
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['ceQuiEstUtilise', 'libelle']),
					$elm$json$Json$Decode$string,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
						_List_fromArray(
							['ou', 'nom']),
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
							_List_fromArray(
								['ou', 'objet']),
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
								_List_fromArray(
									['ou', 'etape']),
								$elm$json$Json$Decode$string,
								'',
								$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeOffreUsage$API$QueryAPIModel$Usage)))))))));
var $author$project$Components$Parametrage$PipeOffreUsage$API$QueryAPIModel$usagesDecoder = A2(
	$elm$json$Json$Decode$field,
	'usages',
	$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeOffreUsage$API$QueryAPIModel$usageDecoder));
var $author$project$Components$Parametrage$PipeOffreUsage$Update$popMessages = function (msg) {
	if (msg.$ === 1) {
		var lecture = msg.a;
		var reponse = msg.b;
		switch (lecture) {
			case 0:
				return $author$project$Components$Parametrage$PipeOffreUsage$Update$dit(
					A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Common$API$QueryAPIModel$annuaireDecoder, reponse));
			case 1:
				return $author$project$Components$Parametrage$PipeOffreUsage$Update$dit(
					A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Common$API$QueryAPIModel$racineDuPipeDecoder, reponse));
			case 2:
				return $author$project$Components$Parametrage$PipeOffreUsage$Update$dit(
					A2(
						$author$project$API$Reponse$lire,
						$elm$json$Json$Decode$succeed(0),
						reponse));
			default:
				return $author$project$Components$Parametrage$PipeOffreUsage$Update$dit(
					A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$PipeOffreUsage$API$QueryAPIModel$usagesDecoder, reponse));
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$PipeOffreUsage$Update$Annuaire = 0;
var $author$project$Components$Parametrage$PipeOffreUsage$Update$Lire = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeOffreUsage$Update$Edition = 2;
var $author$project$Components$Parametrage$PipeOffreUsage$Update$Page = 3;
var $author$project$Components$Parametrage$PipeOffreUsage$Update$Racine = 1;
var $author$project$Components$Parametrage$PipeOffreUsage$Update$Reconnecter = {$: 1};
var $author$project$Components$Parametrage$PipeOffreUsage$Update$sous = F4(
	function (decodeur, reponse, model, suite) {
		var _v0 = A2($author$project$API$Reponse$lire, decodeur, reponse);
		if (!_v0.$) {
			var lue = _v0.a;
			return suite(lue);
		} else {
			var refus = _v0.a;
			return (refus.ri === 401) ? _Utils_Tuple2(
				model,
				_List_fromArray(
					[$author$project$Components$Parametrage$PipeOffreUsage$Update$Reconnecter])) : _Utils_Tuple2(
				_Utils_update(
					model,
					{nf: model.nf || (refus.ri === 404)}),
				_List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$usagesDeLOffre = 'usages';
var $author$project$Components$Parametrage$PipeOffreUsage$Update$lu = F3(
	function (lecture, reponse, model) {
		switch (lecture) {
			case 0:
				return A4(
					$author$project$Components$Parametrage$PipeOffreUsage$Update$sous,
					$author$project$Components$Parametrage$Common$API$QueryAPIModel$lienDuPipeDecoder(model.vx),
					reponse,
					model,
					function (visee) {
						if (!visee.$) {
							var racine = visee.a;
							return _Utils_Tuple2(
								model,
								_List_fromArray(
									[
										A2($author$project$Components$Parametrage$PipeOffreUsage$Update$Lire, 1, racine)
									]));
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{nf: true}),
								_List_Nil);
						}
					});
			case 1:
				return A4(
					$author$project$Components$Parametrage$PipeOffreUsage$Update$sous,
					$author$project$Components$Parametrage$Common$API$QueryAPIModel$racineDuPipeDecoder,
					reponse,
					model,
					function (edition) {
						if (!edition.$) {
							var lien = edition.a;
							return _Utils_Tuple2(
								model,
								_List_fromArray(
									[
										A2($author$project$Components$Parametrage$PipeOffreUsage$Update$Lire, 2, lien)
									]));
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{nf: true}),
								_List_Nil);
						}
					});
			case 2:
				return A4(
					$author$project$Components$Parametrage$PipeOffreUsage$Update$sous,
					A3(
						$elm$json$Json$Decode$map2,
						$elm$core$Tuple$pair,
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['pipe', 'libelles']),
							$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)),
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder),
					reponse,
					model,
					function (_v3) {
						var libelles = _v3.a;
						var liens = _v3.b;
						var suivant = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$usagesDeLOffre, liens);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									nf: _Utils_eq(suivant, $elm$core$Maybe$Nothing),
									Bl: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(libelles)
								}),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									$elm$core$List$singleton,
									A2(
										$elm$core$Maybe$map,
										$author$project$Components$Parametrage$PipeOffreUsage$Update$Lire(3),
										suivant))));
					});
			default:
				return A4(
					$author$project$Components$Parametrage$PipeOffreUsage$Update$sous,
					$author$project$Components$Parametrage$PipeOffreUsage$API$QueryAPIModel$usagesDecoder,
					reponse,
					model,
					function (page) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									EE: $elm$core$Maybe$Just(page)
								}),
							_List_Nil);
					});
		}
	});
var $author$project$Components$Parametrage$PipeOffreUsage$Update$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var code = msg.a;
			var liens = msg.b;
			var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$pipes, liens);
			if (!_v1.$) {
				var lecture = _v1.a;
				return _Utils_Tuple2(
					$author$project$Components$Parametrage$PipeOffreUsage$Model$init(code),
					_List_fromArray(
						[
							A2($author$project$Components$Parametrage$PipeOffreUsage$Update$Lire, 0, lecture)
						]));
			} else {
				return _Utils_Tuple2(
					$author$project$Components$Parametrage$PipeOffreUsage$Model$init(code),
					_List_Nil);
			}
		} else {
			var lecture = msg.a;
			var reponse = msg.b;
			return A3($author$project$Components$Parametrage$PipeOffreUsage$Update$lu, lecture, reponse, model);
		}
	});
var $author$project$Main$Update$versLUsageDeLOffre = F3(
	function (i18n, msg, model) {
		var _v0 = A2($author$project$Components$Parametrage$PipeOffreUsage$Update$update, msg, model.FG);
		var usages = _v0.a;
		var effets = _v0.b;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLUsageDeLOffre,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Parametrage$PipeOffreUsage$Update$popMessages(msg),
							model.Ct),
						FG: usages
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$ApercevoirLaModification = function (a) {
	return {$: 221, a: a};
};
var $author$project$Main$Update$AttendreAvantDeRelireLaBibliotheque = function (a) {
	return {$: 222, a: a};
};
var $author$project$Main$Update$EnvoyerALaBibliotheque = function (a) {
	return {$: 220, a: a};
};
var $author$project$Main$Update$LireLaBibliotheque = F2(
	function (a, b) {
		return {$: 219, a: a, b: b};
	});
var $author$project$Main$Model$PourLaBibliotheque = 42;
var $author$project$Main$Update$depuisLaBibliotheque = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[42]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 1:
				var lecture = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLaBibliotheque(lecture))));
			case 2:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerALaBibliotheque(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 3:
				var lien = effet.a;
				var champ = effet.b;
				var options = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$ApercevoirLaModification(
									{uN: champ, gM: vers.gM, nB: vers.nB, o_: options});
							})));
			case 4:
				var delaiMs = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AttendreAvantDeRelireLaBibliotheque(delaiMs)
							])));
			case 5:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$API$NavLinksDictionary$liste = 'liste';
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$annuaireDecoder = A2(
	$elm$json$Json$Decode$field,
	'listes',
	$elm$json$Json$Decode$list(
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
			A2(
				$elm$json$Json$Decode$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.h0;
					},
					$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$liste)),
				$author$project$API$Liens$deLaRessource))));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$Apercu = F4(
	function (nonConformes, auMoins, parType, conversion) {
		return {tW: auMoins, wd: conversion, oF: nonConformes, o7: parType};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$TypeApercu = F3(
	function (typeId, nom, nonConformes) {
		return {Dj: nom, oF: nonConformes, fi: typeId};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$Conversion = F8(
	function (de, vers, valeurs, arrondies, perdues, parType, exemples, bornes) {
		return {i3: arrondies, us: bornes, wC: de, y_: exemples, o7: parType, pe: perdues, Ki: valeurs, sn: vers};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ConversionBornes = F4(
	function (minAvant, maxAvant, minApres, maxApres) {
		return {Ch: maxApres, Ci: maxAvant, Cy: minApres, Cz: minAvant};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ConversionExemple = F5(
	function (nom, code, avant, apres, arrondie) {
		return {iY: apres, tO: arrondie, je: avant, vx: code, Dj: nom};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ConversionParType = F5(
	function (typeId, nom, valeurs, arrondies, perdues) {
		return {i3: arrondies, Dj: nom, pe: perdues, fi: typeId, Ki: valeurs};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$conversionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'bornes',
	A5(
		$elm$json$Json$Decode$map4,
		$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ConversionBornes,
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'minAvant', $elm$json$Json$Decode$float)),
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'maxAvant', $elm$json$Json$Decode$float)),
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'minApres', $elm$json$Json$Decode$float)),
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'maxApres', $elm$json$Json$Decode$float))),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'exemples',
		$elm$json$Json$Decode$list(
			A6(
				$elm$json$Json$Decode$map5,
				$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ConversionExemple,
				A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'avant', $elm$json$Json$Decode$float),
				A2($elm$json$Json$Decode$field, 'apres', $elm$json$Json$Decode$float),
				A2($elm$json$Json$Decode$field, 'arrondie', $elm$json$Json$Decode$bool))),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'parType',
			$elm$json$Json$Decode$list(
				A6(
					$elm$json$Json$Decode$map5,
					$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ConversionParType,
					A2($elm$json$Json$Decode$field, 'typeId', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'valeurs', $elm$json$Json$Decode$int),
					A2($elm$json$Json$Decode$field, 'arrondies', $elm$json$Json$Decode$int),
					A2($elm$json$Json$Decode$field, 'perdues', $elm$json$Json$Decode$int))),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'perdues',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'arrondies',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'valeurs',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'vers',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'de',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$Conversion)))))))));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$apercuDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$Apercu,
	A2($elm$json$Json$Decode$field, 'nonConformes', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'auMoins', $elm$json$Json$Decode$bool),
	A2(
		$elm$json$Json$Decode$field,
		'parType',
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$TypeApercu,
				A2($elm$json$Json$Decode$field, 'typeId', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'nonConformes', $elm$json$Json$Decode$int)))),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'conversion', $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$conversionDecoder)));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ApercuDuLot = F2(
	function (references, debrayees) {
		return {wF: debrayees, hD: references};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$apercuDuLotDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ApercuDuLot,
	A2($elm$json$Json$Decode$field, 'references', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'debrayees', $elm$json$Json$Decode$int));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$Bibliotheque = F3(
	function (champs, nonRepris, liens) {
		return {dw: champs, nQ: liens, DN: nonRepris};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$Champ = F6(
	function (cle, libelle, typeAffiche, utilisePar, reprise, liens) {
		return {dy: cle, Bl: libelle, nQ: liens, qx: reprise, rU: typeAffiche, sf: utilisePar};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$NonReconnue = F2(
	function (valeur, fiches) {
		return {zu: fiches, fm: valeur};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ValeurFusionnee = F3(
	function (libelle, codes, fiches) {
		return {vC: codes, zu: fiches, Bl: libelle};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ListeExistante = F5(
	function (id, nom, portee, porteeApres, valeurs) {
		return {Aq: id, Dj: nom, F$: portee, F0: porteeApres, Ki: valeurs};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ValeurExistante = F2(
	function (libelle, fiches) {
		return {zu: fiches, Bl: libelle};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$listeExistanteDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$map,
			function (id) {
				return _Utils_Tuple2(id, $elm$core$Maybe$Nothing);
			},
			$elm$json$Json$Decode$string),
			A2(
			$elm$json$Json$Decode$map,
			function (l) {
				return _Utils_Tuple2(
					l.Aq,
					$elm$core$Maybe$Just(l));
			},
			A6(
				$elm$json$Json$Decode$map5,
				$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ListeExistante,
				A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'portee', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'porteeApres', $elm$json$Json$Decode$string),
				A2(
					$elm$json$Json$Decode$field,
					'valeurs',
					$elm$json$Json$Decode$list(
						A3(
							$elm$json$Json$Decode$map2,
							$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ValeurExistante,
							A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string),
							A2($elm$json$Json$Decode$field, 'fiches', $elm$json$Json$Decode$int))))))
		]));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$TypeTouche = F5(
	function (typeId, nom, avant, apres, fiches) {
		return {iY: apres, je: avant, zu: fiches, Dj: nom, fi: typeId};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$identifiantDuType = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$field, 'typeDeProduit', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'typeDePartiePrenante', $elm$json$Json$Decode$string)
		]));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$typeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'fiches',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'apres',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'avant',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'nom',
				$elm$json$Json$Decode$string,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$identifiantDuType,
					$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$TypeTouche))))));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$propositionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'nonReconnues',
	$elm$json$Json$Decode$list(
		A3(
			$elm$json$Json$Decode$map2,
			$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$NonReconnue,
			A2($elm$json$Json$Decode$field, 'valeur', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'fiches', $elm$json$Json$Decode$int))),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'types',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$typeDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'valeurs',
			$elm$json$Json$Decode$list(
				A4(
					$elm$json$Json$Decode$map3,
					$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ValeurFusionnee,
					A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string),
					A2(
						$elm$json$Json$Decode$field,
						'codes',
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
					A2($elm$json$Json$Decode$field, 'fiches', $elm$json$Json$Decode$int))),
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'listeExistante',
				$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$listeExistanteDecoder),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'nomPropose',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed(
						F5(
							function (nom, existante, valeurs, types, nonReconnues) {
								return {
									kN: A2($elm$core$Maybe$andThen, $elm$core$Tuple$second, existante),
									nZ: A2($elm$core$Maybe$map, $elm$core$Tuple$first, existante),
									oB: nom,
									oH: nonReconnues,
									ib: types,
									Ki: valeurs
								};
							})))))));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$champDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$API$Liens$deLaRessource,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'reprise',
		$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$propositionDecoder),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'utilisePar',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'typeAffiche',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'libelle',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'cle',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$Champ)))))));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$NonRepris = F4(
	function (cle, typeId, nom, raison) {
		return {dy: cle, Dj: nom, pH: raison, fi: typeId};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$nonReprisDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'raison',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'nom',
		$elm$json$Json$Decode$string,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$identifiantDuType,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'cle',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$NonRepris)))));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$bibliothequeDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$API$Liens$deLaRessource,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'nonRepris',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$nonReprisDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'champs',
			$elm$json$Json$Decode$list($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$champDecoder),
			$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$Bibliotheque))));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$Fiche = function (id) {
	return function (cle) {
		return function (nom) {
			return function (aide) {
				return function (genre) {
					return function (typeDeChamp) {
						return function (portee) {
							return function (filtrable) {
								return function (recherchable) {
									return function (options) {
										return function (traductions) {
											return function (langues) {
												return function (saisies) {
													return function (valeursAuxEtages) {
														return function (unites) {
															return function (langueParDefaut) {
																return function (ressourcesRattachables) {
																	return function (typesConcernes) {
																		return function (rattachements) {
																			return function (personnelSur) {
																				return function (origine) {
																					return function (calcul) {
																						return function (liens) {
																							return {bp: aide, uB: calcul, dy: cle, zG: filtrable, M: genre, Aq: id, A9: langueParDefaut, Ba: langues, nQ: liens, Dj: nom, o_: options, o4: origine, pj: personnelSur, F$: portee, GY: rattachements, G1: recherchable, HQ: ressourcesRattachables, c7: saisies, JL: traductions, JR: typeDeChamp, JY: typesConcernes, sb: unites, Kj: valeursAuxEtages};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$Unite = F3(
	function (code, libelle, nom) {
		return {vx: code, Bl: libelle, Dj: nom};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$Calcul = F8(
	function (formule, resultat, recalcul, valeur, lit, liste, apercu, mesure) {
		return {tq: apercu, zU: formule, nW: liste, BY: lit, Cu: mesure, G$: recalcul, HW: resultat, fm: valeur};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ApercuDuCalcul = F2(
	function (references, exemple) {
		return {yY: exemple, hD: references};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ExempleDuCalcul = F3(
	function (code, valeur, sources) {
		return {vx: code, IT: sources, fm: valeur};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$valeurDiteDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$elm$json$Json$Decode$string,
			A2($elm$json$Json$Decode$map, $elm$core$String$fromFloat, $elm$json$Json$Decode$float)
		]));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$exempleDuCalculDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ExempleDuCalcul,
	A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'libelle',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)),
				A2(
				$elm$json$Json$Decode$field,
				'valeur',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$valeurDiteDecoder)),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			])),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'sources',
				$elm$json$Json$Decode$keyValuePairs($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$valeurDiteDecoder)),
				$elm$json$Json$Decode$succeed(_List_Nil)
			])));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$apercuDuCalculDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ApercuDuCalcul,
	A2($elm$json$Json$Decode$field, 'references', $elm$json$Json$Decode$int),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'exemple',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$exempleDuCalculDecoder)),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			])));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ListeDuResultat = F2(
	function (nom, valeurs) {
		return {Dj: nom, Ki: valeurs};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$listeDuResultatDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ListeDuResultat,
	A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'valeurs',
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string)))));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$calculDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$andThen,
			function (formule) {
				return A8(
					$elm$json$Json$Decode$map7,
					F7(
						function (resultat, recalcul, valeur, lit, liste, apercu, mesure) {
							return $elm$core$Maybe$Just(
								A8($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$Calcul, formule, resultat, recalcul, valeur, lit, liste, apercu, mesure));
						}),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['options', 'resultat']),
						$elm$json$Json$Decode$string),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['options', 'recalcul']),
						$elm$json$Json$Decode$string),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['options', 'valeur']),
						$elm$json$Json$Decode$string),
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$json$Json$Decode$field,
								'lit',
								$elm$json$Json$Decode$list(
									A3(
										$elm$json$Json$Decode$map2,
										$elm$core$Tuple$pair,
										A2($elm$json$Json$Decode$field, 'cle', $elm$json$Json$Decode$string),
										A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string)))),
								$elm$json$Json$Decode$succeed(_List_Nil)
							])),
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$json$Json$Decode$field,
								'listeDuResultat',
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$listeDuResultatDecoder)),
								$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
							])),
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$json$Json$Decode$field,
								'apercuDuCalcul',
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$apercuDuCalculDecoder)),
								$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
							])),
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$json$Json$Decode$andThen,
								function (unite) {
									return A2(
										$elm$json$Json$Decode$map,
										function (decimales) {
											return $elm$core$Maybe$Just(
												{kv: decimales, sa: unite});
										},
										$elm$json$Json$Decode$oneOf(
											_List_fromArray(
												[
													A2(
													$elm$json$Json$Decode$at,
													_List_fromArray(
														['options', 'decimales']),
													$elm$json$Json$Decode$int),
													$elm$json$Json$Decode$succeed(0)
												])));
								},
								A2(
									$elm$json$Json$Decode$at,
									_List_fromArray(
										['options', 'unite']),
									$elm$json$Json$Decode$string)),
								$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
							])));
			},
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['options', 'formule']),
				$elm$json$Json$Decode$string)),
			$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
		]));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$genreDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (code) {
		var _v0 = $author$project$Components$Shared$GenreDuNom$deCode(code);
		if (!_v0.$) {
			var genre = _v0.a;
			return $elm$json$Json$Decode$succeed(genre);
		} else {
			return $elm$json$Json$Decode$fail(code);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$Options = function (longueurMax) {
	return function (format) {
		return function (grandeur) {
			return function (unite) {
				return function (decimales) {
					return function (min) {
						return function (max) {
							return function (dateMin) {
								return function (dateMax) {
									return function (sousChamps) {
										return function (repetable) {
											return function (libelleOccurrence) {
												return function (genreOccurrence) {
													return function (plusieursChoix) {
														return function (miseEnForme) {
															return {wz: dateMax, wA: dateMin, kv: decimales, zP: format, z9: genreOccurrence, m0: grandeur, Bq: libelleOccurrence, B$: longueurMax, Cg: max, Cx: min, CE: miseEnForme, FT: plusieursChoix, HI: repetable, IX: sousChamps, sa: unite};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Shared$GenreDuNom$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (texte) {
		var _v0 = $author$project$Components$Shared$GenreDuNom$deCode(texte);
		if (!_v0.$) {
			var genre = _v0.a;
			return $elm$json$Json$Decode$succeed(genre);
		} else {
			return $elm$json$Json$Decode$fail(texte);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$SousChamp = function (cle) {
	return function (libelle) {
		return function (genre) {
			return function (liste) {
				return function (typeVise) {
					return function (obligatoire) {
						return function (masque) {
							return function (unite) {
								return function (decimales) {
									return function (min) {
										return function (max) {
											return function (uneSeuleFois) {
												return {dy: cle, kv: decimales, M: genre, Bl: libelle, nW: liste, n4: masque, Cg: max, Cx: min, he: obligatoire, r$: typeVise, J9: uneSeuleFois, sa: unite};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$genreDuSousChamp = function (code) {
	switch (code) {
		case 'nombre':
			return 1;
		case 'date':
			return 2;
		case 'montant':
			return 3;
		case 'mesure':
			return 4;
		case 'devise':
			return 5;
		case 'partie-prenante':
			return 7;
		case 'utilisateur':
			return 8;
		case 'choix-dans-une-liste':
			return 6;
		default:
			return 0;
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$sousChampDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'uneSeuleFois',
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'max',
		A2(
			$elm$json$Json$Decode$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($elm$core$String$fromFloat),
				$elm$core$Maybe$withDefault('')),
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float)),
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'min',
			A2(
				$elm$json$Json$Decode$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$map($elm$core$String$fromFloat),
					$elm$core$Maybe$withDefault('')),
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float)),
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'decimales',
				A2(
					$elm$json$Json$Decode$map,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map($elm$core$String$fromInt),
						$elm$core$Maybe$withDefault('0')),
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int)),
				'0',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'unite',
					A2(
						$elm$json$Json$Decode$map,
						$elm$core$Maybe$withDefault('mm'),
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
					'mm',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'masque',
						$elm$json$Json$Decode$bool,
						false,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'obligatoire',
							$elm$json$Json$Decode$bool,
							false,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'typeVise',
								A2(
									$elm$json$Json$Decode$map,
									$elm$core$Maybe$withDefault(''),
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
								'',
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'liste',
									A2(
										$elm$json$Json$Decode$map,
										$elm$core$Maybe$withDefault(''),
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
									'',
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'typeDeChamp',
										A2($elm$json$Json$Decode$map, $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$genreDuSousChamp, $elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'libelle',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'cle',
												A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
												$elm$json$Json$Decode$succeed($author$project$Components$Shared$EditeurDeSchema$SousChamps$SousChamp)))))))))))));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$optionsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'miseEnForme',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'plusieursChoix',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'genreOccurrence',
			$elm$json$Json$Decode$nullable($author$project$Components$Shared$GenreDuNom$decoder),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'libelleOccurrence',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'repetable',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'sousChamps',
						$elm$json$Json$Decode$nullable(
							$elm$json$Json$Decode$list($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$sousChampDecoder)),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'dateMax',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'dateMin',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'max',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'min',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'decimales',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
											$elm$core$Maybe$Nothing,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'unite',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
												$elm$core$Maybe$Nothing,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'grandeur',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
													$elm$core$Maybe$Nothing,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'format',
														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
														$elm$core$Maybe$Nothing,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'longueurMax',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
															$elm$core$Maybe$Nothing,
															$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$Options))))))))))))))));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$Origine = F3(
	function (genre, id, nom) {
		return {M: genre, Aq: id, Dj: nom};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$origineDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$Origine,
	A2($elm$json$Json$Decode$field, 'genre', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$Heritiers = F2(
	function (gammes, references) {
		return {gG: gammes, hD: references};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$RattachementDuChamp = F8(
	function (ressource, exigence, niveauDeLecture, masque, donneePersonnelle, genreDEtage, parent, heritiers) {
		return {xD: donneePersonnelle, mo: exigence, z8: genreDEtage, Ag: heritiers, n4: masque, g4: niveauDeLecture, ey: parent, HN: ressource};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$TypeConcerne = F3(
	function (id, nom, domaine) {
		return {cC: domaine, Aq: id, Dj: nom};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$typeConcerneDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$TypeConcerne,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'domaine', $elm$json$Json$Decode$string));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$rattachementDuChampDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'heritiers',
	$elm$json$Json$Decode$maybe(
		A3(
			$elm$json$Json$Decode$map2,
			$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$Heritiers,
			A2($elm$json$Json$Decode$field, 'gammes', $elm$json$Json$Decode$int),
			A2($elm$json$Json$Decode$field, 'references', $elm$json$Json$Decode$int))),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'parent',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'genreDEtage',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'donneePersonnelle',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'masque',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'niveauDeLecture',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'exigence',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'ressource',
								$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$typeConcerneDecoder,
								$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$RattachementDuChamp)))))))));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$RessourceRattachable = F4(
	function (id, nom, domaine, lien) {
		return {cC: domaine, Aq: id, nB: lien, Dj: nom};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ressourceRattachableDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'lien',
	A4(
		$elm$json$Json$Decode$map3,
		$author$project$API$Liens$Lien,
		A2($elm$json$Json$Decode$field, 'rel', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'href', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'verbe', $elm$json$Json$Decode$string)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'domaine',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'nom',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$RessourceRattachable)))));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$sansOptions = $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$Options($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing);
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$Traduction = F2(
	function (libelle, aide) {
		return {bp: aide, Bl: libelle};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$traductionDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'aide',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'libelle',
		$elm$json$Json$Decode$string,
		'',
		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$Traduction)));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ficheDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$API$Liens$deLaRessource,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$calculDecoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'origine',
			$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$origineDecoder),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'personnelSur',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'rattachements',
					$elm$json$Json$Decode$list($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$rattachementDuChampDecoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'typesConcernes',
						$elm$json$Json$Decode$list($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$typeConcerneDecoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'ressourcesRattachables',
							$elm$json$Json$Decode$list($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ressourceRattachableDecoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'langueParDefaut',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'unites',
									$elm$json$Json$Decode$list(
										A4(
											$elm$json$Json$Decode$map3,
											$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$Unite,
											A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
											A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string),
											A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string))),
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'valeursAuxEtages',
										$elm$json$Json$Decode$int,
										0,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'saisies',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'langues',
												$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'traductions',
													$elm$json$Json$Decode$dict($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$traductionDecoder),
													$elm$core$Dict$empty,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'options',
														$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$optionsDecoder,
														$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$sansOptions,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'recherchable',
															$elm$json$Json$Decode$bool,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'filtrable',
																$elm$json$Json$Decode$bool,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'portee',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'typeDeChamp',
																		$elm$json$Json$Decode$string,
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'genre',
																			$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$genreDecoder),
																			$elm$core$Maybe$Nothing,
																			A4(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																				'aide',
																				$elm$json$Json$Decode$string,
																				'',
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'nom',
																					$elm$json$Json$Decode$string,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'cle',
																						$elm$json$Json$Decode$string,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'id',
																							$elm$json$Json$Decode$string,
																							$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$Fiche))))))))))))))))))))))));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$FichesDUnType = F3(
	function (id, nom, fiches) {
		return {zu: fiches, Aq: id, Dj: nom};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$FichesDUneValeur = F3(
	function (valeur, fiches, parType) {
		return {zu: fiches, o7: parType, fm: valeur};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$FichesParValeur = F2(
	function (champ, valeurs) {
		return {uN: champ, Ki: valeurs};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$fichesParValeurDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$FichesParValeur,
	A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'valeurs',
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				$author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$FichesDUneValeur,
				A2($elm$json$Json$Decode$field, 'valeur', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'fiches', $elm$json$Json$Decode$int),
				A2(
					$elm$json$Json$Decode$field,
					'parType',
					$elm$json$Json$Decode$list(
						A4(
							$elm$json$Json$Decode$map3,
							$author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$FichesDUnType,
							A2($elm$json$Json$Decode$field, 'typeDeProduit', $elm$json$Json$Decode$string),
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['nom', 'fr']),
								$elm$json$Json$Decode$string),
							A2($elm$json$Json$Decode$field, 'fiches', $elm$json$Json$Decode$int))))))));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$Informations = F4(
	function (porteurs, types, liens, fichesParValeur) {
		return {zA: fichesParValeur, nQ: liens, F3: porteurs, ib: types};
	});
var $author$project$API$NavLinksDictionary$fichesParValeur = 'fiches-par-valeur';
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$Porteur = F4(
	function (classification, noeud, restrictions, liens) {
		return {vj: classification, nQ: liens, ou: noeud, qF: restrictions};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$porteurDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (_v0) {
		var classification = _v0.a;
		var noeud = _v0.b;
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$map,
						function ($) {
							return $.h0;
						},
						$author$project$API$Liens$deLaRessource),
						$elm$json$Json$Decode$succeed(_List_Nil)
					])),
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'restrictions',
				$elm$json$Json$Decode$dict(
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
				$elm$core$Dict$empty,
				$elm$json$Json$Decode$succeed(
					A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$Porteur, classification, noeud))));
	},
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['portee', 'Noeud']),
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			A2($elm$json$Json$Decode$field, 'classification', $author$project$Catalogue$Identifiants$classificationIdDecoder),
			A2($elm$json$Json$Decode$field, 'valeur', $elm$json$Json$Decode$string))));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$TypeRestreint = F4(
	function (id, nom, restrictions, liens) {
		return {Aq: id, nQ: liens, Dj: nom, qF: restrictions};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$typeDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				function ($) {
					return $.h0;
				},
				A2($elm$json$Json$Decode$field, '_links', $author$project$API$Liens$decoder)),
				$elm$json$Json$Decode$succeed(_List_Nil)
			])),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'restrictions',
		$elm$json$Json$Decode$dict(
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
		$elm$core$Dict$empty,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'nom',
			A2($elm$json$Json$Decode$field, 'fr', $elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'typeDeProduit',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$TypeRestreint)))));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$informationsDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$Informations,
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$filterMap($elm$core$Basics$identity),
		A2(
			$elm$json$Json$Decode$field,
			'porteurs',
			$elm$json$Json$Decode$list(
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$porteurDecoder),
							$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
						]))))),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'types',
				$elm$json$Json$Decode$list($author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$typeDecoder)),
				$elm$json$Json$Decode$succeed(_List_Nil)
			])),
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.gF;
			},
			$author$project$API$Liens$trouverGabarit($author$project$API$NavLinksDictionary$fichesParValeur)),
		$author$project$API$Liens$deLaRessource));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$listeDecoder = $author$project$Components$Shared$Bibliotheque$Restriction$listeDecoder;
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ChampAReprendreDesParties = F4(
	function (cle, libelle, types, valeursSaisies) {
		return {dy: cle, Bl: libelle, ib: types, Kp: valeursSaisies};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$Page = F5(
	function (champs, partiesAReprendre, typesDeChamp, unites, liens) {
		return {dw: champs, nQ: liens, E1: partiesAReprendre, J_: typesDeChamp, sb: unites};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ChampReuni = function (id) {
	return function (cle) {
		return function (libelle) {
			return function (typeAffiche) {
				return function (portee) {
					return function (filtrable) {
						return function (recherchable) {
							return function (utilisePar) {
								return function (personnelSur) {
									return function (collection) {
										return function (typeACreer) {
											return function (liste) {
												return function (origine) {
													return function (liens) {
														return {dy: cle, vD: collection, zG: filtrable, Aq: id, Bl: libelle, nQ: liens, nW: liste, o4: origine, pj: personnelSur, F$: portee, G1: recherchable, JQ: typeACreer, rU: typeAffiche, sf: utilisePar};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$champReuniDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$API$Liens$deLaRessource,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'origine',
		$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$origineDecoder),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'liste',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'typeACreer',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'collection',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'personnelSur',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'utilisePar',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'recherchable',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'filtrable',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'portee',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'typeAffiche',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'libelle',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'cle',
													$elm$json$Json$Decode$string,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'id',
														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
														$elm$core$Maybe$Nothing,
														$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ChampReuni)))))))))))))));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$pageDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$API$Liens$deLaRessource,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$unitesDeMesureDecoder,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$typesProposesDecoder,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'champsAReprendrePartiesPrenantes',
				$elm$json$Json$Decode$list(
					A5(
						$elm$json$Json$Decode$map4,
						$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ChampAReprendreDesParties,
						A2($elm$json$Json$Decode$field, 'cle', $elm$json$Json$Decode$string),
						A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string),
						A2(
							$elm$json$Json$Decode$field,
							'types',
							$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
						A2($elm$json$Json$Decode$field, 'valeursSaisies', $elm$json$Json$Decode$int))),
				_List_Nil,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'champs',
					$elm$json$Json$Decode$list($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$champReuniDecoder),
					$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$Page))))));
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$refusDeLecture = F2(
	function (decodeur, reponse) {
		var _v0 = A2($author$project$API$Reponse$lire, decodeur, reponse);
		if (_v0.$ === 1) {
			var refus = _v0.a;
			return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				$author$project$Components$Shared$Messages$Model$duRefus(refus));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$refusDuDomaine = function (refus) {
	var _v0 = refus.bB;
	if (_v0.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Catalogue$Vocabulaire$feminin = function (pluriel) {
	return {
		yg: $elm$core$Maybe$Nothing,
		zX: {av: false, M: 1, bT: pluriel}
	};
};
var $author$project$Catalogue$Vocabulaire$formesDeLArchetype = function (code) {
	switch (code) {
		case 'marque':
			return $elm$core$Maybe$Just(
				$author$project$Catalogue$Vocabulaire$feminin('marques'));
		case 'gamme':
			return $elm$core$Maybe$Just(
				$author$project$Catalogue$Vocabulaire$feminin('gammes'));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$lettreSansAccent = function (c) {
	var code = $elm$core$Char$toCode(c);
	return ((code >= 224) && (code <= 229)) ? 'a' : (((code >= 232) && (code <= 235)) ? 'e' : (((code >= 236) && (code <= 239)) ? 'i' : (((code >= 242) && (code <= 246)) ? 'o' : (((code >= 249) && (code <= 252)) ? 'u' : c))));
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$sansAccents = function (texte) {
	return A2(
		$elm$core$String$map,
		$author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$lettreSansAccent,
		$elm$core$String$toLower(
			$elm$core$String$trim(texte)));
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$memeNom = F2(
	function (a, b) {
		return _Utils_eq(
			$author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$sansAccents(a),
			$author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$sansAccents(b));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$formesDuNiveau = F2(
	function (niveaux, id) {
		return A2(
			$elm$core$Maybe$andThen,
			function (niveau) {
				var _v0 = _Utils_Tuple2(niveau.zS, niveau.R);
				if (_v0.a.$ === 1) {
					if (_v0.b.$ === 1) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return $author$project$Catalogue$Vocabulaire$formesDeLArchetype(niveau.fA);
					} else {
						var _v3 = _v0.a;
						var saisis = _v0.b.a;
						return A2(
							$author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$memeNom,
							saisis.zX,
							$author$project$I18n$Traductions$francaisDe(
								$author$project$Catalogue$Vocabulaire$archetype(niveau.fA))) ? $author$project$Catalogue$Vocabulaire$formesDeLArchetype(niveau.fA) : $elm$core$Maybe$Nothing;
					}
				} else {
					return niveau.zS;
				}
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Aq;
						},
						$elm$core$Basics$eq(id)),
					niveaux)));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$Niveau = F4(
	function (id, archetype, libelles, formes) {
		return {fA: archetype, zS: formes, Aq: id, R: libelles};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$niveauDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'grammaire',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Formes$decoder),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'libelles',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'archetype',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$author$project$Catalogue$Identifiants$niveauIdDecoder,
				$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$Niveau)))));
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$nomDuNiveau = F2(
	function (niveaux, id) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Traductions$tel(''),
			A2(
				$elm$core$Maybe$map,
				$author$project$Catalogue$Niveau$libelleDuNiveau,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(id)),
						niveaux))));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$structureDecoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (niveaux, classifications) {
			return A3(
				$author$project$Catalogue$Typologies$typologiesDeAvecFormes,
				$author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$nomDuNiveau(niveaux),
				$author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$formesDuNiveau(niveaux),
				classifications);
		}),
	A2(
		$elm$json$Json$Decode$field,
		'niveaux',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$niveauDecoder)),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'classifications',
				$elm$json$Json$Decode$list($author$project$Catalogue$API$QueryAPIModel$classificationDecoder)),
				$elm$json$Json$Decode$succeed(_List_Nil)
			])));
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$popMessages = function (msg) {
	_v0$11:
	while (true) {
		switch (msg.$) {
			case 2:
				switch (msg.a.$) {
					case 0:
						var _v1 = msg.a;
						var reponse = msg.b;
						var _v2 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$pageDecoder, reponse);
						if (_v2.$ === 1) {
							var refus = _v2.a;
							return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
								$author$project$Components$Shared$Messages$Model$duRefus(refus));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					case 1:
						var reponse = msg.b;
						var _v3 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$bibliothequeDecoder, reponse);
						if (_v3.$ === 1) {
							var refus = _v3.a;
							return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
								$author$project$Components$Shared$Messages$Model$duRefus(refus));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					case 2:
						var _v4 = msg.a;
						var reponse = msg.b;
						var _v5 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ficheDecoder, reponse);
						if (_v5.$ === 1) {
							var refus = _v5.a;
							return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
								$author$project$Components$Shared$Messages$Model$duRefus(refus));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					case 3:
						var _v6 = msg.a;
						var reponse = msg.b;
						var _v7 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$apercuDecoder, reponse);
						if (_v7.$ === 1) {
							var refus = _v7.a;
							return ((refus.ri === 401) || $author$project$Components$Parametrage$BibliothequeDeChamps$Update$refusDuDomaine(refus)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
								$author$project$Components$Shared$Messages$Model$duRefus(refus));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					case 4:
						var _v8 = msg.a;
						var reponse = msg.b;
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$refusDeLecture, $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$informationsDecoder, reponse);
					case 5:
						var _v9 = msg.a;
						var reponse = msg.b;
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$refusDeLecture, $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$structureDecoder, reponse);
					case 6:
						var _v10 = msg.a;
						var reponse = msg.b;
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$refusDeLecture, $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$annuaireDecoder, reponse);
					case 7:
						var _v11 = msg.a;
						var reponse = msg.b;
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$refusDeLecture, $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$listeDecoder, reponse);
					case 8:
						var _v12 = msg.a;
						var reponse = msg.b;
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$refusDeLecture, $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$fichesParValeurDecoder, reponse);
					case 11:
						var reponse = msg.b;
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$refusDeLecture, $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$apercuDuLotDecoder, reponse);
					default:
						break _v0$11;
				}
			case 1:
				var octets = msg.a;
				return _Utils_eq(
					$author$project$API$ProcessUid$depuisOctets(octets),
					$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
					{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
			default:
				break _v0$11;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Main$Update$requeteSurLaBibliotheque = function (effet) {
	switch (effet.$) {
		case 1:
			return true;
		case 2:
			return true;
		case 3:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DeLaBibliotheque = {$: 0};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DemanderProcessUid = {$: 0};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DesTypesDuGroupe = {$: 12};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$Lire = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$Reconnecter = {$: 6};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Saisie = {$: 0};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DeLaListeDuChamp = {$: 7};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$annuaireLu = F2(
	function (reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$annuaireDecoder, reponse);
		if (!_v0.$) {
			var annuaire = _v0.a;
			var liste = A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.nW;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dy;
							},
							$elm$core$Basics$eq(model.qF.dy)),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.dw;
								},
								model.EE)))));
			return _Utils_Tuple2(
				model,
				A2(
					$elm$core$List$take,
					1,
					A2(
						$elm$core$List$map,
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Lire($author$project$Components$Parametrage$BibliothequeDeChamps$Update$DeLaListeDuChamp),
						A2(
							$elm$core$List$filterMap,
							$elm$core$Tuple$second,
							A2(
								$elm$core$List$filter,
								function (_v1) {
									var id = _v1.a;
									return _Utils_eq(
										$elm$core$Maybe$Just(id),
										liste);
								},
								annuaire)))));
		} else {
			var refus = _v0.a;
			return _Utils_Tuple2(
				model,
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$Apercu = F3(
	function (fichesHorsChoix, auMoins, combinaisonsSansValeur) {
		return {tW: auMoins, vI: combinaisonsSansValeur, zz: fichesHorsChoix};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$apercuDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'combinaisonsSansValeur',
	$elm$json$Json$Decode$int,
	0,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'auMoins',
		$elm$json$Json$Decode$bool,
		false,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'fichesHorsChoix',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$Apercu))));
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$surLaRestriction = F2(
	function (changer, etat) {
		return _Utils_update(
			etat,
			{
				Es: A2(
					$elm$core$Maybe$map,
					function (ouvert) {
						return _Utils_update(
							ouvert,
							{
								al: changer(ouvert.al)
							});
					},
					etat.Es)
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$avecLApercu = function (lu) {
	return $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$surLaRestriction(
		$author$project$Components$Shared$Bibliotheque$Restriction$avecLApercu(lu.zz));
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$surLesRestrictions = F2(
	function (geste, model) {
		return _Utils_update(
			model,
			{
				qF: geste(model.qF)
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$apercuDeRestrictionLu = F2(
	function (reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$apercuDecoder, reponse);
		if (!_v0.$) {
			var apercu = _v0.a;
			return _Utils_Tuple2(
				A2(
					$author$project$Components$Parametrage$BibliothequeDeChamps$Update$surLesRestrictions,
					$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$avecLApercu(apercu),
					model),
				_List_Nil);
		} else {
			var refus = _v0.a;
			return _Utils_Tuple2(
				model,
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Lot$avec = F3(
	function (id, geste, lot) {
		return _Utils_update(
			lot,
			{
				ib: A2(
					$elm$core$List$map,
					function (t) {
						return _Utils_eq(t.Aq, id) ? geste(t) : t;
					},
					lot.ib)
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Lot$apercuIllisible = F2(
	function (id, lot) {
		return A3(
			$author$project$Components$Parametrage$BibliothequeDeChamps$Lot$avec,
			id,
			function (t) {
				return _Utils_update(
					t,
					{Ax: true});
			},
			lot);
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Lot$apercuLu = F3(
	function (id, apercu, lot) {
		return A3(
			$author$project$Components$Parametrage$BibliothequeDeChamps$Lot$avec,
			id,
			function (t) {
				return _Utils_update(
					t,
					{
						tq: $elm$core$Maybe$Just(apercu),
						Ax: false
					});
			},
			lot);
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$apercuDuLotLu = F3(
	function (id, reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$apercuDuLotDecoder, reponse);
		if (!_v0.$) {
			var apercu = _v0.a;
			return _Utils_update(
				model,
				{
					n0: A2(
						$elm$core$Maybe$map,
						A2($author$project$Components$Parametrage$BibliothequeDeChamps$Lot$apercuLu, id, apercu),
						model.n0)
				});
		} else {
			return _Utils_update(
				model,
				{
					n0: A2(
						$elm$core$Maybe$map,
						$author$project$Components$Parametrage$BibliothequeDeChamps$Lot$apercuIllisible(id),
						model.n0)
				});
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$ApercuDemande = {$: 1};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Averti = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$ConversionApercue = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$ConversionImpossible = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Confirmation = {$: 3};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLaDefinition = F2(
	function (geste, model) {
		return _Utils_update(
			model,
			{
				wZ: A2($elm$core$Maybe$map, geste, model.wZ)
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$ModifierLaDefinition = F5(
	function (a, b, c, d, e) {
		return {$: 13, a: a, b: b, c: c, d: d, e: e};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$DeLaDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$DuGroupe = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$DuMontant = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$DuNombre = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Illisible = {$: 2};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Lues = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$PasDOption = {$: 0};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$DuTexte = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$duTexte = F3(
	function (entier, brouillon, miseEnForme) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Illisible,
			A2(
				$elm$core$Maybe$map,
				function (longueurMax) {
					return $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Lues(
						$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$DuTexte(
							{zP: brouillon.zP, B$: longueurMax, CE: miseEnForme}));
				},
				($elm$core$String$trim(brouillon.B$) === '') ? $elm$core$Maybe$Just($elm$core$Maybe$Nothing) : A2(
					$elm$core$Maybe$map,
					$elm$core$Maybe$Just,
					entier(brouillon.B$))));
	});
var $author$project$Components$Parametrage$Vocabulaire$OptionsDeLaDate = 4;
var $author$project$Components$Parametrage$Vocabulaire$OptionsDeLaMesure = 5;
var $author$project$Components$Parametrage$Vocabulaire$OptionsDuChoix = 7;
var $author$project$Components$Parametrage$Vocabulaire$OptionsDuGroupe = 6;
var $author$project$Components$Parametrage$Vocabulaire$OptionsDuMontant = 3;
var $author$project$Components$Parametrage$Vocabulaire$OptionsDuNombre = 2;
var $author$project$Components$Parametrage$Vocabulaire$OptionsDuTexte = 0;
var $author$project$Components$Parametrage$Vocabulaire$OptionsDuTexteLong = 1;
var $author$project$Components$Parametrage$Vocabulaire$SansOptions = 8;
var $author$project$Components$Parametrage$Vocabulaire$familleDOptions = function (code) {
	switch (code) {
		case 'texte':
			return 0;
		case 'texte-long':
			return 1;
		case 'nombre':
			return 2;
		case 'montant':
			return 3;
		case 'date':
			return 4;
		case 'mesure':
			return 5;
		case 'groupe':
			return 6;
		case 'choix-dans-une-liste':
			return 7;
		default:
			return 8;
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$nonVide = function (texte) {
	return ($elm$core$String$trim(texte) === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(texte);
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$lire = F2(
	function (fiche, brouillon) {
		var entier = function (texte) {
			return $elm$core$String$toInt(
				$elm$core$String$trim(texte));
		};
		var date = function (texte) {
			return ($elm$core$String$trim(texte) === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				$elm$core$String$trim(texte));
		};
		var borne = function (texte) {
			return ($elm$core$String$trim(texte) === '') ? $elm$core$Maybe$Just($elm$core$Maybe$Nothing) : A2(
				$elm$core$Maybe$map,
				$elm$core$Maybe$Just,
				$elm$core$String$toFloat(
					A3(
						$elm$core$String$replace,
						',',
						'.',
						$elm$core$String$trim(texte))));
		};
		var _v0 = $author$project$Components$Parametrage$Vocabulaire$familleDOptions(fiche.JR);
		switch (_v0) {
			case 1:
				return A3($author$project$Components$Parametrage$BibliothequeDeChamps$Definition$duTexte, entier, brouillon, brouillon.CE);
			case 0:
				return A3($author$project$Components$Parametrage$BibliothequeDeChamps$Definition$duTexte, entier, brouillon, false);
			case 2:
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Illisible,
					A4(
						$elm$core$Maybe$map3,
						F3(
							function (min, max, decimales) {
								return $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Lues(
									$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$DuNombre(
										{kv: decimales, Cg: max, Cx: min}));
							}),
						borne(brouillon.Cx),
						borne(brouillon.Cg),
						entier(brouillon.kv)));
			case 3:
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Illisible,
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (min, max) {
								return $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Lues(
									$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$DuMontant(
										{Cg: max, Cx: min}));
							}),
						borne(brouillon.Cx),
						borne(brouillon.Cg)));
			case 4:
				return $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Lues(
					$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$DeLaDate(
						{
							wz: date(brouillon.wz),
							wA: date(brouillon.wA)
						}));
			case 5:
				return ($elm$core$String$trim(brouillon.sa) === '') ? $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Illisible : A2(
					$elm$core$Maybe$withDefault,
					$author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Illisible,
					A4(
						$elm$core$Maybe$map3,
						F3(
							function (min, max, decimales) {
								return $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Lues(
									$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$DeLaMesure(
										{
											kv: decimales,
											m0: A2($elm$core$Maybe$withDefault, '', fiche.o_.m0),
											Cg: max,
											Cx: min,
											sa: $elm$core$String$trim(brouillon.sa)
										}));
							}),
						borne(brouillon.Cx),
						borne(brouillon.Cg),
						entier(brouillon.kv)));
			case 6:
				return (_Utils_eq(brouillon.IX, _List_Nil) || (!_Utils_eq(
					$author$project$Components$Shared$EditeurDeSchema$SousChamps$manque(brouillon.IX),
					_List_Nil))) ? $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Illisible : $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Lues(
					$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$DuGroupe(
						{
							z9: brouillon.z9,
							Bq: $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$nonVide(brouillon.Bq),
							HI: brouillon.HI,
							IX: brouillon.IX
						}));
			case 7:
				return $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Lues(
					$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$DuChoix(
						{FS: brouillon.FS}));
			default:
				return $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$PasDOption;
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$commandeDeLaDefinition = F2(
	function (fiche, brouillon) {
		var _v0 = A2($author$project$Components$Parametrage$BibliothequeDeChamps$Definition$lire, fiche, brouillon);
		switch (_v0.$) {
			case 2:
				return $elm$core$Maybe$Nothing;
			case 0:
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$ModifierLaDefinition,
						fiche.Aq,
						$elm$core$String$trim(brouillon.Dj),
						brouillon.bp,
						$elm$core$Maybe$Nothing,
						$elm$core$Maybe$Just(brouillon.M)));
			default:
				var options = _v0.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$ModifierLaDefinition,
						fiche.Aq,
						$elm$core$String$trim(brouillon.Dj),
						brouillon.bp,
						$elm$core$Maybe$Just(options),
						$elm$core$Maybe$Just(brouillon.M)));
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeLaDefinition = F2(
	function (rel, fiche) {
		return A2($author$project$API$Liens$trouver, rel, fiche.nQ.h0);
	});
var $author$project$API$NavLinksDictionary$modifierLaDefinition = 'modifier-la-definition';
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$Envoyer = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$reglageDEnvoi = {
	f8: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DemanderProcessUid,
	l4: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$Envoyer,
	go: function (reponse) {
		var _v0 = A2(
			$author$project$API$Reponse$lire,
			$elm$json$Json$Decode$succeed(0),
			reponse);
		if (_v0.$ === 1) {
			var refus = _v0.a;
			return $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$duRefus(refus);
		} else {
			return $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$Autre;
		}
	},
	pW: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$Reconnecter,
	qu: F2(
		function (_v1, _v2) {
			return true;
		}),
	qv: $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$rendueDecoder
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$envoyerLaDefinition = F3(
	function (fiche, definition, model) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$Components$Parametrage$BibliothequeDeChamps$Definition$commandeDeLaDefinition, fiche, definition.uw),
			A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeLaDefinition, $author$project$API$NavLinksDictionary$modifierLaDefinition, fiche));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var commande = _v0.a.a;
			var lien = _v0.b.a;
			var _v1 = A4(
				$author$project$API$Envoi$partir,
				$author$project$Components$Parametrage$BibliothequeDeChamps$Update$reglageDEnvoi,
				$elm$core$Maybe$Just(lien),
				commande,
				model.l2);
			if (!_v1.$) {
				var _v2 = _v1.a;
				var envoi = _v2.a;
				var effets = _v2.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLaDefinition,
						function (d) {
							return _Utils_update(
								d,
								{pZ: $elm$core$Maybe$Nothing});
						},
						_Utils_update(
							model,
							{l2: envoi})),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$partage = function (fiche) {
	return $elm$core$List$length(fiche.JY) > 1;
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$apresLApercu = F2(
	function (fiche, model) {
		var _v0 = model.wZ;
		if (!_v0.$) {
			var definition = _v0.a;
			return $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$partage(fiche) ? _Utils_Tuple2(
				A2(
					$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLaDefinition,
					function (d) {
						return _Utils_update(
							d,
							{v2: false, me: $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Confirmation});
					},
					model),
				_List_Nil) : A3($author$project$Components$Parametrage$BibliothequeDeChamps$Update$envoyerLaDefinition, fiche, definition, model);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$I18n$Textes$bibliothequeDefinitionRefusAutre = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.refus-autre', _List_Nil, 'La définition n\'a pas pu être enregistrée.');
var $author$project$I18n$Textes$bibliothequeDefinitionRefusConversionEnCours = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.refus-conversion-en-cours', _List_Nil, 'Une conversion d\'unité est déjà en cours pour ce champ. Réessayez dans quelques instants.');
var $author$project$I18n$Textes$bibliothequeDefinitionRefusEvolutionNonAdditive = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'bibliotheque.definition.refus-evolution-non-additive',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'raison',
				$author$project$I18n$Traductions$Sous(p.pH))
			]),
		'Cette évolution est refusée : {raison}.');
};
var $author$project$I18n$Textes$bibliothequeDefinitionRefusGrandeurFigee = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.refus-grandeur-figee', _List_Nil, 'La grandeur ne peut plus changer : des valeurs sont déjà saisies.');
var $author$project$I18n$Textes$bibliothequeDefinitionRefusLangueInconnue = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.refus-langue-inconnue', _List_Nil, 'Cette langue n\'est pas proposée.');
var $author$project$I18n$Textes$bibliothequeDefinitionRefusNomVide = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.refus-nom-vide', _List_Nil, 'Le nom ne peut pas être vide.');
var $author$project$I18n$Textes$bibliothequeDefinitionRefusNonAppliquee = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.refus-non-appliquee', _List_Nil, 'La modification n\'a pas atteint tous les types. Appliquez-la de nouveau : elle reprendra aux types restants.');
var $author$project$I18n$Textes$bibliothequeDefinitionRefusOptionInvalide = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'bibliotheque.definition.refus-option-invalide',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'option',
				$author$project$I18n$Traductions$Sous(p.Eh))
			]),
		'L\'option « {option} » n\'est pas valide : vérifiez la valeur saisie.');
};
var $author$project$I18n$Textes$bibliothequeDefinitionRefusTypeNonModifiable = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.refus-type-non-modifiable', _List_Nil, 'Les options de ce type de champ ne se modifient pas.');
var $author$project$I18n$Textes$bibliothequeDefinitionRefusUniteHorsGrandeur = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.refus-unite-hors-grandeur', _List_Nil, 'Cette unité n\'appartient pas à la grandeur du champ.');
var $author$project$I18n$Textes$bibliothequeDefinitionRefusValeursPerdues = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.refus-valeurs-perdues', _List_Nil, 'Des valeurs non nulles deviendraient zéro avec cette unité : choisissez-en une autre. Rien n\'a été converti.');
var $author$project$I18n$Textes$bibliothequeDefinitionRefusVuesEnRetard = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.refus-vues-en-retard', _List_Nil, 'Le champ n\'est pas encore à jour : rien n\'a été converti pour le moment. Renvoyez le même geste, il reprendra là où il s\'est arrêté.');
var $author$project$I18n$Textes$bibliothequeDefinitionDecimales = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.decimales', _List_Nil, 'Décimales');
var $author$project$I18n$Textes$bibliothequeDefinitionFormat = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.format', _List_Nil, 'Format');
var $author$project$I18n$Textes$bibliothequeDefinitionLongueurMax = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.longueur-max', _List_Nil, 'Longueur maximale');
var $author$project$I18n$Textes$bibliothequeDefinitionRefusOptionBornes = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.refus-option-bornes', _List_Nil, 'Valeurs minimale et maximale');
var $author$project$Components$Parametrage$Vocabulaire$optionDeLaDefinition = function (option) {
	switch (option) {
		case 'longueur':
			return $author$project$I18n$Textes$bibliothequeDefinitionLongueurMax;
		case 'format':
			return $author$project$I18n$Textes$bibliothequeDefinitionFormat;
		case 'bornes':
			return $author$project$I18n$Textes$bibliothequeDefinitionRefusOptionBornes;
		case 'decimales':
			return $author$project$I18n$Textes$bibliothequeDefinitionDecimales;
		default:
			return $author$project$I18n$Traductions$tel(option);
	}
};
var $author$project$I18n$Textes$bibliothequeDefinitionRaisonAutre = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.raison-autre', _List_Nil, 'elle invaliderait des valeurs déjà saisies');
var $author$project$I18n$Textes$bibliothequeDefinitionRaisonBorneResserree = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.raison-borne-resserree', _List_Nil, 'une borne serait resserrée ou posée : des valeurs saisies pourraient en sortir');
var $author$project$I18n$Textes$bibliothequeDefinitionRaisonDecimalesChangees = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.raison-decimales-changees', _List_Nil, 'le nombre de décimales changerait alors que des valeurs sont saisies');
var $author$project$I18n$Textes$bibliothequeDefinitionRaisonFormeChangee = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.raison-forme-changee', _List_Nil, 'la forme des valeurs changerait');
var $author$project$I18n$Textes$bibliothequeDefinitionRaisonLongueurResserree = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.raison-longueur-resserree', _List_Nil, 'la longueur maximale serait resserrée');
var $author$project$I18n$Textes$bibliothequeDefinitionRaisonMotifResserre = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.raison-motif-resserre', _List_Nil, 'le format serait resserré');
var $author$project$I18n$Textes$bibliothequeDefinitionRaisonPersonnelleNonPosable = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.raison-personnelle-non-posable', _List_Nil, 'la mention « donnée personnelle » ne peut pas être posée sur un champ existant');
var $author$project$I18n$Textes$bibliothequeDefinitionRaisonPersonnelleNonRetirable = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.raison-personnelle-non-retirable', _List_Nil, 'la mention « donnée personnelle » ne peut pas être retirée');
var $author$project$I18n$Textes$bibliothequeDefinitionRaisonRepetabiliteChangee = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.raison-repetabilite-changee', _List_Nil, 'des fiches portent des occurrences de ce groupe : il ne peut plus passer de répétable à non répétable, ni l\'inverse');
var $author$project$I18n$Textes$bibliothequeDefinitionRaisonSousChampRetire = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.raison-sous-champ-retire', _List_Nil, 'ce sous-champ est renseigné sur des fiches : le retirer ferait disparaître leurs valeurs. Vous pouvez le masquer : les valeurs sont gardées, la saisie et la lecture le cachent');
var $author$project$I18n$Textes$bibliothequeDefinitionRaisonTypeChange = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.raison-type-change', _List_Nil, 'le type du champ ne peut pas changer');
var $author$project$I18n$Textes$bibliothequeDefinitionRaisonTypeDeSousChampChange = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.raison-type-de-sous-champ-change', _List_Nil, 'le type d\'un sous-champ ne peut pas changer alors que des fiches le renseignent');
var $author$project$I18n$Textes$bibliothequeDefinitionRaisonUniteChangee = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.raison-unite-changee', _List_Nil, 'l\'unité changerait alors que des valeurs sont saisies');
var $author$project$I18n$Textes$bibliothequeDefinitionRaisonValeurRetiree = A3($author$project$I18n$Traductions$texte, 'bibliotheque.definition.raison-valeur-retiree', _List_Nil, 'une valeur de la liste serait retirée ou renommée');
var $author$project$Components$Parametrage$Vocabulaire$raisonDeLEvolution = function (raison) {
	switch (raison) {
		case 'TypeChange':
			return $author$project$I18n$Textes$bibliothequeDefinitionRaisonTypeChange;
		case 'SousChampRetire':
			return $author$project$I18n$Textes$bibliothequeDefinitionRaisonSousChampRetire;
		case 'TypeDeSousChampChange':
			return $author$project$I18n$Textes$bibliothequeDefinitionRaisonTypeDeSousChampChange;
		case 'RepetabiliteChangee':
			return $author$project$I18n$Textes$bibliothequeDefinitionRaisonRepetabiliteChangee;
		case 'ValeurRetiree':
			return $author$project$I18n$Textes$bibliothequeDefinitionRaisonValeurRetiree;
		case 'BorneResserree':
			return $author$project$I18n$Textes$bibliothequeDefinitionRaisonBorneResserree;
		case 'UniteChangee':
			return $author$project$I18n$Textes$bibliothequeDefinitionRaisonUniteChangee;
		case 'DecimalesChangees':
			return $author$project$I18n$Textes$bibliothequeDefinitionRaisonDecimalesChangees;
		case 'FormeChangee':
			return $author$project$I18n$Textes$bibliothequeDefinitionRaisonFormeChangee;
		case 'LongueurResserree':
			return $author$project$I18n$Textes$bibliothequeDefinitionRaisonLongueurResserree;
		case 'MotifResserre':
			return $author$project$I18n$Textes$bibliothequeDefinitionRaisonMotifResserre;
		case 'DonneePersonnelleNonRetirable':
			return $author$project$I18n$Textes$bibliothequeDefinitionRaisonPersonnelleNonRetirable;
		case 'DonneePersonnelleNonPosable':
			return $author$project$I18n$Textes$bibliothequeDefinitionRaisonPersonnelleNonPosable;
		default:
			return $author$project$I18n$Textes$bibliothequeDefinitionRaisonAutre;
	}
};
var $author$project$Components$Parametrage$Vocabulaire$refusDeLaDefinition = F2(
	function (cas, precisions) {
		var precision = function (nom) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$second,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (_v1) {
								var cle = _v1.a;
								return _Utils_eq(cle, nom);
							},
							precisions))));
		};
		switch (cas) {
			case 'NomVide':
				return $author$project$I18n$Textes$bibliothequeDefinitionRefusNomVide;
			case 'OptionInvalide':
				return $author$project$I18n$Textes$bibliothequeDefinitionRefusOptionInvalide(
					{
						Eh: $author$project$Components$Parametrage$Vocabulaire$optionDeLaDefinition(
							precision('option'))
					});
			case 'TypeDeChampNonModifiable':
				return $author$project$I18n$Textes$bibliothequeDefinitionRefusTypeNonModifiable;
			case 'GrandeurFigee':
				return $author$project$I18n$Textes$bibliothequeDefinitionRefusGrandeurFigee;
			case 'UniteHorsGrandeur':
				return $author$project$I18n$Textes$bibliothequeDefinitionRefusUniteHorsGrandeur;
			case 'LangueInconnue':
				return $author$project$I18n$Textes$bibliothequeDefinitionRefusLangueInconnue;
			case 'EvolutionNonAdditive':
				return $author$project$I18n$Textes$bibliothequeDefinitionRefusEvolutionNonAdditive(
					{
						pH: $author$project$Components$Parametrage$Vocabulaire$raisonDeLEvolution(
							precision('raison'))
					});
			case 'DefinitionNonAppliqueeATous':
				return $author$project$I18n$Textes$bibliothequeDefinitionRefusNonAppliquee;
			case 'VuesEnRetard':
				return $author$project$I18n$Textes$bibliothequeDefinitionRefusVuesEnRetard;
			case 'ValeursPerdues':
				return $author$project$I18n$Textes$bibliothequeDefinitionRefusValeursPerdues;
			case 'ConversionDejaEnCours':
				return $author$project$I18n$Textes$bibliothequeDefinitionRefusConversionEnCours;
			case 'ConversionEnCours':
				return $author$project$I18n$Textes$bibliothequeDefinitionRefusConversionEnCours;
			default:
				return $author$project$I18n$Textes$bibliothequeDefinitionRefusAutre;
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$libelleDuRefusDeLaDefinition = function (erreur) {
	switch (erreur.$) {
		case 3:
			var cas = erreur.a;
			var precisions = erreur.b;
			return A2($author$project$Components$Parametrage$Vocabulaire$refusDeLaDefinition, cas, precisions);
		case 4:
			return A2($author$project$Components$Parametrage$Vocabulaire$refusDeLaDefinition, 'DefinitionNonAppliqueeATous', _List_Nil);
		case 5:
			return A2($author$project$Components$Parametrage$Vocabulaire$refusDeLaDefinition, 'VuesEnRetard', _List_Nil);
		default:
			return A2($author$project$Components$Parametrage$Vocabulaire$refusDeLaDefinition, '', _List_Nil);
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$retraitRefuse = function (erreur) {
	if ((erreur.$ === 3) && (erreur.a === 'SousChampRetireAvecValeurs')) {
		var precisions = erreur.b;
		return A3(
			$elm$core$Maybe$map2,
			F2(
				function (libelle, fiches) {
					return {zu: fiches, Bl: libelle};
				}),
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$eq('libelle')),
						precisions))),
			A2(
				$elm$core$Maybe$andThen,
				A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$String$toInt),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$eq('fiches')),
						precisions))));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLeRefus = F2(
	function (erreur, definition) {
		var _v0 = _Utils_Tuple2(
			$author$project$Components$Parametrage$BibliothequeDeChamps$Update$retraitRefuse(erreur),
			!_Utils_eq(definition.uw.IX, _List_Nil));
		if ((!_v0.a.$) && _v0.b) {
			var retrait = _v0.a.a;
			return _Utils_update(
				definition,
				{
					AX: $elm$core$Maybe$Just(retrait),
					pZ: $elm$core$Maybe$Nothing
				});
		} else {
			return _Utils_update(
				definition,
				{
					AX: $elm$core$Maybe$Nothing,
					pZ: $elm$core$Maybe$Just(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$libelleDuRefusDeLaDefinition(erreur))
				});
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$apercuLu = F2(
	function (reponse, model) {
		var _v0 = _Utils_Tuple2(model.zo, model.wZ);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var fiche = _v0.a.a;
			var etape = _v0.b.a.me;
			if (!_Utils_eq(etape, $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$ApercuDemande)) {
				return _Utils_Tuple2(model, _List_Nil);
			} else {
				var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$apercuDecoder, reponse);
				if (!_v1.$) {
					var apercu = _v1.a;
					var _v2 = apercu.wd;
					if (!_v2.$) {
						var conversion = _v2.a;
						return _Utils_Tuple2(
							A2(
								$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLaDefinition,
								function (d) {
									return _Utils_update(
										d,
										{
											v2: false,
											me: (conversion.pe > 0) ? $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$ConversionImpossible(conversion) : $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$ConversionApercue(conversion)
										});
								},
								model),
							_List_Nil);
					} else {
						return ((apercu.oF > 0) || apercu.tW) ? _Utils_Tuple2(
							A2(
								$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLaDefinition,
								function (d) {
									return _Utils_update(
										d,
										{
											me: $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Averti(apercu)
										});
								},
								model),
							_List_Nil) : A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$apresLApercu, fiche, model);
					}
				} else {
					var refus = _v1.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLaDefinition,
							function (d) {
								return A2(
									$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLeRefus,
									$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$duRefus(refus),
									_Utils_update(
										d,
										{me: $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Saisie}));
							},
							model),
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Reconnecter]) : _List_Nil);
				}
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$CalculEnLot = F3(
	function (a, b, c) {
		return {$: 21, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Lot$commande = F2(
	function (fiche, lot) {
		return (lot.vd === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A3($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$CalculEnLot, lot.vd, fiche.dy, 'appliquer'));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Lot$lienDeLaCommande = function (fiche) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$calculEnLotDesReferences, fiche.nQ.h0);
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$appliquerLeLot = function (model) {
	var _v0 = _Utils_Tuple2(model.zo, model.n0);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var fiche = _v0.a.a;
		var lot = _v0.b.a;
		var _v1 = _Utils_Tuple2(
			A2($author$project$Components$Parametrage$BibliothequeDeChamps$Lot$commande, fiche, lot),
			$author$project$Components$Parametrage$BibliothequeDeChamps$Lot$lienDeLaCommande(fiche));
		if ((!_v1.a.$) && (!_v1.b.$)) {
			var commande = _v1.a.a;
			var lien = _v1.b.a;
			var _v2 = A4(
				$author$project$API$Envoi$partir,
				$author$project$Components$Parametrage$BibliothequeDeChamps$Update$reglageDEnvoi,
				$elm$core$Maybe$Just(lien),
				commande,
				model.l2);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var envoi = _v3.a;
				var effets = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: envoi,
							n0: $elm$core$Maybe$Just(
								_Utils_update(
									lot,
									{pZ: false}))
						}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLaTraduction = F2(
	function (geste, model) {
		return _Utils_update(
			model,
			{
				JK: A2($elm$core$Maybe$map, geste, model.JK)
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLeBrouillon = F2(
	function (geste, definition) {
		return _Utils_update(
			definition,
			{
				uw: geste(definition.uw),
				AX: $elm$core$Maybe$Nothing,
				pZ: $elm$core$Maybe$Nothing
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLeCalcul = F2(
	function (geste, model) {
		return _Utils_update(
			model,
			{
				uB: A2($elm$core$Maybe$map, geste, model.uB)
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLeRattachement = F2(
	function (geste, model) {
		return _Utils_update(
			model,
			{
				pN: A2($elm$core$Maybe$map, geste, model.pN)
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLeReglage = F2(
	function (geste, model) {
		return _Utils_update(
			model,
			{
				eO: A2($elm$core$Maybe$map, geste, model.eO)
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$Apercevoir = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$DeLaRestriction = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$DeLaRestrictionDUnType = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$Apercevoir = 2;
var $author$project$API$NavLinksDictionary$apercuRestrictionDUnChampHerite = 'apercu-restriction-d-un-champ-herite';
var $author$project$API$NavLinksDictionary$leverLaRestrictionDUnChampHerite = 'lever-la-restriction-d-un-champ-herite';
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$lienDe = F2(
	function (rel, etat) {
		return A2($author$project$API$Liens$trouver, rel, etat.nQ);
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$typeEnPorteur = function (type_) {
	return A2(
		$elm$core$Maybe$map,
		function (id) {
			return {vj: id, nQ: type_.nQ, ou: type_.Aq, qF: type_.qF};
		},
		$author$project$Catalogue$Identifiants$classificationIdFromString(type_.Aq));
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$tousLesPorteurs = function (etat) {
	return _Utils_ap(
		A2($elm$core$Maybe$withDefault, _List_Nil, etat.F3),
		A2($elm$core$List$filterMap, $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$typeEnPorteur, etat.ib));
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$porteurDe = F2(
	function (etat, noeud) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (p) {
					return _Utils_eq(p.ou, noeud.c0) && _Utils_eq(p.vj, noeud.vj);
				},
				$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$tousLesPorteurs(etat)));
	});
var $author$project$API$NavLinksDictionary$restreindreLesValeursDUnChampHerite = 'restreindre-les-valeurs-d-un-champ-herite';
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$lienPour = F3(
	function (geste, noeud, etat) {
		var _v0 = _Utils_Tuple2(noeud.M, geste);
		if (!_v0.a) {
			switch (_v0.b) {
				case 0:
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					return A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$lienDe, $author$project$API$NavLinksDictionary$restreindreLesValeursDUnChampHerite, etat);
				case 1:
					var _v3 = _v0.a;
					var _v4 = _v0.b;
					return A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$lienDe, $author$project$API$NavLinksDictionary$leverLaRestrictionDUnChampHerite, etat);
				default:
					var _v5 = _v0.a;
					var _v6 = _v0.b;
					return A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.nQ;
							},
							$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$apercuRestrictionDUnChampHerite)),
						A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$porteurDe, etat, noeud));
			}
		} else {
			switch (_v0.b) {
				case 0:
					var _v7 = _v0.a;
					var _v8 = _v0.b;
					return A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.nQ;
							},
							$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$restreindreLesValeurs)),
						A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$porteurDe, etat, noeud));
				case 1:
					var _v9 = _v0.a;
					var _v10 = _v0.b;
					return A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.nQ;
							},
							$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$leverLaRestriction)),
						A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$porteurDe, etat, noeud));
				default:
					var _v11 = _v0.a;
					var _v12 = _v0.b;
					return A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.nQ;
							},
							$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$apercuRestriction)),
						A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$porteurDe, etat, noeud));
			}
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$apercu = function (etat) {
	var _v0 = etat.Es;
	if (!_v0.$) {
		var ouvert = _v0.a;
		return $author$project$Components$Shared$Bibliotheque$Restriction$enregistrable(ouvert.al) ? A2(
			$elm$core$Maybe$map,
			function (lien) {
				return {
					nB: lien,
					ou: ouvert.ou,
					Ki: $author$project$Components$Shared$Bibliotheque$Restriction$retenues(ouvert.al)
				};
			},
			A3($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$lienPour, 2, ouvert.ou, etat)) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$porteeDuNoeud = function (noeud) {
	return {
		vj: $author$project$Catalogue$Identifiants$classificationIdToString(noeud.vj),
		ou: noeud.c0
	};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$chezLApercu = F2(
	function (geste, model) {
		var etat = geste(model.qF);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{qF: etat}),
			function () {
				var _v0 = $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$apercu(etat);
				if (!_v0.$) {
					var demande = _v0.a;
					return _List_fromArray(
						[
							A3(
							$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Apercevoir,
							demande.nB,
							etat.dy,
							$elm$core$Maybe$Just(
								function () {
									var _v1 = demande.ou.M;
									if (_v1 === 1) {
										return A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$DeLaRestrictionDUnType, demande.ou.c0, demande.Ki);
									} else {
										return A2(
											$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$DeLaRestriction,
											$author$project$Components$Parametrage$BibliothequeDeChamps$Update$porteeDuNoeud(demande.ou),
											demande.Ki);
									}
								}()))
						]);
				} else {
					return _List_Nil;
				}
			}());
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Lot$choisi = F2(
	function (id, lot) {
		return _Utils_update(
			lot,
			{vd: id, pZ: false});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Rattachement$choisieParmi = F2(
	function (id, fiche) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (r) {
					return _Utils_eq(r.Aq, id);
				},
				fiche.HQ));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Rattachement$domaineDeLaPartiePrenante = 'parties-prenantes';
var $author$project$Components$Parametrage$BibliothequeDeChamps$Rattachement$choisir = F3(
	function (id, fiche, rattachement) {
		var reglages = rattachement.qc;
		var pasPartiePrenante = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function (r) {
					return !_Utils_eq(r.cC, $author$project$Components$Parametrage$BibliothequeDeChamps$Rattachement$domaineDeLaPartiePrenante);
				},
				A2($author$project$Components$Parametrage$BibliothequeDeChamps$Rattachement$choisieParmi, id, fiche)));
		return _Utils_update(
			rattachement,
			{
				pZ: $elm$core$Maybe$Nothing,
				qc: pasPartiePrenante ? _Utils_update(
					reglages,
					{xD: false}) : reglages,
				HN: (id === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(id)
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$choisirLEtage = F2(
	function (etage, etat) {
		return _Utils_update(
			etat,
			{
				jN: A2(
					$elm$core$Maybe$map,
					function (_v0) {
						return {md: etage, ou: $elm$core$Maybe$Nothing};
					},
					etat.jN)
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$choisirLeNoeud = F2(
	function (noeud, etat) {
		return _Utils_update(
			etat,
			{
				jN: A2(
					$elm$core$Maybe$map,
					function (choix) {
						return _Utils_update(
							choix,
							{
								ou: $elm$core$Maybe$Just(noeud)
							});
					},
					etat.jN)
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$cocher = F2(
	function (id, oui) {
		return $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$surLaRestriction(
			A2($author$project$Components$Shared$Bibliotheque$Restriction$cocher, id, oui));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$AttendreAvantDeRelire = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DeLaFiche = {$: 2};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DesPorteurs = {$: 4};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeLaFicheOuverte = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		function (fiche) {
			return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$self, fiche.nQ.h0);
		},
		model.zo);
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$lienDesPorteurs = $author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$informations);
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$relire = function (model) {
	return _Utils_ap(
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Lire($author$project$Components$Parametrage$BibliothequeDeChamps$Update$DeLaBibliotheque),
					$elm$core$List$singleton),
				model.np)),
		_Utils_ap(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Lire($author$project$Components$Parametrage$BibliothequeDeChamps$Update$DeLaFiche),
						$elm$core$List$singleton),
					$author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeLaFicheOuverte(model))),
			(model.qF.dy === '') ? _List_Nil : A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Lire($author$project$Components$Parametrage$BibliothequeDeChamps$Update$DesPorteurs),
						$elm$core$List$singleton),
					$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$lienDesPorteurs(model.GN)))));
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$PlacerFocus = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDeLaDefinition = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{
						wZ: A2(
							$elm$core$List$member,
							geste,
							_List_fromArray(
								[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$AbandonConfirme])) ? $elm$core$Maybe$Nothing : model.wZ,
						dO: drawer
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.dO));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$conclureLaDefinition = F2(
	function (issue, model) {
		switch (issue.$) {
			case 0:
				var rendue = issue.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(
						rendue.sy ? $author$project$Components$Parametrage$BibliothequeDeChamps$Update$relire(model) : _List_fromArray(
							[
								$author$project$Components$Parametrage$BibliothequeDeChamps$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
							])),
					A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDeLaDefinition, $author$project$Components$Shared$Drawer$Update$Fermer, model));
			case 1:
				var erreur = issue.c;
				var etapeApres = function (etape) {
					var _v1 = _Utils_Tuple2(
						_Utils_eq(erreur, $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$NonAppliqueeATous) || _Utils_eq(erreur, $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIErrorsModel$VuesEnRetard),
						etape);
					if (_v1.a) {
						if (_v1.b.$ === 4) {
							return etape;
						} else {
							return $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Confirmation;
						}
					} else {
						return $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Saisie;
					}
				};
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLaDefinition,
						function (d) {
							return A2(
								$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLeRefus,
								erreur,
								_Utils_update(
									d,
									{
										me: etapeApres(d.me)
									}));
						},
						model),
					_List_Nil);
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$refuser = $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$surLaRestriction($author$project$Components$Shared$Bibliotheque$Restriction$refuser);
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$DeType = 1;
var $author$project$I18n$Textes$restrictionsEtageType = A3($author$project$I18n$Traductions$texte, 'restrictions.etage-type', _List_Nil, 'Type');
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$etageDesTypes = $author$project$I18n$Textes$restrictionsEtageType;
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$typeEnNoeud = function (type_) {
	return A2(
		$elm$core$Maybe$map,
		function (id) {
			return {vj: id, md: $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$etageDesTypes, zS: $elm$core$Maybe$Nothing, M: 1, Aq: type_.Aq, Dj: type_.Dj, ey: $elm$core$Maybe$Nothing, c0: type_.Aq, r3: type_.Aq};
		},
		$author$project$Catalogue$Identifiants$classificationIdFromString(type_.Aq));
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$tous = function (etat) {
	return _Utils_ap(
		A2($elm$core$List$filterMap, $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$typeEnNoeud, etat.ib),
		A2($elm$core$Maybe$withDefault, _List_Nil, etat.Di));
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$ancetres = F2(
	function (etat, noeud) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (id) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (n) {
							return _Utils_eq(n.Aq, id) && _Utils_eq(n.vj, noeud.vj);
						},
						$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$tous(etat)));
			},
			noeud.ey);
		if (!_v0.$) {
			var parent = _v0.a;
			return _Utils_ap(
				A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$ancetres, etat, parent),
				_List_fromArray(
					[parent]));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$propres = F2(
	function (etat, noeud) {
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.qF;
				},
				$elm$core$Dict$get(etat.dy)),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (p) {
						return _Utils_eq(p.ou, noeud.c0) && _Utils_eq(p.vj, noeud.vj);
					},
					$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$tousLesPorteurs(etat))));
	});
var $author$project$Components$Shared$Bibliotheque$Restriction$refuserUneValeur = F3(
	function (valeur, par, restriction) {
		return _Utils_update(
			restriction,
			{
				qa: true,
				eN: par,
				fo: $elm$core$Maybe$Just(valeur)
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$refuserLaValeur = F2(
	function (valeur, etat) {
		var _v0 = etat.Es;
		if (!_v0.$) {
			var ouvert = _v0.a;
			var par = A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Dj;
				},
				$elm$core$List$head(
					$elm$core$List$reverse(
						A2(
							$elm$core$List$filter,
							function (a) {
								return A2(
									$elm$core$Maybe$withDefault,
									false,
									A2(
										$elm$core$Maybe$map,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$List$member(valeur),
											$elm$core$Basics$not),
										A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$propres, etat, a)));
							},
							A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$ancetres, etat, ouvert.ou)))));
			return A2(
				$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$surLaRestriction,
				A2($author$project$Components$Shared$Bibliotheque$Restriction$refuserUneValeur, valeur, par),
				etat);
		} else {
			return etat;
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDeLaRestriction = F2(
	function (geste, model) {
		return ($author$project$API$Envoi$enCours(model.l2) && A2(
			$elm$core$List$member,
			geste,
			_List_fromArray(
				[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$SortieDemandee, $author$project$Components$Shared$Drawer$Update$AbandonConfirme]))) ? _Utils_Tuple2(model, _List_Nil) : A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{
						lC: drawer,
						qF: A2(
							$elm$core$List$member,
							geste,
							_List_fromArray(
								[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$AbandonConfirme])) ? function (etat) {
							return _Utils_update(
								etat,
								{Es: $elm$core$Maybe$Nothing});
						}(model.qF) : model.qF
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.lC));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$conclureLaRestriction = F2(
	function (issue, model) {
		switch (issue.$) {
			case 0:
				var rendue = issue.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(
						rendue.sy ? A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Lire($author$project$Components$Parametrage$BibliothequeDeChamps$Update$DesPorteurs),
									$elm$core$List$singleton),
								$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$lienDesPorteurs(model.GN))) : _List_fromArray(
							[
								$author$project$Components$Parametrage$BibliothequeDeChamps$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
							])),
					A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDeLaRestriction, $author$project$Components$Shared$Drawer$Update$Fermer, model));
			case 1:
				if (issue.c.$ === 8) {
					var valeur = issue.c.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Parametrage$BibliothequeDeChamps$Update$surLesRestrictions,
							$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$refuserLaValeur(valeur),
							model),
						_List_Nil);
				} else {
					return _Utils_Tuple2(
						A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$surLesRestrictions, $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$refuser, model),
						_List_Nil);
				}
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDeLaTraduction = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{
						dR: drawer,
						JK: A2(
							$elm$core$List$member,
							geste,
							_List_fromArray(
								[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$AbandonConfirme])) ? $elm$core$Maybe$Nothing : model.JK
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.dR));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$conclureLaTraduction = F2(
	function (issue, model) {
		var _v0 = _Utils_Tuple2(issue, model.JK);
		_v0$2:
		while (true) {
			if (!_v0.b.$) {
				switch (_v0.a.$) {
					case 0:
						var _v1 = _v0.a;
						var rendue = _v1.b;
						var traduction = _v0.b.a;
						return (!_Utils_eq(traduction.rn, _List_Nil)) ? _Utils_Tuple2(model, _List_Nil) : A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(
								rendue.sy ? $author$project$Components$Parametrage$BibliothequeDeChamps$Update$relire(model) : _List_fromArray(
									[
										$author$project$Components$Parametrage$BibliothequeDeChamps$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
									])),
							A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDeLaTraduction, $author$project$Components$Shared$Drawer$Update$Fermer, model));
					case 1:
						var _v2 = _v0.a;
						var erreur = _v2.c;
						var traduction = _v0.b.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									JK: $elm$core$Maybe$Just(
										_Utils_update(
											traduction,
											{
												pZ: $elm$core$Maybe$Just(
													$author$project$Components$Parametrage$BibliothequeDeChamps$Update$libelleDuRefusDeLaDefinition(erreur)),
												rn: _List_Nil
											}))
								}),
							_List_Nil);
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return _Utils_Tuple2(model, _List_Nil);
	});
var $author$project$I18n$Textes$bibliothequeCalculRefus = A3($author$project$I18n$Traductions$texte, 'bibliotheque.calcul.refus', _List_Nil, 'Le réglage du calcul est refusé.');
var $author$project$I18n$Textes$bibliothequeCalculRefusFormule = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'bibliotheque.calcul.refus-formule',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'cause',
				$author$project$I18n$Traductions$Sous(p.bw))
			]),
		'Formule refusée : {cause}');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$libelleDuRefusDuCalcul = function (erreur) {
	if ((erreur.$ === 3) && (erreur.a === 'FormuleRefusee')) {
		var precisions = erreur.b;
		return $author$project$I18n$Textes$bibliothequeCalculRefusFormule(
			{
				bw: $author$project$I18n$Traductions$tel(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							$elm$core$Tuple$second,
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Tuple$first,
										$elm$core$Basics$eq('cause')),
									precisions)))))
			});
	} else {
		return $author$project$I18n$Textes$bibliothequeCalculRefus;
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDuCalcul = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{
						uB: A2(
							$elm$core$List$member,
							geste,
							_List_fromArray(
								[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$AbandonConfirme])) ? $elm$core$Maybe$Nothing : model.uB,
						dJ: drawer
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.dJ));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$conclureLeCalcul = F2(
	function (issue, model) {
		switch (issue.$) {
			case 0:
				var rendue = issue.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(
						rendue.sy ? $author$project$Components$Parametrage$BibliothequeDeChamps$Update$relire(model) : _List_fromArray(
							[
								$author$project$Components$Parametrage$BibliothequeDeChamps$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
							])),
					A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDuCalcul, $author$project$Components$Shared$Drawer$Update$Fermer, model));
			case 1:
				var erreur = issue.c;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLeCalcul,
						function (r) {
							return _Utils_update(
								r,
								{
									pZ: $elm$core$Maybe$Just(
										$author$project$Components$Parametrage$BibliothequeDeChamps$Update$libelleDuRefusDuCalcul(erreur))
								});
						},
						model),
					_List_Nil);
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Lot$refuse = function (lot) {
	return _Utils_update(
		lot,
		{pZ: true});
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDuLot = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{
						dP: drawer,
						n0: A2(
							$elm$core$List$member,
							geste,
							_List_fromArray(
								[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$AbandonConfirme])) ? $elm$core$Maybe$Nothing : model.n0
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.dP));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$conclureLeLot = F2(
	function (issue, model) {
		switch (issue.$) {
			case 0:
				return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDuLot, $author$project$Components$Shared$Drawer$Update$Fermer, model);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							n0: A2($elm$core$Maybe$map, $author$project$Components$Parametrage$BibliothequeDeChamps$Lot$refuse, model.n0)
						}),
					_List_Nil);
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$I18n$Textes$bibliothequeRattachementRefus = A3($author$project$I18n$Traductions$texte, 'bibliotheque.rattachement.refus', _List_Nil, 'Le rattachement n\'a pas pu être enregistré.');
var $author$project$I18n$Textes$bibliothequeRattachementRefusTypeNonPropose = A3($author$project$I18n$Traductions$texte, 'bibliotheque.rattachement.refus-type-non-propose', _List_Nil, 'Ce type de ressource ne propose pas ce type de champ : le champ ne peut pas lui être rattaché.');
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$libelleDuRefusDuRattachement = function (erreur) {
	if (erreur.$ === 6) {
		return $author$project$I18n$Textes$bibliothequeRattachementRefusTypeNonPropose;
	} else {
		return $author$project$I18n$Textes$bibliothequeRattachementRefus;
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDuRattachement = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{
						dQ: drawer,
						pN: A2(
							$elm$core$List$member,
							geste,
							_List_fromArray(
								[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$AbandonConfirme])) ? $elm$core$Maybe$Nothing : model.pN
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: !_Utils_eq(
						A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.HN;
							},
							model.pN),
						$elm$core$Maybe$Nothing)
				},
				geste,
				model.dQ));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$conclureLeRattachement = F2(
	function (issue, model) {
		switch (issue.$) {
			case 0:
				var rendue = issue.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(
						rendue.sy ? $author$project$Components$Parametrage$BibliothequeDeChamps$Update$relire(model) : _List_fromArray(
							[
								$author$project$Components$Parametrage$BibliothequeDeChamps$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
							])),
					A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDuRattachement, $author$project$Components$Shared$Drawer$Update$Fermer, model));
			case 1:
				var erreur = issue.c;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLeRattachement,
						function (r) {
							return _Utils_update(
								r,
								{
									pZ: $elm$core$Maybe$Just(
										$author$project$Components$Parametrage$BibliothequeDeChamps$Update$libelleDuRefusDuRattachement(erreur))
								});
						},
						model),
					_List_Nil);
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$ChoixAjouter = {$: 0};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$bibliothequeDe = F2(
	function (domaine, model) {
		if (!domaine) {
			return model.dq;
		} else {
			return model.eS;
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$champOuvert = function (model) {
	var _v0 = _Utils_Tuple2(
		model.dy,
		A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$bibliothequeDe, model.cC, model));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var cle = _v0.a.a;
		var bibliotheque = _v0.b.a;
		return A2(
			$elm$core$Maybe$andThen,
			function (champ) {
				return A2(
					$elm$core$Maybe$map,
					function (proposition) {
						return _Utils_Tuple2(champ, proposition);
					},
					champ.qx);
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (champ) {
						return _Utils_eq(champ.dy, cle);
					},
					bibliotheque.dw)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$ChoixLaisser = {$: 2};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$choixDe = F2(
	function (valeur, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$Parametrage$BibliothequeDeChamps$Model$ChoixLaisser,
			A2($elm$core$Dict$get, valeur, model.jN));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$estRapprochee = function (choix) {
	if (choix.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$RattacherLaListe = 0;
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$rattacheLaListe = function (model) {
	return (model.cC === 1) && (!model.cR);
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$valeursApresRattachement = function (proposition) {
	var memeLibelle = F2(
		function (a, b) {
			return _Utils_eq(
				$elm$core$String$toLower(
					$elm$core$String$trim(a)),
				$elm$core$String$toLower(
					$elm$core$String$trim(b)));
		});
	var existantes = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.Ki;
			},
			proposition.kN));
	return _Utils_ap(
		A2(
			$elm$core$List$map,
			function (v) {
				return {
					zu: $elm$core$Maybe$Just(v.zu),
					Bl: v.Bl,
					oS: false
				};
			},
			existantes),
		A2(
			$elm$core$List$map,
			function (v) {
				return {
					zu: $elm$core$Maybe$Just(v.zu),
					Bl: v.Bl,
					oS: true
				};
			},
			A2(
				$elm$core$List$filter,
				function (v) {
					return !A2(
						$elm$core$List$any,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Bl;
							},
							memeLibelle(v.Bl)),
						existantes);
				},
				proposition.Ki)));
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$effectueeDe = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function (_v0) {
			var champ = _v0.a;
			var proposition = _v0.b;
			var decisions = A2(
				$elm$core$List$map,
				function (n) {
					return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$choixDe, n.fm, model);
				},
				proposition.oH);
			return {
				iI: $elm$core$List$length(
					A2(
						$elm$core$List$filter,
						$elm$core$Basics$eq($author$project$Components$Parametrage$BibliothequeDeChamps$Model$ChoixAjouter),
						decisions)),
				Bl: champ.Bl,
				oy: $author$project$Components$Parametrage$BibliothequeDeChamps$Model$rattacheLaListe(model) ? A2(
					$elm$core$Maybe$withDefault,
					$elm$core$String$trim(model.Dj),
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.Dj;
						},
						proposition.kN)) : $elm$core$String$trim(model.Dj),
				DN: A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.DN;
							},
							$elm$core$List$length),
						A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$bibliothequeDe, model.cC, model))),
				pL: $elm$core$List$length(
					A2($elm$core$List$filter, $author$project$Components$Parametrage$BibliothequeDeChamps$Model$estRapprochee, decisions)),
				pM: $author$project$Components$Parametrage$BibliothequeDeChamps$Model$rattacheLaListe(model),
				ib: A2(
					$elm$core$List$map,
					function ($) {
						return $.Dj;
					},
					proposition.ib),
				Ki: $author$project$Components$Parametrage$BibliothequeDeChamps$Model$rattacheLaListe(model) ? $elm$core$List$length(
					$author$project$Components$Parametrage$BibliothequeDeChamps$Model$valeursApresRattachement(proposition)) : ($elm$core$List$length(proposition.Ki) + $elm$core$List$length(
					A2(
						$elm$core$List$filter,
						$elm$core$Basics$eq($author$project$Components$Parametrage$BibliothequeDeChamps$Model$ChoixAjouter),
						decisions)))
			};
		},
		$author$project$Components$Parametrage$BibliothequeDeChamps$Model$champOuvert(model));
};
var $author$project$I18n$Textes$bibliothequeRepriseRefusAutre = A3($author$project$I18n$Traductions$texte, 'bibliotheque.reprise.refus.autre', _List_Nil, 'La reprise a été refusée.');
var $author$project$I18n$Textes$bibliothequeRepriseRefusNomPris = A3($author$project$I18n$Traductions$texte, 'bibliotheque.reprise.refus.nom-pris', _List_Nil, 'Une liste porte déjà ce nom : choisissez un autre nom ou rattachez la liste existante.');
var $author$project$I18n$Textes$bibliothequeRepriseRefusPersonnel = A3($author$project$I18n$Traductions$texte, 'bibliotheque.reprise.refus.personnel', _List_Nil, 'Ce champ est une donnée personnelle : il n\'est jamais repris dans une liste partagée.');
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$libelleDuRefus = function (erreur) {
	switch (erreur.$) {
		case 0:
			return $author$project$I18n$Textes$bibliothequeRepriseRefusNomPris;
		case 1:
			return $author$project$I18n$Textes$bibliothequeRepriseRefusPersonnel;
		case 2:
			return $author$project$I18n$Textes$bibliothequeRepriseRefusAutre;
		case 3:
			return $author$project$I18n$Textes$bibliothequeRepriseRefusAutre;
		case 4:
			return $author$project$I18n$Textes$bibliothequeRepriseRefusAutre;
		case 5:
			return $author$project$I18n$Textes$bibliothequeRepriseRefusAutre;
		case 6:
			return $author$project$I18n$Textes$bibliothequeRepriseRefusAutre;
		case 7:
			return $author$project$I18n$Textes$bibliothequeRepriseRefusAutre;
		case 8:
			return $author$project$I18n$Textes$bibliothequeRepriseRefusAutre;
		default:
			return $author$project$I18n$Textes$bibliothequeRepriseRefusAutre;
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{
						kX: drawer,
						lN: _Utils_eq(geste, $author$project$Components$Shared$Drawer$Update$Fermer) ? $elm$core$Maybe$Nothing : model.lN
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.kX));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$conclureLaReprise = F2(
	function (issue, model) {
		switch (issue.$) {
			case 0:
				var rendue = issue.b;
				var relecture = rendue.sy ? $author$project$Components$Parametrage$BibliothequeDeChamps$Update$relire(model) : _List_fromArray(
					[
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
					]);
				return (model.cC === 1) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dy: $elm$core$Maybe$Nothing,
							v2: false,
							lN: $author$project$Components$Parametrage$BibliothequeDeChamps$Model$effectueeDe(model),
							pZ: $elm$core$Maybe$Nothing
						}),
					relecture) : A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(relecture),
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawer,
						$author$project$Components$Shared$Drawer$Update$Fermer,
						_Utils_update(
							model,
							{dy: $elm$core$Maybe$Nothing, v2: false, pZ: $elm$core$Maybe$Nothing})));
			case 1:
				var erreur = issue.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							pZ: $elm$core$Maybe$Just(
								$author$project$Components$Parametrage$BibliothequeDeChamps$Update$libelleDuRefus(erreur))
						}),
					_List_Nil);
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDesReglages = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{
						lA: drawer,
						eO: A2(
							$elm$core$List$member,
							geste,
							_List_fromArray(
								[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$AbandonConfirme])) ? $elm$core$Maybe$Nothing : model.eO
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.lA));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$fermerLeReglageEtRelire = F2(
	function (vuesAJour, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Basics$append(
				vuesAJour ? $author$project$Components$Parametrage$BibliothequeDeChamps$Update$relire(model) : _List_fromArray(
					[
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
					])),
			A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDesReglages, $author$project$Components$Shared$Drawer$Update$Fermer, model));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$RangerDansUneCollection = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$ReglerLeFiltrable = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$ReglerLeRecherchable = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$rangerUnChampDansUneCollection = 'ranger-un-champ-dans-une-collection';
var $author$project$API$NavLinksDictionary$reglerLeFiltrable = 'regler-le-filtrable';
var $author$project$API$NavLinksDictionary$reglerLeRecherchable = 'regler-le-recherchable';
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$relierAuChamp = F3(
	function (identifiant, liens, attendue) {
		switch (attendue.$) {
			case 8:
				var filtrable = attendue.b;
				return A2(
					$elm$core$Maybe$map,
					function (l) {
						return _Utils_Tuple2(
							A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$ReglerLeFiltrable, identifiant, filtrable),
							l);
					},
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reglerLeFiltrable, liens));
			case 9:
				var recherchable = attendue.b;
				return A2(
					$elm$core$Maybe$map,
					function (l) {
						return _Utils_Tuple2(
							A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$ReglerLeRecherchable, identifiant, recherchable),
							l);
					},
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reglerLeRecherchable, liens));
			case 11:
				var collection = attendue.b;
				return A2(
					$elm$core$Maybe$map,
					function (l) {
						return _Utils_Tuple2(
							A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$RangerDansUneCollection, identifiant, collection),
							l);
					},
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rangerUnChampDansUneCollection, liens));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$reglagesApresLaCreation = F3(
	function (identifiant, rendue, reglage) {
		return A2(
			$elm$core$List$filterMap,
			A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$relierAuChamp, identifiant, rendue.nQ),
			reglage.l$);
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$reglageAbouti = F3(
	function (rendue, reglage, model) {
		if (!_Utils_eq(reglage.rn, _List_Nil)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v0 = A2(
				$elm$core$Maybe$map,
				function (identifiant) {
					return A3($author$project$Components$Parametrage$BibliothequeDeChamps$Update$reglagesApresLaCreation, identifiant, rendue, reglage);
				},
				rendue.uN);
			if ((!_v0.$) && _v0.a.b) {
				var suite = _v0.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eO: $elm$core$Maybe$Just(
								_Utils_update(
									reglage,
									{l$: _List_Nil, rn: suite}))
						}),
					_List_Nil);
			} else {
				return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$fermerLeReglageEtRelire, rendue.sy, model);
			}
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$conclureUnReglage = F2(
	function (issue, model) {
		var _v0 = _Utils_Tuple2(issue, model.eO);
		if (!_v0.b.$) {
			switch (_v0.a.$) {
				case 0:
					var _v1 = _v0.a;
					var rendue = _v1.b;
					var reglage = _v0.b.a;
					return A3($author$project$Components$Parametrage$BibliothequeDeChamps$Update$reglageAbouti, rendue, reglage, model);
				case 1:
					switch (_v0.a.c.$) {
						case 2:
							var _v2 = _v0.a;
							var reglage = _v0.b.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										eO: $elm$core$Maybe$Just(
											_Utils_update(
												reglage,
												{l$: _List_Nil, rn: _List_Nil}))
									}),
								$author$project$Components$Parametrage$BibliothequeDeChamps$Update$relire(model));
						case 7:
							var _v3 = _v0.a;
							var autre = _v3.c.a;
							var reglage = _v0.b.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										eO: $elm$core$Maybe$Just(
											_Utils_update(
												reglage,
												{
													kA: $elm$core$Maybe$Just(autre),
													l$: _List_Nil,
													rn: _List_Nil
												}))
									}),
								_List_Nil);
						default:
							var _v4 = _v0.a;
							var reglage = _v0.b.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										eO: $elm$core$Maybe$Just(
											_Utils_update(
												reglage,
												{l$: _List_Nil, pZ: true, rn: _List_Nil}))
									}),
								_List_Nil);
					}
				default:
					var _v5 = _v0.a;
					return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$conclureLaReprise, issue, model);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$conclure = F2(
	function (issue, model) {
		return (!_Utils_eq(model.qF.Es, $elm$core$Maybe$Nothing)) ? A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$conclureLaRestriction, issue, model) : ((!_Utils_eq(model.uB, $elm$core$Maybe$Nothing)) ? A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$conclureLeCalcul, issue, model) : ((!_Utils_eq(model.n0, $elm$core$Maybe$Nothing)) ? A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$conclureLeLot, issue, model) : ((!_Utils_eq(model.pN, $elm$core$Maybe$Nothing)) ? A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$conclureLeRattachement, issue, model) : ((!_Utils_eq(model.JK, $elm$core$Maybe$Nothing)) ? A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$conclureLaTraduction, issue, model) : ((!_Utils_eq(model.wZ, $elm$core$Maybe$Nothing)) ? A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$conclureLaDefinition, issue, model) : A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$conclureUnReglage, issue, model))))));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$identifiantsDeLaListe = function (etat) {
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.Aq;
		},
		A2($elm$core$Maybe$withDefault, _List_Nil, etat.Ki));
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$transmisesA = F2(
	function (etat, noeud) {
		var retenir = F2(
			function (ancetre, valeurs) {
				var _v0 = A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$propres, etat, ancetre);
				if (!_v0.$) {
					var retenues = _v0.a;
					return A2(
						$elm$core$List$filter,
						function (id) {
							return A2($elm$core$List$member, id, retenues);
						},
						valeurs);
				} else {
					return valeurs;
				}
			});
		return A3(
			$elm$core$List$foldl,
			retenir,
			$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$identifiantsDeLaListe(etat),
			A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$ancetres, etat, noeud));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$proposees = F2(
	function (etat, noeud) {
		var _v0 = A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$propres, etat, noeud);
		if (!_v0.$) {
			var retenues = _v0.a;
			return A2(
				$elm$core$List$filter,
				function (id) {
					return A2($elm$core$List$member, id, retenues);
				},
				A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$transmisesA, etat, noeud));
		} else {
			return A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$transmisesA, etat, noeud);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$ouvrirUnNoeud = F2(
	function (id, etat) {
		var _v0 = _Utils_Tuple2(
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Aq;
						},
						$elm$core$Basics$eq(id)),
					$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$tous(etat))),
			etat.Ki);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var noeud = _v0.a.a;
			var valeurs = _v0.b.a;
			var transmises = A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$transmisesA, etat, noeud);
			var restreignants = A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$propres(etat),
					$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
				A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$ancetres, etat, noeud));
			return _Utils_update(
				etat,
				{
					jN: $elm$core$Maybe$Nothing,
					Es: $elm$core$Maybe$Just(
						{
							ou: noeud,
							al: $author$project$Components$Shared$Bibliotheque$Restriction$ouvrirSousUnParent(
								{
									th: _Utils_eq(restreignants, _List_Nil) ? _List_Nil : A2(
										$elm$core$List$cons,
										{
											Dj: etat.uN,
											w: $elm$core$List$length(valeurs)
										},
										A2(
											$elm$core$List$map,
											function (a) {
												return {
													Dj: a.Dj,
													w: $elm$core$List$length(
														A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$proposees, etat, a))
												};
											},
											restreignants)),
									uN: etat.uN,
									md: $elm$core$Maybe$Nothing,
									ey: A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.Dj;
										},
										$elm$core$List$head(
											$elm$core$List$reverse(restreignants))),
									hN: A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$propres, etat, noeud)),
									I9: noeud.Dj,
									rD: $elm$core$Maybe$Nothing,
									JP: _Utils_eq(restreignants, _List_Nil) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(transmises),
									Ki: valeurs
								})
						})
				});
		} else {
			return etat;
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$continuerLeChoix = function (etat) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		function ($) {
			return $.ou;
		},
		etat.jN);
	if (!_v0.$) {
		var id = _v0.a;
		return A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$ouvrirUnNoeud, id, etat);
	} else {
		return etat;
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$idDuBoutonAutreNoeud = 'restriction-autre-noeud';
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$fermerLeChoix = function (etat) {
	return _Utils_update(
		etat,
		{jN: $elm$core$Maybe$Nothing});
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDuChoix = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{
						kZ: drawer,
						qF: A2(
							$elm$core$List$member,
							geste,
							_List_fromArray(
								[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$AbandonConfirme])) ? $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$fermerLeChoix(model.qF) : model.qF
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.kZ));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$continuerLeChoix = function (model) {
	var suite = $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$continuerLeChoix(model.qF);
	var _v0 = suite.Es;
	if (!_v0.$) {
		var ouvert = _v0.a;
		return function (_v1) {
			var m = _v1.a;
			var effets = _v1.b;
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Basics$append(effets),
				A2(
					$author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDeLaRestriction,
					$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$idDuBoutonAutreNoeud),
					_Utils_update(
						m,
						{
							qF: function (etat) {
								return _Utils_update(
									etat,
									{
										Es: $elm$core$Maybe$Just(ouvert)
									});
							}(m.qF)
						})));
		}(
			A2(
				$author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDuChoix,
				$author$project$Components$Shared$Drawer$Update$Fermer,
				_Utils_update(
					model,
					{qF: suite})));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$API$NavLinksDictionary$apercuModification = 'apercu-modification';
var $author$project$Components$Parametrage$Vocabulaire$formatLibre = 'libre';
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$depuisLaFiche = function (fiche) {
	var texte = function (transformer) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map(transformer),
			$elm$core$Maybe$withDefault(''));
	};
	var o = fiche.o_;
	return {
		bp: fiche.bp,
		wz: A2($elm$core$Maybe$withDefault, '', o.wz),
		wA: A2($elm$core$Maybe$withDefault, '', o.wA),
		kv: A2(texte, $elm$core$String$fromInt, o.kv),
		zP: A2($elm$core$Maybe$withDefault, $author$project$Components$Parametrage$Vocabulaire$formatLibre, o.zP),
		M: A2($elm$core$Maybe$withDefault, 1, fiche.M),
		z9: o.z9,
		Bq: A2($elm$core$Maybe$withDefault, '', o.Bq),
		B$: A2(texte, $elm$core$String$fromInt, o.B$),
		Cg: A2(texte, $elm$core$String$fromFloat, o.Cg),
		Cx: A2(texte, $elm$core$String$fromFloat, o.Cx),
		CE: A2($elm$core$Maybe$withDefault, false, o.CE),
		Dj: fiche.Dj,
		FS: A2($elm$core$Maybe$withDefault, false, o.FT),
		HI: A2($elm$core$Maybe$withDefault, false, o.HI),
		IX: A2($elm$core$Maybe$withDefault, _List_Nil, o.IX),
		sa: A2($elm$core$Maybe$withDefault, '', o.sa)
	};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$optionsDeLaFiche = function (fiche) {
	return A2(
		$author$project$Components$Parametrage$BibliothequeDeChamps$Definition$lire,
		fiche,
		$author$project$Components$Parametrage$BibliothequeDeChamps$Definition$depuisLaFiche(fiche));
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$enregistrable = F2(
	function (fiche, brouillon) {
		var lues = A2($author$project$Components$Parametrage$BibliothequeDeChamps$Definition$lire, fiche, brouillon);
		return ($elm$core$String$trim(brouillon.Dj) !== '') && ((!_Utils_eq(lues, $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Illisible)) && ((!_Utils_eq(
			brouillon,
			$author$project$Components$Parametrage$BibliothequeDeChamps$Definition$depuisLaFiche(fiche))) || (!_Utils_eq(
			lues,
			$author$project$Components$Parametrage$BibliothequeDeChamps$Definition$optionsDeLaFiche(fiche)))));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$optionsAEnvoyer = F2(
	function (fiche, brouillon) {
		var _v0 = A2($author$project$Components$Parametrage$BibliothequeDeChamps$Definition$lire, fiche, brouillon);
		if (_v0.$ === 1) {
			var options = _v0.a;
			return $elm$core$Maybe$Just(options);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$optionsChangent = F2(
	function (fiche, brouillon) {
		return (!_Utils_eq(
			A2($author$project$Components$Parametrage$BibliothequeDeChamps$Definition$optionsAEnvoyer, fiche, brouillon),
			$elm$core$Maybe$Nothing)) && (!_Utils_eq(
			A2($author$project$Components$Parametrage$BibliothequeDeChamps$Definition$lire, fiche, brouillon),
			$author$project$Components$Parametrage$BibliothequeDeChamps$Definition$optionsDeLaFiche(fiche)));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$sousChampRetire = F2(
	function (fiche, brouillon) {
		var gardes = A2(
			$elm$core$List$filterMap,
			function ($) {
				return $.dy;
			},
			brouillon.IX);
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (cle) {
					return !A2($elm$core$List$member, cle, gardes);
				},
				A2(
					$elm$core$List$filterMap,
					function ($) {
						return $.dy;
					},
					$author$project$Components$Parametrage$BibliothequeDeChamps$Definition$depuisLaFiche(fiche).IX)));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$enregistrerLaDefinition = function (model) {
	var _v0 = _Utils_Tuple2(model.zo, model.wZ);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var fiche = _v0.a.a;
		var definition = _v0.b.a;
		if ($author$project$API$Envoi$enCours(model.l2) || (!A2($author$project$Components$Parametrage$BibliothequeDeChamps$Definition$enregistrable, fiche, definition.uw))) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v1 = definition.me;
			switch (_v1.$) {
				case 0:
					var _v2 = _Utils_Tuple2(
						A2($author$project$Components$Parametrage$BibliothequeDeChamps$Definition$optionsChangent, fiche, definition.uw) && _Utils_eq(
							A2($author$project$Components$Parametrage$BibliothequeDeChamps$Definition$sousChampRetire, fiche, definition.uw),
							$elm$core$Maybe$Nothing),
						A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeLaDefinition, $author$project$API$NavLinksDictionary$apercuModification, fiche));
					if (_v2.a && (!_v2.b.$)) {
						var lien = _v2.b.a;
						return _Utils_Tuple2(
							A2(
								$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLaDefinition,
								function (d) {
									return _Utils_update(
										d,
										{me: $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$ApercuDemande});
								},
								model),
							_List_fromArray(
								[
									A3(
									$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Apercevoir,
									lien,
									fiche.Aq,
									A2($author$project$Components$Parametrage$BibliothequeDeChamps$Definition$optionsAEnvoyer, fiche, definition.uw))
								]));
					} else {
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$apresLApercu, fiche, model);
					}
				case 2:
					return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$apresLApercu, fiche, model);
				case 1:
					return _Utils_Tuple2(model, _List_Nil);
				case 4:
					return definition.v2 ? A3($author$project$Components$Parametrage$BibliothequeDeChamps$Update$envoyerLaDefinition, fiche, definition, model) : _Utils_Tuple2(model, _List_Nil);
				case 5:
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLaDefinition,
							function (d) {
								return _Utils_update(
									d,
									{v2: false, me: $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Saisie, AX: $elm$core$Maybe$Nothing, pZ: $elm$core$Maybe$Nothing});
							},
							model),
						_List_Nil);
				default:
					return definition.v2 ? A3($author$project$Components$Parametrage$BibliothequeDeChamps$Update$envoyerLaDefinition, fiche, definition, model) : _Utils_Tuple2(model, _List_Nil);
			}
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$Restreindre = 0;
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$RestreindreLesValeursDUnNoeud = F3(
	function (a, b, c) {
		return {$: 16, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$RestreindreLesValeursDUnType = F3(
	function (a, b, c) {
		return {$: 18, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$enregistrer = F2(
	function (lien, etat) {
		var _v0 = etat.Es;
		if (!_v0.$) {
			var ouvert = _v0.a;
			return $author$project$Components$Shared$Bibliotheque$Restriction$enregistrable(ouvert.al) ? $elm$core$Maybe$Just(
				{
					nB: lien,
					ou: ouvert.ou,
					Ki: $author$project$Components$Shared$Bibliotheque$Restriction$retenues(ouvert.al)
				}) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$envoyerLaRestriction = F3(
	function (lien, commande, model) {
		var _v0 = A4(
			$author$project$API$Envoi$partir,
			$author$project$Components$Parametrage$BibliothequeDeChamps$Update$reglageDEnvoi,
			$elm$core$Maybe$Just(lien),
			commande,
			model.l2);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var envoi = _v1.a;
			var effets = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$enregistrerLaRestriction = function (model) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		function (lien) {
			return A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$enregistrer, lien, model.qF);
		},
		A2(
			$elm$core$Maybe$andThen,
			function (ouvert) {
				return A3($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$lienPour, 0, ouvert.ou, model.qF);
			},
			model.qF.Es));
	if (!_v0.$) {
		var demande = _v0.a;
		return A3(
			$author$project$Components$Parametrage$BibliothequeDeChamps$Update$envoyerLaRestriction,
			demande.nB,
			function () {
				var _v1 = demande.ou.M;
				if (_v1 === 1) {
					return A3($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$RestreindreLesValeursDUnType, demande.ou.c0, model.qF.dy, demande.Ki);
				} else {
					return A3(
						$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$RestreindreLesValeursDUnNoeud,
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$porteeDuNoeud(demande.ou),
						model.qF.dy,
						demande.Ki);
				}
			}(),
			model);
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$ReglerLeCalcul = F4(
	function (a, b, c, d) {
		return {$: 20, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Calcul$commande = F2(
	function (fiche, reglage) {
		return $elm$core$String$isEmpty(
			$elm$core$String$trim(reglage.zU)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A4(
				$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$ReglerLeCalcul,
				fiche.Aq,
				$elm$core$String$trim(reglage.zU),
				reglage.G$,
				reglage.fm));
	});
var $author$project$API$NavLinksDictionary$reglerLeCalcul = 'regler-le-calcul';
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$enregistrerLeCalcul = function (model) {
	var _v0 = _Utils_Tuple2(model.zo, model.uB);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var fiche = _v0.a.a;
		var reglage = _v0.b.a;
		var _v1 = A2($author$project$Components$Parametrage$BibliothequeDeChamps$Calcul$commande, fiche, reglage);
		if (!_v1.$) {
			var commande = _v1.a;
			var _v2 = A4(
				$author$project$API$Envoi$partir,
				$author$project$Components$Parametrage$BibliothequeDeChamps$Update$reglageDEnvoi,
				A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeLaDefinition, $author$project$API$NavLinksDictionary$reglerLeCalcul, fiche),
				commande,
				model.l2);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var envoi = _v3.a;
				var effets = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uB: $elm$core$Maybe$Just(
								_Utils_update(
									reglage,
									{pZ: $elm$core$Maybe$Nothing})),
							l2: envoi
						}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$RattacherAUneRessource = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Rattachement$choisie = F2(
	function (fiche, rattachement) {
		return A2(
			$elm$core$Maybe$andThen,
			function (id) {
				return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Rattachement$choisieParmi, id, fiche);
			},
			rattachement.HN);
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Rattachement$commande = F2(
	function (fiche, rattachement) {
		return A2(
			$elm$core$Maybe$map,
			function (ressource) {
				return _Utils_Tuple2(
					$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$RattacherAUneRessource(
						{uN: fiche.Aq, cC: ressource.cC, qc: rattachement.qc, HN: ressource.Aq}),
					ressource.nB);
			},
			A2($author$project$Components$Parametrage$BibliothequeDeChamps$Rattachement$choisie, fiche, rattachement));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$enregistrerLeRattachement = function (model) {
	var _v0 = _Utils_Tuple2(model.zo, model.pN);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var fiche = _v0.a.a;
		var rattachement = _v0.b.a;
		var _v1 = A2($author$project$Components$Parametrage$BibliothequeDeChamps$Rattachement$commande, fiche, rattachement);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var commande = _v2.a;
			var lien = _v2.b;
			var _v3 = A4(
				$author$project$API$Envoi$partir,
				$author$project$Components$Parametrage$BibliothequeDeChamps$Update$reglageDEnvoi,
				$elm$core$Maybe$Just(lien),
				commande,
				model.l2);
			if (!_v3.$) {
				var _v4 = _v3.a;
				var envoi = _v4.a;
				var effets = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: envoi,
							pN: $elm$core$Maybe$Just(
								_Utils_update(
									rattachement,
									{pZ: $elm$core$Maybe$Nothing}))
						}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$CreerUnChamp = F5(
	function (a, b, c, d, e) {
		return {$: 1, a: a, b: b, c: c, d: d, e: e};
	});
var $author$project$API$NavLinksDictionary$creerUnChamp = 'creer-un-champ';
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$creation = F2(
	function (reglage, champ) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A3(
				$elm$core$Maybe$map2,
				F2(
					function (typeDeChamp, l) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								A5($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$CreerUnChamp, champ.Bl, typeDeChamp, reglage.F$, champ.dy, champ.nW),
								l)
							]);
					}),
				champ.JQ,
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUnChamp, champ.nQ.h0)));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$ChangerLaPortee = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$SortirDeLaCollection = function (a) {
	return {$: 12, a: a};
};
var $author$project$API$NavLinksDictionary$sortirUnChampDeSaCollection = 'sortir-un-champ-de-sa-collection';
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$reglagesDUneDefinition = F2(
	function (reglage, champ) {
		var pour = F2(
			function (rel, voulue) {
				return A2(
					$elm$core$Maybe$map,
					function (l) {
						return _Utils_Tuple2(voulue, l);
					},
					A2($author$project$API$Liens$trouver, rel, champ.nQ.h0));
			});
		var identifiant = A2($elm$core$Maybe$withDefault, '', champ.Aq);
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					(!_Utils_eq(reglage.F$, champ.F$)) ? A2(
					pour,
					$author$project$API$NavLinksDictionary$changerLaPortee,
					A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$ChangerLaPortee, identifiant, reglage.F$)) : $elm$core$Maybe$Nothing,
					(!_Utils_eq(reglage.zG, champ.zG)) ? A2(
					pour,
					$author$project$API$NavLinksDictionary$reglerLeFiltrable,
					A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$ReglerLeFiltrable, identifiant, reglage.zG)) : $elm$core$Maybe$Nothing,
					(!_Utils_eq(reglage.G1, champ.G1)) ? A2(
					pour,
					$author$project$API$NavLinksDictionary$reglerLeRecherchable,
					A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$ReglerLeRecherchable, identifiant, reglage.G1)) : $elm$core$Maybe$Nothing,
					function () {
					if (!_Utils_eq(reglage.vD, champ.vD)) {
						var _v0 = reglage.vD;
						if (!_v0.$) {
							var collection = _v0.a;
							return A2(
								pour,
								$author$project$API$NavLinksDictionary$rangerUnChampDansUneCollection,
								A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$RangerDansUneCollection, identifiant, collection));
						} else {
							return A2(
								pour,
								$author$project$API$NavLinksDictionary$sortirUnChampDeSaCollection,
								$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$SortirDeLaCollection(identifiant));
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}()
				]));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$commandesDuReglage = function (model) {
	var _v0 = _Utils_Tuple2(model.eO, model.EE);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var reglage = _v0.a.a;
		var page = _v0.b.a;
		var _v1 = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (c) {
					return _Utils_eq(c.dy, reglage.dy);
				},
				page.dw));
		if (!_v1.$) {
			var champ = _v1.a;
			return _Utils_eq(champ.Aq, $elm$core$Maybe$Nothing) ? A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$creation, reglage, champ) : A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$reglagesDUneDefinition, reglage, champ);
		} else {
			return _List_Nil;
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$ensuiteDeLaCreation = function (model) {
	var _v0 = _Utils_Tuple2(model.eO, model.EE);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var reglage = _v0.a.a;
		var page = _v0.b.a;
		return A2(
			$elm$core$List$any,
			function (c) {
				return _Utils_eq(c.dy, reglage.dy) && _Utils_eq(c.Aq, $elm$core$Maybe$Nothing);
			},
			page.dw) ? A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					reglage.zG ? $elm$core$Maybe$Just(
					A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$ReglerLeFiltrable, '', true)) : $elm$core$Maybe$Nothing,
					reglage.G1 ? $elm$core$Maybe$Just(
					A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$ReglerLeRecherchable, '', true)) : $elm$core$Maybe$Nothing
				])) : _List_Nil;
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$enregistrerLeReglage = function (model) {
	var _v0 = _Utils_Tuple2(
		$author$project$Components$Parametrage$BibliothequeDeChamps$Model$commandesDuReglage(model),
		model.eO);
	if (_v0.a.b && (!_v0.b.$)) {
		var _v1 = _v0.a;
		var _v2 = _v1.a;
		var premiere = _v2.a;
		var lien = _v2.b;
		var suite = _v1.b;
		var reglage = _v0.b.a;
		var _v3 = A4(
			$author$project$API$Envoi$partir,
			$author$project$Components$Parametrage$BibliothequeDeChamps$Update$reglageDEnvoi,
			$elm$core$Maybe$Just(lien),
			premiere,
			model.l2);
		if (!_v3.$) {
			var _v4 = _v3.a;
			var envoi = _v4.a;
			var effets = _v4.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: envoi,
						eO: $elm$core$Maybe$Just(
							_Utils_update(
								reglage,
								{
									l$: $author$project$Components$Parametrage$BibliothequeDeChamps$Model$ensuiteDeLaCreation(model),
									pZ: false,
									rn: suite
								}))
					}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$TraduireLaDefinition = F4(
	function (a, b, c, d) {
		return {$: 14, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$languesATraduire = function (fiche) {
	return A2(
		$elm$core$List$filter,
		$elm$core$Basics$neq(fiche.A9),
		fiche.Ba);
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$commandesDeTraduction = F2(
	function (fiche, traduction) {
		var present = function (texte) {
			return ($elm$core$String$trim(texte) === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				$elm$core$String$trim(texte));
		};
		var connue = function (langue) {
			return A2(
				$elm$core$Maybe$withDefault,
				{bp: '', Bl: ''},
				A2($elm$core$Dict$get, langue, fiche.JL));
		};
		return A2(
			$elm$core$List$filterMap,
			function (langue) {
				var _v0 = A2($elm$core$Dict$get, langue, traduction.c7);
				if (!_v0.$) {
					var saisie = _v0.a;
					return _Utils_eq(
						{
							bp: $elm$core$String$trim(saisie.bp),
							Bl: $elm$core$String$trim(saisie.Bl)
						},
						connue(langue)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						A4(
							$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$TraduireLaDefinition,
							fiche.Aq,
							langue,
							present(saisie.Bl),
							present(saisie.bp)));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			$author$project$Components$Parametrage$BibliothequeDeChamps$Definition$languesATraduire(fiche));
	});
var $author$project$API$NavLinksDictionary$traduireLaDefinition = 'traduire-la-definition';
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$enregistrerLesTraductions = function (model) {
	var _v0 = _Utils_Tuple2(model.zo, model.JK);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var fiche = _v0.a.a;
		var traduction = _v0.b.a;
		var _v1 = _Utils_Tuple2(
			A2($author$project$Components$Parametrage$BibliothequeDeChamps$Definition$commandesDeTraduction, fiche, traduction),
			A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeLaDefinition, $author$project$API$NavLinksDictionary$traduireLaDefinition, fiche));
		if (_v1.a.b && (!_v1.b.$)) {
			var _v2 = _v1.a;
			var premiere = _v2.a;
			var suite = _v2.b;
			var lien = _v1.b.a;
			var _v3 = A4(
				$author$project$API$Envoi$partir,
				$author$project$Components$Parametrage$BibliothequeDeChamps$Update$reglageDEnvoi,
				$elm$core$Maybe$Just(lien),
				premiere,
				model.l2);
			if (!_v3.$) {
				var _v4 = _v3.a;
				var envoi = _v4.a;
				var effets = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: envoi,
							JK: $elm$core$Maybe$Just(
								_Utils_update(
									traduction,
									{pZ: $elm$core$Maybe$Nothing, rn: suite}))
						}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$LaisserLeChamp = 2;
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$ReprendreUnChamp = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$lien = F2(
	function (rel, champ) {
		return A2($author$project$API$Liens$trouver, rel, champ.nQ.h0);
	});
var $author$project$API$NavLinksDictionary$reprendreDesChamps = 'reprendre-des-champs';
var $author$project$API$NavLinksDictionary$reprendreDesChampsPartiesPrenantes = 'reprendre-des-champs-parties-prenantes';
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeReprendre = F2(
	function (domaine, champ) {
		if (!domaine) {
			return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$lien, $author$project$API$NavLinksDictionary$reprendreDesChamps, champ);
		} else {
			return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$lien, $author$project$API$NavLinksDictionary$reprendreDesChampsPartiesPrenantes, champ);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$reprendreLeRattachement = function (model) {
	var _v0 = _Utils_Tuple2(
		model.cR,
		$author$project$Components$Parametrage$BibliothequeDeChamps$Model$champOuvert(model));
	if ((!_v0.a) && (!_v0.b.$)) {
		var _v1 = _v0.a;
		var _v2 = _v0.b.a;
		var proposition = _v2.b;
		return proposition.nZ;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$Ajouter = {$: 0};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$Laisser = {$: 2};
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$Rapprocher = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$versLIssue = function (choix) {
	switch (choix.$) {
		case 0:
			return $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$Ajouter;
		case 1:
			var avec = choix.a;
			return $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$Rapprocher(avec);
		default:
			return $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$Laisser;
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$commande = function (model) {
	var _v0 = $author$project$Components$Parametrage$BibliothequeDeChamps$Model$champOuvert(model);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var champ = _v1.a;
		var proposition = _v1.b;
		return (model.v2 && ((model.cR !== 2) && ($elm$core$String$trim(model.Dj) !== ''))) ? A2(
			$elm$core$Maybe$map,
			function (l) {
				return _Utils_Tuple2(
					A4(
						$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$ReprendreUnChamp,
						champ.dy,
						$elm$core$String$trim(model.Dj),
						$author$project$Components$Parametrage$BibliothequeDeChamps$Model$reprendreLeRattachement(model),
						A2(
							$elm$core$List$map,
							function (n) {
								return _Utils_Tuple2(
									n.fm,
									$author$project$Components$Parametrage$BibliothequeDeChamps$Model$versLIssue(
										A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$choixDe, n.fm, model)));
							},
							proposition.oH)),
					l);
			},
			A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeReprendre, model.cC, champ)) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$envoyer = function (model) {
	var _v0 = $author$project$Components$Parametrage$BibliothequeDeChamps$Model$commande(model);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var commande = _v1.a;
		var lien = _v1.b;
		var _v2 = A4(
			$author$project$API$Envoi$partir,
			$author$project$Components$Parametrage$BibliothequeDeChamps$Update$reglageDEnvoi,
			$elm$core$Maybe$Just(lien),
			commande,
			model.l2);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var envoi = _v3.a;
			var effets = _v3.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi, pZ: $elm$core$Maybe$Nothing}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$envoyerLaSuiteDesTraductions = function (model) {
	var _v0 = _Utils_Tuple2(model.zo, model.JK);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var fiche = _v0.a.a;
		var traduction = _v0.b.a;
		var suite = traduction.rn;
		var _v1 = _Utils_Tuple2(
			suite,
			A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeLaDefinition, $author$project$API$NavLinksDictionary$traduireLaDefinition, fiche));
		if (_v1.a.b && (!_v1.b.$)) {
			var _v2 = _v1.a;
			var suivante = _v2.a;
			var reste = _v2.b;
			var lien = _v1.b.a;
			var _v3 = A4(
				$author$project$API$Envoi$partir,
				$author$project$Components$Parametrage$BibliothequeDeChamps$Update$reglageDEnvoi,
				$elm$core$Maybe$Just(lien),
				suivante,
				model.l2);
			if (!_v3.$) {
				var _v4 = _v3.a;
				var envoi = _v4.a;
				var effets = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: envoi,
							JK: $elm$core$Maybe$Just(
								_Utils_update(
									traduction,
									{rn: reste}))
						}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$envoyerLaSuiteDuReglage = F2(
	function (lu, model) {
		if (!lu.$) {
			var reglage = lu.a;
			var _v1 = reglage.rn;
			if (_v1.b) {
				var _v2 = _v1.a;
				var suivante = _v2.a;
				var lien = _v2.b;
				var reste = _v1.b;
				var _v3 = A4(
					$author$project$API$Envoi$partir,
					$author$project$Components$Parametrage$BibliothequeDeChamps$Update$reglageDEnvoi,
					$elm$core$Maybe$Just(lien),
					suivante,
					model.l2);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var envoi = _v4.a;
					var effets = _v4.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l2: envoi,
								eO: $elm$core$Maybe$Just(
									_Utils_update(
										reglage,
										{rn: reste}))
							}),
						effets);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$envoyerLaSuiteDesTraductions(model);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$envoyerLaSuite = function (model) {
	return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$envoyerLaSuiteDuReglage, model.eO, model);
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Rattachement$exiger = F2(
	function (exigence, rattachement) {
		var reglages = rattachement.qc;
		return _Utils_update(
			rattachement,
			{
				pZ: $elm$core$Maybe$Nothing,
				qc: _Utils_update(
					reglages,
					{mo: exigence})
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DeLAnnuaire = {$: 6};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DeLaStructure = {$: 5};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$lireLesRestrictions = F2(
	function (fiche, model) {
		var liste = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.nW;
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dy;
						},
						$elm$core$Basics$eq(fiche.dy)),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.dw;
							},
							model.EE)))));
		var lectures = _List_fromArray(
			[
				A2(
				$elm$core$Maybe$map,
				$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Lire($author$project$Components$Parametrage$BibliothequeDeChamps$Update$DesPorteurs),
				$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$lienDesPorteurs(model.GN)),
				A2(
				$elm$core$Maybe$map,
				$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Lire($author$project$Components$Parametrage$BibliothequeDeChamps$Update$DeLaStructure),
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$structureDuCatalogue, model.GN)),
				A2(
				$elm$core$Maybe$map,
				$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Lire($author$project$Components$Parametrage$BibliothequeDeChamps$Update$DeLAnnuaire),
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$listes, model.GN))
			]);
		return (_Utils_eq(model.qF.dy, fiche.dy) || (_Utils_eq(liste, $elm$core$Maybe$Nothing) || A2(
			$elm$core$List$any,
			$elm$core$Basics$eq($elm$core$Maybe$Nothing),
			lectures))) ? _Utils_Tuple2(model, _List_Nil) : _Utils_Tuple2(
			_Utils_update(
				model,
				{
					qF: function (vierge) {
						return _Utils_update(
							vierge,
							{uN: fiche.Dj, dy: fiche.dy});
					}($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$init)
				}),
			A2($elm$core$List$filterMap, $elm$core$Basics$identity, lectures));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ficheLue = F2(
	function (reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$ficheDecoder, reponse);
		if (!_v0.$) {
			var fiche = _v0.a;
			return _Utils_eq(model.EE, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A2(
				$author$project$Components$Parametrage$BibliothequeDeChamps$Update$lireLesRestrictions,
				fiche,
				_Utils_update(
					model,
					{
						zo: $elm$core$Maybe$Just(fiche)
					}));
		} else {
			var refus = _v0.a;
			return _Utils_Tuple2(
				model,
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$avecLesFiches = F2(
	function (lues, etat) {
		return _Utils_update(
			etat,
			{
				zu: $elm$core$Maybe$Just(lues)
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$fichesLues = F2(
	function (reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$fichesParValeurDecoder, reponse);
		if (!_v0.$) {
			var lues = _v0.a;
			return _Utils_Tuple2(
				A2(
					$author$project$Components$Parametrage$BibliothequeDeChamps$Update$surLesRestrictions,
					$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$avecLesFiches(lues),
					model),
				_List_Nil);
		} else {
			var refus = _v0.a;
			return _Utils_Tuple2(
				model,
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Calcul$formuleSaisie = F2(
	function (formule, reglage) {
		return _Utils_update(
			reglage,
			{zU: formule, pZ: $elm$core$Maybe$Nothing});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$Lever = 1;
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$LeverLaRestrictionDUnNoeud = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$LeverLaRestrictionDUnType = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$lever = F2(
	function (lien, etat) {
		var _v0 = etat.Es;
		if (!_v0.$) {
			var ouvert = _v0.a;
			return (!_Utils_eq(
				A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$propres, etat, ouvert.ou),
				$elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(
				{nB: lien, ou: ouvert.ou}) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$leverLaRestriction = function (model) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		function (lien) {
			return A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$lever, lien, model.qF);
		},
		A2(
			$elm$core$Maybe$andThen,
			function (ouvert) {
				return A3($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$lienPour, 1, ouvert.ou, model.qF);
			},
			model.qF.Es));
	if (!_v0.$) {
		var demande = _v0.a;
		return A3(
			$author$project$Components$Parametrage$BibliothequeDeChamps$Update$envoyerLaRestriction,
			demande.nB,
			function () {
				var _v1 = demande.ou.M;
				if (_v1 === 1) {
					return A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$LeverLaRestrictionDUnType, demande.ou.c0, model.qF.dy);
				} else {
					return A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$LeverLaRestrictionDUnNoeud,
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$porteeDuNoeud(demande.ou),
						model.qF.dy);
				}
			}(),
			model);
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Rattachement$lire = F2(
	function (niveau, rattachement) {
		var reglages = rattachement.qc;
		return _Utils_update(
			rattachement,
			{
				pZ: $elm$core$Maybe$Nothing,
				qc: _Utils_update(
					reglages,
					{g4: niveau})
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$avecLaListe = F2(
	function (valeurs, etat) {
		return _Utils_update(
			etat,
			{
				Ki: $elm$core$Maybe$Just(valeurs)
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$listeLue = F2(
	function (reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$listeDecoder, reponse);
		if (!_v0.$) {
			var valeurs = _v0.a;
			return _Utils_Tuple2(
				A2(
					$author$project$Components$Parametrage$BibliothequeDeChamps$Update$surLesRestrictions,
					$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$avecLaListe(valeurs),
					model),
				_List_Nil);
		} else {
			var refus = _v0.a;
			return _Utils_Tuple2(
				model,
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$listesLues = F2(
	function (_v0, model) {
		var listes = _v0.a;
		return _Utils_update(
			model,
			{n_: listes});
	});
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$listeDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Shared$EditeurDeSchema$SousChamps$Liste,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string));
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$typesVisesDecoder = A2(
	$elm$json$Json$Decode$field,
	'types',
	A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$filter(
				A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$Basics$not)),
			$elm$core$List$map($elm$core$Tuple$second)),
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				F2(
					function (archive, liste) {
						return _Utils_Tuple2(archive, liste);
					}),
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							A2($elm$json$Json$Decode$field, 'archive', $elm$json$Json$Decode$bool),
							$elm$json$Json$Decode$succeed(false)
						])),
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$Components$Shared$EditeurDeSchema$SousChamps$Liste,
					A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['libelles', 'fr']),
						$elm$json$Json$Decode$string))))));
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$listesOuTypesDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$map,
			function (listes) {
				return {n_: listes, ib: _List_Nil};
			},
			A2(
				$elm$json$Json$Decode$field,
				'listes',
				$elm$json$Json$Decode$list($author$project$Components$Shared$EditeurDeSchema$SousChamps$listeDecoder))),
			A2(
			$elm$json$Json$Decode$map,
			function (types) {
				return {n_: _List_Nil, ib: types};
			},
			$author$project$Components$Shared$EditeurDeSchema$SousChamps$typesVisesDecoder)
		]));
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DeLaReprise = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$avecLaBibliotheque = F3(
	function (domaine, apercu, model) {
		if (!domaine) {
			return _Utils_update(
				model,
				{dq: apercu});
		} else {
			return _Utils_update(
				model,
				{eS: apercu});
		}
	});
var $author$project$API$NavLinksDictionary$repriseDesChamps = 'reprise-des-champs';
var $author$project$API$NavLinksDictionary$repriseDesChampsPartiesPrenantes = 'reprise-des-champs-parties-prenantes';
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeLaReprise = F2(
	function (domaine, model) {
		var rel = function () {
			if (!domaine) {
				return $author$project$API$NavLinksDictionary$repriseDesChamps;
			} else {
				return $author$project$API$NavLinksDictionary$repriseDesChampsPartiesPrenantes;
			}
		}();
		return A2(
			$elm$core$Maybe$andThen,
			function (page) {
				return A2($author$project$API$Liens$trouver, rel, page.nQ.h0);
			},
			model.EE);
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$lireLaReprise = F2(
	function (domaine, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		var _v1 = A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeLaReprise, domaine, model);
		if (!_v1.$) {
			var lien = _v1.a;
			return _Utils_Tuple2(
				model,
				_Utils_ap(
					effets,
					_List_fromArray(
						[
							A2(
							$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Lire,
							$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DeLaReprise(domaine),
							lien)
						])));
		} else {
			return _Utils_Tuple2(
				A3($author$project$Components$Parametrage$BibliothequeDeChamps$Model$avecLaBibliotheque, domaine, $elm$core$Maybe$Nothing, model),
				effets);
		}
	});
var $author$project$API$NavLinksDictionary$ficheDuChamp = 'fiche-du-champ';
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeLaFiche = function (champ) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ficheDuChamp, champ.nQ.h0);
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$ficheOuverte = F2(
	function (id, model) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeLaFiche,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (champ) {
						return _Utils_eq(
							champ.Aq,
							$elm$core$Maybe$Just(id));
					},
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.dw;
							},
							model.EE)))));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ouvrirLaFicheDuChamp = F2(
	function (id, model) {
		var _v0 = A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$ficheOuverte, id, model);
		if (!_v0.$) {
			var lien = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{ix: $elm$core$Maybe$Nothing}),
				_List_fromArray(
					[
						A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$Lire, $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DeLaFiche, lien)
					]));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$lue = F2(
	function (reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$pageDecoder, reponse);
		if (!_v0.$) {
			var page = _v0.a;
			var apres = _Utils_update(
				model,
				{
					EE: $elm$core$Maybe$Just(page)
				});
			return function (avecLaPage) {
				return A3(
					$elm$core$List$foldl,
					$author$project$Components$Parametrage$BibliothequeDeChamps$Update$lireLaReprise,
					avecLaPage,
					_List_fromArray(
						[0, 1]));
			}(
				A2(
					$author$project$Components$Parametrage$BibliothequeDeChamps$Update$ouvrirLaFicheDuChamp,
					A2($elm$core$Maybe$withDefault, '', model.ix),
					apres));
		} else {
			var refus = _v0.a;
			return _Utils_Tuple2(
				model,
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Rattachement$masquer = F2(
	function (masque, rattachement) {
		var reglages = rattachement.qc;
		return _Utils_update(
			rattachement,
			{
				pZ: $elm$core$Maybe$Nothing,
				qc: _Utils_update(
					reglages,
					{n4: masque})
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$MasquerUnSousChamp = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$masquerUnSousChamp = 'masquer-un-sous-champ';
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$retablirLeGroupe = F2(
	function (fiche, brouillon) {
		var enregistre = $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$depuisLaFiche(fiche);
		return _Utils_update(
			brouillon,
			{HI: enregistre.HI, IX: enregistre.IX});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$masquerLeSousChamp = function (model) {
	var _v0 = model.zo;
	if (!_v0.$) {
		var fiche = _v0.a;
		var _v1 = _Utils_Tuple2(
			A2(
				$elm$core$Maybe$andThen,
				function (d) {
					return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Definition$sousChampRetire, fiche, d.uw);
				},
				model.wZ),
			A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeLaDefinition, $author$project$API$NavLinksDictionary$masquerUnSousChamp, fiche));
		if ((!_v1.a.$) && (!_v1.b.$)) {
			var sousChamp = _v1.a.a;
			var lien = _v1.b.a;
			var _v2 = A4(
				$author$project$API$Envoi$partir,
				$author$project$Components$Parametrage$BibliothequeDeChamps$Update$reglageDEnvoi,
				$elm$core$Maybe$Just(lien),
				A2($author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$MasquerUnSousChamp, fiche.Aq, sousChamp),
				model.l2);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var envoi = _v3.a;
				var effets = _v3.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLaDefinition,
						function (d) {
							return _Utils_update(
								d,
								{AX: $elm$core$Maybe$Nothing, pZ: $elm$core$Maybe$Nothing});
						},
						_Utils_update(
							model,
							{l2: envoi})),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(
				A2(
					$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLaDefinition,
					function (d) {
						return _Utils_update(
							d,
							{
								uw: A2($author$project$Components$Parametrage$BibliothequeDeChamps$Definition$retablirLeGroupe, fiche, d.uw),
								AX: $elm$core$Maybe$Nothing,
								pZ: $elm$core$Maybe$Nothing
							});
					},
					model),
				_List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Calcul$natureChoisie = F2(
	function (valeur, reglage) {
		return _Utils_update(
			reglage,
			{pZ: $elm$core$Maybe$Nothing, fm: valeur});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$ouvert = function (lecture) {
	return _Utils_update(
		$author$project$Components$Parametrage$BibliothequeDeChamps$Model$init,
		{
			np: $elm$core$Maybe$Just(lecture)
		});
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$idDuDeclencheur = function (cle) {
	return 'bibliotheque-reprendre-' + cle;
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$issueParDefaut = F2(
	function (domaine, proposition) {
		return ((domaine === 1) && (!_Utils_eq(proposition.nZ, $elm$core$Maybe$Nothing))) ? 0 : 1;
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ouvrir = F3(
	function (domaine, cle, model) {
		var champ = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (c) {
					return _Utils_eq(c.dy, cle);
				},
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.dw;
						},
						A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$bibliothequeDe, domaine, model)))));
		var _v0 = _Utils_Tuple2(
			champ,
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.qx;
				},
				champ));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var c = _v0.a.a;
			var proposition = _v0.b.a;
			return _Utils_eq(
				A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeReprendre, domaine, c),
				$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A2(
				$author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawer,
				$author$project$Components$Shared$Drawer$Update$Ouvrir(
					$author$project$Components$Parametrage$BibliothequeDeChamps$Model$idDuDeclencheur(cle)),
				_Utils_update(
					model,
					{
						jN: $elm$core$Dict$empty,
						dy: $elm$core$Maybe$Just(cle),
						v2: false,
						cC: domaine,
						lN: $elm$core$Maybe$Nothing,
						cR: A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$issueParDefaut, domaine, proposition),
						Dj: proposition.oB,
						pZ: $elm$core$Maybe$Nothing
					}));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$idModifierLaDefinition = 'bibliotheque-modifier-la-definition';
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ouvrirLaDefinition = function (model) {
	var _v0 = model.zo;
	if (!_v0.$) {
		var fiche = _v0.a;
		return _Utils_eq(
			A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeLaDefinition, $author$project$API$NavLinksDictionary$modifierLaDefinition, fiche),
			$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A2(
			$author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDeLaDefinition,
			$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Parametrage$BibliothequeDeChamps$Model$idModifierLaDefinition),
			_Utils_update(
				model,
				{
					wZ: $elm$core$Maybe$Just(
						{
							uw: $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$depuisLaFiche(fiche),
							v2: false,
							me: $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Saisie,
							AX: $elm$core$Maybe$Nothing,
							pZ: $elm$core$Maybe$Nothing
						})
				}));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$idTraduire = 'bibliotheque-traduire-la-definition';
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$ouvrirLaTraduction = function (fiche) {
	return {
		pZ: $elm$core$Maybe$Nothing,
		c7: $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (langue) {
					return _Utils_Tuple2(
						langue,
						A2(
							$elm$core$Maybe$withDefault,
							{bp: '', Bl: ''},
							A2($elm$core$Dict$get, langue, fiche.JL)));
				},
				$author$project$Components$Parametrage$BibliothequeDeChamps$Definition$languesATraduire(fiche))),
		rn: _List_Nil
	};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ouvrirLaTraduction = function (model) {
	var _v0 = model.zo;
	if (!_v0.$) {
		var fiche = _v0.a;
		return _Utils_eq(
			A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeLaDefinition, $author$project$API$NavLinksDictionary$traduireLaDefinition, fiche),
			$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A2(
			$author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDeLaTraduction,
			$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Parametrage$BibliothequeDeChamps$Model$idTraduire),
			_Utils_update(
				model,
				{
					JK: $elm$core$Maybe$Just(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Definition$ouvrirLaTraduction(fiche))
				}));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$idReglerLeCalcul = 'bibliotheque-regler-le-calcul';
var $author$project$Components$Parametrage$BibliothequeDeChamps$Calcul$ouvrir = function (calcul) {
	return {zU: calcul.zU, G$: calcul.G$, pZ: $elm$core$Maybe$Nothing, fm: calcul.fm};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ouvrirLeCalcul = function (model) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		function ($) {
			return $.uB;
		},
		model.zo);
	if (!_v0.$) {
		var calcul = _v0.a;
		return A2(
			$author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDuCalcul,
			$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Parametrage$BibliothequeDeChamps$Model$idReglerLeCalcul),
			_Utils_update(
				model,
				{
					uB: $elm$core$Maybe$Just(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Calcul$ouvrir(calcul))
				}));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$ouvrirLeChoix = function (etat) {
	return _Utils_update(
		etat,
		{
			jN: $elm$core$Maybe$Just(
				{md: $elm$core$Maybe$Nothing, ou: $elm$core$Maybe$Nothing}),
			Es: $elm$core$Maybe$Nothing
		});
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DeLApercuDuLot = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$idAppliquerAuxReferences = 'bibliotheque-appliquer-aux-references';
var $author$project$Components$Parametrage$BibliothequeDeChamps$Lot$lienDeLApercu = F2(
	function (fiche, id) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2($author$project$API$NavLinksDictionary$variableUid, id)
					])),
			A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$apercuDuCalculEnLot, fiche.nQ.gF));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Lot$ouvrir = function (fiche) {
	var types = A2(
		$elm$core$List$map,
		function (t) {
			return {tq: $elm$core$Maybe$Nothing, Aq: t.Aq, Ax: false, Dj: t.Dj};
		},
		A2(
			$elm$core$List$filter,
			function (t) {
				return t.cC === 'catalogue';
			},
			fiche.JY));
	return {
		vd: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Aq;
				},
				$elm$core$List$head(types))),
		pZ: false,
		ib: types
	};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ouvrirLeLot = function (model) {
	var _v0 = model.zo;
	if (!_v0.$) {
		var fiche = _v0.a;
		if (_Utils_eq(
			$author$project$Components$Parametrage$BibliothequeDeChamps$Lot$lienDeLaCommande(fiche),
			$elm$core$Maybe$Nothing)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var lot = $author$project$Components$Parametrage$BibliothequeDeChamps$Lot$ouvrir(fiche);
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Basics$append(
					A2(
						$elm$core$List$filterMap,
						function (t) {
							return A2(
								$elm$core$Maybe$map,
								$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Lire(
									$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DeLApercuDuLot(t.Aq)),
								A2($author$project$Components$Parametrage$BibliothequeDeChamps$Lot$lienDeLApercu, fiche, t.Aq));
						},
						lot.ib)),
				A2(
					$author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDuLot,
					$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Parametrage$BibliothequeDeChamps$Model$idAppliquerAuxReferences),
					_Utils_update(
						model,
						{
							n0: $elm$core$Maybe$Just(lot)
						})));
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$I18n$Textes$bibliothequeGroupeAction = A3($author$project$I18n$Traductions$texte, 'bibliotheque.groupe.action', _List_Nil, 'Créer le champ');
var $author$project$I18n$Textes$bibliothequeGroupeNom = A3($author$project$I18n$Traductions$texte, 'bibliotheque.groupe.nom', _List_Nil, 'Nom du champ');
var $author$project$I18n$Textes$bibliothequeGroupeSousTitre = A3($author$project$I18n$Traductions$texte, 'bibliotheque.groupe.sous-titre', _List_Nil, 'Un nom, une portée, une collection et un type de champ.');
var $author$project$I18n$Textes$bibliothequeGroupeTitre = A3($author$project$I18n$Traductions$texte, 'bibliotheque.groupe.titre', _List_Nil, 'Nouveau champ');
var $author$project$I18n$Textes$bibliothequeGroupeType = A3($author$project$I18n$Traductions$texte, 'bibliotheque.groupe.type', _List_Nil, 'Type de champ');
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeCreation = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		function (page) {
			return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUnChamp, page.nQ.h0);
		},
		model.EE);
};
var $author$project$I18n$Textes$bibliothequePorteePartiesPrenantes = A3($author$project$I18n$Traductions$texte, 'bibliotheque.portee.parties-prenantes', _List_Nil, 'Parties prenantes');
var $author$project$I18n$Textes$bibliothequePorteeProduits = A3($author$project$I18n$Traductions$texte, 'bibliotheque.portee.produits', _List_Nil, 'Produits');
var $author$project$I18n$Textes$bibliothequePorteeToutes = A3($author$project$I18n$Traductions$texte, 'bibliotheque.portee.toutes', _List_Nil, 'Toutes');
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$porteeDuFiltre = function (model) {
	var _v0 = model.F$;
	switch (_v0) {
		case 0:
			return {fv: $author$project$I18n$Textes$bibliothequePorteeToutes, F$: 'catalogue-et-parties-prenantes'};
		case 1:
			return {fv: $author$project$I18n$Textes$bibliothequePorteeProduits, F$: 'catalogue'};
		default:
			return {fv: $author$project$I18n$Textes$bibliothequePorteePartiesPrenantes, F$: 'parties-prenantes'};
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DesListesDuGroupe = {$: 9};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DesListesDuNouveauChamp = {$: 10};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$depuisLeNouveauChamp = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DemanderProcessUid])));
			case 1:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$Lire, $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DesListesDuNouveauChamp, lien)
							])));
			case 2:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								A3($author$project$Components$Parametrage$BibliothequeDeChamps$Update$Envoyer, lien, processUid, commande)
							])));
			case 3:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Components$Parametrage$BibliothequeDeChamps$Update$PlacerFocus(cible)
							])));
			case 4:
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Reconnecter])));
			case 5:
				var vuesAJour = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						vuesAJour ? $author$project$Components$Parametrage$BibliothequeDeChamps$Update$relire(model) : _List_fromArray(
							[
								$author$project$Components$Parametrage$BibliothequeDeChamps$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
							])));
			case 7:
				return _Utils_Tuple2(model, effets);
			default:
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Lire($author$project$Components$Parametrage$BibliothequeDeChamps$Update$DesListesDuGroupe),
									$elm$core$List$singleton),
								A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$listes, model.GN)))));
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$surLeNouveauChamp = F2(
	function (geste, model) {
		return function (_v0) {
			var nouveauChamp = _v0.a;
			var effets = _v0.b;
			return A3(
				$elm$core$List$foldl,
				$author$project$Components$Parametrage$BibliothequeDeChamps$Update$depuisLeNouveauChamp,
				_Utils_Tuple2(
					_Utils_update(
						model,
						{oP: nouveauChamp}),
					_List_Nil),
				effets);
		}(
			A2($author$project$Components$Parametrage$NouveauChamp$Update$update, geste, model.oP));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ouvrirLeNouveauChamp = F2(
	function (collections, model) {
		var _v0 = _Utils_Tuple2(
			$author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeCreation(model),
			model.EE);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var lien = _v0.a.a;
			var page = _v0.b.a;
			return A2(
				$author$project$Components$Parametrage$BibliothequeDeChamps$Update$surLeNouveauChamp,
				$author$project$Components$Parametrage$NouveauChamp$Update$Ouvert(
					{
						un: $elm$core$Maybe$Nothing,
						uY: _List_Nil,
						vE: collections,
						R: {fs: $author$project$I18n$Textes$bibliothequeGroupeAction, Dj: $author$project$I18n$Textes$bibliothequeGroupeNom, JR: $author$project$I18n$Textes$bibliothequeGroupeType},
						Bz: lien,
						BF: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$listes, model.GN),
						F$: $author$project$Components$Parametrage$BibliothequeDeChamps$Model$porteeDuFiltre(model).F$,
						F1: false,
						c0: _List_Nil,
						pN: $elm$core$Maybe$Nothing,
						aO: $author$project$I18n$Textes$bibliothequeGroupeSousTitre,
						h6: $author$project$I18n$Textes$bibliothequeGroupeTitre,
						ib: model.ib,
						J_: page.J_,
						sb: page.sb
					}),
				model);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$idRattacher = 'bibliotheque-rattacher-a-une-ressource';
var $author$project$Components$Parametrage$BibliothequeDeChamps$Rattachement$ouvrir = {
	pZ: $elm$core$Maybe$Nothing,
	qc: {xD: false, mo: $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceFacultative, n4: false, g4: 'essentiel'},
	HN: $elm$core$Maybe$Nothing
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ouvrirLeRattachement = function (model) {
	var _v0 = model.zo;
	if (!_v0.$) {
		var fiche = _v0.a;
		return _Utils_eq(fiche.HQ, _List_Nil) ? _Utils_Tuple2(model, _List_Nil) : A2(
			$author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDuRattachement,
			$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Parametrage$BibliothequeDeChamps$Model$idRattacher),
			_Utils_update(
				model,
				{
					pN: $elm$core$Maybe$Just($author$project$Components$Parametrage$BibliothequeDeChamps$Rattachement$ouvrir)
				}));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$idDuReglage = function (cle) {
	return 'bibliotheque-regler-' + cle;
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$ouvrirLeReglage = function (champ) {
	return {dy: champ.dy, vD: champ.vD, kA: $elm$core$Maybe$Nothing, l$: _List_Nil, zG: champ.zG, F$: champ.F$, G1: champ.G1, pZ: false, rn: _List_Nil};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$reglable = function (champ) {
	var _v0 = champ.Aq;
	if (!_v0.$) {
		return A2(
			$elm$core$List$any,
			function (rel) {
				return !_Utils_eq(
					A2($author$project$API$Liens$trouver, rel, champ.nQ.h0),
					$elm$core$Maybe$Nothing);
			},
			_List_fromArray(
				[$author$project$API$NavLinksDictionary$reglerLeFiltrable, $author$project$API$NavLinksDictionary$reglerLeRecherchable, $author$project$API$NavLinksDictionary$changerLaPortee, $author$project$API$NavLinksDictionary$rangerUnChampDansUneCollection, $author$project$API$NavLinksDictionary$sortirUnChampDeSaCollection]));
	} else {
		return (!_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUnChamp, champ.nQ.h0),
			$elm$core$Maybe$Nothing)) && (!_Utils_eq(champ.JQ, $elm$core$Maybe$Nothing));
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ouvrirLeReglage = F2(
	function (cle, model) {
		var _v0 = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (c) {
					return _Utils_eq(c.dy, cle);
				},
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.dw;
						},
						model.EE))));
		if (!_v0.$) {
			var champ = _v0.a;
			return $author$project$Components$Parametrage$BibliothequeDeChamps$Model$reglable(champ) ? A2(
				$author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDesReglages,
				$author$project$Components$Shared$Drawer$Update$Ouvrir(
					$author$project$Components$Parametrage$BibliothequeDeChamps$Model$idDuReglage(cle)),
				_Utils_update(
					model,
					{
						eO: $elm$core$Maybe$Just(
							$author$project$Components$Parametrage$BibliothequeDeChamps$Model$ouvrirLeReglage(champ))
					})) : _Utils_Tuple2(model, _List_Nil);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$idDuBoutonModifier = function (noeud) {
	return 'restriction-modifier-' + noeud;
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ouvrirUnNoeud = F2(
	function (id, model) {
		var ouvert = _Utils_update(
			model,
			{
				qF: A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$ouvrirUnNoeud, id, model.qF)
			});
		return _Utils_eq(ouvert.qF.Es, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A2(
			$author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDeLaRestriction,
			$author$project$Components$Shared$Drawer$Update$Ouvrir(
				$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$idDuBoutonModifier(id)),
			ouvert);
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Rattachement$personnelle = F2(
	function (donneePersonnelle, rattachement) {
		var reglages = rattachement.qc;
		return _Utils_update(
			rattachement,
			{
				pZ: $elm$core$Maybe$Nothing,
				qc: _Utils_update(
					reglages,
					{xD: donneePersonnelle})
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DesFichesParValeur = {$: 8};
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$avecLesPorteurs = F2(
	function (lu, etat) {
		return _Utils_update(
			etat,
			{
				dZ: lu.zA,
				nQ: lu.nQ,
				F3: $elm$core$Maybe$Just(lu.F3),
				ib: lu.ib
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$lienDeFiches = function (etat) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$API$Liens$resoudre(
			_List_fromArray(
				[
					_Utils_Tuple2('champ', etat.dy)
				])),
		etat.dZ);
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$porteursLus = F2(
	function (reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$informationsDecoder, reponse);
		if (!_v0.$) {
			var lu = _v0.a;
			var suivant = A2(
				$author$project$Components$Parametrage$BibliothequeDeChamps$Update$surLesRestrictions,
				$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$avecLesPorteurs(lu),
				model);
			return _Utils_Tuple2(
				suivant,
				_Utils_eq(suivant.qF.zu, $elm$core$Maybe$Nothing) ? A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Lire($author$project$Components$Parametrage$BibliothequeDeChamps$Update$DesFichesParValeur),
							$elm$core$List$singleton),
						$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$lienDeFiches(suivant.qF))) : _List_Nil);
		} else {
			var refus = _v0.a;
			return _Utils_Tuple2(
				model,
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Calcul$recalculChoisi = F2(
	function (recalcul, reglage) {
		return _Utils_update(
			reglage,
			{G$: recalcul, pZ: $elm$core$Maybe$Nothing});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$rendueDuLotDecoder = A2(
	$elm$json$Json$Decode$map,
	function (_v0) {
		return {uN: $elm$core$Maybe$Nothing, dw: _List_Nil, nQ: _List_Nil, sy: true};
	},
	A2($elm$json$Json$Decode$field, 'references', $elm$json$Json$Decode$int));
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$reglageDeLaReponse = function (model) {
	var _v0 = model.l2;
	if ((_v0.$ === 2) && (_v0.b.$ === 21)) {
		var _v1 = _v0.b;
		return _Utils_update(
			$author$project$Components$Parametrage$BibliothequeDeChamps$Update$reglageDEnvoi,
			{qv: $author$project$Components$Parametrage$BibliothequeDeChamps$API$WriteAPIModel$rendueDuLotDecoder});
	} else {
		return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$reglageDEnvoi;
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$repriseLue = F3(
	function (domaine, reponse, model) {
		if (_Utils_eq(
			A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeLaReprise, domaine, model),
			$elm$core$Maybe$Nothing)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$bibliothequeDecoder, reponse);
			if (!_v0.$) {
				var bibliotheque = _v0.a;
				return _Utils_Tuple2(
					A3(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Model$avecLaBibliotheque,
						domaine,
						$elm$core$Maybe$Just(bibliotheque),
						model),
					_List_Nil);
			} else {
				var refus = _v0.a;
				return _Utils_Tuple2(
					model,
					(refus.ri === 401) ? _List_fromArray(
						[$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Reconnecter]) : _List_Nil);
			}
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$saisir = F3(
	function (option, texte, brouillon) {
		switch (option) {
			case 0:
				return _Utils_update(
					brouillon,
					{Dj: texte});
			case 1:
				return _Utils_update(
					brouillon,
					{bp: texte});
			case 2:
				return _Utils_update(
					brouillon,
					{
						M: A2(
							$elm$core$Maybe$withDefault,
							brouillon.M,
							$author$project$Components$Shared$GenreDuNom$deCode(texte))
					});
			case 3:
				return _Utils_update(
					brouillon,
					{B$: texte});
			case 4:
				return _Utils_update(
					brouillon,
					{zP: texte});
			case 5:
				return _Utils_update(
					brouillon,
					{sa: texte});
			case 6:
				return _Utils_update(
					brouillon,
					{kv: texte});
			case 7:
				return _Utils_update(
					brouillon,
					{Cx: texte});
			case 8:
				return _Utils_update(
					brouillon,
					{Cg: texte});
			case 9:
				return _Utils_update(
					brouillon,
					{wA: texte});
			default:
				return _Utils_update(
					brouillon,
					{wz: texte});
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$saisirLaDefinition = F3(
	function (option, texte, definition) {
		return _Utils_update(
			definition,
			{
				uw: A3($author$project$Components$Parametrage$BibliothequeDeChamps$Definition$saisir, option, texte, definition.uw),
				v2: false,
				me: $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Saisie,
				pZ: $elm$core$Maybe$Nothing
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$avecLaListeDuCatalogue = F3(
	function (liste, listes, etat) {
		var _v0 = _Utils_Tuple2(
			etat.Ki,
			A2(
				$elm$core$Maybe$andThen,
				function (id) {
					return $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$first,
								$elm$core$Basics$eq(id)),
							listes));
				},
				liste));
		if ((_v0.a.$ === 1) && (!_v0.b.$)) {
			var _v1 = _v0.a;
			var _v2 = _v0.b.a;
			var valeurs = _v2.b;
			return _Utils_update(
				etat,
				{
					Ki: $elm$core$Maybe$Just(valeurs)
				});
		} else {
			return etat;
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$DeTypologie = 0;
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$porteurDe_ = function (valeur) {
	if (!valeur.$) {
		var id = valeur.a;
		return $author$project$Catalogue$Identifiants$valeurIdToString(id);
	} else {
		var id = valeur.a;
		return $author$project$Catalogue$Identifiants$elementIdToString(id);
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$noeudsDe = function (typologie) {
	var _v0 = $author$project$Catalogue$Chemin$tous(typologie.jK);
	var etages = _v0.a;
	var noeuds = _v0.b;
	var designation = function (id) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Traductions$tel(id),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.xt;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(id)),
						etages))));
	};
	var formesDe = function (id) {
		return A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.zS;
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Aq;
						},
						$elm$core$Basics$eq(id)),
					etages)));
	};
	return A2(
		$elm$core$List$map,
		function (noeud) {
			return {
				vj: typologie.Aq,
				md: designation(noeud.md),
				zS: formesDe(noeud.md),
				M: 0,
				Aq: noeud.Aq,
				Dj: noeud.Dj,
				ey: noeud.ey,
				c0: $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$porteurDe_(noeud.fm),
				r3: typologie.Dj
			};
		},
		noeuds);
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$avecLaStructure = F2(
	function (typologies, etat) {
		return _Utils_update(
			etat,
			{
				Di: $elm$core$Maybe$Just(
					A2($elm$core$List$concatMap, $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$noeudsDe, typologies))
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$listesDuCatalogueDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$filter(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.wE;
				},
				$elm$core$Basics$not)),
		$elm$core$List$map(
			function (classification) {
				return _Utils_Tuple2(
					$author$project$Catalogue$Identifiants$classificationIdToString(classification.Aq),
					A2(
						$elm$core$List$map,
						function (v) {
							return {
								Aq: $author$project$Catalogue$Identifiants$valeurIdToString(v.Aq),
								Bl: v.R.zX
							};
						},
						A2(
							$elm$core$List$sortBy,
							function ($) {
								return $.bY;
							},
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.tI;
									},
									$elm$core$Basics$not),
								classification.Ki))));
			})),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'classifications',
				$elm$json$Json$Decode$list($author$project$Catalogue$API$QueryAPIModel$classificationDecoder)),
				$elm$json$Json$Decode$succeed(_List_Nil)
			])));
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$structureLue = F2(
	function (reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$structureDecoder, reponse);
		if (!_v0.$) {
			var lu = _v0.a;
			var listes = A2(
				$elm$core$Result$withDefault,
				_List_Nil,
				A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$BibliothequeDeChamps$API$RestrictionsAPIModel$listesDuCatalogueDecoder, reponse));
			var liste = A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.nW;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dy;
							},
							$elm$core$Basics$eq(model.qF.dy)),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.dw;
								},
								model.EE)))));
			return _Utils_Tuple2(
				A2(
					$author$project$Components$Parametrage$BibliothequeDeChamps$Update$surLesRestrictions,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$avecLaStructure(lu),
						A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$avecLaListeDuCatalogue, liste, listes)),
					model),
				_List_Nil);
		} else {
			var refus = _v0.a;
			return _Utils_Tuple2(
				model,
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$toutCocher = $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$surLaRestriction($author$project$Components$Shared$Bibliotheque$Restriction$toutCocher);
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$toutDecocher = $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$surLaRestriction($author$project$Components$Shared$Bibliotheque$Restriction$toutDecocher);
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$traduire = F3(
	function (langue, changer, traduction) {
		return _Utils_update(
			traduction,
			{
				pZ: $elm$core$Maybe$Nothing,
				c7: A3(
					$elm$core$Dict$update,
					langue,
					$elm$core$Maybe$map(changer),
					traduction.c7)
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$valeurDesFichesChoisie = F2(
	function (id, etat) {
		return _Utils_update(
			etat,
			{
				fn: $elm$core$Maybe$Just(id)
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$voirLeParent = function (etat) {
	var _v0 = etat.Es;
	if (!_v0.$) {
		var ouvert = _v0.a;
		return A2(
			$elm$core$Maybe$withDefault,
			etat,
			A2(
				$elm$core$Maybe$map,
				function (parent) {
					return A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$ouvrirUnNoeud, parent.Aq, etat);
				},
				$elm$core$List$head(
					$elm$core$List$reverse(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$propres(etat),
								$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
							A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$ancetres, etat, ouvert.ou))))));
	} else {
		return etat;
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var liens = msg.a;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$bibliothequeDeChamps, liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						function (ouvert) {
							return _Utils_update(
								ouvert,
								{GN: liens});
						}(
							$author$project$Components$Parametrage$BibliothequeDeChamps$Model$ouvert(lecture)),
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DemanderProcessUid,
									A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$Lire, $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DeLaBibliotheque, lecture)
								]),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Lire($author$project$Components$Parametrage$BibliothequeDeChamps$Update$DesTypesDuGroupe),
										$elm$core$List$singleton),
									A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$typesDePartiePrenante, liens)))));
				} else {
					return _Utils_Tuple2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$init, _List_Nil);
				}
			case 1:
				var octets = msg.a;
				return $author$project$Components$Parametrage$NouveauChamp$Model$ouvert(model.oP) ? A2(
					$author$project$Components$Parametrage$BibliothequeDeChamps$Update$surLeNouveauChamp,
					$author$project$Components$Parametrage$NouveauChamp$Update$ProcessUidRecu(octets),
					model) : $author$project$Components$Parametrage$BibliothequeDeChamps$Update$envoyerLaSuite(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}));
			case 2:
				switch (msg.a.$) {
					case 0:
						var _v2 = msg.a;
						var reponse = msg.b;
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$lue, reponse, model);
					case 1:
						var domaine = msg.a.a;
						var reponse = msg.b;
						return A3($author$project$Components$Parametrage$BibliothequeDeChamps$Update$repriseLue, domaine, reponse, model);
					case 2:
						var _v3 = msg.a;
						var reponse = msg.b;
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$ficheLue, reponse, model);
					case 3:
						var _v4 = msg.a;
						var reponse = msg.b;
						return (!_Utils_eq(model.qF.Es, $elm$core$Maybe$Nothing)) ? A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$apercuDeRestrictionLu, reponse, model) : A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$apercuLu, reponse, model);
					case 4:
						var _v5 = msg.a;
						var reponse = msg.b;
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$porteursLus, reponse, model);
					case 5:
						var _v6 = msg.a;
						var reponse = msg.b;
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$structureLue, reponse, model);
					case 6:
						var _v7 = msg.a;
						var reponse = msg.b;
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$annuaireLu, reponse, model);
					case 7:
						var _v8 = msg.a;
						var reponse = msg.b;
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$listeLue, reponse, model);
					case 8:
						var _v9 = msg.a;
						var reponse = msg.b;
						return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$fichesLues, reponse, model);
					case 11:
						var id = msg.a.a;
						var reponse = msg.b;
						return _Utils_Tuple2(
							A3($author$project$Components$Parametrage$BibliothequeDeChamps$Update$apercuDuLotLu, id, reponse, model),
							_List_Nil);
					case 9:
						var _v10 = msg.a;
						var reponse = msg.b;
						var _v11 = A2(
							$author$project$API$Reponse$lire,
							A3($elm$json$Json$Decode$map2, $elm$core$Tuple$pair, $author$project$Components$Shared$EditeurDeSchema$SousChamps$listesDecoder, $author$project$API$Liens$deLaRessource),
							reponse);
						if (!_v11.$) {
							var listes = _v11.a;
							return _Utils_Tuple2(
								A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$listesLues, listes, model),
								_List_Nil);
						} else {
							var refus = _v11.a;
							return _Utils_Tuple2(
								model,
								(refus.ri === 401) ? _List_fromArray(
									[$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Reconnecter]) : _List_Nil);
						}
					case 10:
						var _v12 = msg.a;
						var reponse = msg.b;
						return A2(
							$author$project$Components$Parametrage$BibliothequeDeChamps$Update$surLeNouveauChamp,
							$author$project$Components$Parametrage$NouveauChamp$Update$ListesLues(reponse),
							model);
					default:
						var _v13 = msg.a;
						var reponse = msg.b;
						var _v14 = A2($author$project$API$Reponse$lire, $author$project$Components$Shared$EditeurDeSchema$SousChamps$listesOuTypesDecoder, reponse);
						if (!_v14.$) {
							var lus = _v14.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{ib: lus.ib}),
								_List_Nil);
						} else {
							var refus = _v14.a;
							return _Utils_Tuple2(
								model,
								(refus.ri === 401) ? _List_fromArray(
									[$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Reconnecter]) : _List_Nil);
						}
				}
			case 70:
				var collections = msg.a;
				return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$ouvrirLeNouveauChamp, collections, model);
			case 71:
				var geste = msg.a;
				return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$surLeNouveauChamp, geste, model);
			case 56:
				var geste = msg.a;
				return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDeLaRestriction, geste, model);
			case 57:
				var geste = msg.a;
				return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDuChoix, geste, model);
			case 58:
				var id = msg.a;
				return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$ouvrirUnNoeud, id, model);
			case 59:
				return A2(
					$author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDuChoix,
					$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$idDuBoutonAutreNoeud),
					_Utils_update(
						model,
						{
							qF: $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$ouvrirLeChoix(model.qF)
						}));
			case 60:
				var etage = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$surLesRestrictions,
						$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$choisirLEtage(etage),
						model),
					_List_Nil);
			case 61:
				var id = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$surLesRestrictions,
						$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$choisirLeNoeud(id),
						model),
					_List_Nil);
			case 62:
				return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$continuerLeChoix(model);
			case 63:
				var id = msg.a;
				var oui = msg.b;
				return A2(
					$author$project$Components$Parametrage$BibliothequeDeChamps$Update$chezLApercu,
					A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$cocher, id, oui),
					model);
			case 64:
				return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$chezLApercu, $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$toutCocher, model);
			case 65:
				return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$chezLApercu, $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$toutDecocher, model);
			case 66:
				return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$enregistrerLaRestriction(model);
			case 67:
				return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$leverLaRestriction(model);
			case 68:
				return _Utils_Tuple2(
					A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$surLesRestrictions, $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$voirLeParent, model),
					_List_Nil);
			case 69:
				var id = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$surLesRestrictions,
						$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$valeurDesFichesChoisie(id),
						model),
					_List_Nil);
			case 3:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Parametrage$BibliothequeDeChamps$Update$relire(model));
			case 4:
				var geste = msg.a;
				return ($author$project$API$Envoi$enCours(model.l2) && A2(
					$elm$core$List$member,
					geste,
					_List_fromArray(
						[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$SortieDemandee, $author$project$Components$Shared$Drawer$Update$AbandonConfirme]))) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawer, geste, model);
			case 5:
				var domaine = msg.a;
				var cle = msg.b;
				return A3($author$project$Components$Parametrage$BibliothequeDeChamps$Update$ouvrir, domaine, cle, model);
			case 13:
				var portee = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{F$: portee}),
					_List_Nil);
			case 14:
				var cle = msg.a;
				return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$ouvrirLeReglage, cle, model);
			case 15:
				var id = msg.a;
				return A2(
					$author$project$Components$Parametrage$BibliothequeDeChamps$Update$ouvrirLaFicheDuChamp,
					id,
					_Utils_update(
						model,
						{
							ix: $elm$core$Maybe$Just(id)
						}));
			case 16:
				var geste = msg.a;
				return ($author$project$API$Envoi$enCours(model.l2) && A2(
					$elm$core$List$member,
					geste,
					_List_fromArray(
						[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$SortieDemandee, $author$project$Components$Shared$Drawer$Update$AbandonConfirme]))) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDesReglages, geste, model);
			case 17:
				var portee = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLeReglage,
						function (r) {
							return _Utils_update(
								r,
								{F$: portee, pZ: false});
						},
						model),
					_List_Nil);
			case 18:
				var coche = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLeReglage,
						function (r) {
							return _Utils_update(
								r,
								{zG: coche, pZ: false});
						},
						model),
					_List_Nil);
			case 19:
				var coche = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLeReglage,
						function (r) {
							return _Utils_update(
								r,
								{G1: coche, pZ: false});
						},
						model),
					_List_Nil);
			case 20:
				var collection = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLeReglage,
						function (r) {
							return _Utils_update(
								r,
								{vD: collection, kA: $elm$core$Maybe$Nothing, pZ: false});
						},
						model),
					_List_Nil);
			case 21:
				return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$enregistrerLeReglage(model);
			case 22:
				var geste = msg.a;
				return ($author$project$API$Envoi$enCours(model.l2) && A2(
					$elm$core$List$member,
					geste,
					_List_fromArray(
						[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$SortieDemandee, $author$project$Components$Shared$Drawer$Update$AbandonConfirme]))) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDeLaDefinition, geste, model);
			case 23:
				return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ouvrirLaDefinition(model);
			case 24:
				var option = msg.a;
				var texte = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLaDefinition,
						A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$saisirLaDefinition, option, texte),
						model),
					_List_Nil);
			case 25:
				var geste = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLaDefinition,
						function (d) {
							return A2(
								$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLeBrouillon,
								function (b) {
									return _Utils_update(
										b,
										{
											IX: A2($author$project$Components$Shared$EditeurDeSchema$SousChamps$appliquer, geste, b.IX)
										});
								},
								d);
						},
						model),
					_List_Nil);
			case 28:
				var oui = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLaDefinition,
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLeBrouillon(
							function (b) {
								return _Utils_update(
									b,
									{CE: oui});
							}),
						model),
					_List_Nil);
			case 27:
				var oui = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLaDefinition,
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLeBrouillon(
							function (b) {
								return _Utils_update(
									b,
									{FS: oui});
							}),
						model),
					_List_Nil);
			case 26:
				var oui = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLaDefinition,
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLeBrouillon(
							function (b) {
								return _Utils_update(
									b,
									{HI: oui});
							}),
						model),
					_List_Nil);
			case 29:
				return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$masquerLeSousChamp(model);
			case 30:
				return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$enregistrerLaDefinition(model);
			case 31:
				var coche = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLaDefinition,
						function (d) {
							return _Utils_update(
								d,
								{v2: coche});
						},
						model),
					_List_Nil);
			case 32:
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLaDefinition,
						function (d) {
							return _Utils_update(
								d,
								{v2: false, me: $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Saisie, AX: $elm$core$Maybe$Nothing, pZ: $elm$core$Maybe$Nothing});
						},
						model),
					_List_Nil);
			case 33:
				var geste = msg.a;
				return ($author$project$API$Envoi$enCours(model.l2) && A2(
					$elm$core$List$member,
					geste,
					_List_fromArray(
						[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$SortieDemandee, $author$project$Components$Shared$Drawer$Update$AbandonConfirme]))) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDeLaTraduction, geste, model);
			case 34:
				return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ouvrirLaTraduction(model);
			case 35:
				var langue = msg.a;
				var texte = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLaTraduction,
						A2(
							$author$project$Components$Parametrage$BibliothequeDeChamps$Definition$traduire,
							langue,
							function (t) {
								return _Utils_update(
									t,
									{Bl: texte});
							}),
						model),
					_List_Nil);
			case 36:
				var langue = msg.a;
				var texte = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLaTraduction,
						A2(
							$author$project$Components$Parametrage$BibliothequeDeChamps$Definition$traduire,
							langue,
							function (t) {
								return _Utils_update(
									t,
									{bp: texte});
							}),
						model),
					_List_Nil);
			case 37:
				return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$enregistrerLesTraductions(model);
			case 38:
				var geste = msg.a;
				return ($author$project$API$Envoi$enCours(model.l2) && A2(
					$elm$core$List$member,
					geste,
					_List_fromArray(
						[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$SortieDemandee, $author$project$Components$Shared$Drawer$Update$AbandonConfirme]))) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDuRattachement, geste, model);
			case 39:
				return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ouvrirLeRattachement(model);
			case 40:
				var id = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLeRattachement,
						function (r) {
							return A2(
								$elm$core$Maybe$withDefault,
								r,
								A2(
									$elm$core$Maybe$map,
									function (fiche) {
										return A3($author$project$Components$Parametrage$BibliothequeDeChamps$Rattachement$choisir, id, fiche, r);
									},
									model.zo));
						},
						model),
					_List_Nil);
			case 41:
				var exigence = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLeRattachement,
						$author$project$Components$Parametrage$BibliothequeDeChamps$Rattachement$exiger(exigence),
						model),
					_List_Nil);
			case 42:
				var niveau = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLeRattachement,
						$author$project$Components$Parametrage$BibliothequeDeChamps$Rattachement$lire(niveau),
						model),
					_List_Nil);
			case 43:
				var masque = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLeRattachement,
						$author$project$Components$Parametrage$BibliothequeDeChamps$Rattachement$masquer(masque),
						model),
					_List_Nil);
			case 44:
				var personnelle = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLeRattachement,
						$author$project$Components$Parametrage$BibliothequeDeChamps$Rattachement$personnelle(personnelle),
						model),
					_List_Nil);
			case 45:
				return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$enregistrerLeRattachement(model);
			case 46:
				var geste = msg.a;
				return ($author$project$API$Envoi$enCours(model.l2) && A2(
					$elm$core$List$member,
					geste,
					_List_fromArray(
						[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$SortieDemandee, $author$project$Components$Shared$Drawer$Update$AbandonConfirme]))) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDuCalcul, geste, model);
			case 47:
				return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ouvrirLeCalcul(model);
			case 48:
				var formule = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLeCalcul,
						$author$project$Components$Parametrage$BibliothequeDeChamps$Calcul$formuleSaisie(formule),
						model),
					_List_Nil);
			case 49:
				var recalcul = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLeCalcul,
						$author$project$Components$Parametrage$BibliothequeDeChamps$Calcul$recalculChoisi(recalcul),
						model),
					_List_Nil);
			case 50:
				var valeur = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$avecLeCalcul,
						$author$project$Components$Parametrage$BibliothequeDeChamps$Calcul$natureChoisie(valeur),
						model),
					_List_Nil);
			case 51:
				return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$enregistrerLeCalcul(model);
			case 52:
				var geste = msg.a;
				return ($author$project$API$Envoi$enCours(model.l2) && A2(
					$elm$core$List$member,
					geste,
					_List_fromArray(
						[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$SortieDemandee, $author$project$Components$Shared$Drawer$Update$AbandonConfirme]))) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawerDuLot, geste, model);
			case 53:
				return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ouvrirLeLot(model);
			case 54:
				var id = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							n0: A2(
								$elm$core$Maybe$map,
								$author$project$Components$Parametrage$BibliothequeDeChamps$Lot$choisi(id),
								model.n0)
						}),
					_List_Nil);
			case 55:
				return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$appliquerLeLot(model);
			case 6:
				var texte = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Dj: texte, pZ: $elm$core$Maybe$Nothing}),
					_List_Nil);
			case 7:
				var valeur = msg.a;
				var choix = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jN: A3($elm$core$Dict$insert, valeur, choix, model.jN)
						}),
					_List_Nil);
			case 8:
				var issue = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cR: issue, pZ: $elm$core$Maybe$Nothing}),
					_List_Nil);
			case 9:
				var coche = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{v2: coche}),
					_List_Nil);
			case 11:
				return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$envoyer(model);
			case 10:
				return A2(
					$author$project$Components$Parametrage$BibliothequeDeChamps$Update$versLeDrawer,
					$author$project$Components$Shared$Drawer$Update$Fermer,
					_Utils_update(
						model,
						{dy: $elm$core$Maybe$Nothing, v2: false, pZ: $elm$core$Maybe$Nothing}));
			default:
				var reponse = msg.a;
				if ($author$project$Components$Parametrage$NouveauChamp$Model$ouvert(model.oP)) {
					return A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$surLeNouveauChamp,
						$author$project$Components$Parametrage$NouveauChamp$Update$CommandeRepondue(reponse),
						model);
				} else {
					var _v15 = A3(
						$author$project$API$Envoi$conclure,
						$author$project$Components$Parametrage$BibliothequeDeChamps$Update$reglageDeLaReponse(model),
						reponse,
						model.l2);
					if (!_v15.$) {
						var _v16 = _v15.a;
						var envoi = _v16.a;
						var issue = _v16.b;
						var effets = _v16.c;
						var _v17 = _Utils_Tuple2(issue, model.l2);
						if (((_v17.a.$ === 1) && (_v17.a.c.$ === 4)) && (_v17.b.$ === 2)) {
							var _v18 = _v17.a;
							var _v19 = _v18.c;
							var _v20 = _v17.b;
							var processUid = _v20.a;
							return A2(
								$author$project$Components$Parametrage$BibliothequeDeChamps$Update$conclure,
								issue,
								_Utils_update(
									model,
									{
										l2: $author$project$API$Envoi$Pret(processUid)
									}));
						} else {
							return A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Basics$append(effets),
								A2(
									$author$project$Components$Parametrage$BibliothequeDeChamps$Update$conclure,
									issue,
									_Utils_update(
										model,
										{l2: envoi})));
						}
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				}
		}
	});
var $author$project$Main$Update$versLaBibliotheque = F3(
	function (i18n, msg, model) {
		var _v0 = A2(
			$author$project$Components$Parametrage$BibliothequeDeChamps$Update$update,
			msg,
			$author$project$Components$Parametrage$BibliothequeDeChamps$Model$ouvrir(model.dq));
		var bibliotheque = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLaBibliotheque, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLaBibliotheque,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						dq: $author$project$Components$Parametrage$BibliothequeDeChamps$Model$envelopper(bibliotheque),
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Parametrage$BibliothequeDeChamps$Update$popMessages(msg),
							gardes)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$FicheDUnElement = 1;
var $author$project$Main$Model$PourLaFicheElement = 6;
var $author$project$Components$Produits$FicheElement$Model$cible = F2(
	function (id, fiche) {
		return _Utils_eq(fiche.lQ.Aq, id) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(fiche.lQ, fiche.os)) : A2(
			$elm$core$Maybe$map,
			function (porte) {
				return _Utils_Tuple2(porte, fiche.C8);
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Aq;
						},
						$elm$core$Basics$eq(id)),
					fiche.yp)));
	});
var $author$project$Components$Produits$FicheElement$Model$formeDeLaCreation = function (fiche) {
	return A2(
		$elm$core$Maybe$map,
		$elm$core$Tuple$pair(1),
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUneGamme, fiche.nQ));
};
var $author$project$API$NavLinksDictionary$modifierUneGamme = 'modifier-une-gamme';
var $author$project$Components$Produits$FicheElement$Model$formeDeLaModification = function (element) {
	var _v0 = _Utils_Tuple2(
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierUneMarque, element.nQ),
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierUneGamme, element.nQ));
	if (!_v0.a.$) {
		var lien = _v0.a.a;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(0, lien));
	} else {
		if (!_v0.b.$) {
			var _v1 = _v0.a;
			var lien = _v0.b.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(1, lien));
		} else {
			var _v2 = _v0.a;
			var _v3 = _v0.b;
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$Components$Produits$FicheElement$Model$formeDuGeste = function (model) {
	var _v0 = _Utils_Tuple2(model.mW, model.zo);
	_v0$2:
	while (true) {
		if (!_v0.b.$) {
			switch (_v0.a.$) {
				case 1:
					var _v1 = _v0.a;
					var fiche = _v0.b.a;
					return A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$first,
						$author$project$Components$Produits$FicheElement$Model$formeDeLaCreation(fiche));
				case 2:
					var id = _v0.a.a;
					var fiche = _v0.b.a;
					return A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$first,
						A2(
							$elm$core$Maybe$andThen,
							A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $author$project$Components$Produits$FicheElement$Model$formeDeLaModification),
							A2($author$project$Components$Produits$FicheElement$Model$cible, id, fiche)));
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Components$Produits$Common$Elements$nom = function (element) {
	return element.R.zX;
};
var $author$project$I18n$Textes$produitsCatalogueGammeEnDoubleDansLaMarque = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.catalogue.gamme.en-double.dans-la-marque',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'marque',
				$author$project$I18n$Traductions$Sous(p.gX))
			]),
		'Cette gamme existe déjà dans la marque {marque}.');
};
var $author$project$I18n$Textes$produitsCatalogueGammeNoteDeCreationDansLaMarque = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.catalogue.gamme.note-de-creation.dans-la-marque',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'marque',
				$author$project$I18n$Traductions$Sous(p.gX))
			]),
		'Une gamme créée ici appartient à {marque}. Si son nom existe déjà, la gamme existante est étendue à {marque}.');
};
var $author$project$Catalogue$Vocabulaire$sousParent = F2(
	function (niveau, parent) {
		return (_Utils_eq(
			_Utils_Tuple2(niveau, parent.os.Bl),
			_Utils_Tuple2(
				{fA: $author$project$Catalogue$Vocabulaire$codeGamme, Bl: $elm$core$Maybe$Nothing},
				$elm$core$Maybe$Nothing)) && _Utils_eq(parent.os.fA, $author$project$Catalogue$Vocabulaire$codeMarque)) ? {
			gi: $author$project$I18n$Textes$produitsCatalogueGammeEnDoubleDansLaMarque(
				{
					gX: $author$project$I18n$Traductions$tel(parent.Dj)
				}),
			oJ: $author$project$I18n$Textes$produitsCatalogueGammeNoteDeCreationDansLaMarque(
				{
					gX: $author$project$I18n$Traductions$tel(parent.Dj)
				})
		} : {
			gi: $author$project$Catalogue$Vocabulaire$tournures(niveau).gi,
			oJ: $author$project$I18n$Traductions$tel('')
		};
	});
var $author$project$Components$Produits$FicheElement$Model$sousLElement = F2(
	function (i18n, fiche) {
		var _v0 = _Utils_Tuple2(fiche.C8, fiche.os);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var porte = _v0.a.a;
				var niveau = _v0.b.a;
				return A2(
					$author$project$Catalogue$Vocabulaire$sousParent,
					$author$project$Components$Produits$Common$Elements$niveau(porte),
					{
						os: $author$project$Components$Produits$Common$Elements$niveau(niveau),
						Dj: $author$project$Components$Produits$Common$Elements$nom(fiche.lQ)
					});
			} else {
				var porte = _v0.a.a;
				var _v1 = _v0.b;
				return {
					gi: A2($author$project$Components$Produits$Common$Elements$tournures, i18n, porte).gi,
					oJ: $author$project$I18n$Traductions$tel('')
				};
			}
		} else {
			var _v2 = _v0.a;
			return {
				gi: $author$project$I18n$Textes$produitsCatalogueNeutreEnDouble,
				oJ: $author$project$I18n$Traductions$tel('')
			};
		}
	});
var $author$project$Components$Produits$FicheElement$Model$contexteDuRefus = F4(
	function (i18n, refusee, model, fiche) {
		var neutres = $author$project$Catalogue$Vocabulaire$tournures(
			{fA: '', Bl: $elm$core$Maybe$Nothing});
		var enElements = function (nombre) {
			return $author$project$I18n$Textes$produitsElements(
				{w: nombre});
		};
		var portes = function () {
			var _v3 = A2($elm$core$Maybe$map, $author$project$Components$Produits$Common$Elements$niveau, fiche.C8);
			if (!_v3.$) {
				var niveau = _v3.a;
				return _Utils_eq(niveau.Bl, $elm$core$Maybe$Nothing) ? $author$project$Catalogue$Vocabulaire$elements(niveau.fA) : enElements;
			} else {
				return enElements;
			}
		}();
		var de = function (id) {
			var _v1 = A2($author$project$Components$Produits$FicheElement$Model$cible, id, fiche);
			if (!_v1.$) {
				var _v2 = _v1.a;
				var element = _v2.a;
				var niveau = _v2.b;
				return {
					aV: _Utils_eq(element.Aq, fiche.lQ.Aq) ? portes : enElements,
					gi: _Utils_eq(element.Aq, fiche.lQ.Aq) ? A2(
						$elm$core$Maybe$withDefault,
						neutres.gi,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Components$Produits$Common$Elements$tournures(i18n),
								function ($) {
									return $.gi;
								}),
							niveau)) : A2($author$project$Components$Produits$FicheElement$Model$sousLElement, i18n, fiche).gi,
					Dj: $author$project$Components$Produits$Common$Elements$nom(element),
					fd: A2(
						$elm$core$Maybe$withDefault,
						neutres,
						A2(
							$elm$core$Maybe$map,
							$author$project$Components$Produits$Common$Elements$tournures(i18n),
							niveau))
				};
			} else {
				return {aV: enElements, gi: neutres.gi, Dj: '', fd: neutres};
			}
		};
		switch (refusee.$) {
			case 1:
				var id = refusee.a;
				return de(id);
			case 2:
				var id = refusee.a;
				return de(id);
			case 5:
				var id = refusee.a;
				return de(id);
			case 6:
				var id = refusee.a;
				return de(id);
			case 8:
				var id = refusee.a;
				return de(id);
			case 7:
				var id = refusee.a;
				return de(id);
			case 9:
				var id = refusee.a;
				return de(id);
			default:
				return {
					aV: enElements,
					gi: A2($author$project$Components$Produits$FicheElement$Model$sousLElement, i18n, fiche).gi,
					Dj: A2(
						$author$project$Components$Produits$Common$Saisie$nomSaisi,
						A2(
							$elm$core$Maybe$withDefault,
							1,
							$author$project$Components$Produits$FicheElement$Model$formeDuGeste(model)),
						model.hP),
					fd: A2(
						$elm$core$Maybe$withDefault,
						neutres,
						A2(
							$elm$core$Maybe$map,
							$author$project$Components$Produits$Common$Elements$tournures(i18n),
							fiche.C8))
				};
		}
	});
var $author$project$Components$Produits$FicheElement$Model$etendue = $author$project$Components$Produits$Common$Gammes$etendue;
var $author$project$Components$Produits$FicheElement$API$QueryAPIModel$Fiche = function (element) {
	return function (niveau) {
		return function (parent) {
			return function (niveauDesEnfants) {
				return function (enfants) {
					return function (gammesDuClient) {
						return function (valeursDEtage) {
							return function (unites) {
								return function (langues) {
									return function (liens) {
										return {lQ: element, yp: enfants, z4: gammesDuClient, Ba: langues, nQ: liens, os: niveau, C8: niveauDesEnfants, ey: parent, sb: unites, Kk: valeursDEtage};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Produits$FicheElement$API$QueryAPIModel$Parent = F3(
	function (id, libelles, ouvrable) {
		return {Aq: id, R: libelles, Ex: ouvrable};
	});
var $author$project$Components$Produits$FicheElement$API$QueryAPIModel$parentDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.h0;
			},
			A2(
				$elm$core$Basics$composeR,
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$self),
				$elm$core$Basics$neq($elm$core$Maybe$Nothing))),
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'libelles',
		$author$project$Catalogue$API$QueryAPIModel$libellesDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$author$project$Catalogue$Identifiants$elementIdDecoder,
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$FicheElement$API$QueryAPIModel$Parent))));
var $author$project$Components$Produits$FicheElement$API$QueryAPIModel$ValeursDeLaPage = F7(
	function (portee, typologie, champs, choix, completude, typesRanges, liens) {
		return {dw: champs, jN: choix, fU: completude, nQ: liens, F$: portee, J4: typesRanges, r3: typologie};
	});
var $author$project$Components$Produits$FicheElement$API$QueryAPIModel$ChampDEtage = F4(
	function (champ, typeDeChamp, valeur, liens) {
		return {uN: champ, nQ: liens, JR: typeDeChamp, fm: valeur};
	});
var $author$project$Components$Produits$FicheElement$API$QueryAPIModel$champDEtageDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$field,
		'champ',
		A2(
			$elm$json$Json$Decode$map,
			function ($) {
				return $.h0;
			},
			$author$project$API$Liens$deLaRessource)),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'valeur',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$value),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
			_List_fromArray(
				['champ', 'typeDeChamp']),
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['champ', 'champ']),
				$author$project$Components$Shared$EditeurDeSchema$Champ$decoder,
				$elm$json$Json$Decode$succeed($author$project$Components$Produits$FicheElement$API$QueryAPIModel$ChampDEtage)))));
var $author$project$Components$Produits$FicheElement$API$QueryAPIModel$Completude = F3(
	function (remplis, total, manques) {
		return {B5: manques, HB: remplis, JE: total};
	});
var $author$project$Components$Produits$FicheElement$API$QueryAPIModel$completudeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'manques',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'total',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'remplis',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$FicheElement$API$QueryAPIModel$Completude))));
var $author$project$Components$Produits$FicheElement$API$QueryAPIModel$valeursDeLaPageDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'typesRanges',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'completude',
			$author$project$Components$Produits$FicheElement$API$QueryAPIModel$completudeDecoder,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'choix',
				$elm$json$Json$Decode$list($author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$decoder),
				_List_Nil,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'champs',
					$elm$json$Json$Decode$list($author$project$Components$Produits$FicheElement$API$QueryAPIModel$champDEtageDecoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['typologie', 'fr']),
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'portee',
							$elm$json$Json$Decode$value,
							$elm$json$Json$Decode$succeed($author$project$Components$Produits$FicheElement$API$QueryAPIModel$ValeursDeLaPage))))))));
var $author$project$Components$Produits$FicheElement$API$QueryAPIModel$ficheDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'langues',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'unites',
			$author$project$Catalogue$API$QueryAPIModel$unitesDecoder,
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'valeursDEtage',
				$elm$json$Json$Decode$list($author$project$Components$Produits$FicheElement$API$QueryAPIModel$valeursDeLaPageDecoder),
				_List_Nil,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'gammesDuClient',
					$author$project$Catalogue$API$QueryAPIModel$gammesDuClientDecoder,
					_List_Nil,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'enfants',
						$elm$json$Json$Decode$list($author$project$Catalogue$API$QueryAPIModel$elementDecoder),
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'niveauDesEnfants',
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$niveauDElementDecoder),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'parent',
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Produits$FicheElement$API$QueryAPIModel$parentDecoder),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'niveau',
									A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$niveauDElementDecoder),
									$elm$core$Maybe$Nothing,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'element',
										$author$project$Catalogue$API$QueryAPIModel$elementDecoder,
										$elm$json$Json$Decode$succeed($author$project$Components$Produits$FicheElement$API$QueryAPIModel$Fiche)))))))))));
var $author$project$Components$Produits$FicheElement$Update$popMessages = F3(
	function (i18n, model, msg) {
		switch (msg.$) {
			case 30:
				var reponse = msg.a;
				var _v1 = _Utils_Tuple3(
					$author$project$Components$Shared$Drawer$Model$estOuvert(model.kX),
					A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, model.l2),
					model.zo);
				_v1$3:
				while (true) {
					if (!_v1.b.$) {
						switch (_v1.b.a.b.$) {
							case 0:
								if (_v1.b.a.b.c) {
									if ((_v1.b.a.b.a.$ === 4) && (!_v1.c.$)) {
										var _v2 = _v1.b.a;
										var _v3 = _v2.b;
										var gamme = _v3.a.a;
										var rendue = _v3.b;
										var fiche = _v1.c.a;
										return A2(
											$author$project$Components$Produits$FicheElement$Model$etendue,
											$author$project$Catalogue$API$WriteAPIModel$CreerUneGamme(gamme),
											rendue) ? $elm$core$Maybe$Just(
											{
												Jx: $author$project$I18n$Textes$produitsCatalogueGammeEtendue(
													{
														gX: $author$project$I18n$Traductions$tel(
															$author$project$Components$Produits$Common$Elements$nom(fiche.lQ)),
														Dj: $author$project$I18n$Traductions$tel(
															A3($author$project$Components$Produits$Common$Gammes$nomDeLaGammeEtendue, fiche.z4, gamme.R.zX, rendue))
													}),
												b9: $elm$core$Maybe$Nothing
											}) : $elm$core$Maybe$Nothing;
									} else {
										break _v1$3;
									}
								} else {
									if (!_v1.a) {
										var _v4 = _v1.b.a;
										var _v5 = _v4.b;
										return $elm$core$Maybe$Just($author$project$Components$Produits$Common$Refus$rejeu);
									} else {
										break _v1$3;
									}
								}
							case 1:
								if ((!_v1.a) && (!_v1.c.$)) {
									var _v6 = _v1.b.a;
									var _v7 = _v6.b;
									var commande = _v7.a;
									var refus = _v7.b;
									var erreur = _v7.c;
									var fiche = _v1.c.a;
									return $elm$core$Maybe$Just(
										A3(
											$author$project$Components$Produits$Common$Refus$message,
											A4($author$project$Components$Produits$FicheElement$Model$contexteDuRefus, i18n, commande, model, fiche),
											refus,
											erreur));
								} else {
									break _v1$3;
								}
							default:
								break _v1$3;
						}
					} else {
						break _v1$3;
					}
				}
				return $elm$core$Maybe$Nothing;
			case 2:
				var reponse = msg.a;
				var _v8 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$FicheElement$API$QueryAPIModel$ficheDecoder, reponse);
				if (_v8.$ === 1) {
					var refus = _v8.a;
					return A2(
						$elm$core$List$member,
						refus.ri,
						_List_fromArray(
							[401, 404])) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 1:
				var octets = msg.a;
				return _Utils_eq(
					$author$project$API$ProcessUid$depuisOctets(octets),
					$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
					{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$FicheElement$Model$ApresLArchivage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$FicheElement$Model$ApresLOuverture = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$FicheElement$Model$Modification = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$FicheElement$Model$Ordonner = {$: 3};
var $author$project$Components$Produits$FicheElement$Model$SurLOrdre = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Produits$FicheElement$Model$SurLaCase = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$FicheElement$Model$Valeurs = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Produits$FicheElement$Update$apresLOrdre = F2(
	function (issue, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		var _v1 = _Utils_Tuple3(issue, model.o2, model.zo);
		if ((!_v1.a.$) && _v1.a.c) {
			var _v2 = _v1.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{o2: $elm$core$Maybe$Nothing}),
				effets);
		} else {
			if ((!_v1.b.$) && (!_v1.c.$)) {
				var precedents = _v1.b.a;
				var fiche = _v1.c.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							iP: $author$project$I18n$Traductions$tel(''),
							zo: $elm$core$Maybe$Just(
								_Utils_update(
									fiche,
									{yp: precedents})),
							o2: $elm$core$Maybe$Nothing
						}),
					effets);
			} else {
				return _Utils_Tuple2(model, effets);
			}
		}
	});
var $author$project$Catalogue$API$WriteAPIModel$ArchiverUneGamme = function (a) {
	return {$: 6, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$ArchiverUneMarque = function (a) {
	return {$: 2, a: a};
};
var $author$project$API$NavLinksDictionary$archiverUneGamme = 'archiver-une-gamme';
var $author$project$API$NavLinksDictionary$archiverUneMarque = 'archiver-une-marque';
var $author$project$Components$Produits$FicheElement$Model$commandeDArchivage = F2(
	function (id, fiche) {
		return A2(
			$elm$core$Maybe$andThen,
			function (_v0) {
				var element = _v0.a;
				var _v1 = _Utils_Tuple2(
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$archiverUneMarque, element.nQ),
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$archiverUneGamme, element.nQ));
				if (!_v1.a.$) {
					var lien = _v1.a.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							$author$project$Catalogue$API$WriteAPIModel$ArchiverUneMarque(id),
							lien));
				} else {
					if (!_v1.b.$) {
						var _v2 = _v1.a;
						var lien = _v1.b.a;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(
								$author$project$Catalogue$API$WriteAPIModel$ArchiverUneGamme(id),
								lien));
					} else {
						var _v3 = _v1.a;
						var _v4 = _v1.b;
						return $elm$core$Maybe$Nothing;
					}
				}
			},
			A2($author$project$Components$Produits$FicheElement$Model$cible, id, fiche));
	});
var $author$project$Components$Produits$FicheElement$Model$commandeDOrdre = F2(
	function (voulus, fiche) {
		return A3(
			$elm$core$Maybe$map2,
			F2(
				function (lien, niveau) {
					return _Utils_Tuple2(
						$author$project$Catalogue$API$WriteAPIModel$OrdonnerLesGammes(
							{
								os: niveau.Aq,
								El: A2(
									$elm$core$List$map,
									function ($) {
										return $.Aq;
									},
									voulus),
								ey: $elm$core$Maybe$Just(fiche.lQ.Aq)
							}),
						lien);
				}),
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ordonnerLesGammes, fiche.nQ),
			fiche.C8);
	});
var $author$project$Catalogue$API$WriteAPIModel$OuvrirUneGammeAToutesLesMarques = function (a) {
	return {$: 9, a: a};
};
var $author$project$API$NavLinksDictionary$ouvrirUneGammeAToutesLesMarques = 'ouvrir-une-gamme-a-toutes-les-marques';
var $author$project$Components$Produits$FicheElement$Model$commandeDOuverture = F2(
	function (id, fiche) {
		return A2(
			$elm$core$Maybe$map,
			function (lien) {
				return _Utils_Tuple2(
					$author$project$Catalogue$API$WriteAPIModel$OuvrirUneGammeAToutesLesMarques(id),
					lien);
			},
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nQ;
					},
					$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$ouvrirUneGammeAToutesLesMarques)),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(id)),
						fiche.yp))));
	});
var $author$project$Components$Produits$FicheElement$Model$gammeDuClient = F2(
	function (id, fiche) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Aq;
					},
					$elm$core$Basics$eq(id)),
				fiche.z4));
	});
var $author$project$Components$Produits$FicheElement$Model$commandeDeRattachement = F2(
	function (id, fiche) {
		return A2(
			$elm$core$Maybe$map,
			function (lien) {
				return _Utils_Tuple2(
					A2($author$project$Catalogue$API$WriteAPIModel$RattacherUneGamme, id, fiche.lQ.Aq),
					lien);
			},
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nQ;
					},
					$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$rattacherUneGammeAUneMarque)),
				A2($author$project$Components$Produits$FicheElement$Model$gammeDuClient, id, fiche)));
	});
var $author$project$Components$Produits$FicheElement$Model$commandeDeRetrait = F2(
	function (id, fiche) {
		return A2(
			$elm$core$Maybe$map,
			function (lien) {
				return _Utils_Tuple2(
					A2($author$project$Catalogue$API$WriteAPIModel$RetirerUneGammeDUneMarque, id, fiche.lQ.Aq),
					lien);
			},
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nQ;
					},
					$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$retirerUneGammeDUneMarque)),
				A2($author$project$Components$Produits$FicheElement$Model$gammeDuClient, id, fiche)));
	});
var $author$project$Catalogue$API$WriteAPIModel$RetirerLaValeurDUnChampHerite = F2(
	function (a, b) {
		return {$: 65, a: a, b: b};
	});
var $author$project$Components$Produits$FicheElement$Valeurs$bloc = F2(
	function (rang, fiche) {
		return $elm$core$List$head(
			A2($elm$core$List$drop, rang, fiche.Kk));
	});
var $author$project$API$NavLinksDictionary$retirerLaValeurDUnChampHerite = 'retirer-la-valeur-d-un-champ-herite';
var $author$project$Components$Produits$FicheElement$Valeurs$commandeDeRetrait = F3(
	function (rang, cle, fiche) {
		return A2(
			$elm$core$Maybe$andThen,
			function (page) {
				return A2(
					$elm$core$Maybe$andThen,
					function (champ) {
						return A2(
							$elm$core$Maybe$map,
							function (lien) {
								return _Utils_Tuple2(
									A2($author$project$Catalogue$API$WriteAPIModel$RetirerLaValeurDUnChampHerite, page.F$, cle),
									lien);
							},
							A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerLaValeurDUnChampHerite, champ.nQ));
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (champ) {
								return _Utils_eq(champ.uN.dy, cle);
							},
							page.dw)));
			},
			A2($author$project$Components$Produits$FicheElement$Valeurs$bloc, rang, fiche));
	});
var $author$project$Components$Produits$FicheElement$Update$estUnOrdre = function (commande) {
	switch (commande.$) {
		case 17:
			return true;
		case 18:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Produits$FicheElement$Update$commandeDOrdre = function (issue) {
	switch (issue.$) {
		case 0:
			var commande = issue.a;
			return $author$project$Components$Produits$FicheElement$Update$estUnOrdre(commande);
		case 1:
			var commande = issue.a;
			return $author$project$Components$Produits$FicheElement$Update$estUnOrdre(commande);
		default:
			return false;
	}
};
var $author$project$Components$Produits$FicheElement$Update$commandeDesValeurs = function (issue) {
	var deLaPage = function (commande) {
		switch (commande.$) {
			case 64:
				return $elm$core$Maybe$Just(commande);
			case 65:
				return $elm$core$Maybe$Just(commande);
			default:
				return $elm$core$Maybe$Nothing;
		}
	};
	switch (issue.$) {
		case 0:
			var commande = issue.a;
			return deLaPage(commande);
		case 1:
			var commande = issue.a;
			return deLaPage(commande);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$FicheElement$Valeurs$Fermer = {$: 3};
var $author$project$Components$Produits$FicheElement$Valeurs$champs = function (page) {
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.uN;
		},
		page.dw);
};
var $author$project$Components$Produits$FicheElement$Update$saisieDesValeursEnCours = function (model) {
	var _v0 = _Utils_Tuple3(model.mW, model.Ki, model.zo);
	if (((_v0.a.$ === 4) && (!_v0.b.$)) && (!_v0.c.$)) {
		var rang = _v0.a.a;
		var ouvertes = _v0.b.a;
		var fiche = _v0.c.a;
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (page) {
					return A2(
						$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$enCours,
						$author$project$Components$Produits$FicheElement$Valeurs$champs(page),
						ouvertes.hP);
				},
				A2($author$project$Components$Produits$FicheElement$Valeurs$bloc, rang, fiche)));
	} else {
		return false;
	}
};
var $author$project$Components$Produits$FicheElement$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{kX: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var vers = _v0;
					return $author$project$Components$Produits$Common$Effet$PlacerFocus(vers);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Produits$Common$Saisie$enCours(model.hP) || $author$project$Components$Produits$FicheElement$Update$saisieDesValeursEnCours(model)
				},
				geste,
				model.kX));
	});
var $author$project$Components$Produits$FicheElement$Update$fermerLesValeurs = F2(
	function (vers, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (m) {
				return _Utils_update(
					m,
					{Ki: $elm$core$Maybe$Nothing});
			},
			function (effets) {
				return _Utils_ap(
					effets,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$PlacerFocus, $elm$core$List$singleton),
							vers)));
			},
			A2(
				$author$project$Components$Produits$FicheElement$Update$versLeDrawer,
				$author$project$Components$Shared$Drawer$Update$Fermer,
				_Utils_update(
					model,
					{mW: $author$project$Components$Produits$FicheElement$Model$AucunGeste})));
	});
var $author$project$Components$Produits$FicheElement$Valeurs$ChoisirParmi = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Produits$FicheElement$Valeurs$CorrigerLaValeur = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$FicheElement$Valeurs$SaisirAilleurs = {$: 2};
var $author$project$I18n$Textes$produitsFicheElementValeursRefusEtage = A3($author$project$I18n$Traductions$texte, 'produits.fiche-element.valeurs.refus-etage', _List_Nil, 'Cet étage ne reçoit pas de valeur pour cette typologie.');
var $author$project$I18n$Textes$produitsFicheElementValeursRefusEtageTitre = A3($author$project$I18n$Traductions$texte, 'produits.fiche-element.valeurs.refus-etage-titre', _List_Nil, 'Champ non saisissable à cet étage');
var $author$project$I18n$Textes$produitsFicheElementValeursRefusNiveau = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.fiche-element.valeurs.refus-niveau',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nom',
				$author$project$I18n$Traductions$Sous(p.Dj)),
				_Utils_Tuple2(
				'niveaux',
				$author$project$I18n$Traductions$Sous(p.C9))
			]),
		'Ce champ ne se saisit pas sur {nom} : il se saisit au niveau « {niveaux} ».');
};
var $author$project$I18n$Textes$produitsFicheElementValeursRefusNiveauTitre = A3($author$project$I18n$Traductions$texte, 'produits.fiche-element.valeurs.refus-niveau-titre', _List_Nil, 'Champ non saisissable à cet étage');
var $author$project$I18n$Textes$produitsFicheElementValeursRefusRestrictionTitre = A3($author$project$I18n$Traductions$texte, 'produits.fiche-element.valeurs.refus-restriction-titre', _List_Nil, 'Valeur hors de la restriction');
var $author$project$I18n$Textes$produitsFicheElementValeursRefusValeur = A3($author$project$I18n$Traductions$texte, 'produits.fiche-element.valeurs.refus-valeur', _List_Nil, 'Cette valeur n\'est pas admise pour ce champ.');
var $author$project$I18n$Textes$produitsFicheElementValeursRefusValeurTitre = A3($author$project$I18n$Traductions$texte, 'produits.fiche-element.valeurs.refus-valeur-titre', _List_Nil, 'Valeur invalide');
var $author$project$I18n$Textes$produitsFicheElementValeursRefusRestriction = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.fiche-element.valeurs.refus-restriction',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'valeur',
				$author$project$I18n$Traductions$Sous(p.fm)),
				_Utils_Tuple2(
				'champ',
				$author$project$I18n$Traductions$Sous(p.uN)),
				_Utils_Tuple2(
				'nom',
				$author$project$I18n$Traductions$Sous(p.Dj)),
				_Utils_Tuple2(
				'nombre',
				$author$project$I18n$Traductions$Entier(p.w))
			]),
		'« {valeur} » n\'est pas proposé pour {champ} sur {nom} ({nombre, plural, one {# valeur retenue} other {# valeurs retenues}}).');
};
var $author$project$Components$Produits$FicheElement$Valeurs$restriction = F4(
	function (nomDeLaMarque, refusee, libelle, n) {
		return $author$project$I18n$Textes$produitsFicheElementValeursRefusRestriction(
			{
				uN: $author$project$I18n$Traductions$tel(libelle),
				Dj: $author$project$I18n$Traductions$tel(nomDeLaMarque),
				w: n,
				fm: $author$project$I18n$Traductions$tel(refusee)
			});
	});
var $author$project$Components$Produits$FicheElement$Valeurs$refusDe = F5(
	function (nomDeLaMarque, page, commande, refus, erreur) {
		var dire = F3(
			function (titre, texte, issue) {
				return $elm$core$Maybe$Just(
					{
						nh: issue,
						Cs: {Jx: texte, b9: refus.b9},
						qb: $elm$core$Maybe$Nothing,
						h6: $elm$core$Maybe$Just(titre)
					});
			});
		var champ = function () {
			switch (commande.$) {
				case 64:
					return '';
				case 65:
					var cle = commande.b;
					return cle;
				default:
					return '';
			}
		}();
		switch (erreur.$) {
			case 75:
				var niveaux = erreur.a;
				return A3(
					dire,
					$author$project$I18n$Textes$produitsFicheElementValeursRefusNiveauTitre,
					$author$project$I18n$Textes$produitsFicheElementValeursRefusNiveau(
						{
							C9: $author$project$I18n$Traductions$tel(
								A2($elm$core$String$join, ', ', niveaux)),
							Dj: $author$project$I18n$Traductions$tel(nomDeLaMarque)
						}),
					$author$project$Components$Produits$FicheElement$Valeurs$SaisirAilleurs);
			case 74:
				return A3(dire, $author$project$I18n$Textes$produitsFicheElementValeursRefusEtageTitre, $author$project$I18n$Textes$produitsFicheElementValeursRefusEtage, $author$project$Components$Produits$FicheElement$Valeurs$Fermer);
			case 76:
				var defauts = erreur.a;
				var premier = $elm$core$List$head(defauts);
				var cle = A2(
					$elm$core$Maybe$withDefault,
					champ,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.uN;
						},
						premier));
				var libelle = A2(
					$elm$core$Maybe$withDefault,
					cle,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.uN;
							},
							function ($) {
								return $.Bl;
							}),
						A2(
							$elm$core$Maybe$andThen,
							function (p) {
								return $elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (c) {
											return _Utils_eq(c.uN.dy, cle);
										},
										p.dw));
							},
							page)));
				var retenues = A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.pE;
						},
						$elm$core$List$length),
					A2(
						$elm$core$Maybe$andThen,
						function (p) {
							return $elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (c) {
										return _Utils_eq(c.dy, cle);
									},
									p.jN));
						},
						page));
				var _v1 = _Utils_Tuple3(
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.vx;
						},
						premier),
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.Bl;
						},
						premier),
					retenues);
				if ((((!_v1.a.$) && (_v1.a.a === 'ValeurHorsChoix')) && (!_v1.b.$)) && (!_v1.c.$)) {
					var refusee = _v1.b.a;
					var n = _v1.c.a;
					return A2(
						$elm$core$Maybe$map,
						function (dit) {
							return _Utils_update(
								dit,
								{
									qb: $elm$core$Maybe$Just(refusee)
								});
						},
						A3(
							dire,
							$author$project$I18n$Textes$produitsFicheElementValeursRefusRestrictionTitre,
							A4($author$project$Components$Produits$FicheElement$Valeurs$restriction, nomDeLaMarque, refusee, libelle, n),
							A2($author$project$Components$Produits$FicheElement$Valeurs$ChoisirParmi, cle, n)));
				} else {
					return A3(
						dire,
						$author$project$I18n$Textes$produitsFicheElementValeursRefusValeurTitre,
						$author$project$I18n$Textes$produitsFicheElementValeursRefusValeur,
						$author$project$Components$Produits$FicheElement$Valeurs$CorrigerLaValeur(cle));
				}
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$FicheElement$Update$relire = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$Lire, $elm$core$List$singleton),
			model.np));
};
var $author$project$Components$Produits$FicheElement$Update$concluDesValeurs = F3(
	function (i18n, issue, model) {
		var _v0 = _Utils_Tuple3(issue, model.Ki, model.zo);
		_v0$3:
		while (true) {
			if (!_v0.b.$) {
				switch (_v0.a.$) {
					case 0:
						if (_v0.a.c) {
							if (!_v0.c.$) {
								var _v1 = _v0.a;
								var ouvertes = _v0.b.a;
								var fiche = _v0.c.a;
								return function (_v2) {
									var m = _v2.a;
									var effets = _v2.b;
									return _Utils_Tuple2(
										_Utils_update(
											m,
											{
												zo: $elm$core$Maybe$Just(fiche)
											}),
										effets);
								}(
									A2(
										$elm$core$Tuple$mapSecond,
										function (effets) {
											return _Utils_ap(
												effets,
												$author$project$Components$Produits$FicheElement$Update$relire(model));
										},
										A2(
											$author$project$Components$Produits$FicheElement$Update$fermerLesValeurs,
											$elm$core$Maybe$Nothing,
											_Utils_update(
												model,
												{
													Ki: $elm$core$Maybe$Just(
														_Utils_update(
															ouvertes,
															{
																hP: $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$acceptee(ouvertes.hP)
															}))
												}))));
							} else {
								break _v0$3;
							}
						} else {
							var _v3 = _v0.a;
							var ouvertes = _v0.b.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										Ki: $elm$core$Maybe$Just(
											_Utils_update(
												ouvertes,
												{
													pZ: $elm$core$Maybe$Just(
														{nh: $author$project$Components$Produits$FicheElement$Valeurs$Fermer, Cs: $author$project$Components$Produits$Common$Refus$rejeu, qb: $elm$core$Maybe$Nothing, h6: $elm$core$Maybe$Nothing})
												}))
									}),
								$author$project$Components$Produits$FicheElement$Update$relire(model));
						}
					case 1:
						if (!_v0.c.$) {
							var _v4 = _v0.a;
							var commande = _v4.a;
							var refus = _v4.b;
							var erreur = _v4.c;
							var ouvertes = _v0.b.a;
							var fiche = _v0.c.a;
							var nom = $author$project$Components$Produits$Common$Elements$nom(fiche.lQ);
							var dit = A2(
								$elm$core$Maybe$withDefault,
								{
									nh: $author$project$Components$Produits$FicheElement$Valeurs$Fermer,
									Cs: A3(
										$author$project$Components$Produits$Common$Refus$message,
										A4($author$project$Components$Produits$FicheElement$Model$contexteDuRefus, i18n, commande, model, fiche),
										refus,
										erreur),
									qb: $elm$core$Maybe$Nothing,
									h6: $elm$core$Maybe$Nothing
								},
								A5(
									$author$project$Components$Produits$FicheElement$Valeurs$refusDe,
									nom,
									A2($author$project$Components$Produits$FicheElement$Valeurs$bloc, ouvertes.fJ, fiche),
									commande,
									refus,
									erreur));
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										Ki: $elm$core$Maybe$Just(
											_Utils_update(
												ouvertes,
												{
													pZ: $elm$core$Maybe$Just(dit)
												}))
									}),
								$author$project$Components$Produits$Common$Refus$perime(erreur) ? $author$project$Components$Produits$FicheElement$Update$relire(model) : _List_Nil);
						} else {
							break _v0$3;
						}
					default:
						break _v0$3;
				}
			} else {
				break _v0$3;
			}
		}
		return _Utils_Tuple2(model, _List_Nil);
	});
var $author$project$Catalogue$Vocabulaire$etatActif = 'active';
var $author$project$Components$Produits$Common$Elements$appliquer = F3(
	function (liens, evenement, element) {
		var sur = F2(
			function (id, modifier) {
				return _Utils_eq(id, element.Aq) ? modifier(
					_Utils_update(
						element,
						{nQ: liens})) : element;
			});
		switch (evenement.$) {
			case 1:
				var id = evenement.a;
				var renommee = evenement.b;
				return A2(
					sur,
					id,
					function (lu) {
						return _Utils_update(
							lu,
							{
								R: {yg: $elm$core$Maybe$Nothing, zX: renommee}
							});
					});
			case 2:
				var id = evenement.a;
				var sousLicence = evenement.b;
				return A2(
					sur,
					id,
					function (lu) {
						return _Utils_update(
							lu,
							{
								IY: $elm$core$Maybe$Just(sousLicence)
							});
					});
			case 3:
				var id = evenement.a;
				return A2(
					sur,
					id,
					function (lu) {
						return _Utils_update(
							lu,
							{gt: $author$project$Catalogue$Vocabulaire$etatArchive});
					});
			case 4:
				var id = evenement.a;
				return A2(
					sur,
					id,
					function (lu) {
						return _Utils_update(
							lu,
							{gt: $author$project$Catalogue$Vocabulaire$etatActif});
					});
			case 6:
				var id = evenement.a;
				var libelles = evenement.b;
				return A2(
					sur,
					id,
					function (lu) {
						return _Utils_update(
							lu,
							{R: libelles});
					});
			case 7:
				var id = evenement.a;
				var millesime = evenement.b;
				return A2(
					sur,
					id,
					function (lu) {
						return _Utils_update(
							lu,
							{n8: millesime});
					});
			case 8:
				var id = evenement.a;
				return A2(
					sur,
					id,
					function (lu) {
						return _Utils_update(
							lu,
							{gt: $author$project$Catalogue$Vocabulaire$etatArchive});
					});
			case 11:
				var id = evenement.a;
				return A2(
					sur,
					id,
					function (lu) {
						return _Utils_update(
							lu,
							{
								tw: $elm$core$Maybe$Just(
									{mn: _List_Nil, cU: _List_Nil, rO: true})
							});
					});
			default:
				return element;
		}
	});
var $author$project$Components$Produits$FicheElement$Model$cochee = F3(
	function (id, appartient, gamme) {
		return _Utils_eq(gamme.Aq, id) ? _Utils_update(
			gamme,
			{tx: appartient, nQ: _List_Nil}) : gamme;
	});
var $author$project$Components$Produits$Common$Elements$idDuNiveau = function (servi) {
	return servi.Aq;
};
var $author$project$Components$Produits$Common$Elements$cree = function (fourni) {
	return {
		tw: $elm$core$Maybe$Nothing,
		fA: fourni.os.fA,
		dt: $elm$core$Maybe$Nothing,
		gi: false,
		yp: 0,
		gt: $author$project$Catalogue$Vocabulaire$etatActif,
		Aq: fourni.Aq,
		R: fourni.R,
		nQ: fourni.nQ,
		n8: fourni.n8,
		os: $author$project$Components$Produits$Common$Elements$idDuNiveau(fourni.os),
		ey: fourni.ey,
		bY: fourni.bY,
		hD: 0,
		Hd: 0,
		IY: fourni.IY
	};
};
var $author$project$Components$Produits$FicheElement$Model$appliquer = F2(
	function (rendue, fiche) {
		var apres = F2(
			function (evenement, courante) {
				var _v0 = _Utils_Tuple2(evenement, courante.C8);
				_v0$4:
				while (true) {
					switch (_v0.a.$) {
						case 5:
							if (!_v0.b.$) {
								var _v1 = _v0.a;
								var id = _v1.a;
								var gamme = _v1.b;
								var niveau = _v0.b.a;
								return _Utils_update(
									courante,
									{
										yp: _Utils_ap(
											courante.yp,
											_List_fromArray(
												[
													$author$project$Components$Produits$Common$Elements$cree(
													{
														Aq: id,
														R: gamme.R,
														nQ: rendue.nQ,
														n8: gamme.n8,
														os: niveau,
														ey: gamme.ey,
														bY: $elm$core$List$length(courante.yp),
														IY: $elm$core$Maybe$Nothing
													})
												]))
									});
							} else {
								break _v0$4;
							}
						case 10:
							var _v2 = _v0.a;
							var id = _v2.a;
							var marque = _v2.b;
							return _Utils_eq(marque, courante.lQ.Aq) ? _Utils_update(
								courante,
								{
									yp: A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.Aq;
											},
											$elm$core$Basics$neq(id)),
										courante.yp),
									z4: A2(
										$elm$core$List$map,
										A2($author$project$Components$Produits$FicheElement$Model$cochee, id, false),
										courante.z4)
								}) : courante;
						case 9:
							var _v3 = _v0.a;
							var id = _v3.a;
							var marque = _v3.b;
							return _Utils_eq(marque, courante.lQ.Aq) ? _Utils_update(
								courante,
								{
									z4: A2(
										$elm$core$List$map,
										A2($author$project$Components$Produits$FicheElement$Model$cochee, id, true),
										courante.z4)
								}) : courante;
						case 12:
							var voulu = _v0.a.a;
							return _Utils_update(
								courante,
								{
									yp: _Utils_ap(
										A2(
											$elm$core$List$filterMap,
											function (id) {
												return $elm$core$List$head(
													A2(
														$elm$core$List$filter,
														A2(
															$elm$core$Basics$composeR,
															function ($) {
																return $.Aq;
															},
															$elm$core$Basics$eq(id)),
														courante.yp));
											},
											voulu.El),
										A2(
											$elm$core$List$filter,
											function (porte) {
												return !A2($elm$core$List$member, porte.Aq, voulu.El);
											},
											courante.yp))
								});
						default:
							break _v0$4;
					}
				}
				return _Utils_update(
					courante,
					{
						lQ: A3($author$project$Components$Produits$Common$Elements$appliquer, rendue.nQ, evenement, courante.lQ),
						yp: A2(
							$elm$core$List$map,
							A2($author$project$Components$Produits$Common$Elements$appliquer, rendue.nQ, evenement),
							courante.yp)
					});
			});
		return A3($elm$core$List$foldl, apres, fiche, rendue.mk);
	});
var $author$project$Components$Produits$FicheElement$Update$estUnArchivage = function (commande) {
	switch (commande.$) {
		case 2:
			return true;
		case 6:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Produits$FicheElement$Update$idDuNom = function (model) {
	return A2(
		$author$project$Components$Produits$Common$Formulaire$idDuNom,
		A2(
			$elm$core$Maybe$withDefault,
			0,
			$author$project$Components$Produits$FicheElement$Model$formeDuGeste(model)),
		$author$project$Components$Shared$Drawer$Model$idRacine(model.kX));
};
var $author$project$Components$Produits$Common$Formulaire$idDuRefus = function (prefixe) {
	return prefixe + '-refus';
};
var $author$project$Components$Produits$FicheElement$Update$relecture = F2(
	function (rendue, model) {
		return (rendue.sy && (!A2($elm$core$List$member, $author$project$Catalogue$API$WriteAPIModel$EvenementInconnu, rendue.mk))) ? $author$project$Components$Produits$FicheElement$Update$relire(model) : _List_fromArray(
			[
				$author$project$Components$Produits$Common$Effet$AttendreAvantDeRelire($author$project$Components$Produits$Common$Envoi$delaiDeRelectureMs)
			]);
	});
var $author$project$Components$Produits$FicheElement$Update$concluDuCatalogue = F3(
	function (i18n, issue, model) {
		var saisie = model.hP;
		var dansLeDrawer = $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX);
		switch (issue.$) {
			case 0:
				if (issue.c) {
					var rendue = issue.b;
					return A2(
						$elm$core$Tuple$mapSecond,
						function (effets) {
							return _Utils_ap(
								effets,
								A2($author$project$Components$Produits$FicheElement$Update$relecture, rendue, model));
						},
						(dansLeDrawer ? $author$project$Components$Produits$FicheElement$Update$versLeDrawer($author$project$Components$Shared$Drawer$Update$Fermer) : function (ferme) {
							return _Utils_Tuple2(ferme, _List_Nil);
						})(
							_Utils_update(
								model,
								{
									zo: A2(
										$elm$core$Maybe$map,
										$author$project$Components$Produits$FicheElement$Model$appliquer(rendue),
										model.zo),
									mW: $author$project$Components$Produits$FicheElement$Model$AucunGeste,
									hP: $author$project$Components$Produits$Common$Saisie$vide
								})));
				} else {
					return _Utils_Tuple2(
						dansLeDrawer ? _Utils_update(
							model,
							{
								hP: _Utils_update(
									saisie,
									{
										pZ: $elm$core$Maybe$Just($author$project$Components$Produits$Common$Refus$rejeu)
									})
							}) : model,
						$author$project$Components$Produits$FicheElement$Update$relire(model));
				}
			case 1:
				var commande = issue.a;
				var refus = issue.b;
				var erreur = issue.c;
				var _v1 = _Utils_Tuple3(dansLeDrawer, erreur, model.zo);
				_v1$2:
				while (true) {
					if (_v1.a) {
						if (!_v1.b.$) {
							var _v2 = _v1.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										hP: _Utils_update(
											saisie,
											{gi: true})
									}),
								_List_fromArray(
									[
										$author$project$Components$Produits$Common$Effet$PlacerFocus(
										$author$project$Components$Produits$FicheElement$Update$idDuNom(model))
									]));
						} else {
							if (!_v1.c.$) {
								var fiche = _v1.c.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											hP: _Utils_update(
												saisie,
												{
													pZ: $elm$core$Maybe$Just(
														A3(
															$author$project$Components$Produits$Common$Refus$message,
															A4($author$project$Components$Produits$FicheElement$Model$contexteDuRefus, i18n, commande, model, fiche),
															refus,
															erreur))
												})
										}),
									_Utils_ap(
										$author$project$Components$Produits$FicheElement$Update$estUnArchivage(commande) ? _List_fromArray(
											[
												$author$project$Components$Produits$Common$Effet$PlacerFocus(
												$author$project$Components$Produits$Common$Formulaire$idDuRefus(
													$author$project$Components$Shared$Drawer$Model$idRacine(model.kX)))
											]) : _List_Nil,
										$author$project$Components$Produits$Common$Refus$perime(erreur) ? $author$project$Components$Produits$FicheElement$Update$relire(model) : _List_Nil));
							} else {
								break _v1$2;
							}
						}
					} else {
						break _v1$2;
					}
				}
				return _Utils_Tuple2(
					model,
					$author$project$Components$Produits$Common$Refus$perime(erreur) ? $author$project$Components$Produits$FicheElement$Update$relire(model) : _List_Nil);
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$Common$Effet$LireLOrdreDesBlocs = function (a) {
	return {$: 10, a: a};
};
var $author$project$Catalogue$API$WriteAPIModel$OrdonnerLesBlocs = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$ReprendreLOrdreDuParent = function (a) {
	return {$: 18, a: a};
};
var $author$project$API$NavLinksDictionary$reprendreLOrdreDuParent = 'reprendre-l-ordre-du-parent';
var $author$project$Components$Produits$FicheElement$Update$versLesBlocs = F2(
	function (geste, model) {
		var _v0 = A2($author$project$Components$Shared$OrdreDesBlocs$Update$update, geste, model.o1);
		var ordre = _v0.a;
		var effets = _v0.b;
		var sortie = _v0.c;
		var focus = A2(
			$elm$core$List$map,
			function (_v5) {
				var cible = _v5;
				return $author$project$Components$Produits$Common$Effet$PlacerFocus(cible);
			},
			effets);
		var porteur = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.c0;
				},
				ordre.B0));
		var suivant = _Utils_update(
			model,
			{o1: ordre});
		var lancer = F2(
			function (commande, rel) {
				var _v2 = A2(
					$elm$core$Maybe$andThen,
					function (lu) {
						return A2($author$project$API$Liens$trouver, rel, lu.nQ);
					},
					ordre.B0);
				if (!_v2.$) {
					var lien = _v2.a;
					var _v3 = A3(
						$author$project$Components$Produits$Common$Envoi$partir,
						$elm$core$Maybe$Just(lien),
						commande,
						suivant.l2);
					if (!_v3.$) {
						var _v4 = _v3.a;
						var envoi = _v4.a;
						var partis = _v4.b;
						return _Utils_Tuple2(
							_Utils_update(
								suivant,
								{l2: envoi}),
							_Utils_ap(focus, partis));
					} else {
						return _Utils_Tuple2(suivant, focus);
					}
				} else {
					return _Utils_Tuple2(suivant, focus);
				}
			});
		switch (sortie.$) {
			case 0:
				return _Utils_Tuple2(suivant, focus);
			case 1:
				var lien = sortie.a;
				return _Utils_Tuple2(
					suivant,
					_Utils_ap(
						focus,
						_List_fromArray(
							[
								$author$project$Components$Produits$Common$Effet$LireLOrdreDesBlocs(lien)
							])));
			case 2:
				var voulu = sortie.a;
				return A2(
					lancer,
					A2($author$project$Catalogue$API$WriteAPIModel$OrdonnerLesBlocs, porteur, voulu),
					$author$project$API$NavLinksDictionary$ordonnerLesBlocs);
			default:
				return A2(
					lancer,
					$author$project$Catalogue$API$WriteAPIModel$ReprendreLOrdreDuParent(porteur),
					$author$project$API$NavLinksDictionary$reprendreLOrdreDuParent);
		}
	});
var $author$project$Components$Produits$FicheElement$Update$conclureLOrdre = F2(
	function (issue, model) {
		switch (issue.$) {
			case 0:
				if (issue.c) {
					var rendue = issue.b;
					var _v1 = A2(
						$author$project$Components$Produits$FicheElement$Update$versLesBlocs,
						$author$project$Components$Shared$OrdreDesBlocs$Update$DuDrawer($author$project$Components$Shared$Drawer$Update$Fermer),
						_Utils_update(
							model,
							{
								o1: $author$project$Components$Shared$OrdreDesBlocs$Model$abouti(model.o1)
							}));
					var fermee = _v1.a;
					var focus = _v1.b;
					return _Utils_Tuple2(
						fermee,
						_Utils_ap(
							focus,
							A2($author$project$Components$Produits$FicheElement$Update$relecture, rendue, fermee)));
				} else {
					return _Utils_Tuple2(
						model,
						$author$project$Components$Produits$FicheElement$Update$relire(model));
				}
			case 1:
				return _Utils_Tuple2(model, _List_Nil);
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$FicheElement$Update$estLeDrawerDesValeurs = function (model) {
	var _v0 = model.mW;
	if (_v0.$ === 4) {
		return !_Utils_eq(model.Ki, $elm$core$Maybe$Nothing);
	} else {
		return false;
	}
};
var $author$project$Components$Produits$FicheElement$Update$conclure = F3(
	function (i18n, issue, model) {
		return $author$project$Components$Produits$FicheElement$Update$commandeDOrdre(issue) ? A2($author$project$Components$Produits$FicheElement$Update$conclureLOrdre, issue, model) : (($author$project$Components$Produits$FicheElement$Update$estLeDrawerDesValeurs(model) && _Utils_eq(
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					return true;
				},
				$author$project$Components$Produits$FicheElement$Update$commandeDesValeurs(issue)),
			$elm$core$Maybe$Just(true))) ? A3($author$project$Components$Produits$FicheElement$Update$concluDesValeurs, i18n, issue, model) : A3($author$project$Components$Produits$FicheElement$Update$concluDuCatalogue, i18n, issue, model));
	});
var $author$project$Components$Produits$Common$Saisie$deLElement = function (element) {
	return $author$project$Components$Produits$Common$Saisie$ouverte(
		{
			R: $author$project$Components$Produits$Common$LibellesSaisis$enSaisie(
				{
					yg: A2($elm$core$Maybe$withDefault, '', element.R.yg),
					zX: element.R.zX
				}),
			n8: A2($elm$core$Maybe$withDefault, '', element.n8),
			Dj: element.R.zX,
			IY: A2($elm$core$Maybe$withDefault, false, element.IY)
		});
};
var $author$project$Catalogue$API$WriteAPIModel$PoserLesValeursDeChampsHerites = F2(
	function (a, b) {
		return {$: 64, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$poserLesValeursDeChampsHerites = 'poser-les-valeurs-de-champs-herites';
var $author$project$Components$Produits$FicheElement$Valeurs$commandeDeLaSaisie = F2(
	function (ouvertes, fiche) {
		var _v0 = A2($author$project$Components$Produits$FicheElement$Valeurs$bloc, ouvertes.fJ, fiche);
		if (!_v0.$) {
			var page = _v0.a;
			var _v1 = A2(
				$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$modifications,
				$author$project$Components$Produits$FicheElement$Valeurs$champs(page),
				ouvertes.hP);
			if (!_v1.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var touches = _v1;
				return A2(
					$elm$core$Maybe$map,
					function (lien) {
						return _Utils_Tuple2(
							A2(
								$author$project$Catalogue$API$WriteAPIModel$PoserLesValeursDeChampsHerites,
								page.F$,
								A2(
									$elm$core$List$map,
									function (_v2) {
										var cle = _v2.a;
										var valeur = _v2.b;
										return _Utils_Tuple2(
											cle,
											$author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$encode(valeur));
									},
									touches)),
							lien);
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filterMap,
							function (champ) {
								return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$poserLesValeursDeChampsHerites, champ.nQ);
							},
							page.dw)));
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$FicheElement$Update$partirAvecLesValeurs = F3(
	function (_v0, ouvertes, model) {
		var commande = _v0.a;
		var lien = _v0.b;
		var _v1 = A3(
			$author$project$Components$Produits$Common$Envoi$partir,
			$elm$core$Maybe$Just(lien),
			commande,
			model.l2);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var envoi = _v2.a;
			var effets = _v2.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: envoi,
						Ki: $elm$core$Maybe$Just(
							_Utils_update(
								ouvertes,
								{pZ: $elm$core$Maybe$Nothing}))
					}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$FicheElement$Update$enregistrerLesValeurs = function (model) {
	var _v0 = _Utils_Tuple2(model.Ki, model.zo);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var ouvertes = _v0.a.a;
		var fiche = _v0.b.a;
		var _v1 = A2($author$project$Components$Produits$FicheElement$Valeurs$commandeDeLaSaisie, ouvertes, fiche);
		if (!_v1.$) {
			var commande = _v1.a;
			return A3($author$project$Components$Produits$FicheElement$Update$partirAvecLesValeurs, commande, ouvertes, model);
		} else {
			return A2($author$project$Components$Produits$FicheElement$Update$fermerLesValeurs, $elm$core$Maybe$Nothing, model);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$FicheElement$Update$foyerHorsDuVolet = F2(
	function (model, foyer) {
		return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(foyer);
	});
var $author$project$Components$Produits$FicheElement$Model$idDeLArchivage = function (id) {
	return 'element-' + ($author$project$Catalogue$Identifiants$elementIdToString(id) + '-archiver');
};
var $author$project$Components$Produits$FicheElement$Model$idDeLOrdre = 'ordonner-les-gammes';
var $author$project$Components$Produits$FicheElement$Model$idDeLaCreation = 'elements-creer';
var $author$project$Components$Produits$FicheElement$Model$idDeLaModification = function (id) {
	return 'element-' + ($author$project$Catalogue$Identifiants$elementIdToString(id) + '-modifier');
};
var $author$project$Components$Produits$FicheElement$Model$idDeLaSection = 'elements-portes';
var $author$project$Components$Produits$FicheElement$Model$idDuBoutonDesValeurs = function (rang) {
	return 'valeurs-modifier-' + $elm$core$String$fromInt(rang);
};
var $author$project$Components$Produits$FicheElement$Model$idsDeLaConfirmation = {to: 'archivage-annuler', j7: 'archivage-confirmer', Cs: 'archivage-message', GN: 'archivage', h6: 'archivage-titre'};
var $author$project$Components$Produits$FicheElement$Model$annonce = F2(
	function (deplace, elements) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Traductions$tel(''),
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var place = _v0.a;
					var element = _v0.b;
					return $author$project$I18n$Textes$produitsStructureOrdreAnnonce(
						{
							Dj: $author$project$I18n$Traductions$tel(
								$author$project$Components$Produits$Common$Elements$nom(element)),
							bY: $author$project$I18n$Traductions$tel(
								$elm$core$String$fromInt(place + 1)),
							JE: $author$project$I18n$Traductions$tel(
								$elm$core$String$fromInt(
									$elm$core$List$length(elements)))
						});
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$second,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(deplace))),
						A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, elements)))));
	});
var $author$project$Components$Produits$FicheElement$Model$ordonnables = function (fiche) {
	return A2(
		$elm$core$List$filter,
		A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Components$Produits$Common$Elements$archive),
		fiche.yp);
};
var $author$project$Components$Produits$FicheElement$Update$ordonner = F4(
	function (deplace, deplacer, foyer, model) {
		var _v0 = model.zo;
		if (!_v0.$) {
			var fiche = _v0.a;
			var places = deplacer(
				$author$project$Components$Produits$FicheElement$Model$ordonnables(fiche));
			var voulus = _Utils_ap(
				places,
				A2($elm$core$List$filter, $author$project$Components$Produits$Common$Elements$archive, fiche.yp));
			if (_Utils_eq(voulus, fiche.yp)) {
				return _Utils_Tuple2(model, _List_Nil);
			} else {
				var _v1 = A2(
					$elm$core$Maybe$andThen,
					function (_v2) {
						var commande = _v2.a;
						var lien = _v2.b;
						return A3(
							$author$project$Components$Produits$Common$Envoi$partir,
							$elm$core$Maybe$Just(lien),
							commande,
							model.l2);
					},
					A2($author$project$Components$Produits$FicheElement$Model$commandeDOrdre, voulus, fiche));
				if (!_v1.$) {
					var _v3 = _v1.a;
					var envoi = _v3.a;
					var effets = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iP: A2($author$project$Components$Produits$FicheElement$Model$annonce, deplace, places),
								l2: envoi,
								zo: $elm$core$Maybe$Just(
									_Utils_update(
										fiche,
										{yp: voulus})),
								mS: foyer,
								o2: $elm$core$Maybe$Just(fiche.yp)
							}),
						effets);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$FicheElement$Update$ordreLu = F2(
	function (reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Shared$OrdreDesBlocs$Model$decoder, reponse);
		if (!_v0.$) {
			var lu = _v0.a;
			return A2(
				$author$project$Components$Produits$FicheElement$Update$versLesBlocs,
				$author$project$Components$Shared$OrdreDesBlocs$Update$OrdreLu(lu),
				model);
		} else {
			var refus = _v0.a;
			return _Utils_Tuple2(
				model,
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Produits$FicheElement$Update$ouvrir = F4(
	function (geste, declencheur, saisie, model) {
		var drawer = model.kX;
		return A2(
			$author$project$Components$Produits$FicheElement$Update$versLeDrawer,
			$author$project$Components$Shared$Drawer$Update$Ouvrir(declencheur),
			_Utils_update(
				model,
				{
					kX: _Utils_update(
						drawer,
						{
							Dj: $author$project$Components$Produits$FicheElement$Model$nomDuDrawer(geste)
						}),
					mW: geste,
					hP: saisie
				}));
	});
var $author$project$Components$Produits$FicheElement$Valeurs$valeurLue = function (champ) {
	return A2(
		$elm$core$Maybe$andThen,
		A2(
			$elm$core$Basics$composeR,
			$elm$json$Json$Decode$decodeValue($author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$decoder),
			$elm$core$Result$toMaybe),
		champ.fm);
};
var $author$project$Components$Produits$FicheElement$Valeurs$ouvrir = F2(
	function (rang, fiche) {
		return A2(
			$elm$core$Maybe$map,
			function (page) {
				return {
					fJ: rang,
					pZ: $elm$core$Maybe$Nothing,
					hP: A2(
						$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$depuis,
						{
							dw: $author$project$Components$Produits$FicheElement$Valeurs$champs(page),
							Ba: fiche.Ba
						},
						A2(
							$elm$core$List$filterMap,
							function (champ) {
								return A2(
									$elm$core$Maybe$map,
									$elm$core$Tuple$pair(champ.uN.dy),
									$author$project$Components$Produits$FicheElement$Valeurs$valeurLue(champ));
							},
							page.dw))
				};
			},
			A2($author$project$Components$Produits$FicheElement$Valeurs$bloc, rang, fiche));
	});
var $author$project$Components$Produits$FicheElement$Valeurs$prefixe = 'valeur-d-etage';
var $author$project$Components$Produits$FicheElement$Valeurs$recompter = F3(
	function (nomDeLaMarque, page, refus) {
		var _v0 = _Utils_Tuple3(refus.qb, refus.nh, page);
		if (((!_v0.a.$) && (_v0.b.$ === 1)) && (!_v0.c.$)) {
			var refusee = _v0.a.a;
			var _v1 = _v0.b;
			var cle = _v1.a;
			var lue = _v0.c.a;
			var _v2 = $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (c) {
						return _Utils_eq(c.dy, cle);
					},
					lue.jN));
			if (!_v2.$) {
				var choix = _v2.a;
				var n = $elm$core$List$length(choix.pE);
				var message = refus.Cs;
				var libelle = A2(
					$elm$core$Maybe$withDefault,
					cle,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.uN;
							},
							function ($) {
								return $.Bl;
							}),
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (c) {
									return _Utils_eq(c.uN.dy, cle);
								},
								lue.dw))));
				return _Utils_update(
					refus,
					{
						nh: A2($author$project$Components$Produits$FicheElement$Valeurs$ChoisirParmi, cle, n),
						Cs: _Utils_update(
							message,
							{
								Jx: A4($author$project$Components$Produits$FicheElement$Valeurs$restriction, nomDeLaMarque, refusee, libelle, n)
							})
					});
			} else {
				return refus;
			}
		} else {
			return refus;
		}
	});
var $author$project$Components$Produits$FicheElement$Update$recomptee = F2(
	function (fiche, ouvertes) {
		return _Utils_update(
			ouvertes,
			{
				pZ: A2(
					$elm$core$Maybe$map,
					A2(
						$author$project$Components$Produits$FicheElement$Valeurs$recompter,
						$author$project$Components$Produits$Common$Elements$nom(fiche.lQ),
						A2($author$project$Components$Produits$FicheElement$Valeurs$bloc, ouvertes.fJ, fiche)),
					ouvertes.pZ)
			});
	});
var $author$project$Components$Produits$FicheElement$Model$idDeLOuverture = function (id) {
	return 'element-' + ($author$project$Catalogue$Identifiants$elementIdToString(id) + '-ouvrir');
};
var $author$project$Components$Produits$FicheElement$Model$idDeLaCase = function (id) {
	return 'element-' + ($author$project$Catalogue$Identifiants$elementIdToString(id) + '-case');
};
var $author$project$Components$Produits$FicheElement$Model$idDuBoutonDOrdre = F2(
	function (id, sens) {
		return 'element-' + ($author$project$Catalogue$Identifiants$elementIdToString(id) + $author$project$Components$Shared$Ordre$suffixe(sens));
	});
var $author$project$Components$Produits$FicheElement$Model$idDuFoyer = F2(
	function (fiche, foyer) {
		var places = A2(
			$elm$core$List$map,
			function ($) {
				return $.Aq;
			},
			$author$project$Components$Produits$FicheElement$Model$ordonnables(fiche));
		switch (foyer.$) {
			case 0:
				var id = foyer.a;
				var sens = foyer.b;
				return A2(
					$author$project$Components$Produits$FicheElement$Model$idDuBoutonDOrdre,
					id,
					function () {
						if (!sens) {
							return _Utils_eq(
								$elm$core$List$head(places),
								$elm$core$Maybe$Just(id)) ? 1 : 0;
						} else {
							return _Utils_eq(
								$elm$core$List$head(
									$elm$core$List$reverse(places)),
								$elm$core$Maybe$Just(id)) ? 0 : 1;
						}
					}());
			case 1:
				var id = foyer.a;
				return _Utils_eq(
					A2($author$project$Components$Produits$FicheElement$Model$commandeDArchivage, id, fiche),
					$elm$core$Maybe$Nothing) ? $author$project$Components$Produits$FicheElement$Model$idDeLaSection : $author$project$Components$Produits$FicheElement$Model$idDeLArchivage(id);
			case 2:
				var id = foyer.a;
				return _Utils_eq(
					A2($author$project$Components$Produits$FicheElement$Model$commandeDOuverture, id, fiche),
					$elm$core$Maybe$Nothing) ? $author$project$Components$Produits$FicheElement$Model$idDeLaSection : $author$project$Components$Produits$FicheElement$Model$idDeLOuverture(id);
			default:
				var id = foyer.a;
				return $author$project$Components$Produits$FicheElement$Model$idDeLaCase(id);
		}
	});
var $author$project$Components$Produits$FicheElement$Update$rendreLeFocus = function (_v0) {
	var model = _v0.a;
	var effets = _v0.b;
	var _v1 = _Utils_Tuple2(model.mS, model.zo);
	if ((!_v1.a.$) && (!_v1.b.$)) {
		var foyer = _v1.a.a;
		var fiche = _v1.b.a;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{mS: $elm$core$Maybe$Nothing}),
			A2($elm$core$List$member, $author$project$Components$Produits$Common$Effet$Reconnecter, effets) ? effets : _Utils_ap(
				effets,
				_List_fromArray(
					[
						$author$project$Components$Produits$Common$Effet$PlacerFocus(
						A2($author$project$Components$Produits$FicheElement$Model$idDuFoyer, fiche, foyer))
					])));
	} else {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{mS: $elm$core$Maybe$Nothing}),
			effets);
	}
};
var $author$project$Catalogue$API$WriteAPIModel$ModifierUneGamme = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$Produits$Common$Gammes$gammeExistante = F2(
	function (gammes, saisie) {
		var normalise = A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$String$toLower);
		var saisi = normalise(
			A2($author$project$Components$Shared$LibellesParLangue$Model$lire, 'fr', saisie.R));
		return (saisi === '') ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.R;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.zX;
						},
						A2(
							$elm$core$Basics$composeR,
							normalise,
							$elm$core$Basics$eq(saisi)))),
				gammes));
	});
var $author$project$Components$Produits$FicheElement$Model$dejaPortee = F2(
	function (fiche, saisie) {
		return _Utils_eq(fiche.lQ.fA, $author$project$Catalogue$Vocabulaire$codeMarque) && A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.tx;
				},
				A2($author$project$Components$Produits$Common$Gammes$gammeExistante, fiche.z4, saisie)));
	});
var $author$project$Components$Produits$FicheElement$Model$sousLaFiche = function (fiche) {
	return _Utils_eq(fiche.lQ.fA, $author$project$Catalogue$Vocabulaire$codeMarque) ? _Utils_Tuple2(
		$elm$core$Maybe$Just(fiche.lQ.Aq),
		$elm$core$Maybe$Nothing) : _Utils_Tuple2(
		$elm$core$Maybe$Nothing,
		$elm$core$Maybe$Just(fiche.lQ.Aq));
};
var $author$project$Components$Produits$FicheElement$Model$commande = function (model) {
	var _v0 = _Utils_Tuple2(model.mW, model.zo);
	_v0$2:
	while (true) {
		if (!_v0.b.$) {
			switch (_v0.a.$) {
				case 1:
					var _v1 = _v0.a;
					var fiche = _v0.b.a;
					var _v2 = _Utils_Tuple3(
						A2($author$project$Components$Produits$FicheElement$Model$dejaPortee, fiche, model.hP),
						$author$project$Components$Produits$FicheElement$Model$formeDeLaCreation(fiche),
						fiche.C8);
					if (((!_v2.a) && (!_v2.b.$)) && (!_v2.c.$)) {
						var _v3 = _v2.b.a;
						var forme = _v3.a;
						var lien = _v3.b;
						var niveau = _v2.c.a;
						var _v4 = A2($author$project$Components$Produits$Common$Saisie$valide, forme, model.hP);
						if ((!_v4.$) && (_v4.a.$ === 1)) {
							var gamme = _v4.a.a;
							var _v5 = $author$project$Components$Produits$FicheElement$Model$sousLaFiche(fiche);
							var marque = _v5.a;
							var parent = _v5.b;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$author$project$Catalogue$API$WriteAPIModel$CreerUneGamme(
										{R: gamme.R, gX: marque, n8: gamme.n8, os: niveau.Aq, ey: parent}),
									lien));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				case 2:
					var id = _v0.a.a;
					var fiche = _v0.b.a;
					return A2(
						$elm$core$Maybe$andThen,
						function (_v6) {
							var forme = _v6.a;
							var lien = _v6.b;
							return A2(
								$elm$core$Maybe$andThen,
								function (saisi) {
									switch (saisi.$) {
										case 0:
											var marque = saisi.a;
											return $elm$core$Maybe$Just(
												_Utils_Tuple2(
													A2($author$project$Catalogue$API$WriteAPIModel$ModifierUneMarque, id, marque),
													lien));
										case 1:
											var gamme = saisi.a;
											return $elm$core$Maybe$Just(
												_Utils_Tuple2(
													A2($author$project$Catalogue$API$WriteAPIModel$ModifierUneGamme, id, gamme),
													lien));
										default:
											return $elm$core$Maybe$Nothing;
									}
								},
								A2($author$project$Components$Produits$Common$Saisie$valide, forme, model.hP));
						},
						A2(
							$elm$core$Maybe$andThen,
							A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $author$project$Components$Produits$FicheElement$Model$formeDeLaModification),
							A2($author$project$Components$Produits$FicheElement$Model$cible, id, fiche)));
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Components$Produits$FicheElement$Update$valider = function (model) {
	var saisie = model.hP;
	var _v0 = $author$project$Components$Produits$FicheElement$Model$commande(model);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var commande = _v1.a;
		var lien = _v1.b;
		var _v2 = A3(
			$author$project$Components$Produits$Common$Envoi$partir,
			$elm$core$Maybe$Just(lien),
			commande,
			model.l2);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var envoi = _v3.a;
			var effets = _v3.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: envoi,
						hP: _Utils_update(
							saisie,
							{gi: false, pZ: $elm$core$Maybe$Nothing})
					}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_eq(model.mW, $author$project$Components$Produits$FicheElement$Model$AucunGeste) ? _Utils_Tuple2(model, _List_Nil) : _Utils_Tuple2(
			_Utils_update(
				model,
				{
					hP: $author$project$Components$Produits$Common$Saisie$tenter(saisie)
				}),
			_List_fromArray(
				[
					$author$project$Components$Produits$Common$Effet$PlacerFocus(
					$author$project$Components$Produits$FicheElement$Update$idDuNom(model))
				]));
	}
};
var $author$project$API$NavLinksDictionary$elementDuCatalogue = 'element-du-catalogue';
var $author$project$Components$Produits$Liens$versElement = F2(
	function (id, gabarits) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$API$NavLinksDictionary$variableUid,
						$author$project$Catalogue$Identifiants$elementIdToString(id))
					])),
			A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$elementDuCatalogue, gabarits));
	});
var $author$project$Components$Produits$FicheElement$Update$aiguiller = F3(
	function (i18n, msg, model) {
		var initial = $author$project$Components$Produits$FicheElement$Model$init;
		switch (msg.$) {
			case 0:
				var id = msg.a;
				var gabarits = msg.b;
				var _v1 = A2($author$project$Components$Produits$Liens$versElement, id, gabarits);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							initial,
							{
								np: $elm$core$Maybe$Just(lecture)
							}),
						_List_fromArray(
							[
								$author$project$Components$Produits$Common$Effet$DemanderProcessUid,
								$author$project$Components$Produits$Common$Effet$Lire(lecture)
							]));
				} else {
					return _Utils_Tuple2(initial, _List_Nil);
				}
			case 1:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$Components$Produits$Common$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 2:
				var reponse = msg.a;
				var _v2 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$FicheElement$API$QueryAPIModel$ficheDecoder, reponse);
				if (!_v2.$) {
					var fiche = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								zo: $elm$core$Maybe$Just(fiche),
								nf: false,
								Ki: A2(
									$elm$core$Maybe$map,
									$author$project$Components$Produits$FicheElement$Update$recomptee(fiche),
									model.Ki)
							}),
						_List_Nil);
				} else {
					var refus = _v2.a;
					return (refus.ri === 401) ? _Utils_Tuple2(
						model,
						_List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter])) : _Utils_Tuple2(
						_Utils_update(
							model,
							{nf: refus.ri === 404}),
						_List_Nil);
				}
			case 3:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Produits$FicheElement$Update$relire(model));
			case 25:
				var geste = msg.a;
				return A2($author$project$Components$Produits$FicheElement$Update$versLesBlocs, geste, model);
			case 26:
				var reponse = msg.a;
				return A2($author$project$Components$Produits$FicheElement$Update$ordreLu, reponse, model);
			case 4:
				var geste = msg.a;
				return A2($author$project$Components$Produits$FicheElement$Update$versLeDrawer, geste, model);
			case 5:
				return _Utils_eq(
					A2($elm$core$Maybe$andThen, $author$project$Components$Produits$FicheElement$Model$formeDeLaCreation, model.zo),
					$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A4($author$project$Components$Produits$FicheElement$Update$ouvrir, $author$project$Components$Produits$FicheElement$Model$Creation, $author$project$Components$Produits$FicheElement$Model$idDeLaCreation, $author$project$Components$Produits$Common$Saisie$vide, model);
			case 6:
				return _Utils_eq(
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$second,
						A2(
							$elm$core$Maybe$andThen,
							$author$project$Components$Produits$FicheElement$Model$commandeDOrdre(_List_Nil),
							model.zo)),
					$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A4($author$project$Components$Produits$FicheElement$Update$ouvrir, $author$project$Components$Produits$FicheElement$Model$Ordonner, $author$project$Components$Produits$FicheElement$Model$idDeLOrdre, $author$project$Components$Produits$Common$Saisie$vide, model);
			case 7:
				var id = msg.a;
				var _v3 = A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$first,
					A2(
						$elm$core$Maybe$andThen,
						$author$project$Components$Produits$FicheElement$Model$cible(id),
						model.zo));
				if (!_v3.$) {
					var element = _v3.a;
					return _Utils_eq(
						$author$project$Components$Produits$FicheElement$Model$formeDeLaModification(element),
						$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A4(
						$author$project$Components$Produits$FicheElement$Update$ouvrir,
						$author$project$Components$Produits$FicheElement$Model$Modification(id),
						$author$project$Components$Produits$FicheElement$Model$idDeLaModification(id),
						$author$project$Components$Produits$Common$Saisie$deLElement(element),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 8:
				var id = msg.a;
				var _v4 = A2(
					$elm$core$Maybe$andThen,
					function (_v5) {
						var commande = _v5.a;
						var lien = _v5.b;
						return A3(
							$author$project$Components$Produits$Common$Envoi$partir,
							$elm$core$Maybe$Just(lien),
							commande,
							model.l2);
					},
					A2(
						$elm$core$Maybe$andThen,
						$author$project$Components$Produits$FicheElement$Model$commandeDOuverture(id),
						model.zo));
				if (!_v4.$) {
					var _v6 = _v4.a;
					var envoi = _v6.a;
					var effets = _v6.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l2: envoi,
								mS: A2(
									$author$project$Components$Produits$FicheElement$Update$foyerHorsDuVolet,
									model,
									$author$project$Components$Produits$FicheElement$Model$ApresLOuverture(id))
							}),
						effets);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 9:
				var id = msg.a;
				var cochee = msg.b;
				var _v7 = A2(
					$elm$core$Maybe$andThen,
					function (_v8) {
						var commande = _v8.a;
						var lien = _v8.b;
						return A3(
							$author$project$Components$Produits$Common$Envoi$partir,
							$elm$core$Maybe$Just(lien),
							commande,
							model.l2);
					},
					A2(
						$elm$core$Maybe$andThen,
						cochee ? $author$project$Components$Produits$FicheElement$Model$commandeDeRattachement(id) : $author$project$Components$Produits$FicheElement$Model$commandeDeRetrait(id),
						model.zo));
				if (!_v7.$) {
					var _v9 = _v7.a;
					var envoi = _v9.a;
					var effets = _v9.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l2: envoi,
								mS: $elm$core$Maybe$Just(
									$author$project$Components$Produits$FicheElement$Model$SurLaCase(id))
							}),
						effets);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 10:
				var champ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hP: A2($author$project$Components$Produits$Common$Saisie$saisir, champ, model.hP)
						}),
					_List_Nil);
			case 24:
				var rang = msg.a;
				var _v10 = A2(
					$elm$core$Maybe$andThen,
					$author$project$Components$Produits$FicheElement$Valeurs$ouvrir(rang),
					model.zo);
				if (!_v10.$) {
					var ouvertes = _v10.a;
					return A4(
						$author$project$Components$Produits$FicheElement$Update$ouvrir,
						$author$project$Components$Produits$FicheElement$Model$Valeurs(rang),
						$author$project$Components$Produits$FicheElement$Model$idDuBoutonDesValeurs(rang),
						$author$project$Components$Produits$Common$Saisie$vide,
						_Utils_update(
							model,
							{
								Ki: $elm$core$Maybe$Just(ouvertes)
							}));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 27:
				var geste = msg.a;
				var _v11 = model.Ki;
				if (!_v11.$) {
					var ouvertes = _v11.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								Ki: $elm$core$Maybe$Just(
									_Utils_update(
										ouvertes,
										{
											hP: A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$saisir, geste, ouvertes.hP)
										}))
							}),
						_List_Nil);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 28:
				var cle = msg.a;
				var _v12 = _Utils_Tuple2(model.Ki, model.zo);
				if ((!_v12.a.$) && (!_v12.b.$)) {
					var ouvertes = _v12.a.a;
					var fiche = _v12.b.a;
					var _v13 = A3($author$project$Components$Produits$FicheElement$Valeurs$commandeDeRetrait, ouvertes.fJ, cle, fiche);
					if (!_v13.$) {
						var _v14 = _v13.a;
						var commande = _v14.a;
						var lien = _v14.b;
						return A3(
							$author$project$Components$Produits$FicheElement$Update$partirAvecLesValeurs,
							_Utils_Tuple2(commande, lien),
							ouvertes,
							model);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 29:
				var issue = msg.a;
				switch (issue.$) {
					case 0:
						var cle = issue.a;
						return _Utils_Tuple2(
							model,
							_List_fromArray(
								[
									$author$project$Components$Produits$Common$Effet$PlacerFocus(
									A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$idDuChamp, $author$project$Components$Produits$FicheElement$Valeurs$prefixe, cle))
								]));
					case 1:
						var cle = issue.a;
						return _Utils_Tuple2(
							model,
							_List_fromArray(
								[
									$author$project$Components$Produits$Common$Effet$PlacerFocus(
									A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$idDuChamp, $author$project$Components$Produits$FicheElement$Valeurs$prefixe, cle))
								]));
					case 2:
						return A2(
							$author$project$Components$Produits$FicheElement$Update$fermerLesValeurs,
							$elm$core$Maybe$Just($author$project$Components$Produits$FicheElement$Model$idDeLaSection),
							model);
					default:
						return A2($author$project$Components$Produits$FicheElement$Update$fermerLesValeurs, $elm$core$Maybe$Nothing, model);
				}
			case 11:
				return ((!_Utils_eq(model.mW, $author$project$Components$Produits$FicheElement$Model$Ordonner)) && $author$project$Components$Produits$FicheElement$Update$estLeDrawerDesValeurs(model)) ? $author$project$Components$Produits$FicheElement$Update$enregistrerLesValeurs(model) : (_Utils_eq(model.mW, $author$project$Components$Produits$FicheElement$Model$Ordonner) ? A2($author$project$Components$Produits$FicheElement$Update$versLeDrawer, $author$project$Components$Shared$Drawer$Update$Fermer, model) : $author$project$Components$Produits$FicheElement$Update$valider(model));
			case 22:
				return _Utils_Tuple2(model, _List_Nil);
			case 23:
				return _Utils_Tuple2(model, _List_Nil);
			case 30:
				var reponse = msg.a;
				var _v16 = A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, model.l2);
				if (!_v16.$) {
					var _v17 = _v16.a;
					var envoi = _v17.a;
					var issue = _v17.b;
					var effets = _v17.c;
					return $author$project$Components$Produits$FicheElement$Update$rendreLeFocus(
						A2(
							$author$project$Components$Produits$FicheElement$Update$apresLOrdre,
							issue,
							A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Basics$append(effets),
								A3(
									$author$project$Components$Produits$FicheElement$Update$conclure,
									i18n,
									issue,
									_Utils_update(
										model,
										{l2: envoi})))));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 12:
				var id = msg.a;
				return A4(
					$author$project$Components$Produits$FicheElement$Update$ordonner,
					id,
					$author$project$Components$Shared$Ordre$monter(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(id))),
					A2(
						$author$project$Components$Produits$FicheElement$Update$foyerHorsDuVolet,
						model,
						A2($author$project$Components$Produits$FicheElement$Model$SurLOrdre, id, 0)),
					model);
			case 13:
				var id = msg.a;
				return A4(
					$author$project$Components$Produits$FicheElement$Update$ordonner,
					id,
					$author$project$Components$Shared$Ordre$descendre(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(id))),
					A2(
						$author$project$Components$Produits$FicheElement$Update$foyerHorsDuVolet,
						model,
						A2($author$project$Components$Produits$FicheElement$Model$SurLOrdre, id, 1)),
					model);
			case 14:
				var id = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							m_: $elm$core$Maybe$Just(id)
						}),
					_List_Nil);
			case 15:
				return _Utils_Tuple2(model, _List_Nil);
			case 16:
				var surLui = msg.a;
				var _v18 = model.m_;
				if (!_v18.$) {
					var glisse = _v18.a;
					return A4(
						$author$project$Components$Produits$FicheElement$Update$ordonner,
						glisse,
						A2(
							$author$project$Components$Shared$Ordre$deposer,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(glisse)),
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(surLui))),
						$elm$core$Maybe$Nothing,
						_Utils_update(
							model,
							{m_: $elm$core$Maybe$Nothing}));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 17:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{m_: $elm$core$Maybe$Nothing}),
					_List_Nil);
			case 18:
				var id = msg.a;
				return _Utils_eq(
					A2(
						$elm$core$Maybe$andThen,
						$author$project$Components$Produits$FicheElement$Model$commandeDArchivage(id),
						model.zo),
					$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ir: $elm$core$Maybe$Just(id)
						}),
					_List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$PlacerFocus($author$project$Components$Produits$FicheElement$Model$idsDeLaConfirmation.to)
						]));
			case 19:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ir: $elm$core$Maybe$Nothing}),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Components$Produits$FicheElement$Model$idDeLArchivage,
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$PlacerFocus, $elm$core$List$singleton)),
							model.ir)));
			case 20:
				var _v19 = A2(
					$elm$core$Maybe$andThen,
					function (_v20) {
						var id = _v20.a;
						var fiche = _v20.b;
						return A2(
							$elm$core$Maybe$map,
							$elm$core$Tuple$pair(id),
							A2(
								$elm$core$Maybe$andThen,
								function (_v21) {
									var commande = _v21.a;
									var lien = _v21.b;
									return A3(
										$author$project$Components$Produits$Common$Envoi$partir,
										$elm$core$Maybe$Just(lien),
										commande,
										model.l2);
								},
								A2($author$project$Components$Produits$FicheElement$Model$commandeDArchivage, id, fiche)));
					},
					A3($elm$core$Maybe$map2, $elm$core$Tuple$pair, model.ir, model.zo));
				if (!_v19.$) {
					var _v22 = _v19.a;
					var id = _v22.a;
					var _v23 = _v22.b;
					var envoi = _v23.a;
					var effets = _v23.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ir: $elm$core$Maybe$Nothing,
								l2: envoi,
								mS: A2(
									$author$project$Components$Produits$FicheElement$Update$foyerHorsDuVolet,
									model,
									$author$project$Components$Produits$FicheElement$Model$ApresLArchivage(id))
							}),
						effets);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			default:
				var vers = msg.a;
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$PlacerFocus(vers)
						]));
		}
	});
var $author$project$Components$Produits$FicheElement$Model$idDuMenuDeLaGamme = function (id) {
	return 'gamme-' + ($author$project$Catalogue$Identifiants$elementIdToString(id) + '-menu');
};
var $author$project$Components$Produits$FicheElement$Update$update = F3(
	function (i18n, msg, model) {
		var _v0 = A3($author$project$Components$Produits$FicheElement$Update$aiguiller, i18n, msg, model);
		var suivant = _v0.a;
		var effets = _v0.b;
		switch (msg.$) {
			case 22:
				var id = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						suivant,
						{
							n7: _Utils_eq(
								model.n7,
								$elm$core$Maybe$Just(id)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(id)
						}),
					_Utils_eq(
						model.n7,
						$elm$core$Maybe$Just(id)) ? _List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$PlacerFocus(
							$author$project$Components$Produits$FicheElement$Model$idDuMenuDeLaGamme(id))
						]) : effets);
			case 23:
				return _Utils_Tuple2(
					_Utils_update(
						suivant,
						{n7: $elm$core$Maybe$Nothing}),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Components$Produits$FicheElement$Model$idDuMenuDeLaGamme,
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$PlacerFocus, $elm$core$List$singleton)),
							model.n7)));
			default:
				return _Utils_Tuple2(
					_Utils_update(
						suivant,
						{n7: $elm$core$Maybe$Nothing}),
					effets);
		}
	});
var $author$project$Main$Update$versLaFicheElement = F3(
	function (i18n, msg, model) {
		var _v0 = A3(
			$author$project$Components$Produits$FicheElement$Update$update,
			i18n,
			msg,
			A2(
				$author$project$Referentiel$Normes$poser,
				model.hd,
				$author$project$Components$Produits$FicheElement$Model$ouvrir(model.zr)));
		var ficheElement = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLesElements, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			A3($author$project$Main$Update$depuisLesElements, i18n, 1, 6),
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						zr: $author$project$Components$Produits$FicheElement$Model$envelopper(ficheElement),
						Ct: A2(
							$author$project$Main$Update$remonter,
							A3(
								$author$project$Components$Produits$FicheElement$Update$popMessages,
								i18n,
								$author$project$Components$Produits$FicheElement$Model$ouvrir(model.zr),
								msg),
							gardes)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$FicheDUnType = 6;
var $author$project$Main$Model$PourLaFicheType = 11;
var $author$project$Components$Produits$FicheType$API$QueryAPIModel$bibliothequeDecoder = $author$project$Components$Shared$Bibliotheque$Champ$bibliothequeDecoder;
var $author$project$Components$Produits$FicheType$API$QueryAPIModel$Fiche = function (typeDeProduit) {
	return function (emplacements) {
		return function (champs) {
			return function (minima) {
				return function (rattachements) {
					return function (bibliotheque) {
						return function (collections) {
							return function (editeur) {
								return function (liens) {
									return function (gabarits) {
										return function (regleDeCode) {
											return {dq: bibliotheque, dw: champs, vE: collections, x5: editeur, ye: emplacements, gF: gabarits, nQ: liens, CC: minima, GY: rattachements, hI: regleDeCode, fh: typeDeProduit};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Produits$FicheType$API$QueryAPIModel$champDeLaFicheDecoder = $author$project$Components$Shared$Bibliotheque$Champ$champDeLaFicheDecoder;
var $author$project$Components$Produits$FicheType$API$QueryAPIModel$ChampDuType = F4(
	function (champ, typeDeChamp, masque, liens) {
		return {uN: champ, nQ: liens, n4: masque, JR: typeDeChamp};
	});
var $author$project$Components$Produits$FicheType$API$QueryAPIModel$champDuTypeDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'masque',
		$elm$json$Json$Decode$bool,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'typeDeChamp',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'champ',
				$author$project$Components$Shared$EditeurDeSchema$Champ$decoder,
				$elm$json$Json$Decode$succeed($author$project$Components$Produits$FicheType$API$QueryAPIModel$ChampDuType)))));
var $author$project$Catalogue$RegleDeCode$Regle = F3(
	function (segments, formule, apercu) {
		return {tq: apercu, zU: formule, Iy: segments};
	});
var $author$project$Catalogue$RegleDeCode$CodeDUneValeur = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Catalogue$RegleDeCode$CodeDeLaMarque = function (a) {
	return {$: 1, a: a};
};
var $author$project$Catalogue$RegleDeCode$Compteur = {$: 3};
var $author$project$Catalogue$RegleDeCode$TexteFixe = function (a) {
	return {$: 0, a: a};
};
var $author$project$Catalogue$RegleDeCode$segmentDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'TexteFixe',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Catalogue$RegleDeCode$TexteFixe,
				A2($elm$json$Json$Decode$field, 'texte', $elm$json$Json$Decode$string))),
			A2(
			$elm$json$Json$Decode$field,
			'CodeDeLaMarque',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Catalogue$RegleDeCode$CodeDeLaMarque,
				A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string))),
			A2(
			$elm$json$Json$Decode$field,
			'CodeDUneValeur',
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Catalogue$RegleDeCode$CodeDUneValeur,
				A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$maybe(
					A2($elm$json$Json$Decode$field, 'tranche', $elm$json$Json$Decode$int)))),
			A2(
			$elm$json$Json$Decode$field,
			'Compteur',
			$elm$json$Json$Decode$succeed($author$project$Catalogue$RegleDeCode$Compteur))
		]));
var $author$project$Catalogue$RegleDeCode$decoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Catalogue$RegleDeCode$Regle,
	A2(
		$elm$json$Json$Decode$field,
		'segments',
		$elm$json$Json$Decode$list($author$project$Catalogue$RegleDeCode$segmentDecoder)),
	A2($elm$json$Json$Decode$field, 'formule', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'apercu', $elm$json$Json$Decode$string)));
var $author$project$Components$Produits$FicheType$API$QueryAPIModel$Emplacement = F6(
	function (typologie, nom, etage, chemins, noeuds, liens) {
		return {u9: chemins, md: etage, nQ: liens, Di: noeuds, Dj: nom, r3: typologie};
	});
var $author$project$Components$Produits$FicheType$API$QueryAPIModel$emplacementDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'noeuds',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'chemins',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
				_List_fromArray(
					['etage', 'libelle', 'fr']),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['typologie', 'libelle', 'fr']),
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['typologie', 'id']),
						$author$project$Catalogue$Identifiants$classificationIdDecoder,
						$elm$json$Json$Decode$succeed($author$project$Components$Produits$FicheType$API$QueryAPIModel$Emplacement)))))));
var $author$project$Components$Produits$FicheType$API$QueryAPIModel$minimaDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Shared$EditeurDeSchema$Model$MinimaVoulus,
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'largeurMinimale', $elm$json$Json$Decode$int)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'hauteurMinimale', $elm$json$Json$Decode$int)),
	A2($elm$json$Json$Decode$field, 'texteAlternatifExige', $elm$json$Json$Decode$bool));
var $author$project$Components$Produits$FicheType$API$QueryAPIModel$Rattachement = F7(
	function (niveauDeLecture, niveauDeSaisie, fige, valeursSaisies, exemple, etagesAdmis, restriction) {
		return {yH: etagesAdmis, yY: exemple, zC: fige, g4: niveauDeLecture, C7: niveauDeSaisie, al: restriction, Kp: valeursSaisies};
	});
var $author$project$Components$Produits$FicheType$API$QueryAPIModel$rattachementDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'restriction',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'etagesAdmis',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'exemple',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'valeursSaisies',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'fige',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'niveauDeSaisie',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'niveauDeLecture',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Components$Produits$FicheType$API$QueryAPIModel$Rattachement))))))));
var $author$project$Components$Produits$FicheType$API$QueryAPIModel$ficheDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'regleDeCode',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$RegleDeCode$decoder),
	$elm$core$Maybe$Nothing,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		A2(
			$elm$json$Json$Decode$map,
			function ($) {
				return $.gF;
			},
			$author$project$API$Liens$deLaRessource),
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2(
				$elm$json$Json$Decode$map,
				function ($) {
					return $.h0;
				},
				$author$project$API$Liens$deLaRessource),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'editeur',
				$author$project$Components$Shared$EditeurDeSchema$Propositions$decoder,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'collections',
					$author$project$Components$Shared$CollectionsDuType$Model$decoder,
					_List_Nil,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'bibliotheque',
						$elm$json$Json$Decode$dict($author$project$Components$Produits$FicheType$API$QueryAPIModel$champDeLaFicheDecoder),
						$elm$core$Dict$empty,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'rattachements',
							$elm$json$Json$Decode$dict($author$project$Components$Produits$FicheType$API$QueryAPIModel$rattachementDecoder),
							$elm$core$Dict$empty,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'minima',
								$elm$json$Json$Decode$dict($author$project$Components$Produits$FicheType$API$QueryAPIModel$minimaDecoder),
								$elm$core$Dict$empty,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'champs',
									$elm$json$Json$Decode$list($author$project$Components$Produits$FicheType$API$QueryAPIModel$champDuTypeDecoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'emplacements',
										$elm$json$Json$Decode$list($author$project$Components$Produits$FicheType$API$QueryAPIModel$emplacementDecoder),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'typeDeProduit',
											$author$project$Catalogue$API$QueryAPIModel$typeDeProduitDecoder,
											$elm$json$Json$Decode$succeed($author$project$Components$Produits$FicheType$API$QueryAPIModel$Fiche))))))))))));
var $author$project$Components$Produits$FicheType$API$QueryAPIModel$Historique = function (versions) {
	return {ss: versions};
};
var $author$project$Components$Produits$FicheType$API$QueryAPIModel$Version = F4(
	function (version, date, ajouts, modifications) {
		return {fx: ajouts, wv: date, g$: modifications, sq: version};
	});
var $author$project$Components$Produits$FicheType$API$QueryAPIModel$historiqueDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Components$Produits$FicheType$API$QueryAPIModel$Historique,
	A2(
		$elm$json$Json$Decode$field,
		'versions',
		$elm$json$Json$Decode$list(
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'modifications',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'ajouts',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'date',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'version',
							$elm$json$Json$Decode$int,
							$elm$json$Json$Decode$succeed($author$project$Components$Produits$FicheType$API$QueryAPIModel$Version))))))));
var $author$project$Components$Produits$FicheType$RestrictionDuChamp$listeDecoder = $author$project$Components$Shared$Bibliotheque$Restriction$listeDecoder;
var $author$project$Components$Produits$FicheType$ValeursPosees$Ligne = F6(
	function (etage, nom, intitule, valeur, portee, retrait) {
		return {md: etage, AS: intitule, Dj: nom, F$: portee, eW: retrait, fm: valeur};
	});
var $author$project$Components$Produits$FicheType$ValeursPosees$ligneDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function (liens) {
			return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerLaValeurDUnChampHerite, liens);
		},
		A2(
			$elm$json$Json$Decode$field,
			'_links',
			A2(
				$elm$json$Json$Decode$map,
				function ($) {
					return $.h0;
				},
				$author$project$API$Liens$decoder))),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'portee',
		$elm$json$Json$Decode$value,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'valeur',
			$elm$json$Json$Decode$value,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'intituleDeLaValeur',
				A2(
					$elm$json$Json$Decode$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.zX;
						},
						$elm$core$Maybe$Just),
					$author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'nom',
					A2(
						$elm$json$Json$Decode$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.zX;
							},
							$elm$core$Maybe$Just),
						$author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'etage',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Components$Produits$FicheType$ValeursPosees$Ligne)))))));
var $author$project$Components$Produits$FicheType$ValeursPosees$listeDecoder = A2(
	$elm$json$Json$Decode$field,
	'valeurs',
	$elm$json$Json$Decode$list($author$project$Components$Produits$FicheType$ValeursPosees$ligneDecoder));
var $author$project$I18n$Textes$produitsTypesErreurArchive = A3($author$project$I18n$Traductions$texte, 'produits.types.erreur.archive', _List_Nil, 'Cette catégorie est archivée : elle n\'évolue plus. La fiche vient d\'être relue.');
var $author$project$I18n$Textes$produitsTypesErreurChampDansLaBibliotheque = A3($author$project$I18n$Traductions$texte, 'produits.types.erreur.champ-dans-la-bibliotheque', _List_Nil, 'Un champ de la bibliothèque porte déjà ce nom ou cette clé.');
var $author$project$I18n$Textes$produitsTypesErreurChampInconnu = A3($author$project$I18n$Traductions$texte, 'produits.types.erreur.champ-inconnu', _List_Nil, 'Cette information n\'existe plus : la fiche vient d\'être relue.');
var $author$project$I18n$Textes$produitsTypesErreurDefinitionPartagee = A3($author$project$I18n$Traductions$texte, 'produits.types.erreur.definition-partagee', _List_Nil, 'La définition de ce champ est partagée : elle se modifie dans la bibliothèque, pas depuis ce type.');
var $author$project$I18n$Textes$produitsTypesErreurFiltrableNonAdmis = A3($author$project$I18n$Traductions$texte, 'produits.types.erreur.filtrable-non-admis', _List_Nil, 'Seuls les champs liste, choix multiple, choix dans une liste partagée et oui/non peuvent être filtrables.');
var $author$project$I18n$Textes$produitsTypesErreurPerime = A3($author$project$I18n$Traductions$texte, 'produits.types.erreur.perime', _List_Nil, 'La catégorie a changé entre-temps : la fiche vient d\'être relue. Recommencez si nécessaire.');
var $author$project$Components$Produits$FicheType$Update$message = F2(
	function (refus, erreur) {
		switch (erreur.$) {
			case 24:
				return {Jx: $author$project$I18n$Textes$produitsTypesErreurChampInconnu, b9: refus.b9};
			case 27:
				return {Jx: $author$project$I18n$Textes$produitsTypesErreurFiltrableNonAdmis, b9: refus.b9};
			case 28:
				return {Jx: $author$project$I18n$Textes$produitsTypesErreurDefinitionPartagee, b9: refus.b9};
			case 25:
				return {Jx: $author$project$I18n$Textes$produitsTypesErreurChampDansLaBibliotheque, b9: refus.b9};
			case 16:
				return {Jx: $author$project$I18n$Textes$produitsCatalogueErreurOrdreInvalide, b9: refus.b9};
			case 17:
				return {Jx: $author$project$I18n$Textes$produitsTypesErreurArchive, b9: refus.b9};
			case 77:
				return $author$project$Components$Shared$Messages$Model$duRefus(refus);
			case 66:
				return $author$project$Components$Shared$Messages$Model$duRefus(refus);
			default:
				return {Jx: $author$project$I18n$Textes$produitsTypesErreurPerime, b9: refus.b9};
		}
	});
var $author$project$Components$Produits$FicheType$Update$popMessages = F2(
	function (model, msg) {
		var deLaLecture = function (lue) {
			if (lue.$ === 1) {
				var refus = lue.a;
				return A2(
					$elm$core$List$member,
					refus.ri,
					_List_fromArray(
						[401, 404])) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Components$Shared$Messages$Model$duRefus(refus));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		switch (msg.$) {
			case 23:
				var reponse = msg.a;
				var _v1 = _Utils_Tuple2(
					$author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) || ((!_Utils_eq(model.al, $elm$core$Maybe$Nothing)) || (!_Utils_eq(model.hI, $elm$core$Maybe$Nothing))),
					A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, model.l2));
				_v1$2:
				while (true) {
					if ((!_v1.a) && (!_v1.b.$)) {
						switch (_v1.b.a.b.$) {
							case 0:
								if (!_v1.b.a.b.c) {
									var _v2 = _v1.b.a;
									var _v3 = _v2.b;
									return $elm$core$Maybe$Just($author$project$Components$Produits$Common$Refus$rejeu);
								} else {
									break _v1$2;
								}
							case 1:
								var _v4 = _v1.b.a;
								var _v5 = _v4.b;
								var refus = _v5.b;
								var erreur = _v5.c;
								return $elm$core$Maybe$Just(
									A2($author$project$Components$Produits$FicheType$Update$message, refus, erreur));
							default:
								break _v1$2;
						}
					} else {
						break _v1$2;
					}
				}
				return $elm$core$Maybe$Nothing;
			case 2:
				var reponse = msg.a;
				return deLaLecture(
					A2(
						$elm$core$Result$map,
						function (_v6) {
							return 0;
						},
						A2($author$project$API$Reponse$lire, $author$project$Components$Produits$FicheType$API$QueryAPIModel$ficheDecoder, reponse)));
			case 3:
				var reponse = msg.a;
				return deLaLecture(
					A2(
						$elm$core$Result$map,
						function (_v7) {
							return 0;
						},
						A2($author$project$API$Reponse$lire, $author$project$Components$Produits$FicheType$API$QueryAPIModel$historiqueDecoder, reponse)));
			case 54:
				var reponse = msg.a;
				return deLaLecture(
					A2(
						$elm$core$Result$map,
						function (_v8) {
							return 0;
						},
						A2($author$project$API$Reponse$lire, $author$project$Components$Produits$FicheType$API$QueryAPIModel$bibliothequeDecoder, reponse)));
			case 52:
				var reponse = msg.a;
				return deLaLecture(
					A2(
						$elm$core$Result$map,
						function (_v9) {
							return 0;
						},
						A2($author$project$API$Reponse$lire, $author$project$Components$Shared$EditeurDeSchema$SousChamps$listesOuTypesDecoder, reponse)));
			case 24:
				var reponse = msg.a;
				return deLaLecture(
					A2(
						$elm$core$Result$map,
						function (_v10) {
							return 0;
						},
						A2($author$project$API$Reponse$lire, $author$project$Components$Shared$EditeurDeSchema$Resserrage$decoder, reponse)));
			case 33:
				var reponse = msg.a;
				return deLaLecture(
					A2(
						$elm$core$Result$map,
						function (_v11) {
							return 0;
						},
						A2($author$project$API$Reponse$lire, $author$project$Components$Produits$FicheType$RestrictionDuChamp$listeDecoder, reponse)));
			case 43:
				var reponse = msg.a;
				return deLaLecture(
					A2(
						$elm$core$Result$map,
						function (_v12) {
							return 0;
						},
						A2($author$project$API$Reponse$lire, $author$project$Components$Produits$FicheType$ValeursPosees$listeDecoder, reponse)));
			case 1:
				var octets = msg.a;
				return _Utils_eq(
					$author$project$API$ProcessUid$depuisOctets(octets),
					$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
					{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Catalogue$API$WriteAPIModel$ChangerLaPortee = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Components$Produits$Common$Effet$LireLesListes = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Produits$Common$Effet$LireLaBibliotheque = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$FicheType$Model$creation = function (fiche) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerEtRattacherUnChamp, fiche.nQ);
};
var $author$project$Components$Produits$FicheType$Update$ajoutOuvert = function (model) {
	var _v0 = _Utils_Tuple2(
		A2($elm$core$Maybe$andThen, $author$project$Components$Produits$FicheType$Model$creation, model.zo),
		model.nC);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var lien = _v0.b.a;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{oR: true}),
			_List_fromArray(
				[
					$author$project$Components$Produits$Common$Effet$LireLaBibliotheque(lien)
				]));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$FicheType$ValeursPosees$annulerLeRetrait = function (enCours) {
	return _Utils_update(
		enCours,
		{dh: $elm$core$Maybe$Nothing});
};
var $author$project$Components$Produits$FicheType$RegleDeCode$Apercu = F3(
	function (code, parties, refus) {
		return {vx: code, E0: parties, pZ: refus};
	});
var $author$project$Components$Produits$FicheType$RegleDeCode$Refus = F3(
	function (segment, motif, champ) {
		return {uN: champ, cX: motif, Ix: segment};
	});
var $author$project$Components$Produits$FicheType$RegleDeCode$apercuDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Produits$FicheType$RegleDeCode$Apercu,
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'apercu', $elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$field,
		'parties',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$maybe(
		A2(
			$elm$json$Json$Decode$field,
			'refus',
			A4(
				$elm$json$Json$Decode$map3,
				$author$project$Components$Produits$FicheType$RegleDeCode$Refus,
				$elm$json$Json$Decode$maybe(
					A2($elm$json$Json$Decode$field, 'segment', $elm$json$Json$Decode$int)),
				A2($elm$json$Json$Decode$field, 'motif', $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$maybe(
					A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string))))));
var $author$project$Components$Produits$FicheType$RegleDeCode$avecLApercu = F2(
	function (apercu, enCours) {
		return _Utils_update(
			enCours,
			{
				tq: $elm$core$Maybe$Just(apercu)
			});
	});
var $author$project$Components$Produits$FicheType$Update$apercuDeLaRegle = F3(
	function (segments, reponse, model) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$API$Reponse$lire, $author$project$Components$Produits$FicheType$RegleDeCode$apercuDecoder, reponse),
			model.hI);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var apercu = _v0.a.a;
				var enCours = _v0.b.a;
				return _Utils_eq(enCours.Iy, segments) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hI: $elm$core$Maybe$Just(
								A2($author$project$Components$Produits$FicheType$RegleDeCode$avecLApercu, apercu, enCours))
						}),
					_List_Nil) : _Utils_Tuple2(model, _List_Nil);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			var refus = _v0.a.a;
			return _Utils_Tuple2(
				model,
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Produits$FicheType$RestrictionDuChamp$surLEtat = F2(
	function (changer, enCours) {
		return _Utils_update(
			enCours,
			{
				gt: A2($elm$core$Maybe$map, changer, enCours.gt)
			});
	});
var $author$project$Components$Produits$FicheType$RestrictionDuChamp$avecLApercu = function (horsChoix) {
	return $author$project$Components$Produits$FicheType$RestrictionDuChamp$surLEtat(
		$author$project$Components$Shared$Bibliotheque$Restriction$avecLApercu(horsChoix));
};
var $author$project$Components$Produits$FicheType$Update$apercuDeLaRestriction = F2(
	function (reponse, model) {
		var _v0 = _Utils_Tuple2(
			A2(
				$author$project$API$Reponse$lire,
				A2($elm$json$Json$Decode$field, 'fichesHorsChoix', $elm$json$Json$Decode$int),
				reponse),
			model.al);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var nombre = _v0.a.a;
				var enCours = _v0.b.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							al: $elm$core$Maybe$Just(
								A2($author$project$Components$Produits$FicheType$RestrictionDuChamp$avecLApercu, nombre, enCours))
						}),
					_List_Nil);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			var refus = _v0.a.a;
			return _Utils_Tuple2(
				model,
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Produits$FicheType$Reglages$choisirExigence = F2(
	function (code, reglage) {
		return _Utils_update(
			reglage,
			{mo: code, pZ: $elm$core$Maybe$Nothing});
	});
var $author$project$Components$Produits$FicheType$Model$idDeLaRechercheDeLaBibliotheque = $author$project$Components$Shared$Bibliotheque$View$idDeLaRechercheDeLaBibliotheque;
var $author$project$Components$Produits$FicheType$Update$choisirLeMode = F2(
	function (mode, model) {
		var lire = function () {
			var _v0 = _Utils_Tuple3(mode, model.pN.dq, model.nC);
			if (((_v0.a === 1) && (_v0.b.$ === 1)) && (!_v0.c.$)) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				var lien = _v0.c.a;
				return _List_fromArray(
					[
						$author$project$Components$Produits$Common$Effet$LireLaBibliotheque(lien)
					]);
			} else {
				return _List_Nil;
			}
		}();
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{kz: $elm$core$Maybe$Nothing, n9: mode}),
			_Utils_ap(
				lire,
				(mode === 1) ? _List_fromArray(
					[
						$author$project$Components$Produits$Common$Effet$PlacerFocus($author$project$Components$Produits$FicheType$Model$idDeLaRechercheDeLaBibliotheque)
					]) : _List_Nil));
	});
var $author$project$Components$Produits$FicheType$ChampDeBibliotheque$choisirLecture = F2(
	function (code, etat) {
		return _Utils_update(
			etat,
			{np: code});
	});
var $author$project$Components$Produits$FicheType$Reglages$choisirLecture = F2(
	function (code, reglage) {
		return _Utils_update(
			reglage,
			{np: code, pZ: $elm$core$Maybe$Nothing});
	});
var $author$project$Components$Produits$FicheType$Reglages$choisirSaisie = F2(
	function (code, reglage) {
		return _Utils_update(
			reglage,
			{pZ: $elm$core$Maybe$Nothing, hP: code});
	});
var $author$project$Components$Produits$FicheType$RestrictionDuChamp$cocher = F2(
	function (id, oui) {
		return $author$project$Components$Produits$FicheType$RestrictionDuChamp$surLEtat(
			A2($author$project$Components$Shared$Bibliotheque$Restriction$cocher, id, oui));
	});
var $author$project$Components$Produits$FicheType$Model$commandeDArchivage = function (fiche) {
	return A2(
		$elm$core$Maybe$map,
		$elm$core$Tuple$pair(
			$author$project$Catalogue$API$WriteAPIModel$ArchiverUnTypeDeProduit(fiche.fh.Aq)),
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$archiverUnTypeDeProduit, fiche.nQ));
};
var $author$project$Components$Produits$FicheType$Model$commandeDeRetrait = F2(
	function (typologie, fiche) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair(
				A2($author$project$Catalogue$API$WriteAPIModel$RetirerUnTypeDUneTypologie, fiche.fh.Aq, typologie)),
			A2(
				$elm$core$Maybe$andThen,
				function (emplacement) {
					return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerUnTypeDUneTypologie, emplacement.nQ);
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (emplacement) {
							return _Utils_eq(emplacement.r3, typologie);
						},
						fiche.ye))));
	});
var $author$project$Components$Produits$FicheType$Update$estUnOrdre = function (commande) {
	switch (commande.$) {
		case 17:
			return true;
		case 18:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Produits$FicheType$Update$commandeDOrdre = function (issue) {
	switch (issue.$) {
		case 0:
			var commande = issue.a;
			return $author$project$Components$Produits$FicheType$Update$estUnOrdre(commande);
		case 1:
			var commande = issue.a;
			return $author$project$Components$Produits$FicheType$Update$estUnOrdre(commande);
		default:
			return false;
	}
};
var $author$project$Components$Produits$FicheType$Update$estUneCollection = function (commande) {
	switch (commande.$) {
		case 15:
			return true;
		case 16:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Produits$FicheType$Update$commandeDeCollection = function (issue) {
	switch (issue.$) {
		case 0:
			var commande = issue.a;
			return $author$project$Components$Produits$FicheType$Update$estUneCollection(commande);
		case 1:
			var commande = issue.a;
			return $author$project$Components$Produits$FicheType$Update$estUneCollection(commande);
		default:
			return false;
	}
};
var $author$project$Components$Produits$FicheType$Update$relire = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$Lire, $elm$core$List$singleton),
			model.np));
};
var $author$project$Components$Produits$FicheType$Update$relecture = F2(
	function (rendue, model) {
		return (rendue.sy && (!A2($elm$core$List$member, $author$project$Catalogue$API$WriteAPIModel$EvenementInconnu, rendue.mk))) ? $author$project$Components$Produits$FicheType$Update$relire(model) : _List_fromArray(
			[
				$author$project$Components$Produits$Common$Effet$AttendreAvantDeRelire($author$project$Components$Produits$Common$Envoi$delaiDeRelectureMs)
			]);
	});
var $author$project$Components$Produits$FicheType$Update$versLesBlocs = F2(
	function (geste, model) {
		var _v0 = A2($author$project$Components$Shared$OrdreDesBlocs$Update$update, geste, model.o1);
		var ordre = _v0.a;
		var effets = _v0.b;
		var sortie = _v0.c;
		var focus = A2(
			$elm$core$List$map,
			function (_v5) {
				var cible = _v5;
				return $author$project$Components$Produits$Common$Effet$PlacerFocus(cible);
			},
			effets);
		var porteur = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.c0;
				},
				ordre.B0));
		var suivant = _Utils_update(
			model,
			{o1: ordre});
		var lancer = F2(
			function (commande, rel) {
				var _v2 = A2(
					$elm$core$Maybe$andThen,
					function (lu) {
						return A2($author$project$API$Liens$trouver, rel, lu.nQ);
					},
					ordre.B0);
				if (!_v2.$) {
					var lien = _v2.a;
					var _v3 = A3(
						$author$project$Components$Produits$Common$Envoi$partir,
						$elm$core$Maybe$Just(lien),
						commande,
						suivant.l2);
					if (!_v3.$) {
						var _v4 = _v3.a;
						var envoi = _v4.a;
						var partis = _v4.b;
						return _Utils_Tuple2(
							_Utils_update(
								suivant,
								{l2: envoi}),
							_Utils_ap(focus, partis));
					} else {
						return _Utils_Tuple2(suivant, focus);
					}
				} else {
					return _Utils_Tuple2(suivant, focus);
				}
			});
		switch (sortie.$) {
			case 0:
				return _Utils_Tuple2(suivant, focus);
			case 1:
				var lien = sortie.a;
				return _Utils_Tuple2(
					suivant,
					_Utils_ap(
						focus,
						_List_fromArray(
							[
								$author$project$Components$Produits$Common$Effet$LireLOrdreDesBlocs(lien)
							])));
			case 2:
				var voulu = sortie.a;
				return A2(
					lancer,
					A2($author$project$Catalogue$API$WriteAPIModel$OrdonnerLesBlocs, porteur, voulu),
					$author$project$API$NavLinksDictionary$ordonnerLesBlocs);
			default:
				return A2(
					lancer,
					$author$project$Catalogue$API$WriteAPIModel$ReprendreLOrdreDuParent(porteur),
					$author$project$API$NavLinksDictionary$reprendreLOrdreDuParent);
		}
	});
var $author$project$Components$Produits$FicheType$Update$conclureLOrdre = F2(
	function (issue, model) {
		switch (issue.$) {
			case 0:
				if (issue.c) {
					var rendue = issue.b;
					var _v1 = A2(
						$author$project$Components$Produits$FicheType$Update$versLesBlocs,
						$author$project$Components$Shared$OrdreDesBlocs$Update$DuDrawer($author$project$Components$Shared$Drawer$Update$Fermer),
						_Utils_update(
							model,
							{
								o1: $author$project$Components$Shared$OrdreDesBlocs$Model$abouti(model.o1)
							}));
					var fermee = _v1.a;
					var focus = _v1.b;
					return _Utils_Tuple2(
						fermee,
						_Utils_ap(
							focus,
							A2($author$project$Components$Produits$FicheType$Update$relecture, rendue, fermee)));
				} else {
					return _Utils_Tuple2(
						model,
						$author$project$Components$Produits$FicheType$Update$relire(model));
				}
			case 1:
				return _Utils_Tuple2(model, _List_Nil);
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$FicheType$Model$champ = F2(
	function (cle, fiche) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.uN;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dy;
						},
						$elm$core$Basics$eq(cle))),
				fiche.dw));
	});
var $author$project$Components$Produits$FicheType$Model$appliquer = F3(
	function (typeAjoute, rendue, fiche) {
		var type_ = fiche.fh;
		var surLeChamp = F3(
			function (cle, changer, champs) {
				return A2(
					$elm$core$List$map,
					function (lu) {
						return _Utils_eq(lu.uN.dy, cle) ? changer(lu) : lu;
					},
					champs);
			});
		var etat = F2(
			function (masque, lu) {
				return _Utils_update(
					lu,
					{nQ: _List_Nil, n4: masque});
			});
		var apres = F2(
			function (evenement, courante) {
				switch (evenement.$) {
					case 15:
						var version = evenement.a;
						var evolue = evenement.b;
						return _Utils_update(
							courante,
							{
								dw: _Utils_ap(
									A3(
										$elm$core$List$foldl,
										function (modifie) {
											return A2(
												surLeChamp,
												modifie.dy,
												function (lu) {
													return _Utils_update(
														lu,
														{uN: modifie});
												});
										},
										courante.dw,
										evolue.g$),
									A2(
										$elm$core$List$map,
										function (ajoute) {
											return {uN: ajoute, nQ: _List_Nil, n4: false, JR: typeAjoute};
										},
										evolue.fx)),
								fh: _Utils_update(
									type_,
									{sq: version})
							});
					case 29:
						return courante;
					case 26:
						return courante;
					case 24:
						var cle = evenement.a;
						var valeurs = evenement.b;
						return _Utils_update(
							courante,
							{
								GY: A3(
									$elm$core$Dict$update,
									cle,
									$elm$core$Maybe$map(
										function (lu) {
											return _Utils_update(
												lu,
												{al: valeurs});
										}),
									courante.GY)
							});
					case 25:
						var cle = evenement.a;
						return _Utils_update(
							courante,
							{
								GY: A3(
									$elm$core$Dict$update,
									cle,
									$elm$core$Maybe$map(
										function (lu) {
											return _Utils_update(
												lu,
												{al: _List_Nil});
										}),
									courante.GY)
							});
					case 16:
						var cle = evenement.a;
						return _Utils_update(
							courante,
							{
								dw: A3(
									surLeChamp,
									cle,
									etat(true),
									courante.dw)
							});
					case 30:
						var cle = evenement.a;
						return _Utils_update(
							courante,
							{
								dw: A3(
									surLeChamp,
									cle,
									etat(false),
									courante.dw)
							});
					case 31:
						var ordre = evenement.a;
						return _Utils_update(
							courante,
							{
								dw: _Utils_ap(
									A2(
										$elm$core$List$filterMap,
										function (cle) {
											return A2($author$project$Components$Produits$FicheType$Model$champ, cle, courante);
										},
										ordre),
									A2(
										$elm$core$List$filter,
										function (lu) {
											return !A2($elm$core$List$member, lu.uN.dy, ordre);
										},
										courante.dw))
							});
					case 52:
						var archive = courante.fh;
						return _Utils_update(
							courante,
							{
								dw: A2(
									$elm$core$List$map,
									function (lu) {
										return _Utils_update(
											lu,
											{nQ: _List_Nil});
									},
									courante.dw),
								fh: _Utils_update(
									archive,
									{tE: true})
							});
					default:
						return courante;
				}
			});
		return A3(
			$elm$core$List$foldl,
			apres,
			_Utils_update(
				fiche,
				{nQ: rendue.nQ}),
			rendue.mk);
	});
var $author$project$Components$Produits$FicheType$RegleDeCode$avecLeRefus = F2(
	function (refus, enCours) {
		return _Utils_update(
			enCours,
			{
				pZ: $elm$core$Maybe$Just(refus)
			});
	});
var $author$project$Catalogue$API$WriteAPIModel$FaireEvoluerLeSchema = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Components$Produits$FicheType$Model$annonce = F2(
	function (deplace, champs) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Traductions$tel(''),
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var place = _v0.a;
					var lu = _v0.b;
					return $author$project$I18n$Textes$produitsStructureOrdreAnnonce(
						{
							Dj: $author$project$I18n$Traductions$tel(lu.uN.Bl),
							bY: $author$project$I18n$Traductions$tel(
								$elm$core$String$fromInt(place + 1)),
							JE: $author$project$I18n$Traductions$tel(
								$elm$core$String$fromInt(
									$elm$core$List$length(champs)))
						});
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$second,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.uN;
								},
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.dy;
									},
									$elm$core$Basics$eq(deplace)))),
						A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, champs)))));
	});
var $author$project$Catalogue$API$WriteAPIModel$OrdonnerLesChamps = F2(
	function (a, b) {
		return {$: 29, a: a, b: b};
	});
var $author$project$Components$Produits$FicheType$Model$commandeDOrdre = F2(
	function (voulus, fiche) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair(
				A2(
					$author$project$Catalogue$API$WriteAPIModel$OrdonnerLesChamps,
					fiche.fh.Aq,
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.uN;
							},
							function ($) {
								return $.dy;
							}),
						voulus))),
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ordonnerLesChamps, fiche.nQ));
	});
var $author$project$Catalogue$API$WriteAPIModel$AfficherUnChamp = F2(
	function (a, b) {
		return {$: 28, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$MasquerUnChamp = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Components$Produits$FicheType$Model$commandeDeMasquage = F3(
	function (masquer, cle, fiche) {
		return A2(
			$elm$core$Maybe$andThen,
			function (lu) {
				return masquer ? A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(
						A2($author$project$Catalogue$API$WriteAPIModel$MasquerUnChamp, fiche.fh.Aq, cle)),
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$masquerUnChamp, lu.nQ)) : A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(
						A2($author$project$Catalogue$API$WriteAPIModel$AfficherUnChamp, fiche.fh.Aq, cle)),
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$afficherUnChamp, lu.nQ));
			},
			A2($author$project$Components$Produits$FicheType$Model$champ, cle, fiche));
	});
var $author$project$Catalogue$API$WriteAPIModel$DefinirLesMinimaDUnChampFichier = F3(
	function (a, b, c) {
		return {$: 27, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$FicheType$Model$definitionDesMinima = F2(
	function (cle, fiche) {
		return A2(
			$elm$core$Maybe$map,
			function (lien) {
				return {
					sW: A2($elm$core$Dict$get, cle, fiche.CC),
					vJ: A2($author$project$Catalogue$API$WriteAPIModel$DefinirLesMinimaDUnChampFichier, fiche.fh.Aq, cle),
					nB: lien
				};
			},
			A2(
				$elm$core$Maybe$andThen,
				function (lu) {
					return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$definirLesMinimaDUnChampFichier, lu.nQ);
				},
				A2($author$project$Components$Produits$FicheType$Model$champ, cle, fiche)));
	});
var $author$project$Components$Produits$FicheType$Model$evolution = function (fiche) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$faireEvoluerLeSchema, fiche.nQ);
};
var $author$project$Components$Produits$FicheType$Update$conduite = function (model) {
	var surLaFiche = function (lire) {
		return A2($elm$core$Maybe$andThen, lire, model.zo);
	};
	return {
		s0: function (cle) {
			return surLaFiche(
				A2($author$project$Components$Produits$FicheType$Model$commandeDeMasquage, false, cle));
		},
		s1: F2(
			function (voulus, courant) {
				return _Utils_update(
					courant,
					{
						zo: A2(
							$elm$core$Maybe$map,
							function (fiche) {
								return _Utils_update(
									fiche,
									{dw: voulus});
							},
							courant.zo)
					});
			}),
		tm: $author$project$Components$Produits$FicheType$Model$annonce,
		dw: A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.dw;
			},
			model.zo),
		dy: A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.uN;
			},
			function ($) {
				return $.dy;
			}),
		xE: _List_Nil,
		l2: $author$project$Components$Produits$Common$Envoi$reglage,
		yW: surLaFiche(
			function (fiche) {
				return A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(
						$author$project$Catalogue$API$WriteAPIModel$FaireEvoluerLeSchema(fiche.fh.Aq)),
					$author$project$Components$Produits$FicheType$Model$evolution(fiche));
			}),
		Ba: A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.x5;
					},
					function ($) {
						return $.Ba;
					}),
				model.zo)),
		Cc: function (cle) {
			return surLaFiche(
				A2($author$project$Components$Produits$FicheType$Model$commandeDeMasquage, true, cle));
		},
		CC: function (cle) {
			return surLaFiche(
				$author$project$Components$Produits$FicheType$Model$definitionDesMinima(cle));
		},
		g_: function (cle) {
			return A2(
				$elm$core$Maybe$andThen,
				function (lu) {
					return A2(
						$elm$core$Maybe$map,
						function (code) {
							return _Utils_Tuple2(code, lu.uN);
						},
						lu.JR);
				},
				surLaFiche(
					$author$project$Components$Produits$FicheType$Model$champ(cle)));
		},
		Do: $author$project$Components$Produits$FicheType$Model$nomDuDrawer,
		hd: model.hd,
		Ek: function (voulus) {
			return surLaFiche(
				$author$project$Components$Produits$FicheType$Model$commandeDOrdre(voulus));
		},
		FO: $author$project$Components$Produits$Common$Effet$PlacerFocus,
		F$: 0
	};
};
var $author$project$Components$Produits$FicheType$Update$perime = function (erreur) {
	switch (erreur.$) {
		case 24:
			return true;
		case 16:
			return true;
		case 19:
			return true;
		case 20:
			return true;
		case 18:
			return true;
		case 17:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Produits$FicheType$Update$relireSiPerime = F2(
	function (erreur, model) {
		return $author$project$Components$Produits$FicheType$Update$perime(erreur) ? $author$project$Components$Produits$FicheType$Update$relire(model) : _List_Nil;
	});
var $author$project$Components$Produits$FicheType$Update$versLeDrawerDeLaRegleDeCode = F2(
	function (geste, model) {
		return function (_v1) {
			var apres = _v1.a;
			var effets = _v1.b;
			return A2(
				$elm$core$List$member,
				geste,
				_List_fromArray(
					[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$AbandonConfirme])) ? _Utils_Tuple2(
				_Utils_update(
					apres,
					{hI: $elm$core$Maybe$Nothing}),
				effets) : _Utils_Tuple2(apres, effets);
		}(
			A3(
				$elm$core$Tuple$mapBoth,
				function (drawer) {
					return _Utils_update(
						model,
						{lB: drawer});
				},
				$elm$core$List$map(
					function (_v0) {
						var vers = _v0;
						return $author$project$Components$Produits$Common$Effet$PlacerFocus(vers);
					}),
				A3(
					$author$project$Components$Shared$Drawer$Update$update,
					{Il: false},
					geste,
					model.lB)));
	});
var $author$project$Components$Produits$FicheType$Update$conclureLaRegleDeCode = F3(
	function (issue, enCours, model) {
		switch (issue.$) {
			case 0:
				var rendue = issue.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(
						A2($author$project$Components$Produits$FicheType$Update$relecture, rendue, model)),
					A2(
						$author$project$Components$Produits$FicheType$Update$versLeDrawerDeLaRegleDeCode,
						$author$project$Components$Shared$Drawer$Update$Fermer,
						_Utils_update(
							model,
							{
								zo: A2(
									$elm$core$Maybe$map,
									A2($author$project$Components$Produits$FicheType$Model$appliquer, $elm$core$Maybe$Nothing, rendue),
									model.zo)
							})));
			case 1:
				if (issue.c.$ === 58) {
					var refus = issue.c.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								hI: $elm$core$Maybe$Just(
									A2($author$project$Components$Produits$FicheType$RegleDeCode$avecLeRefus, refus, enCours))
							}),
						_List_Nil);
				} else {
					var erreur = issue.c;
					return _Utils_Tuple2(
						model,
						A2($author$project$Components$Produits$FicheType$Update$relireSiPerime, erreur, model));
				}
			default:
				return A3(
					$author$project$Components$Shared$EditeurDeSchema$Conduite$conclure,
					$author$project$Components$Produits$FicheType$Update$conduite(model),
					$author$project$Components$Shared$EditeurDeSchema$Conduite$SessionEchue,
					model);
		}
	});
var $author$project$Components$Produits$FicheType$Update$dejaDefini = function (erreur) {
	if (erreur.$ === 25) {
		var id = erreur.a;
		return $elm$core$Maybe$Just(id);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$FicheType$Update$versLeDrawerDesReglages = F2(
	function (geste, model) {
		return function (_v1) {
			var apres = _v1.a;
			var effets = _v1.b;
			return A2(
				$elm$core$List$member,
				geste,
				_List_fromArray(
					[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$AbandonConfirme])) ? _Utils_Tuple2(
				_Utils_update(
					apres,
					{eO: $elm$core$Maybe$Nothing}),
				effets) : _Utils_Tuple2(apres, effets);
		}(
			A3(
				$elm$core$Tuple$mapBoth,
				function (drawer) {
					return _Utils_update(
						model,
						{lA: drawer});
				},
				$elm$core$List$map(
					function (_v0) {
						var vers = _v0;
						return $author$project$Components$Produits$Common$Effet$PlacerFocus(vers);
					}),
				A3(
					$author$project$Components$Shared$Drawer$Update$update,
					{Il: false},
					geste,
					model.lA)));
	});
var $author$project$Components$Produits$FicheType$Update$fermerLesReglages = function (_v0) {
	var model = _v0.a;
	var effets = _v0.b;
	return A2(
		$elm$core$Tuple$mapSecond,
		$elm$core$Basics$append(effets),
		A2($author$project$Components$Produits$FicheType$Update$versLeDrawerDesReglages, $author$project$Components$Shared$Drawer$Update$Fermer, model));
};
var $author$project$Components$Produits$FicheType$Model$idDuRefusDeRattachement = $author$project$Components$Shared$Bibliotheque$View$idDuRefusDeRattachement;
var $author$project$Components$Produits$FicheType$Update$lireLaBibliothequeDuNomPris = F2(
	function (erreur, model) {
		var _v0 = _Utils_Tuple3(
			$author$project$Components$Produits$FicheType$Update$dejaDefini(erreur),
			model.pN.dq,
			model.nC);
		if (((!_v0.a.$) && (_v0.b.$ === 1)) && (!_v0.c.$)) {
			var _v1 = _v0.b;
			var lien = _v0.c.a;
			return _List_fromArray(
				[
					$author$project$Components$Produits$Common$Effet$LireLaBibliotheque(lien)
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Produits$FicheType$Reglages$pourLaSuite = F2(
	function (cle, suite) {
		return {dy: cle, mo: '', np: '', pZ: $elm$core$Maybe$Nothing, hP: '', rn: suite};
	});
var $author$project$Components$Produits$FicheType$Update$refusDuDrawer = F2(
	function (refus, erreur) {
		switch (erreur.$) {
			case 21:
				return $author$project$Components$Shared$EditeurDeSchema$Model$CleDejaUtilisee;
			case 22:
				var refuse = erreur.a;
				return $author$project$Components$Shared$EditeurDeSchema$Model$EvolutionNonAdditive(refuse.pH);
			case 23:
				var defauts = erreur.a;
				return $author$project$Components$Shared$EditeurDeSchema$Model$SchemaInvalide(defauts);
			default:
				return $author$project$Components$Shared$EditeurDeSchema$Model$AutreRefus(
					A2($author$project$Components$Produits$FicheType$Update$message, refus, erreur));
		}
	});
var $author$project$Components$Shared$Bibliotheque$Rattachement$Autre = {$: 2};
var $author$project$Components$Shared$Bibliotheque$Rattachement$LimiteAUnType = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$FicheType$Update$refuserLeRattachement = F2(
	function (erreur, rattachement) {
		if (erreur.$ === 26) {
			var refuse = erreur.a;
			return _Utils_update(
				rattachement,
				{
					pZ: $elm$core$Maybe$Just(
						function () {
							var _v1 = refuse.o4;
							if (!_v1.$) {
								var origine = _v1.a;
								return $author$project$Components$Shared$Bibliotheque$Rattachement$LimiteAUnType(
									{uN: refuse.uN, Dj: origine.Dj});
							} else {
								return $author$project$Components$Shared$Bibliotheque$Rattachement$HorsPortee(
									{uN: refuse.uN, F$: refuse.F$});
							}
						}())
				});
		} else {
			return _Utils_update(
				rattachement,
				{
					pZ: $elm$core$Maybe$Just($author$project$Components$Shared$Bibliotheque$Rattachement$Autre)
				});
		}
	});
var $author$project$Components$Produits$FicheType$Update$reglagesAbouti = F2(
	function (rendue, model) {
		var appliquee = _Utils_update(
			model,
			{
				zo: A2(
					$elm$core$Maybe$map,
					A2($author$project$Components$Produits$FicheType$Model$appliquer, $elm$core$Maybe$Nothing, rendue),
					model.zo)
			});
		var _v0 = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.rn;
			},
			appliquee.eO);
		if ((!_v0.$) && (!_v0.a.b)) {
			var ferme = A2(
				$elm$core$Tuple$mapSecond,
				function (effets) {
					return _Utils_ap(
						effets,
						A2($author$project$Components$Produits$FicheType$Update$relecture, rendue, appliquee));
				},
				$author$project$Components$Produits$FicheType$Update$fermerLesReglages(
					_Utils_Tuple2(
						_Utils_update(
							appliquee,
							{eO: $elm$core$Maybe$Nothing}),
						_List_Nil)));
			return $author$project$Components$Shared$Drawer$Model$estOuvert(appliquee.kX) ? A2(
				$elm$core$Tuple$mapSecond,
				function (effets) {
					return _Utils_ap(ferme.b, effets);
				},
				A3(
					$author$project$Components$Shared$EditeurDeSchema$Conduite$conclure,
					$author$project$Components$Produits$FicheType$Update$conduite(ferme.a),
					$author$project$Components$Shared$EditeurDeSchema$Conduite$Aboutie,
					ferme.a)) : ferme;
		} else {
			return _Utils_Tuple2(appliquee, _List_Nil);
		}
	});
var $author$project$Components$Produits$FicheType$Reglages$MotifAutre = {$: 2};
var $author$project$Components$Produits$FicheType$Reglages$MotifFige = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$FicheType$Reglages$MotifHorsPortee = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$FicheType$Reglages$avecLeRefus = F2(
	function (refus, reglage) {
		return _Utils_update(
			reglage,
			{
				pZ: $elm$core$Maybe$Just(refus),
				rn: _List_Nil
			});
	});
var $author$project$Components$Produits$FicheType$Update$reglagesRefuses = F3(
	function (refus, erreur, model) {
		var lu = function () {
			switch (erreur.$) {
				case 29:
					var etage = erreur.a;
					return $author$project$Components$Produits$FicheType$Reglages$MotifHorsPortee(etage);
				case 30:
					var figee = erreur.a;
					return $author$project$Components$Produits$FicheType$Reglages$MotifFige(figee);
				default:
					return $author$project$Components$Produits$FicheType$Reglages$MotifAutre;
			}
		}();
		return _Utils_update(
			model,
			{
				eO: A2(
					$elm$core$Maybe$map,
					$author$project$Components$Produits$FicheType$Reglages$avecLeRefus(lu),
					model.eO)
			});
	});
var $author$project$Components$Produits$FicheType$Update$conclureLAjout = F2(
	function (issue, model) {
		var typeAjoute = ((model.n9 === 1) || (model.hP.zT.JR === '')) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(model.hP.zT.JR);
		var _v0 = _Utils_Tuple2(issue, model.eO);
		if (!_v0.b.$) {
			switch (_v0.a.$) {
				case 1:
					var _v2 = _v0.a;
					var refus = _v2.b;
					var erreur = _v2.c;
					return _Utils_Tuple2(
						A3($author$project$Components$Produits$FicheType$Update$reglagesRefuses, refus, erreur, model),
						A2($author$project$Components$Produits$FicheType$Update$relireSiPerime, erreur, model));
				case 0:
					if (_v0.a.c) {
						var _v1 = _v0.a;
						var rendue = _v1.b;
						return A2($author$project$Components$Produits$FicheType$Update$reglagesAbouti, rendue, model);
					} else {
						var _v3 = _v0.a;
						return $author$project$Components$Produits$FicheType$Update$fermerLesReglages(
							_Utils_Tuple2(
								_Utils_update(
									model,
									{eO: $elm$core$Maybe$Nothing}),
								$author$project$Components$Produits$FicheType$Update$relire(model)));
					}
				default:
					var _v4 = _v0.a;
					return $author$project$Components$Produits$FicheType$Update$fermerLesReglages(
						_Utils_Tuple2(
							_Utils_update(
								model,
								{eO: $elm$core$Maybe$Nothing}),
							_List_Nil));
			}
		} else {
			switch (_v0.a.$) {
				case 1:
					var _v5 = _v0.a;
					var refus = _v5.b;
					var erreur = _v5.c;
					var _v6 = _v0.b;
					return (model.n9 === 1) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{
								pN: A2($author$project$Components$Produits$FicheType$Update$refuserLeRattachement, erreur, model.pN)
							}),
						A2(
							$elm$core$List$cons,
							$author$project$Components$Produits$Common$Effet$PlacerFocus($author$project$Components$Produits$FicheType$Model$idDuRefusDeRattachement),
							A2($author$project$Components$Produits$FicheType$Update$relireSiPerime, erreur, model))) : A2(
						$elm$core$Tuple$mapSecond,
						function (effets) {
							return _Utils_ap(
								effets,
								_Utils_ap(
									A2($author$project$Components$Produits$FicheType$Update$relireSiPerime, erreur, model),
									A2($author$project$Components$Produits$FicheType$Update$lireLaBibliothequeDuNomPris, erreur, model)));
						},
						A3(
							$author$project$Components$Shared$EditeurDeSchema$Conduite$conclure,
							$author$project$Components$Produits$FicheType$Update$conduite(model),
							$author$project$Components$Shared$EditeurDeSchema$Conduite$Refusee(
								A2($author$project$Components$Produits$FicheType$Update$refusDuDrawer, refus, erreur)),
							_Utils_update(
								model,
								{
									kz: $author$project$Components$Produits$FicheType$Update$dejaDefini(erreur),
									ro: _List_Nil
								})));
				case 0:
					if (_v0.a.c) {
						var _v7 = _v0.a;
						var rendue = _v7.b;
						var _v8 = _v0.b;
						return (!_Utils_eq(model.ro, _List_Nil)) ? _Utils_Tuple2(
							_Utils_update(
								model,
								{
									zo: A2(
										$elm$core$Maybe$map,
										A2($author$project$Components$Produits$FicheType$Model$appliquer, typeAjoute, rendue),
										model.zo),
									eO: $elm$core$Maybe$Just(
										A2($author$project$Components$Produits$FicheType$Reglages$pourLaSuite, model.hP.zT.dy, model.ro)),
									ro: _List_Nil
								}),
							_List_Nil) : A2(
							$elm$core$Tuple$mapSecond,
							function (effets) {
								return _Utils_ap(
									effets,
									A2($author$project$Components$Produits$FicheType$Update$relecture, rendue, model));
							},
							A3(
								$author$project$Components$Shared$EditeurDeSchema$Conduite$conclure,
								$author$project$Components$Produits$FicheType$Update$conduite(model),
								$author$project$Components$Shared$EditeurDeSchema$Conduite$Aboutie,
								_Utils_update(
									model,
									{
										kz: $elm$core$Maybe$Nothing,
										zo: A2(
											$elm$core$Maybe$map,
											A2($author$project$Components$Produits$FicheType$Model$appliquer, typeAjoute, rendue),
											model.zo),
										n9: 0,
										pN: $author$project$Components$Shared$Bibliotheque$Rattachement$init(0)
									})));
					} else {
						var _v9 = _v0.a;
						var _v10 = _v0.b;
						return A2(
							$elm$core$Tuple$mapSecond,
							function (effets) {
								return _Utils_ap(
									effets,
									$author$project$Components$Produits$FicheType$Update$relire(model));
							},
							A3(
								$author$project$Components$Shared$EditeurDeSchema$Conduite$conclure,
								$author$project$Components$Produits$FicheType$Update$conduite(model),
								$author$project$Components$Shared$EditeurDeSchema$Conduite$Refusee(
									$author$project$Components$Shared$EditeurDeSchema$Model$AutreRefus($author$project$Components$Produits$Common$Refus$rejeu)),
								model));
					}
				default:
					var _v11 = _v0.a;
					var _v12 = _v0.b;
					return A3(
						$author$project$Components$Shared$EditeurDeSchema$Conduite$conclure,
						$author$project$Components$Produits$FicheType$Update$conduite(model),
						$author$project$Components$Shared$EditeurDeSchema$Conduite$SessionEchue,
						model);
			}
		}
	});
var $author$project$Components$Produits$FicheType$Update$versLElargissement = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{
						lx: drawer,
						lP: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? model.lP : $elm$core$Maybe$Nothing
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var vers = _v0;
					return $author$project$Components$Produits$Common$Effet$PlacerFocus(vers);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.lx));
	});
var $author$project$Components$Produits$FicheType$Update$conclureLElargissement = F3(
	function (issue, elargissement, model) {
		switch (issue.$) {
			case 0:
				var rattachement = model.pN;
				var elargi = function (lu) {
					return _Utils_eq(lu.Aq, elargissement.uN.Aq) ? _Utils_update(
						lu,
						{
							o4: $elm$core$Maybe$Nothing,
							F$: A2($author$project$Components$Shared$Bibliotheque$Elargissement$porteeProposee, 0, lu)
						}) : lu;
				};
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$LireLaBibliotheque, $elm$core$List$singleton),
								model.nC))),
					A2(
						$author$project$Components$Produits$FicheType$Update$versLElargissement,
						$author$project$Components$Shared$Drawer$Update$Fermer,
						_Utils_update(
							model,
							{
								pN: _Utils_update(
									rattachement,
									{
										dq: A2(
											$elm$core$Maybe$map,
											$elm$core$List$map(elargi),
											rattachement.dq),
										pZ: $elm$core$Maybe$Nothing
									})
							})));
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							lP: $elm$core$Maybe$Just(
								$author$project$Components$Shared$Bibliotheque$Elargissement$refuser(elargissement))
						}),
					_List_Nil);
			default:
				return A3(
					$author$project$Components$Shared$EditeurDeSchema$Conduite$conclure,
					$author$project$Components$Produits$FicheType$Update$conduite(model),
					$author$project$Components$Shared$EditeurDeSchema$Conduite$SessionEchue,
					model);
		}
	});
var $author$project$Components$Produits$FicheType$RestrictionDuChamp$refuser = $author$project$Components$Produits$FicheType$RestrictionDuChamp$surLEtat($author$project$Components$Shared$Bibliotheque$Restriction$refuser);
var $author$project$Components$Produits$FicheType$Update$versLeDrawerDeRestriction = F2(
	function (geste, model) {
		return function (_v1) {
			var apres = _v1.a;
			var effets = _v1.b;
			return A2(
				$elm$core$List$member,
				geste,
				_List_fromArray(
					[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$AbandonConfirme])) ? _Utils_Tuple2(
				_Utils_update(
					apres,
					{al: $elm$core$Maybe$Nothing}),
				effets) : _Utils_Tuple2(apres, effets);
		}(
			A3(
				$elm$core$Tuple$mapBoth,
				function (drawer) {
					return _Utils_update(
						model,
						{lC: drawer});
				},
				$elm$core$List$map(
					function (_v0) {
						var vers = _v0;
						return $author$project$Components$Produits$Common$Effet$PlacerFocus(vers);
					}),
				A3(
					$author$project$Components$Shared$Drawer$Update$update,
					{Il: false},
					geste,
					model.lC)));
	});
var $author$project$Components$Produits$FicheType$Update$conclureLaRestriction = F3(
	function (issue, enCours, model) {
		switch (issue.$) {
			case 0:
				var rendue = issue.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(
						A2($author$project$Components$Produits$FicheType$Update$relecture, rendue, model)),
					A2(
						$author$project$Components$Produits$FicheType$Update$versLeDrawerDeRestriction,
						$author$project$Components$Shared$Drawer$Update$Fermer,
						_Utils_update(
							model,
							{
								zo: A2(
									$elm$core$Maybe$map,
									A2($author$project$Components$Produits$FicheType$Model$appliquer, $elm$core$Maybe$Nothing, rendue),
									model.zo)
							})));
			case 1:
				var erreur = issue.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							al: $elm$core$Maybe$Just(
								$author$project$Components$Produits$FicheType$RestrictionDuChamp$refuser(enCours))
						}),
					A2($author$project$Components$Produits$FicheType$Update$relireSiPerime, erreur, model));
			default:
				return A3(
					$author$project$Components$Shared$EditeurDeSchema$Conduite$conclure,
					$author$project$Components$Produits$FicheType$Update$conduite(model),
					$author$project$Components$Shared$EditeurDeSchema$Conduite$SessionEchue,
					model);
		}
	});
var $author$project$Components$Produits$Common$Effet$LireLesValeursPosees = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Produits$FicheType$ValeursPosees$parPage = 3;
var $author$project$API$NavLinksDictionary$valeursPosees = 'valeurs-posees';
var $author$project$Components$Produits$FicheType$ValeursPosees$demander = F2(
	function (cle, fiche) {
		var _v0 = _Utils_Tuple2(
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.uN;
						},
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dy;
							},
							$elm$core$Basics$eq(cle))),
					fiche.dw)),
			A2(
				$elm$core$Maybe$andThen,
				$author$project$API$Liens$resoudre(
					_List_fromArray(
						[
							_Utils_Tuple2('champ', cle)
						])),
				A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$valeursPosees, fiche.gF)));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var champ = _v0.a.a;
			var lien = _v0.b.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					{dh: $elm$core$Maybe$Nothing, dy: cle, Bl: champ.uN.Bl, gV: _List_Nil, a8: $author$project$Components$Produits$FicheType$ValeursPosees$parPage},
					lien));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$FicheType$Update$surLesValeursPosees = F2(
	function (changer, model) {
		return _Utils_update(
			model,
			{
				si: A2($elm$core$Maybe$map, changer, model.si)
			});
	});
var $author$project$Components$Produits$FicheType$Update$conclureLeRetraitDUneValeur = F3(
	function (issue, enCours, model) {
		switch (issue.$) {
			case 0:
				var rendue = issue.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							zo: A2(
								$elm$core$Maybe$map,
								A2($author$project$Components$Produits$FicheType$Model$appliquer, $elm$core$Maybe$Nothing, rendue),
								model.zo)
						}),
					_Utils_ap(
						A2($author$project$Components$Produits$FicheType$Update$relecture, rendue, model),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Tuple$second,
									A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$LireLesValeursPosees, $elm$core$List$singleton)),
								A2(
									$elm$core$Maybe$andThen,
									$author$project$Components$Produits$FicheType$ValeursPosees$demander(enCours.dy),
									model.zo)))));
			case 1:
				var erreur = issue.c;
				return _Utils_Tuple2(
					A2($author$project$Components$Produits$FicheType$Update$surLesValeursPosees, $author$project$Components$Produits$FicheType$ValeursPosees$annulerLeRetrait, model),
					A2($author$project$Components$Produits$FicheType$Update$relireSiPerime, erreur, model));
			default:
				return A3(
					$author$project$Components$Shared$EditeurDeSchema$Conduite$conclure,
					$author$project$Components$Produits$FicheType$Update$conduite(model),
					$author$project$Components$Shared$EditeurDeSchema$Conduite$SessionEchue,
					model);
		}
	});
var $author$project$Components$Produits$FicheType$Update$conclureLesAutres = F2(
	function (issue, model) {
		var _v0 = _Utils_Tuple3(model.si, model.al, model.lP);
		if (!_v0.a.$) {
			var enCours = _v0.a.a;
			return A3($author$project$Components$Produits$FicheType$Update$conclureLeRetraitDUneValeur, issue, enCours, model);
		} else {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var enCours = _v0.b.a;
				return A3($author$project$Components$Produits$FicheType$Update$conclureLaRestriction, issue, enCours, model);
			} else {
				if (!_v0.c.$) {
					var _v2 = _v0.a;
					var _v3 = _v0.b;
					var elargissement = _v0.c.a;
					return A3($author$project$Components$Produits$FicheType$Update$conclureLElargissement, issue, elargissement, model);
				} else {
					var _v4 = _v0.a;
					var _v5 = _v0.b;
					var _v6 = _v0.c;
					return A2($author$project$Components$Produits$FicheType$Update$conclureLAjout, issue, model);
				}
			}
		}
	});
var $author$project$Components$Produits$FicheType$Update$conclureLaCommande = F2(
	function (issue, model) {
		var _v0 = model.hI;
		if (!_v0.$) {
			var enCours = _v0.a;
			return A3($author$project$Components$Produits$FicheType$Update$conclureLaRegleDeCode, issue, enCours, model);
		} else {
			return A2($author$project$Components$Produits$FicheType$Update$conclureLesAutres, issue, model);
		}
	});
var $author$project$Components$Produits$FicheType$Update$conclureLesCollections = F2(
	function (issue, model) {
		switch (issue.$) {
			case 0:
				if (issue.c) {
					var rendue = issue.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								vE: $author$project$Components$Shared$CollectionsDuType$Model$abouti(model.vE)
							}),
						A2($author$project$Components$Produits$FicheType$Update$relecture, rendue, model));
				} else {
					return _Utils_Tuple2(
						model,
						$author$project$Components$Produits$FicheType$Update$relire(model));
				}
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							vE: $author$project$Components$Shared$CollectionsDuType$Model$refuserLAjout(model.vE)
						}),
					$author$project$Components$Produits$FicheType$Update$relire(model));
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$FicheType$Update$conclure = F2(
	function (issue, model) {
		var _v0 = _Utils_Tuple2(
			$author$project$Components$Produits$FicheType$Update$commandeDOrdre(issue),
			$author$project$Components$Produits$FicheType$Update$commandeDeCollection(issue));
		if (_v0.a) {
			return A2($author$project$Components$Produits$FicheType$Update$conclureLOrdre, issue, model);
		} else {
			if (_v0.b) {
				return A2($author$project$Components$Produits$FicheType$Update$conclureLesCollections, issue, model);
			} else {
				return A2($author$project$Components$Produits$FicheType$Update$conclureLaCommande, issue, model);
			}
		}
	});
var $author$project$Components$Produits$Common$Effet$LireLaListeDuChamp = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Produits$FicheType$RestrictionDuChamp$champDe = F2(
	function (cle, fiche) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.uN;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dy;
						},
						$elm$core$Basics$eq(cle))),
				fiche.dw));
	});
var $author$project$Components$Produits$FicheType$RestrictionDuChamp$demander = F2(
	function (cle, fiche) {
		return A2(
			$elm$core$Maybe$andThen,
			function (lu) {
				var _v0 = _Utils_Tuple2(
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$restreindreLesValeurs, lu.nQ),
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$listeDuChamp, lu.nQ));
				if ((!_v0.a.$) && (!_v0.b.$)) {
					var liste = _v0.b.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							{dy: cle, gt: $elm$core$Maybe$Nothing},
							liste));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			A2($author$project$Components$Produits$FicheType$RestrictionDuChamp$champDe, cle, fiche));
	});
var $author$project$Components$Produits$FicheType$Update$demanderLaRestriction = F2(
	function (cle, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			$author$project$Components$Produits$FicheType$RestrictionDuChamp$demander(cle),
			model.zo);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var enCours = _v1.a;
			var lien = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						al: $elm$core$Maybe$Just(enCours)
					}),
				_List_fromArray(
					[
						$author$project$Components$Produits$Common$Effet$LireLaListeDuChamp(lien)
					]));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$FicheType$ValeursPosees$demanderLeRetrait = F2(
	function (rang, enCours) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.eW;
			},
			$elm$core$List$head(
				A2($elm$core$List$drop, rang, enCours.gV)));
		if (!_v0.$) {
			return _Utils_update(
				enCours,
				{
					dh: $elm$core$Maybe$Just(rang)
				});
		} else {
			return enCours;
		}
	});
var $author$project$Components$Produits$FicheType$Update$demanderLesValeursPosees = F2(
	function (cle, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			$author$project$Components$Produits$FicheType$ValeursPosees$demander(cle),
			model.zo);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var enCours = _v1.a;
			var lien = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						si: $elm$core$Maybe$Just(enCours)
					}),
				_List_fromArray(
					[
						$author$project$Components$Produits$Common$Effet$LireLesValeursPosees(lien)
					]));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Catalogue$API$WriteAPIModel$RestreindreLesValeurs = F3(
	function (a, b, c) {
		return {$: 22, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$FicheType$RestrictionDuChamp$enregistrer = F2(
	function (enCours, fiche) {
		var _v0 = _Utils_Tuple2(
			enCours.gt,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nQ;
					},
					$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$restreindreLesValeurs)),
				A2($author$project$Components$Produits$FicheType$RestrictionDuChamp$champDe, enCours.dy, fiche)));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var etat = _v0.a.a;
			var lien = _v0.b.a;
			return $author$project$Components$Shared$Bibliotheque$Restriction$enregistrable(etat) ? $elm$core$Maybe$Just(
				_Utils_Tuple2(
					A3(
						$author$project$Catalogue$API$WriteAPIModel$RestreindreLesValeurs,
						fiche.fh.Aq,
						enCours.dy,
						$author$project$Components$Shared$Bibliotheque$Restriction$retenues(etat)),
					lien)) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Catalogue$API$WriteAPIModel$ReglerLeRattachement = F4(
	function (a, b, c, d) {
		return {$: 21, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Produits$FicheType$Reglages$avecLExigence = F2(
	function (code, lu) {
		var champ = lu.uN;
		return {
			fx: _List_Nil,
			g$: _List_fromArray(
				[
					_Utils_update(
					champ,
					{
						sG: _Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceALaPublication),
						he: _Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceALEnregistrement)
					})
				])
		};
	});
var $author$project$Components$Produits$FicheType$Reglages$champDe = F2(
	function (cle, fiche) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.uN;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dy;
						},
						$elm$core$Basics$eq(cle))),
				fiche.dw));
	});
var $author$project$Components$Produits$FicheType$Reglages$rattachement = F2(
	function (cle, fiche) {
		return A2($elm$core$Dict$get, cle, fiche.GY);
	});
var $author$project$Components$Produits$FicheType$Reglages$commandes = F2(
	function (reglage, fiche) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$Components$Produits$FicheType$Reglages$champDe, reglage.dy, fiche),
			A2($author$project$Components$Produits$FicheType$Reglages$rattachement, reglage.dy, fiche));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var lu = _v0.a.a;
			var actuel = _v0.b.a;
			var niveaux = ((!_Utils_eq(reglage.np, actuel.g4)) || (!_Utils_eq(reglage.hP, actuel.C7))) ? A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					$elm$core$List$singleton,
					A2(
						$elm$core$Maybe$map,
						function (lien) {
							return _Utils_Tuple2(
								A4($author$project$Catalogue$API$WriteAPIModel$ReglerLeRattachement, fiche.fh.Aq, reglage.dy, reglage.np, reglage.hP),
								lien);
						},
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reglerLeRattachement, lu.nQ)))) : _List_Nil;
			var evolution = (!_Utils_eq(
				reglage.mo,
				$author$project$Components$Shared$EditeurDeSchema$Model$exigenceDe(lu.uN))) ? A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					$elm$core$List$singleton,
					A2(
						$elm$core$Maybe$map,
						function (lien) {
							return _Utils_Tuple2(
								A2(
									$author$project$Catalogue$API$WriteAPIModel$FaireEvoluerLeSchema,
									fiche.fh.Aq,
									A2($author$project$Components$Produits$FicheType$Reglages$avecLExigence, reglage.mo, lu)),
								lien);
						},
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$faireEvoluerLeSchema, fiche.nQ)))) : _List_Nil;
			return _Utils_ap(evolution, niveaux);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Produits$FicheType$Update$enregistrerLesReglages = function (model) {
	var _v0 = _Utils_Tuple2(model.zo, model.eO);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var fiche = _v0.a.a;
		var reglage = _v0.b.a;
		var _v1 = A2($author$project$Components$Produits$FicheType$Reglages$commandes, reglage, fiche);
		if (_v1.b) {
			var _v2 = _v1.a;
			var premiere = _v2.a;
			var lien = _v2.b;
			var suite = _v1.b;
			var _v3 = A3(
				$author$project$Components$Produits$Common$Envoi$partir,
				$elm$core$Maybe$Just(lien),
				premiere,
				model.l2);
			if (!_v3.$) {
				var _v4 = _v3.a;
				var envoi = _v4.a;
				var effets = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: envoi,
							eO: $elm$core$Maybe$Just(
								_Utils_update(
									reglage,
									{pZ: $elm$core$Maybe$Nothing, rn: suite}))
						}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$FicheType$Update$envoyer = F2(
	function (commande, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (_v1) {
				var voulue = _v1.a;
				var lien = _v1.b;
				return A3(
					$author$project$Components$Produits$Common$Envoi$partir,
					$elm$core$Maybe$Just(lien),
					voulue,
					model.l2);
			},
			A2($elm$core$Maybe$andThen, commande, model.zo));
		if (!_v0.$) {
			var _v2 = _v0.a;
			var envoi = _v2.a;
			var effets = _v2.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$FicheType$Update$envoyerLaRestriction = F2(
	function (commande, model) {
		var _v0 = _Utils_Tuple2(model.al, model.zo);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var enCours = _v0.a.a;
			var fiche = _v0.b.a;
			var _v1 = A2(
				$elm$core$Maybe$andThen,
				function (_v2) {
					var voulue = _v2.a;
					var lien = _v2.b;
					return A3(
						$author$project$Components$Produits$Common$Envoi$partir,
						$elm$core$Maybe$Just(lien),
						voulue,
						model.l2);
				},
				A2(commande, enCours, fiche));
			if (!_v1.$) {
				var _v3 = _v1.a;
				var envoi = _v3.a;
				var effets = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{l2: envoi}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$FicheType$Update$envoyerLaSuite = function (model) {
	var _v0 = model.eO;
	if (!_v0.$) {
		var reglage = _v0.a;
		var _v1 = reglage.rn;
		if (_v1.b) {
			var _v2 = _v1.a;
			var suivante = _v2.a;
			var lien = _v2.b;
			var reste = _v1.b;
			var _v3 = A3(
				$author$project$Components$Produits$Common$Envoi$partir,
				$elm$core$Maybe$Just(lien),
				suivante,
				model.l2);
			if (!_v3.$) {
				var _v4 = _v3.a;
				var envoi = _v4.a;
				var effets = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: envoi,
							eO: $elm$core$Maybe$Just(
								_Utils_update(
									reglage,
									{rn: reste}))
						}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$FicheType$ValeursPosees$commandeDeRetrait = function (enCours) {
	return A2(
		$elm$core$Maybe$andThen,
		function (ligne) {
			return A2(
				$elm$core$Maybe$map,
				function (lien) {
					return _Utils_Tuple2(
						A2($author$project$Catalogue$API$WriteAPIModel$RetirerLaValeurDUnChampHerite, ligne.F$, enCours.dy),
						lien);
				},
				ligne.eW);
		},
		A2(
			$elm$core$Maybe$andThen,
			function (rang) {
				return $elm$core$List$head(
					A2($elm$core$List$drop, rang, enCours.gV));
			},
			enCours.dh));
};
var $author$project$Components$Produits$FicheType$Update$envoyerLeRetraitDUneValeur = function (model) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		function (_v1) {
			var voulue = _v1.a;
			var lien = _v1.b;
			return A3(
				$author$project$Components$Produits$Common$Envoi$partir,
				$elm$core$Maybe$Just(lien),
				voulue,
				model.l2);
		},
		A2($elm$core$Maybe$andThen, $author$project$Components$Produits$FicheType$ValeursPosees$commandeDeRetrait, model.si));
	if (!_v0.$) {
		var _v2 = _v0.a;
		var envoi = _v2.a;
		var effets = _v2.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{l2: envoi}),
			effets);
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$FicheType$Update$fermerLeRetrait = function (model) {
	return _Utils_update(
		model,
		{
			dh: $elm$core$Maybe$Nothing,
			eW: A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				$author$project$Components$Shared$Drawer$Update$Fermer,
				model.eW).a
		});
};
var $author$project$Components$Produits$FicheType$ChampDeBibliotheque$filtrer = F2(
	function (filtrable, etat) {
		return _Utils_update(
			etat,
			{zG: filtrable});
	});
var $author$project$Components$Produits$FicheType$Model$idDeLArchivage = 'type-archiver';
var $author$project$Components$Produits$FicheType$Model$idDuRattachement = 'champs-rattacher';
var $author$project$Components$Produits$FicheType$Model$idDuRetrait = function (typologie) {
	return 'type-retirer-' + $author$project$Catalogue$Identifiants$classificationIdToString(typologie);
};
var $author$project$Components$Produits$FicheType$Model$idsDeLArchivage = $author$project$Components$Shared$Confirmation$Clavier$ids('archivage-du-type');
var $author$project$Catalogue$API$WriteAPIModel$LeverLaRestriction = F2(
	function (a, b) {
		return {$: 23, a: a, b: b};
	});
var $author$project$Components$Produits$FicheType$RestrictionDuChamp$lever = F2(
	function (enCours, fiche) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair(
				A2($author$project$Catalogue$API$WriteAPIModel$LeverLaRestriction, fiche.fh.Aq, enCours.dy)),
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nQ;
					},
					$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$leverLaRestriction)),
				A2($author$project$Components$Produits$FicheType$RestrictionDuChamp$champDe, enCours.dy, fiche)));
	});
var $author$project$Components$Produits$Common$Effet$LireLHistorique = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$FicheType$Model$historique = function (fiche) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$versionsDuSchema, fiche.nQ);
};
var $author$project$Components$Produits$FicheType$Update$lireLHistorique = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$LireLHistorique, $elm$core$List$singleton),
			A2($elm$core$Maybe$andThen, $author$project$Components$Produits$FicheType$Model$historique, model.zo)));
};
var $author$project$Components$Produits$FicheType$ChampDeBibliotheque$masquer = F2(
	function (masque, etat) {
		return _Utils_update(
			etat,
			{n4: masque});
	});
var $author$project$Components$Produits$FicheType$RestrictionDuChamp$masquer = F2(
	function (enCours, fiche) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair(
				A2($author$project$Catalogue$API$WriteAPIModel$MasquerUnChamp, fiche.fh.Aq, enCours.dy)),
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nQ;
					},
					$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$masquerUnChamp)),
				A2($author$project$Components$Produits$FicheType$RestrictionDuChamp$champDe, enCours.dy, fiche)));
	});
var $author$project$I18n$Textes$produitsTypesAjoutSousTitre = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.types.ajout.sous-titre',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nomDuType',
				$author$project$I18n$Traductions$Sous(p.Dp))
			]),
		'Type de produit « {nomDuType} »');
};
var $author$project$Components$Produits$FicheType$Model$rattachement = function (fiche) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rattacherUnChamp, fiche.nQ);
};
var $author$project$Components$Produits$Common$Effet$EnvoyerUnNouveauChamp = F3(
	function (a, b, c) {
		return {$: 6, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$Common$Effet$LireLesListesDuNouveauChamp = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Produits$FicheType$Update$depuisLeNouveauChamp = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[$author$project$Components$Produits$Common$Effet$DemanderProcessUid])));
			case 1:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Components$Produits$Common$Effet$LireLesListesDuNouveauChamp(lien)
							])));
			case 2:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								A3($author$project$Components$Produits$Common$Effet$EnvoyerUnNouveauChamp, lien, processUid, commande)
							])));
			case 3:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Components$Produits$Common$Effet$PlacerFocus(cible)
							])));
			case 4:
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter])));
			case 5:
				var vuesAJour = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						vuesAJour ? $author$project$Components$Produits$FicheType$Update$relire(model) : _List_fromArray(
							[
								$author$project$Components$Produits$Common$Effet$AttendreAvantDeRelire($author$project$Components$Produits$Common$Envoi$delaiDeRelectureMs)
							])));
			case 7:
				return _Utils_Tuple2(model, effets);
			default:
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$LireLesListes, $elm$core$List$singleton),
								model.BF))));
		}
	});
var $author$project$Components$Produits$FicheType$Update$surLeNouveauChamp = F2(
	function (geste, model) {
		return function (_v0) {
			var nouveauChamp = _v0.a;
			var effets = _v0.b;
			return A3(
				$elm$core$List$foldl,
				$author$project$Components$Produits$FicheType$Update$depuisLeNouveauChamp,
				_Utils_Tuple2(
					_Utils_update(
						model,
						{oP: nouveauChamp}),
					_List_Nil),
				effets);
		}(
			A2($author$project$Components$Parametrage$NouveauChamp$Update$update, geste, model.oP));
	});
var $author$project$Components$Produits$FicheType$Update$nouveauChampPret = function (model) {
	var _v0 = _Utils_Tuple2(
		model.oR,
		A2(
			$elm$core$Maybe$andThen,
			function (fiche) {
				return A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(fiche),
					$author$project$Components$Produits$FicheType$Model$creation(fiche));
			},
			model.zo));
	if (_v0.a && (!_v0.b.$)) {
		var _v1 = _v0.b.a;
		var fiche = _v1.a;
		var lien = _v1.b;
		return A2(
			$author$project$Components$Produits$FicheType$Update$surLeNouveauChamp,
			$author$project$Components$Parametrage$NouveauChamp$Update$Ouvert(
				{
					un: $elm$core$Maybe$Nothing,
					uY: A2($elm$core$Maybe$withDefault, _List_Nil, model.pN.dq),
					vE: _List_Nil,
					R: {fs: $author$project$I18n$Textes$produitsParcoursInformationsCreerAction, Dj: $author$project$I18n$Textes$produitsParcoursInformationsCreerNom, JR: $author$project$I18n$Textes$produitsParcoursInformationsCreerType},
					Bz: lien,
					BF: model.BF,
					F$: 'catalogue',
					F1: true,
					c0: _List_fromArray(
						[
							_Utils_Tuple2(
							'typeDeProduit',
							$author$project$Catalogue$Identifiants$typeDeProduitIdEncode(fiche.fh.Aq)),
							_Utils_Tuple2(
							'obligatoire',
							$elm$json$Json$Encode$bool(false))
						]),
					pN: A2(
						$elm$core$Maybe$map,
						function (lienDeRattachement) {
							return {
								f$: A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'typeDeProduit',
										$author$project$Catalogue$Identifiants$typeDeProduitIdEncode(fiche.fh.Aq)),
									$author$project$Catalogue$API$WriteAPIModel$reglagesDuRattachementEnJson(
										function () {
											var reglages = $author$project$Components$Shared$Bibliotheque$Rattachement$init(0).qc;
											return {mo: reglages.mo, n4: reglages.n4, g4: reglages.g4};
										}())),
								nB: lienDeRattachement
							};
						},
						$author$project$Components$Produits$FicheType$Model$rattachement(fiche)),
					aO: $author$project$I18n$Textes$produitsTypesAjoutSousTitre(
						{
							Dp: $author$project$I18n$Traductions$tel(fiche.fh.Dj.zX)
						}),
					h6: $author$project$I18n$Textes$produitsParcoursInformationsCreerTitre,
					ib: _List_Nil,
					J_: model.J_,
					sb: model.sc
				}),
			_Utils_update(
				model,
				{oR: false}));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$FicheType$Update$ordreLu = F2(
	function (reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Shared$OrdreDesBlocs$Model$decoder, reponse);
		if (!_v0.$) {
			var lu = _v0.a;
			return A2(
				$author$project$Components$Produits$FicheType$Update$versLesBlocs,
				$author$project$Components$Shared$OrdreDesBlocs$Update$OrdreLu(lu),
				model);
		} else {
			var refus = _v0.a;
			return _Utils_Tuple2(
				model,
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Produits$FicheType$ChampDeBibliotheque$champDe = F2(
	function (cle, fiche) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.uN;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dy;
						},
						$elm$core$Basics$eq(cle))),
				fiche.dw));
	});
var $author$project$Components$Produits$FicheType$ChampDeBibliotheque$ouvrir = F2(
	function (cle, fiche) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$Components$Produits$FicheType$ChampDeBibliotheque$champDe, cle, fiche),
			A2($elm$core$Dict$get, cle, fiche.dq));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var lu = _v0.a.a;
			var definition = _v0.b.a;
			return $elm$core$Maybe$Just(
				{
					dy: cle,
					zG: definition.zG,
					np: A2(
						$elm$core$Maybe$withDefault,
						'essentiel',
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.g4;
							},
							A2($elm$core$Dict$get, cle, fiche.GY))),
					n4: lu.n4,
					G1: definition.G1
				});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$FicheType$RestrictionDuChamp$retenuesDe = F2(
	function (cle, fiche) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.al;
				},
				A2($author$project$Components$Produits$FicheType$Reglages$rattachement, cle, fiche)));
	});
var $author$project$Components$Produits$FicheType$RestrictionDuChamp$avecLaListe = F3(
	function (valeurs, fiche, enCours) {
		var _v0 = A2($author$project$Components$Produits$FicheType$RestrictionDuChamp$champDe, enCours.dy, fiche);
		if (!_v0.$) {
			var lu = _v0.a;
			return _Utils_update(
				enCours,
				{
					gt: $elm$core$Maybe$Just(
						$author$project$Components$Shared$Bibliotheque$Restriction$ouvrir(
							{
								uN: lu.uN.Bl,
								hN: A2($author$project$Components$Produits$FicheType$RestrictionDuChamp$retenuesDe, enCours.dy, fiche),
								I9: fiche.fh.Dj.zX,
								Ki: valeurs
							}))
				});
		} else {
			return enCours;
		}
	});
var $author$project$Components$Produits$FicheType$Update$ouvrirLaRestriction = F2(
	function (reponse, model) {
		var _v0 = _Utils_Tuple3(
			A2($author$project$API$Reponse$lire, $author$project$Components$Produits$FicheType$RestrictionDuChamp$listeDecoder, reponse),
			model.al,
			model.zo);
		if (!_v0.a.$) {
			if ((!_v0.b.$) && (!_v0.c.$)) {
				var valeurs = _v0.a.a;
				var enCours = _v0.b.a;
				var fiche = _v0.c.a;
				return A2(
					$author$project$Components$Produits$FicheType$Update$versLeDrawerDeRestriction,
					$author$project$Components$Shared$Drawer$Update$Ouvrir(
						$author$project$Components$Shared$Drawer$Model$idRacine(model.lC)),
					_Utils_update(
						model,
						{
							al: $elm$core$Maybe$Just(
								A3($author$project$Components$Produits$FicheType$RestrictionDuChamp$avecLaListe, valeurs, fiche, enCours))
						}));
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			var refus = _v0.a.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{al: $elm$core$Maybe$Nothing}),
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$View$idDesReglages = function (cle) {
	return 'champ-' + (cle + '-regler');
};
var $author$project$Components$Produits$FicheType$Reglages$reglable = F2(
	function (fiche, lu) {
		return (!_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reglerLeRattachement, lu.nQ),
			$elm$core$Maybe$Nothing)) && (!_Utils_eq(
			A2($author$project$Components$Produits$FicheType$Reglages$rattachement, lu.uN.dy, fiche),
			$elm$core$Maybe$Nothing));
	});
var $author$project$Components$Produits$FicheType$Reglages$ouvrir = F2(
	function (cle, fiche) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$Components$Produits$FicheType$Reglages$champDe, cle, fiche),
			A2($author$project$Components$Produits$FicheType$Reglages$rattachement, cle, fiche));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var lu = _v0.a.a;
			var actuel = _v0.b.a;
			return A2($author$project$Components$Produits$FicheType$Reglages$reglable, fiche, lu) ? $elm$core$Maybe$Just(
				{
					dy: cle,
					mo: $author$project$Components$Shared$EditeurDeSchema$Model$exigenceDe(lu.uN),
					np: actuel.g4,
					pZ: $elm$core$Maybe$Nothing,
					hP: actuel.C7,
					rn: _List_Nil
				}) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$FicheType$Update$ouvrirLesReglages = F2(
	function (cle, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			$author$project$Components$Produits$FicheType$Reglages$ouvrir(cle),
			model.zo);
		if (!_v0.$) {
			var reglage = _v0.a;
			return A2(
				$author$project$Components$Produits$FicheType$Update$versLeDrawerDesReglages,
				$author$project$Components$Shared$Drawer$Update$Ouvrir(
					$author$project$Components$Shared$EditeurDeSchema$View$idDesReglages(cle)),
				_Utils_update(
					model,
					{
						eO: $elm$core$Maybe$Just(reglage)
					}));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$FicheType$ValeursPosees$avecLesLignes = F2(
	function (lignes, enCours) {
		return _Utils_update(
			enCours,
			{
				dh: $elm$core$Maybe$Nothing,
				gV: lignes,
				a8: A2($elm$core$Basics$max, enCours.a8, $author$project$Components$Produits$FicheType$ValeursPosees$parPage)
			});
	});
var $author$project$Components$Produits$FicheType$Model$idDeLOuvreurDesValeursPosees = 'produits-type-valeurs-posees-ouvreur';
var $author$project$Components$Produits$FicheType$Update$idDeLOuvreurDesValeursPosees = $author$project$Components$Produits$FicheType$Model$idDeLOuvreurDesValeursPosees;
var $author$project$Components$Produits$FicheType$Update$versLeDrawerDesValeursPosees = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{
						lE: drawer,
						si: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? model.si : $elm$core$Maybe$Nothing
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var vers = _v0;
					return $author$project$Components$Produits$Common$Effet$PlacerFocus(vers);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.lE));
	});
var $author$project$Components$Produits$FicheType$Update$ouvrirLesValeursPosees = F2(
	function (reponse, model) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$API$Reponse$lire, $author$project$Components$Produits$FicheType$ValeursPosees$listeDecoder, reponse),
			model.si);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var lignes = _v0.a.a;
				var enCours = _v0.b.a;
				var lu = _Utils_update(
					model,
					{
						si: $elm$core$Maybe$Just(
							A2($author$project$Components$Produits$FicheType$ValeursPosees$avecLesLignes, lignes, enCours))
					});
				return $author$project$Components$Shared$Drawer$Model$estOuvert(model.lE) ? _Utils_Tuple2(lu, _List_Nil) : A2(
					$author$project$Components$Produits$FicheType$Update$versLeDrawerDesValeursPosees,
					$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Produits$FicheType$Update$idDeLOuvreurDesValeursPosees),
					lu);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			var refus = _v0.a.a;
			return _Utils_Tuple2(
				$author$project$Components$Shared$Drawer$Model$estOuvert(model.lE) ? model : _Utils_update(
					model,
					{si: $elm$core$Maybe$Nothing}),
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Produits$FicheType$Update$clearRefus = function (rattachement) {
	return _Utils_update(
		rattachement,
		{pZ: $elm$core$Maybe$Nothing});
};
var $author$project$Catalogue$API$WriteAPIModel$RattacherUnChamp = F3(
	function (a, b, c) {
		return {$: 14, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$FicheType$Model$commandeDeRattachement = F2(
	function (fiche, choix) {
		return A2(
			$elm$core$Maybe$map,
			function (id) {
				return A3(
					$author$project$Catalogue$API$WriteAPIModel$RattacherUnChamp,
					fiche.fh.Aq,
					id,
					{mo: choix.qc.mo, n4: choix.qc.n4, g4: choix.qc.g4});
			},
			choix.vd);
	});
var $author$project$Components$Produits$FicheType$Update$rattacher = function (model) {
	var _v0 = model.zo;
	if (!_v0.$) {
		var fiche = _v0.a;
		var _v1 = _Utils_Tuple2(
			A2($author$project$Components$Produits$FicheType$Model$commandeDeRattachement, fiche, model.pN),
			$author$project$Components$Produits$FicheType$Model$rattachement(fiche));
		if ((!_v1.a.$) && (!_v1.b.$)) {
			var voulue = _v1.a.a;
			var lien = _v1.b.a;
			var _v2 = A3(
				$author$project$Components$Produits$Common$Envoi$partir,
				$elm$core$Maybe$Just(lien),
				voulue,
				model.l2);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var envoi = _v3.a;
				var effets = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: envoi,
							pN: $author$project$Components$Produits$FicheType$Update$clearRefus(model.pN)
						}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$FicheType$ChampDeBibliotheque$rechercher = F2(
	function (recherchable, etat) {
		return _Utils_update(
			etat,
			{G1: recherchable});
	});
var $author$project$Components$Produits$Common$Effet$LireLApercuDeLaRestriction = F4(
	function (a, b, c, d) {
		return {$: 11, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Produits$FicheType$RestrictionDuChamp$apercu = F2(
	function (enCours, fiche) {
		var _v0 = _Utils_Tuple2(
			enCours.gt,
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$apercuRestriction, fiche.nQ));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var etat = _v0.a.a;
			var lien = _v0.b.a;
			return $author$project$Components$Shared$Bibliotheque$Restriction$enregistrable(etat) ? $elm$core$Maybe$Just(
				{
					uN: enCours.dy,
					nB: lien,
					fh: fiche.fh.Aq,
					Ki: $author$project$Components$Shared$Bibliotheque$Restriction$retenues(etat)
				}) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$FicheType$Update$surLaRestriction = F2(
	function (changer, model) {
		var _v0 = _Utils_Tuple2(
			A2($elm$core$Maybe$map, changer, model.al),
			model.zo);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var change = _v0.a.a;
			var fiche = _v0.b.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						al: $elm$core$Maybe$Just(change)
					}),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (demande) {
							return _List_fromArray(
								[
									A4($author$project$Components$Produits$Common$Effet$LireLApercuDeLaRestriction, demande.nB, demande.fh, demande.uN, demande.Ki)
								]);
						},
						A2($author$project$Components$Produits$FicheType$RestrictionDuChamp$apercu, change, fiche))));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$Conduite$surLeFormulaire = F3(
	function (reglage, voulu, model) {
		if (voulu.$ === 12) {
			var _v1 = A2(
				$elm$core$Maybe$andThen,
				function (_v2) {
					var definition = _v2.a;
					var minima = _v2.b;
					return A4(
						$author$project$API$Envoi$partir,
						reglage.l2,
						$elm$core$Maybe$Just(definition.nB),
						definition.vJ(minima),
						model.l2);
				},
				A4(
					$elm$core$Maybe$map3,
					F3(
						function (cle, definition, minima) {
							return _Utils_Tuple2(definition, minima);
						}),
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.dy;
						},
						model.hP.lZ),
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dy;
							},
							reglage.CC),
						model.hP.lZ),
					$author$project$Components$Shared$EditeurDeSchema$Model$minimaVoulus(model.hP)));
			if (!_v1.$) {
				var _v3 = _v1.a;
				var envoi = _v3.a;
				var effets = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: envoi,
							hP: A2($author$project$Components$Shared$EditeurDeSchema$Model$refuser, $elm$core$Maybe$Nothing, model.hP)
						}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(
				A2($author$project$Components$Shared$EditeurDeSchema$Conduite$saisir, voulu, model),
				_List_Nil);
		}
	});
var $author$project$Components$Produits$FicheType$RestrictionDuChamp$toutCocher = $author$project$Components$Produits$FicheType$RestrictionDuChamp$surLEtat($author$project$Components$Shared$Bibliotheque$Restriction$toutCocher);
var $author$project$Components$Produits$FicheType$RestrictionDuChamp$toutDecocher = $author$project$Components$Produits$FicheType$RestrictionDuChamp$surLEtat($author$project$Components$Shared$Bibliotheque$Restriction$toutDecocher);
var $author$project$Catalogue$API$WriteAPIModel$ReglerLeFiltrable = F2(
	function (a, b) {
		return {$: 25, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$ReglerLeRecherchable = F2(
	function (a, b) {
		return {$: 26, a: a, b: b};
	});
var $author$project$Components$Produits$FicheType$ChampDeBibliotheque$commandes = F2(
	function (etat, fiche) {
		var _v0 = _Utils_Tuple3(
			A2($author$project$Components$Produits$FicheType$ChampDeBibliotheque$champDe, etat.dy, fiche),
			A2($elm$core$Dict$get, etat.dy, fiche.dq),
			A2($elm$core$Dict$get, etat.dy, fiche.GY));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var lu = _v0.a.a;
			var definition = _v0.b.a;
			var rattachement = _v0.c;
			var avec = F3(
				function (rel, liens, commande) {
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (lien) {
								return _List_fromArray(
									[
										_Utils_Tuple2(commande, lien)
									]);
							},
							A2($author$project$API$Liens$trouver, rel, liens)));
				});
			var filtre = (!_Utils_eq(etat.zG, definition.zG)) ? A3(
				avec,
				$author$project$API$NavLinksDictionary$reglerLeFiltrable,
				definition.nQ,
				A2($author$project$Catalogue$API$WriteAPIModel$ReglerLeFiltrable, definition.Aq, etat.zG)) : _List_Nil;
			var masquage = (etat.n4 && (!lu.n4)) ? A3(
				avec,
				$author$project$API$NavLinksDictionary$masquerUnChamp,
				lu.nQ,
				A2($author$project$Catalogue$API$WriteAPIModel$MasquerUnChamp, fiche.fh.Aq, etat.dy)) : (((!etat.n4) && lu.n4) ? A3(
				avec,
				$author$project$API$NavLinksDictionary$afficherUnChamp,
				lu.nQ,
				A2($author$project$Catalogue$API$WriteAPIModel$AfficherUnChamp, fiche.fh.Aq, etat.dy)) : _List_Nil);
			var niveau = function () {
				if (!rattachement.$) {
					var actuel = rattachement.a;
					return (!_Utils_eq(etat.np, actuel.g4)) ? A3(
						avec,
						$author$project$API$NavLinksDictionary$reglerLeRattachement,
						lu.nQ,
						A4($author$project$Catalogue$API$WriteAPIModel$ReglerLeRattachement, fiche.fh.Aq, etat.dy, etat.np, actuel.C7)) : _List_Nil;
				} else {
					return _List_Nil;
				}
			}();
			var recherche = (!_Utils_eq(etat.G1, definition.G1)) ? A3(
				avec,
				$author$project$API$NavLinksDictionary$reglerLeRecherchable,
				definition.nQ,
				A2($author$project$Catalogue$API$WriteAPIModel$ReglerLeRecherchable, definition.Aq, etat.G1)) : _List_Nil;
			return _Utils_ap(
				niveau,
				_Utils_ap(
					masquage,
					_Utils_ap(filtre, recherche)));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Produits$FicheType$Update$lancerLaSuite = F3(
	function (cle, suite, model) {
		if (suite.b) {
			var _v1 = suite.a;
			var premiere = _v1.a;
			var lien = _v1.b;
			var reste = suite.b;
			var _v2 = A3(
				$author$project$Components$Produits$Common$Envoi$partir,
				$elm$core$Maybe$Just(lien),
				premiere,
				model.l2);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var envoi = _v3.a;
				var effets = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: envoi,
							eO: $elm$core$Maybe$Just(
								A2($author$project$Components$Produits$FicheType$Reglages$pourLaSuite, cle, reste))
						}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$Common$Effet$LireLApercuDuResserrage = F3(
	function (a, b, c) {
		return {$: 7, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$FicheType$Model$lienDApercu = function (fiche) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$apercuResserrage, fiche.nQ);
};
var $author$project$Components$Produits$FicheType$Update$demandeDApercu = function (model) {
	var _v0 = _Utils_Tuple2(
		model.zo,
		$author$project$Components$Shared$EditeurDeSchema$Model$valide(model.hP));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var fiche = _v0.a.a;
		var champ = _v0.b.a;
		return $author$project$Components$Shared$EditeurDeSchema$Model$resserre(model.hP) ? A2(
			$elm$core$Maybe$map,
			function (lien) {
				return A3($author$project$Components$Produits$Common$Effet$LireLApercuDuResserrage, lien, fiche.fh.Aq, champ);
			},
			$author$project$Components$Produits$FicheType$Model$lienDApercu(fiche)) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$FicheType$Update$validerOuAvertir = function (model) {
	var _v0 = _Utils_Tuple2(
		model.tq,
		$author$project$Components$Produits$FicheType$Update$demandeDApercu(model));
	_v0$2:
	while (true) {
		switch (_v0.a.$) {
			case 0:
				if (!_v0.b.$) {
					var _v1 = _v0.a;
					var effet = _v0.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{tq: $author$project$Components$Shared$EditeurDeSchema$Resserrage$ApercuDemande}),
						_List_fromArray(
							[effet]));
				} else {
					break _v0$2;
				}
			case 1:
				var _v2 = _v0.a;
				return _Utils_Tuple2(model, _List_Nil);
			default:
				break _v0$2;
		}
	}
	return A2(
		$author$project$Components$Shared$EditeurDeSchema$Conduite$valider,
		$author$project$Components$Produits$FicheType$Update$conduite(model),
		_Utils_update(
			model,
			{tq: $author$project$Components$Shared$EditeurDeSchema$Resserrage$SansApercu}));
};
var $author$project$Components$Produits$FicheType$Update$validerLeChamp = function (model) {
	var _v0 = _Utils_Tuple3(model.hP.lZ, model.zo, model.qd);
	if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
		var fiche = _v0.b.a;
		var etat = _v0.c.a;
		var _v1 = A2($author$project$Components$Produits$FicheType$ChampDeBibliotheque$commandes, etat, fiche);
		if (!_v1.b) {
			return $author$project$Components$Produits$FicheType$Update$validerOuAvertir(model);
		} else {
			var suite = _v1;
			return $author$project$Components$Shared$EditeurDeSchema$Model$enCours(model.hP) ? $author$project$Components$Produits$FicheType$Update$validerOuAvertir(
				_Utils_update(
					model,
					{ro: suite})) : A3($author$project$Components$Produits$FicheType$Update$lancerLaSuite, etat.dy, suite, model);
		}
	} else {
		return $author$project$Components$Produits$FicheType$Update$validerOuAvertir(model);
	}
};
var $author$project$Catalogue$API$WriteAPIModel$DefinirLaRegleDeCode = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$definirLaRegleDeCode = 'definir-la-regle-de-code';
var $author$project$Components$Produits$FicheType$RegleDeCode$commande = F2(
	function (enCours, fiche) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair(
				A2($author$project$Catalogue$API$WriteAPIModel$DefinirLaRegleDeCode, fiche.fh.Aq, enCours.Iy)),
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$definirLaRegleDeCode, fiche.nQ));
	});
var $author$project$Components$Produits$Common$Effet$LireLApercuDeLaRegleDeCode = F3(
	function (a, b, c) {
		return {$: 12, a: a, b: b, c: c};
	});
var $author$project$API$NavLinksDictionary$apercuDeLaRegleDeCode = 'apercu-de-la-regle-de-code';
var $author$project$Components$Produits$FicheType$RegleDeCode$apercuADemander = F2(
	function (fiche, enCours) {
		return $elm$core$List$isEmpty(enCours.Iy) ? $elm$core$Maybe$Nothing : A2(
			$elm$core$Maybe$map,
			function (lien) {
				return _Utils_Tuple2(lien, enCours.Iy);
			},
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$apercuDeLaRegleDeCode, fiche.nQ));
	});
var $author$project$Components$Produits$FicheType$Update$demanderLApercuDeLaRegle = F2(
	function (fiche, enCours) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var lien = _v0.a;
					var segments = _v0.b;
					return _List_fromArray(
						[
							A3($author$project$Components$Produits$Common$Effet$LireLApercuDeLaRegleDeCode, lien, fiche.fh.Aq, segments)
						]);
				},
				A2($author$project$Components$Produits$FicheType$RegleDeCode$apercuADemander, fiche, enCours)));
	});
var $author$project$Components$Produits$FicheType$RegleDeCode$enCoursDe = function (fiche) {
	return {
		fw: $elm$core$Maybe$Nothing,
		tq: $elm$core$Maybe$Nothing,
		pZ: $elm$core$Maybe$Nothing,
		Iy: A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Iy;
				},
				fiche.hI))
	};
};
var $author$project$Components$Produits$FicheType$RegleDeCode$GenreTexte = 0;
var $author$project$Components$Produits$FicheType$RegleDeCode$deplacer = F2(
	function (rang, liste) {
		if ((rang < 2) || (_Utils_cmp(
			rang,
			$elm$core$List$length(liste)) > 0)) {
			return liste;
		} else {
			var avant = A2($elm$core$List$take, rang - 2, liste);
			var _v0 = A2($elm$core$List$drop, rang - 2, liste);
			if (_v0.b && _v0.b.b) {
				var precedent = _v0.a;
				var _v1 = _v0.b;
				var courant = _v1.a;
				var suite = _v1.b;
				return _Utils_ap(
					avant,
					A2(
						$elm$core$List$cons,
						courant,
						A2($elm$core$List$cons, precedent, suite)));
			} else {
				return liste;
			}
		}
	});
var $author$project$Components$Produits$FicheType$RegleDeCode$GenreCompteur = 3;
var $author$project$Components$Produits$FicheType$RegleDeCode$GenreMarque = 1;
var $author$project$Components$Produits$FicheType$RegleDeCode$GenreValeur = 2;
var $author$project$Components$Produits$FicheType$RegleDeCode$genreDe = function (code) {
	switch (code) {
		case '2':
			return 1;
		case '3':
			return 2;
		case '4':
			return 3;
		default:
			return 0;
	}
};
var $author$project$Components$Produits$FicheType$RegleDeCode$retirerLe = F2(
	function (rang, liste) {
		return _Utils_ap(
			A2($elm$core$List$take, rang - 1, liste),
			A2($elm$core$List$drop, rang, liste));
	});
var $author$project$Components$Produits$FicheType$RegleDeCode$champsDeType = F2(
	function (genre, fiche) {
		var voulu = (genre === 2) ? 'choix-dans-une-liste' : 'texte';
		return A2(
			$elm$core$List$map,
			function (lu) {
				return {dy: lu.uN.dy, Bl: lu.uN.Bl};
			},
			A2(
				$elm$core$List$filter,
				function (lu) {
					return _Utils_eq(
						lu.JR,
						$elm$core$Maybe$Just(voulu));
				},
				fiche.dw));
	});
var $author$project$Components$Produits$FicheType$RegleDeCode$choisi = F2(
	function (fiche, ajout) {
		return A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.dy;
				},
				$elm$core$Basics$eq(ajout.uN)),
			A2($author$project$Components$Produits$FicheType$RegleDeCode$champsDeType, ajout.M, fiche)) ? $elm$core$Maybe$Just(ajout.uN) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$Produits$FicheType$RegleDeCode$segmentDe = F2(
	function (fiche, ajout) {
		var _v0 = ajout.M;
		switch (_v0) {
			case 0:
				return (ajout.Jx === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Catalogue$RegleDeCode$TexteFixe(ajout.Jx));
			case 3:
				return $elm$core$Maybe$Just($author$project$Catalogue$RegleDeCode$Compteur);
			case 1:
				return A2(
					$elm$core$Maybe$map,
					$author$project$Catalogue$RegleDeCode$CodeDeLaMarque,
					A2($author$project$Components$Produits$FicheType$RegleDeCode$choisi, fiche, ajout));
			default:
				return A2(
					$elm$core$Maybe$map,
					function (cle) {
						return A2(
							$author$project$Catalogue$RegleDeCode$CodeDUneValeur,
							cle,
							$elm$core$String$toInt(ajout.ff));
					},
					A2($author$project$Components$Produits$FicheType$RegleDeCode$choisi, fiche, ajout));
		}
	});
var $author$project$Components$Produits$FicheType$RegleDeCode$surLAjout = F2(
	function (changer, enCours) {
		return _Utils_update(
			enCours,
			{
				fw: A2($elm$core$Maybe$map, changer, enCours.fw)
			});
	});
var $author$project$Components$Produits$FicheType$RegleDeCode$surLaSaisie = F3(
	function (fiche, geste, enCours) {
		switch (geste.$) {
			case 2:
				var rang = geste.a;
				return _Utils_update(
					enCours,
					{
						pZ: $elm$core$Maybe$Nothing,
						Iy: A2($author$project$Components$Produits$FicheType$RegleDeCode$retirerLe, rang, enCours.Iy)
					});
			case 3:
				var rang = geste.a;
				return _Utils_update(
					enCours,
					{
						pZ: $elm$core$Maybe$Nothing,
						Iy: A2($author$project$Components$Produits$FicheType$RegleDeCode$deplacer, rang, enCours.Iy)
					});
			case 4:
				var rang = geste.a;
				return _Utils_update(
					enCours,
					{
						pZ: $elm$core$Maybe$Nothing,
						Iy: A2($author$project$Components$Produits$FicheType$RegleDeCode$deplacer, rang + 1, enCours.Iy)
					});
			case 5:
				return _Utils_update(
					enCours,
					{
						fw: $elm$core$Maybe$Just(
							{uN: '', M: 0, Jx: '', ff: ''})
					});
			case 6:
				return _Utils_update(
					enCours,
					{fw: $elm$core$Maybe$Nothing});
			case 7:
				var code = geste.a;
				return A2(
					$author$project$Components$Produits$FicheType$RegleDeCode$surLAjout,
					function (ajout) {
						return _Utils_update(
							ajout,
							{
								uN: '',
								M: $author$project$Components$Produits$FicheType$RegleDeCode$genreDe(code)
							});
					},
					enCours);
			case 8:
				var texte = geste.a;
				return A2(
					$author$project$Components$Produits$FicheType$RegleDeCode$surLAjout,
					function (ajout) {
						return _Utils_update(
							ajout,
							{Jx: texte});
					},
					enCours);
			case 9:
				var cle = geste.a;
				return A2(
					$author$project$Components$Produits$FicheType$RegleDeCode$surLAjout,
					function (ajout) {
						return _Utils_update(
							ajout,
							{uN: cle});
					},
					enCours);
			case 10:
				var tranche = geste.a;
				return A2(
					$author$project$Components$Produits$FicheType$RegleDeCode$surLAjout,
					function (ajout) {
						return _Utils_update(
							ajout,
							{
								ff: A2($elm$core$String$filter, $elm$core$Char$isDigit, tranche)
							});
					},
					enCours);
			case 11:
				var _v1 = A2(
					$elm$core$Maybe$andThen,
					$author$project$Components$Produits$FicheType$RegleDeCode$segmentDe(fiche),
					enCours.fw);
				if (!_v1.$) {
					var segment = _v1.a;
					return _Utils_update(
						enCours,
						{
							fw: $elm$core$Maybe$Nothing,
							pZ: $elm$core$Maybe$Nothing,
							Iy: _Utils_ap(
								enCours.Iy,
								_List_fromArray(
									[segment]))
						});
				} else {
					return enCours;
				}
			default:
				return enCours;
		}
	});
var $author$project$Components$Produits$FicheType$Update$versLaRegleDeCode = F2(
	function (geste, model) {
		var _v0 = _Utils_Tuple2(geste, model.zo);
		_v0$0:
		while (true) {
			if (!_v0.b.$) {
				switch (_v0.a.$) {
					case 1:
						break _v0$0;
					case 0:
						var _v1 = _v0.a;
						var fiche = _v0.b.a;
						var enCours = $author$project$Components$Produits$FicheType$RegleDeCode$enCoursDe(fiche);
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(
								A2($author$project$Components$Produits$FicheType$Update$demanderLApercuDeLaRegle, fiche, enCours)),
							A2(
								$author$project$Components$Produits$FicheType$Update$versLeDrawerDeLaRegleDeCode,
								$author$project$Components$Shared$Drawer$Update$Ouvrir(
									$author$project$Components$Shared$Drawer$Model$idRacine(model.lB)),
								_Utils_update(
									model,
									{
										hI: $elm$core$Maybe$Just(enCours)
									})));
					case 12:
						var _v2 = _v0.a;
						var fiche = _v0.b.a;
						var _v3 = A2(
							$elm$core$Maybe$andThen,
							function (enCours) {
								return A2($author$project$Components$Produits$FicheType$RegleDeCode$commande, enCours, fiche);
							},
							model.hI);
						if (!_v3.$) {
							var _v4 = _v3.a;
							var voulue = _v4.a;
							var lien = _v4.b;
							var _v5 = A3(
								$author$project$Components$Produits$Common$Envoi$partir,
								$elm$core$Maybe$Just(lien),
								voulue,
								model.l2);
							if (!_v5.$) {
								var _v6 = _v5.a;
								var envoi = _v6.a;
								var effets = _v6.b;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{l2: envoi}),
									effets);
							} else {
								return _Utils_Tuple2(model, _List_Nil);
							}
						} else {
							return _Utils_Tuple2(model, _List_Nil);
						}
					default:
						var fiche = _v0.b.a;
						var apres = A2(
							$elm$core$Maybe$map,
							A2($author$project$Components$Produits$FicheType$RegleDeCode$surLaSaisie, fiche, geste),
							model.hI);
						var change = !_Utils_eq(
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.Iy;
								},
								apres),
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.Iy;
								},
								model.hI));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{hI: apres}),
							change ? A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									$author$project$Components$Produits$FicheType$Update$demanderLApercuDeLaRegle(fiche),
									apres)) : _List_Nil);
				}
			} else {
				if (_v0.a.$ === 1) {
					break _v0$0;
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			}
		}
		var vers = _v0.a.a;
		return A2($author$project$Components$Produits$FicheType$Update$versLeDrawerDeLaRegleDeCode, vers, model);
	});
var $author$project$Components$Produits$FicheType$Update$versLeRetrait = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{
						dh: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? model.dh : $elm$core$Maybe$Nothing,
						eW: drawer
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Produits$Common$Effet$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.eW));
	});
var $author$project$Catalogue$API$WriteAPIModel$AjouterUneCollection = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$RetirerUneCollection = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Components$Produits$FicheType$Update$versLesCollections = F2(
	function (geste, model) {
		var _v0 = model.zo;
		if (!_v0.$) {
			var fiche = _v0.a;
			var _v1 = A3($author$project$Components$Shared$CollectionsDuType$Update$update, fiche.vE, geste, model.vE);
			var collections = _v1.a;
			var effets = _v1.b;
			var sortie = _v1.c;
			var suivant = _Utils_update(
				model,
				{vE: collections});
			var focus = A2(
				$elm$core$List$map,
				function (_v3) {
					var cible = _v3;
					return $author$project$Components$Produits$Common$Effet$PlacerFocus(cible);
				},
				effets);
			var lancer = F2(
				function (commande, rel) {
					return A2(
						$elm$core$Tuple$mapSecond,
						function (partis) {
							return _Utils_ap(focus, partis);
						},
						A2(
							$author$project$Components$Produits$FicheType$Update$envoyer,
							function (f) {
								return A2(
									$elm$core$Maybe$map,
									function (lien) {
										return _Utils_Tuple2(commande, lien);
									},
									A2($author$project$API$Liens$trouver, rel, f.nQ));
							},
							suivant));
				});
			switch (sortie.$) {
				case 0:
					return _Utils_Tuple2(suivant, focus);
				case 1:
					var voulu = sortie.a;
					return A2(
						lancer,
						A2($author$project$Catalogue$API$WriteAPIModel$AjouterUneCollection, fiche.fh.Aq, voulu),
						$author$project$API$NavLinksDictionary$ajouterUneCollectionAUnType);
				default:
					var cle = sortie.a;
					return A2(
						lancer,
						A2($author$project$Catalogue$API$WriteAPIModel$RetirerUneCollection, fiche.fh.Aq, cle),
						$author$project$API$NavLinksDictionary$retirerUneCollectionDUnType);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$typeDeProduit = 'type-de-produit';
var $author$project$Components$Produits$Liens$versType = F2(
	function (id, gabarits) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$API$NavLinksDictionary$variableUid,
						$author$project$Catalogue$Identifiants$typeDeProduitIdToString(id))
					])),
			A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$typeDeProduit, gabarits));
	});
var $author$project$Components$Produits$FicheType$ValeursPosees$voirLesSuivantes = function (enCours) {
	return _Utils_update(
		enCours,
		{
			a8: $elm$core$List$length(enCours.gV)
		});
};
var $author$project$Components$Produits$FicheType$Update$update = F2(
	function (msg, model) {
		var initial = $author$project$Components$Produits$FicheType$Model$init;
		switch (msg.$) {
			case 0:
				var id = msg.a;
				var gabarits = msg.b;
				var _v1 = A2($author$project$Components$Produits$Liens$versType, id, gabarits);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							initial,
							{
								np: $elm$core$Maybe$Just(lecture)
							}),
						_List_fromArray(
							[
								$author$project$Components$Produits$Common$Effet$DemanderProcessUid,
								$author$project$Components$Produits$Common$Effet$Lire(lecture)
							]));
				} else {
					return _Utils_Tuple2(initial, _List_Nil);
				}
			case 19:
				var geste = msg.a;
				return A2($author$project$Components$Produits$FicheType$Update$versLesCollections, geste, model);
			case 20:
				var geste = msg.a;
				return A2($author$project$Components$Produits$FicheType$Update$versLesBlocs, geste, model);
			case 21:
				var reponse = msg.a;
				return A2($author$project$Components$Produits$FicheType$Update$ordreLu, reponse, model);
			case 1:
				var octets = msg.a;
				return $author$project$Components$Parametrage$NouveauChamp$Model$ouvert(model.oP) ? A2(
					$author$project$Components$Produits$FicheType$Update$surLeNouveauChamp,
					$author$project$Components$Parametrage$NouveauChamp$Update$ProcessUidRecu(octets),
					model) : $author$project$Components$Produits$FicheType$Update$envoyerLaSuite(
					_Utils_update(
						model,
						{
							l2: A2($author$project$Components$Produits$Common$Envoi$recevoir, octets, model.l2)
						}));
			case 2:
				var reponse = msg.a;
				var _v2 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$FicheType$API$QueryAPIModel$ficheDecoder, reponse);
				if (!_v2.$) {
					var fiche = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								zo: $elm$core$Maybe$Just(fiche),
								nf: false
							}),
						_Utils_eq(model.ss, $elm$core$Maybe$Nothing) ? _List_Nil : $author$project$Components$Produits$FicheType$Update$lireLHistorique(
							_Utils_update(
								model,
								{
									zo: $elm$core$Maybe$Just(fiche)
								})));
				} else {
					var refus = _v2.a;
					return (refus.ri === 401) ? _Utils_Tuple2(
						model,
						_List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter])) : _Utils_Tuple2(
						_Utils_update(
							model,
							{nf: refus.ri === 404}),
						_List_Nil);
				}
			case 3:
				var reponse = msg.a;
				var _v3 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$FicheType$API$QueryAPIModel$historiqueDecoder, reponse);
				if (!_v3.$) {
					var versions = _v3.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ss: $elm$core$Maybe$Just(versions)
							}),
						_List_Nil);
				} else {
					var refus = _v3.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 4:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Produits$FicheType$Update$relire(model));
			case 5:
				var geste = msg.a;
				return A3(
					$author$project$Components$Shared$EditeurDeSchema$Conduite$versLeDrawer,
					$author$project$Components$Produits$FicheType$Update$conduite(model),
					geste,
					_Utils_update(
						model,
						{
							tq: $author$project$Components$Shared$EditeurDeSchema$Resserrage$SansApercu,
							eO: $author$project$Components$Shared$Drawer$Model$estOuvert(model.lA) ? model.eO : $elm$core$Maybe$Nothing,
							ro: _List_Nil
						}));
			case 6:
				return $author$project$Components$Produits$FicheType$Update$ajoutOuvert(model);
			case 8:
				var geste = msg.a;
				return A2($author$project$Components$Produits$FicheType$Update$surLeNouveauChamp, geste, model);
			case 7:
				return function (_v4) {
					var ouvert = _v4.a;
					var effets = _v4.b;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2($author$project$Components$Produits$FicheType$Update$choisirLeMode, 1, ouvert));
				}(
					A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$LireLesListes, $elm$core$List$singleton),
									model.nM))),
						A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$LireLesListes, $elm$core$List$singleton),
										model.BF))),
							A3(
								$author$project$Components$Shared$EditeurDeSchema$Conduite$ouvrirLAjout,
								$author$project$Components$Produits$FicheType$Update$conduite(model),
								$author$project$Components$Produits$FicheType$Model$idDuRattachement,
								_Utils_update(
									model,
									{
										tq: $author$project$Components$Shared$EditeurDeSchema$Resserrage$SansApercu,
										wZ: {zG: false, G1: false},
										kz: $elm$core$Maybe$Nothing,
										n9: 0,
										pN: $author$project$Components$Shared$Bibliotheque$Rattachement$init(0),
										eO: $elm$core$Maybe$Nothing,
										ro: _List_Nil
									})))));
			case 49:
				var lien = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{nC: lien}),
					_List_Nil);
			case 50:
				var lien = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{BF: lien}),
					_List_Nil);
			case 51:
				var lien = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{nM: lien}),
					_List_Nil);
			case 52:
				var reponse = msg.a;
				var _v5 = A2($author$project$API$Reponse$lire, $author$project$Components$Shared$EditeurDeSchema$SousChamps$listesOuTypesDecoder, reponse);
				if (!_v5.$) {
					var lus = _v5.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								n_: _Utils_eq(lus.n_, _List_Nil) ? model.n_ : lus.n_,
								r2: _Utils_eq(lus.ib, _List_Nil) ? model.r2 : lus.ib
							}),
						_List_Nil);
				} else {
					var refus = _v5.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 53:
				if (!msg.a) {
					var _v6 = msg.a;
					return function (_v7) {
						var ferme = _v7.a;
						var effets = _v7.b;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							$author$project$Components$Produits$FicheType$Update$ajoutOuvert(ferme));
					}(
						A2(
							$author$project$Components$Produits$FicheType$Update$update,
							$author$project$Components$Produits$FicheType$Update$DuDrawer($author$project$Components$Shared$Drawer$Update$Fermer),
							model));
				} else {
					var mode = msg.a;
					return A2($author$project$Components$Produits$FicheType$Update$choisirLeMode, mode, model);
				}
			case 54:
				var reponse = msg.a;
				var _v8 = A2(
					$author$project$API$Reponse$lire,
					A4(
						$elm$json$Json$Decode$map3,
						F3(
							function (c, t, u) {
								return _Utils_Tuple3(c, t, u);
							}),
						$author$project$Components$Produits$FicheType$API$QueryAPIModel$bibliothequeDecoder,
						$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$typesProposesDecoder,
						$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$unitesDeMesureDecoder),
					reponse);
				if (!_v8.$) {
					var _v9 = _v8.a;
					var champs = _v9.a;
					var types = _v9.b;
					var unites = _v9.c;
					var rattachement = model.pN;
					return $author$project$Components$Produits$FicheType$Update$nouveauChampPret(
						_Utils_update(
							model,
							{
								pN: _Utils_update(
									rattachement,
									{
										dq: $elm$core$Maybe$Just(champs)
									}),
								J_: types,
								sc: unites
							}));
				} else {
					var refus = _v8.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 55:
				var texte = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							pN: A2($author$project$Components$Shared$Bibliotheque$Rattachement$saisirLaRecherche, texte, model.pN)
						}),
					_List_Nil);
			case 56:
				var id = msg.a;
				var choisi = A2($author$project$Components$Shared$Bibliotheque$Rattachement$choisir, id, model.pN);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pN: choisi}),
					$author$project$Components$Shared$Bibliotheque$Rattachement$horsPortee(choisi) ? _List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$PlacerFocus($author$project$Components$Produits$FicheType$Model$idDuRefusDeRattachement)
						]) : _List_Nil);
			case 57:
				var exigence = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							pN: A2($author$project$Components$Shared$Bibliotheque$Rattachement$exiger, exigence, model.pN)
						}),
					_List_Nil);
			case 58:
				var niveau = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							pN: A2($author$project$Components$Shared$Bibliotheque$Rattachement$lire, niveau, model.pN)
						}),
					_List_Nil);
			case 59:
				var masque = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							pN: A2($author$project$Components$Shared$Bibliotheque$Rattachement$masquer, masque, model.pN)
						}),
					_List_Nil);
			case 60:
				var coche = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							wZ: {zG: coche, G1: model.wZ.G1}
						}),
					_List_Nil);
			case 61:
				var coche = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							wZ: {zG: model.wZ.zG, G1: coche}
						}),
					_List_Nil);
			case 63:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{kz: $elm$core$Maybe$Nothing}),
					_List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$PlacerFocus(
							A2(
								$author$project$Components$Shared$EditeurDeSchema$View$idDuLibelle,
								$author$project$Components$Shared$Drawer$Model$idRacine(model.kX),
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$elm$core$List$head(model.hP.Ba))))
						]));
			case 62:
				var id = msg.a;
				var rattachement = model.pN;
				return A2(
					$author$project$Components$Produits$FicheType$Update$choisirLeMode,
					1,
					_Utils_update(
						model,
						{
							pN: _Utils_update(
								rattachement,
								{
									vd: $elm$core$Maybe$Just(id)
								})
						}));
			case 9:
				var geste = msg.a;
				return A3(
					$author$project$Components$Shared$EditeurDeSchema$Conduite$surLeFormulaire,
					$author$project$Components$Produits$FicheType$Update$conduite(model),
					geste,
					_Utils_update(
						model,
						{tq: $author$project$Components$Shared$EditeurDeSchema$Resserrage$SansApercu}));
			case 11:
				return ((model.n9 === 1) && _Utils_eq(model.hP.lZ, $elm$core$Maybe$Nothing)) ? $author$project$Components$Produits$FicheType$Update$rattacher(model) : $author$project$Components$Produits$FicheType$Update$validerLeChamp(model);
			case 24:
				var reponse = msg.a;
				var _v10 = A2($author$project$API$Reponse$lire, $author$project$Components$Shared$EditeurDeSchema$Resserrage$decoder, reponse);
				if (!_v10.$) {
					var resserrage = _v10.a;
					return (!_Utils_eq(model.tq, $author$project$Components$Shared$EditeurDeSchema$Resserrage$ApercuDemande)) ? _Utils_Tuple2(model, _List_Nil) : (((!resserrage.oF) && (!resserrage.tW)) ? A2(
						$author$project$Components$Shared$EditeurDeSchema$Conduite$valider,
						$author$project$Components$Produits$FicheType$Update$conduite(model),
						_Utils_update(
							model,
							{tq: $author$project$Components$Shared$EditeurDeSchema$Resserrage$SansApercu})) : _Utils_Tuple2(
						_Utils_update(
							model,
							{
								tq: $author$project$Components$Shared$EditeurDeSchema$Resserrage$Avertit(resserrage)
							}),
						_List_fromArray(
							[
								$author$project$Components$Produits$Common$Effet$PlacerFocus(
								$author$project$Components$Shared$EditeurDeSchema$Resserrage$idDeLApercu(
									$author$project$Components$Shared$Drawer$Model$idRacine(model.kX)))
							])));
				} else {
					var refus = _v10.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{tq: $author$project$Components$Shared$EditeurDeSchema$Resserrage$SansApercu}),
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 12:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Produits$FicheType$Update$lireLHistorique(model));
			case 13:
				return _Utils_eq(
					A2($elm$core$Maybe$andThen, $author$project$Components$Produits$FicheType$Model$commandeDArchivage, model.zo),
					$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : _Utils_Tuple2(
					_Utils_update(
						model,
						{ir: true}),
					_List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$PlacerFocus($author$project$Components$Produits$FicheType$Model$idsDeLArchivage.to)
						]));
			case 14:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ir: false}),
					_List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$PlacerFocus($author$project$Components$Produits$FicheType$Model$idDeLArchivage)
						]));
			case 15:
				return model.ir ? A2(
					$author$project$Components$Produits$FicheType$Update$envoyer,
					$author$project$Components$Produits$FicheType$Model$commandeDArchivage,
					_Utils_update(
						model,
						{ir: false})) : _Utils_Tuple2(model, _List_Nil);
			case 16:
				var typologie = msg.a;
				return _Utils_eq(
					A2(
						$elm$core$Maybe$andThen,
						$author$project$Components$Produits$FicheType$Model$commandeDeRetrait(typologie),
						model.zo),
					$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A2(
					$author$project$Components$Produits$FicheType$Update$versLeRetrait,
					$author$project$Components$Shared$Drawer$Update$Ouvrir(
						$author$project$Components$Produits$FicheType$Model$idDuRetrait(typologie)),
					_Utils_update(
						model,
						{
							dh: $elm$core$Maybe$Just(typologie)
						}));
			case 17:
				var geste = msg.a;
				return A2($author$project$Components$Produits$FicheType$Update$versLeRetrait, geste, model);
			case 18:
				var _v11 = model.dh;
				if (!_v11.$) {
					var typologie = _v11.a;
					return A2(
						$author$project$Components$Produits$FicheType$Update$envoyer,
						$author$project$Components$Produits$FicheType$Model$commandeDeRetrait(typologie),
						$author$project$Components$Produits$FicheType$Update$fermerLeRetrait(model));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 22:
				var vers = msg.a;
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$PlacerFocus(vers)
						]));
			case 64:
				var champ = msg.a;
				var ouvreur = msg.b;
				var _v12 = A2(
					$elm$core$Maybe$andThen,
					A2($author$project$Components$Shared$Bibliotheque$Elargissement$ouvrir, 0, champ),
					model.pN.dq);
				if (!_v12.$) {
					var elargissement = _v12.a;
					return A2(
						$author$project$Components$Produits$FicheType$Update$versLElargissement,
						$author$project$Components$Shared$Drawer$Update$Ouvrir(ouvreur),
						_Utils_update(
							model,
							{
								lP: $elm$core$Maybe$Just(elargissement)
							}));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 65:
				var geste = msg.a;
				return A2($author$project$Components$Produits$Common$Envoi$retientLeDrawer, model.l2, geste) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Produits$FicheType$Update$versLElargissement, geste, model);
			case 66:
				var confirme = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							lP: A2(
								$elm$core$Maybe$map,
								$author$project$Components$Shared$Bibliotheque$Elargissement$confirmer(confirme),
								model.lP)
						}),
					_List_Nil);
			case 67:
				var _v13 = A2($elm$core$Maybe$andThen, $author$project$Components$Shared$Bibliotheque$Elargissement$demande, model.lP);
				if (!_v13.$) {
					var voulue = _v13.a;
					var _v14 = A3(
						$author$project$Components$Produits$Common$Envoi$partir,
						$elm$core$Maybe$Just(voulue.nB),
						A2($author$project$Catalogue$API$WriteAPIModel$ChangerLaPortee, voulue.uN, voulue.F$),
						model.l2);
					if (!_v14.$) {
						var _v15 = _v14.a;
						var envoi = _v15.a;
						var effets = _v15.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{l2: envoi}),
							effets);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 68:
				var code = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							qd: A2(
								$elm$core$Maybe$map,
								$author$project$Components$Produits$FicheType$ChampDeBibliotheque$choisirLecture(code),
								model.qd)
						}),
					_List_Nil);
			case 69:
				var masque = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							qd: A2(
								$elm$core$Maybe$map,
								$author$project$Components$Produits$FicheType$ChampDeBibliotheque$masquer(masque),
								model.qd)
						}),
					_List_Nil);
			case 70:
				var coche = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							qd: A2(
								$elm$core$Maybe$map,
								$author$project$Components$Produits$FicheType$ChampDeBibliotheque$filtrer(coche),
								model.qd)
						}),
					_List_Nil);
			case 71:
				var coche = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							qd: A2(
								$elm$core$Maybe$map,
								$author$project$Components$Produits$FicheType$ChampDeBibliotheque$rechercher(coche),
								model.qd)
						}),
					_List_Nil);
			case 10:
				switch (msg.a.$) {
					case 9:
						var cle = msg.a.a;
						return A2($author$project$Components$Produits$FicheType$Update$ouvrirLesReglages, cle, model);
					case 8:
						var cle = msg.a.a;
						return A3(
							$author$project$Components$Shared$EditeurDeSchema$Conduite$surLeTableau,
							$author$project$Components$Produits$FicheType$Update$conduite(model),
							$author$project$Components$Shared$EditeurDeSchema$View$ModificationDemandee(cle),
							_Utils_update(
								model,
								{
									tq: $author$project$Components$Shared$EditeurDeSchema$Resserrage$SansApercu,
									eO: $elm$core$Maybe$Nothing,
									qd: A2(
										$elm$core$Maybe$andThen,
										$author$project$Components$Produits$FicheType$ChampDeBibliotheque$ouvrir(cle),
										model.zo),
									ro: _List_Nil
								}));
					default:
						var geste = msg.a;
						return A3(
							$author$project$Components$Shared$EditeurDeSchema$Conduite$surLeTableau,
							$author$project$Components$Produits$FicheType$Update$conduite(model),
							geste,
							_Utils_update(
								model,
								{tq: $author$project$Components$Shared$EditeurDeSchema$Resserrage$SansApercu}));
				}
			case 25:
				var geste = msg.a;
				return A2($author$project$Components$Produits$Common$Envoi$retientLeDrawer, model.l2, geste) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Produits$FicheType$Update$versLeDrawerDesReglages, geste, model);
			case 26:
				var code = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eO: A2(
								$elm$core$Maybe$map,
								$author$project$Components$Produits$FicheType$Reglages$choisirExigence(code),
								model.eO)
						}),
					_List_Nil);
			case 27:
				var code = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eO: A2(
								$elm$core$Maybe$map,
								$author$project$Components$Produits$FicheType$Reglages$choisirLecture(code),
								model.eO)
						}),
					_List_Nil);
			case 28:
				var code = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eO: A2(
								$elm$core$Maybe$map,
								$author$project$Components$Produits$FicheType$Reglages$choisirSaisie(code),
								model.eO)
						}),
					_List_Nil);
			case 29:
				return $author$project$Components$Produits$FicheType$Update$enregistrerLesReglages(model);
			case 30:
				var cle = msg.a;
				return A2($author$project$Components$Produits$FicheType$Update$demanderLaRestriction, cle, model);
			case 31:
				var geste = msg.a;
				return A2($author$project$Components$Produits$FicheType$Update$versLaRegleDeCode, geste, model);
			case 32:
				var segments = msg.a;
				var reponse = msg.b;
				return A3($author$project$Components$Produits$FicheType$Update$apercuDeLaRegle, segments, reponse, model);
			case 33:
				var reponse = msg.a;
				return A2($author$project$Components$Produits$FicheType$Update$ouvrirLaRestriction, reponse, model);
			case 34:
				var geste = msg.a;
				return A2($author$project$Components$Produits$Common$Envoi$retientLeDrawer, model.l2, geste) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Produits$FicheType$Update$versLeDrawerDeRestriction, geste, model);
			case 35:
				var id = msg.a;
				var oui = msg.b;
				return A2(
					$author$project$Components$Produits$FicheType$Update$surLaRestriction,
					A2($author$project$Components$Produits$FicheType$RestrictionDuChamp$cocher, id, oui),
					model);
			case 36:
				return A2($author$project$Components$Produits$FicheType$Update$surLaRestriction, $author$project$Components$Produits$FicheType$RestrictionDuChamp$toutCocher, model);
			case 37:
				return A2($author$project$Components$Produits$FicheType$Update$surLaRestriction, $author$project$Components$Produits$FicheType$RestrictionDuChamp$toutDecocher, model);
			case 38:
				return A2($author$project$Components$Produits$FicheType$Update$envoyerLaRestriction, $author$project$Components$Produits$FicheType$RestrictionDuChamp$enregistrer, model);
			case 39:
				return A2($author$project$Components$Produits$FicheType$Update$envoyerLaRestriction, $author$project$Components$Produits$FicheType$RestrictionDuChamp$lever, model);
			case 40:
				return A2($author$project$Components$Produits$FicheType$Update$envoyerLaRestriction, $author$project$Components$Produits$FicheType$RestrictionDuChamp$masquer, model);
			case 41:
				var reponse = msg.a;
				return A2($author$project$Components$Produits$FicheType$Update$apercuDeLaRestriction, reponse, model);
			case 42:
				var cle = msg.a;
				return A2($author$project$Components$Produits$FicheType$Update$demanderLesValeursPosees, cle, model);
			case 43:
				var reponse = msg.a;
				return A2($author$project$Components$Produits$FicheType$Update$ouvrirLesValeursPosees, reponse, model);
			case 44:
				var geste = msg.a;
				return A2($author$project$Components$Produits$FicheType$Update$versLeDrawerDesValeursPosees, geste, model);
			case 45:
				return _Utils_Tuple2(
					A2($author$project$Components$Produits$FicheType$Update$surLesValeursPosees, $author$project$Components$Produits$FicheType$ValeursPosees$voirLesSuivantes, model),
					_List_Nil);
			case 46:
				var rang = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Produits$FicheType$Update$surLesValeursPosees,
						$author$project$Components$Produits$FicheType$ValeursPosees$demanderLeRetrait(rang),
						model),
					_List_Nil);
			case 47:
				return _Utils_Tuple2(
					A2($author$project$Components$Produits$FicheType$Update$surLesValeursPosees, $author$project$Components$Produits$FicheType$ValeursPosees$annulerLeRetrait, model),
					_List_Nil);
			case 48:
				return $author$project$Components$Produits$FicheType$Update$envoyerLeRetraitDUneValeur(model);
			default:
				var reponse = msg.a;
				var _v16 = A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, model.l2);
				if (!_v16.$) {
					var _v17 = _v16.a;
					var envoi = _v17.a;
					var issue = _v17.b;
					var effets = _v17.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Produits$FicheType$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Main$Update$versLaFicheType = F3(
	function (i18n, msg, model) {
		var _v0 = A2(
			$author$project$Components$Produits$FicheType$Update$update,
			msg,
			A2(
				$author$project$Referentiel$Normes$poser,
				model.hd,
				$author$project$Components$Produits$FicheType$Model$ouvrir(model.zs)));
		var ficheType = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLesElements, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			A3($author$project$Main$Update$depuisLesElements, i18n, 6, 11),
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						zs: $author$project$Components$Produits$FicheType$Model$envelopper(ficheType),
						Ct: A2(
							$author$project$Main$Update$remonter,
							A2(
								$author$project$Components$Produits$FicheType$Update$popMessages,
								$author$project$Components$Produits$FicheType$Model$ouvrir(model.zs),
								msg),
							gardes)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$AttendreAvantDeChercherLesReferencesAAjouter = F2(
	function (a, b) {
		return {$: 170, a: a, b: b};
	});
var $author$project$Main$Update$ChercherLesReferencesAAjouter = function (a) {
	return {$: 169, a: a};
};
var $author$project$Main$Update$FicheDUneListeDePrix = 13;
var $author$project$Main$Model$PourLaListeDePrix = 28;
var $author$project$Components$Produits$ListeDePrix$API$QueryAPIModel$Fiche = function (id) {
	return function (nom) {
		return function (publics) {
			return function (publique) {
				return function (devise) {
					return function (taxes) {
						return function (validite) {
							return function (etat) {
								return function (enConflit) {
									return function (listePubliqueDuJour) {
										return function (lignes) {
											return function (publicsProposables) {
												return function (liens) {
													return function (gabarits) {
														return {kO: devise, yi: enConflit, gt: etat, gF: gabarits, Aq: id, nQ: liens, gV: lignes, BV: listePubliqueDuJour, Dj: nom, GA: publics, GB: publicsProposables, GF: publique, rB: taxes, sk: validite};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Produits$ListeDePrix$API$QueryAPIModel$Ligne = F4(
	function (reference, montant, unite, taxes) {
		return {oi: montant, Hc: reference, rB: taxes, sa: unite};
	});
var $author$project$Components$Produits$ListeDePrix$API$QueryAPIModel$ReferenceDeLigne = F5(
	function (id, nom, code, nature, arretee) {
		return {tL: arretee, vx: code, Aq: id, g1: nature, Dj: nom};
	});
var $author$project$Components$Produits$ListeDePrix$API$QueryAPIModel$ligneDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'taxes',
	$author$project$Catalogue$API$PrixAPIModel$taxesDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'unite',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'montant',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				$author$project$Catalogue$Vocabulaire$champDeLaReference,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'arretee',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'nature',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'code',
							$elm$json$Json$Decode$string,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'nom',
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$author$project$Catalogue$Identifiants$referenceIdDecoder,
									$elm$json$Json$Decode$succeed($author$project$Components$Produits$ListeDePrix$API$QueryAPIModel$ReferenceDeLigne)))))),
				$elm$json$Json$Decode$succeed($author$project$Components$Produits$ListeDePrix$API$QueryAPIModel$Ligne)))));
var $author$project$Components$Produits$ListeDePrix$API$QueryAPIModel$ficheDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.gF;
		},
		$author$project$API$Liens$deLaRessource),
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		A2(
			$elm$json$Json$Decode$map,
			function ($) {
				return $.h0;
			},
			$author$project$API$Liens$deLaRessource),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'publicsProposables',
			$elm$json$Json$Decode$list($author$project$Catalogue$API$PrixAPIModel$typeProposeDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'lignes',
				$elm$json$Json$Decode$list($author$project$Components$Produits$ListeDePrix$API$QueryAPIModel$ligneDecoder),
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'listePubliqueDuJour',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$PrixAPIModel$listeNommeeDecoder),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'enConflit',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'etat',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'validite',
								$author$project$Catalogue$API$PrixAPIModel$validiteDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'taxes',
									$author$project$Catalogue$API$PrixAPIModel$taxesDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'devise',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'publique',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'publics',
												$elm$json$Json$Decode$list($author$project$Catalogue$API$PrixAPIModel$publicDecoder),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'nom',
													$author$project$Catalogue$API$QueryAPIModel$libellesDecoder,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'id',
														$author$project$Catalogue$Identifiants$listeDePrixIdDecoder,
														$elm$json$Json$Decode$succeed($author$project$Components$Produits$ListeDePrix$API$QueryAPIModel$Fiche)))))))))))))));
var $author$project$Components$Produits$ListeDePrix$Update$perime = function (erreur) {
	return A2(
		$elm$core$List$member,
		erreur,
		_List_fromArray(
			[$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$Introuvable, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$EcritureConcurrente, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ReferenceIntrouvable, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ReferenceArreteeALAjout, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$PublicRefuse]));
};
var $author$project$Components$Produits$ListeDePrix$Update$message = F2(
	function (refus, erreur) {
		return $author$project$Components$Produits$ListeDePrix$Update$perime(erreur) ? {Jx: $author$project$I18n$Textes$produitsCatalogueErreurPerime, b9: refus.b9} : $author$project$Components$Shared$Messages$Model$duRefus(refus);
	});
var $author$project$Components$Produits$ListeDePrix$API$QueryAPIModel$referencesTrouveesDecoder = A2(
	$elm$json$Json$Decode$field,
	'references',
	$elm$json$Json$Decode$list(
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'arretee',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'code',
				$elm$json$Json$Decode$string,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					$author$project$Catalogue$Vocabulaire$champDuProduit,
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$author$project$Catalogue$Identifiants$referenceIdDecoder,
						$elm$json$Json$Decode$succeed(
							F4(
								function (id, nom, code, arretee) {
									return A5($author$project$Components$Produits$ListeDePrix$API$QueryAPIModel$ReferenceDeLigne, id, nom, code, '', arretee);
								}))))))));
var $author$project$Components$Produits$ListeDePrix$Update$popMessages = F2(
	function (model, msg) {
		switch (msg.$) {
			case 19:
				var reponse = msg.a;
				var _v1 = A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, model.l2);
				_v1$4:
				while (true) {
					_v1$5:
					while (true) {
						if (!_v1.$) {
							switch (_v1.a.b.$) {
								case 0:
									if (!_v1.a.b.c) {
										var _v2 = _v1.a;
										var _v3 = _v2.b;
										return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($author$project$Components$Produits$Common$Refus$rejeu);
									} else {
										break _v1$5;
									}
								case 1:
									switch (_v1.a.b.a.$) {
										case 60:
											if (_v1.a.b.c.$ === 66) {
												var _v4 = _v1.a;
												var _v5 = _v4.b;
												var _v6 = _v5.a;
												return $elm$core$Maybe$Nothing;
											} else {
												break _v1$4;
											}
										case 62:
											var _v7 = _v1.a;
											var _v8 = _v7.b;
											var _v9 = _v8.a;
											return $elm$core$Maybe$Nothing;
										case 63:
											var _v10 = _v1.a;
											var _v11 = _v10.b;
											var _v12 = _v11.a;
											return $elm$core$Maybe$Nothing;
										default:
											break _v1$4;
									}
								default:
									break _v1$5;
							}
						} else {
							break _v1$5;
						}
					}
					return $elm$core$Maybe$Nothing;
				}
				var _v13 = _v1.a;
				var _v14 = _v13.b;
				var refus = _v14.b;
				var erreur = _v14.c;
				return $elm$core$Maybe$Just(
					A2($author$project$Components$Produits$ListeDePrix$Update$message, refus, erreur));
			case 2:
				var reponse = msg.a;
				var _v15 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$ListeDePrix$API$QueryAPIModel$ficheDecoder, reponse);
				if (_v15.$ === 1) {
					var refus = _v15.a;
					return A2(
						$elm$core$List$member,
						refus.ri,
						_List_fromArray(
							[401, 404])) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 12:
				var reponse = msg.b;
				var _v16 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$ListeDePrix$API$QueryAPIModel$referencesTrouveesDecoder, reponse);
				if (_v16.$ === 1) {
					var refus = _v16.a;
					return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 1:
				var octets = msg.a;
				return _Utils_eq(
					$author$project$API$ProcessUid$depuisOctets(octets),
					$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
					{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Catalogue$API$WriteAPIModel$RendrePubliqueUneListeDePrix = F2(
	function (a, b) {
		return {$: 63, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$RetirerUnPrix = F2(
	function (a, b) {
		return {$: 61, a: a, b: b};
	});
var $author$project$Catalogue$Vocabulaire$unitesDePrix = _List_fromArray(
	['unique', 'par-an', 'par-mois', 'par-unite']);
var $author$project$Components$Produits$ListeDePrix$Model$lignesMontrees = F2(
	function (model, fiche) {
		return _Utils_ap(
			fiche.gV,
			A2(
				$elm$core$List$map,
				function (nouvelle) {
					return {
						oi: '',
						Hc: nouvelle,
						rB: fiche.rB,
						sa: A2(
							$elm$core$Maybe$withDefault,
							'',
							$elm$core$List$head($author$project$Catalogue$Vocabulaire$unitesDePrix))
					};
				},
				model.DV));
	});
var $author$project$Components$Produits$ListeDePrix$Model$proposees = F2(
	function (model, fiche) {
		return A2(
			$elm$core$List$filter,
			function (trouvee) {
				return (!trouvee.tL) && (!A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Hc;
						},
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(trouvee.Aq))),
					A2($author$project$Components$Produits$ListeDePrix$Model$lignesMontrees, model, fiche)));
			},
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.fg;
					},
					model.fw)));
	});
var $author$project$Components$Produits$ListeDePrix$Model$ajouter = F3(
	function (id, fiche, model) {
		return A2(
			$elm$core$Maybe$map,
			function (choisie) {
				return _Utils_update(
					model,
					{
						fw: $elm$core$Maybe$Nothing,
						DV: _Utils_ap(
							model.DV,
							_List_fromArray(
								[choisie]))
					});
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Aq;
						},
						$elm$core$Basics$eq(id)),
					A2($author$project$Components$Produits$ListeDePrix$Model$proposees, model, fiche))));
	});
var $author$project$Catalogue$API$WriteAPIModel$ChangerLesPublicsDUneListeDePrix = F2(
	function (a, b) {
		return {$: 62, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$changerLesPublicsDUneListeDePrix = 'changer-les-publics-d-une-liste-de-prix';
var $author$project$Components$Produits$ListeDePrix$Model$lienDesPublics = function (fiche) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$changerLesPublicsDUneListeDePrix, fiche.nQ);
};
var $author$project$Components$Produits$ListeDePrix$Model$commandeDesPublics = F2(
	function (fiche, model) {
		var portes = A2(
			$elm$core$List$map,
			function ($) {
				return $.Hb;
			},
			fiche.GA);
		var memes = _Utils_eq(
			$elm$core$List$length(portes),
			$elm$core$List$length(model.X)) && A2(
			$elm$core$List$all,
			function (ref) {
				return A2($elm$core$List$member, ref, portes);
			},
			model.X);
		return memes ? $elm$core$Maybe$Nothing : A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair(
				A2($author$project$Catalogue$API$WriteAPIModel$ChangerLesPublicsDUneListeDePrix, fiche.Aq, model.X)),
			$author$project$Components$Produits$ListeDePrix$Model$lienDesPublics(fiche));
	});
var $author$project$Components$Produits$ListeDePrix$Update$partir = F3(
	function (lien, commande, model) {
		if (!$elm$core$List$isEmpty(model.iv)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v0 = A3(
				$author$project$Components$Produits$Common$Envoi$partir,
				$elm$core$Maybe$Just(lien),
				commande,
				model.l2);
			if (!_v0.$) {
				var _v1 = _v0.a;
				var envoi = _v1.a;
				var effets = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{l2: envoi, b_: $elm$core$Maybe$Nothing}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		}
	});
var $author$project$Components$Produits$ListeDePrix$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{kX: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Produits$Common$Effet$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.kX));
	});
var $author$project$Components$Produits$ListeDePrix$Update$changerLesPublics = function (model) {
	var _v0 = _Utils_Tuple2(
		$author$project$Components$Shared$Drawer$Model$estOuvert(model.kX),
		model.zo);
	if (_v0.a && (!_v0.b.$)) {
		var fiche = _v0.b.a;
		var _v1 = _Utils_Tuple2(
			$author$project$Components$Produits$ListeDePrix$Model$lienDesPublics(fiche),
			A2($author$project$Components$Produits$ListeDePrix$Model$commandeDesPublics, fiche, model));
		if (_v1.a.$ === 1) {
			var _v2 = _v1.a;
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			if (_v1.b.$ === 1) {
				var _v3 = _v1.b;
				return A2($author$project$Components$Produits$ListeDePrix$Update$versLeDrawer, $author$project$Components$Shared$Drawer$Update$Fermer, model);
			} else {
				var _v4 = _v1.b.a;
				var commande = _v4.a;
				var lien = _v4.b;
				return A3(
					$author$project$Components$Produits$ListeDePrix$Update$partir,
					lien,
					commande,
					_Utils_update(
						model,
						{p7: _List_Nil}));
			}
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$ListeDePrix$Model$lienDeLaRecherche = function (fiche) {
	return A2(
		$author$project$Components$Produits$Liens$versLaRecherche,
		{EE: 1, Jm: 25},
		fiche.gF);
};
var $author$project$Components$Produits$ListeDePrix$Model$recherche = function (ajout) {
	return {i2: false, dt: _List_Nil, dw: _List_Nil, jF: _List_Nil, j2: $elm$core$Maybe$Nothing, gt: $elm$core$Maybe$Nothing, mj: _List_Nil, mu: _List_Nil, gG: _List_Nil, cU: _List_Nil, ou: $elm$core$Maybe$Nothing, pn: _List_Nil, h3: ajout.h3, rS: $elm$core$Maybe$Nothing, fh: $elm$core$Maybe$Nothing, r7: _List_Nil};
};
var $author$project$Components$Produits$ListeDePrix$Update$chercher = function (model) {
	var _v0 = _Utils_Tuple2(
		model.fw,
		A2($elm$core$Maybe$andThen, $author$project$Components$Produits$ListeDePrix$Model$lienDeLaRecherche, model.zo));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var ajout = _v0.a.a;
		var lien = _v0.b.a;
		return _Utils_Tuple2(
			model,
			_List_fromArray(
				[
					A3(
					$author$project$Components$Produits$Common$Effet$Rechercher,
					ajout.DX,
					lien,
					$author$project$Components$Produits$ListeDePrix$Model$recherche(ajout))
				]));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$ListeDePrix$Model$cocherUnPublic = F4(
	function (ref, coche, fiche, model) {
		return (!coche) ? _Utils_update(
			model,
			{
				X: A2(
					$elm$core$List$filter,
					$elm$core$Basics$neq(ref),
					model.X)
			}) : ((A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Hb;
				},
				$elm$core$Basics$eq(ref)),
			fiche.GB) && (!A2($elm$core$List$member, ref, model.X))) ? _Utils_update(
			model,
			{
				X: _Utils_ap(
					model.X,
					_List_fromArray(
						[ref]))
			}) : model);
	});
var $author$project$Components$Produits$ListeDePrix$Model$publicsAChoisir = function (fiche) {
	return _Utils_ap(
		fiche.GB,
		A2(
			$elm$core$List$filter,
			function (porte) {
				return !A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Hb;
						},
						$elm$core$Basics$eq(porte.Hb)),
					fiche.GB);
			},
			fiche.GA));
};
var $author$project$Components$Produits$ListeDePrix$Model$appliquer = F3(
	function (nouvelles, evenements, fiche) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (evenement, courante) {
					switch (evenement.$) {
						case 57:
							var fixe = evenement.a;
							return A2(
								$elm$core$List$any,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.Hc;
									},
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.Aq;
										},
										$elm$core$Basics$eq(fixe.Hc))),
								courante.gV) ? _Utils_update(
								courante,
								{
									gV: A2(
										$elm$core$List$map,
										function (ligne) {
											return _Utils_eq(ligne.Hc.Aq, fixe.Hc) ? _Utils_update(
												ligne,
												{oi: fixe.oi, rB: fixe.rB, sa: fixe.sa}) : ligne;
										},
										courante.gV)
								}) : _Utils_update(
								courante,
								{
									gV: _Utils_ap(
										courante.gV,
										A2(
											$elm$core$List$map,
											function (nouvelle) {
												return {oi: fixe.oi, Hc: nouvelle, rB: fixe.rB, sa: fixe.sa};
											},
											A2(
												$elm$core$List$filter,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.Aq;
													},
													$elm$core$Basics$eq(fixe.Hc)),
												nouvelles)))
								});
						case 58:
							var retiree = evenement.a;
							return _Utils_update(
								courante,
								{
									gV: A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.Hc;
											},
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.Aq;
												},
												$elm$core$Basics$neq(retiree))),
										courante.gV)
								});
						case 60:
							return _Utils_update(
								courante,
								{GF: true});
						case 61:
							return _Utils_update(
								courante,
								{GF: false});
						case 59:
							var refs = evenement.a;
							return _Utils_update(
								courante,
								{
									GA: A2(
										$elm$core$List$filterMap,
										function (ref) {
											return $elm$core$List$head(
												A2(
													$elm$core$List$filter,
													A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.Hb;
														},
														$elm$core$Basics$eq(ref)),
													$author$project$Components$Produits$ListeDePrix$Model$publicsAChoisir(courante)));
										},
										refs)
								});
						default:
							return courante;
					}
				}),
			fiche,
			evenements);
	});
var $author$project$I18n$Textes$produitsCatalogueInfoSansValeur = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.info.sans-valeur', _List_Nil, '—');
var $author$project$I18n$Textes$produitsListesDePrixRefusPublicDejaCouvert = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.listes-de-prix.refus.public-deja-couvert',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'public',
				$author$project$I18n$Traductions$Sous(p.pF)),
				_Utils_Tuple2(
				'liste',
				$author$project$I18n$Traductions$Sous(p.nW)),
				_Utils_Tuple2(
				'couvrante',
				$author$project$I18n$Traductions$Sous(p.wk)),
				_Utils_Tuple2(
				'fin',
				$author$project$I18n$Traductions$Sous(p.mI))
			]),
		'Le type « {public} » ne peut pas rejoindre « {liste} » : il est déjà couvert par « {couvrante} » jusqu\'au {fin}.');
};
var $author$project$I18n$Textes$produitsPrixPublicIndisponible = A3($author$project$I18n$Traductions$texte, 'produits.prix.public.indisponible', _List_Nil, 'Public indisponible');
var $author$project$Components$Produits$Common$Prix$conflits = F2(
	function (contexte, refuses) {
		return A2(
			$elm$core$List$map,
			function (conflit) {
				return $author$project$I18n$Textes$produitsListesDePrixRefusPublicDejaCouvert(
					{
						wk: $author$project$I18n$Traductions$tel(conflit.nW.Dj.zX),
						mI: $author$project$Texte$Jour$enClair(conflit.mI),
						nW: $author$project$I18n$Traductions$tel(contexte.nW),
						pF: A2(
							$elm$core$Maybe$withDefault,
							$author$project$I18n$Textes$produitsCatalogueInfoSansValeur,
							A2(
								$elm$core$Maybe$map,
								function (connu) {
									return connu.AJ ? $author$project$I18n$Textes$produitsPrixPublicIndisponible : $author$project$I18n$Traductions$tel(connu.Bl);
								},
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.Hb;
											},
											$elm$core$Basics$eq(conflit.pF)),
										contexte.v3))))
					});
			},
			refuses);
	});
var $author$project$Components$Produits$ListeDePrix$Model$idDuMontant = function (id) {
	return 'ligne-de-prix-' + ($author$project$Catalogue$Identifiants$referenceIdToString(id) + '-montant');
};
var $author$project$I18n$Textes$produitsListeDePrixPrixPublicRefus = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.liste-de-prix.prix-public.refus',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'liste',
				$author$project$I18n$Traductions$Sous(p.nW)),
				_Utils_Tuple2(
				'fin',
				$author$project$I18n$Traductions$Sous(p.mI))
			]),
		'« {liste} » est déjà la liste publique jusqu\'au {fin}.');
};
var $author$project$Components$Produits$ListeDePrix$Update$relire = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$Lire, $elm$core$List$singleton),
			model.np));
};
var $author$project$Components$Produits$ListeDePrix$Update$relecture = F2(
	function (rendue, model) {
		return (rendue.sy && (!A2($elm$core$List$member, $author$project$Catalogue$API$WriteAPIModel$EvenementInconnu, rendue.mk))) ? $author$project$Components$Produits$ListeDePrix$Update$relire(model) : _List_fromArray(
			[
				$author$project$Components$Produits$Common$Effet$AttendreAvantDeRelire($author$project$Components$Produits$Common$Envoi$delaiDeRelectureMs)
			]);
	});
var $author$project$Components$Produits$ListeDePrix$Update$conclure = F2(
	function (issue, model) {
		_v0$5:
		while (true) {
			switch (issue.$) {
				case 0:
					if (issue.c) {
						var commande = issue.a;
						var rendue = issue.b;
						var enregistree = function () {
							switch (commande.$) {
								case 60:
									var prix = commande.b;
									return A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$Tuple$first,
											$elm$core$Basics$neq(prix.Hc)),
										model.c7);
								case 61:
									var reference = commande.b;
									return A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$Tuple$first,
											$elm$core$Basics$neq(reference)),
										model.c7);
								default:
									return model.c7;
							}
						}();
						var _v1 = function () {
							if (commande.$ === 62) {
								return A2($author$project$Components$Produits$ListeDePrix$Update$versLeDrawer, $author$project$Components$Shared$Drawer$Update$Fermer, model);
							} else {
								return _Utils_Tuple2(model, _List_Nil);
							}
						}();
						var apres = _v1.a;
						var duDrawer = _v1.b;
						return _Utils_Tuple2(
							_Utils_update(
								apres,
								{
									zo: A2(
										$elm$core$Maybe$map,
										function (fiche) {
											return $elm$core$List$isEmpty(rendue.nQ) ? fiche : _Utils_update(
												fiche,
												{nQ: rendue.nQ});
										},
										A2(
											$elm$core$Maybe$map,
											A2($author$project$Components$Produits$ListeDePrix$Model$appliquer, model.DV, rendue.mk),
											model.zo)),
									DV: function () {
										if (commande.$ === 60) {
											var prix = commande.b;
											return A2(
												$elm$core$List$filter,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.Aq;
													},
													$elm$core$Basics$neq(prix.Hc)),
												model.DV);
										} else {
											return model.DV;
										}
									}(),
									c7: enregistree
								}),
							_Utils_ap(
								duDrawer,
								$elm$core$List$isEmpty(model.iv) ? A2($author$project$Components$Produits$ListeDePrix$Update$relecture, rendue, model) : _List_Nil));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									iv: _List_Nil,
									p7: $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) ? _List_fromArray(
										[$author$project$Components$Produits$Common$Refus$rejeu]) : _List_Nil
								}),
							$author$project$Components$Produits$ListeDePrix$Update$relire(model));
					}
				case 1:
					switch (issue.a.$) {
						case 63:
							var _v5 = issue.a;
							var refus = issue.b;
							var erreur = issue.c;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										p3: $elm$core$Maybe$Just(
											function () {
												if (erreur.$ === 61) {
													var enPlace = erreur.a;
													return {
														Jx: $author$project$I18n$Textes$produitsListeDePrixPrixPublicRefus(
															{
																mI: $author$project$Texte$Jour$enClair(enPlace.mI),
																nW: $author$project$I18n$Traductions$tel(enPlace.nW.Dj.zX)
															}),
														b9: refus.b9
													};
												} else {
													return A2($author$project$Components$Produits$ListeDePrix$Update$message, refus, erreur);
												}
											}())
									}),
								$author$project$Components$Produits$ListeDePrix$Update$perime(erreur) ? $author$project$Components$Produits$ListeDePrix$Update$relire(model) : _List_Nil);
						case 62:
							var _v7 = issue.a;
							var refus = issue.b;
							var erreur = issue.c;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										p7: function () {
											var _v8 = _Utils_Tuple2(erreur, model.zo);
											if ((_v8.a.$ === 60) && (!_v8.b.$)) {
												var conflits = _v8.a.a;
												var fiche = _v8.b.a;
												return A2(
													$elm$core$List$map,
													function (texte) {
														return {Jx: texte, b9: refus.b9};
													},
													A2(
														$author$project$Components$Produits$Common$Prix$conflits,
														{
															v3: $author$project$Components$Produits$ListeDePrix$Model$publicsAChoisir(fiche),
															nW: fiche.Dj.zX
														},
														conflits));
											} else {
												return _List_fromArray(
													[
														A2($author$project$Components$Produits$ListeDePrix$Update$message, refus, erreur)
													]);
											}
										}()
									}),
								$author$project$Components$Produits$ListeDePrix$Update$perime(erreur) ? $author$project$Components$Produits$ListeDePrix$Update$relire(model) : _List_Nil);
						case 60:
							if (issue.c.$ === 66) {
								var _v9 = issue.a;
								var prix = _v9.b;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											iv: _List_Nil,
											b_: $elm$core$Maybe$Just(prix.Hc)
										}),
									_List_fromArray(
										[
											$author$project$Components$Produits$Common$Effet$PlacerFocus(
											$author$project$Components$Produits$ListeDePrix$Model$idDuMontant(prix.Hc))
										]));
							} else {
								break _v0$5;
							}
						default:
							break _v0$5;
					}
				default:
					return _Utils_Tuple2(model, _List_Nil);
			}
		}
		var erreur = issue.c;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{iv: _List_Nil}),
			$author$project$Components$Produits$ListeDePrix$Update$perime(erreur) ? $author$project$Components$Produits$ListeDePrix$Update$relire(model) : _List_Nil);
	});
var $author$project$Components$Produits$ListeDePrix$Update$delaiDeSaisieMs = 300;
var $author$project$Catalogue$API$WriteAPIModel$FixerUnPrix = F2(
	function (a, b) {
		return {$: 60, a: a, b: b};
	});
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $author$project$Components$Produits$Common$Prix$decimal = function (saisi) {
	var sansZeros = function (texte) {
		sansZeros:
		while (true) {
			var _v0 = $elm$core$String$toList(texte);
			if ((_v0.b && ('0' === _v0.a)) && _v0.b.b) {
				var _v1 = _v0.b;
				var suite = _v1.a;
				var reste = _v1.b;
				var $temp$texte = $elm$core$String$fromList(
					A2($elm$core$List$cons, suite, reste));
				texte = $temp$texte;
				continue sansZeros;
			} else {
				return texte;
			}
		}
	};
	var net = A3(
		$elm$core$String$replace,
		',',
		'.',
		A2(
			$elm$core$String$filter,
			function (c) {
				return !A2(
					$elm$core$List$member,
					c,
					_List_fromArray(
						[' ', '\u00A0', '\u202F']));
			},
			saisi));
	var chiffres = function (texte) {
		return (texte !== '') && A2($elm$core$String$all, $elm$core$Char$isDigit, texte);
	};
	var ecrit = F2(
		function (entier, decimales) {
			return (chiffres(entier) && (($elm$core$String$length(
				sansZeros(entier)) <= 13) && ($elm$core$String$length(decimales) <= 2))) ? $elm$core$Maybe$Just(
				sansZeros(entier) + ('.' + A3($elm$core$String$padRight, 2, '0', decimales))) : $elm$core$Maybe$Nothing;
		});
	var _v2 = A2($elm$core$String$split, '.', net);
	_v2$2:
	while (true) {
		if (_v2.b) {
			if (!_v2.b.b) {
				var entier = _v2.a;
				return A2(ecrit, entier, '');
			} else {
				if (!_v2.b.b.b) {
					var entier = _v2.a;
					var _v3 = _v2.b;
					var decimales = _v3.a;
					return chiffres(decimales) ? A2(ecrit, entier, decimales) : $elm$core$Maybe$Nothing;
				} else {
					break _v2$2;
				}
			}
		} else {
			break _v2$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Components$Produits$ListeDePrix$Model$montantSaisi = F2(
	function (ligne, saisie) {
		return A2($elm$core$Maybe$withDefault, ligne.oi, saisie.oi);
	});
var $author$project$Components$Produits$ListeDePrix$Model$saisieDe = F2(
	function (model, ligne) {
		return A2(
			$elm$core$Maybe$withDefault,
			{oi: $elm$core$Maybe$Nothing, sa: ligne.sa},
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$eq(ligne.Hc.Aq)),
						model.c7))));
	});
var $author$project$Components$Produits$ListeDePrix$Model$fautives = F2(
	function (model, fiche) {
		return A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Hc;
				},
				function ($) {
					return $.Aq;
				}),
			A2(
				$elm$core$List$filter,
				function (ligne) {
					return _Utils_eq(
						$author$project$Components$Produits$Common$Prix$decimal(
							A2(
								$author$project$Components$Produits$ListeDePrix$Model$montantSaisi,
								ligne,
								A2($author$project$Components$Produits$ListeDePrix$Model$saisieDe, model, ligne))),
						$elm$core$Maybe$Nothing);
				},
				A2($author$project$Components$Produits$ListeDePrix$Model$lignesMontrees, model, fiche)));
	});
var $author$project$Components$Produits$ListeDePrix$Model$commandesDEnregistrement = F2(
	function (model, fiche) {
		return (!_Utils_eq(
			A2($author$project$Components$Produits$ListeDePrix$Model$fautives, model, fiche),
			_List_Nil)) ? _List_Nil : A2(
			$elm$core$List$filterMap,
			function (ligne) {
				var saisie = A2($author$project$Components$Produits$ListeDePrix$Model$saisieDe, model, ligne);
				return A2(
					$elm$core$Maybe$andThen,
					function (montant) {
						return (_Utils_eq(montant, ligne.oi) && _Utils_eq(saisie.sa, ligne.sa)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							A2(
								$author$project$Catalogue$API$WriteAPIModel$FixerUnPrix,
								fiche.Aq,
								{oi: montant, Hc: ligne.Hc.Aq, sa: saisie.sa}));
					},
					$author$project$Components$Produits$Common$Prix$decimal(
						A2($author$project$Components$Produits$ListeDePrix$Model$montantSaisi, ligne, saisie)));
			},
			A2($author$project$Components$Produits$ListeDePrix$Model$lignesMontrees, model, fiche));
	});
var $author$project$API$NavLinksDictionary$fixerUnPrix = 'fixer-un-prix';
var $author$project$Components$Produits$ListeDePrix$Model$lienDeLaSaisie = function (fiche) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$fixerUnPrix, fiche.nQ);
};
var $author$project$Components$Produits$ListeDePrix$Update$enregistrer = function (model) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		function (fiche) {
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$pair(fiche),
				$author$project$Components$Produits$ListeDePrix$Model$lienDeLaSaisie(fiche));
		},
		model.zo);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var fiche = _v1.a;
		var lien = _v1.b;
		var _v2 = _Utils_Tuple2(
			A2($author$project$Components$Produits$ListeDePrix$Model$fautives, model, fiche),
			A2($author$project$Components$Produits$ListeDePrix$Model$commandesDEnregistrement, model, fiche));
		if (_v2.a.b) {
			var _v3 = _v2.a;
			var fautive = _v3.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{b5: true}),
				_List_fromArray(
					[
						$author$project$Components$Produits$Common$Effet$PlacerFocus(
						$author$project$Components$Produits$ListeDePrix$Model$idDuMontant(fautive))
					]));
		} else {
			if (_v2.b.b) {
				var _v4 = _v2.b;
				var premiere = _v4.a;
				var suite = _v4.b;
				if ($elm$core$List$isEmpty(model.iv)) {
					var _v5 = A3(
						$author$project$Components$Produits$Common$Envoi$partir,
						$elm$core$Maybe$Just(lien),
						premiere,
						model.l2);
					if (!_v5.$) {
						var _v6 = _v5.a;
						var envoi = _v6.a;
						var effets = _v6.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{iv: suite, l2: envoi, b_: $elm$core$Maybe$Nothing, b5: false}),
							effets);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$ListeDePrix$Model$idDeLAjout = 'liste-de-prix-ajouter';
var $author$project$Components$Produits$ListeDePrix$Model$idDeLaRecherche = 'liste-de-prix-ajouter-recherche';
var $author$project$Components$Produits$ListeDePrix$Model$idDesPublics = 'liste-de-prix-modifier-les-publics';
var $author$project$API$NavLinksDictionary$rendrePubliqueUneListeDePrix = 'rendre-publique-une-liste-de-prix';
var $author$project$Components$Produits$ListeDePrix$Model$lienDeLaPublicite = function (fiche) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rendrePubliqueUneListeDePrix, fiche.nQ);
};
var $author$project$API$NavLinksDictionary$retirerUnPrix = 'retirer-un-prix';
var $author$project$Components$Produits$ListeDePrix$Model$lienDuRetrait = function (fiche) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerUnPrix, fiche.nQ);
};
var $author$project$Components$Produits$ListeDePrix$Model$retirerLaNouvelle = F2(
	function (id, model) {
		return A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Aq;
				},
				$elm$core$Basics$eq(id)),
			model.DV) ? $elm$core$Maybe$Just(
			_Utils_update(
				model,
				{
					DV: A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$neq(id)),
						model.DV),
					c7: A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$neq(id)),
						model.c7)
				})) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$Produits$ListeDePrix$Model$toucher = F3(
	function (id, change, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$Produits$ListeDePrix$Model$lignesMontrees(model),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$filter(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Hc;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(id)))),
					$elm$core$List$head)),
			model.zo);
		if (!_v0.$) {
			var ligne = _v0.a;
			return _Utils_update(
				model,
				{
					b_: _Utils_eq(
						model.b_,
						$elm$core$Maybe$Just(id)) ? $elm$core$Maybe$Nothing : model.b_,
					c7: A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							id,
							change(
								A2($author$project$Components$Produits$ListeDePrix$Model$saisieDe, model, ligne))),
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$first,
								$elm$core$Basics$neq(id)),
							model.c7))
				});
		} else {
			return model;
		}
	});
var $author$project$Components$Produits$ListeDePrix$Model$saisirLUnite = F3(
	function (id, code, model) {
		return A2($elm$core$List$member, code, $author$project$Catalogue$Vocabulaire$unitesDePrix) ? A3(
			$author$project$Components$Produits$ListeDePrix$Model$toucher,
			id,
			function (saisie) {
				return _Utils_update(
					saisie,
					{sa: code});
			},
			model) : model;
	});
var $author$project$Components$Produits$ListeDePrix$Model$saisirLeMontant = F2(
	function (id, texte) {
		return A2(
			$author$project$Components$Produits$ListeDePrix$Model$toucher,
			id,
			function (saisie) {
				return _Utils_update(
					saisie,
					{
						oi: $elm$core$Maybe$Just(texte)
					});
			});
	});
var $author$project$Components$Produits$ListeDePrix$Model$servie = F2(
	function (fiche, model) {
		var aSaLigne = function (id) {
			return A2(
				$elm$core$List$any,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Hc;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Aq;
						},
						$elm$core$Basics$eq(id))),
				fiche.gV);
		};
		var nouvelles = A2(
			$elm$core$List$filter,
			function (nouvelle) {
				return !aSaLigne(nouvelle.Aq);
			},
			model.DV);
		return _Utils_update(
			model,
			{
				zo: $elm$core$Maybe$Just(fiche),
				nf: false,
				DV: nouvelles,
				c7: A2(
					$elm$core$List$filter,
					function (_v0) {
						var id = _v0.a;
						return aSaLigne(id) || A2(
							$elm$core$List$any,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(id)),
							nouvelles);
					},
					model.c7)
			});
	});
var $author$project$Components$Produits$ListeDePrix$Update$suivante = function (model) {
	var _v0 = _Utils_Tuple2(
		model.iv,
		A2($elm$core$Maybe$andThen, $author$project$Components$Produits$ListeDePrix$Model$lienDeLaSaisie, model.zo));
	if (_v0.a.b) {
		if (!_v0.b.$) {
			var _v1 = _v0.a;
			var commande = _v1.a;
			var reste = _v1.b;
			var lien = _v0.b.a;
			var _v2 = A3(
				$author$project$Components$Produits$Common$Envoi$partir,
				$elm$core$Maybe$Just(lien),
				commande,
				model.l2);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var envoi = _v3.a;
				var effets = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{iv: reste, l2: envoi}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			var _v4 = _v0.a;
			var _v5 = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{iv: _List_Nil}),
				$author$project$Components$Produits$ListeDePrix$Update$relire(model));
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$API$NavLinksDictionary$listeDePrix = 'liste-de-prix';
var $author$project$Components$Produits$Liens$versListeDePrix = F2(
	function (id, gabarits) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$API$NavLinksDictionary$variableUid,
						$author$project$Catalogue$Identifiants$listeDePrixIdToString(id))
					])),
			A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$listeDePrix, gabarits));
	});
var $author$project$Components$Produits$ListeDePrix$Update$update = F2(
	function (msg, model) {
		var initial = $author$project$Components$Produits$ListeDePrix$Model$init;
		switch (msg.$) {
			case 0:
				var id = msg.a;
				var gabarits = msg.b;
				var _v1 = A2($author$project$Components$Produits$Liens$versListeDePrix, id, gabarits);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							initial,
							{
								np: $elm$core$Maybe$Just(lecture)
							}),
						_List_fromArray(
							[
								$author$project$Components$Produits$Common$Effet$DemanderProcessUid,
								$author$project$Components$Produits$Common$Effet$Lire(lecture)
							]));
				} else {
					return _Utils_Tuple2(initial, _List_Nil);
				}
			case 1:
				var octets = msg.a;
				return $author$project$Components$Produits$ListeDePrix$Update$suivante(
					_Utils_update(
						model,
						{
							l2: A2($author$project$Components$Produits$Common$Envoi$recevoir, octets, model.l2)
						}));
			case 2:
				var reponse = msg.a;
				var _v2 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$ListeDePrix$API$QueryAPIModel$ficheDecoder, reponse);
				if (!_v2.$) {
					var fiche = _v2.a;
					return _Utils_Tuple2(
						A2($author$project$Components$Produits$ListeDePrix$Model$servie, fiche, model),
						_List_Nil);
				} else {
					var refus = _v2.a;
					return (refus.ri === 401) ? _Utils_Tuple2(
						model,
						_List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter])) : _Utils_Tuple2(
						_Utils_update(
							model,
							{nf: refus.ri === 404}),
						_List_Nil);
				}
			case 3:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Produits$ListeDePrix$Update$relire(model));
			case 4:
				var id = msg.a;
				var texte = msg.b;
				return _Utils_Tuple2(
					A3($author$project$Components$Produits$ListeDePrix$Model$saisirLeMontant, id, texte, model),
					_List_Nil);
			case 5:
				var id = msg.a;
				var code = msg.b;
				return _Utils_Tuple2(
					A3($author$project$Components$Produits$ListeDePrix$Model$saisirLUnite, id, code, model),
					_List_Nil);
			case 6:
				return $author$project$Components$Produits$ListeDePrix$Update$enregistrer(model);
			case 7:
				var id = msg.a;
				var _v3 = _Utils_Tuple2(
					A2($author$project$Components$Produits$ListeDePrix$Model$retirerLaNouvelle, id, model),
					A2(
						$elm$core$Maybe$andThen,
						function (fiche) {
							return A2(
								$elm$core$Maybe$map,
								$elm$core$Tuple$pair(fiche),
								$author$project$Components$Produits$ListeDePrix$Model$lienDuRetrait(fiche));
						},
						model.zo));
				if (!_v3.a.$) {
					var sansElle = _v3.a.a;
					return _Utils_Tuple2(sansElle, _List_Nil);
				} else {
					if (!_v3.b.$) {
						var _v4 = _v3.a;
						var _v5 = _v3.b.a;
						var fiche = _v5.a;
						var lien = _v5.b;
						return A3(
							$author$project$Components$Produits$ListeDePrix$Update$partir,
							lien,
							A2($author$project$Catalogue$API$WriteAPIModel$RetirerUnPrix, fiche.Aq, id),
							model);
					} else {
						var _v6 = _v3.a;
						var _v7 = _v3.b;
						return _Utils_Tuple2(model, _List_Nil);
					}
				}
			case 8:
				return _Utils_eq(
					A2($elm$core$Maybe$andThen, $author$project$Components$Produits$ListeDePrix$Model$lienDeLaSaisie, model.zo),
					$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$List$cons(
						$author$project$Components$Produits$Common$Effet$PlacerFocus($author$project$Components$Produits$ListeDePrix$Model$idDeLaRecherche)),
					$author$project$Components$Produits$ListeDePrix$Update$chercher(
						_Utils_update(
							model,
							{
								fw: $elm$core$Maybe$Just(
									{DX: 1, h3: '', fg: $elm$core$Maybe$Nothing})
							})));
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{fw: $elm$core$Maybe$Nothing}),
					_List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$PlacerFocus($author$project$Components$Produits$ListeDePrix$Model$idDeLAjout)
						]));
			case 10:
				var terme = msg.a;
				var _v8 = model.fw;
				if (!_v8.$) {
					var ajout = _v8.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								fw: $elm$core$Maybe$Just(
									_Utils_update(
										ajout,
										{DX: ajout.DX + 1, h3: terme, fg: $elm$core$Maybe$Nothing}))
							}),
						_List_fromArray(
							[
								A2($author$project$Components$Produits$Common$Effet$AttendreAvantDeChercher, ajout.DX + 1, $author$project$Components$Produits$ListeDePrix$Update$delaiDeSaisieMs)
							]));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 11:
				var numero = msg.a;
				return _Utils_eq(
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.DX;
						},
						model.fw),
					$elm$core$Maybe$Just(numero)) ? $author$project$Components$Produits$ListeDePrix$Update$chercher(model) : _Utils_Tuple2(model, _List_Nil);
			case 12:
				var numero = msg.a;
				var reponse = msg.b;
				var _v9 = _Utils_Tuple2(
					model.fw,
					A2($author$project$API$Reponse$lire, $author$project$Components$Produits$ListeDePrix$API$QueryAPIModel$referencesTrouveesDecoder, reponse));
				if (_v9.b.$ === 1) {
					var refus = _v9.b.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				} else {
					if (!_v9.a.$) {
						var ajout = _v9.a.a;
						var trouvees = _v9.b.a;
						return _Utils_eq(ajout.DX, numero) ? _Utils_Tuple2(
							_Utils_update(
								model,
								{
									fw: $elm$core$Maybe$Just(
										_Utils_update(
											ajout,
											{
												fg: $elm$core$Maybe$Just(trouvees)
											}))
								}),
							_List_Nil) : _Utils_Tuple2(model, _List_Nil);
					} else {
						var _v10 = _v9.a;
						return _Utils_Tuple2(model, _List_Nil);
					}
				}
			case 13:
				var id = msg.a;
				var _v11 = A2(
					$elm$core$Maybe$andThen,
					function (fiche) {
						return A3($author$project$Components$Produits$ListeDePrix$Model$ajouter, id, fiche, model);
					},
					model.zo);
				if (!_v11.$) {
					var avecElle = _v11.a;
					return _Utils_Tuple2(
						avecElle,
						_List_fromArray(
							[
								$author$project$Components$Produits$Common$Effet$PlacerFocus(
								$author$project$Components$Produits$ListeDePrix$Model$idDuMontant(id))
							]));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 14:
				var geste = msg.a;
				return A2($author$project$Components$Produits$ListeDePrix$Update$versLeDrawer, geste, model);
			case 15:
				var _v12 = A2(
					$elm$core$Maybe$andThen,
					function (fiche) {
						return A2(
							$elm$core$Maybe$map,
							function (_v13) {
								return fiche;
							},
							$author$project$Components$Produits$ListeDePrix$Model$lienDesPublics(fiche));
					},
					model.zo);
				if (!_v12.$) {
					var fiche = _v12.a;
					return A2(
						$author$project$Components$Produits$ListeDePrix$Update$versLeDrawer,
						$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Produits$ListeDePrix$Model$idDesPublics),
						_Utils_update(
							model,
							{
								X: A2(
									$elm$core$List$map,
									function ($) {
										return $.Hb;
									},
									fiche.GA),
								p7: _List_Nil
							}));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 16:
				var ref = msg.a;
				var coche = msg.b;
				var _v14 = model.zo;
				if (!_v14.$) {
					var fiche = _v14.a;
					return _Utils_Tuple2(
						A4($author$project$Components$Produits$ListeDePrix$Model$cocherUnPublic, ref, coche, fiche, model),
						_List_Nil);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 17:
				return $author$project$Components$Produits$ListeDePrix$Update$changerLesPublics(model);
			case 18:
				var voulue = msg.a;
				var _v15 = A2(
					$elm$core$Maybe$andThen,
					function (fiche) {
						return A2(
							$elm$core$Maybe$map,
							$elm$core$Tuple$pair(fiche),
							$author$project$Components$Produits$ListeDePrix$Model$lienDeLaPublicite(fiche));
					},
					model.zo);
				if (!_v15.$) {
					var _v16 = _v15.a;
					var fiche = _v16.a;
					var lien = _v16.b;
					return _Utils_eq(voulue, fiche.GF) ? _Utils_Tuple2(model, _List_Nil) : A3(
						$author$project$Components$Produits$ListeDePrix$Update$partir,
						lien,
						A2($author$project$Catalogue$API$WriteAPIModel$RendrePubliqueUneListeDePrix, fiche.Aq, voulue),
						_Utils_update(
							model,
							{p3: $elm$core$Maybe$Nothing}));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			default:
				var reponse = msg.a;
				var _v17 = A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, model.l2);
				if (!_v17.$) {
					var _v18 = _v17.a;
					var envoi = _v18.a;
					var issue = _v18.b;
					var effets = _v18.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Produits$ListeDePrix$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Main$Update$versLaListeDePrix = F3(
	function (i18n, msg, model) {
		var depuisLaListeDePrix = F2(
			function (effet, _v2) {
				var courant = _v2.a;
				var faits = _v2.b;
				switch (effet.$) {
					case 21:
						var numero = effet.a;
						var lien = effet.b;
						var recherche = effet.c;
						return _Utils_Tuple2(
							courant,
							_Utils_ap(
								faits,
								A3(
									$author$project$Main$Update$versLApi,
									courant,
									lien,
									function (vers) {
										return $author$project$Main$Update$ChercherLesReferencesAAjouter(
											{gM: vers.gM, nB: vers.nB, DX: numero, hC: recherche});
									})));
					case 22:
						var numero = effet.a;
						var delaiMs = effet.b;
						return _Utils_Tuple2(
							courant,
							_Utils_ap(
								faits,
								_List_fromArray(
									[
										A2($author$project$Main$Update$AttendreAvantDeChercherLesReferencesAAjouter, numero, delaiMs)
									])));
					default:
						return A5(
							$author$project$Main$Update$depuisLesElements,
							i18n,
							13,
							28,
							effet,
							_Utils_Tuple2(courant, faits));
				}
			});
		var _v0 = A2(
			$author$project$Components$Produits$ListeDePrix$Update$update,
			msg,
			$author$project$Components$Produits$ListeDePrix$Model$ouvrir(model.nY));
		var listeDePrix = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLesElements, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			depuisLaListeDePrix,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						nY: $author$project$Components$Produits$ListeDePrix$Model$envelopper(listeDePrix),
						Ct: A2(
							$author$project$Main$Update$remonter,
							A2(
								$author$project$Components$Produits$ListeDePrix$Update$popMessages,
								$author$project$Components$Produits$ListeDePrix$Model$ouvrir(model.nY),
								msg),
							gardes)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$ChercherLesArticlesALier = function (a) {
	return {$: 168, a: a};
};
var $author$project$Main$Update$FicheDUneReference = 9;
var $author$project$Main$Update$LireLaStructureDesFiltres = function (a) {
	return {$: 135, a: a};
};
var $author$project$Main$Update$LireLeCatalogueDesFiltres = function (a) {
	return {$: 134, a: a};
};
var $author$project$Main$Model$PourLaReference = 14;
var $author$project$Components$Produits$Reference$API$QueryAPIModel$CalculDeLaFiche = F4(
	function (champ, recalcul, valeur, etat) {
		return {uN: champ, gt: etat, G$: recalcul, fm: valeur};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$CompletudeDetaillee = F3(
	function (remplis, total, manques) {
		return {B5: manques, HB: remplis, JE: total};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$Etape = F3(
	function (element, niveau, libelles) {
		return {lQ: element, R: libelles, os: niveau};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$Fiche = function (id) {
	return function (code) {
		return function (nature) {
			return function (nom) {
				return function (produit) {
					return function (rattachement) {
						return function (ean) {
							return function (millesime) {
								return function (variante) {
									return function (etat) {
										return function (arretee) {
											return function (verrouillee) {
												return function (enDouble) {
													return function (fil) {
														return function (type_) {
															return function (valeurs) {
																return function (valeursNonReconnues) {
																	return function (valeursHorsChoix) {
																		return function (completude) {
																			return function (classement) {
																				return function (rangement) {
																					return function (etats) {
																						return function (publication) {
																							return function (unites) {
																								return function (langues) {
																									return function (choix) {
																										return function (libellesDesChoix) {
																											return function (horsLimitesDepuis) {
																												return function (valeursHeritees) {
																													return function (informations) {
																														return function (liensVersDesArticles) {
																															return function (chemin) {
																																return function (origine) {
																																	return function (variantes) {
																																		return function (memeChemin) {
																																			return function (memeCheminTotal) {
																																				return function (activite) {
																																					return function (fichiers) {
																																						return function (etatDeDepart) {
																																							return function (collections) {
																																								return function (liensDesGroupes) {
																																									return function (partiesPrenantes) {
																																										return function (liens) {
																																											return function (calculs) {
																																												return function (genresDesChamps) {
																																													return function (gabarits) {
																																														return {sT: activite, tL: arretee, uD: calculs, jK: chemin, jN: choix, vi: classement, vx: code, vE: collections, fU: completude, lI: ean, gi: enDouble, gt: etat, yO: etatDeDepart, mj: etats, zB: fichiers, zD: fil, gF: gabarits, Aa: genresDesChamps, Am: horsLimitesDepuis, Aq: id, AM: informations, Ba: langues, Br: libellesDesChoix, nQ: liens, BP: liensDesGroupes, BQ: liensVersDesArticles, Cn: memeChemin, Co: memeCheminTotal, n8: millesime, g1: nature, Dj: nom, o4: origine, eA: partiesPrenantes, Gp: produit, Gz: publication, hA: rangement, pN: rattachement, r0: type_, sb: unites, Ki: valeurs, Km: valeursHeritees, Kn: valeursHorsChoix, Ko: valeursNonReconnues, sl: variante, Kw: variantes, KB: verrouillee};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Produits$Reference$API$QueryAPIModel$EtapeDuChemin = F3(
	function (etage, valeur, libelles) {
		return {md: etage, R: libelles, fm: valeur};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$Etage = F2(
	function (nature, libelles) {
		return {R: libelles, g1: nature};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$etageDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'libelles',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'nature',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$API$QueryAPIModel$Etage)));
var $author$project$Components$Produits$Reference$API$QueryAPIModel$etapeDuCheminDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'libelles',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'valeur',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'etage',
			$author$project$Components$Produits$Reference$API$QueryAPIModel$etageDecoder,
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$API$QueryAPIModel$EtapeDuChemin))));
var $author$project$Components$Produits$Reference$API$QueryAPIModel$EvenementDActivite = F4(
	function (date, auteur, nature, parametres) {
		return {t1: auteur, wv: date, g1: nature, EX: parametres};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$evenementDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'parametres',
	$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
	$elm$core$Dict$empty,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'nature',
		$elm$json$Json$Decode$string,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'auteur',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'date',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$API$QueryAPIModel$EvenementDActivite)))));
var $author$project$Components$Produits$Reference$API$QueryAPIModel$FichierDeLaFiche = F6(
	function (champ, fichier, type_, taille, dimensions, texteAlternatif) {
		return {uN: champ, xz: dimensions, gw: fichier, Jm: taille, Jy: texteAlternatif, r0: type_};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$fichierDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'texteAlternatif',
	$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$string),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'dimensions',
		A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (largeur, hauteur) {
					return $elm$core$Maybe$Just(
						{Ae: hauteur, Bd: largeur});
				}),
			A2($elm$json$Json$Decode$field, 'largeur', $elm$json$Json$Decode$int),
			A2($elm$json$Json$Decode$field, 'hauteur', $elm$json$Json$Decode$int)),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'taille',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'type',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'fichier',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'champ',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$API$QueryAPIModel$FichierDeLaFiche)))))));
var $author$project$Components$Produits$Reference$API$QueryAPIModel$Information = F4(
	function (portee, etage, libelles, champs) {
		return {dw: champs, md: etage, R: libelles, F$: portee};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$Portee = F2(
	function (nature, id) {
		return {Aq: id, g1: nature};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$informationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'champs',
	$elm$json$Json$Decode$list($author$project$Components$Shared$EditeurDeSchema$Champ$decoder),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'libelles',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'etage',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Produits$Reference$API$QueryAPIModel$etageDecoder),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'portee',
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$Components$Produits$Reference$API$QueryAPIModel$Portee,
					A2($elm$json$Json$Decode$field, 'nature', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$maybe(
						A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string))),
				$elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$API$QueryAPIModel$Information)))));
var $author$project$Components$Produits$Reference$API$QueryAPIModel$ArticleLie = F7(
	function (id, code, nom, etat, origine, marque, typeDeProduit) {
		return {vx: code, gt: etat, Aq: id, gX: marque, Dj: nom, o4: origine, fh: typeDeProduit};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$LienDeLaFiche = F7(
	function (cle, plusieurs, articles, masque, perimetres, rechercheDesPerimetres, apercu) {
		return {tq: apercu, tP: articles, dy: cle, n4: masque, pg: perimetres, FS: plusieurs, G2: rechercheDesPerimetres};
	});
var $author$project$API$NavLinksDictionary$apercuDeLaValeur = 'apercu-de-la-valeur';
var $author$project$Catalogue$Vocabulaire$champMarqueDeLArticle = 'marque';
var $author$project$Components$Produits$Reference$API$QueryAPIModel$Arrete = 1;
var $author$project$Components$Produits$Reference$API$QueryAPIModel$Disponible = 0;
var $author$project$Components$Produits$Reference$API$QueryAPIModel$Indisponible = 2;
var $author$project$Catalogue$Vocabulaire$etatArrete = 'arrete';
var $author$project$Components$Produits$Reference$API$QueryAPIModel$etatDeLArticleDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (etat) {
		return (etat === 'disponible') ? $elm$json$Json$Decode$succeed(0) : (_Utils_eq(etat, $author$project$Catalogue$Vocabulaire$etatArrete) ? $elm$json$Json$Decode$succeed(1) : ((etat === 'indisponible') ? $elm$json$Json$Decode$succeed(2) : $elm$json$Json$Decode$fail(etat)));
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$Produits$Reference$API$QueryAPIModel$Origine = F3(
	function (portee, nom, etage) {
		return {md: etage, Dj: nom, F$: portee};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$DUnNoeud = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$DUneTypologie = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$Reference$API$QueryAPIModel$DuCatalogue = {$: 0};
var $author$project$Components$Produits$Reference$API$QueryAPIModel$porteeDOrigineDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (texte) {
		var _v0 = A2($elm$core$String$split, '/', texte);
		_v0$3:
		while (true) {
			if (_v0.b) {
				if (!_v0.b.b) {
					if (_v0.a === 'catalogue') {
						return $elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$API$QueryAPIModel$DuCatalogue);
					} else {
						break _v0$3;
					}
				} else {
					if (!_v0.b.b.b) {
						if (_v0.a === 'typologie') {
							var _v1 = _v0.b;
							var typologie = _v1.a;
							return $elm$json$Json$Decode$succeed(
								$author$project$Components$Produits$Reference$API$QueryAPIModel$DUneTypologie(typologie));
						} else {
							break _v0$3;
						}
					} else {
						if ((_v0.a === 'noeud') && (!_v0.b.b.b.b)) {
							var _v2 = _v0.b;
							var typologie = _v2.a;
							var _v3 = _v2.b;
							var valeur = _v3.a;
							return $elm$json$Json$Decode$succeed(
								A2($author$project$Components$Produits$Reference$API$QueryAPIModel$DUnNoeud, typologie, valeur));
						} else {
							break _v0$3;
						}
					}
				}
			} else {
				break _v0$3;
			}
		}
		return $elm$json$Json$Decode$fail(texte);
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$Produits$Reference$API$QueryAPIModel$origineDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'etage',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'nom',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'portee',
			$author$project$Components$Produits$Reference$API$QueryAPIModel$porteeDOrigineDecoder,
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$API$QueryAPIModel$Origine))));
var $author$project$Components$Produits$Reference$API$QueryAPIModel$PerimetreLie = F7(
	function (id, nom, archive, archiveLe, etat, origine, valeur) {
		return {tE: archive, tF: archiveLe, gt: etat, Aq: id, Dj: nom, o4: origine, fm: valeur};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$PerimetreDisponible = 0;
var $author$project$Components$Produits$Reference$API$QueryAPIModel$PerimetreIndisponible = 1;
var $author$project$Components$Produits$Reference$API$QueryAPIModel$etatDuPerimetreDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (etat) {
		switch (etat) {
			case 'disponible':
				return $elm$json$Json$Decode$succeed(0);
			case 'indisponible':
				return $elm$json$Json$Decode$succeed(1);
			default:
				var autre = etat;
				return $elm$json$Json$Decode$fail('etat-de-perimetre:' + autre);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$API$NavLinksDictionary$valeurDuPerimetre = 'valeur';
var $author$project$Components$Produits$Reference$API$QueryAPIModel$perimetreLieDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function (liens) {
			return A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$valeurDuPerimetre, liens.gF);
		},
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$author$project$API$Liens$deLaRessource,
					$elm$json$Json$Decode$succeed($author$project$API$Liens$aucun)
				]))),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'origine',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Produits$Reference$API$QueryAPIModel$origineDecoder),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'etat',
			$author$project$Components$Produits$Reference$API$QueryAPIModel$etatDuPerimetreDecoder,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'archiveLe',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'archive',
					$elm$json$Json$Decode$bool,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'nom',
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$API$QueryAPIModel$PerimetreLie))))))));
var $author$project$Components$Produits$Reference$API$QueryAPIModel$lienDeLaFicheDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function (liens) {
			return A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$apercuDeLaValeur, liens.gF);
		},
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$author$project$API$Liens$deLaRessource,
					$elm$json$Json$Decode$succeed($author$project$API$Liens$aucun)
				]))),
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		A2(
			$elm$json$Json$Decode$map,
			function (liens) {
				return A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$perimetres, liens.gF);
			},
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						$author$project$API$Liens$deLaRessource,
						$elm$json$Json$Decode$succeed($author$project$API$Liens$aucun)
					]))),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'perimetres',
			$elm$json$Json$Decode$list($author$project$Components$Produits$Reference$API$QueryAPIModel$perimetreLieDecoder),
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'masque',
				$elm$json$Json$Decode$bool,
				false,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'articles',
					$elm$json$Json$Decode$list(
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'typeDeProduit',
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								$author$project$Catalogue$Vocabulaire$champMarqueDeLArticle,
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'origine',
									A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Produits$Reference$API$QueryAPIModel$origineDecoder),
									$elm$core$Maybe$Nothing,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'etat',
										$author$project$Components$Produits$Reference$API$QueryAPIModel$etatDeLArticleDecoder,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'nom',
											A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
											$elm$core$Maybe$Nothing,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'code',
												A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
												$elm$core$Maybe$Nothing,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'id',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$API$QueryAPIModel$ArticleLie))))))))),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'plusieurs',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'cle',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$API$QueryAPIModel$LienDeLaFiche))))))));
var $author$project$Components$Produits$Reference$API$QueryAPIModel$Manque = F5(
	function (critere, champ, langue, cause, champs) {
		return {bw: cause, uN: champ, dw: champs, km: critere, nn: langue};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$manqueDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'champs',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'cause',
		$elm$json$Json$Decode$string,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'langue',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'champ',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'critere',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$API$QueryAPIModel$Manque))))));
var $author$project$Components$Produits$Reference$API$QueryAPIModel$PartiePrenanteCitee = F5(
	function (uid, typeVise, nom, etat, liens) {
		return {gt: etat, nQ: liens, Dj: nom, r$: typeVise, r8: uid};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$PartiesPrenantes = F4(
	function (fiches, types, liens, utilisateurs) {
		return {zu: fiches, nQ: liens, ib: types, Kf: utilisateurs};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$UtilisateurCite = F3(
	function (uid, nom, etat) {
		return {gt: etat, Dj: nom, r8: uid};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$PartieEffacee = 2;
var $author$project$Components$Produits$Reference$API$QueryAPIModel$PartieIndisponible = 3;
var $author$project$Components$Produits$Reference$API$QueryAPIModel$PartiePlusDuType = 1;
var $author$project$Components$Produits$Reference$API$QueryAPIModel$PartieTient = 0;
var $author$project$Components$Produits$Reference$API$QueryAPIModel$etatDeLaPartiePrenanteDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (lu) {
		switch (lu) {
			case 'tient':
				return $elm$json$Json$Decode$succeed(0);
			case 'plus-du-type':
				return $elm$json$Json$Decode$succeed(1);
			case 'effacee':
				return $elm$json$Json$Decode$succeed(2);
			case 'indisponible':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail(lu);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$Produits$Reference$API$QueryAPIModel$partiesPrenantesDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Components$Produits$Reference$API$QueryAPIModel$PartiesPrenantes,
	A2(
		$elm$json$Json$Decode$field,
		'fiches',
		$elm$json$Json$Decode$list(
			A6(
				$elm$json$Json$Decode$map5,
				$author$project$Components$Produits$Reference$API$QueryAPIModel$PartiePrenanteCitee,
				A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'typeVise', $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$maybe(
					A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string)),
				A2($elm$json$Json$Decode$field, 'etat', $author$project$Components$Produits$Reference$API$QueryAPIModel$etatDeLaPartiePrenanteDecoder),
				A2(
					$elm$json$Json$Decode$field,
					'_links',
					A2(
						$elm$json$Json$Decode$map,
						function ($) {
							return $.h0;
						},
						$author$project$API$Liens$decoder))))),
	A2(
		$elm$json$Json$Decode$field,
		'types',
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string)))),
	A2(
		$elm$json$Json$Decode$field,
		'_links',
		A2(
			$elm$json$Json$Decode$map,
			function ($) {
				return $.h0;
			},
			$author$project$API$Liens$decoder)),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'utilisateurs',
				$elm$json$Json$Decode$list(
					A4(
						$elm$json$Json$Decode$map3,
						$author$project$Components$Produits$Reference$API$QueryAPIModel$UtilisateurCite,
						A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
						$elm$json$Json$Decode$maybe(
							A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string)),
						A2($elm$json$Json$Decode$field, 'etat', $elm$json$Json$Decode$string)))),
				$elm$json$Json$Decode$succeed(_List_Nil)
			])));
var $author$project$Components$Produits$Reference$API$QueryAPIModel$Rangement = F5(
	function (valeurs, marque, enregistre, aRanger, typologie) {
		return {iz: aRanger, lZ: enregistre, gX: marque, r3: typologie, Ki: valeurs};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$rangementDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'typologie',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Identifiants$classificationIdDecoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'aRanger',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'enregistre',
			$elm$json$Json$Decode$bool,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				$author$project$Catalogue$Vocabulaire$champDeLaMarque,
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Identifiants$elementIdDecoder),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'valeurs',
					$elm$json$Json$Decode$list($author$project$Catalogue$API$WriteAPIModel$valeurDuDessusDecoder),
					$elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$API$QueryAPIModel$Rangement))))));
var $author$project$Components$Produits$Reference$API$QueryAPIModel$TypeDeLaReference = F8(
	function (id, nom, version, champs, masques, ordre, archive, minima) {
		return {tE: archive, dw: champs, Aq: id, Cd: masques, CC: minima, Dj: nom, El: ordre, sq: version};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$Minima = F3(
	function (largeurMinimale, hauteurMinimale, texteAlternatifExige) {
		return {Af: hauteurMinimale, Be: largeurMinimale, Jz: texteAlternatifExige};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$minimaDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'texteAlternatifExige',
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'hauteurMinimale',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'largeurMinimale',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$int),
			$elm$core$Maybe$Nothing,
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$API$QueryAPIModel$Minima))));
var $author$project$Components$Produits$Reference$API$QueryAPIModel$typeDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'minima',
	$elm$json$Json$Decode$keyValuePairs($author$project$Components$Produits$Reference$API$QueryAPIModel$minimaDecoder),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'archive',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'ordre',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'masques',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['schema', 'fields']),
					$elm$json$Json$Decode$list($author$project$Components$Shared$EditeurDeSchema$Champ$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'version',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'nom',
							$author$project$Catalogue$API$QueryAPIModel$libellesDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$author$project$Catalogue$Identifiants$typeDeProduitIdDecoder,
								$elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$API$QueryAPIModel$TypeDeLaReference)))))))));
var $author$project$Components$Produits$Reference$API$QueryAPIModel$ValeurHeritee = F5(
	function (champ, etage, source, nom, valeur) {
		return {uN: champ, md: etage, Dj: nom, IR: source, fm: valeur};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$dernierSegment = function (portee) {
	return $elm$core$List$head(
		$elm$core$List$reverse(
			A2($elm$core$String$split, '/', portee)));
};
var $author$project$Components$Produits$Reference$API$QueryAPIModel$valeurHeriteeDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Components$Produits$Reference$API$QueryAPIModel$ValeurHeritee,
	A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'etage', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$andThen,
		function (portee) {
			var _v0 = A2(
				$elm$core$Maybe$andThen,
				$author$project$Catalogue$Identifiants$elementIdFromString,
				$author$project$Components$Produits$Reference$API$QueryAPIModel$dernierSegment(portee));
			if (!_v0.$) {
				var id = _v0.a;
				return $elm$json$Json$Decode$succeed(id);
			} else {
				return $elm$json$Json$Decode$fail(portee);
			}
		},
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['source', 'portee']),
			$elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['source', 'nom']),
		$author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'valeur', $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$decoder)));
var $author$project$Components$Produits$Reference$API$QueryAPIModel$Voisine = F5(
	function (id, code, nom, variante, etat) {
		return {vx: code, gt: etat, Aq: id, Dj: nom, sl: variante};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$voisineDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'etat',
	$author$project$Catalogue$Identifiants$etatCodeDecoder,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'variante',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'nom',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'code',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$author$project$Catalogue$Identifiants$referenceIdDecoder,
					$elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$API$QueryAPIModel$Voisine))))));
var $author$project$Components$Produits$Reference$API$QueryAPIModel$ficheDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.gF;
		},
		$author$project$API$Liens$deLaRessource),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'genresDesChamps',
		$elm$json$Json$Decode$keyValuePairs($author$project$Components$Shared$GenreDuNom$decoder),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'calculs',
			$elm$json$Json$Decode$list(
				A5(
					$elm$json$Json$Decode$map4,
					$author$project$Components$Produits$Reference$API$QueryAPIModel$CalculDeLaFiche,
					A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'recalcul', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'valeur', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'etat', $elm$json$Json$Decode$string))),
			_List_Nil,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A2(
					$elm$json$Json$Decode$map,
					function ($) {
						return $.h0;
					},
					$author$project$API$Liens$deLaRessource),
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'partiesPrenantes',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Produits$Reference$API$QueryAPIModel$partiesPrenantesDecoder),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'liensDesGroupes',
						$elm$json$Json$Decode$keyValuePairs(
							A2(
								$elm$json$Json$Decode$map,
								function ($) {
									return $.h0;
								},
								$author$project$API$Liens$decoder)),
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'collections',
							$elm$json$Json$Decode$list($author$project$Components$Shared$CollectionDeLaFiche$decoder),
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'etatDeDepart',
								$elm$json$Json$Decode$keyValuePairs($author$project$Catalogue$Identifiants$etatCodeDecoder),
								_List_Nil,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'fichiers',
									$elm$json$Json$Decode$list($author$project$Components$Produits$Reference$API$QueryAPIModel$fichierDecoder),
									_List_Nil,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'activite',
										$elm$json$Json$Decode$list($author$project$Components$Produits$Reference$API$QueryAPIModel$evenementDecoder),
										_List_Nil,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'memeCheminTotal',
											$elm$json$Json$Decode$int,
											0,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'memeChemin',
												$elm$json$Json$Decode$list($author$project$Components$Produits$Reference$API$QueryAPIModel$voisineDecoder),
												_List_Nil,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'variantes',
													$elm$json$Json$Decode$list($author$project$Components$Produits$Reference$API$QueryAPIModel$voisineDecoder),
													_List_Nil,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'origine',
														A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Produits$Reference$API$QueryAPIModel$voisineDecoder),
														$elm$core$Maybe$Nothing,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'chemin',
															$elm$json$Json$Decode$list($author$project$Components$Produits$Reference$API$QueryAPIModel$etapeDuCheminDecoder),
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'liens',
																$elm$json$Json$Decode$list($author$project$Components$Produits$Reference$API$QueryAPIModel$lienDeLaFicheDecoder),
																_List_Nil,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'informations',
																	$elm$json$Json$Decode$list($author$project$Components$Produits$Reference$API$QueryAPIModel$informationDecoder),
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'valeursHeritees',
																		$elm$json$Json$Decode$list($author$project$Components$Produits$Reference$API$QueryAPIModel$valeurHeriteeDecoder),
																		_List_Nil,
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'horsLimitesDepuis',
																			$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
																			$elm$core$Dict$empty,
																			A4(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																				'libellesDesChoix',
																				$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
																				$elm$core$Dict$empty,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'choix',
																					$elm$json$Json$Decode$list($author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$decoder),
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'langues',
																						$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'unites',
																							$elm$json$Json$Decode$list(
																								A4(
																									$elm$json$Json$Decode$map3,
																									$author$project$Components$Shared$EditeurDeSchema$Propositions$Unite,
																									A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
																									A2($elm$json$Json$Decode$field, 'symbole', $elm$json$Json$Decode$string),
																									A2($elm$json$Json$Decode$field, 'grandeur', $elm$json$Json$Decode$string))),
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'publication',
																								$elm$json$Json$Decode$string,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'etats',
																									$author$project$Catalogue$API$QueryAPIModel$etatsDuClientDecoder,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'rangement',
																										$author$project$Components$Produits$Reference$API$QueryAPIModel$rangementDecoder,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'classement',
																											$elm$json$Json$Decode$list(
																												A3(
																													$elm$json$Json$Decode$map2,
																													F2(
																														function (classification, valeurs) {
																															return {vj: classification, Ki: valeurs};
																														}),
																													A2($elm$json$Json$Decode$field, 'classification', $author$project$Catalogue$Identifiants$classificationIdDecoder),
																													A2(
																														$elm$json$Json$Decode$field,
																														'valeurs',
																														$elm$json$Json$Decode$list($author$project$Catalogue$Identifiants$valeurIdDecoder)))),
																											A4(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																												'completude',
																												A2(
																													$elm$json$Json$Decode$map,
																													$elm$core$Maybe$Just,
																													A4(
																														$elm$json$Json$Decode$map3,
																														$author$project$Components$Produits$Reference$API$QueryAPIModel$CompletudeDetaillee,
																														A2($elm$json$Json$Decode$field, 'remplis', $elm$json$Json$Decode$int),
																														A2($elm$json$Json$Decode$field, 'total', $elm$json$Json$Decode$int),
																														A2(
																															$elm$json$Json$Decode$field,
																															'manques',
																															$elm$json$Json$Decode$list($author$project$Components$Produits$Reference$API$QueryAPIModel$manqueDecoder)))),
																												$elm$core$Maybe$Nothing,
																												A4(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																													'valeursHorsChoix',
																													$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
																													_List_Nil,
																													A4(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																														'valeursNonReconnues',
																														$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
																														_List_Nil,
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'valeurs',
																															$elm$json$Json$Decode$keyValuePairs($author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$decoder),
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'type',
																																$author$project$Components$Produits$Reference$API$QueryAPIModel$typeDecoder,
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'fil',
																																	$elm$json$Json$Decode$list(
																																		A4(
																																			$elm$json$Json$Decode$map3,
																																			$author$project$Components$Produits$Reference$API$QueryAPIModel$Etape,
																																			A2($elm$json$Json$Decode$field, 'element', $author$project$Catalogue$Identifiants$elementIdDecoder),
																																			A2($elm$json$Json$Decode$field, 'niveau', $author$project$Catalogue$Identifiants$niveauIdDecoder),
																																			A2($elm$json$Json$Decode$field, 'libelles', $author$project$Catalogue$API$QueryAPIModel$libellesDecoder))),
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'enDouble',
																																		$elm$json$Json$Decode$bool,
																																		A4(
																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																			'verrouillee',
																																			$elm$json$Json$Decode$bool,
																																			false,
																																			A3(
																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																				'arretee',
																																				$elm$json$Json$Decode$bool,
																																				A3(
																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																					'etat',
																																					$author$project$Catalogue$Identifiants$etatCodeDecoder,
																																					A4(
																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																						'variante',
																																						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
																																						$elm$core$Maybe$Nothing,
																																						A4(
																																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																							'millesime',
																																							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
																																							$elm$core$Maybe$Nothing,
																																							A4(
																																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																								'ean',
																																								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
																																								$elm$core$Maybe$Nothing,
																																								A4(
																																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																									'rattachement',
																																									A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Identifiants$elementIdDecoder),
																																									$elm$core$Maybe$Nothing,
																																									A4(
																																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																										$author$project$Catalogue$Vocabulaire$champDuProduit,
																																										A3(
																																											$elm$json$Json$Decode$map2,
																																											F2(
																																												function (id, libelles) {
																																													return $elm$core$Maybe$Just(
																																														{Aq: id, R: libelles});
																																												}),
																																											A2($elm$json$Json$Decode$field, 'id', $author$project$Catalogue$Identifiants$elementIdDecoder),
																																											A2($elm$json$Json$Decode$field, 'libelles', $author$project$Catalogue$API$QueryAPIModel$libellesDecoder)),
																																										$elm$core$Maybe$Nothing,
																																										A4(
																																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																											'nom',
																																											A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
																																											$elm$core$Maybe$Nothing,
																																											A3(
																																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																												'nature',
																																												$elm$json$Json$Decode$string,
																																												A3(
																																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																													'code',
																																													$elm$json$Json$Decode$string,
																																													A3(
																																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																														'id',
																																														$author$project$Catalogue$Identifiants$referenceIdDecoder,
																																														$elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$API$QueryAPIModel$Fiche)))))))))))))))))))))))))))))))))))))))))))))));
var $author$project$Components$Produits$Reference$API$QueryAPIModel$HistoriqueLu = F2(
	function (activite, total) {
		return {sT: activite, JE: total};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$historiqueDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Produits$Reference$API$QueryAPIModel$HistoriqueLu,
	A2(
		$elm$json$Json$Decode$field,
		'activite',
		$elm$json$Json$Decode$list($author$project$Components$Produits$Reference$API$QueryAPIModel$evenementDecoder)),
	A2($elm$json$Json$Decode$field, 'total', $elm$json$Json$Decode$int));
var $author$project$Components$Produits$Reference$Model$sections = function (fiche) {
	var type_ = fiche.r0;
	var saisiAUnEtage = function (champ) {
		return A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.uN;
				},
				$elm$core$Basics$eq(champ.dy)),
			fiche.Km);
	};
	var ordonnes = A2(
		$elm$core$List$filterMap,
		function (cle) {
			return $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dy;
						},
						$elm$core$Basics$eq(cle)),
					type_.dw));
		},
		type_.El);
	var heritees = A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.dw;
			},
			A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)),
		A2(
			$elm$core$List$map,
			function (information) {
				return {
					dw: A2(
						$elm$core$List$filter,
						A2($elm$core$Basics$composeR, saisiAUnEtage, $elm$core$Basics$not),
						information.dw),
					AL: $elm$core$Maybe$Just(information)
				};
			},
			fiche.AM));
	var dejaMontres = A2(
		$elm$core$List$concatMap,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.dw;
			},
			$elm$core$List$map(
				function ($) {
					return $.dy;
				})),
		heritees);
	var categorie = A2(
		$elm$core$List$filter,
		A2($elm$core$Basics$composeR, saisiAUnEtage, $elm$core$Basics$not),
		A2(
			$elm$core$List$filter,
			function (champ) {
				return !A2($elm$core$List$member, champ.dy, dejaMontres);
			},
			A2(
				$elm$core$List$filter,
				function (champ) {
					return !A2($elm$core$List$member, champ.dy, type_.Cd);
				},
				_Utils_ap(
					ordonnes,
					A2(
						$elm$core$List$filter,
						function (champ) {
							return !A2($elm$core$List$member, champ.dy, type_.El);
						},
						type_.dw)))));
	return _Utils_ap(
		heritees,
		_List_fromArray(
			[
				{dw: categorie, AL: $elm$core$Maybe$Nothing}
			]));
};
var $author$project$Components$Produits$Reference$Model$champs = function (fiche) {
	return A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.dw;
		},
		$author$project$Components$Produits$Reference$Model$sections(fiche));
};
var $author$project$Components$Produits$Reference$Update$horsFiche = F2(
	function (model, refus) {
		var montres = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Produits$Reference$Model$champs,
					$elm$core$List$map(
						function ($) {
							return $.dy;
						})),
				model.zo));
		return A2(
			$elm$core$List$filter,
			function (refuse) {
				return !A2($elm$core$List$member, refuse.uN, montres);
			},
			refus);
	});
var $author$project$Components$Produits$Reference$Update$libelleDuChamp = F2(
	function (model, cle) {
		return A2(
			$elm$core$Maybe$withDefault,
			cle,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				A2(
					$elm$core$Maybe$andThen,
					function (fiche) {
						return $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.dy;
									},
									$elm$core$Basics$eq(cle)),
								fiche.r0.dw));
					},
					model.zo)));
	});
var $author$project$Components$Produits$Reference$Update$perime = function (erreur) {
	return A2(
		$elm$core$List$member,
		erreur,
		_List_fromArray(
			[$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$DejaArretee, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$FicheVerrouillee, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$Introuvable, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$EcritureConcurrente, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$EtatInconnu, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ValeurNonProposable]));
};
var $author$project$I18n$Textes$produitsReferenceErreurConversionEnCours = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.reference.erreur.conversion-en-cours',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'champ',
				$author$project$I18n$Traductions$Sous(p.uN))
			]),
		'Conversion d\'unité en cours pour « {champ} ». La valeur ne peut pas être modifiée pour le moment. Réessayez dans quelques instants, une fois la conversion terminée.');
};
var $author$project$I18n$Textes$produitsReferenceErreurFicheVerrouillee = A3($author$project$I18n$Traductions$texte, 'produits.reference.erreur.fiche-verrouillee', _List_Nil, 'Cette fiche est verrouillée : rien n\'a été modifié. Repassez la référence à un état antérieur pour la modifier.');
var $author$project$Components$Produits$Reference$Update$message = F3(
	function (model, refus, erreur) {
		if (_Utils_eq(erreur, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$EtatInconnu)) {
			return $author$project$Components$Produits$Common$Etat$refusDEtatInconnu(refus);
		} else {
			if (_Utils_eq(erreur, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$FicheVerrouillee)) {
				return {Jx: $author$project$I18n$Textes$produitsReferenceErreurFicheVerrouillee, b9: refus.b9};
			} else {
				if ($author$project$Components$Produits$Reference$Update$perime(erreur)) {
					return {Jx: $author$project$I18n$Textes$produitsCatalogueErreurPerime, b9: refus.b9};
				} else {
					if (erreur.$ === 54) {
						var cle = erreur.a;
						return {
							Jx: $author$project$I18n$Textes$produitsReferenceErreurConversionEnCours(
								{
									uN: $author$project$I18n$Traductions$tel(
										A2($author$project$Components$Produits$Reference$Update$libelleDuChamp, model, cle))
								}),
							b9: refus.b9
						};
					} else {
						return $author$project$Components$Shared$Messages$Model$duRefus(refus);
					}
				}
			}
		}
	});
var $author$project$I18n$Textes$produitsReferenceFichiersVarianteIncomplete = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'produits.reference.fichiers.variante-incomplete',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nombre',
				$author$project$I18n$Traductions$Sous(p.w))
			]),
		'La variante est créée, mais {nombre} fichier(s) n\'ont pas été repris : rattachez-les depuis sa fiche.');
};
var $author$project$API$NavLinksDictionary$rattacherUnFichierAUneReference = 'rattacher-un-fichier-a-une-reference';
var $author$project$Components$Produits$Reference$Update$popMessages = F2(
	function (model, msg) {
		switch (msg.$) {
			case 62:
				var reponse = msg.a;
				var _v1 = A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, model.l2);
				_v1$7:
				while (true) {
					if (!_v1.$) {
						switch (_v1.a.b.$) {
							case 0:
								if (_v1.a.b.c) {
									if (_v1.a.b.a.$ === 37) {
										var _v5 = _v1.a;
										var _v6 = _v5.b;
										var rendue = _v6.b;
										return _Utils_eq(
											A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rattacherUnFichierAUneReference, rendue.nQ),
											$elm$core$Maybe$Nothing) ? A2(
											$elm$core$Maybe$andThen,
											function (n) {
												return (!n) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
													{
														Jx: $author$project$I18n$Textes$produitsReferenceFichiersVarianteIncomplete(
															{
																w: $author$project$I18n$Traductions$tel(
																	$elm$core$String$fromInt(n))
															}),
														b9: $elm$core$Maybe$Nothing
													});
											},
											A2(
												$elm$core$Maybe$map,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.zB;
													},
													$elm$core$List$length),
												model.zo)) : $elm$core$Maybe$Nothing;
									} else {
										break _v1$7;
									}
								} else {
									var _v7 = _v1.a;
									var _v8 = _v7.b;
									return $elm$core$Maybe$Just($author$project$Components$Produits$Common$Refus$rejeu);
								}
							case 1:
								switch (_v1.a.b.a.$) {
									case 47:
										var _v2 = _v1.a;
										var _v3 = _v2.b;
										var _v4 = _v3.a;
										var refus = _v3.b;
										return A2(
											$elm$core$Maybe$map,
											function (reprise) {
												return {
													Jx: $author$project$I18n$Textes$produitsReferenceFichiersVarianteIncomplete(
														{
															w: $author$project$I18n$Traductions$tel(
																$elm$core$String$fromInt(
																	1 + $elm$core$List$length(reprise.HR)))
														}),
													b9: refus.b9
												};
											},
											model.qx);
									case 49:
										var _v9 = _v1.a;
										var _v10 = _v9.b;
										var _v11 = _v10.a;
										return $elm$core$Maybe$Nothing;
									case 50:
										var _v12 = _v1.a;
										var _v13 = _v12.b;
										var _v14 = _v13.a;
										return $elm$core$Maybe$Nothing;
									default:
										if (_v1.a.b.c.$ === 36) {
											var _v15 = _v1.a;
											var _v16 = _v15.b;
											var refus = _v16.b;
											var refuses = _v16.c.a;
											return $elm$core$List$isEmpty(
												A2($author$project$Components$Produits$Reference$Update$horsFiche, model, refuses)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
												{Jx: $author$project$I18n$Textes$produitsCatalogueErreurPerime, b9: refus.b9});
										} else {
											var _v17 = _v1.a;
											var _v18 = _v17.b;
											var refus = _v18.b;
											var erreur = _v18.c;
											return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
												A3($author$project$Components$Produits$Reference$Update$message, model, refus, erreur));
										}
								}
							default:
								break _v1$7;
						}
					} else {
						break _v1$7;
					}
				}
				return $elm$core$Maybe$Nothing;
			case 2:
				var reponse = msg.a;
				var _v19 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Reference$API$QueryAPIModel$ficheDecoder, reponse);
				if (_v19.$ === 1) {
					var refus = _v19.a;
					return A2(
						$elm$core$List$member,
						refus.ri,
						_List_fromArray(
							[401, 404])) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 3:
				var reponse = msg.a;
				var _v20 = A2($author$project$API$Reponse$lire, $author$project$Catalogue$API$PrixAPIModel$prixDUneReferenceDecoder, reponse);
				if (_v20.$ === 1) {
					var refus = _v20.a;
					return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 6:
				var reponse = msg.b;
				var _v21 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Reference$API$QueryAPIModel$historiqueDecoder, reponse);
				if (_v21.$ === 1) {
					var refus = _v21.a;
					return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 1:
				var octets = msg.a;
				return _Utils_eq(
					$author$project$API$ProcessUid$depuisOctets(octets),
					$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
					{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$Common$Effet$LireLaValeurDuPerimetre = F2(
	function (a, b) {
		return {$: 29, a: a, b: b};
	});
var $author$project$Components$Produits$Reference$Model$cleDeLApercu = function (perimetre) {
	return 'apercu:' + perimetre;
};
var $author$project$Components$Produits$Reference$Model$lireLApercuDuBrouillon = F4(
	function (fiche, cle, perimetre, articles) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2('perimetre', perimetre),
						_Utils_Tuple2(
						'choisies',
						A2($elm$core$String$join, ',', articles)),
						_Utils_Tuple2('debut', '0'),
						_Utils_Tuple2('taille', '1')
					])),
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.tq;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dy;
							},
							$elm$core$Basics$eq(cle)),
						fiche.BQ))));
	});
var $author$project$Components$Produits$Reference$Update$lireLApercuDuBrouillon = function (_v0) {
	var model = _v0.a;
	var effets = _v0.b;
	var _v1 = _Utils_Tuple2(
		model.zo,
		A2(
			$elm$core$Maybe$andThen,
			function (brouillon) {
				return A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(brouillon),
					brouillon.E9);
			},
			model.uw));
	if (!_v1.b.$) {
		if (!_v1.a.$) {
			var fiche = _v1.a.a;
			var _v2 = _v1.b.a;
			var brouillon = _v2.a;
			var choisi = _v2.b;
			if (_Utils_eq(
				model.tt,
				$elm$core$Maybe$Just(
					_Utils_Tuple2(choisi.Aq, brouillon.tP)))) {
				return _Utils_Tuple2(model, effets);
			} else {
				var _v3 = A4($author$project$Components$Produits$Reference$Model$lireLApercuDuBrouillon, fiche, brouillon.dy, choisi.Aq, brouillon.tP);
				if (!_v3.$) {
					var lien = _v3.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								tt: $elm$core$Maybe$Just(
									_Utils_Tuple2(choisi.Aq, brouillon.tP))
							}),
						_Utils_ap(
							effets,
							_List_fromArray(
								[
									A2(
									$author$project$Components$Produits$Common$Effet$LireLaValeurDuPerimetre,
									$author$project$Components$Produits$Reference$Model$cleDeLApercu(choisi.Aq),
									lien)
								])));
				} else {
					return _Utils_Tuple2(model, effets);
				}
			}
		} else {
			return _Utils_Tuple2(model, effets);
		}
	} else {
		var _v4 = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{tt: $elm$core$Maybe$Nothing}),
			effets);
	}
};
var $author$project$Components$Produits$Reference$Model$ChangementDEtat = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$Reference$Model$ChangementDuCode = {$: 18};
var $author$project$Components$Produits$Common$Effet$ChoisirUnFichier = function (a) {
	return {$: 42, a: a};
};
var $author$project$Components$Produits$Reference$Model$ChoixDArticles = {$: 11};
var $author$project$Components$Produits$Reference$Model$ChoixDUnPerimetre = {$: 9};
var $author$project$Components$Produits$Reference$Model$ChoixDUtilisateur = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Produits$Reference$Model$CreationDUnPerimetre = {$: 10};
var $author$project$Components$Produits$Reference$Model$DefinitionDeLImage = {$: 6};
var $author$project$Components$Produits$Reference$Model$Duplication = {$: 2};
var $author$project$Components$Produits$Reference$Model$Historique = {$: 4};
var $author$project$Components$Produits$Common$Effet$LireLActiviteDeLaReference = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Components$Produits$Common$Effet$LireLApercuDuRecalcul = function (a) {
	return {$: 31, a: a};
};
var $author$project$Components$Produits$Common$Effet$LireLImage = function (a) {
	return {$: 45, a: a};
};
var $author$project$Components$Produits$Common$Effet$LireLaFicheDUnProduit = function (a) {
	return {$: 28, a: a};
};
var $author$project$Components$Produits$Common$Effet$LireLesDocuments = function (a) {
	return {$: 50, a: a};
};
var $author$project$Components$Produits$Common$Effet$LireUnFichierGlisse = function (a) {
	return {$: 49, a: a};
};
var $author$project$Components$Produits$Reference$Model$Modification = {$: 3};
var $author$project$Components$Produits$Reference$Model$ModificationDesArticles = {$: 8};
var $author$project$Components$Produits$Reference$Model$ProduitDeLaReference = {$: 13};
var $author$project$Components$Produits$Reference$Model$RecalculDUnChamp = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Produits$Reference$Model$RecalculDuCode = {$: 19};
var $author$project$Catalogue$API$WriteAPIModel$RetirerLeFichier = F2(
	function (a, b) {
		return {$: 48, a: a, b: b};
	});
var $author$project$Components$Produits$Reference$Model$RetraitDArticle = {$: 12};
var $author$project$Components$Produits$Reference$Model$RetraitDUneOccurrence = {$: 15};
var $author$project$Components$Produits$Common$Effet$AnnulerLEnvoiDeLImage = {$: 48};
var $author$project$Components$Produits$Reference$Image$Attente = 0;
var $author$project$Components$Produits$Reference$Update$annulerLEnvoiDeLImage = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{
				wZ: A2(
					$elm$core$Maybe$map,
					function (definition) {
						return _Utils_update(
							definition,
							{vd: $elm$core$Maybe$Nothing, kC: $elm$core$Maybe$Nothing, me: 0, pA: $elm$core$Maybe$Nothing, pD: 0, pZ: $elm$core$Maybe$Nothing});
					},
					model.wZ)
			}),
		_List_fromArray(
			[$author$project$Components$Produits$Common$Effet$AnnulerLEnvoiDeLImage, $author$project$Components$Produits$Common$Effet$DemanderProcessUid]));
};
var $author$project$Components$Produits$Reference$API$QueryAPIModel$ApercuDuCode = F3(
	function (ancien, nouveau, numeroGarde) {
		return {ti: ancien, en: nouveau, DY: numeroGarde};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$apercuDuCodeDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Produits$Reference$API$QueryAPIModel$ApercuDuCode,
	A2($elm$json$Json$Decode$field, 'ancien', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'nouveau', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'numeroGarde', $elm$json$Json$Decode$bool));
var $author$project$Components$Produits$Reference$API$QueryAPIModel$ApercuDuRecalcul = F4(
	function (ancienne, nouvelle, sources, sourcesDuDernierCalcul) {
		return {iN: ancienne, oS: nouvelle, IT: sources, IU: sourcesDuDernierCalcul};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$valeurDit = F2(
	function (valeur, libelle) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$field,
					libelle,
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)),
					A2(
					$elm$json$Json$Decode$field,
					valeur,
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
								A2(
								$elm$json$Json$Decode$map,
								A2($elm$core$Basics$composeR, $elm$core$String$fromFloat, $elm$core$Maybe$Just),
								$elm$json$Json$Decode$float),
								A2(
								$elm$json$Json$Decode$map,
								function (b) {
									return $elm$core$Maybe$Just(
										b ? 'oui' : 'non');
								},
								$elm$json$Json$Decode$bool)
							]))),
					$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
				]));
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$valeursDesSources = function (nom) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				nom,
				$elm$json$Json$Decode$keyValuePairs(
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								$elm$json$Json$Decode$string,
								A2($elm$json$Json$Decode$map, $elm$core$String$fromFloat, $elm$json$Json$Decode$float)
							])))),
				$elm$json$Json$Decode$succeed(_List_Nil)
			]));
};
var $author$project$Components$Produits$Reference$API$QueryAPIModel$apercuDuRecalculDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Components$Produits$Reference$API$QueryAPIModel$ApercuDuRecalcul,
	A2($author$project$Components$Produits$Reference$API$QueryAPIModel$valeurDit, 'ancienne', 'libelleDeLAncienne'),
	A2($author$project$Components$Produits$Reference$API$QueryAPIModel$valeurDit, 'nouvelle', 'libelleDeLaNouvelle'),
	$author$project$Components$Produits$Reference$API$QueryAPIModel$valeursDesSources('sources'),
	$author$project$Components$Produits$Reference$API$QueryAPIModel$valeursDesSources('sourcesDuDernierCalcul'));
var $author$project$Components$Produits$Reference$Fichiers$Rattachement = {$: 3};
var $author$project$Catalogue$API$WriteAPIModel$RattacherUnFichier = F4(
	function (a, b, c, d) {
		return {$: 47, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Produits$Reference$Fichiers$Saisie = {$: 0};
var $author$project$Components$Produits$Reference$Fichiers$DepotsFermes = {$: 4};
var $author$project$Components$Produits$Reference$Fichiers$TropGros = {$: 2};
var $author$project$Components$Produits$Reference$Fichiers$DepotIncomplet = {$: 3};
var $author$project$Components$Produits$Reference$Fichiers$FichierVide = {$: 1};
var $author$project$Components$Produits$Reference$Fichiers$TypeNonReconnu = {$: 0};
var $author$project$Components$Produits$Reference$Fichiers$depotIncomplet = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$andThen,
			function (attendus) {
				return (!attendus) ? $elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$Fichiers$FichierVide) : $elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$Fichiers$DepotIncomplet);
			},
			A2($elm$json$Json$Decode$field, 'attendus', $elm$json$Json$Decode$int)),
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$Fichiers$DepotIncomplet)
		]));
var $author$project$Components$Produits$Reference$Fichiers$erreurDuDepot = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'TypeNonReconnu',
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$Fichiers$TypeNonReconnu)),
			A2(
			$elm$json$Json$Decode$field,
			'FichierVide',
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$Fichiers$FichierVide)),
			A2($elm$json$Json$Decode$field, 'DepotIncomplet', $author$project$Components$Produits$Reference$Fichiers$depotIncomplet),
			A2(
			$elm$json$Json$Decode$field,
			'MorceauInvalide',
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$Fichiers$DepotIncomplet)),
			A2(
			$elm$json$Json$Decode$field,
			'RangInvalide',
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$Fichiers$DepotIncomplet)),
			A2(
			$elm$json$Json$Decode$field,
			'DepotsFermes',
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$Fichiers$DepotsFermes))
		]));
var $author$project$Components$Produits$Reference$Fichiers$refusDuDepot = function (reponse) {
	return (reponse.ri === 413) ? $elm$core$Maybe$Just($author$project$Components$Produits$Reference$Fichiers$TropGros) : $elm$core$Result$toMaybe(
		A2(
			$elm$json$Json$Decode$decodeString,
			A2($elm$json$Json$Decode$field, 'error', $author$project$Components$Produits$Reference$Fichiers$erreurDuDepot),
			reponse.f$));
};
var $author$project$Components$Produits$Reference$Update$refuserLeDepot = F2(
	function (refus, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					xc: A2(
						$elm$core$Maybe$map,
						function (depot) {
							return _Utils_update(
								depot,
								{
									me: $author$project$Components$Produits$Reference$Fichiers$Saisie,
									Gn: $elm$core$Maybe$Nothing,
									pZ: $elm$core$Maybe$Just(refus)
								});
						},
						model.xc)
				}),
			_List_fromArray(
				[$author$project$Components$Produits$Common$Effet$DemanderProcessUid]));
	});
var $author$project$Components$Produits$Reference$Update$echecDuDepot = F2(
	function (reponse, model) {
		if (reponse.ri === 401) {
			return _Utils_Tuple2(
				model,
				_List_fromArray(
					[$author$project$Components$Produits$Common$Effet$Reconnecter]));
		} else {
			var _v0 = $author$project$Components$Produits$Reference$Fichiers$refusDuDepot(reponse);
			if (!_v0.$) {
				var refus = _v0.a;
				var _v1 = A2($author$project$Components$Produits$Reference$Update$refuserLeDepot, refus, model);
				var refuse = _v1.a;
				var effets = _v1.b;
				return _Utils_eq(refus, $author$project$Components$Produits$Reference$Fichiers$DepotsFermes) ? _Utils_Tuple2(
					_Utils_update(
						refuse,
						{
							xc: A2(
								$elm$core$Maybe$map,
								function (depot) {
									return _Utils_update(
										depot,
										{
											Gn: A2(
												$elm$core$Maybe$andThen,
												function ($) {
													return $.Gn;
												},
												model.xc)
										});
								},
								refuse.xc)
						}),
					_List_Nil) : _Utils_Tuple2(refuse, effets);
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							xc: A2(
								$elm$core$Maybe$map,
								function (depot) {
									return _Utils_update(
										depot,
										{me: $author$project$Components$Produits$Reference$Fichiers$Saisie});
								},
								model.xc)
						}),
					_List_Nil);
			}
		}
	});
var $author$project$Components$Produits$Reference$Fichiers$uidDuFichierDepose = function (reponse) {
	return $elm$core$Result$toMaybe(
		A2(
			$elm$json$Json$Decode$decodeString,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['fichier', 'id']),
				$elm$json$Json$Decode$string),
			reponse.f$));
};
var $author$project$Components$Produits$Reference$Update$apresLaCloture = F2(
	function (reponse, model) {
		if ((reponse.ri >= 200) && (reponse.ri < 300)) {
			var _v0 = _Utils_Tuple2(model.xc, model.zo);
			if ((!_v0.a.$) && (!_v0.b.$)) {
				var depot = _v0.a.a;
				var fiche = _v0.b.a;
				var _v1 = _Utils_Tuple2(
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rattacherUnFichierAUneReference, fiche.nQ),
					$author$project$Components$Produits$Reference$Fichiers$uidDuFichierDepose(reponse));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var lien = _v1.a.a;
					var fichier = _v1.b.a;
					var textes = A2(
						$elm$core$List$sortBy,
						$elm$core$Tuple$first,
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$second,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$String$trim,
									$elm$core$Basics$neq(''))),
							depot.rF));
					var _v2 = A3(
						$author$project$Components$Produits$Common$Envoi$partir,
						$elm$core$Maybe$Just(lien),
						A4($author$project$Catalogue$API$WriteAPIModel$RattacherUnFichier, fiche.Aq, depot.uN, fichier, textes),
						model.l2);
					if (!_v2.$) {
						var _v3 = _v2.a;
						var envoi = _v3.a;
						var effets = _v3.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									xc: $elm$core$Maybe$Just(
										_Utils_update(
											depot,
											{me: $author$project$Components$Produits$Reference$Fichiers$Rattachement})),
									l2: envoi
								}),
							effets);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									xc: $elm$core$Maybe$Just(
										_Utils_update(
											depot,
											{me: $author$project$Components$Produits$Reference$Fichiers$Saisie}))
								}),
							_List_Nil);
					}
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return A2($author$project$Components$Produits$Reference$Update$echecDuDepot, reponse, model);
		}
	});
var $author$project$Components$Produits$Reference$Fichiers$Cloture = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$Common$Effet$DeposerLeFichier = F4(
	function (a, b, c, d) {
		return {$: 44, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Produits$Common$Effet$PoserUnMorceau = F2(
	function (a, b) {
		return {$: 43, a: a, b: b};
	});
var $author$project$Components$Produits$Reference$Fichiers$Morceaux = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$Reference$Fichiers$etapeSuivante = function (enCours) {
	var _v0 = enCours.HR;
	if (_v0.b) {
		var premier = _v0.a;
		var reste = _v0.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple3(
				enCours.zf,
				premier,
				$author$project$Components$Produits$Reference$Fichiers$Morceaux(
					{zf: enCours.zf + 1, HR: reste, JE: enCours.JE})));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$API$NavLinksDictionary$variableProcessUid = 'processUid';
var $author$project$API$NavLinksDictionary$variableRang = 'rang';
var $author$project$Components$Produits$Reference$Update$lienDuMorceau = F3(
	function (model, uid, rang) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$API$NavLinksDictionary$variableProcessUid,
						$author$project$API$ProcessUid$toString(uid)),
						_Utils_Tuple2(
						$author$project$API$NavLinksDictionary$variableRang,
						$elm$core$String$fromInt(rang))
					])),
			model.d9.ol);
	});
var $author$project$Components$Produits$Reference$Update$poserLeSuivant = function (model) {
	var _v0 = model.xc;
	if (!_v0.$) {
		var depot = _v0.a;
		var processUid = depot.Gn;
		var etape = depot.me;
		var _v1 = _Utils_Tuple2(processUid, etape);
		if ((!_v1.a.$) && (_v1.b.$ === 1)) {
			var uid = _v1.a.a;
			var enCours = _v1.b.a;
			var _v2 = $author$project$Components$Produits$Reference$Fichiers$etapeSuivante(enCours);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var rang = _v3.a;
				var octets = _v3.b;
				var suite = _v3.c;
				var _v4 = A3($author$project$Components$Produits$Reference$Update$lienDuMorceau, model, uid, rang);
				if (!_v4.$) {
					var lien = _v4.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								xc: $elm$core$Maybe$Just(
									_Utils_update(
										depot,
										{me: suite}))
							}),
						_List_fromArray(
							[
								A2($author$project$Components$Produits$Common$Effet$PoserUnMorceau, lien, octets)
							]));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			} else {
				var _v5 = _Utils_Tuple2(model.d9.kI, depot.vd);
				if ((!_v5.a.$) && (!_v5.b.$)) {
					var lien = _v5.a.a;
					var fichier = _v5.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								xc: $elm$core$Maybe$Just(
									_Utils_update(
										depot,
										{
											me: $author$project$Components$Produits$Reference$Fichiers$Cloture(
												{CU: enCours.JE})
										}))
							}),
						_List_fromArray(
							[
								A4($author$project$Components$Produits$Common$Effet$DeposerLeFichier, lien, uid, enCours.JE, fichier.Jm)
							]));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$Reference$Update$apresUnMorceau = F2(
	function (reponse, model) {
		return ((reponse.ri >= 200) && (reponse.ri < 300)) ? $author$project$Components$Produits$Reference$Update$poserLeSuivant(model) : A2($author$project$Components$Produits$Reference$Update$echecDuDepot, reponse, model);
	});
var $author$project$Components$Produits$Reference$Update$archiverLeProduit = function (model) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		function (ouvert) {
			return A2($author$project$Components$Produits$Common$ArchivageDuProduit$commande, ouvert.Aq, ouvert.tD);
		},
		model.pC);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var commande = _v1.a;
		var lien = _v1.b;
		var _v2 = A3(
			$author$project$Components$Produits$Common$Envoi$partir,
			$elm$core$Maybe$Just(lien),
			commande,
			model.l2);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var envoi = _v3.a;
			var effets = _v3.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi, pZ: $elm$core$Maybe$Nothing}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$Reference$Update$avecLeBrouillon = F2(
	function (modifier, model) {
		return _Utils_update(
			model,
			{
				uw: A2($elm$core$Maybe$map, modifier, model.uw)
			});
	});
var $author$project$Components$Produits$Reference$Update$avecLeChoix = F2(
	function (modifier, model) {
		return _Utils_update(
			model,
			{
				tP: A2($elm$core$Maybe$map, modifier, model.tP)
			});
	});
var $author$project$Components$Produits$Reference$Update$basculer = F2(
	function (geste, model) {
		var drawer = model.kX;
		return _Utils_update(
			model,
			{
				kX: _Utils_update(
					drawer,
					{
						Dj: $author$project$Components$Produits$Reference$Model$nomDuDrawer(geste)
					}),
				mW: geste,
				pZ: $elm$core$Maybe$Nothing
			});
	});
var $author$project$I18n$Textes$produitsReferenceLiensIndisponible = A3($author$project$I18n$Traductions$texte, 'produits.reference.liens.indisponible', _List_Nil, 'Article indisponible');
var $author$project$Components$Produits$Reference$Model$ligneDeLArticle = function (lu) {
	return A2(
		$elm$core$List$filter,
		$elm$core$Basics$neq(
			$author$project$I18n$Traductions$tel('')),
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$I18n$Textes$produitsReferenceLiensIndisponible,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.zX;
						},
						$author$project$I18n$Traductions$tel),
					lu.Dj)),
				$author$project$I18n$Traductions$tel(
				A2($elm$core$Maybe$withDefault, '', lu.vx))
			]));
};
var $author$project$Components$Produits$Reference$Model$plusieursArticles = F2(
	function (fiche, cle) {
		return A2(
			$elm$core$List$any,
			function ($) {
				return $.FS;
			},
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.dy;
					},
					$elm$core$Basics$eq(cle)),
				fiche.BQ));
	});
var $author$project$Components$Produits$Reference$Model$brouillonDeLaFiche = F2(
	function (fiche, cle) {
		var lien = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.dy;
					},
					$elm$core$Basics$eq(cle)),
				fiche.BQ));
		var propres = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.tP;
					},
					$elm$core$List$filter(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.o4;
							},
							$elm$core$Basics$eq($elm$core$Maybe$Nothing)))),
				lien));
		return {
			tP: A2(
				$elm$core$List$map,
				function ($) {
					return $.Aq;
				},
				propres),
			dy: cle,
			kk: $elm$core$Maybe$Nothing,
			DG: $elm$core$Dict$fromList(
				A2(
					$elm$core$List$map,
					function (lu) {
						return _Utils_Tuple2(
							lu.Aq,
							$author$project$Components$Produits$Reference$Model$ligneDeLArticle(lu));
					},
					propres)),
			E9: A2(
				$elm$core$Maybe$andThen,
				function (lu) {
					return A2(
						$elm$core$Maybe$map,
						function (nom) {
							return {wp: _List_Nil, wT: $elm$core$Maybe$Nothing, Aq: lu.Aq, Dj: nom};
						},
						lu.Dj);
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.o4;
							},
							$elm$core$Basics$eq($elm$core$Maybe$Nothing)),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.pg;
								},
								lien))))),
			FS: A2($author$project$Components$Produits$Reference$Model$plusieursArticles, fiche, cle),
			pZ: $elm$core$Maybe$Nothing
		};
	});
var $author$project$Components$Produits$Reference$Update$chercherDesArticles = function (_v0) {
	var model = _v0.a;
	var effets = _v0.b;
	var _v1 = model.tP;
	if (!_v1.$) {
		var choix = _v1.a;
		var suivant = _Utils_update(
			choix,
			{DX: choix.DX + 1});
		var _v2 = A2($author$project$Components$Produits$Common$ChoixDArticles$lienDuLot, model.gF, suivant.EE);
		if (!_v2.$) {
			var lien = _v2.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						tP: $elm$core$Maybe$Just(suivant)
					}),
				_Utils_ap(
					effets,
					_List_fromArray(
						[
							A3(
							$author$project$Components$Produits$Common$Effet$Rechercher,
							suivant.DX,
							lien,
							$author$project$Components$Produits$Common$ChoixDArticles$recherche(suivant))
						])));
		} else {
			return _Utils_Tuple2(model, effets);
		}
	} else {
		return _Utils_Tuple2(model, effets);
	}
};
var $author$project$Components$Produits$Reference$Model$commandeDArret = function (fiche) {
	return A2(
		$elm$core$Maybe$map,
		$elm$core$Tuple$pair(
			$author$project$Catalogue$API$WriteAPIModel$ArreterUneReference(fiche.Aq)),
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$arreterUneReference, fiche.nQ));
};
var $author$project$Catalogue$API$WriteAPIModel$DebrayerLeCalcul = F2(
	function (a, b) {
		return {$: 46, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$debrayerLeCalculDUneReference = 'debrayer-le-calcul-d-une-reference';
var $author$project$Components$Produits$Reference$Model$commandeDeDebrayage = F2(
	function (fiche, cle) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair(
				A2($author$project$Catalogue$API$WriteAPIModel$DebrayerLeCalcul, fiche.Aq, cle)),
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$debrayerLeCalculDUneReference, fiche.nQ));
	});
var $author$project$Catalogue$API$WriteAPIModel$RecalculerUnChamp = F2(
	function (a, b) {
		return {$: 44, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$recalculerUnChampDUneReference = 'recalculer-un-champ-d-une-reference';
var $author$project$Components$Produits$Reference$Model$commandeDeRecalcul = F2(
	function (fiche, cle) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair(
				A2($author$project$Catalogue$API$WriteAPIModel$RecalculerUnChamp, fiche.Aq, cle)),
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$recalculerUnChampDUneReference, fiche.nQ));
	});
var $author$project$Catalogue$API$WriteAPIModel$RevenirAuCalcul = F2(
	function (a, b) {
		return {$: 45, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$revenirAuCalculDUneReference = 'revenir-au-calcul-d-une-reference';
var $author$project$Components$Produits$Reference$Model$commandeDeRetourAuCalcul = F2(
	function (fiche, cle) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair(
				A2($author$project$Catalogue$API$WriteAPIModel$RevenirAuCalcul, fiche.Aq, cle)),
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$revenirAuCalculDUneReference, fiche.nQ));
	});
var $author$project$Catalogue$API$WriteAPIModel$ChangerLeCodeDUneReference = F2(
	function (a, b) {
		return {$: 41, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$changerLeCodeDUneReference = 'changer-le-code-d-une-reference';
var $author$project$Components$Produits$Reference$Model$commandeDuCode = F2(
	function (fiche, code) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair(
				A2($author$project$Catalogue$API$WriteAPIModel$ChangerLeCodeDUneReference, fiche.Aq, code)),
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$changerLeCodeDUneReference, fiche.nQ));
	});
var $author$project$Components$Produits$Common$Effet$OuvrirLaReference = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Produits$Reference$Model$ZoneDuCode = 0;
var $author$project$Components$Produits$Reference$Model$codePris = F3(
	function (saisi, marque, fiche) {
		var code = $elm$core$String$trim(saisi);
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Textes$produitsReferencesRefusCodePrisSansMarque(
				{
					vx: $author$project$I18n$Traductions$tel(code)
				}),
			A2(
				$elm$core$Maybe$map,
				function (connue) {
					return $author$project$I18n$Textes$produitsReferencesRefusCodePris(
						{
							vx: $author$project$I18n$Traductions$tel(code),
							gX: $author$project$I18n$Traductions$tel(connue.R.zX)
						});
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (etape) {
							return _Utils_eq(
								$elm$core$Maybe$Just(etape.lQ),
								marque);
						},
						fiche.zD))));
	});
var $author$project$Components$Produits$Reference$Update$surLArchivage = F2(
	function (geste, model) {
		return _Utils_update(
			model,
			{
				pC: A2(
					$elm$core$Maybe$map,
					function (ouvert) {
						return _Utils_update(
							ouvert,
							{
								tD: geste(ouvert.tD)
							});
					},
					model.pC)
			});
	});
var $author$project$Components$Produits$Reference$Update$concluLArchivageDuProduit = F2(
	function (issue, model) {
		var tournures = $author$project$Catalogue$Vocabulaire$tournures(
			{fA: $author$project$Catalogue$Vocabulaire$codeProduit, Bl: $elm$core$Maybe$Nothing});
		var contexte = function (ouvert) {
			return {
				aV: A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$I18n$Traductions$tel),
				gi: tournures.gi,
				Dj: ouvert.Dj,
				fd: tournures
			};
		};
		var _v0 = model.pC;
		if (!_v0.$) {
			var ouvert = _v0.a;
			var _v1 = A3(
				$author$project$Components$Produits$Common$ArchivageDuProduit$conclure,
				contexte(ouvert),
				issue,
				ouvert.tD);
			if (!_v1.$) {
				var conclusion = _v1.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Produits$Reference$Update$surLArchivage,
						$elm$core$Basics$always(conclusion.tD),
						_Utils_update(
							model,
							{pZ: conclusion.pZ})),
					_List_Nil);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$Reference$Update$relire = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$Lire, $elm$core$List$singleton),
			model.np));
};
var $author$project$Components$Produits$Reference$Update$relecture = F2(
	function (rendue, model) {
		return (rendue.sy && (!A2($elm$core$List$member, $author$project$Catalogue$API$WriteAPIModel$EvenementInconnu, rendue.mk))) ? $author$project$Components$Produits$Reference$Update$relire(model) : _List_fromArray(
			[
				$author$project$Components$Produits$Common$Effet$AttendreAvantDeRelire($author$project$Components$Produits$Common$Envoi$delaiDeRelectureMs)
			]);
	});
var $author$project$Components$Produits$Reference$Model$OccurrenceDUnGroupe = {$: 14};
var $author$project$Components$Produits$Reference$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{kX: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Produits$Common$Effet$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: (_Utils_eq(model.mW, $author$project$Components$Produits$Reference$Model$Duplication) && ($elm$core$String$trim(
						_Utils_ap(model.sl.vx, model.sl.sl)) !== '')) || ((_Utils_eq(model.mW, $author$project$Components$Produits$Reference$Model$OccurrenceDUnGroupe) && A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							function (brouillon) {
								return A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$enCours, brouillon.IX, brouillon.hP);
							},
							model.D$))) || (_Utils_eq(model.mW, $author$project$Components$Produits$Reference$Model$Modification) && A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							function (fiche) {
								return A2(
									$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$enCours,
									$author$project$Components$Produits$Reference$Model$champs(fiche),
									model.hP);
							},
							model.zo))))
				},
				geste,
				model.kX));
	});
var $author$project$Components$Produits$Reference$Update$conclureLeRattachement = F2(
	function (issue, model) {
		if (!issue.$) {
			var rendue = issue.b;
			return A2(
				$elm$core$Tuple$mapSecond,
				function (effets) {
					return _Utils_ap(
						effets,
						A2($author$project$Components$Produits$Reference$Update$relecture, rendue, model));
				},
				A2(
					$author$project$Components$Produits$Reference$Update$versLeDrawer,
					$author$project$Components$Shared$Drawer$Update$Fermer,
					_Utils_update(
						model,
						{
							xc: $elm$core$Maybe$Nothing,
							zo: A2(
								$elm$core$Maybe$map,
								function (fiche) {
									return _Utils_update(
										fiche,
										{nQ: rendue.nQ});
								},
								model.zo)
						})));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$Reference$Model$idDeLaSection = 'caracteristiques';
var $author$project$Components$Produits$Reference$Model$idDeVariante = F2(
	function (prefixe, zone) {
		return _Utils_ap(
			prefixe,
			function () {
				switch (zone) {
					case 0:
						return '-code';
					case 1:
						return '-variante';
					default:
						return '-etat';
				}
			}());
	});
var $author$project$Components$Produits$Reference$Update$occurrenceFaite = F2(
	function (rendue, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			function (effets) {
				return _Utils_ap(
					effets,
					A2($author$project$Components$Produits$Reference$Update$relecture, rendue, model));
			},
			A2(
				$author$project$Components$Produits$Reference$Update$versLeDrawer,
				$author$project$Components$Shared$Drawer$Update$Fermer,
				_Utils_update(
					model,
					{
						zo: A2(
							$elm$core$Maybe$map,
							function (fiche) {
								return _Utils_update(
									fiche,
									{nQ: rendue.nQ});
							},
							model.zo),
						D$: $elm$core$Maybe$Nothing,
						D0: $elm$core$Maybe$Nothing,
						J8: false
					})));
	});
var $author$project$Components$Produits$Reference$Update$ouvrirLaVariante = F2(
	function (reprise, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{qx: $elm$core$Maybe$Nothing}),
			_List_fromArray(
				[
					$author$project$Components$Produits$Common$Effet$OuvrirLaReference(reprise.sl)
				]));
	});
var $author$project$Components$Produits$Reference$Update$perimetreCree = function (evenements) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filterMap,
			function (evenement) {
				if (evenement.$ === 38) {
					var id = evenement.a;
					return $elm$core$Maybe$Just(id);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			evenements));
};
var $author$project$Components$Produits$Reference$Model$CritereInconnu = {$: 3};
var $author$project$Components$Produits$Reference$Model$FiltreNonConvertible = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$Reference$Model$FiltreVide = {$: 1};
var $author$project$Components$Produits$Reference$Model$NomDejaPris = {$: 0};
var $author$project$Components$Produits$Reference$Update$refusDeCreation = function (erreur) {
	switch (erreur.$) {
		case 12:
			return $elm$core$Maybe$Just($author$project$Components$Produits$Reference$Model$NomDejaPris);
		case 13:
			return $elm$core$Maybe$Just($author$project$Components$Produits$Reference$Model$FiltreVide);
		case 14:
			var champ = erreur.a;
			return $elm$core$Maybe$Just(
				$author$project$Components$Produits$Reference$Model$FiltreNonConvertible(champ));
		case 15:
			return $elm$core$Maybe$Just($author$project$Components$Produits$Reference$Model$CritereInconnu);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$Reference$Fichiers$ChampNonFichier = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Produits$Reference$Fichiers$Indisponible = {$: 6};
var $author$project$Components$Produits$Reference$Fichiers$TypeRefuse = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Produits$Reference$Fichiers$refusDuRattachement = function (erreur) {
	switch (erreur.$) {
		case 56:
			var champ = erreur.a;
			return $elm$core$Maybe$Just(
				$author$project$Components$Produits$Reference$Fichiers$TypeRefuse(champ));
		case 57:
			var champ = erreur.a;
			return $elm$core$Maybe$Just(
				$author$project$Components$Produits$Reference$Fichiers$ChampNonFichier(champ));
		case 59:
			return $elm$core$Maybe$Just($author$project$Components$Produits$Reference$Fichiers$Indisponible);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$Reference$Update$refuserLOccurrence = F2(
	function (refus, model) {
		var sousChamp = function (refuse) {
			return A2(
				$elm$core$Maybe$withDefault,
				refuse.uN,
				$elm$core$List$head(
					$elm$core$List$reverse(
						A2($elm$core$String$split, '.', refuse.uN))));
		};
		return _Utils_update(
			model,
			{
				D$: A2(
					$elm$core$Maybe$map,
					$author$project$Components$Shared$EditeurDeSchema$Groupe$refuser(
						A2(
							$elm$core$List$map,
							function (refuse) {
								return {
									vx: refuse.vx,
									IW: sousChamp(refuse)
								};
							},
							refus)),
					model.D$)
			});
	});
var $author$project$Components$Produits$Reference$Model$prefixeDesChamps = 'caracteristique';
var $author$project$Components$Produits$Reference$Update$refuserLaSaisie = F2(
	function (refus, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					hP: A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$refuser, refus, model.hP)
				}),
			_Utils_ap(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (premier) {
							return _List_fromArray(
								[
									$author$project$Components$Produits$Common$Effet$PlacerFocus(
									A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$idDuChamp, $author$project$Components$Produits$Reference$Model$prefixeDesChamps, premier.uN))
								]);
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (refuse) {
									return !A2(
										$elm$core$List$member,
										refuse,
										A2($author$project$Components$Produits$Reference$Update$horsFiche, model, refus));
								},
								refus)))),
				$elm$core$List$isEmpty(
					A2($author$project$Components$Produits$Reference$Update$horsFiche, model, refus)) ? _List_Nil : $author$project$Components$Produits$Reference$Update$relire(model)));
	});
var $author$project$Components$Produits$Reference$Update$refuserLaValeurEnDouble = F2(
	function (refuse, model) {
		return _Utils_update(
			model,
			{
				D$: A2(
					$elm$core$Maybe$map,
					$author$project$Components$Shared$EditeurDeSchema$Groupe$refuser(
						_List_fromArray(
							[
								{vx: 'ValeurDeGroupeEnDouble', IW: refuse.IW}
							])),
					model.D$)
			});
	});
var $author$project$Components$Produits$Reference$Update$retourAuxArticles = function (model) {
	return A2(
		$author$project$Components$Produits$Reference$Update$basculer,
		$author$project$Components$Produits$Reference$Model$ModificationDesArticles,
		_Utils_update(
			model,
			{tP: $elm$core$Maybe$Nothing, fO: $elm$core$Maybe$Nothing, wl: $elm$core$Maybe$Nothing}));
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$valeurNonCreee = function (brouillon) {
	return _Utils_update(
		brouillon,
		{
			pZ: _List_fromArray(
				[
					{vx: 'ValeurNonCreee', IW: ''}
				])
		});
};
var $author$project$Components$Produits$Reference$Update$valeurNonCreee = function (model) {
	return _Utils_update(
		model,
		{
			D$: A2($elm$core$Maybe$map, $author$project$Components$Shared$EditeurDeSchema$Groupe$valeurNonCreee, model.D$),
			pZ: $elm$core$Maybe$Nothing
		});
};
var $author$project$Components$Produits$Reference$Update$conclure = F2(
	function (issue, model) {
		_v0$0:
		while (true) {
			_v0$24:
			while (true) {
				_v0$27:
				while (true) {
					switch (issue.$) {
						case 0:
							if (issue.c) {
								switch (issue.a.$) {
									case 36:
										break _v0$0;
									case 39:
										var _v1 = issue.a;
										var nom = _v1.a;
										var rendue = issue.b;
										var _v2 = _Utils_Tuple3(
											$author$project$Components$Produits$Reference$Update$perimetreCree(rendue.mk),
											model.uw,
											model.wl);
										if (((!_v2.a.$) && (!_v2.b.$)) && (!_v2.c.$)) {
											var id = _v2.a.a;
											var brouillon = _v2.b.a;
											var creation = _v2.c.a;
											return _Utils_Tuple2(
												$author$project$Components$Produits$Reference$Update$retourAuxArticles(
													_Utils_update(
														model,
														{
															uw: $elm$core$Maybe$Just(
																_Utils_update(
																	brouillon,
																	{
																		kk: $elm$core$Maybe$Just(
																			$elm$core$String$trim(nom)),
																		E9: $elm$core$Maybe$Just(
																			{
																				wp: _List_Nil,
																				wT: $elm$core$Maybe$Just(creation.wT),
																				Aq: id,
																				Dj: $elm$core$String$trim(nom)
																			}),
																		pZ: $elm$core$Maybe$Nothing
																	})),
															wl: $elm$core$Maybe$Nothing
														})),
												_List_Nil);
										} else {
											return _Utils_Tuple2(model, _List_Nil);
										}
									case 38:
										var _v4 = issue.a;
										var rendue = issue.b;
										return A2(
											$elm$core$Tuple$mapSecond,
											function (effets) {
												return _Utils_ap(
													effets,
													A2($author$project$Components$Produits$Reference$Update$relecture, rendue, model));
											},
											A2(
												$author$project$Components$Produits$Reference$Update$versLeDrawer,
												$author$project$Components$Shared$Drawer$Update$Fermer,
												_Utils_update(
													model,
													{
														zo: A2(
															$elm$core$Maybe$map,
															function (fiche) {
																return _Utils_update(
																	fiche,
																	{nQ: rendue.nQ});
															},
															model.zo),
														hP: $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$acceptee(model.hP)
													})));
									case 40:
										var _v5 = issue.a;
										var rendue = issue.b;
										return A2(
											$elm$core$Tuple$mapSecond,
											function (effets) {
												return _Utils_ap(
													effets,
													A2($author$project$Components$Produits$Reference$Update$relecture, rendue, model));
											},
											A2(
												$author$project$Components$Produits$Reference$Update$versLeDrawer,
												$author$project$Components$Shared$Drawer$Update$Fermer,
												_Utils_update(
													model,
													{
														zo: A2(
															$elm$core$Maybe$map,
															function (fiche) {
																return A2(
																	$author$project$Components$Produits$Common$Etat$apres,
																	rendue.mk,
																	_Utils_update(
																		fiche,
																		{nQ: rendue.nQ}));
															},
															model.zo)
													})));
									case 37:
										var rendue = issue.b;
										var creees = A2(
											$elm$core$List$filterMap,
											function (evenement) {
												if (evenement.$ === 37) {
													var id = evenement.a;
													return $elm$core$Maybe$Just(id);
												} else {
													return $elm$core$Maybe$Nothing;
												}
											},
											rendue.mk);
										var aReprendre = A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.zB;
												},
												model.zo));
										var _v6 = A2(
											$author$project$Components$Produits$Reference$Update$versLeDrawer,
											$author$project$Components$Shared$Drawer$Update$Fermer,
											_Utils_update(
												model,
												{
													sl: $author$project$Components$Produits$Reference$Model$varianteVide($elm$core$Maybe$Nothing)
												}));
										var ferme = _v6.a;
										var effets = _v6.b;
										var _v7 = _Utils_Tuple3(
											creees,
											A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rattacherUnFichierAUneReference, rendue.nQ),
											aReprendre);
										if ((_v7.a.b && (!_v7.b.$)) && _v7.c.b) {
											var _v8 = _v7.a;
											var id = _v8.a;
											var lien = _v7.b.a;
											var _v9 = _v7.c;
											return _Utils_Tuple2(
												_Utils_update(
													ferme,
													{
														qx: $elm$core$Maybe$Just(
															{nB: lien, HR: aReprendre, sl: id})
													}),
												effets);
										} else {
											return _Utils_Tuple2(
												ferme,
												_Utils_ap(
													effets,
													A2($elm$core$List$map, $author$project$Components$Produits$Common$Effet$OuvrirLaReference, creees)));
										}
									case 47:
										var _v11 = issue.a;
										var _v12 = model.qx;
										if (!_v12.$) {
											var reprise = _v12.a;
											return $elm$core$List$isEmpty(reprise.HR) ? A2($author$project$Components$Produits$Reference$Update$ouvrirLaVariante, reprise, model) : _Utils_Tuple2(model, _List_Nil);
										} else {
											return A2($author$project$Components$Produits$Reference$Update$conclureLeRattachement, issue, model);
										}
									case 43:
										var rendue = issue.b;
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{
													zo: A2(
														$elm$core$Maybe$map,
														function (fiche) {
															return _Utils_update(
																fiche,
																{tL: true, nQ: rendue.nQ});
														},
														model.zo)
												}),
											A2(
												$elm$core$List$cons,
												$author$project$Components$Produits$Common$Effet$PlacerFocus($author$project$Components$Produits$Reference$Model$idDeLaSection),
												A2($author$project$Components$Produits$Reference$Update$relecture, rendue, model)));
									case 49:
										var _v13 = issue.a;
										var rendue = issue.b;
										return A2($author$project$Components$Produits$Reference$Update$occurrenceFaite, rendue, model);
									case 50:
										var _v14 = issue.a;
										var rendue = issue.b;
										return A2($author$project$Components$Produits$Reference$Update$occurrenceFaite, rendue, model);
									case 51:
										var _v15 = issue.a;
										var rendue = issue.b;
										return A2($author$project$Components$Produits$Reference$Update$occurrenceFaite, rendue, model);
									case 44:
										var _v16 = issue.a;
										var rendue = issue.b;
										return A2(
											$elm$core$Tuple$mapSecond,
											function (effets) {
												return _Utils_ap(
													effets,
													A2($author$project$Components$Produits$Reference$Update$relecture, rendue, model));
											},
											A2(
												$author$project$Components$Produits$Reference$Update$versLeDrawer,
												$author$project$Components$Shared$Drawer$Update$Fermer,
												_Utils_update(
													model,
													{tq: $elm$core$Maybe$Nothing})));
									case 41:
										var _v17 = issue.a;
										var rendue = issue.b;
										return A2(
											$elm$core$Tuple$mapSecond,
											function (effets) {
												return _Utils_ap(
													effets,
													A2($author$project$Components$Produits$Reference$Update$relecture, rendue, model));
											},
											A2(
												$author$project$Components$Produits$Reference$Update$versLeDrawer,
												$author$project$Components$Shared$Drawer$Update$Fermer,
												_Utils_update(
													model,
													{iV: $elm$core$Maybe$Nothing})));
									default:
										var rendue = issue.b;
										return _Utils_Tuple2(
											model,
											A2($author$project$Components$Produits$Reference$Update$relecture, rendue, model));
								}
							} else {
								if (issue.a.$ === 36) {
									break _v0$0;
								} else {
									return _Utils_Tuple2(
										model,
										$author$project$Components$Produits$Reference$Update$relire(model));
								}
							}
						case 1:
							switch (issue.a.$) {
								case 36:
									return A2($author$project$Components$Produits$Reference$Update$concluLArchivageDuProduit, issue, model);
								case 39:
									var _v3 = issue.a;
									var erreur = issue.c;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												wl: A2(
													$elm$core$Maybe$map,
													function (creation) {
														return _Utils_update(
															creation,
															{
																pZ: $author$project$Components$Produits$Reference$Update$refusDeCreation(erreur)
															});
													},
													model.wl)
											}),
										_List_Nil);
								case 50:
									switch (issue.c.$) {
										case 39:
											var _v21 = issue.a;
											return _Utils_Tuple2(
												$author$project$Components$Produits$Reference$Update$valeurNonCreee(model),
												_List_Nil);
										case 38:
											var _v23 = issue.a;
											var refuse = issue.c.a;
											return _Utils_Tuple2(
												A2($author$project$Components$Produits$Reference$Update$refuserLaValeurEnDouble, refuse, model),
												_List_Nil);
										case 36:
											var _v19 = issue.a;
											var refus = issue.c.a;
											return _Utils_Tuple2(
												A2($author$project$Components$Produits$Reference$Update$refuserLOccurrence, refus, model),
												_List_Nil);
										default:
											break _v0$27;
									}
								case 49:
									switch (issue.c.$) {
										case 39:
											var _v20 = issue.a;
											return _Utils_Tuple2(
												$author$project$Components$Produits$Reference$Update$valeurNonCreee(model),
												_List_Nil);
										case 38:
											var _v22 = issue.a;
											var refuse = issue.c.a;
											return _Utils_Tuple2(
												A2($author$project$Components$Produits$Reference$Update$refuserLaValeurEnDouble, refuse, model),
												_List_Nil);
										case 37:
											var _v24 = issue.a;
											return _Utils_Tuple2(
												_Utils_update(
													model,
													{pZ: $elm$core$Maybe$Nothing, J8: true}),
												_List_Nil);
										case 36:
											var _v18 = issue.a;
											var refus = issue.c.a;
											return _Utils_Tuple2(
												A2($author$project$Components$Produits$Reference$Update$refuserLOccurrence, refus, model),
												_List_Nil);
										default:
											break _v0$27;
									}
								case 38:
									if (issue.c.$ === 36) {
										var _v25 = issue.a;
										var refus = issue.c.a;
										return _Utils_eq(model.mW, $author$project$Components$Produits$Reference$Model$ModificationDesArticles) ? _Utils_Tuple2(
											_Utils_update(
												model,
												{
													uw: A2(
														$elm$core$Maybe$map,
														function (brouillon) {
															return _Utils_update(
																brouillon,
																{
																	pZ: A2(
																		$elm$core$Maybe$map,
																		function ($) {
																			return $.vx;
																		},
																		$elm$core$List$head(refus))
																});
														},
														model.uw)
												}),
											_List_Nil) : A2($author$project$Components$Produits$Reference$Update$refuserLaSaisie, refus, model);
									} else {
										break _v0$27;
									}
								case 47:
									if (issue.c.$ === 36) {
										break _v0$24;
									} else {
										var _v26 = issue.a;
										var erreur = issue.c;
										var _v27 = model.qx;
										if (!_v27.$) {
											var reprise = _v27.a;
											return A2($author$project$Components$Produits$Reference$Update$ouvrirLaVariante, reprise, model);
										} else {
											var _v28 = $author$project$Components$Produits$Reference$Fichiers$refusDuRattachement(erreur);
											if (!_v28.$) {
												var refus = _v28.a;
												return A2($author$project$Components$Produits$Reference$Update$refuserLeDepot, refus, model);
											} else {
												return _Utils_Tuple2(model, _List_Nil);
											}
										}
									}
								case 37:
									switch (issue.c.$) {
										case 36:
											break _v0$24;
										case 31:
											var marque = issue.c.a;
											var variante = model.sl;
											return _Utils_Tuple2(
												_Utils_update(
													model,
													{
														sl: _Utils_update(
															variante,
															{
																fR: A2(
																	$elm$core$Maybe$map,
																	A2($author$project$Components$Produits$Reference$Model$codePris, variante.vx, marque),
																	model.zo)
															})
													}),
												_List_fromArray(
													[
														$author$project$Components$Produits$Common$Effet$PlacerFocus(
														A2(
															$author$project$Components$Produits$Reference$Model$idDeVariante,
															$author$project$Components$Shared$Drawer$Model$idRacine(model.kX),
															0))
													]));
										default:
											break _v0$27;
									}
								default:
									if (issue.c.$ === 36) {
										break _v0$24;
									} else {
										break _v0$27;
									}
							}
						default:
							return _Utils_Tuple2(model, _List_Nil);
					}
				}
				var refus = issue.b;
				var erreur = issue.c;
				return _Utils_Tuple2(
					$author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) ? _Utils_update(
						model,
						{
							pZ: $elm$core$Maybe$Just(
								A3($author$project$Components$Produits$Reference$Update$message, model, refus, erreur))
						}) : model,
					$author$project$Components$Produits$Reference$Update$perime(erreur) ? $author$project$Components$Produits$Reference$Update$relire(model) : _List_Nil);
			}
			var refus = issue.c.a;
			return A2($author$project$Components$Produits$Reference$Update$refuserLaSaisie, refus, model);
		}
		return A2($author$project$Components$Produits$Reference$Update$concluLArchivageDuProduit, issue, model);
	});
var $author$project$API$NavLinksDictionary$definirLImage = 'definir-l-image';
var $author$project$Components$Produits$Reference$Image$DansLaFiche = 1;
var $author$project$Components$Produits$Reference$Fichiers$champsFichier = function (champs) {
	return A2(
		$elm$core$List$filterMap,
		function (champ) {
			var _v0 = champ.r0;
			if (_v0.$ === 9) {
				var propre = _v0.a;
				return $elm$core$Maybe$Just(
					{dy: champ.dy, Bl: champ.Bl, r1: propre.r1});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		champs);
};
var $author$project$Components$Produits$Reference$Fichiers$fichierDuChamp = F2(
	function (fiche, champ) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.uN;
					},
					$elm$core$Basics$eq(champ)),
				fiche.zB));
	});
var $author$project$Components$Produits$Reference$Image$imagesDeLaFiche = F2(
	function (champs, fiche) {
		return A2(
			$elm$core$List$filterMap,
			function (lu) {
				return A2(
					$elm$core$Maybe$map,
					function (porte) {
						return {uN: lu.dy, gw: porte.gw, Bl: lu.Bl};
					},
					A2($author$project$Components$Produits$Reference$Fichiers$fichierDuChamp, fiche, lu.dy));
			},
			A2(
				$elm$core$List$filter,
				function (lu) {
					return (!$elm$core$List$isEmpty(lu.r1)) && A2(
						$elm$core$List$all,
						$elm$core$String$startsWith('image/'),
						lu.r1);
				},
				$author$project$Components$Produits$Reference$Fichiers$champsFichier(champs)));
	});
var $author$project$Components$Produits$Reference$Image$Televerser = 0;
var $author$project$Components$Produits$Reference$Image$nouvelle = {uN: $elm$core$Maybe$Nothing, vd: $elm$core$Maybe$Nothing, kC: $elm$core$Maybe$Nothing, me: 0, o4: 0, eH: $elm$core$Maybe$Nothing, pA: $elm$core$Maybe$Nothing, pD: 0, pZ: $elm$core$Maybe$Nothing};
var $author$project$Components$Produits$Reference$Update$definitionInitiale = function (model) {
	var deLaFiche = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (fiche) {
				return A2(
					$author$project$Components$Produits$Reference$Image$imagesDeLaFiche,
					$author$project$Components$Produits$Reference$Model$champs(fiche),
					fiche);
			},
			model.zo));
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		function ($) {
			return $.IR;
		},
		model.af);
	if ((!_v0.$) && (_v0.a.$ === 1)) {
		var _v1 = _v0.a;
		var cle = _v1.a;
		if (A2(
			$elm$core$List$any,
			function (image) {
				return _Utils_eq(image.uN, cle);
			},
			deLaFiche)) {
			var vide = $author$project$Components$Produits$Reference$Image$nouvelle;
			return _Utils_update(
				vide,
				{
					uN: $elm$core$Maybe$Just(cle),
					o4: 1
				});
		} else {
			return $author$project$Components$Produits$Reference$Image$nouvelle;
		}
	} else {
		return $author$project$Components$Produits$Reference$Image$nouvelle;
	}
};
var $author$project$Components$Produits$Reference$Model$idDeLImage = 'reference-image-definir';
var $author$project$Components$Produits$Reference$Update$ouvrir = F3(
	function (declencheur, geste, model) {
		var drawer = model.kX;
		return A2(
			$author$project$Components$Produits$Reference$Update$versLeDrawer,
			$author$project$Components$Shared$Drawer$Update$Ouvrir(declencheur),
			_Utils_update(
				model,
				{
					kX: _Utils_update(
						drawer,
						{
							Dj: $author$project$Components$Produits$Reference$Model$nomDuDrawer(geste)
						}),
					mW: geste,
					pZ: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Components$Produits$Reference$Update$definirLImage = function (model) {
	var _v0 = _Utils_Tuple2(
		model.zo,
		A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.h0;
					},
					$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$definirLImage))),
			model.af));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Basics$append(
				_List_fromArray(
					[$author$project$Components$Produits$Common$Effet$DemanderProcessUid, $author$project$Components$Produits$Common$Effet$DemanderProcessUid])),
			A3(
				$author$project$Components$Produits$Reference$Update$ouvrir,
				$author$project$Components$Produits$Reference$Model$idDeLImage,
				$author$project$Components$Produits$Reference$Model$DefinitionDeLImage,
				_Utils_update(
					model,
					{
						wZ: $elm$core$Maybe$Just(
							$author$project$Components$Produits$Reference$Update$definitionInitiale(model))
					})));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$Reference$Model$DepotDeFichier = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Produits$Reference$Model$depotPossible = F3(
	function (model, fiche, champ) {
		return (!_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rattacherUnFichierAUneReference, fiche.nQ),
			$elm$core$Maybe$Nothing)) && ((!_Utils_eq(model.d9.kI, $elm$core$Maybe$Nothing)) && ((!_Utils_eq(model.d9.ol, $elm$core$Maybe$Nothing)) && A2(
			$elm$core$List$member,
			champ,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.dy;
				},
				$author$project$Components$Produits$Reference$Fichiers$champsFichier(
					$author$project$Components$Produits$Reference$Model$champs(fiche))))));
	});
var $author$project$Components$Produits$Reference$Model$idDuDepot = 'reference-fichier-depot';
var $author$project$Components$Produits$Reference$Fichiers$nouveau = F2(
	function (champ, remplace) {
		return {uN: champ, vd: $elm$core$Maybe$Nothing, me: $author$project$Components$Produits$Reference$Fichiers$Saisie, Gn: $elm$core$Maybe$Nothing, pZ: $elm$core$Maybe$Nothing, Hz: remplace, rF: _List_Nil};
	});
var $author$project$Components$Produits$Reference$Update$demanderLeDepot = F2(
	function (champ, model) {
		var _v0 = model.zo;
		if (!_v0.$) {
			var fiche = _v0.a;
			return A3($author$project$Components$Produits$Reference$Model$depotPossible, model, fiche, champ) ? A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Basics$append(
					_List_fromArray(
						[$author$project$Components$Produits$Common$Effet$DemanderProcessUid])),
				A3(
					$author$project$Components$Produits$Reference$Update$ouvrir,
					$author$project$Components$Produits$Reference$Model$idDuDepot,
					$author$project$Components$Produits$Reference$Model$DepotDeFichier(champ),
					_Utils_update(
						model,
						{
							xc: $elm$core$Maybe$Just(
								A2(
									$author$project$Components$Produits$Reference$Fichiers$nouveau,
									champ,
									!_Utils_eq(
										A2($author$project$Components$Produits$Reference$Fichiers$fichierDuChamp, fiche, champ),
										$elm$core$Maybe$Nothing)))
						}))) : _Utils_Tuple2(model, _List_Nil);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$demanderUnDepot = 'demander-un-depot';
var $author$project$API$NavLinksDictionary$deposerUnFichier = 'deposer-un-fichier';
var $author$project$Components$Produits$Reference$API$QueryAPIModel$documentsDecoder = $elm$json$Json$Decode$list(
	A4(
		$elm$json$Json$Decode$map3,
		F3(
			function (champ, fichier, adresse) {
				return {aa: adresse, uN: champ, gw: fichier};
			}),
		A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'fichier', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'adresse', $elm$json$Json$Decode$string)));
var $author$project$Components$Produits$Reference$Model$commandeDeSaisie = F2(
	function (model, fiche) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierLesAttributsDUneReference, fiche.nQ),
			A2(
				$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$modifications,
				$author$project$Components$Produits$Reference$Model$champs(fiche),
				model.hP));
		if ((!_v0.a.$) && _v0.b.b) {
			var lien = _v0.a.a;
			var _v1 = _v0.b;
			var premiere = _v1.a;
			var suite = _v1.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					A2(
						$author$project$Catalogue$API$WriteAPIModel$ModifierLesAttributsDUneReference,
						fiche.Aq,
						A2($elm$core$List$cons, premiere, suite)),
					lien));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$Reference$Update$enregistrer = function (model) {
	var _v0 = model.zo;
	if (!_v0.$) {
		var fiche = _v0.a;
		if (_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierLesAttributsDUneReference, fiche.nQ),
			$elm$core$Maybe$Nothing)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v1 = A2(
				$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$fautes,
				$author$project$Components$Produits$Reference$Model$champs(fiche),
				model.hP);
			if (_v1.b) {
				var fautif = _v1.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hP: $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$tenter(model.hP)
						}),
					_List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$PlacerFocus(
							A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$idDuChamp, $author$project$Components$Produits$Reference$Model$prefixeDesChamps, fautif))
						]));
			} else {
				var _v2 = A2(
					$elm$core$Maybe$andThen,
					function (_v3) {
						var commande = _v3.a;
						var lien = _v3.b;
						return A3(
							$author$project$Components$Produits$Common$Envoi$partir,
							$elm$core$Maybe$Just(lien),
							commande,
							model.l2);
					},
					A2($author$project$Components$Produits$Reference$Model$commandeDeSaisie, model, fiche));
				if (!_v2.$) {
					var _v4 = _v2.a;
					var envoi = _v4.a;
					var effets = _v4.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l2: envoi,
								hP: A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$refuser, _List_Nil, model.hP)
							}),
						effets);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			}
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$Reference$Update$envoyerLeCalcul = F2(
	function (commande, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (_v1) {
				var c = _v1.a;
				var lien = _v1.b;
				return A3(
					$author$project$Components$Produits$Common$Envoi$partir,
					$elm$core$Maybe$Just(lien),
					c,
					model.l2);
			},
			commande);
		if (!_v0.$) {
			var _v2 = _v0.a;
			var envoi = _v2.a;
			var effets = _v2.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi, pZ: $elm$core$Maybe$Nothing}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$Reference$Image$formatsAcceptes = _List_fromArray(
	['image/jpeg', 'image/png', 'image/webp']);
var $author$project$Components$Produits$Reference$Model$idDeLArret = 'reference-arreter';
var $author$project$Components$Produits$Reference$Model$idDeLEtat = 'reference-changer-l-etat';
var $author$project$Components$Produits$Reference$Model$idDeLHistorique = 'reference-historique';
var $author$project$Components$Produits$Reference$Model$idDeLaDuplication = 'reference-dupliquer';
var $author$project$Components$Produits$Reference$Model$idDeLaModification = 'reference-modifier';
var $author$project$Components$Produits$Reference$Model$idDuChoixDUtilisateur = 'reference-choisir-utilisateur';
var $author$project$Components$Produits$Reference$Model$idDuCode = 'reference-changer-le-code';
var $author$project$Components$Produits$Reference$Model$idDuNomDePerimetre = 'nom-du-perimetre';
var $author$project$Components$Produits$Reference$Model$idDuProduit = 'reference-produit';
var $author$project$Components$Produits$Reference$Model$idDuRecalcul = function (cle) {
	return 'recalculer-' + cle;
};
var $author$project$Components$Produits$Common$ChoixDArticles$idDuRetrait = 'article-a-retirer';
var $author$project$Components$Produits$Reference$Model$idsDeLArret = $author$project$Components$Shared$Confirmation$Clavier$ids('arret');
var $author$project$Components$Produits$Reference$Model$idsDuRetrait = $author$project$Components$Shared$Confirmation$Clavier$ids('reference-fichier-retrait');
var $author$project$Components$Produits$Reference$Image$Demandee = 1;
var $author$project$Components$Produits$Common$Effet$EnvoyerUneCommandeDImage = F3(
	function (a, b, c) {
		return {$: 46, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$Reference$Image$typeDuBack = function (media) {
	switch (media) {
		case 'image/jpeg':
			return 'Jpeg';
		case 'image/png':
			return 'Png';
		default:
			return 'Webp';
	}
};
var $author$project$Components$Produits$Reference$Image$commandeDemander = F2(
	function (uid, choisi) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$elm$json$Json$Encode$string(
						$author$project$API$ProcessUid$toString(uid))),
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string(
						$author$project$Components$Produits$Reference$Image$typeDuBack(choisi.Ck))),
					_Utils_Tuple2(
					'taille',
					$elm$json$Json$Encode$int(choisi.Jm))
				]));
	});
var $author$project$Components$Produits$Reference$Update$demanderLeDepotDeLImage = function (model) {
	var _v0 = model.wZ;
	if (!_v0.$) {
		var definition = _v0.a;
		var choisi = definition.vd;
		var processUidDuDepot = definition.pA;
		var etape = definition.me;
		var refus = definition.pZ;
		var demande = definition.kC;
		var _v1 = _Utils_Tuple3(choisi, processUidDuDepot, model.d9.kE);
		if (((!_v1.a.$) && (!_v1.b.$)) && (!_v1.c.$)) {
			var fichier = _v1.a.a;
			var uid = _v1.b.a;
			var lien = _v1.c.a;
			return ((!etape) && (_Utils_eq(refus, $elm$core$Maybe$Nothing) && _Utils_eq(demande, $elm$core$Maybe$Nothing))) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{
						wZ: $elm$core$Maybe$Just(
							_Utils_update(
								definition,
								{me: 1}))
					}),
				_List_fromArray(
					[
						A3(
						$author$project$Components$Produits$Common$Effet$EnvoyerUneCommandeDImage,
						'demander',
						lien,
						A2($author$project$Components$Produits$Reference$Image$commandeDemander, uid, fichier))
					])) : _Utils_Tuple2(model, _List_Nil);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$Reference$Image$FormatNonAccepte = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$Reference$Image$TropLourd = function (a) {
	return {$: 1, a: a};
};
var $elm$core$String$toUpper = _String_toUpper;
var $author$project$Components$Produits$Reference$Fichiers$formatDuType = function (media) {
	var _v0 = A2($elm$core$String$split, '/', media);
	if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
		var _v1 = _v0.b;
		var sousType = _v1.a;
		return $elm$core$String$toUpper(sousType);
	} else {
		return $elm$core$String$toUpper(media);
	}
};
var $author$project$Components$Produits$Reference$Image$verifier = F2(
	function (maximum, choisi) {
		if (!A2($elm$core$List$member, choisi.Ck, $author$project$Components$Produits$Reference$Image$formatsAcceptes)) {
			return $elm$core$Maybe$Just(
				$author$project$Components$Produits$Reference$Image$FormatNonAccepte(
					{
						zP: $author$project$Components$Produits$Reference$Fichiers$formatDuType(choisi.Ck),
						Dj: choisi.Dj
					}));
		} else {
			if (!maximum.$) {
				var limite = maximum.a;
				return (_Utils_cmp(choisi.Jm, limite) > 0) ? $elm$core$Maybe$Just(
					$author$project$Components$Produits$Reference$Image$TropLourd(
						{Cj: limite, Dj: choisi.Dj, FV: choisi.Jm})) : $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$Components$Produits$Reference$Update$imageChoisie = F2(
	function (choisi, model) {
		var _v0 = model.wZ;
		if (!_v0.$) {
			var definition = _v0.a;
			return $author$project$Components$Produits$Reference$Update$demanderLeDepotDeLImage(
				_Utils_update(
					model,
					{
						wZ: $elm$core$Maybe$Just(
							_Utils_update(
								definition,
								{
									vd: $elm$core$Maybe$Just(choisi),
									kC: $elm$core$Maybe$Nothing,
									me: 0,
									pZ: A2($author$project$Components$Produits$Reference$Image$verifier, $elm$core$Maybe$Nothing, choisi)
								}))
					}));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$imageDePresentation = 'image-de-presentation';
var $author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$EnPreparation = {$: 1};
var $author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$ImageDePresentation = F3(
	function (etat, source, liens) {
		return {gt: etat, nQ: liens, IR: source};
	});
var $author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$Aucune = {$: 0};
var $author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$ChampRetire = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$NonUtilisable = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$Prete = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$DimensionsHorsPlafond = 2;
var $author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$FichierRejete = 0;
var $author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$Illisible = 1;
var $author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$motifDecoder = function (motif) {
	switch (motif) {
		case 'fichier-rejete':
			return $elm$json$Json$Decode$succeed(0);
		case 'illisible':
			return $elm$json$Json$Decode$succeed(1);
		case 'dimensions-hors-plafond':
			return $elm$json$Json$Decode$succeed(2);
		default:
			var inconnu = motif;
			return $elm$json$Json$Decode$fail(inconnu);
	}
};
var $author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$etatDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (etat) {
		switch (etat) {
			case 'aucune':
				return $elm$json$Json$Decode$succeed($author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$Aucune);
			case 'enPreparation':
				return $elm$json$Json$Decode$succeed($author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$EnPreparation);
			case 'prete':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$Prete,
					A2($elm$json$Json$Decode$field, 'vignette', $elm$json$Json$Decode$string));
			case 'nonUtilisable':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$NonUtilisable,
					A2(
						$elm$json$Json$Decode$andThen,
						$author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$motifDecoder,
						A2($elm$json$Json$Decode$field, 'motif', $elm$json$Json$Decode$string)));
			case 'champRetire':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$ChampRetire,
					A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string));
			default:
				var inconnu = etat;
				return $elm$json$Json$Decode$fail(inconnu);
		}
	},
	A2($elm$json$Json$Decode$field, 'etat', $elm$json$Json$Decode$string));
var $author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$Deposee = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$DuChamp = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$sourceDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (source) {
		_v0$2:
		while (true) {
			if (!source.$) {
				switch (source.a) {
					case 'deposee':
						return A2(
							$elm$json$Json$Decode$map,
							A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$Deposee),
							$elm$json$Json$Decode$maybe(
								A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string)));
					case 'champ':
						return A3(
							$elm$json$Json$Decode$map2,
							F2(
								function (champ, nom) {
									return $elm$core$Maybe$Just(
										A2($author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$DuChamp, champ, nom));
								}),
							A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
							$elm$json$Json$Decode$maybe(
								A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string)));
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
	},
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'source', $elm$json$Json$Decode$string)));
var $author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$API$Liens$deLaRessource,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$sourceDecoder,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			$author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$etatDecoder,
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$ImageDePresentation))));
var $author$project$Components$Produits$Reference$Update$imageLue = F2(
	function (reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$decoder, reponse);
		if (!_v0.$) {
			var image = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						af: $elm$core$Maybe$Just(image)
					}),
				_Utils_eq(image.gt, $author$project$Components$Produits$Common$API$ImageDePresentationQueryAPIModel$EnPreparation) ? _List_fromArray(
					[
						$author$project$Components$Produits$Common$Effet$AttendreAvantDeRelire($author$project$Components$Produits$Common$Envoi$delaiDeRelectureMs)
					]) : _List_Nil);
		} else {
			var refus = _v0.a;
			return _Utils_Tuple2(
				model,
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Produits$Reference$Image$Declaration = 3;
var $author$project$Components$Produits$Reference$Image$Interrompu = 5;
var $author$project$Components$Produits$Reference$Image$commandeDeclarer = F2(
	function (uid, nom) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$elm$json$Json$Encode$string(
						$author$project$API$ProcessUid$toString(uid))),
					_Utils_Tuple2(
					'nom',
					$elm$json$Json$Encode$string(nom))
				]));
	});
var $author$project$Components$Produits$Reference$Update$imagePosee = F2(
	function (reponse, model) {
		var _v0 = model.wZ;
		if (!_v0.$) {
			var definition = _v0.a;
			var _v1 = _Utils_Tuple3(
				(reponse.ri >= 200) && (reponse.ri < 300),
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.wO;
					},
					definition.kC),
				definition.pA);
			if ((_v1.a && (!_v1.b.$)) && (!_v1.c.$)) {
				var lien = _v1.b.a;
				var uid = _v1.c.a;
				var nom = A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.Dj;
						},
						definition.vd));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							wZ: $elm$core$Maybe$Just(
								_Utils_update(
									definition,
									{me: 3}))
						}),
					_List_fromArray(
						[
							A3(
							$author$project$Components$Produits$Common$Effet$EnvoyerUneCommandeDImage,
							'declarer',
							lien,
							A2($author$project$Components$Produits$Reference$Image$commandeDeclarer, uid, nom))
						]));
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							wZ: $elm$core$Maybe$Just(
								_Utils_update(
									definition,
									{me: 5}))
						}),
					_List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$Reference$Image$EnvoiEnCours = 2;
var $author$project$Components$Produits$Reference$Update$imageProgresse = F2(
	function (pourcent, model) {
		var _v0 = model.wZ;
		if (!_v0.$) {
			var definition = _v0.a;
			return ((definition.me === 2) && (pourcent >= 0)) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{
						wZ: $elm$core$Maybe$Just(
							_Utils_update(
								definition,
								{
									pD: A2($elm$core$Basics$min, 100, pourcent)
								}))
					}),
				_List_Nil) : _Utils_Tuple2(model, _List_Nil);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$Common$Effet$PoserSurLAdresse = F4(
	function (a, b, c, d) {
		return {$: 47, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Produits$Reference$Image$Recu = 4;
var $author$project$Components$Produits$Reference$Image$RefusDuServeur = {$: 2};
var $author$project$Components$Produits$Reference$Update$lireLImage = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$LireLImage, $elm$core$List$singleton),
			A2(
				$elm$core$Maybe$andThen,
				function (fiche) {
					return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$imageDePresentation, fiche.nQ);
				},
				model.zo)));
};
var $author$project$Components$Produits$Reference$Update$apresLeRetraitDeLImage = F2(
	function (reponse, model) {
		if ((reponse.ri >= 200) && (reponse.ri < 300)) {
			var _v0 = A2(
				$author$project$Components$Produits$Reference$Update$versLeDrawer,
				$author$project$Components$Shared$Drawer$Update$Fermer,
				_Utils_update(
					model,
					{wZ: $elm$core$Maybe$Nothing}));
			var ferme = _v0.a;
			var effets = _v0.b;
			return _Utils_Tuple2(
				ferme,
				_Utils_ap(
					effets,
					$author$project$Components$Produits$Reference$Update$lireLImage(model)));
		} else {
			return _Utils_Tuple2(
				model,
				(reponse.ri === 401) ? _List_fromArray(
					[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Produits$Reference$Image$Demande = F6(
	function (identifiant, adresse, methode, typeDeContenu, tailleMaximale, declarer) {
		return {aa: adresse, wO: declarer, Au: identifiant, Cv: methode, Jn: tailleMaximale, JS: typeDeContenu};
	});
var $author$project$API$NavLinksDictionary$declarerLeDepot = 'declarer-le-depot';
var $author$project$Components$Produits$Reference$Image$demandeDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function (liens) {
			return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$declarerLeDepot, liens.h0);
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'tailleMaximale',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'typeDeContenu',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'methode',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'adresse',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'identifiant',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$Image$Demande)))))));
var $author$project$Components$Produits$Reference$Image$limiteDuRefus = function (reponse) {
	return $elm$core$Result$toMaybe(
		A2(
			$elm$json$Json$Decode$decodeString,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['error', 'DepotTropGros', 'tailleMaximale']),
				$elm$json$Json$Decode$int),
			reponse.f$));
};
var $author$project$Components$Produits$Reference$Image$refusDeLaCommande = F2(
	function (choisi, reponse) {
		return A2(
			$elm$core$Result$withDefault,
			$author$project$Components$Produits$Reference$Image$RefusDuServeur,
			A2(
				$elm$json$Json$Decode$decodeString,
				A2(
					$elm$json$Json$Decode$field,
					'error',
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$json$Json$Decode$map,
								function (media) {
									return $author$project$Components$Produits$Reference$Image$FormatNonAccepte(
										{
											zP: $author$project$Components$Produits$Reference$Fichiers$formatDuType(media),
											Dj: choisi.Dj
										});
								},
								A2(
									$elm$json$Json$Decode$at,
									_List_fromArray(
										['FormatNonAccepte', 'type_']),
									$elm$json$Json$Decode$string)),
								A2(
								$elm$json$Json$Decode$map,
								function (_v0) {
									var poids = _v0.a;
									var maximum = _v0.b;
									return $author$project$Components$Produits$Reference$Image$TropLourd(
										{Cj: maximum, Dj: choisi.Dj, FV: poids});
								},
								A2(
									$elm$json$Json$Decode$at,
									_List_fromArray(
										['TropLourde']),
									A3(
										$elm$json$Json$Decode$map2,
										$elm$core$Tuple$pair,
										A2($elm$json$Json$Decode$field, 'taille', $elm$json$Json$Decode$int),
										A2($elm$json$Json$Decode$field, 'maximum', $elm$json$Json$Decode$int))))
							]))),
				reponse.f$));
	});
var $author$project$Components$Produits$Reference$Image$tailleAnnoncee = 10485760;
var $author$project$Components$Produits$Reference$Update$imageRepondue = F3(
	function (nom, reponse, model) {
		var _v0 = model.wZ;
		if (_v0.$ === 1) {
			return (nom === 'retirer') ? A2($author$project$Components$Produits$Reference$Update$apresLeRetraitDeLImage, reponse, model) : _Utils_Tuple2(model, _List_Nil);
		} else {
			var definition = _v0.a;
			var reussie = (reponse.ri >= 200) && (reponse.ri < 300);
			if (reponse.ri === 401) {
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[$author$project$Components$Produits$Common$Effet$Reconnecter]));
			} else {
				switch (nom) {
					case 'demander':
						var _v2 = _Utils_Tuple3(
							reussie,
							A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Reference$Image$demandeDecoder, reponse),
							definition.vd);
						_v2$2:
						while (true) {
							if (_v2.a) {
								if ((!_v2.b.$) && (!_v2.c.$)) {
									var demande = _v2.b.a;
									var choisi = _v2.c.a;
									var _v3 = A2(
										$author$project$Components$Produits$Reference$Image$verifier,
										$elm$core$Maybe$Just(demande.Jn),
										choisi);
									if (!_v3.$) {
										var refus = _v3.a;
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{
													wZ: $elm$core$Maybe$Just(
														_Utils_update(
															definition,
															{
																me: 0,
																pZ: $elm$core$Maybe$Just(refus)
															}))
												}),
											_List_Nil);
									} else {
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{
													wZ: $elm$core$Maybe$Just(
														_Utils_update(
															definition,
															{
																kC: $elm$core$Maybe$Just(demande),
																me: 2,
																pD: 0
															}))
												}),
											_List_fromArray(
												[
													A4($author$project$Components$Produits$Common$Effet$PoserSurLAdresse, demande.Cv, demande.aa, demande.JS, choisi.oW)
												]));
									}
								} else {
									break _v2$2;
								}
							} else {
								if (!_v2.c.$) {
									var choisi = _v2.c.a;
									return (reponse.ri === 413) ? _Utils_Tuple2(
										_Utils_update(
											model,
											{
												wZ: $elm$core$Maybe$Just(
													_Utils_update(
														definition,
														{
															me: 0,
															pZ: $elm$core$Maybe$Just(
																$author$project$Components$Produits$Reference$Image$TropLourd(
																	{
																		Cj: A2(
																			$elm$core$Maybe$withDefault,
																			$author$project$Components$Produits$Reference$Image$tailleAnnoncee,
																			$author$project$Components$Produits$Reference$Image$limiteDuRefus(reponse)),
																		Dj: choisi.Dj,
																		FV: choisi.Jm
																	}))
														}))
											}),
										_List_Nil) : _Utils_Tuple2(
										_Utils_update(
											model,
											{
												wZ: $elm$core$Maybe$Just(
													_Utils_update(
														definition,
														{me: 5}))
											}),
										_List_Nil);
								} else {
									break _v2$2;
								}
							}
						}
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									wZ: $elm$core$Maybe$Just(
										_Utils_update(
											definition,
											{me: 5}))
								}),
							_List_Nil);
					case 'declarer':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									wZ: $elm$core$Maybe$Just(
										_Utils_update(
											definition,
											{
												me: reussie ? 4 : 5
											}))
								}),
							_List_Nil);
					case 'retirer':
						return A2($author$project$Components$Produits$Reference$Update$apresLeRetraitDeLImage, reponse, model);
					default:
						return reussie ? A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(
								$author$project$Components$Produits$Reference$Update$lireLImage(model)),
							function (_v4) {
								var fermee = _v4.a;
								var effets = _v4.b;
								return A2(
									$elm$core$Tuple$mapSecond,
									$elm$core$Basics$append(effets),
									A2($author$project$Components$Produits$Reference$Update$versLeDrawer, $author$project$Components$Shared$Drawer$Update$Fermer, fermee));
							}(
								_Utils_Tuple2(
									_Utils_update(
										model,
										{wZ: $elm$core$Maybe$Nothing}),
									_List_Nil))) : _Utils_Tuple2(
							_Utils_update(
								model,
								{
									wZ: $elm$core$Maybe$Just(
										_Utils_update(
											definition,
											{
												me: (!definition.o4) ? 4 : 0,
												pZ: $elm$core$Maybe$Just(
													A2(
														$elm$core$Maybe$withDefault,
														$author$project$Components$Produits$Reference$Image$RefusDuServeur,
														A2(
															$elm$core$Maybe$map,
															function (choisi) {
																return A2($author$project$Components$Produits$Reference$Image$refusDeLaCommande, choisi, reponse);
															},
															definition.vd)))
											}))
								}),
							_List_Nil);
				}
			}
		}
	});
var $author$project$Components$Produits$Reference$Update$libelleDeLEtage = F3(
	function (_v0, catalogue, id) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Traductions$tel(
				$author$project$Catalogue$Identifiants$niveauIdToString(id)),
			A2(
				$elm$core$Maybe$map,
				$author$project$Catalogue$Niveau$libelleDuNiveau,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(id)),
						catalogue.C9))));
	});
var $author$project$Components$Produits$Reference$Model$lienDeDuplication = function (fiche) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUneReference, fiche.nQ);
};
var $author$project$API$NavLinksDictionary$apercuDuRecalcul = 'apercu-du-recalcul';
var $author$project$Components$Produits$Reference$Model$lienDeLApercu = F2(
	function (fiche, cle) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2($author$project$API$NavLinksDictionary$variableChamp, cle)
					])),
			A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$apercuDuRecalcul, fiche.gF));
	});
var $author$project$API$NavLinksDictionary$apercuDuCode = 'apercu-du-code';
var $author$project$Components$Produits$Reference$Model$lienDeLApercuDuCode = function (fiche) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$apercuDuCode, fiche.nQ);
};
var $author$project$Components$Produits$Reference$Model$taillePageHistorique = 25;
var $author$project$Components$Produits$Reference$Model$lienDeLHistorique = F2(
	function (fiche, page) {
		return A2(
			$elm$core$Maybe$map,
			function (lien) {
				return _Utils_update(
					lien,
					{
						cM: lien.cM + ('?page=' + ($elm$core$String$fromInt(page) + ('&taille=' + $elm$core$String$fromInt($author$project$Components$Produits$Reference$Model$taillePageHistorique))))
					});
			},
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$historique, fiche.nQ));
	});
var $author$project$API$NavLinksDictionary$documentsDUneReference = 'documents';
var $author$project$Components$Produits$Reference$Model$lienDesDocuments = function (fiche) {
	return $elm$core$List$isEmpty(fiche.zB) ? $elm$core$Maybe$Nothing : A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$documentsDUneReference, fiche.nQ);
};
var $author$project$API$NavLinksDictionary$produitDeLaReference = 'produit';
var $author$project$Components$Produits$Reference$Model$lienDuProduit = function (fiche) {
	return A3(
		$elm$core$Maybe$map2,
		F2(
			function (lien, produit) {
				return _Utils_Tuple2(
					lien,
					{Aq: produit.Aq, Dj: produit.R.zX});
			}),
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$produitDeLaReference, fiche.nQ),
		fiche.Gp);
};
var $author$project$API$NavLinksDictionary$retirerUnFichierDUneReference = 'retirer-un-fichier-d-une-reference';
var $author$project$Components$Produits$Reference$Model$lienDuRetrait = F2(
	function (fiche, champ) {
		return _Utils_eq(
			A2($author$project$Components$Produits$Reference$Fichiers$fichierDuChamp, fiche, champ),
			$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Nothing : A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerUnFichierDUneReference, fiche.nQ);
	});
var $author$project$Components$Produits$Reference$Model$articlesDuLien = F2(
	function (fiche, cle) {
		return A2(
			$elm$core$List$concatMap,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.tP;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$filter(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.o4;
							},
							$elm$core$Basics$eq($elm$core$Maybe$Nothing))),
					$elm$core$List$map(
						function ($) {
							return $.Aq;
						}))),
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.dy;
					},
					$elm$core$Basics$eq(cle)),
				fiche.BQ));
	});
var $author$project$Components$Produits$Reference$Model$pageDeLaValeur = 5;
var $author$project$Components$Produits$Reference$Model$lireLaValeurDuPerimetre = F4(
	function (fiche, cle, perimetre, debut) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'choisies',
						A2(
							$elm$core$String$join,
							',',
							A2($author$project$Components$Produits$Reference$Model$articlesDuLien, fiche, cle))),
						_Utils_Tuple2(
						'debut',
						$elm$core$String$fromInt(debut)),
						_Utils_Tuple2(
						'taille',
						$elm$core$String$fromInt($author$project$Components$Produits$Reference$Model$pageDeLaValeur))
					])),
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.fm;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(perimetre)),
						A2(
							$elm$core$List$concatMap,
							function ($) {
								return $.pg;
							},
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.dy;
									},
									$elm$core$Basics$eq(cle)),
								fiche.BQ))))));
	});
var $author$project$Components$Produits$Common$Effet$LireLeCatalogue = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Produits$Reference$Update$lireLesFiltres = function (model) {
	var _v0 = _Utils_Tuple3(model.jB, model.r7, model.nx);
	if (_v0.a.$ === 1) {
		var _v1 = _v0.a;
		var catalogue = _v0.c.jB;
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$LireLeCatalogue, $elm$core$List$singleton),
				catalogue));
	} else {
		if (!_v0.b.b) {
			var structure = _v0.c.h$;
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$LireLaStructure, $elm$core$List$singleton),
					structure));
		} else {
			return _List_Nil;
		}
	}
};
var $author$project$Components$Produits$Common$Effet$LireLesPerimetres = F2(
	function (a, b) {
		return {$: 30, a: a, b: b};
	});
var $author$project$Components$Produits$Reference$Update$lireLesPerimetres = F4(
	function (fiche, cle, terme, numero) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Produits$Common$Effet$LireLesPerimetres(numero),
					$elm$core$List$singleton),
				A2(
					$elm$core$Maybe$andThen,
					$author$project$API$Liens$resoudre(
						_List_fromArray(
							[
								_Utils_Tuple2('recherche', terme)
							])),
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.G2;
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.dy;
									},
									$elm$core$Basics$eq(cle)),
								fiche.BQ))))));
	});
var $author$project$Components$Produits$Reference$Update$lireLesValeursDesPerimetres = function (fiche) {
	return A2(
		$elm$core$List$filterMap,
		function (_v0) {
			var cle = _v0.a;
			var perimetre = _v0.b;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Components$Produits$Common$Effet$LireLaValeurDuPerimetre(perimetre),
				A4($author$project$Components$Produits$Reference$Model$lireLaValeurDuPerimetre, fiche, cle, perimetre, 0));
		},
		A2(
			$elm$core$List$concatMap,
			function (lien) {
				return A2(
					$elm$core$List$map,
					function (perimetre) {
						return _Utils_Tuple2(lien.dy, perimetre.Aq);
					},
					lien.pg);
			},
			fiche.BQ));
};
var $author$project$Components$Produits$Reference$Update$modifierLaDefinition = F2(
	function (changer, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					wZ: A2($elm$core$Maybe$map, changer, model.wZ)
				}),
			_List_Nil);
	});
var $author$project$API$NavLinksDictionary$morceauDUnDepot = 'morceau-d-un-depot';
var $author$project$Components$Shared$EditeurDeSchema$Groupe$FicheEffacee = 2;
var $author$project$Components$Shared$EditeurDeSchema$Groupe$FicheIndisponible = 3;
var $author$project$Components$Shared$EditeurDeSchema$Groupe$FichePlusDuType = 1;
var $author$project$Components$Shared$EditeurDeSchema$Groupe$FicheTient = 0;
var $author$project$API$NavLinksDictionary$fichePartiePrenante = 'fiche-de-partie-prenante';
var $author$project$Components$Produits$Reference$Model$fichesCitees = function (fiche) {
	var _v0 = fiche.eA;
	if (_v0.$ === 1) {
		return _List_Nil;
	} else {
		var citees = _v0.a;
		return A2(
			$elm$core$List$map,
			function (citee) {
				return {
					aa: A3(
						$elm$core$Maybe$map2,
						F2(
							function (_v1, uid) {
								return $author$project$Routes$Route$toString(
									A2($author$project$Routes$Route$Fiche, uid, 0));
							}),
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$fichePartiePrenante, citee.nQ),
						$author$project$Components$Referentiel$Identifiants$entiteUidFromString(citee.r8)),
					gt: function () {
						var _v2 = citee.gt;
						switch (_v2) {
							case 0:
								return 0;
							case 1:
								return 1;
							case 2:
								return 2;
							default:
								return 3;
						}
					}(),
					Dj: citee.Dj,
					JV: A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$second,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Tuple$first,
									$elm$core$Basics$eq(citee.r$)),
								citees.ib))),
					r8: citee.r8
				};
			},
			citees.zu);
	}
};
var $author$project$Components$Produits$Reference$Model$contexteDesGroupes = F2(
	function (normes, fiche) {
		return {
			jN: fiche.jN,
			zu: $author$project$Components$Produits$Reference$Model$fichesCitees(fiche),
			nn: A2(
				$elm$core$Maybe$withDefault,
				'fr',
				$elm$core$List$head(fiche.Ba)),
			R: $elm$core$Dict$toList(fiche.Br),
			hd: normes
		};
	});
var $author$project$Components$Produits$Reference$Model$valeurDuGroupe = F2(
	function (fiche, cle) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Vide,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$eq(cle)),
						fiche.Ki))));
	});
var $author$project$Components$Produits$Reference$Update$nomDeLOccurrence = F4(
	function (normes, cle, uid, fiche) {
		return A2(
			$elm$core$Maybe$andThen,
			function (champ) {
				return A2(
					$elm$core$Maybe$map,
					function (lue) {
						return _Utils_Tuple2(
							A3(
								$author$project$Components$Shared$EditeurDeSchema$Groupe$aRetirer,
								A2($author$project$Components$Produits$Reference$Model$contexteDesGroupes, normes, fiche),
								champ,
								lue),
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$I18n$Traductions$tel(champ.Bl),
								A2(
									$elm$core$Maybe$map,
									$author$project$Components$Shared$EditeurDeSchema$Groupe$occurrenceAvecArticle,
									$author$project$Components$Shared$EditeurDeSchema$Groupe$sousChampsDe(champ))));
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.r8;
								},
								$elm$core$Basics$eq(uid)),
							$author$project$Components$Shared$EditeurDeSchema$Groupe$occurrences(
								A2($author$project$Components$Produits$Reference$Model$valeurDuGroupe, fiche, cle)))));
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dy;
						},
						$elm$core$Basics$eq(cle)),
					$author$project$Components$Produits$Reference$Model$champs(fiche))));
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$avecLesTypesVises = F2(
	function (types, brouillon) {
		return _Utils_update(
			brouillon,
			{r2: types});
	});
var $author$project$Components$Produits$Common$Effet$ProposerLesPartiesPrenantes = F3(
	function (a, b, c) {
		return {$: 51, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$Reference$Model$typeUtilisateur = 'utilisateur';
var $author$project$Components$Produits$Reference$Model$lienDeLaRecherche = F2(
	function (typeVise, fiche) {
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				$author$project$API$Liens$trouver(
					_Utils_eq(typeVise, $author$project$Components$Produits$Reference$Model$typeUtilisateur) ? $author$project$API$NavLinksDictionary$rechercherDesUtilisateurs : $author$project$API$NavLinksDictionary$rechercherDesPartiesPrenantes)),
			fiche.eA);
	});
var $author$project$Components$Produits$Reference$Update$proposerLesFiches = F2(
	function (fiche, typesVises) {
		return A2(
			$elm$core$List$filterMap,
			function (typeVise) {
				return A2(
					$elm$core$Maybe$map,
					function (lien) {
						return A3($author$project$Components$Produits$Common$Effet$ProposerLesPartiesPrenantes, lien, typeVise, '');
					},
					A2($author$project$Components$Produits$Reference$Model$lienDeLaRecherche, typeVise, fiche));
			},
			typesVises);
	});
var $author$project$Components$Produits$Reference$Model$dedoublonner = A2(
	$elm$core$List$foldl,
	F2(
		function (lu, vus) {
			return A2($elm$core$List$member, lu, vus) ? vus : _Utils_ap(
				vus,
				_List_fromArray(
					[lu]));
		}),
	_List_Nil);
var $author$project$Components$Produits$Reference$Model$typeViseDe = function (champ) {
	var _v0 = champ.r0;
	switch (_v0.$) {
		case 19:
			var fiche = _v0.a;
			return $elm$core$Maybe$Just(fiche.r$);
		case 20:
			return $elm$core$Maybe$Just($author$project$Components$Produits$Reference$Model$typeUtilisateur);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$Reference$Model$typesVisesDuGroupe = F2(
	function (fiche, cle) {
		return $author$project$Components$Produits$Reference$Model$dedoublonner(
			A2(
				$elm$core$List$filterMap,
				$author$project$Components$Produits$Reference$Model$typeViseDe,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.IX;
						},
						A2(
							$elm$core$Maybe$andThen,
							$author$project$Components$Shared$EditeurDeSchema$Groupe$sousChampsDe,
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.dy;
										},
										$elm$core$Basics$eq(cle)),
									$author$project$Components$Produits$Reference$Model$champs(fiche))))))));
	});
var $author$project$Components$Produits$Reference$Update$ouvrirUneOccurrence = F3(
	function (cle, uid, model) {
		var existantes = function (fiche) {
			return $author$project$Components$Shared$EditeurDeSchema$Groupe$occurrences(
				A2($author$project$Components$Produits$Reference$Model$valeurDuGroupe, fiche, cle));
		};
		var brouillon = F2(
			function (fiche, champ) {
				if (uid.$ === 1) {
					return $author$project$Components$Shared$EditeurDeSchema$Groupe$ajouter(
						{
							uN: champ,
							mp: existantes(fiche),
							Ba: fiche.Ba
						});
				} else {
					var lu = uid.a;
					return A2(
						$elm$core$Maybe$andThen,
						$author$project$Components$Shared$EditeurDeSchema$Groupe$modifier(
							{
								uN: champ,
								mp: existantes(fiche),
								Ba: fiche.Ba
							}),
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.r8;
									},
									$elm$core$Basics$eq(lu)),
								existantes(fiche))));
				}
			});
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (fiche) {
				return A2(
					$elm$core$Maybe$andThen,
					brouillon(fiche),
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.dy;
								},
								$elm$core$Basics$eq(cle)),
							$author$project$Components$Produits$Reference$Model$champs(fiche))));
			},
			model.zo);
		if (!_v0.$) {
			var ouvert = _v0.a;
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Basics$append(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (fiche) {
								return A2(
									$author$project$Components$Produits$Reference$Update$proposerLesFiches,
									fiche,
									A2($author$project$Components$Produits$Reference$Model$typesVisesDuGroupe, fiche, cle));
							},
							model.zo))),
				A3(
					$author$project$Components$Produits$Reference$Update$ouvrir,
					'groupe-' + cle,
					$author$project$Components$Produits$Reference$Model$OccurrenceDUnGroupe,
					_Utils_update(
						model,
						{
							D$: $elm$core$Maybe$Just(
								A2(
									$author$project$Components$Shared$EditeurDeSchema$Groupe$avecLesTypesVises,
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.ib;
											},
											A2(
												$elm$core$Maybe$andThen,
												function ($) {
													return $.eA;
												},
												model.zo))),
									$author$project$Components$Shared$EditeurDeSchema$Groupe$avecCreationALaVolee(ouvert))),
							J8: false
						})));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$proposeeDecoder = A5(
	$elm$json$Json$Decode$map4,
	F4(
		function (uid, nom, role, actif) {
			return {sO: actif, Dj: nom, bi: role, r8: uid};
		}),
	A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$succeed('')
			])),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'role', $elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'estActif', $elm$json$Json$Decode$bool)));
var $author$project$Components$Produits$Reference$API$QueryAPIModel$partiesPrenantesProposeesDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'fiches',
			$elm$json$Json$Decode$list($author$project$Components$Produits$Reference$API$QueryAPIModel$proposeeDecoder)),
			$elm$json$Json$Decode$list($author$project$Components$Produits$Reference$API$QueryAPIModel$proposeeDecoder)
		]));
var $author$project$Components$Produits$Reference$Model$etatDuClient = F2(
	function (fiche, code) {
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.vx;
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.vx;
						},
						A2(
							$elm$core$Basics$composeR,
							$author$project$Catalogue$Identifiants$etatCodeToString,
							$elm$core$Basics$eq(code))),
					fiche.mj)));
	});
var $author$project$Components$Produits$Reference$Model$partirDeLEtatDeDepart = F2(
	function (fiche, variante) {
		var _v0 = variante.gt;
		if (!_v0.$) {
			return variante;
		} else {
			return _Utils_update(
				variante,
				{
					gt: A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Catalogue$Identifiants$etatCodeToString,
							$author$project$Components$Produits$Reference$Model$etatDuClient(fiche)),
						A2(
							$elm$core$Maybe$map,
							$elm$core$Tuple$second,
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Tuple$first,
										$elm$core$Basics$eq(fiche.g1)),
									fiche.yO))))
				});
		}
	});
var $author$project$Components$Produits$Reference$Model$proposer = F3(
	function (visee, fiches, model) {
		return _Utils_update(
			model,
			{
				Gw: A2(
					$elm$core$List$cons,
					_Utils_Tuple2(visee, fiches),
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$neq(visee)),
						model.Gw))
			});
	});
var $author$project$Components$Produits$Reference$Update$recevoirUnProcessUidDImage = F2(
	function (octets, model) {
		var _v0 = _Utils_Tuple2(
			model.wZ,
			$author$project$API$ProcessUid$depuisOctets(octets));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var definition = _v0.a.a;
			var uid = _v0.b.a;
			return _Utils_eq(definition.pA, $elm$core$Maybe$Nothing) ? $author$project$Components$Produits$Reference$Update$demanderLeDepotDeLImage(
				_Utils_update(
					model,
					{
						wZ: $elm$core$Maybe$Just(
							_Utils_update(
								definition,
								{
									pA: $elm$core$Maybe$Just(uid)
								}))
					})) : (_Utils_eq(definition.eH, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{
						wZ: $elm$core$Maybe$Just(
							_Utils_update(
								definition,
								{
									eH: $elm$core$Maybe$Just(uid)
								}))
					}),
				_List_Nil) : _Utils_Tuple2(model, _List_Nil));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$Reference$Model$lienDesUtilisateurs = $author$project$Components$Produits$Reference$Model$lienDeLaRecherche($author$project$Components$Produits$Reference$Model$typeUtilisateur);
var $author$project$Components$Produits$Reference$Update$rechercherDesUtilisateurs = F2(
	function (fiche, terme) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (lien) {
					return _List_fromArray(
						[
							A3($author$project$Components$Produits$Common$Effet$ProposerLesPartiesPrenantes, lien, $author$project$Components$Produits$Reference$Model$typeUtilisateur, terme)
						]);
				},
				$author$project$Components$Produits$Reference$Model$lienDesUtilisateurs(fiche)));
	});
var $author$project$Components$Produits$Reference$Update$reessayerLImage = function (model) {
	var _v0 = model.wZ;
	if (!_v0.$) {
		var definition = _v0.a;
		var demande = definition.kC;
		var choisi = definition.vd;
		var _v1 = _Utils_Tuple2(demande, choisi);
		if ((!_v1.a.$) && (!_v1.b.$)) {
			var obtenue = _v1.a.a;
			var fichier = _v1.b.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						wZ: $elm$core$Maybe$Just(
							_Utils_update(
								definition,
								{me: 2, pD: 0}))
					}),
				_List_fromArray(
					[
						A4($author$project$Components$Produits$Common$Effet$PoserSurLAdresse, obtenue.Cv, obtenue.aa, obtenue.JS, fichier.oW)
					]));
		} else {
			return $author$project$Components$Produits$Reference$Update$demanderLeDepotDeLImage(
				_Utils_update(
					model,
					{
						wZ: $elm$core$Maybe$Just(
							_Utils_update(
								definition,
								{me: 0}))
					}));
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$Reference$Update$remplacerLeFichierDeLImage = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{
				wZ: A2(
					$elm$core$Maybe$map,
					function (definition) {
						return _Utils_update(
							definition,
							{vd: $elm$core$Maybe$Nothing, kC: $elm$core$Maybe$Nothing, me: 0, pA: $elm$core$Maybe$Nothing, pZ: $elm$core$Maybe$Nothing});
					},
					model.wZ)
			}),
		_List_fromArray(
			[
				$author$project$Components$Produits$Common$Effet$DemanderProcessUid,
				$author$project$Components$Produits$Common$Effet$ChoisirUnFichier($author$project$Components$Produits$Reference$Image$formatsAcceptes)
			]));
};
var $author$project$Components$Produits$Reference$Update$reprendre = function (model) {
	var _v0 = model.qx;
	if (!_v0.$) {
		var reprise = _v0.a;
		var _v1 = reprise.HR;
		if (_v1.b) {
			var fichier = _v1.a;
			var suivants = _v1.b;
			var _v2 = A3(
				$author$project$Components$Produits$Common$Envoi$partir,
				$elm$core$Maybe$Just(reprise.nB),
				A4(
					$author$project$Catalogue$API$WriteAPIModel$RattacherUnFichier,
					reprise.sl,
					fichier.uN,
					fichier.gw,
					A2($elm$core$List$sortBy, $elm$core$Tuple$first, fichier.Jy)),
				model.l2);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var envoi = _v3.a;
				var effets = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: envoi,
							qx: $elm$core$Maybe$Just(
								_Utils_update(
									reprise,
									{HR: suivants}))
						}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$Reference$Update$retenirLesFiltres = F2(
	function (model, choix) {
		var _v0 = model.jB;
		if (!_v0.$) {
			var catalogue = _v0.a;
			return A2(
				$author$project$Components$Produits$Common$ChoixDArticles$retenir,
				A2($author$project$Components$Produits$Common$Facettes$depuis, catalogue, model.r7),
				choix);
		} else {
			return choix;
		}
	});
var $author$project$Components$Produits$Reference$Model$RetraitDeLImage = {$: 7};
var $author$project$API$NavLinksDictionary$retirerLImage = 'retirer-l-image';
var $author$project$Components$Produits$Reference$Update$retraitDeLImageDemande = function (model) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.nQ;
			},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.h0;
				},
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$retirerLImage))),
		model.af);
	if (!_v0.$) {
		var drawer = model.kX;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					kX: _Utils_update(
						drawer,
						{
							Dj: $author$project$Components$Produits$Reference$Model$nomDuDrawer($author$project$Components$Produits$Reference$Model$RetraitDeLImage)
						}),
					mW: $author$project$Components$Produits$Reference$Model$RetraitDeLImage
				}),
			_List_Nil);
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$Reference$Model$saisirLaVariante = F3(
	function (fiche, champ, variante) {
		switch (champ.$) {
			case 0:
				var texte = champ.a;
				return _Utils_update(
					variante,
					{vx: texte, fR: $elm$core$Maybe$Nothing});
			case 1:
				var texte = champ.a;
				return _Utils_update(
					variante,
					{sl: texte});
			default:
				var code = champ.a;
				return _Utils_update(
					variante,
					{
						gt: A2(
							$elm$core$Maybe$withDefault,
							variante.gt,
							A2(
								$elm$core$Maybe$map,
								$elm$core$Maybe$Just,
								A2($author$project$Components$Produits$Reference$Model$etatDuClient, fiche, code)))
					});
		}
	});
var $author$project$Components$Produits$Reference$Update$sansProcessUid = function (envoi) {
	if (!envoi.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Produits$Reference$Model$servie = F2(
	function (fiche, model) {
		var memeReference = _Utils_eq(
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Aq;
				},
				model.zo),
			$elm$core$Maybe$Just(fiche.Aq));
		var lue = A2(
			$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$depuis,
			{
				dw: $author$project$Components$Produits$Reference$Model$champs(fiche),
				Ba: fiche.Ba
			},
			fiche.Ki);
		return _Utils_update(
			model,
			{
				zo: $elm$core$Maybe$Just(fiche),
				nf: false,
				hP: (memeReference && A2(
					$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$enCours,
					$author$project$Components$Produits$Reference$Model$champs(fiche),
					model.hP)) ? model.hP : ((memeReference && A2($elm$core$List$member, model.hP.nn, fiche.Ba)) ? _Utils_update(
					lue,
					{nn: model.hP.nn}) : lue)
			});
	});
var $author$project$Components$Produits$Reference$Update$typesDuChamp = F2(
	function (fiche, champ) {
		return A2(
			$elm$core$List$concatMap,
			function ($) {
				return $.r1;
			},
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.dy;
					},
					$elm$core$Basics$eq(champ)),
				$author$project$Components$Produits$Reference$Fichiers$champsFichier(
					$author$project$Components$Produits$Reference$Model$champs(fiche))));
	});
var $author$project$Components$Produits$Reference$Model$typesVisesDeLaFiche = function (fiche) {
	return $author$project$Components$Produits$Reference$Model$dedoublonner(
		A2(
			$elm$core$List$filterMap,
			$author$project$Components$Produits$Reference$Model$typeViseDe,
			$author$project$Components$Produits$Reference$Model$champs(fiche)));
};
var $author$project$Components$Produits$Reference$API$QueryAPIModel$ArticleChoisi = F2(
	function (uid, dejaDansLePerimetre) {
		return {w_: dejaDansLePerimetre, r8: uid};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$LigneResolue = F4(
	function (code, designation, marque, origine) {
		return {vx: code, xt: designation, gX: marque, o4: origine};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$ValeurResolue = F8(
	function (decompte, total, horsPerimetre, criteres, choisis, debut, taille, lignes) {
		return {jL: choisis, wp: criteres, ku: debut, wT: decompte, An: horsPerimetre, gV: lignes, Jm: taille, JE: total};
	});
var $author$project$Components$Produits$Reference$API$QueryAPIModel$Choisi = 1;
var $author$project$Components$Produits$Reference$API$QueryAPIModel$DuPerimetre = 0;
var $author$project$Components$Produits$Reference$API$QueryAPIModel$DuPerimetreEtChoisi = 2;
var $author$project$Components$Produits$Reference$API$QueryAPIModel$HorsPerimetre = 3;
var $author$project$Components$Produits$Reference$API$QueryAPIModel$origineDeLigneDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (origine) {
		switch (origine) {
			case 'perimetre':
				return $elm$json$Json$Decode$succeed(0);
			case 'choisi':
				return $elm$json$Json$Decode$succeed(1);
			case 'perimetre-et-choisi':
				return $elm$json$Json$Decode$succeed(2);
			case 'hors-perimetre':
				return $elm$json$Json$Decode$succeed(3);
			default:
				var autre = origine;
				return $elm$json$Json$Decode$fail('origine-de-ligne:' + autre);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$Produits$Reference$API$QueryAPIModel$valeurResolueDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'lignes',
	$elm$json$Json$Decode$list(
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'origine',
			$author$project$Components$Produits$Reference$API$QueryAPIModel$origineDeLigneDecoder,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				$author$project$Catalogue$Vocabulaire$champDeLaMarque,
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'designation',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'code',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$API$QueryAPIModel$LigneResolue)))))),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'taille',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'debut',
			$elm$json$Json$Decode$int,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'choisis',
				$elm$json$Json$Decode$list(
					A3(
						$elm$json$Json$Decode$map2,
						$author$project$Components$Produits$Reference$API$QueryAPIModel$ArticleChoisi,
						A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
						A2($elm$json$Json$Decode$field, 'dejaDansLePerimetre', $elm$json$Json$Decode$bool))),
				_List_Nil,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
					_List_fromArray(
						['perimetre', 'criteres']),
					$elm$json$Json$Decode$list($author$project$Components$Produits$Common$ChoixDUnPerimetre$segmentDecoder),
					_List_Nil,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'horsPerimetre',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'total',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['perimetre', 'decompte']),
								$elm$json$Json$Decode$int,
								$elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$API$QueryAPIModel$ValeurResolue)))))))));
var $author$project$Components$Produits$Reference$Update$avecLePerimetreChoisi = function (model) {
	var trouve = function (id) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Aq;
					},
					$elm$core$Basics$eq(id)),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.pg;
						},
						model.cl))));
	};
	var _v0 = _Utils_Tuple2(
		A2(
			$elm$core$Maybe$andThen,
			trouve,
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.vd;
				},
				model.fO)),
		model.uw);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var lu = _v0.a.a;
		var brouillon = _v0.b.a;
		return _Utils_update(
			model,
			{
				uw: $elm$core$Maybe$Just(
					_Utils_update(
						brouillon,
						{
							kk: $elm$core$Maybe$Nothing,
							E9: $elm$core$Maybe$Just(
								{
									wp: lu.wp,
									wT: $elm$core$Maybe$Just(lu.wT),
									Aq: lu.Aq,
									Dj: lu.Dj
								}),
							pZ: $elm$core$Maybe$Nothing
						}))
			});
	} else {
		return model;
	}
};
var $author$project$Components$Produits$Common$ChoixDArticles$nomDe = function (trouvee) {
	return A2(
		$elm$core$Maybe$withDefault,
		trouvee.vx,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.zX;
			},
			trouvee.Dj));
};
var $author$project$Components$Produits$Reference$Model$nomsDesArticles = function (choix) {
	return $elm$core$Dict$fromList(
		A2(
			$elm$core$List$map,
			function (trouvee) {
				return _Utils_Tuple2(
					trouvee.Aq,
					_List_fromArray(
						[
							$author$project$I18n$Traductions$tel(
							$author$project$Components$Produits$Common$ChoixDArticles$nomDe(trouvee)),
							$author$project$I18n$Traductions$tel(trouvee.vx)
						]));
			},
			A2(
				$elm$core$List$filter,
				function (trouvee) {
					return A2($elm$core$List$member, trouvee.Aq, choix.at);
				},
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.hD;
						},
						choix.fg)))));
};
var $author$project$Components$Produits$Common$ChoixDArticles$valeurAvecAjout = F3(
	function (plusieurs, deja, coches) {
		return plusieurs ? A2(
			$author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Articles,
			true,
			_Utils_ap(
				deja,
				A2(
					$elm$core$List$filter,
					function (id) {
						return !A2($elm$core$List$member, id, deja);
					},
					coches))) : A2(
			$author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Articles,
			false,
			A2(
				$elm$core$List$drop,
				$elm$core$List$length(coches) - 1,
				coches));
	});
var $author$project$Components$Produits$Reference$Model$avecLesArticlesCoches = F2(
	function (choix, brouillon) {
		var articles = function () {
			var _v0 = A3($author$project$Components$Produits$Common$ChoixDArticles$valeurAvecAjout, brouillon.FS, brouillon.tP, choix.at);
			if (_v0.$ === 6) {
				var uids = _v0.b;
				return uids;
			} else {
				return brouillon.tP;
			}
		}();
		return _Utils_update(
			brouillon,
			{
				tP: articles,
				DG: A2(
					$elm$core$Dict$union,
					$author$project$Components$Produits$Reference$Model$nomsDesArticles(choix),
					brouillon.DG),
				pZ: $elm$core$Maybe$Nothing
			});
	});
var $author$project$Catalogue$API$WriteAPIModel$AjouterUneOccurrenceDUnGroupe = F4(
	function (a, b, c, d) {
		return {$: 49, a: a, b: b, c: c, d: d};
	});
var $author$project$Catalogue$API$WriteAPIModel$ModifierUneOccurrenceDUnGroupe = F5(
	function (a, b, c, d, e) {
		return {$: 50, a: a, b: b, c: c, d: d, e: e};
	});
var $author$project$API$NavLinksDictionary$ajouterUneOccurrenceDUnGroupe = 'ajouter-une-occurrence-d-un-groupe';
var $author$project$Components$Produits$Reference$Model$liensDuGroupe = F2(
	function (fiche, cle) {
		return A2(
			$elm$core$List$concatMap,
			$elm$core$Tuple$second,
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$first,
					$elm$core$Basics$eq(cle)),
				fiche.BP));
	});
var $author$project$API$NavLinksDictionary$modifierUneOccurrenceDUnGroupe = 'modifier-une-occurrence-d-un-groupe';
var $author$project$Components$Produits$Reference$Model$commandeDOccurrence = F2(
	function (model, fiche) {
		return A2(
			$elm$core$Maybe$andThen,
			function (brouillon) {
				return A2(
					$elm$core$Maybe$andThen,
					function (valeurs) {
						var _v0 = brouillon.r8;
						if (_v0.$ === 1) {
							return A2(
								$elm$core$Maybe$map,
								$elm$core$Tuple$pair(
									A4(
										$author$project$Catalogue$API$WriteAPIModel$AjouterUneOccurrenceDUnGroupe,
										fiche.Aq,
										brouillon.uN,
										valeurs,
										A2($author$project$Components$Shared$EditeurDeSchema$Groupe$valeursACreer, fiche.jN, brouillon))),
								A2(
									$author$project$API$Liens$trouver,
									$author$project$API$NavLinksDictionary$ajouterUneOccurrenceDUnGroupe,
									A2($author$project$Components$Produits$Reference$Model$liensDuGroupe, fiche, brouillon.uN)));
						} else {
							var uid = _v0.a;
							return A2(
								$elm$core$Maybe$map,
								$elm$core$Tuple$pair(
									A5(
										$author$project$Catalogue$API$WriteAPIModel$ModifierUneOccurrenceDUnGroupe,
										fiche.Aq,
										brouillon.uN,
										uid,
										valeurs,
										A2($author$project$Components$Shared$EditeurDeSchema$Groupe$valeursACreer, fiche.jN, brouillon))),
								A2(
									$author$project$API$Liens$trouver,
									$author$project$API$NavLinksDictionary$modifierUneOccurrenceDUnGroupe,
									A2($author$project$Components$Produits$Reference$Model$liensDuGroupe, fiche, brouillon.uN)));
						}
					},
					$author$project$Components$Shared$EditeurDeSchema$Groupe$envoyable(brouillon));
			},
			model.D$);
	});
var $author$project$Catalogue$API$WriteAPIModel$CreerUnPerimetreDepuisUnFiltre = F2(
	function (a, b) {
		return {$: 39, a: a, b: b};
	});
var $author$project$Components$Produits$Common$ChoixDArticles$filtreDuChoix = function (choix) {
	return _Utils_ap(
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$pair('typologie'),
			choix.r7),
		_Utils_ap(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$pair('etat'),
				choix.mj),
			_Utils_ap(
				A2(
					$elm$core$List$map,
					$elm$core$Tuple$pair('etages'),
					_Utils_ap(choix.mu, choix.dt)),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$pair($author$project$Catalogue$Vocabulaire$champDeLaMarque),
						choix.cU),
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$pair($author$project$Catalogue$Vocabulaire$champDeLaGamme),
						choix.gG)))));
};
var $author$project$Components$Produits$Reference$Model$commandeDeCreationDUnPerimetre = function (model) {
	var _v0 = _Utils_Tuple3(
		model.wl,
		model.tP,
		A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.wl;
			},
			model.cl));
	if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
		var creation = _v0.a.a;
		var choix = _v0.b.a;
		var lien = _v0.c.a;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(
				A2(
					$author$project$Catalogue$API$WriteAPIModel$CreerUnPerimetreDepuisUnFiltre,
					$elm$core$String$trim(creation.Dj),
					$author$project$Components$Produits$Common$ChoixDArticles$filtreDuChoix(choix)),
				lien));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$Reference$Model$avecLePerimetre = F2(
	function (perimetre, valeur) {
		var _v0 = _Utils_Tuple2(perimetre, valeur);
		_v0$2:
		while (true) {
			if (!_v0.a.$) {
				switch (_v0.b.$) {
					case 6:
						var id = _v0.a.a;
						var _v1 = _v0.b;
						var plusieurs = _v1.a;
						var uids = _v1.b;
						return A3($author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$ArticlesEtPerimetre, plusieurs, uids, id);
					case 0:
						var id = _v0.a.a;
						var _v2 = _v0.b;
						return A3($author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$ArticlesEtPerimetre, false, _List_Nil, id);
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return valeur;
	});
var $author$project$Components$Produits$Reference$Model$lienDeModification = function (fiche) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierLesAttributsDUneReference, fiche.nQ);
};
var $author$project$Components$Produits$Reference$Model$perimetreDuLien = F2(
	function (fiche, cle) {
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.Aq;
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.o4;
						},
						$elm$core$Basics$eq($elm$core$Maybe$Nothing)),
					A2(
						$elm$core$List$concatMap,
						function ($) {
							return $.pg;
						},
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.dy;
								},
								$elm$core$Basics$eq(cle)),
							fiche.BQ)))));
	});
var $author$project$Components$Produits$Common$ChoixDArticles$valeurSansLArticle = F3(
	function (plusieurs, article, deja) {
		var restants = A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(article),
			deja);
		return (plusieurs || (!$elm$core$List$isEmpty(restants))) ? A2($author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Articles, plusieurs, restants) : $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Vide;
	});
var $author$project$Components$Produits$Reference$Model$commandeDeRetraitDArticle = F2(
	function (model, fiche) {
		var _v0 = _Utils_Tuple2(
			model.eW,
			$author$project$Components$Produits$Reference$Model$lienDeModification(fiche));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var retrait = _v0.a.a;
			var lien = _v0.b.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					A2(
						$author$project$Catalogue$API$WriteAPIModel$ModifierLesAttributsDUneReference,
						fiche.Aq,
						_List_fromArray(
							[
								_Utils_Tuple2(
								retrait.dy,
								A2(
									$author$project$Components$Produits$Reference$Model$avecLePerimetre,
									A2($author$project$Components$Produits$Reference$Model$perimetreDuLien, fiche, retrait.dy),
									A3(
										$author$project$Components$Produits$Common$ChoixDArticles$valeurSansLArticle,
										A2($author$project$Components$Produits$Reference$Model$plusieursArticles, fiche, retrait.dy),
										retrait.i4,
										A2($author$project$Components$Produits$Reference$Model$articlesDuLien, fiche, retrait.dy))))
							])),
					lien));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Catalogue$API$WriteAPIModel$RetirerUneOccurrenceDUnGroupe = F3(
	function (a, b, c) {
		return {$: 51, a: a, b: b, c: c};
	});
var $author$project$API$NavLinksDictionary$retirerUneOccurrenceDUnGroupe = 'retirer-une-occurrence-d-un-groupe';
var $author$project$Components$Produits$Reference$Model$commandeDeRetraitDOccurrence = F2(
	function (model, fiche) {
		return A2(
			$elm$core$Maybe$andThen,
			function (retrait) {
				return A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(
						A3($author$project$Catalogue$API$WriteAPIModel$RetirerUneOccurrenceDUnGroupe, fiche.Aq, retrait.uN, retrait.r8)),
					A2(
						$author$project$API$Liens$trouver,
						$author$project$API$NavLinksDictionary$retirerUneOccurrenceDUnGroupe,
						A2($author$project$Components$Produits$Reference$Model$liensDuGroupe, fiche, retrait.uN)));
			},
			model.D0);
	});
var $author$project$Components$Produits$Reference$Model$attributsCopies = function (fiche) {
	var copiable = function (champ) {
		var _v1 = _Utils_Tuple2(champ.zU, champ.r0);
		_v1$0:
		while (true) {
			switch (_v1.b.$) {
				case 9:
					if (!_v1.a.$) {
						break _v1$0;
					} else {
						return false;
					}
				case 23:
					if (!_v1.a.$) {
						break _v1$0;
					} else {
						return false;
					}
				default:
					if (!_v1.a.$) {
						break _v1$0;
					} else {
						return true;
					}
			}
		}
		return false;
	};
	return A2(
		$elm$core$List$filterMap,
		function (champ) {
			return $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var cle = _v0.a;
						var valeur = _v0.b;
						return _Utils_eq(cle, champ.dy) && (!_Utils_eq(valeur, $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Vide));
					},
					fiche.Ki));
		},
		A2(
			$elm$core$List$filter,
			copiable,
			$author$project$Components$Produits$Reference$Model$champs(fiche)));
};
var $author$project$Components$Produits$Reference$Model$ZoneDeLEtat = 2;
var $author$project$Components$Produits$Reference$Model$ZoneDuNom = 1;
var $author$project$Components$Produits$Reference$Model$fautesDeVariante = F2(
	function (fiche, variante) {
		var nouveau = F2(
			function (saisi, source) {
				return ($elm$core$String$trim(saisi) !== '') && (!_Utils_eq(
					$elm$core$Maybe$Just(
						$elm$core$String$trim(saisi)),
					source));
			});
		return A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var zone = _v0.a;
				var fautive = _v0.b;
				return fautive ? $elm$core$Maybe$Just(zone) : $elm$core$Maybe$Nothing;
			},
			_List_fromArray(
				[
					_Utils_Tuple2(
					0,
					!A2(
						nouveau,
						variante.vx,
						$elm$core$Maybe$Just(fiche.vx))),
					_Utils_Tuple2(
					1,
					!A2(nouveau, variante.sl, fiche.sl)),
					_Utils_Tuple2(
					2,
					_Utils_eq(variante.gt, $elm$core$Maybe$Nothing))
				]));
	});
var $author$project$Components$Produits$Reference$Model$commandeDeVariante = F2(
	function (variante, fiche) {
		var _v0 = _Utils_Tuple3(
			$author$project$Components$Produits$Reference$Model$lienDeDuplication(fiche),
			variante.gt,
			A2($author$project$Components$Produits$Reference$Model$fautesDeVariante, fiche, variante));
		if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.b)) {
			var lien = _v0.a.a;
			var etat = _v0.b.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					$author$project$Catalogue$API$WriteAPIModel$CreerUneReference(
						{
							i8: $author$project$Components$Produits$Reference$Model$attributsCopies(fiche),
							vx: $elm$core$String$trim(variante.vx),
							lI: $elm$core$Maybe$Nothing,
							gt: etat,
							n8: fiche.n8,
							g1: fiche.g1,
							Dj: fiche.Dj,
							o4: $elm$core$Maybe$Just(fiche.Aq),
							pN: fiche.pN,
							fh: fiche.r0.Aq,
							r3: fiche.hA.r3,
							Ki: fiche.hA.Ki,
							sl: $elm$core$Maybe$Just(
								$elm$core$String$trim(variante.sl))
						}),
					lien));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$Reference$Model$valeurDuBrouillon = function (brouillon) {
	var _v0 = _Utils_Tuple2(brouillon.E9, brouillon.tP);
	if (!_v0.a.$) {
		var perimetre = _v0.a.a;
		return A3($author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$ArticlesEtPerimetre, brouillon.FS, brouillon.tP, perimetre.Aq);
	} else {
		if (!_v0.b.b) {
			var _v1 = _v0.a;
			return $author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Vide;
		} else {
			var _v2 = _v0.a;
			var articles = _v0.b;
			return A2($author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Articles, brouillon.FS, articles);
		}
	}
};
var $author$project$Components$Produits$Reference$Model$commandeDesArticles = F2(
	function (model, fiche) {
		var _v0 = _Utils_Tuple2(
			model.uw,
			$author$project$Components$Produits$Reference$Model$lienDeModification(fiche));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var brouillon = _v0.a.a;
			var lien = _v0.b.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					A2(
						$author$project$Catalogue$API$WriteAPIModel$ModifierLesAttributsDUneReference,
						fiche.Aq,
						_List_fromArray(
							[
								_Utils_Tuple2(
								brouillon.dy,
								$author$project$Components$Produits$Reference$Model$valeurDuBrouillon(brouillon))
							])),
					lien));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$Reference$Fichiers$tailleDuMorceau = 65536;
var $author$project$Components$Produits$Reference$Fichiers$decouper = function (octets) {
	var pas = function (_v0) {
		var restant = _v0.a;
		var faits = _v0.b;
		if (restant <= 0) {
			return $elm$bytes$Bytes$Decode$succeed(
				$elm$bytes$Bytes$Decode$Done(
					$elm$core$List$reverse(faits)));
		} else {
			var n = A2($elm$core$Basics$min, $author$project$Components$Produits$Reference$Fichiers$tailleDuMorceau, restant);
			return A2(
				$elm$bytes$Bytes$Decode$map,
				function (morceau) {
					return $elm$bytes$Bytes$Decode$Loop(
						_Utils_Tuple2(
							restant - n,
							A2($elm$core$List$cons, morceau, faits)));
				},
				$elm$bytes$Bytes$Decode$bytes(n));
		}
	};
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$bytes$Bytes$Decode$decode,
			A2(
				$elm$bytes$Bytes$Decode$loop,
				_Utils_Tuple2(
					$elm$bytes$Bytes$width(octets),
					_List_Nil),
				pas),
			octets));
};
var $author$project$Components$Produits$Reference$Update$commencerLeDepot = function (model) {
	var _v0 = model.xc;
	if (!_v0.$) {
		var depot = _v0.a;
		var choisi = depot.vd;
		var processUid = depot.Gn;
		var etape = depot.me;
		var _v1 = _Utils_Tuple3(choisi, processUid, etape);
		_v1$2:
		while (true) {
			if (!_v1.b.$) {
				if ((!_v1.a.$) && (!_v1.c.$)) {
					var fichier = _v1.a.a;
					var _v2 = _v1.c;
					var morceaux = $author$project$Components$Produits$Reference$Fichiers$decouper(fichier.oW);
					return $author$project$Components$Produits$Reference$Update$poserLeSuivant(
						_Utils_update(
							model,
							{
								xc: $elm$core$Maybe$Just(
									_Utils_update(
										depot,
										{
											me: $author$project$Components$Produits$Reference$Fichiers$Morceaux(
												{
													zf: 0,
													HR: morceaux,
													JE: $elm$core$List$length(morceaux)
												}),
											pZ: $elm$core$Maybe$Nothing
										}))
							}));
				} else {
					break _v1$2;
				}
			} else {
				if (!_v1.c.$) {
					var _v3 = _v1.b;
					var _v4 = _v1.c;
					return _Utils_Tuple2(
						model,
						_List_fromArray(
							[$author$project$Components$Produits$Common$Effet$DemanderProcessUid]));
				} else {
					break _v1$2;
				}
			}
		}
		return _Utils_Tuple2(model, _List_Nil);
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$Reference$Image$Enregistrement = 6;
var $author$project$API$NavLinksDictionary$choisirLImageDUnChamp = 'choisir-l-image-d-un-champ';
var $author$project$Components$Produits$Reference$Image$genreDeLaCible = $elm$json$Json$Encode$string('reference');
var $author$project$Components$Produits$Reference$Image$commandeChoisir = F3(
	function (uid, cible, champ) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$elm$json$Json$Encode$string(
						$author$project$API$ProcessUid$toString(uid))),
					_Utils_Tuple2('genre', $author$project$Components$Produits$Reference$Image$genreDeLaCible),
					_Utils_Tuple2(
					'cible',
					$elm$json$Json$Encode$string(cible)),
					_Utils_Tuple2(
					'champ',
					$elm$json$Json$Encode$string(champ))
				]));
	});
var $author$project$Components$Produits$Reference$Image$commandeDefinir = F3(
	function (uid, cible, fichier) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$elm$json$Json$Encode$string(
						$author$project$API$ProcessUid$toString(uid))),
					_Utils_Tuple2('genre', $author$project$Components$Produits$Reference$Image$genreDeLaCible),
					_Utils_Tuple2(
					'cible',
					$elm$json$Json$Encode$string(cible)),
					_Utils_Tuple2(
					'fichier',
					$elm$json$Json$Encode$string(fichier))
				]));
	});
var $author$project$Components$Produits$Reference$Image$peutEnregistrer = function (definition) {
	var _v0 = definition.o4;
	if (!_v0) {
		return (definition.me === 4) && (!_Utils_eq(definition.eH, $elm$core$Maybe$Nothing));
	} else {
		return (!_Utils_eq(definition.uN, $elm$core$Maybe$Nothing)) && ((!definition.me) && (!_Utils_eq(definition.eH, $elm$core$Maybe$Nothing)));
	}
};
var $author$project$Components$Produits$Reference$Update$enregistrerLImage = function (model) {
	var _v0 = _Utils_Tuple3(model.zo, model.af, model.wZ);
	if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
		var fiche = _v0.a.a;
		var image = _v0.b.a;
		var definition = _v0.c.a;
		var _v1 = _Utils_Tuple2(
			definition.eH,
			$author$project$Components$Produits$Reference$Image$peutEnregistrer(definition));
		if ((!_v1.a.$) && _v1.b) {
			var uid = _v1.a.a;
			var partir = F2(
				function (rel, corps) {
					var _v5 = A2($author$project$API$Liens$trouver, rel, image.nQ.h0);
					if (!_v5.$) {
						var lien = _v5.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									wZ: $elm$core$Maybe$Just(
										_Utils_update(
											definition,
											{me: 6}))
								}),
							_List_fromArray(
								[
									A3($author$project$Components$Produits$Common$Effet$EnvoyerUneCommandeDImage, 'definir', lien, corps)
								]));
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				});
			var _v2 = _Utils_Tuple3(definition.o4, definition.kC, definition.uN);
			_v2$2:
			while (true) {
				if (!_v2.a) {
					if (!_v2.b.$) {
						var _v3 = _v2.a;
						var demande = _v2.b.a;
						return A2(
							partir,
							$author$project$API$NavLinksDictionary$definirLImage,
							A3(
								$author$project$Components$Produits$Reference$Image$commandeDefinir,
								uid,
								$author$project$Catalogue$Identifiants$referenceIdToString(fiche.Aq),
								demande.Au));
					} else {
						break _v2$2;
					}
				} else {
					if (!_v2.c.$) {
						var _v4 = _v2.a;
						var champ = _v2.c.a;
						return A2(
							partir,
							$author$project$API$NavLinksDictionary$choisirLImageDUnChamp,
							A3(
								$author$project$Components$Produits$Reference$Image$commandeChoisir,
								uid,
								$author$project$Catalogue$Identifiants$referenceIdToString(fiche.Aq),
								champ));
					} else {
						break _v2$2;
					}
				}
			}
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$Reference$Model$prefixeDesOccurrences = 'occurrence';
var $author$project$Components$Produits$Reference$Image$commandeRetirer = F2(
	function (uid, cible) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'processUid',
					$elm$json$Json$Encode$string(
						$author$project$API$ProcessUid$toString(uid))),
					_Utils_Tuple2('genre', $author$project$Components$Produits$Reference$Image$genreDeLaCible),
					_Utils_Tuple2(
					'cible',
					$elm$json$Json$Encode$string(cible))
				]));
	});
var $author$project$Components$Produits$Reference$Update$retraitDeLImageConfirme = function (model) {
	var _v0 = _Utils_Tuple3(
		model.zo,
		A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.eH;
			},
			model.wZ),
		A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.h0;
					},
					$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$retirerLImage))),
			model.af));
	if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
		var fiche = _v0.a.a;
		var uid = _v0.b.a;
		var lien = _v0.c.a;
		return _Utils_Tuple2(
			model,
			_List_fromArray(
				[
					A3(
					$author$project$Components$Produits$Common$Effet$EnvoyerUneCommandeDImage,
					'retirer',
					lien,
					A2(
						$author$project$Components$Produits$Reference$Image$commandeRetirer,
						uid,
						$author$project$Catalogue$Identifiants$referenceIdToString(fiche.Aq)))
				]));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$Reference$Update$valider = function (model) {
	var partir = function (commande) {
		var _v23 = A2(
			$elm$core$Maybe$andThen,
			function (_v24) {
				var voulue = _v24.a;
				var lien = _v24.b;
				return A3(
					$author$project$Components$Produits$Common$Envoi$partir,
					$elm$core$Maybe$Just(lien),
					voulue,
					model.l2);
			},
			commande);
		if (!_v23.$) {
			var _v25 = _v23.a;
			var envoi = _v25.a;
			var effets = _v25.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi, pZ: $elm$core$Maybe$Nothing}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	};
	var _v0 = _Utils_Tuple3(
		model.mW,
		model.zo,
		$author$project$Components$Shared$Drawer$Model$estOuvert(model.kX));
	_v0$16:
	while (true) {
		if (_v0.c) {
			switch (_v0.a.$) {
				case 1:
					if ((!_v0.a.a.$) && (!_v0.b.$)) {
						var voulu = _v0.a.a.a;
						var fiche = _v0.b.a;
						var _v1 = A2($author$project$Components$Produits$Common$Etat$decider, voulu, fiche);
						if (!_v1.$) {
							if (_v1.a.$ === 1) {
								var _v2 = _v1.a;
								return A2($author$project$Components$Produits$Reference$Update$versLeDrawer, $author$project$Components$Shared$Drawer$Update$Fermer, model);
							} else {
								var _v3 = _v1.a;
								var commande = _v3.a;
								var lien = _v3.b;
								return partir(
									$elm$core$Maybe$Just(
										_Utils_Tuple2(commande, lien)));
							}
						} else {
							return _Utils_Tuple2(model, _List_Nil);
						}
					} else {
						break _v0$16;
					}
				case 2:
					if (!_v0.b.$) {
						var _v4 = _v0.a;
						var fiche = _v0.b.a;
						var _v5 = A2($author$project$Components$Produits$Reference$Model$fautesDeVariante, fiche, model.sl);
						if (!_v5.b) {
							return partir(
								A2($author$project$Components$Produits$Reference$Model$commandeDeVariante, model.sl, fiche));
						} else {
							var fautive = _v5.a;
							var variante = model.sl;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										sl: _Utils_update(
											variante,
											{b5: true})
									}),
								_List_fromArray(
									[
										$author$project$Components$Produits$Common$Effet$PlacerFocus(
										A2(
											$author$project$Components$Produits$Reference$Model$idDeVariante,
											$author$project$Components$Shared$Drawer$Model$idRacine(model.kX),
											fautive))
									]));
						}
					} else {
						break _v0$16;
					}
				case 3:
					if (!_v0.b.$) {
						var _v6 = _v0.a;
						return $author$project$Components$Produits$Reference$Update$enregistrer(model);
					} else {
						break _v0$16;
					}
				case 16:
					if (!_v0.b.$) {
						return $author$project$Components$Produits$Reference$Update$enregistrer(model);
					} else {
						break _v0$16;
					}
				case 4:
					var _v7 = _v0.a;
					return A2($author$project$Components$Produits$Reference$Update$versLeDrawer, $author$project$Components$Shared$Drawer$Update$Fermer, model);
				case 13:
					var _v8 = _v0.a;
					return A2($author$project$Components$Produits$Reference$Update$versLeDrawer, $author$project$Components$Shared$Drawer$Update$Fermer, model);
				case 8:
					if (!_v0.b.$) {
						var _v9 = _v0.a;
						var fiche = _v0.b.a;
						return partir(
							A2($author$project$Components$Produits$Reference$Model$commandeDesArticles, model, fiche));
					} else {
						break _v0$16;
					}
				case 11:
					var _v10 = _v0.a;
					return _Utils_Tuple2(
						$author$project$Components$Produits$Reference$Update$retourAuxArticles(
							_Utils_update(
								model,
								{
									uw: function () {
										var _v11 = _Utils_Tuple2(model.uw, model.tP);
										if ((!_v11.a.$) && (!_v11.b.$)) {
											var brouillon = _v11.a.a;
											var choix = _v11.b.a;
											return $elm$core$Maybe$Just(
												A2($author$project$Components$Produits$Reference$Model$avecLesArticlesCoches, choix, brouillon));
										} else {
											return model.uw;
										}
									}()
								})),
						_List_Nil);
				case 9:
					var _v12 = _v0.a;
					return _Utils_Tuple2(
						$author$project$Components$Produits$Reference$Update$retourAuxArticles(
							$author$project$Components$Produits$Reference$Update$avecLePerimetreChoisi(model)),
						_List_Nil);
				case 10:
					var _v13 = _v0.a;
					var _v14 = model.wl;
					if (!_v14.$) {
						var creation = _v14.a;
						return ($elm$core$String$trim(creation.Dj) === '') ? _Utils_Tuple2(
							_Utils_update(
								model,
								{
									wl: $elm$core$Maybe$Just(
										_Utils_update(
											creation,
											{b5: true}))
								}),
							_List_fromArray(
								[
									$author$project$Components$Produits$Common$Effet$PlacerFocus($author$project$Components$Produits$Reference$Model$idDuNomDePerimetre)
								])) : partir(
							$author$project$Components$Produits$Reference$Model$commandeDeCreationDUnPerimetre(model));
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				case 12:
					if (!_v0.b.$) {
						var _v15 = _v0.a;
						var fiche = _v0.b.a;
						return partir(
							A2($author$project$Components$Produits$Reference$Model$commandeDeRetraitDArticle, model, fiche));
					} else {
						break _v0$16;
					}
				case 14:
					if (!_v0.b.$) {
						var _v16 = _v0.a;
						var fiche = _v0.b.a;
						var _v17 = _Utils_Tuple2(
							A2($author$project$Components$Produits$Reference$Model$commandeDOccurrence, model, fiche),
							model.D$);
						if (!_v17.a.$) {
							var commande = _v17.a.a;
							return partir(
								$elm$core$Maybe$Just(commande));
						} else {
							if (!_v17.b.$) {
								var _v18 = _v17.a;
								var brouillon = _v17.b.a;
								var _v19 = A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$fautes, brouillon.IX, brouillon.hP);
								if (!_v19.b) {
									return A2($author$project$Components$Produits$Reference$Update$versLeDrawer, $author$project$Components$Shared$Drawer$Update$Fermer, model);
								} else {
									var fautif = _v19.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												D$: $elm$core$Maybe$Just(
													$author$project$Components$Shared$EditeurDeSchema$Groupe$tenter(brouillon))
											}),
										_List_fromArray(
											[
												$author$project$Components$Produits$Common$Effet$PlacerFocus(
												A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$idDuChamp, $author$project$Components$Produits$Reference$Model$prefixeDesOccurrences, fautif))
											]));
								}
							} else {
								return _Utils_Tuple2(model, _List_Nil);
							}
						}
					} else {
						break _v0$16;
					}
				case 15:
					if (!_v0.b.$) {
						var _v20 = _v0.a;
						var fiche = _v0.b.a;
						return partir(
							A2($author$project$Components$Produits$Reference$Model$commandeDeRetraitDOccurrence, model, fiche));
					} else {
						break _v0$16;
					}
				case 5:
					if (!_v0.b.$) {
						return $author$project$Components$Produits$Reference$Update$commencerLeDepot(model);
					} else {
						break _v0$16;
					}
				case 6:
					if (!_v0.b.$) {
						var _v21 = _v0.a;
						return $author$project$Components$Produits$Reference$Update$enregistrerLImage(model);
					} else {
						break _v0$16;
					}
				case 7:
					if (!_v0.b.$) {
						var _v22 = _v0.a;
						return $author$project$Components$Produits$Reference$Update$retraitDeLImageConfirme(model);
					} else {
						break _v0$16;
					}
				default:
					break _v0$16;
			}
		} else {
			break _v0$16;
		}
	}
	return _Utils_Tuple2(model, _List_Nil);
};
var $author$project$API$NavLinksDictionary$referenceDuCatalogue = 'reference-du-catalogue';
var $author$project$Components$Produits$Liens$versReference = F2(
	function (id, gabarits) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$API$NavLinksDictionary$variableUid,
						$author$project$Catalogue$Identifiants$referenceIdToString(id))
					])),
			A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$referenceDuCatalogue, gabarits));
	});
var $author$project$Components$Produits$Reference$Update$miseAJour = F3(
	function (i18n, msg, model) {
		var initial = $author$project$Components$Produits$Reference$Model$init;
		switch (msg.$) {
			case 0:
				var id = msg.a;
				var gabarits = msg.b;
				var _v1 = A2($author$project$Components$Produits$Liens$versReference, id, gabarits);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							initial,
							{
								np: $elm$core$Maybe$Just(lecture)
							}),
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Components$Produits$Common$Effet$DemanderProcessUid,
									$author$project$Components$Produits$Common$Effet$Lire(lecture)
								]),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$LireLesPrix, $elm$core$List$singleton),
									A2($author$project$Components$Produits$Liens$versLesPrix, id, gabarits)))));
				} else {
					return _Utils_Tuple2(initial, _List_Nil);
				}
			case 1:
				var octets = msg.a;
				if (_Utils_eq(model.mW, $author$project$Components$Produits$Reference$Model$DefinitionDeLImage) && (!$author$project$Components$Produits$Reference$Update$sansProcessUid(model.l2))) {
					return A2($author$project$Components$Produits$Reference$Update$recevoirUnProcessUidDImage, octets, model);
				} else {
					var _v2 = _Utils_Tuple3(
						model.l2,
						model.xc,
						$author$project$API$ProcessUid$depuisOctets(octets));
					if (!_v2.a.$) {
						var _v3 = _v2.a;
						return $author$project$Components$Produits$Reference$Update$reprendre(
							_Utils_update(
								model,
								{
									l2: A2($author$project$Components$Produits$Common$Envoi$recevoir, octets, model.l2)
								}));
					} else {
						if ((!_v2.b.$) && (!_v2.c.$)) {
							var depot = _v2.b.a;
							var uid = _v2.c.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										xc: $elm$core$Maybe$Just(
											_Utils_update(
												depot,
												{
													Gn: $elm$core$Maybe$Just(
														A2($elm$core$Maybe$withDefault, uid, depot.Gn))
												}))
									}),
								_List_Nil);
						} else {
							return _Utils_Tuple2(model, _List_Nil);
						}
					}
				}
			case 2:
				var reponse = msg.a;
				var _v4 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Reference$API$QueryAPIModel$ficheDecoder, reponse);
				if (!_v4.$) {
					var fiche = _v4.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Produits$Reference$Model$servie,
							fiche,
							_Utils_update(
								model,
								{kT: false})),
						_Utils_ap(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$LireLImage, $elm$core$List$singleton),
									A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$imageDePresentation, fiche.nQ))),
							_Utils_ap(
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$LireLesDocuments, $elm$core$List$singleton),
										$author$project$Components$Produits$Reference$Model$lienDesDocuments(fiche))),
								$author$project$Components$Produits$Reference$Update$lireLesValeursDesPerimetres(fiche))));
				} else {
					var refus = _v4.a;
					return (refus.ri === 401) ? _Utils_Tuple2(
						model,
						_List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter])) : _Utils_Tuple2(
						_Utils_update(
							model,
							{nf: refus.ri === 404}),
						_List_Nil);
				}
			case 3:
				var reponse = msg.a;
				var _v5 = A2($author$project$API$Reponse$lire, $author$project$Catalogue$API$PrixAPIModel$prixDUneReferenceDecoder, reponse);
				if (!_v5.$) {
					var prix = _v5.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								py: $elm$core$Maybe$Just(prix)
							}),
						_List_Nil);
				} else {
					var refus = _v5.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{py: $elm$core$Maybe$Nothing}),
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 4:
				var _v6 = A2(
					$elm$core$Maybe$andThen,
					function (fiche) {
						return A2($author$project$Components$Produits$Reference$Model$lienDeLHistorique, fiche, 1);
					},
					model.zo);
				if (!_v6.$) {
					var lien = _v6.a;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(
							_List_fromArray(
								[
									A2($author$project$Components$Produits$Common$Effet$LireLActiviteDeLaReference, lien, 1)
								])),
						A3(
							$author$project$Components$Produits$Reference$Update$ouvrir,
							$author$project$Components$Produits$Reference$Model$idDeLHistorique,
							$author$project$Components$Produits$Reference$Model$Historique,
							_Utils_update(
								model,
								{
									m6: $elm$core$Maybe$Just(
										{B0: $elm$core$Maybe$Nothing, EE: 1})
								})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 5:
				var page = msg.a;
				var _v7 = _Utils_Tuple2(
					A2(
						$elm$core$Maybe$andThen,
						function (fiche) {
							return A2($author$project$Components$Produits$Reference$Model$lienDeLHistorique, fiche, page);
						},
						model.zo),
					model.m6);
				if ((!_v7.a.$) && (!_v7.b.$)) {
					var lien = _v7.a.a;
					var ouvert = _v7.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								m6: $elm$core$Maybe$Just(
									_Utils_update(
										ouvert,
										{EE: page}))
							}),
						_List_fromArray(
							[
								A2($author$project$Components$Produits$Common$Effet$LireLActiviteDeLaReference, lien, page)
							]));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 6:
				var page = msg.a;
				var reponse = msg.b;
				var _v8 = _Utils_Tuple2(
					A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Reference$API$QueryAPIModel$historiqueDecoder, reponse),
					model.m6);
				if (!_v8.a.$) {
					if (!_v8.b.$) {
						var lu = _v8.a.a;
						var ouvert = _v8.b.a;
						return _Utils_Tuple2(
							_Utils_eq(ouvert.EE, page) ? _Utils_update(
								model,
								{
									m6: $elm$core$Maybe$Just(
										_Utils_update(
											ouvert,
											{
												B0: $elm$core$Maybe$Just(lu)
											}))
								}) : model,
							_List_Nil);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				} else {
					var refus = _v8.a.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 7:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Produits$Reference$Update$relire(model));
			case 8:
				var geste = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hP: A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$saisir, geste, model.hP)
						}),
					_List_Nil);
			case 9:
				return $author$project$Components$Produits$Reference$Update$enregistrer(model);
			case 10:
				var geste = msg.a;
				return A2($author$project$Components$Produits$Reference$Update$versLeDrawer, geste, model);
			case 11:
				var _v9 = A2(
					$elm$core$Maybe$andThen,
					function (fiche) {
						return A2(
							$elm$core$Maybe$map,
							function (_v10) {
								return fiche;
							},
							$author$project$Components$Produits$Common$Etat$lien(fiche));
					},
					model.zo);
				if (!_v9.$) {
					var fiche = _v9.a;
					return A3(
						$author$project$Components$Produits$Reference$Update$ouvrir,
						$author$project$Components$Produits$Reference$Model$idDeLEtat,
						$author$project$Components$Produits$Reference$Model$ChangementDEtat(
							$elm$core$Maybe$Just(fiche.gt)),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 12:
				var code = msg.a;
				var _v11 = _Utils_Tuple2(model.mW, model.zo);
				if ((_v11.a.$ === 1) && (!_v11.b.$)) {
					var fiche = _v11.b.a;
					var _v12 = A2($author$project$Components$Produits$Common$Etat$choisir, fiche, code);
					if (!_v12.$) {
						var connu = _v12.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									mW: $author$project$Components$Produits$Reference$Model$ChangementDEtat(
										$elm$core$Maybe$Just(connu))
								}),
							_List_Nil);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 13:
				var _v13 = A2(
					$elm$core$Maybe$andThen,
					function (fiche) {
						return A2(
							$elm$core$Maybe$map,
							function (_v14) {
								return fiche;
							},
							$author$project$Components$Produits$Reference$Model$lienDeDuplication(fiche));
					},
					model.zo);
				if (!_v13.$) {
					var fiche = _v13.a;
					return A3(
						$author$project$Components$Produits$Reference$Update$ouvrir,
						$author$project$Components$Produits$Reference$Model$idDeLaDuplication,
						$author$project$Components$Produits$Reference$Model$Duplication,
						_Utils_update(
							model,
							{
								sl: A2(
									$author$project$Components$Produits$Reference$Model$partirDeLEtatDeDepart,
									fiche,
									$author$project$Components$Produits$Reference$Model$varianteVide($elm$core$Maybe$Nothing))
							}));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 15:
				var cle = msg.a;
				var _v15 = model.zo;
				if (!_v15.$) {
					var fiche = _v15.a;
					return _Utils_eq(
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierLesAttributsDUneReference, fiche.nQ),
						$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(
							A2($author$project$Components$Produits$Reference$Update$rechercherDesUtilisateurs, fiche, '')),
						A3(
							$author$project$Components$Produits$Reference$Update$ouvrir,
							$author$project$Components$Produits$Reference$Model$idDuChoixDUtilisateur,
							$author$project$Components$Produits$Reference$Model$ChoixDUtilisateur(cle),
							_Utils_update(
								model,
								{pP: ''})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 16:
				var terme = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pP: terme}),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (fiche) {
								return A2($author$project$Components$Produits$Reference$Update$rechercherDesUtilisateurs, fiche, terme);
							},
							model.zo)));
			case 17:
				var cle = msg.a;
				var uid = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hP: A2(
								$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$saisir,
								A2(
									$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$Saisi,
									cle,
									$author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Ecrit(uid)),
								model.hP)
						}),
					_List_Nil);
			case 14:
				var _v16 = model.zo;
				if (!_v16.$) {
					var fiche = _v16.a;
					return _Utils_eq(
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierLesAttributsDUneReference, fiche.nQ),
						$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(
							A2(
								$author$project$Components$Produits$Reference$Update$proposerLesFiches,
								fiche,
								$author$project$Components$Produits$Reference$Model$typesVisesDeLaFiche(fiche))),
						A3($author$project$Components$Produits$Reference$Update$ouvrir, $author$project$Components$Produits$Reference$Model$idDeLaModification, $author$project$Components$Produits$Reference$Model$Modification, model));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 18:
				var champ = msg.a;
				var _v17 = model.zo;
				if (!_v17.$) {
					var fiche = _v17.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sl: A3($author$project$Components$Produits$Reference$Model$saisirLaVariante, fiche, champ, model.sl)
							}),
						_List_Nil);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 19:
				return $author$project$Components$Produits$Reference$Update$valider(model);
			case 20:
				return _Utils_eq(
					A2($elm$core$Maybe$andThen, $author$project$Components$Produits$Reference$Model$commandeDArret, model.zo),
					$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : _Utils_Tuple2(
					_Utils_update(
						model,
						{is: true}),
					_List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$PlacerFocus($author$project$Components$Produits$Reference$Model$idsDeLArret.to)
						]));
			case 21:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{is: false}),
					_List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$PlacerFocus($author$project$Components$Produits$Reference$Model$idDeLArret)
						]));
			case 22:
				var _v18 = _Utils_Tuple2(
					model.is,
					A2(
						$elm$core$Maybe$andThen,
						function (_v19) {
							var commande = _v19.a;
							var lien = _v19.b;
							return A3(
								$author$project$Components$Produits$Common$Envoi$partir,
								$elm$core$Maybe$Just(lien),
								commande,
								model.l2);
						},
						A2($elm$core$Maybe$andThen, $author$project$Components$Produits$Reference$Model$commandeDArret, model.zo)));
				if (_v18.a && (!_v18.b.$)) {
					var _v20 = _v18.b.a;
					var envoi = _v20.a;
					var effets = _v20.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{is: false, l2: envoi}),
						effets);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 23:
				var _v21 = A2($elm$core$Maybe$andThen, $author$project$Components$Produits$Reference$Model$lienDuProduit, model.zo);
				if (!_v21.$) {
					var _v22 = _v21.a;
					var lien = _v22.a;
					var produit = _v22.b;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(
							_List_fromArray(
								[
									$author$project$Components$Produits$Common$Effet$LireLaFicheDUnProduit(lien)
								])),
						A3(
							$author$project$Components$Produits$Reference$Update$ouvrir,
							$author$project$Components$Produits$Reference$Model$idDuProduit,
							$author$project$Components$Produits$Reference$Model$ProduitDeLaReference,
							_Utils_update(
								model,
								{
									pC: $elm$core$Maybe$Just(
										{tD: $author$project$Components$Produits$Common$ArchivageDuProduit$aucun, Aq: produit.Aq, Ax: false, B0: false, Dj: produit.Dj})
								})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 25:
				var perimetre = msg.a;
				var reponse = msg.b;
				var _v23 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Reference$API$QueryAPIModel$valeurResolueDecoder, reponse);
				if (!_v23.$) {
					var valeur = _v23.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ih: A3($elm$core$Dict$insert, perimetre, valeur, model.ih)
							}),
						_List_Nil);
				} else {
					var refus = _v23.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 26:
				var cle = msg.a;
				var perimetre = msg.b;
				var debut = msg.c;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Components$Produits$Common$Effet$LireLaValeurDuPerimetre(perimetre),
								$elm$core$List$singleton),
							A2(
								$elm$core$Maybe$andThen,
								function (fiche) {
									return A4($author$project$Components$Produits$Reference$Model$lireLaValeurDuPerimetre, fiche, cle, perimetre, debut);
								},
								model.zo))));
			case 24:
				var reponse = msg.a;
				var _v24 = _Utils_Tuple2(
					A2($author$project$API$Reponse$lire, $author$project$Catalogue$API$QueryAPIModel$ficheDuProduitDecoder, reponse),
					model.pC);
				_v24$2:
				while (true) {
					if (!_v24.a.$) {
						if (!_v24.b.$) {
							var fiche = _v24.a.a;
							var ouvert = _v24.b.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										pC: $elm$core$Maybe$Just(
											_Utils_update(
												ouvert,
												{
													tD: $author$project$Components$Produits$Common$ArchivageDuProduit$depuisLaFiche(fiche),
													Ax: false,
													B0: true
												}))
									}),
								_List_Nil);
						} else {
							break _v24$2;
						}
					} else {
						if (!_v24.b.$) {
							var refus = _v24.a.a;
							var ouvert = _v24.b.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										pC: $elm$core$Maybe$Just(
											_Utils_update(
												ouvert,
												{Ax: true, B0: true}))
									}),
								(refus.ri === 401) ? _List_fromArray(
									[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
						} else {
							break _v24$2;
						}
					}
				}
				return _Utils_Tuple2(model, _List_Nil);
			case 27:
				var cle = msg.a;
				var _v25 = A2(
					$elm$core$Maybe$andThen,
					function (fiche) {
						return A2($author$project$Components$Produits$Reference$Model$lienDeLApercu, fiche, cle);
					},
					model.zo);
				if (!_v25.$) {
					var lien = _v25.a;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(
							_List_fromArray(
								[
									$author$project$Components$Produits$Common$Effet$LireLApercuDuRecalcul(lien)
								])),
						A3(
							$author$project$Components$Produits$Reference$Update$ouvrir,
							$author$project$Components$Produits$Reference$Model$idDuRecalcul(cle),
							$author$project$Components$Produits$Reference$Model$RecalculDUnChamp(cle),
							_Utils_update(
								model,
								{
									tq: $elm$core$Maybe$Just(
										{uN: cle, Ax: false, B0: $elm$core$Maybe$Nothing})
								})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 28:
				var reponse = msg.a;
				if (_Utils_eq(model.mW, $author$project$Components$Produits$Reference$Model$RecalculDuCode)) {
					var _v26 = _Utils_Tuple2(
						A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Reference$API$QueryAPIModel$apercuDuCodeDecoder, reponse),
						model.iV);
					_v26$2:
					while (true) {
						if (!_v26.a.$) {
							if (!_v26.b.$) {
								var lu = _v26.a.a;
								var ouvert = _v26.b.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											iV: $elm$core$Maybe$Just(
												_Utils_update(
													ouvert,
													{
														B0: $elm$core$Maybe$Just(lu)
													}))
										}),
									_List_Nil);
							} else {
								break _v26$2;
							}
						} else {
							if (!_v26.b.$) {
								var refus = _v26.a.a;
								var ouvert = _v26.b.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											iV: $elm$core$Maybe$Just(
												_Utils_update(
													ouvert,
													{Ax: true}))
										}),
									(refus.ri === 401) ? _List_fromArray(
										[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
							} else {
								break _v26$2;
							}
						}
					}
					return _Utils_Tuple2(model, _List_Nil);
				} else {
					var _v27 = _Utils_Tuple2(
						A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Reference$API$QueryAPIModel$apercuDuRecalculDecoder, reponse),
						model.tq);
					_v27$2:
					while (true) {
						if (!_v27.a.$) {
							if (!_v27.b.$) {
								var lu = _v27.a.a;
								var ouvert = _v27.b.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											tq: $elm$core$Maybe$Just(
												_Utils_update(
													ouvert,
													{
														B0: $elm$core$Maybe$Just(lu)
													}))
										}),
									_List_Nil);
							} else {
								break _v27$2;
							}
						} else {
							if (!_v27.b.$) {
								var refus = _v27.a.a;
								var ouvert = _v27.b.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											tq: $elm$core$Maybe$Just(
												_Utils_update(
													ouvert,
													{Ax: true}))
										}),
									(refus.ri === 401) ? _List_fromArray(
										[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
							} else {
								break _v27$2;
							}
						}
					}
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 29:
				var _v28 = _Utils_Tuple2(model.mW, model.zo);
				if ((_v28.a.$ === 17) && (!_v28.b.$)) {
					var cle = _v28.a.a;
					var fiche = _v28.b.a;
					return A2(
						$author$project$Components$Produits$Reference$Update$envoyerLeCalcul,
						A2($author$project$Components$Produits$Reference$Model$commandeDeRecalcul, fiche, cle),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 30:
				var _v29 = model.zo;
				if (!_v29.$) {
					var fiche = _v29.a;
					return A3(
						$author$project$Components$Produits$Reference$Update$ouvrir,
						$author$project$Components$Produits$Reference$Model$idDuCode,
						$author$project$Components$Produits$Reference$Model$ChangementDuCode,
						_Utils_update(
							model,
							{jY: fiche.vx}));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 32:
				var saisie = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{jY: saisie}),
					_List_Nil);
			case 31:
				var _v30 = A2($elm$core$Maybe$andThen, $author$project$Components$Produits$Reference$Model$lienDeLApercuDuCode, model.zo);
				if (!_v30.$) {
					var lien = _v30.a;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(
							_List_fromArray(
								[
									$author$project$Components$Produits$Common$Effet$LireLApercuDuRecalcul(lien)
								])),
						A3(
							$author$project$Components$Produits$Reference$Update$ouvrir,
							$author$project$Components$Produits$Reference$Model$idDuCode,
							$author$project$Components$Produits$Reference$Model$RecalculDuCode,
							_Utils_update(
								model,
								{
									iV: $elm$core$Maybe$Just(
										{Ax: false, B0: $elm$core$Maybe$Nothing})
								})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 33:
				var code = msg.a;
				return function (commande) {
					return A2($author$project$Components$Produits$Reference$Update$envoyerLeCalcul, commande, model);
				}(
					A2(
						$elm$core$Maybe$andThen,
						function (fiche) {
							return A2($author$project$Components$Produits$Reference$Model$commandeDuCode, fiche, code);
						},
						model.zo));
			case 34:
				var cle = msg.a;
				return function (commande) {
					return A2($author$project$Components$Produits$Reference$Update$envoyerLeCalcul, commande, model);
				}(
					A2(
						$elm$core$Maybe$andThen,
						function (fiche) {
							return A2($author$project$Components$Produits$Reference$Model$commandeDeRetourAuCalcul, fiche, cle);
						},
						model.zo));
			case 35:
				var cle = msg.a;
				return function (commande) {
					return A2($author$project$Components$Produits$Reference$Update$envoyerLeCalcul, commande, model);
				}(
					A2(
						$elm$core$Maybe$andThen,
						function (fiche) {
							return A2($author$project$Components$Produits$Reference$Model$commandeDeDebrayage, fiche, cle);
						},
						model.zo));
			case 36:
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Produits$Reference$Update$surLArchivage,
						$author$project$Components$Produits$Common$ArchivageDuProduit$demander,
						_Utils_update(
							model,
							{pZ: $elm$core$Maybe$Nothing})),
					_List_Nil);
			case 37:
				return _Utils_Tuple2(
					A2($author$project$Components$Produits$Reference$Update$surLArchivage, $author$project$Components$Produits$Common$ArchivageDuProduit$renoncer, model),
					_List_Nil);
			case 38:
				return $author$project$Components$Produits$Reference$Update$archiverLeProduit(model);
			case 39:
				var vers = msg.a;
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$PlacerFocus(vers)
						]));
			case 40:
				var cle = msg.a;
				var _v31 = model.zo;
				if (!_v31.$) {
					var fiche = _v31.a;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(
							A4($author$project$Components$Produits$Reference$Update$lireLesPerimetres, fiche, cle, '', 0)),
						A3(
							$author$project$Components$Produits$Reference$Update$ouvrir,
							$author$project$Components$Produits$Common$ChoixDArticles$idDuChoix + ('-' + cle),
							$author$project$Components$Produits$Reference$Model$ModificationDesArticles,
							_Utils_update(
								model,
								{
									tP: $elm$core$Maybe$Nothing,
									uw: $elm$core$Maybe$Just(
										A2($author$project$Components$Produits$Reference$Model$brouillonDeLaFiche, fiche, cle)),
									fO: $elm$core$Maybe$Nothing,
									wl: $elm$core$Maybe$Nothing
								})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 41:
				var _v32 = model.uw;
				if (!_v32.$) {
					var brouillon = _v32.a;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(
							$author$project$Components$Produits$Reference$Update$lireLesFiltres(model)),
						$author$project$Components$Produits$Reference$Update$chercherDesArticles(
							_Utils_Tuple2(
								A2(
									$author$project$Components$Produits$Reference$Update$basculer,
									$author$project$Components$Produits$Reference$Model$ChoixDArticles,
									_Utils_update(
										model,
										{
											tP: $elm$core$Maybe$Just(
												$author$project$Components$Produits$Common$ChoixDArticles$choixVide(brouillon.dy))
										})),
								_List_Nil)));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 42:
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Produits$Reference$Update$basculer,
						$author$project$Components$Produits$Reference$Model$ChoixDUnPerimetre,
						_Utils_update(
							model,
							{
								fO: $elm$core$Maybe$Just(
									{
										vd: A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.Aq;
											},
											A2(
												$elm$core$Maybe$andThen,
												function ($) {
													return $.E9;
												},
												model.uw)),
										AJ: false,
										DX: 0,
										h3: ''
									})
							})),
					_List_Nil);
			case 43:
				var terme = msg.a;
				var _v33 = _Utils_Tuple3(model.fO, model.zo, model.uw);
				if (((!_v33.a.$) && (!_v33.b.$)) && (!_v33.c.$)) {
					var choix = _v33.a.a;
					var fiche = _v33.b.a;
					var brouillon = _v33.c.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								fO: $elm$core$Maybe$Just(
									_Utils_update(
										choix,
										{DX: choix.DX + 1, h3: terme}))
							}),
						A4($author$project$Components$Produits$Reference$Update$lireLesPerimetres, fiche, brouillon.dy, terme, choix.DX + 1));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 44:
				var numero = msg.a;
				var reponse = msg.b;
				if (!_Utils_eq(
					numero,
					A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.DX;
							},
							model.fO)))) {
					return _Utils_Tuple2(model, _List_Nil);
				} else {
					var _v34 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$ChoixDUnPerimetre$annuaireDecoder, reponse);
					if (!_v34.$) {
						var annuaire = _v34.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									cl: $elm$core$Maybe$Just(annuaire),
									fO: A2(
										$elm$core$Maybe$map,
										function (choix) {
											return _Utils_update(
												choix,
												{AJ: false});
										},
										model.fO)
								}),
							_List_Nil);
					} else {
						var refus = _v34.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									fO: A2(
										$elm$core$Maybe$map,
										function (choix) {
											return _Utils_update(
												choix,
												{AJ: true});
										},
										model.fO)
								}),
							(refus.ri === 401) ? _List_fromArray(
								[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
					}
				}
			case 45:
				var id = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fO: A2(
								$elm$core$Maybe$map,
								function (choix) {
									return _Utils_update(
										choix,
										{
											vd: $elm$core$Maybe$Just(id)
										});
								},
								model.fO)
						}),
					_List_Nil);
			case 46:
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Produits$Reference$Update$basculer,
						$author$project$Components$Produits$Reference$Model$CreationDUnPerimetre,
						_Utils_update(
							model,
							{
								wl: $elm$core$Maybe$Just(
									{
										wT: A2(
											$elm$core$Maybe$withDefault,
											0,
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.JE;
												},
												A2(
													$elm$core$Maybe$andThen,
													function ($) {
														return $.fg;
													},
													model.tP))),
										Dj: '',
										pZ: $elm$core$Maybe$Nothing,
										b5: false
									})
							})),
					_List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$PlacerFocus($author$project$Components$Produits$Reference$Model$idDuNomDePerimetre)
						]));
			case 47:
				var nom = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							wl: A2(
								$elm$core$Maybe$map,
								function (creation) {
									return _Utils_update(
										creation,
										{Dj: nom, pZ: $elm$core$Maybe$Nothing});
								},
								model.wl)
						}),
					_List_Nil);
			case 48:
				var id = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Produits$Reference$Update$avecLeBrouillon,
						function (brouillon) {
							return _Utils_update(
								brouillon,
								{
									tP: A2(
										$elm$core$List$filter,
										$elm$core$Basics$neq(id),
										brouillon.tP),
									kk: $elm$core$Maybe$Nothing,
									pZ: $elm$core$Maybe$Nothing
								});
						},
						model),
					_List_Nil);
			case 49:
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Produits$Reference$Update$avecLeBrouillon,
						function (brouillon) {
							return _Utils_update(
								brouillon,
								{kk: $elm$core$Maybe$Nothing, E9: $elm$core$Maybe$Nothing, pZ: $elm$core$Maybe$Nothing});
						},
						model),
					_List_Nil);
			case 58:
				var reponse = msg.a;
				var _v35 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$catalogueDecoder, reponse);
				if (!_v35.$) {
					var catalogue = _v35.a;
					var lu = _Utils_update(
						model,
						{
							jB: $elm$core$Maybe$Just(catalogue)
						});
					return _Utils_Tuple2(
						lu,
						$author$project$Components$Produits$Reference$Update$lireLesFiltres(lu));
				} else {
					var refus = _v35.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 59:
				var reponse = msg.a;
				var _v36 = _Utils_Tuple2(
					A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$API$CatalogueQueryAPIModel$classificationsDecoder, reponse),
					model.jB);
				if (!_v36.a.$) {
					if (!_v36.b.$) {
						var classifications = _v36.a.a;
						var catalogue = _v36.b.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									r7: A2(
										$author$project$Catalogue$Typologies$typologiesDe,
										A2($author$project$Components$Produits$Reference$Update$libelleDeLEtage, i18n, catalogue),
										classifications)
								}),
							_List_Nil);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				} else {
					var refus = _v36.a.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 60:
				var groupe = msg.a;
				var id = msg.b;
				return $author$project$Components$Produits$Reference$Update$chercherDesArticles(
					_Utils_Tuple2(
						A2(
							$author$project$Components$Produits$Reference$Update$avecLeChoix,
							A2(
								$elm$core$Basics$composeR,
								A2($author$project$Components$Produits$Common$ChoixDArticles$basculer, groupe, id),
								$author$project$Components$Produits$Reference$Update$retenirLesFiltres(model)),
							model),
						_List_Nil));
			case 61:
				var groupe = msg.a;
				var id = msg.b;
				return $author$project$Components$Produits$Reference$Update$chercherDesArticles(
					_Utils_Tuple2(
						A2(
							$author$project$Components$Produits$Reference$Update$avecLeChoix,
							A2(
								$elm$core$Basics$composeR,
								A2($author$project$Components$Produits$Common$ChoixDArticles$choisir, groupe, id),
								$author$project$Components$Produits$Reference$Update$retenirLesFiltres(model)),
							model),
						_List_Nil));
			case 50:
				var terme = msg.a;
				return $author$project$Components$Produits$Reference$Update$chercherDesArticles(
					_Utils_Tuple2(
						A2(
							$author$project$Components$Produits$Reference$Update$avecLeChoix,
							function (choix) {
								return _Utils_update(
									choix,
									{EE: 1, h3: terme});
							},
							model),
						_List_Nil));
			case 52:
				var page = msg.a;
				return $author$project$Components$Produits$Reference$Update$chercherDesArticles(
					_Utils_Tuple2(
						A2(
							$author$project$Components$Produits$Reference$Update$avecLeChoix,
							$author$project$Components$Produits$Common$ChoixDArticles$pageDemandee(page),
							model),
						_List_Nil));
			case 51:
				var id = msg.a;
				var voulue = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Produits$Reference$Update$avecLeChoix,
						A2($author$project$Components$Produits$Common$ChoixDArticles$cocher, id, voulue),
						model),
					_List_Nil);
			case 53:
				var numero = msg.a;
				var reponse = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Produits$Reference$Update$avecLeChoix,
						A2(
							$author$project$Components$Produits$Common$ChoixDArticles$recu,
							numero,
							A2(
								$elm$core$Result$mapError,
								function (_v37) {
									return 0;
								},
								A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$ChoixDArticles$decoder, reponse))),
						model),
					_List_Nil);
			case 55:
				var cle = msg.a;
				var uid = msg.b;
				return A3($author$project$Components$Produits$Reference$Update$ouvrirUneOccurrence, cle, uid, model);
			case 56:
				var geste = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							D$: A2(
								$elm$core$Maybe$map,
								$author$project$Components$Shared$EditeurDeSchema$Groupe$saisir(geste),
								model.D$)
						}),
					_List_Nil);
			case 57:
				var cle = msg.a;
				var uid = msg.b;
				var _v38 = A2(
					$elm$core$Maybe$andThen,
					A3($author$project$Components$Produits$Reference$Update$nomDeLOccurrence, model.hd, cle, uid),
					model.zo);
				if (!_v38.$) {
					var _v39 = _v38.a;
					var nom = _v39.a;
					var occurrence = _v39.b;
					return A3(
						$author$project$Components$Produits$Reference$Update$ouvrir,
						'groupe-' + cle,
						$author$project$Components$Produits$Reference$Model$RetraitDUneOccurrence,
						_Utils_update(
							model,
							{
								D0: $elm$core$Maybe$Just(
									{uN: cle, Dj: nom, D$: occurrence, r8: uid})
							}));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 54:
				var cle = msg.a;
				var article = msg.b;
				return A3(
					$author$project$Components$Produits$Reference$Update$ouvrir,
					$author$project$Components$Produits$Common$ChoixDArticles$idDuRetrait + ('-' + article),
					$author$project$Components$Produits$Reference$Model$RetraitDArticle,
					_Utils_update(
						model,
						{
							eW: $elm$core$Maybe$Just(
								{i4: article, dy: cle})
						}));
			case 63:
				var suivables = msg.a;
				var gabarits = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gF: gabarits,
							nx: {
								jB: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$catalogue, suivables),
								h$: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$structureDuCatalogue, suivables)
							},
							d9: {
								kE: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$demanderUnDepot, suivables),
								kI: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$deposerUnFichier, suivables),
								ol: A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$morceauDUnDepot, gabarits)
							}
						}),
					_List_Nil);
			case 64:
				var champ = msg.a;
				return A2($author$project$Components$Produits$Reference$Update$demanderLeDepot, champ, model);
			case 65:
				if (_Utils_eq(model.mW, $author$project$Components$Produits$Reference$Model$DefinitionDeLImage)) {
					return _Utils_Tuple2(
						model,
						_List_fromArray(
							[
								$author$project$Components$Produits$Common$Effet$ChoisirUnFichier($author$project$Components$Produits$Reference$Image$formatsAcceptes)
							]));
				} else {
					var _v40 = _Utils_Tuple2(model.zo, model.xc);
					if ((!_v40.a.$) && (!_v40.b.$)) {
						var fiche = _v40.a.a;
						var depot = _v40.b.a;
						return _Utils_Tuple2(
							model,
							_List_fromArray(
								[
									$author$project$Components$Produits$Common$Effet$ChoisirUnFichier(
									A2($author$project$Components$Produits$Reference$Update$typesDuChamp, fiche, depot.uN))
								]));
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				}
			case 66:
				var choisi = msg.a;
				return _Utils_eq(model.mW, $author$project$Components$Produits$Reference$Model$DefinitionDeLImage) ? A2($author$project$Components$Produits$Reference$Update$imageChoisie, choisi, model) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							xc: A2(
								$elm$core$Maybe$map,
								function (depot) {
									return _Utils_update(
										depot,
										{
											vd: $elm$core$Maybe$Just(choisi),
											pZ: $elm$core$Maybe$Nothing
										});
								},
								model.xc)
						}),
					_List_Nil);
			case 76:
				var reponse = msg.a;
				return A2($author$project$Components$Produits$Reference$Update$imageLue, reponse, model);
			case 77:
				var nom = msg.a;
				var reponse = msg.b;
				return A3($author$project$Components$Produits$Reference$Update$imageRepondue, nom, reponse, model);
			case 78:
				var reponse = msg.a;
				return A2($author$project$Components$Produits$Reference$Update$imagePosee, reponse, model);
			case 79:
				var pourcent = msg.a;
				return A2($author$project$Components$Produits$Reference$Update$imageProgresse, pourcent, model);
			case 80:
				return $author$project$Components$Produits$Reference$Update$annulerLEnvoiDeLImage(model);
			case 82:
				return _Utils_Tuple2(model, _List_Nil);
			case 81:
				var fichier = msg.a;
				return _Utils_eq(model.mW, $author$project$Components$Produits$Reference$Model$DefinitionDeLImage) ? _Utils_Tuple2(
					model,
					_List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$LireUnFichierGlisse(fichier)
						])) : _Utils_Tuple2(model, _List_Nil);
			case 83:
				return $author$project$Components$Produits$Reference$Update$definirLImage(model);
			case 84:
				var origine = msg.a;
				return A2(
					$author$project$Components$Produits$Reference$Update$modifierLaDefinition,
					function (d) {
						return _Utils_update(
							d,
							{o4: origine, pZ: $elm$core$Maybe$Nothing});
					},
					model);
			case 85:
				var champ = msg.a;
				return A2(
					$author$project$Components$Produits$Reference$Update$modifierLaDefinition,
					function (d) {
						return _Utils_update(
							d,
							{
								uN: $elm$core$Maybe$Just(champ)
							});
					},
					model);
			case 86:
				return $author$project$Components$Produits$Reference$Update$reessayerLImage(model);
			case 87:
				return $author$project$Components$Produits$Reference$Update$remplacerLeFichierDeLImage(model);
			case 88:
				return $author$project$Components$Produits$Reference$Update$retraitDeLImageDemande(model);
			case 67:
				var langue = msg.a;
				var texte = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							xc: A2(
								$elm$core$Maybe$map,
								function (depot) {
									return _Utils_update(
										depot,
										{
											rF: A2(
												$elm$core$List$cons,
												_Utils_Tuple2(langue, texte),
												A2(
													$elm$core$List$filter,
													A2(
														$elm$core$Basics$composeR,
														$elm$core$Tuple$first,
														$elm$core$Basics$neq(langue)),
													depot.rF))
										});
								},
								model.xc)
						}),
					_List_Nil);
			case 68:
				var reponse = msg.a;
				return A2($author$project$Components$Produits$Reference$Update$apresUnMorceau, reponse, model);
			case 69:
				var reponse = msg.a;
				return A2($author$project$Components$Produits$Reference$Update$apresLaCloture, reponse, model);
			case 70:
				var champ = msg.a;
				var _v41 = A2(
					$elm$core$Maybe$andThen,
					function (fiche) {
						return A2($author$project$Components$Produits$Reference$Model$lienDuRetrait, fiche, champ);
					},
					model.zo);
				if (!_v41.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dh: $elm$core$Maybe$Just(champ)
							}),
						_List_fromArray(
							[
								$author$project$Components$Produits$Common$Effet$PlacerFocus($author$project$Components$Produits$Reference$Model$idsDuRetrait.to)
							]));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 71:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dh: $elm$core$Maybe$Nothing}),
					_List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$PlacerFocus($author$project$Components$Produits$Reference$Model$idDuDepot)
						]));
			case 72:
				var _v42 = _Utils_Tuple3(
					model.dh,
					model.zo,
					A2(
						$elm$core$Maybe$andThen,
						function (champ) {
							return A2(
								$elm$core$Maybe$andThen,
								function (fiche) {
									return A2($author$project$Components$Produits$Reference$Model$lienDuRetrait, fiche, champ);
								},
								model.zo);
						},
						model.dh));
				if (((!_v42.a.$) && (!_v42.b.$)) && (!_v42.c.$)) {
					var champ = _v42.a.a;
					var fiche = _v42.b.a;
					var lien = _v42.c.a;
					var _v43 = A3(
						$author$project$Components$Produits$Common$Envoi$partir,
						$elm$core$Maybe$Just(lien),
						A2($author$project$Catalogue$API$WriteAPIModel$RetirerLeFichier, fiche.Aq, champ),
						model.l2);
					if (!_v43.$) {
						var _v44 = _v43.a;
						var envoi = _v44.a;
						var effets = _v44.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{dh: $elm$core$Maybe$Nothing, l2: envoi}),
							effets);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 74:
				var typeVise = msg.a;
				var reponse = msg.b;
				var _v45 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Reference$API$QueryAPIModel$partiesPrenantesProposeesDecoder, reponse);
				if (!_v45.$) {
					var fiches = _v45.a;
					return _Utils_Tuple2(
						A3($author$project$Components$Produits$Reference$Model$proposer, typeVise, fiches, model),
						_List_Nil);
				} else {
					var refus = _v45.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 73:
				var reponse = msg.a;
				var _v46 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Reference$API$QueryAPIModel$documentsDecoder, reponse);
				if (!_v46.$) {
					var documents = _v46.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{gb: documents}),
						_List_Nil);
				} else {
					var refus = _v46.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 75:
				var _v47 = _Utils_Tuple2(
					model.kT,
					A2($elm$core$Maybe$andThen, $author$project$Components$Produits$Reference$Model$lienDesDocuments, model.zo));
				if ((!_v47.a) && (!_v47.b.$)) {
					var lien = _v47.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{kT: true}),
						_List_fromArray(
							[
								$author$project$Components$Produits$Common$Effet$LireLesDocuments(lien)
							]));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			default:
				var reponse = msg.a;
				var _v48 = A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, model.l2);
				if (!_v48.$) {
					var _v49 = _v48.a;
					var envoi = _v49.a;
					var issue = _v49.b;
					var effets = _v49.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Produits$Reference$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Components$Produits$Reference$Update$update = F3(
	function (i18n, msg, model) {
		return $author$project$Components$Produits$Reference$Update$lireLApercuDuBrouillon(
			A3($author$project$Components$Produits$Reference$Update$miseAJour, i18n, msg, model));
	});
var $author$project$Main$Update$versLaReference = F3(
	function (i18n, msg, model) {
		var _v0 = A3(
			$author$project$Components$Produits$Reference$Update$update,
			i18n,
			msg,
			A2(
				$author$project$Referentiel$Normes$poser,
				model.hd,
				$author$project$Components$Produits$Reference$Model$ouvrir(model.Hc)));
		var reference = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLesElements, effets) ? _List_Nil : model.Ct;
		var depuisLaReference = F2(
			function (effet, _v2) {
				var courant = _v2.a;
				var faits = _v2.b;
				switch (effet.$) {
					case 21:
						var numero = effet.a;
						var lien = effet.b;
						var recherche = effet.c;
						return _Utils_Tuple2(
							courant,
							_Utils_ap(
								faits,
								A3(
									$author$project$Main$Update$versLApi,
									courant,
									lien,
									function (vers) {
										return $author$project$Main$Update$ChercherLesArticlesALier(
											{gM: vers.gM, nB: vers.nB, DX: numero, hC: recherche});
									})));
					case 14:
						var lien = effet.a;
						return _Utils_Tuple2(
							courant,
							_Utils_ap(
								faits,
								A3($author$project$Main$Update$versLApi, courant, lien, $author$project$Main$Update$LireLeCatalogueDesFiltres)));
					case 13:
						var lien = effet.a;
						return _Utils_Tuple2(
							courant,
							_Utils_ap(
								faits,
								A3($author$project$Main$Update$versLApi, courant, lien, $author$project$Main$Update$LireLaStructureDesFiltres)));
					default:
						return A5(
							$author$project$Main$Update$depuisLesElements,
							i18n,
							9,
							14,
							effet,
							_Utils_Tuple2(courant, faits));
				}
			});
		return A3(
			$elm$core$List$foldl,
			depuisLaReference,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							A2(
								$author$project$Components$Produits$Reference$Update$popMessages,
								$author$project$Components$Produits$Reference$Model$ouvrir(model.Hc),
								msg),
							gardes),
						Hc: $author$project$Components$Produits$Reference$Model$envelopper(reference)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$AttendreAvantDeRelireLeCompteDEnvoi = function (a) {
	return {$: 254, a: a};
};
var $author$project$Main$Update$EnvoyerAuCompteDEnvoi = function (a) {
	return {$: 253, a: a};
};
var $author$project$Main$Update$LireLeCompteDEnvoi = function (a) {
	return {$: 252, a: a};
};
var $author$project$Main$Model$PourLeCompteDEnvoi = 48;
var $author$project$Main$Update$depuisLeCompteDEnvoi = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[48]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 1:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLeCompteDEnvoi)));
			case 2:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerAuCompteDEnvoi(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 3:
				var delaiMs = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AttendreAvantDeRelireLeCompteDEnvoi(delaiMs)
							])));
			case 4:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$Compte = function (etat) {
	return function (fournisseur) {
		return function (expediteur) {
			return function (nomAffiche) {
				return function (reponseA) {
					return function (finDeCle) {
						return function (etapes) {
							return function (adresseDuTest) {
								return function (remplacement) {
									return function (historique) {
										return function (liens) {
											return {iE: adresseDuTest, yL: etapes, gt: etat, mr: expediteur, mJ: finDeCle, zW: fournisseur, m6: historique, nQ: liens, ov: nomAffiche, HA: remplacement, qw: reponseA};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$AVenir = {$: 4};
var $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$Bloquee = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$Echouee = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$EnCours = {$: 1};
var $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$Etape = F2(
	function (etape, etat) {
		return {me: etape, gt: etat};
	});
var $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$Franchie = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$etapeDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$Etape,
	A2($elm$json$Json$Decode$field, 'etape', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$map,
		function (_v0) {
			var etat = _v0.a;
			var le = _v0.b;
			var _v1 = _Utils_Tuple2(etat, le);
			_v1$4:
			while (true) {
				switch (_v1.a) {
					case 'franchie':
						if (!_v1.b.$) {
							var instant = _v1.b.a;
							return $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$Franchie(instant);
						} else {
							break _v1$4;
						}
					case 'en-cours':
						return $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$EnCours;
					case 'echouee':
						return $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$Echouee(le);
					case 'bloquee':
						if (!_v1.b.$) {
							var instant = _v1.b.a;
							return $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$Bloquee(instant);
						} else {
							break _v1$4;
						}
					default:
						break _v1$4;
				}
			}
			return $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$AVenir;
		},
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			A2($elm$json$Json$Decode$field, 'etat', $elm$json$Json$Decode$string),
			$elm$json$Json$Decode$maybe(
				A2($elm$json$Json$Decode$field, 'le', $elm$json$Json$Decode$string)))));
var $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$EnErreur = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$EnVerification = {$: 1};
var $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$NonConfigure = {$: 0};
var $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$Verifie = {$: 2};
var $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$etatDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (_v0) {
		var etat = _v0.a;
		var motif = _v0.b;
		switch (etat) {
			case 'non-configure':
				return $elm$json$Json$Decode$succeed($author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$NonConfigure);
			case 'en-verification':
				return $elm$json$Json$Decode$succeed($author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$EnVerification);
			case 'verifie':
				return $elm$json$Json$Decode$succeed($author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$Verifie);
			case 'en-erreur':
				return $elm$json$Json$Decode$succeed(
					$author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$EnErreur(
						A2($elm$core$Maybe$withDefault, '', motif)));
			default:
				return $elm$json$Json$Decode$fail(etat);
		}
	},
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$Tuple$pair,
		A2($elm$json$Json$Decode$field, 'etat', $elm$json$Json$Decode$string),
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'motif', $elm$json$Json$Decode$string))));
var $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$Fait = F5(
	function (le, fait, detail, parNom, automatique) {
		return {t2: automatique, bB: detail, zf: fait, Bf: le, ET: parNom};
	});
var $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$faitDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'par',
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Basics$eq($elm$core$Maybe$Nothing),
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
	true,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'parNom',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'detail',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'fait',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'le',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$Fait))))));
var $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$Remplacement = F7(
	function (etat, expediteur, nomAffiche, reponseA, finDeCle, etapes, adresseDuTest) {
		return {iE: adresseDuTest, yL: etapes, gt: etat, mr: expediteur, mJ: finDeCle, ov: nomAffiche, qw: reponseA};
	});
var $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$remplacementDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'adresseDuTest',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'etapes',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$etapeDecoder),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'finDeCle',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'reponseA',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'nomAffiche',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'expediteur',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							$author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$etatDecoder,
							$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$Remplacement))))))));
var $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$compteDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'_links',
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$decoder),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'historique',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$faitDecoder),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'remplacement',
			$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$remplacementDecoder),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'adresseDuTest',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'etapes',
					$elm$json$Json$Decode$list($author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$etapeDecoder),
					_List_Nil,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'finDeCle',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'reponseA',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'nomAffiche',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'expediteur',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'fournisseur',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										$elm$core$Maybe$Nothing,
										A2(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
											$author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$etatDecoder,
											$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$Compte))))))))))));
var $author$project$Components$Parametrage$CompteDEnvoi$Update$popMessages = function (msg) {
	if (msg.$ === 2) {
		var reponse = msg.a;
		var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$compteDecoder, reponse);
		if (_v1.$ === 1) {
			var refus = _v1.a;
			return A2(
				$elm$core$List$member,
				refus.ri,
				_List_fromArray(
					[401, 403])) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				$author$project$Components$Shared$Messages$Model$duRefus(refus));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Main$Update$requeteSurLeCompteDEnvoi = function (effet) {
	switch (effet.$) {
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIModel$AnnulerLeRemplacement = {$: 3};
var $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIModel$ConnecterBrevo = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIModel$Deconnecter = {$: 4};
var $author$project$Components$Parametrage$CompteDEnvoi$Update$DemanderProcessUid = {$: 0};
var $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIModel$EnvoyerUnEmailDeTest = {$: 5};
var $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIModel$ModifierLExpediteur = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$CompteDEnvoi$Model$ModifierLExpediteur = 2;
var $author$project$Components$Parametrage$CompteDEnvoi$Update$PlacerFocus = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$CompteDEnvoi$Model$Remplacer = 1;
var $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIModel$Verifier = {$: 2};
var $author$project$API$NavLinksDictionary$annulerLeRemplacement = 'annuler-le-remplacement';
var $author$project$API$NavLinksDictionary$compteDEnvoi = 'compte-d-envoi';
var $author$project$Components$Parametrage$CompteDEnvoi$Update$AttendreAvantDeRelire = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$CompteDEnvoi$Update$adresseIpRefusee = function (model) {
	var _v0 = model.vW;
	if (!_v0.$) {
		var lu = _v0.a;
		return _Utils_eq(
			A2(
				$elm$core$Maybe$withDefault,
				lu.gt,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.gt;
					},
					lu.HA)),
			$author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$EnErreur('adresse_ip_refusee'));
	} else {
		return false;
	}
};
var $author$project$Components$Parametrage$CompteDEnvoi$Model$Echoue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$CompteDEnvoi$Model$Envoye = {$: 0};
var $author$project$Components$Parametrage$CompteDEnvoi$Update$emailDeTest = function (rendue) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var fait = _v0.a;
				var motif = _v0.b;
				switch (fait) {
					case 'EmailDeTestEnvoye':
						return $elm$core$Maybe$Just($author$project$Components$Parametrage$CompteDEnvoi$Model$Envoye);
					case 'EmailDeTestEchoue':
						return $elm$core$Maybe$Just(
							$author$project$Components$Parametrage$CompteDEnvoi$Model$Echoue(
								A2($elm$core$Maybe$withDefault, '', motif)));
					default:
						return $elm$core$Maybe$Nothing;
				}
			},
			rendue.zi));
};
var $author$project$Components$Parametrage$CompteDEnvoi$Update$Lire = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$CompteDEnvoi$Update$relire = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$CompteDEnvoi$Update$Lire, $elm$core$List$singleton),
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$compteDEnvoi, model.nQ)));
};
var $author$project$I18n$Traductions$Rogne = function (a) {
	return {$: 4, a: a};
};
var $author$project$I18n$Choix$codeElision = function (choix) {
	switch (choix) {
		case 0:
			return 'aucune';
		case 1:
			return 'elide';
		default:
			return 'other';
	}
};
var $author$project$I18n$Textes$compteDEnvoiRefusAcces = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'compte-d-envoi.refus.acces',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'elision',
				$author$project$I18n$Traductions$Option(
					$author$project$I18n$Choix$codeElision(p.av))),
				_Utils_Tuple2(
				'espace',
				$author$project$I18n$Traductions$Rogne(p.yz))
			]),
		'Seul un administrateur {elision, select, elide {d\'{espace}} other {de {espace}}} connecte, vérifie ou déconnecte le compte d\'envoi.');
};
var $author$project$I18n$Textes$compteDEnvoiRefusAccesSansEspace = A3($author$project$I18n$Traductions$texte, 'compte-d-envoi.refus.acces.sans-espace', _List_Nil, 'Seul un administrateur de l\'espace connecte, vérifie ou déconnecte le compte d\'envoi.');
var $author$project$I18n$Textes$compteDEnvoiRefusNonConfigure = A3($author$project$I18n$Traductions$texte, 'compte-d-envoi.refus.non-configure', _List_Nil, 'Aucun compte n\'est connecté : il n\'y a rien à vérifier.');
var $author$project$I18n$Textes$compteDEnvoiRefusNonVerifie = A3($author$project$I18n$Traductions$texte, 'compte-d-envoi.refus.non-verifie', _List_Nil, 'Le compte n\'est pas vérifié : l\'email de test ne part que d\'un compte vérifié.');
var $author$project$I18n$Textes$compteDEnvoiRefusRemplacementEnCours = A3($author$project$I18n$Traductions$texte, 'compte-d-envoi.refus.remplacement-en-cours', _List_Nil, 'Un remplacement est en cours : l\'expéditeur du compte actuel ne se modifie plus. Annulez le remplacement, ou attendez sa vérification.');
var $author$project$I18n$Textes$compteDEnvoiRefusSaisie = A3($author$project$I18n$Traductions$texte, 'compte-d-envoi.refus.saisie', _List_Nil, 'La connexion n\'est pas acceptée : corrigez les champs signalés, puis saisissez de nouveau la clé d\'API.');
var $author$project$I18n$Choix$ElisionElide = 1;
var $author$project$I18n$Choix$ElisionOther = 2;
var $author$project$Texte$Elision$lettresElidantes = _List_fromArray(
	['a', 'e', 'i', 'o', 'u', 'y', 'à', 'â', 'ä', 'é', 'è', 'ê', 'ë', 'î', 'ï', 'ô', 'ö', 'ù', 'û', 'ü', 'ÿ', 'œ', 'æ', 'h']);
var $elm$core$Char$toLower = _Char_toLower;
var $author$project$Texte$Elision$elision = function (nom) {
	var _v0 = $elm$core$String$uncons(
		$elm$core$String$trim(nom));
	if (!_v0.$) {
		var _v1 = _v0.a;
		var premiere = _v1.a;
		return A2(
			$elm$core$List$member,
			$elm$core$Char$toLower(premiere),
			$author$project$Texte$Elision$lettresElidantes) ? 1 : 2;
	} else {
		return 2;
	}
};
var $author$project$Components$Parametrage$CompteDEnvoi$Update$texteDuRefus = F3(
	function (model, refus, erreur) {
		switch (erreur.$) {
			case 0:
				return $author$project$I18n$Textes$compteDEnvoiRefusNonConfigure;
			case 1:
				return $author$project$I18n$Textes$compteDEnvoiRefusNonVerifie;
			case 2:
				return $author$project$I18n$Textes$compteDEnvoiRefusRemplacementEnCours;
			case 3:
				return $author$project$I18n$Textes$compteDEnvoiRefusSaisie;
			case 4:
				var _v1 = model.g5;
				if (!_v1.$) {
					var espace = _v1.a;
					return $author$project$I18n$Textes$compteDEnvoiRefusAcces(
						{
							av: $author$project$Texte$Elision$elision(espace),
							yz: $author$project$I18n$Traductions$tel(espace)
						});
				} else {
					return $author$project$I18n$Textes$compteDEnvoiRefusAccesSansEspace;
				}
			default:
				return $author$project$Components$Shared$Messages$Model$duRefus(refus).Jx;
		}
	});
var $author$project$Components$Parametrage$CompteDEnvoi$Model$saisieDuCompte = function (compte) {
	var lu = function (champ) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Maybe$andThen, champ, compte));
	};
	return _Utils_update(
		$author$project$Components$Parametrage$CompteDEnvoi$Model$saisieVide,
		{
			mr: lu(
				function ($) {
					return $.mr;
				}),
			ov: lu(
				function ($) {
					return $.ov;
				}),
			qw: lu(
				function ($) {
					return $.qw;
				})
		});
};
var $author$project$Components$Parametrage$CompteDEnvoi$Model$saisieEnCours = function (model) {
	return !_Utils_eq(
		model.hP,
		$author$project$Components$Parametrage$CompteDEnvoi$Model$saisieDuCompte(model.vW));
};
var $author$project$Components$Parametrage$CompteDEnvoi$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{kX: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Parametrage$CompteDEnvoi$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Parametrage$CompteDEnvoi$Model$saisieEnCours(model)
				},
				geste,
				model.kX));
	});
var $author$project$Components$Parametrage$CompteDEnvoi$Update$versLeDrawerDAnnulation = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{k$: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Parametrage$CompteDEnvoi$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.k$));
	});
var $author$project$Components$Parametrage$CompteDEnvoi$Update$versLeDrawerDeDeconnexion = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{k8: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Parametrage$CompteDEnvoi$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.k8));
	});
var $author$project$Components$Parametrage$CompteDEnvoi$Update$conclure = F2(
	function (issue, model) {
		var sansCle = _Utils_update(
			model,
			{
				hP: function (s) {
					return _Utils_update(
						s,
						{dy: ''});
				}(model.hP)
			});
		switch (issue.$) {
			case 0:
				var commande = issue.a;
				var rendue = issue.b;
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					function (m) {
						return _Utils_update(
							m,
							{hP: $author$project$Components$Parametrage$CompteDEnvoi$Model$saisieVide});
					},
					A2(
						$author$project$Components$Parametrage$CompteDEnvoi$Update$versLeDrawer,
						$author$project$Components$Shared$Drawer$Update$Fermer,
						_Utils_update(
							sansCle,
							{
								ft: rendue.nQ,
								lT: _Utils_eq(commande, $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIModel$EnvoyerUnEmailDeTest) ? $author$project$Components$Parametrage$CompteDEnvoi$Update$emailDeTest(rendue) : $elm$core$Maybe$Nothing,
								rK: _Utils_eq(commande, $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIModel$Verifier) && ($elm$core$List$isEmpty(rendue.zi) && $author$project$Components$Parametrage$CompteDEnvoi$Update$adresseIpRefusee(model))
							})));
				var ferme = _v1.a;
				var focus = _v1.b;
				var _v2 = function (_v3) {
					var m = _v3.a;
					var f = _v3.b;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(f),
						A2($author$project$Components$Parametrage$CompteDEnvoi$Update$versLeDrawerDAnnulation, $author$project$Components$Shared$Drawer$Update$Fermer, m));
				}(
					A2($author$project$Components$Parametrage$CompteDEnvoi$Update$versLeDrawerDeDeconnexion, $author$project$Components$Shared$Drawer$Update$Fermer, ferme));
				var fermes = _v2.a;
				var focusDeDeconnexion = _v2.b;
				return _Utils_Tuple2(
					fermes,
					_Utils_ap(
						focus,
						_Utils_ap(
							focusDeDeconnexion,
							rendue.sy ? $author$project$Components$Parametrage$CompteDEnvoi$Update$relire(fermes) : _List_fromArray(
								[
									$author$project$Components$Parametrage$CompteDEnvoi$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
								]))));
			case 1:
				var commande = issue.a;
				var refus = issue.b;
				var erreur = issue.c;
				var refuse = _Utils_update(
					sansCle,
					{
						fL: function () {
							if (erreur.$ === 3) {
								var champs = erreur.a;
								return champs;
							} else {
								return _List_Nil;
							}
						}(),
						pZ: $elm$core$Maybe$Just(
							{
								Jx: A3($author$project$Components$Parametrage$CompteDEnvoi$Update$texteDuRefus, model, refus, erreur),
								b9: refus.b9
							})
					});
				switch (commande.$) {
					case 4:
						return A2($author$project$Components$Parametrage$CompteDEnvoi$Update$versLeDrawerDeDeconnexion, $author$project$Components$Shared$Drawer$Update$Fermer, refuse);
					case 3:
						return A2($author$project$Components$Parametrage$CompteDEnvoi$Update$versLeDrawerDAnnulation, $author$project$Components$Shared$Drawer$Update$Fermer, refuse);
					default:
						return _Utils_Tuple2(refuse, _List_Nil);
				}
			default:
				return _Utils_Tuple2(sansCle, _List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$connecterBrevo = 'connecter-brevo';
var $author$project$Components$Parametrage$CompteDEnvoi$Model$connexion = function (saisie) {
	var nonVide = function (texte) {
		return $elm$core$String$isEmpty(texte) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(texte);
	};
	var lue = {
		jU: $elm$core$String$trim(saisie.dy),
		mr: $elm$core$String$trim(saisie.mr),
		ov: $elm$core$String$trim(saisie.ov),
		qw: A2(
			$elm$core$Maybe$andThen,
			nonVide,
			$elm$core$Maybe$Just(
				$elm$core$String$trim(saisie.qw)))
	};
	return A2(
		$elm$core$List$any,
		$elm$core$String$isEmpty,
		_List_fromArray(
			[lue.jU, lue.ov, lue.mr])) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(lue);
};
var $author$project$API$NavLinksDictionary$deconnecter = 'deconnecter';
var $author$project$Components$Parametrage$CompteDEnvoi$Model$lienDe = F2(
	function (rel, model) {
		return A2($author$project$API$Liens$trouver, rel, model.ft);
	});
var $author$project$Components$Parametrage$CompteDEnvoi$Update$Envoyer = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$CompteDEnvoi$Update$Reconnecter = {$: 5};
var $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIErrorsModel$AccesRefuse = {$: 4};
var $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIErrorsModel$AutreRefus = {$: 5};
var $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIErrorsModel$CompteNonConfigure = {$: 0};
var $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIErrorsModel$CompteNonVerifie = {$: 1};
var $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIErrorsModel$RemplacementEnCours = {$: 2};
var $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIErrorsModel$SaisieRefusee = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIErrorsModel$duRefus = function (reponse) {
	var _v0 = A2(
		$author$project$API$Reponse$lire,
		$elm$json$Json$Decode$succeed(0),
		reponse);
	if (_v0.$ === 1) {
		var refus = _v0.a;
		var _v1 = _Utils_Tuple2(refus.ri, refus.bB);
		_v1$6:
		while (true) {
			switch (_v1.a) {
				case 409:
					if (_v1.b.$ === 1) {
						switch (_v1.b.a) {
							case 'CompteNonConfigure':
								return $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIErrorsModel$CompteNonConfigure;
							case 'CompteNonVerifie':
								return $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIErrorsModel$CompteNonVerifie;
							case 'RemplacementEnCours':
								return $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIErrorsModel$RemplacementEnCours;
							default:
								break _v1$6;
						}
					} else {
						break _v1$6;
					}
				case 400:
					if (_v1.b.$ === 6) {
						var invalides = _v1.b.a;
						return $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIErrorsModel$SaisieRefusee(
							A2(
								$elm$core$List$concatMap,
								function ($) {
									return $.E6;
								},
								invalides));
					} else {
						return $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIErrorsModel$SaisieRefusee(_List_Nil);
					}
				case 403:
					return $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIErrorsModel$AccesRefuse;
				default:
					break _v1$6;
			}
		}
		return $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIErrorsModel$AutreRefus;
	} else {
		return $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIErrorsModel$AutreRefus;
	}
};
var $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIModel$Rendue = F3(
	function (faits, vuesAJour, liens) {
		return {zi: faits, nQ: liens, sy: vuesAJour};
	});
var $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIModel$faitDecoder = A2(
	$elm$json$Json$Decode$field,
	'event',
	$elm$json$Json$Decode$keyValuePairs(
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'motif', $elm$json$Json$Decode$string))));
var $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIModel$rendueDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'liens',
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vuesAJour',
		$elm$json$Json$Decode$bool,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'evenements',
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$List$concat,
				$elm$json$Json$Decode$list($author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIModel$faitDecoder)),
			_List_Nil,
			$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIModel$Rendue))));
var $author$project$Components$Parametrage$CompteDEnvoi$Update$reglage = {
	f8: $author$project$Components$Parametrage$CompteDEnvoi$Update$DemanderProcessUid,
	l4: $author$project$Components$Parametrage$CompteDEnvoi$Update$Envoyer,
	go: $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIErrorsModel$duRefus,
	pW: $author$project$Components$Parametrage$CompteDEnvoi$Update$Reconnecter,
	qu: F2(
		function (_v0, _v1) {
			return true;
		}),
	qv: $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIModel$rendueDecoder
};
var $author$project$Components$Parametrage$CompteDEnvoi$Update$envoyer = F3(
	function (rel, commande, model) {
		var _v0 = A4(
			$author$project$API$Envoi$partir,
			$author$project$Components$Parametrage$CompteDEnvoi$Update$reglage,
			A2($author$project$Components$Parametrage$CompteDEnvoi$Model$lienDe, rel, model),
			commande,
			model.l2);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var envoi = _v1.a;
			var effets = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{fL: _List_Nil, lT: $elm$core$Maybe$Nothing, l2: envoi, pZ: $elm$core$Maybe$Nothing, rK: false}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$envoyerUnEmailDeTest = 'envoyer-un-email-de-test';
var $author$project$Components$Parametrage$CompteDEnvoi$Model$expediteurSaisi = function (saisie) {
	return A2(
		$elm$core$Maybe$map,
		function (lue) {
			return {mr: lue.mr, ov: lue.ov, qw: lue.qw};
		},
		$author$project$Components$Parametrage$CompteDEnvoi$Model$connexion(
			_Utils_update(
				saisie,
				{dy: '-'})));
};
var $author$project$Components$Parametrage$CompteDEnvoi$Update$idsDeLAnnulation = $author$project$Components$Shared$Confirmation$Clavier$ids('compte-d-envoi-annuler-le-remplacement');
var $author$project$Components$Parametrage$CompteDEnvoi$Update$idsDeLaDeconnexion = $author$project$Components$Shared$Confirmation$Clavier$ids('compte-d-envoi-deconnecter');
var $author$project$API$NavLinksDictionary$modifierLExpediteur = 'modifier-l-expediteur';
var $author$project$Components$Parametrage$CompteDEnvoi$Update$siLibre = F2(
	function (model, geste) {
		return $author$project$API$Envoi$enCours(model.l2) ? _Utils_Tuple2(model, _List_Nil) : geste(model);
	});
var $author$project$Components$Parametrage$CompteDEnvoi$Update$ouvrirLeDrawer = F4(
	function (rel, mode, declencheur, model) {
		var _v0 = A2($author$project$Components$Parametrage$CompteDEnvoi$Model$lienDe, rel, model);
		if (!_v0.$) {
			return A2(
				$author$project$Components$Parametrage$CompteDEnvoi$Update$siLibre,
				model,
				A2(
					$elm$core$Basics$composeL,
					$author$project$Components$Parametrage$CompteDEnvoi$Update$versLeDrawer(
						$author$project$Components$Shared$Drawer$Update$Ouvrir(declencheur)),
					function (m) {
						return _Utils_update(
							m,
							{
								fL: _List_Nil,
								n9: mode,
								pZ: $elm$core$Maybe$Nothing,
								hP: $author$project$Components$Parametrage$CompteDEnvoi$Model$saisieDuCompte(m.vW)
							});
					}));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$CompteDEnvoi$Update$pasLu = F2(
	function (refus, model) {
		return _Utils_Tuple2(
			(refus.ri === 403) ? _Utils_update(
				model,
				{ft: _List_Nil, vW: $elm$core$Maybe$Nothing, gd: false, qa: true}) : _Utils_update(
				model,
				{gd: true}),
			(refus.ri === 401) ? _List_fromArray(
				[$author$project$Components$Parametrage$CompteDEnvoi$Update$Reconnecter]) : _List_Nil);
	});
var $author$project$Components$Parametrage$CompteDEnvoi$Update$saisir = F2(
	function (changer, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					hP: changer(model.hP)
				}),
			_List_Nil);
	});
var $author$project$API$NavLinksDictionary$verifier = 'verifier';
var $author$project$Components$Parametrage$CompteDEnvoi$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var liens = msg.a;
				var nomDuClient = msg.b;
				var ouvert = _Utils_update(
					model,
					{
						gd: false,
						nQ: liens,
						g5: nomDuClient,
						qa: _Utils_eq(
							A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$compteDEnvoi, liens),
							$elm$core$Maybe$Nothing)
					});
				return _Utils_Tuple2(
					ouvert,
					A2(
						$elm$core$List$cons,
						$author$project$Components$Parametrage$CompteDEnvoi$Update$DemanderProcessUid,
						$author$project$Components$Parametrage$CompteDEnvoi$Update$relire(ouvert)));
			case 1:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 2:
				var reponse = msg.a;
				var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$compteDecoder, reponse);
				if (!_v1.$) {
					var compte = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ft: compte.nQ,
								vW: $elm$core$Maybe$Just(compte),
								gd: false
							}),
						_List_Nil);
				} else {
					var refus = _v1.a;
					return A2($author$project$Components$Parametrage$CompteDEnvoi$Update$pasLu, refus, model);
				}
			case 3:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Parametrage$CompteDEnvoi$Update$relire(model));
			case 4:
				var geste = msg.a;
				return A2(
					$author$project$Components$Parametrage$CompteDEnvoi$Update$siLibre,
					model,
					$author$project$Components$Parametrage$CompteDEnvoi$Update$versLeDrawer(geste));
			case 5:
				var geste = msg.a;
				return A2(
					$author$project$Components$Parametrage$CompteDEnvoi$Update$siLibre,
					model,
					$author$project$Components$Parametrage$CompteDEnvoi$Update$versLeDrawerDeDeconnexion(geste));
			case 6:
				var geste = msg.a;
				return A2(
					$author$project$Components$Parametrage$CompteDEnvoi$Update$siLibre,
					model,
					$author$project$Components$Parametrage$CompteDEnvoi$Update$versLeDrawerDAnnulation(geste));
			case 7:
				return A4(
					$author$project$Components$Parametrage$CompteDEnvoi$Update$ouvrirLeDrawer,
					$author$project$API$NavLinksDictionary$connecterBrevo,
					_Utils_eq(
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.gt;
							},
							model.vW),
						$elm$core$Maybe$Just($author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$Verifie)) ? 1 : 0,
					'compte-d-envoi-connecter-ouvrir',
					model);
			case 8:
				return A4($author$project$Components$Parametrage$CompteDEnvoi$Update$ouvrirLeDrawer, $author$project$API$NavLinksDictionary$modifierLExpediteur, 2, 'compte-d-envoi-expediteur-ouvrir', model);
			case 9:
				var cle = msg.a;
				return A2(
					$author$project$Components$Parametrage$CompteDEnvoi$Update$saisir,
					function (s) {
						return _Utils_update(
							s,
							{dy: cle});
					},
					model);
			case 10:
				var nom = msg.a;
				return A2(
					$author$project$Components$Parametrage$CompteDEnvoi$Update$saisir,
					function (s) {
						return _Utils_update(
							s,
							{ov: nom});
					},
					model);
			case 11:
				var adresse = msg.a;
				return A2(
					$author$project$Components$Parametrage$CompteDEnvoi$Update$saisir,
					function (s) {
						return _Utils_update(
							s,
							{mr: adresse});
					},
					model);
			case 12:
				var adresse = msg.a;
				return A2(
					$author$project$Components$Parametrage$CompteDEnvoi$Update$saisir,
					function (s) {
						return _Utils_update(
							s,
							{qw: adresse});
					},
					model);
			case 13:
				var _v2 = model.n9;
				if (_v2 === 2) {
					var _v3 = $author$project$Components$Parametrage$CompteDEnvoi$Model$expediteurSaisi(model.hP);
					if (!_v3.$) {
						var expediteur = _v3.a;
						return A3(
							$author$project$Components$Parametrage$CompteDEnvoi$Update$envoyer,
							$author$project$API$NavLinksDictionary$modifierLExpediteur,
							$author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIModel$ModifierLExpediteur(expediteur),
							model);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				} else {
					var _v4 = $author$project$Components$Parametrage$CompteDEnvoi$Model$connexion(model.hP);
					if (!_v4.$) {
						var connexion = _v4.a;
						return A3(
							$author$project$Components$Parametrage$CompteDEnvoi$Update$envoyer,
							$author$project$API$NavLinksDictionary$connecterBrevo,
							$author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIModel$ConnecterBrevo(connexion),
							model);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				}
			case 14:
				return A3($author$project$Components$Parametrage$CompteDEnvoi$Update$envoyer, $author$project$API$NavLinksDictionary$verifier, $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIModel$Verifier, model);
			case 15:
				var _v5 = A2($author$project$Components$Parametrage$CompteDEnvoi$Model$lienDe, $author$project$API$NavLinksDictionary$deconnecter, model);
				if (!_v5.$) {
					return A2(
						$author$project$Components$Parametrage$CompteDEnvoi$Update$siLibre,
						model,
						function (m) {
							return A2(
								$elm$core$Tuple$mapSecond,
								function (_v6) {
									return _List_fromArray(
										[
											$author$project$Components$Parametrage$CompteDEnvoi$Update$PlacerFocus($author$project$Components$Parametrage$CompteDEnvoi$Update$idsDeLaDeconnexion.to)
										]);
								},
								A2(
									$author$project$Components$Parametrage$CompteDEnvoi$Update$versLeDrawerDeDeconnexion,
									$author$project$Components$Shared$Drawer$Update$Ouvrir('compte-d-envoi-deconnecter-ouvrir'),
									_Utils_update(
										m,
										{pZ: $elm$core$Maybe$Nothing})));
						});
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 16:
				return A3($author$project$Components$Parametrage$CompteDEnvoi$Update$envoyer, $author$project$API$NavLinksDictionary$deconnecter, $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIModel$Deconnecter, model);
			case 17:
				var _v7 = A2($author$project$Components$Parametrage$CompteDEnvoi$Model$lienDe, $author$project$API$NavLinksDictionary$annulerLeRemplacement, model);
				if (!_v7.$) {
					return A2(
						$author$project$Components$Parametrage$CompteDEnvoi$Update$siLibre,
						model,
						function (m) {
							return A2(
								$elm$core$Tuple$mapSecond,
								function (_v8) {
									return _List_fromArray(
										[
											$author$project$Components$Parametrage$CompteDEnvoi$Update$PlacerFocus($author$project$Components$Parametrage$CompteDEnvoi$Update$idsDeLAnnulation.to)
										]);
								},
								A2(
									$author$project$Components$Parametrage$CompteDEnvoi$Update$versLeDrawerDAnnulation,
									$author$project$Components$Shared$Drawer$Update$Ouvrir('compte-d-envoi-annuler-le-remplacement-ouvrir'),
									_Utils_update(
										m,
										{pZ: $elm$core$Maybe$Nothing})));
						});
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 18:
				return A3($author$project$Components$Parametrage$CompteDEnvoi$Update$envoyer, $author$project$API$NavLinksDictionary$annulerLeRemplacement, $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIModel$AnnulerLeRemplacement, model);
			case 19:
				return A3($author$project$Components$Parametrage$CompteDEnvoi$Update$envoyer, $author$project$API$NavLinksDictionary$envoyerUnEmailDeTest, $author$project$Components$Parametrage$CompteDEnvoi$API$WriteAPIModel$EnvoyerUnEmailDeTest, model);
			default:
				var reponse = msg.a;
				var _v9 = A3($author$project$API$Envoi$conclure, $author$project$Components$Parametrage$CompteDEnvoi$Update$reglage, reponse, model.l2);
				if (!_v9.$) {
					var _v10 = _v9.a;
					var envoi = _v10.a;
					var issue = _v10.b;
					var effets = _v10.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Parametrage$CompteDEnvoi$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Main$Update$versLeCompteDEnvoi = F2(
	function (msg, model) {
		var _v0 = A2($author$project$Components$Parametrage$CompteDEnvoi$Update$update, msg, model.vX);
		var compte = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLeCompteDEnvoi, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLeCompteDEnvoi,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						vX: compte,
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Parametrage$CompteDEnvoi$Update$popMessages(msg),
							gardes)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$AttendreAvantDeRelireLeCompteur = function (a) {
	return {$: 251, a: a};
};
var $author$project$Main$Update$EnvoyerAuCompteur = function (a) {
	return {$: 250, a: a};
};
var $author$project$Main$Update$LireLeCompteur = F2(
	function (a, b) {
		return {$: 249, a: a, b: b};
	});
var $author$project$Main$Model$PourLeCompteurDeCode = 47;
var $author$project$Main$Update$depuisLeCompteur = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[47]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 1:
				var lecture = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLeCompteur(lecture))));
			case 2:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerAuCompteur(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 3:
				var delaiMs = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AttendreAvantDeRelireLeCompteur(delaiMs)
							])));
			case 4:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Parametrage$CompteurDeCode$Update$popMessages = function (_v0) {
	return $elm$core$Maybe$Nothing;
};
var $author$project$Main$Update$requeteSurLeCompteur = function (effet) {
	switch (effet.$) {
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Parametrage$CompteurDeCode$Update$DemanderProcessUid = {$: 0};
var $author$project$Components$Parametrage$CompteurDeCode$Model$commande = function (model) {
	var _v0 = _Utils_Tuple2(
		$elm$core$String$toInt(
			$elm$core$String$trim(model.vb)),
		$elm$core$String$toInt(
			$elm$core$String$trim(model.Ge)));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var chiffres = _v0.a.a;
		var premier = _v0.b.a;
		return ((chiffres > 0) && (premier >= 0)) ? $elm$core$Maybe$Just(
			{vb: chiffres, F$: model.F$, Ge: premier}) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$CompteurDeCode$Update$AttendreAvantDeRelire = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$CompteurDeCode$Update$LeReglage = 0;
var $author$project$Components$Parametrage$CompteurDeCode$Update$Lire = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$reglageDuCompteurDeCode = 'reglage-du-compteur-de-code';
var $author$project$Components$Parametrage$CompteurDeCode$Update$relire = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$Parametrage$CompteurDeCode$Update$Lire(0),
				$elm$core$List$singleton),
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reglageDuCompteurDeCode, model.nQ)));
};
var $author$project$Components$Parametrage$CompteurDeCode$Update$PlacerFocus = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$CompteurDeCode$Model$saisieEnCours = function (model) {
	var _v0 = model.eO;
	if (!_v0.$) {
		var reglage = _v0.a;
		return (!_Utils_eq(model.F$, reglage.F$)) || ((!_Utils_eq(
			model.vb,
			$elm$core$String$fromInt(reglage.vb))) || (!_Utils_eq(
			model.Ge,
			$elm$core$String$fromInt(reglage.Ge))));
	} else {
		return false;
	}
};
var $author$project$Components$Parametrage$CompteurDeCode$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{kX: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Parametrage$CompteurDeCode$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Parametrage$CompteurDeCode$Model$saisieEnCours(model)
				},
				geste,
				model.kX));
	});
var $author$project$Components$Parametrage$CompteurDeCode$Update$conclure = F2(
	function (issue, model) {
		switch (issue.$) {
			case 0:
				var rendue = issue.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(
						rendue.sy ? $author$project$Components$Parametrage$CompteurDeCode$Update$relire(model) : _List_fromArray(
							[
								$author$project$Components$Parametrage$CompteurDeCode$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
							])),
					A2(
						$author$project$Components$Parametrage$CompteurDeCode$Update$versLeDrawer,
						$author$project$Components$Shared$Drawer$Update$Fermer,
						_Utils_update(
							model,
							{pZ: $elm$core$Maybe$Nothing})));
			case 1:
				var erreur = issue.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							pZ: $elm$core$Maybe$Just(erreur)
						}),
					_List_Nil);
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$reglerLeCompteurDeCode = 'regler-le-compteur-de-code';
var $author$project$Components$Parametrage$CompteurDeCode$Model$lienDuReglage = function (model) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reglerLeCompteurDeCode, model.nQ);
};
var $author$project$Components$Parametrage$CompteurDeCode$Update$Reconnecter = {$: 5};
var $author$project$Components$Parametrage$CompteurDeCode$Update$pasLue = F2(
	function (refus, model) {
		return _Utils_Tuple2(
			(refus.ri === 403) ? _Utils_update(
				model,
				{gd: false, qa: true, eO: $elm$core$Maybe$Nothing}) : _Utils_update(
				model,
				{gd: true}),
			(refus.ri === 401) ? _List_fromArray(
				[$author$project$Components$Parametrage$CompteurDeCode$Update$Reconnecter]) : _List_Nil);
	});
var $author$project$Components$Parametrage$CompteurDeCode$API$QueryAPIModel$Reglage = F4(
	function (portee, chiffres, premier, dernier) {
		return {vb: chiffres, xg: dernier, F$: portee, Ge: premier};
	});
var $author$project$Components$Parametrage$CompteurDeCode$API$QueryAPIModel$DernierNumero = F2(
	function (portee, numero) {
		return {DX: numero, F$: portee};
	});
var $author$project$Components$Parametrage$CompteurDeCode$API$QueryAPIModel$dernierDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'numero',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'portee',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$CompteurDeCode$API$QueryAPIModel$DernierNumero)));
var $author$project$Components$Parametrage$CompteurDeCode$API$QueryAPIModel$reglageDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'dernierNumeroAttribue',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Parametrage$CompteurDeCode$API$QueryAPIModel$dernierDecoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'premier',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'chiffres',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'portee',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$CompteurDeCode$API$QueryAPIModel$Reglage)))));
var $author$project$Components$Parametrage$CompteurDeCode$Update$lue = F3(
	function (lecture, reponse, model) {
		var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$CompteurDeCode$API$QueryAPIModel$reglageDecoder, reponse);
		if (!_v1.$) {
			var lu = _v1.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						gd: false,
						eO: $elm$core$Maybe$Just(lu)
					}),
				_List_Nil);
		} else {
			var refus = _v1.a;
			return A2($author$project$Components$Parametrage$CompteurDeCode$Update$pasLue, refus, model);
		}
	});
var $author$project$Components$Parametrage$CompteurDeCode$Update$Envoyer = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$CompteurDeCode$API$WriteAPIErrorsModel$AccesRefuse = 1;
var $author$project$Components$Parametrage$CompteurDeCode$API$WriteAPIErrorsModel$AutreRefus = 2;
var $author$project$Components$Parametrage$CompteurDeCode$API$WriteAPIErrorsModel$ReglageRefuse = 0;
var $author$project$Components$Parametrage$CompteurDeCode$API$WriteAPIErrorsModel$duRefus = function (reponse) {
	if (reponse.ri === 403) {
		return 1;
	} else {
		var _v0 = A2(
			$elm$json$Json$Decode$decodeString,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['error']),
				$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value)),
			reponse.f$);
		if (((!_v0.$) && _v0.a.b) && (_v0.a.a.a === 'ReglageDuCompteurRefuse')) {
			var _v1 = _v0.a;
			var _v2 = _v1.a;
			return 0;
		} else {
			return 2;
		}
	}
};
var $author$project$Components$Parametrage$CompteurDeCode$API$WriteAPIModel$Rendue = F2(
	function (vuesAJour, liens) {
		return {nQ: liens, sy: vuesAJour};
	});
var $author$project$Components$Parametrage$CompteurDeCode$API$WriteAPIModel$rendueDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'liens',
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vuesAJour',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$CompteurDeCode$API$WriteAPIModel$Rendue)));
var $author$project$Components$Parametrage$CompteurDeCode$Update$reglage = {
	f8: $author$project$Components$Parametrage$CompteurDeCode$Update$DemanderProcessUid,
	l4: $author$project$Components$Parametrage$CompteurDeCode$Update$Envoyer,
	go: $author$project$Components$Parametrage$CompteurDeCode$API$WriteAPIErrorsModel$duRefus,
	pW: $author$project$Components$Parametrage$CompteurDeCode$Update$Reconnecter,
	qu: F2(
		function (_v0, _v1) {
			return true;
		}),
	qv: $author$project$Components$Parametrage$CompteurDeCode$API$WriteAPIModel$rendueDecoder
};
var $author$project$Components$Parametrage$CompteurDeCode$Update$siLibre = F2(
	function (model, geste) {
		return $author$project$API$Envoi$enCours(model.l2) ? _Utils_Tuple2(model, _List_Nil) : geste(model);
	});
var $author$project$Components$Parametrage$CompteurDeCode$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var liens = msg.a;
				var ouvert = _Utils_update(
					model,
					{gd: false, nQ: liens, qa: false});
				return _Utils_Tuple2(
					ouvert,
					A2(
						$elm$core$List$cons,
						$author$project$Components$Parametrage$CompteurDeCode$Update$DemanderProcessUid,
						$author$project$Components$Parametrage$CompteurDeCode$Update$relire(ouvert)));
			case 1:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 2:
				var lecture = msg.a;
				var reponse = msg.b;
				return A3($author$project$Components$Parametrage$CompteurDeCode$Update$lue, lecture, reponse, model);
			case 3:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Parametrage$CompteurDeCode$Update$relire(model));
			case 4:
				var geste = msg.a;
				return A2(
					$author$project$Components$Parametrage$CompteurDeCode$Update$siLibre,
					model,
					$author$project$Components$Parametrage$CompteurDeCode$Update$versLeDrawer(geste));
			case 5:
				var _v1 = model.eO;
				if (!_v1.$) {
					var lu = _v1.a;
					return A2(
						$author$project$Components$Parametrage$CompteurDeCode$Update$versLeDrawer,
						$author$project$Components$Shared$Drawer$Update$Ouvrir('compteur-regler'),
						_Utils_update(
							model,
							{
								vb: $elm$core$String$fromInt(lu.vb),
								F$: lu.F$,
								Ge: $elm$core$String$fromInt(lu.Ge),
								pZ: $elm$core$Maybe$Nothing
							}));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 6:
				var portee = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{F$: portee}),
					_List_Nil);
			case 7:
				var chiffres = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{vb: chiffres}),
					_List_Nil);
			case 8:
				var premier = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Ge: premier}),
					_List_Nil);
			case 9:
				var _v2 = $author$project$Components$Parametrage$CompteurDeCode$Model$commande(model);
				if (!_v2.$) {
					var commande = _v2.a;
					var _v3 = A4(
						$author$project$API$Envoi$partir,
						$author$project$Components$Parametrage$CompteurDeCode$Update$reglage,
						$author$project$Components$Parametrage$CompteurDeCode$Model$lienDuReglage(model),
						commande,
						model.l2);
					if (!_v3.$) {
						var _v4 = _v3.a;
						var envoi = _v4.a;
						var effets = _v4.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{l2: envoi, pZ: $elm$core$Maybe$Nothing}),
							effets);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			default:
				var reponse = msg.a;
				var _v5 = A3($author$project$API$Envoi$conclure, $author$project$Components$Parametrage$CompteurDeCode$Update$reglage, reponse, model.l2);
				if (!_v5.$) {
					var _v6 = _v5.a;
					var envoi = _v6.a;
					var issue = _v6.b;
					var effets = _v6.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Parametrage$CompteurDeCode$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Main$Update$versLeCompteur = F2(
	function (msg, model) {
		var _v0 = A2($author$project$Components$Parametrage$CompteurDeCode$Update$update, msg, model.v$);
		var compteur = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLeCompteur, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLeCompteur,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						v$: compteur,
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Parametrage$CompteurDeCode$Update$popMessages(msg),
							gardes)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$AttendreAvantDeChercherPourLeGroupe = F2(
	function (a, b) {
		return {$: 184, a: a, b: b};
	});
var $author$project$Main$Update$AttendreAvantDeRelireLeSuiviPourLeGroupe = function (a) {
	return {$: 180, a: a};
};
var $author$project$Main$Update$ChercherPourLeGroupe = function (a) {
	return {$: 183, a: a};
};
var $author$project$Main$Update$CompterPourLeGroupe = function (a) {
	return {$: 185, a: a};
};
var $author$project$Main$Update$EnvoyerAuGroupe = function (a) {
	return {$: 186, a: a};
};
var $author$project$Main$Update$LireLEquipePourLeGroupe = F2(
	function (a, b) {
		return {$: 182, a: a, b: b};
	});
var $author$project$Main$Update$LireLaFicheDUnGroupe = function (a) {
	return {$: 175, a: a};
};
var $author$project$Main$Update$LireLeSuiviPourLeGroupe = function (a) {
	return {$: 178, a: a};
};
var $author$project$Main$Update$LireLesNonAjouteesPourLeGroupe = function (a) {
	return {$: 179, a: a};
};
var $author$project$Main$Update$LireLesTraitementsPourLeGroupe = function (a) {
	return {$: 176, a: a};
};
var $author$project$Main$Model$PourLeGroupe = 32;
var $author$project$Main$Update$depuisLeGroupe = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[32]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 1:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLaFicheDUnGroupe)));
			case 10:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesNotificationsDeFinPourLeGroupe)));
			case 9:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesTraitementsPourLeGroupe)));
			case 11:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLeSuiviPourLeGroupe)));
			case 12:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesNonAjouteesPourLeGroupe)));
			case 13:
				var delaiMs = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AttendreAvantDeRelireLeSuiviPourLeGroupe(delaiMs)
							])));
			case 2:
				var etape = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLEquipePourLeGroupe(etape))));
			case 3:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerAuGroupe(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 6:
				var saisie = effet.a;
				var delaiMs = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								A2($author$project$Main$Update$AttendreAvantDeChercherPourLeGroupe, saisie, delaiMs)
							])));
			case 7:
				var lien = effet.a;
				var recherche = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$ChercherPourLeGroupe(
									{gM: vers.gM, nB: vers.nB, hC: recherche});
							})));
			case 8:
				var lien = effet.a;
				var rang = effet.b;
				var filtre = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$CompterPourLeGroupe(
									{zH: filtre, gM: vers.gM, nB: vers.nB, bY: rang});
							})));
			case 4:
				var adresse = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AllerA(adresse)
							])));
			case 5:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Referentiel$Groupe$Update$popMessages = function (msg) {
	switch (msg.$) {
		case 2:
			var reponse = msg.a;
			var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$ficheDecoder, reponse);
			if (_v1.$ === 1) {
				var refus = _v1.a;
				return ((refus.ri === 401) || (refus.ri === 404)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Components$Shared$Messages$Model$duRefus(refus));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 1:
			var octets = msg.a;
			return _Utils_eq(
				$author$project$API$ProcessUid$depuisOctets(octets),
				$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
				{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$Archiver = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Referentiel$Groupe$Effet$LireLEquipe = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Referentiel$Groupe$Effet$LireLeSuivi = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Referentiel$Groupe$Effet$LireLesNonAjoutees = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Referentiel$Groupe$Effet$LireLesNotificationsDeFin = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Referentiel$Groupe$Effet$LireLesTraitements = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$ModifierLeFiltre = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Referentiel$Groupe$Effet$Naviguer = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Referentiel$Groupe$Effet$PlacerFocus = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Referentiel$Groupe$Effet$Reconnecter = {$: 14};
var $author$project$Components$Referentiel$Groupe$Model$ajoutVide = {L: _List_Nil, l1: '', hC: $author$project$Components$Referentiel$Common$RechercheDeFiche$vide, b5: false};
var $author$project$API$NavLinksDictionary$ajouterDesMembres = 'ajouter-des-membres';
var $author$project$Components$Referentiel$Groupe$Model$lien = F2(
	function (rel, model) {
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				$author$project$API$Liens$trouver(rel)),
			model.zo);
	});
var $author$project$Components$Referentiel$Groupe$Model$ajouter = $author$project$Components$Referentiel$Groupe$Model$lien($author$project$API$NavLinksDictionary$ajouterDesMembres);
var $author$project$Components$Referentiel$Groupe$Model$archivage = $author$project$Components$Referentiel$Groupe$Model$lien($author$project$API$NavLinksDictionary$archiver);
var $author$project$Components$Referentiel$Groupe$Effet$AttendreAvantDeChercher = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Referentiel$Groupe$Update$attendre = function (model) {
	var _v0 = model.fw;
	if (!_v0.$) {
		var ajout = _v0.a;
		return _Utils_Tuple2(
			model,
			_Utils_eq(
				$author$project$Components$Referentiel$Common$RechercheDeFiche$aChercher(ajout.hC),
				$elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
				[
					A2($author$project$Components$Referentiel$Groupe$Effet$AttendreAvantDeChercher, ajout.hC.hP, $author$project$Components$Referentiel$Common$RechercheDeFiche$delaiMs)
				]));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$API$NavLinksDictionary$changerLeResponsable = 'changer-le-responsable';
var $author$project$Components$Referentiel$Groupe$Model$changerLeResponsable = $author$project$Components$Referentiel$Groupe$Model$lien($author$project$API$NavLinksDictionary$changerLeResponsable);
var $author$project$Components$Referentiel$Groupe$Effet$ChercherDesFiches = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Referentiel$Groupe$Update$chercher = F2(
	function (saisie, model) {
		var _v0 = _Utils_Tuple2(
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.hC;
					},
					$author$project$Components$Referentiel$Common$RechercheDeFiche$delaiEcoule(saisie)),
				model.fw),
			A2(
				$author$project$Components$Referentiel$Liens$versEntites,
				{
					EE: 1,
					Jm: $author$project$Routes$Route$premierePage.Jm,
					rS: $author$project$Routes$Route$codeDuTri(0)
				},
				model.gF));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var terme = _v0.a.a;
			var lien = _v0.b.a;
			return _Utils_Tuple2(
				model,
				_List_fromArray(
					[
						A2(
						$author$project$Components$Referentiel$Groupe$Effet$ChercherDesFiches,
						lien,
						A2($author$project$Components$Referentiel$Common$RechercheDeFiche$corps, 2, terme))
					]));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Groupe$Model$cocher = F2(
	function (uid, ajout) {
		return A2(
			$elm$core$List$any,
			function (p) {
				return _Utils_eq(p.r8, uid);
			},
			ajout.L) ? _Utils_update(
			ajout,
			{
				L: A2(
					$elm$core$List$filter,
					function (p) {
						return !_Utils_eq(p.r8, uid);
					},
					ajout.L)
			}) : _Utils_update(
			ajout,
			{
				L: _Utils_ap(
					ajout.L,
					A2(
						$elm$core$List$filter,
						function (p) {
							return _Utils_eq(p.r8, uid);
						},
						ajout.hC.Gw))
			});
	});
var $author$project$Components$Referentiel$Groupe$Model$criteresOuverts = function (fiche) {
	return {
		kC: 0,
		zH: A2(
			$elm$core$Maybe$withDefault,
			{g1: $elm$core$Maybe$Nothing, ho: $elm$core$Maybe$Nothing, hy: $elm$core$Maybe$Nothing, Ic: _List_Nil, Id: _List_Nil},
			A2(
				$elm$core$Maybe$map,
				function (f) {
					return {g1: f.g1, ho: f.ho, hy: f.hy, Ic: f.Ic, Id: f.Id};
				},
				fiche.zH)),
		w: $elm$core$Maybe$Just(fiche.n5),
		Gv: false
	};
};
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$AjouterDesMembres = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Groupe$Effet$DemanderProcessUid = {$: 0};
var $author$project$Components$Referentiel$Groupe$Effet$Envoyer = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$ReponseDeCommande = F3(
	function (liens, vuesAJour, ajoutees) {
		return {iI: ajoutees, nQ: liens, sy: vuesAJour};
	});
var $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$membreAjoute = $elm$json$Json$Decode$maybe(
	A2(
		$elm$json$Json$Decode$map,
		function (_v0) {
			return 0;
		},
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['event', 'MembreAjoute']),
			$elm$json$Json$Decode$value)));
var $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$reponseDeCommandeDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'evenements',
	A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$filterMap($elm$core$Basics$identity),
			$elm$core$List$length),
		$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$membreAjoute)),
	0,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vuesAJour',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'liens',
			A2(
				$elm$json$Json$Decode$map,
				function ($) {
					return $.h0;
				},
				$author$project$API$Liens$decoder),
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$ReponseDeCommande))));
var $author$project$Components$Referentiel$Groupe$Update$reglage = {
	f8: $author$project$Components$Referentiel$Groupe$Effet$DemanderProcessUid,
	l4: $author$project$Components$Referentiel$Groupe$Effet$Envoyer,
	go: function (_v0) {
		return 0;
	},
	pW: $author$project$Components$Referentiel$Groupe$Effet$Reconnecter,
	qu: F2(
		function (_v1, _v2) {
			return true;
		}),
	qv: $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$reponseDeCommandeDecoder
};
var $author$project$Components$Referentiel$Groupe$Update$partir = F3(
	function (lien, commande, model) {
		if ($author$project$API$Envoi$enCours(model.l2)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v0 = A4($author$project$API$Envoi$partir, $author$project$Components$Referentiel$Groupe$Update$reglage, lien, commande, model.l2);
			if (!_v0.$) {
				var _v1 = _v0.a;
				var envoi = _v1.a;
				var effets = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{l2: envoi}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		}
	});
var $author$project$Components$Referentiel$Groupe$Update$demanderLAjout = function (model) {
	var _v0 = _Utils_Tuple2(model.fw, model.zo);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var saisie = _v0.a.a;
		var fiche = _v0.b.a;
		return ($elm$core$List$isEmpty(saisie.L) || $elm$core$String$isEmpty(saisie.l1)) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{
					fw: $elm$core$Maybe$Just(
						_Utils_update(
							saisie,
							{b5: true}))
				}),
			_List_Nil) : A3(
			$author$project$Components$Referentiel$Groupe$Update$partir,
			$author$project$Components$Referentiel$Groupe$Model$ajouter(model),
			A3(
				$author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$AjouterDesMembres,
				fiche.r8,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.r8;
					},
					saisie.L),
				saisie.l1),
			model);
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$ChangerLeResponsable = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Referentiel$Groupe$Update$demanderLeChangement = function (model) {
	var _v0 = _Utils_Tuple2(model.cs, model.zo);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var saisie = _v0.a.a;
		var fiche = _v0.b.a;
		return $elm$core$String$isEmpty(saisie.qB) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{
					cs: $elm$core$Maybe$Just(
						_Utils_update(
							saisie,
							{b5: true}))
				}),
			_List_Nil) : A3(
			$author$project$Components$Referentiel$Groupe$Update$partir,
			$author$project$Components$Referentiel$Groupe$Model$changerLeResponsable(model),
			A2($author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$ChangerLeResponsable, fiche.r8, saisie.qB),
			model);
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$Renommer = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$renommer = 'renommer';
var $author$project$Components$Referentiel$Groupe$Model$renommer = $author$project$Components$Referentiel$Groupe$Model$lien($author$project$API$NavLinksDictionary$renommer);
var $author$project$Components$Referentiel$Groupe$Update$demanderLeRenommage = function (model) {
	var _v0 = _Utils_Tuple2(model.hL, model.zo);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var saisie = _v0.a.a;
		var fiche = _v0.b.a;
		var nom = $elm$core$String$trim(saisie.Dj);
		return $elm$core$String$isEmpty(nom) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{
					hL: $elm$core$Maybe$Just(
						_Utils_update(
							saisie,
							{b5: true}))
				}),
			_List_Nil) : A3(
			$author$project$Components$Referentiel$Groupe$Update$partir,
			$author$project$Components$Referentiel$Groupe$Model$renommer(model),
			A2($author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$Renommer, fiche.r8, nom),
			model);
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$RetirerUnMembre = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$API$NavLinksDictionary$retirerUnMembre = 'retirer-un-membre';
var $author$project$Components$Referentiel$Groupe$Model$retrait = function (membre) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerUnMembre, membre.nQ);
};
var $author$project$Components$Referentiel$Groupe$Update$demanderLeRetrait = function (model) {
	var _v0 = _Utils_Tuple2(model.eW, model.zo);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var saisie = _v0.a.a;
		var fiche = _v0.b.a;
		var lienDuMembre = A2(
			$elm$core$Maybe$andThen,
			$author$project$Components$Referentiel$Groupe$Model$retrait,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (membre) {
						return _Utils_eq(membre.zo, saisie.Cl);
					},
					fiche.Cm)));
		return $elm$core$String$isEmpty(saisie.IQ) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{
					eW: $elm$core$Maybe$Just(
						_Utils_update(
							saisie,
							{b5: true}))
				}),
			_List_Nil) : A3(
			$author$project$Components$Referentiel$Groupe$Update$partir,
			lienDuMembre,
			A3($author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$RetirerUnMembre, fiche.r8, saisie.Cl, saisie.IQ),
			model);
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$API$NavLinksDictionary$fichesNonAjoutees = 'fiches-non-ajoutees';
var $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$FichesNonAjoutees = F2(
	function (traitement, fiches) {
		return {zu: fiches, JO: traitement};
	});
var $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$FicheNonAjoutee = F3(
	function (uid, numero, raison) {
		return {DX: numero, pH: raison, r8: uid};
	});
var $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$Effacee = 0;
var $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$Supprimee = 1;
var $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$raison = A2(
	$elm$json$Json$Decode$andThen,
	function (code) {
		switch (code) {
			case 'effacee':
				return $elm$json$Json$Decode$succeed(0);
			case 'supprimee':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail(code);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$ficheNonAjouteeDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'raison',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$raison),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'numero',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'uid',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$FicheNonAjoutee))));
var $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$fichesNonAjouteesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'fiches',
	$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$ficheNonAjouteeDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'traitement',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$FichesNonAjoutees)));
var $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$FinNotifiee = F2(
	function (groupe, lue) {
		return {m2: groupe, B1: lue};
	});
var $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$finNotifieeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (nature) {
		return (nature === 'traitement-termine') ? A3(
			$elm$json$Json$Decode$map2,
			$author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$FinNotifiee,
			A2($elm$json$Json$Decode$field, 'fiche', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'lue', $elm$json$Json$Decode$bool)) : $elm$json$Json$Decode$fail(nature);
	},
	A2($elm$json$Json$Decode$field, 'nature', $elm$json$Json$Decode$string));
var $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$finsNotifieesDecoder = A2(
	$elm$json$Json$Decode$field,
	'notifications',
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$filterMap($elm$core$Basics$identity),
		$elm$json$Json$Decode$list(
			$elm$json$Json$Decode$maybe($author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$finNotifieeDecoder))));
var $author$project$Components$Referentiel$Groupe$Model$idDeLAjout = 'groupe-ajouter';
var $author$project$Components$Referentiel$Groupe$Model$idDeLArchivage = 'groupe-archiver';
var $author$project$Components$Referentiel$Groupe$Model$idDesCriteres = 'groupe-modifier-les-criteres';
var $author$project$Components$Referentiel$Groupe$Model$idDesNonAjoutees = 'groupe-non-ajoutees';
var $author$project$Components$Referentiel$Groupe$Model$idDuChangementDeResponsable = 'groupe-changer-le-responsable';
var $author$project$Components$Referentiel$Groupe$Model$idDuRenommer = 'groupe-renommer';
var $author$project$Components$Referentiel$Groupe$Model$idsDeLaConfirmation = {to: 'archivage-annuler', j7: 'archivage-confirmer', Cs: 'archivage-message', GN: 'archivage', h6: 'archivage-titre'};
var $author$project$API$NavLinksDictionary$modifierLeFiltre = 'modifier-le-filtre';
var $author$project$Components$Referentiel$Groupe$Model$modifierLeFiltre = $author$project$Components$Referentiel$Groupe$Model$lien($author$project$API$NavLinksDictionary$modifierLeFiltre);
var $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$nombreDecoder = A2($elm$json$Json$Decode$field, 'nombre', $elm$json$Json$Decode$int);
var $author$project$Components$Referentiel$Groupe$Effet$Lire = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Groupe$Update$resoudre = F2(
	function (uid, date) {
		return $author$project$API$Liens$resoudre(
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$API$NavLinksDictionary$variableUid,
					$author$project$Components$Referentiel$Identifiants$groupeUidToString(uid)),
					_Utils_Tuple2(
					$author$project$API$NavLinksDictionary$variableDate,
					A2($elm$core$Maybe$withDefault, '', date))
				]));
	});
var $author$project$Components$Referentiel$Groupe$Update$ouvrir = F4(
	function (uid, date, gabarits, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			A2($author$project$Components$Referentiel$Groupe$Update$resoudre, uid, date),
			A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$groupe, gabarits));
		if (!_v0.$) {
			var lecture = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						kD: $elm$core$Maybe$Just(uid),
						zo: _Utils_eq(
							model.kD,
							$elm$core$Maybe$Just(uid)) ? model.zo : $elm$core$Maybe$Nothing,
						gF: gabarits,
						nf: false
					}),
				_List_fromArray(
					[
						$author$project$Components$Referentiel$Groupe$Effet$DemanderProcessUid,
						$author$project$Components$Referentiel$Groupe$Effet$Lire(lecture)
					]));
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						kD: $elm$core$Maybe$Just(uid)
					}),
				_List_Nil);
		}
	});
var $author$project$Components$Referentiel$Groupe$Model$ajouterSansDoublon = F2(
	function (role, roles) {
		return A2($elm$core$List$member, role, roles) ? roles : _Utils_ap(
			roles,
			_List_fromArray(
				[role]));
	});
var $author$project$Components$Referentiel$Groupe$Model$poserLeCritere = F2(
	function (critere, filtre) {
		switch (critere.$) {
			case 0:
				var valeur = critere.a;
				return _Utils_update(
					filtre,
					{
						g1: $elm$core$Maybe$Just(valeur)
					});
			case 1:
				var valeur = critere.a;
				return _Utils_update(
					filtre,
					{
						hy: $elm$core$Maybe$Just(valeur)
					});
			case 2:
				var role = critere.a;
				return _Utils_update(
					filtre,
					{
						Id: A2($author$project$Components$Referentiel$Groupe$Model$ajouterSansDoublon, role, filtre.Id)
					});
			default:
				var role = critere.a;
				return _Utils_update(
					filtre,
					{
						Ic: A2($author$project$Components$Referentiel$Groupe$Model$ajouterSansDoublon, role, filtre.Ic)
					});
		}
	});
var $author$project$Components$Referentiel$Groupe$Model$recevoir = F4(
	function (terme, recues, model, ajout) {
		var membres = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Cm;
					},
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$filter(
							function ($) {
								return $.sO;
							}),
						$elm$core$List$map(
							function ($) {
								return $.zo;
							}))),
				model.zo));
		return _Utils_update(
			ajout,
			{
				hC: A3(
					$author$project$Components$Referentiel$Common$RechercheDeFiche$recevoir,
					terme,
					A2(
						$elm$core$List$filter,
						function (p) {
							return !A2($elm$core$List$member, p.r8, membres);
						},
						recues),
					ajout.hC)
			});
	});
var $author$project$Components$Referentiel$Groupe$Effet$Compter = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$API$NavLinksDictionary$compterLesMembres = 'compter-les-membres';
var $author$project$Components$Referentiel$Groupe$Model$compter = $author$project$Components$Referentiel$Groupe$Model$lien($author$project$API$NavLinksDictionary$compterLesMembres);
var $author$project$Components$Referentiel$Groupe$Update$recompter = function (model) {
	var _v0 = _Utils_Tuple2(
		model.wp,
		$author$project$Components$Referentiel$Groupe$Model$compter(model));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var criteres = _v0.a.a;
		var lien = _v0.b.a;
		var rang = criteres.kC + 1;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					wp: $elm$core$Maybe$Just(
						_Utils_update(
							criteres,
							{kC: rang}))
				}),
			_List_fromArray(
				[
					A3($author$project$Components$Referentiel$Groupe$Effet$Compter, lien, rang, criteres.zH)
				]));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Groupe$Update$refuser = F2(
	function (refus, model) {
		return (refus.ri === 401) ? _Utils_Tuple2(
			model,
			_List_fromArray(
				[$author$project$Components$Referentiel$Groupe$Effet$Reconnecter])) : _Utils_Tuple2(
			_Utils_update(
				model,
				{
					pZ: $elm$core$Maybe$Just(refus)
				}),
			_List_Nil);
	});
var $author$project$Components$Referentiel$Groupe$Model$remplacer = F3(
	function (avant, apres, roles) {
		return (A2($elm$core$List$member, apres, roles) && (!_Utils_eq(apres, avant))) ? A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(avant),
			roles) : A2(
			$elm$core$List$map,
			function (role) {
				return _Utils_eq(role, avant) ? apres : role;
			},
			roles);
	});
var $author$project$Components$Referentiel$Groupe$Model$remplacerLeCritere = F3(
	function (ancien, nouveau, filtre) {
		var _v0 = _Utils_Tuple2(ancien, nouveau);
		_v0$2:
		while (true) {
			switch (_v0.a.$) {
				case 2:
					if (_v0.b.$ === 2) {
						var avant = _v0.a.a;
						var apres = _v0.b.a;
						return _Utils_update(
							filtre,
							{
								Id: A3($author$project$Components$Referentiel$Groupe$Model$remplacer, avant, apres, filtre.Id)
							});
					} else {
						break _v0$2;
					}
				case 3:
					if (_v0.b.$ === 3) {
						var avant = _v0.a.a;
						var apres = _v0.b.a;
						return _Utils_update(
							filtre,
							{
								Ic: A3($author$project$Components$Referentiel$Groupe$Model$remplacer, avant, apres, filtre.Ic)
							});
					} else {
						break _v0$2;
					}
				default:
					break _v0$2;
			}
		}
		return A2($author$project$Components$Referentiel$Groupe$Model$poserLeCritere, nouveau, filtre);
	});
var $author$project$Components$Referentiel$Groupe$Update$fermeture = function (drawer) {
	return A3(
		$author$project$Components$Shared$Drawer$Update$update,
		{Il: false},
		$author$project$Components$Shared$Drawer$Update$Fermer,
		drawer).a;
};
var $author$project$Components$Referentiel$Groupe$Update$repondre = F2(
	function (reponse, model) {
		var _v0 = A3($author$project$API$Envoi$conclure, $author$project$Components$Referentiel$Groupe$Update$reglage, reponse, model.l2);
		if (!_v0.$) {
			switch (_v0.a.b.$) {
				case 0:
					var _v1 = _v0.a;
					var envoi = _v1.a;
					var _v2 = _v1.b;
					var effets = _v1.c;
					var relecture = A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Groupe$Effet$Lire, $elm$core$List$singleton),
							A2(
								$elm$core$Maybe$andThen,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.nQ;
									},
									$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$self)),
								model.zo)));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								fw: $elm$core$Maybe$Nothing,
								iH: $author$project$Components$Referentiel$Groupe$Update$fermeture(model.iH),
								cs: $elm$core$Maybe$Nothing,
								jH: $author$project$Components$Referentiel$Groupe$Update$fermeture(model.jH),
								wp: $elm$core$Maybe$Nothing,
								kn: $author$project$Components$Referentiel$Groupe$Update$fermeture(model.kn),
								l2: envoi,
								pZ: $elm$core$Maybe$Nothing,
								hL: $elm$core$Maybe$Nothing,
								qp: $author$project$Components$Referentiel$Groupe$Update$fermeture(model.qp),
								eW: $elm$core$Maybe$Nothing,
								qN: $author$project$Components$Referentiel$Groupe$Update$fermeture(model.qN)
							}),
						_Utils_ap(effets, relecture));
				case 1:
					var _v3 = _v0.a;
					var envoi = _v3.a;
					var _v4 = _v3.b;
					var refus = _v4.b;
					var effets = _v3.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l2: envoi,
								pZ: $elm$core$Maybe$Just(refus)
							}),
						effets);
				default:
					var _v5 = _v0.a;
					var envoi = _v5.a;
					var _v6 = _v5.b;
					var effets = _v5.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{l2: envoi}),
						effets);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Groupe$Model$retirerLeCritere = F2(
	function (critere, filtre) {
		switch (critere.$) {
			case 0:
				return _Utils_update(
					filtre,
					{g1: $elm$core$Maybe$Nothing});
			case 1:
				return _Utils_update(
					filtre,
					{hy: $elm$core$Maybe$Nothing});
			case 2:
				var role = critere.a;
				return _Utils_update(
					filtre,
					{
						Id: A2(
							$elm$core$List$filter,
							$elm$core$Basics$neq(role),
							filtre.Id)
					});
			default:
				var role = critere.a;
				return _Utils_update(
					filtre,
					{
						Ic: A2(
							$elm$core$List$filter,
							$elm$core$Basics$neq(role),
							filtre.Ic)
					});
		}
	});
var $author$project$Components$Referentiel$Groupe$Effet$AttendreAvantDeRelireLeSuivi = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Referentiel$Groupe$Model$delaiDeRelectureDuSuiviMs = 2000;
var $author$project$Components$Referentiel$Groupe$Update$suivre = F2(
	function (traitement, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					rr: $elm$core$Maybe$Just(traitement)
				}),
			(traitement.gt === 2) ? _List_Nil : _List_fromArray(
				[
					$author$project$Components$Referentiel$Groupe$Effet$AttendreAvantDeRelireLeSuivi($author$project$Components$Referentiel$Groupe$Model$delaiDeRelectureDuSuiviMs)
				]));
	});
var $author$project$Components$Referentiel$Groupe$Update$surCriteres = F2(
	function (changer, model) {
		return _Utils_update(
			model,
			{
				wp: A2($elm$core$Maybe$map, changer, model.wp)
			});
	});
var $author$project$Components$Referentiel$Groupe$Update$surLAjout = F2(
	function (transformer, model) {
		return _Utils_update(
			model,
			{
				fw: A2($elm$core$Maybe$map, transformer, model.fw)
			});
	});
var $author$project$Components$Referentiel$Groupe$Update$surLesCriteres = F2(
	function (changer, model) {
		var _v0 = model.wp;
		if (!_v0.$) {
			var criteres = _v0.a;
			return $author$project$Components$Referentiel$Groupe$Update$recompter(
				_Utils_update(
					model,
					{
						wp: $elm$core$Maybe$Just(
							_Utils_update(
								criteres,
								{
									zH: changer(criteres.zH)
								}))
					}));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Groupe$Update$versLAjout = F2(
	function (geste, model) {
		var saisi = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (ajout) {
					return (!$author$project$Components$Referentiel$Common$RechercheDeFiche$sansSaisie(ajout.hC)) || (ajout.l1 !== '');
				},
				model.fw));
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{iH: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Referentiel$Groupe$Effet$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: saisi},
				geste,
				model.iH));
	});
var $author$project$Components$Referentiel$Groupe$Update$versLeChangement = F2(
	function (geste, model) {
		var modifie = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (c) {
					return c.qB !== '';
				},
				model.cs));
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{jH: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Referentiel$Groupe$Effet$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: modifie},
				geste,
				model.jH));
	});
var $author$project$Components$Referentiel$Groupe$Update$nomLu = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.Dj;
			},
			model.zo));
};
var $author$project$Components$Referentiel$Groupe$Update$versLeRenommage = F2(
	function (geste, model) {
		var modifie = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (r) {
					return !_Utils_eq(
						r.Dj,
						$author$project$Components$Referentiel$Groupe$Update$nomLu(model));
				},
				model.hL));
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{qp: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Referentiel$Groupe$Effet$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: modifie},
				geste,
				model.qp));
	});
var $author$project$Components$Referentiel$Groupe$Update$versLeRetrait = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{qN: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Referentiel$Groupe$Effet$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.qN));
	});
var $author$project$Components$Referentiel$Groupe$Update$versLesCriteres = F2(
	function (geste, model) {
		var modifie = function () {
			var _v2 = _Utils_Tuple2(model.wp, model.zo);
			if ((!_v2.a.$) && (!_v2.b.$)) {
				var criteres = _v2.a.a;
				var fiche = _v2.b.a;
				return !_Utils_eq(
					criteres.zH,
					$author$project$Components$Referentiel$Groupe$Model$criteresOuverts(fiche).zH);
			} else {
				return false;
			}
		}();
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{Il: modifie},
			geste,
			model.kn);
		var drawer = _v0.a;
		var focus = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					wp: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? model.wp : $elm$core$Maybe$Nothing,
					kn: drawer
				}),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var cible = _v1;
					return $author$project$Components$Referentiel$Groupe$Effet$PlacerFocus(cible);
				},
				focus));
	});
var $author$project$Components$Referentiel$Groupe$Update$versLesNonAjoutees = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{oE: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Referentiel$Groupe$Effet$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.oE));
	});
var $author$project$Components$Referentiel$Groupe$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var uid = msg.a;
				var date = msg.b;
				var gabarits = msg.c;
				return A4($author$project$Components$Referentiel$Groupe$Update$ouvrir, uid, date, gabarits, model);
			case 1:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 2:
				var reponse = msg.a;
				var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$ficheDecoder, reponse);
				if (!_v1.$) {
					var fiche = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								zo: $elm$core$Maybe$Just(fiche),
								nf: false,
								pZ: $elm$core$Maybe$Nothing
							}),
						_List_Nil);
				} else {
					var refus = _v1.a;
					return (refus.ri === 401) ? _Utils_Tuple2(
						model,
						_List_fromArray(
							[$author$project$Components$Referentiel$Groupe$Effet$Reconnecter])) : _Utils_Tuple2(
						_Utils_update(
							model,
							{
								nf: refus.ri === 404,
								pZ: $elm$core$Maybe$Just(refus)
							}),
						_List_Nil);
				}
			case 3:
				var racine = msg.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (_v2) {
									var etape = _v2.a;
									var lien = _v2.b;
									return _List_fromArray(
										[
											A2($author$project$Components$Referentiel$Groupe$Effet$LireLEquipe, etape, lien)
										]);
								},
								$author$project$Components$Referentiel$Common$Equipe$premiereEtape(racine))),
						_Utils_ap(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Groupe$Effet$LireLesTraitements, $elm$core$List$singleton),
									A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$traitements, racine))),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Groupe$Effet$LireLesNotificationsDeFin, $elm$core$List$singleton),
									A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$notifications, racine))))));
			case 41:
				var reponse = msg.a;
				var _v3 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$finsNotifieesDecoder, reponse);
				if (!_v3.$) {
					var fins = _v3.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{oO: fins}),
						_List_Nil);
				} else {
					var refus = _v3.a;
					return A2($author$project$Components$Referentiel$Groupe$Update$refuser, refus, model);
				}
			case 40:
				var reponse = msg.a;
				var _v4 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$traitementsDecoder, reponse);
				if (!_v4.$) {
					var traitements = _v4.a;
					return A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(model, _List_Nil),
						A2(
							$elm$core$Maybe$map,
							function (traitement) {
								return A2($author$project$Components$Referentiel$Groupe$Update$suivre, traitement, model);
							},
							$elm$core$List$head(
								$elm$core$List$reverse(
									A2(
										$elm$core$List$sortBy,
										function ($) {
											return $.w8;
										},
										A2(
											$elm$core$List$filter,
											function (traitement) {
												return _Utils_eq(
													$elm$core$Maybe$Just(traitement.m2),
													model.kD);
											},
											traitements))))));
				} else {
					var refus = _v4.a;
					return A2($author$project$Components$Referentiel$Groupe$Update$refuser, refus, model);
				}
			case 42:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Groupe$Effet$LireLeSuivi, $elm$core$List$singleton),
							A2(
								$elm$core$Maybe$andThen,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.nQ;
									},
									$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$self)),
								model.rr))));
			case 43:
				var reponse = msg.a;
				var _v5 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$traitementDecoder, reponse);
				if (!_v5.$) {
					var traitement = _v5.a;
					return A2($author$project$Components$Referentiel$Groupe$Update$suivre, traitement, model);
				} else {
					var refus = _v5.a;
					return A2($author$project$Components$Referentiel$Groupe$Update$refuser, refus, model);
				}
			case 44:
				var _v6 = A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.nQ;
						},
						$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$fichesNonAjoutees)),
					model.rr);
				if (!_v6.$) {
					var lien = _v6.a;
					return A2(
						$elm$core$Tuple$mapSecond,
						function (effets) {
							return A2(
								$elm$core$List$cons,
								$author$project$Components$Referentiel$Groupe$Effet$LireLesNonAjoutees(lien),
								effets);
						},
						A2(
							$author$project$Components$Referentiel$Groupe$Update$versLesNonAjoutees,
							$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Referentiel$Groupe$Model$idDesNonAjoutees),
							model));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 45:
				var reponse = msg.a;
				var _v7 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$fichesNonAjouteesDecoder, reponse);
				if (!_v7.$) {
					var fiches = _v7.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								oD: $elm$core$Maybe$Just(fiches)
							}),
						_List_Nil);
				} else {
					var refus = _v7.a;
					return A2($author$project$Components$Referentiel$Groupe$Update$refuser, refus, model);
				}
			case 46:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Groupe$Update$versLesNonAjoutees, geste, model);
			case 4:
				var etape = msg.a;
				var reponse = msg.b;
				var _v8 = A2($author$project$Components$Referentiel$Common$Equipe$avancer, etape, reponse);
				if (!_v8.$) {
					var membres = _v8.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l5: $author$project$Components$Referentiel$Common$Equipe$Lue(membres)
							}),
						_List_Nil);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 5:
				var jour = msg.a;
				var _v9 = model.zo;
				if (!_v9.$) {
					var fiche = _v9.a;
					return _Utils_Tuple2(
						model,
						_List_fromArray(
							[
								$author$project$Components$Referentiel$Groupe$Effet$Naviguer(
								$author$project$Routes$Route$toString(
									A2(
										$author$project$Routes$Route$FicheDeGroupe,
										fiche.r8,
										$elm$core$Maybe$Just(jour))))
							]));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 6:
				return A2(
					$author$project$Components$Referentiel$Groupe$Update$versLeRetrait,
					$author$project$Components$Shared$Drawer$Update$Ouvrir('groupe-retirer'),
					_Utils_update(
						model,
						{pZ: $elm$core$Maybe$Nothing, eW: $elm$core$Maybe$Nothing}));
			case 7:
				var membre = msg.a;
				return A2(
					$author$project$Components$Referentiel$Groupe$Update$versLeRetrait,
					$author$project$Components$Shared$Drawer$Update$Ouvrir('groupe-retirer'),
					_Utils_update(
						model,
						{
							pZ: $elm$core$Maybe$Nothing,
							eW: $elm$core$Maybe$Just(
								{Cl: membre, IQ: '', b5: false})
						}));
			case 8:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Groupe$Update$versLeRetrait, geste, model);
			case 9:
				var sortie = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eW: A2(
								$elm$core$Maybe$map,
								function (r) {
									return _Utils_update(
										r,
										{IQ: sortie});
								},
								model.eW)
						}),
					_List_Nil);
			case 10:
				return $author$project$Components$Referentiel$Groupe$Update$demanderLeRetrait(model);
			case 11:
				var _v10 = $author$project$Components$Referentiel$Groupe$Model$ajouter(model);
				if (!_v10.$) {
					return A2(
						$author$project$Components$Referentiel$Groupe$Update$versLAjout,
						$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Referentiel$Groupe$Model$idDeLAjout),
						_Utils_update(
							model,
							{
								fw: $elm$core$Maybe$Just($author$project$Components$Referentiel$Groupe$Model$ajoutVide),
								pZ: $elm$core$Maybe$Nothing
							}));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 12:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Groupe$Update$versLAjout, geste, model);
			case 13:
				var terme = msg.a;
				return $author$project$Components$Referentiel$Groupe$Update$attendre(
					A2(
						$author$project$Components$Referentiel$Groupe$Update$surLAjout,
						function (ajout) {
							return _Utils_update(
								ajout,
								{
									hC: A2($author$project$Components$Referentiel$Common$RechercheDeFiche$setTerme, terme, ajout.hC)
								});
						},
						model));
			case 14:
				var saisie = msg.a;
				return A2($author$project$Components$Referentiel$Groupe$Update$chercher, saisie, model);
			case 15:
				var terme = msg.a;
				var reponse = msg.b;
				var _v11 = A2(
					$author$project$API$Reponse$lire,
					A2(
						$elm$json$Json$Decode$field,
						'fiches',
						$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$QueryAPIModel$ficheLieeDecoder)),
					reponse);
				if (!_v11.$) {
					var liees = _v11.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$Groupe$Update$surLAjout,
							A3(
								$author$project$Components$Referentiel$Groupe$Model$recevoir,
								terme,
								A3($author$project$Components$Referentiel$Common$RechercheDeFiche$propositions, 2, $elm$core$Maybe$Nothing, liees),
								model),
							model),
						_List_Nil);
				} else {
					var refus = _v11.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Referentiel$Groupe$Effet$Reconnecter]) : _List_Nil);
				}
			case 16:
				var uid = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Groupe$Update$surLAjout,
						$author$project$Components$Referentiel$Groupe$Model$cocher(uid),
						model),
					_List_Nil);
			case 17:
				var entree = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Groupe$Update$surLAjout,
						function (ajout) {
							return _Utils_update(
								ajout,
								{l1: entree});
						},
						model),
					_List_Nil);
			case 18:
				return $author$project$Components$Referentiel$Groupe$Update$demanderLAjout(model);
			case 19:
				var _v12 = _Utils_Tuple2(
					$author$project$Components$Referentiel$Groupe$Model$renommer(model),
					model.zo);
				if ((!_v12.a.$) && (!_v12.b.$)) {
					var fiche = _v12.b.a;
					return A2(
						$author$project$Components$Referentiel$Groupe$Update$versLeRenommage,
						$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Referentiel$Groupe$Model$idDuRenommer),
						_Utils_update(
							model,
							{
								pZ: $elm$core$Maybe$Nothing,
								hL: $elm$core$Maybe$Just(
									{Dj: fiche.Dj, b5: false})
							}));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 20:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Groupe$Update$versLeRenommage, geste, model);
			case 21:
				var nom = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hL: A2(
								$elm$core$Maybe$map,
								function (r) {
									return _Utils_update(
										r,
										{Dj: nom});
								},
								model.hL)
						}),
					_List_Nil);
			case 22:
				return $author$project$Components$Referentiel$Groupe$Update$demanderLeRenommage(model);
			case 23:
				var _v13 = $author$project$Components$Referentiel$Groupe$Model$changerLeResponsable(model);
				if (!_v13.$) {
					return A2(
						$author$project$Components$Referentiel$Groupe$Update$versLeChangement,
						$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Referentiel$Groupe$Model$idDuChangementDeResponsable),
						_Utils_update(
							model,
							{
								cs: $elm$core$Maybe$Just(
									{qB: '', b5: false}),
								pZ: $elm$core$Maybe$Nothing
							}));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 24:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Groupe$Update$versLeChangement, geste, model);
			case 25:
				var responsable = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cs: A2(
								$elm$core$Maybe$map,
								function (c) {
									return _Utils_update(
										c,
										{qB: responsable});
								},
								model.cs)
						}),
					_List_Nil);
			case 26:
				return $author$project$Components$Referentiel$Groupe$Update$demanderLeChangement(model);
			case 27:
				var _v14 = $author$project$Components$Referentiel$Groupe$Model$archivage(model);
				if (!_v14.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ir: true, pZ: $elm$core$Maybe$Nothing}),
						_List_fromArray(
							[
								$author$project$Components$Referentiel$Groupe$Effet$PlacerFocus($author$project$Components$Referentiel$Groupe$Model$idsDeLaConfirmation.to)
							]));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 28:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ir: false}),
					_List_fromArray(
						[
							$author$project$Components$Referentiel$Groupe$Effet$PlacerFocus($author$project$Components$Referentiel$Groupe$Model$idDeLArchivage)
						]));
			case 29:
				var _v15 = _Utils_Tuple2(model.ir, model.zo);
				if (_v15.a && (!_v15.b.$)) {
					var fiche = _v15.b.a;
					return A3(
						$author$project$Components$Referentiel$Groupe$Update$partir,
						$author$project$Components$Referentiel$Groupe$Model$archivage(model),
						$author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$Archiver(fiche.r8),
						_Utils_update(
							model,
							{ir: false}));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 30:
				var cible = msg.a;
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[
							$author$project$Components$Referentiel$Groupe$Effet$PlacerFocus(cible)
						]));
			case 31:
				var _v16 = _Utils_Tuple2(
					$author$project$Components$Referentiel$Groupe$Model$modifierLeFiltre(model),
					model.zo);
				if ((!_v16.a.$) && (!_v16.b.$)) {
					var fiche = _v16.b.a;
					var _v17 = A2(
						$author$project$Components$Referentiel$Groupe$Update$versLesCriteres,
						$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Referentiel$Groupe$Model$idDesCriteres),
						_Utils_update(
							model,
							{
								wp: $elm$core$Maybe$Just(
									$author$project$Components$Referentiel$Groupe$Model$criteresOuverts(fiche)),
								pZ: $elm$core$Maybe$Nothing
							}));
					var ouvert = _v17.a;
					var effets = _v17.b;
					return A2(
						$elm$core$Tuple$mapSecond,
						function (comptage) {
							return _Utils_ap(effets, comptage);
						},
						$author$project$Components$Referentiel$Groupe$Update$recompter(ouvert));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 32:
				var critere = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Components$Referentiel$Groupe$Update$surCriteres(
						function (criteres) {
							return _Utils_update(
								criteres,
								{Gv: false});
						}),
					A2(
						$author$project$Components$Referentiel$Groupe$Update$surLesCriteres,
						function (filtre) {
							return A2($author$project$Components$Referentiel$Groupe$Model$poserLeCritere, critere, filtre);
						},
						model));
			case 38:
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Groupe$Update$surCriteres,
						function (criteres) {
							return _Utils_update(
								criteres,
								{Gv: !criteres.Gv});
						},
						model),
					_List_Nil);
			case 33:
				var critere = msg.a;
				return A2(
					$author$project$Components$Referentiel$Groupe$Update$surLesCriteres,
					$author$project$Components$Referentiel$Groupe$Model$retirerLeCritere(critere),
					model);
			case 34:
				var ancien = msg.a;
				var nouveau = msg.b;
				return A2(
					$author$project$Components$Referentiel$Groupe$Update$surLesCriteres,
					A2($author$project$Components$Referentiel$Groupe$Model$remplacerLeCritere, ancien, nouveau),
					model);
			case 35:
				var rang = msg.a;
				var reponse = msg.b;
				var _v18 = _Utils_Tuple2(
					model.wp,
					A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$nombreDecoder, reponse));
				if (!_v18.b.$) {
					if (!_v18.a.$) {
						var criteres = _v18.a.a;
						var nombre = _v18.b.a;
						return _Utils_eq(rang, criteres.kC) ? _Utils_Tuple2(
							_Utils_update(
								model,
								{
									wp: $elm$core$Maybe$Just(
										_Utils_update(
											criteres,
											{
												w: $elm$core$Maybe$Just(nombre)
											}))
								}),
							_List_Nil) : _Utils_Tuple2(model, _List_Nil);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				} else {
					var refus = _v18.b.a;
					return (refus.ri === 401) ? _Utils_Tuple2(
						model,
						_List_fromArray(
							[$author$project$Components$Referentiel$Groupe$Effet$Reconnecter])) : _Utils_Tuple2(
						_Utils_update(
							model,
							{
								pZ: $elm$core$Maybe$Just(refus)
							}),
						_List_Nil);
				}
			case 36:
				var _v19 = _Utils_Tuple2(model.wp, model.zo);
				if ((!_v19.a.$) && (!_v19.b.$)) {
					var criteres = _v19.a.a;
					var fiche = _v19.b.a;
					return A3(
						$author$project$Components$Referentiel$Groupe$Update$partir,
						$author$project$Components$Referentiel$Groupe$Model$modifierLeFiltre(model),
						A2($author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$ModifierLeFiltre, fiche.r8, criteres.zH),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 37:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Groupe$Update$versLesCriteres, geste, model);
			default:
				var reponse = msg.a;
				return A2($author$project$Components$Referentiel$Groupe$Update$repondre, reponse, model);
		}
	});
var $author$project$Main$Update$versLeGroupe = F3(
	function (i18n, msg, model) {
		var _v0 = A2(
			$author$project$Components$Referentiel$Groupe$Update$update,
			msg,
			A2(
				$author$project$Referentiel$Normes$poser,
				model.hd,
				$author$project$Components$Referentiel$Groupe$Model$ouvrir(model.m2)));
		var groupe = _v0.a;
		var effets = _v0.b;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLeGroupe,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						m2: $author$project$Components$Referentiel$Groupe$Model$envelopper(groupe),
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Referentiel$Groupe$Update$popMessages(msg),
							model.Ct)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$ChampsDUnNiveau = 7;
var $author$project$Main$Model$PourLeSchemaDeNiveau = 12;
var $author$project$Components$Produits$SchemaDeNiveau$Update$perime = function (erreur) {
	switch (erreur.$) {
		case 24:
			return true;
		case 16:
			return true;
		case 9:
			return true;
		case 19:
			return true;
		case 20:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Produits$SchemaDeNiveau$Update$message = F2(
	function (refus, erreur) {
		return _Utils_eq(erreur, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$OrdreInvalide) ? {Jx: $author$project$I18n$Textes$produitsCatalogueErreurOrdreInvalide, b9: refus.b9} : ($author$project$Components$Produits$SchemaDeNiveau$Update$perime(erreur) ? {Jx: $author$project$I18n$Textes$produitsCatalogueErreurPerime, b9: refus.b9} : $author$project$Components$Shared$Messages$Model$duRefus(refus));
	});
var $author$project$Components$Produits$SchemaDeNiveau$API$QueryAPIModel$NiveauDeLaStructure = F4(
	function (id, archetype, libelles, liens) {
		return {fA: archetype, Aq: id, R: libelles, nQ: liens};
	});
var $author$project$Components$Produits$SchemaDeNiveau$API$QueryAPIModel$niveauxDecoder = A2(
	$elm$json$Json$Decode$field,
	'niveaux',
	$elm$json$Json$Decode$list(
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2(
				$elm$json$Json$Decode$map,
				function ($) {
					return $.h0;
				},
				$author$project$API$Liens$deLaRessource),
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'libelles',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'archetype',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$author$project$Catalogue$Identifiants$niveauIdDecoder,
						$elm$json$Json$Decode$succeed($author$project$Components$Produits$SchemaDeNiveau$API$QueryAPIModel$NiveauDeLaStructure)))))));
var $author$project$Components$Produits$SchemaDeNiveau$API$QueryAPIModel$Schema = F6(
	function (niveau, archetype, version, champs, editeur, liens) {
		return {fA: archetype, dw: champs, x5: editeur, nQ: liens, os: niveau, sq: version};
	});
var $author$project$Components$Produits$SchemaDeNiveau$API$QueryAPIModel$ChampDuNiveau = F4(
	function (champ, typeDeChamp, masque, liens) {
		return {uN: champ, nQ: liens, n4: masque, JR: typeDeChamp};
	});
var $author$project$Components$Produits$SchemaDeNiveau$API$QueryAPIModel$champDuNiveauDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'masque',
		$elm$json$Json$Decode$bool,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'typeDeChamp',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'champ',
				$author$project$Components$Shared$EditeurDeSchema$Champ$decoder,
				$elm$json$Json$Decode$succeed($author$project$Components$Produits$SchemaDeNiveau$API$QueryAPIModel$ChampDuNiveau)))));
var $author$project$Components$Produits$SchemaDeNiveau$API$QueryAPIModel$schemaDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'editeur',
		$author$project$Components$Shared$EditeurDeSchema$Propositions$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'champs',
			$elm$json$Json$Decode$list($author$project$Components$Produits$SchemaDeNiveau$API$QueryAPIModel$champDuNiveauDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'version',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'archetype',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'niveau',
						$author$project$Catalogue$Identifiants$niveauIdDecoder,
						$elm$json$Json$Decode$succeed($author$project$Components$Produits$SchemaDeNiveau$API$QueryAPIModel$Schema)))))));
var $author$project$Components$Produits$SchemaDeNiveau$Update$popMessages = F2(
	function (model, msg) {
		var deLaLecture = F2(
			function (muets, lue) {
				if (lue.$ === 1) {
					var refus = lue.a;
					return A2($elm$core$List$member, refus.ri, muets) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			});
		switch (msg.$) {
			case 10:
				var reponse = msg.a;
				var _v1 = _Utils_Tuple2(
					$author$project$Components$Shared$Drawer$Model$estOuvert(model.kX),
					A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, model.l2));
				_v1$2:
				while (true) {
					if ((!_v1.a) && (!_v1.b.$)) {
						switch (_v1.b.a.b.$) {
							case 0:
								if (!_v1.b.a.b.c) {
									var _v2 = _v1.b.a;
									var _v3 = _v2.b;
									return $elm$core$Maybe$Just($author$project$Components$Produits$Common$Refus$rejeu);
								} else {
									break _v1$2;
								}
							case 1:
								var _v4 = _v1.b.a;
								var _v5 = _v4.b;
								var refus = _v5.b;
								var erreur = _v5.c;
								return $elm$core$Maybe$Just(
									A2($author$project$Components$Produits$SchemaDeNiveau$Update$message, refus, erreur));
							default:
								break _v1$2;
						}
					} else {
						break _v1$2;
					}
				}
				return $elm$core$Maybe$Nothing;
			case 2:
				var reponse = msg.a;
				return A2(
					deLaLecture,
					_List_fromArray(
						[401]),
					A2(
						$elm$core$Result$map,
						function (_v6) {
							return 0;
						},
						A2($author$project$API$Reponse$lire, $author$project$Components$Produits$SchemaDeNiveau$API$QueryAPIModel$niveauxDecoder, reponse)));
			case 3:
				var reponse = msg.a;
				return A2(
					deLaLecture,
					_List_fromArray(
						[401, 404]),
					A2(
						$elm$core$Result$map,
						function (_v7) {
							return 0;
						},
						A2($author$project$API$Reponse$lire, $author$project$Components$Produits$SchemaDeNiveau$API$QueryAPIModel$schemaDecoder, reponse)));
			case 1:
				var octets = msg.a;
				return _Utils_eq(
					$author$project$API$ProcessUid$depuisOctets(octets),
					$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
					{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$SchemaDeNiveau$Model$champ = F2(
	function (cle, schema) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.uN;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dy;
						},
						$elm$core$Basics$eq(cle))),
				schema.dw));
	});
var $author$project$Components$Produits$SchemaDeNiveau$Model$appliquer = F3(
	function (typeAjoute, rendue, schema) {
		var surLeChamp = F3(
			function (cle, changer, champs) {
				return A2(
					$elm$core$List$map,
					function (lu) {
						return _Utils_eq(lu.uN.dy, cle) ? changer(lu) : lu;
					},
					champs);
			});
		var ici = F3(
			function (niveau, change, courant) {
				return _Utils_eq(niveau, schema.os) ? change(courant) : courant;
			});
		var etat = F2(
			function (masque, lu) {
				return _Utils_update(
					lu,
					{nQ: _List_Nil, n4: masque});
			});
		var apres = function (evenement) {
			switch (evenement.$) {
				case 32:
					var niveau = evenement.a;
					var version = evenement.b;
					var evolue = evenement.c;
					return A2(
						ici,
						niveau,
						function (courant) {
							return _Utils_update(
								courant,
								{
									dw: _Utils_ap(
										A3(
											$elm$core$List$foldl,
											function (modifie) {
												return A2(
													surLeChamp,
													modifie.dy,
													function (lu) {
														return _Utils_update(
															lu,
															{uN: modifie});
													});
											},
											courant.dw,
											evolue.g$),
										A2(
											$elm$core$List$map,
											function (ajoute) {
												return {uN: ajoute, nQ: _List_Nil, n4: false, JR: typeAjoute};
											},
											evolue.fx)),
									sq: version
								});
						});
				case 33:
					var niveau = evenement.a;
					var cle = evenement.b;
					return A2(
						ici,
						niveau,
						function (courant) {
							return _Utils_update(
								courant,
								{
									dw: A3(
										surLeChamp,
										cle,
										etat(true),
										courant.dw)
								});
						});
				case 34:
					var niveau = evenement.a;
					var cle = evenement.b;
					return A2(
						ici,
						niveau,
						function (courant) {
							return _Utils_update(
								courant,
								{
									dw: A3(
										surLeChamp,
										cle,
										etat(false),
										courant.dw)
								});
						});
				case 35:
					var niveau = evenement.a;
					var ordre = evenement.b;
					return A2(
						ici,
						niveau,
						function (courant) {
							return _Utils_update(
								courant,
								{
									dw: _Utils_ap(
										A2(
											$elm$core$List$filterMap,
											function (cle) {
												return A2($author$project$Components$Produits$SchemaDeNiveau$Model$champ, cle, courant);
											},
											ordre),
										A2(
											$elm$core$List$filter,
											function (lu) {
												return !A2($elm$core$List$member, lu.uN.dy, ordre);
											},
											courant.dw))
								});
						});
				default:
					return $elm$core$Basics$identity;
			}
		};
		return A3(
			$elm$core$List$foldl,
			apres,
			_Utils_update(
				schema,
				{nQ: rendue.nQ}),
			rendue.mk);
	});
var $author$project$Catalogue$API$WriteAPIModel$FaireEvoluerLeSchemaDUnNiveau = F2(
	function (a, b) {
		return {$: 30, a: a, b: b};
	});
var $author$project$Components$Produits$SchemaDeNiveau$Model$annonce = F2(
	function (deplace, champs) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Traductions$tel(''),
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var place = _v0.a;
					var lu = _v0.b;
					return $author$project$I18n$Textes$produitsStructureOrdreAnnonce(
						{
							Dj: $author$project$I18n$Traductions$tel(lu.uN.Bl),
							bY: $author$project$I18n$Traductions$tel(
								$elm$core$String$fromInt(place + 1)),
							JE: $author$project$I18n$Traductions$tel(
								$elm$core$String$fromInt(
									$elm$core$List$length(champs)))
						});
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$second,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.uN;
								},
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.dy;
									},
									$elm$core$Basics$eq(deplace)))),
						A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, champs)))));
	});
var $author$project$Catalogue$API$WriteAPIModel$OrdonnerLesChampsDUnNiveau = F2(
	function (a, b) {
		return {$: 33, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$ordonnerLesChampsDUnNiveau = 'ordonner-les-champs-d-un-niveau';
var $author$project$Components$Produits$SchemaDeNiveau$Model$commandeDOrdre = F2(
	function (voulus, schema) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair(
				A2(
					$author$project$Catalogue$API$WriteAPIModel$OrdonnerLesChampsDUnNiveau,
					schema.os,
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.uN;
							},
							function ($) {
								return $.dy;
							}),
						voulus))),
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ordonnerLesChampsDUnNiveau, schema.nQ));
	});
var $author$project$Catalogue$API$WriteAPIModel$AfficherUnChampDUnNiveau = F2(
	function (a, b) {
		return {$: 32, a: a, b: b};
	});
var $author$project$Catalogue$API$WriteAPIModel$MasquerUnChampDUnNiveau = F2(
	function (a, b) {
		return {$: 31, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$afficherUnChampDUnNiveau = 'afficher-un-champ-d-un-niveau';
var $author$project$API$NavLinksDictionary$masquerUnChampDUnNiveau = 'masquer-un-champ-d-un-niveau';
var $author$project$Components$Produits$SchemaDeNiveau$Model$commandeDeMasquage = F3(
	function (masquer, cle, schema) {
		return A2(
			$elm$core$Maybe$andThen,
			function (lu) {
				return masquer ? A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(
						A2($author$project$Catalogue$API$WriteAPIModel$MasquerUnChampDUnNiveau, schema.os, cle)),
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$masquerUnChampDUnNiveau, lu.nQ)) : A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(
						A2($author$project$Catalogue$API$WriteAPIModel$AfficherUnChampDUnNiveau, schema.os, cle)),
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$afficherUnChampDUnNiveau, lu.nQ));
			},
			A2($author$project$Components$Produits$SchemaDeNiveau$Model$champ, cle, schema));
	});
var $author$project$API$NavLinksDictionary$faireEvoluerLeSchemaDUnNiveau = 'faire-evoluer-le-schema-d-un-niveau';
var $author$project$Components$Produits$SchemaDeNiveau$Model$evolution = function (schema) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$faireEvoluerLeSchemaDUnNiveau, schema.nQ);
};
var $author$project$Components$Produits$SchemaDeNiveau$Update$conduite = function (model) {
	var surLeSchema = function (lire) {
		return A2($elm$core$Maybe$andThen, lire, model.aN);
	};
	return {
		s0: function (cle) {
			return surLeSchema(
				A2($author$project$Components$Produits$SchemaDeNiveau$Model$commandeDeMasquage, false, cle));
		},
		s1: F2(
			function (voulus, courant) {
				return _Utils_update(
					courant,
					{
						aN: A2(
							$elm$core$Maybe$map,
							function (schema) {
								return _Utils_update(
									schema,
									{dw: voulus});
							},
							courant.aN)
					});
			}),
		tm: $author$project$Components$Produits$SchemaDeNiveau$Model$annonce,
		dw: A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.dw;
			},
			model.aN),
		dy: A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.uN;
			},
			function ($) {
				return $.dy;
			}),
		xE: _List_Nil,
		l2: $author$project$Components$Produits$Common$Envoi$reglage,
		yW: surLeSchema(
			function (schema) {
				return A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(
						$author$project$Catalogue$API$WriteAPIModel$FaireEvoluerLeSchemaDUnNiveau(schema.os)),
					$author$project$Components$Produits$SchemaDeNiveau$Model$evolution(schema));
			}),
		Ba: A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.x5;
					},
					function ($) {
						return $.Ba;
					}),
				model.aN)),
		Cc: function (cle) {
			return surLeSchema(
				A2($author$project$Components$Produits$SchemaDeNiveau$Model$commandeDeMasquage, true, cle));
		},
		CC: function (_v0) {
			return $elm$core$Maybe$Nothing;
		},
		g_: function (cle) {
			return A2(
				$elm$core$Maybe$andThen,
				function (lu) {
					return A2(
						$elm$core$Maybe$map,
						function (code) {
							return _Utils_Tuple2(code, lu.uN);
						},
						lu.JR);
				},
				surLeSchema(
					$author$project$Components$Produits$SchemaDeNiveau$Model$champ(cle)));
		},
		Do: $author$project$Components$Produits$SchemaDeNiveau$Model$nomDuDrawer,
		hd: model.hd,
		Ek: function (voulus) {
			return surLeSchema(
				$author$project$Components$Produits$SchemaDeNiveau$Model$commandeDOrdre(voulus));
		},
		FO: $author$project$Components$Produits$Common$Effet$PlacerFocus,
		F$: 1
	};
};
var $author$project$Components$Produits$SchemaDeNiveau$Update$refusDuDrawer = F2(
	function (refus, erreur) {
		switch (erreur.$) {
			case 21:
				return $author$project$Components$Shared$EditeurDeSchema$Model$CleDejaUtilisee;
			case 22:
				var refuse = erreur.a;
				return $author$project$Components$Shared$EditeurDeSchema$Model$EvolutionNonAdditive(refuse.pH);
			case 23:
				var defauts = erreur.a;
				return $author$project$Components$Shared$EditeurDeSchema$Model$SchemaInvalide(defauts);
			default:
				return $author$project$Components$Shared$EditeurDeSchema$Model$AutreRefus(
					A2($author$project$Components$Produits$SchemaDeNiveau$Update$message, refus, erreur));
		}
	});
var $author$project$Components$Produits$SchemaDeNiveau$Update$relire = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$Lire, $elm$core$List$singleton),
			model.np));
};
var $author$project$Components$Produits$SchemaDeNiveau$Update$relecture = F2(
	function (rendue, model) {
		return (rendue.sy && (!A2($elm$core$List$member, $author$project$Catalogue$API$WriteAPIModel$EvenementInconnu, rendue.mk))) ? $author$project$Components$Produits$SchemaDeNiveau$Update$relire(model) : _List_fromArray(
			[
				$author$project$Components$Produits$Common$Effet$AttendreAvantDeRelire($author$project$Components$Produits$Common$Envoi$delaiDeRelectureMs)
			]);
	});
var $author$project$Components$Produits$SchemaDeNiveau$Update$conclure = F2(
	function (issue, model) {
		var typeAjoute = (model.hP.zT.JR === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(model.hP.zT.JR);
		switch (issue.$) {
			case 0:
				if (issue.c) {
					var rendue = issue.b;
					return A2(
						$elm$core$Tuple$mapSecond,
						function (effets) {
							return _Utils_ap(
								effets,
								A2($author$project$Components$Produits$SchemaDeNiveau$Update$relecture, rendue, model));
						},
						A3(
							$author$project$Components$Shared$EditeurDeSchema$Conduite$conclure,
							$author$project$Components$Produits$SchemaDeNiveau$Update$conduite(model),
							$author$project$Components$Shared$EditeurDeSchema$Conduite$Aboutie,
							_Utils_update(
								model,
								{
									aN: A2(
										$elm$core$Maybe$map,
										A2($author$project$Components$Produits$SchemaDeNiveau$Model$appliquer, typeAjoute, rendue),
										model.aN)
								})));
				} else {
					return A2(
						$elm$core$Tuple$mapSecond,
						function (effets) {
							return _Utils_ap(
								effets,
								$author$project$Components$Produits$SchemaDeNiveau$Update$relire(model));
						},
						A3(
							$author$project$Components$Shared$EditeurDeSchema$Conduite$conclure,
							$author$project$Components$Produits$SchemaDeNiveau$Update$conduite(model),
							$author$project$Components$Shared$EditeurDeSchema$Conduite$Refusee(
								$author$project$Components$Shared$EditeurDeSchema$Model$AutreRefus($author$project$Components$Produits$Common$Refus$rejeu)),
							model));
				}
			case 1:
				var refus = issue.b;
				var erreur = issue.c;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (effets) {
						return _Utils_ap(
							effets,
							$author$project$Components$Produits$SchemaDeNiveau$Update$perime(erreur) ? $author$project$Components$Produits$SchemaDeNiveau$Update$relire(model) : _List_Nil);
					},
					A3(
						$author$project$Components$Shared$EditeurDeSchema$Conduite$conclure,
						$author$project$Components$Produits$SchemaDeNiveau$Update$conduite(model),
						$author$project$Components$Shared$EditeurDeSchema$Conduite$Refusee(
							A2($author$project$Components$Produits$SchemaDeNiveau$Update$refusDuDrawer, refus, erreur)),
						model));
			default:
				return A3(
					$author$project$Components$Shared$EditeurDeSchema$Conduite$conclure,
					$author$project$Components$Produits$SchemaDeNiveau$Update$conduite(model),
					$author$project$Components$Shared$EditeurDeSchema$Conduite$SessionEchue,
					model);
		}
	});
var $author$project$Components$Produits$SchemaDeNiveau$Model$idDeLAjout = 'champs-ajouter';
var $author$project$API$NavLinksDictionary$schemaDuNiveau = 'schema-du-niveau';
var $author$project$Components$Produits$SchemaDeNiveau$API$QueryAPIModel$schemaDuNiveau = function (niveau) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$schemaDuNiveau, niveau.nQ);
};
var $author$project$Components$Produits$SchemaDeNiveau$Update$surLaStructure = F2(
	function (niveaux, model) {
		var niveau = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (lu) {
					return _Utils_eq(
						$elm$core$Maybe$Just(lu.Aq),
						model.kC);
				},
				niveaux));
		var _v0 = A2($elm$core$Maybe$andThen, $author$project$Components$Produits$SchemaDeNiveau$API$QueryAPIModel$schemaDuNiveau, niveau);
		if (!_v0.$) {
			var lecture = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						nf: false,
						np: $elm$core$Maybe$Just(lecture),
						os: niveau
					}),
				_List_fromArray(
					[
						$author$project$Components$Produits$Common$Effet$Lire(lecture)
					]));
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{nf: true, np: $elm$core$Maybe$Nothing, os: $elm$core$Maybe$Nothing}),
				_List_Nil);
		}
	});
var $author$project$Components$Produits$SchemaDeNiveau$Update$update = F2(
	function (msg, model) {
		var initial = $author$project$Components$Produits$SchemaDeNiveau$Model$init;
		switch (msg.$) {
			case 0:
				var niveau = msg.a;
				var racine = msg.b;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$structureDuCatalogue, racine);
				if (!_v1.$) {
					var structure = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							initial,
							{
								kC: $elm$core$Maybe$Just(niveau),
								h$: $elm$core$Maybe$Just(structure)
							}),
						_List_fromArray(
							[
								$author$project$Components$Produits$Common$Effet$DemanderProcessUid,
								$author$project$Components$Produits$Common$Effet$LireLaStructure(structure)
							]));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							initial,
							{
								kC: $elm$core$Maybe$Just(niveau)
							}),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$Components$Produits$Common$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 2:
				var reponse = msg.a;
				var _v2 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$SchemaDeNiveau$API$QueryAPIModel$niveauxDecoder, reponse);
				if (!_v2.$) {
					var niveaux = _v2.a;
					return A2($author$project$Components$Produits$SchemaDeNiveau$Update$surLaStructure, niveaux, model);
				} else {
					var refus = _v2.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 3:
				var reponse = msg.a;
				var _v3 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$SchemaDeNiveau$API$QueryAPIModel$schemaDecoder, reponse);
				if (!_v3.$) {
					var schema = _v3.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								nf: false,
								aN: $elm$core$Maybe$Just(schema)
							}),
						_List_Nil);
				} else {
					var refus = _v3.a;
					return (refus.ri === 401) ? _Utils_Tuple2(
						model,
						_List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter])) : _Utils_Tuple2(
						_Utils_update(
							model,
							{nf: refus.ri === 404}),
						_List_Nil);
				}
			case 4:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Produits$SchemaDeNiveau$Update$relire(model));
			case 5:
				var geste = msg.a;
				return A3(
					$author$project$Components$Shared$EditeurDeSchema$Conduite$versLeDrawer,
					$author$project$Components$Produits$SchemaDeNiveau$Update$conduite(model),
					geste,
					model);
			case 6:
				return A3(
					$author$project$Components$Shared$EditeurDeSchema$Conduite$ouvrirLAjout,
					$author$project$Components$Produits$SchemaDeNiveau$Update$conduite(model),
					$author$project$Components$Produits$SchemaDeNiveau$Model$idDeLAjout,
					model);
			case 7:
				var geste = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Components$Shared$EditeurDeSchema$Conduite$saisir, geste, model),
					_List_Nil);
			case 9:
				return A2(
					$author$project$Components$Shared$EditeurDeSchema$Conduite$valider,
					$author$project$Components$Produits$SchemaDeNiveau$Update$conduite(model),
					model);
			case 8:
				var geste = msg.a;
				return A3(
					$author$project$Components$Shared$EditeurDeSchema$Conduite$surLeTableau,
					$author$project$Components$Produits$SchemaDeNiveau$Update$conduite(model),
					geste,
					model);
			default:
				var reponse = msg.a;
				var _v4 = A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, model.l2);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var envoi = _v5.a;
					var issue = _v5.b;
					var effets = _v5.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Produits$SchemaDeNiveau$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Main$Update$versLeSchemaDeNiveau = F3(
	function (i18n, msg, model) {
		var _v0 = A2(
			$author$project$Components$Produits$SchemaDeNiveau$Update$update,
			msg,
			A2(
				$author$project$Referentiel$Normes$poser,
				model.hd,
				$author$project$Components$Produits$SchemaDeNiveau$Model$ouvrir(model.Ir)));
		var schemaDeNiveau = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLesElements, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			A3($author$project$Main$Update$depuisLesElements, i18n, 7, 12),
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							A2(
								$author$project$Components$Produits$SchemaDeNiveau$Update$popMessages,
								$author$project$Components$Produits$SchemaDeNiveau$Model$ouvrir(model.Ir),
								msg),
							gardes),
						Ir: $author$project$Components$Produits$SchemaDeNiveau$Model$envelopper(schemaDeNiveau)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Model$PourLeTypeDePartiePrenante = 35;
var $author$project$Components$Referentiel$Type$Update$popMessages = function (msg) {
	switch (msg.$) {
		case 12:
			var reponse = msg.a;
			var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$API$QueryAPIModel$ficheDeTypeDecoder, reponse);
			if (_v1.$ === 1) {
				var refus = _v1.a;
				return A2(
					$elm$core$List$member,
					refus.ri,
					_List_fromArray(
						[401, 404])) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Components$Shared$Messages$Model$duRefus(refus));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 11:
			var octets = msg.a;
			return _Utils_eq(
				$author$project$API$ProcessUid$depuisOctets(octets),
				$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
				{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Type$Model$Illisible = {$: 2};
var $author$project$Components$Referentiel$Common$EffetDeType$LireLaListeDePrix = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Referentiel$Type$Model$Lue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Type$Model$creation = function (fiche) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerEtRattacherUneDefinition, fiche.r0.nQ);
};
var $author$project$Components$Referentiel$Type$Update$ajoutOuvert = function (model) {
	var _v0 = _Utils_Tuple2(
		A2($elm$core$Maybe$andThen, $author$project$Components$Referentiel$Type$Model$creation, model.zo),
		model.nC);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var lien = _v0.b.a;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{oR: true}),
			A2(
				$elm$core$List$cons,
				$author$project$Components$Referentiel$Common$EffetDeType$LireLaBibliotheque(lien),
				function () {
					var _v1 = _Utils_Tuple2(model.jZ, model.nG);
					if ((_v1.a.$ === 1) && (!_v1.b.$)) {
						var _v2 = _v1.a;
						var lienDesCollections = _v1.b.a;
						return _List_fromArray(
							[
								$author$project$Components$Referentiel$Common$EffetDeType$LireLesCollectionsDeChamps(lienDesCollections)
							]);
					} else {
						return _List_Nil;
					}
				}()));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Type$Model$archivage = function (fiche) {
	return A2(
		$elm$core$Maybe$map,
		$elm$core$Tuple$pair(
			$author$project$Components$Referentiel$Common$API$WriteAPIModel$ArchiverLeType(fiche.r0.r8)),
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$archiver, fiche.r0.nQ));
};
var $author$project$Components$Referentiel$Common$RattacherUnChamp$avecLaBibliotheque = function (champs) {
	return $author$project$Components$Referentiel$Common$RattacherUnChamp$avec(
		function (r) {
			return _Utils_update(
				r,
				{
					dq: $elm$core$Maybe$Just(champs)
				});
		});
};
var $author$project$Components$Referentiel$Type$Model$rattachement = function (fiche) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rattacherUnChamp, fiche.r0.nQ);
};
var $author$project$Components$Referentiel$Type$Model$idDeLAjout = 'referentiel-type-ajouter-un-champ';
var $author$project$Components$Referentiel$Type$Update$depuisLeRattachement = F2(
	function (model, _v0) {
		var etat = _v0.a;
		var effets = _v0.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (effet, _v1) {
					var courant = _v1.a;
					var faits = _v1.b;
					switch (effet.$) {
						case 0:
							var cible = effet.a;
							return _Utils_Tuple2(
								courant,
								_Utils_ap(
									faits,
									_List_fromArray(
										[
											$author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(cible)
										])));
						case 1:
							return _Utils_Tuple2(
								courant,
								_Utils_ap(
									faits,
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$EffetDeType$LireLaBibliotheque, $elm$core$List$singleton),
											courant.nC))));
						default:
							var voulue = effet.a;
							var _v3 = A3(
								$author$project$Components$Referentiel$Common$EnvoiDeType$partir,
								$elm$core$Maybe$Just(voulue.nB),
								A2($author$project$Components$Referentiel$Common$API$WriteAPIModel$ChangerLaPorteeDUnChamp, voulue.uN, voulue.F$),
								courant.l2);
							if (!_v3.$) {
								var _v4 = _v3.a;
								var envoi = _v4.a;
								var partis = _v4.b;
								return _Utils_Tuple2(
									_Utils_update(
										courant,
										{l2: envoi}),
									_Utils_ap(faits, partis));
							} else {
								return _Utils_Tuple2(courant, faits);
							}
					}
				}),
			_Utils_Tuple2(
				_Utils_update(
					model,
					{GZ: etat}),
				_List_Nil),
			effets);
	});
var $author$project$Components$Referentiel$Type$Update$surLeRattachement = F2(
	function (geste, model) {
		return A2(
			$author$project$Components$Referentiel$Type$Update$depuisLeRattachement,
			model,
			A2($author$project$Components$Referentiel$Common$RattacherUnChamp$update, geste, model.GZ));
	});
var $author$project$Components$Referentiel$Type$Update$versLeRattachement = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{lz: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.lz));
	});
var $author$project$Components$Referentiel$Type$Update$depuisLeNouveauChamp = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[$author$project$Components$Referentiel$Common$EffetDeType$DemanderProcessUid])));
			case 1:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Components$Referentiel$Common$EffetDeType$LireLesListesDuNouveauChamp(lien)
							])));
			case 2:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								A3($author$project$Components$Referentiel$Common$EffetDeType$EnvoyerUnNouveauChamp, lien, processUid, commande)
							])));
			case 3:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(cible)
							])));
			case 4:
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[$author$project$Components$Referentiel$Common$EffetDeType$Reconnecter])));
			case 5:
				var vuesAJour = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						vuesAJour ? A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$EffetDeType$Lire, $elm$core$List$singleton),
								model.np)) : _List_fromArray(
							[
								$author$project$Components$Referentiel$Common$EffetDeType$AttendreAvantDeRelire($author$project$Components$Referentiel$Common$EnvoiDeType$delaiDeRelectureMs)
							])));
			case 7:
				return function (_v2) {
					var ouvert = _v2.a;
					var ouverts = _v2.b;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(
							_Utils_ap(effets, ouverts)),
						A2(
							$author$project$Components$Referentiel$Type$Update$surLeRattachement,
							$author$project$Components$Referentiel$Common$RattacherUnChamp$ModeChoisi(1),
							ouvert));
				}(
					A2(
						$author$project$Components$Referentiel$Type$Update$versLeRattachement,
						$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Referentiel$Type$Model$idDeLAjout),
						_Utils_update(
							model,
							{
								GZ: $author$project$Components$Referentiel$Common$RattacherUnChamp$reinitialiser(model.GZ)
							})));
			default:
				return _Utils_Tuple2(model, effets);
		}
	});
var $author$project$Components$Referentiel$Type$Update$surLeNouveauChamp = F2(
	function (geste, model) {
		return function (_v0) {
			var nouveauChamp = _v0.a;
			var effets = _v0.b;
			return A3(
				$elm$core$List$foldl,
				$author$project$Components$Referentiel$Type$Update$depuisLeNouveauChamp,
				_Utils_Tuple2(
					_Utils_update(
						model,
						{oP: nouveauChamp}),
					_List_Nil),
				effets);
		}(
			A2($author$project$Components$Parametrage$NouveauChamp$Update$update, geste, model.oP));
	});
var $author$project$Components$Referentiel$Type$Update$nouveauChampOuvert = function (model) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		function (fiche) {
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$pair(fiche),
				$author$project$Components$Referentiel$Type$Model$creation(fiche));
		},
		model.zo);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var fiche = _v1.a;
		var lien = _v1.b;
		return A2(
			$author$project$Components$Referentiel$Type$Update$surLeNouveauChamp,
			$author$project$Components$Parametrage$NouveauChamp$Update$Ouvert(
				{
					un: (!_Utils_eq(
						$author$project$Components$Referentiel$Type$Model$rattachement(fiche),
						$elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(
						{
							bB: $author$project$I18n$Textes$referentielTypesAjoutBandeauDetail(
								{
									Dp: $author$project$I18n$Traductions$tel(fiche.r0.R.zX)
								})
						}) : $elm$core$Maybe$Nothing,
					uY: model.dq,
					vE: A2($elm$core$Maybe$withDefault, _List_Nil, model.jZ),
					R: {fs: $author$project$I18n$Textes$editeurDeSchemaAjouterValider, Dj: $author$project$I18n$Textes$editeurDeSchemaChampNom, JR: $author$project$I18n$Textes$editeurDeSchemaChampTypeDeChamp},
					Bz: lien,
					BF: model.BF,
					F$: 'parties-prenantes',
					F1: true,
					c0: _List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$author$project$Components$Referentiel$Identifiants$typeUidEncode(fiche.r0.r8))
						]),
					pN: $elm$core$Maybe$Nothing,
					aO: $author$project$I18n$Textes$referentielTypesAjoutSousTitre(
						{
							Dp: $author$project$I18n$Traductions$tel(fiche.r0.R.zX)
						}),
					h6: $author$project$I18n$Textes$editeurDeSchemaAjouterTitre,
					ib: _List_Nil,
					J_: model.J_,
					sb: model.sc
				}),
			_Utils_update(
				model,
				{oR: false}));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Type$Update$avecLeNouveauChamp = function (_v0) {
	var model = _v0.a;
	var effets = _v0.b;
	return A2(
		$elm$core$Tuple$mapSecond,
		$elm$core$Basics$append(effets),
		$author$project$Components$Referentiel$Type$Update$nouveauChampOuvert(model));
};
var $author$project$Components$Referentiel$Type$Model$limitation = function (fiche) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$limiterAuxOffres, fiche.r0.nQ);
};
var $author$project$Components$Referentiel$Type$Model$saisieDesOffres = function (model) {
	return {at: model.at, D3: model.D3, hC: model.hC};
};
var $author$project$Components$Referentiel$Type$Model$commandeDeLaLimite = function (model) {
	var _v0 = _Utils_Tuple2(
		model.zo,
		A2($elm$core$Maybe$andThen, $author$project$Components$Referentiel$Type$Model$limitation, model.zo));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var fiche = _v0.a.a;
		var lien = _v0.b.a;
		var nouvelles = A2(
			$author$project$Components$Referentiel$Common$ChoixDesOffres$nouvelles,
			$author$project$Components$Referentiel$Type$Model$saisieDesOffres(model),
			fiche.D3);
		return $elm$core$List$isEmpty(nouvelles) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			_Utils_Tuple2(
				A3(
					$author$project$Components$Referentiel$Common$API$WriteAPIModel$LimiterAuxOffres,
					fiche.r0.r8,
					_Utils_ap(fiche.D3, nouvelles),
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.r8;
						},
						fiche.E9)),
				lien));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Type$Model$commandePourToutes = function (model) {
	var _v0 = _Utils_Tuple2(
		model.zo,
		A2($elm$core$Maybe$andThen, $author$project$Components$Referentiel$Type$Model$limitation, model.zo));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var fiche = _v0.a.a;
		var lien = _v0.b.a;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(
				A3($author$project$Components$Referentiel$Common$API$WriteAPIModel$LimiterAuxOffres, fiche.r0.r8, _List_Nil, $elm$core$Maybe$Nothing),
				lien));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Type$Model$commandeSansLOffre = F2(
	function (offre, model) {
		var _v0 = _Utils_Tuple2(
			model.zo,
			A2($elm$core$Maybe$andThen, $author$project$Components$Referentiel$Type$Model$limitation, model.zo));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var fiche = _v0.a.a;
			var lien = _v0.b.a;
			var restantes = A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Aq;
					},
					$elm$core$Basics$neq(offre)),
				fiche.D3);
			return $elm$core$List$isEmpty(restantes) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				_Utils_Tuple2(
					A3(
						$author$project$Components$Referentiel$Common$API$WriteAPIModel$LimiterAuxOffres,
						fiche.r0.r8,
						restantes,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.r8;
							},
							fiche.E9)),
					lien));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Referentiel$Common$SaisieDeType$annuler = function (saisie) {
	return $author$project$Components$Referentiel$Common$SaisieDeType$ouverte(saisie.cx);
};
var $author$project$Components$Referentiel$Type$Model$servie = F2(
	function (fiche, model) {
		return _Utils_update(
			model,
			{
				fW: false,
				zo: $elm$core$Maybe$Just(fiche),
				nf: false,
				hP: $author$project$Components$Referentiel$Common$SaisieDeType$duType(fiche.r0),
				e2: false
			});
	});
var $author$project$Components$Referentiel$Type$Model$appliquer = F2(
	function (rendue, model) {
		var _v0 = model.zo;
		if (!_v0.$) {
			var fiche = _v0.a;
			var depuis = function (type_) {
				return A2(
					$author$project$Components$Referentiel$Common$TypeApresCommande$appliquer,
					rendue.mk,
					_Utils_update(
						type_,
						{nQ: rendue.nQ}));
			};
			return A2(
				$author$project$Components$Referentiel$Type$Model$servie,
				_Utils_update(
					fiche,
					{
						r0: depuis(fiche.r0)
					}),
				model);
		} else {
			return model;
		}
	});
var $author$project$Components$Referentiel$Type$Model$appliquerLaLimite = F3(
	function (voulues, rendue, model) {
		var _v0 = A2($author$project$Components$Referentiel$Type$Model$appliquer, rendue, model).zo;
		if (!_v0.$) {
			var fiche = _v0.a;
			return A2(
				$author$project$Components$Referentiel$Type$Model$servie,
				_Utils_update(
					fiche,
					{
						D3: voulues,
						E9: $elm$core$List$isEmpty(voulues) ? $elm$core$Maybe$Nothing : fiche.E9
					}),
				A2($author$project$Components$Referentiel$Type$Model$appliquer, rendue, model));
		} else {
			return model;
		}
	});
var $author$project$Components$Referentiel$Type$Update$relire = function (model) {
	return _Utils_Tuple2(
		model,
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$EffetDeType$Lire, $elm$core$List$singleton),
				model.np)));
};
var $author$project$Components$Referentiel$Type$Update$avecLaRelecture = function (_v0) {
	var model = _v0.a;
	var effets = _v0.b;
	return A2(
		$elm$core$Tuple$mapSecond,
		$elm$core$Basics$append(effets),
		$author$project$Components$Referentiel$Type$Update$relire(model));
};
var $author$project$Components$Referentiel$Type$Model$idDeLArchivage = 'type-archiver';
var $author$project$Components$Referentiel$Type$Model$idDeLaLimite = 'type-limiter-offres';
var $author$project$Components$Referentiel$Type$Model$idDeLaRestauration = 'type-restaurer';
var $author$project$Components$Referentiel$Type$Update$foyer = function (commande) {
	switch (commande.$) {
		case 3:
			return $author$project$Components$Referentiel$Type$Model$idDeLaRestauration;
		case 5:
			return $author$project$Components$Referentiel$Type$Model$idDeLaLimite;
		default:
			return $author$project$Components$Referentiel$Type$Model$idDeLArchivage;
	}
};
var $author$project$Components$Referentiel$Type$Model$idDuRechargement = 'type-recharger';
var $author$project$Components$Referentiel$Type$Model$prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(
	$author$project$Components$Shared$Drawer$Model$init($author$project$Components$Referentiel$Type$Model$nomDuRenommage));
var $author$project$I18n$Textes$referentielTypeErreurOffreIntrouvable = A3($author$project$I18n$Traductions$texte, 'referentiel.type.erreur.offre-introuvable', _List_Nil, 'Une des offres choisies n\'est plus proposée. Relisez la liste et choisissez-en d\'autres.');
var $author$project$Components$Referentiel$Type$Update$versLaLimite = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{nV: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.nV));
	});
var $author$project$Components$Referentiel$Type$Update$versLeRenommage = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{
						hL: drawer,
						hP: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? model.hP : $author$project$Components$Referentiel$Common$SaisieDeType$annuler(model.hP)
					});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Referentiel$Common$SaisieDeType$enCours(model.hP)
				},
				geste,
				model.hL));
	});
var $author$project$Components$Referentiel$Type$Update$conclure = F2(
	function (issue, model) {
		var saisie = model.hP;
		var dire = F2(
			function (commande, message) {
				switch (commande.$) {
					case 1:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									hP: _Utils_update(
										saisie,
										{
											pZ: $elm$core$Maybe$Just(message)
										})
								}),
							_List_Nil);
					case 5:
						return $author$project$Components$Shared$Drawer$Model$estOuvert(model.nV) ? _Utils_Tuple2(
							_Utils_update(
								model,
								{
									p2: $elm$core$Maybe$Just(message)
								}),
							_List_Nil) : _Utils_Tuple2(
							_Utils_update(
								model,
								{
									pZ: $elm$core$Maybe$Just(message)
								}),
							_List_fromArray(
								[
									$author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(
									$author$project$Components$Referentiel$Type$Update$foyer(commande))
								]));
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									pZ: $elm$core$Maybe$Just(message)
								}),
							_List_fromArray(
								[
									$author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(
									$author$project$Components$Referentiel$Type$Update$foyer(commande))
								]));
				}
			});
		_v0$5:
		while (true) {
			_v0$12:
			while (true) {
				switch (issue.$) {
					case 0:
						if (issue.c) {
							var commande = issue.a;
							var rendue = issue.b;
							return $elm$core$List$isEmpty(rendue.mk) ? $author$project$Components$Referentiel$Type$Update$relire(model) : A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Basics$append(
									rendue.sy ? _List_Nil : _List_fromArray(
										[
											$author$project$Components$Referentiel$Common$EffetDeType$AttendreAvantDeRelire($author$project$Components$Referentiel$Common$EnvoiDeType$delaiDeRelectureMs)
										])),
								function () {
									switch (commande.$) {
										case 1:
											return A2(
												$author$project$Components$Referentiel$Type$Update$versLeRenommage,
												$author$project$Components$Shared$Drawer$Update$Fermer,
												A2($author$project$Components$Referentiel$Type$Model$appliquer, rendue, model));
										case 2:
											return _Utils_Tuple2(
												A2($author$project$Components$Referentiel$Type$Model$appliquer, rendue, model),
												_List_fromArray(
													[
														$author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus($author$project$Components$Referentiel$Type$Model$idDeLaRestauration)
													]));
										case 3:
											return _Utils_Tuple2(
												A2($author$project$Components$Referentiel$Type$Model$appliquer, rendue, model),
												_List_fromArray(
													[
														$author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus($author$project$Components$Referentiel$Type$Model$idDeLArchivage)
													]));
										case 0:
											return _Utils_Tuple2(
												A2($author$project$Components$Referentiel$Type$Model$appliquer, rendue, model),
												_List_Nil);
										case 4:
											return _Utils_Tuple2(
												A2($author$project$Components$Referentiel$Type$Model$appliquer, rendue, model),
												_List_Nil);
										case 5:
											var voulues = commande.b;
											return A2(
												$elm$core$Tuple$mapFirst,
												function (m) {
													return _Utils_update(
														m,
														{e2: false});
												},
												A2(
													$author$project$Components$Referentiel$Type$Update$versLaLimite,
													$author$project$Components$Shared$Drawer$Update$Fermer,
													A3($author$project$Components$Referentiel$Type$Model$appliquerLaLimite, voulues, rendue, model)));
										case 6:
											return _Utils_Tuple2(
												A2($author$project$Components$Referentiel$Type$Model$appliquer, rendue, model),
												_List_Nil);
										case 7:
											return _Utils_Tuple2(
												A2($author$project$Components$Referentiel$Type$Model$appliquer, rendue, model),
												_List_Nil);
										case 8:
											return _Utils_Tuple2(
												A2($author$project$Components$Referentiel$Type$Model$appliquer, rendue, model),
												_List_Nil);
										case 9:
											return _Utils_Tuple2(
												A2($author$project$Components$Referentiel$Type$Model$appliquer, rendue, model),
												_List_Nil);
										case 10:
											return _Utils_Tuple2(
												A2($author$project$Components$Referentiel$Type$Model$appliquer, rendue, model),
												_List_Nil);
										case 11:
											return _Utils_Tuple2(
												A2($author$project$Components$Referentiel$Type$Model$appliquer, rendue, model),
												_List_Nil);
										case 12:
											return _Utils_Tuple2(
												A2($author$project$Components$Referentiel$Type$Model$appliquer, rendue, model),
												_List_Nil);
										case 13:
											return _Utils_Tuple2(
												A2($author$project$Components$Referentiel$Type$Model$appliquer, rendue, model),
												_List_Nil);
										case 14:
											return _Utils_Tuple2(
												A2($author$project$Components$Referentiel$Type$Model$appliquer, rendue, model),
												_List_Nil);
										case 15:
											return _Utils_Tuple2(
												A2($author$project$Components$Referentiel$Type$Model$appliquer, rendue, model),
												_List_Nil);
										case 16:
											return A2(
												$author$project$Components$Referentiel$Type$Update$versLeRattachement,
												$author$project$Components$Shared$Drawer$Update$Fermer,
												A2($author$project$Components$Referentiel$Type$Model$appliquer, rendue, model));
										case 17:
											return _Utils_Tuple2(
												A2($author$project$Components$Referentiel$Type$Model$appliquer, rendue, model),
												_List_Nil);
										case 18:
											return _Utils_Tuple2(
												A2($author$project$Components$Referentiel$Type$Model$appliquer, rendue, model),
												_List_Nil);
										case 19:
											return _Utils_Tuple2(
												A2($author$project$Components$Referentiel$Type$Model$appliquer, rendue, model),
												_List_Nil);
										case 20:
											var champ = commande.a;
											var portee = commande.b;
											return A2(
												$author$project$Components$Referentiel$Type$Update$depuisLeRattachement,
												A2($author$project$Components$Referentiel$Type$Model$appliquer, rendue, model),
												A3($author$project$Components$Referentiel$Common$RattacherUnChamp$porteeElargie, champ, portee, model.GZ));
										default:
											return _Utils_Tuple2(
												A2($author$project$Components$Referentiel$Type$Model$appliquer, rendue, model),
												_List_Nil);
									}
								}());
						} else {
							if (issue.a.$ === 16) {
								var _v2 = issue.a;
								return $author$project$Components$Referentiel$Type$Update$avecLaRelecture(
									A2($author$project$Components$Referentiel$Type$Update$versLeRattachement, $author$project$Components$Shared$Drawer$Update$Fermer, model));
							} else {
								return $author$project$Components$Referentiel$Type$Update$relire(
									_Utils_update(
										model,
										{
											hP: _Utils_update(
												saisie,
												{
													pZ: $elm$core$Maybe$Just(
														{Jx: $author$project$I18n$Textes$referentielTypesErreurRejeu, b9: $elm$core$Maybe$Nothing})
												})
										}));
							}
						}
					case 1:
						switch (issue.c.$) {
							case 23:
								switch (issue.a.$) {
									case 16:
										var _v3 = issue.a;
										var id = issue.c.a;
										return A2(
											$author$project$Components$Referentiel$Type$Update$depuisLeRattachement,
											model,
											A2($author$project$Components$Referentiel$Common$RattacherUnChamp$champDejaDansLaBibliotheque, id, model.GZ));
									case 20:
										break _v0$5;
									default:
										break _v0$12;
								}
							case 24:
								switch (issue.a.$) {
									case 16:
										var _v4 = issue.a;
										var refuse = issue.c.a;
										return A2(
											$author$project$Components$Referentiel$Type$Update$depuisLeRattachement,
											model,
											A2(
												$author$project$Components$Referentiel$Common$RattacherUnChamp$horsPortee,
												{uN: refuse.uN, F$: refuse.F$},
												model.GZ));
									case 20:
										break _v0$5;
									default:
										break _v0$12;
								}
							case 0:
								if (issue.a.$ === 20) {
									break _v0$5;
								} else {
									var langue = issue.c.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												hP: A2($author$project$Components$Referentiel$Common$SaisieDeType$prendre, langue, saisie)
											}),
										_List_fromArray(
											[
												$author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(
												A2(
													$author$project$Components$Referentiel$Common$SaisieDeType$idDuLibelle,
													$author$project$Components$Referentiel$Type$Model$prefixe,
													$author$project$Components$Referentiel$Common$SaisieDeType$codeDeLaLangue(langue)))
											]));
								}
							case 4:
								if (issue.a.$ === 20) {
									break _v0$5;
								} else {
									var commande = issue.a;
									var refus = issue.b;
									return A2(
										dire,
										commande,
										{Jx: $author$project$I18n$Textes$referentielTypesErreurLibelleRefuse, b9: refus.b9});
								}
							case 6:
								switch (issue.a.$) {
									case 20:
										break _v0$5;
									case 1:
										var _v6 = issue.a;
										var _v7 = issue.c;
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{
													fW: true,
													hP: _Utils_update(
														saisie,
														{
															pZ: $elm$core$Maybe$Just(
																{Jx: $author$project$I18n$Textes$referentielTypeConcurrente, b9: $elm$core$Maybe$Nothing})
														})
												}),
											_List_Nil);
									default:
										var _v8 = issue.c;
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{fW: true}),
											_List_fromArray(
												[
													$author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus($author$project$Components$Referentiel$Type$Model$idDuRechargement)
												]));
								}
							case 1:
								if (issue.a.$ === 20) {
									break _v0$5;
								} else {
									var refus = issue.b;
									var _v9 = issue.c;
									var renommage = model.hL;
									return $author$project$Components$Referentiel$Type$Update$relire(
										_Utils_update(
											model,
											{
												pZ: $elm$core$Maybe$Just(
													{Jx: $author$project$I18n$Textes$referentielTypeErreurArchive, b9: refus.b9}),
												hL: _Utils_update(
													renommage,
													{wQ: $elm$core$Maybe$Nothing, gt: 0}),
												hP: $author$project$Components$Referentiel$Common$SaisieDeType$annuler(saisie)
											}));
								}
							case 22:
								if (issue.a.$ === 20) {
									break _v0$5;
								} else {
									var commande = issue.a;
									var refus = issue.b;
									var _v10 = issue.c;
									return A2(
										dire,
										commande,
										{Jx: $author$project$I18n$Textes$referentielTypeErreurOffreIntrouvable, b9: refus.b9});
								}
							default:
								if (issue.a.$ === 20) {
									break _v0$5;
								} else {
									break _v0$12;
								}
						}
					default:
						return _Utils_Tuple2(model, _List_Nil);
				}
			}
			var commande = issue.a;
			var refus = issue.b;
			return A2(
				dire,
				commande,
				$author$project$Components$Shared$Messages$Model$duRefus(refus));
		}
		var _v5 = issue.a;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					GZ: $author$project$Components$Referentiel$Common$RattacherUnChamp$elargissementRefuse(model.GZ)
				}),
			_List_Nil);
	});
var $author$project$Components$Referentiel$Type$Model$modification = function (fiche) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierApparence, fiche.r0.nQ);
};
var $author$project$Components$Referentiel$Type$Model$commandeDeModification = function (model) {
	return $author$project$Components$Referentiel$Common$SaisieDeType$enCours(model.hP) ? A4(
		$elm$core$Maybe$map3,
		F3(
			function (fiche, lien, apparence) {
				return _Utils_Tuple2(
					A2($author$project$Components$Referentiel$Common$API$WriteAPIModel$ModifierLApparence, fiche.r0.r8, apparence),
					lien);
			}),
		model.zo,
		A2($elm$core$Maybe$andThen, $author$project$Components$Referentiel$Type$Model$modification, model.zo),
		$author$project$Components$Referentiel$Common$SaisieDeType$apparence(model.hP)) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$Referentiel$Type$Update$enregistrer = function (model) {
	var saisie = model.hP;
	if (!$author$project$Components$Shared$Drawer$Model$estOuvert(model.hL)) {
		return _Utils_Tuple2(model, _List_Nil);
	} else {
		if (!$author$project$Components$Referentiel$Common$SaisieDeType$enCours(saisie)) {
			return A2($author$project$Components$Referentiel$Type$Update$versLeRenommage, $author$project$Components$Shared$Drawer$Update$Fermer, model);
		} else {
			var _v0 = $author$project$Components$Referentiel$Type$Model$commandeDeModification(model);
			if (!_v0.$) {
				var _v1 = _v0.a;
				var commande = _v1.a;
				var lien = _v1.b;
				var _v2 = A3(
					$author$project$Components$Referentiel$Common$EnvoiDeType$partir,
					$elm$core$Maybe$Just(lien),
					commande,
					model.l2);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var envoi = _v3.a;
					var effets = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l2: envoi,
								hP: _Utils_update(
									saisie,
									{pZ: $elm$core$Maybe$Nothing})
							}),
						effets);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			} else {
				return _Utils_eq(
					A2($elm$core$Maybe$andThen, $author$project$Components$Referentiel$Type$Model$modification, model.zo),
					$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hP: $author$project$Components$Referentiel$Common$SaisieDeType$tenter(saisie)
						}),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus, $elm$core$List$singleton),
							A3(
								$author$project$Components$Referentiel$Common$SaisieDeType$idDuPremierDefaut,
								{uc: false},
								$author$project$Components$Referentiel$Type$Model$prefixe,
								saisie))));
			}
		}
	}
};
var $author$project$Components$Referentiel$Type$Update$envoyerLaLimite = F2(
	function (commande, model) {
		if (!commande.$) {
			var _v1 = commande.a;
			var cmd = _v1.a;
			var lien = _v1.b;
			var _v2 = A3(
				$author$project$Components$Referentiel$Common$EnvoiDeType$partir,
				$elm$core$Maybe$Just(lien),
				cmd,
				model.l2);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var envoi = _v3.a;
				var effets = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{l2: envoi, pZ: $elm$core$Maybe$Nothing, p2: $elm$core$Maybe$Nothing}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			var message = $elm$core$Maybe$Just(
				{Jx: $author$project$I18n$Textes$referentielTypeLimiteErreurVide, b9: $elm$core$Maybe$Nothing});
			return $author$project$Components$Shared$Drawer$Model$estOuvert(model.nV) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{p2: message}),
				_List_Nil) : _Utils_Tuple2(
				_Utils_update(
					model,
					{pZ: message}),
				_List_Nil);
		}
	});
var $author$project$Components$Referentiel$Type$Model$idDuRenommer = 'type-renommer';
var $author$project$Components$Referentiel$Type$Model$idsDeLaConfirmation = {to: 'archivage-annuler', j7: 'archivage-confirmer', Cs: 'archivage-message', GN: 'archivage', h6: 'archivage-titre'};
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$listeDePrixDuTypeDecoder = function (type_) {
	var validites = A2(
		$elm$json$Json$Decode$field,
		'listes',
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (id, fin, devise) {
						return _Utils_Tuple2(
							id,
							_Utils_Tuple2(fin, devise));
					}),
				A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$maybe(
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['validite', 'fin']),
						$elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$maybe(
					A2($elm$json$Json$Decode$field, 'devise', $elm$json$Json$Decode$string)))));
	var uid = $author$project$Components$Referentiel$Identifiants$typeUidToString(type_);
	var nomEtId = A3(
		$elm$json$Json$Decode$map2,
		$elm$core$Tuple$pair,
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'nom', $author$project$Components$Referentiel$Common$API$QueryAPIModel$libellesDecoder));
	var duType = A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault(false),
		$elm$json$Json$Decode$maybe(
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Basics$eq(uid),
				A2(
					$elm$json$Json$Decode$field,
					'public',
					A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string)))));
	return A4(
		$elm$json$Json$Decode$map3,
		F3(
			function (existe, couverts, fins) {
				return {
					mq: existe,
					nW: function () {
						var detail = function (id) {
							return A2(
								$elm$core$Maybe$map,
								$elm$core$Tuple$second,
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$Tuple$first,
											$elm$core$Basics$eq(id)),
										fins)));
						};
						return A2(
							$elm$core$Maybe$map,
							function (_v1) {
								var id = _v1.a;
								var nom = _v1.b;
								return {
									kO: A2(
										$elm$core$Maybe$andThen,
										$elm$core$Tuple$second,
										detail(id)),
									mI: A2(
										$elm$core$Maybe$andThen,
										$elm$core$Tuple$first,
										detail(id)),
									Dj: nom
								};
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$filterMap,
									function (_v0) {
										var concerne = _v0.a;
										var liste = _v0.b;
										return concerne ? liste : $elm$core$Maybe$Nothing;
									},
									couverts)));
					}()
				};
			}),
		A2(
			$elm$json$Json$Decode$map,
			function (n) {
				return n > 0;
			},
			A2($elm$json$Json$Decode$field, 'nombre', $elm$json$Json$Decode$int)),
		A2(
			$elm$json$Json$Decode$field,
			'prixParPublic',
			$elm$json$Json$Decode$list(
				A3(
					$elm$json$Json$Decode$map2,
					$elm$core$Tuple$pair,
					duType,
					$elm$json$Json$Decode$maybe(
						A2($elm$json$Json$Decode$field, 'liste', nomEtId))))),
		validites);
};
var $author$project$API$NavLinksDictionary$listesDePrix = 'listes-de-prix';
var $author$project$Components$Referentiel$Type$Update$nouveauChampPret = function (model) {
	var _v0 = _Utils_Tuple2(
		model.oR,
		A2(
			$elm$core$Maybe$andThen,
			function (fiche) {
				return A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(fiche),
					$author$project$Components$Referentiel$Type$Model$creation(fiche));
			},
			model.zo));
	if (_v0.a && (!_v0.b.$)) {
		var _v1 = _v0.b.a;
		return ((!_Utils_eq(model.nG, $elm$core$Maybe$Nothing)) && _Utils_eq(model.jZ, $elm$core$Maybe$Nothing)) ? _Utils_Tuple2(model, _List_Nil) : $author$project$Components$Referentiel$Type$Update$nouveauChampOuvert(model);
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Type$Model$offresProposees = function (fiche) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$offresPourLaLimite, fiche.r0.nQ);
};
var $author$project$Components$Referentiel$Type$Update$partir = F2(
	function (geste, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (_v1) {
				var commande = _v1.a;
				var lien = _v1.b;
				return A3(
					$author$project$Components$Referentiel$Common$EnvoiDeType$partir,
					$elm$core$Maybe$Just(lien),
					commande,
					model.l2);
			},
			geste);
		if (!_v0.$) {
			var _v2 = _v0.a;
			var envoi = _v2.a;
			var effets = _v2.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi, pZ: $elm$core$Maybe$Nothing}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Common$RattacherUnChamp$sansRefus = $author$project$Components$Referentiel$Common$RattacherUnChamp$avec(
	function (r) {
		return _Utils_update(
			r,
			{pZ: $elm$core$Maybe$Nothing});
	});
var $author$project$Components$Referentiel$Type$Update$rattacherLeChamp = function (model) {
	var _v0 = _Utils_Tuple2(model.zo, model.GZ.pN.vd);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var fiche = _v0.a.a;
		var champ = _v0.b.a;
		return A2(
			$author$project$Components$Referentiel$Type$Update$partir,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$pair(
					A3($author$project$Components$Referentiel$Common$API$WriteAPIModel$RattacherUnChampAUnType, fiche.r0.r8, champ, model.GZ.pN.qc)),
				$author$project$Components$Referentiel$Type$Model$rattachement(fiche)),
			_Utils_update(
				model,
				{
					GZ: $author$project$Components$Referentiel$Common$RattacherUnChamp$sansRefus(model.GZ)
				}));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Type$Model$restauration = function (fiche) {
	return A2(
		$elm$core$Maybe$map,
		$elm$core$Tuple$pair(
			$author$project$Components$Referentiel$Common$API$WriteAPIModel$RestaurerLeType(fiche.r0.r8)),
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$restaurer, fiche.r0.nQ));
};
var $author$project$API$NavLinksDictionary$parametrageDuTypeDePartiePrenante = 'parametrage-du-type-de-partie-prenante';
var $author$project$Components$Referentiel$Liens$versType = F2(
	function (uid, gabarits) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$API$NavLinksDictionary$variableUid,
						$author$project$Components$Referentiel$Identifiants$typeUidToString(uid))
					])),
			A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$parametrageDuTypeDePartiePrenante, gabarits));
	});
var $author$project$Components$Referentiel$Type$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var uid = msg.a;
				var liens = msg.b;
				var gabarits = msg.c;
				if (_Utils_eq(
					model.kD,
					$elm$core$Maybe$Just(uid))) {
					return _Utils_Tuple2(model, _List_Nil);
				} else {
					var listes = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$listesDePrix, liens);
					var _v1 = A2($author$project$Components$Referentiel$Liens$versType, uid, gabarits);
					if (!_v1.$) {
						var lecture = _v1.a;
						return _Utils_Tuple2(
							A3(
								$author$project$Components$Referentiel$Type$Model$ouvertAvec,
								$elm$core$Maybe$Just(uid),
								$elm$core$Maybe$Just(lecture),
								listes),
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Components$Referentiel$Common$EffetDeType$DemanderProcessUid,
										$author$project$Components$Referentiel$Common$EffetDeType$Lire(lecture)
									]),
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$EffetDeType$LireLaListeDePrix, $elm$core$List$singleton),
										listes))));
					} else {
						return _Utils_Tuple2(
							A2(
								$author$project$Components$Referentiel$Type$Model$ouvert,
								$elm$core$Maybe$Just(uid),
								$elm$core$Maybe$Nothing),
							_List_Nil);
					}
				}
			case 1:
				var reponse = msg.a;
				var _v2 = A2(
					$elm$core$Maybe$map,
					function (uid) {
						return A2(
							$author$project$API$Reponse$lire,
							$author$project$Components$Referentiel$Common$API$QueryAPIModel$listeDePrixDuTypeDecoder(uid),
							reponse);
					},
					model.kD);
				if ((!_v2.$) && (!_v2.a.$)) {
					var liste = _v2.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								nY: $author$project$Components$Referentiel$Type$Model$Lue(liste)
							}),
						_List_Nil);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{nY: $author$project$Components$Referentiel$Type$Model$Illisible}),
						_List_Nil);
				}
			case 2:
				var reponse = msg.a;
				var _v3 = A2(
					$author$project$API$Reponse$lire,
					$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$QueryAPIModel$offreProposeeDecoder),
					reponse);
				if (!_v3.$) {
					var offres = _v3.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								D3: $author$project$Components$Referentiel$Common$Offres$Lue(
									$author$project$Components$Referentiel$Common$Offres$depuis(offres))
							}),
						_List_Nil);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{D3: $author$project$Components$Referentiel$Common$Offres$Illisible}),
						_List_Nil);
				}
			case 3:
				var _v4 = A2(
					$elm$core$Maybe$andThen,
					function (fiche) {
						return A2(
							$elm$core$Maybe$map,
							function (_v5) {
								return fiche;
							},
							$author$project$Components$Referentiel$Type$Model$limitation(fiche));
					},
					model.zo);
				if (!_v4.$) {
					var fiche = _v4.a;
					var lecture = function () {
						var _v7 = _Utils_Tuple2(
							model.D3,
							$author$project$Components$Referentiel$Type$Model$offresProposees(fiche));
						if ((!_v7.a.$) && (!_v7.b.$)) {
							var _v8 = _v7.a;
							var lien = _v7.b.a;
							return _List_fromArray(
								[
									$author$project$Components$Referentiel$Common$EffetDeType$LireLesOffres(lien)
								]);
						} else {
							return _List_Nil;
						}
					}();
					var _v6 = A2(
						$author$project$Components$Referentiel$Type$Update$versLaLimite,
						$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Referentiel$Type$Model$idDeLaLimite),
						_Utils_update(
							model,
							{at: _List_Nil, hC: '', p2: $elm$core$Maybe$Nothing}));
					var ouvert = _v6.a;
					var effets = _v6.b;
					return _Utils_Tuple2(
						ouvert,
						_Utils_ap(effets, lecture));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 4:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Type$Update$versLaLimite, geste, model);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pZ: $elm$core$Maybe$Nothing, e2: true}),
					_List_Nil);
			case 5:
				var _v9 = model.zo;
				if (!_v9.$) {
					var fiche = _v9.a;
					return $elm$core$List$isEmpty(fiche.D3) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{pZ: $elm$core$Maybe$Nothing, e2: false}),
						_List_Nil) : A2(
						$author$project$Components$Referentiel$Type$Update$envoyerLaLimite,
						$author$project$Components$Referentiel$Type$Model$commandePourToutes(model),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 7:
				var offre = msg.a;
				return A2(
					$author$project$Components$Referentiel$Type$Update$envoyerLaLimite,
					A2($author$project$Components$Referentiel$Type$Model$commandeSansLOffre, offre, model),
					model);
			case 9:
				var offre = msg.a;
				var coche = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							at: A3($author$project$Components$Referentiel$Common$ChoixDesOffres$cocher, offre, coche, model.at),
							p2: $elm$core$Maybe$Nothing
						}),
					_List_Nil);
			case 8:
				var texte = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{hC: texte}),
					_List_Nil);
			case 10:
				return A2(
					$author$project$Components$Referentiel$Type$Update$envoyerLaLimite,
					$author$project$Components$Referentiel$Type$Model$commandeDeLaLimite(model),
					model);
			case 11:
				var octets = msg.a;
				return $author$project$Components$Parametrage$NouveauChamp$Model$ouvert(model.oP) ? A2(
					$author$project$Components$Referentiel$Type$Update$surLeNouveauChamp,
					$author$project$Components$Parametrage$NouveauChamp$Update$ProcessUidRecu(octets),
					model) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$Components$Referentiel$Common$EnvoiDeType$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 25:
				var lien = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{nC: lien}),
					_List_Nil);
			case 26:
				var lien = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{BF: lien}),
					_List_Nil);
			case 27:
				var lien = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{nG: lien}),
					_List_Nil);
			case 28:
				var reponse = msg.a;
				var _v10 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$CollectionsDeChamps$API$QueryAPIModel$collectionsDecoder, reponse);
				if (!_v10.$) {
					var lues = _v10.a;
					return $author$project$Components$Referentiel$Type$Update$nouveauChampPret(
						_Utils_update(
							model,
							{
								jZ: $elm$core$Maybe$Just(
									$author$project$Components$Parametrage$CollectionsDeChamps$API$QueryAPIModel$pourLeDrawer(lues))
							}));
				} else {
					var refus = _v10.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Referentiel$Common$EffetDeType$Reconnecter]) : _List_Nil);
				}
			case 29:
				return $author$project$Components$Referentiel$Type$Update$ajoutOuvert(model);
			case 31:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Type$Update$surLeNouveauChamp, geste, model);
			case 32:
				if ((msg.a.$ === 1) && (!msg.a.a)) {
					var _v11 = msg.a.a;
					return $author$project$Components$Referentiel$Type$Update$avecLeNouveauChamp(
						A2($author$project$Components$Referentiel$Type$Update$versLeRattachement, $author$project$Components$Shared$Drawer$Update$Fermer, model));
				} else {
					var geste = msg.a;
					return A2($author$project$Components$Referentiel$Type$Update$surLeRattachement, geste, model);
				}
			case 33:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Type$Update$versLeRattachement, geste, model);
			case 34:
				return $author$project$Components$Referentiel$Type$Update$rattacherLeChamp(model);
			case 30:
				var reponse = msg.a;
				var _v12 = A2(
					$author$project$API$Reponse$lire,
					A4(
						$elm$json$Json$Decode$map3,
						F3(
							function (c, t, u) {
								return _Utils_Tuple3(c, t, u);
							}),
						$author$project$Components$Shared$Bibliotheque$Champ$bibliothequeDecoder,
						$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$typesProposesDecoder,
						$author$project$Components$Parametrage$BibliothequeDeChamps$API$QueryAPIModel$unitesDeMesureDecoder),
					reponse);
				if (!_v12.$) {
					var _v13 = _v12.a;
					var champs = _v13.a;
					var types = _v13.b;
					var unites = _v13.c;
					return $author$project$Components$Referentiel$Type$Update$nouveauChampPret(
						_Utils_update(
							model,
							{
								dq: champs,
								GZ: A2($author$project$Components$Referentiel$Common$RattacherUnChamp$avecLaBibliotheque, champs, model.GZ),
								J_: types,
								sc: unites
							}));
				} else {
					var refus = _v12.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Referentiel$Common$EffetDeType$Reconnecter]) : _List_Nil);
				}
			case 12:
				var reponse = msg.a;
				var _v14 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$API$QueryAPIModel$ficheDeTypeDecoder, reponse);
				if (!_v14.$) {
					var fiche = _v14.a;
					return _Utils_Tuple2(
						A2($author$project$Components$Referentiel$Type$Model$servie, fiche, model),
						_List_Nil);
				} else {
					var refus = _v14.a;
					return (refus.ri === 401) ? _Utils_Tuple2(
						model,
						_List_fromArray(
							[$author$project$Components$Referentiel$Common$EffetDeType$Reconnecter])) : _Utils_Tuple2(
						_Utils_update(
							model,
							{nf: refus.ri === 404}),
						_List_Nil);
				}
			case 13:
				return $author$project$Components$Referentiel$Type$Update$relire(model);
			case 14:
				var champ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hP: A2($author$project$Components$Referentiel$Common$SaisieDeType$saisir, champ, model.hP)
						}),
					_List_Nil);
			case 15:
				var _v15 = A2(
					$elm$core$Maybe$andThen,
					function (fiche) {
						return A2(
							$elm$core$Maybe$map,
							function (_v16) {
								return fiche;
							},
							$author$project$Components$Referentiel$Type$Model$modification(fiche));
					},
					model.zo);
				if (!_v15.$) {
					var fiche = _v15.a;
					return A2(
						$author$project$Components$Referentiel$Type$Update$versLeRenommage,
						$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Referentiel$Type$Model$idDuRenommer),
						_Utils_update(
							model,
							{
								hP: $author$project$Components$Referentiel$Common$SaisieDeType$duType(fiche.r0)
							}));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 16:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Type$Update$versLeRenommage, geste, model);
			case 17:
				return $author$project$Components$Referentiel$Type$Update$enregistrer(model);
			case 18:
				return _Utils_eq(
					A2($elm$core$Maybe$andThen, $author$project$Components$Referentiel$Type$Model$archivage, model.zo),
					$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : _Utils_Tuple2(
					_Utils_update(
						model,
						{ir: true}),
					_List_fromArray(
						[
							$author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus($author$project$Components$Referentiel$Type$Model$idsDeLaConfirmation.to)
						]));
			case 19:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ir: false}),
					_List_fromArray(
						[
							$author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus($author$project$Components$Referentiel$Type$Model$idDeLArchivage)
						]));
			case 20:
				return model.ir ? A2(
					$author$project$Components$Referentiel$Type$Update$partir,
					A2($elm$core$Maybe$andThen, $author$project$Components$Referentiel$Type$Model$archivage, model.zo),
					_Utils_update(
						model,
						{ir: false})) : _Utils_Tuple2(model, _List_Nil);
			case 21:
				return A2(
					$author$project$Components$Referentiel$Type$Update$partir,
					A2($elm$core$Maybe$andThen, $author$project$Components$Referentiel$Type$Model$restauration, model.zo),
					model);
			case 22:
				var cible = msg.a;
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[
							$author$project$Components$Referentiel$Common$EffetDeType$PlacerFocus(cible)
						]));
			case 23:
				return $author$project$Components$Referentiel$Type$Update$relire(model);
			default:
				var reponse = msg.a;
				var _v17 = A2($author$project$Components$Referentiel$Common$EnvoiDeType$conclure, reponse, model.l2);
				if (!_v17.$) {
					var _v18 = _v17.a;
					var envoi = _v18.a;
					var issue = _v18.b;
					var effets = _v18.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Referentiel$Type$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Main$Update$versLeTypeDePartiePrenante = F3(
	function (i18n, msg, model) {
		var _v0 = A2(
			$author$project$Components$Referentiel$Type$Update$update,
			msg,
			$author$project$Components$Referentiel$Type$Model$ouvrir(model.JT));
		var typeDePartiePrenante = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLesTypes, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			A2($author$project$Main$Update$depuisLesTypes, 1, 35),
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Referentiel$Type$Update$popMessages(msg),
							gardes),
						JT: $author$project$Components$Referentiel$Type$Model$envelopper(typeDePartiePrenante)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$AttendreAvantDeRelireLesCollectionsDeChamps = function (a) {
	return {$: 218, a: a};
};
var $author$project$Main$Update$EnvoyerAuxCollectionsDeChamps = function (a) {
	return {$: 217, a: a};
};
var $author$project$Main$Update$LireLesCollectionsDeChamps = function (a) {
	return {$: 216, a: a};
};
var $author$project$Main$Model$PourLesCollectionsDeChamps = 41;
var $author$project$Main$Update$depuisLesCollectionsDeChamps = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[41]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 1:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesCollectionsDeChamps)));
			case 2:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerAuxCollectionsDeChamps(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 3:
				var delaiMs = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AttendreAvantDeRelireLesCollectionsDeChamps(delaiMs)
							])));
			case 4:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$popMessages = function (_v0) {
	return $elm$core$Maybe$Nothing;
};
var $author$project$Main$Update$requeteSurLesCollectionsDeChamps = function (effet) {
	switch (effet.$) {
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$DemanderProcessUid = {$: 0};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$Lire = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIModel$Archiver = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$Envoyer = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$Reconnecter = {$: 5};
var $author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIErrorsModel$AccesRefuse = {$: 4};
var $author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIErrorsModel$AutreRefus = {$: 5};
var $author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIErrorsModel$ChampDejaDansUneAutreCollection = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIErrorsModel$CollectionDejaDansLaBibliotheque = {$: 1};
var $author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIErrorsModel$CollectionHorsPortee = {$: 3};
var $author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIErrorsModel$CollectionNonVide = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIErrorsModel$duRefus = function (reponse) {
	if (reponse.ri === 403) {
		return $author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIErrorsModel$AccesRefuse;
	} else {
		var _v0 = A2(
			$elm$json$Json$Decode$decodeString,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['error']),
				$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value)),
			reponse.f$);
		_v0$4:
		while (true) {
			if ((!_v0.$) && _v0.a.b) {
				switch (_v0.a.a.a) {
					case 'CollectionNonVide':
						var _v1 = _v0.a;
						var _v2 = _v1.a;
						var contenu = _v2.b;
						return A2(
							$elm$core$Result$withDefault,
							$author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIErrorsModel$AutreRefus,
							A2(
								$elm$core$Result$map,
								$author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIErrorsModel$CollectionNonVide,
								A2(
									$elm$json$Json$Decode$decodeValue,
									A2($elm$json$Json$Decode$field, 'membres', $elm$json$Json$Decode$int),
									contenu)));
					case 'CollectionDejaDansLaBibliotheque':
						var _v3 = _v0.a;
						var _v4 = _v3.a;
						return $author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIErrorsModel$CollectionDejaDansLaBibliotheque;
					case 'ChampDejaDansUneAutreCollection':
						var _v5 = _v0.a;
						var _v6 = _v5.a;
						var contenu = _v6.b;
						return A2(
							$elm$core$Result$withDefault,
							$author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIErrorsModel$AutreRefus,
							A2(
								$elm$core$Result$map,
								$author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIErrorsModel$ChampDejaDansUneAutreCollection,
								A2(
									$elm$json$Json$Decode$decodeValue,
									A2($elm$json$Json$Decode$field, 'collection', $elm$json$Json$Decode$string),
									contenu)));
					case 'CollectionHorsPortee':
						var _v7 = _v0.a;
						var _v8 = _v7.a;
						return $author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIErrorsModel$CollectionHorsPortee;
					default:
						break _v0$4;
				}
			} else {
				break _v0$4;
			}
		}
		return $author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIErrorsModel$AutreRefus;
	}
};
var $author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIModel$Rendue = F2(
	function (vuesAJour, liens) {
		return {nQ: liens, sy: vuesAJour};
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIModel$rendueDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'liens',
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vuesAJour',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIModel$Rendue)));
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$reglage = {
	f8: $author$project$Components$Parametrage$CollectionsDeChamps$Update$DemanderProcessUid,
	l4: $author$project$Components$Parametrage$CollectionsDeChamps$Update$Envoyer,
	go: $author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIErrorsModel$duRefus,
	pW: $author$project$Components$Parametrage$CollectionsDeChamps$Update$Reconnecter,
	qu: F2(
		function (_v0, _v1) {
			return true;
		}),
	qv: $author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIModel$rendueDecoder
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$envoyer = F3(
	function (lien, commande, model) {
		var _v0 = A4($author$project$API$Envoi$partir, $author$project$Components$Parametrage$CollectionsDeChamps$Update$reglage, lien, commande, model.l2);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var envoi = _v1.a;
			var effets = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi, pZ: $elm$core$Maybe$Nothing}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$archiverUneCollection = 'archiver-une-collection';
var $author$project$Components$Parametrage$CollectionsDeChamps$Model$lienDeLArchivage = function (collection) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$archiverUneCollection, collection.nQ);
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$archiver = F2(
	function (collection, model) {
		return A3(
			$author$project$Components$Parametrage$CollectionsDeChamps$Update$envoyer,
			$author$project$Components$Parametrage$CollectionsDeChamps$Model$lienDeLArchivage(collection),
			$author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIModel$Archiver(collection.Aq),
			_Utils_update(
				model,
				{
					ir: $elm$core$Maybe$Just(collection)
				}));
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIModel$ArchiverEnRetirant = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$archiverEnRetirant = F2(
	function (collection, model) {
		return A3(
			$author$project$Components$Parametrage$CollectionsDeChamps$Update$envoyer,
			$author$project$Components$Parametrage$CollectionsDeChamps$Model$lienDeLArchivage(collection),
			$author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIModel$ArchiverEnRetirant(collection.Aq),
			_Utils_update(
				model,
				{
					ir: $elm$core$Maybe$Just(collection)
				}));
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$Model$basculer = F2(
	function (champ, choisis) {
		return A2($elm$core$List$member, champ, choisis) ? A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(champ),
			choisis) : _Utils_ap(
			choisis,
			_List_fromArray(
				[champ]));
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$AttendreAvantDeRelire = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$PlacerFocus = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Model$saisieEnCours = function (model) {
	return ($elm$core$String$trim(model.Bl) !== '') || ($elm$core$String$trim(model.dy) !== '');
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{k7: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Parametrage$CollectionsDeChamps$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Parametrage$CollectionsDeChamps$Model$saisieEnCours(model)
				},
				geste,
				model.k7));
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$Model$traductionEnCours = function (model) {
	var _v0 = model.fr;
	if (!_v0.$) {
		var collection = _v0.a;
		return (!_Utils_eq(
			$elm$core$String$trim(model.dY),
			collection.Bl)) || (!_Utils_eq(
			$elm$core$String$trim(model.t),
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Dict$get, 'en', collection.R))));
	} else {
		return false;
	}
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$versLeDrawerDeTraduction = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{lj: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Parametrage$CollectionsDeChamps$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Parametrage$CollectionsDeChamps$Model$traductionEnCours(model)
				},
				geste,
				model.lj));
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$conclure = F2(
	function (issue, model) {
		switch (issue.$) {
			case 0:
				var commande = issue.a;
				var rendue = issue.b;
				var relecture = rendue.sy ? A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$CollectionsDeChamps$Update$Lire, $elm$core$List$singleton),
						model.np)) : _List_fromArray(
					[
						$author$project$Components$Parametrage$CollectionsDeChamps$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
					]);
				switch (commande.$) {
					case 0:
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(relecture),
							A2(
								$author$project$Components$Parametrage$CollectionsDeChamps$Update$versLeDrawer,
								$author$project$Components$Shared$Drawer$Update$Fermer,
								_Utils_update(
									model,
									{jD: _List_Nil, dy: '', Bl: '', pZ: $elm$core$Maybe$Nothing})));
					case 1:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{ir: $elm$core$Maybe$Nothing, pZ: $elm$core$Maybe$Nothing}),
							relecture);
					case 2:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{ir: $elm$core$Maybe$Nothing, pZ: $elm$core$Maybe$Nothing}),
							relecture);
					default:
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(relecture),
							A2(
								$author$project$Components$Parametrage$CollectionsDeChamps$Update$versLeDrawerDeTraduction,
								$author$project$Components$Shared$Drawer$Update$Fermer,
								_Utils_update(
									model,
									{fr: $elm$core$Maybe$Nothing, pZ: $elm$core$Maybe$Nothing})));
				}
			case 1:
				var erreur = issue.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							pZ: $elm$core$Maybe$Just(erreur)
						}),
					_List_Nil);
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIModel$Creer = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$Model$creationPrete = function (model) {
	return $elm$core$String$trim(model.Bl) !== '';
};
var $author$project$API$NavLinksDictionary$creerUneCollection = 'creer-une-collection';
var $author$project$Components$Parametrage$CollectionsDeChamps$Model$lienDeLaCreation = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.nQ;
			},
			$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$creerUneCollection)),
		model.vE);
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$creer = function (model) {
	return $author$project$Components$Parametrage$CollectionsDeChamps$Model$creationPrete(model) ? A3(
		$author$project$Components$Parametrage$CollectionsDeChamps$Update$envoyer,
		$author$project$Components$Parametrage$CollectionsDeChamps$Model$lienDeLaCreation(model),
		A4(
			$author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIModel$Creer,
			$elm$core$String$trim(model.Bl),
			$elm$core$String$trim(model.dy),
			model.F$,
			model.jD),
		model) : _Utils_Tuple2(model, _List_Nil);
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$idDuDeclencheur = 'collections-creer';
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$idDuDeclencheurDeTraduction = function (collection) {
	return 'collections-traduire-' + collection.Aq;
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Model$lienDeLaLecture = $author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$collectionsDeChamps);
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$lue = F2(
	function (reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$CollectionsDeChamps$API$QueryAPIModel$collectionsDecoder, reponse);
		if (!_v0.$) {
			var collections = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						vE: $elm$core$Maybe$Just(collections),
						gd: false
					}),
				_List_Nil);
		} else {
			var refus = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{gd: true}),
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Parametrage$CollectionsDeChamps$Update$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIModel$Traduire = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$API$NavLinksDictionary$modifierLesLibellesDUneCollection = 'modifier-les-libelles-d-une-collection';
var $author$project$Components$Parametrage$CollectionsDeChamps$Model$lienDeLaTraduction = function (collection) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierLesLibellesDUneCollection, collection.nQ);
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Model$traductionPrete = function (model) {
	return $elm$core$String$trim(model.dY) !== '';
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$traduire = function (model) {
	var _v0 = model.fr;
	if (!_v0.$) {
		var collection = _v0.a;
		return $author$project$Components$Parametrage$CollectionsDeChamps$Model$traductionPrete(model) ? A3(
			$author$project$Components$Parametrage$CollectionsDeChamps$Update$envoyer,
			$author$project$Components$Parametrage$CollectionsDeChamps$Model$lienDeLaTraduction(collection),
			A3(
				$author$project$Components$Parametrage$CollectionsDeChamps$API$WriteAPIModel$Traduire,
				collection.Aq,
				$elm$core$String$trim(model.dY),
				$elm$core$String$trim(model.t)),
			model) : _Utils_Tuple2(model, _List_Nil);
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var liens = msg.a;
				var _v1 = $author$project$Components$Parametrage$CollectionsDeChamps$Model$lienDeLaLecture(liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								gd: false,
								np: $elm$core$Maybe$Just(lecture)
							}),
						_List_fromArray(
							[
								$author$project$Components$Parametrage$CollectionsDeChamps$Update$DemanderProcessUid,
								$author$project$Components$Parametrage$CollectionsDeChamps$Update$Lire(lecture)
							]));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{vE: $elm$core$Maybe$Nothing, np: $elm$core$Maybe$Nothing}),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 2:
				var reponse = msg.a;
				return A2($author$project$Components$Parametrage$CollectionsDeChamps$Update$lue, reponse, model);
			case 3:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $author$project$Components$Parametrage$CollectionsDeChamps$Update$Lire, $elm$core$List$singleton),
							model.np)));
			case 4:
				var geste = msg.a;
				return $author$project$API$Envoi$enCours(model.l2) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Parametrage$CollectionsDeChamps$Update$versLeDrawer, geste, model);
			case 5:
				var geste = msg.a;
				return $author$project$API$Envoi$enCours(model.l2) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Parametrage$CollectionsDeChamps$Update$versLeDrawerDeTraduction, geste, model);
			case 6:
				var collection = msg.a;
				return A2(
					$author$project$Components$Parametrage$CollectionsDeChamps$Update$versLeDrawerDeTraduction,
					$author$project$Components$Shared$Drawer$Update$Ouvrir(
						$author$project$Components$Parametrage$CollectionsDeChamps$Update$idDuDeclencheurDeTraduction(collection)),
					_Utils_update(
						model,
						{
							ir: $elm$core$Maybe$Nothing,
							fr: $elm$core$Maybe$Just(collection),
							t: A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Dict$get, 'en', collection.R)),
							dY: collection.Bl,
							pZ: $elm$core$Maybe$Nothing
						}));
			case 7:
				var francais = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dY: francais}),
					_List_Nil);
			case 8:
				var anglais = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{t: anglais}),
					_List_Nil);
			case 9:
				return $author$project$Components$Parametrage$CollectionsDeChamps$Update$traduire(model);
			case 10:
				return A2(
					$author$project$Components$Parametrage$CollectionsDeChamps$Update$versLeDrawer,
					$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Parametrage$CollectionsDeChamps$Update$idDuDeclencheur),
					_Utils_update(
						model,
						{ir: $elm$core$Maybe$Nothing, jD: _List_Nil, dy: '', Bl: '', F$: 0, pZ: $elm$core$Maybe$Nothing}));
			case 11:
				var libelle = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Bl: libelle}),
					_List_Nil);
			case 12:
				var cle = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dy: cle}),
					_List_Nil);
			case 13:
				var portee = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{jD: _List_Nil, F$: portee}),
					_List_Nil);
			case 14:
				var champ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jD: A2($author$project$Components$Parametrage$CollectionsDeChamps$Model$basculer, champ, model.jD)
						}),
					_List_Nil);
			case 15:
				return $author$project$Components$Parametrage$CollectionsDeChamps$Update$creer(model);
			case 16:
				var collection = msg.a;
				return A2($author$project$Components$Parametrage$CollectionsDeChamps$Update$archiver, collection, model);
			case 17:
				var collection = msg.a;
				return A2($author$project$Components$Parametrage$CollectionsDeChamps$Update$archiverEnRetirant, collection, model);
			default:
				var reponse = msg.a;
				var _v2 = A3($author$project$API$Envoi$conclure, $author$project$Components$Parametrage$CollectionsDeChamps$Update$reglage, reponse, model.l2);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var envoi = _v3.a;
					var issue = _v3.b;
					var effets = _v3.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Parametrage$CollectionsDeChamps$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Main$Update$versLesCollectionsDeChamps = F2(
	function (msg, model) {
		var _v0 = A2($author$project$Components$Parametrage$CollectionsDeChamps$Update$update, msg, model.vF);
		var collections = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLesCollectionsDeChamps, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLesCollectionsDeChamps,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						vF: collections,
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Parametrage$CollectionsDeChamps$Update$popMessages(msg),
							gardes)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$AttendreAvantDeRelireLesCorrespondances = function (a) {
	return {$: 206, a: a};
};
var $author$project$Main$Update$EnvoyerAuxCorrespondances = function (a) {
	return {$: 205, a: a};
};
var $author$project$Main$Update$LireLesCorrespondances = F2(
	function (a, b) {
		return {$: 204, a: a, b: b};
	});
var $author$project$Main$Model$PourLesCorrespondances = 38;
var $author$project$Main$Update$depuisLesCorrespondances = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[38]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 1:
				var lecture = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLesCorrespondances(lecture))));
			case 2:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerAuxCorrespondances(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 3:
				var delaiMs = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AttendreAvantDeRelireLesCorrespondances(delaiMs)
							])));
			case 4:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			case 5:
				var adresse = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AllerA(adresse)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Produits$Correspondances$API$QueryAPIModel$Annuaire = F2(
	function (correspondances, liens) {
		return {wh: correspondances, nQ: liens};
	});
var $author$project$Components$Produits$Correspondances$API$QueryAPIModel$Resume = F8(
	function (id, depart, cible, intitule, libelles, lignes, usages, liens) {
		return {vf: cible, cx: depart, Aq: id, AS: intitule, R: libelles, nQ: liens, gV: lignes, Ke: usages};
	});
var $author$project$Components$Produits$Correspondances$API$QueryAPIModel$Valeur = F2(
	function (id, libelle) {
		return {Aq: id, Bl: libelle};
	});
var $author$project$Components$Produits$Correspondances$API$QueryAPIModel$valeurDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Produits$Correspondances$API$QueryAPIModel$Valeur,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string));
var $author$project$Components$Produits$Correspondances$API$QueryAPIModel$resumeDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$API$Liens$deLaRessource,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'usages',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'lignes',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'libelles',
				$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'intitule',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'cible',
						$author$project$Components$Produits$Correspondances$API$QueryAPIModel$valeurDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'depart',
							$author$project$Components$Produits$Correspondances$API$QueryAPIModel$valeurDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Components$Produits$Correspondances$API$QueryAPIModel$Resume)))))))));
var $author$project$Components$Produits$Correspondances$API$QueryAPIModel$annuaireDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$API$Liens$deLaRessource,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'correspondances',
		$elm$json$Json$Decode$list($author$project$Components$Produits$Correspondances$API$QueryAPIModel$resumeDecoder),
		$elm$json$Json$Decode$succeed($author$project$Components$Produits$Correspondances$API$QueryAPIModel$Annuaire)));
var $author$project$Components$Produits$Correspondances$Update$deLaLecture = function (resultat) {
	if (resultat.$ === 1) {
		var refus = resultat.a;
		return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Components$Shared$Messages$Model$duRefus(refus));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$Correspondances$API$QueryAPIModel$Fiche = F4(
	function (correspondance, lignes, valeursDeDepartPossibles, matrice) {
		return {wg: correspondance, gV: lignes, Cf: matrice, Kl: valeursDeDepartPossibles};
	});
var $author$project$Components$Produits$Correspondances$API$QueryAPIModel$Ligne = F3(
	function (valeurDepart, cibles, masquees) {
		return {jS: cibles, Cb: masquees, sg: valeurDepart};
	});
var $author$project$Components$Produits$Correspondances$API$QueryAPIModel$ligneDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'masquees',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'cibles',
		$elm$json$Json$Decode$list($author$project$Components$Produits$Correspondances$API$QueryAPIModel$valeurDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'valeurDepart',
			$author$project$Components$Produits$Correspondances$API$QueryAPIModel$valeurDecoder,
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$Correspondances$API$QueryAPIModel$Ligne))));
var $author$project$Components$Produits$Correspondances$API$QueryAPIModel$Case = F2(
	function (cible, reliee) {
		return {vf: cible, Hx: reliee};
	});
var $author$project$Components$Produits$Correspondances$API$QueryAPIModel$LigneDeMatrice = F2(
	function (valeurDepart, cases) {
		return {uJ: cases, sg: valeurDepart};
	});
var $author$project$Components$Produits$Correspondances$API$QueryAPIModel$Matrice = F3(
	function (colonnes, lignes, limitee) {
		return {j1: colonnes, gV: lignes, BU: limitee};
	});
var $author$project$Components$Produits$Correspondances$API$QueryAPIModel$matriceDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'limitee',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'lignes',
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Components$Produits$Correspondances$API$QueryAPIModel$LigneDeMatrice,
				A2($elm$json$Json$Decode$field, 'valeurDepart', $author$project$Components$Produits$Correspondances$API$QueryAPIModel$valeurDecoder),
				A2(
					$elm$json$Json$Decode$field,
					'cases',
					$elm$json$Json$Decode$list(
						A3(
							$elm$json$Json$Decode$map2,
							$author$project$Components$Produits$Correspondances$API$QueryAPIModel$Case,
							A2($elm$json$Json$Decode$field, 'cible', $elm$json$Json$Decode$string),
							A2($elm$json$Json$Decode$field, 'reliee', $elm$json$Json$Decode$bool)))))),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'colonnes',
			$elm$json$Json$Decode$list($author$project$Components$Produits$Correspondances$API$QueryAPIModel$valeurDecoder),
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$Correspondances$API$QueryAPIModel$Matrice))));
var $author$project$Components$Produits$Correspondances$API$QueryAPIModel$ficheDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'matrice',
	$author$project$Components$Produits$Correspondances$API$QueryAPIModel$matriceDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'valeursDeDepartPossibles',
		$elm$json$Json$Decode$list($author$project$Components$Produits$Correspondances$API$QueryAPIModel$valeurDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'lignes',
			$elm$json$Json$Decode$list($author$project$Components$Produits$Correspondances$API$QueryAPIModel$ligneDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'correspondance',
				$author$project$Components$Produits$Correspondances$API$QueryAPIModel$resumeDecoder,
				$elm$json$Json$Decode$succeed($author$project$Components$Produits$Correspondances$API$QueryAPIModel$Fiche)))));
var $author$project$Components$Produits$Listes$API$QueryAPIModel$Liste = F7(
	function (id, nom, portee, attributs, versionDuSchema, valeurs, liens) {
		return {i8: attributs, Aq: id, nQ: liens, Dj: nom, F$: portee, Ki: valeurs, KK: versionDuSchema};
	});
var $author$project$Components$Produits$Listes$API$QueryAPIModel$Attribut = F3(
	function (cle, libelle, pays) {
		return {dy: cle, Bl: libelle, ho: pays};
	});
var $author$project$Components$Produits$Listes$API$QueryAPIModel$attributDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Produits$Listes$API$QueryAPIModel$Attribut,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'label', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['type', 'Arr', 'of', 'Country']),
				$elm$json$Json$Decode$succeed(true)),
				$elm$json$Json$Decode$succeed(false)
			])));
var $author$project$Components$Produits$Listes$API$QueryAPIModel$Valeur = F6(
	function (id, libelle, masquee, attributs, pays, liens) {
		return {i8: attributs, Aq: id, Bl: libelle, nQ: liens, Ca: masquee, ho: pays};
	});
var $author$project$Components$Produits$Listes$API$QueryAPIModel$retenues = A2(
	$elm$core$Dict$foldl,
	F3(
		function (cle, valeur, reste) {
			return A2(
				$elm$core$Maybe$withDefault,
				reste,
				A2(
					$elm$core$Maybe$map,
					function (v) {
						return A3($elm$core$Dict$insert, cle, v, reste);
					},
					valeur));
		}),
	$elm$core$Dict$empty);
var $author$project$Components$Produits$Listes$API$QueryAPIModel$valeurDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$API$Liens$deLaRessource,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'attributs',
		A2(
			$elm$json$Json$Decode$map,
			$author$project$Components$Produits$Listes$API$QueryAPIModel$retenues,
			$elm$json$Json$Decode$dict(
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$json$Json$Decode$map,
							$elm$core$Maybe$Just,
							$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
							$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
						])))),
		$elm$core$Dict$empty,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'attributs',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Components$Produits$Listes$API$QueryAPIModel$retenues,
				$elm$json$Json$Decode$dict(
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
								$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
							])))),
			$elm$core$Dict$empty,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'masquee',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'libelle',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Components$Produits$Listes$API$QueryAPIModel$Valeur)))))));
var $author$project$Components$Produits$Listes$API$QueryAPIModel$listeDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$API$Liens$deLaRessource,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'valeurs',
		$elm$json$Json$Decode$list($author$project$Components$Produits$Listes$API$QueryAPIModel$valeurDecoder),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'schema',
			A2($elm$json$Json$Decode$field, 'version', $elm$json$Json$Decode$int),
			0,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'schema',
				A2(
					$elm$json$Json$Decode$field,
					'fields',
					$elm$json$Json$Decode$list($author$project$Components$Produits$Listes$API$QueryAPIModel$attributDecoder)),
				_List_Nil,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'portee',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'nom',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Components$Produits$Listes$API$QueryAPIModel$Liste))))))));
var $author$project$Components$Produits$Correspondances$Update$popMessages = function (msg) {
	switch (msg.$) {
		case 2:
			switch (msg.a.$) {
				case 0:
					var _v1 = msg.a;
					var reponse = msg.b;
					return $author$project$Components$Produits$Correspondances$Update$deLaLecture(
						A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Correspondances$API$QueryAPIModel$annuaireDecoder, reponse));
				case 1:
					var _v2 = msg.a;
					var reponse = msg.b;
					return $author$project$Components$Produits$Correspondances$Update$deLaLecture(
						A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Correspondances$API$QueryAPIModel$ficheDecoder, reponse));
				case 2:
					var _v3 = msg.a;
					var reponse = msg.b;
					return $author$project$Components$Produits$Correspondances$Update$deLaLecture(
						A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Listes$API$QueryAPIModel$annuaireDecoder, reponse));
				default:
					var reponse = msg.b;
					return $author$project$Components$Produits$Correspondances$Update$deLaLecture(
						A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Listes$API$QueryAPIModel$listeDecoder, reponse));
			}
		case 1:
			var octets = msg.a;
			return _Utils_eq(
				$author$project$API$ProcessUid$depuisOctets(octets),
				$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
				{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Main$Update$requeteSurLesCorrespondances = function (effet) {
	switch (effet.$) {
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Produits$Correspondances$Update$DeLAnnuaire = {$: 0};
var $author$project$Components$Produits$Correspondances$Model$DeLaMatrice = 1;
var $author$project$Components$Produits$Correspondances$Update$DemanderProcessUid = {$: 0};
var $author$project$Components$Produits$Correspondances$Update$DesListes = {$: 2};
var $author$project$Components$Produits$Correspondances$Update$Lire = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Produits$Correspondances$Model$basculer = F2(
	function (vue, model) {
		return _Utils_update(
			model,
			{io: vue});
	});
var $author$project$Components$Produits$Correspondances$API$WriteAPIModel$Delier = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$Correspondances$API$WriteAPIModel$Relier = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$API$NavLinksDictionary$delierDesValeurs = 'delier-des-valeurs';
var $author$project$Components$Produits$Correspondances$Model$lienDe = F2(
	function (rel, model) {
		var _v0 = _Utils_Tuple2(model.zo, model.aS);
		if (!_v0.a.$) {
			var fiche = _v0.a.a;
			return A2($author$project$API$Liens$trouver, rel, fiche.wg.nQ.h0);
		} else {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var annuaire = _v0.b.a;
				return A2($author$project$API$Liens$trouver, rel, annuaire.nQ.h0);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$Components$Produits$Correspondances$API$WriteAPIErrorsModel$Autre = 7;
var $author$project$Components$Produits$Correspondances$Update$Envoyer = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$Correspondances$Update$Reconnecter = {$: 6};
var $author$project$Components$Produits$Correspondances$API$WriteAPIErrorsModel$CorrespondanceUtilisee = 5;
var $author$project$Components$Produits$Correspondances$API$WriteAPIErrorsModel$CoupleDejaDefini = 1;
var $author$project$Components$Produits$Correspondances$API$WriteAPIErrorsModel$LibelleFrancaisRequis = 6;
var $author$project$Components$Produits$Correspondances$API$WriteAPIErrorsModel$LigneSansCible = 3;
var $author$project$Components$Produits$Correspondances$API$WriteAPIErrorsModel$MemeListe = 0;
var $author$project$Components$Produits$Correspondances$API$WriteAPIErrorsModel$ValeurHorsDeLaListe = 2;
var $author$project$Components$Produits$Correspondances$API$WriteAPIErrorsModel$ValeurMasquee = 4;
var $author$project$Components$Produits$Correspondances$API$WriteAPIErrorsModel$nomDuCas = function (detail) {
	switch (detail.$) {
		case 1:
			var nom = detail.a;
			return $elm$core$Maybe$Just(nom);
		case 4:
			var nom = detail.a;
			return $elm$core$Maybe$Just(nom);
		case 3:
			var nom = detail.a;
			return $elm$core$Maybe$Just(nom);
		case 2:
			var nom = detail.a;
			return $elm$core$Maybe$Just(nom);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$Correspondances$API$WriteAPIErrorsModel$duRefus = function (refus) {
	var _v0 = $author$project$Components$Produits$Correspondances$API$WriteAPIErrorsModel$nomDuCas(refus.bB);
	_v0$7:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'MemeListe':
					return 0;
				case 'CoupleDejaDefini':
					return 1;
				case 'ValeurHorsDeLaListe':
					return 2;
				case 'LigneSansCible':
					return 3;
				case 'ValeurMasquee':
					return 4;
				case 'CorrespondanceUtilisee':
					return 5;
				case 'LibelleFrancaisRequis':
					return 6;
				default:
					break _v0$7;
			}
		} else {
			break _v0$7;
		}
	}
	return 7;
};
var $author$project$Components$Produits$Correspondances$API$WriteAPIModel$Rendue = F2(
	function (vuesAJour, liens) {
		return {nQ: liens, sy: vuesAJour};
	});
var $author$project$Components$Produits$Correspondances$API$WriteAPIModel$rendueDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'liens',
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vuesAJour',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Components$Produits$Correspondances$API$WriteAPIModel$Rendue)));
var $author$project$Components$Produits$Correspondances$Update$reglage = {
	f8: $author$project$Components$Produits$Correspondances$Update$DemanderProcessUid,
	l4: $author$project$Components$Produits$Correspondances$Update$Envoyer,
	go: function (reponse) {
		var _v0 = A2(
			$author$project$API$Reponse$lire,
			$elm$json$Json$Decode$succeed(0),
			reponse);
		if (_v0.$ === 1) {
			var refus = _v0.a;
			return $author$project$Components$Produits$Correspondances$API$WriteAPIErrorsModel$duRefus(refus);
		} else {
			return 7;
		}
	},
	pW: $author$project$Components$Produits$Correspondances$Update$Reconnecter,
	qu: F2(
		function (_v1, _v2) {
			return true;
		}),
	qv: $author$project$Components$Produits$Correspondances$API$WriteAPIModel$rendueDecoder
};
var $author$project$Components$Produits$Correspondances$Update$partir = F3(
	function (lien, commande, model) {
		var _v0 = A4(
			$author$project$API$Envoi$partir,
			$author$project$Components$Produits$Correspondances$Update$reglage,
			$elm$core$Maybe$Just(lien),
			commande,
			model.l2);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var envoi = _v1.a;
			var effets = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi, pZ: $elm$core$Maybe$Nothing}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$relierDesValeurs = 'relier-des-valeurs';
var $author$project$Components$Produits$Correspondances$Update$case_ = F4(
	function (depart, cible, reliee, model) {
		var _v0 = _Utils_Tuple2(
			model.zo,
			A2(
				$author$project$Components$Produits$Correspondances$Model$lienDe,
				reliee ? $author$project$API$NavLinksDictionary$delierDesValeurs : $author$project$API$NavLinksDictionary$relierDesValeurs,
				model));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var fiche = _v0.a.a;
			var lien = _v0.b.a;
			return A3(
				$author$project$Components$Produits$Correspondances$Update$partir,
				lien,
				A3(
					reliee ? $author$project$Components$Produits$Correspondances$API$WriteAPIModel$Delier : $author$project$Components$Produits$Correspondances$API$WriteAPIModel$Relier,
					fiche.wg.Aq,
					depart,
					_List_fromArray(
						[cible])),
				_Utils_update(
					model,
					{mW: $elm$core$Maybe$Nothing}));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$Correspondances$Update$DUneListe = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$Correspondances$Update$lireUneListe = F2(
	function (id, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (lien) {
					return _List_fromArray(
						[
							A2(
							$author$project$Components$Produits$Correspondances$Update$Lire,
							$author$project$Components$Produits$Correspondances$Update$DUneListe(id),
							lien)
						]);
				},
				A2(
					$elm$core$Maybe$andThen,
					function (resume) {
						return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$liste, resume.nQ.h0);
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (resume) {
								return _Utils_eq(resume.Aq, id);
							},
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.n_;
									},
									model.n_)))))));
	});
var $author$project$Components$Produits$Correspondances$Model$Creation = {$: 0};
var $author$project$Components$Produits$Correspondances$Model$NouvelleLigne = {$: 1};
var $author$project$Components$Produits$Correspondances$Model$actives = F2(
	function (listeId, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (liste) {
					return A2(
						$elm$core$List$map,
						function (v) {
							return {Aq: v.Aq, Bl: v.Bl};
						},
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Ca;
								},
								$elm$core$Basics$not),
							liste.Ki));
				},
				A2($elm$core$Dict$get, listeId, model.ig)));
	});
var $author$project$Components$Produits$Correspondances$Model$departDuGeste = function (model) {
	var _v0 = _Utils_Tuple2(model.mW, model.zo);
	if ((!_v0.a.$) && (!_v0.a.a.$)) {
		var _v1 = _v0.a.a;
		return model.dG;
	} else {
		if (!_v0.b.$) {
			var fiche = _v0.b.a;
			return fiche.wg.cx.Aq;
		} else {
			return '';
		}
	}
};
var $author$project$Components$Produits$Correspondances$Model$valeursDeDepart = function (model) {
	var _v0 = _Utils_Tuple2(model.mW, model.zo);
	if (((!_v0.a.$) && (_v0.a.a.$ === 1)) && (!_v0.b.$)) {
		var _v1 = _v0.a.a;
		var fiche = _v0.b.a;
		return fiche.Kl;
	} else {
		return A2(
			$author$project$Components$Produits$Correspondances$Model$actives,
			$author$project$Components$Produits$Correspondances$Model$departDuGeste(model),
			model);
	}
};
var $author$project$Components$Produits$Correspondances$Update$normaliser = function (model) {
	if (_Utils_eq(
		model.mW,
		$elm$core$Maybe$Just($author$project$Components$Produits$Correspondances$Model$Creation)) || _Utils_eq(
		model.mW,
		$elm$core$Maybe$Just($author$project$Components$Produits$Correspondances$Model$NouvelleLigne))) {
		var propres = $author$project$Components$Produits$Correspondances$Model$valeursDeDepart(model);
		return A2(
			$elm$core$List$any,
			function (valeur) {
				return _Utils_eq(valeur.Aq, model.sg);
			},
			propres) ? model : _Utils_update(
			model,
			{
				sg: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.Aq;
						},
						$elm$core$List$head(propres)))
			});
	} else {
		return model;
	}
};
var $author$project$Components$Produits$Correspondances$Update$choisirUneListe = F3(
	function (choisir, id, model) {
		return _Utils_Tuple2(
			$author$project$Components$Produits$Correspondances$Update$normaliser(
				choisir(
					_Utils_update(
						model,
						{pZ: $elm$core$Maybe$Nothing}))),
			A2($author$project$Components$Produits$Correspondances$Update$lireUneListe, id, model));
	});
var $author$project$Components$Produits$Correspondances$Update$AttendreAvantDeRelire = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$Correspondances$Update$Naviguer = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Produits$Correspondances$Model$aucunGeste = function (model) {
	return _Utils_update(
		model,
		{L: _List_Nil, mW: $elm$core$Maybe$Nothing, hC: '', pZ: $elm$core$Maybe$Nothing, b5: false});
};
var $author$project$I18n$Textes$correspondancesRefusAutre = A3($author$project$I18n$Traductions$texte, 'correspondances.refus.autre', _List_Nil, 'La correspondance n\'a pas pu être modifiée. Réessayez.');
var $author$project$I18n$Textes$correspondancesRefusCouple = A3($author$project$I18n$Traductions$texte, 'correspondances.refus.couple', _List_Nil, 'Ces deux listes ont déjà une correspondance.');
var $author$project$I18n$Textes$correspondancesRefusFrancais = A3($author$project$I18n$Traductions$texte, 'correspondances.refus.francais', _List_Nil, 'L\'intitulé commence par le français.');
var $author$project$I18n$Textes$correspondancesRefusHorsListe = A3($author$project$I18n$Traductions$texte, 'correspondances.refus.hors-liste', _List_Nil, 'Cette valeur n\'appartient pas à la liste.');
var $author$project$I18n$Textes$correspondancesRefusMasquee = A3($author$project$I18n$Traductions$texte, 'correspondances.refus.masquee', _List_Nil, 'Une valeur masquée ne reçoit pas de nouveau lien : réactivez-la d\'abord dans sa liste.');
var $author$project$I18n$Textes$correspondancesRefusMemeListe = A3($author$project$I18n$Traductions$texte, 'correspondances.refus.meme-liste', _List_Nil, 'Les deux listes doivent être différentes.');
var $author$project$I18n$Textes$correspondancesRefusSansCible = A3($author$project$I18n$Traductions$texte, 'correspondances.refus.sans-cible', _List_Nil, 'Une ligne garde au moins une valeur : pour la vider, retirez la ligne.');
var $author$project$I18n$Textes$correspondancesRefusUtilisee = A3($author$project$I18n$Traductions$texte, 'correspondances.refus.utilisee', _List_Nil, 'Cette correspondance est utilisée : retirez d\'abord ce qui la consulte.');
var $author$project$Components$Produits$Correspondances$Update$libelleDuRefus = function (erreur) {
	switch (erreur) {
		case 0:
			return $author$project$I18n$Textes$correspondancesRefusMemeListe;
		case 1:
			return $author$project$I18n$Textes$correspondancesRefusCouple;
		case 2:
			return $author$project$I18n$Textes$correspondancesRefusHorsListe;
		case 3:
			return $author$project$I18n$Textes$correspondancesRefusSansCible;
		case 4:
			return $author$project$I18n$Textes$correspondancesRefusMasquee;
		case 5:
			return $author$project$I18n$Textes$correspondancesRefusUtilisee;
		case 6:
			return $author$project$I18n$Textes$correspondancesRefusFrancais;
		default:
			return $author$project$I18n$Textes$correspondancesRefusAutre;
	}
};
var $author$project$Components$Produits$Correspondances$Update$relire = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$Produits$Correspondances$Update$Lire($author$project$Components$Produits$Correspondances$Update$DeLAnnuaire),
				$elm$core$List$singleton),
			model.np));
};
var $author$project$Components$Produits$Correspondances$Update$PlacerFocus = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Produits$Correspondances$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{kX: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Produits$Correspondances$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: (!_Utils_eq(model.L, _List_Nil)) || (!$elm$core$Dict$isEmpty(model.R))
				},
				geste,
				model.kX));
	});
var $author$project$Components$Produits$Correspondances$Update$conclure = F2(
	function (issue, model) {
		switch (issue.$) {
			case 0:
				if (issue.a.$ === 5) {
					return _Utils_Tuple2(
						$author$project$Components$Produits$Correspondances$Model$aucunGeste(model),
						_List_fromArray(
							[
								$author$project$Components$Produits$Correspondances$Update$Naviguer($author$project$Routes$Route$adresseCorrespondances)
							]));
				} else {
					var rendue = issue.b;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(
							rendue.sy ? $author$project$Components$Produits$Correspondances$Update$relire(model) : _List_fromArray(
								[
									$author$project$Components$Produits$Correspondances$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
								])),
						A2(
							$author$project$Components$Produits$Correspondances$Update$versLeDrawer,
							$author$project$Components$Shared$Drawer$Update$Fermer,
							$author$project$Components$Produits$Correspondances$Model$aucunGeste(model)));
				}
			case 1:
				var erreur = issue.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							pZ: $elm$core$Maybe$Just(
								$author$project$Components$Produits$Correspondances$Update$libelleDuRefus(erreur))
						}),
					_List_Nil);
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$correspondances = 'correspondances';
var $author$project$Components$Produits$Correspondances$API$WriteAPIModel$Creer = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Produits$Correspondances$API$WriteAPIModel$Intitule = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Produits$Correspondances$API$WriteAPIModel$Modifier = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$Correspondances$API$WriteAPIModel$Retirer = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Produits$Correspondances$API$WriteAPIModel$RetirerUneLigne = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$creerUneCorrespondance = 'creer-une-correspondance';
var $author$project$API$NavLinksDictionary$modifierLIntituleDUneCorrespondance = 'modifier-l-intitule-d-une-correspondance';
var $author$project$API$NavLinksDictionary$modifierLesValeursAssociees = 'modifier-les-valeurs-associees';
var $author$project$API$NavLinksDictionary$retirerUneCorrespondance = 'retirer-une-correspondance';
var $author$project$API$NavLinksDictionary$retirerUneLigneDeCorrespondance = 'retirer-une-ligne-de-correspondance';
var $author$project$Components$Produits$Correspondances$Model$commande = function (model) {
	var deLaFiche = function (faire) {
		return A2(
			$elm$core$Maybe$andThen,
			function (fiche) {
				return faire(fiche);
			},
			model.zo);
	};
	var avecLien = F2(
		function (rel, faite) {
			return A2(
				$elm$core$Maybe$map,
				function (lien) {
					return _Utils_Tuple2(faite, lien);
				},
				A2($author$project$Components$Produits$Correspondances$Model$lienDe, rel, model));
		});
	var _v0 = model.mW;
	if (!_v0.$) {
		switch (_v0.a.$) {
			case 0:
				var _v1 = _v0.a;
				return ((model.sg === '') || $elm$core$List$isEmpty(model.L)) ? $elm$core$Maybe$Nothing : A2(
					avecLien,
					$author$project$API$NavLinksDictionary$creerUneCorrespondance,
					A4($author$project$Components$Produits$Correspondances$API$WriteAPIModel$Creer, model.dG, model.dx, model.sg, model.L));
			case 1:
				var _v2 = _v0.a;
				return ((model.sg === '') || $elm$core$List$isEmpty(model.L)) ? $elm$core$Maybe$Nothing : deLaFiche(
					function (fiche) {
						return A2(
							avecLien,
							$author$project$API$NavLinksDictionary$relierDesValeurs,
							A3($author$project$Components$Produits$Correspondances$API$WriteAPIModel$Relier, fiche.wg.Aq, model.sg, model.L));
					});
			case 2:
				var depart = _v0.a.a;
				return $elm$core$List$isEmpty(model.L) ? $elm$core$Maybe$Nothing : deLaFiche(
					function (fiche) {
						return A2(
							avecLien,
							$author$project$API$NavLinksDictionary$modifierLesValeursAssociees,
							A3($author$project$Components$Produits$Correspondances$API$WriteAPIModel$Modifier, fiche.wg.Aq, depart, model.L));
					});
			case 3:
				var _v3 = _v0.a;
				return (($elm$core$String$trim(
					A2($author$project$Components$Shared$LibellesParLangue$Model$lire, 'fr', model.R)) === '') && (!$elm$core$Dict$isEmpty(model.R))) ? $elm$core$Maybe$Nothing : deLaFiche(
					function (fiche) {
						return A2(
							avecLien,
							$author$project$API$NavLinksDictionary$modifierLIntituleDUneCorrespondance,
							A2(
								$author$project$Components$Produits$Correspondances$API$WriteAPIModel$Intitule,
								fiche.wg.Aq,
								A2(
									$elm$core$List$map,
									function (langue) {
										return _Utils_Tuple2(
											langue.vx,
											A2($author$project$Components$Shared$LibellesParLangue$Model$lire, langue.vx, model.R));
									},
									$author$project$Referentiel$Langues$desLibelles)));
					});
			case 4:
				var depart = _v0.a.a;
				return deLaFiche(
					function (fiche) {
						return A2(
							avecLien,
							$author$project$API$NavLinksDictionary$retirerUneLigneDeCorrespondance,
							A2($author$project$Components$Produits$Correspondances$API$WriteAPIModel$RetirerUneLigne, fiche.wg.Aq, depart));
					});
			default:
				var _v4 = _v0.a;
				return deLaFiche(
					function (fiche) {
						return $elm$core$List$isEmpty(fiche.wg.Ke) ? A2(
							avecLien,
							$author$project$API$NavLinksDictionary$retirerUneCorrespondance,
							$author$project$Components$Produits$Correspondances$API$WriteAPIModel$Retirer(fiche.wg.Aq)) : $elm$core$Maybe$Nothing;
					});
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$Correspondances$Update$envoyer = function (model) {
	var _v0 = $author$project$Components$Produits$Correspondances$Model$commande(model);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var commande = _v1.a;
		var lien = _v1.b;
		return A3($author$project$Components$Produits$Correspondances$Update$partir, lien, commande, model);
	} else {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{b5: true}),
			_List_Nil);
	}
};
var $author$project$Components$Produits$Correspondances$Update$DeLaFiche = {$: 1};
var $author$project$API$NavLinksDictionary$correspondance = 'correspondance';
var $author$project$Components$Produits$Correspondances$Update$lireLaFiche = F2(
	function (annuaire, model) {
		var _v0 = model.vf;
		if (_v0.$ === 1) {
			return _List_Nil;
		} else {
			var id = _v0.a;
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (lien) {
						return _List_fromArray(
							[
								A2($author$project$Components$Produits$Correspondances$Update$Lire, $author$project$Components$Produits$Correspondances$Update$DeLaFiche, lien)
							]);
					},
					A2(
						$elm$core$Maybe$andThen,
						function (resume) {
							return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$correspondance, resume.nQ.h0);
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (resume) {
									return _Utils_eq(resume.Aq, id);
								},
								annuaire.wh)))));
		}
	});
var $author$project$Components$Produits$Correspondances$Update$lue = F3(
	function (lecture, reponse, model) {
		var sansLecture = function (refus) {
			return _Utils_Tuple2(
				model,
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Produits$Correspondances$Update$Reconnecter]) : _List_Nil);
		};
		switch (lecture.$) {
			case 0:
				var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Correspondances$API$QueryAPIModel$annuaireDecoder, reponse);
				if (!_v1.$) {
					var annuaire = _v1.a;
					var effets = A2($author$project$Components$Produits$Correspondances$Update$lireLaFiche, annuaire, model);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aS: $elm$core$Maybe$Just(annuaire),
								nf: (!_Utils_eq(model.vf, $elm$core$Maybe$Nothing)) && _Utils_eq(effets, _List_Nil)
							}),
						effets);
				} else {
					var refus = _v1.a;
					return sansLecture(refus);
				}
			case 1:
				var _v2 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Correspondances$API$QueryAPIModel$ficheDecoder, reponse);
				if (!_v2.$) {
					var fiche = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								zo: $elm$core$Maybe$Just(fiche)
							}),
						_List_Nil);
				} else {
					var refus = _v2.a;
					return sansLecture(refus);
				}
			case 2:
				var _v3 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Listes$API$QueryAPIModel$annuaireDecoder, reponse);
				if (!_v3.$) {
					var listes = _v3.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								n_: $elm$core$Maybe$Just(listes)
							}),
						_List_Nil);
				} else {
					var refus = _v3.a;
					return sansLecture(refus);
				}
			default:
				var id = lecture.a;
				var _v4 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Listes$API$QueryAPIModel$listeDecoder, reponse);
				if (!_v4.$) {
					var liste = _v4.a;
					return _Utils_Tuple2(
						$author$project$Components$Produits$Correspondances$Update$normaliser(
							_Utils_update(
								model,
								{
									ig: A3($elm$core$Dict$insert, id, liste, model.ig)
								})),
						_List_Nil);
				} else {
					var refus = _v4.a;
					return sansLecture(refus);
				}
		}
	});
var $author$project$Components$Produits$Correspondances$Model$idDuDeclencheur = function (geste) {
	switch (geste.$) {
		case 0:
			return 'correspondances-nouvelle';
		case 1:
			return 'correspondance-nouvelle-ligne';
		case 2:
			var depart = geste.a;
			return 'correspondance-modifier-' + depart;
		case 3:
			return 'correspondance-renommer';
		case 4:
			var depart = geste.a;
			return 'correspondance-retirer-ligne-' + depart;
		default:
			return 'correspondance-retirer';
	}
};
var $author$project$Components$Produits$Correspondances$Update$relDuGeste = function (geste) {
	switch (geste.$) {
		case 0:
			return $author$project$API$NavLinksDictionary$creerUneCorrespondance;
		case 1:
			return $author$project$API$NavLinksDictionary$relierDesValeurs;
		case 2:
			return $author$project$API$NavLinksDictionary$modifierLesValeursAssociees;
		case 3:
			return $author$project$API$NavLinksDictionary$modifierLIntituleDUneCorrespondance;
		case 4:
			return $author$project$API$NavLinksDictionary$retirerUneLigneDeCorrespondance;
		default:
			return $author$project$API$NavLinksDictionary$retirerUneCorrespondance;
	}
};
var $author$project$Components$Produits$Correspondances$Update$ouvrir = F2(
	function (geste, model) {
		var premieres = A2(
			$elm$core$List$map,
			function ($) {
				return $.Aq;
			},
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.n_;
					},
					model.n_)));
		var depart = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(premieres));
		var deLaFiche = function (faire) {
			return A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(model, _List_Nil),
				A2($elm$core$Maybe$map, faire, model.zo));
		};
		var cible = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(
				A2($elm$core$List$drop, 1, premieres)));
		var ouvert = _Utils_update(
			model,
			{
				L: _List_Nil,
				dx: cible,
				dG: depart,
				mW: $elm$core$Maybe$Just(geste),
				R: A2(
					$elm$core$Maybe$withDefault,
					$author$project$Components$Shared$LibellesParLangue$Model$vide,
					A2(
						$elm$core$Maybe$map,
						function (fiche) {
							return fiche.wg.R;
						},
						model.zo)),
				hC: '',
				pZ: $elm$core$Maybe$Nothing,
				b5: false,
				sg: ''
			});
		if (_Utils_eq(
			A2(
				$author$project$Components$Produits$Correspondances$Model$lienDe,
				$author$project$Components$Produits$Correspondances$Update$relDuGeste(geste),
				model),
			$elm$core$Maybe$Nothing)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			switch (geste.$) {
				case 0:
					return ($elm$core$List$length(premieres) < 2) ? _Utils_Tuple2(model, _List_Nil) : A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(
							_Utils_ap(
								A2($author$project$Components$Produits$Correspondances$Update$lireUneListe, depart, model),
								A2($author$project$Components$Produits$Correspondances$Update$lireUneListe, cible, model))),
						A2(
							$author$project$Components$Produits$Correspondances$Update$versLeDrawer,
							$author$project$Components$Shared$Drawer$Update$Ouvrir(
								$author$project$Components$Produits$Correspondances$Model$idDuDeclencheur(geste)),
							ouvert));
				case 2:
					var valeurDepart = geste.a;
					return deLaFiche(
						function (fiche) {
							return A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Basics$append(
									A2($author$project$Components$Produits$Correspondances$Update$lireUneListe, fiche.wg.vf.Aq, model)),
								A2(
									$author$project$Components$Produits$Correspondances$Update$versLeDrawer,
									$author$project$Components$Shared$Drawer$Update$Ouvrir(
										$author$project$Components$Produits$Correspondances$Model$idDuDeclencheur(geste)),
									_Utils_update(
										ouvert,
										{
											L: A2(
												$elm$core$List$concatMap,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.jS;
													},
													$elm$core$List$map(
														function ($) {
															return $.Aq;
														})),
												A2(
													$elm$core$List$filter,
													function (ligne) {
														return _Utils_eq(ligne.sg.Aq, valeurDepart);
													},
													fiche.gV))
										})));
						});
				case 1:
					return deLaFiche(
						function (fiche) {
							return A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Basics$append(
									A2($author$project$Components$Produits$Correspondances$Update$lireUneListe, fiche.wg.vf.Aq, model)),
								A2(
									$author$project$Components$Produits$Correspondances$Update$versLeDrawer,
									$author$project$Components$Shared$Drawer$Update$Ouvrir(
										$author$project$Components$Produits$Correspondances$Model$idDuDeclencheur(geste)),
									$author$project$Components$Produits$Correspondances$Update$normaliser(ouvert)));
						});
				default:
					return A2(
						$author$project$Components$Produits$Correspondances$Update$versLeDrawer,
						$author$project$Components$Shared$Drawer$Update$Ouvrir(
							$author$project$Components$Produits$Correspondances$Model$idDuDeclencheur(geste)),
						ouvert);
			}
		}
	});
var $author$project$Components$Produits$Correspondances$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var cible = msg.a;
				var liens = msg.b;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$correspondances, liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					var desListes = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$listes, liens);
					return _Utils_Tuple2(
						A3(
							$author$project$Components$Produits$Correspondances$Model$ouvert,
							$elm$core$Maybe$Just(lecture),
							desListes,
							cible),
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Components$Produits$Correspondances$Update$DemanderProcessUid,
									A2($author$project$Components$Produits$Correspondances$Update$Lire, $author$project$Components$Produits$Correspondances$Update$DeLAnnuaire, lecture)
								]),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (lien) {
										return _List_fromArray(
											[
												A2($author$project$Components$Produits$Correspondances$Update$Lire, $author$project$Components$Produits$Correspondances$Update$DesListes, lien)
											]);
									},
									desListes))));
				} else {
					return _Utils_Tuple2(
						A3($author$project$Components$Produits$Correspondances$Model$ouvert, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, cible),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 2:
				var lecture = msg.a;
				var reponse = msg.b;
				return A3($author$project$Components$Produits$Correspondances$Update$lue, lecture, reponse, model);
			case 3:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Produits$Correspondances$Update$relire(model));
			case 4:
				var geste = msg.a;
				return ($author$project$API$Envoi$enCours(model.l2) && A2(
					$elm$core$List$member,
					geste,
					_List_fromArray(
						[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$SortieDemandee, $author$project$Components$Shared$Drawer$Update$AbandonConfirme]))) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Produits$Correspondances$Update$versLeDrawer, geste, model);
			case 5:
				var geste = msg.a;
				return A2($author$project$Components$Produits$Correspondances$Update$ouvrir, geste, model);
			case 6:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Produits$Correspondances$Model$basculer,
						(code === 'matrice') ? 1 : 0,
						model),
					_List_Nil);
			case 7:
				var id = msg.a;
				return A3(
					$author$project$Components$Produits$Correspondances$Update$choisirUneListe,
					function (m) {
						return _Utils_update(
							m,
							{dG: id, sg: ''});
					},
					id,
					model);
			case 8:
				var id = msg.a;
				return A3(
					$author$project$Components$Produits$Correspondances$Update$choisirUneListe,
					function (m) {
						return _Utils_update(
							m,
							{L: _List_Nil, dx: id});
					},
					id,
					model);
			case 9:
				var id = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{sg: id}),
					_List_Nil);
			case 10:
				var id = msg.a;
				var choisie = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							L: choisie ? (A2($elm$core$List$member, id, model.L) ? model.L : _Utils_ap(
								model.L,
								_List_fromArray(
									[id]))) : A2(
								$elm$core$List$filter,
								function (autre) {
									return !_Utils_eq(autre, id);
								},
								model.L),
							pZ: $elm$core$Maybe$Nothing
						}),
					_List_Nil);
			case 11:
				var texte = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{hC: texte}),
					_List_Nil);
			case 12:
				var code = msg.a;
				var texte = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							R: A3($author$project$Components$Shared$LibellesParLangue$Model$ecrire, code, texte, model.R)
						}),
					_List_Nil);
			case 13:
				var depart = msg.a;
				var cible = msg.b;
				var reliee = msg.c;
				return A4($author$project$Components$Produits$Correspondances$Update$case_, depart, cible, reliee, model);
			case 14:
				return $author$project$Components$Produits$Correspondances$Update$envoyer(model);
			default:
				var reponse = msg.a;
				var _v2 = A3($author$project$API$Envoi$conclure, $author$project$Components$Produits$Correspondances$Update$reglage, reponse, model.l2);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var envoi = _v3.a;
					var issue = _v3.b;
					var effets = _v3.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Produits$Correspondances$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Main$Update$versLesCorrespondances = F3(
	function (i18n, msg, model) {
		var _v0 = A2(
			$author$project$Components$Produits$Correspondances$Update$update,
			msg,
			$author$project$Components$Produits$Correspondances$Model$ouvrir(model.wh));
		var correspondances = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLesCorrespondances, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLesCorrespondances,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						wh: $author$project$Components$Produits$Correspondances$Model$envelopper(correspondances),
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Produits$Correspondances$Update$popMessages(msg),
							gardes)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$LireLesDestinationsDesChamps = F2(
	function (a, b) {
		return {$: 101, a: a, b: b};
	});
var $author$project$Main$Update$depuisLesDestinationsDesChamps = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		if (!effet.$) {
			var lecture = effet.a;
			var lien = effet.b;
			return _Utils_Tuple2(
				model,
				_Utils_ap(
					effets,
					A3(
						$author$project$Main$Update$versLApi,
						model,
						lien,
						$author$project$Main$Update$LireLesDestinationsDesChamps(lecture))));
		} else {
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Basics$append(effets),
				A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$Carte = F2(
	function (uid, destinations) {
		return {kM: destinations, r8: uid};
	});
var $author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$cartesDecoder = A2(
	$elm$json$Json$Decode$field,
	'formulaires',
	$elm$json$Json$Decode$list(
		A3(
			$elm$json$Json$Decode$map2,
			$author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$Carte,
			A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
			A2(
				$elm$json$Json$Decode$map,
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$destinationsDesChamps),
				$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder))));
var $author$project$Components$Parametrage$PipeDestinations$Update$dit = function (resultat) {
	if (resultat.$ === 1) {
		var erreur = resultat.a;
		return ((erreur.ri === 401) || (erreur.ri === 404)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Components$Shared$Messages$Model$duRefus(erreur));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$Page = F7(
	function (formulaire, versionEnEdition, lignes, destinations, validateurs, roles, ressourcesLiees) {
		return {kM: destinations, zT: formulaire, gV: lignes, HP: ressourcesLiees, eX: roles, Kr: validateurs, KL: versionEnEdition};
	});
var $author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$Formulaire = F5(
	function (uid, libelles, version, sertPour, ficheVisee) {
		return {zt: ficheVisee, R: libelles, IJ: sertPour, r8: uid, sq: version};
	});
var $author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$Role = F4(
	function (uid, libelle, grammaire, parRelation) {
		return {m$: grammaire, Bl: libelle, EW: parRelation, r8: uid};
	});
var $author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$roleDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'parRelation',
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'grammaire',
		$elm$json$Json$Decode$nullable($author$project$Catalogue$Formes$decoder),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'libelle',
			$elm$json$Json$Decode$string,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'uid',
				$elm$json$Json$Decode$string,
				'',
				$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$Role)))));
var $author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$formulaireDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'ficheVisee',
	$elm$json$Json$Decode$nullable($author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$roleDecoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sertPour',
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				F2(
					function (etape, tache) {
						return {me: etape, Jj: tache};
					}),
				A2($elm$json$Json$Decode$field, 'etape', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'tache', $elm$json$Json$Decode$string))),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'version',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'libelles',
				$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'uid',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$Formulaire))))));
var $author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$Ligne = F9(
	function (uid, libelles, destination, aValider, prerempli, bloque, role, etape, visibilite) {
		return {sI: aValider, ur: bloque, xw: destination, me: etape, R: libelles, Gi: prerempli, bi: role, r8: uid, KQ: visibilite};
	});
var $author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$Destination = F5(
	function (type_, roleUid, champ, libelle, ressource) {
		return {uN: champ, Bl: libelle, HN: ressource, H6: roleUid, r0: type_};
	});
var $author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$destinationDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$Destination,
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'roleUid', $elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$maybe(
		A2(
			$elm$json$Json$Decode$field,
			'ressource',
			A3(
				$elm$json$Json$Decode$map2,
				F2(
					function (uid, libelle) {
						return {Bl: libelle, r8: uid};
					}),
				A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string)))));
var $author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$ligneDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$visibiliteDeLEtape),
		$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'controleDetail',
		$elm$json$Json$Decode$nullable(
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['etape', 'libelle']),
				$elm$json$Json$Decode$string)),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'controleDetail',
			$elm$json$Json$Decode$nullable(
				A2($elm$json$Json$Decode$field, 'role', $author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$roleDecoder)),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'controle',
				A2(
					$elm$json$Json$Decode$map,
					function (code) {
						return code === 'bloque-la-publication';
					},
					$elm$json$Json$Decode$string),
				false,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'prerempli',
					$elm$json$Json$Decode$bool,
					false,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'aValider',
						$elm$json$Json$Decode$nullable(
							A2($elm$json$Json$Decode$field, 'roleUid', $elm$json$Json$Decode$string)),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'destination',
							$author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$destinationDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'libelles',
								$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'uid',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$Ligne))))))))));
var $author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$Ressource = F3(
	function (uid, libelle, champs) {
		return {dw: champs, Bl: libelle, r8: uid};
	});
var $author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$ressourceDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$Ressource,
	A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'champs',
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				F2(
					function (code, libelle) {
						return {vx: code, Bl: libelle};
					}),
				A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string)))));
var $author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$pageDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
	_List_fromArray(
		['options', 'ressourcesLiees']),
	$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$ressourceDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['options', 'roles']),
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$roleDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['options', 'validateurs']),
			$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$roleDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['options', 'destinations']),
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'champs',
					$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$ligneDecoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'versionEnEdition',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'formulaire',
							$author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$formulaireDecoder,
							$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$Page))))))));
var $author$project$Components$Parametrage$PipeDestinations$Update$popMessages = function (msg) {
	if (msg.$ === 1) {
		var lecture = msg.a;
		var reponse = msg.b;
		switch (lecture) {
			case 0:
				return $author$project$Components$Parametrage$PipeDestinations$Update$dit(
					A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Common$API$QueryAPIModel$annuaireDecoder, reponse));
			case 1:
				return $author$project$Components$Parametrage$PipeDestinations$Update$dit(
					A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Common$API$QueryAPIModel$racineDuPipeDecoder, reponse));
			case 2:
				return $author$project$Components$Parametrage$PipeDestinations$Update$dit(
					A2(
						$author$project$API$Reponse$lire,
						$elm$json$Json$Decode$succeed(0),
						reponse));
			case 3:
				return $author$project$Components$Parametrage$PipeDestinations$Update$dit(
					A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$cartesDecoder, reponse));
			default:
				return $author$project$Components$Parametrage$PipeDestinations$Update$dit(
					A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$pageDecoder, reponse));
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$PipeDestinations$Update$Annuaire = 0;
var $author$project$Components$Parametrage$PipeDestinations$Update$Lire = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeDestinations$Update$Edition = 2;
var $author$project$Components$Parametrage$PipeDestinations$Update$Page = 4;
var $author$project$Components$Parametrage$PipeDestinations$Update$Racine = 1;
var $author$project$Components$Parametrage$PipeDestinations$Update$LesFormulaires = 3;
var $author$project$Components$Parametrage$PipeDestinations$Update$avecLesFormulaires = F3(
	function (libelle, liens, model) {
		var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$formulairesDuPipe, liens);
		if (!_v0.$) {
			var lien = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{Bl: libelle}),
				_List_fromArray(
					[
						A2($author$project$Components$Parametrage$PipeDestinations$Update$Lire, 3, lien)
					]));
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{nf: true, Bl: libelle}),
				_List_Nil);
		}
	});
var $author$project$Components$Parametrage$PipeDestinations$Update$Reconnecter = {$: 1};
var $author$project$Components$Parametrage$PipeDestinations$Update$sous = F4(
	function (decodeur, reponse, model, suite) {
		var _v0 = A2($author$project$API$Reponse$lire, decodeur, reponse);
		if (!_v0.$) {
			var lue = _v0.a;
			return suite(lue);
		} else {
			var refus = _v0.a;
			return (refus.ri === 401) ? _Utils_Tuple2(
				model,
				_List_fromArray(
					[$author$project$Components$Parametrage$PipeDestinations$Update$Reconnecter])) : _Utils_Tuple2(
				_Utils_update(
					model,
					{nf: model.nf || (refus.ri === 404)}),
				_List_Nil);
		}
	});
var $author$project$Components$Parametrage$PipeDestinations$Update$lu = F3(
	function (lecture, reponse, model) {
		switch (lecture) {
			case 0:
				return A4(
					$author$project$Components$Parametrage$PipeDestinations$Update$sous,
					$author$project$Components$Parametrage$Common$API$QueryAPIModel$lienDuPipeDecoder(model.vx),
					reponse,
					model,
					function (visee) {
						if (!visee.$) {
							var racine = visee.a;
							return _Utils_Tuple2(
								model,
								_List_fromArray(
									[
										A2($author$project$Components$Parametrage$PipeDestinations$Update$Lire, 1, racine)
									]));
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{nf: true}),
								_List_Nil);
						}
					});
			case 1:
				return A4(
					$author$project$Components$Parametrage$PipeDestinations$Update$sous,
					$author$project$Components$Parametrage$Common$API$QueryAPIModel$racineDuPipeDecoder,
					reponse,
					model,
					function (edition) {
						if (!edition.$) {
							var lien = edition.a;
							return _Utils_Tuple2(
								model,
								_List_fromArray(
									[
										A2($author$project$Components$Parametrage$PipeDestinations$Update$Lire, 2, lien)
									]));
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{nf: true}),
								_List_Nil);
						}
					});
			case 2:
				return A4(
					$author$project$Components$Parametrage$PipeDestinations$Update$sous,
					A3(
						$elm$json$Json$Decode$map2,
						$elm$core$Tuple$pair,
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['pipe', 'libelles']),
							$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)),
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder),
					reponse,
					model,
					function (_v3) {
						var libelles = _v3.a;
						var liens = _v3.b;
						return A3(
							$author$project$Components$Parametrage$PipeDestinations$Update$avecLesFormulaires,
							$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(libelles),
							liens,
							model);
					});
			case 3:
				return A4(
					$author$project$Components$Parametrage$PipeDestinations$Update$sous,
					$author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$cartesDecoder,
					reponse,
					model,
					function (cartes) {
						var _v4 = A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.kM;
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (carte) {
										return _Utils_eq(carte.r8, model.mR);
									},
									cartes)));
						if (!_v4.$) {
							var lien = _v4.a;
							return _Utils_Tuple2(
								model,
								_List_fromArray(
									[
										A2($author$project$Components$Parametrage$PipeDestinations$Update$Lire, 4, lien)
									]));
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{nf: true}),
								_List_Nil);
						}
					});
			default:
				return A4(
					$author$project$Components$Parametrage$PipeDestinations$Update$sous,
					$author$project$Components$Parametrage$PipeDestinations$API$QueryAPIModel$pageDecoder,
					reponse,
					model,
					function (page) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									EE: $elm$core$Maybe$Just(page)
								}),
							_List_Nil);
					});
		}
	});
var $author$project$Components$Parametrage$PipeDestinations$Update$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var code = msg.a;
			var formulaireUid = msg.b;
			var liens = msg.c;
			var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$pipes, liens);
			if (!_v1.$) {
				var lecture = _v1.a;
				return _Utils_Tuple2(
					A2($author$project$Components$Parametrage$PipeDestinations$Model$init, code, formulaireUid),
					_List_fromArray(
						[
							A2($author$project$Components$Parametrage$PipeDestinations$Update$Lire, 0, lecture)
						]));
			} else {
				return _Utils_Tuple2(
					A2($author$project$Components$Parametrage$PipeDestinations$Model$init, code, formulaireUid),
					_List_Nil);
			}
		} else {
			var lecture = msg.a;
			var reponse = msg.b;
			return A3($author$project$Components$Parametrage$PipeDestinations$Update$lu, lecture, reponse, model);
		}
	});
var $author$project$Main$Update$versLesDestinationsDesChamps = F3(
	function (i18n, msg, model) {
		var _v0 = A2($author$project$Components$Parametrage$PipeDestinations$Update$update, msg, model.Fx);
		var destinations = _v0.a;
		var effets = _v0.b;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLesDestinationsDesChamps,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Parametrage$PipeDestinations$Update$popMessages(msg),
							model.Ct),
						Fx: destinations
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$EnvoyerAuxGroupes = function (a) {
	return {$: 187, a: a};
};
var $author$project$Main$Update$LireLEquipePourLesGroupes = F2(
	function (a, b) {
		return {$: 181, a: a, b: b};
	});
var $author$project$Main$Update$LireLesGroupes = function (a) {
	return {$: 173, a: a};
};
var $author$project$Main$Model$PourLesGroupes = 30;
var $author$project$Main$Update$depuisLesGroupes = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[30]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 1:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesGroupes)));
			case 2:
				var etape = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLEquipePourLesGroupes(etape))));
			case 4:
				var uid = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AllerA(
								$author$project$Routes$Route$toString(
									A2($author$project$Routes$Route$FicheDeGroupe, uid, $elm$core$Maybe$Nothing)))
							])));
			case 3:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerAuxGroupes(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 5:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$Annuaire = F4(
	function (groupes, total, archives, liens) {
		return {i$: archives, Ac: groupes, nQ: liens, JE: total};
	});
var $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$GroupeAPIView = F8(
	function (uid, nom, description, responsable, sorte, archive, membresActifs, liens) {
		return {tE: archive, dH: description, nQ: liens, n5: membresActifs, Dj: nom, qB: responsable, rg: sorte, r8: uid};
	});
var $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$groupe = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'membresActifs',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'archive',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'sorte',
				$author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$sorte,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'responsable',
					$elm$json$Json$Decode$string,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'description',
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'nom',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'uid',
								$author$project$Components$Referentiel$Identifiants$groupeUidDecoder,
								$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$GroupeAPIView)))))))));
var $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$annuaireDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'archives',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'total',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'groupes',
				$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$groupe),
				$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$Annuaire)))));
var $author$project$Components$Referentiel$Groupes$Update$popMessages = function (msg) {
	switch (msg.$) {
		case 2:
			var reponse = msg.a;
			var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$annuaireDecoder, reponse);
			if (_v1.$ === 1) {
				var refus = _v1.a;
				return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Components$Shared$Messages$Model$duRefus(refus));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 1:
			var octets = msg.a;
			return _Utils_eq(
				$author$project$API$ProcessUid$depuisOctets(octets),
				$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
				{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$Groupes$Effet$DemanderProcessUid = {$: 0};
var $author$project$Components$Referentiel$Groupes$Effet$LireAnnuaire = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Groupes$Effet$LireLEquipe = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Referentiel$Groupes$Model$creationVide = {dH: '', Dj: '', qB: '', rg: $elm$core$Maybe$Nothing, b5: false};
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$CreerDynamique = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$CreerStatique = function (a) {
	return {$: 0, a: a};
};
var $author$project$API$NavLinksDictionary$creerUnGroupeDynamique = 'creer-un-groupe-dynamique';
var $author$project$API$NavLinksDictionary$creerUnGroupeStatique = 'creer-un-groupe-statique';
var $author$project$Components$Referentiel$Groupes$Update$nonVide = function (texte) {
	return $elm$core$String$isEmpty(texte) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(texte);
};
var $author$project$Components$Referentiel$Groupes$Update$commandeValide = function (creation) {
	var nom = $elm$core$String$trim(creation.Dj);
	var groupe = {
		dH: A2(
			$elm$core$Maybe$andThen,
			$author$project$Components$Referentiel$Groupes$Update$nonVide,
			$elm$core$Maybe$Just(
				$elm$core$String$trim(creation.dH))),
		Dj: nom,
		qB: $author$project$Components$Referentiel$Groupes$Update$nonVide(creation.qB)
	};
	if ($elm$core$String$isEmpty(nom)) {
		return $elm$core$Maybe$Nothing;
	} else {
		var _v0 = creation.rg;
		if (!_v0.$) {
			if (!_v0.a) {
				var _v1 = _v0.a;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(
						$author$project$API$NavLinksDictionary$creerUnGroupeStatique,
						$author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$CreerStatique(groupe)));
			} else {
				var _v2 = _v0.a;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(
						$author$project$API$NavLinksDictionary$creerUnGroupeDynamique,
						$author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$CreerDynamique(groupe)));
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$Components$Referentiel$Groupes$EnvoiDeGroupe$enCours = $author$project$API$Envoi$enCours;
var $author$project$Components$Referentiel$Groupes$Model$liensDeLAnnuaire = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.nQ;
			},
			model.aS));
};
var $author$project$Components$Referentiel$Groupes$Effet$Envoyer = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Groupes$Effet$Reconnecter = {$: 6};
var $author$project$Components$Referentiel$Groupes$EnvoiDeGroupe$reglage = {
	f8: $author$project$Components$Referentiel$Groupes$Effet$DemanderProcessUid,
	l4: $author$project$Components$Referentiel$Groupes$Effet$Envoyer,
	go: function (_v0) {
		return 0;
	},
	pW: $author$project$Components$Referentiel$Groupes$Effet$Reconnecter,
	qu: F2(
		function (_v1, _v2) {
			return true;
		}),
	qv: $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$reponseDeCommandeDecoder
};
var $author$project$Components$Referentiel$Groupes$EnvoiDeGroupe$partir = $author$project$API$Envoi$partir($author$project$Components$Referentiel$Groupes$EnvoiDeGroupe$reglage);
var $author$project$Components$Referentiel$Groupes$Update$demanderLaCreation = function (model) {
	var _v0 = model.wl;
	if (!_v0.$) {
		var creation = _v0.a;
		if ($author$project$Components$Referentiel$Groupes$EnvoiDeGroupe$enCours(model.l2)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v1 = $author$project$Components$Referentiel$Groupes$Update$commandeValide(creation);
			if (!_v1.$) {
				var _v2 = _v1.a;
				var rel = _v2.a;
				var commande = _v2.b;
				var _v3 = A3(
					$author$project$Components$Referentiel$Groupes$EnvoiDeGroupe$partir,
					A2(
						$author$project$API$Liens$trouver,
						rel,
						$author$project$Components$Referentiel$Groupes$Model$liensDeLAnnuaire(model)),
					commande,
					model.l2);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var envoi = _v4.a;
					var effets = _v4.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{l2: envoi}),
						effets);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							wl: $elm$core$Maybe$Just(
								_Utils_update(
									creation,
									{b5: true}))
						}),
					_List_Nil);
			}
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$Groupes$Model$idDeLaCreation = 'groupes-nouveau';
var $author$project$Components$Referentiel$Groupes$Model$lienDesArchives = function (model) {
	return model.fB ? $elm$core$Maybe$Nothing : A2(
		$author$project$API$Liens$trouver,
		$author$project$API$NavLinksDictionary$avecLesArchives,
		$author$project$Components$Referentiel$Groupes$Model$liensDeLAnnuaire(model));
};
var $author$project$Components$Referentiel$Groupes$Update$modifier = F2(
	function (f, model) {
		return _Utils_update(
			model,
			{
				wl: A2($elm$core$Maybe$map, f, model.wl)
			});
	});
var $author$project$Components$Referentiel$Groupes$EnvoiDeGroupe$recevoir = $author$project$API$Envoi$recevoir;
var $author$project$Components$Referentiel$Groupes$Effet$OuvrirLaFiche = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Referentiel$Groupes$EnvoiDeGroupe$conclure = $author$project$API$Envoi$conclure($author$project$Components$Referentiel$Groupes$EnvoiDeGroupe$reglage);
var $author$project$Components$Referentiel$Groupes$Update$fermeture = function (drawer) {
	return A3(
		$author$project$Components$Shared$Drawer$Update$update,
		{Il: false},
		$author$project$Components$Shared$Drawer$Update$Fermer,
		drawer).a;
};
var $author$project$Components$Referentiel$Groupes$Update$repondreALaCreation = F2(
	function (reponse, model) {
		var _v0 = A2($author$project$Components$Referentiel$Groupes$EnvoiDeGroupe$conclure, reponse, model.l2);
		if (!_v0.$) {
			switch (_v0.a.b.$) {
				case 0:
					var _v1 = _v0.a;
					var envoi = _v1.a;
					var _v2 = _v1.b;
					var rendue = _v2.b;
					var effets = _v1.c;
					var ouverture = A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Groupes$Effet$OuvrirLaFiche, $elm$core$List$singleton),
						A2(
							$elm$core$Maybe$andThen,
							$author$project$Components$Referentiel$Identifiants$groupeUidFromString,
							A2(
								$elm$core$Maybe$andThen,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.cM;
									},
									A2(
										$elm$core$Basics$composeR,
										$elm$core$String$split('/'),
										A2($elm$core$Basics$composeR, $elm$core$List$reverse, $elm$core$List$head))),
								A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$self, rendue.nQ))));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								wl: $elm$core$Maybe$Nothing,
								kX: $author$project$Components$Referentiel$Groupes$Update$fermeture(model.kX),
								l2: envoi,
								pZ: $elm$core$Maybe$Nothing
							}),
						_Utils_ap(
							effets,
							A2($elm$core$Maybe$withDefault, _List_Nil, ouverture)));
				case 1:
					var _v3 = _v0.a;
					var envoi = _v3.a;
					var _v4 = _v3.b;
					var refus = _v4.b;
					var effets = _v3.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l2: envoi,
								pZ: $elm$core$Maybe$Just(refus)
							}),
						effets);
				default:
					var _v5 = _v0.a;
					var envoi = _v5.a;
					var _v6 = _v5.b;
					var effets = _v5.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{l2: envoi}),
						effets);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$Groupes$Effet$PlacerFocus = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Referentiel$Groupes$Update$saisieEnCours = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (creation) {
				return (creation.Dj !== '') || ((creation.dH !== '') || ((creation.qB !== '') || (!_Utils_eq(creation.rg, $elm$core$Maybe$Nothing))));
			},
			model.wl));
};
var $author$project$Components$Referentiel$Groupes$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{kX: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Referentiel$Groupes$Effet$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Referentiel$Groupes$Update$saisieEnCours(model)
				},
				geste,
				model.kX));
	});
var $author$project$Components$Referentiel$Groupes$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var lien = msg.a;
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[
							$author$project$Components$Referentiel$Groupes$Effet$LireAnnuaire(lien),
							$author$project$Components$Referentiel$Groupes$Effet$DemanderProcessUid
						]));
			case 1:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$Components$Referentiel$Groupes$EnvoiDeGroupe$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 2:
				var reponse = msg.a;
				var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$annuaireDecoder, reponse);
				if (!_v1.$) {
					var annuaire = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aS: $elm$core$Maybe$Just(annuaire),
								pZ: $elm$core$Maybe$Nothing
							}),
						_List_Nil);
				} else {
					var refus = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								pZ: $elm$core$Maybe$Just(refus)
							}),
						_List_Nil);
				}
			case 3:
				var racine = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (_v2) {
								var etape = _v2.a;
								var lien = _v2.b;
								return _List_fromArray(
									[
										A2($author$project$Components$Referentiel$Groupes$Effet$LireLEquipe, etape, lien)
									]);
							},
							$author$project$Components$Referentiel$Common$Equipe$premiereEtape(racine))));
			case 4:
				var etape = msg.a;
				var reponse = msg.b;
				var _v3 = A2($author$project$Components$Referentiel$Common$Equipe$avancer, etape, reponse);
				if (!_v3.$) {
					var membres = _v3.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l5: $author$project$Components$Referentiel$Common$Equipe$Lue(membres)
							}),
						_List_Nil);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 5:
				var _v4 = $author$project$Components$Referentiel$Groupes$Model$lienDesArchives(model);
				if (!_v4.$) {
					var lien = _v4.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{fB: true}),
						_List_fromArray(
							[
								$author$project$Components$Referentiel$Groupes$Effet$LireAnnuaire(lien)
							]));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 6:
				return A2(
					$author$project$Components$Referentiel$Groupes$Update$versLeDrawer,
					$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Referentiel$Groupes$Model$idDeLaCreation),
					_Utils_update(
						model,
						{
							wl: $elm$core$Maybe$Just($author$project$Components$Referentiel$Groupes$Model$creationVide),
							pZ: $elm$core$Maybe$Nothing
						}));
			case 7:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$Groupes$Update$versLeDrawer, geste, model);
			case 8:
				var nom = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Groupes$Update$modifier,
						function (creation) {
							return _Utils_update(
								creation,
								{Dj: nom});
						},
						model),
					_List_Nil);
			case 9:
				var description = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Groupes$Update$modifier,
						function (creation) {
							return _Utils_update(
								creation,
								{dH: description});
						},
						model),
					_List_Nil);
			case 10:
				var responsable = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Groupes$Update$modifier,
						function (creation) {
							return _Utils_update(
								creation,
								{qB: responsable});
						},
						model),
					_List_Nil);
			case 11:
				var sorte = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$Groupes$Update$modifier,
						function (creation) {
							return _Utils_update(
								creation,
								{
									rg: $elm$core$Maybe$Just(sorte)
								});
						},
						model),
					_List_Nil);
			case 12:
				return $author$project$Components$Referentiel$Groupes$Update$demanderLaCreation(model);
			default:
				var reponse = msg.a;
				return A2($author$project$Components$Referentiel$Groupes$Update$repondreALaCreation, reponse, model);
		}
	});
var $author$project$Main$Update$versLesGroupes = F3(
	function (i18n, msg, model) {
		var _v0 = A2($author$project$Components$Referentiel$Groupes$Update$update, msg, model.Ac);
		var groupes = _v0.a;
		var effets = _v0.b;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLesGroupes,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ac: groupes,
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Referentiel$Groupes$Update$popMessages(msg),
							model.Ct)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$ApercevoirUnFichierDImport = function (a) {
	return {$: 236, a: a};
};
var $author$project$Main$Update$AttendreAvantDeRelireLesImports = function (a) {
	return {$: 248, a: a};
};
var $author$project$Main$Update$ChoisirUnFichierDImport = {$: 235};
var $author$project$Main$Update$EnvoyerAuxImports = function (a) {
	return {$: 247, a: a};
};
var $author$project$Main$Update$LireLHistoriqueDImport = function (a) {
	return {$: 243, a: a};
};
var $author$project$Main$Update$LireLaLectureDImport = function (a) {
	return {$: 245, a: a};
};
var $author$project$Main$Update$LireLaSimulationDImport = function (a) {
	return {$: 242, a: a};
};
var $author$project$Main$Update$LireLeRapportDImport = function (a) {
	return {$: 240, a: a};
};
var $author$project$Main$Update$LireLeSuiviDImport = function (a) {
	return {$: 239, a: a};
};
var $author$project$Main$Update$LireLesAdmisesDImport = F2(
	function (a, b) {
		return {$: 232, a: a, b: b};
	});
var $author$project$Main$Update$LireLesChampsDImport = F2(
	function (a, b) {
		return {$: 231, a: a, b: b};
	});
var $author$project$Main$Update$LireLesImports = function (a) {
	return {$: 230, a: a};
};
var $author$project$Main$Update$LireLesLignesRejetees = function (a) {
	return {$: 241, a: a};
};
var $author$project$Main$Update$LireLesLotsDImport = function (a) {
	return {$: 244, a: a};
};
var $author$project$Main$Update$LireLesOffresDImport = function (a) {
	return {$: 234, a: a};
};
var $author$project$Main$Update$LireLesRolesDImport = function (a) {
	return {$: 233, a: a};
};
var $author$project$Main$Update$LireLesValeursDImport = F2(
	function (a, b) {
		return {$: 246, a: a, b: b};
	});
var $author$project$Main$Update$LireUnLotDImport = function (a) {
	return {$: 238, a: a};
};
var $author$project$Main$Model$PourLesImports = 46;
var $author$project$Main$Update$ReappliquerUnModeleDImport = F2(
	function (a, b) {
		return {$: 237, a: a, b: b};
	});
var $author$project$Main$Update$depuisLesImports = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[46]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 1:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesImports)));
			case 2:
				var cle = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLesChampsDImport(cle))));
			case 3:
				var cle = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLesAdmisesDImport(cle))));
			case 4:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesRolesDImport)));
			case 5:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesOffresDImport)));
			case 6:
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[$author$project$Main$Update$ChoisirUnFichierDImport])));
			case 7:
				var lien = effet.a;
				var fichier = effet.b;
				var cible = effet.c;
				var feuille = effet.d;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$ApercevoirUnFichierDImport(
									{vf: cible, mx: feuille, gw: fichier, gM: vers.gM, nB: vers.nB});
							})));
			case 8:
				var feuille = effet.a;
				var lien = effet.b;
				var enTetes = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return A2(
									$author$project$Main$Update$ReappliquerUnModeleDImport,
									feuille,
									{ym: enTetes, gM: vers.gM, nB: vers.nB});
							})));
			case 9:
				var lien = effet.a;
				var fichier = effet.b;
				var destination = effet.c;
				var demande = effet.d;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return A2(
									$author$project$Main$Update$LireLesValeursDImport,
									destination,
									{kC: demande, gw: fichier, gM: vers.gM, nB: vers.nB});
							})));
			case 10:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesLotsDImport)));
			case 11:
				var lien = effet.a;
				var fichier = effet.b;
				var demande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$LireLaLectureDImport(
									{kC: demande, gw: fichier, gM: vers.gM, nB: vers.nB});
							})));
			case 12:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireUnLotDImport)));
			case 13:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLeSuiviDImport)));
			case 14:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLeRapportDImport)));
			case 17:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesLignesRejetees)));
			case 15:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLaSimulationDImport)));
			case 16:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLHistoriqueDImport)));
			case 18:
				var nom = effet.a;
				var contenu = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$TelechargerLesFichiers(
								_List_fromArray(
									[
										{fZ: contenu, Dj: nom, r0: 'text/csv'}
									]))
							])));
			case 19:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerAuxImports(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 20:
				var delaiMs = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AttendreAvantDeRelireLesImports(delaiMs)
							])));
			case 21:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Imports$Outil$Update$popMessages = function (_v0) {
	return $elm$core$Maybe$Nothing;
};
var $author$project$Main$Update$requeteSurLesImports = function (effet) {
	switch (effet.$) {
		case 1:
			return true;
		case 13:
			return true;
		case 14:
			return true;
		case 17:
			return true;
		case 15:
			return true;
		case 16:
			return true;
		case 19:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Imports$Outil$API$WriteAPIModel$AnnulerLaCorrection = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$Components$Imports$Outil$Update$Apercevoir = F4(
	function (a, b, c, d) {
		return {$: 7, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Imports$Outil$API$WriteAPIModel$AppliquerLeLot = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Imports$Outil$Update$AttendreAvantDeRelire = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Imports$Outil$Update$ChoisirUnFichier = {$: 6};
var $author$project$Components$Imports$Outil$API$WriteAPIModel$CorrigerUneLigne = F4(
	function (a, b, c, d) {
		return {$: 3, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Imports$Outil$Update$DemanderProcessUid = {$: 0};
var $author$project$Components$Imports$Outil$Model$EtapeApplication = 6;
var $author$project$Components$Imports$Outil$Model$EtapeCibles = 1;
var $author$project$Components$Imports$Outil$Model$EtapeColonnes = 2;
var $author$project$Components$Imports$Outil$Model$EtapeLotPrepare = 4;
var $author$project$Components$Imports$Outil$API$WriteAPIModel$IgnorerUneLigne = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Components$Imports$Outil$Update$LigneDHistoriqueReprise = function (a) {
	return {$: 80, a: a};
};
var $author$project$Components$Imports$Outil$Update$LigneDHistoriqueSuivie = function (a) {
	return {$: 81, a: a};
};
var $author$project$Components$Imports$Outil$Update$Lire = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Imports$Outil$Update$LireLHistorique = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Imports$Outil$Update$LireLaSimulation = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Imports$Outil$Update$LireLeLot = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Imports$Outil$Update$LireLeRapport = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Imports$Outil$Update$LireLeSuivi = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Imports$Outil$Update$LireLesAdmises = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Imports$Outil$Update$LireLesLignes = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Imports$Outil$Model$PageDeLHistorique = 1;
var $author$project$Components$Imports$Outil$Update$PourLaRepartition = {$: 0};
var $author$project$Components$Imports$Outil$API$WriteAPIModel$PreparerUnLot = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Imports$Outil$Update$Reappliquer = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$Components$Imports$Outil$Update$Reconnecter = {$: 22};
var $author$project$Components$Imports$Outil$Model$RegleLangue = 3;
var $author$project$Components$Imports$Outil$API$WriteAPIModel$RejouerLesLignes = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Imports$Outil$API$WriteAPIModel$ReprendreUneLigne = F3(
	function (a, b, c) {
		return {$: 6, a: a, b: b, c: c};
	});
var $author$project$Components$Imports$Outil$API$WriteAPIModel$SimulerLeLot = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Imports$Outil$Update$Telecharger = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$Admise = F2(
	function (code, libelle) {
		return {vx: code, Bl: libelle};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$admisesDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'valeurs',
			$elm$json$Json$Decode$list(
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'libelle',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'code',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$Admise))))),
			A2(
			$elm$json$Json$Decode$field,
			'formes',
			$elm$json$Json$Decode$list(
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['libelles', 'fr']),
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'uid',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$Admise)))))
		]));
var $author$project$API$NavLinksDictionary$apercuDuFichier = 'apercu-du-fichier';
var $author$project$Components$Imports$Outil$Update$LireLesChamps = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Imports$Outil$Model$cleDeCible = F2(
	function (domaine, type_) {
		return domaine + ('/' + type_);
	});
var $author$project$Components$Imports$Outil$Update$lesChampsAUne = F2(
	function (model, cibles) {
		return A2(
			$elm$core$List$filterMap,
			function (_v1) {
				var domaine = _v1.a;
				var type_ = _v1.b;
				return A2(
					$elm$core$Maybe$map,
					$author$project$Components$Imports$Outil$Update$LireLesChamps(
						A2($author$project$Components$Imports$Outil$Model$cleDeCible, domaine, type_)),
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.BD;
						},
						A2(
							$elm$core$Maybe$andThen,
							function (imports) {
								return $elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (cible) {
											return _Utils_eq(cible.cC, domaine) && _Utils_eq(cible.r0, type_);
										},
										imports.jS));
							},
							model.cN)));
			},
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var domaine = _v0.a;
					var type_ = _v0.b;
					return !A2(
						$elm$core$Dict$member,
						A2($author$project$Components$Imports$Outil$Model$cleDeCible, domaine, type_),
						model.dw);
				},
				A3(
					$elm$core$List$foldl,
					F2(
						function (cible, acc) {
							return A2($elm$core$List$member, cible, acc) ? acc : _Utils_ap(
								acc,
								_List_fromArray(
									[cible]));
						}),
					_List_Nil,
					cibles)));
	});
var $author$project$Components$Imports$Outil$Model$lienDe = F2(
	function (rel, model) {
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				$author$project$API$Liens$trouver(rel)),
			model.cN);
	});
var $author$project$Components$Imports$Outil$Model$siExisteParDefaut = function (domaine) {
	return (domaine === 'catalogue') ? 'mettre-a-jour' : 'completer';
};
var $author$project$Components$Imports$Outil$Update$affecter = F3(
	function (feuille, cible, model) {
		var propositions = function () {
			var _v0 = _Utils_Tuple3(
				A2($author$project$Components$Imports$Outil$Model$lienDe, $author$project$API$NavLinksDictionary$apercuDuFichier, model),
				model.gw,
				cible);
			if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
				var lien = _v0.a.a;
				var fichier = _v0.b.a;
				return _List_fromArray(
					[
						A4(
						$author$project$Components$Imports$Outil$Update$Apercevoir,
						lien,
						fichier,
						cible,
						$elm$core$Maybe$Just(feuille))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var change = _Utils_update(
			model,
			{
				pb: A2(
					$elm$core$List$map,
					function (part) {
						return _Utils_eq(part.mx, feuille) ? _Utils_update(
							part,
							{
								vf: cible,
								j1: $elm$core$Dict$empty,
								hJ: $elm$core$Dict$empty,
								IM: A2(
									$elm$core$Maybe$withDefault,
									part.IM,
									A2(
										$elm$core$Maybe$map,
										A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $author$project$Components$Imports$Outil$Model$siExisteParDefaut),
										cible)),
								e5: $elm$core$Maybe$Nothing
							}) : part;
					},
					model.pb)
			});
		return _Utils_Tuple2(
			change,
			_Utils_ap(
				A2(
					$author$project$Components$Imports$Outil$Update$lesChampsAUne,
					change,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Maybe$map, $elm$core$List$singleton, cible))),
				propositions));
	});
var $author$project$Components$Imports$Outil$Model$taillePage = 50;
var $author$project$Components$Imports$Outil$Model$lienDeLaListe = F2(
	function (lien, lignes) {
		return _Utils_update(
			lien,
			{
				cM: lien.cM + ('?filtre=' + (lignes.zH + ('&page=' + ($elm$core$String$fromInt(lignes.EE) + ('&taille=' + $elm$core$String$fromInt($author$project$Components$Imports$Outil$Model$taillePage))))))
			});
	});
var $author$project$Components$Imports$Outil$Update$relireLesLignes = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (l) {
				return _List_fromArray(
					[
						$author$project$Components$Imports$Outil$Update$LireLesLignes(
						A2($author$project$Components$Imports$Outil$Model$lienDeLaListe, l.nB, l))
					]);
			},
			model.gV));
};
var $author$project$Components$Imports$Outil$Update$andThenRelire = function (_v0) {
	var model = _v0.a;
	var effets = _v0.b;
	return _Utils_Tuple2(
		model,
		_Utils_ap(
			effets,
			$author$project$Components$Imports$Outil$Update$relireLesLignes(model)));
};
var $author$project$API$NavLinksDictionary$annulerLaCorrection = 'annuler-la-correction';
var $author$project$Components$Imports$Outil$API$QueryAPIModel$Apercu = F5(
	function (nom, format, separateur, encodage, feuilles) {
		return {yo: encodage, zn: feuilles, zP: format, Dj: nom, IF: separateur};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$Feuille = F8(
	function (nom, enTetes, nombreDeLignes, propositions, cibleSuggeree, exemples, refusees, controles) {
		return {vg: cibleSuggeree, wc: controles, ym: enTetes, y_: exemples, Dj: nom, g9: nombreDeLignes, Gw: propositions, Hi: refusees};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$Controle = F3(
	function (ok, converti, erreur) {
		return {kb: converti, go: erreur, D7: ok};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$controleDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'erreur',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'converti',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'ok',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$Controle))));
var $author$project$Components$Imports$Outil$API$QueryAPIModel$indexees = function (valeur) {
	return A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$filterMap(
				function (_v0) {
					var cle = _v0.a;
					var v = _v0.b;
					return A2(
						$elm$core$Maybe$map,
						function (index) {
							return _Utils_Tuple2(index, v);
						},
						$elm$core$String$toInt(cle));
				}),
			$elm$core$Dict$fromList),
		$elm$json$Json$Decode$keyValuePairs(valeur));
};
var $author$project$Components$Imports$Outil$API$QueryAPIModel$Refusee = F4(
	function (index, entete, champ, raison) {
		return {uN: champ, l0: entete, AI: index, pH: raison};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$refuseeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'raison',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'champ',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'entete',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'index',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$Refusee)))));
var $author$project$Components$Imports$Outil$API$QueryAPIModel$Suggestion = F4(
	function (domaine, type_, libelle, exacte) {
		return {cC: domaine, mm: exacte, Bl: libelle, r0: type_};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$suggestionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'exacte',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'libelle',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'domaine',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$Suggestion)))));
var $author$project$Components$Imports$Outil$API$QueryAPIModel$feuilleDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'controles',
	$author$project$Components$Imports$Outil$API$QueryAPIModel$indexees($author$project$Components$Imports$Outil$API$QueryAPIModel$controleDecoder),
	$elm$core$Dict$empty,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'refusees',
		$elm$json$Json$Decode$list($author$project$Components$Imports$Outil$API$QueryAPIModel$refuseeDecoder),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'exemples',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'cibleSuggeree',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Imports$Outil$API$QueryAPIModel$suggestionDecoder),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'propositions',
					$author$project$Components$Imports$Outil$API$QueryAPIModel$indexees($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'nombreDeLignes',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'enTetes',
							$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'nom',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$Feuille)))))))));
var $author$project$Components$Imports$Outil$API$QueryAPIModel$apercuDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'feuilles',
	$elm$json$Json$Decode$list($author$project$Components$Imports$Outil$API$QueryAPIModel$feuilleDecoder),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'encodage',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'separateur',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'format',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'nom',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$Apercu))))));
var $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$AccesRefuse = {$: 13};
var $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$AutreRefus = {$: 14};
var $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$ChampSansValeurs = {$: 8};
var $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$CorrectionEncoreEnErreur = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$ExtensionRefusee = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$FichierIllisible = {$: 1};
var $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$FichierTropDeLignes = {$: 4};
var $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$FichierTropGros = {$: 3};
var $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$FichierVide = {$: 2};
var $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$LigneDejaTraitee = {$: 12};
var $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$NomDeModeleDejaPris = {$: 7};
var $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$ChampDejaRecu = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$ChampObligatoireSansColonne = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$ReglageRefuse = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$RegleNonPortee = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$premiereErreur = function (contenu) {
	var _v0 = A2(
		$elm$json$Json$Decode$decodeValue,
		A2(
			$elm$json$Json$Decode$field,
			'erreurs',
			$elm$json$Json$Decode$list(
				A3(
					$elm$json$Json$Decode$map2,
					$elm$core$Tuple$pair,
					A2($elm$json$Json$Decode$field, 'erreur', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
								A2($elm$json$Json$Decode$field, 'reglage', $elm$json$Json$Decode$string)
							]))))),
		contenu);
	_v0$4:
	while (true) {
		if ((!_v0.$) && _v0.a.b) {
			switch (_v0.a.a.a) {
				case 'ReglageRefuse':
					var _v1 = _v0.a;
					var _v2 = _v1.a;
					var reglage = _v2.b;
					return A2(
						$elm$core$Result$withDefault,
						$author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$AutreRefus,
						A2(
							$elm$core$Result$map,
							$author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$ReglageRefuse(reglage),
							A2(
								$elm$json$Json$Decode$decodeValue,
								A2(
									$elm$json$Json$Decode$field,
									'erreurs',
									A2(
										$elm$json$Json$Decode$index,
										0,
										A2($elm$json$Json$Decode$field, 'raison', $elm$json$Json$Decode$string))),
								contenu)));
				case 'ChampObligatoireSansColonne':
					var _v3 = _v0.a;
					var _v4 = _v3.a;
					var champ = _v4.b;
					return $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$ChampObligatoireSansColonne(champ);
				case 'ChampDejaRecu':
					var _v5 = _v0.a;
					var _v6 = _v5.a;
					var champ = _v6.b;
					return $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$ChampDejaRecu(champ);
				case 'RegleInapplicable':
					var _v7 = _v0.a;
					var _v8 = _v7.a;
					var champ = _v8.b;
					return $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$RegleNonPortee(champ);
				default:
					break _v0$4;
			}
		} else {
			break _v0$4;
		}
	}
	return $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$AutreRefus;
};
var $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$duRefus = function (reponse) {
	if (reponse.ri === 403) {
		return $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$AccesRefuse;
	} else {
		if (reponse.ri === 413) {
			return $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$FichierTropGros;
		} else {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeString,
				A2(
					$elm$json$Json$Decode$field,
					'error',
					$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value)),
				reponse.f$);
			_v0$14:
			while (true) {
				if ((!_v0.$) && _v0.a.b) {
					switch (_v0.a.a.a) {
						case 'ExtensionRefusee':
							var _v1 = _v0.a;
							var _v2 = _v1.a;
							var contenu = _v2.b;
							return A2(
								$elm$core$Result$withDefault,
								$author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$ExtensionRefusee(''),
								A2(
									$elm$core$Result$map,
									$author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$ExtensionRefusee,
									A2(
										$elm$json$Json$Decode$decodeValue,
										A2($elm$json$Json$Decode$field, 'extension', $elm$json$Json$Decode$string),
										contenu)));
						case 'FichierIllisible':
							var _v3 = _v0.a;
							var _v4 = _v3.a;
							return $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$FichierIllisible;
						case 'FichierVide':
							var _v5 = _v0.a;
							var _v6 = _v5.a;
							return $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$FichierVide;
						case 'FichierTropGros':
							var _v7 = _v0.a;
							var _v8 = _v7.a;
							return $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$FichierTropGros;
						case 'FichierTropDeLignes':
							var _v9 = _v0.a;
							var _v10 = _v9.a;
							return $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$FichierTropDeLignes;
						case 'CorrespondanceInvalide':
							var _v11 = _v0.a;
							var _v12 = _v11.a;
							var contenu = _v12.b;
							return $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$premiereErreur(contenu);
						case 'ChampSansValeurs':
							var _v13 = _v0.a;
							var _v14 = _v13.a;
							return $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$ChampSansValeurs;
						case 'CorrectionEncoreEnErreur':
							var _v15 = _v0.a;
							var _v16 = _v15.a;
							var contenu = _v16.b;
							return A2(
								$elm$core$Result$withDefault,
								$author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$AutreRefus,
								A2(
									$elm$core$Result$map,
									$author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$CorrectionEncoreEnErreur,
									A2(
										$elm$json$Json$Decode$decodeValue,
										A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
										contenu)));
						case 'AucuneLigneARejouer':
							var _v17 = _v0.a;
							var _v18 = _v17.a;
							return $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$LigneDejaTraitee;
						case 'CorrectionsModifiees':
							var _v19 = _v0.a;
							var _v20 = _v19.a;
							return $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$LigneDejaTraitee;
						case 'LigneNonCorrigee':
							var _v21 = _v0.a;
							var _v22 = _v21.a;
							return $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$LigneDejaTraitee;
						case 'LigneIgnoreeNonCorrigeable':
							var _v23 = _v0.a;
							var _v24 = _v23.a;
							return $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$LigneDejaTraitee;
						case 'ModeleDejaEnregistre':
							var _v25 = _v0.a;
							var _v26 = _v25.a;
							return $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$NomDeModeleDejaPris;
						case 'NomDeModeleDejaPris':
							var _v27 = _v0.a;
							var _v28 = _v27.a;
							return $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$NomDeModeleDejaPris;
						default:
							break _v0$14;
					}
				} else {
					break _v0$14;
				}
			}
			return $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$AutreRefus;
		}
	}
};
var $author$project$Components$Imports$Outil$Update$lesChampsEtPropositions = function (model) {
	return _Utils_ap(
		A2(
			$author$project$Components$Imports$Outil$Update$lesChampsAUne,
			model,
			A2(
				$elm$core$List$filterMap,
				function ($) {
					return $.vf;
				},
				model.pb)),
		function () {
			var _v0 = _Utils_Tuple2(
				A2($author$project$Components$Imports$Outil$Model$lienDe, $author$project$API$NavLinksDictionary$apercuDuFichier, model),
				model.gw);
			if ((!_v0.a.$) && (!_v0.b.$)) {
				var lien = _v0.a.a;
				var fichier = _v0.b.a;
				return A2(
					$elm$core$List$map,
					function (part) {
						return A4(
							$author$project$Components$Imports$Outil$Update$Apercevoir,
							lien,
							fichier,
							part.vf,
							$elm$core$Maybe$Just(part.mx));
					},
					A2(
						$elm$core$List$filter,
						function (part) {
							return !_Utils_eq(part.vf, $elm$core$Maybe$Nothing);
						},
						model.pb));
			} else {
				return _List_Nil;
			}
		}());
};
var $author$project$Components$Imports$Outil$Model$cibleSuggeree = F2(
	function (suggestion, cibles) {
		if (!suggestion.$) {
			var _v1 = suggestion.a;
			var domaine = _v1.a;
			var type_ = _v1.b;
			var _v2 = A2(
				$elm$core$List$filter,
				function (cible) {
					return _Utils_eq(cible.cC, domaine) && (_Utils_eq(type_, $elm$core$Maybe$Nothing) || _Utils_eq(
						type_,
						$elm$core$Maybe$Just(cible.r0)));
				},
				cibles);
			if (_v2.b && (!_v2.b.b)) {
				var seule = _v2.a;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(seule.cC, seule.r0));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Imports$Outil$Model$partsDepuis = F3(
	function (apercu, suggestion, cibles) {
		var arrivee = A2($author$project$Components$Imports$Outil$Model$cibleSuggeree, suggestion, cibles);
		return A2(
			$elm$core$List$map,
			function (feuille) {
				var cible = function () {
					var _v0 = feuille.vg;
					if (!_v0.$) {
						var proposee = _v0.a;
						return proposee.mm ? $elm$core$Maybe$Just(
							_Utils_Tuple2(proposee.cC, proposee.r0)) : arrivee;
					} else {
						return arrivee;
					}
				}();
				return {
					vf: cible,
					j1: _Utils_eq(cible, $elm$core$Maybe$Nothing) ? $elm$core$Dict$empty : feuille.Gw,
					wc: feuille.wc,
					ym: feuille.ym,
					y_: feuille.y_,
					mx: feuille.Dj,
					g9: feuille.g9,
					o5: $elm$core$Maybe$Nothing,
					Hi: _List_Nil,
					qc: $author$project$Components$Imports$Outil$API$WriteAPIModel$reglagesVides,
					hJ: $elm$core$Dict$empty,
					IM: A2(
						$elm$core$Maybe$withDefault,
						'completer',
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $author$project$Components$Imports$Outil$Model$siExisteParDefaut),
							cible)),
					IR: feuille.Dj,
					e5: _Utils_eq(cible, $elm$core$Maybe$Nothing) ? feuille.vg : $elm$core$Maybe$Nothing
				};
			},
			apercu.zn);
	});
var $author$project$Components$Imports$Outil$Update$PlacerFocus = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Imports$Outil$Update$versLeDrawerDuRefus = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{lu: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Imports$Outil$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.lu));
	});
var $author$project$Components$Imports$Outil$Update$apercuLu = F2(
	function (reponse, model) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$API$Reponse$lire, $author$project$Components$Imports$Outil$API$QueryAPIModel$apercuDecoder, reponse),
			model.cN);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var apercu = _v0.a.a;
				var imports = _v0.b.a;
				var parts = A3($author$project$Components$Imports$Outil$Model$partsDepuis, apercu, model.rm, imports.jS);
				var suivi = _Utils_update(
					model,
					{
						tq: $elm$core$Maybe$Just(apercu),
						Et: $elm$core$Maybe$Nothing,
						pb: parts,
						p8: $elm$core$Maybe$Nothing
					});
				return _Utils_Tuple2(
					suivi,
					$author$project$Components$Imports$Outil$Update$lesChampsEtPropositions(suivi));
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			var refus = _v0.a.a;
			var refuse = _Utils_update(
				model,
				{
					tq: $elm$core$Maybe$Nothing,
					pb: _List_Nil,
					p8: $elm$core$Maybe$Just(
						$author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$duRefus(reponse))
				});
			return (refus.ri === 401) ? _Utils_Tuple2(
				_Utils_update(
					refuse,
					{gw: $elm$core$Maybe$Nothing}),
				_List_fromArray(
					[$author$project$Components$Imports$Outil$Update$Reconnecter])) : A2(
				$author$project$Components$Imports$Outil$Update$versLeDrawerDuRefus,
				$author$project$Components$Shared$Drawer$Update$Ouvrir('imports-choisir-un-fichier'),
				refuse);
		}
	});
var $author$project$API$NavLinksDictionary$appliquerLeLot = 'appliquer-le-lot';
var $author$project$Components$Imports$Outil$Update$avecLesLignes = F2(
	function (f, model) {
		return _Utils_update(
			model,
			{
				gV: A2($elm$core$Maybe$map, f, model.gV)
			});
	});
var $author$project$Components$Imports$Outil$Model$champsDe = F2(
	function (part, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$andThen,
				function (_v0) {
					var domaine = _v0.a;
					var type_ = _v0.b;
					return A2(
						$elm$core$Dict$get,
						A2($author$project$Components$Imports$Outil$Model$cleDeCible, domaine, type_),
						model.dw);
				},
				part.vf));
	});
var $author$project$Components$Imports$Outil$Model$champDeLaColonne = F3(
	function (part, index, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (cle) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (champ) {
							return _Utils_eq(champ.dy, cle);
						},
						A2($author$project$Components$Imports$Outil$Model$champsDe, part, model)));
			},
			A2($elm$core$Dict$get, index, part.j1));
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$Champ = F8(
	function (cle, libelle, obligatoire, type_, unite, regles, lienDesValeurs, estLaCle) {
		return {dy: cle, yD: estLaCle, Bl: libelle, BK: lienDesValeurs, he: obligatoire, hJ: regles, r0: type_, sa: unite};
	});
var $author$project$API$NavLinksDictionary$valeursAdmises = 'valeurs-admises';
var $author$project$Components$Imports$Outil$API$QueryAPIModel$champsDecoder = A2(
	$elm$json$Json$Decode$field,
	'champs',
	$elm$json$Json$Decode$list(
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'estLaCle',
			$elm$json$Json$Decode$bool,
			false,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A2(
					$elm$json$Json$Decode$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.h0;
						},
						$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$valeursAdmises)),
					$author$project$API$Liens$deLaRessource),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'regles',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'unite',
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'type',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'obligatoire',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'libelle',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'cle',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$Champ)))))))))));
var $author$project$Components$Imports$Outil$Model$reglesDe = F2(
	function (part, index) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$Imports$Outil$API$QueryAPIModel$reglesVides,
			A2($elm$core$Dict$get, index, part.hJ));
	});
var $author$project$Components$Imports$Outil$Model$usageParDefaut = 'professionnel';
var $author$project$Components$Imports$Outil$Model$choisirLUsage = F4(
	function (feuille, index, usage, model) {
		return _Utils_update(
			model,
			{
				pb: A2(
					$elm$core$List$map,
					function (part) {
						if (_Utils_eq(part.mx, feuille)) {
							var regles = A2($author$project$Components$Imports$Outil$Model$reglesDe, part, index);
							var choisi = _Utils_eq(usage, $author$project$Components$Imports$Outil$Model$usageParDefaut) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(usage);
							var modifiees = _Utils_update(
								regles,
								{sd: choisi});
							return _Utils_update(
								part,
								{
									hJ: _Utils_eq(modifiees, $author$project$Components$Imports$Outil$API$QueryAPIModel$reglesVides) ? A2($elm$core$Dict$remove, index, part.hJ) : A3($elm$core$Dict$insert, index, modifiees, part.hJ)
								});
						} else {
							return part;
						}
					},
					model.pb)
			});
	});
var $author$project$Components$Imports$Outil$Model$langueDeLaColonne = F2(
	function (part, index) {
		var _v0 = A2($author$project$Components$Imports$Outil$Model$reglesDe, part, index).nn;
		if (!_v0.$) {
			if (_v0.a === 'fr') {
				return '';
			} else {
				var langue = _v0.a;
				return langue;
			}
		} else {
			return '';
		}
	});
var $author$project$Components$Imports$Outil$Model$colonnesParLangue = F2(
	function (part, cle) {
		return A2(
			$elm$core$List$map,
			function (_v1) {
				var index = _v1.a;
				return _Utils_Tuple2(
					A2($author$project$Components$Imports$Outil$Model$langueDeLaColonne, part, index),
					index);
			},
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var champ = _v0.b;
					return _Utils_eq(champ, cle);
				},
				$elm$core$Dict$toList(part.j1)));
	});
var $author$project$Components$Imports$Outil$Model$choisirLaColonneDeLaLangue = F3(
	function (langue, colonne, model) {
		var _v0 = model.fK;
		if (!_v0.$) {
			var cle = _v0.a;
			return _Utils_update(
				model,
				{
					pb: A2(
						$elm$core$List$map,
						function (part) {
							if (_Utils_eq(
								$elm$core$Maybe$Just(part.mx),
								model.Et)) {
								var anciennes = A2(
									$elm$core$List$map,
									$elm$core$Tuple$second,
									A2(
										$elm$core$List$filter,
										function (_v2) {
											var l = _v2.a;
											return _Utils_eq(l, langue);
										},
										A2($author$project$Components$Imports$Outil$Model$colonnesParLangue, part, cle)));
								var sans = _Utils_update(
									part,
									{
										j1: A3($elm$core$List$foldl, $elm$core$Dict$remove, part.j1, anciennes),
										hJ: A3($elm$core$List$foldl, $elm$core$Dict$remove, part.hJ, anciennes)
									});
								if (!colonne.$) {
									var index = colonne.a;
									var regles = A2($author$project$Components$Imports$Outil$Model$reglesDe, sans, index);
									return _Utils_update(
										sans,
										{
											j1: A3($elm$core$Dict$insert, index, cle, sans.j1),
											hJ: A3(
												$elm$core$Dict$insert,
												index,
												_Utils_update(
													regles,
													{
														nn: (langue === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(langue)
													}),
												sans.hJ)
										});
								} else {
									return sans;
								}
							} else {
								return part;
							}
						},
						model.pb)
				});
		} else {
			return model;
		}
	});
var $author$project$Components$Imports$Outil$Update$versLeDrawerDeCible = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{k5: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Imports$Outil$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: !_Utils_eq(model.jN, $elm$core$Maybe$Nothing)
				},
				geste,
				model.k5));
	});
var $author$project$Components$Imports$Outil$Update$cibleEnregistree = function (model) {
	var _v0 = _Utils_Tuple2(model.jN, model.Et);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var choix = _v0.a.a;
		var feuille = _v0.b.a;
		var _v1 = A3(
			$author$project$Components$Imports$Outil$Update$affecter,
			feuille,
			function () {
				if (!choix.$) {
					var domaine = choix.a;
					var type_ = choix.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(domaine, type_));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}(),
			model);
		var change = _v1.a;
		var effets = _v1.b;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Basics$append(effets),
			A2($author$project$Components$Imports$Outil$Update$versLeDrawerDeCible, $author$project$Components$Shared$Drawer$Update$Fermer, change));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Imports$Outil$Model$cibleProposee = function (part) {
	return _Utils_eq(part.vf, $elm$core$Maybe$Nothing) ? part.e5 : $elm$core$Maybe$Nothing;
};
var $author$project$Components$Imports$Outil$Model$cleDesAdmises = F2(
	function (part, champ) {
		return A2(
			$elm$core$Maybe$withDefault,
			champ,
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var domaine = _v0.a;
					var type_ = _v0.b;
					return A2($author$project$Components$Imports$Outil$Model$cleDeCible, domaine, type_) + ('/' + champ);
				},
				part.vf));
	});
var $author$project$Components$Imports$Outil$Model$colonneDeRepartitionProposee = function (enTetes) {
	return A2(
		$elm$core$Maybe$map,
		$elm$core$Tuple$first,
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var entete = _v0.b;
					return A2(
						$elm$core$List$member,
						$elm$core$String$toLower(
							$elm$core$String$trim(entete)),
						_List_fromArray(
							['type', 'famille']));
				},
				A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, enTetes))));
};
var $author$project$Components$Imports$Outil$Model$EtapeSimulation = 5;
var $author$project$Components$Imports$Outil$Update$estUnGesteDeLigne = function (commande) {
	switch (commande.$) {
		case 3:
			return true;
		case 4:
			return true;
		case 5:
			return true;
		case 6:
			return true;
		case 7:
			return true;
		default:
			return false;
	}
};
var $author$project$API$NavLinksDictionary$lot = 'lot';
var $author$project$Components$Imports$Outil$Update$orElse = F2(
	function (defaut, valeur) {
		if (!valeur.$) {
			return valeur;
		} else {
			return defaut;
		}
	});
var $author$project$API$NavLinksDictionary$rapportDuLot = 'rapport-du-lot';
var $author$project$Components$Imports$Outil$Update$relireSiVuesEnRetard = F2(
	function (vuesAJour, effets) {
		return vuesAJour ? effets : _Utils_ap(
			effets,
			_List_fromArray(
				[
					$author$project$Components$Imports$Outil$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
				]));
	});
var $author$project$API$NavLinksDictionary$simulationDuLot = 'simulation-du-lot';
var $author$project$API$NavLinksDictionary$suiviDuTraitement = 'suivi-du-traitement';
var $author$project$Components$Imports$Outil$Model$saisieDuModele = function (model) {
	return $elm$core$String$trim(model.g6) !== '';
};
var $author$project$Components$Imports$Outil$Update$versLeDrawerDuModele = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{lt: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Imports$Outil$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Imports$Outil$Model$saisieDuModele(model)
				},
				geste,
				model.lt));
	});
var $author$project$Components$Imports$Outil$Update$versLeDrawerDuRejeu = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{lv: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Imports$Outil$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.lv));
	});
var $author$project$Components$Imports$Outil$Update$conclure = F2(
	function (issue, model) {
		switch (issue.$) {
			case 0:
				switch (issue.a.$) {
					case 0:
						var _v1 = issue.a;
						var rendue = issue.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									mb: 0,
									me: 4,
									nN: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$lot, rendue.nQ),
									n0: $elm$core$Maybe$Nothing,
									pZ: $elm$core$Maybe$Nothing
								}),
							A2(
								$author$project$Components$Imports$Outil$Update$relireSiVuesEnRetard,
								rendue.sy,
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$LireLeLot, $elm$core$List$singleton),
										A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$lot, rendue.nQ)))));
					case 1:
						var rendue = issue.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									bB: $elm$core$Maybe$Nothing,
									ma: 0,
									me: 5,
									nF: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$simulationDuLot, rendue.nQ),
									pK: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rapportDuLot, rendue.nQ),
									pZ: $elm$core$Maybe$Nothing,
									rb: rendue.v_
								}),
							A2(
								$author$project$Components$Imports$Outil$Update$relireSiVuesEnRetard,
								rendue.sy,
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$LireLaSimulation, $elm$core$List$singleton),
										A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$simulationDuLot, rendue.nQ)))));
					case 2:
						var rendue = issue.b;
						var suivi = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$suiviDuTraitement, rendue.nQ);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									ua: $elm$core$Maybe$Nothing,
									uq: rendue.v_,
									me: 6,
									nN: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$lot, rendue.nQ),
									pK: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rapportDuLot, rendue.nQ),
									pZ: $elm$core$Maybe$Nothing,
									rr: suivi
								}),
							A2(
								$author$project$Components$Imports$Outil$Update$relireSiVuesEnRetard,
								rendue.sy,
								_Utils_ap(
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$LireLeSuivi, $elm$core$List$singleton),
											suivi)),
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$LireLeLot, $elm$core$List$singleton),
											A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$lot, rendue.nQ))))));
					case 8:
						var rendue = issue.b;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(
								rendue.sy ? A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$Lire, $elm$core$List$singleton),
										model.np)) : _List_fromArray(
									[
										$author$project$Components$Imports$Outil$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
									])),
							A2(
								$author$project$Components$Imports$Outil$Update$versLeDrawerDuModele,
								$author$project$Components$Shared$Drawer$Update$Fermer,
								_Utils_update(
									model,
									{lZ: true, pZ: $elm$core$Maybe$Nothing})));
					case 3:
						var _v2 = issue.a;
						var part = _v2.b;
						var ligne = _v2.c;
						var rendue = issue.b;
						return _Utils_Tuple2(
							A2(
								$author$project$Components$Imports$Outil$Update$avecLesLignes,
								function (l) {
									return _Utils_update(
										l,
										{
											pZ: A2(
												$elm$core$Dict$remove,
												_Utils_Tuple2(part, ligne),
												l.pZ),
											c7: A2(
												$elm$core$Dict$remove,
												_Utils_Tuple2(part, ligne),
												l.c7)
										});
								},
								model),
							A2(
								$author$project$Components$Imports$Outil$Update$relireSiVuesEnRetard,
								rendue.sy,
								$author$project$Components$Imports$Outil$Update$relireLesLignes(model)));
					case 4:
						var _v3 = issue.a;
						var rendue = issue.b;
						return _Utils_Tuple2(
							model,
							A2(
								$author$project$Components$Imports$Outil$Update$relireSiVuesEnRetard,
								rendue.sy,
								$author$project$Components$Imports$Outil$Update$relireLesLignes(model)));
					case 5:
						var _v4 = issue.a;
						var rendue = issue.b;
						return _Utils_Tuple2(
							model,
							A2(
								$author$project$Components$Imports$Outil$Update$relireSiVuesEnRetard,
								rendue.sy,
								$author$project$Components$Imports$Outil$Update$relireLesLignes(model)));
					case 6:
						var _v5 = issue.a;
						var rendue = issue.b;
						return _Utils_Tuple2(
							model,
							A2(
								$author$project$Components$Imports$Outil$Update$relireSiVuesEnRetard,
								rendue.sy,
								$author$project$Components$Imports$Outil$Update$relireLesLignes(model)));
					default:
						var rendue = issue.b;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(
								A2(
									$author$project$Components$Imports$Outil$Update$relireSiVuesEnRetard,
									rendue.sy,
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$LireLeLot, $elm$core$List$singleton),
											model.nN)))),
							A2(
								$author$project$Components$Imports$Outil$Update$versLeDrawerDuRejeu,
								$author$project$Components$Shared$Drawer$Update$Fermer,
								_Utils_update(
									model,
									{
										uq: A2($author$project$Components$Imports$Outil$Update$orElse, model.uq, rendue.v_),
										mb: 0,
										gV: $elm$core$Maybe$Nothing
									})));
				}
			case 1:
				if ((issue.a.$ === 3) && (issue.c.$ === 11)) {
					var _v6 = issue.a;
					var part = _v6.b;
					var ligne = _v6.c;
					var code = issue.c.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Imports$Outil$Update$avecLesLignes,
							function (l) {
								return _Utils_update(
									l,
									{
										pZ: A3(
											$elm$core$Dict$insert,
											_Utils_Tuple2(part, ligne),
											code,
											l.pZ)
									});
							},
							model),
						_List_Nil);
				} else {
					var commande = issue.a;
					var erreur = issue.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								pZ: $elm$core$Maybe$Just(erreur)
							}),
						$author$project$Components$Imports$Outil$Update$estUnGesteDeLigne(commande) ? $author$project$Components$Imports$Outil$Update$relireLesLignes(model) : _List_Nil);
				}
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$corrigerUneLigne = 'corriger-une-ligne';
var $author$project$Components$Imports$Outil$Model$dejaRetenues = F2(
	function (part, index) {
		return A2($author$project$Components$Imports$Outil$Model$reglesDe, part, index).Ki;
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$CibleDeSimulation = F6(
	function (libelle, creees, modifiees, sansChangement, doublonsPossibles, erreurs) {
		return {wo: creees, kW: doublonsPossibles, gp: erreurs, Bl: libelle, CP: modifiees, qY: sansChangement};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$Detail = F7(
	function (analyseeEnMs, erreurs, erreursTotales, doublons, parCible, lignes, lignesTotales) {
		return {tg: analyseeEnMs, xM: doublons, gp: erreurs, yx: erreursTotales, gV: lignes, BT: lignesTotales, EN: parCible};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$DoublonPossible = F4(
	function (ligne, dansLeFichier, nomFicheExistante, raisons) {
		return {ws: dansLeFichier, ea: ligne, Dq: nomFicheExistante, GT: raisons};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$FicheDeLigne = F3(
	function (nature, nom, creee) {
		return {wm: creee, g1: nature, Dj: nom};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$LigneDuFichier = F7(
	function (part, de, a, issue, colonne, erreur, fiches) {
		return {sD: a, j_: colonne, wC: de, go: erreur, zu: fiches, nh: issue, o9: part};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$LigneEnErreur = F6(
	function (ligne, colonne, valeur, erreur, reference, ligneDOrigine) {
		return {j_: colonne, go: erreur, ea: ligne, BS: ligneDOrigine, Hc: reference, fm: valeur};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$detailDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'lignesTotales',
	$elm$json$Json$Decode$int,
	0,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'lignes',
		$elm$json$Json$Decode$list(
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'fiches',
				$elm$json$Json$Decode$list(
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'creee',
						$elm$json$Json$Decode$bool,
						false,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'nom',
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'nature',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$FicheDeLigne))))),
				_List_Nil,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'erreur',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'colonne',
						$elm$json$Json$Decode$string,
						'',
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'issue',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'a',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'de',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'part',
										$elm$json$Json$Decode$int,
										$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$LigneDuFichier))))))))),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'parCible',
			$elm$json$Json$Decode$list(
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'erreurs',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'doublonsPossibles',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'sansChangement',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'modifiees',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'creees',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'libelle',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$CibleDeSimulation)))))))),
			_List_Nil,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'doublons',
				$elm$json$Json$Decode$list(
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'raisons',
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'nomFicheExistante',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'dansLeFichier',
								A2(
									$elm$json$Json$Decode$map,
									$elm$core$Maybe$withDefault(''),
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
								'',
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'ligne',
									$elm$json$Json$Decode$int,
									$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$DoublonPossible)))))),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'erreursTotales',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'erreurs',
						$elm$json$Json$Decode$list(
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'ligneDOrigine',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'cleDeLaLigne',
									$elm$json$Json$Decode$string,
									'',
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'erreur',
										$elm$json$Json$Decode$string,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'valeur',
											A2(
												$elm$json$Json$Decode$map,
												$elm$core$Maybe$withDefault(''),
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
											'',
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'colonne',
												A2(
													$elm$json$Json$Decode$map,
													$elm$core$Maybe$withDefault(''),
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
												'',
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'ligne',
													$elm$json$Json$Decode$int,
													$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$LigneEnErreur)))))))),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'analyseeEnMs',
							$elm$json$Json$Decode$int,
							$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$Detail))))))));
var $author$project$Components$Imports$Outil$API$WriteAPIModel$EnregistrerUnModele = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Imports$Outil$Model$colonnesDeModele = function (part) {
	return A2(
		$elm$core$List$filterMap,
		function (_v0) {
			var index = _v0.a;
			var champ = _v0.b;
			return A2(
				$elm$core$Maybe$map,
				function (entete) {
					return {
						uN: champ,
						l0: entete,
						hJ: A2($author$project$Components$Imports$Outil$Model$reglesDe, part, index)
					};
				},
				$elm$core$List$head(
					A2($elm$core$List$drop, index, part.ym)));
		},
		$elm$core$Dict$toList(part.j1));
};
var $author$project$API$NavLinksDictionary$enregistrerUnModele = 'enregistrer-un-modele';
var $author$project$Components$Imports$Outil$Update$Envoyer = F3(
	function (a, b, c) {
		return {$: 19, a: a, b: b, c: c};
	});
var $author$project$Components$Imports$Outil$API$WriteAPIModel$Rendue = F3(
	function (vuesAJour, liens, comptes) {
		return {v_: comptes, nQ: liens, sy: vuesAJour};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$Comptes = F6(
	function (creees, modifiees, sansChangement, doublonsPossibles, erreurs, effacees) {
		return {wo: creees, kW: doublonsPossibles, x8: effacees, gp: erreurs, CP: modifiees, qY: sansChangement};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$comptesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'effacees',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'erreurs',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'doublonsPossibles',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'sansChangement',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'modifiees',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'creees',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$Comptes)))))));
var $author$project$Components$Imports$Outil$API$WriteAPIModel$comptesDeLEvenement = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$Just,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['LotSimule', 'comptes']),
				$author$project$Components$Imports$Outil$API$QueryAPIModel$comptesDecoder)),
			A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$Just,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['LotApplique', 'comptes']),
				$author$project$Components$Imports$Outil$API$QueryAPIModel$comptesDecoder)),
			A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$Just,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['LignesRejouees', 'comptes']),
				$author$project$Components$Imports$Outil$API$QueryAPIModel$comptesDecoder)),
			$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
		]));
var $author$project$Components$Imports$Outil$API$WriteAPIModel$rendueDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'evenements',
	A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$filterMap($elm$core$Basics$identity),
			$elm$core$List$head),
		$elm$json$Json$Decode$list(
			A2($elm$json$Json$Decode$field, 'event', $author$project$Components$Imports$Outil$API$WriteAPIModel$comptesDeLEvenement))),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'liens',
		A2(
			$elm$json$Json$Decode$map,
			function ($) {
				return $.h0;
			},
			$author$project$API$Liens$decoder),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'vuesAJour',
			$elm$json$Json$Decode$bool,
			true,
			$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$WriteAPIModel$Rendue))));
var $author$project$Components$Imports$Outil$Update$reglage = {
	f8: $author$project$Components$Imports$Outil$Update$DemanderProcessUid,
	l4: $author$project$Components$Imports$Outil$Update$Envoyer,
	go: $author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$duRefus,
	pW: $author$project$Components$Imports$Outil$Update$Reconnecter,
	qu: F2(
		function (_v0, _v1) {
			return true;
		}),
	qv: $author$project$Components$Imports$Outil$API$WriteAPIModel$rendueDecoder
};
var $author$project$Components$Imports$Outil$Update$envoyer = F3(
	function (lien, commande, model) {
		var _v0 = A4($author$project$API$Envoi$partir, $author$project$Components$Imports$Outil$Update$reglage, lien, commande, model.l2);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var envoi = _v1.a;
			var effets = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi, pZ: $elm$core$Maybe$Nothing}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Imports$Outil$Model$feuilleOuverte = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		function (nom) {
			return $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (part) {
						return _Utils_eq(part.mx, nom);
					},
					model.pb));
		},
		model.Et);
};
var $author$project$Components$Imports$Outil$Update$enregistrerLeModele = function (model) {
	var _v0 = _Utils_Tuple2(
		$author$project$Components$Imports$Outil$Model$feuilleOuverte(model),
		$author$project$Components$Imports$Outil$Model$saisieDuModele(model));
	if ((!_v0.a.$) && _v0.b) {
		var part = _v0.a.a;
		var _v1 = part.vf;
		if (!_v1.$) {
			var _v2 = _v1.a;
			var domaine = _v2.a;
			var type_ = _v2.b;
			return A3(
				$author$project$Components$Imports$Outil$Update$envoyer,
				A2($author$project$Components$Imports$Outil$Model$lienDe, $author$project$API$NavLinksDictionary$enregistrerUnModele, model),
				$author$project$Components$Imports$Outil$API$WriteAPIModel$EnregistrerUnModele(
					{
						j1: $author$project$Components$Imports$Outil$Model$colonnesDeModele(part),
						cC: domaine,
						Dj: $elm$core$String$trim(model.g6),
						r0: type_
					}),
				model);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Imports$Outil$Update$lienDeLaListeDe = F2(
	function (rel, lignes) {
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				$author$project$API$Liens$trouver(rel)),
			lignes.nW);
	});
var $author$project$Components$Imports$Outil$Update$gesteSurUneLigne = F3(
	function (rel, commande, model) {
		var _v0 = _Utils_Tuple2(
			model.n0,
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Components$Imports$Outil$Update$lienDeLaListeDe(rel),
				model.gV));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var lot = _v0.a.a;
			var lien = _v0.b.a;
			return A3(
				$author$project$Components$Imports$Outil$Update$envoyer,
				$elm$core$Maybe$Just(lien),
				commande(lot.Aq),
				model);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$LigneDHistorique = function (id) {
	return function (date) {
		return function (fichier) {
			return function (source) {
				return function (auteur) {
					return function (auteurNom) {
						return function (cibles) {
							return function (comptes) {
								return function (etat) {
									return function (avancement) {
										return function (liens) {
											return {t1: auteur, ja: auteurNom, ua: avancement, jS: cibles, v_: comptes, wv: date, gt: etat, gw: fichier, Aq: id, nQ: liens, IR: source};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Imports$Outil$API$QueryAPIModel$historiqueDecoder = A2(
	$elm$json$Json$Decode$field,
	'imports',
	$elm$json$Json$Decode$list(
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2(
				$elm$json$Json$Decode$map,
				function ($) {
					return $.h0;
				},
				$author$project$API$Liens$deLaRessource),
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'avancement',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'etat',
					$elm$json$Json$Decode$string,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						$author$project$Components$Imports$Outil$API$QueryAPIModel$comptesDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'cibles',
							$elm$json$Json$Decode$list(
								A3(
									$elm$json$Json$Decode$map2,
									$elm$core$Tuple$pair,
									A2($elm$json$Json$Decode$field, 'domaine', $elm$json$Json$Decode$string),
									A2(
										$elm$json$Json$Decode$map,
										$elm$core$Maybe$withDefault(''),
										A2(
											$elm$json$Json$Decode$field,
											'type',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string))))),
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'auteurNom',
								$elm$json$Json$Decode$string,
								'',
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'auteur',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'source',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'fichier',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'date',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'id',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$LigneDHistorique))))))))))))));
var $author$project$API$NavLinksDictionary$ignorerUneLigne = 'ignorer-une-ligne';
var $author$project$API$NavLinksDictionary$imports = 'imports';
var $author$project$Components$Imports$Outil$Update$init = $author$project$Components$Imports$Outil$Model$init;
var $author$project$Components$Imports$Outil$API$QueryAPIModel$LigneLue = F4(
	function (ligne, lu, converti, erreur) {
		return {kb: converti, go: erreur, ea: ligne, B0: lu};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$lectureDecoder = A2(
	$elm$json$Json$Decode$field,
	'lignes',
	$elm$json$Json$Decode$list(
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'erreur',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'converti',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'lu',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'ligne',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$LigneLue)))))));
var $author$project$Components$Imports$Outil$Update$LireLesOffres = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Imports$Outil$Update$LireLesRoles = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Imports$Outil$Model$cibleDe = F2(
	function (part, model) {
		var _v0 = _Utils_Tuple2(part.vf, model.cN);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var _v1 = _v0.a.a;
			var domaine = _v1.a;
			var type_ = _v1.b;
			var imports = _v0.b.a;
			return $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (cible) {
						return _Utils_eq(cible.cC, domaine) && _Utils_eq(cible.r0, type_);
					},
					imports.jS));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Imports$Outil$Update$lesChoixDesReglages = F2(
	function (part, model) {
		var cible = A2(
			$elm$core$Maybe$andThen,
			function (p) {
				return A2($author$project$Components$Imports$Outil$Model$cibleDe, p, model);
			},
			part);
		return _Utils_ap(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (p) {
						return A2(
							$elm$core$List$filterMap,
							function (cle) {
								return A2(
									$elm$core$Maybe$andThen,
									function (lien) {
										return A2(
											$elm$core$Dict$member,
											A2($author$project$Components$Imports$Outil$Model$cleDesAdmises, p, cle),
											model.fu) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
											A2(
												$author$project$Components$Imports$Outil$Update$LireLesAdmises,
												A2($author$project$Components$Imports$Outil$Model$cleDesAdmises, p, cle),
												lien));
									},
									(cle === 'forme') ? A2(
										$elm$core$Maybe$andThen,
										function ($) {
											return $.BE;
										},
										cible) : A2(
										$elm$core$Maybe$andThen,
										function ($) {
											return $.BK;
										},
										$elm$core$List$head(
											A2(
												$elm$core$List$filter,
												function (champ) {
													return _Utils_eq(champ.dy, cle);
												},
												A2($author$project$Components$Imports$Outil$Model$champsDe, p, model)))));
							},
							_List_fromArray(
								['pays', 'forme']));
					},
					part)),
			_Utils_ap(
				_Utils_eq(model.ie, $elm$core$Maybe$Nothing) ? A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$LireLesRoles, $elm$core$List$singleton),
						A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.BJ;
							},
							cible))) : _List_Nil,
				_Utils_eq(model.oX, $elm$core$Maybe$Nothing) ? A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$LireLesOffres, $elm$core$List$singleton),
						A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.BG;
							},
							cible))) : _List_Nil));
	});
var $author$project$Components$Imports$Outil$Update$LireLesValeurs = F4(
	function (a, b, c, d) {
		return {$: 9, a: a, b: b, c: c, d: d};
	});
var $author$project$API$NavLinksDictionary$valeursDuFichier = 'valeurs-du-fichier';
var $author$project$Components$Imports$Outil$Update$lesValeurs = F3(
	function (model, destination, demande) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$Components$Imports$Outil$Model$lienDe, $author$project$API$NavLinksDictionary$valeursDuFichier, model),
			model.gw);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var lien = _v0.a.a;
			var fichier = _v0.b.a;
			return _List_fromArray(
				[
					A4($author$project$Components$Imports$Outil$Update$LireLesValeurs, lien, fichier, destination, demande)
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$API$NavLinksDictionary$historiqueDesImports = 'historique-des-imports';
var $author$project$Components$Imports$Outil$Model$requeteDeLHistorique = function (model) {
	return A2(
		$elm$core$String$join,
		'&',
		A2(
			$elm$core$List$map,
			function (_v1) {
				var nom = _v1.a;
				var valeur = _v1.b;
				return nom + ('=' + valeur);
			},
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var valeur = _v0.b;
					return valeur !== '';
				},
				_List_fromArray(
					[
						_Utils_Tuple2('cible', model.gy),
						_Utils_Tuple2('resultat', model.gz),
						_Utils_Tuple2('auteur', model.gx)
					]))));
};
var $author$project$Components$Imports$Outil$Model$lienDeLHistorique = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function (lien) {
			var _v0 = $author$project$Components$Imports$Outil$Model$requeteDeLHistorique(model);
			if (_v0 === '') {
				return lien;
			} else {
				var requete = _v0;
				return _Utils_update(
					lien,
					{cM: lien.cM + ('?' + requete)});
			}
		},
		A2($author$project$Components$Imports$Outil$Model$lienDe, $author$project$API$NavLinksDictionary$historiqueDesImports, model));
};
var $author$project$API$NavLinksDictionary$lignesRejetees = 'lignes-rejetees';
var $author$project$Components$Imports$Outil$Update$maxEssaisDeLecture = 10;
var $author$project$Components$Imports$Outil$Update$lignesRejeteesAttendues = F2(
	function (model, lot) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (comptes) {
					return comptes.gp > 0;
				},
				model.uq)) && (_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$lignesRejetees, lot.nQ),
			$elm$core$Maybe$Nothing) && (_Utils_cmp(model.mb, $author$project$Components$Imports$Outil$Update$maxEssaisDeLecture) < 0));
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$LignesRejetees = F9(
	function (filtre, page, taille, total, aCorriger, pretes, ignorees, lignes, liens) {
		return {sE: aCorriger, zH: filtre, Aw: ignorees, nQ: liens, gV: lignes, EE: page, Gj: pretes, Jm: taille, JE: total};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$LigneRejetee = function (part) {
	return function (ligne) {
		return function (colonne) {
			return function (valeur) {
				return function (erreur) {
					return function (issue) {
						return function (correction) {
							return function (aussiCorrigeeSur) {
								return function (licencie) {
									return function (jour) {
										return function (mois) {
											return {t0: aussiCorrigeeSur, j_: colonne, wf: correction, go: erreur, nh: issue, A_: jour, Bv: licencie, ea: ligne, CQ: mois, o9: part, fm: valeur};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Imports$Outil$API$QueryAPIModel$ligneRejeteeDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'mois',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$int),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'jour',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'licencie',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'aussiCorrigeeSur',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$int),
				_List_Nil,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'correction',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'issue',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'erreur',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'valeur',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'colonne',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'ligne',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'part',
											$elm$json$Json$Decode$int,
											$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$LigneRejetee))))))))))));
var $author$project$Components$Imports$Outil$API$QueryAPIModel$lignesRejeteesDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'_links',
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$decoder),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'lignes',
		$elm$json$Json$Decode$list($author$project$Components$Imports$Outil$API$QueryAPIModel$ligneRejeteeDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'ignorees',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'pretes',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'aCorriger',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'total',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'taille',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'page',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'filtre',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$LignesRejetees))))))))));
var $author$project$Components$Imports$Outil$Update$LireLaLecture = F3(
	function (a, b, c) {
		return {$: 11, a: a, b: b, c: c};
	});
var $author$project$API$NavLinksDictionary$lectureDeLaColonne = 'lecture-de-la-colonne';
var $author$project$Components$Imports$Outil$Update$lireLaColonne = F2(
	function (model, regles) {
		var _v0 = _Utils_Tuple3(
			A2($author$project$Components$Imports$Outil$Model$lienDe, $author$project$API$NavLinksDictionary$lectureDeLaColonne, model),
			model.gw,
			A3(
				$elm$core$Maybe$map2,
				$elm$core$Tuple$pair,
				$author$project$Components$Imports$Outil$Model$feuilleOuverte(model),
				model.j0));
		if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
			var lien = _v0.a.a;
			var fichier = _v0.b.a;
			var _v1 = _v0.c.a;
			var part = _v1.a;
			var index = _v1.b;
			return _Utils_eq(
				model.qf,
				$elm$core$Maybe$Just(3)) ? _List_Nil : _List_fromArray(
				[
					A3(
					$author$project$Components$Imports$Outil$Update$LireLaLecture,
					lien,
					fichier,
					{
						uN: A2($elm$core$Dict$get, index, part.j1),
						vf: part.vf,
						j_: index,
						mx: (part.IR === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(part.IR),
						zQ: regles.zQ,
						nn: regles.nn,
						IG: regles.IG,
						IH: regles.IH,
						Ka: regles.Ka
					})
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$Lot = F8(
	function (id, nom, octets, parts, dejaImporte, lancePar, lanceLe, liens) {
		return {w$: dejaImporte, Aq: id, A7: lanceLe, A8: lancePar, nQ: liens, Dj: nom, oW: octets, pb: parts};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$PartDuLot = F6(
	function (cle, nombreDeLignes, domaine, type_, nombreDeColonnes, siExiste) {
		return {dy: cle, cC: domaine, Dx: nombreDeColonnes, g9: nombreDeLignes, IM: siExiste, r0: type_};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$partDuLotDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'siExiste',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'colonnes',
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$List$length,
			$elm$json$Json$Decode$list($elm$json$Json$Decode$value)),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'type',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'domaine',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'nombreDeLignes',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'cle',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$PartDuLot)))))));
var $author$project$Components$Imports$Outil$API$QueryAPIModel$lotDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'_links',
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$decoder),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'lanceLe',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'lancePar',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'dejaImporte',
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$Just,
					A2($elm$json$Json$Decode$field, 'le', $elm$json$Json$Decode$string)),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'parts',
					$elm$json$Json$Decode$list($author$project$Components$Imports$Outil$API$QueryAPIModel$partDuLotDecoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'octets',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'nom',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$Lot)))))))));
var $author$project$Components$Imports$Outil$API$QueryAPIModel$LotEnPreparation = F6(
	function (id, nom, octets, prepareLe, parts, lien) {
		return {Aq: id, nB: lien, Dj: nom, oW: octets, pb: parts, Gh: prepareLe};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$PartEnPreparation = F5(
	function (cle, feuille, domaine, type_, nombreDeLignes) {
		return {dy: cle, cC: domaine, mx: feuille, g9: nombreDeLignes, r0: type_};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$lotsEnPreparationDecoder = A2(
	$elm$json$Json$Decode$field,
	'lots',
	$elm$json$Json$Decode$list(
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2(
				$elm$json$Json$Decode$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.h0;
					},
					$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$lot)),
				$author$project$API$Liens$deLaRessource),
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'parts',
				$elm$json$Json$Decode$list(
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'nombreDeLignes',
						$elm$json$Json$Decode$int,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'type',
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'domaine',
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'feuille',
									A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
									$elm$core$Maybe$Nothing,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'cle',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$PartEnPreparation))))))),
				_List_Nil,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'prepareLe',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'octets',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'nom',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$LotEnPreparation)))))))));
var $author$project$Components$Imports$Outil$Update$LireLesLots = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Imports$Outil$API$QueryAPIModel$Imports = F3(
	function (cibles, modeles, liens) {
		return {jS: cibles, nQ: liens, CI: modeles};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$Cible = function (domaine) {
	return function (type_) {
		return function (libelle) {
			return function (natures) {
				return function (permise) {
					return function (raison) {
						return function (lienDesChamps) {
							return function (lienDesRoles) {
								return function (lienDesOffres) {
									return function (lienDesFormes) {
										return {cC: domaine, Bl: libelle, BD: lienDesChamps, BE: lienDesFormes, BG: lienDesOffres, BJ: lienDesRoles, oo: natures, Fc: permise, pH: raison, r0: type_};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$API$NavLinksDictionary$formesPossibles = 'formes-possibles';
var $author$project$API$NavLinksDictionary$offresPossibles = 'offres-possibles';
var $author$project$API$NavLinksDictionary$rolesPossibles = 'roles-possibles';
var $author$project$Components$Imports$Outil$API$QueryAPIModel$cibleDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.h0;
			},
			$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$formesPossibles)),
		$author$project$API$Liens$deLaRessource),
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		A2(
			$elm$json$Json$Decode$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.h0;
				},
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$offresPossibles)),
			$author$project$API$Liens$deLaRessource),
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2(
				$elm$json$Json$Decode$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.h0;
					},
					$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$rolesPossibles)),
				$author$project$API$Liens$deLaRessource),
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A2(
					$elm$json$Json$Decode$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.h0;
						},
						$author$project$API$Liens$trouver('champs-de-la-cible')),
					$author$project$API$Liens$deLaRessource),
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'raison',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'permise',
						$elm$json$Json$Decode$bool,
						true,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'natures',
							$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
							_List_Nil,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'libelle',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'type',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'domaine',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$Cible)))))))))));
var $author$project$Components$Imports$Outil$API$QueryAPIModel$ColonneDeModele = F3(
	function (entete, champ, regles) {
		return {uN: champ, l0: entete, hJ: regles};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$Modele = F8(
	function (id, nom, domaine, type_, auteurNom, enregistreLe, colonnes, liens) {
		return {ja: auteurNom, j1: colonnes, cC: domaine, yr: enregistreLe, Aq: id, nQ: liens, Dj: nom, r0: type_};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$Regles = F7(
	function (formatDeDate, separateurDecimal, separateurDeListe, uniteDeLaColonne, langue, usage, valeurs) {
		return {zQ: formatDeDate, nn: langue, IG: separateurDeListe, IH: separateurDecimal, Ka: uniteDeLaColonne, sd: usage, Ki: valeurs};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$reglesDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'valeurs',
	$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
	$elm$core$Dict$empty,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'usage',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'langue',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'uniteDeLaColonne',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'separateurDeListe',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'separateurDecimal',
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'formatDeDate',
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$Regles))))))));
var $author$project$Components$Imports$Outil$API$QueryAPIModel$modeleDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'colonnes',
		$elm$json$Json$Decode$list(
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'regles',
				$author$project$Components$Imports$Outil$API$QueryAPIModel$reglesDecoder,
				$author$project$Components$Imports$Outil$API$QueryAPIModel$reglesVides,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'champ',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'entete',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$ColonneDeModele))))),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'enregistreLe',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'auteurNom',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'type',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'domaine',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'nom',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$Modele)))))))));
var $author$project$Components$Imports$Outil$API$QueryAPIModel$importsDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'modeles',
		$elm$json$Json$Decode$list($author$project$Components$Imports$Outil$API$QueryAPIModel$modeleDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'cibles',
			$elm$json$Json$Decode$list($author$project$Components$Imports$Outil$API$QueryAPIModel$cibleDecoder),
			$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$Imports))));
var $author$project$API$NavLinksDictionary$lotsEnPreparation = 'lots-en-preparation';
var $author$project$Components$Imports$Outil$Update$pasLue = F2(
	function (refus, model) {
		return _Utils_Tuple2(
			(refus.ri === 403) ? _Utils_update(
				model,
				{gd: false, cN: $elm$core$Maybe$Nothing, qa: true}) : _Utils_update(
				model,
				{gd: true}),
			(refus.ri === 401) ? _List_fromArray(
				[$author$project$Components$Imports$Outil$Update$Reconnecter]) : _List_Nil);
	});
var $author$project$Components$Imports$Outil$Update$lue = F2(
	function (reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Imports$Outil$API$QueryAPIModel$importsDecoder, reponse);
		if (!_v0.$) {
			var imports = _v0.a;
			var lu = _Utils_update(
				model,
				{
					gd: false,
					cN: $elm$core$Maybe$Just(imports),
					qa: false
				});
			return _Utils_Tuple2(
				lu,
				(model.EE === 1) ? A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$LireLHistorique, $elm$core$List$singleton),
						$author$project$Components$Imports$Outil$Model$lienDeLHistorique(lu))) : A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$LireLesLots, $elm$core$List$singleton),
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$lotsEnPreparation, imports.nQ))));
		} else {
			var refus = _v0.a;
			return A2($author$project$Components$Imports$Outil$Update$pasLue, refus, model);
		}
	});
var $author$project$Components$Imports$Outil$Update$modifierLesReglesDe = F3(
	function (model, colonne, transformer) {
		if (!colonne.$) {
			var index = colonne.a;
			return _Utils_update(
				model,
				{
					pb: A2(
						$elm$core$List$map,
						function (part) {
							if (_Utils_eq(
								$elm$core$Maybe$Just(part.mx),
								model.Et)) {
								var nouvelles = transformer(
									A2($author$project$Components$Imports$Outil$Model$reglesDe, part, index));
								return _Utils_update(
									part,
									{
										hJ: _Utils_eq(nouvelles, $author$project$Components$Imports$Outil$API$QueryAPIModel$reglesVides) ? A2($elm$core$Dict$remove, index, part.hJ) : A3($elm$core$Dict$insert, index, nouvelles, part.hJ)
									});
							} else {
								return part;
							}
						},
						model.pb)
				});
		} else {
			return model;
		}
	});
var $author$project$Components$Imports$Outil$Update$modifierLesRegles = F2(
	function (model, transformer) {
		return A3($author$project$Components$Imports$Outil$Update$modifierLesReglesDe, model, model.j0, transformer);
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$OffreProposee = F2(
	function (id, nom) {
		return {Aq: id, Dj: nom};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$offresDecoder = $elm$json$Json$Decode$list(
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'nom',
		$elm$json$Json$Decode$string,
		'',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$OffreProposee))));
var $author$project$Components$Imports$Outil$Model$ChoixCible = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Imports$Outil$Update$oneOf = F2(
	function (premier, second) {
		if (!premier.$) {
			return premier;
		} else {
			return second;
		}
	});
var $author$project$Components$Imports$Outil$Update$ouvrirLeDrawerDeCible = F2(
	function (feuille, model) {
		var deLaSuggestion = A2(
			$elm$core$Maybe$map,
			function (s) {
				return A2($author$project$Components$Imports$Outil$Model$ChoixCible, s.cC, s.r0);
			},
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Components$Imports$Outil$Model$cibleProposee,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (part) {
							return _Utils_eq(part.mx, feuille);
						},
						model.pb))));
		var courant = A2(
			$elm$core$Maybe$map,
			function (_v0) {
				var domaine = _v0.a;
				var type_ = _v0.b;
				return A2($author$project$Components$Imports$Outil$Model$ChoixCible, domaine, type_);
			},
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.vf;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (part) {
							return _Utils_eq(part.mx, feuille);
						},
						model.pb))));
		return A2(
			$author$project$Components$Imports$Outil$Update$versLeDrawerDeCible,
			$author$project$Components$Shared$Drawer$Update$Ouvrir('imports-cible'),
			_Utils_update(
				model,
				{
					jN: A2($author$project$Components$Imports$Outil$Update$oneOf, courant, deLaSuggestion),
					Et: $elm$core$Maybe$Just(feuille),
					pQ: ''
				}));
	});
var $author$project$Components$Imports$Outil$Model$partsAPreparer = function (model) {
	return A2(
		$elm$core$List$filterMap,
		function (part) {
			return A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var domaine = _v0.a;
					var type_ = _v0.b;
					return {
						dy: part.mx,
						j1: A2(
							$elm$core$List$map,
							function (_v1) {
								var index = _v1.a;
								var champ = _v1.b;
								return {
									uN: champ,
									AI: index,
									hJ: A2($author$project$Components$Imports$Outil$Model$reglesDe, part, index)
								};
							},
							$elm$core$Dict$toList(part.j1)),
						cC: domaine,
						mx: (part.IR === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(part.IR),
						nT: 1,
						o5: part.o5,
						qc: part.qc,
						IM: part.IM,
						r0: type_
					};
				},
				part.vf);
		},
		model.pb);
};
var $author$project$Components$Imports$Outil$Update$relireSiEnAttente = F2(
	function (enAttente, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		return enAttente ? _Utils_Tuple2(
			_Utils_update(
				model,
				{mb: model.mb + 1}),
			A2(
				$elm$core$List$cons,
				$author$project$Components$Imports$Outil$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs),
				effets)) : _Utils_Tuple2(model, effets);
	});
var $author$project$Components$Imports$Outil$Update$pasLueOuRelire = F2(
	function (refus, model) {
		return ((refus.ri === 404) && (_Utils_cmp(model.mb, $author$project$Components$Imports$Outil$Update$maxEssaisDeLecture) < 0)) ? A2(
			$author$project$Components$Imports$Outil$Update$relireSiEnAttente,
			true,
			_Utils_Tuple2(model, _List_Nil)) : A2($author$project$Components$Imports$Outil$Update$pasLue, refus, model);
	});
var $author$project$Components$Imports$Outil$Model$uniques = A2(
	$elm$core$List$foldl,
	F2(
		function (x, acc) {
			return A2($elm$core$List$member, x, acc) ? acc : _Utils_ap(
				acc,
				_List_fromArray(
					[x]));
		}),
	_List_Nil);
var $author$project$Components$Imports$Outil$Model$doublons = function (part) {
	var recus = $elm$core$Dict$values(part.j1);
	return $author$project$Components$Imports$Outil$Model$uniques(
		A2(
			$elm$core$List$filter,
			function (champ) {
				return $elm$core$List$length(
					A2(
						$elm$core$List$filter,
						$elm$core$Basics$eq(champ),
						recus)) > 1;
			},
			recus));
};
var $author$project$Components$Imports$Outil$Model$manquants = F2(
	function (part, model) {
		var recus = $elm$core$Dict$values(part.j1);
		return A2(
			$elm$core$List$filter,
			function (champ) {
				return champ.he && (!A2($elm$core$List$member, champ.dy, recus));
			},
			A2($author$project$Components$Imports$Outil$Model$champsDe, part, model));
	});
var $author$project$Components$Imports$Outil$Model$colonnesPretes = F2(
	function (part, model) {
		var _v0 = part.vf;
		if (_v0.$ === 1) {
			return true;
		} else {
			return (!_Utils_eq(
				A2($author$project$Components$Imports$Outil$Model$champsDe, part, model),
				_List_Nil)) && (_Utils_eq(
				A2($author$project$Components$Imports$Outil$Model$manquants, part, model),
				_List_Nil) && (_Utils_eq(
				$author$project$Components$Imports$Outil$Model$doublons(part),
				_List_Nil) && (!$elm$core$Dict$isEmpty(part.j1))));
		}
	});
var $author$project$Components$Imports$Outil$Model$peutPreparer = function (model) {
	var affectees = A2(
		$elm$core$List$filter,
		function (part) {
			return !_Utils_eq(part.vf, $elm$core$Maybe$Nothing);
		},
		model.pb);
	return (!_Utils_eq(affectees, _List_Nil)) && A2(
		$elm$core$List$all,
		function (part) {
			return A2($author$project$Components$Imports$Outil$Model$colonnesPretes, part, model);
		},
		affectees);
};
var $author$project$API$NavLinksDictionary$preparerUnLot = 'preparer-un-lot';
var $author$project$Components$Imports$Outil$Model$valeursDeLaColonne = F3(
	function (feuille, index, model) {
		return A2(
			$elm$core$Maybe$andThen,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Dict$get,
				_Utils_Tuple2(feuille, index),
				model.ii));
	});
var $author$project$Components$Imports$Outil$Update$propositionsDeLaColonne = F3(
	function (feuille, index, model) {
		return $elm$core$Dict$fromList(
			A2(
				$elm$core$List$filterMap,
				function (v) {
					return A2(
						$elm$core$Maybe$map,
						function (code) {
							return _Utils_Tuple2(v.fm, code);
						},
						v.vx);
				},
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$not,
						function ($) {
							return $.mm;
						}),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.Ki;
							},
							A3($author$project$Components$Imports$Outil$Model$valeursDeLaColonne, feuille, index, model))))));
	});
var $author$project$Components$Imports$Outil$Update$propositionsLues = F3(
	function (feuille, reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Imports$Outil$API$QueryAPIModel$apercuDecoder, reponse);
		if (!_v0.$) {
			var apercu = _v0.a;
			var source = A2(
				$elm$core$Maybe$withDefault,
				feuille,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.IR;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (part) {
								return _Utils_eq(part.mx, feuille);
							},
							model.pb))));
			var feuilleLue = $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (f) {
						return _Utils_eq(f.Dj, source);
					},
					apercu.zn));
			var proposees = A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Dict$empty,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Gw;
					},
					feuilleLue));
			var refusees = A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Hi;
					},
					feuilleLue));
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						pb: A2(
							$elm$core$List$map,
							function (part) {
								return _Utils_eq(part.mx, feuille) ? _Utils_update(
									part,
									{
										j1: $elm$core$Dict$isEmpty(part.j1) ? proposees : part.j1,
										wc: A2(
											$elm$core$Maybe$withDefault,
											$elm$core$Dict$empty,
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.wc;
												},
												feuilleLue)),
										Hi: refusees
									}) : part;
							},
							model.pb),
						hw: A2($elm$core$List$cons, feuille, model.hw)
					}),
				_List_Nil);
		} else {
			var refus = _v0.a;
			return A2($author$project$Components$Imports$Outil$Update$pasLue, refus, model);
		}
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$Reapplication = F3(
	function (colonnes, regles, manquantes) {
		return {j1: colonnes, B4: manquantes, hJ: regles};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$reapplicationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'manquantes',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'regles',
		$author$project$Components$Imports$Outil$API$QueryAPIModel$indexees($author$project$Components$Imports$Outil$API$QueryAPIModel$reglesDecoder),
		$elm$core$Dict$empty,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'colonnes',
			$author$project$Components$Imports$Outil$API$QueryAPIModel$indexees($elm$json$Json$Decode$string),
			$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$Reapplication))));
var $author$project$Components$Imports$Outil$Model$reapplique = F3(
	function (feuille, reapplication, model) {
		return _Utils_update(
			model,
			{
				B4: reapplication.B4,
				pb: A2(
					$elm$core$List$map,
					function (part) {
						return _Utils_eq(part.mx, feuille) ? _Utils_update(
							part,
							{
								j1: reapplication.j1,
								hJ: A2(
									$elm$core$Dict$filter,
									F2(
										function (_v0, regles) {
											return !_Utils_eq(regles, $author$project$Components$Imports$Outil$API$QueryAPIModel$reglesVides);
										}),
									reapplication.hJ)
							}) : part;
					},
					model.pb)
			});
	});
var $author$project$API$NavLinksDictionary$reappliquerLeModele = 'reappliquer-le-modele';
var $author$project$Components$Imports$Outil$Model$reglagesRequis = F2(
	function (part, model) {
		var _v0 = A2($author$project$Components$Imports$Outil$Model$cibleDe, part, model);
		if (!_v0.$) {
			var cible = _v0.a;
			if (cible.cC !== 'parties-prenantes') {
				return _List_Nil;
			} else {
				var creeDesOrganisations = !((cible.r0 === 'rattachement') && _Utils_eq(
					part.qc.hi,
					$elm$core$Maybe$Just('erreur')));
				var colonneDe = function (champ) {
					return A2(
						$elm$core$List$member,
						champ,
						$elm$core$Dict$values(part.j1));
				};
				return _Utils_ap(
					A2($elm$core$List$member, 'personne', cible.oo) ? _List_fromArray(
						['base-legale']) : _List_Nil,
					_Utils_ap(
						(A2($elm$core$List$member, 'organisation', cible.oo) && (creeDesOrganisations && (!colonneDe('forme')))) ? _List_fromArray(
							['forme']) : _List_Nil,
						(creeDesOrganisations && (!colonneDe('pays'))) ? _List_fromArray(
							['pays']) : _List_Nil));
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Imports$Outil$Model$reglagesManquants = F2(
	function (part, model) {
		return A2(
			$elm$core$List$filter,
			function (reglage) {
				switch (reglage) {
					case 'base-legale':
						return _Utils_eq(part.qc.fI, $elm$core$Maybe$Nothing);
					case 'forme':
						return _Utils_eq(part.qc.gB, $elm$core$Maybe$Nothing);
					default:
						return _Utils_eq(part.qc.ho, $elm$core$Maybe$Nothing);
				}
			},
			A2($author$project$Components$Imports$Outil$Model$reglagesRequis, part, model));
	});
var $author$project$Components$Imports$Outil$Model$reglagesManquantsEnChoix = F2(
	function (part, model) {
		return A2(
			$author$project$Components$Imports$Outil$Model$reglagesManquants,
			_Utils_update(
				part,
				{qc: model.hG}),
			model);
	});
var $author$project$API$NavLinksDictionary$rejouerLesLignes = 'rejouer-les-lignes';
var $author$project$Components$Imports$Outil$Model$repartir = F3(
	function (colonne, lues, model) {
		var _v0 = $elm$core$List$head(model.pb);
		if (!_v0.$) {
			var base = _v0.a;
			return _Utils_update(
				model,
				{
					fS: $elm$core$Maybe$Just(colonne),
					gW: $elm$core$List$sum(
						A2(
							$elm$core$List$map,
							function ($) {
								return $.gV;
							},
							A2(
								$elm$core$List$filter,
								function (v) {
									return v.fm === '';
								},
								lues.Ki))),
					pb: A2(
						$elm$core$List$map,
						function (v) {
							var cible = A2(
								$elm$core$Maybe$andThen,
								function (c) {
									return c.mm ? $elm$core$Maybe$Just(
										_Utils_Tuple2(c.cC, c.r0)) : $elm$core$Maybe$Nothing;
								},
								v.vf);
							return _Utils_update(
								base,
								{
									vf: cible,
									j1: $elm$core$Dict$empty,
									mx: v.fm,
									g9: v.gV,
									o5: $elm$core$Maybe$Just(colonne),
									qc: $author$project$Components$Imports$Outil$API$WriteAPIModel$reglagesVides,
									hJ: $elm$core$Dict$empty,
									IM: A2(
										$elm$core$Maybe$withDefault,
										'completer',
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $author$project$Components$Imports$Outil$Model$siExisteParDefaut),
											cible)),
									e5: _Utils_eq(cible, $elm$core$Maybe$Nothing) ? v.vf : $elm$core$Maybe$Nothing
								});
						},
						A2(
							$elm$core$List$filter,
							function (v) {
								return v.fm !== '';
							},
							lues.Ki))
				});
		} else {
			return model;
		}
	});
var $author$project$API$NavLinksDictionary$reprendreLeLot = 'reprendre-le-lot';
var $author$project$API$NavLinksDictionary$reprendreUneLigne = 'reprendre-une-ligne';
var $author$project$Components$Imports$Outil$Update$siLibre = F2(
	function (model, geste) {
		return $author$project$API$Envoi$enCours(model.l2) ? _Utils_Tuple2(model, _List_Nil) : geste(model);
	});
var $author$project$API$NavLinksDictionary$simulerLeLot = 'simuler-le-lot';
var $author$project$Components$Imports$Outil$Update$sourceDeLaPremierePart = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		function (part) {
			return (part.IR === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(part.IR);
		},
		$elm$core$List$head(model.pb));
};
var $author$project$Components$Imports$Outil$Update$suggeree = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		function (imports) {
			return A2($author$project$Components$Imports$Outil$Model$cibleSuggeree, model.rm, imports.jS);
		},
		model.cN);
};
var $author$project$Components$Imports$Outil$API$QueryAPIModel$Suivi = F7(
	function (total, traitees, echecs, creees, modifiees, termine, resteEstimeSecondes) {
		return {wo: creees, x2: echecs, CP: modifiees, HT: resteEstimeSecondes, Jt: termine, JE: total, JN: traitees};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$suiviDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'resteEstimeSecondes',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$int),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'etat',
		A2(
			$elm$json$Json$Decode$map,
			function (etat) {
				return etat === 'termine';
			},
			$elm$json$Json$Decode$string),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'modifiees',
			$elm$json$Json$Decode$int,
			0,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'creees',
				$elm$json$Json$Decode$int,
				0,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'echecs',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'traitees',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'total',
							$elm$json$Json$Decode$int,
							$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$Suivi))))))));
var $author$project$Components$Imports$Outil$Model$tousLesRoles = F2(
	function (part, model) {
		var natures = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.oo;
				},
				A2($author$project$Components$Imports$Outil$Model$cibleDe, part, model)));
		return A2(
			$elm$core$List$map,
			function ($) {
				return $.r8;
			},
			A2(
				$elm$core$List$filter,
				function (leType) {
					return A2(
						$elm$core$List$any,
						function (nature) {
							return A2($elm$core$List$member, nature, leType.oo);
						},
						natures);
				},
				A2($elm$core$Maybe$withDefault, _List_Nil, model.ie)));
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$TypeDeRole = F3(
	function (uid, libelle, natures) {
		return {Bl: libelle, oo: natures, r8: uid};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$typesDeRoleDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$filter(
			A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$Basics$not)),
		$elm$core$List$map($elm$core$Tuple$second)),
	A2(
		$elm$json$Json$Decode$field,
		'types',
		$elm$json$Json$Decode$list(
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'archive',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'natures',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'libelles',
						A2($elm$json$Json$Decode$field, 'fr', $elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'uid',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed(
								F4(
									function (uid, libelle, natures, archive) {
										return _Utils_Tuple2(
											archive,
											A3(
												$author$project$Components$Imports$Outil$API$QueryAPIModel$TypeDeRole,
												uid,
												libelle,
												A2($elm$core$List$map, $elm$core$String$toLower, natures)));
									})))))))));
var $author$project$Components$Imports$Outil$API$QueryAPIModel$Valeur = F6(
	function (valeur, lignes, cible, code, libelle, exacte) {
		return {vf: cible, vx: code, mm: exacte, Bl: libelle, gV: lignes, fm: valeur};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$ValeursLues = F2(
	function (valeurs, aFaireCorrespondre) {
		return {sF: aFaireCorrespondre, Ki: valeurs};
	});
var $author$project$Components$Imports$Outil$API$QueryAPIModel$valeursDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'aFaireCorrespondre',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'valeurs',
		$elm$json$Json$Decode$list(
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'exacte',
				$elm$json$Json$Decode$bool,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'libelle',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'code',
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'cible',
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Imports$Outil$API$QueryAPIModel$suggestionDecoder),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'lignes',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'valeur',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$Valeur)))))))),
		$elm$json$Json$Decode$succeed($author$project$Components$Imports$Outil$API$QueryAPIModel$ValeursLues)));
var $author$project$Components$Imports$Outil$Update$valeursLues = F3(
	function (destination, reponse, model) {
		var _v0 = _Utils_Tuple2(
			destination,
			A2($author$project$API$Reponse$lire, $author$project$Components$Imports$Outil$API$QueryAPIModel$valeursDecoder, reponse));
		if (_v0.a.$ === 1) {
			if (!_v0.b.$) {
				var _v2 = _v0.a;
				var feuille = _v2.a;
				var index = _v2.b;
				var lues = _v0.b.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ii: A3(
								$elm$core$Dict$insert,
								_Utils_Tuple2(feuille, index),
								$elm$core$Maybe$Just(lues),
								model.ii)
						}),
					_List_Nil);
			} else {
				var _v3 = _v0.a;
				var feuille = _v3.a;
				var index = _v3.b;
				var refus = _v0.b.a;
				return _Utils_eq(
					$author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$duRefus(reponse),
					$author$project$Components$Imports$Outil$API$WriteAPIErrorsModel$ChampSansValeurs) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ii: A3(
								$elm$core$Dict$insert,
								_Utils_Tuple2(feuille, index),
								$elm$core$Maybe$Nothing,
								model.ii)
						}),
					_List_Nil) : A2($author$project$Components$Imports$Outil$Update$pasLue, refus, model);
			}
		} else {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var lues = _v0.b.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sh: $elm$core$Maybe$Just(lues)
						}),
					_List_Nil);
			} else {
				var _v4 = _v0.a;
				var refus = _v0.b.a;
				return A2($author$project$Components$Imports$Outil$Update$pasLue, refus, model);
			}
		}
	});
var $author$project$Components$Imports$Outil$Model$restantes = F3(
	function (part, index, lues) {
		var retenues = A2($author$project$Components$Imports$Outil$Model$dejaRetenues, part, index);
		return $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (v) {
					return (!v.mm) && (!A2($elm$core$Dict$member, v.fm, retenues));
				},
				lues.Ki));
	});
var $author$project$Components$Imports$Outil$Model$valeursRestantes = function (model) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$concatMap,
			function (part) {
				return A2(
					$elm$core$List$filterMap,
					function (index) {
						return A2(
							$elm$core$Maybe$map,
							A2($author$project$Components$Imports$Outil$Model$restantes, part, index),
							A3($author$project$Components$Imports$Outil$Model$valeursDeLaColonne, part.mx, index, model));
					},
					$elm$core$Dict$keys(part.j1));
			},
			A2(
				$elm$core$List$filter,
				function (part) {
					return !_Utils_eq(part.vf, $elm$core$Maybe$Nothing);
				},
				model.pb)));
};
var $author$project$Components$Imports$Outil$Update$versLeDrawerDApplication = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{k0: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Imports$Outil$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.k0));
	});
var $author$project$Components$Imports$Outil$Update$versLeDrawerDeConfirmation = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{k6: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Imports$Outil$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.k6));
	});
var $author$project$Components$Imports$Outil$Update$versLeDrawerDeLHistorique = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{k9: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Imports$Outil$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.k9));
	});
var $author$project$Components$Imports$Outil$Update$versLeDrawerDeRepartition = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{lf: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Imports$Outil$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.lf));
	});
var $author$project$Components$Imports$Outil$Update$versLeDrawerDesLignes = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{lk: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Imports$Outil$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.lk));
	});
var $author$project$Components$Imports$Outil$Update$versLeDrawerDesReglages = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{ll: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Imports$Outil$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.ll));
	});
var $author$project$Components$Imports$Outil$Update$versLeDrawerDesRegles = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{lm: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Imports$Outil$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.lm));
	});
var $author$project$Components$Imports$Outil$Update$versLeDrawerDesValeurs = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{ln: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Imports$Outil$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.ln));
	});
var $author$project$Components$Imports$Outil$Model$EtapeValeurs = 3;
var $author$project$Components$Imports$Outil$Update$PourUneColonne = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Imports$Outil$Update$versLesValeurs = function (model) {
	return $author$project$Components$Imports$Outil$Model$peutPreparer(model) ? _Utils_Tuple2(
		_Utils_update(
			model,
			{me: 3, pZ: $elm$core$Maybe$Nothing}),
		A2(
			$elm$core$List$concatMap,
			function (part) {
				return A2(
					$elm$core$List$concatMap,
					function (_v1) {
						var index = _v1.a;
						var champ = _v1.b;
						return A3(
							$author$project$Components$Imports$Outil$Update$lesValeurs,
							model,
							A2($author$project$Components$Imports$Outil$Update$PourUneColonne, part.mx, index),
							{
								uN: $elm$core$Maybe$Just(champ),
								vf: part.vf,
								j_: index,
								mx: (part.IR === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(part.IR),
								IF: A2($author$project$Components$Imports$Outil$Model$reglesDe, part, index).IG
							});
					},
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var index = _v0.a;
							return !A2(
								$elm$core$Dict$member,
								_Utils_Tuple2(part.mx, index),
								model.ii);
						},
						$elm$core$Dict$toList(part.j1)));
			},
			A2(
				$elm$core$List$filter,
				function (part) {
					return !_Utils_eq(part.vf, $elm$core$Maybe$Nothing);
				},
				model.pb))) : _Utils_Tuple2(model, _List_Nil);
};
var $author$project$Components$Imports$Outil$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var liens = msg.a;
				var suggestion = msg.b;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$imports, liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							$author$project$Components$Imports$Outil$Update$init,
							{
								np: $elm$core$Maybe$Just(lecture),
								rm: suggestion
							}),
						_List_fromArray(
							[
								$author$project$Components$Imports$Outil$Update$DemanderProcessUid,
								$author$project$Components$Imports$Outil$Update$Lire(lecture)
							]));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							$author$project$Components$Imports$Outil$Update$init,
							{qa: true}),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 2:
				var reponse = msg.a;
				return A2($author$project$Components$Imports$Outil$Update$lue, reponse, model);
			case 46:
				return _Utils_Tuple2(
					model,
					function () {
						if (!_Utils_eq(model.gV, $elm$core$Maybe$Nothing)) {
							return $author$project$Components$Imports$Outil$Update$relireLesLignes(model);
						} else {
							var _v2 = _Utils_Tuple2(model.me, model.rr);
							switch (_v2.a) {
								case 6:
									if (!_v2.b.$) {
										var _v3 = _v2.a;
										var lien = _v2.b.a;
										return _List_fromArray(
											[
												$author$project$Components$Imports$Outil$Update$LireLeSuivi(lien)
											]);
									} else {
										var _v4 = _v2.a;
										var _v5 = _v2.b;
										return A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2(
												$elm$core$Maybe$map,
												A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$LireLeLot, $elm$core$List$singleton),
												model.nN));
									}
								case 5:
									var _v6 = _v2.a;
									return A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$LireLaSimulation, $elm$core$List$singleton),
											model.nF));
								case 4:
									var _v7 = _v2.a;
									return (model.EE === 1) ? A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$LireLHistorique, $elm$core$List$singleton),
											$author$project$Components$Imports$Outil$Model$lienDeLHistorique(model))) : A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$LireLeLot, $elm$core$List$singleton),
											model.nN));
								default:
									return A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$Lire, $elm$core$List$singleton),
											model.np));
							}
						}
					}());
			case 3:
				var cle = msg.a;
				var reponse = msg.b;
				var _v8 = A2($author$project$API$Reponse$lire, $author$project$Components$Imports$Outil$API$QueryAPIModel$champsDecoder, reponse);
				if (!_v8.$) {
					var champs = _v8.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dw: A3($elm$core$Dict$insert, cle, champs, model.dw)
							}),
						_List_Nil);
				} else {
					var refus = _v8.a;
					return A2($author$project$Components$Imports$Outil$Update$pasLue, refus, model);
				}
			case 4:
				var cle = msg.a;
				var reponse = msg.b;
				var _v9 = A2($author$project$API$Reponse$lire, $author$project$Components$Imports$Outil$API$QueryAPIModel$admisesDecoder, reponse);
				if (!_v9.$) {
					var admises = _v9.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								fu: A3($elm$core$Dict$insert, cle, admises, model.fu)
							}),
						_List_Nil);
				} else {
					var refus = _v9.a;
					return A2($author$project$Components$Imports$Outil$Update$pasLue, refus, model);
				}
			case 5:
				var reponse = msg.a;
				var _v10 = A2($author$project$API$Reponse$lire, $author$project$Components$Imports$Outil$API$QueryAPIModel$typesDeRoleDecoder, reponse);
				if (!_v10.$) {
					var types = _v10.a;
					var avec = _Utils_update(
						model,
						{
							ie: $elm$core$Maybe$Just(types)
						});
					return _Utils_Tuple2(
						function () {
							var _v11 = $author$project$Components$Imports$Outil$Model$feuilleOuverte(avec);
							if (!_v11.$) {
								var part = _v11.a;
								return (_Utils_eq(avec.hG.eX, _List_Nil) && _Utils_eq(part.qc.eX, _List_Nil)) ? _Utils_update(
									avec,
									{
										hG: function (r) {
											return _Utils_update(
												r,
												{
													eX: A2($author$project$Components$Imports$Outil$Model$tousLesRoles, part, avec)
												});
										}(avec.hG)
									}) : avec;
							} else {
								return avec;
							}
						}(),
						_List_Nil);
				} else {
					var refus = _v10.a;
					return A2($author$project$Components$Imports$Outil$Update$pasLue, refus, model);
				}
			case 6:
				var reponse = msg.a;
				var _v12 = A2($author$project$API$Reponse$lire, $author$project$Components$Imports$Outil$API$QueryAPIModel$offresDecoder, reponse);
				if (!_v12.$) {
					var offres = _v12.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								oX: $elm$core$Maybe$Just(offres)
							}),
						_List_Nil);
				} else {
					var refus = _v12.a;
					return A2($author$project$Components$Imports$Outil$Update$pasLue, refus, model);
				}
			case 7:
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[$author$project$Components$Imports$Outil$Update$ChoisirUnFichier]));
			case 8:
				var fichier = msg.a;
				var _v13 = A2($author$project$Components$Imports$Outil$Model$lienDe, $author$project$API$NavLinksDictionary$apercuDuFichier, model);
				if (!_v13.$) {
					var lien = _v13.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								tq: $elm$core$Maybe$Nothing,
								gw: $elm$core$Maybe$Just(fichier),
								pb: _List_Nil,
								p8: $elm$core$Maybe$Nothing
							}),
						_List_fromArray(
							[
								A4(
								$author$project$Components$Imports$Outil$Update$Apercevoir,
								lien,
								fichier,
								$author$project$Components$Imports$Outil$Update$suggeree(model),
								$elm$core$Maybe$Nothing)
							]));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 9:
				if (msg.a.$ === 1) {
					var _v14 = msg.a;
					var reponse = msg.b;
					return A2($author$project$Components$Imports$Outil$Update$apercuLu, reponse, model);
				} else {
					var feuille = msg.a.a;
					var reponse = msg.b;
					return A3($author$project$Components$Imports$Outil$Update$propositionsLues, feuille, reponse, model);
				}
			case 10:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{me: 0, pZ: $elm$core$Maybe$Nothing}),
					_List_Nil);
			case 11:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{me: 1, pZ: $elm$core$Maybe$Nothing}),
					_List_Nil);
			case 12:
				return A2(
					$elm$core$List$any,
					function (part) {
						return !_Utils_eq(part.vf, $elm$core$Maybe$Nothing);
					},
					model.pb) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{me: 2, pZ: $elm$core$Maybe$Nothing}),
					_List_Nil) : _Utils_Tuple2(model, _List_Nil);
			case 67:
				return $author$project$Components$Imports$Outil$Update$versLesValeurs(model);
			case 13:
				var feuille = msg.a;
				return A2($author$project$Components$Imports$Outil$Update$ouvrirLeDrawerDeCible, feuille, model);
			case 14:
				var texte = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pQ: texte}),
					_List_Nil);
			case 15:
				var texte = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pU: texte}),
					_List_Nil);
			case 61:
				var feuille = msg.a;
				var _v15 = A2(
					$elm$core$Maybe$andThen,
					$author$project$Components$Imports$Outil$Model$cibleProposee,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (part) {
								return _Utils_eq(part.mx, feuille);
							},
							model.pb)));
				if (!_v15.$) {
					var proposee = _v15.a;
					return A3(
						$author$project$Components$Imports$Outil$Update$affecter,
						feuille,
						$elm$core$Maybe$Just(
							_Utils_Tuple2(proposee.cC, proposee.r0)),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 53:
				var reparti = $elm$core$List$head(
					A2(
						$elm$core$List$filterMap,
						function ($) {
							return $.o5;
						},
						model.pb));
				var proposee = _Utils_eq(reparti, $elm$core$Maybe$Nothing) ? A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.ym;
						},
						$author$project$Components$Imports$Outil$Model$colonneDeRepartitionProposee),
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.zn;
							},
							$elm$core$List$head),
						model.tq)) : $elm$core$Maybe$Nothing;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(
						function () {
							if (!proposee.$) {
								var index = proposee.a;
								return A3(
									$author$project$Components$Imports$Outil$Update$lesValeurs,
									model,
									$author$project$Components$Imports$Outil$Update$PourLaRepartition,
									{
										uN: $elm$core$Maybe$Nothing,
										vf: $elm$core$Maybe$Nothing,
										j_: index,
										mx: $author$project$Components$Imports$Outil$Update$sourceDeLaPremierePart(model),
										IF: $elm$core$Maybe$Nothing
									});
							} else {
								return _List_Nil;
							}
						}()),
					A2(
						$author$project$Components$Imports$Outil$Update$versLeDrawerDeRepartition,
						$author$project$Components$Shared$Drawer$Update$Ouvrir('imports-repartition'),
						_Utils_update(
							model,
							{
								fS: A2(
									$elm$core$Maybe$withDefault,
									reparti,
									A2($elm$core$Maybe$map, $elm$core$Maybe$Just, proposee)),
								sh: $elm$core$Maybe$Nothing
							})));
			case 54:
				var index = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fS: $elm$core$Maybe$Just(index),
							sh: $elm$core$Maybe$Nothing
						}),
					A3(
						$author$project$Components$Imports$Outil$Update$lesValeurs,
						model,
						$author$project$Components$Imports$Outil$Update$PourLaRepartition,
						{
							uN: $elm$core$Maybe$Nothing,
							vf: $elm$core$Maybe$Nothing,
							j_: index,
							mx: $author$project$Components$Imports$Outil$Update$sourceDeLaPremierePart(model),
							IF: $elm$core$Maybe$Nothing
						}));
			case 55:
				var _v17 = _Utils_Tuple2(model.fS, model.sh);
				if ((!_v17.a.$) && (!_v17.b.$)) {
					var colonne = _v17.a.a;
					var lues = _v17.b.a;
					var reparti = A3($author$project$Components$Imports$Outil$Model$repartir, colonne, lues, model);
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(
							$author$project$Components$Imports$Outil$Update$lesChampsEtPropositions(reparti)),
						A2($author$project$Components$Imports$Outil$Update$versLeDrawerDeRepartition, $author$project$Components$Shared$Drawer$Update$Fermer, reparti));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 56:
				var _v18 = _Utils_Tuple2(model.tq, model.cN);
				if ((!_v18.a.$) && (!_v18.b.$)) {
					var apercu = _v18.a.a;
					var imports = _v18.b.a;
					var retire = _Utils_update(
						model,
						{
							fS: $elm$core$Maybe$Nothing,
							gW: 0,
							pb: A3($author$project$Components$Imports$Outil$Model$partsDepuis, apercu, model.rm, imports.jS),
							sh: $elm$core$Maybe$Nothing
						});
					return _Utils_Tuple2(
						retire,
						A2(
							$author$project$Components$Imports$Outil$Update$lesChampsAUne,
							retire,
							A2(
								$elm$core$List$filterMap,
								function ($) {
									return $.vf;
								},
								retire.pb)));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 57:
				var destination = msg.a;
				var reponse = msg.b;
				return A3($author$project$Components$Imports$Outil$Update$valeursLues, destination, reponse, model);
			case 62:
				var feuille = msg.a;
				var index = msg.b;
				var regle = msg.c;
				var actuelles = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Components$Imports$Outil$API$QueryAPIModel$reglesVides,
					A2(
						$elm$core$Maybe$map,
						function (part) {
							return A2($author$project$Components$Imports$Outil$Model$reglesDe, part, index);
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (part) {
									return _Utils_eq(part.mx, feuille);
								},
								model.pb))));
				var ouvert = _Utils_update(
					model,
					{
						fK: A2(
							$elm$core$Dict$get,
							index,
							A2(
								$elm$core$Maybe$withDefault,
								$elm$core$Dict$empty,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.j1;
									},
									$elm$core$List$head(
										A2(
											$elm$core$List$filter,
											function (part) {
												return _Utils_eq(part.mx, feuille);
											},
											model.pb))))),
						j0: $elm$core$Maybe$Just(index),
						nq: $elm$core$Maybe$Nothing,
						Et: $elm$core$Maybe$Just(feuille),
						pZ: $elm$core$Maybe$Nothing,
						qf: $elm$core$Maybe$Just(regle),
						qg: actuelles
					});
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(
						A2($author$project$Components$Imports$Outil$Update$lireLaColonne, ouvert, actuelles)),
					A2(
						$author$project$Components$Imports$Outil$Update$versLeDrawerDesRegles,
						$author$project$Components$Shared$Drawer$Update$Ouvrir('imports-regles'),
						ouvert));
			case 63:
				var regles = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{qg: regles}),
					A2($author$project$Components$Imports$Outil$Update$lireLaColonne, model, regles));
			case 60:
				var reponse = msg.a;
				var _v19 = A2($author$project$API$Reponse$lire, $author$project$Components$Imports$Outil$API$QueryAPIModel$lectureDecoder, reponse);
				if (!_v19.$) {
					var lignes = _v19.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								nq: $elm$core$Maybe$Just(lignes)
							}),
						_List_Nil);
				} else {
					var refus = _v19.a;
					return A2($author$project$Components$Imports$Outil$Update$pasLue, refus, model);
				}
			case 58:
				var reponse = msg.a;
				var _v20 = A2($author$project$API$Reponse$lire, $author$project$Components$Imports$Outil$API$QueryAPIModel$lotsEnPreparationDecoder, reponse);
				if (!_v20.$) {
					var lots = _v20.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								n2: $elm$core$Maybe$Just(lots)
							}),
						_List_Nil);
				} else {
					var refus = _v20.a;
					return A2($author$project$Components$Imports$Outil$Update$pasLue, refus, model);
				}
			case 59:
				var lien = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{me: 4, n0: $elm$core$Maybe$Nothing, pZ: $elm$core$Maybe$Nothing}),
					_List_fromArray(
						[
							$author$project$Components$Imports$Outil$Update$LireLeLot(lien)
						]));
			case 66:
				var feuille = msg.a;
				var index = msg.b;
				var usage = msg.c;
				return _Utils_Tuple2(
					A4($author$project$Components$Imports$Outil$Model$choisirLUsage, feuille, index, usage, model),
					_List_Nil);
			case 65:
				var langue = msg.a;
				var colonne = msg.b;
				return _Utils_Tuple2(
					A3($author$project$Components$Imports$Outil$Model$choisirLaColonneDeLaLangue, langue, colonne, model),
					_List_Nil);
			case 64:
				return A2(
					$author$project$Components$Imports$Outil$Update$versLeDrawerDesRegles,
					$author$project$Components$Shared$Drawer$Update$Fermer,
					_Utils_eq(
						model.qf,
						$elm$core$Maybe$Just(3)) ? model : A2(
						$author$project$Components$Imports$Outil$Update$modifierLesRegles,
						model,
						function (_v21) {
							var saisies = model.qg;
							return _Utils_update(
								saisies,
								{
									Ka: A2(
										$elm$core$Maybe$andThen,
										function (u) {
											return ($elm$core$String$trim(u) === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(u);
										},
										saisies.Ka)
								});
						}));
			case 68:
				var feuille = msg.a;
				var index = msg.b;
				var retenues = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Dict$empty,
					A2(
						$elm$core$Maybe$map,
						function (part) {
							return A2($author$project$Components$Imports$Outil$Model$dejaRetenues, part, index);
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (part) {
									return _Utils_eq(part.mx, feuille);
								},
								model.pb))));
				var lecture = function () {
					var _v22 = $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (part) {
								return _Utils_eq(part.mx, feuille);
							},
							model.pb));
					if (!_v22.$) {
						var part = _v22.a;
						return A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								$elm$core$List$singleton,
								A2(
									$elm$core$Maybe$andThen,
									function (_v23) {
										var cle = _v23.a;
										var lien = _v23.b;
										return A2($elm$core$Dict$member, cle, model.fu) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
											A2($author$project$Components$Imports$Outil$Update$LireLesAdmises, cle, lien));
									},
									A2(
										$elm$core$Maybe$andThen,
										function (champ) {
											return A2(
												$elm$core$Maybe$map,
												function (lien) {
													return _Utils_Tuple2(
														A2($author$project$Components$Imports$Outil$Model$cleDesAdmises, part, champ.dy),
														lien);
												},
												champ.BK);
										},
										A3($author$project$Components$Imports$Outil$Model$champDeLaColonne, part, index, model)))));
					} else {
						return _List_Nil;
					}
				}();
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(lecture),
					A2(
						$author$project$Components$Imports$Outil$Update$versLeDrawerDesValeurs,
						$author$project$Components$Shared$Drawer$Update$Ouvrir('imports-valeurs'),
						_Utils_update(
							model,
							{
								jP: A2(
									$elm$core$Dict$union,
									retenues,
									A3($author$project$Components$Imports$Outil$Update$propositionsDeLaColonne, feuille, index, model)),
								j$: $elm$core$Maybe$Just(index),
								Et: $elm$core$Maybe$Just(feuille)
							})));
			case 69:
				var valeur = msg.a;
				var code = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jP: function () {
								if (!code.$) {
									var c = code.a;
									return A3($elm$core$Dict$insert, valeur, c, model.jP);
								} else {
									return A2($elm$core$Dict$remove, valeur, model.jP);
								}
							}()
						}),
					_List_Nil);
			case 70:
				return A2(
					$author$project$Components$Imports$Outil$Update$versLeDrawerDesValeurs,
					$author$project$Components$Shared$Drawer$Update$Fermer,
					A3(
						$author$project$Components$Imports$Outil$Update$modifierLesReglesDe,
						model,
						model.j$,
						function (regles) {
							return _Utils_update(
								regles,
								{Ki: model.jP});
						}));
			case 16:
				var choix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jN: $elm$core$Maybe$Just(choix)
						}),
					_List_Nil);
			case 17:
				return $author$project$Components$Imports$Outil$Update$cibleEnregistree(model);
			case 18:
				var feuille = msg.a;
				var part = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (p) {
							return _Utils_eq(p.mx, feuille);
						},
						model.pb));
				return A2(
					$elm$core$Tuple$mapSecond,
					function (effets) {
						return _Utils_ap(
							effets,
							A2($author$project$Components$Imports$Outil$Update$lesChoixDesReglages, part, model));
					},
					A2(
						$author$project$Components$Imports$Outil$Update$versLeDrawerDesReglages,
						$author$project$Components$Shared$Drawer$Update$Ouvrir('imports-reglages'),
						_Utils_update(
							model,
							{
								Et: $elm$core$Maybe$Just(feuille),
								hG: A2(
									$elm$core$Maybe$withDefault,
									$author$project$Components$Imports$Outil$API$WriteAPIModel$reglagesVides,
									A2(
										$elm$core$Maybe$map,
										function (p) {
											return _Utils_eq(p.qc.eX, _List_Nil) ? function (r) {
												return _Utils_update(
													r,
													{
														eX: A2($author$project$Components$Imports$Outil$Model$tousLesRoles, p, model)
													});
											}(p.qc) : p.qc;
										},
										part)),
								qe: _List_Nil,
								q9: A2(
									$elm$core$Maybe$withDefault,
									'completer',
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.IM;
										},
										part))
							})));
			case 19:
				var valeur = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{q9: valeur}),
					_List_Nil);
			case 21:
				var valeur = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hG: function (r) {
								return _Utils_update(
									r,
									{
										hy: (valeur === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(valeur)
									});
							}(model.hG)
						}),
					_List_Nil);
			case 23:
				var uid = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hG: function (r) {
								return _Utils_update(
									r,
									{
										eX: A2($elm$core$List$member, uid, r.eX) ? A2(
											$elm$core$List$filter,
											function (autre) {
												return !_Utils_eq(autre, uid);
											},
											r.eX) : _Utils_ap(
											r.eX,
											_List_fromArray(
												[uid]))
									});
							}(model.hG)
						}),
					_List_Nil);
			case 24:
				var valeur = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hG: function (r) {
								return _Utils_update(
									r,
									{
										D1: (valeur === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(valeur)
									});
							}(model.hG)
						}),
					_List_Nil);
			case 25:
				var valeur = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hG: function (r) {
								return _Utils_update(
									r,
									{
										fI: (valeur === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(valeur)
									});
							}(model.hG)
						}),
					_List_Nil);
			case 26:
				var valeur = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hG: function (r) {
								return _Utils_update(
									r,
									{
										ho: (valeur === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(valeur)
									});
							}(model.hG)
						}),
					_List_Nil);
			case 27:
				var valeur = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hG: function (r) {
								return _Utils_update(
									r,
									{
										gB: (valeur === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(valeur)
									});
							}(model.hG)
						}),
					_List_Nil);
			case 22:
				var valeur = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hG: function (r) {
								return _Utils_update(
									r,
									{
										o4: ($elm$core$String$trim(valeur) === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(valeur)
									});
							}(model.hG)
						}),
					_List_Nil);
			case 20:
				var manquants = function () {
					var _v25 = $author$project$Components$Imports$Outil$Model$feuilleOuverte(model);
					if (!_v25.$) {
						var part = _v25.a;
						return _Utils_ap(
							A2($author$project$Components$Imports$Outil$Model$reglagesManquantsEnChoix, part, model),
							(_Utils_eq(model.hG.eX, _List_Nil) && (!_Utils_eq(
								A2($author$project$Components$Imports$Outil$Model$tousLesRoles, part, model),
								_List_Nil))) ? _List_fromArray(
								['roles']) : _List_Nil);
					} else {
						return _List_Nil;
					}
				}();
				return (!_Utils_eq(manquants, _List_Nil)) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{qe: manquants}),
					_List_Nil) : A2(
					$author$project$Components$Imports$Outil$Update$versLeDrawerDesReglages,
					$author$project$Components$Shared$Drawer$Update$Fermer,
					_Utils_update(
						model,
						{
							pb: A2(
								$elm$core$List$map,
								function (part) {
									return _Utils_eq(
										$elm$core$Maybe$Just(part.mx),
										model.Et) ? _Utils_update(
										part,
										{qc: model.hG, IM: model.q9}) : part;
								},
								model.pb),
							qe: _List_Nil
						}));
			case 28:
				var feuille = msg.a;
				var index = msg.b;
				var champ = msg.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							pb: A2(
								$elm$core$List$map,
								function (part) {
									return _Utils_eq(part.mx, feuille) ? _Utils_update(
										part,
										{
											j1: (champ === '') ? A2($elm$core$Dict$remove, index, part.j1) : A3($elm$core$Dict$insert, index, champ, part.j1),
											hJ: A2($elm$core$Dict$remove, index, part.hJ)
										}) : part;
								},
								model.pb),
							pZ: $elm$core$Maybe$Nothing,
							ii: A2(
								$elm$core$Dict$remove,
								_Utils_Tuple2(feuille, index),
								model.ii)
						}),
					_List_Nil);
			case 29:
				var feuille = msg.a;
				return A2(
					$author$project$Components$Imports$Outil$Update$versLeDrawerDuModele,
					$author$project$Components$Shared$Drawer$Update$Ouvrir('imports-modele'),
					_Utils_update(
						model,
						{
							g6: '',
							Et: $elm$core$Maybe$Just(feuille),
							pZ: $elm$core$Maybe$Nothing
						}));
			case 30:
				var nom = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{g6: nom}),
					_List_Nil);
			case 31:
				return $author$project$Components$Imports$Outil$Update$enregistrerLeModele(model);
			case 32:
				var feuille = msg.a;
				return A2(
					$author$project$Components$Imports$Outil$Update$versLeDrawerDApplication,
					$author$project$Components$Shared$Drawer$Update$Ouvrir('imports-application'),
					_Utils_update(
						model,
						{
							B4: _List_Nil,
							ob: $elm$core$Maybe$Nothing,
							Et: $elm$core$Maybe$Just(feuille)
						}));
			case 33:
				var modele = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ob: $elm$core$Maybe$Just(modele)
						}),
					_List_Nil);
			case 34:
				var _v26 = _Utils_Tuple2(
					model.ob,
					$author$project$Components$Imports$Outil$Model$feuilleOuverte(model));
				if ((!_v26.a.$) && (!_v26.b.$)) {
					var modele = _v26.a.a;
					var part = _v26.b.a;
					var _v27 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reappliquerLeModele, modele.nQ);
					if (!_v27.$) {
						var lien = _v27.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$List$cons(
								A3($author$project$Components$Imports$Outil$Update$Reappliquer, part.mx, lien, part.ym)),
							A2($author$project$Components$Imports$Outil$Update$versLeDrawerDApplication, $author$project$Components$Shared$Drawer$Update$Fermer, model));
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 35:
				var feuille = msg.a;
				var reponse = msg.b;
				var _v28 = A2($author$project$API$Reponse$lire, $author$project$Components$Imports$Outil$API$QueryAPIModel$reapplicationDecoder, reponse);
				if (!_v28.$) {
					var reapplication = _v28.a;
					return _Utils_Tuple2(
						A3($author$project$Components$Imports$Outil$Model$reapplique, feuille, reapplication, model),
						_List_Nil);
				} else {
					var refus = _v28.a;
					return A2($author$project$Components$Imports$Outil$Update$pasLue, refus, model);
				}
			case 36:
				var _v29 = _Utils_Tuple2(
					model.gw,
					$author$project$Components$Imports$Outil$Model$peutPreparer(model) && (!$author$project$Components$Imports$Outil$Model$valeursRestantes(model)));
				if ((!_v29.a.$) && _v29.b) {
					var fichier = _v29.a.a;
					return A3(
						$author$project$Components$Imports$Outil$Update$envoyer,
						A2($author$project$Components$Imports$Outil$Model$lienDe, $author$project$API$NavLinksDictionary$preparerUnLot, model),
						A2(
							$author$project$Components$Imports$Outil$API$WriteAPIModel$PreparerUnLot,
							fichier,
							$author$project$Components$Imports$Outil$Model$partsAPreparer(model)),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 37:
				var reponse = msg.a;
				var _v30 = A3($author$project$API$Envoi$conclure, $author$project$Components$Imports$Outil$Update$reglage, reponse, model.l2);
				if (!_v30.$) {
					var _v31 = _v30.a;
					var envoi = _v31.a;
					var issue = _v31.b;
					var effets = _v31.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Imports$Outil$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 38:
				var reponse = msg.a;
				var _v32 = A2($author$project$API$Reponse$lire, $author$project$Components$Imports$Outil$API$QueryAPIModel$lotDecoder, reponse);
				if (!_v32.$) {
					var lot = _v32.a;
					return A2($author$project$Components$Imports$Outil$Update$lignesRejeteesAttendues, model, lot) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{
								mb: model.mb + 1,
								n0: $elm$core$Maybe$Just(lot)
							}),
						_List_fromArray(
							[
								$author$project$Components$Imports$Outil$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
							])) : _Utils_Tuple2(
						_Utils_update(
							model,
							{
								mb: 0,
								n0: $elm$core$Maybe$Just(lot)
							}),
						_List_Nil);
				} else {
					var refus = _v32.a;
					return A2($author$project$Components$Imports$Outil$Update$pasLueOuRelire, refus, model);
				}
			case 39:
				var _v33 = _Utils_Tuple2(
					model.n0,
					A2($author$project$Components$Imports$Outil$Model$lienDe, $author$project$API$NavLinksDictionary$simulerLeLot, model));
				if ((!_v33.a.$) && (!_v33.b.$)) {
					var lot = _v33.a.a;
					var lien = _v33.b.a;
					return A3(
						$author$project$Components$Imports$Outil$Update$envoyer,
						$elm$core$Maybe$Just(lien),
						$author$project$Components$Imports$Outil$API$WriteAPIModel$SimulerLeLot(lot.Aq),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 86:
				return A2(
					$author$project$Components$Imports$Outil$Update$versLeDrawerDeConfirmation,
					$author$project$Components$Shared$Drawer$Update$Ouvrir('imports-confirmation'),
					model);
			case 85:
				return A2(
					$author$project$Components$Imports$Outil$Update$versLeDrawerDesLignes,
					$author$project$Components$Shared$Drawer$Update$Ouvrir('imports-lignes'),
					model);
			case 40:
				var _v34 = _Utils_Tuple2(
					model.n0,
					A2($author$project$Components$Imports$Outil$Model$lienDe, $author$project$API$NavLinksDictionary$appliquerLeLot, model));
				if ((!_v34.a.$) && (!_v34.b.$)) {
					var lot = _v34.a.a;
					var lien = _v34.b.a;
					var _v35 = A2($author$project$Components$Imports$Outil$Update$versLeDrawerDeConfirmation, $author$project$Components$Shared$Drawer$Update$Fermer, model);
					var ferme = _v35.a;
					var effetsDuDrawer = _v35.b;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effetsDuDrawer),
						A3(
							$author$project$Components$Imports$Outil$Update$envoyer,
							$elm$core$Maybe$Just(lien),
							$author$project$Components$Imports$Outil$API$WriteAPIModel$AppliquerLeLot(lot.Aq),
							ferme));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 74:
				var liens = msg.a;
				var _v36 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$imports, liens);
				if (!_v36.$) {
					var lecture = _v36.a;
					return _Utils_Tuple2(
						_Utils_update(
							$author$project$Components$Imports$Outil$Update$init,
							{
								np: $elm$core$Maybe$Just(lecture),
								EE: 1
							}),
						_List_fromArray(
							[
								$author$project$Components$Imports$Outil$Update$DemanderProcessUid,
								$author$project$Components$Imports$Outil$Update$Lire(lecture)
							]));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							$author$project$Components$Imports$Outil$Update$init,
							{EE: 1, qa: true}),
						_List_Nil);
				}
			case 75:
				var liens = msg.a;
				var id = msg.b;
				var _v37 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$imports, liens);
				if (!_v37.$) {
					var lecture = _v37.a;
					return _Utils_Tuple2(
						_Utils_update(
							$author$project$Components$Imports$Outil$Update$init,
							{
								np: $elm$core$Maybe$Just(lecture),
								n1: $elm$core$Maybe$Just(id),
								EE: 1
							}),
						_List_fromArray(
							[
								$author$project$Components$Imports$Outil$Update$DemanderProcessUid,
								$author$project$Components$Imports$Outil$Update$Lire(lecture)
							]));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							$author$project$Components$Imports$Outil$Update$init,
							{EE: 1, qa: true}),
						_List_Nil);
				}
			case 76:
				var reponse = msg.a;
				var _v38 = A2($author$project$API$Reponse$lire, $author$project$Components$Imports$Outil$API$QueryAPIModel$historiqueDecoder, reponse);
				if (!_v38.$) {
					var lignes = _v38.a;
					var vus = A2(
						$elm$core$List$map,
						function (l) {
							return _Utils_Tuple2(l.t1, l.ja);
						},
						lignes);
					var visee = A2(
						$elm$core$Maybe$andThen,
						function (id) {
							return $elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (l) {
										return _Utils_eq(l.Aq, id);
									},
									lignes));
						},
						model.n1);
					var lu = _Utils_update(
						model,
						{
							jb: A3(
								$elm$core$List$foldl,
								F2(
									function (a, connus) {
										return A2($elm$core$List$member, a, connus) ? connus : _Utils_ap(
											connus,
											_List_fromArray(
												[a]));
									}),
								model.jb,
								vus),
							gd: false,
							m6: $elm$core$Maybe$Just(lignes),
							n1: $elm$core$Maybe$Nothing
						});
					var enAttente = A2(
						$elm$core$List$any,
						function (l) {
							return l.gt === 'en-cours';
						},
						lignes) && (_Utils_cmp(model.mb, $author$project$Components$Imports$Outil$Update$maxEssaisDeLecture) < 0);
					return A2(
						$author$project$Components$Imports$Outil$Update$relireSiEnAttente,
						enAttente,
						function () {
							if (!visee.$) {
								var ligne = visee.a;
								var _v40 = _Utils_Tuple2(
									A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$suiviDuTraitement, ligne.nQ),
									A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reprendreLeLot, ligne.nQ));
								if (!_v40.a.$) {
									var suivi = _v40.a.a;
									var lien = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$lot, ligne.nQ);
									return A2(
										$elm$core$Tuple$mapSecond,
										$elm$core$Basics$append(
											A2(
												$elm$core$Maybe$withDefault,
												_List_Nil,
												A2(
													$elm$core$Maybe$map,
													A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$LireLeLot, $elm$core$List$singleton),
													lien))),
										A2(
											$author$project$Components$Imports$Outil$Update$update,
											$author$project$Components$Imports$Outil$Update$LigneDHistoriqueSuivie(suivi),
											_Utils_update(
												lu,
												{nN: lien})));
								} else {
									if (!_v40.b.$) {
										var _v41 = _v40.a;
										var reprise = _v40.b.a;
										return A2(
											$author$project$Components$Imports$Outil$Update$update,
											$author$project$Components$Imports$Outil$Update$LigneDHistoriqueReprise(reprise),
											lu);
									} else {
										return _Utils_Tuple2(lu, _List_Nil);
									}
								}
							} else {
								return _Utils_Tuple2(lu, _List_Nil);
							}
						}());
				} else {
					var refus = _v38.a;
					return A2($author$project$Components$Imports$Outil$Update$pasLueOuRelire, refus, model);
				}
			case 77:
				var filtre = msg.a;
				var valeur = msg.b;
				var filtre_ = function () {
					switch (filtre) {
						case 0:
							return _Utils_update(
								model,
								{gy: valeur});
						case 1:
							return _Utils_update(
								model,
								{gz: valeur});
						default:
							return _Utils_update(
								model,
								{gx: valeur});
					}
				}();
				return _Utils_Tuple2(
					filtre_,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$LireLHistorique, $elm$core$List$singleton),
							$author$project$Components$Imports$Outil$Model$lienDeLHistorique(filtre_))));
			case 78:
				var id = msg.a;
				return A2(
					$author$project$Components$Imports$Outil$Update$versLeDrawerDeLHistorique,
					$author$project$Components$Shared$Drawer$Update$Ouvrir('imports-historique'),
					_Utils_update(
						model,
						{
							nU: $elm$core$Maybe$Just(id)
						}));
			case 79:
				var lien = msg.a;
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[
							$author$project$Components$Imports$Outil$Update$LireLeRapport(lien)
						]));
			case 80:
				var lien = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{me: 4, n0: $elm$core$Maybe$Nothing, EE: 0, pZ: $elm$core$Maybe$Nothing}),
					_List_fromArray(
						[
							$author$project$Components$Imports$Outil$Update$LireLeLot(lien)
						]));
			case 81:
				var lien = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ua: $elm$core$Maybe$Nothing,
							me: 6,
							EE: 0,
							pZ: $elm$core$Maybe$Nothing,
							rr: $elm$core$Maybe$Just(lien)
						}),
					_List_fromArray(
						[
							$author$project$Components$Imports$Outil$Update$LireLeSuivi(lien)
						]));
			case 82:
				var geste = msg.a;
				return A2($author$project$Components$Imports$Outil$Update$versLeDrawerDeLHistorique, geste, model);
			case 83:
				var geste = msg.a;
				return A2($author$project$Components$Imports$Outil$Update$versLeDrawerDesLignes, geste, model);
			case 84:
				var geste = msg.a;
				return A2($author$project$Components$Imports$Outil$Update$versLeDrawerDeConfirmation, geste, model);
			case 98:
				var geste = msg.a;
				return A2($author$project$Components$Imports$Outil$Update$versLeDrawerDuRejeu, geste, model);
			case 87:
				var _v43 = A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.nQ;
						},
						$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$lignesRejetees)),
					model.n0);
				if (!_v43.$) {
					var lien = _v43.a;
					var lignes = {gd: false, zH: 'a-corriger', nB: lien, nW: $elm$core$Maybe$Nothing, EE: 1, pZ: $elm$core$Dict$empty, c7: $elm$core$Dict$empty};
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								gV: $elm$core$Maybe$Just(lignes)
							}),
						_List_fromArray(
							[
								$author$project$Components$Imports$Outil$Update$LireLesLignes(
								A2($author$project$Components$Imports$Outil$Model$lienDeLaListe, lien, lignes))
							]));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 88:
				var reponse = msg.a;
				var _v44 = A2($author$project$API$Reponse$lire, $author$project$Components$Imports$Outil$API$QueryAPIModel$lignesRejeteesDecoder, reponse);
				if (!_v44.$) {
					var liste = _v44.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Imports$Outil$Update$avecLesLignes,
							function (l) {
								return _Utils_update(
									l,
									{
										gd: false,
										nW: $elm$core$Maybe$Just(liste)
									});
							},
							model),
						_List_Nil);
				} else {
					var refus = _v44.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Imports$Outil$Update$avecLesLignes,
							function (l) {
								return _Utils_update(
									l,
									{gd: true});
							},
							model),
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Imports$Outil$Update$Reconnecter]) : _List_Nil);
				}
			case 89:
				var filtre = msg.a;
				return $author$project$Components$Imports$Outil$Update$andThenRelire(
					_Utils_Tuple2(
						A2(
							$author$project$Components$Imports$Outil$Update$avecLesLignes,
							function (l) {
								return _Utils_update(
									l,
									{zH: filtre, EE: 1});
							},
							model),
						_List_Nil));
			case 90:
				var page = msg.a;
				return $author$project$Components$Imports$Outil$Update$andThenRelire(
					_Utils_Tuple2(
						A2(
							$author$project$Components$Imports$Outil$Update$avecLesLignes,
							function (l) {
								return _Utils_update(
									l,
									{EE: page});
							},
							model),
						_List_Nil));
			case 91:
				var part = msg.a;
				var ligne = msg.b;
				var valeur = msg.c;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Imports$Outil$Update$avecLesLignes,
						function (l) {
							return _Utils_update(
								l,
								{
									pZ: A2(
										$elm$core$Dict$remove,
										_Utils_Tuple2(part, ligne),
										l.pZ),
									c7: A3(
										$elm$core$Dict$insert,
										_Utils_Tuple2(part, ligne),
										valeur,
										l.c7)
								});
						},
						model),
					_List_Nil);
			case 92:
				var part = msg.a;
				var ligne = msg.b;
				var _v45 = _Utils_Tuple2(
					model.n0,
					A2(
						$elm$core$Maybe$andThen,
						function (l) {
							return A2(
								$elm$core$Maybe$map,
								$elm$core$Tuple$pair(l),
								A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(part, ligne),
									l.c7));
						},
						model.gV));
				if ((!_v45.a.$) && (!_v45.b.$)) {
					var lot = _v45.a.a;
					var _v46 = _v45.b.a;
					var l = _v46.a;
					var valeur = _v46.b;
					return A3(
						$author$project$Components$Imports$Outil$Update$envoyer,
						A2($author$project$Components$Imports$Outil$Update$lienDeLaListeDe, $author$project$API$NavLinksDictionary$corrigerUneLigne, l),
						A4($author$project$Components$Imports$Outil$API$WriteAPIModel$CorrigerUneLigne, lot.Aq, part, ligne, valeur),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 93:
				var part = msg.a;
				var ligne = msg.b;
				return A3(
					$author$project$Components$Imports$Outil$Update$gesteSurUneLigne,
					$author$project$API$NavLinksDictionary$annulerLaCorrection,
					function (lot) {
						return A3($author$project$Components$Imports$Outil$API$WriteAPIModel$AnnulerLaCorrection, lot, part, ligne);
					},
					model);
			case 94:
				var part = msg.a;
				var ligne = msg.b;
				return A3(
					$author$project$Components$Imports$Outil$Update$gesteSurUneLigne,
					$author$project$API$NavLinksDictionary$ignorerUneLigne,
					function (lot) {
						return A3($author$project$Components$Imports$Outil$API$WriteAPIModel$IgnorerUneLigne, lot, part, ligne);
					},
					model);
			case 95:
				var part = msg.a;
				var ligne = msg.b;
				return A3(
					$author$project$Components$Imports$Outil$Update$gesteSurUneLigne,
					$author$project$API$NavLinksDictionary$reprendreUneLigne,
					function (lot) {
						return A3($author$project$Components$Imports$Outil$API$WriteAPIModel$ReprendreUneLigne, lot, part, ligne);
					},
					model);
			case 96:
				return A2(
					$author$project$Components$Imports$Outil$Update$versLeDrawerDuRejeu,
					$author$project$Components$Shared$Drawer$Update$Ouvrir('imports-rejeu'),
					model);
			case 97:
				return A3($author$project$Components$Imports$Outil$Update$gesteSurUneLigne, $author$project$API$NavLinksDictionary$rejouerLesLignes, $author$project$Components$Imports$Outil$API$WriteAPIModel$RejouerLesLignes, model);
			case 99:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gV: $elm$core$Maybe$Nothing}),
					_List_Nil);
			case 41:
				var reponse = msg.a;
				var _v47 = A2($author$project$API$Reponse$lire, $author$project$Components$Imports$Outil$API$QueryAPIModel$suiviDecoder, reponse);
				if (!_v47.$) {
					var suivi = _v47.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ua: $elm$core$Maybe$Just(suivi)
							}),
						suivi.Jt ? _List_Nil : A2(
							$elm$core$List$cons,
							$author$project$Components$Imports$Outil$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs),
							function () {
								var _v48 = _Utils_Tuple2(
									model.nN,
									A2(
										$elm$core$Maybe$andThen,
										function ($) {
											return $.A7;
										},
										model.n0));
								if ((!_v48.a.$) && (_v48.b.$ === 1)) {
									var lien = _v48.a.a;
									var _v49 = _v48.b;
									return _List_fromArray(
										[
											$author$project$Components$Imports$Outil$Update$LireLeLot(lien)
										]);
								} else {
									return _List_Nil;
								}
							}()));
				} else {
					var refus = _v47.a;
					return A2($author$project$Components$Imports$Outil$Update$pasLue, refus, model);
				}
			case 44:
				var reponse = msg.a;
				var _v50 = A2($author$project$API$Reponse$lire, $author$project$Components$Imports$Outil$API$QueryAPIModel$detailDecoder, reponse);
				if (!_v50.$) {
					var detail = _v50.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bB: $elm$core$Maybe$Just(detail)
							}),
						_List_Nil);
				} else {
					var refus = _v50.a;
					return ((refus.ri === 404) && (model.ma < 10)) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{ma: model.ma + 1}),
						_List_fromArray(
							[
								$author$project$Components$Imports$Outil$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
							])) : A2($author$project$Components$Imports$Outil$Update$pasLue, refus, model);
				}
			case 42:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $author$project$Components$Imports$Outil$Update$LireLeRapport, $elm$core$List$singleton),
							model.pK)));
			case 43:
				var reponse = msg.a;
				return _Utils_Tuple2(
					model,
					(reponse.ri === 200) ? _List_fromArray(
						[
							A2($author$project$Components$Imports$Outil$Update$Telecharger, 'rapport-de-l-import.csv', reponse.f$)
						]) : _List_Nil);
			case 45:
				var valeur = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hG: function (r) {
								return _Utils_update(
									r,
									{
										hi: $elm$core$Maybe$Just(valeur)
									});
							}(model.hG)
						}),
					_List_Nil);
			case 47:
				var geste = msg.a;
				return A2(
					$author$project$Components$Imports$Outil$Update$siLibre,
					model,
					$author$project$Components$Imports$Outil$Update$versLeDrawerDeCible(geste));
			case 48:
				var geste = msg.a;
				return A2($author$project$Components$Imports$Outil$Update$versLeDrawerDuRefus, geste, model);
			case 49:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$List$cons($author$project$Components$Imports$Outil$Update$ChoisirUnFichier),
					A2($author$project$Components$Imports$Outil$Update$versLeDrawerDuRefus, $author$project$Components$Shared$Drawer$Update$Fermer, model));
			case 50:
				var geste = msg.a;
				return A2(
					$author$project$Components$Imports$Outil$Update$siLibre,
					model,
					$author$project$Components$Imports$Outil$Update$versLeDrawerDesReglages(geste));
			case 51:
				var geste = msg.a;
				return A2(
					$author$project$Components$Imports$Outil$Update$siLibre,
					model,
					$author$project$Components$Imports$Outil$Update$versLeDrawerDuModele(geste));
			case 52:
				var geste = msg.a;
				return A2(
					$author$project$Components$Imports$Outil$Update$siLibre,
					model,
					$author$project$Components$Imports$Outil$Update$versLeDrawerDApplication(geste));
			case 71:
				var geste = msg.a;
				return A2(
					$author$project$Components$Imports$Outil$Update$siLibre,
					model,
					$author$project$Components$Imports$Outil$Update$versLeDrawerDeRepartition(geste));
			case 72:
				var geste = msg.a;
				return A2(
					$author$project$Components$Imports$Outil$Update$siLibre,
					model,
					$author$project$Components$Imports$Outil$Update$versLeDrawerDesRegles(geste));
			default:
				var geste = msg.a;
				return A2(
					$author$project$Components$Imports$Outil$Update$siLibre,
					model,
					$author$project$Components$Imports$Outil$Update$versLeDrawerDesValeurs(geste));
		}
	});
var $author$project$Main$Update$versLesImports = F2(
	function (msg, model) {
		var _v0 = A2(
			$author$project$Components$Imports$Outil$Update$update,
			msg,
			$author$project$Components$Imports$Outil$Model$ouvrir(model.AC));
		var outil = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLesImports, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLesImports,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						AC: $author$project$Components$Imports$Outil$Model$envelopper(outil),
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Imports$Outil$Update$popMessages(msg),
							gardes)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$AttendreAvantDeRelireLesLangues = function (a) {
	return {$: 226, a: a};
};
var $author$project$Main$Update$EnvoyerAuxLangues = function (a) {
	return {$: 225, a: a};
};
var $author$project$Main$Update$LireLesLangues = F2(
	function (a, b) {
		return {$: 224, a: a, b: b};
	});
var $author$project$Main$Model$PourLesLanguesDuClient = 44;
var $author$project$Main$Update$depuisLesLangues = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[44]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 1:
				var lecture = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLesLangues(lecture))));
			case 2:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerAuxLangues(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 3:
				var delaiMs = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AttendreAvantDeRelireLesLangues(delaiMs)
							])));
			case 4:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Parametrage$LanguesDuClient$Update$popMessages = function (_v0) {
	return $elm$core$Maybe$Nothing;
};
var $author$project$Main$Update$requeteSurLesLangues = function (effet) {
	switch (effet.$) {
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIModel$Ajouter = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIModel$ApercuDeSuppression = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIModel$ChangerLeDefaut = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$LanguesDuClient$Update$DemanderProcessUid = {$: 0};
var $author$project$Components$Parametrage$LanguesDuClient$Update$LesLangues = 0;
var $author$project$Components$Parametrage$LanguesDuClient$Update$LesPropositions = 1;
var $author$project$Components$Parametrage$LanguesDuClient$Update$Lire = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIModel$Retirer = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIModel$SupprimerLesTraductions = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$LanguesDuClient$Update$AttendreAvantDeRelire = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$LanguesDuClient$Update$relire = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$Parametrage$LanguesDuClient$Update$Lire(0),
				$elm$core$List$singleton),
			model.np));
};
var $author$project$Components$Parametrage$LanguesDuClient$Update$PlacerFocus = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$LanguesDuClient$Update$versLeDrawerDeSuppression = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{li: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Parametrage$LanguesDuClient$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.li));
	});
var $author$project$Components$Parametrage$LanguesDuClient$Update$suiteDeLaSuppression = F2(
	function (restantes, model) {
		return (restantes > 0) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{
					rs: $elm$core$Maybe$Just(restantes)
				}),
			_List_Nil) : A2(
			$author$project$Components$Parametrage$LanguesDuClient$Update$versLeDrawerDeSuppression,
			$author$project$Components$Shared$Drawer$Update$Fermer,
			_Utils_update(
				model,
				{tq: $elm$core$Maybe$Nothing, rs: $elm$core$Maybe$Nothing}));
	});
var $author$project$Components$Parametrage$LanguesDuClient$Model$saisieDeLAjout = function (model) {
	return (!_Utils_eq(model.ve, $elm$core$Maybe$Nothing)) || ($elm$core$String$trim(model.hC) !== '');
};
var $author$project$Components$Parametrage$LanguesDuClient$Update$versLeDrawerDAjout = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{k_: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Parametrage$LanguesDuClient$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Parametrage$LanguesDuClient$Model$saisieDeLAjout(model)
				},
				geste,
				model.k_));
	});
var $author$project$Components$Parametrage$LanguesDuClient$Update$versLeDrawerDeRetrait = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{lh: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Parametrage$LanguesDuClient$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.lh));
	});
var $author$project$Components$Parametrage$LanguesDuClient$Model$saisieDuDefaut = function (model) {
	return !_Utils_eq(model.ve, $elm$core$Maybe$Nothing);
};
var $author$project$Components$Parametrage$LanguesDuClient$Update$versLeDrawerDuDefaut = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{ls: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Parametrage$LanguesDuClient$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Parametrage$LanguesDuClient$Model$saisieDuDefaut(model)
				},
				geste,
				model.ls));
	});
var $author$project$Components$Parametrage$LanguesDuClient$Update$conclure = F2(
	function (issue, model) {
		switch (issue.$) {
			case 0:
				var commande = issue.a;
				var rendue = issue.b;
				var relecture = rendue.sy ? $author$project$Components$Parametrage$LanguesDuClient$Update$relire(model) : _List_fromArray(
					[
						$author$project$Components$Parametrage$LanguesDuClient$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
					]);
				var nette = _Utils_update(
					model,
					{dh: $elm$core$Maybe$Nothing, ve: $elm$core$Maybe$Nothing, hC: '', pZ: $elm$core$Maybe$Nothing});
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(relecture),
					function () {
						switch (commande.$) {
							case 0:
								return A2($author$project$Components$Parametrage$LanguesDuClient$Update$versLeDrawerDAjout, $author$project$Components$Shared$Drawer$Update$Fermer, nette);
							case 1:
								return A2($author$project$Components$Parametrage$LanguesDuClient$Update$versLeDrawerDuDefaut, $author$project$Components$Shared$Drawer$Update$Fermer, nette);
							case 2:
								return _Utils_Tuple2(nette, _List_Nil);
							case 3:
								return function (_v2) {
									var ouvert = _v2.a;
									var effets = _v2.b;
									return A2(
										$elm$core$Tuple$mapSecond,
										$elm$core$Basics$append(effets),
										A2(
											$author$project$Components$Parametrage$LanguesDuClient$Update$versLeDrawerDeSuppression,
											$author$project$Components$Shared$Drawer$Update$Ouvrir('langues-supprimer'),
											ouvert));
								}(
									A2(
										$author$project$Components$Parametrage$LanguesDuClient$Update$versLeDrawerDeRetrait,
										$author$project$Components$Shared$Drawer$Update$Fermer,
										_Utils_update(
											model,
											{
												tq: $elm$core$Maybe$Just(
													{
														zu: A2($elm$core$Maybe$withDefault, 0, rendue.zu),
														Ki: A2($elm$core$Maybe$withDefault, 0, rendue.Ki)
													})
											})));
							default:
								return A2(
									$author$project$Components$Parametrage$LanguesDuClient$Update$suiteDeLaSuppression,
									A2($elm$core$Maybe$withDefault, 0, rendue.qD),
									model);
						}
					}());
			case 1:
				if ((issue.a.$ === 2) && (issue.c.$ === 4)) {
					var code = issue.a.a;
					var erreur = issue.c;
					return A2(
						$author$project$Components$Parametrage$LanguesDuClient$Update$versLeDrawerDeRetrait,
						$author$project$Components$Shared$Drawer$Update$Ouvrir('langues-retirer-' + code),
						_Utils_update(
							model,
							{
								pZ: $elm$core$Maybe$Just(erreur)
							}));
				} else {
					var erreur = issue.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								pZ: $elm$core$Maybe$Just(erreur),
								rs: $elm$core$Maybe$Nothing
							}),
						_List_Nil);
				}
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$LanguesDuClient$Update$Envoyer = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$LanguesDuClient$Update$Reconnecter = {$: 5};
var $author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIErrorsModel$AccesRefuse = {$: 5};
var $author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIErrorsModel$AutreRefus = {$: 6};
var $author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIErrorsModel$LangueDejaPresente = {$: 1};
var $author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIErrorsModel$LangueHorsReferentiel = {$: 0};
var $author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIErrorsModel$LangueParDefautNonRetirable = {$: 2};
var $author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIErrorsModel$TraductionsPresentes = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIErrorsModel$ValeursManquantes = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIErrorsModel$avecNombre = F2(
	function (cas, contenu) {
		return A2(
			$elm$core$Result$withDefault,
			$author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIErrorsModel$AutreRefus,
			A2(
				$elm$core$Result$map,
				cas,
				A2(
					$elm$json$Json$Decode$decodeValue,
					A2($elm$json$Json$Decode$field, 'nombre', $elm$json$Json$Decode$int),
					contenu)));
	});
var $author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIErrorsModel$duRefus = function (reponse) {
	if (reponse.ri === 403) {
		return $author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIErrorsModel$AccesRefuse;
	} else {
		var _v0 = A2(
			$elm$json$Json$Decode$decodeString,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['error']),
				$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value)),
			reponse.f$);
		_v0$5:
		while (true) {
			if ((!_v0.$) && _v0.a.b) {
				switch (_v0.a.a.a) {
					case 'LangueHorsReferentiel':
						var _v1 = _v0.a;
						var _v2 = _v1.a;
						return $author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIErrorsModel$LangueHorsReferentiel;
					case 'LangueDejaPresente':
						var _v3 = _v0.a;
						var _v4 = _v3.a;
						return $author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIErrorsModel$LangueDejaPresente;
					case 'LangueParDefautNonRetirable':
						var _v5 = _v0.a;
						var _v6 = _v5.a;
						return $author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIErrorsModel$LangueParDefautNonRetirable;
					case 'ValeursManquantes':
						var _v7 = _v0.a;
						var _v8 = _v7.a;
						var contenu = _v8.b;
						return A2($author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIErrorsModel$avecNombre, $author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIErrorsModel$ValeursManquantes, contenu);
					case 'TraductionsPresentes':
						var _v9 = _v0.a;
						var _v10 = _v9.a;
						var contenu = _v10.b;
						return A2($author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIErrorsModel$avecNombre, $author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIErrorsModel$TraductionsPresentes, contenu);
					default:
						break _v0$5;
				}
			} else {
				break _v0$5;
			}
		}
		return $author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIErrorsModel$AutreRefus;
	}
};
var $author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIModel$Rendue = F5(
	function (vuesAJour, liens, valeurs, fiches, restantes) {
		return {zu: fiches, nQ: liens, qD: restantes, Ki: valeurs, sy: vuesAJour};
	});
var $author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIModel$rendueDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'restantes',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$int),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'fiches',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'valeurs',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$int),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'liens',
				A2(
					$elm$json$Json$Decode$map,
					function ($) {
						return $.h0;
					},
					$author$project$API$Liens$decoder),
				_List_Nil,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'vuesAJour',
					$elm$json$Json$Decode$bool,
					true,
					$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIModel$Rendue))))));
var $author$project$Components$Parametrage$LanguesDuClient$Update$reglage = {
	f8: $author$project$Components$Parametrage$LanguesDuClient$Update$DemanderProcessUid,
	l4: $author$project$Components$Parametrage$LanguesDuClient$Update$Envoyer,
	go: $author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIErrorsModel$duRefus,
	pW: $author$project$Components$Parametrage$LanguesDuClient$Update$Reconnecter,
	qu: F2(
		function (_v0, _v1) {
			return true;
		}),
	qv: $author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIModel$rendueDecoder
};
var $author$project$Components$Parametrage$LanguesDuClient$Update$envoyer = F3(
	function (lien, commande, model) {
		var _v0 = A4($author$project$API$Envoi$partir, $author$project$Components$Parametrage$LanguesDuClient$Update$reglage, lien, commande, model.l2);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var envoi = _v1.a;
			var effets = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi, pZ: $elm$core$Maybe$Nothing}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$ajouterUneLangue = 'ajouter-une-langue';
var $author$project$Components$Parametrage$LanguesDuClient$Model$lienDeLAjout = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.nQ;
			},
			$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$ajouterUneLangue)),
		model.Ba);
};
var $author$project$API$NavLinksDictionary$apercuDeSuppressionDesTraductions = 'apercu-de-suppression-des-traductions';
var $author$project$Components$Parametrage$LanguesDuClient$Model$lienDeLApercu = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.nQ;
			},
			$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$apercuDeSuppressionDesTraductions)),
		model.dh);
};
var $author$project$API$NavLinksDictionary$languesDuClient = 'langues-du-client';
var $author$project$Components$Parametrage$LanguesDuClient$Model$lienDeLaLecture = $author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$languesDuClient);
var $author$project$API$NavLinksDictionary$supprimerLesTraductions = 'supprimer-les-traductions';
var $author$project$Components$Parametrage$LanguesDuClient$Model$lienDeLaSuppression = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.nQ;
			},
			$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$supprimerLesTraductions)),
		model.dh);
};
var $author$project$API$NavLinksDictionary$changerLaLangueParDefaut = 'changer-la-langue-par-defaut';
var $author$project$Components$Parametrage$LanguesDuClient$Model$lienDuChangementDeDefaut = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.nQ;
			},
			$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$changerLaLangueParDefaut)),
		model.Ba);
};
var $author$project$API$NavLinksDictionary$retirerUneLangue = 'retirer-une-langue';
var $author$project$Components$Parametrage$LanguesDuClient$Model$lienDuRetrait = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.nQ;
			},
			$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$retirerUneLangue)),
		model.Ba);
};
var $author$project$Components$Parametrage$LanguesDuClient$Update$lotSuivant = function (model) {
	var _v0 = _Utils_Tuple2(model.rs, model.dh);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var restantes = _v0.a.a;
		var langue = _v0.b.a;
		return ((restantes > 0) && (!$author$project$API$Envoi$enCours(model.l2))) ? A3(
			$author$project$Components$Parametrage$LanguesDuClient$Update$envoyer,
			$author$project$Components$Parametrage$LanguesDuClient$Model$lienDeLaSuppression(model),
			$author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIModel$SupprimerLesTraductions(langue.vx),
			model) : _Utils_Tuple2(model, _List_Nil);
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$LanguesDuClient$API$QueryAPIModel$Entree = F2(
	function (code, libelle) {
		return {vx: code, Bl: libelle};
	});
var $author$project$Components$Parametrage$LanguesDuClient$API$QueryAPIModel$entreesDecoder = A2(
	$elm$json$Json$Decode$field,
	'entrees',
	$elm$json$Json$Decode$list(
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'libelle',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'code',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$LanguesDuClient$API$QueryAPIModel$Entree)))));
var $author$project$Components$Parametrage$LanguesDuClient$API$QueryAPIModel$Langues = F2(
	function (langues, liens) {
		return {Ba: langues, nQ: liens};
	});
var $author$project$Components$Parametrage$LanguesDuClient$API$QueryAPIModel$Langue = F6(
	function (code, libelle, nomPropre, parDefaut, valeursTraduites, liens) {
		return {vx: code, Bl: libelle, nQ: liens, Ds: nomPropre, o6: parDefaut, Kq: valeursTraduites};
	});
var $author$project$Components$Parametrage$LanguesDuClient$API$QueryAPIModel$langueDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'valeursTraduites',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'parDefaut',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'nomPropre',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'libelle',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'code',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$LanguesDuClient$API$QueryAPIModel$Langue)))))));
var $author$project$Components$Parametrage$LanguesDuClient$API$QueryAPIModel$languesDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'langues',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$LanguesDuClient$API$QueryAPIModel$langueDecoder),
		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$LanguesDuClient$API$QueryAPIModel$Langues)));
var $author$project$Components$Parametrage$LanguesDuClient$Update$pasLue = F2(
	function (refus, model) {
		return _Utils_Tuple2(
			(refus.ri === 403) ? _Utils_update(
				model,
				{gd: false, Ba: $elm$core$Maybe$Nothing, qa: true}) : _Utils_update(
				model,
				{gd: true}),
			(refus.ri === 401) ? _List_fromArray(
				[$author$project$Components$Parametrage$LanguesDuClient$Update$Reconnecter]) : _List_Nil);
	});
var $author$project$Components$Parametrage$LanguesDuClient$Update$lue = F3(
	function (lecture, reponse, model) {
		if (!lecture) {
			var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$LanguesDuClient$API$QueryAPIModel$languesDecoder, reponse);
			if (!_v1.$) {
				var langues = _v1.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gd: false,
							Ba: $elm$core$Maybe$Just(langues)
						}),
					_List_Nil);
			} else {
				var refus = _v1.a;
				return A2($author$project$Components$Parametrage$LanguesDuClient$Update$pasLue, refus, model);
			}
		} else {
			var _v2 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$LanguesDuClient$API$QueryAPIModel$entreesDecoder, reponse);
			if (!_v2.$) {
				var entrees = _v2.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Gw: entrees}),
					_List_Nil);
			} else {
				var refus = _v2.a;
				return A2($author$project$Components$Parametrage$LanguesDuClient$Update$pasLue, refus, model);
			}
		}
	});
var $author$project$Components$Parametrage$LanguesDuClient$Update$siLibre = F2(
	function (model, geste) {
		return $author$project$API$Envoi$enCours(model.l2) ? _Utils_Tuple2(model, _List_Nil) : geste(model);
	});
var $author$project$Components$Parametrage$LanguesDuClient$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var liens = msg.a;
				var gabarits = msg.b;
				var _v1 = $author$project$Components$Parametrage$LanguesDuClient$Model$lienDeLaLecture(liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					var referentiel = A2(
						$elm$core$Maybe$andThen,
						$author$project$API$Liens$resoudre(
							_List_fromArray(
								[
									_Utils_Tuple2('referentiel', 'langues')
								])),
						A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$referentielNormeDuSysteme, gabarits));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								gd: false,
								np: $elm$core$Maybe$Just(lecture),
								pY: referentiel,
								qa: false
							}),
						A2(
							$elm$core$List$cons,
							$author$project$Components$Parametrage$LanguesDuClient$Update$DemanderProcessUid,
							A2(
								$elm$core$List$cons,
								A2($author$project$Components$Parametrage$LanguesDuClient$Update$Lire, 0, lecture),
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Components$Parametrage$LanguesDuClient$Update$Lire(1),
											$elm$core$List$singleton),
										referentiel)))));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{Ba: $elm$core$Maybe$Nothing, np: $elm$core$Maybe$Nothing, qa: true}),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				return $author$project$Components$Parametrage$LanguesDuClient$Update$lotSuivant(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}));
			case 2:
				var lecture = msg.a;
				var reponse = msg.b;
				return A3($author$project$Components$Parametrage$LanguesDuClient$Update$lue, lecture, reponse, model);
			case 3:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Parametrage$LanguesDuClient$Update$relire(model));
			case 4:
				var geste = msg.a;
				return A2(
					$author$project$Components$Parametrage$LanguesDuClient$Update$siLibre,
					model,
					$author$project$Components$Parametrage$LanguesDuClient$Update$versLeDrawerDAjout(geste));
			case 5:
				var geste = msg.a;
				return A2(
					$author$project$Components$Parametrage$LanguesDuClient$Update$siLibre,
					model,
					$author$project$Components$Parametrage$LanguesDuClient$Update$versLeDrawerDuDefaut(geste));
			case 6:
				var geste = msg.a;
				return A2(
					$author$project$Components$Parametrage$LanguesDuClient$Update$siLibre,
					model,
					$author$project$Components$Parametrage$LanguesDuClient$Update$versLeDrawerDeRetrait(geste));
			case 7:
				var geste = msg.a;
				return A2(
					$author$project$Components$Parametrage$LanguesDuClient$Update$siLibre,
					model,
					$author$project$Components$Parametrage$LanguesDuClient$Update$versLeDrawerDeSuppression(geste));
			case 8:
				var _v2 = model.dh;
				if (!_v2.$) {
					var langue = _v2.a;
					return A3(
						$author$project$Components$Parametrage$LanguesDuClient$Update$envoyer,
						$author$project$Components$Parametrage$LanguesDuClient$Model$lienDeLApercu(model),
						$author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIModel$ApercuDeSuppression(langue.vx),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 9:
				var _v3 = _Utils_Tuple2(model.dh, model.tq);
				if ((!_v3.a.$) && (!_v3.b.$)) {
					var langue = _v3.a.a;
					var apercu = _v3.b.a;
					return A3(
						$author$project$Components$Parametrage$LanguesDuClient$Update$envoyer,
						$author$project$Components$Parametrage$LanguesDuClient$Model$lienDeLaSuppression(model),
						$author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIModel$SupprimerLesTraductions(langue.vx),
						_Utils_update(
							model,
							{
								rs: $elm$core$Maybe$Just(apercu.zu)
							}));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 10:
				return A2(
					$author$project$Components$Parametrage$LanguesDuClient$Update$versLeDrawerDAjout,
					$author$project$Components$Shared$Drawer$Update$Ouvrir('langues-ajouter'),
					_Utils_update(
						model,
						{dh: $elm$core$Maybe$Nothing, ve: $elm$core$Maybe$Nothing, hC: '', pZ: $elm$core$Maybe$Nothing}));
			case 11:
				var recherche = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{hC: recherche}),
					_List_Nil);
			case 12:
				var code = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ve: $elm$core$Maybe$Just(code)
						}),
					_List_Nil);
			case 13:
				var _v4 = model.ve;
				if (!_v4.$) {
					var code = _v4.a;
					return A3(
						$author$project$Components$Parametrage$LanguesDuClient$Update$envoyer,
						$author$project$Components$Parametrage$LanguesDuClient$Model$lienDeLAjout(model),
						$author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIModel$Ajouter(code),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 14:
				return A2(
					$author$project$Components$Parametrage$LanguesDuClient$Update$versLeDrawerDuDefaut,
					$author$project$Components$Shared$Drawer$Update$Ouvrir('langues-defaut-changer'),
					_Utils_update(
						model,
						{dh: $elm$core$Maybe$Nothing, ve: $elm$core$Maybe$Nothing, pZ: $elm$core$Maybe$Nothing}));
			case 15:
				var _v5 = model.ve;
				if (!_v5.$) {
					var code = _v5.a;
					return A3(
						$author$project$Components$Parametrage$LanguesDuClient$Update$envoyer,
						$author$project$Components$Parametrage$LanguesDuClient$Model$lienDuChangementDeDefaut(model),
						$author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIModel$ChangerLeDefaut(code),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 16:
				var langue = msg.a;
				return A3(
					$author$project$Components$Parametrage$LanguesDuClient$Update$envoyer,
					$author$project$Components$Parametrage$LanguesDuClient$Model$lienDuRetrait(model),
					$author$project$Components$Parametrage$LanguesDuClient$API$WriteAPIModel$Retirer(langue.vx),
					_Utils_update(
						model,
						{
							dh: $elm$core$Maybe$Just(langue)
						}));
			default:
				var reponse = msg.a;
				var _v6 = A3($author$project$API$Envoi$conclure, $author$project$Components$Parametrage$LanguesDuClient$Update$reglage, reponse, model.l2);
				if (!_v6.$) {
					var _v7 = _v6.a;
					var envoi = _v7.a;
					var issue = _v7.b;
					var effets = _v7.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Parametrage$LanguesDuClient$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Main$Update$versLesLangues = F2(
	function (msg, model) {
		var _v0 = A2($author$project$Components$Parametrage$LanguesDuClient$Update$update, msg, model.Bb);
		var langues = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLesLangues, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLesLangues,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Bb: langues,
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Parametrage$LanguesDuClient$Update$popMessages(msg),
							gardes)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$AttendreAvantDeRelireLesListes = function (a) {
	return {$: 215, a: a};
};
var $author$project$Main$Update$EnvoyerAuxListes = function (a) {
	return {$: 214, a: a};
};
var $author$project$Main$Update$LireLesListes = F2(
	function (a, b) {
		return {$: 213, a: a, b: b};
	});
var $author$project$Main$Model$PourLesListes = 37;
var $author$project$Main$Update$depuisLesListes = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[37]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 1:
				var lecture = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLesListes(lecture))));
			case 2:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerAuxListes(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 3:
				var delaiMs = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AttendreAvantDeRelireLesListes(delaiMs)
							])));
			case 4:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Produits$Listes$Update$deLaLecture = function (resultat) {
	if (resultat.$ === 1) {
		var refus = resultat.a;
		return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Components$Shared$Messages$Model$duRefus(refus));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$Listes$Update$popMessages = function (msg) {
	switch (msg.$) {
		case 2:
			if (!msg.a) {
				var _v1 = msg.a;
				var reponse = msg.b;
				return $author$project$Components$Produits$Listes$Update$deLaLecture(
					A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Listes$API$QueryAPIModel$annuaireDecoder, reponse));
			} else {
				var _v2 = msg.a;
				var reponse = msg.b;
				return $author$project$Components$Produits$Listes$Update$deLaLecture(
					A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Listes$API$QueryAPIModel$listeDecoder, reponse));
			}
		case 1:
			var octets = msg.a;
			return _Utils_eq(
				$author$project$API$ProcessUid$depuisOctets(octets),
				$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
				{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Main$Update$requeteSurLesListes = function (effet) {
	switch (effet.$) {
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Produits$Listes$Update$DeLAnnuaire = 0;
var $author$project$Components$Produits$Listes$Update$DemanderProcessUid = {$: 0};
var $author$project$Components$Produits$Listes$Update$Lire = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Produits$Listes$API$WriteAPIErrorsModel$AttributsInvalides = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Produits$Listes$Update$AttendreAvantDeRelire = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$Listes$Update$relire = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$Produits$Listes$Update$Lire(0),
				$elm$core$List$singleton),
			model.np));
};
var $author$project$Components$Produits$Listes$Update$PlacerFocus = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Produits$Listes$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{kX: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Produits$Listes$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: model.hP !== ''},
				geste,
				model.kX));
	});
var $author$project$Components$Produits$Listes$Update$fermerApresSucces = F2(
	function (rendue, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Basics$append(
				rendue.sy ? $author$project$Components$Produits$Listes$Update$relire(model) : _List_fromArray(
					[
						$author$project$Components$Produits$Listes$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
					])),
			A2(
				$author$project$Components$Produits$Listes$Update$versLeDrawer,
				$author$project$Components$Shared$Drawer$Update$Fermer,
				_Utils_update(
					model,
					{mW: $elm$core$Maybe$Nothing, pZ: $elm$core$Maybe$Nothing, hP: ''})));
	});
var $author$project$I18n$Textes$listesRefusAttributsInvalides = A3($author$project$I18n$Traductions$texte, 'listes.refus.attributs-invalides', _List_Nil, 'Les attributs de cette valeur ne sont pas valides.');
var $author$project$I18n$Textes$listesRefusAucunSchema = A3($author$project$I18n$Traductions$texte, 'listes.refus.aucun-schema', _List_Nil, 'Cette liste n\'a pas d\'attributs : ajoutez la valeur sans attribut.');
var $author$project$I18n$Textes$listesRefusAutre = A3($author$project$I18n$Traductions$texte, 'listes.refus.autre', _List_Nil, 'La commande a été refusée.');
var $author$project$I18n$Textes$listesRefusLibellePris = A3($author$project$I18n$Traductions$texte, 'listes.refus.libelle-pris', _List_Nil, 'Cette liste a déjà une valeur de ce libellé.');
var $author$project$I18n$Textes$listesRefusLibelleVide = A3($author$project$I18n$Traductions$texte, 'listes.refus.libelle-vide', _List_Nil, 'Saisissez le libellé de la valeur.');
var $author$project$I18n$Textes$listesRefusNomPris = A3($author$project$I18n$Traductions$texte, 'listes.refus.nom-pris', _List_Nil, 'Une liste porte déjà ce nom.');
var $author$project$I18n$Textes$listesRefusNomVide = A3($author$project$I18n$Traductions$texte, 'listes.refus.nom-vide', _List_Nil, 'Saisissez le nom de la liste.');
var $author$project$I18n$Textes$listesRefusSchemaIncompatible = A3($author$project$I18n$Traductions$texte, 'listes.refus.schema-incompatible', _List_Nil, 'Ces attributs rendraient invalides des valeurs déjà renseignées.');
var $author$project$Components$Produits$Listes$Update$libelleDuRefus = function (erreur) {
	switch (erreur.$) {
		case 0:
			return $author$project$I18n$Textes$listesRefusNomPris;
		case 1:
			return $author$project$I18n$Textes$listesRefusNomVide;
		case 2:
			return $author$project$I18n$Textes$listesRefusLibelleVide;
		case 3:
			return $author$project$I18n$Textes$listesRefusLibellePris;
		case 4:
			return $author$project$I18n$Textes$listesRefusSchemaIncompatible;
		case 5:
			return $author$project$I18n$Textes$listesRefusAttributsInvalides;
		case 6:
			return $author$project$I18n$Textes$listesRefusAucunSchema;
		default:
			return $author$project$I18n$Textes$listesRefusAutre;
	}
};
var $author$project$Components$Produits$Listes$Update$conclure = F2(
	function (issue, model) {
		switch (issue.$) {
			case 0:
				var rendue = issue.b;
				return (!_Utils_eq(model.rn, $elm$core$Maybe$Nothing)) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Produits$Listes$Update$fermerApresSucces, rendue, model);
			case 1:
				if (issue.c.$ === 5) {
					var champs = issue.c.a;
					return $elm$core$List$isEmpty(champs) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{
								fL: _List_Nil,
								pZ: $elm$core$Maybe$Just(
									$author$project$Components$Produits$Listes$Update$libelleDuRefus(
										$author$project$Components$Produits$Listes$API$WriteAPIErrorsModel$AttributsInvalides(champs))),
								rn: $elm$core$Maybe$Nothing
							}),
						_List_Nil) : _Utils_Tuple2(
						_Utils_update(
							model,
							{fL: champs, pZ: $elm$core$Maybe$Nothing, rn: $elm$core$Maybe$Nothing}),
						_List_Nil);
				} else {
					var erreur = issue.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								fL: _List_Nil,
								pZ: $elm$core$Maybe$Just(
									$author$project$Components$Produits$Listes$Update$libelleDuRefus(erreur)),
								rn: $elm$core$Maybe$Nothing
							}),
						_List_Nil);
				}
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$Listes$API$WriteAPIModel$AjouterUneValeur = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$Listes$API$WriteAPIModel$CreerUneListe = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Produits$Listes$API$WriteAPIModel$DefinirLeSchemaDAttributs = F3(
	function (a, b, c) {
		return {$: 7, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$Listes$API$WriteAPIModel$MasquerUneValeur = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Produits$Listes$API$WriteAPIModel$RenommerUneValeur = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$Listes$API$WriteAPIModel$RenseignerLesAttributs = F4(
	function (a, b, c, d) {
		return {$: 3, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Produits$Listes$Model$attributsDePays = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.i8;
				},
				$elm$core$List$filter(
					function ($) {
						return $.ho;
					})),
			model.nW));
};
var $author$project$Components$Produits$Listes$Model$attributDuGeste = function (model) {
	var _v0 = model.mW;
	if ((!_v0.$) && (_v0.a.$ === 5)) {
		var _v1 = _v0.a;
		var cle = _v1.b;
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (attribut) {
					return _Utils_eq(attribut.dy, cle);
				},
				$author$project$Components$Produits$Listes$Model$attributsDePays(model)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$Listes$Model$attributsRenseignes = F2(
	function (liste, model) {
		return A2(
			$elm$core$List$filterMap,
			function (attribut) {
				return A2(
					$elm$core$Maybe$andThen,
					function (texte) {
						return (texte === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							_Utils_Tuple2(attribut.dy, texte));
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$String$trim,
						A2($elm$core$Dict$get, attribut.dy, model.fC)));
			},
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ho;
					},
					$elm$core$Basics$not),
				liste.i8));
	});
var $author$project$Components$Produits$Listes$Model$lienDe = F2(
	function (rel, model) {
		var _v0 = _Utils_Tuple2(model.nW, model.aS);
		if (!_v0.a.$) {
			var liste = _v0.a.a;
			return A2($author$project$API$Liens$trouver, rel, liste.nQ.h0);
		} else {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var annuaire = _v0.b.a;
				return A2($author$project$API$Liens$trouver, rel, annuaire.nQ.h0);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$API$NavLinksDictionary$renseignerLesAttributs = 'renseigner-les-attributs';
var $author$project$Components$Produits$Listes$Model$attributsModifies = F3(
	function (liste, valeur, model) {
		return (!_Utils_eq(
			A2($author$project$Components$Produits$Listes$Model$lienDe, $author$project$API$NavLinksDictionary$renseignerLesAttributs, model),
			$elm$core$Maybe$Nothing)) && (!_Utils_eq(
			$elm$core$Dict$fromList(
				A2($author$project$Components$Produits$Listes$Model$attributsRenseignes, liste, model)),
			valeur.i8));
	});
var $author$project$API$NavLinksDictionary$definirLeSchemaDAttributs = 'definir-le-schema-d-attributs';
var $author$project$API$NavLinksDictionary$masquerUneValeur = 'masquer-une-valeur';
var $author$project$Components$Produits$Listes$Model$porteeEnCle = function (portee) {
	switch (portee) {
		case 0:
			return 'catalogue';
		case 1:
			return 'parties-prenantes';
		default:
			return 'catalogue-et-parties-prenantes';
	}
};
var $author$project$API$NavLinksDictionary$renommerUneValeur = 'renommer-une-valeur';
var $author$project$Components$Produits$Listes$Model$valeurDuGeste = function (model) {
	var _v0 = _Utils_Tuple2(model.mW, model.nW);
	_v0$3:
	while (true) {
		if ((!_v0.a.$) && (!_v0.b.$)) {
			switch (_v0.a.a.$) {
				case 2:
					var id = _v0.a.a.a;
					var liste = _v0.b.a;
					return $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (valeur) {
								return _Utils_eq(valeur.Aq, id);
							},
							liste.Ki));
				case 3:
					var id = _v0.a.a.a;
					var liste = _v0.b.a;
					return $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (valeur) {
								return _Utils_eq(valeur.Aq, id);
							},
							liste.Ki));
				case 5:
					var _v1 = _v0.a.a;
					var id = _v1.a;
					var liste = _v0.b.a;
					return $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (valeur) {
								return _Utils_eq(valeur.Aq, id);
							},
							liste.Ki));
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Components$Produits$Listes$Model$commande = function (model) {
	var saisi = $elm$core$String$trim(model.hP);
	var deLaListe = function (faire) {
		return A2(
			$elm$core$Maybe$andThen,
			function (liste) {
				return faire(liste);
			},
			model.nW);
	};
	var avecLien = F2(
		function (rel, commandeFaite) {
			return A2(
				$elm$core$Maybe$map,
				function (lien) {
					return _Utils_Tuple2(commandeFaite, lien);
				},
				A2($author$project$Components$Produits$Listes$Model$lienDe, rel, model));
		});
	var _v0 = model.mW;
	if (!_v0.$) {
		switch (_v0.a.$) {
			case 0:
				var _v1 = _v0.a;
				return (saisi === '') ? $elm$core$Maybe$Nothing : A2(
					avecLien,
					$author$project$API$NavLinksDictionary$creerUneListe,
					A2(
						$author$project$Components$Produits$Listes$API$WriteAPIModel$CreerUneListe,
						saisi,
						$author$project$Components$Produits$Listes$Model$porteeEnCle(model.F$)));
			case 1:
				var _v2 = _v0.a;
				return (saisi === '') ? $elm$core$Maybe$Nothing : deLaListe(
					function (liste) {
						return A2(
							avecLien,
							$author$project$API$NavLinksDictionary$ajouterUneValeur,
							A3(
								$author$project$Components$Produits$Listes$API$WriteAPIModel$AjouterUneValeur,
								liste.Aq,
								saisi,
								A2($author$project$Components$Produits$Listes$Model$attributsRenseignes, liste, model)));
					});
			case 2:
				var id = _v0.a.a;
				if (saisi === '') {
					return $elm$core$Maybe$Nothing;
				} else {
					var _v3 = _Utils_Tuple2(
						$author$project$Components$Produits$Listes$Model$valeurDuGeste(model),
						model.nW);
					if ((!_v3.a.$) && (!_v3.b.$)) {
						var valeur = _v3.a.a;
						var liste = _v3.b.a;
						return (_Utils_eq(saisi, valeur.Bl) && A3($author$project$Components$Produits$Listes$Model$attributsModifies, liste, valeur, model)) ? A2(
							avecLien,
							$author$project$API$NavLinksDictionary$renseignerLesAttributs,
							A4(
								$author$project$Components$Produits$Listes$API$WriteAPIModel$RenseignerLesAttributs,
								liste.Aq,
								id,
								A2($author$project$Components$Produits$Listes$Model$attributsRenseignes, liste, model),
								$elm$core$Dict$toList(valeur.ho))) : A2(
							avecLien,
							$author$project$API$NavLinksDictionary$renommerUneValeur,
							A3($author$project$Components$Produits$Listes$API$WriteAPIModel$RenommerUneValeur, liste.Aq, id, saisi));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}
			case 3:
				var id = _v0.a.a;
				return deLaListe(
					function (liste) {
						return A2(
							avecLien,
							$author$project$API$NavLinksDictionary$masquerUneValeur,
							A2($author$project$Components$Produits$Listes$API$WriteAPIModel$MasquerUneValeur, liste.Aq, id));
					});
			case 5:
				var _v4 = _v0.a;
				var id = _v4.a;
				var _v5 = _Utils_Tuple3(
					model.nW,
					$author$project$Components$Produits$Listes$Model$valeurDuGeste(model),
					$author$project$Components$Produits$Listes$Model$attributDuGeste(model));
				if (((!_v5.a.$) && (!_v5.b.$)) && (!_v5.c.$)) {
					var liste = _v5.a.a;
					var valeur = _v5.b.a;
					var attribut = _v5.c.a;
					return A2(
						avecLien,
						$author$project$API$NavLinksDictionary$renseignerLesAttributs,
						A4(
							$author$project$Components$Produits$Listes$API$WriteAPIModel$RenseignerLesAttributs,
							liste.Aq,
							id,
							$elm$core$Dict$toList(valeur.i8),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(attribut.dy, model.hp.jL),
								A2(
									$elm$core$List$filter,
									function (_v6) {
										var cle = _v6.a;
										return !_Utils_eq(cle, attribut.dy);
									},
									$elm$core$Dict$toList(valeur.ho)))));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			default:
				var _v7 = _v0.a;
				return A2(
					$elm$core$List$any,
					function (attribut) {
						return ($elm$core$String$trim(attribut.dy) === '') || ($elm$core$String$trim(attribut.Bl) === '');
					},
					model.i8) ? $elm$core$Maybe$Nothing : deLaListe(
					function (liste) {
						return A2(
							avecLien,
							$author$project$API$NavLinksDictionary$definirLeSchemaDAttributs,
							A3($author$project$Components$Produits$Listes$API$WriteAPIModel$DefinirLeSchemaDAttributs, liste.Aq, liste.KK + 1, model.i8));
					});
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$Listes$API$WriteAPIErrorsModel$Autre = {$: 7};
var $author$project$Components$Produits$Listes$Update$Envoyer = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$Listes$Update$Reconnecter = {$: 5};
var $author$project$Components$Produits$Listes$API$WriteAPIErrorsModel$AucunSchemaDAttributs = {$: 6};
var $author$project$Components$Produits$Listes$API$WriteAPIErrorsModel$LibelleDejaPris = {$: 3};
var $author$project$Components$Produits$Listes$API$WriteAPIErrorsModel$LibelleVide = {$: 2};
var $author$project$Components$Produits$Listes$API$WriteAPIErrorsModel$NomDejaPris = {$: 0};
var $author$project$Components$Produits$Listes$API$WriteAPIErrorsModel$NomVide = {$: 1};
var $author$project$Components$Produits$Listes$API$WriteAPIErrorsModel$SchemaIncompatible = {$: 4};
var $author$project$Components$Produits$Listes$API$WriteAPIErrorsModel$duRefus = function (refus) {
	var _v0 = refus.bB;
	_v0$7:
	while (true) {
		switch (_v0.$) {
			case 1:
				switch (_v0.a) {
					case 'NomDeListeDejaPris':
						return $author$project$Components$Produits$Listes$API$WriteAPIErrorsModel$NomDejaPris;
					case 'NomVide':
						return $author$project$Components$Produits$Listes$API$WriteAPIErrorsModel$NomVide;
					case 'LibelleVide':
						return $author$project$Components$Produits$Listes$API$WriteAPIErrorsModel$LibelleVide;
					case 'LibelleDejaPris':
						return $author$project$Components$Produits$Listes$API$WriteAPIErrorsModel$LibelleDejaPris;
					case 'SchemaIncompatible':
						return $author$project$Components$Produits$Listes$API$WriteAPIErrorsModel$SchemaIncompatible;
					case 'AucunSchemaDAttributs':
						return $author$project$Components$Produits$Listes$API$WriteAPIErrorsModel$AucunSchemaDAttributs;
					default:
						break _v0$7;
				}
			case 3:
				if (_v0.a === 'AttributsInvalides') {
					var champs = _v0.b;
					return $author$project$Components$Produits$Listes$API$WriteAPIErrorsModel$AttributsInvalides(champs);
				} else {
					break _v0$7;
				}
			default:
				break _v0$7;
		}
	}
	return $author$project$Components$Produits$Listes$API$WriteAPIErrorsModel$Autre;
};
var $author$project$Components$Produits$Listes$API$WriteAPIModel$Rendue = F2(
	function (vuesAJour, liens) {
		return {nQ: liens, sy: vuesAJour};
	});
var $author$project$Components$Produits$Listes$API$WriteAPIModel$rendueDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'liens',
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vuesAJour',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Components$Produits$Listes$API$WriteAPIModel$Rendue)));
var $author$project$Components$Produits$Listes$Update$reglage = {
	f8: $author$project$Components$Produits$Listes$Update$DemanderProcessUid,
	l4: $author$project$Components$Produits$Listes$Update$Envoyer,
	go: function (reponse) {
		var _v0 = A2(
			$author$project$API$Reponse$lire,
			$elm$json$Json$Decode$succeed(0),
			reponse);
		if (_v0.$ === 1) {
			var refus = _v0.a;
			return $author$project$Components$Produits$Listes$API$WriteAPIErrorsModel$duRefus(refus);
		} else {
			return $author$project$Components$Produits$Listes$API$WriteAPIErrorsModel$Autre;
		}
	},
	pW: $author$project$Components$Produits$Listes$Update$Reconnecter,
	qu: F2(
		function (_v1, _v2) {
			return true;
		}),
	qv: $author$project$Components$Produits$Listes$API$WriteAPIModel$rendueDecoder
};
var $author$project$Components$Produits$Listes$Update$partir = F3(
	function (lien, commande, model) {
		var _v0 = A4(
			$author$project$API$Envoi$partir,
			$author$project$Components$Produits$Listes$Update$reglage,
			$elm$core$Maybe$Just(lien),
			commande,
			model.l2);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var envoi = _v1.a;
			var effets = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{fL: _List_Nil, l2: envoi, pZ: $elm$core$Maybe$Nothing}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$Listes$Model$suiteDuRenommage = function (model) {
	var _v0 = _Utils_Tuple3(
		model.mW,
		$author$project$Components$Produits$Listes$Model$valeurDuGeste(model),
		model.nW);
	if ((((!_v0.a.$) && (_v0.a.a.$ === 2)) && (!_v0.b.$)) && (!_v0.c.$)) {
		var id = _v0.a.a.a;
		var valeur = _v0.b.a;
		var liste = _v0.c.a;
		return ((!_Utils_eq(
			$elm$core$String$trim(model.hP),
			valeur.Bl)) && A3($author$project$Components$Produits$Listes$Model$attributsModifies, liste, valeur, model)) ? A2(
			$elm$core$Maybe$map,
			function (lien) {
				return _Utils_Tuple2(
					A4(
						$author$project$Components$Produits$Listes$API$WriteAPIModel$RenseignerLesAttributs,
						liste.Aq,
						id,
						A2($author$project$Components$Produits$Listes$Model$attributsRenseignes, liste, model),
						$elm$core$Dict$toList(valeur.ho)),
					lien);
			},
			A2($author$project$Components$Produits$Listes$Model$lienDe, $author$project$API$NavLinksDictionary$renseignerLesAttributs, model)) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$Listes$Update$envoyer = function (model) {
	var _v0 = $author$project$Components$Produits$Listes$Model$commande(model);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var commande = _v1.a;
		var lien = _v1.b;
		return A3(
			$author$project$Components$Produits$Listes$Update$partir,
			lien,
			commande,
			_Utils_update(
				model,
				{
					rn: $author$project$Components$Produits$Listes$Model$suiteDuRenommage(model)
				}));
	} else {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{b5: true}),
			_List_Nil);
	}
};
var $author$project$Components$Produits$Listes$Update$DeLaListe = 1;
var $author$project$Components$Produits$Listes$Update$lireLaFiche = F2(
	function (annuaire, model) {
		var _v0 = model.vf;
		if (_v0.$ === 1) {
			return _List_Nil;
		} else {
			var id = _v0.a;
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (lien) {
						return _List_fromArray(
							[
								A2($author$project$Components$Produits$Listes$Update$Lire, 1, lien)
							]);
					},
					A2(
						$elm$core$Maybe$andThen,
						function (resume) {
							return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$liste, resume.nQ.h0);
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (resume) {
									return _Utils_eq(resume.Aq, id);
								},
								annuaire.n_)))));
		}
	});
var $author$project$Components$Produits$Listes$Update$lue = F3(
	function (lecture, reponse, model) {
		if (!lecture) {
			var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Listes$API$QueryAPIModel$annuaireDecoder, reponse);
			if (!_v1.$) {
				var annuaire = _v1.a;
				var effets = A2($author$project$Components$Produits$Listes$Update$lireLaFiche, annuaire, model);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aS: $elm$core$Maybe$Just(annuaire),
							nf: (!_Utils_eq(model.vf, $elm$core$Maybe$Nothing)) && _Utils_eq(effets, _List_Nil)
						}),
					effets);
			} else {
				var refus = _v1.a;
				return _Utils_Tuple2(
					model,
					(refus.ri === 401) ? _List_fromArray(
						[$author$project$Components$Produits$Listes$Update$Reconnecter]) : _List_Nil);
			}
		} else {
			var _v2 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Listes$API$QueryAPIModel$listeDecoder, reponse);
			if (!_v2.$) {
				var liste = _v2.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							nW: $elm$core$Maybe$Just(liste)
						}),
					_List_Nil);
			} else {
				var refus = _v2.a;
				return _Utils_Tuple2(
					model,
					(refus.ri === 401) ? _List_fromArray(
						[$author$project$Components$Produits$Listes$Update$Reconnecter]) : _List_Nil);
			}
		}
	});
var $author$project$Components$Produits$Listes$Model$idDeLaCreation = 'listes-creer';
var $author$project$Components$Produits$Listes$Model$idDuDeclencheur = function (geste) {
	switch (geste.$) {
		case 0:
			return $author$project$Components$Produits$Listes$Model$idDeLaCreation;
		case 1:
			return 'listes-valeur-ajouter';
		case 4:
			return 'listes-schema-definir';
		case 2:
			var valeur = geste.a;
			return 'listes-valeur-renommer-' + valeur;
		case 3:
			var valeur = geste.a;
			return 'listes-valeur-masquer-' + valeur;
		default:
			var valeur = geste.a;
			var cle = geste.b;
			return 'listes-valeur-pays-' + (valeur + ('-' + cle));
	}
};
var $author$project$Components$Produits$Listes$Update$relDuGeste = function (geste) {
	switch (geste.$) {
		case 0:
			return $author$project$API$NavLinksDictionary$creerUneListe;
		case 1:
			return $author$project$API$NavLinksDictionary$ajouterUneValeur;
		case 2:
			return $author$project$API$NavLinksDictionary$renommerUneValeur;
		case 3:
			return $author$project$API$NavLinksDictionary$masquerUneValeur;
		case 4:
			return $author$project$API$NavLinksDictionary$definirLeSchemaDAttributs;
		default:
			return $author$project$API$NavLinksDictionary$renseignerLesAttributs;
	}
};
var $author$project$Components$Produits$Listes$Update$ouvrir = F2(
	function (geste, model) {
		var ouvert = _Utils_update(
			model,
			{
				i8: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.i8;
						},
						model.nW)),
				fC: $elm$core$Dict$empty,
				fL: _List_Nil,
				mW: $elm$core$Maybe$Just(geste),
				pZ: $elm$core$Maybe$Nothing,
				hP: '',
				rn: $elm$core$Maybe$Nothing,
				b5: false
			});
		var pays = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$Basics$identity,
				A3(
					$elm$core$Maybe$map2,
					F2(
						function (valeur, attribut) {
							return A2($elm$core$Dict$get, attribut.dy, valeur.ho);
						}),
					$author$project$Components$Produits$Listes$Model$valeurDuGeste(ouvert),
					$author$project$Components$Produits$Listes$Model$attributDuGeste(ouvert))));
		var valeurs = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Dict$empty,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.i8;
				},
				$author$project$Components$Produits$Listes$Model$valeurDuGeste(ouvert)));
		var libelle = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				$author$project$Components$Produits$Listes$Model$valeurDuGeste(ouvert)));
		return _Utils_eq(
			A2(
				$author$project$Components$Produits$Listes$Model$lienDe,
				$author$project$Components$Produits$Listes$Update$relDuGeste(geste),
				model),
			$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A2(
			$author$project$Components$Produits$Listes$Update$versLeDrawer,
			$author$project$Components$Shared$Drawer$Update$Ouvrir(
				$author$project$Components$Produits$Listes$Model$idDuDeclencheur(geste)),
			_Utils_update(
				ouvert,
				{
					fC: valeurs,
					hp: {jL: pays, hC: ''},
					hP: libelle
				}));
	});
var $author$project$Components$Produits$Listes$Model$DesDeux = 2;
var $author$project$Components$Produits$Listes$Model$DesPartiesPrenantes = 1;
var $author$project$Components$Produits$Listes$Model$porteeDeLaCle = function (cle) {
	switch (cle) {
		case 'parties-prenantes':
			return 1;
		case 'catalogue-et-parties-prenantes':
			return 2;
		default:
			return 0;
	}
};
var $author$project$Components$Produits$Listes$API$WriteAPIModel$RangerUneValeur = F3(
	function (a, b, c) {
		return {$: 6, a: a, b: b, c: c};
	});
var $author$project$API$NavLinksDictionary$rangerUneValeur = 'ranger-une-valeur';
var $author$project$Components$Produits$Listes$Update$ranger = F3(
	function (id, position, model) {
		var _v0 = _Utils_Tuple2(
			model.nW,
			A2($author$project$Components$Produits$Listes$Model$lienDe, $author$project$API$NavLinksDictionary$rangerUneValeur, model));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var liste = _v0.a.a;
			var lien = _v0.b.a;
			return A3(
				$author$project$Components$Produits$Listes$Update$partir,
				lien,
				A3($author$project$Components$Produits$Listes$API$WriteAPIModel$RangerUneValeur, liste.Aq, id, position),
				_Utils_update(
					model,
					{mW: $elm$core$Maybe$Nothing}));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$Listes$API$WriteAPIModel$ReactiverUneValeur = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$Produits$Listes$Update$reactiver = F2(
	function (id, model) {
		var _v0 = model.nW;
		if (!_v0.$) {
			var liste = _v0.a;
			var _v1 = A2(
				$elm$core$Maybe$andThen,
				function (valeur) {
					return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reactiverUneValeur, valeur.nQ.h0);
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (valeur) {
							return _Utils_eq(valeur.Aq, id);
						},
						liste.Ki)));
			if (!_v1.$) {
				var lien = _v1.a;
				return A3(
					$author$project$Components$Produits$Listes$Update$partir,
					lien,
					A2($author$project$Components$Produits$Listes$API$WriteAPIModel$ReactiverUneValeur, liste.Aq, id),
					_Utils_update(
						model,
						{mW: $elm$core$Maybe$Nothing}));
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$Listes$Update$suivre = function (model) {
	var _v0 = model.rn;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var commande = _v1.a;
		var lien = _v1.b;
		return A3(
			$author$project$Components$Produits$Listes$Update$partir,
			lien,
			commande,
			_Utils_update(
				model,
				{rn: $elm$core$Maybe$Nothing}));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$Listes$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var cible = msg.a;
				var liens = msg.b;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$listes, liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Produits$Listes$Model$ouvert,
							$elm$core$Maybe$Just(lecture),
							cible),
						_List_fromArray(
							[
								$author$project$Components$Produits$Listes$Update$DemanderProcessUid,
								A2($author$project$Components$Produits$Listes$Update$Lire, 0, lecture)
							]));
				} else {
					return _Utils_Tuple2(
						A2($author$project$Components$Produits$Listes$Model$ouvert, $elm$core$Maybe$Nothing, cible),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				return $author$project$Components$Produits$Listes$Update$suivre(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}));
			case 2:
				var lecture = msg.a;
				var reponse = msg.b;
				return A3($author$project$Components$Produits$Listes$Update$lue, lecture, reponse, model);
			case 3:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Produits$Listes$Update$relire(model));
			case 4:
				var geste = msg.a;
				return ($author$project$API$Envoi$enCours(model.l2) && A2(
					$elm$core$List$member,
					geste,
					_List_fromArray(
						[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$SortieDemandee, $author$project$Components$Shared$Drawer$Update$AbandonConfirme]))) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Produits$Listes$Update$versLeDrawer, geste, model);
			case 5:
				var geste = msg.a;
				return A2($author$project$Components$Produits$Listes$Update$ouvrir, geste, model);
			case 6:
				var texte = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{hP: texte}),
					_List_Nil);
			case 7:
				var cle = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							F$: $author$project$Components$Produits$Listes$Model$porteeDeLaCle(cle)
						}),
					_List_Nil);
			case 8:
				var rang = msg.a;
				var cle = msg.b;
				var libelle = msg.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							i8: A2(
								$elm$core$List$indexedMap,
								F2(
									function (i, attribut) {
										return _Utils_eq(i, rang) ? _Utils_update(
											attribut,
											{dy: cle, Bl: libelle}) : attribut;
									}),
								model.i8)
						}),
					_List_Nil);
			case 10:
				var cle = msg.a;
				var texte = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fC: A3($elm$core$Dict$insert, cle, texte, model.fC),
							fL: A2(
								$elm$core$List$filter,
								function (nom) {
									return !_Utils_eq(nom, cle);
								},
								model.fL)
						}),
					_List_Nil);
			case 11:
				var selection = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{hp: selection}),
					_List_Nil);
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							i8: _Utils_ap(
								model.i8,
								_List_fromArray(
									[
										{dy: '', Bl: '', ho: false}
									]))
						}),
					_List_Nil);
			case 12:
				return $author$project$Components$Produits$Listes$Update$envoyer(model);
			case 13:
				var id = msg.a;
				var position = msg.b;
				return A3($author$project$Components$Produits$Listes$Update$ranger, id, position, model);
			case 14:
				var id = msg.a;
				return A2($author$project$Components$Produits$Listes$Update$reactiver, id, model);
			default:
				var reponse = msg.a;
				var _v2 = A3($author$project$API$Envoi$conclure, $author$project$Components$Produits$Listes$Update$reglage, reponse, model.l2);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var envoi = _v3.a;
					var issue = _v3.b;
					var effets = _v3.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Produits$Listes$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Main$Update$versLesListes = F3(
	function (i18n, msg, model) {
		var _v0 = A2(
			$author$project$Components$Produits$Listes$Update$update,
			msg,
			A2(
				$author$project$Referentiel$Normes$poser,
				model.hd,
				$author$project$Components$Produits$Listes$Model$ouvrir(model.n_)));
		var listes = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLesListes, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLesListes,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						n_: $author$project$Components$Produits$Listes$Model$envelopper(listes),
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Produits$Listes$Update$popMessages(msg),
							gardes)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$AnnuaireDesListesDePrix = 12;
var $author$project$Main$Model$PourLesListesDePrix = 27;
var $author$project$Components$Produits$ListesDePrix$API$QueryAPIModel$Annuaire = F6(
	function (listes, nombre, prixParPublic, devisesProposees, liens, gabarits) {
		return {xx: devisesProposees, gF: gabarits, nQ: liens, n_: listes, w: nombre, Gm: prixParPublic};
	});
var $author$project$Components$Produits$ListesDePrix$API$QueryAPIModel$PrixParPublic = F2(
	function (_public, liste) {
		return {nW: liste, pF: _public};
	});
var $author$project$Components$Produits$ListesDePrix$API$QueryAPIModel$Liste = function (id) {
	return function (nom) {
		return function (publics) {
			return function (publique) {
				return function (devise) {
					return function (taxes) {
						return function (validite) {
							return function (etat) {
								return function (enConflit) {
									return function (lignes) {
										return function (ouvrable) {
											return {kO: devise, yi: enConflit, gt: etat, Aq: id, gV: lignes, Dj: nom, Ex: ouvrable, GA: publics, GF: publique, rB: taxes, sk: validite};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Produits$ListesDePrix$API$QueryAPIModel$listeDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.h0;
			},
			A2(
				$elm$core$Basics$composeR,
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$self),
				$elm$core$Basics$neq($elm$core$Maybe$Nothing))),
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'lignes',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'enConflit',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'etat',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'validite',
					$author$project$Catalogue$API$PrixAPIModel$validiteDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'taxes',
						$author$project$Catalogue$API$PrixAPIModel$taxesDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'devise',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'publique',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'publics',
									$elm$json$Json$Decode$list($author$project$Catalogue$API$PrixAPIModel$publicDecoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'nom',
										$author$project$Catalogue$API$QueryAPIModel$libellesDecoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$author$project$Catalogue$Identifiants$listeDePrixIdDecoder,
											$elm$json$Json$Decode$succeed($author$project$Components$Produits$ListesDePrix$API$QueryAPIModel$Liste))))))))))));
var $author$project$Components$Produits$ListesDePrix$API$QueryAPIModel$annuaireDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.gF;
		},
		$author$project$API$Liens$deLaRessource),
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		A2(
			$elm$json$Json$Decode$map,
			function ($) {
				return $.h0;
			},
			$author$project$API$Liens$deLaRessource),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'devisesProposees',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'prixParPublic',
				$elm$json$Json$Decode$list(
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'liste',
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$PrixAPIModel$listeNommeeDecoder),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'public',
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$PrixAPIModel$typeProposeDecoder),
							$elm$core$Maybe$Nothing,
							$elm$json$Json$Decode$succeed($author$project$Components$Produits$ListesDePrix$API$QueryAPIModel$PrixParPublic)))),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'nombre',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'listes',
						$elm$json$Json$Decode$list($author$project$Components$Produits$ListesDePrix$API$QueryAPIModel$listeDecoder),
						$elm$json$Json$Decode$succeed($author$project$Components$Produits$ListesDePrix$API$QueryAPIModel$Annuaire)))))));
var $author$project$Components$Produits$ListesDePrix$Update$popMessages = function (msg) {
	switch (msg.$) {
		case 2:
			var reponse = msg.a;
			var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$ListesDePrix$API$QueryAPIModel$annuaireDecoder, reponse);
			if (_v1.$ === 1) {
				var refus = _v1.a;
				return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Components$Shared$Messages$Model$duRefus(refus));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 1:
			var octets = msg.a;
			return _Utils_eq(
				$author$project$API$ProcessUid$depuisOctets(octets),
				$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
				{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$ListesDePrix$Creation$proposes = function (annuaire) {
	return A2(
		$elm$core$List$filterMap,
		function ($) {
			return $.pF;
		},
		annuaire.Gm);
};
var $author$project$Components$Produits$ListesDePrix$Model$appliquer = F2(
	function (rendue, annuaire) {
		var carte = function (evenement) {
			if (evenement.$ === 56) {
				var id = evenement.a;
				var creee = evenement.b;
				return $elm$core$Maybe$Just(
					{
						kO: creee.kO,
						yi: false,
						gt: '',
						Aq: id,
						gV: 0,
						Dj: creee.Dj,
						Ex: !_Utils_eq(
							A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$self, rendue.nQ),
							$elm$core$Maybe$Nothing),
						GA: A2(
							$elm$core$List$filter,
							function (_public) {
								return A2($elm$core$List$member, _public.Hb, creee.GA);
							},
							$author$project$Components$Produits$ListesDePrix$Creation$proposes(annuaire)),
						GF: false,
						rB: creee.rB,
						sk: creee.sk
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		var creees = A2($elm$core$List$filterMap, carte, rendue.mk);
		return _Utils_update(
			annuaire,
			{
				n_: _Utils_ap(creees, annuaire.n_),
				w: annuaire.w + $elm$core$List$length(creees)
			});
	});
var $author$project$Components$Produits$ListesDePrix$Creation$prefixeDuNom = function (prefixe) {
	return prefixe + '-nom';
};
var $author$project$Components$Produits$ListesDePrix$Creation$idDe = F2(
	function (prefixe, zone) {
		switch (zone) {
			case 0:
				return $author$project$Components$Produits$Common$LibellesSaisis$idDuPremierChamp(
					$author$project$Components$Produits$ListesDePrix$Creation$prefixeDuNom(prefixe));
			case 1:
				return prefixe + '-devise';
			case 2:
				return prefixe + '-taux';
			case 3:
				return prefixe + '-debut';
			default:
				return prefixe + '-fin';
		}
	});
var $author$project$Components$Produits$ListesDePrix$Update$perime = function (erreur) {
	return A2(
		$elm$core$List$member,
		erreur,
		_List_fromArray(
			[$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$PublicRefuse, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$DejaExistant, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$Introuvable]));
};
var $author$project$Components$Produits$ListesDePrix$Creation$ZoneDevise = 1;
var $author$project$Components$Produits$ListesDePrix$Creation$ZoneFin = 4;
var $author$project$Components$Produits$ListesDePrix$Creation$ZoneNom = 0;
var $author$project$Components$Produits$ListesDePrix$Creation$ZoneTaux = 2;
var $author$project$Components$Produits$ListesDePrix$Creation$nomSaisi = function (saisie) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.zX;
			},
			$author$project$Components$Produits$Common$LibellesSaisis$versLApi(saisie.Dj)));
};
var $author$project$I18n$Textes$produitsListesDePrixCreationFinAvantLeDebut = A3($author$project$I18n$Traductions$texte, 'produits.listes-de-prix.creation.fin.avant-le-debut', _List_Nil, 'La fin précède le début.');
var $author$project$I18n$Textes$saisieDeChampMotif = A3($author$project$I18n$Traductions$texte, 'saisie-de-champ.motif', _List_Nil, 'Le format attendu n\'est pas respecté.');
var $author$project$Components$Produits$ListesDePrix$Update$refusDe = F4(
	function (annuaire, model, refus, erreur) {
		var zoneDe = function (champ) {
			switch (champ) {
				case 'nom':
					return $elm$core$Maybe$Just(0);
				case 'devise':
					return $elm$core$Maybe$Just(1);
				case 'taxes':
					return $elm$core$Maybe$Just(2);
				case 'validite':
					return $elm$core$Maybe$Just(4);
				default:
					return $elm$core$Maybe$Nothing;
			}
		};
		var enTete = function (texte) {
			return _Utils_Tuple2(
				_List_fromArray(
					[
						{Jx: texte, b9: refus.b9}
					]),
				$elm$core$Maybe$Nothing);
		};
		switch (erreur.$) {
			case 60:
				var conflits = erreur.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$List$map,
						function (texte) {
							return {Jx: texte, b9: refus.b9};
						},
						A2(
							$author$project$Components$Produits$Common$Prix$conflits,
							{
								v3: $author$project$Components$Produits$ListesDePrix$Creation$proposes(annuaire),
								nW: $author$project$Components$Produits$ListesDePrix$Creation$nomSaisi(model.hP)
							},
							conflits)),
					$elm$core$Maybe$Nothing);
			case 63:
				return _Utils_Tuple2(
					_List_Nil,
					$elm$core$Maybe$Just(
						_Utils_Tuple2(4, $author$project$I18n$Textes$produitsListesDePrixCreationFinAvantLeDebut)));
			case 66:
				var champs = erreur.a;
				var _v1 = A2($elm$core$List$filterMap, zoneDe, champs);
				if (_v1.b) {
					var zone = _v1.a;
					return _Utils_Tuple2(
						_List_Nil,
						$elm$core$Maybe$Just(
							_Utils_Tuple2(zone, $author$project$I18n$Textes$saisieDeChampMotif)));
				} else {
					return _Utils_Tuple2(
						_List_fromArray(
							[
								$author$project$Components$Shared$Messages$Model$duRefus(refus)
							]),
						$elm$core$Maybe$Nothing);
				}
			default:
				return $author$project$Components$Produits$ListesDePrix$Update$perime(erreur) ? enTete($author$project$I18n$Textes$produitsCatalogueErreurPerime) : _Utils_Tuple2(
					_List_fromArray(
						[
							$author$project$Components$Shared$Messages$Model$duRefus(refus)
						]),
					$elm$core$Maybe$Nothing);
		}
	});
var $author$project$Components$Produits$ListesDePrix$Creation$refuser = F3(
	function (enTete, sousUnChamp, saisie) {
		return _Utils_update(
			saisie,
			{pZ: enTete, bf: sousUnChamp});
	});
var $author$project$Components$Produits$ListesDePrix$Update$relire = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$Lire, $elm$core$List$singleton),
			model.np));
};
var $author$project$Components$Produits$ListesDePrix$Update$relecture = F2(
	function (rendue, model) {
		return (rendue.sy && (!A2($elm$core$List$member, $author$project$Catalogue$API$WriteAPIModel$EvenementInconnu, rendue.mk))) ? $author$project$Components$Produits$ListesDePrix$Update$relire(model) : _List_fromArray(
			[
				$author$project$Components$Produits$Common$Effet$AttendreAvantDeRelire($author$project$Components$Produits$Common$Envoi$delaiDeRelectureMs)
			]);
	});
var $author$project$Components$Produits$ListesDePrix$Creation$enCours = function (saisie) {
	return (!_Utils_eq(saisie.Dj, $author$project$Components$Shared$LibellesParLangue$Model$vide)) || (A2(
		$elm$core$List$any,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$trim,
			$elm$core$Basics$neq('')),
		_List_fromArray(
			[saisie.rA, saisie.ku, saisie.mI])) || (!$elm$core$List$isEmpty(saisie.GA)));
};
var $author$project$Components$Produits$ListesDePrix$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{kX: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Produits$Common$Effet$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Produits$ListesDePrix$Creation$enCours(model.hP)
				},
				geste,
				model.kX));
	});
var $author$project$Components$Produits$ListesDePrix$Update$conclure = F2(
	function (issue, model) {
		switch (issue.$) {
			case 0:
				if (issue.c) {
					var rendue = issue.b;
					return A2(
						$elm$core$Tuple$mapSecond,
						function (effets) {
							return _Utils_ap(
								effets,
								A2($author$project$Components$Produits$ListesDePrix$Update$relecture, rendue, model));
						},
						A2(
							$author$project$Components$Produits$ListesDePrix$Update$versLeDrawer,
							$author$project$Components$Shared$Drawer$Update$Fermer,
							_Utils_update(
								model,
								{
									aS: A2(
										$elm$core$Maybe$map,
										$author$project$Components$Produits$ListesDePrix$Model$appliquer(rendue),
										model.aS),
									hP: $author$project$Components$Produits$ListesDePrix$Creation$vide
								})));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								hP: A3(
									$author$project$Components$Produits$ListesDePrix$Creation$refuser,
									_List_fromArray(
										[$author$project$Components$Produits$Common$Refus$rejeu]),
									$elm$core$Maybe$Nothing,
									model.hP)
							}),
						$author$project$Components$Produits$ListesDePrix$Update$relire(model));
				}
			case 1:
				var refus = issue.b;
				var erreur = issue.c;
				var _v1 = A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(
						_List_fromArray(
							[
								$author$project$Components$Shared$Messages$Model$duRefus(refus)
							]),
						$elm$core$Maybe$Nothing),
					A2(
						$elm$core$Maybe$map,
						function (annuaire) {
							return A4($author$project$Components$Produits$ListesDePrix$Update$refusDe, annuaire, model, refus, erreur);
						},
						model.aS));
				var enTete = _v1.a;
				var sousUnChamp = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hP: A3($author$project$Components$Produits$ListesDePrix$Creation$refuser, enTete, sousUnChamp, model.hP)
						}),
					_Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (_v2) {
									var zone = _v2.a;
									return _List_fromArray(
										[
											$author$project$Components$Produits$Common$Effet$PlacerFocus(
											A2(
												$author$project$Components$Produits$ListesDePrix$Creation$idDe,
												$author$project$Components$Shared$Drawer$Model$idRacine(model.kX),
												zone))
										]);
								},
								sousUnChamp)),
						$author$project$Components$Produits$ListesDePrix$Update$perime(erreur) ? $author$project$Components$Produits$ListesDePrix$Update$relire(model) : _List_Nil));
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$creerUneListeDePrix = 'creer-une-liste-de-prix';
var $author$project$Components$Produits$ListesDePrix$Model$creation = function (annuaire) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUneListeDePrix, annuaire.nQ);
};
var $author$project$Catalogue$API$WriteAPIModel$CreerUneListeDePrix = function (a) {
	return {$: 59, a: a};
};
var $author$project$Components$Produits$ListesDePrix$Creation$devise = F2(
	function (annuaire, saisie) {
		return A2($elm$core$List$member, saisie.kO, annuaire.xx) ? $elm$core$Maybe$Just(saisie.kO) : $elm$core$List$head(annuaire.xx);
	});
var $author$project$Components$Produits$ListesDePrix$Creation$ZoneDebut = 3;
var $author$project$Components$Produits$ListesDePrix$Creation$blanc = function (texte) {
	return $elm$core$String$trim(texte) === '';
};
var $author$project$Components$Produits$Common$Prix$tauxSaisi = function (saisi) {
	return A2(
		$elm$core$Maybe$andThen,
		function (ecrit) {
			var _v0 = A2($elm$core$String$split, '.', ecrit);
			if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
				var entier = _v0.a;
				var _v1 = _v0.b;
				var decimales = _v1.a;
				return (($elm$core$String$length(entier) < 3) || ((entier === '100') && (decimales === '00'))) ? $elm$core$Maybe$Just(ecrit) : $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		$author$project$Components$Produits$Common$Prix$decimal(saisi));
};
var $author$project$Components$Produits$ListesDePrix$Creation$taxes = function (saisie) {
	return _Utils_eq(saisie.c4, $author$project$Catalogue$Vocabulaire$taxesHorsTaxe) ? A2(
		$elm$core$Maybe$map,
		$author$project$Catalogue$API$PrixAPIModel$HorsTaxe,
		$author$project$Components$Produits$Common$Prix$tauxSaisi(saisie.rA)) : (_Utils_eq(saisie.c4, $author$project$Catalogue$Vocabulaire$taxesToutesTaxesComprises) ? A2(
		$elm$core$Maybe$map,
		$author$project$Catalogue$API$PrixAPIModel$ToutesTaxesComprises,
		$author$project$Components$Produits$Common$Prix$tauxSaisi(saisie.rA)) : $elm$core$Maybe$Just($author$project$Catalogue$API$PrixAPIModel$Exonerees));
};
var $author$project$Components$Produits$ListesDePrix$Creation$fautes = function (saisie) {
	return A2(
		$elm$core$List$filterMap,
		function (_v0) {
			var zone = _v0.a;
			var fautive = _v0.b;
			return fautive ? $elm$core$Maybe$Just(zone) : $elm$core$Maybe$Nothing;
		},
		_List_fromArray(
			[
				_Utils_Tuple2(
				0,
				_Utils_eq(
					$author$project$Components$Produits$Common$LibellesSaisis$versLApi(saisie.Dj),
					$elm$core$Maybe$Nothing)),
				_Utils_Tuple2(
				2,
				_Utils_eq(
					$author$project$Components$Produits$ListesDePrix$Creation$taxes(saisie),
					$elm$core$Maybe$Nothing)),
				_Utils_Tuple2(
				3,
				$author$project$Components$Produits$ListesDePrix$Creation$blanc(saisie.ku)),
				_Utils_Tuple2(
				4,
				$author$project$Components$Produits$ListesDePrix$Creation$blanc(saisie.mI) || ((!$author$project$Components$Produits$ListesDePrix$Creation$blanc(saisie.ku)) && (_Utils_cmp(saisie.mI, saisie.ku) < 0)))
			]));
};
var $author$project$Components$Produits$ListesDePrix$Creation$listeACreer = F2(
	function (annuaire, saisie) {
		var _v0 = _Utils_Tuple3(
			_Utils_Tuple2(
				$author$project$Components$Produits$ListesDePrix$Creation$fautes(saisie),
				$author$project$Components$Produits$Common$LibellesSaisis$versLApi(saisie.Dj)),
			A2($author$project$Components$Produits$ListesDePrix$Creation$devise, annuaire, saisie),
			$author$project$Components$Produits$ListesDePrix$Creation$taxes(saisie));
		if ((((!_v0.a.a.b) && (!_v0.a.b.$)) && (!_v0.b.$)) && (!_v0.c.$)) {
			var _v1 = _v0.a;
			var nom = _v1.b.a;
			var choisie = _v0.b.a;
			var justes = _v0.c.a;
			return $elm$core$Maybe$Just(
				{
					kO: choisie,
					Dj: nom,
					GA: saisie.GA,
					rB: justes,
					sk: {ku: saisie.ku, mI: saisie.mI}
				});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$ListesDePrix$Model$commandeDeCreation = F2(
	function (annuaire, saisie) {
		return A3(
			$elm$core$Maybe$map2,
			F2(
				function (liste, lien) {
					return _Utils_Tuple2(
						$author$project$Catalogue$API$WriteAPIModel$CreerUneListeDePrix(liste),
						lien);
				}),
			A2($author$project$Components$Produits$ListesDePrix$Creation$listeACreer, annuaire, saisie),
			$author$project$Components$Produits$ListesDePrix$Model$creation(annuaire));
	});
var $author$project$Components$Produits$ListesDePrix$Creation$tenter = function (saisie) {
	return _Utils_update(
		saisie,
		{b5: true});
};
var $author$project$Components$Produits$ListesDePrix$Update$creer = function (model) {
	var _v0 = _Utils_Tuple2(
		model.aS,
		$author$project$Components$Shared$Drawer$Model$estOuvert(model.kX));
	if ((!_v0.a.$) && _v0.b) {
		var annuaire = _v0.a.a;
		var _v1 = _Utils_Tuple2(
			A2($author$project$Components$Produits$ListesDePrix$Model$commandeDeCreation, annuaire, model.hP),
			$author$project$Components$Produits$ListesDePrix$Creation$fautes(model.hP));
		if (!_v1.a.$) {
			var _v2 = _v1.a.a;
			var commande = _v2.a;
			var lien = _v2.b;
			var _v3 = A3(
				$author$project$Components$Produits$Common$Envoi$partir,
				$elm$core$Maybe$Just(lien),
				commande,
				model.l2);
			if (!_v3.$) {
				var _v4 = _v3.a;
				var envoi = _v4.a;
				var effets = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: envoi,
							hP: A3($author$project$Components$Produits$ListesDePrix$Creation$refuser, _List_Nil, $elm$core$Maybe$Nothing, model.hP)
						}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			if (_v1.b.b) {
				var _v5 = _v1.a;
				var _v6 = _v1.b;
				var fautive = _v6.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hP: $author$project$Components$Produits$ListesDePrix$Creation$tenter(model.hP)
						}),
					_List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$PlacerFocus(
							A2(
								$author$project$Components$Produits$ListesDePrix$Creation$idDe,
								$author$project$Components$Shared$Drawer$Model$idRacine(model.kX),
								fautive))
						]));
			} else {
				var _v7 = _v1.a;
				return _Utils_Tuple2(model, _List_Nil);
			}
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$ListesDePrix$Update$depuisLaListe = function (effet) {
	if (!effet.$) {
		var cle = effet.a;
		var vue = effet.b;
		return _List_fromArray(
			[
				A2($author$project$Components$Produits$Common$Effet$GarderVue, cle, vue)
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Produits$ListesDePrix$Model$idDeLaCreation = 'listes-de-prix-creer';
var $author$project$Components$Produits$ListesDePrix$Model$ouvert = F2(
	function (lecture, model) {
		return {
			aS: $elm$core$Maybe$Nothing,
			kX: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$ListesDePrix$Model$nomDuDrawer),
			l2: $author$project$API$Envoi$SansProcessUid,
			np: lecture,
			nW: model.nW,
			hP: $author$project$Components$Produits$ListesDePrix$Creation$vide
		};
	});
var $author$project$Components$Produits$ListesDePrix$Creation$regimes = _List_fromArray(
	[$author$project$Catalogue$Vocabulaire$taxesExonerees, $author$project$Catalogue$Vocabulaire$taxesHorsTaxe, $author$project$Catalogue$Vocabulaire$taxesToutesTaxesComprises]);
var $author$project$Components$Produits$ListesDePrix$Creation$saisir = F3(
	function (annuaire, champ, saisie) {
		var sans = F2(
			function (zone, voulue) {
				return _Utils_update(
					voulue,
					{
						bf: function () {
							var _v1 = voulue.bf;
							if (!_v1.$) {
								var _v2 = _v1.a;
								var fautive = _v2.a;
								return _Utils_eq(fautive, zone) ? $elm$core$Maybe$Nothing : voulue.bf;
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}()
					});
			});
		switch (champ.$) {
			case 0:
				var code = champ.a;
				var texte = champ.b;
				return A2(
					sans,
					0,
					_Utils_update(
						saisie,
						{
							Dj: A3($author$project$Components$Shared$LibellesParLangue$Model$ecrire, code, texte, saisie.Dj)
						}));
			case 1:
				var ref = champ.a;
				var coche = champ.b;
				return (!coche) ? _Utils_update(
					saisie,
					{
						GA: A2(
							$elm$core$List$filter,
							$elm$core$Basics$neq(ref),
							saisie.GA)
					}) : ((A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Hb;
						},
						$elm$core$Basics$eq(ref)),
					$author$project$Components$Produits$ListesDePrix$Creation$proposes(annuaire)) && (!A2($elm$core$List$member, ref, saisie.GA))) ? _Utils_update(
					saisie,
					{
						GA: _Utils_ap(
							saisie.GA,
							_List_fromArray(
								[ref]))
					}) : saisie);
			case 2:
				var code = champ.a;
				return A2($elm$core$List$member, code, annuaire.xx) ? A2(
					sans,
					1,
					_Utils_update(
						saisie,
						{kO: code})) : saisie;
			case 3:
				var code = champ.a;
				return A2($elm$core$List$member, code, $author$project$Components$Produits$ListesDePrix$Creation$regimes) ? A2(
					sans,
					2,
					_Utils_update(
						saisie,
						{c4: code})) : saisie;
			case 4:
				var texte = champ.a;
				return A2(
					sans,
					2,
					_Utils_update(
						saisie,
						{rA: texte}));
			case 5:
				var jour = champ.a;
				return A2(
					sans,
					3,
					_Utils_update(
						saisie,
						{ku: jour}));
			default:
				var jour = champ.a;
				return A2(
					sans,
					4,
					_Utils_update(
						saisie,
						{mI: jour}));
		}
	});
var $author$project$Components$Produits$ListesDePrix$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var liens = msg.a;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$listesDePrix, liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Produits$ListesDePrix$Model$ouvert,
							$elm$core$Maybe$Just(lecture),
							model),
						_List_fromArray(
							[
								$author$project$Components$Produits$Common$Effet$DemanderProcessUid,
								$author$project$Components$Produits$Common$Effet$Lire(lecture)
							]));
				} else {
					return _Utils_Tuple2(
						A2($author$project$Components$Produits$ListesDePrix$Model$ouvert, $elm$core$Maybe$Nothing, model),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$Components$Produits$Common$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 2:
				var reponse = msg.a;
				var _v2 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$ListesDePrix$API$QueryAPIModel$annuaireDecoder, reponse);
				if (!_v2.$) {
					var annuaire = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aS: $elm$core$Maybe$Just(annuaire)
							}),
						_List_Nil);
				} else {
					var refus = _v2.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 3:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Produits$ListesDePrix$Update$relire(model));
			case 4:
				var geste = msg.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					function (liste) {
						return _Utils_update(
							model,
							{nW: liste});
					},
					$elm$core$List$concatMap($author$project$Components$Produits$ListesDePrix$Update$depuisLaListe),
					A2($author$project$Components$Shared$Annuaire$Update$update, geste, model.nW));
			case 5:
				var geste = msg.a;
				return A2($author$project$Components$Produits$Common$Envoi$retientLeDrawer, model.l2, geste) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Produits$ListesDePrix$Update$versLeDrawer, geste, model);
			case 6:
				return _Utils_eq(
					A2($elm$core$Maybe$andThen, $author$project$Components$Produits$ListesDePrix$Model$creation, model.aS),
					$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A2(
					$author$project$Components$Produits$ListesDePrix$Update$versLeDrawer,
					$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Produits$ListesDePrix$Model$idDeLaCreation),
					_Utils_update(
						model,
						{hP: $author$project$Components$Produits$ListesDePrix$Creation$vide}));
			case 7:
				var champ = msg.a;
				var _v3 = model.aS;
				if (!_v3.$) {
					var annuaire = _v3.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								hP: A3($author$project$Components$Produits$ListesDePrix$Creation$saisir, annuaire, champ, model.hP)
							}),
						_List_Nil);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 8:
				return $author$project$Components$Produits$ListesDePrix$Update$creer(model);
			default:
				var reponse = msg.a;
				var _v4 = A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, model.l2);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var envoi = _v5.a;
					var issue = _v5.b;
					var effets = _v5.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Produits$ListesDePrix$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Main$Update$versLesListesDePrix = F3(
	function (i18n, msg, model) {
		var _v0 = A2($author$project$Components$Produits$ListesDePrix$Update$update, msg, model.BW);
		var listesDePrix = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLesElements, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			A3($author$project$Main$Update$depuisLesElements, i18n, 12, 27),
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						BW: listesDePrix,
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Produits$ListesDePrix$Update$popMessages(msg),
							gardes)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$AnnuaireDesElements = 0;
var $author$project$Main$Model$PourLesMarquesEtGammes = 5;
var $author$project$Components$Produits$MarquesEtGammes$API$QueryAPIModel$Annuaire = F3(
	function (niveau, elements, liens) {
		return {aV: elements, nQ: liens, os: niveau};
	});
var $author$project$Components$Produits$MarquesEtGammes$API$QueryAPIModel$annuaireDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'elements',
		$elm$json$Json$Decode$list($author$project$Catalogue$API$QueryAPIModel$elementDecoder),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'niveau',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$niveauDElementDecoder),
			$elm$core$Maybe$Nothing,
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$MarquesEtGammes$API$QueryAPIModel$Annuaire))));
var $author$project$Components$Produits$MarquesEtGammes$Update$popMessages = function (msg) {
	switch (msg.$) {
		case 2:
			var reponse = msg.a;
			var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$MarquesEtGammes$API$QueryAPIModel$annuaireDecoder, reponse);
			if (_v1.$ === 1) {
				var refus = _v1.a;
				return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Components$Shared$Messages$Model$duRefus(refus));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 1:
			var octets = msg.a;
			return _Utils_eq(
				$author$project$API$ProcessUid$depuisOctets(octets),
				$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
				{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$MarquesEtGammes$Model$appliquer = F2(
	function (rendue, annuaire) {
		var ajoute = F5(
			function (id, libelles, sousLicence, millesime, niveau) {
				return $author$project$Components$Produits$Common$Elements$cree(
					{
						Aq: id,
						R: libelles,
						nQ: rendue.nQ,
						n8: millesime,
						os: niveau,
						ey: $elm$core$Maybe$Nothing,
						bY: $elm$core$List$length(annuaire.aV),
						IY: sousLicence
					});
			});
		var apres = F2(
			function (evenement, elements) {
				var _v0 = _Utils_Tuple2(evenement, annuaire.os);
				_v0$2:
				while (true) {
					if (!_v0.b.$) {
						switch (_v0.a.$) {
							case 0:
								var _v1 = _v0.a;
								var id = _v1.a;
								var marque = _v1.b;
								var niveau = _v0.b.a;
								return _Utils_ap(
									elements,
									_List_fromArray(
										[
											A5(
											ajoute,
											id,
											{yg: $elm$core$Maybe$Nothing, zX: marque.Dj},
											$elm$core$Maybe$Just(marque.IY),
											$elm$core$Maybe$Nothing,
											niveau)
										]));
							case 5:
								var _v2 = _v0.a;
								var id = _v2.a;
								var gamme = _v2.b;
								var niveau = _v0.b.a;
								return _Utils_ap(
									elements,
									_List_fromArray(
										[
											A5(ajoute, id, gamme.R, $elm$core$Maybe$Nothing, gamme.n8, niveau)
										]));
							default:
								break _v0$2;
						}
					} else {
						break _v0$2;
					}
				}
				return elements;
			});
		return _Utils_update(
			annuaire,
			{
				aV: A3($elm$core$List$foldl, apres, annuaire.aV, rendue.mk)
			});
	});
var $author$project$Components$Produits$MarquesEtGammes$Model$forme = function (annuaire) {
	var _v0 = _Utils_Tuple2(
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUneMarque, annuaire.nQ),
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUneGamme, annuaire.nQ));
	if (!_v0.a.$) {
		var lien = _v0.a.a;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(0, lien));
	} else {
		if (!_v0.b.$) {
			var _v1 = _v0.a;
			var lien = _v0.b.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(1, lien));
		} else {
			var _v2 = _v0.a;
			var _v3 = _v0.b;
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$Components$Produits$MarquesEtGammes$Update$forme = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$first,
			A2($elm$core$Maybe$andThen, $author$project$Components$Produits$MarquesEtGammes$Model$forme, model.aS)));
};
var $author$project$Components$Produits$MarquesEtGammes$Update$contexte = F2(
	function (i18n, model) {
		var tournures = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Catalogue$Vocabulaire$tournures(
				{fA: '', Bl: $elm$core$Maybe$Nothing}),
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$Produits$Common$Elements$tournures(i18n),
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.os;
					},
					model.aS)));
		return {
			aV: A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$I18n$Traductions$tel),
			gi: tournures.gi,
			Dj: A2(
				$author$project$Components$Produits$Common$Saisie$nomSaisi,
				$author$project$Components$Produits$MarquesEtGammes$Update$forme(model),
				model.hP),
			fd: tournures
		};
	});
var $author$project$Components$Produits$MarquesEtGammes$Update$idDuNom = function (model) {
	return A2(
		$author$project$Components$Produits$Common$Formulaire$idDuNom,
		$author$project$Components$Produits$MarquesEtGammes$Update$forme(model),
		$author$project$Components$Shared$Drawer$Model$idRacine(model.kX));
};
var $author$project$Components$Produits$MarquesEtGammes$Update$relire = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$Lire, $elm$core$List$singleton),
			model.np));
};
var $author$project$Components$Produits$MarquesEtGammes$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{kX: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Produits$Common$Effet$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Produits$Common$Saisie$enCours(model.hP)
				},
				geste,
				model.kX));
	});
var $author$project$Components$Produits$MarquesEtGammes$Update$conclure = F3(
	function (i18n, issue, model) {
		var saisie = model.hP;
		switch (issue.$) {
			case 0:
				if (issue.c) {
					var rendue = issue.b;
					return A2(
						$elm$core$Tuple$mapSecond,
						function (effets) {
							return _Utils_ap(
								effets,
								(rendue.sy && (!A2($elm$core$List$member, $author$project$Catalogue$API$WriteAPIModel$EvenementInconnu, rendue.mk))) ? $author$project$Components$Produits$MarquesEtGammes$Update$relire(model) : _List_fromArray(
									[
										$author$project$Components$Produits$Common$Effet$AttendreAvantDeRelire($author$project$Components$Produits$Common$Envoi$delaiDeRelectureMs)
									]));
						},
						A2(
							$author$project$Components$Produits$MarquesEtGammes$Update$versLeDrawer,
							$author$project$Components$Shared$Drawer$Update$Fermer,
							_Utils_update(
								model,
								{
									aS: A2(
										$elm$core$Maybe$map,
										$author$project$Components$Produits$MarquesEtGammes$Model$appliquer(rendue),
										model.aS),
									hP: $author$project$Components$Produits$Common$Saisie$vide
								})));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								hP: _Utils_update(
									saisie,
									{
										pZ: $elm$core$Maybe$Just($author$project$Components$Produits$Common$Refus$rejeu)
									})
							}),
						$author$project$Components$Produits$MarquesEtGammes$Update$relire(model));
				}
			case 1:
				if (!issue.c.$) {
					var _v1 = issue.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								hP: _Utils_update(
									saisie,
									{gi: true})
							}),
						_List_fromArray(
							[
								$author$project$Components$Produits$Common$Effet$PlacerFocus(
								$author$project$Components$Produits$MarquesEtGammes$Update$idDuNom(model))
							]));
				} else {
					var refus = issue.b;
					var erreur = issue.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								hP: _Utils_update(
									saisie,
									{
										pZ: $elm$core$Maybe$Just(
											A3(
												$author$project$Components$Produits$Common$Refus$message,
												A2($author$project$Components$Produits$MarquesEtGammes$Update$contexte, i18n, model),
												refus,
												erreur))
									})
							}),
						$author$project$Components$Produits$Common$Refus$perime(erreur) ? $author$project$Components$Produits$MarquesEtGammes$Update$relire(model) : _List_Nil);
				}
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$MarquesEtGammes$Model$commandeDeCreation = F2(
	function (annuaire, saisie) {
		var _v0 = _Utils_Tuple2(
			$author$project$Components$Produits$MarquesEtGammes$Model$forme(annuaire),
			annuaire.os);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var _v1 = _v0.a.a;
			var choisie = _v1.a;
			var lien = _v1.b;
			var niveau = _v0.b.a;
			return A2(
				$elm$core$Maybe$andThen,
				function (saisi) {
					switch (saisi.$) {
						case 0:
							var marque = saisi.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$author$project$Catalogue$API$WriteAPIModel$CreerUneMarque(marque),
									lien));
						case 1:
							var gamme = saisi.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$author$project$Catalogue$API$WriteAPIModel$CreerUneGamme(
										{R: gamme.R, gX: $elm$core$Maybe$Nothing, n8: gamme.n8, os: niveau.Aq, ey: $elm$core$Maybe$Nothing}),
									lien));
						default:
							return $elm$core$Maybe$Nothing;
					}
				},
				A2($author$project$Components$Produits$Common$Saisie$valide, choisie, saisie));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$MarquesEtGammes$Update$creer = function (model) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		function (annuaire) {
			return A2($author$project$Components$Produits$MarquesEtGammes$Model$commandeDeCreation, annuaire, model.hP);
		},
		model.aS);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var commande = _v1.a;
		var lien = _v1.b;
		var _v2 = A3(
			$author$project$Components$Produits$Common$Envoi$partir,
			$elm$core$Maybe$Just(lien),
			commande,
			model.l2);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var envoi = _v3.a;
			var effets = _v3.b;
			var saisie = model.hP;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l2: envoi,
						hP: _Utils_update(
							saisie,
							{gi: false, pZ: $elm$core$Maybe$Nothing})
					}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_eq(
			A2($elm$core$Maybe$andThen, $author$project$Components$Produits$MarquesEtGammes$Model$forme, model.aS),
			$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : _Utils_Tuple2(
			_Utils_update(
				model,
				{
					hP: $author$project$Components$Produits$Common$Saisie$tenter(model.hP)
				}),
			_List_fromArray(
				[
					$author$project$Components$Produits$Common$Effet$PlacerFocus(
					$author$project$Components$Produits$MarquesEtGammes$Update$idDuNom(model))
				]));
	}
};
var $author$project$Components$Produits$MarquesEtGammes$Update$depuisLaListe = function (effet) {
	if (!effet.$) {
		var cle = effet.a;
		var vue = effet.b;
		return _List_fromArray(
			[
				A2($author$project$Components$Produits$Common$Effet$GarderVue, cle, vue)
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Produits$MarquesEtGammes$Model$idDeLaCreation = 'elements-creer';
var $author$project$Components$Produits$MarquesEtGammes$Model$ouvert = F2(
	function (lecture, model) {
		return {
			aS: $elm$core$Maybe$Nothing,
			kX: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$MarquesEtGammes$Model$nomDuDrawer),
			l2: $author$project$API$Envoi$SansProcessUid,
			np: lecture,
			nW: model.nW,
			hP: $author$project$Components$Produits$Common$Saisie$vide
		};
	});
var $author$project$Components$Produits$MarquesEtGammes$Update$update = F3(
	function (i18n, msg, model) {
		switch (msg.$) {
			case 0:
				var liens = msg.a;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$marquesEtGammes, liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Produits$MarquesEtGammes$Model$ouvert,
							$elm$core$Maybe$Just(lecture),
							model),
						_List_fromArray(
							[
								$author$project$Components$Produits$Common$Effet$DemanderProcessUid,
								$author$project$Components$Produits$Common$Effet$Lire(lecture)
							]));
				} else {
					return _Utils_Tuple2(
						A2($author$project$Components$Produits$MarquesEtGammes$Model$ouvert, $elm$core$Maybe$Nothing, model),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$Components$Produits$Common$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 2:
				var reponse = msg.a;
				var _v2 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$MarquesEtGammes$API$QueryAPIModel$annuaireDecoder, reponse);
				if (!_v2.$) {
					var annuaire = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aS: $elm$core$Maybe$Just(annuaire)
							}),
						_List_Nil);
				} else {
					var refus = _v2.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 3:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Produits$MarquesEtGammes$Update$relire(model));
			case 4:
				var geste = msg.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					function (liste) {
						return _Utils_update(
							model,
							{nW: liste});
					},
					$elm$core$List$concatMap($author$project$Components$Produits$MarquesEtGammes$Update$depuisLaListe),
					A2($author$project$Components$Shared$Annuaire$Update$update, geste, model.nW));
			case 5:
				var geste = msg.a;
				return A2($author$project$Components$Produits$Common$Envoi$retientLeDrawer, model.l2, geste) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Produits$MarquesEtGammes$Update$versLeDrawer, geste, model);
			case 6:
				return _Utils_eq(
					A2($elm$core$Maybe$andThen, $author$project$Components$Produits$MarquesEtGammes$Model$forme, model.aS),
					$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A2(
					$author$project$Components$Produits$MarquesEtGammes$Update$versLeDrawer,
					$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Produits$MarquesEtGammes$Model$idDeLaCreation),
					_Utils_update(
						model,
						{hP: $author$project$Components$Produits$Common$Saisie$vide}));
			case 7:
				var champ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hP: A2($author$project$Components$Produits$Common$Saisie$saisir, champ, model.hP)
						}),
					_List_Nil);
			case 8:
				return $author$project$Components$Produits$MarquesEtGammes$Update$creer(model);
			default:
				var reponse = msg.a;
				var _v3 = A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, model.l2);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var envoi = _v4.a;
					var issue = _v4.b;
					var effets = _v4.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A3(
							$author$project$Components$Produits$MarquesEtGammes$Update$conclure,
							i18n,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Main$Update$versLesMarquesEtGammes = F3(
	function (i18n, msg, model) {
		var _v0 = A3(
			$author$project$Components$Produits$MarquesEtGammes$Update$update,
			i18n,
			msg,
			$author$project$Components$Produits$MarquesEtGammes$Model$ouvrir(model.B7));
		var marquesEtGammes = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLesElements, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			A3($author$project$Main$Update$depuisLesElements, i18n, 0, 5),
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						B7: $author$project$Components$Produits$MarquesEtGammes$Model$envelopper(marquesEtGammes),
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Produits$MarquesEtGammes$Update$popMessages(msg),
							gardes)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$EnvoyerAuxModelesDeTache = function (a) {
	return {$: 98, a: a};
};
var $author$project$Main$Update$LireLesModelesDeTache = F2(
	function (a, b) {
		return {$: 97, a: a, b: b};
	});
var $author$project$Main$Model$PourLesModelesDeTache = 26;
var $author$project$Main$Update$depuisLesModelesDeTache = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				var lecture = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLesModelesDeTache(lecture))));
			case 1:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (requete) {
								return $author$project$Main$Update$EnvoyerAuxModelesDeTache(
									{vJ: commande, gM: requete.gM, nB: requete.nB, Gn: processUid});
							})));
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[26]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 3:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Parametrage$ModelesDeTache$Update$dit = function (resultat) {
	if (resultat.$ === 1) {
		var erreur = resultat.a;
		return (erreur.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Components$Shared$Messages$Model$duRefus(erreur));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$Fiche = function (uid) {
	return function (libelles) {
		return function (genre) {
			return function (version) {
				return function (etat) {
					return function (roleAttendu) {
						return function (reglage) {
							return function (echeance) {
								return function (relance) {
									return function (notesDeVersion) {
										return function (utilisePar) {
											return function (rolesDesPipes) {
												return function (liens) {
													return {xY: echeance, gt: etat, M: genre, R: libelles, nQ: liens, DU: notesDeVersion, eO: reglage, Hq: relance, qP: roleAttendu, Ia: rolesDesPipes, r8: uid, sf: utilisePar, sq: version};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$libellesDecoder = $elm$json$Json$Decode$dict($elm$json$Json$Decode$string);
var $author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$Utilisation = F6(
	function (code, libelle, versionDuPipe, versionDuModele, versionDisponible, ouvrirLaTache) {
		return {vx: code, Bl: libelle, EA: ouvrirLaTache, KH: versionDisponible, KI: versionDuModele, KJ: versionDuPipe};
	});
var $author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$utilisationDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function (liens) {
			return !_Utils_eq(
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$tacheDuPipe, liens),
				$elm$core$Maybe$Nothing);
		},
		$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'versionDisponible',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'versionDuModele',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'versionDuPipe',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['pipe', 'libelle']),
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['pipe', 'code']),
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$Utilisation)))))));
var $author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$ficheDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'rolesDesPipes',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'utilisePar',
			$elm$json$Json$Decode$list($author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$utilisationDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'notesDeVersion',
				$author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$libellesDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'relance',
					$elm$json$Json$Decode$value,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'echeance',
						$elm$json$Json$Decode$value,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'reglage',
							$elm$json$Json$Decode$value,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['roleAttendu', 'libelles']),
								$author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$libellesDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'etat',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'version',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'type',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'libelles',
												$author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$libellesDecoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'uid',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$Fiche))))))))))))));
var $author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$PageDesModeles = F5(
	function (modeles, total, page, taille, liens) {
		return {nQ: liens, CI: modeles, EE: page, Jm: taille, JE: total};
	});
var $author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$Carte = F8(
	function (uid, libelles, genre, roleAttendu, version, etat, utilisePar, ouvrir) {
		return {gt: etat, M: genre, R: libelles, Ey: ouvrir, qP: roleAttendu, r8: uid, sf: utilisePar, sq: version};
	});
var $author$project$API$NavLinksDictionary$modeleDeTache = 'modele-de-tache';
var $author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$carteDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$modeleDeTache),
		$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'utilisePar',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'etat',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'version',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['roleAttendu', 'libelles']),
					$author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$libellesDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'type',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'libelles',
							$author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$libellesDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'uid',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$Carte)))))))));
var $author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$pageDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'taille',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'page',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'total',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'modeles',
					$elm$json$Json$Decode$list($author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$carteDecoder),
					$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$PageDesModeles))))));
var $author$project$Components$Parametrage$ModelesDeTache$Update$popMessages = function (msg) {
	if (msg.$ === 2) {
		var lecture = msg.a;
		var reponse = msg.b;
		switch (lecture.$) {
			case 0:
				return $author$project$Components$Parametrage$ModelesDeTache$Update$dit(
					A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder, reponse));
			case 1:
				return $author$project$Components$Parametrage$ModelesDeTache$Update$dit(
					A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$pageDecoder, reponse));
			default:
				return $author$project$Components$Parametrage$ModelesDeTache$Update$dit(
					A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$ficheDecoder, reponse));
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$ModelesDeTache$Update$Annuaire = {$: 1};
var $author$project$Components$Parametrage$ModelesDeTache$API$WriteAPIModel$Archiver = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$ModelesDeTache$Update$DemanderProcessUid = {$: 2};
var $author$project$Components$Parametrage$ModelesDeTache$API$WriteAPIModel$Dupliquer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$ModelesDeTache$Update$Fiche = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$ModelesDeTache$Update$Lire = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$ModelesDeTache$API$WriteAPIModel$Modifier = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$ModelesDeTache$Update$Pipes = {$: 0};
var $author$project$Components$Parametrage$ModelesDeTache$API$WriteAPIModel$Restaurer = function (a) {
	return {$: 3, a: a};
};
var $author$project$API$NavLinksDictionary$archiverUnModeleDeTache = 'archiver-un-modele-de-tache';
var $author$project$Components$Parametrage$ModelesDeTache$Update$avecLaRegle = F2(
	function (regle, lesReglages) {
		var _v0 = _Utils_Tuple2(
			regle,
			A2(
				$elm$json$Json$Decode$decodeValue,
				$elm$json$Json$Decode$dict($elm$json$Json$Decode$value),
				lesReglages));
		_v0$0:
		while (true) {
			if (!_v0.b.$) {
				if (_v0.a === '') {
					break _v0$0;
				} else {
					var champs = _v0.b.a;
					return $elm$json$Json$Encode$object(
						$elm$core$Dict$toList(
							A3(
								$elm$core$Dict$insert,
								'regle',
								$elm$json$Json$Encode$string(regle),
								champs)));
				}
			} else {
				if (_v0.a === '') {
					break _v0$0;
				} else {
					return lesReglages;
				}
			}
		}
		return lesReglages;
	});
var $author$project$API$NavLinksDictionary$dupliquerUnModeleDeTache = 'dupliquer-un-modele-de-tache';
var $author$project$Components$Parametrage$ModelesDeTache$Update$Envoyer = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$ModelesDeTache$Update$Reconnecter = {$: 4};
var $author$project$Components$Parametrage$ModelesDeTache$API$WriteAPIModel$ReponseDeCommande = function (vuesAJour) {
	return {sy: vuesAJour};
};
var $author$project$Components$Parametrage$ModelesDeTache$API$WriteAPIModel$reponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Components$Parametrage$ModelesDeTache$API$WriteAPIModel$ReponseDeCommande,
	A2($elm$json$Json$Decode$field, 'vuesAJour', $elm$json$Json$Decode$bool));
var $author$project$Components$Parametrage$ModelesDeTache$Update$reglage = {
	f8: $author$project$Components$Parametrage$ModelesDeTache$Update$DemanderProcessUid,
	l4: $author$project$Components$Parametrage$ModelesDeTache$Update$Envoyer,
	go: $elm$core$Basics$identity,
	pW: $author$project$Components$Parametrage$ModelesDeTache$Update$Reconnecter,
	qu: F2(
		function (_v0, _v1) {
			return true;
		}),
	qv: $author$project$Components$Parametrage$ModelesDeTache$API$WriteAPIModel$reponseDecoder
};
var $author$project$Components$Parametrage$ModelesDeTache$Update$envoyer = F3(
	function (rel, commande, model) {
		var _v0 = model.zo;
		if (!_v0.$) {
			var fiche = _v0.a;
			var _v1 = A4(
				$author$project$API$Envoi$partir,
				$author$project$Components$Parametrage$ModelesDeTache$Update$reglage,
				A2($author$project$API$Liens$trouver, rel, fiche.nQ),
				commande(fiche),
				model.l2);
			if (!_v1.$) {
				var _v2 = _v1.a;
				var envoi = _v2.a;
				var effets = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{l2: envoi, pZ: $elm$core$Maybe$Nothing}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$ModelesDeTache$Update$init = $author$project$Components$Parametrage$ModelesDeTache$Model$init;
var $author$project$Components$Parametrage$ModelesDeTache$Update$PlacerFocus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$ModelesDeTache$Model$idDuDeclencheur = function (uid) {
	return 'modele-de-tache-' + uid;
};
var $author$project$API$NavLinksDictionary$modelesDeTaches = 'modeles-de-taches';
var $author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$premier = function (jours) {
	if (jours.b) {
		var j = jours.a;
		return $elm$json$Json$Decode$succeed(j);
	} else {
		return $elm$json$Json$Decode$fail('aucun');
	}
};
var $author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$joursDe = F2(
	function (chemin, valeur) {
		return $elm$core$Result$toMaybe(
			A2(
				$elm$json$Json$Decode$decodeValue,
				A2(
					$elm$json$Json$Decode$at,
					chemin,
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								$elm$json$Json$Decode$int,
								A2(
								$elm$json$Json$Decode$andThen,
								$author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$premier,
								$elm$json$Json$Decode$list($elm$json$Json$Decode$int))
							]))),
				valeur));
	});
var $author$project$Components$Parametrage$ModelesDeTache$Model$jours = F2(
	function (chemin, valeur) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$fromInt,
				A2($author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$joursDe, chemin, valeur)));
	});
var $author$project$Components$Parametrage$ModelesDeTache$Model$saisieDe = function (fiche) {
	return {
		w2: A2(
			$author$project$Components$Parametrage$ModelesDeTache$Model$jours,
			_List_fromArray(
				['delaiEnJours']),
			fiche.xY),
		yy: A2(
			$author$project$Components$Parametrage$ModelesDeTache$Model$jours,
			_List_fromArray(
				['delaiDeReponseEnJours']),
			fiche.Hq),
		Dj: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(fiche.R),
		oL: '',
		GU: A2(
			$author$project$Components$Parametrage$ModelesDeTache$Model$jours,
			_List_fromArray(
				['rappelsEnJoursAvant']),
			fiche.Hq),
		hH: A2(
			$elm$core$Result$withDefault,
			'',
			A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$field, 'regle', $elm$json$Json$Decode$string),
				fiche.eO)),
		bi: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(fiche.qP)
	};
};
var $author$project$Components$Parametrage$ModelesDeTache$Update$sous = F4(
	function (decodeur, reponse, model, suite) {
		var _v0 = A2($author$project$API$Reponse$lire, decodeur, reponse);
		if (!_v0.$) {
			var lue = _v0.a;
			return suite(lue);
		} else {
			var refus = _v0.a;
			return (refus.ri === 401) ? _Utils_Tuple2(
				model,
				_List_fromArray(
					[$author$project$Components$Parametrage$ModelesDeTache$Update$Reconnecter])) : _Utils_Tuple2(
				_Utils_update(
					model,
					{
						nf: model.nf || ((refus.ri === 404) && _Utils_eq(model.EE, $elm$core$Maybe$Nothing))
					}),
				_List_Nil);
		}
	});
var $author$project$Components$Parametrage$ModelesDeTache$Update$lu = F3(
	function (lecture, reponse, model) {
		switch (lecture.$) {
			case 0:
				return A4(
					$author$project$Components$Parametrage$ModelesDeTache$Update$sous,
					$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
					reponse,
					model,
					function (liens) {
						var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modelesDeTaches, liens);
						if (!_v1.$) {
							var base = _v1.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										jo: $elm$core$Maybe$Just(base)
									}),
								_List_fromArray(
									[
										A2($author$project$Components$Parametrage$ModelesDeTache$Update$Lire, $author$project$Components$Parametrage$ModelesDeTache$Update$Annuaire, base)
									]));
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{nf: true}),
								_List_Nil);
						}
					});
			case 1:
				return A4(
					$author$project$Components$Parametrage$ModelesDeTache$Update$sous,
					$author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$pageDecoder,
					reponse,
					model,
					function (page) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									EE: $elm$core$Maybe$Just(page)
								}),
							_List_Nil);
					});
			default:
				var declencheur = lecture.a;
				return A4(
					$author$project$Components$Parametrage$ModelesDeTache$Update$sous,
					$author$project$Components$Parametrage$ModelesDeTache$API$QueryAPIModel$ficheDecoder,
					reponse,
					model,
					function (fiche) {
						var _v2 = $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) ? _Utils_Tuple2(model.kX, _List_Nil) : A3(
							$author$project$Components$Shared$Drawer$Update$update,
							{Il: false},
							$author$project$Components$Shared$Drawer$Update$Ouvrir(
								$author$project$Components$Parametrage$ModelesDeTache$Model$idDuDeclencheur(declencheur)),
							model.kX);
						var drawer = _v2.a;
						var effets = _v2.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									kX: drawer,
									zo: $elm$core$Maybe$Just(fiche),
									pZ: $elm$core$Maybe$Nothing,
									hP: $author$project$Components$Parametrage$ModelesDeTache$Model$saisieDe(fiche)
								}),
							A2(
								$elm$core$List$map,
								function (_v3) {
									var cible = _v3;
									return $author$project$Components$Parametrage$ModelesDeTache$Update$PlacerFocus(cible);
								},
								effets));
					});
		}
	});
var $author$project$API$NavLinksDictionary$modifierUnModeleDeTache = 'modifier-un-modele-de-tache';
var $author$project$Components$Parametrage$ModelesDeTache$Update$filtree = F2(
	function (href, model) {
		return _Utils_ap(
			A2(
				$elm$core$Maybe$withDefault,
				href,
				$elm$core$List$head(
					A2($elm$core$String$split, '?', href))),
			$elm$url$Url$Builder$toQuery(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$elm$core$String$isEmpty(
							$elm$core$String$trim(model.hC)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							A2($elm$url$Url$Builder$string, 'recherche', model.hC)),
							$elm$core$String$isEmpty(model.M) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							A2($elm$url$Url$Builder$string, 'type', model.M)),
							model.i$ ? $elm$core$Maybe$Just(
							A2($elm$url$Url$Builder$string, 'archives', 'true')) : $elm$core$Maybe$Nothing
						]))));
	});
var $author$project$Components$Parametrage$ModelesDeTache$Update$relire = function (model) {
	var _v0 = model.jo;
	if (!_v0.$) {
		var base = _v0.a;
		return _Utils_Tuple2(
			model,
			_List_fromArray(
				[
					A2(
					$author$project$Components$Parametrage$ModelesDeTache$Update$Lire,
					$author$project$Components$Parametrage$ModelesDeTache$Update$Annuaire,
					_Utils_update(
						base,
						{
							cM: A2($author$project$Components$Parametrage$ModelesDeTache$Update$filtree, base.cM, model)
						}))
				]));
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$ModelesDeTache$Update$fermer = F2(
	function (model, effets) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{Il: false},
			$author$project$Components$Shared$Drawer$Update$Fermer,
			model.kX);
		var drawer = _v0.a;
		var deDrawer = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{kX: drawer, zo: $elm$core$Maybe$Nothing, pZ: $elm$core$Maybe$Nothing}),
			_Utils_ap(
				effets,
				A2(
					$elm$core$List$map,
					function (_v1) {
						var cible = _v1;
						return $author$project$Components$Parametrage$ModelesDeTache$Update$PlacerFocus(cible);
					},
					deDrawer)));
	});
var $author$project$Components$Parametrage$ModelesDeTache$Update$repondue = F2(
	function (reponse, model) {
		var _v0 = A3($author$project$API$Envoi$conclure, $author$project$Components$Parametrage$ModelesDeTache$Update$reglage, reponse, model.l2);
		if (!_v0.$) {
			switch (_v0.a.b.$) {
				case 0:
					var _v1 = _v0.a;
					var envoi = _v1.a;
					var _v2 = _v1.b;
					var commande = _v2.a;
					var effets = _v1.c;
					var annuaire = A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							$elm$core$List$singleton,
							A2(
								$elm$core$Maybe$map,
								$author$project$Components$Parametrage$ModelesDeTache$Update$Lire($author$project$Components$Parametrage$ModelesDeTache$Update$Annuaire),
								A2(
									$elm$core$Maybe$andThen,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.nQ;
										},
										$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$self)),
									model.EE))));
					var refaire = function (fiche) {
						var _v3 = _Utils_Tuple2(
							commande,
							A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$self, fiche.nQ));
						_v3$0:
						while (true) {
							if (!_v3.b.$) {
								if (_v3.a.$ === 1) {
									break _v3$0;
								} else {
									var self = _v3.b.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{l2: envoi, pZ: $elm$core$Maybe$Nothing}),
										A2(
											$elm$core$List$cons,
											A2(
												$author$project$Components$Parametrage$ModelesDeTache$Update$Lire,
												$author$project$Components$Parametrage$ModelesDeTache$Update$Fiche(fiche.r8),
												self),
											annuaire));
								}
							} else {
								if (_v3.a.$ === 1) {
									break _v3$0;
								} else {
									var _v4 = _v3.b;
									return A2(
										$author$project$Components$Parametrage$ModelesDeTache$Update$fermer,
										_Utils_update(
											model,
											{l2: envoi}),
										annuaire);
								}
							}
						}
						return A2(
							$author$project$Components$Parametrage$ModelesDeTache$Update$fermer,
							_Utils_update(
								model,
								{l2: envoi}),
							annuaire);
					};
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								_Utils_update(
									model,
									{l2: envoi}),
								annuaire),
							A2($elm$core$Maybe$map, refaire, model.zo)));
				case 1:
					var _v5 = _v0.a;
					var envoi = _v5.a;
					var _v6 = _v5.b;
					var refus = _v6.b;
					var effets = _v5.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l2: envoi,
								pZ: $elm$core$Maybe$Just(
									$author$project$Components$Parametrage$Vocabulaire$messageDuRefusDeModele(refus))
							}),
						effets);
				default:
					var _v7 = _v0.a;
					var envoi = _v7.a;
					var _v8 = _v7.b;
					var effets = _v7.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{l2: envoi}),
						effets);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$API$NavLinksDictionary$restaurerUnModeleDeTache = 'restaurer-un-modele-de-tache';
var $author$project$Components$Parametrage$ModelesDeTache$Update$saisir = F2(
	function (changement, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					hP: changement(model.hP)
				}),
			_List_Nil);
	});
var $author$project$Components$Parametrage$ModelesDeTache$Update$versLeDrawer = F2(
	function (geste, model) {
		if ($author$project$API$Envoi$enCours(model.l2) && A2(
			$elm$core$List$member,
			geste,
			_List_fromArray(
				[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$SortieDemandee, $author$project$Components$Shared$Drawer$Update$AbandonConfirme]))) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var saisieEnCours = A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (fiche) {
						return !_Utils_eq(
							model.hP,
							$author$project$Components$Parametrage$ModelesDeTache$Model$saisieDe(fiche));
					},
					model.zo));
			var _v0 = A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: saisieEnCours},
				geste,
				model.kX);
			var drawer = _v0.a;
			var effets = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						kX: drawer,
						zo: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? model.zo : $elm$core$Maybe$Nothing,
						pZ: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? model.pZ : $elm$core$Maybe$Nothing
					}),
				A2(
					$elm$core$List$map,
					function (_v1) {
						var cible = _v1;
						return $author$project$Components$Parametrage$ModelesDeTache$Update$PlacerFocus(cible);
					},
					effets));
		}
	});
var $author$project$Components$Parametrage$ModelesDeTache$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var liens = msg.a;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$pipes, liens);
				if (!_v1.$) {
					var annuaireDesPipes = _v1.a;
					return _Utils_Tuple2(
						$author$project$Components$Parametrage$ModelesDeTache$Model$init,
						_List_fromArray(
							[
								$author$project$Components$Parametrage$ModelesDeTache$Update$DemanderProcessUid,
								A2($author$project$Components$Parametrage$ModelesDeTache$Update$Lire, $author$project$Components$Parametrage$ModelesDeTache$Update$Pipes, annuaireDesPipes)
							]));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							$author$project$Components$Parametrage$ModelesDeTache$Update$init,
							{nf: true}),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 2:
				var lecture = msg.a;
				var reponse = msg.b;
				return A3($author$project$Components$Parametrage$ModelesDeTache$Update$lu, lecture, reponse, model);
			case 3:
				var reponse = msg.a;
				return A2($author$project$Components$Parametrage$ModelesDeTache$Update$repondue, reponse, model);
			case 4:
				var texte = msg.a;
				return $author$project$Components$Parametrage$ModelesDeTache$Update$relire(
					_Utils_update(
						model,
						{hC: texte}));
			case 5:
				var genre = msg.a;
				return $author$project$Components$Parametrage$ModelesDeTache$Update$relire(
					_Utils_update(
						model,
						{M: genre}));
			case 6:
				var archives = msg.a;
				return $author$project$Components$Parametrage$ModelesDeTache$Update$relire(
					_Utils_update(
						model,
						{i$: archives}));
			case 7:
				var lien = msg.a;
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[
							A2($author$project$Components$Parametrage$ModelesDeTache$Update$Lire, $author$project$Components$Parametrage$ModelesDeTache$Update$Annuaire, lien)
						]));
			case 8:
				var uid = msg.a;
				var lien = msg.b;
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[
							A2(
							$author$project$Components$Parametrage$ModelesDeTache$Update$Lire,
							$author$project$Components$Parametrage$ModelesDeTache$Update$Fiche(uid),
							lien)
						]));
			case 9:
				var geste = msg.a;
				return A2($author$project$Components$Parametrage$ModelesDeTache$Update$versLeDrawer, geste, model);
			case 10:
				var nom = msg.a;
				return A2(
					$author$project$Components$Parametrage$ModelesDeTache$Update$saisir,
					function (s) {
						return _Utils_update(
							s,
							{Dj: nom});
					},
					model);
			case 11:
				var role = msg.a;
				return A2(
					$author$project$Components$Parametrage$ModelesDeTache$Update$saisir,
					function (s) {
						return _Utils_update(
							s,
							{bi: role});
					},
					model);
			case 12:
				var notes = msg.a;
				return A2(
					$author$project$Components$Parametrage$ModelesDeTache$Update$saisir,
					function (s) {
						return _Utils_update(
							s,
							{oL: notes});
					},
					model);
			case 13:
				var texte = msg.a;
				return A2(
					$author$project$Components$Parametrage$ModelesDeTache$Update$saisir,
					function (s) {
						return _Utils_update(
							s,
							{w2: texte});
					},
					model);
			case 14:
				var texte = msg.a;
				return A2(
					$author$project$Components$Parametrage$ModelesDeTache$Update$saisir,
					function (s) {
						return _Utils_update(
							s,
							{GU: texte});
					},
					model);
			case 15:
				var texte = msg.a;
				return A2(
					$author$project$Components$Parametrage$ModelesDeTache$Update$saisir,
					function (s) {
						return _Utils_update(
							s,
							{yy: texte});
					},
					model);
			case 16:
				var code = msg.a;
				return A2(
					$author$project$Components$Parametrage$ModelesDeTache$Update$saisir,
					function (s) {
						return _Utils_update(
							s,
							{hH: code});
					},
					model);
			case 17:
				return A3(
					$author$project$Components$Parametrage$ModelesDeTache$Update$envoyer,
					$author$project$API$NavLinksDictionary$modifierUnModeleDeTache,
					function (fiche) {
						return $author$project$Components$Parametrage$ModelesDeTache$API$WriteAPIModel$Modifier(
							{
								w2: model.hP.w2,
								xY: fiche.xY,
								yy: model.hP.yy,
								oa: fiche.r8,
								Dj: $elm$core$String$trim(model.hP.Dj),
								oL: model.hP.oL,
								GU: model.hP.GU,
								eO: A2($author$project$Components$Parametrage$ModelesDeTache$Update$avecLaRegle, model.hP.hH, fiche.eO),
								Hq: fiche.Hq,
								bi: $elm$core$String$trim(model.hP.bi)
							});
					},
					model);
			case 18:
				return A3(
					$author$project$Components$Parametrage$ModelesDeTache$Update$envoyer,
					$author$project$API$NavLinksDictionary$dupliquerUnModeleDeTache,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.r8;
						},
						$author$project$Components$Parametrage$ModelesDeTache$API$WriteAPIModel$Dupliquer),
					model);
			case 19:
				return A3(
					$author$project$Components$Parametrage$ModelesDeTache$Update$envoyer,
					$author$project$API$NavLinksDictionary$archiverUnModeleDeTache,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.r8;
						},
						$author$project$Components$Parametrage$ModelesDeTache$API$WriteAPIModel$Archiver),
					model);
			default:
				return A3(
					$author$project$Components$Parametrage$ModelesDeTache$Update$envoyer,
					$author$project$API$NavLinksDictionary$restaurerUnModeleDeTache,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.r8;
						},
						$author$project$Components$Parametrage$ModelesDeTache$API$WriteAPIModel$Restaurer),
					model);
		}
	});
var $author$project$Main$Update$versLesModelesDeTache = F3(
	function (i18n, msg, model) {
		var _v0 = A2($author$project$Components$Parametrage$ModelesDeTache$Update$update, msg, model.CL);
		var modeles = _v0.a;
		var effets = _v0.b;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLesModelesDeTache,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Parametrage$ModelesDeTache$Update$popMessages(msg),
							model.Ct),
						CL: modeles
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$AnnuaireDesOffres = 10;
var $author$project$Main$Model$PourLesOffres = 15;
var $author$project$Components$Produits$Offres$API$QueryAPIModel$Annuaire = F9(
	function (offres, nombre, etatDeDepart, niveauxDeRattachement, rattachables, types, etats, liens, gabarits) {
		return {yO: etatDeDepart, mj: etats, gF: gabarits, nQ: liens, Da: niveauxDeRattachement, w: nombre, D3: offres, GX: rattachables, ib: types};
	});
var $author$project$Components$Produits$Offres$API$QueryAPIModel$NiveauDeRattachement = F3(
	function (id, archetype, libelles) {
		return {fA: archetype, Aq: id, R: libelles};
	});
var $author$project$Components$Produits$Offres$API$QueryAPIModel$TypePropose = F2(
	function (id, nom) {
		return {Aq: id, Dj: nom};
	});
var $author$project$Components$Produits$Offres$API$QueryAPIModel$Offre = F8(
	function (id, nom, code, type_, rattachement, etat, arretee, ouvrable) {
		return {tL: arretee, vx: code, gt: etat, Aq: id, Dj: nom, Ex: ouvrable, pN: rattachement, r0: type_};
	});
var $author$project$Components$Produits$Offres$API$QueryAPIModel$TypeDOffre = F2(
	function (id, nom) {
		return {Aq: id, Dj: nom};
	});
var $author$project$Components$Produits$Offres$API$QueryAPIModel$typeDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'nom',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$author$project$Catalogue$Identifiants$typeDeProduitIdDecoder,
		$elm$json$Json$Decode$succeed($author$project$Components$Produits$Offres$API$QueryAPIModel$TypeDOffre)));
var $author$project$Components$Produits$Offres$API$QueryAPIModel$offreDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.h0;
			},
			A2(
				$elm$core$Basics$composeR,
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$self),
				$elm$core$Basics$neq($elm$core$Maybe$Nothing))),
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'arretee',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'etat',
			$author$project$Catalogue$Identifiants$etatCodeDecoder,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'rattachement',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$elementDeRattachementDecoder),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'type',
					$author$project$Components$Produits$Offres$API$QueryAPIModel$typeDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'code',
						$elm$json$Json$Decode$string,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'nom',
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$author$project$Catalogue$Identifiants$referenceIdDecoder,
								$elm$json$Json$Decode$succeed($author$project$Components$Produits$Offres$API$QueryAPIModel$Offre)))))))));
var $author$project$Components$Produits$Offres$API$QueryAPIModel$annuaireDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.gF;
		},
		$author$project$API$Liens$deLaRessource),
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		A2(
			$elm$json$Json$Decode$map,
			function ($) {
				return $.h0;
			},
			$author$project$API$Liens$deLaRessource),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'etats',
			$author$project$Catalogue$API$QueryAPIModel$etatsDuClientDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'types',
				$elm$json$Json$Decode$list(
					A3(
						$elm$json$Json$Decode$map2,
						$author$project$Components$Produits$Offres$API$QueryAPIModel$TypePropose,
						A2($elm$json$Json$Decode$field, 'id', $author$project$Catalogue$Identifiants$typeDeProduitIdDecoder),
						A2($elm$json$Json$Decode$field, 'nom', $author$project$Catalogue$API$QueryAPIModel$libellesDecoder))),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'rattachables',
					$elm$json$Json$Decode$list($author$project$Catalogue$API$QueryAPIModel$elementDeRattachementDecoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'niveauxDeRattachement',
						$elm$json$Json$Decode$list(
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'libelles',
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$QueryAPIModel$libellesDecoder),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'archetype',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$author$project$Catalogue$Identifiants$niveauIdDecoder,
										$elm$json$Json$Decode$succeed($author$project$Components$Produits$Offres$API$QueryAPIModel$NiveauDeRattachement))))),
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'etatDeDepart',
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$Identifiants$etatCodeDecoder),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'nombre',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'offres',
									$elm$json$Json$Decode$list($author$project$Components$Produits$Offres$API$QueryAPIModel$offreDecoder),
									$elm$json$Json$Decode$succeed($author$project$Components$Produits$Offres$API$QueryAPIModel$Annuaire))))))))));
var $author$project$Catalogue$API$PrixAPIModel$PrixPublics = F5(
	function (liste, devise, taxes, prix, liens) {
		return {kO: devise, nQ: liens, nW: liste, py: prix, rB: taxes};
	});
var $author$project$Catalogue$API$PrixAPIModel$prixPublicsDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'prix',
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (reference, montant, unite) {
						return {oi: montant, Hc: reference, sa: unite};
					}),
				A2($elm$json$Json$Decode$field, $author$project$Catalogue$Vocabulaire$champDeLaReference, $author$project$Catalogue$Identifiants$referenceIdDecoder),
				A2($elm$json$Json$Decode$field, 'montant', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'unite', $elm$json$Json$Decode$string))),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'taxes',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$PrixAPIModel$taxesDecoder),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'devise',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'liste',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Catalogue$API$PrixAPIModel$listeNommeeDecoder),
					$elm$core$Maybe$Nothing,
					$elm$json$Json$Decode$succeed($author$project$Catalogue$API$PrixAPIModel$PrixPublics))))));
var $author$project$Components$Produits$Offres$Update$popMessages = function (msg) {
	switch (msg.$) {
		case 2:
			var reponse = msg.a;
			var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Offres$API$QueryAPIModel$annuaireDecoder, reponse);
			if (_v1.$ === 1) {
				var refus = _v1.a;
				return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Components$Shared$Messages$Model$duRefus(refus));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 3:
			var reponse = msg.a;
			var _v2 = A2($author$project$API$Reponse$lire, $author$project$Catalogue$API$PrixAPIModel$prixPublicsDecoder, reponse);
			if (_v2.$ === 1) {
				var refus = _v2.a;
				return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Components$Shared$Messages$Model$duRefus(refus));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 4:
			var reponse = msg.a;
			var _v3 = A2(
				$author$project$API$Reponse$lire,
				$elm$json$Json$Decode$list($author$project$Catalogue$API$QueryAPIModel$rolesSurUneOffreDecoder),
				reponse);
			if (_v3.$ === 1) {
				var refus = _v3.a;
				return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Components$Shared$Messages$Model$duRefus(refus));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 1:
			var octets = msg.a;
			return _Utils_eq(
				$author$project$API$ProcessUid$depuisOctets(octets),
				$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
				{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$Offres$Model$appliquer = F2(
	function (rendue, annuaire) {
		var carte = function (evenement) {
			if (evenement.$ === 37) {
				var id = evenement.a;
				var creee = evenement.b;
				return $elm$core$Maybe$Just(
					{
						tL: false,
						vx: creee.vx,
						gt: creee.gt,
						Aq: id,
						Dj: creee.Dj,
						Ex: !_Utils_eq(
							A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$self, rendue.nQ),
							$elm$core$Maybe$Nothing),
						pN: $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (element) {
									return _Utils_eq(
										$elm$core$Maybe$Just(element.Aq),
										creee.pN);
								},
								annuaire.GX)),
						r0: {
							Aq: creee.fh,
							Dj: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.Dj;
								},
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.Aq;
											},
											$elm$core$Basics$eq(creee.fh)),
										annuaire.ib)))
						}
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		var creees = A2($elm$core$List$filterMap, carte, rendue.mk);
		return _Utils_update(
			annuaire,
			{
				w: annuaire.w + $elm$core$List$length(creees),
				D3: _Utils_ap(creees, annuaire.D3)
			});
	});
var $author$project$Components$Produits$Offres$Creation$prefixeDuNom = function (prefixe) {
	return prefixe + '-nom';
};
var $author$project$Components$Produits$Offres$Creation$idDe = F2(
	function (prefixe, zone) {
		switch (zone) {
			case 0:
				return prefixe + '-type';
			case 1:
				return prefixe + '-rattachement';
			case 2:
				return $author$project$Components$Produits$Common$LibellesSaisis$idDuPremierChamp(
					$author$project$Components$Produits$Offres$Creation$prefixeDuNom(prefixe));
			default:
				return prefixe + '-code';
		}
	});
var $author$project$Components$Produits$Offres$Update$perime = function (erreur) {
	return A2(
		$elm$core$List$member,
		erreur,
		_List_fromArray(
			[$author$project$Components$Produits$Common$API$WriteAPIErrorsModel$EtatInconnu, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$TypeDeProduitArchive, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$ParentArchive, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$NiveauNonUtilise, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$NiveauInconnu, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$DejaExistant, $author$project$Components$Produits$Common$API$WriteAPIErrorsModel$Introuvable]));
};
var $author$project$Components$Produits$Offres$Creation$ZoneCode = 3;
var $author$project$Components$Produits$Offres$Creation$ZoneNom = 2;
var $author$project$Components$Produits$Offres$Creation$ZoneRattachement = 1;
var $author$project$I18n$Textes$produitsCatalogueChampNomObligatoire = A3($author$project$I18n$Traductions$texte, 'produits.catalogue.champ.nom.obligatoire', _List_Nil, 'Le nom est obligatoire.');
var $author$project$Components$Produits$Offres$Update$refusDe = F3(
	function (model, refus, erreur) {
		var sous = F2(
			function (zone, texte) {
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(
						_Utils_Tuple2(zone, texte)));
			});
		var enTete = function (texte) {
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(
					{Jx: texte, b9: refus.b9}),
				$elm$core$Maybe$Nothing);
		};
		var code = $elm$core$String$trim(model.hP.vx);
		switch (erreur.$) {
			case 31:
				var marque = erreur.a;
				return A2(
					sous,
					3,
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$I18n$Textes$produitsReferencesRefusCodePrisSansMarque(
							{
								vx: $author$project$I18n$Traductions$tel(code)
							}),
						A2(
							$elm$core$Maybe$map,
							function (connue) {
								return $author$project$I18n$Textes$produitsReferencesRefusCodePris(
									{
										vx: $author$project$I18n$Traductions$tel(code),
										gX: $author$project$I18n$Traductions$tel(connue.R.zX)
									});
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (element) {
										return _Utils_eq(
											$elm$core$Maybe$Just(element.Aq),
											marque);
									},
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.GX;
											},
											model.aS)))))));
			case 10:
				return A2(sous, 1, $author$project$I18n$Textes$produitsReferencesRefusRattachementRequis);
			case 11:
				return A2(sous, 1, $author$project$I18n$Textes$produitsReferencesRefusRattachementHorsHierarchie);
			case 32:
				return A2(sous, 2, $author$project$I18n$Textes$produitsCatalogueChampNomObligatoire);
			case 35:
				return enTete($author$project$I18n$Textes$produitsReferencesRefusTypeArchive);
			case 33:
				return enTete($author$project$I18n$Textes$produitsReferencesRefusEtatInconnu);
			default:
				return $author$project$Components$Produits$Offres$Update$perime(erreur) ? enTete($author$project$I18n$Textes$produitsCatalogueErreurPerime) : _Utils_Tuple2(
					$elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus)),
					$elm$core$Maybe$Nothing);
		}
	});
var $author$project$Components$Produits$Offres$Creation$refuser = F3(
	function (enTete, sousUnChamp, saisie) {
		return _Utils_update(
			saisie,
			{pZ: enTete, bf: sousUnChamp});
	});
var $author$project$Components$Produits$Offres$Update$relire = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$Lire, $elm$core$List$singleton),
			model.np));
};
var $author$project$Components$Produits$Offres$Update$relecture = F2(
	function (rendue, model) {
		return (rendue.sy && (!A2($elm$core$List$member, $author$project$Catalogue$API$WriteAPIModel$EvenementInconnu, rendue.mk))) ? $author$project$Components$Produits$Offres$Update$relire(model) : _List_fromArray(
			[
				$author$project$Components$Produits$Common$Effet$AttendreAvantDeRelire($author$project$Components$Produits$Common$Envoi$delaiDeRelectureMs)
			]);
	});
var $author$project$Components$Produits$Offres$Creation$enCours = function (saisie) {
	return (!_Utils_eq(saisie.Dj, $author$project$Components$Shared$LibellesParLangue$Model$vide)) || ($elm$core$String$trim(saisie.vx) !== '');
};
var $author$project$Components$Produits$Offres$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{kX: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Produits$Common$Effet$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Produits$Offres$Creation$enCours(model.hP)
				},
				geste,
				model.kX));
	});
var $author$project$Components$Produits$Offres$Update$conclure = F2(
	function (issue, model) {
		switch (issue.$) {
			case 0:
				if (issue.c) {
					var rendue = issue.b;
					return A2(
						$elm$core$Tuple$mapSecond,
						function (effets) {
							return _Utils_ap(
								effets,
								A2($author$project$Components$Produits$Offres$Update$relecture, rendue, model));
						},
						A2(
							$author$project$Components$Produits$Offres$Update$versLeDrawer,
							$author$project$Components$Shared$Drawer$Update$Fermer,
							_Utils_update(
								model,
								{
									aS: A2(
										$elm$core$Maybe$map,
										$author$project$Components$Produits$Offres$Model$appliquer(rendue),
										model.aS),
									hP: $author$project$Components$Produits$Offres$Creation$vide
								})));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								hP: A3(
									$author$project$Components$Produits$Offres$Creation$refuser,
									$elm$core$Maybe$Just($author$project$Components$Produits$Common$Refus$rejeu),
									$elm$core$Maybe$Nothing,
									model.hP)
							}),
						$author$project$Components$Produits$Offres$Update$relire(model));
				}
			case 1:
				var refus = issue.b;
				var erreur = issue.c;
				var _v1 = A3($author$project$Components$Produits$Offres$Update$refusDe, model, refus, erreur);
				var enTete = _v1.a;
				var sousUnChamp = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hP: A3($author$project$Components$Produits$Offres$Creation$refuser, enTete, sousUnChamp, model.hP)
						}),
					_Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (_v2) {
									var zone = _v2.a;
									return _List_fromArray(
										[
											$author$project$Components$Produits$Common$Effet$PlacerFocus(
											A2(
												$author$project$Components$Produits$Offres$Creation$idDe,
												$author$project$Components$Shared$Drawer$Model$idRacine(model.kX),
												zone))
										]);
								},
								sousUnChamp)),
						$author$project$Components$Produits$Offres$Update$perime(erreur) ? $author$project$Components$Produits$Offres$Update$relire(model) : _List_Nil));
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$Offres$Model$creation = function (annuaire) {
	return A2(
		$elm$core$Maybe$andThen,
		function (_v0) {
			return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUneReference, annuaire.nQ);
		},
		annuaire.yO);
};
var $author$project$Components$Produits$Offres$Creation$ZoneType = 0;
var $author$project$Components$Produits$Offres$Creation$blanc = function (texte) {
	return $elm$core$String$trim(texte) === '';
};
var $author$project$Components$Produits$Offres$Creation$fautes = function (saisie) {
	return A2(
		$elm$core$List$filterMap,
		function (_v0) {
			var zone = _v0.a;
			var fautive = _v0.b;
			return fautive ? $elm$core$Maybe$Just(zone) : $elm$core$Maybe$Nothing;
		},
		_List_fromArray(
			[
				_Utils_Tuple2(
				0,
				_Utils_eq(saisie.fh, $elm$core$Maybe$Nothing)),
				_Utils_Tuple2(
				2,
				_Utils_eq(
					$author$project$Components$Produits$Common$LibellesSaisis$versLApi(saisie.Dj),
					$elm$core$Maybe$Nothing)),
				_Utils_Tuple2(
				3,
				$author$project$Components$Produits$Offres$Creation$blanc(saisie.vx))
			]));
};
var $author$project$Components$Produits$Offres$Creation$offreACreer = F2(
	function (annuaire, saisie) {
		var _v0 = _Utils_Tuple3(
			_Utils_Tuple2(saisie.fh, annuaire.yO),
			$author$project$Components$Produits$Offres$Creation$fautes(saisie),
			$author$project$Components$Produits$Common$LibellesSaisis$versLApi(saisie.Dj));
		if ((((!_v0.a.a.$) && (!_v0.a.b.$)) && (!_v0.b.b)) && (!_v0.c.$)) {
			var _v1 = _v0.a;
			var type_ = _v1.a.a;
			var etatDeDepart = _v1.b.a;
			var nom = _v0.c.a;
			return $elm$core$Maybe$Just(
				{
					i8: _List_Nil,
					vx: $elm$core$String$trim(saisie.vx),
					lI: $elm$core$Maybe$Nothing,
					gt: etatDeDepart,
					n8: $elm$core$Maybe$Nothing,
					g1: $author$project$Catalogue$Vocabulaire$natureDeService,
					Dj: $elm$core$Maybe$Just(nom),
					o4: $elm$core$Maybe$Nothing,
					pN: saisie.pN,
					fh: type_,
					r3: $elm$core$Maybe$Nothing,
					Ki: _List_Nil,
					sl: $elm$core$Maybe$Nothing
				});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$Offres$Model$commandeDeCreation = F2(
	function (annuaire, saisie) {
		return A3(
			$elm$core$Maybe$map2,
			F2(
				function (offre, lien) {
					return _Utils_Tuple2(
						$author$project$Catalogue$API$WriteAPIModel$CreerUneReference(offre),
						lien);
				}),
			A2($author$project$Components$Produits$Offres$Creation$offreACreer, annuaire, saisie),
			$author$project$Components$Produits$Offres$Model$creation(annuaire));
	});
var $author$project$Components$Produits$Offres$Creation$tenter = function (saisie) {
	return _Utils_update(
		saisie,
		{b5: true});
};
var $author$project$Components$Produits$Offres$Update$creer = function (model) {
	var _v0 = _Utils_Tuple2(
		model.aS,
		$author$project$Components$Shared$Drawer$Model$estOuvert(model.kX));
	if ((!_v0.a.$) && _v0.b) {
		var annuaire = _v0.a.a;
		var _v1 = _Utils_Tuple2(
			A2($author$project$Components$Produits$Offres$Model$commandeDeCreation, annuaire, model.hP),
			$author$project$Components$Produits$Offres$Creation$fautes(model.hP));
		if (!_v1.a.$) {
			var _v2 = _v1.a.a;
			var commande = _v2.a;
			var lien = _v2.b;
			var _v3 = A3(
				$author$project$Components$Produits$Common$Envoi$partir,
				$elm$core$Maybe$Just(lien),
				commande,
				model.l2);
			if (!_v3.$) {
				var _v4 = _v3.a;
				var envoi = _v4.a;
				var effets = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: envoi,
							hP: A3($author$project$Components$Produits$Offres$Creation$refuser, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, model.hP)
						}),
					effets);
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		} else {
			if (_v1.b.b) {
				var _v5 = _v1.a;
				var _v6 = _v1.b;
				var fautive = _v6.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hP: $author$project$Components$Produits$Offres$Creation$tenter(model.hP)
						}),
					_List_fromArray(
						[
							$author$project$Components$Produits$Common$Effet$PlacerFocus(
							A2(
								$author$project$Components$Produits$Offres$Creation$idDe,
								$author$project$Components$Shared$Drawer$Model$idRacine(model.kX),
								fautive))
						]));
			} else {
				var _v7 = _v1.a;
				return _Utils_Tuple2(model, _List_Nil);
			}
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$Offres$Update$depuisLaListe = function (effet) {
	if (!effet.$) {
		var cle = effet.a;
		var vue = effet.b;
		return _List_fromArray(
			[
				A2($author$project$Components$Produits$Common$Effet$GarderVue, cle, vue)
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Produits$Offres$Model$idDeLaCreation = 'offres-creer';
var $author$project$API$NavLinksDictionary$offresDeService = 'offres-de-service';
var $author$project$Components$Produits$Offres$Model$ouvert = F2(
	function (lecture, model) {
		return {
			aS: $elm$core$Maybe$Nothing,
			kX: $author$project$Components$Shared$Drawer$Model$init($author$project$Components$Produits$Offres$Model$nomDuDrawer),
			l2: $author$project$API$Envoi$SansProcessUid,
			np: lecture,
			nW: model.nW,
			py: $elm$core$Maybe$Nothing,
			eX: $elm$core$Maybe$Nothing,
			hP: $author$project$Components$Produits$Offres$Creation$vide
		};
	});
var $author$project$API$NavLinksDictionary$prixPublics = 'prix-publics';
var $author$project$Components$Produits$Offres$Creation$saisir = F3(
	function (annuaire, champ, saisie) {
		var sans = F2(
			function (zone, voulue) {
				return _Utils_update(
					voulue,
					{
						bf: function () {
							var _v1 = voulue.bf;
							if (!_v1.$) {
								var _v2 = _v1.a;
								var fautive = _v2.a;
								return _Utils_eq(fautive, zone) ? $elm$core$Maybe$Nothing : voulue.bf;
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}()
					});
			});
		var parmi = F3(
			function (versTexte, proposes, valeur) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							versTexte,
							$elm$core$Basics$eq(valeur)),
						proposes));
			});
		switch (champ.$) {
			case 0:
				var valeur = champ.a;
				return A2(
					sans,
					0,
					_Utils_update(
						saisie,
						{
							fh: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.Aq;
								},
								A3(
									parmi,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.Aq;
										},
										$author$project$Catalogue$Identifiants$typeDeProduitIdToString),
									annuaire.ib,
									valeur))
						}));
			case 1:
				var valeur = champ.a;
				return A2(
					sans,
					1,
					_Utils_update(
						saisie,
						{
							pN: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.Aq;
								},
								A3(
									parmi,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.Aq;
										},
										$author$project$Catalogue$Identifiants$elementIdToString),
									annuaire.GX,
									valeur))
						}));
			case 2:
				var code = champ.a;
				var texte = champ.b;
				return A2(
					sans,
					2,
					_Utils_update(
						saisie,
						{
							Dj: A3($author$project$Components$Shared$LibellesParLangue$Model$ecrire, code, texte, saisie.Dj)
						}));
			default:
				var texte = champ.a;
				return A2(
					sans,
					3,
					_Utils_update(
						saisie,
						{vx: texte}));
		}
	});
var $author$project$Components$Produits$Offres$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var liens = msg.a;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$offresDeService, liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Produits$Offres$Model$ouvert,
							$elm$core$Maybe$Just(lecture),
							model),
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Components$Produits$Common$Effet$DemanderProcessUid,
									$author$project$Components$Produits$Common$Effet$Lire(lecture)
								]),
							_Utils_ap(
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$LireLesPrix, $elm$core$List$singleton),
										A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$prixPublics, liens))),
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										A2($elm$core$Basics$composeR, $author$project$Components$Produits$Common$Effet$LireLeComptageDesRoles, $elm$core$List$singleton),
										$author$project$Catalogue$API$QueryAPIModel$lienDuComptageDesRoles(liens))))));
				} else {
					return _Utils_Tuple2(
						A2($author$project$Components$Produits$Offres$Model$ouvert, $elm$core$Maybe$Nothing, model),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$Components$Produits$Common$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 2:
				var reponse = msg.a;
				var _v2 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Offres$API$QueryAPIModel$annuaireDecoder, reponse);
				if (!_v2.$) {
					var annuaire = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aS: $elm$core$Maybe$Just(annuaire)
							}),
						_List_Nil);
				} else {
					var refus = _v2.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 3:
				var reponse = msg.a;
				var _v3 = A2($author$project$API$Reponse$lire, $author$project$Catalogue$API$PrixAPIModel$prixPublicsDecoder, reponse);
				if (!_v3.$) {
					var prix = _v3.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								py: $elm$core$Maybe$Just(prix)
							}),
						_List_Nil);
				} else {
					var refus = _v3.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{py: $elm$core$Maybe$Nothing}),
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 4:
				var reponse = msg.a;
				var _v4 = A2(
					$author$project$API$Reponse$lire,
					$elm$json$Json$Decode$list($author$project$Catalogue$API$QueryAPIModel$rolesSurUneOffreDecoder),
					reponse);
				if (!_v4.$) {
					var comptage = _v4.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								eX: $elm$core$Maybe$Just(comptage)
							}),
						_List_Nil);
				} else {
					var refus = _v4.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{eX: $elm$core$Maybe$Nothing}),
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Produits$Common$Effet$Reconnecter]) : _List_Nil);
				}
			case 5:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Produits$Offres$Update$relire(model));
			case 6:
				var geste = msg.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					function (liste) {
						return _Utils_update(
							model,
							{nW: liste});
					},
					$elm$core$List$concatMap($author$project$Components$Produits$Offres$Update$depuisLaListe),
					A2($author$project$Components$Shared$Annuaire$Update$update, geste, model.nW));
			case 7:
				var geste = msg.a;
				return A2($author$project$Components$Produits$Common$Envoi$retientLeDrawer, model.l2, geste) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Produits$Offres$Update$versLeDrawer, geste, model);
			case 8:
				return _Utils_eq(
					A2($elm$core$Maybe$andThen, $author$project$Components$Produits$Offres$Model$creation, model.aS),
					$elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A2(
					$author$project$Components$Produits$Offres$Update$versLeDrawer,
					$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Produits$Offres$Model$idDeLaCreation),
					_Utils_update(
						model,
						{hP: $author$project$Components$Produits$Offres$Creation$vide}));
			case 9:
				var champ = msg.a;
				var _v5 = model.aS;
				if (!_v5.$) {
					var annuaire = _v5.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								hP: A3($author$project$Components$Produits$Offres$Creation$saisir, annuaire, champ, model.hP)
							}),
						_List_Nil);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 10:
				return $author$project$Components$Produits$Offres$Update$creer(model);
			default:
				var reponse = msg.a;
				var _v6 = A2($author$project$Components$Produits$Common$Envoi$conclure, reponse, model.l2);
				if (!_v6.$) {
					var _v7 = _v6.a;
					var envoi = _v7.a;
					var issue = _v7.b;
					var effets = _v7.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Produits$Offres$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Main$Update$versLesOffres = F3(
	function (i18n, msg, model) {
		var _v0 = A2(
			$author$project$Components$Produits$Offres$Update$update,
			msg,
			$author$project$Components$Produits$Offres$Model$ouvrir(model.D3));
		var offres = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLesElements, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			A3($author$project$Main$Update$depuisLesElements, i18n, 10, 15),
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Produits$Offres$Update$popMessages(msg),
							gardes),
						D3: $author$project$Components$Produits$Offres$Model$envelopper(offres)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$AttendreAvantDeChercherLesFiches = F2(
	function (a, b) {
		return {$: 65, a: a, b: b};
	});
var $author$project$Main$Update$ChercherLesFiches = function (a) {
	return {$: 57, a: a};
};
var $author$project$Main$Update$EnregistrerPreferencesDeLaListe = function (a) {
	return {$: 64, a: a};
};
var $author$project$Main$Update$EnvoyerAuxGroupesDeLaListe = function (a) {
	return {$: 62, a: a};
};
var $author$project$Main$Update$LireGroupesDeLaListe = function (a) {
	return {$: 59, a: a};
};
var $author$project$Main$Update$LireLEquipePourLaListe = F2(
	function (a, b) {
		return {$: 61, a: a, b: b};
	});
var $author$project$Main$Update$LireLeGroupeDeLaListe = function (a) {
	return {$: 60, a: a};
};
var $author$project$Main$Update$LireLesOffresDeLaListe = function (a) {
	return {$: 174, a: a};
};
var $author$project$Main$Update$LirePreferencesDeLaListe = function (a) {
	return {$: 63, a: a};
};
var $author$project$Main$Update$LireTypesDeLaListe = function (a) {
	return {$: 58, a: a};
};
var $author$project$Main$Model$PourLesGroupesDeLaListe = 31;
var $author$project$Main$Model$PourLesPreferencesDeLaListe = 2;
var $author$project$Main$Update$depuisLesPartiesPrenantes = F3(
	function (i18n, effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				var lecture = effet.a;
				var lien = effet.b;
				var recherche = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$ChercherLesFiches(
									{gM: vers.gM, np: lecture, nB: vers.nB, hC: recherche});
							})));
			case 1:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireTypesDeLaListe)));
			case 3:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesOffresDeLaListe)));
			case 2:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireGroupesDeLaListe)));
			case 15:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLeGroupeDeLaListe)));
			case 16:
				var etape = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLEquipePourLaListe(etape))));
			case 14:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[31]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 17:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerAuxGroupesDeLaListe(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 8:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LirePreferencesDeLaListe)));
			case 9:
				var lien = effet.a;
				var processUid = effet.b;
				var colonnes = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnregistrerPreferencesDeLaListe(
									{j1: colonnes, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 10:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[2]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 4:
				var saisie = effet.a;
				var delaiMs = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								A2($author$project$Main$Update$AttendreAvantDeChercherLesFiches, saisie, delaiMs)
							])));
			case 5:
				var adresse = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AllerA(adresse)
							])));
			case 11:
				var declencheur = effet.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A3($author$project$Main$Update$ouvrirLaCreation, i18n, declencheur, model));
			case 12:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			case 6:
				var cle = effet.a;
				var vue = effet.b;
				return A2(
					$author$project$Main$Update$garder,
					A3($author$project$Preferences$Model$setVue, cle, vue, model.eF),
					_Utils_Tuple2(model, effets));
			case 7:
				var cle = effet.a;
				var masques = effet.b;
				return A2(
					$author$project$Main$Update$garder,
					A3($author$project$Preferences$Model$setFiltresMasques, cle, masques, model.eF),
					_Utils_Tuple2(model, effets));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Main$Update$lectureDesFiches = function (effet) {
	if (!effet.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Referentiel$PartiesPrenantes$API$QueryAPIModel$ListeAPIView = F7(
	function (fiches, total, preferences, enregistrement, offres, offresPourOuvrir, importer) {
		return {l_: enregistrement, zu: fiches, AB: importer, D3: offres, D5: offresPourOuvrir, eF: preferences, JE: total};
	});
var $author$project$API$NavLinksDictionary$enregistrerPreferencesListe = 'enregistrer-preferences-liste';
var $author$project$Components$Referentiel$PartiesPrenantes$API$QueryAPIModel$FicheDeListeAPIView = F9(
	function (uid, qualite, pays, creeeLe, identite, roles, organisation, etat, ouvrable) {
		return {wn: creeeLe, gt: etat, Av: identite, En: organisation, Ex: ouvrable, ho: pays, hy: qualite, eX: roles, r8: uid};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$API$QueryAPIModel$RoleDeListeAPIView = F3(
	function (type_, archetype, offre) {
		return {fA: archetype, D1: offre, r0: type_};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$API$QueryAPIModel$OrganisationAPIView = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$API$QueryAPIModel$PersonneAPIView = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$API$QueryAPIModel$identite = function (nature) {
	switch (nature) {
		case 'Personne':
			return A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'prenom',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'nom',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					$elm$json$Json$Decode$succeed(
						F2(
							function (nom, prenom) {
								return $author$project$Components$Referentiel$PartiesPrenantes$API$QueryAPIModel$PersonneAPIView(
									{Dj: nom, Gg: prenom});
							}))));
		case 'Organisation':
			return A2(
				$elm$json$Json$Decode$map,
				function (raisonSociale) {
					return $author$project$Components$Referentiel$PartiesPrenantes$API$QueryAPIModel$OrganisationAPIView(
						{GR: raisonSociale});
				},
				$elm$json$Json$Decode$maybe(
					A2($elm$json$Json$Decode$field, 'raisonSociale', $elm$json$Json$Decode$string)));
		default:
			return $elm$json$Json$Decode$fail(nature);
	}
};
var $author$project$Components$Referentiel$PartiesPrenantes$API$QueryAPIModel$OrganisationDeListeAPIView = F2(
	function (raisonSociale, autres) {
		return {t7: autres, GR: raisonSociale};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$API$QueryAPIModel$organisation = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'autres',
	$elm$json$Json$Decode$int,
	0,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'raisonSociale',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$PartiesPrenantes$API$QueryAPIModel$OrganisationDeListeAPIView)));
var $author$project$Components$Referentiel$PartiesPrenantes$API$QueryAPIModel$fiche = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.h0;
			},
			A2(
				$elm$core$Basics$composeR,
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$self),
				$elm$core$Basics$neq($elm$core$Maybe$Nothing))),
		$author$project$API$Liens$deLaRessource),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'etat',
		$author$project$Components$Referentiel$Common$API$QueryAPIModel$etatDecoder,
		0,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'organisation',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Referentiel$PartiesPrenantes$API$QueryAPIModel$organisation),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'roles',
				$elm$json$Json$Decode$list(
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'offre',
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Referentiel$Common$API$QueryAPIModel$offreDuRoleDecoder),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'archetype',
							$author$project$Components$Referentiel$Archetype$decoder,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'type',
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Components$Referentiel$Identifiants$typeUidDecoder),
								$elm$core$Maybe$Nothing,
								$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$PartiesPrenantes$API$QueryAPIModel$RoleDeListeAPIView))))),
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					A2(
						$elm$json$Json$Decode$andThen,
						$author$project$Components$Referentiel$PartiesPrenantes$API$QueryAPIModel$identite,
						A2($elm$json$Json$Decode$field, 'nature', $elm$json$Json$Decode$string)),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'creeeLe',
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'pays',
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'qualite',
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'uid',
									$author$project$Components$Referentiel$Identifiants$entiteUidDecoder,
									$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$PartiesPrenantes$API$QueryAPIModel$FicheDeListeAPIView))))))))));
var $author$project$API$NavLinksDictionary$importer = 'importer';
var $author$project$API$NavLinksDictionary$offresDesRoles = 'offres-des-roles';
var $author$project$API$NavLinksDictionary$preferencesListe = 'preferences-liste';
var $author$project$Components$Referentiel$PartiesPrenantes$API$QueryAPIModel$listeDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.h0;
			},
			$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$importer)),
		$author$project$API$Liens$deLaRessource),
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		A2(
			$elm$json$Json$Decode$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.h0;
				},
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$offresPourUnRole)),
			$author$project$API$Liens$deLaRessource),
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2(
				$elm$json$Json$Decode$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.h0;
					},
					$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$offresDesRoles)),
				$author$project$API$Liens$deLaRessource),
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A2(
					$elm$json$Json$Decode$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.h0;
						},
						$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$enregistrerPreferencesListe)),
					$author$project$API$Liens$deLaRessource),
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					A2(
						$elm$json$Json$Decode$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.h0;
							},
							$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$preferencesListe)),
						$author$project$API$Liens$deLaRessource),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'total',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'fiches',
							$elm$json$Json$Decode$list($author$project$Components$Referentiel$PartiesPrenantes$API$QueryAPIModel$fiche),
							$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$PartiesPrenantes$API$QueryAPIModel$ListeAPIView))))))));
var $author$project$Components$Referentiel$PartiesPrenantes$API$QueryAPIModel$PreferencesAPIView = F4(
	function (liste, colonnes, parDefaut, proposees) {
		return {j1: colonnes, nW: liste, o6: parDefaut, pE: proposees};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$API$QueryAPIModel$preferencesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'proposees',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'parDefaut',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'colonnes',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'liste',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Referentiel$PartiesPrenantes$API$QueryAPIModel$PreferencesAPIView)))));
var $author$project$I18n$Textes$referentielPartiesPrenantesFiltreRefuse = A3($author$project$I18n$Traductions$texte, 'referentiel.parties-prenantes.filtre-refuse', _List_Nil, 'Un des filtres posés n\'est pas admis pour cette liste. Retirez-le ou effacez les filtres, puis relancez la recherche.');
var $author$project$Components$Referentiel$PartiesPrenantes$Update$DemanderProcessUid = {$: 10};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$EnregistrerPreferences = F3(
	function (a, b, c) {
		return {$: 9, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$Reconnecter = {$: 13};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$reglageDesPreferences = {
	f8: $author$project$Components$Referentiel$PartiesPrenantes$Update$DemanderProcessUid,
	l4: $author$project$Components$Referentiel$PartiesPrenantes$Update$EnregistrerPreferences,
	go: function (_v0) {
		return 0;
	},
	pW: $author$project$Components$Referentiel$PartiesPrenantes$Update$Reconnecter,
	qu: F2(
		function (_v1, _v2) {
			return true;
		}),
	qv: $elm$json$Json$Decode$succeed(0)
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$popMessages = F2(
	function (model, msg) {
		switch (msg.$) {
			case 7:
				var lecture = msg.a;
				var reponse = msg.b;
				if (!_Utils_eq(lecture, model.np)) {
					return $elm$core$Maybe$Nothing;
				} else {
					var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$PartiesPrenantes$API$QueryAPIModel$listeDecoder, reponse);
					if (_v1.$ === 1) {
						var refus = _v1.a;
						return (refus.ri === 401) ? $elm$core$Maybe$Nothing : (_Utils_eq(
							refus.bB,
							$author$project$API$Reponse$Metier('FiltreRefuse')) ? $elm$core$Maybe$Just(
							{Jx: $author$project$I18n$Textes$referentielPartiesPrenantesFiltreRefuse, b9: refus.b9}) : $elm$core$Maybe$Just(
							$author$project$Components$Shared$Messages$Model$duRefus(refus)));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}
			case 2:
				var reponse = msg.a;
				var _v2 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$API$QueryAPIModel$typesServisDecoder, reponse);
				if (_v2.$ === 1) {
					var refus = _v2.a;
					return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 3:
				var reponse = msg.a;
				var _v3 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$annuaireDecoder, reponse);
				if (_v3.$ === 1) {
					var refus = _v3.a;
					return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 30:
				var reponse = msg.a;
				var _v4 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$PartiesPrenantes$API$QueryAPIModel$preferencesDecoder, reponse);
				if (_v4.$ === 1) {
					var refus = _v4.a;
					return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 31:
				var reponse = msg.a;
				var _v5 = A3($author$project$API$Envoi$conclure, $author$project$Components$Referentiel$PartiesPrenantes$Update$reglageDesPreferences, reponse, model.l2);
				if ((!_v5.$) && (_v5.a.b.$ === 1)) {
					var _v6 = _v5.a;
					var _v7 = _v6.b;
					var refus = _v7.b;
					return $elm$core$Maybe$Just(
						$author$project$Components$Shared$Messages$Model$duRefus(refus));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Model$Affichee = 3;
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$AjouterEnLot = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$AttendreAvantDeChercher = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$DemanderProcessUidDeGroupe = {$: 14};
var $author$project$Components$Referentiel$PartiesPrenantes$Model$EnErreur = 4;
var $author$project$Components$Referentiel$PartiesPrenantes$Update$LireLeGroupeChoisi = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$LireLesGroupes = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$LireLesTypes = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$OuvrirLaCreation = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$PlacerFocus = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Model$SansDroit = 1;
var $author$project$Components$Referentiel$PartiesPrenantes$Groupage$ajoutVide = {vd: $elm$core$Maybe$Nothing, B1: $elm$core$Maybe$Nothing, en: $elm$core$Maybe$Nothing, b5: false};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$AllerA = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$allerA = F2(
	function (page, model) {
		return _Utils_Tuple2(
			model,
			_List_fromArray(
				[
					$author$project$Components$Referentiel$PartiesPrenantes$Update$AllerA(
					$author$project$Routes$Route$toString(
						$author$project$Routes$Route$PartiesPrenantesListe(page)))
				]));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Model$champsPourLAdresse = $elm$core$List$map(
	function (filtre) {
		return {
			dy: filtre.dy,
			r0: filtre.r0,
			fm: function () {
				var _v0 = filtre.fm;
				if (!_v0.$) {
					var texte = _v0.a;
					return $author$project$Routes$Route$ValeurTexte(texte);
				} else {
					var booleen = _v0.a;
					return $author$project$Routes$Route$ValeurOuiNon(booleen);
				}
			}()
		};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$allerAvecLesChamps = F3(
	function (page, champs, model) {
		var filtres = page.mG;
		return A2(
			$author$project$Components$Referentiel$PartiesPrenantes$Update$allerA,
			_Utils_update(
				page,
				{
					mG: _Utils_update(
						filtres,
						{
							dw: $author$project$Components$Referentiel$PartiesPrenantes$Model$champsPourLAdresse(champs)
						})
				}),
			_Utils_update(
				model,
				{dw: champs}));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Model$basculer = F2(
	function (colonne, cochees) {
		return A2($elm$core$List$member, colonne, cochees) ? A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(colonne),
			cochees) : _Utils_ap(
			cochees,
			_List_fromArray(
				[colonne]));
	});
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$OuiNon = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Common$API$QueryAPIModel$Texte = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Model$champsDeLAdresse = $elm$core$List$map(
	function (filtre) {
		return {
			dy: filtre.dy,
			r0: filtre.r0,
			fm: function () {
				var _v0 = filtre.fm;
				if (!_v0.$) {
					var texte = _v0.a;
					return $author$project$Components$Referentiel$Common$API$QueryAPIModel$Texte(texte);
				} else {
					var booleen = _v0.a;
					return $author$project$Components$Referentiel$Common$API$QueryAPIModel$OuiNon(booleen);
				}
			}()
		};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$ChercherLesFiches = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Model$EnLecture = 2;
var $author$project$Components$Referentiel$PartiesPrenantes$Model$champsRenseignes = function (filtres) {
	var _v0 = filtres.ib;
	if (_v0.b && (!_v0.b.b)) {
		var type_ = _v0.a;
		return A2(
			$elm$core$List$map,
			function (cle) {
				return {dy: cle, r0: type_};
			},
			filtres.qs);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Referentiel$PartiesPrenantes$Model$longueurMinDuTerme = 2;
var $author$project$Components$Referentiel$PartiesPrenantes$Model$termeCherche = function (model) {
	var cherche = $elm$core$String$trim(model.h3);
	return (_Utils_cmp(
		$elm$core$String$length(cherche),
		$author$project$Components$Referentiel$PartiesPrenantes$Model$longueurMinDuTerme) > -1) ? $elm$core$Maybe$Just(cherche) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$Referentiel$PartiesPrenantes$Model$recherche = function (model) {
	return {
		dw: model.dw,
		jF: $author$project$Components$Referentiel$PartiesPrenantes$Model$champsRenseignes(model.EE.mG),
		gt: model.EE.mG.gt,
		m2: model.EE.mG.m2,
		g1: model.EE.mG.g1,
		D1: model.EE.mG.D1,
		ho: model.EE.mG.ho,
		hy: model.EE.mG.hy,
		h3: $author$project$Components$Referentiel$PartiesPrenantes$Model$termeCherche(model),
		ib: model.EE.mG.ib
	};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$lire = function (model) {
	var _v0 = A2(
		$author$project$Components$Referentiel$Liens$versEntites,
		{
			EE: model.EE.EE,
			Jm: model.EE.Jm,
			rS: $author$project$Routes$Route$codeDuTri(model.EE.rS)
		},
		model.gF);
	if (!_v0.$) {
		var lien = _v0.a;
		var terme = $author$project$Components$Referentiel$PartiesPrenantes$Model$termeCherche(model);
		var lecture = model.np + 1;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{kC: terme, gt: 2, np: lecture}),
			_List_fromArray(
				[
					A3(
					$author$project$Components$Referentiel$PartiesPrenantes$Update$ChercherLesFiches,
					lecture,
					lien,
					$author$project$Components$Referentiel$PartiesPrenantes$Model$recherche(model))
				]));
	} else {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{gt: 1, B1: $elm$core$Maybe$Nothing}),
			_List_Nil);
	}
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$chercher = function (model) {
	var page = model.EE;
	return (page.EE === 1) ? $author$project$Components$Referentiel$PartiesPrenantes$Update$lire(model) : A2(
		$author$project$Components$Referentiel$PartiesPrenantes$Update$allerA,
		_Utils_update(
			page,
			{EE: 1}),
		model);
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$chercherAvecLesChamps = F2(
	function (champs, model) {
		return A3(
			$author$project$Components$Referentiel$PartiesPrenantes$Update$allerAvecLesChamps,
			function () {
				var p = model.EE;
				return _Utils_update(
					p,
					{EE: 1});
			}(),
			champs,
			model);
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$choisirLesColonnes = F2(
	function (choix, model) {
		return _Utils_update(
			model,
			{
				aS: A2(
					$author$project$Components$Shared$Annuaire$Update$update,
					$author$project$Components$Shared$Annuaire$Update$ColonnesChoisies(choix),
					model.aS).a
			});
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Model$colonnesDuCatalogue = _Utils_ap(
	$author$project$Components$Referentiel$PartiesPrenantes$Model$colonnesParDefaut,
	_List_fromArray(
		['creation']));
var $author$project$Components$Referentiel$PartiesPrenantes$Update$colonnesMontrees = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Components$Referentiel$PartiesPrenantes$Model$colonnesParDefaut,
		A2(
			$elm$core$Maybe$map,
			function (choisies) {
				return A2(
					$elm$core$List$filter,
					function (c) {
						return A2($elm$core$List$member, c, $author$project$Components$Referentiel$PartiesPrenantes$Model$colonnesDuCatalogue);
					},
					choisies);
			},
			model.aS.j1));
};
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$CreerDynamiqueDepuisLaListe = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Groupage$ecartes = F2(
	function (terme, filtres) {
		return {
			kr: false,
			gt: !_Utils_eq(filtres.gt, $elm$core$Maybe$Nothing),
			hC: !_Utils_eq(terme, $elm$core$Maybe$Nothing)
		};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$EnvoyerAUnGroupe = F3(
	function (a, b, c) {
		return {$: 17, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$reglageDeGroupe = {
	f8: $author$project$Components$Referentiel$PartiesPrenantes$Update$DemanderProcessUidDeGroupe,
	l4: $author$project$Components$Referentiel$PartiesPrenantes$Update$EnvoyerAUnGroupe,
	go: function (_v0) {
		return 0;
	},
	pW: $author$project$Components$Referentiel$PartiesPrenantes$Update$Reconnecter,
	qu: F2(
		function (_v1, _v2) {
			return true;
		}),
	qv: $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$reponseDeCommandeDecoder
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$envoyerAuGroupe = F3(
	function (lien, commande, model) {
		var _v0 = A4($author$project$API$Envoi$partir, $author$project$Components$Referentiel$PartiesPrenantes$Update$reglageDeGroupe, lien, commande, model.l3);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var envoi = _v1.a;
			var effets = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l3: envoi, p0: $elm$core$Maybe$Nothing}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Groupage$archetypesDesTypes = F2(
	function (types, choisis) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (archetype, vus) {
					return A2($elm$core$List$member, archetype, vus) ? vus : _Utils_ap(
						vus,
						_List_fromArray(
							[archetype]));
				}),
			_List_Nil,
			A2(
				$elm$core$List$filterMap,
				function (choisi) {
					return A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.fA;
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (t) {
									return _Utils_eq(
										$author$project$Components$Referentiel$Identifiants$typeUidToString(t.r8),
										choisi);
								},
								types)));
				},
				choisis));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Groupage$filtreDeLaCopie = F2(
	function (types, filtres) {
		return {
			g1: filtres.g1,
			ho: filtres.ho,
			hy: filtres.hy,
			Ic: _List_Nil,
			Id: A2($author$project$Components$Referentiel$PartiesPrenantes$Groupage$archetypesDesTypes, types, filtres.ib)
		};
	});
var $author$project$API$NavLinksDictionary$creerUnGroupeDynamiqueDepuisLaListe = 'creer-un-groupe-dynamique-depuis-la-liste';
var $author$project$Components$Referentiel$PartiesPrenantes$Groupage$lienDeLaCopie = function (annuaire) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUnGroupeDynamiqueDepuisLaListe, annuaire.nQ);
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$confirmerLaCopie = function (model) {
	var _v0 = _Utils_Tuple2(model.kc, model.iR);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var copie = _v0.a.a;
		var annuaire = _v0.b.a;
		var posee = function (texte) {
			return $elm$core$String$isEmpty(
				$elm$core$String$trim(texte)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				$elm$core$String$trim(texte));
		};
		var nom = $elm$core$String$trim(copie.Dj);
		return $elm$core$String$isEmpty(nom) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{
					kc: $elm$core$Maybe$Just(
						_Utils_update(
							copie,
							{b5: true}))
				}),
			_List_Nil) : A3(
			$author$project$Components$Referentiel$PartiesPrenantes$Update$envoyerAuGroupe,
			$author$project$Components$Referentiel$PartiesPrenantes$Groupage$lienDeLaCopie(annuaire),
			A3(
				$author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$CreerDynamiqueDepuisLaListe,
				{
					dH: posee(copie.dH),
					Dj: nom,
					qB: posee(copie.qB)
				},
				A2($author$project$Components$Referentiel$PartiesPrenantes$Groupage$filtreDeLaCopie, model.ib, model.EE.mG),
				A2(
					$author$project$Components$Referentiel$PartiesPrenantes$Groupage$ecartes,
					$author$project$Components$Referentiel$PartiesPrenantes$Model$termeCherche(model),
					model.EE.mG)),
			model);
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Referentiel$PartiesPrenantes$Groupage$copieVide = {dH: '', Dj: '', qB: '', b5: false};
var $author$project$Components$Referentiel$PartiesPrenantes$Model$delaiDeSaisieMs = 300;
var $author$project$Components$Referentiel$PartiesPrenantes$Update$demanderLeProcessUid = function (model) {
	var _v0 = model.l2;
	if (!_v0.$) {
		return _List_fromArray(
			[$author$project$Components$Referentiel$PartiesPrenantes$Update$DemanderProcessUid]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Referentiel$PartiesPrenantes$Model$deplacer = F3(
	function (sens, colonne, cochees) {
		if (!sens) {
			return A2(
				$author$project$Components$Shared$Ordre$monter,
				$elm$core$Basics$eq(colonne),
				cochees);
		} else {
			return A2(
				$author$project$Components$Shared$Ordre$descendre,
				$elm$core$Basics$eq(colonne),
				cochees);
		}
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$GarderFiltresMasques = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$GarderVue = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$depuisLAnnuaire = function (effet) {
	if (!effet.$) {
		var cle = effet.a;
		var vue = effet.b;
		return A2($author$project$Components$Referentiel$PartiesPrenantes$Update$GarderVue, cle, vue);
	} else {
		var cle = effet.a;
		var masques = effet.b;
		return A2($author$project$Components$Referentiel$PartiesPrenantes$Update$GarderFiltresMasques, cle, masques);
	}
};
var $author$project$Components$Referentiel$PartiesPrenantes$Model$idDuDeclencheurDuTri = 'parties-prenantes-tri';
var $author$project$Components$Referentiel$PartiesPrenantes$Update$fermerLeMenuDuTri = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{gY: false}),
		_List_fromArray(
			[
				$author$project$Components$Referentiel$PartiesPrenantes$Update$PlacerFocus($author$project$Components$Referentiel$PartiesPrenantes$Model$idDuDeclencheurDuTri)
			]));
};
var $author$project$Components$Referentiel$PartiesPrenantes$Groupage$filtreDeLaListe = F2(
	function (filtres, terme) {
		return {fA: $elm$core$Maybe$Nothing, g1: filtres.g1, ho: filtres.ho, hy: filtres.hy, h3: terme, ib: filtres.ib};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Groupage$filtreEntier = function (annuaire) {
	return A2($author$project$Components$Shared$Annuaire$Model$bandeau, 0, annuaire) === 2;
};
var $author$project$Components$Referentiel$PartiesPrenantes$Model$idDeLOrdre = function (tri) {
	return $author$project$Components$Referentiel$PartiesPrenantes$Model$idDuDeclencheurDuTri + ('-' + $author$project$Routes$Route$codeDuTri(tri));
};
var $author$project$Components$Referentiel$PartiesPrenantes$Model$idDuDeclencheurDAjout = 'parties-prenantes-ajouter-a-un-groupe';
var $author$project$Components$Referentiel$PartiesPrenantes$Model$idDuDeclencheurDeCopie = 'parties-prenantes-enregistrer-comme-groupe';
var $author$project$Components$Referentiel$PartiesPrenantes$Model$idDuDeclencheurDeFiltres = 'parties-prenantes-filtres';
var $author$project$API$NavLinksDictionary$ajouterAUnGroupe = 'ajouter-a-un-groupe';
var $author$project$Components$Referentiel$PartiesPrenantes$Groupage$lienDAjout = function (annuaire) {
	return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ajouterAUnGroupe, annuaire.nQ);
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$LireLEquipeDeLaListe = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$lireLEquipe = function (model) {
	var _v0 = model.l5;
	if (_v0.$ === 1) {
		return _List_Nil;
	} else {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (_v1) {
					var etape = _v1.a;
					var lien = _v1.b;
					return _List_fromArray(
						[
							A2($author$project$Components$Referentiel$PartiesPrenantes$Update$LireLEquipeDeLaListe, etape, lien)
						]);
				},
				$author$project$Components$Referentiel$Common$Equipe$premiereEtape(model.GN)));
	}
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$LireLesOffres = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$lireLesOffres = F2(
	function (model, vue) {
		var _v0 = model.D3;
		if (!_v0.$) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$PartiesPrenantes$Update$LireLesOffres, $elm$core$List$singleton),
					vue.D3));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$LirePreferences = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$lireLesPreferences = F2(
	function (model, vue) {
		var _v0 = _Utils_Tuple2(model.pu, vue.eF);
		if ((!_v0.a) && (!_v0.b.$)) {
			var lien = _v0.b.a;
			return _Utils_Tuple2(
				true,
				_List_fromArray(
					[
						$author$project$Components$Referentiel$PartiesPrenantes$Update$LirePreferences(lien)
					]));
		} else {
			var demandees = _v0.a;
			return _Utils_Tuple2(demandees, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$modifierLaCopie = F2(
	function (f, model) {
		return _Utils_update(
			model,
			{
				kc: A2($elm$core$Maybe$map, f, model.kc)
			});
	});
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$nouveauGroupe = function (nom) {
	return {dH: $elm$core$Maybe$Nothing, Dj: nom, qB: $elm$core$Maybe$Nothing};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Model$ordresProposes = _List_fromArray(
	[0, 1]);
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$FichesCochees = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$ResultatDuFiltre = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Groupage$portee = F3(
	function (toutLeFiltre, fiches, filtre) {
		return toutLeFiltre ? $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$ResultatDuFiltre(filtre) : $author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$FichesCochees(fiches);
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Model$valeurPosee = F2(
	function (cle, champs) {
		return A2(
			$elm$core$List$map,
			function ($) {
				return $.fm;
			},
			A2(
				$elm$core$List$filter,
				function (filtre) {
					return _Utils_eq(filtre.dy, cle);
				},
				champs));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Model$poserUnChoix = F4(
	function (type_, cle, choix, champs) {
		return A2(
			$elm$core$List$member,
			$author$project$Components$Referentiel$Common$API$QueryAPIModel$Texte(choix),
			A2($author$project$Components$Referentiel$PartiesPrenantes$Model$valeurPosee, cle, champs)) ? A2(
			$elm$core$List$filter,
			function (filtre) {
				return !(_Utils_eq(filtre.dy, cle) && _Utils_eq(
					filtre.fm,
					$author$project$Components$Referentiel$Common$API$QueryAPIModel$Texte(choix)));
			},
			champs) : _Utils_ap(
			champs,
			_List_fromArray(
				[
					{
					dy: cle,
					r0: type_,
					fm: $author$project$Components$Referentiel$Common$API$QueryAPIModel$Texte(choix)
				}
				]));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Model$retirerUnChamp = function (cle) {
	return $elm$core$List$filter(
		function (filtre) {
			return !_Utils_eq(filtre.dy, cle);
		});
};
var $author$project$Components$Referentiel$PartiesPrenantes$Model$poserUnTexte = F4(
	function (type_, cle, valeur, champs) {
		return _Utils_ap(
			A2($author$project$Components$Referentiel$PartiesPrenantes$Model$retirerUnChamp, cle, champs),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (pose) {
						return _List_fromArray(
							[
								{dy: cle, r0: type_, fm: pose}
							]);
					},
					valeur)));
	});
var $author$project$Components$Shared$Annuaire$Model$nombreSelectionne = F2(
	function (total, model) {
		var _v0 = model.aw;
		if (_v0 === 2) {
			return total;
		} else {
			return $elm$core$Set$size(model.vv);
		}
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$fichesVisees = function (model) {
	return A2(
		$author$project$Components$Shared$Annuaire$Model$nombreSelectionne,
		A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.JE;
				},
				model.B1)),
		model.aS);
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$surLeVoletDAjout = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (volet) {
				return _Utils_update(
					model,
					{sw: volet});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Referentiel$PartiesPrenantes$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.sw));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$saisieDeLaCopie = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (copie) {
				return (copie.Dj !== '') || ((copie.dH !== '') || (copie.qB !== ''));
			},
			model.kc));
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$surLeVoletDeCopie = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (volet) {
				return _Utils_update(
					model,
					{sx: volet});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Referentiel$PartiesPrenantes$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Referentiel$PartiesPrenantes$Update$saisieDeLaCopie(model)
				},
				geste,
				model.sx));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$repondreAUneCommandeDeGroupe = F2(
	function (reponse, model) {
		var _v0 = A3($author$project$API$Envoi$conclure, $author$project$Components$Referentiel$PartiesPrenantes$Update$reglageDeGroupe, reponse, model.l3);
		if (!_v0.$) {
			switch (_v0.a.b.$) {
				case 0:
					var _v1 = _v0.a;
					var envoi = _v1.a;
					var _v2 = _v1.b;
					var commande = _v2.a;
					var rendue = _v2.b;
					var effets = _v1.c;
					var uidDuSelf = A2(
						$elm$core$Maybe$andThen,
						$author$project$Components$Referentiel$Identifiants$groupeUidFromString,
						A2(
							$elm$core$Maybe$andThen,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.cM;
								},
								A2(
									$elm$core$Basics$composeR,
									$elm$core$String$split('/'),
									A2($elm$core$Basics$composeR, $elm$core$List$reverse, $elm$core$List$head))),
							A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$self, rendue.nQ)));
					var suivant = _Utils_update(
						model,
						{l3: envoi, p0: $elm$core$Maybe$Nothing});
					var relireLesGroupes = A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$PartiesPrenantes$Update$LireLesGroupes, $elm$core$List$singleton),
							A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$groupes, model.GN)));
					switch (commande.$) {
						case 0:
							return _Utils_Tuple2(
								_Utils_update(
									suivant,
									{
										fw: A2(
											$elm$core$Maybe$map,
											function (ajout) {
												return _Utils_update(
													ajout,
													{vd: uidDuSelf, B1: $elm$core$Maybe$Nothing, en: $elm$core$Maybe$Nothing});
											},
											suivant.fw)
									}),
								_Utils_ap(
									effets,
									_Utils_ap(
										relireLesGroupes,
										A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2(
												$elm$core$Maybe$map,
												A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$PartiesPrenantes$Update$LireLeGroupeChoisi, $elm$core$List$singleton),
												A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$self, rendue.nQ))))));
						case 2:
							var _v4 = A2(
								$author$project$Components$Referentiel$PartiesPrenantes$Update$surLeVoletDeCopie,
								$author$project$Components$Shared$Drawer$Update$Fermer,
								_Utils_update(
									suivant,
									{kc: $elm$core$Maybe$Nothing}));
							var ferme = _v4.a;
							var focus = _v4.b;
							return _Utils_Tuple2(
								ferme,
								_Utils_ap(
									effets,
									_Utils_ap(
										focus,
										A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2(
												$elm$core$Maybe$map,
												function (uid) {
													return _List_fromArray(
														[
															$author$project$Components$Referentiel$PartiesPrenantes$Update$AllerA(
															$author$project$Routes$Route$toString(
																A2($author$project$Routes$Route$FicheDeGroupe, uid, $elm$core$Maybe$Nothing)))
														]);
												},
												uidDuSelf)))));
						case 3:
							var groupe = commande.a;
							var nom = A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.Dj;
									},
									A2(
										$elm$core$Maybe$andThen,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.Ac;
											},
											A2(
												$elm$core$Basics$composeR,
												$elm$core$List$filter(
													function (g) {
														return _Utils_eq(g.r8, groupe);
													}),
												$elm$core$List$head)),
										model.iR)));
							var enArrierePlan = !_Utils_eq(
								A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$suiviDuTraitement, rendue.nQ),
								$elm$core$Maybe$Nothing);
							var _v5 = A2(
								$author$project$Components$Referentiel$PartiesPrenantes$Update$surLeVoletDAjout,
								$author$project$Components$Shared$Drawer$Update$Fermer,
								_Utils_update(
									suivant,
									{fw: $elm$core$Maybe$Nothing}));
							var ferme = _v5.a;
							var focus = _v5.b;
							return _Utils_Tuple2(
								_Utils_update(
									ferme,
									{
										iP: enArrierePlan ? $elm$core$Maybe$Just(nom) : $elm$core$Maybe$Nothing,
										aS: $author$project$Components$Shared$Annuaire$Model$deselectionner(ferme.aS),
										jk: enArrierePlan ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
											{
												iI: rendue.iI,
												w1: A2(
													$elm$core$Basics$max,
													0,
													$author$project$Components$Referentiel$PartiesPrenantes$Update$fichesVisees(model) - rendue.iI),
												m2: nom
											})
									}),
								_Utils_ap(
									effets,
									_Utils_ap(focus, relireLesGroupes)));
						default:
							return _Utils_Tuple2(suivant, effets);
					}
				case 1:
					var _v6 = _v0.a;
					var envoi = _v6.a;
					var _v7 = _v6.b;
					var refus = _v7.b;
					var effets = _v6.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l3: envoi,
								p0: $elm$core$Maybe$Just(refus)
							}),
						effets);
				default:
					var _v8 = _v0.a;
					var envoi = _v8.a;
					var _v9 = _v8.b;
					var effets = _v8.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{l3: envoi}),
						effets);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Model$retenirLesChamps = F2(
	function (types, champs) {
		if (types.b && (!types.b.b)) {
			var code = types.a;
			return A2(
				$elm$core$List$filter,
				function (filtre) {
					return _Utils_eq(filtre.r0, code);
				},
				champs);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Model$setFiltre = F3(
	function (filtre, code, page) {
		var pose = $elm$core$String$isEmpty(code) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(code);
		var filtres = page.mG;
		return _Utils_update(
			page,
			{
				mG: function () {
					switch (filtre) {
						case 0:
							return _Utils_update(
								filtres,
								{g1: pose});
						case 1:
							return _Utils_update(
								filtres,
								{hy: pose});
						case 2:
							return _Utils_update(
								filtres,
								{ho: pose});
						case 4:
							return _Utils_update(
								filtres,
								{gt: pose});
						case 5:
							return _Utils_update(
								filtres,
								{m2: pose});
						case 6:
							return _Utils_update(
								filtres,
								{D1: pose});
						default:
							if (pose.$ === 1) {
								return _Utils_update(
									filtres,
									{ib: _List_Nil});
							} else {
								var type_ = pose.a;
								return A2($elm$core$List$member, type_, filtres.ib) ? _Utils_update(
									filtres,
									{
										ib: A2(
											$elm$core$List$filter,
											$elm$core$Basics$neq(type_),
											filtres.ib)
									}) : _Utils_update(
									filtres,
									{
										ib: _Utils_ap(
											filtres.ib,
											_List_fromArray(
												[type_]))
									});
							}
					}
				}(),
				EE: 1
			});
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Model$setTaille = F2(
	function (taille, page) {
		return _Utils_update(
			page,
			{EE: 1, Jm: taille});
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Model$longueurMaxDuTerme = 100;
var $author$project$Components$Referentiel$PartiesPrenantes$Model$setTerme = F2(
	function (saisi, model) {
		return _Utils_update(
			model,
			{
				hP: model.hP + 1,
				h3: A2($elm$core$String$left, $author$project$Components$Referentiel$PartiesPrenantes$Model$longueurMaxDuTerme, saisi)
			});
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$surLeVolet = F2(
	function (voletMsg, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (volet) {
				return _Utils_update(
					model,
					{im: volet});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Referentiel$PartiesPrenantes$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				voletMsg,
				model.im));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$surLeVoletDesColonnes = F2(
	function (voletMsg, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (volet) {
				return _Utils_update(
					model,
					{$9: volet});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Referentiel$PartiesPrenantes$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				voletMsg,
				model.$9));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var page = msg.a;
				var gabarits = msg.b;
				return $author$project$Components$Referentiel$PartiesPrenantes$Update$lire(
					_Utils_update(
						model,
						{
							aS: (!_Utils_eq(page.mG, model.EE.mG)) ? $author$project$Components$Shared$Annuaire$Model$deselectionner(model.aS) : model.aS,
							dw: A2(
								$author$project$Components$Referentiel$PartiesPrenantes$Model$retenirLesChamps,
								page.mG.ib,
								$author$project$Components$Referentiel$PartiesPrenantes$Model$champsDeLAdresse(page.mG.dw)),
							gF: gabarits,
							EE: page
						}));
			case 29:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 30:
				var reponse = msg.a;
				var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$PartiesPrenantes$API$QueryAPIModel$preferencesDecoder, reponse);
				if (!_v1.$) {
					var lues = _v1.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Referentiel$PartiesPrenantes$Update$choisirLesColonnes,
							lues.o6 ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(lues.j1),
							model),
						_List_Nil);
				} else {
					var refus = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{pu: false}),
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Referentiel$PartiesPrenantes$Update$Reconnecter]) : _List_Nil);
				}
			case 31:
				var reponse = msg.a;
				var _v2 = A3($author$project$API$Envoi$conclure, $author$project$Components$Referentiel$PartiesPrenantes$Update$reglageDesPreferences, reponse, model.l2);
				if (!_v2.$) {
					if (!_v2.a.b.$) {
						var _v3 = _v2.a;
						var envoi = _v3.a;
						var _v4 = _v3.b;
						var choix = _v4.a;
						var effets = _v3.c;
						return _Utils_Tuple2(
							A2(
								$author$project$Components$Referentiel$PartiesPrenantes$Update$choisirLesColonnes,
								choix,
								_Utils_update(
									model,
									{l2: envoi})),
							effets);
					} else {
						var _v5 = _v2.a;
						var envoi = _v5.a;
						var effets = _v5.c;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{l2: envoi}),
							effets);
					}
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 1:
				var liens = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{GN: liens}),
					_Utils_ap(
						$elm$core$List$isEmpty(model.ib) ? A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$PartiesPrenantes$Update$LireLesTypes, $elm$core$List$singleton),
								A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$typesDePartiePrenante, liens))) : _List_Nil,
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (lien) {
									return _List_fromArray(
										[
											$author$project$Components$Referentiel$PartiesPrenantes$Update$LireLesGroupes(lien),
											$author$project$Components$Referentiel$PartiesPrenantes$Update$DemanderProcessUidDeGroupe
										]);
								},
								A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$groupes, liens)))));
			case 32:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l3: A2($author$project$API$Envoi$recevoir, octets, model.l3)
						}),
					_List_Nil);
			case 33:
				var etape = msg.a;
				var reponse = msg.b;
				var _v6 = A2($author$project$Components$Referentiel$Common$Equipe$avancer, etape, reponse);
				if (!_v6.$) {
					var membres = _v6.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l5: $author$project$Components$Referentiel$Common$Equipe$Lue(membres)
							}),
						_List_Nil);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 34:
				var _v7 = A2($elm$core$Maybe$andThen, $author$project$Components$Referentiel$PartiesPrenantes$Groupage$lienDAjout, model.iR);
				if (!_v7.$) {
					return A2(
						$author$project$Components$Referentiel$PartiesPrenantes$Update$surLeVoletDAjout,
						$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Referentiel$PartiesPrenantes$Model$idDuDeclencheurDAjout),
						_Utils_update(
							model,
							{
								fw: $elm$core$Maybe$Just($author$project$Components$Referentiel$PartiesPrenantes$Groupage$ajoutVide),
								iP: $elm$core$Maybe$Nothing,
								jk: $elm$core$Maybe$Nothing,
								p0: $elm$core$Maybe$Nothing
							}));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 35:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$PartiesPrenantes$Update$surLeVoletDAjout, geste, model);
			case 36:
				var uid = msg.a;
				var lien = A2(
					$elm$core$Maybe$andThen,
					function (annuaire) {
						return A2(
							$elm$core$Maybe$andThen,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.nQ;
								},
								$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$self)),
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (g) {
										return _Utils_eq(g.r8, uid);
									},
									annuaire.Ac)));
					},
					model.iR);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fw: A2(
								$elm$core$Maybe$map,
								function (ajout) {
									return _Utils_update(
										ajout,
										{
											vd: $elm$core$Maybe$Just(uid),
											B1: $elm$core$Maybe$Nothing
										});
								},
								model.fw)
						}),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$PartiesPrenantes$Update$LireLeGroupeChoisi, $elm$core$List$singleton),
							lien)));
			case 37:
				var reponse = msg.a;
				var _v8 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$ficheDecoder, reponse);
				if (!_v8.$) {
					var fiche = _v8.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								fw: A2(
									$elm$core$Maybe$map,
									function (ajout) {
										return _Utils_eq(
											ajout.vd,
											$elm$core$Maybe$Just(fiche.r8)) ? _Utils_update(
											ajout,
											{
												B1: $elm$core$Maybe$Just(fiche)
											}) : ajout;
									},
									model.fw)
							}),
						_List_Nil);
				} else {
					var refus = _v8.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								p0: $elm$core$Maybe$Just(refus)
							}),
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Referentiel$PartiesPrenantes$Update$Reconnecter]) : _List_Nil);
				}
			case 38:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fw: A2(
								$elm$core$Maybe$map,
								function (ajout) {
									return _Utils_update(
										ajout,
										{
											en: $elm$core$Maybe$Just(''),
											b5: false
										});
								},
								model.fw)
						}),
					_List_Nil);
			case 39:
				var nom = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fw: A2(
								$elm$core$Maybe$map,
								function (ajout) {
									return _Utils_update(
										ajout,
										{
											en: $elm$core$Maybe$Just(nom)
										});
								},
								model.fw)
						}),
					_List_Nil);
			case 40:
				var _v9 = _Utils_Tuple2(model.fw, model.iR);
				if ((!_v9.a.$) && (!_v9.b.$)) {
					var ajout = _v9.a.a;
					var nouveau = ajout.en;
					var annuaire = _v9.b.a;
					var nom = A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $elm$core$String$trim, nouveau));
					return $elm$core$String$isEmpty(nom) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{
								fw: $elm$core$Maybe$Just(
									_Utils_update(
										ajout,
										{b5: true}))
							}),
						_List_Nil) : A3(
						$author$project$Components$Referentiel$PartiesPrenantes$Update$envoyerAuGroupe,
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUnGroupeStatique, annuaire.nQ),
						$author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$CreerStatique(
							$author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$nouveauGroupe(nom)),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 41:
				var _v10 = _Utils_Tuple2(model.fw, model.iR);
				if ((!_v10.a.$) && (!_v10.b.$)) {
					var choisi = _v10.a.a.vd;
					var annuaire = _v10.b.a;
					if (!choisi.$) {
						var groupe = choisi.a;
						return A3(
							$author$project$Components$Referentiel$PartiesPrenantes$Update$envoyerAuGroupe,
							$author$project$Components$Referentiel$PartiesPrenantes$Groupage$lienDAjout(annuaire),
							A3(
								$author$project$Components$Referentiel$Common$API$Groupes$WriteAPIModel$AjouterEnLot,
								groupe,
								A3(
									$author$project$Components$Referentiel$PartiesPrenantes$Groupage$portee,
									$author$project$Components$Referentiel$PartiesPrenantes$Groupage$filtreEntier(model.aS),
									A2(
										$elm$core$List$filterMap,
										$author$project$Components$Referentiel$Identifiants$entiteUidFromString,
										$elm$core$Set$toList(model.aS.vv)),
									A2(
										$author$project$Components$Referentiel$PartiesPrenantes$Groupage$filtreDeLaListe,
										model.EE.mG,
										$author$project$Components$Referentiel$PartiesPrenantes$Model$termeCherche(model))),
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.wv;
										},
										A2(
											$elm$core$Maybe$andThen,
											function ($) {
												return $.B1;
											},
											model.fw)))),
							model);
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 42:
				var reponse = msg.a;
				return A2($author$project$Components$Referentiel$PartiesPrenantes$Update$repondreAUneCommandeDeGroupe, reponse, model);
			case 43:
				var _v12 = A2($elm$core$Maybe$andThen, $author$project$Components$Referentiel$PartiesPrenantes$Groupage$lienDeLaCopie, model.iR);
				if (!_v12.$) {
					return A2(
						$elm$core$Tuple$mapSecond,
						function (effets) {
							return _Utils_ap(
								effets,
								$author$project$Components$Referentiel$PartiesPrenantes$Update$lireLEquipe(model));
						},
						A2(
							$author$project$Components$Referentiel$PartiesPrenantes$Update$surLeVoletDeCopie,
							$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Referentiel$PartiesPrenantes$Model$idDuDeclencheurDeCopie),
							_Utils_update(
								model,
								{
									iP: $elm$core$Maybe$Nothing,
									jk: $elm$core$Maybe$Nothing,
									kc: $elm$core$Maybe$Just($author$project$Components$Referentiel$PartiesPrenantes$Groupage$copieVide),
									p0: $elm$core$Maybe$Nothing
								})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 44:
				var geste = msg.a;
				return A2($author$project$Components$Referentiel$PartiesPrenantes$Update$surLeVoletDeCopie, geste, model);
			case 45:
				var nom = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$PartiesPrenantes$Update$modifierLaCopie,
						function (copie) {
							return _Utils_update(
								copie,
								{Dj: nom});
						},
						model),
					_List_Nil);
			case 46:
				var description = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$PartiesPrenantes$Update$modifierLaCopie,
						function (copie) {
							return _Utils_update(
								copie,
								{dH: description});
						},
						model),
					_List_Nil);
			case 47:
				var responsable = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Referentiel$PartiesPrenantes$Update$modifierLaCopie,
						function (copie) {
							return _Utils_update(
								copie,
								{qB: responsable});
						},
						model),
					_List_Nil);
			case 48:
				return $author$project$Components$Referentiel$PartiesPrenantes$Update$confirmerLaCopie(model);
			case 49:
				return function (_v13) {
					var fermee = _v13.a;
					var effets = _v13.b;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Referentiel$PartiesPrenantes$Update$surLeVolet,
							$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Referentiel$PartiesPrenantes$Model$idDuDeclencheurDeFiltres),
							fermee));
				}(
					A2(
						$elm$core$Tuple$mapSecond,
						function (effets) {
							return effets;
						},
						A2($author$project$Components$Referentiel$PartiesPrenantes$Update$surLeVoletDeCopie, $author$project$Components$Shared$Drawer$Update$Fermer, model)));
			case 4:
				var reponse = msg.a;
				var _v14 = A2(
					$author$project$API$Reponse$lire,
					$elm$json$Json$Decode$list($author$project$Components$Referentiel$Common$API$QueryAPIModel$offreProposeeDecoder),
					reponse);
				if (!_v14.$) {
					var offres = _v14.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								D3: $author$project$Components$Referentiel$Common$Offres$Lue(
									$author$project$Components$Referentiel$Common$Offres$depuis(offres))
							}),
						_List_Nil);
				} else {
					var refus = _v14.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{D3: $author$project$Components$Referentiel$Common$Offres$Illisible}),
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Referentiel$PartiesPrenantes$Update$Reconnecter]) : _List_Nil);
				}
			case 3:
				var reponse = msg.a;
				var _v15 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$API$Groupes$QueryAPIModel$annuaireDecoder, reponse);
				if (!_v15.$) {
					var annuaire = _v15.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iR: $elm$core$Maybe$Just(annuaire),
								Ac: A2(
									$elm$core$List$map,
									function (g) {
										return {
											xW: g.rg === 1,
											Cm: g.n5,
											Dj: g.Dj,
											r8: $author$project$Components$Referentiel$Identifiants$groupeUidToString(g.r8)
										};
									},
									A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.tE;
											},
											$elm$core$Basics$not),
										annuaire.Ac))
							}),
						_List_Nil);
				} else {
					var refus = _v15.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Referentiel$PartiesPrenantes$Update$Reconnecter]) : _List_Nil);
				}
			case 2:
				var reponse = msg.a;
				var _v16 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$Common$API$QueryAPIModel$typesServisDecoder, reponse);
				if (!_v16.$) {
					var types = _v16.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ib: types}),
						_List_Nil);
				} else {
					var refus = _v16.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Referentiel$PartiesPrenantes$Update$Reconnecter]) : _List_Nil);
				}
			case 5:
				var saisi = msg.a;
				var suivant = A2(
					$author$project$Components$Referentiel$PartiesPrenantes$Model$setTerme,
					saisi,
					_Utils_update(
						model,
						{
							aS: $author$project$Components$Shared$Annuaire$Model$deselectionner(model.aS)
						}));
				return ((!suivant.gt) || ((suivant.gt === 1) || _Utils_eq(
					$author$project$Components$Referentiel$PartiesPrenantes$Model$termeCherche(suivant),
					suivant.kC))) ? _Utils_Tuple2(suivant, _List_Nil) : _Utils_Tuple2(
					suivant,
					_List_fromArray(
						[
							A2($author$project$Components$Referentiel$PartiesPrenantes$Update$AttendreAvantDeChercher, suivant.hP, $author$project$Components$Referentiel$PartiesPrenantes$Model$delaiDeSaisieMs)
						]));
			case 6:
				var saisie = msg.a;
				return ((!_Utils_eq(saisie, model.hP)) || _Utils_eq(
					$author$project$Components$Referentiel$PartiesPrenantes$Model$termeCherche(model),
					model.kC)) ? _Utils_Tuple2(model, _List_Nil) : $author$project$Components$Referentiel$PartiesPrenantes$Update$chercher(model);
			case 7:
				var lecture = msg.a;
				var reponse = msg.b;
				if (!_Utils_eq(lecture, model.np)) {
					return _Utils_Tuple2(model, _List_Nil);
				} else {
					var _v17 = A2($author$project$API$Reponse$lire, $author$project$Components$Referentiel$PartiesPrenantes$API$QueryAPIModel$listeDecoder, reponse);
					if (!_v17.$) {
						var vue = _v17.a;
						var _v18 = A2($author$project$Components$Referentiel$PartiesPrenantes$Update$lireLesPreferences, model, vue);
						var demandees = _v18.a;
						var lectures = _v18.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									gt: 3,
									B1: $elm$core$Maybe$Just(vue),
									pu: demandees
								}),
							_Utils_ap(
								lectures,
								A2($author$project$Components$Referentiel$PartiesPrenantes$Update$lireLesOffres, model, vue)));
					} else {
						var refus = _v17.a;
						return (refus.ri === 401) ? _Utils_Tuple2(
							model,
							_List_fromArray(
								[$author$project$Components$Referentiel$PartiesPrenantes$Update$Reconnecter])) : _Utils_Tuple2(
							_Utils_update(
								model,
								{gt: 4, B1: $elm$core$Maybe$Nothing}),
							_List_Nil);
					}
				}
			case 8:
				var page = msg.a;
				return A2($author$project$Components$Referentiel$PartiesPrenantes$Update$allerA, page, model);
			case 9:
				var taille = msg.a;
				return A2($elm$core$List$member, taille, $author$project$Routes$Route$taillesPermises) ? A2(
					$author$project$Components$Referentiel$PartiesPrenantes$Update$allerA,
					A2($author$project$Components$Referentiel$PartiesPrenantes$Model$setTaille, taille, model.EE),
					model) : _Utils_Tuple2(model, _List_Nil);
			case 10:
				var filtre = msg.a;
				var code = msg.b;
				var page = A3($author$project$Components$Referentiel$PartiesPrenantes$Model$setFiltre, filtre, code, model.EE);
				return A3(
					$author$project$Components$Referentiel$PartiesPrenantes$Update$allerAvecLesChamps,
					page,
					A2($author$project$Components$Referentiel$PartiesPrenantes$Model$retenirLesChamps, page.mG.ib, model.dw),
					model);
			case 12:
				var type_ = msg.a;
				var cle = msg.b;
				var valeur = msg.c;
				return A2(
					$author$project$Components$Referentiel$PartiesPrenantes$Update$chercherAvecLesChamps,
					A4($author$project$Components$Referentiel$PartiesPrenantes$Model$poserUnTexte, type_, cle, valeur, model.dw),
					model);
			case 13:
				var type_ = msg.a;
				var cle = msg.b;
				var choix = msg.c;
				return A2(
					$author$project$Components$Referentiel$PartiesPrenantes$Update$chercherAvecLesChamps,
					A4($author$project$Components$Referentiel$PartiesPrenantes$Model$poserUnChoix, type_, cle, choix, model.dw),
					model);
			case 14:
				var cle = msg.a;
				return A2(
					$author$project$Components$Referentiel$PartiesPrenantes$Update$chercherAvecLesChamps,
					A2($author$project$Components$Referentiel$PartiesPrenantes$Model$retirerUnChamp, cle, model.dw),
					model);
			case 20:
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[
							$author$project$Components$Referentiel$PartiesPrenantes$Update$OuvrirLaCreation($author$project$Components$Referentiel$PartiesPrenantes$Model$idDuDeclencheurDeCreation)
						]));
			case 21:
				return A2(
					$author$project$Components$Referentiel$PartiesPrenantes$Update$surLeVolet,
					$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Referentiel$PartiesPrenantes$Model$idDuDeclencheurDeFiltres),
					model);
			case 22:
				var voletMsg = msg.a;
				return A2($author$project$Components$Referentiel$PartiesPrenantes$Update$surLeVolet, voletMsg, model);
			case 23:
				return A2(
					$elm$core$Tuple$mapSecond,
					function (effets) {
						return _Utils_ap(
							effets,
							$author$project$Components$Referentiel$PartiesPrenantes$Update$demanderLeProcessUid(model));
					},
					A2(
						$author$project$Components$Referentiel$PartiesPrenantes$Update$surLeVoletDesColonnes,
						$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Shared$Annuaire$Model$idDuDeclencheurDeColonnes),
						_Utils_update(
							model,
							{
								dA: $author$project$Components$Referentiel$PartiesPrenantes$Update$colonnesMontrees(model)
							})));
			case 24:
				var colonne = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dA: A2($author$project$Components$Referentiel$PartiesPrenantes$Model$basculer, colonne, model.dA)
						}),
					_List_Nil);
			case 25:
				var sens = msg.a;
				var colonne = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dA: A3($author$project$Components$Referentiel$PartiesPrenantes$Model$deplacer, sens, colonne, model.dA)
						}),
					_List_Nil);
			case 26:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dA: $author$project$Components$Referentiel$PartiesPrenantes$Model$colonnesParDefaut}),
					_List_Nil);
			case 27:
				var choix = _Utils_eq(model.dA, $author$project$Components$Referentiel$PartiesPrenantes$Model$colonnesParDefaut) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(model.dA);
				var _v19 = A4(
					$author$project$API$Envoi$partir,
					$author$project$Components$Referentiel$PartiesPrenantes$Update$reglageDesPreferences,
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.l_;
						},
						model.B1),
					choix,
					model.l2);
				if (!_v19.$) {
					var _v20 = _v19.a;
					var envoi = _v20.a;
					var effets = _v20.b;
					var _v21 = A2($author$project$Components$Referentiel$PartiesPrenantes$Update$surLeVoletDesColonnes, $author$project$Components$Shared$Drawer$Update$Fermer, model);
					var ferme = _v21.a;
					var focus = _v21.b;
					return _Utils_Tuple2(
						_Utils_update(
							ferme,
							{l2: envoi}),
						_Utils_ap(focus, effets));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 28:
				var voletMsg = msg.a;
				return A2($author$project$Components$Referentiel$PartiesPrenantes$Update$surLeVoletDesColonnes, voletMsg, model);
			case 11:
				var page = model.EE;
				return A3(
					$author$project$Components$Referentiel$PartiesPrenantes$Update$allerAvecLesChamps,
					_Utils_update(
						page,
						{mG: $author$project$Routes$Route$aucunFiltre, EE: 1}),
					_List_Nil,
					model);
			case 16:
				return model.gY ? $author$project$Components$Referentiel$PartiesPrenantes$Update$fermerLeMenuDuTri(model) : _Utils_Tuple2(
					_Utils_update(
						model,
						{gY: true}),
					_List_fromArray(
						[
							$author$project$Components$Referentiel$PartiesPrenantes$Update$PlacerFocus(
							$author$project$Components$Referentiel$PartiesPrenantes$Model$idDeLOrdre(model.EE.rS))
						]));
			case 17:
				return $author$project$Components$Referentiel$PartiesPrenantes$Update$fermerLeMenuDuTri(model);
			case 18:
				var pas = msg.a;
				var ordres = A2($elm$core$List$map, $author$project$Routes$Route$codeDuTri, $author$project$Components$Referentiel$PartiesPrenantes$Model$ordresProposes);
				var position = A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$first,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (_v22) {
									var c = _v22.b;
									return _Utils_eq(
										c,
										$author$project$Routes$Route$codeDuTri(model.EE.rS));
								},
								A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, ordres)))));
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (code) {
								return _List_fromArray(
									[
										$author$project$Components$Referentiel$PartiesPrenantes$Update$PlacerFocus(
										$author$project$Components$Referentiel$PartiesPrenantes$Model$idDeLOrdre(
											$author$project$Routes$Route$triDuCode(code)))
									]);
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$drop,
									A2(
										$elm$core$Basics$modBy,
										$elm$core$List$length(ordres),
										position + pas),
									ordres)))));
			case 15:
				var code = msg.a;
				var page = model.EE;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (effets) {
						return _Utils_ap(
							effets,
							_List_fromArray(
								[
									$author$project$Components$Referentiel$PartiesPrenantes$Update$PlacerFocus($author$project$Components$Referentiel$PartiesPrenantes$Model$idDuDeclencheurDuTri)
								]));
					},
					A2(
						$author$project$Components$Referentiel$PartiesPrenantes$Update$allerA,
						_Utils_update(
							page,
							{
								EE: 1,
								rS: $author$project$Routes$Route$triDuCode(code)
							}),
						_Utils_update(
							model,
							{gY: false})));
			default:
				var annuaireMsg = msg.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					function (annuaire) {
						return _Utils_update(
							model,
							{aS: annuaire});
					},
					$elm$core$List$map($author$project$Components$Referentiel$PartiesPrenantes$Update$depuisLAnnuaire),
					A2($author$project$Components$Shared$Annuaire$Update$update, annuaireMsg, model.aS));
		}
	});
var $author$project$Main$Update$versLesPartiesPrenantes = F3(
	function (i18n, msg, model) {
		var _v0 = A2(
			$author$project$Components$Referentiel$PartiesPrenantes$Update$update,
			msg,
			A2(
				$author$project$Referentiel$Normes$poser,
				model.hd,
				$author$project$Components$Referentiel$PartiesPrenantes$Model$ouvrir(model.eA)));
		var partiesPrenantes = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$lectureDesFiches, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLesPartiesPrenantes(i18n),
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							A2(
								$author$project$Components$Referentiel$PartiesPrenantes$Update$popMessages,
								$author$project$Components$Referentiel$PartiesPrenantes$Model$ouvrir(model.eA),
								msg),
							gardes),
						eA: $author$project$Components$Referentiel$PartiesPrenantes$Model$envelopper(partiesPrenantes)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$AttendreAvantDeRelireLesPerimetres = function (a) {
	return {$: 209, a: a};
};
var $author$project$Main$Update$EnvoyerAuxPerimetres = function (a) {
	return {$: 208, a: a};
};
var $author$project$Main$Update$LireLesPerimetres = F2(
	function (a, b) {
		return {$: 207, a: a, b: b};
	});
var $author$project$Main$Model$PourLesPerimetres = 39;
var $author$project$Main$Update$depuisLesPerimetres = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[39]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 1:
				var lecture = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLesPerimetres(lecture))));
			case 2:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerAuxPerimetres(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 3:
				var delaiMs = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AttendreAvantDeRelireLesPerimetres(delaiMs)
							])));
			case 4:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			case 5:
				var adresse = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AllerA(adresse)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Produits$Common$API$TypesDeQuantiteQueryAPIModel$Annuaire = F3(
	function (types, total, liens) {
		return {nQ: liens, JE: total, ib: types};
	});
var $author$project$Components$Produits$Common$API$TypesDeQuantiteQueryAPIModel$TypeDeQuantite = function (uid) {
	return function (nom) {
		return function (noms) {
			return function (comportement) {
				return function (bases) {
					return function (periodeParDefaut) {
						return function (archive) {
							return function (utilisePar) {
								return function (basesUtilisees) {
									return function (usages) {
										return function (liens) {
											return {tE: archive, uo: bases, up: basesUtilisees, vV: comportement, nQ: liens, Dj: nom, DG: noms, Fb: periodeParDefaut, r8: uid, Ke: usages, sf: utilisePar};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Produits$Common$API$TypesDeQuantiteQueryAPIModel$Usage = F4(
	function (perimetreUid, nom, regles, liens) {
		return {nQ: liens, Dj: nom, Fa: perimetreUid, hJ: regles};
	});
var $author$project$Components$Produits$Common$API$TypesDeQuantiteQueryAPIModel$usageDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$API$Liens$deLaRessource,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'regles',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'nom',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'perimetreUid',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Produits$Common$API$TypesDeQuantiteQueryAPIModel$Usage)))));
var $author$project$Components$Produits$Common$API$TypesDeQuantiteQueryAPIModel$typeDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$API$Liens$deLaRessource,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'usages',
		$elm$json$Json$Decode$list($author$project$Components$Produits$Common$API$TypesDeQuantiteQueryAPIModel$usageDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'basesUtilisees',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'utilisePar',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'archive',
					$elm$json$Json$Decode$bool,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'periodeParDefaut',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'bases',
							$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'comportement',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'noms',
									$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'nom',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'uid',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Components$Produits$Common$API$TypesDeQuantiteQueryAPIModel$TypeDeQuantite))))))))))));
var $author$project$Components$Produits$Common$API$TypesDeQuantiteQueryAPIModel$annuaireDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$API$Liens$deLaRessource,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'total',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'types',
			$elm$json$Json$Decode$list($author$project$Components$Produits$Common$API$TypesDeQuantiteQueryAPIModel$typeDecoder),
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$Common$API$TypesDeQuantiteQueryAPIModel$Annuaire))));
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$Annuaire = F3(
	function (perimetres, total, liens) {
		return {nQ: liens, pg: perimetres, JE: total};
	});
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$Resume = function (uid) {
	return function (nom) {
		return function (statut) {
			return function (etapeCourante) {
				return function (criteres) {
					return function (criteresLies) {
						return function (inclusions) {
							return function (exclusions) {
								return function (regles) {
									return function (liens) {
										return {wp: criteres, ko: criteresLies, mf: etapeCourante, yX: exclusions, m8: inclusions, nQ: liens, Dj: nom, hJ: regles, ri: statut, r8: uid};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$resumeDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$API$Liens$deLaRessource,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'regles',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'exclusions',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'inclusions',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'criteresLies',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'criteres',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'etapeCourante',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'statut',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'nom',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'uid',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Components$Produits$Perimetres$API$QueryAPIModel$Resume)))))))))));
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$annuaireDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$API$Liens$deLaRessource,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'total',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'perimetres',
			$elm$json$Json$Decode$list($author$project$Components$Produits$Perimetres$API$QueryAPIModel$resumeDecoder),
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$Perimetres$API$QueryAPIModel$Annuaire))));
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$Apercu = F9(
	function (references, echantillon, exemple, exemples, pipes, totalPipes, champs, totalChamps, liens) {
		return {dw: champs, lJ: echantillon, yY: exemple, y_: exemples, nQ: liens, FM: pipes, hD: references, JF: totalChamps, JG: totalPipes};
	});
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$ChampDuPerimetre = F7(
	function (cle, nom, usage, porteur, porteurUid, plusieurs, liens) {
		return {dy: cle, nQ: liens, Dj: nom, FS: plusieurs, c0: porteur, F2: porteurUid, sd: usage};
	});
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$champDuPerimetreDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$API$Liens$deLaRessource,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'plusieurs',
		$elm$json$Json$Decode$bool,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'porteurUid',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'porteur',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'usage',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'nom',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'cle',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Components$Produits$Perimetres$API$QueryAPIModel$ChampDuPerimetre))))))));
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$Exemple = F5(
	function (uid, nom, references, echantillon, exclues) {
		return {lJ: echantillon, mn: exclues, Dj: nom, hD: references, r8: uid};
	});
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$ligneDEchantillon = A3(
	$elm$json$Json$Decode$map2,
	$elm$core$Tuple$pair,
	A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'designation', $elm$json$Json$Decode$string));
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$exempleDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Components$Produits$Perimetres$API$QueryAPIModel$Exemple,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['fiche', 'uid']),
		$elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['fiche', 'nom']),
		$elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'references', $elm$json$Json$Decode$int),
	A2(
		$elm$json$Json$Decode$field,
		'echantillon',
		$elm$json$Json$Decode$list($author$project$Components$Produits$Perimetres$API$QueryAPIModel$ligneDEchantillon)),
	A2(
		$elm$json$Json$Decode$field,
		'exclues',
		$elm$json$Json$Decode$list(
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						$elm$json$Json$Decode$string,
						A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string)
					])))));
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$PipeDuPerimetre = F4(
	function (nom, usage, code, liens) {
		return {vx: code, nQ: liens, Dj: nom, sd: usage};
	});
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$pipeDuPerimetreDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$API$Liens$deLaRessource,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'code',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'usage',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'nom',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Produits$Perimetres$API$QueryAPIModel$PipeDuPerimetre)))));
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$apercuDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$API$Liens$deLaRessource,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'totalChamps',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'champs',
			$elm$json$Json$Decode$list($author$project$Components$Produits$Perimetres$API$QueryAPIModel$champDuPerimetreDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'totalPipes',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'pipes',
					$elm$json$Json$Decode$list($author$project$Components$Produits$Perimetres$API$QueryAPIModel$pipeDuPerimetreDecoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'exemplesParFiche',
						$elm$json$Json$Decode$list($author$project$Components$Produits$Perimetres$API$QueryAPIModel$exempleDecoder),
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'exemple',
							$elm$json$Json$Decode$nullable($author$project$Components$Produits$Perimetres$API$QueryAPIModel$exempleDecoder),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'echantillon',
								$elm$json$Json$Decode$list($author$project$Components$Produits$Perimetres$API$QueryAPIModel$ligneDEchantillon),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
									_List_fromArray(
										['decompte', 'references']),
									$elm$json$Json$Decode$int,
									$elm$json$Json$Decode$succeed($author$project$Components$Produits$Perimetres$API$QueryAPIModel$Apercu))))))))));
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$ClientsProposes = F2(
	function (clients, plusDeResultats) {
		return {vn: clients, pp: plusDeResultats};
	});
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$clientsProposesDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Produits$Perimetres$API$QueryAPIModel$ClientsProposes,
	A2(
		$elm$json$Json$Decode$field,
		'fiches',
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string)))),
	A2($elm$json$Json$Decode$field, 'plusDeResultats', $elm$json$Json$Decode$bool));
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$ApercuDException = F2(
	function (avant, apres) {
		return {iY: apres, je: avant};
	});
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$apercuDExceptionDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Produits$Perimetres$API$QueryAPIModel$ApercuDException,
	A2($elm$json$Json$Decode$field, 'avant', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'apres', $elm$json$Json$Decode$int));
var $author$project$Components$Produits$Perimetres$Update$deLApercuDException = function (reponse) {
	var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Perimetres$API$QueryAPIModel$apercuDExceptionDecoder, reponse);
	if (_v0.$ === 1) {
		var refus = _v0.a;
		return ((refus.ri === 401) || (refus.ri === 422)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Components$Shared$Messages$Model$duRefus(refus));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$ApercuDeRegle = F2(
	function (phrase, remplace) {
		return {Fp: phrase, Hz: remplace};
	});
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$SegmentDePhrase = F2(
	function (texte, fort) {
		return {dX: fort, Jx: texte};
	});
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$phraseDecoder = $elm$json$Json$Decode$list(
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$Components$Produits$Perimetres$API$QueryAPIModel$SegmentDePhrase,
		A2($elm$json$Json$Decode$field, 'texte', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'fort', $elm$json$Json$Decode$bool)));
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$apercuDeRegleDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Produits$Perimetres$API$QueryAPIModel$ApercuDeRegle,
	A2($elm$json$Json$Decode$field, 'phrase', $author$project$Components$Produits$Perimetres$API$QueryAPIModel$phraseDecoder),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'remplace', $author$project$Components$Produits$Perimetres$API$QueryAPIModel$phraseDecoder)));
var $author$project$Components$Produits$Perimetres$Update$deLApercuDeRegle = function (reponse) {
	var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Perimetres$API$QueryAPIModel$apercuDeRegleDecoder, reponse);
	if (_v0.$ === 1) {
		var refus = _v0.a;
		return ((refus.ri === 401) || (refus.ri === 422)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Components$Shared$Messages$Model$duRefus(refus));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$Perimetres$Update$deLaLecture = function (resultat) {
	if (resultat.$ === 1) {
		var refus = resultat.a;
		return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Components$Shared$Messages$Model$duRefus(refus));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$decompteDesCriteresDecoder = A2($elm$json$Json$Decode$field, 'references', $elm$json$Json$Decode$int);
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$Exceptions = F2(
	function (motifs, liens) {
		return {nQ: liens, CY: motifs};
	});
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$codeEtLibelle = A3(
	$elm$json$Json$Decode$map2,
	$elm$core$Tuple$pair,
	A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string));
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$exceptionsDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$API$Liens$deLaRessource,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'motifsDisponibles',
		$elm$json$Json$Decode$list($author$project$Components$Produits$Perimetres$API$QueryAPIModel$codeEtLibelle),
		$elm$json$Json$Decode$succeed($author$project$Components$Produits$Perimetres$API$QueryAPIModel$Exceptions)));
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$Fiche = function (uid) {
	return function (nom) {
		return function (noms) {
			return function (description) {
				return function (statut) {
					return function (etapeCourante) {
						return function (etapes) {
							return function (references) {
								return function (criteres) {
									return function (criteresLies) {
										return function (inclusions) {
											return function (exclusions) {
												return function (regles) {
													return function (archive) {
														return function (archiveLe) {
															return function (archivePar) {
																return function (archiveParRetire) {
																	return function (liens) {
																		return {tE: archive, tF: archiveLe, tG: archivePar, tH: archiveParRetire, wp: criteres, ko: criteresLies, dH: description, mf: etapeCourante, yL: etapes, yX: exclusions, m8: inclusions, nQ: liens, Dj: nom, DG: noms, hD: references, hJ: regles, ri: statut, r8: uid};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$Critere = F2(
	function (cle, valeurs) {
		return {dy: cle, Ki: valeurs};
	});
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$critereDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'valeurs',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'cle',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Components$Produits$Perimetres$API$QueryAPIModel$Critere)));
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$CritereLie = F8(
	function (uid, attribut, nature, champ, comparaison, correspondanceUid, phrase, liens) {
		return {tV: attribut, uN: champ, vP: comparaison, ke: correspondanceUid, nQ: liens, g1: nature, Fp: phrase, r8: uid};
	});
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$critereLieDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$API$Liens$deLaRessource,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'phrase',
		$author$project$Components$Produits$Perimetres$API$QueryAPIModel$phraseDecoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'correspondanceUid',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'comparaison',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'champ',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'nature',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'attribut',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'uid',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Components$Produits$Perimetres$API$QueryAPIModel$CritereLie)))))))));
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$Etape = F5(
	function (numero, cle, libelle, etat, obligatoire) {
		return {dy: cle, gt: etat, Bl: libelle, DX: numero, he: obligatoire};
	});
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$etapeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'obligatoire',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'etat',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'libelle',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'cle',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'numero',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$Components$Produits$Perimetres$API$QueryAPIModel$Etape))))));
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$Exclusion = F6(
	function (referenceUid, code, designation, motif, libelleMotif, liens) {
		return {vx: code, xt: designation, Bp: libelleMotif, nQ: liens, cX: motif, pX: referenceUid};
	});
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$exclusionDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$API$Liens$deLaRessource,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'libelleMotif',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'motif',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'designation',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'code',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'referenceUid',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Components$Produits$Perimetres$API$QueryAPIModel$Exclusion)))))));
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$Inclusion = F5(
	function (referenceUid, code, designation, motif, liens) {
		return {vx: code, xt: designation, nQ: liens, cX: motif, pX: referenceUid};
	});
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$inclusionDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$API$Liens$deLaRessource,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'motif',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'designation',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'code',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'referenceUid',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Produits$Perimetres$API$QueryAPIModel$Inclusion))))));
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$Regle = function (uid) {
	return function (typeUid) {
		return function (libelle) {
			return function (comportement) {
				return function (archive) {
					return function (valeur) {
						return function (portee) {
							return function (base) {
								return function (periode) {
									return function (libelleBase) {
										return function (liens) {
											return {tE: archive, jo: base, vV: comportement, Bl: libelle, Bm: libelleBase, nQ: liens, pi: periode, F$: portee, JX: typeUid, r8: uid, fm: valeur};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$regleDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$API$Liens$deLaRessource,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'libelleBase',
		$elm$json$Json$Decode$string,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'periode',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'base',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'portee',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'valeur',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'archive',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'comportement',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'libelle',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'typeUid',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'uid',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Components$Produits$Perimetres$API$QueryAPIModel$Regle))))))))))));
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$ficheDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$API$Liens$deLaRessource,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'archiveParRetire',
		$elm$json$Json$Decode$bool,
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'archivePar',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'archiveLe',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'archive',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'regles',
						$elm$json$Json$Decode$list($author$project$Components$Produits$Perimetres$API$QueryAPIModel$regleDecoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'exclusions',
							$elm$json$Json$Decode$list($author$project$Components$Produits$Perimetres$API$QueryAPIModel$exclusionDecoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'inclusions',
								$elm$json$Json$Decode$list($author$project$Components$Produits$Perimetres$API$QueryAPIModel$inclusionDecoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'criteresLies',
									$elm$json$Json$Decode$list($author$project$Components$Produits$Perimetres$API$QueryAPIModel$critereLieDecoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'criteres',
										$elm$json$Json$Decode$list($author$project$Components$Produits$Perimetres$API$QueryAPIModel$critereDecoder),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
											_List_fromArray(
												['decompte', 'references']),
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'etapes',
												$elm$json$Json$Decode$list($author$project$Components$Produits$Perimetres$API$QueryAPIModel$etapeDecoder),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'etapeCourante',
													$elm$json$Json$Decode$int,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'statut',
														$elm$json$Json$Decode$string,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'description',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
															$elm$core$Maybe$Nothing,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'noms',
																$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'nom',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'uid',
																		$elm$json$Json$Decode$string,
																		$elm$json$Json$Decode$succeed($author$project$Components$Produits$Perimetres$API$QueryAPIModel$Fiche)))))))))))))))))));
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$Dimension = F4(
	function (cle, libelle, valeurs, references) {
		return {dy: cle, Bl: libelle, hD: references, Ki: valeurs};
	});
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$OptionsCatalogue = function (dimensions) {
	return {xz: dimensions};
};
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$nombreDeReferences = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (code, nombre) {
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$pair(code),
				nombre);
		}),
	A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'references', $elm$json$Json$Decode$int)));
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$optionsCatalogueDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Components$Produits$Perimetres$API$QueryAPIModel$OptionsCatalogue,
	A2(
		$elm$json$Json$Decode$field,
		'dimensions',
		$elm$json$Json$Decode$list(
			A5(
				$elm$json$Json$Decode$map4,
				$author$project$Components$Produits$Perimetres$API$QueryAPIModel$Dimension,
				A2($elm$json$Json$Decode$field, 'cle', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string),
				A2(
					$elm$json$Json$Decode$field,
					'valeurs',
					$elm$json$Json$Decode$list($author$project$Components$Produits$Perimetres$API$QueryAPIModel$codeEtLibelle)),
				A2(
					$elm$json$Json$Decode$field,
					'valeurs',
					A2(
						$elm$json$Json$Decode$map,
						$elm$core$List$filterMap($elm$core$Basics$identity),
						$elm$json$Json$Decode$list($author$project$Components$Produits$Perimetres$API$QueryAPIModel$nombreDeReferences)))))));
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$Combinaison = F6(
	function (attribut, nature, champ, comparaison, correspondanceUid, phrase) {
		return {tV: attribut, uN: champ, vP: comparaison, ke: correspondanceUid, g1: nature, Fp: phrase};
	});
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$OptionsFiche = F5(
	function (natures, attributs, champs, correspondances, combinaisons) {
		return {i8: attributs, dw: champs, vH: combinaisons, wh: correspondances, oo: natures};
	});
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$optionsFicheDecoder = function () {
	var uidEtLibelle = A3(
		$elm$json$Json$Decode$map2,
		$elm$core$Tuple$pair,
		A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string));
	var combinaison = A7(
		$elm$json$Json$Decode$map6,
		$author$project$Components$Produits$Perimetres$API$QueryAPIModel$Combinaison,
		A2($elm$json$Json$Decode$field, 'attribut', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'nature', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'comparaison', $elm$json$Json$Decode$string),
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'correspondanceUid', $elm$json$Json$Decode$string)),
		A2($elm$json$Json$Decode$field, 'phrase', $author$project$Components$Produits$Perimetres$API$QueryAPIModel$phraseDecoder));
	var cleEtLibelle = A3(
		$elm$json$Json$Decode$map2,
		$elm$core$Tuple$pair,
		A2($elm$json$Json$Decode$field, 'cle', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'libelle', $elm$json$Json$Decode$string));
	return A6(
		$elm$json$Json$Decode$map5,
		$author$project$Components$Produits$Perimetres$API$QueryAPIModel$OptionsFiche,
		A2(
			$elm$json$Json$Decode$field,
			'natures',
			$elm$json$Json$Decode$list($author$project$Components$Produits$Perimetres$API$QueryAPIModel$codeEtLibelle)),
		A2(
			$elm$json$Json$Decode$field,
			'attributsDeLaReference',
			$elm$json$Json$Decode$list(cleEtLibelle)),
		A2(
			$elm$json$Json$Decode$field,
			'champsDeLaFiche',
			$elm$json$Json$Decode$list(cleEtLibelle)),
		A2(
			$elm$json$Json$Decode$field,
			'correspondances',
			$elm$json$Json$Decode$list(uidEtLibelle)),
		A2(
			$elm$json$Json$Decode$field,
			'combinaisonsPermises',
			$elm$json$Json$Decode$list(combinaison)));
}();
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$ReferenceProposee = F3(
	function (uid, code, designation) {
		return {vx: code, xt: designation, r8: uid};
	});
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$ReferencesProposees = F2(
	function (references, plusDeResultats) {
		return {pp: plusDeResultats, hD: references};
	});
var $author$project$Components$Produits$Perimetres$API$QueryAPIModel$referencesProposeesDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Produits$Perimetres$API$QueryAPIModel$ReferencesProposees,
	A2(
		$elm$json$Json$Decode$field,
		'references',
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				$author$project$Components$Produits$Perimetres$API$QueryAPIModel$ReferenceProposee,
				A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'designation', $elm$json$Json$Decode$string)))),
	A2($elm$json$Json$Decode$field, 'plusDeResultats', $elm$json$Json$Decode$bool));
var $author$project$Components$Produits$Perimetres$Update$popMessages = function (msg) {
	switch (msg.$) {
		case 2:
			switch (msg.a) {
				case 0:
					var _v1 = msg.a;
					var reponse = msg.b;
					return $author$project$Components$Produits$Perimetres$Update$deLaLecture(
						A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Perimetres$API$QueryAPIModel$annuaireDecoder, reponse));
				case 1:
					var _v2 = msg.a;
					var reponse = msg.b;
					return $author$project$Components$Produits$Perimetres$Update$deLaLecture(
						A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Perimetres$API$QueryAPIModel$ficheDecoder, reponse));
				case 2:
					var _v3 = msg.a;
					var reponse = msg.b;
					return $author$project$Components$Produits$Perimetres$Update$deLaLecture(
						A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Perimetres$API$QueryAPIModel$apercuDecoder, reponse));
				case 3:
					var _v4 = msg.a;
					var reponse = msg.b;
					return $author$project$Components$Produits$Perimetres$Update$deLaLecture(
						A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Perimetres$API$QueryAPIModel$optionsCatalogueDecoder, reponse));
				case 4:
					var _v5 = msg.a;
					var reponse = msg.b;
					return $author$project$Components$Produits$Perimetres$Update$deLaLecture(
						A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Perimetres$API$QueryAPIModel$optionsFicheDecoder, reponse));
				case 5:
					var _v6 = msg.a;
					var reponse = msg.b;
					return $author$project$Components$Produits$Perimetres$Update$deLaLecture(
						A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Perimetres$API$QueryAPIModel$exceptionsDecoder, reponse));
				case 6:
					var _v7 = msg.a;
					var reponse = msg.b;
					return $author$project$Components$Produits$Perimetres$Update$deLaLecture(
						A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Perimetres$API$QueryAPIModel$referencesProposeesDecoder, reponse));
				case 8:
					var _v8 = msg.a;
					var reponse = msg.b;
					return $author$project$Components$Produits$Perimetres$Update$deLaLecture(
						A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Perimetres$API$QueryAPIModel$clientsProposesDecoder, reponse));
				case 9:
					var _v9 = msg.a;
					var reponse = msg.b;
					return $author$project$Components$Produits$Perimetres$Update$deLApercuDeRegle(reponse);
				case 10:
					var _v10 = msg.a;
					var reponse = msg.b;
					return $author$project$Components$Produits$Perimetres$Update$deLApercuDException(reponse);
				case 11:
					var _v11 = msg.a;
					var reponse = msg.b;
					return $author$project$Components$Produits$Perimetres$Update$deLaLecture(
						A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Perimetres$API$QueryAPIModel$decompteDesCriteresDecoder, reponse));
				default:
					var _v12 = msg.a;
					var reponse = msg.b;
					return $author$project$Components$Produits$Perimetres$Update$deLaLecture(
						A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$API$TypesDeQuantiteQueryAPIModel$annuaireDecoder, reponse));
			}
		case 1:
			var octets = msg.a;
			return _Utils_eq(
				$author$project$API$ProcessUid$depuisOctets(octets),
				$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
				{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Main$Update$requeteSurLesPerimetres = function (effet) {
	switch (effet.$) {
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Produits$Perimetres$Update$DeLAnnuaire = 0;
var $author$project$Components$Produits$Perimetres$Update$DeLApercu = 2;
var $author$project$Components$Produits$Perimetres$Update$DemanderProcessUid = {$: 0};
var $author$project$Components$Produits$Perimetres$Update$DesClients = 8;
var $author$project$Components$Produits$Perimetres$Update$DesReferences = 6;
var $author$project$Components$Produits$Perimetres$Update$DesTypes = 7;
var $author$project$Components$Produits$Perimetres$Update$Lire = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Produits$Perimetres$Model$Restauration = {$: 12};
var $author$project$Components$Produits$Perimetres$Update$DeLApercuDException = 10;
var $author$project$API$NavLinksDictionary$apercuDException = 'apercu-d-exception';
var $author$project$Components$Produits$Perimetres$Model$avecParametres = F2(
	function (parametres, lien) {
		return _Utils_update(
			lien,
			{
				cM: _Utils_ap(
					lien.cM,
					$elm$url$Url$Builder$toQuery(parametres))
			});
	});
var $author$project$Components$Produits$Perimetres$Model$lienDeLApercuDException = function (model) {
	var vers = F3(
		function (geste, reference, motif) {
			return A2(
				$elm$core$Maybe$map,
				$author$project$Components$Produits$Perimetres$Model$avecParametres(
					_Utils_ap(
						_List_fromArray(
							[
								A2($elm$url$Url$Builder$string, 'geste', geste),
								A2($elm$url$Url$Builder$string, 'referenceUid', reference)
							]),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (m) {
									return _List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'motif', m)
										]);
								},
								motif)))),
				A2(
					$elm$core$Maybe$andThen,
					function (exceptions) {
						return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$apercuDException, exceptions.nQ.h0);
					},
					model.cI));
		});
	var _v0 = _Utils_Tuple2(model.mW, model.Hc);
	_v0$4:
	while (true) {
		if (!_v0.a.$) {
			switch (_v0.a.a.$) {
				case 5:
					if (!_v0.b.$) {
						var _v1 = _v0.a.a;
						var reference = _v0.b.a;
						return A3(
							vers,
							'inclure',
							reference,
							($elm$core$String$trim(model.cX) === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
								$elm$core$String$trim(model.cX)));
					} else {
						break _v0$4;
					}
				case 6:
					if (!_v0.b.$) {
						var _v2 = _v0.a.a;
						var reference = _v0.b.a;
						return A2(
							$elm$core$Maybe$andThen,
							function (m) {
								return A3(
									vers,
									'exclure',
									reference,
									$elm$core$Maybe$Just(m));
							},
							A2(
								$elm$core$Maybe$andThen,
								function (m) {
									return (m === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(m);
								},
								model.ek));
					} else {
						break _v0$4;
					}
				case 9:
					var reference = _v0.a.a.a;
					return A3(vers, 'retirer', reference, $elm$core$Maybe$Nothing);
				case 8:
					var reference = _v0.a.a.a;
					return A3(vers, 'retirer', reference, $elm$core$Maybe$Nothing);
				default:
					break _v0$4;
			}
		} else {
			break _v0$4;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Components$Produits$Perimetres$Update$avecLApercuDException = function (model) {
	var _v0 = $author$project$Components$Produits$Perimetres$Model$lienDeLApercuDException(model);
	if (!_v0.$) {
		var lien = _v0.a;
		return _Utils_Tuple2(
			model,
			_List_fromArray(
				[
					A2($author$project$Components$Produits$Perimetres$Update$Lire, 10, lien)
				]));
	} else {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{iT: $elm$core$Maybe$Nothing}),
			_List_Nil);
	}
};
var $author$project$Components$Produits$Perimetres$Update$DeLApercuDeRegle = 9;
var $author$project$API$NavLinksDictionary$apercuDeRegle = 'apercu-de-regle';
var $elm$url$Url$Builder$int = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$core$String$fromInt(value));
	});
var $author$project$Components$Produits$Perimetres$Model$lienDeLApercuDeRegle = function (model) {
	var _v0 = _Utils_Tuple2(
		model.dc,
		$elm$core$String$toInt(
			$elm$core$String$trim(model.fm)));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var typeUid = _v0.a.a;
		var valeur = _v0.b.a;
		return (model.jo === '') ? $elm$core$Maybe$Nothing : A2(
			$elm$core$Maybe$map,
			$author$project$Components$Produits$Perimetres$Model$avecParametres(
				_Utils_ap(
					_List_fromArray(
						[
							A2($elm$url$Url$Builder$string, 'typeUid', typeUid),
							A2($elm$url$Url$Builder$int, 'valeur', valeur),
							A2($elm$url$Url$Builder$string, 'portee', model.F$),
							A2($elm$url$Url$Builder$string, 'base', model.jo)
						]),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (periode) {
								return _List_fromArray(
									[
										A2($elm$url$Url$Builder$string, 'periode', periode)
									]);
							},
							model.pi)))),
			A2(
				$elm$core$Maybe$andThen,
				function (exceptions) {
					return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$apercuDeRegle, exceptions.nQ.h0);
				},
				model.cI));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$Perimetres$Update$avecLApercuDeRegle = function (model) {
	var _v0 = $author$project$Components$Produits$Perimetres$Model$lienDeLApercuDeRegle(model);
	if (!_v0.$) {
		var lien = _v0.a;
		return _Utils_Tuple2(
			model,
			_List_fromArray(
				[
					A2($author$project$Components$Produits$Perimetres$Update$Lire, 9, lien)
				]));
	} else {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{fy: $elm$core$Maybe$Nothing}),
			_List_Nil);
	}
};
var $author$project$Components$Produits$Perimetres$Update$DuDecompteDesCriteres = 11;
var $author$project$API$NavLinksDictionary$decompteDesCriteres = 'decompte-criteres';
var $author$project$Components$Produits$Perimetres$Model$valeursChoisies = F2(
	function (cle, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Dict$get, cle, model.jL));
	});
var $author$project$Components$Produits$Perimetres$Model$lienDuDecompte = function (model) {
	var saisie = A2(
		$elm$core$String$join,
		';',
		A2(
			$elm$core$List$map,
			function (_v1) {
				var cle = _v1.a;
				var valeurs = _v1.b;
				return cle + ('=' + A2($elm$core$String$join, ',', valeurs));
			},
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var valeurs = _v0.b;
					return !_Utils_eq(valeurs, _List_Nil);
				},
				A2(
					$elm$core$List$map,
					function (cle) {
						return _Utils_Tuple2(
							cle,
							A2($author$project$Components$Produits$Perimetres$Model$valeursChoisies, cle, model));
					},
					model.dj))));
	return (saisie === '') ? $elm$core$Maybe$Nothing : A2(
		$elm$core$Maybe$andThen,
		$author$project$API$Liens$resoudre(
			_List_fromArray(
				[
					_Utils_Tuple2('criteres', saisie)
				])),
		A2(
			$elm$core$Maybe$andThen,
			function (fiche) {
				return A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$decompteDesCriteres, fiche.nQ.gF);
			},
			model.zo));
};
var $author$project$Components$Produits$Perimetres$Update$avecLeDecompte = function (model) {
	var _v0 = $author$project$Components$Produits$Perimetres$Model$lienDuDecompte(model);
	if (!_v0.$) {
		var lien = _v0.a;
		return _Utils_Tuple2(
			model,
			_List_fromArray(
				[
					A2($author$project$Components$Produits$Perimetres$Update$Lire, 11, lien)
				]));
	} else {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{kx: $elm$core$Maybe$Nothing}),
			_List_Nil);
	}
};
var $author$project$Components$Produits$Perimetres$Update$choisirDansLeCritere = F3(
	function (rubrique, valeur, choix) {
		switch (rubrique) {
			case 0:
				return _Utils_update(
					choix,
					{tV: valeur});
			case 1:
				return _Utils_update(
					choix,
					{g1: valeur});
			case 2:
				return _Utils_update(
					choix,
					{uN: valeur});
			default:
				return _Utils_update(
					choix,
					{wg: valeur});
		}
	});
var $author$project$Components$Produits$Common$API$TypesDeQuantiteQueryAPIModel$proposes = function (annuaire) {
	return A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.tE;
			},
			$elm$core$Basics$not),
		annuaire.ib);
};
var $author$project$Components$Produits$Perimetres$Model$typesProposes = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2($elm$core$Maybe$map, $author$project$Components$Produits$Common$API$TypesDeQuantiteQueryAPIModel$proposes, model.ib));
};
var $author$project$Components$Produits$Perimetres$Model$typeDeLaRegle = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		function (uid) {
			return $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (t) {
						return _Utils_eq(t.r8, uid);
					},
					$author$project$Components$Produits$Perimetres$Model$typesProposes(model)));
		},
		model.dc);
};
var $author$project$Components$Produits$Perimetres$Update$choisirLaBase = F2(
	function (base, model) {
		return _Utils_update(
			model,
			{
				jo: base,
				pi: function () {
					if (base === 'par-periode') {
						var _v0 = model.pi;
						if (!_v0.$) {
							var periode = _v0.a;
							return $elm$core$Maybe$Just(periode);
						} else {
							return A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.Fb;
								},
								$author$project$Components$Produits$Perimetres$Model$typeDeLaRegle(model));
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}(),
				hq: false,
				pZ: $elm$core$Maybe$Nothing
			});
	});
var $author$project$Components$Produits$Perimetres$Update$choisirLeType = F2(
	function (uid, model) {
		var choisi = _Utils_update(
			model,
			{
				hq: false,
				pZ: $elm$core$Maybe$Nothing,
				b5: false,
				dc: $elm$core$Maybe$Just(uid)
			});
		var bases = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.uo;
				},
				$author$project$Components$Produits$Perimetres$Model$typeDeLaRegle(choisi)));
		if (bases.b && (!bases.b.b)) {
			var seule = bases.a;
			return A2(
				$author$project$Components$Produits$Perimetres$Update$choisirLaBase,
				seule,
				_Utils_update(
					choisi,
					{pi: $elm$core$Maybe$Nothing}));
		} else {
			return A2($elm$core$List$member, model.jo, bases) ? A2(
				$author$project$Components$Produits$Perimetres$Update$choisirLaBase,
				model.jo,
				_Utils_update(
					choisi,
					{pi: $elm$core$Maybe$Nothing})) : _Utils_update(
				choisi,
				{jo: '', pi: $elm$core$Maybe$Nothing});
		}
	});
var $author$project$Components$Produits$Perimetres$Update$AttendreAvantDeRelire = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$Perimetres$Update$Naviguer = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Produits$Perimetres$API$WriteAPIErrorsModel$PeriodeManquante = 7;
var $author$project$Components$Produits$Perimetres$Model$aucunGeste = function (model) {
	return _Utils_update(
		model,
		{mW: $elm$core$Maybe$Nothing, hq: false, pZ: $elm$core$Maybe$Nothing, b5: false});
};
var $author$project$I18n$Textes$perimetresRefusAutre = A3($author$project$I18n$Traductions$texte, 'perimetres.refus.autre', _List_Nil, 'Le périmètre n\'a pas pu être enregistré.');
var $author$project$I18n$Textes$perimetresRefusBaseNonPermise = A3($author$project$I18n$Traductions$texte, 'perimetres.refus.base.non.permise', _List_Nil, 'Cette base n\'est pas permise : « Multiple de » ne s\'entend que par commande.');
var $author$project$I18n$Textes$perimetresRefusCombinaison = A3($author$project$I18n$Traductions$texte, 'perimetres.refus.combinaison', _List_Nil, 'Cette combinaison n\'est pas permise.');
var $author$project$I18n$Textes$perimetresRefusCritereDejaPresent = A3($author$project$I18n$Traductions$texte, 'perimetres.refus.critere.deja.present', _List_Nil, 'Ce critère lié à la fiche est déjà posé.');
var $author$project$I18n$Textes$perimetresRefusCritereInconnu = A3($author$project$I18n$Traductions$texte, 'perimetres.refus.critere.inconnu', _List_Nil, 'Un critère ou une de ses valeurs n\'existe plus dans le catalogue.');
var $author$project$I18n$Textes$perimetresRefusCritereSansValeur = A3($author$project$I18n$Traductions$texte, 'perimetres.refus.critere.sans.valeur', _List_Nil, 'Un critère doit garder au moins une valeur.');
var $author$project$I18n$Textes$perimetresRefusNomDejaUtilise = A3($author$project$I18n$Traductions$texte, 'perimetres.refus.nom.deja.utilise', _List_Nil, 'Un périmètre porte déjà ce nom.');
var $author$project$I18n$Textes$perimetresRefusNomVide = A3($author$project$I18n$Traductions$texte, 'perimetres.refus.nom.vide', _List_Nil, 'Le nom du périmètre est obligatoire.');
var $author$project$I18n$Textes$perimetresRefusPeriodeManquante = A3($author$project$I18n$Traductions$texte, 'perimetres.refus.periode.manquante', _List_Nil, 'Choisissez la période.');
var $author$project$I18n$Textes$perimetresRefusReferenceDejaExclue = A3($author$project$I18n$Traductions$texte, 'perimetres.refus.reference.deja.exclue', _List_Nil, 'Cette référence est exclue : retirez d\'abord son exclusion.');
var $author$project$I18n$Textes$perimetresRefusReferenceDejaIncluse = A3($author$project$I18n$Traductions$texte, 'perimetres.refus.reference.deja.incluse', _List_Nil, 'Cette référence est déjà incluse.');
var $author$project$I18n$Textes$perimetresRefusRegleDejaPresente = A3($author$project$I18n$Traductions$texte, 'perimetres.refus.regle.deja.presente', _List_Nil, 'Cette règle existe déjà.');
var $author$project$I18n$Textes$perimetresRefusTypeArchive = A3($author$project$I18n$Traductions$texte, 'perimetres.refus.type.archive', _List_Nil, 'Ce type est archivé : choisissez-en un autre.');
var $author$project$I18n$Textes$perimetresRefusTypeInconnu = A3($author$project$I18n$Traductions$texte, 'perimetres.refus.type.inconnu', _List_Nil, 'Ce type de règle n\'existe pas ou plus dans cet espace.');
var $author$project$I18n$Textes$perimetresRefusValeurInvalide = A3($author$project$I18n$Traductions$texte, 'perimetres.refus.valeur.invalide', _List_Nil, 'Le nombre de pièces doit être un entier positif.');
var $author$project$Components$Produits$Perimetres$Update$libelleDuRefus = function (erreur) {
	switch (erreur) {
		case 0:
			return $author$project$I18n$Textes$perimetresRefusNomVide;
		case 1:
			return $author$project$I18n$Textes$perimetresRefusNomDejaUtilise;
		case 2:
			return $author$project$I18n$Textes$perimetresRefusCritereSansValeur;
		case 3:
			return $author$project$I18n$Textes$perimetresRefusCritereInconnu;
		case 4:
			return $author$project$I18n$Textes$perimetresRefusCritereDejaPresent;
		case 5:
			return $author$project$I18n$Textes$perimetresRefusCombinaison;
		case 6:
			return $author$project$I18n$Textes$perimetresRefusBaseNonPermise;
		case 7:
			return $author$project$I18n$Textes$perimetresRefusPeriodeManquante;
		case 8:
			return $author$project$I18n$Textes$perimetresRefusTypeInconnu;
		case 9:
			return $author$project$I18n$Textes$perimetresRefusTypeArchive;
		case 10:
			return $author$project$I18n$Textes$perimetresRefusValeurInvalide;
		case 11:
			return $author$project$I18n$Textes$perimetresRefusRegleDejaPresente;
		case 12:
			return $author$project$I18n$Textes$perimetresRefusReferenceDejaExclue;
		case 13:
			return $author$project$I18n$Textes$perimetresRefusReferenceDejaIncluse;
		default:
			return $author$project$I18n$Textes$perimetresRefusAutre;
	}
};
var $author$project$Components$Produits$Perimetres$Update$relire = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$Produits$Perimetres$Update$Lire(0),
				$elm$core$List$singleton),
			model.np));
};
var $author$project$Components$Produits$Perimetres$Update$PlacerFocus = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Produits$Perimetres$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{kX: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Produits$Perimetres$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: (model.Dj !== '') || ((!_Utils_eq(model.dj, _List_Nil)) || ((!_Utils_eq(model.fP, $author$project$Components$Produits$Perimetres$Model$choixVide)) || ((!_Utils_eq(model.Hc, $elm$core$Maybe$Nothing)) || (model.fm !== ''))))
				},
				geste,
				model.kX));
	});
var $author$project$Components$Produits$Perimetres$Update$conclure = F2(
	function (issue, model) {
		switch (issue.$) {
			case 0:
				if (!issue.a.$) {
					var creee = issue.b.wm;
					if (!creee.$) {
						var uid = creee.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(
								_List_fromArray(
									[
										$author$project$Components$Produits$Perimetres$Update$Naviguer(
										$author$project$Routes$Route$adresseDuPerimetre(uid))
									])),
							A2(
								$author$project$Components$Produits$Perimetres$Update$versLeDrawer,
								$author$project$Components$Shared$Drawer$Update$Fermer,
								$author$project$Components$Produits$Perimetres$Model$aucunGeste(model)));
					} else {
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(
								$author$project$Components$Produits$Perimetres$Update$relire(model)),
							A2(
								$author$project$Components$Produits$Perimetres$Update$versLeDrawer,
								$author$project$Components$Shared$Drawer$Update$Fermer,
								$author$project$Components$Produits$Perimetres$Model$aucunGeste(model)));
					}
				} else {
					var rendue = issue.b;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(
							rendue.sy ? $author$project$Components$Produits$Perimetres$Update$relire(model) : _List_fromArray(
								[
									$author$project$Components$Produits$Perimetres$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
								])),
						A2(
							$author$project$Components$Produits$Perimetres$Update$versLeDrawer,
							$author$project$Components$Shared$Drawer$Update$Fermer,
							$author$project$Components$Produits$Perimetres$Model$aucunGeste(model)));
				}
			case 1:
				var erreur = issue.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hq: erreur === 7,
							pZ: $elm$core$Maybe$Just(
								$author$project$Components$Produits$Perimetres$Update$libelleDuRefus(erreur))
						}),
					_List_Nil);
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$Perimetres$API$WriteAPIModel$AjouterUnCritereLie = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Produits$Perimetres$API$WriteAPIModel$AjouterUneRegle = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Produits$Perimetres$API$WriteAPIModel$Archiver = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Produits$Perimetres$API$WriteAPIModel$Creer = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$Perimetres$API$WriteAPIModel$DefinirLesCriteres = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Produits$Perimetres$API$WriteAPIModel$ExclureUneReference = F3(
	function (a, b, c) {
		return {$: 7, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$Perimetres$API$WriteAPIModel$InclureUneReference = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$Perimetres$API$WriteAPIModel$Renommer = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Produits$Perimetres$API$WriteAPIModel$Restaurer = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Produits$Perimetres$API$WriteAPIModel$RetirerUnCritereLie = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Produits$Perimetres$API$WriteAPIModel$RetirerUneExclusion = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$Produits$Perimetres$API$WriteAPIModel$RetirerUneInclusion = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Produits$Perimetres$API$WriteAPIModel$RetirerUneRegle = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$Produits$Perimetres$Model$combinaisonChoisie = function (model) {
	var choix = model.fP;
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (c) {
				return _Utils_eq(c.tV, choix.tV) && (_Utils_eq(c.g1, choix.g1) && (_Utils_eq(c.uN, choix.uN) && _Utils_eq(
					A2($elm$core$Maybe$withDefault, '', c.ke),
					choix.wg)));
			},
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.vH;
					},
					model.hh))));
};
var $author$project$API$NavLinksDictionary$ajouterUnCritereLieALaFiche = 'ajouter-un-critere-lie-a-la-fiche';
var $author$project$API$NavLinksDictionary$ajouterUneRegleDeQuantite = 'ajouter-une-regle-de-quantite';
var $author$project$API$NavLinksDictionary$apercuDuPerimetre = 'apercu';
var $author$project$API$NavLinksDictionary$archiverUnPerimetre = 'archiver-un-perimetre';
var $author$project$API$NavLinksDictionary$creerUnPerimetre = 'creer-un-perimetre';
var $author$project$API$NavLinksDictionary$definirLesCriteresDuCatalogue = 'definir-les-criteres-du-catalogue';
var $author$project$API$NavLinksDictionary$exclureUneReference = 'exclure-une-reference';
var $author$project$API$NavLinksDictionary$inclureUneReference = 'inclure-une-reference';
var $author$project$API$NavLinksDictionary$restaurerUnPerimetre = 'restaurer-un-perimetre';
var $author$project$Components$Produits$Perimetres$Model$lienDe = F2(
	function (rel, model) {
		var _v0 = _Utils_Tuple2(model.zo, model.aS);
		if (!_v0.a.$) {
			var fiche = _v0.a.a;
			return (fiche.tE && (!_Utils_eq(rel, $author$project$API$NavLinksDictionary$restaurerUnPerimetre))) ? $elm$core$Maybe$Nothing : A2($author$project$API$Liens$trouver, rel, fiche.nQ.h0);
		} else {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var annuaire = _v0.b.a;
				return A2($author$project$API$Liens$trouver, rel, annuaire.nQ.h0);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$API$NavLinksDictionary$renommerUnPerimetre = 'renommer-un-perimetre';
var $author$project$API$NavLinksDictionary$retirerUnCritereLieALaFiche = 'retirer-un-critere-lie-a-la-fiche';
var $author$project$API$NavLinksDictionary$retirerUneExclusion = 'retirer-une-exclusion';
var $author$project$API$NavLinksDictionary$retirerUneInclusion = 'retirer-une-inclusion';
var $author$project$API$NavLinksDictionary$retirerUneRegleDeQuantite = 'retirer-une-regle-de-quantite';
var $author$project$Components$Produits$Perimetres$Model$lienDuGeste = F2(
	function (geste, model) {
		var deLaLigne = F2(
			function (rel, liens) {
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.tE;
						},
						model.zo)) ? $elm$core$Maybe$Nothing : A2($author$project$API$Liens$trouver, rel, liens);
			});
		var _v0 = _Utils_Tuple2(geste, model.zo);
		_v0$14:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					var _v1 = _v0.a;
					return A2($author$project$Components$Produits$Perimetres$Model$lienDe, $author$project$API$NavLinksDictionary$creerUnPerimetre, model);
				case 1:
					var _v2 = _v0.a;
					return A2($author$project$Components$Produits$Perimetres$Model$lienDe, $author$project$API$NavLinksDictionary$renommerUnPerimetre, model);
				case 2:
					var _v3 = _v0.a;
					return A2($author$project$Components$Produits$Perimetres$Model$lienDe, $author$project$API$NavLinksDictionary$definirLesCriteresDuCatalogue, model);
				case 3:
					var _v4 = _v0.a;
					return A2($author$project$Components$Produits$Perimetres$Model$lienDe, $author$project$API$NavLinksDictionary$ajouterUnCritereLieALaFiche, model);
				case 5:
					var _v5 = _v0.a;
					return A2($author$project$Components$Produits$Perimetres$Model$lienDe, $author$project$API$NavLinksDictionary$inclureUneReference, model);
				case 6:
					var _v6 = _v0.a;
					return A2($author$project$Components$Produits$Perimetres$Model$lienDe, $author$project$API$NavLinksDictionary$exclureUneReference, model);
				case 7:
					var _v7 = _v0.a;
					return A2($author$project$Components$Produits$Perimetres$Model$lienDe, $author$project$API$NavLinksDictionary$ajouterUneRegleDeQuantite, model);
				case 11:
					var _v8 = _v0.a;
					return A2($author$project$Components$Produits$Perimetres$Model$lienDe, $author$project$API$NavLinksDictionary$archiverUnPerimetre, model);
				case 12:
					var _v9 = _v0.a;
					return A2($author$project$Components$Produits$Perimetres$Model$lienDe, $author$project$API$NavLinksDictionary$restaurerUnPerimetre, model);
				case 13:
					if (!_v0.b.$) {
						var _v10 = _v0.a;
						var fiche = _v0.b.a;
						return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$apercuDuPerimetre, fiche.nQ.h0);
					} else {
						break _v0$14;
					}
				case 4:
					if (!_v0.b.$) {
						var uid = _v0.a.a;
						var fiche = _v0.b.a;
						return A2(
							$elm$core$Maybe$andThen,
							function (ligne) {
								return A2(deLaLigne, $author$project$API$NavLinksDictionary$retirerUnCritereLieALaFiche, ligne.nQ.h0);
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (ligne) {
										return _Utils_eq(ligne.r8, uid);
									},
									fiche.ko)));
					} else {
						break _v0$14;
					}
				case 8:
					if (!_v0.b.$) {
						var uid = _v0.a.a;
						var fiche = _v0.b.a;
						return A2(
							$elm$core$Maybe$andThen,
							function (ligne) {
								return A2(deLaLigne, $author$project$API$NavLinksDictionary$retirerUneInclusion, ligne.nQ.h0);
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (ligne) {
										return _Utils_eq(ligne.pX, uid);
									},
									fiche.m8)));
					} else {
						break _v0$14;
					}
				case 9:
					if (!_v0.b.$) {
						var uid = _v0.a.a;
						var fiche = _v0.b.a;
						return A2(
							$elm$core$Maybe$andThen,
							function (ligne) {
								return A2(deLaLigne, $author$project$API$NavLinksDictionary$retirerUneExclusion, ligne.nQ.h0);
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (ligne) {
										return _Utils_eq(ligne.pX, uid);
									},
									fiche.yX)));
					} else {
						break _v0$14;
					}
				default:
					if (!_v0.b.$) {
						var uid = _v0.a.a;
						var fiche = _v0.b.a;
						return A2(
							$elm$core$Maybe$andThen,
							function (ligne) {
								return A2(deLaLigne, $author$project$API$NavLinksDictionary$retirerUneRegleDeQuantite, ligne.nQ.h0);
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (ligne) {
										return _Utils_eq(ligne.r8, uid);
									},
									fiche.hJ)));
					} else {
						break _v0$14;
					}
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Components$Produits$Perimetres$Model$commande = function (model) {
	var saisie = function () {
		var _v0 = _Utils_Tuple2(model.mW, model.zo);
		_v0$13:
		while (true) {
			if (!_v0.a.$) {
				switch (_v0.a.a.$) {
					case 0:
						var _v1 = _v0.a.a;
						return ($elm$core$String$trim(model.Dj) === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							$author$project$Components$Produits$Perimetres$API$WriteAPIModel$Creer(
								$elm$core$String$trim(model.Dj)));
					case 1:
						if (!_v0.b.$) {
							var _v2 = _v0.a.a;
							var fiche = _v0.b.a;
							return ($elm$core$String$trim(
								A2($author$project$Components$Shared$LibellesParLangue$Model$lire, 'fr', model.R)) === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
								A2($author$project$Components$Produits$Perimetres$API$WriteAPIModel$Renommer, fiche.r8, model.R));
						} else {
							break _v0$13;
						}
					case 2:
						if (!_v0.b.$) {
							var _v3 = _v0.a.a;
							var fiche = _v0.b.a;
							return $elm$core$Maybe$Just(
								A2(
									$author$project$Components$Produits$Perimetres$API$WriteAPIModel$DefinirLesCriteres,
									fiche.r8,
									A2(
										$elm$core$List$filter,
										function (_v4) {
											var valeurs = _v4.b;
											return !_Utils_eq(valeurs, _List_Nil);
										},
										A2(
											$elm$core$List$map,
											function (cle) {
												return _Utils_Tuple2(
													cle,
													A2($author$project$Components$Produits$Perimetres$Model$valeursChoisies, cle, model));
											},
											model.dj))));
						} else {
							break _v0$13;
						}
					case 3:
						if (!_v0.b.$) {
							var _v5 = _v0.a.a;
							var fiche = _v0.b.a;
							return A2(
								$elm$core$Maybe$map,
								function (c) {
									return A2(
										$author$project$Components$Produits$Perimetres$API$WriteAPIModel$AjouterUnCritereLie,
										fiche.r8,
										{tV: c.tV, uN: c.uN, vP: c.vP, ke: c.ke, g1: c.g1});
								},
								$author$project$Components$Produits$Perimetres$Model$combinaisonChoisie(model));
						} else {
							break _v0$13;
						}
					case 5:
						if (!_v0.b.$) {
							var _v6 = _v0.a.a;
							var fiche = _v0.b.a;
							return A2(
								$elm$core$Maybe$map,
								function (reference) {
									return A3(
										$author$project$Components$Produits$Perimetres$API$WriteAPIModel$InclureUneReference,
										fiche.r8,
										reference,
										$elm$core$Maybe$Just(model.cX));
								},
								model.Hc);
						} else {
							break _v0$13;
						}
					case 6:
						if (!_v0.b.$) {
							var _v7 = _v0.a.a;
							var fiche = _v0.b.a;
							return A3(
								$elm$core$Maybe$map2,
								$author$project$Components$Produits$Perimetres$API$WriteAPIModel$ExclureUneReference(fiche.r8),
								model.Hc,
								model.ek);
						} else {
							break _v0$13;
						}
					case 7:
						if (!_v0.b.$) {
							var _v8 = _v0.a.a;
							var fiche = _v0.b.a;
							return A2(
								$elm$core$Maybe$andThen,
								function (faite) {
									return (model.jo === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(faite);
								},
								A3(
									$elm$core$Maybe$map2,
									F2(
										function (typeUid, valeur) {
											return A2(
												$author$project$Components$Produits$Perimetres$API$WriteAPIModel$AjouterUneRegle,
												fiche.r8,
												{
													jo: model.jo,
													pi: model.pi,
													F$: model.F$,
													ql: !_Utils_eq(
														$elm$core$Maybe$Nothing,
														A2(
															$elm$core$Maybe$andThen,
															function ($) {
																return $.Hz;
															},
															model.fy)),
													JX: typeUid,
													fm: valeur
												});
										}),
									model.dc,
									$elm$core$String$toInt(
										$elm$core$String$trim(model.fm))));
						} else {
							break _v0$13;
						}
					case 4:
						if (!_v0.b.$) {
							var uid = _v0.a.a.a;
							var fiche = _v0.b.a;
							return $elm$core$Maybe$Just(
								A2($author$project$Components$Produits$Perimetres$API$WriteAPIModel$RetirerUnCritereLie, fiche.r8, uid));
						} else {
							break _v0$13;
						}
					case 8:
						if (!_v0.b.$) {
							var uid = _v0.a.a.a;
							var fiche = _v0.b.a;
							return $elm$core$Maybe$Just(
								A2($author$project$Components$Produits$Perimetres$API$WriteAPIModel$RetirerUneInclusion, fiche.r8, uid));
						} else {
							break _v0$13;
						}
					case 9:
						if (!_v0.b.$) {
							var uid = _v0.a.a.a;
							var fiche = _v0.b.a;
							return $elm$core$Maybe$Just(
								A2($author$project$Components$Produits$Perimetres$API$WriteAPIModel$RetirerUneExclusion, fiche.r8, uid));
						} else {
							break _v0$13;
						}
					case 10:
						if (!_v0.b.$) {
							var uid = _v0.a.a.a;
							var fiche = _v0.b.a;
							return $elm$core$Maybe$Just(
								A2($author$project$Components$Produits$Perimetres$API$WriteAPIModel$RetirerUneRegle, fiche.r8, uid));
						} else {
							break _v0$13;
						}
					case 11:
						if (!_v0.b.$) {
							var _v9 = _v0.a.a;
							var fiche = _v0.b.a;
							return $elm$core$Maybe$Just(
								$author$project$Components$Produits$Perimetres$API$WriteAPIModel$Archiver(fiche.r8));
						} else {
							break _v0$13;
						}
					case 12:
						if (!_v0.b.$) {
							var _v10 = _v0.a.a;
							var fiche = _v0.b.a;
							return $elm$core$Maybe$Just(
								$author$project$Components$Produits$Perimetres$API$WriteAPIModel$Restaurer(fiche.r8));
						} else {
							break _v0$13;
						}
					default:
						break _v0$13;
				}
			} else {
				break _v0$13;
			}
		}
		return $elm$core$Maybe$Nothing;
	}();
	return A3(
		$elm$core$Maybe$map2,
		$elm$core$Tuple$pair,
		saisie,
		A2(
			$elm$core$Maybe$andThen,
			function (geste) {
				return A2($author$project$Components$Produits$Perimetres$Model$lienDuGeste, geste, model);
			},
			model.mW));
};
var $author$project$Components$Produits$Perimetres$API$WriteAPIErrorsModel$Autre = 14;
var $author$project$Components$Produits$Perimetres$Update$Envoyer = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$Perimetres$Update$Reconnecter = {$: 6};
var $author$project$Components$Produits$Perimetres$API$WriteAPIErrorsModel$BaseNonPermise = 6;
var $author$project$Components$Produits$Perimetres$API$WriteAPIErrorsModel$CombinaisonRefusee = 5;
var $author$project$Components$Produits$Perimetres$API$WriteAPIErrorsModel$CritereDejaPresent = 4;
var $author$project$Components$Produits$Perimetres$API$WriteAPIErrorsModel$CritereInconnu = 3;
var $author$project$Components$Produits$Perimetres$API$WriteAPIErrorsModel$CritereSansValeur = 2;
var $author$project$Components$Produits$Perimetres$API$WriteAPIErrorsModel$NomDejaUtilise = 1;
var $author$project$Components$Produits$Perimetres$API$WriteAPIErrorsModel$NomVide = 0;
var $author$project$Components$Produits$Perimetres$API$WriteAPIErrorsModel$ReferenceDejaExclue = 12;
var $author$project$Components$Produits$Perimetres$API$WriteAPIErrorsModel$ReferenceDejaIncluse = 13;
var $author$project$Components$Produits$Perimetres$API$WriteAPIErrorsModel$RegleDejaPresente = 11;
var $author$project$Components$Produits$Perimetres$API$WriteAPIErrorsModel$TypeArchive = 9;
var $author$project$Components$Produits$Perimetres$API$WriteAPIErrorsModel$TypeInconnu = 8;
var $author$project$Components$Produits$Perimetres$API$WriteAPIErrorsModel$ValeurInvalide = 10;
var $author$project$Components$Produits$Perimetres$API$WriteAPIErrorsModel$nomDuCas = function (detail) {
	switch (detail.$) {
		case 1:
			var nom = detail.a;
			return $elm$core$Maybe$Just(nom);
		case 4:
			var nom = detail.a;
			return $elm$core$Maybe$Just(nom);
		case 3:
			var nom = detail.a;
			return $elm$core$Maybe$Just(nom);
		case 2:
			var nom = detail.a;
			return $elm$core$Maybe$Just(nom);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$Perimetres$API$WriteAPIErrorsModel$duRefus = function (refus) {
	var _v0 = $author$project$Components$Produits$Perimetres$API$WriteAPIErrorsModel$nomDuCas(refus.bB);
	_v0$15:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'NomDePerimetreVide':
					return 0;
				case 'NomDePerimetreDejaUtilise':
					return 1;
				case 'CritereSansValeur':
					return 2;
				case 'CritereInconnu':
					return 3;
				case 'ValeurDeCritereInconnue':
					return 3;
				case 'CritereLieAFicheDejaPresent':
					return 4;
				case 'CombinaisonDeCritereRefusee':
					return 5;
				case 'BaseNonPermise':
					return 6;
				case 'PeriodeManquante':
					return 7;
				case 'TypeDeQuantiteInconnu':
					return 8;
				case 'TypeDeQuantiteArchive':
					return 9;
				case 'ValeurDeQuantiteInvalide':
					return 10;
				case 'RegleDeQuantiteDejaPresente':
					return 11;
				case 'ReferenceDejaExclue':
					return 12;
				case 'ReferenceDejaIncluse':
					return 13;
				default:
					break _v0$15;
			}
		} else {
			break _v0$15;
		}
	}
	return 14;
};
var $author$project$Components$Produits$Perimetres$API$WriteAPIModel$Rendue = F3(
	function (vuesAJour, creee, liens) {
		return {wm: creee, nQ: liens, sy: vuesAJour};
	});
var $author$project$Components$Produits$Perimetres$API$WriteAPIModel$rendueDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'liens',
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$decoder),
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$elm$json$Json$Decode$maybe(
			A2(
				$elm$json$Json$Decode$field,
				'evenements',
				A2(
					$elm$json$Json$Decode$index,
					0,
					A2($elm$json$Json$Decode$field, 'aggregateUid', $elm$json$Json$Decode$string)))),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'vuesAJour',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$Perimetres$API$WriteAPIModel$Rendue))));
var $author$project$Components$Produits$Perimetres$Update$reglage = {
	f8: $author$project$Components$Produits$Perimetres$Update$DemanderProcessUid,
	l4: $author$project$Components$Produits$Perimetres$Update$Envoyer,
	go: function (reponse) {
		var _v0 = A2(
			$author$project$API$Reponse$lire,
			$elm$json$Json$Decode$succeed(0),
			reponse);
		if (_v0.$ === 1) {
			var refus = _v0.a;
			return $author$project$Components$Produits$Perimetres$API$WriteAPIErrorsModel$duRefus(refus);
		} else {
			return 14;
		}
	},
	pW: $author$project$Components$Produits$Perimetres$Update$Reconnecter,
	qu: F2(
		function (_v1, _v2) {
			return true;
		}),
	qv: $author$project$Components$Produits$Perimetres$API$WriteAPIModel$rendueDecoder
};
var $author$project$Components$Produits$Perimetres$Update$envoyer = function (model) {
	var _v0 = $author$project$Components$Produits$Perimetres$Model$commande(model);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var commande = _v1.a;
		var lien = _v1.b;
		var _v2 = A4(
			$author$project$API$Envoi$partir,
			$author$project$Components$Produits$Perimetres$Update$reglage,
			$elm$core$Maybe$Just(lien),
			commande,
			model.l2);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var envoi = _v3.a;
			var effets = _v3.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi, pZ: $elm$core$Maybe$Nothing}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{b5: true}),
			_List_Nil);
	}
};
var $author$project$Components$Produits$Perimetres$Model$lienDeLApercu = F2(
	function (client, model) {
		return A2(
			$elm$core$Maybe$map,
			$author$project$Components$Produits$Perimetres$Model$avecParametres(
				_List_fromArray(
					[
						A2($elm$url$Url$Builder$string, 'fiche', client)
					])),
			A2(
				$elm$core$Maybe$andThen,
				function (fiche) {
					return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$apercuDuPerimetre, fiche.nQ.h0);
				},
				model.zo));
	});
var $author$project$API$NavLinksDictionary$fichesDExemple = 'fiches-d-exemple';
var $author$project$Components$Produits$Perimetres$Model$lienDesClients = F2(
	function (texte, model) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2('recherche', texte)
					])),
			A2(
				$elm$core$Maybe$andThen,
				function (apercu) {
					return A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$fichesDExemple, apercu.nQ.gF);
				},
				model.tq));
	});
var $author$project$Components$Produits$Perimetres$Model$AjoutDInclusion = {$: 5};
var $author$project$API$NavLinksDictionary$referencesAExclure = 'references-a-exclure';
var $author$project$API$NavLinksDictionary$referencesAInclure = 'references-a-inclure';
var $author$project$Components$Produits$Perimetres$Model$lienDesReferences = F3(
	function (geste, texte, model) {
		var rel = _Utils_eq(geste, $author$project$Components$Produits$Perimetres$Model$AjoutDInclusion) ? $author$project$API$NavLinksDictionary$referencesAInclure : $author$project$API$NavLinksDictionary$referencesAExclure;
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$API$Liens$resoudre(
				_List_fromArray(
					[
						_Utils_Tuple2('recherche', texte)
					])),
			A2(
				$elm$core$Maybe$andThen,
				function (exceptions) {
					return A2($author$project$API$Liens$trouverGabarit, rel, exceptions.nQ.gF);
				},
				model.cI));
	});
var $author$project$Components$Produits$Perimetres$Update$DesExceptions = 5;
var $author$project$Components$Produits$Perimetres$Update$DesOptionsDeLaFiche = 4;
var $author$project$Components$Produits$Perimetres$Update$DesOptionsDuCatalogue = 3;
var $author$project$API$NavLinksDictionary$exceptionsDuPerimetre = 'exceptions';
var $author$project$Components$Produits$Perimetres$Update$DeLaFiche = 1;
var $author$project$API$NavLinksDictionary$perimetre = 'perimetre';
var $author$project$Components$Produits$Perimetres$Update$lireLaFiche = F2(
	function (annuaire, model) {
		var _v0 = model.vf;
		if (_v0.$ === 1) {
			return _List_Nil;
		} else {
			var id = _v0.a;
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (lien) {
						return _List_fromArray(
							[
								A2($author$project$Components$Produits$Perimetres$Update$Lire, 1, lien)
							]);
					},
					A2(
						$elm$core$Maybe$andThen,
						function (resume) {
							return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$perimetre, resume.nQ.h0);
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (resume) {
									return _Utils_eq(resume.r8, id);
								},
								annuaire.pg)))));
		}
	});
var $author$project$API$NavLinksDictionary$optionsDesCriteresDeLaFiche = 'options-criteres-fiche';
var $author$project$API$NavLinksDictionary$optionsDesCriteresDuCatalogue = 'options-criteres-catalogue';
var $author$project$Components$Produits$Perimetres$Update$lue = F3(
	function (lecture, reponse, model) {
		var sansLecture = function (refus) {
			return _Utils_Tuple2(
				model,
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Produits$Perimetres$Update$Reconnecter]) : _List_Nil);
		};
		switch (lecture) {
			case 0:
				var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Perimetres$API$QueryAPIModel$annuaireDecoder, reponse);
				if (!_v1.$) {
					var annuaire = _v1.a;
					var effets = A2($author$project$Components$Produits$Perimetres$Update$lireLaFiche, annuaire, model);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aS: $elm$core$Maybe$Just(annuaire),
								nf: (!_Utils_eq(model.vf, $elm$core$Maybe$Nothing)) && _Utils_eq(effets, _List_Nil)
							}),
						effets);
				} else {
					var refus = _v1.a;
					return sansLecture(refus);
				}
			case 1:
				var _v2 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Perimetres$API$QueryAPIModel$ficheDecoder, reponse);
				if (!_v2.$) {
					var fiche = _v2.a;
					var lien = F2(
						function (rel, lecture_) {
							return A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (l) {
										return _List_fromArray(
											[
												A2($author$project$Components$Produits$Perimetres$Update$Lire, lecture_, l)
											]);
									},
									A2($author$project$API$Liens$trouver, rel, fiche.nQ.h0)));
						});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								zo: $elm$core$Maybe$Just(fiche)
							}),
						_Utils_ap(
							A2(lien, $author$project$API$NavLinksDictionary$apercuDuPerimetre, 2),
							_Utils_ap(
								A2(lien, $author$project$API$NavLinksDictionary$exceptionsDuPerimetre, 5),
								_Utils_ap(
									A2(lien, $author$project$API$NavLinksDictionary$optionsDesCriteresDuCatalogue, 3),
									A2(lien, $author$project$API$NavLinksDictionary$optionsDesCriteresDeLaFiche, 4)))));
				} else {
					var refus = _v2.a;
					return sansLecture(refus);
				}
			case 2:
				var _v3 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Perimetres$API$QueryAPIModel$apercuDecoder, reponse);
				if (!_v3.$) {
					var apercu = _v3.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								tq: $elm$core$Maybe$Just(apercu)
							}),
						_List_Nil);
				} else {
					var refus = _v3.a;
					return sansLecture(refus);
				}
			case 3:
				var _v4 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Perimetres$API$QueryAPIModel$optionsCatalogueDecoder, reponse);
				if (!_v4.$) {
					var options = _v4.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								et: $elm$core$Maybe$Just(options)
							}),
						_List_Nil);
				} else {
					var refus = _v4.a;
					return sansLecture(refus);
				}
			case 4:
				var _v5 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Perimetres$API$QueryAPIModel$optionsFicheDecoder, reponse);
				if (!_v5.$) {
					var options = _v5.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								hh: $elm$core$Maybe$Just(options)
							}),
						_List_Nil);
				} else {
					var refus = _v5.a;
					return sansLecture(refus);
				}
			case 5:
				var _v6 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Perimetres$API$QueryAPIModel$exceptionsDecoder, reponse);
				if (!_v6.$) {
					var exceptions = _v6.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cI: $elm$core$Maybe$Just(exceptions)
							}),
						_List_Nil);
				} else {
					var refus = _v6.a;
					return sansLecture(refus);
				}
			case 6:
				var _v7 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Perimetres$API$QueryAPIModel$referencesProposeesDecoder, reponse);
				if (!_v7.$) {
					var propositions = _v7.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								Gw: $elm$core$Maybe$Just(propositions)
							}),
						_List_Nil);
				} else {
					var refus = _v7.a;
					return sansLecture(refus);
				}
			case 8:
				var _v8 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Perimetres$API$QueryAPIModel$clientsProposesDecoder, reponse);
				if (!_v8.$) {
					var clients = _v8.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								vn: $elm$core$Maybe$Just(clients)
							}),
						_List_Nil);
				} else {
					var refus = _v8.a;
					return sansLecture(refus);
				}
			case 9:
				var _v9 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Perimetres$API$QueryAPIModel$apercuDeRegleDecoder, reponse);
				if (!_v9.$) {
					var apercu = _v9.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								fy: $elm$core$Maybe$Just(apercu),
								hq: false,
								pZ: $elm$core$Maybe$Nothing
							}),
						_List_Nil);
				} else {
					var refus = _v9.a;
					if (refus.ri === 422) {
						var erreur = $author$project$Components$Produits$Perimetres$API$WriteAPIErrorsModel$duRefus(refus);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									fy: $elm$core$Maybe$Nothing,
									hq: erreur === 7,
									pZ: $elm$core$Maybe$Just(
										$author$project$Components$Produits$Perimetres$Update$libelleDuRefus(erreur))
								}),
							_List_Nil);
					} else {
						return sansLecture(refus);
					}
				}
			case 11:
				var _v10 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Perimetres$API$QueryAPIModel$decompteDesCriteresDecoder, reponse);
				if (!_v10.$) {
					var nombre = _v10.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								kx: $elm$core$Maybe$Just(nombre)
							}),
						_List_Nil);
				} else {
					var refus = _v10.a;
					return sansLecture(refus);
				}
			case 10:
				var _v11 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Perimetres$API$QueryAPIModel$apercuDExceptionDecoder, reponse);
				if (!_v11.$) {
					var apercu = _v11.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iT: $elm$core$Maybe$Just(apercu),
								pZ: $elm$core$Maybe$Nothing
							}),
						_List_Nil);
				} else {
					var refus = _v11.a;
					return (refus.ri === 422) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iT: $elm$core$Maybe$Nothing,
								pZ: $elm$core$Maybe$Just(
									$author$project$Components$Produits$Perimetres$Update$libelleDuRefus(
										$author$project$Components$Produits$Perimetres$API$WriteAPIErrorsModel$duRefus(refus)))
							}),
						_List_Nil) : sansLecture(refus);
				}
			default:
				var _v12 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$API$TypesDeQuantiteQueryAPIModel$annuaireDecoder, reponse);
				if (!_v12.$) {
					var types = _v12.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ib: $elm$core$Maybe$Just(types)
							}),
						_List_Nil);
				} else {
					var refus = _v12.a;
					return sansLecture(refus);
				}
		}
	});
var $author$project$Components$Produits$Perimetres$Model$AjoutDExclusion = {$: 6};
var $author$project$Components$Produits$Perimetres$Model$AjoutDeRegle = {$: 7};
var $author$project$Components$Produits$Perimetres$Model$Criteres = {$: 2};
var $author$project$Components$Produits$Perimetres$Model$criteresRegroupes = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.wp;
				},
				$elm$core$List$map(
					function (critere) {
						return _Utils_Tuple2(critere.dy, critere.Ki);
					})),
			model.zo));
};
var $author$project$Components$Produits$Perimetres$Model$idDuDeclencheur = function (geste) {
	switch (geste.$) {
		case 0:
			return 'perimetres-creer';
		case 1:
			return 'perimetres-renommer';
		case 2:
			return 'perimetres-criteres';
		case 3:
			return 'perimetres-critere-lie';
		case 4:
			var uid = geste.a;
			return 'perimetres-retirer-' + uid;
		case 5:
			return 'perimetres-inclure';
		case 6:
			return 'perimetres-exclure';
		case 7:
			return 'perimetres-regle';
		case 8:
			var uid = geste.a;
			return 'perimetres-retirer-inclusion-' + uid;
		case 9:
			var uid = geste.a;
			return 'perimetres-retirer-exclusion-' + uid;
		case 10:
			var uid = geste.a;
			return 'perimetres-retirer-regle-' + uid;
		case 11:
			return 'perimetres-archiver';
		case 12:
			return 'perimetres-restaurer';
		default:
			return 'perimetres-apercu';
	}
};
var $author$project$Components$Produits$Perimetres$Update$ouvrir = F2(
	function (geste, model) {
		var propositions = (_Utils_eq(geste, $author$project$Components$Produits$Perimetres$Model$AjoutDInclusion) || _Utils_eq(geste, $author$project$Components$Produits$Perimetres$Model$AjoutDExclusion)) ? A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (lien) {
					return _List_fromArray(
						[
							A2($author$project$Components$Produits$Perimetres$Update$Lire, 6, lien)
						]);
				},
				A3($author$project$Components$Produits$Perimetres$Model$lienDesReferences, geste, '', model))) : (_Utils_eq(geste, $author$project$Components$Produits$Perimetres$Model$AjoutDeRegle) ? A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (lien) {
					return _List_fromArray(
						[
							A2($author$project$Components$Produits$Perimetres$Update$Lire, 7, lien)
						]);
				},
				model.nK)) : _List_Nil);
		var permis = function () {
			switch (geste.$) {
				case 2:
					return !_Utils_eq(model.et, $elm$core$Maybe$Nothing);
				case 3:
					return !_Utils_eq(model.hh, $elm$core$Maybe$Nothing);
				case 5:
					return !_Utils_eq(model.cI, $elm$core$Maybe$Nothing);
				case 6:
					return !_Utils_eq(model.cI, $elm$core$Maybe$Nothing);
				default:
					return true;
			}
		}();
		var ouvert = _Utils_update(
			model,
			{
				dj: A2(
					$elm$core$List$map,
					$elm$core$Tuple$first,
					$author$project$Components$Produits$Perimetres$Model$criteresRegroupes(model)),
				iT: $elm$core$Maybe$Nothing,
				fy: $elm$core$Maybe$Nothing,
				jo: '',
				jL: $elm$core$Dict$fromList(
					$author$project$Components$Produits$Perimetres$Model$criteresRegroupes(model)),
				fP: $author$project$Components$Produits$Perimetres$Model$choixVide,
				kx: $elm$core$Maybe$Nothing,
				mW: $elm$core$Maybe$Just(geste),
				R: A2(
					$elm$core$Maybe$withDefault,
					$author$project$Components$Shared$LibellesParLangue$Model$vide,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.DG;
							},
							A2($elm$core$Basics$composeR, $elm$core$Dict$toList, $author$project$Components$Shared$LibellesParLangue$Model$depuis)),
						model.zo)),
				cX: '',
				ek: $elm$core$Maybe$Nothing,
				Dj: '',
				pi: $elm$core$Maybe$Nothing,
				hq: false,
				F$: 'toutes-references',
				Gw: $elm$core$Maybe$Nothing,
				hC: '',
				Hc: $elm$core$Maybe$Nothing,
				pZ: $elm$core$Maybe$Nothing,
				qJ: _List_Nil,
				b5: false,
				dc: $elm$core$Maybe$Nothing,
				fm: ''
			});
		var estUnRetrait = function (g) {
			switch (g.$) {
				case 9:
					return true;
				case 8:
					return true;
				default:
					return false;
			}
		};
		var decompteDuRetrait = _Utils_eq(geste, $author$project$Components$Produits$Perimetres$Model$Criteres) ? A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (lien) {
					return _List_fromArray(
						[
							A2($author$project$Components$Produits$Perimetres$Update$Lire, 11, lien)
						]);
				},
				$author$project$Components$Produits$Perimetres$Model$lienDuDecompte(ouvert))) : (estUnRetrait(geste) ? A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (lien) {
					return _List_fromArray(
						[
							A2($author$project$Components$Produits$Perimetres$Update$Lire, 10, lien)
						]);
				},
				$author$project$Components$Produits$Perimetres$Model$lienDeLApercuDException(ouvert))) : _List_Nil);
		return ((!_Utils_eq(
			A2($author$project$Components$Produits$Perimetres$Model$lienDuGeste, geste, model),
			$elm$core$Maybe$Nothing)) && permis) ? A2(
			$elm$core$Tuple$mapSecond,
			function (effets) {
				return _Utils_eq(geste, $author$project$Components$Produits$Perimetres$Model$Archivage) ? _Utils_ap(
					effets,
					_List_fromArray(
						[
							$author$project$Components$Produits$Perimetres$Update$PlacerFocus(
							$author$project$Components$Shared$Confirmation$Clavier$ids('perimetres-archiver').to)
						])) : effets;
			},
			A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Basics$append(
					_Utils_ap(propositions, decompteDuRetrait)),
				A2(
					$author$project$Components$Produits$Perimetres$Update$versLeDrawer,
					$author$project$Components$Shared$Drawer$Update$Ouvrir(
						$author$project$Components$Produits$Perimetres$Model$idDuDeclencheur(geste)),
					ouvert))) : _Utils_Tuple2(model, _List_Nil);
	});
var $author$project$API$NavLinksDictionary$typesDeQuantite = 'types-de-quantite';
var $author$project$Components$Produits$Perimetres$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var cible = msg.a;
				var liens = msg.b;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$perimetres, liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					var lienDesTypes = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$typesDeQuantite, liens);
					return _Utils_Tuple2(
						A3(
							$author$project$Components$Produits$Perimetres$Model$ouvert,
							$elm$core$Maybe$Just(lecture),
							lienDesTypes,
							cible),
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Components$Produits$Perimetres$Update$DemanderProcessUid,
									A2($author$project$Components$Produits$Perimetres$Update$Lire, 0, lecture)
								]),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (lien) {
										return _List_fromArray(
											[
												A2($author$project$Components$Produits$Perimetres$Update$Lire, 7, lien)
											]);
									},
									lienDesTypes))));
				} else {
					return _Utils_Tuple2(
						A3($author$project$Components$Produits$Perimetres$Model$ouvert, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, cible),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 2:
				var lecture = msg.a;
				var reponse = msg.b;
				return A3($author$project$Components$Produits$Perimetres$Update$lue, lecture, reponse, model);
			case 3:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Produits$Perimetres$Update$relire(model));
			case 4:
				var geste = msg.a;
				return ($author$project$API$Envoi$enCours(model.l2) && A2(
					$elm$core$List$member,
					geste,
					_List_fromArray(
						[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$SortieDemandee, $author$project$Components$Shared$Drawer$Update$AbandonConfirme]))) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Produits$Perimetres$Update$versLeDrawer, geste, model);
			case 5:
				var geste = msg.a;
				return A2($author$project$Components$Produits$Perimetres$Update$ouvrir, geste, model);
			case 6:
				return $author$project$Components$Produits$Perimetres$Update$envoyer(
					_Utils_update(
						model,
						{
							mW: $elm$core$Maybe$Just($author$project$Components$Produits$Perimetres$Model$Restauration)
						}));
			case 7:
				var texte = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Dj: texte, pZ: $elm$core$Maybe$Nothing}),
					_List_Nil);
			case 8:
				var code = msg.a;
				var texte = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							R: A3($author$project$Components$Shared$LibellesParLangue$Model$ecrire, code, texte, model.R)
						}),
					_List_Nil);
			case 9:
				var cle = msg.a;
				return $author$project$Components$Produits$Perimetres$Update$avecLeDecompte(
					_Utils_update(
						model,
						{
							dj: _Utils_ap(
								model.dj,
								_List_fromArray(
									[cle])),
							pZ: $elm$core$Maybe$Nothing,
							qJ: A2(
								$elm$core$List$filter,
								function (autre) {
									return !_Utils_eq(autre, cle);
								},
								model.qJ),
							b5: false
						}));
			case 11:
				var ancienne = msg.a;
				var nouvelle = msg.b;
				return $author$project$Components$Produits$Perimetres$Update$avecLeDecompte(
					_Utils_update(
						model,
						{
							dj: A2(
								$elm$core$List$map,
								function (cle) {
									return _Utils_eq(cle, ancienne) ? nouvelle : cle;
								},
								model.dj),
							jL: A2($elm$core$Dict$remove, ancienne, model.jL),
							pZ: $elm$core$Maybe$Nothing,
							b5: false
						}));
			case 10:
				var cle = msg.a;
				return $author$project$Components$Produits$Perimetres$Update$avecLeDecompte(
					_Utils_update(
						model,
						{
							dj: A2(
								$elm$core$List$filter,
								function (autre) {
									return !_Utils_eq(autre, cle);
								},
								model.dj),
							jL: A2($elm$core$Dict$remove, cle, model.jL),
							pZ: $elm$core$Maybe$Nothing,
							qJ: _Utils_ap(
								model.qJ,
								_List_fromArray(
									[cle]))
						}));
			case 12:
				var cle = msg.a;
				var code = msg.b;
				var choisie = msg.c;
				var avant = A2($author$project$Components$Produits$Perimetres$Model$valeursChoisies, cle, model);
				var apres = choisie ? (A2($elm$core$List$member, code, avant) ? avant : _Utils_ap(
					avant,
					_List_fromArray(
						[code]))) : A2(
					$elm$core$List$filter,
					function (autre) {
						return !_Utils_eq(autre, code);
					},
					avant);
				return $author$project$Components$Produits$Perimetres$Update$avecLeDecompte(
					_Utils_update(
						model,
						{
							jL: A3($elm$core$Dict$insert, cle, apres, model.jL),
							pZ: $elm$core$Maybe$Nothing,
							b5: false
						}));
			case 13:
				var rubrique = msg.a;
				var valeur = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fP: A3($author$project$Components$Produits$Perimetres$Update$choisirDansLeCritere, rubrique, valeur, model.fP),
							pZ: $elm$core$Maybe$Nothing
						}),
					_List_Nil);
			case 14:
				var texte = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{hC: texte}),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (lien) {
								return _List_fromArray(
									[
										A2($author$project$Components$Produits$Perimetres$Update$Lire, 6, lien)
									]);
							},
							A2(
								$elm$core$Maybe$andThen,
								function (geste) {
									return A3($author$project$Components$Produits$Perimetres$Model$lienDesReferences, geste, texte, model);
								},
								model.mW))));
			case 15:
				var texte = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							vn: (texte === '') ? $elm$core$Maybe$Nothing : model.vn,
							pS: texte
						}),
					(texte === '') ? _List_Nil : A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (lien) {
								return _List_fromArray(
									[
										A2($author$project$Components$Produits$Perimetres$Update$Lire, 8, lien)
									]);
							},
							A2($author$project$Components$Produits$Perimetres$Model$lienDesClients, texte, model))));
			case 16:
				var uid = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{vn: $elm$core$Maybe$Nothing, pS: ''}),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (lien) {
								return _List_fromArray(
									[
										A2($author$project$Components$Produits$Perimetres$Update$Lire, 2, lien)
									]);
							},
							A2($author$project$Components$Produits$Perimetres$Model$lienDeLApercu, uid, model))));
			case 17:
				var uid = msg.a;
				return $author$project$Components$Produits$Perimetres$Update$avecLApercuDException(
					_Utils_update(
						model,
						{
							Hc: $elm$core$Maybe$Just(uid),
							pZ: $elm$core$Maybe$Nothing,
							b5: false
						}));
			case 18:
				var texte = msg.a;
				return $author$project$Components$Produits$Perimetres$Update$avecLApercuDException(
					_Utils_update(
						model,
						{cX: texte, pZ: $elm$core$Maybe$Nothing}));
			case 19:
				var code = msg.a;
				return $author$project$Components$Produits$Perimetres$Update$avecLApercuDException(
					_Utils_update(
						model,
						{
							ek: $elm$core$Maybe$Just(code),
							pZ: $elm$core$Maybe$Nothing,
							b5: false
						}));
			case 20:
				var uid = msg.a;
				return $author$project$Components$Produits$Perimetres$Update$avecLApercuDeRegle(
					A2($author$project$Components$Produits$Perimetres$Update$choisirLeType, uid, model));
			case 21:
				var texte = msg.a;
				return $author$project$Components$Produits$Perimetres$Update$avecLApercuDeRegle(
					_Utils_update(
						model,
						{pZ: $elm$core$Maybe$Nothing, b5: false, fm: texte}));
			case 22:
				var portee = msg.a;
				return $author$project$Components$Produits$Perimetres$Update$avecLApercuDeRegle(
					_Utils_update(
						model,
						{F$: portee, pZ: $elm$core$Maybe$Nothing}));
			case 23:
				var base = msg.a;
				return $author$project$Components$Produits$Perimetres$Update$avecLApercuDeRegle(
					A2($author$project$Components$Produits$Perimetres$Update$choisirLaBase, base, model));
			case 24:
				var periode = msg.a;
				return $author$project$Components$Produits$Perimetres$Update$avecLApercuDeRegle(
					_Utils_update(
						model,
						{
							pi: $elm$core$Maybe$Just(periode),
							hq: false,
							pZ: $elm$core$Maybe$Nothing
						}));
			case 25:
				return $author$project$Components$Produits$Perimetres$Update$envoyer(model);
			default:
				var reponse = msg.a;
				var _v2 = A3($author$project$API$Envoi$conclure, $author$project$Components$Produits$Perimetres$Update$reglage, reponse, model.l2);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var envoi = _v3.a;
					var issue = _v3.b;
					var effets = _v3.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Produits$Perimetres$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Main$Update$versLesPerimetres = F3(
	function (i18n, msg, model) {
		var _v0 = A2(
			$author$project$Components$Produits$Perimetres$Update$update,
			msg,
			$author$project$Components$Produits$Perimetres$Model$ouvrir(model.pg));
		var perimetres = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLesPerimetres, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLesPerimetres,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Produits$Perimetres$Update$popMessages(msg),
							gardes),
						pg: $author$project$Components$Produits$Perimetres$Model$envelopper(perimetres)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$LireLesPipes = function (a) {
	return {$: 79, a: a};
};
var $author$project$Main$Update$depuisLesPipes = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		if (!effet.$) {
			var lien = effet.a;
			return _Utils_Tuple2(
				model,
				_Utils_ap(
					effets,
					A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesPipes)));
		} else {
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Basics$append(effets),
				A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Parametrage$Common$API$QueryAPIModel$PageDesPipes = F4(
	function (pipes, page, taille, total) {
		return {EE: page, FM: pipes, Jm: taille, JE: total};
	});
var $author$project$Components$Parametrage$Common$API$QueryAPIModel$pageDesPipesDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$PageDesPipes,
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$annuaireDecoder,
	A2($elm$json$Json$Decode$field, 'page', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'taille', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'total', $elm$json$Json$Decode$int));
var $author$project$Components$Parametrage$Pipes$Update$popMessages = function (msg) {
	switch (msg.$) {
		case 1:
			var reponse = msg.a;
			var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Common$API$QueryAPIModel$pageDesPipesDecoder, reponse);
			if (_v1.$ === 1) {
				var refus = _v1.a;
				return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Components$Shared$Messages$Model$duRefus(refus));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 0:
			return $elm$core$Maybe$Nothing;
		case 2:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$Pipes$Update$Lire = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$Pipes$Update$Reconnecter = {$: 1};
var $author$project$Components$Parametrage$Pipes$Update$annuaireEtLiens = A3($elm$json$Json$Decode$map2, $elm$core$Tuple$pair, $author$project$Components$Parametrage$Common$API$QueryAPIModel$pageDesPipesDecoder, $author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder);
var $author$project$Components$Parametrage$Pipes$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 3:
				var lien = msg.a;
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[
							$author$project$Components$Parametrage$Pipes$Update$Lire(lien)
						]));
			case 2:
				var affichage = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{iF: affichage}),
					_List_Nil);
			case 0:
				var liens = msg.a;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$pipes, liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{FM: $elm$core$Maybe$Nothing}),
						_List_fromArray(
							[
								$author$project$Components$Parametrage$Pipes$Update$Lire(lecture)
							]));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{FM: $elm$core$Maybe$Nothing}),
						_List_Nil);
				}
			default:
				var reponse = msg.a;
				var _v2 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Pipes$Update$annuaireEtLiens, reponse);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var lue = _v3.a;
					var liens = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								nQ: liens,
								EE: lue.EE,
								FM: $elm$core$Maybe$Just(lue.FM),
								Jm: lue.Jm,
								JE: lue.JE
							}),
						_List_Nil);
				} else {
					var refus = _v2.a;
					return _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Parametrage$Pipes$Update$Reconnecter]) : _List_Nil);
				}
		}
	});
var $author$project$Main$Update$versLesPipes = F3(
	function (i18n, msg, model) {
		var _v0 = A2($author$project$Components$Parametrage$Pipes$Update$update, msg, model.FM);
		var pipes = _v0.a;
		var effets = _v0.b;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLesPipes,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Parametrage$Pipes$Update$popMessages(msg),
							model.Ct),
						FM: pipes
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$LireLesRelationsExigees = F2(
	function (a, b) {
		return {$: 102, a: a, b: b};
	});
var $author$project$Main$Update$depuisLesRelationsExigees = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		if (!effet.$) {
			var lecture = effet.a;
			var lien = effet.b;
			return _Utils_Tuple2(
				model,
				_Utils_ap(
					effets,
					A3(
						$author$project$Main$Update$versLApi,
						model,
						lien,
						$author$project$Main$Update$LireLesRelationsExigees(lecture))));
		} else {
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Basics$append(effets),
				A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Parametrage$PipeRelationsExigees$Update$dit = function (resultat) {
	if (resultat.$ === 1) {
		var erreur = resultat.a;
		return ((erreur.ri === 401) || (erreur.ri === 404)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Components$Shared$Messages$Model$duRefus(erreur));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$PipeRelationsExigees$API$QueryAPIModel$Page = F2(
	function (exigences, ajouter) {
		return {s7: ajouter, y$: exigences};
	});
var $author$project$API$NavLinksDictionary$ajouterUneExigenceDuPipe = 'ajouter-une-exigence';
var $author$project$Components$Parametrage$PipeRelationsExigees$API$QueryAPIModel$Exigence = F5(
	function (type_, sens, role, dansLEspace, livrePar) {
		return {wq: dansLEspace, BZ: livrePar, bi: role, IC: sens, r0: type_};
	});
var $author$project$Components$Parametrage$PipeRelationsExigees$API$QueryAPIModel$exigenceDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'livrePar',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'dansLEspace',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['exigePar', 'libelle']),
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'sens',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['typeDeRelation', 'libelle']),
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeRelationsExigees$API$QueryAPIModel$Exigence))))));
var $author$project$Components$Parametrage$PipeRelationsExigees$API$QueryAPIModel$pageDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$ajouterUneExigenceDuPipe),
		$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'exigences',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeRelationsExigees$API$QueryAPIModel$exigenceDecoder),
		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeRelationsExigees$API$QueryAPIModel$Page)));
var $author$project$Components$Parametrage$PipeRelationsExigees$Update$popMessages = function (msg) {
	if (msg.$ === 1) {
		var lecture = msg.a;
		var reponse = msg.b;
		switch (lecture) {
			case 0:
				return $author$project$Components$Parametrage$PipeRelationsExigees$Update$dit(
					A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Common$API$QueryAPIModel$annuaireDecoder, reponse));
			case 1:
				return $author$project$Components$Parametrage$PipeRelationsExigees$Update$dit(
					A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Common$API$QueryAPIModel$racineDuPipeDecoder, reponse));
			case 2:
				return $author$project$Components$Parametrage$PipeRelationsExigees$Update$dit(
					A2(
						$author$project$API$Reponse$lire,
						$elm$json$Json$Decode$succeed(0),
						reponse));
			case 3:
				return $author$project$Components$Parametrage$PipeRelationsExigees$Update$dit(
					A2(
						$author$project$API$Reponse$lire,
						$elm$json$Json$Decode$succeed(0),
						reponse));
			default:
				return $author$project$Components$Parametrage$PipeRelationsExigees$Update$dit(
					A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$PipeRelationsExigees$API$QueryAPIModel$pageDecoder, reponse));
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$PipeRelationsExigees$Update$Annuaire = 0;
var $author$project$Components$Parametrage$PipeRelationsExigees$Update$Lire = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeRelationsExigees$Update$Edition = 2;
var $author$project$Components$Parametrage$PipeRelationsExigees$Update$Page = 4;
var $author$project$Components$Parametrage$PipeRelationsExigees$Update$Racine = 1;
var $author$project$Components$Parametrage$PipeRelationsExigees$Update$Roles = 3;
var $author$project$API$NavLinksDictionary$relationsExigeesDuPipe = 'relations-exigees';
var $author$project$Components$Parametrage$PipeRelationsExigees$Update$Reconnecter = {$: 1};
var $author$project$Components$Parametrage$PipeRelationsExigees$Update$sous = F4(
	function (decodeur, reponse, model, suite) {
		var _v0 = A2($author$project$API$Reponse$lire, decodeur, reponse);
		if (!_v0.$) {
			var lue = _v0.a;
			return suite(lue);
		} else {
			var refus = _v0.a;
			return (refus.ri === 401) ? _Utils_Tuple2(
				model,
				_List_fromArray(
					[$author$project$Components$Parametrage$PipeRelationsExigees$Update$Reconnecter])) : _Utils_Tuple2(
				_Utils_update(
					model,
					{nf: model.nf || (refus.ri === 404)}),
				_List_Nil);
		}
	});
var $author$project$Components$Parametrage$PipeRelationsExigees$Update$lu = F3(
	function (lecture, reponse, model) {
		switch (lecture) {
			case 0:
				return A4(
					$author$project$Components$Parametrage$PipeRelationsExigees$Update$sous,
					$author$project$Components$Parametrage$Common$API$QueryAPIModel$lienDuPipeDecoder(model.vx),
					reponse,
					model,
					function (visee) {
						if (!visee.$) {
							var racine = visee.a;
							return _Utils_Tuple2(
								model,
								_List_fromArray(
									[
										A2($author$project$Components$Parametrage$PipeRelationsExigees$Update$Lire, 1, racine)
									]));
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{nf: true}),
								_List_Nil);
						}
					});
			case 1:
				return A4(
					$author$project$Components$Parametrage$PipeRelationsExigees$Update$sous,
					$author$project$Components$Parametrage$Common$API$QueryAPIModel$racineDuPipeDecoder,
					reponse,
					model,
					function (edition) {
						if (!edition.$) {
							var lien = edition.a;
							return _Utils_Tuple2(
								model,
								_List_fromArray(
									[
										A2($author$project$Components$Parametrage$PipeRelationsExigees$Update$Lire, 2, lien)
									]));
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{nf: true}),
								_List_Nil);
						}
					});
			case 2:
				return A4(
					$author$project$Components$Parametrage$PipeRelationsExigees$Update$sous,
					A3(
						$elm$json$Json$Decode$map2,
						$elm$core$Tuple$pair,
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['pipe', 'libelles']),
							$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)),
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder),
					reponse,
					model,
					function (_v3) {
						var libelles = _v3.a;
						var liens = _v3.b;
						var suivant = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rolesDuPipe, liens);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									nf: _Utils_eq(suivant, $elm$core$Maybe$Nothing),
									Bl: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(libelles)
								}),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									$elm$core$List$singleton,
									A2(
										$elm$core$Maybe$map,
										$author$project$Components$Parametrage$PipeRelationsExigees$Update$Lire(3),
										suivant))));
					});
			case 3:
				return A4(
					$author$project$Components$Parametrage$PipeRelationsExigees$Update$sous,
					$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder,
					reponse,
					model,
					function (liens) {
						var suivant = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$relationsExigeesDuPipe, liens);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									nf: _Utils_eq(suivant, $elm$core$Maybe$Nothing)
								}),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									$elm$core$List$singleton,
									A2(
										$elm$core$Maybe$map,
										$author$project$Components$Parametrage$PipeRelationsExigees$Update$Lire(4),
										suivant))));
					});
			default:
				return A4(
					$author$project$Components$Parametrage$PipeRelationsExigees$Update$sous,
					$author$project$Components$Parametrage$PipeRelationsExigees$API$QueryAPIModel$pageDecoder,
					reponse,
					model,
					function (page) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									EE: $elm$core$Maybe$Just(page)
								}),
							_List_Nil);
					});
		}
	});
var $author$project$Components$Parametrage$PipeRelationsExigees$Update$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var code = msg.a;
			var liens = msg.b;
			var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$pipes, liens);
			if (!_v1.$) {
				var lecture = _v1.a;
				return _Utils_Tuple2(
					$author$project$Components$Parametrage$PipeRelationsExigees$Model$init(code),
					_List_fromArray(
						[
							A2($author$project$Components$Parametrage$PipeRelationsExigees$Update$Lire, 0, lecture)
						]));
			} else {
				return _Utils_Tuple2(
					$author$project$Components$Parametrage$PipeRelationsExigees$Model$init(code),
					_List_Nil);
			}
		} else {
			var lecture = msg.a;
			var reponse = msg.b;
			return A3($author$project$Components$Parametrage$PipeRelationsExigees$Update$lu, lecture, reponse, model);
		}
	});
var $author$project$Main$Update$versLesRelationsExigees = F3(
	function (i18n, msg, model) {
		var _v0 = A2($author$project$Components$Parametrage$PipeRelationsExigees$Update$update, msg, model.FJ);
		var relations = _v0.a;
		var effets = _v0.b;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLesRelationsExigees,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Parametrage$PipeRelationsExigees$Update$popMessages(msg),
							model.Ct),
						FJ: relations
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$AttendreAvantDeRelireLesTypesDeQuantite = function (a) {
	return {$: 212, a: a};
};
var $author$project$Main$Update$EnvoyerAuxTypesDeQuantite = function (a) {
	return {$: 211, a: a};
};
var $author$project$Main$Update$LireLesTypesDeQuantite = function (a) {
	return {$: 210, a: a};
};
var $author$project$Main$Model$PourLesTypesDeQuantite = 40;
var $author$project$Main$Update$depuisLesTypesDeQuantite = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[40]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 1:
				var lien = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3($author$project$Main$Update$versLApi, model, lien, $author$project$Main$Update$LireLesTypesDeQuantite)));
			case 2:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerAuxTypesDeQuantite(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 3:
				var delaiMs = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AttendreAvantDeRelireLesTypesDeQuantite(delaiMs)
							])));
			case 4:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Produits$TypesDeQuantite$Update$deLaLecture = function (resultat) {
	if (resultat.$ === 1) {
		var refus = resultat.a;
		return (refus.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Components$Shared$Messages$Model$duRefus(refus));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$TypesDeQuantite$Update$popMessages = function (msg) {
	switch (msg.$) {
		case 2:
			var reponse = msg.a;
			return $author$project$Components$Produits$TypesDeQuantite$Update$deLaLecture(
				A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$API$TypesDeQuantiteQueryAPIModel$annuaireDecoder, reponse));
		case 1:
			var octets = msg.a;
			return _Utils_eq(
				$author$project$API$ProcessUid$depuisOctets(octets),
				$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
				{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Main$Update$requeteSurLesTypesDeQuantite = function (effet) {
	switch (effet.$) {
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Produits$TypesDeQuantite$Update$DemanderProcessUid = {$: 0};
var $author$project$Components$Produits$TypesDeQuantite$Update$Lire = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$TypesDeQuantite$Model$Modification = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$TypesDeQuantite$Model$basesDuComportement = F2(
	function (comportement, bases) {
		return (comportement === 'multiple') ? A2(
			$elm$core$List$filter,
			$elm$core$Basics$eq('par-commande'),
			bases) : bases;
	});
var $author$project$Components$Produits$TypesDeQuantite$Update$AttendreAvantDeRelire = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$TypesDeQuantite$Model$aucunGeste = function (model) {
	return _Utils_update(
		model,
		{mW: $elm$core$Maybe$Nothing, m_: $elm$core$Maybe$Nothing, ez: false, pZ: $elm$core$Maybe$Nothing, qD: _List_Nil, b5: false});
};
var $author$project$Components$Produits$TypesDeQuantite$Update$relire = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Produits$TypesDeQuantite$Update$Lire, $elm$core$List$singleton),
			model.np));
};
var $author$project$Components$Produits$TypesDeQuantite$Model$Creation = {$: 0};
var $author$project$Components$Produits$TypesDeQuantite$Update$PlacerFocus = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Produits$TypesDeQuantite$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{kX: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Produits$TypesDeQuantite$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: _Utils_eq(
						model.mW,
						$elm$core$Maybe$Just($author$project$Components$Produits$TypesDeQuantite$Model$Creation)) && (!_Utils_eq(model.R, $author$project$Components$Shared$LibellesParLangue$Model$vide))
				},
				geste,
				model.kX));
	});
var $author$project$Components$Produits$TypesDeQuantite$Update$conclure = F2(
	function (issue, model) {
		switch (issue.$) {
			case 0:
				var rendue = issue.b;
				if (!_Utils_eq(model.qD, _List_Nil)) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ez: true}),
						_List_Nil);
				} else {
					var _v1 = _Utils_eq(model.mW, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(model, _List_Nil) : A2(
						$author$project$Components$Produits$TypesDeQuantite$Update$versLeDrawer,
						$author$project$Components$Shared$Drawer$Update$Fermer,
						$author$project$Components$Produits$TypesDeQuantite$Model$aucunGeste(model));
					var ferme = _v1.a;
					var focus = _v1.b;
					return _Utils_Tuple2(
						ferme,
						_Utils_ap(
							focus,
							rendue.sy ? $author$project$Components$Produits$TypesDeQuantite$Update$relire(model) : _List_fromArray(
								[
									$author$project$Components$Produits$TypesDeQuantite$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
								])));
				}
			case 1:
				var erreur = issue.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							pZ: $elm$core$Maybe$Just(erreur),
							qD: _List_Nil
						}),
					model.ez ? $author$project$Components$Produits$TypesDeQuantite$Update$relire(model) : _List_Nil);
			default:
				return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIModel$Archiver = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIModel$Creer = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIModel$Ordonner = function (a) {
	return {$: 7, a: a};
};
var $author$project$API$NavLinksDictionary$archiverUnTypeDeQuantite = 'archiver-un-type-de-quantite';
var $author$project$API$NavLinksDictionary$creerUnTypeDeQuantite = 'creer-un-type-de-quantite';
var $author$project$Components$Produits$TypesDeQuantite$Model$langues = _List_fromArray(
	['fr', 'en', 'es', 'de']);
var $author$project$Components$Produits$TypesDeQuantite$Model$lienDe = F2(
	function (rel, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (annuaire) {
				return A2($author$project$API$Liens$trouver, rel, annuaire.nQ.h0);
			},
			model.aS);
	});
var $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIModel$AjouterUneBase = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIModel$DefinirLaPeriode = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIModel$Renommer = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIModel$RetirerUneBase = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$ajouterUneBaseDeQuantite = 'ajouter-une-base-de-quantite';
var $author$project$API$NavLinksDictionary$definirLaPeriodeParDefaut = 'definir-la-periode-par-defaut';
var $author$project$API$NavLinksDictionary$renommerUnTypeDeQuantite = 'renommer-un-type-de-quantite';
var $author$project$API$NavLinksDictionary$retirerUneBaseDeQuantite = 'retirer-une-base-de-quantite';
var $author$project$Components$Produits$TypesDeQuantite$Model$modifications = F4(
	function (uid, type_, noms, model) {
		var retirees = A2(
			$elm$core$List$filter,
			function (base) {
				return !A2($elm$core$List$member, base, model.uo);
			},
			type_.uo);
		var periodeApres = A2($elm$core$List$member, 'par-periode', model.uo) ? model.pi : $elm$core$Maybe$Nothing;
		var nomsAvant = $elm$core$Dict$fromList(type_.DG);
		var nomsApres = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var texte = _v0.b;
					return $elm$core$String$trim(texte) !== '';
				},
				noms));
		var avec = F2(
			function (rel, faite) {
				return A2(
					$elm$core$Maybe$map,
					function (lien) {
						return _Utils_Tuple2(faite, lien);
					},
					A2($author$project$API$Liens$trouver, rel, type_.nQ.h0));
			});
		var ajoutees = A2(
			$elm$core$List$filter,
			function (base) {
				return !A2($elm$core$List$member, base, type_.uo);
			},
			model.uo);
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_Utils_ap(
				(!_Utils_eq(nomsApres, nomsAvant)) ? _List_fromArray(
					[
						A2(
						avec,
						$author$project$API$NavLinksDictionary$renommerUnTypeDeQuantite,
						A2($author$project$Components$Produits$TypesDeQuantite$API$WriteAPIModel$Renommer, uid, noms))
					]) : _List_Nil,
				_Utils_ap(
					A2(
						$elm$core$List$map,
						function (base) {
							return A2(
								avec,
								$author$project$API$NavLinksDictionary$ajouterUneBaseDeQuantite,
								A2($author$project$Components$Produits$TypesDeQuantite$API$WriteAPIModel$AjouterUneBase, uid, base));
						},
						ajoutees),
					_Utils_ap(
						(!_Utils_eq(periodeApres, type_.Fb)) ? _List_fromArray(
							[
								A2(
								avec,
								$author$project$API$NavLinksDictionary$definirLaPeriodeParDefaut,
								A2($author$project$Components$Produits$TypesDeQuantite$API$WriteAPIModel$DefinirLaPeriode, uid, periodeApres))
							]) : _List_Nil,
						A2(
							$elm$core$List$map,
							function (base) {
								return A2(
									avec,
									$author$project$API$NavLinksDictionary$retirerUneBaseDeQuantite,
									A2($author$project$Components$Produits$TypesDeQuantite$API$WriteAPIModel$RetirerUneBase, uid, base));
							},
							retirees)))));
	});
var $author$project$API$NavLinksDictionary$ordonnerLesTypesDeQuantite = 'ordonner-les-types-de-quantite';
var $author$project$Components$Produits$TypesDeQuantite$Model$trouver = F2(
	function (uid, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (a) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (t) {
							return _Utils_eq(t.r8, uid);
						},
						a.ib));
			},
			model.aS);
	});
var $author$project$Components$Produits$TypesDeQuantite$Model$typeDeLaGeste = F2(
	function (geste, model) {
		switch (geste.$) {
			case 1:
				var uid = geste.a;
				return A2($author$project$Components$Produits$TypesDeQuantite$Model$trouver, uid, model);
			case 2:
				var uid = geste.a;
				return A2($author$project$Components$Produits$TypesDeQuantite$Model$trouver, uid, model);
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$TypesDeQuantite$Model$typeDuGeste = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		function (geste) {
			return A2($author$project$Components$Produits$TypesDeQuantite$Model$typeDeLaGeste, geste, model);
		},
		model.mW);
};
var $author$project$Components$Produits$TypesDeQuantite$Model$commandes = function (model) {
	var noms = A2(
		$elm$core$List$map,
		function (code) {
			return _Utils_Tuple2(
				code,
				A2($author$project$Components$Shared$LibellesParLangue$Model$lire, code, model.R));
		},
		$author$project$Components$Produits$TypesDeQuantite$Model$langues);
	var nomFrancais = $elm$core$String$trim(
		A2($author$project$Components$Shared$LibellesParLangue$Model$lire, 'fr', model.R));
	var _v0 = _Utils_Tuple2(
		model.mW,
		$author$project$Components$Produits$TypesDeQuantite$Model$typeDuGeste(model));
	_v0$4:
	while (true) {
		if (!_v0.a.$) {
			switch (_v0.a.a.$) {
				case 0:
					var _v1 = _v0.a.a;
					return ((nomFrancais === '') || $elm$core$List$isEmpty(model.uo)) ? _List_Nil : A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (lien) {
								return _List_fromArray(
									[
										_Utils_Tuple2(
										A4(
											$author$project$Components$Produits$TypesDeQuantite$API$WriteAPIModel$Creer,
											noms,
											model.vV,
											model.uo,
											A2($elm$core$List$member, 'par-periode', model.uo) ? model.pi : $elm$core$Maybe$Nothing),
										lien)
									]);
							},
							A2($author$project$Components$Produits$TypesDeQuantite$Model$lienDe, $author$project$API$NavLinksDictionary$creerUnTypeDeQuantite, model)));
				case 1:
					if (!_v0.b.$) {
						var uid = _v0.a.a.a;
						var type_ = _v0.b.a;
						return (nomFrancais === '') ? _List_Nil : A4($author$project$Components$Produits$TypesDeQuantite$Model$modifications, uid, type_, noms, model);
					} else {
						break _v0$4;
					}
				case 2:
					if (!_v0.b.$) {
						var uid = _v0.a.a.a;
						var type_ = _v0.b.a;
						return A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (lien) {
									return _List_fromArray(
										[
											_Utils_Tuple2(
											$author$project$Components$Produits$TypesDeQuantite$API$WriteAPIModel$Archiver(uid),
											lien)
										]);
								},
								A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$archiverUnTypeDeQuantite, type_.nQ.h0)));
					} else {
						break _v0$4;
					}
				default:
					var _v2 = _v0.a.a;
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (lien) {
								return _List_fromArray(
									[
										_Utils_Tuple2(
										$author$project$Components$Produits$TypesDeQuantite$API$WriteAPIModel$Ordonner(model.El),
										lien)
									]);
							},
							A2($author$project$Components$Produits$TypesDeQuantite$Model$lienDe, $author$project$API$NavLinksDictionary$ordonnerLesTypesDeQuantite, model)));
			}
		} else {
			break _v0$4;
		}
	}
	return _List_Nil;
};
var $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIErrorsModel$Autre = {$: 6};
var $author$project$Components$Produits$TypesDeQuantite$Update$Envoyer = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$TypesDeQuantite$Update$Reconnecter = {$: 5};
var $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIErrorsModel$AucuneBase = {$: 2};
var $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIErrorsModel$BaseNonPermise = {$: 3};
var $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIErrorsModel$BaseUtilisee = {$: 4};
var $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIErrorsModel$NomDejaPris = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIErrorsModel$NomVide = {$: 1};
var $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIErrorsModel$PeriodeSansBase = {$: 5};
var $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIErrorsModel$existant = function (detail) {
	if (detail.$ === 4) {
		var precisions = detail.b;
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v1) {
							var cle = _v1.a;
							return cle === 'existant';
						},
						precisions))));
	} else {
		return '';
	}
};
var $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIErrorsModel$nomDuCas = function (detail) {
	switch (detail.$) {
		case 1:
			var nom = detail.a;
			return $elm$core$Maybe$Just(nom);
		case 4:
			var nom = detail.a;
			return $elm$core$Maybe$Just(nom);
		case 3:
			var nom = detail.a;
			return $elm$core$Maybe$Just(nom);
		case 2:
			var nom = detail.a;
			return $elm$core$Maybe$Just(nom);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIErrorsModel$duRefus = function (refus) {
	var _v0 = $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIErrorsModel$nomDuCas(refus.bB);
	_v0$6:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'NomDeTypeDejaPris':
					return $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIErrorsModel$NomDejaPris(
						$author$project$Components$Produits$TypesDeQuantite$API$WriteAPIErrorsModel$existant(refus.bB));
				case 'NomDeTypeVide':
					return $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIErrorsModel$NomVide;
				case 'AucuneBase':
					return $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIErrorsModel$AucuneBase;
				case 'BaseNonPermise':
					return $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIErrorsModel$BaseNonPermise;
				case 'BaseUtilisee':
					return $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIErrorsModel$BaseUtilisee;
				case 'PeriodeParDefautSansBase':
					return $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIErrorsModel$PeriodeSansBase;
				default:
					break _v0$6;
			}
		} else {
			break _v0$6;
		}
	}
	return $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIErrorsModel$Autre;
};
var $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIModel$Rendue = F2(
	function (vuesAJour, liens) {
		return {nQ: liens, sy: vuesAJour};
	});
var $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIModel$rendueDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'liens',
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vuesAJour',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Components$Produits$TypesDeQuantite$API$WriteAPIModel$Rendue)));
var $author$project$Components$Produits$TypesDeQuantite$Update$reglage = {
	f8: $author$project$Components$Produits$TypesDeQuantite$Update$DemanderProcessUid,
	l4: $author$project$Components$Produits$TypesDeQuantite$Update$Envoyer,
	go: function (reponse) {
		var _v0 = A2(
			$author$project$API$Reponse$lire,
			$elm$json$Json$Decode$succeed(0),
			reponse);
		if (_v0.$ === 1) {
			var refus = _v0.a;
			return $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIErrorsModel$duRefus(refus);
		} else {
			return $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIErrorsModel$Autre;
		}
	},
	pW: $author$project$Components$Produits$TypesDeQuantite$Update$Reconnecter,
	qu: F2(
		function (_v1, _v2) {
			return true;
		}),
	qv: $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIModel$rendueDecoder
};
var $author$project$Components$Produits$TypesDeQuantite$Update$envoyer = function (model) {
	var _v0 = $author$project$Components$Produits$TypesDeQuantite$Model$commandes(model);
	if (!_v0.b) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{b5: true}),
			_List_Nil);
	} else {
		var _v1 = _v0.a;
		var commande = _v1.a;
		var lien = _v1.b;
		var reste = _v0.b;
		var _v2 = A4(
			$author$project$API$Envoi$partir,
			$author$project$Components$Produits$TypesDeQuantite$Update$reglage,
			$elm$core$Maybe$Just(lien),
			commande,
			model.l2);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var envoi = _v3.a;
			var effets = _v3.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi, pZ: $elm$core$Maybe$Nothing, qD: reste}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	}
};
var $author$project$Components$Produits$TypesDeQuantite$Update$envoyerLaSuivante = function (model) {
	var _v0 = model.qD;
	if (_v0.b) {
		var _v1 = _v0.a;
		var commande = _v1.a;
		var lien = _v1.b;
		var reste = _v0.b;
		var _v2 = A4(
			$author$project$API$Envoi$partir,
			$author$project$Components$Produits$TypesDeQuantite$Update$reglage,
			$elm$core$Maybe$Just(lien),
			commande,
			model.l2);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var envoi = _v3.a;
			var effets = _v3.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi, qD: reste}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Produits$TypesDeQuantite$Update$lue = F2(
	function (reponse, model) {
		var _v0 = A2($author$project$API$Reponse$lire, $author$project$Components$Produits$Common$API$TypesDeQuantiteQueryAPIModel$annuaireDecoder, reponse);
		if (!_v0.$) {
			var annuaire = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						aS: $elm$core$Maybe$Just(annuaire)
					}),
				_List_Nil);
		} else {
			var refus = _v0.a;
			return _Utils_Tuple2(
				model,
				(refus.ri === 401) ? _List_fromArray(
					[$author$project$Components$Produits$TypesDeQuantite$Update$Reconnecter]) : _List_Nil);
		}
	});
var $author$project$Components$Produits$TypesDeQuantite$Update$ordonnees = function (bases) {
	return A2(
		$elm$core$List$filter,
		function (base) {
			return A2($elm$core$List$member, base, bases);
		},
		_List_fromArray(
			['par-commande', 'par-periode', 'commande-consolidee']));
};
var $author$project$Components$Produits$TypesDeQuantite$Model$ouvrir = F2(
	function (geste, model) {
		var neuf = _Utils_update(
			model,
			{
				uo: _List_Nil,
				vV: 'minimum',
				mW: $elm$core$Maybe$Just(geste),
				m_: $elm$core$Maybe$Nothing,
				R: $author$project$Components$Shared$LibellesParLangue$Model$vide,
				El: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (a) {
							return A2(
								$elm$core$List$map,
								function ($) {
									return $.r8;
								},
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.tE;
										},
										$elm$core$Basics$not),
									a.ib));
						},
						model.aS)),
				ez: false,
				pi: $elm$core$Maybe$Nothing,
				pZ: $elm$core$Maybe$Nothing,
				qD: _List_Nil,
				b5: false
			});
		var _v0 = A2($author$project$Components$Produits$TypesDeQuantite$Model$typeDeLaGeste, geste, model);
		if (!_v0.$) {
			var type_ = _v0.a;
			return _Utils_update(
				neuf,
				{
					uo: type_.uo,
					vV: type_.vV,
					R: $author$project$Components$Shared$LibellesParLangue$Model$depuis(type_.DG),
					pi: type_.Fb
				});
		} else {
			return neuf;
		}
	});
var $author$project$Components$Produits$TypesDeQuantite$Model$idDuDeclencheur = function (geste) {
	switch (geste.$) {
		case 0:
			return 'types-de-quantite-nouveau';
		case 1:
			var uid = geste.a;
			return 'type-de-quantite-modifier-' + uid;
		case 2:
			var uid = geste.a;
			return 'type-de-quantite-modifier-' + uid;
		default:
			return 'types-de-quantite-ordonner';
	}
};
var $author$project$Components$Produits$TypesDeQuantite$Model$modifiable = function (type_) {
	return !_Utils_eq(
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$renommerUnTypeDeQuantite, type_.nQ.h0),
		$elm$core$Maybe$Nothing);
};
var $author$project$Components$Produits$TypesDeQuantite$Update$typeModifiable = F2(
	function (uid, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$Produits$TypesDeQuantite$Model$modifiable,
				A2(
					$elm$core$Maybe$andThen,
					function (a) {
						return $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (t) {
									return _Utils_eq(t.r8, uid);
								},
								a.ib));
					},
					model.aS)));
	});
var $author$project$Components$Produits$TypesDeQuantite$Update$ouvrir = F2(
	function (geste, model) {
		var permis = function () {
			switch (geste.$) {
				case 0:
					return !_Utils_eq(
						A2($author$project$Components$Produits$TypesDeQuantite$Model$lienDe, $author$project$API$NavLinksDictionary$creerUnTypeDeQuantite, model),
						$elm$core$Maybe$Nothing);
				case 3:
					return !_Utils_eq(
						A2($author$project$Components$Produits$TypesDeQuantite$Model$lienDe, $author$project$API$NavLinksDictionary$ordonnerLesTypesDeQuantite, model),
						$elm$core$Maybe$Nothing);
				case 1:
					var uid = geste.a;
					return A2($author$project$Components$Produits$TypesDeQuantite$Update$typeModifiable, uid, model);
				default:
					var uid = geste.a;
					return A2($author$project$Components$Produits$TypesDeQuantite$Update$typeModifiable, uid, model);
			}
		}();
		if (!permis) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v0 = model.mW;
			if ((!_v0.$) && (_v0.a.$ === 1)) {
				return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) ? _Utils_Tuple2(
					A2($author$project$Components$Produits$TypesDeQuantite$Model$ouvrir, geste, model),
					_List_Nil) : A2(
					$author$project$Components$Produits$TypesDeQuantite$Update$versLeDrawer,
					$author$project$Components$Shared$Drawer$Update$Ouvrir(
						$author$project$Components$Produits$TypesDeQuantite$Model$idDuDeclencheur(geste)),
					A2($author$project$Components$Produits$TypesDeQuantite$Model$ouvrir, geste, model));
			} else {
				return A2(
					$author$project$Components$Produits$TypesDeQuantite$Update$versLeDrawer,
					$author$project$Components$Shared$Drawer$Update$Ouvrir(
						$author$project$Components$Produits$TypesDeQuantite$Model$idDuDeclencheur(geste)),
					A2($author$project$Components$Produits$TypesDeQuantite$Model$ouvrir, geste, model));
			}
		}
	});
var $author$project$Components$Produits$TypesDeQuantite$API$WriteAPIModel$Restaurer = function (a) {
	return {$: 6, a: a};
};
var $author$project$API$NavLinksDictionary$restaurerUnTypeDeQuantite = 'restaurer-un-type-de-quantite';
var $author$project$Components$Produits$TypesDeQuantite$Update$restaurer = F2(
	function (uid, model) {
		var lien = A2(
			$elm$core$Maybe$andThen,
			function (t) {
				return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$restaurerUnTypeDeQuantite, t.nQ.h0);
			},
			A2(
				$elm$core$Maybe$andThen,
				function (a) {
					return $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (t) {
								return _Utils_eq(t.r8, uid);
							},
							a.ib));
				},
				model.aS));
		var _v0 = A4(
			$author$project$API$Envoi$partir,
			$author$project$Components$Produits$TypesDeQuantite$Update$reglage,
			lien,
			$author$project$Components$Produits$TypesDeQuantite$API$WriteAPIModel$Restaurer(uid),
			model.l2);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var envoi = _v1.a;
			var effets = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Produits$TypesDeQuantite$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var liens = msg.a;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$typesDeQuantite, liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						$author$project$Components$Produits$TypesDeQuantite$Model$ouvert(
							$elm$core$Maybe$Just(lecture)),
						_List_fromArray(
							[
								$author$project$Components$Produits$TypesDeQuantite$Update$DemanderProcessUid,
								$author$project$Components$Produits$TypesDeQuantite$Update$Lire(lecture)
							]));
				} else {
					return _Utils_Tuple2(
						$author$project$Components$Produits$TypesDeQuantite$Model$ouvert($elm$core$Maybe$Nothing),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				return $author$project$Components$Produits$TypesDeQuantite$Update$envoyerLaSuivante(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}));
			case 2:
				var reponse = msg.a;
				return A2($author$project$Components$Produits$TypesDeQuantite$Update$lue, reponse, model);
			case 3:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Produits$TypesDeQuantite$Update$relire(model));
			case 4:
				var geste = msg.a;
				return ($author$project$API$Envoi$enCours(model.l2) && A2(
					$elm$core$List$member,
					geste,
					_List_fromArray(
						[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$SortieDemandee, $author$project$Components$Shared$Drawer$Update$AbandonConfirme]))) ? _Utils_Tuple2(model, _List_Nil) : A2($author$project$Components$Produits$TypesDeQuantite$Update$versLeDrawer, geste, model);
			case 5:
				var geste = msg.a;
				return A2($author$project$Components$Produits$TypesDeQuantite$Update$ouvrir, geste, model);
			case 6:
				var _v2 = model.mW;
				if ((!_v2.$) && (_v2.a.$ === 2)) {
					var uid = _v2.a.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$Produits$TypesDeQuantite$Model$ouvrir,
							$author$project$Components$Produits$TypesDeQuantite$Model$Modification(uid),
							model),
						_List_Nil);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 7:
				var code = msg.a;
				var texte = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							R: A3($author$project$Components$Shared$LibellesParLangue$Model$ecrire, code, texte, model.R),
							pZ: $elm$core$Maybe$Nothing
						}),
					_List_Nil);
			case 8:
				var comportement = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uo: A2($author$project$Components$Produits$TypesDeQuantite$Model$basesDuComportement, comportement, model.uo),
							vV: comportement,
							pZ: $elm$core$Maybe$Nothing
						}),
					_List_Nil);
			case 9:
				var base = msg.a;
				var cochee = msg.b;
				var bases = cochee ? (A2($elm$core$List$member, base, model.uo) ? model.uo : _Utils_ap(
					model.uo,
					_List_fromArray(
						[base]))) : A2(
					$elm$core$List$filter,
					$elm$core$Basics$neq(base),
					model.uo);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uo: $author$project$Components$Produits$TypesDeQuantite$Update$ordonnees(bases),
							pZ: $elm$core$Maybe$Nothing,
							b5: false
						}),
					_List_Nil);
			case 10:
				var code = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							pi: (code === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(code),
							pZ: $elm$core$Maybe$Nothing
						}),
					_List_Nil);
			case 11:
				var uid = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							El: A2(
								$author$project$Components$Shared$Ordre$monter,
								$elm$core$Basics$eq(uid),
								model.El)
						}),
					_List_Nil);
			case 12:
				var uid = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							El: A2(
								$author$project$Components$Shared$Ordre$descendre,
								$elm$core$Basics$eq(uid),
								model.El)
						}),
					_List_Nil);
			case 13:
				var uid = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							m_: $elm$core$Maybe$Just(uid)
						}),
					_List_Nil);
			case 14:
				return _Utils_Tuple2(model, _List_Nil);
			case 15:
				var surLui = msg.a;
				var _v3 = model.m_;
				if (!_v3.$) {
					var glisse = _v3.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								m_: $elm$core$Maybe$Nothing,
								El: A3(
									$author$project$Components$Shared$Ordre$deposer,
									$elm$core$Basics$eq(glisse),
									$elm$core$Basics$eq(surLui),
									model.El)
							}),
						_List_Nil);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 16:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{m_: $elm$core$Maybe$Nothing}),
					_List_Nil);
			case 17:
				var uid = msg.a;
				return A2($author$project$Components$Produits$TypesDeQuantite$Update$restaurer, uid, model);
			case 18:
				return $author$project$Components$Produits$TypesDeQuantite$Update$envoyer(model);
			default:
				var reponse = msg.a;
				var _v4 = A3($author$project$API$Envoi$conclure, $author$project$Components$Produits$TypesDeQuantite$Update$reglage, reponse, model.l2);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var envoi = _v5.a;
					var issue = _v5.b;
					var effets = _v5.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Produits$TypesDeQuantite$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Main$Update$versLesTypesDeQuantite = F3(
	function (i18n, msg, model) {
		var _v0 = A2(
			$author$project$Components$Produits$TypesDeQuantite$Update$update,
			msg,
			$author$project$Components$Produits$TypesDeQuantite$Model$deballer(model.J1));
		var typesDeQuantite = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLesTypesDeQuantite, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLesTypesDeQuantite,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Produits$TypesDeQuantite$Update$popMessages(msg),
							gardes),
						J1: $author$project$Components$Produits$TypesDeQuantite$Model$envelopper(typesDeQuantite)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$AttendreAvantDeRelireLesUtilisateurs = function (a) {
	return {$: 229, a: a};
};
var $author$project$Main$Update$EnvoyerAuxUtilisateurs = function (a) {
	return {$: 228, a: a};
};
var $author$project$Main$Update$LireLesUtilisateurs = F2(
	function (a, b) {
		return {$: 227, a: a, b: b};
	});
var $author$project$Main$Model$PourLesUtilisateurs = 45;
var $author$project$Main$Update$depuisLesUtilisateurs = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[45]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 1:
				var lecture = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLesUtilisateurs(lecture))));
			case 2:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerAuxUtilisateurs(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 3:
				var delaiMs = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AttendreAvantDeRelireLesUtilisateurs(delaiMs)
							])));
			case 4:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			case 5:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
			case 6:
				var adresse = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AllerA(adresse)
							])));
			default:
				var fichier = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$TelechargerLesFichiers(
								_List_fromArray(
									[fichier]))
							])));
		}
	});
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIErrorsModel$AutreRefus = 12;
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$Annuaire = F3(
	function (disponible, utilisateurs, liens) {
		return {kR: disponible, nQ: liens, Kf: utilisateurs};
	});
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$Utilisateur = function (utilisateur) {
	return function (nom) {
		return function (courriel) {
			return function (roles) {
				return function (etat) {
					return function (doubleAuthentification) {
						return function (derniereConnexion) {
							return function (desactiveLe) {
								return function (vous) {
									return function (liens) {
										return {kh: courriel, kJ: derniereConnexion, xp: desactiveLe, kV: doubleAuthentification, gt: etat, nQ: liens, Dj: nom, eX: roles, fl: utilisateur, KX: vous};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$Actif = 0;
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$Desactive = 1;
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$InvitationEnvoyee = 2;
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$InvitationExpiree = 3;
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$etatDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (etat) {
		switch (etat) {
			case 'Actif':
				return $elm$json$Json$Decode$succeed(0);
			case 'Desactive':
				return $elm$json$Json$Decode$succeed(1);
			case 'InvitationEnvoyee':
				return $elm$json$Json$Decode$succeed(2);
			case 'Expiree':
				return $elm$json$Json$Decode$succeed(3);
			default:
				var autre = etat;
				return $elm$json$Json$Decode$fail('etat-inconnu:' + autre);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$facultatif = F2(
	function (champ, decodeur) {
		return A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			champ,
			$elm$json$Json$Decode$nullable(decodeur),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$utilisateurDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vous',
		$elm$json$Json$Decode$bool,
		A3(
			$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$facultatif,
			'desactiveLe',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$facultatif,
				'derniereConnexion',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$facultatif,
					'doubleAuthentification',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'etat',
						$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$etatDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'roles',
							$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'courriel',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'nom',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'utilisateur',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$Utilisateur)))))))))));
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$annuaireDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'utilisateurs',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$utilisateurDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'disponible',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$Annuaire))));
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIErrorsModel$CompteDejaActif = 3;
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIErrorsModel$ComptesIndisponibles = 2;
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIErrorsModel$DepannageImpossible = 10;
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIErrorsModel$DernierAdministrateur = 6;
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIErrorsModel$EmailInvalide = 1;
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIErrorsModel$EnvoiEnCours = 5;
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIErrorsModel$FaitDejaPartieDuClient = 0;
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIErrorsModel$FicheDejaLiee = 9;
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIErrorsModel$FicheIntrouvable = 8;
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIErrorsModel$TropDInvitations = 4;
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIErrorsModel$UtilisateurIntrouvable = 7;
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIErrorsModel$duRefus = function (reponse) {
	var _v0 = A2(
		$elm$json$Json$Decode$decodeString,
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['error']),
			$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value)),
		reponse.f$);
	_v0$11:
	while (true) {
		if ((!_v0.$) && _v0.a.b) {
			switch (_v0.a.a.a) {
				case 'FaitDejaPartieDuClient':
					var _v1 = _v0.a;
					var _v2 = _v1.a;
					return 0;
				case 'ComptesIndisponibles':
					var _v3 = _v0.a;
					var _v4 = _v3.a;
					return 2;
				case 'CompteDejaActif':
					var _v5 = _v0.a;
					var _v6 = _v5.a;
					return 3;
				case 'TropDInvitations':
					var _v7 = _v0.a;
					var _v8 = _v7.a;
					return 4;
				case 'EnvoiEnCours':
					var _v9 = _v0.a;
					var _v10 = _v9.a;
					return 5;
				case 'DernierAdministrateur':
					var _v11 = _v0.a;
					var _v12 = _v11.a;
					return 6;
				case 'UtilisateurIntrouvable':
					var _v13 = _v0.a;
					var _v14 = _v13.a;
					return 7;
				case 'FicheIntrouvable':
					var _v15 = _v0.a;
					var _v16 = _v15.a;
					return 8;
				case 'FicheDejaLiee':
					var _v17 = _v0.a;
					var _v18 = _v17.a;
					return 9;
				case 'DepannageImpossible':
					var _v19 = _v0.a;
					var _v20 = _v19.a;
					return 10;
				case 'SaisieInvalide':
					var _v21 = _v0.a;
					var _v22 = _v21.a;
					var contenu = _v22.b;
					return _Utils_eq(
						A2(
							$elm$json$Json$Decode$decodeValue,
							A2($elm$json$Json$Decode$field, 'champ', $elm$json$Json$Decode$string),
							contenu),
						$elm$core$Result$Ok('email')) ? 1 : 12;
				default:
					break _v0$11;
			}
		} else {
			break _v0$11;
		}
	}
	return 12;
};
var $author$project$Components$Parametrage$Utilisateurs$Update$enPanne = F2(
	function (decodeur, reponse) {
		var _v0 = A2($author$project$API$Reponse$lire, decodeur, reponse);
		if (_v0.$ === 1) {
			var refus = _v0.a;
			return A2(
				$elm$core$List$member,
				refus.ri,
				_List_fromArray(
					[401, 403])) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				$author$project$Components$Shared$Messages$Model$duRefus(refus));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$ExportDesConnexions = F2(
	function (fichier, lignes) {
		return {gw: fichier, gV: lignes};
	});
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$exportDesConnexionsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'lignes',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'fichier',
		A4(
			$elm$json$Json$Decode$map3,
			F3(
				function (nom, type_, contenu) {
					return {fZ: contenu, Dj: nom, r0: type_};
				}),
			A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'contenu', $elm$json$Json$Decode$string)),
		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$ExportDesConnexions)));
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$Fiche = function (utilisateur) {
	return function (nom) {
		return function (courriel) {
			return function (etat) {
				return function (vous) {
					return function (roles) {
						return function (ficheCollaborateur) {
							return function (inviteLe) {
								return function (accepteLe) {
									return function (derniereConnexion) {
										return function (doubleAuthentification) {
											return function (desactivation) {
												return function (reactivation) {
													return function (dernierAdministrateur) {
														return function (securite) {
															return function (liens) {
																return {sL: accepteLe, kh: courriel, xh: dernierAdministrateur, kJ: derniereConnexion, xn: desactivation, kV: doubleAuthentification, gt: etat, zq: ficheCollaborateur, AW: inviteLe, nQ: liens, Dj: nom, G_: reactivation, eX: roles, q1: securite, fl: utilisateur, KX: vous};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$FicheLiee = F2(
	function (fiche, nom) {
		return {zo: fiche, Dj: nom};
	});
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$RoleDeLaFiche = F4(
	function (role, nom, attribueLe, attribuePar) {
		return {tT: attribueLe, tU: attribuePar, Dj: nom, bi: role};
	});
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$Activee = 0;
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$Application = 0;
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$CleDeSecurite = 1;
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$NonActivee = 2;
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$Reinitialisee = 1;
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$SecuriteDeLaFiche = F7(
	function (imposee, etat, moyen, activeeLe, reinitialisation, lienValableJusqua, sessions) {
		return {sS: activeeLe, gt: etat, AD: imposee, BM: lienValableJusqua, CZ: moyen, Hp: reinitialisation, IK: sessions};
	});
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$selon = F2(
	function (inconnu, codes) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (code) {
				var _v0 = A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$eq(code)),
					codes);
				if (_v0.b) {
					var _v1 = _v0.a;
					var valeur = _v1.b;
					return $elm$json$Json$Decode$succeed(valeur);
				} else {
					return $elm$json$Json$Decode$fail(inconnu + (':' + code));
				}
			},
			$elm$json$Json$Decode$string);
	});
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$Trace = F2(
	function (le, par) {
		return {Bf: le, EK: par};
	});
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$traceDecoder = A3(
	$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$facultatif,
	'par',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'le',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$Trace)));
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$securiteDeLaFicheDecoder = A3(
	$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$facultatif,
	'sessions',
	$elm$json$Json$Decode$list(
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
	A3(
		$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$facultatif,
		'lienValableJusqua',
		$elm$json$Json$Decode$string,
		A3(
			$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$facultatif,
			'reinitialisation',
			$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$traceDecoder,
			A3(
				$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$facultatif,
				'activeeLe',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$facultatif,
					'moyen',
					A2(
						$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$selon,
						'moyen-inconnu',
						_List_fromArray(
							[
								_Utils_Tuple2('Application', 0),
								_Utils_Tuple2('CleDeSecurite', 1)
							])),
					A3(
						$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$facultatif,
						'etat',
						A2(
							$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$selon,
							'etat-de-la-double-authentification-inconnu',
							_List_fromArray(
								[
									_Utils_Tuple2('Activee', 0),
									_Utils_Tuple2('Reinitialisee', 1),
									_Utils_Tuple2('NonActivee', 2)
								])),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'imposee',
							$elm$json$Json$Decode$bool,
							$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$SecuriteDeLaFiche))))))));
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$ficheDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'securite',
		$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$securiteDeLaFicheDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'dernierAdministrateur',
			$elm$json$Json$Decode$bool,
			A3(
				$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$facultatif,
				'reactivation',
				$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$traceDecoder,
				A3(
					$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$facultatif,
					'desactivation',
					$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$traceDecoder,
					A3(
						$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$facultatif,
						'doubleAuthentification',
						$elm$json$Json$Decode$bool,
						A3(
							$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$facultatif,
							'derniereConnexion',
							$elm$json$Json$Decode$string,
							A3(
								$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$facultatif,
								'accepteLe',
								$elm$json$Json$Decode$string,
								A3(
									$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$facultatif,
									'inviteLe',
									$elm$json$Json$Decode$string,
									A3(
										$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$facultatif,
										'ficheCollaborateur',
										A3(
											$elm$json$Json$Decode$map2,
											$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$FicheLiee,
											A2($elm$json$Json$Decode$field, 'fiche', $elm$json$Json$Decode$string),
											A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string)),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'roles',
											$elm$json$Json$Decode$list(
												A3(
													$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$facultatif,
													'attribuePar',
													$elm$json$Json$Decode$string,
													A3(
														$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$facultatif,
														'attribueLe',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'nom',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'role',
																$elm$json$Json$Decode$string,
																$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$RoleDeLaFiche)))))),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'vous',
												$elm$json$Json$Decode$bool,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'etat',
													$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$etatDecoder,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'courriel',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'nom',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'utilisateur',
																$elm$json$Json$Decode$string,
																$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$Fiche)))))))))))))))));
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$FicheProposee = F4(
	function (fiche, nom, dejaLiee, memeNom) {
		return {w0: dejaLiee, zo: fiche, Cp: memeNom, Dj: nom};
	});
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$FichesProposees = F2(
	function (fiches, liens) {
		return {zu: fiches, nQ: liens};
	});
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$fichesProposeesDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'fiches',
		$elm$json$Json$Decode$list(
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'memeNom',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'dejaLiee',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'nom',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'fiche',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$FicheProposee)))))),
		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$FichesProposees)));
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$Invitations = F2(
	function (invitations, liens) {
		return {AU: invitations, nQ: liens};
	});
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$Invitation = F7(
	function (utilisateur, nom, courriel, envoyeeLe, expireLe, statut, liens) {
		return {kh: courriel, yw: envoyeeLe, y3: expireLe, nQ: liens, Dj: nom, ri: statut, fl: utilisateur};
	});
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$Acceptee = 2;
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$Annulee = 3;
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$EnAttente = 0;
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$Expiree = 1;
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$statutDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (statut) {
		switch (statut) {
			case 'EnAttente':
				return $elm$json$Json$Decode$succeed(0);
			case 'Expiree':
				return $elm$json$Json$Decode$succeed(1);
			case 'Acceptee':
				return $elm$json$Json$Decode$succeed(2);
			case 'Annulee':
				return $elm$json$Json$Decode$succeed(3);
			default:
				var autre = statut;
				return $elm$json$Json$Decode$fail('statut-inconnu:' + autre);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$invitationDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'statut',
		$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$statutDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'expireLe',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'envoyeeLe',
				$elm$json$Json$Decode$string,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'courriel',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'nom',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'utilisateur',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$Invitation))))))));
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$invitationsDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'invitations',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$invitationDecoder),
		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$Invitations)));
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$Connexion = F6(
	function (le, utilisateur, nom, retire, adresse, navigateur) {
		return {aa: adresse, Bf: le, C4: navigateur, Dj: nom, HZ: retire, fl: utilisateur};
	});
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$JournalDesConnexions = F7(
	function (connexions, total, page, taille, fuseau, conservationEnMois, liens) {
		return {j8: connexions, v6: conservationEnMois, z_: fuseau, nQ: liens, EE: page, Jm: taille, JE: total};
	});
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$journalDesConnexionsDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'conservationEnMois',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'fuseau',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'taille',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'page',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'total',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'connexions',
							$elm$json$Json$Decode$list(
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'navigateur',
									A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'adresse',
										A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
										$elm$core$Maybe$Nothing,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'retire',
											$elm$json$Json$Decode$bool,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'nom',
												A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
												$elm$core$Maybe$Nothing,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'utilisateur',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'le',
														$elm$json$Json$Decode$string,
														$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$Connexion)))))))),
							$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$JournalDesConnexions))))))));
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$Rendue = F3(
	function (invite, vuesAJour, liens) {
		return {AV: invite, nQ: liens, sy: vuesAJour};
	});
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$inviteDecoder = $elm$json$Json$Decode$maybe(
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['event', 'InvitationEnvoyee', 'utilisateur']),
		$elm$json$Json$Decode$string));
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$rendueDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'liens',
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vuesAJour',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'evenements',
			A2(
				$elm$json$Json$Decode$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$filterMap($elm$core$Basics$identity),
					$elm$core$List$head),
				$elm$json$Json$Decode$list($author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$inviteDecoder)),
			$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$Rendue))));
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$Role = F3(
	function (id, nom, liens) {
		return {Aq: id, nQ: liens, Dj: nom};
	});
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$rolesDecoder = A2(
	$elm$json$Json$Decode$field,
	'roles',
	$elm$json$Json$Decode$list(
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2(
				$elm$json$Json$Decode$map,
				function ($) {
					return $.h0;
				},
				$author$project$API$Liens$deLaRessource),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'nom',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$Role))))));
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$SecuriteDeLEspace = F6(
	function (disponible, imposee, imposeeDepuis, total, enAttente, liens) {
		return {kR: disponible, lU: enAttente, AD: imposee, AE: imposeeDepuis, nQ: liens, JE: total};
	});
var $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$securiteDeLEspaceDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'enAttente',
		$elm$json$Json$Decode$list($author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$utilisateurDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'total',
			$elm$json$Json$Decode$int,
			A3(
				$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$facultatif,
				'imposeeDepuis',
				$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$traceDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'imposee',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'disponible',
						$elm$json$Json$Decode$bool,
						$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$SecuriteDeLEspace)))))));
var $author$project$Components$Parametrage$Utilisateurs$Update$tropVolumineux = function (reponse) {
	var _v0 = A2(
		$author$project$API$Reponse$lire,
		$elm$json$Json$Decode$succeed(0),
		reponse);
	if (_v0.$ === 1) {
		var refus = _v0.a;
		return _Utils_eq(
			refus.bB,
			$author$project$API$Reponse$Metier('ExportTropVolumineux'));
	} else {
		return false;
	}
};
var $author$project$Components$Parametrage$Utilisateurs$Update$popMessages = function (msg) {
	switch (msg.$) {
		case 5:
			switch (msg.a) {
				case 0:
					var _v1 = msg.a;
					var reponse = msg.b;
					return A2(
						$author$project$Components$Parametrage$Utilisateurs$Update$enPanne,
						A2(
							$elm$json$Json$Decode$map,
							function (_v2) {
								return 0;
							},
							$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$annuaireDecoder),
						reponse);
				case 1:
					var _v3 = msg.a;
					var reponse = msg.b;
					return A2(
						$author$project$Components$Parametrage$Utilisateurs$Update$enPanne,
						A2(
							$elm$json$Json$Decode$map,
							function (_v4) {
								return 0;
							},
							$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$ficheDecoder),
						reponse);
				case 5:
					var _v5 = msg.a;
					var reponse = msg.b;
					return A2(
						$author$project$Components$Parametrage$Utilisateurs$Update$enPanne,
						A2(
							$elm$json$Json$Decode$map,
							function (_v6) {
								return 0;
							},
							$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$fichesProposeesDecoder),
						reponse);
				case 6:
					var _v7 = msg.a;
					var reponse = msg.b;
					return A2(
						$author$project$Components$Parametrage$Utilisateurs$Update$enPanne,
						A2(
							$elm$json$Json$Decode$map,
							function (_v8) {
								return 0;
							},
							$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$invitationsDecoder),
						reponse);
				case 7:
					var _v9 = msg.a;
					var reponse = msg.b;
					return A2(
						$author$project$Components$Parametrage$Utilisateurs$Update$enPanne,
						A2(
							$elm$json$Json$Decode$map,
							function (_v10) {
								return 0;
							},
							$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$rolesDecoder),
						reponse);
				case 2:
					var _v11 = msg.a;
					var reponse = msg.b;
					return A2(
						$author$project$Components$Parametrage$Utilisateurs$Update$enPanne,
						A2(
							$elm$json$Json$Decode$map,
							function (_v12) {
								return 0;
							},
							$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$journalDesConnexionsDecoder),
						reponse);
				case 4:
					var _v13 = msg.a;
					var reponse = msg.b;
					return A2(
						$author$project$Components$Parametrage$Utilisateurs$Update$enPanne,
						A2(
							$elm$json$Json$Decode$map,
							function (_v14) {
								return 0;
							},
							$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$journalDesConnexionsDecoder),
						reponse);
				case 3:
					var _v15 = msg.a;
					var reponse = msg.b;
					return $author$project$Components$Parametrage$Utilisateurs$Update$tropVolumineux(reponse) ? $elm$core$Maybe$Nothing : A2(
						$author$project$Components$Parametrage$Utilisateurs$Update$enPanne,
						A2(
							$elm$json$Json$Decode$map,
							function (_v16) {
								return 0;
							},
							$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$exportDesConnexionsDecoder),
						reponse);
				default:
					var _v17 = msg.a;
					var reponse = msg.b;
					return A2(
						$author$project$Components$Parametrage$Utilisateurs$Update$enPanne,
						A2(
							$elm$json$Json$Decode$map,
							function (_v18) {
								return 0;
							},
							$author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$securiteDeLEspaceDecoder),
						reponse);
			}
		case 30:
			var reponse = msg.a;
			return ($author$project$Components$Parametrage$Utilisateurs$API$WriteAPIErrorsModel$duRefus(reponse) === 12) ? A2(
				$author$project$Components$Parametrage$Utilisateurs$Update$enPanne,
				A2(
					$elm$json$Json$Decode$map,
					function (_v19) {
						return 0;
					},
					$author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$rendueDecoder),
				reponse) : $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Main$Update$requeteSurLesUtilisateurs = function (effet) {
	switch (effet.$) {
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$Annuler = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$DelierLaFiche = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Update$DemanderProcessUid = {$: 0};
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$Desactiver = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$EnvoyerUneReinitialisationDuMotDePasse = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Model$ExportEnCours = {$: 1};
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$FermerLesSessions = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$ImposerLaDoubleAuthentification = {$: 9};
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$Inviter = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Update$LAnnuaire = 0;
var $author$project$Components$Parametrage$Utilisateurs$Update$LExport = 3;
var $author$project$Components$Parametrage$Utilisateurs$Update$LaSecurite = 8;
var $author$project$Components$Parametrage$Utilisateurs$Update$LesInvitations = 6;
var $author$project$Components$Parametrage$Utilisateurs$Update$LesRoles = 7;
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$LeverLaDoubleAuthentification = {$: 10};
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$LierUneFiche = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Parametrage$Utilisateurs$Update$Lire = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Parametrage$Utilisateurs$Model$OngletSecurite = 1;
var $author$project$Components$Parametrage$Utilisateurs$Update$PlacerFocus = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$Reactiver = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$ReinitialiserLaDoubleAuthentification = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$Renvoyer = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$Retirer = function (a) {
	return {$: 6, a: a};
};
var $author$project$API$NavLinksDictionary$annulerUneInvitation = 'annuler-une-invitation';
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$AttribuerUnRole = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Parametrage$Utilisateurs$Update$Envoyer = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$Utilisateurs$Update$Reconnecter = {$: 5};
var $author$project$Components$Parametrage$Utilisateurs$Update$reglage = {
	f8: $author$project$Components$Parametrage$Utilisateurs$Update$DemanderProcessUid,
	l4: $author$project$Components$Parametrage$Utilisateurs$Update$Envoyer,
	go: $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIErrorsModel$duRefus,
	pW: $author$project$Components$Parametrage$Utilisateurs$Update$Reconnecter,
	qu: F2(
		function (_v0, _v1) {
			return true;
		}),
	qv: $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$rendueDecoder
};
var $author$project$Components$Parametrage$Utilisateurs$Update$envoyer = F3(
	function (lien, commande, model) {
		var _v0 = A4($author$project$API$Envoi$partir, $author$project$Components$Parametrage$Utilisateurs$Update$reglage, lien, commande, model.l2);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var envoi = _v1.a;
			var effets = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi, pZ: $elm$core$Maybe$Nothing}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$Utilisateurs$Update$attribuerLeSuivant = function (model) {
	var _v0 = model.i7;
	if (!_v0.$) {
		var attribution = _v0.a;
		var _v1 = attribution.HR;
		if (_v1.b) {
			var role = _v1.a;
			return A3(
				$author$project$Components$Parametrage$Utilisateurs$Update$envoyer,
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$attribuerUnRole, role.nQ),
				A2($author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$AttribuerUnRole, role.Aq, attribution.fl),
				model);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$Utilisateurs$Update$LesFichesProposees = 5;
var $author$project$API$NavLinksDictionary$fichesCollaborateur = 'fiches-collaborateur';
var $author$project$Components$Parametrage$Utilisateurs$Model$lienDeLaRecherche = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function (lien) {
			return $elm$core$String$isEmpty(
				$elm$core$String$trim(model.hC)) ? lien : _Utils_update(
				lien,
				{
					cM: lien.cM + ('?texte=' + $elm$url$Url$percentEncode(
						$elm$core$String$trim(model.hC)))
				});
		},
		A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$fichesCollaborateur)),
			model.zo));
};
var $author$project$Components$Parametrage$Utilisateurs$Update$chercher = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$Parametrage$Utilisateurs$Update$Lire(5),
				$elm$core$List$singleton),
			$author$project$Components$Parametrage$Utilisateurs$Model$lienDeLaRecherche(model)));
};
var $author$project$Components$Parametrage$Utilisateurs$Model$choisir = F2(
	function (fiche, model) {
		var libre = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.zu;
					},
					$elm$core$List$any(
						function (p) {
							return _Utils_eq(p.zo, fiche) && (!p.w0);
						})),
				model.pE));
		return libre ? _Utils_update(
			model,
			{
				ve: $elm$core$Maybe$Just(fiche)
			}) : model;
	});
var $author$project$Components$Parametrage$Utilisateurs$Update$AttendreAvantDeRelire = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Update$Naviguer = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$API$WriteAPIErrorsModel$TropDeLiensDuMotDePasse = 11;
var $author$project$I18n$Textes$utilisateursAnnonceRetire = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'utilisateurs.annonce.retire',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nom',
				$author$project$I18n$Traductions$Sous(p.Dj)),
				_Utils_Tuple2(
				'elision',
				$author$project$I18n$Traductions$Option(
					$author$project$I18n$Choix$codeElision(p.av))),
				_Utils_Tuple2(
				'espace',
				$author$project$I18n$Traductions$Rogne(p.yz))
			]),
		'{nom} a été retiré {elision, select, elide {d\'{espace}} other {de {espace}}}.');
};
var $author$project$I18n$Textes$utilisateursAnnonceRetireSansEspace = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'utilisateurs.annonce.retire.sans-espace',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nom',
				$author$project$I18n$Traductions$Sous(p.Dj))
			]),
		'{nom} a été retiré de l\'espace.');
};
var $author$project$Components$Parametrage$Utilisateurs$Update$annonceDuRetrait = function (model) {
	var nom = $author$project$I18n$Traductions$tel(
		A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Dj;
				},
				model.zo)));
	var _v0 = model.g5;
	if (!_v0.$) {
		var espace = _v0.a;
		return $author$project$I18n$Textes$utilisateursAnnonceRetire(
			{
				av: $author$project$Texte$Elision$elision(espace),
				yz: $author$project$I18n$Traductions$tel(espace),
				Dj: nom
			});
	} else {
		return $author$project$I18n$Textes$utilisateursAnnonceRetireSansEspace(
			{Dj: nom});
	}
};
var $author$project$Components$Parametrage$Utilisateurs$Update$courrielDe = F2(
	function (utilisateur, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kh;
					},
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.fl;
							},
							$elm$core$Basics$eq(utilisateur)),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.Kf;
								},
								model.aS))))));
	});
var $author$project$Components$Parametrage$Utilisateurs$Update$echoue = function (attribution) {
	return _Utils_update(
		attribution,
		{
			x3: _Utils_ap(
				attribution.x3,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.Dj;
					},
					A2($elm$core$List$take, 1, attribution.HR))),
			HR: A2($elm$core$List$drop, 1, attribution.HR)
		});
};
var $author$project$Components$Parametrage$Utilisateurs$Update$nomDeLaFiche = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.Dj;
			},
			model.zo));
};
var $author$project$Components$Parametrage$Utilisateurs$Update$LaFiche = 1;
var $author$project$Components$Parametrage$Utilisateurs$Update$relireLAnnuaire = function (model) {
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$map,
				$author$project$Components$Parametrage$Utilisateurs$Update$Lire(0),
				model.np),
				A2(
				$elm$core$Maybe$map,
				$author$project$Components$Parametrage$Utilisateurs$Update$Lire(6),
				model.nu)
			]));
};
var $author$project$Components$Parametrage$Utilisateurs$Update$relire = function (model) {
	var _v0 = _Utils_Tuple2(
		model.vf,
		A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				$author$project$API$Liens$trouver('self')),
			model.zo));
	if (!_v0.a.$) {
		if (!_v0.b.$) {
			var soi = _v0.b.a;
			return _List_fromArray(
				[
					A2($author$project$Components$Parametrage$Utilisateurs$Update$Lire, 1, soi)
				]);
		} else {
			var _v1 = _v0.b;
			return _List_Nil;
		}
	} else {
		var _v2 = _v0.a;
		return (model.oZ === 1) ? A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Parametrage$Utilisateurs$Update$Lire(8),
					$elm$core$List$singleton),
				model.nr)) : $author$project$Components$Parametrage$Utilisateurs$Update$relireLAnnuaire(model);
	}
};
var $author$project$Components$Parametrage$Utilisateurs$Model$rolesAttribuables = function (model) {
	return A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.nQ;
			},
			A2(
				$elm$core$Basics$composeR,
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$attribuerUnRole),
				$elm$core$Basics$neq($elm$core$Maybe$Nothing))),
		model.eX);
};
var $author$project$Components$Parametrage$Utilisateurs$Update$suivant = function (attribution) {
	return _Utils_update(
		attribution,
		{
			HR: A2($elm$core$List$drop, 1, attribution.HR)
		});
};
var $author$project$I18n$Textes$utilisateursAnnonceEnvoyee = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'utilisateurs.annonce.envoyee',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$author$project$I18n$Traductions$Sous(p.yb))
			]),
		'Invitation envoyée à {email}.');
};
var $author$project$I18n$Textes$utilisateursAnnonceReactive = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'utilisateurs.annonce.reactive',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nom',
				$author$project$I18n$Traductions$Sous(p.Dj))
			]),
		'{nom} est réactivé.');
};
var $author$project$I18n$Textes$utilisateursAnnonceRenvoyee = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'utilisateurs.annonce.renvoyee',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$author$project$I18n$Traductions$Sous(p.yb))
			]),
		'Invitation renvoyée à {email} : nouveau lien valable 72 heures.');
};
var $author$project$I18n$Textes$utilisateursDepannageAnnonceReinitialisee = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'utilisateurs.depannage.annonce.reinitialisee',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nom',
				$author$project$I18n$Traductions$Sous(p.Dj))
			]),
		'Double authentification de {nom} réinitialisée.');
};
var $author$project$I18n$Textes$utilisateursDepannageAnnonceReinitialiseeEtFermees = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'utilisateurs.depannage.annonce.reinitialisee-et-fermees',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nom',
				$author$project$I18n$Traductions$Sous(p.Dj))
			]),
		'Double authentification de {nom} réinitialisée. Ses sessions ont été fermées.');
};
var $author$project$I18n$Textes$utilisateursDepannageAnnonceSessionsFermees = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'utilisateurs.depannage.annonce.sessions-fermees',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nom',
				$author$project$I18n$Traductions$Sous(p.Dj))
			]),
		'Sessions de {nom} fermées dans toute la suite Asria.');
};
var $author$project$I18n$Textes$utilisateursSecuriteAnnonceImposee = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'utilisateurs.securite.annonce.imposee',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nombre',
				$author$project$I18n$Traductions$Entier(p.w))
			]),
		'Double authentification imposée. {nombre, plural, one {# utilisateur devra l\'activer à sa prochaine connexion.} other {# utilisateurs devront l\'activer à leur prochaine connexion.}}');
};
var $author$project$I18n$Textes$utilisateursSecuriteAnnonceLevee = A3($author$project$I18n$Traductions$texte, 'utilisateurs.securite.annonce.levee', _List_Nil, 'Obligation de double authentification levée.');
var $author$project$Components$Parametrage$Utilisateurs$Model$saisieEnCours = function (model) {
	return A2(
		$elm$core$List$any,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$trim,
			A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not)),
		_List_fromArray(
			[model.hP.Gg, model.hP.Dj, model.hP.yb])) || (!$elm$core$List$isEmpty(model.hP.eX));
};
var $author$project$Components$Parametrage$Utilisateurs$Update$versLeDrawer = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{kX: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Parametrage$Utilisateurs$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: $author$project$Components$Parametrage$Utilisateurs$Model$saisieEnCours(model)
				},
				geste,
				model.kX));
	});
var $author$project$Components$Parametrage$Utilisateurs$Update$versLeDrawerDeLiaison = F2(
	function (geste, model) {
		return A3(
			$elm$core$Tuple$mapBoth,
			function (drawer) {
				return _Utils_update(
					model,
					{xO: drawer});
			},
			$elm$core$List$map(
				function (_v0) {
					var cible = _v0;
					return $author$project$Components$Parametrage$Utilisateurs$Update$PlacerFocus(cible);
				}),
			A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{
					Il: !_Utils_eq(model.ve, $elm$core$Maybe$Nothing)
				},
				geste,
				model.xO));
	});
var $author$project$Components$Parametrage$Utilisateurs$Update$conclure = F2(
	function (issue, model) {
		_v0$5:
		while (true) {
			switch (issue.$) {
				case 0:
					var commande = issue.a;
					var rendue = issue.b;
					var relectureDe = function (apres) {
						return rendue.sy ? $author$project$Components$Parametrage$Utilisateurs$Update$relire(apres) : _List_fromArray(
							[
								$author$project$Components$Parametrage$Utilisateurs$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
							]);
					};
					var relecture = relectureDe(model);
					var avecLesLiens = _Utils_update(
						model,
						{
							zo: A2(
								$elm$core$Maybe$map,
								function (fiche) {
									return _Utils_update(
										fiche,
										{nQ: rendue.nQ});
								},
								model.zo)
						});
					switch (commande.$) {
						case 0:
							var invitee = commande.a;
							var coches = A2(
								$elm$core$List$filter,
								function (role) {
									return A2($elm$core$List$member, role.Aq, model.hP.eX);
								},
								$author$project$Components$Parametrage$Utilisateurs$Model$rolesAttribuables(model));
							return A2(
								$elm$core$Tuple$mapSecond,
								function (effets) {
									return _Utils_ap(effets, relecture);
								},
								A2(
									$author$project$Components$Parametrage$Utilisateurs$Update$versLeDrawer,
									$author$project$Components$Shared$Drawer$Update$Fermer,
									_Utils_update(
										model,
										{
											tn: _Utils_ap(
												model.tn,
												_List_fromArray(
													[
														$author$project$I18n$Textes$utilisateursAnnonceEnvoyee(
														{
															yb: $author$project$I18n$Traductions$tel(invitee.yb)
														})
													])),
											i7: A2(
												$elm$core$Maybe$map,
												function (uid) {
													return {x3: _List_Nil, Dj: invitee.Gg + (' ' + invitee.Dj), HR: coches, fl: uid};
												},
												rendue.AV),
											pZ: $elm$core$Maybe$Nothing,
											hP: $author$project$Components$Parametrage$Utilisateurs$Model$init.hP
										})));
						case 1:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										i7: A2($elm$core$Maybe$map, $author$project$Components$Parametrage$Utilisateurs$Update$suivant, model.i7)
									}),
								_List_Nil);
						case 2:
							var utilisateur = commande.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										tn: _Utils_ap(
											model.tn,
											_List_fromArray(
												[
													$author$project$I18n$Textes$utilisateursAnnonceRenvoyee(
													{
														yb: $author$project$I18n$Traductions$tel(
															A2($author$project$Components$Parametrage$Utilisateurs$Update$courrielDe, utilisateur, model))
													})
												]))
									}),
								relecture);
						case 3:
							return _Utils_eq(model.vf, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(
								_Utils_update(
									model,
									{iq: $elm$core$Maybe$Nothing}),
								relecture) : _Utils_Tuple2(
								_Utils_update(
									model,
									{iq: $elm$core$Maybe$Nothing}),
								_List_fromArray(
									[
										$author$project$Components$Parametrage$Utilisateurs$Update$Naviguer($author$project$Routes$Route$adresseDesUtilisateurs)
									]));
						case 6:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										ip: _List_fromArray(
											[
												$author$project$Components$Parametrage$Utilisateurs$Update$annonceDuRetrait(model)
											]),
										iu: $elm$core$Maybe$Nothing
									}),
								_List_fromArray(
									[
										$author$project$Components$Parametrage$Utilisateurs$Update$Naviguer($author$project$Routes$Route$adresseDesUtilisateurs)
									]));
						case 5:
							return _Utils_Tuple2(
								_Utils_update(
									avecLesLiens,
									{
										tn: _List_fromArray(
											[
												$author$project$I18n$Textes$utilisateursAnnonceReactive(
												{
													Dj: $author$project$I18n$Traductions$tel(
														A2(
															$elm$core$Maybe$withDefault,
															'',
															A2(
																$elm$core$Maybe$map,
																function ($) {
																	return $.Dj;
																},
																model.zo)))
												})
											])
									}),
								relectureDe(avecLesLiens));
						case 7:
							return A2(
								$elm$core$Tuple$mapSecond,
								function (effets) {
									return _Utils_ap(
										effets,
										relectureDe(avecLesLiens));
								},
								A2(
									$author$project$Components$Parametrage$Utilisateurs$Update$versLeDrawerDeLiaison,
									$author$project$Components$Shared$Drawer$Update$Fermer,
									_Utils_update(
										avecLesLiens,
										{ve: $elm$core$Maybe$Nothing})));
						case 9:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										iu: $elm$core$Maybe$Nothing,
										tn: _List_fromArray(
											[
												$author$project$I18n$Textes$utilisateursSecuriteAnnonceImposee(
												{
													w: A2(
														$elm$core$Maybe$withDefault,
														0,
														A2(
															$elm$core$Maybe$map,
															function ($) {
																return $.JE;
															},
															model.q1))
												})
											])
									}),
								relecture);
						case 10:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										iu: $elm$core$Maybe$Nothing,
										tn: _List_fromArray(
											[$author$project$I18n$Textes$utilisateursSecuriteAnnonceLevee])
									}),
								relecture);
						case 11:
							var fermees = commande.b;
							return _Utils_Tuple2(
								_Utils_update(
									avecLesLiens,
									{
										iu: $elm$core$Maybe$Nothing,
										tn: _List_fromArray(
											[
												(fermees ? $author$project$I18n$Textes$utilisateursDepannageAnnonceReinitialiseeEtFermees : $author$project$I18n$Textes$utilisateursDepannageAnnonceReinitialisee)(
												{
													Dj: $author$project$I18n$Traductions$tel(
														$author$project$Components$Parametrage$Utilisateurs$Update$nomDeLaFiche(model))
												})
											]),
										BL: false
									}),
								relectureDe(avecLesLiens));
						case 12:
							return _Utils_Tuple2(
								_Utils_update(
									avecLesLiens,
									{iu: $elm$core$Maybe$Nothing, tn: _List_Nil, BL: true}),
								relectureDe(avecLesLiens));
						case 13:
							return _Utils_Tuple2(
								_Utils_update(
									avecLesLiens,
									{
										iu: $elm$core$Maybe$Nothing,
										tn: _List_fromArray(
											[
												$author$project$I18n$Textes$utilisateursDepannageAnnonceSessionsFermees(
												{
													Dj: $author$project$I18n$Traductions$tel(
														$author$project$Components$Parametrage$Utilisateurs$Update$nomDeLaFiche(model))
												})
											]),
										BL: false
									}),
								relectureDe(avecLesLiens));
						default:
							return _Utils_Tuple2(
								_Utils_update(
									avecLesLiens,
									{iu: $elm$core$Maybe$Nothing}),
								relectureDe(avecLesLiens));
					}
				case 1:
					switch (issue.a.$) {
						case 1:
							var _v2 = issue.a;
							return $author$project$Components$Parametrage$Utilisateurs$Update$attribuerLeSuivant(
								_Utils_update(
									model,
									{
										i7: A2($elm$core$Maybe$map, $author$project$Components$Parametrage$Utilisateurs$Update$echoue, model.i7)
									}));
						case 0:
							var erreur = issue.c;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										pZ: $elm$core$Maybe$Just(erreur)
									}),
								_List_Nil);
						case 12:
							if (issue.c === 4) {
								var _v3 = issue.c;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											iu: $elm$core$Maybe$Nothing,
											pZ: $elm$core$Maybe$Just(11)
										}),
									$author$project$Components$Parametrage$Utilisateurs$Update$relire(model));
							} else {
								break _v0$5;
							}
						case 7:
							var _v4 = issue.a;
							var erreur = issue.c;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										ve: $elm$core$Maybe$Nothing,
										pZ: $elm$core$Maybe$Just(erreur)
									}),
								$author$project$Components$Parametrage$Utilisateurs$Update$chercher(model));
						default:
							break _v0$5;
					}
				default:
					return _Utils_Tuple2(model, _List_Nil);
			}
		}
		var erreur = issue.c;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					iq: $elm$core$Maybe$Nothing,
					iu: $elm$core$Maybe$Nothing,
					pZ: $elm$core$Maybe$Just(erreur)
				}),
			$author$project$Components$Parametrage$Utilisateurs$Update$relire(model));
	});
var $author$project$API$NavLinksDictionary$delierLaFicheCollaborateur = 'delier-la-fiche-collaborateur';
var $author$project$API$NavLinksDictionary$desactiverUnUtilisateur = 'desactiver-un-utilisateur';
var $author$project$Components$Parametrage$Utilisateurs$Update$enLecture = F2(
	function (changer, journal) {
		return changer(
			_Utils_update(
				journal,
				{ms: $author$project$Components$Parametrage$Utilisateurs$Model$PasDExport, B0: $elm$core$Maybe$Nothing}));
	});
var $author$project$API$NavLinksDictionary$envoyerUneReinitialisationDuMotDePasse = 'envoyer-une-reinitialisation-du-mot-de-passe';
var $author$project$Components$Parametrage$Utilisateurs$Model$codeDeLEtat = function (etat) {
	switch (etat) {
		case 0:
			return 'Actif';
		case 1:
			return 'Desactive';
		case 2:
			return 'InvitationEnvoyee';
		default:
			return 'Expiree';
	}
};
var $author$project$Components$Parametrage$Utilisateurs$Model$etatDuCode = function (code) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$Parametrage$Utilisateurs$Model$codeDeLEtat,
				$elm$core$Basics$eq(code)),
			_List_fromArray(
				[0, 1, 2, 3])));
};
var $author$project$API$NavLinksDictionary$exporterLesConnexions = 'exporter-les-connexions';
var $author$project$Components$Parametrage$Utilisateurs$Model$siRempli = F2(
	function (nom, valeur) {
		return $elm$core$String$isEmpty(valeur) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A2($elm$url$Url$Builder$string, nom, valeur));
	});
var $author$project$Components$Parametrage$Utilisateurs$Model$filtresDuJournal = function (journal) {
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$map,
				$elm$url$Url$Builder$string('utilisateur'),
				journal.fl),
				A2($author$project$Components$Parametrage$Utilisateurs$Model$siRempli, 'du', journal.cE),
				A2($author$project$Components$Parametrage$Utilisateurs$Model$siRempli, 'au', journal.cm),
				A2(
				$author$project$Components$Parametrage$Utilisateurs$Model$siRempli,
				'recherche',
				$elm$core$String$trim(journal.hC))
			]));
};
var $author$project$Components$Parametrage$Utilisateurs$Model$lienDeLExport = function (journal) {
	return A2(
		$elm$core$Maybe$map,
		function (lien) {
			return _Utils_update(
				lien,
				{
					cM: _Utils_ap(
						lien.cM,
						$elm$url$Url$Builder$toQuery(
							$author$project$Components$Parametrage$Utilisateurs$Model$filtresDuJournal(journal)))
				});
		},
		A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$exporterLesConnexions)),
			journal.B0));
};
var $author$project$Components$Parametrage$Utilisateurs$Model$plafondDExport = 5000;
var $author$project$Components$Parametrage$Utilisateurs$Model$exportPossible = function (journal) {
	var _v0 = _Utils_Tuple2(journal.B0, journal.ms);
	_v0$0:
	while (true) {
		if (!_v0.a.$) {
			if (_v0.b.$ === 1) {
				break _v0$0;
			} else {
				var lu = _v0.a.a;
				return (lu.JE > 0) && ((_Utils_cmp(lu.JE, $author$project$Components$Parametrage$Utilisateurs$Model$plafondDExport) < 1) && (!_Utils_eq(
					$author$project$Components$Parametrage$Utilisateurs$Model$lienDeLExport(journal),
					$elm$core$Maybe$Nothing)));
			}
		} else {
			if (_v0.b.$ === 1) {
				break _v0$0;
			} else {
				var _v2 = _v0.a;
				return false;
			}
		}
	}
	var _v1 = _v0.b;
	return false;
};
var $author$project$API$NavLinksDictionary$fermerLesSessions = 'fermer-les-sessions';
var $author$project$Components$Parametrage$Utilisateurs$Update$filtrer = F2(
	function (changer, model) {
		return _Utils_update(
			model,
			{
				mG: changer(model.mG)
			});
	});
var $author$project$Components$Parametrage$Utilisateurs$Update$LeJournal = 2;
var $author$project$Components$Parametrage$Utilisateurs$Model$lienDuJournal = function (journal) {
	return A2(
		$elm$core$Maybe$map,
		function (lien) {
			return _Utils_update(
				lien,
				{
					cM: _Utils_ap(
						lien.cM,
						$elm$url$Url$Builder$toQuery(
							_Utils_ap(
								$author$project$Components$Parametrage$Utilisateurs$Model$filtresDuJournal(journal),
								_List_fromArray(
									[
										A2($elm$url$Url$Builder$int, 'page', journal.EE),
										A2($elm$url$Url$Builder$int, 'taille', 50)
									]))))
				});
		},
		journal.nB);
};
var $author$project$Components$Parametrage$Utilisateurs$Update$lireLeJournal = function (journal) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$Parametrage$Utilisateurs$Update$Lire(2),
				$elm$core$List$singleton),
			$author$project$Components$Parametrage$Utilisateurs$Model$lienDuJournal(journal)));
};
var $author$project$Components$Parametrage$Utilisateurs$Update$lireLaPage = function (model) {
	return _Utils_Tuple2(
		model,
		$author$project$Components$Parametrage$Utilisateurs$Update$lireLeJournal(model.a$));
};
var $author$project$Components$Parametrage$Utilisateurs$Update$filtrerLeJournal = F2(
	function (changer, model) {
		return $author$project$Components$Parametrage$Utilisateurs$Update$lireLaPage(
			_Utils_update(
				model,
				{
					a$: A2(
						$author$project$Components$Parametrage$Utilisateurs$Update$enLecture,
						A2(
							$elm$core$Basics$composeR,
							changer,
							function (j) {
								return _Utils_update(
									j,
									{EE: 1});
							}),
						model.a$)
				}));
	});
var $author$project$Components$Parametrage$Utilisateurs$Model$idsDeLaConfirmation = {j7: 'utilisateurs-annulation-confirmer', z7: 'utilisateurs-annulation-garder', Cs: 'utilisateurs-annulation-message', GN: 'utilisateurs-annulation', h6: 'utilisateurs-annulation-titre'};
var $author$project$Components$Parametrage$Utilisateurs$Model$idsDuGeste = {j7: 'utilisateur-geste-confirmer', z7: 'utilisateur-geste-garder', Cs: 'utilisateur-geste-message', GN: 'utilisateur-geste', h6: 'utilisateur-geste-titre'};
var $author$project$API$NavLinksDictionary$imposerLaDoubleAuthentification = 'imposer-la-double-authentification';
var $author$project$API$NavLinksDictionary$journalDesConnexions = 'journal-des-connexions';
var $author$project$Components$Parametrage$Utilisateurs$Update$journalDeLaRacine = F2(
	function (liens, journal) {
		return _Utils_update(
			journal,
			{
				nB: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$journalDesConnexions, liens),
				Es: false
			});
	});
var $author$project$Components$Parametrage$Utilisateurs$Model$journalFiltre = F2(
	function (utilisateur, journal) {
		return _Utils_update(
			journal,
			{cm: '', cE: '', ms: $author$project$Components$Parametrage$Utilisateurs$Model$PasDExport, B0: $elm$core$Maybe$Nothing, Es: true, EE: 1, hC: '', fl: utilisateur});
	});
var $author$project$API$NavLinksDictionary$leverLaDoubleAuthentification = 'lever-la-double-authentification';
var $author$project$API$NavLinksDictionary$inviterUnUtilisateur = 'inviter-un-utilisateur';
var $author$project$Components$Parametrage$Utilisateurs$Model$lienDeLInvitation = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.nQ;
			},
			$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$inviterUnUtilisateur)),
		model.aS);
};
var $author$project$Components$Parametrage$Utilisateurs$Update$lienDeLOnglet = F2(
	function (rel, model) {
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				$author$project$API$Liens$trouver(rel)),
			model.q1);
	});
var $author$project$API$NavLinksDictionary$utilisateurs = 'utilisateurs';
var $author$project$Components$Parametrage$Utilisateurs$Model$lienDeLaLecture = $author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$utilisateurs);
var $author$project$API$NavLinksDictionary$securiteDesUtilisateurs = 'securite-des-utilisateurs';
var $author$project$Components$Parametrage$Utilisateurs$Model$lienDeLaLectureDeLaSecurite = $author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$securiteDesUtilisateurs);
var $author$project$API$NavLinksDictionary$invitations = 'invitations';
var $author$project$Components$Parametrage$Utilisateurs$Model$lienDeLaLectureDesInvitations = $author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$invitations);
var $author$project$Components$Parametrage$Utilisateurs$Model$lienDeLaLectureDesRoles = $author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$rolesInternes);
var $author$project$API$NavLinksDictionary$lierUneFicheCollaborateur = 'lier-une-fiche-collaborateur';
var $author$project$Components$Parametrage$Utilisateurs$Model$Exporte = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Parametrage$Utilisateurs$Update$LesDernieresConnexions = 4;
var $author$project$Components$Parametrage$Utilisateurs$Update$Telecharger = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Model$TropVolumineux = {$: 3};
var $author$project$API$NavLinksDictionary$dernieresConnexions = 'dernieres-connexions';
var $author$project$Components$Parametrage$Utilisateurs$Model$ligneDeLaCible = function (model) {
	var _v0 = _Utils_Tuple2(model.vf, model.aS);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var uid = _v0.a.a;
		var annuaire = _v0.b.a;
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.fl;
					},
					$elm$core$Basics$eq(uid)),
				annuaire.Kf));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$Utilisateurs$Update$pasLue = F2(
	function (refus, model) {
		return _Utils_Tuple2(
			(refus.ri === 403) ? _Utils_update(
				model,
				{aS: $elm$core$Maybe$Nothing, qa: true}) : model,
			(refus.ri === 401) ? _List_fromArray(
				[$author$project$Components$Parametrage$Utilisateurs$Update$Reconnecter]) : _List_Nil);
	});
var $author$project$Components$Parametrage$Utilisateurs$Update$lue = F3(
	function (lecture, reponse, model) {
		switch (lecture) {
			case 0:
				var _v1 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$annuaireDecoder, reponse);
				if (!_v1.$) {
					var annuaire = _v1.a;
					var lu = _Utils_update(
						model,
						{
							aS: $elm$core$Maybe$Just(annuaire)
						});
					var _v2 = _Utils_Tuple2(model.vf, model.zo);
					if ((!_v2.a.$) && (_v2.b.$ === 1)) {
						var _v3 = _v2.b;
						var _v4 = A2(
							$elm$core$Maybe$andThen,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.nQ;
								},
								$author$project$API$Liens$trouver('self')),
							$author$project$Components$Parametrage$Utilisateurs$Model$ligneDeLaCible(lu));
						if (!_v4.$) {
							var soi = _v4.a;
							return _Utils_Tuple2(
								lu,
								_List_fromArray(
									[
										A2($author$project$Components$Parametrage$Utilisateurs$Update$Lire, 1, soi)
									]));
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									lu,
									{nf: true}),
								_List_Nil);
						}
					} else {
						return _Utils_Tuple2(lu, _List_Nil);
					}
				} else {
					var refus = _v1.a;
					return A2($author$project$Components$Parametrage$Utilisateurs$Update$pasLue, refus, model);
				}
			case 1:
				var _v5 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$ficheDecoder, reponse);
				if (!_v5.$) {
					var fiche = _v5.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								zo: $elm$core$Maybe$Just(fiche)
							}),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Components$Parametrage$Utilisateurs$Update$Lire(4),
									$elm$core$List$singleton),
								A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$dernieresConnexions, fiche.nQ))));
				} else {
					var refus = _v5.a;
					return A2($author$project$Components$Parametrage$Utilisateurs$Update$pasLue, refus, model);
				}
			case 2:
				var _v6 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$journalDesConnexionsDecoder, reponse);
				if (!_v6.$) {
					var lu = _v6.a;
					var journal = model.a$;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a$: _Utils_update(
									journal,
									{
										B0: $elm$core$Maybe$Just(lu)
									})
							}),
						_List_Nil);
				} else {
					var refus = _v6.a;
					return A2($author$project$Components$Parametrage$Utilisateurs$Update$pasLue, refus, model);
				}
			case 4:
				var _v7 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$journalDesConnexionsDecoder, reponse);
				if (!_v7.$) {
					var lues = _v7.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								xm: $elm$core$Maybe$Just(lues)
							}),
						_List_Nil);
				} else {
					var refus = _v7.a;
					return A2($author$project$Components$Parametrage$Utilisateurs$Update$pasLue, refus, model);
				}
			case 3:
				var journal = model.a$;
				var _v8 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$exportDesConnexionsDecoder, reponse);
				if (!_v8.$) {
					var _export = _v8.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a$: _Utils_update(
									journal,
									{
										ms: A2($author$project$Components$Parametrage$Utilisateurs$Model$Exporte, _export.gw.Dj, _export.gV)
									})
							}),
						_List_fromArray(
							[
								$author$project$Components$Parametrage$Utilisateurs$Update$Telecharger(_export.gw)
							]));
				} else {
					var refus = _v8.a;
					return $author$project$Components$Parametrage$Utilisateurs$Update$tropVolumineux(reponse) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a$: _Utils_update(
									journal,
									{ms: $author$project$Components$Parametrage$Utilisateurs$Model$TropVolumineux})
							}),
						_List_Nil) : A2(
						$author$project$Components$Parametrage$Utilisateurs$Update$pasLue,
						refus,
						_Utils_update(
							model,
							{
								a$: _Utils_update(
									journal,
									{ms: $author$project$Components$Parametrage$Utilisateurs$Model$PasDExport})
							}));
				}
			case 5:
				var _v9 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$fichesProposeesDecoder, reponse);
				if (!_v9.$) {
					var proposees = _v9.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								pE: $elm$core$Maybe$Just(proposees)
							}),
						_List_Nil);
				} else {
					var refus = _v9.a;
					return A2($author$project$Components$Parametrage$Utilisateurs$Update$pasLue, refus, model);
				}
			case 6:
				var _v10 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$invitationsDecoder, reponse);
				if (!_v10.$) {
					var invitations = _v10.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								AU: $elm$core$Maybe$Just(invitations)
							}),
						_List_Nil);
				} else {
					var refus = _v10.a;
					return A2($author$project$Components$Parametrage$Utilisateurs$Update$pasLue, refus, model);
				}
			case 7:
				var _v11 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$rolesDecoder, reponse);
				if (!_v11.$) {
					var roles = _v11.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{eX: roles}),
						_List_Nil);
				} else {
					var refus = _v11.a;
					return A2($author$project$Components$Parametrage$Utilisateurs$Update$pasLue, refus, model);
				}
			default:
				var _v12 = A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Utilisateurs$API$QueryAPIModel$securiteDeLEspaceDecoder, reponse);
				if (!_v12.$) {
					var securite = _v12.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								q1: $elm$core$Maybe$Just(securite)
							}),
						_List_Nil);
				} else {
					var refus = _v12.a;
					return _Utils_eq(model.vf, $elm$core$Maybe$Nothing) ? A2($author$project$Components$Parametrage$Utilisateurs$Update$pasLue, refus, model) : _Utils_Tuple2(
						model,
						(refus.ri === 401) ? _List_fromArray(
							[$author$project$Components$Parametrage$Utilisateurs$Update$Reconnecter]) : _List_Nil);
				}
		}
	});
var $author$project$Components$Parametrage$Utilisateurs$Model$personne = function (saisie) {
	var lus = {
		yb: $elm$core$String$trim(saisie.yb),
		nn: saisie.nn,
		Dj: $elm$core$String$trim(saisie.Dj),
		Gg: $elm$core$String$trim(saisie.Gg)
	};
	return A2(
		$elm$core$List$any,
		$elm$core$String$isEmpty,
		_List_fromArray(
			[lus.Gg, lus.Dj, lus.yb])) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(lus);
};
var $author$project$API$NavLinksDictionary$reactiverUnUtilisateur = 'reactiver-un-utilisateur';
var $author$project$API$NavLinksDictionary$reinitialiserLaDoubleAuthentification = 'reinitialiser-la-double-authentification';
var $author$project$API$NavLinksDictionary$renvoyerUneInvitation = 'renvoyer-une-invitation';
var $author$project$API$NavLinksDictionary$retirerUnUtilisateur = 'retirer-un-utilisateur';
var $author$project$Components$Parametrage$Utilisateurs$Update$saisir = F2(
	function (changer, model) {
		return _Utils_update(
			model,
			{
				hP: changer(model.hP)
			});
	});
var $author$project$Components$Parametrage$Utilisateurs$Update$siLibre = F2(
	function (model, geste) {
		return $author$project$API$Envoi$enCours(model.l2) ? _Utils_Tuple2(model, _List_Nil) : geste(model);
	});
var $author$project$Components$Parametrage$Utilisateurs$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var liens = msg.a;
				var nomDuClient = msg.b;
				var _v1 = $author$project$Components$Parametrage$Utilisateurs$Model$lienDeLaLecture(liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					var roles = $author$project$Components$Parametrage$Utilisateurs$Model$lienDeLaLectureDesRoles(liens);
					var invitations = $author$project$Components$Parametrage$Utilisateurs$Model$lienDeLaLectureDesInvitations(liens);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ip: _List_Nil,
								tn: model.ip,
								vf: $elm$core$Maybe$Nothing,
								zo: $elm$core$Maybe$Nothing,
								a$: A2($author$project$Components$Parametrage$Utilisateurs$Update$journalDeLaRacine, liens, model.a$),
								np: $elm$core$Maybe$Just(lecture),
								nr: $author$project$Components$Parametrage$Utilisateurs$Model$lienDeLaLectureDeLaSecurite(liens),
								nu: invitations,
								nw: roles,
								g5: nomDuClient,
								oZ: 0,
								pZ: $elm$core$Maybe$Nothing,
								qa: false
							}),
						A2(
							$elm$core$List$cons,
							$author$project$Components$Parametrage$Utilisateurs$Update$DemanderProcessUid,
							A2(
								$elm$core$List$cons,
								A2($author$project$Components$Parametrage$Utilisateurs$Update$Lire, 0, lecture),
								A2(
									$elm$core$List$filterMap,
									$elm$core$Basics$identity,
									_List_fromArray(
										[
											A2(
											$elm$core$Maybe$map,
											$author$project$Components$Parametrage$Utilisateurs$Update$Lire(6),
											invitations),
											A2(
											$elm$core$Maybe$map,
											$author$project$Components$Parametrage$Utilisateurs$Update$Lire(7),
											roles)
										])))));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aS: $elm$core$Maybe$Nothing, np: $elm$core$Maybe$Nothing, qa: true}),
						_List_Nil);
				}
			case 1:
				var uid = msg.a;
				var liens = msg.b;
				var nomDuClient = msg.c;
				var _v2 = $author$project$Components$Parametrage$Utilisateurs$Model$lienDeLaLecture(liens);
				if (!_v2.$) {
					var lecture = _v2.a;
					var securite = $author$project$Components$Parametrage$Utilisateurs$Model$lienDeLaLectureDeLaSecurite(liens);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								tn: _List_Nil,
								vf: $elm$core$Maybe$Just(uid),
								xm: $elm$core$Maybe$Nothing,
								zo: $elm$core$Maybe$Nothing,
								nf: false,
								a$: A2($author$project$Components$Parametrage$Utilisateurs$Update$journalDeLaRacine, liens, model.a$),
								np: $elm$core$Maybe$Just(lecture),
								nr: securite,
								BL: false,
								g5: nomDuClient,
								pZ: $elm$core$Maybe$Nothing,
								qa: false,
								q1: $elm$core$Maybe$Nothing
							}),
						_List_fromArray(
							[
								$author$project$Components$Parametrage$Utilisateurs$Update$DemanderProcessUid,
								A2($author$project$Components$Parametrage$Utilisateurs$Update$Lire, 0, lecture)
							]));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								vf: $elm$core$Maybe$Just(uid),
								zo: $elm$core$Maybe$Nothing,
								np: $elm$core$Maybe$Nothing,
								qa: true
							}),
						_List_Nil);
				}
			case 2:
				var utilisateur = msg.a;
				var liens = msg.b;
				var nomDuClient = msg.c;
				var journal = A2(
					$author$project$Components$Parametrage$Utilisateurs$Model$journalFiltre,
					utilisateur,
					A2($author$project$Components$Parametrage$Utilisateurs$Update$journalDeLaRacine, liens, model.a$));
				var ouvert = _Utils_update(
					model,
					{
						tn: _List_Nil,
						vf: $elm$core$Maybe$Nothing,
						zo: $elm$core$Maybe$Nothing,
						a$: journal,
						np: $author$project$Components$Parametrage$Utilisateurs$Model$lienDeLaLecture(liens),
						nr: $author$project$Components$Parametrage$Utilisateurs$Model$lienDeLaLectureDeLaSecurite(liens),
						g5: nomDuClient,
						oZ: 0,
						pZ: $elm$core$Maybe$Nothing
					});
				var _v3 = _Utils_Tuple2(journal.nB, ouvert.np);
				if ((!_v3.a.$) && (!_v3.b.$)) {
					var lecture = _v3.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							ouvert,
							{qa: false}),
						A2(
							$elm$core$List$cons,
							A2($author$project$Components$Parametrage$Utilisateurs$Update$Lire, 0, lecture),
							$author$project$Components$Parametrage$Utilisateurs$Update$lireLeJournal(journal)));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							ouvert,
							{qa: true}),
						_List_Nil);
				}
			case 3:
				var liens = msg.a;
				var nomDuClient = msg.b;
				var ouverte = _Utils_update(
					model,
					{
						tn: _List_Nil,
						vf: $elm$core$Maybe$Nothing,
						zo: $elm$core$Maybe$Nothing,
						a$: A2($author$project$Components$Parametrage$Utilisateurs$Update$journalDeLaRacine, liens, model.a$),
						np: $author$project$Components$Parametrage$Utilisateurs$Model$lienDeLaLecture(liens),
						nr: $author$project$Components$Parametrage$Utilisateurs$Model$lienDeLaLectureDeLaSecurite(liens),
						g5: nomDuClient,
						oZ: 1,
						pZ: $elm$core$Maybe$Nothing,
						q1: $elm$core$Maybe$Nothing
					});
				var _v4 = ouverte.nr;
				if (!_v4.$) {
					var lecture = _v4.a;
					return _Utils_Tuple2(
						_Utils_update(
							ouverte,
							{qa: false}),
						_List_fromArray(
							[
								$author$project$Components$Parametrage$Utilisateurs$Update$DemanderProcessUid,
								A2($author$project$Components$Parametrage$Utilisateurs$Update$Lire, 8, lecture)
							]));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							ouverte,
							{qa: true}),
						_List_Nil);
				}
			case 4:
				var octets = msg.a;
				return $author$project$Components$Parametrage$Utilisateurs$Update$attribuerLeSuivant(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}));
			case 5:
				var lecture = msg.a;
				var reponse = msg.b;
				return A3($author$project$Components$Parametrage$Utilisateurs$Update$lue, lecture, reponse, model);
			case 6:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Parametrage$Utilisateurs$Update$relire(model));
			case 7:
				var geste = msg.a;
				return A2(
					$author$project$Components$Parametrage$Utilisateurs$Update$siLibre,
					model,
					$author$project$Components$Parametrage$Utilisateurs$Update$versLeDrawer(geste));
			case 8:
				return A2(
					$author$project$Components$Parametrage$Utilisateurs$Update$versLeDrawer,
					$author$project$Components$Shared$Drawer$Update$Ouvrir('utilisateurs-inviter-ouvrir'),
					_Utils_update(
						model,
						{pZ: $elm$core$Maybe$Nothing, hP: $author$project$Components$Parametrage$Utilisateurs$Model$init.hP}));
			case 9:
				var prenom = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$Utilisateurs$Update$saisir,
						function (s) {
							return _Utils_update(
								s,
								{Gg: prenom});
						},
						model),
					_List_Nil);
			case 10:
				var nom = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$Utilisateurs$Update$saisir,
						function (s) {
							return _Utils_update(
								s,
								{Dj: nom});
						},
						model),
					_List_Nil);
			case 11:
				var email = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$Utilisateurs$Update$saisir,
						function (s) {
							return _Utils_update(
								s,
								{yb: email});
						},
						_Utils_update(
							model,
							{pZ: $elm$core$Maybe$Nothing})),
					_List_Nil);
			case 12:
				var role = msg.a;
				var coche = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$Utilisateurs$Update$saisir,
						function (s) {
							return _Utils_update(
								s,
								{
									eX: _Utils_ap(
										A2(
											$elm$core$List$filter,
											$elm$core$Basics$neq(role),
											s.eX),
										coche ? _List_fromArray(
											[role]) : _List_Nil)
								});
						},
						model),
					_List_Nil);
			case 13:
				var langue = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$Utilisateurs$Update$saisir,
						function (s) {
							return _Utils_update(
								s,
								{nn: langue});
						},
						model),
					_List_Nil);
			case 14:
				var _v5 = $author$project$Components$Parametrage$Utilisateurs$Model$personne(model.hP);
				if (!_v5.$) {
					var invitee = _v5.a;
					return A3(
						$author$project$Components$Parametrage$Utilisateurs$Update$envoyer,
						$author$project$Components$Parametrage$Utilisateurs$Model$lienDeLInvitation(model),
						$author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$Inviter(invitee),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 17:
				var geste = msg.a;
				return A2(
					$author$project$Components$Parametrage$Utilisateurs$Update$siLibre,
					model,
					function (libre) {
						return _Utils_Tuple2(
							_Utils_update(
								libre,
								{
									iu: $elm$core$Maybe$Just(geste),
									zl: true,
									pZ: $elm$core$Maybe$Nothing
								}),
							_List_fromArray(
								[
									$author$project$Components$Parametrage$Utilisateurs$Update$PlacerFocus($author$project$Components$Parametrage$Utilisateurs$Model$idsDuGeste.z7)
								]));
					});
			case 20:
				var fermer = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{zl: fermer}),
					_List_Nil);
			case 18:
				return A2(
					$author$project$Components$Parametrage$Utilisateurs$Update$siLibre,
					model,
					function (libre) {
						return _Utils_Tuple2(
							_Utils_update(
								libre,
								{iu: $elm$core$Maybe$Nothing}),
							_List_Nil);
					});
			case 19:
				var _v6 = _Utils_Tuple2(model.iu, model.zo);
				_v6$7:
				while (true) {
					if (!_v6.a.$) {
						switch (_v6.a.a) {
							case 0:
								if (!_v6.b.$) {
									var _v7 = _v6.a.a;
									var fiche = _v6.b.a;
									return A3(
										$author$project$Components$Parametrage$Utilisateurs$Update$envoyer,
										A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$desactiverUnUtilisateur, fiche.nQ),
										$author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$Desactiver(fiche.fl),
										model);
								} else {
									break _v6$7;
								}
							case 1:
								if (!_v6.b.$) {
									var _v8 = _v6.a.a;
									var fiche = _v6.b.a;
									return A3(
										$author$project$Components$Parametrage$Utilisateurs$Update$envoyer,
										A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerUnUtilisateur, fiche.nQ),
										$author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$Retirer(fiche.fl),
										model);
								} else {
									break _v6$7;
								}
							case 2:
								var _v9 = _v6.a.a;
								return A3(
									$author$project$Components$Parametrage$Utilisateurs$Update$envoyer,
									A2($author$project$Components$Parametrage$Utilisateurs$Update$lienDeLOnglet, $author$project$API$NavLinksDictionary$imposerLaDoubleAuthentification, model),
									$author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$ImposerLaDoubleAuthentification,
									model);
							case 3:
								var _v10 = _v6.a.a;
								return A3(
									$author$project$Components$Parametrage$Utilisateurs$Update$envoyer,
									A2($author$project$Components$Parametrage$Utilisateurs$Update$lienDeLOnglet, $author$project$API$NavLinksDictionary$leverLaDoubleAuthentification, model),
									$author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$LeverLaDoubleAuthentification,
									model);
							case 4:
								if (!_v6.b.$) {
									var _v11 = _v6.a.a;
									var fiche = _v6.b.a;
									return A3(
										$author$project$Components$Parametrage$Utilisateurs$Update$envoyer,
										A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reinitialiserLaDoubleAuthentification, fiche.nQ),
										A2($author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$ReinitialiserLaDoubleAuthentification, fiche.fl, model.zl),
										model);
								} else {
									break _v6$7;
								}
							case 5:
								if (!_v6.b.$) {
									var _v12 = _v6.a.a;
									var fiche = _v6.b.a;
									return A3(
										$author$project$Components$Parametrage$Utilisateurs$Update$envoyer,
										A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$envoyerUneReinitialisationDuMotDePasse, fiche.nQ),
										$author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$EnvoyerUneReinitialisationDuMotDePasse(fiche.fl),
										model);
								} else {
									break _v6$7;
								}
							default:
								if (!_v6.b.$) {
									var _v13 = _v6.a.a;
									var fiche = _v6.b.a;
									return A3(
										$author$project$Components$Parametrage$Utilisateurs$Update$envoyer,
										A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$fermerLesSessions, fiche.nQ),
										$author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$FermerLesSessions(fiche.fl),
										model);
								} else {
									break _v6$7;
								}
						}
					} else {
						break _v6$7;
					}
				}
				return _Utils_Tuple2(model, _List_Nil);
			case 21:
				var _v14 = model.zo;
				if (!_v14.$) {
					var fiche = _v14.a;
					return A3(
						$author$project$Components$Parametrage$Utilisateurs$Update$envoyer,
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reactiverUnUtilisateur, fiche.nQ),
						$author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$Reactiver(fiche.fl),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 22:
				return A2(
					$author$project$Components$Parametrage$Utilisateurs$Update$siLibre,
					model,
					function (libre) {
						var ouvert = _Utils_update(
							libre,
							{ve: $elm$core$Maybe$Nothing, pE: $elm$core$Maybe$Nothing, hC: '', pZ: $elm$core$Maybe$Nothing});
						return A2(
							$elm$core$Tuple$mapSecond,
							function (effets) {
								return _Utils_ap(
									effets,
									$author$project$Components$Parametrage$Utilisateurs$Update$chercher(ouvert));
							},
							A2(
								$author$project$Components$Parametrage$Utilisateurs$Update$versLeDrawerDeLiaison,
								$author$project$Components$Shared$Drawer$Update$Ouvrir('utilisateur-lier-ouvrir'),
								ouvert));
					});
			case 23:
				var geste = msg.a;
				return A2(
					$author$project$Components$Parametrage$Utilisateurs$Update$siLibre,
					model,
					$author$project$Components$Parametrage$Utilisateurs$Update$versLeDrawerDeLiaison(geste));
			case 24:
				var texte = msg.a;
				var saisi = _Utils_update(
					model,
					{ve: $elm$core$Maybe$Nothing, hC: texte});
				return _Utils_Tuple2(
					saisi,
					$author$project$Components$Parametrage$Utilisateurs$Update$chercher(saisi));
			case 25:
				var fiche = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Components$Parametrage$Utilisateurs$Model$choisir, fiche, model),
					_List_Nil);
			case 26:
				var _v15 = _Utils_Tuple2(model.zo, model.ve);
				if ((!_v15.a.$) && (!_v15.b.$)) {
					var fiche = _v15.a.a;
					var choisie = _v15.b.a;
					return A3(
						$author$project$Components$Parametrage$Utilisateurs$Update$envoyer,
						A2(
							$elm$core$Maybe$andThen,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.nQ;
								},
								$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$lierUneFicheCollaborateur)),
							model.pE),
						A2($author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$LierUneFiche, fiche.fl, choisie),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 27:
				var _v16 = model.zo;
				if (!_v16.$) {
					var fiche = _v16.a;
					return A3(
						$author$project$Components$Parametrage$Utilisateurs$Update$envoyer,
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$delierLaFicheCollaborateur, fiche.nQ),
						$author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$DelierLaFiche(fiche.fl),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 15:
				var invitation = msg.a;
				return A3(
					$author$project$Components$Parametrage$Utilisateurs$Update$envoyer,
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$renvoyerUneInvitation, invitation.nQ),
					$author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$Renvoyer(invitation.fl),
					model);
			case 16:
				var invitation = msg.a;
				return A2(
					$author$project$Components$Parametrage$Utilisateurs$Update$siLibre,
					model,
					function (libre) {
						return _Utils_Tuple2(
							_Utils_update(
								libre,
								{
									iq: $elm$core$Maybe$Just(invitation),
									pZ: $elm$core$Maybe$Nothing
								}),
							_List_fromArray(
								[
									$author$project$Components$Parametrage$Utilisateurs$Update$PlacerFocus($author$project$Components$Parametrage$Utilisateurs$Model$idsDeLaConfirmation.z7)
								]));
					});
			case 28:
				return A2(
					$author$project$Components$Parametrage$Utilisateurs$Update$siLibre,
					model,
					function (libre) {
						return _Utils_Tuple2(
							_Utils_update(
								libre,
								{iq: $elm$core$Maybe$Nothing}),
							_List_Nil);
					});
			case 29:
				var _v17 = model.iq;
				if (!_v17.$) {
					var invitation = _v17.a;
					return A3(
						$author$project$Components$Parametrage$Utilisateurs$Update$envoyer,
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$annulerUneInvitation, invitation.nQ),
						$author$project$Components$Parametrage$Utilisateurs$API$WriteAPIModel$Annuler(invitation.fl),
						model);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 30:
				var reponse = msg.a;
				var _v18 = A3($author$project$API$Envoi$conclure, $author$project$Components$Parametrage$Utilisateurs$Update$reglage, reponse, model.l2);
				if (!_v18.$) {
					var _v19 = _v18.a;
					var envoi = _v19.a;
					var issue = _v19.b;
					var effets = _v19.c;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Basics$append(effets),
						A2(
							$author$project$Components$Parametrage$Utilisateurs$Update$conclure,
							issue,
							_Utils_update(
								model,
								{l2: envoi})));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 31:
				var cible = msg.a;
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[
							$author$project$Components$Parametrage$Utilisateurs$Update$PlacerFocus(cible)
						]));
			case 32:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$Utilisateurs$Update$filtrer,
						function (f) {
							return _Utils_update(
								f,
								{
									gt: $author$project$Components$Parametrage$Utilisateurs$Model$etatDuCode(code)
								});
						},
						model),
					_List_Nil);
			case 33:
				var role = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$Utilisateurs$Update$filtrer,
						function (f) {
							return _Utils_update(
								f,
								{
									bi: $elm$core$String$isEmpty(role) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(role)
								});
						},
						model),
					_List_Nil);
			case 34:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$Utilisateurs$Update$filtrer,
						function (f) {
							return _Utils_update(
								f,
								{
									kV: function () {
										switch (code) {
											case 'activee':
												return $elm$core$Maybe$Just(true);
											case 'non-activee':
												return $elm$core$Maybe$Just(false);
											default:
												return $elm$core$Maybe$Nothing;
										}
									}()
								});
						},
						model),
					_List_Nil);
			case 35:
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$Utilisateurs$Update$filtrer,
						function (f) {
							return _Utils_update(
								f,
								{gt: $elm$core$Maybe$Nothing});
						},
						model),
					_List_Nil);
			case 36:
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$Utilisateurs$Update$filtrer,
						function (f) {
							return _Utils_update(
								f,
								{bi: $elm$core$Maybe$Nothing});
						},
						model),
					_List_Nil);
			case 37:
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Parametrage$Utilisateurs$Update$filtrer,
						function (f) {
							return _Utils_update(
								f,
								{kV: $elm$core$Maybe$Nothing});
						},
						model),
					_List_Nil);
			case 38:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{mG: $author$project$Components$Parametrage$Utilisateurs$Model$filtresVides}),
					_List_Nil);
			case 39:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Parametrage$Utilisateurs$Update$relire(model));
			case 40:
				var uid = msg.a;
				return A2(
					$author$project$Components$Parametrage$Utilisateurs$Update$filtrerLeJournal,
					function (j) {
						return _Utils_update(
							j,
							{
								fl: $elm$core$String$isEmpty(uid) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(uid)
							});
					},
					model);
			case 41:
				var jour = msg.a;
				return A2(
					$author$project$Components$Parametrage$Utilisateurs$Update$filtrerLeJournal,
					function (j) {
						return _Utils_update(
							j,
							{cE: jour});
					},
					model);
			case 42:
				var jour = msg.a;
				return A2(
					$author$project$Components$Parametrage$Utilisateurs$Update$filtrerLeJournal,
					function (j) {
						return _Utils_update(
							j,
							{cm: jour});
					},
					model);
			case 43:
				var texte = msg.a;
				return A2(
					$author$project$Components$Parametrage$Utilisateurs$Update$filtrerLeJournal,
					function (j) {
						return _Utils_update(
							j,
							{hC: texte});
					},
					model);
			case 44:
				return A2(
					$author$project$Components$Parametrage$Utilisateurs$Update$filtrerLeJournal,
					function (j) {
						return _Utils_update(
							j,
							{fl: $elm$core$Maybe$Nothing});
					},
					model);
			case 45:
				return A2(
					$author$project$Components$Parametrage$Utilisateurs$Update$filtrerLeJournal,
					function (j) {
						return _Utils_update(
							j,
							{cm: '', cE: ''});
					},
					model);
			case 46:
				return A2(
					$author$project$Components$Parametrage$Utilisateurs$Update$filtrerLeJournal,
					$author$project$Components$Parametrage$Utilisateurs$Model$journalFiltre($elm$core$Maybe$Nothing),
					model);
			case 47:
				var numero = msg.a;
				return $author$project$Components$Parametrage$Utilisateurs$Update$lireLaPage(
					_Utils_update(
						model,
						{
							a$: A2(
								$author$project$Components$Parametrage$Utilisateurs$Update$enLecture,
								function (j) {
									return _Utils_update(
										j,
										{EE: numero});
								},
								model.a$)
						}));
			default:
				var journal = model.a$;
				var _v21 = _Utils_Tuple2(
					$author$project$Components$Parametrage$Utilisateurs$Model$exportPossible(journal),
					$author$project$Components$Parametrage$Utilisateurs$Model$lienDeLExport(journal));
				if (_v21.a && (!_v21.b.$)) {
					var lien = _v21.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a$: _Utils_update(
									journal,
									{ms: $author$project$Components$Parametrage$Utilisateurs$Model$ExportEnCours})
							}),
						_List_fromArray(
							[
								A2($author$project$Components$Parametrage$Utilisateurs$Update$Lire, 3, lien)
							]));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Main$Update$versLesUtilisateurs = F3(
	function (i18n, msg, model) {
		var _v0 = A2(
			$author$project$Components$Parametrage$Utilisateurs$Update$update,
			msg,
			$author$project$Components$Parametrage$Utilisateurs$Model$ouvrir(model.Kf));
		var utilisateurs = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurLesUtilisateurs, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLesUtilisateurs,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Parametrage$Utilisateurs$Update$popMessages(msg),
							gardes),
						Kf: $author$project$Components$Parametrage$Utilisateurs$Model$envelopper(utilisateurs)
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$EnvoyerAuxVersionsDUnPipe = function (a) {
	return {$: 99, a: a};
};
var $author$project$Main$Update$LireLesVersionsDUnPipe = F2(
	function (a, b) {
		return {$: 96, a: a, b: b};
	});
var $author$project$Main$Model$PourLesVersionsDUnPipe = 25;
var $author$project$Main$Update$depuisLesVersionsDUnPipe = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				var lecture = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireLesVersionsDUnPipe(lecture))));
			case 1:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerAuxVersionsDUnPipe(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[25]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 3:
				var cible = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$PlacerFocus(cible)
							])));
			case 5:
				var fichier = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$TelechargerLesFichiers(
								_List_fromArray(
									[fichier]))
							])));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
		}
	});
var $author$project$Components$Parametrage$PipeVersions$API$QueryAPIModel$Comparaison = F2(
	function (versionComparee, changements) {
		return {u3: changements, KF: versionComparee};
	});
var $author$project$Components$Parametrage$PipeVersions$API$QueryAPIModel$comparaisonDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'elements',
	$elm$json$Json$Decode$list(
		A2($elm$json$Json$Decode$field, 'texte', $elm$json$Json$Decode$string)),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'de',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeVersions$API$QueryAPIModel$Comparaison)));
var $author$project$Components$Parametrage$PipeVersions$Update$dit = function (resultat) {
	if (resultat.$ === 1) {
		var erreur = resultat.a;
		return ((erreur.ri === 401) || (erreur.ri === 404)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Components$Shared$Messages$Model$duRefus(erreur));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$PipeVersions$API$QueryAPIModel$Version = F9(
	function (numero, statut, baseeSur, publieeLe, publieePar, dossiersEnCours, exporter, retirer, comparer) {
		return {jp: baseeSur, vR: comparer, xK: dossiersEnCours, za: exporter, DX: numero, GD: publieeLe, GE: publieePar, H0: retirer, ri: statut};
	});
var $author$project$API$NavLinksDictionary$comparerUneVersion = 'comparer-une-version';
var $author$project$API$NavLinksDictionary$exporterUneVersion = 'exporter';
var $author$project$API$NavLinksDictionary$retirerLaVersion = 'retirer-la-version';
var $author$project$Components$Parametrage$PipeVersions$API$QueryAPIModel$versionDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$comparerUneVersion),
		$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder),
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		A2(
			$elm$json$Json$Decode$map,
			$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$retirerLaVersion),
			$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder),
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2(
				$elm$json$Json$Decode$map,
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$exporterUneVersion),
				$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder),
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'dossiersEnCours',
				$elm$json$Json$Decode$int,
				0,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
					_List_fromArray(
						['publieePar', 'libelle']),
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'publieeLe',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'baseeSur',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'statut',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'numero',
									$elm$json$Json$Decode$int,
									$elm$json$Json$Decode$succeed($author$project$Components$Parametrage$PipeVersions$API$QueryAPIModel$Version))))))))));
var $author$project$Components$Parametrage$PipeVersions$API$QueryAPIModel$versionsDecoder = A2(
	$elm$json$Json$Decode$field,
	'versions',
	$elm$json$Json$Decode$list($author$project$Components$Parametrage$PipeVersions$API$QueryAPIModel$versionDecoder));
var $author$project$Components$Parametrage$PipeVersions$Update$popMessages = function (msg) {
	if (msg.$ === 2) {
		var lecture = msg.a;
		var reponse = msg.b;
		switch (lecture.$) {
			case 0:
				return $author$project$Components$Parametrage$PipeVersions$Update$dit(
					A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Common$API$QueryAPIModel$annuaireDecoder, reponse));
			case 1:
				return $author$project$Components$Parametrage$PipeVersions$Update$dit(
					A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$Common$API$QueryAPIModel$racineDuPipeDecoder, reponse));
			case 2:
				return $author$project$Components$Parametrage$PipeVersions$Update$dit(
					A2(
						$author$project$API$Reponse$lire,
						$elm$json$Json$Decode$succeed(0),
						reponse));
			case 3:
				return $author$project$Components$Parametrage$PipeVersions$Update$dit(
					A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$PipeVersions$API$QueryAPIModel$versionsDecoder, reponse));
			case 5:
				return $author$project$Components$Parametrage$PipeVersions$Update$dit(
					A2($author$project$API$Reponse$lire, $author$project$Components$Parametrage$PipeVersions$API$QueryAPIModel$comparaisonDecoder, reponse));
			default:
				return $author$project$Components$Parametrage$PipeVersions$Update$dit(
					A2($author$project$API$Reponse$lire, $elm$json$Json$Decode$value, reponse));
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$PipeVersions$Update$Annuaire = {$: 0};
var $author$project$Components$Parametrage$PipeVersions$Update$Comparaison = {$: 5};
var $author$project$Components$Parametrage$PipeVersions$Update$DemanderProcessUid = {$: 2};
var $author$project$Components$Parametrage$PipeVersions$Update$Export = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$PipeVersions$Update$Lire = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeVersions$API$WriteAPIModel$OuvrirLeBrouillon = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$PipeVersions$API$WriteAPIModel$Retirer = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeVersions$Update$Envoyer = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$PipeVersions$Update$Reconnecter = {$: 4};
var $author$project$Components$Parametrage$PipeVersions$API$WriteAPIModel$ReponseDeCommande = function (vuesAJour) {
	return {sy: vuesAJour};
};
var $author$project$Components$Parametrage$PipeVersions$API$WriteAPIModel$reponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Components$Parametrage$PipeVersions$API$WriteAPIModel$ReponseDeCommande,
	A2($elm$json$Json$Decode$field, 'vuesAJour', $elm$json$Json$Decode$bool));
var $author$project$Components$Parametrage$PipeVersions$Update$reglage = {
	f8: $author$project$Components$Parametrage$PipeVersions$Update$DemanderProcessUid,
	l4: $author$project$Components$Parametrage$PipeVersions$Update$Envoyer,
	go: $elm$core$Basics$identity,
	pW: $author$project$Components$Parametrage$PipeVersions$Update$Reconnecter,
	qu: F2(
		function (_v0, _v1) {
			return true;
		}),
	qv: $author$project$Components$Parametrage$PipeVersions$API$WriteAPIModel$reponseDecoder
};
var $author$project$Components$Parametrage$PipeVersions$Model$versionARetirer = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		function (numero) {
			return A2(
				$elm$core$Maybe$andThen,
				function (version) {
					return A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$pair(version),
						version.H0);
				},
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$filter(
							function (version) {
								return _Utils_eq(version.DX, numero);
							}),
						$elm$core$List$head),
					model.EE));
		},
		model.dh);
};
var $author$project$Components$Parametrage$PipeVersions$Update$confirmerLeRetrait = function (model) {
	var _v0 = $author$project$Components$Parametrage$PipeVersions$Model$versionARetirer(model);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var version = _v1.a;
		var lien = _v1.b;
		var _v2 = A4(
			$author$project$API$Envoi$partir,
			$author$project$Components$Parametrage$PipeVersions$Update$reglage,
			$elm$core$Maybe$Just(lien),
			A2($author$project$Components$Parametrage$PipeVersions$API$WriteAPIModel$Retirer, model.FK, version.DX),
			model.l2);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var envoi = _v3.a;
			var effets = _v3.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l2: envoi, pZ: $elm$core$Maybe$Nothing}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	} else {
		return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Components$Parametrage$PipeVersions$Update$PlacerFocus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$PipeVersions$Model$idDuDeclencheur = function (numero) {
	return 'pipe-versions-retirer-v' + $elm$core$String$fromInt(numero);
};
var $author$project$Components$Parametrage$PipeVersions$Update$demanderLeRetrait = F2(
	function (numero, model) {
		var offert = A2(
			$elm$core$List$any,
			function (version) {
				return _Utils_eq(version.DX, numero) && (!_Utils_eq(version.H0, $elm$core$Maybe$Nothing));
			},
			A2($elm$core$Maybe$withDefault, _List_Nil, model.EE));
		if ((!offert) || $author$project$API$Envoi$enCours(model.l2)) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v0 = A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				$author$project$Components$Shared$Drawer$Update$Ouvrir(
					$author$project$Components$Parametrage$PipeVersions$Model$idDuDeclencheur(numero)),
				$author$project$Components$Shared$Drawer$Model$init(
					$author$project$Components$Parametrage$PipeVersions$Model$idDuDrawer('retirer')));
			var drawer = _v0.a;
			var effets = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						dh: $elm$core$Maybe$Just(numero),
						kX: drawer,
						pZ: $elm$core$Maybe$Nothing
					}),
				A2(
					$elm$core$List$map,
					function (_v1) {
						var cible = _v1;
						return $author$project$Components$Parametrage$PipeVersions$Update$PlacerFocus(cible);
					},
					effets));
		}
	});
var $author$project$Components$Parametrage$PipeVersions$Update$Edition = {$: 2};
var $author$project$Components$Parametrage$PipeVersions$Update$Page = {$: 3};
var $author$project$Components$Parametrage$PipeVersions$Update$Racine = {$: 1};
var $author$project$Components$Parametrage$PipeVersions$Update$Telecharger = function (a) {
	return {$: 5, a: a};
};
var $author$project$API$NavLinksDictionary$creerUnBrouillon = 'creer-un-brouillon';
var $author$project$Components$Parametrage$PipeVersions$API$QueryAPIModel$brouillonDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$creerUnBrouillon),
	$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder);
var $author$project$Components$Parametrage$PipeVersions$Update$sous = F4(
	function (decodeur, reponse, model, suite) {
		var _v0 = A2($author$project$API$Reponse$lire, decodeur, reponse);
		if (!_v0.$) {
			var lue = _v0.a;
			return suite(lue);
		} else {
			var refus = _v0.a;
			return (refus.ri === 401) ? _Utils_Tuple2(
				model,
				_List_fromArray(
					[$author$project$Components$Parametrage$PipeVersions$Update$Reconnecter])) : _Utils_Tuple2(
				_Utils_update(
					model,
					{nf: model.nf || (refus.ri === 404)}),
				_List_Nil);
		}
	});
var $author$project$Components$Parametrage$PipeVersions$Update$lu = F3(
	function (lecture, reponse, model) {
		switch (lecture.$) {
			case 0:
				return A4(
					$author$project$Components$Parametrage$PipeVersions$Update$sous,
					$author$project$Components$Parametrage$Common$API$QueryAPIModel$lienDuPipeDecoder(model.vx),
					reponse,
					model,
					function (visee) {
						if (!visee.$) {
							var racine = visee.a;
							return _Utils_Tuple2(
								model,
								_List_fromArray(
									[
										A2($author$project$Components$Parametrage$PipeVersions$Update$Lire, $author$project$Components$Parametrage$PipeVersions$Update$Racine, racine)
									]));
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{nf: true}),
								_List_Nil);
						}
					});
			case 1:
				return A4(
					$author$project$Components$Parametrage$PipeVersions$Update$sous,
					$author$project$Components$Parametrage$Common$API$QueryAPIModel$racineDuPipeDecoder,
					reponse,
					model,
					function (edition) {
						if (!edition.$) {
							var lien = edition.a;
							return _Utils_Tuple2(
								model,
								_List_fromArray(
									[
										A2($author$project$Components$Parametrage$PipeVersions$Update$Lire, $author$project$Components$Parametrage$PipeVersions$Update$Edition, lien)
									]));
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{nf: true}),
								_List_Nil);
						}
					});
			case 2:
				return A4(
					$author$project$Components$Parametrage$PipeVersions$Update$sous,
					A4(
						$elm$json$Json$Decode$map3,
						F3(
							function (uid, libelles, liens) {
								return _Utils_Tuple3(uid, libelles, liens);
							}),
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['pipe', 'uid']),
							$elm$json$Json$Decode$string),
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['pipe', 'libelles']),
							$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)),
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$liensDecoder),
					reponse,
					model,
					function (_v3) {
						var pipeUid = _v3.a;
						var libelles = _v3.b;
						var liens = _v3.c;
						var suivant = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$versionsDuPipe, liens);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									nf: _Utils_eq(suivant, $elm$core$Maybe$Nothing),
									Bl: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(libelles),
									nE: suivant,
									FK: pipeUid
								}),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									$elm$core$List$singleton,
									A2(
										$elm$core$Maybe$map,
										$author$project$Components$Parametrage$PipeVersions$Update$Lire($author$project$Components$Parametrage$PipeVersions$Update$Page),
										suivant))));
					});
			case 3:
				return A4(
					$author$project$Components$Parametrage$PipeVersions$Update$sous,
					A3($elm$json$Json$Decode$map2, $elm$core$Tuple$pair, $author$project$Components$Parametrage$PipeVersions$API$QueryAPIModel$versionsDecoder, $author$project$Components$Parametrage$PipeVersions$API$QueryAPIModel$brouillonDecoder),
					reponse,
					model,
					function (_v4) {
						var page = _v4.a;
						var brouillon = _v4.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									jv: brouillon,
									EE: $elm$core$Maybe$Just(page)
								}),
							_List_Nil);
					});
			case 5:
				return A4(
					$author$project$Components$Parametrage$PipeVersions$Update$sous,
					$author$project$Components$Parametrage$PipeVersions$API$QueryAPIModel$comparaisonDecoder,
					reponse,
					model,
					function (lue) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									vP: $elm$core$Maybe$Just(lue)
								}),
							_List_Nil);
					});
			default:
				var numero = lecture.a;
				var _v5 = A2($author$project$API$Reponse$lire, $elm$json$Json$Decode$value, reponse);
				if (!_v5.$) {
					return _Utils_Tuple2(
						model,
						_List_fromArray(
							[
								$author$project$Components$Parametrage$PipeVersions$Update$Telecharger(
								{
									fZ: reponse.f$,
									Dj: model.vx + ('-version-' + ($elm$core$String$fromInt(numero) + '.json')),
									r0: 'application/json'
								})
							]));
				} else {
					var refus = _v5.a;
					return (refus.ri === 401) ? _Utils_Tuple2(
						model,
						_List_fromArray(
							[$author$project$Components$Parametrage$PipeVersions$Update$Reconnecter])) : _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Components$Parametrage$PipeVersions$Update$repondue = F2(
	function (reponse, model) {
		var _v0 = A3($author$project$API$Envoi$conclure, $author$project$Components$Parametrage$PipeVersions$Update$reglage, reponse, model.l2);
		if (!_v0.$) {
			switch (_v0.a.b.$) {
				case 0:
					var _v1 = _v0.a;
					var envoi = _v1.a;
					var _v2 = _v1.b;
					var effets = _v1.c;
					var _v3 = A3(
						$author$project$Components$Shared$Drawer$Update$update,
						{Il: false},
						$author$project$Components$Shared$Drawer$Update$Fermer,
						model.kX);
					var drawer = _v3.a;
					var deDrawer = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{dh: $elm$core$Maybe$Nothing, kX: drawer, l2: envoi, pZ: $elm$core$Maybe$Nothing}),
						_Utils_ap(
							effets,
							_Utils_ap(
								A2(
									$elm$core$List$map,
									function (_v4) {
										var cible = _v4;
										return $author$project$Components$Parametrage$PipeVersions$Update$PlacerFocus(cible);
									},
									deDrawer),
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										$elm$core$List$singleton,
										A2(
											$elm$core$Maybe$map,
											$author$project$Components$Parametrage$PipeVersions$Update$Lire($author$project$Components$Parametrage$PipeVersions$Update$Page),
											model.nE))))));
				case 1:
					var _v5 = _v0.a;
					var envoi = _v5.a;
					var _v6 = _v5.b;
					var refus = _v6.b;
					var effets = _v5.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l2: envoi,
								pZ: $elm$core$Maybe$Just(
									$author$project$Components$Parametrage$Vocabulaire$messageDuRefus(refus))
							}),
						effets);
				default:
					var _v7 = _v0.a;
					var envoi = _v7.a;
					var _v8 = _v7.b;
					var effets = _v7.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{l2: envoi}),
						effets);
			}
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Parametrage$PipeVersions$Update$versLeDrawer = F2(
	function (geste, model) {
		if ($author$project$API$Envoi$enCours(model.l2) && A2(
			$elm$core$List$member,
			geste,
			_List_fromArray(
				[$author$project$Components$Shared$Drawer$Update$Fermer, $author$project$Components$Shared$Drawer$Update$SortieDemandee, $author$project$Components$Shared$Drawer$Update$AbandonConfirme]))) {
			return _Utils_Tuple2(model, _List_Nil);
		} else {
			var _v0 = A3(
				$author$project$Components$Shared$Drawer$Update$update,
				{Il: false},
				geste,
				model.kX);
			var drawer = _v0.a;
			var effets = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						dh: $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? model.dh : $elm$core$Maybe$Nothing,
						kX: drawer
					}),
				A2(
					$elm$core$List$map,
					function (_v1) {
						var cible = _v1;
						return $author$project$Components$Parametrage$PipeVersions$Update$PlacerFocus(cible);
					},
					effets));
		}
	});
var $author$project$Components$Parametrage$PipeVersions$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var code = msg.a;
				var liens = msg.b;
				var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$pipes, liens);
				if (!_v1.$) {
					var lecture = _v1.a;
					return _Utils_Tuple2(
						$author$project$Components$Parametrage$PipeVersions$Model$init(code),
						_List_fromArray(
							[
								$author$project$Components$Parametrage$PipeVersions$Update$DemanderProcessUid,
								A2($author$project$Components$Parametrage$PipeVersions$Update$Lire, $author$project$Components$Parametrage$PipeVersions$Update$Annuaire, lecture)
							]));
				} else {
					return _Utils_Tuple2(
						$author$project$Components$Parametrage$PipeVersions$Model$init(code),
						_List_Nil);
				}
			case 1:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 2:
				var lecture = msg.a;
				var reponse = msg.b;
				return A3($author$project$Components$Parametrage$PipeVersions$Update$lu, lecture, reponse, model);
			case 3:
				var reponse = msg.a;
				return A2($author$project$Components$Parametrage$PipeVersions$Update$repondue, reponse, model);
			case 4:
				var geste = msg.a;
				return A2($author$project$Components$Parametrage$PipeVersions$Update$versLeDrawer, geste, model);
			case 5:
				var numero = msg.a;
				return A2($author$project$Components$Parametrage$PipeVersions$Update$demanderLeRetrait, numero, model);
			case 6:
				return $author$project$Components$Parametrage$PipeVersions$Update$confirmerLeRetrait(model);
			case 7:
				var _v2 = A4(
					$author$project$API$Envoi$partir,
					$author$project$Components$Parametrage$PipeVersions$Update$reglage,
					model.jv,
					$author$project$Components$Parametrage$PipeVersions$API$WriteAPIModel$OuvrirLeBrouillon(model.FK),
					model.l2);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var envoi = _v3.a;
					var effets = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{l2: envoi, pZ: $elm$core$Maybe$Nothing}),
						effets);
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 9:
				var numero = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$List$take,
						1,
						A2(
							$elm$core$List$map,
							$author$project$Components$Parametrage$PipeVersions$Update$Lire($author$project$Components$Parametrage$PipeVersions$Update$Comparaison),
							A2(
								$elm$core$List$filterMap,
								function ($) {
									return $.vR;
								},
								A2(
									$elm$core$List$filter,
									function (version) {
										return _Utils_eq(version.DX, numero);
									},
									A2($elm$core$Maybe$withDefault, _List_Nil, model.EE))))));
			default:
				var numero = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$List$take,
						1,
						A2(
							$elm$core$List$map,
							$author$project$Components$Parametrage$PipeVersions$Update$Lire(
								$author$project$Components$Parametrage$PipeVersions$Update$Export(numero)),
							A2(
								$elm$core$List$filterMap,
								function ($) {
									return $.za;
								},
								A2(
									$elm$core$List$filter,
									function (version) {
										return _Utils_eq(version.DX, numero);
									},
									A2($elm$core$Maybe$withDefault, _List_Nil, model.EE))))));
		}
	});
var $author$project$Main$Update$versLesVersionsDUnPipe = F3(
	function (i18n, msg, model) {
		var _v0 = A2($author$project$Components$Parametrage$PipeVersions$Update$update, msg, model.FL);
		var versions = _v0.a;
		var effets = _v0.b;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisLesVersionsDUnPipe,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Parametrage$PipeVersions$Update$popMessages(msg),
							model.Ct),
						FL: versions
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$AttendreAvantDeRelireMonCompte = function (a) {
	return {$: 257, a: a};
};
var $author$project$Main$Update$EnvoyerAMonCompte = function (a) {
	return {$: 256, a: a};
};
var $author$project$Main$Update$LireMonCompte = F2(
	function (a, b) {
		return {$: 255, a: a, b: b};
	});
var $author$project$Main$Model$PourMonCompte = 49;
var $author$project$Main$Update$depuisMonCompte = F2(
	function (effet, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		switch (effet.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ta: _Utils_ap(
								model.ta,
								_List_fromArray(
									[49]))
						}),
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$DemanderAlea($author$project$API$ProcessUid$octetsDemandes)
							])));
			case 1:
				var lecture = effet.a;
				var lien = effet.b;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							$author$project$Main$Update$LireMonCompte(lecture))));
			case 2:
				var lien = effet.a;
				var processUid = effet.b;
				var commande = effet.c;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						A3(
							$author$project$Main$Update$versLApi,
							model,
							lien,
							function (vers) {
								return $author$project$Main$Update$EnvoyerAMonCompte(
									{vJ: commande, gM: vers.gM, nB: vers.nB, Gn: processUid});
							})));
			case 3:
				var delaiMs = effet.a;
				return _Utils_Tuple2(
					model,
					_Utils_ap(
						effets,
						_List_fromArray(
							[
								$author$project$Main$Update$AttendreAvantDeRelireMonCompte(delaiMs)
							])));
			case 4:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2($author$project$Main$Update$versLaSession, $author$project$Components$Socle$Session$Update$JetonEchu, model));
			default:
				var action = effet.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Basics$append(effets),
					A2(
						$author$project$Main$Update$versLaSession,
						$author$project$Components$Socle$Session$Update$ActionDemandee(action),
						model));
		}
	});
var $author$project$Components$Comptes$MonCompte$API$WriteAPIErrorsModel$AutreRefus = {$: 1};
var $author$project$Components$Comptes$MonCompte$API$WriteAPIErrorsModel$ProfilInvalide = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Comptes$MonCompte$API$WriteAPIErrorsModel$duRefus = function (reponse) {
	var _v0 = A2(
		$elm$json$Json$Decode$decodeString,
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['error', 'ProfilInvalide', 'erreurs']),
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
		reponse.f$);
	if (!_v0.$) {
		var erreurs = _v0.a;
		return $author$project$Components$Comptes$MonCompte$API$WriteAPIErrorsModel$ProfilInvalide(erreurs);
	} else {
		return $author$project$Components$Comptes$MonCompte$API$WriteAPIErrorsModel$AutreRefus;
	}
};
var $author$project$Components$Comptes$MonCompte$API$QueryAPIModel$Fuseau = F3(
	function (identifiant, libelle, apercus) {
		return {tu: apercus, Au: identifiant, Bl: libelle};
	});
var $author$project$Components$Comptes$MonCompte$API$QueryAPIModel$Apercu = F4(
	function (langue, echeance, montant, origine) {
		return {xY: echeance, nn: langue, oi: montant, o4: origine};
	});
var $author$project$Components$Comptes$MonCompte$API$QueryAPIModel$apercuDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'origine',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'montant',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'echeance',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'langue',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Components$Comptes$MonCompte$API$QueryAPIModel$Apercu)))));
var $author$project$Components$Comptes$MonCompte$API$QueryAPIModel$fuseauxDecoder = A2(
	$elm$json$Json$Decode$field,
	'fuseaux',
	$elm$json$Json$Decode$list(
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'apercus',
			$elm$json$Json$Decode$list($author$project$Components$Comptes$MonCompte$API$QueryAPIModel$apercuDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'libelle',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'identifiant',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Components$Comptes$MonCompte$API$QueryAPIModel$Fuseau))))));
var $author$project$Components$Comptes$MonCompte$Update$ignorer = function (_v0) {
	return 0;
};
var $author$project$Components$Comptes$MonCompte$API$QueryAPIModel$Preferences = F3(
	function (langue, fuseau, liens) {
		return {z_: fuseau, nn: langue, nQ: liens};
	});
var $author$project$Components$Comptes$MonCompte$API$QueryAPIModel$preferencesDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'fuseau',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'langue',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			$elm$json$Json$Decode$succeed($author$project$Components$Comptes$MonCompte$API$QueryAPIModel$Preferences))));
var $author$project$Components$Comptes$MonCompte$API$QueryAPIModel$Profil = F7(
	function (prenom, nom, email, emailEnAttente, fonction, telephonePro, liens) {
		return {yb: email, yc: emailEnAttente, zO: fonction, nQ: liens, Dj: nom, Gg: prenom, Jp: telephonePro};
	});
var $author$project$Components$Comptes$MonCompte$API$QueryAPIModel$profilDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$deLaRessource),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'telephonePro',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'fonction',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'emailEnAttente',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'email',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'nom',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'prenom',
							$elm$json$Json$Decode$string,
							'',
							$elm$json$Json$Decode$succeed($author$project$Components$Comptes$MonCompte$API$QueryAPIModel$Profil))))))));
var $author$project$Components$Comptes$MonCompte$Update$refus = function (resultat) {
	if (resultat.$ === 1) {
		var lu = resultat.a;
		return (lu.ri === 401) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Components$Shared$Messages$Model$duRefus(lu));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Comptes$MonCompte$API$WriteAPIModel$Rendue = F2(
	function (vuesAJour, liens) {
		return {nQ: liens, sy: vuesAJour};
	});
var $author$project$Components$Comptes$MonCompte$API$WriteAPIModel$rendueDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'liens',
	A2(
		$elm$json$Json$Decode$map,
		function ($) {
			return $.h0;
		},
		$author$project$API$Liens$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vuesAJour',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Components$Comptes$MonCompte$API$WriteAPIModel$Rendue)));
var $author$project$Components$Comptes$MonCompte$Update$popMessages = function (msg) {
	switch (msg.$) {
		case 2:
			switch (msg.a) {
				case 0:
					var _v1 = msg.a;
					var reponse = msg.b;
					return $author$project$Components$Comptes$MonCompte$Update$refus(
						A2($author$project$API$Reponse$lire, $author$project$Components$Comptes$MonCompte$API$QueryAPIModel$profilDecoder, reponse));
				case 1:
					var _v2 = msg.a;
					var reponse = msg.b;
					return $author$project$Components$Comptes$MonCompte$Update$refus(
						A2($author$project$API$Reponse$lire, $author$project$Components$Comptes$MonCompte$API$QueryAPIModel$preferencesDecoder, reponse));
				default:
					var _v3 = msg.a;
					var reponse = msg.b;
					return $author$project$Components$Comptes$MonCompte$Update$refus(
						A2($author$project$API$Reponse$lire, $author$project$Components$Comptes$MonCompte$API$QueryAPIModel$fuseauxDecoder, reponse));
			}
		case 12:
			var reponse = msg.a;
			return _Utils_eq(
				$author$project$Components$Comptes$MonCompte$API$WriteAPIErrorsModel$duRefus(reponse),
				$author$project$Components$Comptes$MonCompte$API$WriteAPIErrorsModel$AutreRefus) ? $author$project$Components$Comptes$MonCompte$Update$refus(
				A2(
					$author$project$API$Reponse$lire,
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2($elm$json$Json$Decode$map, $author$project$Components$Comptes$MonCompte$Update$ignorer, $author$project$Components$Comptes$MonCompte$API$QueryAPIModel$profilDecoder),
								A2($elm$json$Json$Decode$map, $author$project$Components$Comptes$MonCompte$Update$ignorer, $author$project$Components$Comptes$MonCompte$API$WriteAPIModel$rendueDecoder)
							])),
					reponse)) : $elm$core$Maybe$Nothing;
		case 1:
			var octets = msg.a;
			return _Utils_eq(
				$author$project$API$ProcessUid$depuisOctets(octets),
				$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
				{Jx: $author$project$I18n$Textes$erreurApiTechnique, b9: $elm$core$Maybe$Nothing}) : $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Main$Update$requeteSurMonCompte = function (effet) {
	switch (effet.$) {
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Comptes$MonCompte$Update$DemanderProcessUid = {$: 0};
var $author$project$Components$Comptes$MonCompte$Update$LancerLActionKeycloak = function (a) {
	return {$: 5, a: a};
};
var $author$project$API$NavLinksDictionary$changerLEmail = 'changer-l-email';
var $author$project$Components$Comptes$MonCompte$API$WriteAPIModel$EnregistrerLesPreferences = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Comptes$MonCompte$Model$commandeDesPreferences = function (model) {
	return ($elm$core$String$isEmpty(model.nn) || $elm$core$String$isEmpty(model.z_)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		$author$project$Components$Comptes$MonCompte$API$WriteAPIModel$EnregistrerLesPreferences(
			{z_: model.z_, nn: model.nn}));
};
var $author$project$Components$Comptes$MonCompte$API$WriteAPIModel$EnregistrerLeProfil = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Comptes$MonCompte$Model$commandeDuProfil = function (model) {
	return ($elm$core$String$isEmpty(
		$elm$core$String$trim(model.Gg)) || $elm$core$String$isEmpty(
		$elm$core$String$trim(model.Dj))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		$author$project$Components$Comptes$MonCompte$API$WriteAPIModel$EnregistrerLeProfil(
			{zO: model.zO, Dj: model.Dj, Gg: model.Gg, Jp: model.Jp}));
};
var $author$project$API$NavLinksDictionary$enregistrerLeProfil = 'enregistrer-le-profil';
var $author$project$API$NavLinksDictionary$enregistrerLesPreferences = 'enregistrer-les-preferences';
var $author$project$Components$Comptes$MonCompte$Model$lienDeLaCommande = F2(
	function (rel, model) {
		return A2(
			$author$project$API$Liens$trouver,
			rel,
			$elm$core$List$concat(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.nQ;
							},
							model.c2),
							A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.nQ;
							},
							model.eF)
						]))));
	});
var $author$project$Components$Comptes$MonCompte$Update$LesFuseaux = 2;
var $author$project$Components$Comptes$MonCompte$Update$Lire = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$API$NavLinksDictionary$monCompteFuseaux = 'mon-compte-fuseaux';
var $author$project$Components$Comptes$MonCompte$Update$lireLesFuseaux = F2(
	function (preferences, model) {
		return $elm$core$List$isEmpty(model.gD) ? A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Comptes$MonCompte$Update$Lire(2),
					$elm$core$List$singleton),
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$monCompteFuseaux, preferences.nQ))) : _List_Nil;
	});
var $author$project$API$NavLinksDictionary$monCompteProfil = 'mon-compte-profil';
var $author$project$Components$Comptes$MonCompte$Update$partir = F4(
	function (reglageDeLEnvoi, rel, commande, model) {
		var depart = function (fournie) {
			return A4(
				$author$project$API$Envoi$partir,
				reglageDeLEnvoi,
				A2($author$project$Components$Comptes$MonCompte$Model$lienDeLaCommande, rel, model),
				fournie,
				model.l2);
		};
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			depart,
			commande(model));
		if (!_v0.$) {
			var _v1 = _v0.a;
			var envoi = _v1.a;
			var effets = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{l_: $elm$core$Maybe$Nothing, l2: envoi, hF: $elm$core$Maybe$Nothing}),
				effets);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Comptes$MonCompte$Update$AttendreAvantDeRelire = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Comptes$MonCompte$Model$PreferencesEnregistrees = 1;
var $author$project$Components$Comptes$MonCompte$Update$LesPreferences = 1;
var $author$project$Components$Comptes$MonCompte$Update$relireLesPreferences = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$Comptes$MonCompte$Update$Lire(1),
				$elm$core$List$singleton),
			model.nJ));
};
var $author$project$Components$Comptes$MonCompte$Update$preferencesConclues = F2(
	function (issue, model) {
		if (!issue.$) {
			var rendue = issue.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						l_: $elm$core$Maybe$Just(1)
					}),
				rendue.sy ? $author$project$Components$Comptes$MonCompte$Update$relireLesPreferences(model) : _List_fromArray(
					[
						$author$project$Components$Comptes$MonCompte$Update$AttendreAvantDeRelire($author$project$API$Envoi$delaiDeRelectureMs)
					]));
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Components$Comptes$MonCompte$Model$ProfilEnregistre = 0;
var $author$project$Components$Comptes$MonCompte$Model$recevoirLeProfil = F2(
	function (profil, model) {
		return _Utils_update(
			model,
			{
				zO: profil.zO,
				Dj: profil.Dj,
				Gg: profil.Gg,
				c2: $elm$core$Maybe$Just(profil),
				Jp: profil.Jp
			});
	});
var $author$project$Components$Comptes$MonCompte$Update$profilConclu = F2(
	function (issue, model) {
		switch (issue.$) {
			case 0:
				var profil = issue.b;
				return A2(
					$author$project$Components$Comptes$MonCompte$Model$recevoirLeProfil,
					profil,
					_Utils_update(
						model,
						{
							l_: $elm$core$Maybe$Just(0)
						}));
			case 1:
				var erreur = issue.c;
				return _Utils_update(
					model,
					{
						hF: $elm$core$Maybe$Just(erreur)
					});
			default:
				return model;
		}
	});
var $author$project$Components$Comptes$MonCompte$Model$recevoirLesPreferences = F2(
	function (preferences, model) {
		return _Utils_update(
			model,
			{
				z_: A2($elm$core$Maybe$withDefault, '', preferences.z_),
				nn: A2($elm$core$Maybe$withDefault, '', preferences.nn),
				eF: $elm$core$Maybe$Just(preferences)
			});
	});
var $author$project$Components$Comptes$MonCompte$Update$Reconnecter = {$: 4};
var $author$project$Components$Comptes$MonCompte$Update$reconnecterSi = function (lu) {
	return (lu.ri === 401) ? _List_fromArray(
		[$author$project$Components$Comptes$MonCompte$Update$Reconnecter]) : _List_Nil;
};
var $author$project$Components$Comptes$MonCompte$Update$Envoyer = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$Comptes$MonCompte$Update$reglage = function (decoder) {
	return {
		f8: $author$project$Components$Comptes$MonCompte$Update$DemanderProcessUid,
		l4: $author$project$Components$Comptes$MonCompte$Update$Envoyer,
		go: $author$project$Components$Comptes$MonCompte$API$WriteAPIErrorsModel$duRefus,
		pW: $author$project$Components$Comptes$MonCompte$Update$Reconnecter,
		qu: F2(
			function (_v0, _v1) {
				return true;
			}),
		qv: decoder
	};
};
var $author$project$Components$Comptes$MonCompte$Update$LeProfil = 0;
var $author$project$Components$Comptes$MonCompte$Update$relire = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$Comptes$MonCompte$Update$Lire(0),
				$elm$core$List$singleton),
			model.nO));
};
var $author$project$Components$Comptes$MonCompte$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var liens = msg.a;
				var statut = msg.b;
				var ouvert = _Utils_update(
					model,
					{
						nJ: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$monComptePreferences, liens),
						nO: A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$monCompteProfil, liens),
						h_: statut
					});
				return _Utils_Tuple2(
					ouvert,
					A2(
						$elm$core$List$cons,
						$author$project$Components$Comptes$MonCompte$Update$DemanderProcessUid,
						_Utils_ap(
							$author$project$Components$Comptes$MonCompte$Update$relire(ouvert),
							$author$project$Components$Comptes$MonCompte$Update$relireLesPreferences(ouvert))));
			case 1:
				var octets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l2: A2($author$project$API$Envoi$recevoir, octets, model.l2)
						}),
					_List_Nil);
			case 2:
				switch (msg.a) {
					case 0:
						var _v1 = msg.a;
						var reponse = msg.b;
						var _v2 = A2($author$project$API$Reponse$lire, $author$project$Components$Comptes$MonCompte$API$QueryAPIModel$profilDecoder, reponse);
						if (!_v2.$) {
							var profil = _v2.a;
							return _Utils_Tuple2(
								A2($author$project$Components$Comptes$MonCompte$Model$recevoirLeProfil, profil, model),
								_List_Nil);
						} else {
							var lu = _v2.a;
							return _Utils_Tuple2(
								model,
								$author$project$Components$Comptes$MonCompte$Update$reconnecterSi(lu));
						}
					case 1:
						var _v3 = msg.a;
						var reponse = msg.b;
						var _v4 = A2($author$project$API$Reponse$lire, $author$project$Components$Comptes$MonCompte$API$QueryAPIModel$preferencesDecoder, reponse);
						if (!_v4.$) {
							var preferences = _v4.a;
							return _Utils_Tuple2(
								A2($author$project$Components$Comptes$MonCompte$Model$recevoirLesPreferences, preferences, model),
								A2($author$project$Components$Comptes$MonCompte$Update$lireLesFuseaux, preferences, model));
						} else {
							var lu = _v4.a;
							return _Utils_Tuple2(
								model,
								$author$project$Components$Comptes$MonCompte$Update$reconnecterSi(lu));
						}
					default:
						var _v5 = msg.a;
						var reponse = msg.b;
						var _v6 = A2($author$project$API$Reponse$lire, $author$project$Components$Comptes$MonCompte$API$QueryAPIModel$fuseauxDecoder, reponse);
						if (!_v6.$) {
							var fuseaux = _v6.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{gD: fuseaux}),
								_List_Nil);
						} else {
							var lu = _v6.a;
							return _Utils_Tuple2(
								model,
								$author$project$Components$Comptes$MonCompte$Update$reconnecterSi(lu));
						}
				}
			case 3:
				return _Utils_Tuple2(
					model,
					$author$project$Components$Comptes$MonCompte$Update$relireLesPreferences(model));
			case 4:
				var prenom = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{l_: $elm$core$Maybe$Nothing, Gg: prenom}),
					_List_Nil);
			case 5:
				var nom = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{l_: $elm$core$Maybe$Nothing, Dj: nom}),
					_List_Nil);
			case 6:
				var fonction = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{l_: $elm$core$Maybe$Nothing, zO: fonction}),
					_List_Nil);
			case 7:
				var telephone = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{l_: $elm$core$Maybe$Nothing, Jp: telephone}),
					_List_Nil);
			case 8:
				var langue = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{l_: $elm$core$Maybe$Nothing, nn: langue}),
					_List_Nil);
			case 9:
				var fuseau = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{l_: $elm$core$Maybe$Nothing, z_: fuseau}),
					_List_Nil);
			case 10:
				return A4(
					$author$project$Components$Comptes$MonCompte$Update$partir,
					$author$project$Components$Comptes$MonCompte$Update$reglage($author$project$Components$Comptes$MonCompte$API$QueryAPIModel$profilDecoder),
					$author$project$API$NavLinksDictionary$enregistrerLeProfil,
					$author$project$Components$Comptes$MonCompte$Model$commandeDuProfil,
					model);
			case 11:
				return A4(
					$author$project$Components$Comptes$MonCompte$Update$partir,
					$author$project$Components$Comptes$MonCompte$Update$reglage($author$project$Components$Comptes$MonCompte$API$WriteAPIModel$rendueDecoder),
					$author$project$API$NavLinksDictionary$enregistrerLesPreferences,
					$author$project$Components$Comptes$MonCompte$Model$commandeDesPreferences,
					model);
			case 13:
				var _v7 = _Utils_Tuple2(
					$author$project$API$Envoi$enCours(model.l2),
					A2($author$project$Components$Comptes$MonCompte$Model$lienDeLaCommande, $author$project$API$NavLinksDictionary$changerLEmail, model));
				if ((!_v7.a) && (!_v7.b.$)) {
					var lien = _v7.b.a;
					return _Utils_Tuple2(
						model,
						_List_fromArray(
							[
								$author$project$Components$Comptes$MonCompte$Update$LancerLActionKeycloak(lien)
							]));
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			default:
				var reponse = msg.a;
				var _v8 = model.l2;
				if (_v8.$ === 2) {
					if (!_v8.b.$) {
						var _v9 = A3(
							$author$project$API$Envoi$conclure,
							$author$project$Components$Comptes$MonCompte$Update$reglage($author$project$Components$Comptes$MonCompte$API$QueryAPIModel$profilDecoder),
							reponse,
							model.l2);
						if (!_v9.$) {
							var _v10 = _v9.a;
							var envoi = _v10.a;
							var issue = _v10.b;
							var effets = _v10.c;
							return _Utils_Tuple2(
								A2(
									$author$project$Components$Comptes$MonCompte$Update$profilConclu,
									issue,
									_Utils_update(
										model,
										{l2: envoi})),
								effets);
						} else {
							return _Utils_Tuple2(model, _List_Nil);
						}
					} else {
						var _v11 = A3(
							$author$project$API$Envoi$conclure,
							$author$project$Components$Comptes$MonCompte$Update$reglage($author$project$Components$Comptes$MonCompte$API$WriteAPIModel$rendueDecoder),
							reponse,
							model.l2);
						if (!_v11.$) {
							var _v12 = _v11.a;
							var envoi = _v12.a;
							var issue = _v12.b;
							var effets = _v12.c;
							return A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Basics$append(effets),
								A2(
									$author$project$Components$Comptes$MonCompte$Update$preferencesConclues,
									issue,
									_Utils_update(
										model,
										{l2: envoi})));
						} else {
							return _Utils_Tuple2(model, _List_Nil);
						}
					}
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
		}
	});
var $author$project$Main$Update$versMonCompte = F2(
	function (msg, model) {
		var _v0 = A2($author$project$Components$Comptes$MonCompte$Update$update, msg, model.CT);
		var monCompte = _v0.a;
		var effets = _v0.b;
		var gardes = A2($elm$core$List$any, $author$project$Main$Update$requeteSurMonCompte, effets) ? _List_Nil : model.Ct;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$Update$depuisMonCompte,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ct: A2(
							$author$project$Main$Update$remonter,
							$author$project$Components$Comptes$MonCompte$Update$popMessages(msg),
							gardes),
						CT: monCompte
					}),
				_List_Nil),
			effets);
	});
var $author$project$Main$Update$ouvrirLaPageDeLaRoute = F2(
	function (i18n, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		var _v1 = _Utils_Tuple2(
			model.Ih,
			$author$project$Main$Update$liensDeLaRacine(model));
		_v1$62:
		while (true) {
			if (!_v1.b.$) {
				switch (_v1.a.$) {
					case 2:
						var page = _v1.a.a;
						var liens = _v1.b.a;
						var _v2 = A3(
							$author$project$Main$Update$versLesPartiesPrenantes,
							i18n,
							A2($author$project$Components$Referentiel$PartiesPrenantes$Update$Ouverte, page, liens.gF),
							model);
						var ouverte = _v2.a;
						var deLOuverture = _v2.b;
						var _v3 = A3(
							$author$project$Main$Update$versLesPartiesPrenantes,
							i18n,
							$author$project$Components$Referentiel$PartiesPrenantes$Update$RacineConnue(liens.h0),
							ouverte);
						var annoncee = _v3.a;
						var deLaRacine = _v3.b;
						return (!_Utils_eq(
							$author$project$Components$Referentiel$NouvelleFiche$Model$ouvrir(model.oU).iQ,
							$elm$core$Maybe$Nothing)) ? A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(
								_Utils_ap(
									effets,
									_Utils_ap(deLOuverture, deLaRacine))),
							A3($author$project$Main$Update$ouvrirLaCreation, i18n, $author$project$Components$Referentiel$PartiesPrenantes$Model$idDuDeclencheurDeCreation, annoncee)) : _Utils_Tuple2(
							annoncee,
							_Utils_ap(
								effets,
								_Utils_ap(deLOuverture, deLaRacine)));
					case 4:
						var _v4 = _v1.a;
						var premiere = _v4.a;
						var seconde = _v4.b;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLaFusion,
								i18n,
								A3($author$project$Components$Referentiel$Fusion$Update$Ouverte, premiere, seconde, liens.gF),
								model));
					case 3:
						var _v5 = _v1.a;
						var uid = _v5.a;
						var liens = _v1.b.a;
						var _v6 = A3(
							$author$project$Main$Update$versLaFiche,
							i18n,
							A2($author$project$Components$Referentiel$Fiche$Update$Ouverte, uid, liens.gF),
							A3(
								$author$project$Main$Update$versLaFiche,
								i18n,
								$author$project$Components$Referentiel$Fiche$Update$RacineConnue(liens.h0),
								A3(
									$author$project$Main$Update$versLaFusion,
									i18n,
									$author$project$Components$Referentiel$Fusion$Update$GabaritsConnus(liens.gF),
									model).a).a);
						var ouverte = _v6.a;
						var deLOuverture = _v6.b;
						var _v7 = A3(
							$author$project$Main$Update$versLaFiche,
							i18n,
							$author$project$Components$Referentiel$Fiche$Update$RacineLue(liens.h0),
							ouverte);
						var annoncee = _v7.a;
						var deLaRacine = _v7.b;
						return _Utils_Tuple2(
							annoncee,
							_Utils_ap(
								effets,
								_Utils_ap(deLOuverture, deLaRacine)));
					case 6:
						var _v8 = _v1.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							function () {
								var _v10 = model.Ih;
								if (_v10.$ === 6) {
									var etape = _v10.a;
									return A2($author$project$Main$Update$ouvrirLeFormulaireDeReference, i18n, etape);
								} else {
									return $elm$core$Basics$identity;
								}
							}()(
								A2(
									$elm$core$Tuple$mapFirst,
									function (ouverte) {
										return _Utils_update(
											ouverte,
											{
												I3: A3($author$project$Main$Update$typologieDeLAdresse, i18n, ouverte.Ih, ouverte.I3)
											});
									},
									function (_v9) {
										var ouverte = _v9.a;
										var deLOuverture = _v9.b;
										return A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$Basics$append(deLOuverture),
											A3(
												$author$project$Main$Update$versLaStructureDuCatalogue,
												i18n,
												A2($author$project$Components$Produits$StructureCatalogue$Update$LiensDesArticlesRecus, liens.h0, liens.gF),
												ouverte));
									}(
										A3(
											$author$project$Main$Update$versLaStructureDuCatalogue,
											i18n,
											$author$project$Components$Produits$StructureCatalogue$Update$Ouverte(liens.h0),
											model)))));
					case 23:
						var id = _v1.a.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLaFicheElement,
								i18n,
								A2($author$project$Components$Produits$FicheElement$Update$Ouverte, id, liens.gF),
								model));
					case 1:
						var _v11 = _v1.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLAccueil,
								i18n,
								$author$project$Components$Accueil$Update$Ouverte(liens.h0),
								model));
					case 10:
						var _v12 = _v1.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLesModelesDeTache,
								i18n,
								$author$project$Components$Parametrage$ModelesDeTache$Update$Ouverte(liens.h0),
								model));
					case 9:
						var _v13 = _v1.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLesPipes,
								i18n,
								$author$project$Components$Parametrage$Pipes$Update$Ouverte(liens.h0),
								model));
					case 11:
						var code = _v1.a.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLEtape1DUnPipe,
								i18n,
								A2($author$project$Components$Parametrage$PipeEtape1$Update$Ouverte, code, liens.h0),
								model));
					case 12:
						var code = _v1.a.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLEtape2DUnPipe,
								i18n,
								A2($author$project$Components$Parametrage$PipeEtape2$Update$Ouverte, code, liens.h0),
								model));
					case 13:
						var code = _v1.a.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLEtape3DUnPipe,
								i18n,
								A2($author$project$Components$Parametrage$PipeEtape3$Update$Ouverte, code, liens.h0),
								model));
					case 14:
						var code = _v1.a.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLEtape4DUnPipe,
								i18n,
								A2($author$project$Components$Parametrage$PipeEtape4$Update$Ouverte, code, liens.h0),
								model));
					case 15:
						var code = _v1.a.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLEtape5DUnPipe,
								i18n,
								A2($author$project$Components$Parametrage$PipeEtape5$Update$Ouverte, code, liens.h0),
								model));
					case 16:
						var code = _v1.a.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLEtape6DUnPipe,
								i18n,
								A2($author$project$Components$Parametrage$PipeEtape6$Update$Ouverte, code, liens.h0),
								model));
					case 17:
						var code = _v1.a.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLEtape7DUnPipe,
								i18n,
								A2($author$project$Components$Parametrage$PipeEtape7$Update$Ouverte, code, liens.h0),
								model));
					case 18:
						var code = _v1.a.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLEtape8DUnPipe,
								i18n,
								A2($author$project$Components$Parametrage$PipeEtape8$Update$Ouverte, code, liens.h0),
								model));
					case 19:
						var code = _v1.a.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLesVersionsDUnPipe,
								i18n,
								A2($author$project$Components$Parametrage$PipeVersions$Update$Ouverte, code, liens.h0),
								model));
					case 21:
						var _v14 = _v1.a;
						var code = _v14.a;
						var formulaire = _v14.b;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLesDestinationsDesChamps,
								i18n,
								A3($author$project$Components$Parametrage$PipeDestinations$Update$Ouverte, code, formulaire, liens.h0),
								model));
					case 20:
						var code = _v1.a.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLUsageDeLOffre,
								i18n,
								A2($author$project$Components$Parametrage$PipeOffreUsage$Update$Ouverte, code, liens.h0),
								model));
					case 22:
						var code = _v1.a.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLesRelationsExigees,
								i18n,
								A2($author$project$Components$Parametrage$PipeRelationsExigees$Update$Ouverte, code, liens.h0),
								model));
					case 35:
						var _v15 = _v1.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A2(
								$author$project$Main$Update$versLesDoublons,
								A2($author$project$Components$Referentiel$Doublons$Update$Ouverte, 0, liens.gF),
								model));
					case 36:
						var _v16 = _v1.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A2(
								$author$project$Main$Update$versLesDoublons,
								A2($author$project$Components$Referentiel$Doublons$Update$Ouverte, 1, liens.gF),
								model));
					case 33:
						var _v17 = _v1.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLesAlertes,
								i18n,
								$author$project$Components$Produits$Alertes$Update$Ouverte(liens.gF),
								model));
					case 34:
						var _v18 = _v1.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLesAlertesDePartiesPrenantes,
								i18n,
								$author$project$Components$Referentiel$Alertes$Update$Ouverte(liens.gF),
								model));
					case 8:
						var _v19 = _v1.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLesMarquesEtGammes,
								i18n,
								$author$project$Components$Produits$MarquesEtGammes$Update$Ouverte(liens.h0),
								model));
					case 40:
						var id = _v1.a.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							function (_v20) {
								var ouverte = _v20.a;
								var effetsDeLaFiche = _v20.b;
								return function (_v22) {
									var avecLesListes = _v22.a;
									var desListes = _v22.b;
									return A2(
										$elm$core$Tuple$mapSecond,
										$elm$core$Basics$append(desListes),
										A3(
											$author$project$Main$Update$versLaFicheType,
											i18n,
											$author$project$Components$Produits$FicheType$Update$LienDesTypesVises(
												A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$typesDePartiePrenante, liens.h0)),
											avecLesListes));
								}(
									function (_v21) {
										var avecLaBibliotheque = _v21.a;
										var deLaBibliotheque = _v21.b;
										return A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$Basics$append(deLaBibliotheque),
											A3(
												$author$project$Main$Update$versLaFicheType,
												i18n,
												$author$project$Components$Produits$FicheType$Update$LienDesListes(
													A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$listes, liens.h0)),
												avecLaBibliotheque));
									}(
										A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$Basics$append(effetsDeLaFiche),
											A3(
												$author$project$Main$Update$versLaFicheType,
												i18n,
												$author$project$Components$Produits$FicheType$Update$LienDeLaBibliotheque(
													A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$bibliothequeDeChamps, liens.h0)),
												ouverte))));
							}(
								A3(
									$author$project$Main$Update$versLaFicheType,
									i18n,
									A2($author$project$Components$Produits$FicheType$Update$Ouverte, id, liens.gF),
									model)));
					case 25:
						var demande = _v1.a.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLeCatalogue,
								i18n,
								A2($author$project$Components$Produits$Catalogue$Update$Ouverte, demande, liens.h0),
								model));
					case 27:
						var _v23 = _v1.a;
						var liens = _v1.b.a;
						var _v24 = A3(
							$author$project$Main$Update$versLeCatalogue,
							i18n,
							A2($author$project$Components$Produits$Catalogue$Update$Ouverte, $author$project$Routes$Route$premiereListeDeReferences, liens.h0),
							model);
						var ouvert = _v24.a;
						var deLOuverture = _v24.b;
						var _v25 = A3($author$project$Main$Update$versLeCatalogue, i18n, $author$project$Components$Produits$Catalogue$Update$NouvelleReferenceOuverte, ouvert);
						var creation = _v25.a;
						var deLaPage = _v25.b;
						return _Utils_Tuple2(
							creation,
							_Utils_ap(
								effets,
								_Utils_ap(deLOuverture, deLaPage)));
					case 26:
						var typologie = _v1.a.a;
						var liens = _v1.b.a;
						var _v26 = A3(
							$author$project$Main$Update$versLeCatalogue,
							i18n,
							A2($author$project$Components$Produits$Catalogue$Update$Ouverte, $author$project$Routes$Route$premiereListeDeReferences, liens.h0),
							model);
						var ouvert = _v26.a;
						var deLOuverture = _v26.b;
						var _v27 = A3(
							$author$project$Main$Update$versLeCatalogue,
							i18n,
							$author$project$Components$Produits$Catalogue$Update$ARangerOuverte(typologie),
							ouvert);
						var aRanger = _v27.a;
						var deLaPage = _v27.b;
						return _Utils_Tuple2(
							aRanger,
							_Utils_ap(
								effets,
								_Utils_ap(deLOuverture, deLaPage)));
					case 28:
						var id = _v1.a.a;
						var liens = _v1.b.a;
						var _v28 = A3(
							$author$project$Main$Update$versLaReference,
							i18n,
							A2($author$project$Components$Produits$Reference$Update$Ouverte, id, liens.gF),
							model);
						var ouverte = _v28.a;
						var deLOuverture = _v28.b;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(
								_Utils_ap(effets, deLOuverture)),
							A3(
								$author$project$Main$Update$versLaReference,
								i18n,
								A2($author$project$Components$Produits$Reference$Update$LiensDeDepotRecus, liens.h0, liens.gF),
								ouverte));
					case 30:
						var _v29 = _v1.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLesOffres,
								i18n,
								$author$project$Components$Produits$Offres$Update$Ouverte(liens.h0),
								model));
					case 31:
						var id = _v1.a.a;
						var liens = _v1.b.a;
						var _v30 = A3(
							$author$project$Main$Update$versLOffre,
							i18n,
							A2($author$project$Components$Produits$Offre$Update$Ouverte, id, liens.gF),
							model);
						var ouverte = _v30.a;
						var deLOuverture = _v30.b;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(
								_Utils_ap(effets, deLOuverture)),
							A3(
								$author$project$Main$Update$versLOffre,
								i18n,
								$author$project$Components$Produits$Offre$Update$RacineLue(liens.h0),
								ouverte));
					case 37:
						var _v31 = _v1.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLesListesDePrix,
								i18n,
								$author$project$Components$Produits$ListesDePrix$Update$Ouverte(liens.h0),
								model));
					case 38:
						var id = _v1.a.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLaListeDePrix,
								i18n,
								A2($author$project$Components$Produits$ListeDePrix$Update$Ouverte, id, liens.gF),
								model));
					case 7:
						var niveau = _v1.a.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLeSchemaDeNiveau,
								i18n,
								A2($author$project$Components$Produits$SchemaDeNiveau$Update$Ouverte, niveau, liens.h0),
								model));
					case 52:
						var _v32 = _v1.a;
						var uid = _v32.a;
						var date = _v32.b;
						var liens = _v1.b.a;
						return A2(
							$author$project$Main$Update$enchainer,
							A2(
								$author$project$Main$Update$versLeGroupe,
								i18n,
								$author$project$Components$Referentiel$Groupe$Update$EquipeOuverte(liens.h0)),
							A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Basics$append(effets),
								A3(
									$author$project$Main$Update$versLeGroupe,
									i18n,
									A3($author$project$Components$Referentiel$Groupe$Update$Ouverte, uid, date, liens.gF),
									model)));
					case 43:
						var _v33 = _v1.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(model, effets),
							A2(
								$elm$core$Maybe$map,
								function (lien) {
									return A2(
										$author$project$Main$Update$enchainer,
										A2(
											$author$project$Main$Update$versLesGroupes,
											i18n,
											$author$project$Components$Referentiel$Groupes$Update$EquipeOuverte(liens.h0)),
										A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$Basics$append(effets),
											A3(
												$author$project$Main$Update$versLesGroupes,
												i18n,
												$author$project$Components$Referentiel$Groupes$Update$Ouverte(lien),
												model)));
								},
								A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$groupes, liens.h0)));
					case 42:
						var _v34 = _v1.a;
						var etape = _v34.a;
						var uid = _v34.b;
						var liens = _v1.b.a;
						var _v35 = A3(
							$author$project$Main$Update$versLesTypesDePartiesPrenantes,
							i18n,
							$author$project$Components$Referentiel$Types$Update$Ouverte(liens.h0),
							model);
						var ouvert = _v35.a;
						var deLOuverture = _v35.b;
						return A3(
							$author$project$Main$Update$reglerLeTypeDeLAdresse,
							i18n,
							uid,
							function () {
								switch (etape) {
									case 5:
										return A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$Basics$append(
												_Utils_ap(effets, deLOuverture)),
											A2(
												$author$project$Main$Update$versLaConservation,
												$author$project$Components$Parametrage$Conservation$Update$OuverteSurLesRegles(liens.h0),
												ouvert));
									case 6:
										return A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$Basics$append(
												_Utils_ap(effets, deLOuverture)),
											A3(
												$author$project$Main$Update$andThenFormes,
												i18n,
												$author$project$Components$Referentiel$Formes$Update$Ouverte(liens.h0),
												A3(
													$author$project$Main$Update$andThenPostes,
													i18n,
													$author$project$Components$Referentiel$Postes$Update$Ouverte(liens.h0),
													A3(
														$author$project$Main$Update$versLesTypesDeRelation,
														i18n,
														$author$project$Components$Referentiel$TypesDeRelation$Update$Ouverte(liens.h0),
														ouvert))));
									default:
										return _Utils_Tuple2(
											ouvert,
											_Utils_ap(effets, deLOuverture));
								}
							}());
					case 60:
						var _v37 = _v1.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A2(
								$author$project$Main$Update$versLeCompteur,
								$author$project$Components$Parametrage$CompteurDeCode$Update$Ouverte(liens.h0),
								model));
					case 61:
						var _v38 = _v1.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A2(
								$author$project$Main$Update$versLeCompteDEnvoi,
								A2(
									$author$project$Components$Parametrage$CompteDEnvoi$Update$Ouverte,
									liens.h0,
									$author$project$Main$Update$nomDuClient(model)),
								model));
					case 63:
						var _v39 = _v1.a;
						var liens = _v1.b.a;
						var session = model.e1;
						var statut = A2(
							$elm$core$Maybe$andThen,
							function (retour) {
								return _Utils_eq(retour.fs, $author$project$Components$Comptes$MonCompte$Update$actionChangerLEmail) ? $elm$core$Maybe$Just(retour.ri) : $elm$core$Maybe$Nothing;
							},
							session.H1);
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A2(
								$author$project$Main$Update$versMonCompte,
								A2($author$project$Components$Comptes$MonCompte$Update$Ouverte, liens.h0, statut),
								_Utils_update(
									model,
									{
										e1: _Utils_update(
											session,
											{H1: $elm$core$Maybe$Nothing})
									})));
					case 64:
						var _v40 = _v1.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3($author$project$Main$Update$ouvrirLaSecurite, 0, liens.h0, model));
					case 65:
						var _v41 = _v1.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3($author$project$Main$Update$ouvrirLaSecurite, 1, liens.h0, model));
					case 66:
						var _v42 = _v1.a;
						var domaine = _v42.a;
						var type_ = _v42.b;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A2(
								$author$project$Main$Update$versLesImports,
								A2(
									$author$project$Components$Imports$Outil$Update$Ouverte,
									liens.h0,
									A2(
										$elm$core$Maybe$map,
										function (d) {
											return _Utils_Tuple2(d, type_);
										},
										domaine)),
								model));
					case 68:
						var lot = _v1.a.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A2(
								$author$project$Main$Update$versLesImports,
								A2($author$project$Components$Imports$Outil$Update$OuverteSurUnLot, liens.h0, lot),
								model));
					case 67:
						var _v43 = _v1.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A2(
								$author$project$Main$Update$versLesImports,
								$author$project$Components$Imports$Outil$Update$OuverteHistorique(liens.h0),
								model));
					case 55:
						var _v44 = _v1.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A2(
								$author$project$Main$Update$versLesLangues,
								A2($author$project$Components$Parametrage$LanguesDuClient$Update$Ouverte, liens.h0, liens.gF),
								model));
					case 56:
						var _v45 = _v1.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLesUtilisateurs,
								i18n,
								A2(
									$author$project$Components$Parametrage$Utilisateurs$Update$Ouverte,
									liens.h0,
									$author$project$Main$Update$nomDuClient(model)),
								model));
					case 57:
						var _v46 = _v1.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLesUtilisateurs,
								i18n,
								A2(
									$author$project$Components$Parametrage$Utilisateurs$Update$SecuriteOuverte,
									liens.h0,
									$author$project$Main$Update$nomDuClient(model)),
								model));
					case 58:
						var uid = _v1.a.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLesUtilisateurs,
								i18n,
								A3(
									$author$project$Components$Parametrage$Utilisateurs$Update$FicheOuverte,
									uid,
									liens.h0,
									$author$project$Main$Update$nomDuClient(model)),
								model));
					case 59:
						var utilisateur = _v1.a.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLesUtilisateurs,
								i18n,
								A3(
									$author$project$Components$Parametrage$Utilisateurs$Update$JournalOuvert,
									utilisateur,
									liens.h0,
									$author$project$Main$Update$nomDuClient(model)),
								model));
					case 54:
						var _v47 = _v1.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A2(
								$author$project$Main$Update$versLaConservation,
								$author$project$Components$Parametrage$Conservation$Update$OuverteSurLesEcheances(liens.h0),
								model));
					case 47:
						var _v48 = _v1.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLesPerimetres,
								i18n,
								A2($author$project$Components$Produits$Perimetres$Update$Ouverte, $elm$core$Maybe$Nothing, liens.h0),
								model));
					case 48:
						var id = _v1.a.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLesPerimetres,
								i18n,
								A2(
									$author$project$Components$Produits$Perimetres$Update$Ouverte,
									$elm$core$Maybe$Just(id),
									liens.h0),
								model));
					case 49:
						var _v49 = _v1.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLesTypesDeQuantite,
								i18n,
								$author$project$Components$Produits$TypesDeQuantite$Update$Ouverte(liens.h0),
								model));
					case 46:
						var _v50 = _v1.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLesCorrespondances,
								i18n,
								A2($author$project$Components$Produits$Correspondances$Update$Ouverte, $elm$core$Maybe$Nothing, liens.h0),
								model));
					case 50:
						var id = _v1.a.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLesCorrespondances,
								i18n,
								A2(
									$author$project$Components$Produits$Correspondances$Update$Ouverte,
									$elm$core$Maybe$Just(id),
									liens.h0),
								model));
					case 44:
						var _v51 = _v1.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLesListes,
								i18n,
								A2($author$project$Components$Produits$Listes$Update$Ouverte, $elm$core$Maybe$Nothing, liens.h0),
								model));
					case 51:
						var champ = _v1.a.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							function (_v53) {
								var ouverte = _v53.a;
								var effetsDeLaPage = _v53.b;
								if (!champ.$) {
									var id = champ.a;
									return A2(
										$elm$core$Tuple$mapSecond,
										$elm$core$Basics$append(effetsDeLaPage),
										A3(
											$author$project$Main$Update$versLaBibliotheque,
											i18n,
											$author$project$Components$Parametrage$BibliothequeDeChamps$Update$FicheDuChampDemandee(id),
											ouverte));
								} else {
									return _Utils_Tuple2(ouverte, effetsDeLaPage);
								}
							}(
								function (_v52) {
									var avecLesCollections = _v52.a;
									var effetsDesCollections = _v52.b;
									return A2(
										$elm$core$Tuple$mapSecond,
										$elm$core$Basics$append(effetsDesCollections),
										A3(
											$author$project$Main$Update$versLaBibliotheque,
											i18n,
											$author$project$Components$Parametrage$BibliothequeDeChamps$Update$Ouverte(liens.h0),
											avecLesCollections));
								}(
									A2(
										$author$project$Main$Update$versLesCollectionsDeChamps,
										$author$project$Components$Parametrage$CollectionsDeChamps$Update$Ouverte(liens.h0),
										model))));
					case 45:
						var id = _v1.a.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLesListes,
								i18n,
								A2(
									$author$project$Components$Produits$Listes$Update$Ouverte,
									$elm$core$Maybe$Just(id),
									liens.h0),
								model));
					case 53:
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							A3(
								$author$project$Main$Update$versLesDroits,
								i18n,
								$author$project$Components$Parametrage$Droits$Update$Ouverte(liens.h0),
								model));
					case 69:
						var _v55 = _v1.a;
						var uid = _v55.a;
						var liens = _v1.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Basics$append(effets),
							function (_v56) {
								var ouverte = _v56.a;
								var deLOuverture = _v56.b;
								return function (_v57) {
									var avecLaBibliotheque = _v57.a;
									var deLaBibliotheque = _v57.b;
									return function (_v58) {
										var avecLesListes = _v58.a;
										var deLesListes = _v58.b;
										return A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$Basics$append(deLesListes),
											A3(
												$author$project$Main$Update$versLeTypeDePartiePrenante,
												i18n,
												$author$project$Components$Referentiel$Type$Update$LienDesCollections(
													A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$collectionsDeChamps, liens.h0)),
												avecLesListes));
									}(
										A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$Basics$append(deLaBibliotheque),
											A3(
												$author$project$Main$Update$versLeTypeDePartiePrenante,
												i18n,
												$author$project$Components$Referentiel$Type$Update$LienDesListes(
													A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$listes, liens.h0)),
												avecLaBibliotheque)));
								}(
									A2(
										$elm$core$Tuple$mapSecond,
										$elm$core$Basics$append(deLOuverture),
										A3(
											$author$project$Main$Update$versLeTypeDePartiePrenante,
											i18n,
											$author$project$Components$Referentiel$Type$Update$LienDeLaBibliotheque(
												A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$bibliothequeDeChamps, liens.h0)),
											ouverte)));
							}(
								A3(
									$author$project$Main$Update$versLeTypeDePartiePrenante,
									i18n,
									A3($author$project$Components$Referentiel$Type$Update$Ouverte, uid, liens.h0, liens.gF),
									model)));
					default:
						break _v1$62;
				}
			} else {
				break _v1$62;
			}
		}
		return _Utils_Tuple2(model, effets);
	});
var $author$project$Main$Update$ouvrirLaPage = F2(
	function (i18n, _v0) {
		var model = _v0.a;
		var effets = _v0.b;
		var _v1 = A2(
			$author$project$Main$Update$ouvrirLaPageDeLaRoute,
			i18n,
			_Utils_Tuple2(model, effets));
		var ouverte = _v1.a;
		var deLaPage = _v1.b;
		var _v2 = $author$project$Main$Update$liensDeLaRacine(ouverte);
		if (!_v2.$) {
			var liens = _v2.a;
			var _v3 = A3($author$project$Main$Update$demanderLesNormes, i18n, liens.gF, ouverte);
			var avecNormes = _v3.a;
			var deNormes = _v3.b;
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Basics$append(deLaPage),
				A2(
					$author$project$Main$Update$andThenDoublons,
					$author$project$Components$Referentiel$Doublons$Update$RacineConnue(liens.gF),
					A3(
						$author$project$Main$Update$andThenAlertesDePartiesPrenantes,
						i18n,
						$author$project$Components$Referentiel$Alertes$Update$RacineConnue(liens.gF),
						A3(
							$author$project$Main$Update$andThenAlertes,
							i18n,
							$author$project$Components$Produits$Alertes$Update$RacineConnue(liens.gF),
							A2(
								$author$project$Main$Update$andThenNotifications,
								$author$project$Components$Notifications$Update$RacineConnue(liens.h0),
								A2(
									$elm$core$Tuple$mapSecond,
									$elm$core$Basics$append(deNormes),
									A2(
										$author$project$Main$Update$versLesNotifications,
										$author$project$Components$Notifications$Update$GabaritsConnus(liens.gF),
										avecNormes)))))));
		} else {
			return _Utils_Tuple2(ouverte, deLaPage);
		}
	});
var $author$project$Components$Demonstration$Model$idChamp = function (formulaire) {
	switch (formulaire) {
		case 0:
			return 'demonstration-partie-prenante-creer-nom';
		case 1:
			return 'demonstration-dossier-creer-nom';
		default:
			return 'demonstration-fiche-modifier-commentaire';
	}
};
var $author$project$Components$Demonstration$Model$setDrawer = F3(
	function (formulaire, nouveau, model) {
		switch (formulaire) {
			case 0:
				return _Utils_update(
					model,
					{ep: nouveau});
			case 1:
				return _Utils_update(
					model,
					{eo: nouveau});
			default:
				return _Utils_update(
					model,
					{eh: nouveau});
		}
	});
var $author$project$Components$Demonstration$Model$quitter = F2(
	function (route, model) {
		var _v0 = $author$project$Components$Demonstration$Model$formulaireDeLaPage(route);
		if (!_v0.$) {
			var formulaire = _v0.a;
			return A3(
				$author$project$Components$Demonstration$Model$setDrawer,
				formulaire,
				$author$project$Components$Shared$Drawer$Model$init(
					A2($author$project$Components$Demonstration$Model$drawer, formulaire, model).Dj),
				_Utils_update(
					model,
					{
						c7: A2(
							$elm$core$Dict$remove,
							$author$project$Components$Demonstration$Model$idChamp(formulaire),
							model.c7)
					}));
		} else {
			return model;
		}
	});
var $author$project$Main$Update$quitterLaFiche = F3(
	function (avant, apres, fiche) {
		var _v0 = _Utils_Tuple2(avant, apres);
		if (_v0.a.$ === 3) {
			if (_v0.b.$ === 3) {
				var _v1 = _v0.a;
				var quittee = _v1.a;
				var _v2 = _v0.b;
				var ouverte = _v2.a;
				return _Utils_eq(quittee, ouverte) ? fiche : $author$project$Components$Referentiel$Fiche$Model$init;
			} else {
				var _v3 = _v0.a;
				return $author$project$Components$Referentiel$Fiche$Model$init;
			}
		} else {
			return fiche;
		}
	});
var $author$project$Main$Update$quitterLeType = F3(
	function (avant, apres, fiche) {
		var _v0 = _Utils_Tuple2(avant, apres);
		if (_v0.a.$ === 69) {
			if (_v0.b.$ === 69) {
				var _v1 = _v0.a;
				var quitte = _v1.a;
				var _v2 = _v0.b;
				var ouvert = _v2.a;
				return _Utils_eq(quitte, ouvert) ? fiche : $author$project$Components$Referentiel$Type$Model$init;
			} else {
				var _v3 = _v0.a;
				return $author$project$Components$Referentiel$Type$Model$init;
			}
		} else {
			return fiche;
		}
	});
var $author$project$Components$Demonstration$Model$annuaire = F2(
	function (choisi, model) {
		if (!choisi) {
			return model.eA;
		} else {
			return model.xJ;
		}
	});
var $author$project$Components$Demonstration$Update$GarderFiltresMasques = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Demonstration$Update$GarderVue = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Demonstration$Update$depuisLAnnuaire = function (effet) {
	if (!effet.$) {
		var cle = effet.a;
		var vue = effet.b;
		return A2($author$project$Components$Demonstration$Update$GarderVue, cle, vue);
	} else {
		var cle = effet.a;
		var masques = effet.b;
		return A2($author$project$Components$Demonstration$Update$GarderFiltresMasques, cle, masques);
	}
};
var $author$project$Components$Demonstration$Model$setAnnuaire = F3(
	function (choisi, nouveau, model) {
		if (!choisi) {
			return _Utils_update(
				model,
				{eA: nouveau});
		} else {
			return _Utils_update(
				model,
				{xJ: nouveau});
		}
	});
var $author$project$Components$Demonstration$Update$PlacerFocus = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Demonstration$Update$depuisLeDrawer = function (effet) {
	var cible = effet;
	return $author$project$Components$Demonstration$Update$PlacerFocus(cible);
};
var $author$project$Components$Demonstration$Model$saisie = F2(
	function (id, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Dict$get, id, model.c7));
	});
var $author$project$Components$Demonstration$Model$saisieEnCours = F2(
	function (formulaire, model) {
		return A2(
			$author$project$Components$Demonstration$Model$saisie,
			$author$project$Components$Demonstration$Model$idChamp(formulaire),
			model) !== '';
	});
var $author$project$Components$Demonstration$Update$surLeDrawer = F3(
	function (formulaire, drawerMsg, model) {
		var _v0 = A3(
			$author$project$Components$Shared$Drawer$Update$update,
			{
				Il: A2($author$project$Components$Demonstration$Model$saisieEnCours, formulaire, model)
			},
			drawerMsg,
			A2($author$project$Components$Demonstration$Model$drawer, formulaire, model));
		var drawer = _v0.a;
		var effets = _v0.b;
		var saisies = $author$project$Components$Shared$Drawer$Model$estOuvert(drawer) ? model.c7 : A2(
			$elm$core$Dict$remove,
			$author$project$Components$Demonstration$Model$idChamp(formulaire),
			model.c7);
		return _Utils_Tuple2(
			A3(
				$author$project$Components$Demonstration$Model$setDrawer,
				formulaire,
				drawer,
				_Utils_update(
					model,
					{c7: saisies})),
			A2($elm$core$List$map, $author$project$Components$Demonstration$Update$depuisLeDrawer, effets));
	});
var $author$project$Components$Demonstration$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var annuaire = msg.a;
				var annuaireMsg = msg.b;
				return A3(
					$elm$core$Tuple$mapBoth,
					function (nouveau) {
						return A3($author$project$Components$Demonstration$Model$setAnnuaire, annuaire, nouveau, model);
					},
					$elm$core$List$map($author$project$Components$Demonstration$Update$depuisLAnnuaire),
					A2(
						$author$project$Components$Shared$Annuaire$Update$update,
						annuaireMsg,
						A2($author$project$Components$Demonstration$Model$annuaire, annuaire, model)));
			case 1:
				var formulaire = msg.a;
				var drawerMsg = msg.b;
				return A3($author$project$Components$Demonstration$Update$surLeDrawer, formulaire, drawerMsg, model);
			case 2:
				var id = msg.a;
				var valeur = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c7: A3($elm$core$Dict$insert, id, valeur, model.c7)
						}),
					_List_Nil);
			case 3:
				var formulaire = msg.a;
				return A3($author$project$Components$Demonstration$Update$surLeDrawer, formulaire, $author$project$Components$Shared$Drawer$Update$Fermer, model);
			default:
				var id = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							mg: _Utils_eq(
								model.mg,
								$elm$core$Maybe$Just(id)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(id)
						}),
					_List_Nil);
		}
	});
var $author$project$Components$Shared$Navigation$Update$ChangerDEspace = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Shared$Navigation$Update$Deconnecter = {$: 2};
var $author$project$Components$Shared$Navigation$Update$GarderMenuReplie = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Shared$Navigation$Update$PlacerFocus = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Shared$Navigation$Model$idRecherche = 'navigation-recherche';
var $author$project$Components$Shared$Navigation$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{j3: !model.j3, l9: false}),
					_List_Nil);
			case 1:
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[
							$author$project$Components$Shared$Navigation$Update$PlacerFocus($author$project$Components$Shared$Navigation$Model$idRecherche)
						]));
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{kG: model.kG && model.qt, qt: !model.qt}),
					_List_fromArray(
						[
							$author$project$Components$Shared$Navigation$Update$GarderMenuReplie(!model.qt)
						]));
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{kG: !model.kG}),
					_List_Nil);
			case 4:
				var nom = msg.a;
				var ouverte = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							kG: true,
							qt: false,
							hU: A3($elm$core$Dict$insert, nom, ouverte || model.qt, model.hU)
						}),
					model.qt ? _List_fromArray(
						[
							$author$project$Components$Shared$Navigation$Update$GarderMenuReplie(false)
						]) : _List_Nil);
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{j3: false}),
					_List_fromArray(
						[$author$project$Components$Shared$Navigation$Update$Deconnecter]));
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{l9: !model.l9}),
					_List_Nil);
			default:
				var cle = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{j3: false, l9: false}),
					_List_fromArray(
						[
							$author$project$Components$Shared$Navigation$Update$ChangerDEspace(cle)
						]));
		}
	});
var $author$project$Components$Socle$Theme$Model$Illisible = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Socle$Theme$Model$NonConforme = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Socle$Theme$Model$Applique = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Socle$Theme$Update$PoserFavicon = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Socle$Theme$Update$Signaler = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Socle$Theme$Model$TokensIgnores = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Socle$Theme$Update$appliquer = F2(
	function (theme, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					gt: $author$project$Components$Socle$Theme$Model$Applique(theme)
				}),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2($elm$core$Maybe$map, $author$project$Components$Socle$Theme$Update$PoserFavicon, theme.gX.mv),
						$elm$core$List$isEmpty(theme.AH) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Components$Socle$Theme$Update$Signaler(
							$author$project$Components$Socle$Theme$Model$TokensIgnores(theme.AH)))
					])));
	});
var $author$project$Components$Socle$Theme$Model$DelaiDepasse = {$: 1};
var $author$project$Components$Socle$Theme$Model$EnErreur = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Socle$Theme$Model$Injoignable = {$: 0};
var $author$project$Components$Shared$Theme$Model$JsonInvalide = {$: 0};
var $author$project$Components$Socle$Theme$Update$causeDe = function (erreur) {
	switch (erreur.$) {
		case 1:
			return $author$project$Components$Socle$Theme$Model$DelaiDepasse;
		case 3:
			var statut = erreur.a;
			return $author$project$Components$Socle$Theme$Model$EnErreur(statut);
		case 2:
			return $author$project$Components$Socle$Theme$Model$Injoignable;
		case 0:
			return $author$project$Components$Socle$Theme$Model$Injoignable;
		default:
			return $author$project$Components$Socle$Theme$Model$Illisible($author$project$Components$Shared$Theme$Model$JsonInvalide);
	}
};
var $author$project$Components$Socle$Theme$Model$Ecarte = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Socle$Theme$Model$ThemeEcarte = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Socle$Theme$Update$ecarter = F2(
	function (cause, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					gt: $author$project$Components$Socle$Theme$Model$Ecarte(cause)
				}),
			_List_fromArray(
				[
					$author$project$Components$Socle$Theme$Update$Signaler(
					$author$project$Components$Socle$Theme$Model$ThemeEcarte(cause))
				]));
	});
var $author$project$Components$Shared$Theme$Model$Theme = F3(
	function (marque, surcharges, inconnus) {
		return {AH: inconnus, gX: marque, Jg: surcharges};
	});
var $author$project$Theme$Asria$Color = 0;
var $author$project$Theme$Asria$Dimension = 1;
var $author$project$Theme$Asria$FontFamily = 2;
var $author$project$Theme$Asria$FontWeight = 3;
var $author$project$Theme$Asria$Number = 4;
var $author$project$Theme$Asria$Shadow = 5;
var $author$project$Theme$Asria$tokens = _List_fromArray(
	[
		{td: $elm$core$Maybe$Nothing, Dj: 'brand-color', rg: 0, fm: '#0a7591'},
		{td: $elm$core$Maybe$Nothing, Dj: 'brand-hover-color', rg: 0, fm: '#075e75'},
		{
		td: $elm$core$Maybe$Just('brand-hover-color'),
		Dj: 'brand-active-color',
		rg: 0,
		fm: '#075e75'
	},
		{
		td: $elm$core$Maybe$Just('brand-hover-color'),
		Dj: 'brand-text-color',
		rg: 0,
		fm: '#075e75'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'brand-nav-accent-color', rg: 0, fm: '#5cc3d9'},
		{td: $elm$core$Maybe$Nothing, Dj: 'brand-subtle-background-color', rg: 0, fm: '#e3f1f5'},
		{td: $elm$core$Maybe$Nothing, Dj: 'on-brand-color', rg: 0, fm: '#ffffff'},
		{
		td: $elm$core$Maybe$Just('brand-color'),
		Dj: 'link-color',
		rg: 0,
		fm: '#0a7591'
	},
		{
		td: $elm$core$Maybe$Just('brand-hover-color'),
		Dj: 'link-hover-color',
		rg: 0,
		fm: '#075e75'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'text-color', rg: 0, fm: '#1b1f24'},
		{td: $elm$core$Maybe$Nothing, Dj: 'text-muted-color', rg: 0, fm: '#5b636e'},
		{td: $elm$core$Maybe$Nothing, Dj: 'label-color', rg: 0, fm: '#5b636e'},
		{td: $elm$core$Maybe$Nothing, Dj: 'heading-color', rg: 0, fm: '#2f4858'},
		{td: $elm$core$Maybe$Nothing, Dj: 'placeholder-color', rg: 0, fm: '#646c77'},
		{td: $elm$core$Maybe$Nothing, Dj: 'border-color', rg: 0, fm: '#e3e6ea'},
		{td: $elm$core$Maybe$Nothing, Dj: 'separator-color', rg: 0, fm: '#e3e6ea'},
		{td: $elm$core$Maybe$Nothing, Dj: 'control-border-color', rg: 0, fm: '#7f8791'},
		{td: $elm$core$Maybe$Nothing, Dj: 'page-background-color', rg: 0, fm: '#f7f8f9'},
		{td: $elm$core$Maybe$Nothing, Dj: 'surface-background-color', rg: 0, fm: '#ffffff'},
		{td: $elm$core$Maybe$Nothing, Dj: 'hover-background-color', rg: 0, fm: '#eef0f2'},
		{
		td: $elm$core$Maybe$Just('brand-subtle-background-color'),
		Dj: 'selected-background-color',
		rg: 0,
		fm: '#e3f1f5'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'disabled-color', rg: 0, fm: '#7f8791'},
		{td: $elm$core$Maybe$Nothing, Dj: 'disabled-background-color', rg: 0, fm: '#eef0f2'},
		{td: $elm$core$Maybe$Nothing, Dj: 'overlay-background-color', rg: 0, fm: '#1b1f247a'},
		{td: $elm$core$Maybe$Nothing, Dj: 'danger-color', rg: 0, fm: '#ce1919'},
		{td: $elm$core$Maybe$Nothing, Dj: 'danger-vivid-color', rg: 0, fm: '#eb5757'},
		{td: $elm$core$Maybe$Nothing, Dj: 'danger-background-color', rg: 0, fm: '#fce4e4'},
		{td: $elm$core$Maybe$Nothing, Dj: 'warning-color', rg: 0, fm: '#af5302'},
		{td: $elm$core$Maybe$Nothing, Dj: 'warning-vivid-color', rg: 0, fm: '#fda95f'},
		{td: $elm$core$Maybe$Nothing, Dj: 'warning-background-color', rg: 0, fm: '#ffefe1'},
		{td: $elm$core$Maybe$Nothing, Dj: 'success-color', rg: 0, fm: '#2c7e2c'},
		{td: $elm$core$Maybe$Nothing, Dj: 'success-vivid-color', rg: 0, fm: '#8cd78c'},
		{td: $elm$core$Maybe$Nothing, Dj: 'success-background-color', rg: 0, fm: '#e8f7e8'},
		{
		td: $elm$core$Maybe$Just('brand-color'),
		Dj: 'focus-outline-color',
		rg: 0,
		fm: '#0a7591'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'focus-outline-width', rg: 1, fm: '0.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'focus-outline-offset', rg: 1, fm: '0.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'font-family', rg: 2, fm: 'Figtree, system-ui, sans-serif'},
		{td: $elm$core$Maybe$Nothing, Dj: 'font-family-mono', rg: 2, fm: 'ui-monospace, Menlo, monospace'},
		{td: $elm$core$Maybe$Nothing, Dj: 'regular-font-weight', rg: 3, fm: '400'},
		{td: $elm$core$Maybe$Nothing, Dj: 'medium-font-weight', rg: 3, fm: '500'},
		{td: $elm$core$Maybe$Nothing, Dj: 'strong-font-weight', rg: 3, fm: '600'},
		{td: $elm$core$Maybe$Nothing, Dj: 'heading-font-weight', rg: 3, fm: '600'},
		{td: $elm$core$Maybe$Nothing, Dj: 'text-font-size', rg: 1, fm: '1.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'small-font-size', rg: 1, fm: '1.3rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'caption-font-size', rg: 1, fm: '1.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'badge-font-size', rg: 1, fm: '1.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'card-title-font-size', rg: 1, fm: '1.6rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'section-title-font-size', rg: 1, fm: '1.8rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'page-title-font-size', rg: 1, fm: '2.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'display-font-size', rg: 1, fm: '3rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'kpi-font-size', rg: 1, fm: '3rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'text-line-height', rg: 4, fm: '1.43'},
		{td: $elm$core$Maybe$Nothing, Dj: 'heading-line-height', rg: 4, fm: '1.33'},
		{td: $elm$core$Maybe$Nothing, Dj: 'badge-border-radius', rg: 1, fm: '0.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'control-border-radius', rg: 1, fm: '0.6rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'card-border-radius', rg: 1, fm: '0.8rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'dialog-border-radius', rg: 1, fm: '1.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'round-border-radius', rg: 1, fm: '999rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'border-width', rg: 1, fm: '0.1rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'strong-border-width', rg: 1, fm: '0.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'space-xs', rg: 1, fm: '0.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'space-s', rg: 1, fm: '0.8rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'space-m', rg: 1, fm: '1.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'space-l', rg: 1, fm: '1.6rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'space-xl', rg: 1, fm: '2.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'space-2xl', rg: 1, fm: '3.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'touch-target-size', rg: 1, fm: '4.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'space-2xs', rg: 1, fm: '0.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'brand-gradient-start-color', rg: 0, fm: '#3a9ee0'},
		{
		td: $elm$core$Maybe$Just('brand-color'),
		Dj: 'brand-gradient-end-color',
		rg: 0,
		fm: '#0a7591'
	},
		{
		td: $elm$core$Maybe$Just('brand-subtle-background-color'),
		Dj: 'icon-pastille-background-color',
		rg: 0,
		fm: '#e3f1f5'
	},
		{
		td: $elm$core$Maybe$Just('brand-color'),
		Dj: 'icon-pastille-color',
		rg: 0,
		fm: '#0a7591'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'svg-xs-size', rg: 1, fm: '1.6rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'svg-s-size', rg: 1, fm: '1.8rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'svg-m-size', rg: 1, fm: '2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'svg-l-size', rg: 1, fm: '2.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'svg-xl-size', rg: 1, fm: '2.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'confirmation-box-shadow', rg: 5, fm: '0rem 2.4rem 6.4rem 0rem #1b1f2452'},
		{td: $elm$core$Maybe$Nothing, Dj: 'card-box-shadow', rg: 5, fm: '0rem 0.2rem 0.8rem 0rem #1b1f240f'},
		{td: $elm$core$Maybe$Nothing, Dj: 'contact-valeur-min-width', rg: 1, fm: '20rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'filters-width', rg: 1, fm: '32rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'drawer-tableau-width', rg: 1, fm: '76rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'confirmation-width', rg: 1, fm: '52rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'kanban-column-width', rg: 1, fm: '25rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'input-height', rg: 1, fm: '4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'button-height', rg: 1, fm: '4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'tag-success-background-color', rg: 0, fm: '#e8f7e8'},
		{td: $elm$core$Maybe$Nothing, Dj: 'tag-success-color', rg: 0, fm: '#2c7e2c'},
		{td: $elm$core$Maybe$Nothing, Dj: 'exceptions-rule-background-color', rg: 0, fm: '#fff7e8'},
		{td: $elm$core$Maybe$Nothing, Dj: 'exceptions-rule-border-color', rg: 0, fm: '#f2c879'},
		{
		td: $elm$core$Maybe$Just('warning-color'),
		Dj: 'exceptions-rule-color',
		rg: 0,
		fm: '#af5302'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'tag-warning-background-color', rg: 0, fm: '#ffefe1'},
		{td: $elm$core$Maybe$Nothing, Dj: 'tag-warning-color', rg: 0, fm: '#af5302'},
		{td: $elm$core$Maybe$Nothing, Dj: 'tag-danger-background-color', rg: 0, fm: '#fce4e4'},
		{td: $elm$core$Maybe$Nothing, Dj: 'tag-danger-color', rg: 0, fm: '#ce1919'},
		{td: $elm$core$Maybe$Nothing, Dj: 'tag-neutral-background-color', rg: 0, fm: '#eef0f2'},
		{td: $elm$core$Maybe$Nothing, Dj: 'tag-neutral-color', rg: 0, fm: '#5b636e'},
		{
		td: $elm$core$Maybe$Just('brand-subtle-background-color'),
		Dj: 'tag-brand-background-color',
		rg: 0,
		fm: '#e3f1f5'
	},
		{
		td: $elm$core$Maybe$Just('brand-text-color'),
		Dj: 'tag-brand-color',
		rg: 0,
		fm: '#075e75'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'pipe-tasks-column-width', rg: 1, fm: '23.6rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'pipe-grid-column-width', rg: 1, fm: '11rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'pipe-grid-step-width', rg: 1, fm: '14rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'pipe-grid-shadow-width', rg: 1, fm: '2.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'pipe-grid-shadow-color', rg: 0, fm: '#1b1f2426'},
		{td: $elm$core$Maybe$Nothing, Dj: 'pipe-grid-bar-height', rg: 1, fm: '0.8rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'bottom-gap', rg: 1, fm: '1.8rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'fixed-gap', rg: 1, fm: '1rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'fiche-gap', rg: 1, fm: '2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'fiche-field-min-width', rg: 1, fm: '18rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'section-padding', rg: 1, fm: '2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'section-gap', rg: 1, fm: '1.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'cartouche-padding-block', rg: 1, fm: '1.6rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'cartouche-padding-inline', rg: 1, fm: '1.8rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'cartouche-gap', rg: 1, fm: '1.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'list-gap', rg: 1, fm: '1rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'cartouche-content-gap', rg: 1, fm: '0.6rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'annuaire-gap', rg: 1, fm: '2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'pagination-gap', rg: 1, fm: '0.6rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'button-padding-inline', rg: 1, fm: '1.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'button-icon-size', rg: 1, fm: '4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'button-small-height', rg: 1, fm: '3.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'button-small-padding-inline', rg: 1, fm: '1rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'occurrence-conditions-columns', rg: 4, fm: '4'},
		{td: $elm$core$Maybe$Nothing, Dj: 'occurrence-geste-height', rg: 1, fm: '2.6rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'occurrence-geste-padding-inline', rg: 1, fm: '0.9rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'occurrence-geste-font-size', rg: 1, fm: '1.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'input-padding-inline', rg: 1, fm: '1rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'input-label-gap', rg: 1, fm: '0.6rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'form-gap', rg: 1, fm: '1.6rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'bascule-height', rg: 1, fm: '3.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'bascule-padding-inline', rg: 1, fm: '1.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'tag-padding-block', rg: 1, fm: '0.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'tag-padding-inline', rg: 1, fm: '0.8rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'tag-gap', rg: 1, fm: '0.6rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'note-padding-block', rg: 1, fm: '1rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'note-padding-inline', rg: 1, fm: '1.2rem'},
		{
		td: $elm$core$Maybe$Just('brand-subtle-background-color'),
		Dj: 'note-information-background-color',
		rg: 0,
		fm: '#e3f1f5'
	},
		{
		td: $elm$core$Maybe$Just('brand-nav-accent-color'),
		Dj: 'note-information-border-color',
		rg: 0,
		fm: '#5cc3d9'
	},
		{
		td: $elm$core$Maybe$Just('brand-text-color'),
		Dj: 'note-information-color',
		rg: 0,
		fm: '#075e75'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'note-validation-background-color', rg: 0, fm: '#e8f7e8'},
		{td: $elm$core$Maybe$Nothing, Dj: 'note-validation-color', rg: 0, fm: '#2c7e2c'},
		{td: $elm$core$Maybe$Nothing, Dj: 'tab-padding-block', rg: 1, fm: '1rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'tab-padding-inline', rg: 1, fm: '1.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'tableau-cell-padding-block', rg: 1, fm: '1rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'tableau-cell-padding-inline', rg: 1, fm: '0.8rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'drawer-padding-block', rg: 1, fm: '2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'drawer-padding-inline', rg: 1, fm: '2.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'drawer-gap', rg: 1, fm: '1.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'drawer-footer-gap', rg: 1, fm: '1rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'confirmation-top', rg: 1, fm: '20rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'confirmation-border-width', rg: 1, fm: '0.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accordeon-padding-block', rg: 1, fm: '1.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accordeon-padding-inline', rg: 1, fm: '1.8rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accordeon-bullet-size', rg: 1, fm: '2.6rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accordeon-indent', rg: 1, fm: '5.6rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'tuile-padding-block', rg: 1, fm: '1.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'tuile-padding-inline', rg: 1, fm: '1.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'tuiles-gap', rg: 1, fm: '1.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'selecteur-norme-max-height', rg: 1, fm: '22rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'kanban-gap', rg: 1, fm: '1rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'kanban-column-padding', rg: 1, fm: '1rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'kanban-column-background-color', rg: 0, fm: '#eef0f2'},
		{td: $elm$core$Maybe$Nothing, Dj: 'indicateur-cle-padding', rg: 1, fm: '1.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'indicateur-cle-min-width', rg: 1, fm: '16rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'barre-repartition-height', rg: 1, fm: '0.8rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'barre-repartition-gap', rg: 1, fm: '0.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'barre-repartition-segment-min-width', rg: 1, fm: '0.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'barre-repartition-legende-gap', rg: 1, fm: '1.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'tuile-lien-mobile-flex-basis', rg: 1, fm: '14rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'tuile-lien-height', rg: 1, fm: '11.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'tuile-lien-icon-size', rg: 1, fm: '3.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'tuile-lien-kpi-font-size', rg: 1, fm: '1.8rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'etiquette-type-height', rg: 1, fm: '2.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'etiquette-type-icon-size', rg: 1, fm: '1.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'session-espaces-max-width', rg: 1, fm: '54rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'session-espaces-logo-size', rg: 1, fm: '4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'session-marque-font-size', rg: 1, fm: '2.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'menu-espace-logo-size', rg: 1, fm: '2.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'image-actuelle-miniature-size', rg: 1, fm: '8rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'image-fichier-vignette-size', rg: 1, fm: '5.6rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'galerie-image-columns', rg: 4, fm: '3'},
		{td: $elm$core$Maybe$Nothing, Dj: 'avatar-fiche-size', rg: 1, fm: '6.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'avatar-fiche-font-size', rg: 1, fm: '2.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'avatar-fiche-gap', rg: 1, fm: '1.8rem'},
		{
		td: $elm$core$Maybe$Just('brand-color'),
		Dj: 'barre-repartition-1-background-color',
		rg: 0,
		fm: '#0a7591'
	},
		{
		td: $elm$core$Maybe$Just('brand-gradient-start-color'),
		Dj: 'barre-repartition-2-background-color',
		rg: 0,
		fm: '#3a9ee0'
	},
		{
		td: $elm$core$Maybe$Just('brand-nav-accent-color'),
		Dj: 'barre-repartition-3-background-color',
		rg: 0,
		fm: '#5cc3d9'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'barre-repartition-4-background-color', rg: 0, fm: '#bde3ec'},
		{
		td: $elm$core$Maybe$Just('brand-subtle-background-color'),
		Dj: 'barre-repartition-5-background-color',
		rg: 0,
		fm: '#e3f1f5'
	},
		{
		td: $elm$core$Maybe$Just('warning-color'),
		Dj: 'accueil-canal-achats-color',
		rg: 0,
		fm: '#af5302'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-tendance-good-color', rg: 0, fm: '#2c7e2c'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-tendance-good-background-color', rg: 0, fm: '#e8f7e8'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-tendance-alert-color', rg: 0, fm: '#ce1919'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-tendance-alert-background-color', rg: 0, fm: '#fce4e4'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-tendance-neutral-color', rg: 0, fm: '#5b636e'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-tendance-neutral-background-color', rg: 0, fm: '#eef0f2'},
		{
		td: $elm$core$Maybe$Just('danger-color'),
		Dj: 'accueil-tuile-retard-color',
		rg: 0,
		fm: '#ce1919'
	},
		{
		td: $elm$core$Maybe$Just('danger-background-color'),
		Dj: 'accueil-tuile-retard-background-color',
		rg: 0,
		fm: '#fce4e4'
	},
		{
		td: $elm$core$Maybe$Just('brand-color'),
		Dj: 'accueil-tuile-validations-color',
		rg: 0,
		fm: '#0a7591'
	},
		{
		td: $elm$core$Maybe$Just('brand-subtle-background-color'),
		Dj: 'accueil-tuile-validations-background-color',
		rg: 0,
		fm: '#e3f1f5'
	},
		{
		td: $elm$core$Maybe$Just('brand-color'),
		Dj: 'accueil-tuile-messages-color',
		rg: 0,
		fm: '#0a7591'
	},
		{
		td: $elm$core$Maybe$Just('brand-subtle-background-color'),
		Dj: 'accueil-tuile-messages-background-color',
		rg: 0,
		fm: '#e3f1f5'
	},
		{
		td: $elm$core$Maybe$Just('brand-color'),
		Dj: 'accueil-tuile-dossiers-color',
		rg: 0,
		fm: '#0a7591'
	},
		{
		td: $elm$core$Maybe$Just('brand-subtle-background-color'),
		Dj: 'accueil-tuile-dossiers-background-color',
		rg: 0,
		fm: '#e3f1f5'
	},
		{
		td: $elm$core$Maybe$Just('brand-color'),
		Dj: 'accueil-tuile-propositions-color',
		rg: 0,
		fm: '#0a7591'
	},
		{
		td: $elm$core$Maybe$Just('brand-subtle-background-color'),
		Dj: 'accueil-tuile-propositions-background-color',
		rg: 0,
		fm: '#e3f1f5'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-tuile-height', rg: 1, fm: '17.6rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-tuile-border-width', rg: 1, fm: '0.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-tuile-pastille-size', rg: 1, fm: '4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-tuile-kpi-font-size', rg: 1, fm: '4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-tuile-hover-box-shadow', rg: 5, fm: '0rem 1.2rem 2.8rem 0rem #0a0e1724'},
		{
		td: $elm$core$Maybe$Just('brand-color'),
		Dj: 'accueil-courbe-color',
		rg: 0,
		fm: '#0a7591'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-piste-background-color', rg: 0, fm: '#eef0f2'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-bento-gap', rg: 1, fm: '1.6rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-campagne-height', rg: 1, fm: '53rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-bloc-min-width', rg: 1, fm: '30rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-reference-code-width', rg: 1, fm: '9rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-reference-value-width', rg: 1, fm: '4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-carrousel-visible-count', rg: 4, fm: '2'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-jauge-height', rg: 1, fm: '0.8rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-avatar-size', rg: 1, fm: '6.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-serie-label-width', rg: 1, fm: '12rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-serie-value-width', rg: 1, fm: '4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-serie-row-height', rg: 1, fm: '3.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-serie-bar-height', rg: 1, fm: '1.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-serie-min-width', rg: 1, fm: '28rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-pastille-min-width', rg: 1, fm: '13rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-pastille-height', rg: 1, fm: '7.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-dossiers-bar-height', rg: 1, fm: '2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-puce-size', rg: 1, fm: '1rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-frise-min-width', rg: 1, fm: '72rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'confirmation-z-index', rg: 4, fm: '21'},
		{td: $elm$core$Maybe$Nothing, Dj: 'parcours-steps-width', rg: 1, fm: '26rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'parcours-steps-max-width', rg: 1, fm: '32rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'parcours-work-width', rg: 1, fm: '52rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'parcours-preview-width', rg: 1, fm: '26rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'parcours-preview-max-width', rg: 1, fm: '34rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'parcours-step-min-height', rg: 1, fm: '5.6rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'parcours-pastille-size', rg: 1, fm: '2.8rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'parcours-schema-node-size', rg: 1, fm: '11.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'parcours-schema-passage-width', rg: 1, fm: '9.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'parcours-schema-return-width', rg: 1, fm: '9rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'parcours-schema-branch-height', rg: 1, fm: '12rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'parcours-schema-end-height', rg: 1, fm: '8.8rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'parcours-etage-min-width', rg: 1, fm: '22rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'parcours-values-column-min-width', rg: 1, fm: '21rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'parcours-preview-background-color', rg: 0, fm: '#1c2b35'},
		{
		td: $elm$core$Maybe$Just('menu-color'),
		Dj: 'parcours-preview-color',
		rg: 0,
		fm: '#ffffff'
	},
		{
		td: $elm$core$Maybe$Just('menu-muted-color'),
		Dj: 'parcours-preview-muted-color',
		rg: 0,
		fm: '#ffffffb8'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'desktop-grid-padding', rg: 1, fm: '4.8rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'tablet-grid-padding', rg: 1, fm: '3.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'mobile-grid-padding', rg: 1, fm: '2.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'squircle-smoothing', rg: 4, fm: '0.26'},
		{td: $elm$core$Maybe$Nothing, Dj: 'drawer-z-index', rg: 4, fm: '100'},
		{td: $elm$core$Maybe$Nothing, Dj: 'fixed-z-index', rg: 4, fm: '97'},
		{td: $elm$core$Maybe$Nothing, Dj: 'menu-z-index', rg: 4, fm: '98'},
		{td: $elm$core$Maybe$Nothing, Dj: 'fixed-min-height', rg: 1, fm: '7.3rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'menu-width', rg: 1, fm: '36rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'menu-replie-width', rg: 1, fm: '16rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'menu-barre-width', rg: 1, fm: '8rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'filters-gap', rg: 1, fm: '2.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'filters-title-margin-right', rg: 1, fm: '4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'filters-title-min-height', rg: 1, fm: '3.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'filters-title-padding-block', rg: 1, fm: '0.2rem'},
		{
		td: $elm$core$Maybe$Just('text-muted-color'),
		Dj: 'breadcrumb-color',
		rg: 0,
		fm: '#5b636e'
	},
		{
		td: $elm$core$Maybe$Just('separator-color'),
		Dj: 'breadcrumb-separator-color',
		rg: 0,
		fm: '#e3e6ea'
	},
		{
		td: $elm$core$Maybe$Just('control-border-radius'),
		Dj: 'button-border-radius',
		rg: 1,
		fm: '0.6rem'
	},
		{
		td: $elm$core$Maybe$Just('border-width'),
		Dj: 'button-border-width',
		rg: 1,
		fm: '0.1rem'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'button-icon-active-background-color', rg: 0, fm: '#00000000'},
		{
		td: $elm$core$Maybe$Just('brand-active-color'),
		Dj: 'button-icon-active-color',
		rg: 0,
		fm: '#075e75'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'button-icon-background-color', rg: 0, fm: '#00000000'},
		{td: $elm$core$Maybe$Nothing, Dj: 'button-icon-border-radius', rg: 1, fm: '0rem'},
		{
		td: $elm$core$Maybe$Just('brand-color'),
		Dj: 'button-icon-color',
		rg: 0,
		fm: '#0a7591'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'button-icon-height', rg: 1, fm: '2.4rem'},
		{
		td: $elm$core$Maybe$Just('brand-color'),
		Dj: 'button-icon-hover-color',
		rg: 0,
		fm: '#0a7591'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'button-icon-hover-background-color', rg: 0, fm: '#00000000'},
		{td: $elm$core$Maybe$Nothing, Dj: 'button-icon-width', rg: 1, fm: '2.4rem'},
		{
		td: $elm$core$Maybe$Just('brand-color'),
		Dj: 'button-primary-background-color',
		rg: 0,
		fm: '#0a7591'
	},
		{
		td: $elm$core$Maybe$Just('brand-color'),
		Dj: 'button-primary-border-color',
		rg: 0,
		fm: '#0a7591'
	},
		{
		td: $elm$core$Maybe$Just('on-brand-color'),
		Dj: 'button-primary-color',
		rg: 0,
		fm: '#ffffff'
	},
		{
		td: $elm$core$Maybe$Just('brand-hover-color'),
		Dj: 'button-primary-hover-background-color',
		rg: 0,
		fm: '#075e75'
	},
		{
		td: $elm$core$Maybe$Just('on-brand-color'),
		Dj: 'button-primary-disabled-color',
		rg: 0,
		fm: '#ffffff'
	},
		{
		td: $elm$core$Maybe$Just('disabled-color'),
		Dj: 'button-primary-disabled-background-color',
		rg: 0,
		fm: '#7f8791'
	},
		{
		td: $elm$core$Maybe$Just('control-border-color'),
		Dj: 'button-secondary-border-color',
		rg: 0,
		fm: '#7f8791'
	},
		{
		td: $elm$core$Maybe$Just('text-color'),
		Dj: 'button-secondary-color',
		rg: 0,
		fm: '#1b1f24'
	},
		{
		td: $elm$core$Maybe$Just('disabled-color'),
		Dj: 'button-secondary-disabled-border-color',
		rg: 0,
		fm: '#7f8791'
	},
		{
		td: $elm$core$Maybe$Just('disabled-color'),
		Dj: 'button-secondary-disabled-color',
		rg: 0,
		fm: '#7f8791'
	},
		{
		td: $elm$core$Maybe$Just('brand-color'),
		Dj: 'button-secondary-hover-border-color',
		rg: 0,
		fm: '#0a7591'
	},
		{
		td: $elm$core$Maybe$Just('brand-color'),
		Dj: 'button-secondary-hover-color',
		rg: 0,
		fm: '#0a7591'
	},
		{
		td: $elm$core$Maybe$Just('brand-color'),
		Dj: 'button-tertiary-color',
		rg: 0,
		fm: '#0a7591'
	},
		{
		td: $elm$core$Maybe$Just('disabled-color'),
		Dj: 'button-tertiary-disabled-color',
		rg: 0,
		fm: '#7f8791'
	},
		{
		td: $elm$core$Maybe$Just('page-background-color'),
		Dj: 'drawer-background-color',
		rg: 0,
		fm: '#f7f8f9'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'drawer-body-spacing', rg: 1, fm: '1.2rem'},
		{
		td: $elm$core$Maybe$Just('space-s'),
		Dj: 'drawer-actions-gap',
		rg: 1,
		fm: '0.8rem'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'drawer-actions-padding-block', rg: 1, fm: '1.6rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'drawer-actions-padding-inline', rg: 1, fm: '3.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'drawer-top-padding-block', rg: 1, fm: '2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'drawer-top-padding-inline', rg: 1, fm: '3.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'drawer-content-padding', rg: 1, fm: '3.2rem'},
		{
		td: $elm$core$Maybe$Just('dialog-border-radius'),
		Dj: 'drawer-border-radius',
		rg: 1,
		fm: '1.2rem'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'drawer-width', rg: 1, fm: '64rem'},
		{
		td: $elm$core$Maybe$Just('surface-background-color'),
		Dj: 'fixed-background-color',
		rg: 0,
		fm: '#ffffff'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'focus-visible-outline-offset', rg: 1, fm: '-0.1rem'},
		{
		td: $elm$core$Maybe$Just('text-muted-color'),
		Dj: 'infos-color',
		rg: 0,
		fm: '#5b636e'
	},
		{
		td: $elm$core$Maybe$Just('control-border-radius'),
		Dj: 'input-border-radius',
		rg: 1,
		fm: '0.6rem'
	},
		{
		td: $elm$core$Maybe$Just('border-width'),
		Dj: 'input-border-width',
		rg: 1,
		fm: '0.1rem'
	},
		{
		td: $elm$core$Maybe$Just('text-font-size'),
		Dj: 'input-font-size',
		rg: 1,
		fm: '1.4rem'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'input-horizontal-padding', rg: 1, fm: '2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'menu-background-color', rg: 0, fm: '#1c2b35'},
		{td: $elm$core$Maybe$Nothing, Dj: 'menu-color', rg: 0, fm: '#ffffff'},
		{td: $elm$core$Maybe$Nothing, Dj: 'menu-muted-color', rg: 0, fm: '#ffffffb8'},
		{
		td: $elm$core$Maybe$Just('surface-background-color'),
		Dj: 'input-background-color',
		rg: 0,
		fm: '#ffffff'
	},
		{
		td: $elm$core$Maybe$Just('control-border-color'),
		Dj: 'input-border-color',
		rg: 0,
		fm: '#7f8791'
	},
		{
		td: $elm$core$Maybe$Just('text-muted-color'),
		Dj: 'input-hover-border-color',
		rg: 0,
		fm: '#5b636e'
	},
		{
		td: $elm$core$Maybe$Just('border-color'),
		Dj: 'input-disabled-border-color',
		rg: 0,
		fm: '#e3e6ea'
	},
		{
		td: $elm$core$Maybe$Just('danger-vivid-color'),
		Dj: 'input-error-border-color',
		rg: 0,
		fm: '#eb5757'
	},
		{
		td: $elm$core$Maybe$Just('surface-background-color'),
		Dj: 'section-background-color',
		rg: 0,
		fm: '#ffffff'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'menu-body-spacing', rg: 1, fm: '1.2rem'},
		{
		td: $elm$core$Maybe$Just('dialog-border-radius'),
		Dj: 'menu-border-radius',
		rg: 1,
		fm: '1.2rem'
	},
		{
		td: $elm$core$Maybe$Just('disabled-background-color'),
		Dj: 'readonly-background-color',
		rg: 0,
		fm: '#eef0f2'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'svg-height', rg: 1, fm: '2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'svg-width', rg: 1, fm: '2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'svg-secondary-opacity', rg: 4, fm: '0.4'},
		{td: $elm$core$Maybe$Nothing, Dj: 'svg-stroke-width', rg: 4, fm: '1.75'},
		{
		td: $elm$core$Maybe$Just('text-muted-color'),
		Dj: 'tab-color',
		rg: 0,
		fm: '#5b636e'
	},
		{
		td: $elm$core$Maybe$Just('text-color'),
		Dj: 'tab-hover-color',
		rg: 0,
		fm: '#1b1f24'
	},
		{
		td: $elm$core$Maybe$Just('brand-color'),
		Dj: 'tab-active-color',
		rg: 0,
		fm: '#0a7591'
	},
		{
		td: $elm$core$Maybe$Just('text-font-size'),
		Dj: 'tab-font-size',
		rg: 1,
		fm: '1.4rem'
	},
		{
		td: $elm$core$Maybe$Just('brand-color'),
		Dj: 'tab-active-background-color',
		rg: 0,
		fm: '#0a7591'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'tab-active-border-radius', rg: 1, fm: '0.2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'tabs-gap', rg: 1, fm: '2.4rem'},
		{
		td: $elm$core$Maybe$Just('text-muted-color'),
		Dj: 'tag-color',
		rg: 0,
		fm: '#5b636e'
	},
		{
		td: $elm$core$Maybe$Just('badge-font-size'),
		Dj: 'tag-font-size',
		rg: 1,
		fm: '1.2rem'
	},
		{
		td: $elm$core$Maybe$Just('surface-background-color'),
		Dj: 'top-background-color',
		rg: 0,
		fm: '#ffffff'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-tuile-padding', rg: 1, fm: '1.8rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-tuile-padding-bottom', rg: 1, fm: '1.6rem'},
		{
		td: $elm$core$Maybe$Just('hover-background-color'),
		Dj: 'accueil-tuile-border-color',
		rg: 0,
		fm: '#eef0f2'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-campagne-padding', rg: 1, fm: '2rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-campagne-ca-min-height', rg: 1, fm: '4.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-campagne-chiffre-min-height', rg: 1, fm: '8rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-campagne-chiffre-padding-block', rg: 1, fm: '1rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-tuile-kpi-letter-spacing', rg: 1, fm: '-0.08rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-etape-min-height', rg: 1, fm: '6rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-etape-pointe-width', rg: 1, fm: '1rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-etape-overlap', rg: 1, fm: '0.6rem'},
		{
		td: $elm$core$Maybe$Just('brand-subtle-background-color'),
		Dj: 'accueil-etape-background-color',
		rg: 0,
		fm: '#e3f1f5'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'accueil-etape-chargee-background-color', rg: 0, fm: '#bde3ec'},
		{
		td: $elm$core$Maybe$Just('brand-hover-color'),
		Dj: 'accueil-etape-count-color',
		rg: 0,
		fm: '#075e75'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'tuile-lien-padding-inline-end', rg: 1, fm: '4rem'},
		{
		td: $elm$core$Maybe$Just('hover-background-color'),
		Dj: 'tuile-lien-border-color',
		rg: 0,
		fm: '#eef0f2'
	},
		{td: $elm$core$Maybe$Nothing, Dj: 'fiche-tableau-header-height', rg: 1, fm: '4.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'fiche-tableau-row-height', rg: 1, fm: '6.4rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'nom-par-langue-label-width', rg: 1, fm: '14rem'},
		{td: $elm$core$Maybe$Nothing, Dj: 'nom-par-langue-langue-reference-font-size', rg: 1, fm: '1.2rem'}
	]);
var $author$project$Components$Shared$Theme$API$QueryAPIModel$sorteDe = function (nom) {
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.rg;
		},
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (token) {
					return _Utils_eq(token.Dj, nom);
				},
				$author$project$Theme$Asria$tokens)));
};
var $author$project$Components$Shared$Theme$API$QueryAPIModel$inconnus = function (tokens) {
	return A2(
		$elm$core$List$filter,
		function (nom) {
			return _Utils_eq(
				$author$project$Components$Shared$Theme$API$QueryAPIModel$sorteDe(nom),
				$elm$core$Maybe$Nothing);
		},
		A2($elm$core$List$map, $elm$core$Tuple$first, tokens));
};
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $author$project$Components$Shared$Theme$API$QueryAPIModel$combiner = A2(
	$elm$core$List$foldr,
	$elm$core$Result$map2($elm$core$List$cons),
	$elm$core$Result$Ok(_List_Nil));
var $author$project$Components$Shared$Theme$Model$Surcharge = F2(
	function (nom, valeur) {
		return {Dj: nom, fm: valeur};
	});
var $author$project$Components$Shared$Theme$Model$AliasRecu = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Shared$Theme$Model$TypeDifferent = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Shared$Theme$Model$ValeurHorsGrammaire = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Shared$Theme$API$QueryAPIModel$valeur = F2(
	function (decoder, brut) {
		return $elm$core$Result$toMaybe(
			A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$field, '$value', decoder),
				brut));
	});
var $author$project$Components$Shared$Theme$API$QueryAPIModel$estUnAlias = function (brut) {
	var _v0 = A2($author$project$Components$Shared$Theme$API$QueryAPIModel$valeur, $elm$json$Json$Decode$string, brut);
	if (!_v0.$) {
		var texte = _v0.a;
		return A2($elm$core$String$startsWith, '{', texte) && A2($elm$core$String$endsWith, '}', texte);
	} else {
		return false;
	}
};
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $author$project$Components$Shared$Theme$Model$Couleur = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Shared$Theme$Model$Dimension = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Shared$Theme$Model$Graisse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Shared$Theme$Model$Nombre = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Shared$Theme$Model$OmbrePortee = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Shared$Theme$Model$Polices = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Shared$Theme$API$QueryAPIModel$couleur = function (texte) {
	var _v0 = $elm$core$String$uncons(texte);
	if ((!_v0.$) && ('#' === _v0.a.a)) {
		var _v1 = _v0.a;
		var chiffres = _v1.b;
		return (A2(
			$elm$core$List$member,
			$elm$core$String$length(chiffres),
			_List_fromArray(
				[6, 8])) && A2($elm$core$String$all, $elm$core$Char$isHexDigit, chiffres)) ? $elm$core$Maybe$Just(
			$elm$core$String$toLower(texte)) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Shared$Theme$API$QueryAPIModel$fini = function (reel) {
	return ($elm$core$Basics$isInfinite(reel) || $elm$core$Basics$isNaN(reel)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(reel);
};
var $author$project$Components$Shared$Theme$API$QueryAPIModel$graisse = function (entier) {
	return ((entier >= 1) && (entier <= 1000)) ? $elm$core$Maybe$Just(entier) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$Shared$Theme$API$QueryAPIModel$estUnNomDePolice = function (nom) {
	var _v0 = $elm$core$String$uncons(nom);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var premier = _v1.a;
		var reste = _v1.b;
		return $elm$core$Char$isAlphaNum(premier) && A2(
			$elm$core$String$all,
			function (c) {
				return $elm$core$Char$isAlphaNum(c) || ((c === ' ') || (c === '-'));
			},
			reste);
	} else {
		return false;
	}
};
var $author$project$Components$Shared$Theme$API$QueryAPIModel$nomsDePolice = function (noms) {
	return ((!$elm$core$List$isEmpty(noms)) && A2($elm$core$List$all, $author$project$Components$Shared$Theme$API$QueryAPIModel$estUnNomDePolice, noms)) ? $elm$core$Maybe$Just(noms) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$Shared$Theme$Model$Ombre = F5(
	function (decalageX, decalageY, flou, etendue, couleur) {
		return {kf: couleur, wJ: decalageX, wK: decalageY, aw: etendue, zN: flou};
	});
var $elm$core$Maybe$map5 = F6(
	function (func, ma, mb, mc, md, me) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					if (md.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var d = md.a;
						if (me.$ === 1) {
							return $elm$core$Maybe$Nothing;
						} else {
							var e = me.a;
							return $elm$core$Maybe$Just(
								A5(func, a, b, c, d, e));
						}
					}
				}
			}
		}
	});
var $author$project$Components$Shared$Theme$API$QueryAPIModel$decimal = function (texte) {
	var sansSigne = A2($elm$core$String$startsWith, '-', texte) ? A2($elm$core$String$dropLeft, 1, texte) : texte;
	var chiffres = function (partie) {
		return (!$elm$core$String$isEmpty(partie)) && A2($elm$core$String$all, $elm$core$Char$isDigit, partie);
	};
	var admis = function () {
		var _v0 = A2($elm$core$String$split, '.', sansSigne);
		_v0$2:
		while (true) {
			if (_v0.b) {
				if (!_v0.b.b) {
					var entier = _v0.a;
					return chiffres(entier);
				} else {
					if (!_v0.b.b.b) {
						var entier = _v0.a;
						var _v1 = _v0.b;
						var fraction = _v1.a;
						return A2($elm$core$String$all, $elm$core$Char$isDigit, entier) && chiffres(fraction);
					} else {
						break _v0$2;
					}
				}
			} else {
				break _v0$2;
			}
		}
		return false;
	}();
	return admis ? $elm$core$String$toFloat(texte) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$Shared$Theme$API$QueryAPIModel$rem = function (texte) {
	return A2($elm$core$String$endsWith, 'rem', texte) ? $author$project$Components$Shared$Theme$API$QueryAPIModel$decimal(
		A2($elm$core$String$dropRight, 3, texte)) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$Shared$Theme$API$QueryAPIModel$ombre = A6(
	$elm$json$Json$Decode$map5,
	F5(
		function (x, y, flou, etendue, teinte) {
			return A6(
				$elm$core$Maybe$map5,
				$author$project$Components$Shared$Theme$Model$Ombre,
				$author$project$Components$Shared$Theme$API$QueryAPIModel$rem(x),
				$author$project$Components$Shared$Theme$API$QueryAPIModel$rem(y),
				$author$project$Components$Shared$Theme$API$QueryAPIModel$rem(flou),
				$author$project$Components$Shared$Theme$API$QueryAPIModel$rem(etendue),
				$author$project$Components$Shared$Theme$API$QueryAPIModel$couleur(teinte));
		}),
	A2($elm$json$Json$Decode$field, 'offsetX', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'offsetY', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'blur', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'spread', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'color', $elm$json$Json$Decode$string));
var $author$project$Components$Shared$Theme$API$QueryAPIModel$polices = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$map, $elm$core$List$singleton, $elm$json$Json$Decode$string)
		]));
var $author$project$Components$Shared$Theme$API$QueryAPIModel$lireValeur = F2(
	function (sorte, brut) {
		switch (sorte) {
			case 0:
				return A2(
					$elm$core$Maybe$map,
					$author$project$Components$Shared$Theme$Model$Couleur,
					A2(
						$elm$core$Maybe$andThen,
						$author$project$Components$Shared$Theme$API$QueryAPIModel$couleur,
						A2($author$project$Components$Shared$Theme$API$QueryAPIModel$valeur, $elm$json$Json$Decode$string, brut)));
			case 1:
				return A2(
					$elm$core$Maybe$map,
					$author$project$Components$Shared$Theme$Model$Dimension,
					A2(
						$elm$core$Maybe$andThen,
						$author$project$Components$Shared$Theme$API$QueryAPIModel$rem,
						A2($author$project$Components$Shared$Theme$API$QueryAPIModel$valeur, $elm$json$Json$Decode$string, brut)));
			case 2:
				return A2(
					$elm$core$Maybe$map,
					$author$project$Components$Shared$Theme$Model$Polices,
					A2(
						$elm$core$Maybe$andThen,
						$author$project$Components$Shared$Theme$API$QueryAPIModel$nomsDePolice,
						A2($author$project$Components$Shared$Theme$API$QueryAPIModel$valeur, $author$project$Components$Shared$Theme$API$QueryAPIModel$polices, brut)));
			case 3:
				return A2(
					$elm$core$Maybe$map,
					$author$project$Components$Shared$Theme$Model$Graisse,
					A2(
						$elm$core$Maybe$andThen,
						$author$project$Components$Shared$Theme$API$QueryAPIModel$graisse,
						A2($author$project$Components$Shared$Theme$API$QueryAPIModel$valeur, $elm$json$Json$Decode$int, brut)));
			case 4:
				return A2(
					$elm$core$Maybe$map,
					$author$project$Components$Shared$Theme$Model$Nombre,
					A2(
						$elm$core$Maybe$andThen,
						$author$project$Components$Shared$Theme$API$QueryAPIModel$fini,
						A2($author$project$Components$Shared$Theme$API$QueryAPIModel$valeur, $elm$json$Json$Decode$float, brut)));
			default:
				return A2(
					$elm$core$Maybe$map,
					$author$project$Components$Shared$Theme$Model$OmbrePortee,
					A2(
						$elm$core$Maybe$andThen,
						$elm$core$Basics$identity,
						A2($author$project$Components$Shared$Theme$API$QueryAPIModel$valeur, $author$project$Components$Shared$Theme$API$QueryAPIModel$ombre, brut)));
		}
	});
var $author$project$Components$Shared$Theme$API$QueryAPIModel$nomDeSorte = function (sorte) {
	switch (sorte) {
		case 0:
			return 'color';
		case 1:
			return 'dimension';
		case 2:
			return 'fontFamily';
		case 3:
			return 'fontWeight';
		case 4:
			return 'number';
		default:
			return 'shadow';
	}
};
var $author$project$Components$Shared$Theme$Model$AlphaDansUnCouple = function (a) {
	return {$: 6, a: a};
};
var $author$project$Theme$Asria$opaques = _List_fromArray(
	['text-color', 'surface-background-color', 'page-background-color', 'text-muted-color', 'label-color', 'focus-outline-color', 'brand-color', 'brand-subtle-background-color', 'selected-background-color', 'hover-background-color', 'link-color', 'on-brand-color', 'danger-color', 'warning-color', 'warning-background-color', 'exceptions-rule-color', 'exceptions-rule-background-color', 'tag-success-color', 'tag-success-background-color', 'tag-warning-color', 'tag-warning-background-color', 'tag-danger-color', 'tag-danger-background-color', 'tag-neutral-color', 'tag-neutral-background-color', 'tag-brand-color', 'brand-text-color', 'brand-hover-color', 'tag-brand-background-color', 'control-border-color', 'kanban-column-background-color', 'brand-active-color', 'note-information-color', 'note-information-background-color', 'note-validation-color', 'note-validation-background-color', 'link-hover-color', 'success-color', 'success-background-color', 'danger-background-color', 'heading-color', 'placeholder-color']);
var $author$project$Components$Shared$Theme$API$QueryAPIModel$verifierOpacite = F2(
	function (nom, lue) {
		if (!lue.$) {
			var hexadecimale = lue.a;
			return (($elm$core$String$length(hexadecimale) === 9) && A2($elm$core$List$member, nom, $author$project$Theme$Asria$opaques)) ? $elm$core$Result$Err(
				$author$project$Components$Shared$Theme$Model$AlphaDansUnCouple(nom)) : $elm$core$Result$Ok(lue);
		} else {
			return $elm$core$Result$Ok(lue);
		}
	});
var $author$project$Components$Shared$Theme$API$QueryAPIModel$lireToken = F3(
	function (sorte, nom, brut) {
		return (!_Utils_eq(
			A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$field, '$type', $elm$json$Json$Decode$string),
				brut),
			$elm$core$Result$Ok(
				$author$project$Components$Shared$Theme$API$QueryAPIModel$nomDeSorte(sorte)))) ? $elm$core$Result$Err(
			$author$project$Components$Shared$Theme$Model$TypeDifferent(nom)) : ($author$project$Components$Shared$Theme$API$QueryAPIModel$estUnAlias(brut) ? $elm$core$Result$Err(
			$author$project$Components$Shared$Theme$Model$AliasRecu(nom)) : A2(
			$elm$core$Result$andThen,
			$author$project$Components$Shared$Theme$API$QueryAPIModel$verifierOpacite(nom),
			A2(
				$elm$core$Result$fromMaybe,
				$author$project$Components$Shared$Theme$Model$ValeurHorsGrammaire(nom),
				A2($author$project$Components$Shared$Theme$API$QueryAPIModel$lireValeur, sorte, brut))));
	});
var $author$project$Components$Shared$Theme$API$QueryAPIModel$lireSurcharge = function (_v0) {
	var nom = _v0.a;
	var brut = _v0.b;
	return A2(
		$elm$core$Maybe$map,
		function (sorte) {
			return A2(
				$elm$core$Result$map,
				$author$project$Components$Shared$Theme$Model$Surcharge(nom),
				A3($author$project$Components$Shared$Theme$API$QueryAPIModel$lireToken, sorte, nom, brut));
		},
		$author$project$Components$Shared$Theme$API$QueryAPIModel$sorteDe(nom));
};
var $author$project$Components$Shared$Theme$API$QueryAPIModel$lireSurcharges = function (tokens) {
	return $author$project$Components$Shared$Theme$API$QueryAPIModel$combiner(
		A2($elm$core$List$filterMap, $author$project$Components$Shared$Theme$API$QueryAPIModel$lireSurcharge, tokens));
};
var $author$project$Components$Shared$Theme$API$QueryAPIModel$assembler = F2(
	function (marque, tokens) {
		return A2(
			$elm$core$Result$map,
			function (surcharges) {
				return A3(
					$author$project$Components$Shared$Theme$Model$Theme,
					marque,
					surcharges,
					$author$project$Components$Shared$Theme$API$QueryAPIModel$inconnus(tokens));
			},
			$author$project$Components$Shared$Theme$API$QueryAPIModel$lireSurcharges(tokens));
	});
var $author$project$Components$Shared$Theme$Model$Marque = F5(
	function (nom, logo, favicon, police, applications) {
		return {tz: applications, mv: favicon, n$: logo, Dj: nom, pq: police};
	});
var $author$project$Components$Shared$Theme$Model$MarqueHorsGrammaire = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Shared$Theme$Model$Application = F5(
	function (cle, nom, icone, adresse, courante) {
		return {aa: adresse, dy: cle, wj: courante, aC: icone, Dj: nom};
	});
var $author$project$Components$Shared$Theme$API$MarqueAPIModel$cle = function (texte) {
	return ((!$elm$core$String$isEmpty(texte)) && A2(
		$elm$core$String$all,
		function (c) {
			return $elm$core$Char$isLower(c) || ($elm$core$Char$isDigit(c) || (c === '-'));
		},
		texte)) ? $elm$core$Maybe$Just(texte) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$Shared$Theme$API$MarqueAPIModel$estDeChemin = function (c) {
	return $elm$core$Char$isAlphaNum(c) || A2(
		$elm$core$List$member,
		c,
		_List_fromArray(
			['/', '.', '_', '~', '-']));
};
var $author$project$Components$Shared$Theme$API$MarqueAPIModel$estUnHote = function (hote) {
	var nonVide = F2(
		function (verifier, texte) {
			return (!$elm$core$String$isEmpty(texte)) && A2($elm$core$String$all, verifier, texte);
		});
	var estDeNom = function (c) {
		return $elm$core$Char$isLower(c) || ($elm$core$Char$isDigit(c) || ((c === '.') || (c === '-')));
	};
	var _v0 = A2($elm$core$String$split, ':', hote);
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (!_v0.b.b) {
				var nomDHote = _v0.a;
				return A2(nonVide, estDeNom, nomDHote);
			} else {
				if (!_v0.b.b.b) {
					var nomDHote = _v0.a;
					var _v1 = _v0.b;
					var port_ = _v1.a;
					return A2(nonVide, estDeNom, nomDHote) && A2(nonVide, $elm$core$Char$isDigit, port_);
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return false;
};
var $author$project$Components$Shared$Theme$API$MarqueAPIModel$schema = 'https://';
var $author$project$Components$Shared$Theme$API$MarqueAPIModel$origine = function (adresse) {
	var reste = A2(
		$elm$core$String$dropLeft,
		$elm$core$String$length($author$project$Components$Shared$Theme$API$MarqueAPIModel$schema),
		adresse);
	var hote = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			A2($elm$core$String$split, '/', reste)));
	var chemin = A2(
		$elm$core$String$dropLeft,
		$elm$core$String$length(hote),
		reste);
	return (A2($elm$core$String$startsWith, $author$project$Components$Shared$Theme$API$MarqueAPIModel$schema, adresse) && ($author$project$Components$Shared$Theme$API$MarqueAPIModel$estUnHote(hote) && A2($elm$core$String$all, $author$project$Components$Shared$Theme$API$MarqueAPIModel$estDeChemin, chemin))) ? $elm$core$Maybe$Just(
		_Utils_ap($author$project$Components$Shared$Theme$API$MarqueAPIModel$schema, hote)) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$Shared$Theme$API$MarqueAPIModel$fichier = F2(
	function (origines, adresse) {
		return A2(
			$elm$core$Maybe$andThen,
			function (lue) {
				return A2($elm$core$List$member, lue, origines) ? $elm$core$Maybe$Just(adresse) : $elm$core$Maybe$Nothing;
			},
			$author$project$Components$Shared$Theme$API$MarqueAPIModel$origine(adresse));
	});
var $elm$core$Maybe$map4 = F5(
	function (func, ma, mb, mc, md) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					if (md.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var d = md.a;
						return $elm$core$Maybe$Just(
							A4(func, a, b, c, d));
					}
				}
			}
		}
	});
var $author$project$Components$Shared$Theme$API$MarqueAPIModel$nom = function (texte) {
	return ($elm$core$String$isEmpty(
		$elm$core$String$trim(texte)) || ($elm$core$String$length(texte) > 60)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(texte);
};
var $author$project$Components$Shared$Theme$API$MarqueAPIModel$application = F2(
	function (origines, lue) {
		return A5(
			$elm$core$Maybe$map4,
			F4(
				function (cleLue, nomLu, icone, adresse) {
					return A5($author$project$Components$Shared$Theme$Model$Application, cleLue, nomLu, icone, adresse, lue.wj);
				}),
			$author$project$Components$Shared$Theme$API$MarqueAPIModel$cle(lue.dy),
			$author$project$Components$Shared$Theme$API$MarqueAPIModel$nom(lue.Dj),
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Maybe$Just($elm$core$Maybe$Nothing),
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Shared$Theme$API$MarqueAPIModel$fichier(origines),
						$elm$core$Maybe$map($elm$core$Maybe$Just)),
					lue.aC)),
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$always(lue.aa),
				$author$project$Components$Shared$Theme$API$MarqueAPIModel$origine(lue.aa)));
	});
var $author$project$Components$Shared$Theme$API$MarqueAPIModel$facultatif = F2(
	function (nomDuChamp, decoder) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (present) {
				return _Utils_eq(present, $elm$core$Maybe$Nothing) ? $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing) : A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$Just,
					A2($elm$json$Json$Decode$field, nomDuChamp, decoder));
			},
			$elm$json$Json$Decode$maybe(
				A2($elm$json$Json$Decode$field, nomDuChamp, $elm$json$Json$Decode$value)));
	});
var $author$project$Components$Shared$Theme$API$MarqueAPIModel$applicationDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Components$Shared$Theme$Model$Application,
	A2($elm$json$Json$Decode$field, 'cle', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'nom', $elm$json$Json$Decode$string),
	A2($author$project$Components$Shared$Theme$API$MarqueAPIModel$facultatif, 'icone', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'adresse', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault(false),
		A2($author$project$Components$Shared$Theme$API$MarqueAPIModel$facultatif, 'courante', $elm$json$Json$Decode$bool)));
var $author$project$Components$Shared$Theme$API$MarqueAPIModel$champ = F4(
	function (nomDuChamp, decoder, valider, brut) {
		var _v0 = A2(
			$elm$json$Json$Decode$decodeValue,
			A2($author$project$Components$Shared$Theme$API$MarqueAPIModel$facultatif, nomDuChamp, decoder),
			brut);
		if (!_v0.$) {
			if (_v0.a.$ === 1) {
				var _v1 = _v0.a;
				return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
			} else {
				var lu = _v0.a.a;
				return A2(
					$elm$core$Result$fromMaybe,
					$author$project$Components$Shared$Theme$Model$MarqueHorsGrammaire(nomDuChamp),
					A2(
						$elm$core$Maybe$map,
						$elm$core$Maybe$Just,
						valider(lu)));
			}
		} else {
			return $elm$core$Result$Err(
				$author$project$Components$Shared$Theme$Model$MarqueHorsGrammaire(nomDuChamp));
		}
	});
var $elm$core$Result$map5 = F6(
	function (func, ra, rb, rc, rd, re) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				if (rc.$ === 1) {
					var x = rc.a;
					return $elm$core$Result$Err(x);
				} else {
					var c = rc.a;
					if (rd.$ === 1) {
						var x = rd.a;
						return $elm$core$Result$Err(x);
					} else {
						var d = rd.a;
						if (re.$ === 1) {
							var x = re.a;
							return $elm$core$Result$Err(x);
						} else {
							var e = re.a;
							return $elm$core$Result$Ok(
								A5(func, a, b, c, d, e));
						}
					}
				}
			}
		}
	});
var $author$project$Components$Shared$Theme$Model$marqueAsria = {tz: $elm$core$Maybe$Nothing, mv: $elm$core$Maybe$Nothing, n$: $elm$core$Maybe$Nothing, Dj: $elm$core$Maybe$Nothing, pq: $elm$core$Maybe$Nothing};
var $author$project$Components$Shared$Theme$Model$PoliceDeMarque = F2(
	function (famille, fichiers) {
		return {zj: famille, zB: fichiers};
	});
var $author$project$Components$Shared$Theme$API$MarqueAPIModel$tous = function (valider) {
	return A2(
		$elm$core$List$foldr,
		function (element) {
			return A2(
				$elm$core$Maybe$map2,
				$elm$core$List$cons,
				valider(element));
		},
		$elm$core$Maybe$Just(_List_Nil));
};
var $author$project$Components$Shared$Theme$API$MarqueAPIModel$police = F3(
	function (estUnNomDePolice, origines, lue) {
		return (estUnNomDePolice(lue.zj) && (!$elm$core$List$isEmpty(lue.zB))) ? A2(
			$elm$core$Maybe$map,
			$author$project$Components$Shared$Theme$Model$PoliceDeMarque(lue.zj),
			A2(
				$author$project$Components$Shared$Theme$API$MarqueAPIModel$tous,
				$author$project$Components$Shared$Theme$API$MarqueAPIModel$fichier(origines),
				lue.zB)) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$Shared$Theme$API$MarqueAPIModel$policeDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Components$Shared$Theme$Model$PoliceDeMarque,
	A2($elm$json$Json$Decode$field, 'famille', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'fichiers',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
var $author$project$Components$Shared$Theme$API$MarqueAPIModel$lire = F3(
	function (estUnNomDePolice, origines, document) {
		var _v0 = A2(
			$elm$json$Json$Decode$decodeValue,
			A2($elm$json$Json$Decode$field, 'marque', $elm$json$Json$Decode$value),
			document);
		if (_v0.$ === 1) {
			return $elm$core$Result$Ok($author$project$Components$Shared$Theme$Model$marqueAsria);
		} else {
			var brut = _v0.a;
			var _v1 = A2(
				$elm$json$Json$Decode$decodeValue,
				$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value),
				brut);
			if (_v1.$ === 1) {
				return $elm$core$Result$Err(
					$author$project$Components$Shared$Theme$Model$MarqueHorsGrammaire('marque'));
			} else {
				return A6(
					$elm$core$Result$map5,
					$author$project$Components$Shared$Theme$Model$Marque,
					A4($author$project$Components$Shared$Theme$API$MarqueAPIModel$champ, 'nom', $elm$json$Json$Decode$string, $author$project$Components$Shared$Theme$API$MarqueAPIModel$nom, brut),
					A4(
						$author$project$Components$Shared$Theme$API$MarqueAPIModel$champ,
						'logo',
						$elm$json$Json$Decode$string,
						$author$project$Components$Shared$Theme$API$MarqueAPIModel$fichier(origines),
						brut),
					A4(
						$author$project$Components$Shared$Theme$API$MarqueAPIModel$champ,
						'favicon',
						$elm$json$Json$Decode$string,
						$author$project$Components$Shared$Theme$API$MarqueAPIModel$fichier(origines),
						brut),
					A4(
						$author$project$Components$Shared$Theme$API$MarqueAPIModel$champ,
						'police',
						$author$project$Components$Shared$Theme$API$MarqueAPIModel$policeDecoder,
						A2($author$project$Components$Shared$Theme$API$MarqueAPIModel$police, estUnNomDePolice, origines),
						brut),
					A4(
						$author$project$Components$Shared$Theme$API$MarqueAPIModel$champ,
						'applications',
						$elm$json$Json$Decode$list($author$project$Components$Shared$Theme$API$MarqueAPIModel$applicationDecoder),
						$author$project$Components$Shared$Theme$API$MarqueAPIModel$tous(
							$author$project$Components$Shared$Theme$API$MarqueAPIModel$application(origines)),
						brut));
			}
		}
	});
var $author$project$Components$Shared$Theme$Model$TokensAbsents = {$: 2};
var $author$project$Components$Shared$Theme$API$QueryAPIModel$lireTokens = function (document) {
	return A2(
		$elm$core$Result$mapError,
		$elm$core$Basics$always($author$project$Components$Shared$Theme$Model$TokensAbsents),
		A2(
			$elm$json$Json$Decode$decodeValue,
			A2(
				$elm$json$Json$Decode$field,
				'tokens',
				$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value)),
			document));
};
var $author$project$Components$Shared$Theme$Model$VersionInconnue = {$: 1};
var $author$project$Components$Shared$Theme$API$QueryAPIModel$verifierVersion = function (document) {
	return _Utils_eq(
		A2(
			$elm$json$Json$Decode$decodeValue,
			A2($elm$json$Json$Decode$field, 'version', $elm$json$Json$Decode$int),
			document),
		$elm$core$Result$Ok(1)) ? $elm$core$Result$Ok(document) : $elm$core$Result$Err($author$project$Components$Shared$Theme$Model$VersionInconnue);
};
var $author$project$Components$Shared$Theme$API$QueryAPIModel$lire = F2(
	function (origines, corps) {
		return A2(
			$elm$core$Result$andThen,
			function (document) {
				return A2(
					$elm$core$Result$andThen,
					$elm$core$Basics$identity,
					A3(
						$elm$core$Result$map2,
						$author$project$Components$Shared$Theme$API$QueryAPIModel$assembler,
						A3($author$project$Components$Shared$Theme$API$MarqueAPIModel$lire, $author$project$Components$Shared$Theme$API$QueryAPIModel$estUnNomDePolice, origines, document),
						$author$project$Components$Shared$Theme$API$QueryAPIModel$lireTokens(document)));
			},
			A2(
				$elm$core$Result$andThen,
				$author$project$Components$Shared$Theme$API$QueryAPIModel$verifierVersion,
				A2(
					$elm$core$Result$mapError,
					$elm$core$Basics$always($author$project$Components$Shared$Theme$Model$JsonInvalide),
					A2($elm$json$Json$Decode$decodeString, $elm$json$Json$Decode$value, corps))));
	});
var $author$project$Theme$Asria$couples = _List_fromArray(
	[
		{je: 'text-color', mN: 'surface-background-color', IL: 4.5},
		{je: 'text-color', mN: 'page-background-color', IL: 4.5},
		{je: 'text-muted-color', mN: 'surface-background-color', IL: 4.5},
		{je: 'text-muted-color', mN: 'page-background-color', IL: 4.5},
		{je: 'label-color', mN: 'surface-background-color', IL: 4.5},
		{je: 'label-color', mN: 'page-background-color', IL: 4.5},
		{je: 'focus-outline-color', mN: 'surface-background-color', IL: 3},
		{je: 'focus-outline-color', mN: 'page-background-color', IL: 3},
		{je: 'focus-outline-color', mN: 'brand-subtle-background-color', IL: 3},
		{je: 'focus-outline-color', mN: 'selected-background-color', IL: 3},
		{je: 'focus-outline-color', mN: 'hover-background-color', IL: 3},
		{je: 'link-color', mN: 'surface-background-color', IL: 4.5},
		{je: 'link-color', mN: 'page-background-color', IL: 4.5},
		{je: 'on-brand-color', mN: 'brand-color', IL: 4.5},
		{je: 'danger-color', mN: 'surface-background-color', IL: 4.5},
		{je: 'warning-color', mN: 'warning-background-color', IL: 4.5},
		{je: 'exceptions-rule-color', mN: 'exceptions-rule-background-color', IL: 4.5},
		{je: 'tag-success-color', mN: 'tag-success-background-color', IL: 4.5},
		{je: 'tag-warning-color', mN: 'tag-warning-background-color', IL: 4.5},
		{je: 'tag-danger-color', mN: 'tag-danger-background-color', IL: 4.5},
		{je: 'tag-neutral-color', mN: 'tag-neutral-background-color', IL: 4.5},
		{je: 'tag-brand-color', mN: 'tag-brand-background-color', IL: 4.5},
		{je: 'text-muted-color', mN: 'tag-brand-background-color', IL: 4.5},
		{je: 'control-border-color', mN: 'surface-background-color', IL: 3},
		{je: 'control-border-color', mN: 'page-background-color', IL: 3},
		{je: 'brand-text-color', mN: 'brand-subtle-background-color', IL: 4.5},
		{je: 'text-color', mN: 'selected-background-color', IL: 4.5},
		{je: 'text-muted-color', mN: 'selected-background-color', IL: 4.5},
		{je: 'text-color', mN: 'hover-background-color', IL: 4.5},
		{je: 'text-muted-color', mN: 'hover-background-color', IL: 4.5},
		{je: 'text-color', mN: 'kanban-column-background-color', IL: 4.5},
		{je: 'text-muted-color', mN: 'kanban-column-background-color', IL: 4.5},
		{je: 'on-brand-color', mN: 'brand-hover-color', IL: 4.5},
		{je: 'on-brand-color', mN: 'brand-active-color', IL: 4.5},
		{je: 'danger-color', mN: 'page-background-color', IL: 4.5},
		{je: 'note-information-color', mN: 'note-information-background-color', IL: 4.5},
		{je: 'note-validation-color', mN: 'note-validation-background-color', IL: 4.5},
		{je: 'control-border-color', mN: 'hover-background-color', IL: 3},
		{je: 'brand-color', mN: 'surface-background-color', IL: 3},
		{je: 'brand-color', mN: 'selected-background-color', IL: 3},
		{je: 'danger-color', mN: 'tag-danger-background-color', IL: 4.5},
		{je: 'link-hover-color', mN: 'surface-background-color', IL: 4.5},
		{je: 'link-hover-color', mN: 'page-background-color', IL: 4.5},
		{je: 'label-color', mN: 'hover-background-color', IL: 4.5},
		{je: 'link-color', mN: 'hover-background-color', IL: 4.5},
		{je: 'link-color', mN: 'selected-background-color', IL: 4.5},
		{je: 'link-hover-color', mN: 'hover-background-color', IL: 4.5},
		{je: 'link-hover-color', mN: 'selected-background-color', IL: 4.5},
		{je: 'success-color', mN: 'success-background-color', IL: 4.5},
		{je: 'success-color', mN: 'surface-background-color', IL: 4.5},
		{je: 'danger-color', mN: 'danger-background-color', IL: 4.5},
		{je: 'warning-color', mN: 'surface-background-color', IL: 4.5},
		{je: 'heading-color', mN: 'surface-background-color', IL: 4.5},
		{je: 'heading-color', mN: 'page-background-color', IL: 4.5},
		{je: 'placeholder-color', mN: 'surface-background-color', IL: 4.5},
		{je: 'brand-text-color', mN: 'surface-background-color', IL: 4.5}
	]);
var $author$project$Components$Shared$Theme$Model$CoupleEnCause = F4(
	function (avant, fond, ratio, seuil) {
		return {je: avant, mN: fond, GW: ratio, IL: seuil};
	});
var $author$project$Components$Shared$Theme$Contraste$couleurDe = F2(
	function (surcharges, nom) {
		var _v1 = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.fm;
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (surcharge) {
						return _Utils_eq(surcharge.Dj, nom);
					},
					surcharges)));
		if (!_v1.$) {
			if (!_v1.a.$) {
				var recue = _v1.a.a;
				return $elm$core$Maybe$Just(recue);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			return A2(
				$elm$core$Maybe$andThen,
				$author$project$Components$Shared$Theme$Contraste$suivre(surcharges),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (token) {
							return _Utils_eq(token.Dj, nom);
						},
						$author$project$Theme$Asria$tokens)));
		}
	});
var $author$project$Components$Shared$Theme$Contraste$suivre = F2(
	function (surcharges, token) {
		var _v0 = token.td;
		if (!_v0.$) {
			var cible = _v0.a;
			return A2($author$project$Components$Shared$Theme$Contraste$couleurDe, surcharges, cible);
		} else {
			return $elm$core$Maybe$Just(token.fm);
		}
	});
var $author$project$Components$Shared$Theme$Contraste$chiffre = function (c) {
	return $elm$core$Char$isDigit(c) ? $elm$core$Maybe$Just(
		$elm$core$Char$toCode(c) - $elm$core$Char$toCode('0')) : ($elm$core$Char$isHexDigit(c) ? $elm$core$Maybe$Just(
		($elm$core$Char$toCode(
			$elm$core$Char$toLower(c)) - $elm$core$Char$toCode('a')) + 10) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$pow = _Basics_pow;
var $author$project$Components$Shared$Theme$Contraste$lineaire = function (c) {
	return (c <= 0.03928) ? (c / 12.92) : A2($elm$core$Basics$pow, (c + 0.055) / 1.055, 2.4);
};
var $author$project$Components$Shared$Theme$Contraste$canal = F2(
	function (fort, faible) {
		return A3(
			$elm$core$Maybe$map2,
			F2(
				function (f, l) {
					return $author$project$Components$Shared$Theme$Contraste$lineaire(((f * 16) + l) / 255);
				}),
			$author$project$Components$Shared$Theme$Contraste$chiffre(fort),
			$author$project$Components$Shared$Theme$Contraste$chiffre(faible));
	});
var $author$project$Components$Shared$Theme$Contraste$luminance = function (couleur) {
	var _v0 = $elm$core$String$toList(couleur);
	if ((((((((_v0.b && ('#' === _v0.a)) && _v0.b.b) && _v0.b.b.b) && _v0.b.b.b.b) && _v0.b.b.b.b.b) && _v0.b.b.b.b.b.b) && _v0.b.b.b.b.b.b.b) && (!_v0.b.b.b.b.b.b.b.b)) {
		var _v1 = _v0.b;
		var r1 = _v1.a;
		var _v2 = _v1.b;
		var r2 = _v2.a;
		var _v3 = _v2.b;
		var v1 = _v3.a;
		var _v4 = _v3.b;
		var v2 = _v4.a;
		var _v5 = _v4.b;
		var b1 = _v5.a;
		var _v6 = _v5.b;
		var b2 = _v6.a;
		return A4(
			$elm$core$Maybe$map3,
			F3(
				function (r, v, b) {
					return ((0.2126 * r) + (0.7152 * v)) + (0.0722 * b);
				}),
			A2($author$project$Components$Shared$Theme$Contraste$canal, r1, r2),
			A2($author$project$Components$Shared$Theme$Contraste$canal, v1, v2),
			A2($author$project$Components$Shared$Theme$Contraste$canal, b1, b2));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Shared$Theme$Contraste$ratio = F2(
	function (avant, fond) {
		return A3(
			$elm$core$Maybe$map2,
			F2(
				function (a, b) {
					return (A2($elm$core$Basics$max, a, b) + 0.05) / (A2($elm$core$Basics$min, a, b) + 0.05);
				}),
			$author$project$Components$Shared$Theme$Contraste$luminance(avant),
			$author$project$Components$Shared$Theme$Contraste$luminance(fond));
	});
var $author$project$Components$Shared$Theme$Contraste$mesurer = F2(
	function (surcharges, couple) {
		return A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				A2($author$project$Components$Shared$Theme$Model$CoupleEnCause, couple.je, couple.mN),
				$elm$core$Basics$apR(couple.IL)),
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$Basics$identity,
				A3(
					$elm$core$Maybe$map2,
					$author$project$Components$Shared$Theme$Contraste$ratio,
					A2($author$project$Components$Shared$Theme$Contraste$couleurDe, surcharges, couple.je),
					A2($author$project$Components$Shared$Theme$Contraste$couleurDe, surcharges, couple.mN))));
	});
var $author$project$Components$Shared$Theme$Contraste$verifier = function (surcharges) {
	var _v0 = A2(
		$elm$core$List$filter,
		function (c) {
			return _Utils_cmp(c.GW, c.IL) < 0;
		},
		A2(
			$elm$core$List$filterMap,
			$author$project$Components$Shared$Theme$Contraste$mesurer(surcharges),
			$author$project$Theme$Asria$couples));
	if (!_v0.b) {
		return $elm$core$Result$Ok(0);
	} else {
		var premier = _v0.a;
		return $elm$core$Result$Err(premier);
	}
};
var $author$project$Components$Socle$Theme$Update$recevoir = F2(
	function (reponse, model) {
		if (!reponse.$) {
			var corps = reponse.a;
			var _v1 = A2($author$project$Components$Shared$Theme$API$QueryAPIModel$lire, model.hj, corps);
			if (!_v1.$) {
				var theme = _v1.a;
				var _v2 = $author$project$Components$Shared$Theme$Contraste$verifier(theme.Jg);
				if (!_v2.$) {
					return A2($author$project$Components$Socle$Theme$Update$appliquer, theme, model);
				} else {
					var couple = _v2.a;
					return A2(
						$author$project$Components$Socle$Theme$Update$ecarter,
						$author$project$Components$Socle$Theme$Model$NonConforme(couple),
						model);
				}
			} else {
				var raison = _v1.a;
				return A2(
					$author$project$Components$Socle$Theme$Update$ecarter,
					$author$project$Components$Socle$Theme$Model$Illisible(raison),
					model);
			}
		} else {
			var erreur = reponse.a;
			return A2(
				$author$project$Components$Socle$Theme$Update$ecarter,
				$author$project$Components$Socle$Theme$Update$causeDe(erreur),
				model);
		}
	});
var $author$project$Components$Socle$Theme$Update$update = F2(
	function (msg, model) {
		var _v0 = _Utils_Tuple2(msg, model.gt);
		if (_v0.b.$ === 1) {
			var reponse = _v0.a;
			var _v1 = _v0.b;
			return A2($author$project$Components$Socle$Theme$Update$recevoir, reponse, model);
		} else {
			return _Utils_Tuple2(model, _List_Nil);
		}
	});
var $author$project$Main$Update$update = F2(
	function (msg, model) {
		var i18n = model.e1.JL;
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var url = msg.a.a;
					var _v1 = url.zY;
					if (!_v1.$) {
						var cible = _v1.a;
						return _Utils_eq(
							$author$project$Routes$Route$fromUrl(url),
							model.Ih) ? _Utils_Tuple2(
							model,
							_List_fromArray(
								[
									$author$project$Main$Update$PlacerFocus(cible)
								])) : _Utils_Tuple2(
							model,
							_List_fromArray(
								[
									$author$project$Main$Update$AllerA(
									$elm$url$Url$toString(url))
								]));
					} else {
						return _Utils_Tuple2(
							model,
							_List_fromArray(
								[
									$author$project$Main$Update$AllerA(
									$elm$url$Url$toString(url))
								]));
					}
				} else {
					var adresse = msg.a.a;
					return _Utils_Tuple2(
						model,
						_List_fromArray(
							[
								$author$project$Main$Update$ChargerAdresse(adresse)
							]));
				}
			case 1:
				var url = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (arrivee) {
						return _Utils_update(
							arrivee,
							{
								I3: A3($author$project$Main$Update$typologieDeLAdresse, i18n, arrivee.Ih, arrivee.I3)
							});
					},
					(A2(
						$author$project$Main$Update$memeParcours,
						model,
						$author$project$Routes$Route$fromUrl(url)) ? $author$project$Main$Update$changerDEtape(i18n) : $author$project$Main$Update$ouvrirLaPage(i18n))(
						A2(
							$author$project$Main$Update$versLaSession,
							$author$project$Components$Socle$Session$Update$PageChangee(url),
							_Utils_update(
								model,
								{
									xa: A2($author$project$Components$Demonstration$Model$quitter, model.Ih, model.xa),
									zo: $author$project$Components$Referentiel$Fiche$Model$envelopper(
										A3(
											$author$project$Main$Update$quitterLaFiche,
											model.Ih,
											$author$project$Routes$Route$fromUrl(url),
											$author$project$Components$Referentiel$Fiche$Model$ouvrir(model.zo))),
									Ct: _List_Nil,
									Ee: A2(
										$author$project$Main$Update$arriveeSurLesAlertes,
										model.Ih,
										$author$project$Routes$Route$fromUrl(url)),
									Ih: $author$project$Routes$Route$fromUrl(url),
									JT: $author$project$Components$Referentiel$Type$Model$envelopper(
										A3(
											$author$project$Main$Update$quitterLeType,
											model.Ih,
											$author$project$Routes$Route$fromUrl(url),
											$author$project$Components$Referentiel$Type$Model$ouvrir(model.JT)))
								}))));
			case 2:
				var themeMsg = msg.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					function (theme) {
						return _Utils_update(
							model,
							{JA: theme});
					},
					$elm$core$List$map($author$project$Main$Update$depuisLeTheme),
					A2($author$project$Components$Socle$Theme$Update$update, themeMsg, model.JA));
			case 3:
				var sessionMsg = msg.a;
				var suivant = A2($author$project$Main$Update$versLaSession, sessionMsg, model);
				return _Utils_eq(
					$author$project$Main$Update$liensDeLaRacine(model),
					$elm$core$Maybe$Nothing) ? A2($author$project$Main$Update$ouvrirLaPage, i18n, suivant) : suivant;
			case 63:
				var octets = msg.a;
				var _v2 = model.ta;
				if (_v2.b) {
					switch (_v2.a) {
						case 0:
							var _v3 = _v2.a;
							var reste = _v2.b;
							return A2(
								$author$project$Main$Update$versLaSession,
								$author$project$Components$Socle$Session$Update$AleaRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 1:
							var _v4 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLaNouvelleFiche,
								i18n,
								$author$project$Components$Referentiel$NouvelleFiche$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 2:
							var _v5 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLesPartiesPrenantes,
								i18n,
								$author$project$Components$Referentiel$PartiesPrenantes$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 31:
							var _v6 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLesPartiesPrenantes,
								i18n,
								$author$project$Components$Referentiel$PartiesPrenantes$Update$ProcessUidDeGroupeRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 3:
							var _v7 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLaFiche,
								i18n,
								$author$project$Components$Referentiel$Fiche$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 33:
							var _v8 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLaFusion,
								i18n,
								$author$project$Components$Referentiel$Fusion$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 34:
							var _v9 = _v2.a;
							var reste = _v2.b;
							return A2(
								$author$project$Main$Update$versLesDoublons,
								$author$project$Components$Referentiel$Doublons$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 4:
							var _v10 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLaStructureDuCatalogue,
								i18n,
								$author$project$Components$Produits$StructureCatalogue$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 5:
							var _v11 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLesMarquesEtGammes,
								i18n,
								$author$project$Components$Produits$MarquesEtGammes$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 6:
							var _v12 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLaFicheElement,
								i18n,
								$author$project$Components$Produits$FicheElement$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 7:
							var _v13 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLaStructureDuCatalogue,
								i18n,
								$author$project$Components$Produits$StructureCatalogue$Update$DesCategories(
									$author$project$Components$Produits$StructureCatalogue$Categories$Update$ProcessUidRecu(octets)),
								_Utils_update(
									model,
									{ta: reste}));
						case 8:
							var _v14 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLaStructureDuCatalogue,
								i18n,
								$author$project$Components$Produits$StructureCatalogue$Update$DesMarques(
									$author$project$Components$Produits$StructureCatalogue$Marques$Update$ProcessUidRecu(octets)),
								_Utils_update(
									model,
									{ta: reste}));
						case 9:
							var _v15 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLaStructureDuCatalogue,
								i18n,
								$author$project$Components$Produits$StructureCatalogue$Update$DesGammes(
									$author$project$Components$Produits$StructureCatalogue$Gammes$Update$ProcessUidRecu(octets)),
								_Utils_update(
									model,
									{ta: reste}));
						case 10:
							var _v16 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLaStructureDuCatalogue,
								i18n,
								$author$project$Components$Produits$StructureCatalogue$Update$DesProduits(
									$author$project$Components$Produits$StructureCatalogue$Produits$Update$ProcessUidRecu(octets)),
								_Utils_update(
									model,
									{ta: reste}));
						case 11:
							var _v17 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLaFicheType,
								i18n,
								$author$project$Components$Produits$FicheType$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 13:
							var _v18 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLeCatalogue,
								i18n,
								$author$project$Components$Produits$Catalogue$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 14:
							var _v19 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLaReference,
								i18n,
								$author$project$Components$Produits$Reference$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 15:
							var _v20 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLesOffres,
								i18n,
								$author$project$Components$Produits$Offres$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 16:
							var _v21 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLOffre,
								i18n,
								$author$project$Components$Produits$Offre$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 17:
							var _v22 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLEtape1DUnPipe,
								i18n,
								$author$project$Components$Parametrage$PipeEtape1$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 18:
							var _v23 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLEtape2DUnPipe,
								i18n,
								$author$project$Components$Parametrage$PipeEtape2$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 20:
							var _v24 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLEtape4DUnPipe,
								i18n,
								$author$project$Components$Parametrage$PipeEtape4$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 21:
							var _v25 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLEtape5DUnPipe,
								i18n,
								$author$project$Components$Parametrage$PipeEtape5$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 22:
							var _v26 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLEtape6DUnPipe,
								i18n,
								$author$project$Components$Parametrage$PipeEtape6$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 23:
							var _v27 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLEtape7DUnPipe,
								i18n,
								$author$project$Components$Parametrage$PipeEtape7$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 26:
							var _v28 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLesModelesDeTache,
								i18n,
								$author$project$Components$Parametrage$ModelesDeTache$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 25:
							var _v29 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLesVersionsDUnPipe,
								i18n,
								$author$project$Components$Parametrage$PipeVersions$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 24:
							var _v30 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLEtape8DUnPipe,
								i18n,
								$author$project$Components$Parametrage$PipeEtape8$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 19:
							var _v31 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLEtape3DUnPipe,
								i18n,
								$author$project$Components$Parametrage$PipeEtape3$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 27:
							var _v32 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLesListesDePrix,
								i18n,
								$author$project$Components$Produits$ListesDePrix$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 28:
							var _v33 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLaListeDePrix,
								i18n,
								$author$project$Components$Produits$ListeDePrix$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 12:
							var _v34 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLeSchemaDeNiveau,
								i18n,
								$author$project$Components$Produits$SchemaDeNiveau$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 32:
							var _v35 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLeGroupe,
								i18n,
								$author$project$Components$Referentiel$Groupe$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 30:
							var _v36 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLesGroupes,
								i18n,
								$author$project$Components$Referentiel$Groupes$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 29:
							var _v37 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLesTypesDePartiesPrenantes,
								i18n,
								$author$project$Components$Referentiel$Types$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 36:
							var _v38 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLesDroits,
								i18n,
								$author$project$Components$Parametrage$Droits$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 37:
							var _v39 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLesListes,
								i18n,
								$author$project$Components$Produits$Listes$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 39:
							var _v40 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLesPerimetres,
								i18n,
								$author$project$Components$Produits$Perimetres$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 40:
							var _v41 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLesTypesDeQuantite,
								i18n,
								$author$project$Components$Produits$TypesDeQuantite$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 38:
							var _v42 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLesCorrespondances,
								i18n,
								$author$project$Components$Produits$Correspondances$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 41:
							var _v43 = _v2.a;
							var reste = _v2.b;
							return A2(
								$author$project$Main$Update$versLesCollectionsDeChamps,
								$author$project$Components$Parametrage$CollectionsDeChamps$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 42:
							var _v44 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLaBibliotheque,
								i18n,
								$author$project$Components$Parametrage$BibliothequeDeChamps$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 46:
							var _v45 = _v2.a;
							var reste = _v2.b;
							return A2(
								$author$project$Main$Update$versLesImports,
								$author$project$Components$Imports$Outil$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 44:
							var _v46 = _v2.a;
							var reste = _v2.b;
							return A2(
								$author$project$Main$Update$versLesLangues,
								$author$project$Components$Parametrage$LanguesDuClient$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 45:
							var _v47 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLesUtilisateurs,
								i18n,
								$author$project$Components$Parametrage$Utilisateurs$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 47:
							var _v48 = _v2.a;
							var reste = _v2.b;
							return A2(
								$author$project$Main$Update$versLeCompteur,
								$author$project$Components$Parametrage$CompteurDeCode$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 48:
							var _v49 = _v2.a;
							var reste = _v2.b;
							return A2(
								$author$project$Main$Update$versLeCompteDEnvoi,
								$author$project$Components$Parametrage$CompteDEnvoi$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 49:
							var _v50 = _v2.a;
							var reste = _v2.b;
							return A2(
								$author$project$Main$Update$versMonCompte,
								$author$project$Components$Comptes$MonCompte$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 50:
							var _v51 = _v2.a;
							var reste = _v2.b;
							return A2(
								$author$project$Main$Update$versLaSecurite,
								$author$project$Components$Comptes$Securite$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 43:
							var _v52 = _v2.a;
							var reste = _v2.b;
							return A2(
								$author$project$Main$Update$versLaConservation,
								$author$project$Components$Parametrage$Conservation$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 51:
							var _v53 = _v2.a;
							var reste = _v2.b;
							return A2(
								$author$project$Main$Update$versLesNotifications,
								$author$project$Components$Notifications$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 52:
							var _v54 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLesTypesDeRelation,
								i18n,
								$author$project$Components$Referentiel$TypesDeRelation$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 53:
							var _v55 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLesPostes,
								i18n,
								$author$project$Components$Referentiel$Postes$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						case 54:
							var _v56 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLesFormes,
								i18n,
								$author$project$Components$Referentiel$Formes$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
						default:
							var _v57 = _v2.a;
							var reste = _v2.b;
							return A3(
								$author$project$Main$Update$versLeTypeDePartiePrenante,
								i18n,
								$author$project$Components$Referentiel$Type$Update$ProcessUidRecu(octets),
								_Utils_update(
									model,
									{ta: reste}));
					}
				} else {
					return _Utils_Tuple2(model, _List_Nil);
				}
			case 26:
				var ficheMsg = msg.a;
				return A3($author$project$Main$Update$versLaFicheElement, i18n, ficheMsg, model);
			case 27:
				var ficheMsg = msg.a;
				return A3($author$project$Main$Update$versLaFicheType, i18n, ficheMsg, model);
			case 28:
				var catalogueMsg = msg.a;
				return A3($author$project$Main$Update$versLeCatalogue, i18n, catalogueMsg, model);
			case 29:
				var referenceMsg = msg.a;
				return A3($author$project$Main$Update$versLaReference, i18n, referenceMsg, model);
			case 30:
				var offresMsg = msg.a;
				return A3($author$project$Main$Update$versLesOffres, i18n, offresMsg, model);
			case 31:
				var offreMsg = msg.a;
				return A3($author$project$Main$Update$versLOffre, i18n, offreMsg, model);
			case 32:
				var alertesMsg = msg.a;
				return A3($author$project$Main$Update$versLesAlertes, i18n, alertesMsg, model);
			case 33:
				var alertesMsg = msg.a;
				return A3($author$project$Main$Update$versLesAlertesDePartiesPrenantes, i18n, alertesMsg, model);
			case 34:
				var listesDePrixMsg = msg.a;
				return A3($author$project$Main$Update$versLesListesDePrix, i18n, listesDePrixMsg, model);
			case 35:
				var listeDePrixMsg = msg.a;
				return A3($author$project$Main$Update$versLaListeDePrix, i18n, listeDePrixMsg, model);
			case 36:
				var schemaMsg = msg.a;
				return A3($author$project$Main$Update$versLeSchemaDeNiveau, i18n, schemaMsg, model);
			case 37:
				var typesMsg = msg.a;
				return A3($author$project$Main$Update$versLesTypesDePartiesPrenantes, i18n, typesMsg, model);
			case 38:
				var groupesMsg = msg.a;
				return A3($author$project$Main$Update$versLesGroupes, i18n, groupesMsg, model);
			case 39:
				var groupeMsg = msg.a;
				return A3($author$project$Main$Update$versLeGroupe, i18n, groupeMsg, model);
			case 42:
				var typeMsg = msg.a;
				return A3($author$project$Main$Update$versLeTypeDePartiePrenante, i18n, typeMsg, model);
			case 43:
				var droitsMsg = msg.a;
				return A3($author$project$Main$Update$versLesDroits, i18n, droitsMsg, model);
			case 44:
				var listesMsg = msg.a;
				return A3($author$project$Main$Update$versLesListes, i18n, listesMsg, model);
			case 45:
				var correspondancesMsg = msg.a;
				return A3($author$project$Main$Update$versLesCorrespondances, i18n, correspondancesMsg, model);
			case 46:
				var perimetresMsg = msg.a;
				return A3($author$project$Main$Update$versLesPerimetres, i18n, perimetresMsg, model);
			case 47:
				var typesMsg = msg.a;
				return A3($author$project$Main$Update$versLesTypesDeQuantite, i18n, typesMsg, model);
			case 48:
				var collectionsMsg = msg.a;
				return A2($author$project$Main$Update$versLesCollectionsDeChamps, collectionsMsg, model);
			case 49:
				var bibliothequeMsg = msg.a;
				return A3($author$project$Main$Update$versLaBibliotheque, i18n, bibliothequeMsg, model);
			case 50:
				var conservationMsg = msg.a;
				return A2($author$project$Main$Update$versLaConservation, conservationMsg, model);
			case 51:
				var languesMsg = msg.a;
				return A2($author$project$Main$Update$versLesLangues, languesMsg, model);
			case 52:
				var utilisateursMsg = msg.a;
				return A3($author$project$Main$Update$versLesUtilisateurs, i18n, utilisateursMsg, model);
			case 53:
				var importsMsg = msg.a;
				return A2($author$project$Main$Update$versLesImports, importsMsg, model);
			case 54:
				var compteurMsg = msg.a;
				return A2($author$project$Main$Update$versLeCompteur, compteurMsg, model);
			case 55:
				var compteMsg = msg.a;
				return A2($author$project$Main$Update$versLeCompteDEnvoi, compteMsg, model);
			case 56:
				var monCompteMsg = msg.a;
				return A2($author$project$Main$Update$versMonCompte, monCompteMsg, model);
			case 57:
				var securiteMsg = msg.a;
				return A2($author$project$Main$Update$versLaSecurite, securiteMsg, model);
			case 58:
				var notificationsMsg = msg.a;
				return A2($author$project$Main$Update$versLesNotifications, notificationsMsg, model);
			case 59:
				var norme = msg.a;
				var reponse = msg.b;
				return _Utils_Tuple2(
					A4($author$project$Main$Update$normesLues, i18n, norme, reponse, model),
					_List_Nil);
			case 60:
				var typesMsg = msg.a;
				return A3($author$project$Main$Update$versLesTypesDeRelation, i18n, typesMsg, model);
			case 61:
				var postesMsg = msg.a;
				return A3($author$project$Main$Update$versLesPostes, i18n, postesMsg, model);
			case 62:
				var formesMsg = msg.a;
				return A3($author$project$Main$Update$versLesFormes, i18n, formesMsg, model);
			case 6:
				var nouvelleFicheMsg = msg.a;
				return A3($author$project$Main$Update$versLaNouvelleFiche, i18n, nouvelleFicheMsg, model);
			case 10:
				var marquesMsg = msg.a;
				return A3($author$project$Main$Update$versLesMarquesEtGammes, i18n, marquesMsg, model);
			case 11:
				var pipesMsg = msg.a;
				return A3($author$project$Main$Update$versLesPipes, i18n, pipesMsg, model);
			case 13:
				var accueilMsg = msg.a;
				return A3($author$project$Main$Update$versLAccueil, i18n, accueilMsg, model);
			case 14:
				var etape1Msg = msg.a;
				return A3($author$project$Main$Update$versLEtape1DUnPipe, i18n, etape1Msg, model);
			case 15:
				var etape2Msg = msg.a;
				return A3($author$project$Main$Update$versLEtape2DUnPipe, i18n, etape2Msg, model);
			case 16:
				var etape3Msg = msg.a;
				return A3($author$project$Main$Update$versLEtape3DUnPipe, i18n, etape3Msg, model);
			case 17:
				var etape4Msg = msg.a;
				return A3($author$project$Main$Update$versLEtape4DUnPipe, i18n, etape4Msg, model);
			case 18:
				var etape5Msg = msg.a;
				return A3($author$project$Main$Update$versLEtape5DUnPipe, i18n, etape5Msg, model);
			case 19:
				var etape6Msg = msg.a;
				return A3($author$project$Main$Update$versLEtape6DUnPipe, i18n, etape6Msg, model);
			case 20:
				var etape7Msg = msg.a;
				return A3($author$project$Main$Update$versLEtape7DUnPipe, i18n, etape7Msg, model);
			case 21:
				var etape8Msg = msg.a;
				return A3($author$project$Main$Update$versLEtape8DUnPipe, i18n, etape8Msg, model);
			case 22:
				var versionsMsg = msg.a;
				return A3($author$project$Main$Update$versLesVersionsDUnPipe, i18n, versionsMsg, model);
			case 12:
				var modelesMsg = msg.a;
				return A3($author$project$Main$Update$versLesModelesDeTache, i18n, modelesMsg, model);
			case 23:
				var usageMsg = msg.a;
				return A3($author$project$Main$Update$versLUsageDeLOffre, i18n, usageMsg, model);
			case 24:
				var destinationsMsg = msg.a;
				return A3($author$project$Main$Update$versLesDestinationsDesChamps, i18n, destinationsMsg, model);
			case 25:
				var relationsMsg = msg.a;
				return A3($author$project$Main$Update$versLesRelationsExigees, i18n, relationsMsg, model);
			case 7:
				var ficheMsg = msg.a;
				return A3($author$project$Main$Update$versLaFiche, i18n, ficheMsg, model);
			case 40:
				var fusionMsg = msg.a;
				return A3($author$project$Main$Update$versLaFusion, i18n, fusionMsg, model);
			case 41:
				var doublonsMsg = msg.a;
				return A2($author$project$Main$Update$versLesDoublons, doublonsMsg, model);
			case 8:
				var partiesPrenantesMsg = msg.a;
				return A3($author$project$Main$Update$versLesPartiesPrenantes, i18n, partiesPrenantesMsg, model);
			case 9:
				if (msg.a.$ === 92) {
					var formulaire = msg.a.a;
					return A3($author$project$Main$Update$versLeCatalogue, i18n, formulaire, model);
				} else {
					var structureMsg = msg.a;
					return A3($author$project$Main$Update$versLaStructureDuCatalogue, i18n, structureMsg, model);
				}
			case 4:
				var navigationMsg = msg.a;
				var _v58 = A2($author$project$Components$Shared$Navigation$Update$update, navigationMsg, model.C5);
				var navigation = _v58.a;
				var effets = _v58.b;
				return A3(
					$elm$core$List$foldl,
					$author$project$Main$Update$depuisLaNavigation,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{C5: navigation}),
						_List_Nil),
					effets);
			case 5:
				var demonstrationMsg = msg.a;
				var _v59 = A2($author$project$Components$Demonstration$Update$update, demonstrationMsg, model.xa);
				var demonstration = _v59.a;
				var effets = _v59.b;
				return A3(
					$elm$core$List$foldl,
					$author$project$Main$Update$depuisLaDemonstration,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{xa: demonstration}),
						_List_Nil),
					effets);
			case 64:
				return _Utils_Tuple2(model, _List_Nil);
			default:
				var fichier = msg.a;
				return _Utils_Tuple2(
					model,
					_List_fromArray(
						[
							$author$project$Main$Update$LireLesOctetsDuFichier(fichier)
						]));
		}
	});
var $author$project$Components$Shared$Theme$View$nomDePolice = function (nom) {
	return A2($elm$core$String$contains, ' ', nom) ? ('\"' + (nom + '\"')) : nom;
};
var $author$project$Components$Shared$Theme$View$rem = function (taille) {
	return $elm$core$String$fromFloat(taille) + 'rem';
};
var $author$project$Components$Shared$Theme$View$valeurCss = function (valeur) {
	switch (valeur.$) {
		case 0:
			var hexadecimale = valeur.a;
			return hexadecimale;
		case 1:
			var taille = valeur.a;
			return $author$project$Components$Shared$Theme$View$rem(taille);
		case 2:
			var noms = valeur.a;
			return A2(
				$elm$core$String$join,
				', ',
				A2($elm$core$List$map, $author$project$Components$Shared$Theme$View$nomDePolice, noms));
		case 3:
			var graisse = valeur.a;
			return $elm$core$String$fromInt(graisse);
		case 4:
			var nombre = valeur.a;
			return $elm$core$String$fromFloat(nombre);
		default:
			var ombre = valeur.a;
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[
						$author$project$Components$Shared$Theme$View$rem(ombre.wJ),
						$author$project$Components$Shared$Theme$View$rem(ombre.wK),
						$author$project$Components$Shared$Theme$View$rem(ombre.zN),
						$author$project$Components$Shared$Theme$View$rem(ombre.aw),
						ombre.kf
					]));
	}
};
var $author$project$Components$Shared$Theme$View$declaration = function (surcharge) {
	return '--' + (surcharge.Dj + (': ' + ($author$project$Components$Shared$Theme$View$valeurCss(surcharge.fm) + ';')));
};
var $author$project$Components$Shared$Theme$View$policeDeMarque = function (police) {
	return '@font-face { font-family: \"' + (police.zj + ('\"; src: ' + (A2(
		$elm$core$String$join,
		', ',
		A2(
			$elm$core$List$map,
			function (fichier) {
				return 'url(\"' + (fichier + '\")');
			},
			police.zB)) + '; }')));
};
var $author$project$Components$Shared$Theme$View$css = function (theme) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2($elm$core$Maybe$map, $author$project$Components$Shared$Theme$View$policeDeMarque, theme.gX.pq),
					$elm$core$List$isEmpty(theme.Jg) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					':root { ' + (A2(
						$elm$core$String$join,
						' ',
						A2($elm$core$List$map, $author$project$Components$Shared$Theme$View$declaration, theme.Jg)) + ' }'))
				])));
};
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Components$Shared$Theme$View$bloc = function (theme) {
	return A3(
		$elm$html$Html$node,
		'style',
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Components$Shared$Theme$View$css(theme))
			]));
};
var $author$project$Components$Socle$Session$Update$ChangerDEspaceDemande = {$: 14};
var $rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$Node;
var $rtfeldman$elm_css$Html$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$node;
var $rtfeldman$elm_css$Html$Styled$button = $rtfeldman$elm_css$Html$Styled$node('button');
var $rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlJson(value));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$property = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$property, key, value),
			_List_Nil,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$class = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('className');
var $rtfeldman$elm_css$Html$Styled$Attributes$classList = function (classes) {
	return $rtfeldman$elm_css$Html$Styled$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $rtfeldman$elm_css$Html$Styled$div = $rtfeldman$elm_css$Html$Styled$node('div');
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$attribute = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$attribute, key, value),
			_List_Nil,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$attribute = $rtfeldman$elm_css$VirtualDom$Styled$attribute;
var $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$disabled = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('disabled');
var $rtfeldman$elm_css$Html$Styled$li = $rtfeldman$elm_css$Html$Styled$node('li');
var $rtfeldman$elm_css$Html$Styled$Attributes$alt = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('alt');
var $rtfeldman$elm_css$Html$Styled$img = $rtfeldman$elm_css$Html$Styled$node('img');
var $author$project$Texte$Initiales$initiales = function (nom) {
	var premiere = function (mot) {
		return $elm$core$String$toUpper(
			A2($elm$core$String$left, 1, mot));
	};
	var mots = $elm$core$String$words(nom);
	var _v0 = _Utils_Tuple2(
		mots,
		$elm$core$List$reverse(mots));
	_v0$2:
	while (true) {
		if (_v0.a.b) {
			if (!_v0.a.b.b) {
				var _v1 = _v0.a;
				var seul = _v1.a;
				return premiere(seul);
			} else {
				if (_v0.b.b) {
					var _v2 = _v0.a;
					var premier = _v2.a;
					var _v3 = _v0.b;
					var dernier = _v3.a;
					return _Utils_ap(
						premiere(premier),
						premiere(dernier));
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return '';
};
var $author$project$Texte$Initiales$initialesDOrganisation = function (nom) {
	var _v0 = $elm$core$String$words(nom);
	if (_v0.b && (!_v0.b.b)) {
		var seul = _v0.a;
		return $elm$core$String$toUpper(
			A2($elm$core$String$left, 2, seul));
	} else {
		return $author$project$Texte$Initiales$initiales(nom);
	}
};
var $rtfeldman$elm_css$Html$Styled$span = $rtfeldman$elm_css$Html$Styled$node('span');
var $rtfeldman$elm_css$Html$Styled$Attributes$src = function (url) {
	return A2($rtfeldman$elm_css$Html$Styled$Attributes$stringProperty, 'src', url);
};
var $rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
	return {$: 4, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
	return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
		$elm$virtual_dom$VirtualDom$text(str));
};
var $rtfeldman$elm_css$Html$Styled$text = $rtfeldman$elm_css$VirtualDom$Styled$text;
var $author$project$Components$Shared$Navigation$View$logoDEspace = function (espace) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$span,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('logo'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = espace.n$;
				if (!_v0.$) {
					var adresse = _v0.a;
					return A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$src(adresse),
								$rtfeldman$elm_css$Html$Styled$Attributes$alt('')
							]),
						_List_Nil);
				} else {
					return $rtfeldman$elm_css$Html$Styled$text(
						$author$project$Texte$Initiales$initialesDOrganisation(espace.Dj));
				}
			}()
			]));
};
var $author$project$I18n$Cles$marqueAsriaCrm = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'marque.asria.crm', _List_Nil, 'Asria CRM');
};
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $rtfeldman$elm_css$VirtualDom$Styled$on = F2(
	function (eventName, handler) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$on, eventName, handler),
			_List_Nil,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Events$on = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $rtfeldman$elm_css$Html$Styled$Events$onClick = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$I18n$Cles$sessionEspacesDernierChoisi = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'session.espaces.dernier-choisi', _List_Nil, 'Dernier choisi');
};
var $author$project$I18n$Cles$sessionEspacesSuspendu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'session.espaces.suspendu', _List_Nil, 'Compte suspendu');
};
var $rtfeldman$elm_css$Html$Styled$strong = $rtfeldman$elm_css$Html$Styled$node('strong');
var $rtfeldman$elm_css$Svg$Styled$Attributes$class = $rtfeldman$elm_css$VirtualDom$Styled$attribute('class');
var $rtfeldman$elm_css$Svg$Styled$Attributes$d = $rtfeldman$elm_css$VirtualDom$Styled$attribute('d');
var $rtfeldman$elm_css$VirtualDom$Styled$NodeNS = F4(
	function (a, b, c, d) {
		return {$: 1, a: a, b: b, c: c, d: d};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$nodeNS = $rtfeldman$elm_css$VirtualDom$Styled$NodeNS;
var $rtfeldman$elm_css$Svg$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$nodeNS('http://www.w3.org/2000/svg');
var $rtfeldman$elm_css$Svg$Styled$path = $rtfeldman$elm_css$Svg$Styled$node('path');
var $rtfeldman$elm_css$Svg$Styled$svg = $rtfeldman$elm_css$Svg$Styled$node('svg');
var $rtfeldman$elm_css$Svg$Styled$Attributes$viewBox = $rtfeldman$elm_css$VirtualDom$Styled$attribute('viewBox');
var $author$project$Components$Shared$Svg$icone = F3(
	function (nom, trace, cercles) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$class(nom + ' stroke'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'focusable', 'false')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d(trace)
						]),
					_List_Nil),
				cercles));
	});
var $author$project$Components$Shared$Svg$svgArrowRight = A3($author$project$Components$Shared$Svg$icone, 'arrow-right', 'M5 12h14M15 8l4 4-4 4', _List_Nil);
var $rtfeldman$elm_css$Html$Styled$Attributes$type_ = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('type');
var $author$project$Components$Socle$Session$View$espace = F3(
	function (i18n, dernier, fourni) {
		var estLeDernier = fourni.sO && _Utils_eq(
			dernier,
			$elm$core$Maybe$Just(fourni.td));
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('suspendu', !fourni.sO),
							_Utils_Tuple2('dernier', estLeDernier)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_Utils_ap(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!fourni.sO)
							]),
						fourni.sO ? _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Socle$Session$Update$EspaceChoisi(fourni.td))
							]) : _List_Nil),
					_List_fromArray(
						[
							$author$project$Components$Shared$Navigation$View$logoDEspace(fourni),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(fourni.Dj)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											fourni.sO ? $author$project$I18n$Cles$marqueAsriaCrm(i18n) : $author$project$I18n$Cles$sessionEspacesSuspendu(i18n))
										]))
								])),
							estLeDernier ? A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('tag')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$sessionEspacesDernierChoisi(i18n))
								])) : $rtfeldman$elm_css$Html$Styled$text(''),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('fleche'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
								]),
							_List_fromArray(
								[$author$project$Components$Shared$Svg$svgArrowRight]))
						]))
				]));
	});
var $rtfeldman$elm_css$Html$Styled$h1 = $rtfeldman$elm_css$Html$Styled$node('h1');
var $rtfeldman$elm_css$Html$Styled$Attributes$id = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('id');
var $author$project$Components$Socle$Session$Model$sansAccent = function (lettre) {
	switch (lettre) {
		case 'à':
			return 'a';
		case 'â':
			return 'a';
		case 'ä':
			return 'a';
		case 'ç':
			return 'c';
		case 'é':
			return 'e';
		case 'è':
			return 'e';
		case 'ê':
			return 'e';
		case 'ë':
			return 'e';
		case 'î':
			return 'i';
		case 'ï':
			return 'i';
		case 'ô':
			return 'o';
		case 'ö':
			return 'o';
		case 'ù':
			return 'u';
		case 'û':
			return 'u';
		case 'ü':
			return 'u';
		default:
			return lettre;
	}
};
var $author$project$Components$Socle$Session$Model$cleDeTri = function (nom) {
	return A2(
		$elm$core$String$map,
		$author$project$Components$Socle$Session$Model$sansAccent,
		$elm$core$String$toLower(nom));
};
var $author$project$Components$Socle$Session$Model$ordonner = F2(
	function (dernier, espaces) {
		var estLeDernier = function (espace) {
			return espace.sO && _Utils_eq(
				$elm$core$Maybe$Just(espace.td),
				dernier);
		};
		var _v0 = A2(
			$elm$core$List$partition,
			estLeDernier,
			A2(
				$elm$core$List$sortBy,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Dj;
					},
					$author$project$Components$Socle$Session$Model$cleDeTri),
				espaces));
		var enTete = _v0.a;
		var suite = _v0.b;
		return _Utils_ap(enTete, suite);
	});
var $rtfeldman$elm_css$Html$Styled$p = $rtfeldman$elm_css$Html$Styled$node('p');
var $author$project$I18n$Cles$marqueAsria = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'marque.asria', _List_Nil, 'Asria');
};
var $author$project$Components$Socle$Session$View$pageDeSession = F3(
	function (racine, i18n, carte) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			racine,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('marque-asria')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$marqueAsria(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('carte')
						]),
					carte)
				]));
	});
var $author$project$I18n$Cles$sessionConnecteEnTantQue = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'session.connecte-en-tant-que',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'email',
					$author$project$I18n$Traductions$Chaine(p.yb))
				]),
			'Connecté(e) en tant que ' + p.yb);
	});
var $author$project$I18n$Cles$sessionEspacesAucunRaison = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'session.espaces.aucun.raison', _List_Nil, 'Votre compte n\'a accès à aucun espace actif. Contactez l\'administrateur de votre organisation ou votre interlocuteur Asria.');
};
var $author$project$I18n$Cles$sessionEspacesAucunTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'session.espaces.aucun.titre', _List_Nil, 'Aucun espace disponible');
};
var $author$project$I18n$Cles$sessionEspacesDeconnexion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'session.espaces.deconnexion', _List_Nil, 'Se déconnecter');
};
var $author$project$I18n$Cles$sessionEspacesNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'session.espaces.note', _List_Nil, 'Vous pourrez changer d\'espace à tout moment depuis le menu de votre compte, sans vous reconnecter.');
};
var $author$project$I18n$Cles$sessionEspacesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'session.espaces.titre', _List_Nil, 'Choisissez votre espace');
};
var $rtfeldman$elm_css$Html$Styled$ul = $rtfeldman$elm_css$Html$Styled$node('ul');
var $author$project$Components$Socle$Session$View$choixDEspace = F3(
	function (i18n, dernier, choix) {
		var _v0 = choix.yC;
		if (_v0.$ === 1) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var espaces = _v0.a;
			var aucun = !A2(
				$elm$core$List$any,
				function ($) {
					return $.sO;
				},
				espaces);
			return A3(
				$author$project$Components$Socle$Session$View$pageDeSession,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id('page-session-espaces'),
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('aucun', aucun)
							]))
					]),
				i18n,
				aucun ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$h1,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$sessionEspacesAucunTitre(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('session')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$sessionConnecteEnTantQue,
											i18n,
											{yb: choix.yb}))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('contenu')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$sessionEspacesAucunRaison(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('primary'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Socle$Session$Update$DeconnexionDemandee)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$sessionEspacesDeconnexion(i18n))
											]))
									]))
							]))
					]) : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$h1,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$sessionEspacesTitre(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('session')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$sessionConnecteEnTantQue,
											i18n,
											{yb: choix.yb}))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('contenu')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$ul,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('espaces')
									]),
								A2(
									$elm$core$List$map,
									A2($author$project$Components$Socle$Session$View$espace, i18n, dernier),
									A2($author$project$Components$Socle$Session$Model$ordonner, dernier, espaces))),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$sessionEspacesNote(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('deconnexion'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Socle$Session$Update$DeconnexionDemandee)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$sessionEspacesDeconnexion(i18n))
									]))
							]))
					]));
		}
	});
var $author$project$Components$Referentiel$Doublons$Model$compteurDuMenu = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		function (nombre) {
			return (nombre > 0) ? $elm$core$Maybe$Just(nombre) : $elm$core$Maybe$Nothing;
		},
		model.fV);
};
var $rtfeldman$elm_css$Html$Styled$a = $rtfeldman$elm_css$Html$Styled$node('a');
var $author$project$I18n$Cles$sessionAccesDesactiveChangerDEspace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'session.acces-desactive.changer-d-espace', _List_Nil, 'Changer d\'espace');
};
var $author$project$I18n$Cles$sessionAccesDesactiveDeconnexion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'session.acces-desactive.deconnexion', _List_Nil, 'Se déconnecter');
};
var $author$project$I18n$Cles$sessionAccesDesactiveEtat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'session.acces-desactive.etat', _List_Nil, 'Accès désactivé');
};
var $author$project$I18n$Cles$sessionAccesDesactiveRaison = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'session.acces-desactive.raison',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.yz)))
				]),
			'Vous ne pouvez plus utiliser cet espace. Pour retrouver l\'accès, adressez-vous à l\'administrateur ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.yz);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.yz);
					default:
						return 'de ' + $elm$core$String$trim(p.yz);
				}
			}() + '.'));
	});
var $author$project$I18n$Cles$sessionAccesDesactiveRaisonSansEspace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'session.acces-desactive.raison.sans-espace', _List_Nil, 'Vous ne pouvez plus utiliser cet espace. Pour retrouver l\'accès, adressez-vous à l\'administrateur de l\'espace.');
};
var $author$project$I18n$Cles$sessionAccesDesactiveTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'session.acces-desactive.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(p.yz))
				]),
			'Votre accès à ' + (p.yz + ' est désactivé'));
	});
var $author$project$I18n$Cles$sessionAccesDesactiveTitreSansEspace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'session.acces-desactive.titre.sans-espace', _List_Nil, 'Votre accès à cet espace est désactivé');
};
var $author$project$Components$Socle$Session$View$accesDesactive = F3(
	function (i18n, messages, desactive) {
		var _v0 = function () {
			var _v1 = desactive.yz;
			if (!_v1.$) {
				var nom = _v1.a;
				return _Utils_Tuple2(
					A2(
						$author$project$I18n$Cles$sessionAccesDesactiveTitre,
						i18n,
						{yz: nom}),
					A2(
						$author$project$I18n$Cles$sessionAccesDesactiveRaison,
						i18n,
						{
							av: $author$project$Texte$Elision$elision(nom),
							yz: nom
						}));
			} else {
				return _Utils_Tuple2(
					$author$project$I18n$Cles$sessionAccesDesactiveTitreSansEspace(i18n),
					$author$project$I18n$Cles$sessionAccesDesactiveRaisonSansEspace(i18n));
			}
		}();
		var titre = _v0.a;
		var raison = _v0.b;
		return A3(
			$author$project$Components$Socle$Session$View$pageDeSession,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id('page-session-acces-desactive')
				]),
			i18n,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h1,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(titre)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('session')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$sessionConnecteEnTantQue,
										i18n,
										{yb: desactive.yb}))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('contenu')
						]),
					_List_fromArray(
						[
							function () {
							var _v2 = desactive.yz;
							if (!_v2.$) {
								var nom = _v2.a;
								return A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('espace')
										]),
									_List_fromArray(
										[
											$author$project$Components$Shared$Navigation$View$logoDEspace(
											{n$: $elm$core$Maybe$Nothing, Dj: nom}),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$strong,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(nom)
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$sessionAccesDesactiveEtat(i18n))
														]))
												]))
										]));
							} else {
								return $rtfeldman$elm_css$Html$Styled$text('');
							}
						}(),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('raison')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(raison)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('primary'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(messages.u4)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$sessionAccesDesactiveChangerDEspace(i18n))
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('secondary'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(messages.wU)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$sessionAccesDesactiveDeconnexion(i18n))
												]))
										]))
								]))
						]))
				]));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$href = function (url) {
	return A2($rtfeldman$elm_css$Html$Styled$Attributes$stringProperty, 'href', url);
};
var $author$project$I18n$Cles$navigationDeconnexion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'navigation.deconnexion', _List_Nil, 'Déconnexion');
};
var $author$project$I18n$Cles$sessionAccesRefuseRaison = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'session.acces-refuse.raison', _List_Nil, 'Votre organisation n\'a pas accès à ASRIA CRM.');
};
var $author$project$I18n$Cles$sessionAccesRefuseTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'session.acces-refuse.titre', _List_Nil, 'Accès refusé');
};
var $author$project$I18n$Cles$sessionErreurRaison = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'session.erreur.raison', _List_Nil, 'La connexion à ASRIA CRM n\'a pas abouti.');
};
var $author$project$I18n$Cles$sessionErreurTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'session.erreur.titre', _List_Nil, 'Connexion impossible');
};
var $author$project$I18n$Cles$sessionRetourALAccueil = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'session.retour-a-l-accueil', _List_Nil, 'Revenir à l\'accueil');
};
var $author$project$Components$Socle$Session$View$ecran = F3(
	function (i18n, messages, cause) {
		var retour = A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$href(
					$author$project$Routes$Route$toString($author$project$Routes$Route$Version))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$I18n$Cles$sessionRetourALAccueil(i18n))
				]));
		switch (cause.$) {
			case 7:
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('acces-refuse')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h1,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$sessionAccesRefuseTitre(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$sessionAccesRefuseRaison(i18n))
								])),
							retour,
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('deconnexion'),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(messages.wU)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$navigationDeconnexion(i18n))
								]))
						]));
			case 8:
				var desactive = cause.a;
				return A3($author$project$Components$Socle$Session$View$accesDesactive, i18n, messages, desactive);
			default:
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('connexion-impossible')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h1,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$sessionErreurTitre(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$sessionErreurRaison(i18n))
								])),
							retour
						]));
		}
	});
var $author$project$Components$Comptes$Securite$Update$dialogueOuvert = function (model) {
	return (!_Utils_eq(model.iu, $elm$core$Maybe$Nothing)) || $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX);
};
var $author$project$Components$Comptes$Securite$View$dialogueOuvert = $author$project$Components$Comptes$Securite$Update$dialogueOuvert;
var $author$project$Components$Imports$Outil$Update$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.k5) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.lu) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.ll) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.lt) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.k0) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.lf) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.lm) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.ln) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.k9) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.lk) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.k6) || $author$project$Components$Shared$Drawer$Model$estOuvert(model.lv)))))))))));
};
var $author$project$Components$Imports$Outil$View$dialogueOuvert = $author$project$Components$Imports$Outil$Update$dialogueOuvert;
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsView$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.lC) || $author$project$Components$Shared$Drawer$Model$estOuvert(model.kZ);
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.dO) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.dR) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.dQ) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.dJ) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.dP) || $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsView$dialogueOuvert(model)))));
};
var $author$project$Components$Parametrage$NouveauChamp$View$ouvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.lp) || $author$project$Components$Shared$Drawer$Model$estOuvert(model.lc);
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.lA) || ($author$project$Components$Parametrage$NouveauChamp$View$ouvert(model.oP) || $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$dialogueOuvert(model)));
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.k7) || $author$project$Components$Shared$Drawer$Model$estOuvert(model.lj);
};
var $author$project$Components$Parametrage$CollectionsDeChamps$View$dialogueOuvert = $author$project$Components$Parametrage$CollectionsDeChamps$Update$dialogueOuvert;
var $author$project$Components$Parametrage$CompteDEnvoi$Update$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.k8) || $author$project$Components$Shared$Drawer$Model$estOuvert(model.k$));
};
var $author$project$Components$Parametrage$CompteDEnvoi$View$dialogueOuvert = $author$project$Components$Parametrage$CompteDEnvoi$Update$dialogueOuvert;
var $author$project$Components$Parametrage$CompteurDeCode$Update$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX);
};
var $author$project$Components$Parametrage$CompteurDeCode$View$dialogueOuvert = $author$project$Components$Parametrage$CompteurDeCode$Update$dialogueOuvert;
var $author$project$Components$Parametrage$Conservation$Update$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.lw) || $author$project$Components$Shared$Drawer$Model$estOuvert(model.ld);
};
var $author$project$Components$Parametrage$Conservation$View$dialogueOuvert = $author$project$Components$Parametrage$Conservation$Update$dialogueOuvert;
var $author$project$Components$Parametrage$Droits$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX);
};
var $author$project$Components$Parametrage$LanguesDuClient$Update$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.k_) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.ls) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.lh) || $author$project$Components$Shared$Drawer$Model$estOuvert(model.li)));
};
var $author$project$Components$Parametrage$LanguesDuClient$View$dialogueOuvert = $author$project$Components$Parametrage$LanguesDuClient$Update$dialogueOuvert;
var $author$project$Components$Parametrage$ModelesDeTache$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX);
};
var $author$project$Components$Parametrage$PipeEtape1$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX);
};
var $author$project$Components$Parametrage$PipeEtape2$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) || model.bB;
};
var $author$project$Components$Parametrage$PipeEtape3$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX);
};
var $author$project$Components$Parametrage$PipeEtape4$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX);
};
var $author$project$Components$Parametrage$PipeEtape5$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX);
};
var $author$project$Components$Parametrage$PipeEtape6$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX);
};
var $author$project$Components$Parametrage$PipeEtape7$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX);
};
var $author$project$Components$Parametrage$PipeVersions$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX);
};
var $author$project$Components$Parametrage$Utilisateurs$Update$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.xO) || ((!_Utils_eq(model.iq, $elm$core$Maybe$Nothing)) || (!_Utils_eq(model.iu, $elm$core$Maybe$Nothing))));
};
var $author$project$Components$Parametrage$Utilisateurs$View$dialogueOuvert = $author$project$Components$Parametrage$Utilisateurs$Update$dialogueOuvert;
var $author$project$Components$Produits$Catalogue$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) || $author$project$Components$Shared$Drawer$Model$estOuvert(model.dP);
};
var $author$project$Components$Produits$Correspondances$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX);
};
var $author$project$Components$Produits$FicheElement$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) || ((!_Utils_eq(model.ir, $elm$core$Maybe$Nothing)) || $author$project$Components$Shared$Drawer$Model$estOuvert(model.o1.kX));
};
var $author$project$Components$Produits$FicheType$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.lA) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.lC) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.lB) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.lE) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.lx) || (model.ir || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.eW) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.vE.kY) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.vE.lD) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.o1.kX) || $author$project$Components$Parametrage$NouveauChamp$Model$ouvert(model.oP)))))))))));
};
var $author$project$Components$Produits$ListeDePrix$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX);
};
var $author$project$Components$Produits$Listes$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX);
};
var $author$project$Components$Produits$ListesDePrix$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX);
};
var $author$project$Components$Produits$MarquesEtGammes$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX);
};
var $author$project$Components$Produits$Offre$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.lb) || model.is);
};
var $author$project$Components$Produits$Offres$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX);
};
var $author$project$Components$Produits$Perimetres$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX);
};
var $author$project$Components$Produits$Reference$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) || (model.is || (!_Utils_eq(model.dh, $elm$core$Maybe$Nothing)));
};
var $author$project$Components$Produits$SchemaDeNiveau$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX);
};
var $author$project$Components$Produits$StructureCatalogue$View$dialogueOuvert = function (model) {
	return A2(
		$elm$core$List$any,
		$author$project$Components$Shared$Drawer$Model$estOuvert,
		_List_fromArray(
			[model.dt.kX, model.hL, model.vk.kX, model.c5, model.qn, model.br, model.iG, model.pO, model.T, model.qo, model.qM, model.y, model.bg, model.bZ, model.cU.kX, model.gG.kX, model.aK.kX, model.aK.lg, model.dL, model.gc, model.c6, model.le, model.k3, model.dt.la, model.dt.hL])) || $author$project$Components$Parametrage$NouveauChamp$Model$ouvert(model.oP);
};
var $author$project$Components$Produits$TypesDeQuantite$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX);
};
var $author$project$Components$Referentiel$Doublons$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) || (!_Utils_eq(model.j6, $elm$core$Maybe$Nothing));
};
var $author$project$Components$Referentiel$Fiche$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.k4) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.k1) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.Bk.kX) || ((!_Utils_eq(
		$author$project$Components$Referentiel$Fiche$Liaisons$declencheurDeLaConfirmation(model.Bk),
		$elm$core$Maybe$Nothing)) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.lr) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.x9.kX) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.k9) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.lo) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.k2) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.oV.kX) || $author$project$Components$Shared$Drawer$Model$estOuvert(model.lq))))))))));
};
var $author$project$Components$Referentiel$Formes$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) || $author$project$Components$Shared$Drawer$Model$estOuvert(model.DG);
};
var $author$project$Components$Referentiel$Fusion$View$dialogueOuvert = function (model) {
	return model.j6;
};
var $author$project$Components$Referentiel$Groupe$View$dialogueOuvert = function (model) {
	return model.ir || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.qN) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.qp) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.jH) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.iH) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.kn) || $author$project$Components$Shared$Drawer$Model$estOuvert(model.oE))))));
};
var $author$project$Components$Referentiel$Groupes$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX);
};
var $author$project$Components$Referentiel$Postes$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) || $author$project$Components$Shared$Drawer$Model$estOuvert(model.DG);
};
var $author$project$Components$Referentiel$Type$View$dialogueOuvert = function (model) {
	return model.ir || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.hL) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.nV) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.lz) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.GZ.lx) || $author$project$Components$Parametrage$NouveauChamp$Model$ouvert(model.oP)))));
};
var $author$project$Components$Referentiel$Types$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.j9) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.hL) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.pJ) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.jK) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.jQ) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.jR) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.AM.kX) || ($author$project$Components$Parametrage$NouveauChamp$View$ouvert(model.AM.oP) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.vE.kY) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.vE.lD) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.o1.kX) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.AM.zo) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.AM.Ca) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.AM.qc) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.AM.lC) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.AM.ss) || ($author$project$Components$Shared$Drawer$Model$estOuvert(model.AM.GZ.lx) || $author$project$Components$Shared$Drawer$Model$estOuvert(model.AM.ly))))))))))))))))));
};
var $author$project$Components$Referentiel$TypesDeRelation$View$dialogueOuvert = function (model) {
	return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) || $author$project$Components$Shared$Drawer$Model$estOuvert(model.DG);
};
var $author$project$Main$View$dialogueOuvert = function (model) {
	var _v0 = model.Ih;
	switch (_v0.$) {
		case 3:
			return $author$project$Components$Referentiel$Fiche$View$dialogueOuvert(
				$author$project$Components$Referentiel$Fiche$Model$ouvrir(model.zo)) || $author$project$Components$Shared$Drawer$Model$estOuvert(model.z$.im);
		case 4:
			return $author$project$Components$Referentiel$Fusion$View$dialogueOuvert(model.z$);
		case 6:
			return $author$project$Components$Produits$StructureCatalogue$View$dialogueOuvert(
				$author$project$Components$Produits$StructureCatalogue$Model$ouvrir(model.I3));
		case 7:
			return $author$project$Components$Produits$SchemaDeNiveau$View$dialogueOuvert(
				$author$project$Components$Produits$SchemaDeNiveau$Model$ouvrir(model.Ir));
		case 23:
			return $author$project$Components$Produits$FicheElement$View$dialogueOuvert(
				$author$project$Components$Produits$FicheElement$Model$ouvrir(model.zr));
		case 8:
			return $author$project$Components$Produits$MarquesEtGammes$View$dialogueOuvert(
				$author$project$Components$Produits$MarquesEtGammes$Model$ouvrir(model.B7));
		case 40:
			return $author$project$Components$Produits$FicheType$View$dialogueOuvert(
				$author$project$Components$Produits$FicheType$Model$ouvrir(model.zs));
		case 25:
			return $author$project$Components$Produits$Catalogue$View$dialogueOuvert(
				$author$project$Components$Produits$Catalogue$Model$ouvrir(model.jB));
		case 26:
			return $author$project$Components$Produits$Catalogue$View$dialogueOuvert(
				$author$project$Components$Produits$Catalogue$Model$ouvrir(model.jB));
		case 27:
			return $author$project$Components$Produits$Catalogue$View$dialogueOuvert(
				$author$project$Components$Produits$Catalogue$Model$ouvrir(model.jB));
		case 28:
			return $author$project$Components$Produits$Reference$View$dialogueOuvert(
				$author$project$Components$Produits$Reference$Model$ouvrir(model.Hc));
		case 30:
			return $author$project$Components$Produits$Offres$View$dialogueOuvert(
				$author$project$Components$Produits$Offres$Model$ouvrir(model.D3));
		case 31:
			return $author$project$Components$Produits$Offre$View$dialogueOuvert(
				$author$project$Components$Produits$Offre$Model$ouvrir(model.D1));
		case 11:
			return $author$project$Components$Parametrage$PipeEtape1$View$dialogueOuvert(
				$author$project$Components$Parametrage$PipeEtape1$Model$ouvrir(model.Fy));
		case 12:
			return $author$project$Components$Parametrage$PipeEtape2$View$dialogueOuvert(
				$author$project$Components$Parametrage$PipeEtape2$Model$ouvrir(model.Fz));
		case 13:
			return $author$project$Components$Parametrage$PipeEtape3$View$dialogueOuvert(
				$author$project$Components$Parametrage$PipeEtape3$Model$ouvrir(model.FA));
		case 14:
			return $author$project$Components$Parametrage$PipeEtape4$View$dialogueOuvert(
				$author$project$Components$Parametrage$PipeEtape4$Model$ouvrir(model.FB));
		case 15:
			return $author$project$Components$Parametrage$PipeEtape5$View$dialogueOuvert(
				$author$project$Components$Parametrage$PipeEtape5$Model$ouvrir(model.FC));
		case 16:
			return $author$project$Components$Parametrage$PipeEtape6$View$dialogueOuvert(
				$author$project$Components$Parametrage$PipeEtape6$Model$ouvrir(model.FD));
		case 17:
			return $author$project$Components$Parametrage$PipeEtape7$View$dialogueOuvert(
				$author$project$Components$Parametrage$PipeEtape7$Model$ouvrir(model.FE));
		case 19:
			return $author$project$Components$Parametrage$PipeVersions$View$dialogueOuvert(model.FL);
		case 10:
			return $author$project$Components$Parametrage$ModelesDeTache$View$dialogueOuvert(model.CL);
		case 35:
			return $author$project$Components$Referentiel$Doublons$View$dialogueOuvert(
				$author$project$Components$Referentiel$Doublons$Model$ouvrir(model.xM));
		case 36:
			return $author$project$Components$Referentiel$Doublons$View$dialogueOuvert(
				$author$project$Components$Referentiel$Doublons$Model$ouvrir(model.xM));
		case 33:
			return false;
		case 34:
			return false;
		case 37:
			return $author$project$Components$Produits$ListesDePrix$View$dialogueOuvert(model.BW);
		case 38:
			return $author$project$Components$Produits$ListeDePrix$View$dialogueOuvert(
				$author$project$Components$Produits$ListeDePrix$Model$ouvrir(model.nY));
		case 42:
			switch (_v0.a) {
				case 5:
					var _v1 = _v0.a;
					return $author$project$Components$Parametrage$Conservation$View$dialogueOuvert(model.v5);
				case 6:
					var _v2 = _v0.a;
					return $author$project$Components$Referentiel$TypesDeRelation$View$dialogueOuvert(model.J2) || ($author$project$Components$Referentiel$Postes$View$dialogueOuvert(model.F6) || $author$project$Components$Referentiel$Formes$View$dialogueOuvert(model.zS));
				default:
					return $author$project$Components$Referentiel$Types$View$dialogueOuvert(
						$author$project$Components$Referentiel$Types$Model$ouvrir(model.J0));
			}
		case 43:
			return $author$project$Components$Referentiel$Groupes$View$dialogueOuvert(model.Ac);
		case 52:
			return $author$project$Components$Referentiel$Groupe$View$dialogueOuvert(
				$author$project$Components$Referentiel$Groupe$Model$ouvrir(model.m2));
		case 54:
			return $author$project$Components$Parametrage$Conservation$View$dialogueOuvert(model.v5);
		case 55:
			return $author$project$Components$Parametrage$LanguesDuClient$View$dialogueOuvert(model.Bb);
		case 56:
			return $author$project$Components$Parametrage$Utilisateurs$View$dialogueOuvert(
				$author$project$Components$Parametrage$Utilisateurs$Model$ouvrir(model.Kf));
		case 57:
			return $author$project$Components$Parametrage$Utilisateurs$View$dialogueOuvert(
				$author$project$Components$Parametrage$Utilisateurs$Model$ouvrir(model.Kf));
		case 58:
			return $author$project$Components$Parametrage$Utilisateurs$View$dialogueOuvert(
				$author$project$Components$Parametrage$Utilisateurs$Model$ouvrir(model.Kf));
		case 59:
			return $author$project$Components$Parametrage$Utilisateurs$View$dialogueOuvert(
				$author$project$Components$Parametrage$Utilisateurs$Model$ouvrir(model.Kf));
		case 66:
			return $author$project$Components$Imports$Outil$View$dialogueOuvert(
				$author$project$Components$Imports$Outil$Model$ouvrir(model.AC));
		case 67:
			return $author$project$Components$Imports$Outil$View$dialogueOuvert(
				$author$project$Components$Imports$Outil$Model$ouvrir(model.AC));
		case 68:
			return $author$project$Components$Imports$Outil$View$dialogueOuvert(
				$author$project$Components$Imports$Outil$Model$ouvrir(model.AC));
		case 60:
			return $author$project$Components$Parametrage$CompteurDeCode$View$dialogueOuvert(model.v$);
		case 61:
			return $author$project$Components$Parametrage$CompteDEnvoi$View$dialogueOuvert(model.vX);
		case 63:
			return false;
		case 64:
			return $author$project$Components$Comptes$Securite$View$dialogueOuvert(model.q1);
		case 65:
			return $author$project$Components$Comptes$Securite$View$dialogueOuvert(model.q1);
		case 53:
			return $author$project$Components$Parametrage$Droits$View$dialogueOuvert(
				$author$project$Components$Parametrage$Droits$Model$ouvrir(model.xS));
		case 44:
			return $author$project$Components$Produits$Listes$View$dialogueOuvert(
				$author$project$Components$Produits$Listes$Model$ouvrir(model.n_));
		case 45:
			return $author$project$Components$Produits$Listes$View$dialogueOuvert(
				$author$project$Components$Produits$Listes$Model$ouvrir(model.n_));
		case 47:
			return $author$project$Components$Produits$Perimetres$View$dialogueOuvert(
				$author$project$Components$Produits$Perimetres$Model$ouvrir(model.pg));
		case 48:
			return $author$project$Components$Produits$Perimetres$View$dialogueOuvert(
				$author$project$Components$Produits$Perimetres$Model$ouvrir(model.pg));
		case 49:
			return $author$project$Components$Produits$TypesDeQuantite$View$dialogueOuvert(
				$author$project$Components$Produits$TypesDeQuantite$Model$deballer(model.J1));
		case 46:
			return $author$project$Components$Produits$Correspondances$View$dialogueOuvert(
				$author$project$Components$Produits$Correspondances$Model$ouvrir(model.wh));
		case 50:
			return $author$project$Components$Produits$Correspondances$View$dialogueOuvert(
				$author$project$Components$Produits$Correspondances$Model$ouvrir(model.wh));
		case 51:
			return $author$project$Components$Parametrage$BibliothequeDeChamps$View$dialogueOuvert(
				$author$project$Components$Parametrage$BibliothequeDeChamps$Model$ouvrir(model.dq)) || $author$project$Components$Parametrage$CollectionsDeChamps$View$dialogueOuvert(model.vF);
		case 69:
			return $author$project$Components$Referentiel$Type$View$dialogueOuvert(
				$author$project$Components$Referentiel$Type$Model$ouvrir(model.JT));
		default:
			return false;
	}
};
var $author$project$Main$View$inerteSousUnDialogue = F2(
	function (model, donnees) {
		return _Utils_update(
			donnees,
			{
				AK: $author$project$Main$View$dialogueOuvert(model)
			});
	});
var $rtfeldman$elm_css$VirtualDom$Styled$KeyedNode = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$KeyedNodeNS = F4(
	function (a, b, c, d) {
		return {$: 3, a: a, b: b, c: c, d: d};
	});
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
var $rtfeldman$elm_css$VirtualDom$Styled$mapAttribute = F2(
	function (transform, _v0) {
		var prop = _v0.a;
		var styles = _v0.b;
		var classname = _v0.c;
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$mapAttribute, transform, prop),
			styles,
			classname);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$map = F2(
	function (transform, vdomNode) {
		switch (vdomNode.$) {
			case 0:
				var elemType = vdomNode.a;
				var properties = vdomNode.b;
				var children = vdomNode.c;
				return A3(
					$rtfeldman$elm_css$VirtualDom$Styled$Node,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
						properties),
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$map(transform),
						children));
			case 1:
				var ns = vdomNode.a;
				var elemType = vdomNode.b;
				var properties = vdomNode.c;
				var children = vdomNode.d;
				return A4(
					$rtfeldman$elm_css$VirtualDom$Styled$NodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
						properties),
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$map(transform),
						children));
			case 2:
				var elemType = vdomNode.a;
				var properties = vdomNode.b;
				var children = vdomNode.c;
				return A3(
					$rtfeldman$elm_css$VirtualDom$Styled$KeyedNode,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
						properties),
					A2(
						$elm$core$List$map,
						function (_v1) {
							var key = _v1.a;
							var child = _v1.b;
							return _Utils_Tuple2(
								key,
								A2($rtfeldman$elm_css$VirtualDom$Styled$map, transform, child));
						},
						children));
			case 3:
				var ns = vdomNode.a;
				var elemType = vdomNode.b;
				var properties = vdomNode.c;
				var children = vdomNode.d;
				return A4(
					$rtfeldman$elm_css$VirtualDom$Styled$KeyedNodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
						properties),
					A2(
						$elm$core$List$map,
						function (_v2) {
							var key = _v2.a;
							var child = _v2.b;
							return _Utils_Tuple2(
								key,
								A2($rtfeldman$elm_css$VirtualDom$Styled$map, transform, child));
						},
						children));
			default:
				var vdom = vdomNode.a;
				return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
					A2($elm$virtual_dom$VirtualDom$map, transform, vdom));
		}
	});
var $rtfeldman$elm_css$Html$Styled$map = $rtfeldman$elm_css$VirtualDom$Styled$map;
var $author$project$Components$Shared$Navigation$View$courante = function (estCourante) {
	return estCourante ? _List_fromArray(
		[
			A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-current', 'page')
		]) : _List_Nil;
};
var $rtfeldman$elm_css$Html$Styled$i = $rtfeldman$elm_css$Html$Styled$node('i');
var $rtfeldman$elm_css$Html$Styled$Attributes$title = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('title');
var $author$project$Components$Shared$Navigation$View$application = function (fournie) {
	var contenu = _List_fromArray(
		[
			A2($rtfeldman$elm_css$Html$Styled$i, _List_Nil, _List_Nil),
			A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(fournie.Dj)
				]))
		]);
	return A2(
		$rtfeldman$elm_css$Html$Styled$li,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class(fournie.dy)
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = fournie.aa;
				if (!_v0.$) {
					var adresse = _v0.a;
					return A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_Utils_ap(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href(adresse),
									$rtfeldman$elm_css$Html$Styled$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('active', fournie.wj)
										])),
									$rtfeldman$elm_css$Html$Styled$Attributes$title(fournie.Dj)
								]),
							$author$project$Components$Shared$Navigation$View$courante(fournie.wj)),
						contenu);
				} else {
					return A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$title(fournie.Dj),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('locked')
							]),
						contenu);
				}
			}()
			]));
};
var $author$project$Components$Shared$Navigation$Update$CompteBascule = {$: 0};
var $author$project$Components$Shared$Navigation$Update$EspacesBascule = {$: 6};
var $author$project$Components$Shared$Navigation$Update$DeconnexionDemandee = {$: 5};
var $author$project$Components$Shared$Svg$traceSecondaire = function (trace) {
	return A2(
		$rtfeldman$elm_css$Svg$Styled$path,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Svg$Styled$Attributes$class('secondaire'),
				$rtfeldman$elm_css$Svg$Styled$Attributes$d(trace)
			]),
		_List_Nil);
};
var $author$project$Components$Shared$Svg$svgLogout = A3(
	$author$project$Components$Shared$Svg$icone,
	'logout',
	'M17.5078,15.7351 L21.2509,11.9921 L17.5078,8.24902 M21.2509,11.9921 L9.08594,11.9921',
	_List_fromArray(
		[
			$author$project$Components$Shared$Svg$traceSecondaire('M14.9403,4.68959 C13.7449,3.97152 12.3571,3.56055 10.8769,3.56055 C6.38852,3.56055 2.75,7.33901 2.75,12 C2.75,16.6609 6.38852,20.4394 10.8769,20.4394 C12.3571,20.4394 13.7449,20.0284 14.9403,19.3104')
		]));
var $author$project$Components$Shared$Navigation$View$boutonDeDeconnexion = function (i18n) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$button,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
				$rtfeldman$elm_css$Html$Styled$Attributes$class('deconnexion'),
				$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Shared$Navigation$Update$DeconnexionDemandee)
			]),
		_List_fromArray(
			[
				$author$project$Components$Shared$Svg$svgLogout,
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$navigationDeconnexion(i18n))
					]))
			]));
};
var $author$project$I18n$Cles$navigationChangerDEspace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'navigation.changer-d-espace', _List_Nil, 'Changer d\'espace');
};
var $author$project$I18n$Cles$navigationMonCompte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'navigation.mon-compte', _List_Nil, 'Mon compte');
};
var $author$project$Components$Shared$Navigation$View$entreesDuCompte = F2(
	function (i18n, donnees) {
		return _Utils_ap(
			($elm$core$List$length(donnees.yC) > 1) ? _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('changer-d-espace')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Shared$Navigation$Update$EspacesBascule)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$navigationChangerDEspace(i18n))
								]))
						]))
				]) : _List_Nil,
			_Utils_ap(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (adresse) {
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mon-compte')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$href(adresse)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$navigationMonCompte(i18n))
												]))
										]))
								]);
						},
						donnees.CT)),
				donnees.wU ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('logout')
							]),
						_List_fromArray(
							[
								$author$project$Components$Shared$Navigation$View$boutonDeDeconnexion(i18n)
							]))
					]) : _List_Nil));
	});
var $author$project$I18n$Cles$navigationEspaceCourant = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'navigation.espace-courant', _List_Nil, 'Espace courant');
};
var $rtfeldman$elm_css$Html$Styled$small = $rtfeldman$elm_css$Html$Styled$node('small');
var $author$project$Components$Shared$Navigation$View$espaceCourant = F2(
	function (i18n, espaces) {
		var _v0 = A2(
			$elm$core$List$filter,
			function ($) {
				return $.wi;
			},
			espaces);
		if (_v0.b) {
			var courant = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('espace-courant')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$small,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$navigationEspaceCourant(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('espace')
							]),
						_List_fromArray(
							[
								$author$project$Components$Shared$Navigation$View$logoDEspace(courant),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(courant.Dj)
									]))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Shared$Navigation$Update$EspaceChoisi = function (a) {
	return {$: 7, a: a};
};
var $author$project$I18n$Cles$navigationEspaceSuspendu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'navigation.espace-suspendu', _List_Nil, 'Compte suspendu');
};
var $author$project$Components$Shared$Navigation$View$espaceAChoisir = F2(
	function (i18n, espace) {
		var mention = espace.wi ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$small,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$navigationEspaceCourant(i18n))
					]))
			]) : ((!espace.sO) ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$small,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$navigationEspaceSuspendu(i18n))
					]))
			]) : _List_Nil);
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('courant', espace.wi),
							_Utils_Tuple2('suspendu', !espace.sO)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_Utils_ap(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(espace.wi || (!espace.sO))
							]),
						espace.wi ? _List_fromArray(
							[
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-current', 'true')
							]) : _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Shared$Navigation$Update$EspaceChoisi(espace.dy))
							])),
					A2(
						$elm$core$List$cons,
						$author$project$Components$Shared$Navigation$View$logoDEspace(espace),
						A2(
							$elm$core$List$cons,
							A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(espace.Dj)
									])),
							mention)))
				]));
	});
var $author$project$I18n$Cles$navigationChangerDEspaceNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'navigation.changer-d-espace.note', _List_Nil, 'Les écrans ouverts seront fermés.');
};
var $author$project$I18n$Cles$navigationChangerDEspaceRetour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'navigation.changer-d-espace.retour', _List_Nil, 'Retour au menu du compte');
};
var $author$project$Components$Shared$Svg$svgChevronLeft = A3($author$project$Components$Shared$Svg$icone, 'chevron-left', 'M15 6l-6 6 6 6', _List_Nil);
var $author$project$Components$Shared$Navigation$View$listeDesEspaces = F2(
	function (i18n, espaces) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('espaces')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('retour')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('button-icon'),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									$author$project$I18n$Cles$navigationChangerDEspaceRetour(i18n)),
									$rtfeldman$elm_css$Html$Styled$Attributes$title(
									$author$project$I18n$Cles$navigationChangerDEspaceRetour(i18n)),
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Shared$Navigation$Update$EspacesBascule)
								]),
							_List_fromArray(
								[$author$project$Components$Shared$Svg$svgChevronLeft])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$navigationChangerDEspace(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Components$Shared$Navigation$View$espaceAChoisir(i18n),
						espaces)),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$navigationChangerDEspaceNote(i18n))
						]))
				]));
	});
var $author$project$I18n$Cles$navigationCompte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'navigation.compte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.Dj)))
				]),
			function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'Compte de ' + $elm$core$String$trim(p.Dj);
					case 1:
						return 'Compte d\'' + $elm$core$String$trim(p.Dj);
					default:
						return 'Compte de ' + $elm$core$String$trim(p.Dj);
				}
			}());
	});
var $author$project$Components$Shared$Navigation$View$compte = F4(
	function (i18n, donnees, model, fourni) {
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-expanded',
						model.j3 ? 'true' : 'false'),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-label',
						A2(
							$author$project$I18n$Cles$navigationCompte,
							i18n,
							{
								av: $author$project$Texte$Elision$elision(fourni.Dj),
								Dj: fourni.Dj
							})),
						$rtfeldman$elm_css$Html$Styled$Attributes$title(
						A2(
							$author$project$I18n$Cles$navigationCompte,
							i18n,
							{
								av: $author$project$Texte$Elision$elision(fourni.Dj),
								Dj: fourni.Dj
							})),
						$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Shared$Navigation$Update$CompteBascule)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$i,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(fourni.AP)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('menu'),
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('opened', model.j3),
								_Utils_Tuple2('espaces-ouverts', model.l9)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('identity')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('picture')
									]),
								_List_Nil),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('name')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(fourni.Dj)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('account')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('role')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(fourni.bi)
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('organisation')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(fourni.En)
											]))
									]))
							])),
						A2($author$project$Components$Shared$Navigation$View$espaceCourant, i18n, donnees.yC),
						function () {
						var _v0 = A2($author$project$Components$Shared$Navigation$View$entreesDuCompte, i18n, donnees);
						if (!_v0.b) {
							return $rtfeldman$elm_css$Html$Styled$text('');
						} else {
							var entrees = _v0;
							return A2($rtfeldman$elm_css$Html$Styled$ul, _List_Nil, entrees);
						}
					}(),
						($elm$core$List$length(donnees.yC) > 1) ? A2($author$project$Components$Shared$Navigation$View$listeDesEspaces, i18n, donnees.yC) : $rtfeldman$elm_css$Html$Styled$text('')
					]))
			]);
	});
var $author$project$Components$Shared$Navigation$View$inertie = function (inerte) {
	return inerte ? _List_fromArray(
		[
			A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'inert', ''),
			A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
		]) : _List_Nil;
};
var $rtfeldman$elm_css$Html$Styled$nav = $rtfeldman$elm_css$Html$Styled$node('nav');
var $author$project$I18n$Cles$navigationApplications = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'navigation.applications', _List_Nil, 'Applications de la suite');
};
var $author$project$Components$Shared$Navigation$View$barreDesApplications = F3(
	function (i18n, donnees, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$nav,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$id('menu-aside'),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-label',
						$author$project$I18n$Cles$navigationApplications(i18n)),
					$author$project$Components$Shared$Navigation$View$inertie(donnees.AK))),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('apps')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_Nil,
							A2($elm$core$List$map, $author$project$Components$Shared$Navigation$View$application, donnees.tz))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('user')
						]),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A3($author$project$Components$Shared$Navigation$View$compte, i18n, donnees, model),
							donnees.vW)))
				]));
	});
var $author$project$Components$Shared$Navigation$Update$DeplieSurEcranEtroitBascule = {$: 3};
var $author$project$I18n$Cles$navigationDeplier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'navigation.deplier', _List_Nil, 'Déplier le menu');
};
var $author$project$I18n$Cles$navigationReplier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'navigation.replier', _List_Nil, 'Replier le menu');
};
var $author$project$Components$Shared$Svg$svgMenuClose = A3(
	$author$project$Components$Shared$Svg$icone,
	'menu-close',
	'M7 16L3 11.9994M3 11.9994L7 8M3 11.9994L21 12',
	_List_fromArray(
		[
			$author$project$Components$Shared$Svg$traceSecondaire('M12 5H21M12 19H21')
		]));
var $author$project$Components$Shared$Svg$svgMenuOpen = A3(
	$author$project$Components$Shared$Svg$icone,
	'menu-open',
	'M17 16L21 11.9994M21 11.9994L17 8M21 11.9994L3 12',
	_List_fromArray(
		[
			$author$project$Components$Shared$Svg$traceSecondaire('M12 5H3M12 19H3')
		]));
var $author$project$Components$Shared$Navigation$View$iconeEtLibelleDeRepli = F2(
	function (i18n, deplie) {
		return deplie ? _List_fromArray(
			[
				$author$project$Components$Shared$Svg$svgMenuClose,
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$navigationReplier(i18n))
					]))
			]) : _List_fromArray(
			[
				$author$project$Components$Shared$Svg$svgMenuOpen,
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$navigationDeplier(i18n))
					]))
			]);
	});
var $author$project$Components$Shared$Navigation$View$boutonDEcranEtroit = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('deplier-sur-ecran-etroit'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-pressed',
					model.kG ? 'true' : 'false'),
					$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Shared$Navigation$Update$DeplieSurEcranEtroitBascule)
				]),
			A2($author$project$Components$Shared$Navigation$View$iconeEtLibelleDeRepli, i18n, model.kG));
	});
var $author$project$Components$Shared$Navigation$Update$RepliBascule = {$: 2};
var $author$project$Components$Shared$Navigation$View$boutonDeRepli = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('replier'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-pressed',
					model.qt ? 'true' : 'false'),
					$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Shared$Navigation$Update$RepliBascule)
				]),
			A2($author$project$Components$Shared$Navigation$View$iconeEtLibelleDeRepli, i18n, !model.qt));
	});
var $author$project$Components$Shared$Navigation$Update$SectionBascule = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Shared$Navigation$View$pastilleDe = function (fournie) {
	if (!fournie.$) {
		var pastille = fournie.a;
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille'),
						$rtfeldman$elm_css$Html$Styled$Attributes$title(pastille.Dj),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', pastille.Dj)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$elm$core$String$fromInt(pastille.w))
					]))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Shared$Navigation$View$sousEntree = function (fournie) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$li,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('active', fournie.wj)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$a,
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Html$Styled$Attributes$href(fournie.aa),
					$author$project$Components$Shared$Navigation$View$courante(fournie.wj)),
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Html$Styled$text(fournie.Dj),
					$author$project$Components$Shared$Navigation$View$pastilleDe(fournie.hn)))
			]));
};
var $author$project$Components$Shared$Navigation$View$section = function (fournie) {
	return A2(
		$elm$core$List$cons,
		A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('titre-de-section')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(fournie.h6)
				])),
		A2($elm$core$List$map, $author$project$Components$Shared$Navigation$View$sousEntree, fournie.yv));
};
var $author$project$Components$Shared$Navigation$Model$sectionOuverte = F3(
	function (model, nom, courante) {
		return A2(
			$elm$core$Maybe$withDefault,
			courante,
			A2($elm$core$Dict$get, nom, model.hU));
	});
var $author$project$Components$Shared$Navigation$View$entree = F2(
	function (model, fournie) {
		var ouverte = A3($author$project$Components$Shared$Navigation$Model$sectionOuverte, model, fournie.Dj, fournie.wj);
		var contenu = _Utils_ap(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$i,
					_List_Nil,
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Html$Styled$map, $elm$core$Basics$never, fournie.aC)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(fournie.Dj)
						]))
				]),
			$author$project$Components$Shared$Navigation$View$pastilleDe(fournie.hn));
		return ($elm$core$List$isEmpty(fournie.hY) && $elm$core$List$isEmpty(fournie.hT)) ? A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('active', fournie.wj)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$href(fournie.aa),
						A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Attributes$title(fournie.Dj),
							$author$project$Components$Shared$Navigation$View$courante(fournie.wj))),
					contenu)
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('active', fournie.wj),
							_Utils_Tuple2('ouverte', ouverte)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$title(fournie.Dj),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-expanded',
							ouverte ? 'true' : 'false'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							A2($author$project$Components$Shared$Navigation$Update$SectionBascule, fournie.Dj, !ouverte))
						]),
					contenu),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('sous-entrees')
						]),
					_Utils_ap(
						A2($elm$core$List$map, $author$project$Components$Shared$Navigation$View$sousEntree, fournie.hY),
						A2($elm$core$List$concatMap, $author$project$Components$Shared$Navigation$View$section, fournie.hT)))
				]));
	});
var $author$project$I18n$Cles$navigationLogoApplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'navigation.logo.application', _List_Nil, 'CRM');
};
var $author$project$Components$Shared$Navigation$View$logo = F2(
	function (i18n, nomApplication) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('logo')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$href('/accueil'),
							$rtfeldman$elm_css$Html$Styled$Attributes$title(nomApplication)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('asria')
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('app')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$navigationLogoApplication(i18n))
								]))
						]))
				]));
	});
var $author$project$I18n$Cles$navigationMenu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'navigation.menu', _List_Nil, 'Menu de l\'application');
};
var $rtfeldman$elm_css$Html$Styled$input = $rtfeldman$elm_css$Html$Styled$node('input');
var $rtfeldman$elm_css$Html$Styled$kbd = $rtfeldman$elm_css$Html$Styled$node('kbd');
var $author$project$I18n$Cles$navigationRecherche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'navigation.recherche', _List_Nil, 'Recherche globale');
};
var $author$project$I18n$Cles$navigationRecherchePlaceholder = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'navigation.recherche.placeholder', _List_Nil, 'Rechercher');
};
var $author$project$I18n$Cles$navigationRechercheTouche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'navigation.recherche.touche', _List_Nil, 'Ctrl K');
};
var $rtfeldman$elm_css$Html$Styled$Attributes$placeholder = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('placeholder');
var $author$project$Components$Shared$Navigation$Model$raccourcisDeRecherche = _List_fromArray(
	['Control+K', 'Meta+K']);
var $rtfeldman$elm_css$Svg$Styled$circle = $rtfeldman$elm_css$Svg$Styled$node('circle');
var $rtfeldman$elm_css$Svg$Styled$Attributes$cx = $rtfeldman$elm_css$VirtualDom$Styled$attribute('cx');
var $rtfeldman$elm_css$Svg$Styled$Attributes$cy = $rtfeldman$elm_css$VirtualDom$Styled$attribute('cy');
var $rtfeldman$elm_css$Svg$Styled$Attributes$r = $rtfeldman$elm_css$VirtualDom$Styled$attribute('r');
var $author$project$Components$Shared$Svg$cercle = F3(
	function (x, y, rayon) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$circle,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$cx(
					$elm$core$String$fromFloat(x)),
					$rtfeldman$elm_css$Svg$Styled$Attributes$cy(
					$elm$core$String$fromFloat(y)),
					$rtfeldman$elm_css$Svg$Styled$Attributes$r(
					$elm$core$String$fromFloat(rayon))
				]),
			_List_Nil);
	});
var $author$project$Components$Shared$Svg$svgSearch = A3(
	$author$project$Components$Shared$Svg$icone,
	'search',
	'M15.6821,15.8648 L20,20.1767',
	_List_fromArray(
		[
			A3($author$project$Components$Shared$Svg$cercle, 10.9517, 10.7716, 6.9516)
		]));
var $author$project$Components$Shared$Navigation$View$recherche = function (i18n) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('search')
			]),
		_List_fromArray(
			[
				$author$project$Components$Shared$Svg$svgSearch,
				A2(
				$rtfeldman$elm_css$Html$Styled$input,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Shared$Navigation$Model$idRecherche),
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('search'),
						$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(
						$author$project$I18n$Cles$navigationRecherchePlaceholder(i18n)),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-label',
						$author$project$I18n$Cles$navigationRecherche(i18n)),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-keyshortcuts',
						A2($elm$core$String$join, ' ', $author$project$Components$Shared$Navigation$Model$raccourcisDeRecherche))
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$kbd,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$navigationRechercheTouche(i18n))
					]))
			]));
};
var $author$project$Components$Shared$Navigation$View$menu = F3(
	function (i18n, donnees, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$nav,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id('menu-main'),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-label',
						$author$project$I18n$Cles$navigationMenu(i18n))
					]),
				$author$project$Components$Shared$Navigation$View$inertie(donnees.AK)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('hider')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('scroll')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('menu-top')
										]),
									_List_fromArray(
										[
											A2($author$project$Components$Shared$Navigation$View$logo, i18n, donnees.Dk),
											A2($author$project$Components$Shared$Navigation$View$boutonDeRepli, i18n, model),
											A2($author$project$Components$Shared$Navigation$View$boutonDEcranEtroit, i18n, model)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('menu-content')
										]),
									_List_fromArray(
										[
											$author$project$Components$Shared$Navigation$View$recherche(i18n),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('nav')
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$ul,
													_List_Nil,
													A2(
														$elm$core$List$map,
														$author$project$Components$Shared$Navigation$View$entree(model),
														donnees.yv))
												]))
										]))
								]))
						]))
				]));
	});
var $rtfeldman$elm_css$Html$Styled$menu = $rtfeldman$elm_css$Html$Styled$node('menu');
var $author$project$Components$Shared$Note$View$Information = 0;
var $author$project$I18n$Cles$coquilleEspaceEnPreparation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'coquille.espace-en-preparation', _List_Nil, 'Les droits de cet espace sont en cours de préparation. Réessayez dans quelques instants.');
};
var $author$project$I18n$Cles$coquilleEspaceEnPreparationTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'coquille.espace-en-preparation.titre', _List_Nil, 'Espace en préparation');
};
var $rtfeldman$elm_css$Html$Styled$ol = $rtfeldman$elm_css$Html$Styled$node('ol');
var $author$project$I18n$Cles$pageFilDAriane = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'page.fil-d-ariane', _List_Nil, 'Fil d\'Ariane');
};
var $author$project$Components$Shared$Page$View$filDAriane = F2(
	function (i18n, etapes) {
		var etapeDuFil = function (etape) {
			return $elm$core$String$isEmpty(etape.aa) ? A2(
				$rtfeldman$elm_css$Html$Styled$li,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-current', 'page')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(etape.Dj)
							]))
					])) : A2(
				$rtfeldman$elm_css$Html$Styled$li,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$href(etape.aa)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(etape.Dj)
							]))
					]));
		};
		return $elm$core$List$isEmpty(etapes) ? _List_Nil : _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$nav,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('breadcrumb'),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-label',
						$author$project$I18n$Cles$pageFilDAriane(i18n))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$ol,
						_List_Nil,
						A2($elm$core$List$map, etapeDuFil, etapes))
					]))
			]);
	});
var $author$project$Components$Shared$Page$View$enTete = F2(
	function (i18n, contenu) {
		return _Utils_ap(
			A2($author$project$Components$Shared$Page$View$filDAriane, i18n, contenu.zE),
			_Utils_ap(
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$h1,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(contenu.h6)
							])),
					contenu.vS),
				contenu.Ef));
	});
var $author$project$Components$Shared$Page$View$inertie = function (inerte) {
	return inerte ? _List_fromArray(
		[
			A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'inert', ''),
			A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
		]) : _List_Nil;
};
var $author$project$Components$Shared$Page$View$page = F2(
	function (nom, zones) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id('page-' + nom)
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Attributes$id('top'),
							$author$project$Components$Shared$Page$View$inertie(zones.AK)),
						zones.JD),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Attributes$id('bottom'),
							$author$project$Components$Shared$Page$View$inertie(zones.AK)),
						zones.ut),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Attributes$id('fixed'),
							$author$project$Components$Shared$Page$View$inertie(zones.AK)),
						zones.zM)
					]),
				zones.xy));
	});
var $author$project$Components$Shared$Note$View$classe = function (sens) {
	switch (sens) {
		case 0:
			return 'information';
		case 1:
			return 'avertissement';
		case 2:
			return 'erreur';
		default:
			return 'validation';
	}
};
var $author$project$Components$Shared$Note$View$view = F2(
	function (sens, contenu) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('note'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					$author$project$Components$Shared$Note$View$classe(sens)),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'note')
				]),
			contenu);
	});
var $author$project$Components$Socle$Coquille$View$enPreparation = function (i18n) {
	return A2(
		$author$project$Components$Shared$Page$View$page,
		'espace-en-preparation',
		{
			ut: _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('espace-en-preparation')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Note$View$view,
									0,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$coquilleEspaceEnPreparation(i18n))
												]))
										]))
								]))
						]))
				]),
			xy: _List_Nil,
			zM: _List_Nil,
			AK: false,
			JD: A2(
				$author$project$Components$Shared$Page$View$enTete,
				i18n,
				{
					vS: _List_Nil,
					zE: _List_Nil,
					Ef: _List_Nil,
					h6: $author$project$I18n$Cles$coquilleEspaceEnPreparationTitre(i18n)
				})
		});
};
var $author$project$I18n$Cles$posteEtapeApercuExemple = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'poste.etape.apercu.exemple',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'poste',
					$author$project$I18n$Traductions$Chaine(p.F4))
				]),
			'Claire Faure est ' + (p.F4 + ' de Brandt'));
	});
var $author$project$I18n$Cles$posteEtapeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'poste.etape.titre', _List_Nil, 'Postes');
};
var $author$project$Components$Referentiel$Postes$View$apercu = F2(
	function (i18n, model) {
		var _v0 = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.F6;
					},
					$elm$core$List$filter(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.tE;
							},
							$elm$core$Basics$not))),
				model.nW));
		if (!_v0.b) {
			return {gV: _List_Nil, w: 0};
		} else {
			var premier = _v0.a;
			var reste = _v0.b;
			return {
				gV: _List_fromArray(
					[
						{
						dX: true,
						eW: 0,
						Jx: $author$project$I18n$Cles$posteEtapeTitre(i18n)
					},
						{
						dX: false,
						eW: 1,
						Jx: A2(
							$author$project$I18n$Cles$posteEtapeApercuExemple,
							i18n,
							{
								F4: $elm$core$String$toLower(premier.R.zX)
							})
					}
					]),
				w: 1 + $elm$core$List$length(reste)
			};
		}
	});
var $author$project$I18n$Cles$backofficeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'backoffice.titre', _List_Nil, 'ASRIA CRM — back-office');
};
var $author$project$Main$View$champsProposables = function (bibliotheque) {
	return A2(
		$elm$core$List$filterMap,
		function (champ) {
			return A2(
				$elm$core$Maybe$map,
				function (id) {
					return {vD: champ.vD, Aq: id, Bl: champ.Bl, F$: champ.F$, rU: champ.rU};
				},
				champ.Aq);
		},
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.dw;
				},
				bibliotheque.EE)));
};
var $author$project$Components$Referentiel$Formes$Update$EnregistrementDemande = {$: 10};
var $author$project$Components$Referentiel$Formes$Update$Saisi = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Referentiel$Formes$Update$ArchivageDemande = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Shared$Bouton$View$Destructif = 3;
var $author$project$Components$Shared$Bouton$View$classe = function (variante) {
	switch (variante) {
		case 0:
			return 'primary';
		case 1:
			return 'secondary';
		case 2:
			return 'tertiary';
		default:
			return 'destructive';
	}
};
var $author$project$Components$Shared$Bouton$View$bouton = F3(
	function (variante, attributs, libelle) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Html$Styled$Attributes$class('button'),
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
							$author$project$Components$Shared$Bouton$View$classe(variante)),
						attributs))),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						]))
				]));
	});
var $author$project$I18n$Cles$formeDrawerArchiver = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'forme.drawer.archiver', _List_Nil, 'Archiver');
};
var $author$project$I18n$Cles$formeDrawerArchiverAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'forme.drawer.archiver.aide', _List_Nil, 'Archivée, la forme n\'est plus proposée pour de nouvelles fiches. Les fiches la gardent. Vous pouvez la restaurer.');
};
var $author$project$I18n$Cles$formeDrawerArchiverBouton = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'forme.drawer.archiver.bouton',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			'Archiver « ' + (p.Bl + ' »'));
	});
var $rtfeldman$elm_css$Html$Styled$h3 = $rtfeldman$elm_css$Html$Styled$node('h3');
var $rtfeldman$elm_css$Html$Styled$section = $rtfeldman$elm_css$Html$Styled$node('section');
var $author$project$Components$Referentiel$Formes$View$archivage = F2(
	function (i18n, modification) {
		if (!modification.$) {
			var forme = modification.a;
			var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$archiverLaForme, forme.nQ);
			if (!_v1.$) {
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$section,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('archivage')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$h3,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$formeDrawerArchiver(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$formeDrawerArchiverAide(i18n))
									])),
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								3,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Referentiel$Formes$Update$ArchivageDemande(forme.Aq))
									]),
								A2(
									$author$project$I18n$Cles$formeDrawerArchiverBouton,
									i18n,
									{Bl: forme.R.zX}))
							]))
					]);
			} else {
				return _List_Nil;
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Referentiel$Formes$Model$estEnvoi = function (model) {
	return $author$project$API$Envoi$enCours(model.l2);
};
var $author$project$I18n$Cles$formeDrawerCreer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'forme.drawer.creer', _List_Nil, 'Créer la forme');
};
var $author$project$I18n$Cles$formeDrawerKickerCreation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'forme.drawer.kicker-creation', _List_Nil, 'Nouvelle forme');
};
var $author$project$I18n$Cles$formeDrawerKickerForme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'forme.drawer.kicker-forme', _List_Nil, 'Forme d\'organisation');
};
var $author$project$I18n$Cles$formeDrawerTitreCreation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'forme.drawer.titre-creation', _List_Nil, 'Ajouter une forme');
};
var $author$project$Components$Referentiel$Formes$Model$Fr = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$Formes$View$boutonDuNom = function (libelle) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$button,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
				$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
				$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Formes$Model$idDuNom),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'dialog'),
				$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Formes$Model$OuvrirNom)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(libelle)
			]));
};
var $author$project$I18n$Cles$formeLibelleDoublon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'forme.libelle.doublon', _List_Nil, 'Une forme porte déjà ce nom');
};
var $author$project$I18n$Cles$relationLibelleObligatoire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.libelle.obligatoire', _List_Nil, 'Ce champ est obligatoire.');
};
var $author$project$Components$Referentiel$Formes$View$erreurDeLibelle = F2(
	function (i18n, saisie) {
		return (saisie.b5 && $elm$core$String$isEmpty(
			$elm$core$String$trim(saisie.zX))) ? $elm$core$Maybe$Just(
			$author$project$I18n$Cles$relationLibelleObligatoire(i18n)) : (_Utils_eq(
			saisie.pZ,
			$elm$core$Maybe$Just($author$project$Components$Referentiel$Formes$Model$Doublon)) ? $elm$core$Maybe$Just(
			$author$project$I18n$Cles$formeLibelleDoublon(i18n)) : $elm$core$Maybe$Nothing);
	});
var $author$project$I18n$Cles$formeDrawerNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'forme.drawer.nom', _List_Nil, 'Nom');
};
var $author$project$I18n$Cles$relationDrawerAnglais = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'relation.drawer.anglais',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Anglais : ' + p.Dj);
	});
var $author$project$I18n$Cles$relationDrawerAnglaisARenseigner = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.anglais-a-renseigner', _List_Nil, 'Anglais : à renseigner');
};
var $author$project$I18n$Cles$relationDrawerAnglaisVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.anglais-vide', _List_Nil, 'Anglais : —');
};
var $author$project$I18n$Cles$relationDrawerRenommer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.renommer', _List_Nil, 'Renommer');
};
var $author$project$I18n$Cles$relationDrawerTraduire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.traduire', _List_Nil, 'Traduire');
};
var $author$project$Components$Shared$Champ$View$idErreur = function (champ) {
	return champ.Aq + '-erreur';
};
var $author$project$Components$Shared$Champ$View$etatsDecrits = F2(
	function (aides, champ) {
		var decrit = _Utils_ap(
			aides,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (_v0) {
						return _List_fromArray(
							[
								$author$project$Components$Shared$Champ$View$idErreur(champ)
							]);
					},
					champ.go)));
		return _Utils_ap(
			champ.he ? _List_fromArray(
				[
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-required', 'true')
				]) : _List_Nil,
			_Utils_ap(
				(!_Utils_eq(champ.go, $elm$core$Maybe$Nothing)) ? _List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-invalid', 'true')
					]) : _List_Nil,
				$elm$core$List$isEmpty(decrit) ? _List_Nil : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-describedby',
						A2($elm$core$String$join, ' ', decrit))
					])));
	});
var $author$project$Components$Shared$Champ$View$etats = $author$project$Components$Shared$Champ$View$etatsDecrits(_List_Nil);
var $author$project$Components$Shared$Champ$View$idLibelle = function (champ) {
	return champ.Aq + '-libelle';
};
var $author$project$Components$Shared$Champ$View$controle = function (champ) {
	return A2(
		$elm$core$List$cons,
		$rtfeldman$elm_css$Html$Styled$Attributes$id(champ.Aq),
		A2(
			$elm$core$List$cons,
			A2(
				$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
				'aria-labelledby',
				$author$project$Components$Shared$Champ$View$idLibelle(champ)),
			$author$project$Components$Shared$Champ$View$etats(champ)));
};
var $author$project$Components$Shared$Champ$View$classes = function (champ) {
	return $rtfeldman$elm_css$Html$Styled$Attributes$classList(
		_List_fromArray(
			[
				_Utils_Tuple2('mandatory', champ.he),
				_Utils_Tuple2(
				'error',
				!_Utils_eq(champ.go, $elm$core$Maybe$Nothing))
			]));
};
var $author$project$Components$Shared$Champ$View$erreurs = function (champ) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$ul,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('errors'),
				$rtfeldman$elm_css$Html$Styled$Attributes$id(
				$author$project$Components$Shared$Champ$View$idErreur(champ))
			]),
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (message) {
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(message)
								]))
						]);
				},
				champ.go)));
};
var $rtfeldman$elm_css$Html$Styled$fieldset = $rtfeldman$elm_css$Html$Styled$node('fieldset');
var $rtfeldman$elm_css$Html$Styled$legend = $rtfeldman$elm_css$Html$Styled$node('legend');
var $author$project$Components$Shared$Champ$View$libelle = function (champ) {
	return A2(
		$elm$core$List$cons,
		$rtfeldman$elm_css$Html$Styled$text(champ.Bl),
		champ.he ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$strong,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('asterisque')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('*')
					]))
			]) : _List_Nil);
};
var $author$project$Components$Shared$Champ$View$formItem = F2(
	function (champ, contenu) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$fieldset,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
					$author$project$Components$Shared$Champ$View$classes(champ)
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$legend,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id(
									$author$project$Components$Shared$Champ$View$idLibelle(champ))
								]),
							$author$project$Components$Shared$Champ$View$libelle(champ))
						])),
				_Utils_ap(
					contenu,
					_List_fromArray(
						[
							$author$project$Components$Shared$Champ$View$erreurs(champ)
						]))));
	});
var $rtfeldman$elm_css$Html$Styled$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $rtfeldman$elm_css$Html$Styled$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $rtfeldman$elm_css$Html$Styled$Events$onInput = function (tagger) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$rtfeldman$elm_css$Html$Styled$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $rtfeldman$elm_css$Html$Styled$Events$targetValue)));
};
var $rtfeldman$elm_css$Html$Styled$Attributes$value = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('value');
var $author$project$Components$Shared$Champ$View$texteAvecIndication = F2(
	function (champ, saisie) {
		return A2(
			$author$project$Components$Shared$Champ$View$formItem,
			champ,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
						A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Attributes$value(saisie.fm),
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_css$Html$Styled$Events$onInput(saisie.hg),
								_Utils_ap(
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeR, $rtfeldman$elm_css$Html$Styled$Attributes$placeholder, $elm$core$List$singleton),
											saisie.na)),
									$author$project$Components$Shared$Champ$View$controle(champ))))),
					_List_Nil)
				]));
	});
var $author$project$Components$Shared$Champ$View$texte = F2(
	function (champ, saisie) {
		return A2(
			$author$project$Components$Shared$Champ$View$texteAvecIndication,
			champ,
			{na: $elm$core$Maybe$Nothing, hg: saisie.hg, fm: saisie.fm});
	});
var $author$project$Components$Referentiel$Formes$View$nom = F3(
	function (i18n, prefixe, saisie) {
		var anglais = $elm$core$String$isEmpty(
			$elm$core$String$trim(saisie.yg)) ? $author$project$I18n$Cles$relationDrawerAnglaisARenseigner(i18n) : A2(
			$author$project$I18n$Cles$relationDrawerAnglais,
			i18n,
			{
				Dj: $elm$core$String$trim(saisie.yg)
			});
		var _v0 = saisie.n9;
		if (!_v0.$) {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$section,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('noms')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Champ$View$texte,
							{
								go: A2($author$project$Components$Referentiel$Formes$View$erreurDeLibelle, i18n, saisie),
								Aq: prefixe + '-fr',
								Bl: $author$project$I18n$Cles$formeDrawerNom(i18n),
								he: true
							},
							{hg: $author$project$Components$Referentiel$Formes$Model$Fr, fm: saisie.zX}),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('anglais')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$strong,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(anglais)
												]))
										])),
									$author$project$Components$Referentiel$Formes$View$boutonDuNom(
									$author$project$I18n$Cles$relationDrawerTraduire(i18n))
								]))
						]))
				]);
		} else {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$section,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('noms')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$formeDrawerNom(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$strong,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(saisie.zX)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$elm$core$String$isEmpty(
														$elm$core$String$trim(saisie.yg)) ? $author$project$I18n$Cles$relationDrawerAnglaisVide(i18n) : A2(
														$author$project$I18n$Cles$relationDrawerAnglais,
														i18n,
														{
															Dj: $elm$core$String$trim(saisie.yg)
														}))
												]))
										])),
									$author$project$Components$Referentiel$Formes$View$boutonDuNom(
									$author$project$I18n$Cles$relationDrawerRenommer(i18n))
								]))
						]))
				]);
		}
	});
var $author$project$Components$Referentiel$Formes$View$refusEnMessage = function (refus) {
	if ((!refus.$) && (refus.a.$ === 1)) {
		var dit = refus.a.a;
		return _List_fromArray(
			[
				{Jx: dit, b9: $elm$core$Maybe$Nothing}
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$I18n$Cles$relationDrawerEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$formeDrawerUtilisation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'forme.drawer.utilisation', _List_Nil, 'Utilisation');
};
var $author$project$I18n$Cles$formeDrawerUtilisationNombre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'forme.drawer.utilisation.nombre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiche') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiches'));
	});
var $author$project$I18n$Cles$formeDrawerUtilisationSuite = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'forme.drawer.utilisation.suite',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ' a cette forme.' : ' ont cette forme.');
	});
var $author$project$Components$Referentiel$Formes$View$utilisation = F2(
	function (i18n, modification) {
		if (!modification.$) {
			var forme = modification.a;
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$section,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('utilisation')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$formeDrawerUtilisation(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$formeDrawerUtilisationNombre,
												i18n,
												{w: forme.zu}))
										])),
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$formeDrawerUtilisationSuite,
										i18n,
										{w: forme.zu}))
								]))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$I18n$Cles$drawerAnnuler = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'drawer.annuler', _List_Nil, 'Annuler');
};
var $author$project$Components$Shared$Bouton$View$Principal = 0;
var $author$project$Components$Shared$Bouton$View$Secondaire = 1;
var $author$project$Components$Shared$Drawer$View$piedDe = F3(
	function (libelle, supplementaires, versMsg) {
		return {
			oJ: $elm$core$Maybe$Nothing,
			HF: function (attributs) {
				return A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_Utils_ap(
						attributs,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								versMsg($author$project$Components$Shared$Drawer$Update$Fermer))
							])),
					libelle);
			},
			Jb: supplementaires
		};
	});
var $author$project$Components$Shared$Confirmation$View$Courte = 0;
var $author$project$Components$Shared$Drawer$Update$FocusDemande = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Shared$Drawer$Update$retenir = function (msg) {
	return $elm$json$Json$Decode$succeed(
		_Utils_Tuple2(msg, true));
};
var $author$project$Components$Shared$Drawer$Update$clavier = function (dialogue) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			var touche = _v0.a;
			var maj = _v0.b;
			var cible = _v0.c;
			return (touche !== 'Tab') ? $elm$json$Json$Decode$fail('') : ((maj && A2(
				$elm$core$List$member,
				cible,
				_List_fromArray(
					[dialogue.GN, dialogue.h6, dialogue.Ge]))) ? $author$project$Components$Shared$Drawer$Update$retenir(
				$author$project$Components$Shared$Drawer$Update$FocusDemande(dialogue.xg)) : (((!maj) && A2(
				$elm$core$List$member,
				cible,
				_List_fromArray(
					[dialogue.GN, dialogue.xg]))) ? $author$project$Components$Shared$Drawer$Update$retenir(
				$author$project$Components$Shared$Drawer$Update$FocusDemande(dialogue.Ge)) : $elm$json$Json$Decode$fail('')));
		},
		A4(
			$elm$json$Json$Decode$map3,
			F3(
				function (touche, maj, cible) {
					return _Utils_Tuple3(touche, maj, cible);
				}),
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['target', 'id']),
				$elm$json$Json$Decode$string)));
};
var $author$project$Components$Shared$Drawer$Model$idAbandonner = function (model) {
	return $author$project$Components$Shared$Drawer$Model$idConfirmation(model) + '-abandonner';
};
var $author$project$Components$Shared$Drawer$Model$idConfirmationMessage = function (model) {
	return $author$project$Components$Shared$Drawer$Model$idConfirmation(model) + '-message';
};
var $author$project$Components$Shared$Drawer$Model$idConfirmationTitre = function (model) {
	return $author$project$Components$Shared$Drawer$Model$idConfirmation(model) + '-titre';
};
var $author$project$Components$Shared$Drawer$Update$clavierDeLaConfirmation = function (model) {
	return $author$project$Components$Shared$Drawer$Update$clavier(
		{
			xg: $author$project$Components$Shared$Drawer$Model$idAbandonner(model),
			Ge: $author$project$Components$Shared$Drawer$Model$idConfirmationMessage(model),
			GN: $author$project$Components$Shared$Drawer$Model$idConfirmation(model),
			h6: $author$project$Components$Shared$Drawer$Model$idConfirmationTitre(model)
		});
};
var $author$project$Components$Shared$Drawer$Model$idAction = function (model) {
	return $author$project$Components$Shared$Drawer$Model$idRacine(model) + '-action';
};
var $author$project$Components$Shared$Drawer$Model$idAnnuler = function (model) {
	return $author$project$Components$Shared$Drawer$Model$idRacine(model) + '-annuler';
};
var $author$project$Components$Shared$Drawer$Model$idFermer = function (model) {
	return $author$project$Components$Shared$Drawer$Model$idRacine(model) + '-fermer';
};
var $author$project$Components$Shared$Drawer$Update$clavierDuDrawer = F2(
	function (_v0, model) {
		var actionActive = _v0.sP;
		return $author$project$Components$Shared$Drawer$Update$clavier(
			{
				xg: actionActive ? $author$project$Components$Shared$Drawer$Model$idAction(model) : $author$project$Components$Shared$Drawer$Model$idAnnuler(model),
				Ge: $author$project$Components$Shared$Drawer$Model$idFermer(model),
				GN: $author$project$Components$Shared$Drawer$Model$idRacine(model),
				h6: $author$project$Components$Shared$Drawer$Model$idTitre(model)
			});
	});
var $author$project$I18n$Cles$drawerAbandonAbandonner = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'drawer.abandon.abandonner', _List_Nil, 'Abandonner la saisie');
};
var $author$project$I18n$Cles$drawerAbandonMessage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'drawer.abandon.message', _List_Nil, 'Les informations saisies ne seront pas enregistrées.');
};
var $author$project$I18n$Cles$drawerAbandonPoursuivre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'drawer.abandon.poursuivre', _List_Nil, 'Poursuivre la saisie');
};
var $author$project$I18n$Cles$drawerAbandonTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'drawer.abandon.titre', _List_Nil, 'Abandonner la saisie ?');
};
var $author$project$I18n$Cles$drawerFermer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'drawer.fermer', _List_Nil, 'Fermer');
};
var $rtfeldman$elm_css$Html$Styled$h2 = $rtfeldman$elm_css$Html$Styled$node('h2');
var $author$project$Components$Shared$Drawer$View$inertie = function (inerte) {
	return inerte ? _List_fromArray(
		[
			A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'inert', ''),
			A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
		]) : _List_Nil;
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $author$project$Components$Shared$Svg$svgClose = A3($author$project$Components$Shared$Svg$icone, 'close', 'M6 6l12 12M18 6L6 18', _List_Nil);
var $rtfeldman$elm_css$Html$Styled$Attributes$tabindex = function (n) {
	return A2(
		$rtfeldman$elm_css$VirtualDom$Styled$attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $author$project$Components$Shared$Drawer$View$versDecodeur = function (versMsg) {
	return $elm$json$Json$Decode$map(
		$elm$core$Tuple$mapFirst(versMsg));
};
var $author$project$Components$Shared$Drawer$View$panneau = F5(
	function (i18n, versMsg, contenu, pied, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						$author$project$Components$Shared$Drawer$Model$idRacine(model)),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'dialog'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-modal', 'true'),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-labelledby',
						$author$project$Components$Shared$Drawer$Model$idTitre(model)),
						$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1),
						A2(
						$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
						'keydown',
						A2($author$project$Components$Shared$Drawer$View$versDecodeur, versMsg, contenu.vl))
					]),
				$author$project$Components$Shared$Drawer$View$inertie(contenu.AK)),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer-top')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('titres')
									]),
								A2(
									$elm$core$List$filterMap,
									$elm$core$Basics$identity,
									_List_fromArray(
										[
											A2(
											$elm$core$Maybe$map,
											function (kicker) {
												return A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('kicker')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(kicker)
														]));
											},
											contenu.A6),
											$elm$core$Maybe$Just(
											A2(
												$rtfeldman$elm_css$Html$Styled$h2,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$id(
														$author$project$Components$Shared$Drawer$Model$idTitre(model)),
														$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(contenu.h6)
													]))),
											A2(
											$elm$core$Maybe$map,
											function (sousTitre) {
												return A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('sous-titre')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(sousTitre)
														]));
											},
											contenu.aO)
										]))),
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$id(
										$author$project$Components$Shared$Drawer$Model$idFermer(model)),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer-close'),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
										'aria-label',
										$author$project$I18n$Cles$drawerFermer(i18n)),
										$rtfeldman$elm_css$Html$Styled$Attributes$title(
										$author$project$I18n$Cles$drawerFermer(i18n)),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										versMsg($author$project$Components$Shared$Drawer$Update$Fermer))
									]),
								_List_fromArray(
									[$author$project$Components$Shared$Svg$svgClose]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('hider')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('scroll')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer-content')
											]),
										contenu.fZ)
									]))
							]))
					]),
				$elm$core$List$isEmpty(pied) ? _List_Nil : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer-actions')
							]),
						pied)
					])));
	});
var $author$project$Components$Shared$Confirmation$View$Neutre = 3;
var $author$project$Components$Shared$Confirmation$View$bouton = F2(
	function (variante, fourni) {
		return A3(
			$author$project$Components$Shared$Bouton$View$bouton,
			variante,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id(fourni.Aq),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(fourni.C$)
				]),
			fourni.Bl);
	});
var $author$project$Components$Shared$Confirmation$View$actions = function (boite) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
			]),
		_List_fromArray(
			[
				A2($author$project$Components$Shared$Confirmation$View$bouton, 1, boite.HG),
				A2(
				$author$project$Components$Shared$Confirmation$View$bouton,
				(boite.sl === 3) ? 0 : 3,
				boite.j7)
			]));
};
var $author$project$Components$Shared$Confirmation$View$AlerteBloquante = 1;
var $author$project$Components$Shared$Confirmation$View$AvecNote = 2;
var $author$project$Components$Shared$Confirmation$View$racine = function (boite) {
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$id(boite.Aq),
			$rtfeldman$elm_css$Html$Styled$Attributes$class('confirmation'),
			$rtfeldman$elm_css$Html$Styled$Attributes$classList(
			_List_fromArray(
				[
					_Utils_Tuple2('opened', boite.Et),
					_Utils_Tuple2('alerte', boite.sl === 1),
					_Utils_Tuple2('avec-note', boite.sl === 2)
				])),
			A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alertdialog'),
			A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-modal', 'true'),
			A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-labelledby', boite.At),
			A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-describedby', boite.As),
			$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1),
			A2($rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn, 'keydown', boite.vl)
		]);
};
var $author$project$Components$Shared$Confirmation$View$viewAvecResume = F3(
	function (i18n, resume, boite) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			$author$project$Components$Shared$Confirmation$View$racine(boite),
			function () {
				var _v0 = boite.sl;
				if (_v0 === 2) {
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('top')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h2,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id(boite.At)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(boite.h6)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer-close'),
											A2(
											$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
											'aria-label',
											$author$project$I18n$Cles$drawerFermer(i18n)),
											$rtfeldman$elm_css$Html$Styled$Attributes$title(
											$author$project$I18n$Cles$drawerFermer(i18n)),
											$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(boite.HG.C$)
										]),
									_List_fromArray(
										[$author$project$Components$Shared$Svg$svgClose]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('contenu')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id(boite.As),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('note'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('avertissement'),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'note'),
											$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(0)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(boite.Cs)
										]))
								])),
							$author$project$Components$Shared$Confirmation$View$actions(boite)
						]);
				} else {
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id(boite.At)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(boite.h6)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id(boite.As),
									$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(0)
								]),
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_css$Html$Styled$text(boite.Cs),
								(resume === '') ? _List_Nil : _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('resume')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(resume)
											]))
									]))),
							$author$project$Components$Shared$Confirmation$View$actions(boite)
						]);
				}
			}());
	});
var $author$project$Components$Shared$Confirmation$View$view = F2(
	function (i18n, boite) {
		return A3($author$project$Components$Shared$Confirmation$View$viewAvecResume, i18n, '', boite);
	});
var $author$project$Components$Shared$Drawer$View$viewAvecPied = F7(
	function (i18n, variante, sousTitre, pied, versMsg, contenu, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'opened',
							$author$project$Components$Shared$Drawer$Model$estOuvert(model)),
							_Utils_Tuple2('drawer-large', contenu.Bc)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('overlay'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							versMsg($author$project$Components$Shared$Drawer$Update$SortieDemandee))
						]),
					_List_Nil),
					A5(
					$author$project$Components$Shared$Drawer$View$panneau,
					i18n,
					versMsg,
					{
						vl: A2(
							$author$project$Components$Shared$Drawer$Update$clavierDuDrawer,
							{sP: contenu.fs.sR},
							model),
						fZ: contenu.fZ,
						AK: model.gt === 2,
						A6: contenu.A6,
						aO: sousTitre,
						h6: contenu.h6
					},
					_Utils_ap(
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$map,
									function (note) {
										return A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('pied-note')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(note)
												]));
									},
									pied(versMsg).oJ)
								])),
						_Utils_ap(
							_List_fromArray(
								[
									pied(versMsg).HF(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id(
											$author$project$Components$Shared$Drawer$Model$idAnnuler(model))
										]))
								]),
							_Utils_ap(
								pied(versMsg).Jb,
								_List_fromArray(
									[
										A3(
										$author$project$Components$Shared$Bouton$View$bouton,
										variante,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id(
												$author$project$Components$Shared$Drawer$Model$idAction(model)),
												$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!contenu.fs.sR),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(contenu.fs.C$)
											]),
										contenu.fs.Bl)
									])))),
					model),
					A2(
					$author$project$Components$Shared$Confirmation$View$view,
					i18n,
					{
						vl: A2(
							$author$project$Components$Shared$Drawer$View$versDecodeur,
							versMsg,
							$author$project$Components$Shared$Drawer$Update$clavierDeLaConfirmation(model)),
						j7: {
							Aq: $author$project$Components$Shared$Drawer$Model$idAbandonner(model),
							Bl: $author$project$I18n$Cles$drawerAbandonAbandonner(i18n),
							C$: versMsg($author$project$Components$Shared$Drawer$Update$AbandonConfirme)
						},
						Aq: $author$project$Components$Shared$Drawer$Model$idConfirmation(model),
						As: $author$project$Components$Shared$Drawer$Model$idConfirmationMessage(model),
						At: $author$project$Components$Shared$Drawer$Model$idConfirmationTitre(model),
						Cs: $author$project$I18n$Cles$drawerAbandonMessage(i18n),
						Et: model.gt === 2,
						HG: {
							Aq: $author$project$Components$Shared$Drawer$Model$idRester(model),
							Bl: $author$project$I18n$Cles$drawerAbandonPoursuivre(i18n),
							C$: versMsg($author$project$Components$Shared$Drawer$Update$AbandonRefuse)
						},
						h6: $author$project$I18n$Cles$drawerAbandonTitre(i18n),
						sl: 0
					})
				]));
	});
var $author$project$Components$Shared$Drawer$View$viewAvecRenoncement = F2(
	function (i18n, libelleDuRenoncement) {
		return A4(
			$author$project$Components$Shared$Drawer$View$viewAvecPied,
			i18n,
			0,
			$elm$core$Maybe$Nothing,
			A2($author$project$Components$Shared$Drawer$View$piedDe, libelleDuRenoncement, _List_Nil));
	});
var $author$project$Components$Shared$Drawer$View$view = function (i18n) {
	return A2(
		$author$project$Components$Shared$Drawer$View$viewAvecRenoncement,
		i18n,
		$author$project$I18n$Cles$drawerAnnuler(i18n));
};
var $author$project$Components$Shared$Note$View$Avertissement = 1;
var $author$project$I18n$Cles$erreurApiReference = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'erreur.api.reference',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'traceId',
					$author$project$I18n$Traductions$Chaine(p.b9))
				]),
			'Référence : ' + p.b9);
	});
var $author$project$Components$Shared$Messages$View$reference = F2(
	function (i18n, traceId) {
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('reference')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$erreurApiReference,
							i18n,
							{b9: traceId}))
					]))
			]);
	});
var $author$project$I18n$Cles$texte = $author$project$I18n$Traductions$rendre;
var $author$project$Components$Shared$Messages$View$message = F2(
	function (i18n, fourni) {
		return A2(
			$author$project$Components$Shared$Note$View$view,
			1,
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$I18n$Cles$texte, i18n, fourni.Jx))
						])),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$author$project$Components$Shared$Messages$View$reference(i18n),
						fourni.b9))));
	});
var $author$project$Components$Shared$Messages$View$messageAvecLien = function (fourni) {
	return A2(
		$author$project$Components$Shared$Note$View$view,
		1,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(fourni.Jx)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$href(fourni.aa)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(fourni.Bl)
					]))
			]));
};
var $author$project$Components$Shared$Messages$View$avec = F3(
	function (i18n, lies, messages) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('messages'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
				]),
			_Utils_ap(
				A2($elm$core$List$map, $author$project$Components$Shared$Messages$View$messageAvecLien, lies),
				A2(
					$elm$core$List$map,
					$author$project$Components$Shared$Messages$View$message(i18n),
					messages)));
	});
var $author$project$Components$Shared$Messages$View$view = function (i18n) {
	return A2($author$project$Components$Shared$Messages$View$avec, i18n, _List_Nil);
};
var $author$project$Components$Referentiel$Formes$View$drawer = F2(
	function (i18n, model) {
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.kX);
		var modification = function () {
			var _v1 = model.hP.n9;
			if (_v1.$ === 1) {
				var forme = _v1.a;
				return $elm$core$Maybe$Just(forme);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$Formes$Update$DuDrawer,
			{
				fs: {
					sR: !$author$project$Components$Referentiel$Formes$Model$estEnvoi(model),
					Bl: _Utils_eq(modification, $elm$core$Maybe$Nothing) ? $author$project$I18n$Cles$formeDrawerCreer(i18n) : $author$project$I18n$Cles$relationDrawerEnregistrer(i18n),
					C$: $author$project$Components$Referentiel$Formes$Update$EnregistrementDemande
				},
				fZ: _Utils_ap(
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Referentiel$Formes$Update$Saisi),
						_Utils_ap(
							A3($author$project$Components$Referentiel$Formes$View$nom, i18n, prefixe, model.hP),
							A2($author$project$Components$Referentiel$Formes$View$utilisation, i18n, modification))),
					_Utils_ap(
						A2($author$project$Components$Referentiel$Formes$View$archivage, i18n, modification),
						_List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Messages$View$view,
								i18n,
								$author$project$Components$Referentiel$Formes$View$refusEnMessage(model.hP.pZ))
							]))),
				A6: $elm$core$Maybe$Just(
					_Utils_eq(modification, $elm$core$Maybe$Nothing) ? $author$project$I18n$Cles$formeDrawerKickerCreation(i18n) : $author$project$I18n$Cles$formeDrawerKickerForme(i18n)),
				Bc: false,
				h6: function () {
					if (!modification.$) {
						var forme = modification.a;
						return forme.R.zX;
					} else {
						return $author$project$I18n$Cles$formeDrawerTitreCreation(i18n);
					}
				}()
			},
			model.kX);
	});
var $author$project$Components$Referentiel$Formes$Model$En = function (a) {
	return {$: 1, a: a};
};
var $author$project$I18n$Cles$relationDrawerNomEn = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.nom-en', _List_Nil, 'Nom en anglais');
};
var $author$project$I18n$Cles$relationDrawerNomsValider = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.noms-valider', _List_Nil, 'Valider');
};
var $author$project$I18n$Cles$relationDrawerRenommerDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'relation.drawer.renommer-de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Renommer « ' + (p.Dj + ' »'));
	});
var $author$project$Components$Shared$LibellesParLangue$View$CoteACote = 0;
var $author$project$Components$Shared$LibellesParLangue$View$PrefixeEtLangue = 1;
var $author$project$Referentiel$Langues$nom = F2(
	function (i18n, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			code,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Bl;
					},
					$author$project$I18n$Cles$texte(i18n)),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (langue) {
							return _Utils_eq(langue.vx, code);
						},
						$author$project$Referentiel$Langues$toutes))));
	});
var $author$project$I18n$Cles$saisieDeChampParLangueFacultative = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'saisie-de-champ.par-langue.facultative',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'langue',
					$author$project$I18n$Traductions$Chaine(p.nn))
				]),
			p.nn + ' (facultatif)');
	});
var $author$project$I18n$Cles$saisieDeChampParNomDeLangue = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'saisie-de-champ.par-nom-de-langue',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl)),
					_Utils_Tuple2(
					'langue',
					$author$project$I18n$Traductions$Chaine(p.nn))
				]),
			p.Bl + (' (' + ($elm$core$String$toLower(p.nn) + ')')));
	});
var $author$project$I18n$Cles$saisieDeChampPrefixeEtLangue = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'saisie-de-champ.prefixe-et-langue',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl)),
					_Utils_Tuple2(
					'langue',
					$author$project$I18n$Traductions$Chaine(p.nn))
				]),
			p.Bl + (' · ' + p.nn));
	});
var $author$project$Components$Shared$LibellesParLangue$View$nommer = F4(
	function (i18n, disposition, libelle, langue) {
		switch (disposition) {
			case 0:
				return A2(
					$author$project$I18n$Cles$saisieDeChampParNomDeLangue,
					i18n,
					{
						nn: A2($author$project$Referentiel$Langues$nom, i18n, langue.vx),
						Bl: libelle
					});
			case 3:
				return A2($author$project$Referentiel$Langues$nom, i18n, langue.vx);
			case 1:
				return A2(
					$author$project$I18n$Cles$saisieDeChampPrefixeEtLangue,
					i18n,
					{
						nn: A2($author$project$Referentiel$Langues$nom, i18n, langue.vx),
						Bl: libelle
					});
			default:
				return langue.he ? A2($author$project$Referentiel$Langues$nom, i18n, langue.vx) : A2(
					$author$project$I18n$Cles$saisieDeChampParLangueFacultative,
					i18n,
					{
						nn: A2($author$project$Referentiel$Langues$nom, i18n, langue.vx)
					});
		}
	});
var $author$project$Components$Shared$LibellesParLangue$View$rendre = F5(
	function (i18n, disposition, indication, attributs, libelles) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$class('noms'),
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('l-un-sous-l-autre', (!(!disposition)) && (disposition !== 1))
							])),
					attributs)),
			A2(
				$elm$core$List$map,
				function (langue) {
					return A2(
						$author$project$Components$Shared$Champ$View$texteAvecIndication,
						{
							go: libelles.go(langue.vx),
							Aq: A2($author$project$Components$Shared$LibellesParLangue$View$idDuChamp, libelles.pv, langue.vx),
							Bl: A4($author$project$Components$Shared$LibellesParLangue$View$nommer, i18n, disposition, libelles.Bl, langue),
							he: langue.he && (disposition !== 1)
						},
						{
							na: indication(langue.vx),
							hg: libelles.hg(langue.vx),
							fm: libelles.fm(langue.vx)
						});
				},
				libelles.Ba));
	});
var $author$project$Components$Shared$LibellesParLangue$View$avecIndications = function (i18n) {
	return A2($author$project$Components$Shared$LibellesParLangue$View$rendre, i18n, 0);
};
var $author$project$Components$Shared$LibellesParLangue$View$view = function (i18n) {
	return A2(
		$author$project$Components$Shared$LibellesParLangue$View$avecIndications,
		i18n,
		function (_v0) {
			return $elm$core$Maybe$Nothing;
		});
};
var $author$project$Components$Referentiel$Formes$View$drawerDesNoms = F2(
	function (i18n, model) {
		var saisie = model.hP;
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.DG);
		var ouvert = $author$project$Components$Shared$Drawer$Model$estOuvert(model.DG) && saisie.bO;
		var champs = function () {
			var _v2 = _Utils_Tuple2(ouvert, saisie.n9);
			if (_v2.a) {
				if (!_v2.b.$) {
					var _v3 = _v2.b;
					return _List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Champ$View$texte,
							{
								go: $elm$core$Maybe$Nothing,
								Aq: prefixe + '-en',
								Bl: $author$project$I18n$Cles$relationDrawerNomEn(i18n),
								he: false
							},
							{hg: $author$project$Components$Referentiel$Formes$Model$En, fm: saisie.yg})
						]);
				} else {
					return _List_fromArray(
						[
							A3(
							$author$project$Components$Shared$LibellesParLangue$View$view,
							i18n,
							_List_Nil,
							{
								go: function (code) {
									return (code === 'fr') ? A2($author$project$Components$Referentiel$Formes$View$erreurDeLibelle, i18n, saisie) : $elm$core$Maybe$Nothing;
								},
								Ba: $author$project$Referentiel$Langues$desLibelles,
								Bl: $author$project$I18n$Cles$formeDrawerNom(i18n),
								hg: F2(
									function (code, saisi) {
										return (code === 'fr') ? $author$project$Components$Referentiel$Formes$Model$Fr(saisi) : $author$project$Components$Referentiel$Formes$Model$En(saisi);
									}),
								pv: prefixe,
								fm: function (code) {
									return (code === 'fr') ? saisie.zX : saisie.yg;
								}
							})
						]);
				}
			} else {
				return _List_Nil;
			}
		}();
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$Formes$Update$DesNoms,
			{
				fs: {
					sR: !$elm$core$List$isEmpty(champs),
					Bl: $elm$core$List$isEmpty(champs) ? '' : $author$project$I18n$Cles$relationDrawerNomsValider(i18n),
					C$: $author$project$Components$Referentiel$Formes$Update$DesNoms($author$project$Components$Shared$Drawer$Update$Fermer)
				},
				fZ: A2(
					$elm$core$List$map,
					$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Referentiel$Formes$Update$Saisi),
					champs),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: function () {
					var _v0 = _Utils_Tuple2(ouvert, saisie.n9);
					if (_v0.a) {
						if (_v0.b.$ === 1) {
							return A2(
								$author$project$I18n$Cles$relationDrawerRenommerDe,
								i18n,
								{Dj: saisie.zX});
						} else {
							var _v1 = _v0.b;
							return $author$project$I18n$Cles$relationDrawerTraduire(i18n);
						}
					} else {
						return '';
					}
				}()
			},
			model.DG);
	});
var $author$project$Components$Referentiel$Formes$View$dialogues = F2(
	function (i18n, model) {
		return _List_fromArray(
			[
				A2($author$project$Components$Referentiel$Formes$View$drawer, i18n, model),
				A2($author$project$Components$Referentiel$Formes$View$drawerDesNoms, i18n, model)
			]);
	});
var $author$project$Components$Referentiel$Postes$Update$EnregistrementDemande = {$: 10};
var $author$project$Components$Referentiel$Postes$Update$Saisi = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Referentiel$Postes$Update$ArchivageDemande = function (a) {
	return {$: 11, a: a};
};
var $author$project$I18n$Cles$posteDrawerArchiver = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'poste.drawer.archiver', _List_Nil, 'Archiver');
};
var $author$project$I18n$Cles$posteDrawerArchiverAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'poste.drawer.archiver.aide', _List_Nil, 'Archivé, le poste n\'est plus proposé. Les personnes rattachées le gardent. Vous pouvez le restaurer.');
};
var $author$project$I18n$Cles$posteDrawerArchiverBouton = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'poste.drawer.archiver.bouton',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			'Archiver « ' + (p.Bl + ' »'));
	});
var $author$project$Components$Referentiel$Postes$View$archivage = F2(
	function (i18n, modification) {
		if (!modification.$) {
			var poste = modification.a;
			var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$archiverLePoste, poste.nQ);
			if (!_v1.$) {
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$section,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('archivage')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$h3,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$posteDrawerArchiver(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$posteDrawerArchiverAide(i18n))
									])),
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								3,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Referentiel$Postes$Update$ArchivageDemande(poste.Aq))
									]),
								A2(
									$author$project$I18n$Cles$posteDrawerArchiverBouton,
									i18n,
									{Bl: poste.R.zX}))
							]))
					]);
			} else {
				return _List_Nil;
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Referentiel$Postes$Model$estEnvoi = function (model) {
	return $author$project$API$Envoi$enCours(model.l2);
};
var $author$project$Components$Referentiel$Postes$Model$Fr = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$Postes$View$boutonDuNom = function (libelle) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$button,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
				$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
				$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Postes$Model$idDuNom),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'dialog'),
				$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Postes$Model$OuvrirNom)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(libelle)
			]));
};
var $author$project$I18n$Cles$posteLibelleDoublon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'poste.libelle.doublon', _List_Nil, 'Un poste porte déjà ce nom');
};
var $author$project$Components$Referentiel$Postes$View$erreurDeLibelle = F2(
	function (i18n, saisie) {
		return (saisie.b5 && $elm$core$String$isEmpty(
			$elm$core$String$trim(saisie.zX))) ? $elm$core$Maybe$Just(
			$author$project$I18n$Cles$relationLibelleObligatoire(i18n)) : (_Utils_eq(
			saisie.pZ,
			$elm$core$Maybe$Just($author$project$Components$Referentiel$Postes$Model$Doublon)) ? $elm$core$Maybe$Just(
			$author$project$I18n$Cles$posteLibelleDoublon(i18n)) : $elm$core$Maybe$Nothing);
	});
var $author$project$I18n$Cles$posteDrawerNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'poste.drawer.nom', _List_Nil, 'Nom');
};
var $author$project$Components$Referentiel$Postes$View$nom = F3(
	function (i18n, prefixe, saisie) {
		var anglais = $elm$core$String$isEmpty(
			$elm$core$String$trim(saisie.yg)) ? $author$project$I18n$Cles$relationDrawerAnglaisARenseigner(i18n) : A2(
			$author$project$I18n$Cles$relationDrawerAnglais,
			i18n,
			{
				Dj: $elm$core$String$trim(saisie.yg)
			});
		var _v0 = saisie.n9;
		if (!_v0.$) {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$section,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('noms')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Champ$View$texte,
							{
								go: A2($author$project$Components$Referentiel$Postes$View$erreurDeLibelle, i18n, saisie),
								Aq: prefixe + '-fr',
								Bl: $author$project$I18n$Cles$posteDrawerNom(i18n),
								he: true
							},
							{hg: $author$project$Components$Referentiel$Postes$Model$Fr, fm: saisie.zX}),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('anglais')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$strong,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(anglais)
												]))
										])),
									$author$project$Components$Referentiel$Postes$View$boutonDuNom(
									$author$project$I18n$Cles$relationDrawerTraduire(i18n))
								]))
						]))
				]);
		} else {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$section,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('noms')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$posteDrawerNom(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$strong,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(saisie.zX)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$elm$core$String$isEmpty(
														$elm$core$String$trim(saisie.yg)) ? $author$project$I18n$Cles$relationDrawerAnglaisVide(i18n) : A2(
														$author$project$I18n$Cles$relationDrawerAnglais,
														i18n,
														{
															Dj: $elm$core$String$trim(saisie.yg)
														}))
												]))
										])),
									$author$project$Components$Referentiel$Postes$View$boutonDuNom(
									$author$project$I18n$Cles$relationDrawerRenommer(i18n))
								]))
						]))
				]);
		}
	});
var $author$project$I18n$Cles$posteDrawerCreer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'poste.drawer.creer', _List_Nil, 'Créer le poste');
};
var $author$project$I18n$Cles$posteDrawerKickerCreation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'poste.drawer.kicker-creation', _List_Nil, 'Nouveau poste');
};
var $author$project$I18n$Cles$posteDrawerKickerPoste = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'poste.drawer.kicker-poste', _List_Nil, 'Poste');
};
var $author$project$I18n$Cles$posteDrawerTitreCreation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'poste.drawer.titre-creation', _List_Nil, 'Ajouter un poste');
};
var $author$project$Components$Referentiel$Postes$View$refusEnMessage = function (refus) {
	if ((!refus.$) && (refus.a.$ === 1)) {
		var dit = refus.a.a;
		return _List_fromArray(
			[
				{Jx: dit, b9: $elm$core$Maybe$Nothing}
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$I18n$Cles$posteDrawerUtilisation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'poste.drawer.utilisation', _List_Nil, 'Utilisation');
};
var $author$project$I18n$Cles$posteDrawerUtilisationNombre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'poste.drawer.utilisation.nombre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' personne') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' personnes'));
	});
var $author$project$I18n$Cles$posteDrawerUtilisationSuite = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'poste.drawer.utilisation.suite',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ' a ce poste.' : ' ont ce poste.');
	});
var $author$project$Components$Referentiel$Postes$View$utilisation = F2(
	function (i18n, modification) {
		if (!modification.$) {
			var poste = modification.a;
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$section,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('utilisation')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$posteDrawerUtilisation(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$posteDrawerUtilisationNombre,
												i18n,
												{w: poste.GY}))
										])),
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$posteDrawerUtilisationSuite,
										i18n,
										{w: poste.GY}))
								]))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Referentiel$Postes$View$drawer = F2(
	function (i18n, model) {
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.kX);
		var modification = function () {
			var _v1 = model.hP.n9;
			if (_v1.$ === 1) {
				var poste = _v1.a;
				return $elm$core$Maybe$Just(poste);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$Postes$Update$DuDrawer,
			{
				fs: {
					sR: !$author$project$Components$Referentiel$Postes$Model$estEnvoi(model),
					Bl: _Utils_eq(modification, $elm$core$Maybe$Nothing) ? $author$project$I18n$Cles$posteDrawerCreer(i18n) : $author$project$I18n$Cles$relationDrawerEnregistrer(i18n),
					C$: $author$project$Components$Referentiel$Postes$Update$EnregistrementDemande
				},
				fZ: _Utils_ap(
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Referentiel$Postes$Update$Saisi),
						_Utils_ap(
							A3($author$project$Components$Referentiel$Postes$View$nom, i18n, prefixe, model.hP),
							A2($author$project$Components$Referentiel$Postes$View$utilisation, i18n, modification))),
					_Utils_ap(
						A2($author$project$Components$Referentiel$Postes$View$archivage, i18n, modification),
						_List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Messages$View$view,
								i18n,
								$author$project$Components$Referentiel$Postes$View$refusEnMessage(model.hP.pZ))
							]))),
				A6: $elm$core$Maybe$Just(
					_Utils_eq(modification, $elm$core$Maybe$Nothing) ? $author$project$I18n$Cles$posteDrawerKickerCreation(i18n) : $author$project$I18n$Cles$posteDrawerKickerPoste(i18n)),
				Bc: false,
				h6: function () {
					if (!modification.$) {
						var poste = modification.a;
						return poste.R.zX;
					} else {
						return $author$project$I18n$Cles$posteDrawerTitreCreation(i18n);
					}
				}()
			},
			model.kX);
	});
var $author$project$Components$Referentiel$Postes$Model$En = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Postes$View$drawerDesNoms = F2(
	function (i18n, model) {
		var saisie = model.hP;
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.DG);
		var ouvert = $author$project$Components$Shared$Drawer$Model$estOuvert(model.DG) && saisie.bO;
		var champs = function () {
			var _v2 = _Utils_Tuple2(ouvert, saisie.n9);
			if (_v2.a) {
				if (!_v2.b.$) {
					var _v3 = _v2.b;
					return _List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Champ$View$texte,
							{
								go: $elm$core$Maybe$Nothing,
								Aq: prefixe + '-en',
								Bl: $author$project$I18n$Cles$relationDrawerNomEn(i18n),
								he: false
							},
							{hg: $author$project$Components$Referentiel$Postes$Model$En, fm: saisie.yg})
						]);
				} else {
					return _List_fromArray(
						[
							A3(
							$author$project$Components$Shared$LibellesParLangue$View$view,
							i18n,
							_List_Nil,
							{
								go: function (code) {
									return (code === 'fr') ? A2($author$project$Components$Referentiel$Postes$View$erreurDeLibelle, i18n, saisie) : $elm$core$Maybe$Nothing;
								},
								Ba: $author$project$Referentiel$Langues$desLibelles,
								Bl: $author$project$I18n$Cles$posteDrawerNom(i18n),
								hg: F2(
									function (code, saisi) {
										return (code === 'fr') ? $author$project$Components$Referentiel$Postes$Model$Fr(saisi) : $author$project$Components$Referentiel$Postes$Model$En(saisi);
									}),
								pv: prefixe,
								fm: function (code) {
									return (code === 'fr') ? saisie.zX : saisie.yg;
								}
							})
						]);
				}
			} else {
				return _List_Nil;
			}
		}();
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$Postes$Update$DesNoms,
			{
				fs: {
					sR: !$elm$core$List$isEmpty(champs),
					Bl: $elm$core$List$isEmpty(champs) ? '' : $author$project$I18n$Cles$relationDrawerNomsValider(i18n),
					C$: $author$project$Components$Referentiel$Postes$Update$DesNoms($author$project$Components$Shared$Drawer$Update$Fermer)
				},
				fZ: A2(
					$elm$core$List$map,
					$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Referentiel$Postes$Update$Saisi),
					champs),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: function () {
					var _v0 = _Utils_Tuple2(ouvert, saisie.n9);
					if (_v0.a) {
						if (_v0.b.$ === 1) {
							return A2(
								$author$project$I18n$Cles$relationDrawerRenommerDe,
								i18n,
								{Dj: saisie.zX});
						} else {
							var _v1 = _v0.b;
							return $author$project$I18n$Cles$relationDrawerTraduire(i18n);
						}
					} else {
						return '';
					}
				}()
			},
			model.DG);
	});
var $author$project$Components$Referentiel$Postes$View$dialogues = F2(
	function (i18n, model) {
		return _List_fromArray(
			[
				A2($author$project$Components$Referentiel$Postes$View$drawer, i18n, model),
				A2($author$project$Components$Referentiel$Postes$View$drawerDesNoms, i18n, model)
			]);
	});
var $author$project$I18n$Cles$conservationEcheancesFil = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.echeances.fil', _List_Nil, 'Conservation');
};
var $author$project$I18n$Cles$conservationEcheancesNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.echeances.note', _List_Nil, 'Une ligne par fiche, et une ligne par information à durée propre. Chacune se prolonge séparément. Une fiche que vous ne pouvez pas ouvrir apparaît sans son nom.');
};
var $author$project$I18n$Cles$conservationEcheancesResume = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'conservation.echeances.resume',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w)),
					_Utils_Tuple2(
					'heure',
					$author$project$I18n$Traductions$Chaine(p.Ah)),
					_Utils_Tuple2(
					'ville',
					$author$project$I18n$Traductions$Chaine(p.KP))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' échéance · traitement automatique chaque nuit à ' + (p.Ah + (' (heure de ' + (p.KP + '). À l\'échéance, les informations sont effacées.'))))) : (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' échéances · traitement automatique chaque nuit à ' + (p.Ah + (' (heure de ' + (p.KP + '). À l\'échéance, les informations sont effacées.'))))));
	});
var $author$project$I18n$Cles$conservationEcheancesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.echeances.titre', _List_Nil, 'Échéances des 30 prochains jours');
};
var $author$project$Components$Parametrage$Conservation$Update$EcheanceSaisie = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Parametrage$Conservation$Update$PrecisionSaisie = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Parametrage$Conservation$Update$ProlongationDemandee = {$: 21};
var $author$project$I18n$Cles$conservationProlongerAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.prolonger.action', _List_Nil, 'Prolonger');
};
var $author$project$I18n$Cles$conservationProlongerActuelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.prolonger.actuelle', _List_Nil, 'Échéance actuelle : ');
};
var $author$project$I18n$Cles$conservationProlongerKicker = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'conservation.prolonger.kicker',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fiche',
					$author$project$I18n$Traductions$Chaine(p.zo)),
					_Utils_Tuple2(
					'information',
					$author$project$I18n$Traductions$Chaine(p.AL))
				]),
			p.zo + (' · ' + p.AL));
	});
var $author$project$I18n$Cles$conservationProlongerMotif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.prolonger.motif', _List_Nil, 'Motif');
};
var $author$project$I18n$Cles$conservationProlongerNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.prolonger.note', _List_Nil, 'La prolongation est tracée. Elle ne peut pas être raccourcie ensuite.');
};
var $author$project$I18n$Cles$conservationProlongerNouvelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.prolonger.nouvelle', _List_Nil, 'Nouvelle échéance');
};
var $author$project$I18n$Cles$conservationProlongerPorteeClasse = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'conservation.prolonger.portee-classe',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'information',
					$author$project$I18n$Traductions$Chaine(p.AL))
				]),
			'La prolongation ne porte que sur ' + (p.AL + ' ; le reste de la fiche garde sa propre échéance.'));
	});
var $author$project$I18n$Cles$conservationProlongerPorteeFiche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.prolonger.portee-fiche', _List_Nil, 'La prolongation porte sur toute la fiche.');
};
var $author$project$I18n$Cles$conservationProlongerPrecision = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.prolonger.precision', _List_Nil, 'Précision (obligatoire si « Autre ») — 500 caractères max');
};
var $author$project$I18n$Cles$conservationProlongerPrecisionAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.prolonger.precision.aide', _List_Nil, 'N\'y écrivez ni le nom ni les coordonnées de la personne.');
};
var $author$project$I18n$Cles$conservationProlongerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.prolonger.titre', _List_Nil, 'Prolonger la conservation');
};
var $author$project$I18n$Cles$conservationTouteLaFiche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.toute-la-fiche', _List_Nil, 'Toute la fiche');
};
var $author$project$Components$Shared$Champ$View$date = F2(
	function (champ, saisie) {
		return A2(
			$author$project$Components$Shared$Champ$View$formItem,
			champ,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('date'),
						A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Attributes$value(saisie.fm),
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_css$Html$Styled$Events$onInput(saisie.hg),
								$author$project$Components$Shared$Champ$View$controle(champ)))),
					_List_Nil)
				]));
	});
var $author$project$Texte$Jour$enFrancais = F2(
	function (i18n, jour) {
		return A2(
			$author$project$I18n$Cles$texte,
			i18n,
			$author$project$Texte$Jour$enClair(jour));
	});
var $author$project$I18n$Cles$conservationProlongerRefusAcces = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.prolonger.refus.acces', _List_Nil, 'Vous n\'avez pas le droit de prolonger cette conservation.');
};
var $author$project$I18n$Cles$conservationProlongerRefusAutre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.prolonger.refus.autre', _List_Nil, 'La prolongation a échoué. Rien n\'a été modifié.');
};
var $author$project$I18n$Cles$conservationProlongerRefusFicheEffacee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.prolonger.refus.fiche-effacee', _List_Nil, 'Cette fiche a été effacée : sa conservation ne peut plus être prolongée.');
};
var $author$project$I18n$Cles$conservationProlongerRejeu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.prolonger.rejeu', _List_Nil, 'Cette prolongation avait déjà été appliquée. Les échéances affichées sont celles du serveur.');
};
var $author$project$Components$Parametrage$Conservation$View$erreurDeProlongation = F2(
	function (i18n, model) {
		var _v0 = model.pZ;
		if (!_v0.$) {
			switch (_v0.a.$) {
				case 2:
					var _v1 = _v0.a;
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$conservationProlongerRefusAcces(i18n))
							]));
				case 3:
					var _v2 = _v0.a;
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$conservationProlongerRefusFicheEffacee(i18n))
							]));
				default:
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$conservationProlongerRefusAutre(i18n))
							]));
			}
		} else {
			return model.qh ? A2(
				$author$project$Components$Shared$Note$View$view,
				0,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$conservationProlongerRejeu(i18n))
					])) : $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$Conservation$Update$MotifChoisi = function (a) {
	return {$: 19, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Attributes$checked = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('checked');
var $rtfeldman$elm_css$Html$Styled$label = $rtfeldman$elm_css$Html$Styled$node('label');
var $author$project$I18n$Cles$conservationMotifAutre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.motif.autre', _List_Nil, 'Autre (préciser)');
};
var $author$project$I18n$Cles$conservationMotifContentieuxEnCours = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.motif.contentieux-en-cours', _List_Nil, 'Contentieux en cours');
};
var $author$project$I18n$Cles$conservationMotifNouvelleDemande = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.motif.nouvelle-demande', _List_Nil, 'Nouvelle demande de la personne');
};
var $author$project$I18n$Cles$conservationMotifObligationLegale = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.motif.obligation-legale', _List_Nil, 'Obligation légale');
};
var $author$project$Components$Parametrage$Conservation$View$libelleDuMotif = F2(
	function (i18n, choisi) {
		switch (choisi) {
			case 0:
				return $author$project$I18n$Cles$conservationMotifContentieuxEnCours(i18n);
			case 1:
				return $author$project$I18n$Cles$conservationMotifNouvelleDemande(i18n);
			case 2:
				return $author$project$I18n$Cles$conservationMotifObligationLegale(i18n);
			default:
				return $author$project$I18n$Cles$conservationMotifAutre(i18n);
		}
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$name = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('name');
var $author$project$Components$Parametrage$Conservation$View$motif = F3(
	function (i18n, model, choisi) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('motif')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
							$rtfeldman$elm_css$Html$Styled$Attributes$name('conservation-motif'),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(
							A2($author$project$Components$Parametrage$Conservation$View$libelleDuMotif, i18n, choisi)),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(
							_Utils_eq(
								model.cX,
								$elm$core$Maybe$Just(choisi))),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Parametrage$Conservation$Update$MotifChoisi(choisi))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Parametrage$Conservation$View$libelleDuMotif, i18n, choisi))
						]))
				]));
	});
var $author$project$Components$Shared$Champ$View$texteDecritPar = F2(
	function (champ, saisie) {
		return A2(
			$author$project$Components$Shared$Champ$View$formItem,
			champ,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
						A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Attributes$value(saisie.fm),
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_css$Html$Styled$Events$onInput(saisie.hg),
								A2(
									$elm$core$List$cons,
									$rtfeldman$elm_css$Html$Styled$Attributes$id(champ.Aq),
									A2(
										$elm$core$List$cons,
										A2(
											$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
											'aria-labelledby',
											$author$project$Components$Shared$Champ$View$idLibelle(champ)),
										A2(
											$author$project$Components$Shared$Champ$View$etatsDecrits,
											_List_fromArray(
												[saisie.wV]),
											champ)))))),
					_List_Nil)
				]));
	});
var $author$project$Components$Parametrage$Conservation$View$contenuDeProlongation = F2(
	function (i18n, model) {
		var precision = $author$project$Components$Parametrage$Conservation$Model$etatDeLaPrecision(model);
		var information = function (ligne) {
			return A2(
				$elm$core$Maybe$withDefault,
				$author$project$I18n$Cles$conservationTouteLaFiche(i18n),
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.uN;
					},
					ligne.jT));
		};
		return {
			fs: {
				sR: (!_Utils_eq(
					$author$project$Components$Parametrage$Conservation$Model$prolongationPrete(model),
					$elm$core$Maybe$Nothing)) && (!$author$project$API$Envoi$enCours(model.l2)),
				Bl: $author$project$I18n$Cles$conservationProlongerAction(i18n),
				C$: $author$project$Components$Parametrage$Conservation$Update$ProlongationDemandee
			},
			fZ: function () {
				var _v0 = model.fq;
				if (!_v0.$) {
					var ligne = _v0.a;
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('echeance-actuelle')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$conservationProlongerActuelle(i18n)),
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$Texte$Jour$enFrancais, i18n, ligne.xY))
										])),
									$rtfeldman$elm_css$Html$Styled$text('. '),
									$rtfeldman$elm_css$Html$Styled$text(
									function () {
										var _v1 = ligne.jT;
										if (!_v1.$) {
											var classe = _v1.a;
											return A2(
												$author$project$I18n$Cles$conservationProlongerPorteeClasse,
												i18n,
												{AL: classe.uN});
										} else {
											return $author$project$I18n$Cles$conservationProlongerPorteeFiche(i18n);
										}
									}())
								])),
							A2(
							$author$project$Components$Shared$Champ$View$date,
							{
								go: $elm$core$Maybe$Nothing,
								Aq: 'conservation-jusqu-a',
								Bl: $author$project$I18n$Cles$conservationProlongerNouvelle(i18n),
								he: true
							},
							{hg: $author$project$Components$Parametrage$Conservation$Update$EcheanceSaisie, fm: model.A3}),
							A2(
							$rtfeldman$elm_css$Html$Styled$fieldset,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('mandatory'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('motifs'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'radiogroup')
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$rtfeldman$elm_css$Html$Styled$legend,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$conservationProlongerMotif(i18n))
												]))
										])),
								A2(
									$elm$core$List$map,
									A2($author$project$Components$Parametrage$Conservation$View$motif, i18n, model),
									_List_fromArray(
										[0, 1, 2, 3])))),
							A2(
							$author$project$Components$Shared$Champ$View$texteDecritPar,
							{
								go: $elm$core$Maybe$Nothing,
								Aq: 'conservation-precision',
								Bl: $author$project$I18n$Cles$conservationProlongerPrecision(i18n),
								he: precision.he
							},
							{wV: 'conservation-precision-aide', hg: $author$project$Components$Parametrage$Conservation$Update$PrecisionSaisie, fm: model.Gd}),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aide-precision'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id('conservation-precision-aide')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$conservationProlongerPrecisionAide(i18n))
								])),
							A2($author$project$Components$Parametrage$Conservation$View$erreurDeProlongation, i18n, model),
							A2(
							$author$project$Components$Shared$Note$View$view,
							0,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$conservationProlongerNote(i18n))
								]))
						]);
				} else {
					return _List_Nil;
				}
			}(),
			A6: A2(
				$elm$core$Maybe$map,
				function (ligne) {
					return A2(
						$author$project$I18n$Cles$conservationProlongerKicker,
						i18n,
						{
							zo: A2($elm$core$Maybe$withDefault, '', ligne.Dj),
							AL: information(ligne)
						});
				},
				model.fq),
			Bc: false,
			h6: $author$project$I18n$Cles$conservationProlongerTitre(i18n)
		};
	});
var $author$project$Components$Parametrage$Conservation$View$drawerDeProlongation = F2(
	function (i18n, model) {
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Parametrage$Conservation$Update$DuDrawerDeProlongation,
			A2($author$project$Components$Parametrage$Conservation$View$contenuDeProlongation, i18n, model),
			model.ld);
	});
var $author$project$Components$Parametrage$Conservation$Update$FiltreChoisi = function (a) {
	return {$: 16, a: a};
};
var $author$project$I18n$Cles$conservationEcheancesTousLesTypes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.echeances.tous-les-types', _List_Nil, 'Tous les types');
};
var $author$project$I18n$Cles$conservationEcheancesType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.echeances.type', _List_Nil, 'Type');
};
var $rtfeldman$elm_css$Html$Styled$option = $rtfeldman$elm_css$Html$Styled$node('option');
var $rtfeldman$elm_css$Html$Styled$select = $rtfeldman$elm_css$Html$Styled$node('select');
var $rtfeldman$elm_css$Html$Styled$Attributes$selected = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('selected');
var $author$project$Components$Shared$Champ$View$liste = F2(
	function (champ, saisie) {
		return A2(
			$author$project$Components$Shared$Champ$View$formItem,
			champ,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$select,
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Events$onInput(saisie.hg),
						$author$project$Components$Shared$Champ$View$controle(champ)),
					A2(
						$elm$core$List$map,
						function (fournie) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$option,
								_List_fromArray(
									[
										A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'value', fournie.fm),
										$rtfeldman$elm_css$Html$Styled$Attributes$selected(
										_Utils_eq(fournie.fm, saisie.fm))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(fournie.Bl)
									]));
						},
						saisie.o_))
				]));
	});
var $author$project$Components$Parametrage$Conservation$View$filtre = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('filtre-par-type')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: 'conservation-filtre',
						Bl: $author$project$I18n$Cles$conservationEcheancesType(i18n),
						he: false
					},
					{
						hg: $author$project$Components$Parametrage$Conservation$Update$FiltreChoisi,
						o_: A2(
							$elm$core$List$cons,
							{
								Bl: $author$project$I18n$Cles$conservationEcheancesTousLesTypes(i18n),
								fm: ''
							},
							A2(
								$elm$core$List$map,
								function (regle) {
									return {Bl: regle.Bl, fm: regle.r8};
								},
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.ib;
										},
										model.hJ)))),
						fm: A2($elm$core$Maybe$withDefault, '', model.zH)
					})
				]));
	});
var $author$project$I18n$Cles$conservationEcheancesColonneAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.echeances.colonne.action', _List_Nil, 'Action');
};
var $author$project$I18n$Cles$conservationEcheancesColonneEcheance = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.echeances.colonne.echeance', _List_Nil, 'Échéance');
};
var $author$project$I18n$Cles$conservationEcheancesColonneEtat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.echeances.colonne.etat', _List_Nil, 'État');
};
var $author$project$I18n$Cles$conservationEcheancesColonneFiche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.echeances.colonne.fiche', _List_Nil, 'Fiche');
};
var $author$project$I18n$Cles$conservationEcheancesColonneType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.echeances.colonne.type', _List_Nil, 'Type');
};
var $author$project$I18n$Cles$conservationEcheancesIllisible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.echeances.illisible', _List_Nil, 'Les échéances n\'ont pas pu être lues.');
};
var $author$project$I18n$Cles$conservationEcheancesIndisponible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.echeances.indisponible', _List_Nil, 'Les échéances ne sont pas disponibles pour votre compte.');
};
var $author$project$I18n$Cles$conservationEcheancesVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.echeances.vide', _List_Nil, 'Aucune échéance dans les 30 prochains jours.');
};
var $author$project$Components$Parametrage$Conservation$Model$filtrees = function (model) {
	var _v0 = _Utils_Tuple2(model.x0, model.zH);
	if (!_v0.a.$) {
		if (!_v0.b.$) {
			var echeances = _v0.a.a;
			var type_ = _v0.b.a;
			return A2(
				$elm$core$List$filter,
				function (ligne) {
					return A2($elm$core$List$member, type_, ligne.ib);
				},
				echeances.x0);
		} else {
			var echeances = _v0.a.a;
			var _v1 = _v0.b;
			return echeances.x0;
		}
	} else {
		var _v2 = _v0.a;
		return _List_Nil;
	}
};
var $author$project$Components$Parametrage$Conservation$Update$ProlongationOuverte = function (a) {
	return {$: 17, a: a};
};
var $author$project$I18n$Cles$conservationEcheancesNonAccessible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.echeances.non-accessible', _List_Nil, 'Fiche non accessible');
};
var $author$project$I18n$Cles$conservationEcheancesProlonger = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.echeances.prolonger', _List_Nil, 'Prolonger');
};
var $author$project$I18n$Cles$conservationEcheancesProlongerFiche = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'conservation.echeances.prolonger.fiche',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fiche',
					$author$project$I18n$Traductions$Chaine(p.zo))
				]),
			'Prolonger la conservation de ' + p.zo);
	});
var $author$project$Components$Shared$Tag$View$Ambre = 1;
var $author$project$Components$Shared$Tag$View$Gris = 3;
var $author$project$Components$Shared$Tag$View$Rouge = 2;
var $author$project$Components$Shared$Tag$View$Vert = 0;
var $author$project$I18n$Cles$conservationEtatDue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.etat.due', _List_Nil, 'Échue');
};
var $author$project$I18n$Cles$conservationEtatEnAlerte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.etat.en-alerte', _List_Nil, 'En alerte');
};
var $author$project$I18n$Cles$conservationEtatPrevue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.etat.prevue', _List_Nil, 'Prévue');
};
var $author$project$I18n$Cles$conservationEtatProlongee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'conservation.etat.prolongee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'jour',
					$author$project$I18n$Traductions$Chaine(p.A_))
				]),
			'Prolongée jusqu\'au ' + p.A_);
	});
var $author$project$Components$Shared$Tag$View$classe = function (couleur) {
	switch (couleur) {
		case 0:
			return 'vert';
		case 1:
			return 'ambre';
		case 2:
			return 'rouge';
		case 3:
			return 'gris';
		case 4:
			return 'bleu';
		default:
			return 'accent';
	}
};
var $author$project$Components$Shared$Tag$View$view = F2(
	function (couleur, libelle) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('tag'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					$author$project$Components$Shared$Tag$View$classe(couleur))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(libelle)
				]));
	});
var $author$project$Components$Parametrage$Conservation$View$etat = F2(
	function (i18n, lu) {
		switch (lu.$) {
			case 0:
				return A2(
					$author$project$Components$Shared$Tag$View$view,
					3,
					$author$project$I18n$Cles$conservationEtatPrevue(i18n));
			case 1:
				return A2(
					$author$project$Components$Shared$Tag$View$view,
					1,
					$author$project$I18n$Cles$conservationEtatEnAlerte(i18n));
			case 2:
				return A2(
					$author$project$Components$Shared$Tag$View$view,
					2,
					$author$project$I18n$Cles$conservationEtatDue(i18n));
			default:
				var jour = lu.a;
				return A2(
					$author$project$Components$Shared$Tag$View$view,
					0,
					A2(
						$author$project$I18n$Cles$conservationEtatProlongee,
						i18n,
						{
							A_: A2($author$project$Texte$Jour$enFrancais, i18n, jour)
						}));
		}
	});
var $author$project$Components$Parametrage$Conservation$Model$libelleDuType = F2(
	function (model, uid) {
		return A2(
			$elm$core$Maybe$withDefault,
			uid,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				A2($author$project$Components$Parametrage$Conservation$Model$regleDuType, model, uid)));
	});
var $rtfeldman$elm_css$Html$Styled$td = $rtfeldman$elm_css$Html$Styled$node('td');
var $rtfeldman$elm_css$Html$Styled$tr = $rtfeldman$elm_css$Html$Styled$node('tr');
var $author$project$Components$Parametrage$Conservation$View$ligneDEcheance = F3(
	function (i18n, model, ligne) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('inaccessible', !ligne.sM)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('fiche')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$elm$core$Maybe$withDefault,
												$author$project$I18n$Cles$conservationEcheancesNonAccessible(i18n),
												ligne.Dj))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('information')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$elm$core$Maybe$withDefault,
												$author$project$I18n$Cles$conservationTouteLaFiche(i18n),
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.uN;
													},
													ligne.jT)))
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$elm$core$String$join,
								', ',
								A2(
									$elm$core$List$map,
									$author$project$Components$Parametrage$Conservation$Model$libelleDuType(model),
									ligne.ib)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Texte$Jour$enFrancais, i18n, ligne.xY))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Components$Parametrage$Conservation$View$etat, i18n, ligne.gt)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = $author$project$Components$Parametrage$Conservation$Model$lienDeLaLigne(ligne);
							if (!_v0.$) {
								return A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Parametrage$Conservation$Update$ProlongationOuverte(ligne)),
											A2(
											$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
											'aria-label',
											A2(
												$author$project$I18n$Cles$conservationEcheancesProlongerFiche,
												i18n,
												{
													zo: A2($elm$core$Maybe$withDefault, '', ligne.Dj)
												})),
											$rtfeldman$elm_css$Html$Styled$Attributes$title(
											A2(
												$author$project$I18n$Cles$conservationEcheancesProlongerFiche,
												i18n,
												{
													zo: A2($elm$core$Maybe$withDefault, '', ligne.Dj)
												}))
										]),
									$author$project$I18n$Cles$conservationEcheancesProlonger(i18n));
							} else {
								return $rtfeldman$elm_css$Html$Styled$text('');
							}
						}()
						]))
				]));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$scope = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('scope');
var $rtfeldman$elm_css$Html$Styled$table = $rtfeldman$elm_css$Html$Styled$node('table');
var $rtfeldman$elm_css$Html$Styled$tbody = $rtfeldman$elm_css$Html$Styled$node('tbody');
var $rtfeldman$elm_css$Html$Styled$th = $rtfeldman$elm_css$Html$Styled$node('th');
var $rtfeldman$elm_css$Html$Styled$thead = $rtfeldman$elm_css$Html$Styled$node('thead');
var $author$project$Components$Parametrage$Conservation$View$listeDesEcheances = F2(
	function (i18n, model) {
		var _v0 = model.x0;
		if (_v0.$ === 1) {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							model.gd ? $author$project$I18n$Cles$conservationEcheancesIllisible(i18n) : $author$project$I18n$Cles$conservationEcheancesIndisponible(i18n))
						]))
				]);
		} else {
			var _v1 = $author$project$Components$Parametrage$Conservation$Model$filtrees(model);
			if (!_v1.b) {
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aucun')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$conservationEcheancesVide(i18n))
							]))
					]);
			} else {
				var lignes = _v1;
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$table,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('echeances')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$conservationEcheancesColonneFiche(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$conservationEcheancesColonneType(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$conservationEcheancesColonneEcheance(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$conservationEcheancesColonneEtat(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col'),
																A2(
																$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
																'aria-label',
																$author$project$I18n$Cles$conservationEcheancesColonneAction(i18n))
															]),
														_List_Nil)
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$tbody,
										_List_Nil,
										A2(
											$elm$core$List$map,
											A2($author$project$Components$Parametrage$Conservation$View$ligneDEcheance, i18n, model),
											lignes))
									]))
							]))
					]);
			}
		}
	});
var $author$project$I18n$Cles$produitsParametrageTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parametrage.titre', _List_Nil, 'Paramétrage');
};
var $author$project$Components$Parametrage$Conservation$Model$ville = function (fuseau) {
	return A3(
		$elm$core$String$replace,
		'_',
		' ',
		A2(
			$elm$core$Maybe$withDefault,
			fuseau,
			$elm$core$List$head(
				$elm$core$List$reverse(
					A2($elm$core$String$split, '/', fuseau)))));
};
var $author$project$Components$Parametrage$Conservation$View$echeances = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'parametrage-conservation',
			{
				ut: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						A2(
							$elm$core$List$cons,
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							A2(
								$elm$core$List$cons,
								A2($author$project$Components$Parametrage$Conservation$View$filtre, i18n, model),
								_Utils_ap(
									A2($author$project$Components$Parametrage$Conservation$View$listeDesEcheances, i18n, model),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$conservationEcheancesNote(i18n))
												]))
										])))))
					]),
				xy: _List_fromArray(
					[
						A2($author$project$Components$Parametrage$Conservation$View$drawerDeProlongation, i18n, model)
					]),
				zM: _List_Nil,
				AK: $author$project$Components$Parametrage$Conservation$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										function () {
											var _v0 = model.x0;
											if (!_v0.$) {
												var lues = _v0.a;
												return A2(
													$author$project$I18n$Cles$conservationEcheancesResume,
													i18n,
													{
														Ah: lues.Ai,
														w: lues.w,
														KP: $author$project$Components$Parametrage$Conservation$Model$ville(lues.z_)
													});
											} else {
												return '';
											}
										}())
									]))
							]),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adresseTypesDePartiesPrenantes,
								Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
							},
								{
								aa: $author$project$Routes$Route$adresseDesEcheancesDeConservation,
								Dj: $author$project$I18n$Cles$conservationEcheancesFil(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$conservationEcheancesTitre(i18n)
					})
			});
	});
var $author$project$Components$Shared$Parcours$Model$Texte = function (a) {
	return {$: 0, a: a};
};
var $author$project$I18n$Cles$conservationApercuChamp = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'conservation.apercu.champ',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN)),
					_Utils_Tuple2(
					'duree',
					$author$project$I18n$Traductions$Chaine(p.lG))
				]),
			p.uN + (' : effacées ' + (p.lG + ' après la clôture')));
	});
var $author$project$I18n$Cles$conservationApercuFiche = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'conservation.apercu.fiche',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'duree',
					$author$project$I18n$Traductions$Chaine(p.lG))
				]),
			'Fiche : effacée ' + (p.lG + ' après la clôture'));
	});
var $author$project$I18n$Cles$conservationApercuSansDuree = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.apercu.sans-duree', _List_Nil, 'Fiche : aucune durée fixée');
};
var $author$project$I18n$Cles$conservationApercuTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.apercu.titre', _List_Nil, 'Ce qui sera gardé');
};
var $author$project$I18n$Cles$conservationDureeAns = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'conservation.duree.ans',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' an') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' ans'));
	});
var $author$project$I18n$Cles$conservationDureeMois = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'conservation.duree.mois',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' mois') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' mois'));
	});
var $author$project$Components$Parametrage$Conservation$View$enDuree = F2(
	function (i18n, mois) {
		return ((mois > 0) && (!A2($elm$core$Basics$modBy, 12, mois))) ? A2(
			$author$project$I18n$Cles$conservationDureeAns,
			i18n,
			{d: (mois / 12) | 0}) : A2(
			$author$project$I18n$Cles$conservationDureeMois,
			i18n,
			{d: mois});
	});
var $author$project$I18n$Cles$conservationApercuEcheances = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'conservation.apercu.echeances',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiche arrive à échéance dans les 30 prochains jours') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiches arrivent à échéance dans les 30 prochains jours'));
	});
var $author$project$Components$Parametrage$Conservation$View$ligneDesEcheances = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.ns, model.x0);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var lues = _v0.b.a;
			return _List_fromArray(
				[
					{
					dX: false,
					eW: 0,
					Jx: A2(
						$author$project$I18n$Cles$conservationApercuEcheances,
						i18n,
						{w: lues.w})
				}
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Parametrage$Conservation$View$apercu = F2(
	function (i18n, model) {
		return {
			gV: function (lignes) {
				return _Utils_ap(
					lignes,
					A2($author$project$Components$Parametrage$Conservation$View$ligneDesEcheances, i18n, model));
			}(
				A2(
					$elm$core$List$concatMap,
					function (regle) {
						return A2(
							$elm$core$List$cons,
							{dX: true, eW: 0, Jx: regle.Bl},
							A2(
								$elm$core$List$cons,
								{
									dX: false,
									eW: 1,
									Jx: A2(
										$elm$core$Maybe$withDefault,
										$author$project$I18n$Cles$conservationApercuSansDuree(i18n),
										A2(
											$elm$core$Maybe$map,
											function (d) {
												return A2(
													$author$project$I18n$Cles$conservationApercuFiche,
													i18n,
													{
														lG: A2($author$project$Components$Parametrage$Conservation$View$enDuree, i18n, d.CQ)
													});
											},
											regle.lG))
								},
								A2(
									$elm$core$List$map,
									function (champ) {
										return {
											dX: false,
											eW: 1,
											Jx: A2(
												$author$project$I18n$Cles$conservationApercuChamp,
												i18n,
												{
													uN: champ.Bl,
													lG: A2($author$project$Components$Parametrage$Conservation$View$enDuree, i18n, champ.lG.CQ)
												})
										};
									},
									regle.dw)));
					},
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.ib;
							},
							model.hJ)))),
			h6: $elm$core$Maybe$Just(
				$author$project$I18n$Cles$conservationApercuTitre(i18n))
		};
	});
var $author$project$I18n$Cles$parcoursApercuSurtitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'parcours.apercu.surtitre', _List_Nil, 'Aperçu');
};
var $author$project$Components$Shared$Parcours$View$apercu = F3(
	function (i18n, nom, calcule) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id('aside'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'complementary'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', nom)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('surtitre')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$parcoursApercuSurtitre(i18n))
						])),
					A2(
					$elm$core$Maybe$withDefault,
					$rtfeldman$elm_css$Html$Styled$text(''),
					A2(
						$elm$core$Maybe$map,
						function (titre) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$h2,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(titre)
									]));
						},
						calcule.h6)),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu')
						]),
					A2(
						$elm$core$List$map,
						function (ligne) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class(
										'retrait-' + $elm$core$String$fromInt(
											A2($elm$core$Basics$min, ligne.eW, 4))),
										$rtfeldman$elm_css$Html$Styled$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('fort', ligne.dX)
											]))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(ligne.Jx)
									]));
						},
						calcule.gV))
				]));
	});
var $author$project$Components$Shared$Parcours$Model$numero = F2(
	function (etapes, etape) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$first,
					$elm$core$Basics$add(1)),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var autre = _v0.b;
							return _Utils_eq(autre, etape);
						},
						A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, etapes)))));
	});
var $author$project$Components$Parametrage$Conservation$View$avecLesEtapesPrecedentesFaites = function (parcours) {
	var rang = $author$project$Components$Shared$Parcours$Model$numero(parcours.yL);
	return _Utils_update(
		parcours,
		{
			qm: function (autre) {
				return parcours.qm(autre) || (_Utils_cmp(
					rang(autre),
					rang(5)) < 0);
			}
		});
};
var $author$project$I18n$Cles$conservationEtapeExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.etape.explication', _List_Nil, 'Pour chaque type de partie prenante, fixez combien de temps garder ses informations une fois la fiche close ou supprimée. À l\'échéance, elles sont effacées.');
};
var $author$project$I18n$Cles$conservationEtapeQuestion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.etape.question', _List_Nil, 'Combien de temps garde-t-on leurs données ?');
};
var $author$project$Components$Parametrage$Conservation$Update$AjoutDemande = {$: 10};
var $author$project$I18n$Cles$conservationAjouterChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.ajouter-champ', _List_Nil, 'Ajouter : Information à durée propre');
};
var $author$project$Components$Parametrage$Conservation$View$ajouterSousLesCartouches = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(
			$author$project$Components$Parametrage$Conservation$Model$lienDuTypeEnregistre(model),
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Components$Parametrage$Conservation$Model$regleDuType(model),
				$author$project$Components$Parametrage$Conservation$Model$typeEnCours(model)));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var regle = _v0.b.a;
			return $elm$core$List$isEmpty(
				A2(
					$author$project$Components$Parametrage$Conservation$Model$champsAAjouter,
					regle,
					$author$project$Components$Parametrage$Conservation$Model$reglageDuType(regle))) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
						$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$Conservation$Update$AjoutDemande)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$conservationAjouterChamp(i18n))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$conservationEtapeIllisible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.etape.illisible', _List_Nil, 'Les durées de conservation n\'ont pas pu être lues.');
};
var $author$project$I18n$Cles$conservationEtapeIndisponible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.etape.indisponible', _List_Nil, 'Les durées de conservation ne sont pas disponibles pour votre compte.');
};
var $author$project$I18n$Cles$conservationNoteAlerteFort = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.note.alerte.fort', _List_Nil, 'Alerte avant l\'échéance');
};
var $author$project$I18n$Cles$conservationNoteAlerteSuite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.note.alerte.suite', _List_Nil, ' : au délai choisi, un avertissement s\'affiche dans l\'application. Aucun e-mail n\'est envoyé.');
};
var $author$project$I18n$Cles$conservationNoteDepart = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.note.depart', _List_Nil, 'Le délai part de la clôture ou de la suppression de la fiche. Rouvrir ou restaurer la fiche l\'annule. Une fiche active n\'arrive jamais à échéance. Les données de facturation ne suivent pas ces règles : elles sont gardées le temps de l\'obligation légale.');
};
var $author$project$Components$Parametrage$Conservation$Update$TypeOuvert = function (a) {
	return {$: 8, a: a};
};
var $author$project$I18n$Cles$conservationColonneAlerte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.colonne.alerte', _List_Nil, 'Alerte');
};
var $author$project$I18n$Cles$conservationColonneDuree = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.colonne.duree', _List_Nil, 'Durée après la clôture');
};
var $author$project$I18n$Cles$conservationColonneInformation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.colonne.information', _List_Nil, 'Information');
};
var $author$project$I18n$Cles$conservationModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.modifier', _List_Nil, 'Modifier');
};
var $author$project$I18n$Cles$conservationModifierType = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'conservation.modifier.type',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Modifier la conservation de ' + p.Dj);
	});
var $author$project$I18n$Cles$conservationAlerteAvant = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'conservation.alerte-avant',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'jours',
					$author$project$I18n$Traductions$Entier(p.ni))
				]),
			((!p.ni) || (p.ni === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.ni) + ' jour avant') : (A2($author$project$I18n$Nombre$formater, 0, p.ni) + ' jours avant'));
	});
var $author$project$I18n$Cles$conservationSansDuree = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.sans-duree', _List_Nil, 'Aucune durée fixée');
};
var $author$project$Components$Parametrage$Conservation$View$ligneDeDuree = F3(
	function (i18n, information, duree) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$th,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$scope('row')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(information)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$I18n$Cles$conservationSansDuree(i18n),
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.CQ;
										},
										$author$project$Components$Parametrage$Conservation$View$enDuree(i18n)),
									duree)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('alerte')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									function (d) {
										return A2(
											$author$project$I18n$Cles$conservationAlerteAvant,
											i18n,
											{ni: d.iJ});
									},
									duree)))
						]))
				]));
	});
var $author$project$I18n$Cles$conservationReferenceCommeProspect = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.reference.comme-prospect', _List_Nil, 'comme un prospect');
};
var $author$project$Components$Parametrage$Vocabulaire$commeUnArchetype = F2(
	function (i18n, archetype) {
		if (archetype === 'Prospect') {
			return $elm$core$Maybe$Just(
				$author$project$I18n$Cles$conservationReferenceCommeProspect(i18n));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$I18n$Cles$conservationReferenceAvecDuree = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'conservation.reference.avec-duree',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'duree',
					$author$project$I18n$Traductions$Chaine(p.lG)),
					_Utils_Tuple2(
					'source',
					$author$project$I18n$Traductions$Chaine(p.IR))
				]),
			'Référence : ' + (p.lG + (' après la clôture (' + (p.IR + ').'))));
	});
var $author$project$I18n$Cles$conservationReferenceAvecDureeComme = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'conservation.reference.avec-duree-comme',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'duree',
					$author$project$I18n$Traductions$Chaine(p.lG)),
					_Utils_Tuple2(
					'comme',
					$author$project$I18n$Traductions$Chaine(p.vL)),
					_Utils_Tuple2(
					'source',
					$author$project$I18n$Traductions$Chaine(p.IR))
				]),
			'Référence : ' + (p.lG + (' après la clôture, ' + (p.vL + (' (' + (p.IR + ').'))))));
	});
var $author$project$I18n$Cles$conservationReferenceAvecDureeEtMention = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'conservation.reference.avec-duree-et-mention',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'duree',
					$author$project$I18n$Traductions$Chaine(p.lG)),
					_Utils_Tuple2(
					'source',
					$author$project$I18n$Traductions$Chaine(p.IR)),
					_Utils_Tuple2(
					'mention',
					$author$project$I18n$Traductions$Chaine(p.Cq))
				]),
			'Référence : ' + (p.lG + (' après la clôture (' + (p.IR + (') ; ' + (p.Cq + '.'))))));
	});
var $author$project$I18n$Cles$conservationReferenceSansDuree = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'conservation.reference.sans-duree',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'source',
					$author$project$I18n$Traductions$Chaine(p.IR))
				]),
			'Aucune durée de référence (' + (p.IR + ').'));
	});
var $author$project$I18n$Cles$conservationReferenceSansDureeEtMention = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'conservation.reference.sans-duree-et-mention',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'mention',
					$author$project$I18n$Traductions$Chaine(p.Cq)),
					_Utils_Tuple2(
					'source',
					$author$project$I18n$Traductions$Chaine(p.IR))
				]),
			'Aucune durée de référence : ' + (p.Cq + (' (' + (p.IR + ').'))));
	});
var $author$project$Components$Parametrage$Conservation$View$repere = F3(
	function (i18n, archetype, reference) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('repere')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					function () {
						var _v0 = _Utils_Tuple2(reference.CQ, reference.Cq);
						if (!_v0.a.$) {
							if (_v0.b.$ === 1) {
								var mois = _v0.a.a;
								var _v1 = _v0.b;
								var _v2 = A2($author$project$Components$Parametrage$Vocabulaire$commeUnArchetype, i18n, archetype);
								if (!_v2.$) {
									var comme = _v2.a;
									return A2(
										$author$project$I18n$Cles$conservationReferenceAvecDureeComme,
										i18n,
										{
											vL: comme,
											lG: A2($author$project$Components$Parametrage$Conservation$View$enDuree, i18n, mois),
											IR: reference.IR
										});
								} else {
									return A2(
										$author$project$I18n$Cles$conservationReferenceAvecDuree,
										i18n,
										{
											lG: A2($author$project$Components$Parametrage$Conservation$View$enDuree, i18n, mois),
											IR: reference.IR
										});
								}
							} else {
								var mois = _v0.a.a;
								var mention = _v0.b.a;
								return A2(
									$author$project$I18n$Cles$conservationReferenceAvecDureeEtMention,
									i18n,
									{
										lG: A2($author$project$Components$Parametrage$Conservation$View$enDuree, i18n, mois),
										Cq: mention,
										IR: reference.IR
									});
							}
						} else {
							if (_v0.b.$ === 1) {
								var _v3 = _v0.a;
								var _v4 = _v0.b;
								return A2(
									$author$project$I18n$Cles$conservationReferenceSansDuree,
									i18n,
									{IR: reference.IR});
							} else {
								var _v5 = _v0.a;
								var mention = _v0.b.a;
								return A2(
									$author$project$I18n$Cles$conservationReferenceSansDureeEtMention,
									i18n,
									{Cq: mention, IR: reference.IR});
							}
						}
					}())
				]));
	});
var $author$project$Components$Parametrage$Conservation$View$regleDuType = F3(
	function (i18n, model, regle) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('cartouche-regle-du-type'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'ouvert',
							_Utils_eq(
								model.ia,
								$elm$core$Maybe$Just(regle.r8))),
							_Utils_Tuple2(
							'en-cours',
							_Utils_eq(
								$author$project$Components$Parametrage$Conservation$Model$typeEnCours(model),
								$elm$core$Maybe$Just(regle.r8)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(regle.Bl)
								])),
							function () {
							var _v0 = $author$project$Components$Parametrage$Conservation$Model$lienDuTypeEnregistre(model);
							if (!_v0.$) {
								return A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Parametrage$Conservation$Update$TypeOuvert(regle.r8)),
											A2(
											$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
											'aria-label',
											A2(
												$author$project$I18n$Cles$conservationModifierType,
												i18n,
												{Dj: regle.Bl})),
											$rtfeldman$elm_css$Html$Styled$Attributes$title(
											A2(
												$author$project$I18n$Cles$conservationModifierType,
												i18n,
												{Dj: regle.Bl}))
										]),
									$author$project$I18n$Cles$conservationModifier(i18n));
							} else {
								return $rtfeldman$elm_css$Html$Styled$text('');
							}
						}()
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$table,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('durees')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$thead,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$tr,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$conservationColonneInformation(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$conservationColonneDuree(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$conservationColonneAlerte(i18n))
														]))
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$tbody,
									_List_Nil,
									A2(
										$elm$core$List$cons,
										A3(
											$author$project$Components$Parametrage$Conservation$View$ligneDeDuree,
											i18n,
											$author$project$I18n$Cles$conservationTouteLaFiche(i18n),
											regle.lG),
										A2(
											$elm$core$List$map,
											function (champ) {
												return A3(
													$author$project$Components$Parametrage$Conservation$View$ligneDeDuree,
													i18n,
													champ.Bl,
													$elm$core$Maybe$Just(champ.lG));
											},
											regle.dw)))
								]))
						])),
					A3($author$project$Components$Parametrage$Conservation$View$repere, i18n, regle.fA, regle.Hc)
				]));
	});
var $author$project$I18n$Cles$conservationEtapeVoirLesEcheances = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.etape.voir-les-echeances', _List_Nil, 'Voir les échéances des 30 prochains jours');
};
var $author$project$Components$Parametrage$Conservation$View$voirLesEcheances = F2(
	function (i18n, model) {
		var _v0 = model.ns;
		if (!_v0.$) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('conseil', true),
								_Utils_Tuple2('voir-les-echeances', true)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Routes$Route$adresseDesEcheancesDeConservation)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$conservationEtapeVoirLesEcheances(i18n))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$Conservation$View$contenuDeLEtape = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.hJ, model.nv);
		if (!_v0.a.$) {
			var regles = _v0.a.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('conservation')
					]),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						A2($author$project$Components$Parametrage$Conservation$View$regleDuType, i18n, model),
						regles.ib),
					_List_fromArray(
						[
							A2($author$project$Components$Parametrage$Conservation$View$ajouterSousLesCartouches, i18n, model),
							A2($author$project$Components$Parametrage$Conservation$View$voirLesEcheances, i18n, model),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('conseil', true),
											_Utils_Tuple2('alerte', true)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$conservationNoteAlerteFort(i18n))
										])),
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$conservationNoteAlerteSuite(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$conservationNoteDepart(i18n))
								]))
						])));
		} else {
			if (_v0.b.$ === 1) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$conservationEtapeIndisponible(i18n))
						]));
			} else {
				var _v3 = _v0.a;
				return model.gd ? A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$conservationEtapeIllisible(i18n))
						])) : $rtfeldman$elm_css$Html$Styled$text('');
			}
		}
	});
var $author$project$Components$Parametrage$Conservation$Update$EnregistrementDemande = {$: 15};
var $author$project$Components$Parametrage$Conservation$Update$AjoutOuvert = {$: 9};
var $author$project$Components$Parametrage$Conservation$Update$ChampAjoute = function (a) {
	return {$: 11, a: a};
};
var $author$project$I18n$Cles$conservationAjouterChampChoix = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.ajouter-champ.choix', _List_Nil, 'Choisissez l\'information à garder plus ou moins longtemps');
};
var $author$project$Components$Parametrage$Conservation$View$ajoutDeChamp = F3(
	function (i18n, model, regle) {
		var _v0 = A2($author$project$Components$Parametrage$Conservation$Model$champsAAjouter, regle, model.gV);
		if (!_v0.b) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout')
					]),
				_List_Nil);
		} else {
			var possibles = _v0;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-expanded',
								model.jO ? 'true' : 'false'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$Conservation$Update$AjoutOuvert)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$conservationAjouterChamp(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('choix-de-champ'),
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('ouvert', model.jO)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-label',
								$author$project$I18n$Cles$conservationAjouterChampChoix(i18n))
							]),
						A2(
							$elm$core$List$map,
							function (possible) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$button,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
													$rtfeldman$elm_css$Html$Styled$Events$onClick(
													$author$project$Components$Parametrage$Conservation$Update$ChampAjoute(possible.uN))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(possible.Bl)
												]))
										]));
							},
							possibles))
					]));
		}
	});
var $author$project$Components$Parametrage$Conservation$Model$confirmationEnAttente = function (model) {
	var _v0 = model.pZ;
	if ((!_v0.$) && (_v0.a.$ === 1)) {
		return !model.v2;
	} else {
		return false;
	}
};
var $author$project$I18n$Cles$conservationDrawerEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.drawer.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$conservationDrawerKicker = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'conservation.drawer.kicker',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Conservation · ' + p.Dj);
	});
var $author$project$I18n$Cles$conservationDrawerNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.drawer.note', _List_Nil, 'À l\'échéance, les informations sont effacées. Pour garder une fiche plus longtemps, prolongez-la depuis la liste des échéances.');
};
var $author$project$I18n$Cles$conservationDrawerRejeu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.drawer.rejeu', _List_Nil, 'Cet enregistrement avait déjà été appliqué. Les durées affichées sont celles du serveur.');
};
var $author$project$I18n$Cles$conservationRefusAcces = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.refus.acces', _List_Nil, 'Vous n\'avez pas le droit d\'enregistrer cette conservation.');
};
var $author$project$I18n$Cles$conservationRefusAutre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.refus.autre', _List_Nil, 'L\'enregistrement a échoué. Rien n\'a été modifié.');
};
var $author$project$Components$Parametrage$Conservation$View$erreurGenerale = F2(
	function (i18n, model) {
		var _v0 = model.pZ;
		_v0$2:
		while (true) {
			if (!_v0.$) {
				switch (_v0.a.$) {
					case 2:
						var _v1 = _v0.a;
						return A2(
							$author$project$Components$Shared$Note$View$view,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$conservationRefusAcces(i18n))
								]));
					case 4:
						var _v2 = _v0.a;
						return A2(
							$author$project$Components$Shared$Note$View$view,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$conservationRefusAutre(i18n))
								]));
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return model.qh ? A2(
			$author$project$Components$Shared$Note$View$view,
			0,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$I18n$Cles$conservationDrawerRejeu(i18n))
				])) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$Components$Parametrage$Conservation$Update$AlerteChoisie = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Components$Parametrage$Conservation$Update$DureeChoisie = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Components$Parametrage$Conservation$Model$ensemble = F2(
	function (valeur, proposees) {
		return A2($elm$core$List$member, valeur, proposees) ? proposees : $elm$core$List$sort(
			A2($elm$core$List$cons, valeur, proposees));
	});
var $author$project$Components$Parametrage$Conservation$Model$alertesProposees = function (courante) {
	return A2(
		$author$project$Components$Parametrage$Conservation$Model$ensemble,
		courante.iJ,
		_List_fromArray(
			[15, 30, 60, 90]));
};
var $author$project$I18n$Cles$conservationDrawerAlerte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.drawer.alerte', _List_Nil, 'Avertir dans l\'application');
};
var $author$project$I18n$Cles$conservationDrawerDuree = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.drawer.duree', _List_Nil, 'Durée après la clôture ou la suppression');
};
var $author$project$Components$Parametrage$Conservation$Model$dureesProposees = function (courante) {
	return A2(
		$author$project$Components$Parametrage$Conservation$Model$ensemble,
		courante.CQ,
		_List_fromArray(
			[6, 12, 24, 36, 48, 60, 84, 120]));
};
var $author$project$Components$Parametrage$Conservation$View$nomDeLaLigne = F2(
	function (i18n, ligne) {
		var _v0 = ligne.uN;
		if (!_v0.$) {
			return ligne.Bl;
		} else {
			return $author$project$I18n$Cles$conservationTouteLaFiche(i18n);
		}
	});
var $author$project$I18n$Cles$conservationRefusDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.refus.debut', _List_Nil, 'Les informations « ');
};
var $author$project$I18n$Cles$conservationRefusFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.refus.fin', _List_Nil, ' au plus.');
};
var $author$project$I18n$Cles$conservationRefusMilieu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.refus.milieu', _List_Nil, ' » ne peuvent pas être gardées ');
};
var $author$project$I18n$Cles$conservationRefusPlusLongtemps = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.refus.plus-longtemps', _List_Nil, ', plus longtemps que la fiche (');
};
var $author$project$I18n$Cles$conservationRefusSuite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.refus.suite', _List_Nil, '). Quand la fiche est effacée, toutes ses informations le sont avec elle : elles ne survivraient pas. Choisissez ');
};
var $author$project$I18n$Cles$conservationRefusTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.refus.titre', _List_Nil, 'Durée refusée');
};
var $author$project$Components$Parametrage$Conservation$View$refusNomme = F3(
	function (i18n, libelle, detail) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('refus'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$conservationRefusTitre(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							_Utils_ap(
								$author$project$I18n$Cles$conservationRefusDebut(i18n),
								_Utils_ap(
									libelle,
									$author$project$I18n$Cles$conservationRefusMilieu(i18n)))),
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Parametrage$Conservation$View$enDuree, i18n, detail.CQ))
								])),
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$conservationRefusPlusLongtemps(i18n)),
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Parametrage$Conservation$View$enDuree, i18n, detail.CS))
								])),
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$conservationRefusSuite(i18n)),
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Parametrage$Conservation$View$enDuree, i18n, detail.CS))
								])),
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$conservationRefusFin(i18n))
						]))
				]));
	});
var $author$project$Components$Parametrage$Conservation$Update$ConfirmationCochee = function (a) {
	return {$: 12, a: a};
};
var $author$project$I18n$Cles$conservationConfirmerCase = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.confirmer.case', _List_Nil, 'Je valide en connaissance de cause. Ce choix est tracé.');
};
var $author$project$I18n$Cles$conservationConfirmerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.confirmer.titre', _List_Nil, 'Réglage à confirmer');
};
var $rtfeldman$elm_css$Html$Styled$Attributes$for = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('htmlFor');
var $author$project$I18n$Cles$conservationConfirmerAutre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.confirmer.autre', _List_Nil, 'Ce réglage s\'écarte d\'une règle que l\'application vérifie.');
};
var $author$project$I18n$Cles$conservationConfirmerDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.confirmer.debut', _List_Nil, 'Les informations « ');
};
var $author$project$I18n$Cles$conservationConfirmerDejaSaisies = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.confirmer.deja-saisies', _List_Nil, 'Les valeurs déjà saisies gardent la durée de la fiche. Seules les nouvelles suivent ');
};
var $author$project$I18n$Cles$conservationConfirmerFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.confirmer.fin', _List_Nil, '.');
};
var $author$project$I18n$Cles$conservationConfirmerMilieu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.confirmer.milieu', _List_Nil, ' » sont gardées ');
};
var $author$project$I18n$Cles$conservationConfirmerMoinsLongtemps = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.confirmer.moins-longtemps', _List_Nil, ', moins longtemps que la fiche (');
};
var $author$project$I18n$Cles$conservationConfirmerSuite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.confirmer.suite', _List_Nil, '). Elles seront effacées avant le reste de la fiche.');
};
var $author$project$Components$Parametrage$Conservation$View$libelleDuChamp = F2(
	function (model, champ) {
		return A2(
			$elm$core$Maybe$withDefault,
			champ,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (ligne) {
							return _Utils_eq(
								ligne.uN,
								$elm$core$Maybe$Just(champ));
						},
						model.gV))));
	});
var $author$project$Components$Parametrage$Conservation$View$incoherenceAConfirmer = F3(
	function (i18n, model, incoherence) {
		if (!incoherence.$) {
			var detail = incoherence.a;
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							_Utils_ap(
								$author$project$I18n$Cles$conservationConfirmerDebut(i18n),
								_Utils_ap(
									A2($author$project$Components$Parametrage$Conservation$View$libelleDuChamp, model, detail.uN),
									$author$project$I18n$Cles$conservationConfirmerMilieu(i18n)))),
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Parametrage$Conservation$View$enDuree, i18n, detail.lG))
								])),
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$conservationConfirmerMoinsLongtemps(i18n)),
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Parametrage$Conservation$View$enDuree, i18n, detail.lH))
								])),
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$conservationConfirmerSuite(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$conservationConfirmerDejaSaisies(i18n)),
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Parametrage$Conservation$View$enDuree, i18n, detail.lG))
								])),
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$conservationConfirmerFin(i18n))
						]))
				]);
		} else {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$conservationConfirmerAutre(i18n))
						]))
				]);
		}
	});
var $rtfeldman$elm_css$Html$Styled$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $rtfeldman$elm_css$Html$Styled$Events$onCheck = function (tagger) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $rtfeldman$elm_css$Html$Styled$Events$targetChecked));
};
var $author$project$Components$Parametrage$Conservation$View$reglageAConfirmer = F3(
	function (i18n, model, incoherences) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('a-confirmer'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'group')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$conservationConfirmerTitre(i18n))
							]))
					]),
				_Utils_ap(
					A2(
						$elm$core$List$concatMap,
						A2($author$project$Components$Parametrage$Conservation$View$incoherenceAConfirmer, i18n, model),
						incoherences),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$fieldset,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$input,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
											$rtfeldman$elm_css$Html$Styled$Attributes$id('conservation-confirmer'),
											$rtfeldman$elm_css$Html$Styled$Attributes$checked(model.v2),
											$rtfeldman$elm_css$Html$Styled$Events$onCheck($author$project$Components$Parametrage$Conservation$Update$ConfirmationCochee)
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$label,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$for('conservation-confirmer')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$conservationConfirmerCase(i18n))
										]))
								]))
						]))));
	});
var $author$project$Components$Parametrage$Conservation$View$sectionDuType = F3(
	function (i18n, model, ligne) {
		var refusee = function () {
			var _v1 = model.pZ;
			if ((!_v1.$) && (!_v1.a.$)) {
				var detail = _v1.a.a;
				return _Utils_eq(
					ligne.uN,
					$elm$core$Maybe$Just(detail.uN));
			} else {
				return false;
			}
		}();
		var idDe = function (cible) {
			return 'conservation-' + (cible + ('-' + A2($elm$core$Maybe$withDefault, 'fiche', ligne.uN)));
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne-de-conservation'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('refusee', refusee)
						]))
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h3,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$Components$Parametrage$Conservation$View$nomDeLaLigne, i18n, ligne))
							])),
						A2(
						$author$project$Components$Shared$Champ$View$liste,
						{
							go: $elm$core$Maybe$Nothing,
							Aq: idDe('duree'),
							Bl: $author$project$I18n$Cles$conservationDrawerDuree(i18n),
							he: false
						},
						{
							hg: $author$project$Components$Parametrage$Conservation$Update$DureeChoisie(ligne.uN),
							o_: A2(
								$elm$core$List$map,
								function (mois) {
									return {
										Bl: A2($author$project$Components$Parametrage$Conservation$View$enDuree, i18n, mois),
										fm: $elm$core$String$fromInt(mois)
									};
								},
								$author$project$Components$Parametrage$Conservation$Model$dureesProposees(ligne.lG)),
							fm: $elm$core$String$fromInt(ligne.lG.CQ)
						})
					]),
				_Utils_ap(
					_Utils_eq(ligne.uN, $elm$core$Maybe$Nothing) ? A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function (regle) {
									return A3($author$project$Components$Parametrage$Conservation$View$repere, i18n, regle.fA, regle.Hc);
								},
								$elm$core$List$singleton),
							A2(
								$elm$core$Maybe$andThen,
								$author$project$Components$Parametrage$Conservation$Model$regleDuType(model),
								model.ia))) : _List_Nil,
					_Utils_ap(
						function () {
							var _v0 = model.pZ;
							_v0$2:
							while (true) {
								if (!_v0.$) {
									switch (_v0.a.$) {
										case 0:
											var detail = _v0.a.a;
											return refusee ? _List_fromArray(
												[
													A3(
													$author$project$Components$Parametrage$Conservation$View$refusNomme,
													i18n,
													A2($author$project$Components$Parametrage$Conservation$View$nomDeLaLigne, i18n, ligne),
													detail)
												]) : _List_Nil;
										case 1:
											var incoherences = _v0.a.a;
											return _Utils_eq(
												$elm$core$Maybe$Just(ligne.uN),
												A2(
													$elm$core$Maybe$map,
													$author$project$Components$Parametrage$Conservation$Model$champDeLIncoherence,
													$elm$core$List$head(incoherences))) ? _List_fromArray(
												[
													A3($author$project$Components$Parametrage$Conservation$View$reglageAConfirmer, i18n, model, incoherences)
												]) : _List_Nil;
										default:
											break _v0$2;
									}
								} else {
									break _v0$2;
								}
							}
							return _List_Nil;
						}(),
						_List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Champ$View$liste,
								{
									go: $elm$core$Maybe$Nothing,
									Aq: idDe('alerte'),
									Bl: $author$project$I18n$Cles$conservationDrawerAlerte(i18n),
									he: false
								},
								{
									hg: $author$project$Components$Parametrage$Conservation$Update$AlerteChoisie(ligne.uN),
									o_: A2(
										$elm$core$List$map,
										function (jours) {
											return {
												Bl: A2(
													$author$project$I18n$Cles$conservationAlerteAvant,
													i18n,
													{ni: jours}),
												fm: $elm$core$String$fromInt(jours)
											};
										},
										$author$project$Components$Parametrage$Conservation$Model$alertesProposees(ligne.lG)),
									fm: $elm$core$String$fromInt(ligne.lG.iJ)
								})
							])))));
	});
var $author$project$Components$Parametrage$Conservation$View$contenuDuTypeOuvert = F2(
	function (i18n, model) {
		var regle = A2(
			$elm$core$Maybe$andThen,
			$author$project$Components$Parametrage$Conservation$Model$regleDuType(model),
			model.ia);
		var libelle = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				regle));
		return {
			fs: {
				sR: (!_Utils_eq(regle, $elm$core$Maybe$Nothing)) && ((!$author$project$API$Envoi$enCours(model.l2)) && (!$author$project$Components$Parametrage$Conservation$Model$confirmationEnAttente(model))),
				Bl: $author$project$I18n$Cles$conservationDrawerEnregistrer(i18n),
				C$: $author$project$Components$Parametrage$Conservation$Update$EnregistrementDemande
			},
			fZ: function () {
				if (!regle.$) {
					var ouvert = regle.a;
					return _Utils_ap(
						A2(
							$elm$core$List$map,
							A2($author$project$Components$Parametrage$Conservation$View$sectionDuType, i18n, model),
							model.gV),
						_List_fromArray(
							[
								A3($author$project$Components$Parametrage$Conservation$View$ajoutDeChamp, i18n, model, ouvert),
								A2($author$project$Components$Parametrage$Conservation$View$erreurGenerale, i18n, model),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$conservationDrawerNote(i18n))
									]))
							]));
				} else {
					return _List_Nil;
				}
			}(),
			A6: $elm$core$Maybe$Just(
				A2(
					$author$project$I18n$Cles$conservationDrawerKicker,
					i18n,
					{Dj: libelle})),
			Bc: false,
			h6: libelle
		};
	});
var $author$project$Components$Parametrage$Conservation$View$drawerDuType = F2(
	function (i18n, model) {
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Parametrage$Conservation$Update$DuDrawerDuType,
			A2($author$project$Components$Parametrage$Conservation$View$contenuDuTypeOuvert, i18n, model),
			model.lw);
	});
var $author$project$Components$Shared$Parcours$View$fragment = function (fourni) {
	if (!fourni.$) {
		var texte = fourni.a;
		return $rtfeldman$elm_css$Html$Styled$text(texte);
	} else {
		var texte = fourni.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$strong,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(texte)
				]));
	}
};
var $author$project$Components$Shared$Parcours$View$etapeAvecPastille = F5(
	function (pastille, parcours, courante, fournie, porte) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('etape'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					parcours.Dj(fournie)),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'hidden',
							!_Utils_eq(fournie, courante))
						]))
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id(
							$author$project$Components$Shared$Parcours$Model$idDuTitre(
								parcours.Dj(fournie))),
							$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1)
						]),
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$text(porte.GJ),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (libelle) {
									return _List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(' '),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('chip')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(libelle)
												]))
										]);
								},
								pastille)))),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('explication')
							]),
						A2($elm$core$List$map, $author$project$Components$Shared$Parcours$View$fragment, porte.y8)),
					porte.fZ)));
	});
var $author$project$Components$Shared$Parcours$View$etape = $author$project$Components$Shared$Parcours$View$etapeAvecPastille($elm$core$Maybe$Nothing);
var $author$project$Components$Shared$Parcours$Model$EnCours = 1;
var $author$project$Components$Shared$Parcours$Model$Faite = 0;
var $author$project$Components$Shared$Parcours$Model$AVenir = 2;
var $author$project$Components$Shared$Parcours$Model$avancement = F3(
	function (remplie, courante, etape) {
		return _Utils_eq(etape, courante) ? 1 : (remplie(etape) ? 0 : 2);
	});
var $author$project$I18n$Cles$parcoursEtapeAVenir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'parcours.etape.a-venir', _List_Nil, 'À venir');
};
var $author$project$I18n$Cles$parcoursEtapeEnCours = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'parcours.etape.en-cours', _List_Nil, 'En cours');
};
var $author$project$I18n$Cles$parcoursEtapeFaite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'parcours.etape.faite', _List_Nil, 'Faite');
};
var $author$project$Components$Shared$Parcours$Model$libelleDeLAvancement = F2(
	function (i18n, etat) {
		switch (etat) {
			case 0:
				return $author$project$I18n$Cles$parcoursEtapeFaite(i18n);
			case 1:
				return $author$project$I18n$Cles$parcoursEtapeEnCours(i18n);
			default:
				return $author$project$I18n$Cles$parcoursEtapeAVenir(i18n);
		}
	});
var $author$project$I18n$Cles$parcoursEtapes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'parcours.etapes', _List_Nil, 'Étapes');
};
var $author$project$Components$Shared$Parcours$View$etapes = F3(
	function (i18n, parcours, courante) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$nav,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('etapes'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					$author$project$I18n$Cles$parcoursEtapes(i18n))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$ol,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (fournie) {
							var ou = A3($author$project$Components$Shared$Parcours$Model$avancement, parcours.qm, courante, fournie);
							return A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_Utils_ap(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$href(
													parcours.aa(fournie)),
													$rtfeldman$elm_css$Html$Styled$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('active', ou === 1),
															_Utils_Tuple2('faite', !ou)
														]))
												]),
											(ou === 1) ? _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-current', 'step')
												]) : _List_Nil),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('numero')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$elm$core$String$fromInt(
															A2($author$project$Components$Shared$Parcours$Model$numero, parcours.yL, fournie)))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														parcours.h6(fournie))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('avancement')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2($author$project$Components$Shared$Parcours$Model$libelleDeLAvancement, i18n, ou))
													]))
											]))
									]));
						},
						parcours.yL))
				]));
	});
var $author$project$Components$Shared$Bouton$View$lienAvec = F4(
	function (variante, attributs, adresse, libelle) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$a,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$class('button'),
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
						$author$project$Components$Shared$Bouton$View$classe(variante)),
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$href(adresse),
						attributs))),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						]))
				]));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$keyedNode = $rtfeldman$elm_css$VirtualDom$Styled$KeyedNode;
var $rtfeldman$elm_css$Html$Styled$Keyed$node = $rtfeldman$elm_css$VirtualDom$Styled$keyedNode;
var $author$project$I18n$Cles$parcoursEtapePrecedente = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'parcours.etape.precedente', _List_Nil, 'Étape précédente');
};
var $author$project$I18n$Cles$parcoursEtapeSuivante = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'parcours.etape.suivante', _List_Nil, 'Étape suivante');
};
var $author$project$Components$Shared$Parcours$Model$voisine = F2(
	function (etapes, rang) {
		return (rang < 1) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, rang - 1, etapes));
	});
var $author$project$Components$Shared$Parcours$Model$precedente = F2(
	function (etapes, etape) {
		return A2(
			$author$project$Components$Shared$Parcours$Model$voisine,
			etapes,
			A2($author$project$Components$Shared$Parcours$Model$numero, etapes, etape) - 1);
	});
var $author$project$Components$Shared$Parcours$Model$suivante = F2(
	function (etapes, etape) {
		return A2(
			$author$project$Components$Shared$Parcours$Model$voisine,
			etapes,
			A2($author$project$Components$Shared$Parcours$Model$numero, etapes, etape) + 1);
	});
var $author$project$Components$Shared$Parcours$View$piedAvec = F4(
	function (i18n, aLaFin, parcours, courante) {
		var vers = F3(
			function (variante, libelle, autre) {
				return A4(
					$author$project$Components$Shared$Bouton$View$lienAvec,
					variante,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							parcours.tX(autre))
						]),
					parcours.aa(autre),
					libelle);
			});
		return A3(
			$rtfeldman$elm_css$Html$Styled$Keyed$node,
			'div',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pied')
				]),
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'precedente',
					function () {
						var _v0 = A2($author$project$Components$Shared$Parcours$Model$precedente, parcours.yL, courante);
						if (!_v0.$) {
							var autre = _v0.a;
							return A3(
								vers,
								1,
								$author$project$I18n$Cles$parcoursEtapePrecedente(i18n),
								autre);
						} else {
							return A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
									]),
								$author$project$I18n$Cles$parcoursEtapePrecedente(i18n));
						}
					}()),
				A2(
					$elm$core$Maybe$withDefault,
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (i, geste) {
								return _Utils_Tuple2(
									'fin-' + $elm$core$String$fromInt(i),
									geste);
							}),
						aLaFin),
					A2(
						$elm$core$Maybe$map,
						function (autre) {
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'suivante',
									A3(
										vers,
										0,
										$author$project$I18n$Cles$parcoursEtapeSuivante(i18n),
										autre))
								]);
						},
						A2($author$project$Components$Shared$Parcours$Model$suivante, parcours.yL, courante)))));
	});
var $author$project$Components$Shared$Parcours$View$pied = function (i18n) {
	return A2($author$project$Components$Shared$Parcours$View$piedAvec, i18n, _List_Nil);
};
var $author$project$I18n$Cles$referentielParcoursApercu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.apercu', _List_Nil, 'Aperçu du type');
};
var $author$project$Components$Parametrage$Conservation$View$etape = F4(
	function (i18n, habillage, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'referentiel-types-list',
			{
				ut: _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Parcours$View$etapes,
						i18n,
						$author$project$Components$Parametrage$Conservation$View$avecLesEtapesPrecedentesFaites(habillage.ex),
						5),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						_List_fromArray(
							[
								A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
								A4(
								$author$project$Components$Shared$Parcours$View$etape,
								habillage.ex,
								5,
								5,
								{
									fZ: _List_fromArray(
										[
											A2($author$project$Components$Parametrage$Conservation$View$contenuDeLEtape, i18n, model)
										]),
									y8: _List_fromArray(
										[
											$author$project$Components$Shared$Parcours$Model$Texte(
											$author$project$I18n$Cles$conservationEtapeExplication(i18n))
										]),
									GJ: $author$project$I18n$Cles$conservationEtapeQuestion(i18n)
								}),
								A3($author$project$Components$Shared$Parcours$View$pied, i18n, habillage.ex, 5)
							])),
						A3(
						$author$project$Components$Shared$Parcours$View$apercu,
						i18n,
						$author$project$I18n$Cles$referentielParcoursApercu(i18n),
						A2($author$project$Components$Parametrage$Conservation$View$apercu, i18n, model))
					]),
				xy: _List_fromArray(
					[
						A2($author$project$Components$Parametrage$Conservation$View$drawerDuType, i18n, model)
					]),
				zM: _List_Nil,
				AK: $author$project$Components$Parametrage$Conservation$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(habillage.dH)
									]))
							]),
						zE: habillage.zE,
						Ef: _List_Nil,
						h6: habillage.h6
					})
			});
	});
var $author$project$Components$Shared$Parcours$Model$Fort = function (a) {
	return {$: 1, a: a};
};
var $author$project$I18n$Cles$posteEtapeApercuTotal = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'poste.etape.apercu.total',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' poste') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' postes'));
	});
var $author$project$I18n$Cles$relationEtapeApercuExemple = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'relation.etape.apercu.exemple',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			'Léa Dubois ' + (_Utils_ap(
				$elm$core$String$toLower(
					A2($elm$core$String$left, 1, p.Bl)),
				A2($elm$core$String$dropLeft, 1, p.Bl)) + ' Camille Martin'));
	});
var $author$project$I18n$Cles$relationEtapeApercuTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.etape.apercu.titre', _List_Nil, 'Ce que disent vos liens');
};
var $author$project$I18n$Cles$relationEtapeApercuTotal = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'relation.etape.apercu.total',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' type') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' types'));
	});
var $author$project$I18n$Cles$relationEtapeApercuTotalAvecPostes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'relation.etape.apercu.total.avec.postes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'types',
					$author$project$I18n$Traductions$Chaine(p.ib)),
					_Utils_Tuple2(
					'postes',
					$author$project$I18n$Traductions$Chaine(p.F6))
				]),
			p.ib + (', ' + p.F6));
	});
var $author$project$Components$Referentiel$TypesDeRelation$View$apercu = F3(
	function (i18n, postes, model) {
		var enVigueur = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ib;
					},
					$elm$core$List$filter(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.tE;
							},
							$elm$core$Basics$not))),
				model.aS));
		return {
			gV: _Utils_ap(
				A2(
					$elm$core$List$concatMap,
					function (relation) {
						return _List_fromArray(
							[
								{dX: true, eW: 0, Jx: relation.Bn.zX},
								{
								dX: false,
								eW: 1,
								Jx: A2(
									$author$project$I18n$Cles$relationEtapeApercuExemple,
									i18n,
									{Bl: relation.Bn.zX})
							}
							]);
					},
					enVigueur),
				_Utils_ap(
					postes.gV,
					$elm$core$List$isEmpty(enVigueur) ? _List_Nil : _List_fromArray(
						[
							{
							dX: false,
							eW: 0,
							Jx: (!postes.w) ? A2(
								$author$project$I18n$Cles$relationEtapeApercuTotal,
								i18n,
								{
									w: $elm$core$List$length(enVigueur)
								}) : A2(
								$author$project$I18n$Cles$relationEtapeApercuTotalAvecPostes,
								i18n,
								{
									F6: A2(
										$author$project$I18n$Cles$posteEtapeApercuTotal,
										i18n,
										{w: postes.w}),
									ib: A2(
										$author$project$I18n$Cles$relationEtapeApercuTotal,
										i18n,
										{
											w: $elm$core$List$length(enVigueur)
										})
								})
						}
						]))),
			h6: $elm$core$Maybe$Just(
				$author$project$I18n$Cles$relationEtapeApercuTitre(i18n))
		};
	});
var $author$project$Components$Referentiel$TypesDeRelation$View$avecLesEtapesPrecedentesFaites = function (parcours) {
	var rang = $author$project$Components$Shared$Parcours$Model$numero(parcours.yL);
	return _Utils_update(
		parcours,
		{
			qm: function (autre) {
				return parcours.qm(autre) || (_Utils_cmp(
					rang(autre),
					rang(6)) < 0);
			}
		});
};
var $author$project$Components$Referentiel$TypesDeRelation$Update$EnregistrementDemande = {$: 12};
var $author$project$Components$Referentiel$TypesDeRelation$Update$Saisi = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Referentiel$TypesDeRelation$Update$ArchivageDemande = function (a) {
	return {$: 13, a: a};
};
var $author$project$I18n$Cles$relationDrawerArchiver = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.archiver', _List_Nil, 'Archiver');
};
var $author$project$I18n$Cles$relationDrawerArchiverAide = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'relation.drawer.archiver.aide',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Un type utilisé ne se supprime pas. Archivé, il n\'est plus proposé ; le ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' lien reste affiché.')) : ('Un type utilisé ne se supprime pas. Archivé, il n\'est plus proposé ; les ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' liens restent affichés.')));
	});
var $author$project$I18n$Cles$relationDrawerArchiverAideSansLien = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.archiver.aide-sans-lien', _List_Nil, 'Archivé, il n\'est plus proposé.');
};
var $author$project$I18n$Cles$relationDrawerArchiverBouton = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'relation.drawer.archiver.bouton',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			'Archiver « ' + (p.Bl + ' »'));
	});
var $author$project$Components$Referentiel$TypesDeRelation$View$archivage = F2(
	function (i18n, modification) {
		if (!modification.$) {
			var relation = modification.a;
			var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$archiverLeTypeDeRelation, relation.nQ);
			if (!_v1.$) {
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$section,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('archivage')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$h3,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$relationDrawerArchiver(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										(!relation.Kg) ? $author$project$I18n$Cles$relationDrawerArchiverAideSansLien(i18n) : A2(
											$author$project$I18n$Cles$relationDrawerArchiverAide,
											i18n,
											{w: relation.Kg}))
									])),
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								3,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Referentiel$TypesDeRelation$Update$ArchivageDemande(relation.Aq))
									]),
								A2(
									$author$project$I18n$Cles$relationDrawerArchiverBouton,
									i18n,
									{Bl: relation.Bn.zX}))
							]))
					]);
			} else {
				return _List_Nil;
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Referentiel$TypesDeRelation$Model$estEnvoi = function (model) {
	return $author$project$API$Envoi$enCours(model.l2);
};
var $author$project$I18n$Cles$relationDrawerApercu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.apercu', _List_Nil, 'Aperçu');
};
var $author$project$I18n$Cles$relationDrawerApercuDirectDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.apercu.direct.debut', _List_Nil, 'Léa Dubois ');
};
var $author$project$I18n$Cles$relationDrawerApercuDirectFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.apercu.direct.fin', _List_Nil, ' Camille Martin.');
};
var $author$project$I18n$Cles$relationDrawerApercuInverseDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.apercu.inverse.debut', _List_Nil, 'Chez Camille : « ');
};
var $author$project$I18n$Cles$relationDrawerApercuInverseFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.apercu.inverse.fin', _List_Nil, ' Léa Dubois ».');
};
var $author$project$I18n$Cles$relationDrawerApercuNom = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'relation.drawer.apercu.nom',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			_Utils_ap(
				$elm$core$String$toLower(
					A2($elm$core$String$left, 1, p.Dj)),
				A2($elm$core$String$dropLeft, 1, p.Dj)));
	});
var $author$project$Components$Referentiel$TypesDeRelation$View$apercuDuType = F2(
	function (i18n, saisie) {
		var direct = $elm$core$String$isEmpty(
			$elm$core$String$trim(saisie.cB)) ? '…' : $elm$core$String$trim(saisie.cB);
		var inverse = saisie.G6 ? direct : ($elm$core$String$isEmpty(
			$elm$core$String$trim(saisie.cQ)) ? '…' : $elm$core$String$trim(saisie.cQ));
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$relationDrawerApercu(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('exemple'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'note')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$relationDrawerApercuDirectDebut(i18n)),
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$relationDrawerApercuNom,
												i18n,
												{Dj: direct}))
										])),
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$relationDrawerApercuDirectFin(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$relationDrawerApercuInverseDebut(i18n)),
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$relationDrawerApercuNom,
												i18n,
												{Dj: inverse}))
										])),
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$relationDrawerApercuInverseFin(i18n))
								]))
						]))
				]));
	});
var $author$project$Components$Referentiel$TypesDeRelation$Model$DirectFr = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$TypesDeRelation$Model$InverseFr = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Referentiel$TypesDeRelation$View$orElse = F2(
	function (suivant, premier) {
		if (!premier.$) {
			return premier;
		} else {
			return suivant;
		}
	});
var $author$project$I18n$Cles$relationLibelleDoublon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.libelle.doublon', _List_Nil, 'Un type de relation porte déjà ce libellé');
};
var $author$project$Components$Referentiel$TypesDeRelation$View$erreurDeLibelle = F3(
	function (i18n, saisie, saisi) {
		var manque = (saisie.b5 && $elm$core$String$isEmpty(
			$elm$core$String$trim(saisi))) ? $elm$core$Maybe$Just(
			$author$project$I18n$Cles$relationLibelleObligatoire(i18n)) : $elm$core$Maybe$Nothing;
		var doublon = _Utils_eq(
			saisie.pZ,
			$elm$core$Maybe$Just($author$project$Components$Referentiel$TypesDeRelation$Model$Doublon)) ? $elm$core$Maybe$Just(
			$author$project$I18n$Cles$relationLibelleDoublon(i18n)) : $elm$core$Maybe$Nothing;
		return A2($author$project$Components$Referentiel$TypesDeRelation$View$orElse, doublon, manque);
	});
var $author$project$I18n$Cles$relationDrawerNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.nom', _List_Nil, 'Nom');
};
var $author$project$I18n$Cles$relationDrawerNomAutreSens = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.nom-autre-sens', _List_Nil, 'Nom dans l\'autre sens');
};
var $author$project$I18n$Cles$relationDrawerNomUnSens = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.nom-un-sens', _List_Nil, 'Nom dans un sens');
};
var $author$project$I18n$Cles$relationDrawerNoms = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.noms', _List_Nil, 'Noms');
};
var $author$project$Components$Referentiel$TypesDeRelation$View$texte = F6(
	function (identifiant, libelle, obligatoire, erreur, valeur, surSaisie) {
		return A2(
			$author$project$Components$Shared$Champ$View$texte,
			{go: erreur, Aq: identifiant, Bl: libelle, he: obligatoire},
			{hg: surSaisie, fm: valeur});
	});
var $author$project$Components$Referentiel$TypesDeRelation$View$nomsDeLaCreation = F3(
	function (i18n, prefixe, saisie) {
		var inverseFr = A6(
			$author$project$Components$Referentiel$TypesDeRelation$View$texte,
			prefixe + '-inverse-fr',
			$author$project$I18n$Cles$relationDrawerNomAutreSens(i18n),
			true,
			(saisie.b5 && $elm$core$String$isEmpty(
				$elm$core$String$trim(saisie.cQ))) ? $elm$core$Maybe$Just(
				$author$project$I18n$Cles$relationLibelleObligatoire(i18n)) : $elm$core$Maybe$Nothing,
			saisie.cQ,
			$author$project$Components$Referentiel$TypesDeRelation$Model$InverseFr);
		var directFr = A6(
			$author$project$Components$Referentiel$TypesDeRelation$View$texte,
			prefixe + '-direct-fr',
			saisie.G6 ? $author$project$I18n$Cles$relationDrawerNom(i18n) : $author$project$I18n$Cles$relationDrawerNomUnSens(i18n),
			true,
			A3($author$project$Components$Referentiel$TypesDeRelation$View$erreurDeLibelle, i18n, saisie, saisie.cB),
			saisie.cB,
			$author$project$Components$Referentiel$TypesDeRelation$Model$DirectFr);
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('noms')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h3,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$relationDrawerNoms(i18n))
							])),
						directFr
					]),
				_Utils_ap(
					saisie.G6 ? _List_Nil : _List_fromArray(
						[inverseFr]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('anglais')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$strong,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$elm$core$String$isEmpty(
														$elm$core$String$trim(saisie.cA)) ? $author$project$I18n$Cles$relationDrawerAnglaisARenseigner(i18n) : A2(
														$author$project$I18n$Cles$relationDrawerAnglais,
														i18n,
														{
															Dj: $elm$core$String$trim(saisie.cA)
														}))
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
											$rtfeldman$elm_css$Html$Styled$Attributes$id(
											$author$project$Components$Referentiel$TypesDeRelation$Model$idDuNom(0)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'dialog'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Referentiel$TypesDeRelation$Model$OuvrirNom(0))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$relationDrawerTraduire(i18n))
										]))
								]))
						]))));
	});
var $author$project$Components$Referentiel$TypesDeRelation$View$nomsDuType = F3(
	function (i18n, saisie, relation) {
		var carte = F3(
			function (sens, fr, en) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(fr)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$elm$core$String$isEmpty(
												$elm$core$String$trim(en)) ? $author$project$I18n$Cles$relationDrawerAnglaisVide(i18n) : A2(
												$author$project$I18n$Cles$relationDrawerAnglais,
												i18n,
												{
													Dj: $elm$core$String$trim(en)
												}))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id(
									$author$project$Components$Referentiel$TypesDeRelation$Model$idDuNom(sens)),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'dialog'),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Referentiel$TypesDeRelation$Model$OuvrirNom(sens))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$relationDrawerRenommer(i18n))
								]))
						]));
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('noms')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$relationDrawerNoms(i18n))
						])),
				A2(
					$elm$core$List$cons,
					A3(carte, 0, saisie.cB, saisie.cA),
					relation.G6 ? _List_Nil : _List_fromArray(
						[
							A3(carte, 1, saisie.cQ, saisie.cP)
						]))));
	});
var $author$project$Components$Shared$Tag$View$Accent = 5;
var $author$project$Components$Referentiel$TypesDeRelation$Model$Arrivee = 1;
var $author$project$Components$Referentiel$TypesDeRelation$Model$Depart = 0;
var $author$project$Components$Referentiel$TypesDeRelation$Model$ModifierLePerimetre = {$: 10};
var $author$project$Components$Referentiel$TypesDeRelation$View$nomDeLaForme = F2(
	function (formes, id) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.R;
					},
					function ($) {
						return $.zX;
					}),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (forme) {
							return _Utils_eq(forme.Aq, id);
						},
						formes))));
	});
var $author$project$I18n$Cles$relationCoteOrganisation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.cote.organisation', _List_Nil, 'Toute organisation');
};
var $author$project$I18n$Cles$relationCoteOu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.cote.ou', _List_Nil, ' ou ');
};
var $author$project$I18n$Cles$relationCoteParticuliere = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.cote.particuliere', _List_Nil, 'Personne particulière');
};
var $author$project$I18n$Cles$relationCotePersonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.cote.personne', _List_Nil, 'Personne');
};
var $author$project$I18n$Cles$relationCoteProfessionnelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.cote.professionnelle', _List_Nil, 'Personne professionnelle');
};
var $author$project$I18n$Cles$relationCoteToute = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.cote.toute', _List_Nil, 'Toute fiche');
};
var $author$project$Components$Referentiel$TypesDeRelation$View$nomDuCote = F3(
	function (i18n, formes, cote) {
		if (cote.hs && (cote.hr && _Utils_eq(cote.o3, $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$Toutes))) {
			return $author$project$I18n$Cles$relationCoteToute(i18n);
		} else {
			var personnes = function () {
				var _v1 = _Utils_Tuple2(cote.hs, cote.hr);
				if (_v1.a) {
					if (_v1.b) {
						return _List_fromArray(
							[
								$author$project$I18n$Cles$relationCotePersonne(i18n)
							]);
					} else {
						return _List_fromArray(
							[
								$author$project$I18n$Cles$relationCoteProfessionnelle(i18n)
							]);
					}
				} else {
					if (_v1.b) {
						return _List_fromArray(
							[
								$author$project$I18n$Cles$relationCoteParticuliere(i18n)
							]);
					} else {
						return _List_Nil;
					}
				}
			}();
			var organisations = function () {
				var _v0 = cote.o3;
				switch (_v0.$) {
					case 1:
						return _List_fromArray(
							[
								$author$project$I18n$Cles$relationCoteOrganisation(i18n)
							]);
					case 2:
						var ids = _v0.a;
						return _List_fromArray(
							[
								A2(
								$elm$core$String$join,
								', ',
								A2(
									$elm$core$List$map,
									$author$project$Components$Referentiel$TypesDeRelation$View$nomDeLaForme(formes),
									ids))
							]);
					default:
						return _List_Nil;
				}
			}();
			return A2(
				$elm$core$String$join,
				$author$project$I18n$Cles$relationCoteOu(i18n),
				_Utils_ap(personnes, organisations));
		}
	});
var $author$project$Components$Referentiel$TypesDeRelation$View$nomDuCoteSaisi = F4(
	function (i18n, formes, saisie, cote) {
		var _v0 = saisie.n9;
		if (_v0.$ === 1) {
			var relation = _v0.a;
			if (!cote) {
				return A3($author$project$Components$Referentiel$TypesDeRelation$View$nomDuCote, i18n, formes, relation.IR);
			} else {
				return A3(
					$author$project$Components$Referentiel$TypesDeRelation$View$nomDuCote,
					i18n,
					formes,
					A2($elm$core$Maybe$withDefault, relation.IR, relation.vf));
			}
		} else {
			return '';
		}
	});
var $author$project$Components$Referentiel$TypesDeRelation$Model$Particulieres = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Referentiel$TypesDeRelation$Model$Professionnelles = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$Referentiel$TypesDeRelation$Model$ToutesLesOrganisations = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Referentiel$TypesDeRelation$Model$UneForme = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$Components$Shared$Champ$View$caseACocher = F2(
	function (champ, saisie) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$fieldset,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
					$author$project$Components$Shared$Champ$View$classes(champ)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_Utils_ap(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
								$rtfeldman$elm_css$Html$Styled$Attributes$id(champ.Aq),
								$rtfeldman$elm_css$Html$Styled$Attributes$checked(saisie.vt),
								$rtfeldman$elm_css$Html$Styled$Events$onCheck(saisie.D9)
							]),
						$author$project$Components$Shared$Champ$View$etats(champ)),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$for(champ.Aq)
						]),
					$author$project$Components$Shared$Champ$View$libelle(champ)),
					$author$project$Components$Shared$Champ$View$erreurs(champ)
				]));
	});
var $author$project$Components$Shared$Champ$View$compose = $author$project$Components$Shared$Champ$View$formItem;
var $author$project$Components$Referentiel$TypesDeRelation$Model$cotePeutEtreVide = F2(
	function (saisie, cote) {
		return $author$project$Components$Referentiel$TypesDeRelation$Model$vide(
			function () {
				if (!cote) {
					return saisie.cx;
				} else {
					return saisie.tN;
				}
			}());
	});
var $author$project$I18n$Cles$relationPerimetreOrganisations = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.perimetre.organisations', _List_Nil, 'Toute organisation');
};
var $author$project$I18n$Cles$relationPerimetreParticulieres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.perimetre.particulieres', _List_Nil, 'Personne particulière');
};
var $author$project$I18n$Cles$relationPerimetreProfessionnelles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.perimetre.professionnelles', _List_Nil, 'Personne professionnelle');
};
var $author$project$I18n$Cles$relationPerimetreVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.perimetre.vide', _List_Nil, 'Choisissez au moins une catégorie.');
};
var $author$project$Components$Referentiel$TypesDeRelation$View$perimetre = F6(
	function (i18n, prefixe, formes, saisie, cote, titre) {
		var vide = saisie.b5 && A2($author$project$Components$Referentiel$TypesDeRelation$Model$cotePeutEtreVide, saisie, cote);
		var suffixe = function () {
			if (!cote) {
				return 'depart';
			} else {
				return 'arrivee';
			}
		}();
		var courant = function () {
			if (!cote) {
				return saisie.cx;
			} else {
				return saisie.tN;
			}
		}();
		var case_ = F4(
			function (nom, libelle, coche, surCoche) {
				return A2(
					$author$project$Components$Shared$Champ$View$caseACocher,
					{go: $elm$core$Maybe$Nothing, Aq: prefixe + ('-' + (suffixe + ('-' + nom))), Bl: libelle, he: false},
					{vt: coche, D9: surCoche});
			});
		return A2(
			$author$project$Components$Shared$Champ$View$compose,
			{
				go: vide ? $elm$core$Maybe$Just(
					$author$project$I18n$Cles$relationPerimetreVide(i18n)) : $elm$core$Maybe$Nothing,
				Aq: prefixe + ('-perimetre-' + suffixe),
				Bl: titre,
				he: true
			},
			_Utils_ap(
				_List_fromArray(
					[
						A4(
						case_,
						'pro',
						$author$project$I18n$Cles$relationPerimetreProfessionnelles(i18n),
						courant.bX,
						$author$project$Components$Referentiel$TypesDeRelation$Model$Professionnelles(cote)),
						A4(
						case_,
						'particuliers',
						$author$project$I18n$Cles$relationPerimetreParticulieres(i18n),
						courant.bS,
						$author$project$Components$Referentiel$TypesDeRelation$Model$Particulieres(cote)),
						A4(
						case_,
						'toutes',
						$author$project$I18n$Cles$relationPerimetreOrganisations(i18n),
						courant.rO,
						$author$project$Components$Referentiel$TypesDeRelation$Model$ToutesLesOrganisations(cote))
					]),
				$elm$core$List$isEmpty(formes) ? _List_Nil : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('formes')
							]),
						A2(
							$elm$core$List$map,
							function (forme) {
								return A4(
									case_,
									'forme-' + $author$project$Components$Referentiel$TypesDeRelation$API$QueryAPIModel$formeIdVersTexte(forme.Aq),
									forme.R.zX,
									A2($elm$core$List$member, forme.Aq, courant.zS),
									A2($author$project$Components$Referentiel$TypesDeRelation$Model$UneForme, cote, forme.Aq));
							},
							formes))
					])));
	});
var $author$project$I18n$Cles$relationDrawerDe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.de', _List_Nil, 'De');
};
var $author$project$I18n$Cles$relationDrawerDeLegende = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.de-legende', _List_Nil, 'De :');
};
var $author$project$I18n$Cles$relationDrawerModifierLePerimetre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.modifier-le-perimetre', _List_Nil, 'Modifier le périmètre');
};
var $author$project$I18n$Cles$relationDrawerVers = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.vers', _List_Nil, 'vers');
};
var $author$project$I18n$Cles$relationDrawerVersLegende = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.vers-legende', _List_Nil, 'Vers :');
};
var $author$project$I18n$Cles$relationPerimetreAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.perimetre.aide', _List_Nil, 'Cochez les fiches concernées de chaque côté.');
};
var $author$project$I18n$Cles$relationPerimetreDeux = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.perimetre.deux', _List_Nil, 'Les deux fiches');
};
var $author$project$I18n$Cles$relationPerimetreNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.perimetre.note', _List_Nil, 'Les liens déjà créés ne changent pas.');
};
var $author$project$I18n$Cles$relationPerimetreTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.perimetre.titre', _List_Nil, 'Qui peut être relié ?');
};
var $author$project$Components$Referentiel$TypesDeRelation$View$qui = F5(
	function (i18n, prefixe, formes, saisie, ouvert) {
		var groupes = saisie.G6 ? _List_fromArray(
			[
				A6(
				$author$project$Components$Referentiel$TypesDeRelation$View$perimetre,
				i18n,
				prefixe,
				formes,
				saisie,
				0,
				$author$project$I18n$Cles$relationPerimetreDeux(i18n))
			]) : _List_fromArray(
			[
				A6(
				$author$project$Components$Referentiel$TypesDeRelation$View$perimetre,
				i18n,
				prefixe,
				formes,
				saisie,
				0,
				$author$project$I18n$Cles$relationDrawerDeLegende(i18n)),
				A6(
				$author$project$Components$Referentiel$TypesDeRelation$View$perimetre,
				i18n,
				prefixe,
				formes,
				saisie,
				1,
				$author$project$I18n$Cles$relationDrawerVersLegende(i18n))
			]);
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('qui')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$relationPerimetreTitre(i18n))
						])),
				_Utils_ap(
					ouvert ? A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$relationPerimetreAide(i18n))
								])),
						groupes) : _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('sens')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$relationDrawerDe(i18n))
										])),
									A2(
									$author$project$Components$Shared$Tag$View$view,
									5,
									A4($author$project$Components$Referentiel$TypesDeRelation$View$nomDuCoteSaisi, i18n, formes, saisie, 0)),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$relationDrawerVers(i18n))
										])),
									A2(
									$author$project$Components$Shared$Tag$View$view,
									5,
									A4(
										$author$project$Components$Referentiel$TypesDeRelation$View$nomDuCoteSaisi,
										i18n,
										formes,
										saisie,
										saisie.G6 ? 0 : 1))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$TypesDeRelation$Model$ModifierLePerimetre)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$relationDrawerModifierLePerimetre(i18n))
								]))
						]),
					function () {
						var _v0 = saisie.n9;
						if (_v0.$ === 1) {
							var relation = _v0.a;
							return (relation.Kg > 0) ? _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$relationPerimetreNote(i18n))
										]))
								]) : _List_Nil;
						} else {
							return _List_Nil;
						}
					}())));
	});
var $author$project$Components$Referentiel$TypesDeRelation$Model$Reciproque = function (a) {
	return {$: 0, a: a};
};
var $author$project$I18n$Cles$relationDrawerReciprocite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.reciprocite', _List_Nil, 'Réciprocité');
};
var $author$project$I18n$Cles$relationDrawerReciproque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.reciproque', _List_Nil, 'Réciproque');
};
var $author$project$I18n$Cles$relationDrawerReciproqueAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.reciproque.aide', _List_Nil, 'Cochez si le lien se dit pareil dans les deux sens (« partenaire de »). Un seul nom suffit alors.');
};
var $author$project$Components$Referentiel$TypesDeRelation$View$reciprocite = F3(
	function (i18n, prefixe, saisie) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('reciprocite')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$relationDrawerReciprocite(i18n))
						])),
					A2(
					$author$project$Components$Shared$Champ$View$caseACocher,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: prefixe + '-reciproque',
						Bl: $author$project$I18n$Cles$relationDrawerReciproque(i18n),
						he: false
					},
					{vt: saisie.G6, D9: $author$project$Components$Referentiel$TypesDeRelation$Model$Reciproque}),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$relationDrawerReciproqueAide(i18n))
						]))
				]));
	});
var $author$project$Components$Referentiel$TypesDeRelation$View$refusEnMessage = function (refus) {
	if ((!refus.$) && (refus.a.$ === 1)) {
		var dit = refus.a.a;
		return _List_fromArray(
			[
				{Jx: dit, b9: $elm$core$Maybe$Nothing}
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Referentiel$TypesDeRelation$View$formulaire = F4(
	function (i18n, prefixe, formes, saisie) {
		var _v0 = saisie.n9;
		if (!_v0.$) {
			return _List_fromArray(
				[
					A3($author$project$Components$Referentiel$TypesDeRelation$View$reciprocite, i18n, prefixe, saisie),
					A3($author$project$Components$Referentiel$TypesDeRelation$View$nomsDeLaCreation, i18n, prefixe, saisie),
					A5($author$project$Components$Referentiel$TypesDeRelation$View$qui, i18n, prefixe, formes, saisie, true),
					A2($author$project$Components$Referentiel$TypesDeRelation$View$apercuDuType, i18n, saisie),
					A2(
					$author$project$Components$Shared$Messages$View$view,
					i18n,
					$author$project$Components$Referentiel$TypesDeRelation$View$refusEnMessage(saisie.pZ))
				]);
		} else {
			var relation = _v0.a;
			return _List_fromArray(
				[
					A3($author$project$Components$Referentiel$TypesDeRelation$View$nomsDuType, i18n, saisie, relation),
					A5($author$project$Components$Referentiel$TypesDeRelation$View$qui, i18n, prefixe, formes, saisie, saisie.eD),
					A2($author$project$Components$Referentiel$TypesDeRelation$View$apercuDuType, i18n, saisie),
					A2(
					$author$project$Components$Shared$Messages$View$view,
					i18n,
					$author$project$Components$Referentiel$TypesDeRelation$View$refusEnMessage(saisie.pZ))
				]);
		}
	});
var $author$project$I18n$Cles$relationDrawerCreer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.creer', _List_Nil, 'Créer le type');
};
var $author$project$I18n$Cles$relationDrawerKickerCreation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.kicker-creation', _List_Nil, 'Nouveau type');
};
var $author$project$I18n$Cles$relationDrawerKickerType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.kicker-type', _List_Nil, 'Type de relation');
};
var $author$project$I18n$Cles$relationDrawerTitreCreation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.titre-creation', _List_Nil, 'Ajouter un type de relation');
};
var $author$project$Components$Referentiel$TypesDeRelation$View$drawer = F2(
	function (i18n, model) {
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.kX);
		var modification = function () {
			var _v1 = model.hP.n9;
			if (_v1.$ === 1) {
				var relation = _v1.a;
				return $elm$core$Maybe$Just(relation);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$TypesDeRelation$Update$DuDrawer,
			{
				fs: {
					sR: !$author$project$Components$Referentiel$TypesDeRelation$Model$estEnvoi(model),
					Bl: _Utils_eq(modification, $elm$core$Maybe$Nothing) ? $author$project$I18n$Cles$relationDrawerCreer(i18n) : $author$project$I18n$Cles$relationDrawerEnregistrer(i18n),
					C$: $author$project$Components$Referentiel$TypesDeRelation$Update$EnregistrementDemande
				},
				fZ: _Utils_ap(
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Referentiel$TypesDeRelation$Update$Saisi),
						A4($author$project$Components$Referentiel$TypesDeRelation$View$formulaire, i18n, prefixe, model.zS, model.hP)),
					A2($author$project$Components$Referentiel$TypesDeRelation$View$archivage, i18n, modification)),
				A6: $elm$core$Maybe$Just(
					_Utils_eq(modification, $elm$core$Maybe$Nothing) ? $author$project$I18n$Cles$relationDrawerKickerCreation(i18n) : $author$project$I18n$Cles$relationDrawerKickerType(i18n)),
				Bc: false,
				h6: function () {
					if (!modification.$) {
						var relation = modification.a;
						return relation.Bn.zX;
					} else {
						return $author$project$I18n$Cles$relationDrawerTitreCreation(i18n);
					}
				}()
			},
			model.kX);
	});
var $author$project$Components$Referentiel$TypesDeRelation$Model$DirectEn = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$TypesDeRelation$Model$InverseEn = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Referentiel$TypesDeRelation$View$nomEnDeuxLangues = F7(
	function (i18n, prefixe, saisie, fr, en, surFr, surEn) {
		return A3(
			$author$project$Components$Shared$LibellesParLangue$View$view,
			i18n,
			_List_Nil,
			{
				go: function (code) {
					return (code === 'fr') ? A3($author$project$Components$Referentiel$TypesDeRelation$View$erreurDeLibelle, i18n, saisie, fr) : $elm$core$Maybe$Nothing;
				},
				Ba: $author$project$Referentiel$Langues$desLibelles,
				Bl: $author$project$I18n$Cles$relationDrawerNom(i18n),
				hg: F2(
					function (code, saisi) {
						return (code === 'fr') ? surFr(saisi) : surEn(saisi);
					}),
				pv: prefixe,
				fm: function (code) {
					return (code === 'fr') ? fr : en;
				}
			});
	});
var $author$project$I18n$Cles$relationDrawerNomAutreSensEn = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.drawer.nom-autre-sens-en', _List_Nil, 'Nom en anglais dans l\'autre sens');
};
var $author$project$Components$Referentiel$TypesDeRelation$View$drawerDesNoms = F2(
	function (i18n, model) {
		var saisie = model.hP;
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.DG);
		var ouvert = $author$project$Components$Shared$Drawer$Model$estOuvert(model.DG);
		var sens = ouvert ? saisie.bO : $elm$core$Maybe$Nothing;
		var champs = function () {
			var _v5 = _Utils_Tuple2(sens, saisie.n9);
			if (!_v5.a.$) {
				if (!_v5.b.$) {
					var _v6 = _v5.b;
					return A2(
						$elm$core$List$cons,
						A6(
							$author$project$Components$Referentiel$TypesDeRelation$View$texte,
							prefixe + '-direct-en',
							$author$project$I18n$Cles$relationDrawerNomEn(i18n),
							false,
							$elm$core$Maybe$Nothing,
							saisie.cA,
							$author$project$Components$Referentiel$TypesDeRelation$Model$DirectEn),
						saisie.G6 ? _List_Nil : _List_fromArray(
							[
								A6(
								$author$project$Components$Referentiel$TypesDeRelation$View$texte,
								prefixe + '-inverse-en',
								$author$project$I18n$Cles$relationDrawerNomAutreSensEn(i18n),
								false,
								$elm$core$Maybe$Nothing,
								saisie.cP,
								$author$project$Components$Referentiel$TypesDeRelation$Model$InverseEn)
							]));
				} else {
					if (!_v5.a.a) {
						var _v7 = _v5.a.a;
						return _List_fromArray(
							[
								A7($author$project$Components$Referentiel$TypesDeRelation$View$nomEnDeuxLangues, i18n, prefixe, saisie, saisie.cB, saisie.cA, $author$project$Components$Referentiel$TypesDeRelation$Model$DirectFr, $author$project$Components$Referentiel$TypesDeRelation$Model$DirectEn)
							]);
					} else {
						var _v8 = _v5.a.a;
						return _List_fromArray(
							[
								A7($author$project$Components$Referentiel$TypesDeRelation$View$nomEnDeuxLangues, i18n, prefixe, saisie, saisie.cQ, saisie.cP, $author$project$Components$Referentiel$TypesDeRelation$Model$InverseFr, $author$project$Components$Referentiel$TypesDeRelation$Model$InverseEn)
							]);
					}
				}
			} else {
				var _v9 = _v5.a;
				return _List_Nil;
			}
		}();
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$TypesDeRelation$Update$DesNoms,
			{
				fs: {
					sR: !$elm$core$List$isEmpty(champs),
					Bl: $elm$core$List$isEmpty(champs) ? '' : $author$project$I18n$Cles$relationDrawerNomsValider(i18n),
					C$: $author$project$Components$Referentiel$TypesDeRelation$Update$DesNoms($author$project$Components$Shared$Drawer$Update$Fermer)
				},
				fZ: A2(
					$elm$core$List$map,
					$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Referentiel$TypesDeRelation$Update$Saisi),
					champs),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: function () {
					var _v0 = _Utils_Tuple2(sens, saisie.n9);
					if (!_v0.a.$) {
						if (_v0.b.$ === 1) {
							if (!_v0.a.a) {
								var _v1 = _v0.a.a;
								return A2(
									$author$project$I18n$Cles$relationDrawerRenommerDe,
									i18n,
									{Dj: saisie.cB});
							} else {
								var _v2 = _v0.a.a;
								return A2(
									$author$project$I18n$Cles$relationDrawerRenommerDe,
									i18n,
									{Dj: saisie.cQ});
							}
						} else {
							var _v3 = _v0.b;
							return $author$project$I18n$Cles$relationDrawerTraduire(i18n);
						}
					} else {
						var _v4 = _v0.a;
						return '';
					}
				}()
			},
			model.DG);
	});
var $author$project$I18n$Cles$relationEtapeExplicationDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.etape.explication.debut', _List_Nil, 'Une ');
};
var $author$project$I18n$Cles$relationEtapeExplicationFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.etape.explication.fin', _List_Nil, ' relie deux fiches : une société et sa filiale, un client et celui qui l\'a recommandé. Vous choisissez quels liens existent, et entre quelles fiches.');
};
var $author$project$I18n$Cles$relationEtapeExplicationFort = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.etape.explication.fort', _List_Nil, 'relation');
};
var $author$project$I18n$Cles$relationEtapeNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.etape.note', _List_Nil, 'Cliquez un type pour régler ses noms et les fiches concernées de chaque côté. Un type déjà utilisé ne se supprime pas : on l\'archive, les liens existants restent affichés.');
};
var $author$project$I18n$Cles$relationEtapeQuestion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.etape.question', _List_Nil, 'Comment sont-elles liées entre elles ?');
};
var $author$project$Components$Referentiel$TypesDeRelation$Update$CreationOuverte = {$: 9};
var $author$project$I18n$Cles$relationEtapeAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.etape.ajouter', _List_Nil, 'Ajouter : Type de relation');
};
var $author$project$Components$Referentiel$TypesDeRelation$View$ajouter = F2(
	function (i18n, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$creerUnTypeDeRelation)),
			model.aS);
		if (!_v0.$) {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$TypesDeRelation$Model$idDeLaCreation),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$TypesDeRelation$Update$CreationOuverte)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$relationEtapeAjouter(i18n))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Referentiel$TypesDeRelation$Update$ArchivesChoisies = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Referentiel$TypesDeRelation$Model$archivesLues = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ib;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$filter(
						function ($) {
							return $.tE;
						}),
					$elm$core$List$length)),
			model.aS));
};
var $author$project$Components$Referentiel$TypesDeRelation$View$idDesArchives = 'types-de-relation-archives';
var $author$project$I18n$Cles$relationArchivesAfficher = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'relation.archives.afficher',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' archivé') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' archivés'));
	});
var $author$project$I18n$Cles$relationArchivesMasquer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.archives.masquer', _List_Nil, 'Masquer les archivés');
};
var $author$project$Components$Referentiel$TypesDeRelation$View$archives = F2(
	function (i18n, model) {
		var nombre = $author$project$Components$Referentiel$TypesDeRelation$Model$archivesLues(model);
		return (!nombre) ? _List_Nil : _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
						$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$TypesDeRelation$View$idDesArchives),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-expanded',
						model.i$ ? 'true' : 'false'),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Referentiel$TypesDeRelation$Update$ArchivesChoisies(!model.i$))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						model.i$ ? $author$project$I18n$Cles$relationArchivesMasquer(i18n) : A2(
							$author$project$I18n$Cles$relationArchivesAfficher,
							i18n,
							{w: nombre}))
					]))
			]);
	});
var $author$project$Components$Referentiel$TypesDeRelation$Update$ModificationOuverte = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Referentiel$TypesDeRelation$Update$RestaurationDemandee = function (a) {
	return {$: 14, a: a};
};
var $author$project$I18n$Cles$relationArchive = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.archive', _List_Nil, 'archivé');
};
var $author$project$I18n$Cles$relationEtapeDe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.etape.de', _List_Nil, 'De');
};
var $author$project$I18n$Cles$relationEtapeLiens = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'relation.etape.liens',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' lien') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' liens'));
	});
var $author$project$I18n$Cles$relationEtapeReciproque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.etape.reciproque', _List_Nil, 'Réciproque');
};
var $author$project$I18n$Cles$relationEtapeUnSeulSens = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.etape.un-seul-sens', _List_Nil, 'Un seul sens');
};
var $author$project$I18n$Cles$relationEtapeVers = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.etape.vers', _List_Nil, 'vers');
};
var $author$project$I18n$Cles$relationRestaurer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.restaurer', _List_Nil, 'Restaurer');
};
var $author$project$Components$Referentiel$TypesDeRelation$View$cartouche = F3(
	function (i18n, formes, relation) {
		var corps = _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('noms')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('libelles')
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(relation.Bn.zX)
									])),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (inverse) {
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('inverse')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(inverse.zX)
													]))
											]);
									},
									relation.Bo)))),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('liens')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$relationEtapeLiens,
									i18n,
									{w: relation.Kg}))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('sens')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$relationEtapeDe(i18n))
							])),
						A2(
						$author$project$Components$Shared$Tag$View$view,
						3,
						A3($author$project$Components$Referentiel$TypesDeRelation$View$nomDuCote, i18n, formes, relation.IR)),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$relationEtapeVers(i18n))
							])),
						A2(
						$author$project$Components$Shared$Tag$View$view,
						3,
						A3(
							$author$project$Components$Referentiel$TypesDeRelation$View$nomDuCote,
							i18n,
							formes,
							A2($elm$core$Maybe$withDefault, relation.IR, relation.vf))),
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('reciproque', relation.G6)
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								relation.G6 ? $author$project$I18n$Cles$relationEtapeReciproque(i18n) : $author$project$I18n$Cles$relationEtapeUnSeulSens(i18n))
							]))
					]))
			]);
		return relation.tE ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne-de-relation'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('archive')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('tag-archive')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$relationArchive(i18n))
								])),
						corps)),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					function () {
						var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$restaurerLeTypeDeRelation, relation.nQ);
						if (!_v0.$) {
							return _List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Referentiel$TypesDeRelation$Update$RestaurationDemandee(relation.Aq))
										]),
									$author$project$I18n$Cles$relationRestaurer(i18n))
								]);
						} else {
							return _List_Nil;
						}
					}())
				])) : ($author$project$Components$Referentiel$TypesDeRelation$Model$modifiable(relation) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne-de-relation')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(
							$author$project$Components$Referentiel$TypesDeRelation$Model$idDuModifier(relation.Aq)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Referentiel$TypesDeRelation$Update$ModificationOuverte(relation.Aq))
						]),
					corps)
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne-de-relation')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne')
						]),
					corps)
				])));
	});
var $author$project$I18n$Cles$relationEtapeAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.etape.aucun', _List_Nil, 'Aucun type de relation.');
};
var $author$project$I18n$Cles$relationEtapeTypes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.etape.types', _List_Nil, 'Types de relation');
};
var $author$project$Components$Referentiel$TypesDeRelation$Model$libellesDe = function (l) {
	return A2(
		$elm$core$List$cons,
		l.zX,
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Maybe$map, $elm$core$List$singleton, l.yg)));
};
var $author$project$Components$Referentiel$TypesDeRelation$Model$visibles = function (model) {
	var terme = $elm$core$String$toLower(
		$elm$core$String$trim(model.hC));
	var porte = function (libelle) {
		return A2(
			$elm$core$String$contains,
			terme,
			$elm$core$String$toLower(libelle));
	};
	var correspond = function (type_) {
		return (terme === '') || A2(
			$elm$core$List$any,
			porte,
			_Utils_ap(
				$author$project$Components$Referentiel$TypesDeRelation$Model$libellesDe(type_.Bn),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $author$project$Components$Referentiel$TypesDeRelation$Model$libellesDe, type_.Bo))));
	};
	return A2(
		$elm$core$List$filter,
		function (type_) {
			return (model.i$ || (!type_.tE)) && correspond(type_);
		},
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ib;
				},
				model.aS)));
};
var $author$project$Components$Referentiel$TypesDeRelation$View$types = F2(
	function (i18n, model) {
		var listes = $author$project$Components$Referentiel$TypesDeRelation$Model$visibles(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('relations')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$relationEtapeTypes(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
						]),
					((!_Utils_eq(model.aS, $elm$core$Maybe$Nothing)) && $elm$core$List$isEmpty(listes)) ? _List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$relationEtapeAucun(i18n))
						]) : _List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('types-de-relation'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'loading',
									_Utils_eq(model.aS, $elm$core$Maybe$Nothing))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-busy',
							_Utils_eq(model.aS, $elm$core$Maybe$Nothing) ? 'true' : 'false')
						]),
					A2(
						$elm$core$List$map,
						function (relation) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('item')
									]),
								_List_fromArray(
									[
										A3($author$project$Components$Referentiel$TypesDeRelation$View$cartouche, i18n, model.zS, relation)
									]));
						},
						listes)),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('archives')
						]),
					A2($author$project$Components$Referentiel$TypesDeRelation$View$archives, i18n, model)),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ajouter')
						]),
					A2($author$project$Components$Referentiel$TypesDeRelation$View$ajouter, i18n, model))
				]));
	});
var $author$project$Components$Referentiel$TypesDeRelation$View$etape = F6(
	function (i18n, lever, habillage, messages, complement, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'referentiel-types-list',
			{
				ut: _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Parcours$View$etapes,
						i18n,
						$author$project$Components$Referentiel$TypesDeRelation$View$avecLesEtapesPrecedentesFaites(habillage.ex),
						6),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						_List_fromArray(
							[
								A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
								A4(
								$author$project$Components$Shared$Parcours$View$etape,
								habillage.ex,
								6,
								6,
								{
									fZ: _Utils_ap(
										complement.je,
										A2(
											$elm$core$List$cons,
											A2(
												$rtfeldman$elm_css$Html$Styled$map,
												lever,
												A2($author$project$Components$Referentiel$TypesDeRelation$View$types, i18n, model)),
											_Utils_ap(
												complement.hT,
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$p,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$relationEtapeNote(i18n))
															]))
													])))),
									y8: _List_fromArray(
										[
											$author$project$Components$Shared$Parcours$Model$Texte(
											$author$project$I18n$Cles$relationEtapeExplicationDebut(i18n)),
											$author$project$Components$Shared$Parcours$Model$Fort(
											$author$project$I18n$Cles$relationEtapeExplicationFort(i18n)),
											$author$project$Components$Shared$Parcours$Model$Texte(
											$author$project$I18n$Cles$relationEtapeExplicationFin(i18n))
										]),
									GJ: $author$project$I18n$Cles$relationEtapeQuestion(i18n)
								}),
								A3($author$project$Components$Shared$Parcours$View$pied, i18n, habillage.ex, 6)
							])),
						A3(
						$author$project$Components$Shared$Parcours$View$apercu,
						i18n,
						$author$project$I18n$Cles$referentielParcoursApercu(i18n),
						A3($author$project$Components$Referentiel$TypesDeRelation$View$apercu, i18n, complement.tq, model))
					]),
				xy: _Utils_ap(
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$map,
							lever,
							A2($author$project$Components$Referentiel$TypesDeRelation$View$drawer, i18n, model)),
							A2(
							$rtfeldman$elm_css$Html$Styled$map,
							lever,
							A2($author$project$Components$Referentiel$TypesDeRelation$View$drawerDesNoms, i18n, model))
						]),
					complement.xy),
				zM: _List_Nil,
				AK: $author$project$Components$Referentiel$TypesDeRelation$View$dialogueOuvert(model) || complement.AK,
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(habillage.dH)
									]))
							]),
						zE: habillage.zE,
						Ef: _List_Nil,
						h6: habillage.h6
					})
			});
	});
var $author$project$Components$Produits$Catalogue$Update$CreationDemandee = {$: 34};
var $author$project$Components$Produits$Catalogue$Update$Saisi = function (a) {
	return {$: 33, a: a};
};
var $author$project$Catalogue$Chemin$colonnes = function (chemin) {
	var etages = chemin.a;
	var noeuds = chemin.b;
	var proposes = F3(
		function (premier, etage, dessus) {
			return A2(
				$elm$core$List$filter,
				function (n) {
					if (!dessus.$) {
						var choisi = dessus.a;
						return _Utils_eq(
							n.ey,
							$elm$core$Maybe$Just(choisi.Aq));
					} else {
						return premier;
					}
				},
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.md;
						},
						$elm$core$Basics$eq(etage.Aq)),
					noeuds));
		});
	var suite = F3(
		function (premier, restants, dessus) {
			if (!restants.b) {
				return _List_Nil;
			} else {
				var etage = restants.a;
				var plus = restants.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						etage,
						A3(proposes, premier, etage, dessus)),
					A3(
						suite,
						false,
						plus,
						A2($author$project$Catalogue$Chemin$choisiSur, chemin, etage)));
			}
		});
	return A3(
		suite,
		true,
		$author$project$Catalogue$Chemin$duChemin(etages),
		$elm$core$Maybe$Nothing);
};
var $author$project$Components$Produits$Catalogue$View$enCreation = function (model) {
	var _v0 = _Utils_Tuple2(
		$author$project$Components$Produits$Catalogue$Model$creable(model),
		model.hA);
	if ((!_v0.a.$) && (_v0.b.$ === 1)) {
		var catalogue = _v0.a.a;
		var _v1 = _v0.b;
		return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) ? $elm$core$Maybe$Just(catalogue) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Catalogue$Chemin$categorie = function (_v0) {
	var etages = _v0.a;
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.xt;
		},
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function ($) {
					return $.dS;
				},
				etages)));
};
var $author$project$Components$Produits$Catalogue$Creation$etageManquantDuChemin = function (saisie) {
	var _v0 = saisie.r3;
	if (_v0.$ === 1) {
		return $elm$core$Maybe$Nothing;
	} else {
		var typologie = _v0.a;
		var _v1 = $author$project$Catalogue$Chemin$etagesManquants(typologie.jK);
		if (_v1.b) {
			var premier = _v1.a;
			return $elm$core$Maybe$Just(premier);
		} else {
			return _Utils_eq(saisie.fh, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
				A2(
					$elm$core$Maybe$withDefault,
					$author$project$I18n$Traductions$tel(''),
					$author$project$Catalogue$Chemin$categorie(typologie.jK))) : $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$Components$Produits$Catalogue$Creation$etageManquant = function (saisie) {
	var _v0 = saisie.r3;
	if (_v0.$ === 1) {
		return $elm$core$Maybe$Nothing;
	} else {
		return $author$project$Catalogue$Vocabulaire$estUnService(saisie.g1) ? $elm$core$Maybe$Nothing : $author$project$Components$Produits$Catalogue$Creation$etageManquantDuChemin(saisie);
	}
};
var $author$project$Components$Produits$Catalogue$Creation$Code = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Produits$Catalogue$Creation$Ean = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Produits$Catalogue$Creation$Etat = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Produits$Catalogue$Creation$Millesime = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Produits$Catalogue$Creation$Nature = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$Catalogue$Creation$Nom = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Produits$Catalogue$Creation$Rattachement = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Produits$Catalogue$Creation$Type = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$Catalogue$Creation$Variante = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Produits$Catalogue$Creation$NomDuProduit = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Produits$Catalogue$Creation$Parent = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Produits$Catalogue$Creation$Produit = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$Catalogue$Model$libelleDeLArchetype = F4(
	function (i18n, estLui, parDefaut, catalogue) {
		return A2(
			$elm$core$Maybe$withDefault,
			parDefaut,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Catalogue$Niveau$libelleDuNiveau,
					$author$project$I18n$Cles$texte(i18n)),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.fA;
							},
							estLui),
						catalogue.C9))));
	});
var $author$project$I18n$Cles$produitsArchetypeProduit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.archetype.produit', _List_Nil, 'Produit');
};
var $author$project$Components$Produits$Catalogue$Model$libelleDuProduit = function (i18n) {
	return A3(
		$author$project$Components$Produits$Catalogue$Model$libelleDeLArchetype,
		i18n,
		$author$project$Catalogue$Vocabulaire$estUnProduit,
		$author$project$I18n$Cles$produitsArchetypeProduit(i18n));
};
var $author$project$I18n$Cles$produitsCatalogueChampMillesimeInvalide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.champ.millesime.invalide', _List_Nil, 'Le millésime est une année sur quatre chiffres.');
};
var $author$project$I18n$Cles$produitsReferencesCreationEanInvalide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.ean.invalide', _List_Nil, 'L\'EAN compte treize chiffres, clé de contrôle comprise.');
};
var $author$project$I18n$Cles$saisieDeChampObligatoire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'saisie-de-champ.obligatoire', _List_Nil, 'Ce champ est obligatoire.');
};
var $author$project$Components$Produits$Catalogue$Creation$erreur = F4(
	function (i18n, catalogue, saisie, zone) {
		var duBack = A2(
			$elm$core$Maybe$map,
			$author$project$I18n$Cles$texte(i18n),
			A2(
				$elm$core$Maybe$andThen,
				function (_v1) {
					var fautive = _v1.a;
					var texte = _v1.b;
					return _Utils_eq(fautive, zone) ? $elm$core$Maybe$Just(texte) : $elm$core$Maybe$Nothing;
				},
				saisie.bf));
		return (saisie.b5 && A2(
			$elm$core$List$member,
			zone,
			A2($author$project$Components$Produits$Catalogue$Creation$fautes, catalogue, saisie))) ? $elm$core$Maybe$Just(
			function () {
				switch (zone.$) {
					case 9:
						return $author$project$I18n$Cles$produitsReferencesCreationEanInvalide(i18n);
					case 10:
						return $author$project$I18n$Cles$produitsCatalogueChampMillesimeInvalide(i18n);
					default:
						return $author$project$I18n$Cles$saisieDeChampObligatoire(i18n);
				}
			}()) : duBack;
	});
var $author$project$Components$Produits$Common$LibellesSaisis$manque = F3(
	function (tentee, libelles, code) {
		return tentee && A2(
			$elm$core$List$member,
			code,
			A2($author$project$Components$Shared$LibellesParLangue$Model$manquantes, $author$project$Referentiel$Langues$desLibelles, libelles));
	});
var $author$project$Components$Produits$Catalogue$Creation$erreurDUneLangue = F5(
	function (i18n, catalogue, saisie, zone, code) {
		var saisis = _Utils_eq(zone, $author$project$Components$Produits$Catalogue$Creation$ZoneNomDuProduit) ? saisie.aF : saisie.Dj;
		return _Utils_eq(
			$author$project$Components$Produits$Common$LibellesSaisis$premiereObligatoire,
			$elm$core$Maybe$Just(code)) ? A4($author$project$Components$Produits$Catalogue$Creation$erreur, i18n, catalogue, saisie, zone) : ((A3($author$project$Components$Produits$Common$LibellesSaisis$manque, saisie.b5, saisis, code) && A2(
			$elm$core$List$member,
			zone,
			A2($author$project$Components$Produits$Catalogue$Creation$fautes, catalogue, saisie))) ? $elm$core$Maybe$Just(
			$author$project$I18n$Cles$saisieDeChampObligatoire(i18n)) : $elm$core$Maybe$Nothing);
	});
var $author$project$Components$Produits$Catalogue$View$parLangue = F7(
	function (i18n, model, catalogue, zone, libelle, saisis, versChamp) {
		return A3(
			$author$project$Components$Shared$LibellesParLangue$View$view,
			i18n,
			_List_Nil,
			{
				go: A4($author$project$Components$Produits$Catalogue$Creation$erreurDUneLangue, i18n, catalogue, model.hP, zone),
				Ba: $author$project$Referentiel$Langues$desLibelles,
				Bl: libelle,
				hg: versChamp,
				pv: A2(
					$author$project$Components$Produits$Catalogue$Creation$prefixeDesLangues,
					$author$project$Components$Shared$Drawer$Model$idRacine(model.kX),
					zone),
				fm: function (code) {
					return A2($author$project$Components$Shared$LibellesParLangue$Model$lire, code, saisis);
				}
			});
	});
var $author$project$I18n$Cles$produitsReferencesCreationNomDuProduit = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.creation.nom-du-produit',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'niveau',
					$author$project$I18n$Traductions$Chaine(p.os))
				]),
			'Nom — ' + $elm$core$String$toLower(p.os));
	});
var $author$project$I18n$Cles$produitsReferencesCreationRattachement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.rattachement', _List_Nil, 'Rattachement');
};
var $author$project$I18n$Cles$produitsReferencesCreationSurPlace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.sur-place', _List_Nil, 'Créer sur place…');
};
var $author$project$I18n$Cles$produitsReferencesCreationTypeDuProduit = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.creation.type-du-produit',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'version',
					$author$project$I18n$Traductions$Chaine(p.sq))
				]),
			p.Dj + (' (informations v' + (p.sq + ')')));
	});
var $author$project$Components$Produits$Catalogue$View$choixDuProduit = F7(
	function (i18n, model, catalogue, champ, aucun, element, types) {
		var saisie = model.hP;
		var typeDuProduit = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (type_) {
					return A2(
						$author$project$I18n$Cles$produitsReferencesCreationTypeDuProduit,
						i18n,
						{
							Dj: type_.Dj.zX,
							sq: $elm$core$String$fromInt(type_.sq)
						});
				},
				A2(
					$elm$core$Maybe$andThen,
					function (id) {
						return $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.Aq;
									},
									$elm$core$Basics$eq(id)),
								catalogue.ib));
					},
					A2($author$project$Components$Produits$Catalogue$Creation$typeRetenu, catalogue, saisie))));
		var niveau = A2($author$project$Components$Produits$Catalogue$Model$libelleDuProduit, i18n, catalogue);
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Components$Shared$Champ$View$liste,
				A3(champ, $author$project$Components$Produits$Catalogue$Creation$ZoneProduit, niveau, true),
				{
					hg: $author$project$Components$Produits$Catalogue$Creation$Produit,
					o_: A2(
						$elm$core$List$cons,
						aucun,
						_Utils_ap(
							A2(
								$elm$core$List$map,
								function (existant) {
									return {
										Bl: existant.R.zX,
										fm: $author$project$Catalogue$Identifiants$elementIdToString(existant.Aq)
									};
								},
								A2($author$project$Components$Produits$Catalogue$Creation$produitsProposes, catalogue, saisie)),
							_List_fromArray(
								[
									{
									Bl: $author$project$I18n$Cles$produitsReferencesCreationSurPlace(i18n),
									fm: $author$project$Components$Produits$Catalogue$Creation$nouveauProduit
								}
								]))),
					fm: function () {
						var _v0 = saisie.Gp;
						switch (_v0.$) {
							case 0:
								return '';
							case 1:
								var choisi = _v0.a;
								return $author$project$Catalogue$Identifiants$elementIdToString(choisi);
							default:
								return $author$project$Components$Produits$Catalogue$Creation$nouveauProduit;
						}
					}()
				}),
			function () {
				var _v1 = saisie.Gp;
				if (_v1.$ === 2) {
					return _Utils_ap(
						_List_fromArray(
							[
								A7(
								$author$project$Components$Produits$Catalogue$View$parLangue,
								i18n,
								model,
								catalogue,
								$author$project$Components$Produits$Catalogue$Creation$ZoneNomDuProduit,
								A2(
									$author$project$I18n$Cles$produitsReferencesCreationNomDuProduit,
									i18n,
									{os: niveau}),
								saisie.aF,
								$author$project$Components$Produits$Catalogue$Creation$NomDuProduit),
								types
							]),
						function () {
							var _v2 = _Utils_Tuple2(saisie.r7, catalogue.pN.EY);
							if ((!_v2.a.b) && (!_v2.b.$)) {
								var attendu = _v2.b.a;
								return _List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Champ$View$liste,
										A3(
											champ,
											$author$project$Components$Produits$Catalogue$Creation$ZoneParent,
											A2(
												$elm$core$Maybe$withDefault,
												$author$project$I18n$Cles$produitsReferencesCreationRattachement(i18n),
												A2(
													$elm$core$Maybe$map,
													A2(
														$elm$core$Basics$composeR,
														$author$project$Catalogue$Niveau$libelleDuNiveau,
														$author$project$I18n$Cles$texte(i18n)),
													$elm$core$List$head(
														A2(
															$elm$core$List$filter,
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.Aq;
																},
																$elm$core$Basics$eq(attendu)),
															catalogue.C9)))),
											true),
										{
											hg: $author$project$Components$Produits$Catalogue$Creation$Parent,
											o_: A2(
												$elm$core$List$cons,
												aucun,
												element(
													A2($author$project$Components$Produits$Catalogue$Creation$parents, catalogue, model.aV))),
											fm: A2(
												$elm$core$Maybe$withDefault,
												'',
												A2($elm$core$Maybe$map, $author$project$Catalogue$Identifiants$elementIdToString, saisie.ey))
										})
									]);
							} else {
								return _List_Nil;
							}
						}());
				} else {
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(typeDuProduit)
								]))
						]);
				}
			}());
	});
var $author$project$Catalogue$Vocabulaire$estUnTypeDeProduit = function (code) {
	return code === 'type-de-produit';
};
var $author$project$Components$Produits$Catalogue$Model$libelleDeLEtat = F3(
	function (i18n, etats, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2(
				$author$project$I18n$Cles$texte,
				i18n,
				$author$project$Catalogue$Vocabulaire$etat(
					$author$project$Catalogue$Identifiants$etatCodeToString(code))),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.zX;
				},
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.R;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.vx;
								},
								$elm$core$Basics$eq(code)),
							etats)))));
	});
var $author$project$Catalogue$Vocabulaire$naturesProposees = F2(
	function (i18n, servies) {
		return $elm$core$List$isEmpty(servies) ? A2(
			$elm$core$List$map,
			function (code) {
				return {
					Bl: A2(
						$author$project$I18n$Cles$texte,
						i18n,
						$author$project$Catalogue$Vocabulaire$nature(code)),
					fm: code
				};
			},
			$author$project$Catalogue$Vocabulaire$naturesDArticle) : A2(
			$elm$core$List$map,
			function (_v0) {
				var code = _v0.a;
				var saisi = _v0.b;
				return {
					Bl: A2(
						$author$project$I18n$Cles$texte,
						i18n,
						A2($author$project$Catalogue$Vocabulaire$natureNommee, saisi, code)),
					fm: code
				};
			},
			servies);
	});
var $author$project$Components$Produits$Catalogue$Creation$CodeRevenu = {$: 11};
var $author$project$I18n$Cles$produitsReferencesCreationCodeAMain = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.code-a-main', _List_Nil, 'À la main');
};
var $author$project$I18n$Cles$produitsReferencesCreationCodeNumero = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.code-numero', _List_Nil, 'Numéro attribué à l\'enregistrement. Un code tapé à la main ne consomme aucun numéro.');
};
var $author$project$I18n$Cles$produitsReferencesCreationCodePropose = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.code-propose', _List_Nil, 'Proposé par la règle');
};
var $author$project$I18n$Cles$produitsReferencesCreationCodeRevenir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.code-revenir', _List_Nil, 'Revenir au code proposé');
};
var $rtfeldman$elm_css$Html$Styled$b = $rtfeldman$elm_css$Html$Styled$node('b');
var $author$project$I18n$Cles$produitsReferencesCreationSiLaRegleALaMain = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.si-la-regle.a-la-main', _List_Nil, 'Code modifié à la main');
};
var $author$project$I18n$Cles$produitsReferencesCreationSiLaRegleALaMainTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.si-la-regle.a-la-main-texte', _List_Nil, 'Le code tapé est gardé tel quel ; « Revenir au code proposé » rend celui de la règle.');
};
var $author$project$I18n$Cles$produitsReferencesCreationSiLaRegleMarqueSansCode = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.si-la-regle.marque-sans-code', _List_Nil, 'Marque sans code');
};
var $author$project$I18n$Cles$produitsReferencesCreationSiLaRegleMarqueSansCodeTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.si-la-regle.marque-sans-code-texte', _List_Nil, 'Le code de référence reste vide et modifiable : le mode proposé ne bloque jamais, la référence se crée quand même.');
};
var $author$project$I18n$Cles$produitsReferencesCreationSiLaRegleTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.si-la-regle.titre', _List_Nil, 'Si la règle ne convient pas');
};
var $author$project$Components$Produits$Catalogue$View$siLaRegleNeConvientPas = function (i18n) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('si-la-regle-ne-convient-pas')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$h3,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsReferencesCreationSiLaRegleTitre(i18n))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$ul,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$b,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsReferencesCreationSiLaRegleMarqueSansCode(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsReferencesCreationSiLaRegleMarqueSansCodeTexte(i18n))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$b,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsReferencesCreationSiLaRegleALaMain(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsReferencesCreationSiLaRegleALaMainTexte(i18n))
									]))
							]))
					]))
			]));
};
var $author$project$Components$Produits$Catalogue$View$noteDuCode = F2(
	function (i18n, saisie) {
		var _v0 = saisie.dz;
		if (!_v0.$) {
			var propose = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('code-propose')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_Utils_eq(saisie.vx, propose) ? _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('tag')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsReferencesCreationCodePropose(i18n))
									]))
							]) : _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('tag')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsReferencesCreationCodeAMain(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('secondary'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Catalogue$Creation$CodeRevenu)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$produitsReferencesCreationCodeRevenir(i18n))
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('numero')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsReferencesCreationCodeNumero(i18n))
							])),
						$author$project$Components$Produits$Catalogue$View$siLaRegleNeConvientPas(i18n)
					]));
		} else {
			return saisie.hI ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('code-propose')
					]),
				_List_fromArray(
					[
						$author$project$Components$Produits$Catalogue$View$siLaRegleNeConvientPas(i18n)
					])) : A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('code-propose')
					]),
				_List_Nil);
		}
	});
var $author$project$I18n$Cles$produitsArchetypeTypeDeProduit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.archetype.type-de-produit', _List_Nil, 'Catégorie');
};
var $author$project$I18n$Cles$produitsCatalogueChampMillesime = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.champ.millesime', _List_Nil, 'Millésime');
};
var $author$project$I18n$Cles$produitsCatalogueChampNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.champ.nom', _List_Nil, 'Nom');
};
var $author$project$I18n$Cles$produitsCatalogueColonneEtat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.colonne.etat', _List_Nil, 'État');
};
var $author$project$I18n$Cles$produitsReferencesCarteVariante = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.carte.variante', _List_Nil, 'Variante');
};
var $author$project$I18n$Cles$produitsReferencesCreationAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.aucun', _List_Nil, 'Aucun');
};
var $author$project$I18n$Cles$produitsReferencesCreationCode = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.code', _List_Nil, 'Code');
};
var $author$project$I18n$Cles$produitsReferencesCreationEan = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.ean', _List_Nil, 'EAN');
};
var $author$project$I18n$Cles$produitsReferencesCreationNature = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.nature', _List_Nil, 'Nature');
};
var $author$project$I18n$Cles$produitsReferencesCreationProduitCree = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.creation.produit-cree',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'« ' + (p.Dj + ' » a été créé et reste choisi : seule la référence reste à créer.'));
	});
var $author$project$Components$Produits$Catalogue$Creation$Categorie = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Produits$Catalogue$Creation$ChoixDeNoeud = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Produits$Catalogue$Creation$ChoixDeTypologie = function (a) {
	return {$: 6, a: a};
};
var $author$project$Catalogue$Chemin$choisis = function (_v0) {
	var ids = _v0.c;
	return ids;
};
var $author$project$Catalogue$Chemin$dropWhileNot = F2(
	function (etage, reversed) {
		dropWhileNot:
		while (true) {
			if (!reversed.b) {
				return _List_Nil;
			} else {
				var premier = reversed.a;
				var suite = reversed.b;
				if (_Utils_eq(premier.Aq, etage.Aq)) {
					return A2($elm$core$List$take, 1, suite);
				} else {
					var $temp$etage = etage,
						$temp$reversed = suite;
					etage = $temp$etage;
					reversed = $temp$reversed;
					continue dropWhileNot;
				}
			}
		}
	});
var $author$project$Catalogue$Chemin$nomDuDessus = F2(
	function (chemin, etage) {
		var etages = chemin.a;
		var dessus = A2(
			$author$project$Catalogue$Chemin$dropWhileNot,
			etage,
			$elm$core$List$reverse(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dS;
						},
						$elm$core$Basics$not),
					etages)));
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.Dj;
			},
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Catalogue$Chemin$choisiSur(chemin),
				$elm$core$List$head(dessus)));
	});
var $author$project$Catalogue$Chemin$noms = function (chemin) {
	var etages = chemin.a;
	return $author$project$Catalogue$Chemin$complet(chemin) ? $elm$core$Maybe$Just(
		A2(
			$elm$core$List$map,
			function ($) {
				return $.Dj;
			},
			A2(
				$elm$core$List$filterMap,
				$author$project$Catalogue$Chemin$choisiSur(chemin),
				$author$project$Catalogue$Chemin$duChemin(etages)))) : $elm$core$Maybe$Nothing;
};
var $author$project$I18n$Cles$produitsReferencesCreationEtageDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.creation.etage-de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'· celles de « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$produitsReferencesCreationEtageManquant = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.creation.etage-manquant',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md))
				]),
			'Il reste à choisir : ' + (p.md + '.'));
	});
var $author$project$I18n$Cles$produitsReferencesCreationEtageVide = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.creation.etage-vide',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md)),
					_Utils_Tuple2(
					'dessus',
					$author$project$I18n$Traductions$Chaine(p.kL))
				]),
			'« ' + (p.md + (' » : aucune valeur sous « ' + (p.kL + ' ».'))));
	});
var $author$project$I18n$Cles$produitsReferencesCreationRangementAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.rangement-aide', _List_Nil, 'Cliquer de nouveau un choix le retire, et ceux qui en dépendent. Tant qu\'un étage reste à choisir, « Créer la référence » reste inactif.');
};
var $author$project$I18n$Cles$produitsReferencesCreationRangementObtenu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.rangement-obtenu', _List_Nil, 'Rangement obtenu :');
};
var $author$project$I18n$Cles$produitsReferencesCreationRangementSeparateur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.rangement-separateur', _List_Nil, ' › ');
};
var $author$project$I18n$Cles$produitsReferencesCreationTypologie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.typologie', _List_Nil, 'Typologie');
};
var $author$project$Components$Produits$Catalogue$Creation$rangementObtenu = function (saisie) {
	var categorie = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Dj;
				},
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.zX;
					},
					$elm$core$List$singleton)),
			A2(
				$elm$core$Maybe$andThen,
				function (id) {
					return $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(id)),
							saisie.dt));
				},
				saisie.fh)));
	return A2(
		$elm$core$Maybe$map,
		function (noms) {
			return _Utils_ap(noms, categorie);
		},
		A2(
			$elm$core$Maybe$andThen,
			function (typologie) {
				return $author$project$Catalogue$Chemin$noms(typologie.jK);
			},
			saisie.r3));
};
var $author$project$Components$Produits$Catalogue$View$rangementDe = F4(
	function (i18n, figee, model, catalogue) {
		var saisie = model.hP;
		var rangementObtenu = function (s) {
			var _v7 = $author$project$Components$Produits$Catalogue$Creation$rangementObtenu(s);
			if (!_v7.$) {
				var noms = _v7.a;
				return _List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsReferencesCreationRangementObtenu(i18n) + ' '),
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$elm$core$String$join,
									$author$project$I18n$Cles$produitsReferencesCreationRangementSeparateur(i18n),
									noms))
							]))
					]);
			} else {
				return _List_Nil;
			}
		};
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.kX);
		var resteACHoisir = A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('rangement-obtenu'),
					$rtfeldman$elm_css$Html$Styled$Attributes$id(
					A2($author$project$Components$Produits$Catalogue$Creation$idDe, prefixe, $author$project$Components$Produits$Catalogue$Creation$ZoneRangement)),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'tabindex', '-1')
				]),
			function (manquants) {
				return (_Utils_eq(manquants, _List_Nil) || $author$project$Catalogue$Vocabulaire$estUnService(saisie.g1)) ? _List_Nil : _List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$produitsReferencesCreationEtageManquant,
							i18n,
							{
								md: A2(
									$elm$core$String$join,
									', ',
									A2(
										$elm$core$List$map,
										$author$project$I18n$Cles$texte(i18n),
										manquants))
							}))
					]);
			}(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.jK;
							},
							$author$project$Catalogue$Chemin$etagesManquants),
						saisie.r3))));
		var manquantDe = function (manquant) {
			return A2(
				$author$project$I18n$Cles$produitsReferencesCreationEtageManquant,
				i18n,
				{
					md: A2($author$project$I18n$Cles$texte, i18n, manquant)
				});
		};
		var obtenu = A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('rangement-obtenu'),
					$rtfeldman$elm_css$Html$Styled$Attributes$id(
					A2($author$project$Components$Produits$Catalogue$Creation$idDe, prefixe, $author$project$Components$Produits$Catalogue$Creation$ZoneRangement)),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'tabindex', '-1')
				]),
			function () {
				var _v3 = _Utils_Tuple2(
					$author$project$Components$Produits$Catalogue$Creation$rangementObtenu(saisie),
					$author$project$Components$Produits$Catalogue$Creation$etageManquant(saisie));
				if (!_v3.a.$) {
					if (!_v3.b.$) {
						var manquant = _v3.b.a;
						return (saisie.cq && _Utils_eq(saisie.dt, _List_Nil)) ? _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								manquantDe(manquant))
							]) : rangementObtenu(saisie);
					} else {
						return rangementObtenu(saisie);
					}
				} else {
					if (!_v3.b.$) {
						var _v4 = _v3.a;
						var manquant = _v3.b.a;
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								manquantDe(manquant))
							]);
					} else {
						var _v5 = _v3.a;
						var _v6 = _v3.b;
						return _List_Nil;
					}
				}
			}());
		var ligne = F3(
			function (cle, libelle, boutons) {
				return A2(
					$author$project$Components$Shared$Champ$View$compose,
					{go: $elm$core$Maybe$Nothing, Aq: prefixe + ('-rangement-' + cle), Bl: libelle, he: true},
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('choix-etage'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'group'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', libelle)
								]),
							boutons)
						]));
			});
		var dernierNom = function (chemin) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$andThen,
					A2($elm$core$Basics$composeR, $elm$core$List$reverse, $elm$core$List$head),
					$author$project$Catalogue$Chemin$noms(chemin)));
		};
		var choix = F3(
			function (choisi, msg, libelle) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('choix'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('selected', choisi)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-pressed',
							choisi ? 'true' : 'false'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						]));
			});
		var etages = function (typologie) {
			return A2(
				$elm$core$List$map,
				function (_v0) {
					var etage = _v0.a;
					var noeuds = _v0.b;
					return A3(
						ligne,
						etage.Aq,
						function () {
							var _v1 = A2($author$project$Catalogue$Chemin$nomDuDessus, typologie.jK, etage);
							if (!_v1.$) {
								var dessus = _v1.a;
								return A2($author$project$I18n$Cles$texte, i18n, etage.xt) + (' ' + A2(
									$author$project$I18n$Cles$produitsReferencesCreationEtageDe,
									i18n,
									{Dj: dessus}));
							} else {
								return A2($author$project$I18n$Cles$texte, i18n, etage.xt);
							}
						}(),
						function () {
							var _v2 = _Utils_Tuple2(
								noeuds,
								A2($author$project$Catalogue$Chemin$nomDuDessus, typologie.jK, etage));
							if ((!_v2.a.b) && (!_v2.b.$)) {
								var dessus = _v2.b.a;
								return _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2('aide', true),
														_Utils_Tuple2('etage-vide', true)
													]))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$produitsReferencesCreationEtageVide,
													i18n,
													{
														kL: dessus,
														md: A2($author$project$I18n$Cles$texte, i18n, etage.xt)
													}))
											]))
									]);
							} else {
								return A2(
									$elm$core$List$map,
									function (propose) {
										return A3(
											choix,
											A2(
												$elm$core$List$member,
												propose.Aq,
												$author$project$Catalogue$Chemin$choisis(typologie.jK)),
											$author$project$Components$Produits$Catalogue$Creation$ChoixDeNoeud(propose.Aq),
											propose.Dj);
									},
									noeuds);
							}
						}());
				},
				$author$project$Catalogue$Chemin$colonnes(typologie.jK));
		};
		var typologies = A3(
			ligne,
			'typologie',
			$author$project$I18n$Cles$produitsReferencesCreationTypologie(i18n),
			A2(
				$elm$core$List$map,
				function (typologie) {
					return A3(
						choix,
						_Utils_eq(
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.Aq;
								},
								saisie.r3),
							$elm$core$Maybe$Just(typologie.Aq)),
						$author$project$Components$Produits$Catalogue$Creation$ChoixDeTypologie(
							$author$project$Catalogue$Identifiants$classificationIdToString(typologie.Aq)),
						typologie.Dj);
				},
				saisie.r7));
		var categories = function (typologie) {
			return $author$project$Catalogue$Chemin$complet(typologie.jK) ? _List_fromArray(
				[
					A3(
					ligne,
					'categorie',
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							$author$project$I18n$Cles$texte(i18n),
							$author$project$Catalogue$Chemin$categorie(typologie.jK))),
					(saisie.cq && _Utils_eq(saisie.dt, _List_Nil)) ? _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('aide', true),
											_Utils_Tuple2('etage-vide', true)
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$produitsReferencesCreationEtageVide,
										i18n,
										{
											kL: dernierNom(typologie.jK),
											md: A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													$author$project$I18n$Cles$texte(i18n),
													$author$project$Catalogue$Chemin$categorie(typologie.jK)))
										}))
								]))
						]) : A2(
						$elm$core$List$map,
						function (proposee) {
							var identifiant = $author$project$Catalogue$Identifiants$typeDeProduitIdToString(proposee.Aq);
							var choisie = _Utils_eq(
								saisie.fh,
								$elm$core$Maybe$Just(proposee.Aq));
							return A3(
								choix,
								choisie,
								$author$project$Components$Produits$Catalogue$Creation$Categorie(
									choisie ? '' : identifiant),
								proposee.Dj.zX);
						},
						saisie.dt))
				]) : _List_Nil;
		};
		return figee ? _Utils_ap(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, etages, saisie.r3)),
			_List_fromArray(
				[
					resteACHoisir,
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('errors')
						]),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (texte) {
								return _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$li,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(texte)
											]))
									]);
							},
							A4($author$project$Components$Produits$Catalogue$Creation$erreur, i18n, catalogue, saisie, $author$project$Components$Produits$Catalogue$Creation$ZoneRangement))))
				])) : A2(
			$elm$core$List$cons,
			typologies,
			_Utils_ap(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (typologie) {
							return _Utils_ap(
								etages(typologie),
								categories(typologie));
						},
						saisie.r3)),
				_List_fromArray(
					[
						obtenu,
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('errors')
							]),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (texte) {
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$li,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(texte)
												]))
										]);
								},
								A4($author$project$Components$Produits$Catalogue$Creation$erreur, i18n, catalogue, saisie, $author$project$Components$Produits$Catalogue$Creation$ZoneRangement)))),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsReferencesCreationRangementAide(i18n))
							]))
					])));
	});
var $author$project$I18n$Cles$saisieDeChampListeAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'saisie-de-champ.liste.aucune', _List_Nil, '—');
};
var $author$project$Components$Produits$Catalogue$View$rangementParListes = F3(
	function (i18n, model, catalogue) {
		var saisie = model.hP;
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.kX);
		var aucun = {
			Bl: $author$project$I18n$Cles$saisieDeChampListeAucune(i18n),
			fm: ''
		};
		var liste = F5(
			function (cle, libelle, valeur, options, onInput) {
				return A2(
					$author$project$Components$Shared$Champ$View$liste,
					{go: $elm$core$Maybe$Nothing, Aq: prefixe + ('-rangement-' + cle), Bl: libelle, he: true},
					{
						hg: onInput,
						o_: A2($elm$core$List$cons, aucun, options),
						fm: valeur
					});
			});
		var categories = function (typologie) {
			return $author$project$Catalogue$Chemin$complet(typologie.jK) ? _List_fromArray(
				[
					A5(
					liste,
					'categorie',
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							$author$project$I18n$Cles$texte(i18n),
							$author$project$Catalogue$Chemin$categorie(typologie.jK))),
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $author$project$Catalogue$Identifiants$typeDeProduitIdToString, saisie.fh)),
					A2(
						$elm$core$List$map,
						function (proposee) {
							return {
								Bl: proposee.Dj.zX,
								fm: $author$project$Catalogue$Identifiants$typeDeProduitIdToString(proposee.Aq)
							};
						},
						saisie.dt),
					$author$project$Components$Produits$Catalogue$Creation$Categorie)
				]) : _List_Nil;
		};
		var etages = function (typologie) {
			return A2(
				$elm$core$List$map,
				function (_v0) {
					var etage = _v0.a;
					var noeuds = _v0.b;
					var choisi = A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.Aq;
							},
							A2($author$project$Catalogue$Chemin$choisiSur, typologie.jK, etage)));
					return A5(
						liste,
						etage.Aq,
						A2($author$project$I18n$Cles$texte, i18n, etage.xt),
						choisi,
						A2(
							$elm$core$List$map,
							function (propose) {
								return {Bl: propose.Dj, fm: propose.Aq};
							},
							noeuds),
						function (valeur) {
							return $author$project$Components$Produits$Catalogue$Creation$ChoixDeNoeud(
								(valeur === '') ? choisi : valeur);
						});
				},
				$author$project$Catalogue$Chemin$colonnes(typologie.jK));
		};
		var typologies = A5(
			liste,
			'typologie',
			$author$project$I18n$Cles$produitsReferencesCreationTypologie(i18n),
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Aq;
						},
						$author$project$Catalogue$Identifiants$classificationIdToString),
					saisie.r3)),
			A2(
				$elm$core$List$map,
				function (typologie) {
					return {
						Bl: typologie.Dj,
						fm: $author$project$Catalogue$Identifiants$classificationIdToString(typologie.Aq)
					};
				},
				saisie.r7),
			$author$project$Components$Produits$Catalogue$Creation$ChoixDeTypologie);
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('rangement-listes')
					]),
				A2(
					$elm$core$List$cons,
					typologies,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (typologie) {
								return _Utils_ap(
									etages(typologie),
									categories(typologie));
							},
							saisie.r3))))
			]);
	});
var $author$project$Components$Produits$Catalogue$View$rangement = F2(
	function (i18n, model) {
		return model.gg ? A2($author$project$Components$Produits$Catalogue$View$rangementParListes, i18n, model) : A3($author$project$Components$Produits$Catalogue$View$rangementDe, i18n, false, model);
	});
var $author$project$Components$Produits$Catalogue$View$formulaire = F3(
	function (i18n, model, catalogue) {
		var saisie = model.hP;
		var rangeParEtages = !_Utils_eq(saisie.r7, _List_Nil);
		var typesProposes = rangeParEtages ? A2(
			$elm$core$List$map,
			function (proposee) {
				return {Aq: proposee.Aq, Dj: proposee.Dj};
			},
			saisie.dt) : A2(
			$elm$core$List$map,
			function (type_) {
				return {Aq: type_.Aq, Dj: type_.Dj};
			},
			catalogue.ib);
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.kX);
		var nomDeLaReference = A7(
			$author$project$Components$Produits$Catalogue$View$parLangue,
			i18n,
			model,
			catalogue,
			$author$project$Components$Produits$Catalogue$Creation$ZoneNom,
			$author$project$I18n$Cles$produitsCatalogueChampNom(i18n),
			saisie.Dj,
			$author$project$Components$Produits$Catalogue$Creation$Nom);
		var element = function (proposes) {
			return A2(
				$elm$core$List$map,
				function (propose) {
					return {
						Bl: propose.Dj,
						fm: $author$project$Catalogue$Identifiants$elementIdToString(propose.Aq)
					};
				},
				proposes);
		};
		var champ = F3(
			function (zone, libelle, obligatoire) {
				return {
					go: A4($author$project$Components$Produits$Catalogue$Creation$erreur, i18n, catalogue, saisie, zone),
					Aq: A2($author$project$Components$Produits$Catalogue$Creation$idDe, prefixe, zone),
					Bl: libelle,
					he: obligatoire
				};
			});
		var texte = F5(
			function (zone, libelle, obligatoire, valeur, versChamp) {
				return A2(
					$author$project$Components$Shared$Champ$View$texte,
					A3(champ, zone, libelle, obligatoire),
					{hg: versChamp, fm: valeur});
			});
		var aucun = {
			Bl: $author$project$I18n$Cles$saisieDeChampListeAucune(i18n),
			fm: ''
		};
		var types = A2(
			$author$project$Components$Shared$Champ$View$liste,
			A3(
				champ,
				$author$project$Components$Produits$Catalogue$Creation$ZoneType,
				A4(
					$author$project$Components$Produits$Catalogue$Model$libelleDeLArchetype,
					i18n,
					$author$project$Catalogue$Vocabulaire$estUnTypeDeProduit,
					$author$project$I18n$Cles$produitsArchetypeTypeDeProduit(i18n),
					catalogue),
				true),
			{
				hg: $author$project$Components$Produits$Catalogue$Creation$Type,
				o_: A2(
					$elm$core$List$cons,
					aucun,
					A2(
						$elm$core$List$map,
						function (type_) {
							return {
								Bl: type_.Dj.zX,
								fm: $author$project$Catalogue$Identifiants$typeDeProduitIdToString(type_.Aq)
							};
						},
						typesProposes)),
				fm: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Maybe$map, $author$project$Catalogue$Identifiants$typeDeProduitIdToString, saisie.fh))
			});
		var sansProduit = F2(
			function (libelleDuRattachement, obligatoire) {
				return rangeParEtages ? _Utils_ap(
					A3($author$project$Components$Produits$Catalogue$View$rangement, i18n, model, catalogue),
					_Utils_ap(
						$author$project$Catalogue$Vocabulaire$estUnService(saisie.g1) ? _List_fromArray(
							[types]) : _List_Nil,
						_List_fromArray(
							[nomDeLaReference]))) : _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Champ$View$liste,
						A3(champ, $author$project$Components$Produits$Catalogue$Creation$ZoneRattachement, libelleDuRattachement, obligatoire),
						{
							hg: $author$project$Components$Produits$Catalogue$Creation$Rattachement,
							o_: A2(
								$elm$core$List$cons,
								{
									Bl: $author$project$I18n$Cles$produitsReferencesCreationAucun(i18n),
									fm: ''
								},
								element(
									A3($author$project$Components$Produits$Catalogue$Creation$rattachables, catalogue, model.aV, saisie.g1))),
							fm: A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Maybe$map, $author$project$Catalogue$Identifiants$elementIdToString, saisie.pN))
						}),
						types,
						nomDeLaReference
					]);
			});
		return {
			fT: _List_fromArray(
				[
					A5(
					texte,
					$author$project$Components$Produits$Catalogue$Creation$ZoneCode,
					$author$project$I18n$Cles$produitsReferencesCreationCode(i18n),
					true,
					saisie.vx,
					$author$project$Components$Produits$Catalogue$Creation$Code),
					A2($author$project$Components$Produits$Catalogue$View$noteDuCode, i18n, saisie),
					A5(
					texte,
					$author$project$Components$Produits$Catalogue$Creation$ZoneEan,
					$author$project$I18n$Cles$produitsReferencesCreationEan(i18n),
					false,
					saisie.lI,
					$author$project$Components$Produits$Catalogue$Creation$Ean),
					A5(
					texte,
					$author$project$Components$Produits$Catalogue$Creation$ZoneMillesime,
					$author$project$I18n$Cles$produitsCatalogueChampMillesime(i18n),
					false,
					saisie.n8,
					$author$project$Components$Produits$Catalogue$Creation$Millesime),
					A5(
					texte,
					$author$project$Components$Produits$Catalogue$Creation$ZoneVariante,
					$author$project$I18n$Cles$produitsReferencesCarteVariante(i18n),
					false,
					saisie.sl,
					$author$project$Components$Produits$Catalogue$Creation$Variante),
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					A3(
						champ,
						$author$project$Components$Produits$Catalogue$Creation$ZoneEtat,
						$author$project$I18n$Cles$produitsCatalogueColonneEtat(i18n),
						true),
					{
						hg: $author$project$Components$Produits$Catalogue$Creation$Etat,
						o_: A2(
							$elm$core$List$map,
							function (etat) {
								return {
									Bl: A3($author$project$Components$Produits$Catalogue$Model$libelleDeLEtat, i18n, catalogue.mj, etat.vx),
									fm: $author$project$Catalogue$Identifiants$etatCodeToString(etat.vx)
								};
							},
							catalogue.mj),
						fm: A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, $author$project$Catalogue$Identifiants$etatCodeToString, saisie.gt))
					})
				]),
			hA: _Utils_ap(
				_List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Messages$View$view,
						i18n,
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2($elm$core$Maybe$map, $elm$core$List$singleton, saisie.pZ))),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('produit-cree')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								function () {
									var _v0 = _Utils_Tuple2(saisie.bd, saisie.Gp);
									if (_v0.a && (_v0.b.$ === 1)) {
										var cree = _v0.b.a;
										return A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												function (lu) {
													return A2(
														$author$project$I18n$Cles$produitsReferencesCreationProduitCree,
														i18n,
														{Dj: lu.R.zX});
												},
												$elm$core$List$head(
													A2(
														$elm$core$List$filter,
														A2(
															$elm$core$Basics$composeR,
															function ($) {
																return $.Aq;
															},
															$elm$core$Basics$eq(cree)),
														catalogue.aK))));
									} else {
										return '';
									}
								}())
							])),
						A2(
						$author$project$Components$Shared$Champ$View$liste,
						A3(
							champ,
							$author$project$Components$Produits$Catalogue$Creation$ZoneNature,
							$author$project$I18n$Cles$produitsReferencesCreationNature(i18n),
							true),
						{
							hg: $author$project$Components$Produits$Catalogue$Creation$Nature,
							o_: A2($author$project$Catalogue$Vocabulaire$naturesProposees, i18n, model.oo),
							fm: saisie.g1
						})
					]),
				function () {
					var _v1 = A2($author$project$Components$Produits$Catalogue$Creation$demande, catalogue, saisie.g1);
					switch (_v1.$) {
						case 0:
							return _Utils_ap(
								rangeParEtages ? A3($author$project$Components$Produits$Catalogue$View$rangement, i18n, model, catalogue) : _List_Nil,
								A7($author$project$Components$Produits$Catalogue$View$choixDuProduit, i18n, model, catalogue, champ, aucun, element, types));
						case 1:
							var niveau = _v1.a;
							return A2(
								sansProduit,
								A2(
									$elm$core$Maybe$withDefault,
									$author$project$I18n$Cles$produitsReferencesCreationRattachement(i18n),
									A2(
										$elm$core$Maybe$map,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Catalogue$Niveau$libelleDuNiveau,
											$author$project$I18n$Cles$texte(i18n)),
										$elm$core$List$head(
											A2(
												$elm$core$List$filter,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.Aq;
													},
													$elm$core$Basics$eq(niveau)),
												catalogue.C9)))),
								true);
						case 2:
							return A2(
								sansProduit,
								$author$project$I18n$Cles$produitsReferencesCreationRattachement(i18n),
								false);
						default:
							return rangeParEtages ? _Utils_ap(
								A3($author$project$Components$Produits$Catalogue$View$rangement, i18n, model, catalogue),
								_List_fromArray(
									[nomDeLaReference])) : _List_fromArray(
								[types, nomDeLaReference]);
					}
				}())
		};
	});
var $author$project$Components$Produits$Catalogue$Creation$Information = function (a) {
	return {$: 16, a: a};
};
var $author$project$I18n$Cles$produitsReferencesCreationInformationsAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.informations-aide', _List_Nil, 'Propres à la catégorie et héritées de son chemin');
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$aucuneIndication = {bB: false, yS: $elm$core$Maybe$Nothing, ou: ''};
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$LangueChoisie = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$langue = F2(
	function (i18n, code) {
		var _v0 = A2($elm$core$String$split, '-', code);
		if (_v0.b) {
			if (!_v0.b.b) {
				var base = _v0.a;
				return A2($author$project$Referentiel$Langues$nom, i18n, base);
			} else {
				var base = _v0.a;
				return A2($author$project$Referentiel$Langues$nom, i18n, base) + (' (' + (code + ')'));
			}
		} else {
			return code;
		}
	});
var $author$project$I18n$Cles$produitsReferenceSaisieLangueATraduire = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.saisie.langue.a-traduire',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'langue',
					$author$project$I18n$Traductions$Chaine(p.nn)),
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			p.nn + (' · ' + (p.w + ' à traduire')));
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$boutonDeLangue = F4(
	function (i18n, presentation, saisie, code) {
		var nom = A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$langue, i18n, code);
		var manquants = presentation.fr(code);
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-pressed',
					_Utils_eq(saisie.nn, code) ? 'true' : 'false'),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$LangueChoisie(code))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							(manquants > 0) ? A2(
								$author$project$I18n$Cles$produitsReferenceSaisieLangueATraduire,
								i18n,
								{
									nn: nom,
									w: $elm$core$String$fromInt(manquants)
								}) : nom)
						]))
				]));
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$LienDemande = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$choixDe = F2(
	function (presentation, champ) {
		var _v0 = champ.r0;
		switch (_v0.$) {
			case 17:
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dy;
							},
							$elm$core$Basics$eq(champ.dy)),
						presentation.jN));
			case 21:
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dy;
							},
							$elm$core$Basics$eq(champ.dy)),
						presentation.jN));
			case 19:
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dy;
							},
							$elm$core$Basics$eq(champ.dy)),
						presentation.jN));
			case 20:
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dy;
							},
							$elm$core$Basics$eq(champ.dy)),
						presentation.jN));
			case 18:
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dy;
							},
							$elm$core$Basics$eq(champ.dy)),
						presentation.jN));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$listeDeRecherche = '@recherche';
var $author$project$I18n$Cles$saisieDeChampLienChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'saisie-de-champ.lien.choisir', _List_Nil, 'Choisir…');
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$boutonDeRecherche = F3(
	function (i18n, presentation, champ) {
		var _v0 = A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$choixDe, presentation, champ);
		if (!_v0.$) {
			var choix = _v0.a;
			return (_Utils_eq(choix.nW, $author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$listeDeRecherche) && ((!choix.Ca) && (!presentation.np))) ? A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('secondary'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('choisir-un-lien'),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$LienDemande(champ.dy))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$saisieDeChampLienChoisir(i18n))
							]))
					])) : $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$produitsFicheElementValeursProposees = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.fiche-element.valeurs.proposees',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeur proposée') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeurs proposées'));
	});
var $author$project$I18n$Cles$produitsFicheElementValeursProposeesRestreintes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.fiche-element.valeurs.proposees-restreintes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE)),
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			((!p.w) || (p.w === 1)) ? (p.JE + (' valeurs, ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' proposée par la restriction posée sur ' + (p.Dj + '.'))))) : (p.JE + (' valeurs, ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' proposées par la restriction posée sur ' + (p.Dj + '.'))))));
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$noteDesValeurs = F3(
	function (i18n, noeud, choix) {
		var _v0 = choix.al;
		if (!_v0.$) {
			var restriction = _v0.a;
			return A2(
				$author$project$I18n$Cles$produitsFicheElementValeursProposeesRestreintes,
				i18n,
				{
					Dj: noeud,
					w: $elm$core$List$length(choix.pE),
					JE: $elm$core$String$fromInt(restriction.JE)
				});
		} else {
			return A2(
				$author$project$I18n$Cles$produitsFicheElementValeursProposees,
				i18n,
				{
					w: $elm$core$List$length(choix.pE)
				});
		}
	});
var $author$project$I18n$Cles$produitsFicheElementValeursTypeFichier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.fiche-element.valeurs.type-fichier', _List_Nil, 'fichier');
};
var $author$project$I18n$Cles$produitsFicheElementValeursTypeListeUnique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.fiche-element.valeurs.type-liste-unique', _List_Nil, 'liste unique');
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$detailDuChamp = F4(
	function (i18n, noeud, presentation, champ) {
		var pastille = function (texte) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('tag'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('type-de-champ')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(texte)
					]));
		};
		var _v0 = champ.r0;
		if (_v0.$ === 9) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('detail')
					]),
				_List_fromArray(
					[
						pastille(
						$author$project$I18n$Cles$produitsFicheElementValeursTypeFichier(i18n))
					]));
		} else {
			var _v1 = A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$choixDe, presentation, champ);
			if (!_v1.$) {
				var choix = _v1.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('detail')
						]),
					_List_fromArray(
						[
							pastille(
							$author$project$I18n$Cles$produitsFicheElementValeursTypeListeUnique(i18n)),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A3($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$noteDesValeurs, i18n, noeud, choix))
								]))
						]));
			} else {
				return $rtfeldman$elm_css$Html$Styled$text('');
			}
		}
	});
var $author$project$I18n$Cles$saisieDeChampVoirLaFiche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'saisie-de-champ.voir-la-fiche', _List_Nil, 'Voir la fiche');
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$lienDeLaFichePrise = F3(
	function (i18n, saisie, refus) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Maybe$map,
					function (_v0) {
						var adresse = _v0.b;
						return A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('fiche-qui-la-porte'),
									$rtfeldman$elm_css$Html$Styled$Attributes$href(adresse)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$saisieDeChampVoirLaFiche(i18n))
								]));
					},
					A2(
						$elm$core$Maybe$andThen,
						function (refuse) {
							return $elm$core$List$head(
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Tuple$first,
										$elm$core$Basics$eq(refuse.uN)),
									saisie.aJ));
						},
						refus))));
	});
var $author$project$Components$Shared$Champ$View$attributs = $author$project$Components$Shared$Champ$View$controle;
var $author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$libelle = F2(
	function (langue, valeur) {
		var _v0 = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$first,
				$elm$core$Basics$eq(langue)),
			valeur.R);
		if (_v0.b) {
			var _v1 = _v0.a;
			var texte = _v1.b;
			return texte;
		} else {
			return A2(
				$elm$core$Maybe$withDefault,
				valeur.Aq,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$second,
					$elm$core$List$head(valeur.R)));
		}
	});
var $author$project$I18n$Cles$produitsReferenceSaisieChoixArchivee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.saisie.choix.archivee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			p.Bl + ' (archivée)');
	});
var $author$project$I18n$Cles$restrictionHorsChoixOption = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restriction.hors-choix-option',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			p.Bl + ' (hors choix)');
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$libelleDeValeur = F4(
	function (i18n, choix, langue, valeur) {
		return valeur.tI ? A2(
			$author$project$I18n$Cles$produitsReferenceSaisieChoixArchivee,
			i18n,
			{
				Bl: A2($author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$libelle, langue, valeur)
			}) : (A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Aq;
				},
				$elm$core$Basics$eq(valeur.Aq)),
			choix.pE) ? A2($author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$libelle, langue, valeur) : A2(
			$author$project$I18n$Cles$restrictionHorsChoixOption,
			i18n,
			{
				Bl: A2($author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$libelle, langue, valeur)
			}));
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$ecrire = function (lu) {
	return A3(
		$elm$core$String$replace,
		'.',
		',',
		$elm$core$String$fromFloat(lu));
};
var $author$project$I18n$Cles$saisieDeChampBornes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'saisie-de-champ.bornes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'min',
					$author$project$I18n$Traductions$Chaine(p.Cx)),
					_Utils_Tuple2(
					'max',
					$author$project$I18n$Traductions$Chaine(p.Cg))
				]),
			'Valeur attendue entre ' + (p.Cx + (' et ' + (p.Cg + '.'))));
	});
var $author$project$I18n$Cles$saisieDeChampBornesMax = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'saisie-de-champ.bornes.max',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'max',
					$author$project$I18n$Traductions$Chaine(p.Cg))
				]),
			'Valeur attendue : au plus ' + (p.Cg + '.'));
	});
var $author$project$I18n$Cles$saisieDeChampBornesMin = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'saisie-de-champ.bornes.min',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'min',
					$author$project$I18n$Traductions$Chaine(p.Cx))
				]),
			'Valeur attendue : au moins ' + (p.Cx + '.'));
	});
var $author$project$I18n$Cles$saisieDeChampChoixEnDouble = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'saisie-de-champ.choix-en-double', _List_Nil, 'Un même choix revient deux fois.');
};
var $author$project$I18n$Cles$saisieDeChampDecimales = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'saisie-de-champ.decimales',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'decimales',
					$author$project$I18n$Traductions$Entier(p.kv))
				]),
			((!p.kv) || (p.kv === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.kv) + ' décimale au plus.') : (A2($author$project$I18n$Nombre$formater, 0, p.kv) + ' décimales au plus.'));
	});
var $author$project$I18n$Cles$saisieDeChampFormatNombre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'saisie-de-champ.format.nombre', _List_Nil, 'Un nombre est attendu.');
};
var $author$project$I18n$Cles$saisieDeChampHorsBornesPlausibles = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'saisie-de-champ.hors-bornes-plausibles',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'min',
					$author$project$I18n$Traductions$Chaine(p.Cx)),
					_Utils_Tuple2(
					'max',
					$author$project$I18n$Traductions$Chaine(p.Cg)),
					_Utils_Tuple2(
					'unite',
					$author$project$I18n$Traductions$Chaine(p.sa))
				]),
			'Valeur peu plausible : entre ' + (p.Cx + (' et ' + (p.Cg + (' ' + (p.sa + '.'))))));
	});
var $author$project$I18n$Cles$saisieDeChampHorsBornesPlausiblesMax = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'saisie-de-champ.hors-bornes-plausibles.max',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'max',
					$author$project$I18n$Traductions$Chaine(p.Cg)),
					_Utils_Tuple2(
					'unite',
					$author$project$I18n$Traductions$Chaine(p.sa))
				]),
			'Valeur peu plausible : au plus ' + (p.Cg + (' ' + (p.sa + '.'))));
	});
var $author$project$I18n$Cles$saisieDeChampHorsBornesPlausiblesMin = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'saisie-de-champ.hors-bornes-plausibles.min',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'min',
					$author$project$I18n$Traductions$Chaine(p.Cx)),
					_Utils_Tuple2(
					'unite',
					$author$project$I18n$Traductions$Chaine(p.sa))
				]),
			'Valeur peu plausible : au moins ' + (p.Cx + (' ' + (p.sa + '.'))));
	});
var $author$project$I18n$Cles$saisieDeChampHorsListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'saisie-de-champ.hors-liste', _List_Nil, 'Cette valeur n\'est pas dans la liste.');
};
var $author$project$I18n$Cles$saisieDeChampLongueurMax = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'saisie-de-champ.longueur.max',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'maximum',
					$author$project$I18n$Traductions$Chaine(p.Cj))
				]),
			p.Cj + ' caractères au plus.');
	});
var $author$project$I18n$Cles$saisieDeChampLongueurMin = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'saisie-de-champ.longueur.min',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'minimum',
					$author$project$I18n$Traductions$Chaine(p.CD))
				]),
			p.CD + ' caractères au moins.');
	});
var $author$project$I18n$Cles$saisieDeChampMotif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'saisie-de-champ.motif', _List_Nil, 'Le format attendu n\'est pas respecté.');
};
var $author$project$I18n$Cles$saisieDeChampNombreDeChoix = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'saisie-de-champ.nombre-de-choix', _List_Nil, 'Le nombre de choix n\'est pas admis.');
};
var $author$project$Components$Shared$EditeurDeSchema$Propositions$symbole = F2(
	function (unites, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			code,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Jh;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.vx;
							},
							$elm$core$Basics$eq(code)),
						unites))));
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$message = F4(
	function (i18n, unites, champ, defaut) {
		switch (defaut) {
			case 0:
				return $author$project$I18n$Cles$saisieDeChampObligatoire(i18n);
			case 1:
				return $author$project$I18n$Cles$saisieDeChampFormatNombre(i18n);
			case 7:
				return $author$project$I18n$Cles$saisieDeChampHorsListe(i18n);
			case 6:
				return $author$project$I18n$Cles$saisieDeChampNombreDeChoix(i18n);
			case 9:
				return $author$project$I18n$Cles$saisieDeChampChoixEnDouble(i18n);
			case 8:
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$I18n$Cles$saisieDeChampMotif(i18n),
					$elm$core$List$head(
						A2(
							$elm$core$List$filterMap,
							function (regle) {
								if (regle.$ === 2) {
									var dit = regle.b;
									return ($elm$core$String$trim(dit) === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(dit);
								} else {
									return $elm$core$Maybe$Nothing;
								}
							},
							champ.hJ)));
			case 2:
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(
						A2(
							$elm$core$List$filterMap,
							function (regle) {
								_v2$2:
								while (true) {
									if (regle.$ === 1) {
										if (!regle.b.$) {
											var max = regle.b.a;
											return $elm$core$Maybe$Just(
												A2(
													$author$project$I18n$Cles$saisieDeChampLongueurMax,
													i18n,
													{
														Cj: $elm$core$String$fromInt(max)
													}));
										} else {
											if (!regle.a.$) {
												var min = regle.a.a;
												var _v3 = regle.b;
												return $elm$core$Maybe$Just(
													A2(
														$author$project$I18n$Cles$saisieDeChampLongueurMin,
														i18n,
														{
															CD: $elm$core$String$fromInt(min)
														}));
											} else {
												break _v2$2;
											}
										}
									} else {
										break _v2$2;
									}
								}
								return $elm$core$Maybe$Nothing;
							},
							champ.hJ)));
			case 3:
				var _v4 = $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$bornesDeNombre(champ);
				if (!_v4.a.$) {
					if (!_v4.b.$) {
						var min = _v4.a.a;
						var max = _v4.b.a;
						return A2(
							$author$project$I18n$Cles$saisieDeChampBornes,
							i18n,
							{
								Cg: $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$ecrire(max),
								Cx: $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$ecrire(min)
							});
					} else {
						var min = _v4.a.a;
						var _v5 = _v4.b;
						return A2(
							$author$project$I18n$Cles$saisieDeChampBornesMin,
							i18n,
							{
								Cx: $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$ecrire(min)
							});
					}
				} else {
					if (!_v4.b.$) {
						var _v6 = _v4.a;
						var max = _v4.b.a;
						return A2(
							$author$project$I18n$Cles$saisieDeChampBornesMax,
							i18n,
							{
								Cg: $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$ecrire(max)
							});
					} else {
						var _v7 = _v4.a;
						var _v8 = _v4.b;
						return '';
					}
				}
			case 4:
				var _v9 = champ.r0;
				if (_v9.$ === 10) {
					var mesure = _v9.a;
					return A2(
						$author$project$I18n$Cles$saisieDeChampDecimales,
						i18n,
						{kv: mesure.kv});
				} else {
					return '';
				}
			default:
				var _v10 = champ.r0;
				if (_v10.$ === 10) {
					var mesure = _v10.a;
					var unite = A2($author$project$Components$Shared$EditeurDeSchema$Propositions$symbole, unites, mesure.sa);
					var _v11 = _Utils_Tuple2(mesure.Cx, mesure.Cg);
					if (!_v11.a.$) {
						if (!_v11.b.$) {
							var min = _v11.a.a;
							var max = _v11.b.a;
							return A2(
								$author$project$I18n$Cles$saisieDeChampHorsBornesPlausibles,
								i18n,
								{
									Cg: $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$ecrire(max),
									Cx: $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$ecrire(min),
									sa: unite
								});
						} else {
							var min = _v11.a.a;
							var _v12 = _v11.b;
							return A2(
								$author$project$I18n$Cles$saisieDeChampHorsBornesPlausiblesMin,
								i18n,
								{
									Cx: $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$ecrire(min),
									sa: unite
								});
						}
					} else {
						if (!_v11.b.$) {
							var _v13 = _v11.a;
							var max = _v11.b.a;
							return A2(
								$author$project$I18n$Cles$saisieDeChampHorsBornesPlausiblesMax,
								i18n,
								{
									Cg: $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$ecrire(max),
									sa: unite
								});
						} else {
							var _v14 = _v11.a;
							var _v15 = _v11.b;
							return '';
						}
					}
				} else {
					return '';
				}
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$montrees = function (choix) {
	return _Utils_ap(
		choix.pE,
		A2(
			$elm$core$List$filter,
			function (portee) {
				return !A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Aq;
						},
						$elm$core$Basics$eq(portee.Aq)),
					choix.pE);
			},
			choix.hu));
};
var $author$project$I18n$Cles$restrictionAucuneValeurDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restriction.aucune-valeur-detail', _List_Nil, 'Les restrictions de ce champ ne laissent aucune valeur à choisir. Pour en proposer, modifiez la restriction du type.');
};
var $author$project$I18n$Cles$restrictionAucuneValeurProposee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restriction.aucune-valeur-proposee', _List_Nil, 'Aucune valeur proposée');
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$listeDeChoix = F5(
	function (i18n, presentation, saisie, champ, choix) {
		var valeur = A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$valeurDe, champ.dy, saisie.Ki);
		var montrees = $author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$montrees(choix);
		var identifiant = A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$idDuChamp, presentation.pv, champ.dy);
		var fourni = {
			go: A2(
				$elm$core$Maybe$map,
				A3($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$message, i18n, presentation.sb, champ),
				$elm$core$List$head(
					A2($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$juger, champ, valeur))),
			Aq: identifiant,
			Bl: champ.Bl,
			he: champ.he
		};
		var coches = function () {
			if (valeur.$ === 2) {
				var choisis = valeur.a;
				return choisis;
			} else {
				return _List_Nil;
			}
		}();
		var uneCase = F2(
			function (rang, proposee) {
				var idDeLaCase = identifiant + ('-' + $elm$core$String$fromInt(rang));
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('choix')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id(idDeLaCase),
									$rtfeldman$elm_css$Html$Styled$Attributes$checked(
									A2($elm$core$List$member, proposee.Aq, coches)),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(choix.Ca),
									$rtfeldman$elm_css$Html$Styled$Events$onCheck(
									function (cochee) {
										return $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Choix(
											A2(
												$elm$core$List$filter,
												function (autre) {
													return _Utils_eq(autre, proposee.Aq) ? cochee : A2($elm$core$List$member, autre, coches);
												},
												A2(
													$elm$core$List$map,
													function ($) {
														return $.Aq;
													},
													montrees)));
									})
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$for(idDeLaCase)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A4($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$libelleDeValeur, i18n, choix, saisie.nn, proposee))
								]))
						]));
			});
		var choisie = function () {
			if (valeur.$ === 1) {
				var id = valeur.a;
				return id;
			} else {
				return '';
			}
		}();
		var listeUnique = A2(
			$rtfeldman$elm_css$Html$Styled$select,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$disabled(choix.Ca),
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Ecrit),
					$author$project$Components$Shared$Champ$View$attributs(fourni))),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$option,
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'value', ''),
							$rtfeldman$elm_css$Html$Styled$Attributes$selected(choisie === '')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$saisieDeChampListeAucune(i18n))
						])),
				A2(
					$elm$core$List$map,
					function (proposee) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$option,
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'value', proposee.Aq),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(choisie, proposee.Aq))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A4($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$libelleDeValeur, i18n, choix, saisie.nn, proposee))
								]));
					},
					montrees)));
		return ($elm$core$List$isEmpty(choix.pE) && (!_Utils_eq(choix.nW, $author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$listeDeRecherche))) ? A2(
			$author$project$Components$Shared$Champ$View$compose,
			fourni,
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('aide'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('aucune-valeur-proposee', true)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$restrictionAucuneValeurProposee(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$restrictionAucuneValeurDetail(i18n))
								]))
						])),
				$elm$core$List$isEmpty(montrees) ? _List_Nil : _List_fromArray(
					[listeUnique]))) : (choix.FS ? A2(
			$author$project$Components$Shared$Champ$View$compose,
			fourni,
			A2($elm$core$List$indexedMap, uneCase, montrees)) : A2(
			$author$project$Components$Shared$Champ$View$compose,
			fourni,
			_List_fromArray(
				[listeUnique])));
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$codeDeLaValeurHorsChoix = 'ValeurHorsChoix';
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$ChoixEnDouble = 9;
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$HorsMotif = 8;
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$duCode = function (code) {
	switch (code) {
		case 'Obligatoire':
			return $elm$core$Maybe$Just(0);
		case 'Format':
			return $elm$core$Maybe$Just(1);
		case 'Longueur':
			return $elm$core$Maybe$Just(2);
		case 'Bornes':
			return $elm$core$Maybe$Just(3);
		case 'Decimales':
			return $elm$core$Maybe$Just(4);
		case 'HorsBornesPlausibles':
			return $elm$core$Maybe$Just(5);
		case 'NombreDeChoix':
			return $elm$core$Maybe$Just(6);
		case 'HorsListe':
			return $elm$core$Maybe$Just(7);
		case 'Motif':
			return $elm$core$Maybe$Just(8);
		case 'ChoixEnDouble':
			return $elm$core$Maybe$Just(9);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$I18n$Cles$produitsReferenceSaisieRefus = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.saisie.refus', _List_Nil, 'Cette valeur n\'est pas admise.');
};
var $author$project$I18n$Cles$produitsReferenceSaisieRefusLangue = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.saisie.refus.langue',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'message',
					$author$project$I18n$Traductions$Chaine(p.Cs)),
					_Utils_Tuple2(
					'langue',
					$author$project$I18n$Traductions$Chaine(p.nn))
				]),
			p.Cs + (' (' + (p.nn + ')')));
	});
var $author$project$I18n$Cles$restrictionRefusValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restriction.refus-valeur', _List_Nil, 'Cette valeur n\'est pas proposée pour cette fiche : choisissez parmi les valeurs que le type propose.');
};
var $author$project$I18n$Cles$saisieDeChampCodeEnDouble = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'saisie-de-champ.code-en-double',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'code',
					$author$project$I18n$Traductions$Chaine(p.vx))
				]),
			'Le code ' + (p.vx + ' est choisi deux fois : retire le doublon.'));
	});
var $author$project$I18n$Cles$saisieDeChampCodeHorsReferentiel = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'saisie-de-champ.code-hors-referentiel',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'code',
					$author$project$I18n$Traductions$Chaine(p.vx))
				]),
			'Le code ' + (p.vx + ' n\'est pas au référentiel : retire-le ou choisis un autre.'));
	});
var $author$project$I18n$Cles$saisieDeChampValeurPrise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'saisie-de-champ.valeur-prise', _List_Nil, 'Valeur déjà prise par une autre fiche.');
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$messageDuRefus = F4(
	function (i18n, presentation, champ, refus) {
		var message = _Utils_eq(refus.vx, $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$codeDeLaValeurPrise) ? $author$project$I18n$Cles$saisieDeChampValeurPrise(i18n) : (_Utils_eq(refus.vx, $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$codeDeLaValeurHorsChoix) ? $author$project$I18n$Cles$restrictionRefusValeur(i18n) : ((refus.vx === 'CodeHorsReferentiel') ? A2(
			$author$project$I18n$Cles$saisieDeChampCodeHorsReferentiel,
			i18n,
			{
				vx: A2($elm$core$Maybe$withDefault, '', refus.vA)
			}) : ((refus.vx === 'CodeEnDouble') ? A2(
			$author$project$I18n$Cles$saisieDeChampCodeEnDouble,
			i18n,
			{
				vx: A2($elm$core$Maybe$withDefault, '', refus.vA)
			}) : A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Cles$produitsReferenceSaisieRefus(i18n),
			A2(
				$elm$core$Maybe$map,
				A3($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$message, i18n, presentation.sb, champ),
				$author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$duCode(refus.vx))))));
		var _v0 = refus.nn;
		if (!_v0.$) {
			var code = _v0.a;
			return A2(
				$author$project$I18n$Cles$produitsReferenceSaisieRefusLangue,
				i18n,
				{
					nn: A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$langue, i18n, code),
					Cs: message
				});
		} else {
			return message;
		}
	});
var $author$project$Referentiel$Normes$entreesDePays = function (_v0) {
	var normes = _v0;
	return normes.ho;
};
var $author$project$I18n$Cles$referentielCreationChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.choisir', _List_Nil, 'Choisir…');
};
var $author$project$I18n$Cles$referentielCreationContactAdresseCodePostal = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.contact.adresse.code-postal', _List_Nil, 'Code postal');
};
var $author$project$I18n$Cles$referentielCreationContactAdresseLigne1 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.contact.adresse.ligne1', _List_Nil, 'Adresse');
};
var $author$project$I18n$Cles$referentielCreationContactAdresseLigne2 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.contact.adresse.ligne2', _List_Nil, 'Complément d\'adresse');
};
var $author$project$I18n$Cles$referentielCreationContactAdresseLigne3 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.contact.adresse.ligne3', _List_Nil, 'Complément d\'adresse (suite)');
};
var $author$project$I18n$Cles$referentielCreationContactAdresseLocalite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.contact.adresse.localite', _List_Nil, 'Ville');
};
var $author$project$I18n$Cles$referentielCreationContactAdressePays = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.contact.adresse.pays', _List_Nil, 'Pays');
};
var $author$project$I18n$Cles$referentielCreationContactAdresseRegion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.contact.adresse.region', _List_Nil, 'Région, état ou province');
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$adresse = F4(
	function (i18n, contexte, fourni, valeur) {
		var sousChamp = F3(
			function (suffixe, libelle, obligatoire) {
				return {go: $elm$core$Maybe$Nothing, Aq: contexte.Aq + ('-' + suffixe), Bl: libelle, he: obligatoire};
			});
		var texteDe = F5(
			function (suffixe, libelle, obligatoire, lu, pose) {
				return A2(
					$author$project$Components$Shared$Champ$View$texte,
					A3(sousChamp, suffixe, libelle, obligatoire),
					{
						hg: function (saisi) {
							return $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Postale(
								pose(saisi));
						},
						fm: lu
					});
			});
		var courante = function () {
			if (valeur.$ === 6) {
				var a = valeur.a;
				return a;
			} else {
				return $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$adresseVide;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('adresse')
				]),
			_List_fromArray(
				[
					A5(
					texteDe,
					'ligne1',
					$author$project$I18n$Cles$referentielCreationContactAdresseLigne1(i18n),
					true,
					courante.a3,
					function (v) {
						return _Utils_update(
							courante,
							{a3: v});
					}),
					A5(
					texteDe,
					'ligne2',
					$author$project$I18n$Cles$referentielCreationContactAdresseLigne2(i18n),
					false,
					courante.a4,
					function (v) {
						return _Utils_update(
							courante,
							{a4: v});
					}),
					A5(
					texteDe,
					'ligne3',
					$author$project$I18n$Cles$referentielCreationContactAdresseLigne3(i18n),
					false,
					courante.a5,
					function (v) {
						return _Utils_update(
							courante,
							{a5: v});
					}),
					A5(
					texteDe,
					'code-postal',
					$author$project$I18n$Cles$referentielCreationContactAdresseCodePostal(i18n),
					false,
					courante.vz,
					function (v) {
						return _Utils_update(
							courante,
							{vz: v});
					}),
					A5(
					texteDe,
					'localite',
					$author$project$I18n$Cles$referentielCreationContactAdresseLocalite(i18n),
					true,
					courante.B_,
					function (v) {
						return _Utils_update(
							courante,
							{B_: v});
					}),
					A5(
					texteDe,
					'region',
					$author$project$I18n$Cles$referentielCreationContactAdresseRegion(i18n),
					false,
					courante.Hj,
					function (v) {
						return _Utils_update(
							courante,
							{Hj: v});
					}),
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					A3(
						sousChamp,
						'pays',
						$author$project$I18n$Cles$referentielCreationContactAdressePays(i18n),
						true),
					{
						hg: function (code) {
							return $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Postale(
								_Utils_update(
									courante,
									{ho: code}));
						},
						o_: A2(
							$elm$core$List$cons,
							{
								Bl: $author$project$I18n$Cles$referentielCreationChoisir(i18n),
								fm: ''
							},
							A2(
								$elm$core$List$map,
								function (p) {
									return {Bl: p.Dj, fm: p.vx};
								},
								$author$project$Referentiel$Normes$entreesDePays(contexte.hd))),
						fm: courante.ho
					})
				]));
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$cases = F3(
	function (contexte, valeurs, valeur) {
		var coches = function () {
			if (valeur.$ === 2) {
				var choisis = valeur.a;
				return choisis;
			} else {
				return _List_Nil;
			}
		}();
		var basculer = F2(
			function (proposee, cochee) {
				return $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Choix(
					A2(
						$elm$core$List$filter,
						function (autre) {
							return _Utils_eq(autre, proposee) ? cochee : A2($elm$core$List$member, autre, coches);
						},
						valeurs));
			});
		var uneCase = F2(
			function (rang, proposee) {
				var idDeLaCase = contexte.Aq + ('-' + $elm$core$String$fromInt(rang));
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('choix')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id(idDeLaCase),
									$rtfeldman$elm_css$Html$Styled$Attributes$checked(
									A2($elm$core$List$member, proposee, coches)),
									$rtfeldman$elm_css$Html$Styled$Events$onCheck(
									basculer(proposee))
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$for(idDeLaCase)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(proposee)
								]))
						]));
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('liste-de-choix')
				]),
			A2($elm$core$List$indexedMap, uneCase, valeurs));
	});
var $author$project$I18n$Cles$saisieDeChampCompteur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'saisie-de-champ.compteur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'saisis',
					$author$project$I18n$Traductions$Chaine(p.Im)),
					_Utils_Tuple2(
					'maximum',
					$author$project$I18n$Traductions$Chaine(p.Cj))
				]),
			p.Im + (' / ' + p.Cj));
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$compteur = F3(
	function (i18n, champ, saisi) {
		var maximum = $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (regle) {
					if (regle.$ === 1) {
						var max = regle.b;
						return max;
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				champ.hJ));
		return A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
				]),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (max) {
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$saisieDeChampCompteur,
									i18n,
									{
										Cj: $elm$core$String$fromInt(max),
										Im: $elm$core$String$fromInt(
											$elm$core$String$length(saisi))
									}))
							]);
					},
					maximum)));
	});
var $author$project$Referentiel$Normes$entreesDeDevises = function (_v0) {
	var normes = _v0;
	return normes.ga;
};
var $author$project$Referentiel$Normes$entreesDeLangues = function (_v0) {
	var normes = _v0;
	return normes.Ba;
};
var $author$project$Components$Shared$EditeurDeSchema$Champ$libelleDeLaValeur = F3(
	function (langue, champ, valeur) {
		return A2(
			$elm$core$Maybe$andThen,
			function (libelles) {
				return A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$second,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$first,
								$elm$core$Basics$eq(langue)),
							libelles)));
			},
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$eq(valeur)),
						champ.Bt))));
	});
var $author$project$Texte$MiseEnForme$Gras = 0;
var $author$project$Texte$MiseEnForme$Italique = 1;
var $author$project$Texte$MiseEnForme$Lien = 3;
var $author$project$Texte$MiseEnForme$Liste = 2;
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$gesteDe = function (nom) {
	switch (nom) {
		case 'gras':
			return 0;
		case 'italique':
			return 1;
		case 'liste':
			return 2;
		default:
			return 3;
	}
};
var $author$project$Texte$MiseEnForme$inserer = F3(
	function (exemple, geste, saisi) {
		switch (geste) {
			case 0:
				return saisi + ('**' + (exemple + '**'));
			case 1:
				return saisi + ('*' + (exemple + '*'));
			case 2:
				return saisi + ((((saisi === '') || A2($elm$core$String$endsWith, '\n', saisi)) ? '' : '\n') + ('- ' + exemple));
			default:
				return saisi + ('[' + (exemple + '](https://)'));
		}
	});
var $author$project$I18n$Cles$saisieDeChampMiseEnFormeGras = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'saisie-de-champ.mise-en-forme.gras', _List_Nil, 'Gras');
};
var $author$project$I18n$Cles$saisieDeChampMiseEnFormeItalique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'saisie-de-champ.mise-en-forme.italique', _List_Nil, 'Italique');
};
var $author$project$I18n$Cles$saisieDeChampMiseEnFormeLien = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'saisie-de-champ.mise-en-forme.lien', _List_Nil, 'Lien');
};
var $author$project$I18n$Cles$saisieDeChampMiseEnFormeListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'saisie-de-champ.mise-en-forme.liste', _List_Nil, 'Liste');
};
var $rtfeldman$elm_css$Html$Styled$textarea = $rtfeldman$elm_css$Html$Styled$node('textarea');
var $author$project$Texte$MiseEnForme$elementDe = function (l) {
	if (l.$ === 1) {
		var contenu = l.a;
		return $elm$core$Maybe$Just(contenu);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_css$Html$Styled$em = $rtfeldman$elm_css$Html$Styled$node('em');
var $author$project$Texte$MiseEnForme$lienSur = function (adresse) {
	return A2(
		$elm$core$List$any,
		function (debut) {
			return A2(
				$elm$core$String$startsWith,
				debut,
				$elm$core$String$toLower(adresse));
		},
		_List_fromArray(
			['https://', 'http://', 'mailto:']));
};
var $author$project$Texte$MiseEnForme$premiereMarque = function (texte) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (candidate, retenu) {
				if (!retenu.$) {
					var _v1 = retenu.a;
					var rangRetenu = _v1.a;
					return (_Utils_cmp(candidate.a, rangRetenu) < 0) ? $elm$core$Maybe$Just(candidate) : retenu;
				} else {
					return $elm$core$Maybe$Just(candidate);
				}
			}),
		$elm$core$Maybe$Nothing,
		A2(
			$elm$core$List$filterMap,
			function (marque) {
				return A2(
					$elm$core$Maybe$map,
					function (rang) {
						return _Utils_Tuple2(rang, marque);
					},
					$elm$core$List$head(
						A2($elm$core$String$indexes, marque, texte)));
			},
			_List_fromArray(
				['**', '*', '['])));
};
var $rtfeldman$elm_css$Html$Styled$Attributes$rel = $rtfeldman$elm_css$VirtualDom$Styled$attribute('rel');
var $rtfeldman$elm_css$Html$Styled$Attributes$target = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('target');
var $author$project$Texte$MiseEnForme$balise = F2(
	function (marque, suite) {
		switch (marque) {
			case '**':
				return A3($author$project$Texte$MiseEnForme$entre, '**', suite, $rtfeldman$elm_css$Html$Styled$strong);
			case '*':
				return A3($author$project$Texte$MiseEnForme$entre, '*', suite, $rtfeldman$elm_css$Html$Styled$em);
			default:
				return $author$project$Texte$MiseEnForme$lien(suite);
		}
	});
var $author$project$Texte$MiseEnForme$enLigne = function (texte) {
	var _v3 = $author$project$Texte$MiseEnForme$premiereMarque(texte);
	if (_v3.$ === 1) {
		return (texte === '') ? _List_Nil : _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(texte)
			]);
	} else {
		var _v4 = _v3.a;
		var rang = _v4.a;
		var marque = _v4.b;
		var suite = A2($elm$core$String$dropLeft, rang, texte);
		return _Utils_ap(
			(!rang) ? _List_Nil : _List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2($elm$core$String$left, rang, texte))
				]),
			A2($author$project$Texte$MiseEnForme$balise, marque, suite));
	}
};
var $author$project$Texte$MiseEnForme$entre = F3(
	function (marque, suite, enveloppe) {
		var reste = A2(
			$elm$core$String$dropLeft,
			$elm$core$String$length(marque),
			suite);
		var _v2 = A2($elm$core$String$indexes, marque, reste);
		if (_v2.b) {
			var fin = _v2.a;
			return (fin > 0) ? A2(
				$elm$core$List$cons,
				A2(
					enveloppe,
					_List_Nil,
					$author$project$Texte$MiseEnForme$enLigne(
						A2($elm$core$String$left, fin, reste))),
				$author$project$Texte$MiseEnForme$enLigne(
					A2(
						$elm$core$String$dropLeft,
						fin + $elm$core$String$length(marque),
						reste))) : A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$text(marque),
				$author$project$Texte$MiseEnForme$enLigne(reste));
		} else {
			return A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$text(marque),
				$author$project$Texte$MiseEnForme$enLigne(reste));
		}
	});
var $author$project$Texte$MiseEnForme$lien = function (suite) {
	var reste = A2($elm$core$String$dropLeft, 1, suite);
	var litteral = A2(
		$elm$core$List$cons,
		$rtfeldman$elm_css$Html$Styled$text('['),
		$author$project$Texte$MiseEnForme$enLigne(reste));
	var _v0 = A2($elm$core$String$indexes, '](', reste);
	if (_v0.b) {
		var milieu = _v0.a;
		var libelle = A2($elm$core$String$left, milieu, reste);
		var apresAdresse = A2($elm$core$String$dropLeft, milieu + 2, reste);
		var _v1 = A2($elm$core$String$indexes, ')', apresAdresse);
		if (_v1.b) {
			var fin = _v1.a;
			var adresse = A2($elm$core$String$left, fin, apresAdresse);
			return ((libelle !== '') && $author$project$Texte$MiseEnForme$lienSur(adresse)) ? A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$href(adresse),
							$rtfeldman$elm_css$Html$Styled$Attributes$rel('noopener'),
							$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						])),
				$author$project$Texte$MiseEnForme$enLigne(
					A2($elm$core$String$dropLeft, fin + 1, apresAdresse))) : litteral;
		} else {
			return litteral;
		}
	} else {
		return litteral;
	}
};
var $rtfeldman$elm_css$Html$Styled$br = $rtfeldman$elm_css$Html$Styled$node('br');
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $author$project$Texte$MiseEnForme$paragraphe = function (textes) {
	return $elm$core$List$concat(
		A2(
			$elm$core$List$intersperse,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil)
				]),
			A2($elm$core$List$map, $author$project$Texte$MiseEnForme$enLigne, textes)));
};
var $author$project$Texte$MiseEnForme$prendre = F2(
	function (choisir, lignes) {
		if (lignes.b) {
			var premiere = lignes.a;
			var reste = lignes.b;
			var _v1 = choisir(premiere);
			if (!_v1.$) {
				var contenu = _v1.a;
				var _v2 = A2($author$project$Texte$MiseEnForme$prendre, choisir, reste);
				var suite = _v2.a;
				var fin = _v2.b;
				return _Utils_Tuple2(
					A2($elm$core$List$cons, contenu, suite),
					fin);
			} else {
				return _Utils_Tuple2(_List_Nil, lignes);
			}
		} else {
			return _Utils_Tuple2(_List_Nil, _List_Nil);
		}
	});
var $author$project$Texte$MiseEnForme$texteDe = function (l) {
	if (l.$ === 2) {
		var contenu = l.a;
		return $elm$core$Maybe$Just(contenu);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Texte$MiseEnForme$blocs = function (lignes) {
	blocs:
	while (true) {
		if (!lignes.b) {
			return _List_Nil;
		} else {
			switch (lignes.a.$) {
				case 0:
					var _v1 = lignes.a;
					var reste = lignes.b;
					var $temp$lignes = reste;
					lignes = $temp$lignes;
					continue blocs;
				case 1:
					var _v2 = A2($author$project$Texte$MiseEnForme$prendre, $author$project$Texte$MiseEnForme$elementDe, lignes);
					var elements = _v2.a;
					var reste = _v2.b;
					return A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (contenu) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$li,
										_List_Nil,
										$author$project$Texte$MiseEnForme$enLigne(contenu));
								},
								elements)),
						$author$project$Texte$MiseEnForme$blocs(reste));
				default:
					var _v3 = A2($author$project$Texte$MiseEnForme$prendre, $author$project$Texte$MiseEnForme$texteDe, lignes);
					var textes = _v3.a;
					var reste = _v3.b;
					return A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							$author$project$Texte$MiseEnForme$paragraphe(textes)),
						$author$project$Texte$MiseEnForme$blocs(reste));
			}
		}
	}
};
var $author$project$Texte$MiseEnForme$Element = function (a) {
	return {$: 1, a: a};
};
var $author$project$Texte$MiseEnForme$Texte = function (a) {
	return {$: 2, a: a};
};
var $author$project$Texte$MiseEnForme$Vide = {$: 0};
var $author$project$Texte$MiseEnForme$ligne = function (brut) {
	return ($elm$core$String$trim(brut) === '') ? $author$project$Texte$MiseEnForme$Vide : ((A2($elm$core$String$startsWith, '- ', brut) || A2($elm$core$String$startsWith, '* ', brut)) ? $author$project$Texte$MiseEnForme$Element(
		A2($elm$core$String$dropLeft, 2, brut)) : $author$project$Texte$MiseEnForme$Texte(brut));
};
var $author$project$Texte$MiseEnForme$vue = function (saisi) {
	return $author$project$Texte$MiseEnForme$blocs(
		A2(
			$elm$core$List$map,
			$author$project$Texte$MiseEnForme$ligne,
			$elm$core$String$lines(
				A3($elm$core$String$replace, '\u000D', '', saisi))));
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$miseEnForme = F3(
	function (i18n, fourni, ecrit) {
		var geste = function (_v0) {
			var nom = _v0.a;
			var libelle = _v0.b;
			return A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('button', true),
								_Utils_Tuple2('secondary', true),
								_Utils_Tuple2(nom, true)
							])),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						ecrit.hg(
							A3(
								$author$project$Texte$MiseEnForme$inserer,
								libelle,
								$author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$gesteDe(nom),
								ecrit.fm)))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(libelle)
							]))
					]));
		};
		return A2(
			$author$project$Components$Shared$Champ$View$compose,
			fourni,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('barre-mise-en-forme')
						]),
					A2(
						$elm$core$List$map,
						geste,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'gras',
								$author$project$I18n$Cles$saisieDeChampMiseEnFormeGras(i18n)),
								_Utils_Tuple2(
								'italique',
								$author$project$I18n$Cles$saisieDeChampMiseEnFormeItalique(i18n)),
								_Utils_Tuple2(
								'liste',
								$author$project$I18n$Cles$saisieDeChampMiseEnFormeListe(i18n)),
								_Utils_Tuple2(
								'lien',
								$author$project$I18n$Cles$saisieDeChampMiseEnFormeLien(i18n))
							]))),
					A2(
					$rtfeldman$elm_css$Html$Styled$textarea,
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$value(ecrit.fm),
						A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Events$onInput(ecrit.hg),
							$author$project$Components$Shared$Champ$View$attributs(fourni))),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu-mise-en-forme')
						]),
					$author$project$Texte$MiseEnForme$vue(ecrit.fm))
				]));
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Selectionne = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Shared$Champ$SelecteurNorme$retirer = F2(
	function (code, choisis) {
		return A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(code),
			choisis);
	});
var $author$project$Components$Shared$Champ$SelecteurNorme$basculer = F3(
	function (code, coche, choisis) {
		return coche ? (A2($elm$core$List$member, code, choisis) ? choisis : _Utils_ap(
			choisis,
			_List_fromArray(
				[code]))) : A2($author$project$Components$Shared$Champ$SelecteurNorme$retirer, code, choisis);
	});
var $author$project$Components$Shared$Champ$SelecteurNorme$correspondances = F2(
	function (recherche, entrees) {
		var cherche = $author$project$Referentiel$Normes$plier(
			$elm$core$String$trim(recherche));
		return (cherche === '') ? entrees : A2(
			$elm$core$List$filter,
			function (entree) {
				return A2(
					$elm$core$String$contains,
					cherche,
					$author$project$Referentiel$Normes$plier(entree.Dj)) || A2(
					$elm$core$String$contains,
					cherche,
					$author$project$Referentiel$Normes$plier(entree.vx));
			},
			entrees);
	});
var $author$project$Referentiel$Normes$nomDeCode = F2(
	function (entrees, code) {
		var nomExact = function (c) {
			return A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Dj;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.vx;
							},
							$elm$core$Basics$eq(c)),
						entrees)));
		};
		var _v0 = _Utils_Tuple2(
			nomExact(code),
			A2($elm$core$String$split, '-', code));
		if (!_v0.a.$) {
			var nom = _v0.a.a;
			return $elm$core$Maybe$Just(nom);
		} else {
			if ((_v0.b.b && _v0.b.b.b) && (!_v0.b.b.b.b)) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				var langue = _v2.a;
				var _v3 = _v2.b;
				var region = _v3.a;
				return (_Utils_eq(
					langue,
					$elm$core$String$toLower(langue)) && (($elm$core$String$length(region) === 2) && _Utils_eq(
					region,
					$elm$core$String$toUpper(region)))) ? A2(
					$elm$core$Maybe$map,
					function (nom) {
						return nom + (' (' + (region + ')'));
					},
					nomExact(langue)) : $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$I18n$Cles$selecteurNormeChoisis = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'selecteur-norme.choisis',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Choisis (' + (p.w + ')'));
	});
var $author$project$I18n$Cles$selecteurNormeCodeRetire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'selecteur-norme.code-retire', _List_Nil, 'code retiré');
};
var $author$project$I18n$Cles$selecteurNormeRetirer = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'selecteur-norme.retirer',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer ' + p.Dj);
	});
var $author$project$Components$Shared$Champ$SelecteurNorme$view = F2(
	function (i18n, fourni) {
		var selection = fourni.q3;
		var retrait = F2(
			function (nom, code) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer'),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-label',
							A2(
								$author$project$I18n$Cles$selecteurNormeRetirer,
								i18n,
								{Dj: nom})),
							$rtfeldman$elm_css$Html$Styled$Attributes$title(
							A2(
								$author$project$I18n$Cles$selecteurNormeRetirer,
								i18n,
								{Dj: nom})),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							_Utils_update(
								selection,
								{
									jL: A2($author$project$Components$Shared$Champ$SelecteurNorme$retirer, code, selection.jL)
								}))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('×')
						]));
			});
		var nomDe = function (code) {
			return A2($author$project$Referentiel$Normes$nomDeCode, fourni.yv, code);
		};
		var puce = function (code) {
			var _v0 = nomDe(code);
			if (!_v0.$) {
				var nom = _v0.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('puce')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('tag'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('accent')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(nom),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('code')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(code)
										]))
								])),
							A2(retrait, nom, code)
						]));
			} else {
				return A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('puce'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('retiree')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('tag'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('ambre')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(code),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('code')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$selecteurNormeCodeRetire(i18n))
										]))
								])),
							A2(retrait, code, code)
						]));
			}
		};
		var triesParNom = A2(
			$elm$core$List$sortBy,
			function (code) {
				return $author$project$Referentiel$Normes$plier(
					A2(
						$elm$core$Maybe$withDefault,
						code,
						nomDe(code)));
			},
			selection.jL);
		var ligne = F2(
			function (rang, entree) {
				var identifiant = fourni.uN.Aq + ('-' + $elm$core$String$fromInt(rang));
				var cochee = A2($elm$core$List$member, entree.vx, selection.jL);
				return A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('selectionnee', cochee)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id(identifiant),
									$rtfeldman$elm_css$Html$Styled$Attributes$checked(cochee),
									$rtfeldman$elm_css$Html$Styled$Events$onCheck(
									function (coche) {
										return _Utils_update(
											selection,
											{
												jL: A3($author$project$Components$Shared$Champ$SelecteurNorme$basculer, entree.vx, coche, selection.jL)
											});
									})
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'for', identifiant)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(entree.Dj)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('tag'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('gris')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(entree.vx)
										]))
								]))
						]));
			});
		return A2(
			$author$project$Components$Shared$Champ$View$compose,
			fourni.uN,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(fourni.uN.Aq),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(selection.hC),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'autocomplete', 'off'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', fourni.G3),
							$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(fourni.G3),
							$rtfeldman$elm_css$Html$Styled$Events$onInput(
							function (texte) {
								return _Utils_update(
									selection,
									{hC: texte});
							})
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('lignes')
						]),
					A2(
						$elm$core$List$indexedMap,
						ligne,
						A2($author$project$Components$Shared$Champ$SelecteurNorme$correspondances, selection.hC, fourni.yv))),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('choisis')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$selecteurNormeChoisis,
										i18n,
										{
											w: $elm$core$String$fromInt(
												$elm$core$List$length(selection.jL))
										}))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('puces')
								]),
							A2($elm$core$List$map, puce, triesParNom)),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(fourni.oJ)
								]))
						]))
				]));
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$normee = F6(
	function (i18n, plusieurs, textes, fourni, entrees, valeur) {
		return plusieurs ? A2(
			$rtfeldman$elm_css$Html$Styled$map,
			$author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Selectionne,
			A2(
				$author$project$Components$Shared$Champ$SelecteurNorme$view,
				i18n,
				{
					uN: fourni,
					yv: entrees,
					oJ: textes.oJ,
					G3: textes.G3,
					q3: function () {
						switch (valeur.$) {
							case 5:
								var selection = valeur.a;
								return selection;
							case 2:
								var choisis = valeur.a;
								return {jL: choisis, hC: ''};
							default:
								return {jL: _List_Nil, hC: ''};
						}
					}()
				})) : A2(
			$author$project$Components$Shared$Champ$View$liste,
			fourni,
			{
				hg: $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Ecrit,
				o_: A2(
					$elm$core$List$cons,
					{
						Bl: $author$project$I18n$Cles$saisieDeChampListeAucune(i18n),
						fm: ''
					},
					A2(
						$elm$core$List$map,
						function (entree) {
							return {Bl: entree.Dj, fm: entree.vx};
						},
						entrees)),
				fm: function () {
					if (valeur.$ === 1) {
						var saisi = valeur.a;
						return saisi;
					} else {
						return '';
					}
				}()
			});
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$numerique = F2(
	function (fourni, saisi) {
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$input,
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
					A2(
						$elm$core$List$cons,
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'inputmode', 'decimal'),
						A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Attributes$value(saisi),
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Ecrit),
								$author$project$Components$Shared$Champ$View$attributs(fourni))))),
				_List_Nil)
			]);
	});
var $author$project$I18n$Cles$saisieDeChampParLangue = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'saisie-de-champ.par-langue',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl)),
					_Utils_Tuple2(
					'langue',
					$author$project$I18n$Traductions$Chaine(p.nn))
				]),
			p.Bl + (' (' + (p.nn + ')')));
	});
var $author$project$Components$Shared$Champ$View$zoneDeTexte = F2(
	function (champ, saisie) {
		return A2(
			$author$project$Components$Shared$Champ$View$formItem,
			champ,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$textarea,
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$value(saisie.fm),
						A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Events$onInput(saisie.hg),
							$author$project$Components$Shared$Champ$View$controle(champ))),
					_List_Nil)
				]));
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$parLangue = F4(
	function (i18n, contexte, champ, valeur) {
		var textes = function () {
			if (valeur.$ === 4) {
				var saisis = valeur.a;
				return saisis;
			} else {
				return _List_Nil;
			}
		}();
		var de = function (code) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$second,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$first,
								$elm$core$Basics$eq(code)),
							textes))));
		};
		var poser = F2(
			function (code, saisi) {
				return $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$ParLangue(
					A2(
						$elm$core$List$map,
						function (autre) {
							return _Utils_Tuple2(
								autre,
								_Utils_eq(autre, code) ? saisi : de(autre));
						},
						contexte.Ba));
			});
		var un = F2(
			function (rang, code) {
				var fourni = {
					go: $elm$core$Maybe$Nothing,
					Aq: (!rang) ? contexte.Aq : (contexte.Aq + ('-' + code)),
					Bl: A2(
						$author$project$I18n$Cles$saisieDeChampParLangue,
						i18n,
						{
							nn: A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$langue, i18n, code),
							Bl: champ.Bl
						}),
					he: champ.he && (!rang)
				};
				return _Utils_eq(champ.r0, $author$project$Components$Shared$EditeurDeSchema$Champ$TexteLong) ? A2(
					$author$project$Components$Shared$Champ$View$zoneDeTexte,
					fourni,
					{
						hg: poser(code),
						fm: de(code)
					}) : A2(
					$author$project$Components$Shared$Champ$View$compose,
					fourni,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$input,
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
								A2(
									$elm$core$List$cons,
									$rtfeldman$elm_css$Html$Styled$Attributes$value(
										de(code)),
									A2(
										$elm$core$List$cons,
										$rtfeldman$elm_css$Html$Styled$Events$onInput(
											poser(code)),
										$author$project$Components$Shared$Champ$View$attributs(fourni)))),
							_List_Nil),
							A3(
							$author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$compteur,
							i18n,
							champ,
							de(code))
						]));
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('par-langue')
				]),
			A2($elm$core$List$indexedMap, un, contexte.Ba));
	});
var $author$project$Components$Shared$EditeurDeSchema$Champ$memesCodes = F2(
	function (langues, valeurs) {
		return (!_Utils_eq(langues, _List_Nil)) && _Utils_eq(
			$elm$core$List$sort(langues),
			$elm$core$List$sort(valeurs));
	});
var $author$project$Components$Shared$EditeurDeSchema$Champ$reconnaitreLesLangues = F2(
	function (langues, champ) {
		var _v0 = champ.r0;
		switch (_v0.$) {
			case 7:
				var valeurs = _v0.a;
				return A2($author$project$Components$Shared$EditeurDeSchema$Champ$memesCodes, langues, valeurs) ? $author$project$Components$Shared$EditeurDeSchema$Champ$langueDeLaFiche(champ) : champ;
			case 8:
				var valeurs = _v0.a.Ki;
				var min = _v0.a.Cx;
				var max = _v0.a.Cg;
				return (_Utils_eq(min, $elm$core$Maybe$Nothing) && (_Utils_eq(max, $elm$core$Maybe$Nothing) && A2($author$project$Components$Shared$EditeurDeSchema$Champ$memesCodes, langues, valeurs))) ? $author$project$Components$Shared$EditeurDeSchema$Champ$langueDeLaFiche(champ) : champ;
			default:
				return champ;
		}
	});
var $author$project$I18n$Cles$saisieDeChampCalcule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'saisie-de-champ.calcule', _List_Nil, 'Calculé : ce champ ne se saisit pas.');
};
var $author$project$I18n$Cles$saisieDeChampFichier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'saisie-de-champ.fichier', _List_Nil, 'Le fichier se dépose dans la fiche.');
};
var $author$project$I18n$Cles$saisieDeChampHorsLimites = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'saisie-de-champ.hors-limites',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'limite',
					$author$project$I18n$Traductions$Chaine(p.nV))
				]),
			'Hors limites : ' + (p.nV + '.'));
	});
var $author$project$I18n$Cles$saisieDeChampNonPrisEnCharge = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'saisie-de-champ.non-pris-en-charge', _List_Nil, 'Ce champ ne se saisit pas dans cet écran.');
};
var $author$project$I18n$Cles$selecteurNormeLanguesNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'selecteur-norme.langues.note', _List_Nil, 'Triées par nom. Une langue déjà choisie est cochée : la décocher la retire.');
};
var $author$project$I18n$Cles$selecteurNormeLanguesRechercher = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'selecteur-norme.langues.rechercher', _List_Nil, 'Rechercher une langue (nom ou code)');
};
var $author$project$I18n$Cles$selecteurNormePaysNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'selecteur-norme.pays.note', _List_Nil, 'Triés par nom. Un pays déjà choisi est coché : le décocher le retire.');
};
var $author$project$I18n$Cles$selecteurNormePaysRechercher = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'selecteur-norme.pays.rechercher', _List_Nil, 'Rechercher un pays (nom ou code)');
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$texteCourt = F2(
	function (fourni, saisi) {
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$input,
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$value(saisi),
						A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Ecrit),
							$author$project$Components$Shared$Champ$View$attributs(fourni)))),
				_List_Nil)
			]);
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$vue = F6(
	function (i18n, horsLimites, jugee, contexte, champBrut, valeur) {
		var saisi = function () {
			if (valeur.$ === 1) {
				var texte = valeur.a;
				return texte;
			} else {
				return '';
			}
		}();
		var ecrit = {hg: $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Ecrit, fm: saisi};
		var champ = A2(
			$author$project$Components$Shared$EditeurDeSchema$Champ$reconnaitreLesLangues,
			$author$project$Referentiel$Normes$codesDesLangues(contexte.hd),
			champBrut);
		var fourni = {
			go: function () {
				if (!horsLimites.$) {
					var limite = horsLimites.a;
					return $elm$core$Maybe$Just(
						A2(
							$author$project$I18n$Cles$saisieDeChampHorsLimites,
							i18n,
							{nV: limite}));
				} else {
					return jugee ? A2(
						$elm$core$Maybe$map,
						A3($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$message, i18n, contexte.sb, champ),
						$elm$core$List$head(
							A2($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$juger, champ, valeur))) : $elm$core$Maybe$Nothing;
				}
			}(),
			Aq: contexte.Aq,
			Bl: champ.Bl,
			he: champ.he
		};
		var inactif = function (dit) {
			return A2(
				$author$project$Components$Shared$Champ$View$compose,
				fourni,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$input,
						A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true),
								A2(
									$elm$core$List$cons,
									$rtfeldman$elm_css$Html$Styled$Attributes$value(''),
									$author$project$Components$Shared$Champ$View$attributs(fourni)))),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(dit)
							]))
					]));
		};
		if (!_Utils_eq(champ.zU, $elm$core$Maybe$Nothing)) {
			return inactif(
				$author$project$I18n$Cles$saisieDeChampCalcule(i18n));
		} else {
			if (champ.h8) {
				return A4($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$parLangue, i18n, contexte, champ, valeur);
			} else {
				var _v0 = champ.r0;
				switch (_v0.$) {
					case 0:
						return A2(
							$author$project$Components$Shared$Champ$View$compose,
							fourni,
							_Utils_ap(
								A2($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$texteCourt, fourni, saisi),
								_List_fromArray(
									[
										A3($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$compteur, i18n, champ, saisi)
									])));
					case 1:
						return A2($author$project$Components$Shared$Champ$View$zoneDeTexte, fourni, ecrit);
					case 2:
						return A3($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$miseEnForme, i18n, fourni, ecrit);
					case 3:
						return A2(
							$author$project$Components$Shared$Champ$View$compose,
							fourni,
							A2($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$numerique, fourni, saisi));
					case 4:
						return A2(
							$author$project$Components$Shared$Champ$View$compose,
							fourni,
							A2($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$numerique, fourni, saisi));
					case 5:
						return A2($author$project$Components$Shared$Champ$View$date, fourni, ecrit);
					case 6:
						return A2(
							$author$project$Components$Shared$Champ$View$caseACocher,
							fourni,
							{
								vt: _Utils_eq(
									valeur,
									$author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Coche(true)),
								D9: $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Coche
							});
					case 7:
						var valeurs = _v0.a;
						return A2(
							$author$project$Components$Shared$Champ$View$liste,
							fourni,
							{
								hg: $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Ecrit,
								o_: A2(
									$elm$core$List$cons,
									{
										Bl: $author$project$I18n$Cles$saisieDeChampListeAucune(i18n),
										fm: ''
									},
									A2(
										$elm$core$List$map,
										function (proposee) {
											return {
												Bl: A2(
													$elm$core$Maybe$withDefault,
													proposee,
													A3(
														$author$project$Components$Shared$EditeurDeSchema$Champ$libelleDeLaValeur,
														A2(
															$elm$core$Maybe$withDefault,
															'',
															$elm$core$List$head(contexte.Ba)),
														champ,
														proposee)),
												fm: proposee
											};
										},
										valeurs)),
								fm: saisi
							});
					case 8:
						var choix = _v0.a;
						return A2(
							$author$project$Components$Shared$Champ$View$compose,
							fourni,
							_List_fromArray(
								[
									A3($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$cases, contexte, choix.Ki, valeur)
								]));
					case 10:
						var mesure = _v0.a;
						return A2(
							$author$project$Components$Shared$Champ$View$compose,
							fourni,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('avec-unite')
										]),
									_Utils_ap(
										A2($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$numerique, fourni, saisi),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('unite')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2($author$project$Components$Shared$EditeurDeSchema$Propositions$symbole, contexte.sb, mesure.sa))
													]))
											])))
								]));
					case 11:
						return A2(
							$author$project$Components$Shared$Champ$View$compose,
							fourni,
							A2($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$texteCourt, fourni, saisi));
					case 12:
						return A2(
							$author$project$Components$Shared$Champ$View$compose,
							fourni,
							A2($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$texteCourt, fourni, saisi));
					case 13:
						return A6(
							$author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$normee,
							i18n,
							false,
							{
								oJ: $author$project$I18n$Cles$saisieDeChampListeAucune(i18n),
								G3: $author$project$I18n$Cles$saisieDeChampListeAucune(i18n)
							},
							fourni,
							$author$project$Referentiel$Normes$entreesDeDevises(contexte.hd),
							valeur);
					case 15:
						var choix = _v0.a;
						return A6(
							$author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$normee,
							i18n,
							choix.FS,
							{
								oJ: $author$project$I18n$Cles$selecteurNormePaysNote(i18n),
								G3: $author$project$I18n$Cles$selecteurNormePaysRechercher(i18n)
							},
							fourni,
							$author$project$Referentiel$Normes$entreesDePays(contexte.hd),
							valeur);
					case 16:
						var choix = _v0.a;
						return A6(
							$author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$normee,
							i18n,
							choix.FS,
							{
								oJ: $author$project$I18n$Cles$selecteurNormeLanguesNote(i18n),
								G3: $author$project$I18n$Cles$selecteurNormeLanguesRechercher(i18n)
							},
							fourni,
							$author$project$Referentiel$Normes$entreesDeLangues(contexte.hd),
							valeur);
					case 9:
						return inactif(
							$author$project$I18n$Cles$saisieDeChampFichier(i18n));
					case 14:
						return A2(
							$author$project$Components$Shared$Champ$View$compose,
							fourni,
							_List_fromArray(
								[
									A4($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$adresse, i18n, contexte, fourni, valeur)
								]));
					case 17:
						return inactif(
							$author$project$I18n$Cles$saisieDeChampNonPrisEnCharge(i18n));
					case 18:
						return inactif(
							$author$project$I18n$Cles$saisieDeChampNonPrisEnCharge(i18n));
					case 19:
						return inactif(
							$author$project$I18n$Cles$saisieDeChampNonPrisEnCharge(i18n));
					case 20:
						return inactif(
							$author$project$I18n$Cles$saisieDeChampNonPrisEnCharge(i18n));
					case 21:
						return inactif(
							$author$project$I18n$Cles$saisieDeChampNonPrisEnCharge(i18n));
					case 22:
						return inactif(
							$author$project$I18n$Cles$saisieDeChampNonPrisEnCharge(i18n));
					default:
						return inactif(
							$author$project$I18n$Cles$saisieDeChampNonPrisEnCharge(i18n));
				}
			}
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$view = function (i18n) {
	return A3($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$vue, i18n, $elm$core$Maybe$Nothing, true);
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$viewHorsLimites = F2(
	function (i18n, limite) {
		return A3(
			$author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$vue,
			i18n,
			$elm$core$Maybe$Just(limite),
			true);
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$viewSansJugement = function (i18n) {
	return A3($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$vue, i18n, $elm$core$Maybe$Nothing, false);
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$vueDuChamp = F3(
	function (i18n, limite, jugee) {
		var _v0 = _Utils_Tuple2(limite, jugee);
		if (!_v0.a.$) {
			var dite = _v0.a.a;
			return A2($author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$viewHorsLimites, i18n, dite);
		} else {
			if (_v0.b) {
				var _v1 = _v0.a;
				return $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$view(i18n);
			} else {
				var _v2 = _v0.a;
				return $author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$viewSansJugement(i18n);
			}
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$caracteristique = F5(
	function (i18n, indications, presentation, saisie, champ) {
		var refus = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.uN;
					},
					$elm$core$Basics$eq(champ.dy)),
				saisie.pZ));
		var parDefaut = _Utils_eq(
			$elm$core$List$head(presentation.Ba),
			$elm$core$Maybe$Just(saisie.nn));
		var jugee = (!saisie.eK) || (saisie.b5 || (!_Utils_eq(
			A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$valeurDe, champ.dy, saisie.Ki),
			A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$valeurDe, champ.dy, saisie.AP))));
		var fautif = saisie.b5 && A2(
			$elm$core$List$member,
			champ.dy,
			A2(
				$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$fautes,
				_List_fromArray(
					[champ]),
				saisie));
		var dit = function () {
			var _v1 = _Utils_Tuple2(refus, fautif && champ.h8);
			if (!_v1.a.$) {
				var refuse = _v1.a.a;
				return A4($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$messageDuRefus, i18n, presentation, champ, refuse);
			} else {
				if (_v1.b) {
					var _v2 = _v1.a;
					return $author$project$I18n$Cles$saisieDeChampObligatoire(i18n);
				} else {
					var _v3 = _v1.a;
					return '';
				}
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('caracteristique'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'error',
							fautif || (!_Utils_eq(refus, $elm$core$Maybe$Nothing)))
						]))
				]),
			_List_fromArray(
				[
					indications.bB ? A4($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$detailDuChamp, i18n, indications.ou, presentation, champ) : $rtfeldman$elm_css$Html$Styled$text(''),
					A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$Saisi(champ.dy),
					function () {
						var _v0 = A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$choixDe, presentation, champ);
						if (!_v0.$) {
							var choix = _v0.a;
							return A5($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$listeDeChoix, i18n, presentation, saisie, champ, choix);
						} else {
							return A6(
								$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$vueDuChamp,
								i18n,
								A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$textesDe, champ.dy, saisie.d1),
								jugee,
								{
									Aq: A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$idDuChamp, presentation.pv, champ.dy),
									Ba: champ.h8 ? _List_fromArray(
										[saisie.nn]) : presentation.Ba,
									hd: presentation.hd,
									sb: presentation.sb
								},
								_Utils_update(
									champ,
									{he: champ.he && (parDefaut || (!champ.h8))}),
								A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$valeurDe, champ.dy, saisie.Ki));
						}
					}()),
					A3($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$boutonDeRecherche, i18n, presentation, champ),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('refus')
						]),
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$text(dit),
						A3($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$lienDeLaFichePrise, i18n, saisie, refus)))
				]));
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$enMilliers = F2(
	function (i18n, nombre) {
		if (A2($elm$core$String$startsWith, '-', nombre)) {
			return '-' + A2(
				$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$enMilliers,
				i18n,
				A2($elm$core$String$dropLeft, 1, nombre));
		} else {
			var _v0 = A2($elm$core$String$split, ',', nombre);
			if (_v0.b) {
				var entier = _v0.a;
				var decimales = _v0.b;
				return A2($elm$core$String$all, $elm$core$Char$isDigit, entier) ? A2(
					$elm$core$Maybe$withDefault,
					nombre,
					A2(
						$elm$core$Maybe$map,
						function (lu) {
							return A2(
								$elm$core$String$join,
								',',
								A2(
									$elm$core$List$cons,
									A2(
										$author$project$I18n$Nombre$formater,
										$author$project$I18n$Traductions$langue(i18n),
										lu),
									decimales));
						},
						$elm$core$String$toInt(entier))) : nombre;
			} else {
				return nombre;
			}
		}
	});
var $author$project$I18n$Cles$produitsCatalogueInfoSansValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.info.sans-valeur', _List_Nil, '—');
};
var $author$project$Components$Shared$Champ$SelecteurNorme$lecture = F3(
	function (i18n, entrees, choisis) {
		var nomDe = function (code) {
			return A2($author$project$Referentiel$Normes$nomDeCode, entrees, code);
		};
		var puce = function (code) {
			var _v0 = nomDe(code);
			if (!_v0.$) {
				var nom = _v0.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('puce')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('tag'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('accent')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(nom),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('code')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(code)
										]))
								]))
						]));
			} else {
				return A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('puce'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('retiree')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('tag'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('ambre')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(code),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('code')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$selecteurNormeCodeRetire(i18n))
										]))
								]))
						]));
			}
		};
		return $elm$core$List$isEmpty(choisis) ? $rtfeldman$elm_css$Html$Styled$text(
			$author$project$I18n$Cles$produitsCatalogueInfoSansValeur(i18n)) : A2(
			$rtfeldman$elm_css$Html$Styled$ul,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('puces')
				]),
			A2(
				$elm$core$List$map,
				puce,
				A2(
					$elm$core$List$sortBy,
					function (code) {
						return $author$project$Referentiel$Normes$plier(
							A2(
								$elm$core$Maybe$withDefault,
								code,
								nomDe(code)));
					},
					choisis)));
	});
var $author$project$I18n$Cles$referentielFicheChampsDuTypeFormule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.champs-du-type.formule', _List_Nil, 'formule');
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$mentionFormule = function (i18n) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$span,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('formule')
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$I18n$Cles$referentielFicheChampsDuTypeFormule(i18n))
			]));
};
var $author$project$I18n$Cles$produitsReferenceSaisieNon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.saisie.non', _List_Nil, 'Non');
};
var $author$project$I18n$Cles$produitsReferenceSaisieOui = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.saisie.oui', _List_Nil, 'Oui');
};
var $author$project$I18n$Cles$saisieDeChampLibelleCalcule = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'saisie-de-champ.libelle-calcule',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			p.Bl + ' (calculé)');
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$enLecture = F5(
	function (i18n, etiquette, presentation, saisie, champBrut) {
		var champ = A2(
			$author$project$Components$Shared$EditeurDeSchema$Champ$reconnaitreLesLangues,
			$author$project$Referentiel$Normes$codesDesLangues(presentation.hd),
			champBrut);
		var choixLu = A2(
			$elm$core$Maybe$map,
			function (c) {
				return _Utils_update(
					c,
					{
						pE: $author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$montrees(c)
					});
			},
			A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$choixDe, presentation, champ));
		var libelleLu = function (id) {
			return A2(
				$elm$core$Maybe$withDefault,
				id,
				A2(
					$elm$core$Maybe$andThen,
					function (c) {
						return A2(
							$elm$core$Maybe$map,
							A3($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$libelleDeValeur, i18n, c, saisie.nn),
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.Aq;
										},
										$elm$core$Basics$eq(id)),
									c.pE)));
					},
					choixLu));
		};
		var mention = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (_v5) {
					return _List_fromArray(
						[
							$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$mentionFormule(i18n)
						]);
				},
				champ.zU));
		var valeurEcrite = A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$valeurDe, champ.dy, saisie.Ki);
		var codes = function () {
			switch (valeurEcrite.$) {
				case 5:
					var selection = valeurEcrite.a;
					return selection.jL;
				case 2:
					var choisis = valeurEcrite.a;
					return choisis;
				case 1:
					var texte = valeurEcrite.a;
					return ($elm$core$String$trim(texte) === '') ? _List_Nil : _List_fromArray(
						[texte]);
				default:
					return _List_Nil;
			}
		}();
		var absent = $author$project$I18n$Cles$produitsCatalogueInfoSansValeur(i18n);
		var ecrit = function (texte) {
			if ($elm$core$String$trim(texte) === '') {
				return absent;
			} else {
				var _v3 = champ.r0;
				switch (_v3.$) {
					case 10:
						var mesure = _v3.a;
						return A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$enMilliers, i18n, texte) + (' ' + A2($author$project$Components$Shared$EditeurDeSchema$Propositions$symbole, presentation.sb, mesure.sa));
					case 3:
						return A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$enMilliers, i18n, texte);
					case 4:
						return A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$enMilliers, i18n, texte);
					case 5:
						return A2($author$project$Texte$Jour$enFrancais, i18n, texte);
					case 15:
						return A2($author$project$Referentiel$Normes$nomDePays, presentation.hd, texte);
					case 16:
						return A2(
							$elm$core$Maybe$withDefault,
							texte,
							A2(
								$author$project$Referentiel$Normes$nomDeCode,
								$author$project$Referentiel$Normes$entreesDeLangues(presentation.hd),
								texte));
					default:
						return texte;
				}
			}
		};
		var texteLu = _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				function () {
					switch (valeurEcrite.$) {
						case 5:
							var selection = valeurEcrite.a;
							return A2(
								$elm$core$String$join,
								', ',
								A2($elm$core$List$map, libelleLu, selection.jL));
						case 1:
							var texte = valeurEcrite.a;
							return ecrit(
								libelleLu(texte));
						case 2:
							if (!valeurEcrite.a.b) {
								return absent;
							} else {
								var choisis = valeurEcrite.a;
								return A2(
									$elm$core$String$join,
									', ',
									A2($elm$core$List$map, libelleLu, choisis));
							}
						case 3:
							if (valeurEcrite.a) {
								return $author$project$I18n$Cles$produitsReferenceSaisieOui(i18n);
							} else {
								return $author$project$I18n$Cles$produitsReferenceSaisieNon(i18n);
							}
						case 4:
							var textes = valeurEcrite.a;
							return ecrit(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$textesDe, saisie.nn, textes)));
						case 6:
							var lue = valeurEcrite.a;
							return A2(
								$elm$core$String$join,
								', ',
								A2(
									$elm$core$List$filter,
									$elm$core$Basics$neq(''),
									A2(
										$elm$core$List$map,
										$elm$core$String$trim,
										_List_fromArray(
											[
												lue.a3,
												lue.a4,
												lue.a5,
												lue.vz + (' ' + lue.B_),
												lue.Hj,
												(lue.ho === '') ? '' : A2($author$project$Referentiel$Normes$nomDePays, presentation.hd, lue.ho)
											]))));
						default:
							return absent;
					}
				}())
			]);
		var valeurLue = function () {
			var _v1 = champ.r0;
			switch (_v1.$) {
				case 15:
					var choix = _v1.a;
					return choix.FS ? _List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Champ$SelecteurNorme$lecture,
							i18n,
							$author$project$Referentiel$Normes$entreesDePays(presentation.hd),
							codes)
						]) : texteLu;
				case 16:
					var choix = _v1.a;
					return choix.FS ? _List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Champ$SelecteurNorme$lecture,
							i18n,
							$author$project$Referentiel$Normes$entreesDeLangues(presentation.hd),
							codes)
						]) : texteLu;
				default:
					return texteLu;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'calcule',
							!_Utils_eq(champ.zU, $elm$core$Maybe$Nothing))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							function () {
								var _v0 = champ.zU;
								if (!_v0.$) {
									return A2(
										$author$project$I18n$Cles$saisieDeChampLibelleCalcule,
										i18n,
										{Bl: champ.Bl});
								} else {
									return champ.Bl;
								}
							}())
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_Nil,
					_Utils_ap(valeurLue, mention)),
					A2(
					$elm$core$Maybe$withDefault,
					$rtfeldman$elm_css$Html$Styled$text(''),
					A2(
						$elm$core$Maybe$map,
						function (texte) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('tag'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('etiquette')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(texte)
									]));
						},
						etiquette))
				]));
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$estUnGroupe = function (type_) {
	if (type_.$ === 22) {
		return true;
	} else {
		return false;
	}
};
var $author$project$I18n$Cles$produitsReferenceSaisieLangues = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.saisie.langues', _List_Nil, 'Langue des textes');
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$viewAvecIndications = F4(
	function (i18n, indications, fournie, saisie) {
		var presentation = _Utils_update(
			fournie,
			{
				dw: A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.r0;
						},
						A2($elm$core$Basics$composeR, $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$estUnGroupe, $elm$core$Basics$not)),
					fournie.dw)
			});
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('langues'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'group'),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-label',
						$author$project$I18n$Cles$produitsReferenceSaisieLangues(i18n))
					]),
				A2(
					$elm$core$List$any,
					function ($) {
						return $.h8;
					},
					presentation.dw) ? A2(
					$elm$core$List$map,
					A3($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$boutonDeLangue, i18n, presentation, saisie),
					presentation.Ba) : _List_Nil),
				presentation.np ? A2(
				$rtfeldman$elm_css$Html$Styled$ul,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('infos')
					]),
				A2(
					$elm$core$List$map,
					A4($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$enLecture, i18n, indications.yS, presentation, saisie),
					presentation.dw)) : A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('champs')
					]),
				A2(
					$elm$core$List$map,
					A4($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$caracteristique, i18n, indications, presentation, saisie),
					presentation.dw))
			]);
	});
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$view = function (i18n) {
	return A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$viewAvecIndications, i18n, $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$aucuneIndication);
};
var $author$project$Components$Produits$Catalogue$View$informationsDuType = F3(
	function (i18n, model, catalogue) {
		var _v0 = model.hP.aN;
		if (!_v0.$) {
			var schema = _v0.a;
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('informations')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('en-tete')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.Dj;
														},
														function ($) {
															return $.zX;
														}),
													$elm$core$List$head(
														A2(
															$elm$core$List$filter,
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.Aq;
																},
																$elm$core$Basics$eq(schema.r0)),
															catalogue.ib)))))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsReferencesCreationInformationsAide(i18n))
										]))
								])),
						A2(
							$elm$core$List$map,
							$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Produits$Catalogue$Creation$Information),
							A3(
								$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$view,
								i18n,
								{
									fr: function (_v1) {
										return 0;
									},
									dw: schema.dw,
									jN: schema.jN,
									Ba: A2(
										$elm$core$List$map,
										function ($) {
											return $.vx;
										},
										$author$project$Referentiel$Langues$desLibelles),
									np: false,
									hd: model.hd,
									pv: $author$project$Components$Produits$Catalogue$Creation$prefixeDesInformations(
										$author$project$Components$Shared$Drawer$Model$idRacine(model.kX)),
									sb: _List_Nil
								},
								model.hP.i8))))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$I18n$Cles$produitsReferencesCreationInformationsASaisir = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.creation.informations-a-saisir',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w)),
					_Utils_Tuple2(
					'detail',
					$author$project$I18n$Traductions$Chaine(p.bB))
				]),
			'Puis ' + (p.w + (' informations à saisir : ' + (p.bB + '.'))));
	});
var $author$project$I18n$Cles$produitsReferencesCreationInformationsOrigineCatalogue = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.creation.informations-origine-catalogue',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			p.w + ' communes');
	});
var $author$project$I18n$Cles$produitsReferencesCreationInformationsOrigineCategorie = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.creation.informations-origine-categorie',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.w + (' des ' + p.Dj));
	});
var $author$project$I18n$Cles$produitsReferencesCreationInformationsOrigineNoeud = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.creation.informations-origine-noeud',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.w + (' de ' + p.Dj));
	});
var $author$project$I18n$Cles$produitsReferencesCreationInformationsOrigineTypologie = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.creation.informations-origine-typologie',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.w + (' de l\'' + p.Dj));
	});
var $author$project$Components$Produits$Catalogue$View$ligneDesInformations = F3(
	function (i18n, model, catalogue) {
		var _v0 = model.hP.aN;
		if (!_v0.$) {
			var schema = _v0.a;
			var nommee = F3(
				function (nombre, cle, nom) {
					return (!nombre) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						cle(
							{
								Dj: nom,
								w: $elm$core$String$fromInt(nombre)
							}));
				});
			var de = function (origine) {
				return $elm$core$List$length(
					A2(
						$elm$core$List$filter,
						function (champ) {
							return _Utils_eq(
								A2($elm$core$Dict$get, champ.dy, schema.hj),
								$elm$core$Maybe$Just(origine));
						},
						schema.dw));
			};
			var categorie = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Dj;
						},
						function ($) {
							return $.zX;
						}),
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(schema.r0)),
							catalogue.ib))));
			var parties = A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A3(
						nommee,
						de('catalogue'),
						function (v) {
							return A2(
								$author$project$I18n$Cles$produitsReferencesCreationInformationsOrigineCatalogue,
								i18n,
								{w: v.w});
						},
						''),
						A3(
						nommee,
						de('typologie'),
						$author$project$I18n$Cles$produitsReferencesCreationInformationsOrigineTypologie(i18n),
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.Dj;
									},
									$elm$core$String$toLower),
								model.hP.r3))),
						A3(
						nommee,
						de('noeud'),
						$author$project$I18n$Cles$produitsReferencesCreationInformationsOrigineNoeud(i18n),
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								$elm$core$String$join(', '),
								A2(
									$elm$core$Maybe$andThen,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.jK;
										},
										$author$project$Catalogue$Chemin$noms),
									model.hP.r3)))),
						A3(
						nommee,
						de('categorie'),
						$author$project$I18n$Cles$produitsReferencesCreationInformationsOrigineCategorie(i18n),
						$elm$core$String$toLower(categorie))
					]));
			return A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('informations-a-saisir')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$produitsReferencesCreationInformationsASaisir,
							i18n,
							{
								bB: A2($elm$core$String$join, ', ', parties),
								w: $elm$core$String$fromInt(
									$elm$core$List$length(schema.dw))
							}))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$produitsParcoursVerificationCreer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.verification.creer', _List_Nil, 'Créer la première référence');
};
var $author$project$Components$Produits$Catalogue$Creation$schemaEnAttente = F2(
	function (catalogue, saisie) {
		var _v0 = A2($author$project$Components$Produits$Catalogue$Creation$schemaDemande, catalogue, saisie);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var type_ = _v1.a;
			return _Utils_eq(saisie.aN, $elm$core$Maybe$Nothing) && (!_Utils_eq(
				A2($author$project$Components$Produits$Liens$versLeSchemaEffectif, type_, catalogue.gF),
				$elm$core$Maybe$Nothing));
		} else {
			return false;
		}
	});
var $author$project$Components$Produits$Catalogue$View$formulaireEmbarque = F2(
	function (i18n, model) {
		return A2(
			$elm$core$Maybe$map,
			function (catalogue) {
				var parties = A3($author$project$Components$Produits$Catalogue$View$formulaire, i18n, model, catalogue);
				var actif = (!$author$project$Components$Produits$Common$Envoi$enCours(model.l2)) && (_Utils_eq(
					$author$project$Components$Produits$Catalogue$Creation$etageManquant(model.hP),
					$elm$core$Maybe$Nothing) && (!A2($author$project$Components$Produits$Catalogue$Creation$schemaEnAttente, catalogue, model.hP)));
				return {
					uK: A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Dj;
							},
							function ($) {
								return $.zX;
							}),
						A2(
							$elm$core$Maybe$andThen,
							function (schema) {
								return $elm$core$List$head(
									A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.Aq;
											},
											$elm$core$Basics$eq(schema.r0)),
										catalogue.ib));
							},
							model.hP.aN)),
					wo: model.f1,
					dC: A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('primary'),
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'loading',
										$author$project$Components$Produits$Common$Envoi$enCours(model.l2))
									])),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!actif),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Catalogue$Update$CreationDemandee)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsParcoursVerificationCreer(i18n))
									]))
							])),
					zT: A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('formulaire-de-reference')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer-content')
									]),
								A2(
									$elm$core$List$map,
									$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Produits$Catalogue$Update$Saisi),
									parties.hA)),
								A3($author$project$Components$Produits$Catalogue$View$ligneDesInformations, i18n, model, catalogue),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer-content')
									]),
								A2(
									$elm$core$List$map,
									$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Produits$Catalogue$Update$Saisi),
									parties.fT)),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer-content')
									]),
								A2(
									$elm$core$List$map,
									$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Produits$Catalogue$Update$Saisi),
									A3($author$project$Components$Produits$Catalogue$View$informationsDuType, i18n, model, catalogue)))
							])),
					hA: A2(
						$elm$core$List$filter,
						$elm$core$Basics$neq(''),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.Dj;
									},
									model.hP.r3)),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (typologie) {
										return A2(
											$elm$core$List$filterMap,
											function (_v0) {
												var etage = _v0.a;
												return A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.Dj;
													},
													A2($author$project$Catalogue$Chemin$choisiSur, typologie.jK, etage));
											},
											$author$project$Catalogue$Chemin$colonnes(typologie.jK));
									},
									model.hP.r3))))
				};
			},
			$author$project$Components$Produits$Catalogue$View$enCreation(model));
	});
var $author$project$Components$Shared$Note$View$Erreur = 2;
var $author$project$Components$Parametrage$CollectionsDeChamps$View$codeDeLaPortee = function (portee) {
	if (!portee) {
		return 'catalogue';
	} else {
		return 'parties-prenantes';
	}
};
var $author$project$I18n$Cles$collectionsEchecDeLecture = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.echec-de-lecture', _List_Nil, 'Les collections n\'ont pas pu être lues. Rechargez la page.');
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$CleSaisie = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$CreationEnvoyee = {$: 15};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$LibelleSaisi = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Parametrage$Vocabulaire$serviLeCatalogue = function (portee) {
	return portee !== 'parties-prenantes';
};
var $author$project$Components$Parametrage$Vocabulaire$serviLesPartiesPrenantes = function (portee) {
	return portee !== 'catalogue';
};
var $author$project$Components$Parametrage$CollectionsDeChamps$View$champsDeLaPortee = function (portee) {
	return $elm$core$List$filter(
		function (champ) {
			if (!portee) {
				return $author$project$Components$Parametrage$Vocabulaire$serviLeCatalogue(champ.F$);
			} else {
				return $author$project$Components$Parametrage$Vocabulaire$serviLesPartiesPrenantes(champ.F$);
			}
		});
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$ChampBascule = function (a) {
	return {$: 14, a: a};
};
var $author$project$I18n$Cles$collectionsCreationChampDejaDans = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'collections.creation.champ.deja-dans',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'collection',
					$author$project$I18n$Traductions$Chaine(p.vD))
				]),
			'déjà dans ' + p.vD);
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$View$libelleDeLaCollection = F2(
	function (model, cle) {
		return A2(
			$elm$core$Maybe$withDefault,
			cle,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (c) {
							return _Utils_eq(c.dy, cle);
						},
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.vE;
								},
								model.vE))))));
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$View$choixDeChamp = F3(
	function (i18n, model, champ) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('champ-propose'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					_Utils_eq(champ.vD, $elm$core$Maybe$Nothing) ? 'libre' : 'pris')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id('collections-champ-' + champ.Aq),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(
							A2($elm$core$List$member, champ.Aq, model.jD)),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
							!_Utils_eq(champ.vD, $elm$core$Maybe$Nothing)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Parametrage$CollectionsDeChamps$Update$ChampBascule(champ.Aq))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(champ.Bl)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('type')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(champ.rU)
						])),
					function () {
					var _v0 = champ.vD;
					if (!_v0.$) {
						var cle = _v0.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('deja-dans')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$collectionsCreationChampDejaDans,
										i18n,
										{
											vD: A2($author$project$Components$Parametrage$CollectionsDeChamps$View$libelleDeLaCollection, model, cle)
										}))
								]));
					} else {
						return $rtfeldman$elm_css$Html$Styled$text('');
					}
				}()
				]));
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$PorteeChoisie = function (a) {
	return {$: 13, a: a};
};
var $author$project$I18n$Cles$collectionsPorteePartiesPrenantes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.portee.parties-prenantes', _List_Nil, 'Parties prenantes');
};
var $author$project$I18n$Cles$collectionsPorteeProduits = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.portee.produits', _List_Nil, 'Produits');
};
var $author$project$Components$Parametrage$CollectionsDeChamps$View$libelleDeLaPortee = F2(
	function (i18n, portee) {
		if (!portee) {
			return $author$project$I18n$Cles$collectionsPorteeProduits(i18n);
		} else {
			return $author$project$I18n$Cles$collectionsPorteePartiesPrenantes(i18n);
		}
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$View$choixDePortee = F3(
	function (i18n, model, choisie) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('portee')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
							$rtfeldman$elm_css$Html$Styled$Attributes$name('collections-portee'),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(
							A2($author$project$Components$Parametrage$CollectionsDeChamps$View$libelleDeLaPortee, i18n, choisie)),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(
							_Utils_eq(model.F$, choisie)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Parametrage$CollectionsDeChamps$Update$PorteeChoisie(choisie))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Parametrage$CollectionsDeChamps$View$libelleDeLaPortee, i18n, choisie))
						]))
				]));
	});
var $author$project$I18n$Cles$collectionsCle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.cle', _List_Nil, 'Clé');
};
var $author$project$I18n$Cles$collectionsCleAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.cle.aide', _List_Nil, 'Figée après la création ; sert aux imports et aux liens. Vide, elle est tirée du libellé.');
};
var $author$project$I18n$Cles$collectionsColonnePortee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.colonne.portee', _List_Nil, 'Portée');
};
var $author$project$I18n$Cles$collectionsCreationAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.creation.action', _List_Nil, 'Créer la collection');
};
var $author$project$I18n$Cles$collectionsCreationChamps = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'collections.creation.champs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Champs de la collection (' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' choisi)')) : ('Champs de la collection (' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' choisis)')));
	});
var $author$project$I18n$Cles$collectionsCreationChampsAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.creation.champs.aide', _List_Nil, 'Un champ n\'appartient qu\'à une collection. Les champs « sans collection » sont proposés ; ceux déjà rangés ailleurs sont grisés.');
};
var $author$project$I18n$Cles$collectionsCreationDroitRequis = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.creation.droit-requis', _List_Nil, 'Droit requis : Paramétrage du catalogue');
};
var $author$project$I18n$Cles$collectionsCreationKicker = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.creation.kicker', _List_Nil, 'Bibliothèque de champs');
};
var $author$project$I18n$Cles$collectionsCreationTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.creation.titre', _List_Nil, 'Créer une collection');
};
var $author$project$I18n$Cles$collectionsLibelleFrancais = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.libelle-francais', _List_Nil, 'Libellé (français)');
};
var $author$project$I18n$Cles$collectionsPorteeAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.portee.aide', _List_Nil, 'Seuls les champs de cette portée peuvent entrer.');
};
var $author$project$I18n$Cles$collectionsRefusAcces = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.refus.acces', _List_Nil, 'Vous n\'avez pas le droit de gérer les collections. Demandez à une personne qui gère le paramétrage du catalogue.');
};
var $author$project$I18n$Cles$collectionsRefusAutre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.refus.autre', _List_Nil, 'La commande a été refusée. Rechargez la page et reprenez.');
};
var $author$project$I18n$Cles$collectionsRefusChampDejaDans = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'collections.refus.champ-deja-dans',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'collection',
					$author$project$I18n$Traductions$Chaine(p.vD))
				]),
			'Un champ choisi est déjà dans la collection « ' + (p.vD + ' ». Décochez-le, ou sortez-le d\'abord de cette collection.'));
	});
var $author$project$I18n$Cles$collectionsRefusCleDejaPrise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.refus.cle-deja-prise', _List_Nil, 'Une collection porte déjà cette clé. Choisissez-en une autre.');
};
var $author$project$I18n$Cles$collectionsRefusHorsPortee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.refus.hors-portee', _List_Nil, 'Un champ choisi ne sert pas la portée de cette collection. Décochez-le.');
};
var $author$project$Components$Parametrage$CollectionsDeChamps$View$erreurDeCreation = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(
			(!_Utils_eq(model.ir, $elm$core$Maybe$Nothing)) || (!_Utils_eq(model.fr, $elm$core$Maybe$Nothing)),
			model.pZ);
		if ((!_v0.a) && (!_v0.b.$)) {
			switch (_v0.b.a.$) {
				case 1:
					var _v1 = _v0.b.a;
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$collectionsRefusCleDejaPrise(i18n))
							]));
				case 2:
					var cle = _v0.b.a.a;
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$collectionsRefusChampDejaDans,
									i18n,
									{
										vD: A2($author$project$Components$Parametrage$CollectionsDeChamps$View$libelleDeLaCollection, model, cle)
									}))
							]));
				case 3:
					var _v2 = _v0.b.a;
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$collectionsRefusHorsPortee(i18n))
							]));
				case 4:
					var _v3 = _v0.b.a;
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$collectionsRefusAcces(i18n))
							]));
				default:
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$collectionsRefusAutre(i18n))
							]));
			}
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$View$contenuDeCreation = F3(
	function (i18n, champs, model) {
		return {
			fs: {
				sR: $author$project$Components$Parametrage$CollectionsDeChamps$Model$creationPrete(model) && (!$author$project$API$Envoi$enCours(model.l2)),
				Bl: $author$project$I18n$Cles$collectionsCreationAction(i18n),
				C$: $author$project$Components$Parametrage$CollectionsDeChamps$Update$CreationEnvoyee
			},
			fZ: _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Champ$View$texte,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: 'collections-libelle',
						Bl: $author$project$I18n$Cles$collectionsLibelleFrancais(i18n),
						he: true
					},
					{hg: $author$project$Components$Parametrage$CollectionsDeChamps$Update$LibelleSaisi, fm: model.Bl}),
					A2(
					$author$project$Components$Shared$Champ$View$texteAvecIndication,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: 'collections-cle',
						Bl: $author$project$I18n$Cles$collectionsCle(i18n),
						he: false
					},
					{
						na: $elm$core$Maybe$Just(
							$author$project$I18n$Cles$collectionsCleAide(i18n)),
						hg: $author$project$Components$Parametrage$CollectionsDeChamps$Update$CleSaisie,
						fm: model.dy
					}),
					A2(
					$rtfeldman$elm_css$Html$Styled$fieldset,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('portees')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$legend,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$collectionsColonnePortee(i18n))
										]))
								])),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								A2($author$project$Components$Parametrage$CollectionsDeChamps$View$choixDePortee, i18n, model),
								_List_fromArray(
									[0, 1])),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$collectionsPorteeAide(i18n))
										]))
								])))),
					A2(
					$rtfeldman$elm_css$Html$Styled$fieldset,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('champs-de-la-collection')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$legend,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$collectionsCreationChamps,
												i18n,
												{
													w: $elm$core$List$length(model.jD)
												}))
										]))
								])),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								A2($author$project$Components$Parametrage$CollectionsDeChamps$View$choixDeChamp, i18n, model),
								A2($author$project$Components$Parametrage$CollectionsDeChamps$View$champsDeLaPortee, model.F$, champs)),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$collectionsCreationChampsAide(i18n))
										]))
								])))),
					A2($author$project$Components$Parametrage$CollectionsDeChamps$View$erreurDeCreation, i18n, model),
					(!model.F$) ? A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('droit-requis')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$collectionsCreationDroitRequis(i18n))
						])) : $rtfeldman$elm_css$Html$Styled$text('')
				]),
			A6: $elm$core$Maybe$Just(
				$author$project$I18n$Cles$collectionsCreationKicker(i18n)),
			Bc: false,
			h6: $author$project$I18n$Cles$collectionsCreationTitre(i18n)
		};
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$View$drawerDeCreation = F3(
	function (i18n, champs, model) {
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Parametrage$CollectionsDeChamps$Update$DuDrawerDeCreation,
			A3($author$project$Components$Parametrage$CollectionsDeChamps$View$contenuDeCreation, i18n, champs, model),
			model.k7);
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$AnglaisSaisi = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$FrancaisSaisi = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$TraductionEnvoyee = {$: 9};
var $author$project$I18n$Cles$collectionsLangueAnglais = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.langue.anglais', _List_Nil, 'English');
};
var $author$project$I18n$Cles$collectionsLangueFrancais = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.langue.francais', _List_Nil, 'Français');
};
var $author$project$I18n$Cles$collectionsTraductionAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.traduction.action', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$collectionsTraductionAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.traduction.aide', _List_Nil, 'Au moins le français est obligatoire. Un libellé changé se voit partout (fiches, pages d\'étage, bibliothèque) sans toucher aux fiches existantes.');
};
var $author$project$I18n$Cles$collectionsTraductionSousTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.traduction.sous-titre', _List_Nil, 'Libellé par langue.');
};
var $author$project$I18n$Cles$collectionsTraductionTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'collections.traduction.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'collection',
					$author$project$I18n$Traductions$Chaine(p.vD))
				]),
			'Traduire « ' + (p.vD + ' »'));
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$View$drawerDeTraduction = F2(
	function (i18n, model) {
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Parametrage$CollectionsDeChamps$Update$DuDrawerDeTraduction,
			{
				fs: {
					sR: $author$project$Components$Parametrage$CollectionsDeChamps$Model$traductionPrete(model) && (!$author$project$API$Envoi$enCours(model.l2)),
					Bl: $author$project$I18n$Cles$collectionsTraductionAction(i18n),
					C$: $author$project$Components$Parametrage$CollectionsDeChamps$Update$TraductionEnvoyee
				},
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$collectionsTraductionSousTitre(i18n))
							])),
						A2(
						$author$project$Components$Shared$Champ$View$texte,
						{
							go: $elm$core$Maybe$Nothing,
							Aq: 'collections-francais',
							Bl: $author$project$I18n$Cles$collectionsLangueFrancais(i18n),
							he: true
						},
						{hg: $author$project$Components$Parametrage$CollectionsDeChamps$Update$FrancaisSaisi, fm: model.dY}),
						A2(
						$author$project$Components$Shared$Champ$View$texteAvecIndication,
						{
							go: $elm$core$Maybe$Nothing,
							Aq: 'collections-anglais',
							Bl: $author$project$I18n$Cles$collectionsLangueAnglais(i18n),
							he: false
						},
						{
							na: $elm$core$Maybe$Just(
								$author$project$I18n$Cles$collectionsTraductionAide(i18n)),
							hg: $author$project$Components$Parametrage$CollectionsDeChamps$Update$AnglaisSaisi,
							fm: model.t
						}),
						function () {
						var _v0 = _Utils_Tuple2(model.fr, model.pZ);
						if ((!_v0.a.$) && (!_v0.b.$)) {
							if (_v0.b.a.$ === 4) {
								var _v1 = _v0.b.a;
								return A2(
									$author$project$Components$Shared$Note$View$view,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$collectionsRefusAcces(i18n))
										]));
							} else {
								return A2(
									$author$project$Components$Shared$Note$View$view,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$collectionsRefusAutre(i18n))
										]));
							}
						} else {
							return $rtfeldman$elm_css$Html$Styled$text('');
						}
					}()
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: A2(
					$author$project$I18n$Cles$collectionsTraductionTitre,
					i18n,
					{
						vD: A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.Bl;
								},
								model.fr))
					})
			},
			model.lj);
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$ArchivageAvecRetraitDemande = function (a) {
	return {$: 17, a: a};
};
var $author$project$I18n$Cles$collectionsArchivageImpossible = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'collections.archivage.impossible',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'collection',
					$author$project$I18n$Traductions$Chaine(p.vD))
				]),
			'Impossible d\'archiver « ' + (p.vD + ' ».'));
	});
var $author$project$I18n$Cles$collectionsArchivageNonVide = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'collections.archivage.non-vide',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Elle contient encore ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champ.')) : ('Elle contient encore ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champs.')));
	});
var $author$project$I18n$Cles$collectionsArchivageRetirerLesChamps = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'collections.archivage.retirer-les-champs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Retirer le ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champ')) : ('Retirer les ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champs')));
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$View$refusDArchivage = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.ir, model.pZ);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			switch (_v0.b.a.$) {
				case 0:
					var collection = _v0.a.a;
					var membres = _v0.b.a.a;
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('refus')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$collectionsArchivageImpossible,
													i18n,
													{vD: collection.Bl}))
											])),
										$rtfeldman$elm_css$Html$Styled$text(' '),
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$collectionsArchivageNonVide,
											i18n,
											{w: membres}))
									])),
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('collections-retirer-les-champs'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('pale'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Parametrage$CollectionsDeChamps$Update$ArchivageAvecRetraitDemande(collection))
									]),
								A2(
									$author$project$I18n$Cles$collectionsArchivageRetirerLesChamps,
									i18n,
									{w: membres}))
							]));
				case 4:
					var _v1 = _v0.b.a;
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$collectionsRefusAcces(i18n))
							]));
				default:
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$collectionsRefusAutre(i18n))
							]));
			}
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$CreationDemandee = {$: 10};
var $author$project$I18n$Cles$collectionsAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.aucune', _List_Nil, 'Aucune collection pour le moment.');
};
var $author$project$I18n$Cles$collectionsColonneActions = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.colonne.actions', _List_Nil, 'Actions');
};
var $author$project$I18n$Cles$collectionsColonneChamps = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.colonne.champs', _List_Nil, 'Champs');
};
var $author$project$I18n$Cles$collectionsColonneCollection = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.colonne.collection', _List_Nil, 'Collection');
};
var $author$project$I18n$Cles$collectionsColonnePorteeSur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.colonne.portee-sur', _List_Nil, 'Portée sur');
};
var $author$project$I18n$Cles$collectionsCreer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.creer', _List_Nil, 'Créer une collection');
};
var $author$project$I18n$Cles$collectionsNoteDesLangues = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.note-des-langues', _List_Nil, 'Le libellé affiché est celui de la langue de l\'utilisateur ; les autres langues se règlent dans le drawer « Traduire ».');
};
var $author$project$I18n$Cles$collectionsTableau = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.tableau', _List_Nil, 'Collections');
};
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$ArchivageDemande = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Shared$Bouton$View$Tertiaire = 2;
var $author$project$Components$Parametrage$CollectionsDeChamps$Update$TraductionDemandee = function (a) {
	return {$: 6, a: a};
};
var $author$project$I18n$Cles$collectionsArchiver = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.archiver', _List_Nil, 'Archiver');
};
var $author$project$I18n$Cles$collectionsPorteeSur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'collections.portee-sur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' type') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' types'));
	});
var $author$project$I18n$Cles$collectionsTraduire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.traduire', _List_Nil, 'Traduire');
};
var $author$project$Components$Parametrage$CollectionsDeChamps$View$ligne = F2(
	function (i18n, collection) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('collection')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(collection.Bl)
								])),
							$rtfeldman$elm_css$Html$Styled$text(' '),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('cle')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(collection.dy)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							5,
							A2($author$project$Components$Parametrage$CollectionsDeChamps$View$libelleDeLaPortee, i18n, collection.F$))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(collection.Cm))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$collectionsPorteeSur,
								i18n,
								{w: collection.J3}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					_List_fromArray(
						[
							function () {
							var _v0 = $author$project$Components$Parametrage$CollectionsDeChamps$Model$lienDeLaTraduction(collection);
							if (!_v0.$) {
								return A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									2,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id('collections-traduire-' + collection.Aq),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Parametrage$CollectionsDeChamps$Update$TraductionDemandee(collection))
										]),
									$author$project$I18n$Cles$collectionsTraduire(i18n));
							} else {
								return $rtfeldman$elm_css$Html$Styled$text('');
							}
						}(),
							function () {
							var _v1 = $author$project$Components$Parametrage$CollectionsDeChamps$Model$lienDeLArchivage(collection);
							if (!_v1.$) {
								return A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									2,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id('collections-archiver-' + collection.Aq),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Parametrage$CollectionsDeChamps$Update$ArchivageDemande(collection))
										]),
									$author$project$I18n$Cles$collectionsArchiver(i18n));
							} else {
								return $rtfeldman$elm_css$Html$Styled$text('');
							}
						}()
						]))
				]));
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$View$tableau = F2(
	function (i18n, model) {
		var collections = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.vE;
				},
				model.vE));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('card'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('collections')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$collectionsTableau(i18n))
								])),
							function () {
							var _v0 = $author$project$Components$Parametrage$CollectionsDeChamps$Model$lienDeLaCreation(model);
							if (!_v0.$) {
								return A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									0,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id('collections-creer'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$CollectionsDeChamps$Update$CreationDemandee)
										]),
									$author$project$I18n$Cles$collectionsCreer(i18n));
							} else {
								return $rtfeldman$elm_css$Html$Styled$text('');
							}
						}()
						])),
					_Utils_eq(collections, _List_Nil) ? A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$collectionsAucune(i18n))
						])) : A2(
					$rtfeldman$elm_css$Html$Styled$table,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$collectionsColonneCollection(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$collectionsColonnePortee(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$collectionsColonneChamps(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$collectionsColonnePorteeSur(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$collectionsColonneActions(i18n))
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$tbody,
							_List_Nil,
							A2(
								$elm$core$List$map,
								$author$project$Components$Parametrage$CollectionsDeChamps$View$ligne(i18n),
								collections))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note-des-langues')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$collectionsNoteDesLangues(i18n))
						]))
				]));
	});
var $author$project$Components$Parametrage$CollectionsDeChamps$View$greffon = F4(
	function (i18n, versLeParent, champs, model) {
		return {
			js: A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Html$Styled$map(versLeParent),
				_Utils_ap(
					model.gd ? _List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Note$View$view,
							2,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$collectionsEchecDeLecture(i18n))
								]))
						]) : _List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('refus-de-collection')
								]),
							_List_fromArray(
								[
									A2($author$project$Components$Parametrage$CollectionsDeChamps$View$refusDArchivage, i18n, model)
								])),
							A2($author$project$Components$Parametrage$CollectionsDeChamps$View$tableau, i18n, model)
						]))),
			vE: A2(
				$elm$core$List$map,
				function (c) {
					return {
						dy: c.dy,
						Bl: c.Bl,
						F$: $author$project$Components$Parametrage$CollectionsDeChamps$View$codeDeLaPortee(c.F$)
					};
				},
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.vE;
						},
						model.vE))),
			xy: _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$map,
					versLeParent,
					A3($author$project$Components$Parametrage$CollectionsDeChamps$View$drawerDeCreation, i18n, champs, model)),
					A2(
					$rtfeldman$elm_css$Html$Styled$map,
					versLeParent,
					A2($author$project$Components$Parametrage$CollectionsDeChamps$View$drawerDeTraduction, i18n, model))
				]),
			AK: $author$project$Components$Parametrage$CollectionsDeChamps$View$dialogueOuvert(model),
			n3: (!_Utils_eq(model.vE, $elm$core$Maybe$Nothing)) || model.gd
		};
	});
var $author$project$Components$Parametrage$Conservation$Update$EtapeDemandeeAuPied = function (a) {
	return {$: 5, a: a};
};
var $author$project$I18n$Cles$referentielParcoursDescription = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parcours.description',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Huit étapes, dans l\'ordre. À chacune, l\'aperçu de droite montre ce qu\'une fiche « ' + (p.Dj + ' » est devenue.'));
	});
var $author$project$I18n$Cles$referentielParcoursDescriptionSansType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.description.sans-type', _List_Nil, 'Huit étapes, dans l\'ordre. À chacune, l\'aperçu de droite montre ce qu\'une fiche est devenue.');
};
var $author$project$Components$Referentiel$Types$Parcours$description = F2(
	function (i18n, regle) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Cles$referentielParcoursDescriptionSansType(i18n),
			A2(
				$elm$core$Maybe$map,
				function (libelle) {
					return A2(
						$author$project$I18n$Cles$referentielParcoursDescription,
						i18n,
						{Dj: libelle});
				},
				regle));
	});
var $author$project$I18n$Cles$referentielParcoursFil = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.fil', _List_Nil, 'Parties prenantes');
};
var $author$project$I18n$Cles$referentielParcoursTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.titre', _List_Nil, 'Décrire vos parties prenantes');
};
var $author$project$Components$Referentiel$Types$View$regle = A2(
	$elm$core$Basics$composeR,
	$author$project$Components$Referentiel$Types$Model$typeRegle,
	$elm$core$Maybe$map(
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.R;
			},
			function ($) {
				return $.zX;
			})));
var $author$project$Components$Referentiel$Types$View$entete = F2(
	function (i18n, model) {
		return {
			dH: A2(
				$author$project$Components$Referentiel$Types$Parcours$description,
				i18n,
				$author$project$Components$Referentiel$Types$View$regle(model)),
			zE: _List_fromArray(
				[
					{
					aa: $author$project$Routes$Route$adresseTypesDePartiesPrenantes,
					Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
				},
					{
					aa: $author$project$Routes$Route$adresseTypesDePartiesPrenantes,
					Dj: $author$project$I18n$Cles$referentielParcoursFil(i18n)
				}
				]),
			h6: $author$project$I18n$Cles$referentielParcoursTitre(i18n)
		};
	});
var $author$project$Components$Referentiel$Types$View$idDuTitre = $author$project$Components$Referentiel$Types$Parcours$idDuTitre;
var $author$project$Components$Referentiel$Vocabulaire$codeDuResultatSysteme = 'effacement-rgpd';
var $author$project$I18n$Cles$referentielRoleResultatAbandon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.resultat.abandon', _List_Nil, 'Abandon');
};
var $author$project$I18n$Cles$referentielRoleResultatConverti = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.resultat.converti', _List_Nil, 'Converti');
};
var $author$project$I18n$Cles$referentielRoleResultatDesistement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.resultat.desistement', _List_Nil, 'Désistement');
};
var $author$project$I18n$Cles$referentielRoleResultatEffacementRgpd = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.resultat.effacement-rgpd', _List_Nil, 'Effacement RGPD');
};
var $author$project$I18n$Cles$referentielRoleResultatRefuse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.resultat.refuse', _List_Nil, 'Refusé');
};
var $author$project$Components$Referentiel$Vocabulaire$resultatsDeRole = function (i18n) {
	return $elm$core$Dict$fromList(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'converti',
				$author$project$I18n$Cles$referentielRoleResultatConverti(i18n)),
				_Utils_Tuple2(
				'refuse',
				$author$project$I18n$Cles$referentielRoleResultatRefuse(i18n)),
				_Utils_Tuple2(
				'desistement',
				$author$project$I18n$Cles$referentielRoleResultatDesistement(i18n)),
				_Utils_Tuple2(
				'abandon',
				$author$project$I18n$Cles$referentielRoleResultatAbandon(i18n)),
				_Utils_Tuple2(
				$author$project$Components$Referentiel$Vocabulaire$codeDuResultatSysteme,
				$author$project$I18n$Cles$referentielRoleResultatEffacementRgpd(i18n))
			]));
};
var $author$project$Components$Referentiel$Vocabulaire$resultatDeRole = F2(
	function (i18n, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			code,
			A2(
				$elm$core$Dict$get,
				code,
				$author$project$Components$Referentiel$Vocabulaire$resultatsDeRole(i18n)));
	});
var $author$project$Components$Referentiel$Types$Chemin$libelleDuResultat = F2(
	function (i18n, resultat) {
		var _v0 = resultat.R;
		if (!_v0.$) {
			var libelles = _v0.a;
			return libelles.zX;
		} else {
			return A2(
				$author$project$Components$Referentiel$Vocabulaire$resultatDeRole,
				i18n,
				$author$project$Components$Referentiel$Identifiants$resultatIdToString(resultat.Aq));
		}
	});
var $author$project$Components$Referentiel$Vocabulaire$libelleParDefautDuResultat = F2(
	function (i18n, code) {
		return _Utils_eq(code, $author$project$Components$Referentiel$Vocabulaire$codeDuResultatSysteme) ? $elm$core$Maybe$Nothing : A2(
			$elm$core$Dict$get,
			code,
			$author$project$Components$Referentiel$Vocabulaire$resultatsDeRole(i18n));
	});
var $author$project$I18n$Cles$referentielRoleStatutActif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.statut.actif', _List_Nil, 'Actif');
};
var $author$project$Components$Referentiel$Vocabulaire$statutsDeRole = function (i18n) {
	return $elm$core$Dict$fromList(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'actif',
				$author$project$I18n$Cles$referentielRoleStatutActif(i18n))
			]));
};
var $author$project$Components$Referentiel$Vocabulaire$libelleParDefautDuStatut = F2(
	function (i18n, code) {
		return A2(
			$elm$core$Dict$get,
			code,
			$author$project$Components$Referentiel$Vocabulaire$statutsDeRole(i18n));
	});
var $author$project$Components$Referentiel$Types$Chemin$change = F2(
	function (i18n, fiche) {
		var dOrigine = F4(
			function (libelleParDefaut, code, libelle, retire) {
				return (!retire) && _Utils_eq(
					libelleParDefaut(code),
					$elm$core$Maybe$Just(libelle));
			});
		return A2(
			$elm$core$List$any,
			function (statut) {
				return !A4(
					dOrigine,
					$author$project$Components$Referentiel$Vocabulaire$libelleParDefautDuStatut(i18n),
					$author$project$Components$Referentiel$Identifiants$statutIdToString(statut.Aq),
					statut.R.zX,
					statut.HZ);
			},
			fiche.I1) || A2(
			$elm$core$List$any,
			function (resultat) {
				return (!resultat.rv) && (!A4(
					dOrigine,
					$author$project$Components$Referentiel$Vocabulaire$libelleParDefautDuResultat(i18n),
					$author$project$Components$Referentiel$Identifiants$resultatIdToString(resultat.Aq),
					A2($author$project$Components$Referentiel$Types$Chemin$libelleDuResultat, i18n, resultat),
					resultat.HZ));
			},
			fiche.bh);
	});
var $author$project$Components$Referentiel$Types$Informations$demandees = function (fiche) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.dw;
				},
				$elm$core$List$filter(
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$not,
						function ($) {
							return $.n4;
						}))),
			fiche.aN));
};
var $author$project$Components$Referentiel$Types$Model$restreinte = function (fiche) {
	return A2(
		$elm$core$List$any,
		function (nature) {
			return !A2($elm$core$List$member, nature, fiche.oo);
		},
		$author$project$Components$Referentiel$Admission$natures) || A2(
		$elm$core$List$any,
		function (qualite) {
			return !A2($elm$core$List$member, qualite, fiche.GG);
		},
		$author$project$Components$Referentiel$Admission$qualites);
};
var $author$project$Components$Referentiel$Types$Model$remplie = F3(
	function (i18n, model, etape) {
		switch (etape) {
			case 0:
				return !$elm$core$List$isEmpty(
					$author$project$Components$Referentiel$Types$Model$types(model));
			case 1:
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$author$project$Components$Referentiel$Types$Model$restreinte,
						$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model)));
			case 2:
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$author$project$Components$Referentiel$Types$Offres$limitee,
						$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model)));
			case 3:
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$author$project$Components$Referentiel$Types$Chemin$change(i18n),
						$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model)));
			case 4:
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Referentiel$Types$Informations$demandees,
							A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)),
						$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model)));
			case 5:
				return false;
			case 6:
				return false;
			default:
				return false;
		}
	});
var $author$project$I18n$Cles$conservationEtapeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'conservation.etape.titre', _List_Nil, 'La durée de conservation');
};
var $author$project$I18n$Cles$referentielParcoursInformationsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.informations.titre', _List_Nil, 'Les informations à demander');
};
var $author$project$I18n$Cles$referentielParcoursOffresTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.titre', _List_Nil, 'À quelles offres ce rôle a-t-il accès');
};
var $author$project$I18n$Cles$referentielParcoursPorteursTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.porteurs.titre', _List_Nil, 'Qui peut porter le rôle');
};
var $author$project$I18n$Cles$referentielParcoursStatutsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.statuts.titre', _List_Nil, 'Statuts et résultats');
};
var $author$project$I18n$Cles$referentielParcoursVerificationTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.verification.titre', _List_Nil, 'Une fiche pour vérifier');
};
var $author$project$I18n$Cles$referentielParcoursVosTypesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.vos-types.titre', _List_Nil, 'Vos types');
};
var $author$project$I18n$Cles$relationEtapeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'relation.etape.titre', _List_Nil, 'Les liens entre fiches');
};
var $author$project$Components$Referentiel$Types$Parcours$titre = F2(
	function (i18n, etape) {
		switch (etape) {
			case 0:
				return $author$project$I18n$Cles$referentielParcoursVosTypesTitre(i18n);
			case 1:
				return $author$project$I18n$Cles$referentielParcoursPorteursTitre(i18n);
			case 2:
				return $author$project$I18n$Cles$referentielParcoursOffresTitre(i18n);
			case 3:
				return $author$project$I18n$Cles$referentielParcoursStatutsTitre(i18n);
			case 4:
				return $author$project$I18n$Cles$referentielParcoursInformationsTitre(i18n);
			case 5:
				return $author$project$I18n$Cles$conservationEtapeTitre(i18n);
			case 6:
				return $author$project$I18n$Cles$relationEtapeTitre(i18n);
			default:
				return $author$project$I18n$Cles$referentielParcoursVerificationTitre(i18n);
		}
	});
var $author$project$Components$Referentiel$Types$View$parcoursDe = F3(
	function (i18n, auPied, model) {
		return {
			aa: function (visee) {
				return $author$project$Routes$Route$toString(
					A2(
						$author$project$Routes$Route$TypesDePartiesPrenantes,
						visee,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.r8;
							},
							$author$project$Components$Referentiel$Types$Model$typeRegle(model))));
			},
			tX: auPied,
			yL: A2(
				$elm$core$List$filter,
				function (autre) {
					return (autre !== 6) || model.jh;
				},
				$author$project$Routes$Route$etapesDesTypes),
			Dj: $author$project$Components$Referentiel$Types$Parcours$nom,
			qm: A2($author$project$Components$Referentiel$Types$Model$remplie, i18n, model),
			h6: $author$project$Components$Referentiel$Types$Parcours$titre(i18n)
		};
	});
var $author$project$Main$View$habillageDeLaConservation = F2(
	function (i18n, model) {
		var entete = A2(
			$author$project$Components$Referentiel$Types$View$entete,
			i18n,
			$author$project$Components$Referentiel$Types$Model$ouvrir(model.J0));
		return {
			dH: entete.dH,
			zE: entete.zE,
			ex: A3(
				$author$project$Components$Referentiel$Types$View$parcoursDe,
				i18n,
				A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Types$View$idDuTitre, $author$project$Components$Parametrage$Conservation$Update$EtapeDemandeeAuPied),
				$author$project$Components$Referentiel$Types$Model$ouvrir(model.J0)),
			h6: entete.h6
		};
	});
var $author$project$Components$Referentiel$TypesDeRelation$Update$EtapeDemandeeAuPied = function (a) {
	return {$: 16, a: a};
};
var $author$project$Main$View$habillageDesLiens = F2(
	function (i18n, model) {
		var entete = A2(
			$author$project$Components$Referentiel$Types$View$entete,
			i18n,
			$author$project$Components$Referentiel$Types$Model$ouvrir(model.J0));
		return {
			dH: entete.dH,
			zE: entete.zE,
			ex: A3(
				$author$project$Components$Referentiel$Types$View$parcoursDe,
				i18n,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Referentiel$Types$View$idDuTitre,
					A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$TypesDeRelation$Update$EtapeDemandeeAuPied, $author$project$Main$Update$TypesDeRelationMsg)),
				$author$project$Components$Referentiel$Types$Model$ouvrir(model.J0)),
			h6: entete.h6
		};
	});
var $author$project$I18n$Cles$coquilleAccesRefuse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'coquille.acces-refuse', _List_Nil, 'Vous n\'avez pas accès à cet écran.');
};
var $author$project$Components$Imports$Outil$Update$RapportDHistoriqueDemande = function (a) {
	return {$: 79, a: a};
};
var $author$project$I18n$Cles$importsDomaineCatalogue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.domaine.catalogue', _List_Nil, 'Catalogue');
};
var $author$project$I18n$Cles$importsDomainePartiesPrenantes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.domaine.parties-prenantes', _List_Nil, 'Parties prenantes');
};
var $author$project$Components$Imports$Vocabulaire$domaine = F2(
	function (i18n, code) {
		switch (code) {
			case 'parties-prenantes':
				return $author$project$I18n$Cles$importsDomainePartiesPrenantes(i18n);
			case 'catalogue':
				return $author$project$I18n$Cles$importsDomaineCatalogue(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$Components$Imports$Outil$View$libelleDeCible = F3(
	function (i18n, model, _v0) {
		var domaine = _v0.a;
		var type_ = _v0.b;
		return A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$Components$Imports$Vocabulaire$domaine, i18n, domaine),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				A2(
					$elm$core$Maybe$andThen,
					function (i) {
						return $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (c) {
									return _Utils_eq(c.cC, domaine) && _Utils_eq(c.r0, type_);
								},
								i.jS));
					},
					model.cN)));
	});
var $author$project$Components$Imports$Outil$View$cibleDeLHistorique = F3(
	function (i18n, model, ligne) {
		return A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				A2($author$project$Components$Imports$Outil$View$libelleDeCible, i18n, model),
				ligne.jS));
	});
var $author$project$I18n$Cles$importsCompteurCreees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.compteur.creees', _List_Nil, 'fiches créées');
};
var $author$project$I18n$Cles$importsCompteurDoublons = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.compteur.doublons', _List_Nil, 'doublons possibles');
};
var $author$project$I18n$Cles$importsCompteurEffacees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.compteur.effacees', _List_Nil, 'personnes effacées, ignorées');
};
var $author$project$I18n$Cles$importsCompteurErreurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.compteur.erreurs', _List_Nil, 'lignes en erreur');
};
var $author$project$I18n$Cles$importsCompteurModifiees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.compteur.modifiees', _List_Nil, 'fiches mises à jour');
};
var $author$project$I18n$Cles$importsCompteurSansChangement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.compteur.sans-changement', _List_Nil, 'fiches sans changement');
};
var $author$project$Components$Imports$Outil$View$compteurs = F2(
	function (i18n, c) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('compteurs')
				]),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var nom = _v0.a;
					var n = _v0.b;
					var libelle = _v0.c;
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('compteur'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(nom)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$elm$core$String$fromInt(n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(libelle)
									]))
							]));
				},
				_List_fromArray(
					[
						_Utils_Tuple3(
						'creees',
						c.wo,
						$author$project$I18n$Cles$importsCompteurCreees(i18n)),
						_Utils_Tuple3(
						'modifiees',
						c.CP,
						$author$project$I18n$Cles$importsCompteurModifiees(i18n)),
						_Utils_Tuple3(
						'sans-changement',
						c.qY,
						$author$project$I18n$Cles$importsCompteurSansChangement(i18n)),
						_Utils_Tuple3(
						'doublons',
						c.kW,
						$author$project$I18n$Cles$importsCompteurDoublons(i18n)),
						_Utils_Tuple3(
						'erreurs',
						c.gp,
						$author$project$I18n$Cles$importsCompteurErreurs(i18n)),
						_Utils_Tuple3(
						'effacees',
						c.x8,
						$author$project$I18n$Cles$importsCompteurEffacees(i18n))
					])));
	});
var $rtfeldman$elm_css$Html$Styled$dd = $rtfeldman$elm_css$Html$Styled$node('dd');
var $rtfeldman$elm_css$Html$Styled$dl = $rtfeldman$elm_css$Html$Styled$node('dl');
var $rtfeldman$elm_css$Html$Styled$dt = $rtfeldman$elm_css$Html$Styled$node('dt');
var $author$project$I18n$Cles$jourHorodate = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'jour.horodate',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'jour',
					$author$project$I18n$Traductions$Chaine(p.A_)),
					_Utils_Tuple2(
					'heure',
					$author$project$I18n$Traductions$Chaine(p.Ah))
				]),
			p.A_ + (' · ' + p.Ah));
	});
var $author$project$Texte$Jour$horodate = F2(
	function (i18n, instant) {
		var _v0 = A2($elm$core$String$split, 'T', instant);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var jour = _v0.a;
			var _v1 = _v0.b;
			var heure = _v1.a;
			var _v2 = _Utils_Tuple2(
				A2($author$project$Texte$Jour$lire, $author$project$Texte$Jour$mois, jour),
				A2($elm$core$String$split, ':', heure));
			if (((!_v2.a.$) && _v2.b.b) && _v2.b.b.b) {
				var _v3 = _v2.b;
				var heures = _v3.a;
				var _v4 = _v3.b;
				var minutes = _v4.a;
				return A2(
					$author$project$I18n$Cles$jourHorodate,
					i18n,
					{
						Ah: heures + (':' + minutes),
						A_: A2($author$project$Texte$Jour$enFrancais, i18n, jour)
					});
			} else {
				return instant;
			}
		} else {
			return instant;
		}
	});
var $author$project$Texte$Jour$horodateDeParis = F2(
	function (i18n, instant) {
		var _v0 = $author$project$Texte$Jour$posixDe(instant);
		if (_v0.$ === 1) {
			return A2($author$project$Texte$Jour$horodate, i18n, instant);
		} else {
			var lu = _v0.a;
			var zone = A2(
				$elm$time$Time$customZone,
				$author$project$Texte$Jour$decalageDeParis(lu),
				_List_Nil);
			var deux = function (nombre) {
				return A3(
					$elm$core$String$padLeft,
					2,
					'0',
					$elm$core$String$fromInt(nombre));
			};
			return A2(
				$author$project$Texte$Jour$horodate,
				i18n,
				$author$project$Texte$Jour$jourDeParis(instant) + ('T' + (deux(
					A2($elm$time$Time$toHour, zone, lu)) + (':' + deux(
					A2($elm$time$Time$toMinute, zone, lu))))));
		}
	});
var $author$project$I18n$Cles$importsHistoriqueColonneAuteur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.historique.colonne-auteur', _List_Nil, 'Auteur');
};
var $author$project$I18n$Cles$importsHistoriqueColonneCible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.historique.colonne-cible', _List_Nil, 'Cible');
};
var $author$project$I18n$Cles$importsHistoriqueColonneSource = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.historique.colonne-source', _List_Nil, 'Source');
};
var $author$project$I18n$Cles$importsHistoriqueDrawerTermineLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.historique.drawer-termine-le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Import terminé le ' + (p.wv + '.'));
	});
var $author$project$I18n$Cles$importsSimulationRapport = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.simulation.rapport', _List_Nil, 'Télécharger le rapport (CSV)');
};
var $author$project$Components$Imports$Vocabulaire$sourceDImport = function (source) {
	switch (source) {
		case 'csv':
			return 'CSV';
		case 'xlsx':
			return 'Excel';
		case 'xls':
			return 'Excel';
		default:
			var autre = source;
			return autre;
	}
};
var $author$project$Components$Shared$Drawer$View$viewAvecSousTitre = F2(
	function (i18n, sousTitre) {
		return A4(
			$author$project$Components$Shared$Drawer$View$viewAvecPied,
			i18n,
			0,
			$elm$core$Maybe$Just(sousTitre),
			A2(
				$author$project$Components$Shared$Drawer$View$piedDe,
				$author$project$I18n$Cles$drawerAnnuler(i18n),
				_List_Nil));
	});
var $author$project$Components$Imports$Outil$View$drawerDeLHistorique = F2(
	function (i18n, model) {
		var ouverte = A2(
			$elm$core$Maybe$andThen,
			function (id) {
				return A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$filter(
							function (l) {
								return _Utils_eq(l.Aq, id);
							}),
						$elm$core$List$head),
					model.m6);
			},
			model.nU);
		if (ouverte.$ === 1) {
			return A5(
				$author$project$Components$Shared$Drawer$View$viewAvecSousTitre,
				i18n,
				'',
				$author$project$Components$Imports$Outil$Update$DuDrawerDeLHistorique,
				{
					fs: {
						sR: false,
						Bl: $author$project$I18n$Cles$drawerFermer(i18n),
						C$: $author$project$Components$Imports$Outil$Update$DuDrawerDeLHistorique($author$project$Components$Shared$Drawer$Update$Fermer)
					},
					fZ: _List_Nil,
					A6: $elm$core$Maybe$Nothing,
					Bc: false,
					h6: ''
				},
				model.k9);
		} else {
			var ligne = ouverte.a;
			var rapport = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rapportDuLot, ligne.nQ);
			return A5(
				$author$project$Components$Shared$Drawer$View$viewAvecSousTitre,
				i18n,
				(ligne.gt === 'applique') ? A2(
					$author$project$I18n$Cles$importsHistoriqueDrawerTermineLe,
					i18n,
					{
						wv: A2($author$project$Texte$Jour$horodateDeParis, i18n, ligne.wv)
					}) : '',
				$author$project$Components$Imports$Outil$Update$DuDrawerDeLHistorique,
				{
					fs: {
						sR: !_Utils_eq(rapport, $elm$core$Maybe$Nothing),
						Bl: $author$project$I18n$Cles$importsSimulationRapport(i18n),
						C$: A2(
							$elm$core$Maybe$withDefault,
							$author$project$Components$Imports$Outil$Update$DuDrawerDeLHistorique($author$project$Components$Shared$Drawer$Update$Fermer),
							A2($elm$core$Maybe$map, $author$project$Components$Imports$Outil$Update$RapportDHistoriqueDemande, rapport))
					},
					fZ: _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$dl,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('kv')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$dt,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$importsHistoriqueColonneCible(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$dd,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A3($author$project$Components$Imports$Outil$View$cibleDeLHistorique, i18n, model, ligne))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$dt,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$importsHistoriqueColonneAuteur(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$dd,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(ligne.ja)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$dt,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$importsHistoriqueColonneSource(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$dd,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Components$Imports$Vocabulaire$sourceDImport(ligne.IR))
										]))
								])),
							A2($author$project$Components$Imports$Outil$View$compteurs, i18n, ligne.v_)
						]),
					A6: $elm$core$Maybe$Nothing,
					Bc: false,
					h6: ligne.gw
				},
				model.k9);
		}
	});
var $author$project$Components$Imports$Outil$Update$FiltreChoisi = F2(
	function (a, b) {
		return {$: 77, a: a, b: b};
	});
var $author$project$Components$Imports$Outil$Model$FiltreDAuteur = 2;
var $author$project$Components$Imports$Outil$Model$FiltreDeCible = 0;
var $author$project$Components$Imports$Outil$Update$FiltreDeCibleRecherche = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Imports$Outil$Model$FiltreDeResultat = 1;
var $author$project$Components$Imports$Outil$Model$cibleDeLaLigne = function (_v0) {
	var domaine = _v0.a;
	var type_ = _v0.b;
	return (type_ === '') ? domaine : (domaine + (':' + type_));
};
var $author$project$I18n$Cles$importsCibleRecherche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.cible.recherche', _List_Nil, 'Rechercher un domaine ou un type');
};
var $author$project$I18n$Cles$importsCibleRechercheExemple = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.cible.recherche-exemple', _List_Nil, 'Ex. : four, licencié, fournisseur');
};
var $author$project$I18n$Cles$importsHistoriqueAuteur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.historique.auteur', _List_Nil, 'Auteur');
};
var $author$project$I18n$Cles$importsHistoriqueAvecErreurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.historique.avec-erreurs', _List_Nil, 'Avec erreurs');
};
var $author$project$I18n$Cles$importsHistoriqueCible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.historique.cible', _List_Nil, 'Cible');
};
var $author$project$I18n$Cles$importsHistoriqueResultat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.historique.resultat', _List_Nil, 'Résultat');
};
var $author$project$I18n$Cles$importsHistoriqueSansErreur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.historique.sans-erreur', _List_Nil, 'Sans erreur');
};
var $author$project$I18n$Cles$importsHistoriqueTous = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.historique.tous', _List_Nil, 'Tous');
};
var $author$project$I18n$Cles$importsHistoriqueToutesLesCibles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.historique.toutes-les-cibles', _List_Nil, 'Toutes les cibles');
};
var $author$project$Components$Imports$Outil$View$filtres = F2(
	function (i18n, model) {
		var filtreEnChoix = F4(
			function (filtre, nom, valeur, options) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('filtre')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(nom)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$select,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onInput(
									$author$project$Components$Imports$Outil$Update$FiltreChoisi(filtre)),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', nom)
								]),
							A2(
								$elm$core$List$map,
								function (_v1) {
									var v = _v1.a;
									var libelle = _v1.b;
									return A2(
										$rtfeldman$elm_css$Html$Styled$option,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
												$rtfeldman$elm_css$Html$Styled$Attributes$selected(
												_Utils_eq(v, valeur))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(libelle)
											]));
								},
								options))
						]));
			});
		var cibles = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.jS;
				},
				model.cN));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('filtres')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('filtre')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$importsCibleRecherche(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('search'),
									$rtfeldman$elm_css$Html$Styled$Attributes$value(model.pU),
									$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Imports$Outil$Update$FiltreDeCibleRecherche),
									$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(
									$author$project$I18n$Cles$importsCibleRechercheExemple(i18n)),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									$author$project$I18n$Cles$importsCibleRecherche(i18n))
								]),
							_List_Nil)
						])),
					A4(
					filtreEnChoix,
					0,
					$author$project$I18n$Cles$importsHistoriqueCible(i18n),
					model.gy,
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'',
							$author$project$I18n$Cles$importsHistoriqueToutesLesCibles(i18n)),
						A2(
							$elm$core$List$map,
							function (c) {
								return _Utils_Tuple2(
									$author$project$Components$Imports$Outil$Model$cibleDeLaLigne(
										_Utils_Tuple2(c.cC, c.r0)),
									c.Bl);
							},
							A2(
								$elm$core$List$filter,
								function (c) {
									return A2(
										$elm$core$String$contains,
										$elm$core$String$toLower(
											$elm$core$String$trim(model.pU)),
										$elm$core$String$toLower(
											A2($author$project$Components$Imports$Vocabulaire$domaine, i18n, c.cC) + (' ' + c.Bl))) || _Utils_eq(
										$author$project$Components$Imports$Outil$Model$cibleDeLaLigne(
											_Utils_Tuple2(c.cC, c.r0)),
										model.gy);
								},
								cibles)))),
					A4(
					filtreEnChoix,
					1,
					$author$project$I18n$Cles$importsHistoriqueResultat(i18n),
					model.gz,
					_List_fromArray(
						[
							_Utils_Tuple2(
							'',
							$author$project$I18n$Cles$importsHistoriqueTous(i18n)),
							_Utils_Tuple2(
							'avec-erreurs',
							$author$project$I18n$Cles$importsHistoriqueAvecErreurs(i18n)),
							_Utils_Tuple2(
							'sans-erreur',
							$author$project$I18n$Cles$importsHistoriqueSansErreur(i18n))
						])),
					A4(
					filtreEnChoix,
					2,
					$author$project$I18n$Cles$importsHistoriqueAuteur(i18n),
					model.gx,
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'',
							$author$project$I18n$Cles$importsHistoriqueTous(i18n)),
						A2(
							$elm$core$List$map,
							function (_v0) {
								var uid = _v0.a;
								var nom = _v0.b;
								return _Utils_Tuple2(uid, nom);
							},
							model.jb)))
				]));
	});
var $author$project$I18n$Cles$importsEchecDeLecture = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.echec-de-lecture', _List_Nil, 'L\'outil d\'import n\'a pas pu être lu. Rechargez la page.');
};
var $author$project$I18n$Cles$importsHistoriqueListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.historique.liste', _List_Nil, 'Imports');
};
var $author$project$I18n$Cles$importsHistoriqueNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.historique.note', _List_Nil, 'Le rapport est conservé 30 jours, puis supprimé : la ligne reste, avec son résultat.');
};
var $author$project$I18n$Cles$importsHistoriqueSousTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.historique.sous-titre', _List_Nil, 'Tous les imports du client, toutes cibles');
};
var $author$project$I18n$Cles$importsHistoriqueVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.historique.vide', _List_Nil, 'Aucun import à afficher.');
};
var $author$project$I18n$Cles$importsMenu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.menu', _List_Nil, 'Importer');
};
var $author$project$I18n$Cles$importsMenuHistorique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.menu.historique', _List_Nil, 'Historique des imports');
};
var $author$project$Components$Imports$Outil$View$section = F3(
	function (nom, titre, enfants) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class(nom)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(titre)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					enfants)
				]));
	});
var $author$project$I18n$Cles$importsHistoriqueColonneDate = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.historique.colonne-date', _List_Nil, 'Date');
};
var $author$project$I18n$Cles$importsHistoriqueColonneFichier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.historique.colonne-fichier', _List_Nil, 'Fichier');
};
var $author$project$I18n$Cles$importsHistoriqueColonneResultat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.historique.colonne-resultat', _List_Nil, 'Résultat');
};
var $author$project$Components$Imports$Outil$Update$LigneDHistoriqueOuverte = function (a) {
	return {$: 78, a: a};
};
var $author$project$I18n$Cles$importsHistoriqueDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.historique.detail', _List_Nil, 'Détail');
};
var $author$project$I18n$Cles$importsHistoriqueRapport = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.historique.rapport', _List_Nil, 'Rapport');
};
var $author$project$I18n$Cles$importsHistoriqueReprendre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.historique.reprendre', _List_Nil, 'Reprendre');
};
var $author$project$I18n$Cles$importsHistoriqueSuivre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.historique.suivre', _List_Nil, 'Suivre');
};
var $author$project$Components$Shared$Bouton$View$lien = function (variante) {
	return A2($author$project$Components$Shared$Bouton$View$lienAvec, variante, _List_Nil);
};
var $author$project$Components$Imports$Outil$View$actionsDeLHistorique = F2(
	function (i18n, ligne) {
		var detail = A3(
			$author$project$Components$Shared$Bouton$View$bouton,
			2,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Components$Imports$Outil$Update$LigneDHistoriqueOuverte(ligne.Aq))
				]),
			$author$project$I18n$Cles$importsHistoriqueDetail(i18n));
		var _v0 = _Utils_Tuple2(
			ligne.gt,
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reprendreLeLot, ligne.nQ));
		_v0$0:
		while (true) {
			_v0$1:
			while (true) {
				if (!_v0.b.$) {
					switch (_v0.a) {
						case 'en-cours':
							break _v0$0;
						case 'applique':
							break _v0$1;
						default:
							return _List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$lien,
									2,
									$author$project$Routes$Route$adresseDuLotDImport(ligne.Aq),
									$author$project$I18n$Cles$importsHistoriqueReprendre(i18n))
								]);
					}
				} else {
					switch (_v0.a) {
						case 'en-cours':
							break _v0$0;
						case 'applique':
							break _v0$1;
						default:
							var _v3 = _v0.b;
							return _List_fromArray(
								[detail]);
					}
				}
			}
			var _v2 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rapportDuLot, ligne.nQ);
			if (!_v2.$) {
				var lien = _v2.a;
				return _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						2,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Imports$Outil$Update$RapportDHistoriqueDemande(lien))
							]),
						$author$project$I18n$Cles$importsHistoriqueRapport(i18n)),
						detail
					]);
			} else {
				return _List_fromArray(
					[detail]);
			}
		}
		var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$suiviDuTraitement, ligne.nQ);
		if (!_v1.$) {
			return _List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$lien,
					2,
					$author$project$Routes$Route$adresseDuLotDImport(ligne.Aq),
					$author$project$I18n$Cles$importsHistoriqueSuivre(i18n))
				]);
		} else {
			return _List_fromArray(
				[detail]);
		}
	});
var $author$project$Components$Shared$Tag$View$Bleu = 4;
var $author$project$I18n$Cles$importsHistoriqueCreees = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.historique.creees',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' créée') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' créées'));
	});
var $author$project$I18n$Cles$importsHistoriqueErreurs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.historique.erreurs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' erreur') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' erreurs'));
	});
var $author$project$I18n$Cles$importsHistoriqueEtatEnCours = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.historique.etat-en-cours', _List_Nil, 'En cours');
};
var $author$project$I18n$Cles$importsHistoriqueEtatEnCoursAvancement = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.historique.etat-en-cours-avancement',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			'En cours · ' + (p.d + ' %'));
	});
var $author$project$I18n$Cles$importsHistoriqueEtatInterrompu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.historique.etat-interrompu', _List_Nil, 'Interrompu');
};
var $author$project$I18n$Cles$importsHistoriqueEtatSimule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.historique.etat-simule', _List_Nil, 'Simulé, non appliqué');
};
var $author$project$I18n$Cles$importsHistoriqueEtatTermine = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.historique.etat-termine', _List_Nil, 'Terminé');
};
var $author$project$Components$Imports$Outil$View$etatDeLHistorique = F2(
	function (i18n, ligne) {
		var _v0 = ligne.gt;
		switch (_v0) {
			case 'applique':
				return A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('resultat')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							0,
							$author$project$I18n$Cles$importsHistoriqueEtatTermine(i18n)),
							$rtfeldman$elm_css$Html$Styled$text(
							' ' + (A2(
								$author$project$I18n$Cles$importsHistoriqueCreees,
								i18n,
								{d: ligne.v_.wo}) + ((ligne.v_.gp > 0) ? (' · ' + A2(
								$author$project$I18n$Cles$importsHistoriqueErreurs,
								i18n,
								{d: ligne.v_.gp})) : '')))
						]));
			case 'en-cours':
				return A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('resultat')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							4,
							function () {
								var _v1 = ligne.ua;
								if (!_v1.$) {
									var n = _v1.a;
									return A2(
										$author$project$I18n$Cles$importsHistoriqueEtatEnCoursAvancement,
										i18n,
										{
											d: $elm$core$String$fromInt(n)
										});
								} else {
									return $author$project$I18n$Cles$importsHistoriqueEtatEnCours(i18n);
								}
							}())
						]));
			case 'interrompu':
				return A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('resultat')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							2,
							$author$project$I18n$Cles$importsHistoriqueEtatInterrompu(i18n))
						]));
			default:
				return A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('resultat')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							1,
							$author$project$I18n$Cles$importsHistoriqueEtatSimule(i18n))
						]));
		}
	});
var $author$project$Components$Imports$Outil$View$ligneDHistorique = F3(
	function (i18n, model, ligne) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class(ligne.gt)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('date')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Texte$Jour$horodateDeParis, i18n, ligne.wv))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(ligne.gw)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('cible')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A3($author$project$Components$Imports$Outil$View$cibleDeLHistorique, i18n, model, ligne))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(ligne.ja)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Components$Imports$Vocabulaire$sourceDImport(ligne.IR))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Components$Imports$Outil$View$etatDeLHistorique, i18n, ligne)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('action')
						]),
					A2($author$project$Components$Imports$Outil$View$actionsDeLHistorique, i18n, ligne))
				]));
	});
var $author$project$Components$Imports$Outil$View$tableDeLHistorique = F3(
	function (i18n, model, lignes) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$table,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('historique')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$tr,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (e) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(e)
											]));
								},
								_List_fromArray(
									[
										$author$project$I18n$Cles$importsHistoriqueColonneDate(i18n),
										$author$project$I18n$Cles$importsHistoriqueColonneFichier(i18n),
										$author$project$I18n$Cles$importsHistoriqueColonneCible(i18n),
										$author$project$I18n$Cles$importsHistoriqueColonneAuteur(i18n),
										$author$project$I18n$Cles$importsHistoriqueColonneSource(i18n),
										$author$project$I18n$Cles$importsHistoriqueColonneResultat(i18n),
										''
									])))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						A2($author$project$Components$Imports$Outil$View$ligneDHistorique, i18n, model),
						lignes))
				]));
	});
var $author$project$Components$Imports$Outil$View$historique = F3(
	function (i18n, messages, model) {
		var lignes = A2($elm$core$Maybe$withDefault, _List_Nil, model.m6);
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'imports-historique',
			{
				ut: model.qa ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('acces-refuse')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Note$View$view,
										1,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$coquilleAccesRefuse(i18n))
													]))
											]))
									]))
							]))
					]) : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						A2(
							$elm$core$List$cons,
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							_Utils_ap(
								model.gd ? _List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Note$View$view,
										2,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$importsEchecDeLecture(i18n))
											]))
									]) : _List_Nil,
								_List_fromArray(
									[
										A3(
										$author$project$Components$Imports$Outil$View$section,
										'historique',
										$author$project$I18n$Cles$importsHistoriqueListe(i18n) + (' ' + $elm$core$String$fromInt(
											$elm$core$List$length(lignes))),
										_List_fromArray(
											[
												A2($author$project$Components$Imports$Outil$View$filtres, i18n, model),
												_Utils_eq(lignes, _List_Nil) ? A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$importsHistoriqueVide(i18n))
													])) : A3($author$project$Components$Imports$Outil$View$tableDeLHistorique, i18n, model, lignes),
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$importsHistoriqueNote(i18n))
													]))
											]))
									]))))
					]),
				xy: _List_fromArray(
					[
						A2($author$project$Components$Imports$Outil$View$drawerDeLHistorique, i18n, model)
					]),
				zM: _List_Nil,
				AK: $author$project$Components$Imports$Outil$Update$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsHistoriqueSousTitre(i18n))
									]))
							]),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adresseImporter,
								Dj: $author$project$I18n$Cles$importsMenu(i18n)
							},
								{
								aa: '',
								Dj: $author$project$I18n$Cles$importsMenuHistorique(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$importsMenuHistorique(i18n)
					})
			});
	});
var $author$project$Main$View$liensDeLaRacine = function (model) {
	var _v0 = model.e1.gt;
	if (_v0.$ === 1) {
		var connexion = _v0.a;
		return connexion.nQ;
	} else {
		return _List_Nil;
	}
};
var $author$project$I18n$Cles$alertesOngletPartiesPrenantes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'alertes.onglet.parties-prenantes', _List_Nil, 'Parties prenantes');
};
var $author$project$I18n$Cles$alertesOngletProduits = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'alertes.onglet.produits', _List_Nil, 'Produits');
};
var $author$project$Main$View$ongletsDesAlertes = F2(
	function (i18n, model) {
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					function (_v0) {
						return {
							sO: _Utils_eq(model.Ih, $author$project$Routes$Route$Alertes),
							aa: $author$project$Routes$Route$adresseAlertes,
							vW: A2($elm$core$Maybe$map, $elm$core$String$fromInt, model.tb.ys),
							Dj: $author$project$I18n$Cles$alertesOngletProduits(i18n)
						};
					},
					model.tb.dZ),
					A2(
					$elm$core$Maybe$map,
					function (_v1) {
						return {
							sO: _Utils_eq(model.Ih, $author$project$Routes$Route$AlertesDePartiesPrenantes),
							aa: $author$project$Routes$Route$adresseAlertesDePartiesPrenantes,
							vW: A2($elm$core$Maybe$map, $elm$core$String$fromInt, model.tc.ys),
							Dj: $author$project$I18n$Cles$alertesOngletPartiesPrenantes(i18n)
						};
					},
					model.tc.dZ)
				]));
	});
var $author$project$Components$Referentiel$Doublons$Update$EcartAnnule = {$: 13};
var $author$project$Components$Referentiel$Doublons$Update$EcartConfirme = {$: 14};
var $author$project$I18n$Cles$referentielDoublonsConfirmationAnnuler = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.confirmation.annuler', _List_Nil, 'Annuler');
};
var $author$project$I18n$Cles$referentielDoublonsConfirmationConfirmer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.confirmation.confirmer', _List_Nil, 'Écarter la paire');
};
var $author$project$I18n$Cles$referentielDoublonsConfirmationMessagePaire = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.doublons.confirmation.message-paire',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'a',
					$author$project$I18n$Traductions$Chaine(p.sD)),
					_Utils_Tuple2(
					'b',
					$author$project$I18n$Traductions$Chaine(p.jl))
				]),
			p.sD + (' et ' + (p.jl + ' ne reviendront plus dans la file, même si une nouvelle ressemblance apparaît.')));
	});
var $author$project$I18n$Cles$referentielDoublonsConfirmationMessagePlusieurs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.doublons.confirmation.message-plusieurs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Ces ' + (p.w + ' paires ne reviendront plus dans la file, même si une nouvelle ressemblance apparaît.'));
	});
var $author$project$I18n$Cles$referentielDoublonsConfirmationResume = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.confirmation.resume', _List_Nil, 'Vous pourrez rouvrir la paire depuis l\'onglet « Écartées ».');
};
var $author$project$I18n$Cles$referentielDoublonsConfirmationTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.confirmation.titre', _List_Nil, 'Ce ne sont pas les mêmes ?');
};
var $author$project$Components$Referentiel$Doublons$View$boite = F4(
	function (i18n, model, paires, nom) {
		return A3(
			$author$project$Components$Shared$Confirmation$View$viewAvecResume,
			i18n,
			$author$project$I18n$Cles$referentielDoublonsConfirmationResume(i18n),
			{
				vl: $elm$json$Json$Decode$fail(''),
				j7: {
					Aq: 'confirmation-ecart-confirmer',
					Bl: $author$project$I18n$Cles$referentielDoublonsConfirmationConfirmer(i18n),
					C$: $author$project$Components$Referentiel$Doublons$Update$EcartConfirme
				},
				Aq: 'confirmation-ecart',
				As: 'confirmation-ecart-message',
				At: 'confirmation-ecart-titre',
				Cs: function () {
					if (paires.b && (!paires.b.b)) {
						var seule = paires.a;
						return A2(
							$author$project$I18n$Cles$referentielDoublonsConfirmationMessagePaire,
							i18n,
							{
								sD: nom(seule.Gf),
								jl: nom(seule.Iv)
							});
					} else {
						return A2(
							$author$project$I18n$Cles$referentielDoublonsConfirmationMessagePlusieurs,
							i18n,
							{
								w: $elm$core$String$fromInt(
									$elm$core$List$length(paires))
							});
					}
				}(),
				Et: !_Utils_eq(model.j6, $elm$core$Maybe$Nothing),
				HG: {
					Aq: 'confirmation-ecart-renoncer',
					Bl: $author$project$I18n$Cles$referentielDoublonsConfirmationAnnuler(i18n),
					C$: $author$project$Components$Referentiel$Doublons$Update$EcartAnnule
				},
				h6: $author$project$I18n$Cles$referentielDoublonsConfirmationTitre(i18n),
				sl: 3
			});
	});
var $author$project$Components$Referentiel$Doublons$Model$nomDeLaFiche = function (fiche) {
	var _v0 = fiche.GR;
	if (!_v0.$) {
		var raison = _v0.a;
		return raison;
	} else {
		return A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[fiche.Gg, fiche.Dj])));
	}
};
var $author$project$I18n$Cles$referentielFicheNomMasque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.nom-masque', _List_Nil, 'Nom masqué');
};
var $author$project$Components$Referentiel$Doublons$View$nomOuMasque = F2(
	function (i18n, fournie) {
		var _v0 = $author$project$Components$Referentiel$Doublons$Model$nomDeLaFiche(fournie);
		if (_v0 === '') {
			return $author$project$I18n$Cles$referentielFicheNomMasque(i18n);
		} else {
			var nom = _v0;
			return nom;
		}
	});
var $author$project$Components$Referentiel$Doublons$View$confirmation = F2(
	function (i18n, model) {
		var paires = A2($elm$core$Maybe$withDefault, _List_Nil, model.j6);
		var nom = function (fournie) {
			return A2($author$project$Components$Referentiel$Doublons$View$nomOuMasque, i18n, fournie);
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'opened',
							!_Utils_eq(model.j6, $elm$core$Maybe$Nothing))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('overlay'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Doublons$Update$EcartAnnule)
						]),
					_List_Nil),
					A4($author$project$Components$Referentiel$Doublons$View$boite, i18n, model, paires, nom)
				]));
	});
var $author$project$Components$Referentiel$Doublons$Update$EcartDemande = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Referentiel$Doublons$View$droitDEcarter = function (model) {
	var _v0 = model.n3;
	if (!_v0.$) {
		var lues = _v0.a;
		return !_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ecarterDesPaires, lues.nQ),
			$elm$core$Maybe$Nothing);
	} else {
		return false;
	}
};
var $author$project$I18n$Cles$referentielDoublonsEcarterN = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.doublons.ecarter-n',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Ce ne sont pas les mêmes (' + (p.w + ')'));
	});
var $author$project$Components$Referentiel$Doublons$Model$cleDeLaPaire = function (paire) {
	return $author$project$Components$Referentiel$Identifiants$entiteUidToString(paire.Gf.r8) + ('/' + $author$project$Components$Referentiel$Identifiants$entiteUidToString(paire.Iv.r8));
};
var $author$project$Components$Referentiel$Doublons$Model$selectionnees = function (model) {
	return A2(
		$elm$core$List$filter,
		function (paire) {
			return A2(
				$elm$core$List$member,
				$author$project$Components$Referentiel$Doublons$Model$cleDeLaPaire(paire),
				model.q3);
		},
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.EJ;
				},
				model.n3)));
};
var $author$project$Components$Referentiel$Doublons$View$barreDuBas = F2(
	function (i18n, model) {
		var choisies = $author$project$Components$Referentiel$Doublons$Model$selectionnees(model);
		return ($author$project$Components$Referentiel$Doublons$View$droitDEcarter(model) && ((!model.oZ) && (!$elm$core$List$isEmpty(choisies)))) ? _List_fromArray(
			[
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				0,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Referentiel$Doublons$Update$EcartDemande(choisies))
					]),
				A2(
					$author$project$I18n$Cles$referentielDoublonsEcarterN,
					i18n,
					{
						w: $elm$core$String$fromInt(
							$elm$core$List$length(choisies))
					}))
			]) : _List_Nil;
	});
var $author$project$Components$Referentiel$Doublons$Update$Relue = {$: 19};
var $author$project$I18n$Cles$referentielDoublonsColonneFicheA = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.colonne.fiche-a', _List_Nil, 'Fiche A');
};
var $author$project$I18n$Cles$referentielDoublonsColonneFicheB = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.colonne.fiche-b', _List_Nil, 'Fiche B');
};
var $author$project$I18n$Cles$referentielDoublonsColonneMotif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.colonne.motif', _List_Nil, 'Motif et valeur commune');
};
var $author$project$Components$Referentiel$Doublons$View$enTete = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$th,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$scope('col'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('case')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$th,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$referentielDoublonsColonneFicheA(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$th,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$referentielDoublonsColonneFicheB(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$th,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$referentielDoublonsColonneMotif(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$th,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$scope('col'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('gestes')
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$Referentiel$Doublons$Update$MotifChoisi = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Referentiel$Doublons$Update$NatureChoisie = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Referentiel$Doublons$Update$TermeSaisi = function (a) {
	return {$: 5, a: a};
};
var $author$project$I18n$Cles$referentielDoublonsMotifMemeEmail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.motif.meme-email', _List_Nil, 'Même email');
};
var $author$project$I18n$Cles$referentielDoublonsMotifMemeIdentifiantLegal = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.motif.meme-identifiant-legal', _List_Nil, 'Même identifiant légal');
};
var $author$project$I18n$Cles$referentielDoublonsMotifMemeTelephone = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.motif.meme-telephone', _List_Nil, 'Même téléphone');
};
var $author$project$I18n$Cles$referentielDoublonsMotifNomEtPays = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.motif.nom-et-pays', _List_Nil, 'Nom et pays');
};
var $author$project$Components$Referentiel$Doublons$View$libelleDuMotif = F2(
	function (i18n, code) {
		switch (code) {
			case 'MemeEmail':
				return $author$project$I18n$Cles$referentielDoublonsMotifMemeEmail(i18n);
			case 'MemeIdentifiantLegal':
				return $author$project$I18n$Cles$referentielDoublonsMotifMemeIdentifiantLegal(i18n);
			case 'MemeTelephone':
				return $author$project$I18n$Cles$referentielDoublonsMotifMemeTelephone(i18n);
			default:
				return $author$project$I18n$Cles$referentielDoublonsMotifNomEtPays(i18n);
		}
	});
var $author$project$I18n$Cles$referentielDoublonsFiltreMotif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.filtre.motif', _List_Nil, 'Motif');
};
var $author$project$I18n$Cles$referentielDoublonsFiltreNature = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.filtre.nature', _List_Nil, 'Nature');
};
var $author$project$I18n$Cles$referentielDoublonsFiltreOrganisations = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.filtre.organisations', _List_Nil, 'Organisations');
};
var $author$project$I18n$Cles$referentielDoublonsFiltrePersonnes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.filtre.personnes', _List_Nil, 'Personnes');
};
var $author$project$I18n$Cles$referentielDoublonsFiltreTousLesMotifs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.filtre.tous-les-motifs', _List_Nil, 'Tous les motifs');
};
var $author$project$I18n$Cles$referentielDoublonsFiltreToutesNatures = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.filtre.toutes-natures', _List_Nil, 'Personnes et organisations');
};
var $author$project$I18n$Cles$referentielDoublonsRecherche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.recherche', _List_Nil, 'Rechercher une fiche');
};
var $author$project$Components$Referentiel$Doublons$View$filtres = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('filtres')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('search'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('recherche'),
							$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(
							$author$project$I18n$Cles$referentielDoublonsRecherche(i18n)),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-label',
							$author$project$I18n$Cles$referentielDoublonsRecherche(i18n)),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(model.h3),
							$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Referentiel$Doublons$Update$TermeSaisi)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$select,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-label',
							$author$project$I18n$Cles$referentielDoublonsFiltreMotif(i18n)),
							$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Referentiel$Doublons$Update$MotifChoisi)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$option,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(''),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(model.cX === '')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielDoublonsFiltreTousLesMotifs(i18n))
								])),
						A2(
							$elm$core$List$map,
							function (code) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$option,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(code),
											$rtfeldman$elm_css$Html$Styled$Attributes$selected(
											_Utils_eq(model.cX, code))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$Components$Referentiel$Doublons$View$libelleDuMotif, i18n, code))
										]));
							},
							_List_fromArray(
								['MemeEmail', 'MemeIdentifiantLegal', 'MemeTelephone', 'MemeNom'])))),
					A2(
					$rtfeldman$elm_css$Html$Styled$select,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-label',
							$author$project$I18n$Cles$referentielDoublonsFiltreNature(i18n)),
							$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Referentiel$Doublons$Update$NatureChoisie)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$option,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(''),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(model.g1 === '')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielDoublonsFiltreToutesNatures(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$option,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value('Personne'),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(model.g1 === 'Personne')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielDoublonsFiltrePersonnes(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$option,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value('Organisation'),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(model.g1 === 'Organisation')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielDoublonsFiltreOrganisations(i18n))
								]))
						]))
				]));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$colspan = function (n) {
	return A2(
		$rtfeldman$elm_css$VirtualDom$Styled$attribute,
		'colspan',
		$elm$core$String$fromInt(n));
};
var $author$project$I18n$Cles$referentielDoublonsGroupeMemeIdentifiantLegal = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.groupe.meme-identifiant-legal', _List_Nil, 'Même identifiant légal entier');
};
var $author$project$Components$Referentiel$Doublons$View$libelleDuGroupe = F2(
	function (i18n, code) {
		if (code === 'MemeIdentifiantLegal') {
			return $author$project$I18n$Cles$referentielDoublonsGroupeMemeIdentifiantLegal(i18n);
		} else {
			return A2($author$project$Components$Referentiel$Doublons$View$libelleDuMotif, i18n, code);
		}
	});
var $author$project$Components$Referentiel$Doublons$View$enTeteDeGroupe = F3(
	function (i18n, groupes, motif) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('groupe')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$colspan(5)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Referentiel$Doublons$View$libelleDuGroupe, i18n, motif))
								])),
							A2(
							$elm$core$Maybe$withDefault,
							$rtfeldman$elm_css$Html$Styled$text(''),
							A2(
								$elm$core$Maybe$map,
								function (g) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$elm$core$String$fromInt(g.w))
											]));
								},
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (g) {
											return _Utils_eq(g.cX, motif);
										},
										groupes))))
						]))
				]));
	});
var $author$project$Components$Referentiel$Doublons$Update$PaireCochee = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$Referentiel$Doublons$View$couleurDuMotif = function (code) {
	return ((code === 'MemeEmail') || (code === 'MemeIdentifiantLegal')) ? 5 : 3;
};
var $author$project$I18n$Cles$referentielDoublonsNatureOrganisation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.nature.organisation', _List_Nil, 'Organisation');
};
var $author$project$I18n$Cles$referentielDoublonsNaturePersonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.nature.personne', _List_Nil, 'Personne');
};
var $author$project$Components$Referentiel$Doublons$View$libelleDeLaNature = F2(
	function (i18n, nature) {
		return (nature === 'Organisation') ? $author$project$I18n$Cles$referentielDoublonsNatureOrganisation(i18n) : $author$project$I18n$Cles$referentielDoublonsNaturePersonne(i18n);
	});
var $author$project$Components$Referentiel$Doublons$View$libelleDuTypeDeRole = F2(
	function (i18n, libelles) {
		var _v0 = $author$project$I18n$Traductions$langue(i18n);
		if (_v0 === 1) {
			return A2($elm$core$Maybe$withDefault, libelles.zX, libelles.yg);
		} else {
			return libelles.zX;
		}
	});
var $author$project$Components$Referentiel$Doublons$View$nomDuPays = F2(
	function (normes, code) {
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.Dj;
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (pays) {
						return _Utils_eq(pays.vx, code);
					},
					$author$project$Referentiel$Normes$entreesDePays(normes))));
	});
var $author$project$Components$Referentiel$Doublons$View$fiche = F3(
	function (i18n, normes, fournie) {
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$strong,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$Components$Referentiel$Doublons$View$nomOuMasque, i18n, fournie))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('precisions')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$elm$core$String$join,
							' · ',
							_Utils_ap(
								A2(
									$elm$core$List$map,
									$author$project$Components$Referentiel$Doublons$View$libelleDuTypeDeRole(i18n),
									fournie.eX),
								_Utils_ap(
									_List_fromArray(
										[
											A2($author$project$Components$Referentiel$Doublons$View$libelleDeLaNature, i18n, fournie.g1)
										]),
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											$elm$core$List$singleton,
											A2(
												$elm$core$Maybe$andThen,
												$author$project$Components$Referentiel$Doublons$View$nomDuPays(normes),
												fournie.ho)))))))
					]))
			]);
	});
var $author$project$Components$Referentiel$Doublons$Update$PaireOuverte = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Referentiel$Doublons$Update$RouvertureDemandee = function (a) {
	return {$: 16, a: a};
};
var $author$project$I18n$Cles$referentielDoublonsComparer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.comparer', _List_Nil, 'Comparer');
};
var $author$project$I18n$Cles$referentielDoublonsRouvrir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.rouvrir', _List_Nil, 'Rouvrir');
};
var $author$project$Components$Referentiel$Doublons$View$gestes = F3(
	function (i18n, model, paire) {
		var _v0 = model.oZ;
		if (!_v0) {
			var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$paireDeDoublons, paire.nQ);
			if (!_v1.$) {
				return _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Referentiel$Doublons$Update$PaireOuverte(paire))
							]),
						$author$project$I18n$Cles$referentielDoublonsComparer(i18n))
					]);
			} else {
				return _List_Nil;
			}
		} else {
			var _v2 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rouvrirUnePaire, paire.nQ);
			if (!_v2.$) {
				return _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Referentiel$Doublons$Update$RouvertureDemandee(paire))
							]),
						$author$project$I18n$Cles$referentielDoublonsRouvrir(i18n))
					]);
			} else {
				return _List_Nil;
			}
		}
	});
var $author$project$I18n$Cles$referentielDoublonsCase = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.doublons.case',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'a',
					$author$project$I18n$Traductions$Chaine(p.sD)),
					_Utils_Tuple2(
					'b',
					$author$project$I18n$Traductions$Chaine(p.jl))
				]),
			'Sélectionner la paire ' + (p.sD + (' et ' + p.jl)));
	});
var $author$project$Components$Referentiel$Doublons$View$ligne = F4(
	function (i18n, model, avecCase, paire) {
		var motif = $elm$core$List$head(paire.CY);
		var cle = $author$project$Components$Referentiel$Doublons$Model$cleDeLaPaire(paire);
		var cochee = A2($elm$core$List$member, cle, model.q3);
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('paire'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('selectionnee', cochee)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('case')
						]),
					avecCase ? _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
									$rtfeldman$elm_css$Html$Styled$Attributes$checked(cochee),
									$rtfeldman$elm_css$Html$Styled$Events$onCheck(
									$author$project$Components$Referentiel$Doublons$Update$PaireCochee(cle)),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									A2(
										$author$project$I18n$Cles$referentielDoublonsCase,
										i18n,
										{
											sD: $author$project$Components$Referentiel$Doublons$Model$nomDeLaFiche(paire.Gf),
											jl: $author$project$Components$Referentiel$Doublons$Model$nomDeLaFiche(paire.Iv)
										}))
								]),
							_List_Nil)
						]) : _List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('fiche')
						]),
					A3($author$project$Components$Referentiel$Doublons$View$fiche, i18n, model.hd, paire.Gf)),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('fiche')
						]),
					A3($author$project$Components$Referentiel$Doublons$View$fiche, i18n, model.hd, paire.Iv)),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('motif')
						]),
					function () {
						if (!motif.$) {
							var m = motif.a;
							return _List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Tag$View$view,
									$author$project$Components$Referentiel$Doublons$View$couleurDuMotif(m.cX),
									A2($author$project$Components$Referentiel$Doublons$View$libelleDuMotif, i18n, m.cX)),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($elm$core$Maybe$withDefault, '', m.fm))
										]))
								]);
						} else {
							return _List_Nil;
						}
					}()),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('gestes')
						]),
					A3($author$project$Components$Referentiel$Doublons$View$gestes, i18n, model, paire))
				]));
	});
var $author$project$Components$Referentiel$Doublons$View$lignes = F3(
	function (i18n, model, lues) {
		var groupe = function (paire) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.cX;
					},
					$elm$core$List$head(paire.CY)));
		};
		var ensemble = $author$project$Components$Referentiel$Doublons$View$droitDEcarter(model) && (!model.oZ);
		return A3(
			$elm$core$List$foldl,
			F2(
				function (paire, _v0) {
					var precedent = _v0.a;
					var acc = _v0.b;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							groupe(paire)),
						_Utils_ap(
							acc,
							_Utils_ap(
								((!model.oZ) && (!_Utils_eq(
									precedent,
									$elm$core$Maybe$Just(
										groupe(paire))))) ? _List_fromArray(
									[
										A3(
										$author$project$Components$Referentiel$Doublons$View$enTeteDeGroupe,
										i18n,
										lues.Ac,
										groupe(paire))
									]) : _List_Nil,
								_List_fromArray(
									[
										A4($author$project$Components$Referentiel$Doublons$View$ligne, i18n, model, ensemble, paire)
									]))));
				}),
			_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil),
			lues.EJ).b;
	});
var $author$project$Components$Referentiel$Doublons$Update$PageChoisie = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Shared$Annuaire$View$PaginationAvecPlage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Doublons$Update$TailleChoisie = function (a) {
	return {$: 7, a: a};
};
var $author$project$I18n$Cles$annuairePaginationPlage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'annuaire.pagination.plage',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'debut',
					$author$project$I18n$Traductions$Chaine(p.ku)),
					_Utils_Tuple2(
					'fin',
					$author$project$I18n$Traductions$Chaine(p.mI)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			p.ku + ('–' + (p.mI + (' sur ' + p.JE))));
	});
var $author$project$I18n$Cles$annuairePaginationPrecedente = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'annuaire.pagination.precedente', _List_Nil, 'Page précédente');
};
var $author$project$I18n$Cles$annuairePaginationSuivante = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'annuaire.pagination.suivante', _List_Nil, 'Page suivante');
};
var $author$project$I18n$Cles$annuairePagination = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'annuaire.pagination', _List_Nil, 'Pagination');
};
var $author$project$Components$Shared$Annuaire$View$versLaPage = function (demande) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
			]),
		A2(
			$elm$core$Maybe$map,
			function (msg) {
				return _List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
					]);
			},
			demande));
};
var $author$project$Components$Shared$Annuaire$View$boutonsDePage = F5(
	function (i18n, precedent, suivant, precedente, suivante) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$nav,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pagination'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					$author$project$I18n$Cles$annuairePagination(i18n))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Attributes$class('precedente'),
							$author$project$Components$Shared$Annuaire$View$versLaPage(precedente))),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(precedent)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Attributes$class('suivante'),
							$author$project$Components$Shared$Annuaire$View$versLaPage(suivante))),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(suivant)
								]))
						]))
				]));
	});
var $author$project$I18n$Cles$annuairePaginationParPage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'annuaire.pagination.par-page', _List_Nil, 'Par page');
};
var $author$project$I18n$Cles$annuairePaginationPrecedent = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'annuaire.pagination.precedent', _List_Nil, 'Précédent');
};
var $author$project$I18n$Cles$annuairePaginationSuivant = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'annuaire.pagination.suivant', _List_Nil, 'Suivant');
};
var $author$project$Components$Shared$Annuaire$View$piedAvecPlage = F2(
	function (i18n, tenue) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$nav,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('pagination', true),
							_Utils_Tuple2('avec-plage', true)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					$author$project$I18n$Cles$annuairePagination(i18n))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('plage')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(tenue.FQ)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('commandes')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Champ$View$liste,
							{
								go: $elm$core$Maybe$Nothing,
								Aq: 'annuaire-par-page',
								Bl: $author$project$I18n$Cles$annuairePaginationParPage(i18n),
								he: false
							},
							{
								hg: function (choix) {
									return tenue.Jf(
										A2(
											$elm$core$Maybe$withDefault,
											tenue.Jm,
											$elm$core$String$toInt(choix)));
								},
								o_: A2(
									$elm$core$List$map,
									function (taille) {
										return {
											Bl: $elm$core$String$fromInt(taille),
											fm: $elm$core$String$fromInt(taille)
										};
									},
									tenue.Jo),
								fm: $elm$core$String$fromInt(tenue.Jm)
							}),
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								A2(
									$elm$core$List$cons,
									$rtfeldman$elm_css$Html$Styled$Attributes$class('precedente'),
									$author$project$Components$Shared$Annuaire$View$versLaPage(tenue.Gc))),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$annuairePaginationPrecedent(i18n))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								A2(
									$elm$core$List$cons,
									$rtfeldman$elm_css$Html$Styled$Attributes$class('suivante'),
									$author$project$Components$Shared$Annuaire$View$versLaPage(tenue.I7))),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$annuairePaginationSuivant(i18n))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Shared$Annuaire$View$pagination = F2(
	function (i18n, fournie) {
		switch (fournie.$) {
			case 0:
				return A5(
					$author$project$Components$Shared$Annuaire$View$boutonsDePage,
					i18n,
					$author$project$I18n$Cles$annuairePaginationPrecedente(i18n),
					$author$project$I18n$Cles$annuairePaginationSuivante(i18n),
					$elm$core$Maybe$Nothing,
					$elm$core$Maybe$Nothing);
			case 1:
				var tenue = fournie.a;
				return A5(
					$author$project$Components$Shared$Annuaire$View$boutonsDePage,
					i18n,
					$author$project$I18n$Cles$annuairePaginationPrecedente(i18n),
					$author$project$I18n$Cles$annuairePaginationSuivante(i18n),
					tenue.Gc,
					tenue.I7);
			default:
				var tenue = fournie.a;
				return A2($author$project$Components$Shared$Annuaire$View$piedAvecPlage, i18n, tenue);
		}
	});
var $author$project$Components$Referentiel$Doublons$View$pied = F3(
	function (i18n, model, lues) {
		var debut = ((model.EE - 1) * model.Jm) + 1;
		var fin = (debut + $elm$core$List$length(lues.EJ)) - 1;
		return A2(
			$author$project$Components$Shared$Annuaire$View$pagination,
			i18n,
			$author$project$Components$Shared$Annuaire$View$PaginationAvecPlage(
				{
					FQ: A2(
						$author$project$I18n$Cles$annuairePaginationPlage,
						i18n,
						{
							ku: $elm$core$String$fromInt(debut),
							mI: $elm$core$String$fromInt(fin),
							JE: $elm$core$String$fromInt(lues.JE)
						}),
					Gc: (model.EE > 1) ? $elm$core$Maybe$Just(
						$author$project$Components$Referentiel$Doublons$Update$PageChoisie(model.EE - 1)) : $elm$core$Maybe$Nothing,
					I7: (_Utils_cmp(fin, lues.JE) < 0) ? $elm$core$Maybe$Just(
						$author$project$Components$Referentiel$Doublons$Update$PageChoisie(model.EE + 1)) : $elm$core$Maybe$Nothing,
					Jf: $author$project$Components$Referentiel$Doublons$Update$TailleChoisie,
					Jm: model.Jm,
					Jo: $author$project$Routes$Route$taillesPermises
				}));
	});
var $author$project$I18n$Cles$referentielDoublonsEcarteesMention = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.ecartees.mention', _List_Nil, 'Ces paires sont écartées pour toujours. « Rouvrir » les remet dans la file.');
};
var $author$project$I18n$Cles$referentielDoublonsVideTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.vide.texte', _List_Nil, 'Aucune paire de fiches ne se ressemble. Les paires écartées restent dans l\'onglet « Écartées ».');
};
var $author$project$I18n$Cles$referentielDoublonsVideTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.vide.titre', _List_Nil, 'Aucun doublon possible');
};
var $author$project$Components$Referentiel$Doublons$View$vide = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('doublons-vide')
				]),
			(model.oZ === 1) ? _List_Nil : _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$referentielDoublonsVideTitre(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$referentielDoublonsVideTexte(i18n))
						]))
				]));
	});
var $author$project$Components$Referentiel$Doublons$View$corps = F3(
	function (i18n, model, lues) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('doublons')
				]),
			_List_fromArray(
				[
					(model.oZ === 1) ? A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('mention'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'note')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$referentielDoublonsEcarteesMention(i18n))
						])) : A2($author$project$Components$Referentiel$Doublons$View$filtres, i18n, model),
					$elm$core$List$isEmpty(lues.EJ) ? A2($author$project$Components$Referentiel$Doublons$View$vide, i18n, model) : A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$table,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$thead,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$Components$Referentiel$Doublons$View$enTete, i18n, model)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$tbody,
									_List_Nil,
									A3($author$project$Components$Referentiel$Doublons$View$lignes, i18n, model, lues))
								]))
						])),
					((_Utils_cmp(lues.JE, model.Jm) > 0) || (model.EE > 1)) ? A3($author$project$Components$Referentiel$Doublons$View$pied, i18n, model, lues) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$I18n$Cles$erreurApiTechnique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'erreur.api.technique', _List_Nil, 'Une erreur est survenue. Réessayez dans un instant.');
};
var $author$project$I18n$Cles$referentielDoublonsOngletAExaminer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.onglet.a-examiner', _List_Nil, 'À examiner');
};
var $author$project$I18n$Cles$referentielDoublonsOngletEcartees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.onglet.ecartees', _List_Nil, 'Écartées');
};
var $author$project$Components$Shared$Onglets$View$courant = function (actif) {
	return actif ? _List_fromArray(
		[
			A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-current', 'page')
		]) : _List_Nil;
};
var $author$project$Components$Shared$Onglets$View$onglet = function (fourni) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$a,
		A2(
			$elm$core$List$cons,
			$rtfeldman$elm_css$Html$Styled$Attributes$href(fourni.aa),
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('active', fourni.sO)
						])),
				$author$project$Components$Shared$Onglets$View$courant(fourni.sO))),
		A2(
			$elm$core$List$cons,
			$rtfeldman$elm_css$Html$Styled$text(fourni.Dj),
			function () {
				var _v0 = fourni.vW;
				if (!_v0.$) {
					var compte = _v0.a;
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(compte)
								]))
						]);
				} else {
					return _List_Nil;
				}
			}()));
};
var $author$project$Components$Shared$Onglets$View$view = function (onglets) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('tabs')
			]),
		A2($elm$core$List$map, $author$project$Components$Shared$Onglets$View$onglet, onglets));
};
var $author$project$Components$Referentiel$Doublons$View$onglets = F2(
	function (i18n, model) {
		return $author$project$Components$Shared$Onglets$View$view(
			_List_fromArray(
				[
					{
					sO: !model.oZ,
					aa: $author$project$Routes$Route$adresseDoublons,
					vW: A2($elm$core$Maybe$map, $elm$core$String$fromInt, model.fV),
					Dj: $author$project$I18n$Cles$referentielDoublonsOngletAExaminer(i18n)
				},
					{
					sO: model.oZ === 1,
					aa: $author$project$Routes$Route$adresseDoublonsEcartees,
					vW: A2($elm$core$Maybe$map, $elm$core$String$fromInt, model.xX),
					Dj: $author$project$I18n$Cles$referentielDoublonsOngletEcartees(i18n)
				}
				]));
	});
var $author$project$I18n$Cles$referentielDoublonsCarteTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.carte.titre', _List_Nil, 'Doublons possibles');
};
var $author$project$I18n$Cles$referentielDoublonsTraiteeActualiser = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.traitee.actualiser', _List_Nil, 'Actualiser la liste');
};
var $author$project$Components$Referentiel$Doublons$View$carte = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('carte-doublons')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielDoublonsCarteTitre(i18n))
								]))
						])),
					A2($author$project$Components$Referentiel$Doublons$View$onglets, i18n, model),
					function () {
					var _v0 = _Utils_Tuple2(model.n3, model.lV);
					if (_v0.b) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('doublons-erreur'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$erreurApiTechnique(i18n))
										])),
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Doublons$Update$Relue)
										]),
									$author$project$I18n$Cles$referentielDoublonsTraiteeActualiser(i18n))
								]));
					} else {
						if (!_v0.a.$) {
							var lues = _v0.a.a;
							return A3($author$project$Components$Referentiel$Doublons$View$corps, i18n, model, lues);
						} else {
							var _v1 = _v0.a;
							return $rtfeldman$elm_css$Html$Styled$text('');
						}
					}
				}()
				]));
	});
var $author$project$I18n$Cles$referentielDoublonsToastEcartee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.toast.ecartee', _List_Nil, 'Paire écartée');
};
var $author$project$I18n$Cles$referentielDoublonsToastRouverte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.toast.rouverte', _List_Nil, 'Paire rouverte');
};
var $author$project$Components$Referentiel$Doublons$View$toast = function (texte) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('toast'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(texte)
			]));
};
var $author$project$Components$Referentiel$Doublons$View$notice = F2(
	function (i18n, model) {
		var _v0 = model.oM;
		if (!_v0.$) {
			switch (_v0.a) {
				case 0:
					var _v1 = _v0.a;
					return $author$project$Components$Referentiel$Doublons$View$toast(
						$author$project$I18n$Cles$referentielDoublonsToastEcartee(i18n));
				case 1:
					var _v2 = _v0.a;
					return $author$project$Components$Referentiel$Doublons$View$toast(
						$author$project$I18n$Cles$referentielDoublonsToastEcartee(i18n));
				default:
					var _v3 = _v0.a;
					return $author$project$Components$Referentiel$Doublons$View$toast(
						$author$project$I18n$Cles$referentielDoublonsToastRouverte(i18n));
			}
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$referentielDoublonsFilDAriane = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.fil-d-ariane', _List_Nil, 'Parties prenantes');
};
var $author$project$I18n$Cles$referentielDoublonsSousTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.sous-titre', _List_Nil, 'Paires de fiches qui se ressemblent, classées par motif');
};
var $author$project$I18n$Cles$referentielDoublonsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.titre', _List_Nil, 'Doublons');
};
var $author$project$Components$Referentiel$Doublons$View$view = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'referentiel-doublons',
			{
				ut: model.qa ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('acces-refuse')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Note$View$view,
										1,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$coquilleAccesRefuse(i18n))
													]))
											]))
									]))
							]))
					]) : (_Utils_eq(model.cK, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						A2(
							$elm$core$List$cons,
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							_List_fromArray(
								[
									A2($author$project$Components$Referentiel$Doublons$View$carte, i18n, model),
									A2($author$project$Components$Referentiel$Doublons$View$notice, i18n, model)
								])))
					])),
				xy: _List_Nil,
				zM: A2($author$project$Components$Referentiel$Doublons$View$barreDuBas, i18n, model),
				AK: $author$project$Components$Referentiel$Doublons$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielDoublonsSousTitre(i18n))
									]))
							]),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adressePartiesPrenantes,
								Dj: $author$project$I18n$Cles$referentielDoublonsFilDAriane(i18n)
							},
								{
								aa: '',
								Dj: $author$project$I18n$Cles$referentielDoublonsTitre(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$referentielDoublonsTitre(i18n)
					})
			});
	});
var $author$project$Components$Referentiel$Doublons$Update$FusionDemandee = function (a) {
	return {$: 18, a: a};
};
var $author$project$I18n$Cles$referentielDoublonsChampCreeeLe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.champ.creee-le', _List_Nil, 'Créée le');
};
var $author$project$I18n$Cles$referentielDoublonsChampEmail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.champ.email', _List_Nil, 'Email');
};
var $author$project$I18n$Cles$referentielDoublonsChampNature = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.champ.nature', _List_Nil, 'Nature');
};
var $author$project$I18n$Cles$referentielDoublonsChampPays = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.champ.pays', _List_Nil, 'Pays');
};
var $author$project$I18n$Cles$referentielDoublonsChampPrenom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.champ.prenom', _List_Nil, 'Prénom');
};
var $author$project$I18n$Cles$referentielDoublonsChampRoles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.champ.roles', _List_Nil, 'Rôles');
};
var $author$project$I18n$Cles$referentielDoublonsChampTelephone = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.champ.telephone', _List_Nil, 'Téléphone');
};
var $author$project$Components$Referentiel$Doublons$View$libelleDuChamp = F2(
	function (i18n, champ) {
		switch (champ) {
			case 0:
				return $author$project$I18n$Cles$referentielDoublonsChampNature(i18n);
			case 1:
				return $author$project$I18n$Cles$referentielDoublonsChampPrenom(i18n);
			case 2:
				return $author$project$I18n$Cles$referentielDoublonsChampPays(i18n);
			case 3:
				return $author$project$I18n$Cles$referentielDoublonsChampEmail(i18n);
			case 4:
				return $author$project$I18n$Cles$referentielDoublonsChampTelephone(i18n);
			case 5:
				return $author$project$I18n$Cles$referentielDoublonsChampRoles(i18n);
			default:
				return $author$project$I18n$Cles$referentielDoublonsChampCreeeLe(i18n);
		}
	});
var $author$project$Components$Referentiel$Doublons$View$lienVersLaFiche = F2(
	function (i18n, fournie) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$href(
					$author$project$Routes$Route$toString(
						A2($author$project$Routes$Route$Fiche, fournie.r8, 0)))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2($author$project$Components$Referentiel$Doublons$View$nomOuMasque, i18n, fournie))
				]));
	});
var $author$project$Components$Referentiel$Doublons$Model$ChampCreeeLe = 6;
var $author$project$Components$Referentiel$Doublons$Model$ChampEmail = 3;
var $author$project$Components$Referentiel$Doublons$Model$ChampNature = 0;
var $author$project$Components$Referentiel$Doublons$Model$ChampPays = 2;
var $author$project$Components$Referentiel$Doublons$Model$ChampPrenom = 1;
var $author$project$Components$Referentiel$Doublons$Model$ChampRoles = 5;
var $author$project$Components$Referentiel$Doublons$Model$ChampTelephone = 4;
var $author$project$Components$Referentiel$Doublons$Model$lignesDeComparaison = F5(
	function (nomDuPays, libelleDuRole, paire, premiereCoordonnees, secondeCoordonnees) {
		var seconde = paire.Iv;
		var roles = function (fiche) {
			return A2(
				$elm$core$String$join,
				', ',
				A2($elm$core$List$map, libelleDuRole, fiche.eX));
		};
		var premiere = paire.Gf;
		var pays = function (fiche) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, nomDuPays, fiche.ho));
		};
		var ligne = F3(
			function (champ, a, b) {
				return {
					uN: champ,
					kP: (!_Utils_eq(a, b)) && (champ !== 6),
					Gf: a,
					Iv: b
				};
			});
		var jour = function (fiche) {
			return A2($elm$core$Maybe$withDefault, '', fiche.wn);
		};
		var estUnePersonne = function (fiche) {
			return fiche.g1 === 'Personne';
		};
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					A3(ligne, 0, premiere.g1, seconde.g1)),
					(estUnePersonne(premiere) || estUnePersonne(seconde)) ? $elm$core$Maybe$Just(
					A3(
						ligne,
						1,
						A2($elm$core$Maybe$withDefault, '', premiere.Gg),
						A2($elm$core$Maybe$withDefault, '', seconde.Gg))) : $elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(
					A3(
						ligne,
						2,
						pays(premiere),
						pays(seconde))),
					$elm$core$Maybe$Just(
					A3(
						ligne,
						3,
						A2($elm$core$String$join, ', ', premiereCoordonnees.yd),
						A2($elm$core$String$join, ', ', secondeCoordonnees.yd))),
					$elm$core$Maybe$Just(
					A3(
						ligne,
						4,
						A2($elm$core$String$join, ', ', premiereCoordonnees.Jq),
						A2($elm$core$String$join, ', ', secondeCoordonnees.Jq))),
					$elm$core$Maybe$Just(
					A3(
						ligne,
						5,
						roles(premiere),
						roles(seconde))),
					$elm$core$Maybe$Just(
					A3(
						ligne,
						6,
						jour(premiere),
						jour(seconde)))
				]));
	});
var $author$project$I18n$Cles$referentielDoublonsDrawerNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.drawer.note', _List_Nil, 'Les lignes en jaune diffèrent. Les fiches s\'ouvrent en entier depuis leur nom.');
};
var $author$project$Components$Referentiel$Doublons$View$valeurDeChamp = F3(
	function (i18n, champ, valeur) {
		return (!champ) ? A2($author$project$Components$Referentiel$Doublons$View$libelleDeLaNature, i18n, valeur) : (((champ === 6) && (valeur !== '')) ? A2(
			$author$project$Texte$Jour$enFrancais,
			i18n,
			A2($elm$core$String$left, 10, valeur)) : valeur);
	});
var $author$project$Components$Referentiel$Doublons$View$comparaison = F5(
	function (i18n, model, paire, a, b) {
		var lignesDeLaTable = A5(
			$author$project$Components$Referentiel$Doublons$Model$lignesDeComparaison,
			function (code) {
				return A2(
					$elm$core$Maybe$withDefault,
					code,
					A2($author$project$Components$Referentiel$Doublons$View$nomDuPays, model.hd, code));
			},
			$author$project$Components$Referentiel$Doublons$View$libelleDuTypeDeRole(i18n),
			paire,
			a,
			b);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('comparaison')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$table,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_Nil),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													A2($author$project$Components$Referentiel$Doublons$View$lienVersLaFiche, i18n, paire.Gf)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													A2($author$project$Components$Referentiel$Doublons$View$lienVersLaFiche, i18n, paire.Iv)
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$tbody,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (ligneDeComparaison) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$tr,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2('differe', ligneDeComparaison.kP)
													]))
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$scope('row')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2($author$project$Components$Referentiel$Doublons$View$libelleDuChamp, i18n, ligneDeComparaison.uN))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$td,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A3($author$project$Components$Referentiel$Doublons$View$valeurDeChamp, i18n, ligneDeComparaison.uN, ligneDeComparaison.Gf))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$td,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A3($author$project$Components$Referentiel$Doublons$View$valeurDeChamp, i18n, ligneDeComparaison.uN, ligneDeComparaison.Iv))
													]))
											]));
								},
								lignesDeLaTable))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('legende')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$referentielDoublonsDrawerNote(i18n))
						]))
				]));
	});
var $author$project$Components$Shared$Drawer$View$consultationAvec = F7(
	function (i18n, versMsg, variante, libelle, precisions, contenu, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'opened',
							$author$project$Components$Shared$Drawer$Model$estOuvert(model))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('overlay'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							versMsg($author$project$Components$Shared$Drawer$Update$SortieDemandee))
						]),
					_List_Nil),
					A5(
					$author$project$Components$Shared$Drawer$View$panneau,
					i18n,
					versMsg,
					{
						vl: A2(
							$author$project$Components$Shared$Drawer$Update$clavierDuDrawer,
							{sP: false},
							model),
						fZ: contenu.fZ,
						AK: contenu.G8,
						A6: $elm$core$Maybe$Nothing,
						aO: precisions.aO,
						h6: contenu.h6
					},
					_Utils_ap(
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$map,
									function (note) {
										return A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('pied-note')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(note)
												]));
									},
									precisions.oJ)
								])),
						_List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								variante,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id(
										$author$project$Components$Shared$Drawer$Model$idAnnuler(model)),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										versMsg($author$project$Components$Shared$Drawer$Update$Fermer))
									]),
								libelle)
							])),
					model)
				]));
	});
var $author$project$Components$Shared$Drawer$View$consultation = F3(
	function (i18n, versMsg, contenu) {
		return A6(
			$author$project$Components$Shared$Drawer$View$consultationAvec,
			i18n,
			versMsg,
			1,
			$author$project$I18n$Cles$drawerFermer(i18n),
			{oJ: $elm$core$Maybe$Nothing, aO: $elm$core$Maybe$Nothing},
			{fZ: contenu.fZ, G8: contenu.G8, h6: contenu.h6});
	});
var $author$project$Components$Referentiel$Doublons$View$motifEnTete = F2(
	function (i18n, motif) {
		if (!motif.$) {
			var m = motif.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('motif-de-la-paire')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$Components$Referentiel$Doublons$View$libelleDuMotif, i18n, m.cX))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($elm$core$Maybe$withDefault, '', m.fm))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$referentielDoublonsDrawerFusionner = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.drawer.fusionner', _List_Nil, 'Fusionner ces fiches…');
};
var $author$project$I18n$Cles$referentielDoublonsDrawerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.drawer.titre', _List_Nil, 'Comparer deux fiches');
};
var $author$project$I18n$Cles$referentielDoublonsEcarter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.ecarter', _List_Nil, 'Ce ne sont pas les mêmes');
};
var $author$project$Components$Shared$Drawer$View$viewAvecPiedLibre = F2(
	function (i18n, pied) {
		return A4(
			$author$project$Components$Shared$Drawer$View$viewAvecPied,
			i18n,
			0,
			$elm$core$Maybe$Nothing,
			function (_v0) {
				return pied;
			});
	});
var $author$project$Components$Referentiel$Doublons$View$drawerDeComparaison = F5(
	function (i18n, model, paire, premiere, seconde) {
		var peutFusionner = !_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$fusionner, paire.nQ),
			$elm$core$Maybe$Nothing);
		var peutEcarter = !_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ecarterDesPaires, paire.nQ),
			$elm$core$Maybe$Nothing);
		var contenu = _List_fromArray(
			[
				A2(
				$author$project$Components$Referentiel$Doublons$View$motifEnTete,
				i18n,
				$elm$core$List$head(paire.CY)),
				A5($author$project$Components$Referentiel$Doublons$View$comparaison, i18n, model, paire, premiere, seconde)
			]);
		return (peutFusionner && peutEcarter) ? A5(
			$author$project$Components$Shared$Drawer$View$viewAvecPiedLibre,
			i18n,
			{
				oJ: $elm$core$Maybe$Nothing,
				HF: function (attributs) {
					return A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_Utils_ap(
							attributs,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Referentiel$Doublons$Update$EcartDemande(
										_List_fromArray(
											[paire])))
								])),
						$author$project$I18n$Cles$referentielDoublonsEcarter(i18n));
				},
				Jb: _List_Nil
			},
			$author$project$Components$Referentiel$Doublons$Update$DuDrawer,
			{
				fs: {
					sR: true,
					Bl: $author$project$I18n$Cles$referentielDoublonsDrawerFusionner(i18n),
					C$: $author$project$Components$Referentiel$Doublons$Update$FusionDemandee(paire)
				},
				fZ: contenu,
				A6: $elm$core$Maybe$Nothing,
				Bc: true,
				h6: $author$project$I18n$Cles$referentielDoublonsDrawerTitre(i18n)
			},
			model.kX) : A4(
			$author$project$Components$Shared$Drawer$View$consultation,
			i18n,
			$author$project$Components$Referentiel$Doublons$Update$DuDrawer,
			{
				fZ: contenu,
				G8: !_Utils_eq(model.j6, $elm$core$Maybe$Nothing),
				h6: $author$project$I18n$Cles$referentielDoublonsDrawerTitre(i18n)
			},
			model.kX);
	});
var $author$project$Components$Referentiel$Doublons$View$drawerDeLecture = F2(
	function (i18n, model) {
		return A4(
			$author$project$Components$Shared$Drawer$View$consultation,
			i18n,
			$author$project$Components$Referentiel$Doublons$Update$DuDrawer,
			{
				fZ: _List_Nil,
				G8: !_Utils_eq(model.j6, $elm$core$Maybe$Nothing),
				h6: $author$project$I18n$Cles$referentielDoublonsDrawerTitre(i18n)
			},
			model.kX);
	});
var $author$project$I18n$Cles$referentielDoublonsTraiteeTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.traitee.texte', _List_Nil, 'Elle a été écartée ou fusionnée par un collègue depuis l\'ouverture de la liste. Actualisez la liste pour la mettre à jour.');
};
var $author$project$I18n$Cles$referentielDoublonsTraiteeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.doublons.traitee.titre', _List_Nil, 'Cette paire a déjà été traitée');
};
var $author$project$Components$Referentiel$Doublons$View$drawerDePaireTraitee = F2(
	function (i18n, model) {
		return A5(
			$author$project$Components$Shared$Drawer$View$viewAvecRenoncement,
			i18n,
			$author$project$I18n$Cles$drawerFermer(i18n),
			$author$project$Components$Referentiel$Doublons$Update$DuDrawer,
			{
				fs: {
					sR: true,
					Bl: $author$project$I18n$Cles$referentielDoublonsTraiteeActualiser(i18n),
					C$: $author$project$Components$Referentiel$Doublons$Update$Relue
				},
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('alerte-ambre'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielDoublonsTraiteeTitre(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielDoublonsTraiteeTexte(i18n))
									]))
							]))
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: true,
				h6: $author$project$I18n$Cles$referentielDoublonsDrawerTitre(i18n)
			},
			model.kX);
	});
var $author$project$Components$Referentiel$Doublons$View$volet = F2(
	function (i18n, model) {
		var _v0 = model.bB;
		switch (_v0.$) {
			case 0:
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 1:
				return A2($author$project$Components$Referentiel$Doublons$View$drawerDeLecture, i18n, model);
			case 2:
				var paire = _v0.a;
				var premiere = _v0.b;
				var seconde = _v0.c;
				return A5($author$project$Components$Referentiel$Doublons$View$drawerDeComparaison, i18n, model, paire, premiere, seconde);
			default:
				return A2($author$project$Components$Referentiel$Doublons$View$drawerDePaireTraitee, i18n, model);
		}
	});
var $author$project$Main$View$pageDesDoublons = F2(
	function (i18n, model) {
		var doublons = A2(
			$author$project$Referentiel$Normes$poser,
			model.hd,
			$author$project$Components$Referentiel$Doublons$Model$ouvrir(model.xM));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$DoublonsMsg,
					A3($author$project$Components$Referentiel$Doublons$View$view, i18n, model.Ct, doublons)),
					A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$DoublonsMsg,
					A2($author$project$Components$Referentiel$Doublons$View$volet, i18n, doublons)),
					A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$DoublonsMsg,
					A2($author$project$Components$Referentiel$Doublons$View$confirmation, i18n, doublons))
				]));
	});
var $author$project$I18n$Cles$produitsCatalogueRetour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.retour', _List_Nil, 'Retour à « Marques et gammes »');
};
var $author$project$I18n$Cles$produitsListeDePrixRetour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.liste-de-prix.retour', _List_Nil, 'Retour aux listes de prix');
};
var $author$project$I18n$Cles$produitsOffresRetour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.offres.retour', _List_Nil, 'Retour aux offres de service');
};
var $author$project$I18n$Cles$produitsReferencesRetour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.retour', _List_Nil, 'Retour au catalogue');
};
var $author$project$I18n$Cles$produitsTypesRetour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.retour', _List_Nil, 'Retour aux catégories');
};
var $author$project$I18n$Cles$referentielFicheRetour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.retour', _List_Nil, 'Revenir aux parties prenantes');
};
var $author$project$I18n$Cles$referentielTypesRetour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.retour', _List_Nil, 'Retour à « Types de parties prenantes »');
};
var $author$project$Components$Referentiel$Formes$Update$CreationOuverte = {$: 7};
var $author$project$I18n$Cles$formeEtapeAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'forme.etape.ajouter', _List_Nil, 'Ajouter : Forme');
};
var $author$project$Components$Referentiel$Formes$View$ajouter = F2(
	function (i18n, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$creerUneForme)),
			model.nW);
		if (!_v0.$) {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Formes$Model$idDeLaCreation),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Formes$Update$CreationOuverte)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$formeEtapeAjouter(i18n))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Referentiel$Formes$Model$archivesLues = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.zS;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$filter(
						function ($) {
							return $.tI;
						}),
					$elm$core$List$length)),
			model.nW));
};
var $author$project$Components$Referentiel$Formes$Update$ArchivesChoisies = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Referentiel$Formes$View$idDesArchives = 'formes-archives';
var $author$project$Components$Referentiel$Formes$View$basculeDesArchives = F2(
	function (i18n, model) {
		var nombre = $author$project$Components$Referentiel$Formes$Model$archivesLues(model);
		return (!nombre) ? _List_Nil : _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
						$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Formes$View$idDesArchives),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-expanded',
						model.i$ ? 'true' : 'false'),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Referentiel$Formes$Update$ArchivesChoisies(!model.i$))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						model.i$ ? $author$project$I18n$Cles$relationArchivesMasquer(i18n) : A2(
							$author$project$I18n$Cles$relationArchivesAfficher,
							i18n,
							{w: nombre}))
					]))
			]);
	});
var $author$project$Components$Referentiel$Formes$Update$ModificationOuverte = function (a) {
	return {$: 8, a: a};
};
var $author$project$I18n$Cles$formeEtapeFiches = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'forme.etape.fiches',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiche') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiches'));
	});
var $author$project$I18n$Cles$formeEtapeModifier = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'forme.etape.modifier',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Modifier ' + p.Dj);
	});
var $author$project$Components$Shared$Svg$svgEdit = A3(
	$author$project$Components$Shared$Svg$icone,
	'edit',
	'M13.3119,4.41112 C14.5105,2.78198 16.1727,3.6544 17.4305,4.57977 C18.6882,5.50514 20.0157,6.83244 18.8171,8.46158 L10.6665,19.1249 C10.3023,19.62 9.75542,19.949 9.14744,20.039 L6.08998,20.4916 C5.67267,20.5534 5.2836,20.2671 5.21839,19.8504 L4.74061,16.7967 C4.6456,16.1895 4.79704,15.5695 5.16127,15.0744 L13.3119,4.41112 Z',
	_List_fromArray(
		[
			$author$project$Components$Shared$Svg$traceSecondaire('M11.9999,6.28905 L17.2877,10.1748')
		]));
var $author$project$Components$Referentiel$Formes$View$cartouche = F2(
	function (i18n, forme) {
		var corps = _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(forme.R.zX),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('sens')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$formeEtapeFiches,
							i18n,
							{w: forme.zu}))
					]))
			]);
		return $author$project$Components$Referentiel$Formes$Model$modifiable(forme) ? A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille-forme'),
					$rtfeldman$elm_css$Html$Styled$Attributes$id(
					$author$project$Components$Referentiel$Formes$Model$idDuModifier(forme.Aq)),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					A2(
						$author$project$I18n$Cles$formeEtapeModifier,
						i18n,
						{Dj: forme.R.zX})),
					$rtfeldman$elm_css$Html$Styled$Attributes$title(
					A2(
						$author$project$I18n$Cles$formeEtapeModifier,
						i18n,
						{Dj: forme.R.zX})),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Components$Referentiel$Formes$Update$ModificationOuverte(forme.Aq))
				]),
			_Utils_ap(
				corps,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('crayon')
							]),
						_List_fromArray(
							[$author$project$Components$Shared$Svg$svgEdit]))
					]))) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille-forme')
				]),
			corps);
	});
var $author$project$I18n$Cles$formeEtapeAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'forme.etape.aucun', _List_Nil, 'Aucune forme.');
};
var $author$project$I18n$Cles$formeEtapeExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'forme.etape.explication', _List_Nil, 'La forme d\'une organisation (société, association, administration…) se choisit à la création de sa fiche.');
};
var $author$project$I18n$Cles$formeEtapeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'forme.etape.titre', _List_Nil, 'Formes d\'organisation');
};
var $author$project$Components$Referentiel$Formes$Update$RestaurationDemandee = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Referentiel$Formes$View$ligneArchivee = F2(
	function (i18n, forme) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne-de-forme'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('archive')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('tag-archive')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$relationArchive(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(forme.R.zX)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					function () {
						var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$restaurerLaForme, forme.nQ);
						if (!_v0.$) {
							return _List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Referentiel$Formes$Update$RestaurationDemandee(forme.Aq))
										]),
									$author$project$I18n$Cles$relationRestaurer(i18n))
								]);
						} else {
							return _List_Nil;
						}
					}())
				]));
	});
var $author$project$Components$Referentiel$Formes$Model$visibles = function (model) {
	return A2(
		$elm$core$List$filter,
		function (forme) {
			return model.i$ || (!forme.tI);
		},
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.zS;
				},
				model.nW)));
};
var $author$project$Components$Referentiel$Formes$View$section = F2(
	function (i18n, model) {
		var formes = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.tI;
				},
				$elm$core$Basics$not),
			$author$project$Components$Referentiel$Formes$Model$visibles(model));
		var archives = A2(
			$elm$core$List$filter,
			function ($) {
				return $.tI;
			},
			$author$project$Components$Referentiel$Formes$Model$visibles(model));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('relations'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('formes')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$formeEtapeTitre(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('explication')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$formeEtapeExplication(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
						]),
					((!_Utils_eq(model.nW, $elm$core$Maybe$Nothing)) && ($elm$core$List$isEmpty(formes) && (!$author$project$Components$Referentiel$Formes$Model$archivesLues(model)))) ? _List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$formeEtapeAucun(i18n))
						]) : _List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('formes-liste'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'loading',
									_Utils_eq(model.nW, $elm$core$Maybe$Nothing))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-busy',
							_Utils_eq(model.nW, $elm$core$Maybe$Nothing) ? 'true' : 'false')
						]),
					A2(
						$elm$core$List$map,
						function (forme) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('item')
									]),
								_List_fromArray(
									[
										A2($author$project$Components$Referentiel$Formes$View$cartouche, i18n, forme)
									]));
						},
						formes)),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('archives')
						]),
					A2($author$project$Components$Referentiel$Formes$View$basculeDesArchives, i18n, model)),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('formes-archives'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('hidden', !model.i$)
								]))
						]),
					A2(
						$elm$core$List$map,
						function (forme) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('item')
									]),
								_List_fromArray(
									[
										A2($author$project$Components$Referentiel$Formes$View$ligneArchivee, i18n, forme)
									]));
						},
						archives)),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ajouter')
						]),
					A2($author$project$Components$Referentiel$Formes$View$ajouter, i18n, model))
				]));
	});
var $author$project$Components$Referentiel$Postes$Update$CreationOuverte = {$: 7};
var $author$project$I18n$Cles$posteEtapeAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'poste.etape.ajouter', _List_Nil, 'Ajouter : Poste');
};
var $author$project$Components$Referentiel$Postes$View$ajouter = F2(
	function (i18n, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$creerUnPoste)),
			model.nW);
		if (!_v0.$) {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Postes$Model$idDeLaCreation),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Postes$Update$CreationOuverte)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$posteEtapeAjouter(i18n))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Referentiel$Postes$Model$archivesLues = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.F6;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$filter(
						function ($) {
							return $.tE;
						}),
					$elm$core$List$length)),
			model.nW));
};
var $author$project$Components$Referentiel$Postes$Update$ArchivesChoisies = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Referentiel$Postes$View$idDesArchives = 'postes-archives';
var $author$project$Components$Referentiel$Postes$View$basculeDesArchives = F2(
	function (i18n, model) {
		var nombre = $author$project$Components$Referentiel$Postes$Model$archivesLues(model);
		return (!nombre) ? _List_Nil : _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
						$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Postes$View$idDesArchives),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-expanded',
						model.i$ ? 'true' : 'false'),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Referentiel$Postes$Update$ArchivesChoisies(!model.i$))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						model.i$ ? $author$project$I18n$Cles$relationArchivesMasquer(i18n) : A2(
							$author$project$I18n$Cles$relationArchivesAfficher,
							i18n,
							{w: nombre}))
					]))
			]);
	});
var $author$project$Components$Referentiel$Postes$Update$ModificationOuverte = function (a) {
	return {$: 8, a: a};
};
var $author$project$I18n$Cles$posteEtapeModifier = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'poste.etape.modifier',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Modifier ' + p.Dj);
	});
var $author$project$I18n$Cles$posteEtapeSens = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'poste.etape.sens', _List_Nil, 'Personne professionnelle → organisation');
};
var $author$project$Components$Referentiel$Postes$View$cartouche = F2(
	function (i18n, poste) {
		var corps = _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(poste.R.zX),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('sens')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$posteEtapeSens(i18n))
					]))
			]);
		return $author$project$Components$Referentiel$Postes$Model$modifiable(poste) ? A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille-poste'),
					$rtfeldman$elm_css$Html$Styled$Attributes$id(
					$author$project$Components$Referentiel$Postes$Model$idDuModifier(poste.Aq)),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					A2(
						$author$project$I18n$Cles$posteEtapeModifier,
						i18n,
						{Dj: poste.R.zX})),
					$rtfeldman$elm_css$Html$Styled$Attributes$title(
					A2(
						$author$project$I18n$Cles$posteEtapeModifier,
						i18n,
						{Dj: poste.R.zX})),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Components$Referentiel$Postes$Update$ModificationOuverte(poste.Aq))
				]),
			_Utils_ap(
				corps,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('crayon')
							]),
						_List_fromArray(
							[$author$project$Components$Shared$Svg$svgEdit]))
					]))) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille-poste')
				]),
			corps);
	});
var $author$project$Components$Referentiel$Postes$Update$RestaurationDemandee = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Referentiel$Postes$View$ligneArchivee = F2(
	function (i18n, poste) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne-de-poste'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('archive')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('tag-archive')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$relationArchive(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(poste.R.zX)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					function () {
						var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$restaurerLePoste, poste.nQ);
						if (!_v0.$) {
							return _List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Referentiel$Postes$Update$RestaurationDemandee(poste.Aq))
										]),
									$author$project$I18n$Cles$relationRestaurer(i18n))
								]);
						} else {
							return _List_Nil;
						}
					}())
				]));
	});
var $author$project$I18n$Cles$posteEtapeAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'poste.etape.aucun', _List_Nil, 'Aucun poste.');
};
var $author$project$I18n$Cles$posteEtapeExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'poste.etape.explication', _List_Nil, 'Un poste relie une personne professionnelle à l\'organisation où elle travaille.');
};
var $author$project$Components$Referentiel$Postes$Model$visibles = function (model) {
	return A2(
		$elm$core$List$filter,
		function (poste) {
			return model.i$ || (!poste.tE);
		},
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.F6;
				},
				model.nW)));
};
var $author$project$Components$Referentiel$Postes$View$section = F2(
	function (i18n, model) {
		var postes = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.tE;
				},
				$elm$core$Basics$not),
			$author$project$Components$Referentiel$Postes$Model$visibles(model));
		var archives = A2(
			$elm$core$List$filter,
			function ($) {
				return $.tE;
			},
			$author$project$Components$Referentiel$Postes$Model$visibles(model));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('relations'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('postes')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$posteEtapeTitre(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('explication')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$posteEtapeExplication(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
						]),
					((!_Utils_eq(model.nW, $elm$core$Maybe$Nothing)) && ($elm$core$List$isEmpty(postes) && (!$author$project$Components$Referentiel$Postes$Model$archivesLues(model)))) ? _List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$posteEtapeAucun(i18n))
						]) : _List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('postes-liste'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'loading',
									_Utils_eq(model.nW, $elm$core$Maybe$Nothing))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-busy',
							_Utils_eq(model.nW, $elm$core$Maybe$Nothing) ? 'true' : 'false')
						]),
					A2(
						$elm$core$List$map,
						function (poste) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('item')
									]),
								_List_fromArray(
									[
										A2($author$project$Components$Referentiel$Postes$View$cartouche, i18n, poste)
									]));
						},
						postes)),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('archives')
						]),
					A2($author$project$Components$Referentiel$Postes$View$basculeDesArchives, i18n, model)),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('postes-archives'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('hidden', !model.i$)
								]))
						]),
					A2(
						$elm$core$List$map,
						function (poste) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('item')
									]),
								_List_fromArray(
									[
										A2($author$project$Components$Referentiel$Postes$View$ligneArchivee, i18n, poste)
									]));
						},
						archives)),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ajouter')
						]),
					A2($author$project$Components$Referentiel$Postes$View$ajouter, i18n, model))
				]));
	});
var $author$project$Main$View$utilisateur = function (model) {
	var _v0 = model.e1.gt;
	if (_v0.$ === 1) {
		var connexion = _v0.a;
		return {
			AP: $author$project$Texte$Initiales$initiales(connexion.Dj),
			Dj: connexion.Dj
		};
	} else {
		return {AP: '', Dj: ''};
	}
};
var $author$project$I18n$Cles$accueilTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.titre', _List_Nil, 'Accueil');
};
var $author$project$Components$Accueil$Update$Precedente = {$: 2};
var $author$project$Components$Accueil$Update$Suivante = {$: 3};
var $author$project$I18n$Cles$accueilCampagnesCarrousel = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.campagnes.carrousel', _List_Nil, 'Campagnes en cours');
};
var $author$project$I18n$Cles$accueilCampagnesPrecedente = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.campagnes.precedente', _List_Nil, 'Campagne précédente');
};
var $author$project$I18n$Cles$accueilCampagnesSuivante = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.campagnes.suivante', _List_Nil, 'Campagne suivante');
};
var $author$project$I18n$Cles$accueilCampagnesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.campagnes.titre', _List_Nil, 'Campagnes en cours');
};
var $author$project$I18n$Cles$accueilCampagnesToutes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.campagnes.toutes', _List_Nil, 'Toutes les campagnes');
};
var $author$project$Components$Accueil$View$boutonDeRang = F5(
	function (nom, msg, desactive, icone, classe) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('button-icon ' + classe),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', nom),
					$rtfeldman$elm_css$Html$Styled$Attributes$title(nom),
					$rtfeldman$elm_css$Html$Styled$Attributes$disabled(desactive),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
				]),
			_List_fromArray(
				[icone]));
	});
var $author$project$I18n$Cles$accueilCampagnesAutres = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.campagnes.autres',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'+ ' + (p.w + ' autres références'));
	});
var $author$project$I18n$Cles$accueilCampagnesAvantCloture = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.campagnes.avant-cloture', _List_Nil, 'avant clôture');
};
var $author$project$I18n$Cles$accueilCampagnesCa = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.campagnes.ca',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'engage',
					$author$project$I18n$Traductions$Chaine(p.yq)),
					_Utils_Tuple2(
					'prevu',
					$author$project$I18n$Traductions$Chaine(p.Gl)),
					_Utils_Tuple2(
					'pourcentage',
					$author$project$I18n$Traductions$Chaine(p.Gb))
				]),
			p.yq + (' engagés sur ' + (p.Gl + (' prévus · ' + (p.Gb + ' %')))));
	});
var $author$project$I18n$Cles$accueilCampagnesCaNonRenseigne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.campagnes.ca-non-renseigne', _List_Nil, 'CA non renseigné');
};
var $author$project$I18n$Cles$accueilCampagnesCarte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.campagnes.carte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rang',
					$author$project$I18n$Traductions$Chaine(p.bY)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			'Campagne ' + (p.bY + (' sur ' + p.JE)));
	});
var $author$project$I18n$Cles$accueilCampagnesChiffreAffaires = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.campagnes.chiffre-affaires', _List_Nil, 'Chiffre d\'affaires');
};
var $author$project$I18n$Cles$accueilCampagnesCommandes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.campagnes.commandes', _List_Nil, 'commandes à valider');
};
var $author$project$I18n$Cles$accueilCampagnesEngagees = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.campagnes.engagees',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'engagees',
					$author$project$I18n$Traductions$Chaine(p.lY)),
					_Utils_Tuple2(
					'moq',
					$author$project$I18n$Traductions$Chaine(p.ok))
				]),
			p.lY + (' engagées sur ' + (p.ok + ' unités')));
	});
var $author$project$I18n$Cles$accueilCampagnesJours = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.campagnes.jours',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			p.w + ' j');
	});
var $author$project$I18n$Cles$accueilCampagnesLicenciesEngages = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.campagnes.licencies-engages', _List_Nil, 'licenciés engagés');
};
var $author$project$I18n$Cles$accueilCampagnesNombre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.campagnes.nombre', _List_Nil, 'références');
};
var $author$project$I18n$Cles$accueilCampagnesOuvrir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.campagnes.ouvrir', _List_Nil, 'Ouvrir la campagne');
};
var $author$project$I18n$Cles$accueilCampagnesPipeEtape = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.campagnes.pipe-etape',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'pipe',
					$author$project$I18n$Traductions$Chaine(p.Fs)),
					_Utils_Tuple2(
					'etape',
					$author$project$I18n$Traductions$Chaine(p.me))
				]),
			p.Fs + (' · étape ' + p.me));
	});
var $author$project$I18n$Cles$accueilCampagnesPourcentage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.campagnes.pourcentage',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			p.fm + ' %');
	});
var $author$project$I18n$Cles$accueilCampagnesPremieres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.campagnes.premieres', _List_Nil, 'Premières références engagées');
};
var $author$project$I18n$Cles$accueilCampagnesReferences = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.campagnes.references', _List_Nil, 'Références');
};
var $author$project$I18n$Cles$accueilCampagnesToutesListees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.campagnes.toutes-listees', _List_Nil, 'Toutes les références sont listées');
};
var $author$project$I18n$Cles$accueilCampagnesUneSeule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.campagnes.une-seule', _List_Nil, 'Une seule référence dans cette campagne');
};
var $author$project$Components$Accueil$View$chiffre = F2(
	function (valeur, libelle) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(valeur)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						]))
				]));
	});
var $author$project$Components$Accueil$View$classeDeTonalite = function (tonalite) {
	switch (tonalite) {
		case 0:
			return 'vert';
		case 1:
			return 'ambre';
		default:
			return 'accent';
	}
};
var $author$project$I18n$Cles$accueilCampagnesProgression = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.campagnes.progression',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'engagees',
					$author$project$I18n$Traductions$Chaine(p.lY)),
					_Utils_Tuple2(
					'moq',
					$author$project$I18n$Traductions$Chaine(p.ok)),
					_Utils_Tuple2(
					'pourcentage',
					$author$project$I18n$Traductions$Chaine(p.Gb))
				]),
			p.lY + (' unités engagées sur ' + (p.ok + (', ' + (p.Gb + ' %')))));
	});
var $author$project$Components$Accueil$View$jauge = F3(
	function (nom, part, contenu) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('jauge'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'img'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', nom),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'style',
					'--part: ' + ($elm$core$String$fromInt(
						A3($elm$core$Basics$clamp, 0, 100, part)) + '%'))
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('part')
						]),
					_List_Nil),
				contenu));
	});
var $author$project$Components$Accueil$View$progression = F2(
	function (i18n, campagne) {
		return A3(
			$author$project$Components$Accueil$View$jauge,
			A2(
				$author$project$I18n$Cles$accueilCampagnesProgression,
				i18n,
				{
					lY: $elm$core$String$fromInt(campagne.lY),
					ok: $elm$core$String$fromInt(campagne.ok),
					Gb: $elm$core$String$fromInt(campagne.Gb)
				}),
			campagne.Gb,
			_List_Nil);
	});
var $author$project$I18n$Cles$accueilCampagnesReferenceAvancement = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.campagnes.reference-avancement',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'engagees',
					$author$project$I18n$Traductions$Chaine(p.lY)),
					_Utils_Tuple2(
					'moq',
					$author$project$I18n$Traductions$Chaine(p.ok))
				]),
			p.lY + (' / ' + p.ok));
	});
var $author$project$Components$Accueil$View$reference = F3(
	function (i18n, campagne, r) {
		var plus = A2(
			$elm$core$Maybe$withDefault,
			1,
			$elm$core$List$maximum(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.lY;
					},
					campagne.hD)));
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('code'),
							$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Routes$Route$adressePipes)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(r.vx)
						])),
					A3(
					$author$project$Components$Accueil$View$jauge,
					A2(
						$author$project$I18n$Cles$accueilCampagnesReferenceAvancement,
						i18n,
						{
							lY: $elm$core$String$fromInt(r.lY),
							ok: $elm$core$String$fromInt(r.ok)
						}),
					((r.lY * 100) / A2($elm$core$Basics$max, 1, plus)) | 0,
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(r.lY))
						]))
				]));
	});
var $author$project$Components$Shared$Svg$svgChevronRight = A3($author$project$Components$Shared$Svg$icone, 'chevron-right', 'M9 6l6 6-6 6', _List_Nil);
var $author$project$Components$Accueil$View$carte = F5(
	function (i18n, total, rang, position, campagne) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('carte-campagne'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'avant',
							_Utils_cmp(position, rang) < 0)
						])),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'group'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-roledescription', 'diapositive'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					A2(
						$author$project$I18n$Cles$accueilCampagnesCarte,
						i18n,
						{
							bY: $elm$core$String$fromInt(position + 1),
							JE: $elm$core$String$fromInt(total)
						}))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('haut')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom'),
									$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Routes$Route$adressePipes)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(campagne.Dj)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class(
									'tag ' + $author$project$Components$Accueil$View$classeDeTonalite(campagne.rI))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(campagne.gt)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('pipe-etape')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$accueilCampagnesPipeEtape,
								i18n,
								{me: campagne.me, Fs: campagne.Fs}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('progression')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('valeurs')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$accueilCampagnesPourcentage,
												i18n,
												{
													fm: $elm$core$String$fromInt(campagne.Gb)
												}))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$accueilCampagnesEngagees,
												i18n,
												{
													lY: $elm$core$String$fromInt(campagne.lY),
													ok: $elm$core$String$fromInt(campagne.ok)
												}))
										]))
								])),
							A2($author$project$Components$Accueil$View$progression, i18n, campagne)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ca')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$accueilCampagnesChiffreAffaires(i18n))
								])),
							function () {
							var _v0 = campagne.uA;
							if (!_v0.$) {
								var ca = _v0.a;
								return A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$accueilCampagnesCa,
												i18n,
												{
													yq: ca.yq,
													Gb: $elm$core$String$fromInt(campagne.Gb),
													Gl: ca.Gl
												}))
										]));
							} else {
								return A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$accueilCampagnesCaNonRenseigne(i18n))
										]));
							}
						}()
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('chiffres')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Accueil$View$chiffre,
							$elm$core$String$fromInt(
								$elm$core$List$length(campagne.hD) + campagne.t7),
							$author$project$I18n$Cles$accueilCampagnesNombre(i18n)),
							A2(
							$author$project$Components$Accueil$View$chiffre,
							$elm$core$String$fromInt(campagne.Bw),
							$author$project$I18n$Cles$accueilCampagnesLicenciesEngages(i18n)),
							A2(
							$author$project$Components$Accueil$View$chiffre,
							A2(
								$author$project$I18n$Cles$accueilCampagnesJours,
								i18n,
								{
									w: $elm$core$String$fromInt(campagne.A2)
								}),
							$author$project$I18n$Cles$accueilCampagnesAvantCloture(i18n)),
							A2(
							$author$project$Components$Accueil$View$chiffre,
							$elm$core$String$fromInt(campagne.vK),
							$author$project$I18n$Cles$accueilCampagnesCommandes(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('premieres')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$accueilCampagnesPremieres(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('references'),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-label',
							$author$project$I18n$Cles$accueilCampagnesReferences(i18n))
						]),
					A2(
						$elm$core$List$map,
						A2($author$project$Components$Accueil$View$reference, i18n, campagne),
						A2($elm$core$List$take, 3, campagne.hD))),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('autres')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							(campagne.t7 > 0) ? A2(
								$author$project$I18n$Cles$accueilCampagnesAutres,
								i18n,
								{
									w: $elm$core$String$fromInt(campagne.t7)
								}) : (($elm$core$List$length(campagne.hD) === 1) ? $author$project$I18n$Cles$accueilCampagnesUneSeule(i18n) : $author$project$I18n$Cles$accueilCampagnesToutesListees(i18n)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ouvrir'),
							$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Routes$Route$adressePipes)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$accueilCampagnesOuvrir(i18n)),
							$author$project$Components$Shared$Svg$svgChevronRight
						]))
				]));
	});
var $author$project$Components$Accueil$Update$RangChoisi = function (a) {
	return {$: 4, a: a};
};
var $author$project$I18n$Cles$accueilCampagnesAllerA = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.campagnes.aller-a',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rang',
					$author$project$I18n$Traductions$Chaine(p.bY)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			'Aller à la campagne ' + (p.bY + (' sur ' + p.JE)));
	});
var $author$project$Components$Accueil$View$point = F5(
	function (i18n, total, rang, position, _v0) {
		var nom = A2(
			$author$project$I18n$Cles$accueilCampagnesAllerA,
			i18n,
			{
				bY: $elm$core$String$fromInt(position + 1),
				JE: $elm$core$String$fromInt(total)
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('point', true),
									_Utils_Tuple2(
									'active',
									_Utils_eq(position, rang))
								])),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', nom),
							$rtfeldman$elm_css$Html$Styled$Attributes$title(nom),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-current',
							_Utils_eq(position, rang) ? 'true' : 'false'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Accueil$Update$RangChoisi(position))
						]),
					_List_Nil)
				]));
	});
var $author$project$I18n$Cles$accueilCampagnesAfficheeUne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.campagnes.affichee-une',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rang',
					$author$project$I18n$Traductions$Chaine(p.bY)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			p.bY + (' sur ' + (p.JE + ' affichée')));
	});
var $author$project$I18n$Cles$accueilCampagnesAfficheesDeux = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.campagnes.affichees-deux',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'premiere',
					$author$project$I18n$Traductions$Chaine(p.Gf)),
					_Utils_Tuple2(
					'seconde',
					$author$project$I18n$Traductions$Chaine(p.Iv)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			p.Gf + (' et ' + (p.Iv + (' sur ' + (p.JE + ' affichées')))));
	});
var $author$project$I18n$Cles$accueilCampagnesSousTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.campagnes.sous-titre', _List_Nil, 'Clôture la plus proche d\'abord');
};
var $author$project$Components$Accueil$View$sousTitreDuCarrousel = F3(
	function (i18n, rang, total) {
		var premiere = A3(
			$elm$core$Basics$clamp,
			0,
			A2($elm$core$Basics$max, 0, total - 2),
			rang) + 1;
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$I18n$Cles$accueilCampagnesSousTitre(i18n) + ' · '),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('deux-cartes')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						(total < 2) ? A2(
							$author$project$I18n$Cles$accueilCampagnesAfficheeUne,
							i18n,
							{
								bY: $elm$core$String$fromInt(rang + 1),
								JE: $elm$core$String$fromInt(total)
							}) : A2(
							$author$project$I18n$Cles$accueilCampagnesAfficheesDeux,
							i18n,
							{
								Gf: $elm$core$String$fromInt(premiere),
								Iv: $elm$core$String$fromInt(premiere + 1),
								JE: $elm$core$String$fromInt(total)
							}))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('une-carte')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$accueilCampagnesAfficheeUne,
							i18n,
							{
								bY: $elm$core$String$fromInt(rang + 1),
								JE: $elm$core$String$fromInt(total)
							}))
					]))
			]);
	});
var $author$project$Components$Accueil$View$encartDesCampagnes = F3(
	function (i18n, rang, tableau) {
		var total = $elm$core$List$length(tableau.uE);
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('bloc'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('campagnes')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('titres')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h2,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$accueilCampagnesTitre(i18n)),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('nombre')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$elm$core$String$fromInt(total))
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('sous-titre')
										]),
									A3($author$project$Components$Accueil$View$sousTitreDuCarrousel, i18n, rang, total))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Routes$Route$adressePipes)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$accueilCampagnesToutes(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('boutons')
								]),
							_List_fromArray(
								[
									A5(
									$author$project$Components$Accueil$View$boutonDeRang,
									$author$project$I18n$Cles$accueilCampagnesPrecedente(i18n),
									$author$project$Components$Accueil$Update$Precedente,
									rang <= 0,
									$author$project$Components$Shared$Svg$svgChevronLeft,
									'precedente'),
									A5(
									$author$project$Components$Accueil$View$boutonDeRang,
									$author$project$I18n$Cles$accueilCampagnesSuivante(i18n),
									$author$project$Components$Accueil$Update$Suivante,
									_Utils_cmp(rang, total - 1) > -1,
									$author$project$Components$Shared$Svg$svgChevronRight,
									'suivante')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('carrousel'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'group'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-roledescription', 'carrousel'),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-label',
							$author$project$I18n$Cles$accueilCampagnesCarrousel(i18n))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('fenetre')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$ul,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('piste'),
											A2(
											$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
											'style',
											'--rang: ' + ($elm$core$String$fromInt(rang) + ('; --total: ' + $elm$core$String$fromInt(total))))
										]),
									A2(
										$elm$core$List$indexedMap,
										A3($author$project$Components$Accueil$View$carte, i18n, total, rang),
										tableau.uE))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('points')
								]),
							A2(
								$elm$core$List$indexedMap,
								A3($author$project$Components$Accueil$View$point, i18n, total, rang),
								tableau.uE))
						]))
				]));
	});
var $author$project$Components$Accueil$View$campagnes = F3(
	function (i18n, rang, tableau) {
		return $elm$core$List$isEmpty(tableau.uE) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A3($author$project$Components$Accueil$View$encartDesCampagnes, i18n, rang, tableau));
	});
var $author$project$I18n$Cles$accueilCatalogueARanger = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.catalogue.a-ranger', _List_Nil, 'à ranger');
};
var $author$project$I18n$Cles$accueilCatalogueCompletes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.catalogue.completes', _List_Nil, 'complètes');
};
var $author$project$I18n$Cles$accueilCatalogueCompletudeMoyenne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.catalogue.completude-moyenne', _List_Nil, 'complétude moyenne');
};
var $author$project$I18n$Cles$accueilCatalogueCreees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.catalogue.creees', _List_Nil, 'créées cette semaine');
};
var $author$project$I18n$Cles$accueilCatalogueModifiees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.catalogue.modifiees', _List_Nil, 'modifiées cette semaine');
};
var $author$project$I18n$Cles$accueilCatalogueParEtat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.catalogue.par-etat', _List_Nil, 'Par état');
};
var $author$project$I18n$Cles$accueilCataloguePourcent = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.catalogue.pourcent',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			p.fm + ' %');
	});
var $author$project$I18n$Cles$accueilCataloguePublication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.catalogue.publication', _List_Nil, 'Publication');
};
var $author$project$I18n$Cles$accueilCatalogueSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.catalogue.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w)),
					_Utils_Tuple2(
					'typologie',
					$author$project$I18n$Traductions$Chaine(p.r3))
				]),
			p.w + (' références · ' + p.r3));
	});
var $author$project$I18n$Cles$accueilCatalogueTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.catalogue.titre', _List_Nil, 'Évolution du catalogue et des références');
};
var $author$project$I18n$Cles$accueilCatalogueVoir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.catalogue.voir', _List_Nil, 'Voir les références');
};
var $author$project$I18n$Cles$accueilQualiteSur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.qualite.sur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w)),
					_Utils_Tuple2(
					'sur',
					$author$project$I18n$Traductions$Chaine(p.h1))
				]),
			p.w + (' / ' + p.h1));
	});
var $author$project$Components$Accueil$View$entete = function (e) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('titres')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h2,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(e.h6)
							])),
						function () {
						var _v0 = e.aO;
						if (!_v0.$) {
							var sousTitre = _v0.a;
							return A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('sous-titre')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(sousTitre)
									]));
						} else {
							return $rtfeldman$elm_css$Html$Styled$text('');
						}
					}()
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$href(e.aa)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(e.nB)
					]))
			]));
};
var $author$project$Components$Accueil$View$pastille = F2(
	function (valeur, libelle) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Routes$Route$adresseCatalogue)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(valeur)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(libelle)
								]))
						]))
				]));
	});
var $author$project$I18n$Cles$accueilCatalogueLigneAria = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.catalogue.ligne-aria',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			p.Dj + (' : ' + (p.w + (' sur ' + (p.JE + '. Liste filtrée')))));
	});
var $author$project$Components$Accueil$View$serie = F4(
	function (i18n, titre, total, valeurs) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('serie')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(titre)
						])),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var nom = _v0.a;
						var nombre = _v0.b;
						return A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne'),
									$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Routes$Route$adresseCatalogue),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									A2(
										$author$project$I18n$Cles$accueilCatalogueLigneAria,
										i18n,
										{
											Dj: nom,
											w: $elm$core$String$fromInt(nombre),
											JE: $elm$core$String$fromInt(total)
										}))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(nom)
										])),
									A3(
									$author$project$Components$Accueil$View$jauge,
									'',
									(!total) ? 0 : (((nombre * 100) / total) | 0),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$elm$core$String$fromInt(nombre))
										]))
								]));
					},
					valeurs)));
	});
var $author$project$Components$Accueil$View$catalogue = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.rw, model.jB);
		if (!_v0.a.$) {
			var t = _v0.a.a;
			var p = t.Gz;
			var total = A2(
				$elm$core$Maybe$withDefault,
				p.JE,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.hD;
					},
					model.jB));
			return A2(
				$rtfeldman$elm_css$Html$Styled$section,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('bloc'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('catalogue')
					]),
				_List_fromArray(
					[
						$author$project$Components$Accueil$View$entete(
						{
							aa: $author$project$Routes$Route$adresseCatalogue,
							nB: $author$project$I18n$Cles$accueilCatalogueVoir(i18n),
							aO: $elm$core$Maybe$Just(
								A2(
									$author$project$I18n$Cles$accueilCatalogueSousTitre,
									i18n,
									{
										w: $elm$core$String$fromInt(total),
										r3: p.r3
									})),
							h6: $author$project$I18n$Cles$accueilCatalogueTitre(i18n)
						}),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('series')
							]),
						_List_fromArray(
							[
								A4(
								$author$project$Components$Accueil$View$serie,
								i18n,
								$author$project$I18n$Cles$accueilCatalogueParEtat(i18n),
								total,
								p.EP),
								A4(
								$author$project$Components$Accueil$View$serie,
								i18n,
								$author$project$I18n$Cles$accueilCataloguePublication(i18n),
								total,
								p.mj)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('pastilles')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$Accueil$View$pastille,
								A2(
									$author$project$I18n$Cles$accueilCataloguePourcent,
									i18n,
									{
										fm: $elm$core$String$fromInt(p.vU)
									}),
								$author$project$I18n$Cles$accueilCatalogueCompletudeMoyenne(i18n)),
								A2(
								$author$project$Components$Accueil$View$pastille,
								$elm$core$String$fromInt(p.wo),
								$author$project$I18n$Cles$accueilCatalogueCreees(i18n)),
								A2(
								$author$project$Components$Accueil$View$pastille,
								$elm$core$String$fromInt(p.CP),
								$author$project$I18n$Cles$accueilCatalogueModifiees(i18n)),
								A2(
								$author$project$Components$Accueil$View$pastille,
								$elm$core$String$fromInt(p.iz),
								$author$project$I18n$Cles$accueilCatalogueARanger(i18n))
							]))
					]));
		} else {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var c = _v0.b.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$section,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('bloc'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('catalogue')
						]),
					_List_fromArray(
						[
							$author$project$Components$Accueil$View$entete(
							{
								aa: $author$project$Routes$Route$adresseCatalogue,
								nB: $author$project$I18n$Cles$accueilCatalogueVoir(i18n),
								aO: $elm$core$Maybe$Nothing,
								h6: $author$project$I18n$Cles$accueilCatalogueTitre(i18n)
							}),
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('pastilles')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Components$Accueil$View$pastille,
									A2(
										$author$project$I18n$Cles$accueilQualiteSur,
										i18n,
										{
											w: $elm$core$String$fromInt(c.vT),
											h1: $elm$core$String$fromInt(c.hD)
										}),
									$author$project$I18n$Cles$accueilCatalogueCompletes(i18n))
								]))
						]));
			} else {
				var _v2 = _v0.a;
				var _v3 = _v0.b;
				return A2(
					$rtfeldman$elm_css$Html$Styled$section,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('bloc'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('catalogue')
						]),
					_List_fromArray(
						[
							$author$project$Components$Accueil$View$entete(
							{
								aa: $author$project$Routes$Route$adresseCatalogue,
								nB: $author$project$I18n$Cles$accueilCatalogueVoir(i18n),
								aO: $elm$core$Maybe$Nothing,
								h6: $author$project$I18n$Cles$accueilCatalogueTitre(i18n)
							}),
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('pastilles')
								]),
							_List_Nil)
						]));
			}
		}
	});
var $author$project$I18n$Cles$accueilCompteurAria = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.compteur.aria',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl)),
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm)),
					_Utils_Tuple2(
					'sens',
					$author$project$I18n$Traductions$Chaine(p.IC)),
					_Utils_Tuple2(
					'tendance',
					$author$project$I18n$Traductions$Chaine(p.Jr))
				]),
			p.Bl + (' : ' + (p.fm + (', ' + (p.IC + (' (' + (p.Jr + '). Ouvrir la page.')))))));
	});
var $author$project$Components$Accueil$View$adresseDeCompteur = function (id) {
	return (id === 'dossiers-en-cours') ? $author$project$Routes$Route$adressePipes : $author$project$Routes$Route$adresseDesNotifications;
};
var $author$project$Components$Shared$Svg$svgArrowDown = A3($author$project$Components$Shared$Svg$icone, 'arrow-down', 'M12 5v14M6 13l6 6 6-6', _List_Nil);
var $author$project$Components$Shared$Svg$svgArrowUp = A3($author$project$Components$Shared$Svg$icone, 'arrow-up', 'M12 19V5M6 11l6-6 6 6', _List_Nil);
var $author$project$Components$Accueil$View$fleche = function (variation) {
	return (variation > 0) ? $author$project$Components$Shared$Svg$svgArrowUp : ((variation < 0) ? $author$project$Components$Shared$Svg$svgArrowDown : $author$project$Components$Shared$Svg$svgArrowRight);
};
var $author$project$Components$Shared$Svg$svgAiSparkles = A3($author$project$Components$Shared$Svg$icone, 'ai-sparkles', 'M11 3l1.9 5.1L18 10l-5.1 1.9L11 17l-1.9-5.1L4 10l5.1-1.9zM18.5 14.5l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z', _List_Nil);
var $author$project$Components$Shared$Svg$svgClock = A3(
	$author$project$Components$Shared$Svg$icone,
	'clock',
	'M12 7.5V12l3 2',
	_List_fromArray(
		[
			A3($author$project$Components$Shared$Svg$cercle, 12, 12, 8.5)
		]));
var $author$project$Components$Shared$Svg$svgFolder = A3($author$project$Components$Shared$Svg$icone, 'folder', 'M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM8 13h8', _List_Nil);
var $author$project$Components$Shared$Svg$svgMail = A3($author$project$Components$Shared$Svg$icone, 'mail', 'M5 5.5h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2zM3.5 7l8.5 6 8.5-6', _List_Nil);
var $author$project$Components$Shared$Svg$svgValidation = A3($author$project$Components$Shared$Svg$icone, 'validation', 'M5 12.5l4.5 4.5L19 7.5', _List_Nil);
var $author$project$Components$Accueil$View$iconeDeCompteur = function (id) {
	switch (id) {
		case 'taches-en-retard':
			return $author$project$Components$Shared$Svg$svgClock;
		case 'validations':
			return $author$project$Components$Shared$Svg$svgValidation;
		case 'messages-non-lus':
			return $author$project$Components$Shared$Svg$svgMail;
		case 'dossiers-en-cours':
			return $author$project$Components$Shared$Svg$svgFolder;
		default:
			return $author$project$Components$Shared$Svg$svgAiSparkles;
	}
};
var $author$project$I18n$Cles$accueilCompteurDossiersEnCours = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.compteur.dossiers-en-cours', _List_Nil, 'Dossiers en cours');
};
var $author$project$I18n$Cles$accueilCompteurMessagesNonLus = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.compteur.messages-non-lus', _List_Nil, 'Messages non lus');
};
var $author$project$I18n$Cles$accueilCompteurPropositionsIa = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.compteur.propositions-ia', _List_Nil, 'Propositions d’agents IA');
};
var $author$project$I18n$Cles$accueilCompteurTachesEnRetard = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.compteur.taches-en-retard', _List_Nil, 'Tâches en retard');
};
var $author$project$I18n$Cles$accueilCompteurValidations = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.compteur.validations', _List_Nil, 'Validations à donner');
};
var $author$project$Components$Accueil$Vocabulaire$libelleDeCompteur = F2(
	function (i18n, id) {
		switch (id) {
			case 'taches-en-retard':
				return $author$project$I18n$Cles$accueilCompteurTachesEnRetard(i18n);
			case 'validations':
				return $author$project$I18n$Cles$accueilCompteurValidations(i18n);
			case 'messages-non-lus':
				return $author$project$I18n$Cles$accueilCompteurMessagesNonLus(i18n);
			case 'dossiers-en-cours':
				return $author$project$I18n$Cles$accueilCompteurDossiersEnCours(i18n);
			default:
				return $author$project$I18n$Cles$accueilCompteurPropositionsIa(i18n);
		}
	});
var $author$project$I18n$Cles$accueilCompteurSensBaisse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.compteur.sens.baisse', _List_Nil, 'en baisse');
};
var $author$project$I18n$Cles$accueilCompteurSensEvolution = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.compteur.sens.evolution', _List_Nil, 'évolution');
};
var $author$project$I18n$Cles$accueilCompteurSensHausse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.compteur.sens.hausse', _List_Nil, 'en hausse');
};
var $author$project$Components$Accueil$View$sensDeTendance = F2(
	function (i18n, c) {
		var _v0 = _Utils_Tuple2(
			c.rI,
			A2($elm$core$Basics$compare, c.Kx, 0));
		_v0$0:
		while (true) {
			switch (_v0.b) {
				case 0:
					if (_v0.a === 2) {
						break _v0$0;
					} else {
						var _v2 = _v0.b;
						return $author$project$I18n$Cles$accueilCompteurSensBaisse(i18n);
					}
				case 2:
					if (_v0.a === 2) {
						break _v0$0;
					} else {
						var _v3 = _v0.b;
						return $author$project$I18n$Cles$accueilCompteurSensHausse(i18n);
					}
				default:
					if (_v0.a === 2) {
						break _v0$0;
					} else {
						var _v4 = _v0.b;
						return $author$project$I18n$Cles$accueilCompteurSensEvolution(i18n);
					}
			}
		}
		var _v1 = _v0.a;
		return $author$project$I18n$Cles$accueilCompteurSensEvolution(i18n);
	});
var $author$project$Components$Shared$Svg$svgArrowUpRight = A3($author$project$Components$Shared$Svg$icone, 'arrow-up-right', 'M7 17L17 7M9 7h8v8', _List_Nil);
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $author$project$I18n$Cles$accueilTendanceHier = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.tendance.hier',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'variation',
					$author$project$I18n$Traductions$Chaine(p.Kx))
				]),
			p.Kx + ' vs hier');
	});
var $author$project$I18n$Cles$accueilTendanceSemaine = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.tendance.semaine',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'variation',
					$author$project$I18n$Traductions$Chaine(p.Kx))
				]),
			p.Kx + ' vs semaine passée');
	});
var $author$project$I18n$Cles$accueilTendanceStableHier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.tendance.stable-hier', _List_Nil, 'Stable');
};
var $author$project$I18n$Cles$accueilTendanceStableSemaine = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.tendance.stable-semaine', _List_Nil, 'Stable');
};
var $author$project$Components$Accueil$View$texteDeTendance = F2(
	function (i18n, c) {
		var signe = (c.Kx > 0) ? ('+' + $elm$core$String$fromInt(c.Kx)) : ('−' + $elm$core$String$fromInt(
			$elm$core$Basics$abs(c.Kx)));
		var _v0 = _Utils_Tuple2(!c.Kx, c.pi === 'hier');
		if (_v0.a) {
			if (_v0.b) {
				return $author$project$I18n$Cles$accueilTendanceStableHier(i18n);
			} else {
				return $author$project$I18n$Cles$accueilTendanceStableSemaine(i18n);
			}
		} else {
			if (_v0.b) {
				return A2(
					$author$project$I18n$Cles$accueilTendanceHier,
					i18n,
					{Kx: signe});
			} else {
				return A2(
					$author$project$I18n$Cles$accueilTendanceSemaine,
					i18n,
					{Kx: signe});
			}
		}
	});
var $author$project$Components$Accueil$View$tonaliteEnClasse = function (tonalite) {
	switch (tonalite) {
		case 0:
			return 'bon';
		case 1:
			return 'alerte';
		default:
			return 'neutre';
	}
};
var $author$project$Components$Accueil$View$unCompteur = F2(
	function (i18n, c) {
		var tendance = A2($author$project$Components$Accueil$View$texteDeTendance, i18n, c);
		var libelle = A2($author$project$Components$Accueil$Vocabulaire$libelleDeCompteur, i18n, c.Aq);
		return A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('compteur ' + c.Aq),
					$rtfeldman$elm_css$Html$Styled$Attributes$href(
					$author$project$Components$Accueil$View$adresseDeCompteur(c.Aq)),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					A2(
						$author$project$I18n$Cles$accueilCompteurAria,
						i18n,
						{
							Bl: libelle,
							IC: A2($author$project$Components$Accueil$View$sensDeTendance, i18n, c),
							Jr: tendance,
							fm: $elm$core$String$fromInt(c.fm)
						}))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ouvrir'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
						]),
					_List_fromArray(
						[$author$project$Components$Shared$Svg$svgArrowUpRight])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
						]),
					_List_fromArray(
						[
							$author$project$Components$Accueil$View$iconeDeCompteur(c.Aq)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(c.fm))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('tendance'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class(
							$author$project$Components$Accueil$View$tonaliteEnClasse(c.rI))
						]),
					_List_fromArray(
						[
							$author$project$Components$Accueil$View$fleche(c.Kx),
							$rtfeldman$elm_css$Html$Styled$text(tendance)
						]))
				]));
	});
var $author$project$Components$Accueil$View$compteurs = F2(
	function (i18n, tableau) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('compteurs')
				]),
			A2(
				$elm$core$List$map,
				$author$project$Components$Accueil$View$unCompteur(i18n),
				tableau.v0));
	});
var $author$project$I18n$Cles$accueilDossiersNombreDePipes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.dossiers.nombre-de-pipes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' pipe') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' pipes'));
	});
var $author$project$I18n$Cles$accueilDossiersSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.dossiers.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'dossiers',
					$author$project$I18n$Traductions$Chaine(p.xJ)),
					_Utils_Tuple2(
					'pipes',
					$author$project$I18n$Traductions$Chaine(p.FM))
				]),
			p.xJ + (' dossiers dans ' + (p.FM + ', répartis par étape du début à la fin de chaque pipe')));
	});
var $author$project$I18n$Cles$accueilDossiersTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.dossiers.titre', _List_Nil, 'Dossiers en cours');
};
var $author$project$I18n$Cles$accueilDossiersVoir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.dossiers.voir', _List_Nil, 'Voir tous les dossiers');
};
var $author$project$I18n$Cles$accueilDossiersCompte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.dossiers.compte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' dossier') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' dossiers'));
	});
var $author$project$I18n$Cles$accueilDossiersEnRetard = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.dossiers.en-retard',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			p.w + ' en retard');
	});
var $author$project$Components$Accueil$View$resumeDEtape = function (etape) {
	return etape.Dj + (' ' + $elm$core$String$fromInt(etape.w));
};
var $author$project$Components$Accueil$View$uneEtape = F3(
	function (i18n, plusChargee, etape) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'chargee',
							(etape.w > 0) && _Utils_eq(etape.w, plusChargee)),
							_Utils_Tuple2('vide', !etape.w)
						])),
					$rtfeldman$elm_css$Html$Styled$Attributes$title(
					etape.Dj + (' : ' + A2(
						$author$project$I18n$Cles$accueilDossiersCompte,
						i18n,
						{w: etape.w})))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(etape.w))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(etape.Dj)
						]))
				]));
	});
var $author$project$Components$Accueil$View$unPipe = F2(
	function (i18n, pipe) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pipe')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Routes$Route$adressePipes)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(pipe.Dj)
										])),
									$rtfeldman$elm_css$Html$Styled$text(
									' · ' + A2(
										$author$project$I18n$Cles$accueilDossiersCompte,
										i18n,
										{
											w: $elm$core$List$sum(
												A2(
													$elm$core$List$map,
													function ($) {
														return $.w;
													},
													pipe.yL))
										}))
								])),
							(pipe.lW > 0) ? A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('tag'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('rouge')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$accueilDossiersEnRetard,
										i18n,
										{
											w: $elm$core$String$fromInt(pipe.lW)
										}))
								])) : $rtfeldman$elm_css$Html$Styled$text('')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ol,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('etapes'),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-label',
							pipe.Dj + (' : ' + A2(
								$elm$core$String$join,
								', ',
								A2($elm$core$List$map, $author$project$Components$Accueil$View$resumeDEtape, pipe.yL))))
						]),
					A2(
						$elm$core$List$map,
						A2(
							$author$project$Components$Accueil$View$uneEtape,
							i18n,
							A3(
								$elm$core$List$foldl,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.w;
									},
									$elm$core$Basics$max),
								0,
								pipe.yL)),
						pipe.yL))
				]));
	});
var $author$project$Components$Accueil$View$dossiers = F2(
	function (i18n, tableau) {
		var total = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				function (pipe) {
					return $elm$core$List$sum(
						A2(
							$elm$core$List$map,
							function ($) {
								return $.w;
							},
							pipe.yL));
				},
				tableau.xJ));
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('bloc'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('dossiers')
				]),
			_List_fromArray(
				[
					$author$project$Components$Accueil$View$entete(
					{
						aa: $author$project$Routes$Route$adressePipes,
						nB: $author$project$I18n$Cles$accueilDossiersVoir(i18n),
						aO: $elm$core$Maybe$Just(
							A2(
								$author$project$I18n$Cles$accueilDossiersSousTitre,
								i18n,
								{
									xJ: $elm$core$String$fromInt(total),
									FM: A2(
										$author$project$I18n$Cles$accueilDossiersNombreDePipes,
										i18n,
										{
											w: $elm$core$List$length(tableau.xJ)
										})
								})),
						h6: $author$project$I18n$Cles$accueilDossiersTitre(i18n)
					}),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('pipes')
						]),
					A2(
						$elm$core$List$map,
						$author$project$Components$Accueil$View$unPipe(i18n),
						tableau.xJ))
				]));
	});
var $author$project$I18n$Cles$accueilJourneeAria = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.journee.aria',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'evenements',
					$author$project$I18n$Traductions$Chaine(p.mk)),
					_Utils_Tuple2(
					'heure',
					$author$project$I18n$Traductions$Chaine(p.Ah))
				]),
			'Frise de la journée : ' + (p.mk + ('. Maintenant, ' + p.Ah)));
	});
var $author$project$I18n$Cles$accueilJourneeEvenementAria = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.journee.evenement-aria',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'heure',
					$author$project$I18n$Traductions$Chaine(p.Ah)),
					_Utils_Tuple2(
					'titre',
					$author$project$I18n$Traductions$Chaine(p.h6)),
					_Utils_Tuple2(
					'detail',
					$author$project$I18n$Traductions$Chaine(p.bB))
				]),
			p.Ah + (' ' + (p.h6 + (', ' + p.bB))));
	});
var $author$project$I18n$Cles$accueilJourneeHeure = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.journee.heure',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'heure',
					$author$project$I18n$Traductions$Chaine(p.Ah))
				]),
			p.Ah + ' h');
	});
var $author$project$I18n$Cles$accueilJourneeMaintenant = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.journee.maintenant', _List_Nil, 'Maintenant');
};
var $author$project$I18n$Cles$accueilJourneeSousTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.journee.sous-titre', _List_Nil, 'Ce qui s’est passé et ce qui vient, de 8 h à 18 h');
};
var $author$project$I18n$Cles$accueilJourneeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.journee.titre', _List_Nil, 'Ma journée');
};
var $author$project$I18n$Cles$accueilJourneeVoir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.journee.voir', _List_Nil, 'Voir mon agenda et l’historique');
};
var $rtfeldman$elm_css$Svg$Styled$g = $rtfeldman$elm_css$Svg$Styled$node('g');
var $rtfeldman$elm_css$Svg$Styled$line = $rtfeldman$elm_css$Svg$Styled$node('line');
var $author$project$Components$Accueil$View$minutes = function (heure) {
	var _v0 = A2(
		$elm$core$List$map,
		$elm$core$String$toInt,
		A2($elm$core$String$split, ':', heure));
	if ((((_v0.b && (!_v0.a.$)) && _v0.b.b) && (!_v0.b.a.$)) && (!_v0.b.b.b)) {
		var h = _v0.a.a;
		var _v1 = _v0.b;
		var m = _v1.a.a;
		return (h * 60) + m;
	} else {
		return 0;
	}
};
var $rtfeldman$elm_css$Svg$Styled$text = $rtfeldman$elm_css$VirtualDom$Styled$text;
var $rtfeldman$elm_css$Svg$Styled$Attributes$textAnchor = $rtfeldman$elm_css$VirtualDom$Styled$attribute('text-anchor');
var $rtfeldman$elm_css$Svg$Styled$text_ = $rtfeldman$elm_css$Svg$Styled$node('text');
var $rtfeldman$elm_css$Svg$Styled$Attributes$x = $rtfeldman$elm_css$VirtualDom$Styled$attribute('x');
var $rtfeldman$elm_css$Svg$Styled$Attributes$x1 = $rtfeldman$elm_css$VirtualDom$Styled$attribute('x1');
var $rtfeldman$elm_css$Svg$Styled$Attributes$x2 = $rtfeldman$elm_css$VirtualDom$Styled$attribute('x2');
var $rtfeldman$elm_css$Svg$Styled$Attributes$y = $rtfeldman$elm_css$VirtualDom$Styled$attribute('y');
var $rtfeldman$elm_css$Svg$Styled$Attributes$y1 = $rtfeldman$elm_css$VirtualDom$Styled$attribute('y1');
var $rtfeldman$elm_css$Svg$Styled$Attributes$y2 = $rtfeldman$elm_css$VirtualDom$Styled$attribute('y2');
var $author$project$Components$Accueil$View$journee = F2(
	function (i18n, tableau) {
		var x = function (minutesDuJour) {
			return 40 + (((minutesDuJour - 480) * 920) / 600);
		};
		var j = tableau.A1;
		var maintenant = $author$project$Components$Accueil$View$minutes(j.B3);
		var place = F2(
			function (rang, e) {
				var passe = _Utils_cmp(
					$author$project$Components$Accueil$View$minutes(e.Ah),
					maintenant) < 1;
				var haut = !A2($elm$core$Basics$modBy, 2, rang);
				var ex = x(
					$author$project$Components$Accueil$View$minutes(e.Ah));
				return A2(
					$rtfeldman$elm_css$Svg$Styled$g,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$class('moment'),
							$rtfeldman$elm_css$Svg$Styled$Attributes$class(
							passe ? 'passe' : 'a-venir')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Svg$Styled$circle,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Svg$Styled$Attributes$cx(
									$elm$core$String$fromFloat(ex)),
									$rtfeldman$elm_css$Svg$Styled$Attributes$cy('60'),
									$rtfeldman$elm_css$Svg$Styled$Attributes$r('6'),
									$rtfeldman$elm_css$Svg$Styled$Attributes$class(e.g1)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Svg$Styled$text_,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Svg$Styled$Attributes$class('titre'),
									$rtfeldman$elm_css$Svg$Styled$Attributes$x(
									$elm$core$String$fromFloat(ex)),
									$rtfeldman$elm_css$Svg$Styled$Attributes$y(
									haut ? '36' : '90'),
									$rtfeldman$elm_css$Svg$Styled$Attributes$textAnchor('middle')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Svg$Styled$text(e.Ah + (' · ' + e.h6))
								])),
							A2(
							$rtfeldman$elm_css$Svg$Styled$text_,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Svg$Styled$Attributes$class('detail'),
									$rtfeldman$elm_css$Svg$Styled$Attributes$x(
									$elm$core$String$fromFloat(ex)),
									$rtfeldman$elm_css$Svg$Styled$Attributes$y(
									haut ? '48' : '102'),
									$rtfeldman$elm_css$Svg$Styled$Attributes$textAnchor('middle')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Svg$Styled$text(e.bB)
								]))
						]));
			});
		var graduation = function (h) {
			return A2(
				$rtfeldman$elm_css$Svg$Styled$text_,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$class('heure'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$x(
						$elm$core$String$fromFloat(
							x(h * 60))),
						$rtfeldman$elm_css$Svg$Styled$Attributes$y('118'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$textAnchor('middle')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$text(
						A2(
							$author$project$I18n$Cles$accueilJourneeHeure,
							i18n,
							{
								Ah: $elm$core$String$fromInt(h)
							}))
					]));
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('bloc'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('journee')
				]),
			_List_fromArray(
				[
					$author$project$Components$Accueil$View$entete(
					{
						aa: $author$project$Routes$Route$adresseDesNotifications,
						nB: $author$project$I18n$Cles$accueilJourneeVoir(i18n),
						aO: $elm$core$Maybe$Just(
							$author$project$I18n$Cles$accueilJourneeSousTitre(i18n)),
						h6: $author$project$I18n$Cles$accueilJourneeTitre(i18n)
					}),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('frise')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Svg$Styled$svg,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 1000 124'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'img'),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									A2(
										$author$project$I18n$Cles$accueilJourneeAria,
										i18n,
										{
											mk: A2(
												$elm$core$String$join,
												', ',
												A2(
													$elm$core$List$map,
													function (e) {
														return A2(
															$author$project$I18n$Cles$accueilJourneeEvenementAria,
															i18n,
															{bB: e.bB, Ah: e.Ah, h6: e.h6});
													},
													j.mk)),
											Ah: j.B3
										}))
								]),
							_Utils_ap(
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Svg$Styled$line,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Svg$Styled$Attributes$class('axe'),
												$rtfeldman$elm_css$Svg$Styled$Attributes$x1('40'),
												$rtfeldman$elm_css$Svg$Styled$Attributes$y1('60'),
												$rtfeldman$elm_css$Svg$Styled$Attributes$x2('960'),
												$rtfeldman$elm_css$Svg$Styled$Attributes$y2('60')
											]),
										_List_Nil),
										A2(
										$rtfeldman$elm_css$Svg$Styled$line,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Svg$Styled$Attributes$class('maintenant'),
												$rtfeldman$elm_css$Svg$Styled$Attributes$x1(
												$elm$core$String$fromFloat(
													x(maintenant))),
												$rtfeldman$elm_css$Svg$Styled$Attributes$y1('20'),
												$rtfeldman$elm_css$Svg$Styled$Attributes$x2(
												$elm$core$String$fromFloat(
													x(maintenant))),
												$rtfeldman$elm_css$Svg$Styled$Attributes$y2('100')
											]),
										_List_Nil),
										A2(
										$rtfeldman$elm_css$Svg$Styled$text_,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Svg$Styled$Attributes$class('mot-maintenant'),
												$rtfeldman$elm_css$Svg$Styled$Attributes$x(
												$elm$core$String$fromFloat(
													x(maintenant) + 6)),
												$rtfeldman$elm_css$Svg$Styled$Attributes$y('76')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Svg$Styled$text(
												$author$project$I18n$Cles$accueilJourneeMaintenant(i18n))
											]))
									]),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										graduation,
										_List_fromArray(
											[8, 10, 12, 14, 16, 18])),
									A2($elm$core$List$indexedMap, place, j.mk))))
						]))
				]));
	});
var $author$project$I18n$Cles$accueilQualiteDoublons = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.qualite.doublons', _List_Nil, 'Doublons à traiter');
};
var $author$project$I18n$Cles$accueilQualiteEcheances = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.qualite.echeances', _List_Nil, 'Échéances de conservation');
};
var $author$project$I18n$Cles$accueilQualiteEcheancesDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.qualite.echeances-detail', _List_Nil, 'sous 30 jours');
};
var $author$project$I18n$Cles$accueilQualiteIncompletes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.qualite.incompletes', _List_Nil, 'Fiches incomplètes');
};
var $author$project$I18n$Cles$accueilQualiteIncompletesDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.qualite.incompletes-detail', _List_Nil, 'Commentaires vides : ARICA, GABRI, Amena, Goufri');
};
var $author$project$I18n$Cles$accueilQualiteSansContact = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.qualite.sans-contact', _List_Nil, 'Contacts manquants');
};
var $author$project$I18n$Cles$accueilQualiteSansContactDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.qualite.sans-contact-detail', _List_Nil, 'organisations sans email ni téléphone');
};
var $author$project$I18n$Cles$accueilQualiteTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.qualite.titre', _List_Nil, 'Qualité des données');
};
var $author$project$I18n$Cles$accueilQualiteVoir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.qualite.voir', _List_Nil, 'Voir');
};
var $author$project$I18n$Cles$accueilQualiteAria = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.qualite.aria',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl)),
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			p.Bl + (' : ' + p.fm));
	});
var $author$project$Components$Accueil$View$barre = F5(
	function (classe, x, y, largeur, hauteur) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$class(classe),
					$rtfeldman$elm_css$Svg$Styled$Attributes$d(
					'M' + ($elm$core$String$fromFloat(x) + (' ' + ($elm$core$String$fromFloat(y) + ('h' + ($elm$core$String$fromFloat(largeur) + ('v' + ($elm$core$String$fromFloat(hauteur) + ('h' + ($elm$core$String$fromFloat(-largeur) + 'z'))))))))))
				]),
			_List_Nil);
	});
var $rtfeldman$elm_css$Svg$Styled$Attributes$preserveAspectRatio = $rtfeldman$elm_css$VirtualDom$Styled$attribute('preserveAspectRatio');
var $author$project$Components$Accueil$View$ligne = F8(
	function (i18n, classe, libelle, valeur, nombre, sur, detail, adresse) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class(classe)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$href(adresse),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-label',
							A2(
								$author$project$I18n$Cles$accueilQualiteAria,
								i18n,
								{Bl: libelle, fm: valeur}))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(libelle)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(valeur)
										]))
								])),
							A2(
							$rtfeldman$elm_css$Svg$Styled$svg,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Svg$Styled$Attributes$class('jauge'),
									$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 100 3'),
									$rtfeldman$elm_css$Svg$Styled$Attributes$preserveAspectRatio('none'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
								]),
							_List_fromArray(
								[
									A5($author$project$Components$Accueil$View$barre, 'piste', 0, 0, 100, 3),
									A5(
									$author$project$Components$Accueil$View$barre,
									'part',
									0,
									0,
									(!sur) ? 0 : ((nombre * 100) / sur),
									3)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('detail')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(detail)
								]))
						]))
				]));
	});
var $author$project$Components$Accueil$View$qualite = F2(
	function (i18n, model) {
		var lignes = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					function (t) {
						return A8(
							$author$project$Components$Accueil$View$ligne,
							i18n,
							'doublons',
							$author$project$I18n$Cles$accueilQualiteDoublons(i18n),
							$elm$core$String$fromInt(t.xM.w),
							t.xM.w,
							t.xM.h1,
							t.xM.yY,
							$author$project$Routes$Route$adressePartiesPrenantes);
					},
					model.rw),
					A2(
					$elm$core$Maybe$map,
					function (t) {
						return A8(
							$author$project$Components$Accueil$View$ligne,
							i18n,
							'incompletes',
							$author$project$I18n$Cles$accueilQualiteIncompletes(i18n),
							A2(
								$author$project$I18n$Cles$accueilQualiteSur,
								i18n,
								{
									w: $elm$core$String$fromInt(t.AG.w),
									h1: $elm$core$String$fromInt(t.AG.h1)
								}),
							t.AG.w,
							t.AG.h1,
							$author$project$I18n$Cles$accueilQualiteIncompletesDetail(i18n),
							$author$project$Routes$Route$adressePartiesPrenantes);
					},
					model.rw),
					A2(
					$elm$core$Maybe$map,
					function (n) {
						return A8(
							$author$project$Components$Accueil$View$ligne,
							i18n,
							'echeances',
							$author$project$I18n$Cles$accueilQualiteEcheances(i18n),
							$elm$core$String$fromInt(n),
							n,
							30,
							$author$project$I18n$Cles$accueilQualiteEcheancesDetail(i18n),
							$author$project$Routes$Route$adresseDesEcheancesDeConservation);
					},
					function () {
						var _v0 = model.x0;
						if (!_v0.$) {
							var n = _v0.a;
							return $elm$core$Maybe$Just(n);
						} else {
							return A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.x0;
								},
								model.rw);
						}
					}()),
					A2(
					$elm$core$Maybe$map,
					function (t) {
						return A8(
							$author$project$Components$Accueil$View$ligne,
							i18n,
							'contacts',
							$author$project$I18n$Cles$accueilQualiteSansContact(i18n),
							A2(
								$author$project$I18n$Cles$accueilQualiteSur,
								i18n,
								{
									w: $elm$core$String$fromInt(t.In.w),
									h1: $elm$core$String$fromInt(t.In.h1)
								}),
							t.In.w,
							t.In.h1,
							$author$project$I18n$Cles$accueilQualiteSansContactDetail(i18n),
							$author$project$Routes$Route$adressePartiesPrenantes);
					},
					model.rw)
				]));
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('bloc'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('qualite')
				]),
			_List_fromArray(
				[
					$author$project$Components$Accueil$View$entete(
					{
						aa: $author$project$Routes$Route$adressePartiesPrenantes,
						nB: $author$project$I18n$Cles$accueilQualiteVoir(i18n),
						aO: $elm$core$Maybe$Nothing,
						h6: $author$project$I18n$Cles$accueilQualiteTitre(i18n)
					}),
					A2($rtfeldman$elm_css$Html$Styled$ul, _List_Nil, lignes)
				]));
	});
var $author$project$Components$Accueil$View$rangee = function (blocs) {
	var _v0 = A2($elm$core$List$filterMap, $elm$core$Basics$identity, blocs);
	if (!_v0.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var presents = _v0;
		return $elm$core$Maybe$Just(
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('rangee')
					]),
				presents));
	}
};
var $author$project$I18n$Cles$accueilTachesAujourdhui = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.taches.aujourdhui', _List_Nil, 'Aujourd’hui');
};
var $author$project$I18n$Cles$accueilTachesEnRetard = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.taches.en-retard', _List_Nil, 'En retard');
};
var $author$project$I18n$Cles$accueilTachesSemaine = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.taches.semaine', _List_Nil, 'Cette semaine');
};
var $author$project$I18n$Cles$accueilTachesSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'accueil.taches.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			p.w + ' tâches ouvertes, par échéance');
	});
var $author$project$I18n$Cles$accueilTachesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.taches.titre', _List_Nil, 'Mes tâches');
};
var $author$project$I18n$Cles$accueilTachesVoir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.taches.voir', _List_Nil, 'Voir toutes mes tâches');
};
var $author$project$Components$Accueil$Update$FiltreTachesChoisi = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Accueil$View$pastilleDeTaches = F5(
	function (model, classe, periode, libelle, nombre) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class(classe),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'active',
									_Utils_eq(
										model.mF,
										$elm$core$Maybe$Just(periode)))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-pressed',
							_Utils_eq(
								model.mF,
								$elm$core$Maybe$Just(periode)) ? 'true' : 'false'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Accueil$Update$FiltreTachesChoisi(periode))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(libelle)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$elm$core$String$fromInt(nombre))
								]))
						]))
				]));
	});
var $author$project$I18n$Cles$accueilTachesPastilleRetard = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.taches.pastille-retard', _List_Nil, 'En retard');
};
var $author$project$Components$Accueil$View$uneTache = F2(
	function (i18n, x) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('en-retard', x.qH)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('titre'),
							$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Routes$Route$adresseDesNotifications)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(x.h6)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('dossier')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(x.xI + (' · ' + x.me))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('echeance')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(x.xY)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('retard')
						]),
					x.qH ? _List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$accueilTachesPastilleRetard(i18n))
						]) : _List_Nil)
				]));
	});
var $author$project$Components$Accueil$View$taches = F3(
	function (i18n, model, tableau) {
		var t = tableau.Jk;
		var visibles = A2(
			$elm$core$List$take,
			4,
			A2(
				$elm$core$List$filter,
				function (x) {
					return A2(
						$elm$core$Maybe$withDefault,
						true,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$eq(x.pi),
							model.mF));
				},
				t.nW));
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('bloc'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('taches')
				]),
			_List_fromArray(
				[
					$author$project$Components$Accueil$View$entete(
					{
						aa: $author$project$Routes$Route$adresseDesNotifications,
						nB: $author$project$I18n$Cles$accueilTachesVoir(i18n),
						aO: $elm$core$Maybe$Just(
							A2(
								$author$project$I18n$Cles$accueilTachesSousTitre,
								i18n,
								{
									w: $elm$core$String$fromInt(t.Eu)
								})),
						h6: $author$project$I18n$Cles$accueilTachesTitre(i18n)
					}),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('pastilles')
						]),
					_List_fromArray(
						[
							A5(
							$author$project$Components$Accueil$View$pastilleDeTaches,
							model,
							'en-retard',
							0,
							$author$project$I18n$Cles$accueilTachesEnRetard(i18n),
							t.lW),
							A5(
							$author$project$Components$Accueil$View$pastilleDeTaches,
							model,
							'aujourdhui',
							1,
							$author$project$I18n$Cles$accueilTachesAujourdhui(i18n),
							t.t$),
							A5(
							$author$project$Components$Accueil$View$pastilleDeTaches,
							model,
							'semaine',
							2,
							$author$project$I18n$Cles$accueilTachesSemaine(i18n),
							t.q6)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('liste')
						]),
					A2(
						$elm$core$List$map,
						$author$project$Components$Accueil$View$uneTache(i18n),
						visibles))
				]));
	});
var $author$project$Components$Accueil$View$bento = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('bento')
				]),
			A2(
				$elm$core$List$filterMap,
				$author$project$Components$Accueil$View$rangee,
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							$author$project$Components$Accueil$View$compteurs(i18n),
							model.rw)
						]),
						_List_fromArray(
						[
							A2(
							$elm$core$Maybe$andThen,
							A2($author$project$Components$Accueil$View$campagnes, i18n, model.bY),
							model.rw)
						]),
						_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							$author$project$Components$Accueil$View$dossiers(i18n),
							model.rw),
							A2(
							$elm$core$Maybe$map,
							A2($author$project$Components$Accueil$View$taches, i18n, model),
							model.rw)
						]),
						_List_fromArray(
						[
							$elm$core$Maybe$Just(
							A2($author$project$Components$Accueil$View$catalogue, i18n, model)),
							$elm$core$Maybe$Just(
							A2($author$project$Components$Accueil$View$qualite, i18n, model))
						]),
						_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							$author$project$Components$Accueil$View$journee(i18n),
							model.rw)
						])
					])));
	});
var $author$project$I18n$Cles$accueilDemonstration = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'accueil.demonstration', _List_Nil, 'Données de démonstration, sauf le catalogue et les échéances de conservation');
};
var $rtfeldman$elm_css$Html$Styled$Attributes$hidden = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('hidden');
var $author$project$Components$Accueil$View$hidden = $rtfeldman$elm_css$Html$Styled$Attributes$hidden;
var $author$project$Components$Accueil$View$mentionDeDemonstration = F2(
	function (i18n, model) {
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('tag', true),
								_Utils_Tuple2('donnees-de-demonstration', true)
							])),
						$author$project$Components$Accueil$View$hidden(
						_Utils_eq(model.rw, $elm$core$Maybe$Nothing))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$accueilDemonstration(i18n))
					]))
			]);
	});
var $author$project$Components$Accueil$View$view = F4(
	function (i18n, messages, utilisateur, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'accueil',
			{
				ut: _List_fromArray(
					[
						A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
						A2($author$project$Components$Accueil$View$bento, i18n, model)
					]),
				xy: _List_Nil,
				zM: _List_Nil,
				AK: false,
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: A2($author$project$Components$Accueil$View$mentionDeDemonstration, i18n, model),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adresseAccueil,
								Dj: $author$project$I18n$Cles$accueilTitre(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$accueilTitre(i18n)
					})
			});
	});
var $author$project$Components$Comptes$MonCompte$View$nomComplet = function (profil) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
			_List_fromArray(
				[profil.Gg, profil.Dj])));
};
var $author$project$Components$Comptes$MonCompte$View$entete = function (profil) {
	return _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('avatar')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$i,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Texte$Initiales$initiales(
								$author$project$Components$Comptes$MonCompte$View$nomComplet(profil)))
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('infos')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2(
						$elm$core$String$join,
						' · ',
						A2(
							$elm$core$List$filter,
							A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
							_List_fromArray(
								[
									profil.zO,
									A2($elm$core$Maybe$withDefault, '', profil.yb)
								]))))
				]))
		]);
};
var $author$project$Components$Shared$Page$View$fiche = function (contenu) {
	return _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
				]),
			contenu.B2),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id('aside')
				]),
			contenu.tQ)
		]);
};
var $author$project$I18n$Cles$monCompteOngletProfil = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.onglet.profil', _List_Nil, 'Profil');
};
var $author$project$I18n$Cles$monCompteTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.titre', _List_Nil, 'Mon compte');
};
var $author$project$Components$Comptes$MonCompte$Update$FuseauChoisi = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Comptes$MonCompte$Update$LangueChoisie = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Comptes$MonCompte$Update$PreferencesEnvoyees = {$: 11};
var $author$project$I18n$Cles$monComptePreferencesAChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.preferences.a-choisir', _List_Nil, 'À choisir');
};
var $author$project$Components$Comptes$MonCompte$View$aChoisir = function (i18n) {
	return {
		Bl: $author$project$I18n$Cles$monComptePreferencesAChoisir(i18n),
		fm: ''
	};
};
var $author$project$Components$Comptes$MonCompte$View$actions = F5(
	function (model, rel, commande, envoyer, libelle) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
				]),
			function () {
				var _v0 = A2($author$project$Components$Comptes$MonCompte$Model$lienDeLaCommande, rel, model);
				if (!_v0.$) {
					return _List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							0,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(envoyer),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
									_Utils_eq(commande, $elm$core$Maybe$Nothing) || $author$project$API$Envoi$enCours(model.l2)),
									$rtfeldman$elm_css$Html$Styled$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'loading',
											$author$project$API$Envoi$enCours(model.l2))
										]))
								]),
							libelle)
						]);
				} else {
					return _List_Nil;
				}
			}());
	});
var $author$project$Components$Comptes$MonCompte$Model$apercu = function (model) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (lu) {
				return _Utils_eq(lu.nn, model.nn);
			},
			A2(
				$elm$core$List$concatMap,
				function ($) {
					return $.tu;
				},
				A2(
					$elm$core$List$filter,
					function (fuseau) {
						return _Utils_eq(fuseau.Au, model.z_);
					},
					model.gD))));
};
var $author$project$I18n$Cles$monComptePreferencesApercuDates = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'mon-compte.preferences.apercu.dates',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'echeance',
					$author$project$I18n$Traductions$Chaine(p.xY)),
					_Utils_Tuple2(
					'montant',
					$author$project$I18n$Traductions$Chaine(p.oi))
				]),
			'Dates et nombres : ' + (p.xY + (' · ' + p.oi)));
	});
var $author$project$I18n$Cles$monComptePreferencesApercuEcheance = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.preferences.apercu.echeance', _List_Nil, 'Échéance d\'une tâche due à Paris :');
};
var $author$project$I18n$Cles$monComptePreferencesApercuOrigine = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'mon-compte.preferences.apercu.origine',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'origine',
					$author$project$I18n$Traductions$Chaine(p.o4))
				]),
			'(' + (p.o4 + ')'));
	});
var $author$project$I18n$Cles$monComptePreferencesApercuTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.preferences.apercu.titre', _List_Nil, 'Aperçu');
};
var $author$project$Components$Comptes$MonCompte$View$apercu = F2(
	function (i18n, model) {
		var _v0 = $author$project$Components$Comptes$MonCompte$Model$apercu(model);
		if (!_v0.$) {
			var lu = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu')
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$b,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$monComptePreferencesApercuTitre(i18n))
							])),
					A2(
						$elm$core$List$cons,
						A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
						A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$monComptePreferencesApercuDates,
									i18n,
									{xY: lu.xY, oi: lu.oi})),
							function () {
								var _v1 = lu.o4;
								if (!_v1.$) {
									var origine = _v1.a;
									return _List_fromArray(
										[
											A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$monComptePreferencesApercuEcheance(i18n)),
											$rtfeldman$elm_css$Html$Styled$text(' '),
											A2(
											$rtfeldman$elm_css$Html$Styled$b,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(lu.xY)
												])),
											$rtfeldman$elm_css$Html$Styled$text(' '),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('origine')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$author$project$I18n$Cles$monComptePreferencesApercuOrigine,
														i18n,
														{o4: origine}))
												]))
										]);
								} else {
									return _List_Nil;
								}
							}()))));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Comptes$MonCompte$View$choix = F2(
	function (identifiant, libelle) {
		return {go: $elm$core$Maybe$Nothing, Aq: identifiant, Bl: libelle, he: true};
	});
var $author$project$Components$Shared$Note$View$Validation = 3;
var $author$project$Components$Comptes$MonCompte$View$enregistre = F3(
	function (model, section, message) {
		return _Utils_eq(
			model.l_,
			$elm$core$Maybe$Just(section)) ? A2(
			$author$project$Components$Shared$Note$View$view,
			3,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(message)
				])) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$I18n$Cles$monCompteLangueEn = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.langue.en', _List_Nil, 'English');
};
var $author$project$I18n$Cles$monCompteLangueFr = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.langue.fr', _List_Nil, 'Français');
};
var $author$project$Components$Comptes$Vocabulaire$languesDInterface = function (i18n) {
	return _List_fromArray(
		[
			{
			vx: 'fr',
			Dj: $author$project$I18n$Cles$monCompteLangueFr(i18n)
		},
			{
			vx: 'en',
			Dj: $author$project$I18n$Cles$monCompteLangueEn(i18n)
		}
		]);
};
var $author$project$I18n$Cles$monComptePreferencesAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.preferences.aide', _List_Nil, 'Par défaut, ceux de votre navigateur. Les échéances gardent leur fuseau d\'origine, indiqué quand il diffère.');
};
var $author$project$I18n$Cles$monComptePreferencesEnregistrees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.preferences.enregistrees', _List_Nil, 'Langue et fuseau horaire enregistrés.');
};
var $author$project$I18n$Cles$monComptePreferencesEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.preferences.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$monComptePreferencesFuseau = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.preferences.fuseau', _List_Nil, 'Fuseau horaire');
};
var $author$project$I18n$Cles$monComptePreferencesLangue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.preferences.langue', _List_Nil, 'Langue de l\'interface');
};
var $author$project$I18n$Cles$monComptePreferencesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.preferences.titre', _List_Nil, 'Langue et fuseau horaire');
};
var $author$project$Components$Shared$Page$View$section = F2(
	function (attributs, fournie) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$class(fournie.Dj),
				attributs),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(fournie.h6)
								])),
						fournie.fw)),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					fournie.fZ)
				]));
	});
var $author$project$Components$Comptes$MonCompte$View$sectionPreferences = F2(
	function (i18n, model) {
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_Nil,
			{
				fw: _List_Nil,
				fZ: _List_fromArray(
					[
						A3(
						$author$project$Components$Comptes$MonCompte$View$enregistre,
						model,
						1,
						$author$project$I18n$Cles$monComptePreferencesEnregistrees(i18n)),
						A2(
						$author$project$Components$Shared$Champ$View$liste,
						A2(
							$author$project$Components$Comptes$MonCompte$View$choix,
							'mon-compte-langue',
							$author$project$I18n$Cles$monComptePreferencesLangue(i18n)),
						{
							hg: $author$project$Components$Comptes$MonCompte$Update$LangueChoisie,
							o_: A2(
								$elm$core$List$cons,
								$author$project$Components$Comptes$MonCompte$View$aChoisir(i18n),
								A2(
									$elm$core$List$map,
									function (langue) {
										return {Bl: langue.Dj, fm: langue.vx};
									},
									$author$project$Components$Comptes$Vocabulaire$languesDInterface(i18n))),
							fm: model.nn
						}),
						A2(
						$author$project$Components$Shared$Champ$View$liste,
						A2(
							$author$project$Components$Comptes$MonCompte$View$choix,
							'mon-compte-fuseau',
							$author$project$I18n$Cles$monComptePreferencesFuseau(i18n)),
						{
							hg: $author$project$Components$Comptes$MonCompte$Update$FuseauChoisi,
							o_: A2(
								$elm$core$List$cons,
								$author$project$Components$Comptes$MonCompte$View$aChoisir(i18n),
								A2(
									$elm$core$List$map,
									function (fuseau) {
										return {Bl: fuseau.Bl, fm: fuseau.Au};
									},
									model.gD)),
							fm: model.z_
						}),
						A2($author$project$Components$Comptes$MonCompte$View$apercu, i18n, model),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$monComptePreferencesAide(i18n))
							])),
						A5(
						$author$project$Components$Comptes$MonCompte$View$actions,
						model,
						$author$project$API$NavLinksDictionary$enregistrerLesPreferences,
						$author$project$Components$Comptes$MonCompte$Model$commandeDesPreferences(model),
						$author$project$Components$Comptes$MonCompte$Update$PreferencesEnvoyees,
						$author$project$I18n$Cles$monComptePreferencesEnregistrer(i18n))
					]),
				Dj: 'preferences',
				h6: $author$project$I18n$Cles$monComptePreferencesTitre(i18n)
			});
	});
var $author$project$Components$Comptes$MonCompte$Update$ChangementDEmailDemande = {$: 13};
var $author$project$I18n$Cles$monCompteEmailActuelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.email.actuelle', _List_Nil, 'Adresse actuelle');
};
var $author$project$I18n$Cles$monCompteEmailAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.email.aide', _List_Nil, 'Le changement se fait sur l\'écran de connexion d\'Asria, qui peut vous redemander votre mot de passe. Il prend effet quand vous cliquez sur le lien reçu à la nouvelle adresse.');
};
var $author$project$I18n$Cles$monCompteEmailChanger = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.email.changer', _List_Nil, 'Changer l\'email');
};
var $author$project$I18n$Cles$monCompteEmailDemandePrise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.email.demande-prise', _List_Nil, 'Votre demande de changement d\'email est prise en compte : suivez le lien reçu à la nouvelle adresse.');
};
var $author$project$I18n$Cles$monCompteEmailEchec = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.email.echec', _List_Nil, 'Le changement d\'email n\'a pas abouti.');
};
var $author$project$I18n$Cles$monCompteEmailLienEnvoye = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'mon-compte.email.lien-envoye',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'adresse',
					$author$project$I18n$Traductions$Chaine(p.aa)),
					_Utils_Tuple2(
					'actuelle',
					$author$project$I18n$Traductions$Chaine(p.sV))
				]),
			'Lien de confirmation envoyé à ' + (p.aa + ('. Votre email changera quand vous l\'aurez cliqué ; d\'ici là, vous vous connectez avec ' + (p.sV + '.'))));
	});
var $author$project$I18n$Cles$monCompteEmailTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.email.titre', _List_Nil, 'Email');
};
var $author$project$Components$Comptes$MonCompte$Model$ChangementEchoue = {$: 2};
var $author$project$Components$Comptes$MonCompte$Model$DemandePriseEnCompte = {$: 1};
var $author$project$Components$Comptes$MonCompte$Model$LienEnvoye = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Comptes$MonCompte$Model$retourDeLEmail = function (model) {
	var _v0 = model.h_;
	_v0$2:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'success':
					return $elm$core$Maybe$Just(
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Components$Comptes$MonCompte$Model$DemandePriseEnCompte,
							A2(
								$elm$core$Maybe$map,
								$author$project$Components$Comptes$MonCompte$Model$LienEnvoye,
								A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.yc;
									},
									model.c2))));
				case 'error':
					return $elm$core$Maybe$Just($author$project$Components$Comptes$MonCompte$Model$ChangementEchoue);
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $rtfeldman$elm_css$Html$Styled$Attributes$readonly = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('readOnly');
var $author$project$Components$Shared$Champ$View$texteEnLectureSeule = F2(
	function (champ, saisie) {
		return A2(
			$author$project$Components$Shared$Champ$View$formItem,
			champ,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
						A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Attributes$value(saisie.fm),
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_css$Html$Styled$Attributes$readonly(true),
								$author$project$Components$Shared$Champ$View$controle(champ)))),
					_List_Nil)
				]));
	});
var $author$project$Components$Comptes$MonCompte$View$sectionEmail = F3(
	function (i18n, model, profil) {
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_Nil,
			{
				fw: function () {
					var _v0 = A2($author$project$Components$Comptes$MonCompte$Model$lienDeLaCommande, $author$project$API$NavLinksDictionary$changerLEmail, model);
					if (!_v0.$) {
						return _List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Comptes$MonCompte$Update$ChangementDEmailDemande)
									]),
								$author$project$I18n$Cles$monCompteEmailChanger(i18n))
							]);
					} else {
						return _List_Nil;
					}
				}(),
				fZ: _List_fromArray(
					[
						function () {
						var _v1 = $author$project$Components$Comptes$MonCompte$Model$retourDeLEmail(model);
						if (!_v1.$) {
							switch (_v1.a.$) {
								case 0:
									var adresse = _v1.a.a;
									return A2(
										$author$project$Components$Shared$Note$View$view,
										3,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$monCompteEmailLienEnvoye,
													i18n,
													{
														sV: A2($elm$core$Maybe$withDefault, '', profil.yb),
														aa: adresse
													}))
											]));
								case 1:
									var _v2 = _v1.a;
									return A2(
										$author$project$Components$Shared$Note$View$view,
										3,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$monCompteEmailDemandePrise(i18n))
											]));
								default:
									var _v3 = _v1.a;
									return A2(
										$author$project$Components$Shared$Note$View$view,
										2,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$monCompteEmailEchec(i18n))
											]));
							}
						} else {
							return $rtfeldman$elm_css$Html$Styled$text('');
						}
					}(),
						A2(
						$author$project$Components$Shared$Champ$View$texteEnLectureSeule,
						{
							go: $elm$core$Maybe$Nothing,
							Aq: 'mon-compte-email',
							Bl: $author$project$I18n$Cles$monCompteEmailActuelle(i18n),
							he: false
						},
						{
							fm: A2($elm$core$Maybe$withDefault, '', profil.yb)
						}),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$monCompteEmailAide(i18n))
							]))
					]),
				Dj: 'email',
				h6: $author$project$I18n$Cles$monCompteEmailTitre(i18n)
			});
	});
var $author$project$Components$Comptes$MonCompte$Update$FonctionSaisie = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Comptes$MonCompte$Update$NomSaisi = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Comptes$MonCompte$Update$PrenomSaisi = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Comptes$MonCompte$Update$ProfilEnvoye = {$: 10};
var $author$project$Components$Comptes$MonCompte$Update$TelephoneSaisi = function (a) {
	return {$: 7, a: a};
};
var $author$project$I18n$Cles$monCompteProfilErreurNomObligatoire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.profil.erreur.nom-obligatoire', _List_Nil, 'Le nom est obligatoire.');
};
var $author$project$I18n$Cles$monCompteProfilErreurPrenomObligatoire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.profil.erreur.prenom-obligatoire', _List_Nil, 'Le prénom est obligatoire.');
};
var $author$project$I18n$Cles$monCompteProfilErreurTelephoneInvalide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.profil.erreur.telephone-invalide', _List_Nil, 'Numéro de téléphone invalide.');
};
var $author$project$I18n$Cles$monCompteProfilErreurTropLong = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.profil.erreur.trop-long', _List_Nil, '255 caractères au plus.');
};
var $author$project$Components$Comptes$Vocabulaire$erreurDeProfil = F2(
	function (i18n, code) {
		switch (code) {
			case 'PrenomObligatoire':
				return $elm$core$Maybe$Just(
					{
						uN: 'prenom',
						Cs: $author$project$I18n$Cles$monCompteProfilErreurPrenomObligatoire(i18n)
					});
			case 'PrenomTropLong':
				return $elm$core$Maybe$Just(
					{
						uN: 'prenom',
						Cs: $author$project$I18n$Cles$monCompteProfilErreurTropLong(i18n)
					});
			case 'NomObligatoire':
				return $elm$core$Maybe$Just(
					{
						uN: 'nom',
						Cs: $author$project$I18n$Cles$monCompteProfilErreurNomObligatoire(i18n)
					});
			case 'NomTropLong':
				return $elm$core$Maybe$Just(
					{
						uN: 'nom',
						Cs: $author$project$I18n$Cles$monCompteProfilErreurTropLong(i18n)
					});
			case 'FonctionTropLongue':
				return $elm$core$Maybe$Just(
					{
						uN: 'fonction',
						Cs: $author$project$I18n$Cles$monCompteProfilErreurTropLong(i18n)
					});
			case 'TelephoneInvalide':
				return $elm$core$Maybe$Just(
					{
						uN: 'telephonePro',
						Cs: $author$project$I18n$Cles$monCompteProfilErreurTelephoneInvalide(i18n)
					});
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Comptes$MonCompte$Model$erreurDuChamp = F3(
	function (i18n, champ, model) {
		var _v0 = model.hF;
		if ((!_v0.$) && (!_v0.a.$)) {
			var codes = _v0.a.a;
			return A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Cs;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (erreur) {
							return _Utils_eq(erreur.uN, champ);
						},
						A2(
							$elm$core$List$filterMap,
							$author$project$Components$Comptes$Vocabulaire$erreurDeProfil(i18n),
							codes))));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Comptes$MonCompte$View$champ = F7(
	function (i18n, model, nom, libelle, obligatoire, valeur, saisi) {
		return A2(
			$author$project$Components$Shared$Champ$View$texte,
			{
				go: A3($author$project$Components$Comptes$MonCompte$Model$erreurDuChamp, i18n, nom, model),
				Aq: 'mon-compte-' + nom,
				Bl: libelle,
				he: obligatoire
			},
			{hg: saisi, fm: valeur});
	});
var $author$project$I18n$Cles$monCompteProfilEnregistre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.profil.enregistre', _List_Nil, 'Profil enregistré.');
};
var $author$project$I18n$Cles$monCompteProfilEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.profil.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$monCompteProfilFonction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.profil.fonction', _List_Nil, 'Fonction');
};
var $author$project$I18n$Cles$monCompteProfilNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.profil.nom', _List_Nil, 'Nom');
};
var $author$project$I18n$Cles$monCompteProfilNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.profil.note', _List_Nil, 'Votre fonction est visible des autres utilisateurs ; votre téléphone n\'est montré qu\'ici. Votre profil vaut pour toute la suite Asria.');
};
var $author$project$I18n$Cles$monCompteProfilPrenom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.profil.prenom', _List_Nil, 'Prénom');
};
var $author$project$I18n$Cles$monCompteProfilTelephone = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.profil.telephone', _List_Nil, 'Téléphone professionnel');
};
var $author$project$I18n$Cles$monCompteProfilTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.profil.titre', _List_Nil, 'Profil');
};
var $author$project$Components$Comptes$MonCompte$View$sectionProfil = F2(
	function (i18n, model) {
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_Nil,
			{
				fw: _List_Nil,
				fZ: _List_fromArray(
					[
						A3(
						$author$project$Components$Comptes$MonCompte$View$enregistre,
						model,
						0,
						$author$project$I18n$Cles$monCompteProfilEnregistre(i18n)),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('identite')
							]),
						_List_fromArray(
							[
								A7(
								$author$project$Components$Comptes$MonCompte$View$champ,
								i18n,
								model,
								'prenom',
								$author$project$I18n$Cles$monCompteProfilPrenom(i18n),
								true,
								model.Gg,
								$author$project$Components$Comptes$MonCompte$Update$PrenomSaisi),
								A7(
								$author$project$Components$Comptes$MonCompte$View$champ,
								i18n,
								model,
								'nom',
								$author$project$I18n$Cles$monCompteProfilNom(i18n),
								true,
								model.Dj,
								$author$project$Components$Comptes$MonCompte$Update$NomSaisi)
							])),
						A7(
						$author$project$Components$Comptes$MonCompte$View$champ,
						i18n,
						model,
						'fonction',
						$author$project$I18n$Cles$monCompteProfilFonction(i18n),
						false,
						model.zO,
						$author$project$Components$Comptes$MonCompte$Update$FonctionSaisie),
						A7(
						$author$project$Components$Comptes$MonCompte$View$champ,
						i18n,
						model,
						'telephonePro',
						$author$project$I18n$Cles$monCompteProfilTelephone(i18n),
						false,
						model.Jp,
						$author$project$Components$Comptes$MonCompte$Update$TelephoneSaisi),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$monCompteProfilNote(i18n))
							])),
						A5(
						$author$project$Components$Comptes$MonCompte$View$actions,
						model,
						$author$project$API$NavLinksDictionary$enregistrerLeProfil,
						$author$project$Components$Comptes$MonCompte$Model$commandeDuProfil(model),
						$author$project$Components$Comptes$MonCompte$Update$ProfilEnvoye,
						$author$project$I18n$Cles$monCompteProfilEnregistrer(i18n))
					]),
				Dj: 'profil',
				h6: $author$project$I18n$Cles$monCompteProfilTitre(i18n)
			});
	});
var $author$project$Components$Comptes$MonCompte$View$sections = F3(
	function (i18n, model, profil) {
		return _List_fromArray(
			[
				A2($author$project$Components$Comptes$MonCompte$View$sectionProfil, i18n, model),
				A3($author$project$Components$Comptes$MonCompte$View$sectionEmail, i18n, model, profil)
			]);
	});
var $author$project$Components$Comptes$MonCompte$View$view = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'mon-compte',
			{
				ut: $author$project$Components$Shared$Page$View$fiche(
					{
						tQ: _List_Nil,
						B2: A2(
							$elm$core$List$cons,
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							_Utils_ap(
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										A2($author$project$Components$Comptes$MonCompte$View$sections, i18n, model),
										model.c2)),
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function (_v0) {
											return _List_fromArray(
												[
													A2($author$project$Components$Comptes$MonCompte$View$sectionPreferences, i18n, model)
												]);
										},
										model.eF))))
					}),
				xy: _List_Nil,
				zM: _List_Nil,
				AK: false,
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2($elm$core$Maybe$map, $author$project$Components$Comptes$MonCompte$View$entete, model.c2)),
						zE: _List_Nil,
						Ef: _List_fromArray(
							[
								$author$project$Components$Shared$Onglets$View$view(
								_List_fromArray(
									[
										{
										sO: true,
										aa: $author$project$Routes$Route$adresseDeMonCompte,
										vW: $elm$core$Maybe$Nothing,
										Dj: $author$project$I18n$Cles$monCompteOngletProfil(i18n)
									}
									]))
							]),
						h6: A2(
							$elm$core$Maybe$withDefault,
							$author$project$I18n$Cles$monCompteTitre(i18n),
							A2($elm$core$Maybe$map, $author$project$Components$Comptes$MonCompte$View$nomComplet, model.c2))
					})
			});
	});
var $author$project$Components$Comptes$Common$Onglets$Securite = 1;
var $author$project$Components$Comptes$Common$Onglets$Sessions = 2;
var $author$project$Components$Comptes$Securite$Update$GesteConfirme = {$: 6};
var $author$project$Components$Comptes$Securite$Update$FocusDemande = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Shared$Confirmation$Clavier$clavier = F2(
	function (boite, versFocus) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (_v0) {
				var touche = _v0.a;
				var maj = _v0.b;
				var vers = _v0.c;
				return (touche !== 'Tab') ? $elm$json$Json$Decode$fail('') : ((maj && A2(
					$elm$core$List$member,
					vers,
					_List_fromArray(
						[boite.GN, boite.Cs]))) ? $elm$json$Json$Decode$succeed(
					_Utils_Tuple2(
						versFocus(boite.j7),
						true)) : (((!maj) && A2(
					$elm$core$List$member,
					vers,
					_List_fromArray(
						[boite.GN, boite.j7]))) ? $elm$json$Json$Decode$succeed(
					_Utils_Tuple2(
						versFocus(boite.Cs),
						true)) : $elm$json$Json$Decode$fail('')));
			},
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (touche, maj, vers) {
						return _Utils_Tuple3(touche, maj, vers);
					}),
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool),
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['target', 'id']),
					$elm$json$Json$Decode$string)));
	});
var $author$project$Components$Comptes$Securite$Update$clavierDeLaConfirmation = A2($author$project$Components$Shared$Confirmation$Clavier$clavier, $author$project$Components$Comptes$Securite$Model$idsDeLaConfirmation, $author$project$Components$Comptes$Securite$Update$FocusDemande);
var $author$project$I18n$Cles$monCompteSessionsAppareilInconnu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.sessions.appareil-inconnu', _List_Nil, 'Appareil inconnu');
};
var $author$project$Components$Comptes$Securite$Model$libelleDeLAppareil = function (i18n) {
	return $elm$core$Maybe$withDefault(
		$author$project$I18n$Cles$monCompteSessionsAppareilInconnu(i18n));
};
var $author$project$I18n$Cles$monCompteAnnuler = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.annuler', _List_Nil, 'Annuler');
};
var $author$project$I18n$Cles$monCompteFermetureConfirmer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.fermeture.confirmer', _List_Nil, 'Fermer la session');
};
var $author$project$I18n$Cles$monCompteFermetureDesAutresConfirmer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.fermeture-des-autres.confirmer', _List_Nil, 'Me reconnecter et fermer');
};
var $author$project$I18n$Cles$monCompteFermetureDesAutresMessage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.fermeture-des-autres.message', _List_Nil, 'Vous allez d\'abord confirmer votre identité sur l\'écran de connexion sécurisé. Ensuite, tous vos autres appareils, dans toute la suite Asria, devront se reconnecter.');
};
var $author$project$I18n$Cles$monCompteFermetureDesAutresTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.fermeture-des-autres.titre', _List_Nil, 'Fermer toutes les autres sessions ?');
};
var $author$project$I18n$Cles$monCompteFermetureMessage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'mon-compte.fermeture.message',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'application',
					$author$project$I18n$Traductions$Chaine(p.ty)),
					_Utils_Tuple2(
					'activite',
					$author$project$I18n$Traductions$Chaine(p.sT))
				]),
			p.ty + (', dernière activité le ' + (p.sT + '. Cet ordinateur devra se reconnecter.')));
	});
var $author$project$I18n$Cles$monCompteFermetureTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'mon-compte.fermeture.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'appareil',
					$author$project$I18n$Traductions$Chaine(p.tv))
				]),
			'Fermer la session ' + (p.tv + ' ?'));
	});
var $author$project$I18n$Cles$monCompteRetraitConfirmer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.retrait.confirmer', _List_Nil, 'Me reconnecter et retirer');
};
var $author$project$I18n$Cles$monCompteRetraitDernier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.retrait.dernier', _List_Nil, 'C\'est votre seul moyen : votre compte ne sera plus protégé par la double authentification.');
};
var $author$project$I18n$Cles$monCompteRetraitMessage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.retrait.message', _List_Nil, 'Vous allez d\'abord confirmer votre identité sur l\'écran de connexion sécurisé. Ensuite, ce moyen ne sera plus demandé à la connexion.');
};
var $author$project$I18n$Cles$monCompteRetraitTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'mon-compte.retrait.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer « ' + (p.Dj + ' » ?'));
	});
var $author$project$I18n$Cles$monCompteSecuriteApplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.securite.application', _List_Nil, 'Application d\'authentification');
};
var $author$project$I18n$Cles$monCompteSecuriteAutreMoyen = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.securite.autre-moyen', _List_Nil, 'Autre moyen');
};
var $author$project$I18n$Cles$monCompteSecuriteCle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.securite.cle', _List_Nil, 'Clé de sécurité');
};
var $author$project$Components$Comptes$Securite$View$nomDuType = F2(
	function (i18n, type_) {
		switch (type_) {
			case 0:
				return $author$project$I18n$Cles$monCompteSecuriteApplication(i18n);
			case 1:
				return $author$project$I18n$Cles$monCompteSecuriteCle(i18n);
			default:
				return $author$project$I18n$Cles$monCompteSecuriteAutreMoyen(i18n);
		}
	});
var $author$project$Components$Comptes$Securite$View$confirmation = F2(
	function (i18n, model) {
		var ids = $author$project$Components$Comptes$Securite$Model$idsDeLaConfirmation;
		var _v0 = function () {
			var _v1 = model.iu;
			if (!_v1.$) {
				switch (_v1.a.$) {
					case 0:
						var moyen = _v1.a.a;
						return _Utils_Tuple3(
							A2(
								$author$project$I18n$Cles$monCompteRetraitTitre,
								i18n,
								{
									Dj: A2(
										$elm$core$Maybe$withDefault,
										A2($author$project$Components$Comptes$Securite$View$nomDuType, i18n, moyen.r0),
										moyen.Dj)
								}),
							_Utils_ap(
								$author$project$I18n$Cles$monCompteRetraitMessage(i18n),
								($elm$core$List$length(
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.C_;
											},
											model.q1))) <= 1) ? (' ' + $author$project$I18n$Cles$monCompteRetraitDernier(i18n)) : ''),
							$author$project$I18n$Cles$monCompteRetraitConfirmer(i18n));
					case 1:
						var session = _v1.a.a;
						return _Utils_Tuple3(
							A2(
								$author$project$I18n$Cles$monCompteFermetureTitre,
								i18n,
								{
									tv: A2($author$project$Components$Comptes$Securite$Model$libelleDeLAppareil, i18n, session.tv)
								}),
							A2(
								$author$project$I18n$Cles$monCompteFermetureMessage,
								i18n,
								{
									sT: A2($author$project$Texte$Jour$horodate, i18n, session.xk),
									ty: A2($elm$core$String$join, ', ', session.tz)
								}),
							$author$project$I18n$Cles$monCompteFermetureConfirmer(i18n));
					default:
						var _v2 = _v1.a;
						return _Utils_Tuple3(
							$author$project$I18n$Cles$monCompteFermetureDesAutresTitre(i18n),
							$author$project$I18n$Cles$monCompteFermetureDesAutresMessage(i18n),
							$author$project$I18n$Cles$monCompteFermetureDesAutresConfirmer(i18n));
				}
			} else {
				return _Utils_Tuple3('', '', '');
			}
		}();
		var titre = _v0.a;
		var message = _v0.b;
		var confirmer = _v0.c;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'opened',
							!_Utils_eq(model.iu, $elm$core$Maybe$Nothing))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('overlay'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Comptes$Securite$Update$GesteAnnule)
						]),
					_List_Nil),
					A2(
					$author$project$Components$Shared$Confirmation$View$view,
					i18n,
					{
						vl: $author$project$Components$Comptes$Securite$Update$clavierDeLaConfirmation,
						j7: {Aq: ids.j7, Bl: confirmer, C$: $author$project$Components$Comptes$Securite$Update$GesteConfirme},
						Aq: ids.GN,
						As: ids.Cs,
						At: ids.h6,
						Cs: message,
						Et: !_Utils_eq(model.iu, $elm$core$Maybe$Nothing),
						HG: {
							Aq: ids.to,
							Bl: $author$project$I18n$Cles$monCompteAnnuler(i18n),
							C$: $author$project$Components$Comptes$Securite$Update$GesteAnnule
						},
						h6: titre,
						sl: 0
					})
				]));
	});
var $author$project$I18n$Cles$monCompteSuite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.suite', _List_Nil, 'Votre compte vaut pour toute la suite Asria (Asria CRM, Asria Cockpit, Asria Insight) : mot de passe, double authentification et sessions s\'y appliquent partout.');
};
var $author$project$Components$Comptes$Securite$Update$NomSaisi = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Comptes$Securite$Update$RenommageEnvoye = {$: 9};
var $author$project$I18n$Cles$monCompteRenommageAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.renommage.aide', _List_Nil, 'Ce nom vous aide à reconnaître l\'appareil. Il ne sert pas à la connexion.');
};
var $author$project$I18n$Cles$monCompteRenommageEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.renommage.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$monCompteRenommageNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.renommage.nom', _List_Nil, 'Nom');
};
var $author$project$I18n$Cles$monCompteRenommageNomInvalide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.renommage.nom-invalide', _List_Nil, 'Un nom de 1 à 255 caractères.');
};
var $author$project$I18n$Cles$monCompteRenommageTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.renommage.titre', _List_Nil, 'Renommer le moyen');
};
var $author$project$Components$Comptes$Securite$View$renommage = F2(
	function (i18n, model) {
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Comptes$Securite$Update$DuDrawer,
			{
				fs: {
					sR: (!$elm$core$String$isEmpty(
						$elm$core$String$trim(model.Dj))) && (!$author$project$API$Envoi$enCours(model.l2)),
					Bl: $author$project$I18n$Cles$monCompteRenommageEnregistrer(i18n),
					C$: $author$project$Components$Comptes$Securite$Update$RenommageEnvoye
				},
				fZ: _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Champ$View$texte,
						{
							go: _Utils_eq(
								model.pZ,
								$elm$core$Maybe$Just(3)) ? $elm$core$Maybe$Just(
								$author$project$I18n$Cles$monCompteRenommageNomInvalide(i18n)) : $elm$core$Maybe$Nothing,
							Aq: 'mon-compte-renommer-nom',
							Bl: $author$project$I18n$Cles$monCompteRenommageNom(i18n),
							he: true
						},
						{hg: $author$project$Components$Comptes$Securite$Update$NomSaisi, fm: model.Dj}),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$monCompteRenommageAide(i18n))
							]))
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$monCompteRenommageTitre(i18n)
			},
			model.kX);
	});
var $author$project$I18n$Cles$monCompteRetourApplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.retour.application', _List_Nil, 'Application d\'authentification ajoutée.');
};
var $author$project$I18n$Cles$monCompteRetourApplicationDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.retour.application-detail', _List_Nil, 'À votre prochaine connexion, le code vous sera demandé.');
};
var $author$project$I18n$Cles$monCompteRetourAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.retour.aucune', _List_Nil, 'Aucune modification.');
};
var $author$project$I18n$Cles$monCompteRetourAucuneDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.retour.aucune-detail', _List_Nil, 'Vous avez quitté l\'écran de connexion sécurisé sans rien changer.');
};
var $author$project$I18n$Cles$monCompteRetourAutresFermees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.retour.autres-fermees', _List_Nil, 'Vos autres sessions ont été fermées.');
};
var $author$project$I18n$Cles$monCompteRetourCle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.retour.cle', _List_Nil, 'Clé de sécurité ajoutée.');
};
var $author$project$I18n$Cles$monCompteRetourEchec = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.retour.echec', _List_Nil, 'La modification n\'a pas abouti sur l\'écran de connexion sécurisé. Réessayez.');
};
var $author$project$I18n$Cles$monCompteRetourMotDePasse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.retour.mot-de-passe', _List_Nil, 'Mot de passe modifié.');
};
var $author$project$I18n$Cles$monCompteRetourMotDePasseDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.retour.mot-de-passe-detail', _List_Nil, 'Vos autres sessions ont été fermées.');
};
var $author$project$I18n$Cles$monCompteRetourRenomme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.retour.renomme', _List_Nil, 'Moyen renommé.');
};
var $author$project$I18n$Cles$monCompteRetourRetire = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'mon-compte.retour.retire',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'moyen',
					$author$project$I18n$Traductions$Chaine(p.CZ))
				]),
			p.CZ + ' retirée.');
	});
var $author$project$I18n$Cles$monCompteRetourSessionFermee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.retour.session-fermee', _List_Nil, 'Session fermée.');
};
var $author$project$I18n$Cles$monCompteRetourSessionFermeeDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'mon-compte.retour.session-fermee-detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'appareil',
					$author$project$I18n$Traductions$Chaine(p.tv))
				]),
			p.tv + ' devra se reconnecter.');
	});
var $author$project$I18n$Cles$monCompteSecuriteDernierMoyenImpose = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.securite.dernier-moyen-impose', _List_Nil, 'Votre espace impose la double authentification : votre dernier moyen ne peut pas être retiré. Ajoutez-en un autre pour pouvoir le remplacer.');
};
var $author$project$I18n$Cles$monCompteSecuriteReconnexionRequise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.securite.reconnexion-requise', _List_Nil, 'Reconnectez-vous d\'abord : votre connexion n\'est pas assez récente pour ce geste.');
};
var $author$project$I18n$Cles$monCompteSessionsCouranteNonFermable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.sessions.courante-non-fermable', _List_Nil, 'La session de cet appareil se ferme par « Déconnexion ».');
};
var $author$project$Components$Comptes$Securite$View$retour = F2(
	function (i18n, model) {
		var valide = F2(
			function (titre, detail) {
				return A2(
					$author$project$Components$Shared$Note$View$view,
					3,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(titre)
								])),
							$rtfeldman$elm_css$Html$Styled$text(' ' + detail)
						]));
			});
		var _v0 = _Utils_Tuple2(model.pZ, model.qL);
		_v0$0:
		while (true) {
			_v0$1:
			while (true) {
				_v0$2:
				while (true) {
					_v0$3:
					while (true) {
						_v0$4:
						while (true) {
							_v0$5:
							while (true) {
								_v0$6:
								while (true) {
									_v0$7:
									while (true) {
										_v0$8:
										while (true) {
											_v0$9:
											while (true) {
												_v0$10:
												while (true) {
													_v0$11:
													while (true) {
														_v0$12:
														while (true) {
															if (!_v0.b.$) {
																switch (_v0.b.a.$) {
																	case 0:
																		if (!_v0.a.$) {
																			switch (_v0.a.a) {
																				case 1:
																					break _v0$0;
																				case 0:
																					break _v0$1;
																				case 2:
																					break _v0$2;
																				default:
																					break _v0$3;
																			}
																		} else {
																			break _v0$3;
																		}
																	case 1:
																		if (!_v0.a.$) {
																			switch (_v0.a.a) {
																				case 1:
																					break _v0$0;
																				case 0:
																					break _v0$1;
																				case 2:
																					break _v0$2;
																				default:
																					break _v0$4;
																			}
																		} else {
																			break _v0$4;
																		}
																	case 2:
																		if (!_v0.a.$) {
																			switch (_v0.a.a) {
																				case 1:
																					break _v0$0;
																				case 0:
																					break _v0$1;
																				case 2:
																					break _v0$2;
																				default:
																					break _v0$5;
																			}
																		} else {
																			break _v0$5;
																		}
																	case 3:
																		if (!_v0.a.$) {
																			switch (_v0.a.a) {
																				case 1:
																					break _v0$0;
																				case 0:
																					break _v0$1;
																				case 2:
																					break _v0$2;
																				default:
																					break _v0$6;
																			}
																		} else {
																			break _v0$6;
																		}
																	case 4:
																		if (!_v0.a.$) {
																			switch (_v0.a.a) {
																				case 1:
																					break _v0$0;
																				case 0:
																					break _v0$1;
																				case 2:
																					break _v0$2;
																				default:
																					break _v0$7;
																			}
																		} else {
																			break _v0$7;
																		}
																	case 5:
																		if (!_v0.a.$) {
																			switch (_v0.a.a) {
																				case 1:
																					break _v0$0;
																				case 0:
																					break _v0$1;
																				case 2:
																					break _v0$2;
																				default:
																					break _v0$8;
																			}
																		} else {
																			break _v0$8;
																		}
																	case 6:
																		if (!_v0.a.$) {
																			switch (_v0.a.a) {
																				case 1:
																					break _v0$0;
																				case 0:
																					break _v0$1;
																				case 2:
																					break _v0$2;
																				default:
																					break _v0$9;
																			}
																		} else {
																			break _v0$9;
																		}
																	case 7:
																		if (!_v0.a.$) {
																			switch (_v0.a.a) {
																				case 1:
																					break _v0$0;
																				case 0:
																					break _v0$1;
																				case 2:
																					break _v0$2;
																				default:
																					break _v0$10;
																			}
																		} else {
																			break _v0$10;
																		}
																	default:
																		if (!_v0.a.$) {
																			switch (_v0.a.a) {
																				case 1:
																					break _v0$0;
																				case 0:
																					break _v0$1;
																				case 2:
																					break _v0$2;
																				default:
																					break _v0$11;
																			}
																		} else {
																			break _v0$11;
																		}
																}
															} else {
																if (!_v0.a.$) {
																	switch (_v0.a.a) {
																		case 1:
																			break _v0$0;
																		case 0:
																			break _v0$1;
																		case 2:
																			break _v0$2;
																		default:
																			break _v0$12;
																	}
																} else {
																	break _v0$12;
																}
															}
														}
														return $rtfeldman$elm_css$Html$Styled$text('');
													}
													var _v10 = _v0.b.a;
													return A2(
														$author$project$Components$Shared$Note$View$view,
														3,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$monCompteRetourAutresFermees(i18n))
															]));
												}
												var appareil = _v0.b.a.a;
												return A2(
													valide,
													$author$project$I18n$Cles$monCompteRetourSessionFermee(i18n),
													A2(
														$author$project$I18n$Cles$monCompteRetourSessionFermeeDetail,
														i18n,
														{
															tv: A2($author$project$Components$Comptes$Securite$Model$libelleDeLAppareil, i18n, appareil)
														}));
											}
											var _v9 = _v0.b.a;
											return A2(
												$author$project$Components$Shared$Note$View$view,
												3,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$monCompteRetourRenomme(i18n))
													]));
										}
										var type_ = _v0.b.a.a;
										return A2(
											$author$project$Components$Shared$Note$View$view,
											3,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$author$project$I18n$Cles$monCompteRetourRetire,
														i18n,
														{
															CZ: A2($author$project$Components$Comptes$Securite$View$nomDuType, i18n, type_)
														}))
												]));
									}
									var _v8 = _v0.b.a;
									return A2(
										$author$project$Components$Shared$Note$View$view,
										2,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$monCompteRetourEchec(i18n))
											]));
								}
								var _v7 = _v0.b.a;
								return A2(
									$author$project$Components$Shared$Note$View$view,
									0,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$b,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$monCompteRetourAucune(i18n))
												])),
											$rtfeldman$elm_css$Html$Styled$text(
											' ' + $author$project$I18n$Cles$monCompteRetourAucuneDetail(i18n))
										]));
							}
							var _v6 = _v0.b.a;
							return A2(
								valide,
								$author$project$I18n$Cles$monCompteRetourCle(i18n),
								$author$project$I18n$Cles$monCompteRetourApplicationDetail(i18n));
						}
						var _v5 = _v0.b.a;
						return A2(
							valide,
							$author$project$I18n$Cles$monCompteRetourApplication(i18n),
							$author$project$I18n$Cles$monCompteRetourApplicationDetail(i18n));
					}
					var _v4 = _v0.b.a;
					return A2(
						valide,
						$author$project$I18n$Cles$monCompteRetourMotDePasse(i18n),
						$author$project$I18n$Cles$monCompteRetourMotDePasseDetail(i18n));
				}
				var _v3 = _v0.a.a;
				return A2(
					$author$project$Components$Shared$Note$View$view,
					2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$monCompteSessionsCouranteNonFermable(i18n))
						]));
			}
			var _v2 = _v0.a.a;
			return A2(
				$author$project$Components$Shared$Note$View$view,
				2,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$monCompteSecuriteReconnexionRequise(i18n))
					]));
		}
		var _v1 = _v0.a.a;
		return A2(
			$author$project$Components$Shared$Note$View$view,
			2,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$I18n$Cles$monCompteSecuriteDernierMoyenImpose(i18n))
				]));
	});
var $author$project$Components$Comptes$Securite$Update$ActionKeycloakDemandee = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Comptes$Securite$View$action = F4(
	function (variante, rel, libelle, lue) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (lien) {
					return _List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							variante,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Comptes$Securite$Update$ActionKeycloakDemandee(lien))
								]),
							libelle)
						]);
				},
				A2($author$project$API$Liens$trouver, rel, lue.nQ)));
	});
var $author$project$API$NavLinksDictionary$ajouterUneApplication = 'ajouter-une-application';
var $author$project$API$NavLinksDictionary$ajouterUneCle = 'ajouter-une-cle';
var $author$project$API$NavLinksDictionary$changerLeMotDePasse = 'changer-le-mot-de-passe';
var $author$project$Components$Comptes$Securite$View$jour = F2(
	function (i18n, instant) {
		return A2(
			$author$project$Texte$Jour$enFrancais,
			i18n,
			A2($elm$core$String$left, 10, instant));
	});
var $author$project$Components$Comptes$Securite$Update$GesteDemande = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Comptes$Securite$Update$RenommageDemande = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Comptes$Securite$Model$RetraitDuMoyen = function (a) {
	return {$: 0, a: a};
};
var $author$project$I18n$Cles$monCompteSecuriteRenommer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.securite.renommer', _List_Nil, 'Renommer');
};
var $author$project$I18n$Cles$monCompteSecuriteRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.securite.retirer', _List_Nil, 'Retirer');
};
var $author$project$Components$Comptes$Securite$View$siLien = F3(
	function (rel, liens, bouton) {
		return A2(
			$elm$core$Maybe$map,
			function (_v0) {
				return bouton;
			},
			A2($author$project$API$Liens$trouver, rel, liens));
	});
var $author$project$Components$Comptes$Securite$View$ligneDuMoyen = F3(
	function (i18n, model, moyen) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Comptes$Securite$View$nomDuType, i18n, moyen.r0))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', moyen.Dj))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$author$project$Components$Comptes$Securite$View$jour(i18n),
									moyen.s6)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								A3(
								$author$project$Components$Comptes$Securite$View$siLien,
								$author$project$API$NavLinksDictionary$renommerUnMoyen,
								moyen.nQ,
								A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									2,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Comptes$Securite$Update$RenommageDemande(moyen)),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
											$author$project$API$Envoi$enCours(model.l2))
										]),
									$author$project$I18n$Cles$monCompteSecuriteRenommer(i18n))),
								A3(
								$author$project$Components$Comptes$Securite$View$siLien,
								$author$project$API$NavLinksDictionary$retirerUnMoyen,
								moyen.nQ,
								A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									2,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Comptes$Securite$Update$GesteDemande(
												$author$project$Components$Comptes$Securite$Model$RetraitDuMoyen(moyen))),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
											$author$project$API$Envoi$enCours(model.l2))
										]),
									$author$project$I18n$Cles$monCompteSecuriteRetirer(i18n)))
							])))
				]));
	});
var $author$project$I18n$Cles$monCompteSecuriteActivee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.securite.activee', _List_Nil, 'Activée');
};
var $author$project$I18n$Cles$monCompteSecuriteActiver = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.securite.activer', _List_Nil, 'Activer la double authentification');
};
var $author$project$I18n$Cles$monCompteSecuriteAjouterUneApplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.securite.ajouter-une-application', _List_Nil, 'Ajouter une application d\'authentification');
};
var $author$project$I18n$Cles$monCompteSecuriteAjouterUneCle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.securite.ajouter-une-cle', _List_Nil, 'Ajouter une clé de sécurité');
};
var $author$project$I18n$Cles$monCompteSecuriteChangerLeMotDePasse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.securite.changer-le-mot-de-passe', _List_Nil, 'Changer mon mot de passe');
};
var $author$project$I18n$Cles$monCompteSecuriteColonneAjoute = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.securite.colonne-ajoute', _List_Nil, 'Ajouté le');
};
var $author$project$I18n$Cles$monCompteSecuriteColonneMoyen = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.securite.colonne-moyen', _List_Nil, 'Moyen');
};
var $author$project$I18n$Cles$monCompteSecuriteColonneNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.securite.colonne-nom', _List_Nil, 'Nom');
};
var $author$project$I18n$Cles$monCompteSecuriteDerniereModification = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.securite.derniere-modification', _List_Nil, 'Dernière modification');
};
var $author$project$I18n$Cles$monCompteSecuriteDoubleAuthentification = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.securite.double-authentification', _List_Nil, 'Double authentification');
};
var $author$project$I18n$Cles$monCompteSecuriteImposee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.securite.imposee', _List_Nil, 'Imposée par votre espace');
};
var $author$project$I18n$Cles$monCompteSecuriteIncitation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.securite.incitation', _List_Nil, 'Ajoutez une application d\'authentification ou une clé de sécurité. À chaque connexion, un code vous sera demandé en plus du mot de passe : un mot de passe volé ne suffira plus.');
};
var $author$project$I18n$Cles$monCompteSecuriteIncitationTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.securite.incitation-titre', _List_Nil, 'Protégez votre compte');
};
var $author$project$I18n$Cles$monCompteSecuriteJamais = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.securite.jamais', _List_Nil, 'Jamais');
};
var $author$project$I18n$Cles$monCompteSecuriteMotDePasse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.securite.mot-de-passe', _List_Nil, 'Mot de passe');
};
var $author$project$I18n$Cles$monCompteSecuriteMotDePasseAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.securite.mot-de-passe-aide', _List_Nil, 'Le changement se fait sur l\'écran de connexion sécurisé d\'Asria, qui vous ramène ici. Vos autres sessions seront fermées.');
};
var $author$project$I18n$Cles$monCompteSecuriteNonActivee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.securite.non-activee', _List_Nil, 'Non activée');
};
var $author$project$I18n$Cles$monCompteSecuriteRetraitAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.securite.retrait-aide', _List_Nil, 'Retirer un moyen demande de vous reconnecter.');
};
var $author$project$Components$Comptes$Securite$View$securite = F3(
	function (i18n, model, lue) {
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Page$View$section,
				_List_Nil,
				{
					fw: _List_Nil,
					fZ: _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('modification')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$monCompteSecuriteDerniereModification(i18n))
										])),
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$I18n$Cles$monCompteSecuriteJamais(i18n),
										A2(
											$elm$core$Maybe$map,
											$author$project$Components$Comptes$Securite$View$jour(i18n),
											lue.CV)))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$monCompteSecuriteMotDePasseAide(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
								]),
							A4(
								$author$project$Components$Comptes$Securite$View$action,
								1,
								$author$project$API$NavLinksDictionary$changerLeMotDePasse,
								$author$project$I18n$Cles$monCompteSecuriteChangerLeMotDePasse(i18n),
								lue))
						]),
					Dj: 'mot-de-passe',
					h6: $author$project$I18n$Cles$monCompteSecuriteMotDePasse(i18n)
				}),
				A2(
				$author$project$Components$Shared$Page$View$section,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'activee',
								!$elm$core$List$isEmpty(lue.C_))
							]))
					]),
				{
					fw: $elm$core$List$isEmpty(lue.C_) ? _List_Nil : _Utils_ap(
						A4(
							$author$project$Components$Comptes$Securite$View$action,
							1,
							$author$project$API$NavLinksDictionary$ajouterUneCle,
							$author$project$I18n$Cles$monCompteSecuriteAjouterUneCle(i18n),
							lue),
						A4(
							$author$project$Components$Comptes$Securite$View$action,
							1,
							$author$project$API$NavLinksDictionary$ajouterUneApplication,
							$author$project$I18n$Cles$monCompteSecuriteAjouterUneApplication(i18n),
							lue)),
					fZ: $elm$core$List$isEmpty(lue.C_) ? _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('etat')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Tag$View$view,
									3,
									$author$project$I18n$Cles$monCompteSecuriteNonActivee(i18n))
								])),
							A2(
							$author$project$Components$Shared$Note$View$view,
							1,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$b,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$monCompteSecuriteIncitationTitre(i18n))
										])),
									$rtfeldman$elm_css$Html$Styled$text(
									' ' + $author$project$I18n$Cles$monCompteSecuriteIncitation(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
								]),
							A4(
								$author$project$Components$Comptes$Securite$View$action,
								0,
								$author$project$API$NavLinksDictionary$ajouterUneApplication,
								$author$project$I18n$Cles$monCompteSecuriteActiver(i18n),
								lue))
						]) : _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('etat')
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$Components$Shared$Tag$View$view,
									0,
									$author$project$I18n$Cles$monCompteSecuriteActivee(i18n)),
								lue.AD ? _List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Tag$View$view,
										5,
										$author$project$I18n$Cles$monCompteSecuriteImposee(i18n))
									]) : _List_Nil)),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$table,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$thead,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$tr,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	$author$project$I18n$Cles$monCompteSecuriteColonneMoyen(i18n))
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	$author$project$I18n$Cles$monCompteSecuriteColonneNom(i18n))
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	$author$project$I18n$Cles$monCompteSecuriteColonneAjoute(i18n))
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
																]),
															_List_Nil)
														]))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$tbody,
											_List_Nil,
											A2(
												$elm$core$List$map,
												A2($author$project$Components$Comptes$Securite$View$ligneDuMoyen, i18n, model),
												lue.C_))
										]))
								])),
							(A2(
							$elm$core$List$any,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.nQ;
								},
								A2(
									$elm$core$Basics$composeR,
									$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$retirerUnMoyen),
									$elm$core$Basics$eq($elm$core$Maybe$Nothing))),
							lue.C_) && lue.AD) ? A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$monCompteSecuriteDernierMoyenImpose(i18n))
								])) : A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$monCompteSecuriteRetraitAide(i18n))
								]))
						]),
					Dj: 'double-authentification',
					h6: $author$project$I18n$Cles$monCompteSecuriteDoubleAuthentification(i18n)
				})
			]);
	});
var $author$project$Components$Comptes$Securite$Model$FermetureDesAutres = {$: 2};
var $author$project$Components$Comptes$Securite$Model$FermetureDeLaSession = function (a) {
	return {$: 1, a: a};
};
var $author$project$I18n$Cles$monCompteSessionsCetAppareil = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.sessions.cet-appareil', _List_Nil, 'Cet appareil');
};
var $author$project$I18n$Cles$monCompteSessionsFermer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.sessions.fermer', _List_Nil, 'Fermer');
};
var $author$project$I18n$Cles$monCompteSessionsMaintenant = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.sessions.maintenant', _List_Nil, 'Maintenant');
};
var $author$project$I18n$Cles$monCompteSessionsSeFermeParDeconnexion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.sessions.se-ferme-par-deconnexion', _List_Nil, 'Se ferme par « Déconnexion »');
};
var $author$project$Components$Comptes$Securite$View$ligneDeLaSession = F3(
	function (i18n, model, session) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('courante', session.wj)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Comptes$Securite$Model$libelleDeLAppareil, i18n, session.tv))
								])),
						session.wj ? _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(' '),
								A2(
								$author$project$Components$Shared$Tag$View$view,
								5,
								$author$project$I18n$Cles$monCompteSessionsCetAppareil(i18n))
							]) : _List_Nil)),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$String$join, ', ', session.tz))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							session.wj ? $author$project$I18n$Cles$monCompteSessionsMaintenant(i18n) : A2($author$project$Texte$Jour$horodate, i18n, session.xk))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					_List_fromArray(
						[
							session.wj ? A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$monCompteSessionsSeFermeParDeconnexion(i18n))
								])) : A2(
							$elm$core$Maybe$withDefault,
							$rtfeldman$elm_css$Html$Styled$text(''),
							A3(
								$author$project$Components$Comptes$Securite$View$siLien,
								$author$project$API$NavLinksDictionary$fermerUneSession,
								session.nQ,
								A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Comptes$Securite$Update$GesteDemande(
												$author$project$Components$Comptes$Securite$Model$FermetureDeLaSession(session))),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
											$author$project$API$Envoi$enCours(model.l2))
										]),
									$author$project$I18n$Cles$monCompteSessionsFermer(i18n))))
						]))
				]));
	});
var $author$project$I18n$Cles$monCompteConnexionsAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.connexions.aide', _List_Nil, '30 derniers jours, sessions ouvertes dans Asria CRM. Une connexion que vous ne reconnaissez pas ? Changez votre mot de passe et fermez les autres sessions.');
};
var $author$project$I18n$Cles$monCompteConnexionsColonneDate = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.connexions.colonne-date', _List_Nil, 'Date et heure');
};
var $author$project$I18n$Cles$monCompteConnexionsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.connexions.titre', _List_Nil, 'Mes dernières connexions');
};
var $author$project$I18n$Cles$monCompteSessionsColonneActivite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.sessions.colonne-activite', _List_Nil, 'Dernière activité');
};
var $author$project$I18n$Cles$monCompteSessionsColonneAppareil = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.sessions.colonne-appareil', _List_Nil, 'Appareil et navigateur');
};
var $author$project$I18n$Cles$monCompteSessionsColonneApplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.sessions.colonne-application', _List_Nil, 'Application');
};
var $author$project$I18n$Cles$monCompteSessionsFermerLesAutres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.sessions.fermer-les-autres', _List_Nil, 'Fermer toutes les autres sessions…');
};
var $author$project$I18n$Cles$monCompteSessionsFermerLesAutresAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.sessions.fermer-les-autres-aide', _List_Nil, 'Fermer toutes les autres sessions demande de vous reconnecter.');
};
var $author$project$I18n$Cles$monCompteSessionsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.sessions.titre', _List_Nil, 'Sessions et appareils ouverts');
};
var $author$project$Components$Shared$Page$View$sectionAvecCompte = F2(
	function (attributs, fournie) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$class(fournie.Dj),
				attributs),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (identifiant) {
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id(identifiant),
												$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1)
											]);
									},
									fournie.Ar)),
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_css$Html$Styled$text(fournie.h6),
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function (compte) {
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(compte)
														]))
												]);
										},
										fournie.vW)))),
						fournie.fw)),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					fournie.fZ)
				]));
	});
var $author$project$Components$Comptes$Securite$View$sessions = F3(
	function (i18n, model, lues) {
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Page$View$sectionAvecCompte,
				_List_Nil,
				{
					fw: _List_Nil,
					vW: $elm$core$Maybe$Just(
						$elm$core$String$fromInt(
							$elm$core$List$length(lues.IK))),
					fZ: _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$table,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$thead,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$tr,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	$author$project$I18n$Cles$monCompteSessionsColonneAppareil(i18n))
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	$author$project$I18n$Cles$monCompteSessionsColonneApplication(i18n))
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	$author$project$I18n$Cles$monCompteSessionsColonneActivite(i18n))
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
																]),
															_List_Nil)
														]))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$tbody,
											_List_Nil,
											A2(
												$elm$core$List$map,
												A2($author$project$Components$Comptes$Securite$View$ligneDeLaSession, i18n, model),
												lues.IK))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
								]),
							function () {
								var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$fermerLesAutresSessions, lues.nQ);
								if (!_v0.$) {
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$monCompteSessionsFermerLesAutresAide(i18n))
												])),
											A3(
											$author$project$Components$Shared$Bouton$View$bouton,
											3,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Events$onClick(
													$author$project$Components$Comptes$Securite$Update$GesteDemande($author$project$Components$Comptes$Securite$Model$FermetureDesAutres)),
													$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
													$author$project$API$Envoi$enCours(model.l2))
												]),
											$author$project$I18n$Cles$monCompteSessionsFermerLesAutres(i18n))
										]);
								} else {
									return _List_Nil;
								}
							}())
						]),
					Ar: $elm$core$Maybe$Nothing,
					Dj: 'sessions',
					h6: $author$project$I18n$Cles$monCompteSessionsTitre(i18n)
				}),
				A2(
				$author$project$Components$Shared$Page$View$section,
				_List_Nil,
				{
					fw: _List_Nil,
					fZ: _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$table,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$thead,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$tr,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	$author$project$I18n$Cles$monCompteConnexionsColonneDate(i18n))
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	$author$project$I18n$Cles$monCompteSessionsColonneAppareil(i18n))
																]))
														]))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$tbody,
											_List_Nil,
											A2(
												$elm$core$List$map,
												function (connexion) {
													return A2(
														$rtfeldman$elm_css$Html$Styled$tr,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$rtfeldman$elm_css$Html$Styled$td,
																_List_Nil,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(
																		A2($author$project$Texte$Jour$horodate, i18n, connexion.Bf))
																	])),
																A2(
																$rtfeldman$elm_css$Html$Styled$td,
																_List_Nil,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(
																		A2($author$project$Components$Comptes$Securite$Model$libelleDeLAppareil, i18n, connexion.C4))
																	]))
															]));
												},
												model.j8))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$monCompteConnexionsAide(i18n))
								]))
						]),
					Dj: 'connexions',
					h6: $author$project$I18n$Cles$monCompteConnexionsTitre(i18n)
				})
			]);
	});
var $author$project$Components$Comptes$Common$Onglets$Profil = 0;
var $author$project$I18n$Cles$monCompteOngletSecurite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.onglet.securite', _List_Nil, 'Sécurité');
};
var $author$project$I18n$Cles$monCompteOngletSessions = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'mon-compte.onglet.sessions', _List_Nil, 'Sessions');
};
var $author$project$Components$Comptes$Common$Onglets$view = F2(
	function (i18n, actif) {
		return $author$project$Components$Shared$Onglets$View$view(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var onglet = _v0.a;
					var nom = _v0.b;
					var adresse = _v0.c;
					return {
						sO: _Utils_eq(onglet, actif),
						aa: adresse,
						vW: $elm$core$Maybe$Nothing,
						Dj: nom
					};
				},
				_List_fromArray(
					[
						_Utils_Tuple3(
						0,
						$author$project$I18n$Cles$monCompteOngletProfil(i18n),
						$author$project$Routes$Route$adresseDeMonCompte),
						_Utils_Tuple3(
						1,
						$author$project$I18n$Cles$monCompteOngletSecurite(i18n),
						$author$project$Routes$Route$adresseDeLaSecuriteDuCompte),
						_Utils_Tuple3(
						2,
						$author$project$I18n$Cles$monCompteOngletSessions(i18n),
						$author$project$Routes$Route$adresseDesSessionsDuCompte)
					])));
	});
var $author$project$Components$Comptes$Securite$View$view = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'mon-compte-securite',
			{
				ut: $author$project$Components$Shared$Page$View$fiche(
					{
						tQ: _List_Nil,
						B2: A2(
							$elm$core$List$cons,
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							A2(
								$elm$core$List$cons,
								A2($author$project$Components$Comptes$Securite$View$retour, i18n, model),
								A2(
									$elm$core$List$cons,
									A2(
										$author$project$Components$Shared$Note$View$view,
										0,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$monCompteSuite(i18n))
											])),
									function () {
										var _v0 = model.oZ;
										if (!_v0) {
											return A2(
												$elm$core$Maybe$withDefault,
												_List_Nil,
												A2(
													$elm$core$Maybe$map,
													A2($author$project$Components$Comptes$Securite$View$securite, i18n, model),
													model.q1));
										} else {
											return A2(
												$elm$core$Maybe$withDefault,
												_List_Nil,
												A2(
													$elm$core$Maybe$map,
													A2($author$project$Components$Comptes$Securite$View$sessions, i18n, model),
													model.IK));
										}
									}())))
					}),
				xy: _List_fromArray(
					[
						A2($author$project$Components$Comptes$Securite$View$confirmation, i18n, model),
						A2($author$project$Components$Comptes$Securite$View$renommage, i18n, model)
					]),
				zM: _List_Nil,
				AK: $author$project$Components$Comptes$Securite$Update$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_Nil,
						zE: _List_Nil,
						Ef: _List_fromArray(
							[
								A2(
								$author$project$Components$Comptes$Common$Onglets$view,
								i18n,
								(!model.oZ) ? 1 : 2)
							]),
						h6: $author$project$I18n$Cles$monCompteTitre(i18n)
					})
			});
	});
var $author$project$I18n$Cles$demonstrationTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.titre', _List_Nil, 'Démonstration du socle');
};
var $author$project$Components$Demonstration$View$AccordeonDEtapes = 11;
var $author$project$Components$Demonstration$View$BarreDeRepartition = 15;
var $author$project$Components$Demonstration$View$Bascule = 2;
var $author$project$Components$Demonstration$View$Boutons = 8;
var $author$project$Components$Demonstration$View$CarteDAnnuaire = 0;
var $author$project$Components$Demonstration$View$Champs = 9;
var $author$project$Components$Demonstration$View$Confirmation = 5;
var $author$project$Components$Demonstration$View$Drawer = 4;
var $author$project$Components$Demonstration$View$IndicateursCles = 14;
var $author$project$Components$Demonstration$View$KanbanDePipe = 13;
var $author$project$Components$Demonstration$View$NavigationDeLaSuite = 16;
var $author$project$Components$Demonstration$View$Notes = 10;
var $author$project$Components$Demonstration$View$OngletsDeFiche = 6;
var $author$project$Components$Demonstration$View$Selection = 3;
var $author$project$Components$Demonstration$View$TableauDAnnuaire = 1;
var $author$project$Components$Demonstration$View$Tags = 7;
var $author$project$Components$Demonstration$View$TuilesDeChoix = 12;
var $author$project$Components$Demonstration$View$documentes = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16]);
var $author$project$I18n$Cles$demonstrationSectionEtatDuTheme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.section.etat-du-theme', _List_Nil, 'État du thème');
};
var $author$project$I18n$Cles$themeEtatApplique = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'theme.etat.applique',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Thème de l\'instance appliqué : ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' token surchargé.')) : ('Thème de l\'instance appliqué : ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' tokens surchargés.')));
	});
var $author$project$I18n$Cles$themeEtatSansAdresse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'theme.etat.sans-adresse', _List_Nil, 'Thème Asria appliqué : aucune route de thème n\'est configurée.');
};
var $author$project$Components$Demonstration$View$etatDuTheme = F2(
	function (i18n, theme) {
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id('etat-du-theme')
				]),
			{
				fw: _List_Nil,
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								function () {
									var _v0 = theme.gt;
									switch (_v0.$) {
										case 0:
											return $author$project$I18n$Cles$themeEtatSansAdresse(i18n);
										case 1:
											return '';
										case 2:
											var applique = _v0.a;
											return A2(
												$author$project$I18n$Cles$themeEtatApplique,
												i18n,
												{
													w: $elm$core$List$length(applique.Jg)
												});
										default:
											var cause = _v0.a;
											return A2($author$project$Components$Socle$Theme$View$cause, i18n, cause);
									}
								}())
							]))
					]),
				Dj: 'etat-du-theme',
				h6: $author$project$I18n$Cles$demonstrationSectionEtatDuTheme(i18n)
			});
	});
var $author$project$Components$Demonstration$View$nom = function (composant) {
	switch (composant) {
		case 0:
			return 'carte-annuaire';
		case 1:
			return 'tableau';
		case 2:
			return 'bascule';
		case 3:
			return 'selection';
		case 4:
			return 'drawer';
		case 5:
			return 'confirmation';
		case 6:
			return 'onglets';
		case 7:
			return 'tags';
		case 8:
			return 'boutons';
		case 9:
			return 'champs';
		case 10:
			return 'notes';
		case 11:
			return 'accordeon';
		case 12:
			return 'tuiles';
		case 13:
			return 'kanban';
		case 14:
			return 'indicateur-cle';
		case 15:
			return 'barre-repartition';
		default:
			return 'navigation';
	}
};
var $author$project$Components$Demonstration$View$ancre = function (composant) {
	return 'composant-' + $author$project$Components$Demonstration$View$nom(composant);
};
var $author$project$Components$Demonstration$Update$EtapeBasculee = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Demonstration$Update$Saisi = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$I18n$Cles$demonstrationChampCase = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.champ.case', _List_Nil, 'Dossier prioritaire');
};
var $author$project$I18n$Cles$demonstrationChampErreur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.champ.erreur', _List_Nil, 'Le nom du dossier est obligatoire.');
};
var $author$project$I18n$Cles$demonstrationDossiersCreerNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.dossiers.creer.nom', _List_Nil, 'Nom du dossier');
};
var $author$project$I18n$Cles$demonstrationFicheCommentaire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.fiche.commentaire', _List_Nil, 'Commentaire');
};
var $author$project$I18n$Cles$demonstrationPartiesPrenantesColonneTags = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.parties-prenantes.colonne.tags', _List_Nil, 'Rôle');
};
var $author$project$Components$Demonstration$Donnees$roles = _List_fromArray(
	[
		_Utils_Tuple2(0, 'Licencié'),
		_Utils_Tuple2(3, 'Gestionnaire'),
		_Utils_Tuple2(1, 'Producteur')
	]);
var $author$project$Components$Demonstration$View$champs = F2(
	function (i18n, model) {
		var saisie = function (identifiant) {
			return {
				hg: $author$project$Components$Demonstration$Update$Saisi(identifiant),
				fm: A2($author$project$Components$Demonstration$Model$saisie, identifiant, model)
			};
		};
		var champ = F2(
			function (identifiant, libelle) {
				return {go: $elm$core$Maybe$Nothing, Aq: identifiant, Bl: libelle, he: false};
			});
		var nomDuDossier = A2(
			champ,
			'demonstration-champ-texte',
			$author$project$I18n$Cles$demonstrationDossiersCreerNom(i18n));
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Champ$View$texte,
				_Utils_update(
					nomDuDossier,
					{
						go: (A2($author$project$Components$Demonstration$Model$saisie, nomDuDossier.Aq, model) === '') ? $elm$core$Maybe$Just(
							$author$project$I18n$Cles$demonstrationChampErreur(i18n)) : $elm$core$Maybe$Nothing,
						he: true
					}),
				saisie(nomDuDossier.Aq)),
				A2(
				$author$project$Components$Shared$Champ$View$zoneDeTexte,
				A2(
					champ,
					'demonstration-champ-zone',
					$author$project$I18n$Cles$demonstrationFicheCommentaire(i18n)),
				saisie('demonstration-champ-zone')),
				A2(
				$author$project$Components$Shared$Champ$View$liste,
				A2(
					champ,
					'demonstration-champ-liste',
					$author$project$I18n$Cles$demonstrationPartiesPrenantesColonneTags(i18n)),
				{
					hg: $author$project$Components$Demonstration$Update$Saisi('demonstration-champ-liste'),
					o_: A2(
						$elm$core$List$map,
						function (_v0) {
							var role = _v0.b;
							return {Bl: role, fm: role};
						},
						$author$project$Components$Demonstration$Donnees$roles),
					fm: A2($author$project$Components$Demonstration$Model$saisie, 'demonstration-champ-liste', model)
				}),
				A2(
				$author$project$Components$Shared$Champ$View$caseACocher,
				A2(
					champ,
					'demonstration-champ-case',
					$author$project$I18n$Cles$demonstrationChampCase(i18n)),
				{
					vt: A2($author$project$Components$Demonstration$Model$saisie, 'demonstration-champ-case', model) !== '',
					D9: function (cochee) {
						return A2(
							$author$project$Components$Demonstration$Update$Saisi,
							'demonstration-champ-case',
							cochee ? 'oui' : '');
					}
				})
			]);
	});
var $author$project$I18n$Cles$demonstrationDossiersColonneIndicateur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.dossiers.colonne.indicateur', _List_Nil, 'Ancienneté');
};
var $author$project$I18n$Cles$demonstrationDossiersColonneTags = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.dossiers.colonne.tags', _List_Nil, 'État');
};
var $author$project$I18n$Cles$demonstrationDossiersColonneTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.dossiers.colonne.titre', _List_Nil, 'Dossier');
};
var $author$project$Components$Demonstration$View$colonnesDesDossiers = function (i18n) {
	return {
		m9: $elm$core$Maybe$Just(
			$author$project$I18n$Cles$demonstrationDossiersColonneIndicateur(i18n)),
		ry: $author$project$I18n$Cles$demonstrationDossiersColonneTags(i18n),
		h6: $author$project$I18n$Cles$demonstrationDossiersColonneTitre(i18n)
	};
};
var $author$project$I18n$Cles$demonstrationFicheEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.fiche.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$demonstrationFicheOngletHistorique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.fiche.onglet.historique', _List_Nil, 'Historique');
};
var $author$project$I18n$Cles$demonstrationFicheOngletSynthese = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.fiche.onglet.synthese', _List_Nil, 'Synthèse');
};
var $author$project$I18n$Cles$demonstrationSectionVoirConfirmation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.section.voir.confirmation', _List_Nil, 'Dans le drawer « Nouveau dossier » : une saisie, puis un clic sur l\'overlay.');
};
var $author$project$I18n$Cles$demonstrationSectionVoirNavigation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.section.voir.navigation', _List_Nil, 'La barre des applications et le menu accompagnent cette page.');
};
var $author$project$I18n$Cles$demonstrationTuilesLegende = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.tuiles.legende', _List_Nil, 'Type de dossier');
};
var $author$project$Components$Demonstration$Donnees$auRang = F3(
	function (vide, rang, liste) {
		return A2(
			$elm$core$Maybe$withDefault,
			vide,
			$elm$core$List$head(
				A2(
					$elm$core$List$drop,
					A2(
						$elm$core$Basics$modBy,
						A2(
							$elm$core$Basics$max,
							1,
							$elm$core$List$length(liste)),
						rang),
					liste)));
	});
var $author$project$Components$Demonstration$Donnees$etapes = _List_fromArray(
	['Besoin saisi', 'En vérification', 'Confirmée']);
var $author$project$Components$Demonstration$Donnees$etats = _List_fromArray(
	[
		_Utils_Tuple2(0, 'Actif'),
		_Utils_Tuple2(1, 'En attente'),
		_Utils_Tuple2(2, 'En retard'),
		_Utils_Tuple2(3, 'Clos')
	]);
var $author$project$Components$Demonstration$Donnees$noms = _List_fromArray(
	['Martin', 'Durand', 'Bernard', 'Petit', 'Moreau']);
var $author$project$Components$Demonstration$Donnees$prenoms = _List_fromArray(
	['Camille', 'Alex', 'Sacha', 'Charlie', 'Dominique', 'Claude', 'Maxime', 'Morgan', 'Lou', 'Andréa']);
var $author$project$Components$Demonstration$Donnees$personne = function (rang) {
	return A3($author$project$Components$Demonstration$Donnees$auRang, '', rang - 1, $author$project$Components$Demonstration$Donnees$prenoms) + (' ' + A3(
		$author$project$Components$Demonstration$Donnees$auRang,
		'',
		((rang - 1) / $elm$core$List$length($author$project$Components$Demonstration$Donnees$prenoms)) | 0,
		$author$project$Components$Demonstration$Donnees$noms));
};
var $author$project$Components$Demonstration$Donnees$dossier = function (rang) {
	var id = 'd-' + $elm$core$String$fromInt(rang);
	return {
		aa: $elm$core$Maybe$Just(
			$author$project$Routes$Route$toString(
				A3($author$project$Routes$Route$DemonstrationFiche, 1, id, 0))),
		Aq: id,
		m9: $elm$core$Maybe$Just(
			$elm$core$String$fromInt(rang * 3) + ' jours'),
		gL: _List_fromArray(
			[
				_Utils_Tuple2(
				'Responsable',
				$author$project$Components$Demonstration$Donnees$personne(rang + 20)),
				_Utils_Tuple2(
				'Étape',
				A3($author$project$Components$Demonstration$Donnees$auRang, '', rang, $author$project$Components$Demonstration$Donnees$etapes))
			]),
		ry: _List_fromArray(
			[
				A3(
				$author$project$Components$Demonstration$Donnees$auRang,
				_Utils_Tuple2(3, ''),
				rang,
				$author$project$Components$Demonstration$Donnees$etats)
			]),
		rz: _List_Nil,
		h6: 'Commande licencié — ' + $author$project$Components$Demonstration$Donnees$personne(rang)
	};
};
var $author$project$Components$Demonstration$Donnees$dossiers = A2(
	$elm$core$List$map,
	$author$project$Components$Demonstration$Donnees$dossier,
	A2($elm$core$List$range, 1, 12));
var $author$project$I18n$Cles$demonstrationDossiersCompteur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'demonstration.dossiers.compteur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' dossier') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' dossiers'));
	});
var $author$project$Components$Demonstration$Donnees$parEtape = function (etape) {
	return A2(
		$elm$core$List$filter,
		function (unDossier) {
			return A2(
				$elm$core$List$member,
				_Utils_Tuple2('Étape', etape),
				unDossier.gL);
		},
		$author$project$Components$Demonstration$Donnees$dossiers);
};
var $author$project$Components$Shared$Cartouche$View$versLaFiche = function (entree) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $rtfeldman$elm_css$Html$Styled$Attributes$href, $elm$core$List$singleton),
			entree.aa));
};
var $author$project$Components$Demonstration$View$etape = F3(
	function (i18n, rang, fournie) {
		var dossiers = $author$project$Components$Demonstration$Donnees$parEtape(fournie);
		return {
			fZ: _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (dossier) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										$author$project$Components$Shared$Cartouche$View$versLaFiche(dossier),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(dossier.h6)
											]))
									]));
						},
						dossiers))
				]),
			Aq: 'demonstration-etape-' + $elm$core$String$fromInt(rang + 1),
			Dj: fournie,
			HX: _List_fromArray(
				[
					_Utils_Tuple2(
					3,
					A2(
						$author$project$I18n$Cles$demonstrationDossiersCompteur,
						i18n,
						{
							w: $elm$core$List$length(dossiers)
						}))
				])
		};
	});
var $author$project$Components$Demonstration$View$idTuiles = 'demonstration-type-de-dossier';
var $author$project$Components$Demonstration$Donnees$indicateurs = _List_fromArray(
	[
		{
		iJ: false,
		Bl: 'Dossiers ouverts',
		fm: $elm$core$String$fromInt(
			$elm$core$List$length($author$project$Components$Demonstration$Donnees$dossiers))
	},
		{iJ: true, Bl: 'Dossiers en retard', fm: '3'}
	]);
var $author$project$Components$Demonstration$View$nonVide = function (valeur) {
	return (valeur === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(valeur);
};
var $author$project$Components$Demonstration$Donnees$notes = {uj: 'Trois dossiers attendent une décision depuis plus de trente jours.', AL: 'Ce pipe sert deux offres du catalogue.', Ks: 'Le paramétrage du pipe est cohérent.'};
var $author$project$Components$Demonstration$Donnees$typesDeDossier = _List_fromArray(
	[
		{dH: 'Commande d\'un licencié', h6: 'Commande', fm: 'commande'},
		{dH: 'Dossier qui en réunit d\'autres', h6: 'Regroupement', fm: 'regroupement'}
	]);
var $author$project$Components$Demonstration$View$versLAncre = function (composant) {
	return $author$project$Routes$Route$adresseDemonstration + ('#' + $author$project$Components$Demonstration$View$ancre(composant));
};
var $author$project$I18n$Cles$demonstrationSectionVoirDossiers = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.section.voir.dossiers', _List_Nil, 'Voir l\'annuaire des dossiers');
};
var $author$project$I18n$Cles$demonstrationSectionVoirPartiesPrenantes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.section.voir.parties-prenantes', _List_Nil, 'Voir l\'annuaire des parties prenantes');
};
var $author$project$Components$Demonstration$View$versLAnnuaire = F3(
	function (i18n, variante, annuaire) {
		return A3(
			$author$project$Components$Shared$Bouton$View$lien,
			variante,
			$author$project$Routes$Route$toString(
				$author$project$Routes$Route$DemonstrationAnnuaire(annuaire)),
			function () {
				if (!annuaire) {
					return $author$project$I18n$Cles$demonstrationSectionVoirPartiesPrenantes(i18n);
				} else {
					return $author$project$I18n$Cles$demonstrationSectionVoirDossiers(i18n);
				}
			}());
	});
var $author$project$Components$Shared$Svg$svgChevronDown = A3($author$project$Components$Shared$Svg$icone, 'chevron-down', 'M18 9l-6 6-6-6', _List_Nil);
var $author$project$Components$Shared$Accordeon$View$element = F3(
	function (accordeon, rang, fourni) {
		var ouvert = _Utils_eq(
			accordeon.Es,
			$elm$core$Maybe$Just(fourni.Aq));
		var idContenu = fourni.Aq + '-contenu';
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('opened', ouvert)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-expanded',
							ouvert ? 'true' : 'false'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-controls', idContenu),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							accordeon.D8(fourni.Aq))
						]),
					_List_fromArray(
						[
							ouvert ? $author$project$Components$Shared$Svg$svgChevronDown : $author$project$Components$Shared$Svg$svgChevronRight,
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('numero')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$elm$core$String$fromInt(rang + 1))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(fourni.Dj)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('pills')
								]),
							A2(
								$elm$core$List$map,
								function (_v0) {
									var couleur = _v0.a;
									var libelle = _v0.b;
									return A2($author$project$Components$Shared$Tag$View$view, couleur, libelle);
								},
								fourni.HX))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id(idContenu),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('accordeon-contenu')
						]),
					fourni.fZ)
				]));
	});
var $author$project$Components$Shared$Accordeon$View$view = F2(
	function (accordeon, elements) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$ol,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('accordeon')
				]),
			A2(
				$elm$core$List$indexedMap,
				$author$project$Components$Shared$Accordeon$View$element(accordeon),
				elements));
	});
var $author$project$Components$Shared$BarreRepartition$View$legende = function (part) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$li,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(part.Dj)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$strong,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$elm$core$String$fromInt(part.w))
					]))
			]));
};
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $rtfeldman$elm_css$VirtualDom$Styled$style = F2(
	function (key, val) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$style, key, val),
			_List_Nil,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$style = $rtfeldman$elm_css$VirtualDom$Styled$style;
var $author$project$Components$Shared$BarreRepartition$View$segment = F2(
	function (rang, part) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('segment'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					'nuance-' + $elm$core$String$fromInt(rang + 1)),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$style,
					'flex-grow',
					$elm$core$String$fromInt(part.w))
				]),
			_List_Nil);
	});
var $author$project$Components$Shared$BarreRepartition$View$view = function (parts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('barre-repartition')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('segments'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
					]),
				A2(
					$elm$core$List$indexedMap,
					$author$project$Components$Shared$BarreRepartition$View$segment,
					A2(
						$elm$core$List$filter,
						function (part) {
							return part.w > 0;
						},
						parts))),
				A2(
				$rtfeldman$elm_css$Html$Styled$ul,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('legende')
					]),
				A2($elm$core$List$map, $author$project$Components$Shared$BarreRepartition$View$legende, parts))
			]));
};
var $author$project$Components$Shared$Cartouche$View$caseDeSelection = function (selection) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$input,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
				$rtfeldman$elm_css$Html$Styled$Attributes$checked(selection.vt),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', selection.Bl),
				$rtfeldman$elm_css$Html$Styled$Events$onCheck(selection.D9)
			]),
		_List_Nil);
};
var $author$project$Components$Shared$Cartouche$View$indicateur = function (fourni) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (valeur) {
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(valeur)
							]))
					]);
			},
			fourni));
};
var $author$project$Components$Shared$Cartouche$View$info = function (_v0) {
	var libelle = _v0.a;
	var valeur = _v0.b;
	return A2(
		$rtfeldman$elm_css$Html$Styled$li,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(libelle)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$strong,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(valeur)
					]))
			]));
};
var $author$project$Components$Shared$Cartouche$View$view = F3(
	function (entite, selection, entree) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('cartouche-' + entite),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'selected',
							A2(
								$elm$core$Maybe$withDefault,
								false,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.vt;
									},
									selection)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('selection')
						]),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $author$project$Components$Shared$Cartouche$View$caseDeSelection, $elm$core$List$singleton),
							selection))),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('content')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('main')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									A2(
										$elm$core$List$cons,
										$rtfeldman$elm_css$Html$Styled$Attributes$class('title'),
										$author$project$Components$Shared$Cartouche$View$versLaFiche(entree)),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(entree.h6)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('pills')
										]),
									A2(
										$elm$core$List$map,
										function (_v0) {
											var couleur = _v0.a;
											var libelle = _v0.b;
											return A2($author$project$Components$Shared$Tag$View$view, couleur, libelle);
										},
										entree.ry)),
									A2(
									$rtfeldman$elm_css$Html$Styled$ul,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('infos')
										]),
									A2($elm$core$List$map, $author$project$Components$Shared$Cartouche$View$info, entree.gL))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aside')
								]),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									function (_v1) {
										var couleur = _v1.a;
										var libelle = _v1.b;
										return A2($author$project$Components$Shared$Tag$View$view, couleur, libelle);
									},
									entree.rz),
								$author$project$Components$Shared$Cartouche$View$indicateur(entree.m9)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$Shared$IndicateurCle$View$view = function (indicateur) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('indicateur-cle'),
				$rtfeldman$elm_css$Html$Styled$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('alerte', indicateur.iJ)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$strong,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(indicateur.fm)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(indicateur.Bl)
					]))
			]));
};
var $author$project$Components$Shared$Kanban$View$colonne = F2(
	function (entite, fournie) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('colonne')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('colonne-titre')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(fournie.Dj)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nombre')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$elm$core$String$fromInt(
										$elm$core$List$length(fournie.yv)))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('list')
						]),
					A2(
						$elm$core$List$map,
						function (entree) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('item')
									]),
								_List_fromArray(
									[
										A3($author$project$Components$Shared$Cartouche$View$view, entite, $elm$core$Maybe$Nothing, entree)
									]));
						},
						fournie.yv))
				]));
	});
var $author$project$Components$Shared$Kanban$View$view = F2(
	function (entite, colonnes) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('kanban')
				]),
			A2(
				$elm$core$List$map,
				$author$project$Components$Shared$Kanban$View$colonne(entite),
				colonnes));
	});
var $author$project$Components$Shared$Tableau$View$enTetes = F3(
	function (colonnes, avecSelection, entrees) {
		var libelles = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.gL;
					},
					$elm$core$List$map($elm$core$Tuple$first)),
				$elm$core$List$head(entrees)));
		return _Utils_ap(
			avecSelection ? _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('selection')
						]),
					_List_Nil)
				]) : _List_Nil,
			A2(
				$elm$core$List$map,
				function (nom) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$th,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(nom)
							]));
				},
				A2(
					$elm$core$List$cons,
					colonnes.h6,
					A2(
						$elm$core$List$cons,
						colonnes.ry,
						_Utils_ap(
							libelles,
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2($elm$core$Maybe$map, $elm$core$List$singleton, colonnes.m9)))))));
	});
var $author$project$Components$Shared$Tableau$View$caseDeLigne = function (selection) {
	return _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$td,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('selection')
				]),
			_List_fromArray(
				[
					$author$project$Components$Shared$Cartouche$View$caseDeSelection(selection)
				]))
		]);
};
var $author$project$Components$Shared$Tableau$View$tag = function (_v0) {
	var couleur = _v0.a;
	var libelle = _v0.b;
	return A2($author$project$Components$Shared$Tag$View$view, couleur, libelle);
};
var $author$project$Components$Shared$Tableau$View$ligne = F3(
	function (colonnes, selection, entree) {
		var fournie = A2(
			$elm$core$Maybe$map,
			function (pour) {
				return pour(entree);
			},
			selection);
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'selected',
							A2(
								$elm$core$Maybe$withDefault,
								false,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.vt;
									},
									fournie)))
						]))
				]),
			_Utils_ap(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $author$project$Components$Shared$Tableau$View$caseDeLigne, fournie)),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$td,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									A2(
										$elm$core$List$cons,
										$rtfeldman$elm_css$Html$Styled$Attributes$class('title'),
										$author$project$Components$Shared$Cartouche$View$versLaFiche(entree)),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(entree.h6)
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$td,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('pills')
										]),
									A2(
										$elm$core$List$map,
										$author$project$Components$Shared$Tableau$View$tag,
										_Utils_ap(entree.ry, entree.rz)))
								]))
						]),
					_Utils_ap(
						A2(
							$elm$core$List$map,
							function (_v0) {
								var valeur = _v0.b;
								return A2(
									$rtfeldman$elm_css$Html$Styled$td,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(valeur)
										]));
							},
							entree.gL),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (_v1) {
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$td,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2($elm$core$Maybe$withDefault, '', entree.m9))
												]))
										]);
								},
								colonnes.m9))))));
	});
var $author$project$Components$Shared$Tableau$View$view = F4(
	function (attributs, colonnes, selection, entrees) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau'),
				attributs),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$table,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									A3(
										$author$project$Components$Shared$Tableau$View$enTetes,
										colonnes,
										!_Utils_eq(selection, $elm$core$Maybe$Nothing),
										entrees))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$tbody,
							_List_Nil,
							A2(
								$elm$core$List$map,
								A2($author$project$Components$Shared$Tableau$View$ligne, colonnes, selection),
								entrees))
						]))
				]));
	});
var $author$project$Components$Shared$Tuiles$View$idDeLaTuile = F2(
	function (nom, valeur) {
		return nom + ('-' + valeur);
	});
var $author$project$Components$Shared$Tuiles$View$tuile = F2(
	function (groupe, fournie) {
		var choisie = _Utils_eq(
			groupe.ve,
			$elm$core$Maybe$Just(fournie.fm));
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('tuile'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('selected', choisie)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(
							A2($author$project$Components$Shared$Tuiles$View$idDeLaTuile, groupe.Dj, fournie.fm)),
							$rtfeldman$elm_css$Html$Styled$Attributes$name(groupe.Dj),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(fournie.fm),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(choisie),
							$rtfeldman$elm_css$Html$Styled$Events$onCheck(
							function (_v0) {
								return groupe.Eb(fournie.fm);
							})
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(fournie.h6)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(fournie.dH)
						]))
				]));
	});
var $author$project$Components$Shared$Tuiles$View$view = F2(
	function (groupe, tuiles) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$fieldset,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('tuiles')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$legend,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(groupe.Bi)
								]))
						])),
				A2(
					$elm$core$List$map,
					$author$project$Components$Shared$Tuiles$View$tuile(groupe),
					tuiles)));
	});
var $author$project$Components$Demonstration$View$exemple = F3(
	function (i18n, model, composant) {
		switch (composant) {
			case 0:
				return A2(
					$elm$core$List$map,
					A2($author$project$Components$Shared$Cartouche$View$view, 'dossier', $elm$core$Maybe$Nothing),
					A2($elm$core$List$take, 1, $author$project$Components$Demonstration$Donnees$dossiers));
			case 1:
				return _List_fromArray(
					[
						A4(
						$author$project$Components$Shared$Tableau$View$view,
						_List_Nil,
						$author$project$Components$Demonstration$View$colonnesDesDossiers(i18n),
						$elm$core$Maybe$Nothing,
						A2($elm$core$List$take, 3, $author$project$Components$Demonstration$Donnees$dossiers))
					]);
			case 2:
				return _List_fromArray(
					[
						A3($author$project$Components$Demonstration$View$versLAnnuaire, i18n, 1, 1)
					]);
			case 3:
				return _List_fromArray(
					[
						A3($author$project$Components$Demonstration$View$versLAnnuaire, i18n, 1, 0)
					]);
			case 4:
				return _List_fromArray(
					[
						A3($author$project$Components$Demonstration$View$versLAnnuaire, i18n, 1, 1)
					]);
			case 5:
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$demonstrationSectionVoirConfirmation(i18n))
							])),
						A3($author$project$Components$Demonstration$View$versLAnnuaire, i18n, 1, 1)
					]);
			case 6:
				return _List_fromArray(
					[
						$author$project$Components$Shared$Onglets$View$view(
						_List_fromArray(
							[
								{
								sO: true,
								aa: $author$project$Components$Demonstration$View$versLAncre(6),
								vW: $elm$core$Maybe$Nothing,
								Dj: $author$project$I18n$Cles$demonstrationFicheOngletSynthese(i18n)
							},
								{
								sO: false,
								aa: $author$project$Components$Demonstration$View$versLAncre(6),
								vW: $elm$core$Maybe$Nothing,
								Dj: $author$project$I18n$Cles$demonstrationFicheOngletHistorique(i18n)
							}
							]))
					]);
			case 7:
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('pills')
							]),
						A2(
							$elm$core$List$map,
							function (_v1) {
								var couleur = _v1.a;
								var libelle = _v1.b;
								return A2($author$project$Components$Shared$Tag$View$view, couleur, libelle);
							},
							$author$project$Components$Demonstration$Donnees$etats))
					]);
			case 8:
				return _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						0,
						_List_Nil,
						$author$project$I18n$Cles$demonstrationFicheEnregistrer(i18n)),
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_Nil,
						$author$project$I18n$Cles$drawerAnnuler(i18n)),
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						3,
						_List_Nil,
						$author$project$I18n$Cles$drawerAbandonAbandonner(i18n)),
						A3($author$project$Components$Demonstration$View$versLAnnuaire, i18n, 1, 0)
					]);
			case 9:
				return A2($author$project$Components$Demonstration$View$champs, i18n, model);
			case 10:
				return _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Note$View$view,
						0,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text($author$project$Components$Demonstration$Donnees$notes.AL)
									]))
							])),
						A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text($author$project$Components$Demonstration$Donnees$notes.uj)
									]))
							])),
						A2(
						$author$project$Components$Shared$Note$View$view,
						3,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text($author$project$Components$Demonstration$Donnees$notes.Ks)
									]))
							]))
					]);
			case 11:
				return _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Accordeon$View$view,
						{D8: $author$project$Components$Demonstration$Update$EtapeBasculee, Es: model.mg},
						A2(
							$elm$core$List$indexedMap,
							$author$project$Components$Demonstration$View$etape(i18n),
							$author$project$Components$Demonstration$Donnees$etapes))
					]);
			case 12:
				return _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Tuiles$View$view,
						{
							ve: A2(
								$elm$core$Maybe$andThen,
								$author$project$Components$Demonstration$View$nonVide,
								$elm$core$Maybe$Just(
									A2($author$project$Components$Demonstration$Model$saisie, $author$project$Components$Demonstration$View$idTuiles, model))),
							Bi: $author$project$I18n$Cles$demonstrationTuilesLegende(i18n),
							Dj: $author$project$Components$Demonstration$View$idTuiles,
							Eb: $author$project$Components$Demonstration$Update$Saisi($author$project$Components$Demonstration$View$idTuiles)
						},
						$author$project$Components$Demonstration$Donnees$typesDeDossier)
					]);
			case 13:
				return _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Kanban$View$view,
						'dossier',
						A2(
							$elm$core$List$map,
							function (colonne) {
								return {
									yv: $author$project$Components$Demonstration$Donnees$parEtape(colonne),
									Dj: colonne
								};
							},
							$author$project$Components$Demonstration$Donnees$etapes))
					]);
			case 14:
				return A2($elm$core$List$map, $author$project$Components$Shared$IndicateurCle$View$view, $author$project$Components$Demonstration$Donnees$indicateurs);
			case 15:
				return _List_fromArray(
					[
						$author$project$Components$Shared$BarreRepartition$View$view(
						A2(
							$elm$core$List$map,
							function (colonne) {
								return {
									Dj: colonne,
									w: $elm$core$List$length(
										$author$project$Components$Demonstration$Donnees$parEtape(colonne))
								};
							},
							$author$project$Components$Demonstration$Donnees$etapes))
					]);
			default:
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$demonstrationSectionVoirNavigation(i18n))
							]))
					]);
		}
	});
var $author$project$I18n$Cles$demonstrationSectionAccordeon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.section.accordeon', _List_Nil, 'Accordéon');
};
var $author$project$I18n$Cles$demonstrationSectionBarreRepartition = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.section.barre-repartition', _List_Nil, 'Barre de répartition');
};
var $author$project$I18n$Cles$demonstrationSectionBascule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.section.bascule', _List_Nil, 'Bascule Cartes / Tableau');
};
var $author$project$I18n$Cles$demonstrationSectionBoutons = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.section.boutons', _List_Nil, 'Boutons');
};
var $author$project$I18n$Cles$demonstrationSectionCarteAnnuaire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.section.carte-annuaire', _List_Nil, 'Carte d\'annuaire');
};
var $author$project$I18n$Cles$demonstrationSectionChamps = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.section.champs', _List_Nil, 'Champs');
};
var $author$project$I18n$Cles$demonstrationSectionConfirmation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.section.confirmation', _List_Nil, 'Boîte de confirmation');
};
var $author$project$I18n$Cles$demonstrationSectionDrawer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.section.drawer', _List_Nil, 'Drawer');
};
var $author$project$I18n$Cles$demonstrationSectionIndicateurCle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.section.indicateur-cle', _List_Nil, 'Indicateur clé');
};
var $author$project$I18n$Cles$demonstrationSectionKanban = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.section.kanban', _List_Nil, 'Kanban');
};
var $author$project$I18n$Cles$demonstrationSectionNavigation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.section.navigation', _List_Nil, 'Navigation de la suite');
};
var $author$project$I18n$Cles$demonstrationSectionNotes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.section.notes', _List_Nil, 'Notes');
};
var $author$project$I18n$Cles$demonstrationSectionOnglets = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.section.onglets', _List_Nil, 'Onglets');
};
var $author$project$I18n$Cles$demonstrationSectionSelection = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.section.selection', _List_Nil, 'Sélection et « Tout sélectionner »');
};
var $author$project$I18n$Cles$demonstrationSectionTableau = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.section.tableau', _List_Nil, 'Tableau');
};
var $author$project$I18n$Cles$demonstrationSectionTags = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.section.tags', _List_Nil, 'Tags');
};
var $author$project$I18n$Cles$demonstrationSectionTuiles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.section.tuiles', _List_Nil, 'Tuiles sélectionnables');
};
var $author$project$Components$Demonstration$View$titre = F2(
	function (i18n, composant) {
		switch (composant) {
			case 0:
				return $author$project$I18n$Cles$demonstrationSectionCarteAnnuaire(i18n);
			case 1:
				return $author$project$I18n$Cles$demonstrationSectionTableau(i18n);
			case 2:
				return $author$project$I18n$Cles$demonstrationSectionBascule(i18n);
			case 3:
				return $author$project$I18n$Cles$demonstrationSectionSelection(i18n);
			case 4:
				return $author$project$I18n$Cles$demonstrationSectionDrawer(i18n);
			case 5:
				return $author$project$I18n$Cles$demonstrationSectionConfirmation(i18n);
			case 6:
				return $author$project$I18n$Cles$demonstrationSectionOnglets(i18n);
			case 7:
				return $author$project$I18n$Cles$demonstrationSectionTags(i18n);
			case 8:
				return $author$project$I18n$Cles$demonstrationSectionBoutons(i18n);
			case 9:
				return $author$project$I18n$Cles$demonstrationSectionChamps(i18n);
			case 10:
				return $author$project$I18n$Cles$demonstrationSectionNotes(i18n);
			case 11:
				return $author$project$I18n$Cles$demonstrationSectionAccordeon(i18n);
			case 12:
				return $author$project$I18n$Cles$demonstrationSectionTuiles(i18n);
			case 13:
				return $author$project$I18n$Cles$demonstrationSectionKanban(i18n);
			case 14:
				return $author$project$I18n$Cles$demonstrationSectionIndicateurCle(i18n);
			case 15:
				return $author$project$I18n$Cles$demonstrationSectionBarreRepartition(i18n);
			default:
				return $author$project$I18n$Cles$demonstrationSectionNavigation(i18n);
		}
	});
var $author$project$Components$Demonstration$View$section = F3(
	function (i18n, model, composant) {
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id(
					$author$project$Components$Demonstration$View$ancre(composant))
				]),
			{
				fw: _List_Nil,
				fZ: A3($author$project$Components$Demonstration$View$exemple, i18n, model, composant),
				Dj: $author$project$Components$Demonstration$View$nom(composant),
				h6: A2($author$project$Components$Demonstration$View$titre, i18n, composant)
			});
	});
var $author$project$Components$Demonstration$View$composants = F3(
	function (i18n, theme, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'demonstration',
			{
				ut: A2(
					$elm$core$List$cons,
					A2($author$project$Components$Demonstration$View$etatDuTheme, i18n, theme),
					A2(
						$elm$core$List$map,
						A2($author$project$Components$Demonstration$View$section, i18n, model),
						$author$project$Components$Demonstration$View$documentes)),
				xy: _List_Nil,
				zM: _List_fromArray(
					[
						A3($author$project$Components$Demonstration$View$versLAnnuaire, i18n, 1, 0),
						A3($author$project$Components$Demonstration$View$versLAnnuaire, i18n, 0, 1)
					]),
				AK: false,
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_Nil,
						zE: _List_Nil,
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$demonstrationTitre(i18n)
					})
			});
	});
var $author$project$Components$Demonstration$Donnees$villes = _List_fromArray(
	['Lyon', 'Nantes', 'Lille', 'Bordeaux']);
var $author$project$Components$Demonstration$Donnees$partiePrenante = function (rang) {
	var id = 'pp-' + $elm$core$String$fromInt(rang);
	return {
		aa: $elm$core$Maybe$Just(
			$author$project$Routes$Route$toString(
				A3($author$project$Routes$Route$DemonstrationFiche, 0, id, 0))),
		Aq: id,
		m9: $elm$core$Maybe$Just(
			$elm$core$String$fromInt(
				A2($elm$core$Basics$modBy, 4, rang)) + ' dossiers'),
		gL: _List_fromArray(
			[
				_Utils_Tuple2(
				'Email',
				'contact' + ($elm$core$String$fromInt(rang) + '@exemple.test')),
				_Utils_Tuple2(
				'Ville',
				A3($author$project$Components$Demonstration$Donnees$auRang, '', rang, $author$project$Components$Demonstration$Donnees$villes))
			]),
		ry: _List_fromArray(
			[
				A3(
				$author$project$Components$Demonstration$Donnees$auRang,
				_Utils_Tuple2(3, ''),
				rang,
				$author$project$Components$Demonstration$Donnees$roles)
			]),
		rz: _List_Nil,
		h6: $author$project$Components$Demonstration$Donnees$personne(rang)
	};
};
var $author$project$Components$Demonstration$Donnees$entrees = function (annuaire) {
	if (!annuaire) {
		return A2(
			$elm$core$List$map,
			$author$project$Components$Demonstration$Donnees$partiePrenante,
			A2($elm$core$List$range, 1, 50));
	} else {
		return $author$project$Components$Demonstration$Donnees$dossiers;
	}
};
var $author$project$Components$Demonstration$Donnees$entree = F2(
	function (annuaire, id) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (candidate) {
					return _Utils_eq(candidate.Aq, id);
				},
				$author$project$Components$Demonstration$Donnees$entrees(annuaire)));
	});
var $author$project$I18n$Cles$demonstrationLienRetour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.lien-retour', _List_Nil, 'Aller à la page de démonstration');
};
var $author$project$I18n$Cles$introuvableTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'introuvable.titre', _List_Nil, 'Page introuvable');
};
var $author$project$Components$Shared$Introuvable$View$view = F2(
	function (i18n, lien) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id('page-introuvable')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('top')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h1,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$introuvableTitre(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('bottom')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href(lien.aa)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(lien.Bl)
								]))
						]))
				]));
	});
var $author$project$Components$Demonstration$View$introuvable = function (i18n) {
	return A2(
		$author$project$Components$Shared$Introuvable$View$view,
		i18n,
		{
			aa: $author$project$Routes$Route$adresseDemonstration,
			Bl: $author$project$I18n$Cles$demonstrationLienRetour(i18n)
		});
};
var $author$project$Components$Demonstration$Update$AnnuaireMsg = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Shared$Page$View$annuaire = function (contenu) {
	return _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id('filters'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('hidden', contenu.mH)
						]))
				]),
			contenu.mG),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
				]),
			contenu.nW)
		]);
};
var $author$project$Components$Demonstration$Annuaire$View$creation = function (annuaire) {
	if (!annuaire) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Components$Demonstration$Model$dialogueOuvert = F2(
	function (route, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (formulaire) {
					return $author$project$Components$Shared$Drawer$Model$estOuvert(
						A2($author$project$Components$Demonstration$Model$drawer, formulaire, model));
				},
				$author$project$Components$Demonstration$Model$formulaireDeLaPage(route)));
	});
var $author$project$Components$Shared$Annuaire$View$PaginationEnPresentation = {$: 0};
var $author$project$Components$Shared$Annuaire$View$RechercheEnPresentation = {$: 0};
var $author$project$I18n$Cles$annuaireAnnulerLaSelection = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'annuaire.annuler-la-selection', _List_Nil, 'Annuler la sélection');
};
var $author$project$I18n$Cles$demonstrationSelectionExporter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.selection.exporter', _List_Nil, 'Exporter la sélection');
};
var $author$project$Components$Demonstration$Annuaire$View$entite = function (annuaire) {
	if (!annuaire) {
		return 'partie-prenante';
	} else {
		return 'dossier';
	}
};
var $author$project$Components$Demonstration$Model$idDeclencheur = function (formulaire) {
	switch (formulaire) {
		case 0:
			return 'demonstration-partie-prenante-creer-declencheur';
		case 1:
			return 'demonstration-dossier-creer-declencheur';
		default:
			return 'demonstration-fiche-modifier-declencheur';
	}
};
var $author$project$I18n$Cles$annuaireCompteurAffichees = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'annuaire.compteur.affichees',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'compteur',
					$author$project$I18n$Traductions$Chaine(p.fV)),
					_Utils_Tuple2(
					'debut',
					$author$project$I18n$Traductions$Chaine(p.ku)),
					_Utils_Tuple2(
					'fin',
					$author$project$I18n$Traductions$Chaine(p.mI))
				]),
			p.fV + (' · ' + (p.ku + ('–' + (p.mI + ' affichées')))));
	});
var $author$project$I18n$Cles$annuaireSelectionDeLaPage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'annuaire.selection.de-la-page',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiche de cette page sélectionnée') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiches de cette page sélectionnées'));
	});
var $author$project$I18n$Cles$annuaireSelectionDuFiltre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'annuaire.selection.du-filtre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? 'La fiche du filtre est sélectionnée' : ('Les ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiches du filtre sont sélectionnées')));
	});
var $author$project$I18n$Cles$annuaireSelectionFiches = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'annuaire.selection.fiches',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiche sélectionnée') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiches sélectionnées'));
	});
var $author$project$I18n$Cles$demonstrationDossiersRecherche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.dossiers.recherche', _List_Nil, 'Nom du dossier, responsable…');
};
var $author$project$I18n$Cles$demonstrationDossiersSelection = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'demonstration.dossiers.selection',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' dossier sélectionné') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' dossiers sélectionnés'));
	});
var $author$project$I18n$Cles$demonstrationDossiersToutLeFiltre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'demonstration.dossiers.tout-le-filtre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Sélectionner les ' + (p.w + ' dossiers'));
	});
var $author$project$I18n$Cles$demonstrationPartiesPrenantesColonneIndicateur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.parties-prenantes.colonne.indicateur', _List_Nil, 'Dossiers');
};
var $author$project$I18n$Cles$demonstrationPartiesPrenantesColonneTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.parties-prenantes.colonne.titre', _List_Nil, 'Nom');
};
var $author$project$I18n$Cles$demonstrationPartiesPrenantesCompteur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'demonstration.parties-prenantes.compteur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' partie prenante') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' parties prenantes'));
	});
var $author$project$I18n$Cles$demonstrationPartiesPrenantesRecherche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.parties-prenantes.recherche', _List_Nil, 'Nom, email, identifiant légal…');
};
var $author$project$I18n$Cles$demonstrationPartiesPrenantesToutLeFiltre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'demonstration.parties-prenantes.tout-le-filtre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Sélectionner les ' + (p.w + ' parties prenantes'));
	});
var $author$project$I18n$Cles$demonstrationSelectionCase = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'demonstration.selection.case',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'titre',
					$author$project$I18n$Traductions$Chaine(p.h6))
				]),
			'Sélectionner ' + p.h6);
	});
var $author$project$Components$Demonstration$Donnees$total = function (annuaire) {
	if (!annuaire) {
		return 1284;
	} else {
		return $elm$core$List$length($author$project$Components$Demonstration$Donnees$dossiers);
	}
};
var $author$project$Components$Demonstration$Annuaire$View$libelles = F2(
	function (i18n, annuaire) {
		var nombre = $author$project$Components$Demonstration$Donnees$total(annuaire);
		var affichees = $elm$core$List$length(
			$author$project$Components$Demonstration$Donnees$entrees(annuaire));
		if (!annuaire) {
			return {
				jA: function (nom) {
					return A2(
						$author$project$I18n$Cles$demonstrationSelectionCase,
						i18n,
						{h6: nom});
				},
				j1: {
					m9: $elm$core$Maybe$Just(
						$author$project$I18n$Cles$demonstrationPartiesPrenantesColonneIndicateur(i18n)),
					ry: $author$project$I18n$Cles$demonstrationPartiesPrenantesColonneTags(i18n),
					h6: $author$project$I18n$Cles$demonstrationPartiesPrenantesColonneTitre(i18n)
				},
				fV: A2(
					$author$project$I18n$Cles$annuaireCompteurAffichees,
					i18n,
					{
						fV: A2(
							$author$project$I18n$Cles$demonstrationPartiesPrenantesCompteur,
							i18n,
							{w: nombre}),
						ku: A2(
							$author$project$I18n$Nombre$formater,
							$author$project$I18n$Traductions$langue(i18n),
							1),
						mI: A2(
							$author$project$I18n$Nombre$formater,
							$author$project$I18n$Traductions$langue(i18n),
							affichees)
					}),
				hC: $author$project$I18n$Cles$demonstrationPartiesPrenantesRecherche(i18n),
				q3: function (selectionnees) {
					return A2(
						$author$project$I18n$Cles$annuaireSelectionFiches,
						i18n,
						{w: selectionnees});
				},
				q4: function (selectionnees) {
					return A2(
						$author$project$I18n$Cles$annuaireSelectionDeLaPage,
						i18n,
						{w: selectionnees});
				},
				q5: function (selectionnees) {
					return A2(
						$author$project$I18n$Cles$annuaireSelectionDuFiltre,
						i18n,
						{w: selectionnees});
				},
				rN: A2(
					$author$project$I18n$Cles$demonstrationPartiesPrenantesToutLeFiltre,
					i18n,
					{
						w: A2(
							$author$project$I18n$Nombre$formater,
							$author$project$I18n$Traductions$langue(i18n),
							nombre)
					})
			};
		} else {
			return {
				jA: function (nom) {
					return A2(
						$author$project$I18n$Cles$demonstrationSelectionCase,
						i18n,
						{h6: nom});
				},
				j1: {
					m9: $elm$core$Maybe$Just(
						$author$project$I18n$Cles$demonstrationDossiersColonneIndicateur(i18n)),
					ry: $author$project$I18n$Cles$demonstrationDossiersColonneTags(i18n),
					h6: $author$project$I18n$Cles$demonstrationDossiersColonneTitre(i18n)
				},
				fV: A2(
					$author$project$I18n$Cles$demonstrationDossiersCompteur,
					i18n,
					{w: nombre}),
				hC: $author$project$I18n$Cles$demonstrationDossiersRecherche(i18n),
				q3: function (selectionnees) {
					return A2(
						$author$project$I18n$Cles$demonstrationDossiersSelection,
						i18n,
						{w: selectionnees});
				},
				q4: function (selectionnees) {
					return A2(
						$author$project$I18n$Cles$annuaireSelectionDeLaPage,
						i18n,
						{w: selectionnees});
				},
				q5: function (selectionnees) {
					return A2(
						$author$project$I18n$Cles$annuaireSelectionDuFiltre,
						i18n,
						{w: selectionnees});
				},
				rN: A2(
					$author$project$I18n$Cles$demonstrationDossiersToutLeFiltre,
					i18n,
					{
						w: A2(
							$author$project$I18n$Nombre$formater,
							$author$project$I18n$Traductions$langue(i18n),
							nombre)
					})
			};
		}
	});
var $author$project$I18n$Cles$demonstrationDossiersCreer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.dossiers.creer', _List_Nil, 'Nouveau dossier');
};
var $author$project$I18n$Cles$demonstrationDossiersCreerAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.dossiers.creer.action', _List_Nil, 'Créer le dossier');
};
var $author$project$I18n$Cles$demonstrationPartiesPrenantesCreer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.parties-prenantes.creer', _List_Nil, 'Nouvelle partie prenante');
};
var $author$project$I18n$Cles$demonstrationPartiesPrenantesCreerAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.parties-prenantes.creer.action', _List_Nil, 'Créer la partie prenante');
};
var $author$project$I18n$Cles$demonstrationPartiesPrenantesCreerNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.parties-prenantes.creer.nom', _List_Nil, 'Nom');
};
var $author$project$Components$Demonstration$Annuaire$View$libellesDeCreation = F2(
	function (i18n, annuaire) {
		if (!annuaire) {
			return {
				fs: $author$project$I18n$Cles$demonstrationPartiesPrenantesCreerAction(i18n),
				uN: $author$project$I18n$Cles$demonstrationPartiesPrenantesCreerNom(i18n),
				h6: $author$project$I18n$Cles$demonstrationPartiesPrenantesCreer(i18n)
			};
		} else {
			return {
				fs: $author$project$I18n$Cles$demonstrationDossiersCreerAction(i18n),
				uN: $author$project$I18n$Cles$demonstrationDossiersCreerNom(i18n),
				h6: $author$project$I18n$Cles$demonstrationDossiersCreer(i18n)
			};
		}
	});
var $author$project$Components$Demonstration$Annuaire$View$donnees = F2(
	function (i18n, annuaire) {
		var declencheur = $author$project$Components$Demonstration$Model$idDeclencheur(
			$author$project$Components$Demonstration$Annuaire$View$creation(annuaire));
		return {
			sQ: _List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
						]),
					$author$project$I18n$Cles$demonstrationSelectionExporter(i18n))
				]),
			ue: true,
			uf: true,
			uh: true,
			ui: true,
			uH: false,
			u7: false,
			vG: _List_Nil,
			wl: _List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					0,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id(declencheur),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							A2(
								$author$project$Components$Demonstration$Update$DrawerMsg,
								$author$project$Components$Demonstration$Annuaire$View$creation(annuaire),
								$author$project$Components$Shared$Drawer$Update$Ouvrir(declencheur)))
						]),
					A2($author$project$Components$Demonstration$Annuaire$View$libellesDeCreation, i18n, annuaire).h6)
				]),
			xs: $author$project$I18n$Cles$annuaireAnnulerLaSelection(i18n),
			yt: $author$project$Components$Demonstration$Annuaire$View$entite(annuaire),
			yv: $author$project$Components$Demonstration$Donnees$entrees(annuaire),
			mG: _List_Nil,
			R: A2($author$project$Components$Demonstration$Annuaire$View$libelles, i18n, annuaire),
			Cs: _List_Nil,
			EB: $elm$core$Maybe$Nothing,
			EH: $author$project$Components$Shared$Annuaire$View$PaginationEnPresentation,
			GS: $elm$core$Maybe$Nothing,
			hC: $author$project$Components$Shared$Annuaire$View$RechercheEnPresentation,
			Iz: false,
			JE: $author$project$Components$Demonstration$Donnees$total(annuaire),
			rS: _List_Nil
		};
	});
var $author$project$Components$Shared$Annuaire$Update$FiltresMasquesChoisis = function (a) {
	return {$: 5, a: a};
};
var $author$project$I18n$Cles$annuaireFiltresMasquer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'annuaire.filtres.masquer', _List_Nil, 'Masquer');
};
var $author$project$I18n$Cles$annuaireFiltresTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'annuaire.filtres.titre', _List_Nil, 'Filtres');
};
var $author$project$I18n$Cles$annuaireRecherche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'annuaire.recherche', _List_Nil, 'Rechercher dans l\'annuaire');
};
var $author$project$Components$Shared$Annuaire$View$saisie = function (recherche) {
	if (!recherche.$) {
		return _List_Nil;
	} else {
		var tenue = recherche.a;
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$value(tenue.fm),
				$rtfeldman$elm_css$Html$Styled$Events$onInput(tenue.hg)
			]);
	}
};
var $author$project$Components$Shared$Svg$svgHideFilters = A3($author$project$Components$Shared$Svg$icone, 'hide-filters', 'M16.2178 3L7.78313 3C4.83503 3 3 5.08119 3 8.02638V15.9736C3 18.9188 4.83503 21 7.78411 21H16.2178C19.1659 21 21 18.9188 21 15.9736V8.02638C21 5.08119 19.1572 3 16.2178 3Z M7 12.0018L10 9M7 12.0018L10 15M7 12.0018H14.9211 M15 3.06641L15 20.9414', _List_Nil);
var $author$project$Components$Shared$Annuaire$View$filtres = F3(
	function (i18n, versMsg, donnees) {
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$annuaireFiltresTitre(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('masquer'),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-label',
							$author$project$I18n$Cles$annuaireFiltresMasquer(i18n)),
							$rtfeldman$elm_css$Html$Styled$Attributes$title(
							$author$project$I18n$Cles$annuaireFiltresMasquer(i18n)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							versMsg(
								$author$project$Components$Shared$Annuaire$Update$FiltresMasquesChoisis(true)))
						]),
					_List_fromArray(
						[$author$project$Components$Shared$Svg$svgHideFilters])),
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_Utils_ap(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('search'),
								$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(donnees.R.hC),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-label',
								$author$project$I18n$Cles$annuaireRecherche(i18n))
							]),
						$author$project$Components$Shared$Annuaire$View$saisie(donnees.hC)),
					_List_Nil)
				]),
			donnees.mG);
	});
var $author$project$Components$Shared$Annuaire$Update$SelectionEffacee = {$: 3};
var $author$project$I18n$Cles$annuaireDeselectionner = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'annuaire.deselectionner', _List_Nil, 'Désélectionner');
};
var $author$project$Components$Shared$Annuaire$View$proposee = F2(
	function (servie, action) {
		return servie ? _List_fromArray(
			[action]) : _List_Nil;
	});
var $author$project$Components$Shared$Annuaire$View$fixed = F4(
	function (i18n, versMsg, donnees, model) {
		var nombre = A2($author$project$Components$Shared$Annuaire$Model$nombreSelectionne, donnees.JE, model);
		return _Utils_ap(
			A2(
				$author$project$Components$Shared$Annuaire$View$proposee,
				donnees.uh && (!donnees.Iz),
				A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('selection'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('hidden', !nombre)
								]))
						]),
					_Utils_ap(
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('nombre')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										donnees.R.q3(nombre))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('deselectionner'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										versMsg($author$project$Components$Shared$Annuaire$Update$SelectionEffacee))
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$annuaireDeselectionner(i18n))
											]))
									]))
							]),
						donnees.sQ))),
			donnees.wl);
	});
var $author$project$I18n$Cles$annuaireEffacerLaSelection = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'annuaire.effacer-la-selection', _List_Nil, 'Effacer la sélection');
};
var $author$project$Components$Shared$Annuaire$View$bandeauDeLaPage = F4(
	function (i18n, versMsg, donnees, propose) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('bandeau-selection'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('hidden', !propose)
						]))
				]),
			function () {
				switch (propose) {
					case 0:
						return _List_Nil;
					case 1:
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										versMsg($author$project$Components$Shared$Annuaire$Update$FiltreEntierDemande))
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(donnees.R.rN)
											]))
									]))
							]);
					default:
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										versMsg($author$project$Components$Shared$Annuaire$Update$SelectionEffacee))
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$annuaireEffacerLaSelection(i18n))
											]))
									]))
							]);
				}
			}());
	});
var $author$project$Components$Shared$Annuaire$View$barreDeSelection = F4(
	function (versMsg, donnees, model, propose) {
		var nombre = A2($author$project$Components$Shared$Annuaire$Model$nombreSelectionne, donnees.JE, model);
		var deselectionner = A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('deselectionner'),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					versMsg($author$project$Components$Shared$Annuaire$Update$SelectionEffacee))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(donnees.xs)
						]))
				]));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('bandeau-selection'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('barre'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('hidden', !nombre),
							_Utils_Tuple2('case-en-tete', donnees.uH),
							_Utils_Tuple2(
							'warn',
							!_Utils_eq(donnees.GS, $elm$core$Maybe$Nothing))
						]))
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nombre')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							function () {
								switch (propose) {
									case 1:
										return donnees.R.q4(nombre);
									case 2:
										return donnees.R.q5(nombre);
									default:
										return donnees.R.q3(nombre);
								}
							}())
						])),
				_Utils_ap(
					function () {
						var _v1 = donnees.GS;
						if (!_v1.$) {
							var raison = _v1.a;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('raison')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(raison)
										]))
								]);
						} else {
							return _List_Nil;
						}
					}(),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('liens')
								]),
							_Utils_ap(
								((propose === 1) && (donnees.R.rN !== '')) ? _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$button,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												versMsg($author$project$Components$Shared$Annuaire$Update$FiltreEntierDemande))
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(donnees.R.rN)
													]))
											]))
									]) : _List_Nil,
								A2($author$project$Components$Shared$Annuaire$View$proposee, !donnees.uH, deselectionner))),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
								]),
							_Utils_ap(
								donnees.sQ,
								A2($author$project$Components$Shared$Annuaire$View$proposee, donnees.uH, deselectionner)))
						]))));
	});
var $author$project$Components$Shared$Annuaire$View$bandeau = F4(
	function (i18n, versMsg, donnees, model) {
		return donnees.Iz ? A4(
			$author$project$Components$Shared$Annuaire$View$barreDeSelection,
			versMsg,
			donnees,
			model,
			A2($author$project$Components$Shared$Annuaire$Model$bandeau, donnees.JE, model)) : A4(
			$author$project$Components$Shared$Annuaire$View$bandeauDeLaPage,
			i18n,
			versMsg,
			donnees,
			A2($author$project$Components$Shared$Annuaire$Model$bandeau, donnees.JE, model));
	});
var $author$project$I18n$Cles$annuaireColonnes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'annuaire.colonnes', _List_Nil, 'Colonnes');
};
var $author$project$I18n$Cles$annuaireFiltresAfficher = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'annuaire.filtres.afficher', _List_Nil, 'Filtres');
};
var $author$project$I18n$Cles$annuaireTrier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'annuaire.trier', _List_Nil, 'Trier par');
};
var $author$project$I18n$Cles$annuaireVueCartes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'annuaire.vue.cartes', _List_Nil, 'Cartes');
};
var $author$project$I18n$Cles$annuaireVueTableau = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'annuaire.vue.tableau', _List_Nil, 'Tableau');
};
var $author$project$Components$Shared$Annuaire$Update$VueChoisie = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Shared$Annuaire$View$boutonDeVue = F4(
	function (versMsg, model, vue, libelle) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-pressed',
					_Utils_eq(model.io, vue) ? 'true' : 'false'),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					versMsg(
						$author$project$Components$Shared$Annuaire$Update$VueChoisie(vue)))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						]))
				]));
	});
var $author$project$Components$Shared$Svg$svgShowFilters = A3($author$project$Components$Shared$Svg$icone, 'show-filters', 'M7.78216 3L16.2169 3C19.165 3 21 5.08119 21 8.02638V15.9736C21 18.9188 19.165 21 16.2159 21H7.78216C4.83405 21 3 18.9188 3 15.9736L3 8.02638C3 5.08119 4.84281 3 7.78216 3Z M17 12.0018L14 9M17 12.0018L14 15M17 12.0018H9.07897 M9 3.06641L9 20.9414', _List_Nil);
var $author$project$Components$Shared$Annuaire$Update$PageSelectionnee = function (a) {
	return {$: 1, a: a};
};
var $author$project$I18n$Cles$annuaireToutSelectionner = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'annuaire.tout-selectionner', _List_Nil, 'Tout sélectionner');
};
var $author$project$Components$Shared$Annuaire$Model$estCochee = F2(
	function (id, model) {
		return A2($elm$core$Set$member, id, model.vv);
	});
var $author$project$Components$Shared$Annuaire$View$toutSelectionner = F4(
	function (i18n, versMsg, donnees, model) {
		var ids = A2(
			$elm$core$List$map,
			function ($) {
				return $.Aq;
			},
			donnees.yv);
		return donnees.uH ? A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('tout-selectionner')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-label',
							$author$project$I18n$Cles$annuaireToutSelectionner(i18n)),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(
							(!$elm$core$List$isEmpty(ids)) && A2(
								$elm$core$List$all,
								function (id) {
									return A2($author$project$Components$Shared$Annuaire$Model$estCochee, id, model);
								},
								ids)),
							$rtfeldman$elm_css$Html$Styled$Events$onCheck(
							function (cochee) {
								return versMsg(
									cochee ? $author$project$Components$Shared$Annuaire$Update$PageSelectionnee(ids) : $author$project$Components$Shared$Annuaire$Update$SelectionEffacee);
							})
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$annuaireToutSelectionner(i18n))
						]))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('tout-selectionner'),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					versMsg(
						$author$project$Components$Shared$Annuaire$Update$PageSelectionnee(ids)))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$annuaireToutSelectionner(i18n))
						]))
				]));
	});
var $author$project$Components$Shared$Annuaire$View$vueMontree = F2(
	function (donnees, model) {
		return donnees.ue ? model.io : 0;
	});
var $author$project$Components$Shared$Annuaire$View$enTete = F4(
	function (i18n, versMsg, donnees, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('list-header')
				]),
			_Utils_ap(
				A2(
					$author$project$Components$Shared$Annuaire$View$proposee,
					donnees.uh && donnees.uH,
					A4($author$project$Components$Shared$Annuaire$View$toutSelectionner, i18n, versMsg, donnees, model)),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('count')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(donnees.R.fV)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('afficher-filtres'),
									$rtfeldman$elm_css$Html$Styled$Attributes$title(
									$author$project$I18n$Cles$annuaireFiltresAfficher(i18n)),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									versMsg(
										$author$project$Components$Shared$Annuaire$Update$FiltresMasquesChoisis(false)))
								]),
							_List_fromArray(
								[
									$author$project$Components$Shared$Svg$svgShowFilters,
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$annuaireFiltresAfficher(i18n))
										]))
								]))
						]),
					_Utils_ap(
						A2(
							$author$project$Components$Shared$Annuaire$View$proposee,
							donnees.ue,
							A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('bascule')
									]),
								_List_fromArray(
									[
										A4(
										$author$project$Components$Shared$Annuaire$View$boutonDeVue,
										versMsg,
										model,
										0,
										$author$project$I18n$Cles$annuaireVueCartes(i18n)),
										A4(
										$author$project$Components$Shared$Annuaire$View$boutonDeVue,
										versMsg,
										model,
										1,
										$author$project$I18n$Cles$annuaireVueTableau(i18n))
									]))),
						_Utils_ap(
							A2(
								$author$project$Components$Shared$Annuaire$View$proposee,
								donnees.ui,
								A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('trier'),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$annuaireTrier(i18n))
												]))
										]))),
							_Utils_ap(
								donnees.rS,
								_Utils_ap(
									A2(
										$author$project$Components$Shared$Annuaire$View$proposee,
										donnees.uf,
										A2(
											$rtfeldman$elm_css$Html$Styled$button,
											_Utils_ap(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
														$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Shared$Annuaire$Model$idDuDeclencheurDeColonnes),
														$rtfeldman$elm_css$Html$Styled$Attributes$class('colonnes'),
														$rtfeldman$elm_css$Html$Styled$Attributes$classList(
														_List_fromArray(
															[
																_Utils_Tuple2(
																'hidden',
																A2($author$project$Components$Shared$Annuaire$View$vueMontree, donnees, model) !== 1)
															]))
													]),
												A2(
													$elm$core$Maybe$withDefault,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
														]),
													A2(
														$elm$core$Maybe$map,
														function (ouvrir) {
															return _List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Events$onClick(ouvrir)
																]);
														},
														donnees.EB))),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$annuaireColonnes(i18n))
														]))
												]))),
									A2(
										$author$project$Components$Shared$Annuaire$View$proposee,
										donnees.uh && (!donnees.uH),
										A4($author$project$Components$Shared$Annuaire$View$toutSelectionner, i18n, versMsg, donnees, model)))))))));
	});
var $author$project$Components$Shared$Annuaire$Update$EntreeCochee = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Shared$Annuaire$View$caseDEntree = F4(
	function (versMsg, libelles, model, entree) {
		return {
			vt: A2($author$project$Components$Shared$Annuaire$Model$estCochee, entree.Aq, model),
			Bl: libelles.jA(entree.h6),
			D9: A2(
				$elm$core$Basics$composeR,
				$author$project$Components$Shared$Annuaire$Update$EntreeCochee(entree.Aq),
				versMsg)
		};
	});
var $author$project$Components$Shared$Tableau$View$ligneParColonnes = F3(
	function (colonnes, selection, entree) {
		var fournie = A2(
			$elm$core$Maybe$map,
			function (pour) {
				return pour(entree);
			},
			selection);
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'selected',
							A2(
								$elm$core$Maybe$withDefault,
								false,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.vt;
									},
									fournie)))
						]))
				]),
			_Utils_ap(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $author$project$Components$Shared$Tableau$View$caseDeLigne, fournie)),
				A2(
					$elm$core$List$map,
					function (colonne) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$td,
							_List_Nil,
							_List_fromArray(
								[
									colonne.uM(entree)
								]));
					},
					colonnes)));
	});
var $author$project$Components$Shared$Tableau$View$parColonnes = F4(
	function (attributs, colonnes, selection, entrees) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau'),
				attributs),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$table,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									_Utils_ap(
										(!_Utils_eq(selection, $elm$core$Maybe$Nothing)) ? _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$td,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('selection')
													]),
												_List_Nil)
											]) : _List_Nil,
										A2(
											$elm$core$List$map,
											function (colonne) {
												return A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(colonne.Bl)
														]));
											},
											colonnes)))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$tbody,
							_List_Nil,
							A2(
								$elm$core$List$map,
								A2($author$project$Components$Shared$Tableau$View$ligneParColonnes, colonnes, selection),
								entrees))
						]))
				]));
	});
var $author$project$Components$Shared$Tableau$View$visibles = F2(
	function (choix, colonnes) {
		if (choix.$ === 1) {
			return A2(
				$elm$core$List$filter,
				function ($) {
					return $.f5;
				},
				colonnes);
		} else {
			var ids = choix.a;
			return _Utils_ap(
				A2(
					$elm$core$List$filter,
					function ($) {
						return $.he;
					},
					colonnes),
				A2(
					$elm$core$List$filterMap,
					function (id) {
						return $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (colonne) {
									return _Utils_eq(colonne.Aq, id) && (!colonne.he);
								},
								colonnes));
					},
					ids));
		}
	});
var $author$project$Components$Shared$Annuaire$View$tableau = F3(
	function (donnees, model, selection) {
		var attributs = _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'hidden',
						A2($author$project$Components$Shared$Annuaire$View$vueMontree, donnees, model) !== 1)
					]))
			]);
		return $elm$core$List$isEmpty(donnees.vG) ? A4($author$project$Components$Shared$Tableau$View$view, attributs, donnees.R.j1, selection, donnees.yv) : A4(
			$author$project$Components$Shared$Tableau$View$parColonnes,
			attributs,
			A2($author$project$Components$Shared$Tableau$View$visibles, model.j1, donnees.vG),
			selection,
			donnees.yv);
	});
var $author$project$Components$Shared$Annuaire$View$entrees = F3(
	function (versMsg, donnees, model) {
		var selection = donnees.uh ? $elm$core$Maybe$Just(
			A3($author$project$Components$Shared$Annuaire$View$caseDEntree, versMsg, donnees.R, model)) : $elm$core$Maybe$Nothing;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('list'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('loading', donnees.u7)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-busy',
					donnees.u7 ? 'true' : 'false')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('cartes'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'hidden',
									!(!A2($author$project$Components$Shared$Annuaire$View$vueMontree, donnees, model)))
								]))
						]),
					A2(
						$elm$core$List$map,
						function (entree) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('item')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Components$Shared$Cartouche$View$view,
										donnees.yt,
										A2(
											$elm$core$Maybe$map,
											function (pour) {
												return pour(entree);
											},
											selection),
										entree)
									]));
						},
						donnees.yv)),
					A3($author$project$Components$Shared$Annuaire$View$tableau, donnees, model, selection)
				]));
	});
var $author$project$Components$Shared$Annuaire$View$liste = F4(
	function (i18n, versMsg, donnees, model) {
		return _Utils_ap(
			_List_fromArray(
				[
					A4($author$project$Components$Shared$Annuaire$View$enTete, i18n, versMsg, donnees, model)
				]),
			_Utils_ap(
				donnees.uh ? _List_fromArray(
					[
						A4($author$project$Components$Shared$Annuaire$View$bandeau, i18n, versMsg, donnees, model)
					]) : _List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('message')
							]),
						donnees.Cs),
						A3($author$project$Components$Shared$Annuaire$View$entrees, versMsg, donnees, model),
						A2($author$project$Components$Shared$Annuaire$View$pagination, i18n, donnees.EH)
					])));
	});
var $author$project$Components$Demonstration$Annuaire$View$racine = function (annuaire) {
	if (!annuaire) {
		return 'demonstration-parties-prenantes-list';
	} else {
		return 'demonstration-dossiers-list';
	}
};
var $author$project$I18n$Cles$demonstrationAnnuaireDossiers = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.annuaire.dossiers', _List_Nil, 'Dossiers');
};
var $author$project$I18n$Cles$demonstrationAnnuairePartiesPrenantes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.annuaire.parties-prenantes', _List_Nil, 'Parties prenantes');
};
var $author$project$Components$Demonstration$Annuaire$View$titre = F2(
	function (i18n, annuaire) {
		if (!annuaire) {
			return $author$project$I18n$Cles$demonstrationAnnuairePartiesPrenantes(i18n);
		} else {
			return $author$project$I18n$Cles$demonstrationAnnuaireDossiers(i18n);
		}
	});
var $author$project$Components$Demonstration$Update$Valide = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Demonstration$Drawer$View$view = F4(
	function (i18n, formulaire, libelles, model) {
		var idChamp = $author$project$Components$Demonstration$Model$idChamp(formulaire);
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Demonstration$Update$DrawerMsg(formulaire),
			{
				fs: {
					sR: true,
					Bl: libelles.fs,
					C$: $author$project$Components$Demonstration$Update$Valide(formulaire)
				},
				fZ: _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Champ$View$texte,
						{go: $elm$core$Maybe$Nothing, Aq: idChamp, Bl: libelles.uN, he: false},
						{
							hg: $author$project$Components$Demonstration$Update$Saisi(idChamp),
							fm: A2($author$project$Components$Demonstration$Model$saisie, idChamp, model)
						})
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: libelles.h6
			},
			A2($author$project$Components$Demonstration$Model$drawer, formulaire, model));
	});
var $author$project$Components$Demonstration$Annuaire$View$view = F3(
	function (i18n, annuaire, model) {
		var versMsg = $author$project$Components$Demonstration$Update$AnnuaireMsg(annuaire);
		var fournies = A2($author$project$Components$Demonstration$Annuaire$View$donnees, i18n, annuaire);
		var etat = A2($author$project$Components$Demonstration$Model$annuaire, annuaire, model);
		return A2(
			$author$project$Components$Shared$Page$View$page,
			$author$project$Components$Demonstration$Annuaire$View$racine(annuaire),
			{
				ut: $author$project$Components$Shared$Page$View$annuaire(
					{
						mG: A3($author$project$Components$Shared$Annuaire$View$filtres, i18n, versMsg, fournies),
						mH: etat.mH,
						nW: A4($author$project$Components$Shared$Annuaire$View$liste, i18n, versMsg, fournies, etat)
					}),
				xy: _List_fromArray(
					[
						A4(
						$author$project$Components$Demonstration$Drawer$View$view,
						i18n,
						$author$project$Components$Demonstration$Annuaire$View$creation(annuaire),
						A2($author$project$Components$Demonstration$Annuaire$View$libellesDeCreation, i18n, annuaire),
						model)
					]),
				zM: A4($author$project$Components$Shared$Annuaire$View$fixed, i18n, versMsg, fournies, etat),
				AK: A2(
					$author$project$Components$Demonstration$Model$dialogueOuvert,
					$author$project$Routes$Route$DemonstrationAnnuaire(annuaire),
					model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_Nil,
						zE: _List_Nil,
						Ef: _List_Nil,
						h6: A2($author$project$Components$Demonstration$Annuaire$View$titre, i18n, annuaire)
					})
			});
	});
var $author$project$I18n$Cles$demonstrationFicheHistoriqueVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.fiche.historique.vide', _List_Nil, 'Aucun événement pour cette fiche de démonstration.');
};
var $author$project$I18n$Cles$demonstrationFicheInformations = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.fiche.informations', _List_Nil, 'Informations');
};
var $author$project$Components$Demonstration$Fiche$View$contenu = F3(
	function (i18n, entree, onglet) {
		if (!onglet) {
			return A2(
				$author$project$Components$Shared$Page$View$section,
				_List_Nil,
				{
					fw: _List_Nil,
					fZ: _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('infos')
								]),
							A2(
								$elm$core$List$map,
								function (_v1) {
									var libelle = _v1.a;
									var valeur = _v1.b;
									return A2(
										$rtfeldman$elm_css$Html$Styled$li,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(libelle)
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$strong,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(valeur)
													]))
											]));
								},
								entree.gL))
						]),
					Dj: 'informations',
					h6: $author$project$I18n$Cles$demonstrationFicheInformations(i18n)
				});
		} else {
			return A2(
				$author$project$Components$Shared$Page$View$section,
				_List_Nil,
				{
					fw: _List_Nil,
					fZ: _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$demonstrationFicheHistoriqueVide(i18n))
								]))
						]),
					Dj: 'historique',
					h6: $author$project$I18n$Cles$demonstrationFicheOngletHistorique(i18n)
				});
		}
	});
var $author$project$Components$Demonstration$Fiche$View$declencheur = $author$project$Components$Demonstration$Model$idDeclencheur(2);
var $author$project$I18n$Cles$demonstrationFicheContexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.fiche.contexte', _List_Nil, 'Contexte');
};
var $author$project$I18n$Cles$demonstrationFicheModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.fiche.modifier', _List_Nil, 'Modifier');
};
var $author$project$I18n$Cles$demonstrationFicheModifierTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.fiche.modifier.titre', _List_Nil, 'Modifier la fiche');
};
var $author$project$I18n$Cles$demonstrationFicheNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'demonstration.fiche.note', _List_Nil, 'Fiche à données fictives : rien n\'est enregistré.');
};
var $author$project$Components$Demonstration$Fiche$View$lienDOnglet = F5(
	function (annuaire, entree, courant, onglet, nom) {
		return {
			sO: _Utils_eq(onglet, courant),
			aa: $author$project$Routes$Route$toString(
				A3($author$project$Routes$Route$DemonstrationFiche, annuaire, entree.Aq, onglet)),
			vW: $elm$core$Maybe$Nothing,
			Dj: nom
		};
	});
var $author$project$Components$Demonstration$Fiche$View$nomDeLAnnuaire = F2(
	function (i18n, annuaire) {
		if (!annuaire) {
			return $author$project$I18n$Cles$demonstrationAnnuairePartiesPrenantes(i18n);
		} else {
			return $author$project$I18n$Cles$demonstrationAnnuaireDossiers(i18n);
		}
	});
var $author$project$Components$Demonstration$Fiche$View$racine = function (annuaire) {
	if (!annuaire) {
		return 'demonstration-partie-prenante-detail';
	} else {
		return 'demonstration-dossier-detail';
	}
};
var $author$project$Components$Demonstration$Fiche$View$view = F5(
	function (i18n, annuaire, entree, onglet, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			$author$project$Components$Demonstration$Fiche$View$racine(annuaire),
			{
				ut: $author$project$Components$Shared$Page$View$fiche(
					{
						tQ: _List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Page$View$section,
								_List_Nil,
								{
									fw: _List_Nil,
									fZ: _List_fromArray(
										[
											A2(
											$author$project$Components$Shared$Note$View$view,
											0,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$demonstrationFicheNote(i18n))
														]))
												]))
										]),
									Dj: 'contexte',
									h6: $author$project$I18n$Cles$demonstrationFicheContexte(i18n)
								})
							]),
						B2: _List_fromArray(
							[
								A3($author$project$Components$Demonstration$Fiche$View$contenu, i18n, entree, onglet)
							])
					}),
				xy: _List_fromArray(
					[
						A4(
						$author$project$Components$Demonstration$Drawer$View$view,
						i18n,
						2,
						{
							fs: $author$project$I18n$Cles$demonstrationFicheEnregistrer(i18n),
							uN: $author$project$I18n$Cles$demonstrationFicheCommentaire(i18n),
							h6: $author$project$I18n$Cles$demonstrationFicheModifierTitre(i18n)
						},
						model)
					]),
				zM: _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						0,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Demonstration$Fiche$View$declencheur),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								A2(
									$author$project$Components$Demonstration$Update$DrawerMsg,
									2,
									$author$project$Components$Shared$Drawer$Update$Ouvrir($author$project$Components$Demonstration$Fiche$View$declencheur)))
							]),
						$author$project$I18n$Cles$demonstrationFicheModifier(i18n))
					]),
				AK: A2(
					$author$project$Components$Demonstration$Model$dialogueOuvert,
					A3($author$project$Routes$Route$DemonstrationFiche, annuaire, entree.Aq, onglet),
					model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('pills')
									]),
								A2(
									$elm$core$List$map,
									function (_v0) {
										var couleur = _v0.a;
										var libelle = _v0.b;
										return A2($author$project$Components$Shared$Tag$View$view, couleur, libelle);
									},
									entree.ry))
							]),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$toString(
									$author$project$Routes$Route$DemonstrationAnnuaire(annuaire)),
								Dj: A2($author$project$Components$Demonstration$Fiche$View$nomDeLAnnuaire, i18n, annuaire)
							}
							]),
						Ef: _List_fromArray(
							[
								$author$project$Components$Shared$Onglets$View$view(
								_List_fromArray(
									[
										A5(
										$author$project$Components$Demonstration$Fiche$View$lienDOnglet,
										annuaire,
										entree,
										onglet,
										0,
										$author$project$I18n$Cles$demonstrationFicheOngletSynthese(i18n)),
										A5(
										$author$project$Components$Demonstration$Fiche$View$lienDOnglet,
										annuaire,
										entree,
										onglet,
										1,
										$author$project$I18n$Cles$demonstrationFicheOngletHistorique(i18n))
									]))
							]),
						h6: entree.h6
					})
			});
	});
var $author$project$Components$Demonstration$View$view = F4(
	function (i18n, theme, route, model) {
		switch (route.$) {
			case 71:
				return A3($author$project$Components$Demonstration$View$composants, i18n, theme, model);
			case 72:
				var annuaire = route.a;
				return A3($author$project$Components$Demonstration$Annuaire$View$view, i18n, annuaire, model);
			case 73:
				var annuaire = route.a;
				var identifiant = route.b;
				var onglet = route.c;
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Components$Demonstration$View$introuvable(i18n),
					A2(
						$elm$core$Maybe$map,
						function (entree) {
							return A5($author$project$Components$Demonstration$Fiche$View$view, i18n, annuaire, entree, onglet, model);
						},
						A2($author$project$Components$Demonstration$Donnees$entree, annuaire, identifiant)));
			default:
				return $author$project$Components$Demonstration$View$introuvable(i18n);
		}
	});
var $author$project$I18n$Cles$importsResultatTexte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.resultat.texte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'lignes',
					$author$project$I18n$Traductions$Entier(p.gV))
				]),
			((!p.gV) || (p.gV === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.gV) + ' ligne traitée.') : (A2($author$project$I18n$Nombre$formater, 0, p.gV) + ' lignes traitées.'));
	});
var $author$project$I18n$Cles$importsResultatTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.resultat.titre', _List_Nil, 'Import terminé');
};
var $author$project$I18n$Cles$importsSuiviCreees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.suivi.creees', _List_Nil, 'Créées');
};
var $author$project$I18n$Cles$importsSuiviErreurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.suivi.erreurs', _List_Nil, 'Erreurs');
};
var $author$project$I18n$Cles$importsSuiviModifiees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.suivi.modifiees', _List_Nil, 'Mises à jour');
};
var $author$project$Components$Imports$Outil$Update$LignesRejeteesDemandees = {$: 87};
var $author$project$Components$Imports$Outil$Update$RapportDemande = {$: 42};
var $author$project$I18n$Cles$importsLignesCorrigerEtRejouer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes.corriger-et-rejouer', _List_Nil, 'Corriger et rejouer les lignes rejetées');
};
var $author$project$I18n$Cles$importsRapportAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.rapport.aide', _List_Nil, 'Corrigez le fichier et réimportez-le : seules les lignes nouvelles ou corrigées sont traitées.');
};
var $author$project$I18n$Cles$importsRapportTexte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.rapport.texte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? ('Les ' + (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' ligne rejetée, avec une colonne « erreur », prêtes à corriger. Le rapport contient des données personnelles : il est chiffré et supprimé au bout de 30 jours.')) : ('Les ' + (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' lignes rejetées, avec une colonne « erreur », prêtes à corriger. Le rapport contient des données personnelles : il est chiffré et supprimé au bout de 30 jours.')));
	});
var $author$project$I18n$Cles$importsRapportTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.rapport.titre', _List_Nil, 'Rapport');
};
var $author$project$Components$Imports$Outil$View$rapportDuLot = F3(
	function (i18n, model, c) {
		var _v0 = model.pK;
		if (!_v0.$) {
			return (!c.gp) ? $rtfeldman$elm_css$Html$Styled$text('') : A3(
				$author$project$Components$Imports$Outil$View$section,
				'rapport',
				$author$project$I18n$Cles$importsRapportTitre(i18n),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$importsRapportTexte,
									i18n,
									{d: c.gp}))
							])),
						function () {
						var _v1 = A2(
							$elm$core$Maybe$andThen,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.nQ;
								},
								$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$lignesRejetees)),
							model.n0);
						if (!_v1.$) {
							return A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								0,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Imports$Outil$Update$LignesRejeteesDemandees)
									]),
								$author$project$I18n$Cles$importsLignesCorrigerEtRejouer(i18n));
						} else {
							return $rtfeldman$elm_css$Html$Styled$text('');
						}
					}(),
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						_Utils_eq(
							A2(
								$elm$core$Maybe$andThen,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.nQ;
									},
									$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$lignesRejetees)),
								model.n0),
							$elm$core$Maybe$Nothing) ? 0 : 1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Imports$Outil$Update$RapportDemande)
							]),
						$author$project$I18n$Cles$importsSimulationRapport(i18n)),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$importsRapportAide(i18n))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$importsSuiviAvancement = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.suivi.avancement',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'traitees',
					$author$project$I18n$Traductions$Chaine(p.JN)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Entier(p.JE))
				]),
			((!p.JE) || (p.JE === 1)) ? (p.JN + (' sur ' + (A2($author$project$I18n$Nombre$formater, 0, p.JE) + ' ligne'))) : (p.JN + (' sur ' + (A2($author$project$I18n$Nombre$formater, 0, p.JE) + ' lignes'))));
	});
var $author$project$I18n$Cles$importsSuiviMode = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.suivi.mode', _List_Nil, 'Mode');
};
var $author$project$I18n$Cles$importsSuiviModeValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.suivi.mode.valeur', _List_Nil, 'Traitement différé · paquets de 1 000');
};
var $author$project$I18n$Cles$importsSuiviQuitterTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.suivi.quitter.texte', _List_Nil, 'Une notification vous prévient à la fin. Si le service redémarre, l\'import reprend à la ligne suivante, sans double création.');
};
var $author$project$I18n$Cles$importsSuiviQuitterTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.suivi.quitter.titre', _List_Nil, 'Vous pouvez quitter cet écran');
};
var $author$project$I18n$Cles$importsSuiviTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.suivi.titre', _List_Nil, 'Application en cours');
};
var $rtfeldman$elm_css$Html$Styled$Attributes$max = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('max');
var $rtfeldman$elm_css$Html$Styled$progress = $rtfeldman$elm_css$Html$Styled$node('progress');
var $author$project$I18n$Cles$importsSuiviResteHeures = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.suivi.reste-heures',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			'reste environ ' + (p.d + ' h'));
	});
var $author$project$I18n$Cles$importsSuiviResteMinutes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.suivi.reste-minutes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			'reste environ ' + (p.d + ' min'));
	});
var $author$project$I18n$Cles$importsSuiviResteSecondes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.suivi.reste-secondes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			'reste environ ' + (p.d + ' s'));
	});
var $author$project$Components$Imports$Outil$View$resteEstime = F2(
	function (i18n, secondes) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('reste')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					(secondes < 60) ? A2(
						$author$project$I18n$Cles$importsSuiviResteSecondes,
						i18n,
						{
							d: $elm$core$String$fromInt(secondes)
						}) : ((secondes < 3600) ? A2(
						$author$project$I18n$Cles$importsSuiviResteMinutes,
						i18n,
						{
							d: $elm$core$String$fromInt(((secondes + 30) / 60) | 0)
						}) : A2(
						$author$project$I18n$Cles$importsSuiviResteHeures,
						i18n,
						{
							d: $elm$core$String$fromInt(((secondes + 1800) / 3600) | 0)
						})))
				]));
	});
var $author$project$Components$Imports$Outil$View$suiviEnCours = F2(
	function (i18n, suivi) {
		return A3(
			$author$project$Components$Imports$Outil$View$section,
			'suivi',
			$author$project$I18n$Cles$importsSuiviTitre(i18n),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$progress,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$value(
							$elm$core$String$fromInt(suivi.JN)),
							$rtfeldman$elm_css$Html$Styled$Attributes$max(
							$elm$core$String$fromInt(suivi.JE))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('avancement')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$importsSuiviAvancement,
										i18n,
										{
											JE: suivi.JE,
											JN: $elm$core$String$fromInt(suivi.JN)
										}))
								])),
							A2(
							$elm$core$Maybe$withDefault,
							$rtfeldman$elm_css$Html$Styled$text(''),
							A2(
								$elm$core$Maybe$map,
								$author$project$Components$Imports$Outil$View$resteEstime(i18n),
								suivi.HT))
						])),
					A2(
					$author$project$Components$Shared$Note$View$view,
					0,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$importsSuiviQuitterTitre(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$importsSuiviQuitterTexte(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$dl,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('kv')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$dt,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$importsSuiviMode(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$dd,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$importsSuiviModeValeur(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$dt,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$importsSuiviCreees(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$dd,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$elm$core$String$fromInt(suivi.wo))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$dt,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$importsSuiviModifiees(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$dd,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$elm$core$String$fromInt(suivi.CP))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$dt,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$importsSuiviErreurs(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$dd,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$elm$core$String$fromInt(suivi.x2))
								]))
						]))
				]));
	});
var $author$project$Components$Imports$Outil$View$application = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.uq, model.ua);
		if (!_v0.a.$) {
			var c = _v0.a.a;
			return _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Note$View$view,
					0,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$importsResultatTitre(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$importsResultatTexte,
										i18n,
										{gV: ((((c.wo + c.CP) + c.qY) + c.kW) + c.gp) + c.x8}))
								]))
						])),
					A2($author$project$Components$Imports$Outil$View$compteurs, i18n, c),
					A3($author$project$Components$Imports$Outil$View$rapportDuLot, i18n, model, c)
				]);
		} else {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var suivi = _v0.b.a;
				return suivi.Jt ? _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Note$View$view,
						0,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsResultatTitre(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$importsResultatTexte,
											i18n,
											{gV: suivi.JN}))
									]))
							])),
						A3(
						$author$project$Components$Imports$Outil$View$section,
						'suivi',
						$author$project$I18n$Cles$importsSuiviErreurs(i18n),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsSuiviCreees(i18n) + (' : ' + $elm$core$String$fromInt(suivi.wo)))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsSuiviModifiees(i18n) + (' : ' + $elm$core$String$fromInt(suivi.CP)))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$elm$core$String$fromInt(suivi.x2))
									]))
							]))
					]) : _List_fromArray(
					[
						A2($author$project$Components$Imports$Outil$View$suiviEnCours, i18n, suivi)
					]);
			} else {
				return _List_Nil;
			}
		}
	});
var $author$project$Components$Imports$Outil$Update$FichierDemande = {$: 7};
var $author$project$I18n$Cles$importsFichierChanger = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.fichier.changer', _List_Nil, 'Changer de fichier');
};
var $author$project$I18n$Cles$importsFichierCsv = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.fichier.csv',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'separateur',
					$author$project$I18n$Traductions$Chaine(p.IF)),
					_Utils_Tuple2(
					'encodage',
					$author$project$I18n$Traductions$Chaine(p.yo)),
					_Utils_Tuple2(
					'lignes',
					$author$project$I18n$Traductions$Chaine(p.gV))
				]),
			'Fichier CSV · séparateur « ' + (p.IF + (' » · encodage ' + (p.yo + (' · lignes : ' + p.gV)))));
	});
var $author$project$I18n$Cles$importsFichierXlsx = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.fichier.xlsx',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'feuilles',
					$author$project$I18n$Traductions$Entier(p.zn)),
					_Utils_Tuple2(
					'lignes',
					$author$project$I18n$Traductions$Chaine(p.gV))
				]),
			((!p.zn) || (p.zn === 1)) ? ('Classeur Excel · ' + (A2($author$project$I18n$Nombre$formater, 0, p.zn) + (' feuille · lignes : ' + p.gV))) : ('Classeur Excel · ' + (A2($author$project$I18n$Nombre$formater, 0, p.zn) + (' feuilles · lignes : ' + p.gV))));
	});
var $author$project$Components$Imports$Outil$View$resume = F2(
	function (i18n, apercu) {
		var lignes = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.g9;
				},
				apercu.zn));
		var _v0 = _Utils_Tuple2(apercu.IF, apercu.yo);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var separateur = _v0.a.a;
			var encodage = _v0.b.a;
			return A2(
				$author$project$I18n$Cles$importsFichierCsv,
				i18n,
				{
					yo: encodage,
					gV: $elm$core$String$fromInt(lignes),
					IF: separateur
				});
		} else {
			return A2(
				$author$project$I18n$Cles$importsFichierXlsx,
				i18n,
				{
					zn: $elm$core$List$length(apercu.zn),
					gV: $elm$core$String$fromInt(lignes)
				});
		}
	});
var $author$project$Components$Imports$Outil$View$carteDApercu = F2(
	function (i18n, apercu) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('sub-card')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(apercu.Dj)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Imports$Outil$View$resume, i18n, apercu))
								]))
						])),
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Imports$Outil$Update$FichierDemande)
						]),
					$author$project$I18n$Cles$importsFichierChanger(i18n))
				]));
	});
var $author$project$I18n$Cles$importsFichierTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.fichier.titre', _List_Nil, 'Fichier');
};
var $author$project$Components$Imports$Outil$View$carteDuFichier = F2(
	function (i18n, model) {
		return A3(
			$author$project$Components$Imports$Outil$View$section,
			'fichier',
			$author$project$I18n$Cles$importsFichierTitre(i18n),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Imports$Outil$View$carteDApercu(i18n),
						$elm$core$List$singleton),
					model.tq)));
	});
var $author$project$I18n$Cles$importsDomaineCatalogueDescription = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.domaine.catalogue.description', _List_Nil, 'Références de tous les types de produit (fours, tables de cuisson, lave-linge…), avec leurs fichiers rattachés (fiches techniques, notices, photos).');
};
var $author$project$I18n$Cles$importsDomainePartiesPrenantesDescription = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.domaine.parties-prenantes.description', _List_Nil, 'Organisations, personnes, contacts et rattachements : licenciés, producteurs, fournisseurs, contacts de salon…');
};
var $author$project$Components$Imports$Vocabulaire$descriptionDuDomaine = F2(
	function (i18n, code) {
		switch (code) {
			case 'parties-prenantes':
				return $author$project$I18n$Cles$importsDomainePartiesPrenantesDescription(i18n);
			case 'catalogue':
				return $author$project$I18n$Cles$importsDomaineCatalogueDescription(i18n);
			default:
				return '';
		}
	});
var $author$project$I18n$Cles$importsCiblesAutorise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.cibles.autorise', _List_Nil, 'Autorisé');
};
var $author$project$I18n$Cles$importsCibleRaisonAutre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.cible.raison-autre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'raison',
					$author$project$I18n$Traductions$Chaine(p.pH))
				]),
			p.pH);
	});
var $author$project$I18n$Cles$importsCibleRaisonDroitImporterManquant = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.cible.raison-droit-importer-manquant',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'domaine',
					$author$project$I18n$Traductions$Chaine(p.cC))
				]),
			'Droit « Importer des données » absent dans ' + p.cC);
	});
var $author$project$Components$Imports$Vocabulaire$raisonDeCible = F3(
	function (i18n, leDomaine, raison) {
		if (raison === 'droit-importer-manquant') {
			return A2(
				$author$project$I18n$Cles$importsCibleRaisonDroitImporterManquant,
				i18n,
				{
					cC: A2($author$project$Components$Imports$Vocabulaire$domaine, i18n, leDomaine)
				});
		} else {
			var autre = raison;
			return A2(
				$author$project$I18n$Cles$importsCibleRaisonAutre,
				i18n,
				{pH: autre});
		}
	});
var $author$project$Components$Imports$Outil$View$domainePossible = F3(
	function (i18n, cibles, leDomaine) {
		var duDomaine = A2(
			$elm$core$List$filter,
			function (c) {
				return _Utils_eq(c.cC, leDomaine);
			},
			cibles);
		var motif = $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function ($) {
					return $.pH;
				},
				duDomaine));
		var permis = A2(
			$elm$core$List$any,
			function ($) {
				return $.Fc;
			},
			duDomaine);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('cible'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('grisee', !permis)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Imports$Vocabulaire$domaine, i18n, leDomaine)),
							A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Imports$Vocabulaire$descriptionDuDomaine, i18n, leDomaine))
								]))
						])),
					permis ? A2(
					$author$project$Components$Shared$Tag$View$view,
					0,
					$author$project$I18n$Cles$importsCiblesAutorise(i18n)) : A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									A2($author$project$Components$Imports$Vocabulaire$raisonDeCible, i18n, leDomaine),
									motif)))
						]))
				]));
	});
var $author$project$I18n$Cles$importsCiblesNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.cibles.note', _List_Nil, 'Un domaine sans le droit « Importer des données » est grisé avec son motif. La cible de chaque feuille se règle à l\'étape suivante : un même classeur peut mêler les deux domaines.');
};
var $author$project$I18n$Cles$importsCiblesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.cibles.titre', _List_Nil, 'Ce que vous pouvez importer');
};
var $author$project$Components$Imports$Outil$View$ciblesPossibles = F2(
	function (i18n, model) {
		var cibles = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.jS;
				},
				model.cN));
		var domaines = A3(
			$elm$core$List$foldl,
			F2(
				function (cible, vus) {
					return A2($elm$core$List$member, cible.cC, vus) ? vus : _Utils_ap(
						vus,
						_List_fromArray(
							[cible.cC]));
				}),
			_List_Nil,
			cibles);
		return A3(
			$author$project$Components$Imports$Outil$View$section,
			'cibles-possibles',
			$author$project$I18n$Cles$importsCiblesTitre(i18n),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('cibles')
						]),
					A2(
						$elm$core$List$map,
						A2($author$project$Components$Imports$Outil$View$domainePossible, i18n, cibles),
						domaines)),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$importsCiblesNote(i18n))
						]))
				]));
	});
var $author$project$I18n$Cles$importsRefuseesAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.refusees.aide', _List_Nil, 'Une colonne refusée n\'est pas lue ; le reste du fichier s\'importe.');
};
var $author$project$I18n$Cles$importsRefuseesChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.refusees.champ', _List_Nil, 'Champ');
};
var $author$project$I18n$Cles$importsRefuseesColonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.refusees.colonne', _List_Nil, 'Colonne');
};
var $author$project$I18n$Cles$importsRefuseesRaison = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.refusees.raison', _List_Nil, 'Raison');
};
var $author$project$I18n$Cles$importsRefuseesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.refusees.titre', _List_Nil, 'Colonnes refusées');
};
var $author$project$I18n$Cles$importsRefuseesCalcule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.refusees.calcule', _List_Nil, 'Calculé');
};
var $author$project$I18n$Cles$importsRefuseesCalculeSuite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.refusees.calcule-suite', _List_Nil, 'recalculé à l\'import, non importable');
};
var $author$project$I18n$Cles$importsRefuseesNonImportable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.refusees.non-importable', _List_Nil, 'Non importable');
};
var $author$project$I18n$Cles$importsRefuseesNonModifiable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.refusees.non-modifiable', _List_Nil, 'Non modifiable');
};
var $author$project$I18n$Cles$importsRefuseesNonModifiableSuite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.refusees.non-modifiable-suite', _List_Nil, 'par votre rôle');
};
var $author$project$Components$Imports$Vocabulaire$raisonDeRefus = F2(
	function (i18n, code) {
		switch (code) {
			case 'calcule':
				return _Utils_Tuple2(
					$author$project$I18n$Cles$importsRefuseesCalcule(i18n),
					$author$project$I18n$Cles$importsRefuseesCalculeSuite(i18n));
			case 'non-modifiable':
				return _Utils_Tuple2(
					$author$project$I18n$Cles$importsRefuseesNonModifiable(i18n),
					$author$project$I18n$Cles$importsRefuseesNonModifiableSuite(i18n));
			default:
				return _Utils_Tuple2(
					$author$project$I18n$Cles$importsRefuseesNonImportable(i18n),
					'');
		}
	});
var $author$project$Components$Imports$Outil$View$colonnesRefusees = F2(
	function (i18n, part) {
		return _Utils_eq(part.Hi, _List_Nil) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('colonnes-refusees')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$importsRefuseesTitre(i18n)),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$elm$core$String$fromInt(
												$elm$core$List$length(part.Hi)))
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$table,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$thead,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$tr,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$importsRefuseesColonne(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$importsRefuseesChamp(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$importsRefuseesRaison(i18n))
														]))
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$tbody,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (refusee) {
											var _v0 = A2($author$project$Components$Imports$Vocabulaire$raisonDeRefus, i18n, refusee.pH);
											var etiquette = _v0.a;
											var suite = _v0.b;
											return A2(
												$rtfeldman$elm_css$Html$Styled$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$td,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$rtfeldman$elm_css$Html$Styled$span,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(refusee.l0)
																	]))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$td,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(refusee.uN)
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$td,
														_List_Nil,
														_List_fromArray(
															[
																A2($author$project$Components$Shared$Tag$View$view, 2, etiquette),
																$rtfeldman$elm_css$Html$Styled$text(suite)
															]))
													]));
										},
										part.Hi))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$importsRefuseesAide(i18n))
								]))
						]))
				]));
	});
var $author$project$Components$Imports$Outil$Update$ApplicationDemandee = function (a) {
	return {$: 32, a: a};
};
var $author$project$Components$Imports$Outil$Update$ModeleDemande = function (a) {
	return {$: 29, a: a};
};
var $author$project$Components$Imports$Outil$Model$avecUsageDuContact = function (champs) {
	return A2(
		$elm$core$List$any,
		function (c) {
			return A2($elm$core$List$member, 'usage', c.hJ);
		},
		champs);
};
var $author$project$Components$Imports$Outil$Update$ReglesDemandees = F3(
	function (a, b, c) {
		return {$: 62, a: a, b: b, c: c};
	});
var $author$project$I18n$Cles$importsReglesDateAjmExemple = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.date-ajm-exemple', _List_Nil, 'AAAA-MM-JJ · 2026-12-31');
};
var $author$project$I18n$Cles$importsReglesDateJmaExemple = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.date-jma-exemple', _List_Nil, 'JJ/MM/AAAA · 31/12/2026');
};
var $author$project$I18n$Cles$importsReglesDateJmaTirets = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.date-jma-tirets', _List_Nil, 'JJ-MM-AAAA');
};
var $author$project$I18n$Cles$importsReglesDateSerie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.date-serie', _List_Nil, 'Série Excel · 46388 = 01/01/2027');
};
var $author$project$Components$Imports$Outil$View$formatsDeDate = function (i18n) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'',
			$author$project$I18n$Cles$importsReglesDateSerie(i18n)),
			_Utils_Tuple2(
			'dd/MM/yyyy',
			$author$project$I18n$Cles$importsReglesDateJmaExemple(i18n)),
			_Utils_Tuple2(
			'yyyy-MM-dd',
			$author$project$I18n$Cles$importsReglesDateAjmExemple(i18n)),
			_Utils_Tuple2(
			'dd-MM-yyyy',
			$author$project$I18n$Cles$importsReglesDateJmaTirets(i18n))
		]);
};
var $author$project$I18n$Cles$importsReglesBoutonDate = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.regles.bouton-date',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			'Format : ' + p.fm);
	});
var $author$project$I18n$Cles$importsReglesBoutonLangues = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.regles.bouton-langues',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' colonne par langue') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' colonnes par langue'));
	});
var $author$project$I18n$Cles$importsReglesBoutonSeparateur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.regles.bouton-separateur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			'Séparateur : ' + p.fm);
	});
var $author$project$I18n$Cles$importsReglesBoutonUnite = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.regles.bouton-unite',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			'Unité : ' + p.fm);
	});
var $author$project$I18n$Cles$importsReglesListeAuto = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.liste-auto', _List_Nil, 'Virgule (par défaut)');
};
var $author$project$I18n$Cles$importsReglesUniteCellule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.unite-cellule', _List_Nil, 'lue dans la cellule');
};
var $author$project$I18n$Cles$importsReglesValeurAuto = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.valeur-auto', _List_Nil, 'automatique');
};
var $author$project$Components$Imports$Outil$View$libelleDe = F3(
	function (options, retenue, parDefaut) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_eq(retenue, $elm$core$Maybe$Nothing) ? parDefaut : A2($elm$core$Maybe$withDefault, parDefaut, retenue),
			A2(
				$elm$core$Maybe$andThen,
				function (v) {
					return A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$second,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (_v0) {
									var code = _v0.a;
									return _Utils_eq(code, v);
								},
								options)));
				},
				retenue));
	});
var $author$project$I18n$Cles$importsReglesListeBarreExemple = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.liste-barre-exemple', _List_Nil, 'Barre verticale · GEM|PEM');
};
var $author$project$I18n$Cles$importsReglesListePv = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.liste-pv', _List_Nil, 'Point-virgule · GEM; PEM');
};
var $author$project$I18n$Cles$importsReglesListeRetour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.liste-retour', _List_Nil, 'Retour à la ligne · une valeur par ligne');
};
var $author$project$I18n$Cles$importsReglesListeVirgule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.liste-virgule', _List_Nil, 'Virgule · GEM, PEM');
};
var $author$project$Components$Imports$Outil$View$separateursDeListe = function (i18n) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'',
			$author$project$I18n$Cles$importsReglesListeVirgule(i18n)),
			_Utils_Tuple2(
			';',
			$author$project$I18n$Cles$importsReglesListePv(i18n)),
			_Utils_Tuple2(
			'|',
			$author$project$I18n$Cles$importsReglesListeBarreExemple(i18n)),
			_Utils_Tuple2(
			'\n',
			$author$project$I18n$Cles$importsReglesListeRetour(i18n))
		]);
};
var $author$project$I18n$Cles$importsReglesDecimalAuto = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.decimal-auto', _List_Nil, 'Lu automatiquement');
};
var $author$project$I18n$Cles$importsReglesDecimalPoint = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.decimal-point', _List_Nil, 'Point');
};
var $author$project$I18n$Cles$importsReglesDecimalVirgule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.decimal-virgule', _List_Nil, 'Virgule');
};
var $author$project$Components$Imports$Outil$View$separateursDecimaux = function (i18n) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'',
			$author$project$I18n$Cles$importsReglesDecimalAuto(i18n)),
			_Utils_Tuple2(
			',',
			$author$project$I18n$Cles$importsReglesDecimalVirgule(i18n)),
			_Utils_Tuple2(
			'.',
			$author$project$I18n$Cles$importsReglesDecimalPoint(i18n))
		]);
};
var $author$project$Components$Imports$Outil$View$boutonDeRegle = F5(
	function (i18n, model, part, index, regle) {
		var regles = A2($author$project$Components$Imports$Outil$Model$reglesDe, part, index);
		var listeAuto = $author$project$I18n$Cles$importsReglesValeurAuto(i18n);
		var deListe = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (champ) {
					return champ.r0 === 'choix-multiples';
				},
				A3($author$project$Components$Imports$Outil$Model$champDeLaColonne, part, index, model)));
		var libelle = function () {
			switch (regle) {
				case 0:
					return A2(
						$author$project$I18n$Cles$importsReglesBoutonDate,
						i18n,
						{
							fm: A3(
								$author$project$Components$Imports$Outil$View$libelleDe,
								$author$project$Components$Imports$Outil$View$formatsDeDate(i18n),
								regles.zQ,
								listeAuto)
						});
				case 1:
					return A2(
						$author$project$I18n$Cles$importsReglesBoutonUnite,
						i18n,
						{
							fm: A2(
								$elm$core$Maybe$withDefault,
								$author$project$I18n$Cles$importsReglesUniteCellule(i18n),
								regles.Ka)
						});
				case 2:
					return deListe ? A2(
						$author$project$I18n$Cles$importsReglesBoutonSeparateur,
						i18n,
						{
							fm: A3(
								$author$project$Components$Imports$Outil$View$libelleDe,
								$author$project$Components$Imports$Outil$View$separateursDeListe(i18n),
								regles.IG,
								$author$project$I18n$Cles$importsReglesListeAuto(i18n))
						}) : A2(
						$author$project$I18n$Cles$importsReglesBoutonSeparateur,
						i18n,
						{
							fm: A3(
								$author$project$Components$Imports$Outil$View$libelleDe,
								$author$project$Components$Imports$Outil$View$separateursDecimaux(i18n),
								regles.IH,
								listeAuto)
						});
				default:
					return A2(
						$author$project$I18n$Cles$importsReglesBoutonLangues,
						i18n,
						{
							d: A2(
								$elm$core$Maybe$withDefault,
								1,
								A2(
									$elm$core$Maybe$map,
									function (c) {
										return $elm$core$List$length(
											A2($author$project$Components$Imports$Outil$Model$colonnesParLangue, part, c.dy));
									},
									A3($author$project$Components$Imports$Outil$Model$champDeLaColonne, part, index, model)))
						});
			}
		}();
		return A3(
			$author$project$Components$Shared$Bouton$View$bouton,
			2,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					A3($author$project$Components$Imports$Outil$Update$ReglesDemandees, part.mx, index, regle))
				]),
			A2(
				$elm$core$Maybe$withDefault,
				libelle,
				$elm$core$List$head(
					A2($elm$core$String$split, ' · ', libelle))));
	});
var $author$project$Components$Imports$Outil$Update$ColonneAffectee = F3(
	function (a, b, c) {
		return {$: 28, a: a, b: b, c: c};
	});
var $author$project$I18n$Cles$importsColonnesChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.colonnes.champ', _List_Nil, 'Champ');
};
var $author$project$I18n$Cles$importsColonnesIgnorer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.colonnes.ignorer', _List_Nil, 'Ignorer cette colonne');
};
var $author$project$Components$Imports$Outil$View$choixDuChamp = F4(
	function (i18n, part, index, champs) {
		var actuel = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Dict$get, index, part.j1));
		return A2(
			$rtfeldman$elm_css$Html$Styled$select,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onInput(
					A2($author$project$Components$Imports$Outil$Update$ColonneAffectee, part.mx, index)),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					$author$project$I18n$Cles$importsColonnesChamp(i18n))
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$option,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$value(''),
							$rtfeldman$elm_css$Html$Styled$Attributes$selected(actuel === '')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$importsColonnesIgnorer(i18n))
						])),
				A2(
					$elm$core$List$map,
					function (champ) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$option,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(champ.dy),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(actuel, champ.dy))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									champ.he ? (champ.Bl + ' *') : champ.Bl)
								]));
					},
					champs)));
	});
var $author$project$I18n$Cles$importsColonnesJamaisStockee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.colonnes.jamais-stockee', _List_Nil, 'Jamais stockée');
};
var $author$project$I18n$Cles$importsColonnesOk = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.colonnes.ok', _List_Nil, 'OK');
};
var $author$project$I18n$Cles$importsColonnesValeursAFaire = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.colonnes.valeurs-a-faire',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' valeur à faire correspondre') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' valeurs à faire correspondre'));
	});
var $author$project$I18n$Cles$importsColonnesValeursSuite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.colonnes.valeurs-suite', _List_Nil, 'Valeurs lues à l\'étape suivante');
};
var $author$project$Components$Imports$Outil$View$controleDesValeurs = F4(
	function (i18n, model, part, index) {
		var _v0 = A3($author$project$Components$Imports$Outil$Model$champDeLaColonne, part, index, model);
		if (_v0.$ === 1) {
			return A2(
				$author$project$Components$Shared$Tag$View$view,
				1,
				$author$project$I18n$Cles$importsColonnesJamaisStockee(i18n));
		} else {
			var champ = _v0.a;
			if (_Utils_eq(champ.BK, $elm$core$Maybe$Nothing)) {
				return A2(
					$author$project$Components$Shared$Tag$View$view,
					0,
					$author$project$I18n$Cles$importsColonnesOk(i18n));
			} else {
				var _v1 = A3($author$project$Components$Imports$Outil$Model$valeursDeLaColonne, part.mx, index, model);
				if (!_v1.$) {
					var lues = _v1.a;
					return (lues.sF > 0) ? A2(
						$author$project$Components$Shared$Tag$View$view,
						1,
						A2(
							$author$project$I18n$Cles$importsColonnesValeursAFaire,
							i18n,
							{d: lues.sF})) : A2(
						$author$project$Components$Shared$Tag$View$view,
						0,
						$author$project$I18n$Cles$importsColonnesOk(i18n));
				} else {
					return A2(
						$author$project$Components$Shared$Tag$View$view,
						3,
						$author$project$I18n$Cles$importsColonnesValeursSuite(i18n));
				}
			}
		}
	});
var $author$project$I18n$Cles$importsLectureAFaireCorrespondre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lecture.a-faire-correspondre', _List_Nil, 'à faire correspondre');
};
var $author$project$I18n$Cles$importsLectureErreurDate = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lecture.erreur-date', _List_Nil, 'date illisible');
};
var $author$project$I18n$Cles$importsLectureErreurMesure = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lecture.erreur-mesure', _List_Nil, 'mesure illisible');
};
var $author$project$I18n$Cles$importsLectureErreurNombre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lecture.erreur-nombre', _List_Nil, 'nombre illisible');
};
var $author$project$I18n$Cles$importsLectureErreurUnite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lecture.erreur-unite', _List_Nil, 'unité absente');
};
var $author$project$Components$Imports$Vocabulaire$erreurDeLecture = F2(
	function (i18n, code) {
		switch (code) {
			case 'date':
				return $author$project$I18n$Cles$importsLectureErreurDate(i18n);
			case 'nombre':
				return $author$project$I18n$Cles$importsLectureErreurNombre(i18n);
			case 'mesure':
				return $author$project$I18n$Cles$importsLectureErreurMesure(i18n);
			case 'unite':
				return $author$project$I18n$Cles$importsLectureErreurUnite(i18n);
			case 'a-faire-correspondre':
				return $author$project$I18n$Cles$importsLectureAFaireCorrespondre(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$I18n$Cles$importsColonnesErreur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.colonnes.erreur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'raison',
					$author$project$I18n$Traductions$Chaine(p.pH))
				]),
			'Erreur · ' + p.pH);
	});
var $author$project$I18n$Cles$importsColonnesOkValeur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.colonnes.ok-valeur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			'OK · ' + p.fm);
	});
var $author$project$Components$Imports$Outil$Model$valeurLue = function (valeur) {
	var _v0 = A2($elm$core$String$split, '-', valeur);
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
		var annee = _v0.a;
		var _v1 = _v0.b;
		var mois = _v1.a;
		var _v2 = _v1.b;
		var jour = _v2.a;
		return (($elm$core$String$length(annee) === 4) && (($elm$core$String$length(mois) === 2) && (($elm$core$String$length(jour) === 2) && A2(
			$elm$core$List$all,
			$elm$core$String$all($elm$core$Char$isDigit),
			_List_fromArray(
				[annee, mois, jour]))))) ? (jour + ('/' + (mois + ('/' + annee)))) : valeur;
	} else {
		return valeur;
	}
};
var $author$project$Components$Imports$Outil$View$controleDeLaValeur = F4(
	function (i18n, model, part, index) {
		var _v0 = _Utils_Tuple2(
			A3($author$project$Components$Imports$Outil$Model$champDeLaColonne, part, index, model),
			A2($elm$core$Dict$get, index, part.wc));
		if (_v0.a.$ === 1) {
			var _v1 = _v0.a;
			return A2(
				$author$project$Components$Shared$Tag$View$view,
				1,
				$author$project$I18n$Cles$importsColonnesJamaisStockee(i18n));
		} else {
			if (!_v0.b.$) {
				var ok = _v0.b.a.D7;
				var converti = _v0.b.a.kb;
				var erreur = _v0.b.a.go;
				var _v2 = _Utils_Tuple3(ok, converti, erreur);
				_v2$2:
				while (true) {
					if (_v2.a) {
						if (!_v2.b.$) {
							var valeur = _v2.b.a;
							return A2(
								$author$project$Components$Shared$Tag$View$view,
								0,
								A2(
									$author$project$I18n$Cles$importsColonnesOkValeur,
									i18n,
									{
										fm: $author$project$Components$Imports$Outil$Model$valeurLue(valeur)
									}));
						} else {
							break _v2$2;
						}
					} else {
						if (!_v2.c.$) {
							var code = _v2.c.a;
							return (code === 'a-faire-correspondre') ? A4($author$project$Components$Imports$Outil$View$controleDesValeurs, i18n, model, part, index) : A2(
								$author$project$Components$Shared$Tag$View$view,
								2,
								A2(
									$author$project$I18n$Cles$importsColonnesErreur,
									i18n,
									{
										pH: A2($author$project$Components$Imports$Vocabulaire$erreurDeLecture, i18n, code)
									}));
						} else {
							break _v2$2;
						}
					}
				}
				return A4($author$project$Components$Imports$Outil$View$controleDesValeurs, i18n, model, part, index);
			} else {
				var _v3 = _v0.b;
				return A4($author$project$Components$Imports$Outil$View$controleDesValeurs, i18n, model, part, index);
			}
		}
	});
var $author$project$I18n$Cles$importsColonnesCleNaturelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.colonnes.cle-naturelle', _List_Nil, 'Clé naturelle');
};
var $author$project$Components$Imports$Outil$View$controle = F4(
	function (i18n, model, part, index) {
		var _v0 = _Utils_Tuple2(
			A3($author$project$Components$Imports$Outil$Model$champDeLaColonne, part, index, model),
			A2($elm$core$Dict$get, index, part.wc));
		if (!_v0.a.$) {
			if (_v0.b.$ === 1) {
				var champ = _v0.a.a;
				var _v1 = _v0.b;
				return champ.yD ? A2(
					$author$project$Components$Shared$Tag$View$view,
					0,
					$author$project$I18n$Cles$importsColonnesCleNaturelle(i18n)) : A4($author$project$Components$Imports$Outil$View$controleDeLaValeur, i18n, model, part, index);
			} else {
				var champ = _v0.a.a;
				var ok = _v0.b.a.D7;
				return (champ.yD && ok) ? A2(
					$author$project$Components$Shared$Tag$View$view,
					0,
					$author$project$I18n$Cles$importsColonnesCleNaturelle(i18n)) : A4($author$project$Components$Imports$Outil$View$controleDeLaValeur, i18n, model, part, index);
			}
		} else {
			return A4($author$project$Components$Imports$Outil$View$controleDeLaValeur, i18n, model, part, index);
		}
	});
var $author$project$Components$Imports$Outil$View$exemple = F2(
	function (part, index) {
		var _v0 = $elm$core$List$head(
			A2($elm$core$List$drop, index, part.y_));
		if (!_v0.$) {
			var valeur = _v0.a;
			return (valeur === '') ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('col-ex')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(valeur)
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$importsColonnesAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.colonnes.aide', _List_Nil, 'Proposée d\'après les en-têtes, modifiable. Une colonne obligatoire sans correspondance bloque la simulation.');
};
var $author$project$I18n$Cles$importsColonnesAppliquer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.colonnes.appliquer', _List_Nil, 'Appliquer un modèle');
};
var $author$project$I18n$Cles$importsColonnesChampDuType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.colonnes.champ-du-type', _List_Nil, 'Champ du type');
};
var $author$project$I18n$Cles$importsColonnesControle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.colonnes.controle', _List_Nil, 'Contrôle');
};
var $author$project$I18n$Cles$importsColonnesEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.colonnes.enregistrer', _List_Nil, 'Enregistrer comme modèle');
};
var $author$project$I18n$Cles$importsColonnesEntete = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.colonnes.entete', _List_Nil, 'Colonne du fichier');
};
var $author$project$I18n$Cles$importsColonnesExemple = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.colonnes.exemple', _List_Nil, 'Exemple (ligne 2)');
};
var $author$project$I18n$Cles$importsColonnesManquantes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.colonnes.manquantes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'colonnes',
					$author$project$I18n$Traductions$Chaine(p.j1))
				]),
			'Colonnes du modèle absentes du fichier : ' + p.j1);
	});
var $author$project$I18n$Cles$importsColonnesModeleEnregistre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.colonnes.modele-enregistre', _List_Nil, 'Modèle enregistré.');
};
var $author$project$I18n$Cles$importsColonnesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.colonnes.titre', _List_Nil, 'Correspondance des colonnes');
};
var $author$project$I18n$Cles$importsColonnesUsage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.colonnes.usage', _List_Nil, 'Usage du contact');
};
var $author$project$I18n$Cles$importsRefusChampDouble = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.refus.champ-double',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'Le champ ' + (p.uN + ' reçoit deux colonnes : une seule est possible'));
	});
var $author$project$I18n$Cles$importsRefusChampObligatoire = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.refus.champ-obligatoire',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'Le champ ' + (p.uN + ' doit recevoir une colonne'));
	});
var $author$project$Components$Imports$Outil$Model$RegleDate = 0;
var $author$project$Components$Imports$Outil$Model$RegleSeparateur = 2;
var $author$project$Components$Imports$Outil$Model$RegleUnite = 1;
var $author$project$Components$Imports$Outil$Model$reglesAdmises = F3(
	function (part, index, model) {
		return A2(
			$elm$core$List$filterMap,
			function (nom) {
				switch (nom) {
					case 'date':
						return $elm$core$Maybe$Just(0);
					case 'unite':
						return $elm$core$Maybe$Just(1);
					case 'separateur':
						return $elm$core$Maybe$Just(2);
					case 'langue':
						return $elm$core$Maybe$Just(3);
					default:
						return $elm$core$Maybe$Nothing;
				}
			},
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.hJ;
					},
					A3($author$project$Components$Imports$Outil$Model$champDeLaColonne, part, index, model))));
	});
var $author$project$I18n$Cles$importsTypeCle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.type.cle', _List_Nil, 'clé');
};
var $author$project$I18n$Cles$importsTypeChoixMultiples = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.type.choix-multiples', _List_Nil, 'choix multiples');
};
var $author$project$I18n$Cles$importsTypeDate = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.type.date', _List_Nil, 'date');
};
var $author$project$I18n$Cles$importsTypeDevise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.type.devise', _List_Nil, 'ISO 4217');
};
var $author$project$I18n$Cles$importsTypeMesure = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.type.mesure', _List_Nil, 'mesure');
};
var $author$project$I18n$Cles$importsTypeMontant = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.type.montant', _List_Nil, 'montant');
};
var $author$project$I18n$Cles$importsTypeNombre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.type.nombre', _List_Nil, 'nombre');
};
var $author$project$I18n$Cles$importsTypeOuiNon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.type.oui-non', _List_Nil, 'oui / non');
};
var $author$project$I18n$Cles$importsTypePays = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.type.pays', _List_Nil, 'ISO 3166');
};
var $author$project$I18n$Cles$importsTypeReference = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.type.reference', _List_Nil, 'référence');
};
var $author$project$I18n$Cles$importsTypeTraduisible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.type.traduisible', _List_Nil, 'traduisible');
};
var $author$project$Components$Imports$Vocabulaire$typeDeChamp = F2(
	function (i18n, code) {
		switch (code) {
			case 'date':
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$importsTypeDate(i18n));
			case 'mesure':
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$importsTypeMesure(i18n));
			case 'choix-multiples':
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$importsTypeChoixMultiples(i18n));
			case 'pays':
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$importsTypePays(i18n));
			case 'devise':
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$importsTypeDevise(i18n));
			case 'traduisible':
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$importsTypeTraduisible(i18n));
			case 'nombre':
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$importsTypeNombre(i18n));
			case 'montant':
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$importsTypeMontant(i18n));
			case 'oui-non':
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$importsTypeOuiNon(i18n));
			case 'reference':
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$importsTypeReference(i18n));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Imports$Outil$View$typeDeLaColonne = F4(
	function (i18n, model, part, index) {
		var champ = A3($author$project$Components$Imports$Outil$Model$champDeLaColonne, part, index, model);
		if (_Utils_eq(
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.yD;
				},
				champ),
			$elm$core$Maybe$Just(true))) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('type-du-champ')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$importsTypeCle(i18n))
					]));
		} else {
			var _v0 = A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.r0;
					},
					$author$project$Components$Imports$Vocabulaire$typeDeChamp(i18n)),
				champ);
			if (!_v0.$) {
				var libelle = _v0.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('type-du-champ')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						]));
			} else {
				return $rtfeldman$elm_css$Html$Styled$text('');
			}
		}
	});
var $author$project$Components$Imports$Outil$Update$UsageDeColonneChoisi = F3(
	function (a, b, c) {
		return {$: 66, a: a, b: b, c: c};
	});
var $author$project$Components$Imports$Outil$Model$usageDeLaColonne = F2(
	function (part, index) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$Imports$Outil$Model$usageParDefaut,
			A2($author$project$Components$Imports$Outil$Model$reglesDe, part, index).sd);
	});
var $author$project$I18n$Cles$importsUsageAutre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.usage.autre', _List_Nil, 'Autre');
};
var $author$project$I18n$Cles$importsUsageFacturation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.usage.facturation', _List_Nil, 'Facturation');
};
var $author$project$I18n$Cles$importsUsageLivraison = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.usage.livraison', _List_Nil, 'Livraison');
};
var $author$project$I18n$Cles$importsUsagePersonnel = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.usage.personnel', _List_Nil, 'Personnel');
};
var $author$project$I18n$Cles$importsUsageProfessionnel = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.usage.professionnel', _List_Nil, 'Professionnel');
};
var $author$project$I18n$Cles$importsUsageSiege = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.usage.siege', _List_Nil, 'Siège');
};
var $author$project$Components$Imports$Vocabulaire$usageDuContact = F2(
	function (i18n, code) {
		switch (code) {
			case 'personnel':
				return $author$project$I18n$Cles$importsUsagePersonnel(i18n);
			case 'facturation':
				return $author$project$I18n$Cles$importsUsageFacturation(i18n);
			case 'livraison':
				return $author$project$I18n$Cles$importsUsageLivraison(i18n);
			case 'siege':
				return $author$project$I18n$Cles$importsUsageSiege(i18n);
			case 'autre':
				return $author$project$I18n$Cles$importsUsageAutre(i18n);
			default:
				return $author$project$I18n$Cles$importsUsageProfessionnel(i18n);
		}
	});
var $author$project$Components$Imports$Outil$Model$usagesDeContact = _List_fromArray(
	['professionnel', 'personnel', 'facturation', 'livraison', 'siege', 'autre']);
var $author$project$Components$Imports$Outil$View$usageDuContact = F4(
	function (i18n, model, part, index) {
		if (A2(
			$elm$core$List$member,
			'usage',
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.hJ;
					},
					A3($author$project$Components$Imports$Outil$Model$champDeLaColonne, part, index, model))))) {
			var actuel = A2($author$project$Components$Imports$Outil$Model$usageDeLaColonne, part, index);
			return A2(
				$rtfeldman$elm_css$Html$Styled$select,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onInput(
						A2($author$project$Components$Imports$Outil$Update$UsageDeColonneChoisi, part.mx, index)),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-label',
						$author$project$I18n$Cles$importsColonnesUsage(i18n))
					]),
				A2(
					$elm$core$List$map,
					function (usage) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$option,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(usage),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(actuel, usage))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Imports$Vocabulaire$usageDuContact, i18n, usage))
								]));
					},
					$author$project$Components$Imports$Outil$Model$usagesDeContact));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Imports$Outil$View$correspondance = F3(
	function (i18n, model, part) {
		var manquantsDeLaPart = A2($author$project$Components$Imports$Outil$Model$manquants, part, model);
		var indexRefuses = A2(
			$elm$core$List$map,
			function ($) {
				return $.AI;
			},
			part.Hi);
		var lues = A2(
			$elm$core$List$filter,
			function (_v1) {
				var index = _v1.a;
				return !A2($elm$core$List$member, index, indexRefuses);
			},
			A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, part.ym));
		var doublonsDeLaPart = $author$project$Components$Imports$Outil$Model$doublons(part);
		var champs = A2($author$project$Components$Imports$Outil$Model$champsDe, part, model);
		var avecUsage = $author$project$Components$Imports$Outil$Model$avecUsageDuContact(champs);
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('correspondance')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$importsColonnesTitre(i18n)),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$elm$core$String$fromInt(
												$elm$core$List$length(part.ym)))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('gestes')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									2,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Imports$Outil$Update$ApplicationDemandee(part.mx))
										]),
									$author$project$I18n$Cles$importsColonnesAppliquer(i18n)),
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									2,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Imports$Outil$Update$ModeleDemande(part.mx)),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
											_Utils_eq(
												A2($author$project$Components$Imports$Outil$Model$lienDe, $author$project$API$NavLinksDictionary$enregistrerUnModele, model),
												$elm$core$Maybe$Nothing) || $elm$core$Dict$isEmpty(part.j1))
										]),
									$author$project$I18n$Cles$importsColonnesEnregistrer(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$table,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$thead,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$tr,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$importsColonnesEntete(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$importsColonnesExemple(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$importsColonnesChampDuType(i18n))
														])),
													avecUsage ? A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$importsColonnesUsage(i18n))
														])) : $rtfeldman$elm_css$Html$Styled$text(''),
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$importsColonnesControle(i18n))
														]))
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$tbody,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (_v0) {
											var index = _v0.a;
											var entete = _v0.b;
											return A2(
												$rtfeldman$elm_css$Html$Styled$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$td,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$rtfeldman$elm_css$Html$Styled$span,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(entete)
																	]))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$td,
														_List_Nil,
														_List_fromArray(
															[
																A2($author$project$Components$Imports$Outil$View$exemple, part, index)
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$td,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$rtfeldman$elm_css$Html$Styled$div,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('champ-et-type')
																	]),
																_List_fromArray(
																	[
																		A4($author$project$Components$Imports$Outil$View$choixDuChamp, i18n, part, index, champs),
																		A4($author$project$Components$Imports$Outil$View$typeDeLaColonne, i18n, model, part, index)
																	])),
																A2(
																$rtfeldman$elm_css$Html$Styled$div,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('regles-de-la-colonne')
																	]),
																A2(
																	$elm$core$List$map,
																	A4($author$project$Components$Imports$Outil$View$boutonDeRegle, i18n, model, part, index),
																	A3($author$project$Components$Imports$Outil$Model$reglesAdmises, part, index, model)))
															])),
														avecUsage ? A2(
														$rtfeldman$elm_css$Html$Styled$td,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('usage-du-contact')
															]),
														_List_fromArray(
															[
																A4($author$project$Components$Imports$Outil$View$usageDuContact, i18n, model, part, index)
															])) : $rtfeldman$elm_css$Html$Styled$text(''),
														A2(
														$rtfeldman$elm_css$Html$Styled$td,
														_List_Nil,
														_List_fromArray(
															[
																A4($author$project$Components$Imports$Outil$View$controle, i18n, model, part, index)
															]))
													]));
										},
										lues))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('messages-de-la-part'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
								]),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									function (champ) {
										return A2(
											$author$project$Components$Shared$Note$View$view,
											1,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$author$project$I18n$Cles$importsRefusChampObligatoire,
														i18n,
														{uN: champ.Bl}))
												]));
									},
									manquantsDeLaPart),
								A2(
									$elm$core$List$map,
									function (champ) {
										return A2(
											$author$project$Components$Shared$Note$View$view,
											1,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$author$project$I18n$Cles$importsRefusChampDouble,
														i18n,
														{uN: champ}))
												]));
									},
									doublonsDeLaPart))),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$importsColonnesAide(i18n))
								])),
							((!_Utils_eq(model.B4, _List_Nil)) && _Utils_eq(
							model.Et,
							$elm$core$Maybe$Just(part.mx))) ? A2(
							$author$project$Components$Shared$Note$View$view,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$importsColonnesManquantes,
										i18n,
										{
											j1: A2($elm$core$String$join, ', ', model.B4)
										}))
								])) : $rtfeldman$elm_css$Html$Styled$text(''),
							(model.lZ && _Utils_eq(
							model.Et,
							$elm$core$Maybe$Just(part.mx))) ? A2(
							$author$project$Components$Shared$Note$View$view,
							3,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$importsColonnesModeleEnregistre(i18n))
								])) : $rtfeldman$elm_css$Html$Styled$text('')
						]))
				]));
	});
var $author$project$I18n$Cles$importsFichierAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.fichier.aide', _List_Nil, 'Déposez un classeur .xlsx ou un fichier .csv. Aucune fiche n\'est modifiée avant la simulation et votre accord.');
};
var $author$project$I18n$Cles$importsFichierChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.fichier.choisir', _List_Nil, 'Choisir un fichier');
};
var $author$project$I18n$Cles$importsFichierLimites = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.fichier.limites', _List_Nil, 'Limites : .xlsx et .csv, 100 000 lignes, 50 Mo.');
};
var $author$project$Components$Imports$Outil$View$fichier = F2(
	function (i18n, model) {
		return A3(
			$author$project$Components$Imports$Outil$View$section,
			'fichier',
			$author$project$I18n$Cles$importsFichierTitre(i18n),
			function () {
				var _v0 = model.tq;
				if (!_v0.$) {
					var apercu = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Components$Imports$Outil$View$carteDApercu, i18n, apercu)
						]);
				} else {
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('lead')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$importsFichierAide(i18n))
								])),
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Imports$Outil$Update$FichierDemande),
									$rtfeldman$elm_css$Html$Styled$Attributes$id('imports-choisir-un-fichier'),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
									_Utils_eq(
										A2($author$project$Components$Imports$Outil$Model$lienDe, $author$project$API$NavLinksDictionary$apercuDuFichier, model),
										$elm$core$Maybe$Nothing))
								]),
							$author$project$I18n$Cles$importsFichierChoisir(i18n)),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$importsFichierLimites(i18n))
								]))
						]);
				}
			}());
	});
var $author$project$Components$Imports$Outil$Update$PageDeLignesChoisie = function (a) {
	return {$: 90, a: a};
};
var $author$project$Components$Imports$Outil$Update$FiltreDeLignesChoisi = function (a) {
	return {$: 89, a: a};
};
var $author$project$I18n$Cles$importsLignesFiltreACorriger = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.lignes.filtre-a-corriger',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			'À corriger ' + p.d);
	});
var $author$project$I18n$Cles$importsLignesFiltreIgnorees = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.lignes.filtre-ignorees',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			'Ignorées ' + p.d);
	});
var $author$project$I18n$Cles$importsLignesFiltrePretes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.lignes.filtre-pretes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			'Prêtes ' + p.d);
	});
var $author$project$I18n$Cles$importsLignesFiltreToutes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.lignes.filtre-toutes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			'Toutes ' + p.d);
	});
var $author$project$I18n$Cles$importsLignesFiltres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes.filtres', _List_Nil, 'Filtrer les lignes rejetées');
};
var $author$project$Components$Shared$Segment$View$uneOption = F2(
	function (config, option) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('option'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					_Utils_eq(option.vx, config.vd) ? 'on' : '')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
							$rtfeldman$elm_css$Html$Styled$Attributes$name(config.Dj),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(option.vx),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(
							_Utils_eq(option.vx, config.vd)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							config.Ea(option.vx))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(option.Bl)
						]))
				]));
	});
var $author$project$Components$Shared$Segment$View$view = function (config) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('segment'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'radiogroup'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', config.Bi)
			]),
		A2(
			$elm$core$List$map,
			$author$project$Components$Shared$Segment$View$uneOption(config),
			config.o_));
};
var $author$project$Components$Imports$Outil$View$filtresDesLignes = F3(
	function (i18n, lignes, liste) {
		var option = function (_v0) {
			var code = _v0.a;
			var libelle = _v0.b;
			var n = _v0.c;
			return {
				vx: code,
				Bl: libelle(
					{
						d: $elm$core$String$fromInt(n)
					})
			};
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('filtres-de-lignes')
				]),
			_List_fromArray(
				[
					$author$project$Components$Shared$Segment$View$view(
					{
						vd: lignes.zH,
						Bi: $author$project$I18n$Cles$importsLignesFiltres(i18n),
						Dj: 'filtre-des-lignes',
						Ea: $author$project$Components$Imports$Outil$Update$FiltreDeLignesChoisi,
						o_: A2(
							$elm$core$List$map,
							option,
							_List_fromArray(
								[
									_Utils_Tuple3(
									'a-corriger',
									$author$project$I18n$Cles$importsLignesFiltreACorriger(i18n),
									liste.sE),
									_Utils_Tuple3(
									'pretes',
									$author$project$I18n$Cles$importsLignesFiltrePretes(i18n),
									liste.Gj),
									_Utils_Tuple3(
									'ignorees',
									$author$project$I18n$Cles$importsLignesFiltreIgnorees(i18n),
									liste.Aw),
									_Utils_Tuple3(
									'toutes',
									$author$project$I18n$Cles$importsLignesFiltreToutes(i18n),
									(liste.sE + liste.Gj) + liste.Aw)
								]))
					})
				]));
	});
var $author$project$I18n$Cles$importsLignesBandeauTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes.bandeau-texte', _List_Nil, 'Les lignes déjà appliquées ne changent pas. Une ligne corrigée est revalidée tout de suite ; elle n\'est écrite qu\'au clic sur « Rejouer ».');
};
var $author$project$I18n$Cles$importsLignesBandeauTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.lignes.bandeau-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'pretes',
					$author$project$I18n$Traductions$Entier(p.Gj)),
					_Utils_Tuple2(
					'erreurs',
					$author$project$I18n$Traductions$Chaine(p.gp)),
					_Utils_Tuple2(
					'ignorees',
					$author$project$I18n$Traductions$Entier(p.Aw))
				]),
			(((!p.Gj) || (p.Gj === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.Gj) + ' ligne prête') : (A2($author$project$I18n$Nombre$formater, 0, p.Gj) + ' lignes prêtes')) + (', ' + (p.gp + (' encore en erreur, ' + (((!p.Aw) || (p.Aw === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.Aw) + ' ignorée') : (A2($author$project$I18n$Nombre$formater, 0, p.Aw) + ' ignorées'))))));
	});
var $author$project$I18n$Cles$importsLignesColonneLicencie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes.colonne-licencie', _List_Nil, 'Licencié (fichier)');
};
var $author$project$I18n$Cles$importsLignesColonneValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes.colonne-valeur', _List_Nil, 'Valeur à corriger');
};
var $author$project$I18n$Cles$importsLignesDejaTraitee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes.deja-traitee', _List_Nil, 'Cette ligne a déjà changé d\'état : la liste est relue.');
};
var $author$project$I18n$Cles$importsLignesEchec = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes.echec', _List_Nil, 'La liste des lignes rejetées n\'a pas pu être lue.');
};
var $author$project$I18n$Cles$importsLignesListeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes.liste-titre', _List_Nil, 'Lignes rejetées');
};
var $author$project$I18n$Cles$importsLignesPiedListe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.lignes.pied-liste',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'affichees',
					$author$project$I18n$Traductions$Entier(p.dk)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			((!p.dk) || (p.dk === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.dk) + (' ligne sur ' + (p.JE + ' affichée. Modifiez la valeur sur place puis validez avec Entrée : la ligne est revalidée aussitôt.'))) : (A2($author$project$I18n$Nombre$formater, 0, p.dk) + (' lignes sur ' + (p.JE + ' affichées. Modifiez la valeur sur place puis validez avec Entrée : la ligne est revalidée aussitôt.'))));
	});
var $author$project$I18n$Cles$importsLignesPrecedente = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes.precedente', _List_Nil, 'Page précédente');
};
var $author$project$I18n$Cles$importsLignesRefus = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes.refus', _List_Nil, 'Ce geste n\'a pas pu être appliqué.');
};
var $author$project$I18n$Cles$importsLignesSuivante = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes.suivante', _List_Nil, 'Page suivante');
};
var $author$project$I18n$Cles$importsLignesVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes.vide', _List_Nil, 'Aucune ligne dans cette liste.');
};
var $author$project$I18n$Cles$importsSimulationColonneColonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.simulation.colonne.colonne', _List_Nil, 'Colonne');
};
var $author$project$I18n$Cles$importsSimulationColonneErreur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.simulation.colonne.erreur', _List_Nil, 'Erreur');
};
var $author$project$I18n$Cles$importsSimulationColonneLigne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.simulation.colonne.ligne', _List_Nil, 'Ligne');
};
var $author$project$Components$Imports$Outil$Update$CorrectionAnnulee = F2(
	function (a, b) {
		return {$: 93, a: a, b: b};
	});
var $author$project$Components$Imports$Outil$Update$LigneCorrigee = F2(
	function (a, b) {
		return {$: 92, a: a, b: b};
	});
var $author$project$Components$Imports$Outil$Update$LigneIgnoree = F2(
	function (a, b) {
		return {$: 94, a: a, b: b};
	});
var $author$project$Components$Imports$Outil$Update$LigneReprise = F2(
	function (a, b) {
		return {$: 95, a: a, b: b};
	});
var $author$project$Components$Imports$Outil$Update$ValeurDeLigneSaisie = F3(
	function (a, b, c) {
		return {$: 91, a: a, b: b, c: c};
	});
var $author$project$I18n$Cles$importsErreurDeLigneAFaireCorrespondre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.a-faire-correspondre', _List_Nil, 'Valeur à faire correspondre à la liste');
};
var $author$project$I18n$Cles$importsErreurDeLigneBaseLegale = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.base-legale', _List_Nil, 'Base légale non réglée pour la part');
};
var $author$project$I18n$Cles$importsErreurDeLigneChoixEnDouble = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.choix-en-double', _List_Nil, 'Choix en double');
};
var $author$project$I18n$Cles$importsErreurDeLigneCodeDUnAutreType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.code-d-un-autre-type', _List_Nil, 'Code déjà utilisé par une référence d\'un autre type');
};
var $author$project$I18n$Cles$importsErreurDeLigneCodeManquant = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.code-manquant', _List_Nil, 'Code de référence manquant');
};
var $author$project$I18n$Cles$importsErreurDeLigneDate = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.date', _List_Nil, 'Date illisible');
};
var $author$project$I18n$Cles$importsErreurDeLigneDateInexistanteSansJour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.date-inexistante-sans-jour', _List_Nil, 'Date invalide : cette date n\'existe pas');
};
var $author$project$I18n$Cles$importsErreurDeLigneDecimales = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.decimales', _List_Nil, 'Trop de décimales');
};
var $author$project$I18n$Cles$importsErreurDeLigneDoublonDansLeFichier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.doublon-dans-le-fichier', _List_Nil, 'Code déjà présent dans le fichier');
};
var $author$project$I18n$Cles$importsErreurDeLigneEtageIntrouvable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.etage-introuvable', _List_Nil, 'Étage inconnu de la structure');
};
var $author$project$I18n$Cles$importsErreurDeLigneEtatAbsent = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.etat-absent', _List_Nil, 'Aucun état de départ défini pour ce type');
};
var $author$project$I18n$Cles$importsErreurDeLigneFormatEmailInvalide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.format-email-invalide', _List_Nil, 'Format d\'email invalide');
};
var $author$project$I18n$Cles$importsErreurDeLigneFormatInvalide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.format-invalide', _List_Nil, 'Format invalide');
};
var $author$project$I18n$Cles$importsErreurDeLigneFormatTelephoneInvalide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.format-telephone-invalide', _List_Nil, 'Format de téléphone invalide');
};
var $author$project$I18n$Cles$importsErreurDeLigneForme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.forme', _List_Nil, 'Forme d\'organisation inconnue');
};
var $author$project$I18n$Cles$importsErreurDeLigneGammeIntrouvable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.gamme-introuvable', _List_Nil, 'Gamme inconnue de la marque');
};
var $author$project$I18n$Cles$importsErreurDeLigneHorsBornes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.hors-bornes', _List_Nil, 'Valeur hors des bornes');
};
var $author$project$I18n$Cles$importsErreurDeLigneHorsBornesPlausibles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.hors-bornes-plausibles', _List_Nil, 'Valeur hors des bornes plausibles');
};
var $author$project$I18n$Cles$importsErreurDeLigneHorsListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.hors-liste', _List_Nil, 'Valeur absente de la liste');
};
var $author$project$I18n$Cles$importsErreurDeLigneInconnue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.inconnue', _List_Nil, 'Forme inconnue ou archivée');
};
var $author$project$I18n$Cles$importsErreurDeLigneLangueNonAdmise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.langue-non-admise', _List_Nil, 'Langue non admise');
};
var $author$project$I18n$Cles$importsErreurDeLigneLongueur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.longueur', _List_Nil, 'Longueur non admise');
};
var $author$project$I18n$Cles$importsErreurDeLigneMarqueIntrouvable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.marque-introuvable', _List_Nil, 'Marque inconnue du catalogue');
};
var $author$project$I18n$Cles$importsErreurDeLigneMesure = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.mesure', _List_Nil, 'Mesure illisible');
};
var $author$project$I18n$Cles$importsErreurDeLigneModificationRefusee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.modification-refusee', _List_Nil, 'Modification de la fiche refusée');
};
var $author$project$I18n$Cles$importsErreurDeLigneMotif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.motif', _List_Nil, 'Format non respecté');
};
var $author$project$I18n$Cles$importsErreurDeLigneNombre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.nombre', _List_Nil, 'Nombre illisible');
};
var $author$project$I18n$Cles$importsErreurDeLigneNombreDeChoix = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.nombre-de-choix', _List_Nil, 'Nombre de choix non admis');
};
var $author$project$I18n$Cles$importsErreurDeLigneObligatoire = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.erreur-de-ligne.obligatoire',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'colonne',
					$author$project$I18n$Traductions$Chaine(p.j_))
				]),
			p.j_ + ' obligatoire absent');
	});
var $author$project$I18n$Cles$importsErreurDeLigneOrganisationAbsente = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.organisation-absente', _List_Nil, 'Raison sociale absente : le rattachement a besoin d\'une organisation');
};
var $author$project$I18n$Cles$importsErreurDeLigneOrganisationInconnue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.organisation-inconnue', _List_Nil, 'Organisation introuvable : jamais créée');
};
var $author$project$I18n$Cles$importsErreurDeLigneOuiNon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.oui-non', _List_Nil, 'Réponse oui ou non illisible');
};
var $author$project$I18n$Cles$importsErreurDeLignePays = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.pays', _List_Nil, 'Pays inconnu');
};
var $author$project$I18n$Cles$importsErreurDeLignePersonneIntrouvable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.personne-introuvable', _List_Nil, 'Partie prenante introuvable : jamais créée');
};
var $author$project$I18n$Cles$importsErreurDeLigneRaisonSociale = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.raison-sociale', _List_Nil, 'Raison sociale refusée');
};
var $author$project$I18n$Cles$importsErreurDeLigneTraductionManquante = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.traduction-manquante', _List_Nil, 'Traduction manquante');
};
var $author$project$I18n$Cles$importsErreurDeLigneValeurInvalide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.valeur-invalide', _List_Nil, 'Valeur invalide');
};
var $author$project$Components$Imports$Vocabulaire$erreurDeLigne = F3(
	function (i18n, colonne, code) {
		switch (code) {
			case 'obligatoire':
				return A2(
					$author$project$I18n$Cles$importsErreurDeLigneObligatoire,
					i18n,
					{
						j_: _Utils_ap(
							$elm$core$String$toUpper(
								A2($elm$core$String$left, 1, colonne)),
							A2($elm$core$String$dropLeft, 1, colonne))
					});
			case 'personne-introuvable':
				return $author$project$I18n$Cles$importsErreurDeLignePersonneIntrouvable(i18n);
			case 'organisation-inconnue':
				return $author$project$I18n$Cles$importsErreurDeLigneOrganisationInconnue(i18n);
			case 'organisation-absente':
				return $author$project$I18n$Cles$importsErreurDeLigneOrganisationAbsente(i18n);
			case 'format-email-invalide':
				return $author$project$I18n$Cles$importsErreurDeLigneFormatEmailInvalide(i18n);
			case 'format-telephone-invalide':
				return $author$project$I18n$Cles$importsErreurDeLigneFormatTelephoneInvalide(i18n);
			case 'base-legale':
				return $author$project$I18n$Cles$importsErreurDeLigneBaseLegale(i18n);
			case 'forme':
				return $author$project$I18n$Cles$importsErreurDeLigneForme(i18n);
			case 'pays':
				return $author$project$I18n$Cles$importsErreurDeLignePays(i18n);
			case 'raison_sociale':
				return $author$project$I18n$Cles$importsErreurDeLigneRaisonSociale(i18n);
			case 'inconnue':
				return $author$project$I18n$Cles$importsErreurDeLigneInconnue(i18n);
			case 'modification-refusee':
				return $author$project$I18n$Cles$importsErreurDeLigneModificationRefusee(i18n);
			case 'date-inexistante':
				return $author$project$I18n$Cles$importsErreurDeLigneDateInexistanteSansJour(i18n);
			case 'date':
				return $author$project$I18n$Cles$importsErreurDeLigneDate(i18n);
			case 'nombre':
				return $author$project$I18n$Cles$importsErreurDeLigneNombre(i18n);
			case 'mesure':
				return $author$project$I18n$Cles$importsErreurDeLigneMesure(i18n);
			case 'oui/non':
				return $author$project$I18n$Cles$importsErreurDeLigneOuiNon(i18n);
			case 'a-faire-correspondre':
				return $author$project$I18n$Cles$importsErreurDeLigneAFaireCorrespondre(i18n);
			case 'format-invalide':
				return $author$project$I18n$Cles$importsErreurDeLigneFormatInvalide(i18n);
			case 'hors-liste':
				return $author$project$I18n$Cles$importsErreurDeLigneHorsListe(i18n);
			case 'hors-bornes':
				return $author$project$I18n$Cles$importsErreurDeLigneHorsBornes(i18n);
			case 'hors-bornes-plausibles':
				return $author$project$I18n$Cles$importsErreurDeLigneHorsBornesPlausibles(i18n);
			case 'longueur':
				return $author$project$I18n$Cles$importsErreurDeLigneLongueur(i18n);
			case 'motif':
				return $author$project$I18n$Cles$importsErreurDeLigneMotif(i18n);
			case 'decimales':
				return $author$project$I18n$Cles$importsErreurDeLigneDecimales(i18n);
			case 'nombre-de-choix':
				return $author$project$I18n$Cles$importsErreurDeLigneNombreDeChoix(i18n);
			case 'choix-en-double':
				return $author$project$I18n$Cles$importsErreurDeLigneChoixEnDouble(i18n);
			case 'langue-non-admise':
				return $author$project$I18n$Cles$importsErreurDeLigneLangueNonAdmise(i18n);
			case 'traduction-manquante':
				return $author$project$I18n$Cles$importsErreurDeLigneTraductionManquante(i18n);
			case 'valeur-invalide':
				return $author$project$I18n$Cles$importsErreurDeLigneValeurInvalide(i18n);
			case 'code-manquant':
				return $author$project$I18n$Cles$importsErreurDeLigneCodeManquant(i18n);
			case 'doublon-dans-le-fichier':
				return $author$project$I18n$Cles$importsErreurDeLigneDoublonDansLeFichier(i18n);
			case 'code-d-un-autre-type':
				return $author$project$I18n$Cles$importsErreurDeLigneCodeDUnAutreType(i18n);
			case 'marque-introuvable':
				return $author$project$I18n$Cles$importsErreurDeLigneMarqueIntrouvable(i18n);
			case 'gamme-introuvable':
				return $author$project$I18n$Cles$importsErreurDeLigneGammeIntrouvable(i18n);
			case 'etage-introuvable':
				return $author$project$I18n$Cles$importsErreurDeLigneEtageIntrouvable(i18n);
			case 'etat-absent':
				return $author$project$I18n$Cles$importsErreurDeLigneEtatAbsent(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$I18n$Cles$importsErreurDeLigneDateInexistante = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.erreur-de-ligne.date-inexistante',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'jour',
					$author$project$I18n$Traductions$Chaine(p.A_)),
					_Utils_Tuple2(
					'mois',
					$author$project$I18n$Traductions$Chaine(p.CQ))
				]),
			'Date invalide : le ' + (p.A_ + (' ' + (p.CQ + ' n\'existe pas'))));
	});
var $author$project$I18n$Cles$importsErreurDeLigneMois1 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.mois-1', _List_Nil, 'janvier');
};
var $author$project$I18n$Cles$importsErreurDeLigneMois10 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.mois-10', _List_Nil, 'octobre');
};
var $author$project$I18n$Cles$importsErreurDeLigneMois11 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.mois-11', _List_Nil, 'novembre');
};
var $author$project$I18n$Cles$importsErreurDeLigneMois12 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.mois-12', _List_Nil, 'décembre');
};
var $author$project$I18n$Cles$importsErreurDeLigneMois2 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.mois-2', _List_Nil, 'février');
};
var $author$project$I18n$Cles$importsErreurDeLigneMois3 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.mois-3', _List_Nil, 'mars');
};
var $author$project$I18n$Cles$importsErreurDeLigneMois4 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.mois-4', _List_Nil, 'avril');
};
var $author$project$I18n$Cles$importsErreurDeLigneMois5 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.mois-5', _List_Nil, 'mai');
};
var $author$project$I18n$Cles$importsErreurDeLigneMois6 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.mois-6', _List_Nil, 'juin');
};
var $author$project$I18n$Cles$importsErreurDeLigneMois7 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.mois-7', _List_Nil, 'juillet');
};
var $author$project$I18n$Cles$importsErreurDeLigneMois8 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.mois-8', _List_Nil, 'août');
};
var $author$project$I18n$Cles$importsErreurDeLigneMois9 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.erreur-de-ligne.mois-9', _List_Nil, 'septembre');
};
var $author$project$Components$Imports$Vocabulaire$nomDuMois = F2(
	function (i18n, mois) {
		switch (mois) {
			case 1:
				return $author$project$I18n$Cles$importsErreurDeLigneMois1(i18n);
			case 2:
				return $author$project$I18n$Cles$importsErreurDeLigneMois2(i18n);
			case 3:
				return $author$project$I18n$Cles$importsErreurDeLigneMois3(i18n);
			case 4:
				return $author$project$I18n$Cles$importsErreurDeLigneMois4(i18n);
			case 5:
				return $author$project$I18n$Cles$importsErreurDeLigneMois5(i18n);
			case 6:
				return $author$project$I18n$Cles$importsErreurDeLigneMois6(i18n);
			case 7:
				return $author$project$I18n$Cles$importsErreurDeLigneMois7(i18n);
			case 8:
				return $author$project$I18n$Cles$importsErreurDeLigneMois8(i18n);
			case 9:
				return $author$project$I18n$Cles$importsErreurDeLigneMois9(i18n);
			case 10:
				return $author$project$I18n$Cles$importsErreurDeLigneMois10(i18n);
			case 11:
				return $author$project$I18n$Cles$importsErreurDeLigneMois11(i18n);
			default:
				return $author$project$I18n$Cles$importsErreurDeLigneMois12(i18n);
		}
	});
var $author$project$Components$Imports$Vocabulaire$erreurDeLigneDatee = F5(
	function (i18n, colonne, code, jour, mois) {
		var _v0 = _Utils_Tuple3(code, jour, mois);
		if (((_v0.a === 'date-inexistante') && (!_v0.b.$)) && (!_v0.c.$)) {
			var j = _v0.b.a;
			var m = _v0.c.a;
			return A2(
				$author$project$I18n$Cles$importsErreurDeLigneDateInexistante,
				i18n,
				{
					A_: $elm$core$String$fromInt(j),
					CQ: A2($author$project$Components$Imports$Vocabulaire$nomDuMois, i18n, m)
				});
		} else {
			return A3($author$project$Components$Imports$Vocabulaire$erreurDeLigne, i18n, colonne, code);
		}
	});
var $author$project$I18n$Cles$importsLignesAnnuler = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes.annuler', _List_Nil, 'Annuler la correction');
};
var $author$project$I18n$Cles$importsLignesAussi = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.lignes.aussi',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'lignes',
					$author$project$I18n$Traductions$Entier(p.gV)),
					_Utils_Tuple2(
					'liste',
					$author$project$I18n$Traductions$Chaine(p.nW))
				]),
			((!p.gV) || (p.gV === 1)) ? ('Aussi corrigée sur la ligne ' + p.nW) : ('Aussi corrigée sur les lignes ' + p.nW));
	});
var $author$project$I18n$Cles$importsLignesIgnoree = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes.ignoree', _List_Nil, 'Ignorée par vous');
};
var $author$project$I18n$Cles$importsLignesIgnorer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes.ignorer', _List_Nil, 'Ignorer…');
};
var $author$project$I18n$Cles$importsLignesPrete = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes.prete', _List_Nil, 'Prête');
};
var $author$project$I18n$Cles$importsLignesReprendre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes.reprendre', _List_Nil, 'Reprendre');
};
var $author$project$I18n$Cles$importsLignesValeurDeLaLigne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.lignes.valeur-de-la-ligne',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'ligne',
					$author$project$I18n$Traductions$Chaine(p.ea))
				]),
			'Valeur corrigée de la ligne ' + p.ea);
	});
var $author$project$I18n$Cles$importsLignesJointure = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.lignes.jointure',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'debut',
					$author$project$I18n$Traductions$Chaine(p.ku)),
					_Utils_Tuple2(
					'fin',
					$author$project$I18n$Traductions$Chaine(p.mI))
				]),
			p.ku + (' et ' + p.mI));
	});
var $author$project$Components$Imports$Outil$View$listeDeLignes = F2(
	function (i18n, numeros) {
		var _v0 = $elm$core$List$reverse(
			A2($elm$core$List$map, $elm$core$String$fromInt, numeros));
		if (!_v0.b) {
			return '';
		} else {
			if (!_v0.b.b) {
				var seul = _v0.a;
				return seul;
			} else {
				var dernier = _v0.a;
				var avant = _v0.b;
				return A2(
					$author$project$I18n$Cles$importsLignesJointure,
					i18n,
					{
						ku: A2(
							$elm$core$String$join,
							', ',
							$elm$core$List$reverse(avant)),
						mI: dernier
					});
			}
		}
	});
var $author$project$Components$Imports$Outil$View$surEntree = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'keydown',
		A2(
			$elm$json$Json$Decode$andThen,
			function (touche) {
				return (touche === 'Enter') ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail(touche);
			},
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)));
};
var $author$project$Components$Imports$Outil$Model$valeurAffichee = F2(
	function (lignes, ligne) {
		var _v0 = A2(
			$elm$core$Dict$get,
			_Utils_Tuple2(ligne.o9, ligne.ea),
			lignes.c7);
		if (!_v0.$) {
			var saisie = _v0.a;
			return saisie;
		} else {
			return A2($elm$core$Maybe$withDefault, ligne.fm, ligne.wf);
		}
	});
var $author$project$Components$Imports$Outil$View$ligneRejetee = F4(
	function (i18n, lignes, liste, ligne) {
		var prete = ligne.nh === 'prete';
		var peut = function (rel) {
			return !_Utils_eq(
				A2($author$project$API$Liens$trouver, rel, liste.nQ),
				$elm$core$Maybe$Nothing);
		};
		var lien = F2(
			function (msg, libelle) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('lien-de-geste'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						]));
			});
		var ignoree = ligne.nh === 'ignoree';
		var cle = _Utils_Tuple2(ligne.o9, ligne.ea);
		var refus = A2($elm$core$Dict$get, cle, lignes.pZ);
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('prete', prete),
							_Utils_Tuple2('ignoree', ignoree),
							_Utils_Tuple2(
							'en-erreur',
							(!_Utils_eq(refus, $elm$core$Maybe$Nothing)) || (ligne.nh === 'a-corriger'))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(ligne.ea))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('licencie')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', ligne.Bv))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(ligne.j_)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							ignoree ? A2(
							$rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur'),
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
									$rtfeldman$elm_css$Html$Styled$Attributes$value(ligne.fm),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									A2(
										$author$project$I18n$Cles$importsLignesValeurDeLaLigne,
										i18n,
										{
											ea: $elm$core$String$fromInt(ligne.ea)
										}))
								]),
							_List_Nil) : A2(
							$rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur'),
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
									$rtfeldman$elm_css$Html$Styled$Attributes$value(
									A2($author$project$Components$Imports$Outil$Model$valeurAffichee, lignes, ligne)),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
									!peut($author$project$API$NavLinksDictionary$corrigerUneLigne)),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									A2(
										$author$project$I18n$Cles$importsLignesValeurDeLaLigne,
										i18n,
										{
											ea: $elm$core$String$fromInt(ligne.ea)
										})),
									$rtfeldman$elm_css$Html$Styled$Events$onInput(
									A2($author$project$Components$Imports$Outil$Update$ValeurDeLigneSaisie, ligne.o9, ligne.ea)),
									$author$project$Components$Imports$Outil$View$surEntree(
									A2($author$project$Components$Imports$Outil$Update$LigneCorrigee, ligne.o9, ligne.ea))
								]),
							_List_Nil),
							function () {
							var _v0 = ligne.t0;
							if (!_v0.b) {
								return $rtfeldman$elm_css$Html$Styled$text('');
							} else {
								var autres = _v0;
								return A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('aussi')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$importsLignesAussi,
												i18n,
												{
													gV: $elm$core$List$length(autres),
													nW: A2($author$project$Components$Imports$Outil$View$listeDeLignes, i18n, autres)
												}))
										]));
							}
						}()
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							ignoree ? A2(
							$author$project$Components$Shared$Tag$View$view,
							3,
							$author$project$I18n$Cles$importsLignesIgnoree(i18n)) : ((prete && _Utils_eq(refus, $elm$core$Maybe$Nothing)) ? A2(
							$author$project$Components$Shared$Tag$View$view,
							0,
							$author$project$I18n$Cles$importsLignesPrete(i18n)) : A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('erreur')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A5(
										$author$project$Components$Imports$Vocabulaire$erreurDeLigneDatee,
										i18n,
										ligne.j_,
										A2($elm$core$Maybe$withDefault, ligne.go, refus),
										ligne.A_,
										ligne.CQ))
								])))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('gestes')
						]),
					_List_fromArray(
						[
							ignoree ? (peut($author$project$API$NavLinksDictionary$reprendreUneLigne) ? A2(
							lien,
							A2($author$project$Components$Imports$Outil$Update$LigneReprise, ligne.o9, ligne.ea),
							$author$project$I18n$Cles$importsLignesReprendre(i18n)) : $rtfeldman$elm_css$Html$Styled$text('')) : (prete ? (peut($author$project$API$NavLinksDictionary$annulerLaCorrection) ? A2(
							lien,
							A2($author$project$Components$Imports$Outil$Update$CorrectionAnnulee, ligne.o9, ligne.ea),
							$author$project$I18n$Cles$importsLignesAnnuler(i18n)) : $rtfeldman$elm_css$Html$Styled$text('')) : (peut($author$project$API$NavLinksDictionary$ignorerUneLigne) ? A2(
							lien,
							A2($author$project$Components$Imports$Outil$Update$LigneIgnoree, ligne.o9, ligne.ea),
							$author$project$I18n$Cles$importsLignesIgnorer(i18n)) : $rtfeldman$elm_css$Html$Styled$text('')))
						]))
				]));
	});
var $author$project$Components$Imports$Outil$View$lignesRejetees = F3(
	function (i18n, model, lignes) {
		var _v0 = lignes.nW;
		if (_v0.$ === 1) {
			return _List_fromArray(
				[
					lignes.gd ? A2(
					$author$project$Components$Shared$Note$View$view,
					2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$importsLignesEchec(i18n))
						])) : $rtfeldman$elm_css$Html$Styled$text('')
				]);
		} else {
			var liste = _v0.a;
			return _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Note$View$view,
					0,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$importsLignesBandeauTitre,
										i18n,
										{
											gp: $elm$core$String$fromInt(liste.sE),
											Aw: liste.Aw,
											Gj: liste.Gj
										}))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$importsLignesBandeauTexte(i18n))
								]))
						])),
					function () {
					var _v1 = model.pZ;
					if (!_v1.$) {
						if (_v1.a.$ === 12) {
							var _v2 = _v1.a;
							return A2(
								$author$project$Components$Shared$Note$View$view,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsLignesDejaTraitee(i18n))
									]));
						} else {
							return A2(
								$author$project$Components$Shared$Note$View$view,
								2,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsLignesRefus(i18n))
									]));
						}
					} else {
						return $rtfeldman$elm_css$Html$Styled$text('');
					}
				}(),
					A2(
					$rtfeldman$elm_css$Html$Styled$section,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('lignes-rejetees')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h2,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$importsLignesListeTitre(i18n)),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$elm$core$String$fromInt(liste.sE))
												]))
										])),
									A3($author$project$Components$Imports$Outil$View$filtresDesLignes, i18n, lignes, liste)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
								]),
							_List_fromArray(
								[
									$elm$core$List$isEmpty(liste.gV) ? A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$importsLignesVide(i18n))
										])) : A2(
									$rtfeldman$elm_css$Html$Styled$table,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('lignes-a-corriger')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$thead,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$tr,
													_List_Nil,
													A2(
														$elm$core$List$map,
														function (e) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$th,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(e)
																	]));
														},
														_List_fromArray(
															[
																$author$project$I18n$Cles$importsSimulationColonneLigne(i18n),
																$author$project$I18n$Cles$importsLignesColonneLicencie(i18n),
																$author$project$I18n$Cles$importsSimulationColonneColonne(i18n),
																$author$project$I18n$Cles$importsLignesColonneValeur(i18n),
																$author$project$I18n$Cles$importsSimulationColonneErreur(i18n),
																''
															])))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$tbody,
											_List_Nil,
											A2(
												$elm$core$List$map,
												A3($author$project$Components$Imports$Outil$View$ligneRejetee, i18n, lignes, liste),
												liste.gV))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('pagination')
										]),
									_List_fromArray(
										[
											(lignes.EE > 1) ? A3(
											$author$project$Components$Shared$Bouton$View$bouton,
											2,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Events$onClick(
													$author$project$Components$Imports$Outil$Update$PageDeLignesChoisie(lignes.EE - 1))
												]),
											$author$project$I18n$Cles$importsLignesPrecedente(i18n)) : $rtfeldman$elm_css$Html$Styled$text(''),
											(_Utils_cmp(lignes.EE * liste.Jm, liste.JE) < 0) ? A3(
											$author$project$Components$Shared$Bouton$View$bouton,
											2,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Events$onClick(
													$author$project$Components$Imports$Outil$Update$PageDeLignesChoisie(lignes.EE + 1))
												]),
											$author$project$I18n$Cles$importsLignesSuivante(i18n)) : $rtfeldman$elm_css$Html$Styled$text('')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$importsLignesPiedListe,
												i18n,
												{
													dk: $elm$core$List$length(liste.gV),
													JE: $elm$core$String$fromInt(liste.JE)
												}))
										]))
								]))
						]))
				]);
		}
	});
var $author$project$I18n$Cles$importsLotAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lot.aide', _List_Nil, 'Aucune fiche n\'est écrite : la simulation vient à l\'étape suivante.');
};
var $author$project$I18n$Cles$importsLotDejaImporte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.lot.deja-importe',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Ce fichier a déjà été importé le ' + (p.wv + '.'));
	});
var $author$project$I18n$Cles$importsLotPart = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.lot.part',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'feuille',
					$author$project$I18n$Traductions$Chaine(p.mx)),
					_Utils_Tuple2(
					'lignes',
					$author$project$I18n$Traductions$Chaine(p.gV)),
					_Utils_Tuple2(
					'colonnes',
					$author$project$I18n$Traductions$Chaine(p.j1))
				]),
			p.mx + (' · lignes : ' + (p.gV + (' · colonnes en correspondance : ' + p.j1))));
	});
var $author$project$I18n$Cles$importsLotTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.lot.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Lot préparé : ' + p.Dj);
	});
var $author$project$Components$Imports$Outil$View$lotPrepare = F2(
	function (i18n, model) {
		var _v0 = model.n0;
		if (!_v0.$) {
			var lot = _v0.a;
			return A3(
				$author$project$Components$Imports$Outil$View$section,
				'lot',
				A2(
					$author$project$I18n$Cles$importsLotTitre,
					i18n,
					{Dj: lot.Dj}),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						function (part) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('part')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$importsLotPart,
											i18n,
											{
												j1: $elm$core$String$fromInt(part.Dx),
												mx: part.dy,
												gV: $elm$core$String$fromInt(part.g9)
											}))
									]));
						},
						lot.pb),
					_Utils_ap(
						function () {
							var _v1 = lot.w$;
							if (!_v1.$) {
								var le = _v1.a;
								return _List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Note$View$view,
										1,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$importsLotDejaImporte,
													i18n,
													{
														wv: A2($elm$core$String$left, 10, le)
													}))
											]))
									]);
							} else {
								return _List_Nil;
							}
						}(),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsLotAide(i18n))
									]))
							]))));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Imports$Outil$Update$RepartitionDemandee = {$: 53};
var $author$project$Components$Imports$Outil$Update$RepartitionRetiree = {$: 56};
var $author$project$Components$Imports$Outil$View$enteteDe = F2(
	function (model, index) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ym;
					},
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$drop(index),
						$elm$core$List$head)),
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.zn;
						},
						$elm$core$List$head),
					model.tq)));
	});
var $author$project$I18n$Cles$importsRepartitionColonneQuiRepartit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.repartition.colonne-qui-repartit', _List_Nil, 'Colonne qui répartit les lignes');
};
var $author$project$I18n$Cles$importsRepartitionDistinctes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.repartition.distinctes', _List_Nil, 'Valeurs distinctes');
};
var $author$project$I18n$Cles$importsRepartitionDistinctesEtVides = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.repartition.distinctes-et-vides',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' type et des lignes vides') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' types et des lignes vides'));
	});
var $author$project$I18n$Cles$importsRepartitionDistinctesSeules = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.repartition.distinctes-seules',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' type') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' types'));
	});
var $author$project$I18n$Cles$importsRepartitionRegle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.repartition.regle', _List_Nil, 'Chaque valeur devient une part et reçoit n\'importe quelle cible autorisée (un type de partie prenante comme un type de produit), puis sa correspondance de colonnes, comme une feuille d\'un classeur. Une colonne sans champ dans un type est ignorée pour ce type.');
};
var $author$project$I18n$Cles$importsRepartitionRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.repartition.retirer', _List_Nil, 'Ne plus répartir');
};
var $author$project$I18n$Cles$importsRepartitionSection = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.repartition.section', _List_Nil, 'Colonne « Type »');
};
var $author$project$Components$Imports$Outil$View$colonneType = F2(
	function (i18n, model) {
		var index = A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$List$head(
				A2(
					$elm$core$List$filterMap,
					function ($) {
						return $.o5;
					},
					model.pb)));
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('colonne-type')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$importsRepartitionSection(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('gestes')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									2,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Imports$Outil$Update$RepartitionRetiree)
										]),
									$author$project$I18n$Cles$importsRepartitionRetirer(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('kv')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$importsRepartitionColonneQuiRepartit(i18n))
										])),
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('champ'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Imports$Outil$Update$RepartitionDemandee)
										]),
									A2($author$project$Components$Imports$Outil$View$enteteDe, model, index))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('kv')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$importsRepartitionDistinctes(i18n))
										])),
									$rtfeldman$elm_css$Html$Styled$text(
									(model.gW > 0) ? A2(
										$author$project$I18n$Cles$importsRepartitionDistinctesEtVides,
										i18n,
										{
											d: $elm$core$List$length(model.pb)
										}) : A2(
										$author$project$I18n$Cles$importsRepartitionDistinctesSeules,
										i18n,
										{
											d: $elm$core$List$length(model.pb)
										}))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$importsRepartitionRegle(i18n))
								]))
						]))
				]));
	});
var $author$project$Components$Imports$Outil$View$estUnCsv = function (model) {
	return !_Utils_eq(
		A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.IF;
			},
			model.tq),
		$elm$core$Maybe$Nothing);
};
var $author$project$I18n$Cles$importsPartsCible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.parts.cible', _List_Nil, 'Cible');
};
var $author$project$I18n$Cles$importsPartsFeuille = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.parts.feuille', _List_Nil, 'Feuille');
};
var $author$project$I18n$Cles$importsPartsLignes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.parts.lignes', _List_Nil, 'Lignes');
};
var $author$project$I18n$Cles$importsPartsModele = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.parts.modele', _List_Nil, 'Modèle du type');
};
var $author$project$I18n$Cles$importsPartsReglage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.parts.reglage', _List_Nil, 'Si la fiche existe déjà');
};
var $author$project$I18n$Cles$importsPartsSansCible = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.parts.sans-cible',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' part sans cible') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' parts sans cible'));
	});
var $author$project$I18n$Cles$importsPartsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.parts.titre', _List_Nil, 'Parts du fichier : une par feuille');
};
var $author$project$Components$Imports$Outil$Update$CibleDemandee = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Imports$Outil$Update$CibleProposeeRetenue = function (a) {
	return {$: 61, a: a};
};
var $author$project$Components$Imports$Outil$Update$ReglagesDemandes = function (a) {
	return {$: 18, a: a};
};
var $author$project$I18n$Cles$importsCibleChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.cible.choisir', _List_Nil, 'Choisir la cible');
};
var $author$project$I18n$Cles$importsCibleIgnoree = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.cible.ignoree', _List_Nil, 'Ignorée');
};
var $author$project$I18n$Cles$importsCibleProposee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.cible.proposee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'cible',
					$author$project$I18n$Traductions$Chaine(p.vf))
				]),
			'Proposée : ' + p.vf);
	});
var $author$project$I18n$Cles$importsCibleUtiliser = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.cible.utiliser', _List_Nil, 'Utiliser cette cible');
};
var $author$project$I18n$Cles$importsPartsToutLeFichier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.parts.tout-le-fichier', _List_Nil, 'Tout le fichier');
};
var $author$project$I18n$Cles$importsPartsUneSeuleFeuille = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.parts.une-seule-feuille', _List_Nil, 'une seule feuille');
};
var $author$project$I18n$Cles$importsReglagesACompleter = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.reglages.a-completer',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' réglage à compléter') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' réglages à compléter'));
	});
var $author$project$I18n$Cles$importsRepartitionAucuneCible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.repartition.aucune-cible', _List_Nil, 'Aucune cible');
};
var $author$project$Components$Imports$Outil$View$libelleAvecDomaine = F2(
	function (i18n, cible) {
		return (cible.cC === 'catalogue') ? (A2($author$project$Components$Imports$Vocabulaire$domaine, i18n, cible.cC) + (' · ' + cible.Bl)) : cible.Bl;
	});
var $author$project$Components$Imports$Outil$Model$modelesDe = F2(
	function (part, model) {
		var _v0 = _Utils_Tuple2(part.vf, model.cN);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var _v1 = _v0.a.a;
			var domaine = _v1.a;
			var type_ = _v1.b;
			var imports = _v0.b.a;
			return A2(
				$elm$core$List$filter,
				function (modele) {
					return _Utils_eq(modele.cC, domaine) && _Utils_eq(modele.r0, type_);
				},
				imports.CI);
		} else {
			return _List_Nil;
		}
	});
var $author$project$I18n$Cles$importsSiExisteCompleter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.si-existe.completer', _List_Nil, 'Compléter les champs vides');
};
var $author$project$I18n$Cles$importsSiExisteMettreAJour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.si-existe.mettre-a-jour', _List_Nil, 'Mettre à jour');
};
var $author$project$I18n$Cles$importsSiExisteNeRienModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.si-existe.ne-rien-modifier', _List_Nil, 'Ne rien modifier');
};
var $author$project$Components$Imports$Vocabulaire$siExiste = F2(
	function (i18n, code) {
		switch (code) {
			case 'completer':
				return $author$project$I18n$Cles$importsSiExisteCompleter(i18n);
			case 'mettre-a-jour':
				return $author$project$I18n$Cles$importsSiExisteMettreAJour(i18n);
			case 'ne-rien-modifier':
				return $author$project$I18n$Cles$importsSiExisteNeRienModifier(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$Components$Imports$Outil$View$ligneDePart = F3(
	function (i18n, model, part) {
		var fichierPlat = $author$project$Components$Imports$Outil$View$estUnCsv(model) && _Utils_eq(part.o5, $elm$core$Maybe$Nothing);
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'ignoree',
							_Utils_eq(part.vf, $elm$core$Maybe$Nothing))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					fichierPlat ? _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$importsPartsToutLeFichier(i18n))
								])),
							A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$importsPartsUneSeuleFeuille(i18n))
								]))
						]) : _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(part.mx)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('num')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(part.g9))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_Utils_ap(
						(fichierPlat && _Utils_eq(part.vf, $elm$core$Maybe$Nothing)) ? _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('champ', true),
												_Utils_Tuple2('erreur', true)
											]))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsRepartitionAucuneCible(i18n))
									]))
							]) : (fichierPlat ? _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Components$Imports$Outil$View$libelleAvecDomaine(i18n),
												A2($author$project$Components$Imports$Outil$Model$cibleDe, part, model))))
									]))
							]) : _List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								2,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Imports$Outil$Update$CibleDemandee(part.mx))
									]),
								A2(
									$elm$core$Maybe$withDefault,
									$author$project$I18n$Cles$importsCibleChoisir(i18n),
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.Bl;
										},
										A2($author$project$Components$Imports$Outil$Model$cibleDe, part, model))))
							])),
						function () {
							var _v0 = $author$project$Components$Imports$Outil$Model$cibleProposee(part);
							if (!_v0.$) {
								var proposee = _v0.a;
								return _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('proposee')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$importsCibleProposee,
													i18n,
													{vf: proposee.Bl}))
											])),
										A3(
										$author$project$Components$Shared$Bouton$View$bouton,
										2,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												$author$project$Components$Imports$Outil$Update$CibleProposeeRetenue(part.mx))
											]),
										$author$project$I18n$Cles$importsCibleUtiliser(i18n))
									]);
							} else {
								return _List_Nil;
							}
						}())),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					function () {
						var _v1 = A2($author$project$Components$Imports$Outil$Model$modelesDe, part, model);
						if (!_v1.b) {
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mut')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('—')
										]))
								]);
						} else {
							var modeles = _v1;
							return _List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$elm$core$String$join,
										', ',
										A2(
											$elm$core$List$map,
											function ($) {
												return $.Dj;
											},
											modeles)))
								]);
						}
					}()),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_Utils_eq(part.vf, $elm$core$Maybe$Nothing) ? _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('mut')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$importsCibleIgnoree(i18n))
								]))
						]) : _List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							2,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Imports$Outil$Update$ReglagesDemandes(part.mx))
								]),
							A2($author$project$Components$Imports$Vocabulaire$siExiste, i18n, part.IM)),
							function () {
							var _v2 = A2($author$project$Components$Imports$Outil$Model$reglagesManquants, part, model);
							if (!_v2.b) {
								return $rtfeldman$elm_css$Html$Styled$text('');
							} else {
								var manquants = _v2;
								return A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('tag'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('warning')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$importsReglagesACompleter,
												i18n,
												{
													d: $elm$core$List$length(manquants)
												}))
										]));
							}
						}()
						]))
				]));
	});
var $author$project$I18n$Cles$importsRepartitionErreurTypeInconnu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.repartition.erreur-type-inconnu', _List_Nil, 'Erreur de ligne · « Type inconnu »');
};
var $author$project$I18n$Cles$importsRepartitionVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.repartition.vide', _List_Nil, '(vide)');
};
var $author$project$Components$Imports$Outil$View$ligneSansType = F3(
	function (i18n, avecModele, model) {
		return (model.gW > 0) ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$tr,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('sans-type')
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$td,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('col-ex')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$importsRepartitionVide(i18n))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$td,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('num')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$elm$core$String$fromInt(model.gW))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$td,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('champ', true),
													_Utils_Tuple2('erreur', true)
												]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$importsRepartitionAucuneCible(i18n))
										]))
								]))
						]),
					_Utils_ap(
						avecModele ? _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$td,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mut')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('—')
											]))
									]))
							]) : _List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$td,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Tag$View$view,
										2,
										$author$project$I18n$Cles$importsRepartitionErreurTypeInconnu(i18n))
									]))
							]))))
			]) : _List_Nil;
	});
var $author$project$Components$Imports$Outil$View$choisirLaCibleDuFichier = F2(
	function (i18n, model) {
		var _v0 = model.pb;
		if (_v0.b) {
			var part = _v0.a;
			return A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Imports$Outil$Update$CibleDemandee(part.mx))
					]),
				$author$project$I18n$Cles$importsCibleChoisir(i18n));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$importsPartsRepartie = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.parts.repartie',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'colonne',
					$author$project$I18n$Traductions$Chaine(p.j_))
				]),
			'Fichier réparti par la colonne « ' + (p.j_ + ' »'));
	});
var $author$project$I18n$Cles$importsPartsRepartir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.parts.repartir', _List_Nil, 'Répartir par une colonne');
};
var $author$project$I18n$Cles$importsRepartitionSansType = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.repartition.sans-type',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'lignes',
					$author$project$I18n$Traductions$Entier(p.gV))
				]),
			((!p.gV) || (p.gV === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.gV) + ' ligne sans type : elle sera en erreur de ligne « Type inconnu ».') : (A2($author$project$I18n$Nombre$formater, 0, p.gV) + ' lignes sans type : elles seront en erreur de ligne « Type inconnu ».'));
	});
var $author$project$I18n$Cles$importsRepartitionTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.repartition.titre', _List_Nil, 'Répartir par une colonne');
};
var $author$project$Components$Imports$Outil$View$repartition = F2(
	function (i18n, model) {
		var reparti = $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function ($) {
					return $.o5;
				},
				model.pb));
		var entete = function (index) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.ym;
						},
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$drop(index),
							$elm$core$List$head)),
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.zn;
							},
							$elm$core$List$head),
						model.tq)));
		};
		var csv = !_Utils_eq(
			$elm$core$Maybe$Nothing,
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.IF;
				},
				model.tq));
		var _v0 = _Utils_Tuple2(
			reparti,
			csv && (!_Utils_eq(
				A2($author$project$Components$Imports$Outil$Model$lienDe, $author$project$API$NavLinksDictionary$valeursDuFichier, model),
				$elm$core$Maybe$Nothing)));
		if (!_v0.a.$) {
			var index = _v0.a.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('repartition')
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$importsPartsRepartie,
										i18n,
										{
											j_: entete(index)
										}))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('gestes')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									2,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Imports$Outil$Update$RepartitionDemandee)
										]),
									$author$project$I18n$Cles$importsRepartitionTitre(i18n)),
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									2,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Imports$Outil$Update$RepartitionRetiree)
										]),
									$author$project$I18n$Cles$importsRepartitionRetirer(i18n))
								]))
						]),
					(model.gW > 0) ? _List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Note$View$view,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$importsRepartitionSansType,
										i18n,
										{gV: model.gW}))
								]))
						]) : _List_Nil));
		} else {
			if (_v0.b) {
				var _v1 = _v0.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('repartition')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('gestes')
								]),
							_List_fromArray(
								[
									A2($author$project$Components$Imports$Outil$View$choisirLaCibleDuFichier, i18n, model),
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									2,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Imports$Outil$Update$RepartitionDemandee)
										]),
									$author$project$I18n$Cles$importsPartsRepartir(i18n))
								]))
						]));
			} else {
				return csv ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('repartition')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('gestes')
								]),
							_List_fromArray(
								[
									A2($author$project$Components$Imports$Outil$View$choisirLaCibleDuFichier, i18n, model)
								]))
						])) : $rtfeldman$elm_css$Html$Styled$text('');
			}
		}
	});
var $author$project$Components$Imports$Outil$View$partsParFeuille = F2(
	function (i18n, model) {
		var sansCible = $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (part) {
					return _Utils_eq(part.vf, $elm$core$Maybe$Nothing);
				},
				model.pb));
		return A3(
			$author$project$Components$Imports$Outil$View$section,
			'parts',
			$author$project$I18n$Cles$importsPartsTitre(i18n),
			_List_fromArray(
				[
					((sansCible > 0) && $author$project$Components$Imports$Outil$View$estUnCsv(model)) ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('chips')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							2,
							A2(
								$author$project$I18n$Cles$importsPartsSansCible,
								i18n,
								{d: sansCible}))
						])) : $rtfeldman$elm_css$Html$Styled$text(''),
					A2(
					$rtfeldman$elm_css$Html$Styled$table,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$importsPartsFeuille(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col'),
													$rtfeldman$elm_css$Html$Styled$Attributes$class('num')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$importsPartsLignes(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$importsPartsCible(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$importsPartsModele(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$importsPartsReglage(i18n))
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$tbody,
							_List_Nil,
							_Utils_ap(
								A2(
									$elm$core$List$map,
									A2($author$project$Components$Imports$Outil$View$ligneDePart, i18n, model),
									model.pb),
								A3($author$project$Components$Imports$Outil$View$ligneSansType, i18n, true, model)))
						])),
					A2($author$project$Components$Imports$Outil$View$repartition, i18n, model)
				]));
	});
var $author$project$I18n$Cles$importsRepartitionEnteteValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.repartition.entete-valeur', _List_Nil, 'Valeur');
};
var $author$project$I18n$Cles$importsRepartitionSansCible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.repartition.sans-cible', _List_Nil, 'Sans cible, elles seront en erreur de ligne « Type inconnu ». Choisissez « Ignorer » pour les écarter sans erreur.');
};
var $author$project$I18n$Cles$importsRepartitionSansColonne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.repartition.sans-colonne',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'lignes',
					$author$project$I18n$Traductions$Entier(p.gV)),
					_Utils_Tuple2(
					'colonne',
					$author$project$I18n$Traductions$Chaine(p.j_))
				]),
			((!p.gV) || (p.gV === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.gV) + (' ligne sans ' + p.j_)) : (A2($author$project$I18n$Nombre$formater, 0, p.gV) + (' lignes sans ' + p.j_)));
	});
var $author$project$I18n$Cles$importsRepartitionValeursTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.repartition.valeurs-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'colonne',
					$author$project$I18n$Traductions$Chaine(p.j_))
				]),
			'Valeurs de la colonne « ' + (p.j_ + ' »'));
	});
var $author$project$I18n$Cles$importsRepartitionReconnueTag = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.repartition.reconnue-tag', _List_Nil, 'Reconnue');
};
var $author$project$Components$Imports$Outil$View$ligneDeValeurRepartie = F3(
	function (i18n, model, part) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('col-ex')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(part.mx)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('num')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(part.g9))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('champ'),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Imports$Outil$Update$CibleDemandee(part.mx))
								]),
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$I18n$Cles$importsCibleChoisir(i18n),
								A2(
									$elm$core$Maybe$map,
									$author$project$Components$Imports$Outil$View$libelleAvecDomaine(i18n),
									A2($author$project$Components$Imports$Outil$Model$cibleDe, part, model)))),
							function () {
							var _v0 = $author$project$Components$Imports$Outil$Model$cibleProposee(part);
							if (!_v0.$) {
								var proposee = _v0.a;
								return A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('proposee')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$importsCibleProposee,
												i18n,
												{vf: proposee.Bl}))
										]));
							} else {
								return $rtfeldman$elm_css$Html$Styled$text('');
							}
						}()
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							(!_Utils_eq(part.vf, $elm$core$Maybe$Nothing)) ? A2(
							$author$project$Components$Shared$Tag$View$view,
							0,
							$author$project$I18n$Cles$importsRepartitionReconnueTag(i18n)) : A2(
							$author$project$Components$Shared$Tag$View$view,
							1,
							$author$project$I18n$Cles$importsCibleChoisir(i18n))
						]))
				]));
	});
var $author$project$Components$Imports$Outil$View$valeursDeLaColonneType = F2(
	function (i18n, model) {
		var colonne = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$Imports$Outil$View$enteteDe(model),
				$elm$core$List$head(
					A2(
						$elm$core$List$filterMap,
						function ($) {
							return $.o5;
						},
						model.pb))));
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('valeurs-de-la-colonne')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$importsRepartitionValeursTitre,
										i18n,
										{j_: colonne})),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$elm$core$String$fromInt(
												$elm$core$List$length(model.pb) + ((model.gW > 0) ? 1 : 0)))
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					_List_fromArray(
						[
							(model.gW > 0) ? A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('alerte', true),
											_Utils_Tuple2('avertissement', true)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$importsRepartitionSansColonne,
												i18n,
												{
													j_: $elm$core$String$toLower(colonne),
													gV: model.gW
												}))
										])),
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$importsRepartitionSansCible(i18n))
								])) : $rtfeldman$elm_css$Html$Styled$text(''),
							A2(
							$rtfeldman$elm_css$Html$Styled$table,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$thead,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$tr,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$importsRepartitionEnteteValeur(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col'),
															$rtfeldman$elm_css$Html$Styled$Attributes$class('num')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$importsPartsLignes(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$importsPartsCible(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$importsColonnesControle(i18n))
														]))
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$tbody,
									_List_Nil,
									_Utils_ap(
										A3($author$project$Components$Imports$Outil$View$ligneSansType, i18n, false, model),
										A2(
											$elm$core$List$map,
											A2($author$project$Components$Imports$Outil$View$ligneDeValeurRepartie, i18n, model),
											model.pb)))
								]))
						]))
				]));
	});
var $author$project$Components$Imports$Outil$View$parts = F2(
	function (i18n, model) {
		return A2(
			$elm$core$List$any,
			function (part) {
				return !_Utils_eq(part.o5, $elm$core$Maybe$Nothing);
			},
			model.pb) ? _List_fromArray(
			[
				A2($author$project$Components$Imports$Outil$View$colonneType, i18n, model),
				A2($author$project$Components$Imports$Outil$View$valeursDeLaColonneType, i18n, model)
			]) : _List_fromArray(
			[
				A2($author$project$Components$Imports$Outil$View$partsParFeuille, i18n, model)
			]);
	});
var $author$project$I18n$Cles$importsLotsAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lots.aide', _List_Nil, 'Les imports commencés, simulés ou appliqués se retrouvent dans l\'historique.');
};
var $author$project$I18n$Cles$importsLotsAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lots.aucun', _List_Nil, 'Aucun import en préparation.');
};
var $author$project$I18n$Cles$importsLotsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lots.titre', _List_Nil, 'Reprendre un travail');
};
var $author$project$Components$Imports$Outil$Update$LotRepris = function (a) {
	return {$: 59, a: a};
};
var $author$project$I18n$Cles$importsLotsPart = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.lots.part',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'part',
					$author$project$I18n$Traductions$Chaine(p.o9)),
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (p.o9 + (' · ' + (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' ligne'))) : (p.o9 + (' · ' + (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' lignes'))));
	});
var $author$project$I18n$Cles$importsLotsPrepare = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.lots.prepare',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv)),
					_Utils_Tuple2(
					'taille',
					$author$project$I18n$Traductions$Chaine(p.Jm))
				]),
			'Préparé le ' + (p.wv + (' · ' + p.Jm)));
	});
var $author$project$I18n$Cles$importsLotsReprendre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lots.reprendre', _List_Nil, 'Reprendre');
};
var $author$project$Components$Imports$Outil$View$taille = function (octets) {
	return (octets >= 1000000) ? ($elm$core$String$fromInt(
		$elm$core$Basics$round(octets / 1000000)) + ' Mo') : ($elm$core$String$fromInt(
		A2(
			$elm$core$Basics$max,
			1,
			$elm$core$Basics$round(octets / 1000))) + ' Ko');
};
var $author$project$Components$Imports$Outil$View$unLotEnPreparation = F2(
	function (i18n, lot) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('sub-card'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('lot-en-preparation')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(lot.Dj)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$importsLotsPrepare,
										i18n,
										{
											wv: $author$project$Components$Imports$Outil$Model$valeurLue(
												A2($elm$core$String$left, 10, lot.Gh)),
											Jm: $author$project$Components$Imports$Outil$View$taille(lot.oW)
										}))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('chips')
								]),
							A2(
								$elm$core$List$map,
								function (part) {
									return A2(
										$author$project$Components$Shared$Tag$View$view,
										3,
										A2(
											$author$project$I18n$Cles$importsLotsPart,
											i18n,
											{
												d: part.g9,
												o9: A2($elm$core$Maybe$withDefault, part.dy, part.mx)
											}));
								},
								lot.pb))
						])),
					function () {
					var _v0 = lot.nB;
					if (!_v0.$) {
						var lien = _v0.a;
						return A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Imports$Outil$Update$LotRepris(lien))
								]),
							$author$project$I18n$Cles$importsLotsReprendre(i18n));
					} else {
						return $rtfeldman$elm_css$Html$Styled$text('');
					}
				}()
				]));
	});
var $author$project$Components$Imports$Outil$View$reprendreUnTravail = F2(
	function (i18n, model) {
		var _v0 = model.n2;
		if (_v0.$ === 1) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var lots = _v0.a;
			return A3(
				$author$project$Components$Imports$Outil$View$section,
				'reprendre-un-travail',
				$author$project$I18n$Cles$importsLotsTitre(i18n),
				$elm$core$List$isEmpty(lots) ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mut')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$importsLotsAucun(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$importsLotsAide(i18n))
							]))
					]) : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('lots')
							]),
						A2(
							$elm$core$List$map,
							$author$project$Components$Imports$Outil$View$unLotEnPreparation(i18n),
							lots))
					]));
		}
	});
var $author$project$Components$Imports$Outil$Model$catalogueSeul = function (model) {
	var cibles = A2(
		$elm$core$List$filterMap,
		function ($) {
			return $.vf;
		},
		model.pb);
	return (!$elm$core$List$isEmpty(cibles)) && A2(
		$elm$core$List$all,
		function (_v0) {
			var domaine = _v0.a;
			return domaine === 'catalogue';
		},
		cibles);
};
var $author$project$Components$Imports$Outil$View$compteursDeSimulation = F2(
	function (i18n, c) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('compteurs')
				]),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var nom = _v0.a;
					var n = _v0.b;
					var libelle = _v0.c;
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('compteur'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(nom)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$elm$core$String$fromInt(n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(libelle)
									]))
							]));
				},
				_List_fromArray(
					[
						_Utils_Tuple3(
						'creees',
						c.wo,
						$author$project$I18n$Cles$importsCompteurCreees(i18n)),
						_Utils_Tuple3(
						'modifiees',
						c.CP,
						$author$project$I18n$Cles$importsCompteurModifiees(i18n)),
						_Utils_Tuple3(
						'doublons',
						c.kW,
						$author$project$I18n$Cles$importsCompteurDoublons(i18n)),
						_Utils_Tuple3(
						'erreurs',
						c.gp,
						$author$project$I18n$Cles$importsCompteurErreurs(i18n)),
						_Utils_Tuple3(
						'effacees',
						c.x8,
						$author$project$I18n$Cles$importsCompteurEffacees(i18n))
					])));
	});
var $author$project$I18n$Cles$importsCompteurReferencesCreees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.compteur.references-creees', _List_Nil, 'références créées');
};
var $author$project$I18n$Cles$importsCompteurReferencesModifiees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.compteur.references-modifiees', _List_Nil, 'références mises à jour (code connu)');
};
var $author$project$I18n$Cles$importsCompteurReferencesSansChangement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.compteur.references-sans-changement', _List_Nil, 'références sans changement');
};
var $author$project$Components$Imports$Outil$View$compteursDeSimulationDuCatalogue = F2(
	function (i18n, c) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('compteurs')
				]),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var nom = _v0.a;
					var n = _v0.b;
					var libelle = _v0.c;
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('compteur'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(nom)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$elm$core$String$fromInt(n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(libelle)
									]))
							]));
				},
				_Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple3(
							'creees',
							c.wo,
							$author$project$I18n$Cles$importsCompteurReferencesCreees(i18n)),
							_Utils_Tuple3(
							'modifiees',
							c.CP,
							$author$project$I18n$Cles$importsCompteurReferencesModifiees(i18n))
						]),
					_Utils_ap(
						(c.qY > 0) ? _List_fromArray(
							[
								_Utils_Tuple3(
								'sans-changement',
								c.qY,
								$author$project$I18n$Cles$importsCompteurReferencesSansChangement(i18n))
							]) : _List_Nil,
						_List_fromArray(
							[
								_Utils_Tuple3(
								'erreurs',
								c.gp,
								$author$project$I18n$Cles$importsCompteurErreurs(i18n))
							])))));
	});
var $author$project$I18n$Cles$importsSimulationColonneDansLeFichier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.simulation.colonne.dans-le-fichier', _List_Nil, 'Dans le fichier');
};
var $author$project$I18n$Cles$importsSimulationColonneFicheExistante = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.simulation.colonne.fiche-existante', _List_Nil, 'Fiche existante');
};
var $author$project$I18n$Cles$importsSimulationColonneRaison = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.simulation.colonne.raison', _List_Nil, 'Raison');
};
var $author$project$I18n$Cles$importsSimulationDoublonsAide = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.simulation.doublons.aide',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? 'Cette ligne est comptée dans l\'application : elles seront créées, puis placées dans la file des doublons à décider.' : ('Ces ' + (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' lignes sont comptées dans l\'application : elles seront créées, puis placées dans la file des doublons à décider.')));
	});
var $author$project$I18n$Cles$importsSimulationDoublonsDetailMasque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.simulation.doublons.detail-masque', _List_Nil, 'Détail masqué');
};
var $author$project$I18n$Cles$importsSimulationDoublonsHorsPerimetre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.simulation.doublons.hors-perimetre', _List_Nil, 'Fiche hors de votre périmètre');
};
var $author$project$I18n$Cles$importsSimulationDoublonsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.simulation.doublons.titre', _List_Nil, 'Doublons possibles');
};
var $author$project$I18n$Cles$importsRaisonDoublonMemeEmail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.raison-doublon.meme-email', _List_Nil, 'Même email');
};
var $author$project$I18n$Cles$importsRaisonDoublonMemeIdentifiantLegal = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.raison-doublon.meme-identifiant-legal', _List_Nil, 'Même identifiant légal');
};
var $author$project$I18n$Cles$importsRaisonDoublonMemeNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.raison-doublon.meme-nom', _List_Nil, 'Même nom');
};
var $author$project$I18n$Cles$importsRaisonDoublonMemeRaisonSociale = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.raison-doublon.meme-raison-sociale', _List_Nil, 'Même raison sociale');
};
var $author$project$I18n$Cles$importsRaisonDoublonMemeTelephone = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.raison-doublon.meme-telephone', _List_Nil, 'Même téléphone');
};
var $author$project$Components$Imports$Vocabulaire$raisonDeDoublon = F2(
	function (i18n, code) {
		switch (code) {
			case 'MemeEmail':
				return $author$project$I18n$Cles$importsRaisonDoublonMemeEmail(i18n);
			case 'MemeTelephone':
				return $author$project$I18n$Cles$importsRaisonDoublonMemeTelephone(i18n);
			case 'MemeNom':
				return $author$project$I18n$Cles$importsRaisonDoublonMemeNom(i18n);
			case 'MemeRaisonSociale':
				return $author$project$I18n$Cles$importsRaisonDoublonMemeRaisonSociale(i18n);
			case 'MemeIdentifiantLegal':
				return $author$project$I18n$Cles$importsRaisonDoublonMemeIdentifiantLegal(i18n);
			default:
				return code;
		}
	});
var $author$project$Components$Imports$Outil$View$tableauAvecCellules = F3(
	function (nom, entetes, lignes) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$table,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class(nom)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$tr,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (e) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(e)
											]));
								},
								entetes))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (cellules) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$tr,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (c) {
										return A2(
											$rtfeldman$elm_css$Html$Styled$td,
											_List_Nil,
											_List_fromArray(
												[c]));
									},
									cellules));
						},
						lignes))
				]));
	});
var $author$project$Components$Imports$Outil$View$tableau = F3(
	function (nom, entetes, lignes) {
		return A3(
			$author$project$Components$Imports$Outil$View$tableauAvecCellules,
			nom,
			entetes,
			A2(
				$elm$core$List$map,
				$elm$core$List$map($rtfeldman$elm_css$Html$Styled$text),
				lignes));
	});
var $author$project$Components$Imports$Outil$View$doublonsPossibles = F2(
	function (i18n, model) {
		var _v0 = model.bB;
		if (!_v0.$) {
			var detail = _v0.a;
			return _Utils_eq(detail.xM, _List_Nil) ? $rtfeldman$elm_css$Html$Styled$text('') : A3(
				$author$project$Components$Imports$Outil$View$section,
				'doublons-possibles',
				$author$project$I18n$Cles$importsSimulationDoublonsTitre(i18n),
				_List_fromArray(
					[
						A3(
						$author$project$Components$Imports$Outil$View$tableau,
						'doublons',
						_List_fromArray(
							[
								$author$project$I18n$Cles$importsSimulationColonneLigne(i18n),
								$author$project$I18n$Cles$importsSimulationColonneDansLeFichier(i18n),
								$author$project$I18n$Cles$importsSimulationColonneFicheExistante(i18n),
								$author$project$I18n$Cles$importsSimulationColonneRaison(i18n)
							]),
						A2(
							$elm$core$List$map,
							function (d) {
								return _List_fromArray(
									[
										$elm$core$String$fromInt(d.ea),
										d.ws,
										A2(
										$elm$core$Maybe$withDefault,
										$author$project$I18n$Cles$importsSimulationDoublonsDetailMasque(i18n),
										d.Dq),
										_Utils_eq(d.GT, _List_Nil) ? $author$project$I18n$Cles$importsSimulationDoublonsHorsPerimetre(i18n) : A2(
										$elm$core$String$join,
										', ',
										A2(
											$elm$core$List$map,
											$author$project$Components$Imports$Vocabulaire$raisonDeDoublon(i18n),
											d.GT))
									]);
							},
							detail.xM)),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$importsSimulationDoublonsAide,
									i18n,
									{
										d: $elm$core$List$length(detail.xM)
									}))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$importsSimulationAvertissementTexte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.simulation.avertissement.texte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'lignes',
					$author$project$I18n$Traductions$Entier(p.gV))
				]),
			((!p.gV) || (p.gV === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.gV) + ' ligne analysée. Les chiffres ci-dessous sont ce que l\'import ferait.') : (A2($author$project$I18n$Nombre$formater, 0, p.gV) + ' lignes analysées. Les chiffres ci-dessous sont ce que l\'import ferait.'));
	});
var $author$project$I18n$Cles$importsSimulationAvertissementTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.simulation.avertissement.titre', _List_Nil, 'Rien n\'a encore été écrit');
};
var $author$project$I18n$Cles$importsFaitCreee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.fait.creee', _List_Nil, 'Une fiche créée par ligne');
};
var $author$project$I18n$Cles$importsFaitDoublonPossible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.fait.doublon-possible', _List_Nil, 'Une fiche créée et signalée comme doublon possible');
};
var $author$project$I18n$Cles$importsFaitEffacee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.fait.effacee', _List_Nil, 'Personne effacée : rien n\'est créé');
};
var $author$project$I18n$Cles$importsFaitErreur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.fait.erreur', _List_Nil, 'Rien n\'est créé');
};
var $author$project$I18n$Cles$importsFaitIgnoree = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.fait.ignoree', _List_Nil, 'Annotation : aucune valeur dans les colonnes retenues');
};
var $author$project$I18n$Cles$importsFaitModifiee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.fait.modifiee', _List_Nil, 'Une fiche mise à jour par ligne');
};
var $author$project$I18n$Cles$importsFaitSansChangement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.fait.sans-changement', _List_Nil, 'Rien à changer : la fiche est déjà à jour');
};
var $author$project$Components$Imports$Vocabulaire$faitDeLigne = F2(
	function (i18n, issue) {
		switch (issue) {
			case 'creee':
				return $author$project$I18n$Cles$importsFaitCreee(i18n);
			case 'modifiee':
				return $author$project$I18n$Cles$importsFaitModifiee(i18n);
			case 'sans-changement':
				return $author$project$I18n$Cles$importsFaitSansChangement(i18n);
			case 'doublon-possible':
				return $author$project$I18n$Cles$importsFaitDoublonPossible(i18n);
			case 'erreur':
				return $author$project$I18n$Cles$importsFaitErreur(i18n);
			case 'effacee':
				return $author$project$I18n$Cles$importsFaitEffacee(i18n);
			case 'ignoree':
				return $author$project$I18n$Cles$importsFaitIgnoree(i18n);
			default:
				var autre = issue;
				return autre;
		}
	});
var $author$project$I18n$Cles$importsLignesDuFichierBornees = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.lignes-du-fichier.bornees',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'affichees',
					$author$project$I18n$Traductions$Chaine(p.dk)),
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			'Les ' + (p.dk + (' premières suites de lignes sur ' + (p.d + '.'))));
	});
var $author$project$I18n$Cles$importsLignesDuFichierDeA = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.lignes-du-fichier.de-a',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'premiere',
					$author$project$I18n$Traductions$Chaine(p.Gf)),
					_Utils_Tuple2(
					'derniere',
					$author$project$I18n$Traductions$Chaine(p.xj))
				]),
			p.Gf + (' à ' + p.xj));
	});
var $author$project$I18n$Cles$importsLignesDuFichierFait = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes-du-fichier.fait', _List_Nil, 'Ce que l\'import fait');
};
var $author$project$I18n$Cles$importsLignesDuFichierFicheAgent = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes-du-fichier.fiche-agent', _List_Nil, 'Fiche agent');
};
var $author$project$I18n$Cles$importsLignesDuFichierFicheCreee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes-du-fichier.fiche-creee', _List_Nil, 'créée');
};
var $author$project$I18n$Cles$importsLignesDuFichierFicheOrganisation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes-du-fichier.fiche-organisation', _List_Nil, 'Fiche organisation');
};
var $author$project$I18n$Cles$importsLignesDuFichierIssue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes-du-fichier.issue', _List_Nil, 'Issue');
};
var $author$project$I18n$Cles$importsLignesDuFichierTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes-du-fichier.titre', _List_Nil, 'Lignes du fichier');
};
var $author$project$I18n$Cles$importsIssueCreee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.issue.creee', _List_Nil, 'Créées');
};
var $author$project$I18n$Cles$importsIssueDoublonPossible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.issue.doublon-possible', _List_Nil, 'Doublon possible');
};
var $author$project$I18n$Cles$importsIssueEffacee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.issue.effacee', _List_Nil, 'Effacées');
};
var $author$project$I18n$Cles$importsIssueErreur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.issue.erreur', _List_Nil, 'Erreur');
};
var $author$project$I18n$Cles$importsIssueIgnoree = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.issue.ignoree', _List_Nil, 'Ignorées');
};
var $author$project$I18n$Cles$importsIssueModifiee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.issue.modifiee', _List_Nil, 'Mises à jour');
};
var $author$project$I18n$Cles$importsIssueSansChangement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.issue.sans-changement', _List_Nil, 'Sans changement');
};
var $author$project$Components$Imports$Vocabulaire$issueDeLigne = F2(
	function (i18n, issue) {
		switch (issue) {
			case 'creee':
				return $author$project$I18n$Cles$importsIssueCreee(i18n);
			case 'modifiee':
				return $author$project$I18n$Cles$importsIssueModifiee(i18n);
			case 'sans-changement':
				return $author$project$I18n$Cles$importsIssueSansChangement(i18n);
			case 'doublon-possible':
				return $author$project$I18n$Cles$importsIssueDoublonPossible(i18n);
			case 'erreur':
				return $author$project$I18n$Cles$importsIssueErreur(i18n);
			case 'effacee':
				return $author$project$I18n$Cles$importsIssueEffacee(i18n);
			case 'ignoree':
				return $author$project$I18n$Cles$importsIssueIgnoree(i18n);
			default:
				var autre = issue;
				return autre;
		}
	});
var $author$project$Components$Imports$Outil$View$issueEnTag = F2(
	function (i18n, ligne) {
		var couleur = function () {
			var _v0 = ligne.nh;
			switch (_v0) {
				case 'creee':
					return 0;
				case 'doublon-possible':
					return 1;
				case 'erreur':
					return 2;
				default:
					return 3;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('issue')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Components$Shared$Tag$View$view,
					couleur,
					A2($author$project$Components$Imports$Vocabulaire$issueDeLigne, i18n, ligne.nh)),
				(ligne.nh === 'erreur') ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('detail')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A3($author$project$Components$Imports$Vocabulaire$erreurDeLigne, i18n, ligne.j_, ligne.go))
							]))
					]) : _List_Nil));
	});
var $author$project$Components$Imports$Outil$View$lignesDuFichier = F2(
	function (i18n, model) {
		var _v0 = model.bB;
		if (!_v0.$) {
			var detail = _v0.a;
			if ($elm$core$List$isEmpty(detail.gV)) {
				return $rtfeldman$elm_css$Html$Styled$text('');
			} else {
				var plage = function (ligne) {
					return _Utils_eq(ligne.wC, ligne.sD) ? $elm$core$String$fromInt(ligne.wC) : A2(
						$author$project$I18n$Cles$importsLignesDuFichierDeA,
						i18n,
						{
							xj: $elm$core$String$fromInt(ligne.sD),
							Gf: $elm$core$String$fromInt(ligne.wC)
						});
				};
				var ficheDeNature = F2(
					function (nature, ligne) {
						return A2(
							$elm$core$Maybe$withDefault,
							$rtfeldman$elm_css$Html$Styled$text('—'),
							$elm$core$List$head(
								A2(
									$elm$core$List$filterMap,
									function (f) {
										return A2(
											$elm$core$Maybe$map,
											function (nom) {
												return A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('fiche')
														]),
													A2(
														$elm$core$List$cons,
														A2(
															$rtfeldman$elm_css$Html$Styled$span,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(nom)
																])),
														f.wm ? _List_fromArray(
															[
																A2(
																$author$project$Components$Shared$Tag$View$view,
																0,
																$author$project$I18n$Cles$importsLignesDuFichierFicheCreee(i18n))
															]) : _List_Nil));
											},
											f.Dj);
									},
									A2(
										$elm$core$List$filter,
										function (f) {
											return _Utils_eq(f.g1, nature);
										},
										ligne.zu))));
					});
				return A2(
					$rtfeldman$elm_css$Html$Styled$section,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('lignes-du-fichier')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h2,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$importsLignesDuFichierTitre(i18n)),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$elm$core$String$fromInt(detail.BT))
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Components$Imports$Outil$View$tableauAvecCellules,
									'du-fichier',
									_List_fromArray(
										[
											$author$project$I18n$Cles$importsSimulationColonneLigne(i18n),
											$author$project$I18n$Cles$importsLignesDuFichierFait(i18n),
											$author$project$I18n$Cles$importsLignesDuFichierFicheOrganisation(i18n),
											$author$project$I18n$Cles$importsLignesDuFichierFicheAgent(i18n),
											$author$project$I18n$Cles$importsLignesDuFichierIssue(i18n)
										]),
									A2(
										$elm$core$List$map,
										function (ligne) {
											return _List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													plage(ligne)),
													$rtfeldman$elm_css$Html$Styled$text(
													A2($author$project$Components$Imports$Vocabulaire$faitDeLigne, i18n, ligne.nh)),
													A2(ficheDeNature, 'organisation', ligne),
													A2(ficheDeNature, 'personne', ligne),
													A2($author$project$Components$Imports$Outil$View$issueEnTag, i18n, ligne)
												]);
										},
										detail.gV)),
									(_Utils_cmp(
									detail.BT,
									$elm$core$List$length(detail.gV)) > 0) ? A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$importsLignesDuFichierBornees,
												i18n,
												{
													dk: $elm$core$String$fromInt(
														$elm$core$List$length(detail.gV)),
													d: $elm$core$String$fromInt(detail.BT)
												}))
										])) : $rtfeldman$elm_css$Html$Styled$text('')
								]))
						]));
			}
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Imports$Outil$Update$LignesDemandees = {$: 85};
var $author$project$Components$Imports$Outil$View$cibleDuCatalogue = function (model) {
	var _v0 = A2(
		$elm$core$List$filterMap,
		function ($) {
			return $.vf;
		},
		model.pb);
	if (!_v0.b) {
		return false;
	} else {
		var cibles = _v0;
		return A2(
			$elm$core$List$all,
			function (_v1) {
				var domaine = _v1.a;
				return domaine === 'catalogue';
			},
			cibles);
	}
};
var $author$project$I18n$Cles$importsSimulationColonneValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.simulation.colonne.valeur', _List_Nil, 'Valeur');
};
var $author$project$I18n$Cles$importsSimulationErreursAffichees = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.simulation.erreurs.affichees',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'affichees',
					$author$project$I18n$Traductions$Entier(p.dk)),
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			((!p.dk) || (p.dk === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.dk) + (' sur ' + (p.d + ' affichée'))) : (A2($author$project$I18n$Nombre$formater, 0, p.dk) + (' sur ' + (p.d + ' affichées'))));
	});
var $author$project$I18n$Cles$importsSimulationErreursTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.simulation.erreurs.titre', _List_Nil, 'Lignes en erreur');
};
var $author$project$I18n$Cles$importsSimulationErreursVoir = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.simulation.erreurs.voir',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? 'Voir la ligne' : ('Voir les ' + (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' lignes')));
	});
var $author$project$I18n$Cles$importsErreurDeLigneAvecValeur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.erreur-de-ligne.avec-valeur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'colonne',
					$author$project$I18n$Traductions$Chaine(p.j_)),
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm)),
					_Utils_Tuple2(
					'erreur',
					$author$project$I18n$Traductions$Chaine(p.go))
				]),
			'« ' + (p.j_ + (' » vaut « ' + (p.fm + (' » : ' + p.go)))));
	});
var $author$project$I18n$Cles$importsErreurDeLigneDoublonLigne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.erreur-de-ligne.doublon-ligne',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'ligne',
					$author$project$I18n$Traductions$Chaine(p.ea))
				]),
			'Code déjà présent à la ligne ' + (p.ea + ' du fichier'));
	});
var $author$project$Components$Imports$Vocabulaire$erreurDeReference = F2(
	function (i18n, e) {
		var _v0 = _Utils_Tuple2(e.go, e.BS);
		if ((_v0.a === 'doublon-dans-le-fichier') && (!_v0.b.$)) {
			var ligne = _v0.b.a;
			return A2(
				$author$project$I18n$Cles$importsErreurDeLigneDoublonLigne,
				i18n,
				{
					ea: $elm$core$String$fromInt(ligne)
				});
		} else {
			return ((e.fm === '') || A2(
				$elm$core$List$member,
				e.go,
				_List_fromArray(
					['code-manquant', 'doublon-dans-le-fichier', 'code-d-un-autre-type']))) ? A3($author$project$Components$Imports$Vocabulaire$erreurDeLigne, i18n, e.j_, e.go) : A2(
				$author$project$I18n$Cles$importsErreurDeLigneAvecValeur,
				i18n,
				{
					j_: e.j_,
					go: A3($author$project$Components$Imports$Vocabulaire$erreurDeLigne, i18n, e.j_, e.go),
					fm: e.fm
				});
		}
	});
var $author$project$I18n$Cles$importsSimulationEtiquetteCle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.simulation.etiquette.cle', _List_Nil, 'Clé');
};
var $author$project$I18n$Cles$importsSimulationEtiquetteDoublon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.simulation.etiquette.doublon', _List_Nil, 'Doublon');
};
var $author$project$I18n$Cles$importsSimulationEtiquetteValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.simulation.etiquette.valeur', _List_Nil, 'Valeur');
};
var $author$project$Components$Imports$Vocabulaire$etiquetteDErreurDeReference = F2(
	function (i18n, code) {
		switch (code) {
			case 'code-manquant':
				return $author$project$I18n$Cles$importsSimulationEtiquetteCle(i18n);
			case 'doublon-dans-le-fichier':
				return $author$project$I18n$Cles$importsSimulationEtiquetteDoublon(i18n);
			case 'code-d-un-autre-type':
				return $author$project$I18n$Cles$importsSimulationEtiquetteDoublon(i18n);
			default:
				return $author$project$I18n$Cles$importsSimulationEtiquetteValeur(i18n);
		}
	});
var $author$project$I18n$Cles$importsSimulationColonneReference = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.simulation.colonne.reference', _List_Nil, 'Référence');
};
var $author$project$I18n$Cles$importsSimulationReferenceAbsente = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.simulation.reference-absente', _List_Nil, '—');
};
var $author$project$Components$Imports$Outil$View$tableauDesReferencesEnErreur = F2(
	function (i18n, lignes) {
		return A3(
			$author$project$Components$Imports$Outil$View$tableauAvecCellules,
			'erreurs',
			_List_fromArray(
				[
					$author$project$I18n$Cles$importsSimulationColonneLigne(i18n),
					$author$project$I18n$Cles$importsSimulationColonneReference(i18n),
					$author$project$I18n$Cles$importsSimulationColonneErreur(i18n)
				]),
			A2(
				$elm$core$List$map,
				function (e) {
					return _List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(e.ea)),
							(e.Hc === '') ? $rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$importsSimulationReferenceAbsente(i18n)) : A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('cle-de-ligne')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(e.Hc)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('erreur-de-reference')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Tag$View$view,
									2,
									A2($author$project$Components$Imports$Vocabulaire$etiquetteDErreurDeReference, i18n, e.go)),
									$rtfeldman$elm_css$Html$Styled$text(
									' ' + A2($author$project$Components$Imports$Vocabulaire$erreurDeReference, i18n, e))
								]))
						]);
				},
				lignes));
	});
var $author$project$Components$Imports$Outil$View$lignesEnErreur = F2(
	function (i18n, model) {
		var _v0 = model.bB;
		if (!_v0.$) {
			var detail = _v0.a;
			if (!detail.yx) {
				return $rtfeldman$elm_css$Html$Styled$text('');
			} else {
				var affichees = A2($elm$core$List$take, 5, detail.gp);
				return A2(
					$rtfeldman$elm_css$Html$Styled$section,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('lignes-en-erreur')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h2,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$importsSimulationErreursTitre(i18n)),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$elm$core$String$fromInt(detail.yx))
												]))
										])),
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									2,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Imports$Outil$Update$LignesDemandees)
										]),
									A2(
										$author$project$I18n$Cles$importsSimulationErreursVoir,
										i18n,
										{d: detail.yx})),
									function () {
									var _v1 = model.pK;
									if (!_v1.$) {
										return A3(
											$author$project$Components$Shared$Bouton$View$bouton,
											2,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Imports$Outil$Update$RapportDemande)
												]),
											$author$project$I18n$Cles$importsSimulationRapport(i18n));
									} else {
										return $rtfeldman$elm_css$Html$Styled$text('');
									}
								}()
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
								]),
							_List_fromArray(
								[
									$author$project$Components$Imports$Outil$View$cibleDuCatalogue(model) ? A2($author$project$Components$Imports$Outil$View$tableauDesReferencesEnErreur, i18n, affichees) : A3(
									$author$project$Components$Imports$Outil$View$tableau,
									'erreurs',
									_List_fromArray(
										[
											$author$project$I18n$Cles$importsSimulationColonneLigne(i18n),
											$author$project$I18n$Cles$importsSimulationColonneColonne(i18n),
											$author$project$I18n$Cles$importsSimulationColonneValeur(i18n),
											$author$project$I18n$Cles$importsSimulationColonneErreur(i18n)
										]),
									A2(
										$elm$core$List$map,
										function (e) {
											return _List_fromArray(
												[
													$elm$core$String$fromInt(e.ea),
													e.j_,
													e.fm,
													A3($author$project$Components$Imports$Vocabulaire$erreurDeLigne, i18n, e.j_, e.go)
												]);
										},
										affichees)),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$importsSimulationErreursAffichees,
												i18n,
												{
													dk: $elm$core$List$length(affichees),
													d: $elm$core$String$fromInt(detail.yx)
												}))
										]))
								]))
						]));
			}
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$importsRefusAcces = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.refus.acces', _List_Nil, 'Vous n\'avez pas le droit d\'importer cette cible.');
};
var $author$project$I18n$Cles$importsRefusAutre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.refus.autre', _List_Nil, 'Le geste n\'a pas abouti. Réessayez.');
};
var $author$project$I18n$Cles$importsRefusChampSansValeurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.refus.champ-sans-valeurs', _List_Nil, 'Ce champ n\'a pas de valeurs à faire correspondre.');
};
var $author$project$I18n$Cles$importsRefusExtension = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.refus.extension', _List_Nil, 'Ce format n\'est pas lu. Enregistrez le classeur en .xlsx ou en .csv, puis déposez-le de nouveau.');
};
var $author$project$I18n$Cles$importsRefusIllisible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.refus.illisible', _List_Nil, 'Ce fichier n\'est pas un classeur ou un CSV lisible (encodage inconnu, aucune ligne). Vous revenez au dépôt.');
};
var $author$project$I18n$Cles$importsRefusModeleDejaPris = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.refus.modele-deja-pris', _List_Nil, 'Un modèle porte déjà ce nom : choisissez-en un autre.');
};
var $author$project$I18n$Cles$importsRefusRegleNonPortee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.refus.regle-non-portee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'La colonne du champ ' + (p.uN + ' ne porte pas cette règle : retirez-la ou changez de champ.'));
	});
var $author$project$I18n$Cles$importsRefusTitreTropGros = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.refus.titre-trop-gros', _List_Nil, 'Fichier trop gros');
};
var $author$project$I18n$Cles$importsRefusTropDeLignes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.refus.trop-de-lignes', _List_Nil, 'Le classeur dépasse 100 000 lignes en tout, toutes feuilles retenues. Retirez des feuilles ou découpez-le en plusieurs imports.');
};
var $author$project$I18n$Cles$importsRefusVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.refus.vide', _List_Nil, 'Ce fichier ne contient aucune ligne : choisissez-en un autre.');
};
var $author$project$I18n$Cles$importsReglagesRefuse = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.reglages.refuse',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'raison',
					$author$project$I18n$Traductions$Chaine(p.pH))
				]),
			'Réglage refusé : ' + p.pH);
	});
var $author$project$I18n$Cles$importsReglagesRaisonAutre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.reglages.raison-autre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'raison',
					$author$project$I18n$Traductions$Chaine(p.pH))
				]),
			p.pH);
	});
var $author$project$I18n$Cles$importsReglagesRaisonOffreInconnue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.raison-offre-inconnue', _List_Nil, 'cette offre n\'existe pas');
};
var $author$project$I18n$Cles$importsReglagesRaisonOffreNonAdmiseParLeRole = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.raison-offre-non-admise-par-le-role', _List_Nil, 'le rôle n\'admet pas cette offre');
};
var $author$project$I18n$Cles$importsReglagesRaisonOffreRequiseParLeRole = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.raison-offre-requise-par-le-role', _List_Nil, 'le rôle demande une offre');
};
var $author$project$I18n$Cles$importsReglagesRaisonOffreSansRole = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.raison-offre-sans-role', _List_Nil, 'une offre demande un rôle à ouvrir');
};
var $author$project$I18n$Cles$importsReglagesRaisonOrigineTropLongue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.raison-origine-trop-longue', _List_Nil, 'l\'origine est trop longue');
};
var $author$project$I18n$Cles$importsReglagesRaisonOrigineVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.raison-origine-vide', _List_Nil, 'l\'origine est vide');
};
var $author$project$I18n$Cles$importsReglagesRaisonQualiteInconnue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.raison-qualite-inconnue', _List_Nil, 'cette qualité n\'existe pas');
};
var $author$project$I18n$Cles$importsReglagesRaisonQualiteNonAdmise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.raison-qualite-non-admise', _List_Nil, 'ce type de partie prenante n\'admet pas cette qualité');
};
var $author$project$I18n$Cles$importsReglagesRaisonRoleInconnu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.raison-role-inconnu', _List_Nil, 'ce type de rôle n\'existe pas');
};
var $author$project$I18n$Cles$importsReglagesRaisonRoleNatureNonAdmise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.raison-role-nature-non-admise', _List_Nil, 'ce type de rôle n\'admet pas la nature de la cible');
};
var $author$project$Components$Imports$Vocabulaire$raisonDeReglage = F3(
	function (i18n, reglage, raison) {
		var _v0 = _Utils_Tuple2(reglage, raison);
		_v0$10:
		while (true) {
			switch (_v0.a) {
				case 'qualite':
					switch (_v0.b) {
						case 'inconnue':
							return $author$project$I18n$Cles$importsReglagesRaisonQualiteInconnue(i18n);
						case 'non-admise':
							return $author$project$I18n$Cles$importsReglagesRaisonQualiteNonAdmise(i18n);
						default:
							break _v0$10;
					}
				case 'origine':
					switch (_v0.b) {
						case 'vide':
							return $author$project$I18n$Cles$importsReglagesRaisonOrigineVide(i18n);
						case 'trop-longue':
							return $author$project$I18n$Cles$importsReglagesRaisonOrigineTropLongue(i18n);
						default:
							break _v0$10;
					}
				case 'role':
					switch (_v0.b) {
						case 'inconnu':
							return $author$project$I18n$Cles$importsReglagesRaisonRoleInconnu(i18n);
						case 'nature-non-admise':
							return $author$project$I18n$Cles$importsReglagesRaisonRoleNatureNonAdmise(i18n);
						default:
							break _v0$10;
					}
				case 'offre':
					switch (_v0.b) {
						case 'sans-role':
							return $author$project$I18n$Cles$importsReglagesRaisonOffreSansRole(i18n);
						case 'inconnue':
							return $author$project$I18n$Cles$importsReglagesRaisonOffreInconnue(i18n);
						case 'non-admise-par-le-role':
							return $author$project$I18n$Cles$importsReglagesRaisonOffreNonAdmiseParLeRole(i18n);
						case 'requise-par-le-role':
							return $author$project$I18n$Cles$importsReglagesRaisonOffreRequiseParLeRole(i18n);
						default:
							break _v0$10;
					}
				default:
					break _v0$10;
			}
		}
		return A2(
			$author$project$I18n$Cles$importsReglagesRaisonAutre,
			i18n,
			{pH: raison});
	});
var $author$project$Components$Imports$Outil$View$dit = F2(
	function (i18n, erreur) {
		switch (erreur.$) {
			case 0:
				return $author$project$I18n$Cles$importsRefusExtension(i18n);
			case 1:
				return $author$project$I18n$Cles$importsRefusIllisible(i18n);
			case 2:
				return $author$project$I18n$Cles$importsRefusVide(i18n);
			case 3:
				return $author$project$I18n$Cles$importsRefusTitreTropGros(i18n);
			case 4:
				return $author$project$I18n$Cles$importsRefusTropDeLignes(i18n);
			case 5:
				var champ = erreur.a;
				return A2(
					$author$project$I18n$Cles$importsRefusChampObligatoire,
					i18n,
					{uN: champ});
			case 6:
				var champ = erreur.a;
				return A2(
					$author$project$I18n$Cles$importsRefusChampDouble,
					i18n,
					{uN: champ});
			case 8:
				return $author$project$I18n$Cles$importsRefusChampSansValeurs(i18n);
			case 9:
				var champ = erreur.a;
				return A2(
					$author$project$I18n$Cles$importsRefusRegleNonPortee,
					i18n,
					{uN: champ});
			case 7:
				return $author$project$I18n$Cles$importsRefusModeleDejaPris(i18n);
			case 10:
				var reglage = erreur.a;
				var raison = erreur.b;
				return A2(
					$author$project$I18n$Cles$importsReglagesRefuse,
					i18n,
					{
						pH: A3($author$project$Components$Imports$Vocabulaire$raisonDeReglage, i18n, reglage, raison)
					});
			case 11:
				return $author$project$I18n$Cles$importsLignesRefus(i18n);
			case 12:
				return $author$project$I18n$Cles$importsLignesDejaTraitee(i18n);
			case 13:
				return $author$project$I18n$Cles$importsRefusAcces(i18n);
			default:
				return $author$project$I18n$Cles$importsRefusAutre(i18n);
		}
	});
var $author$project$Components$Imports$Outil$View$refusDuLot = F2(
	function (i18n, model) {
		var _v0 = model.pZ;
		if (!_v0.$) {
			var erreur = _v0.a;
			return A2(
				$author$project$Components$Shared$Note$View$view,
				2,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$Components$Imports$Outil$View$dit, i18n, erreur))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$importsResultatParCibleCible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.resultat-par-cible.cible', _List_Nil, 'Cible');
};
var $author$project$I18n$Cles$importsResultatParCibleCreees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.resultat-par-cible.creees', _List_Nil, 'Créées');
};
var $author$project$I18n$Cles$importsResultatParCibleErreurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.resultat-par-cible.erreurs', _List_Nil, 'Erreurs');
};
var $author$project$I18n$Cles$importsResultatParCibleMisesAJour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.resultat-par-cible.mises-a-jour', _List_Nil, 'Mises à jour');
};
var $author$project$I18n$Cles$importsResultatParCibleNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.resultat-par-cible.note', _List_Nil, 'Chaque ligne est comptée une fois, sous la cible de sa part. Les lignes d\'annotation ne portent aucune valeur dans les colonnes retenues : ignorées, comptées à part, hors des cinq compteurs.');
};
var $author$project$I18n$Cles$importsResultatParCibleSansChangement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.resultat-par-cible.sans-changement', _List_Nil, 'Sans changement');
};
var $author$project$I18n$Cles$importsResultatParCibleTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.resultat-par-cible.titre', _List_Nil, 'Résultat par cible');
};
var $author$project$Components$Imports$Outil$View$resultatParCible = F2(
	function (i18n, model) {
		var _v0 = model.bB;
		if (!_v0.$) {
			var detail = _v0.a;
			return $elm$core$List$isEmpty(detail.EN) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
				$rtfeldman$elm_css$Html$Styled$section,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('resultat-par-cible')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$h2,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsResultatParCibleTitre(i18n)),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$elm$core$String$fromInt(
													$elm$core$List$length(detail.EN)))
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Components$Imports$Outil$View$tableau,
								'par-cible',
								_List_fromArray(
									[
										$author$project$I18n$Cles$importsResultatParCibleCible(i18n),
										$author$project$I18n$Cles$importsResultatParCibleCreees(i18n),
										$author$project$I18n$Cles$importsResultatParCibleMisesAJour(i18n),
										$author$project$I18n$Cles$importsResultatParCibleSansChangement(i18n),
										$author$project$I18n$Cles$importsResultatParCibleErreurs(i18n)
									]),
								A2(
									$elm$core$List$map,
									function (c) {
										return _List_fromArray(
											[
												c.Bl,
												$elm$core$String$fromInt(c.wo),
												$elm$core$String$fromInt(c.CP),
												$elm$core$String$fromInt(c.qY),
												$elm$core$String$fromInt(c.gp)
											]);
									},
									detail.EN)),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsResultatParCibleNote(i18n))
									]))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Imports$Outil$View$simulation = F2(
	function (i18n, model) {
		var _v0 = model.rb;
		if (!_v0.$) {
			var c = _v0.a;
			return _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Note$View$view,
					0,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$importsSimulationAvertissementTitre(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$importsSimulationAvertissementTexte,
										i18n,
										{gV: ((((c.wo + c.CP) + c.qY) + c.kW) + c.gp) + c.x8}))
								]))
						])),
					$author$project$Components$Imports$Outil$Model$catalogueSeul(model) ? A2($author$project$Components$Imports$Outil$View$compteursDeSimulationDuCatalogue, i18n, c) : A2($author$project$Components$Imports$Outil$View$compteursDeSimulation, i18n, c),
					$author$project$Components$Imports$Outil$Model$catalogueSeul(model) ? $rtfeldman$elm_css$Html$Styled$text('') : A2($author$project$Components$Imports$Outil$View$resultatParCible, i18n, model),
					$author$project$Components$Imports$Outil$Model$catalogueSeul(model) ? $rtfeldman$elm_css$Html$Styled$text('') : A2($author$project$Components$Imports$Outil$View$lignesDuFichier, i18n, model),
					A2($author$project$Components$Imports$Outil$View$lignesEnErreur, i18n, model),
					A2($author$project$Components$Imports$Outil$View$doublonsPossibles, i18n, model),
					A2($author$project$Components$Imports$Outil$View$refusDuLot, i18n, model)
				]);
		} else {
			return _List_fromArray(
				[
					A2($author$project$Components$Imports$Outil$View$refusDuLot, i18n, model)
				]);
		}
	});
var $rtfeldman$elm_css$Html$Styled$caption = $rtfeldman$elm_css$Html$Styled$node('caption');
var $author$project$I18n$Cles$importsValeursAFaireTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.valeurs.a-faire-titre', _List_Nil, 'À faire correspondre');
};
var $author$project$I18n$Cles$importsValeursAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.valeurs.aide', _List_Nil, 'Une valeur reconnue (code ou libellé exact) n\'est pas demandée. Une proposition n\'est jamais appliquée sans votre validation.');
};
var $author$project$I18n$Cles$importsValeursAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.valeurs.aucune', _List_Nil, 'Aucune colonne de cette part n\'a de valeurs à faire correspondre.');
};
var $author$project$I18n$Cles$importsValeursChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.valeurs.champ', _List_Nil, 'Champ');
};
var $author$project$I18n$Cles$importsValeursColonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.valeurs.colonne', _List_Nil, 'Colonne');
};
var $author$project$I18n$Cles$importsValeursDuFichier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.valeurs.du-fichier', _List_Nil, 'Valeurs du fichier');
};
var $author$project$I18n$Cles$importsValeursModele = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.valeurs.modele', _List_Nil, 'Enregistrer dans le modèle');
};
var $author$project$I18n$Cles$importsValeursReconnues = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.valeurs.reconnues', _List_Nil, 'Reconnues');
};
var $author$project$I18n$Cles$importsValeursTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.valeurs.titre', _List_Nil, 'Valeurs à faire correspondre');
};
var $author$project$I18n$Cles$importsValeursTotal = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.valeurs.total',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' valeur à faire correspondre.') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' valeurs à faire correspondre.'));
	});
var $author$project$Components$Imports$Outil$Update$ValeursDemandees = F2(
	function (a, b) {
		return {$: 68, a: a, b: b};
	});
var $author$project$I18n$Cles$importsValeursAFaire = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.valeurs.a-faire',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' valeur') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' valeurs'));
	});
var $author$project$I18n$Cles$importsValeursFaireCorrespondre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.valeurs.faire-correspondre', _List_Nil, 'Faire correspondre');
};
var $author$project$I18n$Cles$importsValeursToutesReconnues = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.valeurs.toutes-reconnues', _List_Nil, 'Toutes reconnues');
};
var $author$project$Components$Imports$Outil$View$ligneDeValeurs = F4(
	function (i18n, model, part, _v0) {
		var index = _v0.a;
		var champ = _v0.b;
		var lues = _v0.c;
		var restantes = A3($author$project$Components$Imports$Outil$Model$restantes, part, index, lues);
		var libelleDuChamp = A2(
			$elm$core$Maybe$withDefault,
			champ,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (c) {
							return _Utils_eq(c.dy, champ);
						},
						A2($author$project$Components$Imports$Outil$Model$champsDe, part, model)))));
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(libelleDuChamp)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								$elm$core$List$head(
									A2($elm$core$List$drop, index, part.ym))))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('num')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(
								$elm$core$List$length(lues.Ki)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('num')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(
								$elm$core$List$length(
									A2(
										$elm$core$List$filter,
										function ($) {
											return $.mm;
										},
										lues.Ki))))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							(!lues.sF) ? A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('mut')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$importsValeursToutesReconnues(i18n))
								])) : A2(
							$author$project$Components$Shared$Tag$View$view,
							(!restantes) ? 0 : 1,
							A2(
								$author$project$I18n$Cles$importsValeursAFaire,
								i18n,
								{d: restantes}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					(!lues.sF) ? _List_Nil : _List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							2,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									A2($author$project$Components$Imports$Outil$Update$ValeursDemandees, part.mx, index))
								]),
							$author$project$I18n$Cles$importsValeursFaireCorrespondre(i18n))
						]))
				]));
	});
var $author$project$Components$Imports$Outil$View$valeurs = F2(
	function (i18n, model) {
		var lignes = function (part) {
			return A2(
				$elm$core$List$filterMap,
				function (_v2) {
					var index = _v2.a;
					var champ = _v2.b;
					return A2(
						$elm$core$Maybe$map,
						function (lues) {
							return _Utils_Tuple3(index, champ, lues);
						},
						A3($author$project$Components$Imports$Outil$Model$valeursDeLaColonne, part.mx, index, model));
				},
				$elm$core$Dict$toList(part.j1));
		};
		var affectees = A2(
			$elm$core$List$filter,
			function (part) {
				return !_Utils_eq(part.vf, $elm$core$Maybe$Nothing);
			},
			model.pb);
		var restantesDeTout = $elm$core$List$sum(
			A2(
				$elm$core$List$concatMap,
				function (part) {
					return A2(
						$elm$core$List$map,
						function (_v1) {
							var index = _v1.a;
							var lues = _v1.c;
							return A3($author$project$Components$Imports$Outil$Model$restantes, part, index, lues);
						},
						lignes(part));
				},
				affectees));
		return A3(
			$author$project$Components$Imports$Outil$View$section,
			'valeurs',
			$author$project$I18n$Cles$importsValeursTitre(i18n),
			_Utils_ap(
				A2(
					$elm$core$List$map,
					function (part) {
						var _v0 = lignes(part);
						if (!_v0.b) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsValeursAucune(i18n))
									]));
						} else {
							var colonnes = _v0;
							return A2(
								$rtfeldman$elm_css$Html$Styled$table,
								_List_Nil,
								_List_fromArray(
									[
										($elm$core$List$length(affectees) > 1) ? A2(
										$rtfeldman$elm_css$Html$Styled$caption,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(part.mx)
											])) : $rtfeldman$elm_css$Html$Styled$text(''),
										A2(
										$rtfeldman$elm_css$Html$Styled$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$importsValeursChamp(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$importsValeursColonne(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col'),
																$rtfeldman$elm_css$Html$Styled$Attributes$class('num')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$importsValeursDuFichier(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col'),
																$rtfeldman$elm_css$Html$Styled$Attributes$class('num')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$importsValeursReconnues(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$importsValeursAFaireTitre(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_Nil)
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$tbody,
										_List_Nil,
										A2(
											$elm$core$List$map,
											A3($author$project$Components$Imports$Outil$View$ligneDeValeurs, i18n, model, part),
											colonnes))
									]));
						}
					},
					affectees),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$importsValeursTotal,
									i18n,
									{d: restantesDeTout}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$importsValeursAide(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('gestes')
							]),
						A2(
							$elm$core$List$map,
							function (part) {
								return A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Imports$Outil$Update$ModeleDemande(part.mx)),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
											_Utils_eq(
												A2($author$project$Components$Imports$Outil$Model$lienDe, $author$project$API$NavLinksDictionary$enregistrerUnModele, model),
												$elm$core$Maybe$Nothing))
										]),
									$author$project$I18n$Cles$importsValeursModele(i18n));
							},
							A2(
								$elm$core$List$filter,
								function (part) {
									return !$elm$core$Dict$isEmpty(part.j1);
								},
								affectees))),
						model.lZ ? A2(
						$author$project$Components$Shared$Note$View$view,
						3,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$importsColonnesModeleEnregistre(i18n))
							])) : $rtfeldman$elm_css$Html$Styled$text('')
					])));
	});
var $author$project$Components$Imports$Outil$View$contenu = F2(
	function (i18n, model) {
		var _v0 = model.me;
		switch (_v0) {
			case 0:
				return _List_fromArray(
					[
						A2($author$project$Components$Imports$Outil$View$ciblesPossibles, i18n, model),
						A2($author$project$Components$Imports$Outil$View$fichier, i18n, model),
						A2($author$project$Components$Imports$Outil$View$reprendreUnTravail, i18n, model)
					]);
			case 1:
				return A2(
					$elm$core$List$cons,
					A2($author$project$Components$Imports$Outil$View$carteDuFichier, i18n, model),
					A2($author$project$Components$Imports$Outil$View$parts, i18n, model));
			case 2:
				return A2(
					$elm$core$List$concatMap,
					function (part) {
						return _List_fromArray(
							[
								A3($author$project$Components$Imports$Outil$View$correspondance, i18n, model, part),
								A2($author$project$Components$Imports$Outil$View$colonnesRefusees, i18n, part)
							]);
					},
					A2(
						$elm$core$List$filter,
						function (part) {
							return !_Utils_eq(part.vf, $elm$core$Maybe$Nothing);
						},
						model.pb));
			case 3:
				return _List_fromArray(
					[
						A2($author$project$Components$Imports$Outil$View$valeurs, i18n, model)
					]);
			case 4:
				return _List_fromArray(
					[
						A2($author$project$Components$Imports$Outil$View$lotPrepare, i18n, model)
					]);
			case 5:
				return A2($author$project$Components$Imports$Outil$View$simulation, i18n, model);
			default:
				var _v1 = model.gV;
				if (!_v1.$) {
					var lignes = _v1.a;
					return A3($author$project$Components$Imports$Outil$View$lignesRejetees, i18n, model, lignes);
				} else {
					return A2($author$project$Components$Imports$Outil$View$application, i18n, model);
				}
		}
	});
var $author$project$Components$Imports$Outil$Update$ModeleApplique = {$: 34};
var $author$project$I18n$Cles$importsApplicationAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.application.action', _List_Nil, 'Appliquer le modèle');
};
var $author$project$I18n$Cles$importsApplicationAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.application.aide', _List_Nil, 'Le modèle remplace la correspondance de cette feuille ; les colonnes qu\'il ne retrouve pas dans le fichier sont signalées.');
};
var $author$project$I18n$Cles$importsApplicationAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.application.aucun', _List_Nil, 'Aucun modèle n\'existe pour cette cible.');
};
var $author$project$I18n$Cles$importsApplicationSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.application.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'cible',
					$author$project$I18n$Traductions$Chaine(p.vf))
				]),
			'Les modèles du client rattachés à la cible « ' + (p.vf + ' ». Ceux des autres cibles ne sont pas proposés.'));
	});
var $author$project$I18n$Cles$importsApplicationTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.application.titre', _List_Nil, 'Appliquer un modèle');
};
var $author$project$Components$Imports$Outil$Update$ModeleChoisi = function (a) {
	return {$: 33, a: a};
};
var $author$project$Texte$Jour$enNumerique = function (jour) {
	var _v0 = A2($elm$core$String$split, '-', jour);
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
		var annee = _v0.a;
		var _v1 = _v0.b;
		var mois_ = _v1.a;
		var _v2 = _v1.b;
		var quantieme = _v2.a;
		return quantieme + ('/' + (mois_ + ('/' + annee)));
	} else {
		return jour;
	}
};
var $author$project$I18n$Cles$importsApplicationModeleColonnes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.application.modele-colonnes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' colonne') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' colonnes'));
	});
var $author$project$Components$Imports$Outil$View$modele = F3(
	function (i18n, model, m) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('proposition'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'choisie',
							_Utils_eq(
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.Aq;
									},
									model.ob),
								$elm$core$Maybe$Just(m.Aq)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
							$rtfeldman$elm_css$Html$Styled$Attributes$name('imports-modele'),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(
							_Utils_eq(
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.Aq;
									},
									model.ob),
								$elm$core$Maybe$Just(m.Aq))),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Imports$Outil$Update$ModeleChoisi(m))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(m.Dj)
										])),
									A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$elm$core$String$join,
												' · ',
												A2(
													$elm$core$List$filterMap,
													$elm$core$Basics$identity,
													_List_fromArray(
														[
															m.ja,
															A2(
															$elm$core$Maybe$map,
															A2(
																$elm$core$Basics$composeR,
																$elm$core$String$left(10),
																$author$project$Texte$Jour$enNumerique),
															m.yr),
															$elm$core$Maybe$Just(
															A2(
																$author$project$I18n$Cles$importsApplicationModeleColonnes,
																i18n,
																{
																	d: $elm$core$List$length(m.j1)
																}))
														]))))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Imports$Outil$View$drawerDApplication = F2(
	function (i18n, model) {
		var ouverte = $author$project$Components$Imports$Outil$Model$feuilleOuverte(model);
		var modeles = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (part) {
					return A2($author$project$Components$Imports$Outil$Model$modelesDe, part, model);
				},
				ouverte));
		var cible = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				A2(
					$elm$core$Maybe$andThen,
					function (part) {
						return A2($author$project$Components$Imports$Outil$Model$cibleDe, part, model);
					},
					ouverte)));
		return A5(
			$author$project$Components$Shared$Drawer$View$viewAvecSousTitre,
			i18n,
			A2(
				$author$project$I18n$Cles$importsApplicationSousTitre,
				i18n,
				{vf: cible}),
			$author$project$Components$Imports$Outil$Update$DuDrawerDApplication,
			{
				fs: {
					sR: !_Utils_eq(model.ob, $elm$core$Maybe$Nothing),
					Bl: $author$project$I18n$Cles$importsApplicationAction(i18n),
					C$: $author$project$Components$Imports$Outil$Update$ModeleApplique
				},
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('propositions')
							]),
						A2(
							$elm$core$List$map,
							A2($author$project$Components$Imports$Outil$View$modele, i18n, model),
							modeles)),
						_Utils_eq(modeles, _List_Nil) ? A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$importsApplicationAucun(i18n))
							])) : $rtfeldman$elm_css$Html$Styled$text(''),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$importsApplicationAide(i18n))
							]))
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$importsApplicationTitre(i18n)
			},
			model.k0);
	});
var $author$project$Components$Imports$Outil$Model$ChoixIgnorer = {$: 1};
var $author$project$Components$Imports$Outil$Update$CibleEnregistree = {$: 17};
var $author$project$Components$Imports$Outil$Update$CibleRecherchee = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Imports$Outil$Update$ChoixFait = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Imports$Outil$View$choixDeCible = F6(
	function (permise, choisi, valeur, libelle, note, pastille) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('proposition'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('choisie', choisi),
							_Utils_Tuple2('grisee', !permise)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
							$rtfeldman$elm_css$Html$Styled$Attributes$name('imports-cible'),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(choisi),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!permise),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Imports$Outil$Update$ChoixFait(valeur))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(libelle)
										])),
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function (n) {
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(n)
														]))
												]);
										},
										note)))),
							function () {
							if (!pastille.$) {
								var texte = pastille.a;
								return A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(texte)
										]));
							} else {
								return $rtfeldman$elm_css$Html$Styled$text('');
							}
						}()
						]))
				]));
	});
var $author$project$Components$Imports$Outil$View$choix = $author$project$Components$Imports$Outil$View$choixDeCible(true);
var $author$project$Components$Imports$Outil$Model$ciblesRetenues = F3(
	function (recherche, libelleDuDomaine, cibles) {
		var cherche = $elm$core$String$toLower(
			$elm$core$String$trim(recherche));
		return (cherche === '') ? cibles : A2(
			$elm$core$List$filter,
			function (cible) {
				return A2(
					$elm$core$String$contains,
					cherche,
					$elm$core$String$toLower(cible.Bl)) || A2(
					$elm$core$String$contains,
					cherche,
					$elm$core$String$toLower(
						libelleDuDomaine(cible.cC)));
			},
			cibles);
	});
var $author$project$I18n$Cles$importsCibleDomaine = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.cible.domaine',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'domaine',
					$author$project$I18n$Traductions$Chaine(p.cC)),
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (p.cC + (' · ' + (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' type'))) : (p.cC + (' · ' + (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' types'))));
	});
var $author$project$I18n$Cles$importsCibleSansDroit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.cible.sans-droit', _List_Nil, 'Sans droit');
};
var $author$project$I18n$Cles$importsCibleSuggereeParLeNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.cible.suggeree-par-le-nom', _List_Nil, 'Suggérée par le nom');
};
var $author$project$I18n$Cles$importsCibleNatureOrganisation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.cible.nature-organisation', _List_Nil, 'Organisation');
};
var $author$project$I18n$Cles$importsCibleNaturePersonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.cible.nature-personne', _List_Nil, 'Personne');
};
var $author$project$Components$Imports$Vocabulaire$nature = F2(
	function (i18n, code) {
		switch (code) {
			case 'personne':
				return $author$project$I18n$Cles$importsCibleNaturePersonne(i18n);
			case 'organisation':
				return $author$project$I18n$Cles$importsCibleNatureOrganisation(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$Components$Imports$Outil$View$proposition = F4(
	function (i18n, model, suggeree, cible) {
		return A6(
			$author$project$Components$Imports$Outil$View$choixDeCible,
			cible.Fc,
			_Utils_eq(
				model.jN,
				$elm$core$Maybe$Just(
					A2($author$project$Components$Imports$Outil$Model$ChoixCible, cible.cC, cible.r0))),
			A2($author$project$Components$Imports$Outil$Model$ChoixCible, cible.cC, cible.r0),
			cible.Bl,
			cible.Fc ? (_Utils_eq(cible.oo, _List_Nil) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A2(
					$elm$core$String$join,
					' · ',
					A2(
						$elm$core$List$map,
						$author$project$Components$Imports$Vocabulaire$nature(i18n),
						cible.oo)))) : $elm$core$Maybe$Just(
				A3(
					$author$project$Components$Imports$Vocabulaire$raisonDeCible,
					i18n,
					cible.cC,
					A2($elm$core$Maybe$withDefault, '', cible.pH))),
			(!cible.Fc) ? $elm$core$Maybe$Just(
				$author$project$I18n$Cles$importsCibleSansDroit(i18n)) : (A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (s) {
						return _Utils_eq(s.cC, cible.cC) && _Utils_eq(s.r0, cible.r0);
					},
					suggeree)) ? $elm$core$Maybe$Just(
				$author$project$I18n$Cles$importsCibleSuggereeParLeNom(i18n)) : $elm$core$Maybe$Nothing));
	});
var $author$project$Components$Imports$Outil$View$domaineDeCibles = F5(
	function (i18n, model, suggeree, cibles, domaine) {
		var deLeDomaine = A2(
			$elm$core$List$filter,
			function (cible) {
				return _Utils_eq(cible.cC, domaine);
			},
			cibles);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$importsCibleDomaine,
								i18n,
								{
									cC: A2($author$project$Components$Imports$Vocabulaire$domaine, i18n, domaine),
									d: $elm$core$List$length(deLeDomaine)
								}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('propositions')
						]),
					A2(
						$elm$core$List$map,
						A3($author$project$Components$Imports$Outil$View$proposition, i18n, model, suggeree),
						deLeDomaine))
				]));
	});
var $author$project$I18n$Cles$importsCibleAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.cible.action', _List_Nil, 'Enregistrer la cible');
};
var $author$project$I18n$Cles$importsCibleAucuneTrouvee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.cible.aucune-trouvee', _List_Nil, 'Aucun domaine ni type ne correspond à la recherche.');
};
var $author$project$I18n$Cles$importsCibleDeLaFeuille = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.cible.de-la-feuille', _List_Nil, 'Cible de cette feuille');
};
var $author$project$I18n$Cles$importsCibleIgnorer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.cible.ignorer', _List_Nil, 'Ignorer cette feuille');
};
var $author$project$I18n$Cles$importsCibleIgnorerAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.cible.ignorer-aide', _List_Nil, 'Rien n\'en est importé');
};
var $author$project$I18n$Cles$importsCibleSousTitreCsv = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.cible.sous-titre-csv',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'lignes',
					$author$project$I18n$Traductions$Entier(p.gV))
				]),
			((!p.gV) || (p.gV === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.gV) + ' ligne · aucune suggestion d\'après le nom du fichier. Tous les domaines et tous les types que vous pouvez importer sont proposés.') : (A2($author$project$I18n$Nombre$formater, 0, p.gV) + ' lignes · aucune suggestion d\'après le nom du fichier. Tous les domaines et tous les types que vous pouvez importer sont proposés.'));
	});
var $author$project$I18n$Cles$importsCibleSousTitreFeuille = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.cible.sous-titre-feuille',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'lignes',
					$author$project$I18n$Traductions$Entier(p.gV))
				]),
			((!p.gV) || (p.gV === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.gV) + ' ligne · aucune suggestion d\'après le nom de la feuille. Tous les domaines et tous les types que vous pouvez importer sont proposés.') : (A2($author$project$I18n$Nombre$formater, 0, p.gV) + ' lignes · aucune suggestion d\'après le nom de la feuille. Tous les domaines et tous les types que vous pouvez importer sont proposés.'));
	});
var $author$project$I18n$Cles$importsCibleSousTitreSuggestion = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.cible.sous-titre-suggestion',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'lignes',
					$author$project$I18n$Traductions$Entier(p.gV)),
					_Utils_Tuple2(
					'cible',
					$author$project$I18n$Traductions$Chaine(p.vf))
				]),
			((!p.gV) || (p.gV === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.gV) + (' ligne · suggestion d\'après le nom de la feuille : ' + (p.vf + ', présélectionnée.'))) : (A2($author$project$I18n$Nombre$formater, 0, p.gV) + (' lignes · suggestion d\'après le nom de la feuille : ' + (p.vf + ', présélectionnée.'))));
	});
var $author$project$I18n$Cles$importsCibleTitreCsv = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.cible.titre-csv', _List_Nil, 'Cible de la part « Tout le fichier »');
};
var $author$project$I18n$Cles$importsCibleTitreFeuille = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.cible.titre-feuille',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'feuille',
					$author$project$I18n$Traductions$Chaine(p.mx))
				]),
			'Cible de la feuille « ' + (p.mx + ' »'));
	});
var $author$project$Components$Imports$Outil$View$drawerDeCible = F2(
	function (i18n, model) {
		var ouverte = $author$project$Components$Imports$Outil$Model$feuilleOuverte(model);
		var proposee = A2($elm$core$Maybe$andThen, $author$project$Components$Imports$Outil$Model$cibleProposee, ouverte);
		var lignes = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.g9;
				},
				ouverte));
		var csv = !_Utils_eq(
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.IF;
				},
				model.tq),
			$elm$core$Maybe$Nothing);
		var cibles = A3(
			$author$project$Components$Imports$Outil$Model$ciblesRetenues,
			model.pQ,
			$author$project$Components$Imports$Vocabulaire$domaine(i18n),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.jS;
					},
					model.cN)));
		var domaines = A3(
			$elm$core$List$foldl,
			F2(
				function (cible, acc) {
					return A2($elm$core$List$member, cible.cC, acc) ? acc : _Utils_ap(
						acc,
						_List_fromArray(
							[cible.cC]));
				}),
			_List_Nil,
			cibles);
		return A5(
			$author$project$Components$Shared$Drawer$View$viewAvecSousTitre,
			i18n,
			function () {
				if (!proposee.$) {
					var s = proposee.a;
					return A2(
						$author$project$I18n$Cles$importsCibleSousTitreSuggestion,
						i18n,
						{vf: s.Bl, gV: lignes});
				} else {
					return csv ? A2(
						$author$project$I18n$Cles$importsCibleSousTitreCsv,
						i18n,
						{gV: lignes}) : A2(
						$author$project$I18n$Cles$importsCibleSousTitreFeuille,
						i18n,
						{gV: lignes});
				}
			}(),
			$author$project$Components$Imports$Outil$Update$DuDrawerDeCible,
			{
				fs: {
					sR: !_Utils_eq(model.jN, $elm$core$Maybe$Nothing),
					Bl: $author$project$I18n$Cles$importsCibleAction(i18n),
					C$: $author$project$Components$Imports$Outil$Update$CibleEnregistree
				},
				fZ: _Utils_ap(
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$label,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle'),
											$rtfeldman$elm_css$Html$Styled$Attributes$for('imports-recherche-de-cible')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$importsCibleRecherche(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$input,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
											$rtfeldman$elm_css$Html$Styled$Attributes$id('imports-recherche-de-cible'),
											$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(
											$author$project$I18n$Cles$importsCibleRechercheExemple(i18n)),
											$rtfeldman$elm_css$Html$Styled$Attributes$value(model.pQ),
											$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Imports$Outil$Update$CibleRecherchee)
										]),
									_List_Nil)
								]))
						]),
					_Utils_ap(
						csv ? _List_Nil : _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$label,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$importsCibleDeLaFeuille(i18n))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('propositions')
											]),
										_List_fromArray(
											[
												A5(
												$author$project$Components$Imports$Outil$View$choix,
												_Utils_eq(
													model.jN,
													$elm$core$Maybe$Just($author$project$Components$Imports$Outil$Model$ChoixIgnorer)),
												$author$project$Components$Imports$Outil$Model$ChoixIgnorer,
												$author$project$I18n$Cles$importsCibleIgnorer(i18n),
												$elm$core$Maybe$Just(
													$author$project$I18n$Cles$importsCibleIgnorerAide(i18n)),
												$elm$core$Maybe$Nothing)
											]))
									]))
							]),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								A4($author$project$Components$Imports$Outil$View$domaineDeCibles, i18n, model, proposee, cibles),
								domaines),
							_Utils_eq(cibles, _List_Nil) ? _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$importsCibleAucuneTrouvee(i18n))
										]))
								]) : _List_Nil))),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: csv ? $author$project$I18n$Cles$importsCibleTitreCsv(i18n) : A2(
					$author$project$I18n$Cles$importsCibleTitreFeuille,
					i18n,
					{
						mx: A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.mx;
								},
								ouverte))
					})
			},
			model.k5);
	});
var $author$project$Components$Imports$Outil$Update$ApplicationDuLotDemandee = {$: 40};
var $author$project$Components$Imports$Outil$View$aAppliquer = function (comptes) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$map,
			function (c) {
				return (c.wo + c.CP) + c.kW;
			},
			comptes));
};
var $author$project$Components$Imports$Outil$View$envoiPasPret = function (envoi) {
	if (envoi.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $author$project$I18n$Cles$importsApplicationDuLotAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.application-du-lot.action', _List_Nil, 'Appliquer l\'import');
};
var $author$project$I18n$Cles$importsApplicationDuLotArrierePlanTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.application-du-lot.arriere-plan.texte', _List_Nil, 'Au-delà de 5 000 lignes, l\'import est traité par paquets de 1 000. Vous pouvez quitter l\'écran : une notification vous prévient à la fin. Pour un petit fichier, l\'application est immédiate.');
};
var $author$project$I18n$Cles$importsApplicationDuLotArrierePlanTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.application-du-lot.arriere-plan.titre', _List_Nil, 'Traitement en arrière-plan');
};
var $author$project$I18n$Cles$importsApplicationDuLotDont = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.application-du-lot.dont',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'creees',
					$author$project$I18n$Traductions$Entier(p.wo)),
					_Utils_Tuple2(
					'modifiees',
					$author$project$I18n$Traductions$Entier(p.CP)),
					_Utils_Tuple2(
					'doublons',
					$author$project$I18n$Traductions$Entier(p.xM))
				]),
			'Dont ' + ((((!p.wo) || (p.wo === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.wo) + ' création') : (A2($author$project$I18n$Nombre$formater, 0, p.wo) + ' créations')) + (' · ' + ((((!p.CP) || (p.CP === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.CP) + ' mise à jour') : (A2($author$project$I18n$Nombre$formater, 0, p.CP) + ' mises à jour')) + (' · ' + (((!p.xM) || (p.xM === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.xM) + ' doublon possible') : (A2($author$project$I18n$Nombre$formater, 0, p.xM) + ' doublons possibles')))))));
	});
var $author$project$I18n$Cles$importsApplicationDuLotFichier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.application-du-lot.fichier', _List_Nil, 'Fichier');
};
var $author$project$I18n$Cles$importsApplicationDuLotLignes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.application-du-lot.lignes', _List_Nil, 'Lignes appliquées');
};
var $author$project$I18n$Cles$importsApplicationDuLotLignesValeur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.application-du-lot.lignes-valeur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			p.d + (' sur ' + p.JE));
	});
var $author$project$I18n$Cles$importsApplicationDuLotNonAppliquees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.application-du-lot.non-appliquees', _List_Nil, 'Non appliquées');
};
var $author$project$I18n$Cles$importsApplicationDuLotNonAppliqueesValeur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.application-du-lot.non-appliquees-valeur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'erreurs',
					$author$project$I18n$Traductions$Entier(p.gp)),
					_Utils_Tuple2(
					'effacees',
					$author$project$I18n$Traductions$Entier(p.x8))
				]),
			(((!p.gp) || (p.gp === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.gp) + ' ligne en erreur') : (A2($author$project$I18n$Nombre$formater, 0, p.gp) + ' lignes en erreur')) + (' · ' + (((!p.x8) || (p.x8 === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.x8) + ' personne effacée, ignorée') : (A2($author$project$I18n$Nombre$formater, 0, p.x8) + ' personnes effacées, ignorées'))));
	});
var $author$project$I18n$Cles$importsApplicationDuLotRegle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.application-du-lot.regle', _List_Nil, 'Chaque ligne suit les règles de la saisie. Il n\'y a pas d\'annulation globale : les fiches se corrigent ou s\'effacent une par une.');
};
var $author$project$I18n$Cles$importsApplicationDuLotSource = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.application-du-lot.source', _List_Nil, 'Source des fiches');
};
var $author$project$I18n$Cles$importsApplicationDuLotSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.application-du-lot.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' ligne : fiches créées, mises à jour ou créées comme doublons possibles, avec vos droits.') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' lignes : fiches créées, mises à jour ou créées comme doublons possibles, avec vos droits.'));
	});
var $author$project$I18n$Cles$importsApplicationDuLotTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.application-du-lot.titre', _List_Nil, 'Appliquer l\'import');
};
var $author$project$I18n$Cles$importsApplicationDuLotSourceSansOrigine = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.application-du-lot.source-sans-origine', _List_Nil, 'Import');
};
var $author$project$I18n$Cles$importsApplicationDuLotSourceValeur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.application-du-lot.source-valeur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'origine',
					$author$project$I18n$Traductions$Chaine(p.o4))
				]),
			'Import · ' + p.o4);
	});
var $author$project$Components$Imports$Outil$View$sourceDesFiches = F2(
	function (i18n, model) {
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (o, vues) {
					return A2($elm$core$List$member, o, vues) ? vues : _Utils_ap(
						vues,
						_List_fromArray(
							[o]));
				}),
			_List_Nil,
			A2(
				$elm$core$List$filterMap,
				function (part) {
					return part.qc.o4;
				},
				model.pb));
		if (!_v0.b) {
			return $author$project$I18n$Cles$importsApplicationDuLotSourceSansOrigine(i18n);
		} else {
			var origines = _v0;
			return A2(
				$author$project$I18n$Cles$importsApplicationDuLotSourceValeur,
				i18n,
				{
					o4: A2($elm$core$String$join, ', ', origines)
				});
		}
	});
var $author$project$Components$Imports$Outil$View$drawerDeConfirmation = F2(
	function (i18n, model) {
		var n = $author$project$Components$Imports$Outil$View$aAppliquer(model.rb);
		var comptes = A2(
			$elm$core$Maybe$withDefault,
			{wo: 0, kW: 0, x8: 0, gp: 0, CP: 0, qY: 0},
			model.rb);
		var sur = ((((comptes.wo + comptes.CP) + comptes.qY) + comptes.kW) + comptes.gp) + comptes.x8;
		return A5(
			$author$project$Components$Shared$Drawer$View$viewAvecSousTitre,
			i18n,
			A2(
				$author$project$I18n$Cles$importsApplicationDuLotSousTitre,
				i18n,
				{d: n}),
			$author$project$Components$Imports$Outil$Update$DuDrawerDeConfirmation,
			{
				fs: {
					sR: (!$author$project$Components$Imports$Outil$View$envoiPasPret(model.l2)) && (!_Utils_eq(
						A2($author$project$Components$Imports$Outil$Model$lienDe, $author$project$API$NavLinksDictionary$appliquerLeLot, model),
						$elm$core$Maybe$Nothing)),
					Bl: $author$project$I18n$Cles$importsApplicationDuLotAction(i18n),
					C$: $author$project$Components$Imports$Outil$Update$ApplicationDuLotDemandee
				},
				fZ: _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Note$View$view,
						0,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsApplicationDuLotArrierePlanTitre(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsApplicationDuLotArrierePlanTexte(i18n))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$dl,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('kv')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$dt,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsApplicationDuLotFichier(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$dd,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.Dj;
												},
												model.n0)))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$dt,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsApplicationDuLotLignes(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$dd,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$importsApplicationDuLotLignesValeur,
											i18n,
											{
												d: $elm$core$String$fromInt(n),
												JE: $elm$core$String$fromInt(sur)
											})),
										A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$importsApplicationDuLotDont,
													i18n,
													{wo: comptes.wo, xM: comptes.kW, CP: comptes.CP}))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$dt,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsApplicationDuLotSource(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$dd,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$Components$Imports$Outil$View$sourceDesFiches, i18n, model))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$dt,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsApplicationDuLotNonAppliquees(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$dd,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$importsApplicationDuLotNonAppliqueesValeur,
											i18n,
											{x8: comptes.x8, gp: comptes.gp}))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$importsApplicationDuLotRegle(i18n))
							]))
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$importsApplicationDuLotTitre(i18n)
			},
			model.k6);
	});
var $author$project$Components$Imports$Outil$Update$ColonneDeRepartitionChoisie = function (a) {
	return {$: 54, a: a};
};
var $author$project$Components$Imports$Outil$Update$RepartitionAppliquee = {$: 55};
var $author$project$I18n$Cles$importsRepartitionAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.repartition.action', _List_Nil, 'Répartir');
};
var $author$project$I18n$Cles$importsRepartitionAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.repartition.aide', _List_Nil, 'Chaque valeur de la colonne devient une part et reçoit sa cible, puis sa correspondance de colonnes, comme une feuille d\'un classeur.');
};
var $author$project$I18n$Cles$importsRepartitionChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.repartition.choisir', _List_Nil, 'Choisir une colonne');
};
var $author$project$I18n$Cles$importsRepartitionColonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.repartition.colonne', _List_Nil, 'Colonne qui répartit les lignes');
};
var $author$project$I18n$Cles$importsRepartitionColonneProposee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.repartition.colonne-proposee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'colonne',
					$author$project$I18n$Traductions$Chaine(p.j_))
				]),
			'proposée : colonne nommée « ' + (p.j_ + ' »'));
	});
var $author$project$I18n$Cles$importsRepartitionProposee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.repartition.proposee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'cible',
					$author$project$I18n$Traductions$Chaine(p.vf))
				]),
			'Cible proposée : ' + p.vf);
	});
var $author$project$I18n$Cles$importsRepartitionReconnue = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.repartition.reconnue',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'cible',
					$author$project$I18n$Traductions$Chaine(p.vf))
				]),
			'Cible reconnue : ' + p.vf);
	});
var $author$project$I18n$Cles$importsRepartitionValeur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.repartition.valeur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm)),
					_Utils_Tuple2(
					'lignes',
					$author$project$I18n$Traductions$Chaine(p.gV))
				]),
			p.fm + (' · lignes : ' + p.gV));
	});
var $author$project$Components$Imports$Outil$View$valeurDeRepartition = F2(
	function (i18n, v) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('proposition')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$importsRepartitionValeur,
								i18n,
								{
									gV: $elm$core$String$fromInt(v.gV),
									fm: (v.fm === '') ? $author$project$I18n$Cles$importsRepartitionVide(i18n) : v.fm
								}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('mut')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							function () {
								var _v0 = v.vf;
								if (!_v0.$) {
									var cible = _v0.a;
									return cible.mm ? A2(
										$author$project$I18n$Cles$importsRepartitionReconnue,
										i18n,
										{vf: cible.Bl}) : A2(
										$author$project$I18n$Cles$importsRepartitionProposee,
										i18n,
										{vf: cible.Bl});
								} else {
									return $author$project$I18n$Cles$importsRepartitionAucuneCible(i18n);
								}
							}())
						]))
				]));
	});
var $author$project$Components$Imports$Outil$View$drawerDeRepartition = F2(
	function (i18n, model) {
		var enTetes = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ym;
				},
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.zn;
						},
						$elm$core$List$head),
					model.tq)));
		var proposee = $author$project$Components$Imports$Outil$Model$colonneDeRepartitionProposee(enTetes);
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Imports$Outil$Update$DuDrawerDeRepartition,
			{
				fs: {
					sR: !_Utils_eq(model.sh, $elm$core$Maybe$Nothing),
					Bl: $author$project$I18n$Cles$importsRepartitionAction(i18n),
					C$: $author$project$Components$Imports$Outil$Update$RepartitionAppliquee
				},
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$label,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle'),
										$rtfeldman$elm_css$Html$Styled$Attributes$for('imports-colonne-de-repartition')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsRepartitionColonne(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$select,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('imports-colonne-de-repartition'),
										$rtfeldman$elm_css$Html$Styled$Events$onInput(
										A2(
											$elm$core$Basics$composeR,
											$elm$core$String$toInt,
											A2(
												$elm$core$Basics$composeR,
												$elm$core$Maybe$map($author$project$Components$Imports$Outil$Update$ColonneDeRepartitionChoisie),
												$elm$core$Maybe$withDefault($author$project$Components$Imports$Outil$Update$RepartitionRetiree))))
									]),
								A2(
									$elm$core$List$cons,
									A2(
										$rtfeldman$elm_css$Html$Styled$option,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$value(''),
												$rtfeldman$elm_css$Html$Styled$Attributes$selected(
												_Utils_eq(model.fS, $elm$core$Maybe$Nothing))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$importsRepartitionChoisir(i18n))
											])),
									A2(
										$elm$core$List$indexedMap,
										F2(
											function (index, entete) {
												return A2(
													$rtfeldman$elm_css$Html$Styled$option,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$value(
															$elm$core$String$fromInt(index)),
															$rtfeldman$elm_css$Html$Styled$Attributes$selected(
															_Utils_eq(
																model.fS,
																$elm$core$Maybe$Just(index)))
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(entete)
														]));
											}),
										enTetes)))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$importsRepartitionAide(i18n))
							])),
						function () {
						var _v0 = _Utils_Tuple2(proposee, model.fS);
						if ((!_v0.a.$) && (!_v0.b.$)) {
							var index = _v0.a.a;
							var choisie = _v0.b.a;
							return (_Utils_eq(index, choisie) && A2(
								$elm$core$List$all,
								function (part) {
									return _Utils_eq(part.o5, $elm$core$Maybe$Nothing);
								},
								model.pb)) ? A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$importsRepartitionColonneProposee,
											i18n,
											{
												j_: A2(
													$elm$core$Maybe$withDefault,
													'',
													$elm$core$List$head(
														A2($elm$core$List$drop, index, enTetes)))
											}))
									])) : $rtfeldman$elm_css$Html$Styled$text('');
						} else {
							return $rtfeldman$elm_css$Html$Styled$text('');
						}
					}(),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('propositions')
							]),
						A2(
							$elm$core$List$map,
							$author$project$Components$Imports$Outil$View$valeurDeRepartition(i18n),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.Ki;
									},
									model.sh))))
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$importsRepartitionTitre(i18n)
			},
			model.lf);
	});
var $author$project$I18n$Cles$importsSimulationErreursDrawerSousTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.simulation.erreurs.drawer-sous-titre', _List_Nil, 'Corrigez-les dans le fichier téléchargé puis réimportez : seules les lignes nouvelles ou corrigées sont traitées.');
};
var $author$project$I18n$Cles$importsSimulationErreursDrawerTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.simulation.erreurs.drawer-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' ligne en erreur') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' lignes en erreur'));
	});
var $author$project$Components$Shared$Drawer$View$viewAvecPiedLibreEtSousTitre = F3(
	function (i18n, sousTitre, pied) {
		return A4(
			$author$project$Components$Shared$Drawer$View$viewAvecPied,
			i18n,
			0,
			$elm$core$Maybe$Just(sousTitre),
			function (_v0) {
				return pied;
			});
	});
var $author$project$Components$Imports$Outil$View$drawerDesLignes = F2(
	function (i18n, model) {
		var detail = model.bB;
		var lignes = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.gp;
				},
				detail));
		var total = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.yx;
				},
				detail));
		return A6(
			$author$project$Components$Shared$Drawer$View$viewAvecPiedLibreEtSousTitre,
			i18n,
			$author$project$I18n$Cles$importsSimulationErreursDrawerSousTitre(i18n),
			{
				oJ: $elm$core$Maybe$Nothing,
				HF: function (attributs) {
					return A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_Utils_ap(
							attributs,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Imports$Outil$Update$DuDrawerDesLignes($author$project$Components$Shared$Drawer$Update$Fermer))
								])),
						$author$project$I18n$Cles$drawerFermer(i18n));
				},
				Jb: _List_Nil
			},
			$author$project$Components$Imports$Outil$Update$DuDrawerDesLignes,
			{
				fs: {
					sR: !_Utils_eq(model.pK, $elm$core$Maybe$Nothing),
					Bl: $author$project$I18n$Cles$importsSimulationRapport(i18n),
					C$: $author$project$Components$Imports$Outil$Update$RapportDemande
				},
				fZ: _List_fromArray(
					[
						A3(
						$author$project$Components$Imports$Outil$View$tableau,
						'erreurs',
						_List_fromArray(
							[
								$author$project$I18n$Cles$importsSimulationColonneLigne(i18n),
								$author$project$I18n$Cles$importsSimulationColonneColonne(i18n),
								$author$project$I18n$Cles$importsSimulationColonneErreur(i18n)
							]),
						A2(
							$elm$core$List$map,
							function (e) {
								return _List_fromArray(
									[
										$elm$core$String$fromInt(e.ea),
										e.j_,
										A3($author$project$Components$Imports$Vocabulaire$erreurDeLigne, i18n, e.j_, e.go)
									]);
							},
							lignes)),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$importsSimulationErreursAffichees,
									i18n,
									{
										dk: $elm$core$List$length(lignes),
										d: $elm$core$String$fromInt(total)
									}))
							]))
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: true,
				h6: A2(
					$author$project$I18n$Cles$importsSimulationErreursDrawerTitre,
					i18n,
					{d: total})
			},
			model.lk);
	});
var $author$project$Components$Imports$Outil$Update$OffreChoisie = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$Imports$Outil$Update$OrganisationInconnueChoisie = function (a) {
	return {$: 45, a: a};
};
var $author$project$Components$Imports$Outil$Update$OrigineSaisie = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Imports$Outil$Update$QualiteChoisie = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Imports$Outil$Update$ReglagesEnregistres = {$: 20};
var $author$project$I18n$Cles$importsReglagesACompleterDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.reglages.a-completer-detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'liste',
					$author$project$I18n$Traductions$Chaine(p.nW))
				]),
			'Choisissez ' + (p.nW + ' pour enregistrer les réglages.'));
	});
var $author$project$I18n$Cles$importsReglagesListeEt = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.liste.et', _List_Nil, ' et ');
};
var $author$project$I18n$Cles$importsReglagesListeBaseLegale = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.liste.base-legale', _List_Nil, 'la base légale');
};
var $author$project$I18n$Cles$importsReglagesListeForme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.liste.forme', _List_Nil, 'la forme');
};
var $author$project$I18n$Cles$importsReglagesListePays = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.liste.pays', _List_Nil, 'le pays');
};
var $author$project$Components$Imports$Vocabulaire$reglageManquant = F2(
	function (i18n, reglage) {
		switch (reglage) {
			case 'pays':
				return $author$project$I18n$Cles$importsReglagesListePays(i18n);
			case 'forme':
				return $author$project$I18n$Cles$importsReglagesListeForme(i18n);
			case 'base-legale':
				return $author$project$I18n$Cles$importsReglagesListeBaseLegale(i18n);
			default:
				var autre = reglage;
				return autre;
		}
	});
var $author$project$Components$Imports$Outil$View$bandeauDesReglages = F2(
	function (i18n, model) {
		var manquants = A2(
			$elm$core$List$filter,
			function (r) {
				return A2($elm$core$List$member, r, model.qe);
			},
			_List_fromArray(
				['pays', 'forme', 'base-legale']));
		var enumeration = function () {
			var _v0 = $elm$core$List$reverse(
				A2(
					$elm$core$List$map,
					$author$project$Components$Imports$Vocabulaire$reglageManquant(i18n),
					manquants));
			if (_v0.b && _v0.b.b) {
				var dernier = _v0.a;
				var _v1 = _v0.b;
				var avant = _v1.a;
				var debut = _v1.b;
				return _Utils_ap(
					A2(
						$elm$core$String$join,
						', ',
						$elm$core$List$reverse(
							A2($elm$core$List$cons, avant, debut))),
					_Utils_ap(
						$author$project$I18n$Cles$importsReglagesListeEt(i18n),
						dernier));
			} else {
				var seul = _v0;
				return A2($elm$core$String$join, '', seul);
			}
		}();
		return $elm$core$List$isEmpty(manquants) ? _List_Nil : _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Note$View$view,
				2,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$importsReglagesACompleter,
									i18n,
									{
										d: $elm$core$List$length(manquants)
									}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$importsReglagesACompleterDetail,
									i18n,
									{nW: enumeration}))
							]))
					]))
			]);
	});
var $author$project$I18n$Cles$importsReglagesCle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.cle', _List_Nil, 'Clé');
};
var $author$project$I18n$Cles$importsReglagesCleCode = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.cle-code', _List_Nil, 'Code de référence');
};
var $author$project$I18n$Cles$importsReglagesCleNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.cle-note', _List_Nil, 'ne se modifie pas par l\'import');
};
var $author$project$I18n$Cles$importsReglagesCleTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.cle-titre', _List_Nil, 'Clé de rapprochement');
};
var $author$project$I18n$Cles$importsReglagesCodeInconnu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.code-inconnu', _List_Nil, 'Code inconnu');
};
var $author$project$I18n$Cles$importsReglagesCodeInconnuCreer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.code-inconnu-creer', _List_Nil, 'Créer la référence');
};
var $author$project$I18n$Cles$importsReglagesErreurDeLigne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.erreur-de-ligne', _List_Nil, 'Erreur de ligne');
};
var $author$project$I18n$Cles$importsReglagesLigneSansCode = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.ligne-sans-code', _List_Nil, 'Ligne sans code');
};
var $author$project$Components$Imports$Outil$View$cleDeRapprochement = function (i18n) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
				$rtfeldman$elm_css$Html$Styled$Attributes$class('rapprochement')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$label,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$importsReglagesCleTitre(i18n))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$dl,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('kv')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$dt,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$importsReglagesCle(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$dd,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsReglagesCleCode(i18n))
									])),
								$rtfeldman$elm_css$Html$Styled$text(
								' · ' + $author$project$I18n$Cles$importsReglagesCleNote(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$dt,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$importsReglagesCodeInconnu(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$dd,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$importsReglagesCodeInconnuCreer(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$dt,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$importsReglagesLigneSansCode(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$dd,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$importsReglagesErreurDeLigne(i18n))
							]))
					]))
			]));
};
var $author$project$I18n$Cles$importsReglagesAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.action', _List_Nil, 'Enregistrer les réglages');
};
var $author$project$I18n$Cles$importsReglagesAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.aucune', _List_Nil, 'Aucune');
};
var $author$project$I18n$Cles$importsReglagesCreeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.cree-titre', _List_Nil, 'Ce que crée l\'import');
};
var $author$project$I18n$Cles$importsReglagesNature = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.nature', _List_Nil, 'Nature');
};
var $author$project$I18n$Cles$importsReglagesOffre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.offre', _List_Nil, 'Offre');
};
var $author$project$I18n$Cles$importsReglagesOrganisationInconnue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.organisation-inconnue', _List_Nil, 'Organisation inconnue');
};
var $author$project$I18n$Cles$importsReglagesOrganisationInconnueCreer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.organisation-inconnue.creer', _List_Nil, 'Créer l\'organisation');
};
var $author$project$I18n$Cles$importsReglagesOrganisationInconnueErreur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.organisation-inconnue.erreur', _List_Nil, 'Erreur de ligne');
};
var $author$project$I18n$Cles$importsReglagesOrigine = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.origine', _List_Nil, 'Origine');
};
var $author$project$I18n$Cles$importsReglagesOrigineExemple = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.origine-exemple', _List_Nil, 'Ex. : Reprise Héritage 2026');
};
var $author$project$I18n$Cles$importsReglagesQualite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.qualite', _List_Nil, 'Qualité');
};
var $author$project$I18n$Cles$importsReglagesQualiteAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.qualite-aucune', _List_Nil, 'Non précisée');
};
var $author$project$I18n$Cles$importsReglagesRoles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.roles', _List_Nil, 'Rôles à ouvrir');
};
var $author$project$I18n$Cles$importsReglagesSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.reglages.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'lignes',
					$author$project$I18n$Traductions$Entier(p.gV)),
					_Utils_Tuple2(
					'cible',
					$author$project$I18n$Traductions$Chaine(p.vf))
				]),
			((!p.gV) || (p.gV === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.gV) + (' ligne · cible ' + (p.vf + '. Ce qui dépend de la cible se règle ici, part par part.'))) : (A2($author$project$I18n$Nombre$formater, 0, p.gV) + (' lignes · cible ' + (p.vf + '. Ce qui dépend de la cible se règle ici, part par part.'))));
	});
var $author$project$I18n$Cles$importsReglagesTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.reglages.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'part',
					$author$project$I18n$Traductions$Chaine(p.o9))
				]),
			'Réglages de la part « ' + (p.o9 + ' »'));
	});
var $author$project$I18n$Cles$importsReglagesType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.type', _List_Nil, 'Type');
};
var $author$project$I18n$Cles$importsSiExisteCompleterAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.si-existe.completer-aide', _List_Nil, 'et ajouter les nouveaux moyens de contact');
};
var $author$project$I18n$Cles$importsSiExisteMettreAJourAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.si-existe.mettre-a-jour-aide', _List_Nil, 'Les valeurs du fichier remplacent celles de la fiche');
};
var $author$project$I18n$Cles$importsSiExisteTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.si-existe.titre', _List_Nil, 'Si la fiche existe déjà (même email ou identifiant légal)');
};
var $author$project$I18n$Cles$importsSiExisteTitreReference = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.si-existe.titre-reference', _List_Nil, 'Si la référence existe déjà');
};
var $author$project$Components$Imports$Outil$View$organisationInconnueEnChoix = function (reglages) {
	return A2($elm$core$Maybe$withDefault, 'creer', reglages.hi);
};
var $author$project$I18n$Cles$importsReglagesQualiteParticulier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.qualite-particulier', _List_Nil, 'Particulier');
};
var $author$project$I18n$Cles$importsReglagesQualiteProfessionnel = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.qualite-professionnel', _List_Nil, 'Professionnel');
};
var $author$project$Components$Imports$Vocabulaire$qualites = function (i18n) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'Professionnel',
			$author$project$I18n$Cles$importsReglagesQualiteProfessionnel(i18n)),
			_Utils_Tuple2(
			'Particulier',
			$author$project$I18n$Cles$importsReglagesQualiteParticulier(i18n))
		]);
};
var $author$project$Components$Imports$Outil$Update$SiExisteChoisi = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Imports$Outil$View$reglageDeSiExiste = F3(
	function (i18n, model, _v0) {
		var valeur = _v0.a;
		var aide = _v0.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('proposition'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'choisie',
							_Utils_eq(model.q9, valeur))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
							$rtfeldman$elm_css$Html$Styled$Attributes$name('imports-si-existe'),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(
							_Utils_eq(model.q9, valeur)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Imports$Outil$Update$SiExisteChoisi(valeur))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$Components$Imports$Vocabulaire$siExiste, i18n, valeur))
										])),
								(aide === '') ? _List_Nil : _List_fromArray(
									[
										A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(aide)
											]))
									])))
						]))
				]));
	});
var $author$project$Components$Imports$Outil$Update$BaseLegaleChoisie = function (a) {
	return {$: 25, a: a};
};
var $author$project$Components$Imports$Outil$Update$FormeChoisie = function (a) {
	return {$: 27, a: a};
};
var $author$project$Components$Imports$Outil$Update$PaysChoisi = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$Imports$Outil$Model$admisesDe = F3(
	function (part, champ, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Dict$get,
				A2($author$project$Components$Imports$Outil$Model$cleDesAdmises, part, champ),
				model.fu));
	});
var $author$project$Components$Imports$Outil$Model$colonnesConnues = F2(
	function (part, model) {
		return A2($elm$core$List$member, part.mx, model.hw) || (!$elm$core$Dict$isEmpty(part.j1));
	});
var $author$project$I18n$Cles$importsBaseLegaleConsentement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.base-legale.consentement', _List_Nil, 'Consentement');
};
var $author$project$I18n$Cles$importsBaseLegaleConsentementAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.base-legale.consentement-aide', _List_Nil, 'la personne a donné son accord');
};
var $author$project$I18n$Cles$importsBaseLegaleContrat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.base-legale.contrat', _List_Nil, 'Contrat');
};
var $author$project$I18n$Cles$importsBaseLegaleContratAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.base-legale.contrat-aide', _List_Nil, 'un contrat ou sa préparation');
};
var $author$project$I18n$Cles$importsBaseLegaleInteret = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.base-legale.interet', _List_Nil, 'Intérêt légitime');
};
var $author$project$I18n$Cles$importsBaseLegaleInteretAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.base-legale.interet-aide', _List_Nil, 'relation attendue par la personne');
};
var $author$project$I18n$Cles$importsBaseLegaleObligation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.base-legale.obligation', _List_Nil, 'Obligation légale');
};
var $author$project$I18n$Cles$importsBaseLegaleObligationAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.base-legale.obligation-aide', _List_Nil, 'une loi impose le traitement');
};
var $author$project$I18n$Cles$importsReglagesBaseLegale = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.base-legale', _List_Nil, 'Base légale des personnes créées');
};
var $author$project$I18n$Cles$importsReglagesBaseLegaleAChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.base-legale-a-choisir', _List_Nil, 'Choisissez une base légale : cet import crée des personnes.');
};
var $author$project$I18n$Cles$importsReglagesBaseLegaleAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.base-legale-aide', _List_Nil, 'Vaut pour chaque personne créée par ce fichier. Une personne déjà dans le CRM garde la sienne.');
};
var $author$project$I18n$Cles$importsReglagesChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.choisir', _List_Nil, 'Choisir');
};
var $author$project$I18n$Cles$importsReglagesForme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.forme', _List_Nil, 'Forme, pour tout le fichier');
};
var $author$project$I18n$Cles$importsReglagesFormeAChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.forme-a-choisir', _List_Nil, 'Choisissez une forme : le fichier n\'en donne aucune.');
};
var $author$project$I18n$Cles$importsReglagesFormeAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.forme-aide', _List_Nil, 'Le fichier n\'a pas de colonne « Forme » : cette forme vaut pour chaque organisation créée.');
};
var $author$project$I18n$Cles$importsReglagesObligatoire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.obligatoire', _List_Nil, 'obligatoire');
};
var $author$project$I18n$Cles$importsReglagesPays = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.pays', _List_Nil, 'Pays, pour tout le fichier');
};
var $author$project$I18n$Cles$importsReglagesPaysAChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.pays-a-choisir', _List_Nil, 'Choisissez un pays : le fichier n\'en donne aucun.');
};
var $author$project$I18n$Cles$importsReglagesPaysAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.pays-aide', _List_Nil, 'Le fichier n\'a pas de colonne « Pays » : ce pays vaut pour chaque ligne.');
};
var $author$project$I18n$Cles$importsReglagesRoleRequis = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.role-requis', _List_Nil, 'Cochez au moins un rôle à ouvrir.');
};
var $author$project$Components$Imports$Outil$View$reglagesPourToutLeFichier = F3(
	function (i18n, model, ouverte) {
		if (ouverte.$ === 1) {
			return _List_Nil;
		} else {
			var part = ouverte.a;
			if (!A2($author$project$Components$Imports$Outil$Model$colonnesConnues, part, model)) {
				return _List_Nil;
			} else {
				var requis = A2($author$project$Components$Imports$Outil$Model$reglagesRequis, part, model);
				var refuse = F2(
					function (reglage, message) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('errors')
								]),
							A2($elm$core$List$member, reglage, model.qe) ? _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(message)
										]))
								]) : _List_Nil);
					});
				var liste = F3(
					function (cle, choisi, msg) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$select,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id('imports-reglage-' + cle),
									$rtfeldman$elm_css$Html$Styled$Events$onInput(msg)
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$rtfeldman$elm_css$Html$Styled$option,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(''),
											$rtfeldman$elm_css$Html$Styled$Attributes$selected(
											_Utils_eq(choisi, $elm$core$Maybe$Nothing))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$importsReglagesChoisir(i18n))
										])),
								A2(
									$elm$core$List$map,
									function (admise) {
										return A2(
											$rtfeldman$elm_css$Html$Styled$option,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$value(admise.vx),
													$rtfeldman$elm_css$Html$Styled$Attributes$selected(
													_Utils_eq(
														choisi,
														$elm$core$Maybe$Just(admise.vx)))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(admise.Bl)
												]));
									},
									A3($author$project$Components$Imports$Outil$Model$admisesDe, part, cle, model))));
					});
				var champ = F5(
					function (reglage, libelle, aide, message, saisie) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('mandatory'),
									$rtfeldman$elm_css$Html$Styled$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'error',
											A2($elm$core$List$member, reglage, model.qe))
										]))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$label,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(libelle),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('obligatoire')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$importsReglagesObligatoire(i18n))
												]))
										])),
									saisie,
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(aide)
										])),
									A2(refuse, reglage, message)
								]));
					});
				return _Utils_ap(
					A2($elm$core$List$member, 'pays', requis) ? _List_fromArray(
						[
							A5(
							champ,
							'pays',
							$author$project$I18n$Cles$importsReglagesPays(i18n),
							$author$project$I18n$Cles$importsReglagesPaysAide(i18n),
							$author$project$I18n$Cles$importsReglagesPaysAChoisir(i18n),
							A3(liste, 'pays', model.hG.ho, $author$project$Components$Imports$Outil$Update$PaysChoisi))
						]) : _List_Nil,
					_Utils_ap(
						A2($elm$core$List$member, 'forme', requis) ? _List_fromArray(
							[
								A5(
								champ,
								'forme',
								$author$project$I18n$Cles$importsReglagesForme(i18n),
								$author$project$I18n$Cles$importsReglagesFormeAide(i18n),
								$author$project$I18n$Cles$importsReglagesFormeAChoisir(i18n),
								A3(liste, 'forme', model.hG.gB, $author$project$Components$Imports$Outil$Update$FormeChoisie))
							]) : _List_Nil,
						_Utils_ap(
							A2($elm$core$List$member, 'base-legale', requis) ? _List_fromArray(
								[
									A5(
									champ,
									'base-legale',
									$author$project$I18n$Cles$importsReglagesBaseLegale(i18n),
									$author$project$I18n$Cles$importsReglagesBaseLegaleAide(i18n),
									$author$project$I18n$Cles$importsReglagesBaseLegaleAChoisir(i18n),
									A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('propositions')
											]),
										A2(
											$elm$core$List$map,
											function (_v1) {
												var valeur = _v1.a;
												var libelle = _v1.b;
												var aide = _v1.c;
												return A2(
													$rtfeldman$elm_css$Html$Styled$label,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('proposition'),
															$rtfeldman$elm_css$Html$Styled$Attributes$classList(
															_List_fromArray(
																[
																	_Utils_Tuple2(
																	'choisie',
																	_Utils_eq(
																		model.hG.fI,
																		$elm$core$Maybe$Just(valeur)))
																]))
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$input,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
																	$rtfeldman$elm_css$Html$Styled$Attributes$name('imports-base-legale'),
																	$rtfeldman$elm_css$Html$Styled$Attributes$checked(
																	_Utils_eq(
																		model.hG.fI,
																		$elm$core$Maybe$Just(valeur))),
																	$rtfeldman$elm_css$Html$Styled$Events$onClick(
																	$author$project$Components$Imports$Outil$Update$BaseLegaleChoisie(valeur))
																]),
															_List_Nil),
															A2(
															$rtfeldman$elm_css$Html$Styled$span,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
																]),
															_List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$span,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$rtfeldman$elm_css$Html$Styled$strong,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$rtfeldman$elm_css$Html$Styled$text(libelle)
																				]))
																		])),
																	A2(
																	$rtfeldman$elm_css$Html$Styled$span,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
																		]),
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text(aide)
																		]))
																]))
														]));
											},
											_List_fromArray(
												[
													_Utils_Tuple3(
													'Consentement',
													$author$project$I18n$Cles$importsBaseLegaleConsentement(i18n),
													$author$project$I18n$Cles$importsBaseLegaleConsentementAide(i18n)),
													_Utils_Tuple3(
													'InteretLegitime',
													$author$project$I18n$Cles$importsBaseLegaleInteret(i18n),
													$author$project$I18n$Cles$importsBaseLegaleInteretAide(i18n)),
													_Utils_Tuple3(
													'Contrat',
													$author$project$I18n$Cles$importsBaseLegaleContrat(i18n),
													$author$project$I18n$Cles$importsBaseLegaleContratAide(i18n)),
													_Utils_Tuple3(
													'ObligationLegale',
													$author$project$I18n$Cles$importsBaseLegaleObligation(i18n),
													$author$project$I18n$Cles$importsBaseLegaleObligationAide(i18n))
												]))))
								]) : _List_Nil,
							A2($elm$core$List$member, 'roles', model.qe) ? _List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Note$View$view,
									2,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$importsReglagesRoleRequis(i18n))
										]))
								]) : _List_Nil)));
			}
		}
	});
var $author$project$Components$Imports$Outil$Update$RoleBascule = function (a) {
	return {$: 23, a: a};
};
var $author$project$I18n$Cles$importsReglagesAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.aucun', _List_Nil, 'Aucun');
};
var $author$project$Components$Imports$Outil$View$rolesAOuvrir = F3(
	function (i18n, model, natures) {
		var possibles = A2(
			$elm$core$List$filter,
			function (leType) {
				return A2(
					$elm$core$List$any,
					function (nature) {
						return A2($elm$core$List$member, nature, leType.oo);
					},
					natures);
			},
			A2($elm$core$Maybe$withDefault, _List_Nil, model.ie));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('zone-roles')
				]),
			_List_fromArray(
				[
					$elm$core$List$isEmpty(possibles) ? $rtfeldman$elm_css$Html$Styled$text(
					$author$project$I18n$Cles$importsReglagesAucun(i18n)) : A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('propositions')
						]),
					A2(
						$elm$core$List$map,
						function (leType) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$label,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('role-a-ouvrir')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$input,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
												$rtfeldman$elm_css$Html$Styled$Attributes$checked(
												A2($elm$core$List$member, leType.r8, model.hG.eX)),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												$author$project$Components$Imports$Outil$Update$RoleBascule(leType.r8))
											]),
										_List_Nil),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(leType.Bl)
											]))
									]));
						},
						possibles))
				]));
	});
var $author$project$Components$Imports$Outil$View$drawerDesReglages = F2(
	function (i18n, model) {
		var reglagesEnChoix = model.hG;
		var refusSous = function (reglage) {
			var _v2 = model.pZ;
			if ((!_v2.$) && (_v2.a.$ === 10)) {
				var _v3 = _v2.a;
				var r = _v3.a;
				var raison = _v3.b;
				return _Utils_eq(r, reglage) ? A2(
					$author$project$Components$Shared$Note$View$view,
					2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$importsReglagesRefuse,
								i18n,
								{
									pH: A3($author$project$Components$Imports$Vocabulaire$raisonDeReglage, i18n, r, raison)
								}))
						])) : $rtfeldman$elm_css$Html$Styled$text('');
			} else {
				return $rtfeldman$elm_css$Html$Styled$text('');
			}
		};
		var ouverte = $author$project$Components$Imports$Outil$Model$feuilleOuverte(model);
		var laCible = A2(
			$elm$core$Maybe$andThen,
			function (part) {
				return A2($author$project$Components$Imports$Outil$Model$cibleDe, part, model);
			},
			ouverte);
		var cible = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				laCible));
		var catalogue = _Utils_eq(
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.cC;
				},
				laCible),
			$elm$core$Maybe$Just('catalogue'));
		return A5(
			$author$project$Components$Shared$Drawer$View$viewAvecSousTitre,
			i18n,
			A2(
				$author$project$I18n$Cles$importsReglagesSousTitre,
				i18n,
				{
					vf: cible,
					gV: A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.g9;
							},
							ouverte))
				}),
			$author$project$Components$Imports$Outil$Update$DuDrawerDesReglages,
			{
				fs: {
					sR: true,
					Bl: $author$project$I18n$Cles$importsReglagesAction(i18n),
					C$: $author$project$Components$Imports$Outil$Update$ReglagesEnregistres
				},
				fZ: _Utils_ap(
					A2($author$project$Components$Imports$Outil$View$bandeauDesReglages, i18n, model),
					_Utils_ap(
						catalogue ? _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$label,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$importsReglagesCreeTitre(i18n))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$dl,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('kv')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$dt,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$importsReglagesType(i18n))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$dd,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2(
															$elm$core$Maybe$withDefault,
															'',
															A2(
																$elm$core$Maybe$map,
																function ($) {
																	return $.Bl;
																},
																laCible)))
													]))
											]))
									])),
								$author$project$Components$Imports$Outil$View$cleDeRapprochement(i18n)
							]) : _Utils_ap(
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$label,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$importsReglagesCreeTitre(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$dl,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('kv')
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$dt,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$importsReglagesNature(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$dd,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															A2(
																$elm$core$Maybe$withDefault,
																'',
																A2(
																	$elm$core$Maybe$map,
																	A2(
																		$elm$core$Basics$composeR,
																		function ($) {
																			return $.oo;
																		},
																		A2(
																			$elm$core$Basics$composeR,
																			$elm$core$List$map(
																				$author$project$Components$Imports$Vocabulaire$nature(i18n)),
																			$elm$core$String$join(' · '))),
																	laCible)))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$dt,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$importsReglagesQualite(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$dd,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$select,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$id('imports-reglage-qualite'),
																	$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Imports$Outil$Update$QualiteChoisie)
																]),
															A2(
																$elm$core$List$map,
																function (_v0) {
																	var code = _v0.a;
																	var libelle = _v0.b;
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$option,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$value(code),
																				$rtfeldman$elm_css$Html$Styled$Attributes$selected(
																				_Utils_eq(
																					A2($elm$core$Maybe$withDefault, '', reglagesEnChoix.hy),
																					code))
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(libelle)
																			]));
																},
																A2(
																	$elm$core$List$cons,
																	_Utils_Tuple2(
																		'',
																		$author$project$I18n$Cles$importsReglagesQualiteAucune(i18n)),
																	$author$project$Components$Imports$Vocabulaire$qualites(i18n)))),
															refusSous('qualite')
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$dt,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$importsReglagesRoles(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$dd,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('roles-a-ouvrir')
														]),
													_List_fromArray(
														[
															A3(
															$author$project$Components$Imports$Outil$View$rolesAOuvrir,
															i18n,
															model,
															A2(
																$elm$core$Maybe$withDefault,
																_List_Nil,
																A2(
																	$elm$core$Maybe$map,
																	function ($) {
																		return $.oo;
																	},
																	laCible))),
															refusSous('role')
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$dt,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$importsReglagesOffre(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$dd,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$select,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$id('imports-reglage-offre'),
																	$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Imports$Outil$Update$OffreChoisie)
																]),
															A2(
																$elm$core$List$cons,
																A2(
																	$rtfeldman$elm_css$Html$Styled$option,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$value(''),
																			$rtfeldman$elm_css$Html$Styled$Attributes$selected(
																			_Utils_eq(reglagesEnChoix.D1, $elm$core$Maybe$Nothing))
																		]),
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text(
																			$author$project$I18n$Cles$importsReglagesAucune(i18n))
																		])),
																A2(
																	$elm$core$List$map,
																	function (offre) {
																		return A2(
																			$rtfeldman$elm_css$Html$Styled$option,
																			_List_fromArray(
																				[
																					$rtfeldman$elm_css$Html$Styled$Attributes$value(offre.Aq),
																					$rtfeldman$elm_css$Html$Styled$Attributes$selected(
																					_Utils_eq(
																						reglagesEnChoix.D1,
																						$elm$core$Maybe$Just(offre.Aq)))
																				]),
																			_List_fromArray(
																				[
																					$rtfeldman$elm_css$Html$Styled$text(offre.Dj)
																				]));
																	},
																	A2($elm$core$Maybe$withDefault, _List_Nil, model.oX)))),
															refusSous('offre')
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$dt,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$importsReglagesOrigine(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$dd,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$input,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
																	$rtfeldman$elm_css$Html$Styled$Attributes$id('imports-reglage-origine'),
																	$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(
																	$author$project$I18n$Cles$importsReglagesOrigineExemple(i18n)),
																	$rtfeldman$elm_css$Html$Styled$Attributes$value(
																	A2($elm$core$Maybe$withDefault, '', reglagesEnChoix.o4)),
																	$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Imports$Outil$Update$OrigineSaisie)
																]),
															_List_Nil),
															refusSous('origine')
														]))
												]))
										]))
								]),
							A3($author$project$Components$Imports$Outil$View$reglagesPourToutLeFichier, i18n, model, ouverte)),
						_Utils_ap(
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$label,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													catalogue ? $author$project$I18n$Cles$importsSiExisteTitreReference(i18n) : $author$project$I18n$Cles$importsSiExisteTitre(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('propositions')
												]),
											A2(
												$elm$core$List$map,
												A2($author$project$Components$Imports$Outil$View$reglageDeSiExiste, i18n, model),
												catalogue ? _List_fromArray(
													[
														_Utils_Tuple2(
														'mettre-a-jour',
														$author$project$I18n$Cles$importsSiExisteMettreAJourAide(i18n)),
														_Utils_Tuple2('ne-rien-modifier', '')
													]) : _List_fromArray(
													[
														_Utils_Tuple2(
														'completer',
														$author$project$I18n$Cles$importsSiExisteCompleterAide(i18n)),
														_Utils_Tuple2('ne-rien-modifier', '')
													])))
										]))
								]),
							_Utils_eq(
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.r0;
									},
									laCible),
								$elm$core$Maybe$Just('rattachement')) ? _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$label,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$importsReglagesOrganisationInconnue(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('propositions')
												]),
											A2(
												$elm$core$List$map,
												function (_v1) {
													var valeur = _v1.a;
													var libelle = _v1.b;
													return A2(
														$rtfeldman$elm_css$Html$Styled$label,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('proposition'),
																$rtfeldman$elm_css$Html$Styled$Attributes$classList(
																_List_fromArray(
																	[
																		_Utils_Tuple2(
																		'choisie',
																		_Utils_eq(
																			$author$project$Components$Imports$Outil$View$organisationInconnueEnChoix(reglagesEnChoix),
																			valeur))
																	]))
															]),
														_List_fromArray(
															[
																A2(
																$rtfeldman$elm_css$Html$Styled$input,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
																		$rtfeldman$elm_css$Html$Styled$Attributes$name('imports-organisation-inconnue'),
																		$rtfeldman$elm_css$Html$Styled$Attributes$checked(
																		_Utils_eq(
																			$author$project$Components$Imports$Outil$View$organisationInconnueEnChoix(reglagesEnChoix),
																			valeur)),
																		$rtfeldman$elm_css$Html$Styled$Events$onClick(
																		$author$project$Components$Imports$Outil$Update$OrganisationInconnueChoisie(valeur))
																	]),
																_List_Nil),
																A2(
																$rtfeldman$elm_css$Html$Styled$span,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$rtfeldman$elm_css$Html$Styled$span,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$strong,
																				_List_Nil,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(libelle)
																					]))
																			]))
																	]))
															]));
												},
												_List_fromArray(
													[
														_Utils_Tuple2(
														'creer',
														$author$project$I18n$Cles$importsReglagesOrganisationInconnueCreer(i18n)),
														_Utils_Tuple2(
														'erreur',
														$author$project$I18n$Cles$importsReglagesOrganisationInconnueErreur(i18n))
													])))
										]))
								]) : _List_Nil))),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: A2(
					$author$project$I18n$Cles$importsReglagesTitre,
					i18n,
					{
						o9: A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.mx;
								},
								ouverte))
					})
			},
			model.ll);
	});
var $author$project$Components$Imports$Outil$Update$ReglesEnregistrees = {$: 64};
var $author$project$Components$Imports$Outil$Update$ReglesSaisies = function (a) {
	return {$: 63, a: a};
};
var $author$project$Components$Imports$Outil$View$choixDeRegle = F5(
	function (libelle, nom, options, actuel, versMsg) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('propositions')
						]),
					A2(
						$elm$core$List$map,
						function (_v0) {
							var v = _v0.a;
							var texte = _v0.b;
							return A2(
								$rtfeldman$elm_css$Html$Styled$label,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('proposition'),
										$rtfeldman$elm_css$Html$Styled$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'choisie',
												_Utils_eq(actuel, v))
											]))
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$input,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
												$rtfeldman$elm_css$Html$Styled$Attributes$name(nom),
												$rtfeldman$elm_css$Html$Styled$Attributes$checked(
												_Utils_eq(actuel, v)),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												versMsg(v))
											]),
										_List_Nil),
										function () {
										var _v1 = A2($elm$core$String$split, ' · ', texte);
										if ((_v1.b && _v1.b.b) && (!_v1.b.b.b)) {
											var intitule = _v1.a;
											var _v2 = _v1.b;
											var exemple_ = _v2.a;
											return A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(intitule),
														A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('exemple')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(exemple_)
															]))
													]));
										} else {
											return A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(texte)
													]));
										}
									}()
									]));
						},
						options))
				]));
	});
var $author$project$I18n$Cles$importsReglesAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.action', _List_Nil, 'Appliquer');
};
var $author$project$I18n$Cles$importsReglesAideDate = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.aide-date', _List_Nil, 'Comment lire les dates de cette colonne.');
};
var $author$project$I18n$Cles$importsReglesAideDecimal = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.aide-decimal', _List_Nil, 'Comment lire les nombres de cette colonne.');
};
var $author$project$I18n$Cles$importsReglesAideLangues = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.aide-langues', _List_Nil, 'Une colonne du fichier par langue ouverte pour ce champ.');
};
var $author$project$I18n$Cles$importsReglesAideListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.aide-liste', _List_Nil, 'Une cellule peut contenir plusieurs valeurs de la liste.');
};
var $author$project$I18n$Cles$importsReglesAideUnite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.aide-unite', _List_Nil, 'La valeur est convertie dans l\'unité du champ dès la lecture.');
};
var $author$project$I18n$Cles$importsReglesDateLabel = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.date-label', _List_Nil, 'Format');
};
var $author$project$I18n$Cles$importsReglesLangueSansColonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.langue-sans-colonne', _List_Nil, 'Langue sans colonne');
};
var $author$project$I18n$Cles$importsReglesLangueSansColonneAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.langue-sans-colonne-aide', _List_Nil, 'La valeur de la langue du client sert de repli ; elle reste modifiable ensuite dans la fiche.');
};
var $author$project$I18n$Cles$importsReglesSeparateurLabel = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.separateur-label', _List_Nil, 'Séparateur');
};
var $author$project$I18n$Cles$importsReglesTitreDate = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.regles.titre-date',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'colonne',
					$author$project$I18n$Traductions$Chaine(p.j_))
				]),
			'Format de la colonne « ' + (p.j_ + ' »'));
	});
var $author$project$I18n$Cles$importsReglesTitreLangues = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.regles.titre-langues',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'Colonnes par langue · ' + p.uN);
	});
var $author$project$I18n$Cles$importsReglesTitreSeparateur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.regles.titre-separateur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'colonne',
					$author$project$I18n$Traductions$Chaine(p.j_))
				]),
			'Séparateur de la colonne « ' + (p.j_ + ' »'));
	});
var $author$project$I18n$Cles$importsReglesTitreUnite = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.regles.titre-unite',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'colonne',
					$author$project$I18n$Traductions$Chaine(p.j_))
				]),
			'Unité de la colonne « ' + (p.j_ + ' »'));
	});
var $author$project$I18n$Cles$importsReglesUniteFixe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.unite-fixe', _List_Nil, 'Fixe pour toute la colonne');
};
var $author$project$I18n$Cles$importsReglesUniteLabel = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.unite-label', _List_Nil, 'Unité');
};
var $author$project$I18n$Cles$importsReglesUniteLue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.unite-lue', _List_Nil, 'Lue dans la cellule : « 71L » donne 71 litres');
};
var $author$project$I18n$Cles$importsReglesVideTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.vide-texte', _List_Nil, 'Lue comme vide si le champ n\'est pas obligatoire ; erreur de ligne s\'il l\'est.');
};
var $author$project$I18n$Cles$importsReglesVideTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.vide-titre', _List_Nil, 'Cellule vide ou « TBD », « N/A », « / »');
};
var $author$project$I18n$Cles$importsReglesLangueDeNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.langue-de-nom', _List_Nil, 'Deutsch');
};
var $author$project$I18n$Cles$importsReglesLangueEnNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.langue-en-nom', _List_Nil, 'English');
};
var $author$project$I18n$Cles$importsReglesLangueFrClient = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.langue-fr-client', _List_Nil, 'Français · langue du client');
};
var $author$project$Components$Imports$Outil$View$langues = function (i18n) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'',
			$author$project$I18n$Cles$importsReglesLangueFrClient(i18n)),
			_Utils_Tuple2(
			'en',
			$author$project$I18n$Cles$importsReglesLangueEnNom(i18n)),
			_Utils_Tuple2(
			'de',
			$author$project$I18n$Cles$importsReglesLangueDeNom(i18n))
		]);
};
var $author$project$Components$Imports$Outil$Update$LangueDeColonneChoisie = F2(
	function (a, b) {
		return {$: 65, a: a, b: b};
	});
var $author$project$I18n$Cles$importsReglesLangueIgnoree = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.langue-ignoree', _List_Nil, 'Ignorer cette langue');
};
var $author$project$Components$Imports$Outil$View$ligneDeLangue = F4(
	function (i18n, part, cle, _v0) {
		var langue = _v0.a;
		var libelle = _v0.b;
		var retenue = A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v1) {
						var l = _v1.a;
						return _Utils_eq(l, langue);
					},
					A2($author$project$Components$Imports$Outil$Model$colonnesParLangue, part, cle))));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-item', true),
							_Utils_Tuple2('langue', true)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$select,
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', libelle),
							$rtfeldman$elm_css$Html$Styled$Events$onInput(
							function (v) {
								return A2(
									$author$project$Components$Imports$Outil$Update$LangueDeColonneChoisie,
									langue,
									$elm$core$String$toInt(v));
							})
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$option,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(''),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(retenue, $elm$core$Maybe$Nothing))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$importsReglesLangueIgnoree(i18n))
								])),
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (index, entete) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$option,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$value(
												$elm$core$String$fromInt(index)),
												$rtfeldman$elm_css$Html$Styled$Attributes$selected(
												_Utils_eq(
													retenue,
													$elm$core$Maybe$Just(index)))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(entete)
											]));
								}),
							part.ym)))
				]));
	});
var $author$project$I18n$Cles$importsReglesApercu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.apercu', _List_Nil, 'Aperçu des premières lignes');
};
var $author$project$I18n$Cles$importsReglesDansLeFichier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.dans-le-fichier', _List_Nil, 'Dans le fichier');
};
var $author$project$I18n$Cles$importsReglesLuComme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.regles.lu-comme', _List_Nil, 'Lu comme');
};
var $author$project$I18n$Cles$importsLectureErreur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.lecture.erreur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'raison',
					$author$project$I18n$Traductions$Chaine(p.pH))
				]),
			'erreur : ' + p.pH);
	});
var $author$project$I18n$Cles$importsLectureVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lecture.vide', _List_Nil, 'vide');
};
var $author$project$Components$Imports$Outil$View$ligneLue = F2(
	function (i18n, ligne) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('exemple-du-fichier')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(ligne.B0)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							function () {
								var _v0 = _Utils_Tuple2(ligne.kb, ligne.go);
								if (!_v0.a.$) {
									var valeur = _v0.a.a;
									return $author$project$Components$Imports$Outil$Model$valeurLue(valeur);
								} else {
									if (!_v0.b.$) {
										var _v1 = _v0.a;
										var code = _v0.b.a;
										return (code === 'a-faire-correspondre') ? A2($author$project$Components$Imports$Vocabulaire$erreurDeLecture, i18n, code) : A2(
											$author$project$I18n$Cles$importsLectureErreur,
											i18n,
											{
												pH: A2($author$project$Components$Imports$Vocabulaire$erreurDeLecture, i18n, code)
											});
									} else {
										var _v2 = _v0.a;
										var _v3 = _v0.b;
										return $author$project$I18n$Cles$importsLectureVide(i18n);
									}
								}
							}())
						]))
				]));
	});
var $author$project$Components$Imports$Outil$View$luComme = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.qf, model.nq);
		_v0$0:
		while (true) {
			if (_v0.b.$ === 1) {
				if ((!_v0.a.$) && (_v0.a.a === 3)) {
					break _v0$0;
				} else {
					var _v2 = _v0.b;
					return _List_Nil;
				}
			} else {
				if ((!_v0.a.$) && (_v0.a.a === 3)) {
					break _v0$0;
				} else {
					var lignes = _v0.b.a;
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('lu-comme')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$label,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$importsReglesApercu(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$table,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$thead,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$tr,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	$author$project$I18n$Cles$importsReglesDansLeFichier(i18n))
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	$author$project$I18n$Cles$importsReglesLuComme(i18n))
																]))
														]))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$tbody,
											_List_Nil,
											A2(
												$elm$core$List$map,
												$author$project$Components$Imports$Outil$View$ligneLue(i18n),
												lignes))
										]))
								]))
						]);
				}
			}
		}
		var _v1 = _v0.a.a;
		return _List_Nil;
	});
var $author$project$Components$Imports$Outil$View$rien = function (valeur) {
	return (valeur === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(valeur);
};
var $author$project$Components$Imports$Outil$View$drawerDesRegles = F2(
	function (i18n, model) {
		var regles = model.qg;
		var ouverte = $author$project$Components$Imports$Outil$Model$feuilleOuverte(model);
		var entete = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				function (part) {
					return A2(
						$elm$core$Maybe$andThen,
						function (index) {
							return $elm$core$List$head(
								A2($elm$core$List$drop, index, part.ym));
						},
						model.j0);
				},
				ouverte));
		var champ = function () {
			var _v6 = _Utils_Tuple2(ouverte, model.j0);
			if ((!_v6.a.$) && (!_v6.b.$)) {
				var part = _v6.a.a;
				var index = _v6.b.a;
				return A3($author$project$Components$Imports$Outil$Model$champDeLaColonne, part, index, model);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var deListe = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (c) {
					return c.r0 === 'choix-multiples';
				},
				champ));
		var _v0 = function () {
			var _v1 = model.qf;
			_v1$3:
			while (true) {
				if (!_v1.$) {
					switch (_v1.a) {
						case 1:
							var _v2 = _v1.a;
							return _Utils_Tuple3(
								A2(
									$author$project$I18n$Cles$importsReglesTitreUnite,
									i18n,
									{j_: entete}),
								$author$project$I18n$Cles$importsReglesAideUnite(i18n),
								_List_fromArray(
									[
										A5(
										$author$project$Components$Imports$Outil$View$choixDeRegle,
										$author$project$I18n$Cles$importsReglesUniteLabel(i18n),
										'imports-regle-unite',
										_List_fromArray(
											[
												_Utils_Tuple2(
												'lue',
												$author$project$I18n$Cles$importsReglesUniteLue(i18n)),
												_Utils_Tuple2(
												'fixe',
												$author$project$I18n$Cles$importsReglesUniteFixe(i18n))
											]),
										_Utils_eq(regles.Ka, $elm$core$Maybe$Nothing) ? 'lue' : 'fixe',
										function (v) {
											return $author$project$Components$Imports$Outil$Update$ReglesSaisies(
												_Utils_update(
													regles,
													{
														Ka: (v === 'lue') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
															A2(
																$elm$core$Maybe$withDefault,
																'',
																A2(
																	$elm$core$Maybe$andThen,
																	function ($) {
																		return $.sa;
																	},
																	champ)))
													}));
										}),
										_Utils_eq(regles.Ka, $elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
										$rtfeldman$elm_css$Html$Styled$input,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
												$rtfeldman$elm_css$Html$Styled$Attributes$id('imports-regle-unite-fixe'),
												A2(
												$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
												'aria-label',
												$author$project$I18n$Cles$importsReglesUniteFixe(i18n)),
												$rtfeldman$elm_css$Html$Styled$Attributes$value(
												A2($elm$core$Maybe$withDefault, '', regles.Ka)),
												$rtfeldman$elm_css$Html$Styled$Events$onInput(
												function (v) {
													return $author$project$Components$Imports$Outil$Update$ReglesSaisies(
														_Utils_update(
															regles,
															{
																Ka: $elm$core$Maybe$Just(
																	$elm$core$String$trim(v))
															}));
												})
											]),
										_List_Nil)
									]));
						case 2:
							var _v3 = _v1.a;
							return deListe ? _Utils_Tuple3(
								A2(
									$author$project$I18n$Cles$importsReglesTitreSeparateur,
									i18n,
									{j_: entete}),
								$author$project$I18n$Cles$importsReglesAideListe(i18n),
								_List_fromArray(
									[
										A5(
										$author$project$Components$Imports$Outil$View$choixDeRegle,
										$author$project$I18n$Cles$importsReglesSeparateurLabel(i18n),
										'imports-regle-liste',
										$author$project$Components$Imports$Outil$View$separateursDeListe(i18n),
										A2($elm$core$Maybe$withDefault, '', regles.IG),
										function (v) {
											return $author$project$Components$Imports$Outil$Update$ReglesSaisies(
												_Utils_update(
													regles,
													{
														IG: $author$project$Components$Imports$Outil$View$rien(v)
													}));
										})
									])) : _Utils_Tuple3(
								A2(
									$author$project$I18n$Cles$importsReglesTitreSeparateur,
									i18n,
									{j_: entete}),
								$author$project$I18n$Cles$importsReglesAideDecimal(i18n),
								_List_fromArray(
									[
										A5(
										$author$project$Components$Imports$Outil$View$choixDeRegle,
										$author$project$I18n$Cles$importsReglesSeparateurLabel(i18n),
										'imports-regle-decimal',
										$author$project$Components$Imports$Outil$View$separateursDecimaux(i18n),
										A2($elm$core$Maybe$withDefault, '', regles.IH),
										function (v) {
											return $author$project$Components$Imports$Outil$Update$ReglesSaisies(
												_Utils_update(
													regles,
													{
														IH: $author$project$Components$Imports$Outil$View$rien(v)
													}));
										})
									]));
						case 3:
							var _v4 = _v1.a;
							return _Utils_Tuple3(
								A2(
									$author$project$I18n$Cles$importsReglesTitreLangues,
									i18n,
									{
										uN: A2(
											$elm$core$Maybe$withDefault,
											entete,
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.Bl;
												},
												champ))
									}),
								$author$project$I18n$Cles$importsReglesAideLangues(i18n),
								function () {
									if (!ouverte.$) {
										var part = ouverte.a;
										return _Utils_ap(
											A2(
												$elm$core$List$map,
												A3(
													$author$project$Components$Imports$Outil$View$ligneDeLangue,
													i18n,
													part,
													A2(
														$elm$core$Maybe$withDefault,
														'',
														A2(
															$elm$core$Maybe$map,
															function ($) {
																return $.dy;
															},
															champ))),
												$author$project$Components$Imports$Outil$View$langues(i18n)),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$div,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$span,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	$author$project$I18n$Cles$importsReglesLangueSansColonne(i18n))
																])),
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$importsReglesLangueSansColonneAide(i18n))
														]))
												]));
									} else {
										return _List_Nil;
									}
								}());
						default:
							break _v1$3;
					}
				} else {
					break _v1$3;
				}
			}
			return _Utils_Tuple3(
				A2(
					$author$project$I18n$Cles$importsReglesTitreDate,
					i18n,
					{j_: entete}),
				$author$project$I18n$Cles$importsReglesAideDate(i18n),
				_List_fromArray(
					[
						A5(
						$author$project$Components$Imports$Outil$View$choixDeRegle,
						$author$project$I18n$Cles$importsReglesDateLabel(i18n),
						'imports-regle-date',
						$author$project$Components$Imports$Outil$View$formatsDeDate(i18n),
						A2($elm$core$Maybe$withDefault, '', regles.zQ),
						function (v) {
							return $author$project$Components$Imports$Outil$Update$ReglesSaisies(
								_Utils_update(
									regles,
									{
										zQ: $author$project$Components$Imports$Outil$View$rien(v)
									}));
						})
					]));
		}();
		var titre = _v0.a;
		var aide = _v0.b;
		var corps = _v0.c;
		return A5(
			$author$project$Components$Shared$Drawer$View$viewAvecSousTitre,
			i18n,
			aide,
			$author$project$Components$Imports$Outil$Update$DuDrawerDesRegles,
			{
				fs: {
					sR: true,
					Bl: $author$project$I18n$Cles$importsReglesAction(i18n),
					C$: $author$project$Components$Imports$Outil$Update$ReglesEnregistrees
				},
				fZ: _Utils_ap(
					corps,
					_Utils_ap(
						A2($author$project$Components$Imports$Outil$View$luComme, i18n, model),
						(_Utils_eq(
							model.qf,
							$elm$core$Maybe$Just(0)) || _Utils_eq(model.qf, $elm$core$Maybe$Nothing)) ? _List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Note$View$view,
								0,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$strong,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$importsReglesVideTitre(i18n))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$importsReglesVideTexte(i18n))
											]))
									]))
							]) : _List_Nil)),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: titre
			},
			model.lm);
	});
var $author$project$Components$Imports$Outil$Update$ValeursEnregistrees = {$: 70};
var $author$project$I18n$Cles$importsValeursAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.valeurs.action', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$importsValeursDrawerAide = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.valeurs.drawer-aide',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' valeur du fichier n\'a pas de correspondance exacte.') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' valeurs du fichier n\'ont pas de correspondance exacte.'));
	});
var $author$project$I18n$Cles$importsValeursDrawerTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.valeurs.drawer-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'colonne',
					$author$project$I18n$Traductions$Chaine(p.j_))
				]),
			'Valeurs de « ' + (p.j_ + ' »'));
	});
var $author$project$I18n$Cles$importsValeursPaysNormes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.valeurs.pays-normes', _List_Nil, 'Les pays sont ceux du référentiel normé (ISO 3166) : on n\'en crée pas. Pour une liste ouverte du client, une option « Créer la valeur » s\'ajoute.');
};
var $author$project$I18n$Cles$importsValeursMemoire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.valeurs.memoire', _List_Nil, 'Une correspondance validée est gardée dans le modèle quand vous l\'enregistrez : elle ne vous est plus demandée.');
};
var $author$project$I18n$Cles$importsValeursMemoireExemple = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.valeurs.memoire-exemple',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm)),
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			'Au prochain import, « ' + (p.fm + (' » deviendra « ' + (p.Bl + ' » sans question.'))));
	});
var $author$project$I18n$Cles$importsValeursMemoireTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.valeurs.memoire-titre', _List_Nil, 'Une correspondance est mémorisée dans le modèle');
};
var $author$project$Components$Imports$Outil$View$memorisation = F4(
	function (i18n, model, aFaire, champ) {
		var admises = $elm$core$List$concat(
			$elm$core$Dict$values(model.fu));
		var exemple_ = $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (v) {
					return A2(
						$elm$core$Maybe$map,
						function (a) {
							return _Utils_Tuple2(v.fm, a.Bl);
						},
						A2(
							$elm$core$Maybe$andThen,
							function (code) {
								return $elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (a) {
											return _Utils_eq(a.vx, code);
										},
										admises));
							},
							A2($elm$core$Dict$get, v.fm, model.jP)));
				},
				aFaire));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('alerte')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$importsValeursMemoireTitre(i18n))
						])),
				function () {
					var _v0 = _Utils_Tuple2(exemple_, champ);
					if (!_v0.a.$) {
						var _v1 = _v0.a.a;
						var valeur = _v1.a;
						var libelle = _v1.b;
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$importsValeursMemoireExemple,
									i18n,
									{Bl: libelle, fm: valeur}))
							]);
					} else {
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$importsValeursMemoire(i18n))
							]);
					}
				}()));
	});
var $author$project$Components$Imports$Outil$Update$ValeurChoisie = F2(
	function (a, b) {
		return {$: 69, a: a, b: b};
	});
var $author$project$I18n$Cles$importsValeursChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.valeurs.choisir', _List_Nil, 'Choisir une valeur');
};
var $author$project$I18n$Cles$importsValeursChoisirPays = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.valeurs.choisir-pays', _List_Nil, 'Choisir un pays');
};
var $author$project$I18n$Cles$importsValeursLigne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.valeurs.ligne',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm)),
					_Utils_Tuple2(
					'lignes',
					$author$project$I18n$Traductions$Chaine(p.gV))
				]),
			p.fm + (' · lignes : ' + p.gV));
	});
var $author$project$I18n$Cles$importsValeursLignes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.valeurs.lignes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'lignes',
					$author$project$I18n$Traductions$Entier(p.gV))
				]),
			((!p.gV) || (p.gV === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.gV) + ' ligne') : (A2($author$project$I18n$Nombre$formater, 0, p.gV) + ' lignes'));
	});
var $author$project$I18n$Cles$importsValeursProposee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.valeurs.proposee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			p.Bl + ' · proposé');
	});
var $author$project$Components$Imports$Outil$View$valeurAFaire = F5(
	function (i18n, model, ouverte, champ, v) {
		var invite = _Utils_eq(
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.r0;
				},
				champ),
			$elm$core$Maybe$Just('pays')) ? $author$project$I18n$Cles$importsValeursChoisirPays(i18n) : $author$project$I18n$Cles$importsValeursChoisir(i18n);
		var choisi = A2($elm$core$Dict$get, v.fm, model.jP);
		var option_ = function (admise) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$option,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$value(admise.vx),
						$rtfeldman$elm_css$Html$Styled$Attributes$selected(
						_Utils_eq(
							choisi,
							$elm$core$Maybe$Just(admise.vx)))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						(_Utils_eq(
							$elm$core$Maybe$Just(admise.vx),
							v.vx) && (!v.mm)) ? A2(
							$author$project$I18n$Cles$importsValeursProposee,
							i18n,
							{Bl: admise.Bl}) : admise.Bl)
					]));
		};
		var admises = function () {
			var _v1 = _Utils_Tuple2(ouverte, champ);
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var part = _v1.a.a;
				var c = _v1.b.a;
				return A3($author$project$Components$Imports$Outil$Model$admisesDe, part, c.dy, model);
			} else {
				return _List_Nil;
			}
		}();
		var tous = function () {
			if (_Utils_eq(admises, _List_Nil)) {
				var _v0 = _Utils_Tuple2(v.vx, v.Bl);
				if ((!_v0.a.$) && (!_v0.b.$)) {
					var code = _v0.a.a;
					var libelle = _v0.b.a;
					return _List_fromArray(
						[
							{vx: code, Bl: libelle}
						]);
				} else {
					return _List_Nil;
				}
			} else {
				return admises;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('proposition'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('valeur-du-fichier', true),
							_Utils_Tuple2(
							'a-choisir',
							_Utils_eq(choisi, $elm$core$Maybe$Nothing))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('col-ex')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(v.fm)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('mut')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$importsValeursLignes,
										i18n,
										{gV: v.gV}))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('fleche'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('→')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$select,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-label',
							A2(
								$author$project$I18n$Cles$importsValeursLigne,
								i18n,
								{
									gV: $elm$core$String$fromInt(v.gV),
									fm: v.fm
								})),
							$rtfeldman$elm_css$Html$Styled$Events$onInput(
							function (code) {
								return A2(
									$author$project$Components$Imports$Outil$Update$ValeurChoisie,
									v.fm,
									(code === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(code));
							})
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$option,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(''),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(choisi, $elm$core$Maybe$Nothing))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(invite)
								])),
						A2($elm$core$List$map, option_, tous)))
				]));
	});
var $author$project$Components$Imports$Outil$View$drawerDesValeurs = F2(
	function (i18n, model) {
		var ouverte = $author$project$Components$Imports$Outil$Model$feuilleOuverte(model);
		var colonne = model.j$;
		var entete = function () {
			var _v2 = _Utils_Tuple2(ouverte, colonne);
			if ((!_v2.a.$) && (!_v2.b.$)) {
				var part = _v2.a.a;
				var index = _v2.b.a;
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(
						A2($elm$core$List$drop, index, part.ym)));
			} else {
				return '';
			}
		}();
		var lues = function () {
			var _v1 = _Utils_Tuple2(ouverte, colonne);
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var part = _v1.a.a;
				var index = _v1.b.a;
				return A3($author$project$Components$Imports$Outil$Model$valeursDeLaColonne, part.mx, index, model);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var champ = function () {
			var _v0 = _Utils_Tuple2(ouverte, colonne);
			if ((!_v0.a.$) && (!_v0.b.$)) {
				var part = _v0.a.a;
				var index = _v0.b.a;
				return A3($author$project$Components$Imports$Outil$Model$champDeLaColonne, part, index, model);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var aFaire = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Ki;
					},
					$elm$core$List$filter(
						A2(
							$elm$core$Basics$composeL,
							$elm$core$Basics$not,
							function ($) {
								return $.mm;
							}))),
				lues));
		return A5(
			$author$project$Components$Shared$Drawer$View$viewAvecSousTitre,
			i18n,
			A2(
				$author$project$I18n$Cles$importsValeursDrawerAide,
				i18n,
				{
					d: $elm$core$List$length(aFaire)
				}),
			$author$project$Components$Imports$Outil$Update$DuDrawerDesValeurs,
			{
				fs: {
					sR: true,
					Bl: $author$project$I18n$Cles$importsValeursAction(i18n),
					C$: $author$project$Components$Imports$Outil$Update$ValeursEnregistrees
				},
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('propositions')
							]),
						A2(
							$elm$core$List$map,
							A4($author$project$Components$Imports$Outil$View$valeurAFaire, i18n, model, ouverte, champ),
							aFaire)),
						A4($author$project$Components$Imports$Outil$View$memorisation, i18n, model, aFaire, champ),
						_Utils_eq(
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.r0;
							},
							champ),
						$elm$core$Maybe$Just('pays')) ? A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$importsValeursPaysNormes(i18n))
							])) : $rtfeldman$elm_css$Html$Styled$text('')
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: A2(
					$author$project$I18n$Cles$importsValeursDrawerTitre,
					i18n,
					{
						j_: A2(
							$elm$core$Maybe$withDefault,
							entete,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.Bl;
								},
								champ))
					})
			},
			model.ln);
	});
var $author$project$Components$Imports$Outil$Update$ModeleEnregistre = {$: 31};
var $author$project$Components$Imports$Outil$Update$NomDuModeleSaisi = function (a) {
	return {$: 30, a: a};
};
var $author$project$I18n$Cles$importsModeleAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.modele.action', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$importsModeleAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.modele.aide', _List_Nil, 'Le modèle garde les colonnes mises en correspondance, jamais une valeur du fichier. Il est partagé dans votre client.');
};
var $author$project$I18n$Cles$importsModeleNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.modele.nom', _List_Nil, 'Nom du modèle');
};
var $author$project$I18n$Cles$importsModeleRattacheTexte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.modele.rattache-texte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'cible',
					$author$project$I18n$Traductions$Chaine(p.vf))
				]),
			'Ce modèle ne sera proposé que pour « ' + (p.vf + ' ».'));
	});
var $author$project$I18n$Cles$importsModeleRattacheTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.modele.rattache-titre', _List_Nil, 'Rattaché à sa cible');
};
var $author$project$I18n$Cles$importsModeleRecapCible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.modele.recap-cible', _List_Nil, 'Cible');
};
var $author$project$I18n$Cles$importsModeleRecapColonnes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.modele.recap-colonnes', _List_Nil, 'Colonnes');
};
var $author$project$I18n$Cles$importsModeleRecapColonnesValeur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.modele.recap-colonnes-valeur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d)),
					_Utils_Tuple2(
					'ignorees',
					$author$project$I18n$Traductions$Chaine(p.Aw))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + (' colonne dont ignorées : ' + p.Aw)) : (A2($author$project$I18n$Nombre$formater, 0, p.d) + (' colonnes dont ignorées : ' + p.Aw)));
	});
var $author$project$I18n$Cles$importsModeleSousTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.modele.sous-titre', _List_Nil, 'La correspondance des colonnes, les formats et les valeurs sont réutilisables.');
};
var $author$project$I18n$Cles$importsModeleTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.modele.titre', _List_Nil, 'Enregistrer comme modèle');
};
var $author$project$Components$Imports$Outil$View$drawerDuModele = F2(
	function (i18n, model) {
		var ouverte = $author$project$Components$Imports$Outil$Model$feuilleOuverte(model);
		var ignorees = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function (part) {
					return $elm$core$List$length(part.ym) - $elm$core$Dict$size(part.j1);
				},
				ouverte));
		var colonnes = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function (part) {
					return $elm$core$Dict$size(part.j1);
				},
				ouverte));
		var cible = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				A2(
					$elm$core$Maybe$andThen,
					function (part) {
						return A2($author$project$Components$Imports$Outil$Model$cibleDe, part, model);
					},
					ouverte)));
		return A5(
			$author$project$Components$Shared$Drawer$View$viewAvecSousTitre,
			i18n,
			$author$project$I18n$Cles$importsModeleSousTitre(i18n),
			$author$project$Components$Imports$Outil$Update$DuDrawerDuModele,
			{
				fs: {
					sR: $author$project$Components$Imports$Outil$Model$saisieDuModele(model) && (!$author$project$Components$Imports$Outil$View$envoiPasPret(model.l2)),
					Bl: $author$project$I18n$Cles$importsModeleAction(i18n),
					C$: $author$project$Components$Imports$Outil$Update$ModeleEnregistre
				},
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$label,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle'),
										$rtfeldman$elm_css$Html$Styled$Attributes$for('imports-nom-du-modele')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsModeleNom(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$input,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
										$rtfeldman$elm_css$Html$Styled$Attributes$id('imports-nom-du-modele'),
										$rtfeldman$elm_css$Html$Styled$Attributes$value(model.g6),
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Imports$Outil$Update$NomDuModeleSaisi)
									]),
								_List_Nil)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$importsModeleAide(i18n))
							])),
						A2(
						$author$project$Components$Shared$Note$View$view,
						0,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsModeleRattacheTitre(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$importsModeleRattacheTexte,
											i18n,
											{vf: cible}))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$dl,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('recapitulatif')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$dt,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsModeleRecapCible(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$dd,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(cible)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$dt,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsModeleRecapColonnes(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$dd,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$importsModeleRecapColonnesValeur,
											i18n,
											{
												Aw: $elm$core$String$fromInt(ignorees),
												d: colonnes + ignorees
											}))
									]))
							])),
						A2($author$project$Components$Imports$Outil$View$refusDuLot, i18n, model)
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$importsModeleTitre(i18n)
			},
			model.lt);
	});
var $author$project$Components$Imports$Outil$Update$AutreFichierDemande = {$: 49};
var $author$project$I18n$Cles$importsRefusAutreFichier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.refus.autre-fichier', _List_Nil, 'Choisir un autre fichier');
};
var $author$project$I18n$Cles$importsRefusDrawerSousTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.refus.drawer-sous-titre', _List_Nil, 'Refus : le fichier n\'est pas retenu et rien n\'est enregistré.');
};
var $author$project$I18n$Cles$importsRefusDrawerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.refus.drawer-titre', _List_Nil, 'Choisir un fichier');
};
var $author$project$I18n$Cles$importsRefusExtensionMacros = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.refus.extension-macros', _List_Nil, 'Les classeurs avec macros ne sont pas lus. Enregistrez-le en .xlsx (sans macros).');
};
var $author$project$I18n$Cles$importsRefusNote = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.refus.note',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'taille',
					$author$project$I18n$Traductions$Chaine(p.Jm))
				]),
			p.Jm);
	});
var $author$project$I18n$Cles$importsRefusNoteXls = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.refus.note-xls',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'taille',
					$author$project$I18n$Traductions$Chaine(p.Jm))
				]),
			'Classeur Excel 97-2003 · ' + p.Jm);
	});
var $author$project$I18n$Cles$importsRefusTitreAutre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.refus.titre-autre', _List_Nil, 'Fichier refusé');
};
var $author$project$I18n$Cles$importsRefusTitreExtension = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.refus.titre-extension',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'extension',
					$author$project$I18n$Traductions$Chaine(p.zb))
				]),
			'Fichier ' + (p.zb + ' refusé'));
	});
var $author$project$I18n$Cles$importsRefusTitreIllisible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.refus.titre-illisible', _List_Nil, 'Fichier illisible');
};
var $author$project$I18n$Cles$importsRefusTitreTropDeLignes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.refus.titre-trop-de-lignes', _List_Nil, 'Trop de lignes');
};
var $author$project$I18n$Cles$importsRefusTitreVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.refus.titre-vide', _List_Nil, 'Fichier vide');
};
var $author$project$I18n$Cles$importsRefusTropGros = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.refus.trop-gros',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'taille',
					$author$project$I18n$Traductions$Chaine(p.Jm))
				]),
			'Ce fichier pèse ' + (p.Jm + ' ; la limite est de 50 Mo. Découpez-le en plusieurs fichiers.'));
	});
var $author$project$Components$Imports$Outil$View$drawerDuRefus = F2(
	function (i18n, model) {
		var octets = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$file$File$size, model.gw));
		var note = function () {
			var _v6 = model.p8;
			if ((!_v6.$) && (!_v6.a.$)) {
				var extension = _v6.a.a;
				return A2(
					$elm$core$String$endsWith,
					'xls',
					$elm$core$String$toLower(extension)) ? A2(
					$author$project$I18n$Cles$importsRefusNoteXls,
					i18n,
					{
						Jm: $author$project$Components$Imports$Outil$View$taille(octets)
					}) : A2(
					$author$project$I18n$Cles$importsRefusNote,
					i18n,
					{
						Jm: $author$project$Components$Imports$Outil$View$taille(octets)
					});
			} else {
				return A2(
					$author$project$I18n$Cles$importsRefusNote,
					i18n,
					{
						Jm: $author$project$Components$Imports$Outil$View$taille(octets)
					});
			}
		}();
		var nom = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Maybe$map, $elm$file$File$name, model.gw));
		var _v0 = function () {
			var _v1 = model.p8;
			if (!_v1.$) {
				switch (_v1.a.$) {
					case 0:
						var extension = _v1.a.a;
						var point = A2($elm$core$String$startsWith, '.', extension) ? extension : ('.' + extension);
						return _Utils_Tuple2(
							A2(
								$author$project$I18n$Cles$importsRefusTitreExtension,
								i18n,
								{zb: point}),
							($elm$core$String$toLower(point) === '.xlsm') ? $author$project$I18n$Cles$importsRefusExtensionMacros(i18n) : $author$project$I18n$Cles$importsRefusExtension(i18n));
					case 1:
						var _v2 = _v1.a;
						return _Utils_Tuple2(
							$author$project$I18n$Cles$importsRefusTitreIllisible(i18n),
							$author$project$I18n$Cles$importsRefusIllisible(i18n));
					case 2:
						var _v3 = _v1.a;
						return _Utils_Tuple2(
							$author$project$I18n$Cles$importsRefusTitreVide(i18n),
							$author$project$I18n$Cles$importsRefusVide(i18n));
					case 3:
						var _v4 = _v1.a;
						return _Utils_Tuple2(
							$author$project$I18n$Cles$importsRefusTitreTropGros(i18n),
							A2(
								$author$project$I18n$Cles$importsRefusTropGros,
								i18n,
								{
									Jm: $author$project$Components$Imports$Outil$View$taille(octets)
								}));
					case 4:
						var _v5 = _v1.a;
						return _Utils_Tuple2(
							$author$project$I18n$Cles$importsRefusTitreTropDeLignes(i18n),
							$author$project$I18n$Cles$importsRefusTropDeLignes(i18n));
					default:
						var erreur = _v1.a;
						return _Utils_Tuple2(
							$author$project$I18n$Cles$importsRefusTitreAutre(i18n),
							A2($author$project$Components$Imports$Outil$View$dit, i18n, erreur));
				}
			} else {
				return _Utils_Tuple2('', '');
			}
		}();
		var titre = _v0.a;
		var texte = _v0.b;
		return A5(
			$author$project$Components$Shared$Drawer$View$viewAvecSousTitre,
			i18n,
			$author$project$I18n$Cles$importsRefusDrawerSousTitre(i18n),
			$author$project$Components$Imports$Outil$Update$DuDrawerDuRefus,
			{
				fs: {
					sR: true,
					Bl: $author$project$I18n$Cles$importsRefusAutreFichier(i18n),
					C$: $author$project$Components$Imports$Outil$Update$AutreFichierDemande
				},
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('sub-card')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(nom)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(note)
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('alerte'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('warn'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(titre)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(texte)
									]))
							]))
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$importsRefusDrawerTitre(i18n)
			},
			model.lu);
	});
var $author$project$Components$Imports$Outil$Update$RejeuConfirme = {$: 97};
var $author$project$I18n$Cles$importsLignesRejeuImport = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes.rejeu-import', _List_Nil, 'Import');
};
var $author$project$I18n$Cles$importsLignesRejeuMemeImportTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes.rejeu-meme-import-texte', _List_Nil, 'Les fiches créées portent la source de cet import. Une ligne déjà écrite ne l\'est pas deux fois. Chaque ligne suit vos droits du moment.');
};
var $author$project$I18n$Cles$importsLignesRejeuMemeImportTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes.rejeu-meme-import-titre', _List_Nil, 'Dans le même import');
};
var $author$project$I18n$Cles$importsLignesRejeuRejouees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes.rejeu-rejouees', _List_Nil, 'Lignes rejouées');
};
var $author$project$I18n$Cles$importsLignesRejeuRejoueesValeur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.lignes.rejeu-rejouees-valeur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' ligne corrigée') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' lignes corrigées'));
	});
var $author$project$I18n$Cles$importsLignesRejeuRestent = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes.rejeu-restent', _List_Nil, 'Restent rejetées');
};
var $author$project$I18n$Cles$importsLignesRejeuRestentValeur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.lignes.rejeu-restent-valeur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d)),
					_Utils_Tuple2(
					'erreurs',
					$author$project$I18n$Traductions$Chaine(p.gp)),
					_Utils_Tuple2(
					'ignorees',
					$author$project$I18n$Traductions$Entier(p.Aw))
				]),
			(((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' ligne') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' lignes')) + (' (' + (p.gp + (' en erreur, ' + ((((!p.Aw) || (p.Aw === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.Aw) + ' ignorée') : (A2($author$project$I18n$Nombre$formater, 0, p.Aw) + ' ignorées')) + '), toujours au rapport')))));
	});
var $author$project$I18n$Cles$importsLignesRejeuSousTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes.rejeu-sous-titre', _List_Nil, 'Les lignes prêtes sont appliquées ; le résultat et le rapport se mettent à jour.');
};
var $author$project$I18n$Cles$importsLignesRejeuTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.lignes.rejeu-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? ('Rejouer ' + (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' ligne')) : ('Rejouer ' + (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' lignes')));
	});
var $author$project$Components$Imports$Outil$View$drawerDuRejeu = F2(
	function (i18n, model) {
		var liste = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.nW;
			},
			model.gV);
		var pretes = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Gj;
				},
				liste));
		var reste = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function (l) {
					return l.sE + l.Aw;
				},
				liste));
		return A5(
			$author$project$Components$Shared$Drawer$View$viewAvecSousTitre,
			i18n,
			$author$project$I18n$Cles$importsLignesRejeuSousTitre(i18n),
			$author$project$Components$Imports$Outil$Update$DuDrawerDuRejeu,
			{
				fs: {
					sR: !$author$project$Components$Imports$Outil$View$envoiPasPret(model.l2),
					Bl: A2(
						$author$project$I18n$Cles$importsLignesRejeuTitre,
						i18n,
						{d: pretes}),
					C$: $author$project$Components$Imports$Outil$Update$RejeuConfirme
				},
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$dl,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('kv')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$dt,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsLignesRejeuImport(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$dd,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.Dj;
												},
												model.n0)))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$dt,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsLignesRejeuRejouees(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$dd,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$importsLignesRejeuRejoueesValeur,
											i18n,
											{d: pretes}))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$dt,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsLignesRejeuRestent(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$dd,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$importsLignesRejeuRestentValeur,
											i18n,
											{
												gp: $elm$core$String$fromInt(
													A2(
														$elm$core$Maybe$withDefault,
														0,
														A2(
															$elm$core$Maybe$map,
															function ($) {
																return $.sE;
															},
															liste))),
												Aw: A2(
													$elm$core$Maybe$withDefault,
													0,
													A2(
														$elm$core$Maybe$map,
														function ($) {
															return $.Aw;
														},
														liste)),
												d: reste
											}))
									]))
							])),
						A2(
						$author$project$Components$Shared$Note$View$view,
						0,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsLignesRejeuMemeImportTitre(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$importsLignesRejeuMemeImportTexte(i18n))
									]))
							]))
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: A2(
					$author$project$I18n$Cles$importsLignesRejeuTitre,
					i18n,
					{d: pretes})
			},
			model.lv);
	});
var $author$project$I18n$Cles$importsEtapeApplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.etape.application', _List_Nil, 'Application');
};
var $author$project$I18n$Cles$importsEtapeCibles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.etape.cibles', _List_Nil, 'Feuilles et cibles');
};
var $author$project$I18n$Cles$importsEtapeColonnes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.etape.colonnes', _List_Nil, 'Colonnes');
};
var $author$project$I18n$Cles$importsEtapeFichier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.etape.fichier', _List_Nil, 'Fichier');
};
var $author$project$I18n$Cles$importsEtapeSimulation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.etape.simulation', _List_Nil, 'Simulation');
};
var $author$project$I18n$Cles$importsEtapeValeurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.etape.valeurs', _List_Nil, 'Valeurs');
};
var $author$project$I18n$Cles$importsEtapesNav = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.etapes.nav', _List_Nil, 'Étapes de l\'import');
};
var $author$project$Components$Imports$Outil$View$numero = function (etape) {
	switch (etape) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 4;
		case 5:
			return 5;
		default:
			return 6;
	}
};
var $author$project$Components$Imports$Outil$View$etapes = F2(
	function (i18n, courante) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$nav,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('etapes'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					$author$project$I18n$Cles$importsEtapesNav(i18n))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$ol,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (i, nom) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'on',
													_Utils_eq(
														i + 1,
														$author$project$Components$Imports$Outil$View$numero(courante))),
													_Utils_Tuple2(
													'faite',
													_Utils_cmp(
														i + 1,
														$author$project$Components$Imports$Outil$View$numero(courante)) < 0)
												])),
											_Utils_eq(
											i + 1,
											$author$project$Components$Imports$Outil$View$numero(courante)) ? A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-current', 'step') : $rtfeldman$elm_css$Html$Styled$Attributes$class('')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('numero')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													(_Utils_cmp(
														i + 1,
														$author$project$Components$Imports$Outil$View$numero(courante)) < 0) ? '✓' : $elm$core$String$fromInt(i + 1))
												])),
											$rtfeldman$elm_css$Html$Styled$text(nom)
										]));
							}),
						_List_fromArray(
							[
								$author$project$I18n$Cles$importsEtapeFichier(i18n),
								$author$project$I18n$Cles$importsEtapeCibles(i18n),
								$author$project$I18n$Cles$importsEtapeColonnes(i18n),
								$author$project$I18n$Cles$importsEtapeValeurs(i18n),
								$author$project$I18n$Cles$importsEtapeSimulation(i18n),
								$author$project$I18n$Cles$importsEtapeApplication(i18n)
							])))
				]));
	});
var $author$project$I18n$Cles$importsLignesFil = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes.fil', _List_Nil, 'Corriger et rejouer');
};
var $author$project$Components$Imports$Outil$View$nomDeLEtape = F2(
	function (i18n, etape) {
		switch (etape) {
			case 0:
				return $author$project$I18n$Cles$importsEtapeFichier(i18n);
			case 1:
				return $author$project$I18n$Cles$importsEtapeCibles(i18n);
			case 2:
				return $author$project$I18n$Cles$importsEtapeColonnes(i18n);
			case 3:
				return $author$project$I18n$Cles$importsEtapeValeurs(i18n);
			case 4:
				return $author$project$I18n$Cles$importsEtapeValeurs(i18n);
			case 5:
				return $author$project$I18n$Cles$importsEtapeSimulation(i18n);
			default:
				return $author$project$I18n$Cles$importsEtapeApplication(i18n);
		}
	});
var $author$project$Components$Imports$Outil$View$filDAriane = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.me, model.n0);
		if ((_v0.a === 6) && (!_v0.b.$)) {
			var _v1 = _v0.a;
			var lot = _v0.b.a;
			return _Utils_ap(
				_List_fromArray(
					[
						{
						aa: $author$project$Routes$Route$adresseImporter,
						Dj: $author$project$I18n$Cles$importsMenu(i18n)
					},
						{
						aa: $author$project$Routes$Route$adresseHistoriqueDesImports,
						Dj: $author$project$I18n$Cles$importsMenuHistorique(i18n)
					},
						{aa: '', Dj: lot.Dj}
					]),
				(!_Utils_eq(model.gV, $elm$core$Maybe$Nothing)) ? _List_fromArray(
					[
						{
						aa: '',
						Dj: $author$project$I18n$Cles$importsLignesFil(i18n)
					}
					]) : _List_Nil);
		} else {
			return _List_fromArray(
				[
					{
					aa: $author$project$Routes$Route$adresseImporter,
					Dj: $author$project$I18n$Cles$importsMenu(i18n)
				},
					{
					aa: '',
					Dj: A2($author$project$Components$Imports$Outil$View$nomDeLEtape, i18n, model.me)
				}
				]);
		}
	});
var $author$project$I18n$Cles$importsApplicationEnCours = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.application.en-cours', _List_Nil, 'En cours');
};
var $author$project$I18n$Cles$importsApplicationPage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.application.page', _List_Nil, 'Application de l\'import');
};
var $author$project$I18n$Cles$importsLignesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes.titre', _List_Nil, 'Corriger les lignes rejetées');
};
var $author$project$I18n$Cles$importsResultatPage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.resultat.page', _List_Nil, 'Résultat de l\'import');
};
var $author$project$I18n$Cles$importsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.titre', _List_Nil, 'Importer des données');
};
var $author$project$I18n$Cles$importsValeursPage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.valeurs.page', _List_Nil, 'Correspondance des valeurs');
};
var $author$project$Components$Imports$Outil$Update$ConfirmationDemandee = {$: 86};
var $author$project$Components$Imports$Outil$Update$LotDemande = {$: 36};
var $author$project$Components$Imports$Outil$Update$SimulationDemandee = {$: 39};
var $author$project$Components$Imports$Outil$Update$VersLeFichier = {$: 10};
var $author$project$Components$Imports$Outil$Update$VersLesCibles = {$: 11};
var $author$project$Components$Imports$Outil$Update$VersLesColonnes = {$: 12};
var $author$project$Components$Imports$Outil$Update$VersLesValeurs = {$: 67};
var $author$project$I18n$Cles$importsColonnesBilan = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.colonnes.bilan',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'colonnes',
					$author$project$I18n$Traductions$Entier(p.j1)),
					_Utils_Tuple2(
					'reconnues',
					$author$project$I18n$Traductions$Chaine(p.G7)),
					_Utils_Tuple2(
					'ignorees',
					$author$project$I18n$Traductions$Chaine(p.Aw)),
					_Utils_Tuple2(
					'refusees',
					$author$project$I18n$Traductions$Chaine(p.Hi))
				]),
			((!p.j1) || (p.j1 === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.j1) + (' colonne : ' + (p.G7 + (' reconnues, ' + (p.Aw + (' ignorées, ' + (p.Hi + ' refusées'))))))) : (A2($author$project$I18n$Nombre$formater, 0, p.j1) + (' colonnes : ' + (p.G7 + (' reconnues, ' + (p.Aw + (' ignorées, ' + (p.Hi + ' refusées'))))))));
	});
var $author$project$Components$Imports$Outil$View$bilanDesColonnes = F2(
	function (i18n, model) {
		var _v0 = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (part) {
					return !_Utils_eq(part.vf, $elm$core$Maybe$Nothing);
				},
				model.pb));
		if (!_v0.$) {
			var part = _v0.a;
			var total = $elm$core$List$length(part.ym);
			var refusees = $elm$core$List$length(part.Hi);
			var reconnues = $elm$core$Dict$size(part.j1);
			return A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('restantes')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$importsColonnesBilan,
							i18n,
							{
								j1: total,
								Aw: $elm$core$String$fromInt((total - reconnues) - refusees),
								G7: $elm$core$String$fromInt(reconnues),
								Hi: $elm$core$String$fromInt(refusees)
							}))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$importsColonnesPreparer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.colonnes.preparer', _List_Nil, 'Préparer le lot');
};
var $author$project$I18n$Cles$importsContinuerCibles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.continuer.cibles', _List_Nil, 'Continuer : feuilles et cibles');
};
var $author$project$I18n$Cles$importsContinuerColonnes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.continuer.colonnes', _List_Nil, 'Continuer : les colonnes');
};
var $author$project$I18n$Cles$importsContinuerValeurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.continuer.valeurs', _List_Nil, 'Continuer : les valeurs');
};
var $author$project$I18n$Cles$importsLotSimuler = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lot.simuler', _List_Nil, 'Simuler l\'import');
};
var $author$project$I18n$Cles$importsResultatPied = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.resultat.pied', _List_Nil, 'Les fiches portent la source « import » et le nom du lot dans leur historique.');
};
var $author$project$I18n$Cles$importsRetour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.retour', _List_Nil, 'Retour');
};
var $author$project$I18n$Cles$importsSimulationAppliquer = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.simulation.appliquer',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'lignes',
					$author$project$I18n$Traductions$Entier(p.gV))
				]),
			((!p.gV) || (p.gV === 1)) ? ('Appliquer l\'import (' + (A2($author$project$I18n$Nombre$formater, 0, p.gV) + ' ligne)')) : ('Appliquer l\'import (' + (A2($author$project$I18n$Nombre$formater, 0, p.gV) + ' lignes)')));
	});
var $author$project$I18n$Cles$importsSimulationCorriger = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.simulation.corriger', _List_Nil, 'Corriger la correspondance');
};
var $author$project$I18n$Cles$importsSimulationPied = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.simulation.pied',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'lignes',
					$author$project$I18n$Traductions$Entier(p.gV)),
					_Utils_Tuple2(
					'creees',
					$author$project$I18n$Traductions$Entier(p.wo)),
					_Utils_Tuple2(
					'modifiees',
					$author$project$I18n$Traductions$Entier(p.CP)),
					_Utils_Tuple2(
					'doublons',
					$author$project$I18n$Traductions$Entier(p.xM))
				]),
			(((!p.gV) || (p.gV === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.gV) + ' ligne sera appliquée') : (A2($author$project$I18n$Nombre$formater, 0, p.gV) + ' lignes seront appliquées')) + (' : ' + ((((!p.wo) || (p.wo === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.wo) + ' création') : (A2($author$project$I18n$Nombre$formater, 0, p.wo) + ' créations')) + (', ' + ((((!p.CP) || (p.CP === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.CP) + ' mise à jour') : (A2($author$project$I18n$Nombre$formater, 0, p.CP) + ' mises à jour')) + (', ' + ((((!p.xM) || (p.xM === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.xM) + ' doublon possible') : (A2($author$project$I18n$Nombre$formater, 0, p.xM) + ' doublons possibles')) + '.')))))));
	});
var $author$project$I18n$Cles$importsSimulationPiedCatalogue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.simulation.pied-catalogue', _List_Nil, 'Une référence en erreur n\'est pas écrite ; les autres le sont.');
};
var $author$project$I18n$Cles$importsSuiviPied = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.suivi.pied', _List_Nil, 'L\'import continue sans vous.');
};
var $author$project$I18n$Cles$importsSuiviQuitter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.suivi.quitter', _List_Nil, 'Quitter l\'écran');
};
var $author$project$I18n$Cles$importsValeursRestantes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.valeurs.restantes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' valeur restante : la préparation du lot est désactivée.') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' valeurs restantes : la préparation du lot est désactivée.'));
	});
var $author$project$Components$Imports$Outil$Model$partsARegler = function (model) {
	return A2(
		$elm$core$List$filter,
		function (_v0) {
			var aCompleter = _v0.b;
			return !_Utils_eq(aCompleter, _List_Nil);
		},
		A2(
			$elm$core$List$map,
			function (part) {
				return _Utils_Tuple2(
					part,
					A2($author$project$Components$Imports$Outil$Model$reglagesManquants, part, model));
			},
			A2(
				$elm$core$List$filter,
				function (part) {
					return !_Utils_eq(part.vf, $elm$core$Maybe$Nothing);
				},
				model.pb)));
};
var $author$project$I18n$Cles$importsReglagesBloquePart = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.reglages.bloque.part',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'part',
					$author$project$I18n$Traductions$Chaine(p.o9)),
					_Utils_Tuple2(
					'reglages',
					$author$project$I18n$Traductions$Chaine(p.qc))
				]),
			'Part « ' + (p.o9 + (' » : ' + (p.qc + '.'))));
	});
var $author$project$I18n$Cles$importsReglagesBloqueTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.bloque.titre', _List_Nil, 'La simulation ne se lance pas : des réglages manquent');
};
var $author$project$I18n$Cles$importsReglagesRegler = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglages.regler', _List_Nil, 'Régler la part');
};
var $author$project$I18n$Cles$importsReglageBaseLegale = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglage.base-legale', _List_Nil, 'base légale');
};
var $author$project$I18n$Cles$importsReglageForme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglage.forme', _List_Nil, 'forme');
};
var $author$project$I18n$Cles$importsReglagePays = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.reglage.pays', _List_Nil, 'pays');
};
var $author$project$Components$Imports$Vocabulaire$nomDuReglage = F2(
	function (i18n, code) {
		switch (code) {
			case 'base-legale':
				return $author$project$I18n$Cles$importsReglageBaseLegale(i18n);
			case 'forme':
				return $author$project$I18n$Cles$importsReglageForme(i18n);
			case 'pays':
				return $author$project$I18n$Cles$importsReglagePays(i18n);
			default:
				return code;
		}
	});
var $author$project$Components$Imports$Outil$View$reglagesABloquer = F2(
	function (i18n, model) {
		var _v0 = $author$project$Components$Imports$Outil$Model$partsARegler(model);
		if (!_v0.b) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var aRegler = _v0;
			return A2(
				$author$project$Components$Shared$Note$View$view,
				1,
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$importsReglagesBloqueTitre(i18n))
							])),
					A2(
						$elm$core$List$map,
						function (_v1) {
							var part = _v1.a;
							var manquants = _v1.b;
							return A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$importsReglagesBloquePart,
											i18n,
											{
												o9: part.mx,
												qc: A2(
													$elm$core$String$join,
													', ',
													A2(
														$elm$core$List$map,
														$author$project$Components$Imports$Vocabulaire$nomDuReglage(i18n),
														manquants))
											})),
										A3(
										$author$project$Components$Shared$Bouton$View$bouton,
										2,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												$author$project$Components$Imports$Outil$Update$ReglagesDemandes(part.mx))
											]),
										$author$project$I18n$Cles$importsReglagesRegler(i18n))
									]));
						},
						aRegler)));
		}
	});
var $author$project$Components$Imports$Outil$View$termine = function (model) {
	return (!_Utils_eq(model.uq, $elm$core$Maybe$Nothing)) || A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.Jt;
			},
			model.ua));
};
var $author$project$Components$Imports$Outil$View$piedDeLEtape = F2(
	function (i18n, model) {
		var _v0 = model.me;
		switch (_v0) {
			case 0:
				return _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						0,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Imports$Outil$Update$VersLesCibles),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
								_Utils_eq(model.tq, $elm$core$Maybe$Nothing))
							]),
						$author$project$I18n$Cles$importsContinuerCibles(i18n))
					]);
			case 1:
				return _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Imports$Outil$Update$VersLeFichier)
							]),
						$author$project$I18n$Cles$importsRetour(i18n)),
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						0,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Imports$Outil$Update$VersLesColonnes),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
								!A2(
									$elm$core$List$any,
									function (part) {
										return !_Utils_eq(part.vf, $elm$core$Maybe$Nothing);
									},
									model.pb))
							]),
						$author$project$I18n$Cles$importsContinuerColonnes(i18n))
					]);
			case 2:
				return _List_fromArray(
					[
						A2($author$project$Components$Imports$Outil$View$bilanDesColonnes, i18n, model),
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Imports$Outil$Update$VersLesCibles)
							]),
						$author$project$I18n$Cles$importsRetour(i18n)),
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						0,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Imports$Outil$Update$VersLesValeurs),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
								!$author$project$Components$Imports$Outil$Model$peutPreparer(model))
							]),
						$author$project$I18n$Cles$importsContinuerValeurs(i18n))
					]);
			case 3:
				return _List_fromArray(
					[
						A2($author$project$Components$Imports$Outil$View$refusDuLot, i18n, model),
						($author$project$Components$Imports$Outil$Model$valeursRestantes(model) > 0) ? A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('restantes'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$importsValeursRestantes,
									i18n,
									{
										d: $author$project$Components$Imports$Outil$Model$valeursRestantes(model)
									}))
							])) : $rtfeldman$elm_css$Html$Styled$text(''),
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Imports$Outil$Update$VersLesColonnes)
							]),
						$author$project$I18n$Cles$importsRetour(i18n)),
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						0,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Imports$Outil$Update$LotDemande),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
								(!$author$project$Components$Imports$Outil$Model$peutPreparer(model)) || (($author$project$Components$Imports$Outil$Model$valeursRestantes(model) > 0) || ($author$project$Components$Imports$Outil$View$envoiPasPret(model.l2) || _Utils_eq(
									A2($author$project$Components$Imports$Outil$Model$lienDe, $author$project$API$NavLinksDictionary$preparerUnLot, model),
									$elm$core$Maybe$Nothing))))
							]),
						$author$project$I18n$Cles$importsColonnesPreparer(i18n))
					]);
			case 4:
				return _List_fromArray(
					[
						A2($author$project$Components$Imports$Outil$View$reglagesABloquer, i18n, model),
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						0,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Imports$Outil$Update$SimulationDemandee),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
								_Utils_eq(model.n0, $elm$core$Maybe$Nothing) || ($author$project$Components$Imports$Outil$View$envoiPasPret(model.l2) || (_Utils_eq(
									A2($author$project$Components$Imports$Outil$Model$lienDe, $author$project$API$NavLinksDictionary$simulerLeLot, model),
									$elm$core$Maybe$Nothing) || (!_Utils_eq(
									$author$project$Components$Imports$Outil$Model$partsARegler(model),
									_List_Nil)))))
							]),
						$author$project$I18n$Cles$importsLotSimuler(i18n))
					]);
			case 5:
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('restantes')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Components$Imports$Outil$Model$catalogueSeul(model) ? $author$project$I18n$Cles$importsSimulationPiedCatalogue(i18n) : A2(
									$author$project$I18n$Cles$importsSimulationPied,
									i18n,
									{
										wo: A2(
											$elm$core$Maybe$withDefault,
											0,
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.wo;
												},
												model.rb)),
										xM: A2(
											$elm$core$Maybe$withDefault,
											0,
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.kW;
												},
												model.rb)),
										gV: $author$project$Components$Imports$Outil$View$aAppliquer(model.rb),
										CP: A2(
											$elm$core$Maybe$withDefault,
											0,
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.CP;
												},
												model.rb))
									}))
							])),
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Imports$Outil$Update$VersLesColonnes)
							]),
						$author$project$I18n$Cles$importsSimulationCorriger(i18n)),
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						0,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Imports$Outil$Update$ConfirmationDemandee),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
								$author$project$Components$Imports$Outil$View$envoiPasPret(model.l2) || _Utils_eq(
									A2($author$project$Components$Imports$Outil$Model$lienDe, $author$project$API$NavLinksDictionary$appliquerLeLot, model),
									$elm$core$Maybe$Nothing))
							]),
						A2(
							$author$project$I18n$Cles$importsSimulationAppliquer,
							i18n,
							{
								gV: $author$project$Components$Imports$Outil$View$aAppliquer(model.rb)
							}))
					]);
			default:
				return $author$project$Components$Imports$Outil$View$termine(model) ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('restantes')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$importsResultatPied(i18n))
							]))
					]) : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('restantes')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$importsSuiviPied(i18n))
							])),
						A3(
						$author$project$Components$Shared$Bouton$View$lien,
						0,
						$author$project$Routes$Route$adresseImporter,
						$author$project$I18n$Cles$importsSuiviQuitter(i18n))
					]);
		}
	});
var $author$project$Components$Imports$Outil$Update$RejeuDemande = {$: 96};
var $author$project$Components$Imports$Outil$Update$RetourAuResultat = {$: 99};
var $author$project$I18n$Cles$importsLignesPretesARejouer = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.lignes.pretes-a-rejouer',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' ligne prête à rejouer') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' lignes prêtes à rejouer'));
	});
var $author$project$I18n$Cles$importsLignesRejouer = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.lignes.rejouer',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? ('Rejouer ' + (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' ligne…')) : ('Rejouer ' + (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' lignes…')));
	});
var $author$project$I18n$Cles$importsLignesRetour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.lignes.retour', _List_Nil, 'Retour au résultat');
};
var $author$project$Components$Imports$Outil$View$piedDesLignes = F3(
	function (i18n, model, lignes) {
		var pretes = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Gj;
				},
				lignes.nW));
		var peutRejouer = !_Utils_eq(
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nQ;
					},
					$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$rejouerLesLignes)),
				lignes.nW),
			$elm$core$Maybe$Nothing);
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('restantes'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$importsLignesPretesARejouer,
							i18n,
							{d: pretes}))
					])),
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Imports$Outil$Update$RetourAuResultat)
					]),
				$author$project$I18n$Cles$importsLignesRetour(i18n)),
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				0,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Imports$Outil$Update$RejeuDemande),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
						(!peutRejouer) || $author$project$Components$Imports$Outil$View$envoiPasPret(model.l2))
					]),
				A2(
					$author$project$I18n$Cles$importsLignesRejouer,
					i18n,
					{d: pretes}))
			]);
	});
var $author$project$Components$Imports$Outil$View$pied = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.gV, model.me);
		if ((!_v0.a.$) && (_v0.b === 6)) {
			var lignes = _v0.a.a;
			var _v1 = _v0.b;
			return A3($author$project$Components$Imports$Outil$View$piedDesLignes, i18n, model, lignes);
		} else {
			return A2($author$project$Components$Imports$Outil$View$piedDeLEtape, i18n, model);
		}
	});
var $author$project$I18n$Cles$importsEtape = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.etape',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'numero',
					$author$project$I18n$Traductions$Chaine(p.DX)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Étape ' + (p.DX + (' sur 6 · ' + p.Dj)));
	});
var $author$project$I18n$Cles$importsApplicationLanceLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.application.lance-le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'cibles',
					$author$project$I18n$Traductions$Chaine(p.jS)),
					_Utils_Tuple2(
					'le',
					$author$project$I18n$Traductions$Chaine(p.Bf))
				]),
			p.jS + (' · lancé le ' + p.Bf));
	});
var $author$project$I18n$Cles$importsApplicationLancePar = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'imports.application.lance-par',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'cibles',
					$author$project$I18n$Traductions$Chaine(p.jS)),
					_Utils_Tuple2(
					'auteur',
					$author$project$I18n$Traductions$Chaine(p.t1)),
					_Utils_Tuple2(
					'le',
					$author$project$I18n$Traductions$Chaine(p.Bf))
				]),
			p.jS + (' · lancé par ' + (p.t1 + (' · ' + p.Bf))));
	});
var $author$project$Components$Imports$Outil$View$lancement = F3(
	function (i18n, model, lot) {
		var cibles = A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				function (_v2) {
					var domaine = _v2.a;
					var type_ = _v2.b;
					return A2($author$project$Components$Imports$Vocabulaire$domaine, i18n, domaine) + (' · ' + A3(
						$author$project$Components$Imports$Outil$View$libelleDeCible,
						i18n,
						model,
						_Utils_Tuple2(domaine, type_)));
				},
				A3(
					$elm$core$List$foldl,
					F2(
						function (c, vus) {
							return A2($elm$core$List$member, c, vus) ? vus : _Utils_ap(
								vus,
								_List_fromArray(
									[c]));
						}),
					_List_Nil,
					A2(
						$elm$core$List$filterMap,
						function (part) {
							return A3($elm$core$Maybe$map2, $elm$core$Tuple$pair, part.cC, part.r0);
						},
						lot.pb))));
		var _v0 = _Utils_Tuple2(lot.A8, lot.A7);
		_v0$2:
		while (true) {
			if (!_v0.a.$) {
				if (!_v0.b.$) {
					var auteur = _v0.a.a;
					var le = _v0.b.a;
					return A2(
						$author$project$I18n$Cles$importsApplicationLancePar,
						i18n,
						{
							t1: auteur,
							jS: cibles,
							Bf: A2($author$project$Texte$Jour$horodateDeParis, i18n, le)
						});
				} else {
					break _v0$2;
				}
			} else {
				if (!_v0.b.$) {
					var _v1 = _v0.a;
					var le = _v0.b.a;
					return A2(
						$author$project$I18n$Cles$importsApplicationLanceLe,
						i18n,
						{
							jS: cibles,
							Bf: A2($author$project$Texte$Jour$horodateDeParis, i18n, le)
						});
				} else {
					break _v0$2;
				}
			}
		}
		return lot.Dj;
	});
var $author$project$Components$Imports$Outil$View$sousTitre = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple3(model.me, model.tq, model.n0);
		_v0$2:
		while (true) {
			_v0$3:
			while (true) {
				switch (_v0.a) {
					case 0:
						var _v1 = _v0.a;
						return A2(
							$author$project$I18n$Cles$importsEtape,
							i18n,
							{
								Dj: A2($author$project$Components$Imports$Outil$View$nomDeLEtape, i18n, 0),
								DX: '1'
							});
					case 6:
						if (!_v0.c.$) {
							var _v2 = _v0.a;
							var lot = _v0.c.a;
							return A3($author$project$Components$Imports$Outil$View$lancement, i18n, model, lot);
						} else {
							if (!_v0.b.$) {
								break _v0$2;
							} else {
								break _v0$3;
							}
						}
					default:
						if (!_v0.b.$) {
							break _v0$2;
						} else {
							break _v0$3;
						}
				}
			}
			return '';
		}
		var apercu = _v0.b.a;
		return apercu.Dj;
	});
var $author$project$Components$Imports$Outil$View$view = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'imports-outil',
			{
				ut: model.qa ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('acces-refuse')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Note$View$view,
										1,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$coquilleAccesRefuse(i18n))
													]))
											]))
									]))
							]))
					]) : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						A2(
							$elm$core$List$cons,
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							_Utils_ap(
								model.gd ? _List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Note$View$view,
										2,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$importsEchecDeLecture(i18n))
											]))
									]) : _List_Nil,
								A2($author$project$Components$Imports$Outil$View$contenu, i18n, model))))
					]),
				xy: _List_fromArray(
					[
						A2($author$project$Components$Imports$Outil$View$drawerDuRefus, i18n, model),
						A2($author$project$Components$Imports$Outil$View$drawerDeCible, i18n, model),
						A2($author$project$Components$Imports$Outil$View$drawerDesReglages, i18n, model),
						A2($author$project$Components$Imports$Outil$View$drawerDuModele, i18n, model),
						A2($author$project$Components$Imports$Outil$View$drawerDApplication, i18n, model),
						A2($author$project$Components$Imports$Outil$View$drawerDeRepartition, i18n, model),
						A2($author$project$Components$Imports$Outil$View$drawerDesRegles, i18n, model),
						A2($author$project$Components$Imports$Outil$View$drawerDesValeurs, i18n, model),
						A2($author$project$Components$Imports$Outil$View$drawerDesLignes, i18n, model),
						A2($author$project$Components$Imports$Outil$View$drawerDeConfirmation, i18n, model),
						A2($author$project$Components$Imports$Outil$View$drawerDuRejeu, i18n, model)
					]),
				zM: A2($author$project$Components$Imports$Outil$View$pied, i18n, model),
				AK: $author$project$Components$Imports$Outil$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _Utils_ap(
							((model.me === 6) && (!$author$project$Components$Imports$Outil$View$termine(model))) ? _List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Tag$View$view,
									5,
									$author$project$I18n$Cles$importsApplicationEnCours(i18n))
								]) : _List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$Components$Imports$Outil$View$sousTitre, i18n, model))
										])),
									A2($author$project$Components$Imports$Outil$View$etapes, i18n, model.me)
								])),
						zE: A2($author$project$Components$Imports$Outil$View$filDAriane, i18n, model),
						Ef: _List_Nil,
						h6: function () {
							var _v0 = model.me;
							switch (_v0) {
								case 6:
									return (!_Utils_eq(model.gV, $elm$core$Maybe$Nothing)) ? $author$project$I18n$Cles$importsLignesTitre(i18n) : ($author$project$Components$Imports$Outil$View$termine(model) ? $author$project$I18n$Cles$importsResultatPage(i18n) : $author$project$I18n$Cles$importsApplicationPage(i18n));
								case 0:
									return $author$project$I18n$Cles$importsTitre(i18n);
								case 2:
									return $author$project$I18n$Cles$importsColonnesTitre(i18n);
								case 3:
									return $author$project$I18n$Cles$importsValeursPage(i18n);
								case 4:
									return $author$project$I18n$Cles$importsValeursPage(i18n);
								default:
									return A2($author$project$Components$Imports$Outil$View$nomDeLEtape, i18n, model.me);
							}
						}()
					})
			});
	});
var $author$project$Components$Notifications$Update$MarqueeDemandee = function (a) {
	return {$: 4, a: a};
};
var $author$project$I18n$Cles$notificationsMarquerCommeLue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'notifications.marquer-comme-lue', _List_Nil, 'Marquer comme lue');
};
var $author$project$Components$Notifications$View$marquer = F3(
	function (i18n, model, chacune) {
		var _v0 = A2($author$project$Components$Notifications$Model$lienDeLaNotification, model, chacune.r8);
		if (!_v0.$) {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('secondary'),
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'loading',
									$author$project$API$Envoi$enCours(model.l2))
								])),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Notifications$Update$MarqueeDemandee(chacune.r8))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$notificationsMarquerCommeLue(i18n))
								]))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$I18n$Cles$notificationsLue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'notifications.lue', _List_Nil, 'Lue');
};
var $author$project$I18n$Cles$notificationsOuvrirLeGroupe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'notifications.ouvrir-le-groupe', _List_Nil, 'Ouvrir le groupe');
};
var $author$project$Components$Notifications$View$ouvrir = F2(
	function (i18n, chacune) {
		var _v0 = _Utils_Tuple2(
			chacune.g1,
			$author$project$Components$Referentiel$Identifiants$groupeUidFromString(chacune.zo));
		if ((_v0.a.$ === 1) && (!_v0.b.$)) {
			var _v1 = _v0.a;
			var groupe = _v0.b.a;
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ouvrir-le-groupe'),
							$rtfeldman$elm_css$Html$Styled$Attributes$href(
							$author$project$Routes$Route$toString(
								A2($author$project$Routes$Route$FicheDeGroupe, groupe, $elm$core$Maybe$Nothing)))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$notificationsOuvrirLeGroupe(i18n))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$I18n$Cles$notificationsAlerteDeConservation = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'notifications.alerte-de-conservation',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Une fiche arrive à l\'échéance de sa conservation le ' + (p.wv + '.'));
	});
var $author$project$I18n$Cles$notificationsNatureInconnue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'notifications.nature-inconnue', _List_Nil, 'Notification');
};
var $author$project$I18n$Cles$notificationsTraitementTermine = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'notifications.traitement-termine', _List_Nil, 'Un ajout en lot à un groupe est terminé.');
};
var $author$project$Components$Notifications$View$texte = F2(
	function (i18n, chacune) {
		var _v0 = chacune.g1;
		switch (_v0.$) {
			case 0:
				return A2(
					$author$project$I18n$Cles$notificationsAlerteDeConservation,
					i18n,
					{
						wv: A2($author$project$Texte$Jour$enFrancais, i18n, chacune.xY)
					});
			case 1:
				return $author$project$I18n$Cles$notificationsTraitementTermine(i18n);
			default:
				return $author$project$I18n$Cles$notificationsNatureInconnue(i18n);
		}
	});
var $author$project$Components$Notifications$View$notification = F3(
	function (i18n, model, chacune) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('item')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('cartouche-notification'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('non-lue', !chacune.B1)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('content')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('main')
										]),
									A2(
										$elm$core$List$cons,
										A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('title')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2($author$project$Components$Notifications$View$texte, i18n, chacune))
												])),
										A2($author$project$Components$Notifications$View$ouvrir, i18n, chacune))),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('aside')
										]),
									_List_fromArray(
										[
											chacune.B1 ? A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('tag'),
													$rtfeldman$elm_css$Html$Styled$Attributes$class('lue')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$notificationsLue(i18n))
												])) : $rtfeldman$elm_css$Html$Styled$text('')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
								]),
							A3($author$project$Components$Notifications$View$marquer, i18n, model, chacune))
						]))
				]));
	});
var $author$project$I18n$Cles$notificationsIllisible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'notifications.illisible', _List_Nil, 'Les notifications n\'ont pas pu être lues.');
};
var $author$project$I18n$Cles$notificationsIndisponible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'notifications.indisponible', _List_Nil, 'Les notifications ne sont pas disponibles.');
};
var $author$project$I18n$Cles$notificationsVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'notifications.vide', _List_Nil, 'Aucune notification.');
};
var $author$project$Components$Notifications$View$liste = F2(
	function (i18n, model) {
		var _v0 = model.nW;
		if (_v0.$ === 1) {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							model.gd ? $author$project$I18n$Cles$notificationsIllisible(i18n) : $author$project$I18n$Cles$notificationsIndisponible(i18n))
						]))
				]);
		} else {
			var lue = _v0.a;
			var _v1 = lue.oN;
			if (!_v1.b) {
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aucun')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$notificationsVide(i18n))
							]))
					]);
			} else {
				var notifications = _v1;
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('list')
							]),
						A2(
							$elm$core$List$map,
							A2($author$project$Components$Notifications$View$notification, i18n, model),
							notifications))
					]);
			}
		}
	});
var $author$project$Components$Notifications$Model$nonLues = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.oG;
		},
		model.nW);
};
var $author$project$I18n$Cles$notificationsAucuneNonLue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'notifications.aucune-non-lue', _List_Nil, 'Aucune notification non lue.');
};
var $author$project$I18n$Cles$notificationsNonLues = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'notifications.non-lues',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' notification non lue.') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' notifications non lues.'));
	});
var $author$project$Components$Notifications$View$nonLues = F2(
	function (i18n, nombre) {
		return (!nombre) ? $author$project$I18n$Cles$notificationsAucuneNonLue(i18n) : A2(
			$author$project$I18n$Cles$notificationsNonLues,
			i18n,
			{w: nombre});
	});
var $author$project$I18n$Cles$notificationsFil = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'notifications.fil', _List_Nil, 'Notifications');
};
var $author$project$I18n$Cles$notificationsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'notifications.titre', _List_Nil, 'Notifications');
};
var $author$project$Components$Notifications$View$view = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'notifications',
			{
				ut: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						A2(
							$elm$core$List$cons,
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							A2($author$project$Components$Notifications$View$liste, i18n, model)))
					]),
				xy: _List_Nil,
				zM: _List_Nil,
				AK: false,
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description'),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-live', 'polite')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Components$Notifications$View$nonLues(i18n),
												$author$project$Components$Notifications$Model$nonLues(model))))
									]))
							]),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adresseDesNotifications,
								Dj: $author$project$I18n$Cles$notificationsFil(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$notificationsTitre(i18n)
					})
			});
	});
var $author$project$I18n$Cles$bibliothequeDescription = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.description', _List_Nil, 'Champs et listes partagés par les types de produit et de partie prenante');
};
var $author$project$I18n$Cles$bibliothequeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.titre', _List_Nil, 'Bibliothèque de champs');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$NouveauChampOuvert = function (a) {
	return {$: 70, a: a};
};
var $author$project$I18n$Cles$bibliothequeGroupeCreer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.groupe.creer', _List_Nil, 'Créer un champ');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$boutonDeCreation = F3(
	function (i18n, collections, model) {
		var _v0 = _Utils_Tuple2(
			model.zo,
			$author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeCreation(model));
		if ((_v0.a.$ === 1) && (!_v0.b.$)) {
			var _v1 = _v0.a;
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('primary'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Parametrage$BibliothequeDeChamps$Update$NouveauChampOuvert(collections))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$bibliothequeGroupeCreer(i18n))
								]))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$I18n$Cles$bibliothequeFicheLectureSeuleDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.fiche.lecture-seule-detail', _List_Nil, 'Votre profil n\'a pas le droit de modifier les champs de la bibliothèque. Demandez à une personne qui gère le paramétrage du catalogue.');
};
var $author$project$I18n$Cles$bibliothequeFicheLectureSeuleTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.fiche.lecture-seule-titre', _List_Nil, 'Vous consultez la définition en lecture seule.');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$AutreNoeudDemande = {$: 59};
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$etagesProposes = function (etat) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (etage, vus) {
				return A2($elm$core$List$member, etage, vus) ? vus : _Utils_ap(
					vus,
					_List_fromArray(
						[etage]));
			}),
		_List_Nil,
		A2(
			$elm$core$List$map,
			function ($) {
				return $.md;
			},
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$propres(etat),
					$elm$core$Basics$eq($elm$core$Maybe$Nothing)),
				$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$tous(etat))));
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ValeurDesFichesChoisie = function (a) {
	return {$: 69, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$valeurDesFiches = function (etat) {
	var _v0 = etat.fn;
	if (!_v0.$) {
		var choisie = _v0.a;
		return $elm$core$Maybe$Just(choisie);
	} else {
		var avecDesFiches = A2(
			$elm$core$List$map,
			function ($) {
				return $.fm;
			},
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Ki;
					},
					etat.zu)));
		return $elm$core$List$head(
			function (ids) {
				return _Utils_ap(
					A2(
						$elm$core$List$filter,
						function (id) {
							return A2($elm$core$List$member, id, avecDesFiches);
						},
						ids),
					ids);
			}(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.Aq;
					},
					A2($elm$core$Maybe$withDefault, _List_Nil, etat.Ki))));
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$fichesAffichees = function (etat) {
	var _v0 = _Utils_Tuple2(
		etat.zu,
		$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$valeurDesFiches(etat));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var lues = _v0.a.a;
		var valeur = _v0.b.a;
		return $elm$core$Maybe$Just(
			A2(
				$elm$core$Maybe$withDefault,
				{zu: 0, o7: _List_Nil, fm: valeur},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.fm;
							},
							$elm$core$Basics$eq(valeur)),
						lues.Ki))));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$I18n$Cles$restrictionsFichesColonneFiches = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restrictions.fiches.colonne-fiches', _List_Nil, 'Fiches');
};
var $author$project$I18n$Cles$restrictionsFichesColonneType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restrictions.fiches.colonne-type', _List_Nil, 'Type');
};
var $author$project$I18n$Cles$restrictionsFichesIntro = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restrictions.fiches.intro',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'Filtre « ' + (p.uN + ' » dans le catalogue, grâce à la liste unique.'));
	});
var $author$project$I18n$Cles$restrictionsFichesNote = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restrictions.fiches.note',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w)),
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'Sans liste unique, il faudrait ' + (p.w + (' filtres « ' + (p.uN + ' » distincts.'))));
	});
var $author$project$I18n$Cles$restrictionsFichesTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restrictions.fiches.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'Toutes les fiches d\'une valeur de « ' + (p.uN + ' »'));
	});
var $author$project$I18n$Cles$restrictionsFichesTotal = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restrictions.fiches.total',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiche') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiches'));
	});
var $author$project$I18n$Cles$restrictionsFichesValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restrictions.fiches.valeur', _List_Nil, 'Valeur');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsView$fichesParValeur = F2(
	function (i18n, etat) {
		var _v0 = $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$fichesAffichees(etat);
		if (_v0.$ === 1) {
			return _List_Nil;
		} else {
			var fiches = _v0.a;
			return _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Page$View$sectionAvecCompte,
					_List_Nil,
					{
						fw: _List_Nil,
						vW: $elm$core$Maybe$Nothing,
						fZ: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$restrictionsFichesIntro,
											i18n,
											{uN: etat.uN}))
									])),
								A2(
								$author$project$Components$Shared$Champ$View$liste,
								{
									go: $elm$core$Maybe$Nothing,
									Aq: 'restrictions-fiches-valeur',
									Bl: $author$project$I18n$Cles$restrictionsFichesValeur(i18n),
									he: false
								},
								{
									hg: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ValeurDesFichesChoisie,
									o_: A2(
										$elm$core$List$map,
										function (v) {
											return {Bl: v.Bl, fm: v.Aq};
										},
										A2($elm$core$Maybe$withDefault, _List_Nil, etat.Ki)),
									fm: A2(
										$elm$core$Maybe$withDefault,
										'',
										$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$valeurDesFiches(etat))
								}),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('total')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$restrictionsFichesTotal,
											i18n,
											{w: fiches.zu}))
									])),
								_Utils_eq(fiches.o7, _List_Nil) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('cadre')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$table,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('fiches-par-valeur')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$thead,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$tr,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$rtfeldman$elm_css$Html$Styled$th,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(
																		$author$project$I18n$Cles$restrictionsFichesColonneType(i18n))
																	])),
																A2(
																$rtfeldman$elm_css$Html$Styled$th,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$scope('col'),
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(
																		$author$project$I18n$Cles$restrictionsFichesColonneFiches(i18n))
																	]))
															]))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$tbody,
												_List_Nil,
												A2(
													$elm$core$List$map,
													function (t) {
														return A2(
															$rtfeldman$elm_css$Html$Styled$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class('noeud')
																		]),
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text(t.Dj)
																		])),
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$rtfeldman$elm_css$Html$Styled$strong,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$rtfeldman$elm_css$Html$Styled$text(
																					$elm$core$String$fromInt(t.zu))
																				]))
																		]))
																]));
													},
													fiches.o7))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$restrictionsFichesNote,
											i18n,
											{
												uN: etat.uN,
												w: $elm$core$String$fromInt(
													$elm$core$List$length(fiches.o7))
											}))
									]))
							]),
						Ar: $elm$core$Maybe$Nothing,
						Dj: 'fiches-par-valeur',
						h6: A2(
							$author$project$I18n$Cles$restrictionsFichesTitre,
							i18n,
							{uN: etat.uN})
					})
				]);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$prete = function (etat) {
	return (!_Utils_eq(etat.F3, $elm$core$Maybe$Nothing)) && ((!_Utils_eq(etat.Di, $elm$core$Maybe$Nothing)) && (!_Utils_eq(etat.Ki, $elm$core$Maybe$Nothing)));
};
var $author$project$I18n$Cles$restrictionsAutreNoeud = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restrictions.autre-noeud', _List_Nil, 'Restreindre un autre nœud…');
};
var $author$project$I18n$Cles$restrictionsHorsChoix = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restrictions.hors-choix', _List_Nil, 'Une valeur retirée d\'un nœud reste visible sur les fiches qui l\'ont déjà, marquée « hors choix ».');
};
var $author$project$I18n$Cles$restrictionsIntro = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restrictions.intro', _List_Nil, 'Sans restriction, un nœud propose toutes les valeurs. Une restriction se pose sur un nœud du catalogue (marque, gamme ou autre étage) et se transmet vers le bas ; elle retire des choix, jamais des valeurs de la liste.');
};
var $author$project$I18n$Cles$restrictionsNote = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restrictions.note',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			'Un nœud absent du tableau propose toutes les valeurs de la liste. Les valeurs de la liste restent les ' + (p.JE + ', quel que soit le nœud.'));
	});
var $author$project$I18n$Cles$restrictionsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restrictions.titre', _List_Nil, 'Valeurs retenues par type, étage, marque ou gamme');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$NoeudAModifier = function (a) {
	return {$: 58, a: a};
};
var $author$project$I18n$Cles$restrictionsCompte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restrictions.compte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'retenues',
					$author$project$I18n$Traductions$Chaine(p.hN)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			p.hN + (' sur ' + p.JE));
	});
var $author$project$I18n$Cles$restrictionsHerite = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restrictions.herite',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'hérité de ' + p.Dj);
	});
var $author$project$I18n$Cles$restrictionsModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restrictions.modifier', _List_Nil, 'Modifier');
};
var $author$project$I18n$Cles$restrictionsModifierEtiquette = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restrictions.modifier-etiquette',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Modifier la restriction de ' + p.Dj);
	});
var $author$project$I18n$Cles$restrictionsNature = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restrictions.nature',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md))
				]),
			'étage ' + p.md);
	});
var $author$project$I18n$Cles$restrictionsNatureSous = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restrictions.nature-sous',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md)),
					_Utils_Tuple2(
					'parent',
					$author$project$I18n$Traductions$Chaine(p.ey))
				]),
			'étage ' + (p.md + (', sous ' + p.ey)));
	});
var $author$project$I18n$Cles$restrictionsNatureType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restrictions.nature-type', _List_Nil, 'type');
};
var $author$project$I18n$Cles$restrictionsSeResserre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restrictions.se-resserre', _List_Nil, 'se resserre encore');
};
var $author$project$I18n$Cles$restrictionsSeTransmet = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restrictions.se-transmet', _List_Nil, 'se transmet vers le bas');
};
var $author$project$I18n$Cles$restrictionsTitreNoeud = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restrictions.titre-noeud',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.md + (' ' + p.Dj));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsView$ligne = F4(
	function (i18n, peutModifier, etat, l) {
		var nom = l.ou.Dj;
		var titre = (l.ou.M === 1) ? nom : A2(
			$author$project$I18n$Cles$restrictionsTitreNoeud,
			i18n,
			{
				md: A2($author$project$I18n$Cles$texte, i18n, l.ou.md),
				Dj: nom
			});
		var nature = function () {
			var _v1 = _Utils_Tuple2(l.ou.M, l.m4);
			_v1$0:
			while (true) {
				if (!_v1.b.$) {
					if (_v1.a === 1) {
						break _v1$0;
					} else {
						var parent = _v1.b.a;
						return A2(
							$author$project$I18n$Cles$restrictionsNatureSous,
							i18n,
							{
								md: A2($author$project$I18n$Cles$texte, i18n, l.ou.md),
								ey: parent
							});
					}
				} else {
					if (_v1.a === 1) {
						break _v1$0;
					} else {
						var _v3 = _v1.b;
						return A2(
							$author$project$I18n$Cles$restrictionsNature,
							i18n,
							{
								md: A2($author$project$I18n$Cles$texte, i18n, l.ou.md)
							});
					}
				}
			}
			var _v2 = _v1.a;
			return $author$project$I18n$Cles$restrictionsNatureType(i18n);
		}();
		var libelles = A2(
			$elm$core$List$filter,
			function (v) {
				return A2($elm$core$List$member, v.Aq, l.hN);
			},
			A2($elm$core$Maybe$withDefault, _List_Nil, etat.Ki));
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('noeud')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(titre)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nature')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(nature)
										]))
								])),
							function () {
							var _v0 = l.m4;
							if (!_v0.$) {
								var parent = _v0.a;
								return A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('herite')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Components$Shared$Tag$View$view,
											3,
											A2(
												$author$project$I18n$Cles$restrictionsHerite,
												i18n,
												{Dj: parent}))
										]));
							} else {
								return $rtfeldman$elm_css$Html$Styled$text('');
							}
						}()
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('valeurs')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('pills')
								]),
							A2(
								$elm$core$List$map,
								function (v) {
									return A2($author$project$Components$Shared$Tag$View$view, 3, v.Bl);
								},
								libelles))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$restrictionsCompte,
								i18n,
								{
									hN: $elm$core$String$fromInt(
										$elm$core$List$length(l.hN)),
									JE: $elm$core$String$fromInt(l.h1)
								})),
							l.q_ ? A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('suite')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									', ' + $author$project$I18n$Cles$restrictionsSeResserre(i18n))
								])) : (l.q$ ? A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('suite')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									', ' + $author$project$I18n$Cles$restrictionsSeTransmet(i18n))
								])) : $rtfeldman$elm_css$Html$Styled$text(''))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					_List_fromArray(
						[
							peutModifier ? A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id(
									$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$idDuBoutonModifier(l.ou.Aq)),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'dialog'),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									A2(
										$author$project$I18n$Cles$restrictionsModifierEtiquette,
										i18n,
										{Dj: nom})),
									$rtfeldman$elm_css$Html$Styled$Attributes$title(
									A2(
										$author$project$I18n$Cles$restrictionsModifierEtiquette,
										i18n,
										{Dj: nom})),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Parametrage$BibliothequeDeChamps$Update$NoeudAModifier(l.ou.Aq))
								]),
							$author$project$I18n$Cles$restrictionsModifier(i18n)) : $rtfeldman$elm_css$Html$Styled$text('')
						]))
				]));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$lignes = function (etat) {
	var restreints = A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$propres(etat),
			$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
		$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$tous(etat));
	var ligne = function (noeud) {
		return {
			m4: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Dj;
				},
				$elm$core$List$head(
					$elm$core$List$reverse(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$propres(etat),
								$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
							A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$ancetres, etat, noeud))))),
			ou: noeud,
			hN: A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$proposees, etat, noeud),
			q_: A2(
				$elm$core$List$any,
				function (autre) {
					return A2(
						$elm$core$List$member,
						noeud,
						A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$ancetres, etat, autre));
				},
				restreints),
			q$: A2(
				$elm$core$List$any,
				function (autre) {
					return _Utils_eq(
						autre.ey,
						$elm$core$Maybe$Just(noeud.Aq));
				},
				$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$tous(etat)),
			h1: $elm$core$List$length(
				A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$transmisesA, etat, noeud))
		};
	};
	return A2($elm$core$List$map, ligne, restreints);
};
var $author$project$I18n$Cles$restrictionsColonneCompte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restrictions.colonne-compte', _List_Nil, 'n sur N');
};
var $author$project$I18n$Cles$restrictionsColonneNoeud = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restrictions.colonne-noeud', _List_Nil, 'Nœud');
};
var $author$project$I18n$Cles$restrictionsColonneValeurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restrictions.colonne-valeurs', _List_Nil, 'Valeurs retenues');
};
var $author$project$I18n$Cles$restrictionsVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restrictions.vide', _List_Nil, 'Aucun nœud ne restreint ce champ.');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsView$tableau = F3(
	function (i18n, peutModifier, etat) {
		var _v0 = $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$lignes(etat);
		if (!_v0.b) {
			return A2(
				$author$project$Components$Shared$Note$View$view,
				0,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$restrictionsVide(i18n))
					]));
		} else {
			var lignes = _v0;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('cadre')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$table,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('restrictions')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$thead,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$restrictionsColonneNoeud(i18n))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$restrictionsColonneValeurs(i18n))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$scope('col'),
														$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$restrictionsColonneCompte(i18n))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
													]),
												_List_Nil)
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$tbody,
								_List_Nil,
								A2(
									$elm$core$List$map,
									A3($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsView$ligne, i18n, peutModifier, etat),
									lignes))
							]))
					]));
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsView$bloc = F2(
	function (i18n, model) {
		var etat = model.qF;
		var peutRestreindre = !_Utils_eq(
			A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$lienDe, $author$project$API$NavLinksDictionary$restreindreLesValeursDUnChampHerite, etat),
			$elm$core$Maybe$Nothing);
		return $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$prete(etat) ? _Utils_ap(
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Page$View$sectionAvecCompte,
					_List_Nil,
					{
						fw: (peutRestreindre && (!_Utils_eq(
							$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$etagesProposes(etat),
							_List_Nil))) ? _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Components$Shared$Bouton$View$bouton,
										1,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$idDuBoutonAutreNoeud),
												$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$BibliothequeDeChamps$Update$AutreNoeudDemande),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'dialog')
											]),
										$author$project$I18n$Cles$restrictionsAutreNoeud(i18n))
									]))
							]) : _List_Nil,
						vW: $elm$core$Maybe$Nothing,
						fZ: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$restrictionsIntro(i18n))
									])),
								A3($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsView$tableau, i18n, peutRestreindre, etat),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$restrictionsNote,
											i18n,
											{
												JE: $elm$core$String$fromInt(
													$elm$core$List$length(
														A2($elm$core$Maybe$withDefault, _List_Nil, etat.Ki)))
											})),
										$rtfeldman$elm_css$Html$Styled$text(' '),
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$restrictionsHorsChoix(i18n))
									]))
							]),
						Ar: $elm$core$Maybe$Nothing,
						Dj: 'restrictions',
						h6: $author$project$I18n$Cles$restrictionsTitre(i18n)
					})
				]),
			A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsView$fichesParValeur, i18n, etat)) : _List_Nil;
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$lectureSeule = function (fiche) {
	return _Utils_eq(
		A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeLaDefinition, $author$project$API$NavLinksDictionary$modifierLaDefinition, fiche),
		$elm$core$Maybe$Nothing) && _Utils_eq(
		A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeLaDefinition, $author$project$API$NavLinksDictionary$traduireLaDefinition, fiche),
		$elm$core$Maybe$Nothing);
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$CalculOuvert = {$: 47};
var $author$project$I18n$Cles$bibliothequeCalculFormule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.formule', _List_Nil, 'Formule');
};
var $author$project$I18n$Cles$bibliothequeCalculLit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.lit', _List_Nil, 'Lit');
};
var $author$project$I18n$Cles$bibliothequeCalculLitChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.lit-champ', _List_Nil, 'champ de la référence');
};
var $author$project$I18n$Cles$bibliothequeCalculRecalcul = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.recalcul', _List_Nil, 'Recalcul');
};
var $author$project$I18n$Cles$bibliothequeCalculRegler = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.regler', _List_Nil, 'Régler le calcul');
};
var $author$project$I18n$Cles$bibliothequeCalculResultat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.resultat', _List_Nil, 'Type du résultat');
};
var $author$project$I18n$Cles$bibliothequeCalculTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.titre', _List_Nil, 'Calcul');
};
var $author$project$I18n$Cles$bibliothequeCalculValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.valeur', _List_Nil, 'Valeur');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$LotOuvert = {$: 53};
var $author$project$I18n$Cles$bibliothequeCalculLotAppliquer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.lot.appliquer', _List_Nil, 'Appliquer aux références existantes');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$boutonDuLot = F2(
	function (i18n, fiche) {
		return _Utils_eq(
			$author$project$Components$Parametrage$BibliothequeDeChamps$Lot$lienDeLaCommande(fiche),
			$elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text('') : A3(
			$author$project$Components$Shared$Bouton$View$bouton,
			1,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Parametrage$BibliothequeDeChamps$Model$idAppliquerAuxReferences),
					$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$BibliothequeDeChamps$Update$LotOuvert),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'dialog')
				]),
			$author$project$I18n$Cles$bibliothequeCalculLotAppliquer(i18n));
	});
var $rtfeldman$elm_css$Html$Styled$code = $rtfeldman$elm_css$Html$Styled$node('code');
var $author$project$I18n$Cles$bibliothequeCalculValeurImposee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.valeur-imposee', _List_Nil, 'Imposée : non modifiable');
};
var $author$project$I18n$Cles$bibliothequeCalculValeurProposee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.valeur-proposee', _List_Nil, 'Proposée : prérempli, modifiable, ne bloque jamais la création');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$libelleDeLaNature = F2(
	function (i18n, valeur) {
		return (valeur === 'imposee') ? $author$project$I18n$Cles$bibliothequeCalculValeurImposee(i18n) : $author$project$I18n$Cles$bibliothequeCalculValeurProposee(i18n);
	});
var $author$project$I18n$Cles$bibliothequeCalculRecalculFige = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.recalcul-fige', _List_Nil, 'Figé : calculé une fois, à la première écriture');
};
var $author$project$I18n$Cles$bibliothequeCalculRecalculSurChangement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.recalcul-sur-changement', _List_Nil, 'Sur changement : dès qu\'une source change');
};
var $author$project$I18n$Cles$bibliothequeCalculRecalculSurDemande = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.recalcul-sur-demande', _List_Nil, 'Sur demande : jamais seul, « Recalculer » sur la fiche');
};
var $author$project$Components$Parametrage$Vocabulaire$libelleDuRecalcul = F2(
	function (i18n, recalcul) {
		switch (recalcul) {
			case 'fige':
				return $author$project$I18n$Cles$bibliothequeCalculRecalculFige(i18n);
			case 'sur-demande':
				return $author$project$I18n$Cles$bibliothequeCalculRecalculSurDemande(i18n);
			default:
				return $author$project$I18n$Cles$bibliothequeCalculRecalculSurChangement(i18n);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ligne = F2(
	function (libelle, contenu) {
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$dt,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(libelle)
							])),
						A2($rtfeldman$elm_css$Html$Styled$dd, _List_Nil, contenu)
					]))
			]);
	});
var $author$project$I18n$Cles$bibliothequeCalculResultatListe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.calcul.resultat-liste',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Liste unique « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$bibliothequeCalculResultatMesure = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.calcul.resultat-mesure',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'unite',
					$author$project$I18n$Traductions$Chaine(p.sa))
				]),
			'Mesure en ' + p.sa);
	});
var $author$project$I18n$Cles$bibliothequeCalculResultatNombre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.resultat-nombre', _List_Nil, 'Nombre');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$symboleDeLUnite = F2(
	function (fiche, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			code,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (u) {
							return _Utils_eq(u.vx, code);
						},
						fiche.sb))));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$resultatDuCalcul = F3(
	function (i18n, fiche, calcul) {
		var _v0 = calcul.nW;
		if (!_v0.$) {
			var liste = _v0.a;
			return A2(
				$author$project$I18n$Cles$bibliothequeCalculResultatListe,
				i18n,
				{Dj: liste.Dj});
		} else {
			var _v1 = calcul.Cu;
			if (!_v1.$) {
				var mesure = _v1.a;
				return A2(
					$author$project$I18n$Cles$bibliothequeCalculResultatMesure,
					i18n,
					{
						sa: A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$symboleDeLUnite, fiche, mesure.sa)
					});
			} else {
				return $author$project$I18n$Cles$bibliothequeCalculResultatNombre(i18n);
			}
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$sectionCalcul = F2(
	function (i18n, fiche) {
		var _v0 = fiche.uB;
		if (!_v0.$) {
			var calcul = _v0.a;
			return A2(
				$author$project$Components$Shared$Page$View$sectionAvecCompte,
				_List_Nil,
				{
					fw: _Utils_eq(
						A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeLaDefinition, $author$project$API$NavLinksDictionary$reglerLeCalcul, fiche),
						$elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Parametrage$BibliothequeDeChamps$Model$idReglerLeCalcul),
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$BibliothequeDeChamps$Update$CalculOuvert),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'dialog')
										]),
									$author$project$I18n$Cles$bibliothequeCalculRegler(i18n)),
									A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$boutonDuLot, i18n, fiche)
								]))
						]),
					vW: $elm$core$Maybe$Nothing,
					fZ: _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$dl,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('definition')
								]),
							_Utils_ap(
								A2(
									$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ligne,
									$author$project$I18n$Cles$bibliothequeCalculResultat(i18n),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A3($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$resultatDuCalcul, i18n, fiche, calcul))
										])),
								_Utils_ap(
									A2(
										$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ligne,
										$author$project$I18n$Cles$bibliothequeCalculFormule(i18n),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$code,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('formule')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(calcul.zU)
													]))
											])),
									_Utils_ap(
										A2(
											$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ligne,
											$author$project$I18n$Cles$bibliothequeCalculLit(i18n),
											_Utils_eq(calcul.BY, _List_Nil) ? _List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('-')
												]) : A2(
												$elm$core$List$map,
												function (_v1) {
													var nom = _v1.b;
													return A2(
														$rtfeldman$elm_css$Html$Styled$div,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('source')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(nom),
																$rtfeldman$elm_css$Html$Styled$text(' '),
																A2(
																$author$project$Components$Shared$Tag$View$view,
																3,
																$author$project$I18n$Cles$bibliothequeCalculLitChamp(i18n))
															]));
												},
												calcul.BY)),
										_Utils_ap(
											A2(
												$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ligne,
												$author$project$I18n$Cles$bibliothequeCalculRecalcul(i18n),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2($author$project$Components$Parametrage$Vocabulaire$libelleDuRecalcul, i18n, calcul.G$))
													])),
											A2(
												$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ligne,
												$author$project$I18n$Cles$bibliothequeCalculValeur(i18n),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$libelleDeLaNature, i18n, calcul.fm))
													])))))))
						]),
					Ar: $elm$core$Maybe$Nothing,
					Dj: 'calcul',
					h6: $author$project$I18n$Cles$bibliothequeCalculTitre(i18n)
				});
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DefinitionOuverte = {$: 23};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$TraductionOuverte = {$: 34};
var $author$project$I18n$Cles$bibliothequeDefinitionModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.modifier', _List_Nil, 'Modifier la définition');
};
var $author$project$I18n$Cles$bibliothequeDefinitionTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.titre', _List_Nil, 'Définition');
};
var $author$project$I18n$Cles$bibliothequeDefinitionTraduire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.traduire', _List_Nil, 'Libellés et aide par langue');
};
var $author$project$I18n$Cles$bibliothequeDefinitionAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.aide', _List_Nil, 'Aide');
};
var $author$project$I18n$Cles$bibliothequeDefinitionAideTraduite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.aide-traduite', _List_Nil, 'Aide traduite');
};
var $author$project$I18n$Cles$bibliothequeDefinitionAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.aucune', _List_Nil, 'Aucune');
};
var $author$project$I18n$Cles$bibliothequeDefinitionCle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.cle', _List_Nil, 'Clé');
};
var $author$project$I18n$Cles$bibliothequeDefinitionCleNonModifiable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.cle-non-modifiable', _List_Nil, 'non modifiable');
};
var $author$project$I18n$Cles$bibliothequeDefinitionDateMax = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.date-max', _List_Nil, 'Date maximale');
};
var $author$project$I18n$Cles$bibliothequeDefinitionDateMin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.date-min', _List_Nil, 'Date minimale');
};
var $author$project$I18n$Cles$bibliothequeDefinitionDecimales = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.decimales', _List_Nil, 'Décimales');
};
var $author$project$I18n$Cles$bibliothequeDefinitionFige = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.fige', _List_Nil, 'figé');
};
var $author$project$I18n$Cles$bibliothequeDefinitionFiltrableRecherchable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.filtrable-recherchable', _List_Nil, 'Filtrable · Recherchable');
};
var $author$project$I18n$Cles$bibliothequeDefinitionFormat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.format', _List_Nil, 'Format');
};
var $author$project$I18n$Cles$bibliothequeDefinitionGrandeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.grandeur', _List_Nil, 'Grandeur');
};
var $author$project$I18n$Cles$bibliothequeDefinitionLibelleLangue = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.libelle-langue',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'langue',
					$author$project$I18n$Traductions$Chaine(p.nn)),
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			p.nn + (' : ' + p.Bl));
	});
var $author$project$I18n$Cles$bibliothequeDefinitionLibelles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.libelles', _List_Nil, 'Libellés');
};
var $author$project$I18n$Cles$bibliothequeDefinitionLongueurMax = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.longueur-max', _List_Nil, 'Longueur maximale');
};
var $author$project$I18n$Cles$bibliothequeDefinitionLongueurValeur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.longueur-valeur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' caractère') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' caractères'));
	});
var $author$project$I18n$Cles$bibliothequeDefinitionMax = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.max', _List_Nil, 'Valeur maximale');
};
var $author$project$I18n$Cles$bibliothequeDefinitionMin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.min', _List_Nil, 'Valeur minimale');
};
var $author$project$I18n$Cles$bibliothequeDefinitionMiseEnForme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.mise-en-forme', _List_Nil, 'Mise en forme simple');
};
var $author$project$I18n$Cles$bibliothequeDefinitionMiseEnFormeNon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.mise-en-forme-non', _List_Nil, 'Non autorisée');
};
var $author$project$I18n$Cles$bibliothequeDefinitionMiseEnFormeOui = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.mise-en-forme-oui', _List_Nil, 'Autorisée');
};
var $author$project$I18n$Cles$bibliothequeDefinitionNonTraduitLangue = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.non-traduit-langue',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'langue',
					$author$project$I18n$Traductions$Chaine(p.nn))
				]),
			p.nn + ' : non traduit');
	});
var $author$project$I18n$Cles$bibliothequeDefinitionType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.type', _List_Nil, 'Type');
};
var $author$project$I18n$Cles$bibliothequeDefinitionUnite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.unite', _List_Nil, 'Unité');
};
var $author$project$I18n$Cles$editeurDeSchemaChampNon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.champ.non', _List_Nil, 'Non');
};
var $author$project$I18n$Cles$editeurDeSchemaChampOui = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.champ.oui', _List_Nil, 'Oui');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionPlusieursChoix = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.plusieurs-choix', _List_Nil, 'Plusieurs choix');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionPlusieursChoixNon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.plusieurs-choix.non', _List_Nil, 'Non, un seul');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionPlusieursChoixOui = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.plusieurs-choix.oui', _List_Nil, 'Oui, plusieurs');
};
var $author$project$I18n$Cles$bibliothequeDefinitionFormatAdresseWeb = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.format-adresse-web', _List_Nil, 'Adresse web');
};
var $author$project$I18n$Cles$bibliothequeDefinitionFormatCourriel = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.format-courriel', _List_Nil, 'Courriel');
};
var $author$project$I18n$Cles$bibliothequeDefinitionFormatLettresChiffresEtTirets = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.format-lettres-chiffres-et-tirets', _List_Nil, 'Lettres, chiffres et tirets');
};
var $author$project$I18n$Cles$bibliothequeDefinitionFormatLettresEtChiffres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.format-lettres-et-chiffres', _List_Nil, 'Lettres et chiffres');
};
var $author$project$I18n$Cles$bibliothequeDefinitionFormatLibre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.format-libre', _List_Nil, 'Libre');
};
var $author$project$Components$Parametrage$Vocabulaire$formatDeTexte = F2(
	function (i18n, code) {
		switch (code) {
			case 'lettres-et-chiffres':
				return $author$project$I18n$Cles$bibliothequeDefinitionFormatLettresEtChiffres(i18n);
			case 'lettres-chiffres-et-tirets':
				return $author$project$I18n$Cles$bibliothequeDefinitionFormatLettresChiffresEtTirets(i18n);
			case 'courriel':
				return $author$project$I18n$Cles$bibliothequeDefinitionFormatCourriel(i18n);
			case 'adresse-web':
				return $author$project$I18n$Cles$bibliothequeDefinitionFormatAdresseWeb(i18n);
			default:
				return $author$project$I18n$Cles$bibliothequeDefinitionFormatLibre(i18n);
		}
	});
var $author$project$I18n$Cles$bibliothequeDefinitionNom = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.nom',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'langue',
					$author$project$I18n$Traductions$Chaine(p.nn))
				]),
			'Nom (' + ($elm$core$String$toLower(p.nn) + ', langue par défaut)'));
	});
var $author$project$I18n$Cles$bibliothequeLangueDe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.langue.de', _List_Nil, 'Allemand');
};
var $author$project$I18n$Cles$bibliothequeLangueEn = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.langue.en', _List_Nil, 'Anglais');
};
var $author$project$I18n$Cles$bibliothequeLangueEs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.langue.es', _List_Nil, 'Espagnol');
};
var $author$project$I18n$Cles$bibliothequeLangueFr = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.langue.fr', _List_Nil, 'Français');
};
var $author$project$I18n$Cles$bibliothequeLangueIt = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.langue.it', _List_Nil, 'Italien');
};
var $author$project$I18n$Cles$bibliothequeLangueNl = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.langue.nl', _List_Nil, 'Néerlandais');
};
var $author$project$I18n$Cles$bibliothequeLanguePt = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.langue.pt', _List_Nil, 'Portugais');
};
var $author$project$Components$Parametrage$Vocabulaire$nomDeLaLangue = F2(
	function (i18n, code) {
		switch (code) {
			case 'fr':
				return $author$project$I18n$Cles$bibliothequeLangueFr(i18n);
			case 'en':
				return $author$project$I18n$Cles$bibliothequeLangueEn(i18n);
			case 'de':
				return $author$project$I18n$Cles$bibliothequeLangueDe(i18n);
			case 'es':
				return $author$project$I18n$Cles$bibliothequeLangueEs(i18n);
			case 'it':
				return $author$project$I18n$Cles$bibliothequeLangueIt(i18n);
			case 'nl':
				return $author$project$I18n$Cles$bibliothequeLangueNl(i18n);
			case 'pt':
				return $author$project$I18n$Cles$bibliothequeLanguePt(i18n);
			default:
				return $elm$core$String$toUpper(code);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$libelleDuNom = F2(
	function (i18n, fiche) {
		return A2(
			$author$project$I18n$Cles$bibliothequeDefinitionNom,
			i18n,
			{
				nn: A2($author$project$Components$Parametrage$Vocabulaire$nomDeLaLangue, i18n, fiche.A9)
			});
	});
var $author$project$I18n$Cles$bibliothequeTypeChampDuType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.type.champ-du-type', _List_Nil, 'Champ du type');
};
var $author$project$I18n$Cles$bibliothequeTypeListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.type.liste', _List_Nil, 'Liste');
};
var $author$project$I18n$Cles$bibliothequeTypeListeDuType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.type.liste-du-type', _List_Nil, 'Liste de valeurs du type');
};
var $author$project$I18n$Cles$bibliothequeTypeListePartagee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.type.liste-partagee', _List_Nil, 'Liste partagée');
};
var $author$project$I18n$Cles$bibliothequeTypeListeUnique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.type.liste-unique', _List_Nil, 'Choix dans une liste');
};
var $author$project$I18n$Cles$editeurDeSchemaTypeAdresse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.type.adresse', _List_Nil, 'Adresse');
};
var $author$project$I18n$Cles$editeurDeSchemaTypeChoixMultiples = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.type.choix-multiples', _List_Nil, 'Choix multiples');
};
var $author$project$I18n$Cles$editeurDeSchemaTypeDate = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.type.date', _List_Nil, 'Date');
};
var $author$project$I18n$Cles$editeurDeSchemaTypeEmail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.type.email', _List_Nil, 'E-mail');
};
var $author$project$I18n$Cles$editeurDeSchemaTypeFichier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.type.fichier', _List_Nil, 'Fichier');
};
var $author$project$I18n$Cles$editeurDeSchemaTypeInconnu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.type.inconnu', _List_Nil, 'Type non pris en charge par cet écran');
};
var $author$project$I18n$Cles$editeurDeSchemaTypeListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.type.liste', _List_Nil, 'Liste de valeurs');
};
var $author$project$I18n$Cles$editeurDeSchemaTypeMesure = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.type.mesure', _List_Nil, 'Mesure avec unité');
};
var $author$project$I18n$Cles$editeurDeSchemaTypeMontant = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.type.montant', _List_Nil, 'Montant');
};
var $author$project$I18n$Cles$editeurDeSchemaTypeNombre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.type.nombre', _List_Nil, 'Nombre');
};
var $author$project$I18n$Cles$editeurDeSchemaTypeOuiNon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.type.oui-non', _List_Nil, 'Oui/non');
};
var $author$project$I18n$Cles$editeurDeSchemaTypePays = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.type.pays', _List_Nil, 'Pays');
};
var $author$project$I18n$Cles$editeurDeSchemaTypeReference = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.type.reference', _List_Nil, 'Référence (vers une autre ressource)');
};
var $author$project$I18n$Cles$editeurDeSchemaTypeTelephone = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.type.telephone', _List_Nil, 'Téléphone');
};
var $author$project$I18n$Cles$editeurDeSchemaTypeTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.type.texte', _List_Nil, 'Texte');
};
var $author$project$I18n$Cles$editeurDeSchemaTypeTexteLong = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.type.texte-long', _List_Nil, 'Texte long');
};
var $author$project$I18n$Cles$editeurDeSchemaTypeCalcule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.type.calcule', _List_Nil, 'Calculé (formule)');
};
var $author$project$I18n$Cles$editeurDeSchemaTypeCalculeCourt = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.type.calcule.court', _List_Nil, 'Calculé');
};
var $author$project$I18n$Cles$editeurDeSchemaTypeGroupe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.type.groupe', _List_Nil, 'Groupe de sous-champs');
};
var $author$project$I18n$Cles$editeurDeSchemaTypeLangue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.type.langue', _List_Nil, 'Langue');
};
var $author$project$I18n$Cles$editeurDeSchemaTypeLangueLong = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.type.langue-long', _List_Nil, 'Langue (BCP 47)');
};
var $author$project$I18n$Cles$editeurDeSchemaTypeListeCourt = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.type.liste.court', _List_Nil, 'Liste');
};
var $author$project$I18n$Cles$editeurDeSchemaTypeMesureCourt = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.type.mesure.court', _List_Nil, 'Mesure');
};
var $author$project$I18n$Cles$editeurDeSchemaTypePartiePrenante = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.type.partie-prenante', _List_Nil, 'Partie prenante');
};
var $author$project$I18n$Cles$editeurDeSchemaTypePaysLong = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.type.pays-long', _List_Nil, 'Pays (ISO 3166)');
};
var $author$project$I18n$Cles$editeurDeSchemaTypeUtilisateur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.type.utilisateur', _List_Nil, 'Utilisateur');
};
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerLienVersDesArticles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.drawer.lien-vers-des-articles', _List_Nil, 'Lien vers des articles');
};
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$types = function (i18n) {
	var simple = function (nom) {
		return {ad: nom, Dj: nom};
	};
	return $elm$core$Dict$fromList(
		_List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeTexte,
				simple(
					$author$project$I18n$Cles$editeurDeSchemaTypeTexte(i18n))),
				_Utils_Tuple2(
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeTexteLong,
				simple(
					$author$project$I18n$Cles$editeurDeSchemaTypeTexteLong(i18n))),
				_Utils_Tuple2(
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeNombre,
				simple(
					$author$project$I18n$Cles$editeurDeSchemaTypeNombre(i18n))),
				_Utils_Tuple2(
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeMesure,
				{
					ad: $author$project$I18n$Cles$editeurDeSchemaTypeMesureCourt(i18n),
					Dj: $author$project$I18n$Cles$editeurDeSchemaTypeMesure(i18n)
				}),
				_Utils_Tuple2(
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeMontant,
				simple(
					$author$project$I18n$Cles$editeurDeSchemaTypeMontant(i18n))),
				_Utils_Tuple2(
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeDate,
				simple(
					$author$project$I18n$Cles$editeurDeSchemaTypeDate(i18n))),
				_Utils_Tuple2(
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeOuiNon,
				simple(
					$author$project$I18n$Cles$editeurDeSchemaTypeOuiNon(i18n))),
				_Utils_Tuple2(
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeListe,
				{
					ad: $author$project$I18n$Cles$editeurDeSchemaTypeListeCourt(i18n),
					Dj: $author$project$I18n$Cles$editeurDeSchemaTypeListe(i18n)
				}),
				_Utils_Tuple2(
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeChoixMultiples,
				simple(
					$author$project$I18n$Cles$editeurDeSchemaTypeChoixMultiples(i18n))),
				_Utils_Tuple2(
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeFichier,
				simple(
					$author$project$I18n$Cles$editeurDeSchemaTypeFichier(i18n))),
				_Utils_Tuple2(
				'reference',
				simple(
					$author$project$I18n$Cles$editeurDeSchemaTypeReference(i18n))),
				_Utils_Tuple2(
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeGroupe,
				simple(
					$author$project$I18n$Cles$editeurDeSchemaTypeGroupe(i18n))),
				_Utils_Tuple2(
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typePartiePrenante,
				simple(
					$author$project$I18n$Cles$editeurDeSchemaTypePartiePrenante(i18n))),
				_Utils_Tuple2(
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeUtilisateur,
				simple(
					$author$project$I18n$Cles$editeurDeSchemaTypeUtilisateur(i18n))),
				_Utils_Tuple2(
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeCalcule,
				{
					ad: $author$project$I18n$Cles$editeurDeSchemaTypeCalculeCourt(i18n),
					Dj: $author$project$I18n$Cles$editeurDeSchemaTypeCalcule(i18n)
				}),
				_Utils_Tuple2(
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeEmail,
				simple(
					$author$project$I18n$Cles$editeurDeSchemaTypeEmail(i18n))),
				_Utils_Tuple2(
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeTelephone,
				simple(
					$author$project$I18n$Cles$editeurDeSchemaTypeTelephone(i18n))),
				_Utils_Tuple2(
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeAdresse,
				simple(
					$author$project$I18n$Cles$editeurDeSchemaTypeAdresse(i18n))),
				_Utils_Tuple2(
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typePays,
				{
					ad: $author$project$I18n$Cles$editeurDeSchemaTypePays(i18n),
					Dj: $author$project$I18n$Cles$editeurDeSchemaTypePaysLong(i18n)
				}),
				_Utils_Tuple2(
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeLangue,
				{
					ad: $author$project$I18n$Cles$editeurDeSchemaTypeLangue(i18n),
					Dj: $author$project$I18n$Cles$editeurDeSchemaTypeLangueLong(i18n)
				}),
				_Utils_Tuple2(
				'nombre-avec-unite',
				{
					ad: $author$project$I18n$Cles$editeurDeSchemaTypeMesureCourt(i18n),
					Dj: $author$project$I18n$Cles$editeurDeSchemaTypeMesure(i18n)
				}),
				_Utils_Tuple2(
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeListeUnique,
				simple(
					$author$project$I18n$Cles$bibliothequeTypeListeUnique(i18n))),
				_Utils_Tuple2(
				'choix-dans-une-liste-partagee',
				simple(
					$author$project$I18n$Cles$bibliothequeTypeListePartagee(i18n))),
				_Utils_Tuple2(
				'lien-vers-des-articles',
				simple(
					$author$project$I18n$Cles$produitsParcoursInformationsDrawerLienVersDesArticles(i18n)))
			]));
};
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeConnu = F2(
	function (i18n, code) {
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.ad;
			},
			A2(
				$elm$core$Dict$get,
				code,
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$types(i18n)));
	});
var $author$project$Components$Parametrage$Vocabulaire$typeDeChampDeLaBibliotheque = F2(
	function (i18n, code) {
		switch (code) {
			case 'liste-partagee':
				return $author$project$I18n$Cles$bibliothequeTypeListePartagee(i18n);
			case 'liste-unique':
				return $author$project$I18n$Cles$bibliothequeTypeListeUnique(i18n);
			case 'liste-du-type':
				return $author$project$I18n$Cles$bibliothequeTypeListeDuType(i18n);
			case 'liste':
				return $author$project$I18n$Cles$bibliothequeTypeListe(i18n);
			case 'champ-du-type':
				return $author$project$I18n$Cles$bibliothequeTypeChampDuType(i18n);
			case 'mesure':
				return $author$project$I18n$Cles$editeurDeSchemaTypeMesure(i18n);
			case 'enum':
				return $author$project$I18n$Cles$editeurDeSchemaTypeListe(i18n);
			case 'multienum':
				return $author$project$I18n$Cles$editeurDeSchemaTypeChoixMultiples(i18n);
			case 'choice':
				return $author$project$I18n$Cles$bibliothequeTypeListeUnique(i18n);
			case 'text':
				return $author$project$I18n$Cles$editeurDeSchemaTypeTexte(i18n);
			case 'longtext':
				return $author$project$I18n$Cles$editeurDeSchemaTypeTexteLong(i18n);
			case 'number':
				return $author$project$I18n$Cles$editeurDeSchemaTypeNombre(i18n);
			case 'integer':
				return $author$project$I18n$Cles$editeurDeSchemaTypeNombre(i18n);
			case 'money':
				return $author$project$I18n$Cles$editeurDeSchemaTypeMontant(i18n);
			case 'bool':
				return $author$project$I18n$Cles$editeurDeSchemaTypeOuiNon(i18n);
			case 'date':
				return $author$project$I18n$Cles$editeurDeSchemaTypeDate(i18n);
			case 'email':
				return $author$project$I18n$Cles$editeurDeSchemaTypeEmail(i18n);
			case 'phone':
				return $author$project$I18n$Cles$editeurDeSchemaTypeTelephone(i18n);
			case 'address':
				return $author$project$I18n$Cles$editeurDeSchemaTypeAdresse(i18n);
			case 'country':
				return $author$project$I18n$Cles$editeurDeSchemaTypePays(i18n);
			case 'file':
				return $author$project$I18n$Cles$editeurDeSchemaTypeFichier(i18n);
			case 'ref':
				return $author$project$I18n$Cles$editeurDeSchemaTypeReference(i18n);
			default:
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$I18n$Cles$editeurDeSchemaTypeInconnu(i18n),
					A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeConnu, i18n, code));
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$lignesDeLaDefinition = F2(
	function (i18n, fiche) {
		var traduite = function (langue) {
			return A2($elm$core$Dict$get, langue, fiche.JL);
		};
		var oui = function (valeur) {
			return valeur ? $author$project$I18n$Cles$editeurDeSchemaChampOui(i18n) : $author$project$I18n$Cles$editeurDeSchemaChampNon(i18n);
		};
		var o = fiche.o_;
		var nonTraduit = function (langue) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$bibliothequeDefinitionNonTraduitLangue,
							i18n,
							{
								nn: A2($author$project$Components$Parametrage$Vocabulaire$nomDeLaLangue, i18n, langue)
							}))
					]));
		};
		var nombre = $elm$core$Maybe$map($elm$core$String$fromFloat);
		var famille = $author$project$Components$Parametrage$Vocabulaire$familleDOptions(fiche.JR);
		var facultatif = F2(
			function (libelle, valeur) {
				return A2(
					$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ligne,
					libelle,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$I18n$Cles$bibliothequeDefinitionAucune(i18n),
								valeur))
						]));
			});
		var autres = A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(fiche.A9),
			fiche.Ba);
		var libelles = A2(
			$elm$core$List$intersperse,
			A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
			A2(
				$elm$core$List$map,
				function (langue) {
					var _v0 = A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.Bl;
						},
						traduite(langue));
					if (!_v0.$) {
						var libelle = _v0.a;
						return (libelle !== '') ? A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$bibliothequeDefinitionLibelleLangue,
										i18n,
										{
											nn: A2($author$project$Components$Parametrage$Vocabulaire$nomDeLaLangue, i18n, langue),
											Bl: libelle
										}))
								])) : nonTraduit(langue);
					} else {
						return nonTraduit(langue);
					}
				},
				autres));
		var aidesTraduites = A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				$author$project$Components$Parametrage$Vocabulaire$nomDeLaLangue(i18n),
				A2(
					$elm$core$List$filter,
					function (langue) {
						return A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.bp;
									},
									$elm$core$Basics$neq('')),
								traduite(langue)));
					},
					autres)));
		return _Utils_ap(
			A2(
				$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ligne,
				A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$libelleDuNom, i18n, fiche),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(fiche.Dj)
							]))
					])),
			_Utils_ap(
				A2(
					$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ligne,
					$author$project$I18n$Cles$bibliothequeDefinitionLibelles(i18n),
					libelles),
				_Utils_ap(
					A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ligne,
						$author$project$I18n$Cles$bibliothequeDefinitionAide(i18n),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								(fiche.bp === '') ? $author$project$I18n$Cles$bibliothequeDefinitionAucune(i18n) : fiche.bp)
							])),
					_Utils_ap(
						A2(
							$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ligne,
							$author$project$I18n$Cles$bibliothequeDefinitionAideTraduite(i18n),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									(aidesTraduites === '') ? $author$project$I18n$Cles$bibliothequeDefinitionAucune(i18n) : aidesTraduites)
								])),
						_Utils_ap(
							A2(
								$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ligne,
								$author$project$I18n$Cles$bibliothequeDefinitionCle(i18n),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$code,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(fiche.dy)
											])),
										$rtfeldman$elm_css$Html$Styled$text(' '),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$bibliothequeDefinitionCleNonModifiable(i18n))
											]))
									])),
							_Utils_ap(
								A2(
									$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ligne,
									$author$project$I18n$Cles$bibliothequeDefinitionType(i18n),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$Components$Parametrage$Vocabulaire$typeDeChampDeLaBibliotheque, i18n, fiche.JR)),
											$rtfeldman$elm_css$Html$Styled$text(' '),
											A2(
											$author$project$Components$Shared$Tag$View$view,
											3,
											$author$project$I18n$Cles$bibliothequeDefinitionFige(i18n))
										])),
								_Utils_ap(
									(famille === 1) ? A2(
										$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ligne,
										$author$project$I18n$Cles$bibliothequeDefinitionMiseEnForme(i18n),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												_Utils_eq(
													o.CE,
													$elm$core$Maybe$Just(true)) ? $author$project$I18n$Cles$bibliothequeDefinitionMiseEnFormeOui(i18n) : $author$project$I18n$Cles$bibliothequeDefinitionMiseEnFormeNon(i18n))
											])) : _List_Nil,
									_Utils_ap(
										(!famille) ? _Utils_ap(
											A2(
												facultatif,
												$author$project$I18n$Cles$bibliothequeDefinitionLongueurMax(i18n),
												A2(
													$elm$core$Maybe$map,
													function (n) {
														return A2(
															$author$project$I18n$Cles$bibliothequeDefinitionLongueurValeur,
															i18n,
															{w: n});
													},
													o.B$)),
											A2(
												$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ligne,
												$author$project$I18n$Cles$bibliothequeDefinitionFormat(i18n),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2(
															$author$project$Components$Parametrage$Vocabulaire$formatDeTexte,
															i18n,
															A2($elm$core$Maybe$withDefault, $author$project$Components$Parametrage$Vocabulaire$formatLibre, o.zP)))
													]))) : _List_Nil,
										_Utils_ap(
											(famille === 7) ? A2(
												$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ligne,
												$author$project$I18n$Cles$editeurDeSchemaOptionPlusieursChoix(i18n),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														_Utils_eq(
															o.FT,
															$elm$core$Maybe$Just(true)) ? $author$project$I18n$Cles$editeurDeSchemaOptionPlusieursChoixOui(i18n) : $author$project$I18n$Cles$editeurDeSchemaOptionPlusieursChoixNon(i18n))
													])) : _List_Nil,
											_Utils_ap(
												(famille === 5) ? _Utils_ap(
													A2(
														facultatif,
														$author$project$I18n$Cles$bibliothequeDefinitionGrandeur(i18n),
														o.m0),
													A2(
														facultatif,
														$author$project$I18n$Cles$bibliothequeDefinitionUnite(i18n),
														o.sa)) : _List_Nil,
												_Utils_ap(
													A2(
														$elm$core$List$member,
														famille,
														_List_fromArray(
															[2, 5])) ? A2(
														facultatif,
														$author$project$I18n$Cles$bibliothequeDefinitionDecimales(i18n),
														A2($elm$core$Maybe$map, $elm$core$String$fromInt, o.kv)) : _List_Nil,
													_Utils_ap(
														A2(
															$elm$core$List$member,
															famille,
															_List_fromArray(
																[2, 3, 5])) ? _Utils_ap(
															A2(
																facultatif,
																$author$project$I18n$Cles$bibliothequeDefinitionMin(i18n),
																nombre(o.Cx)),
															A2(
																facultatif,
																$author$project$I18n$Cles$bibliothequeDefinitionMax(i18n),
																nombre(o.Cg))) : _List_Nil,
														_Utils_ap(
															(famille === 4) ? _Utils_ap(
																A2(
																	facultatif,
																	$author$project$I18n$Cles$bibliothequeDefinitionDateMin(i18n),
																	o.wA),
																A2(
																	facultatif,
																	$author$project$I18n$Cles$bibliothequeDefinitionDateMax(i18n),
																	o.wz)) : _List_Nil,
															A2(
																$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ligne,
																$author$project$I18n$Cles$bibliothequeDefinitionFiltrableRecherchable(i18n),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(
																		oui(fiche.zG) + (' · ' + oui(fiche.G1)))
																	])))))))))))))));
	});
var $author$project$I18n$Cles$bibliothequeFicheValeursPosees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.fiche.valeurs-posees', _List_Nil, 'Valeurs posées');
};
var $author$project$I18n$Cles$bibliothequeFicheValeursPoseesNombre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.fiche.valeurs-posees-nombre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeur posée') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeurs posées'));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ligneDesValeursPosees = F2(
	function (i18n, fiche) {
		return (!fiche.Kj) ? _List_Nil : A2(
			$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ligne,
			$author$project$I18n$Cles$bibliothequeFicheValeursPosees(i18n),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2(
						$author$project$I18n$Cles$bibliothequeFicheValeursPoseesNombre,
						i18n,
						{w: fiche.Kj}))
				]));
	});
var $author$project$I18n$Cles$bibliothequeFicheDonneePersonnelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.fiche.donnee-personnelle', _List_Nil, 'Donnée personnelle');
};
var $author$project$I18n$Cles$bibliothequeFichePersonnelSur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.fiche.personnel-sur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('personnel sur ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' rattachement')) : ('personnel sur ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' rattachements')));
	});
var $author$project$I18n$Cles$bibliothequeFichePersonnelSurDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.fiche.personnel-sur-detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE)),
					_Utils_Tuple2(
					'ressources',
					$author$project$I18n$Traductions$Chaine(p.HO))
				]),
			'sur ' + (p.JE + (' : ' + p.HO)));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$lignePersonnelle = F2(
	function (i18n, fiche) {
		return (!fiche.pj) ? _List_Nil : A2(
			$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ligne,
			$author$project$I18n$Cles$bibliothequeFicheDonneePersonnelle(i18n),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2(
						$author$project$I18n$Cles$bibliothequeFichePersonnelSur,
						i18n,
						{w: fiche.pj})),
					$rtfeldman$elm_css$Html$Styled$text(' '),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$bibliothequeFichePersonnelSurDetail,
								i18n,
								{
									HO: A2(
										$elm$core$String$join,
										', ',
										A2(
											$elm$core$List$map,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.HN;
												},
												function ($) {
													return $.Dj;
												}),
											A2(
												$elm$core$List$filter,
												function ($) {
													return $.xD;
												},
												fiche.GY))),
									JE: $elm$core$String$fromInt(
										$elm$core$List$length(fiche.GY))
								}))
						]))
				]));
	});
var $author$project$I18n$Cles$bibliothequeFicheCreeDepuis = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.fiche.cree-depuis',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Créé depuis ' + p.Dj);
	});
var $author$project$I18n$Cles$bibliothequeFichePortee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.fiche.portee', _List_Nil, 'Portée');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$lignePortee = F2(
	function (i18n, fiche) {
		return (_Utils_eq(fiche.o4, $elm$core$Maybe$Nothing) && _Utils_eq(fiche.JY, _List_Nil)) ? _List_Nil : A2(
			$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ligne,
			$author$project$I18n$Cles$bibliothequeFichePortee(i18n),
			_Utils_ap(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (origine) {
							return _List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$bibliothequeFicheCreeDepuis,
										i18n,
										{Dj: origine.Dj})),
									$rtfeldman$elm_css$Html$Styled$text(' ')
								]);
						},
						fiche.o4)),
				A2(
					$elm$core$List$map,
					function (concerne) {
						return A2($author$project$Components$Shared$Tag$View$view, 5, concerne.Dj);
					},
					fiche.JY)));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$lignesDeLaPortee = F2(
	function (i18n, fiche) {
		return _Utils_ap(
			A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$lignePortee, i18n, fiche),
			_Utils_ap(
				A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ligneDesValeursPosees, i18n, fiche),
				A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$lignePersonnelle, i18n, fiche)));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$sectionDefinition = F2(
	function (i18n, fiche) {
		var bouton = F4(
			function (rel, identifiant, msg, libelle) {
				return _Utils_eq(
					A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeLaDefinition, rel, fiche),
					$elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id(identifiant),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
							]),
						libelle)
					]);
			});
		return A2(
			$author$project$Components$Shared$Page$View$sectionAvecCompte,
			_List_Nil,
			{
				fw: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
							]),
						_Utils_ap(
							A4(
								bouton,
								$author$project$API$NavLinksDictionary$modifierLaDefinition,
								$author$project$Components$Parametrage$BibliothequeDeChamps$Model$idModifierLaDefinition,
								$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DefinitionOuverte,
								$author$project$I18n$Cles$bibliothequeDefinitionModifier(i18n)),
							A4(
								bouton,
								$author$project$API$NavLinksDictionary$traduireLaDefinition,
								$author$project$Components$Parametrage$BibliothequeDeChamps$Model$idTraduire,
								$author$project$Components$Parametrage$BibliothequeDeChamps$Update$TraductionOuverte,
								$author$project$I18n$Cles$bibliothequeDefinitionTraduire(i18n))))
					]),
				vW: $elm$core$Maybe$Nothing,
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$dl,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('definition')
							]),
						_Utils_ap(
							A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$lignesDeLaDefinition, i18n, fiche),
							A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$lignesDeLaPortee, i18n, fiche)))
					]),
				Ar: $elm$core$Maybe$Nothing,
				Dj: 'definition',
				h6: $author$project$I18n$Cles$bibliothequeDefinitionTitre(i18n)
			});
	});
var $author$project$I18n$Cles$bibliothequeFicheRechercheFiltrableNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.fiche.recherche-filtrable-note', _List_Nil, 'Décidé une fois pour toute la plateforme. Jamais offert sur les fiches où le champ est personnel.');
};
var $author$project$I18n$Cles$bibliothequeFicheRecherchePourquoi = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.fiche.recherche-pourquoi', _List_Nil, 'Une donnée personnelle n\'entre dans aucun filtre ni aucune facette. Le filtre commun ne couvre que les fiches où le champ n\'est pas personnel.');
};
var $author$project$I18n$Cles$bibliothequeFicheRecherchePourquoiTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.fiche.recherche-pourquoi-titre', _List_Nil, 'Pourquoi pas de filtre ici');
};
var $author$project$I18n$Cles$bibliothequeFicheRechercheRecherchableNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.fiche.recherche-recherchable-note', _List_Nil, 'Recherche exacte sur la valeur complète, sans filtre ni recherche partielle.');
};
var $author$project$I18n$Cles$bibliothequeFicheRechercheTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.fiche.recherche-titre', _List_Nil, 'Réglages de recherche');
};
var $author$project$I18n$Cles$bibliothequeReglagesFiltrable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reglages.filtrable', _List_Nil, 'Filtrable : apparaît dans les filtres de recherche');
};
var $author$project$I18n$Cles$bibliothequeReglagesRecherchable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reglages.recherchable', _List_Nil, 'Recherchable par valeur exacte');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$sectionRecherche = F3(
	function (i18n, model, fiche) {
		var personnel = A2(
			$elm$core$List$any,
			function (champ) {
				return _Utils_eq(
					champ.Aq,
					$elm$core$Maybe$Just(fiche.Aq)) && (champ.pj > 0);
			},
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.dw;
					},
					model.EE)));
		var bloc = F2(
			function (titre, note) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('reglage')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(titre)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(note)
								]))
						]));
			});
		return A2(
			$author$project$Components$Shared$Page$View$sectionAvecCompte,
			_List_Nil,
			{
				fw: _List_Nil,
				vW: $elm$core$Maybe$Nothing,
				fZ: _List_fromArray(
					[
						A2(
						bloc,
						$author$project$I18n$Cles$bibliothequeReglagesFiltrable(i18n),
						$author$project$I18n$Cles$bibliothequeFicheRechercheFiltrableNote(i18n)),
						A2(
						bloc,
						$author$project$I18n$Cles$bibliothequeReglagesRecherchable(i18n),
						$author$project$I18n$Cles$bibliothequeFicheRechercheRecherchableNote(i18n)),
						personnel ? A2(
						bloc,
						$author$project$I18n$Cles$bibliothequeFicheRecherchePourquoiTitre(i18n),
						$author$project$I18n$Cles$bibliothequeFicheRecherchePourquoi(i18n)) : $rtfeldman$elm_css$Html$Styled$text('')
					]),
				Ar: $elm$core$Maybe$Nothing,
				Dj: 'recherche',
				h6: $author$project$I18n$Cles$bibliothequeFicheRechercheTitre(i18n)
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$RattachementOuvert = {$: 39};
var $author$project$I18n$Cles$bibliothequeFicheRattacher = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.fiche.rattacher', _List_Nil, 'Rattacher à une ressource');
};
var $author$project$I18n$Cles$bibliothequeFicheUtilisePar = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.fiche.utilise-par', _List_Nil, 'Utilisé par');
};
var $author$project$I18n$Cles$bibliothequeFicheRattachementsParent = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.fiche.rattachements.parent',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'parent',
					$author$project$I18n$Traductions$Chaine(p.ey))
				]),
			'de ' + p.ey);
	});
var $author$project$I18n$Cles$bibliothequeFicheRattachementsTypeDeProduit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.fiche.rattachements.type-de-produit', _List_Nil, 'Type de produit');
};
var $author$project$I18n$Cles$bibliothequeFicheRattachementsEtageAutre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.fiche.rattachements.etage-autre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'genre',
					$author$project$I18n$Traductions$Chaine(p.M))
				]),
			'Étage ' + p.M);
	});
var $author$project$I18n$Cles$bibliothequeFicheRattachementsEtageCatalogue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.fiche.rattachements.etage-catalogue', _List_Nil, 'Étage Catalogue');
};
var $author$project$I18n$Cles$bibliothequeFicheRattachementsEtageGamme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.fiche.rattachements.etage-gamme', _List_Nil, 'Étage Gamme');
};
var $author$project$I18n$Cles$bibliothequeFicheRattachementsEtageMarque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.fiche.rattachements.etage-marque', _List_Nil, 'Étage Marque');
};
var $author$project$Components$Parametrage$Vocabulaire$genreDEtage = F2(
	function (i18n, genre) {
		switch (genre) {
			case 'marque':
				return $author$project$I18n$Cles$bibliothequeFicheRattachementsEtageMarque(i18n);
			case 'gamme':
				return $author$project$I18n$Cles$bibliothequeFicheRattachementsEtageGamme(i18n);
			case 'catalogue':
				return $author$project$I18n$Cles$bibliothequeFicheRattachementsEtageCatalogue(i18n);
			default:
				var autre = genre;
				return A2(
					$author$project$I18n$Cles$bibliothequeFicheRattachementsEtageAutre,
					i18n,
					{M: autre});
		}
	});
var $author$project$I18n$Cles$bibliothequeFicheRattachementsHeritiers = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.fiche.rattachements.heritiers',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'gammes',
					$author$project$I18n$Traductions$Chaine(p.gG)),
					_Utils_Tuple2(
					'references',
					$author$project$I18n$Traductions$Chaine(p.hD))
				]),
			'hérité par ses ' + (p.gG + (' gammes et ' + (p.hD + ' références'))));
	});
var $author$project$I18n$Cles$bibliothequeFicheRattachementsHeritiersReferences = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.fiche.rattachements.heritiers-references',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'references',
					$author$project$I18n$Traductions$Chaine(p.hD))
				]),
			'hérité par ses ' + (p.hD + ' références'));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$heritiersDits = F2(
	function (i18n, heritiers) {
		return (!heritiers.gG) ? A2(
			$author$project$I18n$Cles$bibliothequeFicheRattachementsHeritiersReferences,
			i18n,
			{
				hD: $elm$core$String$fromInt(heritiers.hD)
			}) : A2(
			$author$project$I18n$Cles$bibliothequeFicheRattachementsHeritiers,
			i18n,
			{
				gG: $elm$core$String$fromInt(heritiers.gG),
				hD: $elm$core$String$fromInt(heritiers.hD)
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ressourceDuRattachement = F2(
	function (i18n, rattachement) {
		return _Utils_ap(
			A2(
				$elm$core$Maybe$withDefault,
				_List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Tag$View$view,
						3,
						$author$project$I18n$Cles$bibliothequeFicheRattachementsTypeDeProduit(i18n))
					]),
				A2(
					$elm$core$Maybe$map,
					function (genre) {
						return _List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Tag$View$view,
								5,
								A2($author$project$Components$Parametrage$Vocabulaire$genreDEtage, i18n, genre))
							]);
					},
					rattachement.z8)),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(rattachement.HN.Dj)
							]))
					]),
				_Utils_ap(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (parent) {
								return _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2('note', true),
														_Utils_Tuple2('parent', true)
													]))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$bibliothequeFicheRattachementsParent,
													i18n,
													{ey: parent}))
											]))
									]);
							},
							rattachement.ey)),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (heritiers) {
								return _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2('note', true),
														_Utils_Tuple2('heritiers', true)
													]))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$heritiersDits, i18n, heritiers))
											]))
									]);
							},
							rattachement.Ag)))));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ligneDeRattachement = F2(
	function (i18n, rattachement) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ressourceDuRattachement, i18n, rattachement));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$tableDesRattachements = F2(
	function (i18n, fiche) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$ul,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('rattachements')
				]),
			A2(
				$elm$core$List$map,
				$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ligneDeRattachement(i18n),
				fiche.GY));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$sectionUtilisePar = F2(
	function (i18n, fiche) {
		return A2(
			$author$project$Components$Shared$Page$View$sectionAvecCompte,
			_List_Nil,
			{
				fw: _Utils_eq(fiche.HQ, _List_Nil) ? _List_Nil : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Parametrage$BibliothequeDeChamps$Model$idRattacher),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$BibliothequeDeChamps$Update$RattachementOuvert),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'dialog')
									]),
								$author$project$I18n$Cles$bibliothequeFicheRattacher(i18n))
							]))
					]),
				vW: $elm$core$Maybe$Just(
					$elm$core$String$fromInt(
						$elm$core$List$length(fiche.GY))),
				fZ: _List_fromArray(
					[
						A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$tableDesRattachements, i18n, fiche)
					]),
				Ar: $elm$core$Maybe$Nothing,
				Dj: 'utilise-par',
				h6: $author$project$I18n$Cles$bibliothequeFicheUtilisePar(i18n)
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$corps = F4(
	function (i18n, messages, model, fiche) {
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id('main'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('fiche')
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$sectionDefinition, i18n, fiche),
							A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$sectionCalcul, i18n, fiche),
							A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$sectionUtilisePar, i18n, fiche)
						]),
					A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsView$bloc, i18n, model))),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id('aside')
					]),
				_List_fromArray(
					[
						$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$lectureSeule(fiche) ? A2(
						$author$project$Components$Shared$Note$View$view,
						0,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$bibliothequeFicheLectureSeuleTitre(i18n))
									])),
								$rtfeldman$elm_css$Html$Styled$text(' '),
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$bibliothequeFicheLectureSeuleDetail(i18n))
							])) : $rtfeldman$elm_css$Html$Styled$text(''),
						A3($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$sectionRecherche, i18n, model, fiche)
					]))
			]);
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$LeParentDemande = {$: 68};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$RestrictionCochee = F2(
	function (a, b) {
		return {$: 63, a: a, b: b};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$RestrictionEnregistree = {$: 66};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$RestrictionLevee = {$: 67};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$RestrictionToutCochee = {$: 64};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$RestrictionToutDecochee = {$: 65};
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$peutLever = function (etat) {
	var _v0 = etat.Es;
	if (!_v0.$) {
		var ouvert = _v0.a;
		return (!_Utils_eq(
			A3($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$lienPour, 1, ouvert.ou, etat),
			$elm$core$Maybe$Nothing)) && (!_Utils_eq(
			A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$propres, etat, ouvert.ou),
			$elm$core$Maybe$Nothing));
	} else {
		return false;
	}
};
var $author$project$Catalogue$Formes$determinant = function (forme) {
	if (forme.av) {
		return 'l\'';
	} else {
		var _v0 = forme.M;
		if (!_v0) {
			return 'le ';
		} else {
			return 'la ';
		}
	}
};
var $author$project$Catalogue$Formes$avecArticle = F2(
	function (formes, nom) {
		return A2(
			$elm$core$Maybe$withDefault,
			nom,
			A2(
				$elm$core$Maybe$map,
				function (lues) {
					return _Utils_ap(
						$author$project$Catalogue$Formes$determinant(lues.zX),
						$elm$core$String$toLower(nom));
				},
				formes));
	});
var $author$project$Catalogue$Formes$avecSon = F2(
	function (formes, nom) {
		return A2(
			$elm$core$Maybe$map,
			function (lues) {
				return _Utils_ap(
					function () {
						var _v0 = _Utils_Tuple2(lues.zX.M, lues.zX.av);
						if ((_v0.a === 1) && (!_v0.b)) {
							var _v1 = _v0.a;
							return 'sa ';
						} else {
							return 'son ';
						}
					}(),
					$elm$core$String$toLower(nom));
			},
			formes);
	});
var $author$project$Catalogue$Formes$avecUn = F2(
	function (formes, nom) {
		return A2(
			$elm$core$Maybe$withDefault,
			nom,
			A2(
				$elm$core$Maybe$map,
				function (lues) {
					return _Utils_ap(
						function () {
							var _v0 = lues.zX.M;
							if (!_v0) {
								return 'un ';
							} else {
								return 'une ';
							}
						}(),
						$elm$core$String$toLower(nom));
				},
				formes));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$majuscule = function (texte) {
	return _Utils_ap(
		$elm$core$String$toUpper(
			A2($elm$core$String$left, 1, texte)),
		A2($elm$core$String$dropLeft, 1, texte));
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$termesDe = F3(
	function (i18n, etat, noeud) {
		var dessus = A2(
			$elm$core$Maybe$andThen,
			function (id) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (n) {
							return _Utils_eq(n.Aq, id) && _Utils_eq(n.vj, noeud.vj);
						},
						$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$tous(etat)));
			},
			noeud.ey);
		return A3(
			$elm$core$Maybe$map2,
			F2(
				function (formes, dessous) {
					return {
						yE: A2(
							$author$project$Catalogue$Formes$avecArticle,
							$elm$core$Maybe$Just(formes),
							A2($author$project$I18n$Cles$texte, i18n, noeud.md)),
						yF: $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$majuscule(
							A2(
								$author$project$Catalogue$Formes$avecUn,
								$elm$core$Maybe$Just(formes),
								A2($author$project$I18n$Cles$texte, i18n, noeud.md))),
						E_: dessous
					};
				}),
			noeud.zS,
			A2(
				$elm$core$Maybe$andThen,
				function (d) {
					return A2(
						$author$project$Catalogue$Formes$avecSon,
						d.zS,
						A2($author$project$I18n$Cles$texte, i18n, d.md));
				},
				dessus));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$restrictionAffichee = F3(
	function (i18n, etat, _v0) {
		var noeud = _v0.ou;
		var restriction = _v0.al;
		return (noeud.M === 1) ? restriction : _Utils_update(
			restriction,
			{
				md: $elm$core$Maybe$Just(
					A2($author$project$I18n$Cles$texte, i18n, noeud.md)),
				rD: A3($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$termesDe, i18n, etat, noeud)
			});
	});
var $author$project$I18n$Cles$restrictionsDroit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restrictions.droit', _List_Nil, 'Droit requis : Paramétrage du catalogue');
};
var $author$project$I18n$Cles$restrictionNonTransmise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restriction.non-transmise', _List_Nil, 'non transmise');
};
var $author$project$Components$Shared$Bibliotheque$RestrictionView$avecLaMention = F4(
	function (i18n, id, restriction, caseACocher) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'non-transmise',
							!A2($author$project$Components$Shared$Bibliotheque$Restriction$transmise, id, restriction))
						]))
				]),
			_List_fromArray(
				[
					caseACocher,
					A2($author$project$Components$Shared$Bibliotheque$Restriction$transmise, id, restriction) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('mention')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$restrictionNonTransmise(i18n))
						]))
				]));
	});
var $author$project$Components$Shared$Champ$View$caseACocherInactivable = F2(
	function (champ, saisie) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$fieldset,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
					$author$project$Components$Shared$Champ$View$classes(champ),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('disabled', saisie.d4)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_Utils_ap(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
								$rtfeldman$elm_css$Html$Styled$Attributes$id(champ.Aq),
								$rtfeldman$elm_css$Html$Styled$Attributes$checked(saisie.vt),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(saisie.d4),
								$rtfeldman$elm_css$Html$Styled$Events$onCheck(saisie.D9)
							]),
						$author$project$Components$Shared$Champ$View$etats(champ)),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$for(champ.Aq)
						]),
					$author$project$Components$Shared$Champ$View$libelle(champ)),
					$author$project$Components$Shared$Champ$View$erreurs(champ)
				]));
	});
var $author$project$Components$Shared$Bibliotheque$RestrictionView$chaine = function (restriction) {
	return $elm$core$List$isEmpty(restriction.th) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('chaine')
			]),
		_Utils_ap(
			A2(
				$elm$core$List$map,
				function (ancetre) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('ancetre')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								ancetre.Dj + (' (' + ($elm$core$String$fromInt(ancetre.w) + ')')))
							]));
				},
				restriction.th),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('ancetre', true),
									_Utils_Tuple2('actuel', true)
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(restriction.I9)
						]))
				])));
};
var $author$project$I18n$Cles$restrictionIntro = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restriction.intro', _List_Nil, 'Cochez les valeurs que ce type propose. Les autres restent dans la liste et sur les fiches qui les ont déjà.');
};
var $author$project$I18n$Cles$restrictionIntroEtage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restriction.intro-etage', _List_Nil, 'Cochez les valeurs que ce nœud propose. Elles se transmettent vers le bas, à ses étages et à ses références.');
};
var $author$project$I18n$Cles$restrictionIntroEtageSousParent = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restriction.intro-etage-sous-parent', _List_Nil, 'Un nœud ne peut que resserrer ce que le nœud du dessus lui transmet.');
};
var $author$project$I18n$Cles$restrictionIntroEtageSousParentNomme = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restriction.intro-etage-sous-parent-nomme',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md)),
					_Utils_Tuple2(
					'parent',
					$author$project$I18n$Traductions$Chaine(p.ey))
				]),
			p.md + (' ne peut que resserrer ce que ' + (p.ey + ' lui transmet.')));
	});
var $author$project$I18n$Cles$restrictionIntroPartiePrenante = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restriction.intro-partie-prenante', _List_Nil, 'Un type de partie prenante n\'a pas d\'étages : la restriction se pose sur le type seulement.');
};
var $author$project$Components$Shared$Bibliotheque$RestrictionView$intro = F3(
	function (i18n, options, restriction) {
		var _v0 = _Utils_Tuple2(restriction.md, restriction.ey);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var _v1 = restriction.rD;
				if (!_v1.$) {
					var termes = _v1.a;
					return A2(
						$author$project$I18n$Cles$restrictionIntroEtageSousParentNomme,
						i18n,
						{md: termes.yF, ey: termes.E_});
				} else {
					return $author$project$I18n$Cles$restrictionIntroEtageSousParent(i18n);
				}
			} else {
				var _v2 = _v0.b;
				return $author$project$I18n$Cles$restrictionIntroEtage(i18n);
			}
		} else {
			return options.E$ ? $author$project$I18n$Cles$restrictionIntroPartiePrenante(i18n) : $author$project$I18n$Cles$restrictionIntro(i18n);
		}
	});
var $author$project$I18n$Cles$restrictionIntroTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restriction.intro-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Restreindre « ' + (p.uN + (' » pour le type « ' + (p.Dj + ' ».'))));
	});
var $author$project$I18n$Cles$restrictionIntroTitreEtage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restriction.intro-titre-etage',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN)),
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Restreindre « ' + (p.uN + (' » pour ' + (p.md + (' « ' + (p.Dj + ' ».'))))));
	});
var $author$project$Components$Shared$Bibliotheque$RestrictionView$introTitre = F2(
	function (i18n, restriction) {
		var _v0 = restriction.md;
		if (!_v0.$) {
			var etage = _v0.a;
			return A2(
				$author$project$I18n$Cles$restrictionIntroTitreEtage,
				i18n,
				{
					uN: restriction.uN,
					md: A2(
						$elm$core$Maybe$withDefault,
						$elm$core$String$toLower(etage),
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.yE;
							},
							restriction.rD)),
					Dj: restriction.I9
				});
		} else {
			return A2(
				$author$project$I18n$Cles$restrictionIntroTitre,
				i18n,
				{uN: restriction.uN, Dj: restriction.I9});
		}
	});
var $author$project$I18n$Cles$restrictionNonTransmiseExplication = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restriction.non-transmise-explication',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Les valeurs grisées ne sont pas transmises par « ' + (p.Dj + (' » ; pour les proposer, modifiez d\'abord la restriction de « ' + (p.Dj + ' ».'))));
	});
var $author$project$I18n$Cles$restrictionVoirLeParent = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restriction.voir-le-parent',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Voir la restriction de ' + p.Dj);
	});
var $author$project$Components$Shared$Bibliotheque$RestrictionView$issueDuParent = F3(
	function (i18n, voirLeParent, restriction) {
		var _v0 = _Utils_Tuple2(restriction.ey, voirLeParent);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var parent = _v0.a.a;
			var voir = _v0.b.a;
			return (_Utils_cmp(
				$author$project$Components$Shared$Bibliotheque$Restriction$total(restriction),
				$elm$core$List$length(restriction.Ki)) < 0) ? _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Note$View$view,
					0,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$restrictionNonTransmiseExplication,
								i18n,
								{Dj: parent}))
						])),
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onClick(voir)
						]),
					A2(
						$author$project$I18n$Cles$restrictionVoirLeParent,
						i18n,
						{Dj: parent}))
				]) : _List_Nil;
		} else {
			return _List_Nil;
		}
	});
var $author$project$I18n$Cles$restrictionCompteur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restriction.compteur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'retenues',
					$author$project$I18n$Traductions$Chaine(p.hN)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			p.hN + (' sur ' + (p.JE + ' valeurs retenues')));
	});
var $author$project$I18n$Cles$restrictionCompteurTransmises = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restriction.compteur-transmises',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'retenues',
					$author$project$I18n$Traductions$Chaine(p.hN)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			p.hN + (' sur ' + (p.JE + ' valeurs transmises')));
	});
var $author$project$I18n$Cles$restrictionToutCocher = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restriction.tout-cocher', _List_Nil, 'Tout cocher');
};
var $author$project$I18n$Cles$restrictionToutDecocher = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restriction.tout-decocher', _List_Nil, 'Tout décocher');
};
var $author$project$Components$Shared$Bibliotheque$Restriction$retenue = F2(
	function (id, restriction) {
		return A2($elm$core$Set$member, id, restriction.L);
	});
var $author$project$Components$Shared$Bibliotheque$Restriction$aApercu = function (restriction) {
	return A2(
		$elm$core$Maybe$andThen,
		function (n) {
			return (n > 0) ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
		},
		restriction.gH);
};
var $author$project$Components$Shared$Bibliotheque$RestrictionView$libelleDe = F2(
	function (id, restriction) {
		return A2(
			$elm$core$Maybe$withDefault,
			id,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(id)),
						restriction.Ki))));
	});
var $author$project$Components$Shared$Bibliotheque$RestrictionView$nomDuRefus = function (restriction) {
	var _v0 = restriction.eN;
	if (!_v0.$) {
		var nom = _v0.a;
		return $elm$core$Maybe$Just(nom);
	} else {
		return restriction.ey;
	}
};
var $author$project$I18n$Cles$restrictionRefus = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restriction.refus', _List_Nil, 'La restriction n\'a pas été enregistrée.');
};
var $author$project$I18n$Cles$restrictionRefusNonTransmise = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restriction.refus-non-transmise',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'« ' + (p.fm + (' » n\'est pas transmise par « ' + (p.Dj + ' ».'))));
	});
var $author$project$I18n$Cles$restrictionRefusNonTransmiseDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restriction.refus-non-transmise-detail', _List_Nil, 'Un nœud ne peut proposer que ce que le nœud du dessus lui transmet.');
};
var $author$project$I18n$Cles$restrictionRefusNonTransmiseDetailNomme = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restriction.refus-non-transmise-detail-nomme',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md)),
					_Utils_Tuple2(
					'parent',
					$author$project$I18n$Traductions$Chaine(p.ey))
				]),
			p.md + (' ne peut proposer que ce que ' + (p.ey + ' lui transmet.')));
	});
var $author$project$Components$Shared$Bibliotheque$RestrictionView$refus = F3(
	function (i18n, voirLeParent, restriction) {
		var _v0 = _Utils_Tuple2(
			restriction.fo,
			$author$project$Components$Shared$Bibliotheque$RestrictionView$nomDuRefus(restriction));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var id = _v0.a.a;
			var parent = _v0.b.a;
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$b,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$restrictionRefusNonTransmise,
								i18n,
								{
									Dj: parent,
									fm: A2($author$project$Components$Shared$Bibliotheque$RestrictionView$libelleDe, id, restriction)
								}))
						])),
					$rtfeldman$elm_css$Html$Styled$text(' '),
					$rtfeldman$elm_css$Html$Styled$text(
					function () {
						var _v1 = restriction.rD;
						if (!_v1.$) {
							var termes = _v1.a;
							return A2(
								$author$project$I18n$Cles$restrictionRefusNonTransmiseDetailNomme,
								i18n,
								{md: termes.yF, ey: termes.E_});
						} else {
							return $author$project$I18n$Cles$restrictionRefusNonTransmiseDetail(i18n);
						}
					}()),
					function () {
					if (!voirLeParent.$) {
						var voir = voirLeParent.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('issues')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(voir)
										]),
									A2(
										$author$project$I18n$Cles$restrictionVoirLeParent,
										i18n,
										{Dj: parent}))
								]));
					} else {
						return $rtfeldman$elm_css$Html$Styled$text('');
					}
				}()
				]);
		} else {
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$I18n$Cles$restrictionRefus(i18n))
				]);
		}
	});
var $author$project$I18n$Cles$restrictionApercuDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restriction.apercu.detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'retenues',
					$author$project$I18n$Traductions$Chaine(p.hN))
				]),
			'Elles gardent leur valeur ; la changer demandera de choisir parmi les ' + (p.hN + ' valeurs retenues. Aucune fiche n\'est modifiée.'));
	});
var $author$project$I18n$Cles$restrictionApercuTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restriction.apercu.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' fiche de ' + (p.Dj + ' sera « hors choix ».'))) : (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' fiches de ' + (p.Dj + ' seront « hors choix ».'))));
	});
var $author$project$I18n$Cles$restrictionLever = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restriction.lever', _List_Nil, 'Lever la restriction');
};
var $author$project$I18n$Cles$restrictionMasquer = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restriction.masquer',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Masquer le champ sur ' + p.Dj);
	});
var $author$project$I18n$Cles$restrictionVideDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restriction.vide.detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			'Pour ne plus rien proposer sur « ' + (p.Dj + (' », masquez le champ sur ce type, ou levez la restriction pour proposer les ' + (p.JE + ' valeurs.'))));
	});
var $author$project$I18n$Cles$restrictionVideDetailEtage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restriction.vide-detail-etage',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Pour proposer de nouveau les valeurs que « ' + (p.Dj + ' » reçoit du dessus, levez la restriction.'));
	});
var $author$project$I18n$Cles$restrictionVideTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restriction.vide.titre', _List_Nil, 'Une restriction ne peut pas être vide.');
};
var $author$project$Components$Shared$Bibliotheque$RestrictionView$retours = F5(
	function (i18n, voirLeParent, options, msgs, restriction) {
		return $author$project$Components$Shared$Bibliotheque$Restriction$estVide(restriction) ? _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Note$View$view,
				1,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$b,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$restrictionVideTitre(i18n))
							])),
						$rtfeldman$elm_css$Html$Styled$text(' '),
						$rtfeldman$elm_css$Html$Styled$text(
						_Utils_eq(restriction.md, $elm$core$Maybe$Nothing) ? A2(
							$author$project$I18n$Cles$restrictionVideDetail,
							i18n,
							{
								Dj: restriction.I9,
								JE: $elm$core$String$fromInt(
									$author$project$Components$Shared$Bibliotheque$Restriction$total(restriction))
							}) : A2(
							$author$project$I18n$Cles$restrictionVideDetailEtage,
							i18n,
							{Dj: restriction.I9})),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('issues')
							]),
						_Utils_ap(
							options.Fn ? _List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(msgs.Cc)
										]),
									A2(
										$author$project$I18n$Cles$restrictionMasquer,
										i18n,
										{Dj: restriction.I9}))
								]) : _List_Nil,
							options.Fm ? _List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(msgs.Bj)
										]),
									$author$project$I18n$Cles$restrictionLever(i18n))
								]) : _List_Nil))
					]))
			]) : _List_fromArray(
			[
				function () {
				var _v0 = $author$project$Components$Shared$Bibliotheque$Restriction$aApercu(restriction);
				if (!_v0.$) {
					var nombre = _v0.a;
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$b,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$restrictionApercuTitre,
											i18n,
											{Dj: restriction.I9, w: nombre}))
									])),
								$rtfeldman$elm_css$Html$Styled$text(' '),
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$restrictionApercuDetail,
									i18n,
									{
										hN: $elm$core$String$fromInt(
											$author$project$Components$Shared$Bibliotheque$Restriction$nombreRetenues(restriction))
									}))
							]));
				} else {
					return $rtfeldman$elm_css$Html$Styled$text('');
				}
			}(),
				restriction.qa ? A2(
				$author$project$Components$Shared$Note$View$view,
				1,
				A3($author$project$Components$Shared$Bibliotheque$RestrictionView$refus, i18n, voirLeParent, restriction)) : $rtfeldman$elm_css$Html$Styled$text('')
			]);
	});
var $author$project$Components$Shared$Bibliotheque$RestrictionView$corps = F6(
	function (i18n, voirLeParent, options, msgs, prefixe, restriction) {
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Note$View$view,
				0,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$b,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$Components$Shared$Bibliotheque$RestrictionView$introTitre, i18n, restriction))
							])),
						$rtfeldman$elm_css$Html$Styled$text(' '),
						$rtfeldman$elm_css$Html$Styled$text(
						A3($author$project$Components$Shared$Bibliotheque$RestrictionView$intro, i18n, options, restriction))
					])),
				$author$project$Components$Shared$Bibliotheque$RestrictionView$chaine(restriction),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('compteur')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$b,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								(_Utils_eq(restriction.JP, $elm$core$Maybe$Nothing) ? $author$project$I18n$Cles$restrictionCompteur(i18n) : $author$project$I18n$Cles$restrictionCompteurTransmises(i18n))(
									{
										hN: $elm$core$String$fromInt(
											$author$project$Components$Shared$Bibliotheque$Restriction$nombreRetenues(restriction)),
										JE: $elm$core$String$fromInt(
											$author$project$Components$Shared$Bibliotheque$Restriction$total(restriction))
									}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('gestes')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								2,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick(msgs.JI)
									]),
								$author$project$I18n$Cles$restrictionToutCocher(i18n)),
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								2,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick(msgs.JJ)
									]),
								$author$project$I18n$Cles$restrictionToutDecocher(i18n))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('valeurs')
					]),
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (rang, valeur) {
							return A4(
								$author$project$Components$Shared$Bibliotheque$RestrictionView$avecLaMention,
								i18n,
								valeur.Aq,
								restriction,
								A2(
									$author$project$Components$Shared$Champ$View$caseACocherInactivable,
									{
										go: $elm$core$Maybe$Nothing,
										Aq: prefixe + ('-valeur-' + $elm$core$String$fromInt(rang)),
										Bl: valeur.Bl,
										he: false
									},
									{
										vt: A2($author$project$Components$Shared$Bibliotheque$Restriction$retenue, valeur.Aq, restriction),
										d4: !A2($author$project$Components$Shared$Bibliotheque$Restriction$transmise, valeur.Aq, restriction),
										D9: msgs.vw(valeur.Aq)
									}));
						}),
					restriction.Ki)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('valeurs-grisees')
					]),
				A3($author$project$Components$Shared$Bibliotheque$RestrictionView$issueDuParent, i18n, voirLeParent, restriction)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('retours'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-live', 'polite')
					]),
				A5($author$project$Components$Shared$Bibliotheque$RestrictionView$retours, i18n, voirLeParent, options, msgs, restriction))
			]);
	});
var $author$project$Components$Shared$Bibliotheque$RestrictionView$pied = F3(
	function (i18n, options, msgs) {
		return {
			oJ: $elm$core$Maybe$Just(options.xP),
			HF: function (attributs) {
				return A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_Utils_ap(
						attributs,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								msgs.xU($author$project$Components$Shared$Drawer$Update$Fermer))
							])),
					$author$project$I18n$Cles$drawerAnnuler(i18n));
			},
			Jb: options.Fm ? _List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onClick(msgs.Bj),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(options.yj)
						]),
					$author$project$I18n$Cles$restrictionLever(i18n))
				]) : _List_Nil
		};
	});
var $author$project$I18n$Cles$restrictionAction = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restriction.action',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'retenues',
					$author$project$I18n$Traductions$Entier(p.hN))
				]),
			((!p.hN) || (p.hN === 1)) ? ('Restreindre à ' + (A2($author$project$I18n$Nombre$formater, 0, p.hN) + ' valeur')) : ('Restreindre à ' + (A2($author$project$I18n$Nombre$formater, 0, p.hN) + ' valeurs')));
	});
var $author$project$I18n$Cles$restrictionActionVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restriction.action-vide', _List_Nil, 'Restreindre');
};
var $author$project$I18n$Cles$restrictionTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restriction.titre', _List_Nil, 'Restreindre les valeurs');
};
var $author$project$I18n$Cles$restrictionSujet = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restriction.sujet',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'« ' + (p.uN + (' » · type « ' + (p.Dj + ' »'))));
	});
var $author$project$I18n$Cles$restrictionSujetEtage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restriction.sujet-etage',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN)),
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'« ' + (p.uN + (' » · ' + (p.md + (' « ' + (p.Dj + ' »'))))));
	});
var $author$project$Components$Shared$Bibliotheque$RestrictionView$sujetDe = F2(
	function (i18n, restriction) {
		var _v0 = restriction.md;
		if (!_v0.$) {
			var etage = _v0.a;
			return A2(
				$author$project$I18n$Cles$restrictionSujetEtage,
				i18n,
				{
					uN: restriction.uN,
					md: $elm$core$String$toLower(etage),
					Dj: restriction.I9
				});
		} else {
			return A2(
				$author$project$I18n$Cles$restrictionSujet,
				i18n,
				{uN: restriction.uN, Dj: restriction.I9});
		}
	});
var $author$project$Components$Shared$Bibliotheque$RestrictionView$viewSousUnParent = F6(
	function (i18n, voirLeParent, options, msgs, restriction, drawerModel) {
		var vide = {
			fs: {sR: false, Bl: '', C$: msgs.HV},
			fZ: _List_Nil,
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: ''
		};
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(drawerModel);
		var contenu = function () {
			if (!restriction.$) {
				var courante = restriction.a;
				return _Utils_update(
					vide,
					{
						fs: {
							sR: $author$project$Components$Shared$Bibliotheque$Restriction$enregistrable(courante) && (!options.yj),
							Bl: $author$project$Components$Shared$Bibliotheque$Restriction$estVide(courante) ? $author$project$I18n$Cles$restrictionActionVide(i18n) : A2(
								$author$project$I18n$Cles$restrictionAction,
								i18n,
								{
									hN: $author$project$Components$Shared$Bibliotheque$Restriction$nombreRetenues(courante)
								}),
							C$: msgs.HV
						},
						fZ: A6($author$project$Components$Shared$Bibliotheque$RestrictionView$corps, i18n, voirLeParent, options, msgs, prefixe, courante),
						h6: $author$project$I18n$Cles$restrictionTitre(i18n)
					});
			} else {
				return vide;
			}
		}();
		return A6(
			$author$project$Components$Shared$Drawer$View$viewAvecPiedLibreEtSousTitre,
			i18n,
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$Shared$Bibliotheque$RestrictionView$sujetDe(i18n),
					restriction)),
			A3($author$project$Components$Shared$Bibliotheque$RestrictionView$pied, i18n, options, msgs),
			msgs.xU,
			contenu,
			drawerModel);
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsView$drawerDeLaRestriction = F2(
	function (i18n, model) {
		var etat = model.qF;
		var ouvert = etat.Es;
		var parent = A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.al;
				},
				function ($) {
					return $.ey;
				}),
			ouvert);
		return A6(
			$author$project$Components$Shared$Bibliotheque$RestrictionView$viewSousUnParent,
			i18n,
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$LeParentDemande;
				},
				parent),
			{
				xP: $author$project$I18n$Cles$restrictionsDroit(i18n),
				yj: $author$project$API$Envoi$enCours(model.l2),
				E$: false,
				Fm: $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$peutLever(etat),
				Fn: false
			},
			{vw: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$RestrictionCochee, xU: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDeLaRestriction, Bj: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$RestrictionLevee, Cc: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$RestrictionLevee, HV: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$RestrictionEnregistree, JI: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$RestrictionToutCochee, JJ: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$RestrictionToutDecochee},
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$restrictionAffichee, i18n, etat),
				ouvert),
			model.lC);
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ChoixDeNoeudContinue = {$: 62};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$EtageDeRestrictionChoisi = function (a) {
	return {$: 60, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$NoeudDeRestrictionChoisi = function (a) {
	return {$: 61, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$aChoisir = function (etat) {
	return !_Utils_eq(
		$elm$core$Maybe$Nothing,
		A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.ou;
			},
			etat.jN));
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$noeudsProposes = F2(
	function (etage, etat) {
		return A2(
			$elm$core$List$filter,
			function (noeud) {
				return _Utils_eq(noeud.md, etage) && _Utils_eq(
					A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$propres, etat, noeud),
					$elm$core$Maybe$Nothing);
			},
			$author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$tous(etat));
	});
var $author$project$I18n$Cles$restrictionsChoixAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restrictions.choix.aucun', _List_Nil, 'Tous les nœuds de l\'arbre ont déjà une restriction pour ce champ.');
};
var $author$project$I18n$Cles$restrictionsChoixChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restrictions.choix.choisir', _List_Nil, 'Choisir…');
};
var $author$project$I18n$Cles$restrictionsChoixContinuer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restrictions.choix.continuer', _List_Nil, 'Continuer');
};
var $author$project$I18n$Cles$restrictionsChoixEtage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restrictions.choix.etage', _List_Nil, 'Étage');
};
var $author$project$I18n$Cles$restrictionsChoixInvite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restrictions.choix.invite', _List_Nil, 'Ce nœud n\'a pas encore de restriction : il propose aujourd\'hui les valeurs que lui transmet le nœud du dessus. « Continuer » ouvre le drawer « Restreindre » pour ce nœud.');
};
var $author$project$I18n$Cles$restrictionsChoixNoeud = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restrictions.choix.noeud', _List_Nil, 'Nœud');
};
var $author$project$I18n$Cles$restrictionsChoixSujet = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'restrictions.choix.sujet',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'« ' + (p.uN + ' »'));
	});
var $author$project$I18n$Cles$restrictionsChoixTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restrictions.choix.titre', _List_Nil, 'Restreindre un autre nœud');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsView$drawerDuChoix = F2(
	function (i18n, model) {
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.kZ);
		var etat = model.qF;
		var etages = $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$etagesProposes(etat);
		var etage = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.md;
			},
			etat.jN);
		var noeuds = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (e) {
					return A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$noeudsProposes, e, etat);
				},
				etage));
		return A6(
			$author$project$Components$Shared$Drawer$View$viewAvecPiedLibreEtSousTitre,
			i18n,
			A2(
				$author$project$I18n$Cles$restrictionsChoixSujet,
				i18n,
				{uN: etat.uN}),
			{
				oJ: $elm$core$Maybe$Just(
					$author$project$I18n$Cles$restrictionsDroit(i18n)),
				HF: function (attributs) {
					return A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_Utils_ap(
							attributs,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDuChoixDeNoeud($author$project$Components$Shared$Drawer$Update$Fermer))
								])),
						$author$project$I18n$Cles$drawerAnnuler(i18n));
				},
				Jb: _List_Nil
			},
			$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDuChoixDeNoeud,
			{
				fs: {
					sR: $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsDesNoeuds$aChoisir(etat),
					Bl: $author$project$I18n$Cles$restrictionsChoixContinuer(i18n),
					C$: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ChoixDeNoeudContinue
				},
				fZ: _Utils_eq(etages, _List_Nil) ? _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Note$View$view,
						0,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$restrictionsChoixAucun(i18n))
							]))
					]) : _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Champ$View$liste,
						{
							go: $elm$core$Maybe$Nothing,
							Aq: prefixe + '-etage',
							Bl: $author$project$I18n$Cles$restrictionsChoixEtage(i18n),
							he: true
						},
						{
							hg: function (valeur) {
								return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$EtageDeRestrictionChoisi(
									A2(
										$elm$core$Maybe$andThen,
										function (i) {
											return $elm$core$List$head(
												A2($elm$core$List$drop, i, etages));
										},
										$elm$core$String$toInt(valeur)));
							},
							o_: A2(
								$elm$core$List$cons,
								{
									Bl: $author$project$I18n$Cles$restrictionsChoixChoisir(i18n),
									fm: ''
								},
								A2(
									$elm$core$List$indexedMap,
									F2(
										function (i, e) {
											return {
												Bl: A2($author$project$I18n$Cles$texte, i18n, e),
												fm: $elm$core$String$fromInt(i)
											};
										}),
									etages)),
							fm: A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$String$fromInt),
									$elm$core$List$head(
										A2(
											$elm$core$List$filter,
											A2(
												$elm$core$Basics$composeR,
												$elm$core$Tuple$second,
												A2(
													$elm$core$Basics$composeR,
													$elm$core$Maybe$Just,
													$elm$core$Basics$eq(etage))),
											A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, etages)))))
						}),
						A2(
						$author$project$Components$Shared$Champ$View$liste,
						{
							go: $elm$core$Maybe$Nothing,
							Aq: prefixe + '-noeud',
							Bl: $author$project$I18n$Cles$restrictionsChoixNoeud(i18n),
							he: true
						},
						{
							hg: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$NoeudDeRestrictionChoisi,
							o_: A2(
								$elm$core$List$cons,
								{
									Bl: $author$project$I18n$Cles$restrictionsChoixChoisir(i18n),
									fm: ''
								},
								A2(
									$elm$core$List$map,
									function (n) {
										return {Bl: n.Dj, fm: n.Aq};
									},
									noeuds)),
							fm: A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.ou;
									},
									etat.jN))
						}),
						A2(
						$author$project$Components$Shared$Note$View$view,
						0,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$restrictionsChoixInvite(i18n))
							]))
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$restrictionsChoixTitre(i18n)
			},
			model.kZ);
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsView$dialogues = F2(
	function (i18n, model) {
		return _List_fromArray(
			[
				A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsView$drawerDeLaRestriction, i18n, model),
				A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsView$drawerDuChoix, i18n, model)
			]);
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DefinitionEnregistree = {$: 30};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$RetourALaDefinition = {$: 32};
var $author$project$I18n$Cles$bibliothequeDefinitionConfirmerAppliquer = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.confirmer-appliquer',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Appliquer aux ' + (p.w + ' types'));
	});
var $author$project$I18n$Cles$bibliothequeDefinitionConfirmerRetour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.confirmer-retour', _List_Nil, 'Retour à la définition');
};
var $author$project$I18n$Cles$bibliothequeDefinitionConfirmerSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.confirmer-sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Champ utilisé par ' + (p.w + ' types'));
	});
var $author$project$I18n$Cles$bibliothequeDefinitionConfirmerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.confirmer-titre', _List_Nil, 'Confirmer la modification');
};
var $author$project$I18n$Cles$bibliothequeDefinitionConversionContinuer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.conversion-continuer', _List_Nil, 'Continuer vers l\'aperçu');
};
var $author$project$I18n$Cles$bibliothequeDefinitionConversionConvertir = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.conversion-convertir',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Convertir ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeur')) : ('Convertir ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeurs')));
	});
var $author$project$I18n$Cles$bibliothequeDefinitionConversionPied = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.conversion-pied', _List_Nil, 'Rien n\'est converti avant confirmation');
};
var $author$project$I18n$Cles$bibliothequeDefinitionConversionPiedImmediat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.conversion-pied-immediat', _List_Nil, 'Action immédiate, non réversible : une nouvelle conversion en sens inverse arrondirait de nouveau.');
};
var $author$project$I18n$Cles$bibliothequeDefinitionConversionSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.conversion-sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'origine',
					$author$project$I18n$Traductions$Chaine(p.o4)),
					_Utils_Tuple2(
					'vers',
					$author$project$I18n$Traductions$Chaine(p.sn))
				]),
			'Mesure « ' + (p.Dj + (' » : ' + (p.o4 + (' → ' + (p.sn + '.'))))));
	});
var $author$project$I18n$Cles$bibliothequeDefinitionConversionTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.conversion-titre', _List_Nil, 'Confirmer le changement d\'unité');
};
var $author$project$I18n$Cles$bibliothequeDefinitionDrawerSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.drawer-sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'typeDeChamp',
					$author$project$I18n$Traductions$Chaine(p.JR))
				]),
			'Champ « ' + (p.Dj + (' » · ' + p.JR)));
	});
var $author$project$I18n$Cles$bibliothequeDefinitionEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$bibliothequeDefinitionEnregistrerConfirmer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.enregistrer-confirmer', _List_Nil, 'Enregistrer…');
};
var $author$project$I18n$Cles$bibliothequeDefinitionEnregistrerQuandMeme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.enregistrer-quand-meme', _List_Nil, 'Enregistrer quand même');
};
var $author$project$I18n$Cles$bibliothequeDefinitionImpossibleChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.impossible-choisir', _List_Nil, 'Choisir une autre unité');
};
var $author$project$I18n$Cles$bibliothequeDefinitionImpossibleTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.impossible-titre', _List_Nil, 'Conversion impossible');
};
var $author$project$I18n$Cles$bibliothequeDefinitionConversionColonneFiche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.conversion-colonne-fiche', _List_Nil, 'Fiche');
};
var $author$project$I18n$Cles$bibliothequeDefinitionConversionColonneResultat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.conversion-colonne-resultat', _List_Nil, 'Résultat');
};
var $author$project$I18n$Cles$bibliothequeDefinitionConversionColonneValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.conversion-colonne-valeur', _List_Nil, 'Valeur');
};
var $author$project$I18n$Cles$bibliothequeDefinitionConversionExemples = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.conversion-exemples', _List_Nil, 'Exemples de valeurs');
};
var $author$project$I18n$Cles$bibliothequeDefinitionImpossibleAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.impossible-aide', _List_Nil, 'Choisissez une autre unité qui garde ces valeurs lisibles. Les décimales ne peuvent pas être augmentées tant que des valeurs sont saisies.');
};
var $author$project$I18n$Cles$bibliothequeDefinitionImpossibleAlerte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.impossible-alerte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeur deviendrait zéro.') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeurs deviendraient zéro.'));
	});
var $author$project$I18n$Cles$bibliothequeDefinitionImpossibleDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.impossible-detail', _List_Nil, 'Une valeur non nulle serait perdue par l\'arrondi. Rien n\'a été modifié.');
};
var $author$project$I18n$Cles$bibliothequeDefinitionImpossibleQueFaire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.impossible-que-faire', _List_Nil, 'Que faire ?');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$nomEtCode = function (e) {
	return e.Dj + (' · ' + e.vx);
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$refus = F2(
	function (i18n, cle) {
		if (!cle.$) {
			var message = cle.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('refus'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$I18n$Cles$texte, i18n, message))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$tableau = F3(
	function (colonneAvant, entetes, lignes) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('bloc')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$table,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('changements')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (e) {
											return A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(e)
													]));
										},
										entetes))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$tbody,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (cellules) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$tr,
										_List_Nil,
										A2(
											$elm$core$List$indexedMap,
											F2(
												function (i, cellule) {
													return A2(
														$rtfeldman$elm_css$Html$Styled$td,
														_Utils_eq(i, colonneAvant) ? _List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('avant')
															]) : _List_Nil,
														cellule);
												}),
											cellules));
								},
								lignes))
						]))
				]));
	});
var $author$project$I18n$Cles$bibliothequeDefinitionConversionValeur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.conversion-valeur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm)),
					_Utils_Tuple2(
					'unite',
					$author$project$I18n$Traductions$Chaine(p.sa))
				]),
			p.fm + (' ' + p.sa));
	});
var $author$project$I18n$Nombre$formaterFlottant = F3(
	function (langue, decimales, nombre) {
		var virgule = function () {
			if (!langue) {
				return ',';
			} else {
				return '.';
			}
		}();
		var texte = $elm$core$String$fromFloat(
			$elm$core$Basics$abs(nombre));
		var signe = (nombre < 0) ? '-' : '';
		if (A2($elm$core$String$contains, 'e', texte)) {
			return $elm$core$String$fromFloat(nombre);
		} else {
			var _v0 = A2($elm$core$String$split, '.', texte);
			if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
				var entiers = _v0.a;
				var _v1 = _v0.b;
				var fraction = _v1.a;
				return _Utils_ap(
					signe,
					_Utils_ap(
						A2(
							$elm$core$String$join,
							$author$project$I18n$Nombre$separateur(langue),
							$author$project$I18n$Nombre$grouper(entiers)),
						_Utils_ap(
							virgule,
							A3($elm$core$String$padRight, decimales, '0', fraction))));
			} else {
				return _Utils_ap(
					signe,
					_Utils_ap(
						A2(
							$elm$core$String$join,
							$author$project$I18n$Nombre$separateur(langue),
							$author$project$I18n$Nombre$grouper(texte)),
						(decimales > 0) ? _Utils_ap(
							virgule,
							A2($elm$core$String$repeat, decimales, '0')) : ''));
			}
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$valeurAvecUnite = F4(
	function (i18n, decimales, unite, valeur) {
		return A2(
			$author$project$I18n$Cles$bibliothequeDefinitionConversionValeur,
			i18n,
			{
				sa: unite,
				fm: A3(
					$author$project$I18n$Nombre$formaterFlottant,
					$author$project$I18n$Traductions$langue(i18n),
					decimales,
					valeur)
			});
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$contenuDeLImpossibilite = F4(
	function (i18n, definition, conversion, fiche) {
		var perdues = A2(
			$elm$core$List$filter,
			function (e) {
				return (!e.iY) && (!(!e.je));
			},
			conversion.y_);
		var decimales = A2($elm$core$Maybe$withDefault, 0, fiche.o_.kv);
		return _List_fromArray(
			[
				A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$refus, i18n, definition.pZ),
				A2(
				$author$project$Components$Shared$Note$View$view,
				2,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$bibliothequeDefinitionImpossibleAlerte,
									i18n,
									{w: conversion.pe}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$bibliothequeDefinitionImpossibleDetail(i18n))
							]))
					])),
				_Utils_eq(perdues, _List_Nil) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$bibliothequeDefinitionConversionExemples(i18n))
							])),
						A3(
						$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$tableau,
						1,
						_List_fromArray(
							[
								$author$project$I18n$Cles$bibliothequeDefinitionConversionColonneFiche(i18n),
								$author$project$I18n$Cles$bibliothequeDefinitionConversionColonneValeur(i18n),
								$author$project$I18n$Cles$bibliothequeDefinitionConversionColonneResultat(i18n)
							]),
						A2(
							$elm$core$List$map,
							function (e) {
								return _List_fromArray(
									[
										_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$nomEtCode(e))
										]),
										_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A4($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$valeurAvecUnite, i18n, 0, conversion.wC, e.je))
										]),
										_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A4($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$valeurAvecUnite, i18n, decimales, conversion.sn, e.iY))
										])
									]);
							},
							perdues))
					])),
				A2(
				$author$project$Components$Shared$Note$View$view,
				0,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$bibliothequeDefinitionImpossibleQueFaire(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$bibliothequeDefinitionImpossibleAide(i18n))
							]))
					]))
			]);
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DefinitionConfirmee = function (a) {
	return {$: 31, a: a};
};
var $author$project$I18n$Cles$bibliothequeDefinitionConfirmerAlerte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.confirmer-alerte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Ce champ est utilisé par ' + (p.w + ' types.'));
	});
var $author$project$I18n$Cles$bibliothequeDefinitionConfirmerApres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.confirmer-apres', _List_Nil, 'Après');
};
var $author$project$I18n$Cles$bibliothequeDefinitionConfirmerAvant = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.confirmer-avant', _List_Nil, 'Avant');
};
var $author$project$I18n$Cles$bibliothequeDefinitionConfirmerCase = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.confirmer-case',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Je confirme : cette définition s\'applique aux ' + (p.w + (' types qui utilisent « ' + (p.Dj + ' ».'))));
	});
var $author$project$I18n$Cles$bibliothequeDefinitionConfirmerChange = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.confirmer-change', _List_Nil, 'Ce qui change');
};
var $author$project$I18n$Cles$bibliothequeDefinitionConfirmerDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.confirmer-detail', _List_Nil, 'La modification s\'applique à chacun d\'eux, aussitôt, sans toucher aux valeurs déjà saisies.');
};
var $author$project$I18n$Cles$bibliothequeDefinitionConfirmerElement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.confirmer-element', _List_Nil, 'Élément');
};
var $author$project$I18n$Cles$bibliothequeDefinitionConfirmerTypes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.confirmer-types', _List_Nil, 'Types concernés');
};
var $author$project$I18n$Cles$bibliothequeDefinitionGenre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.genre', _List_Nil, 'Genre du nom');
};
var $author$project$I18n$Cles$bibliothequeDefinitionNomCourt = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.nom-court', _List_Nil, 'Nom');
};
var $author$project$I18n$Cles$bibliothequeDefinitionGenreFeminin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.genre.feminin', _List_Nil, 'Féminin (la personne référente)');
};
var $author$project$I18n$Cles$bibliothequeDefinitionGenreMasculin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.genre.masculin', _List_Nil, 'Masculin (le chef de produit)');
};
var $author$project$Components$Parametrage$Vocabulaire$genreDuNom = F2(
	function (i18n, genre) {
		if (!genre) {
			return $author$project$I18n$Cles$bibliothequeDefinitionGenreFeminin(i18n);
		} else {
			return $author$project$I18n$Cles$bibliothequeDefinitionGenreMasculin(i18n);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$miseEnFormeEnTexte = F2(
	function (i18n, autorisee) {
		return autorisee ? $author$project$I18n$Cles$bibliothequeDefinitionMiseEnFormeOui(i18n) : $author$project$I18n$Cles$bibliothequeDefinitionMiseEnFormeNon(i18n);
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$plusieursEnTexte = F2(
	function (i18n, plusieurs) {
		return plusieurs ? $author$project$I18n$Cles$editeurDeSchemaOptionPlusieursChoixOui(i18n) : $author$project$I18n$Cles$editeurDeSchemaOptionPlusieursChoixNon(i18n);
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$changements = F3(
	function (i18n, fiche, brouillon) {
		var ligne = F4(
			function (element, lu, saisi, formater) {
				return _Utils_eq(lu, saisi) ? _List_Nil : _List_fromArray(
					[
						{
						iY: formater(saisi),
						je: formater(lu),
						lQ: element
					}
					]);
			});
		var famille = $author$project$Components$Parametrage$Vocabulaire$familleDOptions(fiche.JR);
		var parmi = F2(
			function (familles, lignes) {
				return A2($elm$core$List$member, famille, familles) ? lignes : _List_Nil;
			});
		var brut = function (texte) {
			return ($elm$core$String$trim(texte) === '') ? $author$project$I18n$Cles$bibliothequeDefinitionAucune(i18n) : texte;
		};
		var avant = $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$depuisLaFiche(fiche);
		return _Utils_ap(
			A4(
				ligne,
				$author$project$I18n$Cles$bibliothequeDefinitionNomCourt(i18n),
				avant.Dj,
				$elm$core$String$trim(brouillon.Dj),
				brut),
			_Utils_ap(
				A4(
					ligne,
					$author$project$I18n$Cles$bibliothequeDefinitionAide(i18n),
					avant.bp,
					brouillon.bp,
					brut),
				_Utils_ap(
					A4(
						ligne,
						$author$project$I18n$Cles$bibliothequeDefinitionGenre(i18n),
						avant.M,
						brouillon.M,
						$author$project$Components$Parametrage$Vocabulaire$genreDuNom(i18n)),
					_Utils_ap(
						A2(
							parmi,
							_List_fromArray(
								[0]),
							_Utils_ap(
								A4(
									ligne,
									$author$project$I18n$Cles$bibliothequeDefinitionLongueurMax(i18n),
									avant.B$,
									brouillon.B$,
									brut),
								A4(
									ligne,
									$author$project$I18n$Cles$bibliothequeDefinitionFormat(i18n),
									avant.zP,
									brouillon.zP,
									$author$project$Components$Parametrage$Vocabulaire$formatDeTexte(i18n)))),
						_Utils_ap(
							A2(
								parmi,
								_List_fromArray(
									[1]),
								A4(
									ligne,
									$author$project$I18n$Cles$bibliothequeDefinitionMiseEnForme(i18n),
									avant.CE,
									brouillon.CE,
									$author$project$Components$Parametrage$BibliothequeDeChamps$Definition$miseEnFormeEnTexte(i18n))),
							_Utils_ap(
								A2(
									parmi,
									_List_fromArray(
										[7]),
									A4(
										ligne,
										$author$project$I18n$Cles$editeurDeSchemaOptionPlusieursChoix(i18n),
										avant.FS,
										brouillon.FS,
										$author$project$Components$Parametrage$BibliothequeDeChamps$Definition$plusieursEnTexte(i18n))),
								_Utils_ap(
									A2(
										parmi,
										_List_fromArray(
											[5]),
										A4(
											ligne,
											$author$project$I18n$Cles$bibliothequeDefinitionUnite(i18n),
											avant.sa,
											brouillon.sa,
											brut)),
									_Utils_ap(
										A2(
											parmi,
											_List_fromArray(
												[2, 5]),
											A4(
												ligne,
												$author$project$I18n$Cles$bibliothequeDefinitionDecimales(i18n),
												avant.kv,
												brouillon.kv,
												brut)),
										_Utils_ap(
											A2(
												parmi,
												_List_fromArray(
													[2, 3, 5]),
												_Utils_ap(
													A4(
														ligne,
														$author$project$I18n$Cles$bibliothequeDefinitionMin(i18n),
														avant.Cx,
														brouillon.Cx,
														brut),
													A4(
														ligne,
														$author$project$I18n$Cles$bibliothequeDefinitionMax(i18n),
														avant.Cg,
														brouillon.Cg,
														brut))),
											A2(
												parmi,
												_List_fromArray(
													[4]),
												_Utils_ap(
													A4(
														ligne,
														$author$project$I18n$Cles$bibliothequeDefinitionDateMin(i18n),
														avant.wA,
														brouillon.wA,
														brut),
													A4(
														ligne,
														$author$project$I18n$Cles$bibliothequeDefinitionDateMax(i18n),
														avant.wz,
														brouillon.wz,
														brut))))))))))));
	});
var $author$project$I18n$Cles$bibliothequePorteePartiesPrenantes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.portee.parties-prenantes', _List_Nil, 'Parties prenantes');
};
var $author$project$I18n$Cles$bibliothequePorteeProduits = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.portee.produits', _List_Nil, 'Produits');
};
var $author$project$I18n$Cles$bibliothequePorteeProduitsEtPartiesPrenantes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.portee.produits-et-parties-prenantes', _List_Nil, 'Produits et parties prenantes');
};
var $author$project$Components$Parametrage$Vocabulaire$porteeDeLaBibliotheque = F2(
	function (i18n, code) {
		switch (code) {
			case 'parties-prenantes':
				return $author$project$I18n$Cles$bibliothequePorteePartiesPrenantes(i18n);
			case 'catalogue-et-parties-prenantes':
				return $author$project$I18n$Cles$bibliothequePorteeProduitsEtPartiesPrenantes(i18n);
			default:
				return $author$project$I18n$Cles$bibliothequePorteeProduits(i18n);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$contenuDeLaConfirmation = F4(
	function (i18n, prefixe, fiche, definition) {
		var nombre = $elm$core$List$length(fiche.JY);
		return _List_fromArray(
			[
				A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$refus, i18n, definition.pZ),
				A2(
				$author$project$Components$Shared$Note$View$view,
				1,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$bibliothequeDefinitionConfirmerAlerte,
									i18n,
									{
										w: $elm$core$String$fromInt(nombre)
									}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$bibliothequeDefinitionConfirmerDetail(i18n))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$bibliothequeDefinitionConfirmerChange(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('bloc')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$table,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('changements')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$bibliothequeDefinitionConfirmerElement(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$bibliothequeDefinitionConfirmerAvant(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$bibliothequeDefinitionConfirmerApres(i18n))
															]))
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$tbody,
										_List_Nil,
										A2(
											$elm$core$List$map,
											function (c) {
												return A2(
													$rtfeldman$elm_css$Html$Styled$tr,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$td,
															_List_Nil,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(c.lQ)
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$td,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$class('avant')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(c.je)
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$td,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$strong,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text(c.iY)
																		]))
																]))
														]));
											},
											A3($author$project$Components$Parametrage$BibliothequeDeChamps$Definition$changements, i18n, fiche, definition.uw)))
									]))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$bibliothequeDefinitionConfirmerTypes(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('bloc')
							]),
						A2(
							$elm$core$List$map,
							function (concerne) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$strong,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(concerne.Dj)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2($author$project$Components$Parametrage$Vocabulaire$porteeDeLaBibliotheque, i18n, concerne.cC))
												]))
										]));
							},
							fiche.JY))
					])),
				A2(
				$author$project$Components$Shared$Champ$View$caseACocher,
				{
					go: $elm$core$Maybe$Nothing,
					Aq: prefixe + '-case-confirmation',
					Bl: A2(
						$author$project$I18n$Cles$bibliothequeDefinitionConfirmerCase,
						i18n,
						{
							Dj: fiche.Dj,
							w: $elm$core$String$fromInt(nombre)
						}),
					he: false
				},
				{vt: definition.v2, D9: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DefinitionConfirmee})
			]);
	});
var $author$project$I18n$Cles$bibliothequeDefinitionConversionArrondi = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.conversion-arrondi', _List_Nil, 'arrondi');
};
var $author$project$I18n$Cles$bibliothequeDefinitionConversionArrondies = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.conversion-arrondies',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w)),
					_Utils_Tuple2(
					'decimales',
					$author$project$I18n$Traductions$Chaine(p.kv))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' valeur sera arrondie à ' + (p.kv + ' décimale(s).'))) : (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' valeurs seront arrondies à ' + (p.kv + ' décimale(s).'))));
	});
var $author$project$I18n$Cles$bibliothequeDefinitionConversionArrondiesDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.conversion-arrondies-detail', _List_Nil, 'Le détail précis des valeurs d\'origine reste visible dans l\'historique de chaque fiche.');
};
var $author$project$I18n$Cles$bibliothequeDefinitionConversionBornes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.conversion-bornes', _List_Nil, 'Bornes');
};
var $author$project$I18n$Cles$bibliothequeDefinitionConversionCase = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.conversion-case',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Je confirme la conversion de ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeur.')) : ('Je confirme la conversion de ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeurs.')));
	});
var $author$project$I18n$Cles$bibliothequeDefinitionConversionColonneType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.conversion-colonne-type', _List_Nil, 'Type de produit');
};
var $author$project$I18n$Cles$bibliothequeDefinitionConversionColonneValeurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.conversion-colonne-valeurs', _List_Nil, 'Valeurs');
};
var $author$project$I18n$Cles$bibliothequeDefinitionConversionFiches = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.conversion-fiches', _List_Nil, 'Fiches concernées');
};
var $author$project$I18n$Cles$bibliothequeDefinitionConversionImmediate = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.conversion-immediate',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeur sera convertie aussitôt, en une fois. Les valeurs d\'étage sont comprises.') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeurs seront converties aussitôt, en une fois. Les valeurs d\'étage sont comprises.'));
	});
var $author$project$I18n$Cles$bibliothequeDefinitionConversionTypes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.conversion-types',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Ce champ est utilisé par ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' type de produit.')) : ('Ce champ est utilisé par ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' types de produit.')));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$contenuDeLaConversion = F5(
	function (i18n, prefixe, fiche, definition, conversion) {
		var decimales = A2($elm$core$Maybe$withDefault, 0, fiche.o_.kv);
		var bornes = A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var element = _v0.a;
				var avant = _v0.b;
				var apres = _v0.c;
				return A3(
					$elm$core$Maybe$map2,
					F2(
						function (a, b) {
							return _List_fromArray(
								[
									_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(element)
									]),
									_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A4($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$valeurAvecUnite, i18n, 0, conversion.wC, a))
									]),
									_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$strong,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A4($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$valeurAvecUnite, i18n, decimales, conversion.sn, b))
											]))
									])
								]);
						}),
					avant,
					apres);
			},
			_List_fromArray(
				[
					_Utils_Tuple3(
					$author$project$I18n$Cles$bibliothequeDefinitionMin(i18n),
					conversion.us.Cz,
					conversion.us.Cy),
					_Utils_Tuple3(
					$author$project$I18n$Cles$bibliothequeDefinitionMax(i18n),
					conversion.us.Ci,
					conversion.us.Ch)
				]));
		return _List_fromArray(
			[
				A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$refus, i18n, definition.pZ),
				A2(
				$author$project$Components$Shared$Note$View$view,
				1,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$bibliothequeDefinitionConversionTypes,
									i18n,
									{
										w: $elm$core$List$length(conversion.o7)
									}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$bibliothequeDefinitionConversionImmediate,
									i18n,
									{w: conversion.Ki}))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$bibliothequeDefinitionConversionFiches(i18n))
							])),
						A3(
						$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$tableau,
						-1,
						_List_fromArray(
							[
								$author$project$I18n$Cles$bibliothequeDefinitionConversionColonneType(i18n),
								$author$project$I18n$Cles$bibliothequeDefinitionConversionColonneValeurs(i18n)
							]),
						A2(
							$elm$core$List$map,
							function (t) {
								return _List_fromArray(
									[
										_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(t.Dj)
										]),
										_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$elm$core$String$fromInt(t.Ki))
										])
									]);
							},
							conversion.o7))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$bibliothequeDefinitionConversionExemples(i18n))
							])),
						A3(
						$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$tableau,
						1,
						_List_fromArray(
							[
								$author$project$I18n$Cles$bibliothequeDefinitionConversionColonneFiche(i18n),
								$author$project$I18n$Cles$bibliothequeDefinitionConfirmerAvant(i18n),
								$author$project$I18n$Cles$bibliothequeDefinitionConfirmerApres(i18n)
							]),
						A2(
							$elm$core$List$map,
							function (e) {
								return _List_fromArray(
									[
										_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$nomEtCode(e))
										]),
										_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A4($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$valeurAvecUnite, i18n, 0, conversion.wC, e.je))
										]),
										_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$strong,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A4($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$valeurAvecUnite, i18n, decimales, conversion.sn, e.iY))
												])),
											e.tO ? A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(' '),
													A2(
													$author$project$Components$Shared$Tag$View$view,
													1,
													$author$project$I18n$Cles$bibliothequeDefinitionConversionArrondi(i18n))
												])) : $rtfeldman$elm_css$Html$Styled$text('')
										])
									]);
							},
							conversion.y_))
					])),
				(conversion.i3 > 0) ? A2(
				$author$project$Components$Shared$Note$View$view,
				0,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$bibliothequeDefinitionConversionArrondies,
									i18n,
									{
										kv: $elm$core$String$fromInt(decimales),
										w: conversion.i3
									}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$bibliothequeDefinitionConversionArrondiesDetail(i18n))
							]))
					])) : $rtfeldman$elm_css$Html$Styled$text(''),
				_Utils_eq(bornes, _List_Nil) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$bibliothequeDefinitionConversionBornes(i18n))
							])),
						A3(
						$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$tableau,
						1,
						_List_fromArray(
							[
								$author$project$I18n$Cles$bibliothequeDefinitionConfirmerElement(i18n),
								$author$project$I18n$Cles$bibliothequeDefinitionConfirmerAvant(i18n),
								$author$project$I18n$Cles$bibliothequeDefinitionConfirmerApres(i18n)
							]),
						bornes)
					])),
				A2(
				$author$project$Components$Shared$Champ$View$caseACocher,
				{
					go: $elm$core$Maybe$Nothing,
					Aq: prefixe + '-case-confirmation',
					Bl: A2(
						$author$project$I18n$Cles$bibliothequeDefinitionConversionCase,
						i18n,
						{w: conversion.Ki}),
					he: false
				},
				{vt: definition.v2, D9: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DefinitionConfirmee})
			]);
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Aide = 1;
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DefinitionSaisie = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Genre = 2;
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Nom = 0;
var $author$project$I18n$Cles$bibliothequeDefinitionConversionAlerte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.conversion-alerte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w)),
					_Utils_Tuple2(
					'origine',
					$author$project$I18n$Traductions$Chaine(p.o4)),
					_Utils_Tuple2(
					'vers',
					$author$project$I18n$Traductions$Chaine(p.sn))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' valeur sera convertie de ' + (p.o4 + (' en ' + (p.sn + '.'))))) : (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' valeurs seront converties de ' + (p.o4 + (' en ' + (p.sn + '.'))))));
	});
var $author$project$I18n$Cles$bibliothequeDefinitionConversionAlerteDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.conversion-alerte-detail', _List_Nil, 'Les bornes seront converties aussi. Un aperçu vous est présenté avant toute modification.');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$libelleDeLUnite = F2(
	function (fiche, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			code,
			A2(
				$elm$core$Maybe$map,
				function (unite) {
					return unite.Dj + (' (' + (unite.Bl + ')'));
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (unite) {
							return _Utils_eq(unite.vx, code);
						},
						fiche.sb))));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$uniteChange = F2(
	function (fiche, brouillon) {
		var saisie = $elm$core$String$trim(brouillon.sa);
		return ($author$project$Components$Parametrage$Vocabulaire$familleDOptions(fiche.JR) === 5) && ((fiche.c7 > 0) && ((saisie !== '') && (!_Utils_eq(
			saisie,
			A2($elm$core$Maybe$withDefault, '', fiche.o_.sa)))));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$annonceDeLaConversion = F3(
	function (i18n, fiche, definition) {
		return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Definition$uniteChange, fiche, definition.uw) ? A2(
			$author$project$Components$Shared$Note$View$view,
			1,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$bibliothequeDefinitionConversionAlerte,
								i18n,
								{
									w: fiche.c7,
									o4: A2(
										$author$project$Components$Parametrage$BibliothequeDeChamps$Definition$libelleDeLUnite,
										fiche,
										A2($elm$core$Maybe$withDefault, '', fiche.o_.sa)),
									sn: A2($author$project$Components$Parametrage$BibliothequeDeChamps$Definition$libelleDeLUnite, fiche, definition.uw.sa)
								}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$bibliothequeDefinitionConversionAlerteDetail(i18n))
						]))
				])) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$I18n$Cles$bibliothequeDefinitionApercuAuMoins = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.apercu-au-moins',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Resserrer les bornes ne modifie aucune valeur : au moins ' + (p.w + ' valeurs seraient hors des nouvelles bornes et resteraient affichées comme telles.'));
	});
var $author$project$I18n$Cles$bibliothequeDefinitionApercuDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.apercu-detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Resserrer les bornes ne modifie aucune valeur : ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeur serait hors des nouvelles bornes et resterait affichée comme telle.')) : ('Resserrer les bornes ne modifie aucune valeur : ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeurs seraient hors des nouvelles bornes et resteraient affichées comme telles.')));
	});
var $author$project$I18n$Cles$bibliothequeDefinitionApercuTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.apercu-titre', _List_Nil, 'Valeurs déjà saisies');
};
var $author$project$I18n$Cles$bibliothequeDefinitionApercuType = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.apercu-type',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (p.Dj + (' : ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeur'))) : (p.Dj + (' : ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeurs'))));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$apercuAverti = F2(
	function (i18n, a) {
		return A2(
			$author$project$Components$Shared$Note$View$view,
			1,
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$bibliothequeDefinitionApercuTitre(i18n))
						])),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								a.tW ? A2(
									$author$project$I18n$Cles$bibliothequeDefinitionApercuAuMoins,
									i18n,
									{
										w: $elm$core$String$fromInt(a.oF)
									}) : A2(
									$author$project$I18n$Cles$bibliothequeDefinitionApercuDetail,
									i18n,
									{w: a.oF}))
							])),
					A2(
						$elm$core$List$map,
						function (t) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('type')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$bibliothequeDefinitionApercuType,
											i18n,
											{Dj: t.Dj, w: t.oF}))
									]));
						},
						A2(
							$elm$core$List$filter,
							function (t) {
								return t.oF > 0;
							},
							a.o7)))));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$apercu = F2(
	function (i18n, etape) {
		if (etape.$ === 2) {
			var a = etape.a;
			return A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$apercuAverti, i18n, a);
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$bibliothequeDefinitionCleNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.cle-note', _List_Nil, 'Non modifiable.');
};
var $author$project$I18n$Cles$bibliothequeDefinitionTypeNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.type-note', _List_Nil, 'Figé après enregistrement.');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$IssueDuGroupeChoisie = {$: 29};
var $author$project$I18n$Cles$bibliothequeDefinitionIssueMasquerLeSousChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.issue-masquer-le-sous-champ', _List_Nil, 'Masquer le sous-champ');
};
var $author$project$I18n$Cles$bibliothequeDefinitionRetraitRefuseCorps = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.retrait-refuse-corps', _List_Nil, 'Le retirer les ferait disparaître. Vous pouvez le masquer : les valeurs sont gardées, la saisie et la lecture le cachent.');
};
var $author$project$I18n$Cles$bibliothequeDefinitionRetraitRefuseTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.retrait-refuse-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl)),
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('« ' + (p.Bl + (' » est renseigné sur ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiche.')))) : ('« ' + (p.Bl + (' » est renseigné sur ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiches.')))));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$issueDuGroupe = F2(
	function (i18n, retrait) {
		if (!retrait.$) {
			var libelle = retrait.a.Bl;
			var fiches = retrait.a.zu;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('refus')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('alerte'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('warn'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$bibliothequeDefinitionRetraitRefuseTitre,
											i18n,
											{Bl: libelle, w: fiches}))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$bibliothequeDefinitionRetraitRefuseCorps(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('secondary'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$BibliothequeDeChamps$Update$IssueDuGroupeChoisie)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$bibliothequeDefinitionIssueMasquerLeSousChamp(i18n))
											]))
									]))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$bibliothequeDefinitionTraductionsAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.traductions-aucune', _List_Nil, 'aucune');
};
var $author$project$I18n$Cles$bibliothequeDefinitionTraductionsResume = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.traductions-resume',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'traduites',
					$author$project$I18n$Traductions$Chaine(p.JM)),
					_Utils_Tuple2(
					'manquantes',
					$author$project$I18n$Traductions$Chaine(p.B4))
				]),
			'Renseignées : ' + (p.JM + (' · non traduites : ' + p.B4)));
	});
var $author$project$I18n$Cles$bibliothequeDefinitionTraduireBouton = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.traduire-bouton', _List_Nil, 'Traduire…');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$traduitesEtManquantes = function (fiche) {
	return A2(
		$elm$core$List$partition,
		function (langue) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (t) {
						return ($elm$core$String$trim(t.Bl) !== '') || ($elm$core$String$trim(t.bp) !== '');
					},
					A2($elm$core$Dict$get, langue, fiche.JL)));
		},
		$author$project$Components$Parametrage$BibliothequeDeChamps$Definition$languesATraduire(fiche));
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ligneDesTraductions = F2(
	function (i18n, fiche) {
		if (_Utils_eq(
			A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeLaDefinition, $author$project$API$NavLinksDictionary$traduireLaDefinition, fiche),
			$elm$core$Maybe$Nothing)) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var noms = function (langues) {
				return _Utils_eq(langues, _List_Nil) ? $author$project$I18n$Cles$bibliothequeDefinitionTraductionsAucune(i18n) : A2(
					$elm$core$String$join,
					', ',
					A2(
						$elm$core$List$map,
						$author$project$Components$Parametrage$Vocabulaire$nomDeLaLangue(i18n),
						langues));
			};
			var _v0 = $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$traduitesEtManquantes(fiche);
			var traduites = _v0.a;
			var manquantes = _v0.b;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne-traductions')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$bibliothequeDefinitionTraduire(i18n))
									])),
								A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$bibliothequeDefinitionTraductionsResume,
											i18n,
											{
												B4: noms(manquantes),
												JM: noms(traduites)
											}))
									]))
							])),
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$BibliothequeDeChamps$Update$TraductionOuverte)
							]),
						$author$project$I18n$Cles$bibliothequeDefinitionTraduireBouton(i18n))
					]));
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DefinitionDesSousChamps = function (a) {
	return {$: 25, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DefinitionRepetable = function (a) {
	return {$: 26, a: a};
};
var $author$project$I18n$Cles$bibliothequeGroupeRepetable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.groupe.repetable', _List_Nil, 'Répétable');
};
var $author$project$I18n$Cles$editeurDeSchemaGroupeRepetableNon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.groupe.repetable.non', _List_Nil, 'Non, une seule');
};
var $author$project$I18n$Cles$editeurDeSchemaGroupeRepetableOui = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.groupe.repetable.oui', _List_Nil, 'Oui, plusieurs occurrences');
};
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$ChoixDeType = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$Descendre = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$Exigence = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$Libelle = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$Monter = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$Retirer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$codeDuGenre = function (genre) {
	switch (genre) {
		case 0:
			return 'texte';
		case 1:
			return 'nombre';
		case 2:
			return 'date';
		case 3:
			return 'montant';
		case 4:
			return 'mesure';
		case 5:
			return 'devise';
		case 6:
			return 'liste';
		case 7:
			return 'partie-prenante';
		default:
			return 'utilisateur';
	}
};
var $author$project$I18n$Cles$sousChampsTypeDate = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.type.date', _List_Nil, 'Date');
};
var $author$project$I18n$Cles$sousChampsTypeDevise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.type.devise', _List_Nil, 'Devise (ISO 4217)');
};
var $author$project$I18n$Cles$sousChampsTypeListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.type.liste', _List_Nil, 'Choix dans une liste');
};
var $author$project$I18n$Cles$sousChampsTypeMesure = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.type.mesure', _List_Nil, 'Mesure');
};
var $author$project$I18n$Cles$sousChampsTypeMontant = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.type.montant', _List_Nil, 'Montant');
};
var $author$project$I18n$Cles$sousChampsTypeNombre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.type.nombre', _List_Nil, 'Nombre');
};
var $author$project$I18n$Cles$sousChampsTypePartiePrenante = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.type.partie-prenante', _List_Nil, 'Partie prenante');
};
var $author$project$I18n$Cles$sousChampsTypeTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.type.texte', _List_Nil, 'Texte');
};
var $author$project$I18n$Cles$sousChampsTypeUtilisateur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.type.utilisateur', _List_Nil, 'Utilisateur');
};
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$libelleDuGenre = F2(
	function (i18n, genre) {
		switch (genre) {
			case 0:
				return $author$project$I18n$Cles$sousChampsTypeTexte(i18n);
			case 1:
				return $author$project$I18n$Cles$sousChampsTypeNombre(i18n);
			case 2:
				return $author$project$I18n$Cles$sousChampsTypeDate(i18n);
			case 3:
				return $author$project$I18n$Cles$sousChampsTypeMontant(i18n);
			case 4:
				return $author$project$I18n$Cles$sousChampsTypeMesure(i18n);
			case 5:
				return $author$project$I18n$Cles$sousChampsTypeDevise(i18n);
			case 6:
				return $author$project$I18n$Cles$sousChampsTypeListe(i18n);
			case 7:
				return $author$project$I18n$Cles$sousChampsTypePartiePrenante(i18n);
			default:
				return $author$project$I18n$Cles$sousChampsTypeUtilisateur(i18n);
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$optionDeType = F3(
	function (i18n, sousChamp, genre) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$option,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'value',
					$author$project$Components$Shared$EditeurDeSchema$SousChamps$codeDuGenre(genre)),
					$rtfeldman$elm_css$Html$Styled$Attributes$selected(
					_Utils_eq(genre, sousChamp.M))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2($author$project$Components$Shared$EditeurDeSchema$SousChamps$libelleDuGenre, i18n, genre))
				]));
	});
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$Decimales = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$Max = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$Min = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$Reglage = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$Unite = function (a) {
	return {$: 0, a: a};
};
var $author$project$I18n$Cles$sousChampsDecimales = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.decimales', _List_Nil, 'Décimales');
};
var $author$project$I18n$Cles$sousChampsMaximum = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.maximum', _List_Nil, 'Maximum');
};
var $author$project$I18n$Cles$sousChampsMinimum = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.minimum', _List_Nil, 'Minimum');
};
var $author$project$I18n$Cles$sousChampsUnite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.unite', _List_Nil, 'Unité');
};
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$UneSeuleFois = function (a) {
	return {$: 4, a: a};
};
var $author$project$I18n$Cles$sousChampsUneSeuleFois = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.une-seule-fois', _List_Nil, 'Une seule fois par fiche');
};
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$uneFois = F4(
	function (i18n, repetable, rang, sousChamp) {
		return repetable ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$label,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('une-seule-fois')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$input,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
								$rtfeldman$elm_css$Html$Styled$Attributes$checked(sousChamp.J9),
								$rtfeldman$elm_css$Html$Styled$Events$onCheck(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$Shared$EditeurDeSchema$SousChamps$Reglage(rang),
									$author$project$Components$Shared$EditeurDeSchema$SousChamps$UneSeuleFois))
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$sousChampsUneSeuleFois(i18n))
							]))
					]))
			]) : _List_Nil;
	});
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$unitesProposees = _List_fromArray(
	['mm', 'cm', 'm']);
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$options = F4(
	function (i18n, repetable, rang, sousChamp) {
		var numero = $elm$core$String$fromInt(rang + 1);
		var champ = F3(
			function (legende, valeur, reglage) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('option'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'inputmode', 'decimal'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', legende + (' ' + numero)),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(valeur),
							$rtfeldman$elm_css$Html$Styled$Events$onInput(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Components$Shared$EditeurDeSchema$SousChamps$Reglage(rang),
								reglage))
						]),
					_List_Nil);
			});
		var bornes = _List_fromArray(
			[
				A3(
				champ,
				$author$project$I18n$Cles$sousChampsMinimum(i18n),
				sousChamp.Cx,
				$author$project$Components$Shared$EditeurDeSchema$SousChamps$Min),
				A3(
				champ,
				$author$project$I18n$Cles$sousChampsMaximum(i18n),
				sousChamp.Cg,
				$author$project$Components$Shared$EditeurDeSchema$SousChamps$Max)
			]);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('options')
				]),
			function () {
				var _v0 = sousChamp.M;
				switch (_v0) {
					case 4:
						return _Utils_ap(
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$select,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
											'aria-label',
											$author$project$I18n$Cles$sousChampsUnite(i18n) + (' ' + numero)),
											$rtfeldman$elm_css$Html$Styled$Events$onInput(
											A2(
												$elm$core$Basics$composeL,
												$author$project$Components$Shared$EditeurDeSchema$SousChamps$Reglage(rang),
												$author$project$Components$Shared$EditeurDeSchema$SousChamps$Unite))
										]),
									A2(
										$elm$core$List$map,
										function (unite) {
											return A2(
												$rtfeldman$elm_css$Html$Styled$option,
												_List_fromArray(
													[
														A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'value', unite),
														$rtfeldman$elm_css$Html$Styled$Attributes$selected(
														_Utils_eq(unite, sousChamp.sa))
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(unite)
													]));
										},
										$author$project$Components$Shared$EditeurDeSchema$SousChamps$unitesProposees)),
									A3(
									champ,
									$author$project$I18n$Cles$sousChampsDecimales(i18n),
									sousChamp.kv,
									$author$project$Components$Shared$EditeurDeSchema$SousChamps$Decimales)
								]),
							bornes);
					case 1:
						return _Utils_ap(
							bornes,
							A4($author$project$Components$Shared$EditeurDeSchema$SousChamps$uneFois, i18n, repetable, rang, sousChamp));
					case 3:
						return bornes;
					case 2:
						return A4($author$project$Components$Shared$EditeurDeSchema$SousChamps$uneFois, i18n, repetable, rang, sousChamp);
					default:
						return _List_Nil;
				}
			}());
	});
var $author$project$I18n$Cles$sousChampsTypeListeNom = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'sous-champs.type.liste.nom',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'liste',
					$author$project$I18n$Traductions$Chaine(p.nW))
				]),
			'Choix dans une liste · ' + p.nW);
	});
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$optionsDeListe = F3(
	function (i18n, listes, sousChamp) {
		var estChoix = sousChamp.M === 6;
		return _Utils_ap(
			(estChoix && (sousChamp.nW === '')) ? _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$option,
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'value', 'liste:'),
							$rtfeldman$elm_css$Html$Styled$Attributes$selected(true)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$sousChampsTypeListe(i18n))
						]))
				]) : _List_Nil,
			A2(
				$elm$core$List$map,
				function (liste) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$option,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'value', 'liste:' + liste.Aq),
								$rtfeldman$elm_css$Html$Styled$Attributes$selected(
								estChoix && _Utils_eq(liste.Aq, sousChamp.nW))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$sousChampsTypeListeNom,
									i18n,
									{nW: liste.Dj}))
							]));
				},
				listes));
	});
var $author$project$I18n$Cles$sousChampsTypePartiePrenanteNom = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'sous-champs.type.partie-prenante.nom',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typeDeFiche',
					$author$project$I18n$Traductions$Chaine(p.ca))
				]),
			'Partie prenante · ' + p.ca);
	});
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$optionsDeType = F3(
	function (i18n, types, sousChamp) {
		var estFiche = sousChamp.M === 7;
		return _Utils_ap(
			(estFiche && (sousChamp.r$ === '')) ? _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$option,
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'value', 'partie-prenante:'),
							$rtfeldman$elm_css$Html$Styled$Attributes$selected(true)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$sousChampsTypePartiePrenante(i18n))
						]))
				]) : _List_Nil,
			_Utils_ap(
				A2(
					$elm$core$List$map,
					function (type_) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$option,
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'value', 'partie-prenante:' + type_.Aq),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									estFiche && _Utils_eq(type_.Aq, sousChamp.r$))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$sousChampsTypePartiePrenanteNom,
										i18n,
										{ca: type_.Dj}))
								]));
					},
					types),
				_List_fromArray(
					[
						A3($author$project$Components$Shared$EditeurDeSchema$SousChamps$optionDeType, i18n, sousChamp, 8)
					])));
	});
var $author$project$I18n$Cles$sousChampsDescendre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'sous-champs.descendre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Descendre ' + p.Dj);
	});
var $author$project$I18n$Cles$sousChampsFacultatif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.facultatif', _List_Nil, 'Facultatif');
};
var $author$project$I18n$Cles$sousChampsLibelle = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'sous-champs.libelle',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rang',
					$author$project$I18n$Traductions$Chaine(p.bY))
				]),
			'Libellé du sous-champ ' + p.bY);
	});
var $author$project$I18n$Cles$sousChampsMasque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.masque', _List_Nil, 'Masqué');
};
var $author$project$I18n$Cles$sousChampsMonter = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'sous-champs.monter',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Monter ' + p.Dj);
	});
var $author$project$I18n$Cles$sousChampsObligatoire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.obligatoire', _List_Nil, 'Obligatoire');
};
var $author$project$I18n$Cles$sousChampsRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.retirer', _List_Nil, 'Retirer');
};
var $author$project$I18n$Cles$sousChampsRetirerNom = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'sous-champs.retirer.nom',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer ' + p.Dj);
	});
var $author$project$I18n$Cles$sousChampsSaisie = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'sous-champs.saisie',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rang',
					$author$project$I18n$Traductions$Chaine(p.bY))
				]),
			'Saisie du sous-champ ' + p.bY);
	});
var $author$project$I18n$Cles$sousChampsSansNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.sans-nom', _List_Nil, 'sans nom');
};
var $author$project$I18n$Cles$sousChampsType = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'sous-champs.type',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rang',
					$author$project$I18n$Traductions$Chaine(p.bY))
				]),
			'Type du sous-champ ' + p.bY);
	});
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$ligne = F5(
	function (i18n, fourni, dernier, rang, sousChamp) {
		var numero = $elm$core$String$fromInt(rang + 1);
		var nom = ($elm$core$String$trim(sousChamp.Bl) === '') ? $author$project$I18n$Cles$sousChampsSansNom(i18n) : sousChamp.Bl;
		var fleche = F4(
			function (libelle, geste, desactive, symbole) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('fleche'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', libelle),
							$rtfeldman$elm_css$Html$Styled$Attributes$title(libelle),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(desactive),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(geste)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(symbole)
						]));
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('sous-champ')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('fleches')
						]),
					_List_fromArray(
						[
							A4(
							fleche,
							A2(
								$author$project$I18n$Cles$sousChampsMonter,
								i18n,
								{Dj: nom}),
							$author$project$Components$Shared$EditeurDeSchema$SousChamps$Monter(rang),
							!rang,
							'\u25B2'),
							A4(
							fleche,
							A2(
								$author$project$I18n$Cles$sousChampsDescendre,
								i18n,
								{Dj: nom}),
							$author$project$Components$Shared$EditeurDeSchema$SousChamps$Descendre(rang),
							_Utils_eq(rang, dernier),
							'\u25BC')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle'),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-label',
							A2(
								$author$project$I18n$Cles$sousChampsLibelle,
								i18n,
								{bY: numero})),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(sousChamp.Bl),
							$rtfeldman$elm_css$Html$Styled$Events$onInput(
							$author$project$Components$Shared$EditeurDeSchema$SousChamps$Libelle(rang))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('type')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$select,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									A2(
										$author$project$I18n$Cles$sousChampsType,
										i18n,
										{bY: numero})),
									$rtfeldman$elm_css$Html$Styled$Events$onInput(
									$author$project$Components$Shared$EditeurDeSchema$SousChamps$ChoixDeType(rang))
								]),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									A2($author$project$Components$Shared$EditeurDeSchema$SousChamps$optionDeType, i18n, sousChamp),
									_List_fromArray(
										[0, 1, 3, 4, 5, 2])),
								_Utils_ap(
									A3($author$project$Components$Shared$EditeurDeSchema$SousChamps$optionsDeListe, i18n, fourni.n_, sousChamp),
									A3($author$project$Components$Shared$EditeurDeSchema$SousChamps$optionsDeType, i18n, fourni.ib, sousChamp))))
						])),
					sousChamp.n4 ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('masque')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$sousChampsMasque(i18n))
						])) : $rtfeldman$elm_css$Html$Styled$text(''),
					$author$project$Components$Shared$Segment$View$view(
					{
						vd: sousChamp.he ? 'obligatoire' : 'facultatif',
						Bi: A2(
							$author$project$I18n$Cles$sousChampsSaisie,
							i18n,
							{bY: numero}),
						Dj: fourni.pv + ('-saisie-' + numero),
						Ea: function (code) {
							return A2($author$project$Components$Shared$EditeurDeSchema$SousChamps$Exigence, rang, code === 'obligatoire');
						},
						o_: _List_fromArray(
							[
								{
								vx: 'facultatif',
								Bl: $author$project$I18n$Cles$sousChampsFacultatif(i18n)
							},
								{
								vx: 'obligatoire',
								Bl: $author$project$I18n$Cles$sousChampsObligatoire(i18n)
							}
							])
					}),
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					2,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-label',
							A2(
								$author$project$I18n$Cles$sousChampsRetirerNom,
								i18n,
								{Dj: nom})),
							$rtfeldman$elm_css$Html$Styled$Attributes$title(
							A2(
								$author$project$I18n$Cles$sousChampsRetirerNom,
								i18n,
								{Dj: nom})),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Shared$EditeurDeSchema$SousChamps$Retirer(rang))
						]),
					$author$project$I18n$Cles$sousChampsRetirer(i18n)),
					A4($author$project$Components$Shared$EditeurDeSchema$SousChamps$options, i18n, fourni.HI, rang, sousChamp)
				]));
	});
var $author$project$I18n$Cles$sousChampsAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.aide', _List_Nil, 'Types admis dans un sous-champ : texte, nombre, montant, date, choix dans une liste, partie prenante. Pas de groupe dans un groupe, ni de référence ou de champ calculé (prévus plus tard). Un groupe n\'est pas filtrable ni recherchable.');
};
var $author$project$I18n$Cles$sousChampsAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.ajouter', _List_Nil, '+ Ajouter un sous-champ');
};
var $author$project$I18n$Cles$sousChampsEnteteLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.entete.libelle', _List_Nil, 'Libellé');
};
var $author$project$I18n$Cles$sousChampsEnteteSaisie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.entete.saisie', _List_Nil, 'Saisie');
};
var $author$project$I18n$Cles$sousChampsEnteteType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.entete.type', _List_Nil, 'Type');
};
var $author$project$I18n$Cles$sousChampsLegende = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.legende', _List_Nil, 'Sous-champs, dans l\'ordre de saisie');
};
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$view = F3(
	function (i18n, fourni, sousChamps) {
		var dernier = $elm$core$List$length(sousChamps) - 1;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('sous-champs')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('legende')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$sousChampsLegende(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('bloc')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
								]),
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$sousChampsEnteteLibelle(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$sousChampsEnteteType(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$sousChampsEnteteSaisie(i18n))
										])),
									A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$ol,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('lignes')
								]),
							A2(
								$elm$core$List$indexedMap,
								A3($author$project$Components$Shared$EditeurDeSchema$SousChamps$ligne, i18n, fourni, dernier),
								sousChamps))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Shared$EditeurDeSchema$SousChamps$Ajouter)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$sousChampsAjouter(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$sousChampsAide(i18n))
						]))
				]));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$optionsDuGroupe = F6(
	function (i18n, prefixe, listes, types, fiche, definition) {
		return ($author$project$Components$Parametrage$Vocabulaire$familleDOptions(fiche.JR) !== 6) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$fieldset,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$legend,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$bibliothequeGroupeRepetable(i18n))
										]))
								])),
							$author$project$Components$Shared$Segment$View$view(
							{
								vd: definition.uw.HI ? 'oui' : 'non',
								Bi: $author$project$I18n$Cles$bibliothequeGroupeRepetable(i18n),
								Dj: prefixe + '-repetable',
								Ea: function (code) {
									return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DefinitionRepetable(code === 'oui');
								},
								o_: _List_fromArray(
									[
										{
										vx: 'oui',
										Bl: $author$project$I18n$Cles$editeurDeSchemaGroupeRepetableOui(i18n)
									},
										{
										vx: 'non',
										Bl: $author$project$I18n$Cles$editeurDeSchemaGroupeRepetableNon(i18n)
									}
									])
							})
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DefinitionDesSousChamps,
					A3(
						$author$project$Components$Shared$EditeurDeSchema$SousChamps$view,
						i18n,
						{n_: listes, pv: prefixe + '-groupe', HI: definition.uw.HI, ib: types},
						definition.uw.IX))
				]));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$DateMax = 10;
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$DateMin = 9;
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Decimales = 6;
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DefinitionMiseEnForme = function (a) {
	return {$: 28, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DefinitionPlusieursChoix = function (a) {
	return {$: 27, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Format = 4;
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$LongueurMax = 3;
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Max = 8;
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Min = 7;
var $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Unite = 5;
var $author$project$I18n$Cles$bibliothequeDefinitionFigee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.figee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Figée : ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeur saisie.')) : ('Figée : ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeurs saisies.')));
	});
var $author$project$I18n$Cles$bibliothequeDefinitionFigees = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.figees',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Figées dès qu\'une valeur est saisie : ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeur saisie.')) : ('Figées dès qu\'une valeur est saisie : ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeurs saisies.')));
	});
var $author$project$I18n$Cles$bibliothequeDefinitionFormatsNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.formats-note', _List_Nil, 'Libre · Lettres et chiffres · Lettres, chiffres et tirets · Courriel · Adresse web');
};
var $author$project$I18n$Cles$bibliothequeDefinitionLongueurMaxCaracteres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.longueur-max-caracteres', _List_Nil, 'Longueur maximale (caractères)');
};
var $author$project$I18n$Cles$bibliothequeDefinitionMiseEnFormeCase = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.mise-en-forme-case', _List_Nil, 'Autoriser la mise en forme simple');
};
var $author$project$I18n$Cles$bibliothequeDefinitionMiseEnFormeNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.mise-en-forme-note', _List_Nil, 'Gras, italique, listes et liens.');
};
var $author$project$I18n$Cles$bibliothequeDefinitionOptionsTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.options-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typeDeChamp',
					$author$project$I18n$Traductions$Chaine(p.JR))
				]),
			'Options du type ' + p.JR);
	});
var $author$project$Components$Parametrage$Vocabulaire$formatsDeTexte = _List_fromArray(
	[$author$project$Components$Parametrage$Vocabulaire$formatLibre, 'lettres-et-chiffres', 'lettres-chiffres-et-tirets', 'courriel', 'adresse-web']);
var $author$project$Components$Parametrage$BibliothequeDeChamps$OptionsView$plusieursChoix = F2(
	function (i18n, config) {
		return $author$project$Components$Shared$Segment$View$view(
			{
				vd: config.FS ? 'oui' : 'non',
				Bi: $author$project$I18n$Cles$editeurDeSchemaOptionPlusieursChoix(i18n),
				Dj: config.Dj,
				Ea: function (code) {
					return config.Ea(code === 'oui');
				},
				o_: _List_fromArray(
					[
						{
						vx: 'oui',
						Bl: $author$project$I18n$Cles$editeurDeSchemaOptionPlusieursChoixOui(i18n)
					},
						{
						vx: 'non',
						Bl: $author$project$I18n$Cles$editeurDeSchemaOptionPlusieursChoixNon(i18n)
					}
					])
			});
	});
var $author$project$I18n$Cles$bibliothequeDefinitionUniteNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.unite-note', _List_Nil, 'Une unité de la grandeur du champ.');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$OptionsView$unite = F2(
	function (i18n, config) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: config.Aq,
						Bl: $author$project$I18n$Cles$bibliothequeDefinitionUnite(i18n),
						he: false
					},
					{
						hg: config.hg,
						o_: A2(
							$elm$core$List$map,
							function (u) {
								return {Bl: u.Bl, fm: u.vx};
							},
							config.sb),
						fm: config.fm
					}),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$bibliothequeDefinitionUniteNote(i18n))
						]))
				]));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$optionsDuType = F4(
	function (i18n, prefixe, fiche, definition) {
		var saisie = F2(
			function (option, valeur) {
				return {
					hg: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DefinitionSaisie(option),
					fm: valeur
				};
			});
		var note = function (texte) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(texte)
					]));
		};
		var figees = fiche.c7 > 0;
		var champ = F2(
			function (suffixe, libelle) {
				return {go: $elm$core$Maybe$Nothing, Aq: prefixe + ('-' + suffixe), Bl: libelle, he: false};
			});
		var b = definition.uw;
		var bornes = _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Champ$View$texte,
				A2(
					champ,
					'min',
					$author$project$I18n$Cles$bibliothequeDefinitionMin(i18n)),
				A2(saisie, 7, b.Cx)),
				A2(
				$author$project$Components$Shared$Champ$View$texte,
				A2(
					champ,
					'max',
					$author$project$I18n$Cles$bibliothequeDefinitionMax(i18n)),
				A2(saisie, 8, b.Cg))
			]);
		var decimales = figees ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Champ$View$texteEnLectureSeule,
					A2(
						champ,
						'decimales',
						$author$project$I18n$Cles$bibliothequeDefinitionDecimales(i18n)),
					{fm: b.kv}),
					note(
					A2(
						$author$project$I18n$Cles$bibliothequeDefinitionFigees,
						i18n,
						{w: fiche.c7}))
				])) : A2(
			$author$project$Components$Shared$Champ$View$texte,
			A2(
				champ,
				'decimales',
				$author$project$I18n$Cles$bibliothequeDefinitionDecimales(i18n)),
			A2(saisie, 6, b.kv));
		var contenu = function () {
			var _v0 = $author$project$Components$Parametrage$Vocabulaire$familleDOptions(fiche.JR);
			switch (_v0) {
				case 0:
					return _List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Champ$View$texte,
							A2(
								champ,
								'longueur-max',
								$author$project$I18n$Cles$bibliothequeDefinitionLongueurMaxCaracteres(i18n)),
							A2(saisie, 3, b.B$)),
							A2(
							$author$project$Components$Shared$Champ$View$liste,
							A2(
								champ,
								'format',
								$author$project$I18n$Cles$bibliothequeDefinitionFormat(i18n)),
							{
								hg: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DefinitionSaisie(4),
								o_: A2(
									$elm$core$List$map,
									function (code) {
										return {
											Bl: A2($author$project$Components$Parametrage$Vocabulaire$formatDeTexte, i18n, code),
											fm: code
										};
									},
									$author$project$Components$Parametrage$Vocabulaire$formatsDeTexte),
								fm: b.zP
							}),
							note(
							$author$project$I18n$Cles$bibliothequeDefinitionFormatsNote(i18n))
						]);
				case 2:
					return A2($elm$core$List$cons, decimales, bornes);
				case 3:
					return bornes;
				case 4:
					return _List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Champ$View$date,
							A2(
								champ,
								'date-min',
								$author$project$I18n$Cles$bibliothequeDefinitionDateMin(i18n)),
							A2(saisie, 9, b.wA)),
							A2(
							$author$project$Components$Shared$Champ$View$date,
							A2(
								champ,
								'date-max',
								$author$project$I18n$Cles$bibliothequeDefinitionDateMax(i18n)),
							A2(saisie, 10, b.wz))
						]);
				case 5:
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('deux')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Components$Shared$Champ$View$texteEnLectureSeule,
											A2(
												champ,
												'grandeur',
												$author$project$I18n$Cles$bibliothequeDefinitionGrandeur(i18n)),
											{
												fm: A2($elm$core$Maybe$withDefault, '', fiche.o_.m0)
											}),
											figees ? note(
											A2(
												$author$project$I18n$Cles$bibliothequeDefinitionFigee,
												i18n,
												{w: fiche.c7})) : $rtfeldman$elm_css$Html$Styled$text('')
										])),
									A2(
									$author$project$Components$Parametrage$BibliothequeDeChamps$OptionsView$unite,
									i18n,
									{
										Aq: prefixe + '-unite',
										hg: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DefinitionSaisie(5),
										sb: A2(
											$elm$core$List$map,
											function (u) {
												return {vx: u.vx, Bl: u.Bl};
											},
											fiche.sb),
										fm: b.sa
									})
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('deux')
								]),
							bornes),
							decimales
						]);
				case 1:
					return _List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Champ$View$caseACocher,
							{
								go: $elm$core$Maybe$Nothing,
								Aq: prefixe + '-mise-en-forme',
								Bl: $author$project$I18n$Cles$bibliothequeDefinitionMiseEnFormeCase(i18n),
								he: false
							},
							{vt: b.CE, D9: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DefinitionMiseEnForme}),
							note(
							$author$project$I18n$Cles$bibliothequeDefinitionMiseEnFormeNote(i18n))
						]);
				case 7:
					return _List_fromArray(
						[
							A2(
							$author$project$Components$Parametrage$BibliothequeDeChamps$OptionsView$plusieursChoix,
							i18n,
							{Dj: prefixe + '-plusieurs-choix', Ea: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DefinitionPlusieursChoix, FS: b.FS})
						]);
				case 6:
					return _List_Nil;
				default:
					return _List_Nil;
			}
		}();
		return _Utils_eq(contenu, _List_Nil) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$bibliothequeDefinitionOptionsTitre,
								i18n,
								{
									JR: A2($author$project$Components$Parametrage$Vocabulaire$typeDeChampDeLaBibliotheque, i18n, fiche.JR)
								}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('bloc')
						]),
					contenu)
				]));
	});
var $author$project$I18n$Cles$bibliothequeDefinitionPartageDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.partage-detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w)),
					_Utils_Tuple2(
					'types',
					$author$project$I18n$Traductions$Chaine(p.ib))
				]),
			'Cette définition s\'applique aux ' + (p.w + (' types qui utilisent le champ : ' + (p.ib + '.'))));
	});
var $author$project$I18n$Cles$bibliothequeDefinitionPartageTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.partage-titre', _List_Nil, 'Champ partagé');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$partageAnnonce = F2(
	function (i18n, fiche) {
		return $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$partage(fiche) ? A2(
			$author$project$Components$Shared$Note$View$view,
			1,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$bibliothequeDefinitionPartageTitre(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$bibliothequeDefinitionPartageDetail,
								i18n,
								{
									w: $elm$core$String$fromInt(
										$elm$core$List$length(fiche.JY)),
									ib: A2(
										$elm$core$String$join,
										', ',
										A2(
											$elm$core$List$map,
											function ($) {
												return $.Dj;
											},
											fiche.JY))
								}))
						]))
				])) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$contenuDeLaSaisie = F6(
	function (i18n, prefixe, listes, types, fiche, definition) {
		var saisie = F2(
			function (option, valeur) {
				return {
					hg: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DefinitionSaisie(option),
					fm: valeur
				};
			});
		var champ = F3(
			function (suffixe, libelle, obligatoire) {
				return {go: $elm$core$Maybe$Nothing, Aq: prefixe + ('-' + suffixe), Bl: libelle, he: obligatoire};
			});
		var b = definition.uw;
		return _List_fromArray(
			[
				A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$refus, i18n, definition.pZ),
				A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$issueDuGroupe, i18n, definition.AX),
				A2(
				$author$project$Components$Shared$Champ$View$texte,
				A3(
					champ,
					'nom',
					A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$libelleDuNom, i18n, fiche),
					true),
				A2(saisie, 0, b.Dj)),
				A2(
				$rtfeldman$elm_css$Html$Styled$fieldset,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$legend,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$bibliothequeDefinitionGenre(i18n))
									]))
							])),
						$author$project$Components$Shared$Segment$View$view(
						{
							vd: $author$project$Components$Shared$GenreDuNom$code(b.M),
							Bi: $author$project$I18n$Cles$bibliothequeDefinitionGenre(i18n),
							Dj: prefixe + '-genre',
							Ea: function (code) {
								return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$DefinitionSaisie, 2, code);
							},
							o_: _List_fromArray(
								[
									{
									vx: $author$project$Components$Shared$GenreDuNom$code(0),
									Bl: $author$project$I18n$Cles$bibliothequeDefinitionGenreFeminin(i18n)
								},
									{
									vx: $author$project$Components$Shared$GenreDuNom$code(1),
									Bl: $author$project$I18n$Cles$bibliothequeDefinitionGenreMasculin(i18n)
								}
								])
						})
					])),
				A2(
				$author$project$Components$Shared$Champ$View$zoneDeTexte,
				A3(
					champ,
					'aide',
					$author$project$I18n$Cles$bibliothequeDefinitionAide(i18n),
					false),
				A2(saisie, 1, b.bp)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('deux')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Champ$View$texteEnLectureSeule,
								A3(
									champ,
									'cle',
									$author$project$I18n$Cles$bibliothequeDefinitionCle(i18n),
									false),
								{fm: fiche.dy}),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$bibliothequeDefinitionCleNote(i18n))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Champ$View$texteEnLectureSeule,
								A3(
									champ,
									'type',
									$author$project$I18n$Cles$bibliothequeDefinitionType(i18n),
									false),
								{
									fm: A2($author$project$Components$Parametrage$Vocabulaire$typeDeChampDeLaBibliotheque, i18n, fiche.JR)
								}),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$bibliothequeDefinitionTypeNote(i18n))
									]))
							]))
					])),
				A4($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$optionsDuType, i18n, prefixe, fiche, definition),
				A6($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$optionsDuGroupe, i18n, prefixe, listes, types, fiche, definition),
				A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$apercu, i18n, definition.me),
				A3($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$annonceDeLaConversion, i18n, fiche, definition),
				A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$ligneDesTraductions, i18n, fiche),
				A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$partageAnnonce, i18n, fiche)
			]);
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$drawerVide = F4(
	function (i18n, versLeDrawer, msg, drawerModel) {
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			versLeDrawer,
			{
				fs: {sR: false, Bl: '', C$: msg},
				fZ: _List_Nil,
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: ''
			},
			drawerModel);
	});
var $author$project$I18n$Cles$bibliothequeDefinitionDroit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.droit', _List_Nil, 'Droit requis : Paramétrage du catalogue');
};
var $author$project$I18n$Cles$bibliothequeDefinitionDroitLesDeux = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.droit-les-deux', _List_Nil, 'Droits requis : Paramétrage du catalogue et Paramétrage des parties prenantes');
};
var $author$project$I18n$Cles$bibliothequeDefinitionDroitPartiesPrenantes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.droit-parties-prenantes', _List_Nil, 'Droit requis : Paramétrage des parties prenantes');
};
var $author$project$Components$Parametrage$Vocabulaire$droitDeLaDefinition = F2(
	function (i18n, portee) {
		switch (portee) {
			case 'parties-prenantes':
				return $author$project$I18n$Cles$bibliothequeDefinitionDroitPartiesPrenantes(i18n);
			case 'catalogue-et-parties-prenantes':
				return $author$project$I18n$Cles$bibliothequeDefinitionDroitLesDeux(i18n);
			default:
				return $author$project$I18n$Cles$bibliothequeDefinitionDroit(i18n);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$drawerDeLaDefinition = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.zo, model.wZ);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var fiche = _v0.a.a;
			var definition = _v0.b.a;
			var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.dO);
			var laConversion = function () {
				var _v8 = definition.me;
				switch (_v8.$) {
					case 4:
						var conversion = _v8.a;
						return $elm$core$Maybe$Just(conversion);
					case 5:
						var conversion = _v8.a;
						return $elm$core$Maybe$Just(conversion);
					default:
						return $elm$core$Maybe$Nothing;
				}
			}();
			var impossible = function () {
				var _v7 = definition.me;
				if (_v7.$ === 5) {
					return true;
				} else {
					return false;
				}
			}();
			var enCours = $author$project$API$Envoi$enCours(model.l2);
			var convertit = A2($author$project$Components$Parametrage$BibliothequeDeChamps$Definition$uniteChange, fiche, definition.uw);
			var libelleAction = function () {
				var _v6 = definition.me;
				switch (_v6.$) {
					case 3:
						return A2(
							$author$project$I18n$Cles$bibliothequeDefinitionConfirmerAppliquer,
							i18n,
							{
								w: $elm$core$String$fromInt(
									$elm$core$List$length(fiche.JY))
							});
					case 4:
						var conversion = _v6.a;
						return A2(
							$author$project$I18n$Cles$bibliothequeDefinitionConversionConvertir,
							i18n,
							{w: conversion.Ki});
					case 5:
						return $author$project$I18n$Cles$bibliothequeDefinitionImpossibleChoisir(i18n);
					case 2:
						return $author$project$I18n$Cles$bibliothequeDefinitionEnregistrerQuandMeme(i18n);
					default:
						return convertit ? $author$project$I18n$Cles$bibliothequeDefinitionConversionContinuer(i18n) : ($author$project$Components$Parametrage$BibliothequeDeChamps$Definition$partage(fiche) ? $author$project$I18n$Cles$bibliothequeDefinitionEnregistrerConfirmer(i18n) : $author$project$I18n$Cles$bibliothequeDefinitionEnregistrer(i18n));
				}
			}();
			var note = function () {
				var _v5 = definition.me;
				switch (_v5.$) {
					case 4:
						return $author$project$I18n$Cles$bibliothequeDefinitionConversionPiedImmediat(i18n);
					case 0:
						return convertit ? $author$project$I18n$Cles$bibliothequeDefinitionConversionPied(i18n) : A2($author$project$Components$Parametrage$Vocabulaire$droitDeLaDefinition, i18n, fiche.F$);
					default:
						return A2($author$project$Components$Parametrage$Vocabulaire$droitDeLaDefinition, i18n, fiche.F$);
				}
			}();
			var confirmation = _Utils_eq(definition.me, $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$Confirmation);
			var pied = {
				oJ: $elm$core$Maybe$Just(note),
				HF: function (attributs) {
					return A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_Utils_ap(
							attributs,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDeLaDefinition($author$project$Components$Shared$Drawer$Update$Fermer))
								])),
						impossible ? $author$project$I18n$Cles$drawerFermer(i18n) : $author$project$I18n$Cles$drawerAnnuler(i18n));
				},
				Jb: confirmation ? _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$BibliothequeDeChamps$Update$RetourALaDefinition)
							]),
						$author$project$I18n$Cles$bibliothequeDefinitionConfirmerRetour(i18n))
					]) : _List_Nil
			};
			var sousTitre = function () {
				if (!laConversion.$) {
					var conversion = laConversion.a;
					return A2(
						$author$project$I18n$Cles$bibliothequeDefinitionConversionSousTitre,
						i18n,
						{
							Dj: fiche.Dj,
							o4: A2($author$project$Components$Parametrage$BibliothequeDeChamps$Definition$libelleDeLUnite, fiche, conversion.wC),
							sn: A2($author$project$Components$Parametrage$BibliothequeDeChamps$Definition$libelleDeLUnite, fiche, conversion.sn)
						});
				} else {
					return confirmation ? A2(
						$author$project$I18n$Cles$bibliothequeDefinitionConfirmerSousTitre,
						i18n,
						{
							w: $elm$core$String$fromInt(
								$elm$core$List$length(fiche.JY))
						}) : A2(
						$author$project$I18n$Cles$bibliothequeDefinitionDrawerSousTitre,
						i18n,
						{
							Dj: fiche.Dj,
							JR: A2($author$project$Components$Parametrage$Vocabulaire$typeDeChampDeLaBibliotheque, i18n, fiche.JR)
						});
				}
			}();
			var active = (!enCours) && function () {
				var _v3 = definition.me;
				switch (_v3.$) {
					case 3:
						return definition.v2;
					case 4:
						return definition.v2;
					case 5:
						return true;
					default:
						return (!_Utils_eq(definition.me, $author$project$Components$Parametrage$BibliothequeDeChamps$Definition$ApercuDemande)) && A2($author$project$Components$Parametrage$BibliothequeDeChamps$Definition$enregistrable, fiche, definition.uw);
				}
			}();
			return A6(
				$author$project$Components$Shared$Drawer$View$viewAvecPiedLibreEtSousTitre,
				i18n,
				sousTitre,
				pied,
				$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDeLaDefinition,
				{
					fs: {sR: active, Bl: libelleAction, C$: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DefinitionEnregistree},
					fZ: function () {
						var _v1 = definition.me;
						switch (_v1.$) {
							case 3:
								return A4($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$contenuDeLaConfirmation, i18n, prefixe, fiche, definition);
							case 4:
								var conversion = _v1.a;
								return A5($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$contenuDeLaConversion, i18n, prefixe, fiche, definition, conversion);
							case 5:
								var conversion = _v1.a;
								return A4($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$contenuDeLImpossibilite, i18n, definition, conversion, fiche);
							default:
								return A6($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$contenuDeLaSaisie, i18n, prefixe, model.n_, model.ib, fiche, definition);
						}
					}(),
					A6: $elm$core$Maybe$Nothing,
					Bc: false,
					h6: function () {
						var _v2 = definition.me;
						switch (_v2.$) {
							case 4:
								return $author$project$I18n$Cles$bibliothequeDefinitionConversionTitre(i18n);
							case 5:
								return $author$project$I18n$Cles$bibliothequeDefinitionImpossibleTitre(i18n);
							default:
								return confirmation ? $author$project$I18n$Cles$bibliothequeDefinitionConfirmerTitre(i18n) : $author$project$I18n$Cles$bibliothequeDefinitionModifier(i18n);
						}
					}()
				},
				model.dO);
		} else {
			return A4($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$drawerVide, i18n, $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDeLaDefinition, $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DefinitionEnregistree, model.dO);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$TraductionsEnregistrees = {$: 37};
var $author$project$I18n$Cles$bibliothequeDefinitionTraductionEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.traduction-enregistrer', _List_Nil, 'Enregistrer les traductions');
};
var $author$project$I18n$Cles$bibliothequeDefinitionTraductionPied = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.traduction-pied', _List_Nil, 'Le français se modifie dans la définition');
};
var $author$project$I18n$Cles$bibliothequeDefinitionTraductionSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.definition.traduction-sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Champ « ' + (p.Dj + ' »'));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$AideTraduite = F2(
	function (a, b) {
		return {$: 36, a: a, b: b};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$LibelleTraduit = F2(
	function (a, b) {
		return {$: 35, a: a, b: b};
	});
var $author$project$I18n$Cles$bibliothequeDefinitionTraductionLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.traduction-libelle', _List_Nil, 'Libellé');
};
var $author$project$I18n$Cles$bibliothequeDefinitionTraductionManquante = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.traduction-manquante', _List_Nil, 'non traduit');
};
var $author$project$I18n$Cles$bibliothequeDefinitionTraductionTraduit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.traduction-traduit', _List_Nil, 'traduit');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$enTeteDeLaLangue = F3(
	function (i18n, langue, etat) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('entete-de-langue')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Parametrage$Vocabulaire$nomDeLaLangue, i18n, langue))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('iso')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$toUpper(langue))
						])),
					etat
				]));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$blocDeLaLangue = F5(
	function (i18n, prefixe, fiche, traduction, langue) {
		var traduite = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (t) {
					return (t.Bl !== '') || (t.bp !== '');
				},
				A2($elm$core$Dict$get, langue, fiche.JL)));
		var saisie = A2(
			$elm$core$Maybe$withDefault,
			{bp: '', Bl: ''},
			A2($elm$core$Dict$get, langue, traduction.c7));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('langue')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$enTeteDeLaLangue,
					i18n,
					langue,
					traduite ? A2(
						$author$project$Components$Shared$Tag$View$view,
						0,
						$author$project$I18n$Cles$bibliothequeDefinitionTraductionTraduit(i18n)) : A2(
						$author$project$Components$Shared$Tag$View$view,
						1,
						$author$project$I18n$Cles$bibliothequeDefinitionTraductionManquante(i18n))),
					A2(
					$author$project$Components$Shared$Champ$View$texte,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: prefixe + ('-' + (langue + '-libelle')),
						Bl: $author$project$I18n$Cles$bibliothequeDefinitionTraductionLibelle(i18n),
						he: false
					},
					{
						hg: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$LibelleTraduit(langue),
						fm: saisie.Bl
					}),
					A2(
					$author$project$Components$Shared$Champ$View$zoneDeTexte,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: prefixe + ('-' + (langue + '-aide')),
						Bl: $author$project$I18n$Cles$bibliothequeDefinitionAide(i18n),
						he: false
					},
					{
						hg: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$AideTraduite(langue),
						fm: saisie.bp
					})
				]));
	});
var $author$project$I18n$Cles$bibliothequeDefinitionTraductionDefaut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.definition.traduction-defaut', _List_Nil, 'langue par défaut');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$blocDeLaLangueParDefaut = F3(
	function (i18n, prefixe, fiche) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('langue')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$enTeteDeLaLangue,
					i18n,
					fiche.A9,
					A2(
						$author$project$Components$Shared$Tag$View$view,
						5,
						$author$project$I18n$Cles$bibliothequeDefinitionTraductionDefaut(i18n))),
					A2(
					$author$project$Components$Shared$Champ$View$texteEnLectureSeule,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: prefixe + '-defaut-libelle',
						Bl: $author$project$I18n$Cles$bibliothequeDefinitionTraductionLibelle(i18n),
						he: false
					},
					{fm: fiche.Dj}),
					A2(
					$author$project$Components$Shared$Champ$View$texteEnLectureSeule,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: prefixe + '-defaut-aide',
						Bl: $author$project$I18n$Cles$bibliothequeDefinitionAide(i18n),
						he: false
					},
					{fm: fiche.bp})
				]));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$drawerDeLaTraduction = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.zo, model.JK);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var fiche = _v0.a.a;
			var traduction = _v0.b.a;
			var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.dR);
			var pied = {
				oJ: $elm$core$Maybe$Just(
					$author$project$I18n$Cles$bibliothequeDefinitionTraductionPied(i18n)),
				HF: function (attributs) {
					return A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_Utils_ap(
							attributs,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDeLaTraduction($author$project$Components$Shared$Drawer$Update$Fermer))
								])),
						$author$project$I18n$Cles$drawerAnnuler(i18n));
				},
				Jb: _List_Nil
			};
			return A6(
				$author$project$Components$Shared$Drawer$View$viewAvecPiedLibreEtSousTitre,
				i18n,
				A2(
					$author$project$I18n$Cles$bibliothequeDefinitionTraductionSousTitre,
					i18n,
					{Dj: fiche.Dj}),
				pied,
				$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDeLaTraduction,
				{
					fs: {
						sR: (!$author$project$API$Envoi$enCours(model.l2)) && (!_Utils_eq(
							A2($author$project$Components$Parametrage$BibliothequeDeChamps$Definition$commandesDeTraduction, fiche, traduction),
							_List_Nil)),
						Bl: $author$project$I18n$Cles$bibliothequeDefinitionTraductionEnregistrer(i18n),
						C$: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$TraductionsEnregistrees
					},
					fZ: A2(
						$elm$core$List$cons,
						A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$refus, i18n, traduction.pZ),
						A2(
							$elm$core$List$cons,
							A3($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$blocDeLaLangueParDefaut, i18n, prefixe, fiche),
							A2(
								$elm$core$List$map,
								A4($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$blocDeLaLangue, i18n, prefixe, fiche, traduction),
								$elm$core$Dict$keys(traduction.c7)))),
					A6: $elm$core$Maybe$Nothing,
					Bc: false,
					h6: $author$project$I18n$Cles$bibliothequeDefinitionTraduire(i18n)
				},
				model.dR);
		} else {
			return A4($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$drawerVide, i18n, $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDeLaTraduction, $author$project$Components$Parametrage$BibliothequeDeChamps$Update$TraductionsEnregistrees, model.dR);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$CalculEnregistre = {$: 51};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$FormuleSaisie = function (a) {
	return {$: 48, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$NatureChoisie = function (a) {
	return {$: 50, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$RecalculChoisi = function (a) {
	return {$: 49, a: a};
};
var $author$project$I18n$Cles$bibliothequeCalculApercu = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.calcul.apercu',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'code',
					$author$project$I18n$Traductions$Chaine(p.vx))
				]),
			'Aperçu sur la référence ' + p.vx);
	});
var $author$project$I18n$Cles$bibliothequeCalculApercuSource = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.calcul.apercu-source',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			p.Dj + (' ' + p.fm));
	});
var $author$project$I18n$Cles$bibliothequeCalculApercuValeur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.calcul.apercu-valeur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			p.Dj + (' → ' + p.fm));
	});
var $author$project$I18n$Cles$bibliothequeCalculApercuVide = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.calcul.apercu-vide',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.Dj + ' : aucune valeur calculée sur cette fiche');
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$nombreDit = F2(
	function (i18n, dite) {
		var _v0 = $elm$core$String$toFloat(dite);
		if (!_v0.$) {
			var nombre = _v0.a;
			return A3(
				$author$project$I18n$Nombre$formaterFlottant,
				$author$project$I18n$Traductions$langue(i18n),
				function () {
					var _v1 = A2($elm$core$String$split, '.', dite);
					if ((_v1.b && _v1.b.b) && (!_v1.b.b.b)) {
						var _v2 = _v1.b;
						var fraction = _v2.a;
						return $elm$core$String$length(fraction);
					} else {
						return 0;
					}
				}(),
				nombre);
		} else {
			return dite;
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$resultatDit = F3(
	function (i18n, fiche, dite) {
		var _v0 = _Utils_Tuple2(
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.Cu;
				},
				fiche.uB),
			$elm$core$String$toFloat(dite));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var mesure = _v0.a.a;
			var nombre = _v0.b.a;
			var symbole = A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$symboleDeLUnite, fiche, mesure.sa);
			return ((nombre > 0) ? '+' : '') + (A3(
				$author$project$I18n$Nombre$formaterFlottant,
				$author$project$I18n$Traductions$langue(i18n),
				mesure.kv,
				nombre) + ('\u00A0' + symbole));
		} else {
			return A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$nombreDit, i18n, dite);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$apercuDuCalcul = F2(
	function (i18n, fiche) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.yY;
			},
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.tq;
				},
				fiche.uB));
		if (!_v0.$) {
			var exemple = _v0.a;
			var lues = A2(
				$elm$core$String$join,
				' · ',
				A2(
					$elm$core$List$filterMap,
					function (_v2) {
						var cle = _v2.a;
						var nom = _v2.b;
						return A2(
							$elm$core$Maybe$map,
							function (_v4) {
								var dite = _v4.b;
								return A2(
									$author$project$I18n$Cles$bibliothequeCalculApercuSource,
									i18n,
									{
										Dj: nom,
										fm: A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$nombreDit, i18n, dite)
									});
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (_v3) {
										var autre = _v3.a;
										return _Utils_eq(autre, cle);
									},
									exemple.IT)));
					},
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.BY;
							},
							fiche.uB))));
			var avantLaFleche = (lues === '') ? fiche.Dj : lues;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu-du-calcul')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$bibliothequeCalculApercu,
									i18n,
									{vx: exemple.vx}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								function () {
									var _v1 = exemple.fm;
									if (!_v1.$) {
										var dite = _v1.a;
										return A2(
											$author$project$I18n$Cles$bibliothequeCalculApercuValeur,
											i18n,
											{
												Dj: avantLaFleche,
												fm: A3($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$resultatDit, i18n, fiche, dite)
											});
									} else {
										return A2(
											$author$project$I18n$Cles$bibliothequeCalculApercuVide,
											i18n,
											{Dj: fiche.Dj});
									}
								}())
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$bibliothequeCalculDrawerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.drawer-titre', _List_Nil, 'Régler le calcul');
};
var $author$project$I18n$Cles$bibliothequeCalculEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$bibliothequeCalculNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.note', _List_Nil, 'Jugée à l\'enregistrement : champs connus, types compatibles, pas de boucle, valeurs de la liste. Aucune fiche n\'est recalculée seule.');
};
var $author$project$I18n$Cles$bibliothequeCalculSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.calcul.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.Dj + ' · bibliothèque de champs');
	});
var $author$project$Components$Shared$ChoixEnListe$View$uneOption = F2(
	function (config, option) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('etage'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					_Utils_eq(option.vx, config.vd) ? 'on' : '')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
							$rtfeldman$elm_css$Html$Styled$Attributes$name(config.Dj),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(option.vx),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(
							_Utils_eq(option.vx, config.vd)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							config.Ea(option.vx))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(option.Bl)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aide-etage')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(option.bp)
								]))
						])),
					function () {
					var _v0 = option.yS;
					if (!_v0.$) {
						var texte = _v0.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('etiquette'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('choisi')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(texte)
								]));
					} else {
						return $rtfeldman$elm_css$Html$Styled$text('');
					}
				}()
				]));
	});
var $author$project$Components$Shared$ChoixEnListe$View$viewEtiquete = function (config) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('niveau-de-saisie'),
				$rtfeldman$elm_css$Html$Styled$Attributes$class('libre')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('etages'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'radiogroup'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', config.Bi)
					]),
				A2(
					$elm$core$List$map,
					$author$project$Components$Shared$ChoixEnListe$View$uneOption(config),
					config.o_))
			]));
};
var $author$project$Components$Shared$ChoixEnListe$View$view = function (config) {
	return $author$project$Components$Shared$ChoixEnListe$View$viewEtiquete(
		{
			vd: config.vd,
			Bi: config.Bi,
			Dj: config.Dj,
			Ea: config.Ea,
			o_: A2(
				$elm$core$List$map,
				function (o) {
					return {bp: o.bp, vx: o.vx, yS: $elm$core$Maybe$Nothing, Bl: o.Bl};
				},
				config.o_)
		});
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$OptionsView$choixDuCalcul = F2(
	function (libelle, config) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$fieldset,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$legend,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(libelle)
								]))
						])),
					$author$project$Components$Shared$ChoixEnListe$View$view(
					{vd: config.vd, Bi: libelle, Dj: config.Dj, Ea: config.Ea, o_: config.o_})
				]));
	});
var $author$project$I18n$Cles$bibliothequeCalculReferences = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.calcul.references',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' référence porte ce champ') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' références portent ce champ'));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$notePiedDuCalcul = F2(
	function (i18n, fiche) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.tq;
			},
			fiche.uB);
		if (!_v0.$) {
			var sur = _v0.a;
			return A2(
				$author$project$I18n$Cles$bibliothequeCalculReferences,
				i18n,
				{d: sur.hD});
		} else {
			return $author$project$I18n$Cles$bibliothequeCalculNote(i18n);
		}
	});
var $author$project$I18n$Cles$bibliothequeCalculAideFige = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.aide-fige', _List_Nil, 'calculé une fois, à la première écriture');
};
var $author$project$I18n$Cles$bibliothequeCalculAideSurChangement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.aide-sur-changement', _List_Nil, 'dès qu\'une source change');
};
var $author$project$I18n$Cles$bibliothequeCalculAideSurDemande = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.aide-sur-demande', _List_Nil, 'jamais seul ; « Recalculer » sur la fiche');
};
var $author$project$I18n$Cles$bibliothequeCalculCourtFige = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.court-fige', _List_Nil, 'Figé');
};
var $author$project$I18n$Cles$bibliothequeCalculCourtSurChangement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.court-sur-changement', _List_Nil, 'Sur changement');
};
var $author$project$I18n$Cles$bibliothequeCalculCourtSurDemande = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.court-sur-demande', _List_Nil, 'Sur demande');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$OptionsView$recalculs = function (i18n) {
	return _List_fromArray(
		[
			{
			bp: $author$project$I18n$Cles$bibliothequeCalculAideFige(i18n),
			vx: 'fige',
			Bl: $author$project$I18n$Cles$bibliothequeCalculCourtFige(i18n)
		},
			{
			bp: $author$project$I18n$Cles$bibliothequeCalculAideSurChangement(i18n),
			vx: 'sur-changement',
			Bl: $author$project$I18n$Cles$bibliothequeCalculCourtSurChangement(i18n)
		},
			{
			bp: $author$project$I18n$Cles$bibliothequeCalculAideSurDemande(i18n),
			vx: 'sur-demande',
			Bl: $author$project$I18n$Cles$bibliothequeCalculCourtSurDemande(i18n)
		}
		]);
};
var $author$project$I18n$Cles$bibliothequeCalculAideImposee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.aide-imposee', _List_Nil, 'non modifiable');
};
var $author$project$I18n$Cles$bibliothequeCalculAideProposee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.aide-proposee', _List_Nil, 'prérempli, modifiable, ne bloque jamais la création');
};
var $author$project$I18n$Cles$bibliothequeCalculCourtImposee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.court-imposee', _List_Nil, 'Imposée');
};
var $author$project$I18n$Cles$bibliothequeCalculCourtProposee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.court-proposee', _List_Nil, 'Proposée');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$OptionsView$valeurs = function (i18n) {
	return _List_fromArray(
		[
			{
			bp: $author$project$I18n$Cles$bibliothequeCalculAideProposee(i18n),
			vx: 'proposee',
			Bl: $author$project$I18n$Cles$bibliothequeCalculCourtProposee(i18n)
		},
			{
			bp: $author$project$I18n$Cles$bibliothequeCalculAideImposee(i18n),
			vx: 'imposee',
			Bl: $author$project$I18n$Cles$bibliothequeCalculCourtImposee(i18n)
		}
		]);
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$drawerDuCalcul = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.zo, model.uB);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var fiche = _v0.a.a;
			var reglage = _v0.b.a;
			var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.dJ);
			return A6(
				$author$project$Components$Shared$Drawer$View$viewAvecPiedLibreEtSousTitre,
				i18n,
				A2(
					$author$project$I18n$Cles$bibliothequeCalculSousTitre,
					i18n,
					{Dj: fiche.Dj}),
				{
					oJ: $elm$core$Maybe$Just(
						A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$notePiedDuCalcul, i18n, fiche)),
					HF: function (attributs) {
						return A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_Utils_ap(
								attributs,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDuCalcul($author$project$Components$Shared$Drawer$Update$Fermer))
									])),
							$author$project$I18n$Cles$drawerAnnuler(i18n));
					},
					Jb: _List_Nil
				},
				$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDuCalcul,
				{
					fs: {
						sR: (!$author$project$API$Envoi$enCours(model.l2)) && (!_Utils_eq(
							A2($author$project$Components$Parametrage$BibliothequeDeChamps$Calcul$commande, fiche, reglage),
							$elm$core$Maybe$Nothing)),
						Bl: $author$project$I18n$Cles$bibliothequeCalculEnregistrer(i18n),
						C$: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$CalculEnregistre
					},
					fZ: _List_fromArray(
						[
							A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$refus, i18n, reglage.pZ),
							A2(
							$author$project$Components$Shared$Champ$View$zoneDeTexte,
							{
								go: $elm$core$Maybe$Nothing,
								Aq: prefixe + '-formule',
								Bl: $author$project$I18n$Cles$bibliothequeCalculFormule(i18n),
								he: true
							},
							{hg: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$FormuleSaisie, fm: reglage.zU}),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$bibliothequeCalculNote(i18n))
								])),
							A2(
							$author$project$Components$Parametrage$BibliothequeDeChamps$OptionsView$choixDuCalcul,
							$author$project$I18n$Cles$bibliothequeCalculRecalcul(i18n),
							{
								vd: reglage.G$,
								Dj: prefixe + '-recalcul',
								Ea: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$RecalculChoisi,
								o_: $author$project$Components$Parametrage$BibliothequeDeChamps$OptionsView$recalculs(i18n)
							}),
							A2(
							$author$project$Components$Parametrage$BibliothequeDeChamps$OptionsView$choixDuCalcul,
							$author$project$I18n$Cles$bibliothequeCalculValeur(i18n),
							{
								vd: reglage.fm,
								Dj: prefixe + '-valeur',
								Ea: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$NatureChoisie,
								o_: $author$project$Components$Parametrage$BibliothequeDeChamps$OptionsView$valeurs(i18n)
							}),
							A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$apercuDuCalcul, i18n, fiche)
						]),
					A6: $elm$core$Maybe$Nothing,
					Bc: false,
					h6: $author$project$I18n$Cles$bibliothequeCalculDrawerTitre(i18n)
				},
				model.dJ);
		} else {
			return A4($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$drawerVide, i18n, $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDuCalcul, $author$project$Components$Parametrage$BibliothequeDeChamps$Update$CalculEnregistre, model.dJ);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDuLot = function (a) {
	return {$: 52, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$LotApplique = {$: 55};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$TypeDuLotChoisi = function (a) {
	return {$: 54, a: a};
};
var $author$project$I18n$Cles$bibliothequeCalculLotAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.lot.action', _List_Nil, 'Appliquer');
};
var $author$project$I18n$Cles$bibliothequeCalculLotConcernees = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.calcul.lot.concernees',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' référence concernée') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' références concernées'));
	});
var $author$project$I18n$Cles$bibliothequeCalculLotDebrayees = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.calcul.lot.debrayees',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' est déjà débrayée et ne bouge pas') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' sont déjà débrayées et ne bougent pas'));
	});
var $author$project$I18n$Cles$bibliothequeCalculLotIllisible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.lot.illisible', _List_Nil, 'Le nombre de références n\'a pas pu être lu.');
};
var $author$project$I18n$Cles$bibliothequeCalculLotNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.lot.note', _List_Nil, 'Les fiches figées sont recalculées, jamais les fiches débrayées. Rejouable : une fiche déjà à jour ne change pas.');
};
var $author$project$I18n$Textes$bibliothequeCalculLotRefus = A3($author$project$I18n$Traductions$texte, 'bibliotheque.calcul.lot.refus', _List_Nil, 'Le calcul n\'a pas pu être appliqué aux références de ce type.');
var $author$project$I18n$Cles$bibliothequeCalculLotSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.calcul.lot.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.Dj + ' · bibliothèque de champs');
	});
var $author$project$I18n$Cles$bibliothequeCalculLotTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.lot.titre', _List_Nil, 'Appliquer aux références existantes');
};
var $author$project$I18n$Cles$bibliothequeCalculLotType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.calcul.lot.type', _List_Nil, 'Type de produit');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$drawerDuLot = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.zo, model.n0);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var fiche = _v0.a.a;
			var lot = _v0.b.a;
			var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.dP);
			var choisi = $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (t) {
						return _Utils_eq(t.Aq, lot.vd);
					},
					lot.ib));
			return A6(
				$author$project$Components$Shared$Drawer$View$viewAvecPiedLibreEtSousTitre,
				i18n,
				A2(
					$author$project$I18n$Cles$bibliothequeCalculLotSousTitre,
					i18n,
					{Dj: fiche.Dj}),
				{
					oJ: $elm$core$Maybe$Nothing,
					HF: function (attributs) {
						return A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_Utils_ap(
								attributs,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDuLot($author$project$Components$Shared$Drawer$Update$Fermer))
									])),
							$author$project$I18n$Cles$drawerAnnuler(i18n));
					},
					Jb: _List_Nil
				},
				$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDuLot,
				{
					fs: {
						sR: (!$author$project$API$Envoi$enCours(model.l2)) && A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$map,
								function (a) {
									return (a.hD - a.wF) > 0;
								},
								A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.tq;
									},
									choisi))),
						Bl: $author$project$I18n$Cles$bibliothequeCalculLotAction(i18n),
						C$: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$LotApplique
					},
					fZ: _List_fromArray(
						[
							A2(
							$author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$refus,
							i18n,
							lot.pZ ? $elm$core$Maybe$Just($author$project$I18n$Textes$bibliothequeCalculLotRefus) : $elm$core$Maybe$Nothing),
							function () {
							var _v1 = lot.ib;
							if (_v1.b && (!_v1.b.b)) {
								var seul = _v1.a;
								var champ = {
									go: $elm$core$Maybe$Nothing,
									Aq: prefixe + '-type',
									Bl: $author$project$I18n$Cles$bibliothequeCalculLotType(i18n),
									he: false
								};
								return A2(
									$author$project$Components$Shared$Champ$View$compose,
									champ,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$input,
											A2(
												$elm$core$List$cons,
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
												A2(
													$elm$core$List$cons,
													$rtfeldman$elm_css$Html$Styled$Attributes$value(seul.Dj),
													A2(
														$elm$core$List$cons,
														$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true),
														$author$project$Components$Shared$Champ$View$attributs(champ)))),
											_List_Nil)
										]));
							} else {
								return A2(
									$author$project$Components$Parametrage$BibliothequeDeChamps$OptionsView$choixDuCalcul,
									$author$project$I18n$Cles$bibliothequeCalculLotType(i18n),
									{
										vd: lot.vd,
										Dj: prefixe + '-type',
										Ea: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$TypeDuLotChoisi,
										o_: A2(
											$elm$core$List$map,
											function (t) {
												return {bp: '', vx: t.Aq, Bl: t.Dj};
											},
											lot.ib)
									});
							}
						}(),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu-du-lot')
								]),
							function () {
								if (!choisi.$) {
									var type_ = choisi.a;
									var _v3 = type_.tq;
									if (!_v3.$) {
										var comptes = _v3.a;
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$strong,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2(
															$author$project$I18n$Cles$bibliothequeCalculLotConcernees,
															i18n,
															{d: comptes.hD - comptes.wF}))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2(
															$author$project$I18n$Cles$bibliothequeCalculLotDebrayees,
															i18n,
															{d: comptes.wF}))
													]))
											]);
									} else {
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														type_.Ax ? $author$project$I18n$Cles$bibliothequeCalculLotIllisible(i18n) : '')
													]))
											]);
									}
								} else {
									return _List_Nil;
								}
							}()),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$bibliothequeCalculLotNote(i18n))
								]))
						]),
					A6: $elm$core$Maybe$Nothing,
					Bc: false,
					h6: $author$project$I18n$Cles$bibliothequeCalculLotTitre(i18n)
				},
				model.dP);
		} else {
			return A4($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$drawerVide, i18n, $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDuLot, $author$project$Components$Parametrage$BibliothequeDeChamps$Update$LotApplique, model.dP);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ExigenceDuRattachement = function (a) {
	return {$: 41, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$LectureDuRattachement = function (a) {
	return {$: 42, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$MasqueDuRattachement = function (a) {
	return {$: 43, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$PersonnelleDuRattachement = function (a) {
	return {$: 44, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$RattachementEnregistre = {$: 45};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$RessourceChoisie = function (a) {
	return {$: 40, a: a};
};
var $author$project$I18n$Cles$bibliothequeRattachementAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.rattachement.action', _List_Nil, 'Rattacher');
};
var $author$project$I18n$Cles$bibliothequeRattachementActionA = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.rattachement.action-a',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Rattacher à ' + p.Dj);
	});
var $author$project$I18n$Cles$bibliothequeRattachementChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.rattachement.choisir', _List_Nil, 'Choisir une ressource');
};
var $author$project$I18n$Cles$bibliothequeRattachementDomaineCatalogue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.rattachement.domaine-catalogue', _List_Nil, 'type de produit');
};
var $author$project$I18n$Cles$bibliothequeRattachementDomainePartiesPrenantes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.rattachement.domaine-parties-prenantes', _List_Nil, 'type de partie prenante');
};
var $author$project$I18n$Cles$bibliothequeRattachementOption = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.rattachement.option',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'domaine',
					$author$project$I18n$Traductions$Chaine(p.cC))
				]),
			p.Dj + (' · ' + p.cC));
	});
var $author$project$I18n$Cles$bibliothequeRattachementRessource = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.rattachement.ressource', _List_Nil, 'Ressource');
};
var $author$project$I18n$Cles$bibliothequeRattachementSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.rattachement.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'typeDeChamp',
					$author$project$I18n$Traductions$Chaine(p.JR))
				]),
			'Champ « ' + (p.Dj + (' » · ' + p.JR)));
	});
var $author$project$I18n$Cles$bibliothequeRattachementTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.rattachement.titre', _List_Nil, 'Rattacher à une ressource');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionDonneePersonnelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.donnee-personnelle', _List_Nil, 'Donnée personnelle');
};
var $author$project$I18n$Cles$reglagesDuChampExigenceALEnregistrement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'reglages-du-champ.exigence.a-l-enregistrement', _List_Nil, 'Obligatoire à l\'enregistrement');
};
var $author$project$I18n$Cles$reglagesDuChampExigenceALaPublication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'reglages-du-champ.exigence.a-la-publication', _List_Nil, 'Obligatoire à la publication');
};
var $author$project$I18n$Cles$reglagesDuChampExigenceFacultative = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'reglages-du-champ.exigence.facultative', _List_Nil, 'Facultatif');
};
var $author$project$Components$Shared$Bibliotheque$Vocabulaire$exigenceDuReglage = F2(
	function (i18n, code) {
		switch (code) {
			case 'a-l-enregistrement':
				return $author$project$I18n$Cles$reglagesDuChampExigenceALEnregistrement(i18n);
			case 'a-la-publication':
				return $author$project$I18n$Cles$reglagesDuChampExigenceALaPublication(i18n);
			default:
				return $author$project$I18n$Cles$reglagesDuChampExigenceFacultative(i18n);
		}
	});
var $author$project$Components$Shared$Bibliotheque$View$exigences = _List_fromArray(
	[$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceFacultative, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceALEnregistrement, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceALaPublication]);
var $author$project$I18n$Cles$produitsTypesAjoutExigence = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.ajout.exigence', _List_Nil, 'Exigence');
};
var $author$project$I18n$Cles$produitsTypesAjoutLecture = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.ajout.lecture', _List_Nil, 'Niveau de lecture');
};
var $author$project$I18n$Cles$produitsTypesAjoutLectureDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.ajout.lecture.detail', _List_Nil, 'Détail');
};
var $author$project$I18n$Cles$produitsTypesAjoutLectureEssentiel = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.ajout.lecture.essentiel', _List_Nil, 'Essentiel');
};
var $author$project$I18n$Cles$produitsTypesAjoutMasque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.ajout.masque', _List_Nil, 'Masqué');
};
var $author$project$I18n$Cles$produitsTypesAjoutMasqueNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.ajout.masque-note', _List_Nil, 'Le champ n\'apparaît plus sur les fiches de ce type.');
};
var $author$project$I18n$Cles$produitsTypesAjoutReglages = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.ajout.reglages', _List_Nil, 'Réglages pour ce type');
};
var $author$project$I18n$Cles$referentielTypesAjoutDonneePersonnelleNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.ajout.donnee-personnelle-note', _List_Nil, 'Réglage de ce rattachement.');
};
var $author$project$Components$Shared$Bibliotheque$View$reglageEnSegments = F6(
	function (prefixe, legende, suffixe, options, choisi, onChoisir) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(legende)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$fieldset,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('segments')
						]),
					_List_fromArray(
						[
							$author$project$Components$Shared$Segment$View$view(
							{vd: choisi, Bi: legende, Dj: prefixe + ('-' + suffixe), Ea: onChoisir, o_: options})
						]))
				]));
	});
var $author$project$Components$Shared$Bibliotheque$View$reglagesDuRattachement = F4(
	function (i18n, contexte, msgs, reglages) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('reglages-du-rattachement'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('masques', contexte.Cd)
						]))
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('overline')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsTypesAjoutReglages(i18n))
							])),
						A6(
						$author$project$Components$Shared$Bibliotheque$View$reglageEnSegments,
						contexte.pv,
						$author$project$I18n$Cles$produitsTypesAjoutExigence(i18n),
						'exigence',
						A2(
							$elm$core$List$map,
							function (code) {
								return {
									vx: code,
									Bl: A2($author$project$Components$Shared$Bibliotheque$Vocabulaire$exigenceDuReglage, i18n, code)
								};
							},
							$author$project$Components$Shared$Bibliotheque$View$exigences),
						reglages.mo,
						msgs.mo),
						A6(
						$author$project$Components$Shared$Bibliotheque$View$reglageEnSegments,
						contexte.pv,
						$author$project$I18n$Cles$produitsTypesAjoutLecture(i18n),
						'lecture',
						_List_fromArray(
							[
								{
								vx: 'essentiel',
								Bl: $author$project$I18n$Cles$produitsTypesAjoutLectureEssentiel(i18n)
							},
								{
								vx: 'detail',
								Bl: $author$project$I18n$Cles$produitsTypesAjoutLectureDetail(i18n)
							}
							]),
						reglages.g4,
						msgs.np),
						A2(
						$author$project$Components$Shared$Champ$View$caseACocher,
						{
							go: $elm$core$Maybe$Nothing,
							Aq: contexte.pv + '-masque',
							Bl: $author$project$I18n$Cles$produitsTypesAjoutMasque(i18n),
							he: false
						},
						{vt: reglages.n4, D9: msgs.n4}),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsTypesAjoutMasqueNote(i18n))
							]))
					]),
				function () {
					var _v0 = msgs.Ff;
					if (!_v0.$) {
						var personnelle = _v0.a;
						return _List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Champ$View$caseACocher,
								{
									go: $elm$core$Maybe$Nothing,
									Aq: contexte.pv + '-donnee-personnelle',
									Bl: $author$project$I18n$Cles$editeurDeSchemaOptionDonneePersonnelle(i18n),
									he: false
								},
								{vt: reglages.xD, D9: personnelle}),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielTypesAjoutDonneePersonnelleNote(i18n))
									]))
							]);
					} else {
						return _List_Nil;
					}
				}()));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$drawerDuRattachement = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.zo, model.pN);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var fiche = _v0.a.a;
			var rattachement = _v0.b.a;
			var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.dQ);
			var domaine = function (r) {
				return _Utils_eq(r.cC, $author$project$Components$Parametrage$BibliothequeDeChamps$Rattachement$domaineDeLaPartiePrenante) ? $author$project$I18n$Cles$bibliothequeRattachementDomainePartiesPrenantes(i18n) : $author$project$I18n$Cles$bibliothequeRattachementDomaineCatalogue(i18n);
			};
			var options = A2(
				$elm$core$List$cons,
				{
					Bl: $author$project$I18n$Cles$bibliothequeRattachementChoisir(i18n),
					fm: ''
				},
				A2(
					$elm$core$List$map,
					function (r) {
						return {
							Bl: A2(
								$author$project$I18n$Cles$bibliothequeRattachementOption,
								i18n,
								{
									cC: domaine(r),
									Dj: r.Dj
								}),
							fm: r.Aq
						};
					},
					fiche.HQ));
			var choisie = A2($author$project$Components$Parametrage$BibliothequeDeChamps$Rattachement$choisie, fiche, rattachement);
			var partiePrenante = A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (r) {
						return _Utils_eq(r.cC, $author$project$Components$Parametrage$BibliothequeDeChamps$Rattachement$domaineDeLaPartiePrenante);
					},
					choisie));
			return A6(
				$author$project$Components$Shared$Drawer$View$viewAvecPiedLibreEtSousTitre,
				i18n,
				A2(
					$author$project$I18n$Cles$bibliothequeRattachementSousTitre,
					i18n,
					{
						Dj: fiche.Dj,
						JR: A2($author$project$Components$Parametrage$Vocabulaire$typeDeChampDeLaBibliotheque, i18n, fiche.JR)
					}),
				{
					oJ: A2(
						$elm$core$Maybe$map,
						function (_v1) {
							return partiePrenante ? $author$project$I18n$Cles$bibliothequeDefinitionDroitPartiesPrenantes(i18n) : $author$project$I18n$Cles$bibliothequeDefinitionDroit(i18n);
						},
						choisie),
					HF: function (attributs) {
						return A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_Utils_ap(
								attributs,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDuRattachement($author$project$Components$Shared$Drawer$Update$Fermer))
									])),
							$author$project$I18n$Cles$drawerAnnuler(i18n));
					},
					Jb: _List_Nil
				},
				$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDuRattachement,
				{
					fs: {
						sR: (!_Utils_eq(choisie, $elm$core$Maybe$Nothing)) && (!$author$project$API$Envoi$enCours(model.l2)),
						Bl: A2(
							$elm$core$Maybe$withDefault,
							$author$project$I18n$Cles$bibliothequeRattachementAction(i18n),
							A2(
								$elm$core$Maybe$map,
								function (r) {
									return A2(
										$author$project$I18n$Cles$bibliothequeRattachementActionA,
										i18n,
										{Dj: r.Dj});
								},
								choisie)),
						C$: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$RattachementEnregistre
					},
					fZ: _List_fromArray(
						[
							A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$refus, i18n, rattachement.pZ),
							A2(
							$author$project$Components$Shared$Champ$View$liste,
							{
								go: $elm$core$Maybe$Nothing,
								Aq: prefixe + '-ressource',
								Bl: $author$project$I18n$Cles$bibliothequeRattachementRessource(i18n),
								he: true
							},
							{
								hg: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$RessourceChoisie,
								o_: options,
								fm: A2($elm$core$Maybe$withDefault, '', rattachement.HN)
							}),
							A4(
							$author$project$Components$Shared$Bibliotheque$View$reglagesDuRattachement,
							i18n,
							{Cd: false, pv: prefixe},
							{
								mo: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ExigenceDuRattachement,
								np: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$LectureDuRattachement,
								n4: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$MasqueDuRattachement,
								Ff: partiePrenante ? $elm$core$Maybe$Just($author$project$Components$Parametrage$BibliothequeDeChamps$Update$PersonnelleDuRattachement) : $elm$core$Maybe$Nothing
							},
							rattachement.qc)
						]),
					A6: $elm$core$Maybe$Nothing,
					Bc: false,
					h6: $author$project$I18n$Cles$bibliothequeRattachementTitre(i18n)
				},
				model.dQ);
		} else {
			return A4($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$drawerVide, i18n, $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDuRattachement, $author$project$Components$Parametrage$BibliothequeDeChamps$Update$RattachementEnregistre, model.dQ);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$dialogues = F2(
	function (i18n, model) {
		return _Utils_ap(
			_List_fromArray(
				[
					A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$drawerDeLaDefinition, i18n, model),
					A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$drawerDeLaTraduction, i18n, model),
					A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$drawerDuRattachement, i18n, model),
					A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$drawerDuCalcul, i18n, model),
					A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$drawerDuLot, i18n, model)
				]),
			A2($author$project$Components$Parametrage$BibliothequeDeChamps$RestrictionsView$dialogues, i18n, model));
	});
var $author$project$Components$Parametrage$NouveauChamp$Update$DeLaListe = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Update$ListeCreee = {$: 12};
var $author$project$I18n$Cles$bibliothequeListeAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.liste.action', _List_Nil, 'Créer la liste');
};
var $author$project$I18n$Cles$bibliothequeListeKickerPortee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.liste.kicker-portee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'portee',
					$author$project$I18n$Traductions$Chaine(p.F$))
				]),
			'Liste partagée · portée ' + p.F$);
	});
var $author$project$I18n$Cles$bibliothequeListePied = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.liste.pied', _List_Nil, 'Droit « Modifier » du module Produits');
};
var $author$project$I18n$Cles$bibliothequeListeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.liste.titre', _List_Nil, 'Créer une liste');
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$AutreNomVoulu = {$: 3};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$ListeExistanteVoulue = {$: 2};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$NomDeListeSaisi = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$ValeursDeListeSaisies = function (a) {
	return {$: 1, a: a};
};
var $author$project$I18n$Cles$bibliothequeListeAutreNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.liste.autre-nom', _List_Nil, 'Choisir un autre nom');
};
var $author$project$I18n$Cles$bibliothequeListeChoisirExistante = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.liste.choisir-existante', _List_Nil, 'Choisir la liste existante');
};
var $author$project$I18n$Cles$bibliothequeListeNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.liste.nom', _List_Nil, 'Nom de la liste');
};
var $author$project$I18n$Cles$bibliothequeListeNomPris = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.liste.nom-pris',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'La liste « ' + (p.Dj + ' » existe déjà.'));
	});
var $author$project$I18n$Cles$bibliothequeListePortee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.liste.portee', _List_Nil, 'Portée');
};
var $author$project$I18n$Cles$bibliothequeListePorteeAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.liste.portee-aide', _List_Nil, 'Étendue aux parties prenantes depuis Paramétrage › Listes.');
};
var $author$project$I18n$Cles$bibliothequeListeRefus = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.liste.refus', _List_Nil, 'La liste n\'est pas créée : le serveur la refuse.');
};
var $author$project$I18n$Cles$bibliothequeListeValeurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.liste.valeurs', _List_Nil, 'Valeurs');
};
var $author$project$I18n$Cles$bibliothequeListeValeursAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.liste.valeurs-aide', _List_Nil, 'Une valeur par ligne. L\'ordre, les attributs et les traductions se règlent ensuite dans Paramétrage › Listes.');
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$idDeLaPorteeDeListe = 'nouvelle-liste-portee';
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$idDesValeursDeListe = 'nouvelle-liste-valeurs';
var $author$project$I18n$Cles$listesPorteeCatalogue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.portee.catalogue', _List_Nil, 'Catalogue');
};
var $author$project$I18n$Cles$listesPorteeCatalogueEtPartiesPrenantes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.portee.catalogue-et-parties-prenantes', _List_Nil, 'Catalogue et parties prenantes');
};
var $author$project$I18n$Cles$listesPorteePartiesPrenantes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.portee.parties-prenantes', _List_Nil, 'Parties prenantes');
};
var $author$project$Components$Parametrage$Vocabulaire$porteeDeLaListe = F2(
	function (i18n, code) {
		switch (code) {
			case 'parties-prenantes':
				return $author$project$I18n$Cles$listesPorteePartiesPrenantes(i18n);
			case 'catalogue-et-parties-prenantes':
				return $author$project$I18n$Cles$listesPorteeCatalogueEtPartiesPrenantes(i18n);
			default:
				return $author$project$I18n$Cles$listesPorteeCatalogue(i18n);
		}
	});
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$contenuDeLaListe = F3(
	function (i18n, portee, liste) {
		return _List_fromArray(
			[
				liste.g7 ? A2(
				$author$project$Components$Shared$Note$View$view,
				1,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$bibliothequeListeNomPris,
									i18n,
									{
										Dj: $elm$core$String$trim(liste.Dj)
									}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								2,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('choisir-la-liste'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$NouveauChamp$Formulaire$ListeExistanteVoulue)
									]),
								$author$project$I18n$Cles$bibliothequeListeChoisirExistante(i18n)),
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								2,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('autre-nom'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$NouveauChamp$Formulaire$AutreNomVoulu)
									]),
								$author$project$I18n$Cles$bibliothequeListeAutreNom(i18n))
							]))
					])) : (liste.qa ? A2(
				$author$project$Components$Shared$Note$View$view,
				1,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$bibliothequeListeRefus(i18n))
							]))
					])) : $rtfeldman$elm_css$Html$Styled$text('')),
				A2(
				$rtfeldman$elm_css$Html$Styled$fieldset,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('mandatory')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$legend,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$bibliothequeListeNom(i18n))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$input,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Parametrage$NouveauChamp$Formulaire$idDuNomDeListe),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
								$rtfeldman$elm_css$Html$Styled$Attributes$value(liste.Dj),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Parametrage$NouveauChamp$Formulaire$NomDeListeSaisi)
							]),
						_List_Nil)
					])),
				A2(
				$author$project$Components$Shared$Champ$View$zoneDeTexte,
				{
					go: $elm$core$Maybe$Nothing,
					Aq: $author$project$Components$Parametrage$NouveauChamp$Formulaire$idDesValeursDeListe,
					Bl: $author$project$I18n$Cles$bibliothequeListeValeurs(i18n),
					he: false
				},
				{hg: $author$project$Components$Parametrage$NouveauChamp$Formulaire$ValeursDeListeSaisies, fm: liste.Ki}),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$bibliothequeListeValeursAide(i18n))
					])),
				A2(
				$author$project$Components$Shared$Champ$View$texteEnLectureSeule,
				{
					go: $elm$core$Maybe$Nothing,
					Aq: $author$project$Components$Parametrage$NouveauChamp$Formulaire$idDeLaPorteeDeListe,
					Bl: $author$project$I18n$Cles$bibliothequeListePortee(i18n),
					he: false
				},
				{
					fm: A2($author$project$Components$Parametrage$Vocabulaire$porteeDeLaListe, i18n, portee)
				}),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$bibliothequeListePorteeAide(i18n))
					]))
			]);
	});
var $author$project$Components$Parametrage$NouveauChamp$Model$porteeDuChamp = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		'catalogue',
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.F$;
			},
			model.uw));
};
var $author$project$Components$Shared$Drawer$View$piedAvecNote = F2(
	function (note, pied) {
		return _Utils_update(
			pied,
			{oJ: note});
	});
var $author$project$Components$Shared$Drawer$View$avecSousTitreEtNote = F4(
	function (i18n, variante, sousTitre, note) {
		return A4(
			$author$project$Components$Shared$Drawer$View$viewAvecPied,
			i18n,
			variante,
			sousTitre,
			function (versMsg) {
				return A2(
					$author$project$Components$Shared$Drawer$View$piedAvecNote,
					note,
					A3(
						$author$project$Components$Shared$Drawer$View$piedDe,
						$author$project$I18n$Cles$drawerAnnuler(i18n),
						_List_Nil,
						versMsg));
			});
	});
var $author$project$Components$Shared$Drawer$View$viewAvecSousTitreEtNote = function (i18n) {
	return A2($author$project$Components$Shared$Drawer$View$avecSousTitreEtNote, i18n, 0);
};
var $author$project$Components$Parametrage$NouveauChamp$View$drawerDeLaListe = F2(
	function (i18n, model) {
		return A6(
			$author$project$Components$Shared$Drawer$View$viewAvecSousTitreEtNote,
			i18n,
			$elm$core$Maybe$Just(
				A2(
					$author$project$I18n$Cles$bibliothequeListeKickerPortee,
					i18n,
					{
						F$: A2(
							$author$project$Components$Parametrage$Vocabulaire$porteeDeLaListe,
							i18n,
							$author$project$Components$Parametrage$NouveauChamp$Model$porteeDuChamp(model))
					})),
			$elm$core$Maybe$Just(
				$author$project$I18n$Cles$bibliothequeListePied(i18n)),
			$author$project$Components$Parametrage$NouveauChamp$Update$DuDrawerDeLaListe,
			{
				fs: {
					sR: !$author$project$API$Envoi$enCours(model.l2),
					Bl: $author$project$I18n$Cles$bibliothequeListeAction(i18n),
					C$: $author$project$Components$Parametrage$NouveauChamp$Update$ListeCreee
				},
				fZ: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							A2(
								$author$project$Components$Parametrage$NouveauChamp$Formulaire$contenuDeLaListe,
								i18n,
								$author$project$Components$Parametrage$NouveauChamp$Model$porteeDuChamp(model)),
							$elm$core$List$map(
								$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Parametrage$NouveauChamp$Update$DeLaListe))),
						model.nW)),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$bibliothequeListeTitre(i18n)
			},
			model.lc);
	});
var $author$project$Components$Parametrage$NouveauChamp$Update$AutreNomVoulu = {$: 8};
var $author$project$Components$Parametrage$NouveauChamp$Update$ChampCree = {$: 5};
var $author$project$Components$Parametrage$NouveauChamp$Update$ChampExistantVoulu = {$: 9};
var $author$project$Components$Parametrage$NouveauChamp$Update$DuChamp = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Update$CreerVoulu = {$: 6};
var $author$project$Components$Parametrage$NouveauChamp$Update$RattacherVoulu = {$: 7};
var $author$project$I18n$Cles$produitsTypesAjoutBandeauTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.ajout.bandeau.titre', _List_Nil, 'Le champ entre dans la bibliothèque');
};
var $author$project$I18n$Cles$produitsTypesAjoutCreer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.ajout.creer', _List_Nil, 'Créer un champ');
};
var $author$project$I18n$Cles$produitsTypesAjoutMode = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.ajout.mode', _List_Nil, 'Comment ajouter le champ');
};
var $author$project$I18n$Cles$produitsTypesAjoutRattacher = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.ajout.rattacher', _List_Nil, 'Rattacher un champ existant');
};
var $author$project$Components$Parametrage$NouveauChamp$View$basculeEtBandeau = F2(
	function (i18n, ouverture) {
		var _v0 = ouverture.un;
		if (!_v0.$) {
			var detail = _v0.a.bB;
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsTypesAjoutMode(i18n))
								])),
							$author$project$Components$Shared$Segment$View$view(
							{
								vd: 'creer',
								Bi: $author$project$I18n$Cles$produitsTypesAjoutMode(i18n),
								Dj: 'nouveau-champ-mode',
								Ea: function (code) {
									return (code === 'rattacher') ? $author$project$Components$Parametrage$NouveauChamp$Update$RattacherVoulu : $author$project$Components$Parametrage$NouveauChamp$Update$CreerVoulu;
								},
								o_: _List_fromArray(
									[
										{
										vx: 'creer',
										Bl: $author$project$I18n$Cles$produitsTypesAjoutCreer(i18n)
									},
										{
										vx: 'rattacher',
										Bl: $author$project$I18n$Cles$produitsTypesAjoutRattacher(i18n)
									}
									])
							})
						])),
					A2(
					$author$project$Components$Shared$Note$View$view,
					0,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsTypesAjoutBandeauTitre(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$I18n$Cles$texte, i18n, detail))
								]))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$I18n$Cles$bibliothequeGroupeAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.groupe.action', _List_Nil, 'Créer le champ');
};
var $author$project$I18n$Cles$bibliothequeGroupeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.groupe.titre', _List_Nil, 'Nouveau champ');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampListePied = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.liste.pied', _List_Nil, 'La liste est lue dans Paramétrage › Listes');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampNomPrisAutreNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.nom-pris.autre-nom', _List_Nil, 'Choisir un autre nom');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampNomPrisRattacher = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.nom-pris.rattacher', _List_Nil, 'Rattacher le champ existant');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampNomPrisRienCree = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.nom-pris.rien-cree', _List_Nil, 'Rien n\'a été créé');
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$NomSaisi = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$nomDejaPris = function (brouillon) {
	return !_Utils_eq(
		$author$project$Components$Parametrage$NouveauChamp$Formulaire$champDuNomPris(brouillon),
		$elm$core$Maybe$Nothing);
};
var $author$project$I18n$Cles$bibliothequeGroupeManques = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.groupe.manques', _List_Nil, 'Nommez le champ et chacun de ses sous-champs ; un choix dans une liste cite sa liste.');
};
var $author$project$I18n$Cles$bibliothequeGroupeManquesSimple = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.groupe.manques-simple', _List_Nil, 'Nommez le champ ; un choix dans une liste cite sa liste, une partie prenante son type.');
};
var $author$project$I18n$Cles$bibliothequeGroupeRefusAutre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.groupe.refus.autre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'code',
					$author$project$I18n$Traductions$Chaine(p.vx))
				]),
			'Le serveur refuse le champ (' + (p.vx + ').'));
	});
var $author$project$I18n$Cles$bibliothequeGroupeRefusDejaDefini = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.groupe.refus.deja-defini', _List_Nil, 'Un champ porte déjà ce nom dans la bibliothèque : choisissez-en un autre.');
};
var $author$project$I18n$Cles$bibliothequeGroupeRefusEnDouble = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.groupe.refus.en-double',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			'Deux sous-champs portent le libellé « ' + (p.Bl + ' » : renommez l\'un des deux.'));
	});
var $author$project$I18n$Cles$bibliothequeGroupeRefusListeInadmise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.groupe.refus.liste-inadmise', _List_Nil, 'La liste d\'un sous-champ ne sert pas ce groupe : choisissez une autre liste.');
};
var $author$project$I18n$Cles$bibliothequeGroupeRefusNonAdmis = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.groupe.refus.non-admis',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'genre',
					$author$project$I18n$Traductions$Chaine(p.M))
				]),
			'Un sous-champ de type « ' + (p.M + ' » n\'est pas admis : choisissez texte, nombre, date ou liste.'));
	});
var $author$project$I18n$Cles$bibliothequeGroupeRefusSansLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.groupe.refus.sans-libelle', _List_Nil, 'Un sous-champ n\'a pas de libellé : nommez-le ou retirez-le.');
};
var $author$project$I18n$Cles$bibliothequeGroupeRefusSansSousChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.groupe.refus.sans-sous-champ', _List_Nil, 'Un groupe porte au moins un sous-champ : ajoutez-en un.');
};
var $author$project$I18n$Cles$bibliothequeGroupeRefusTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.groupe.refus.titre', _List_Nil, 'Le champ n\'est pas créé.');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampCalculManque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.calcul-manque', _List_Nil, 'Écrivez la formule du calcul et, selon son résultat, son unité, ses décimales ou sa liste.');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampEtagesManquent = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.etages-manquent', _List_Nil, 'Choisissez au moins un étage du catalogue.');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampMesureManque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.mesure-manque', _List_Nil, 'Choisissez la grandeur, l\'unité et le nombre de décimales de la mesure.');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampRefusCollection = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.refus-collection', _List_Nil, 'Cette collection n\'existe plus ou n\'accueille plus de champ : le champ n\'est pas créé. Choisissez une autre collection, ou aucune.');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampRefusCollectionPortee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.refus-collection-portee', _List_Nil, 'Cette collection ne couvre pas la portée du champ : le champ n\'est pas créé. Choisissez une collection de cette portée, ou aucune.');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampRefusEtages = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.refus-etages', _List_Nil, 'Les étages ne se règlent que pour un champ du catalogue : le champ n\'est pas créé. Choisissez la portée « Étages du catalogue » ou « Produits ».');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampRefusFiltrable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.refus-filtrable', _List_Nil, 'Un champ de ce type n\'est pas filtrable : le champ n\'est pas créé. Décochez « Filtrable » ou changez de type.');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampRefusRecherchable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.refus-recherchable', _List_Nil, 'Un champ de ce type n\'est pas recherchable : le champ n\'est pas créé. Décochez « Recherchable » ou changez de type.');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampNomPrisAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.nom-pris.aide', _List_Nil, 'Si le champ existant convient, rattachez-le : le porteur le prend tel quel, avec sa forme. Si vous voulez une autre forme, changez de nom.');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampNomPrisCree = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.nom-pris.cree', _List_Nil, 'Ce que vous créez');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampNomPrisExistant = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.nom-pris.existant', _List_Nil, 'Champ existant');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampNomPrisFormeDifferente = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.nom-pris.forme-differente', _List_Nil, 'forme différente');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampNomPrisFormeIdentique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.nom-pris.forme-identique', _List_Nil, 'forme identique');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampNomPrisLigne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.nouveau-champ.nom-pris.ligne',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'forme',
					$author$project$I18n$Traductions$Chaine(p.gB)),
					_Utils_Tuple2(
					'portee',
					$author$project$I18n$Traductions$Chaine(p.F$))
				]),
			p.gB + (' · portée ' + p.F$));
	});
var $author$project$I18n$Cles$bibliothequeNouveauChampNomPrisTexte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.nouveau-champ.nom-pris.texte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Un champ « ' + (p.Dj + ' » existe déjà, de la même forme que celle que vous créez. Deux champs ne peuvent pas porter le même nom.'));
	});
var $author$project$I18n$Cles$bibliothequeNouveauChampNomPrisTexteAutreForme = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.nouveau-champ.nom-pris.texte-autre-forme',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Un champ « ' + (p.Dj + ' » existe déjà, d\'une autre forme que celle que vous créez. Deux champs ne peuvent pas porter le même nom.'));
	});
var $author$project$I18n$Cles$bibliothequeNouveauChampNomPrisTexteSansForme = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.nouveau-champ.nom-pris.texte-sans-forme',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Un champ « ' + (p.Dj + ' » existe déjà. Deux champs ne peuvent pas porter le même nom.'));
	});
var $author$project$I18n$Cles$bibliothequeNouveauChampNomPrisTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.nom-pris.titre', _List_Nil, 'Ce nom est déjà pris dans la bibliothèque.');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampNomPrisUtilise = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.nouveau-champ.nom-pris.utilise',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Utilisé par ' + p.w);
	});
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeDeChamp = F2(
	function (i18n, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			code,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Dj;
				},
				A2(
					$elm$core$Dict$get,
					code,
					$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$types(i18n))));
	});
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$nomPris = F4(
	function (i18n, contexte, brouillon, precisions) {
		var formeSaisie = A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeDeChamp, i18n, brouillon.JR);
		var existant = A2(
			$elm$core$Maybe$andThen,
			function (_v1) {
				var id = _v1.b;
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(id)),
						contexte.uY));
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$eq('champ')),
					precisions)));
		var memeForme = A2(
			$elm$core$Maybe$map,
			function (lu) {
				return _Utils_eq(
					A2($author$project$Components$Parametrage$Vocabulaire$typeDeChampDeLaBibliotheque, i18n, lu.rU),
					formeSaisie);
			},
			existant);
		var nom = A2(
			$elm$core$Maybe$withDefault,
			brouillon.Dj,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				existant));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('nom-pris')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$b,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$bibliothequeNouveauChampNomPrisTitre(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										function () {
											if (!memeForme.$) {
												if (memeForme.a) {
													return A2(
														$author$project$I18n$Cles$bibliothequeNouveauChampNomPrisTexte,
														i18n,
														{Dj: nom});
												} else {
													return A2(
														$author$project$I18n$Cles$bibliothequeNouveauChampNomPrisTexteAutreForme,
														i18n,
														{Dj: nom});
												}
											} else {
												return A2(
													$author$project$I18n$Cles$bibliothequeNouveauChampNomPrisTexteSansForme,
													i18n,
													{Dj: nom});
											}
										}())
									]))
							]))
					]),
				_Utils_ap(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (lu) {
								return _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('fleche')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('bloc')
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('lbl')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$bibliothequeNouveauChampNomPrisCree(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$strong,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(brouillon.Dj)
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(formeSaisie)
															]))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('signe'),
														A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'img'),
														A2(
														$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
														'aria-label',
														_Utils_eq(
															memeForme,
															$elm$core$Maybe$Just(true)) ? $author$project$I18n$Cles$bibliothequeNouveauChampNomPrisFormeIdentique(i18n) : $author$project$I18n$Cles$bibliothequeNouveauChampNomPrisFormeDifferente(i18n))
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														_Utils_eq(
															memeForme,
															$elm$core$Maybe$Just(true)) ? '=' : '≠')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('bloc'),
														$rtfeldman$elm_css$Html$Styled$Attributes$class('nouveau')
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('lbl')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$bibliothequeNouveauChampNomPrisExistant(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$strong,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(lu.Bl)
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																A2(
																	$author$project$I18n$Cles$bibliothequeNouveauChampNomPrisLigne,
																	i18n,
																	{
																		gB: A2($author$project$Components$Parametrage$Vocabulaire$typeDeChampDeLaBibliotheque, i18n, lu.rU),
																		F$: A2($author$project$Components$Parametrage$Vocabulaire$porteeDeLaBibliotheque, i18n, lu.F$)
																	}))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																A2(
																	$author$project$I18n$Cles$bibliothequeNouveauChampNomPrisUtilise,
																	i18n,
																	{
																		w: $elm$core$String$fromInt(lu.sf)
																	}))
															]))
													]))
											]))
									]);
							},
							existant)),
					contexte.hB ? _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$bibliothequeNouveauChampNomPrisAide(i18n))
								]))
						]) : _List_Nil)));
	});
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$refusAffiche = F3(
	function (i18n, contexte, brouillon) {
		var _v0 = brouillon.pZ;
		if (!_v0.$) {
			if (_v0.a.a === 'ChampDejaDansLaBibliotheque') {
				var _v1 = _v0.a;
				var precisions = _v1.b;
				return A4($author$project$Components$Parametrage$NouveauChamp$Formulaire$nomPris, i18n, contexte, brouillon, precisions);
			} else {
				var _v2 = _v0.a;
				var cas = _v2.a;
				var precisions = _v2.b;
				var precision = function (cle) {
					return A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							$elm$core$Tuple$second,
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Tuple$first,
										$elm$core$Basics$eq(cle)),
									precisions))));
				};
				return A2(
					$author$project$Components$Shared$Note$View$view,
					1,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$bibliothequeGroupeRefusTitre(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									function () {
										switch (cas) {
											case 'GroupeSansSousChamp':
												return $author$project$I18n$Cles$bibliothequeGroupeRefusSansSousChamp(i18n);
											case 'SousChampSansLibelle':
												return $author$project$I18n$Cles$bibliothequeGroupeRefusSansLibelle(i18n);
											case 'SousChampsEnDouble':
												return A2(
													$author$project$I18n$Cles$bibliothequeGroupeRefusEnDouble,
													i18n,
													{
														Bl: precision('libelle')
													});
											case 'SousChampNonAdmis':
												return A2(
													$author$project$I18n$Cles$bibliothequeGroupeRefusNonAdmis,
													i18n,
													{
														M: precision('genre')
													});
											case 'ListeDeSousChampInadmise':
												return $author$project$I18n$Cles$bibliothequeGroupeRefusListeInadmise(i18n);
											case 'DejaDefini':
												return $author$project$I18n$Cles$bibliothequeGroupeRefusDejaDefini(i18n);
											case 'CollectionIntrouvable':
												return $author$project$I18n$Cles$bibliothequeNouveauChampRefusCollection(i18n);
											case 'CollectionHorsPortee':
												return $author$project$I18n$Cles$bibliothequeNouveauChampRefusCollectionPortee(i18n);
											case 'FiltrableNonAdmis':
												return $author$project$I18n$Cles$bibliothequeNouveauChampRefusFiltrable(i18n);
											case 'RecherchableNonAdmis':
												return $author$project$I18n$Cles$bibliothequeNouveauChampRefusRecherchable(i18n);
											case 'ChampHorsDuCatalogue':
												return $author$project$I18n$Cles$bibliothequeNouveauChampRefusEtages(i18n);
											case 'AucunEtage':
												return $author$project$I18n$Cles$bibliothequeNouveauChampEtagesManquent(i18n);
											default:
												return A2(
													$author$project$I18n$Cles$bibliothequeGroupeRefusAutre,
													i18n,
													{vx: cas});
										}
									}())
								]))
						]));
			}
		} else {
			return (brouillon.b5 && (!$author$project$Components$Parametrage$NouveauChamp$Formulaire$enregistrable(brouillon))) ? A2(
				$author$project$Components$Shared$Note$View$view,
				1,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$b,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$bibliothequeGroupeRefusTitre(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Components$Parametrage$NouveauChamp$Formulaire$estUnGroupe(brouillon) ? $author$project$I18n$Cles$bibliothequeGroupeManques(i18n) : ((brouillon.ao && _Utils_eq(brouillon.yG, _List_Nil)) ? $author$project$I18n$Cles$bibliothequeNouveauChampEtagesManquent(i18n) : (_Utils_eq(brouillon.JR, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeMesure) ? $author$project$I18n$Cles$bibliothequeNouveauChampMesureManque(i18n) : ($author$project$Components$Parametrage$NouveauChamp$Formulaire$estUnCalcule(brouillon) ? $author$project$I18n$Cles$bibliothequeNouveauChampCalculManque(i18n) : $author$project$I18n$Cles$bibliothequeGroupeManquesSimple(i18n)))))
							]))
					])) : $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$DonneePersonnelleCochee = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$FiltrableCoche = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$PorteeChoisie = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$RecherchableCoche = function (a) {
	return {$: 8, a: a};
};
var $author$project$I18n$Cles$bibliothequeNouveauChampListeUniqueNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.liste-unique-note', _List_Nil, 'Une seule sorte de liste : celles de Paramétrage › Listes. Plus de « liste partagée » à part.');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampPorteeEtages = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.portee-etages', _List_Nil, 'Étages du catalogue');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampRecherchableNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.recherchable-note', _List_Nil, 'Réglage de tout champ, modifiable ensuite. Valeur chiffrée : recherche exacte par empreinte, sans filtre ni recherche partielle.');
};
var $author$project$I18n$Cles$bibliothequeReglagesFiltrableNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reglages.filtrable-note', _List_Nil, 'Réglage de tout champ, quel que soit son type ; modifiable ensuite.');
};
var $author$project$I18n$Cles$bibliothequeReglagesPortee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reglages.portee', _List_Nil, 'Portée');
};
var $author$project$I18n$Cles$bibliothequeReglagesRecherche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reglages.recherche', _List_Nil, 'Recherche');
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$cartouche = F2(
	function (identifiant, config) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pick'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pick-ligne')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id(identifiant),
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(config.vt),
							$rtfeldman$elm_css$Html$Styled$Events$onCheck(config.D9)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(config.h6)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(config.oJ)
								]))
						]))
				]));
	});
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$DesSousChamps = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$GenreChoisi = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$ModeleChoisi = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$OccurrenceSaisie = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$PlusieursChoisi = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$RepetableChoisi = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$TypeViseChoisi = function (a) {
	return {$: 6, a: a};
};
var $author$project$I18n$Cles$bibliothequeNouveauChampListeApercu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.liste.apercu', _List_Nil, 'Aperçu');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampListeApercuNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.liste.apercu-note', _List_Nil, 'La liste reste unique : la modifier ailleurs la change ici.');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampListeApercuTexte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.nouveau-champ.liste.apercu-texte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN)),
					_Utils_Tuple2(
					'valeurs',
					$author$project$I18n$Traductions$Chaine(p.Ki)),
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w)),
					_Utils_Tuple2(
					'liste',
					$author$project$I18n$Traductions$Chaine(p.nW))
				]),
			p.uN + (' : ' + (p.Ki + (' (' + (p.w + (' valeurs, lues dans la liste « ' + (p.nW + ' »)')))))));
	});
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$nomsDesValeurs = function (detail) {
	return _Utils_ap(
		A2(
			$elm$core$String$join,
			', ',
			A2($elm$core$List$take, 3, detail.R)),
		($elm$core$List$length(detail.R) > 3) ? '…' : '');
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$apercuDeLaListe = F3(
	function (i18n, contexte, brouillon) {
		var _v0 = _Utils_Tuple2(
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (l) {
						return _Utils_eq(l.Aq, brouillon.nW);
					},
					contexte.n_)),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (d) {
						return _Utils_eq(d.Aq, brouillon.nW);
					},
					contexte.cz)));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var liste = _v0.a.a;
			var detail = _v0.b.a;
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$bibliothequeNouveauChampListeApercu(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$bibliothequeNouveauChampListeApercuTexte,
										i18n,
										{
											uN: $elm$core$String$trim(brouillon.Dj),
											nW: liste.Dj,
											w: $elm$core$String$fromInt(detail.Ki),
											Ki: $author$project$Components$Parametrage$NouveauChamp$Formulaire$nomsDesValeurs(detail)
										}))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$bibliothequeNouveauChampListeApercuNote(i18n))
								]))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$I18n$Cles$bibliothequeGroupeRepetableNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.groupe.repetable.note', _List_Nil, 'Une fiche peut porter plusieurs occurrences de ce groupe.');
};
var $author$project$I18n$Cles$bibliothequeGroupeTypeVise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.groupe.type-vise', _List_Nil, 'Type de partie prenante');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampPlusieursLegende = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.plusieurs.legende', _List_Nil, 'Plusieurs choix possibles');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampPlusieursPlusieurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.plusieurs.plusieurs', _List_Nil, 'Plusieurs');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampPlusieursUn = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.plusieurs.un', _List_Nil, 'Un seul');
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$FormuleSaisie = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$RecalculChoisi = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$ResultatChoisi = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$ValeurChoisie = function (a) {
	return {$: 17, a: a};
};
var $author$project$I18n$Cles$bibliothequeGroupeListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.groupe.liste', _List_Nil, 'Liste');
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$DecimalesSaisies = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$champDesDecimales = F2(
	function (i18n, brouillon) {
		return A2(
			$author$project$Components$Shared$Champ$View$texte,
			{
				go: $elm$core$Maybe$Nothing,
				Aq: 'champ-a-creer-decimales',
				Bl: $author$project$I18n$Cles$bibliothequeDefinitionDecimales(i18n),
				he: false
			},
			{hg: $author$project$Components$Parametrage$NouveauChamp$Formulaire$DecimalesSaisies, fm: brouillon.kv});
	});
var $author$project$I18n$Cles$bibliothequeGroupeAucuneListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.groupe.aucune-liste', _List_Nil, 'Aucune liste de la bibliothèque encore : créez-en une.');
};
var $author$project$I18n$Cles$bibliothequeGroupeChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.groupe.choisir', _List_Nil, 'Choisir…');
};
var $author$project$I18n$Cles$bibliothequeGroupeCreerUneListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.groupe.creer-une-liste', _List_Nil, 'Créer une liste');
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$choixDansUneListe = F7(
	function (i18n, peutCreer, identifiant, libelle, choisie, surChoix, options) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					{go: $elm$core$Maybe$Nothing, Aq: identifiant, Bl: libelle, he: true},
					{
						hg: surChoix,
						o_: A2(
							$elm$core$List$cons,
							{
								Bl: $author$project$I18n$Cles$bibliothequeGroupeChoisir(i18n),
								fm: ''
							},
							_Utils_ap(
								A2(
									$elm$core$List$map,
									function (o) {
										return {Bl: o.Dj, fm: o.Aq};
									},
									options),
								peutCreer ? _List_fromArray(
									[
										{
										Bl: $author$project$I18n$Cles$bibliothequeGroupeCreerUneListe(i18n),
										fm: $author$project$Components$Parametrage$NouveauChamp$Formulaire$valeurNouvelleListe
									}
									]) : _List_Nil)),
						fm: choisie
					}),
					(_Utils_eq(options, _List_Nil) && peutCreer) ? A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('aide'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('aucune-liste')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$bibliothequeGroupeAucuneListe(i18n))
						])) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$porteeCouvre = F2(
	function (liste, champ) {
		var sert = function (code) {
			return _Utils_Tuple2(code !== 'parties-prenantes', code !== 'catalogue');
		};
		var _v0 = sert(liste);
		var listeCatalogue = _v0.a;
		var listePartiesPrenantes = _v0.b;
		var _v1 = sert(champ);
		var champCatalogue = _v1.a;
		var champPartiesPrenantes = _v1.b;
		return ((!champCatalogue) || listeCatalogue) && ((!champPartiesPrenantes) || listePartiesPrenantes);
	});
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$listesOffertes = F2(
	function (contexte, brouillon) {
		return A2(
			$elm$core$List$filter,
			function (l) {
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (d) {
							return A2($author$project$Components$Parametrage$NouveauChamp$Formulaire$porteeCouvre, d.F$, brouillon.F$);
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (d) {
									return _Utils_eq(d.Aq, l.Aq);
								},
								contexte.cz))));
			},
			contexte.n_);
	});
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$GrandeurChoisie = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$UniteChoisie = function (a) {
	return {$: 12, a: a};
};
var $author$project$I18n$Cles$bibliothequeNouveauChampGrandeurChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.grandeur-choisir', _List_Nil, 'Choisir une grandeur');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampUniteChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.unite-choisir', _List_Nil, 'Choisir une unité');
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$unitesDe = F3(
	function (i18n, grandeur, unites) {
		return A2(
			$elm$core$List$cons,
			{
				vx: '',
				Bl: $author$project$I18n$Cles$bibliothequeNouveauChampUniteChoisir(i18n)
			},
			A2(
				$elm$core$List$map,
				function (u) {
					return {vx: u.vx, Bl: u.Dj + (' (' + (u.Jh + ')'))};
				},
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.m0;
						},
						$elm$core$Basics$eq(grandeur)),
					unites)));
	});
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$mesure = F3(
	function (i18n, contexte, brouillon) {
		var grandeurs = A3(
			$elm$core$List$foldr,
			F2(
				function (u, vues) {
					return A2($elm$core$List$member, u.m0, vues) ? vues : A2($elm$core$List$cons, u.m0, vues);
				}),
			_List_Nil,
			contexte.sb);
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('deux')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Champ$View$liste,
						{
							go: $elm$core$Maybe$Nothing,
							Aq: 'champ-a-creer-grandeur',
							Bl: $author$project$I18n$Cles$bibliothequeDefinitionGrandeur(i18n),
							he: true
						},
						{
							hg: $author$project$Components$Parametrage$NouveauChamp$Formulaire$GrandeurChoisie,
							o_: A2(
								$elm$core$List$cons,
								{
									Bl: $author$project$I18n$Cles$bibliothequeNouveauChampGrandeurChoisir(i18n),
									fm: ''
								},
								A2(
									$elm$core$List$map,
									function (g) {
										return {Bl: g, fm: g};
									},
									grandeurs)),
							fm: brouillon.m0
						}),
						A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$OptionsView$unite,
						i18n,
						{
							Aq: 'champ-a-creer-unite',
							hg: $author$project$Components$Parametrage$NouveauChamp$Formulaire$UniteChoisie,
							sb: A3($author$project$Components$Parametrage$NouveauChamp$Formulaire$unitesDe, i18n, brouillon.m0, contexte.sb),
							fm: brouillon.sa
						})
					])),
				A2($author$project$Components$Parametrage$NouveauChamp$Formulaire$champDesDecimales, i18n, brouillon)
			]);
	});
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$calcule = F3(
	function (i18n, contexte, brouillon) {
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Champ$View$zoneDeTexte,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: 'champ-a-creer-formule',
						Bl: $author$project$I18n$Cles$bibliothequeCalculFormule(i18n),
						he: true
					},
					{hg: $author$project$Components$Parametrage$NouveauChamp$Formulaire$FormuleSaisie, fm: brouillon.zU}),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$bibliothequeCalculNote(i18n))
						])),
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: 'champ-a-creer-resultat',
						Bl: $author$project$I18n$Cles$bibliothequeCalculResultat(i18n),
						he: false
					},
					{
						hg: $author$project$Components$Parametrage$NouveauChamp$Formulaire$ResultatChoisi,
						o_: A2(
							$elm$core$List$map,
							function (_v0) {
								var code = _v0.a;
								var type_ = _v0.b;
								return {
									Bl: A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeDeChamp, i18n, type_),
									fm: code
								};
							},
							_List_fromArray(
								[
									_Utils_Tuple2('texte', $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeTexte),
									_Utils_Tuple2('nombre', $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeNombre),
									_Utils_Tuple2('mesure', $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeMesure),
									_Utils_Tuple2('liste', $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeListeUnique)
								])),
						fm: brouillon.HW
					})
				]),
			_Utils_ap(
				function () {
					var _v1 = brouillon.HW;
					switch (_v1) {
						case 'nombre':
							return _List_fromArray(
								[
									A2($author$project$Components$Parametrage$NouveauChamp$Formulaire$champDesDecimales, i18n, brouillon)
								]);
						case 'mesure':
							return A3($author$project$Components$Parametrage$NouveauChamp$Formulaire$mesure, i18n, contexte, brouillon);
						case 'liste':
							return _List_fromArray(
								[
									A7(
									$author$project$Components$Parametrage$NouveauChamp$Formulaire$choixDansUneListe,
									i18n,
									contexte.ht,
									'champ-a-creer-liste',
									$author$project$I18n$Cles$bibliothequeGroupeListe(i18n),
									brouillon.nW,
									$author$project$Components$Parametrage$NouveauChamp$Formulaire$ListeChoisie,
									A2($author$project$Components$Parametrage$NouveauChamp$Formulaire$listesOffertes, contexte, brouillon))
								]);
						default:
							return _List_Nil;
					}
				}(),
				_List_fromArray(
					[
						A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$OptionsView$choixDuCalcul,
						$author$project$I18n$Cles$bibliothequeCalculRecalcul(i18n),
						{
							vd: brouillon.G$,
							Dj: 'champ-a-creer-recalcul',
							Ea: $author$project$Components$Parametrage$NouveauChamp$Formulaire$RecalculChoisi,
							o_: $author$project$Components$Parametrage$BibliothequeDeChamps$OptionsView$recalculs(i18n)
						}),
						A2(
						$author$project$Components$Parametrage$BibliothequeDeChamps$OptionsView$choixDuCalcul,
						$author$project$I18n$Cles$bibliothequeCalculValeur(i18n),
						{
							vd: brouillon.fm,
							Dj: 'champ-a-creer-valeur',
							Ea: $author$project$Components$Parametrage$NouveauChamp$Formulaire$ValeurChoisie,
							o_: $author$project$Components$Parametrage$BibliothequeDeChamps$OptionsView$valeurs(i18n)
						})
					])));
	});
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$GroupeVide = 3;
var $author$project$I18n$Cles$sousChampsModeleLibelleAnnee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.modele.libelle-annee', _List_Nil, 'Année');
};
var $author$project$I18n$Cles$sousChampsModeleLibelleDevise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.modele.libelle-devise', _List_Nil, 'Devise');
};
var $author$project$I18n$Cles$sousChampsModeleLibelleHauteur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.modele.libelle-hauteur', _List_Nil, 'Hauteur');
};
var $author$project$I18n$Cles$sousChampsModeleLibelleLargeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.modele.libelle-largeur', _List_Nil, 'Largeur');
};
var $author$project$I18n$Cles$sousChampsModeleLibelleMontant = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.modele.libelle-montant', _List_Nil, 'Montant');
};
var $author$project$I18n$Cles$sousChampsModeleLibelleProfondeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.modele.libelle-profondeur', _List_Nil, 'Profondeur');
};
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$modeleChoisi = F2(
	function (i18n, modele) {
		var obligatoire = function (sousChamp) {
			return _Utils_update(
				sousChamp,
				{he: true});
		};
		var montant = _List_fromArray(
			[
				obligatoire(
				_Utils_update(
					$author$project$Components$Shared$EditeurDeSchema$SousChamps$vide,
					{
						M: 3,
						Bl: $author$project$I18n$Cles$sousChampsModeleLibelleMontant(i18n)
					})),
				obligatoire(
				_Utils_update(
					$author$project$Components$Shared$EditeurDeSchema$SousChamps$vide,
					{
						M: 5,
						Bl: $author$project$I18n$Cles$sousChampsModeleLibelleDevise(i18n)
					}))
			]);
		var mesure = function (libelle) {
			return _Utils_update(
				$author$project$Components$Shared$EditeurDeSchema$SousChamps$vide,
				{M: 4, Bl: libelle, Cx: '1', sa: 'mm'});
		};
		switch (modele) {
			case 0:
				return {
					HI: false,
					IX: _List_fromArray(
						[
							mesure(
							$author$project$I18n$Cles$sousChampsModeleLibelleHauteur(i18n)),
							mesure(
							$author$project$I18n$Cles$sousChampsModeleLibelleLargeur(i18n)),
							mesure(
							$author$project$I18n$Cles$sousChampsModeleLibelleProfondeur(i18n))
						])
				};
			case 1:
				return {HI: false, IX: montant};
			case 2:
				return {
					HI: true,
					IX: A2(
						$elm$core$List$cons,
						obligatoire(
							_Utils_update(
								$author$project$Components$Shared$EditeurDeSchema$SousChamps$vide,
								{
									M: 1,
									Bl: $author$project$I18n$Cles$sousChampsModeleLibelleAnnee(i18n),
									Cg: '2100',
									Cx: '1900',
									J9: true
								})),
						montant)
				};
			default:
				return {HI: true, IX: _List_Nil};
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$Dimensions = 0;
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$MontantAvecDevise = 1;
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$ValeurParAnnee = 2;
var $author$project$I18n$Cles$sousChampsModeleAnnee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.modele.annee', _List_Nil, 'Valeur par année');
};
var $author$project$I18n$Cles$sousChampsModeleDimensions = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.modele.dimensions', _List_Nil, 'Dimensions (H × L × P)');
};
var $author$project$I18n$Cles$sousChampsModeleMontant = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.modele.montant', _List_Nil, 'Montant avec devise');
};
var $author$project$I18n$Cles$sousChampsModeleVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.modele.vide', _List_Nil, 'Groupe vide');
};
var $author$project$Components$Shared$EditeurDeSchema$SousChamps$modeles = function (i18n) {
	return _List_fromArray(
		[
			_Utils_Tuple3(
			0,
			'dimensions',
			$author$project$I18n$Cles$sousChampsModeleDimensions(i18n)),
			_Utils_Tuple3(
			1,
			'montant',
			$author$project$I18n$Cles$sousChampsModeleMontant(i18n)),
			_Utils_Tuple3(
			2,
			'annee',
			$author$project$I18n$Cles$sousChampsModeleAnnee(i18n)),
			_Utils_Tuple3(
			3,
			'vide',
			$author$project$I18n$Cles$sousChampsModeleVide(i18n))
		]);
};
var $author$project$I18n$Cles$sousChampsModele = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.modele', _List_Nil, 'Partir d\'un modèle');
};
var $author$project$I18n$Cles$sousChampsModeleAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'sous-champs.modele.aide', _List_Nil, 'Un modèle préremplit les sous-champs ; tout se modifie ensuite. C\'est un groupe ordinaire, rien de plus.');
};
var $author$project$Components$Shared$EditeurDeSchema$View$choixDeModele = F3(
	function (i18n, nom, surChoix) {
		var choisir = function (code) {
			return surChoix(
				A2(
					$author$project$Components$Shared$EditeurDeSchema$SousChamps$modeleChoisi,
					i18n,
					A2(
						$elm$core$Maybe$withDefault,
						3,
						A2(
							$elm$core$Maybe$map,
							function (_v2) {
								var modele = _v2.a;
								return modele;
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (_v1) {
										var c = _v1.b;
										return _Utils_eq(c, code);
									},
									$author$project$Components$Shared$EditeurDeSchema$SousChamps$modeles(i18n)))))));
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('modeles-de-groupe')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$sousChampsModele(i18n))
						])),
					$author$project$Components$Shared$Segment$View$view(
					{
						vd: '',
						Bi: $author$project$I18n$Cles$sousChampsModele(i18n),
						Dj: nom,
						Ea: choisir,
						o_: A2(
							$elm$core$List$map,
							function (_v0) {
								var code = _v0.b;
								var libelle = _v0.c;
								return {vx: code, Bl: libelle};
							},
							$author$project$Components$Shared$EditeurDeSchema$SousChamps$modeles(i18n))
					}),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$sousChampsModeleAide(i18n))
						]))
				]));
	});
var $author$project$I18n$Cles$editeurDeSchemaGroupeGenre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.groupe.genre', _List_Nil, 'Genre de ce mot');
};
var $author$project$I18n$Cles$editeurDeSchemaGroupeGenreFeminin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.groupe.genre.feminin', _List_Nil, 'Féminin (une certification)');
};
var $author$project$I18n$Cles$editeurDeSchemaGroupeGenreMasculin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.groupe.genre.masculin', _List_Nil, 'Masculin (un foyer)');
};
var $author$project$I18n$Cles$editeurDeSchemaGroupeOccurrence = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.groupe.occurrence', _List_Nil, 'Une occurrence s\'appelle (au singulier)');
};
var $author$project$I18n$Cles$editeurDeSchemaGroupeRegroupe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.groupe.regroupe', _List_Nil, 'Regroupe plusieurs informations liées, saisies ensemble.');
};
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$genreMasculin = 'masculin';
var $author$project$I18n$Cles$bibliothequeNouveauChampListeUneValeur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.nouveau-champ.liste.une-valeur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'portee',
					$author$project$I18n$Traductions$Chaine(p.F$))
				]),
			'1 valeur · portée ' + p.F$);
	});
var $author$project$I18n$Cles$bibliothequeNouveauChampListeValeurs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.nouveau-champ.liste.valeurs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w)),
					_Utils_Tuple2(
					'portee',
					$author$project$I18n$Traductions$Chaine(p.F$))
				]),
			p.w + (' valeurs · portée ' + p.F$));
	});
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$detailDeLaListe = F2(
	function (i18n, detail) {
		return (detail.Ki === 1) ? A2(
			$author$project$I18n$Cles$bibliothequeNouveauChampListeUneValeur,
			i18n,
			{
				F$: A2($author$project$Components$Parametrage$Vocabulaire$porteeDeLaListe, i18n, detail.F$)
			}) : A2(
			$author$project$I18n$Cles$bibliothequeNouveauChampListeValeurs,
			i18n,
			{
				w: $elm$core$String$fromInt(detail.Ki),
				F$: A2($author$project$Components$Parametrage$Vocabulaire$porteeDeLaListe, i18n, detail.F$)
			});
	});
var $author$project$I18n$Cles$bibliothequeListeUtiliseePar = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.liste.utilisee-par',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('utilisée par ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champ')) : ('utilisée par ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champs')));
	});
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$utiliseePar = F3(
	function (i18n, contexte, id) {
		return A2(
			$elm$core$Maybe$map,
			function (d) {
				return A2(
					$author$project$I18n$Cles$bibliothequeListeUtiliseePar,
					i18n,
					{w: d.Kh});
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (d) {
						return _Utils_eq(d.Aq, id) && (d.Kh > 0);
					},
					contexte.cz)));
	});
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$listeEnRadios = F3(
	function (i18n, contexte, brouillon) {
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$fieldset,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('mandatory')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$legend,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$bibliothequeGroupeListe(i18n))
									]))
							])),
						$author$project$Components$Shared$ChoixEnListe$View$viewEtiquete(
						{
							vd: brouillon.nW,
							Bi: $author$project$I18n$Cles$bibliothequeGroupeListe(i18n),
							Dj: 'champ-a-creer-liste',
							Ea: $author$project$Components$Parametrage$NouveauChamp$Formulaire$ListeChoisie,
							o_: A2(
								$elm$core$List$map,
								function (l) {
									return {
										bp: A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Components$Parametrage$NouveauChamp$Formulaire$detailDeLaListe(i18n),
												$elm$core$List$head(
													A2(
														$elm$core$List$filter,
														function (d) {
															return _Utils_eq(d.Aq, l.Aq);
														},
														contexte.cz)))),
										vx: l.Aq,
										yS: A3($author$project$Components$Parametrage$NouveauChamp$Formulaire$utiliseePar, i18n, contexte, l.Aq),
										Bl: l.Dj
									};
								},
								A2($author$project$Components$Parametrage$NouveauChamp$Formulaire$listesOffertes, contexte, brouillon))
						}),
						_Utils_eq(
						A2($author$project$Components$Parametrage$NouveauChamp$Formulaire$listesOffertes, contexte, brouillon),
						_List_Nil) ? A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aucune-liste')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$bibliothequeGroupeAucuneListe(i18n))
							])) : $rtfeldman$elm_css$Html$Styled$text(''),
						contexte.ht ? A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						2,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('creer-une-liste'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Parametrage$NouveauChamp$Formulaire$ListeChoisie($author$project$Components$Parametrage$NouveauChamp$Formulaire$valeurNouvelleListe))
							]),
						$author$project$I18n$Cles$bibliothequeGroupeCreerUneListe(i18n)) : $rtfeldman$elm_css$Html$Styled$text('')
					]))
			]);
	});
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$ceQueLeTypeDemande = F3(
	function (i18n, contexte, brouillon) {
		return _Utils_eq(brouillon.JR, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeListeUnique) ? _Utils_ap(
			A3($author$project$Components$Parametrage$NouveauChamp$Formulaire$listeEnRadios, i18n, contexte, brouillon),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$fieldset,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$legend,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$bibliothequeNouveauChampPlusieursLegende(i18n))
											]))
									])),
								$author$project$Components$Shared$ChoixEnListe$View$view(
								{
									vd: brouillon.FT ? 'oui' : 'non',
									Bi: $author$project$I18n$Cles$bibliothequeNouveauChampPlusieursLegende(i18n),
									Dj: 'champ-a-creer-plusieurs-choix',
									Ea: function (code) {
										return $author$project$Components$Parametrage$NouveauChamp$Formulaire$PlusieursChoisi(code === 'oui');
									},
									o_: _List_fromArray(
										[
											{
											bp: '',
											vx: 'non',
											Bl: $author$project$I18n$Cles$bibliothequeNouveauChampPlusieursUn(i18n)
										},
											{
											bp: '',
											vx: 'oui',
											Bl: $author$project$I18n$Cles$bibliothequeNouveauChampPlusieursPlusieurs(i18n)
										}
										])
								})
							]))
					]),
				A3($author$project$Components$Parametrage$NouveauChamp$Formulaire$apercuDeLaListe, i18n, contexte, brouillon))) : (_Utils_eq(brouillon.JR, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typePartiePrenante) ? _List_fromArray(
			[
				A7(
				$author$project$Components$Parametrage$NouveauChamp$Formulaire$choixDansUneListe,
				i18n,
				false,
				'champ-a-creer-type-vise',
				$author$project$I18n$Cles$bibliothequeGroupeTypeVise(i18n),
				brouillon.r$,
				$author$project$Components$Parametrage$NouveauChamp$Formulaire$TypeViseChoisi,
				contexte.ib)
			]) : (_Utils_eq(brouillon.JR, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeMesure) ? A3($author$project$Components$Parametrage$NouveauChamp$Formulaire$mesure, i18n, contexte, brouillon) : ($author$project$Components$Parametrage$NouveauChamp$Formulaire$estUnCalcule(brouillon) ? A3($author$project$Components$Parametrage$NouveauChamp$Formulaire$calcule, i18n, contexte, brouillon) : ($author$project$Components$Parametrage$NouveauChamp$Formulaire$estUnGroupe(brouillon) ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$editeurDeSchemaGroupeRegroupe(i18n))
					])),
				A3($author$project$Components$Shared$EditeurDeSchema$View$choixDeModele, i18n, 'champ-a-creer-modele', $author$project$Components$Parametrage$NouveauChamp$Formulaire$ModeleChoisi),
				A2(
				$rtfeldman$elm_css$Html$Styled$fieldset,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$legend,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$bibliothequeGroupeRepetable(i18n))
									]))
							])),
						$author$project$Components$Shared$Segment$View$view(
						{
							vd: brouillon.HI ? 'oui' : 'non',
							Bi: $author$project$I18n$Cles$bibliothequeGroupeRepetable(i18n),
							Dj: 'champ-a-creer-repetable',
							Ea: function (code) {
								return $author$project$Components$Parametrage$NouveauChamp$Formulaire$RepetableChoisi(code === 'oui');
							},
							o_: _List_fromArray(
								[
									{
									vx: 'oui',
									Bl: $author$project$I18n$Cles$editeurDeSchemaGroupeRepetableOui(i18n)
								},
									{
									vx: 'non',
									Bl: $author$project$I18n$Cles$editeurDeSchemaGroupeRepetableNon(i18n)
								}
								])
						}),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$bibliothequeGroupeRepetableNote(i18n))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$fieldset,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$legend,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$editeurDeSchemaGroupeOccurrence(i18n))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$input,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
								$rtfeldman$elm_css$Html$Styled$Attributes$value(brouillon.Bq),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Parametrage$NouveauChamp$Formulaire$OccurrenceSaisie)
							]),
						_List_Nil)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$fieldset,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$legend,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$editeurDeSchemaGroupeGenre(i18n))
									]))
							])),
						$author$project$Components$Shared$Segment$View$view(
						{
							vd: $author$project$Components$Shared$GenreDuNom$code(brouillon.z9),
							Bi: $author$project$I18n$Cles$editeurDeSchemaGroupeGenre(i18n),
							Dj: 'champ-a-creer-genre',
							Ea: function (texte) {
								return $author$project$Components$Parametrage$NouveauChamp$Formulaire$GenreChoisi(
									A2(
										$elm$core$Maybe$withDefault,
										brouillon.z9,
										$author$project$Components$Shared$GenreDuNom$deCode(texte)));
							},
							o_: _List_fromArray(
								[
									{
									vx: $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$genreFeminin,
									Bl: $author$project$I18n$Cles$editeurDeSchemaGroupeGenreFeminin(i18n)
								},
									{
									vx: $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$genreMasculin,
									Bl: $author$project$I18n$Cles$editeurDeSchemaGroupeGenreMasculin(i18n)
								}
								])
						})
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$map,
				$author$project$Components$Parametrage$NouveauChamp$Formulaire$DesSousChamps,
				A3(
					$author$project$Components$Shared$EditeurDeSchema$SousChamps$view,
					i18n,
					{
						n_: A2($author$project$Components$Parametrage$NouveauChamp$Formulaire$listesOffertes, contexte, brouillon),
						pv: 'champ-a-creer',
						HI: brouillon.HI,
						ib: contexte.ib
					},
					brouillon.IX))
			]) : _List_Nil))));
	});
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$EtageCoche = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$I18n$Cles$bibliothequeNouveauChampEtageGamme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.etage-gamme', _List_Nil, 'saisi sur la fiche de la gamme');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampEtageMarque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.etage-marque', _List_Nil, 'saisi sur la fiche de la marque');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampEtageType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.etage-type', _List_Nil, 'saisi sur la fiche de la catégorie');
};
var $author$project$Catalogue$Vocabulaire$aideDeLEtageDuNouveauChamp = F2(
	function (i18n, etage) {
		switch (etage) {
			case 'marque':
				return $author$project$I18n$Cles$bibliothequeNouveauChampEtageMarque(i18n);
			case 'gamme':
				return $author$project$I18n$Cles$bibliothequeNouveauChampEtageGamme(i18n);
			default:
				return $author$project$I18n$Cles$bibliothequeNouveauChampEtageType(i18n);
		}
	});
var $author$project$I18n$Cles$bibliothequeNouveauChampEtages = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.etages', _List_Nil, 'Étages concernés');
};
var $author$project$I18n$Cles$bibliothequeNouveauChampEtagesNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.nouveau-champ.etages-note', _List_Nil, 'Le champ se saisit à l\'étage choisi et se transmet vers le bas : gammes, références, portails.');
};
var $author$project$I18n$Cles$produitsInformationsRattacherEtageGamme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.rattacher.etage.gamme', _List_Nil, 'Gamme');
};
var $author$project$I18n$Cles$produitsInformationsRattacherEtageMarque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.rattacher.etage.marque', _List_Nil, 'Marque');
};
var $author$project$I18n$Cles$produitsInformationsRattacherEtageProduit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.rattacher.etage.produit', _List_Nil, 'Produits');
};
var $author$project$I18n$Cles$produitsInformationsRattacherEtageType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.rattacher.etage.type', _List_Nil, 'Catégorie');
};
var $author$project$Catalogue$Vocabulaire$etageAdmisAuRattachement = F2(
	function (i18n, code) {
		switch (code) {
			case 'produit':
				return $author$project$I18n$Cles$produitsInformationsRattacherEtageProduit(i18n);
			case 'marque':
				return $author$project$I18n$Cles$produitsInformationsRattacherEtageMarque(i18n);
			case 'gamme':
				return $author$project$I18n$Cles$produitsInformationsRattacherEtageGamme(i18n);
			case 'type':
				return $author$project$I18n$Cles$produitsInformationsRattacherEtageType(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$etagesConcernes = F2(
	function (i18n, brouillon) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$bibliothequeNouveauChampEtages(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('bloc')
						]),
					A2(
						$elm$core$List$map,
						function (etage) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$label,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('pick'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('pick-ligne'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('etage')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$input,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id('champ-a-creer-etage-' + etage),
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
												$rtfeldman$elm_css$Html$Styled$Attributes$checked(
												A2($elm$core$List$member, etage, brouillon.yG)),
												$rtfeldman$elm_css$Html$Styled$Events$onCheck(
												$author$project$Components$Parametrage$NouveauChamp$Formulaire$EtageCoche(etage))
											]),
										_List_Nil),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$b,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2($author$project$Catalogue$Vocabulaire$etageAdmisAuRattachement, i18n, etage))
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2($author$project$Catalogue$Vocabulaire$aideDeLEtageDuNouveauChamp, i18n, etage))
											]))
									]));
						},
						$author$project$Catalogue$Vocabulaire$etagesDeLaBibliotheque)),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$bibliothequeNouveauChampEtagesNote(i18n))
						]))
				]));
	});
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$CollectionChoisie = function (a) {
	return {$: 2, a: a};
};
var $author$project$I18n$Cles$bibliothequeReglagesCollection = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reglages.collection', _List_Nil, 'Collection');
};
var $author$project$I18n$Cles$bibliothequeReglagesCollectionAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reglages.collection.aide', _List_Nil, 'Facultatif. Seules les collections de la portée du champ sont proposées. Sans collection, le champ apparaît dans « Autres champs » des fiches.');
};
var $author$project$I18n$Cles$bibliothequeReglagesCollectionAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reglages.collection.aucune', _List_Nil, 'Aucune');
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$listeDesCollections = F3(
	function (i18n, contexte, brouillon) {
		var admises = A2(
			$elm$core$List$filter,
			function (c) {
				return (brouillon.F$ === 'catalogue-et-parties-prenantes') || _Utils_eq(c.F$, brouillon.F$);
			},
			contexte.vE);
		return (contexte.F1 && ((brouillon.F$ !== 'parties-prenantes') || $elm$core$List$isEmpty(admises))) ? _List_Nil : _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Champ$View$liste,
				{
					go: $elm$core$Maybe$Nothing,
					Aq: 'champ-a-creer-collection',
					Bl: $author$project$I18n$Cles$bibliothequeReglagesCollection(i18n),
					he: false
				},
				{
					hg: function (cle) {
						return $author$project$Components$Parametrage$NouveauChamp$Formulaire$CollectionChoisie(
							(cle === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(cle));
					},
					o_: A2(
						$elm$core$List$cons,
						{
							Bl: $author$project$I18n$Cles$bibliothequeReglagesCollectionAucune(i18n),
							fm: ''
						},
						A2(
							$elm$core$List$map,
							function (c) {
								return {Bl: c.Bl, fm: c.dy};
							},
							admises)),
					fm: A2($elm$core$Maybe$withDefault, '', brouillon.vD)
				}),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$bibliothequeReglagesCollectionAide(i18n))
					]))
			]);
	});
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$TypeChoisi = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$listeDesTypes = F3(
	function (i18n, contexte, brouillon) {
		return A2(
			$author$project$Components$Shared$Champ$View$liste,
			{go: $elm$core$Maybe$Nothing, Aq: 'champ-a-creer-type', Bl: contexte.nA, he: false},
			{
				hg: $author$project$Components$Parametrage$NouveauChamp$Formulaire$TypeChoisi,
				o_: A2(
					$elm$core$List$map,
					function (t) {
						return {
							Bl: A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeDeChamp, i18n, t.vx),
							fm: t.vx
						};
					},
					contexte.J_),
				fm: brouillon.JR
			});
	});
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$siPorteeLibre = F2(
	function (contexte, lignes) {
		return contexte.F1 ? _List_Nil : lignes;
	});
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$suiteDuFormulaire = F4(
	function (i18n, contexte, brouillon, admis) {
		return _Utils_ap(
			_List_Nil,
			_Utils_ap(
				A2(
					$author$project$Components$Parametrage$NouveauChamp$Formulaire$siPorteeLibre,
					contexte,
					_Utils_ap(
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$bibliothequeReglagesPortee(i18n))
											])),
										$author$project$Components$Shared$Segment$View$view(
										{
											vd: brouillon.ao ? 'etages' : brouillon.F$,
											Bi: $author$project$I18n$Cles$bibliothequeReglagesPortee(i18n),
											Dj: 'champ-a-creer-portee',
											Ea: $author$project$Components$Parametrage$NouveauChamp$Formulaire$PorteeChoisie,
											o_: _List_fromArray(
												[
													{
													vx: 'catalogue',
													Bl: A2($author$project$Components$Parametrage$Vocabulaire$porteeDeLaBibliotheque, i18n, 'catalogue')
												},
													{
													vx: 'parties-prenantes',
													Bl: A2($author$project$Components$Parametrage$Vocabulaire$porteeDeLaBibliotheque, i18n, 'parties-prenantes')
												},
													{
													vx: 'catalogue-et-parties-prenantes',
													Bl: A2($author$project$Components$Parametrage$Vocabulaire$porteeDeLaBibliotheque, i18n, 'catalogue-et-parties-prenantes')
												},
													{
													vx: 'etages',
													Bl: $author$project$I18n$Cles$bibliothequeNouveauChampPorteeEtages(i18n)
												}
												])
										})
									]))
							]),
						_Utils_ap(
							brouillon.ao ? _List_fromArray(
								[
									A2($author$project$Components$Parametrage$NouveauChamp$Formulaire$etagesConcernes, i18n, brouillon)
								]) : _List_Nil,
							A3($author$project$Components$Parametrage$NouveauChamp$Formulaire$listeDesCollections, i18n, contexte, brouillon)))),
				_Utils_ap(
					function () {
						if (contexte.F1) {
							var collection = A3($author$project$Components$Parametrage$NouveauChamp$Formulaire$listeDesCollections, i18n, contexte, brouillon);
							return _Utils_ap(
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('type-et-collection')
											]),
										A2(
											$elm$core$List$cons,
											A3($author$project$Components$Parametrage$NouveauChamp$Formulaire$listeDesTypes, i18n, contexte, brouillon),
											A2($elm$core$List$take, 1, collection)))
									]),
								A2($elm$core$List$drop, 1, collection));
						} else {
							return _List_fromArray(
								[
									A3($author$project$Components$Parametrage$NouveauChamp$Formulaire$listeDesTypes, i18n, contexte, brouillon)
								]);
						}
					}(),
					_Utils_ap(
						(contexte.F1 && _Utils_eq(brouillon.JR, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeListeUnique)) ? _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$bibliothequeNouveauChampListeUniqueNote(i18n))
									]))
							]) : _List_Nil,
						_Utils_ap(
							A3($author$project$Components$Parametrage$NouveauChamp$Formulaire$ceQueLeTypeDemande, i18n, contexte, brouillon),
							_Utils_ap(
								(admis.zG || admis.G1) ? _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$bibliothequeReglagesRecherche(i18n))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('bloc')
													]),
												_List_fromArray(
													[
														admis.zG ? A2(
														$author$project$Components$Parametrage$NouveauChamp$Formulaire$cartouche,
														'champ-a-creer-filtrable',
														{
															vt: brouillon.zG,
															oJ: $author$project$I18n$Cles$bibliothequeReglagesFiltrableNote(i18n),
															D9: $author$project$Components$Parametrage$NouveauChamp$Formulaire$FiltrableCoche,
															h6: $author$project$I18n$Cles$bibliothequeReglagesFiltrable(i18n)
														}) : $rtfeldman$elm_css$Html$Styled$text(''),
														admis.G1 ? A2(
														$author$project$Components$Parametrage$NouveauChamp$Formulaire$cartouche,
														'champ-a-creer-recherchable',
														{
															vt: brouillon.G1,
															oJ: $author$project$I18n$Cles$bibliothequeNouveauChampRecherchableNote(i18n),
															D9: $author$project$Components$Parametrage$NouveauChamp$Formulaire$RecherchableCoche,
															h6: $author$project$I18n$Cles$bibliothequeReglagesRecherchable(i18n)
														}) : $rtfeldman$elm_css$Html$Styled$text('')
													]))
											]))
									]) : _List_Nil,
								contexte.kU ? _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('bloc')
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Components$Parametrage$NouveauChamp$Formulaire$cartouche,
														'champ-a-creer-donnee-personnelle',
														{
															vt: brouillon.xD,
															oJ: '',
															D9: $author$project$Components$Parametrage$NouveauChamp$Formulaire$DonneePersonnelleCochee,
															h6: $author$project$I18n$Cles$editeurDeSchemaOptionDonneePersonnelle(i18n)
														})
													]))
											]))
									]) : _List_Nil))))));
	});
var $author$project$Components$Parametrage$NouveauChamp$Formulaire$contenu = F3(
	function (i18n, contexte, brouillon) {
		var nom = A2(
			$rtfeldman$elm_css$Html$Styled$fieldset,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('mandatory')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$legend,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(contexte.nz)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Parametrage$NouveauChamp$Formulaire$idDuNom),
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(brouillon.Dj),
							$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Parametrage$NouveauChamp$Formulaire$NomSaisi)
						]),
					_List_Nil)
				]));
		var admis = A2($author$project$Components$Parametrage$NouveauChamp$Formulaire$duBack, contexte.J_, brouillon.JR);
		return ($author$project$Components$Parametrage$NouveauChamp$Formulaire$nomDejaPris(brouillon) && contexte.hB) ? _List_fromArray(
			[
				A3($author$project$Components$Parametrage$NouveauChamp$Formulaire$refusAffiche, i18n, contexte, brouillon),
				nom
			]) : _Utils_ap(
			_List_fromArray(
				[
					A3($author$project$Components$Parametrage$NouveauChamp$Formulaire$refusAffiche, i18n, contexte, brouillon),
					nom
				]),
			A4($author$project$Components$Parametrage$NouveauChamp$Formulaire$suiteDuFormulaire, i18n, contexte, brouillon, admis));
	});
var $author$project$Components$Parametrage$NouveauChamp$View$contexte = F3(
	function (i18n, ouverture, model) {
		return {
			uY: ouverture.uY,
			vE: ouverture.vE,
			cz: model.cz,
			kU: ouverture.F1 && (ouverture.F$ === 'parties-prenantes'),
			nz: A2($author$project$I18n$Cles$texte, i18n, ouverture.R.Dj),
			nA: A2($author$project$I18n$Cles$texte, i18n, ouverture.R.JR),
			n_: model.n_,
			ht: !_Utils_eq(
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUneListe, model.nS),
				$elm$core$Maybe$Nothing),
			F1: ouverture.F1,
			hB: A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(true),
					ouverture.pN)),
			ib: ouverture.ib,
			J_: ouverture.J_,
			sb: ouverture.sb
		};
	});
var $author$project$Components$Parametrage$NouveauChamp$View$nomPrisRattachable = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$always(true),
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.pN;
				},
				model.ew))) && A2(
		$elm$core$Maybe$withDefault,
		false,
		A2($elm$core$Maybe$map, $author$project$Components$Parametrage$NouveauChamp$Formulaire$nomDejaPris, model.uw));
};
var $author$project$Components$Parametrage$NouveauChamp$View$drawerDuChamp = F2(
	function (i18n, model) {
		var sousTitre = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.aO;
					},
					$author$project$I18n$Cles$texte(i18n)),
				model.ew));
		var contenu = {
			fs: {
				sR: !$author$project$API$Envoi$enCours(model.l2),
				Bl: A2(
					$elm$core$Maybe$withDefault,
					$author$project$I18n$Cles$bibliothequeGroupeAction(i18n),
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.R;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.fs;
								},
								$author$project$I18n$Cles$texte(i18n))),
						model.ew)),
				C$: $author$project$Components$Parametrage$NouveauChamp$Update$ChampCree
			},
			fZ: A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A3(
					$elm$core$Maybe$map2,
					F2(
						function (ouverture, brouillon) {
							return _Utils_ap(
								A2($author$project$Components$Parametrage$NouveauChamp$View$basculeEtBandeau, i18n, ouverture),
								A2(
									$elm$core$List$map,
									$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Parametrage$NouveauChamp$Update$DuChamp),
									A3(
										$author$project$Components$Parametrage$NouveauChamp$Formulaire$contenu,
										i18n,
										A3($author$project$Components$Parametrage$NouveauChamp$View$contexte, i18n, ouverture, model),
										brouillon)));
						}),
					model.ew,
					model.uw)),
			A6: $elm$core$Maybe$Nothing,
			Bc: !A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.F1;
					},
					model.ew)),
			h6: A2(
				$elm$core$Maybe$withDefault,
				$author$project$I18n$Cles$bibliothequeGroupeTitre(i18n),
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.h6;
						},
						$author$project$I18n$Cles$texte(i18n)),
					model.ew))
		};
		return $author$project$Components$Parametrage$NouveauChamp$View$nomPrisRattachable(model) ? A6(
			$author$project$Components$Shared$Drawer$View$viewAvecPiedLibreEtSousTitre,
			i18n,
			sousTitre,
			{
				oJ: $elm$core$Maybe$Just(
					$author$project$I18n$Cles$bibliothequeNouveauChampNomPrisRienCree(i18n)),
				HF: function (attributs) {
					return A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_Utils_ap(
							attributs,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$NouveauChamp$Update$AutreNomVoulu)
								])),
						$author$project$I18n$Cles$bibliothequeNouveauChampNomPrisAutreNom(i18n));
				},
				Jb: _List_Nil
			},
			$author$project$Components$Parametrage$NouveauChamp$Update$DuDrawerDuChamp,
			_Utils_update(
				contenu,
				{
					fs: {
						sR: !$author$project$API$Envoi$enCours(model.l2),
						Bl: $author$project$I18n$Cles$bibliothequeNouveauChampNomPrisRattacher(i18n),
						C$: $author$project$Components$Parametrage$NouveauChamp$Update$ChampExistantVoulu
					}
				}),
			model.lp) : A6(
			$author$project$Components$Shared$Drawer$View$viewAvecSousTitreEtNote,
			i18n,
			$elm$core$Maybe$Just(sousTitre),
			A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.JR;
						},
						$elm$core$Basics$eq($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeListeUnique)),
					model.uw)) ? $elm$core$Maybe$Just(
				$author$project$I18n$Cles$bibliothequeNouveauChampListePied(i18n)) : $elm$core$Maybe$Nothing,
			$author$project$Components$Parametrage$NouveauChamp$Update$DuDrawerDuChamp,
			contenu,
			model.lp);
	});
var $author$project$Components$Parametrage$NouveauChamp$View$dialogues = F3(
	function (i18n, vers, model) {
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$map,
				vers,
				A2($author$project$Components$Parametrage$NouveauChamp$View$drawerDuChamp, i18n, model)),
				A2(
				$rtfeldman$elm_css$Html$Styled$map,
				vers,
				A2($author$project$Components$Parametrage$NouveauChamp$View$drawerDeLaListe, i18n, model))
			]);
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ChampLaisse = {$: 10};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$RepriseDemandee = {$: 11};
var $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesIssueLaisser = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.parties-prenantes.issue-laisser', _List_Nil, 'Laisser ce champ tel quel');
};
var $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesReprendreEtRattacher = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.parties-prenantes.reprendre-et-rattacher', _List_Nil, 'Rattacher et reprendre');
};
var $author$project$I18n$Cles$bibliothequeRepriseReprendre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.reprendre', _List_Nil, 'Reprendre');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ConfirmationCochee = function (a) {
	return {$: 9, a: a};
};
var $author$project$I18n$Cles$bibliothequeRepriseDrawerTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reprise.drawer-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Reprendre le champ « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$bibliothequeRepriseIrreversibleTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.irreversible-titre', _List_Nil, 'Cette reprise ne s\'annule pas.');
};
var $author$project$I18n$Cles$bibliothequeRepriseOffresNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.offres-note', _List_Nil, 'La restriction d\'origine de chaque type pourra être remise en place par rattachement.');
};
var $author$project$I18n$Cles$bibliothequeRepriseTypeValeurs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reprise.type-valeurs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typeNom',
					$author$project$I18n$Traductions$Chaine(p.rZ)),
					_Utils_Tuple2(
					'valeurs',
					$author$project$I18n$Traductions$Entier(p.Ki))
				]),
			((!p.Ki) || (p.Ki === 1)) ? (p.rZ + (' · ' + (A2($author$project$I18n$Nombre$formater, 0, p.Ki) + ' valeur'))) : (p.rZ + (' · ' + (A2($author$project$I18n$Nombre$formater, 0, p.Ki) + ' valeurs'))));
	});
var $author$project$I18n$Cles$bibliothequeRepriseHorsSchema = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.hors-schema', _List_Nil, 'Valeurs saisies sur des fiches mais absentes du schéma');
};
var $author$project$I18n$Cles$bibliothequeRepriseHorsSchemaNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.hors-schema-note', _List_Nil, 'Aucune fiche n\'est modifiée. Une valeur laissée reste affichée sur la fiche, marquée « non reconnue ».');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ChoixFait = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$ChoixRapprocher = function (a) {
	return {$: 1, a: a};
};
var $author$project$I18n$Cles$bibliothequeRepriseFiches = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reprise.fiches',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fiches',
					$author$project$I18n$Traductions$Entier(p.zu))
				]),
			((!p.zu) || (p.zu === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.zu) + ' fiche') : (A2($author$project$I18n$Nombre$formater, 0, p.zu) + ' fiches'));
	});
var $author$project$I18n$Cles$bibliothequeRepriseHorsSchemaTag = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.hors-schema-tag', _List_Nil, 'hors schéma');
};
var $author$project$I18n$Cles$bibliothequeRepriseIssueAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.issue-ajouter', _List_Nil, 'Ajouter à la liste');
};
var $author$project$I18n$Cles$bibliothequeRepriseIssueLaisser = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.issue-laisser', _List_Nil, 'Laisser');
};
var $author$project$I18n$Cles$bibliothequeRepriseIssueRapprocher = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.issue-rapprocher', _List_Nil, 'Rapprocher de…');
};
var $author$project$I18n$Cles$bibliothequeRepriseRapprocherDe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.rapprocher-de', _List_Nil, 'Rapprocher de');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$isRapprocher = function (choix) {
	if (choix.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$uneHorsSchema = F5(
	function (i18n, prefixe, model, proposition, n) {
		var premiere = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				$elm$core$List$head(proposition.Ki)));
		var issue = F3(
			function (libelle, choix, actif) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-pressed',
							actif ? 'true' : 'false'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$ChoixFait, n.fm, choix))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						]));
			});
		var choisi = A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$choixDe, n.fm, model);
		var rapproche = function () {
			if (choisi.$ === 1) {
				var avec = choisi.a;
				return avec;
			} else {
				return premiere;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('hors-schema')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('« ' + (n.fm + ' » ')),
										A2(
										$author$project$Components$Shared$Tag$View$view,
										1,
										$author$project$I18n$Cles$bibliothequeRepriseHorsSchemaTag(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$bibliothequeRepriseFiches,
											i18n,
											{zu: n.zu}))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('issues')
							]),
						_List_fromArray(
							[
								A3(
								issue,
								$author$project$I18n$Cles$bibliothequeRepriseIssueAjouter(i18n),
								$author$project$Components$Parametrage$BibliothequeDeChamps$Model$ChoixAjouter,
								_Utils_eq(choisi, $author$project$Components$Parametrage$BibliothequeDeChamps$Model$ChoixAjouter)),
								A3(
								issue,
								$author$project$I18n$Cles$bibliothequeRepriseIssueRapprocher(i18n),
								$author$project$Components$Parametrage$BibliothequeDeChamps$Model$ChoixRapprocher(rapproche),
								$author$project$Components$Parametrage$BibliothequeDeChamps$View$isRapprocher(choisi)),
								A3(
								issue,
								$author$project$I18n$Cles$bibliothequeRepriseIssueLaisser(i18n),
								$author$project$Components$Parametrage$BibliothequeDeChamps$Model$ChoixLaisser,
								_Utils_eq(choisi, $author$project$Components$Parametrage$BibliothequeDeChamps$Model$ChoixLaisser))
							]))
					]),
				$author$project$Components$Parametrage$BibliothequeDeChamps$View$isRapprocher(choisi) ? _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Champ$View$liste,
						{
							go: $elm$core$Maybe$Nothing,
							Aq: prefixe + ('-rapprocher-' + n.fm),
							Bl: $author$project$I18n$Cles$bibliothequeRepriseRapprocherDe(i18n),
							he: false
						},
						{
							hg: function (avec) {
								return A2(
									$author$project$Components$Parametrage$BibliothequeDeChamps$Update$ChoixFait,
									n.fm,
									$author$project$Components$Parametrage$BibliothequeDeChamps$Model$ChoixRapprocher(avec));
							},
							o_: A2(
								$elm$core$List$map,
								function (v) {
									return {Bl: v.Bl, fm: v.Bl};
								},
								proposition.Ki),
							fm: rapproche
						})
					]) : _List_Nil));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$horsSchema = F4(
	function (i18n, prefixe, model, proposition) {
		return _Utils_eq(proposition.oH, _List_Nil) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$bibliothequeRepriseHorsSchema(i18n))
						])),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						A4($author$project$Components$Parametrage$BibliothequeDeChamps$View$uneHorsSchema, i18n, prefixe, model, proposition),
						proposition.oH),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$bibliothequeRepriseHorsSchemaNote(i18n))
								]))
						]))));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$NomSaisi = function (a) {
	return {$: 6, a: a};
};
var $author$project$I18n$Cles$bibliothequeRepriseListeCreee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.liste-creee', _List_Nil, 'Liste créée dans la bibliothèque');
};
var $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesListeExistanteDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reprise.parties-prenantes.liste-existante-detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'portee',
					$author$project$I18n$Traductions$Chaine(p.F$))
				]),
			'Portée : ' + (p.F$ + '. Choisissez l\'issue pour ce champ.'));
	});
var $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesListeExistanteTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reprise.parties-prenantes.liste-existante-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Une liste « ' + (p.Dj + ' » existe déjà'));
	});
var $author$project$I18n$Cles$bibliothequeRepriseValeursFusionnees = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reprise.valeurs-fusionnees',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeurs',
					$author$project$I18n$Traductions$Entier(p.Ki))
				]),
			((!p.Ki) || (p.Ki === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.Ki) + ' valeur après fusion') : (A2($author$project$I18n$Nombre$formater, 0, p.Ki) + ' valeurs après fusion'));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$IssueDuNomChoisie = function (a) {
	return {$: 8, a: a};
};
var $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesIssueAutreNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.parties-prenantes.issue-autre-nom', _List_Nil, 'Créer une liste sous un autre nom');
};
var $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesIssueAutreNomDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.parties-prenantes.issue-autre-nom-detail', _List_Nil, 'Nom à saisir.');
};
var $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesIssueLaisserDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.parties-prenantes.issue-laisser-detail', _List_Nil, 'Rien n\'est repris : les types gardent leur liste fermée.');
};
var $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesIssueLegende = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.parties-prenantes.issue-legende', _List_Nil, 'Issue pour ce champ');
};
var $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesIssuePropose = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.parties-prenantes.issue-propose', _List_Nil, 'Proposé');
};
var $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesIssueRattacher = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.parties-prenantes.issue-rattacher', _List_Nil, 'Rattacher à la liste existante');
};
var $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesIssueRattacherDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reprise.parties-prenantes.issue-rattacher-detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'portee',
					$author$project$I18n$Traductions$Chaine(p.F$))
				]),
			'Les types de partie prenante utilisent « ' + (p.Dj + (' ». Sa portée passe à ' + (p.F$ + '. Ses valeurs sont conservées, les valeurs nouvelles y sont ajoutées.'))));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$issueEnTexte = function (issue) {
	switch (issue) {
		case 0:
			return 'rattacher';
		case 1:
			return 'autre-nom';
		default:
			return 'laisser';
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$issuesDuNom = F4(
	function (i18n, prefixe, model, liste) {
		var issue = F4(
			function (issueChoisie, titre, detail, propose) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('issue'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'choisie',
									_Utils_eq(model.cR, issueChoisie))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
									$rtfeldman$elm_css$Html$Styled$Attributes$name(prefixe + '-issue'),
									$rtfeldman$elm_css$Html$Styled$Attributes$value(
									$author$project$Components$Parametrage$BibliothequeDeChamps$View$issueEnTexte(issueChoisie)),
									$rtfeldman$elm_css$Html$Styled$Attributes$checked(
									_Utils_eq(model.cR, issueChoisie)),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Parametrage$BibliothequeDeChamps$Update$IssueDuNomChoisie(issueChoisie))
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(titre)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(detail)
										]))
								])),
							propose ? A2(
							$author$project$Components$Shared$Tag$View$view,
							5,
							$author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesIssuePropose(i18n)) : $rtfeldman$elm_css$Html$Styled$text('')
						]));
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$fieldset,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('issues-du-nom'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'radiogroup')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$legend,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesIssueLegende(i18n))
								]))
						])),
					A4(
					issue,
					0,
					$author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesIssueRattacher(i18n),
					A2(
						$author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesIssueRattacherDetail,
						i18n,
						{
							Dj: liste.Dj,
							F$: A2($author$project$Components$Parametrage$Vocabulaire$porteeDeLaBibliotheque, i18n, liste.F0)
						}),
					true),
					A4(
					issue,
					1,
					$author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesIssueAutreNom(i18n),
					$author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesIssueAutreNomDetail(i18n),
					false),
					A4(
					issue,
					2,
					$author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesIssueLaisser(i18n),
					$author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesIssueLaisserDetail(i18n),
					false)
				]));
	});
var $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesPorteeActuelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.parties-prenantes.portee-actuelle', _List_Nil, 'Portée actuelle');
};
var $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesPorteeApres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.parties-prenantes.portee-apres', _List_Nil, 'Portée après reprise');
};
var $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesValeursApres = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reprise.parties-prenantes.valeurs-apres',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE)),
					_Utils_Tuple2(
					'ajoutees',
					$author$project$I18n$Traductions$Entier(p.iI))
				]),
			((!p.iI) || (p.iI === 1)) ? ('Valeurs de la liste après rattachement (' + (p.JE + (' dont ' + (A2($author$project$I18n$Nombre$formater, 0, p.iI) + ' ajoutée)')))) : ('Valeurs de la liste après rattachement (' + (p.JE + (' dont ' + (A2($author$project$I18n$Nombre$formater, 0, p.iI) + ' ajoutées)')))));
	});
var $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesValeurNouvelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.parties-prenantes.valeur-nouvelle', _List_Nil, 'nouvelle');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$uneValeurApresRattachement = F2(
	function (i18n, valeur) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(valeur.Bl),
					$rtfeldman$elm_css$Html$Styled$text(' '),
					function () {
					var _v0 = _Utils_Tuple2(valeur.oS, valeur.zu);
					if (_v0.a) {
						return A2(
							$author$project$Components$Shared$Tag$View$view,
							5,
							$author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesValeurNouvelle(i18n));
					} else {
						if (!_v0.b.$) {
							var fiches = _v0.b.a;
							return A2(
								$rtfeldman$elm_css$Html$Styled$small,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$bibliothequeRepriseFiches,
											i18n,
											{zu: fiches}))
									]));
						} else {
							var _v1 = _v0.b;
							return $rtfeldman$elm_css$Html$Styled$text('');
						}
					}
				}()
				]));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$porteesEtValeurs = F3(
	function (i18n, liste, proposition) {
		var valeurs = $author$project$Components$Parametrage$BibliothequeDeChamps$Model$valeursApresRattachement(proposition);
		var ajoutees = $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function ($) {
					return $.oS;
				},
				valeurs));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('rattachement-detail')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('portees')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('avant')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesPorteeActuelle(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$Components$Parametrage$Vocabulaire$porteeDeLaBibliotheque, i18n, liste.F$))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('fleche'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('›')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('apres')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesPorteeApres(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$Components$Parametrage$Vocabulaire$porteeDeLaBibliotheque, i18n, liste.F0))
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesValeursApres,
										i18n,
										{
											iI: ajoutees,
											JE: $elm$core$String$fromInt(
												$elm$core$List$length(valeurs))
										}))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('valeurs-fusionnees')
								]),
							A2(
								$elm$core$List$map,
								$author$project$Components$Parametrage$BibliothequeDeChamps$View$uneValeurApresRattachement(i18n),
								valeurs))
						]))
				]));
	});
var $author$project$I18n$Cles$bibliothequeRepriseRattacher = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.rattacher', _List_Nil, 'Une liste porte déjà ce nom. La reprise la rattachera : aucune valeur n\'est dupliquée.');
};
var $author$project$I18n$Cles$bibliothequeRepriseRattacherAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.rattacher-action', _List_Nil, 'Rattacher la liste existante');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$rattachement = F4(
	function (i18n, prefixe, model, proposition) {
		var _v0 = proposition.nZ;
		if (!_v0.$) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('rattachement')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$bibliothequeRepriseRattacher(i18n))
							])),
						A2(
						$author$project$Components$Shared$Champ$View$caseACocher,
						{
							go: $elm$core$Maybe$Nothing,
							Aq: prefixe + '-rattacher',
							Bl: $author$project$I18n$Cles$bibliothequeRepriseRattacherAction(i18n),
							he: false
						},
						{
							vt: !model.cR,
							D9: function (coche) {
								return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$IssueDuNomChoisie(
									coche ? 0 : 1);
							}
						})
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$uneValeurFusionnee = F2(
	function (i18n, valeur) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(valeur.Bl),
					$rtfeldman$elm_css$Html$Styled$text(' '),
					A2(
					$rtfeldman$elm_css$Html$Styled$small,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$bibliothequeRepriseFiches,
								i18n,
								{zu: valeur.zu}))
						]))
				]));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$nomEtValeurs = F5(
	function (i18n, prefixe, model, textes, proposition) {
		var fusionnees = A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$bibliothequeRepriseValeursFusionnees,
								i18n,
								{
									Ki: $elm$core$List$length(proposition.Ki)
								})),
							$rtfeldman$elm_css$Html$Styled$text(' '),
							A2(
							$rtfeldman$elm_css$Html$Styled$small,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(textes.Kp)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('valeurs-fusionnees')
						]),
					A2(
						$elm$core$List$map,
						$author$project$Components$Parametrage$BibliothequeDeChamps$View$uneValeurFusionnee(i18n),
						proposition.Ki))
				]));
		var champNom = A2(
			$author$project$Components$Shared$Champ$View$texte,
			{
				go: A2(
					$elm$core$Maybe$map,
					$author$project$I18n$Cles$texte(i18n),
					model.pZ),
				Aq: prefixe + '-nom',
				Bl: $author$project$I18n$Cles$bibliothequeRepriseListeCreee(i18n),
				he: true
			},
			{hg: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$NomSaisi, fm: model.Dj});
		var _v0 = _Utils_Tuple2(model.cC, proposition.kN);
		if ((_v0.a === 1) && (!_v0.b.$)) {
			var _v1 = _v0.a;
			var liste = _v0.b.a;
			return _Utils_ap(
				_List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('liste-existante')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesListeExistanteTitre,
													i18n,
													{Dj: liste.Dj}))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesListeExistanteDetail,
													i18n,
													{
														F$: A2($author$project$Components$Parametrage$Vocabulaire$porteeDeLaBibliotheque, i18n, liste.F$)
													}))
											]))
									]))
							])),
						A4($author$project$Components$Parametrage$BibliothequeDeChamps$View$issuesDuNom, i18n, prefixe, model, liste)
					]),
				function () {
					var _v2 = model.cR;
					switch (_v2) {
						case 0:
							return _List_fromArray(
								[
									A3($author$project$Components$Parametrage$BibliothequeDeChamps$View$porteesEtValeurs, i18n, liste, proposition)
								]);
						case 1:
							return _List_fromArray(
								[champNom, fusionnees]);
						default:
							return _List_Nil;
					}
				}());
		} else {
			return _List_fromArray(
				[
					champNom,
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(textes.F$)
						])),
					A4($author$project$Components$Parametrage$BibliothequeDeChamps$View$rattachement, i18n, prefixe, model, proposition),
					fusionnees
				]);
		}
	});
var $author$project$I18n$Cles$bibliothequeRepriseNonReprisTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.non-repris-titre', _List_Nil, 'Champs non repris');
};
var $author$project$I18n$Cles$bibliothequeRepriseNonReprisDefinitionDifferente = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.non-repris.definition-differente', _List_Nil, 'Définition différente');
};
var $author$project$I18n$Cles$bibliothequeRepriseNonReprisDefinitionDifferenteDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.non-repris.definition-differente-detail', _List_Nil, 'Les valeurs autorisées ne correspondent pas à celles du même champ des autres types.');
};
var $author$project$I18n$Cles$bibliothequeRepriseNonReprisDonneePersonnelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.non-repris.donnee-personnelle', _List_Nil, 'Champ personnel');
};
var $author$project$I18n$Cles$bibliothequeRepriseNonReprisDonneePersonnelleDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.non-repris.donnee-personnelle-detail', _List_Nil, 'Un champ personnel est chiffré : il n\'est jamais repris dans une liste partagée. Il reste tel quel sur son type.');
};
var $author$project$Components$Parametrage$Vocabulaire$raisonDeNonReprise = F2(
	function (i18n, raison) {
		switch (raison) {
			case 'donnee-personnelle':
				return {
					bB: $author$project$I18n$Cles$bibliothequeRepriseNonReprisDonneePersonnelleDetail(i18n),
					Bl: $author$project$I18n$Cles$bibliothequeRepriseNonReprisDonneePersonnelle(i18n)
				};
			case 'definition-differente':
				return {
					bB: $author$project$I18n$Cles$bibliothequeRepriseNonReprisDefinitionDifferenteDetail(i18n),
					Bl: $author$project$I18n$Cles$bibliothequeRepriseNonReprisDefinitionDifferente(i18n)
				};
			default:
				var autre = raison;
				return {bB: '', Bl: autre};
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$nonReprisDuDrawer = F2(
	function (i18n, model) {
		var nonRepris = (model.cC === 1) ? A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.DN;
				},
				model.eS)) : _List_Nil;
		return _Utils_eq(nonRepris, _List_Nil) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('non-repris')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$bibliothequeRepriseNonReprisTitre(i18n))
						])),
				A2(
					$elm$core$List$map,
					function (n) {
						var raison = A2($author$project$Components$Parametrage$Vocabulaire$raisonDeNonReprise, i18n, n.pH);
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('non-repris-ligne')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$strong,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(n.dy)
												])),
											$rtfeldman$elm_css$Html$Styled$text(' · '),
											$rtfeldman$elm_css$Html$Styled$text(n.Dj),
											$rtfeldman$elm_css$Html$Styled$text(' '),
											A2($author$project$Components$Shared$Tag$View$view, 1, raison.Bl)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(raison.bB)
										]))
								]));
					},
					nonRepris)));
	});
var $author$project$I18n$Cles$bibliothequeRepriseConfirmer = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reprise.confirmer',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'types',
					$author$project$I18n$Traductions$Entier(p.ib))
				]),
			((!p.ib) || (p.ib === 1)) ? ('Je confirme la reprise de « ' + (p.Dj + (' » dans ' + (A2($author$project$I18n$Nombre$formater, 0, p.ib) + ' type')))) : ('Je confirme la reprise de « ' + (p.Dj + (' » dans ' + (A2($author$project$I18n$Nombre$formater, 0, p.ib) + ' types')))));
	});
var $author$project$I18n$Cles$bibliothequeRepriseDrawerDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.drawer-detail', _List_Nil, 'Aperçu en lecture seule. Rien n\'est écrit tant que vous ne confirmez pas.');
};
var $author$project$I18n$Cles$bibliothequeRepriseDroit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.droit', _List_Nil, 'Droit requis : paramétrage du catalogue');
};
var $author$project$I18n$Cles$bibliothequeRepriseIrreversibleDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.irreversible-detail', _List_Nil, 'La liste pourra ensuite être complétée, renommée ou masquée ; rien ne s\'y supprime. Les fiches existantes gardent leur historique.');
};
var $author$project$I18n$Cles$bibliothequeRepriseOffreLigne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reprise.offre-ligne',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeurs',
					$author$project$I18n$Traductions$Entier(p.Ki)),
					_Utils_Tuple2(
					'apres',
					$author$project$I18n$Traductions$Chaine(p.iY))
				]),
			((!p.Ki) || (p.Ki === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.Ki) + (' valeur → ' + p.iY)) : (A2($author$project$I18n$Nombre$formater, 0, p.Ki) + (' valeurs → ' + p.iY)));
	});
var $author$project$I18n$Cles$bibliothequeRepriseOffresTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.offres-titre', _List_Nil, 'Les offres changent jusqu\'à la restriction par rattachement');
};
var $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesConfirmer = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reprise.parties-prenantes.confirmer',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Je confirme la reprise de « ' + (p.Dj + ' » dans une liste partagée.'));
	});
var $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesDrawerDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.parties-prenantes.drawer-detail', _List_Nil, 'Types de partie prenante. Aperçu en lecture seule. Rien n\'est écrit tant que vous ne confirmez pas.');
};
var $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesDroit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.parties-prenantes.droit', _List_Nil, 'Droit requis : Paramétrage des parties prenantes');
};
var $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesIrreversibleDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.parties-prenantes.irreversible-detail', _List_Nil, 'La liste pourra ensuite être complétée, renommée ou masquée ; rien ne s\'y supprime. Aucune fiche de partie prenante n\'est réécrite.');
};
var $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesOffreLigne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reprise.parties-prenantes.offre-ligne',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'avant',
					$author$project$I18n$Traductions$Chaine(p.je)),
					_Utils_Tuple2(
					'apres',
					$author$project$I18n$Traductions$Chaine(p.iY))
				]),
			p.je + (' → ' + (p.iY + ' valeurs')));
	});
var $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesOffresTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.parties-prenantes.offres-titre', _List_Nil, 'Les offres changent');
};
var $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesPorteeNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.parties-prenantes.portee-note', _List_Nil, 'Portée : parties prenantes. Si le nom existe déjà, vous pourrez rattacher la liste existante.');
};
var $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesTypes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.parties-prenantes.types', _List_Nil, 'Types de partie prenante concernés');
};
var $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesValeursSaisiesNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.parties-prenantes.valeurs-saisies-note', _List_Nil, '(majuscules et espaces ignorés : « pme » et « PME » ne font qu\'une valeur)');
};
var $author$project$I18n$Cles$bibliothequeReprisePorteeNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.portee-note', _List_Nil, 'Modifiable. Si le nom existe déjà, vous pourrez rattacher la liste existante.');
};
var $author$project$I18n$Cles$bibliothequeRepriseTypes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.types', _List_Nil, 'Types concernés');
};
var $author$project$I18n$Cles$bibliothequeRepriseValeursSaisies = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.valeurs-saisies', _List_Nil, '(majuscules et espaces ignorés : « noir » et « Noir » ne font qu\'une valeur)');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$textesDe = F2(
	function (i18n, domaine) {
		if (!domaine) {
			return {
				j7: F2(
					function (champ, proposition) {
						return A2(
							$author$project$I18n$Cles$bibliothequeRepriseConfirmer,
							i18n,
							{
								Dj: champ.Bl,
								ib: $elm$core$List$length(proposition.ib)
							});
					}),
				bB: $author$project$I18n$Cles$bibliothequeRepriseDrawerDetail(i18n),
				xP: $author$project$I18n$Cles$bibliothequeRepriseDroit(i18n),
				d7: $author$project$I18n$Cles$bibliothequeRepriseIrreversibleDetail(i18n),
				er: function (t) {
					return A2(
						$author$project$I18n$Cles$bibliothequeRepriseOffreLigne,
						i18n,
						{
							iY: $elm$core$String$fromInt(t.iY),
							Ki: t.je
						});
				},
				es: $author$project$I18n$Cles$bibliothequeRepriseOffresTitre(i18n),
				F$: $author$project$I18n$Cles$bibliothequeReprisePorteeNote(i18n),
				ib: $author$project$I18n$Cles$bibliothequeRepriseTypes(i18n),
				Kp: $author$project$I18n$Cles$bibliothequeRepriseValeursSaisies(i18n)
			};
		} else {
			return {
				j7: F2(
					function (champ, _v1) {
						return A2(
							$author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesConfirmer,
							i18n,
							{Dj: champ.Bl});
					}),
				bB: $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesDrawerDetail(i18n),
				xP: $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesDroit(i18n),
				d7: $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesIrreversibleDetail(i18n),
				er: function (t) {
					return A2(
						$author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesOffreLigne,
						i18n,
						{
							iY: $elm$core$String$fromInt(t.iY),
							je: $elm$core$String$fromInt(t.je)
						});
				},
				es: $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesOffresTitre(i18n),
				F$: $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesPorteeNote(i18n),
				ib: $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesTypes(i18n),
				Kp: $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesValeursSaisiesNote(i18n)
			};
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$corps = F5(
	function (i18n, prefixe, model, champ, proposition) {
		var textes = A2($author$project$Components$Parametrage$BibliothequeDeChamps$View$textesDe, i18n, model.cC);
		return {
			f$: _Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(textes.bB)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(textes.ib)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$ul,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('types')
									]),
								A2(
									$elm$core$List$map,
									function (t) {
										return A2(
											$rtfeldman$elm_css$Html$Styled$li,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Components$Shared$Tag$View$view,
													5,
													A2(
														$author$project$I18n$Cles$bibliothequeRepriseTypeValeurs,
														i18n,
														{rZ: t.Dj, Ki: t.je}))
												]));
									},
									proposition.ib))
							]))
					]),
				_Utils_ap(
					A5($author$project$Components$Parametrage$BibliothequeDeChamps$View$nomEtValeurs, i18n, prefixe, model, textes, proposition),
					_List_fromArray(
						[
							A4($author$project$Components$Parametrage$BibliothequeDeChamps$View$horsSchema, i18n, prefixe, model, proposition),
							A2($author$project$Components$Parametrage$BibliothequeDeChamps$View$nonReprisDuDrawer, i18n, model),
							A2(
							$author$project$Components$Shared$Note$View$view,
							1,
							$elm$core$List$singleton(
								A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('offres')
										]),
									A2(
										$elm$core$List$cons,
										A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(textes.es)
												])),
										_Utils_ap(
											A2(
												$elm$core$List$map,
												function (t) {
													return A2(
														$rtfeldman$elm_css$Html$Styled$p,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne')
															]),
														_List_fromArray(
															[
																A2(
																$rtfeldman$elm_css$Html$Styled$span,
																_List_Nil,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(t.Dj)
																	])),
																A2(
																$rtfeldman$elm_css$Html$Styled$span,
																_List_Nil,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(
																		textes.er(t))
																	]))
															]));
												},
												proposition.ib),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$bibliothequeRepriseOffresNote(i18n))
														]))
												])))))),
							A2(
							$author$project$Components$Shared$Note$View$view,
							0,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$bibliothequeRepriseIrreversibleTitre(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(textes.d7)
										]))
								])),
							A2(
							$author$project$Components$Shared$Champ$View$caseACocher,
							{
								go: $elm$core$Maybe$Nothing,
								Aq: prefixe + '-confirmation',
								Bl: A2(textes.j7, champ, proposition),
								he: false
							},
							{vt: model.v2, D9: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ConfirmationCochee}),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('droit-requis')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(textes.xP)
								]))
						]))),
			h6: A2(
				$author$project$I18n$Cles$bibliothequeRepriseDrawerTitre,
				i18n,
				{Dj: champ.Bl})
		};
	});
var $author$project$I18n$Cles$bibliothequeRepriseEffectueeAjoutees = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reprise.effectuee-ajoutees',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'ajoutees',
					$author$project$I18n$Traductions$Entier(p.iI))
				]),
			((!p.iI) || (p.iI === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.iI) + ' valeur ajoutée') : (A2($author$project$I18n$Nombre$formater, 0, p.iI) + ' valeurs ajoutées'));
	});
var $author$project$I18n$Cles$bibliothequeRepriseEffectueeFiches = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.effectuee-fiches', _List_Nil, 'Fiches réécrites');
};
var $author$project$I18n$Cles$bibliothequeRepriseEffectueeFichesNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.effectuee-fiches-note', _List_Nil, 'Les fiches existantes s\'affichent avec la valeur de la liste.');
};
var $author$project$I18n$Cles$bibliothequeRepriseEffectueeListe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reprise.effectuee-liste',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Liste « ' + (p.Dj + ' » créée dans la bibliothèque.'));
	});
var $author$project$I18n$Cles$bibliothequeRepriseEffectueeListeRattachee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reprise.effectuee-liste-rattachee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Liste « ' + (p.Dj + ' » rattachée aux types.'));
	});
var $author$project$I18n$Cles$bibliothequeRepriseEffectueeNonRepris = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.effectuee-non-repris', _List_Nil, 'Champs non repris');
};
var $author$project$I18n$Cles$bibliothequeRepriseEffectueeNonReprisVoir = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reprise.effectuee-non-repris-voir',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			p.w + ' (voir l\'aperçu)');
	});
var $author$project$I18n$Cles$bibliothequeRepriseEffectueeRapprochees = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reprise.effectuee-rapprochees',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rapprochees',
					$author$project$I18n$Traductions$Entier(p.pL))
				]),
			((!p.pL) || (p.pL === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.pL) + ' rapprochée') : (A2($author$project$I18n$Nombre$formater, 0, p.pL) + ' rapprochées'));
	});
var $author$project$I18n$Cles$bibliothequeRepriseEffectueeRejeu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.effectuee-rejeu', _List_Nil, 'Rejouer cette reprise ne change rien : le champ est déjà repris.');
};
var $author$project$I18n$Cles$bibliothequeRepriseEffectueeSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reprise.effectuee-sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Champ « ' + (p.Dj + ' », types de partie prenante.'));
	});
var $author$project$I18n$Cles$bibliothequeRepriseEffectueeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.effectuee-titre', _List_Nil, 'Reprise effectuée');
};
var $author$project$I18n$Cles$bibliothequeRepriseEffectueeTitreRattachee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.effectuee-titre-rattachee', _List_Nil, 'Liste rattachée');
};
var $author$project$I18n$Cles$bibliothequeRepriseEffectueeTypes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.effectuee-types', _List_Nil, 'Types de partie prenante');
};
var $author$project$I18n$Cles$bibliothequeRepriseEffectueeTypesMaj = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reprise.effectuee-types-maj',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'types',
					$author$project$I18n$Traductions$Entier(p.ib))
				]),
			((!p.ib) || (p.ib === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.ib) + ' type mis à jour') : (A2($author$project$I18n$Nombre$formater, 0, p.ib) + ' types mis à jour'));
	});
var $author$project$I18n$Cles$bibliothequeRepriseEffectueeValeurs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reprise.effectuee-valeurs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeurs',
					$author$project$I18n$Traductions$Entier(p.Ki))
				]),
			((!p.Ki) || (p.Ki === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.Ki) + ' valeur') : (A2($author$project$I18n$Nombre$formater, 0, p.Ki) + ' valeurs'));
	});
var $author$project$I18n$Cles$bibliothequeRepriseFermer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.fermer', _List_Nil, 'Fermer');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$drawerDeLaRepriseEffectuee = F3(
	function (i18n, model, effectuee) {
		return A5(
			$author$project$Components$Shared$Drawer$View$viewAvecPiedLibre,
			i18n,
			{
				oJ: $elm$core$Maybe$Nothing,
				HF: function (_v0) {
					return $rtfeldman$elm_css$Html$Styled$text('');
				},
				Jb: _List_Nil
			},
			$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawer,
			{
				fs: {
					sR: true,
					Bl: $author$project$I18n$Cles$bibliothequeRepriseFermer(i18n),
					C$: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawer($author$project$Components$Shared$Drawer$Update$Fermer)
				},
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$bibliothequeRepriseEffectueeSousTitre,
									i18n,
									{Dj: effectuee.Bl}))
							])),
						A2(
						$author$project$Components$Shared$Note$View$view,
						3,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										effectuee.pM ? A2(
											$author$project$I18n$Cles$bibliothequeRepriseEffectueeListeRattachee,
											i18n,
											{Dj: effectuee.oy}) : A2(
											$author$project$I18n$Cles$bibliothequeRepriseEffectueeListe,
											i18n,
											{Dj: effectuee.oy}))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$elm$core$String$join,
											' · ',
											_List_fromArray(
												[
													A2(
													$author$project$I18n$Cles$bibliothequeRepriseEffectueeValeurs,
													i18n,
													{Ki: effectuee.Ki}),
													A2(
													$author$project$I18n$Cles$bibliothequeRepriseEffectueeTypesMaj,
													i18n,
													{
														ib: $elm$core$List$length(effectuee.ib)
													}),
													A2(
													$author$project$I18n$Cles$bibliothequeRepriseEffectueeAjoutees,
													i18n,
													{iI: effectuee.iI})
												])) + (', ' + A2(
											$author$project$I18n$Cles$bibliothequeRepriseEffectueeRapprochees,
											i18n,
											{pL: effectuee.pL})))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$bibliothequeRepriseEffectueeTypes(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($elm$core$String$join, ', ', effectuee.ib))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$bibliothequeRepriseEffectueeFiches(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$strong,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('0')
											])),
										$rtfeldman$elm_css$Html$Styled$text('. '),
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$bibliothequeRepriseEffectueeFichesNote(i18n))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$bibliothequeRepriseEffectueeNonRepris(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$bibliothequeRepriseEffectueeNonReprisVoir,
											i18n,
											{
												w: $elm$core$String$fromInt(effectuee.DN)
											}))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$bibliothequeRepriseEffectueeRejeu(i18n))
							]))
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: effectuee.pM ? $author$project$I18n$Cles$bibliothequeRepriseEffectueeTitreRattachee(i18n) : $author$project$I18n$Cles$bibliothequeRepriseEffectueeTitre(i18n)
			},
			model.kX);
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$drawerDeLaReprise = F2(
	function (i18n, model) {
		var _v0 = model.lN;
		if (!_v0.$) {
			var effectuee = _v0.a;
			return A3($author$project$Components$Parametrage$BibliothequeDeChamps$View$drawerDeLaRepriseEffectuee, i18n, model, effectuee);
		} else {
			var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.kX);
			var contenu = function () {
				var _v1 = $author$project$Components$Parametrage$BibliothequeDeChamps$Model$champOuvert(model);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var champ = _v2.a;
					var proposition = _v2.b;
					return A5($author$project$Components$Parametrage$BibliothequeDeChamps$View$corps, i18n, prefixe, model, champ, proposition);
				} else {
					return {f$: _List_Nil, h6: ''};
				}
			}();
			return A4(
				$author$project$Components$Shared$Drawer$View$view,
				i18n,
				$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawer,
				{
					fs: ((model.cC === 1) && (model.cR === 2)) ? {
						sR: !$author$project$API$Envoi$enCours(model.l2),
						Bl: $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesIssueLaisser(i18n),
						C$: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ChampLaisse
					} : {
						sR: (!_Utils_eq(
							$author$project$Components$Parametrage$BibliothequeDeChamps$Model$commande(model),
							$elm$core$Maybe$Nothing)) && (!$author$project$API$Envoi$enCours(model.l2)),
						Bl: ((model.cC === 1) && (!model.cR)) ? $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesReprendreEtRattacher(i18n) : $author$project$I18n$Cles$bibliothequeRepriseReprendre(i18n),
						C$: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$RepriseDemandee
					},
					fZ: contenu.f$,
					A6: $elm$core$Maybe$Nothing,
					Bc: false,
					h6: contenu.h6
				},
				model.kX);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ReglageEnregistre = {$: 21};
var $author$project$I18n$Cles$bibliothequeReglagesEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reglages.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$CollectionReglee = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$FiltrableCoche = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$PorteeReglee = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$RecherchableCoche = function (a) {
	return {$: 19, a: a};
};
var $author$project$I18n$Cles$bibliothequeReglagesCollectionRefus = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reglages.collection.refus',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'collection',
					$author$project$I18n$Traductions$Chaine(p.vD))
				]),
			'« ' + (p.Dj + (' » est déjà dans « ' + (p.vD + ' ». Un champ n\'appartient qu\'à une collection : sortez-le d\'abord de l\'autre.'))));
	});
var $author$project$I18n$Cles$bibliothequeReglagesCollectionRefusIssue = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reglages.collection.refus.issue',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'collection',
					$author$project$I18n$Traductions$Chaine(p.vD))
				]),
			'Sortir le champ de « ' + (p.vD + ' »'));
	});
var $author$project$I18n$Cles$bibliothequeReglagesDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reglages.detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'« ' + (p.Dj + ' » : sa portée et sa recherche.'));
	});
var $author$project$I18n$Cles$bibliothequeReglagesRecherchableNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reglages.recherchable-note', _List_Nil, 'Réglage de tout champ, modifiable ensuite.');
};
var $author$project$I18n$Cles$bibliothequeReglagesRefus = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reglages.refus', _List_Nil, 'Le réglage n\'a pas été enregistré : le champ ne peut pas être réglé ainsi.');
};
var $author$project$I18n$Cles$bibliothequeReglagesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reglages.titre', _List_Nil, 'Réglages du champ');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$libelleDeLaCollection = F2(
	function (collections, cle) {
		if (!cle.$) {
			var trouvee = cle.a;
			return A2(
				$elm$core$Maybe$withDefault,
				trouvee,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Bl;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (c) {
								return _Utils_eq(c.dy, trouvee);
							},
							collections))));
		} else {
			return '';
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$peutRegler = F2(
	function (rel, champ) {
		return (!_Utils_eq(
			A2($author$project$API$Liens$trouver, rel, champ.nQ.h0),
			$elm$core$Maybe$Nothing)) || (_Utils_eq(champ.Aq, $elm$core$Maybe$Nothing) && ((!_Utils_eq(champ.JQ, $elm$core$Maybe$Nothing)) && (!_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUnChamp, champ.nQ.h0),
			$elm$core$Maybe$Nothing))));
	});
var $author$project$Components$Parametrage$Vocabulaire$porteesDeLaBibliotheque = _List_fromArray(
	['catalogue', 'parties-prenantes', 'catalogue-et-parties-prenantes']);
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$proposeePour = F2(
	function (portee, collection) {
		return (portee === 'catalogue-et-parties-prenantes') || _Utils_eq(collection.F$, portee);
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$corpsDesReglages = F6(
	function (i18n, prefixe, collections, model, reglage, champ) {
		var peut = function (rel) {
			return A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$peutRegler, rel, champ);
		};
		return {
			f$: _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$bibliothequeReglagesDetail,
								i18n,
								{Dj: champ.Bl}))
						])),
					peut($author$project$API$NavLinksDictionary$changerLaPortee) ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$bibliothequeReglagesPortee(i18n))
								])),
							$author$project$Components$Shared$Segment$View$view(
							{
								vd: reglage.F$,
								Bi: $author$project$I18n$Cles$bibliothequeReglagesPortee(i18n),
								Dj: prefixe + '-portee',
								Ea: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$PorteeReglee,
								o_: A2(
									$elm$core$List$map,
									function (code) {
										return {
											vx: code,
											Bl: A2($author$project$Components$Parametrage$Vocabulaire$porteeDeLaBibliotheque, i18n, code)
										};
									},
									$author$project$Components$Parametrage$Vocabulaire$porteesDeLaBibliotheque)
							})
						])) : $rtfeldman$elm_css$Html$Styled$text(''),
					(peut($author$project$API$NavLinksDictionary$rangerUnChampDansUneCollection) || peut($author$project$API$NavLinksDictionary$sortirUnChampDeSaCollection)) ? A2(
					$author$project$Components$Shared$Champ$View$liste,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: prefixe + '-collection',
						Bl: $author$project$I18n$Cles$bibliothequeReglagesCollection(i18n),
						he: false
					},
					{
						hg: function (cle) {
							return $author$project$Components$Parametrage$BibliothequeDeChamps$Update$CollectionReglee(
								(cle === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(cle));
						},
						o_: A2(
							$elm$core$List$cons,
							{
								Bl: $author$project$I18n$Cles$bibliothequeReglagesCollectionAucune(i18n),
								fm: ''
							},
							A2(
								$elm$core$List$map,
								function (c) {
									return {Bl: c.Bl, fm: c.dy};
								},
								A2(
									$elm$core$List$filter,
									$author$project$Components$Parametrage$BibliothequeDeChamps$View$proposeePour(reglage.F$),
									collections))),
						fm: A2($elm$core$Maybe$withDefault, '', reglage.vD)
					}) : $rtfeldman$elm_css$Html$Styled$text(''),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$bibliothequeReglagesCollectionAide(i18n))
						])),
					function () {
					var _v0 = reglage.kA;
					if (!_v0.$) {
						var autre = _v0.a;
						return A2(
							$author$project$Components$Shared$Note$View$view,
							1,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('refus')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$bibliothequeReglagesCollectionRefus,
												i18n,
												{
													vD: A2(
														$author$project$Components$Parametrage$BibliothequeDeChamps$View$libelleDeLaCollection,
														collections,
														$elm$core$Maybe$Just(autre)),
													Dj: champ.Bl
												}))
										])),
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id(prefixe + '-sortir-de-la-collection'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Parametrage$BibliothequeDeChamps$Update$CollectionReglee($elm$core$Maybe$Nothing))
										]),
									A2(
										$author$project$I18n$Cles$bibliothequeReglagesCollectionRefusIssue,
										i18n,
										{
											vD: A2(
												$author$project$Components$Parametrage$BibliothequeDeChamps$View$libelleDeLaCollection,
												collections,
												$elm$core$Maybe$Just(autre))
										}))
								]));
					} else {
						return $rtfeldman$elm_css$Html$Styled$text('');
					}
				}(),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$bibliothequeReglagesRecherche(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('bloc')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('pick')
										]),
									_List_fromArray(
										[
											peut($author$project$API$NavLinksDictionary$reglerLeFiltrable) ? A2(
											$author$project$Components$Shared$Champ$View$caseACocher,
											{
												go: $elm$core$Maybe$Nothing,
												Aq: prefixe + '-filtrable',
												Bl: $author$project$I18n$Cles$bibliothequeReglagesFiltrable(i18n),
												he: false
											},
											{vt: reglage.zG, D9: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$FiltrableCoche}) : $rtfeldman$elm_css$Html$Styled$text(''),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$bibliothequeReglagesFiltrableNote(i18n))
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('pick')
										]),
									_List_fromArray(
										[
											peut($author$project$API$NavLinksDictionary$reglerLeRecherchable) ? A2(
											$author$project$Components$Shared$Champ$View$caseACocher,
											{
												go: $elm$core$Maybe$Nothing,
												Aq: prefixe + '-recherchable',
												Bl: $author$project$I18n$Cles$bibliothequeReglagesRecherchable(i18n),
												he: false
											},
											{vt: reglage.G1, D9: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$RecherchableCoche}) : $rtfeldman$elm_css$Html$Styled$text(''),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$bibliothequeReglagesRecherchableNote(i18n))
												]))
										]))
								]))
						])),
					reglage.pZ ? A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('refus'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$bibliothequeReglagesRefus(i18n))
						])) : $rtfeldman$elm_css$Html$Styled$text('')
				]),
			h6: $author$project$I18n$Cles$bibliothequeReglagesTitre(i18n)
		};
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$drawerDesReglages = F3(
	function (i18n, collections, model) {
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.lA);
		var champ = A2(
			$elm$core$Maybe$andThen,
			function (r) {
				return A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$filter(
							function (c) {
								return _Utils_eq(c.dy, r.dy);
							}),
						$elm$core$List$head),
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.dw;
						},
						model.EE));
			},
			model.eO);
		var contenu = function () {
			var _v0 = _Utils_Tuple2(model.eO, champ);
			if ((!_v0.a.$) && (!_v0.b.$)) {
				var reglage = _v0.a.a;
				var lu = _v0.b.a;
				return A6($author$project$Components$Parametrage$BibliothequeDeChamps$View$corpsDesReglages, i18n, prefixe, collections, model, reglage, lu);
			} else {
				return {f$: _List_Nil, h6: ''};
			}
		}();
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuDrawerDesReglages,
			{
				fs: {
					sR: (!_Utils_eq(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Model$commandesDuReglage(model),
						_List_Nil)) && (!$author$project$API$Envoi$enCours(model.l2)),
					Bl: $author$project$I18n$Cles$bibliothequeReglagesEnregistrer(i18n),
					C$: $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ReglageEnregistre
				},
				fZ: contenu.f$,
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: contenu.h6
			},
			model.lA);
	});
var $author$project$I18n$Cles$bibliothequeFicheSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.fiche.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typeDeChamp',
					$author$project$I18n$Traductions$Chaine(p.JR))
				]),
			'Champ de la bibliothèque · ' + p.JR);
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$enTete = F2(
	function (i18n, fiche) {
		return A2(
			$author$project$Components$Shared$Page$View$enTete,
			i18n,
			{
				vS: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$bibliothequeFicheSousTitre,
									i18n,
									{
										JR: A2($author$project$Components$Parametrage$Vocabulaire$typeDeChampDeLaBibliotheque, i18n, fiche.JR)
									}))
							]))
					]),
				zE: _List_fromArray(
					[
						{
						aa: $author$project$Routes$Route$adresseBibliothequeDeChamps,
						Dj: $author$project$I18n$Cles$bibliothequeTitre(i18n)
					},
						{aa: '', Dj: fiche.Dj}
					]),
				Ef: _List_Nil,
				h6: fiche.Dj
			});
	});
var $author$project$I18n$Cles$bibliothequeRepriseIntro = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.intro', _List_Nil, 'Ces champs « choix » existent à l\'identique dans plusieurs types. Les reprendre crée une liste partagée dans la bibliothèque. Vous voyez d\'abord un aperçu ; rien ne change avant votre confirmation.');
};
var $author$project$I18n$Cles$bibliothequeRepriseNonRepris = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reprise.non-repris',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN)),
					_Utils_Tuple2(
					'typeNom',
					$author$project$I18n$Traductions$Chaine(p.rZ)),
					_Utils_Tuple2(
					'raison',
					$author$project$I18n$Traductions$Chaine(p.pH))
				]),
			'Non repris : ' + (p.uN + (' dans ' + (p.rZ + (' (' + (p.pH + ')'))))));
	});
var $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesIntro = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.parties-prenantes.intro', _List_Nil, 'Ces champs « choix » existent à l\'identique dans plusieurs types de partie prenante. Les reprendre crée une liste partagée. Vous voyez d\'abord un aperçu ; rien ne change avant votre confirmation.');
};
var $author$project$I18n$Cles$bibliothequeRepriseSansLeDroit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.sans-le-droit', _List_Nil, 'Votre profil ne permet pas de reprendre ces champs. Demandez à une personne qui a le droit Paramétrage des parties prenantes.');
};
var $author$project$I18n$Cles$bibliothequeRepriseTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.titre', _List_Nil, 'Champs recopiés à reprendre');
};
var $author$project$I18n$Cles$bibliothequeRepriseVideDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.vide-detail', _List_Nil, 'Aucun champ « choix » n\'est recopié dans plusieurs types. Quand un champ de même nom et de même forme apparaîtra dans un second type, il sera proposé ici.');
};
var $author$project$I18n$Cles$bibliothequeRepriseVideTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.vide-titre', _List_Nil, 'Aucun champ à reprendre');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ReprendreOuvert = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$I18n$Cles$bibliothequeRepriseDroitRequisTag = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.reprise.droit-requis-tag', _List_Nil, 'Droit requis');
};
var $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesTrouveDans = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reprise.parties-prenantes.trouve-dans',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w)),
					_Utils_Tuple2(
					'types',
					$author$project$I18n$Traductions$Chaine(p.ib))
				]),
			((!p.w) || (p.w === 1)) ? ('Trouvé dans ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' type de partie prenante : ' + p.ib))) : ('Trouvé dans ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' types de partie prenante : ' + p.ib))));
	});
var $author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesValeursSaisies = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reprise.parties-prenantes.valeurs-saisies',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'saisies',
					$author$project$I18n$Traductions$Entier(p.c7))
				]),
			((!p.c7) || (p.c7 === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.c7) + ' valeur saisie') : (A2($author$project$I18n$Nombre$formater, 0, p.c7) + ' valeurs saisies'));
	});
var $author$project$I18n$Cles$bibliothequeRepriseReprendreDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reprise.reprendre-de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Reprendre ' + p.Dj);
	});
var $author$project$I18n$Cles$bibliothequeRepriseTrouveDans = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.reprise.trouve-dans',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w)),
					_Utils_Tuple2(
					'types',
					$author$project$I18n$Traductions$Chaine(p.ib))
				]),
			((!p.w) || (p.w === 1)) ? ('Trouvé dans ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' type : ' + p.ib))) : ('Trouvé dans ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' types : ' + p.ib))));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$ligneAReprendre = F3(
	function (i18n, domaine, _v0) {
		var champ = _v0.a;
		var proposition = _v0.b;
		var types = A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				function ($) {
					return $.Dj;
				},
				proposition.ib));
		var detail = function () {
			if (!domaine) {
				return A2(
					$author$project$I18n$Cles$bibliothequeRepriseTrouveDans,
					i18n,
					{
						w: $elm$core$List$length(proposition.ib),
						ib: types
					});
			} else {
				return A2(
					$author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesTrouveDans,
					i18n,
					{
						w: $elm$core$List$length(proposition.ib),
						ib: types
					}) + (' · ' + A2(
					$author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesValeursSaisies,
					i18n,
					{
						c7: $elm$core$List$length(
							A2(
								$elm$core$List$concatMap,
								function ($) {
									return $.vC;
								},
								proposition.Ki))
					}));
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(champ.Bl)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('detail')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(detail)
								]))
						])),
					(!_Utils_eq(
					A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeReprendre, domaine, champ),
					$elm$core$Maybe$Nothing)) ? A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id(
							$author$project$Components$Parametrage$BibliothequeDeChamps$Model$idDuDeclencheur(champ.dy)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							A2($author$project$Components$Parametrage$BibliothequeDeChamps$Update$ReprendreOuvert, domaine, champ.dy)),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-label',
							A2(
								$author$project$I18n$Cles$bibliothequeRepriseReprendreDe,
								i18n,
								{Dj: champ.Bl}))
						]),
					$author$project$I18n$Cles$bibliothequeRepriseReprendre(i18n)) : ((domaine === 1) ? A2(
					$author$project$Components$Shared$Tag$View$view,
					3,
					$author$project$I18n$Cles$bibliothequeRepriseDroitRequisTag(i18n)) : $rtfeldman$elm_css$Html$Styled$text(''))
				]));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$ligneSurLaPage = F3(
	function (i18n, model, champ) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(champ.Bl)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('detail')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesTrouveDans,
										i18n,
										{
											w: $elm$core$List$length(champ.ib),
											ib: A2($elm$core$String$join, ', ', champ.ib)
										}) + (' · ' + A2(
										$author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesValeursSaisies,
										i18n,
										{c7: champ.Kp})))
								]))
						])),
					_Utils_eq(
					A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeLaReprise, 1, model),
					$elm$core$Maybe$Nothing) ? A2(
					$author$project$Components$Shared$Tag$View$view,
					3,
					$author$project$I18n$Cles$bibliothequeRepriseDroitRequisTag(i18n)) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$encart = F2(
	function (i18n, model) {
		var nonRepris = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.DN;
				},
				model.dq));
		var desPartiesLuesSurLaPage = _Utils_eq(model.eS, $elm$core$Maybe$Nothing) ? A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.E1;
				},
				model.EE)) : _List_Nil;
		var arepredre = function (bibliotheque) {
			return A2(
				$elm$core$List$filterMap,
				function (champ) {
					return A2(
						$elm$core$Maybe$map,
						function (proposition) {
							return _Utils_Tuple2(champ, proposition);
						},
						champ.qx);
				},
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.dw;
						},
						bibliotheque)));
		};
		var desParties = arepredre(model.eS);
		var sansLeDroit = A2(
			$elm$core$List$any,
			function (_v0) {
				var champ = _v0.a;
				return _Utils_eq(
					A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeReprendre, 1, champ),
					$elm$core$Maybe$Nothing);
			},
			desParties) || ((!_Utils_eq(desPartiesLuesSurLaPage, _List_Nil)) && _Utils_eq(
			A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeLaReprise, 1, model),
			$elm$core$Maybe$Nothing));
		var duCatalogue = arepredre(model.dq);
		var nombre = ($elm$core$List$length(duCatalogue) + $elm$core$List$length(desParties)) + $elm$core$List$length(desPartiesLuesSurLaPage);
		return (!nombre) ? A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('reprise'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$bibliothequeRepriseVideTitre(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$bibliothequeRepriseVideDetail(i18n))
						]))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('reprise')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h2,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$bibliothequeRepriseTitre(i18n)),
								$rtfeldman$elm_css$Html$Styled$text(' '),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('nombre')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$elm$core$String$fromInt(nombre))
									]))
							]))
					]),
				_Utils_ap(
					_Utils_eq(duCatalogue, _List_Nil) ? _List_Nil : _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$bibliothequeRepriseIntro(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('champs')
								]),
							A2(
								$elm$core$List$map,
								A2($author$project$Components$Parametrage$BibliothequeDeChamps$View$ligneAReprendre, i18n, 0),
								duCatalogue)),
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('non-repris')
								]),
							A2(
								$elm$core$List$map,
								function (n) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$li,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$bibliothequeRepriseNonRepris,
													i18n,
													{uN: n.dy, pH: n.pH, rZ: n.Dj}))
											]));
								},
								nonRepris))
						]),
					_Utils_ap(
						(_Utils_eq(desParties, _List_Nil) && _Utils_eq(desPartiesLuesSurLaPage, _List_Nil)) ? _List_Nil : _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$bibliothequeReprisePartiesPrenantesIntro(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$ul,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('champs')
									]),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										A2($author$project$Components$Parametrage$BibliothequeDeChamps$View$ligneAReprendre, i18n, 1),
										desParties),
									A2(
										$elm$core$List$map,
										A2($author$project$Components$Parametrage$BibliothequeDeChamps$View$ligneSurLaPage, i18n, model),
										desPartiesLuesSurLaPage)))
							]),
						sansLeDroit ? _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('sans-le-droit'),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$bibliothequeRepriseSansLeDroit(i18n))
									]))
							]) : _List_Nil))));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$DesPartiesPrenantes = 2;
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$DesProduits = 1;
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$PorteeChoisie = function (a) {
	return {$: 13, a: a};
};
var $author$project$I18n$Cles$bibliothequePorteeLegende = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.portee.legende', _List_Nil, 'Portée');
};
var $author$project$I18n$Cles$bibliothequePorteeToutes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.portee.toutes', _List_Nil, 'Toutes');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$filtreDePortee = F2(
	function (i18n, model) {
		var depuis = function (texte) {
			switch (texte) {
				case 'produits':
					return 1;
				case 'parties-prenantes':
					return 2;
				default:
					return 0;
			}
		};
		var code = function (portee) {
			switch (portee) {
				case 0:
					return 'toutes';
				case 1:
					return 'produits';
				default:
					return 'parties-prenantes';
			}
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('filtre-portee')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$bibliothequePorteeLegende(i18n))
						])),
					$author$project$Components$Shared$Segment$View$view(
					{
						vd: code(model.F$),
						Bi: $author$project$I18n$Cles$bibliothequePorteeLegende(i18n),
						Dj: 'bibliotheque-portee',
						Ea: A2($elm$core$Basics$composeR, depuis, $author$project$Components$Parametrage$BibliothequeDeChamps$Update$PorteeChoisie),
						o_: _List_fromArray(
							[
								{
								vx: 'toutes',
								Bl: $author$project$I18n$Cles$bibliothequePorteeToutes(i18n)
							},
								{
								vx: 'produits',
								Bl: $author$project$I18n$Cles$bibliothequePorteeProduits(i18n)
							},
								{
								vx: 'parties-prenantes',
								Bl: $author$project$I18n$Cles$bibliothequePorteePartiesPrenantes(i18n)
							}
							])
					})
				]));
	});
var $author$project$I18n$Cles$bibliothequeAucunChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.aucun-champ', _List_Nil, 'Aucun champ pour le moment.');
};
var $author$project$I18n$Cles$bibliothequeColonneActions = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.colonne.actions', _List_Nil, 'Actions');
};
var $author$project$I18n$Cles$bibliothequeColonneChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.colonne.champ', _List_Nil, 'Champ');
};
var $author$project$I18n$Cles$bibliothequeColonneCollection = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.colonne.collection', _List_Nil, 'Collection');
};
var $author$project$I18n$Cles$bibliothequeColonnePortee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.colonne.portee', _List_Nil, 'Portée');
};
var $author$project$I18n$Cles$bibliothequeColonneType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.colonne.type', _List_Nil, 'Type');
};
var $author$project$I18n$Cles$bibliothequeColonneUtilisePar = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.colonne.utilise-par', _List_Nil, 'Utilisé par');
};
var $author$project$I18n$Cles$bibliothequeTableau = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.tableau', _List_Nil, 'Champs de la bibliothèque');
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Update$ReglageOuvert = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$domaineAReprendre = F2(
	function (model, champ) {
		var reprenable = function (domaine) {
			return A2(
				$elm$core$List$any,
				function (c) {
					return _Utils_eq(c.dy, champ.dy) && ((!_Utils_eq(c.qx, $elm$core$Maybe$Nothing)) && (!_Utils_eq(
						A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeReprendre, domaine, c),
						$elm$core$Maybe$Nothing)));
				},
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.dw;
						},
						A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$bibliothequeDe, domaine, model))));
		};
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				reprenable,
				_List_fromArray(
					[0, 1])));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$aReprendre = F2(
	function (model, champ) {
		return !_Utils_eq(
			A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$domaineAReprendre, model, champ),
			$elm$core$Maybe$Nothing);
	});
var $author$project$I18n$Cles$bibliothequeFiltrable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.filtrable', _List_Nil, 'filtrable');
};
var $author$project$I18n$Cles$bibliothequePersonnelSur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.personnel-sur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('personnel sur ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' rattachement')) : ('personnel sur ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' rattachements')));
	});
var $author$project$I18n$Cles$bibliothequeRecherchable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.recherchable', _List_Nil, 'recherchable');
};
var $author$project$I18n$Cles$bibliothequeRegler = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.regler', _List_Nil, 'Régler');
};
var $author$project$I18n$Cles$bibliothequeReglerDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.regler-de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Régler ' + p.Dj);
	});
var $author$project$I18n$Cles$bibliothequeTypes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.types',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' type') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' types'));
	});
var $author$project$I18n$Cles$bibliothequeFicheOuvrir = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'bibliotheque.fiche.ouvrir',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Ouvrir la fiche de ' + p.Dj);
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$nomDuChamp = F2(
	function (i18n, champ) {
		var _v0 = _Utils_Tuple2(
			champ.Aq,
			$author$project$Components$Parametrage$BibliothequeDeChamps$Model$lienDeLaFiche(champ));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var id = _v0.a.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ouvrir-la-fiche'),
						$rtfeldman$elm_css$Html$Styled$Attributes$href(
						$author$project$Routes$Route$adresseDuChampDeLaBibliotheque(id)),
						$rtfeldman$elm_css$Html$Styled$Attributes$title(
						A2(
							$author$project$I18n$Cles$bibliothequeFicheOuvrir,
							i18n,
							{Dj: champ.Bl}))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(champ.Bl)
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text(champ.Bl);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$ouvrirLaReprise = F2(
	function (model, champ) {
		return A2(
			$author$project$Components$Parametrage$BibliothequeDeChamps$Update$ReprendreOuvert,
			A2(
				$elm$core$Maybe$withDefault,
				0,
				A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$domaineAReprendre, model, champ)),
			champ.dy);
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$porteeAffichee = F2(
	function (i18n, champ) {
		var _v0 = champ.o4;
		if (!_v0.$) {
			var origine = _v0.a;
			return (champ.sf <= 1) ? A2(
				$author$project$I18n$Cles$bibliothequeFicheCreeDepuis,
				i18n,
				{Dj: origine.Dj}) : A2($author$project$Components$Parametrage$Vocabulaire$porteeDeLaBibliotheque, i18n, champ.F$);
		} else {
			return A2($author$project$Components$Parametrage$Vocabulaire$porteeDeLaBibliotheque, i18n, champ.F$);
		}
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$ligne = F4(
	function (i18n, collections, model, champ) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('champ')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
						]),
					_Utils_ap(
						_List_fromArray(
							[
								A2($author$project$Components$Parametrage$BibliothequeDeChamps$View$nomDuChamp, i18n, champ)
							]),
						_Utils_ap(
							champ.zG ? _List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(' '),
									A2(
									$author$project$Components$Shared$Tag$View$view,
									5,
									$author$project$I18n$Cles$bibliothequeFiltrable(i18n))
								]) : _List_Nil,
							_Utils_ap(
								champ.G1 ? _List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(' '),
										A2(
										$author$project$Components$Shared$Tag$View$view,
										3,
										$author$project$I18n$Cles$bibliothequeRecherchable(i18n))
									]) : _List_Nil,
								(champ.pj > 0) ? _List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(' '),
										A2(
										$author$project$Components$Shared$Tag$View$view,
										3,
										A2(
											$author$project$I18n$Cles$bibliothequePersonnelSur,
											i18n,
											{w: champ.pj}))
									]) : _List_Nil)))),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('type')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Parametrage$Vocabulaire$typeDeChampDeLaBibliotheque, i18n, champ.rU))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('portee')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Parametrage$BibliothequeDeChamps$View$porteeAffichee, i18n, champ))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('collection')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Parametrage$BibliothequeDeChamps$View$libelleDeLaCollection, collections, champ.vD))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('utilise-par')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							5,
							A2(
								$author$project$I18n$Cles$bibliothequeTypes,
								i18n,
								{w: champ.sf}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					_Utils_ap(
						$author$project$Components$Parametrage$BibliothequeDeChamps$Model$reglable(champ) ? _List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id(
										$author$project$Components$Parametrage$BibliothequeDeChamps$Model$idDuReglage(champ.dy)),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Parametrage$BibliothequeDeChamps$Update$ReglageOuvert(champ.dy)),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
										'aria-label',
										A2(
											$author$project$I18n$Cles$bibliothequeReglerDe,
											i18n,
											{Dj: champ.Bl})),
										$rtfeldman$elm_css$Html$Styled$Attributes$title(
										A2(
											$author$project$I18n$Cles$bibliothequeReglerDe,
											i18n,
											{Dj: champ.Bl}))
									]),
								$author$project$I18n$Cles$bibliothequeRegler(i18n))
							]) : _List_Nil,
						A2($author$project$Components$Parametrage$BibliothequeDeChamps$Model$aReprendre, model, champ) ? _List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										A2($author$project$Components$Parametrage$BibliothequeDeChamps$View$ouvrirLaReprise, model, champ)),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
										'aria-label',
										A2(
											$author$project$I18n$Cles$bibliothequeRepriseReprendreDe,
											i18n,
											{Dj: champ.Bl})),
										$rtfeldman$elm_css$Html$Styled$Attributes$title(
										A2(
											$author$project$I18n$Cles$bibliothequeRepriseReprendreDe,
											i18n,
											{Dj: champ.Bl}))
									]),
								$author$project$I18n$Cles$bibliothequeRepriseReprendre(i18n))
							]) : _List_Nil))
				]));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$Model$visibles = function (model) {
	var champs = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.dw;
			},
			model.EE));
	var _v0 = model.F$;
	switch (_v0) {
		case 0:
			return champs;
		case 1:
			return A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.F$;
					},
					$author$project$Components$Parametrage$Vocabulaire$serviLeCatalogue),
				champs);
		default:
			return A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.F$;
					},
					$author$project$Components$Parametrage$Vocabulaire$serviLesPartiesPrenantes),
				champs);
	}
};
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$tableau = F3(
	function (i18n, collections, model) {
		var champs = $author$project$Components$Parametrage$BibliothequeDeChamps$Model$visibles(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('card')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$bibliothequeTableau(i18n))
						])),
					_Utils_eq(champs, _List_Nil) ? A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$bibliothequeAucunChamp(i18n))
						])) : A2(
					$rtfeldman$elm_css$Html$Styled$table,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$bibliothequeColonneChamp(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$bibliothequeColonneType(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$bibliothequeColonnePortee(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$bibliothequeColonneCollection(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$bibliothequeColonneUtilisePar(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$bibliothequeColonneActions(i18n))
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$tbody,
							_List_Nil,
							A2(
								$elm$core$List$map,
								A3($author$project$Components$Parametrage$BibliothequeDeChamps$View$ligne, i18n, collections, model),
								champs))
						]))
				]));
	});
var $author$project$Components$Parametrage$BibliothequeDeChamps$View$view = F5(
	function (i18n, versLeParent, greffon, messages, model) {
		var deLaPage = $elm$core$List$map(
			$rtfeldman$elm_css$Html$Styled$map(versLeParent));
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'parametrage-bibliotheque-de-champs',
			{
				ut: function () {
					var _v0 = _Utils_Tuple2(model.zo, model.EE);
					if (!_v0.b.$) {
						if (!_v0.a.$) {
							var fiche = _v0.a.a;
							return deLaPage(
								A4($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$corps, i18n, messages, model, fiche));
						} else {
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
										]),
									_Utils_ap(
										deLaPage(
											_List_fromArray(
												[
													A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
													(_Utils_eq(model.dq, $elm$core$Maybe$Nothing) && (_Utils_eq(model.eS, $elm$core$Maybe$Nothing) && _Utils_eq(
													A2(
														$elm$core$Maybe$withDefault,
														_List_Nil,
														A2(
															$elm$core$Maybe$map,
															function ($) {
																return $.E1;
															},
															model.EE)),
													_List_Nil))) ? $rtfeldman$elm_css$Html$Styled$text('') : A2($author$project$Components$Parametrage$BibliothequeDeChamps$View$encart, i18n, model),
													A2($author$project$Components$Parametrage$BibliothequeDeChamps$View$filtreDePortee, i18n, model),
													A3($author$project$Components$Parametrage$BibliothequeDeChamps$View$tableau, i18n, greffon.vE, model)
												])),
										greffon.js))
								]);
						}
					} else {
						var _v1 = _v0.b;
						return _List_Nil;
					}
				}(),
				xy: _Utils_ap(
					deLaPage(
						_Utils_ap(
							_List_fromArray(
								[
									A2($author$project$Components$Parametrage$BibliothequeDeChamps$View$drawerDeLaReprise, i18n, model),
									A3($author$project$Components$Parametrage$BibliothequeDeChamps$View$drawerDesReglages, i18n, greffon.vE, model)
								]),
							_Utils_ap(
								A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$dialogues, i18n, model),
								A3($author$project$Components$Parametrage$NouveauChamp$View$dialogues, i18n, $author$project$Components$Parametrage$BibliothequeDeChamps$Update$DuNouveauChamp, model.oP)))),
					greffon.xy),
				zM: deLaPage(
					greffon.n3 ? A3($author$project$Components$Parametrage$BibliothequeDeChamps$View$boutonDeCreation, i18n, greffon.vE, model) : _List_Nil),
				AK: $author$project$Components$Parametrage$BibliothequeDeChamps$View$dialogueOuvert(model) || greffon.AK,
				JD: deLaPage(
					function () {
						var _v2 = model.zo;
						if (!_v2.$) {
							var fiche = _v2.a;
							return A2($author$project$Components$Parametrage$BibliothequeDeChamps$FicheView$enTete, i18n, fiche);
						} else {
							return A2(
								$author$project$Components$Shared$Page$View$enTete,
								i18n,
								{
									vS: _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$bibliothequeDescription(i18n))
												]))
										]),
									zE: _List_fromArray(
										[
											{
											aa: $author$project$Routes$Route$adresseBibliothequeDeChamps,
											Dj: $author$project$I18n$Cles$bibliothequeTitre(i18n)
										}
										]),
									Ef: _List_Nil,
									h6: $author$project$I18n$Cles$bibliothequeTitre(i18n)
								});
						}
					}())
			});
	});
var $author$project$I18n$Cles$compteDEnvoiBandeauAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.bandeau.aucun', _List_Nil, 'Aucun compte d\'envoi : vos portails ne peuvent pas envoyer de code de connexion.');
};
var $author$project$I18n$Cles$compteDEnvoiBandeauAucunVerifie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.bandeau.aucun-verifie', _List_Nil, 'Aucun compte d\'envoi vérifié : vos portails ne peuvent pas envoyer de code de connexion.');
};
var $author$project$I18n$Cles$compteDEnvoiBandeauRemplacement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.bandeau.remplacement', _List_Nil, 'Remplacement en cours : le nouveau compte est en vérification.');
};
var $author$project$I18n$Cles$compteDEnvoiBandeauRemplacementDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.bandeau.remplacement.detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.yz)))
				]),
			'Les emails ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.yz);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.yz);
					default:
						return 'de ' + $elm$core$String$trim(p.yz);
				}
			}() + ' partent encore par le compte actuel. Dès que le nouveau compte est vérifié, il devient le seul compte actif et l\'ancien est déconnecté. L\'historique d\'envoi est gardé.'));
	});
var $author$project$I18n$Cles$compteDEnvoiBandeauRemplacementDetailSansEspace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.bandeau.remplacement.detail.sans-espace', _List_Nil, 'Les emails de l\'espace partent encore par le compte actuel. Dès que le nouveau compte est vérifié, il devient le seul compte actif et l\'ancien est déconnecté. L\'historique d\'envoi est gardé.');
};
var $author$project$I18n$Cles$compteDEnvoiBandeauRemplacementNonVerifie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.bandeau.remplacement-non-verifie', _List_Nil, 'Remplacement en cours : le nouveau compte n\'est pas vérifié.');
};
var $author$project$I18n$Cles$compteDEnvoiBandeauRienNePart = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.bandeau.rien-ne-part',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.yz)))
				]),
			'Tant qu\'aucun compte n\'est vérifié, aucun email ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.yz);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.yz);
					default:
						return 'de ' + $elm$core$String$trim(p.yz);
				}
			}() + ' ne part.'));
	});
var $author$project$I18n$Cles$compteDEnvoiBandeauRienNePartSansEspace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.bandeau.rien-ne-part.sans-espace', _List_Nil, 'Tant qu\'aucun compte n\'est vérifié, aucun email de l\'espace ne part.');
};
var $author$project$I18n$Cles$compteDEnvoiBandeauVerifie = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.bandeau.verifie',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'expediteur',
					$author$project$I18n$Traductions$Chaine(p.mr)),
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.yz)))
				]),
			'Tous les emails ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.yz);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.yz);
					default:
						return 'de ' + $elm$core$String$trim(p.yz);
				}
			}() + (' partent de ' + (p.mr + ', sous la responsabilité de l\'espace.'))));
	});
var $author$project$I18n$Cles$compteDEnvoiBandeauVerifieSansEspace = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.bandeau.verifie.sans-espace',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'expediteur',
					$author$project$I18n$Traductions$Chaine(p.mr))
				]),
			'Tous les emails de l\'espace partent de ' + (p.mr + ', sous la responsabilité de l\'espace.'));
	});
var $author$project$I18n$Cles$compteDEnvoiBandeauVerifieTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.bandeau.verifie.titre', _List_Nil, 'Compte vérifié.');
};
var $author$project$I18n$Cles$compteDEnvoiLectureSeuleDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.lecture-seule.detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.yz)))
				]),
			'Lecture seule. Seul un administrateur ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.yz);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.yz);
					default:
						return 'de ' + $elm$core$String$trim(p.yz);
				}
			}() + ' connecte, remplace ou déconnecte le compte d\'envoi.'));
	});
var $author$project$I18n$Cles$compteDEnvoiLectureSeuleDetailSansEspace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.lecture-seule.detail.sans-espace', _List_Nil, 'Lecture seule. Seul un administrateur de l\'espace connecte, remplace ou déconnecte le compte d\'envoi.');
};
var $author$project$I18n$Cles$compteDEnvoiEmailDeTestEchoue = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.email-de-test.echoue',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'motif',
					$author$project$I18n$Traductions$Chaine(p.cX))
				]),
			'L\'email de test n\'est pas parti : ' + (p.cX + '.'));
	});
var $author$project$I18n$Cles$compteDEnvoiEmailDeTestEnvoye = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.email-de-test.envoye', _List_Nil, 'Email de test envoyé par Brevo.');
};
var $author$project$I18n$Cles$compteDEnvoiMotifAdresseIpRefusee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.motif.adresse-ip-refusee', _List_Nil, 'adresse IP refusée par Brevo');
};
var $author$project$I18n$Cles$compteDEnvoiMotifAdresseIpRefuseeEmailDeTest = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.motif.adresse-ip-refusee.email-de-test',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.yz)))
				]),
			'Brevo refuse les appels du CRM, car votre compte bloque les adresses IP inconnues. Tant que ce blocage est actif, aucun email ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.yz);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.yz);
					default:
						return 'de ' + $elm$core$String$trim(p.yz);
				}
			}() + ' ne part. Dans Brevo, Sécurité › IP autorisées, désactivez le blocage des IP inconnues, puis envoyez de nouveau un email de test. Autoriser une seule adresse ne suffit pas : le CRM n\'a pas d\'adresse de sortie fixe.'));
	});
var $author$project$I18n$Cles$compteDEnvoiMotifAdresseIpRefuseeEmailDeTestSansEspace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.motif.adresse-ip-refusee.email-de-test.sans-espace', _List_Nil, 'Brevo refuse les appels du CRM, car votre compte bloque les adresses IP inconnues. Tant que ce blocage est actif, aucun email de l\'espace ne part. Dans Brevo, Sécurité › IP autorisées, désactivez le blocage des IP inconnues, puis envoyez de nouveau un email de test. Autoriser une seule adresse ne suffit pas : le CRM n\'a pas d\'adresse de sortie fixe.');
};
var $author$project$Components$Parametrage$CompteDEnvoi$Model$nommerLEspace = F3(
	function (model, avecLeNom, sansLeNom) {
		var _v0 = model.g5;
		if (!_v0.$) {
			var nom = _v0.a;
			return avecLeNom(
				{
					av: $author$project$Texte$Elision$elision(nom),
					yz: nom
				});
		} else {
			return sansLeNom;
		}
	});
var $author$project$Components$Parametrage$CompteDEnvoi$View$espace = F4(
	function (model, avecLeNom, sansLeNom, i18n) {
		return A3(
			$author$project$Components$Parametrage$CompteDEnvoi$Model$nommerLEspace,
			model,
			avecLeNom(i18n),
			sansLeNom(i18n));
	});
var $author$project$I18n$Cles$compteDEnvoiMotifAdresseIpRefuseeDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.motif.adresse-ip-refusee.detail', _List_Nil, 'Brevo refuse les appels du CRM, car votre compte bloque les adresses IP inconnues. Dans Brevo, Sécurité › IP autorisées, désactivez le blocage des IP inconnues, puis vérifiez de nouveau. Autoriser une seule adresse ne suffit pas : le CRM n\'a pas d\'adresse de sortie fixe.');
};
var $author$project$I18n$Cles$compteDEnvoiMotifAutre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.motif.autre', _List_Nil, 'vérification échouée');
};
var $author$project$I18n$Cles$compteDEnvoiMotifAutreDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.motif.autre.detail', _List_Nil, 'Le fournisseur n\'a pas vérifié le compte. Rien n\'est enregistré comme vérifié.');
};
var $author$project$I18n$Cles$compteDEnvoiMotifCleRefusee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.motif.cle-refusee', _List_Nil, 'clé refusée');
};
var $author$project$I18n$Cles$compteDEnvoiMotifCleRefuseeDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.motif.cle-refusee.detail', _List_Nil, 'Brevo refuse la clé d\'API : elle est invalide ou a été révoquée. Rien n\'est enregistré comme vérifié.');
};
var $author$project$I18n$Cles$compteDEnvoiMotifDomaineNonAuthentifie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.motif.domaine-non-authentifie', _List_Nil, 'domaine non authentifié');
};
var $author$project$I18n$Cles$compteDEnvoiMotifDomaineNonAuthentifieDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.motif.domaine-non-authentifie.detail', _List_Nil, 'Brevo n\'authentifie pas le domaine de l\'adresse d\'expédition. Rien ne part tant que le domaine n\'est pas authentifié : corrigez-le chez Brevo, puis vérifiez de nouveau.');
};
var $author$project$I18n$Cles$compteDEnvoiMotifEmailDeTestBloqueDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.motif.email-de-test-bloque.detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'adresse',
					$author$project$I18n$Traductions$Chaine(p.aa))
				]),
			'Brevo a bloqué l\'email de test à ' + (p.aa + ' : l\'adresse est dans sa liste de blocage. Retirez-la dans Brevo, puis renvoyez un email de test.'));
	});
var $author$project$I18n$Cles$compteDEnvoiMotifEmailDeTestNonDelivre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.motif.email-de-test-non-delivre', _List_Nil, 'email de test non délivré');
};
var $author$project$I18n$Cles$compteDEnvoiMotifEmailDeTestRefuseDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.motif.email-de-test-refuse.detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'adresse',
					$author$project$I18n$Traductions$Chaine(p.aa))
				]),
			'Brevo n\'a pas pu délivrer l\'email de test à ' + (p.aa + ' : le serveur du destinataire l\'a refusé. Vérifiez l\'adresse, puis renvoyez un email de test.'));
	});
var $author$project$I18n$Cles$compteDEnvoiMotifExpediteurInconnu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.motif.expediteur-inconnu', _List_Nil, 'expéditeur inconnu');
};
var $author$project$I18n$Cles$compteDEnvoiMotifExpediteurInconnuDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.motif.expediteur-inconnu.detail', _List_Nil, 'Brevo ne connaît pas l\'adresse d\'expédition : ajoutez-la aux expéditeurs du compte Brevo, puis vérifiez de nouveau.');
};
var $author$project$I18n$Cles$compteDEnvoiMotifFournisseurIndisponible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.motif.fournisseur-indisponible', _List_Nil, 'fournisseur indisponible');
};
var $author$project$I18n$Cles$compteDEnvoiMotifFournisseurIndisponibleDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.motif.fournisseur-indisponible.detail', _List_Nil, 'Brevo n\'a pas répondu. Vérifiez de nouveau dans quelques minutes.');
};
var $author$project$I18n$Cles$compteDEnvoiMotifRequeteRefusee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.motif.requete-refusee', _List_Nil, 'requête refusée');
};
var $author$project$I18n$Cles$compteDEnvoiMotifRequeteRefuseeDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.motif.requete-refusee.detail', _List_Nil, 'Brevo a refusé la requête du CRM. Vérifiez de nouveau ; si le refus persiste, contactez le support.');
};
var $author$project$Components$Parametrage$Vocabulaire$motifDuCompteDEnvoi = F3(
	function (i18n, motif, adresse) {
		var dit = F2(
			function (nom, detail) {
				return {bB: detail, Dj: nom, oT: false, Ez: false, HH: false};
			});
		switch (motif) {
			case 'cle_refusee':
				var lu = A2(
					dit,
					$author$project$I18n$Cles$compteDEnvoiMotifCleRefusee(i18n),
					$author$project$I18n$Cles$compteDEnvoiMotifCleRefuseeDetail(i18n));
				return _Utils_update(
					lu,
					{oT: true});
			case 'expediteur_inconnu':
				return A2(
					dit,
					$author$project$I18n$Cles$compteDEnvoiMotifExpediteurInconnu(i18n),
					$author$project$I18n$Cles$compteDEnvoiMotifExpediteurInconnuDetail(i18n));
			case 'domaine_non_authentifie':
				var lu = A2(
					dit,
					$author$project$I18n$Cles$compteDEnvoiMotifDomaineNonAuthentifie(i18n),
					$author$project$I18n$Cles$compteDEnvoiMotifDomaineNonAuthentifieDetail(i18n));
				return _Utils_update(
					lu,
					{Ez: true});
			case 'fournisseur_indisponible':
				return A2(
					dit,
					$author$project$I18n$Cles$compteDEnvoiMotifFournisseurIndisponible(i18n),
					$author$project$I18n$Cles$compteDEnvoiMotifFournisseurIndisponibleDetail(i18n));
			case 'requete_refusee':
				return A2(
					dit,
					$author$project$I18n$Cles$compteDEnvoiMotifRequeteRefusee(i18n),
					$author$project$I18n$Cles$compteDEnvoiMotifRequeteRefuseeDetail(i18n));
			case 'email_de_test_refuse':
				var lu = A2(
					dit,
					$author$project$I18n$Cles$compteDEnvoiMotifEmailDeTestNonDelivre(i18n),
					A2(
						$author$project$I18n$Cles$compteDEnvoiMotifEmailDeTestRefuseDetail,
						i18n,
						{aa: adresse}));
				return _Utils_update(
					lu,
					{HH: true});
			case 'email_de_test_bloque':
				var lu = A2(
					dit,
					$author$project$I18n$Cles$compteDEnvoiMotifEmailDeTestNonDelivre(i18n),
					A2(
						$author$project$I18n$Cles$compteDEnvoiMotifEmailDeTestBloqueDetail,
						i18n,
						{aa: adresse}));
				return _Utils_update(
					lu,
					{Ez: true});
			case 'adresse_ip_refusee':
				var lu = A2(
					dit,
					$author$project$I18n$Cles$compteDEnvoiMotifAdresseIpRefusee(i18n),
					$author$project$I18n$Cles$compteDEnvoiMotifAdresseIpRefuseeDetail(i18n));
				return _Utils_update(
					lu,
					{Ez: true});
			default:
				return A2(
					dit,
					$author$project$I18n$Cles$compteDEnvoiMotifAutre(i18n),
					$author$project$I18n$Cles$compteDEnvoiMotifAutreDetail(i18n));
		}
	});
var $author$project$I18n$Cles$compteDEnvoiOuvrirIpAutorisees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.ouvrir-ip-autorisees', _List_Nil, 'Ouvrir les IP autorisées de Brevo');
};
var $author$project$Components$Parametrage$CompteDEnvoi$View$ouvrirLesIpAutorisees = F2(
	function (racine, i18n) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id(racine + '-ouvrir-brevo'),
							$rtfeldman$elm_css$Html$Styled$Attributes$href('https://app.brevo.com/security/authorised_ips'),
							$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank'),
							$rtfeldman$elm_css$Html$Styled$Attributes$rel('noopener')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$compteDEnvoiOuvrirIpAutorisees(i18n))
						]))
				]));
	});
var $author$project$Components$Parametrage$CompteDEnvoi$View$emailDeTest = F2(
	function (i18n, model) {
		var _v0 = model.lT;
		if (!_v0.$) {
			if (!_v0.a.$) {
				var _v1 = _v0.a;
				return _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Note$View$view,
						3,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$compteDEnvoiEmailDeTestEnvoye(i18n))
							]))
					]);
			} else {
				if (_v0.a.a === 'adresse_ip_refusee') {
					return _List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Note$View$view,
							2,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$b,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$author$project$I18n$Cles$compteDEnvoiEmailDeTestEchoue,
														i18n,
														{
															cX: $author$project$I18n$Cles$compteDEnvoiMotifAdresseIpRefusee(i18n)
														}))
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A4($author$project$Components$Parametrage$CompteDEnvoi$View$espace, model, $author$project$I18n$Cles$compteDEnvoiMotifAdresseIpRefuseeEmailDeTest, $author$project$I18n$Cles$compteDEnvoiMotifAdresseIpRefuseeEmailDeTestSansEspace, i18n))
										])),
									A2($author$project$Components$Parametrage$CompteDEnvoi$View$ouvrirLesIpAutorisees, 'compte-d-envoi-email-de-test', i18n)
								]))
						]);
				} else {
					var motif = _v0.a.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Note$View$view,
							2,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$compteDEnvoiEmailDeTestEchoue,
										i18n,
										{
											cX: A3($author$project$Components$Parametrage$Vocabulaire$motifDuCompteDEnvoi, i18n, motif, '').Dj
										}))
								]))
						]);
				}
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$I18n$Cles$compteDEnvoiBandeauEmailDeTestRecu = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.bandeau.email-de-test-recu',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'adresse',
					$author$project$I18n$Traductions$Chaine(p.aa)),
					_Utils_Tuple2(
					'instant',
					$author$project$I18n$Traductions$Chaine(p.cO))
				]),
			'Email de test reçu par ' + (p.aa + (' le ' + (p.cO + '.'))));
	});
var $author$project$Components$Parametrage$CompteDEnvoi$View$etatDeLEtape = function (nom) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$filter(
			function (lue) {
				return _Utils_eq(lue.me, nom);
			}),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			$elm$core$Maybe$map(
				function ($) {
					return $.gt;
				})));
};
var $author$project$I18n$Cles$jourAHeure = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'jour.a-heure',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'jour',
					$author$project$I18n$Traductions$Chaine(p.A_)),
					_Utils_Tuple2(
					'heure',
					$author$project$I18n$Traductions$Chaine(p.Ah))
				]),
			p.A_ + (' à ' + p.Ah));
	});
var $author$project$Texte$Jour$horodateALHeure = F2(
	function (i18n, instant) {
		var _v0 = A2($elm$core$String$split, 'T', instant);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var jour = _v0.a;
			var _v1 = _v0.b;
			var heure = _v1.a;
			var _v2 = _Utils_Tuple2(
				A2($author$project$Texte$Jour$lire, $author$project$Texte$Jour$mois, jour),
				A2($elm$core$String$split, ':', heure));
			if (((!_v2.a.$) && _v2.b.b) && _v2.b.b.b) {
				var _v3 = _v2.b;
				var heures = _v3.a;
				var _v4 = _v3.b;
				var minutes = _v4.a;
				return A2(
					$author$project$I18n$Cles$jourAHeure,
					i18n,
					{
						Ah: heures + (':' + minutes),
						A_: A2($author$project$Texte$Jour$enFrancais, i18n, jour)
					});
			} else {
				return instant;
			}
		} else {
			return instant;
		}
	});
var $author$project$Components$Parametrage$CompteDEnvoi$View$emailDeTestRecu = F2(
	function (i18n, lu) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$Components$Parametrage$CompteDEnvoi$View$etatDeLEtape, 'email-de-test', lu.yL),
			lu.iE);
		if (((!_v0.a.$) && (!_v0.a.a.$)) && (!_v0.b.$)) {
			var le = _v0.a.a.a;
			var adresse = _v0.b.a;
			return ' ' + A2(
				$author$project$I18n$Cles$compteDEnvoiBandeauEmailDeTestRecu,
				i18n,
				{
					aa: adresse,
					cO: A2($author$project$Texte$Jour$horodateALHeure, i18n, le)
				});
		} else {
			return '';
		}
	});
var $author$project$Components$Parametrage$CompteDEnvoi$Update$EmailDeTestDemande = {$: 19};
var $author$project$I18n$Cles$compteDEnvoiEmailDeTest = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.email-de-test', _List_Nil, 'Envoyer un email de test');
};
var $author$project$I18n$Cles$compteDEnvoiEtatEnErreur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.etat.en-erreur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'motif',
					$author$project$I18n$Traductions$Chaine(p.cX))
				]),
			'En erreur : ' + p.cX);
	});
var $author$project$I18n$Cles$compteDEnvoiMotifAdresseIpRefuseeLectureSeule = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.motif.adresse-ip-refusee.lecture-seule',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.yz)))
				]),
			'Brevo refuse les appels du CRM, car le compte Brevo ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.yz);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.yz);
					default:
						return 'de ' + $elm$core$String$trim(p.yz);
				}
			}() + (' bloque les adresses IP inconnues. Un administrateur ' + (function () {
				var _v1 = p.av;
				switch (_v1) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.yz);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.yz);
					default:
						return 'de ' + $elm$core$String$trim(p.yz);
				}
			}() + ' doit désactiver ce blocage dans Brevo, puis vérifier de nouveau.'))));
	});
var $author$project$I18n$Cles$compteDEnvoiMotifAdresseIpRefuseeLectureSeuleSansEspace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.motif.adresse-ip-refusee.lecture-seule.sans-espace', _List_Nil, 'Brevo refuse les appels du CRM, car le compte Brevo de l\'espace bloque les adresses IP inconnues. Un administrateur de l\'espace doit désactiver ce blocage dans Brevo, puis vérifier de nouveau.');
};
var $author$project$I18n$Cles$compteDEnvoiOuvrirBrevo = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.ouvrir-brevo', _List_Nil, 'Ouvrir Brevo');
};
var $author$project$Components$Parametrage$CompteDEnvoi$View$ipRefusee = 'adresse_ip_refusee';
var $author$project$Components$Parametrage$CompteDEnvoi$View$lectureSeule = function (model) {
	return (!_Utils_eq(model.vW, $elm$core$Maybe$Nothing)) && $elm$core$List$isEmpty(
		A2(
			$elm$core$List$filter,
			function (lien) {
				return !_Utils_eq(lien.eP, $author$project$API$NavLinksDictionary$self);
			},
			model.ft));
};
var $author$project$Components$Parametrage$CompteDEnvoi$View$enErreur = F5(
	function (i18n, model, racine, motif, adresse) {
		var dit = A3($author$project$Components$Parametrage$Vocabulaire$motifDuCompteDEnvoi, i18n, motif, adresse);
		var brevo = function (adresseDeBrevo) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id(racine + '-ouvrir-brevo'),
								$rtfeldman$elm_css$Html$Styled$Attributes$href(adresseDeBrevo),
								$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank'),
								$rtfeldman$elm_css$Html$Styled$Attributes$rel('noopener')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$compteDEnvoiOuvrirBrevo(i18n))
							]))
					]));
		};
		return A2(
			$author$project$Components$Shared$Note$View$view,
			2,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$compteDEnvoiEtatEnErreur,
										i18n,
										{cX: dit.Dj}))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							(_Utils_eq(motif, $author$project$Components$Parametrage$CompteDEnvoi$View$ipRefusee) && $author$project$Components$Parametrage$CompteDEnvoi$View$lectureSeule(model)) ? A4($author$project$Components$Parametrage$CompteDEnvoi$View$espace, model, $author$project$I18n$Cles$compteDEnvoiMotifAdresseIpRefuseeLectureSeule, $author$project$I18n$Cles$compteDEnvoiMotifAdresseIpRefuseeLectureSeuleSansEspace, i18n) : dit.bB)
						])),
					((!dit.Ez) || (_Utils_eq(motif, $author$project$Components$Parametrage$CompteDEnvoi$View$ipRefusee) && $author$project$Components$Parametrage$CompteDEnvoi$View$lectureSeule(model))) ? $rtfeldman$elm_css$Html$Styled$text('') : (_Utils_eq(motif, $author$project$Components$Parametrage$CompteDEnvoi$View$ipRefusee) ? A2($author$project$Components$Parametrage$CompteDEnvoi$View$ouvrirLesIpAutorisees, racine, i18n) : ((motif === 'domaine_non_authentifie') ? brevo('https://app.brevo.com/senders/domain/list') : brevo('https://app.brevo.com/contact/list'))),
					function () {
					var _v0 = _Utils_Tuple2(
						dit.HH,
						A2($author$project$Components$Parametrage$CompteDEnvoi$Model$lienDe, $author$project$API$NavLinksDictionary$envoyerUnEmailDeTest, model));
					if (_v0.a && (!_v0.b.$)) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id(racine + '-renvoyer-le-test'),
											$rtfeldman$elm_css$Html$Styled$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'loading',
													$author$project$API$Envoi$enCours(model.l2))
												])),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
											$author$project$API$Envoi$enCours(model.l2)),
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$CompteDEnvoi$Update$EmailDeTestDemande)
										]),
									$author$project$I18n$Cles$compteDEnvoiEmailDeTest(i18n))
								]));
					} else {
						return $rtfeldman$elm_css$Html$Styled$text('');
					}
				}()
				]));
	});
var $author$project$I18n$Cles$compteDEnvoiBandeauNouveauCompteEnErreur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.bandeau.nouveau-compte-en-erreur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'motif',
					$author$project$I18n$Traductions$Chaine(p.cX))
				]),
			'Nouveau compte en erreur : ' + (p.cX + '.'));
	});
var $author$project$I18n$Cles$compteDEnvoiMotifAdresseIpRefuseeNouveauCompte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.motif.adresse-ip-refusee.nouveau-compte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fin',
					$author$project$I18n$Traductions$Chaine(p.mI))
				]),
			'Brevo refuse les appels du CRM, car le nouveau compte Brevo (clé •••• ' + (p.mI + ') bloque les adresses IP inconnues. Dans ce compte Brevo, Sécurité › IP autorisées, désactivez le blocage des IP inconnues, puis vérifiez de nouveau. Autoriser une seule adresse ne suffit pas : le CRM n\'a pas d\'adresse de sortie fixe.'));
	});
var $author$project$Components$Parametrage$CompteDEnvoi$View$nouveauCompteBloque = F3(
	function (i18n, model, nouveau) {
		return A2(
			$author$project$Components$Shared$Note$View$view,
			2,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$compteDEnvoiBandeauNouveauCompteEnErreur,
										i18n,
										{
											cX: $author$project$I18n$Cles$compteDEnvoiMotifAdresseIpRefusee(i18n)
										}))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Components$Parametrage$CompteDEnvoi$View$lectureSeule(model) ? A4($author$project$Components$Parametrage$CompteDEnvoi$View$espace, model, $author$project$I18n$Cles$compteDEnvoiMotifAdresseIpRefuseeLectureSeule, $author$project$I18n$Cles$compteDEnvoiMotifAdresseIpRefuseeLectureSeuleSansEspace, i18n) : A2(
								$author$project$I18n$Cles$compteDEnvoiMotifAdresseIpRefuseeNouveauCompte,
								i18n,
								{
									mI: A2($elm$core$Maybe$withDefault, '', nouveau.mJ)
								}))
						])),
					$author$project$Components$Parametrage$CompteDEnvoi$View$lectureSeule(model) ? $rtfeldman$elm_css$Html$Styled$text('') : A2($author$project$Components$Parametrage$CompteDEnvoi$View$ouvrirLesIpAutorisees, 'compte-d-envoi-nouveau', i18n)
				]));
	});
var $author$project$I18n$Cles$compteDEnvoiVerificationToujoursRefusee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.verification.toujours-refusee', _List_Nil, 'Brevo refuse toujours les appels du CRM.');
};
var $author$project$Components$Parametrage$CompteDEnvoi$View$toujoursRefuse = F2(
	function (i18n, model) {
		return model.rK ? _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Note$View$view,
				0,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-live', 'polite')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$compteDEnvoiVerificationToujoursRefusee(i18n))
							]))
					]))
			]) : _List_Nil;
	});
var $author$project$Components$Parametrage$CompteDEnvoi$View$vuParLesDestinataires = function (lu) {
	return A2($elm$core$Maybe$withDefault, '', lu.ov) + (' <' + (A2($elm$core$Maybe$withDefault, '', lu.mr) + '>'));
};
var $author$project$Components$Parametrage$CompteDEnvoi$View$bandeaux = F3(
	function (i18n, model, lu) {
		var seule = $author$project$Components$Parametrage$CompteDEnvoi$View$lectureSeule(model) ? _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Note$View$view,
				0,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A4($author$project$Components$Parametrage$CompteDEnvoi$View$espace, model, $author$project$I18n$Cles$compteDEnvoiLectureSeuleDetail, $author$project$I18n$Cles$compteDEnvoiLectureSeuleDetailSansEspace, i18n))
					]))
			]) : _List_Nil;
		var bloque = function (premier) {
			return A2(
				$author$project$Components$Shared$Note$View$view,
				1,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(premier)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A4($author$project$Components$Parametrage$CompteDEnvoi$View$espace, model, $author$project$I18n$Cles$compteDEnvoiBandeauRienNePart, $author$project$I18n$Cles$compteDEnvoiBandeauRienNePartSansEspace, i18n))
							]))
					]));
		};
		return _Utils_ap(
			seule,
			_Utils_ap(
				A2($author$project$Components$Parametrage$CompteDEnvoi$View$toujoursRefuse, i18n, model),
				_Utils_ap(
					A2($author$project$Components$Parametrage$CompteDEnvoi$View$emailDeTest, i18n, model),
					_Utils_ap(
						function () {
							var _v0 = lu.gt;
							switch (_v0.$) {
								case 0:
									return _List_fromArray(
										[
											bloque(
											$author$project$I18n$Cles$compteDEnvoiBandeauAucun(i18n))
										]);
								case 1:
									return _List_fromArray(
										[
											bloque(
											$author$project$I18n$Cles$compteDEnvoiBandeauAucunVerifie(i18n))
										]);
								case 2:
									return ((!_Utils_eq(lu.HA, $elm$core$Maybe$Nothing)) || _Utils_eq(
										model.lT,
										$elm$core$Maybe$Just(
											$author$project$Components$Parametrage$CompteDEnvoi$Model$Echoue($author$project$Components$Parametrage$CompteDEnvoi$View$ipRefusee)))) ? _List_Nil : _List_fromArray(
										[
											A2(
											$author$project$Components$Shared$Note$View$view,
											3,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$b,
															_List_Nil,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	$author$project$I18n$Cles$compteDEnvoiBandeauVerifieTitre(i18n))
																]))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															_Utils_ap(
																A3(
																	$author$project$Components$Parametrage$CompteDEnvoi$Model$nommerLEspace,
																	model,
																	function (nom) {
																		return A2(
																			$author$project$I18n$Cles$compteDEnvoiBandeauVerifie,
																			i18n,
																			{
																				av: nom.av,
																				yz: nom.yz,
																				mr: $author$project$Components$Parametrage$CompteDEnvoi$View$vuParLesDestinataires(lu)
																			});
																	},
																	A2(
																		$author$project$I18n$Cles$compteDEnvoiBandeauVerifieSansEspace,
																		i18n,
																		{
																			mr: $author$project$Components$Parametrage$CompteDEnvoi$View$vuParLesDestinataires(lu)
																		})),
																A2($author$project$Components$Parametrage$CompteDEnvoi$View$emailDeTestRecu, i18n, lu)))
														]))
												]))
										]);
								default:
									var motif = _v0.a;
									return _List_fromArray(
										[
											bloque(
											$author$project$I18n$Cles$compteDEnvoiBandeauAucunVerifie(i18n)),
											A5(
											$author$project$Components$Parametrage$CompteDEnvoi$View$enErreur,
											i18n,
											model,
											'compte-d-envoi',
											motif,
											A2($elm$core$Maybe$withDefault, '', lu.iE))
										]);
							}
						}(),
						function () {
							var _v1 = lu.HA;
							if (!_v1.$) {
								var nouveau = _v1.a;
								return _Utils_ap(
									_List_fromArray(
										[
											A2(
											$author$project$Components$Shared$Note$View$view,
											0,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$b,
															_List_Nil,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	_Utils_eq(
																		nouveau.gt,
																		$author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$EnErreur($author$project$Components$Parametrage$CompteDEnvoi$View$ipRefusee)) ? $author$project$I18n$Cles$compteDEnvoiBandeauRemplacementNonVerifie(i18n) : $author$project$I18n$Cles$compteDEnvoiBandeauRemplacement(i18n))
																]))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															A4($author$project$Components$Parametrage$CompteDEnvoi$View$espace, model, $author$project$I18n$Cles$compteDEnvoiBandeauRemplacementDetail, $author$project$I18n$Cles$compteDEnvoiBandeauRemplacementDetailSansEspace, i18n))
														]))
												]))
										]),
									_Utils_eq(
										nouveau.gt,
										$author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$EnErreur($author$project$Components$Parametrage$CompteDEnvoi$View$ipRefusee)) ? _List_fromArray(
										[
											A3($author$project$Components$Parametrage$CompteDEnvoi$View$nouveauCompteBloque, i18n, model, nouveau)
										]) : _List_Nil);
							} else {
								return _List_Nil;
							}
						}()))));
	});
var $author$project$I18n$Cles$compteDEnvoiAucunDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.aucun.detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.yz)))
				]),
			'Connectez le compte d\'envoi ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.yz);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.yz);
					default:
						return 'de ' + $elm$core$String$trim(p.yz);
				}
			}() + (' : Brevo, par sa clé d\'API. Les emails partiront sous le nom de l\'espace et sous sa responsabilité. Un seul compte d\'envoi est actif pour ' + (p.yz + '.'))));
	});
var $author$project$I18n$Cles$compteDEnvoiAucunDetailSansEspace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.aucun.detail.sans-espace', _List_Nil, 'Connectez le compte d\'envoi de l\'espace : Brevo, par sa clé d\'API. Les emails partiront sous le nom de l\'espace et sous sa responsabilité. Un seul compte d\'envoi est actif pour l\'espace.');
};
var $author$project$I18n$Cles$compteDEnvoiAucunTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.aucun.texte', _List_Nil, 'Aucun compte connecté.');
};
var $author$project$I18n$Cles$compteDEnvoiAucunTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.aucun.titre', _List_Nil, 'Le compte d\'envoi');
};
var $author$project$I18n$Cles$compteDEnvoiConnexionCleGardee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.connexion.cle-gardee', _List_Nil, 'Enregistrée');
};
var $author$project$I18n$Cles$compteDEnvoiConnexionCleMasquee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.connexion.cle-masquee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fin',
					$author$project$I18n$Traductions$Chaine(p.mI))
				]),
			'•••• •••• •••• ' + p.mI);
	});
var $author$project$Components$Parametrage$CompteDEnvoi$View$cleMasquee = F2(
	function (i18n, lu) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Cles$compteDEnvoiConnexionCleGardee(i18n),
			A2(
				$elm$core$Maybe$map,
				function (fin) {
					return A2(
						$author$project$I18n$Cles$compteDEnvoiConnexionCleMasquee,
						i18n,
						{mI: fin});
				},
				lu.mJ));
	});
var $author$project$I18n$Cles$compteDEnvoiCompteActuelTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.compte-actuel.titre', _List_Nil, 'Compte actuel · Brevo');
};
var $author$project$I18n$Cles$compteDEnvoiConnexionCle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.connexion.cle', _List_Nil, 'Clé d\'API');
};
var $author$project$I18n$Cles$compteDEnvoiConnexionEtat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.connexion.etat', _List_Nil, 'État');
};
var $author$project$I18n$Cles$compteDEnvoiConnexionNote = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.connexion.note',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.yz)))
				]),
			'La clé est chiffrée avec la clé ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.yz);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.yz);
					default:
						return 'de ' + $elm$core$String$trim(p.yz);
				}
			}() + '. Elle n\'est jamais réaffichée : seuls ses quatre derniers caractères le sont.'));
	});
var $author$project$I18n$Cles$compteDEnvoiConnexionNoteSansEspace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.connexion.note.sans-espace', _List_Nil, 'La clé est chiffrée avec la clé de l\'espace. Elle n\'est jamais réaffichée : seuls ses quatre derniers caractères le sont.');
};
var $author$project$I18n$Cles$compteDEnvoiConnexionTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.connexion.titre', _List_Nil, 'Connexion Brevo');
};
var $author$project$Components$Parametrage$CompteDEnvoi$View$dansLeFixed = F2(
	function (etat, i18n) {
		if (etat.$ === 3) {
			var motif = etat.a;
			return !A3($author$project$Components$Parametrage$Vocabulaire$motifDuCompteDEnvoi, i18n, motif, '').oT;
		} else {
			return false;
		}
	});
var $author$project$Components$Parametrage$CompteDEnvoi$View$domaineDe = function (adresse) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$String$split('@'),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$drop(1),
					$elm$core$List$head)),
			adresse));
};
var $author$project$I18n$Cles$compteDEnvoiEtapes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.etapes', _List_Nil, 'Étapes de la vérification');
};
var $author$project$I18n$Cles$compteDEnvoiEtapeEnCours = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.etape.en-cours', _List_Nil, 'en cours');
};
var $author$project$I18n$Cles$compteDEnvoiEtapeHeure = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.etape.heure',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'heure',
					$author$project$I18n$Traductions$Chaine(p.Ah))
				]),
			'· ' + p.Ah);
	});
var $author$project$I18n$Cles$compteDEnvoiEtapeAutreAVenir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.etape.autre.a-venir', _List_Nil, 'Étape de vérification à venir');
};
var $author$project$I18n$Cles$compteDEnvoiEtapeAutreEchouee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.etape.autre.echouee', _List_Nil, 'Étape de vérification échouée');
};
var $author$project$I18n$Cles$compteDEnvoiEtapeAutreFranchie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.etape.autre.franchie', _List_Nil, 'Étape de vérification franchie');
};
var $author$project$I18n$Cles$compteDEnvoiEtapeCleAVenir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.etape.cle.a-venir', _List_Nil, 'Clé d\'API : à vérifier');
};
var $author$project$I18n$Cles$compteDEnvoiEtapeCleEchouee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.etape.cle.echouee', _List_Nil, 'Clé d\'API refusée par Brevo');
};
var $author$project$I18n$Cles$compteDEnvoiEtapeCleFranchie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.etape.cle.franchie', _List_Nil, 'Clé d\'API acceptée par Brevo');
};
var $author$project$I18n$Cles$compteDEnvoiEtapeDomaineAVenir = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.etape.domaine.a-venir',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'domaine',
					$author$project$I18n$Traductions$Chaine(p.cC))
				]),
			'Domaine ' + (p.cC + ' : à vérifier'));
	});
var $author$project$I18n$Cles$compteDEnvoiEtapeDomaineEchouee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.etape.domaine.echouee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'domaine',
					$author$project$I18n$Traductions$Chaine(p.cC))
				]),
			'Domaine ' + (p.cC + ' non authentifié par Brevo'));
	});
var $author$project$I18n$Cles$compteDEnvoiEtapeDomaineFranchie = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.etape.domaine.franchie',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'domaine',
					$author$project$I18n$Traductions$Chaine(p.cC))
				]),
			'Domaine ' + (p.cC + ' authentifié par Brevo'));
	});
var $author$project$I18n$Cles$compteDEnvoiEtapeEmailDeTestAVenir = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.etape.email-de-test.a-venir',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'adresse',
					$author$project$I18n$Traductions$Chaine(p.aa))
				]),
			'Email de test à ' + p.aa);
	});
var $author$project$I18n$Cles$compteDEnvoiEtapeEmailDeTestEchouee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.etape.email-de-test.echouee', _List_Nil, 'Email de test non délivré');
};
var $author$project$I18n$Cles$compteDEnvoiEtapeEmailDeTestEnCours = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.etape.email-de-test.en-cours',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'adresse',
					$author$project$I18n$Traductions$Chaine(p.aa))
				]),
			'Email de test à ' + p.aa);
	});
var $author$project$I18n$Cles$compteDEnvoiEtapeEmailDeTestFranchie = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.etape.email-de-test.franchie',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'adresse',
					$author$project$I18n$Traductions$Chaine(p.aa))
				]),
			'Email de test reçu par ' + p.aa);
	});
var $author$project$I18n$Cles$compteDEnvoiEtapeExpediteurAVenir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.etape.expediteur.a-venir', _List_Nil, 'Adresse d\'expédition : à vérifier');
};
var $author$project$I18n$Cles$compteDEnvoiEtapeExpediteurEchouee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.etape.expediteur.echouee', _List_Nil, 'Adresse d\'expédition inconnue de Brevo');
};
var $author$project$I18n$Cles$compteDEnvoiEtapeExpediteurFranchie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.etape.expediteur.franchie', _List_Nil, 'Adresse d\'expédition reconnue par Brevo');
};
var $author$project$I18n$Cles$compteDEnvoiEtapeWebhookAVenir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.etape.webhook.a-venir', _List_Nil, 'Webhook de suivi : à venir');
};
var $author$project$I18n$Cles$compteDEnvoiEtapeWebhookEchouee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.etape.webhook.echouee', _List_Nil, 'Webhook de suivi non inscrit');
};
var $author$project$I18n$Cles$compteDEnvoiEtapeWebhookFranchie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.etape.webhook.franchie', _List_Nil, 'Webhook de suivi inscrit');
};
var $author$project$Components$Parametrage$Vocabulaire$etapeDuCompteDEnvoi = F3(
	function (i18n, etape, cites) {
		var dit = F3(
			function (franchie, echouee, aVenir) {
				return {sJ: aVenir, lL: echouee, yj: aVenir, zZ: franchie};
			});
		switch (etape) {
			case 'cle':
				return A3(
					dit,
					$author$project$I18n$Cles$compteDEnvoiEtapeCleFranchie(i18n),
					$author$project$I18n$Cles$compteDEnvoiEtapeCleEchouee(i18n),
					$author$project$I18n$Cles$compteDEnvoiEtapeCleAVenir(i18n));
			case 'expediteur':
				return A3(
					dit,
					$author$project$I18n$Cles$compteDEnvoiEtapeExpediteurFranchie(i18n),
					$author$project$I18n$Cles$compteDEnvoiEtapeExpediteurEchouee(i18n),
					$author$project$I18n$Cles$compteDEnvoiEtapeExpediteurAVenir(i18n));
			case 'domaine':
				return A3(
					dit,
					A2(
						$author$project$I18n$Cles$compteDEnvoiEtapeDomaineFranchie,
						i18n,
						{cC: cites.cC}),
					A2(
						$author$project$I18n$Cles$compteDEnvoiEtapeDomaineEchouee,
						i18n,
						{cC: cites.cC}),
					A2(
						$author$project$I18n$Cles$compteDEnvoiEtapeDomaineAVenir,
						i18n,
						{cC: cites.cC}));
			case 'webhook':
				return A3(
					dit,
					$author$project$I18n$Cles$compteDEnvoiEtapeWebhookFranchie(i18n),
					$author$project$I18n$Cles$compteDEnvoiEtapeWebhookEchouee(i18n),
					$author$project$I18n$Cles$compteDEnvoiEtapeWebhookAVenir(i18n));
			case 'email-de-test':
				return {
					sJ: A2(
						$author$project$I18n$Cles$compteDEnvoiEtapeEmailDeTestAVenir,
						i18n,
						{aa: cites.aa}),
					lL: $author$project$I18n$Cles$compteDEnvoiEtapeEmailDeTestEchouee(i18n),
					yj: A2(
						$author$project$I18n$Cles$compteDEnvoiEtapeEmailDeTestEnCours,
						i18n,
						{aa: cites.aa}),
					zZ: A2(
						$author$project$I18n$Cles$compteDEnvoiEtapeEmailDeTestFranchie,
						i18n,
						{aa: cites.aa})
				};
			default:
				return A3(
					dit,
					$author$project$I18n$Cles$compteDEnvoiEtapeAutreFranchie(i18n),
					$author$project$I18n$Cles$compteDEnvoiEtapeAutreEchouee(i18n),
					$author$project$I18n$Cles$compteDEnvoiEtapeAutreAVenir(i18n));
		}
	});
var $author$project$Texte$Jour$heureDe = function (instant) {
	var _v0 = A2(
		$elm$core$Maybe$map,
		$elm$core$String$split(':'),
		$elm$core$List$head(
			A2(
				$elm$core$List$drop,
				1,
				A2($elm$core$String$split, 'T', instant))));
	if (((!_v0.$) && _v0.a.b) && _v0.a.b.b) {
		var _v1 = _v0.a;
		var heures = _v1.a;
		var _v2 = _v1.b;
		var minutes = _v2.a;
		return heures + (':' + A2($elm$core$String$left, 2, minutes));
	} else {
		return instant;
	}
};
var $author$project$Components$Shared$Svg$svgCheck = A3($author$project$Components$Shared$Svg$icone, 'check', 'M6 12l4 4 8-8', _List_Nil);
var $author$project$Components$Parametrage$CompteDEnvoi$View$etape = F3(
	function (i18n, cites, lue) {
		var instant = function (le) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('instant')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$compteDEnvoiEtapeHeure,
							i18n,
							{
								Ah: $author$project$Texte$Jour$heureDe(le)
							}))
					]));
		};
		var dit = A3($author$project$Components$Parametrage$Vocabulaire$etapeDuCompteDEnvoi, i18n, lue.me, cites);
		var _v0 = lue.gt;
		switch (_v0.$) {
			case 0:
				var le = _v0.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('etape'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('franchie')
						]),
					_List_fromArray(
						[
							$author$project$Components$Shared$Svg$svgCheck,
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(dit.zZ)
								])),
							instant(le)
						]));
			case 1:
				return A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('etape'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('en-cours')
						]),
					_List_fromArray(
						[
							$author$project$Components$Shared$Svg$svgClock,
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(dit.yj)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('instant')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$compteDEnvoiEtapeEnCours(i18n))
								]))
						]));
			case 2:
				var le = _v0.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('etape'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('echouee')
						]),
					A2(
						$elm$core$List$cons,
						$author$project$Components$Shared$Svg$svgClose,
						A2(
							$elm$core$List$cons,
							A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(dit.lL)
									])),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A2($elm$core$Basics$composeR, instant, $elm$core$List$singleton),
									le)))));
			case 3:
				var le = _v0.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('etape'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('echouee')
						]),
					_List_fromArray(
						[
							$author$project$Components$Shared$Svg$svgClose,
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(dit.lL)
								])),
							instant(le)
						]));
			default:
				return A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('etape'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('a-venir')
						]),
					_List_fromArray(
						[
							$author$project$Components$Shared$Svg$svgClock,
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(dit.sJ)
								]))
						]));
		}
	});
var $author$project$Components$Parametrage$CompteDEnvoi$View$etapes = F3(
	function (i18n, cites, lues) {
		return $elm$core$List$isEmpty(lues) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$ol,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('etapes'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					$author$project$I18n$Cles$compteDEnvoiEtapes(i18n))
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$Components$Parametrage$CompteDEnvoi$View$etape, i18n, cites),
				lues));
	});
var $author$project$Components$Parametrage$CompteDEnvoi$View$ligne = F3(
	function (nom, libelle, valeur) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(nom)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$dt,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$dd,
					_List_Nil,
					_List_fromArray(
						[valeur]))
				]));
	});
var $author$project$Components$Parametrage$CompteDEnvoi$Update$ConnexionDemandee = {$: 7};
var $author$project$I18n$Cles$compteDEnvoiConnexionBloqueLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.connexion.bloque-le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'instant',
					$author$project$I18n$Traductions$Chaine(p.cO))
				]),
			'Brevo a bloqué l\'appel le ' + p.cO);
	});
var $author$project$I18n$Cles$compteDEnvoiConnexionCleAcceptee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.connexion.cle-acceptee', _List_Nil, 'Acceptée');
};
var $author$project$I18n$Cles$compteDEnvoiConnexionCleNonVerifiee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.connexion.cle-non-verifiee', _List_Nil, 'Non vérifiée');
};
var $author$project$I18n$Cles$compteDEnvoiConnexionCleRefusee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.connexion.cle-refusee', _List_Nil, 'Refusée');
};
var $author$project$I18n$Cles$compteDEnvoiConnexionCleRefuseeLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.connexion.cle-refusee-le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'instant',
					$author$project$I18n$Traductions$Chaine(p.cO))
				]),
			'Refusée le ' + p.cO);
	});
var $author$project$I18n$Cles$compteDEnvoiConnexionDomaine = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.connexion.domaine',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'domaine',
					$author$project$I18n$Traductions$Chaine(p.cC))
				]),
			'Domaine ' + p.cC);
	});
var $author$project$I18n$Cles$compteDEnvoiConnexionDomaineAuthentifie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.connexion.domaine-authentifie', _List_Nil, 'Authentifié chez Brevo');
};
var $author$project$I18n$Cles$compteDEnvoiConnexionDomaineAuthentifieLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.connexion.domaine-authentifie-le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'instant',
					$author$project$I18n$Traductions$Chaine(p.cO))
				]),
			'Domaine authentifié, lu le ' + p.cO);
	});
var $author$project$I18n$Cles$compteDEnvoiConnexionDomaineLuLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.connexion.domaine-lu-le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'instant',
					$author$project$I18n$Traductions$Chaine(p.cO))
				]),
			'lu le ' + p.cO);
	});
var $author$project$I18n$Cles$compteDEnvoiConnexionDomaineNonAuthentifie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.connexion.domaine-non-authentifie', _List_Nil, 'Non authentifié');
};
var $author$project$I18n$Cles$compteDEnvoiConnexionDomaineNonLu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.connexion.domaine-non-lu', _List_Nil, 'Non lu');
};
var $author$project$I18n$Cles$compteDEnvoiConnexionModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.connexion.modifier', _List_Nil, 'modifier');
};
var $author$project$I18n$Cles$compteDEnvoiConnexionWebhook = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.connexion.webhook', _List_Nil, 'Webhook de suivi');
};
var $author$project$I18n$Cles$compteDEnvoiConnexionWebhookInscrit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.connexion.webhook-inscrit', _List_Nil, 'Inscrit');
};
var $author$project$I18n$Cles$compteDEnvoiConnexionWebhookNonInscrit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.connexion.webhook-non-inscrit', _List_Nil, 'Non inscrit');
};
var $author$project$I18n$Cles$compteDEnvoiConnexionWebhookSecret = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.connexion.webhook-secret',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(p.yz))
				]),
			'protégé par un jeton propre à ' + p.yz);
	});
var $author$project$I18n$Cles$compteDEnvoiConnexionWebhookSecretSansEspace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.connexion.webhook-secret.sans-espace', _List_Nil, 'protégé par un jeton propre à l\'espace');
};
var $author$project$Components$Parametrage$CompteDEnvoi$View$resume = F3(
	function (i18n, model, lu) {
		var modifier = function () {
			var _v4 = _Utils_Tuple2(
				lu.g_,
				A2($author$project$Components$Parametrage$CompteDEnvoi$Model$lienDe, $author$project$API$NavLinksDictionary$connecterBrevo, model));
			if (_v4.a && (!_v4.b.$)) {
				return _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						2,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('compte-d-envoi-cle-modifier'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$CompteDEnvoi$Update$ConnexionDemandee)
							]),
						$author$project$I18n$Cles$compteDEnvoiConnexionModifier(i18n))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var lu_ = function (instant) {
			return A2($author$project$Texte$Jour$horodateALHeure, i18n, instant);
		};
		var etatDe = function (nom) {
			return A2($author$project$Components$Parametrage$CompteDEnvoi$View$etatDeLEtape, nom, lu.yL);
		};
		var aide = function (texte) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(texte)
					]));
		};
		var bloqueLe = function (instant) {
			return aide(
				A2(
					$author$project$I18n$Cles$compteDEnvoiConnexionBloqueLe,
					i18n,
					{
						cO: lu_(instant)
					}));
		};
		var cle = A2(
			$elm$core$List$cons,
			A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('cle')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$Components$Parametrage$CompteDEnvoi$View$cleMasquee, i18n, lu))
					])),
			function () {
				if (_Utils_eq(lu.gt, $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$Verifie)) {
					return modifier;
				} else {
					var _v2 = etatDe('cle');
					_v2$4:
					while (true) {
						if (!_v2.$) {
							switch (_v2.a.$) {
								case 0:
									return _List_fromArray(
										[
											A2(
											$author$project$Components$Shared$Tag$View$view,
											0,
											$author$project$I18n$Cles$compteDEnvoiConnexionCleAcceptee(i18n))
										]);
								case 3:
									var le = _v2.a.a;
									return _List_fromArray(
										[
											A2(
											$author$project$Components$Shared$Tag$View$view,
											3,
											$author$project$I18n$Cles$compteDEnvoiConnexionCleNonVerifiee(i18n)),
											bloqueLe(le)
										]);
								case 2:
									if (!_v2.a.a.$) {
										var le = _v2.a.a.a;
										return _List_fromArray(
											[
												aide(
												A2(
													$author$project$I18n$Cles$compteDEnvoiConnexionCleRefuseeLe,
													i18n,
													{
														cO: lu_(le)
													}))
											]);
									} else {
										var _v3 = _v2.a.a;
										return _List_fromArray(
											[
												A2(
												$author$project$Components$Shared$Tag$View$view,
												2,
												$author$project$I18n$Cles$compteDEnvoiConnexionCleRefusee(i18n))
											]);
									}
								default:
									break _v2$4;
							}
						} else {
							break _v2$4;
						}
					}
					return _List_Nil;
				}
			}());
		var domaine = function () {
			var _v1 = etatDe('domaine');
			_v1$2:
			while (true) {
				if (!_v1.$) {
					switch (_v1.a.$) {
						case 0:
							var le = _v1.a.a;
							return _List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Tag$View$view,
									0,
									$author$project$I18n$Cles$compteDEnvoiConnexionDomaineAuthentifie(i18n)),
									aide(
									A2(
										$author$project$I18n$Cles$compteDEnvoiConnexionDomaineAuthentifieLe,
										i18n,
										{
											cO: lu_(le)
										}))
								]);
						case 2:
							var le = _v1.a.a;
							return A2(
								$elm$core$List$cons,
								A2(
									$author$project$Components$Shared$Tag$View$view,
									2,
									$author$project$I18n$Cles$compteDEnvoiConnexionDomaineNonAuthentifie(i18n)),
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function (instant) {
											return _List_fromArray(
												[
													aide(
													A2(
														$author$project$I18n$Cles$compteDEnvoiConnexionDomaineLuLe,
														i18n,
														{
															cO: lu_(instant)
														}))
												]);
										},
										le)));
						default:
							break _v1$2;
					}
				} else {
					break _v1$2;
				}
			}
			return _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Tag$View$view,
					3,
					$author$project$I18n$Cles$compteDEnvoiConnexionDomaineNonLu(i18n))
				]);
		}();
		var webhook = function () {
			var _v0 = etatDe('webhook');
			_v0$2:
			while (true) {
				if (!_v0.$) {
					switch (_v0.a.$) {
						case 0:
							return _List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Tag$View$view,
									0,
									$author$project$I18n$Cles$compteDEnvoiConnexionWebhookInscrit(i18n)),
									aide(
									A3(
										$author$project$Components$Parametrage$CompteDEnvoi$Model$nommerLEspace,
										model,
										function (nom) {
											return A2(
												$author$project$I18n$Cles$compteDEnvoiConnexionWebhookSecret,
												i18n,
												{yz: nom.yz});
										},
										$author$project$I18n$Cles$compteDEnvoiConnexionWebhookSecretSansEspace(i18n)))
								]);
						case 3:
							var le = _v0.a.a;
							return _List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Tag$View$view,
									2,
									$author$project$I18n$Cles$compteDEnvoiConnexionWebhookNonInscrit(i18n)),
									bloqueLe(le)
								]);
						default:
							break _v0$2;
					}
				} else {
					break _v0$2;
				}
			}
			return _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Tag$View$view,
					3,
					$author$project$I18n$Cles$compteDEnvoiConnexionWebhookNonInscrit(i18n))
				]);
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$dl,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('valeurs'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('resume')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Components$Parametrage$CompteDEnvoi$View$ligne,
					'cle',
					$author$project$I18n$Cles$compteDEnvoiConnexionCle(i18n),
					A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
							]),
						cle)),
					A3(
					$author$project$Components$Parametrage$CompteDEnvoi$View$ligne,
					'domaine',
					A2(
						$author$project$I18n$Cles$compteDEnvoiConnexionDomaine,
						i18n,
						{
							cC: $author$project$Components$Parametrage$CompteDEnvoi$View$domaineDe(lu.mr)
						}),
					A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
							]),
						domaine)),
					A3(
					$author$project$Components$Parametrage$CompteDEnvoi$View$ligne,
					'webhook',
					$author$project$I18n$Cles$compteDEnvoiConnexionWebhook(i18n),
					A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
							]),
						webhook))
				]));
	});
var $author$project$I18n$Cles$compteDEnvoiEtatEnVerification = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.etat.en-verification', _List_Nil, 'Vérification en cours');
};
var $author$project$I18n$Cles$compteDEnvoiEtatNonConfigure = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.etat.non-configure', _List_Nil, 'Non configuré');
};
var $author$project$I18n$Cles$compteDEnvoiEtatVerifie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.etat.verifie', _List_Nil, 'Vérifié');
};
var $author$project$Components$Parametrage$CompteDEnvoi$View$tagDeLEtat = F2(
	function (i18n, etat) {
		switch (etat.$) {
			case 0:
				return A2(
					$author$project$Components$Shared$Tag$View$view,
					1,
					$author$project$I18n$Cles$compteDEnvoiEtatNonConfigure(i18n));
			case 1:
				return A2(
					$author$project$Components$Shared$Tag$View$view,
					1,
					$author$project$I18n$Cles$compteDEnvoiEtatEnVerification(i18n));
			case 2:
				return A2(
					$author$project$Components$Shared$Tag$View$view,
					0,
					$author$project$I18n$Cles$compteDEnvoiEtatVerifie(i18n));
			default:
				var motif = etat.a;
				return A2(
					$author$project$Components$Shared$Tag$View$view,
					2,
					A2(
						$author$project$I18n$Cles$compteDEnvoiEtatEnErreur,
						i18n,
						{
							cX: A3($author$project$Components$Parametrage$Vocabulaire$motifDuCompteDEnvoi, i18n, motif, '').Dj
						}));
		}
	});
var $author$project$Components$Parametrage$CompteDEnvoi$Update$VerificationDemandee = {$: 14};
var $author$project$I18n$Cles$compteDEnvoiVerifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.verifier', _List_Nil, 'Vérifier de nouveau');
};
var $author$project$Components$Parametrage$CompteDEnvoi$View$verifierEn = F3(
	function (variante, i18n, model) {
		var _v0 = A2($author$project$Components$Parametrage$CompteDEnvoi$Model$lienDe, $author$project$API$NavLinksDictionary$verifier, model);
		if (!_v0.$) {
			return _List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					variante,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('compte-d-envoi-verifier'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'loading',
									$author$project$API$Envoi$enCours(model.l2))
								])),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
							$author$project$API$Envoi$enCours(model.l2)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$CompteDEnvoi$Update$VerificationDemandee)
						]),
					$author$project$I18n$Cles$compteDEnvoiVerifier(i18n))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Parametrage$CompteDEnvoi$View$verifier = $author$project$Components$Parametrage$CompteDEnvoi$View$verifierEn(1);
var $author$project$Components$Parametrage$CompteDEnvoi$View$connexion = F3(
	function (i18n, model, lu) {
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_Nil,
			{
				fw: (_Utils_eq(lu.HA, $elm$core$Maybe$Nothing) && (!A2($author$project$Components$Parametrage$CompteDEnvoi$View$dansLeFixed, lu.gt, i18n))) ? A2($author$project$Components$Parametrage$CompteDEnvoi$View$verifier, i18n, model) : _List_Nil,
				fZ: _Utils_ap(
					_Utils_eq(lu.gt, $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$EnVerification) ? _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$dl,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('valeurs')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Components$Parametrage$CompteDEnvoi$View$ligne,
									'cle',
									$author$project$I18n$Cles$compteDEnvoiConnexionCle(i18n),
									$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$Components$Parametrage$CompteDEnvoi$View$cleMasquee, i18n, lu))),
									A3(
									$author$project$Components$Parametrage$CompteDEnvoi$View$ligne,
									'etat',
									$author$project$I18n$Cles$compteDEnvoiConnexionEtat(i18n),
									A2($author$project$Components$Parametrage$CompteDEnvoi$View$tagDeLEtat, i18n, lu.gt))
								])),
							A3(
							$author$project$Components$Parametrage$CompteDEnvoi$View$etapes,
							i18n,
							{
								aa: A2($elm$core$Maybe$withDefault, '', lu.iE),
								cC: $author$project$Components$Parametrage$CompteDEnvoi$View$domaineDe(lu.mr)
							},
							lu.yL)
						]) : _List_fromArray(
						[
							A3(
							$author$project$Components$Parametrage$CompteDEnvoi$View$resume,
							i18n,
							model,
							{
								yL: lu.yL,
								gt: lu.gt,
								mr: lu.mr,
								mJ: lu.mJ,
								g_: _Utils_eq(lu.gt, $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$Verifie) && _Utils_eq(lu.HA, $elm$core$Maybe$Nothing)
							})
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A4($author$project$Components$Parametrage$CompteDEnvoi$View$espace, model, $author$project$I18n$Cles$compteDEnvoiConnexionNote, $author$project$I18n$Cles$compteDEnvoiConnexionNoteSansEspace, i18n))
								]))
						])),
				Dj: 'connexion',
				h6: (!_Utils_eq(lu.HA, $elm$core$Maybe$Nothing)) ? $author$project$I18n$Cles$compteDEnvoiCompteActuelTitre(i18n) : $author$project$I18n$Cles$compteDEnvoiConnexionTitre(i18n)
			});
	});
var $author$project$Components$Parametrage$CompteDEnvoi$Update$ModificationDeLExpediteurDemandee = {$: 8};
var $author$project$I18n$Cles$compteDEnvoiExpediteurAdresse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.expediteur.adresse', _List_Nil, 'Adresse d\'expédition');
};
var $author$project$I18n$Cles$compteDEnvoiExpediteurApercu = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.expediteur.apercu',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'adresse',
					$author$project$I18n$Traductions$Chaine(p.aa))
				]),
			'Les destinataires voient ' + (p.Dj + (' <' + (p.aa + '>'))));
	});
var $author$project$I18n$Cles$compteDEnvoiExpediteurNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.expediteur.nom', _List_Nil, 'Nom de l\'expéditeur');
};
var $author$project$I18n$Cles$compteDEnvoiExpediteurNonRenseignee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.expediteur.non-renseignee', _List_Nil, 'Non renseignée');
};
var $author$project$I18n$Cles$compteDEnvoiExpediteurReponse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.expediteur.reponse', _List_Nil, 'Adresse de réponse');
};
var $author$project$I18n$Cles$compteDEnvoiExpediteurTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.expediteur.titre', _List_Nil, 'Expéditeur');
};
var $author$project$I18n$Cles$compteDEnvoiModifierLExpediteur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.modifier-l-expediteur', _List_Nil, 'Modifier l\'expéditeur');
};
var $author$project$Components$Parametrage$CompteDEnvoi$View$expediteur = F3(
	function (i18n, model, lu) {
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_Nil,
			{
				fw: function () {
					var _v0 = A2($author$project$Components$Parametrage$CompteDEnvoi$Model$lienDe, $author$project$API$NavLinksDictionary$modifierLExpediteur, model);
					if (!_v0.$) {
						return _List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('compte-d-envoi-expediteur-ouvrir'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$CompteDEnvoi$Update$ModificationDeLExpediteurDemandee)
									]),
								$author$project$I18n$Cles$compteDEnvoiModifierLExpediteur(i18n))
							]);
					} else {
						return _List_Nil;
					}
				}(),
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$dl,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('valeurs')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Components$Parametrage$CompteDEnvoi$View$ligne,
								'nom',
								$author$project$I18n$Cles$compteDEnvoiExpediteurNom(i18n),
								$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$Maybe$withDefault, '', lu.ov))),
								A3(
								$author$project$Components$Parametrage$CompteDEnvoi$View$ligne,
								'adresse',
								$author$project$I18n$Cles$compteDEnvoiExpediteurAdresse(i18n),
								$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$Maybe$withDefault, '', lu.mr))),
								A3(
								$author$project$Components$Parametrage$CompteDEnvoi$View$ligne,
								'reponse',
								$author$project$I18n$Cles$compteDEnvoiExpediteurReponse(i18n),
								$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$I18n$Cles$compteDEnvoiExpediteurNonRenseignee(i18n),
										lu.qw)))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$compteDEnvoiExpediteurApercu,
									i18n,
									{
										aa: A2($elm$core$Maybe$withDefault, '', lu.mr),
										Dj: A2($elm$core$Maybe$withDefault, '', lu.ov)
									}))
							]))
					]),
				Dj: 'expediteur',
				h6: $author$project$I18n$Cles$compteDEnvoiExpediteurTitre(i18n)
			});
	});
var $author$project$I18n$Cles$compteDEnvoiHistoriqueAuteurInconnu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.historique.auteur-inconnu', _List_Nil, 'Auteur inconnu');
};
var $author$project$I18n$Cles$compteDEnvoiHistoriqueDate = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.historique.date', _List_Nil, 'Date');
};
var $author$project$I18n$Cles$compteDEnvoiHistoriqueEvenement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.historique.evenement', _List_Nil, 'Événement');
};
var $author$project$I18n$Cles$compteDEnvoiHistoriquePar = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.historique.par', _List_Nil, 'Par');
};
var $author$project$I18n$Cles$compteDEnvoiHistoriqueTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.historique.titre', _List_Nil, 'Historique du compte');
};
var $author$project$I18n$Cles$compteDEnvoiHistoriqueVerificationAutomatique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.historique.verification-automatique', _List_Nil, 'Vérification automatique');
};
var $author$project$I18n$Cles$compteDEnvoiFaitAutre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.fait.autre', _List_Nil, 'Événement du compte');
};
var $author$project$I18n$Cles$compteDEnvoiFaitBrevoConnecte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.fait.brevo-connecte', _List_Nil, 'Compte Brevo connecté');
};
var $author$project$I18n$Cles$compteDEnvoiFaitCompteDeconnecte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.fait.compte-deconnecte', _List_Nil, 'Compte déconnecté');
};
var $author$project$I18n$Cles$compteDEnvoiFaitCompteRemplace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.fait.compte-remplace', _List_Nil, 'Compte remplacé : le nouveau compte est le seul actif');
};
var $author$project$I18n$Cles$compteDEnvoiFaitCompteVerifie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.fait.compte-verifie', _List_Nil, 'Compte vérifié');
};
var $author$project$I18n$Cles$compteDEnvoiFaitEmailDeTestEchoue = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.fait.email-de-test-echoue',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'motif',
					$author$project$I18n$Traductions$Chaine(p.cX))
				]),
			'Email de test non parti : ' + p.cX);
	});
var $author$project$I18n$Cles$compteDEnvoiFaitEmailDeTestEnvoye = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.fait.email-de-test-envoye', _List_Nil, 'Email de test envoyé');
};
var $author$project$I18n$Cles$compteDEnvoiFaitEmailDeTestNonDelivre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.fait.email-de-test-non-delivre', _List_Nil, 'Email de test non délivré');
};
var $author$project$I18n$Cles$compteDEnvoiFaitEmailDeTestRecu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.fait.email-de-test-recu', _List_Nil, 'Email de test reçu');
};
var $author$project$I18n$Cles$compteDEnvoiFaitExpediteurModifie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.fait.expediteur-modifie', _List_Nil, 'Expéditeur modifié : nouveau compte en vérification');
};
var $author$project$I18n$Cles$compteDEnvoiFaitRemplacementAnnule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.fait.remplacement-annule', _List_Nil, 'Remplacement annulé');
};
var $author$project$I18n$Cles$compteDEnvoiFaitRemplacementDemande = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.fait.remplacement-demande',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fin',
					$author$project$I18n$Traductions$Chaine(p.mI))
				]),
			'Remplacement demandé : nouveau compte Brevo (clé •••• ' + (p.mI + ')'));
	});
var $author$project$I18n$Cles$compteDEnvoiFaitVerificationEchouee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.fait.verification-echouee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'motif',
					$author$project$I18n$Traductions$Chaine(p.cX))
				]),
			'Vérification échouée : ' + p.cX);
	});
var $author$project$Components$Parametrage$Vocabulaire$faitDuCompteDEnvoi = F4(
	function (i18n, fait, detail, domaine) {
		var cite = A2($elm$core$Maybe$withDefault, '', detail);
		var motif = A3($author$project$Components$Parametrage$Vocabulaire$motifDuCompteDEnvoi, i18n, cite, '').Dj;
		switch (fait) {
			case 'brevo_connecte':
				return $author$project$I18n$Cles$compteDEnvoiFaitBrevoConnecte(i18n);
			case 'remplacement_demande':
				return A2(
					$author$project$I18n$Cles$compteDEnvoiFaitRemplacementDemande,
					i18n,
					{mI: cite});
			case 'expediteur_modifie':
				return $author$project$I18n$Cles$compteDEnvoiFaitExpediteurModifie(i18n);
			case 'etape_franchie':
				return A3(
					$author$project$Components$Parametrage$Vocabulaire$etapeDuCompteDEnvoi,
					i18n,
					cite,
					{aa: '', cC: domaine}).zZ;
			case 'webhook_inscrit':
				return $author$project$I18n$Cles$compteDEnvoiEtapeWebhookFranchie(i18n);
			case 'compte_verifie':
				return $author$project$I18n$Cles$compteDEnvoiFaitCompteVerifie(i18n);
			case 'verification_echouee':
				return A2(
					$author$project$I18n$Cles$compteDEnvoiFaitVerificationEchouee,
					i18n,
					{cX: motif});
			case 'email_de_test_envoye':
				return $author$project$I18n$Cles$compteDEnvoiFaitEmailDeTestEnvoye(i18n);
			case 'email_de_test_echoue':
				return A2(
					$author$project$I18n$Cles$compteDEnvoiFaitEmailDeTestEchoue,
					i18n,
					{cX: motif});
			case 'email_de_test_recu':
				return $author$project$I18n$Cles$compteDEnvoiFaitEmailDeTestRecu(i18n);
			case 'email_de_test_non_delivre':
				return $author$project$I18n$Cles$compteDEnvoiFaitEmailDeTestNonDelivre(i18n);
			case 'compte_remplace':
				return $author$project$I18n$Cles$compteDEnvoiFaitCompteRemplace(i18n);
			case 'remplacement_annule':
				return $author$project$I18n$Cles$compteDEnvoiFaitRemplacementAnnule(i18n);
			case 'compte_deconnecte':
				return $author$project$I18n$Cles$compteDEnvoiFaitCompteDeconnecte(i18n);
			default:
				return $author$project$I18n$Cles$compteDEnvoiFaitAutre(i18n);
		}
	});
var $author$project$Components$Parametrage$CompteDEnvoi$View$historique = F2(
	function (i18n, lu) {
		var fait = function (lu_) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$Texte$Jour$horodateALHeure, i18n, lu_.Bf))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A4(
									$author$project$Components$Parametrage$Vocabulaire$faitDuCompteDEnvoi,
									i18n,
									lu_.zf,
									lu_.bB,
									$author$project$Components$Parametrage$CompteDEnvoi$View$domaineDe(lu.mr)))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								lu_.t2 ? $author$project$I18n$Cles$compteDEnvoiHistoriqueVerificationAutomatique(i18n) : A2(
									$elm$core$Maybe$withDefault,
									$author$project$I18n$Cles$compteDEnvoiHistoriqueAuteurInconnu(i18n),
									lu_.ET))
							]))
					]));
		};
		return $elm$core$List$isEmpty(lu.m6) ? _List_Nil : _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Page$View$section,
				_List_Nil,
				{
					fw: _List_Nil,
					fZ: _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$table,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$thead,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$tr,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	$author$project$I18n$Cles$compteDEnvoiHistoriqueDate(i18n))
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	$author$project$I18n$Cles$compteDEnvoiHistoriqueEvenement(i18n))
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	$author$project$I18n$Cles$compteDEnvoiHistoriquePar(i18n))
																]))
														]))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$tbody,
											_List_Nil,
											A2($elm$core$List$map, fait, lu.m6))
										]))
								]))
						]),
					Dj: 'historique',
					h6: $author$project$I18n$Cles$compteDEnvoiHistoriqueTitre(i18n)
				})
			]);
	});
var $author$project$I18n$Cles$compteDEnvoiNouveauCompteTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.nouveau-compte.titre', _List_Nil, 'Nouveau compte · Brevo');
};
var $author$project$I18n$Cles$compteDEnvoiNouveauCompteNote = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.nouveau-compte.note',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fin',
					$author$project$I18n$Traductions$Chaine(p.mI))
				]),
			'Le compte actuel (clé •••• ' + (p.mI + ') reste le seul actif jusqu\'à la vérification du nouveau.'));
	});
var $author$project$Components$Parametrage$CompteDEnvoi$View$nouveauCompteEnVerification = F4(
	function (i18n, model, actif, nouveau) {
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_Nil,
			{
				fw: A2($author$project$Components$Parametrage$CompteDEnvoi$View$dansLeFixed, nouveau.gt, i18n) ? _List_Nil : A2($author$project$Components$Parametrage$CompteDEnvoi$View$verifier, i18n, model),
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$dl,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('valeurs')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Components$Parametrage$CompteDEnvoi$View$ligne,
								'etat',
								$author$project$I18n$Cles$compteDEnvoiConnexionEtat(i18n),
								A2($author$project$Components$Parametrage$CompteDEnvoi$View$tagDeLEtat, i18n, nouveau.gt)),
								A3(
								$author$project$Components$Parametrage$CompteDEnvoi$View$ligne,
								'cle',
								$author$project$I18n$Cles$compteDEnvoiConnexionCle(i18n),
								$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$I18n$Cles$compteDEnvoiConnexionCleGardee(i18n),
										A2(
											$elm$core$Maybe$map,
											function (fin) {
												return A2(
													$author$project$I18n$Cles$compteDEnvoiConnexionCleMasquee,
													i18n,
													{mI: fin});
											},
											nouveau.mJ)))),
								A3(
								$author$project$Components$Parametrage$CompteDEnvoi$View$ligne,
								'expediteur',
								$author$project$I18n$Cles$compteDEnvoiExpediteurTitre(i18n),
								$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$compteDEnvoiExpediteurApercu,
										i18n,
										{
											aa: A2($elm$core$Maybe$withDefault, '', nouveau.mr),
											Dj: A2($elm$core$Maybe$withDefault, '', nouveau.ov)
										})))
							])),
						function () {
						var _v0 = nouveau.gt;
						if (_v0.$ === 3) {
							var motif = _v0.a;
							return A5(
								$author$project$Components$Parametrage$CompteDEnvoi$View$enErreur,
								i18n,
								model,
								'compte-d-envoi-nouveau',
								motif,
								A2($elm$core$Maybe$withDefault, '', nouveau.iE));
						} else {
							return $rtfeldman$elm_css$Html$Styled$text('');
						}
					}(),
						A3(
						$author$project$Components$Parametrage$CompteDEnvoi$View$etapes,
						i18n,
						{
							aa: A2($elm$core$Maybe$withDefault, '', nouveau.iE),
							cC: $author$project$Components$Parametrage$CompteDEnvoi$View$domaineDe(nouveau.mr)
						},
						nouveau.yL),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$compteDEnvoiNouveauCompteNote,
									i18n,
									{
										mI: A2($elm$core$Maybe$withDefault, '', actif.mJ)
									}))
							]))
					]),
				Dj: 'nouveau-compte',
				h6: $author$project$I18n$Cles$compteDEnvoiNouveauCompteTitre(i18n)
			});
	});
var $author$project$Components$Parametrage$CompteDEnvoi$View$nouveauCompte = F4(
	function (i18n, model, actif, nouveau) {
		return _Utils_eq(
			nouveau.gt,
			$author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$EnErreur($author$project$Components$Parametrage$CompteDEnvoi$View$ipRefusee)) ? A2(
			$author$project$Components$Shared$Page$View$section,
			_List_Nil,
			{
				fw: _List_fromArray(
					[
						A2($author$project$Components$Parametrage$CompteDEnvoi$View$tagDeLEtat, i18n, nouveau.gt)
					]),
				fZ: _List_fromArray(
					[
						A3(
						$author$project$Components$Parametrage$CompteDEnvoi$View$resume,
						i18n,
						model,
						{yL: nouveau.yL, gt: nouveau.gt, mr: nouveau.mr, mJ: nouveau.mJ, g_: false})
					]),
				Dj: 'nouveau-compte',
				h6: $author$project$I18n$Cles$compteDEnvoiNouveauCompteTitre(i18n)
			}) : A4($author$project$Components$Parametrage$CompteDEnvoi$View$nouveauCompteEnVerification, i18n, model, actif, nouveau);
	});
var $author$project$Components$Parametrage$CompteDEnvoi$View$compte = F3(
	function (i18n, model, lu) {
		return _Utils_ap(
			_Utils_eq(lu.gt, $author$project$Components$Parametrage$CompteDEnvoi$API$QueryAPIModel$NonConfigure) ? _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Page$View$section,
					_List_Nil,
					{
						fw: _List_Nil,
						fZ: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('aucun')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$compteDEnvoiAucunTexte(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A4($author$project$Components$Parametrage$CompteDEnvoi$View$espace, model, $author$project$I18n$Cles$compteDEnvoiAucunDetail, $author$project$I18n$Cles$compteDEnvoiAucunDetailSansEspace, i18n))
									]))
							]),
						Dj: 'aucun-compte',
						h6: $author$project$I18n$Cles$compteDEnvoiAucunTitre(i18n)
					})
				]) : _Utils_ap(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							A3($author$project$Components$Parametrage$CompteDEnvoi$View$nouveauCompte, i18n, model, lu),
							$elm$core$List$singleton),
						lu.HA)),
				_List_fromArray(
					[
						A3($author$project$Components$Parametrage$CompteDEnvoi$View$connexion, i18n, model, lu),
						A3($author$project$Components$Parametrage$CompteDEnvoi$View$expediteur, i18n, model, lu)
					])),
			A2($author$project$Components$Parametrage$CompteDEnvoi$View$historique, i18n, lu));
	});
var $author$project$I18n$Cles$compteDEnvoiDescription = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.description',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.yz)))
				]),
			'Le compte par lequel partent tous les emails ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.yz);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.yz);
					default:
						return 'de ' + $elm$core$String$trim(p.yz);
				}
			}() + ' : portails, pipes, notifications, campagnes et séquences.'));
	});
var $author$project$I18n$Cles$compteDEnvoiDescriptionSansEspace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.description.sans-espace', _List_Nil, 'Le compte par lequel partent tous les emails de l\'espace : portails, pipes, notifications, campagnes et séquences.');
};
var $author$project$I18n$Cles$compteDEnvoiEchecDeLecture = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.echec-de-lecture', _List_Nil, 'Le compte d\'envoi n\'a pas pu être lu.');
};
var $author$project$I18n$Cles$compteDEnvoiFil = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.fil', _List_Nil, 'Envoi des emails');
};
var $author$project$I18n$Cles$compteDEnvoiTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.titre', _List_Nil, 'Envoi des emails');
};
var $author$project$Components$Parametrage$CompteDEnvoi$Update$AnnulationConfirmee = {$: 18};
var $author$project$I18n$Cles$compteDEnvoiAnnulationAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.annulation.action', _List_Nil, 'Annuler le remplacement');
};
var $author$project$I18n$Cles$compteDEnvoiAnnulationTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.annulation.texte', _List_Nil, 'Le nouveau compte est abandonné et sa clé oubliée. Le compte actuel reste le seul actif.');
};
var $author$project$I18n$Cles$compteDEnvoiAnnulationTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.annulation.titre', _List_Nil, 'Annuler le remplacement ?');
};
var $author$project$Components$Parametrage$CompteDEnvoi$View$confirmationDAnnulation = F2(
	function (i18n, model) {
		var renoncer = $author$project$Components$Parametrage$CompteDEnvoi$Update$DuDrawerDAnnulation($author$project$Components$Shared$Drawer$Update$Fermer);
		var ouverte = $author$project$Components$Shared$Drawer$Model$estOuvert(model.k$);
		var ids = $author$project$Components$Parametrage$CompteDEnvoi$Update$idsDeLAnnulation;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('opened', ouverte)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('overlay'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(renoncer)
						]),
					_List_Nil),
					A2(
					$author$project$Components$Shared$Confirmation$View$view,
					i18n,
					{
						vl: A2(
							$author$project$Components$Shared$Confirmation$Clavier$clavier,
							ids,
							A2($elm$core$Basics$composeR, $author$project$Components$Shared$Drawer$Update$FocusDemande, $author$project$Components$Parametrage$CompteDEnvoi$Update$DuDrawerDAnnulation)),
						j7: {
							Aq: ids.j7,
							Bl: $author$project$I18n$Cles$compteDEnvoiAnnulationAction(i18n),
							C$: $author$project$Components$Parametrage$CompteDEnvoi$Update$AnnulationConfirmee
						},
						Aq: ids.GN,
						As: ids.Cs,
						At: ids.h6,
						Cs: $author$project$I18n$Cles$compteDEnvoiAnnulationTexte(i18n),
						Et: ouverte,
						HG: {
							Aq: ids.to,
							Bl: $author$project$I18n$Cles$drawerAnnuler(i18n),
							C$: renoncer
						},
						h6: $author$project$I18n$Cles$compteDEnvoiAnnulationTitre(i18n),
						sl: 0
					})
				]));
	});
var $author$project$Components$Parametrage$CompteDEnvoi$Update$DeconnexionConfirmee = {$: 16};
var $author$project$I18n$Cles$compteDEnvoiDeconnexionAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.deconnexion.action', _List_Nil, 'Déconnecter');
};
var $author$project$I18n$Cles$compteDEnvoiDeconnexionCle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.deconnexion.cle', _List_Nil, 'La clé d\'API est oubliée.');
};
var $author$project$I18n$Cles$compteDEnvoiDeconnexionTexte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.deconnexion.texte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.yz)))
				]),
			'Plus aucun email ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.yz);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.yz);
					default:
						return 'de ' + $elm$core$String$trim(p.yz);
				}
			}() + ' ne partira : codes de connexion des portails, communications des pipes, notifications, campagnes et séquences.'));
	});
var $author$project$I18n$Cles$compteDEnvoiDeconnexionTexteSansEspace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.deconnexion.texte.sans-espace', _List_Nil, 'Plus aucun email de l\'espace ne partira : codes de connexion des portails, communications des pipes, notifications, campagnes et séquences.');
};
var $author$project$I18n$Cles$compteDEnvoiDeconnexionTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.deconnexion.titre', _List_Nil, 'Déconnecter le compte d\'envoi ?');
};
var $author$project$Components$Parametrage$CompteDEnvoi$View$confirmationDeDeconnexion = F2(
	function (i18n, model) {
		var renoncer = $author$project$Components$Parametrage$CompteDEnvoi$Update$DuDrawerDeDeconnexion($author$project$Components$Shared$Drawer$Update$Fermer);
		var ouverte = $author$project$Components$Shared$Drawer$Model$estOuvert(model.k8);
		var ids = $author$project$Components$Parametrage$CompteDEnvoi$Update$idsDeLaDeconnexion;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('opened', ouverte)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('overlay'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(renoncer)
						]),
					_List_Nil),
					A2(
					$author$project$Components$Shared$Confirmation$View$view,
					i18n,
					{
						vl: A2(
							$author$project$Components$Shared$Confirmation$Clavier$clavier,
							ids,
							A2($elm$core$Basics$composeR, $author$project$Components$Shared$Drawer$Update$FocusDemande, $author$project$Components$Parametrage$CompteDEnvoi$Update$DuDrawerDeDeconnexion)),
						j7: {
							Aq: ids.j7,
							Bl: $author$project$I18n$Cles$compteDEnvoiDeconnexionAction(i18n),
							C$: $author$project$Components$Parametrage$CompteDEnvoi$Update$DeconnexionConfirmee
						},
						Aq: ids.GN,
						As: ids.Cs,
						At: ids.h6,
						Cs: A4($author$project$Components$Parametrage$CompteDEnvoi$View$espace, model, $author$project$I18n$Cles$compteDEnvoiDeconnexionTexte, $author$project$I18n$Cles$compteDEnvoiDeconnexionTexteSansEspace, i18n) + (' ' + $author$project$I18n$Cles$compteDEnvoiDeconnexionCle(i18n)),
						Et: ouverte,
						HG: {
							Aq: ids.to,
							Bl: $author$project$I18n$Cles$drawerAnnuler(i18n),
							C$: renoncer
						},
						h6: $author$project$I18n$Cles$compteDEnvoiDeconnexionTitre(i18n),
						sl: 0
					})
				]));
	});
var $author$project$Components$Parametrage$CompteDEnvoi$Update$CleSaisie = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Parametrage$CompteDEnvoi$Update$ConnexionEnvoyee = {$: 13};
var $author$project$Components$Parametrage$CompteDEnvoi$Update$ExpediteurSaisi = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Parametrage$CompteDEnvoi$Update$NomAfficheSaisi = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Parametrage$CompteDEnvoi$Update$ReponseASaisie = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Parametrage$CompteDEnvoi$Model$champEnErreur = F2(
	function (champ, model) {
		return A2(
			$elm$core$List$any,
			$elm$core$String$contains(champ),
			model.fL);
	});
var $author$project$I18n$Cles$compteDEnvoiDrawerActionConnecter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.drawer.action-connecter', _List_Nil, 'Connecter et vérifier');
};
var $author$project$I18n$Cles$compteDEnvoiDrawerActionModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.drawer.action-modifier', _List_Nil, 'Modifier et vérifier');
};
var $author$project$I18n$Cles$compteDEnvoiDrawerActionRemplacer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.drawer.action-remplacer', _List_Nil, 'Remplacer et vérifier');
};
var $author$project$I18n$Cles$compteDEnvoiDrawerAdresseInvalide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.drawer.adresse-invalide', _List_Nil, 'Cette adresse n\'est pas une adresse email valide.');
};
var $author$project$I18n$Cles$compteDEnvoiDrawerApercu = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.drawer.apercu',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'adresse',
					$author$project$I18n$Traductions$Chaine(p.aa))
				]),
			'Les destinataires voient : ' + (p.Dj + (' <' + (p.aa + '>'))));
	});
var $author$project$I18n$Cles$compteDEnvoiDrawerBrevo = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.drawer.brevo', _List_Nil, 'Brevo');
};
var $author$project$I18n$Cles$compteDEnvoiDrawerBrevoDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.drawer.brevo-detail', _List_Nil, 'Connexion par clé d\'API. Suivi complet : délivrés, ouvertures, clics, rebonds, désinscriptions.');
};
var $author$project$I18n$Cles$compteDEnvoiDrawerCle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.drawer.cle', _List_Nil, 'Clé d\'API');
};
var $author$project$I18n$Cles$compteDEnvoiDrawerCleDuNouveauCompte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.drawer.cle-du-nouveau-compte', _List_Nil, 'Clé d\'API du nouveau compte');
};
var $author$project$I18n$Cles$compteDEnvoiDrawerCleInvalide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.drawer.cle-invalide', _List_Nil, 'La clé d\'API n\'est pas acceptée.');
};
var $author$project$I18n$Cles$compteDEnvoiDrawerExpediteur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.drawer.expediteur', _List_Nil, 'Expéditeur');
};
var $author$project$I18n$Cles$compteDEnvoiDrawerModification = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.drawer.modification', _List_Nil, 'L\'expéditeur actuel reste en usage jusqu\'à la vérification du nouveau : le CRM relit le domaine chez Brevo et vous envoie un email de test. La clé d\'API ne change pas.');
};
var $author$project$I18n$Cles$compteDEnvoiDrawerNomInvalide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.drawer.nom-invalide', _List_Nil, 'Le nom de l\'expéditeur tient en 100 caractères au plus.');
};
var $author$project$I18n$Cles$compteDEnvoiDrawerNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.drawer.note', _List_Nil, 'À la connexion, le CRM vérifie la clé, l\'adresse d\'expédition et son domaine chez Brevo, inscrit le webhook de suivi et vous envoie un email de test.');
};
var $author$project$I18n$Cles$compteDEnvoiDrawerRemplacement = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'compte-d-envoi.drawer.remplacement',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.yz)))
				]),
			'Les emails ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.yz);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.yz);
					default:
						return 'de ' + $elm$core$String$trim(p.yz);
				}
			}() + ' partent par le compte actuel jusqu\'à ce que le nouveau compte soit vérifié ; il devient alors le seul compte actif et l\'ancien est déconnecté. L\'historique d\'envoi est gardé.'));
	});
var $author$project$I18n$Cles$compteDEnvoiDrawerRemplacementSansEspace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.drawer.remplacement.sans-espace', _List_Nil, 'Les emails de l\'espace partent par le compte actuel jusqu\'à ce que le nouveau compte soit vérifié ; il devient alors le seul compte actif et l\'ancien est déconnecté. L\'historique d\'envoi est gardé.');
};
var $author$project$I18n$Cles$compteDEnvoiDrawerRemplacementTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.drawer.remplacement-titre', _List_Nil, 'Rien ne s\'arrête pendant le remplacement.');
};
var $author$project$I18n$Cles$compteDEnvoiDrawerSousTitreRemplacer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.drawer.sous-titre-remplacer', _List_Nil, 'Le compte actuel reste le seul actif jusqu\'à la vérification du nouveau.');
};
var $author$project$I18n$Cles$compteDEnvoiDrawerTitreConnecter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.drawer.titre-connecter', _List_Nil, 'Connecter un compte d\'envoi');
};
var $author$project$I18n$Cles$compteDEnvoiDrawerTitreRemplacer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.drawer.titre-remplacer', _List_Nil, 'Remplacer le compte d\'envoi');
};
var $author$project$Components$Parametrage$CompteDEnvoi$View$refusDuDrawer = F2(
	function (ouvert, model) {
		return $author$project$Components$Shared$Drawer$Model$estOuvert(ouvert) ? A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Maybe$map, $elm$core$List$singleton, model.pZ)) : _List_Nil;
	});
var $author$project$Components$Parametrage$CompteDEnvoi$View$drawer = F2(
	function (i18n, model) {
		var champ = F5(
			function (identifiant, libelle, obligatoire, nomDuChamp, erreur) {
				return {
					go: A2($author$project$Components$Parametrage$CompteDEnvoi$Model$champEnErreur, nomDuChamp, model) ? $elm$core$Maybe$Just(erreur) : $elm$core$Maybe$Nothing,
					Aq: identifiant,
					Bl: libelle,
					he: obligatoire
				};
			});
		var cle = A5(
			champ,
			'compte-d-envoi-cle',
			(model.n9 === 1) ? $author$project$I18n$Cles$compteDEnvoiDrawerCleDuNouveauCompte(i18n) : $author$project$I18n$Cles$compteDEnvoiDrawerCle(i18n),
			true,
			'cleApi',
			$author$project$I18n$Cles$compteDEnvoiDrawerCleInvalide(i18n));
		var adresse = F6(
			function (identifiant, libelle, obligatoire, nomDuChamp, valeur, msg) {
				var fourni = A5(
					champ,
					identifiant,
					libelle,
					obligatoire,
					nomDuChamp,
					$author$project$I18n$Cles$compteDEnvoiDrawerAdresseInvalide(i18n));
				return A2(
					$author$project$Components$Shared$Champ$View$compose,
					fourni,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$input,
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('email'),
								A2(
									$elm$core$List$cons,
									$rtfeldman$elm_css$Html$Styled$Attributes$value(valeur),
									A2(
										$elm$core$List$cons,
										$rtfeldman$elm_css$Html$Styled$Events$onInput(msg),
										$author$project$Components$Shared$Champ$View$attributs(fourni)))),
							_List_Nil)
						]));
			});
		var _v0 = function () {
			var _v1 = model.n9;
			switch (_v1) {
				case 0:
					return _Utils_Tuple3(
						$author$project$I18n$Cles$compteDEnvoiDrawerTitreConnecter(i18n),
						$author$project$I18n$Cles$compteDEnvoiDrawerActionConnecter(i18n),
						!_Utils_eq(
							$author$project$Components$Parametrage$CompteDEnvoi$Model$connexion(model.hP),
							$elm$core$Maybe$Nothing));
				case 1:
					return _Utils_Tuple3(
						$author$project$I18n$Cles$compteDEnvoiDrawerTitreRemplacer(i18n),
						$author$project$I18n$Cles$compteDEnvoiDrawerActionRemplacer(i18n),
						!_Utils_eq(
							$author$project$Components$Parametrage$CompteDEnvoi$Model$connexion(model.hP),
							$elm$core$Maybe$Nothing));
				default:
					return _Utils_Tuple3(
						$author$project$I18n$Cles$compteDEnvoiModifierLExpediteur(i18n),
						$author$project$I18n$Cles$compteDEnvoiDrawerActionModifier(i18n),
						!_Utils_eq(
							$author$project$Components$Parametrage$CompteDEnvoi$Model$expediteurSaisi(model.hP),
							$elm$core$Maybe$Nothing));
			}
		}();
		var titre = _v0.a;
		var actionLibelle = _v0.b;
		var valide = _v0.c;
		return A3(
			(model.n9 === 1) ? A2(
				$author$project$Components$Shared$Drawer$View$viewAvecSousTitre,
				i18n,
				$author$project$I18n$Cles$compteDEnvoiDrawerSousTitreRemplacer(i18n)) : $author$project$Components$Shared$Drawer$View$view(i18n),
			$author$project$Components$Parametrage$CompteDEnvoi$Update$DuDrawer,
			{
				fs: {
					sR: valide && (!$author$project$API$Envoi$enCours(model.l2)),
					Bl: actionLibelle,
					C$: $author$project$Components$Parametrage$CompteDEnvoi$Update$ConnexionEnvoyee
				},
				fZ: _List_fromArray(
					[
						function () {
						var _v2 = model.n9;
						switch (_v2) {
							case 1:
								return A2(
									$author$project$Components$Shared$Note$View$view,
									0,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$b,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$compteDEnvoiDrawerRemplacementTitre(i18n))
														]))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A4($author$project$Components$Parametrage$CompteDEnvoi$View$espace, model, $author$project$I18n$Cles$compteDEnvoiDrawerRemplacement, $author$project$I18n$Cles$compteDEnvoiDrawerRemplacementSansEspace, i18n))
												]))
										]));
							case 2:
								return A2(
									$author$project$Components$Shared$Note$View$view,
									0,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$compteDEnvoiDrawerModification(i18n))
										]));
							default:
								return $rtfeldman$elm_css$Html$Styled$text('');
						}
					}(),
						(model.n9 === 2) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('fournisseur')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$b,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$compteDEnvoiDrawerBrevo(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$compteDEnvoiDrawerBrevoDetail(i18n))
									]))
							])),
						(model.n9 === 2) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
						$author$project$Components$Shared$Champ$View$compose,
						cle,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$input,
								A2(
									$elm$core$List$cons,
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('password'),
									A2(
										$elm$core$List$cons,
										A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'autocomplete', 'new-password'),
										A2(
											$elm$core$List$cons,
											$rtfeldman$elm_css$Html$Styled$Attributes$value(model.hP.dy),
											A2(
												$elm$core$List$cons,
												$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Parametrage$CompteDEnvoi$Update$CleSaisie),
												$author$project$Components$Shared$Champ$View$attributs(cle))))),
								_List_Nil)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$h3,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$compteDEnvoiDrawerExpediteur(i18n))
							])),
						A2(
						$author$project$Components$Shared$Champ$View$texte,
						A5(
							champ,
							'compte-d-envoi-nom',
							$author$project$I18n$Cles$compteDEnvoiExpediteurNom(i18n),
							true,
							'nomAffiche',
							$author$project$I18n$Cles$compteDEnvoiDrawerNomInvalide(i18n)),
						{hg: $author$project$Components$Parametrage$CompteDEnvoi$Update$NomAfficheSaisi, fm: model.hP.ov}),
						A6(
						adresse,
						'compte-d-envoi-adresse',
						$author$project$I18n$Cles$compteDEnvoiExpediteurAdresse(i18n),
						true,
						'expediteur',
						model.hP.mr,
						$author$project$Components$Parametrage$CompteDEnvoi$Update$ExpediteurSaisi),
						A6(
						adresse,
						'compte-d-envoi-reponse',
						$author$project$I18n$Cles$compteDEnvoiExpediteurReponse(i18n),
						false,
						'reponseA',
						model.hP.qw,
						$author$project$Components$Parametrage$CompteDEnvoi$Update$ReponseASaisie),
						A2(
						$elm$core$List$any,
						A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$String$isEmpty),
						_List_fromArray(
							[model.hP.ov, model.hP.mr])) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$compteDEnvoiDrawerApercu,
									i18n,
									{
										aa: $elm$core$String$trim(model.hP.mr),
										Dj: $elm$core$String$trim(model.hP.ov)
									}))
							])),
						(!model.n9) ? A2(
						$author$project$Components$Shared$Note$View$view,
						0,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$compteDEnvoiDrawerNote(i18n))
							])) : $rtfeldman$elm_css$Html$Styled$text(''),
						A2(
						$author$project$Components$Shared$Messages$View$view,
						i18n,
						A2($author$project$Components$Parametrage$CompteDEnvoi$View$refusDuDrawer, model.kX, model))
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: titre
			},
			model.kX);
	});
var $author$project$I18n$Cles$compteDEnvoiLectureSeule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.lecture-seule', _List_Nil, 'Lecture seule');
};
var $author$project$I18n$Cles$compteDEnvoiRemplacementEnCours = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.remplacement-en-cours', _List_Nil, 'Remplacement en cours');
};
var $author$project$Components$Parametrage$CompteDEnvoi$View$etats = F2(
	function (i18n, model) {
		var _v0 = model.vW;
		if (!_v0.$) {
			var lu = _v0.a;
			return $elm$core$List$singleton(
				A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('etats')
						]),
					_List_fromArray(
						[
							A2($author$project$Components$Parametrage$CompteDEnvoi$View$tagDeLEtat, i18n, lu.gt),
							(!_Utils_eq(lu.HA, $elm$core$Maybe$Nothing)) ? A2(
							$author$project$Components$Shared$Tag$View$view,
							5,
							$author$project$I18n$Cles$compteDEnvoiRemplacementEnCours(i18n)) : $rtfeldman$elm_css$Html$Styled$text(''),
							$author$project$Components$Parametrage$CompteDEnvoi$View$lectureSeule(model) ? A2(
							$author$project$Components$Shared$Tag$View$view,
							3,
							$author$project$I18n$Cles$compteDEnvoiLectureSeule(i18n)) : $rtfeldman$elm_css$Html$Styled$text('')
						])));
		} else {
			return _List_Nil;
		}
	});
var $author$project$I18n$Cles$compteDEnvoiFournisseurBrevo = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.fournisseur.brevo', _List_Nil, 'Brevo');
};
var $author$project$I18n$Cles$compteDEnvoiFournisseurClics = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.fournisseur.clics', _List_Nil, 'Clics');
};
var $author$project$I18n$Cles$compteDEnvoiFournisseurDelivres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.fournisseur.delivres', _List_Nil, 'Délivrés');
};
var $author$project$I18n$Cles$compteDEnvoiFournisseurDesinscriptions = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.fournisseur.desinscriptions', _List_Nil, 'Désinscriptions par la page du CRM');
};
var $author$project$I18n$Cles$compteDEnvoiFournisseurEnvoyes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.fournisseur.envoyes', _List_Nil, 'Envoyés');
};
var $author$project$I18n$Cles$compteDEnvoiFournisseurEvenement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.fournisseur.evenement', _List_Nil, 'Événement');
};
var $author$project$I18n$Cles$compteDEnvoiFournisseurNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.fournisseur.note', _List_Nil, 'Les campagnes et les séquences n\'affichent que ce que le fournisseur remonte. Le CRM ne lui envoie que le message rendu : aucune liste ni donnée de contact n\'y est synchronisée. Les désinscriptions passent toujours par la page du CRM.');
};
var $author$project$I18n$Cles$compteDEnvoiFournisseurOui = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.fournisseur.oui', _List_Nil, 'Oui');
};
var $author$project$I18n$Cles$compteDEnvoiFournisseurOuvertures = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.fournisseur.ouvertures', _List_Nil, 'Ouvertures');
};
var $author$project$I18n$Cles$compteDEnvoiFournisseurRebonds = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.fournisseur.rebonds', _List_Nil, 'Rebonds');
};
var $author$project$I18n$Cles$compteDEnvoiFournisseurTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.fournisseur.titre', _List_Nil, 'Ce que remonte le fournisseur');
};
var $author$project$Components$Parametrage$CompteDEnvoi$View$fournisseur = function (i18n) {
	var evenement = function (libelle) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$th,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$scope('row')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$compteDEnvoiFournisseurOui(i18n))
						]))
				]));
	};
	return A2(
		$author$project$Components$Shared$Page$View$section,
		_List_Nil,
		{
			fw: _List_Nil,
			fZ: _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$table,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$thead,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$tr,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$compteDEnvoiFournisseurEvenement(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$compteDEnvoiFournisseurBrevo(i18n))
														]))
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$tbody,
									_List_Nil,
									A2(
										$elm$core$List$map,
										evenement,
										_List_fromArray(
											[
												$author$project$I18n$Cles$compteDEnvoiFournisseurEnvoyes(i18n),
												$author$project$I18n$Cles$compteDEnvoiFournisseurDelivres(i18n),
												$author$project$I18n$Cles$compteDEnvoiFournisseurOuvertures(i18n),
												$author$project$I18n$Cles$compteDEnvoiFournisseurClics(i18n),
												$author$project$I18n$Cles$compteDEnvoiFournisseurRebonds(i18n),
												$author$project$I18n$Cles$compteDEnvoiFournisseurDesinscriptions(i18n)
											])))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$compteDEnvoiFournisseurNote(i18n))
						]))
				]),
			Dj: 'fournisseur',
			h6: $author$project$I18n$Cles$compteDEnvoiFournisseurTitre(i18n)
		});
};
var $author$project$Components$Parametrage$CompteDEnvoi$Update$AnnulationDemandee = {$: 17};
var $author$project$Components$Parametrage$CompteDEnvoi$Update$DeconnexionDemandee = {$: 15};
var $author$project$I18n$Cles$compteDEnvoiAnnulerLeRemplacement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.annuler-le-remplacement', _List_Nil, 'Annuler le remplacement…');
};
var $author$project$I18n$Cles$compteDEnvoiConnecter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.connecter', _List_Nil, 'Connecter un compte d\'envoi');
};
var $author$project$I18n$Cles$compteDEnvoiDeconnecter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.deconnecter', _List_Nil, 'Déconnecter le compte…');
};
var $author$project$I18n$Cles$compteDEnvoiNouvelleCle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.nouvelle-cle', _List_Nil, 'Saisir une nouvelle clé');
};
var $author$project$I18n$Cles$compteDEnvoiRemplacer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compte-d-envoi.remplacer', _List_Nil, 'Remplacer le compte…');
};
var $author$project$Components$Parametrage$CompteDEnvoi$View$gestes = F2(
	function (i18n, model) {
		var emailDeTestPart = function () {
			var _v12 = A2($author$project$Components$Parametrage$CompteDEnvoi$Model$lienDe, $author$project$API$NavLinksDictionary$envoyerUnEmailDeTest, model);
			if (!_v12.$) {
				return _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						0,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('compte-d-envoi-email-de-test'),
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'loading',
										$author$project$API$Envoi$enCours(model.l2))
									])),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
								$author$project$API$Envoi$enCours(model.l2)),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$CompteDEnvoi$Update$EmailDeTestDemande)
							]),
						$author$project$I18n$Cles$compteDEnvoiEmailDeTest(i18n))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var deconnecter = function () {
			var _v11 = A2($author$project$Components$Parametrage$CompteDEnvoi$Model$lienDe, $author$project$API$NavLinksDictionary$deconnecter, model);
			if (!_v11.$) {
				return _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						3,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('compte-d-envoi-deconnecter-ouvrir'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$CompteDEnvoi$Update$DeconnexionDemandee)
							]),
						$author$project$I18n$Cles$compteDEnvoiDeconnecter(i18n))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var connecter = F3(
			function (variante, idDuBouton, libelle) {
				var _v10 = A2($author$project$Components$Parametrage$CompteDEnvoi$Model$lienDe, $author$project$API$NavLinksDictionary$connecterBrevo, model);
				if (!_v10.$) {
					return _List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							variante,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id(idDuBouton),
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$CompteDEnvoi$Update$ConnexionDemandee)
								]),
							libelle)
						]);
				} else {
					return _List_Nil;
				}
			});
		var nouvelleCle = function (motif) {
			return A3($author$project$Components$Parametrage$Vocabulaire$motifDuCompteDEnvoi, i18n, motif, '').oT ? A3(
				connecter,
				0,
				'compte-d-envoi-connecter-ouvrir',
				$author$project$I18n$Cles$compteDEnvoiNouvelleCle(i18n)) : A3($author$project$Components$Parametrage$CompteDEnvoi$View$verifierEn, 0, i18n, model);
		};
		var annuler = function () {
			var _v9 = A2($author$project$Components$Parametrage$CompteDEnvoi$Model$lienDe, $author$project$API$NavLinksDictionary$annulerLeRemplacement, model);
			if (!_v9.$) {
				return _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('compte-d-envoi-annuler-le-remplacement-ouvrir'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$CompteDEnvoi$Update$AnnulationDemandee)
							]),
						$author$project$I18n$Cles$compteDEnvoiAnnulerLeRemplacement(i18n))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var _v0 = model.vW;
		if (_v0.$ === 1) {
			return _List_Nil;
		} else {
			var lu = _v0.a;
			var _v1 = _Utils_Tuple2(lu.gt, lu.HA);
			_v1$0:
			while (true) {
				if (!_v1.b.$) {
					if (!_v1.a.$) {
						break _v1$0;
					} else {
						var nouveau = _v1.b.a;
						return _Utils_ap(
							annuler,
							function () {
								var _v3 = nouveau.gt;
								if (_v3.$ === 3) {
									var motif = _v3.a;
									return nouvelleCle(motif);
								} else {
									return _List_Nil;
								}
							}());
					}
				} else {
					switch (_v1.a.$) {
						case 0:
							break _v1$0;
						case 3:
							var motif = _v1.a.a;
							var _v4 = _v1.b;
							return _Utils_ap(
								deconnecter,
								nouvelleCle(motif));
						case 2:
							var _v5 = _v1.a;
							var _v6 = _v1.b;
							return _Utils_ap(
								deconnecter,
								_Utils_ap(
									A3(
										connecter,
										1,
										'compte-d-envoi-remplacer-ouvrir',
										$author$project$I18n$Cles$compteDEnvoiRemplacer(i18n)),
									emailDeTestPart));
						default:
							var _v7 = _v1.a;
							var _v8 = _v1.b;
							return deconnecter;
					}
				}
			}
			var _v2 = _v1.a;
			return A3(
				connecter,
				0,
				'compte-d-envoi-connecter-ouvrir',
				$author$project$I18n$Cles$compteDEnvoiConnecter(i18n));
		}
	});
var $author$project$Components$Parametrage$CompteDEnvoi$View$refusSurLaPage = function (model) {
	return $author$project$Components$Parametrage$CompteDEnvoi$View$dialogueOuvert(model) ? _List_Nil : A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2($elm$core$Maybe$map, $elm$core$List$singleton, model.pZ));
};
var $author$project$Components$Parametrage$CompteDEnvoi$View$view = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'parametrage-compte-d-envoi',
			{
				ut: model.qa ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('acces-refuse')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Note$View$view,
										1,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$coquilleAccesRefuse(i18n))
													]))
											]))
									]))
							]))
					]) : A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('bandeaux')
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$Components$Shared$Messages$View$view,
								i18n,
								_Utils_ap(
									messages,
									$author$project$Components$Parametrage$CompteDEnvoi$View$refusSurLaPage(model))),
							A2(
								$elm$core$List$cons,
								model.gd ? A2(
									$author$project$Components$Shared$Note$View$view,
									2,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$compteDEnvoiEchecDeLecture(i18n))
										])) : $rtfeldman$elm_css$Html$Styled$text(''),
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										A2($author$project$Components$Parametrage$CompteDEnvoi$View$bandeaux, i18n, model),
										model.vW))))),
					$author$project$Components$Shared$Page$View$fiche(
						{
							tQ: A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (_v0) {
										return _List_fromArray(
											[
												$author$project$Components$Parametrage$CompteDEnvoi$View$fournisseur(i18n)
											]);
									},
									model.vW)),
							B2: A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A2($author$project$Components$Parametrage$CompteDEnvoi$View$compte, i18n, model),
									model.vW))
						})),
				xy: _List_fromArray(
					[
						A2($author$project$Components$Parametrage$CompteDEnvoi$View$drawer, i18n, model),
						A2($author$project$Components$Parametrage$CompteDEnvoi$View$confirmationDeDeconnexion, i18n, model),
						A2($author$project$Components$Parametrage$CompteDEnvoi$View$confirmationDAnnulation, i18n, model)
					]),
				zM: A2($author$project$Components$Parametrage$CompteDEnvoi$View$gestes, i18n, model),
				AK: $author$project$Components$Parametrage$CompteDEnvoi$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _Utils_ap(
							A2($author$project$Components$Parametrage$CompteDEnvoi$View$etats, i18n, model),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A4($author$project$Components$Parametrage$CompteDEnvoi$View$espace, model, $author$project$I18n$Cles$compteDEnvoiDescription, $author$project$I18n$Cles$compteDEnvoiDescriptionSansEspace, i18n))
										]))
								])),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adresseTypesDePartiesPrenantes,
								Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
							},
								{
								aa: $author$project$Routes$Route$adresseDuCompteDEnvoi,
								Dj: $author$project$I18n$Cles$compteDEnvoiFil(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$compteDEnvoiTitre(i18n)
					})
			});
	});
var $author$project$Components$Parametrage$CompteurDeCode$Update$ReglageDemande = {$: 5};
var $author$project$I18n$Cles$compteurCarte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.carte', _List_Nil, 'Compteur du code de référence');
};
var $author$project$I18n$Cles$compteurChiffres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.chiffres', _List_Nil, 'Chiffres');
};
var $author$project$I18n$Cles$compteurDernier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.dernier', _List_Nil, 'Dernier numéro attribué');
};
var $author$project$I18n$Cles$compteurPortee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.portee', _List_Nil, 'Portée');
};
var $author$project$I18n$Cles$compteurPremier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.premier', _List_Nil, 'Premier numéro');
};
var $author$project$I18n$Cles$compteurRegler = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.regler', _List_Nil, 'Régler le compteur');
};
var $author$project$I18n$Cles$compteurDernierAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.dernier-aucun', _List_Nil, 'Aucun numéro attribué pour l\'instant');
};
var $author$project$Components$Parametrage$CompteurDeCode$View$dernier = F2(
	function (i18n, reglage) {
		var _v0 = reglage.xg;
		if (!_v0.$) {
			var attribue = _v0.a;
			return $rtfeldman$elm_css$Html$Styled$text(
				attribue.F$ + (' → ' + A3(
					$elm$core$String$padLeft,
					reglage.vb,
					'0',
					$elm$core$String$fromInt(attribue.DX))));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text(
				$author$project$I18n$Cles$compteurDernierAucun(i18n));
		}
	});
var $author$project$I18n$Cles$compteurPorteeParPrefixe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.portee-par-prefixe', _List_Nil, 'Par préfixe');
};
var $author$project$I18n$Cles$compteurPorteeParType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.portee-par-type', _List_Nil, 'Par type');
};
var $author$project$I18n$Cles$compteurPorteeToutLeCatalogue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.portee-tout-le-catalogue', _List_Nil, 'Tout le catalogue');
};
var $author$project$Components$Parametrage$Vocabulaire$porteeDuCompteur = F2(
	function (i18n, portee) {
		switch (portee) {
			case 'par-type':
				return $author$project$I18n$Cles$compteurPorteeParType(i18n);
			case 'tout-le-catalogue':
				return $author$project$I18n$Cles$compteurPorteeToutLeCatalogue(i18n);
			default:
				return $author$project$I18n$Cles$compteurPorteeParPrefixe(i18n);
		}
	});
var $author$project$Components$Parametrage$CompteurDeCode$View$carte = F3(
	function (i18n, model, reglage) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('card'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('compteur')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$compteurCarte(i18n))
								])),
							function () {
							var _v0 = $author$project$Components$Parametrage$CompteurDeCode$Model$lienDuReglage(model);
							if (!_v0.$) {
								return A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id('compteur-regler'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$CompteurDeCode$Update$ReglageDemande)
										]),
									$author$project$I18n$Cles$compteurRegler(i18n));
							} else {
								return $rtfeldman$elm_css$Html$Styled$text('');
							}
						}()
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$dl,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('reglage')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('portee')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$dt,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$compteurPortee(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$dd,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$Components$Parametrage$Vocabulaire$porteeDuCompteur, i18n, reglage.F$))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('chiffres')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$dt,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$compteurChiffres(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$dd,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$elm$core$String$fromInt(reglage.vb))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('premier')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$dt,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$compteurPremier(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$dd,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$elm$core$String$fromInt(reglage.Ge))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('dernier')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$dt,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$compteurDernier(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$dd,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$Components$Parametrage$CompteurDeCode$View$dernier, i18n, reglage)
										]))
								]))
						]))
				]));
	});
var $author$project$I18n$Cles$compteurDescription = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.description', _List_Nil, 'Un seul réglage pour tous les types : il numérote les codes de référence proposés par la règle de chaque type.');
};
var $author$project$I18n$Cles$compteurEchecDeLecture = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.echec-de-lecture', _List_Nil, 'Le réglage du compteur n\'a pas pu être lu.');
};
var $author$project$I18n$Cles$compteurFil = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.fil', _List_Nil, 'Compteur de code');
};
var $author$project$I18n$Cles$compteurTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.titre', _List_Nil, 'Compteur du code de référence');
};
var $author$project$Components$Parametrage$CompteurDeCode$Update$ChiffresSaisis = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Parametrage$CompteurDeCode$Update$PremierSaisi = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Parametrage$CompteurDeCode$Update$ReglageEnvoye = {$: 9};
var $author$project$Components$Parametrage$CompteurDeCode$Update$PorteeChoisie = function (a) {
	return {$: 6, a: a};
};
var $author$project$I18n$Cles$compteurParDefaut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.par-defaut', _List_Nil, 'par défaut');
};
var $author$project$Components$Parametrage$CompteurDeCode$View$choix = F6(
	function (i18n, model, portee, libelle, detail, parDefaut) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('option'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'choisie',
							_Utils_eq(model.F$, portee))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
							$rtfeldman$elm_css$Html$Styled$Attributes$name('compteur-portee'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id('compteur-portee-' + portee),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(
							_Utils_eq(model.F$, portee)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Parametrage$CompteurDeCode$Update$PorteeChoisie(portee))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(libelle)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('detail')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(detail)
								]))
						])),
					parDefaut ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('tag'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('defaut')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$compteurParDefaut(i18n))
						])) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$I18n$Cles$compteurDrawerAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.drawer-action', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$compteurDrawerChiffres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.drawer-chiffres', _List_Nil, 'Nombre de chiffres');
};
var $author$project$I18n$Cles$compteurDrawerNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.drawer-note', _List_Nil, 'Dès qu\'un numéro est attribué, la portée et le premier numéro ne changent plus. Le nombre de chiffres vaut pour les codes à venir.');
};
var $author$project$I18n$Cles$compteurDrawerPortee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.drawer-portee', _List_Nil, 'Portée du compteur');
};
var $author$project$I18n$Cles$compteurDrawerPremier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.drawer-premier', _List_Nil, 'Premier numéro');
};
var $author$project$I18n$Cles$compteurDrawerSousTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.drawer-sous-titre', _List_Nil, 'Réglage du client · Catalogue');
};
var $author$project$I18n$Cles$compteurDrawerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.drawer-titre', _List_Nil, 'Régler le compteur');
};
var $author$project$I18n$Cles$compteurPorteeParPrefixeDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.portee-par-prefixe-detail', _List_Nil, 'un compteur par début de code (MA-TC4.IN. → 0001, 0002…)');
};
var $author$project$I18n$Cles$compteurPorteeParTypeDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.portee-par-type-detail', _List_Nil, 'un compteur par type de produit');
};
var $author$project$I18n$Cles$compteurPorteeToutLeCatalogueDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.portee-tout-le-catalogue-detail', _List_Nil, 'un seul compteur');
};
var $author$project$Components$Parametrage$CompteurDeCode$Model$pret = function (model) {
	return !_Utils_eq(
		$author$project$Components$Parametrage$CompteurDeCode$Model$commande(model),
		$elm$core$Maybe$Nothing);
};
var $author$project$I18n$Cles$compteurRefusAcces = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.refus-acces', _List_Nil, 'Vous n\'avez pas le droit de régler le compteur.');
};
var $author$project$I18n$Cles$compteurRefusAutre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.refus-autre', _List_Nil, 'Le réglage n\'a pas pu être enregistré.');
};
var $author$project$I18n$Cles$compteurRefusFige = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.refus-fige', _List_Nil, 'Réglage refusé : un numéro a déjà été attribué, la portée et le premier numéro ne changent plus. Le nombre de chiffres reste réglable.');
};
var $author$project$Components$Parametrage$CompteurDeCode$View$refus = F2(
	function (i18n, model) {
		var _v0 = model.pZ;
		if (!_v0.$) {
			switch (_v0.a) {
				case 0:
					var _v1 = _v0.a;
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$compteurRefusFige(i18n))
							]));
				case 1:
					var _v2 = _v0.a;
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$compteurRefusAcces(i18n))
							]));
				default:
					var _v3 = _v0.a;
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$compteurRefusAutre(i18n))
							]));
			}
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$compteurResumeParPrefixe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.resume-par-prefixe', _List_Nil, '1 compteur par préfixe');
};
var $author$project$I18n$Cles$compteurResumeParType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.resume-par-type', _List_Nil, '1 compteur par type');
};
var $author$project$I18n$Cles$compteurResumeToutLeCatalogue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'compteur.resume-tout-le-catalogue', _List_Nil, '1 seul compteur');
};
var $author$project$Components$Parametrage$Vocabulaire$resumeDeLaPortee = F2(
	function (i18n, portee) {
		switch (portee) {
			case 'par-type':
				return $author$project$I18n$Cles$compteurResumeParType(i18n);
			case 'tout-le-catalogue':
				return $author$project$I18n$Cles$compteurResumeToutLeCatalogue(i18n);
			default:
				return $author$project$I18n$Cles$compteurResumeParPrefixe(i18n);
		}
	});
var $author$project$Components$Parametrage$CompteurDeCode$View$drawer = F2(
	function (i18n, model) {
		return A6(
			$author$project$Components$Shared$Drawer$View$viewAvecSousTitreEtNote,
			i18n,
			$elm$core$Maybe$Just(
				$author$project$I18n$Cles$compteurDrawerSousTitre(i18n)),
			$elm$core$Maybe$Just(
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.F$;
							},
							$author$project$Components$Parametrage$Vocabulaire$resumeDeLaPortee(i18n)),
						model.eO))),
			$author$project$Components$Parametrage$CompteurDeCode$Update$DuDrawer,
			{
				fs: {
					sR: $author$project$Components$Parametrage$CompteurDeCode$Model$pret(model) && (!$author$project$API$Envoi$enCours(model.l2)),
					Bl: $author$project$I18n$Cles$compteurDrawerAction(i18n),
					C$: $author$project$Components$Parametrage$CompteurDeCode$Update$ReglageEnvoye
				},
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$fieldset,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('portee')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$legend,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$compteurDrawerPortee(i18n))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('options')
									]),
								_List_fromArray(
									[
										A6(
										$author$project$Components$Parametrage$CompteurDeCode$View$choix,
										i18n,
										model,
										'par-prefixe',
										$author$project$I18n$Cles$compteurPorteeParPrefixe(i18n),
										$author$project$I18n$Cles$compteurPorteeParPrefixeDetail(i18n),
										true),
										A6(
										$author$project$Components$Parametrage$CompteurDeCode$View$choix,
										i18n,
										model,
										'par-type',
										$author$project$I18n$Cles$compteurPorteeParType(i18n),
										$author$project$I18n$Cles$compteurPorteeParTypeDetail(i18n),
										false),
										A6(
										$author$project$Components$Parametrage$CompteurDeCode$View$choix,
										i18n,
										model,
										'tout-le-catalogue',
										$author$project$I18n$Cles$compteurPorteeToutLeCatalogue(i18n),
										$author$project$I18n$Cles$compteurPorteeToutLeCatalogueDetail(i18n),
										false)
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('deux')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$fieldset,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('chiffres')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$legend,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$compteurDrawerChiffres(i18n))
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$input,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id('compteur-chiffres'),
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('number'),
												$rtfeldman$elm_css$Html$Styled$Attributes$value(model.vb),
												$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Parametrage$CompteurDeCode$Update$ChiffresSaisis)
											]),
										_List_Nil)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$fieldset,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('premier')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$legend,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$compteurDrawerPremier(i18n))
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$input,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id('compteur-premier'),
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('number'),
												$rtfeldman$elm_css$Html$Styled$Attributes$value(model.Ge),
												$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Parametrage$CompteurDeCode$Update$PremierSaisi)
											]),
										_List_Nil)
									]))
							])),
						A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$compteurDrawerNote(i18n))
							])),
						A2($author$project$Components$Parametrage$CompteurDeCode$View$refus, i18n, model)
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$compteurDrawerTitre(i18n)
			},
			model.kX);
	});
var $author$project$Components$Parametrage$CompteurDeCode$View$view = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'parametrage-compteur-de-code',
			{
				ut: model.qa ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('acces-refuse')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Note$View$view,
										1,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$coquilleAccesRefuse(i18n))
													]))
											]))
									]))
							]))
					]) : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						_List_fromArray(
							[
								A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
								model.gd ? A2(
								$author$project$Components$Shared$Note$View$view,
								2,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$compteurEchecDeLecture(i18n))
									])) : $rtfeldman$elm_css$Html$Styled$text(''),
								A2(
								$elm$core$Maybe$withDefault,
								$rtfeldman$elm_css$Html$Styled$text(''),
								A2(
									$elm$core$Maybe$map,
									A2($author$project$Components$Parametrage$CompteurDeCode$View$carte, i18n, model),
									model.eO))
							]))
					]),
				xy: _List_fromArray(
					[
						A2($author$project$Components$Parametrage$CompteurDeCode$View$drawer, i18n, model)
					]),
				zM: _List_Nil,
				AK: $author$project$Components$Parametrage$CompteurDeCode$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$compteurDescription(i18n))
									]))
							]),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adresseTypesDePartiesPrenantes,
								Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
							},
								{
								aa: $author$project$Routes$Route$adresseDuCompteurDeCode,
								Dj: $author$project$I18n$Cles$compteurFil(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$compteurTitre(i18n)
					})
			});
	});
var $author$project$Components$Parametrage$Droits$View$accesDuModule = F2(
	function (droits, cle) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Dict$get, cle, droits.of));
	});
var $author$project$I18n$Cles$droitsApercuAilleurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.apercu.ailleurs', _List_Nil, 'Ailleurs : « Fiche introuvable »');
};
var $author$project$I18n$Cles$droitsApercuAucunDroit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.apercu.aucun-droit', _List_Nil, 'Aucun droit particulier');
};
var $author$project$I18n$Cles$droitsApercuChampsResume = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.apercu.champs-resume',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'masques',
					$author$project$I18n$Traductions$Entier(p.Cd)),
					_Utils_Tuple2(
					'lecture',
					$author$project$I18n$Traductions$Chaine(p.np))
				]),
			((!p.Cd) || (p.Cd === 1)) ? ('Champs : ' + (A2($author$project$I18n$Nombre$formater, 0, p.Cd) + (' masqué, ' + (p.np + ' en lecture')))) : ('Champs : ' + (A2($author$project$I18n$Nombre$formater, 0, p.Cd) + (' masqués, ' + (p.np + ' en lecture')))));
	});
var $author$project$I18n$Cles$droitsApercuLectureSeuleTracee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.apercu.lecture-seule-tracee', _List_Nil, 'Aperçu en lecture seule, tracé');
};
var $author$project$I18n$Cles$droitsApercuModulesSur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.apercu.modules-sur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			'Modules : ' + (p.w + (' sur ' + p.JE)));
	});
var $author$project$I18n$Cles$droitsApercuRoles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.apercu.roles', _List_Nil, 'Rôles');
};
var $author$project$I18n$Cles$droitsApercuTitreChamps = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.apercu.titre.champs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typeDeFiche',
					$author$project$I18n$Traductions$Chaine(p.ca))
				]),
			'Les champs d\'un ' + p.ca);
	});
var $author$project$I18n$Cles$droitsApercuTitreFiches = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.apercu.titre.fiches', _List_Nil, 'Les fiches vues');
};
var $author$project$I18n$Cles$droitsApercuTitreModules = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.apercu.titre.modules', _List_Nil, 'Ce que le rôle peut faire');
};
var $author$project$I18n$Cles$droitsApercuTitrePersonnes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.apercu.titre.personnes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' personne a ce rôle') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' personnes ont ce rôle'));
	});
var $author$project$I18n$Cles$droitsApercuTitrePret = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.apercu.titre.pret', _List_Nil, 'Le rôle est prêt');
};
var $author$project$I18n$Cles$droitsApercuTitreRoles = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.apercu.titre.roles',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' rôle') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' rôles'));
	});
var $author$project$I18n$Cles$droitsApercuTitreRolesDont = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.apercu.titre.roles-dont',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w)),
					_Utils_Tuple2(
					'fourni',
					$author$project$I18n$Traductions$Chaine(p.zV))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' rôle dont « ' + (p.zV + ' »'))) : (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' rôles dont « ' + (p.zV + ' »'))));
	});
var $author$project$I18n$Cles$droitsPersonnesSansNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.personnes.sans-nom', _List_Nil, 'Personne sans nom');
};
var $author$project$I18n$Cles$droitsRolePersonnes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.role.personnes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' personne') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' personnes'));
	});
var $author$project$Components$Parametrage$Droits$Model$groupesDeChamps = function (champs) {
	return A3(
		$elm$core$List$foldr,
		F2(
			function (champ, groupes) {
				if (groupes.b && groupes.a.b) {
					var _v1 = groupes.a;
					var premier = _v1.a;
					var reste = _v1.b;
					var suivants = groupes.b;
					return _Utils_eq(premier.ce, champ.ce) ? A2(
						$elm$core$List$cons,
						A2(
							$elm$core$List$cons,
							champ,
							A2($elm$core$List$cons, premier, reste)),
						suivants) : A2(
						$elm$core$List$cons,
						_List_fromArray(
							[champ]),
						groupes);
				} else {
					return A2(
						$elm$core$List$cons,
						_List_fromArray(
							[champ]),
						groupes);
				}
			}),
		_List_Nil,
		champs);
};
var $author$project$I18n$Cles$droitsParticulierComptable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.particulier.comptable', _List_Nil, 'Voir les données de facturation');
};
var $author$project$I18n$Cles$droitsParticulierConcevoirLesPipes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.particulier.concevoir-les-pipes', _List_Nil, 'Concevoir les pipes');
};
var $author$project$I18n$Cles$droitsParticulierEnrichirLesListesDesPartiesPrenantes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.particulier.enrichir-les-listes-des-parties-prenantes', _List_Nil, 'Enrichir les listes des parties prenantes');
};
var $author$project$I18n$Cles$droitsParticulierEnrichirLesListesDuCatalogue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.particulier.enrichir-les-listes-du-catalogue', _List_Nil, 'Enrichir les listes du catalogue');
};
var $author$project$I18n$Cles$droitsParticulierFusionnerToutesLesFiches = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.particulier.fusionner-toutes-les-fiches', _List_Nil, 'Fusionner toutes les fiches');
};
var $author$project$I18n$Cles$droitsParticulierGererLesGroupes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.particulier.gerer-les-groupes', _List_Nil, 'Gérer les groupes');
};
var $author$project$I18n$Cles$droitsParticulierReferentRgpd = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.particulier.referent-rgpd', _List_Nil, 'Exporter ou effacer les données d\'une personne');
};
var $author$project$Components$Parametrage$Droits$View$libelleDuParticulier = F2(
	function (i18n, cle) {
		switch (cle) {
			case 'ReferentRgpd':
				return $author$project$I18n$Cles$droitsParticulierReferentRgpd(i18n);
			case 'Comptable':
				return $author$project$I18n$Cles$droitsParticulierComptable(i18n);
			case 'GererLesGroupes':
				return $author$project$I18n$Cles$droitsParticulierGererLesGroupes(i18n);
			case 'FusionnerToutesLesFiches':
				return $author$project$I18n$Cles$droitsParticulierFusionnerToutesLesFiches(i18n);
			case 'ConcevoirLesPipes':
				return $author$project$I18n$Cles$droitsParticulierConcevoirLesPipes(i18n);
			case 'EnrichirLesListesDuCatalogue':
				return $author$project$I18n$Cles$droitsParticulierEnrichirLesListesDuCatalogue(i18n);
			case 'EnrichirLesListesDesPartiesPrenantes':
				return $author$project$I18n$Cles$droitsParticulierEnrichirLesListesDesPartiesPrenantes(i18n);
			default:
				var autre = cle;
				return autre;
		}
	});
var $author$project$Components$Parametrage$Droits$View$ligne = F3(
	function (fort, retrait, texte) {
		return {dX: fort, eW: retrait, Jx: texte};
	});
var $author$project$I18n$Cles$droitsApercuAccesLecture = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.apercu.acces.lecture', _List_Nil, 'lecture seule');
};
var $author$project$I18n$Cles$droitsApercuAccesMasque = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.apercu.acces.masque',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? 'masqué' : 'masqués');
	});
var $author$project$I18n$Cles$droitsApercuAccesModifiable = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.apercu.acces.modifiable',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? 'modifiable' : 'modifiables');
	});
var $author$project$I18n$Cles$droitsApercuChamps = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.apercu.champs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champs',
					$author$project$I18n$Traductions$Chaine(p.dw)),
					_Utils_Tuple2(
					'acces',
					$author$project$I18n$Traductions$Chaine(p.ce))
				]),
			p.dw + (' : ' + p.ce));
	});
var $author$project$Components$Parametrage$Droits$View$ligneDesChamps = F2(
	function (i18n, groupe) {
		var nombre = $elm$core$List$length(groupe);
		var minuscule = function (libelle) {
			return function (tete) {
				return _Utils_ap(
					tete,
					A2($elm$core$String$dropLeft, 1, libelle));
			}(
				$elm$core$String$toLower(
					A2($elm$core$String$left, 1, libelle)));
		};
		var libelles = function () {
			var _v3 = A2(
				$elm$core$List$map,
				function ($) {
					return $.Bl;
				},
				groupe);
			if (_v3.b) {
				var premier = _v3.a;
				var suite = _v3.b;
				return A2(
					$elm$core$List$cons,
					premier,
					A2($elm$core$List$map, minuscule, suite));
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$author$project$I18n$Cles$droitsApercuChamps,
			i18n,
			{
				ce: function () {
					var _v0 = A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.ce;
						},
						$elm$core$List$head(groupe));
					_v0$2:
					while (true) {
						if (!_v0.$) {
							switch (_v0.a) {
								case 2:
									var _v1 = _v0.a;
									return A2(
										$author$project$I18n$Cles$droitsApercuAccesModifiable,
										i18n,
										{w: nombre});
								case 1:
									var _v2 = _v0.a;
									return $author$project$I18n$Cles$droitsApercuAccesLecture(i18n);
								default:
									break _v0$2;
							}
						} else {
							break _v0$2;
						}
					}
					return A2(
						$author$project$I18n$Cles$droitsApercuAccesMasque,
						i18n,
						{w: nombre});
				}(),
				dw: A2($elm$core$String$join, ', ', libelles)
			});
	});
var $author$project$I18n$Cles$droitsApercuModule = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.apercu.module',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nomDuModule',
					$author$project$I18n$Traductions$Chaine(p.oA)),
					_Utils_Tuple2(
					'acces',
					$author$project$I18n$Traductions$Chaine(p.ce))
				]),
			p.oA + (' : ' + p.ce));
	});
var $author$project$I18n$Cles$droitsApercuModuleSansEffet = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.apercu.module.sans-effet',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nomDuModule',
					$author$project$I18n$Traductions$Chaine(p.oA)),
					_Utils_Tuple2(
					'acces',
					$author$project$I18n$Traductions$Chaine(p.ce))
				]),
			p.oA + (' : ' + (p.ce + ' (sans effet pour l\'instant)')));
	});
var $author$project$I18n$Cles$droitsAccesAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.acces.aucun', _List_Nil, 'Aucun');
};
var $author$project$I18n$Cles$droitsAccesLecture = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.acces.lecture', _List_Nil, 'Lecture');
};
var $author$project$I18n$Cles$droitsAccesModification = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.acces.modification', _List_Nil, 'Modification');
};
var $author$project$Components$Parametrage$Droits$View$libelleDeLAcces = F2(
	function (i18n, acces) {
		switch (acces) {
			case 0:
				return $author$project$I18n$Cles$droitsAccesAucun(i18n);
			case 1:
				return $author$project$I18n$Cles$droitsAccesLecture(i18n);
			default:
				return $author$project$I18n$Cles$droitsAccesModification(i18n);
		}
	});
var $author$project$I18n$Cles$droitsModuleDossiersEtPipes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.module.dossiers-et-pipes', _List_Nil, 'Dossiers et pipes');
};
var $author$project$I18n$Cles$droitsModuleParametrage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.module.parametrage', _List_Nil, 'Paramétrage');
};
var $author$project$I18n$Cles$droitsModulePartiesPrenantes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.module.parties-prenantes', _List_Nil, 'Parties prenantes');
};
var $author$project$I18n$Cles$droitsModuleProduits = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.module.produits', _List_Nil, 'Produits');
};
var $author$project$Components$Parametrage$Droits$View$libelleDuModule = F2(
	function (i18n, cle) {
		switch (cle) {
			case 'PartiesPrenantes':
				return $author$project$I18n$Cles$droitsModulePartiesPrenantes(i18n);
			case 'Produits':
				return $author$project$I18n$Cles$droitsModuleProduits(i18n);
			case 'Parametrage':
				return $author$project$I18n$Cles$droitsModuleParametrage(i18n);
			case 'DossiersEtPipes':
				return $author$project$I18n$Cles$droitsModuleDossiersEtPipes(i18n);
			default:
				var autre = cle;
				return autre;
		}
	});
var $author$project$Components$Parametrage$Droits$View$ligneDuModule = F3(
	function (i18n, fiche, cle) {
		var acces = A2($author$project$Components$Parametrage$Droits$View$accesDuModule, fiche.xS, cle);
		var parametres = {
			ce: A2($author$project$Components$Parametrage$Droits$View$libelleDeLAcces, i18n, acces),
			oA: A2($author$project$Components$Parametrage$Droits$View$libelleDuModule, i18n, cle)
		};
		return ((cle === 'DossiersEtPipes') && (!(!acces))) ? A2($author$project$I18n$Cles$droitsApercuModuleSansEffet, i18n, parametres) : A2($author$project$I18n$Cles$droitsApercuModule, i18n, parametres);
	});
var $author$project$I18n$Cles$droitsApercuPerimetreSiennes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.apercu.perimetre.siennes', _List_Nil, 'les siennes');
};
var $author$project$I18n$Cles$droitsApercuPerimetreToutes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.apercu.perimetre.toutes', _List_Nil, 'toutes les fiches');
};
var $author$project$I18n$Cles$droitsApercuType = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.apercu.type',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typeDeFiche',
					$author$project$I18n$Traductions$Chaine(p.ca)),
					_Utils_Tuple2(
					'perimetre',
					$author$project$I18n$Traductions$Chaine(p.E9))
				]),
			p.ca + (' : ' + p.E9));
	});
var $author$project$I18n$Cles$droitsApercuTypePasVu = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.apercu.type.pas-vu',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typeDeFiche',
					$author$project$I18n$Traductions$Chaine(p.ca))
				]),
			p.ca + ' : pas vu');
	});
var $author$project$Components$Parametrage$Droits$View$ligneDuType = F2(
	function (i18n, affiche) {
		return affiche.xP.KT ? A2(
			$author$project$I18n$Cles$droitsApercuType,
			i18n,
			{
				E9: (affiche.xP.E9 === 'Toutes') ? $author$project$I18n$Cles$droitsApercuPerimetreToutes(i18n) : $author$project$I18n$Cles$droitsApercuPerimetreSiennes(i18n),
				ca: affiche.Bl
			}) : A2(
			$author$project$I18n$Cles$droitsApercuTypePasVu,
			i18n,
			{ca: affiche.Bl});
	});
var $author$project$Components$Parametrage$Droits$Model$modulesReglables = _List_fromArray(
	['PartiesPrenantes', 'Produits', 'Parametrage', 'DossiersEtPipes']);
var $author$project$Components$Parametrage$Droits$View$typeChoisi = F2(
	function (model, types) {
		var _v0 = A2(
			$elm$core$List$filter,
			function (affiche) {
				return _Utils_eq(
					$elm$core$Maybe$Just(affiche.dy),
					model.r_);
			},
			types);
		if (_v0.b) {
			var premier = _v0.a;
			return $elm$core$Maybe$Just(premier);
		} else {
			return $elm$core$List$head(types);
		}
	});
var $author$project$Components$Parametrage$Droits$Model$typesAffiches = function (fiche) {
	return A2(
		$elm$core$List$map,
		function (reglable) {
			var droit = A2(
				$elm$core$Maybe$withDefault,
				$author$project$Components$Parametrage$Droits$Model$droitParDefaut(reglable.oe),
				A2($elm$core$Dict$get, reglable.JW, fiche.xS.ib));
			return {
				dw: A2(
					$elm$core$List$map,
					function (champ) {
						return {
							ce: A2(
								$elm$core$Maybe$withDefault,
								0,
								A2($elm$core$Dict$get, champ.uN, droit.dw)),
							dy: champ.uN,
							Bl: champ.Bl,
							en: champ.en,
							Fe: champ.Fe,
							IZ: champ.IZ
						};
					},
					reglable.dw),
				dy: reglable.JW,
				xP: droit,
				Bl: reglable.Bl,
				en: reglable.en
			};
		},
		fiche.Hl);
};
var $author$project$Components$Parametrage$Droits$View$apercu = F3(
	function (i18n, courante, model) {
		var _v0 = _Utils_Tuple3(courante, model.zo, model.aS);
		_v0$6:
		while (true) {
			switch (_v0.a) {
				case 0:
					if (!_v0.c.$) {
						var _v1 = _v0.a;
						var annuaire = _v0.c.a;
						return {
							gV: A2(
								$elm$core$List$cons,
								A3(
									$author$project$Components$Parametrage$Droits$View$ligne,
									true,
									0,
									$author$project$I18n$Cles$droitsApercuRoles(i18n)),
								A2(
									$elm$core$List$map,
									function (role) {
										return A3(
											$author$project$Components$Parametrage$Droits$View$ligne,
											false,
											1,
											role.Dj + (' · ' + $elm$core$String$fromInt(role.Kf)));
									},
									annuaire.eX)),
							h6: $elm$core$Maybe$Just(
								function () {
									var _v2 = A2(
										$elm$core$List$filter,
										function ($) {
											return $.rv;
										},
										annuaire.eX);
									if (_v2.b) {
										var fourni = _v2.a;
										return A2(
											$author$project$I18n$Cles$droitsApercuTitreRolesDont,
											i18n,
											{
												zV: fourni.Dj,
												w: $elm$core$List$length(annuaire.eX)
											});
									} else {
										return A2(
											$author$project$I18n$Cles$droitsApercuTitreRoles,
											i18n,
											{
												w: $elm$core$List$length(annuaire.eX)
											});
									}
								}())
						};
					} else {
						break _v0$6;
					}
				case 1:
					if (!_v0.b.$) {
						var _v3 = _v0.a;
						var fiche = _v0.b.a;
						return {
							gV: A2(
								$elm$core$List$cons,
								A3($author$project$Components$Parametrage$Droits$View$ligne, true, 0, fiche.Dj),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											A2($author$project$Components$Parametrage$Droits$View$ligneDuModule, i18n, fiche),
											A2($author$project$Components$Parametrage$Droits$View$ligne, false, 1)),
										$author$project$Components$Parametrage$Droits$Model$modulesReglables),
									$elm$core$List$isEmpty(fiche.xS.pa) ? _List_fromArray(
										[
											A3(
											$author$project$Components$Parametrage$Droits$View$ligne,
											false,
											1,
											$author$project$I18n$Cles$droitsApercuAucunDroit(i18n))
										]) : A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Components$Parametrage$Droits$View$libelleDuParticulier(i18n),
											A2($author$project$Components$Parametrage$Droits$View$ligne, false, 1)),
										fiche.xS.pa))),
							h6: $elm$core$Maybe$Just(
								$author$project$I18n$Cles$droitsApercuTitreModules(i18n))
						};
					} else {
						break _v0$6;
					}
				case 2:
					if (!_v0.b.$) {
						var _v4 = _v0.a;
						var fiche = _v0.b.a;
						return {
							gV: A2(
								$elm$core$List$cons,
								A3($author$project$Components$Parametrage$Droits$View$ligne, true, 0, fiche.Dj),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Components$Parametrage$Droits$View$ligneDuType(i18n),
											A2($author$project$Components$Parametrage$Droits$View$ligne, false, 1)),
										$author$project$Components$Parametrage$Droits$Model$typesAffiches(fiche)),
									_List_fromArray(
										[
											A3(
											$author$project$Components$Parametrage$Droits$View$ligne,
											false,
											1,
											$author$project$I18n$Cles$droitsApercuAilleurs(i18n))
										]))),
							h6: $elm$core$Maybe$Just(
								$author$project$I18n$Cles$droitsApercuTitreFiches(i18n))
						};
					} else {
						break _v0$6;
					}
				case 3:
					if (!_v0.b.$) {
						var _v5 = _v0.a;
						var fiche = _v0.b.a;
						var _v6 = A2(
							$author$project$Components$Parametrage$Droits$View$typeChoisi,
							model,
							$author$project$Components$Parametrage$Droits$Model$typesAffiches(fiche));
						if (!_v6.$) {
							var affiche = _v6.a;
							return {
								gV: A2(
									$elm$core$List$cons,
									A3($author$project$Components$Parametrage$Droits$View$ligne, true, 0, affiche.Bl),
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Components$Parametrage$Droits$View$ligneDesChamps(i18n),
											A2($author$project$Components$Parametrage$Droits$View$ligne, false, 1)),
										$author$project$Components$Parametrage$Droits$Model$groupesDeChamps(affiche.dw))),
								h6: $elm$core$Maybe$Just(
									A2(
										$author$project$I18n$Cles$droitsApercuTitreChamps,
										i18n,
										{ca: affiche.Bl}))
							};
						} else {
							return {gV: _List_Nil, h6: $elm$core$Maybe$Nothing};
						}
					} else {
						break _v0$6;
					}
				case 4:
					if (!_v0.b.$) {
						var _v7 = _v0.a;
						var fiche = _v0.b.a;
						return {
							gV: A2(
								$elm$core$List$cons,
								A3($author$project$Components$Parametrage$Droits$View$ligne, true, 0, fiche.Dj),
								A2(
									$elm$core$List$map,
									function (personne) {
										return A3(
											$author$project$Components$Parametrage$Droits$View$ligne,
											false,
											1,
											A2(
												$elm$core$Maybe$withDefault,
												$author$project$I18n$Cles$droitsPersonnesSansNom(i18n),
												personne.Dj));
									},
									fiche.Fg)),
							h6: $elm$core$Maybe$Just(
								A2(
									$author$project$I18n$Cles$droitsApercuTitrePersonnes,
									i18n,
									{
										w: $elm$core$List$length(fiche.Fg)
									}))
						};
					} else {
						break _v0$6;
					}
				default:
					if (!_v0.b.$) {
						var _v8 = _v0.a;
						var fiche = _v0.b.a;
						var modulesAvecAcces = $elm$core$List$length(
							A2(
								$elm$core$List$filter,
								function (cle) {
									return !(!A2($author$project$Components$Parametrage$Droits$View$accesDuModule, fiche.xS, cle));
								},
								$author$project$Components$Parametrage$Droits$Model$modulesReglables));
						var affiches = $author$project$Components$Parametrage$Droits$Model$typesAffiches(fiche);
						var lesChamps = A2(
							$elm$core$List$concatMap,
							function ($) {
								return $.dw;
							},
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.xP;
									},
									function ($) {
										return $.KT;
									}),
								affiches));
						var nombreDe = function (acces) {
							return $elm$core$List$length(
								A2(
									$elm$core$List$filter,
									function (c) {
										return _Utils_eq(c.ce, acces);
									},
									lesChamps));
						};
						return {
							gV: A2(
								$elm$core$List$cons,
								A3($author$project$Components$Parametrage$Droits$View$ligne, true, 0, fiche.Dj),
								A2(
									$elm$core$List$cons,
									A3(
										$author$project$Components$Parametrage$Droits$View$ligne,
										false,
										1,
										A2(
											$author$project$I18n$Cles$droitsRolePersonnes,
											i18n,
											{
												w: $elm$core$List$length(fiche.Fg)
											})),
									A2(
										$elm$core$List$cons,
										A3(
											$author$project$Components$Parametrage$Droits$View$ligne,
											false,
											1,
											A2(
												$author$project$I18n$Cles$droitsApercuModulesSur,
												i18n,
												{
													w: $elm$core$String$fromInt(modulesAvecAcces),
													JE: $elm$core$String$fromInt(
														$elm$core$List$length($author$project$Components$Parametrage$Droits$Model$modulesReglables))
												})),
										_Utils_ap(
											A2(
												$elm$core$List$map,
												A2(
													$elm$core$Basics$composeR,
													$author$project$Components$Parametrage$Droits$View$ligneDuType(i18n),
													A2($author$project$Components$Parametrage$Droits$View$ligne, false, 1)),
												affiches),
											_List_fromArray(
												[
													A3(
													$author$project$Components$Parametrage$Droits$View$ligne,
													false,
													1,
													A2(
														$author$project$I18n$Cles$droitsApercuChampsResume,
														i18n,
														{
															np: $elm$core$String$fromInt(
																nombreDe(1)),
															Cd: nombreDe(0)
														})),
													A3(
													$author$project$Components$Parametrage$Droits$View$ligne,
													false,
													1,
													$author$project$I18n$Cles$droitsApercuLectureSeuleTracee(i18n))
												]))))),
							h6: $elm$core$Maybe$Just(
								$author$project$I18n$Cles$droitsApercuTitrePret(i18n))
						};
					} else {
						break _v0$6;
					}
			}
		}
		return {gV: _List_Nil, h6: $elm$core$Maybe$Nothing};
	});
var $author$project$Components$Parametrage$Droits$Update$AttributionDemandee = {$: 20};
var $author$project$Components$Parametrage$Droits$Update$CreationDemandee = {$: 13};
var $author$project$Components$Parametrage$Droits$Update$RenommageDemande = {$: 15};
var $author$project$Components$Parametrage$Droits$Update$RechercheSaisie = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Parametrage$Droits$View$correspond = F2(
	function (recherche, membre) {
		var cherche = $elm$core$String$toLower(
			$elm$core$String$trim(recherche));
		return (cherche === '') || A2(
			$elm$core$String$contains,
			cherche,
			$elm$core$String$toLower(membre.Dj + (' ' + membre.kh)));
	});
var $author$project$I18n$Cles$droitsAttribuerAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.attribuer.aucune', _List_Nil, 'Aucune personne à ajouter.');
};
var $author$project$I18n$Cles$droitsAttribuerChercher = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.attribuer.chercher', _List_Nil, 'Chercher');
};
var $author$project$I18n$Cles$droitsAttribuerListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.attribuer.liste', _List_Nil, 'Personnes de votre équipe');
};
var $author$project$I18n$Cles$droitsAttribuerNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.attribuer.note', _List_Nil, 'Une personne peut garder son autre rôle : ses droits s\'ajoutent.');
};
var $author$project$Components$Parametrage$Droits$View$idDuChamp = function (suffixe) {
	return 'droits-' + suffixe;
};
var $author$project$I18n$Cles$droitsRejeu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.rejeu', _List_Nil, 'Cette saisie n\'a pas été appliquée : l\'écran vient d\'être relu.');
};
var $author$project$I18n$Cles$droitsErreurAutre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.erreur.autre', _List_Nil, 'La modification n\'a pas abouti.');
};
var $author$project$I18n$Cles$droitsErreurDernierAdministrateur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.erreur.dernier-administrateur', _List_Nil, 'Le dernier administrateur ne se retire pas.');
};
var $author$project$I18n$Cles$droitsErreurIncoherents = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.erreur.incoherents', _List_Nil, 'Ces droits ne sont plus cohérents : relisez le rôle.');
};
var $author$project$I18n$Cles$droitsErreurNomInvalide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.erreur.nom-invalide', _List_Nil, 'Le nom du rôle est vide ou trop long.');
};
var $author$project$I18n$Cles$droitsErreurNomPris = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.erreur.nom-pris', _List_Nil, 'Un rôle porte déjà ce nom.');
};
var $author$project$I18n$Cles$droitsErreurRecalcul = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.erreur.recalcul', _List_Nil, 'Vos droits sont en cours de mise à jour, réessayez dans un instant.');
};
var $author$project$I18n$Cles$droitsErreurRoleAttribue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.erreur.role-attribue', _List_Nil, 'Ce rôle a encore des utilisateurs.');
};
var $author$project$I18n$Cles$droitsErreurSysteme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.erreur.systeme', _List_Nil, 'Le rôle Administrateur ne se modifie pas.');
};
var $author$project$I18n$Cles$droitsErreurUtilisateur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.erreur.utilisateur', _List_Nil, 'Cette personne n\'est plus membre de votre équipe.');
};
var $author$project$Components$Parametrage$Droits$View$texteDuRefus = F2(
	function (i18n, erreur) {
		switch (erreur) {
			case 0:
				return $author$project$I18n$Cles$droitsErreurNomPris(i18n);
			case 1:
				return $author$project$I18n$Cles$droitsErreurNomInvalide(i18n);
			case 2:
				return $author$project$I18n$Cles$droitsErreurRoleAttribue(i18n);
			case 3:
				return $author$project$I18n$Cles$droitsErreurDernierAdministrateur(i18n);
			case 4:
				return $author$project$I18n$Cles$droitsErreurSysteme(i18n);
			case 5:
				return $author$project$I18n$Cles$droitsErreurIncoherents(i18n);
			case 6:
				return $author$project$I18n$Cles$droitsErreurUtilisateur(i18n);
			case 7:
				return $author$project$I18n$Cles$droitsErreurRecalcul(i18n);
			default:
				return $author$project$I18n$Cles$droitsErreurAutre(i18n);
		}
	});
var $author$project$Components$Parametrage$Droits$View$refus = F2(
	function (i18n, model) {
		var _v0 = model.pZ;
		if (!_v0.$) {
			var erreur = _v0.a;
			return A2(
				$author$project$Components$Shared$Note$View$view,
				1,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$Components$Parametrage$Droits$View$texteDuRefus, i18n, erreur))
							]))
					]));
		} else {
			return model.qh ? A2(
				$author$project$Components$Shared$Note$View$view,
				1,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$droitsRejeu(i18n))
							]))
					])) : $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$Droits$View$refusEnTete = F2(
	function (i18n, model) {
		var _v0 = model.pZ;
		_v0$2:
		while (true) {
			if (!_v0.$) {
				switch (_v0.a) {
					case 0:
						var _v1 = _v0.a;
						return $rtfeldman$elm_css$Html$Styled$text('');
					case 1:
						var _v2 = _v0.a;
						return $rtfeldman$elm_css$Html$Styled$text('');
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return A2($author$project$Components$Parametrage$Droits$View$refus, i18n, model);
	});
var $author$project$Components$Parametrage$Droits$Update$MembreCoche = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$I18n$Cles$droitsAttribuerDeja = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.attribuer.deja', _List_Nil, 'A déjà ce rôle');
};
var $author$project$I18n$Cles$droitsAttribuerSansRole = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.attribuer.sans-role', _List_Nil, 'Sans rôle pour l\'instant');
};
var $author$project$Components$Parametrage$Droits$View$unMembre = F4(
	function (i18n, model, deja, membre) {
		var possede = A2($elm$core$List$member, membre.r8, deja);
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('membre'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('disabled', possede)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Champ$View$caseACocherInactivable,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: $author$project$Components$Parametrage$Droits$View$idDuChamp('membre-' + membre.r8),
						Bl: membre.Dj + (' · ' + (function () {
							var _v0 = membre.eX;
							if (_v0.$ === 1) {
								return membre.kh;
							} else {
								if (!_v0.a.b) {
									return $author$project$I18n$Cles$droitsAttribuerSansRole(i18n);
								} else {
									var roles = _v0.a;
									return A2($elm$core$String$join, ', ', roles);
								}
							}
						}() + (possede ? (' · ' + $author$project$I18n$Cles$droitsAttribuerDeja(i18n)) : ''))),
						he: false
					},
					{
						vt: A2($elm$core$List$member, membre.r8, model.jL) || possede,
						d4: possede,
						D9: $author$project$Components$Parametrage$Droits$Update$MembreCoche(membre.r8)
					})
				]));
	});
var $author$project$Components$Parametrage$Droits$View$attribution = F2(
	function (i18n, model) {
		var membres = A2(
			$elm$core$List$filter,
			$author$project$Components$Parametrage$Droits$View$correspond(model.hC),
			A2($elm$core$Maybe$withDefault, _List_Nil, model.Cm));
		var deja = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Fg;
					},
					$elm$core$List$map(
						function ($) {
							return $.r8;
						})),
				model.zo));
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Champ$View$texte,
				{
					go: $elm$core$Maybe$Nothing,
					Aq: $author$project$Components$Parametrage$Droits$View$idDuChamp('recherche'),
					Bl: $author$project$I18n$Cles$droitsAttribuerChercher(i18n),
					he: false
				},
				{hg: $author$project$Components$Parametrage$Droits$Update$RechercheSaisie, fm: model.hC}),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$droitsAttribuerListe(i18n))
					])),
				$elm$core$List$isEmpty(membres) ? A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$droitsAttribuerAucune(i18n))
					])) : A2(
				$rtfeldman$elm_css$Html$Styled$ul,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('membres')
					]),
				A2(
					$elm$core$List$map,
					A3($author$project$Components$Parametrage$Droits$View$unMembre, i18n, model, deja),
					membres)),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$droitsAttribuerNote(i18n))
					])),
				A2($author$project$Components$Parametrage$Droits$View$refusEnTete, i18n, model)
			]);
	});
var $author$project$Components$Parametrage$Droits$Update$ModeleChoisi = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Parametrage$Droits$Update$NomSaisi = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Parametrage$Droits$View$champDeNom = F4(
	function (i18n, model, libelle, indication) {
		return A2(
			$author$project$Components$Shared$Champ$View$texteAvecIndication,
			{
				go: function () {
					var _v0 = model.pZ;
					_v0$2:
					while (true) {
						if (!_v0.$) {
							switch (_v0.a) {
								case 0:
									var _v1 = _v0.a;
									return $elm$core$Maybe$Just(
										$author$project$I18n$Cles$droitsErreurNomPris(i18n));
								case 1:
									var _v2 = _v0.a;
									return $elm$core$Maybe$Just(
										$author$project$I18n$Cles$droitsErreurNomInvalide(i18n));
								default:
									break _v0$2;
							}
						} else {
							break _v0$2;
						}
					}
					return $elm$core$Maybe$Nothing;
				}(),
				Aq: $author$project$Components$Parametrage$Droits$View$idDuChamp('nom'),
				Bl: libelle,
				he: true
			},
			{na: indication, hg: $author$project$Components$Parametrage$Droits$Update$NomSaisi, fm: model.Dj});
	});
var $author$project$Components$Parametrage$Droits$View$choix = F6(
	function (groupe, inactif, coche, libelle, note, msg) {
		var identifiant = $author$project$Components$Parametrage$Droits$View$idDuChamp(
			groupe + ('-' + $elm$core$String$toLower(
				A2($elm$core$String$filter, $elm$core$Char$isAlphaNum, libelle))));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('choix')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(identifiant),
							$rtfeldman$elm_css$Html$Styled$Attributes$name(groupe),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(coche),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif),
							$rtfeldman$elm_css$Html$Styled$Events$onCheck(
							function (_v0) {
								return msg;
							})
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$for(identifiant)
						]),
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$text(libelle),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (n) {
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(n)
												]))
										]);
								},
								note))))
				]));
	});
var $author$project$I18n$Cles$droitsCreerCopie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.creer.copie', _List_Nil, 'Copier un rôle');
};
var $author$project$I18n$Cles$droitsCreerCopieNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.creer.copie.note', _List_Nil, 'Mêmes droits que le rôle choisi. Les personnes ne sont pas copiées.');
};
var $author$project$I18n$Cles$droitsCreerDepart = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.creer.depart', _List_Nil, 'Point de départ');
};
var $author$project$I18n$Cles$droitsCreerModele = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.creer.modele', _List_Nil, 'Rôle à copier');
};
var $author$project$I18n$Cles$droitsCreerNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.creer.nom', _List_Nil, 'Nom');
};
var $author$project$I18n$Cles$droitsCreerNomIndication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.creer.nom.indication', _List_Nil, 'Nom du nouveau rôle');
};
var $author$project$I18n$Cles$droitsCreerNomNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.creer.nom.note', _List_Nil, 'Deux rôles ne peuvent pas porter le même nom.');
};
var $author$project$I18n$Cles$droitsCreerRien = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.creer.rien', _List_Nil, 'Partir de rien');
};
var $author$project$I18n$Cles$droitsCreerRienNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.creer.rien.note', _List_Nil, 'Un rôle vide : rien n\'est autorisé.');
};
var $author$project$Components$Parametrage$Droits$View$nonVide = function (texte) {
	return (texte === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(texte);
};
var $author$project$I18n$Cles$droitsCreerObtenez = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.creer.obtenez', _List_Nil, 'Ce que vous obtenez');
};
var $author$project$I18n$Cles$droitsCreerObtenezChampsMasques = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.creer.obtenez.champs-masques',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champ masqué') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champs masqués'));
	});
var $author$project$I18n$Cles$droitsCreerObtenezLecture = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.creer.obtenez.lecture',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'modules',
					$author$project$I18n$Traductions$Chaine(p.of))
				]),
			p.of + ' en lecture');
	});
var $author$project$I18n$Cles$droitsCreerObtenezModification = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.creer.obtenez.modification',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'modules',
					$author$project$I18n$Traductions$Chaine(p.of))
				]),
			p.of + ' en modification');
	});
var $author$project$I18n$Cles$droitsCreerObtenezPersonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.creer.obtenez.personne', _List_Nil, 'Aucune personne n\'aura ce rôle tant que vous ne l\'aurez pas attribué.');
};
var $author$project$I18n$Cles$droitsCreerObtenezTout = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.creer.obtenez.tout', _List_Nil, 'Tous les droits, y compris ceux à venir');
};
var $author$project$I18n$Cles$droitsCreerObtenezTypes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.creer.obtenez.types',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' type de fiches') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' types de fiches'));
	});
var $author$project$Components$Parametrage$Droits$View$enMajuscule = function (texte) {
	return _Utils_ap(
		$elm$core$String$toUpper(
			A2($elm$core$String$left, 1, texte)),
		A2($elm$core$String$dropLeft, 1, texte));
};
var $author$project$Components$Parametrage$Droits$View$h3Titre = function (libelle) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h3,
		_List_Nil,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(libelle)
			]));
};
var $author$project$I18n$Cles$droitsCreerObtenezEt = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.creer.obtenez.et', _List_Nil, 'et');
};
var $author$project$Components$Parametrage$Droits$View$niveauDeModules = F3(
	function (i18n, phrase, cles) {
		var _v0 = A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$Parametrage$Droits$View$libelleDuModule(i18n),
				$elm$core$String$toLower),
			cles);
		if (!_v0.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!_v0.b.b) {
				var seul = _v0.a;
				return $elm$core$Maybe$Just(
					phrase(
						{of: seul}));
			} else {
				var plusieurs = _v0;
				return $elm$core$Maybe$Just(
					phrase(
						{
							of: A2(
								$elm$core$String$join,
								', ',
								A2(
									$elm$core$List$take,
									$elm$core$List$length(plusieurs) - 1,
									plusieurs)) + (' ' + ($author$project$I18n$Cles$droitsCreerObtenezEt(i18n) + (' ' + A2(
								$elm$core$Maybe$withDefault,
								'',
								$elm$core$List$head(
									$elm$core$List$reverse(plusieurs))))))
						}));
			}
		}
	});
var $author$project$Components$Parametrage$Droits$Model$resumeDuRole = function (copie) {
	if (copie.$ === 1) {
		return {fM: 0, gj: _List_Nil, gk: _List_Nil, rM: false, ib: 0};
	} else {
		var fiche = copie.a;
		var vus = A2(
			$elm$core$List$filter,
			function (affiche) {
				return affiche.xP.KT;
			},
			$author$project$Components$Parametrage$Droits$Model$typesAffiches(fiche));
		var niveau = function (acces) {
			return A2(
				$elm$core$List$filter,
				function (cle) {
					return _Utils_eq(
						A2(
							$elm$core$Maybe$withDefault,
							0,
							A2($elm$core$Dict$get, cle, fiche.xS.of)),
						acces);
				},
				$author$project$Components$Parametrage$Droits$Model$modulesReglables);
		};
		return {
			fM: $elm$core$List$sum(
				A2(
					$elm$core$List$map,
					function (affiche) {
						return $elm$core$List$length(
							A2(
								$elm$core$List$filter,
								function (champ) {
									return !champ.ce;
								},
								affiche.dw));
					},
					vus)),
			gj: niveau(1),
			gk: niveau(2),
			rM: fiche.xS.rM,
			ib: $elm$core$List$length(vus)
		};
	}
};
var $author$project$Components$Parametrage$Droits$View$obtenu = F2(
	function (i18n, model) {
		var resume = $author$project$Components$Parametrage$Droits$Model$resumeDuRole(model.oc);
		var copie = !_Utils_eq(model.oa, $elm$core$Maybe$Nothing);
		var morceaux = (copie && _Utils_eq(model.oc, $elm$core$Maybe$Nothing)) ? _List_Nil : (resume.rM ? _List_fromArray(
			[
				$author$project$I18n$Cles$droitsCreerObtenezTout(i18n)
			]) : A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$Components$Parametrage$Droits$View$niveauDeModules,
					i18n,
					$author$project$I18n$Cles$droitsCreerObtenezModification(i18n),
					resume.gk),
					A3(
					$author$project$Components$Parametrage$Droits$View$niveauDeModules,
					i18n,
					$author$project$I18n$Cles$droitsCreerObtenezLecture(i18n),
					resume.gj),
					(resume.ib > 0) ? $elm$core$Maybe$Just(
					A2(
						$author$project$I18n$Cles$droitsCreerObtenezTypes,
						i18n,
						{w: resume.ib})) : $elm$core$Maybe$Nothing,
					(resume.fM > 0) ? $elm$core$Maybe$Just(
					A2(
						$author$project$I18n$Cles$droitsCreerObtenezChampsMasques,
						i18n,
						{w: resume.fM})) : $elm$core$Maybe$Nothing
				])));
		var droits = ($elm$core$List$isEmpty(morceaux) && (!(copie && _Utils_eq(model.oc, $elm$core$Maybe$Nothing)))) ? _List_fromArray(
			[
				$author$project$I18n$Cles$droitsApercuAucunDroit(i18n)
			]) : morceaux;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('obtenu')
				]),
			_List_fromArray(
				[
					$author$project$Components$Parametrage$Droits$View$h3Titre(
					$author$project$I18n$Cles$droitsCreerObtenez(i18n)),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							_Utils_ap(
								$elm$core$List$isEmpty(droits) ? '' : ($author$project$Components$Parametrage$Droits$View$enMajuscule(
									A2($elm$core$String$join, ', ', droits)) + '. '),
								$author$project$I18n$Cles$droitsCreerObtenezPersonne(i18n)))
						]))
				]));
	});
var $author$project$Components$Parametrage$Droits$View$creation = F2(
	function (i18n, model) {
		var roles = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.eX;
				},
				model.aS));
		var copie = !_Utils_eq(model.oa, $elm$core$Maybe$Nothing);
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$fieldset,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('depart')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$legend,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$droitsCreerDepart(i18n))
									]))
							])),
						A6(
						$author$project$Components$Parametrage$Droits$View$choix,
						'depart',
						false,
						!copie,
						$author$project$I18n$Cles$droitsCreerRien(i18n),
						$elm$core$Maybe$Just(
							$author$project$I18n$Cles$droitsCreerRienNote(i18n)),
						$author$project$Components$Parametrage$Droits$Update$ModeleChoisi($elm$core$Maybe$Nothing)),
						A6(
						$author$project$Components$Parametrage$Droits$View$choix,
						'depart',
						false,
						copie,
						$author$project$I18n$Cles$droitsCreerCopie(i18n),
						$elm$core$Maybe$Just(
							$author$project$I18n$Cles$droitsCreerCopieNote(i18n)),
						$author$project$Components$Parametrage$Droits$Update$ModeleChoisi(
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.Aq;
								},
								$elm$core$List$head(roles))))
					])),
				copie ? A2(
				$author$project$Components$Shared$Champ$View$liste,
				{
					go: $elm$core$Maybe$Nothing,
					Aq: $author$project$Components$Parametrage$Droits$View$idDuChamp('modele'),
					Bl: $author$project$I18n$Cles$droitsCreerModele(i18n),
					he: true
				},
				{
					hg: function (id) {
						return $author$project$Components$Parametrage$Droits$Update$ModeleChoisi(
							$author$project$Components$Parametrage$Droits$View$nonVide(id));
					},
					o_: A2(
						$elm$core$List$map,
						function (role) {
							return {
								Bl: role.Dj + (' · ' + A2(
									$author$project$I18n$Cles$droitsRolePersonnes,
									i18n,
									{w: role.Kf})),
								fm: role.Aq
							};
						},
						roles),
					fm: A2($elm$core$Maybe$withDefault, '', model.oa)
				}) : $rtfeldman$elm_css$Html$Styled$text(''),
				A4(
				$author$project$Components$Parametrage$Droits$View$champDeNom,
				i18n,
				model,
				$author$project$I18n$Cles$droitsCreerNom(i18n),
				$elm$core$Maybe$Just(
					$author$project$I18n$Cles$droitsCreerNomIndication(i18n))),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$droitsCreerNomNote(i18n))
					])),
				A2($author$project$Components$Parametrage$Droits$View$obtenu, i18n, model),
				A2($author$project$Components$Parametrage$Droits$View$refusEnTete, i18n, model)
			]);
	});
var $author$project$I18n$Cles$droitsAttribuerAction = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.attribuer.action',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Ajouter ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' personne')) : ('Ajouter ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' personnes')));
	});
var $author$project$I18n$Cles$droitsAttribuerKicker = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.attribuer.kicker',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Rôle · ' + p.Dj);
	});
var $author$project$I18n$Cles$droitsAttribuerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.attribuer.titre', _List_Nil, 'Ajouter des personnes');
};
var $author$project$I18n$Cles$droitsCreerAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.creer.action', _List_Nil, 'Créer le rôle');
};
var $author$project$I18n$Cles$droitsCreerKicker = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.creer.kicker', _List_Nil, 'Rôle');
};
var $author$project$I18n$Cles$droitsCreerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.creer.titre', _List_Nil, 'Créer un rôle');
};
var $author$project$I18n$Cles$droitsReglerChamp = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.regler.champ',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'Champ « ' + (p.uN + ' »'));
	});
var $author$project$I18n$Cles$droitsReglerModule = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.regler.module',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nomDuModule',
					$author$project$I18n$Traductions$Chaine(p.oA))
				]),
			'Accès à « ' + (p.oA + ' »'));
	});
var $author$project$I18n$Cles$droitsReglerParticulier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.regler.particulier', _List_Nil, 'Droit particulier');
};
var $author$project$I18n$Cles$droitsReglerType = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.regler.type',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typeDeFiche',
					$author$project$I18n$Traductions$Chaine(p.ca))
				]),
			'Fiches « ' + (p.ca + ' »'));
	});
var $author$project$I18n$Cles$droitsRenommerAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.renommer.action', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$droitsRenommerTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.renommer.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Renommer « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$droitsRoleDupliquerUn = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.role.dupliquer-un', _List_Nil, 'Dupliquer un rôle');
};
var $author$project$Components$Parametrage$Droits$View$envoiEnCours = function (model) {
	return $author$project$API$Envoi$enCours(model.l2);
};
var $author$project$Components$Parametrage$Droits$Model$libelleDuChamp = F3(
	function (cle, champ, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			champ,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				A2(
					$elm$core$Maybe$andThen,
					function (r) {
						return $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (c) {
									return _Utils_eq(c.uN, champ);
								},
								r.dw));
					},
					A2($author$project$Components$Parametrage$Droits$Model$reglableDe, cle, model))));
	});
var $author$project$Components$Parametrage$Droits$Model$libelleDuType = F2(
	function (cle, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			cle,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				A2($author$project$Components$Parametrage$Droits$Model$reglableDe, cle, model)));
	});
var $author$project$Components$Parametrage$Droits$View$nomRegle = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.Dj;
			},
			$author$project$Components$Parametrage$Droits$Model$roleRegle(model)));
};
var $author$project$Components$Parametrage$Droits$Update$ReglageDemande = {$: 27};
var $author$project$I18n$Cles$droitsReglerAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.regler.action', _List_Nil, 'Enregistrer');
};
var $author$project$Components$Parametrage$Droits$View$reglageAction = F2(
	function (i18n, active) {
		return {
			sR: active,
			Bl: $author$project$I18n$Cles$droitsReglerAction(i18n),
			C$: $author$project$Components$Parametrage$Droits$Update$ReglageDemande
		};
	});
var $author$project$Components$Parametrage$Droits$Update$ChampChoisi = function (a) {
	return {$: 26, a: a};
};
var $author$project$I18n$Cles$droitsChampsNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.champs.note', _List_Nil, 'Un champ masqué n\'est jamais envoyé au navigateur, et son historique reste introuvable. Un champ ne peut être modifiable que si le rôle peut modifier le type.');
};
var $author$project$I18n$Cles$droitsChampsLecture = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.champs.lecture', _List_Nil, 'Lecture seule');
};
var $author$project$I18n$Cles$droitsChampsMasque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.champs.masque', _List_Nil, 'Masqué');
};
var $author$project$I18n$Cles$droitsChampsModification = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.champs.modification', _List_Nil, 'Modifiable');
};
var $author$project$Components$Parametrage$Droits$View$libelleDeLAccesDuChamp = F2(
	function (i18n, acces) {
		switch (acces) {
			case 0:
				return $author$project$I18n$Cles$droitsChampsMasque(i18n);
			case 1:
				return $author$project$I18n$Cles$droitsChampsLecture(i18n);
			default:
				return $author$project$I18n$Cles$droitsChampsModification(i18n);
		}
	});
var $author$project$Components$Parametrage$Droits$View$reglageDuChamp = F4(
	function (i18n, cle, champ, model) {
		var courant = A2(
			$elm$core$Maybe$map,
			function (droit) {
				return _Utils_Tuple2(
					droit,
					A2(
						$elm$core$Maybe$withDefault,
						0,
						A2($elm$core$Dict$get, champ, droit.dw)));
			},
			A2(
				$elm$core$Maybe$andThen,
				function (droits) {
					return A2($elm$core$Dict$get, cle, droits.ib);
				},
				model.uw));
		var modifiable = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (_v2) {
					var droit = _v2.a;
					return droit.ei;
				},
				courant));
		var vu = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (_v1) {
					var droit = _v1.a;
					return droit.KT;
				},
				courant));
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$fieldset,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$legend,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A3($author$project$Components$Parametrage$Droits$Model$libelleDuChamp, cle, champ, model))
									]))
							])),
					A2(
						$elm$core$List$map,
						function (acces) {
							return A6(
								$author$project$Components$Parametrage$Droits$View$choix,
								'champ-' + champ,
								((!(!acces)) && (!vu)) || ((acces === 2) && (!modifiable)),
								A2(
									$elm$core$Maybe$withDefault,
									false,
									A2(
										$elm$core$Maybe$map,
										function (_v0) {
											var actuel = _v0.b;
											return _Utils_eq(actuel, acces);
										},
										courant)),
								A2($author$project$Components$Parametrage$Droits$View$libelleDeLAccesDuChamp, i18n, acces),
								$elm$core$Maybe$Nothing,
								$author$project$Components$Parametrage$Droits$Update$ChampChoisi(acces));
						},
						_List_fromArray(
							[2, 1, 0])))),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$droitsChampsNote(i18n))
					])),
				A2($author$project$Components$Parametrage$Droits$View$refus, i18n, model)
			]);
	});
var $author$project$Components$Parametrage$Droits$Update$ModuleChoisi = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Parametrage$Droits$View$reglageDuModule = F3(
	function (i18n, cle, model) {
		var courant = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function (droits) {
					return A2($author$project$Components$Parametrage$Droits$View$accesDuModule, droits, cle);
				},
				model.uw));
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$fieldset,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$legend,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$Components$Parametrage$Droits$View$libelleDuModule, i18n, cle))
									]))
							])),
					A2(
						$elm$core$List$map,
						function (acces) {
							return A6(
								$author$project$Components$Parametrage$Droits$View$choix,
								'module-' + cle,
								false,
								_Utils_eq(acces, courant),
								A2($author$project$Components$Parametrage$Droits$View$libelleDeLAcces, i18n, acces),
								$elm$core$Maybe$Nothing,
								$author$project$Components$Parametrage$Droits$Update$ModuleChoisi(acces));
						},
						_List_fromArray(
							[0, 1, 2])))),
				A2($author$project$Components$Parametrage$Droits$View$refus, i18n, model)
			]);
	});
var $author$project$Components$Parametrage$Droits$Update$ParticulierChoisi = function (a) {
	return {$: 24, a: a};
};
var $author$project$I18n$Cles$droitsParticulierNon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.particulier.non', _List_Nil, 'Non');
};
var $author$project$I18n$Cles$droitsParticulierOui = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.particulier.oui', _List_Nil, 'Oui');
};
var $author$project$Components$Parametrage$Droits$View$reglageDuParticulier = F3(
	function (i18n, cle, model) {
		var donne = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.pa;
					},
					$elm$core$List$member(cle)),
				model.uw));
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$fieldset,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$legend,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$Components$Parametrage$Droits$View$libelleDuParticulier, i18n, cle))
									]))
							])),
						A6(
						$author$project$Components$Parametrage$Droits$View$choix,
						'particulier-' + cle,
						false,
						donne,
						$author$project$I18n$Cles$droitsParticulierOui(i18n),
						$elm$core$Maybe$Nothing,
						$author$project$Components$Parametrage$Droits$Update$ParticulierChoisi(true)),
						A6(
						$author$project$Components$Parametrage$Droits$View$choix,
						'particulier-' + cle,
						false,
						!donne,
						$author$project$I18n$Cles$droitsParticulierNon(i18n),
						$elm$core$Maybe$Nothing,
						$author$project$Components$Parametrage$Droits$Update$ParticulierChoisi(false))
					])),
				A2($author$project$Components$Parametrage$Droits$View$refus, i18n, model)
			]);
	});
var $author$project$Components$Parametrage$Droits$Update$TypeRegle = function (a) {
	return {$: 25, a: a};
};
var $author$project$I18n$Cles$droitsFichesCreer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.fiches.creer', _List_Nil, 'Créer');
};
var $author$project$I18n$Cles$droitsFichesFiches = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.fiches.fiches', _List_Nil, 'Fiches :');
};
var $author$project$I18n$Cles$droitsFichesModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.fiches.modifier', _List_Nil, 'Modifier');
};
var $author$project$I18n$Cles$droitsFichesNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.fiches.note', _List_Nil, '« Les siennes » : les fiches dont la personne est responsable. Les équipes viendront plus tard. Une fiche hors du périmètre ne se montre ni dans les listes, ni dans la recherche, ni par son adresse.');
};
var $author$project$I18n$Cles$droitsFichesSiennes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.fiches.siennes', _List_Nil, 'Les siennes');
};
var $author$project$I18n$Cles$droitsFichesToutes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.fiches.toutes', _List_Nil, 'Toutes');
};
var $author$project$I18n$Cles$droitsFichesVoit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.fiches.voit', _List_Nil, 'Voit');
};
var $author$project$Components$Parametrage$Droits$View$reglageDuType = F3(
	function (i18n, cle, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (droits) {
				return A2($elm$core$Dict$get, cle, droits.ib);
			},
			model.uw);
		if (_v0.$ === 1) {
			return _List_fromArray(
				[
					A2($author$project$Components$Parametrage$Droits$View$refus, i18n, model)
				]);
		} else {
			var droit = _v0.a;
			var regle = F4(
				function (voir, creer, modifier, perimetreVoulu) {
					return $author$project$Components$Parametrage$Droits$Update$TypeRegle(
						{dC: creer, ei: modifier, E9: perimetreVoulu, KT: voir});
				});
			var module_ = A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					function (droits) {
						return A2($author$project$Components$Parametrage$Droits$View$accesDuModule, droits, droit.oe);
					},
					model.uw));
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$fieldset,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$legend,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$Components$Parametrage$Droits$Model$libelleDuType, cle, model))
										]))
								])),
							A2(
							$author$project$Components$Shared$Champ$View$caseACocherInactivable,
							{
								go: $elm$core$Maybe$Nothing,
								Aq: $author$project$Components$Parametrage$Droits$View$idDuChamp('voir'),
								Bl: $author$project$I18n$Cles$droitsFichesVoit(i18n),
								he: false
							},
							{
								vt: droit.KT,
								d4: !module_,
								D9: function (voir) {
									return A4(regle, voir, droit.dC, droit.ei, droit.E9);
								}
							}),
							A2(
							$author$project$Components$Shared$Champ$View$caseACocherInactivable,
							{
								go: $elm$core$Maybe$Nothing,
								Aq: $author$project$Components$Parametrage$Droits$View$idDuChamp('creer'),
								Bl: $author$project$I18n$Cles$droitsFichesCreer(i18n),
								he: false
							},
							{
								vt: droit.dC,
								d4: module_ !== 2,
								D9: function (creer) {
									return A4(regle, true, creer, droit.ei, droit.E9);
								}
							}),
							A2(
							$author$project$Components$Shared$Champ$View$caseACocherInactivable,
							{
								go: $elm$core$Maybe$Nothing,
								Aq: $author$project$Components$Parametrage$Droits$View$idDuChamp('modifier'),
								Bl: $author$project$I18n$Cles$droitsFichesModifier(i18n),
								he: false
							},
							{
								vt: droit.ei,
								d4: module_ !== 2,
								D9: function (modifier) {
									return A4(regle, true, droit.dC, modifier, droit.E9);
								}
							})
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$fieldset,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$legend,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$droitsFichesFiches(i18n))
										]))
								])),
							A6(
							$author$project$Components$Parametrage$Droits$View$choix,
							'perimetre',
							!droit.KT,
							droit.E9 === 'Toutes',
							$author$project$I18n$Cles$droitsFichesToutes(i18n),
							$elm$core$Maybe$Nothing,
							A4(regle, droit.KT, droit.dC, droit.ei, 'Toutes')),
							A6(
							$author$project$Components$Parametrage$Droits$View$choix,
							'perimetre',
							!droit.KT,
							droit.E9 !== 'Toutes',
							$author$project$I18n$Cles$droitsFichesSiennes(i18n),
							$elm$core$Maybe$Nothing,
							A4(regle, droit.KT, droit.dC, droit.ei, 'Siennes'))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$droitsFichesNote(i18n))
						])),
					A2($author$project$Components$Parametrage$Droits$View$refus, i18n, model)
				]);
		}
	});
var $author$project$I18n$Cles$droitsRenommerNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.renommer.nom', _List_Nil, 'Nom du rôle');
};
var $author$project$I18n$Cles$droitsRenommerNote = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.renommer.note',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? 'Le nouveau nom s\'applique tout de suite à la personne qui a ce rôle. Leurs droits ne changent pas.' : ('Le nouveau nom s\'applique tout de suite aux ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' personnes qui ont ce rôle. Leurs droits ne changent pas.')));
	});
var $author$project$Components$Parametrage$Droits$View$renommage = F2(
	function (i18n, model) {
		return _List_fromArray(
			[
				A4(
				$author$project$Components$Parametrage$Droits$View$champDeNom,
				i18n,
				model,
				$author$project$I18n$Cles$droitsRenommerNom(i18n),
				$elm$core$Maybe$Nothing),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$droitsRenommerNote,
							i18n,
							{
								w: A2(
									$elm$core$Maybe$withDefault,
									0,
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.Kf;
										},
										$author$project$Components$Parametrage$Droits$Model$roleRegle(model)))
							}))
					])),
				A2($author$project$Components$Parametrage$Droits$View$refusEnTete, i18n, model)
			]);
	});
var $author$project$Components$Parametrage$Droits$View$contenuDuDrawer = F2(
	function (i18n, model) {
		var vide = {
			fs: {
				sR: false,
				Bl: '',
				C$: $author$project$Components$Parametrage$Droits$Update$DuDrawer($author$project$Components$Shared$Drawer$Update$Fermer)
			},
			fZ: _List_Nil,
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: ''
		};
		var sansEnvoi = !$author$project$Components$Parametrage$Droits$View$envoiEnCours(model);
		var _v0 = model.mW;
		if (!_v0.$) {
			switch (_v0.a.$) {
				case 0:
					var _v1 = _v0.a;
					return _Utils_update(
						vide,
						{
							fs: {
								sR: sansEnvoi,
								Bl: $author$project$I18n$Cles$droitsCreerAction(i18n),
								C$: $author$project$Components$Parametrage$Droits$Update$CreationDemandee
							},
							fZ: A2($author$project$Components$Parametrage$Droits$View$creation, i18n, model),
							A6: $elm$core$Maybe$Just(
								$author$project$I18n$Cles$droitsCreerKicker(i18n)),
							h6: _Utils_eq(model.oa, $elm$core$Maybe$Nothing) ? $author$project$I18n$Cles$droitsCreerTitre(i18n) : $author$project$I18n$Cles$droitsRoleDupliquerUn(i18n)
						});
				case 1:
					var _v2 = _v0.a;
					return _Utils_update(
						vide,
						{
							fs: {
								sR: sansEnvoi,
								Bl: $author$project$I18n$Cles$droitsRenommerAction(i18n),
								C$: $author$project$Components$Parametrage$Droits$Update$RenommageDemande
							},
							fZ: A2($author$project$Components$Parametrage$Droits$View$renommage, i18n, model),
							h6: A2(
								$author$project$I18n$Cles$droitsRenommerTitre,
								i18n,
								{
									Dj: $author$project$Components$Parametrage$Droits$View$nomRegle(model)
								})
						});
				case 2:
					var _v3 = _v0.a;
					return _Utils_update(
						vide,
						{
							fs: {
								sR: sansEnvoi && (!_Utils_eq(model.jL, _List_Nil)),
								Bl: A2(
									$author$project$I18n$Cles$droitsAttribuerAction,
									i18n,
									{
										w: $elm$core$List$length(model.jL)
									}),
								C$: $author$project$Components$Parametrage$Droits$Update$AttributionDemandee
							},
							fZ: A2($author$project$Components$Parametrage$Droits$View$attribution, i18n, model),
							A6: $elm$core$Maybe$Just(
								A2(
									$author$project$I18n$Cles$droitsAttribuerKicker,
									i18n,
									{
										Dj: $author$project$Components$Parametrage$Droits$View$nomRegle(model)
									})),
							h6: $author$project$I18n$Cles$droitsAttribuerTitre(i18n)
						});
				case 3:
					var cle = _v0.a.a;
					return _Utils_update(
						vide,
						{
							fs: A2($author$project$Components$Parametrage$Droits$View$reglageAction, i18n, sansEnvoi),
							fZ: A3($author$project$Components$Parametrage$Droits$View$reglageDuModule, i18n, cle, model),
							h6: A2(
								$author$project$I18n$Cles$droitsReglerModule,
								i18n,
								{
									oA: A2($author$project$Components$Parametrage$Droits$View$libelleDuModule, i18n, cle)
								})
						});
				case 4:
					var cle = _v0.a.a;
					return _Utils_update(
						vide,
						{
							fs: A2($author$project$Components$Parametrage$Droits$View$reglageAction, i18n, sansEnvoi),
							fZ: A3($author$project$Components$Parametrage$Droits$View$reglageDuParticulier, i18n, cle, model),
							h6: $author$project$I18n$Cles$droitsReglerParticulier(i18n)
						});
				case 5:
					var cle = _v0.a.a;
					return _Utils_update(
						vide,
						{
							fs: A2($author$project$Components$Parametrage$Droits$View$reglageAction, i18n, sansEnvoi),
							fZ: A3($author$project$Components$Parametrage$Droits$View$reglageDuType, i18n, cle, model),
							h6: A2(
								$author$project$I18n$Cles$droitsReglerType,
								i18n,
								{
									ca: A2($author$project$Components$Parametrage$Droits$Model$libelleDuType, cle, model)
								})
						});
				default:
					var _v4 = _v0.a;
					var cle = _v4.a;
					var champ = _v4.b;
					return _Utils_update(
						vide,
						{
							fs: A2($author$project$Components$Parametrage$Droits$View$reglageAction, i18n, sansEnvoi),
							fZ: A4($author$project$Components$Parametrage$Droits$View$reglageDuChamp, i18n, cle, champ, model),
							h6: A2(
								$author$project$I18n$Cles$droitsReglerChamp,
								i18n,
								{
									uN: A3($author$project$Components$Parametrage$Droits$Model$libelleDuChamp, cle, champ, model)
								})
						});
			}
		} else {
			return vide;
		}
	});
var $author$project$Components$Parametrage$Droits$View$drawer = F2(
	function (i18n, model) {
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Parametrage$Droits$Update$DuDrawer,
			A2($author$project$Components$Parametrage$Droits$View$contenuDuDrawer, i18n, model),
			model.kX);
	});
var $author$project$I18n$Cles$droitsAccesRefuse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.acces-refuse', _List_Nil, 'Vous n\'avez pas accès à cet écran.');
};
var $author$project$I18n$Cles$droitsApercu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.apercu', _List_Nil, 'Aperçu des droits');
};
var $author$project$I18n$Cles$droitsDescription = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.description', _List_Nil, 'Six étapes, dans l\'ordre. Chaque réglage est enregistré tout de suite. À chacune, l\'aperçu de droite résume ce que voit le rôle réglé.');
};
var $author$project$I18n$Cles$droitsFil = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.fil', _List_Nil, 'Équipe et droits');
};
var $author$project$I18n$Cles$droitsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.titre', _List_Nil, 'Votre équipe et ses droits');
};
var $author$project$Components$Parametrage$Droits$Update$TypeChoisi = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Parametrage$Droits$Model$ReglageDuChamp = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Parametrage$Droits$Model$champsARegler = function (affiche) {
	return $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			function ($) {
				return $.en;
			},
			affiche.dw));
};
var $author$project$Components$Parametrage$Droits$Update$ReglageOuvert = function (a) {
	return {$: 22, a: a};
};
var $author$project$I18n$Cles$droitsChanger = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.changer', _List_Nil, 'Changer');
};
var $author$project$Components$Parametrage$Droits$Model$peutModifier = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				$elm$core$List$any(
					function (lien) {
						return lien.eP === 'fixer-les-droits';
					})),
			model.zo));
};
var $author$project$Components$Parametrage$Droits$View$changer = F3(
	function (i18n, model, reglageOuvert) {
		return $author$project$Components$Parametrage$Droits$Model$peutModifier(model) ? A3(
			$author$project$Components$Shared$Bouton$View$bouton,
			1,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Components$Parametrage$Droits$Update$ReglageOuvert(reglageOuvert))
				]),
			$author$project$I18n$Cles$droitsChanger(i18n)) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$Components$Parametrage$Droits$View$classeDeLAccesDuChamp = function (acces) {
	switch (acces) {
		case 0:
			return 'masque';
		case 1:
			return 'lecture';
		default:
			return 'modification';
	}
};
var $author$project$I18n$Cles$droitsChampsARegler = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.champs.a-regler',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champ récent est à régler.') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champs récents sont à régler.'));
	});
var $author$project$I18n$Cles$droitsChampsAReglerSuite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.champs.a-regler.suite', _List_Nil, 'Tant que vous ne les réglez pas, ils restent masqués pour ce rôle.');
};
var $author$project$I18n$Cles$droitsChampsAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.champs.aucun', _List_Nil, 'Aucun champ n\'est encore réglé pour ce type.');
};
var $author$project$I18n$Cles$droitsChampsPasVu = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.champs.pas-vu',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typeDeFiche',
					$author$project$I18n$Traductions$Chaine(p.ca))
				]),
			'« ' + (p.ca + ' » n\'est pas vu par ce rôle : tous ses champs sont masqués d\'office.'));
	});
var $author$project$I18n$Cles$droitsChampsPersonnel = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.champs.personnel', _List_Nil, 'donnée personnelle');
};
var $author$project$I18n$Cles$droitsChampsStandard = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.champs.standard', _List_Nil, 'champ standard');
};
var $author$project$Components$Parametrage$Droits$View$champsDuType = F3(
	function (i18n, model, affiche) {
		var recents = $author$project$Components$Parametrage$Droits$Model$champsARegler(affiche);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('champs-du-type')
				]),
			_Utils_ap(
				affiche.xP.KT ? _List_Nil : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$droitsChampsPasVu,
									i18n,
									{ca: affiche.Bl}))
							]))
					]),
				_List_fromArray(
					[
						$elm$core$List$isEmpty(affiche.dw) ? A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$droitsChampsAucun(i18n))
							])) : A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('liste-des-champs')
							]),
						A2(
							$elm$core$List$map,
							function (champ) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('champ')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(champ.Bl)
														])),
													champ.Fe ? A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('nature'),
															$rtfeldman$elm_css$Html$Styled$Attributes$class('perso')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$droitsChampsPersonnel(i18n))
														])) : (champ.IZ ? A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('nature')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$droitsChampsStandard(i18n))
														])) : $rtfeldman$elm_css$Html$Styled$text(''))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('etat'),
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															$author$project$Components$Parametrage$Droits$View$classeDeLAccesDuChamp(champ.ce))
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															A2($author$project$Components$Parametrage$Droits$View$libelleDeLAccesDuChamp, i18n, champ.ce))
														])),
													A3(
													$author$project$Components$Parametrage$Droits$View$changer,
													i18n,
													model,
													A2($author$project$Components$Parametrage$Droits$Model$ReglageDuChamp, affiche.dy, champ.dy))
												]))
										]));
							},
							affiche.dw)),
						(recents > 0) ? A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('a-regler')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$droitsChampsARegler,
											i18n,
											{w: recents}))
									])),
								$rtfeldman$elm_css$Html$Styled$text(
								' ' + $author$project$I18n$Cles$droitsChampsAReglerSuite(i18n))
							])) : $rtfeldman$elm_css$Html$Styled$text('')
					])));
	});
var $author$project$I18n$Cles$droitsChampsType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.champs.type', _List_Nil, 'Type de partie prenante');
};
var $author$project$I18n$Cles$droitsRoleSystemeNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.role.systeme-note', _List_Nil, 'rôle fourni, tous les droits, pas modifiable');
};
var $author$project$Components$Parametrage$Droits$View$champs = F2(
	function (i18n, model) {
		var _v0 = model.zo;
		if (_v0.$ === 1) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var fiche = _v0.a;
			var types = $author$project$Components$Parametrage$Droits$Model$typesAffiches(fiche);
			var choisi = A2($author$project$Components$Parametrage$Droits$View$typeChoisi, model, types);
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('champs')
					]),
				fiche.xS.rM ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$droitsRoleSystemeNote(i18n))
							]))
					]) : _List_fromArray(
					[
						$author$project$Components$Parametrage$Droits$View$h3Titre(
						$author$project$I18n$Cles$droitsChampsType(i18n)),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('pastilles')
							]),
						A2(
							$elm$core$List$map,
							function (affiche) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_Nil,
									_List_fromArray(
										[
											A3(
											$author$project$Components$Shared$Bouton$View$bouton,
											1,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Events$onClick(
													$author$project$Components$Parametrage$Droits$Update$TypeChoisi(affiche.dy)),
													$rtfeldman$elm_css$Html$Styled$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'active',
															_Utils_eq(
																$elm$core$Maybe$Just(affiche.dy),
																A2(
																	$elm$core$Maybe$map,
																	function ($) {
																		return $.dy;
																	},
																	choisi)))
														]))
												]),
											affiche.Bl)
										]));
							},
							types)),
						function () {
						if (!choisi.$) {
							var affiche = choisi.a;
							return A3($author$project$Components$Parametrage$Droits$View$champsDuType, i18n, model, affiche);
						} else {
							return A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$droitsChampsAucun(i18n))
									]));
						}
					}(),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$droitsChampsNote(i18n))
							]))
					]));
		}
	});
var $author$project$I18n$Cles$droitsEtapeChampsExplicationDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.champs.explication.debut', _List_Nil, 'Pour chaque champ, trois choix : ');
};
var $author$project$I18n$Cles$droitsEtapeChampsExplicationFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.champs.explication.fin', _List_Nil, '.');
};
var $author$project$I18n$Cles$droitsEtapeChampsExplicationFort1 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.champs.explication.fort-1', _List_Nil, 'Modifiable');
};
var $author$project$I18n$Cles$droitsEtapeChampsExplicationFort2 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.champs.explication.fort-2', _List_Nil, 'Lecture seule');
};
var $author$project$I18n$Cles$droitsEtapeChampsExplicationFort3 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.champs.explication.fort-3', _List_Nil, 'Masqué');
};
var $author$project$I18n$Cles$droitsEtapeChampsExplicationMilieu1 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.champs.explication.milieu-1', _List_Nil, ', ');
};
var $author$project$I18n$Cles$droitsEtapeChampsExplicationMilieu2 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.champs.explication.milieu-2', _List_Nil, ' ou ');
};
var $author$project$I18n$Cles$droitsEtapeFichesExplicationDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.fiches.explication.debut', _List_Nil, 'Pour chaque type de partie prenante, dites si le rôle le voit, puis lesquelles : ');
};
var $author$project$I18n$Cles$droitsEtapeFichesExplicationFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.fiches.explication.fin', _List_Nil, '.');
};
var $author$project$I18n$Cles$droitsEtapeFichesExplicationFort1 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.fiches.explication.fort-1', _List_Nil, 'toutes');
};
var $author$project$I18n$Cles$droitsEtapeFichesExplicationFort2 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.fiches.explication.fort-2', _List_Nil, 'seulement les siennes');
};
var $author$project$I18n$Cles$droitsEtapeFichesExplicationMilieu1 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.fiches.explication.milieu-1', _List_Nil, ', ou ');
};
var $author$project$I18n$Cles$droitsEtapeModulesExplicationDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.modules.explication.debut', _List_Nil, 'Pour chaque partie de l\'application, choisissez : ');
};
var $author$project$I18n$Cles$droitsEtapeModulesExplicationFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.modules.explication.fin', _List_Nil, '.');
};
var $author$project$I18n$Cles$droitsEtapeModulesExplicationFort1 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.modules.explication.fort-1', _List_Nil, 'Aucun');
};
var $author$project$I18n$Cles$droitsEtapeModulesExplicationFort2 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.modules.explication.fort-2', _List_Nil, 'Lecture');
};
var $author$project$I18n$Cles$droitsEtapeModulesExplicationFort3 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.modules.explication.fort-3', _List_Nil, 'Modification');
};
var $author$project$I18n$Cles$droitsEtapeModulesExplicationMilieu1 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.modules.explication.milieu-1', _List_Nil, ' accès, ');
};
var $author$project$I18n$Cles$droitsEtapeModulesExplicationMilieu2 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.modules.explication.milieu-2', _List_Nil, ' ou ');
};
var $author$project$I18n$Cles$droitsEtapePersonnesExplication = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.etape.personnes.explication',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? 'Une personne a ce rôle. Une personne peut avoir plusieurs rôles : elle cumule alors leurs droits, et le plus large l\'emporte.' : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' personnes ont ce rôle. Une personne peut avoir plusieurs rôles : elle cumule alors leurs droits, et le plus large l\'emporte.'));
	});
var $author$project$I18n$Cles$droitsEtapeRolesExplicationDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.roles.explication.debut', _List_Nil, 'Un ');
};
var $author$project$I18n$Cles$droitsEtapeRolesExplicationFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.roles.explication.fin', _List_Nil, ' regroupe des droits. Chaque personne de votre équipe en a un ou plusieurs. Un nouveau rôle ne permet rien tant que vous n\'avez rien réglé.');
};
var $author$project$I18n$Cles$droitsEtapeRolesExplicationMot = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.roles.explication.mot', _List_Nil, 'rôle');
};
var $author$project$I18n$Cles$droitsEtapeVerificationExplicationDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.verification.explication.debut', _List_Nil, 'Vous regardez l\'application comme ce rôle, ');
};
var $author$project$I18n$Cles$droitsEtapeVerificationExplicationFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.verification.explication.fin', _List_Nil, ' : rien ne peut être modifié. Si quelque chose ne va pas, revenez à l\'étape concernée.');
};
var $author$project$I18n$Cles$droitsEtapeVerificationExplicationFort1 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.verification.explication.fort-1', _List_Nil, 'en lecture seule');
};
var $author$project$Components$Parametrage$Droits$Parcours$explication = F3(
	function (i18n, nombre, etape) {
		switch (etape) {
			case 0:
				return _List_fromArray(
					[
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$droitsEtapeRolesExplicationDebut(i18n)),
						$author$project$Components$Shared$Parcours$Model$Fort(
						$author$project$I18n$Cles$droitsEtapeRolesExplicationMot(i18n)),
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$droitsEtapeRolesExplicationFin(i18n))
					]);
			case 1:
				return _List_fromArray(
					[
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$droitsEtapeModulesExplicationDebut(i18n)),
						$author$project$Components$Shared$Parcours$Model$Fort(
						$author$project$I18n$Cles$droitsEtapeModulesExplicationFort1(i18n)),
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$droitsEtapeModulesExplicationMilieu1(i18n)),
						$author$project$Components$Shared$Parcours$Model$Fort(
						$author$project$I18n$Cles$droitsEtapeModulesExplicationFort2(i18n)),
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$droitsEtapeModulesExplicationMilieu2(i18n)),
						$author$project$Components$Shared$Parcours$Model$Fort(
						$author$project$I18n$Cles$droitsEtapeModulesExplicationFort3(i18n)),
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$droitsEtapeModulesExplicationFin(i18n))
					]);
			case 2:
				return _List_fromArray(
					[
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$droitsEtapeFichesExplicationDebut(i18n)),
						$author$project$Components$Shared$Parcours$Model$Fort(
						$author$project$I18n$Cles$droitsEtapeFichesExplicationFort1(i18n)),
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$droitsEtapeFichesExplicationMilieu1(i18n)),
						$author$project$Components$Shared$Parcours$Model$Fort(
						$author$project$I18n$Cles$droitsEtapeFichesExplicationFort2(i18n)),
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$droitsEtapeFichesExplicationFin(i18n))
					]);
			case 3:
				return _List_fromArray(
					[
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$droitsEtapeChampsExplicationDebut(i18n)),
						$author$project$Components$Shared$Parcours$Model$Fort(
						$author$project$I18n$Cles$droitsEtapeChampsExplicationFort1(i18n)),
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$droitsEtapeChampsExplicationMilieu1(i18n)),
						$author$project$Components$Shared$Parcours$Model$Fort(
						$author$project$I18n$Cles$droitsEtapeChampsExplicationFort2(i18n)),
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$droitsEtapeChampsExplicationMilieu2(i18n)),
						$author$project$Components$Shared$Parcours$Model$Fort(
						$author$project$I18n$Cles$droitsEtapeChampsExplicationFort3(i18n)),
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$droitsEtapeChampsExplicationFin(i18n))
					]);
			case 4:
				return _List_fromArray(
					[
						$author$project$Components$Shared$Parcours$Model$Texte(
						A2(
							$author$project$I18n$Cles$droitsEtapePersonnesExplication,
							i18n,
							{w: nombre}))
					]);
			default:
				return _List_fromArray(
					[
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$droitsEtapeVerificationExplicationDebut(i18n)),
						$author$project$Components$Shared$Parcours$Model$Fort(
						$author$project$I18n$Cles$droitsEtapeVerificationExplicationFort1(i18n)),
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$droitsEtapeVerificationExplicationFin(i18n))
					]);
		}
	});
var $author$project$Components$Parametrage$Droits$Model$ReglageDuType = function (a) {
	return {$: 5, a: a};
};
var $author$project$I18n$Cles$droitsFichesVerraAucuneDebut = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.fiches.verra.aucune.debut',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typeDeFiche',
					$author$project$I18n$Traductions$Chaine(p.ca))
				]),
			'Une fiche « ' + (p.ca + ' » : '));
	});
var $author$project$I18n$Cles$droitsFichesVerraCollegueDebut = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.fiches.verra.collegue.debut',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typeDeFiche',
					$author$project$I18n$Traductions$Chaine(p.ca))
				]),
			'Une fiche « ' + (p.ca + ' » d\'un collègue : '));
	});
var $author$project$I18n$Cles$droitsFichesVerraCollegueFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.fiches.verra.collegue.fin', _List_Nil, ', comme si elle n\'existait pas.');
};
var $author$project$I18n$Cles$droitsFichesVerraIntrouvable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.fiches.verra.introuvable', _List_Nil, '« Fiche introuvable »');
};
var $author$project$I18n$Cles$droitsFichesVerraPoint = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.fiches.verra.point', _List_Nil, '.');
};
var $author$project$I18n$Cles$droitsFichesVerraSiennesDebut = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.fiches.verra.siennes.debut',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typeDeFiche',
					$author$project$I18n$Traductions$Chaine(p.ca))
				]),
			'Une fiche « ' + (p.ca + ' » dont elle est responsable : '));
	});
var $author$project$I18n$Cles$droitsFichesVerraTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.fiches.verra.titre', _List_Nil, 'Ce qu\'une personne de ce rôle verra');
};
var $author$project$I18n$Cles$droitsFichesVerraToutesDebut = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.fiches.verra.toutes.debut',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typeDeFiche',
					$author$project$I18n$Traductions$Chaine(p.ca))
				]),
			'Une fiche « ' + (p.ca + ' » : '));
	});
var $author$project$I18n$Cles$droitsFichesVerraToutesFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.fiches.verra.toutes.fin', _List_Nil, ', quel que soit son responsable.');
};
var $author$project$I18n$Cles$droitsFichesVerraVisible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.fiches.verra.visible', _List_Nil, 'visible');
};
var $author$project$Components$Parametrage$Droits$View$ceQueVerra = F2(
	function (i18n, types) {
		var phrase = F3(
			function (debut, fort, fin) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(debut),
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(fort)
								])),
							$rtfeldman$elm_css$Html$Styled$text(fin)
						]));
			});
		var phrases = function (affiche) {
			var nom = {ca: affiche.Bl};
			return (!affiche.xP.KT) ? _List_fromArray(
				[
					A3(
					phrase,
					A2($author$project$I18n$Cles$droitsFichesVerraAucuneDebut, i18n, nom),
					$author$project$I18n$Cles$droitsFichesVerraIntrouvable(i18n),
					$author$project$I18n$Cles$droitsFichesVerraPoint(i18n))
				]) : ((affiche.xP.E9 === 'Toutes') ? _List_fromArray(
				[
					A3(
					phrase,
					A2($author$project$I18n$Cles$droitsFichesVerraToutesDebut, i18n, nom),
					$author$project$I18n$Cles$droitsFichesVerraVisible(i18n),
					$author$project$I18n$Cles$droitsFichesVerraToutesFin(i18n))
				]) : _List_fromArray(
				[
					A3(
					phrase,
					A2($author$project$I18n$Cles$droitsFichesVerraSiennesDebut, i18n, nom),
					$author$project$I18n$Cles$droitsFichesVerraVisible(i18n),
					$author$project$I18n$Cles$droitsFichesVerraPoint(i18n)),
					A3(
					phrase,
					A2($author$project$I18n$Cles$droitsFichesVerraCollegueDebut, i18n, nom),
					$author$project$I18n$Cles$droitsFichesVerraIntrouvable(i18n),
					$author$project$I18n$Cles$droitsFichesVerraCollegueFin(i18n))
				]));
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ce-que-verra')
				]),
			_List_fromArray(
				[
					$author$project$Components$Parametrage$Droits$View$h3Titre(
					$author$project$I18n$Cles$droitsFichesVerraTitre(i18n)),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_Nil,
					A2($elm$core$List$concatMap, phrases, types))
				]));
	});
var $author$project$I18n$Cles$droitsFichesAucunType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.fiches.aucun-type', _List_Nil, 'Aucun type n\'est encore réglé pour ce rôle.');
};
var $author$project$I18n$Cles$droitsFichesNeVoitPas = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.fiches.ne-voit-pas', _List_Nil, 'Ne voit pas');
};
var $author$project$Components$Parametrage$Droits$View$perimetre = F2(
	function (i18n, droit) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('perimetre')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$droitsFichesFiches(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('niveaux')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('courant', droit.E9 === 'Toutes')
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$droitsFichesToutes(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('courant', droit.E9 !== 'Toutes')
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$droitsFichesSiennes(i18n))
								]))
						]))
				]));
	});
var $author$project$Components$Parametrage$Droits$View$fiches = F2(
	function (i18n, model) {
		var _v0 = model.zo;
		if (_v0.$ === 1) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var fiche = _v0.a;
			var types = $author$project$Components$Parametrage$Droits$Model$typesAffiches(fiche);
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('fiches')
					]),
				_List_fromArray(
					[
						fiche.xS.rM ? A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$droitsRoleSystemeNote(i18n))
							])) : ($elm$core$List$isEmpty(types) ? A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$droitsFichesAucunType(i18n))
							])) : A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('liste-des-types')
							]),
						A2(
							$elm$core$List$map,
							function (affiche) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('type'),
											$rtfeldman$elm_css$Html$Styled$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('pas-vu', !affiche.xP.KT)
												]))
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(affiche.Bl)
														]))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
												]),
											_Utils_ap(
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('voit')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																affiche.xP.KT ? $author$project$I18n$Cles$droitsFichesVoit(i18n) : $author$project$I18n$Cles$droitsFichesNeVoitPas(i18n))
															]))
													]),
												_Utils_ap(
													affiche.xP.KT ? _List_fromArray(
														[
															A2($author$project$Components$Parametrage$Droits$View$perimetre, i18n, affiche.xP)
														]) : _List_Nil,
													_List_fromArray(
														[
															A3(
															$author$project$Components$Parametrage$Droits$View$changer,
															i18n,
															model,
															$author$project$Components$Parametrage$Droits$Model$ReglageDuType(affiche.dy))
														]))))
										]));
							},
							types))),
						A2($author$project$Components$Parametrage$Droits$View$ceQueVerra, i18n, types),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$droitsFichesNote(i18n))
							]))
					]));
		}
	});
var $author$project$Components$Parametrage$Droits$Model$ReglageDuModule = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$Droits$Model$ReglageDuParticulier = function (a) {
	return {$: 4, a: a};
};
var $author$project$I18n$Cles$droitsModuleDossiersEtPipesDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.module.dossiers-et-pipes.detail', _List_Nil, 'Les dossiers suivis dans vos pipes');
};
var $author$project$I18n$Cles$droitsModuleParametrageDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.module.parametrage.detail', _List_Nil, 'Types, champs, rôles et droits…');
};
var $author$project$I18n$Cles$droitsModulePartiesPrenantesDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.module.parties-prenantes.detail', _List_Nil, 'Fiches des personnes et organisations');
};
var $author$project$I18n$Cles$droitsModuleProduitsDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.module.produits.detail', _List_Nil, 'Catalogue et fiches produits');
};
var $author$project$Components$Parametrage$Droits$View$detailDuModule = F2(
	function (i18n, cle) {
		switch (cle) {
			case 'PartiesPrenantes':
				return $author$project$I18n$Cles$droitsModulePartiesPrenantesDetail(i18n);
			case 'Produits':
				return $author$project$I18n$Cles$droitsModuleProduitsDetail(i18n);
			case 'Parametrage':
				return $author$project$I18n$Cles$droitsModuleParametrageDetail(i18n);
			case 'DossiersEtPipes':
				return $author$project$I18n$Cles$droitsModuleDossiersEtPipesDetail(i18n);
			default:
				var autre = cle;
				return autre;
		}
	});
var $author$project$I18n$Cles$droitsModuleSansEffet = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.module.sans-effet', _List_Nil, 'Réglable dès maintenant, mais sans effet tant que les dossiers n\'existent pas.');
};
var $author$project$I18n$Cles$droitsModulesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.modules.titre', _List_Nil, 'Les quatre modules');
};
var $author$project$I18n$Cles$droitsParticuliersNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.particuliers.note', _List_Nil, 'Un droit particulier s\'ajoute au module. Il n\'est jamais donné par défaut. Pour les régler, appuyez sur « Changer » : un volet s\'ouvre à droite.');
};
var $author$project$I18n$Cles$droitsParticuliersTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.particuliers.titre', _List_Nil, 'Droits particuliers');
};
var $author$project$Components$Parametrage$Droits$View$niveaux = F2(
	function (i18n, courant) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$ul,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('niveaux')
				]),
			A2(
				$elm$core$List$map,
				function (acces) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'courant',
										_Utils_eq(acces, courant))
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$Components$Parametrage$Droits$View$libelleDeLAcces, i18n, acces))
							]));
				},
				_List_fromArray(
					[0, 1, 2])));
	});
var $author$project$Components$Parametrage$Droits$Model$particuliersReglables = _List_fromArray(
	['ReferentRgpd', 'Comptable', 'GererLesGroupes', 'FusionnerToutesLesFiches', 'ConcevoirLesPipes', 'EnrichirLesListesDuCatalogue', 'EnrichirLesListesDesPartiesPrenantes']);
var $author$project$Components$Parametrage$Droits$View$modules = F2(
	function (i18n, model) {
		var _v0 = model.zo;
		if (_v0.$ === 1) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var fiche = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('modules')
					]),
				_List_fromArray(
					[
						$author$project$Components$Parametrage$Droits$View$h3Titre(
						$author$project$I18n$Cles$droitsModulesTitre(i18n)),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('liste-des-modules')
							]),
						A2(
							$elm$core$List$map,
							function (cle) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('module')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															A2($author$project$Components$Parametrage$Droits$View$libelleDuModule, i18n, cle))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															A2($author$project$Components$Parametrage$Droits$View$detailDuModule, i18n, cle))
														]))
												])),
											A2(
											$author$project$Components$Parametrage$Droits$View$niveaux,
											i18n,
											A2($author$project$Components$Parametrage$Droits$View$accesDuModule, fiche.xS, cle)),
											A3(
											$author$project$Components$Parametrage$Droits$View$changer,
											i18n,
											model,
											$author$project$Components$Parametrage$Droits$Model$ReglageDuModule(cle))
										]));
							},
							$author$project$Components$Parametrage$Droits$Model$modulesReglables)),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$droitsModuleSansEffet(i18n))
							])),
						$author$project$Components$Parametrage$Droits$View$h3Titre(
						$author$project$I18n$Cles$droitsParticuliersTitre(i18n)),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('liste-des-particuliers')
							]),
						A2(
							$elm$core$List$map,
							function (cle) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('particulier')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2($author$project$Components$Parametrage$Droits$View$libelleDuParticulier, i18n, cle))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('etat')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2($elm$core$List$member, cle, fiche.xS.pa) ? $author$project$I18n$Cles$droitsParticulierOui(i18n) : $author$project$I18n$Cles$droitsParticulierNon(i18n))
												])),
											A3(
											$author$project$Components$Parametrage$Droits$View$changer,
											i18n,
											model,
											$author$project$Components$Parametrage$Droits$Model$ReglageDuParticulier(cle))
										]));
							},
							$author$project$Components$Parametrage$Droits$Model$particuliersReglables)),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$droitsParticuliersNote(i18n))
							]))
					]));
		}
	});
var $author$project$Components$Parametrage$Droits$View$nomDuRole = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.Dj;
		},
		model.zo);
};
var $author$project$Components$Parametrage$Droits$View$nombreDePersonnes = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Fg;
				},
				$elm$core$List$length),
			model.zo));
};
var $author$project$Components$Parametrage$Droits$Update$EtapeDemandeeAuPied = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Parametrage$Droits$Model$remplie = F2(
	function (model, etape) {
		switch (etape) {
			case 0:
				return !_Utils_eq(model.aS, $elm$core$Maybe$Nothing);
			case 5:
				return !_Utils_eq(model.tq, $elm$core$Maybe$Nothing);
			default:
				return !_Utils_eq(model.zo, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$I18n$Cles$droitsEtapeChampsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.champs.titre', _List_Nil, 'Quels champs il voit');
};
var $author$project$I18n$Cles$droitsEtapeFichesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.fiches.titre', _List_Nil, 'Quelles fiches il voit');
};
var $author$project$I18n$Cles$droitsEtapeModulesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.modules.titre', _List_Nil, 'Ce que chaque rôle peut faire');
};
var $author$project$I18n$Cles$droitsEtapePersonnesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.personnes.titre', _List_Nil, 'Qui a ce rôle');
};
var $author$project$I18n$Cles$droitsEtapeRolesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.roles.titre', _List_Nil, 'Vos rôles');
};
var $author$project$I18n$Cles$droitsEtapeVerificationTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.verification.titre', _List_Nil, 'Vérifiez : voir comme');
};
var $author$project$Components$Parametrage$Droits$Parcours$titre = F2(
	function (i18n, etape) {
		switch (etape) {
			case 0:
				return $author$project$I18n$Cles$droitsEtapeRolesTitre(i18n);
			case 1:
				return $author$project$I18n$Cles$droitsEtapeModulesTitre(i18n);
			case 2:
				return $author$project$I18n$Cles$droitsEtapeFichesTitre(i18n);
			case 3:
				return $author$project$I18n$Cles$droitsEtapeChampsTitre(i18n);
			case 4:
				return $author$project$I18n$Cles$droitsEtapePersonnesTitre(i18n);
			default:
				return $author$project$I18n$Cles$droitsEtapeVerificationTitre(i18n);
		}
	});
var $author$project$Components$Parametrage$Droits$View$parcours = F2(
	function (i18n, model) {
		return {
			aa: A2($elm$core$Basics$composeR, $author$project$Routes$Route$Droits, $author$project$Routes$Route$toString),
			tX: $author$project$Components$Parametrage$Droits$Update$EtapeDemandeeAuPied,
			yL: $author$project$Routes$Route$etapesDesDroits,
			Dj: $author$project$Components$Parametrage$Droits$Parcours$nom,
			qm: $author$project$Components$Parametrage$Droits$Model$remplie(model),
			h6: $author$project$Components$Parametrage$Droits$Parcours$titre(i18n)
		};
	});
var $author$project$Components$Parametrage$Droits$Update$AttributionOuverte = {$: 17};
var $author$project$I18n$Cles$droitsPersonnesAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.personnes.ajouter', _List_Nil, 'Ajouter quelqu\'un à ce rôle');
};
var $author$project$I18n$Cles$droitsPersonnesAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.personnes.aucune', _List_Nil, 'Personne n\'a encore ce rôle.');
};
var $author$project$I18n$Cles$droitsPersonnesNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.personnes.note', _List_Nil, 'Pour « Administrateur », on ne peut pas retirer le dernier : le bouton « Retirer du rôle » est alors grisé, avec la raison.');
};
var $author$project$Components$Parametrage$Droits$Update$RetraitDemande = function (a) {
	return {$: 21, a: a};
};
var $author$project$I18n$Cles$droitsPersonnesInconnu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.personnes.inconnu', _List_Nil, 'Compte inconnu');
};
var $author$project$I18n$Cles$droitsPersonnesRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.personnes.retirer', _List_Nil, 'Retirer du rôle');
};
var $author$project$I18n$Cles$droitsPersonnesRetirerDernier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.personnes.retirer.dernier', _List_Nil, 'Il doit toujours rester au moins un administrateur');
};
var $author$project$Components$Parametrage$Droits$View$unePersonne = F4(
	function (i18n, retirable, dernier, personne) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('personne'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('inconnue', personne.vY)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									personne.vY ? $author$project$I18n$Cles$droitsPersonnesInconnu(i18n) : A2(
										$elm$core$Maybe$withDefault,
										$author$project$I18n$Cles$droitsPersonnesSansNom(i18n),
										personne.Dj))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$Maybe$withDefault, '', personne.kh))
								]))
						])),
					retirable ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_Utils_ap(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Parametrage$Droits$Update$RetraitDemande(personne.r8))
									]),
								dernier ? _List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-disabled', 'true'),
										$rtfeldman$elm_css$Html$Styled$Attributes$title(
										$author$project$I18n$Cles$droitsPersonnesRetirerDernier(i18n))
									]) : _List_Nil),
							$author$project$I18n$Cles$droitsPersonnesRetirer(i18n))
						])) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$Components$Parametrage$Droits$View$personnes = F2(
	function (i18n, model) {
		var _v0 = model.zo;
		if (_v0.$ === 1) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var fiche = _v0.a;
			var retirable = !_Utils_eq(
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerUnRole, fiche.nQ),
				$elm$core$Maybe$Nothing);
			var dernier = fiche.rv && ($elm$core$List$length(fiche.Fg) <= 1);
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('personnes')
					]),
				_List_fromArray(
					[
						$elm$core$List$isEmpty(fiche.Fg) ? A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$droitsPersonnesAucune(i18n))
							])) : A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('liste-des-personnes')
							]),
						A2(
							$elm$core$List$map,
							A3($author$project$Components$Parametrage$Droits$View$unePersonne, i18n, retirable, dernier),
							fiche.Fg)),
						(!_Utils_eq(
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$membresDuClient, fiche.nQ),
						$elm$core$Maybe$Nothing)) ? A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('ajouter')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$Droits$Update$AttributionOuverte)
									]),
								$author$project$I18n$Cles$droitsPersonnesAjouter(i18n))
							])) : $rtfeldman$elm_css$Html$Styled$text(''),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$droitsPersonnesNote(i18n))
							]))
					]));
		}
	});
var $author$project$I18n$Cles$droitsEtapeChampsQuestion = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.etape.champs.question',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Quels champs voit « ' + (p.bi + ' » ?'));
	});
var $author$project$I18n$Cles$droitsEtapeFichesQuestion = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.etape.fiches.question',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Quelles fiches voit « ' + (p.bi + ' » ?'));
	});
var $author$project$I18n$Cles$droitsEtapeModulesQuestion = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.etape.modules.question',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Que peut faire « ' + (p.bi + ' » ?'));
	});
var $author$project$I18n$Cles$droitsEtapePersonnesQuestion = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.etape.personnes.question',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Qui a le rôle « ' + (p.bi + ' » ?'));
	});
var $author$project$I18n$Cles$droitsEtapeRolesQuestion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.roles.question', _List_Nil, 'Quels rôles avez-vous ?');
};
var $author$project$I18n$Cles$droitsEtapeVerificationQuestion = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.etape.verification.question',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Voyez ce que voit « ' + (p.bi + ' »'));
	});
var $author$project$I18n$Cles$droitsEtapeVerificationQuestionSansRole = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.etape.verification.question-sans-role', _List_Nil, 'Voyez ce que voit un rôle');
};
var $author$project$Components$Parametrage$Droits$Parcours$question = F3(
	function (i18n, regle, etape) {
		var du = function (role) {
			return A2($elm$core$Maybe$withDefault, '', role);
		};
		switch (etape) {
			case 0:
				return $author$project$I18n$Cles$droitsEtapeRolesQuestion(i18n);
			case 1:
				return A2(
					$author$project$I18n$Cles$droitsEtapeModulesQuestion,
					i18n,
					{
						bi: du(regle)
					});
			case 2:
				return A2(
					$author$project$I18n$Cles$droitsEtapeFichesQuestion,
					i18n,
					{
						bi: du(regle)
					});
			case 3:
				return A2(
					$author$project$I18n$Cles$droitsEtapeChampsQuestion,
					i18n,
					{
						bi: du(regle)
					});
			case 4:
				return A2(
					$author$project$I18n$Cles$droitsEtapePersonnesQuestion,
					i18n,
					{
						bi: du(regle)
					});
			default:
				if (!regle.$) {
					var role = regle.a;
					return A2(
						$author$project$I18n$Cles$droitsEtapeVerificationQuestion,
						i18n,
						{bi: role});
				} else {
					return $author$project$I18n$Cles$droitsEtapeVerificationQuestionSansRole(i18n);
				}
		}
	});
var $author$project$Components$Parametrage$Droits$Update$RoleChoisi = function (a) {
	return {$: 4, a: a};
};
var $author$project$I18n$Cles$droitsRegle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.regle', _List_Nil, 'Vous réglez le rôle');
};
var $author$project$Components$Parametrage$Droits$View$choixDuRole = F3(
	function (i18n, model, auChoix) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('choix-du-role')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$droitsRegle(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('pastilles')
						]),
					A2(
						$elm$core$List$map,
						function (role) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A3(
										$author$project$Components$Shared$Bouton$View$bouton,
										1,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												auChoix(role.Aq)),
												$rtfeldman$elm_css$Html$Styled$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'active',
														_Utils_eq(
															model.hH,
															$elm$core$Maybe$Just(role.Aq)))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
												'aria-pressed',
												_Utils_eq(
													model.hH,
													$elm$core$Maybe$Just(role.Aq)) ? 'true' : 'false')
											]),
										role.Dj)
									]));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.eX;
								},
								model.aS))))
				]));
	});
var $author$project$I18n$Cles$droitsChargement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.chargement', _List_Nil, 'Les rôles se chargent.');
};
var $author$project$Components$Parametrage$Droits$View$reglage = F3(
	function (i18n, model, contenu) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('reglage')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					_List_fromArray(
						[
							A3($author$project$Components$Parametrage$Droits$View$choixDuRole, i18n, model, $author$project$Components$Parametrage$Droits$Update$RoleChoisi),
							_Utils_eq(model.zo, $elm$core$Maybe$Nothing) ? A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('chargement')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$droitsChargement(i18n))
								])) : contenu
						]))
				]));
	});
var $author$project$Components$Parametrage$Droits$Update$RoleChoisiPourLApercu = function (a) {
	return {$: 5, a: a};
};
var $author$project$I18n$Cles$droitsVoirCommeBandeauDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.voir-comme.bandeau.debut', _List_Nil, 'Aperçu');
};
var $author$project$I18n$Cles$droitsVoirCommeBandeauFin = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.voir-comme.bandeau.fin',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			' · vous voyez comme « ' + (p.bi + ' »'));
	});
var $author$project$I18n$Cles$droitsVoirCommeQuitter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.voir-comme.quitter', _List_Nil, 'Quitter l\'aperçu');
};
var $author$project$Components$Parametrage$Droits$View$bandeauDApercu = F2(
	function (i18n, fiche) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('bandeau-apercu')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$droitsVoirCommeBandeauDebut(i18n))
								])),
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$droitsVoirCommeBandeauFin,
								i18n,
								{bi: fiche.Dj}))
						])),
					A3(
					$author$project$Components$Shared$Bouton$View$lien,
					1,
					$author$project$Routes$Route$toString(
						$author$project$Routes$Route$Droits(0)),
					$author$project$I18n$Cles$droitsVoirCommeQuitter(i18n))
				]));
	});
var $author$project$I18n$Cles$droitsVerificationChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.verification.choisir', _List_Nil, 'Choisissez ci-dessus le rôle à regarder : l\'aperçu s\'ouvre dès qu\'il est choisi.');
};
var $author$project$I18n$Cles$droitsVoirCommeChampAdresse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.voir-comme.champ.adresse', _List_Nil, 'Adresse');
};
var $author$project$I18n$Cles$droitsVoirCommeChampEmail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.voir-comme.champ.email', _List_Nil, 'Email');
};
var $author$project$I18n$Cles$droitsVoirCommeChampTelephone = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.voir-comme.champ.telephone', _List_Nil, 'Téléphone');
};
var $author$project$Components$Parametrage$Droits$View$canauxDeContact = function (i18n) {
	return _List_fromArray(
		[
			_Utils_Tuple3(
			'crm.entite.email',
			'Email',
			$author$project$I18n$Cles$droitsVoirCommeChampEmail(i18n)),
			_Utils_Tuple3(
			'crm.entite.telephone',
			'Telephone',
			$author$project$I18n$Cles$droitsVoirCommeChampTelephone(i18n)),
			_Utils_Tuple3(
			'crm.entite.adresse',
			'Adresse',
			$author$project$I18n$Cles$droitsVoirCommeChampAdresse(i18n))
		]);
};
var $author$project$Components$Parametrage$Droits$Model$champsDuType = F2(
	function (cle, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.dw;
					},
					$elm$core$List$map(
						function ($) {
							return $.uN;
						})),
				A2($author$project$Components$Parametrage$Droits$Model$reglableDe, cle, model)));
	});
var $author$project$Components$Parametrage$Droits$View$champsDuBloc = F3(
	function (model, champ, bloc) {
		var lu = function (nom) {
			return $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (c) {
						return _Utils_eq(c.uN, nom);
					},
					bloc.dw));
		};
		var cle = 'crm.entite.type.' + bloc.JX;
		var libelle = function (nom) {
			return A3($author$project$Components$Parametrage$Droits$Model$libelleDuChamp, cle, nom, model);
		};
		var _v0 = A2($author$project$Components$Parametrage$Droits$Model$champsDuType, cle, model);
		if (!_v0.b) {
			return A2(
				$elm$core$List$map,
				function (c) {
					return A3(
						champ,
						cle + ('.' + c.uN),
						libelle(c.uN),
						$elm$core$Maybe$Just(
							A2($elm$core$Maybe$withDefault, '', c.fm)));
				},
				bloc.dw);
		} else {
			var declares = _v0;
			return A2(
				$elm$core$List$map,
				function (nom) {
					return A3(
						champ,
						cle + ('.' + nom),
						libelle(nom),
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.fm;
								},
								$elm$core$Maybe$withDefault('')),
							lu(nom)));
				},
				declares);
		}
	});
var $author$project$I18n$Cles$droitsVoirCommeChampCivilite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.voir-comme.champ.civilite', _List_Nil, 'Civilité');
};
var $author$project$I18n$Cles$droitsVoirCommeChampLectureSeule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.voir-comme.champ.lecture-seule', _List_Nil, ' · lecture seule');
};
var $author$project$I18n$Cles$droitsVoirCommeChampNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.voir-comme.champ.nom', _List_Nil, 'Nom');
};
var $author$project$I18n$Cles$droitsVoirCommeChampNonAffiche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.voir-comme.champ.non-affiche', _List_Nil, 'Non affiché');
};
var $author$project$I18n$Cles$droitsVoirCommeChampPrenom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.voir-comme.champ.prenom', _List_Nil, 'Prénom');
};
var $author$project$I18n$Cles$droitsVoirCommeChampRaisonSociale = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.voir-comme.champ.raison-sociale', _List_Nil, 'Raison sociale');
};
var $author$project$I18n$Cles$droitsVoirCommeFicheSansNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.voir-comme.fiche.sans-nom', _List_Nil, 'Nom non affiché');
};
var $author$project$Components$Parametrage$Droits$Model$lisibleEnApercu = F2(
	function (fiche, champ) {
		return A2($elm$core$List$member, champ, fiche.uZ);
	});
var $author$project$Components$Parametrage$Droits$Model$lectureSeuleEnApercu = F2(
	function (fiche, champ) {
		return A2($author$project$Components$Parametrage$Droits$Model$lisibleEnApercu, fiche, champ) && (!A2($elm$core$List$member, champ, fiche.u_));
	});
var $author$project$I18n$Cles$droitsVoirCommeNatureOrganisation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.voir-comme.nature.organisation', _List_Nil, 'Organisation');
};
var $author$project$I18n$Cles$droitsVoirCommeNaturePersonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.voir-comme.nature.personne', _List_Nil, 'Personne');
};
var $author$project$Components$Parametrage$Droits$View$libelleDeLaNature = F2(
	function (i18n, nature) {
		if (!nature) {
			return $author$project$I18n$Cles$droitsVoirCommeNaturePersonne(i18n);
		} else {
			return $author$project$I18n$Cles$droitsVoirCommeNatureOrganisation(i18n);
		}
	});
var $author$project$Components$Parametrage$Droits$View$libelleDuType = F2(
	function (i18n, fiche) {
		var _v0 = fiche.js;
		if (_v0.b) {
			var bloc = _v0.a;
			return bloc.Bl;
		} else {
			return A2($author$project$Components$Parametrage$Droits$View$libelleDeLaNature, i18n, fiche.g1);
		}
	});
var $author$project$Components$Parametrage$Droits$Model$valeursDuCanal = F2(
	function (canal, fiche) {
		return A2(
			$elm$core$List$filterMap,
			function ($) {
				return $.fm;
			},
			A2(
				$elm$core$List$filter,
				function (c) {
					return _Utils_eq(c.uF, canal);
				},
				fiche.wa));
	});
var $author$project$Components$Parametrage$Droits$View$ligneDeContact = F3(
	function (fiche, champ, _v0) {
		var ref = _v0.a;
		var canal = _v0.b;
		var libelle = _v0.c;
		var _v1 = _Utils_Tuple2(
			A2($author$project$Components$Parametrage$Droits$Model$lisibleEnApercu, fiche, ref),
			A2($author$project$Components$Parametrage$Droits$Model$valeursDuCanal, canal, fiche));
		if (_v1.a) {
			if (!_v1.b.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var valeurs = _v1.b;
				return $elm$core$Maybe$Just(
					A3(
						champ,
						ref,
						libelle,
						$elm$core$Maybe$Just(
							A2($elm$core$String$join, ', ', valeurs))));
			}
		} else {
			return $elm$core$Maybe$Just(
				A3(champ, ref, libelle, $elm$core$Maybe$Nothing));
		}
	});
var $author$project$Components$Parametrage$Droits$View$detailDeLaFiche = F3(
	function (i18n, model, fiche) {
		var champ = F3(
			function (ref, libelle, valeur) {
				var affiche = (!_Utils_eq(valeur, $elm$core$Maybe$Nothing)) || A2($author$project$Components$Parametrage$Droits$Model$lisibleEnApercu, fiche, ref);
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('champ')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
								]),
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_css$Html$Styled$text(libelle),
								A2($author$project$Components$Parametrage$Droits$Model$lectureSeuleEnApercu, fiche, ref) ? _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('lecture-seule')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$droitsVoirCommeChampLectureSeule(i18n))
											]))
									]) : _List_Nil)),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur'),
									$rtfeldman$elm_css$Html$Styled$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('non-affiche', !affiche)
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									affiche ? A2($elm$core$Maybe$withDefault, '', valeur) : $author$project$I18n$Cles$droitsVoirCommeChampNonAffiche(i18n))
								]))
						]));
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('fiche')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									function () {
										var _v0 = fiche.g1;
										if (_v0 === 1) {
											return A2(
												$elm$core$Maybe$withDefault,
												$author$project$I18n$Cles$droitsVoirCommeFicheSansNom(i18n),
												fiche.GR);
										} else {
											var _v1 = A2(
												$elm$core$List$filterMap,
												$elm$core$Basics$identity,
												_List_fromArray(
													[fiche.Gg, fiche.Dj]));
											if (!_v1.b) {
												return $author$project$I18n$Cles$droitsVoirCommeFicheSansNom(i18n);
											} else {
												var morceaux = _v1;
												return A2($elm$core$String$join, ' ', morceaux);
											}
										}
									}())
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Parametrage$Droits$View$libelleDuType, i18n, fiche))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('champs')
						]),
					_Utils_ap(
						function () {
							var _v2 = fiche.js;
							if (!_v2.b) {
								var _v3 = fiche.g1;
								if (_v3 === 1) {
									return _List_fromArray(
										[
											A3(
											champ,
											'crm.entite.raisonSociale',
											$author$project$I18n$Cles$droitsVoirCommeChampRaisonSociale(i18n),
											fiche.GR)
										]);
								} else {
									return _List_fromArray(
										[
											A3(
											champ,
											'crm.entite.civilite',
											$author$project$I18n$Cles$droitsVoirCommeChampCivilite(i18n),
											fiche.vh),
											A3(
											champ,
											'crm.entite.prenom',
											$author$project$I18n$Cles$droitsVoirCommeChampPrenom(i18n),
											fiche.Gg),
											A3(
											champ,
											'crm.entite.nom',
											$author$project$I18n$Cles$droitsVoirCommeChampNom(i18n),
											fiche.Dj)
										]);
								}
							} else {
								var blocs = _v2;
								return A2(
									$elm$core$List$concatMap,
									A2($author$project$Components$Parametrage$Droits$View$champsDuBloc, model, champ),
									blocs);
							}
						}(),
						A2(
							$elm$core$List$filterMap,
							A2($author$project$Components$Parametrage$Droits$View$ligneDeContact, fiche, champ),
							$author$project$Components$Parametrage$Droits$View$canauxDeContact(i18n))))
				]));
	});
var $author$project$I18n$Cles$droitsVoirCommeFicheAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.voir-comme.fiche.aucune', _List_Nil, 'Ouvrez une fiche de la liste pour la voir comme ce rôle.');
};
var $author$project$I18n$Cles$droitsVoirCommeFicheIntrouvable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.voir-comme.fiche.introuvable', _List_Nil, 'Réponse : « Fiche introuvable ». Comme si elle n\'existait pas.');
};
var $author$project$I18n$Cles$droitsVoirCommeFicheTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.voir-comme.fiche.titre', _List_Nil, 'La fiche ouverte');
};
var $author$project$Components$Parametrage$Droits$View$ficheApercue = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('fiche-ouverte')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$droitsVoirCommeFicheTitre(i18n))
						])),
					function () {
					var _v0 = _Utils_Tuple2(model.iW, model.iX);
					if (!_v0.a.$) {
						var fiche = _v0.a.a;
						return A3($author$project$Components$Parametrage$Droits$View$detailDeLaFiche, i18n, model, fiche);
					} else {
						if (_v0.b) {
							var _v1 = _v0.a;
							return A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('introuvable')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$droitsVoirCommeFicheIntrouvable(i18n))
									]));
						} else {
							var _v2 = _v0.a;
							return A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$droitsVoirCommeFicheAucune(i18n))
									]));
						}
					}
				}()
				]));
	});
var $author$project$I18n$Cles$droitsVoirCommeListeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.voir-comme.liste.titre', _List_Nil, 'Les fiches de la liste');
};
var $author$project$I18n$Cles$droitsVoirCommeListeVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.voir-comme.liste.vide', _List_Nil, 'Le rôle ne voit aucune fiche dans la liste.');
};
var $author$project$Components$Parametrage$Droits$Update$FicheApercueOuverte = function (a) {
	return {$: 29, a: a};
};
var $author$project$I18n$Cles$droitsVoirCommeResponsableNom = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'droits.voir-comme.responsable.nom',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'à ' + p.Dj);
	});
var $author$project$I18n$Cles$droitsVoirCommeResponsableVous = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.voir-comme.responsable.vous', _List_Nil, 'à vous');
};
var $author$project$Components$Parametrage$Droits$View$responsableDeLaFiche = F2(
	function (i18n, responsable) {
		var _v0 = _Utils_Tuple2(responsable.KX, responsable.Dj);
		if (_v0.a) {
			return $elm$core$Maybe$Just(
				$author$project$I18n$Cles$droitsVoirCommeResponsableVous(i18n));
		} else {
			if (!_v0.b.$) {
				var nom = _v0.b.a;
				return $elm$core$Maybe$Just(
					A2(
						$author$project$I18n$Cles$droitsVoirCommeResponsableNom,
						i18n,
						{Dj: nom}));
			} else {
				var _v1 = _v0.b;
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$Components$Parametrage$Droits$View$noteDeLaLigne = F2(
	function (i18n, fiche) {
		return A2(
			$elm$core$String$join,
			' · ',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						function () {
						var _v0 = fiche.ib;
						if (!_v0.b) {
							return $elm$core$Maybe$Nothing;
						} else {
							var types = _v0;
							return $elm$core$Maybe$Just(
								A2($elm$core$String$join, ', ', types));
						}
					}(),
						A2(
						$elm$core$Maybe$andThen,
						$author$project$Components$Parametrage$Droits$View$responsableDeLaFiche(i18n),
						fiche.qB)
					])));
	});
var $author$project$Components$Parametrage$Droits$View$ficheDeLaListe = F2(
	function (i18n, fiche) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('fiche')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ouvrir'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Parametrage$Droits$Update$FicheApercueOuverte(fiche.r8))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$I18n$Cles$droitsVoirCommeFicheSansNom(i18n),
										fiche.Dj))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Parametrage$Droits$View$noteDeLaLigne, i18n, fiche))
								]))
						]))
				]));
	});
var $author$project$Components$Parametrage$Droits$View$listeDesFichesApercues = F2(
	function (i18n, lesFiches) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('fiches-de-la-liste')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$droitsVoirCommeListeTitre(i18n))
						])),
					$elm$core$List$isEmpty(lesFiches) ? A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$droitsVoirCommeListeVide(i18n))
						])) : A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('liste-des-fiches')
						]),
					A2(
						$elm$core$List$map,
						$author$project$Components$Parametrage$Droits$View$ficheDeLaListe(i18n),
						lesFiches))
				]));
	});
var $author$project$I18n$Cles$droitsVoirCommeTraceFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.voir-comme.trace.fin', _List_Nil, ' : chaque ouverture est notée (qui, quel rôle, quand). Il faut le droit « Paramétrage : Modification » pour l\'utiliser.');
};
var $author$project$I18n$Cles$droitsVoirCommeTraceFort = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.voir-comme.trace.fort', _List_Nil, 'Aperçu tracé');
};
var $author$project$Components$Parametrage$Droits$View$noteDeLaTrace = function (i18n) {
	return A2(
		$author$project$Components$Shared$Note$View$view,
		0,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$droitsVoirCommeTraceFort(i18n))
							])),
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$droitsVoirCommeTraceFin(i18n))
					]))
			]));
};
var $author$project$Components$Parametrage$Droits$View$voirComme = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('voir-comme')
				]),
			function () {
				var _v0 = _Utils_Tuple2(model.zo, model.tq);
				if (!_v0.a.$) {
					if (!_v0.b.$) {
						var fiche = _v0.a.a;
						var lu = _v0.b.a;
						return _List_fromArray(
							[
								A2($author$project$Components$Parametrage$Droits$View$bandeauDApercu, i18n, fiche),
								A2($author$project$Components$Parametrage$Droits$View$listeDesFichesApercues, i18n, lu.zu),
								A2($author$project$Components$Parametrage$Droits$View$ficheApercue, i18n, model),
								$author$project$Components$Parametrage$Droits$View$noteDeLaTrace(i18n)
							]);
					} else {
						var _v1 = _v0.b;
						return _Utils_eq(
							$author$project$Components$Parametrage$Droits$Model$lienDeLApercu(model),
							$elm$core$Maybe$Nothing) ? _List_fromArray(
							[
								$author$project$Components$Parametrage$Droits$View$noteDeLaTrace(i18n)
							]) : _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('chargement')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$droitsChargement(i18n))
									])),
								$author$project$Components$Parametrage$Droits$View$noteDeLaTrace(i18n)
							]);
					}
				} else {
					var _v2 = _v0.a;
					return (_Utils_eq(model.aS, $elm$core$Maybe$Nothing) || (!_Utils_eq(model.hH, $elm$core$Maybe$Nothing))) ? _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('chargement')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$droitsChargement(i18n))
								])),
							$author$project$Components$Parametrage$Droits$View$noteDeLaTrace(i18n)
						]) : _List_fromArray(
						[
							A3($author$project$Components$Parametrage$Droits$View$choixDuRole, i18n, model, $author$project$Components$Parametrage$Droits$Update$RoleChoisiPourLApercu),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('invitation')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$droitsVerificationChoisir(i18n))
								])),
							$author$project$Components$Parametrage$Droits$View$noteDeLaTrace(i18n)
						]);
				}
			}());
	});
var $author$project$Components$Parametrage$Droits$Update$CreationOuverte = function (a) {
	return {$: 10, a: a};
};
var $author$project$I18n$Cles$droitsRoleCreer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.role.creer', _List_Nil, 'Créer un rôle');
};
var $author$project$I18n$Cles$droitsRoleNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.role.note', _List_Nil, 'Un rôle ne se supprime que lorsque plus personne ne l\'a. « Administrateur » est fourni : il ne se modifie ni ne se supprime. Il doit toujours rester au moins un administrateur.');
};
var $author$project$Components$Parametrage$Droits$View$geste = F3(
	function (lien, libelle, msg) {
		return A2(
			$elm$core$Maybe$map,
			function (_v0) {
				return A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
						]),
					libelle);
			},
			lien);
	});
var $author$project$Components$Parametrage$Droits$Update$ReglerLeRole = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Parametrage$Droits$Update$RenommageOuvert = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Parametrage$Droits$Update$SuppressionDemandee = function (a) {
	return {$: 16, a: a};
};
var $author$project$I18n$Cles$droitsRoleDupliquer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.role.dupliquer', _List_Nil, 'Dupliquer');
};
var $author$project$I18n$Cles$droitsRoleFourni = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.role.fourni', _List_Nil, 'Fourni');
};
var $author$project$I18n$Cles$droitsRoleRegler = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.role.regler', _List_Nil, 'Régler');
};
var $author$project$I18n$Cles$droitsRoleRenommer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.role.renommer', _List_Nil, 'Renommer');
};
var $author$project$I18n$Cles$droitsRoleSupprimer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.role.supprimer', _List_Nil, 'Supprimer');
};
var $author$project$I18n$Cles$droitsRoleSupprimerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'droits.role.supprimer.titre', _List_Nil, 'Retirez d\'abord les personnes');
};
var $author$project$API$NavLinksDictionary$dupliquerUnRole = 'dupliquer-un-role';
var $author$project$Components$Parametrage$Droits$View$ligneDeRole = F3(
	function (i18n, model, role) {
		var note = _Utils_ap(
			A2(
				$author$project$I18n$Cles$droitsRolePersonnes,
				i18n,
				{w: role.Kf}),
			role.rv ? (' · ' + $author$project$I18n$Cles$droitsRoleSystemeNote(i18n)) : '');
		var a = function (rel) {
			return !_Utils_eq(
				A2($author$project$API$Liens$trouver, rel, role.nQ),
				$elm$core$Maybe$Nothing);
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('role'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'regle',
							_Utils_eq(
								model.hH,
								$elm$core$Maybe$Just(role.Aq))),
							_Utils_Tuple2('systeme', role.rv)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(role.Dj)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(note)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								a($author$project$API$NavLinksDictionary$reglerUnRole) ? $elm$core$Maybe$Just(
								A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Parametrage$Droits$Update$ReglerLeRole(role.Aq))
										]),
									$author$project$I18n$Cles$droitsRoleRegler(i18n))) : $elm$core$Maybe$Nothing,
								a($author$project$API$NavLinksDictionary$renommerUnRole) ? $elm$core$Maybe$Just(
								A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Parametrage$Droits$Update$RenommageOuvert(role.Aq))
										]),
									$author$project$I18n$Cles$droitsRoleRenommer(i18n))) : $elm$core$Maybe$Nothing,
								a($author$project$API$NavLinksDictionary$dupliquerUnRole) ? $elm$core$Maybe$Just(
								A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Parametrage$Droits$Update$CreationOuverte(
												$elm$core$Maybe$Just(role.Aq)))
										]),
									$author$project$I18n$Cles$droitsRoleDupliquer(i18n))) : $elm$core$Maybe$Nothing,
								a($author$project$API$NavLinksDictionary$supprimerUnRole) ? $elm$core$Maybe$Just(
								A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									3,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Parametrage$Droits$Update$SuppressionDemandee(role.Aq))
										]),
									$author$project$I18n$Cles$droitsRoleSupprimer(i18n))) : (((!role.rv) && ((role.Kf > 0) && a($author$project$API$NavLinksDictionary$roleInterne))) ? $elm$core$Maybe$Just(
								A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									3,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-disabled', 'true'),
											$rtfeldman$elm_css$Html$Styled$Attributes$title(
											$author$project$I18n$Cles$droitsRoleSupprimerTitre(i18n))
										]),
									$author$project$I18n$Cles$droitsRoleSupprimer(i18n))) : $elm$core$Maybe$Nothing),
								role.rv ? $elm$core$Maybe$Just(
								A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('fourni')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$droitsRoleFourni(i18n))
										]))) : $elm$core$Maybe$Nothing
							])))
				]));
	});
var $author$project$Components$Parametrage$Droits$View$vosRoles = F2(
	function (i18n, model) {
		var roles = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.eX;
				},
				model.aS));
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('roles')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('liste-des-roles')
								]),
							A2(
								$elm$core$List$map,
								A2($author$project$Components$Parametrage$Droits$View$ligneDeRole, i18n, model),
								roles)),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('creer')
								]),
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_List_fromArray(
									[
										A3(
										$author$project$Components$Parametrage$Droits$View$geste,
										A2($author$project$Components$Parametrage$Droits$Model$lienDeCommande, $author$project$API$NavLinksDictionary$creerUnRole, model),
										$author$project$I18n$Cles$droitsRoleCreer(i18n),
										$author$project$Components$Parametrage$Droits$Update$CreationOuverte($elm$core$Maybe$Nothing)),
										A3(
										$author$project$Components$Parametrage$Droits$View$geste,
										$author$project$Components$Parametrage$Droits$Model$lienDeDuplication(model),
										$author$project$I18n$Cles$droitsRoleDupliquerUn(i18n),
										$author$project$Components$Parametrage$Droits$Update$CreationOuverte(
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.Aq;
												},
												$elm$core$List$head(roles))))
									]))),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$droitsRoleNote(i18n))
								]))
						]))
				]));
	});
var $author$project$Components$Parametrage$Droits$View$etape = F4(
	function (i18n, courante, model, fournie) {
		return A4(
			$author$project$Components$Shared$Parcours$View$etape,
			A2($author$project$Components$Parametrage$Droits$View$parcours, i18n, model),
			courante,
			fournie,
			{
				fZ: function () {
					switch (fournie) {
						case 0:
							return _List_fromArray(
								[
									A2($author$project$Components$Parametrage$Droits$View$vosRoles, i18n, model)
								]);
						case 1:
							return _List_fromArray(
								[
									A3(
									$author$project$Components$Parametrage$Droits$View$reglage,
									i18n,
									model,
									A2($author$project$Components$Parametrage$Droits$View$modules, i18n, model))
								]);
						case 2:
							return _List_fromArray(
								[
									A3(
									$author$project$Components$Parametrage$Droits$View$reglage,
									i18n,
									model,
									A2($author$project$Components$Parametrage$Droits$View$fiches, i18n, model))
								]);
						case 3:
							return _List_fromArray(
								[
									A3(
									$author$project$Components$Parametrage$Droits$View$reglage,
									i18n,
									model,
									A2($author$project$Components$Parametrage$Droits$View$champs, i18n, model))
								]);
						case 4:
							return _List_fromArray(
								[
									A3(
									$author$project$Components$Parametrage$Droits$View$reglage,
									i18n,
									model,
									A2($author$project$Components$Parametrage$Droits$View$personnes, i18n, model))
								]);
						default:
							return _List_fromArray(
								[
									A2($author$project$Components$Parametrage$Droits$View$voirComme, i18n, model)
								]);
					}
				}(),
				y8: A3(
					$author$project$Components$Parametrage$Droits$Parcours$explication,
					i18n,
					$author$project$Components$Parametrage$Droits$View$nombreDePersonnes(model),
					fournie),
				GJ: A3(
					$author$project$Components$Parametrage$Droits$Parcours$question,
					i18n,
					$author$project$Components$Parametrage$Droits$View$nomDuRole(model),
					fournie)
			});
	});
var $author$project$I18n$Cles$parcoursEtapeTerminer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'parcours.etape.terminer', _List_Nil, 'Terminer');
};
var $author$project$Components$Shared$Parcours$View$piedAvecFin = F2(
	function (i18n, fin) {
		return A2(
			$author$project$Components$Shared$Parcours$View$piedAvec,
			i18n,
			_List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$lien,
					0,
					fin,
					$author$project$I18n$Cles$parcoursEtapeTerminer(i18n))
				]));
	});
var $author$project$Components$Parametrage$Droits$View$view = F4(
	function (i18n, courante, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'parametrage-droits',
			{
				ut: model.qa ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('acces-refuse')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Note$View$view,
										1,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$droitsAccesRefuse(i18n))
													]))
											]))
									]))
							]))
					]) : (_Utils_eq(model.aS, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Parcours$View$etapes,
						i18n,
						A2($author$project$Components$Parametrage$Droits$View$parcours, i18n, model),
						courante),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						A2(
							$elm$core$List$cons,
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									A3($author$project$Components$Parametrage$Droits$View$etape, i18n, courante, model),
									$author$project$Routes$Route$etapesDesDroits),
								_List_fromArray(
									[
										A4(
										$author$project$Components$Shared$Parcours$View$piedAvecFin,
										i18n,
										$author$project$Routes$Route$adresseTypesDePartiesPrenantes,
										A2($author$project$Components$Parametrage$Droits$View$parcours, i18n, model),
										courante)
									])))),
						A3(
						$author$project$Components$Shared$Parcours$View$apercu,
						i18n,
						$author$project$I18n$Cles$droitsApercu(i18n),
						A3($author$project$Components$Parametrage$Droits$View$apercu, i18n, courante, model))
					])),
				xy: _List_fromArray(
					[
						A2($author$project$Components$Parametrage$Droits$View$drawer, i18n, model)
					]),
				zM: _List_Nil,
				AK: $author$project$Components$Parametrage$Droits$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$droitsDescription(i18n))
									]))
							]),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adresseDesDroits,
								Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
							},
								{
								aa: $author$project$Routes$Route$adresseDesDroits,
								Dj: $author$project$I18n$Cles$droitsFil(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$droitsTitre(i18n)
					})
			});
	});
var $author$project$Components$Parametrage$LanguesDuClient$Update$AjoutEnvoye = {$: 13};
var $author$project$Components$Parametrage$LanguesDuClient$Update$RechercheSaisie = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Parametrage$LanguesDuClient$Model$ajoutPret = function (model) {
	return !_Utils_eq(model.ve, $elm$core$Maybe$Nothing);
};
var $author$project$I18n$Cles$languesAjoutAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.ajout-action', _List_Nil, 'Ajouter la langue');
};
var $author$project$I18n$Cles$languesAjoutAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.ajout-aide', _List_Nil, 'Après l\'ajout, la langue est proposée dans « Traduire la fiche ». Tant qu\'une valeur n\'est pas traduite, la fiche affiche la langue par défaut.');
};
var $author$project$I18n$Cles$languesAjoutRecherche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.ajout-recherche', _List_Nil, 'Rechercher une langue');
};
var $author$project$I18n$Cles$languesAjoutRecherchePlaceholder = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.ajout-recherche-placeholder', _List_Nil, 'Nom de la langue');
};
var $author$project$I18n$Cles$languesAjoutSousTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.ajout-sous-titre', _List_Nil, 'Choisie dans le référentiel des langues (ISO 639-1). Aucune installation ni développement.');
};
var $author$project$I18n$Cles$languesAjoutTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.ajout-titre', _List_Nil, 'Ajouter une langue');
};
var $author$project$Components$Parametrage$LanguesDuClient$Model$proposees = function (model) {
	var recherche = $elm$core$String$toLower(
		$elm$core$String$trim(model.hC));
	return A2(
		$elm$core$List$filter,
		function (entree) {
			return (recherche === '') || (A2(
				$elm$core$String$contains,
				recherche,
				$elm$core$String$toLower(entree.Bl)) || _Utils_eq(entree.vx, recherche));
		},
		model.Gw);
};
var $author$project$Components$Parametrage$LanguesDuClient$Update$LangueChoisie = function (a) {
	return {$: 12, a: a};
};
var $author$project$I18n$Cles$languesAjoutDejaDansLaListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.ajout-deja-dans-la-liste', _List_Nil, 'déjà dans la liste');
};
var $author$project$Components$Parametrage$LanguesDuClient$View$proposition = F3(
	function (i18n, model, entree) {
		var presente = A2(
			$elm$core$List$any,
			function (langue) {
				return _Utils_eq(langue.vx, entree.vx);
			},
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Ba;
					},
					model.Ba)));
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('proposition'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('deja-presente', presente),
							_Utils_Tuple2(
							'choisie',
							_Utils_eq(
								model.ve,
								$elm$core$Maybe$Just(entree.vx)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
							$rtfeldman$elm_css$Html$Styled$Attributes$name('langues-ajout-choix'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id('langues-proposition-' + entree.vx),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(
							_Utils_eq(
								model.ve,
								$elm$core$Maybe$Just(entree.vx))),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(presente),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Parametrage$LanguesDuClient$Update$LangueChoisie(entree.vx))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(entree.Bl)
						])),
					presente ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('deja')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$languesAjoutDejaDansLaListe(i18n))
						])) : $rtfeldman$elm_css$Html$Styled$text(''),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('code')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(entree.vx)
						]))
				]));
	});
var $author$project$I18n$Cles$languesDefautImpossible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.defaut-impossible', _List_Nil, 'Impossible de changer la langue par défaut.');
};
var $author$project$I18n$Cles$languesDefautIssue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.defaut-issue', _List_Nil, 'Issue : traduire d\'abord ces valeurs dans la langue choisie (« Traduire la fiche »), puis changer la langue par défaut.');
};
var $author$project$I18n$Cles$languesDefautManquantes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'langues.defaut-manquantes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeur manque dans cette langue.') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeurs manquent dans cette langue.'));
	});
var $author$project$I18n$Cles$languesRefusAcces = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.refus-acces', _List_Nil, 'Vous n\'avez pas le droit de modifier les langues du client.');
};
var $author$project$I18n$Cles$languesRefusAutre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.refus-autre', _List_Nil, 'L\'opération n\'a pas abouti. Rien n\'a été modifié.');
};
var $author$project$I18n$Cles$languesRefusDejaPresente = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.refus-deja-presente', _List_Nil, 'Cette langue est déjà dans la liste du client.');
};
var $author$project$I18n$Cles$languesRefusHorsReferentiel = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.refus-hors-referentiel', _List_Nil, 'Cette langue n\'est pas dans le référentiel des langues.');
};
var $author$project$Components$Parametrage$LanguesDuClient$View$refusDeLaSaisie = F3(
	function (i18n, defaut, model) {
		var _v0 = _Utils_Tuple2(model.dh, model.pZ);
		if ((_v0.a.$ === 1) && (!_v0.b.$)) {
			switch (_v0.b.a.$) {
				case 0:
					var _v1 = _v0.a;
					var _v2 = _v0.b.a;
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$languesRefusHorsReferentiel(i18n))
							]));
				case 1:
					var _v3 = _v0.a;
					var _v4 = _v0.b.a;
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$languesRefusDejaPresente(i18n))
							]));
				case 3:
					var _v5 = _v0.a;
					var nombre = _v0.b.a.a;
					return defaut ? A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('refus')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$languesDefautImpossible(i18n))
											])),
										$rtfeldman$elm_css$Html$Styled$text(' '),
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$languesDefautManquantes,
											i18n,
											{w: nombre}))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('issue')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$languesDefautIssue(i18n))
									]))
							])) : $rtfeldman$elm_css$Html$Styled$text('');
				case 5:
					var _v6 = _v0.a;
					var _v7 = _v0.b.a;
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$languesRefusAcces(i18n))
							]));
				default:
					var _v8 = _v0.a;
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$languesRefusAutre(i18n))
							]));
			}
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$LanguesDuClient$View$drawerDAjout = F2(
	function (i18n, model) {
		return A5(
			$author$project$Components$Shared$Drawer$View$viewAvecSousTitre,
			i18n,
			$author$project$I18n$Cles$languesAjoutSousTitre(i18n),
			$author$project$Components$Parametrage$LanguesDuClient$Update$DuDrawerDAjout,
			{
				fs: {
					sR: $author$project$Components$Parametrage$LanguesDuClient$Model$ajoutPret(model) && (!$author$project$API$Envoi$enCours(model.l2)),
					Bl: $author$project$I18n$Cles$languesAjoutAction(i18n),
					C$: $author$project$Components$Parametrage$LanguesDuClient$Update$AjoutEnvoye
				},
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('recherche')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$label,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle'),
										$rtfeldman$elm_css$Html$Styled$Attributes$for('langues-recherche')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$languesAjoutRecherche(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$input,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
										$rtfeldman$elm_css$Html$Styled$Attributes$id('langues-recherche'),
										$rtfeldman$elm_css$Html$Styled$Attributes$value(model.hC),
										$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(
										$author$project$I18n$Cles$languesAjoutRecherchePlaceholder(i18n)),
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Parametrage$LanguesDuClient$Update$RechercheSaisie)
									]),
								_List_Nil)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('propositions')
							]),
						A2(
							$elm$core$List$map,
							A2($author$project$Components$Parametrage$LanguesDuClient$View$proposition, i18n, model),
							$author$project$Components$Parametrage$LanguesDuClient$Model$proposees(model))),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$languesAjoutAide(i18n))
							])),
						A3($author$project$Components$Parametrage$LanguesDuClient$View$refusDeLaSaisie, i18n, false, model)
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$languesAjoutTitre(i18n)
			},
			model.k_);
	});
var $author$project$Components$Parametrage$LanguesDuClient$Update$SuppressionDemandee = {$: 8};
var $author$project$I18n$Cles$languesGarderLaLangue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.garder-la-langue', _List_Nil, 'Garder la langue');
};
var $author$project$I18n$Cles$languesRetraitImpossible = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'langues.retrait-impossible',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'langue',
					$author$project$I18n$Traductions$Chaine(p.nn))
				]),
			'Impossible de retirer la langue « ' + (p.nn + ' ».'));
	});
var $author$project$I18n$Cles$languesRetraitIssue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.retrait-issue', _List_Nil, 'Issue : supprimer d\'abord les traductions de cette langue, ou la garder. La langue par défaut ne se retire jamais : changez-la d\'abord.');
};
var $author$project$I18n$Cles$languesRetraitRien = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.retrait-rien', _List_Nil, 'Rien n\'est modifié');
};
var $author$project$I18n$Cles$languesRetraitTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.retrait-titre', _List_Nil, 'Retirer la langue');
};
var $author$project$I18n$Cles$languesRetraitTraductions = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'langues.retrait-traductions',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeur est traduite dans cette langue. Les retirer les perdrait.') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeurs sont traduites dans cette langue. Les retirer les perdrait.'));
	});
var $author$project$I18n$Cles$languesSupprimerIndisponible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.supprimer-indisponible', _List_Nil, '« Supprimer les traductions… » est grisé : il demande les droits « Paramétrage : Modifier » et « Produits : Modifier ». Demandez-les à un administrateur, ou gardez la langue.');
};
var $author$project$I18n$Cles$languesSupprimerLesTraductions = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.supprimer-les-traductions', _List_Nil, 'Supprimer les traductions…');
};
var $author$project$Components$Parametrage$LanguesDuClient$View$drawerDeRetrait = F2(
	function (i18n, model) {
		var langue = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				model.dh));
		return A5(
			$author$project$Components$Shared$Drawer$View$viewAvecPiedLibre,
			i18n,
			{
				oJ: $elm$core$Maybe$Just(
					$author$project$I18n$Cles$languesRetraitRien(i18n)),
				HF: function (attributs) {
					return A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_Utils_ap(
							attributs,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Parametrage$LanguesDuClient$Update$DuDrawerDeRetrait($author$project$Components$Shared$Drawer$Update$Fermer))
								])),
						$author$project$I18n$Cles$languesGarderLaLangue(i18n));
				},
				Jb: _List_Nil
			},
			$author$project$Components$Parametrage$LanguesDuClient$Update$DuDrawerDeRetrait,
			{
				fs: {
					sR: (!_Utils_eq(
						$author$project$Components$Parametrage$LanguesDuClient$Model$lienDeLApercu(model),
						$elm$core$Maybe$Nothing)) && (!$author$project$API$Envoi$enCours(model.l2)),
					Bl: $author$project$I18n$Cles$languesSupprimerLesTraductions(i18n),
					C$: $author$project$Components$Parametrage$LanguesDuClient$Update$SuppressionDemandee
				},
				fZ: _List_fromArray(
					[
						function () {
						var _v0 = model.pZ;
						if ((!_v0.$) && (_v0.a.$ === 4)) {
							var nombre = _v0.a.a;
							return A2(
								$author$project$Components$Shared$Note$View$view,
								1,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('refus')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2(
															$author$project$I18n$Cles$languesRetraitImpossible,
															i18n,
															{nn: langue}))
													])),
												$rtfeldman$elm_css$Html$Styled$text(' '),
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$languesRetraitTraductions,
													i18n,
													{w: nombre}))
											]))
									]));
						} else {
							return $rtfeldman$elm_css$Html$Styled$text('');
						}
					}(),
						function () {
						var _v1 = model.pZ;
						if ((!_v1.$) && (_v1.a.$ === 4)) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('issue')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$languesRetraitIssue(i18n))
											]))
									]));
						} else {
							return $rtfeldman$elm_css$Html$Styled$text('');
						}
					}(),
						function () {
						var _v2 = _Utils_Tuple2(
							model.pZ,
							$author$project$Components$Parametrage$LanguesDuClient$Model$lienDeLApercu(model));
						if (((!_v2.a.$) && (_v2.a.a.$ === 4)) && (_v2.b.$ === 1)) {
							var _v3 = _v2.b;
							return A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('issue'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('indisponible')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$languesSupprimerIndisponible(i18n))
									]));
						} else {
							return $rtfeldman$elm_css$Html$Styled$text('');
						}
					}()
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$languesRetraitTitre(i18n)
			},
			model.lh);
	});
var $author$project$Components$Parametrage$LanguesDuClient$Update$SuppressionConfirmee = {$: 9};
var $author$project$I18n$Cles$languesSuppressionAction = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'langues.suppression-action',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeurs',
					$author$project$I18n$Traductions$Entier(p.Ki))
				]),
			((!p.Ki) || (p.Ki === 1)) ? 'Supprimer la valeur' : ('Supprimer les ' + (A2($author$project$I18n$Nombre$formater, 0, p.Ki) + ' valeurs')));
	});
var $author$project$I18n$Cles$languesSuppressionAvancement = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'langues.suppression-avancement',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'faites',
					$author$project$I18n$Traductions$Chaine(p.zh)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			p.zh + (' sur ' + (p.JE + ' fiches traitées')));
	});
var $author$project$I18n$Cles$languesSuppressionDefinitive = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.suppression-definitive', _List_Nil, 'Cette suppression est définitive : les textes ne se retrouvent plus dans l\'application. La langue par défaut n\'est pas touchée.');
};
var $author$project$I18n$Cles$languesSuppressionNombres = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'langues.suppression-nombres',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fiches',
					$author$project$I18n$Traductions$Chaine(p.zu)),
					_Utils_Tuple2(
					'valeurs',
					$author$project$I18n$Traductions$Entier(p.Ki))
				]),
			((!p.Ki) || (p.Ki === 1)) ? ('Fiches touchées : ' + (p.zu + ('. ' + (A2($author$project$I18n$Nombre$formater, 0, p.Ki) + ' valeur sera supprimée.')))) : ('Fiches touchées : ' + (p.zu + ('. ' + (A2($author$project$I18n$Nombre$formater, 0, p.Ki) + ' valeurs seront supprimées.')))));
	});
var $author$project$I18n$Cles$languesSuppressionTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.suppression-titre', _List_Nil, 'Supprimer les traductions de la langue');
};
var $author$project$Components$Shared$Drawer$View$viewDestructif = function (i18n) {
	return A4(
		$author$project$Components$Shared$Drawer$View$viewAvecPied,
		i18n,
		3,
		$elm$core$Maybe$Nothing,
		A2(
			$author$project$Components$Shared$Drawer$View$piedDe,
			$author$project$I18n$Cles$drawerAnnuler(i18n),
			_List_Nil));
};
var $author$project$Components$Parametrage$LanguesDuClient$View$drawerDeSuppression = F2(
	function (i18n, model) {
		var apercu = A2(
			$elm$core$Maybe$withDefault,
			{zu: 0, Ki: 0},
			model.tq);
		return A4(
			$author$project$Components$Shared$Drawer$View$viewDestructif,
			i18n,
			$author$project$Components$Parametrage$LanguesDuClient$Update$DuDrawerDeSuppression,
			{
				fs: {
					sR: _Utils_eq(model.rs, $elm$core$Maybe$Nothing) && (!$author$project$API$Envoi$enCours(model.l2)),
					Bl: A2(
						$author$project$I18n$Cles$languesSuppressionAction,
						i18n,
						{Ki: apercu.Ki}),
					C$: $author$project$Components$Parametrage$LanguesDuClient$Update$SuppressionConfirmee
				},
				fZ: _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('refus')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$languesSuppressionNombres,
											i18n,
											{
												zu: $elm$core$String$fromInt(apercu.zu),
												Ki: apercu.Ki
											}))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('issue')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$languesSuppressionDefinitive(i18n))
									]))
							])),
						function () {
						var _v0 = model.rs;
						if (!_v0.$) {
							var restantes = _v0.a;
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('progression')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$progress,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$max(
												$elm$core$String$fromInt(apercu.zu)),
												$rtfeldman$elm_css$Html$Styled$Attributes$value(
												$elm$core$String$fromInt(apercu.zu - restantes))
											]),
										_List_Nil),
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('avancement')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$languesSuppressionAvancement,
													i18n,
													{
														zh: $elm$core$String$fromInt(apercu.zu - restantes),
														JE: $elm$core$String$fromInt(apercu.zu)
													}))
											]))
									]));
						} else {
							return $rtfeldman$elm_css$Html$Styled$text('');
						}
					}()
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$languesSuppressionTitre(i18n)
			},
			model.li);
	});
var $author$project$Components$Parametrage$LanguesDuClient$Update$ChangementDeDefautEnvoye = {$: 15};
var $author$project$Components$Parametrage$LanguesDuClient$View$choixDeDefaut = F2(
	function (model, langue) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('proposition'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'choisie',
							_Utils_eq(
								model.ve,
								$elm$core$Maybe$Just(langue.vx)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
							$rtfeldman$elm_css$Html$Styled$Attributes$name('langues-defaut-choix'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id('langues-defaut-' + langue.vx),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(
							_Utils_eq(
								model.ve,
								$elm$core$Maybe$Just(langue.vx))),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Parametrage$LanguesDuClient$Update$LangueChoisie(langue.vx))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(langue.Bl)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('code')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(langue.vx)
						]))
				]));
	});
var $author$project$Components$Parametrage$LanguesDuClient$Model$defautPret = function (model) {
	return !_Utils_eq(model.ve, $elm$core$Maybe$Nothing);
};
var $author$project$I18n$Cles$languesDefautAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.defaut-action', _List_Nil, 'Changer la langue par défaut');
};
var $author$project$I18n$Cles$languesDefautSousTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.defaut-sous-titre', _List_Nil, 'La langue par défaut sert de repli : elle doit porter toutes les valeurs.');
};
var $author$project$I18n$Cles$languesDefautTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.defaut-titre', _List_Nil, 'Changer la langue par défaut');
};
var $author$project$Components$Parametrage$LanguesDuClient$View$drawerDuDefaut = F2(
	function (i18n, model) {
		return A5(
			$author$project$Components$Shared$Drawer$View$viewAvecSousTitre,
			i18n,
			$author$project$I18n$Cles$languesDefautSousTitre(i18n),
			$author$project$Components$Parametrage$LanguesDuClient$Update$DuDrawerDuDefaut,
			{
				fs: {
					sR: $author$project$Components$Parametrage$LanguesDuClient$Model$defautPret(model) && (!$author$project$API$Envoi$enCours(model.l2)),
					Bl: $author$project$I18n$Cles$languesDefautAction(i18n),
					C$: $author$project$Components$Parametrage$LanguesDuClient$Update$ChangementDeDefautEnvoye
				},
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('propositions')
							]),
						A2(
							$elm$core$List$map,
							$author$project$Components$Parametrage$LanguesDuClient$View$choixDeDefaut(model),
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.o6;
									},
									$elm$core$Basics$not),
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.Ba;
										},
										model.Ba))))),
						A3($author$project$Components$Parametrage$LanguesDuClient$View$refusDeLaSaisie, i18n, true, model)
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$languesDefautTitre(i18n)
			},
			model.ls);
	});
var $author$project$I18n$Cles$languesDescription = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.description', _List_Nil, 'Les langues dans lesquelles les fiches se traduisent. La langue par défaut sert de repli.');
};
var $author$project$I18n$Cles$languesEchecDeLecture = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.echec-de-lecture', _List_Nil, 'Les langues du client n\'ont pas pu être lues.');
};
var $author$project$I18n$Cles$languesFil = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.fil', _List_Nil, 'Langues');
};
var $author$project$I18n$Cles$languesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.titre', _List_Nil, 'Langues du client');
};
var $author$project$Components$Parametrage$LanguesDuClient$View$refusHorsDrawer = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.dh, model.pZ);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			switch (_v0.b.a.$) {
				case 4:
					return $rtfeldman$elm_css$Html$Styled$text('');
				case 5:
					var _v1 = _v0.b.a;
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$languesRefusAcces(i18n))
							]));
				default:
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$languesRefusAutre(i18n))
							]));
			}
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$LanguesDuClient$Update$AjoutDemande = {$: 10};
var $author$project$Components$Parametrage$LanguesDuClient$Update$ChangementDeDefautDemande = {$: 14};
var $author$project$I18n$Cles$languesAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.ajouter', _List_Nil, 'Ajouter une langue');
};
var $author$project$I18n$Cles$languesChangerLeDefaut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.changer-le-defaut', _List_Nil, 'Changer la langue par défaut');
};
var $author$project$I18n$Cles$languesColonneLangue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.colonne-langue', _List_Nil, 'Langue');
};
var $author$project$I18n$Cles$languesColonneTraductions = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.colonne-traductions', _List_Nil, 'Traductions saisies');
};
var $author$project$I18n$Cles$languesNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.note', _List_Nil, 'Le français et l\'anglais existent au départ ; rien à saisir pour les retrouver. Les libellés de l\'application restent en français et en anglais.');
};
var $author$project$I18n$Cles$languesTableau = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.tableau', _List_Nil, 'Langues');
};
var $author$project$Components$Parametrage$LanguesDuClient$Update$RetraitDemande = function (a) {
	return {$: 16, a: a};
};
var $author$project$I18n$Cles$languesParDefaut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.par-defaut', _List_Nil, 'Langue par défaut');
};
var $author$project$I18n$Cles$languesRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.retirer', _List_Nil, 'Retirer');
};
var $author$project$I18n$Cles$languesToutesLesFiches = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'langues.toutes-les-fiches', _List_Nil, 'toutes les fiches');
};
var $author$project$I18n$Cles$languesValeurs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'langues.valeurs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeur') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeurs'));
	});
var $author$project$Components$Parametrage$LanguesDuClient$View$ligne = F3(
	function (i18n, model, langue) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('langue'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('par-defaut', langue.o6)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(langue.Bl)
								])),
							$rtfeldman$elm_css$Html$Styled$text(' '),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('code')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(langue.vx)
								])),
							langue.o6 ? A2(
							$author$project$Components$Shared$Tag$View$view,
							5,
							$author$project$I18n$Cles$languesParDefaut(i18n)) : $rtfeldman$elm_css$Html$Styled$text('')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('traductions')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							langue.o6 ? $author$project$I18n$Cles$languesToutesLesFiches(i18n) : A2(
								$author$project$I18n$Cles$languesValeurs,
								i18n,
								{w: langue.Kq}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					_List_fromArray(
						[
							function () {
							var _v0 = _Utils_Tuple2(
								langue.o6,
								$author$project$Components$Parametrage$LanguesDuClient$Model$lienDuRetrait(model));
							if ((!_v0.a) && (!_v0.b.$)) {
								return A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									2,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id('langues-retirer-' + langue.vx),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Parametrage$LanguesDuClient$Update$RetraitDemande(langue))
										]),
									$author$project$I18n$Cles$languesRetirer(i18n));
							} else {
								return $rtfeldman$elm_css$Html$Styled$text('');
							}
						}()
						]))
				]));
	});
var $author$project$Components$Parametrage$LanguesDuClient$View$tableau = F2(
	function (i18n, model) {
		var langues = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Ba;
				},
				model.Ba));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('card'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('langues')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$languesTableau(i18n)),
									$rtfeldman$elm_css$Html$Styled$text(' '),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$elm$core$String$fromInt(
												$elm$core$List$length(langues)))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('gestes')
								]),
							_List_fromArray(
								[
									function () {
									var _v0 = $author$project$Components$Parametrage$LanguesDuClient$Model$lienDuChangementDeDefaut(model);
									if (!_v0.$) {
										return A3(
											$author$project$Components$Shared$Bouton$View$bouton,
											1,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$id('langues-defaut-changer'),
													$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$LanguesDuClient$Update$ChangementDeDefautDemande)
												]),
											$author$project$I18n$Cles$languesChangerLeDefaut(i18n));
									} else {
										return $rtfeldman$elm_css$Html$Styled$text('');
									}
								}(),
									function () {
									var _v1 = $author$project$Components$Parametrage$LanguesDuClient$Model$lienDeLAjout(model);
									if (!_v1.$) {
										return A3(
											$author$project$Components$Shared$Bouton$View$bouton,
											1,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$id('langues-ajouter'),
													$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$LanguesDuClient$Update$AjoutDemande)
												]),
											$author$project$I18n$Cles$languesAjouter(i18n));
									} else {
										return $rtfeldman$elm_css$Html$Styled$text('');
									}
								}()
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$table,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$languesColonneLangue(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$languesColonneTraductions(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_Nil)
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$tbody,
							_List_Nil,
							A2(
								$elm$core$List$map,
								A2($author$project$Components$Parametrage$LanguesDuClient$View$ligne, i18n, model),
								langues))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$languesNote(i18n))
						]))
				]));
	});
var $author$project$Components$Parametrage$LanguesDuClient$View$view = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'parametrage-langues',
			{
				ut: model.qa ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('acces-refuse')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Note$View$view,
										1,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$coquilleAccesRefuse(i18n))
													]))
											]))
									]))
							]))
					]) : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						_List_fromArray(
							[
								A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
								model.gd ? A2(
								$author$project$Components$Shared$Note$View$view,
								2,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$languesEchecDeLecture(i18n))
									])) : $rtfeldman$elm_css$Html$Styled$text(''),
								A2($author$project$Components$Parametrage$LanguesDuClient$View$refusHorsDrawer, i18n, model),
								A2($author$project$Components$Parametrage$LanguesDuClient$View$tableau, i18n, model)
							]))
					]),
				xy: _List_fromArray(
					[
						A2($author$project$Components$Parametrage$LanguesDuClient$View$drawerDAjout, i18n, model),
						A2($author$project$Components$Parametrage$LanguesDuClient$View$drawerDuDefaut, i18n, model),
						A2($author$project$Components$Parametrage$LanguesDuClient$View$drawerDeRetrait, i18n, model),
						A2($author$project$Components$Parametrage$LanguesDuClient$View$drawerDeSuppression, i18n, model)
					]),
				zM: _List_Nil,
				AK: $author$project$Components$Parametrage$LanguesDuClient$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$languesDescription(i18n))
									]))
							]),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adresseTypesDePartiesPrenantes,
								Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
							},
								{
								aa: $author$project$Routes$Route$adresseDesLanguesDuClient,
								Dj: $author$project$I18n$Cles$languesFil(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$languesTitre(i18n)
					})
			});
	});
var $author$project$Components$Parametrage$ModelesDeTache$Update$ModificationDemandee = {$: 17};
var $author$project$Components$Parametrage$ModelesDeTache$Update$RestaurationDemandee = {$: 20};
var $author$project$Components$Parametrage$ModelesDeTache$Update$ArchivageDemande = {$: 19};
var $author$project$Components$Parametrage$ModelesDeTache$Update$DuplicationDemandee = {$: 18};
var $author$project$Components$Parametrage$ModelesDeTache$Update$NomSaisi = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Parametrage$ModelesDeTache$Update$NotesSaisies = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Parametrage$ModelesDeTache$Update$RoleSaisi = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Parametrage$ModelesDeTache$View$geste = F5(
	function (rel, msg, libelle, fiche, model) {
		return A2(
			$elm$core$Maybe$map,
			function (_v0) {
				return A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
							$author$project$API$Envoi$enCours(model.l2)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
						]),
					libelle);
			},
			A2($author$project$API$Liens$trouver, rel, fiche.nQ));
	});
var $author$project$I18n$Cles$modeleTacheDrawerArchive = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.drawer.archive', _List_Nil, 'Ce modèle est archivé : restaurez-le pour le modifier.');
};
var $author$project$I18n$Cles$modeleTacheDrawerArchiver = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.drawer.archiver', _List_Nil, 'Archiver');
};
var $author$project$I18n$Cles$modeleTacheDrawerDupliquer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.drawer.dupliquer', _List_Nil, 'Dupliquer');
};
var $author$project$I18n$Cles$modeleTacheDrawerLeModele = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.drawer.le-modele', _List_Nil, 'Le modèle');
};
var $author$project$I18n$Cles$modeleTacheDrawerNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.drawer.nom', _List_Nil, 'Nom');
};
var $author$project$I18n$Cles$modeleTacheDrawerNotes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'modele-tache.drawer.notes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'numero',
					$author$project$I18n$Traductions$Chaine(p.DX))
				]),
			'Notes de la prochaine version (v' + (p.DX + ')'));
	});
var $author$project$I18n$Cles$modeleTacheDrawerNotesCourantes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'modele-tache.drawer.notes-courantes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'numero',
					$author$project$I18n$Traductions$Chaine(p.DX))
				]),
			'Notes de la v' + p.DX);
	});
var $author$project$I18n$Cles$modeleTacheDrawerRole = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.drawer.role', _List_Nil, 'Rôle attendu');
};
var $author$project$I18n$Cles$modeleTacheDrawerRoleAide = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'modele-tache.drawer.role-aide',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'À l\'insertion dans un pipe, le rôle attendu « ' + (p.bi + ' » est associé à un rôle du dossier.'));
	});
var $author$project$Components$Parametrage$ModelesDeTache$Update$DelaiSaisi = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Parametrage$ModelesDeTache$Update$EscaladeSaisie = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Parametrage$ModelesDeTache$Update$RappelSaisi = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Parametrage$ModelesDeTache$Update$RegleSaisie = function (a) {
	return {$: 16, a: a};
};
var $author$project$I18n$Cles$pipeEtape4DecisionsAccepter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.decisions.accepter', _List_Nil, 'Accepter');
};
var $author$project$I18n$Cles$pipeEtape4DecisionsDemanderUneReprise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.decisions.demander-une-reprise', _List_Nil, 'Demander une reprise');
};
var $author$project$I18n$Cles$pipeEtape4DecisionsRefuser = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.decisions.refuser', _List_Nil, 'Refuser');
};
var $author$project$Components$Parametrage$Vocabulaire$decisionDeTache = F2(
	function (i18n, code) {
		switch (code) {
			case 'accepter':
				return $author$project$I18n$Cles$pipeEtape4DecisionsAccepter(i18n);
			case 'refuser':
				return $author$project$I18n$Cles$pipeEtape4DecisionsRefuser(i18n);
			case 'demander-une-reprise':
				return $author$project$I18n$Cles$pipeEtape4DecisionsDemanderUneReprise(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$Components$Parametrage$ModelesDeTache$View$jours = F6(
	function (_v0, libre, identifiant, libelle, valeur, surSaisie) {
		return libre ? A2(
			$author$project$Components$Shared$Champ$View$texte,
			{go: $elm$core$Maybe$Nothing, Aq: identifiant, Bl: libelle, he: false},
			{hg: surSaisie, fm: valeur}) : A2(
			$author$project$Components$Shared$Champ$View$texteEnLectureSeule,
			{go: $elm$core$Maybe$Nothing, Aq: identifiant, Bl: libelle, he: false},
			{fm: valeur});
	});
var $author$project$Components$Parametrage$Common$Conception$liste = F4(
	function (libelle, valeur, choix_, surChoix) {
		return A3(
			$rtfeldman$elm_css$Html$Styled$Keyed$node,
			'label',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('champ')
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(libelle)
							]))),
					_Utils_Tuple2(
					A2(
						$elm$core$String$join,
						'|',
						A2(
							$elm$core$List$cons,
							valeur,
							A2($elm$core$List$map, $elm$core$Tuple$first, choix_))),
					A2(
						$rtfeldman$elm_css$Html$Styled$select,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput(surChoix)
							]),
						A2(
							$elm$core$List$map,
							function (_v0) {
								var code = _v0.a;
								var texte = _v0.b;
								return A2(
									$rtfeldman$elm_css$Html$Styled$option,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(code),
											$rtfeldman$elm_css$Html$Styled$Attributes$selected(
											_Utils_eq(valeur, code))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(texte)
										]));
							},
							choix_)))
				]));
	});
var $author$project$I18n$Cles$modeleTacheDrawerDecisions = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'modele-tache.drawer.decisions',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'liste',
					$author$project$I18n$Traductions$Chaine(p.nW))
				]),
			'Décisions : ' + p.nW);
	});
var $author$project$I18n$Cles$modeleTacheDrawerDelai = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.drawer.delai', _List_Nil, 'Délai de réponse, en jours');
};
var $author$project$I18n$Cles$modeleTacheDrawerEscalade = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.drawer.escalade', _List_Nil, 'Escalade après, en jours');
};
var $author$project$I18n$Cles$modeleTacheDrawerRappel = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.drawer.rappel', _List_Nil, 'Relance, en jours avant l\'échéance');
};
var $author$project$I18n$Cles$modeleTacheDrawerReglage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.drawer.reglage', _List_Nil, 'Réglage');
};
var $author$project$I18n$Cles$modeleTacheDrawerRegle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.drawer.regle', _List_Nil, 'Règle de décision');
};
var $author$project$I18n$Cles$pipeEtape4DecisionMajorite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.decision.majorite', _List_Nil, 'Majorité');
};
var $author$project$I18n$Cles$pipeEtape4DecisionMajoriteAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.decision.majorite-aide', _List_Nil, 'Plus de la moitié accepte ; nombre minimum de réponses ci-dessous.');
};
var $author$project$I18n$Cles$pipeEtape4DecisionUnSeul = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.decision.un-seul', _List_Nil, 'Un seul valideur suffit');
};
var $author$project$I18n$Cles$pipeEtape4DecisionUnSeulAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.decision.un-seul-aide', _List_Nil, 'La première décision clôt la tâche.');
};
var $author$project$I18n$Cles$pipeEtape4DecisionUnanimite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.decision.unanimite', _List_Nil, 'Unanimité');
};
var $author$project$I18n$Cles$pipeEtape4DecisionUnanimiteAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.decision.unanimite-aide', _List_Nil, 'Tous les valideurs acceptent.');
};
var $author$project$Components$Parametrage$Vocabulaire$regleDeDecision = F2(
	function (i18n, code) {
		switch (code) {
			case 'un-seul-valideur':
				return _Utils_Tuple2(
					$author$project$I18n$Cles$pipeEtape4DecisionUnSeul(i18n),
					$author$project$I18n$Cles$pipeEtape4DecisionUnSeulAide(i18n));
			case 'unanimite':
				return _Utils_Tuple2(
					$author$project$I18n$Cles$pipeEtape4DecisionUnanimite(i18n),
					$author$project$I18n$Cles$pipeEtape4DecisionUnanimiteAide(i18n));
			case 'majorite':
				return _Utils_Tuple2(
					$author$project$I18n$Cles$pipeEtape4DecisionMajorite(i18n),
					$author$project$I18n$Cles$pipeEtape4DecisionMajoriteAide(i18n));
			default:
				var autre = code;
				return _Utils_Tuple2(autre, '');
		}
	});
var $author$project$Components$Parametrage$ModelesDeTache$View$reglage = F4(
	function (i18n, libre, model, fiche) {
		var regle = $elm$core$Result$toMaybe(
			A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$field, 'regle', $elm$json$Json$Decode$string),
				fiche.eO));
		var decisions = A2(
			$elm$core$Result$withDefault,
			_List_Nil,
			A2(
				$elm$json$Json$Decode$decodeValue,
				A2(
					$elm$json$Json$Decode$field,
					'decisions',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
				fiche.eO));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('reglage')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$modeleTacheDrawerReglage(i18n))
						])),
					function () {
					if (!regle.$) {
						var code = regle.a;
						return libre ? A4(
							$author$project$Components$Parametrage$Common$Conception$liste,
							$author$project$I18n$Cles$modeleTacheDrawerRegle(i18n),
							model.hP.hH,
							A2(
								$elm$core$List$map,
								function (autre) {
									return _Utils_Tuple2(
										autre,
										A2($author$project$Components$Parametrage$Vocabulaire$regleDeDecision, i18n, autre).a);
								},
								_List_fromArray(
									['un-seul-valideur', 'unanimite', 'majorite'])),
							$author$project$Components$Parametrage$ModelesDeTache$Update$RegleSaisie) : A2(
							$author$project$Components$Shared$Champ$View$texteEnLectureSeule,
							{
								go: $elm$core$Maybe$Nothing,
								Aq: 'modele-regle',
								Bl: $author$project$I18n$Cles$modeleTacheDrawerRegle(i18n),
								he: false
							},
							{
								fm: A2($author$project$Components$Parametrage$Vocabulaire$regleDeDecision, i18n, code).a
							});
					} else {
						return $rtfeldman$elm_css$Html$Styled$text('');
					}
				}(),
					A6(
					$author$project$Components$Parametrage$ModelesDeTache$View$jours,
					i18n,
					libre,
					'modele-delai',
					$author$project$I18n$Cles$modeleTacheDrawerDelai(i18n),
					model.hP.w2,
					$author$project$Components$Parametrage$ModelesDeTache$Update$DelaiSaisi),
					A6(
					$author$project$Components$Parametrage$ModelesDeTache$View$jours,
					i18n,
					libre,
					'modele-rappel',
					$author$project$I18n$Cles$modeleTacheDrawerRappel(i18n),
					model.hP.GU,
					$author$project$Components$Parametrage$ModelesDeTache$Update$RappelSaisi),
					A6(
					$author$project$Components$Parametrage$ModelesDeTache$View$jours,
					i18n,
					libre,
					'modele-escalade',
					$author$project$I18n$Cles$modeleTacheDrawerEscalade(i18n),
					model.hP.yy,
					$author$project$Components$Parametrage$ModelesDeTache$Update$EscaladeSaisie),
					$elm$core$List$isEmpty(decisions) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$modeleTacheDrawerDecisions,
								i18n,
								{
									nW: A2(
										$elm$core$String$join,
										' · ',
										A2(
											$elm$core$List$map,
											$author$project$Components$Parametrage$Vocabulaire$decisionDeTache(i18n),
											decisions))
								}))
						]))
				]));
	});
var $author$project$Components$Parametrage$ModelesDeTache$View$rolesProposes = F2(
	function (actuel, employes) {
		return A2(
			$elm$core$List$map,
			function (role) {
				return {Bl: role, fm: role};
			},
			((actuel === '') || A2($elm$core$List$member, actuel, employes)) ? employes : A2($elm$core$List$cons, actuel, employes));
	});
var $author$project$I18n$Cles$modeleTacheDrawerAJour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.drawer.a-jour', _List_Nil, 'À jour');
};
var $author$project$I18n$Cles$modeleTacheDrawerDisponible = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'modele-tache.drawer.disponible',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'numero',
					$author$project$I18n$Traductions$Chaine(p.DX))
				]),
			'v' + (p.DX + ' disponible'));
	});
var $author$project$I18n$Cles$modeleTacheDrawerOuvrirLaTache = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.drawer.ouvrir-la-tache', _List_Nil, 'Ouvrir la tâche');
};
var $author$project$Components$Parametrage$ModelesDeTache$View$ligneUtilisation = F2(
	function (i18n, u) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('utilisation')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('pipe')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(u.Bl)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(u.KJ)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							'v' + ($elm$core$String$fromInt(u.KI) + ' ')),
							(_Utils_cmp(u.KH, u.KI) > 0) ? A2(
							$author$project$Components$Shared$Tag$View$view,
							1,
							A2(
								$author$project$I18n$Cles$modeleTacheDrawerDisponible,
								i18n,
								{
									DX: $elm$core$String$fromInt(u.KH)
								})) : A2(
							$author$project$Components$Shared$Tag$View$view,
							0,
							$author$project$I18n$Cles$modeleTacheDrawerAJour(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							u.EA ? A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href(
									$author$project$Routes$Route$adressePipeEtape4(u.vx))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$modeleTacheDrawerOuvrirLaTache(i18n))
								])) : $rtfeldman$elm_css$Html$Styled$text('—')
						]))
				]));
	});
var $author$project$I18n$Cles$modeleTacheDrawerColonneAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.drawer.colonne-action', _List_Nil, 'Action');
};
var $author$project$I18n$Cles$modeleTacheDrawerColonnePipe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.drawer.colonne-pipe', _List_Nil, 'Pipe');
};
var $author$project$I18n$Cles$modeleTacheDrawerColonneVersionModele = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.drawer.colonne-version-modele', _List_Nil, 'Version du modèle');
};
var $author$project$I18n$Cles$modeleTacheDrawerColonneVersionPipe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.drawer.colonne-version-pipe', _List_Nil, 'Version du pipe');
};
var $author$project$I18n$Cles$modeleTacheDrawerUtiliseAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.drawer.utilise-aide', _List_Nil, 'Insérer un modèle copie la tâche dans le pipe. Une nouvelle version du modèle ne change aucun pipe publié : elle est proposée dans le brouillon, et appliquée seulement si on l\'accepte.');
};
var $author$project$I18n$Cles$modeleTacheDrawerUtilisePar = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.drawer.utilise-par', _List_Nil, 'Utilisé par');
};
var $author$project$I18n$Cles$modeleTacheDrawerUtiliseVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.drawer.utilise-vide', _List_Nil, 'Aucun pipe n\'utilise encore ce modèle.');
};
var $author$project$Components$Parametrage$ModelesDeTache$View$utilisePar = F2(
	function (i18n, fiche) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('utilise-par')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$modeleTacheDrawerUtilisePar(i18n))
						])),
					$elm$core$List$isEmpty(fiche.sf) ? A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$modeleTacheDrawerUtiliseVide(i18n))
						])) : A2(
					$rtfeldman$elm_css$Html$Styled$table,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (cle) {
											return A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(cle)
													]));
										},
										_List_fromArray(
											[
												$author$project$I18n$Cles$modeleTacheDrawerColonnePipe(i18n),
												$author$project$I18n$Cles$modeleTacheDrawerColonneVersionPipe(i18n),
												$author$project$I18n$Cles$modeleTacheDrawerColonneVersionModele(i18n),
												$author$project$I18n$Cles$modeleTacheDrawerColonneAction(i18n)
											])))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$tbody,
							_List_Nil,
							A2(
								$elm$core$List$map,
								$author$project$Components$Parametrage$ModelesDeTache$View$ligneUtilisation(i18n),
								fiche.sf))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$modeleTacheDrawerUtiliseAide(i18n))
						]))
				]));
	});
var $author$project$Components$Parametrage$ModelesDeTache$View$contenuDeLaFiche = F4(
	function (i18n, model, fiche, libre) {
		var champ = F2(
			function (id_, libelle) {
				return {go: $elm$core$Maybe$Nothing, Aq: id_, Bl: libelle, he: false};
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('fiche')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$modeleTacheDrawerLeModele(i18n))
						])),
					libre ? A2(
					$author$project$Components$Shared$Champ$View$texte,
					A2(
						champ,
						'modele-nom',
						$author$project$I18n$Cles$modeleTacheDrawerNom(i18n)),
					{hg: $author$project$Components$Parametrage$ModelesDeTache$Update$NomSaisi, fm: model.hP.Dj}) : A2(
					$author$project$Components$Shared$Champ$View$texteEnLectureSeule,
					A2(
						champ,
						'modele-nom',
						$author$project$I18n$Cles$modeleTacheDrawerNom(i18n)),
					{
						fm: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(fiche.R)
					}),
					libre ? A2(
					$author$project$Components$Shared$Champ$View$liste,
					A2(
						champ,
						'modele-role',
						$author$project$I18n$Cles$modeleTacheDrawerRole(i18n)),
					{
						hg: $author$project$Components$Parametrage$ModelesDeTache$Update$RoleSaisi,
						o_: A2($author$project$Components$Parametrage$ModelesDeTache$View$rolesProposes, model.hP.bi, fiche.Ia),
						fm: model.hP.bi
					}) : A2(
					$author$project$Components$Shared$Champ$View$texteEnLectureSeule,
					A2(
						champ,
						'modele-role',
						$author$project$I18n$Cles$modeleTacheDrawerRole(i18n)),
					{
						fm: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(fiche.qP)
					}),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$modeleTacheDrawerRoleAide,
								i18n,
								{
									bi: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(fiche.qP)
								}))
						])),
					$elm$core$Dict$isEmpty(fiche.DU) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
					$author$project$Components$Shared$Champ$View$texteEnLectureSeule,
					A2(
						champ,
						'modele-notes-courantes',
						A2(
							$author$project$I18n$Cles$modeleTacheDrawerNotesCourantes,
							i18n,
							{
								DX: $elm$core$String$fromInt(fiche.sq)
							})),
					{
						fm: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(fiche.DU)
					}),
					libre ? A2(
					$author$project$Components$Shared$Champ$View$texte,
					A2(
						champ,
						'modele-notes',
						A2(
							$author$project$I18n$Cles$modeleTacheDrawerNotes,
							i18n,
							{
								DX: $elm$core$String$fromInt(fiche.sq + 1)
							})),
					{hg: $author$project$Components$Parametrage$ModelesDeTache$Update$NotesSaisies, fm: model.hP.oL}) : A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('archive')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$modeleTacheDrawerArchive(i18n))
						])),
					A4($author$project$Components$Parametrage$ModelesDeTache$View$reglage, i18n, libre, model, fiche),
					A2($author$project$Components$Parametrage$ModelesDeTache$View$utilisePar, i18n, fiche),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('gestes')
						]),
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								A5(
								$author$project$Components$Parametrage$ModelesDeTache$View$geste,
								$author$project$API$NavLinksDictionary$dupliquerUnModeleDeTache,
								$author$project$Components$Parametrage$ModelesDeTache$Update$DuplicationDemandee,
								$author$project$I18n$Cles$modeleTacheDrawerDupliquer(i18n),
								fiche,
								model),
								A5(
								$author$project$Components$Parametrage$ModelesDeTache$View$geste,
								$author$project$API$NavLinksDictionary$archiverUnModeleDeTache,
								$author$project$Components$Parametrage$ModelesDeTache$Update$ArchivageDemande,
								$author$project$I18n$Cles$modeleTacheDrawerArchiver(i18n),
								fiche,
								model)
							])))
				]));
	});
var $author$project$I18n$Cles$modeleTacheDrawerKicker = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'modele-tache.drawer.kicker',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'genre',
					$author$project$I18n$Traductions$Chaine(p.M))
				]),
			'Modèle de tâche · ' + p.M);
	});
var $author$project$I18n$Cles$modeleTacheDrawerModifier = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'modele-tache.drawer.modifier',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'numero',
					$author$project$I18n$Traductions$Chaine(p.DX))
				]),
			'Modifier (crée la v' + (p.DX + ')'));
	});
var $author$project$I18n$Cles$modeleTacheDrawerRestaurer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.drawer.restaurer', _List_Nil, 'Restaurer');
};
var $author$project$I18n$Cles$modeleTacheDrawerTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'modele-tache.drawer.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'numero',
					$author$project$I18n$Traductions$Chaine(p.DX))
				]),
			p.Dj + (' · v' + p.DX));
	});
var $author$project$I18n$Textes$pipeEtape4TypeActionManuelle = A3($author$project$I18n$Traductions$texte, 'pipe-etape-4.type.action-manuelle', _List_Nil, 'Action manuelle');
var $author$project$I18n$Textes$pipeEtape4TypeAgentIa = A3($author$project$I18n$Traductions$texte, 'pipe-etape-4.type.agent-ia', _List_Nil, 'Agent IA');
var $author$project$I18n$Textes$pipeEtape4TypeAttente = A3($author$project$I18n$Traductions$texte, 'pipe-etape-4.type.attente', _List_Nil, 'Attente');
var $author$project$I18n$Textes$pipeEtape4TypeCommunication = A3($author$project$I18n$Traductions$texte, 'pipe-etape-4.type.communication', _List_Nil, 'Communication');
var $author$project$I18n$Textes$pipeEtape4TypeDocumentEtSignature = A3($author$project$I18n$Traductions$texte, 'pipe-etape-4.type.document-et-signature', _List_Nil, 'Document et signature');
var $author$project$I18n$Textes$pipeEtape4TypeEchange = A3($author$project$I18n$Traductions$texte, 'pipe-etape-4.type.echange', _List_Nil, 'Échange');
var $author$project$I18n$Textes$pipeEtape4TypeEvaluation = A3($author$project$I18n$Traductions$texte, 'pipe-etape-4.type.evaluation', _List_Nil, 'Évaluation');
var $author$project$I18n$Textes$pipeEtape4TypePaiement = A3($author$project$I18n$Traductions$texte, 'pipe-etape-4.type.paiement', _List_Nil, 'Paiement');
var $author$project$I18n$Textes$pipeEtape4TypeRendezVous = A3($author$project$I18n$Traductions$texte, 'pipe-etape-4.type.rendez-vous', _List_Nil, 'Rendez-vous');
var $author$project$I18n$Textes$pipeEtape4TypeSaisie = A3($author$project$I18n$Traductions$texte, 'pipe-etape-4.type.saisie', _List_Nil, 'Saisie');
var $author$project$I18n$Textes$pipeEtape4TypeSousDossier = A3($author$project$I18n$Traductions$texte, 'pipe-etape-4.type.sous-dossier', _List_Nil, 'Sous-dossier');
var $author$project$I18n$Textes$pipeEtape4TypeValidation = A3($author$project$I18n$Traductions$texte, 'pipe-etape-4.type.validation', _List_Nil, 'Validation');
var $author$project$Components$Parametrage$Vocabulaire$typeDeTache = function (code) {
	switch (code) {
		case 'saisie':
			return $author$project$I18n$Textes$pipeEtape4TypeSaisie;
		case 'evaluation':
			return $author$project$I18n$Textes$pipeEtape4TypeEvaluation;
		case 'validation':
			return $author$project$I18n$Textes$pipeEtape4TypeValidation;
		case 'action-manuelle':
			return $author$project$I18n$Textes$pipeEtape4TypeActionManuelle;
		case 'attente':
			return $author$project$I18n$Textes$pipeEtape4TypeAttente;
		case 'sous-dossier':
			return $author$project$I18n$Textes$pipeEtape4TypeSousDossier;
		case 'echange':
			return $author$project$I18n$Textes$pipeEtape4TypeEchange;
		case 'communication':
			return $author$project$I18n$Textes$pipeEtape4TypeCommunication;
		case 'rendez-vous':
			return $author$project$I18n$Textes$pipeEtape4TypeRendezVous;
		case 'paiement':
			return $author$project$I18n$Textes$pipeEtape4TypePaiement;
		case 'document-et-signature':
			return $author$project$I18n$Textes$pipeEtape4TypeDocumentEtSignature;
		case 'agent-ia':
			return $author$project$I18n$Textes$pipeEtape4TypeAgentIa;
		default:
			var autre = code;
			return $author$project$I18n$Traductions$tel(autre);
	}
};
var $author$project$Components$Parametrage$ModelesDeTache$View$contenuDuDrawer = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(model.kX),
			model.zo);
		if (_v0.a && (!_v0.b.$)) {
			var fiche = _v0.b.a;
			var restaurable = !_Utils_eq(
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$restaurerUnModeleDeTache, fiche.nQ),
				$elm$core$Maybe$Nothing);
			var libre = !_Utils_eq(
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierUnModeleDeTache, fiche.nQ),
				$elm$core$Maybe$Nothing);
			var libelleDeLAction = restaurable ? $author$project$I18n$Cles$modeleTacheDrawerRestaurer(i18n) : A2(
				$author$project$I18n$Cles$modeleTacheDrawerModifier,
				i18n,
				{
					DX: $elm$core$String$fromInt(fiche.sq + 1)
				});
			return {
				fs: {
					sR: (libre || restaurable) && (!$author$project$API$Envoi$enCours(model.l2)),
					Bl: libelleDeLAction,
					C$: restaurable ? $author$project$Components$Parametrage$ModelesDeTache$Update$RestaurationDemandee : $author$project$Components$Parametrage$ModelesDeTache$Update$ModificationDemandee
				},
				fZ: _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Messages$View$view,
						i18n,
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2($elm$core$Maybe$map, $elm$core$List$singleton, model.pZ))),
						A4($author$project$Components$Parametrage$ModelesDeTache$View$contenuDeLaFiche, i18n, model, fiche, libre)
					]),
				A6: $elm$core$Maybe$Just(
					A2(
						$author$project$I18n$Cles$modeleTacheDrawerKicker,
						i18n,
						{
							M: A2(
								$author$project$I18n$Cles$texte,
								i18n,
								$author$project$Components$Parametrage$Vocabulaire$typeDeTache(fiche.M))
						})),
				Bc: false,
				h6: A2(
					$author$project$I18n$Cles$modeleTacheDrawerTitre,
					i18n,
					{
						Dj: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(fiche.R),
						DX: $elm$core$String$fromInt(fiche.sq)
					})
			};
		} else {
			return {
				fs: {sR: false, Bl: '', C$: $author$project$Components$Parametrage$ModelesDeTache$Update$ModificationDemandee},
				fZ: _List_Nil,
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: ''
			};
		}
	});
var $author$project$Components$Parametrage$ModelesDeTache$View$drawer = F2(
	function (i18n, model) {
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Parametrage$ModelesDeTache$Update$DuDrawer,
			A2($author$project$Components$Parametrage$ModelesDeTache$View$contenuDuDrawer, i18n, model),
			model.kX);
	});
var $author$project$Components$Parametrage$ModelesDeTache$Update$ArchivesChoisies = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Parametrage$ModelesDeTache$Update$GenreChoisi = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Parametrage$ModelesDeTache$Update$RechercheSaisie = function (a) {
	return {$: 4, a: a};
};
var $author$project$I18n$Cles$modeleTacheArchives = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.archives', _List_Nil, 'Afficher les modèles archivés');
};
var $author$project$I18n$Cles$modeleTacheRecherche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.recherche', _List_Nil, 'Chercher un modèle');
};
var $author$project$I18n$Cles$modeleTacheType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.type', _List_Nil, 'Type');
};
var $author$project$I18n$Cles$modeleTacheTypeTous = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.type-tous', _List_Nil, 'Tous les types');
};
var $author$project$Components$Parametrage$ModelesDeTache$View$types = _List_fromArray(
	['saisie', 'validation', 'evaluation', 'action-manuelle', 'attente', 'sous-dossier', 'echange', 'communication', 'rendez-vous', 'paiement', 'document-et-signature', 'agent-ia']);
var $author$project$Components$Parametrage$ModelesDeTache$View$filtres = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('filtres')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Champ$View$texte,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: 'modeles-recherche',
						Bl: $author$project$I18n$Cles$modeleTacheRecherche(i18n),
						he: false
					},
					{hg: $author$project$Components$Parametrage$ModelesDeTache$Update$RechercheSaisie, fm: model.hC}),
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: 'modeles-type',
						Bl: $author$project$I18n$Cles$modeleTacheType(i18n),
						he: false
					},
					{
						hg: $author$project$Components$Parametrage$ModelesDeTache$Update$GenreChoisi,
						o_: A2(
							$elm$core$List$cons,
							{
								Bl: $author$project$I18n$Cles$modeleTacheTypeTous(i18n),
								fm: ''
							},
							A2(
								$elm$core$List$map,
								function (code) {
									return {
										Bl: A2(
											$author$project$I18n$Cles$texte,
											i18n,
											$author$project$Components$Parametrage$Vocabulaire$typeDeTache(code)),
										fm: code
									};
								},
								$author$project$Components$Parametrage$ModelesDeTache$View$types)),
						fm: model.M
					}),
					A2(
					$author$project$Components$Shared$Champ$View$caseACocher,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: 'modeles-archives',
						Bl: $author$project$I18n$Cles$modeleTacheArchives(i18n),
						he: false
					},
					{vt: model.i$, D9: $author$project$Components$Parametrage$ModelesDeTache$Update$ArchivesChoisies})
				]));
	});
var $author$project$I18n$Cles$modeleTacheArchive = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.archive', _List_Nil, 'Archivé');
};
var $author$project$I18n$Cles$modeleTacheVersion = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'modele-tache.version',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'numero',
					$author$project$I18n$Traductions$Chaine(p.DX))
				]),
			'Version ' + p.DX);
	});
var $author$project$Components$Parametrage$ModelesDeTache$Update$FicheDemandee = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$Parametrage$ModelesDeTache$View$titre = function (carte) {
	var _v0 = carte.Ey;
	if (!_v0.$) {
		var lien = _v0.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('title'),
					$rtfeldman$elm_css$Html$Styled$Attributes$id(
					$author$project$Components$Parametrage$ModelesDeTache$Model$idDuDeclencheur(carte.r8)),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					A2($author$project$Components$Parametrage$ModelesDeTache$Update$FicheDemandee, carte.r8, lien))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(carte.R))
				]));
	} else {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('title')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(carte.R))
				]));
	}
};
var $author$project$Components$Parametrage$ModelesDeTache$View$ligne = F2(
	function (i18n, carte) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('item')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('cartouche-modele-tache')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('content')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('main')
										]),
									_List_fromArray(
										[
											$author$project$Components$Parametrage$ModelesDeTache$View$titre(carte),
											A2(
											$rtfeldman$elm_css$Html$Styled$ul,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('infos')
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Components$Shared$Tag$View$view,
															3,
															A2(
																$author$project$I18n$Cles$texte,
																i18n,
																$author$project$Components$Parametrage$Vocabulaire$typeDeTache(carte.M)))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(carte.qP))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															A2(
																$author$project$I18n$Cles$modeleTacheVersion,
																i18n,
																{
																	DX: $elm$core$String$fromInt(carte.sq)
																}))
														]))
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('aside')
										]),
									(carte.gt === 'archive') ? _List_fromArray(
										[
											A2(
											$author$project$Components$Shared$Tag$View$view,
											1,
											$author$project$I18n$Cles$modeleTacheArchive(i18n))
										]) : _List_Nil)
								]))
						]))
				]));
	});
var $author$project$I18n$Cles$modeleTacheListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.liste', _List_Nil, 'Les modèles de votre bibliothèque');
};
var $author$project$I18n$Cles$modeleTacheVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.vide', _List_Nil, 'Aucun modèle ne correspond.');
};
var $author$project$Components$Parametrage$ModelesDeTache$View$liste = F2(
	function (i18n, cartes) {
		return $elm$core$List$isEmpty(cartes) ? A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$I18n$Cles$modeleTacheVide(i18n))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('titre-de-liste')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$modeleTacheListe(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('list')
						]),
					A2(
						$elm$core$List$map,
						$author$project$Components$Parametrage$ModelesDeTache$View$ligne(i18n),
						cartes))
				]));
	});
var $author$project$I18n$Cles$modeleTacheSousTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.sous-titre', _List_Nil, 'La bibliothèque des tâches que l\'on insère dans les étapes des pipes.');
};
var $author$project$I18n$Cles$modeleTacheTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'modele-tache.titre', _List_Nil, 'Modèles de tâches');
};
var $author$project$Components$Parametrage$ModelesDeTache$Update$PageChoisie = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Shared$Annuaire$View$PaginationTenue = function (a) {
	return {$: 1, a: a};
};
var $author$project$API$NavLinksDictionary$pagePrecedente = 'page-precedente';
var $author$project$Components$Parametrage$ModelesDeTache$View$pied = F2(
	function (i18n, page) {
		var vers = function (rel) {
			return A2(
				$elm$core$Maybe$map,
				$author$project$Components$Parametrage$ModelesDeTache$Update$PageChoisie,
				A2($author$project$API$Liens$trouver, rel, page.nQ));
		};
		var debut = ((page.EE - 1) * page.Jm) + 1;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pied-de-liste')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('plage')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$annuairePaginationPlage,
								i18n,
								{
									ku: $elm$core$String$fromInt(
										(!page.JE) ? 0 : debut),
									mI: $elm$core$String$fromInt(
										(debut + $elm$core$List$length(page.CI)) - 1),
									JE: $elm$core$String$fromInt(page.JE)
								}))
						])),
					A2(
					$author$project$Components$Shared$Annuaire$View$pagination,
					i18n,
					$author$project$Components$Shared$Annuaire$View$PaginationTenue(
						{
							Gc: vers($author$project$API$NavLinksDictionary$pagePrecedente),
							I7: vers($author$project$API$NavLinksDictionary$pageSuivante)
						}))
				]));
	});
var $author$project$I18n$Cles$pipeEtape1Introuvable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.introuvable', _List_Nil, 'Ce pipe n\'existe pas.');
};
var $author$project$I18n$Cles$pipesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipes.titre', _List_Nil, 'Modèles de pipes');
};
var $author$project$Components$Parametrage$ModelesDeTache$View$view = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'parametrage-modeles-de-tache',
			{
				ut: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('main')
							]),
						A2(
							$elm$core$List$cons,
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							function () {
								var _v0 = _Utils_Tuple2(model.EE, model.nf);
								if (!_v0.a.$) {
									var page = _v0.a.a;
									return _List_fromArray(
										[
											A2($author$project$Components$Parametrage$ModelesDeTache$View$filtres, i18n, model),
											A2($author$project$Components$Parametrage$ModelesDeTache$View$liste, i18n, page.CI),
											A2($author$project$Components$Parametrage$ModelesDeTache$View$pied, i18n, page)
										]);
								} else {
									if (_v0.b) {
										var _v1 = _v0.a;
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$pipeEtape1Introuvable(i18n))
													]))
											]);
									} else {
										var _v2 = _v0.a;
										return _List_Nil;
									}
								}
							}()))
					]),
				xy: _List_fromArray(
					[
						A2($author$project$Components$Parametrage$ModelesDeTache$View$drawer, i18n, model)
					]),
				zM: _List_Nil,
				AK: $author$project$Components$Parametrage$ModelesDeTache$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$modeleTacheSousTitre(i18n))
									]))
							]),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adressePipes,
								Dj: $author$project$I18n$Cles$pipesTitre(i18n)
							},
								{
								aa: $author$project$Routes$Route$adresseModelesDeTache,
								Dj: $author$project$I18n$Cles$modeleTacheTitre(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$modeleTacheTitre(i18n)
					})
			});
	});
var $author$project$I18n$Cles$pipeDestinationsPublier = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-destinations.publier',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'version',
					$author$project$I18n$Traductions$Chaine(p.sq))
				]),
			'Publier la v' + p.sq);
	});
var $author$project$I18n$Cles$pipeDestinationsVerifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-destinations.verifier', _List_Nil, 'Vérifier');
};
var $author$project$Components$Parametrage$PipeDestinations$View$actions = F3(
	function (i18n, code, page) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('actions-bandeau')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$lien,
					1,
					$author$project$Routes$Route$adressePipeEtape8(code),
					$author$project$I18n$Cles$pipeDestinationsVerifier(i18n)),
					A3(
					$author$project$Components$Shared$Bouton$View$lien,
					0,
					$author$project$Routes$Route$adressePipeEtape8(code),
					A2(
						$author$project$I18n$Cles$pipeDestinationsPublier,
						i18n,
						{
							sq: $elm$core$String$fromInt(page.KL)
						}))
				]));
	});
var $author$project$Components$Parametrage$PipeDestinations$Model$aValider = $elm$core$List$filter(
	function (ligne) {
		return !_Utils_eq(ligne.sI, $elm$core$Maybe$Nothing);
	});
var $author$project$I18n$Cles$pipeDestinationsCroiseAValider = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-destinations.croise.a-valider',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'« À valider » : la valeur saisie est proposée sur la fiche et n\'est écrite qu\'après validation par ' + (p.bi + '.'));
	});
var $author$project$Components$Parametrage$PipeDestinations$View$noteAValider = F3(
	function (i18n, page, champ) {
		return A2(
			$elm$core$Maybe$map,
			function (validateur) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('a-valider')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$pipeDestinationsCroiseAValider,
								i18n,
								{
									bi: A2($author$project$Catalogue$Formes$avecUn, validateur.m$, validateur.Bl)
								}))
						]));
			},
			A2(
				$elm$core$Maybe$andThen,
				function (roleUid) {
					return $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (role) {
								return _Utils_eq(role.r8, roleUid);
							},
							page.Kr));
				},
				champ.sI));
	});
var $author$project$I18n$Cles$pipeEtape5ControleDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.controle.detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN)),
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi)),
					_Utils_Tuple2(
					'etape',
					$author$project$I18n$Traductions$Chaine(p.me))
				]),
			' « ' + (p.uN + (' » : le rôle ' + (p.bi + (' n\'a pas le droit de modifier ce champ de la fiche à l\'étape « ' + (p.me + ' » (étape 6). Changez la destination ou la visibilité ; sinon la publication est bloquée.'))))));
	});
var $author$project$I18n$Cles$pipeEtape5ControleNonModifiable = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.controle.non-modifiable',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Non modifiable par ' + (p.bi + ' à cette étape.'));
	});
var $author$project$Components$Parametrage$PipeDestinations$View$phraseDuBlocage = F2(
	function (i18n, champ) {
		return A3(
			$elm$core$Maybe$map2,
			F2(
				function (role, etape) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('encart')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$pipeEtape5ControleNonModifiable,
											i18n,
											{bi: role.Bl}))
									])),
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$pipeEtape5ControleDetail,
									i18n,
									{
										uN: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(champ.R),
										me: etape,
										bi: role.Bl
									}))
							]));
				}),
			champ.bi,
			champ.me);
	});
var $author$project$I18n$Cles$pipeEtape5ControleOuvrir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.controle.ouvrir', _List_Nil, 'Ouvrir la visibilité de l\'étape');
};
var $author$project$I18n$Cles$pipeEtape5ControleTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.controle.titre', _List_Nil, 'Contrôle croisé destination × visibilité');
};
var $author$project$Components$Parametrage$PipeDestinations$Model$quiBloquent = $elm$core$List$filter(
	function ($) {
		return $.ur;
	});
var $author$project$Components$Parametrage$PipeDestinations$View$bloquants = F3(
	function (i18n, code, page) {
		var notes = A2(
			$elm$core$List$filterMap,
			A2($author$project$Components$Parametrage$PipeDestinations$View$noteAValider, i18n, page),
			A2(
				$elm$core$List$take,
				1,
				$author$project$Components$Parametrage$PipeDestinations$Model$aValider(page.gV)));
		var bloques = $author$project$Components$Parametrage$PipeDestinations$Model$quiBloquent(page.gV);
		var bouton = $elm$core$List$isEmpty(bloques) ? _List_Nil : _List_fromArray(
			[
				A2(
				$elm$core$List$all,
				function (champ) {
					return _Utils_eq(champ.KQ, $elm$core$Maybe$Nothing);
				},
				bloques) ? A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
					]),
				$author$project$I18n$Cles$pipeEtape5ControleOuvrir(i18n)) : A3(
				$author$project$Components$Shared$Bouton$View$lien,
				1,
				$author$project$Routes$Route$adressePipeEtape6(code),
				$author$project$I18n$Cles$pipeEtape5ControleOuvrir(i18n))
			]);
		return ($elm$core$List$isEmpty(bloques) && $elm$core$List$isEmpty(notes)) ? _List_Nil : _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('controle-croise')
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$h2,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape5ControleTitre(i18n))
							])),
					_Utils_ap(
						A2(
							$elm$core$List$filterMap,
							$author$project$Components$Parametrage$PipeDestinations$View$phraseDuBlocage(i18n),
							bloques),
						_Utils_ap(bouton, notes))))
			]);
	});
var $author$project$Components$Parametrage$PipeDestinations$Model$ligneDeLaRessourceLiee = function (lignes) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (ligne) {
				return ligne.xw.r0 === 'va-sur-la-ressource-liee';
			},
			lignes));
};
var $author$project$Components$Parametrage$PipeDestinations$View$liste = F2(
	function (titre, choix) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('liste')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(titre)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$select,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
						]),
					A2(
						$elm$core$List$map,
						function (_v0) {
							var code = _v0.a;
							var libelle = _v0.b;
							var choisi = _v0.c;
							return A2(
								$rtfeldman$elm_css$Html$Styled$option,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value(code),
										$rtfeldman$elm_css$Html$Styled$Attributes$selected(choisi)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(libelle)
									]));
						},
						choix))
				]));
	});
var $author$project$I18n$Cles$pipeDestinationsRessourceAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-destinations.ressource.aide', _List_Nil, 'Une ressource liée est un document ou un objet rattaché au dossier, avec ses propres champs.');
};
var $author$project$I18n$Cles$pipeDestinationsRessourceChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-destinations.ressource.champ', _List_Nil, 'Champ de la ressource');
};
var $author$project$I18n$Cles$pipeDestinationsRessourceDestination = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-destinations.ressource.destination', _List_Nil, 'Destination');
};
var $author$project$I18n$Cles$pipeDestinationsRessourceRessource = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-destinations.ressource.ressource', _List_Nil, 'Ressource liée');
};
var $author$project$I18n$Cles$pipeDestinationsRessourceTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-destinations.ressource.titre', _List_Nil, 'Destination « ressource liée »');
};
var $author$project$I18n$Choix$ArticleAucun = 0;
var $author$project$I18n$Choix$ArticleOther = 4;
var $author$project$I18n$Choix$ArticleElide = 1;
var $author$project$I18n$Choix$ArticleLa = 2;
var $author$project$I18n$Choix$ArticleLe = 3;
var $author$project$Catalogue$Formes$articleDe = function (forme) {
	if (forme.av) {
		return 1;
	} else {
		var _v0 = forme.M;
		if (!_v0) {
			return 3;
		} else {
			return 2;
		}
	}
};
var $author$project$Catalogue$Formes$article = function (formes) {
	return A2(
		$elm$core$Maybe$withDefault,
		4,
		A2(
			$elm$core$Maybe$map,
			function (lues) {
				return $author$project$Catalogue$Formes$articleDe(lues.zX);
			},
			formes));
};
var $author$project$I18n$Cles$pipeDestinationsDestinationEstRangeAvecLesDocuments = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-destinations.destination.est-range-avec-les-documents', _List_Nil, 'Rangé avec les documents du dossier');
};
var $author$project$I18n$Cles$pipeDestinationsDestinationResteDansLaReponse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-destinations.destination.reste-dans-la-reponse', _List_Nil, 'Réponse de la tâche');
};
var $author$project$I18n$Cles$pipeDestinationsDestinationResteSurLeDossier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-destinations.destination.reste-sur-le-dossier', _List_Nil, 'Champ du dossier');
};
var $author$project$I18n$Cles$pipeDestinationsDestinationVaSurLaFicheDUnAutreRole = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-destinations.destination.va-sur-la-fiche-d-un-autre-role', _List_Nil, 'Fiche d\'un participant');
};
var $author$project$I18n$Choix$codeArticle = function (choix) {
	switch (choix) {
		case 0:
			return 'aucun';
		case 1:
			return 'elide';
		case 2:
			return 'la';
		case 3:
			return 'le';
		default:
			return 'other';
	}
};
var $author$project$I18n$Cles$pipeDestinationsDestinationVaSurLaFicheVisee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-destinations.destination.va-sur-la-fiche-visee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'article',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeArticle(p.i4))),
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Fiche ' + (function () {
				var _v0 = p.i4;
				switch (_v0) {
					case 0:
						return '';
					case 1:
						return 'de l\'' + $elm$core$String$toLower(p.bi);
					case 2:
						return 'de la ' + $elm$core$String$toLower(p.bi);
					case 3:
						return 'du ' + $elm$core$String$toLower(p.bi);
					default:
						return 'de ' + p.bi;
				}
			}() + ' (cible)'));
	});
var $author$project$I18n$Cles$pipeDestinationsDestinationVaSurLaRessourceLiee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-destinations.destination.va-sur-la-ressource-liee', _List_Nil, 'Ressource liée au dossier');
};
var $author$project$Components$Parametrage$Vocabulaire$destinationDuTableau = F3(
	function (i18n, phrase, code) {
		switch (code) {
			case 'reste-dans-la-reponse':
				return $author$project$I18n$Cles$pipeDestinationsDestinationResteDansLaReponse(i18n);
			case 'reste-sur-le-dossier':
				return $author$project$I18n$Cles$pipeDestinationsDestinationResteSurLeDossier(i18n);
			case 'va-sur-la-fiche-visee':
				return A2(
					$author$project$I18n$Cles$pipeDestinationsDestinationVaSurLaFicheVisee,
					i18n,
					{i4: phrase.zo.i4, bi: phrase.zo.bi});
			case 'va-sur-la-fiche-d-un-autre-role':
				return $author$project$I18n$Cles$pipeDestinationsDestinationVaSurLaFicheDUnAutreRole(i18n);
			case 'va-sur-la-ressource-liee':
				return $author$project$I18n$Cles$pipeDestinationsDestinationVaSurLaRessourceLiee(i18n);
			case 'est-range-avec-les-documents':
				return $author$project$I18n$Cles$pipeDestinationsDestinationEstRangeAvecLesDocuments(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$Components$Parametrage$PipeDestinations$View$typeDeDestination = F3(
	function (i18n, page, code) {
		return A3(
			$author$project$Components$Parametrage$Vocabulaire$destinationDuTableau,
			i18n,
			{
				zo: A2(
					$elm$core$Maybe$withDefault,
					{i4: 0, bi: ''},
					A2(
						$elm$core$Maybe$map,
						function (role) {
							return {
								i4: $author$project$Catalogue$Formes$article(role.m$),
								bi: role.Bl
							};
						},
						page.zT.zt))
			},
			code);
	});
var $author$project$Components$Parametrage$PipeDestinations$View$ressourceLiee = F2(
	function (i18n, page) {
		var _v0 = $author$project$Components$Parametrage$PipeDestinations$Model$ligneDeLaRessourceLiee(page.gV);
		if (_v0.$ === 1) {
			return _List_Nil;
		} else {
			var champ = _v0.a;
			var choisie = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.r8;
					},
					champ.xw.HN));
			var champsDeLaRessource = A2(
				$elm$core$List$concatMap,
				function ($) {
					return $.dw;
				},
				A2(
					$elm$core$List$filter,
					function (ressource) {
						return _Utils_eq(ressource.r8, choisie);
					},
					page.HP));
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ressource-liee')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeDestinationsRessourceTitre(i18n))
								])),
							A2(
							$author$project$Components$Parametrage$PipeDestinations$View$liste,
							$author$project$I18n$Cles$pipeDestinationsRessourceDestination(i18n),
							A2(
								$elm$core$List$map,
								function (code) {
									return _Utils_Tuple3(
										code,
										A3($author$project$Components$Parametrage$PipeDestinations$View$typeDeDestination, i18n, page, code),
										_Utils_eq(code, champ.xw.r0));
								},
								page.kM)),
							A2(
							$author$project$Components$Parametrage$PipeDestinations$View$liste,
							$author$project$I18n$Cles$pipeDestinationsRessourceRessource(i18n),
							A2(
								$elm$core$List$map,
								function (ressource) {
									return _Utils_Tuple3(
										ressource.r8,
										ressource.Bl,
										_Utils_eq(ressource.r8, choisie));
								},
								page.HP)),
							A2(
							$author$project$Components$Parametrage$PipeDestinations$View$liste,
							$author$project$I18n$Cles$pipeDestinationsRessourceChamp(i18n),
							A2(
								$elm$core$List$map,
								function (c) {
									return _Utils_Tuple3(
										c.vx,
										c.Bl,
										_Utils_eq(
											$elm$core$Maybe$Just(c.vx),
											champ.xw.uN));
								},
								champsDeLaRessource)),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeDestinationsRessourceAide(i18n))
								]))
						]))
				]);
		}
	});
var $author$project$I18n$Cles$pipeDestinationsDestinationAValider = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-destinations.destination.a-valider',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'destination',
					$author$project$I18n$Traductions$Chaine(p.xw))
				]),
			p.xw + ' · à valider');
	});
var $author$project$I18n$Cles$pipeDestinationsDestinationRessource = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-destinations.destination.ressource',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'destination',
					$author$project$I18n$Traductions$Chaine(p.xw)),
					_Utils_Tuple2(
					'ressource',
					$author$project$I18n$Traductions$Chaine(p.HN))
				]),
			p.xw + (' · ' + p.HN));
	});
var $author$project$I18n$Cles$pipeDestinationsDestinationRole = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-destinations.destination.role',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'destination',
					$author$project$I18n$Traductions$Chaine(p.xw)),
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			p.xw + (' · rôle ' + p.bi));
	});
var $author$project$Components$Parametrage$PipeDestinations$Model$RessourceChoisie = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$PipeDestinations$Model$RoleChoisi = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$PipeDestinations$Model$SansPrecision = {$: 2};
var $author$project$Components$Parametrage$PipeDestinations$Model$precision = function (destination) {
	var _v0 = _Utils_Tuple3(destination.r0, destination.H6, destination.HN);
	_v0$2:
	while (true) {
		switch (_v0.a) {
			case 'va-sur-la-fiche-d-un-autre-role':
				if (!_v0.b.$) {
					var roleUid = _v0.b.a;
					return $author$project$Components$Parametrage$PipeDestinations$Model$RoleChoisi(roleUid);
				} else {
					break _v0$2;
				}
			case 'va-sur-la-ressource-liee':
				if (!_v0.c.$) {
					var ressource = _v0.c.a;
					return $author$project$Components$Parametrage$PipeDestinations$Model$RessourceChoisie(ressource);
				} else {
					break _v0$2;
				}
			default:
				break _v0$2;
		}
	}
	return $author$project$Components$Parametrage$PipeDestinations$Model$SansPrecision;
};
var $author$project$Components$Parametrage$PipeDestinations$View$destination = F3(
	function (i18n, page, champ) {
		var precise = function () {
			var _v1 = $author$project$Components$Parametrage$PipeDestinations$Model$precision(champ.xw);
			switch (_v1.$) {
				case 0:
					var roleUid = _v1.a;
					return A2(
						$elm$core$Maybe$withDefault,
						A3($author$project$Components$Parametrage$PipeDestinations$View$typeDeDestination, i18n, page, champ.xw.r0),
						A2(
							$elm$core$Maybe$map,
							function (role) {
								return A2(
									$author$project$I18n$Cles$pipeDestinationsDestinationRole,
									i18n,
									{
										xw: A3($author$project$Components$Parametrage$PipeDestinations$View$typeDeDestination, i18n, page, champ.xw.r0),
										bi: role.Bl
									});
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (role) {
										return _Utils_eq(role.r8, roleUid);
									},
									page.eX))));
				case 1:
					var ressource = _v1.a;
					return A2(
						$author$project$I18n$Cles$pipeDestinationsDestinationRessource,
						i18n,
						{
							xw: A3($author$project$Components$Parametrage$PipeDestinations$View$typeDeDestination, i18n, page, champ.xw.r0),
							HN: ressource.Bl
						});
				default:
					return A3($author$project$Components$Parametrage$PipeDestinations$View$typeDeDestination, i18n, page, champ.xw.r0);
			}
		}();
		var _v0 = champ.sI;
		if (!_v0.$) {
			return A2(
				$author$project$I18n$Cles$pipeDestinationsDestinationAValider,
				i18n,
				{xw: precise});
		} else {
			return precise;
		}
	});
var $author$project$I18n$Cles$pipeDestinationsNon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-destinations.non', _List_Nil, 'non');
};
var $author$project$I18n$Cles$pipeDestinationsOui = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-destinations.oui', _List_Nil, 'oui');
};
var $author$project$I18n$Cles$pipesSansValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipes.sans-valeur', _List_Nil, '—');
};
var $author$project$I18n$Cles$pipeDestinationsControleOk = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-destinations.controle.ok', _List_Nil, 'OK');
};
var $author$project$I18n$Cles$pipeEtape5ControleBloque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.controle.bloque', _List_Nil, 'Bloque la publication');
};
var $author$project$Components$Parametrage$PipeDestinations$View$verdict = F2(
	function (i18n, champ) {
		return champ.ur ? A2(
			$author$project$Components$Shared$Tag$View$view,
			2,
			$author$project$I18n$Cles$pipeEtape5ControleBloque(i18n)) : A2(
			$author$project$Components$Shared$Tag$View$view,
			0,
			$author$project$I18n$Cles$pipeDestinationsControleOk(i18n));
	});
var $author$project$Components$Parametrage$PipeDestinations$View$ligne = F3(
	function (i18n, page, champ) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$th,
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'scope', 'row')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(champ.R))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A3($author$project$Components$Parametrage$PipeDestinations$View$destination, i18n, page, champ))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$I18n$Cles$pipesSansValeur(i18n),
								champ.xw.Bl))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							champ.Gi ? $author$project$I18n$Cles$pipeDestinationsOui(i18n) : $author$project$I18n$Cles$pipeDestinationsNon(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Components$Parametrage$PipeDestinations$View$verdict, i18n, champ)
						]))
				]));
	});
var $author$project$I18n$Cles$pipeDestinationsColonneChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-destinations.colonne.champ', _List_Nil, 'Champ du formulaire');
};
var $author$project$I18n$Cles$pipeDestinationsColonneControle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-destinations.colonne.controle', _List_Nil, 'Contrôle');
};
var $author$project$I18n$Cles$pipeDestinationsColonneDestination = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-destinations.colonne.destination', _List_Nil, 'Destination');
};
var $author$project$I18n$Cles$pipeDestinationsColonnePrerempli = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-destinations.colonne.prerempli', _List_Nil, 'Pré-rempli');
};
var $author$project$I18n$Cles$pipeDestinationsColonneVise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-destinations.colonne.vise', _List_Nil, 'Champ visé');
};
var $author$project$I18n$Cles$pipeDestinationsTableauTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-destinations.tableau.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.Dj + ' · où va chaque champ');
	});
var $author$project$I18n$Cles$pipeDestinationsTableauVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-destinations.tableau.vide', _List_Nil, 'Ce formulaire n\'a aucun champ.');
};
var $author$project$Components$Parametrage$PipeDestinations$View$tableau = F2(
	function (i18n, page) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('section-destinations')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$pipeDestinationsTableauTitre,
								i18n,
								{
									Dj: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(page.zT.R)
								}))
						])),
					$elm$core$List$isEmpty(page.gV) ? A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeDestinationsTableauVide(i18n))
						])) : A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$table,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$thead,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$tr,
											_List_Nil,
											A2(
												$elm$core$List$map,
												function (titre) {
													return A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'scope', 'col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(titre)
															]));
												},
												_List_fromArray(
													[
														$author$project$I18n$Cles$pipeDestinationsColonneChamp(i18n),
														$author$project$I18n$Cles$pipeDestinationsColonneDestination(i18n),
														$author$project$I18n$Cles$pipeDestinationsColonneVise(i18n),
														$author$project$I18n$Cles$pipeDestinationsColonnePrerempli(i18n),
														$author$project$I18n$Cles$pipeDestinationsColonneControle(i18n)
													])))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$tbody,
									_List_Nil,
									A2(
										$elm$core$List$map,
										A2($author$project$Components$Parametrage$PipeDestinations$View$ligne, i18n, page),
										page.gV))
								]))
						]))
				]));
	});
var $author$project$Components$Parametrage$PipeDestinations$View$contenu = F3(
	function (i18n, code, page) {
		return A2(
			$elm$core$List$cons,
			A2($author$project$Components$Parametrage$PipeDestinations$View$tableau, i18n, page),
			_Utils_ap(
				A3($author$project$Components$Parametrage$PipeDestinations$View$bloquants, i18n, code, page),
				A2($author$project$Components$Parametrage$PipeDestinations$View$ressourceLiee, i18n, page)));
	});
var $author$project$I18n$Cles$pipeDestinationsContexte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-destinations.contexte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etape',
					$author$project$I18n$Traductions$Chaine(p.me)),
					_Utils_Tuple2(
					'tache',
					$author$project$I18n$Traductions$Chaine(p.Jj)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'version',
					$author$project$I18n$Traductions$Chaine(p.sq))
				]),
			'Étape « ' + (p.me + (' » · tâche : ' + (p.Jj + (' · formulaire « ' + (p.Dj + (' » v' + p.sq)))))));
	});
var $author$project$I18n$Cles$pipeDestinationsContexteSansTache = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-destinations.contexte.sans-tache',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'version',
					$author$project$I18n$Traductions$Chaine(p.sq))
				]),
			'Ne sert à aucune tâche · formulaire « ' + (p.Dj + (' » v' + p.sq)));
	});
var $author$project$Components$Parametrage$PipeDestinations$View$contexte = F2(
	function (i18n, formulaire) {
		var _v0 = formulaire.IJ;
		if (_v0.b) {
			var usage = _v0.a;
			return A2(
				$author$project$I18n$Cles$pipeDestinationsContexte,
				i18n,
				{
					me: usage.me,
					Dj: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(formulaire.R),
					Jj: usage.Jj,
					sq: $elm$core$String$fromInt(formulaire.sq)
				});
		} else {
			return A2(
				$author$project$I18n$Cles$pipeDestinationsContexteSansTache,
				i18n,
				{
					Dj: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(formulaire.R),
					sq: $elm$core$String$fromInt(formulaire.sq)
				});
		}
	});
var $author$project$I18n$Cles$pipeDestinationsFilFormulaires = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-destinations.fil.formulaires', _List_Nil, 'Formulaires');
};
var $author$project$I18n$Cles$pipeDestinationsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-destinations.titre', _List_Nil, 'Destination des champs d\'un recueil');
};
var $author$project$Components$Parametrage$PipeDestinations$View$view = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'parametrage-pipe-destinations',
			{
				ut: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('main')
							]),
						A2(
							$elm$core$List$cons,
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							function () {
								var _v0 = _Utils_Tuple2(model.EE, model.nf);
								if (!_v0.a.$) {
									var page = _v0.a.a;
									return A3($author$project$Components$Parametrage$PipeDestinations$View$contenu, i18n, model.vx, page);
								} else {
									if (_v0.b) {
										var _v1 = _v0.a;
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$pipeEtape1Introuvable(i18n))
													]))
											]);
									} else {
										var _v2 = _v0.a;
										return _List_Nil;
									}
								}
							}()))
					]),
				xy: _List_Nil,
				zM: _List_Nil,
				AK: false,
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: function () {
							var _v3 = model.EE;
							if (!_v3.$) {
								var page = _v3.a;
								return _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2($author$project$Components$Parametrage$PipeDestinations$View$contexte, i18n, page.zT))
											])),
										A3($author$project$Components$Parametrage$PipeDestinations$View$actions, i18n, model.vx, page)
									]);
							} else {
								return _List_Nil;
							}
						}(),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adressePipes,
								Dj: $author$project$I18n$Cles$pipesTitre(i18n)
							},
								{
								aa: $author$project$Routes$Route$adressePipeEtape1(model.vx),
								Dj: model.Bl
							},
								{
								aa: $author$project$Routes$Route$adressePipeEtape5(model.vx),
								Dj: $author$project$I18n$Cles$pipeDestinationsFilFormulaires(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$pipeDestinationsTitre(i18n)
					})
			});
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$TypeDeDossierDemande = {$: 37};
var $author$project$I18n$Cles$pipeEtape1LienAjouterType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.ajouter-type', _List_Nil, '+ Ajouter un type de dossier');
};
var $author$project$I18n$Cles$pipeEtape1LienAjouterTypeAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.ajouter-type-aide', _List_Nil, 'Un seul geste');
};
var $author$project$Components$Parametrage$PipeEtape1$View$ajoutDUnType = F2(
	function (i18n, model) {
		var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ajouterUnTypeDeDossier, model.nR);
		if (!_v0.$) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout-de-type'),
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						$author$project$Components$Parametrage$PipeEtape1$Model$idDuDeclencheur('type-de-dossier')),
						$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape1$Update$TypeDeDossierDemande)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$pipeEtape1LienAjouterType(i18n)),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape1LienAjouterTypeAide(i18n))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$pipeEtape1ApercuObjetViseQualifie = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.apercu.objet-vise.qualifie',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'precision',
					$author$project$I18n$Traductions$Chaine(p.Gd))
				]),
			'la fiche de la personne (' + (p.Gd + ')'));
	});
var $author$project$I18n$Cles$pipeEtape1ObjetViseMarque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.objet-vise.marque', _List_Nil, 'Une marque');
};
var $author$project$I18n$Cles$pipeEtape1ObjetViseProduits = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.objet-vise.produits',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'types',
					$author$project$I18n$Traductions$Chaine(p.ib))
				]),
			'Produits de type ' + p.ib);
	});
var $author$project$I18n$Cles$pipeEtape1ObjetViseTousLesProduits = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.objet-vise.tous-les-produits', _List_Nil, 'Tous les produits');
};
var $author$project$I18n$Cles$pipeEtape1ObjetViseToutesLesPartiesPrenantes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.objet-vise.toutes-les-parties-prenantes', _List_Nil, 'Toutes les parties prenantes');
};
var $author$project$I18n$Cles$pipeEtape1ObjetViseVariesTypes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.objet-vise.varies-types',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'types',
					$author$project$I18n$Traductions$Chaine(p.ib))
				]),
			'Fiches de type ' + p.ib);
	});
var $author$project$Components$Parametrage$PipeEtape1$Phrases$objetVise = F2(
	function (i18n, objet) {
		var precision = A2(
			$elm$core$Maybe$map,
			$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle,
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.hy;
				},
				$elm$core$List$head(objet.ib)));
		var noms = function (types) {
			return A2(
				$elm$core$String$join,
				', ',
				A2(
					$elm$core$List$map,
					function ($) {
						return $.Bl;
					},
					types));
		};
		if (_Utils_eq(objet.g1, $author$project$Components$Parametrage$Vocabulaire$natureProduit)) {
			return objet.rL ? $author$project$I18n$Cles$pipeEtape1ObjetViseTousLesProduits(i18n) : A2(
				$author$project$I18n$Cles$pipeEtape1ObjetViseProduits,
				i18n,
				{
					ib: noms(objet.id)
				});
		} else {
			if (_Utils_eq(objet.g1, $author$project$Components$Parametrage$Vocabulaire$natureMarque)) {
				return $author$project$I18n$Cles$pipeEtape1ObjetViseMarque(i18n);
			} else {
				var _v0 = _Utils_Tuple3(objet.g1, objet.rL, precision);
				if (_v0.a === 'partie-prenante') {
					if (_v0.b) {
						return $author$project$I18n$Cles$pipeEtape1ObjetViseToutesLesPartiesPrenantes(i18n);
					} else {
						if (!_v0.c.$) {
							var lue = _v0.c.a;
							return ($elm$core$List$length(objet.ib) > 1) ? A2(
								$author$project$I18n$Cles$pipeEtape1ObjetViseVariesTypes,
								i18n,
								{
									ib: noms(objet.ib)
								}) : A2(
								$author$project$I18n$Cles$pipeEtape1ApercuObjetViseQualifie,
								i18n,
								{Gd: lue});
						} else {
							var _v1 = _v0.c;
							return ($elm$core$List$length(objet.ib) > 1) ? A2(
								$author$project$I18n$Cles$pipeEtape1ObjetViseVariesTypes,
								i18n,
								{
									ib: noms(objet.ib)
								}) : objet.Bl;
						}
					}
				} else {
					return objet.Bl;
				}
			}
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$Phrases$forme = function (nom) {
	var _v0 = A2($elm$core$Dict$get, 'fr', nom);
	if (!_v0.$) {
		var lue = _v0.a;
		return $elm$core$Maybe$Just(lue);
	} else {
		return $elm$core$List$head(
			$elm$core$Dict$values(nom));
	}
};
var $author$project$I18n$Cles$pipeEtape1NatureCategoriesNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.nature.categories.nom', _List_Nil, 'catégories');
};
var $author$project$I18n$Cles$pipeEtape1NatureCategoriesNomSingulier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.nature.categories.nom-singulier', _List_Nil, 'catégorie');
};
var $author$project$I18n$Cles$pipeEtape1NatureListeDOffresNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.nature.liste-d-offres.nom', _List_Nil, 'offres');
};
var $author$project$I18n$Cles$pipeEtape1NatureListeDOffresNomSingulier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.nature.liste-d-offres.nom-singulier', _List_Nil, 'offre');
};
var $author$project$I18n$Cles$pipeEtape1NaturePerimetresNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.nature.perimetres.nom', _List_Nil, 'périmètres');
};
var $author$project$I18n$Cles$pipeEtape1NaturePerimetresNomSingulier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.nature.perimetres.nom-singulier', _List_Nil, 'périmètre');
};
var $author$project$I18n$Cles$pipeEtape1NatureProduitsNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.nature.produits.nom', _List_Nil, 'produits');
};
var $author$project$I18n$Cles$pipeEtape1NatureProduitsNomSingulier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.nature.produits.nom-singulier', _List_Nil, 'produit');
};
var $author$project$I18n$Cles$pipeEtape1NatureReferencesNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.nature.references.nom', _List_Nil, 'références');
};
var $author$project$I18n$Cles$pipeEtape1NatureReferencesNomSingulier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.nature.references.nom-singulier', _List_Nil, 'référence');
};
var $author$project$Components$Parametrage$Vocabulaire$natureNom = F3(
	function (i18n, code, nombre) {
		var _v0 = _Utils_Tuple2(code, nombre > 1);
		_v0$10:
		while (true) {
			if (_v0.b) {
				switch (_v0.a) {
					case 'liste-d-offres':
						return $author$project$I18n$Cles$pipeEtape1NatureListeDOffresNom(i18n);
					case 'perimetres':
						return $author$project$I18n$Cles$pipeEtape1NaturePerimetresNom(i18n);
					case 'categories':
						return $author$project$I18n$Cles$pipeEtape1NatureCategoriesNom(i18n);
					case 'produits':
						return $author$project$I18n$Cles$pipeEtape1NatureProduitsNom(i18n);
					case 'references':
						return $author$project$I18n$Cles$pipeEtape1NatureReferencesNom(i18n);
					default:
						break _v0$10;
				}
			} else {
				switch (_v0.a) {
					case 'liste-d-offres':
						return $author$project$I18n$Cles$pipeEtape1NatureListeDOffresNomSingulier(i18n);
					case 'perimetres':
						return $author$project$I18n$Cles$pipeEtape1NaturePerimetresNomSingulier(i18n);
					case 'categories':
						return $author$project$I18n$Cles$pipeEtape1NatureCategoriesNomSingulier(i18n);
					case 'produits':
						return $author$project$I18n$Cles$pipeEtape1NatureProduitsNomSingulier(i18n);
					case 'references':
						return $author$project$I18n$Cles$pipeEtape1NatureReferencesNomSingulier(i18n);
					default:
						break _v0$10;
				}
			}
		}
		var autre = _v0.a;
		return autre;
	});
var $author$project$Components$Parametrage$PipeEtape1$Phrases$nombreDeLaSource = function (source) {
	return A2($elm$core$Maybe$withDefault, source.CD, source.Cj);
};
var $author$project$Components$Parametrage$PipeEtape1$Phrases$nomDesElements = F2(
	function (i18n, source) {
		var _v0 = A2($elm$core$Maybe$andThen, $author$project$Components$Parametrage$PipeEtape1$Phrases$forme, source.Dm);
		if (!_v0.$) {
			var lue = _v0.a;
			return ($author$project$Components$Parametrage$PipeEtape1$Phrases$nombreDeLaSource(source) > 1) ? lue.bT : lue.IN;
		} else {
			return A3(
				$author$project$Components$Parametrage$Vocabulaire$natureNom,
				i18n,
				source.g1,
				$author$project$Components$Parametrage$PipeEtape1$Phrases$nombreDeLaSource(source));
		}
	});
var $author$project$I18n$Cles$pipeEtape1SourceNomAuMoins = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.source.nom.au-moins',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'minimum',
					$author$project$I18n$Traductions$Chaine(p.CD)),
					_Utils_Tuple2(
					'nature',
					$author$project$I18n$Traductions$Chaine(p.g1)),
					_Utils_Tuple2(
					'elements',
					$author$project$I18n$Traductions$Chaine(p.aV))
				]),
			'au moins ' + (p.CD + (' ' + (p.g1 + (' parmi ' + p.aV)))));
	});
var $author$project$I18n$Cles$pipeEtape1SourceNomAuMoinsSansElement = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.source.nom.au-moins-sans-element',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'minimum',
					$author$project$I18n$Traductions$Chaine(p.CD)),
					_Utils_Tuple2(
					'nature',
					$author$project$I18n$Traductions$Chaine(p.g1))
				]),
			'au moins ' + (p.CD + (' ' + p.g1)));
	});
var $author$project$I18n$Cles$pipeEtape1SourceNomEntre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.source.nom.entre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'minimum',
					$author$project$I18n$Traductions$Chaine(p.CD)),
					_Utils_Tuple2(
					'maximum',
					$author$project$I18n$Traductions$Chaine(p.Cj)),
					_Utils_Tuple2(
					'nature',
					$author$project$I18n$Traductions$Chaine(p.g1)),
					_Utils_Tuple2(
					'elements',
					$author$project$I18n$Traductions$Chaine(p.aV))
				]),
			p.CD + (' à ' + (p.Cj + (' ' + (p.g1 + (' parmi ' + p.aV))))));
	});
var $author$project$I18n$Cles$pipeEtape1SourceNomEntreSansElement = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.source.nom.entre-sans-element',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'minimum',
					$author$project$I18n$Traductions$Chaine(p.CD)),
					_Utils_Tuple2(
					'maximum',
					$author$project$I18n$Traductions$Chaine(p.Cj)),
					_Utils_Tuple2(
					'nature',
					$author$project$I18n$Traductions$Chaine(p.g1))
				]),
			p.CD + (' à ' + (p.Cj + (' ' + p.g1))));
	});
var $author$project$Components$Parametrage$PipeEtape1$Phrases$nomDeLaSource = F2(
	function (i18n, source) {
		var nature = A2($author$project$Components$Parametrage$PipeEtape1$Phrases$nomDesElements, i18n, source);
		var minimum = $elm$core$String$fromInt(source.CD);
		var elements = A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				function ($) {
					return $.Bl;
				},
				source.aV));
		var _v0 = _Utils_Tuple2(
			source.Cj,
			$elm$core$List$isEmpty(source.aV));
		if (!_v0.a.$) {
			if (!_v0.b) {
				var maximum = _v0.a.a;
				return A2(
					$author$project$I18n$Cles$pipeEtape1SourceNomEntre,
					i18n,
					{
						aV: elements,
						Cj: $elm$core$String$fromInt(maximum),
						CD: minimum,
						g1: nature
					});
			} else {
				var maximum = _v0.a.a;
				return A2(
					$author$project$I18n$Cles$pipeEtape1SourceNomEntreSansElement,
					i18n,
					{
						Cj: $elm$core$String$fromInt(maximum),
						CD: minimum,
						g1: nature
					});
			}
		} else {
			if (!_v0.b) {
				var _v1 = _v0.a;
				return A2(
					$author$project$I18n$Cles$pipeEtape1SourceNomAuMoins,
					i18n,
					{aV: elements, CD: minimum, g1: nature});
			} else {
				var _v2 = _v0.a;
				return A2(
					$author$project$I18n$Cles$pipeEtape1SourceNomAuMoinsSansElement,
					i18n,
					{CD: minimum, g1: nature});
			}
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$Phrases$offre = F2(
	function (i18n, sources) {
		return A2(
			$elm$core$String$join,
			' ; ',
			A2(
				$elm$core$List$map,
				$author$project$Components$Parametrage$PipeEtape1$Phrases$nomDeLaSource(i18n),
				sources));
	});
var $author$project$I18n$Cles$pipeEtape1ApercuDossier = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.apercu.dossier',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'mot',
					$author$project$I18n$Traductions$Chaine(p.ej))
				]),
			'Un dossier = ' + p.ej);
	});
var $author$project$I18n$Cles$pipeEtape1ApercuFichesCreees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.apercu.fiches-creees', _List_Nil, 'Fiches créées : proposées jusqu\'à validation');
};
var $author$project$I18n$Cles$pipeEtape1ApercuObjetVise = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.apercu.objet-vise',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'objet',
					$author$project$I18n$Traductions$Chaine(p.DZ))
				]),
			'Objet visé : ' + p.DZ);
	});
var $author$project$I18n$Cles$pipeEtape1ApercuObjetViseAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.apercu.objet-vise.aucun', _List_Nil, 'Objet visé : aucun');
};
var $author$project$I18n$Cles$pipeEtape1ApercuOffre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.apercu.offre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'offre',
					$author$project$I18n$Traductions$Chaine(p.D1))
				]),
			'Offre : ' + p.D1);
	});
var $author$project$I18n$Cles$pipeEtape1ApercuOuverturesTiers = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.apercu.ouvertures-tiers',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' ouverture par un tiers') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' ouvertures par un tiers'));
	});
var $author$project$I18n$Cles$pipeEtape1ApercuRole = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.apercu.role',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Rôle du dossier : « ' + (p.bi + ' »'));
	});
var $author$project$I18n$Cles$pipeEtape1ApercuSansOffre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.apercu.sans-offre', _List_Nil, 'Offre : aucune');
};
var $author$project$I18n$Cles$pipeEtape1ApercuSurtitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.apercu.surtitre', _List_Nil, 'Aperçu · Ce que donne ce pipe');
};
var $author$project$I18n$Cles$pipeEtape1ApercuTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.apercu.titre', _List_Nil, 'Aperçu');
};
var $author$project$Components$Parametrage$PipeEtape1$View$apercu = F3(
	function (i18n, _v0, edition) {
		var mot = $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(edition.CW);
		var ligneDeLApercu = F3(
			function (retrait, fort, texte) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class(
							'retrait-' + $elm$core$String$fromInt(retrait)),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('fort', fort)
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(texte)
						]));
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id('aside'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'complementary'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					$author$project$I18n$Cles$pipeEtape1ApercuTitre(i18n))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('surtitre')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape1ApercuSurtitre(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu')
						]),
					_Utils_ap(
						_List_fromArray(
							[
								A3(
								ligneDeLApercu,
								0,
								true,
								A2(
									$author$project$I18n$Cles$pipeEtape1ApercuDossier,
									i18n,
									{
										ej: A2(
											$elm$core$Maybe$withDefault,
											mot,
											A2($elm$core$Maybe$map, $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle, edition.xr))
									})),
								A3(
								ligneDeLApercu,
								1,
								false,
								$elm$core$List$isEmpty(edition.D_.ib) ? $author$project$I18n$Cles$pipeEtape1ApercuObjetViseAucun(i18n) : A2(
									$author$project$I18n$Cles$pipeEtape1ApercuObjetVise,
									i18n,
									{
										DZ: A2($author$project$Components$Parametrage$PipeEtape1$Phrases$objetVise, i18n, edition.D_)
									}))
							]),
						_Utils_ap(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (role) {
										return _List_fromArray(
											[
												A3(
												ligneDeLApercu,
												1,
												false,
												A2(
													$author$project$I18n$Cles$pipeEtape1ApercuRole,
													i18n,
													{bi: role}))
											]);
									},
									edition.D_.gR)),
							_Utils_ap(
								$elm$core$List$isEmpty(edition.Ew) ? _List_Nil : _Utils_ap(
									_List_fromArray(
										[
											A3(
											ligneDeLApercu,
											0,
											false,
											A2(
												$author$project$I18n$Cles$pipeEtape1ApercuOuverturesTiers,
												i18n,
												{
													w: $elm$core$List$length(edition.Ew)
												}))
										]),
									edition.zv ? _List_fromArray(
										[
											A3(
											ligneDeLApercu,
											0,
											false,
											$author$project$I18n$Cles$pipeEtape1ApercuFichesCreees(i18n))
										]) : _List_Nil),
								_List_fromArray(
									[
										A3(
										ligneDeLApercu,
										1,
										false,
										$elm$core$List$isEmpty(edition.IT) ? $author$project$I18n$Cles$pipeEtape1ApercuSansOffre(i18n) : A2(
											$author$project$I18n$Cles$pipeEtape1ApercuOffre,
											i18n,
											{
												D1: A2($author$project$Components$Parametrage$PipeEtape1$Phrases$offre, i18n, edition.IT)
											}))
									])))))
				]));
	});
var $author$project$I18n$Cles$pipeEtape1LectureSeulePublie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lecture-seule.publie', _List_Nil, 'Version en ligne : lecture seule. Pour modifier l\'objet visé, créez un brouillon depuis la page « Modèles de pipes ». Les dossiers ouverts restent sur la version en ligne.');
};
var $author$project$I18n$Cles$pipeEtape1LectureSeuleSansDroit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lecture-seule.sans-droit', _List_Nil, 'Lecture seule. Vous n\'avez pas le droit « Concevoir les pipes ». Demandez-le à un administrateur de l\'espace.');
};
var $author$project$Components$Parametrage$PipeEtape1$View$noteDeLectureSeule = F2(
	function (i18n, edition) {
		return (!_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$definirLObjetVise, edition.BN),
			$elm$core$Maybe$Nothing)) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('lecture-seule')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					(edition.ri === 'brouillon') ? $author$project$I18n$Cles$pipeEtape1LectureSeuleSansDroit(i18n) : $author$project$I18n$Cles$pipeEtape1LectureSeulePublie(i18n))
				]));
	});
var $author$project$I18n$Cles$pipeEtape1Etape1 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.etape.1', _List_Nil, 'Le pipe et ses dossiers');
};
var $author$project$I18n$Cles$pipeEtape1QuelIntro = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.quel.intro', _List_Nil, 'Un pipe est le modèle d\'un processus. Chaque fois qu\'il démarre pour quelqu\'un, cela donne un dossier.');
};
var $author$project$Components$Parametrage$PipeEtape1$Update$ObjetViseDemande = {$: 12};
var $author$project$Components$Parametrage$PipeEtape1$View$geste = F3(
	function (edition, rel, ouverture) {
		return A2(
			$elm$core$Maybe$map,
			function (_v0) {
				return ouverture;
			},
			A2($author$project$API$Liens$trouver, rel, edition.BN));
	});
var $author$project$I18n$Cles$pipeEtape1ObjetViseType = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.objet-vise.type',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.Dj)))
				]),
			'Fiche ' + function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + ($elm$core$String$toLower(
							A2(
								$elm$core$String$left,
								1,
								$elm$core$String$trim(p.Dj))) + A2(
							$elm$core$String$dropLeft,
							1,
							$elm$core$String$trim(p.Dj)));
					case 1:
						return 'd\'' + ($elm$core$String$toLower(
							A2(
								$elm$core$String$left,
								1,
								$elm$core$String$trim(p.Dj))) + A2(
							$elm$core$String$dropLeft,
							1,
							$elm$core$String$trim(p.Dj)));
					default:
						return 'de ' + ($elm$core$String$toLower(
							A2(
								$elm$core$String$left,
								1,
								$elm$core$String$trim(p.Dj))) + A2(
							$elm$core$String$dropLeft,
							1,
							$elm$core$String$trim(p.Dj)));
				}
			}());
	});
var $author$project$Components$Parametrage$PipeEtape1$Phrases$ficheDe = F2(
	function (i18n, libelle) {
		return A2(
			$author$project$I18n$Cles$pipeEtape1ObjetViseType,
			i18n,
			{
				av: $author$project$Texte$Elision$elision(libelle),
				Dj: libelle
			});
	});
var $author$project$I18n$Cles$pipeEtape1ObjetViseAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.objet-vise.aucun', _List_Nil, 'Aucun objet visé');
};
var $author$project$Components$Parametrage$PipeEtape1$Phrases$ligneDeLObjetVise = F2(
	function (i18n, objet) {
		var _v0 = _Utils_Tuple3(objet.g1, objet.ib, objet.rL);
		_v0$2:
		while (true) {
			switch (_v0.a) {
				case 'partie-prenante':
					if ((_v0.b.b && (!_v0.b.b.b)) && (!_v0.c)) {
						var _v1 = _v0.b;
						var seul = _v1.a;
						return A2($author$project$Components$Parametrage$PipeEtape1$Phrases$ficheDe, i18n, seul.Bl);
					} else {
						break _v0$2;
					}
				case 'aucun':
					return $author$project$I18n$Cles$pipeEtape1ObjetViseAucun(i18n);
				default:
					break _v0$2;
			}
		}
		return A2($author$project$Components$Parametrage$PipeEtape1$Phrases$objetVise, i18n, objet);
	});
var $author$project$Components$Parametrage$PipeEtape1$View$objetVise = F2(
	function (i18n, edition) {
		return A2($author$project$Components$Parametrage$PipeEtape1$Phrases$ligneDeLObjetVise, i18n, edition.D_);
	});
var $author$project$Components$Parametrage$PipeEtape1$View$libelleDeLArchetype = F2(
	function (i18n, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			code,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Referentiel$Archetype$libelle,
					$author$project$I18n$Cles$texte(i18n)),
				$author$project$Components$Referentiel$Archetype$fromCode(code)));
	});
var $author$project$Components$Parametrage$PipeEtape1$View$pastilleDeLArchetype = F2(
	function (i18n, edition) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.fA;
			},
			$elm$core$List$head(edition.D_.ib));
		if (!_v0.$) {
			var archetype = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$Components$Parametrage$PipeEtape1$View$libelleDeLArchetype, i18n, archetype))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$pipeEtape1ObjetViseModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.objet-vise.modifier', _List_Nil, 'Modifier');
};
var $author$project$I18n$Cles$pipeEtape1ObjetViseTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.objet-vise.titre', _List_Nil, 'Objet visé');
};
var $author$project$Components$Parametrage$PipeEtape1$View$reglage = F5(
	function (nom, intitule, valeur, ouvre, libelleDuGeste) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('reglage'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(nom)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('rubrique')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(intitule)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
						]),
					valeur),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('geste')
						]),
					function () {
						if (!ouvre.$) {
							var _v1 = ouvre.a;
							var identifiant = _v1.a;
							var msg = _v1.b;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$id(identifiant),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('modifier'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(libelleDuGeste)
										]))
								]);
						} else {
							return _List_Nil;
						}
					}())
				]));
	});
var $author$project$Components$Parametrage$PipeEtape1$View$ligneDeLObjetVise = F2(
	function (i18n, edition) {
		return A5(
			$author$project$Components$Parametrage$PipeEtape1$View$reglage,
			'objet-vise',
			$author$project$I18n$Cles$pipeEtape1ObjetViseTitre(i18n),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Parametrage$PipeEtape1$View$objetVise, i18n, edition))
						])),
					A2($author$project$Components$Parametrage$PipeEtape1$View$pastilleDeLArchetype, i18n, edition)
				]),
			A3(
				$author$project$Components$Parametrage$PipeEtape1$View$geste,
				edition,
				$author$project$API$NavLinksDictionary$definirLObjetVise,
				_Utils_Tuple2(
					$author$project$Components$Parametrage$PipeEtape1$Model$idDuDeclencheur('objet-vise'),
					$author$project$Components$Parametrage$PipeEtape1$Update$ObjetViseDemande)),
			$author$project$I18n$Cles$pipeEtape1ObjetViseModifier(i18n));
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$OuvertureDemandee = {$: 9};
var $author$project$Components$Parametrage$PipeEtape1$Phrases$majuscule = function (texte) {
	return _Utils_ap(
		$elm$core$String$toUpper(
			A2($elm$core$String$left, 1, texte)),
		A2($elm$core$String$dropLeft, 1, texte));
};
var $author$project$I18n$Cles$pipeEtape1MoisAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.mois.aucune', _List_Nil, 'pas de fermeture');
};
var $author$project$I18n$Cles$pipeEtape1MoisN = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.mois.n', _List_Nil, 'n');
};
var $author$project$I18n$Cles$pipeEtape1MoisNPlus1 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.mois.n-plus-1', _List_Nil, 'n+1');
};
var $author$project$Components$Parametrage$Vocabulaire$mois = F2(
	function (i18n, code) {
		switch (code) {
			case 'n':
				return $author$project$I18n$Cles$pipeEtape1MoisN(i18n);
			case 'n+1':
				return $author$project$I18n$Cles$pipeEtape1MoisNPlus1(i18n);
			case 'aucune':
				return $author$project$I18n$Cles$pipeEtape1MoisAucune(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$I18n$Cles$pipeEtape1PeriodeJourDuMois = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.periode.jour-du-mois',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'jour',
					$author$project$I18n$Traductions$Chaine(p.A_)),
					_Utils_Tuple2(
					'mois',
					$author$project$I18n$Traductions$Chaine(p.CQ))
				]),
			p.A_ + (' du mois ' + p.CQ));
	});
var $author$project$Components$Parametrage$PipeEtape1$Phrases$jourDuMois = F3(
	function (i18n, jour, mois) {
		return A2(
			$author$project$I18n$Cles$pipeEtape1PeriodeJourDuMois,
			i18n,
			{
				A_: $elm$core$String$fromInt(jour),
				CQ: A2($author$project$Components$Parametrage$Vocabulaire$mois, i18n, mois)
			});
	});
var $author$project$I18n$Cles$pipeEtape1PeriodePhraseEntre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.periode.phrase.entre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'du',
					$author$project$I18n$Traductions$Chaine(p.cE)),
					_Utils_Tuple2(
					'au',
					$author$project$I18n$Traductions$Chaine(p.cm))
				]),
			'du ' + (p.cE + (' au ' + p.cm)));
	});
var $author$project$I18n$Cles$pipeEtape1PeriodePhraseRecurrente = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.periode.phrase.recurrente',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'ouverture',
					$author$project$I18n$Traductions$Chaine(p.ew)),
					_Utils_Tuple2(
					'fermeture',
					$author$project$I18n$Traductions$Chaine(p.zm))
				]),
			'du ' + (p.ew + (' au ' + p.zm)));
	});
var $author$project$I18n$Cles$pipeEtape1PeriodePhraseRecurrenteSansFermeture = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.periode.phrase.recurrente-sans-fermeture',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'ouverture',
					$author$project$I18n$Traductions$Chaine(p.ew))
				]),
			'à partir du ' + p.ew);
	});
var $author$project$I18n$Cles$pipeEtape1PeriodePhraseToujours = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.periode.phrase.toujours', _List_Nil, 'toujours');
};
var $author$project$Components$Parametrage$PipeEtape1$Phrases$periode = F2(
	function (i18n, lue) {
		switch (lue.$) {
			case 0:
				return $author$project$I18n$Cles$pipeEtape1PeriodePhraseToujours(i18n);
			case 1:
				var du = lue.a;
				var au = lue.b;
				return A2(
					$author$project$I18n$Cles$pipeEtape1PeriodePhraseEntre,
					i18n,
					{cm: au, cE: du});
			default:
				var r = lue.a;
				var _v1 = r.A0;
				if (!_v1.$) {
					var fermeture = _v1.a;
					return A2(
						$author$project$I18n$Cles$pipeEtape1PeriodePhraseRecurrente,
						i18n,
						{
							zm: A3($author$project$Components$Parametrage$PipeEtape1$Phrases$jourDuMois, i18n, fermeture, r.oh),
							ew: A3($author$project$Components$Parametrage$PipeEtape1$Phrases$jourDuMois, i18n, r.A$, r.CR)
						});
				} else {
					return A2(
						$author$project$I18n$Cles$pipeEtape1PeriodePhraseRecurrenteSansFermeture,
						i18n,
						{
							ew: A3($author$project$Components$Parametrage$PipeEtape1$Phrases$jourDuMois, i18n, r.A$, r.CR)
						});
				}
		}
	});
var $author$project$I18n$Cles$pipeEtape1PeriodePhraseTouteLAnnee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.periode.phrase.toute-l-annee', _List_Nil, 'toute l\'année');
};
var $author$project$Components$Parametrage$PipeEtape1$Phrases$periodeDansLaPhrase = F2(
	function (i18n, lue) {
		if (!lue.$) {
			return $author$project$I18n$Cles$pipeEtape1PeriodePhraseTouteLAnnee(i18n);
		} else {
			var autre = lue;
			return A2($author$project$Components$Parametrage$PipeEtape1$Phrases$periode, i18n, autre);
		}
	});
var $author$project$I18n$Cles$pipeEtape1QuiCalendrierPar = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.qui.calendrier.par', _List_Nil, 'automatiquement, selon un calendrier');
};
var $author$project$I18n$Cles$pipeEtape1QuiEvenementPar = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.qui.evenement.par', _List_Nil, 'automatiquement, sur un événement');
};
var $author$project$I18n$Cles$pipeEtape1QuiPersonneSurLePortailPar = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.qui.personne-sur-le-portail.par', _List_Nil, 'par la personne, sur le portail');
};
var $author$project$I18n$Cles$pipeEtape1QuiUtilisateurPar = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.qui.utilisateur.par', _List_Nil, 'par un utilisateur du CRM');
};
var $author$project$Components$Parametrage$Vocabulaire$quiPar = F2(
	function (i18n, code) {
		switch (code) {
			case 'utilisateur':
				return $author$project$I18n$Cles$pipeEtape1QuiUtilisateurPar(i18n);
			case 'personne-sur-le-portail':
				return $author$project$I18n$Cles$pipeEtape1QuiPersonneSurLePortailPar(i18n);
			case 'calendrier':
				return $author$project$I18n$Cles$pipeEtape1QuiCalendrierPar(i18n);
			case 'evenement':
				return $author$project$I18n$Cles$pipeEtape1QuiEvenementPar(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$Phrases$ouvertureEnTitre = F2(
	function (i18n, lue) {
		return $author$project$Components$Parametrage$PipeEtape1$Phrases$majuscule(
			A2(
				$elm$core$String$join,
				', ',
				A2(
					$elm$core$List$filter,
					A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not),
					_List_fromArray(
						[
							A2(
							$elm$core$String$join,
							' et ',
							A2(
								$elm$core$List$map,
								$author$project$Components$Parametrage$Vocabulaire$quiPar(i18n),
								lue.GK)),
							A2($author$project$Components$Parametrage$PipeEtape1$Phrases$periodeDansLaPhrase, i18n, lue.pi)
						]))));
	});
var $author$project$I18n$Cles$pipeEtape1Modifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.modifier', _List_Nil, 'Modifier');
};
var $author$project$I18n$Cles$pipeEtape1OuvertureRubrique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouverture.rubrique', _List_Nil, 'Ouverture');
};
var $author$project$Components$Parametrage$PipeEtape1$View$ligneDeLOuverture = F2(
	function (i18n, edition) {
		return A5(
			$author$project$Components$Parametrage$PipeEtape1$View$reglage,
			'ouverture',
			$author$project$I18n$Cles$pipeEtape1OuvertureRubrique(i18n),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Parametrage$PipeEtape1$Phrases$ouvertureEnTitre, i18n, edition.ew))
						]))
				]),
			A3(
				$author$project$Components$Parametrage$PipeEtape1$View$geste,
				edition,
				$author$project$API$NavLinksDictionary$reglerLOuverture,
				_Utils_Tuple2(
					$author$project$Components$Parametrage$PipeEtape1$Model$idDuDeclencheur('ouverture'),
					$author$project$Components$Parametrage$PipeEtape1$Update$OuvertureDemandee)),
			$author$project$I18n$Cles$pipeEtape1Modifier(i18n));
	});
var $author$project$I18n$Cles$pipeEtape1VersionAide = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.version.aide',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'numero',
					$author$project$I18n$Traductions$Chaine(p.DX))
				]),
			'Version ' + (p.DX + ' publiée : les dossiers déjà ouverts restent dessus'));
	});
var $author$project$I18n$Cles$pipeEtape1VersionAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.version.aucune', _List_Nil, 'Aucune version publiée');
};
var $author$project$I18n$Cles$pipeEtape1VersionBrouillon = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.version.brouillon',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'numero',
					$author$project$I18n$Traductions$Chaine(p.DX))
				]),
			'Version ' + (p.DX + ' · brouillon'));
	});
var $author$project$I18n$Cles$pipeEtape1VersionTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.version.titre', _List_Nil, 'Version');
};
var $author$project$I18n$Cles$pipeEtape1VersionVoir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.version.voir', _List_Nil, 'Voir les versions');
};
var $author$project$Components$Parametrage$PipeEtape1$View$precision = function (texte) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$span,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(texte)
			]));
};
var $author$project$Components$Parametrage$PipeEtape1$View$ligneDeLaVersion = F2(
	function (i18n, edition) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('reglage'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('version')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('rubrique')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape1VersionTitre(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$pipeEtape1VersionBrouillon,
										i18n,
										{
											DX: $elm$core$String$fromInt(edition.DX)
										}))
								])),
							$author$project$Components$Parametrage$PipeEtape1$View$precision(
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$I18n$Cles$pipeEtape1VersionAucune(i18n),
								A2(
									$elm$core$Maybe$map,
									function (numero) {
										return A2(
											$author$project$I18n$Cles$pipeEtape1VersionAide,
											i18n,
											{
												DX: $elm$core$String$fromInt(numero)
											});
									},
									edition.KM)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('geste')
						]),
					function () {
						var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$versionsDuPipe, edition.BN);
						if (!_v0.$) {
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id(
											$author$project$Components$Parametrage$PipeEtape1$Model$idDuDeclencheur('version')),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('modifier'),
											$rtfeldman$elm_css$Html$Styled$Attributes$href(
											$author$project$Routes$Route$adresseVersionsDuPipe(edition.vx))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape1VersionVoir(i18n))
										]))
								]);
						} else {
							return _List_Nil;
						}
					}())
				]));
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$OuvertureParUnTiersDemandee = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$Update$OuvertureParUnTiersRetiree = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.ajouter', _List_Nil, 'Ajouter : Ouverture par un tiers');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersLigneExistante = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.ouvertures-tiers.ligne-existante',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi)),
					_Utils_Tuple2(
					'portail',
					$author$project$I18n$Traductions$Chaine(p.FY))
				]),
			'Rôle « ' + (p.bi + (' » · Portail ' + (p.FY + ' · sur une fiche existante de son périmètre'))));
	});
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersLigneNouvelle = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.ouvertures-tiers.ligne-nouvelle',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi)),
					_Utils_Tuple2(
					'portail',
					$author$project$I18n$Traductions$Chaine(p.FY)),
					_Utils_Tuple2(
					'types',
					$author$project$I18n$Traductions$Chaine(p.ib))
				]),
			'Rôle « ' + (p.bi + (' » · Portail ' + (p.FY + (' · crée une nouvelle fiche ' + (p.ib + ' (proposée)'))))));
	});
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.retirer', _List_Nil, 'Retirer');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersRubrique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.rubrique', _List_Nil, 'Un tiers peut ouvrir un dossier');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.vide', _List_Nil, 'Rien n\'est ouvrable par un tiers tant que vous n\'ajoutez pas de réglage.');
};
var $author$project$Components$Parametrage$PipeEtape1$View$ligneDesOuverturesParUnTiers = F2(
	function (i18n, edition) {
		var peut = function (lien) {
			return !_Utils_eq(
				A2($author$project$API$Liens$trouver, lien, edition.BN),
				$elm$core$Maybe$Nothing);
		};
		var nomDuType = function (code) {
			return A2(
				$elm$core$Maybe$withDefault,
				code,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Bl;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (t) {
								return _Utils_eq(t.vx, code);
							},
							_Utils_ap(edition.D_.ib, edition.D_.id)))));
		};
		var ligne = function (ouverture) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$li,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ouverture-par-un-tiers')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								function () {
									var _v0 = ouverture.zo;
									if (!_v0.$) {
										return A2(
											$author$project$I18n$Cles$pipeEtape1OuverturesTiersLigneExistante,
											i18n,
											{
												FY: ouverture.FY.Bl,
												bi: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(ouverture.bi.R)
											});
									} else {
										var types = _v0.a;
										return A2(
											$author$project$I18n$Cles$pipeEtape1OuverturesTiersLigneNouvelle,
											i18n,
											{
												FY: ouverture.FY.Bl,
												bi: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(ouverture.bi.R),
												ib: A2(
													$elm$core$String$join,
													', ',
													A2($elm$core$List$map, nomDuType, types))
											});
									}
								}())
							])),
						peut($author$project$API$NavLinksDictionary$modifierUneOuvertureParUnTiers) ? A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('modifier'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Parametrage$PipeEtape1$Update$OuvertureParUnTiersDemandee(
									$elm$core$Maybe$Just(ouverture)))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape1Modifier(i18n))
							])) : $rtfeldman$elm_css$Html$Styled$text(''),
						peut($author$project$API$NavLinksDictionary$retirerUneOuvertureParUnTiers) ? A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								A2($author$project$Components$Parametrage$PipeEtape1$Update$OuvertureParUnTiersRetiree, ouverture.bi.r8, ouverture.FY.vx))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape1OuverturesTiersRetirer(i18n))
							])) : $rtfeldman$elm_css$Html$Styled$text('')
					]));
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('reglage'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ouvertures-par-un-tiers')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('rubrique')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape1OuverturesTiersRubrique(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
						]),
					$elm$core$List$isEmpty(edition.Ew) ? _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape1OuverturesTiersVide(i18n))
								]))
						]) : _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('ouvertures')
								]),
							A2($elm$core$List$map, ligne, edition.Ew))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('geste')
						]),
					peut($author$project$API$NavLinksDictionary$ajouterUneOuvertureParUnTiers) ? _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id(
									$author$project$Components$Parametrage$PipeEtape1$Model$idDuDeclencheur('ouverture-tiers')),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('modifier'),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Parametrage$PipeEtape1$Update$OuvertureParUnTiersDemandee($elm$core$Maybe$Nothing))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape1OuverturesTiersAjouter(i18n))
								]))
						]) : _List_Nil)
				]));
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$MotDemande = {$: 7};
var $author$project$Components$Parametrage$PipeEtape1$View$pastille = function (texte) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$span,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille')
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(texte)
			]));
};
var $author$project$I18n$Cles$pipeEtape1MotRubrique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.mot.rubrique', _List_Nil, 'Mot employé');
};
var $author$project$I18n$Cles$pipeEtape1MotPluriel = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.mot.pluriel',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'pluriel',
					$author$project$I18n$Traductions$Chaine(p.bT))
				]),
			'Pluriel : ' + p.bT);
	});
var $author$project$Components$Parametrage$PipeEtape1$Model$plurielDeLaLangue = F2(
	function (langue, edition) {
		return A2(
			$elm$core$Maybe$andThen,
			function (texte) {
				return $elm$core$String$isEmpty(
					$elm$core$String$trim(texte)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(texte);
			},
			A2(
				$elm$core$Dict$get,
				langue,
				$author$project$Components$Parametrage$PipeEtape1$Model$plurielPropre(edition)));
	});
var $author$project$Components$Parametrage$PipeEtape1$View$plurielsDuMot = F2(
	function (i18n, edition) {
		var code = function () {
			var _v0 = $author$project$I18n$Traductions$langue(i18n);
			if (!_v0) {
				return 'fr';
			} else {
				return 'en';
			}
		}();
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Maybe$map,
					function (texte) {
						return A2(
							$author$project$I18n$Cles$pipeEtape1MotPluriel,
							i18n,
							{bT: texte});
					},
					A2($author$project$Components$Parametrage$PipeEtape1$Model$plurielDeLaLangue, code, edition))));
	});
var $author$project$Components$Parametrage$PipeEtape1$View$ligneDuMot = F2(
	function (i18n, edition) {
		return A5(
			$author$project$Components$Parametrage$PipeEtape1$View$reglage,
			'mot',
			$author$project$I18n$Cles$pipeEtape1MotRubrique(i18n),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(edition.CW))
						])),
				A2(
					$elm$core$List$map,
					$author$project$Components$Parametrage$PipeEtape1$View$pastille,
					A2($author$project$Components$Parametrage$PipeEtape1$View$plurielsDuMot, i18n, edition))),
			A3(
				$author$project$Components$Parametrage$PipeEtape1$View$geste,
				edition,
				$author$project$API$NavLinksDictionary$modifierLeMotEmploye,
				_Utils_Tuple2(
					$author$project$Components$Parametrage$PipeEtape1$Model$idDuDeclencheur('mot'),
					$author$project$Components$Parametrage$PipeEtape1$Update$MotDemande)),
			$author$project$I18n$Cles$pipeEtape1Modifier(i18n));
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$NomDemande = {$: 6};
var $author$project$I18n$Cles$pipeEtape1NomARenseigner = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.nom.a-renseigner', _List_Nil, 'À renseigner');
};
var $author$project$I18n$Cles$pipeEtape1NomAutreLangue = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.nom.autre-langue',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'langue',
					$author$project$I18n$Traductions$Chaine(p.nn)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.nn + (' : ' + p.Dj));
	});
var $author$project$Components$Parametrage$PipeEtape1$View$autresLangues = F2(
	function (i18n, libelles) {
		return A2(
			$elm$core$List$map,
			function (langue) {
				return A2(
					$author$project$I18n$Cles$pipeEtape1NomAutreLangue,
					i18n,
					{
						nn: A2($author$project$Referentiel$Langues$nom, i18n, langue.vx),
						Dj: A2(
							$elm$core$Maybe$withDefault,
							$author$project$I18n$Cles$pipeEtape1NomARenseigner(i18n),
							A2($elm$core$Dict$get, langue.vx, libelles))
					});
			},
			A2(
				$elm$core$List$filter,
				function (langue) {
					return langue.vx !== 'fr';
				},
				$author$project$Referentiel$Langues$desLibelles));
	});
var $author$project$I18n$Cles$pipeEtape1NomRubrique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.nom.rubrique', _List_Nil, 'Nom du pipe');
};
var $author$project$Components$Parametrage$PipeEtape1$View$ligneDuNom = F2(
	function (i18n, edition) {
		return A5(
			$author$project$Components$Parametrage$PipeEtape1$View$reglage,
			'nom',
			$author$project$I18n$Cles$pipeEtape1NomRubrique(i18n),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(edition.R))
						])),
				A2(
					$elm$core$List$map,
					$author$project$Components$Parametrage$PipeEtape1$View$precision,
					A2($author$project$Components$Parametrage$PipeEtape1$View$autresLangues, i18n, edition.R))),
			A3(
				$author$project$Components$Parametrage$PipeEtape1$View$geste,
				edition,
				$author$project$API$NavLinksDictionary$renommerLePipe,
				_Utils_Tuple2(
					$author$project$Components$Parametrage$PipeEtape1$Model$idDuDeclencheur('nom'),
					$author$project$Components$Parametrage$PipeEtape1$Update$NomDemande)),
			$author$project$I18n$Cles$pipeEtape1Modifier(i18n));
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$OffreDemandee = {$: 8};
var $author$project$I18n$Cles$pipeEtape1OffreAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.offre.aucune', _List_Nil, 'Aucune source : le dossier ne porte aucune offre');
};
var $author$project$I18n$Cles$pipeEtape1OffreTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.offre.titre', _List_Nil, 'Offre');
};
var $author$project$I18n$Cles$pipeEtape1OffreUsage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.offre.usage', _List_Nil, 'Où l\'offre est utilisée');
};
var $author$project$Components$Parametrage$PipeEtape1$View$usageDeLOffre = F2(
	function (i18n, edition) {
		var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$usagesDeLOffre, edition.BN);
		if (!_v0.$) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						$author$project$Components$Parametrage$PipeEtape1$Model$idDuDeclencheur('offre-usage')),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('usage'),
						$rtfeldman$elm_css$Html$Styled$Attributes$href(
						$author$project$Routes$Route$adresseUsagesDeLOffre(edition.vx))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$pipeEtape1OffreUsage(i18n))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$View$lignesDeLOffre = F2(
	function (i18n, edition) {
		return A5(
			$author$project$Components$Parametrage$PipeEtape1$View$reglage,
			'offre',
			$author$project$I18n$Cles$pipeEtape1OffreTitre(i18n),
			_Utils_ap(
				$elm$core$List$isEmpty(edition.IT) ? _List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$pipeEtape1OffreAucune(i18n))
					]) : A2(
					$elm$core$List$map,
					function (source) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Parametrage$PipeEtape1$Phrases$nomDeLaSource, i18n, source))
								]));
					},
					edition.IT),
				_List_fromArray(
					[
						A2($author$project$Components$Parametrage$PipeEtape1$View$usageDeLOffre, i18n, edition)
					])),
			A3(
				$author$project$Components$Parametrage$PipeEtape1$View$geste,
				edition,
				$author$project$API$NavLinksDictionary$ajouterUneSourceDOffre,
				_Utils_Tuple2(
					$author$project$Components$Parametrage$PipeEtape1$Model$idDuDeclencheur('offre'),
					$author$project$Components$Parametrage$PipeEtape1$Update$OffreDemandee)),
			$author$project$I18n$Cles$pipeEtape1Modifier(i18n));
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$LienAjoutDemande = {$: 39};
var $author$project$Components$Parametrage$PipeEtape1$Update$LienDemande = function (a) {
	return {$: 38, a: a};
};
var $author$project$I18n$Cles$pipeEtape1LienAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.aide', _List_Nil, 'Cliquez pour ouvrir le tiroir : relier ce pipe à un autre (regroupement ou enchaînement)');
};
var $author$project$I18n$Cles$pipeEtape1LienTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.titre', _List_Nil, 'Lien avec les autres pipes');
};
var $author$project$I18n$Cles$pipesLienAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipes.lien.aucun', _List_Nil, 'Aucun pipe lié pour l\'instant');
};
var $author$project$I18n$Cles$pipesLienEstDeclenchePar = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipes.lien.est-declenche-par',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'pipe',
					$author$project$I18n$Traductions$Chaine(p.Fs))
				]),
			'Est déclenché par ' + p.Fs);
	});
var $author$project$I18n$Cles$pipesLienEstRegroupe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipes.lien.est-regroupe',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'pipe',
					$author$project$I18n$Traductions$Chaine(p.Fs))
				]),
			'Est regroupé par ' + p.Fs);
	});
var $author$project$I18n$Cles$pipesLienOuvre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipes.lien.ouvre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'pipe',
					$author$project$I18n$Traductions$Chaine(p.Fs))
				]),
			'Ouvre ' + p.Fs);
	});
var $author$project$I18n$Cles$pipesLienRegroupe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipes.lien.regroupe',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'pipe',
					$author$project$I18n$Traductions$Chaine(p.Fs))
				]),
			'Regroupe ' + p.Fs);
	});
var $author$project$Components$Parametrage$Vocabulaire$lienEntrePipes = F3(
	function (i18n, autre, lien) {
		var _v0 = lien.IC;
		switch (_v0) {
			case 'est-regroupe':
				return A2(
					$author$project$I18n$Cles$pipesLienEstRegroupe,
					i18n,
					{Fs: autre});
			case 'regroupe':
				return A2(
					$author$project$I18n$Cles$pipesLienRegroupe,
					i18n,
					{Fs: autre});
			case 'est-declenche-par':
				return A2(
					$author$project$I18n$Cles$pipesLienEstDeclenchePar,
					i18n,
					{Fs: autre});
			case 'ouvre':
				return A2(
					$author$project$I18n$Cles$pipesLienOuvre,
					i18n,
					{Fs: autre});
			default:
				var sens = _v0;
				return sens;
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$View$versLeLien = F2(
	function (i18n, lien) {
		return A3(
			$author$project$Components$Parametrage$Vocabulaire$lienEntrePipes,
			i18n,
			lien.t5,
			{t5: lien.t5, IC: lien.IC, r0: lien.r0});
	});
var $author$project$Components$Parametrage$PipeEtape1$View$lignesDesLiens = F2(
	function (i18n, edition) {
		return $elm$core$List$isEmpty(edition.nQ) ? _List_fromArray(
			[
				A5(
				$author$project$Components$Parametrage$PipeEtape1$View$reglage,
				'lien',
				$author$project$I18n$Cles$pipeEtape1LienTitre(i18n),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipesLienAucun(i18n))
							])),
						$author$project$Components$Parametrage$PipeEtape1$View$precision(
						$author$project$I18n$Cles$pipeEtape1LienAide(i18n))
					]),
				A2(
					$elm$core$Maybe$map,
					function (_v0) {
						return _Utils_Tuple2(
							$author$project$Components$Parametrage$PipeEtape1$Model$idDuDeclencheur('lien'),
							$author$project$Components$Parametrage$PipeEtape1$Update$LienAjoutDemande);
					},
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierLeLien, edition.BN)),
				$author$project$I18n$Cles$pipeEtape1Modifier(i18n))
			]) : A2(
			$elm$core$List$indexedMap,
			F2(
				function (rang, lien) {
					return A5(
						$author$project$Components$Parametrage$PipeEtape1$View$reglage,
						'lien',
						(!rang) ? $author$project$I18n$Cles$pipeEtape1LienTitre(i18n) : '',
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$Components$Parametrage$PipeEtape1$View$versLeLien, i18n, lien))
									]))
							]),
						A2(
							$elm$core$Maybe$map,
							function (lecture) {
								return _Utils_Tuple2(
									$author$project$Components$Parametrage$PipeEtape1$Model$idDuDeclencheur(
										(!rang) ? 'lien' : ('lien-' + $elm$core$String$fromInt(rang))),
									$author$project$Components$Parametrage$PipeEtape1$Update$LienDemande(lecture));
							},
							A2(
								$elm$core$Maybe$andThen,
								function (_v1) {
									return lien.np;
								},
								A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierLeLien, edition.BN))),
						$author$project$I18n$Cles$pipeEtape1Modifier(i18n));
				}),
			edition.nQ);
	});
var $author$project$Components$Parametrage$PipeEtape1$View$reglages = F2(
	function (i18n, edition) {
		return _Utils_ap(
			_List_fromArray(
				[
					A2($author$project$Components$Parametrage$PipeEtape1$View$ligneDuNom, i18n, edition),
					A2($author$project$Components$Parametrage$PipeEtape1$View$ligneDuMot, i18n, edition),
					A2($author$project$Components$Parametrage$PipeEtape1$View$ligneDeLObjetVise, i18n, edition),
					A2($author$project$Components$Parametrage$PipeEtape1$View$lignesDeLOffre, i18n, edition),
					A2($author$project$Components$Parametrage$PipeEtape1$View$ligneDeLOuverture, i18n, edition),
					A2($author$project$Components$Parametrage$PipeEtape1$View$ligneDesOuverturesParUnTiers, i18n, edition),
					A2($author$project$Components$Parametrage$PipeEtape1$View$ligneDeLaVersion, i18n, edition)
				]),
			A2($author$project$Components$Parametrage$PipeEtape1$View$lignesDesLiens, i18n, edition));
	});
var $author$project$Components$Parametrage$PipeEtape1$View$corps = F3(
	function (i18n, messages, model) {
		var _v0 = _Utils_Tuple2(model.ge, model.nf);
		if (!_v0.a.$) {
			var edition = _v0.a.a;
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
						]),
					_List_fromArray(
						[
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('etape')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h2,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape1Etape1(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('explication')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape1QuelIntro(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$ul,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('reglages')
										]),
									A2($author$project$Components$Parametrage$PipeEtape1$View$reglages, i18n, edition)),
									A2($author$project$Components$Parametrage$PipeEtape1$View$noteDeLectureSeule, i18n, edition)
								]))
						])),
					A3($author$project$Components$Parametrage$PipeEtape1$View$apercu, i18n, model, edition)
				]);
		} else {
			if (_v0.b) {
				var _v1 = _v0.a;
				return _List_fromArray(
					[
						A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape1Introuvable(i18n))
							]))
					]);
			} else {
				var _v2 = _v0.a;
				return _List_fromArray(
					[
						A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
						A2($author$project$Components$Parametrage$PipeEtape1$View$ajoutDUnType, i18n, model)
					]);
			}
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$EnregistrementDemande = {$: 42};
var $author$project$Components$Parametrage$PipeEtape1$Update$Recharger = {$: 5};
var $author$project$Components$Parametrage$PipeEtape1$Lien$ChampRepris = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$Lien$ChampsChoisis = {$: 2};
var $author$project$Components$Parametrage$PipeEtape1$Update$DuLien = F2(
	function (a, b) {
		return {$: 40, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$DuLienCoche = F2(
	function (a, b) {
		return {$: 41, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape1$Lien$EtapeDeDepart = {$: 10};
var $author$project$Components$Parametrage$PipeEtape1$Lien$Fiche = {$: 0};
var $author$project$Components$Parametrage$PipeEtape1$Lien$Passage = {$: 11};
var $author$project$Components$Parametrage$PipeEtape1$Lien$PipeDeDepart = {$: 9};
var $author$project$Components$Parametrage$PipeEtape1$Lien$Roles = {$: 1};
var $author$project$I18n$Cles$pipeEtape1LienDepartMotLElide = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.lien.depart-mot-l-elide',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'l\'' + p.Dj);
	});
var $author$project$I18n$Cles$pipeEtape1LienDepartMotLa = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.lien.depart-mot-la',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'la ' + p.Dj);
	});
var $author$project$I18n$Cles$pipeEtape1LienDepartMotLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.lien.depart-mot-le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'le ' + p.Dj);
	});
var $author$project$Components$Parametrage$PipeEtape1$Phrases$avecArticleDefini = F2(
	function (i18n, lue) {
		if (lue.av) {
			return A2(
				$author$project$I18n$Cles$pipeEtape1LienDepartMotLElide,
				i18n,
				{Dj: lue.IN});
		} else {
			var _v0 = lue.M;
			if (!_v0) {
				return A2(
					$author$project$I18n$Cles$pipeEtape1LienDepartMotLe,
					i18n,
					{Dj: lue.IN});
			} else {
				return A2(
					$author$project$I18n$Cles$pipeEtape1LienDepartMotLa,
					i18n,
					{Dj: lue.IN});
			}
		}
	});
var $author$project$Components$Parametrage$Common$Conception$caseACocher = F5(
	function (groupe, estCochee, titre, aide, msg) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('choix'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-groupe', groupe)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
							$rtfeldman$elm_css$Html$Styled$Attributes$name(groupe),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(estCochee),
							$rtfeldman$elm_css$Html$Styled$Events$onCheck(msg)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('textes')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(titre)
								])),
							(aide === '') ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(aide)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('etat'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('coche', estCochee)
								])),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-type', 'checkbox')
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$Parametrage$PipeEtape1$Lien$etapesDe = F2(
	function (options, pipeUid) {
		return A2(
			$elm$core$List$concatMap,
			$elm$core$Tuple$second,
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var uid = _v0.a;
					return _Utils_eq(uid, pipeUid);
				},
				options.yL));
	});
var $author$project$Components$Parametrage$PipeEtape1$LienView$libelleDe = F2(
	function (uid, choix) {
		return A2(
			$elm$core$Maybe$withDefault,
			'…',
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var code = _v0.a;
							return _Utils_eq(code, uid);
						},
						choix))));
	});
var $author$project$Components$Parametrage$PipeEtape1$LienView$liste = F4(
	function (libelle, valeur, msg, choix) {
		return A4(
			$author$project$Components$Parametrage$Common$Conception$liste,
			libelle,
			valeur,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2('', ''),
				choix),
			msg);
	});
var $author$project$I18n$Cles$pipeEtape1LienChampOrigineDossier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.champ-origine-dossier', _List_Nil, 'Champ du dossier');
};
var $author$project$Components$Parametrage$Vocabulaire$origineDuChamp = F2(
	function (i18n, code) {
		if (code === 'champ-du-dossier') {
			return $author$project$I18n$Cles$pipeEtape1LienChampOrigineDossier(i18n);
		} else {
			return code;
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$Lien$passagesDe = F2(
	function (options, etapeUid) {
		return A2(
			$elm$core$List$concatMap,
			$elm$core$Tuple$second,
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var uid = _v0.a;
					return _Utils_eq(uid, etapeUid);
				},
				options.E5));
	});
var $author$project$I18n$Cles$pipeEtape1LienApercu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.apercu', _List_Nil, 'Aperçu');
};
var $author$project$I18n$Cles$pipeEtape1LienApercuEnchainementDebut = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.lien.apercu-enchainement-debut',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'depart',
					$author$project$I18n$Traductions$Chaine(p.cx)),
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av)))
				]),
			'Quand ' + (p.cx + (' ' + function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ';
					case 1:
						return 'd\'';
					default:
						return 'de ';
				}
			}())));
	});
var $author$project$I18n$Cles$pipeEtape1LienApercuEnchainementDossier = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.lien.apercu-enchainement-dossier',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'mot',
					$author$project$I18n$Traductions$Chaine(p.ej)),
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'personne',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.Fd)))
				]),
			p.ej + (' ' + function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.Fd);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.Fd);
					default:
						return 'de ' + $elm$core$String$trim(p.Fd);
				}
			}()));
	});
var $author$project$I18n$Cles$pipeEtape1LienApercuEnchainementFin = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.lien.apercu-enchainement-fin',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'reprise',
					$author$project$I18n$Traductions$Chaine(p.qx))
				]),
			' s\'ouvre' + (p.qx + '.'));
	});
var $author$project$I18n$Cles$pipeEtape1LienApercuEnchainementMilieu = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.lien.apercu-enchainement-milieu',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etape',
					$author$project$I18n$Traductions$Chaine(p.me)),
					_Utils_Tuple2(
					'passage',
					$author$project$I18n$Traductions$Chaine(p.aH))
				]),
			' passe à « ' + (p.me + (' » (passage « ' + (p.aH + ' »), le dossier '))));
	});
var $author$project$I18n$Cles$pipeEtape1LienApercuPersonneInconnue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.apercu-personne-inconnue', _List_Nil, 'la personne');
};
var $author$project$I18n$Cles$pipeEtape1LienDepart = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.depart', _List_Nil, 'Départ de l\'enchaînement');
};
var $author$project$I18n$Cles$pipeEtape1LienDepartDossierDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.lien.depart-dossier-de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'mot',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.ej)))
				]),
			'un dossier ' + function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + ($elm$core$String$toLower(
							A2(
								$elm$core$String$left,
								1,
								$elm$core$String$trim(p.ej))) + A2(
							$elm$core$String$dropLeft,
							1,
							$elm$core$String$trim(p.ej)));
					case 1:
						return 'd\'' + ($elm$core$String$toLower(
							A2(
								$elm$core$String$left,
								1,
								$elm$core$String$trim(p.ej))) + A2(
							$elm$core$String$dropLeft,
							1,
							$elm$core$String$trim(p.ej)));
					default:
						return 'de ' + ($elm$core$String$toLower(
							A2(
								$elm$core$String$left,
								1,
								$elm$core$String$trim(p.ej))) + A2(
							$elm$core$String$dropLeft,
							1,
							$elm$core$String$trim(p.ej)));
				}
			}());
	});
var $author$project$I18n$Cles$pipeEtape1LienDepartEtape = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.depart-etape', _List_Nil, 'Étape de départ');
};
var $author$project$I18n$Cles$pipeEtape1LienDepartPassage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.depart-passage', _List_Nil, 'Passage déclencheur');
};
var $author$project$I18n$Cles$pipeEtape1LienDepartPipe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.depart-pipe', _List_Nil, 'Pipe de départ');
};
var $author$project$I18n$Cles$pipeEtape1LienDepartSansPipe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.depart-sans-pipe', _List_Nil, 'un dossier');
};
var $author$project$I18n$Cles$pipeEtape1LienDepartTexte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.lien.depart-texte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'depart',
					$author$project$I18n$Traductions$Chaine(p.cx)),
					_Utils_Tuple2(
					'etape',
					$author$project$I18n$Traductions$Chaine(p.me)),
					_Utils_Tuple2(
					'passage',
					$author$project$I18n$Traductions$Chaine(p.aH)),
					_Utils_Tuple2(
					'arrivee',
					$author$project$I18n$Traductions$Chaine(p.tN))
				]),
			'Quand ' + (p.cx + (' arrive à l\'étape « ' + (p.me + (' » par le passage « ' + (p.aH + (' », ' + (p.tN + ' s\'ouvre.'))))))));
	});
var $author$project$I18n$Cles$pipeEtape1LienReprise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.reprise', _List_Nil, 'Repris dans le nouveau dossier');
};
var $author$project$I18n$Cles$pipeEtape1LienRepriseChamps = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.reprise-champs', _List_Nil, 'Des champs choisis');
};
var $author$project$I18n$Cles$pipeEtape1LienRepriseChampsAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.reprise-champs-aide', _List_Nil, 'Seuls les champs cochés sont copiés');
};
var $author$project$I18n$Cles$pipeEtape1LienRepriseFiche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.reprise-fiche', _List_Nil, 'La fiche visée');
};
var $author$project$I18n$Cles$pipeEtape1LienRepriseFicheAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.reprise-fiche-aide', _List_Nil, 'Le producteur devient l\'objet visé de la campagne');
};
var $author$project$I18n$Cles$pipeEtape1LienRepriseGroupe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.reprise-groupe', _List_Nil, 'À reprendre');
};
var $author$project$I18n$Cles$pipeEtape1LienRepriseRoles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.reprise-roles', _List_Nil, 'Les rôles');
};
var $author$project$I18n$Cles$pipeEtape1LienRepriseRolesAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.reprise-roles-aide', _List_Nil, 'Mêmes gestionnaires et mêmes contrôleurs qualité, si le pipe d\'arrivée les prévoit');
};
var $author$project$I18n$Cles$pipeEtape1LienApercuReprise = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.lien.apercu-reprise',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elements',
					$author$project$I18n$Traductions$Chaine(p.aV))
				]),
			'avec ' + p.aV);
	});
var $author$project$I18n$Cles$pipeEtape1LienApercuRepriseChamps = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.apercu-reprise-champs', _List_Nil, 'les champs repris');
};
var $author$project$I18n$Cles$pipeEtape1LienApercuRepriseFiche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.apercu-reprise-fiche', _List_Nil, 'sa fiche');
};
var $author$project$I18n$Cles$pipeEtape1LienApercuRepriseRoles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.apercu-reprise-roles', _List_Nil, 'ses rôles');
};
var $author$project$Components$Parametrage$PipeEtape1$LienView$reprise = F3(
	function (i18n, options, saisie) {
		var elements = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					saisie.zo ? $elm$core$Maybe$Just(
					$author$project$I18n$Cles$pipeEtape1LienApercuRepriseFiche(i18n)) : $elm$core$Maybe$Nothing,
					saisie.eX ? $elm$core$Maybe$Just(
					$author$project$I18n$Cles$pipeEtape1LienApercuRepriseRoles(i18n)) : $elm$core$Maybe$Nothing,
					A2(
					$elm$core$List$any,
					function (champ_) {
						return A2($elm$core$List$member, champ_.uN, saisie.K);
					},
					options.u0) ? $elm$core$Maybe$Just(
					$author$project$I18n$Cles$pipeEtape1LienApercuRepriseChamps(i18n)) : $elm$core$Maybe$Nothing
				]));
		var _v0 = $elm$core$List$reverse(elements);
		if (!_v0.b) {
			return '';
		} else {
			if (!_v0.b.b) {
				var seul = _v0.a;
				return ' ' + A2(
					$author$project$I18n$Cles$pipeEtape1LienApercuReprise,
					i18n,
					{aV: seul});
			} else {
				var dernier = _v0.a;
				var avant = _v0.b;
				return ' ' + A2(
					$author$project$I18n$Cles$pipeEtape1LienApercuReprise,
					i18n,
					{
						aV: A2(
							$elm$core$String$join,
							', ',
							$elm$core$List$reverse(avant)) + (' et ' + dernier)
					});
			}
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$LienView$section = F2(
	function (titre, contenu_) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('section-drawer')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(titre)
						])),
				contenu_));
	});
var $author$project$I18n$Cles$pipeEtape1LienDepartMotUn = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.lien.depart-mot-un',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'un ' + p.Dj);
	});
var $author$project$I18n$Cles$pipeEtape1LienDepartMotUne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.lien.depart-mot-une',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'une ' + p.Dj);
	});
var $author$project$Components$Parametrage$PipeEtape1$LienView$unNom = F2(
	function (i18n, lue) {
		var _v0 = lue.M;
		if (!_v0) {
			return A2(
				$author$project$I18n$Cles$pipeEtape1LienDepartMotUn,
				i18n,
				{Dj: lue.IN});
		} else {
			return A2(
				$author$project$I18n$Cles$pipeEtape1LienDepartMotUne,
				i18n,
				{Dj: lue.IN});
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$LienView$enchainement = F4(
	function (i18n, contexte, options, saisie) {
		var pipes = A2(
			$elm$core$List$map,
			function (pipe) {
				return _Utils_Tuple2(pipe.r8, pipe.Bl);
			},
			options.eE);
		var personne = A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Cles$pipeEtape1LienApercuPersonneInconnue(i18n),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Fd;
				},
				contexte.yY));
		var passages = A2(
			$elm$core$List$map,
			function (passage) {
				return _Utils_Tuple2(passage.r8, passage.Bl);
			},
			A2($author$project$Components$Parametrage$PipeEtape1$Lien$passagesDe, options, saisie.yJ));
		var motDeDepart = A2(
			$elm$core$Maybe$andThen,
			$author$project$Components$Parametrage$PipeEtape1$Phrases$forme,
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.CW;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (pipe) {
							return _Utils_eq(pipe.r8, saisie.Fv);
						},
						options.eE))));
		var etapes = A2(
			$elm$core$List$map,
			function (etape) {
				return _Utils_Tuple2(etape.r8, etape.Bl);
			},
			A2($author$project$Components$Parametrage$PipeEtape1$Lien$etapesDe, options, saisie.Fv));
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Parametrage$PipeEtape1$LienView$section,
				$author$project$I18n$Cles$pipeEtape1LienDepart(i18n),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$pipeEtape1LienDepartTexte,
									i18n,
									{
										tN: A2(
											$author$project$I18n$Cles$pipeEtape1LienDepartDossierDe,
											i18n,
											{
												av: $author$project$Texte$Elision$elision(contexte.ej),
												ej: contexte.ej
											}),
										cx: A2(
											$elm$core$Maybe$withDefault,
											$author$project$I18n$Cles$pipeEtape1LienDepartSansPipe(i18n),
											A2(
												$elm$core$Maybe$map,
												$author$project$Components$Parametrage$PipeEtape1$LienView$unNom(i18n),
												motDeDepart)),
										me: A2($author$project$Components$Parametrage$PipeEtape1$LienView$libelleDe, saisie.yJ, etapes),
										aH: A2($author$project$Components$Parametrage$PipeEtape1$LienView$libelleDe, saisie.aH, passages)
									}))
							])),
						A4(
						$author$project$Components$Parametrage$PipeEtape1$LienView$liste,
						$author$project$I18n$Cles$pipeEtape1LienDepartPipe(i18n),
						saisie.Fv,
						$author$project$Components$Parametrage$PipeEtape1$Update$DuLien($author$project$Components$Parametrage$PipeEtape1$Lien$PipeDeDepart),
						pipes),
						A4(
						$author$project$Components$Parametrage$PipeEtape1$LienView$liste,
						$author$project$I18n$Cles$pipeEtape1LienDepartEtape(i18n),
						saisie.yJ,
						$author$project$Components$Parametrage$PipeEtape1$Update$DuLien($author$project$Components$Parametrage$PipeEtape1$Lien$EtapeDeDepart),
						etapes),
						A4(
						$author$project$Components$Parametrage$PipeEtape1$LienView$liste,
						$author$project$I18n$Cles$pipeEtape1LienDepartPassage(i18n),
						saisie.aH,
						$author$project$Components$Parametrage$PipeEtape1$Update$DuLien($author$project$Components$Parametrage$PipeEtape1$Lien$Passage),
						passages)
					])),
				A2(
				$author$project$Components$Parametrage$PipeEtape1$LienView$section,
				$author$project$I18n$Cles$pipeEtape1LienReprise(i18n),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$fieldset,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('groupe-de-choix')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$legend,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape1LienRepriseGroupe(i18n))
									])),
								A5(
								$author$project$Components$Parametrage$Common$Conception$caseACocher,
								'reprise',
								saisie.zo,
								$author$project$I18n$Cles$pipeEtape1LienRepriseFiche(i18n),
								$author$project$I18n$Cles$pipeEtape1LienRepriseFicheAide(i18n),
								$author$project$Components$Parametrage$PipeEtape1$Update$DuLienCoche($author$project$Components$Parametrage$PipeEtape1$Lien$Fiche)),
								A5(
								$author$project$Components$Parametrage$Common$Conception$caseACocher,
								'reprise',
								saisie.eX,
								$author$project$I18n$Cles$pipeEtape1LienRepriseRoles(i18n),
								$author$project$I18n$Cles$pipeEtape1LienRepriseRolesAide(i18n),
								$author$project$Components$Parametrage$PipeEtape1$Update$DuLienCoche($author$project$Components$Parametrage$PipeEtape1$Lien$Roles)),
								A5(
								$author$project$Components$Parametrage$Common$Conception$caseACocher,
								'reprise',
								saisie.jD,
								$author$project$I18n$Cles$pipeEtape1LienRepriseChamps(i18n),
								$author$project$I18n$Cles$pipeEtape1LienRepriseChampsAide(i18n),
								$author$project$Components$Parametrage$PipeEtape1$Update$DuLienCoche($author$project$Components$Parametrage$PipeEtape1$Lien$ChampsChoisis))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('champs-repris'),
								$rtfeldman$elm_css$Html$Styled$Attributes$hidden(!saisie.jD)
							]),
						A2(
							$elm$core$List$map,
							function (champ_) {
								return A5(
									$author$project$Components$Parametrage$Common$Conception$caseACocher,
									'champs',
									A2($elm$core$List$member, champ_.uN, saisie.K),
									champ_.Bl,
									A2($author$project$Components$Parametrage$Vocabulaire$origineDuChamp, i18n, champ_.o4),
									$author$project$Components$Parametrage$PipeEtape1$Update$DuLienCoche(
										$author$project$Components$Parametrage$PipeEtape1$Lien$ChampRepris(champ_.uN)));
							},
							options.u0))
					])),
				A2(
				$author$project$Components$Parametrage$PipeEtape1$LienView$section,
				$author$project$I18n$Cles$pipeEtape1LienApercu(i18n),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu-du-lien')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$pipeEtape1LienApercuEnchainementDebut,
									i18n,
									{
										cx: A2(
											$elm$core$Maybe$withDefault,
											$author$project$I18n$Cles$pipeEtape1LienDepartSansPipe(i18n),
											A2(
												$elm$core$Maybe$map,
												$author$project$Components$Parametrage$PipeEtape1$Phrases$avecArticleDefini(i18n),
												motDeDepart)),
										av: $author$project$Texte$Elision$elision(personne)
									})),
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(personne)
									])),
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$pipeEtape1LienApercuEnchainementMilieu,
									i18n,
									{
										me: A2($author$project$Components$Parametrage$PipeEtape1$LienView$libelleDe, saisie.yJ, etapes),
										aH: A2($author$project$Components$Parametrage$PipeEtape1$LienView$libelleDe, saisie.aH, passages)
									})),
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$pipeEtape1LienApercuEnchainementDossier,
											i18n,
											{
												av: $author$project$Texte$Elision$elision(personne),
												ej: contexte.ej,
												Fd: personne
											}))
									])),
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$pipeEtape1LienApercuEnchainementFin,
									i18n,
									{
										qx: A3($author$project$Components$Parametrage$PipeEtape1$LienView$reprise, i18n, options, saisie)
									}))
							]))
					]))
			]);
	});
var $author$project$Components$Parametrage$PipeEtape1$Lien$Mot = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$Lien$Nom = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$LienView$champ = F3(
	function (libelle, valeur, msg) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('champ')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(valeur),
							$rtfeldman$elm_css$Html$Styled$Events$onInput(msg)
						]),
					_List_Nil)
				]));
	});
var $author$project$I18n$Cles$pipeEtape1LienMot = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.mot', _List_Nil, 'Mot employé pour un dossier');
};
var $author$project$I18n$Cles$pipeEtape1LienNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.nom', _List_Nil, 'Nom');
};
var $author$project$I18n$Cles$pipeEtape1LienNomDuPipe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.nom-du-pipe', _List_Nil, 'Nom du pipe');
};
var $author$project$Components$Parametrage$PipeEtape1$LienView$valeurFr = function (libelles) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Dict$get, 'fr', libelles));
};
var $author$project$Components$Parametrage$PipeEtape1$LienView$nomEtMot = F2(
	function (i18n, saisie) {
		return A2(
			$author$project$Components$Parametrage$PipeEtape1$LienView$section,
			$author$project$I18n$Cles$pipeEtape1LienNom(i18n),
			_List_fromArray(
				[
					A3(
					$author$project$Components$Parametrage$PipeEtape1$LienView$champ,
					$author$project$I18n$Cles$pipeEtape1LienNomDuPipe(i18n),
					$author$project$Components$Parametrage$PipeEtape1$LienView$valeurFr(saisie.Dj),
					$author$project$Components$Parametrage$PipeEtape1$Update$DuLien(
						$author$project$Components$Parametrage$PipeEtape1$Lien$Nom('fr'))),
					A3(
					$author$project$Components$Parametrage$PipeEtape1$LienView$champ,
					$author$project$I18n$Cles$pipeEtape1LienMot(i18n),
					$author$project$Components$Parametrage$PipeEtape1$LienView$valeurFr(saisie.ej),
					$author$project$Components$Parametrage$PipeEtape1$Update$DuLien(
						$author$project$Components$Parametrage$PipeEtape1$Lien$Mot('fr')))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape1$Lien$Champ = {$: 8};
var $author$project$Components$Parametrage$PipeEtape1$Lien$Critere = {$: 6};
var $author$project$Components$Parametrage$PipeEtape1$Lien$Jour = {$: 5};
var $author$project$Components$Parametrage$PipeEtape1$Update$PageSuivanteDesPipesLiablesDemandee = {$: 11};
var $author$project$Components$Parametrage$PipeEtape1$Lien$Periode = {$: 7};
var $author$project$Components$Parametrage$PipeEtape1$Lien$PipeRegroupe = {$: 3};
var $author$project$Components$Parametrage$PipeEtape1$Lien$Regle = {$: 4};
var $author$project$Components$Parametrage$Common$Conception$choix = F6(
	function (groupe, code, estCoche, titre, aide, msg) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('choix'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-groupe', groupe)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
							$rtfeldman$elm_css$Html$Styled$Attributes$name(groupe),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(estCoche),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(msg),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(code)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('textes')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(titre)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(aide)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('etat'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('coche', estCoche)
								])),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-type', 'radio')
						]),
					_List_Nil)
				]));
	});
var $author$project$I18n$Cles$pipeEtape1LienAgregats = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.agregats', _List_Nil, 'Agrégats qui pilotent les passages');
};
var $author$project$I18n$Cles$pipeEtape1LienAgregatsTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.agregats-texte', _List_Nil, 'Le regroupement calcule ces totaux ; ils décident de ses passages. Ses actions s\'appliquent aux dossiers qu\'il contient.');
};
var $author$project$I18n$Cles$pipeEtape1LienChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.champ', _List_Nil, 'Champ');
};
var $author$project$I18n$Cles$pipeEtape1LienCritere = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.critere', _List_Nil, 'Critère de regroupement');
};
var $author$project$I18n$Cles$pipeEtape1LienCritereChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.critere-champ', _List_Nil, 'Un champ');
};
var $author$project$I18n$Cles$pipeEtape1LienCritereChampAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.critere-champ-aide', _List_Nil, 'Les dossiers qui ont la même valeur sur un champ choisi sont rassemblés.');
};
var $author$project$I18n$Cles$pipeEtape1LienCriterePeriode = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.critere-periode', _List_Nil, 'La période');
};
var $author$project$I18n$Cles$pipeEtape1LienCriterePeriodeAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.critere-periode-aide', _List_Nil, 'Une commande rejoint la campagne du mois où elle est saisie.');
};
var $author$project$I18n$Cles$pipeEtape1LienPeriode = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.periode', _List_Nil, 'Période');
};
var $author$project$I18n$Cles$pipeEtape1LienPeriodeMoisCivil = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.periode-mois-civil', _List_Nil, 'Le mois civil');
};
var $author$project$I18n$Cles$pipeEtape1LienPeriodeSemaine = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.periode-semaine', _List_Nil, 'La semaine');
};
var $author$project$I18n$Cles$pipeEtape1LienPeriodeTrimestre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.periode-trimestre', _List_Nil, 'Le trimestre');
};
var $author$project$I18n$Cles$pipeEtape1LienPipeRegroupe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.pipe-regroupe', _List_Nil, 'Pipe regroupé');
};
var $author$project$I18n$Cles$pipeEtape1LienPipeRegroupeChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.pipe-regroupe-champ', _List_Nil, 'Les dossiers de ce pipe sont rassemblés');
};
var $author$project$I18n$Cles$pipeEtape1LienPipeRegroupeTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.pipe-regroupe-texte', _List_Nil, 'Chaque dossier de ce pipe est rattaché à un dossier de regroupement.');
};
var $author$project$I18n$Cles$pipeEtape1LienRegle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.regle', _List_Nil, 'Règle de création');
};
var $author$project$I18n$Cles$pipeEtape1LienRegleALaMain = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.regle-a-la-main', _List_Nil, 'À la main, par un gestionnaire');
};
var $author$project$I18n$Cles$pipeEtape1LienRegleChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.regle-champ', _List_Nil, 'Quand un dossier de regroupement est créé');
};
var $author$project$I18n$Cles$pipeEtape1LienRegleJour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.regle-jour', _List_Nil, 'Jour du mois');
};
var $author$project$I18n$Cles$pipeEtape1LienRegleTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.regle-texte', _List_Nil, 'Exemple : « Campagne de production — novembre 2026 ».');
};
var $author$project$I18n$Cles$pipeEtape1LienRegleUnParMois = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.lien.regle-un-par-mois',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'jour',
					$author$project$I18n$Traductions$Chaine(p.A_))
				]),
			'Un dossier par mois, créé le ' + p.A_);
	});
var $author$project$I18n$Cles$pipeEtape1LienRegleUnParSemaine = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.regle-un-par-semaine', _List_Nil, 'Un dossier par semaine, créé le lundi');
};
var $author$project$Components$Parametrage$PipeEtape1$LienView$regroupement = F3(
	function (i18n, options, saisie) {
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Parametrage$PipeEtape1$LienView$section,
				$author$project$I18n$Cles$pipeEtape1LienPipeRegroupe(i18n),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape1LienPipeRegroupeTexte(i18n))
							])),
						A4(
						$author$project$Components$Parametrage$PipeEtape1$LienView$liste,
						$author$project$I18n$Cles$pipeEtape1LienPipeRegroupeChamp(i18n),
						saisie.FH,
						$author$project$Components$Parametrage$PipeEtape1$Update$DuLien($author$project$Components$Parametrage$PipeEtape1$Lien$PipeRegroupe),
						A2(
							$elm$core$List$map,
							function (pipe) {
								return _Utils_Tuple2(pipe.r8, pipe.Bl);
							},
							options.eE)),
						A2(
						$elm$core$Maybe$withDefault,
						$rtfeldman$elm_css$Html$Styled$text(''),
						A2(
							$elm$core$Maybe$map,
							function (_v0) {
								return A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape1$Update$PageSuivanteDesPipesLiablesDemandee)
										]),
									$author$project$I18n$Cles$annuairePaginationSuivante(i18n));
							},
							options.I7))
					])),
				A2(
				$author$project$Components$Parametrage$PipeEtape1$LienView$section,
				$author$project$I18n$Cles$pipeEtape1LienRegle(i18n),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape1LienRegleTexte(i18n))
								])),
							A4(
							$author$project$Components$Parametrage$PipeEtape1$LienView$liste,
							$author$project$I18n$Cles$pipeEtape1LienRegleChamp(i18n),
							saisie.hH,
							$author$project$Components$Parametrage$PipeEtape1$Update$DuLien($author$project$Components$Parametrage$PipeEtape1$Lien$Regle),
							_List_fromArray(
								[
									_Utils_Tuple2(
									'un-par-mois',
									A2(
										$author$project$I18n$Cles$pipeEtape1LienRegleUnParMois,
										i18n,
										{A_: saisie.A_})),
									_Utils_Tuple2(
									'un-par-semaine',
									$author$project$I18n$Cles$pipeEtape1LienRegleUnParSemaine(i18n)),
									_Utils_Tuple2(
									'a-la-main',
									$author$project$I18n$Cles$pipeEtape1LienRegleALaMain(i18n))
								]))
						]),
					(saisie.hH === 'un-par-mois') ? _List_fromArray(
						[
							A3(
							$author$project$Components$Parametrage$PipeEtape1$LienView$champ,
							$author$project$I18n$Cles$pipeEtape1LienRegleJour(i18n),
							saisie.A_,
							$author$project$Components$Parametrage$PipeEtape1$Update$DuLien($author$project$Components$Parametrage$PipeEtape1$Lien$Jour))
						]) : _List_Nil)),
				A2(
				$author$project$Components$Parametrage$PipeEtape1$LienView$section,
				$author$project$I18n$Cles$pipeEtape1LienCritere(i18n),
				_Utils_ap(
					_List_fromArray(
						[
							A6(
							$author$project$Components$Parametrage$Common$Conception$choix,
							'critere',
							'periode',
							saisie.km === 'periode',
							$author$project$I18n$Cles$pipeEtape1LienCriterePeriode(i18n),
							$author$project$I18n$Cles$pipeEtape1LienCriterePeriodeAide(i18n),
							A2($author$project$Components$Parametrage$PipeEtape1$Update$DuLien, $author$project$Components$Parametrage$PipeEtape1$Lien$Critere, 'periode')),
							A6(
							$author$project$Components$Parametrage$Common$Conception$choix,
							'critere',
							'champ',
							saisie.km === 'champ',
							$author$project$I18n$Cles$pipeEtape1LienCritereChamp(i18n),
							$author$project$I18n$Cles$pipeEtape1LienCritereChampAide(i18n),
							A2($author$project$Components$Parametrage$PipeEtape1$Update$DuLien, $author$project$Components$Parametrage$PipeEtape1$Lien$Critere, 'champ'))
						]),
					_List_fromArray(
						[
							(saisie.km === 'champ') ? A3(
							$author$project$Components$Parametrage$PipeEtape1$LienView$champ,
							$author$project$I18n$Cles$pipeEtape1LienChamp(i18n),
							saisie.uN,
							$author$project$Components$Parametrage$PipeEtape1$Update$DuLien($author$project$Components$Parametrage$PipeEtape1$Lien$Champ)) : A4(
							$author$project$Components$Parametrage$PipeEtape1$LienView$liste,
							$author$project$I18n$Cles$pipeEtape1LienPeriode(i18n),
							saisie.pi,
							$author$project$Components$Parametrage$PipeEtape1$Update$DuLien($author$project$Components$Parametrage$PipeEtape1$Lien$Periode),
							_List_fromArray(
								[
									_Utils_Tuple2(
									'mois-civil',
									$author$project$I18n$Cles$pipeEtape1LienPeriodeMoisCivil(i18n)),
									_Utils_Tuple2(
									'semaine',
									$author$project$I18n$Cles$pipeEtape1LienPeriodeSemaine(i18n)),
									_Utils_Tuple2(
									'trimestre',
									$author$project$I18n$Cles$pipeEtape1LienPeriodeTrimestre(i18n))
								]))
						]))),
				A2(
				$author$project$Components$Parametrage$PipeEtape1$LienView$section,
				$author$project$I18n$Cles$pipeEtape1LienAgregats(i18n),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape1LienAgregatsTexte(i18n))
							])),
					A2(
						$elm$core$List$map,
						function (agregat) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(agregat.Bl)
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(agregat.dH)
											]))
									]));
						},
						saisie.s4)))
			]);
	});
var $author$project$Components$Parametrage$PipeEtape1$Lien$Type = {$: 2};
var $author$project$Components$Parametrage$PipeEtape1$LienView$estModification = function (saisie) {
	var _v0 = saisie.n9;
	if (_v0.$ === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$I18n$Cles$pipeEtape1LienType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.type', _List_Nil, 'Type de lien');
};
var $author$project$I18n$Cles$pipeEtape1LienTypeAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.type-aucun', _List_Nil, 'Sans lien');
};
var $author$project$I18n$Cles$pipeEtape1LienTypeAucunAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.type-aucun-aide', _List_Nil, 'Ce pipe n\'est relié à aucun autre pour l\'instant.');
};
var $author$project$I18n$Cles$pipeEtape1LienTypeEnchainement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.type-enchainement', _List_Nil, 'Enchaînement');
};
var $author$project$I18n$Cles$pipeEtape1LienTypeEnchainementAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.type-enchainement-aide', _List_Nil, 'Un dossier arrivé à une étape donnée ouvre un dossier dans l\'autre pipe.');
};
var $author$project$I18n$Cles$pipeEtape1LienTypeRegroupement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.type-regroupement', _List_Nil, 'Regroupement');
};
var $author$project$I18n$Cles$pipeEtape1LienTypeRegroupementAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.type-regroupement-aide', _List_Nil, 'Un dossier rassemble plusieurs dossiers de l\'autre pipe, selon une période ou un critère.');
};
var $author$project$Components$Parametrage$PipeEtape1$LienView$typeDeLien = F2(
	function (i18n, saisie) {
		var choix = F3(
			function (code, titre, aide) {
				return function (controle) {
					return ($author$project$Components$Parametrage$PipeEtape1$LienView$estModification(saisie) && (!_Utils_eq(saisie.r0, code))) ? $rtfeldman$elm_css$Html$Styled$text('') : controle;
				}(
					A6(
						$author$project$Components$Parametrage$Common$Conception$choix,
						'type-de-lien',
						code,
						_Utils_eq(saisie.r0, code),
						titre,
						aide,
						A2($author$project$Components$Parametrage$PipeEtape1$Update$DuLien, $author$project$Components$Parametrage$PipeEtape1$Lien$Type, code)));
			});
		return A2(
			$author$project$Components$Parametrage$PipeEtape1$LienView$section,
			$author$project$I18n$Cles$pipeEtape1LienType(i18n),
			_List_fromArray(
				[
					_Utils_eq(saisie.n9, $author$project$Components$Parametrage$PipeEtape1$Lien$Creation) ? A3(
					choix,
					'',
					$author$project$I18n$Cles$pipeEtape1LienTypeAucun(i18n),
					$author$project$I18n$Cles$pipeEtape1LienTypeAucunAide(i18n)) : $rtfeldman$elm_css$Html$Styled$text(''),
					A3(
					choix,
					'regroupement',
					$author$project$I18n$Cles$pipeEtape1LienTypeRegroupement(i18n),
					$author$project$I18n$Cles$pipeEtape1LienTypeRegroupementAide(i18n)),
					A3(
					choix,
					'enchainement',
					$author$project$I18n$Cles$pipeEtape1LienTypeEnchainement(i18n),
					$author$project$I18n$Cles$pipeEtape1LienTypeEnchainementAide(i18n))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape1$LienView$contenu = F4(
	function (i18n, contexte, options, saisie) {
		return _Utils_ap(
			_Utils_eq(saisie.n9, $author$project$Components$Parametrage$PipeEtape1$Lien$Creation) ? _List_fromArray(
				[
					A2($author$project$Components$Parametrage$PipeEtape1$LienView$nomEtMot, i18n, saisie)
				]) : _List_Nil,
			_Utils_ap(
				_List_fromArray(
					[
						A2($author$project$Components$Parametrage$PipeEtape1$LienView$typeDeLien, i18n, saisie)
					]),
				function () {
					var _v0 = _Utils_Tuple2(saisie.r0, options);
					_v0$2:
					while (true) {
						if (!_v0.b.$) {
							switch (_v0.a) {
								case 'regroupement':
									var proposees = _v0.b.a;
									return A3($author$project$Components$Parametrage$PipeEtape1$LienView$regroupement, i18n, proposees, saisie);
								case 'enchainement':
									var proposees = _v0.b.a;
									return A4($author$project$Components$Parametrage$PipeEtape1$LienView$enchainement, i18n, contexte, proposees, saisie);
								default:
									break _v0$2;
							}
						} else {
							break _v0$2;
						}
					}
					return _List_Nil;
				}()));
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$NatureDeLObjetViseChoisie = function (a) {
	return {$: 21, a: a};
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseLiaisonDeTypes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.drawer.objet-vise.liaison-de-types',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'debut',
					$author$project$I18n$Traductions$Chaine(p.ku)),
					_Utils_Tuple2(
					'dernier',
					$author$project$I18n$Traductions$Chaine(p.xg))
				]),
			p.ku + (' et ' + p.xg));
	});
var $author$project$Components$Parametrage$PipeEtape1$View$nommes = F2(
	function (i18n, noms) {
		var _v0 = $elm$core$List$reverse(noms);
		if (_v0.b && _v0.b.b) {
			var dernier = _v0.a;
			var _v1 = _v0.b;
			var avant = _v1.a;
			var reste = _v1.b;
			return A2(
				$author$project$I18n$Cles$pipeEtape1DrawerObjetViseLiaisonDeTypes,
				i18n,
				{
					ku: A2(
						$elm$core$String$join,
						', ',
						$elm$core$List$reverse(
							A2($elm$core$List$cons, avant, reste))),
					xg: dernier
				});
		} else {
			return A2($elm$core$String$join, ', ', noms);
		}
	});
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseAideChampsCommuns = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.aide-champs-communs', _List_Nil, 'Seuls les champs présents dans tous les types choisis servent de destination à l\'étape 5.');
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseAideChampsCommunsNombre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.drawer.objet-vise.aide-champs-communs-nombre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w)),
					_Utils_Tuple2(
					'types',
					$author$project$I18n$Traductions$Chaine(p.ib))
				]),
			((!p.w) || (p.w === 1)) ? ('Seuls les champs présents dans tous les types choisis servent de destination à l\'étape 5 : ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' champ commun à ' + (p.ib + '.')))) : ('Seuls les champs présents dans tous les types choisis servent de destination à l\'étape 5 : ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' champs communs à ' + (p.ib + '.')))));
	});
var $author$project$Components$Parametrage$PipeEtape1$View$aideDesChampsCommuns = F3(
	function (i18n, model, saisie) {
		var noms = A2(
			$elm$core$List$filterMap,
			function (code) {
				return A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Bl;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (o) {
								return _Utils_eq(o.vx, code);
							},
							model.ic)));
			},
			saisie.ib);
		var _v0 = _Utils_Tuple3(saisie.rL, model.uT, noms);
		if ((((!_v0.a) && (!_v0.b.$)) && _v0.c.b) && _v0.c.b.b) {
			var nombre = _v0.b.a;
			var _v1 = _v0.c;
			var _v2 = _v1.b;
			return A2(
				$author$project$I18n$Cles$pipeEtape1DrawerObjetViseAideChampsCommunsNombre,
				i18n,
				{
					w: nombre,
					ib: A2($author$project$Components$Parametrage$PipeEtape1$View$nommes, i18n, noms)
				});
		} else {
			return $author$project$I18n$Cles$pipeEtape1DrawerObjetViseAideChampsCommuns(i18n);
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$View$aideDuDrawer = function (texte) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(texte)
					]))
			]));
};
var $author$project$Components$Parametrage$Common$Conception$drawerSection = F2(
	function (titre, contenu) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('section-drawer')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(titre)
						])),
				contenu));
	});
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseAideProduit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.aide-produit', _List_Nil, 'Les périmètres d\'offre du catalogue bornent toujours les références concernées. Un produit n\'est jamais un participant : il n\'a ni compte, ni portail.');
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.aucun', _List_Nil, 'Aucun objet visé');
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseAucunAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.aucun-aide', _List_Nil, 'pour un pipe de campagne');
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseModuleNonSouscrit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.module-non-souscrit', _List_Nil, 'Module Produits non souscrit par cet espace');
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseNatureMarque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.nature-marque', _List_Nil, 'Une marque');
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseNatureMarqueAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.nature-marque-aide', _List_Nil, 'Une marque du catalogue.');
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseNatureProduit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.nature-produit', _List_Nil, 'Un produit');
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseNatureProduitAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.nature-produit-aide', _List_Nil, 'Une référence du catalogue.');
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseUneFiche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.une-fiche', _List_Nil, 'Une partie prenante');
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseUneFicheAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.une-fiche-aide', _List_Nil, 'Une personne, une organisation ou un groupe de l\'annuaire.');
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseVise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.vise', _List_Nil, 'Ce que le dossier concerne');
};
var $author$project$Components$Parametrage$PipeEtape1$Update$RoleRenommeDemande = {$: 24};
var $author$project$Components$Parametrage$PipeEtape1$Update$LibelleSaisi = F2(
	function (a, b) {
		return {$: 25, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape1$View$libellesParLangue = F4(
	function (i18n, nom, libelle, libelles) {
		return A3(
			$author$project$Components$Shared$LibellesParLangue$View$view,
			i18n,
			_List_Nil,
			{
				go: function (_v0) {
					return $elm$core$Maybe$Nothing;
				},
				Ba: $author$project$Referentiel$Langues$desLibelles,
				Bl: libelle,
				hg: $author$project$Components$Parametrage$PipeEtape1$Update$LibelleSaisi,
				pv: $author$project$Components$Parametrage$PipeEtape1$Model$idDuDrawer(nom),
				fm: function (code) {
					return A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Dict$get, code, libelles));
				}
			});
	});
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseRenommer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.renommer', _List_Nil, 'Renommer');
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseRoleAnglais = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.drawer.objet-vise.role-anglais',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Anglais : ' + p.Dj);
	});
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseRoleAnglaisVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.role-anglais-vide', _List_Nil, 'Anglais : à renseigner');
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseRoleLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.role-libelle', _List_Nil, 'Libellé du rôle');
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseRoleTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.role-texte', _List_Nil, 'Avec plusieurs types, il porte le nom de la nature. Vous pouvez le renommer.');
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseRoleTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.role-titre', _List_Nil, 'Le rôle de l\'objet visé');
};
var $author$project$Components$Parametrage$PipeEtape1$View$roleDeLObjetVise = F3(
	function (i18n, model, saisie) {
		var libelles = A2($author$project$Components$Parametrage$PipeEtape1$Model$libelleDuRole, model, saisie);
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape1DrawerObjetViseRoleTitre(i18n),
			function () {
				var _v0 = saisie.hL;
				if (!_v0.$) {
					var saisis = _v0.a;
					return _List_fromArray(
						[
							A4(
							$author$project$Components$Parametrage$PipeEtape1$View$libellesParLangue,
							i18n,
							'role-de-l-objet-vise',
							$author$project$I18n$Cles$pipeEtape1DrawerObjetViseRoleLibelle(i18n),
							saisis)
						]);
				} else {
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape1DrawerObjetViseRoleTexte(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('role-de-l-objet-vise')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('textes')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$strong,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$elm$core$Maybe$withDefault,
														'',
														A2($elm$core$Dict$get, 'fr', libelles)))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													function () {
														var _v1 = A2($elm$core$Dict$get, 'en', libelles);
														if (!_v1.$) {
															var anglais = _v1.a;
															return A2(
																$author$project$I18n$Cles$pipeEtape1DrawerObjetViseRoleAnglais,
																i18n,
																{Dj: anglais});
														} else {
															return $author$project$I18n$Cles$pipeEtape1DrawerObjetViseRoleAnglaisVide(i18n);
														}
													}())
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape1$Update$RoleRenommeDemande)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape1DrawerObjetViseRenommer(i18n))
										]))
								]))
						]);
				}
			}());
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$TousBascule = {$: 23};
var $author$project$Components$Parametrage$PipeEtape1$Update$TypeBascule = function (a) {
	return {$: 22, a: a};
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetVisePastilleArchive = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.pastille-archive', _List_Nil, 'archivé');
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseReferences = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.drawer.objet-vise.references',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fiches',
					$author$project$I18n$Traductions$Entier(p.zu))
				]),
			((!p.zu) || (p.zu === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.zu) + ' référence') : (A2($author$project$I18n$Nombre$formater, 0, p.zu) + ' références'));
	});
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseTypeDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.drawer.objet-vise.type-detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'archetype',
					$author$project$I18n$Traductions$Chaine(p.fA)),
					_Utils_Tuple2(
					'fiches',
					$author$project$I18n$Traductions$Entier(p.zu))
				]),
			((!p.zu) || (p.zu === 1)) ? (p.fA + (' · ' + (A2($author$project$I18n$Nombre$formater, 0, p.zu) + ' fiche'))) : (p.fA + (' · ' + (A2($author$project$I18n$Nombre$formater, 0, p.zu) + ' fiches'))));
	});
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseTypeDetailArchive = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.drawer.objet-vise.type-detail-archive',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'archetype',
					$author$project$I18n$Traductions$Chaine(p.fA))
				]),
			p.fA + ' · archivé');
	});
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseTypeDetailArchiveLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.drawer.objet-vise.type-detail-archive-le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'archetype',
					$author$project$I18n$Traductions$Chaine(p.fA)),
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			p.fA + (' · archivé depuis le ' + p.wv));
	});
var $author$project$Components$Parametrage$PipeEtape1$View$choixDeType = F5(
	function (i18n, saisie, typeArchive, archivesLe, option) {
		var estCoche = saisie.rL || A2($elm$core$List$member, option.vx, saisie.ib);
		var archive = _Utils_eq(
			typeArchive,
			$elm$core$Maybe$Just(option.vx));
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('choix'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('type'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('grise', saisie.rL)
						])),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-groupe', 'type-de-fiche')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
							$rtfeldman$elm_css$Html$Styled$Attributes$name('type-de-fiche'),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(estCoche),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(saisie.rL),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Parametrage$PipeEtape1$Update$TypeBascule(option.vx)),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(option.vx)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('textes')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(option.Bl)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									function () {
										if (archive) {
											var _v0 = A2($author$project$Components$Parametrage$PipeEtape1$Model$dateDArchivage, archivesLe, option.vx);
											if (!_v0.$) {
												var jour = _v0.a;
												return A2(
													$author$project$I18n$Cles$pipeEtape1DrawerObjetViseTypeDetailArchiveLe,
													i18n,
													{
														fA: A2($author$project$Components$Parametrage$PipeEtape1$View$libelleDeLArchetype, i18n, option.fA),
														wv: A2($author$project$Texte$Jour$enFrancais, i18n, jour)
													});
											} else {
												return A2(
													$author$project$I18n$Cles$pipeEtape1DrawerObjetViseTypeDetailArchive,
													i18n,
													{
														fA: A2($author$project$Components$Parametrage$PipeEtape1$View$libelleDeLArchetype, i18n, option.fA)
													});
											}
										} else {
											if (option.fA === '') {
												return A2(
													$author$project$I18n$Cles$pipeEtape1DrawerObjetViseReferences,
													i18n,
													{zu: option.oC});
											} else {
												return A2(
													$author$project$I18n$Cles$pipeEtape1DrawerObjetViseTypeDetail,
													i18n,
													{
														fA: A2($author$project$Components$Parametrage$PipeEtape1$View$libelleDeLArchetype, i18n, option.fA),
														zu: option.oC
													});
											}
										}
									}())
								]))
						])),
					((option.fA === '') && (!archive)) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('archive', archive)
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							archive ? $author$project$I18n$Cles$pipeEtape1DrawerObjetVisePastilleArchive(i18n) : A2($author$project$Components$Parametrage$PipeEtape1$View$libelleDeLArchetype, i18n, option.fA))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('etat'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('coche', estCoche)
								])),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-type', 'checkbox')
						]),
					_List_Nil)
				]));
	});
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseTous = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.tous', _List_Nil, 'Toutes les parties prenantes');
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseTousAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.tous-aide', _List_Nil, 'Un type créé plus tard en fait partie.');
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseTousProduits = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.tous-produits', _List_Nil, 'Tous les produits');
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseTousProduitsAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.tous-produits-aide', _List_Nil, 'Les types de produit créés plus tard en font partie.');
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseTousReprise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.tous-reprise', _List_Nil, 'Les types sont repris par « Tous ». Décochez « Tous » pour en choisir quelques-uns.');
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.type', _List_Nil, 'Quels types de fiche ?');
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseTypeProduit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.type-produit', _List_Nil, 'Quels types de produit ?');
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseTypeProduitTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.type-produit-texte', _List_Nil, 'Choisissez des typologies larges.');
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseTypeTexte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.drawer.objet-vise.type-texte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Plusieurs types à la fois, ou tous. Le rôle « ' + (p.bi + ' » est créé avec l\'objet visé.'));
	});
var $author$project$Components$Parametrage$PipeEtape1$View$sectionDesTypes = F4(
	function (i18n, model, saisie, types) {
		var produit = _Utils_eq(saisie.g1, $author$project$Components$Parametrage$Vocabulaire$natureProduit);
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			produit ? $author$project$I18n$Cles$pipeEtape1DrawerObjetViseTypeProduit(i18n) : $author$project$I18n$Cles$pipeEtape1DrawerObjetViseType(i18n),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							produit ? $author$project$I18n$Cles$pipeEtape1DrawerObjetViseTypeProduitTexte(i18n) : A2(
								$author$project$I18n$Cles$pipeEtape1DrawerObjetViseTypeTexte,
								i18n,
								{
									bi: A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Dict$get,
											'fr',
											A2($author$project$Components$Parametrage$PipeEtape1$Model$libelleDuRole, model, saisie)))
								}))
						])),
				A2(
					$elm$core$List$cons,
					A5(
						$author$project$Components$Parametrage$Common$Conception$caseACocher,
						'tous-les-types',
						saisie.rL,
						produit ? $author$project$I18n$Cles$pipeEtape1DrawerObjetViseTousProduits(i18n) : $author$project$I18n$Cles$pipeEtape1DrawerObjetViseTous(i18n),
						produit ? $author$project$I18n$Cles$pipeEtape1DrawerObjetViseTousProduitsAide(i18n) : $author$project$I18n$Cles$pipeEtape1DrawerObjetViseTousAide(i18n),
						function (_v0) {
							return $author$project$Components$Parametrage$PipeEtape1$Update$TousBascule;
						}),
					_Utils_ap(
						A2(
							$elm$core$List$map,
							A4($author$project$Components$Parametrage$PipeEtape1$View$choixDeType, i18n, saisie, model.rV, model.i0),
							types),
						(saisie.rL && produit) ? _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mini')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape1DrawerObjetViseTousReprise(i18n))
									]))
							]) : _List_Nil))));
	});
var $author$project$Components$Parametrage$PipeEtape1$View$contenuDeLObjetVise = F3(
	function (i18n, model, saisie) {
		var types = _Utils_eq(saisie.g1, $author$project$Components$Parametrage$Vocabulaire$natureProduit) ? A2($elm$core$Maybe$withDefault, _List_Nil, model.id) : model.ic;
		var produitsSouscrits = !_Utils_eq(model.id, $elm$core$Maybe$Nothing);
		var natureGrisee = F2(
			function (code, titre) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('choix'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('grise'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-groupe', 'nature-de-l-objet-vise'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-disabled', 'true')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
									$rtfeldman$elm_css$Html$Styled$Attributes$name('nature-de-l-objet-vise'),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true),
									$rtfeldman$elm_css$Html$Styled$Attributes$value(code)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('textes')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(titre)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape1DrawerObjetViseModuleNonSouscrit(i18n))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('etat'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-type', 'radio')
								]),
							_List_Nil)
						]));
			});
		var nature = F3(
			function (code, titre, aide) {
				return A6(
					$author$project$Components$Parametrage$Common$Conception$choix,
					'nature-de-l-objet-vise',
					code,
					_Utils_eq(saisie.g1, code),
					titre,
					aide,
					$author$project$Components$Parametrage$PipeEtape1$Update$NatureDeLObjetViseChoisie(code));
			});
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$author$project$Components$Parametrage$Common$Conception$drawerSection,
					$author$project$I18n$Cles$pipeEtape1DrawerObjetViseVise(i18n),
					_List_fromArray(
						[
							A3(
							nature,
							'partie-prenante',
							$author$project$I18n$Cles$pipeEtape1DrawerObjetViseUneFiche(i18n),
							$author$project$I18n$Cles$pipeEtape1DrawerObjetViseUneFicheAide(i18n)),
							produitsSouscrits ? A3(
							nature,
							$author$project$Components$Parametrage$Vocabulaire$natureProduit,
							$author$project$I18n$Cles$pipeEtape1DrawerObjetViseNatureProduit(i18n),
							$author$project$I18n$Cles$pipeEtape1DrawerObjetViseNatureProduitAide(i18n)) : A2(
							natureGrisee,
							$author$project$Components$Parametrage$Vocabulaire$natureProduit,
							$author$project$I18n$Cles$pipeEtape1DrawerObjetViseNatureProduit(i18n)),
							produitsSouscrits ? A3(
							nature,
							$author$project$Components$Parametrage$Vocabulaire$natureMarque,
							$author$project$I18n$Cles$pipeEtape1DrawerObjetViseNatureMarque(i18n),
							$author$project$I18n$Cles$pipeEtape1DrawerObjetViseNatureMarqueAide(i18n)) : A2(
							natureGrisee,
							$author$project$Components$Parametrage$Vocabulaire$natureMarque,
							$author$project$I18n$Cles$pipeEtape1DrawerObjetViseNatureMarque(i18n)),
							A3(
							nature,
							'aucun',
							$author$project$I18n$Cles$pipeEtape1DrawerObjetViseAucun(i18n),
							$author$project$I18n$Cles$pipeEtape1DrawerObjetViseAucunAide(i18n))
						]))
				]),
			_Utils_ap(
				((saisie.g1 === 'partie-prenante') || _Utils_eq(saisie.g1, $author$project$Components$Parametrage$Vocabulaire$natureProduit)) ? _List_fromArray(
					[
						A4($author$project$Components$Parametrage$PipeEtape1$View$sectionDesTypes, i18n, model, saisie, types)
					]) : _List_Nil,
				_Utils_ap(
					(saisie.g1 !== 'aucun') ? _List_fromArray(
						[
							A3($author$project$Components$Parametrage$PipeEtape1$View$roleDeLObjetVise, i18n, model, saisie)
						]) : _List_Nil,
					((saisie.g1 === 'partie-prenante') && (saisie.rL || ($elm$core$List$length(saisie.ib) > 1))) ? _List_fromArray(
						[
							$author$project$Components$Parametrage$PipeEtape1$View$aideDuDrawer(
							A3($author$project$Components$Parametrage$PipeEtape1$View$aideDesChampsCommuns, i18n, model, saisie))
						]) : (_Utils_eq(saisie.g1, $author$project$Components$Parametrage$Vocabulaire$natureProduit) ? _List_fromArray(
						[
							$author$project$Components$Parametrage$PipeEtape1$View$aideDuDrawer(
							$author$project$I18n$Cles$pipeEtape1DrawerObjetViseAideProduit(i18n))
						]) : _List_Nil))));
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$SourceAjoutee = {$: 27};
var $author$project$I18n$Cles$pipeEtape1DrawerCeQueCelaDonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.ce-que-cela-donne', _List_Nil, 'Ce que cela donne');
};
var $author$project$Components$Parametrage$PipeEtape1$View$pipeOuvert = function (edition) {
	return {vf: '', vx: edition.vx, xK: 0, gt: '', np: $elm$core$Maybe$Nothing, R: edition.R, nB: $elm$core$Maybe$Nothing, CW: edition.CW, Dt: edition.Dt, DE: edition.DE, F_: _List_Nil, IT: _List_Nil, r8: edition.r8, KE: $elm$core$Maybe$Nothing, KM: edition.KM};
};
var $author$project$Components$Parametrage$PipeEtape1$View$pipesCites = function (model) {
	var _v0 = model.ge;
	if (!_v0.$) {
		var edition = _v0.a;
		return A2(
			$elm$core$List$cons,
			$author$project$Components$Parametrage$PipeEtape1$View$pipeOuvert(edition),
			_Utils_ap(edition.y_.jj, edition.y_.qZ));
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Parametrage$PipeEtape1$View$ceQueCelaDonne = F3(
	function (i18n, model, phrase) {
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape1DrawerCeQueCelaDonne(i18n),
			A2(
				$elm$core$List$map,
				function (pipe) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(phrase, model, pipe))
							]));
				},
				$author$project$Components$Parametrage$PipeEtape1$View$pipesCites(model)));
	});
var $author$project$I18n$Cles$pipeEtape1ExempleEt = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.exemple.et',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'debut',
					$author$project$I18n$Traductions$Chaine(p.ku)),
					_Utils_Tuple2(
					'fin',
					$author$project$I18n$Traductions$Chaine(p.mI))
				]),
			p.ku + (' et ' + p.mI));
	});
var $author$project$Components$Parametrage$PipeEtape1$Phrases$enumeration = F2(
	function (i18n, liste) {
		var _v0 = $elm$core$List$reverse(liste);
		if (_v0.b && _v0.b.b) {
			var dernier = _v0.a;
			var _v1 = _v0.b;
			var avant = _v1.a;
			var debut = _v1.b;
			return A2(
				$author$project$I18n$Cles$pipeEtape1ExempleEt,
				i18n,
				{
					ku: A2(
						$elm$core$String$join,
						', ',
						$elm$core$List$reverse(
							A2($elm$core$List$cons, avant, debut))),
					mI: dernier
				});
		} else {
			return A2($elm$core$String$join, ', ', liste);
		}
	});
var $author$project$I18n$Cles$pipeEtape1ExempleGuillemets = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.exemple.guillemets',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'texte',
					$author$project$I18n$Traductions$Chaine(p.Jx))
				]),
			'« ' + (p.Jx + ' »'));
	});
var $author$project$Components$Parametrage$PipeEtape1$Phrases$guillemets = F2(
	function (i18n, texte) {
		return A2(
			$author$project$I18n$Cles$pipeEtape1ExempleGuillemets,
			i18n,
			{Jx: texte});
	});
var $author$project$I18n$Cles$pipeEtape1SourceNomDefini = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.source.nom-defini',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'article',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeArticle(p.i4))),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			function () {
				var _v0 = p.i4;
				switch (_v0) {
					case 0:
						return 'Le ' + p.Dj;
					case 1:
						return 'L\'' + p.Dj;
					case 2:
						return 'La ' + p.Dj;
					case 3:
						return 'Le ' + p.Dj;
					default:
						return 'Le ' + p.Dj;
				}
			}());
	});
var $author$project$Components$Parametrage$PipeEtape1$Phrases$leNom = F2(
	function (i18n, lue) {
		return A2(
			$author$project$I18n$Cles$pipeEtape1SourceNomDefini,
			i18n,
			{
				i4: function () {
					if (lue.av) {
						return 1;
					} else {
						var _v0 = lue.M;
						if (!_v0) {
							return 3;
						} else {
							return 2;
						}
					}
				}(),
				Dj: lue.IN
			});
	});
var $author$project$I18n$Cles$pipeEtape1ExempleBornesEntre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.exemple.bornes-entre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'minimum',
					$author$project$I18n$Traductions$Chaine(p.CD)),
					_Utils_Tuple2(
					'maximum',
					$author$project$I18n$Traductions$Chaine(p.Cj))
				]),
			'de ' + (p.CD + (' à ' + p.Cj)));
	});
var $author$project$I18n$Cles$pipeEtape1ExempleBornesSansMaximum = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.exemple.bornes-sans-maximum', _List_Nil, 'sans maximum');
};
var $author$project$I18n$Cles$pipeEtape1ExempleChoixAuMoins = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.exemple.choix-au-moins',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'personne',
					$author$project$I18n$Traductions$Chaine(p.Fd)),
					_Utils_Tuple2(
					'minimum',
					$author$project$I18n$Traductions$Chaine(p.CD)),
					_Utils_Tuple2(
					'nature',
					$author$project$I18n$Traductions$Chaine(p.g1)),
					_Utils_Tuple2(
					'elements',
					$author$project$I18n$Traductions$Chaine(p.aV))
				]),
			_Utils_ap(
				$elm$core$String$toLower(
					A2($elm$core$String$left, 1, p.Fd)),
				A2($elm$core$String$dropLeft, 1, p.Fd)) + (' choisit au moins ' + (p.CD + (' ' + (p.g1 + (' parmi ' + (p.aV + ' en ouvrant son dossier')))))));
	});
var $author$project$I18n$Cles$pipeEtape1ExempleChoixEntre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.exemple.choix-entre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'personne',
					$author$project$I18n$Traductions$Chaine(p.Fd)),
					_Utils_Tuple2(
					'minimum',
					$author$project$I18n$Traductions$Chaine(p.CD)),
					_Utils_Tuple2(
					'maximum',
					$author$project$I18n$Traductions$Chaine(p.Cj)),
					_Utils_Tuple2(
					'nature',
					$author$project$I18n$Traductions$Chaine(p.g1)),
					_Utils_Tuple2(
					'elements',
					$author$project$I18n$Traductions$Chaine(p.aV))
				]),
			_Utils_ap(
				$elm$core$String$toLower(
					A2($elm$core$String$left, 1, p.Fd)),
				A2($elm$core$String$dropLeft, 1, p.Fd)) + (' choisit de ' + (p.CD + (' à ' + (p.Cj + (' ' + (p.g1 + (' parmi ' + (p.aV + ' en ouvrant son dossier')))))))));
	});
var $author$project$I18n$Cles$pipeEtape1ExempleProduitsDes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.exemple.produits-des',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nature',
					$author$project$I18n$Traductions$Chaine(p.g1)),
					_Utils_Tuple2(
					'elements',
					$author$project$I18n$Traductions$Chaine(p.aV)),
					_Utils_Tuple2(
					'bornes',
					$author$project$I18n$Traductions$Chaine(p.us))
				]),
			'des produits des ' + (p.g1 + (' ' + (p.aV + (', ' + p.us)))));
	});
var $author$project$I18n$Cles$pipeEtape1SourcePersonneParDefaut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.source.personne-par-defaut', _List_Nil, 'La personne');
};
var $author$project$Components$Parametrage$PipeEtape1$Phrases$phraseDeLaSource = F3(
	function (i18n, role, source) {
		var _v0 = source.g1;
		if (_v0 === 'liste-d-offres') {
			var personne = A2(
				$elm$core$Maybe$withDefault,
				$author$project$I18n$Cles$pipeEtape1SourcePersonneParDefaut(i18n),
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$Parametrage$PipeEtape1$Phrases$leNom(i18n),
					A2($elm$core$Maybe$andThen, $author$project$Components$Parametrage$PipeEtape1$Phrases$forme, role)));
			var elements = A2(
				$author$project$Components$Parametrage$PipeEtape1$Phrases$enumeration,
				i18n,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.Bl;
					},
					source.aV));
			var _v1 = source.Cj;
			if (!_v1.$) {
				var maximum = _v1.a;
				return A2(
					$author$project$I18n$Cles$pipeEtape1ExempleChoixEntre,
					i18n,
					{
						aV: elements,
						Cj: $elm$core$String$fromInt(maximum),
						CD: $elm$core$String$fromInt(source.CD),
						g1: A2($author$project$Components$Parametrage$PipeEtape1$Phrases$nomDesElements, i18n, source),
						Fd: personne
					});
			} else {
				return A2(
					$author$project$I18n$Cles$pipeEtape1ExempleChoixAuMoins,
					i18n,
					{
						aV: elements,
						CD: $elm$core$String$fromInt(source.CD),
						g1: A2($author$project$Components$Parametrage$PipeEtape1$Phrases$nomDesElements, i18n, source),
						Fd: personne
					});
			}
		} else {
			return A2(
				$author$project$I18n$Cles$pipeEtape1ExempleProduitsDes,
				i18n,
				{
					us: function () {
						var _v2 = source.Cj;
						if (!_v2.$) {
							var maximum = _v2.a;
							return A2(
								$author$project$I18n$Cles$pipeEtape1ExempleBornesEntre,
								i18n,
								{
									Cj: $elm$core$String$fromInt(maximum),
									CD: $elm$core$String$fromInt(source.CD)
								});
						} else {
							return $author$project$I18n$Cles$pipeEtape1ExempleBornesSansMaximum(i18n);
						}
					}(),
					aV: A2(
						$author$project$Components$Parametrage$PipeEtape1$Phrases$enumeration,
						i18n,
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Bl;
								},
								$author$project$Components$Parametrage$PipeEtape1$Phrases$guillemets(i18n)),
							source.aV)),
					g1: A3(
						$author$project$Components$Parametrage$Vocabulaire$natureNom,
						i18n,
						source.g1,
						$elm$core$List$length(source.aV))
				});
		}
	});
var $author$project$I18n$Cles$pipeEtape1DrawerCeQueCelaDonneOffre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.drawer.ce-que-cela-donne.offre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'pipe',
					$author$project$I18n$Traductions$Chaine(p.Fs)),
					_Utils_Tuple2(
					'phrase',
					$author$project$I18n$Traductions$Chaine(p.Fp))
				]),
			p.Fs + (' : ' + (p.Fp + '.')));
	});
var $author$project$I18n$Cles$pipeEtape1DrawerCeQueCelaDonneSansOffre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.ce-que-cela-donne.sans-offre', _List_Nil, 'sans offre');
};
var $author$project$Components$Parametrage$PipeEtape1$Phrases$ceQueDonneLOffre = F4(
	function (i18n, intitule, role, sources) {
		var phrase = $elm$core$List$isEmpty(sources) ? $author$project$I18n$Cles$pipeEtape1DrawerCeQueCelaDonneSansOffre(i18n) : A2(
			$elm$core$String$join,
			' ; ',
			A2(
				$elm$core$List$map,
				A2($author$project$Components$Parametrage$PipeEtape1$Phrases$phraseDeLaSource, i18n, role),
				sources));
		return A2(
			$author$project$I18n$Cles$pipeEtape1DrawerCeQueCelaDonneOffre,
			i18n,
			{Fp: phrase, Fs: intitule});
	});
var $author$project$Components$Parametrage$PipeEtape1$View$resumees = function (pipe) {
	return A2(
		$elm$core$List$map,
		function (source) {
			return {
				aV: A2(
					$elm$core$List$map,
					function (libelle) {
						return {bB: $elm$core$Maybe$Nothing, Bl: libelle, r8: libelle};
					},
					source.aV),
				np: $elm$core$Maybe$Nothing,
				Cj: source.Cj,
				CD: source.CD,
				CM: $elm$core$Maybe$Nothing,
				g1: source.g1,
				Dm: $elm$core$Maybe$Nothing,
				eW: $elm$core$Maybe$Nothing,
				r8: source.r8
			};
		},
		pipe.IT);
};
var $author$project$Components$Parametrage$PipeEtape1$View$sourcesDuPipe = F2(
	function (model, pipe) {
		var _v0 = model.ge;
		if (!_v0.$) {
			var edition = _v0.a;
			return _Utils_eq(edition.vx, pipe.vx) ? edition.IT : $author$project$Components$Parametrage$PipeEtape1$View$resumees(pipe);
		} else {
			return $author$project$Components$Parametrage$PipeEtape1$View$resumees(pipe);
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$View$ceQueDonneLOffre = F3(
	function (i18n, model, pipe) {
		var sonEdition = A2(
			$elm$core$Maybe$andThen,
			function (edition) {
				return _Utils_eq(edition.vx, pipe.vx) ? $elm$core$Maybe$Just(edition) : $elm$core$Maybe$Nothing;
			},
			model.ge);
		return A4(
			$author$project$Components$Parametrage$PipeEtape1$Phrases$ceQueDonneLOffre,
			i18n,
			A2(
				$elm$core$Maybe$withDefault,
				$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(pipe.R),
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle,
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.AT;
						},
						sonEdition))),
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.D_;
					},
					function ($) {
						return $.qR;
					}),
				sonEdition),
			A2($author$project$Components$Parametrage$PipeEtape1$View$sourcesDuPipe, model, pipe));
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$SourceModifieeDemandee = function (a) {
	return {$: 28, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$Update$SourceRetiree = function (a) {
	return {$: 29, a: a};
};
var $author$project$I18n$Cles$pipeEtape1SourceBornes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.source.bornes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'minimum',
					$author$project$I18n$Traductions$Chaine(p.CD)),
					_Utils_Tuple2(
					'maximum',
					$author$project$I18n$Traductions$Chaine(p.Cj))
				]),
			'Minimum ' + (p.CD + (' · maximum ' + p.Cj)));
	});
var $author$project$I18n$Cles$pipeEtape1SourceBornesSansMaximum = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.source.bornes.sans-maximum',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'minimum',
					$author$project$I18n$Traductions$Chaine(p.CD))
				]),
			'Minimum ' + (p.CD + ' · sans maximum'));
	});
var $author$project$Components$Parametrage$PipeEtape1$View$bornes = F2(
	function (i18n, source) {
		var _v0 = source.Cj;
		if (!_v0.$) {
			var maximum = _v0.a;
			return A2(
				$author$project$I18n$Cles$pipeEtape1SourceBornes,
				i18n,
				{
					Cj: $elm$core$String$fromInt(maximum),
					CD: $elm$core$String$fromInt(source.CD)
				});
		} else {
			return A2(
				$author$project$I18n$Cles$pipeEtape1SourceBornesSansMaximum,
				i18n,
				{
					CD: $elm$core$String$fromInt(source.CD)
				});
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$View$bouton = F2(
	function (msg, libelle) {
		return A3(
			$author$project$Components$Shared$Bouton$View$bouton,
			1,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
				]),
			libelle);
	});
var $author$project$I18n$Cles$pipeEtape1NatureCategories = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.nature.categories', _List_Nil, 'Catégories');
};
var $author$project$I18n$Cles$pipeEtape1NatureListeDOffres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.nature.liste-d-offres', _List_Nil, 'Liste d\'offres');
};
var $author$project$I18n$Cles$pipeEtape1NaturePerimetres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.nature.perimetres', _List_Nil, 'Périmètres');
};
var $author$project$I18n$Cles$pipeEtape1NatureProduits = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.nature.produits', _List_Nil, 'Produits');
};
var $author$project$I18n$Cles$pipeEtape1NatureReferences = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.nature.references', _List_Nil, 'Références');
};
var $author$project$Components$Parametrage$Vocabulaire$nature = F2(
	function (i18n, code) {
		switch (code) {
			case 'liste-d-offres':
				return $author$project$I18n$Cles$pipeEtape1NatureListeDOffres(i18n);
			case 'perimetres':
				return $author$project$I18n$Cles$pipeEtape1NaturePerimetres(i18n);
			case 'categories':
				return $author$project$I18n$Cles$pipeEtape1NatureCategories(i18n);
			case 'produits':
				return $author$project$I18n$Cles$pipeEtape1NatureProduits(i18n);
			case 'references':
				return $author$project$I18n$Cles$pipeEtape1NatureReferences(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$I18n$Cles$pipeEtape1DrawerOffreModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.offre.modifier', _List_Nil, 'Modifier');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOffreRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.offre.retirer', _List_Nil, 'Retirer');
};
var $author$project$Components$Parametrage$PipeEtape1$View$ligneDeSourceDansLeDrawer = F2(
	function (i18n, source) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('source')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('textes')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Parametrage$PipeEtape1$Phrases$nomDeLaSource, i18n, source))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Parametrage$Vocabulaire$nature, i18n, source.g1) + (' · ' + A2($author$project$Components$Parametrage$PipeEtape1$View$bornes, i18n, source)))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					_Utils_ap(
						_List_fromArray(
							[
								A2(
								$author$project$Components$Parametrage$PipeEtape1$View$bouton,
								$author$project$Components$Parametrage$PipeEtape1$Update$SourceModifieeDemandee(source.r8),
								$author$project$I18n$Cles$pipeEtape1DrawerOffreModifier(i18n))
							]),
						_Utils_eq(source.eW, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
							[
								A2(
								$author$project$Components$Parametrage$PipeEtape1$View$bouton,
								$author$project$Components$Parametrage$PipeEtape1$Update$SourceRetiree(source.r8),
								$author$project$I18n$Cles$pipeEtape1DrawerOffreRetirer(i18n))
							])))
				]));
	});
var $author$project$I18n$Cles$pipeEtape1DrawerOffreSansOffre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.offre.sans-offre', _List_Nil, 'Un dossier sans offre');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOffreSources = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.offre.sources', _List_Nil, 'Les sources d\'offre');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOffreSourcesTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.offre.sources-texte', _List_Nil, 'Chaque source dit où l\'on choisit et combien. Ajoutez-en autant que nécessaire. Sans source, le dossier ne porte aucune offre.');
};
var $author$project$I18n$Cles$pipeEtape1OffreAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.offre.ajouter', _List_Nil, 'Ajouter : Source d\'offre');
};
var $author$project$Components$Parametrage$PipeEtape1$Update$ElementBascule = F2(
	function (a, b) {
		return {$: 31, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$MaximumSaisi = function (a) {
	return {$: 33, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$Update$MinimumSaisi = function (a) {
	return {$: 32, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$Update$NatureChoisie = function (a) {
	return {$: 30, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$View$elementsProposes = F2(
	function (model, source) {
		return _Utils_ap(
			model.jy,
			A2(
				$elm$core$List$filter,
				function (element) {
					return !A2(
						$elm$core$List$any,
						function (candidat) {
							return _Utils_eq(candidat.r8, element.r8);
						},
						model.jy);
				},
				source.aV));
	});
var $author$project$I18n$Cles$pipeEtape1NatureCategoriesAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.nature.categories.aide', _List_Nil, 'On prend les produits de catégories du catalogue.');
};
var $author$project$I18n$Cles$pipeEtape1NatureListeDOffresAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.nature.liste-d-offres.aide', _List_Nil, 'La personne choisit parmi une liste courte d\'offres, par exemple des collections.');
};
var $author$project$I18n$Cles$pipeEtape1NaturePerimetresAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.nature.perimetres.aide', _List_Nil, 'On prend les produits d\'un ou plusieurs périmètres d\'offre existants.');
};
var $author$project$I18n$Cles$pipeEtape1NatureProduitsAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.nature.produits.aide', _List_Nil, 'On désigne les produits un par un.');
};
var $author$project$I18n$Cles$pipeEtape1NatureReferencesAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.nature.references.aide', _List_Nil, 'On désigne des références précises.');
};
var $author$project$Components$Parametrage$Vocabulaire$natureAide = F2(
	function (i18n, code) {
		switch (code) {
			case 'liste-d-offres':
				return $author$project$I18n$Cles$pipeEtape1NatureListeDOffresAide(i18n);
			case 'perimetres':
				return $author$project$I18n$Cles$pipeEtape1NaturePerimetresAide(i18n);
			case 'categories':
				return $author$project$I18n$Cles$pipeEtape1NatureCategoriesAide(i18n);
			case 'produits':
				return $author$project$I18n$Cles$pipeEtape1NatureProduitsAide(i18n);
			case 'references':
				return $author$project$I18n$Cles$pipeEtape1NatureReferencesAide(i18n);
			default:
				return '';
		}
	});
var $author$project$I18n$Cles$pipeEtape1NatureChoixCategories = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.nature-choix.categories', _List_Nil, 'Des catégories');
};
var $author$project$I18n$Cles$pipeEtape1NatureChoixListeDOffres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.nature-choix.liste-d-offres', _List_Nil, 'Une liste d\'offres');
};
var $author$project$I18n$Cles$pipeEtape1NatureChoixPerimetres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.nature-choix.perimetres', _List_Nil, 'Un ou plusieurs périmètres');
};
var $author$project$I18n$Cles$pipeEtape1NatureChoixProduits = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.nature-choix.produits', _List_Nil, 'Des produits');
};
var $author$project$I18n$Cles$pipeEtape1NatureChoixReferences = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.nature-choix.references', _List_Nil, 'Des références');
};
var $author$project$Components$Parametrage$Vocabulaire$natureChoix = F2(
	function (i18n, code) {
		switch (code) {
			case 'liste-d-offres':
				return $author$project$I18n$Cles$pipeEtape1NatureChoixListeDOffres(i18n);
			case 'perimetres':
				return $author$project$I18n$Cles$pipeEtape1NatureChoixPerimetres(i18n);
			case 'categories':
				return $author$project$I18n$Cles$pipeEtape1NatureChoixCategories(i18n);
			case 'produits':
				return $author$project$I18n$Cles$pipeEtape1NatureChoixProduits(i18n);
			case 'references':
				return $author$project$I18n$Cles$pipeEtape1NatureChoixReferences(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$View$naturesPossibles = _List_fromArray(
	['liste-d-offres', 'perimetres', 'categories', 'produits', 'references']);
var $author$project$I18n$Cles$pipeEtape1DrawerOffreCombien = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.offre.combien', _List_Nil, 'Combien');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOffreCombienTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.offre.combien-texte', _List_Nil, 'Le nombre d\'éléments que la personne choisit dans cette source. Laissez le maximum vide pour ne pas le limiter.');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOffreElements = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.offre.elements', _List_Nil, 'Les éléments');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOffreElementsTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.offre.elements-texte', _List_Nil, 'Choisissez les éléments que la personne pourra choisir.');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOffreMaximum = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.offre.maximum', _List_Nil, 'Maximum');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOffreMinimum = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.offre.minimum', _List_Nil, 'Minimum');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOffreModifierLaSource = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.offre.modifier-la-source', _List_Nil, 'Modifier la source');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOffreNouvelleSource = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.offre.nouvelle-source', _List_Nil, 'Nouvelle source');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOffreOu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.offre.ou', _List_Nil, 'Où l\'on choisit');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOffreSansMaximum = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.offre.sans-maximum', _List_Nil, 'Sans maximum');
};
var $author$project$Components$Parametrage$PipeEtape1$View$reglageDeLaSource = F3(
	function (i18n, model, source) {
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				_Utils_eq(source.r8, $elm$core$Maybe$Nothing) ? $author$project$I18n$Cles$pipeEtape1DrawerOffreNouvelleSource(i18n) : $author$project$I18n$Cles$pipeEtape1DrawerOffreModifierLaSource(i18n),
				_List_Nil),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape1DrawerOffreOu(i18n),
				A2(
					$elm$core$List$map,
					function (nature) {
						return A6(
							$author$project$Components$Parametrage$Common$Conception$choix,
							'nature',
							nature,
							_Utils_eq(source.g1, nature),
							A2($author$project$Components$Parametrage$Vocabulaire$natureChoix, i18n, nature),
							A2($author$project$Components$Parametrage$Vocabulaire$natureAide, i18n, nature),
							$author$project$Components$Parametrage$PipeEtape1$Update$NatureChoisie(nature));
					},
					$author$project$Components$Parametrage$PipeEtape1$View$naturesPossibles)),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape1DrawerOffreElements(i18n),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape1DrawerOffreElementsTexte(i18n))
							])),
					A2(
						$elm$core$List$map,
						function (element) {
							return A5(
								$author$project$Components$Parametrage$Common$Conception$caseACocher,
								'element',
								A2(
									$elm$core$List$any,
									function (choisi) {
										return _Utils_eq(choisi.r8, element.r8);
									},
									source.aV),
								element.Bl,
								A2($elm$core$Maybe$withDefault, '', element.bB),
								$author$project$Components$Parametrage$PipeEtape1$Update$ElementBascule(element.r8));
						},
						A2($author$project$Components$Parametrage$PipeEtape1$View$elementsProposes, model, source)))),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape1DrawerOffreCombien(i18n),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape1DrawerOffreCombienTexte(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('champs')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$label,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('champ')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$pipeEtape1DrawerOffreMinimum(i18n))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$input,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
												$rtfeldman$elm_css$Html$Styled$Attributes$value(source.CD),
												$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Parametrage$PipeEtape1$Update$MinimumSaisi)
											]),
										_List_Nil)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$label,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('champ')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$pipeEtape1DrawerOffreMaximum(i18n))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$input,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
												$rtfeldman$elm_css$Html$Styled$Attributes$value(source.Cj),
												$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(
												$author$project$I18n$Cles$pipeEtape1DrawerOffreSansMaximum(i18n)),
												$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Parametrage$PipeEtape1$Update$MaximumSaisi)
											]),
										_List_Nil)
									]))
							]))
					]))
			]);
	});
var $author$project$I18n$Cles$pipeEtape1DrawerOffreSansOffreCas = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.drawer.offre.sans-offre-cas',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'pipes',
					$author$project$I18n$Traductions$Chaine(p.FM))
				]),
			'C\'est le cas de ' + (p.FM + '.'));
	});
var $author$project$I18n$Cles$pipeEtape1DrawerOffreSansOffreTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.offre.sans-offre-texte', _List_Nil, 'Un dossier sans offre reste possible : retirez toutes les sources.');
};
var $author$project$Components$Parametrage$PipeEtape1$View$sansOffre = F2(
	function (i18n, model) {
		var pipesSansOffre = A2(
			$elm$core$List$map,
			function (pipe) {
				return A2(
					$elm$core$Maybe$withDefault,
					A2(
						$author$project$Components$Parametrage$PipeEtape1$Phrases$guillemets,
						i18n,
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(pipe.R)),
					A2(
						$elm$core$Maybe$map,
						$author$project$Components$Parametrage$PipeEtape1$Phrases$avecArticleDefini(i18n),
						A2(
							$elm$core$Maybe$andThen,
							$author$project$Components$Parametrage$PipeEtape1$Phrases$forme,
							A2(
								$elm$core$Maybe$andThen,
								function (edition) {
									return _Utils_eq(edition.vx, pipe.vx) ? edition.Dr : $elm$core$Maybe$Nothing;
								},
								model.ge))));
			},
			A2(
				$elm$core$List$filter,
				function (pipe) {
					return $elm$core$List$isEmpty(
						A2($author$project$Components$Parametrage$PipeEtape1$View$sourcesDuPipe, model, pipe));
				},
				$author$project$Components$Parametrage$PipeEtape1$View$pipesCites(model)));
		return $elm$core$List$isEmpty(pipesSansOffre) ? $author$project$I18n$Cles$pipeEtape1DrawerOffreSansOffreTexte(i18n) : ($author$project$I18n$Cles$pipeEtape1DrawerOffreSansOffreTexte(i18n) + (' ' + A2(
			$author$project$I18n$Cles$pipeEtape1DrawerOffreSansOffreCas,
			i18n,
			{
				FM: A2($author$project$Components$Parametrage$PipeEtape1$Phrases$enumeration, i18n, pipesSansOffre)
			})));
	});
var $author$project$Components$Parametrage$PipeEtape1$View$contenuDeLOffre = F3(
	function (i18n, model, enSaisie) {
		var sources = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.IT;
				},
				model.ge));
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$author$project$Components$Parametrage$Common$Conception$drawerSection,
					$author$project$I18n$Cles$pipeEtape1DrawerOffreSources(i18n),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape1DrawerOffreSourcesTexte(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('sources')
								]),
							A2(
								$elm$core$List$map,
								$author$project$Components$Parametrage$PipeEtape1$View$ligneDeSourceDansLeDrawer(i18n),
								sources)),
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout'),
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape1$Update$SourceAjoutee)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape1OffreAjouter(i18n))
								]))
						]))
				]),
			_Utils_ap(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2($author$project$Components$Parametrage$PipeEtape1$View$reglageDeLaSource, i18n, model),
						enSaisie)),
				_List_fromArray(
					[
						A2(
						$author$project$Components$Parametrage$Common$Conception$drawerSection,
						$author$project$I18n$Cles$pipeEtape1DrawerOffreSansOffre(i18n),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$Components$Parametrage$PipeEtape1$View$sansOffre, i18n, model))
									]))
							])),
						A3(
						$author$project$Components$Parametrage$PipeEtape1$View$ceQueCelaDonne,
						i18n,
						model,
						$author$project$Components$Parametrage$PipeEtape1$View$ceQueDonneLOffre(i18n))
					])));
	});
var $author$project$Components$Parametrage$PipeEtape1$Model$Au = 4;
var $author$project$Components$Parametrage$PipeEtape1$Update$ChampChoisi = F2(
	function (a, b) {
		return {$: 36, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape1$Model$Du = 3;
var $author$project$Components$Parametrage$PipeEtape1$Model$Etape = 1;
var $author$project$Components$Parametrage$PipeEtape1$Update$EvenementBascule = F2(
	function (a, b) {
		return {$: 35, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape1$Model$JourDOuverture = 6;
var $author$project$Components$Parametrage$PipeEtape1$Model$JourDeFermeture = 8;
var $author$project$Components$Parametrage$PipeEtape1$Model$LaPeriode = 2;
var $author$project$Components$Parametrage$PipeEtape1$Model$MoisDOuverture = 7;
var $author$project$Components$Parametrage$PipeEtape1$Model$MoisDeFermeture = 9;
var $author$project$Components$Parametrage$PipeEtape1$Update$OuvreurBascule = F2(
	function (a, b) {
		return {$: 34, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$PageSuivanteDesOriginesDemandee = {$: 10};
var $author$project$Components$Parametrage$PipeEtape1$Model$ParPersonne = 10;
var $author$project$Components$Parametrage$PipeEtape1$Model$PipeDOrigine = 0;
var $author$project$Components$Parametrage$PipeEtape1$Model$Rythme = 5;
var $author$project$Components$Parametrage$PipeEtape1$View$ceQueCelaDonnePourLePipeOuvert = F3(
	function (i18n, model, phrase) {
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape1DrawerCeQueCelaDonne(i18n),
			function () {
				var _v0 = model.ge;
				if (!_v0.$) {
					var edition = _v0.a;
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										phrase,
										$author$project$Components$Parametrage$PipeEtape1$View$pipeOuvert(edition),
										edition))
								]))
						]);
				} else {
					return _List_Nil;
				}
			}());
	});
var $author$project$I18n$Cles$pipeEtape1ParPersonneSansLimitePhrase = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.par-personne.sans-limite.phrase', _List_Nil, 'sans limite de dossiers par personne');
};
var $author$project$I18n$Cles$pipeEtape1ParPersonneUnSeulOuvertALaFoisPhrase = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.par-personne.un-seul-ouvert-a-la-fois.phrase', _List_Nil, 'un seul dossier ouvert à la fois');
};
var $author$project$I18n$Cles$pipeEtape1ParPersonneUnSeulParPeriodePhrase = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.par-personne.un-seul-par-periode.phrase', _List_Nil, 'un seul dossier par période');
};
var $author$project$Components$Parametrage$Vocabulaire$parPersonnePhrase = F2(
	function (i18n, code) {
		switch (code) {
			case 'un-seul-par-periode':
				return $author$project$I18n$Cles$pipeEtape1ParPersonneUnSeulParPeriodePhrase(i18n);
			case 'un-seul-ouvert-a-la-fois':
				return $author$project$I18n$Cles$pipeEtape1ParPersonneUnSeulOuvertALaFoisPhrase(i18n);
			case 'sans-limite':
				return $author$project$I18n$Cles$pipeEtape1ParPersonneSansLimitePhrase(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$I18n$Cles$pipeEtape1QuiPersonneSurLePortailParPhrase = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.qui.personne-sur-le-portail.par-phrase', _List_Nil, 'par la personne sur le portail');
};
var $author$project$Components$Parametrage$Vocabulaire$quiParPhrase = F2(
	function (i18n, code) {
		if (code === 'personne-sur-le-portail') {
			return $author$project$I18n$Cles$pipeEtape1QuiPersonneSurLePortailParPhrase(i18n);
		} else {
			var autre = code;
			return A2($author$project$Components$Parametrage$Vocabulaire$quiPar, i18n, autre);
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$Phrases$ouverture = F2(
	function (i18n, lue) {
		return A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not),
				_List_fromArray(
					[
						A2(
						$elm$core$String$join,
						' et ',
						A2(
							$elm$core$List$map,
							$author$project$Components$Parametrage$Vocabulaire$quiParPhrase(i18n),
							lue.GK)),
						A2($author$project$Components$Parametrage$PipeEtape1$Phrases$periodeDansLaPhrase, i18n, lue.pi),
						A2($author$project$Components$Parametrage$Vocabulaire$parPersonnePhrase, i18n, lue.EU)
					])));
	});
var $author$project$I18n$Cles$pipeEtape1DrawerCeQueCelaDonnePipe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.drawer.ce-que-cela-donne.pipe',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'pipe',
					$author$project$I18n$Traductions$Chaine(p.Fs)),
					_Utils_Tuple2(
					'phrase',
					$author$project$I18n$Traductions$Chaine(p.Fp))
				]),
			p.Fs + (' : ' + p.Fp));
	});
var $author$project$Components$Parametrage$PipeEtape1$View$ceQueDonneLOuverture = F3(
	function (i18n, pipe, edition) {
		return A2(
			$author$project$I18n$Cles$pipeEtape1DrawerCeQueCelaDonnePipe,
			i18n,
			{
				Fp: A2($author$project$Components$Parametrage$PipeEtape1$Phrases$ouverture, i18n, edition.ew),
				Fs: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(pipe.R)
			});
	});
var $author$project$I18n$Cles$pipeEtape1EvenementChangementDeStatut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.evenement.changement-de-statut', _List_Nil, 'Changement de statut');
};
var $author$project$I18n$Cles$pipeEtape1EvenementFinDuDossierPrecedent = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.evenement.fin-du-dossier-precedent', _List_Nil, 'Fin du dossier précédent dans un enchaînement');
};
var $author$project$I18n$Cles$pipeEtape1EvenementImport = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.evenement.import', _List_Nil, 'Import');
};
var $author$project$Components$Parametrage$Vocabulaire$evenement = F2(
	function (i18n, code) {
		switch (code) {
			case 'fin-du-dossier-precedent':
				return $author$project$I18n$Cles$pipeEtape1EvenementFinDuDossierPrecedent(i18n);
			case 'changement-de-statut':
				return $author$project$I18n$Cles$pipeEtape1EvenementChangementDeStatut(i18n);
			case 'import':
				return $author$project$I18n$Cles$pipeEtape1EvenementImport(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$I18n$Cles$pipeEtape1EvenementChangementDeStatutAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.evenement.changement-de-statut.aide', _List_Nil, 'Le dossier s\'ouvre quand le statut d\'une fiche change.');
};
var $author$project$I18n$Cles$pipeEtape1EvenementFinDuDossierPrecedentAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.evenement.fin-du-dossier-precedent.aide', _List_Nil, 'Un dossier arrivé à une étape donnée ouvre ce dossier.');
};
var $author$project$I18n$Cles$pipeEtape1EvenementImportAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.evenement.import.aide', _List_Nil, 'Le dossier s\'ouvre pour chaque ligne d\'un import.');
};
var $author$project$Components$Parametrage$Vocabulaire$evenementAide = F2(
	function (i18n, code) {
		switch (code) {
			case 'fin-du-dossier-precedent':
				return $author$project$I18n$Cles$pipeEtape1EvenementFinDuDossierPrecedentAide(i18n);
			case 'changement-de-statut':
				return $author$project$I18n$Cles$pipeEtape1EvenementChangementDeStatutAide(i18n);
			case 'import':
				return $author$project$I18n$Cles$pipeEtape1EvenementImportAide(i18n);
			default:
				return '';
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$View$liste_ = F4(
	function (libelle, champ, valeur, choix_) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('champ')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$select,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onInput(
							$author$project$Components$Parametrage$PipeEtape1$Update$ChampChoisi(champ))
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$option,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(''),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(valeur === '')
								]),
							_List_Nil),
						A2(
							$elm$core$List$map,
							function (_v0) {
								var code = _v0.a;
								var texte = _v0.b;
								return A2(
									$rtfeldman$elm_css$Html$Styled$option,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(code),
											$rtfeldman$elm_css$Html$Styled$Attributes$selected(
											_Utils_eq(valeur, code))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(texte)
										]));
							},
							choix_)))
				]));
	});
var $author$project$I18n$Cles$pipeEtape1MoisChoixN = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.mois.choix.n', _List_Nil, 'mois n');
};
var $author$project$I18n$Cles$pipeEtape1MoisChoixNPlus1 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.mois.choix.n-plus-1', _List_Nil, 'mois n+1');
};
var $author$project$Components$Parametrage$Vocabulaire$moisAuChoix = F2(
	function (i18n, code) {
		switch (code) {
			case 'n':
				return $author$project$I18n$Cles$pipeEtape1MoisChoixN(i18n);
			case 'n+1':
				return $author$project$I18n$Cles$pipeEtape1MoisChoixNPlus1(i18n);
			case 'aucune':
				return $author$project$I18n$Cles$pipeEtape1MoisAucune(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$I18n$Cles$pipeEtape1ParPersonneSansLimite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.par-personne.sans-limite', _List_Nil, 'Sans limite');
};
var $author$project$I18n$Cles$pipeEtape1ParPersonneUnSeulOuvertALaFois = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.par-personne.un-seul-ouvert-a-la-fois', _List_Nil, 'Un seul ouvert à la fois');
};
var $author$project$I18n$Cles$pipeEtape1ParPersonneUnSeulParPeriode = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.par-personne.un-seul-par-periode', _List_Nil, 'Un seul par période');
};
var $author$project$Components$Parametrage$Vocabulaire$parPersonne = F2(
	function (i18n, code) {
		switch (code) {
			case 'un-seul-par-periode':
				return $author$project$I18n$Cles$pipeEtape1ParPersonneUnSeulParPeriode(i18n);
			case 'un-seul-ouvert-a-la-fois':
				return $author$project$I18n$Cles$pipeEtape1ParPersonneUnSeulOuvertALaFois(i18n);
			case 'sans-limite':
				return $author$project$I18n$Cles$pipeEtape1ParPersonneSansLimite(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$I18n$Cles$pipeEtape1ParPersonneSansLimiteAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.par-personne.sans-limite.aide', _List_Nil, 'Chaque personne peut ouvrir autant de dossiers qu\'elle le souhaite.');
};
var $author$project$I18n$Cles$pipeEtape1ParPersonneUnSeulOuvertALaFoisAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.par-personne.un-seul-ouvert-a-la-fois.aide', _List_Nil, 'Un nouveau dossier est possible quand le précédent est terminé.');
};
var $author$project$I18n$Cles$pipeEtape1ParPersonneUnSeulParPeriodeAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.par-personne.un-seul-par-periode.aide', _List_Nil, 'Chaque personne a au plus un dossier pour chaque période d\'ouverture.');
};
var $author$project$Components$Parametrage$Vocabulaire$parPersonneAide = F2(
	function (i18n, code) {
		switch (code) {
			case 'un-seul-par-periode':
				return $author$project$I18n$Cles$pipeEtape1ParPersonneUnSeulParPeriodeAide(i18n);
			case 'un-seul-ouvert-a-la-fois':
				return $author$project$I18n$Cles$pipeEtape1ParPersonneUnSeulOuvertALaFoisAide(i18n);
			case 'sans-limite':
				return $author$project$I18n$Cles$pipeEtape1ParPersonneSansLimiteAide(i18n);
			default:
				return '';
		}
	});
var $author$project$I18n$Cles$pipeEtape1PeriodeEntreDeuxDates = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.periode.entre-deux-dates', _List_Nil, 'Entre deux dates');
};
var $author$project$I18n$Cles$pipeEtape1PeriodeRecurrente = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.periode.recurrente', _List_Nil, 'Récurrente');
};
var $author$project$I18n$Cles$pipeEtape1PeriodeToujours = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.periode.toujours', _List_Nil, 'Toujours');
};
var $author$project$Components$Parametrage$Vocabulaire$periode = F2(
	function (i18n, code) {
		switch (code) {
			case 'toujours':
				return $author$project$I18n$Cles$pipeEtape1PeriodeToujours(i18n);
			case 'entre-deux-dates':
				return $author$project$I18n$Cles$pipeEtape1PeriodeEntreDeuxDates(i18n);
			case 'recurrente':
				return $author$project$I18n$Cles$pipeEtape1PeriodeRecurrente(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$I18n$Cles$pipeEtape1PeriodeEntreDeuxDatesAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.periode.entre-deux-dates.aide', _List_Nil, 'Une seule fenêtre, par exemple pour une campagne de commandes.');
};
var $author$project$I18n$Cles$pipeEtape1PeriodeRecurrenteAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.periode.recurrente.aide', _List_Nil, 'La fenêtre revient à intervalle régulier.');
};
var $author$project$I18n$Cles$pipeEtape1PeriodeToujoursAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.periode.toujours.aide', _List_Nil, 'Aucune limite de date.');
};
var $author$project$Components$Parametrage$Vocabulaire$periodeAide = F2(
	function (i18n, code) {
		switch (code) {
			case 'toujours':
				return $author$project$I18n$Cles$pipeEtape1PeriodeToujoursAide(i18n);
			case 'entre-deux-dates':
				return $author$project$I18n$Cles$pipeEtape1PeriodeEntreDeuxDatesAide(i18n);
			case 'recurrente':
				return $author$project$I18n$Cles$pipeEtape1PeriodeRecurrenteAide(i18n);
			default:
				return '';
		}
	});
var $author$project$I18n$Cles$pipeEtape1DrawerOuvertureAu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.ouverture.au', _List_Nil, 'Au');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOuvertureDateAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.ouverture.date-aide', _List_Nil, 'jj/mm/aaaa');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOuvertureDates = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.ouverture.dates', _List_Nil, 'Entre deux dates (si choisi)');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOuvertureDu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.ouverture.du', _List_Nil, 'Du');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOuvertureEtape = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.ouverture.etape', _List_Nil, 'À l\'étape');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOuvertureEvenement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.ouverture.evenement', _List_Nil, 'Événement déclencheur (si choisi)');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOuvertureFermeture = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.ouverture.fermeture', _List_Nil, 'Fermeture');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOuvertureJour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.ouverture.jour', _List_Nil, 'Jour');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOuvertureMois = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.ouverture.mois', _List_Nil, 'Mois');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOuvertureOuverture = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.ouverture.ouverture', _List_Nil, 'Ouverture');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOuvertureParPersonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.ouverture.par-personne', _List_Nil, 'Nombre de dossiers par personne');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOuverturePeriode = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.ouverture.periode', _List_Nil, 'Période d\'ouverture');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOuverturePeriodeAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.ouverture.periode-aide', _List_Nil, 'Pendant quelle période un dossier peut être ouvert.');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOuverturePipeDOrigine = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.ouverture.pipe-d-origine', _List_Nil, 'Pipe d\'origine (enchaînement)');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOuvertureQui = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.ouverture.qui', _List_Nil, 'Qui ouvre le dossier ?');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOuvertureQuiAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.ouverture.qui-aide', _List_Nil, 'Plusieurs choix possibles.');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOuvertureRecurrente = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.ouverture.recurrente', _List_Nil, 'Récurrente');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOuvertureRythme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.ouverture.rythme', _List_Nil, 'Rythme');
};
var $author$project$I18n$Cles$pipeEtape1QuiCalendrier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.qui.calendrier', _List_Nil, 'Automatiquement, selon un calendrier');
};
var $author$project$I18n$Cles$pipeEtape1QuiEvenement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.qui.evenement', _List_Nil, 'Automatiquement, sur un événement');
};
var $author$project$I18n$Cles$pipeEtape1QuiPersonneSurLePortail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.qui.personne-sur-le-portail', _List_Nil, 'La personne, sur le portail');
};
var $author$project$I18n$Cles$pipeEtape1QuiUtilisateur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.qui.utilisateur', _List_Nil, 'Un utilisateur du CRM');
};
var $author$project$Components$Parametrage$Vocabulaire$qui = F2(
	function (i18n, code) {
		switch (code) {
			case 'utilisateur':
				return $author$project$I18n$Cles$pipeEtape1QuiUtilisateur(i18n);
			case 'personne-sur-le-portail':
				return $author$project$I18n$Cles$pipeEtape1QuiPersonneSurLePortail(i18n);
			case 'calendrier':
				return $author$project$I18n$Cles$pipeEtape1QuiCalendrier(i18n);
			case 'evenement':
				return $author$project$I18n$Cles$pipeEtape1QuiEvenement(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$I18n$Cles$pipeEtape1QuiCalendrierAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.qui.calendrier.aide', _List_Nil, 'Le dossier s\'ouvre à date fixe, sans geste.');
};
var $author$project$I18n$Cles$pipeEtape1QuiEvenementAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.qui.evenement.aide', _List_Nil, 'Le dossier s\'ouvre quand un événement se produit.');
};
var $author$project$I18n$Cles$pipeEtape1QuiPersonneSurLePortailAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.qui.personne-sur-le-portail.aide', _List_Nil, 'La personne ouvre elle-même son dossier depuis le portail.');
};
var $author$project$I18n$Cles$pipeEtape1QuiUtilisateurAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.qui.utilisateur.aide', _List_Nil, 'Un gestionnaire crée le dossier depuis la liste des dossiers.');
};
var $author$project$Components$Parametrage$Vocabulaire$quiAide = F2(
	function (i18n, code) {
		switch (code) {
			case 'utilisateur':
				return $author$project$I18n$Cles$pipeEtape1QuiUtilisateurAide(i18n);
			case 'personne-sur-le-portail':
				return $author$project$I18n$Cles$pipeEtape1QuiPersonneSurLePortailAide(i18n);
			case 'calendrier':
				return $author$project$I18n$Cles$pipeEtape1QuiCalendrierAide(i18n);
			case 'evenement':
				return $author$project$I18n$Cles$pipeEtape1QuiEvenementAide(i18n);
			default:
				return '';
		}
	});
var $author$project$I18n$Cles$pipeEtape1RythmeMois = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.rythme.mois', _List_Nil, 'Chaque mois');
};
var $author$project$I18n$Cles$pipeEtape1RythmeSemaine = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.rythme.semaine', _List_Nil, 'Chaque semaine');
};
var $author$project$I18n$Cles$pipeEtape1RythmeTrimestre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.rythme.trimestre', _List_Nil, 'Chaque trimestre');
};
var $author$project$Components$Parametrage$Vocabulaire$rythme = F2(
	function (i18n, code) {
		switch (code) {
			case 'semaine':
				return $author$project$I18n$Cles$pipeEtape1RythmeSemaine(i18n);
			case 'mois':
				return $author$project$I18n$Cles$pipeEtape1RythmeMois(i18n);
			case 'trimestre':
				return $author$project$I18n$Cles$pipeEtape1RythmeTrimestre(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$View$saisieAvecAide = F4(
	function (libelle, aide, valeur, champ) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('champ')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
							$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(aide),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(valeur),
							$rtfeldman$elm_css$Html$Styled$Events$onInput(
							$author$project$Components$Parametrage$PipeEtape1$Update$ChampChoisi(champ))
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$Parametrage$PipeEtape1$View$saisieDeTexte = F3(
	function (libelle, valeur, champ) {
		return A4($author$project$Components$Parametrage$PipeEtape1$View$saisieAvecAide, libelle, '', valeur, champ);
	});
var $author$project$Components$Parametrage$PipeEtape1$View$contenuDeLOuverture = F3(
	function (i18n, model, saisie) {
		var options = model.o_;
		var liste = F2(
			function (choisir, defaut) {
				return A2(
					$elm$core$Maybe$withDefault,
					defaut,
					A2($elm$core$Maybe$map, choisir, options));
			});
		var origines = A2(
			liste,
			function ($) {
				return $.FN;
			},
			_List_Nil);
		var etapesDeLOrigine = A2(
			$elm$core$List$concatMap,
			function ($) {
				return $.yL;
			},
			A2(
				$elm$core$List$filter,
				function (origine) {
					return _Utils_eq(origine.vx, saisie.Fu);
				},
				origines));
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape1DrawerOuvertureQui(i18n),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape1DrawerOuvertureQuiAide(i18n))
							])),
					A2(
						$elm$core$List$map,
						function (code) {
							return A5(
								$author$project$Components$Parametrage$Common$Conception$caseACocher,
								'qui',
								A2($elm$core$List$member, code, saisie.GK),
								A2($author$project$Components$Parametrage$Vocabulaire$qui, i18n, code),
								A2($author$project$Components$Parametrage$Vocabulaire$quiAide, i18n, code),
								$author$project$Components$Parametrage$PipeEtape1$Update$OuvreurBascule(code));
						},
						A2(
							liste,
							function ($) {
								return $.GL;
							},
							saisie.GK)))),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape1DrawerOuvertureEvenement(i18n),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						function (code) {
							return A5(
								$author$project$Components$Parametrage$Common$Conception$caseACocher,
								'evenement',
								A2($elm$core$List$member, code, saisie.mk),
								A2($author$project$Components$Parametrage$Vocabulaire$evenement, i18n, code),
								A2($author$project$Components$Parametrage$Vocabulaire$evenementAide, i18n, code),
								$author$project$Components$Parametrage$PipeEtape1$Update$EvenementBascule(code));
						},
						A2(
							liste,
							function ($) {
								return $.yU;
							},
							saisie.mk)),
					_Utils_ap(
						_List_fromArray(
							[
								A4(
								$author$project$Components$Parametrage$PipeEtape1$View$liste_,
								$author$project$I18n$Cles$pipeEtape1DrawerOuverturePipeDOrigine(i18n),
								0,
								saisie.Fu,
								A2(
									$elm$core$List$map,
									function (origine) {
										return _Utils_Tuple2(origine.vx, origine.Bl);
									},
									origines))
							]),
						_Utils_ap(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (_v0) {
										return _List_fromArray(
											[
												A2(
												$author$project$Components$Parametrage$PipeEtape1$View$bouton,
												$author$project$Components$Parametrage$PipeEtape1$Update$PageSuivanteDesOriginesDemandee,
												$author$project$I18n$Cles$annuairePaginationSuivante(i18n))
											]);
									},
									A2(
										$elm$core$Maybe$andThen,
										function ($) {
											return $.I7;
										},
										options))),
							_List_fromArray(
								[
									A4(
									$author$project$Components$Parametrage$PipeEtape1$View$liste_,
									$author$project$I18n$Cles$pipeEtape1DrawerOuvertureEtape(i18n),
									1,
									saisie.me,
									A2(
										$elm$core$List$map,
										function (uneEtape) {
											return _Utils_Tuple2(uneEtape.r8, uneEtape.Bl);
										},
										etapesDeLOrigine))
								]))))),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape1DrawerOuverturePeriode(i18n),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape1DrawerOuverturePeriodeAide(i18n))
							])),
					A2(
						$elm$core$List$map,
						function (code) {
							return A6(
								$author$project$Components$Parametrage$Common$Conception$choix,
								'periode',
								code,
								_Utils_eq(saisie.pi, code),
								A2($author$project$Components$Parametrage$Vocabulaire$periode, i18n, code),
								A2($author$project$Components$Parametrage$Vocabulaire$periodeAide, i18n, code),
								A2($author$project$Components$Parametrage$PipeEtape1$Update$ChampChoisi, 2, code));
						},
						_List_fromArray(
							['toujours', 'entre-deux-dates', 'recurrente'])))),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape1DrawerOuvertureDates(i18n),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('champs')
							]),
						_List_fromArray(
							[
								A4(
								$author$project$Components$Parametrage$PipeEtape1$View$saisieAvecAide,
								$author$project$I18n$Cles$pipeEtape1DrawerOuvertureDu(i18n),
								$author$project$I18n$Cles$pipeEtape1DrawerOuvertureDateAide(i18n),
								saisie.cE,
								3),
								A4(
								$author$project$Components$Parametrage$PipeEtape1$View$saisieAvecAide,
								$author$project$I18n$Cles$pipeEtape1DrawerOuvertureAu(i18n),
								$author$project$I18n$Cles$pipeEtape1DrawerOuvertureDateAide(i18n),
								saisie.cm,
								4)
							]))
					])),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape1DrawerOuvertureRecurrente(i18n),
				_List_fromArray(
					[
						A4(
						$author$project$Components$Parametrage$PipeEtape1$View$liste_,
						$author$project$I18n$Cles$pipeEtape1DrawerOuvertureRythme(i18n),
						5,
						saisie.Ij,
						A2(
							$elm$core$List$map,
							function (code) {
								return _Utils_Tuple2(
									code,
									A2($author$project$Components$Parametrage$Vocabulaire$rythme, i18n, code));
							},
							A2(
								liste,
								function ($) {
									return $.Ik;
								},
								_List_fromArray(
									[saisie.Ij])))),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'group'),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-label',
								$author$project$I18n$Cles$pipeEtape1DrawerOuvertureOuverture(i18n))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('groupe')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape1DrawerOuvertureOuverture(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('champs')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Components$Parametrage$PipeEtape1$View$saisieDeTexte,
										$author$project$I18n$Cles$pipeEtape1DrawerOuvertureJour(i18n),
										saisie.A$,
										6),
										A4(
										$author$project$Components$Parametrage$PipeEtape1$View$liste_,
										$author$project$I18n$Cles$pipeEtape1DrawerOuvertureMois(i18n),
										7,
										saisie.CR,
										_List_fromArray(
											[
												_Utils_Tuple2(
												'n',
												A2($author$project$Components$Parametrage$Vocabulaire$moisAuChoix, i18n, 'n'))
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'group'),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-label',
								$author$project$I18n$Cles$pipeEtape1DrawerOuvertureFermeture(i18n))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('groupe')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape1DrawerOuvertureFermeture(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('champs')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Components$Parametrage$PipeEtape1$View$saisieDeTexte,
										$author$project$I18n$Cles$pipeEtape1DrawerOuvertureJour(i18n),
										saisie.A0,
										8),
										A4(
										$author$project$Components$Parametrage$PipeEtape1$View$liste_,
										$author$project$I18n$Cles$pipeEtape1DrawerOuvertureMois(i18n),
										9,
										saisie.oh,
										A2(
											$elm$core$List$map,
											function (code) {
												return _Utils_Tuple2(
													code,
													A2($author$project$Components$Parametrage$Vocabulaire$moisAuChoix, i18n, code));
											},
											A2(
												liste,
												function ($) {
													return $.oh;
												},
												_List_fromArray(
													[saisie.oh]))))
									]))
							]))
					])),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape1DrawerOuvertureParPersonne(i18n),
				A2(
					$elm$core$List$map,
					function (code) {
						return A6(
							$author$project$Components$Parametrage$Common$Conception$choix,
							'par-personne',
							code,
							_Utils_eq(saisie.EU, code),
							A2($author$project$Components$Parametrage$Vocabulaire$parPersonne, i18n, code),
							A2($author$project$Components$Parametrage$Vocabulaire$parPersonneAide, i18n, code),
							A2($author$project$Components$Parametrage$PipeEtape1$Update$ChampChoisi, 10, code));
					},
					A2(
						liste,
						function ($) {
							return $.EV;
						},
						_List_fromArray(
							[saisie.EU])))),
				A3(
				$author$project$Components$Parametrage$PipeEtape1$View$ceQueCelaDonnePourLePipeOuvert,
				i18n,
				model,
				$author$project$Components$Parametrage$PipeEtape1$View$ceQueDonneLOuverture(i18n))
			]);
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$FicheDeLOuvertureChoisie = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$Update$OuvreurChoisi = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$Update$PlafondSaisi = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$Update$PortailChoisi = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$Update$SansPlafondBascule = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Parametrage$PipeEtape1$Update$TypeCreeBascule = function (a) {
	return {$: 17, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Attributes$min = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('min');
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerAucunPortail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.drawer.aucun-portail', _List_Nil, 'Aucun portail pour l\'instant');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerAucunRole = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.drawer.aucun-role', _List_Nil, 'Aucun rôle externe choisi dans chaque dossier : ajoutez-en un à l\'étape 3.');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerCeQueFera = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.ouvertures-tiers.drawer.ce-que-fera',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'portail',
					$author$project$I18n$Traductions$Chaine(p.FY)),
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi)),
					_Utils_Tuple2(
					'types',
					$author$project$I18n$Traductions$Chaine(p.ib))
				]),
			'Sur le portail « ' + (p.FY + (' », la personne qui tient le rôle « ' + (p.bi + (' » ouvre un dossier en nommant la nouvelle fiche. La fiche ' + (p.ib + ' naît proposée : absente de l\'annuaire, des listes et des campagnes jusqu\'à validation.'))))));
	});
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerCeQueFeraTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.drawer.ce-que-fera-titre', _List_Nil, 'Ce que fera le dossier.');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerDoublons = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.drawer.doublons', _List_Nil, 'Les doublons possibles (code, EAN) ne sont jamais montrés à l\'ouvreur ; l\'équipe interne les voit à la validation.');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerExistante = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.drawer.existante', _List_Nil, 'Sur une fiche existante');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerExistanteAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.drawer.existante-aide', _List_Nil, 'L\'ouvreur choisit une fiche de son périmètre.');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerNouvelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.drawer.nouvelle', _List_Nil, 'En créant une nouvelle fiche');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerNouvelleAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.drawer.nouvelle-aide', _List_Nil, 'Le dossier crée la fiche visée. Ses valeurs restent dans la réponse jusqu\'à l\'acceptation si une validation est prévue ; sinon la fiche entre dès la création.');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerPlafond = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.drawer.plafond', _List_Nil, 'Fiches proposées en attente');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerPlafondAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.drawer.plafond-aide', _List_Nil, 'Au-delà, l\'ouvreur ne peut plus en proposer tant que l\'équipe n\'a pas validé les précédentes. 20 par défaut.');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerPlafondValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.drawer.plafond-valeur', _List_Nil, 'Nombre de fiches proposées non validées, par ouvreur');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerPortail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.drawer.portail', _List_Nil, 'Portail où le pipe est proposé');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerPortailAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.drawer.portail-aide', _List_Nil, 'Le bloc « Demande » de ce portail offre ce pipe aux personnes qui tiennent ce rôle.');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerQuiOuvre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.drawer.qui-ouvre', _List_Nil, 'Qui ouvre');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerRole = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.drawer.role', _List_Nil, 'Rôle de l\'ouvreur');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerRoleAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.drawer.role-aide', _List_Nil, 'L\'ouvreur est un rôle externe du pipe, choisi à chaque dossier.');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerSansPlafond = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.drawer.sans-plafond', _List_Nil, 'Sans plafond');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerSansPlafondAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.drawer.sans-plafond-aide', _List_Nil, 'L\'ouvreur peut proposer autant de fiches qu\'il veut.');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerSansValidation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.drawer.sans-validation', _List_Nil, 'La fiche resterait proposée. Ajoutez une tâche Validation à l\'étape 4 pour la publier. Non bloquant à la publication.');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerSansValidationTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.drawer.sans-validation-titre', _List_Nil, 'Aucune tâche de validation après la création.');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerSurQuelleFiche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.drawer.sur-quelle-fiche', _List_Nil, 'Sur quelle fiche ?');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerTypes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.drawer.types', _List_Nil, 'Types de la fiche créée');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerTypesAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.drawer.types-aide', _List_Nil, 'L\'ouvreur en choisit un s\'il y en a plusieurs.');
};
var $author$project$Components$Parametrage$PipeEtape1$View$contenuDeLOuvertureParUnTiers = F3(
	function (i18n, model, saisie) {
		var typesProposes = function () {
			var _v2 = model.ge;
			if (!_v2.$) {
				var edition = _v2.a;
				return _Utils_eq(edition.D_.g1, $author$project$Components$Parametrage$Vocabulaire$natureProduit) ? (edition.D_.rL ? A2(
					$elm$core$List$map,
					function (t) {
						return _Utils_Tuple2(t.vx, t.Bl);
					},
					A2($elm$core$Maybe$withDefault, _List_Nil, model.id)) : A2(
					$elm$core$List$map,
					function (t) {
						return _Utils_Tuple2(t.vx, t.Bl);
					},
					edition.D_.id)) : (edition.D_.rL ? A2(
					$elm$core$List$map,
					function (t) {
						return _Utils_Tuple2(t.vx, t.Bl);
					},
					model.ic) : A2(
					$elm$core$List$map,
					function (t) {
						return _Utils_Tuple2(t.vx, t.Bl);
					},
					edition.D_.ib));
			} else {
				return _List_Nil;
			}
		}();
		var options = A2(
			$elm$core$Maybe$withDefault,
			{F_: _List_Nil, eX: _List_Nil},
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Ei;
				},
				model.ge));
		var modification = !_Utils_eq(saisie.iN, $elm$core$Maybe$Nothing);
		var choixDeType_ = function (_v1) {
			var code = _v1.a;
			var libelle = _v1.b;
			return A2(
				$rtfeldman$elm_css$Html$Styled$label,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('choix'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('type'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-groupe', 'type-de-la-fiche-creee')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$input,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
								$rtfeldman$elm_css$Html$Styled$Attributes$name('type-de-la-fiche-creee'),
								$rtfeldman$elm_css$Html$Styled$Attributes$checked(
								A2($elm$core$List$member, code, saisie.ib)),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Parametrage$PipeEtape1$Update$TypeCreeBascule(code)),
								$rtfeldman$elm_css$Html$Styled$Attributes$value(code)
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('textes')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(libelle)
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('etat'),
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'coche',
										A2($elm$core$List$member, code, saisie.ib))
									])),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-type', 'checkbox')
							]),
						_List_Nil)
					]));
		};
		var aUneTacheDeValidation = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.sH;
				},
				model.ge));
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$author$project$Components$Parametrage$Common$Conception$drawerSection,
					$author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerQuiOuvre(i18n),
					_List_fromArray(
						[
							modification ? A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('identite')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											function (r) {
												return $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(r.R);
											},
											$elm$core$List$head(
												A2(
													$elm$core$List$filter,
													function (r) {
														return _Utils_eq(r.r8, saisie.H6);
													},
													options.eX)))))
								])) : ($elm$core$List$isEmpty(options.eX) ? A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aucun-role')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerAucunRole(i18n))
								])) : A4(
							$author$project$Components$Parametrage$Common$Conception$liste,
							$author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerRole(i18n),
							saisie.H6,
							A2(
								$elm$core$List$map,
								function (r) {
									return _Utils_Tuple2(
										r.r8,
										$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(r.R));
								},
								options.eX),
							$author$project$Components$Parametrage$PipeEtape1$Update$OuvreurChoisi)),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerRoleAide(i18n))
								])),
							modification ? A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('identite')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$elm$core$Maybe$withDefault,
										saisie.FY,
										A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.Bl;
											},
											$elm$core$List$head(
												A2(
													$elm$core$List$filter,
													function (p) {
														return _Utils_eq(p.vx, saisie.FY);
													},
													options.F_)))))
								])) : ($elm$core$List$isEmpty(options.F_) ? A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aucun-portail')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerAucunPortail(i18n))
								])) : A4(
							$author$project$Components$Parametrage$Common$Conception$liste,
							$author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerPortail(i18n),
							saisie.FY,
							A2(
								$elm$core$List$map,
								function (p) {
									return _Utils_Tuple2(p.vx, p.Bl);
								},
								options.F_),
							$author$project$Components$Parametrage$PipeEtape1$Update$PortailChoisi)),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerPortailAide(i18n))
								]))
						])),
					A2(
					$author$project$Components$Parametrage$Common$Conception$drawerSection,
					$author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerSurQuelleFiche(i18n),
					_List_fromArray(
						[
							A6(
							$author$project$Components$Parametrage$Common$Conception$choix,
							'fiche-de-l-ouverture',
							'existante',
							!saisie.oU,
							$author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerExistante(i18n),
							$author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerExistanteAide(i18n),
							$author$project$Components$Parametrage$PipeEtape1$Update$FicheDeLOuvertureChoisie(false)),
							A6(
							$author$project$Components$Parametrage$Common$Conception$choix,
							'fiche-de-l-ouverture',
							'nouvelle',
							saisie.oU,
							$author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerNouvelle(i18n),
							$author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerNouvelleAide(i18n),
							$author$project$Components$Parametrage$PipeEtape1$Update$FicheDeLOuvertureChoisie(true))
						]))
				]),
			saisie.oU ? _List_fromArray(
				[
					A2(
					$author$project$Components$Parametrage$Common$Conception$drawerSection,
					$author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerTypes(i18n),
					_Utils_ap(
						A2($elm$core$List$map, choixDeType_, typesProposes),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerTypesAide(i18n))
									]))
							]))),
					A2(
					$author$project$Components$Parametrage$Common$Conception$drawerSection,
					$author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerPlafond(i18n),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('champ'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('plafond')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerPlafondValeur(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$input,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('number'),
											$rtfeldman$elm_css$Html$Styled$Attributes$min('1'),
											$rtfeldman$elm_css$Html$Styled$Attributes$value(saisie.pm),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(saisie.e$),
											$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Parametrage$PipeEtape1$Update$PlafondSaisi)
										]),
									_List_Nil)
								])),
							A5(
							$author$project$Components$Parametrage$Common$Conception$caseACocher,
							'sans-plafond',
							saisie.e$,
							$author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerSansPlafond(i18n),
							$author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerSansPlafondAide(i18n),
							$author$project$Components$Parametrage$PipeEtape1$Update$SansPlafondBascule),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerPlafondAide(i18n))
								]))
						])),
					((saisie.H6 === '') || (saisie.FY === '')) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('encart-info'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ce-que-fera-le-dossier')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerCeQueFeraTitre(i18n))
										])),
									$rtfeldman$elm_css$Html$Styled$text(' '),
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerCeQueFera,
										i18n,
										{
											FY: A2(
												$elm$core$Maybe$withDefault,
												saisie.FY,
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.Bl;
													},
													$elm$core$List$head(
														A2(
															$elm$core$List$filter,
															function (p_) {
																return _Utils_eq(p_.vx, saisie.FY);
															},
															options.F_)))),
											bi: A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													function (r) {
														return $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(r.R);
													},
													$elm$core$List$head(
														A2(
															$elm$core$List$filter,
															function (r) {
																return _Utils_eq(r.r8, saisie.H6);
															},
															options.eX)))),
											ib: A2(
												$elm$core$String$join,
												', ',
												A2(
													$elm$core$List$map,
													$elm$core$Tuple$second,
													A2(
														$elm$core$List$filter,
														function (_v0) {
															var code = _v0.a;
															return A2($elm$core$List$member, code, saisie.ib);
														},
														typesProposes)))
										}))
								]))
						])),
					aUneTacheDeValidation ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
					$author$project$Components$Shared$Note$View$view,
					1,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerSansValidationTitre(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerSansValidation(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('encart-info'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('doublons')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerDoublons(i18n))
								]))
						]))
				]) : _List_Nil);
	});
var $author$project$Components$Parametrage$PipeEtape1$View$contexteDuLien = F2(
	function (model, saisie) {
		return {
			yY: _Utils_eq(saisie.n9, $author$project$Components$Parametrage$PipeEtape1$Lien$Creation) ? $elm$core$Maybe$Nothing : A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.yY;
				},
				model.ge),
			ej: function () {
				var _v0 = model.ge;
				if (!_v0.$) {
					var edition = _v0.a;
					return _Utils_eq(saisie.n9, $author$project$Components$Parametrage$PipeEtape1$Lien$Creation) ? $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(saisie.ej) : $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(edition.CW);
				} else {
					return $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(saisie.ej);
				}
			}()
		};
	});
var $author$project$Components$Parametrage$PipeEtape1$Update$PlurielSaisi = F2(
	function (a, b) {
		return {$: 26, a: a, b: b};
	});
var $author$project$I18n$Cles$pipeEtape1DrawerMotLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.mot.libelle', _List_Nil, 'Mot');
};
var $author$project$I18n$Cles$pipeEtape1DrawerMotPluriel = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.drawer.mot.pluriel',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'langue',
					$author$project$I18n$Traductions$Chaine(p.nn))
				]),
			'Pluriel (' + (p.nn + '), facultatif'));
	});
var $author$project$Components$Parametrage$PipeEtape1$View$motParLangue = F2(
	function (i18n, saisie) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('noms'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('l-un-sous-l-autre')
				]),
			A2(
				$elm$core$List$concatMap,
				function (langue) {
					var nom = $elm$core$String$toLower(
						A2($author$project$Referentiel$Langues$nom, i18n, langue.vx));
					return _List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Champ$View$texteAvecIndication,
							{
								go: $elm$core$Maybe$Nothing,
								Aq: A2(
									$author$project$Components$Shared$LibellesParLangue$View$idDuChamp,
									$author$project$Components$Parametrage$PipeEtape1$Model$idDuDrawer('mot'),
									langue.vx),
								Bl: A2(
									$author$project$I18n$Cles$saisieDeChampParLangue,
									i18n,
									{
										nn: nom,
										Bl: $author$project$I18n$Cles$pipeEtape1DrawerMotLibelle(i18n)
									}),
								he: langue.he
							},
							{
								na: $elm$core$Maybe$Nothing,
								hg: $author$project$Components$Parametrage$PipeEtape1$Update$LibelleSaisi(langue.vx),
								fm: A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Dict$get, langue.vx, saisie.IN))
							}),
							A2(
							$author$project$Components$Shared$Champ$View$texteAvecIndication,
							{
								go: $elm$core$Maybe$Nothing,
								Aq: A2(
									$author$project$Components$Shared$LibellesParLangue$View$idDuChamp,
									$author$project$Components$Parametrage$PipeEtape1$Model$idDuDrawer('mot-pluriel'),
									langue.vx),
								Bl: A2(
									$author$project$I18n$Cles$pipeEtape1DrawerMotPluriel,
									i18n,
									{nn: nom}),
								he: false
							},
							{
								na: $elm$core$Maybe$Nothing,
								hg: $author$project$Components$Parametrage$PipeEtape1$Update$PlurielSaisi(langue.vx),
								fm: A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Dict$get, langue.vx, saisie.bT))
							})
						]);
				},
				$author$project$Referentiel$Langues$desLibelles));
	});
var $author$project$I18n$Cles$pipeEtape1DrawerEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$pipeEtape1DrawerKicker = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.drawer.kicker',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'pipe',
					$author$project$I18n$Traductions$Chaine(p.Fs))
				]),
			'Étape 1 · ' + p.Fs);
	});
var $author$project$I18n$Cles$pipeEtape1DrawerMotTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.mot.titre', _List_Nil, 'Mot employé pour un dossier');
};
var $author$project$I18n$Cles$pipeEtape1DrawerNomLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.nom.libelle', _List_Nil, 'Nom');
};
var $author$project$I18n$Cles$pipeEtape1DrawerNomTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.nom.titre', _List_Nil, 'Nom du pipe et traduction');
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseKicker = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.kicker', _List_Nil, 'Étape 1 · Objet visé');
};
var $author$project$I18n$Cles$pipeEtape1DrawerObjetViseTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.objet-vise.titre', _List_Nil, 'Modifier l\'objet visé');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOffreTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.offre.titre', _List_Nil, 'Offre du dossier');
};
var $author$project$I18n$Cles$pipeEtape1DrawerOuvertureTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.drawer.ouverture.titre', _List_Nil, 'Comment s\'ouvre un dossier');
};
var $author$project$I18n$Cles$pipeEtape1LienKickerCreation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.kicker-creation', _List_Nil, 'Type de dossier');
};
var $author$project$I18n$Cles$pipeEtape1LienTitreCreation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.titre-creation', _List_Nil, 'Ajouter : Type de dossier');
};
var $author$project$I18n$Cles$pipeEtape1LienTitreModification = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.titre-modification', _List_Nil, 'Lien avec un autre pipe');
};
var $author$project$I18n$Cles$pipeEtape1LienValiderCreation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lien.valider-creation', _List_Nil, 'Ajouter');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.drawer.ajouter', _List_Nil, 'Ajouter');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerKicker = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.drawer.kicker', _List_Nil, 'Étape 1 · Un tiers peut ouvrir un dossier');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerTitreAjout = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.drawer.titre-ajout', _List_Nil, 'Ajouter une ouverture par un tiers');
};
var $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerTitreModification = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.ouvertures-tiers.drawer.titre-modification', _List_Nil, 'Modifier l\'ouverture par un tiers');
};
var $author$project$Components$Parametrage$PipeEtape1$View$typeArchiveChoisi = F2(
	function (model, saisie) {
		var _v0 = model.rV;
		if (!_v0.$) {
			var archive = _v0.a;
			return A2($elm$core$List$member, archive, saisie.ib);
		} else {
			return false;
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$View$valideLeLien = function (saisie) {
	return (!_Utils_eq(
		$author$project$Components$Parametrage$PipeEtape1$Lien$voulu(saisie),
		$elm$core$Maybe$Nothing)) && ((!_Utils_eq(saisie.n9, $author$project$Components$Parametrage$PipeEtape1$Lien$Creation)) || ((!_Utils_eq(
		$author$project$Components$Parametrage$PipeEtape1$Model$libellesVoulus(saisie.Dj),
		$elm$core$Maybe$Nothing)) && (!_Utils_eq(
		$author$project$Components$Parametrage$PipeEtape1$Model$libellesVoulus(saisie.ej),
		$elm$core$Maybe$Nothing))));
};
var $author$project$I18n$Cles$pipeParcoursRecharger = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-parcours.recharger', _List_Nil, 'Recharger');
};
var $author$project$Components$Parametrage$Common$RefusDuParcours$vue = F4(
	function (i18n, recharger, figee, refus) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('refus-du-parcours'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('figee', figee)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Messages$View$view,
					i18n,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Maybe$map, $elm$core$List$singleton, refus))),
					figee ? A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onClick(recharger)
						]),
					$author$project$I18n$Cles$pipeParcoursRecharger(i18n)) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)
				]));
	});
var $author$project$Components$Parametrage$PipeEtape1$View$contenuDuDrawer = F2(
	function (i18n, model) {
		var vide = {
			fs: {sR: false, Bl: '', C$: $author$project$Components$Parametrage$PipeEtape1$Update$EnregistrementDemande},
			fZ: _List_Nil,
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: ''
		};
		var refus = A4($author$project$Components$Parametrage$Common$RefusDuParcours$vue, i18n, $author$project$Components$Parametrage$PipeEtape1$Update$Recharger, model.sr, model.pZ);
		var kicker = A2(
			$elm$core$Maybe$map,
			function (edition) {
				return A2(
					$author$project$I18n$Cles$pipeEtape1DrawerKicker,
					i18n,
					{
						Fs: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(edition.R)
					});
			},
			model.ge);
		var enregistrer = function (valide) {
			return {
				sR: valide && ((!$author$project$API$Envoi$enCours(model.l2)) && (!model.sr)),
				Bl: $author$project$I18n$Cles$pipeEtape1DrawerEnregistrer(i18n),
				C$: $author$project$Components$Parametrage$PipeEtape1$Update$EnregistrementDemande
			};
		};
		var _v0 = _Utils_Tuple2(
			model.mW,
			$author$project$Components$Shared$Drawer$Model$estOuvert(model.kX));
		if ((!_v0.a.$) && _v0.b) {
			switch (_v0.a.a.$) {
				case 0:
					var libelles = _v0.a.a.a;
					return _Utils_update(
						vide,
						{
							fs: enregistrer(
								!_Utils_eq(
									$author$project$Components$Parametrage$PipeEtape1$Model$libellesVoulus(libelles),
									$elm$core$Maybe$Nothing)),
							fZ: _List_fromArray(
								[
									refus,
									A4(
									$author$project$Components$Parametrage$PipeEtape1$View$libellesParLangue,
									i18n,
									'nom',
									$author$project$I18n$Cles$pipeEtape1DrawerNomLibelle(i18n),
									libelles)
								]),
							A6: kicker,
							h6: $author$project$I18n$Cles$pipeEtape1DrawerNomTitre(i18n)
						});
				case 1:
					var saisie = _v0.a.a.a;
					return _Utils_update(
						vide,
						{
							fs: enregistrer(
								!_Utils_eq(
									$author$project$Components$Parametrage$PipeEtape1$Model$motVoulu(saisie),
									$elm$core$Maybe$Nothing)),
							fZ: _List_fromArray(
								[
									refus,
									A2($author$project$Components$Parametrage$PipeEtape1$View$motParLangue, i18n, saisie)
								]),
							A6: kicker,
							h6: $author$project$I18n$Cles$pipeEtape1DrawerMotTitre(i18n)
						});
				case 2:
					var enSaisie = _v0.a.a.a;
					return _Utils_update(
						vide,
						{
							fs: enregistrer(
								!_Utils_eq(
									$elm$core$Maybe$Nothing,
									A2($elm$core$Maybe$andThen, $author$project$Components$Parametrage$PipeEtape1$Model$sourceVoulue, enSaisie))),
							fZ: A2(
								$elm$core$List$cons,
								refus,
								A3($author$project$Components$Parametrage$PipeEtape1$View$contenuDeLOffre, i18n, model, enSaisie)),
							A6: kicker,
							Bc: true,
							h6: $author$project$I18n$Cles$pipeEtape1DrawerOffreTitre(i18n)
						});
				case 4:
					var saisie = _v0.a.a.a;
					return _Utils_update(
						vide,
						{
							fs: enregistrer(
								!A2($author$project$Components$Parametrage$PipeEtape1$View$typeArchiveChoisi, model, saisie)),
							fZ: A2(
								$elm$core$List$cons,
								refus,
								A3($author$project$Components$Parametrage$PipeEtape1$View$contenuDeLObjetVise, i18n, model, saisie)),
							A6: $elm$core$Maybe$Just(
								$author$project$I18n$Cles$pipeEtape1DrawerObjetViseKicker(i18n)),
							h6: $author$project$I18n$Cles$pipeEtape1DrawerObjetViseTitre(i18n)
						});
				case 6:
					var saisie = _v0.a.a.a;
					return _Utils_update(
						vide,
						{
							fs: {
								sR: $author$project$Components$Parametrage$PipeEtape1$View$valideLeLien(saisie) && (!$author$project$API$Envoi$enCours(model.l2)),
								Bl: _Utils_eq(saisie.n9, $author$project$Components$Parametrage$PipeEtape1$Lien$Creation) ? $author$project$I18n$Cles$pipeEtape1LienValiderCreation(i18n) : $author$project$I18n$Cles$pipeEtape1DrawerEnregistrer(i18n),
								C$: $author$project$Components$Parametrage$PipeEtape1$Update$EnregistrementDemande
							},
							fZ: A2(
								$elm$core$List$cons,
								refus,
								A4(
									$author$project$Components$Parametrage$PipeEtape1$LienView$contenu,
									i18n,
									A2($author$project$Components$Parametrage$PipeEtape1$View$contexteDuLien, model, saisie),
									model.o$,
									saisie)),
							A6: _Utils_eq(saisie.n9, $author$project$Components$Parametrage$PipeEtape1$Lien$Creation) ? $elm$core$Maybe$Just(
								$author$project$I18n$Cles$pipeEtape1LienKickerCreation(i18n)) : kicker,
							Bc: true,
							h6: _Utils_eq(saisie.n9, $author$project$Components$Parametrage$PipeEtape1$Lien$Creation) ? $author$project$I18n$Cles$pipeEtape1LienTitreCreation(i18n) : $author$project$I18n$Cles$pipeEtape1LienTitreModification(i18n)
						});
				case 5:
					var saisie = _v0.a.a.a;
					return _Utils_update(
						vide,
						{
							fs: {
								sR: (!_Utils_eq(
									$author$project$Components$Parametrage$PipeEtape1$Model$ouvertureParUnTiersVoulue(saisie),
									$elm$core$Maybe$Nothing)) && ((!$author$project$API$Envoi$enCours(model.l2)) && (!model.sr)),
								Bl: $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerAjouter(i18n),
								C$: $author$project$Components$Parametrage$PipeEtape1$Update$EnregistrementDemande
							},
							fZ: A2(
								$elm$core$List$cons,
								refus,
								A3($author$project$Components$Parametrage$PipeEtape1$View$contenuDeLOuvertureParUnTiers, i18n, model, saisie)),
							A6: $elm$core$Maybe$Just(
								$author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerKicker(i18n)),
							h6: _Utils_eq(saisie.iN, $elm$core$Maybe$Nothing) ? $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerTitreAjout(i18n) : $author$project$I18n$Cles$pipeEtape1OuverturesTiersDrawerTitreModification(i18n)
						});
				default:
					var saisie = _v0.a.a.a;
					return _Utils_update(
						vide,
						{
							fs: enregistrer(
								!_Utils_eq(
									$author$project$Components$Parametrage$PipeEtape1$Model$ouvertureVoulue(saisie),
									$elm$core$Maybe$Nothing)),
							fZ: A2(
								$elm$core$List$cons,
								refus,
								A3($author$project$Components$Parametrage$PipeEtape1$View$contenuDeLOuverture, i18n, model, saisie)),
							A6: kicker,
							Bc: true,
							h6: $author$project$I18n$Cles$pipeEtape1DrawerOuvertureTitre(i18n)
						});
			}
		} else {
			return vide;
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$View$drawer = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.mW, model.ge);
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Parametrage$PipeEtape1$Update$DuDrawer,
			A2($author$project$Components$Parametrage$PipeEtape1$View$contenuDuDrawer, i18n, model),
			model.kX);
	});
var $author$project$I18n$Cles$pipeEtape1Retour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.retour', _List_Nil, 'Retour aux pipes');
};
var $author$project$I18n$Cles$pipeEtape1Suivante = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.suivante', _List_Nil, 'Étape suivante');
};
var $author$project$Components$Parametrage$PipeEtape1$View$pied = F2(
	function (i18n, _v0) {
		return _List_fromArray(
			[
				A3(
				$author$project$Components$Shared$Bouton$View$lien,
				1,
				$author$project$Routes$Route$adressePipes,
				$author$project$I18n$Cles$pipeEtape1Retour(i18n)),
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				0,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
					]),
				$author$project$I18n$Cles$pipeEtape1Suivante(i18n))
			]);
	});
var $author$project$I18n$Cles$pipeEtape1BadgeBrouillon = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.badge.brouillon',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'numero',
					$author$project$I18n$Traductions$Chaine(p.DX))
				]),
			'Brouillon v' + p.DX);
	});
var $author$project$I18n$Cles$pipeEtape1BadgePublie = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.badge.publie',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'numero',
					$author$project$I18n$Traductions$Chaine(p.DX))
				]),
			'En ligne v' + p.DX);
	});
var $author$project$I18n$Cles$pipeEtape1LectureSeuleTag = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.lecture-seule.tag', _List_Nil, 'Lecture seule');
};
var $author$project$Components$Parametrage$PipeEtape1$View$tagDeLectureSeule = F2(
	function (i18n, edition) {
		return _Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$definirLObjetVise, edition.BN),
			$elm$core$Maybe$Nothing) ? _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Tag$View$view,
				3,
				$author$project$I18n$Cles$pipeEtape1LectureSeuleTag(i18n))
			]) : _List_Nil;
	});
var $author$project$Components$Parametrage$PipeEtape1$View$badges = F2(
	function (i18n, edition) {
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Components$Shared$Tag$View$view,
				3,
				(edition.ri === 'brouillon') ? A2(
					$author$project$I18n$Cles$pipeEtape1BadgeBrouillon,
					i18n,
					{
						DX: $elm$core$String$fromInt(edition.DX)
					}) : A2(
					$author$project$I18n$Cles$pipeEtape1BadgePublie,
					i18n,
					{
						DX: $elm$core$String$fromInt(edition.DX)
					})),
			A2($author$project$Components$Parametrage$PipeEtape1$View$tagDeLectureSeule, i18n, edition));
	});
var $author$project$Components$Parametrage$Common$Conception$adresseDe = F2(
	function (numero, code) {
		switch (numero) {
			case 1:
				return $author$project$Routes$Route$adressePipeEtape1(code);
			case 2:
				return $author$project$Routes$Route$adressePipeEtape2(code);
			case 3:
				return $author$project$Routes$Route$adressePipeEtape3(code);
			case 4:
				return $author$project$Routes$Route$adressePipeEtape4(code);
			case 5:
				return $author$project$Routes$Route$adressePipeEtape5(code);
			case 6:
				return $author$project$Routes$Route$adressePipeEtape6(code);
			case 7:
				return $author$project$Routes$Route$adressePipeEtape7(code);
			default:
				return $author$project$Routes$Route$adressePipeEtape8(code);
		}
	});
var $author$project$Components$Parametrage$Common$Conception$etapeOuvrable = function (numero) {
	return A2(
		$elm$core$List$member,
		numero,
		_List_fromArray(
			[1, 2, 3, 4, 5]));
};
var $author$project$I18n$Cles$pipeEtape1Etape2 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.etape.2', _List_Nil, 'Les étapes');
};
var $author$project$I18n$Cles$pipeEtape1Etape3 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.etape.3', _List_Nil, 'Les rôles dans le dossier');
};
var $author$project$I18n$Cles$pipeEtape1Etape4 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.etape.4', _List_Nil, 'Les tâches de chaque étape');
};
var $author$project$I18n$Cles$pipeEtape1Etape5 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.etape.5', _List_Nil, 'Les formulaires');
};
var $author$project$I18n$Cles$pipeEtape1Etape6 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.etape.6', _List_Nil, 'Qui voit quoi');
};
var $author$project$I18n$Cles$pipeEtape1Etape7 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.etape.7', _List_Nil, 'Les automatismes');
};
var $author$project$I18n$Cles$pipeEtape1Etape8 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.etape.8', _List_Nil, 'Vérifier et publier');
};
var $author$project$I18n$Cles$pipeEtape1Etapes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.etapes', _List_Nil, 'Étapes');
};
var $author$project$I18n$Cles$pipeEtape1Onglet = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.onglet',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'numero',
					$author$project$I18n$Traductions$Chaine(p.DX)),
					_Utils_Tuple2(
					'titre',
					$author$project$I18n$Traductions$Chaine(p.h6))
				]),
			p.DX + (' · ' + p.h6));
	});
var $author$project$Components$Parametrage$Common$Conception$onglets = F3(
	function (i18n, code, actuelle) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('tabs'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					$author$project$I18n$Cles$pipeEtape1Etapes(i18n))
				]),
			A3(
				$elm$core$List$map2,
				F2(
					function (numero, titre) {
						var nom = A2(
							$author$project$I18n$Cles$pipeEtape1Onglet,
							i18n,
							{
								DX: $elm$core$String$fromInt(numero),
								h6: titre
							});
						return _Utils_eq(numero, actuelle) ? A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href(
									A2($author$project$Components$Parametrage$Common$Conception$adresseDe, numero, code)),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('active'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-current', 'step')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(nom)
								])) : ($author$project$Components$Parametrage$Common$Conception$etapeOuvrable(numero) ? A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href(
									A2($author$project$Components$Parametrage$Common$Conception$adresseDe, numero, code))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(nom)
								])) : A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('bientot'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-disabled', 'true')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(nom)
								])));
					}),
				A2($elm$core$List$range, 1, 8),
				_List_fromArray(
					[
						$author$project$I18n$Cles$pipeEtape1Etape1(i18n),
						$author$project$I18n$Cles$pipeEtape1Etape2(i18n),
						$author$project$I18n$Cles$pipeEtape1Etape3(i18n),
						$author$project$I18n$Cles$pipeEtape1Etape4(i18n),
						$author$project$I18n$Cles$pipeEtape1Etape5(i18n),
						$author$project$I18n$Cles$pipeEtape1Etape6(i18n),
						$author$project$I18n$Cles$pipeEtape1Etape7(i18n),
						$author$project$I18n$Cles$pipeEtape1Etape8(i18n)
					])));
	});
var $author$project$I18n$Cles$pipeEtape1Introduction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.introduction', _List_Nil, 'Huit étapes, dans l\'ordre. À chacune, l\'aperçu de droite montre ce que votre réglage donne.');
};
var $author$project$I18n$Cles$pipeEtape1SousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etapes',
					$author$project$I18n$Traductions$Chaine(p.yL)),
					_Utils_Tuple2(
					'passages',
					$author$project$I18n$Traductions$Chaine(p.E5))
				]),
			'Concevoir un pipe · ' + (p.yL + (' · ' + p.E5)));
	});
var $author$project$I18n$Cles$pipeEtape1Titre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.titre', _List_Nil, 'Concevoir un pipe');
};
var $author$project$I18n$Cles$pipesEtapes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipes.etapes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etapes',
					$author$project$I18n$Traductions$Entier(p.yL))
				]),
			((!p.yL) || (p.yL === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.yL) + ' étape') : (A2($author$project$I18n$Nombre$formater, 0, p.yL) + ' étapes'));
	});
var $author$project$I18n$Cles$pipesPassages = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipes.passages',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'passages',
					$author$project$I18n$Traductions$Entier(p.E5))
				]),
			((!p.E5) || (p.E5 === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.E5) + ' passage') : (A2($author$project$I18n$Nombre$formater, 0, p.E5) + ' passages'));
	});
var $author$project$Components$Parametrage$PipeEtape1$View$top = F2(
	function (i18n, model) {
		var _v0 = model.ge;
		if (!_v0.$) {
			var edition = _v0.a;
			return A2(
				$author$project$Components$Shared$Page$View$enTete,
				i18n,
				{
					vS: _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('badges')
								]),
							A2($author$project$Components$Parametrage$PipeEtape1$View$badges, i18n, edition)),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$pipeEtape1SousTitre,
										i18n,
										{
											yL: A2(
												$author$project$I18n$Cles$pipesEtapes,
												i18n,
												{yL: edition.Dt}),
											E5: A2(
												$author$project$I18n$Cles$pipesPassages,
												i18n,
												{E5: edition.DE})
										}))
								]))
						]),
					zE: _List_fromArray(
						[
							{
							aa: $author$project$Routes$Route$adressePipes,
							Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
						},
							{
							aa: $author$project$Routes$Route$adressePipes,
							Dj: $author$project$I18n$Cles$pipesTitre(i18n)
						},
							{
							aa: '',
							Dj: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(edition.R)
						}
						]),
					Ef: _List_fromArray(
						[
							A3($author$project$Components$Parametrage$Common$Conception$onglets, i18n, edition.vx, 1)
						]),
					h6: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(edition.R)
				});
		} else {
			return A2(
				$author$project$Components$Shared$Page$View$enTete,
				i18n,
				{
					vS: _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape1Introduction(i18n))
								]))
						]),
					zE: _List_fromArray(
						[
							{
							aa: $author$project$Routes$Route$adressePipes,
							Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
						},
							{
							aa: $author$project$Routes$Route$adressePipes,
							Dj: $author$project$I18n$Cles$pipesTitre(i18n)
						}
						]),
					Ef: _List_Nil,
					h6: $author$project$I18n$Cles$pipeEtape1Titre(i18n)
				});
		}
	});
var $author$project$Components$Parametrage$PipeEtape1$View$view = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'parametrage-pipe-etape-1',
			{
				ut: A3($author$project$Components$Parametrage$PipeEtape1$View$corps, i18n, messages, model),
				xy: _List_fromArray(
					[
						A2($author$project$Components$Parametrage$PipeEtape1$View$drawer, i18n, model)
					]),
				zM: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$author$project$Components$Parametrage$PipeEtape1$View$pied(i18n),
						model.ge)),
				AK: $author$project$Components$Parametrage$PipeEtape1$View$dialogueOuvert(model),
				JD: A2($author$project$Components$Parametrage$PipeEtape1$View$top, i18n, model)
			});
	});
var $author$project$Components$Parametrage$Common$Conception$ajoutDUnType = F2(
	function (i18n, liens) {
		var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ajouterUnTypeDeDossier, liens);
		if (!_v0.$) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout-de-type'),
						$rtfeldman$elm_css$Html$Styled$Attributes$href(
						$author$project$Routes$Route$adressePipeEtape1(''))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$pipeEtape1LienAjouterType(i18n)),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape1LienAjouterTypeAide(i18n))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$Common$Conception$pipeDuBandeau = F5(
	function (i18n, nom, adresse, code, pipe) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pipe'),
					$rtfeldman$elm_css$Html$Styled$Attributes$href(
					adresse(pipe.vx)),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-pressed',
					_Utils_eq(pipe.vx, code) ? 'true' : 'false')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(
								nom(pipe)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('infos')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$pipesEtapes,
								i18n,
								{yL: pipe.Dt})),
							$rtfeldman$elm_css$Html$Styled$text(' · '),
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$pipesPassages,
								i18n,
								{E5: pipe.DE}))
						]))
				]));
	});
var $author$project$I18n$Cles$pipeEtape1Bandeau = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.bandeau', _List_Nil, 'Pipes du paramétrage');
};
var $author$project$I18n$Cles$pipeEtape1BandeauTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.bandeau.titre', _List_Nil, 'Pipe du paramétrage');
};
var $author$project$Components$Parametrage$Common$Conception$bandeauNomme = F6(
	function (i18n, nom, adresse, code, annuaire, ajout) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$nav,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('bandeau-des-pipes'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					$author$project$I18n$Cles$pipeEtape1Bandeau(i18n))
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape1BandeauTitre(i18n))
						])),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						A4($author$project$Components$Parametrage$Common$Conception$pipeDuBandeau, i18n, nom, adresse, code),
						A2($elm$core$Maybe$withDefault, _List_Nil, annuaire)),
					_List_fromArray(
						[ajout]))));
	});
var $author$project$Components$Parametrage$Common$Conception$bandeau = F5(
	function (i18n, adresse, code, annuaire, liens) {
		return A6(
			$author$project$Components$Parametrage$Common$Conception$bandeauNomme,
			i18n,
			function ($) {
				return $.R;
			},
			adresse,
			code,
			annuaire,
			A2($author$project$Components$Parametrage$Common$Conception$ajoutDUnType, i18n, liens));
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$EtapeAjoutDemandee = {$: 6};
var $author$project$Components$Parametrage$PipeEtape2$Update$PassageAjoutDemande = function (a) {
	return {$: 8, a: a};
};
var $author$project$I18n$Cles$pipeEtape2AjouterEtape = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.ajouter.etape', _List_Nil, 'Ajouter : Étape');
};
var $author$project$I18n$Cles$pipeEtape2AjouterPassage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.ajouter.passage', _List_Nil, 'Ajouter : Passage');
};
var $author$project$Components$Parametrage$PipeEtape2$View$premiereEtape = F2(
	function (_v0, parcours) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.r8;
				},
				$elm$core$List$head(parcours.yL)));
	});
var $author$project$Components$Parametrage$PipeEtape2$View$ajouts = F3(
	function (i18n, model, parcours) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ajouts')
				]),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function (_v0) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout'),
										$rtfeldman$elm_css$Html$Styled$Attributes$id(
										$author$project$Components$Parametrage$PipeEtape2$Model$idDuDeclencheur('etape-ajout')),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape2$Update$EtapeAjoutDemandee)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape2AjouterEtape(i18n))
									]));
						},
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ajouterUneEtape, parcours.nQ)),
						A2(
						$elm$core$Maybe$map,
						function (_v1) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout'),
										$rtfeldman$elm_css$Html$Styled$Attributes$id(
										$author$project$Components$Parametrage$PipeEtape2$Model$idDuDeclencheur('passage-ajout')),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Parametrage$PipeEtape2$Update$PassageAjoutDemande(
											A2($author$project$Components$Parametrage$PipeEtape2$View$premiereEtape, model, parcours)))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape2AjouterPassage(i18n))
									]));
						},
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ajouterUnPassage, parcours.nQ))
					])));
	});
var $author$project$I18n$Cles$pipeEtape2LiaisonEt = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.liaison.et', _List_Nil, 'et');
};
var $author$project$I18n$Cles$pipeEtape2LiaisonOu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.liaison.ou', _List_Nil, 'ou');
};
var $author$project$Components$Parametrage$PipeEtape2$Phrases$liaison = F2(
	function (i18n, lue) {
		if (lue === 1) {
			return $author$project$I18n$Cles$pipeEtape2LiaisonOu(i18n);
		} else {
			return $author$project$I18n$Cles$pipeEtape2LiaisonEt(i18n);
		}
	});
var $author$project$I18n$Cles$pipeEtape2ConditionSi = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.condition.si',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'condition',
					$author$project$I18n$Traductions$Chaine(p.j4))
				]),
			'Si ' + p.j4);
	});
var $author$project$I18n$Cles$pipeEtape2ConditionSinon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.condition.sinon', _List_Nil, 'Sinon (passage par défaut)');
};
var $author$project$I18n$Cles$pipeEtape2ConditionToujours = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.condition.toujours', _List_Nil, 'Dès que l\'étape est terminée');
};
var $author$project$I18n$Cles$pipeEtape2ComparaisonAuMoins = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.comparaison.au-moins', _List_Nil, 'est au moins');
};
var $author$project$I18n$Cles$pipeEtape2ComparaisonAuPlus = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.comparaison.au-plus', _List_Nil, 'est au plus');
};
var $author$project$I18n$Cles$pipeEtape2ComparaisonDifferentDe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.comparaison.different-de', _List_Nil, 'est différent de');
};
var $author$project$I18n$Cles$pipeEtape2ComparaisonEgalA = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.comparaison.egal-a', _List_Nil, 'est égal à');
};
var $author$project$I18n$Cles$pipeEtape2ComparaisonNonRenseigne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.comparaison.non-renseigne', _List_Nil, 'n\'est pas renseigné');
};
var $author$project$I18n$Cles$pipeEtape2ComparaisonRenseigne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.comparaison.renseigne', _List_Nil, 'est renseigné');
};
var $author$project$Components$Parametrage$Vocabulaire$comparaison = F2(
	function (i18n, code) {
		switch (code) {
			case 'au-moins':
				return $author$project$I18n$Cles$pipeEtape2ComparaisonAuMoins(i18n);
			case 'au-plus':
				return $author$project$I18n$Cles$pipeEtape2ComparaisonAuPlus(i18n);
			case 'egal-a':
				return $author$project$I18n$Cles$pipeEtape2ComparaisonEgalA(i18n);
			case 'different-de':
				return $author$project$I18n$Cles$pipeEtape2ComparaisonDifferentDe(i18n);
			case 'renseigne':
				return $author$project$I18n$Cles$pipeEtape2ComparaisonRenseigne(i18n);
			case 'non-renseigne':
				return $author$project$I18n$Cles$pipeEtape2ComparaisonNonRenseigne(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$Components$Parametrage$PipeEtape2$Phrases$libelleDeLaValeur = F2(
	function (options, lu) {
		var _v0 = lu.wg;
		if (_v0.$ === 1) {
			return lu.fm;
		} else {
			var correspondance = _v0.a;
			return A2(
				$elm$core$Maybe$withDefault,
				lu.fm,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Bl;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (v) {
								return _Utils_eq(v.Aq, lu.fm);
							},
							A2(
								$elm$core$List$concatMap,
								function ($) {
									return $.Ki;
								},
								A2(
									$elm$core$List$filter,
									function (c) {
										return _Utils_eq(c.Aq, correspondance);
									},
									A2(
										$elm$core$List$concatMap,
										function ($) {
											return $.wh;
										},
										options.Ja)))))));
		}
	});
var $author$project$Components$Parametrage$PipeEtape2$Phrases$lowerFirst = function (texte) {
	return function (tete) {
		return _Utils_ap(
			tete,
			A2($elm$core$String$dropLeft, 1, texte));
	}(
		$elm$core$String$toLower(
			A2($elm$core$String$left, 1, texte)));
};
var $author$project$I18n$Cles$pipeEtape2Terme = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.terme',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'sujet',
					$author$project$I18n$Traductions$Chaine(p.I9)),
					_Utils_Tuple2(
					'comparaison',
					$author$project$I18n$Traductions$Chaine(p.vP)),
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			p.I9 + (' ' + (p.vP + (' ' + p.fm))));
	});
var $author$project$Components$Parametrage$PipeEtape2$Phrases$sujet = F2(
	function (options, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			code,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (lu) {
							return _Utils_eq(lu.vx, code);
						},
						options.Ja))));
	});
var $author$project$Components$Parametrage$PipeEtape2$Phrases$terme = F3(
	function (i18n, options, lu) {
		return $elm$core$String$trim(
			A2(
				$author$project$I18n$Cles$pipeEtape2Terme,
				i18n,
				{
					vP: A2($author$project$Components$Parametrage$Vocabulaire$comparaison, i18n, lu.vP),
					I9: $author$project$Components$Parametrage$PipeEtape2$Phrases$lowerFirst(
						A2($author$project$Components$Parametrage$PipeEtape2$Phrases$sujet, options, lu.I9)),
					fm: A2($author$project$Components$Parametrage$PipeEtape2$Phrases$libelleDeLaValeur, options, lu)
				}));
	});
var $author$project$Components$Parametrage$PipeEtape2$Phrases$condition = F3(
	function (i18n, options, lue) {
		var _v0 = lue.n9;
		switch (_v0) {
			case 0:
				return $author$project$I18n$Cles$pipeEtape2ConditionToujours(i18n);
			case 2:
				return $author$project$I18n$Cles$pipeEtape2ConditionSinon(i18n);
			default:
				return A2(
					$author$project$I18n$Cles$pipeEtape2ConditionSi,
					i18n,
					{
						j4: A2(
							$elm$core$String$join,
							' ' + (A2($author$project$Components$Parametrage$PipeEtape2$Phrases$liaison, i18n, lue.Bk) + ' '),
							A2(
								$elm$core$List$map,
								A2($author$project$Components$Parametrage$PipeEtape2$Phrases$terme, i18n, options),
								lue.rD))
					});
		}
	});
var $author$project$I18n$Cles$pipeEtape2PassageRetour = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.passage.retour',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			p.Bl + ' (retour)');
	});
var $author$project$Components$Parametrage$PipeEtape2$Phrases$libelleDuPassage = F3(
	function (i18n, options, passage) {
		var nom = function () {
			var _v0 = A2($elm$core$Dict$get, 'fr', passage.Bl);
			if (!_v0.$) {
				var texte = _v0.a;
				return (texte === '') ? A3($author$project$Components$Parametrage$PipeEtape2$Phrases$condition, i18n, options, passage.j4) : texte;
			} else {
				return A3($author$project$Components$Parametrage$PipeEtape2$Phrases$condition, i18n, options, passage.j4);
			}
		}();
		if (passage.IC === 2) {
			var avecMention = A2(
				$author$project$I18n$Cles$pipeEtape2PassageRetour,
				i18n,
				{Bl: nom});
			return A2(
				$elm$core$String$endsWith,
				A2(
					$elm$core$String$dropLeft,
					$elm$core$String$length(nom),
					avecMention),
				nom) ? nom : avecMention;
		} else {
			return nom;
		}
	});
var $author$project$I18n$Cles$pipeEtape2ApercuAToutMoment = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.apercu.a-tout-moment',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etape',
					$author$project$I18n$Traductions$Chaine(p.me))
				]),
			'À tout moment avant ' + p.me);
	});
var $author$project$I18n$Cles$pipeEtape2ApercuChainon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.apercu.chainon', _List_Nil, ' › ');
};
var $author$project$I18n$Cles$pipeEtape2ApercuLaterale = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.apercu.laterale',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'origine',
					$author$project$I18n$Traductions$Chaine(p.o4)),
					_Utils_Tuple2(
					'condition',
					$author$project$I18n$Traductions$Chaine(p.j4)),
					_Utils_Tuple2(
					'laterale',
					$author$project$I18n$Traductions$Chaine(p.no))
				]),
			p.o4 + (' : ' + (p.j4 + (', ' + (p.no + '.')))));
	});
var $author$project$I18n$Cles$pipeEtape2ApercuLateraleRetour = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.apercu.laterale-retour',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'laterale',
					$author$project$I18n$Traductions$Chaine(p.no)),
					_Utils_Tuple2(
					'vers',
					$author$project$I18n$Traductions$Chaine(p.sn))
				]),
			p.no + (' : retour à ' + (p.sn + '.')));
	});
var $author$project$I18n$Cles$pipeEtape2ApercuPassage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.apercu.passage',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl)),
					_Utils_Tuple2(
					'vers',
					$author$project$I18n$Traductions$Chaine(p.sn))
				]),
			p.Bl + (' : ' + p.sn));
	});
var $author$project$I18n$Cles$pipeEtape2ApercuSinon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.apercu.sinon', _List_Nil, 'Sinon');
};
var $author$project$Components$Parametrage$PipeEtape2$Phrases$upperFirst = function (texte) {
	return function (tete) {
		return _Utils_ap(
			tete,
			A2($elm$core$String$dropLeft, 1, texte));
	}(
		$elm$core$String$toUpper(
			A2($elm$core$String$left, 1, texte)));
};
var $author$project$Components$Parametrage$PipeEtape2$Phrases$apercuGroupe = F3(
	function (i18n, options, parcours) {
		var unRetour = function (uid) {
			return A2(
				$elm$core$List$any,
				function (passage) {
					return _Utils_eq(passage.wC, uid) && (passage.IC === 2);
				},
				parcours.E5);
		};
		var sorties = A2(
			$elm$core$List$filter,
			function (passage) {
				return passage.IC !== 2;
			},
			parcours.E5);
		var nom = function (uid) {
			return A2(
				$elm$core$Maybe$withDefault,
				uid,
				A2(
					$elm$core$Maybe$map,
					function (etape) {
						return $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(etape.R);
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (etape) {
								return _Utils_eq(etape.r8, uid);
							},
							parcours.yL))));
		};
		var libelleDeLigne = function (passage) {
			var nomDuPassage = A3($author$project$Components$Parametrage$PipeEtape2$Phrases$libelleDuPassage, i18n, options, passage);
			return (passage.j4.n9 === 2) ? $author$project$I18n$Cles$pipeEtape2ApercuSinon(i18n) : (((!passage.j4.n9) && A2($elm$core$String$startsWith, 'Si ', nomDuPassage)) ? $author$project$Components$Parametrage$PipeEtape2$Phrases$upperFirst(
				A2($elm$core$String$dropLeft, 3, nomDuPassage)) : nomDuPassage);
		};
		var ligne = function (passage) {
			return {
				dX: false,
				eW: 1,
				Jx: A2(
					$author$project$I18n$Cles$pipeEtape2ApercuPassage,
					i18n,
					{
						Bl: libelleDeLigne(passage),
						sn: nom(passage.sn)
					})
			};
		};
		var fort = function (texte) {
			return {dX: true, eW: 0, Jx: texte};
		};
		var conditionDeLaterale = function (passage) {
			return ((passage.j4.n9 === 2) && (A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Dict$get, 'fr', passage.Bl)) === '')) ? $author$project$Components$Parametrage$PipeEtape2$Phrases$lowerFirst(
				$author$project$I18n$Cles$pipeEtape2ApercuSinon(i18n)) : $author$project$Components$Parametrage$PipeEtape2$Phrases$lowerFirst(
				A3($author$project$Components$Parametrage$PipeEtape2$Phrases$libelleDuPassage, i18n, options, passage));
		};
		var cle = function (passage) {
			return _Utils_Tuple2(
				A3($author$project$Components$Parametrage$PipeEtape2$Phrases$libelleDuPassage, i18n, options, passage),
				passage.sn);
		};
		var chemin = A2(
			$elm$core$List$filter,
			function (etape) {
				return etape.g1 !== 3;
			},
			parcours.yL);
		var position = function (uid) {
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$first,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v3) {
							var etape = _v3.b;
							return _Utils_eq(etape.r8, uid);
						},
						A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, chemin))));
		};
		var sources = function (passage) {
			return A2(
				$elm$core$List$filterMap,
				position,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.wC;
					},
					A2(
						$elm$core$List$filter,
						function (autre) {
							return _Utils_eq(
								cle(autre),
								cle(passage));
						},
						sorties)));
		};
		var communs = A2(
			$elm$core$List$filter,
			function (passage) {
				return (!passage.j4.n9) && ($elm$core$List$length(
					sources(passage)) > 1);
			},
			sorties);
		var nominal = function (uid) {
			return $elm$core$List$head(
				A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.El;
					},
					A2(
						$elm$core$List$filter,
						function (passage) {
							return _Utils_eq(passage.wC, uid) && (!A2($elm$core$List$member, passage, communs));
						},
						sorties)));
		};
		var enchaine = function (uid) {
			return A2(
				$elm$core$Maybe$andThen,
				function (passage) {
					return (_Utils_eq(
						position(passage.sn),
						$elm$core$Maybe$Nothing) || (unRetour(uid) && (passage.j4.n9 === 1))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(passage.sn);
				},
				nominal(uid));
		};
		var laterale = function (uid) {
			return unRetour(uid) && (!A2(
				$elm$core$List$any,
				function (etape) {
					return _Utils_eq(
						$elm$core$Maybe$Just(uid),
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.sn;
							},
							nominal(etape.r8)));
				},
				chemin));
		};
		var laterales = A2(
			$elm$core$List$filter,
			laterale,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.r8;
				},
				chemin));
		var lignesDeLaterale = function (uid) {
			return _Utils_ap(
				A2(
					$elm$core$List$map,
					function (passage) {
						return {
							dX: false,
							eW: 0,
							Jx: A2(
								$author$project$I18n$Cles$pipeEtape2ApercuLaterale,
								i18n,
								{
									j4: conditionDeLaterale(passage),
									no: nom(uid),
									o4: nom(passage.wC)
								})
						};
					},
					A2(
						$elm$core$List$filter,
						function (passage) {
							return _Utils_eq(passage.sn, uid) && (!A2($elm$core$List$member, passage.wC, laterales));
						},
						sorties)),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						function (passage) {
							return {
								dX: false,
								eW: 0,
								Jx: A2(
									$author$project$I18n$Cles$pipeEtape2ApercuLateraleRetour,
									i18n,
									{
										no: nom(uid),
										sn: nom(passage.sn)
									})
							};
						},
						A2(
							$elm$core$List$filter,
							function (passage) {
								return _Utils_eq(passage.wC, uid) && (passage.IC === 2);
							},
							parcours.E5)),
					A2(
						$elm$core$List$map,
						ligne,
						A2(
							$elm$core$List$filter,
							function (passage) {
								return _Utils_eq(passage.wC, uid) && (!A2($elm$core$List$member, passage, communs));
							},
							sorties))));
		};
		var versUneLaterale = function (passage) {
			return A2($elm$core$List$member, passage.sn, laterales);
		};
		var sortiesDe = function (uids) {
			return A2(
				$elm$core$List$concatMap,
				function (uid) {
					return A2(
						$elm$core$List$filter,
						function (passage) {
							return !(_Utils_eq(
								enchaine(uid),
								$elm$core$Maybe$Just(passage.sn)) && (passage.j4.n9 !== 1));
						},
						A2(
							$elm$core$List$filter,
							function (passage) {
								return _Utils_eq(passage.wC, uid) && ((!A2($elm$core$List$member, passage, communs)) && (!versUneLaterale(passage)));
							},
							sorties));
				},
				uids);
		};
		var chaine = F2(
			function (vus, depart) {
				if (A2($elm$core$List$member, depart, vus)) {
					return _List_Nil;
				} else {
					var _v0 = enchaine(depart);
					if (!_v0.$) {
						var suite_ = _v0.a;
						return A2(
							$elm$core$List$cons,
							depart,
							A2(
								chaine,
								A2($elm$core$List$cons, depart, vus),
								suite_));
					} else {
						return _List_fromArray(
							[depart]);
					}
				}
			});
		var blocs = function (restantes) {
			if (!restantes.b) {
				return _List_Nil;
			} else {
				var depart = restantes.a;
				var uids = A2(chaine, _List_Nil, depart);
				return A2(
					$elm$core$List$cons,
					A2(
						$elm$core$List$cons,
						fort(
							A2(
								$elm$core$String$join,
								$author$project$I18n$Cles$pipeEtape2ApercuChainon(i18n),
								A2($elm$core$List$map, nom, uids))),
						A2(
							$elm$core$List$map,
							ligne,
							sortiesDe(uids))),
					blocs(
						A2(
							$elm$core$List$filter,
							function (uid) {
								return !A2($elm$core$List$member, uid, uids);
							},
							restantes)));
			}
		};
		var avantTout = function (passage) {
			var derniere = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$List$maximum(
					sources(passage)));
			var jusqua = A2(
				$elm$core$Maybe$withDefault,
				nom(passage.sn),
				A2(
					$elm$core$Maybe$map,
					function (etape) {
						return $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(etape.R);
					},
					$elm$core$List$head(
						A2($elm$core$List$drop, derniere + 1, chemin))));
			return _Utils_Tuple2(jusqua, passage);
		};
		var regroupes = A2(
			$elm$core$List$concatMap,
			function (_v2) {
				var jusqua = _v2.a;
				var passage = _v2.b;
				return _List_fromArray(
					[
						fort(
						A2(
							$author$project$I18n$Cles$pipeEtape2ApercuAToutMoment,
							i18n,
							{me: jusqua})),
						ligne(passage)
					]);
			},
			A2(
				$elm$core$List$map,
				avantTout,
				A2(
					$elm$core$List$filter,
					function (passage) {
						return _Utils_eq(
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (autre) {
										return _Utils_eq(
											cle(autre),
											cle(passage));
									},
									communs)),
							$elm$core$Maybe$Just(passage));
					},
					communs)));
		return _Utils_ap(
			$elm$core$List$concat(
				blocs(
					A2(
						$elm$core$List$filter,
						function (uid) {
							return !laterale(uid);
						},
						A2(
							$elm$core$List$map,
							function ($) {
								return $.r8;
							},
							chemin)))),
			_Utils_ap(
				A2($elm$core$List$concatMap, lignesDeLaterale, laterales),
				regroupes));
	});
var $author$project$I18n$Cles$pipeEtape2ApercuSousTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.apercu.sous-titre', _List_Nil, 'Le chemin d\'un dossier');
};
var $author$project$I18n$Cles$pipeEtape2ApercuTotal = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.apercu.total',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etapes',
					$author$project$I18n$Traductions$Chaine(p.yL)),
					_Utils_Tuple2(
					'passages',
					$author$project$I18n$Traductions$Chaine(p.E5)),
					_Utils_Tuple2(
					'fins',
					$author$project$I18n$Traductions$Chaine(p.zL))
				]),
			p.yL + (', ' + (p.E5 + (', ' + p.zL))));
	});
var $author$project$I18n$Cles$pipeEtape2Fins = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.fins',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fin') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fins'));
	});
var $author$project$Components$Parametrage$PipeEtape2$View$total = F2(
	function (i18n, parcours) {
		return A2(
			$author$project$I18n$Cles$pipeEtape2ApercuTotal,
			i18n,
			{
				yL: A2(
					$author$project$I18n$Cles$pipesEtapes,
					i18n,
					{yL: parcours.HX.Dt}),
				zL: A2(
					$author$project$I18n$Cles$pipeEtape2Fins,
					i18n,
					{w: parcours.HX.Dz}),
				E5: A2(
					$author$project$I18n$Cles$pipesPassages,
					i18n,
					{E5: parcours.HX.DE})
			});
	});
var $author$project$Components$Parametrage$PipeEtape2$View$apercu = F3(
	function (i18n, options, parcours) {
		return A3(
			$author$project$Components$Shared$Parcours$View$apercu,
			i18n,
			$author$project$I18n$Cles$pipeEtape1ApercuTitre(i18n),
			{
				gV: _Utils_ap(
					A3($author$project$Components$Parametrage$PipeEtape2$Phrases$apercuGroupe, i18n, options, parcours),
					_List_fromArray(
						[
							{
							dX: false,
							eW: 0,
							Jx: A2($author$project$Components$Parametrage$PipeEtape2$View$total, i18n, parcours)
						}
						])),
				h6: $elm$core$Maybe$Just(
					$author$project$I18n$Cles$pipeEtape2ApercuSousTitre(i18n))
			});
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$DetailOuvert = {$: 26};
var $author$project$Components$Parametrage$PipeEtape2$Update$EtapeDemandee = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Parametrage$PipeEtape2$View$classeDuResultat = function (resultat) {
	switch (resultat) {
		case 'gagne':
			return 'gagne';
		case 'perdu':
			return 'perdu';
		case 'abandonne':
			return 'abandonne';
		default:
			var autre = resultat;
			return autre;
	}
};
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$codeDeLaNature = function (nature) {
	switch (nature) {
		case 0:
			return 'debut';
		case 1:
			return 'chemin';
		case 2:
			return 'fin';
		default:
			return 'fin-hors-chemin';
	}
};
var $author$project$Components$Parametrage$PipeEtape2$View$etiquetteDe = function (_v0) {
	var teinte = _v0.a;
	var texte = _v0.b;
	return A2(
		$rtfeldman$elm_css$Html$Styled$span,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('etiquette'),
				$rtfeldman$elm_css$Html$Styled$Attributes$class(teinte)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(texte)
			]));
};
var $author$project$I18n$Cles$pipeEtape2NatureDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.nature.debut', _List_Nil, 'Début');
};
var $author$project$I18n$Cles$pipeEtape2NatureFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.nature.fin', _List_Nil, 'Fin');
};
var $author$project$Components$Parametrage$Vocabulaire$natureDeLEtape = F2(
	function (i18n, code) {
		switch (code) {
			case 'debut':
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$pipeEtape2NatureDebut(i18n));
			case 'fin':
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$pipeEtape2NatureFin(i18n));
			case 'fin-hors-chemin':
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$pipeEtape2NatureFin(i18n));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$I18n$Cles$pipeEtape2SansRole = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.sans-role', _List_Nil, 'aucun rôle');
};
var $author$project$I18n$Cles$pipeEtape2SansTache = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.sans-tache', _List_Nil, 'aucune tâche');
};
var $author$project$I18n$Cles$pipeEtape2Taches = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.taches',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' tâche') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' tâches'));
	});
var $author$project$I18n$Cles$pipeEtape2ResultatAbandonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.resultat.abandonne', _List_Nil, 'Abandonné');
};
var $author$project$I18n$Cles$pipeEtape2ResultatAccepte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.resultat.accepte', _List_Nil, 'Accepté');
};
var $author$project$I18n$Cles$pipeEtape2ResultatGagne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.resultat.gagne', _List_Nil, 'Gagné');
};
var $author$project$I18n$Cles$pipeEtape2ResultatPerdu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.resultat.perdu', _List_Nil, 'Perdu');
};
var $author$project$I18n$Cles$pipeEtape2ResultatRefuse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.resultat.refuse', _List_Nil, 'Refusé');
};
var $author$project$Components$Parametrage$Vocabulaire$resultatDeFin = F2(
	function (i18n, code) {
		switch (code) {
			case 'gagne':
				return $author$project$I18n$Cles$pipeEtape2ResultatGagne(i18n);
			case 'perdu':
				return $author$project$I18n$Cles$pipeEtape2ResultatPerdu(i18n);
			case 'abandonne':
				return $author$project$I18n$Cles$pipeEtape2ResultatAbandonne(i18n);
			case 'accepte':
				return $author$project$I18n$Cles$pipeEtape2ResultatAccepte(i18n);
			case 'refuse':
				return $author$project$I18n$Cles$pipeEtape2ResultatRefuse(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$Components$Parametrage$PipeEtape2$Phrases$infosDeLEtape = F2(
	function (i18n, etape) {
		return A2(
			$elm$core$String$join,
			' · ',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$author$project$Components$Parametrage$Vocabulaire$natureDeLEtape,
						i18n,
						$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$codeDeLaNature(etape.g1)),
						A2(
						$elm$core$Maybe$map,
						$author$project$Components$Parametrage$Vocabulaire$resultatDeFin(i18n),
						etape.mK),
						$elm$core$Maybe$Just(
						$elm$core$List$isEmpty(etape.eX) ? $author$project$I18n$Cles$pipeEtape2SansRole(i18n) : A2(
							$elm$core$String$join,
							', ',
							A2(
								$elm$core$List$map,
								function ($) {
									return $.Bl;
								},
								etape.eX))),
						$elm$core$Maybe$Just(
						(!etape.DD) ? $author$project$I18n$Cles$pipeEtape2SansTache(i18n) : A2(
							$author$project$I18n$Cles$pipeEtape2Taches,
							i18n,
							{w: etape.DD}))
					])));
	});
var $author$project$Components$Parametrage$PipeEtape2$View$nomDeLEtape = F2(
	function (parcours, uid) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (lue) {
					return $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(lue.R);
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (lue) {
							return _Utils_eq(lue.r8, uid);
						},
						parcours.yL))));
	});
var $author$project$I18n$Cles$pipeEtape2Depuis = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.depuis',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etapes',
					$author$project$I18n$Traductions$Chaine(p.yL))
				]),
			'depuis ' + p.yL);
	});
var $author$project$I18n$Cles$pipeEtape2Ou = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.ou',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'vers',
					$author$project$I18n$Traductions$Chaine(p.sn))
				]),
			'ou ' + p.sn);
	});
var $author$project$I18n$Cles$pipeEtape2SuitLaCampagne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.suit-la-campagne', _List_Nil, 'suit la campagne');
};
var $author$project$I18n$Cles$pipeEtape2RetourVers = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.retour-vers',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'article',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeArticle(p.i4))),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retour ' + function () {
				var _v0 = p.i4;
				switch (_v0) {
					case 0:
						return 'à ' + p.Dj;
					case 1:
						return 'à l\'' + $elm$core$String$toLower(p.Dj);
					case 2:
						return 'à la ' + $elm$core$String$toLower(p.Dj);
					case 3:
						return 'au ' + $elm$core$String$toLower(p.Dj);
					default:
						return 'à ' + p.Dj;
				}
			}());
	});
var $author$project$Components$Parametrage$PipeEtape2$Phrases$retourVers = F2(
	function (i18n, etape) {
		return A2(
			$author$project$I18n$Cles$pipeEtape2RetourVers,
			i18n,
			{
				i4: $author$project$Catalogue$Formes$article(etape.m$),
				Dj: function () {
					var _v0 = etape.m$;
					if (!_v0.$) {
						return A2(
							$elm$core$Maybe$withDefault,
							$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(etape.R),
							etape.Dl);
					} else {
						return $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(etape.R);
					}
				}()
			});
	});
var $author$project$Components$Parametrage$PipeEtape2$View$retourVers = F3(
	function (i18n, parcours, uid) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$Parametrage$PipeEtape2$Phrases$retourVers(i18n),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (lue) {
							return _Utils_eq(lue.r8, uid);
						},
						parcours.yL))));
	});
var $author$project$Components$Parametrage$PipeEtape2$View$teinteDeLaFin = F2(
	function (parcours, uid) {
		return A2(
			$elm$core$Maybe$withDefault,
			'neutre',
			A2(
				$elm$core$Maybe$map,
				function (resultat) {
					switch (resultat) {
						case 'perdu':
							return 'rouge';
						case 'abandonne':
							return 'orange';
						default:
							return 'neutre';
					}
				},
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.mK;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (lue) {
								return _Utils_eq(lue.r8, uid);
							},
							parcours.yL)))));
	});
var $author$project$Components$Parametrage$PipeEtape2$View$ligneDEtape = F3(
	function (i18n, parcours, etape_) {
		var suit = etape_.Fr ? _List_fromArray(
			[
				_Utils_Tuple2(
				'accent',
				$author$project$I18n$Cles$pipeEtape2SuitLaCampagne(i18n))
			]) : _List_Nil;
		var passagesDeCote = A2(
			$elm$core$List$sortBy,
			function (passage) {
				return (passage.IC === 2) ? 1 : 0;
			},
			A2(
				$elm$core$List$filter,
				function (passage) {
					return _Utils_eq(passage.wC, etape_.r8) && (!(!passage.IC));
				},
				parcours.E5));
		var etiquette = function (passage) {
			var _v1 = passage.IC;
			if (_v1 === 2) {
				return _Utils_Tuple2(
					'neutre',
					A3($author$project$Components$Parametrage$PipeEtape2$View$retourVers, i18n, parcours, passage.sn));
			} else {
				return _Utils_Tuple2(
					A2($author$project$Components$Parametrage$PipeEtape2$View$teinteDeLaFin, parcours, passage.sn),
					A2(
						$author$project$I18n$Cles$pipeEtape2Ou,
						i18n,
						{
							sn: A2($author$project$Components$Parametrage$PipeEtape2$View$nomDeLEtape, parcours, passage.sn)
						}));
			}
		};
		var depuis = $elm$core$List$isEmpty(etape_.tM) ? _List_Nil : _List_fromArray(
			[
				_Utils_Tuple2(
				'neutre',
				A2(
					$author$project$I18n$Cles$pipeEtape2Depuis,
					i18n,
					{
						yL: A2(
							$elm$core$String$join,
							', ',
							A2(
								$elm$core$List$map,
								$author$project$Components$Parametrage$PipeEtape2$View$nomDeLEtape(parcours),
								etape_.tM))
					}))
			]);
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne-d-etape'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'data-nature',
					$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$codeDeLaNature(etape_.g1))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_Utils_ap(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$id(
								$author$project$Components$Parametrage$PipeEtape2$Model$idDuDeclencheur('etape-' + etape_.r8)),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Parametrage$PipeEtape2$Update$EtapeDemandee(etape_.r8))
							]),
						A2(
							$elm$core$Maybe$withDefault,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
								]),
							A2(
								$elm$core$Maybe$map,
								function (_v0) {
									return _List_Nil;
								},
								etape_.np))),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2($elm$core$Maybe$map, $author$project$Components$Parametrage$PipeEtape2$View$classeDuResultat, etape_.mK)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									(etape_.g1 === 3) ? '–' : $elm$core$String$fromInt(etape_.bY))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('textes')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(etape_.R))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$Components$Parametrage$PipeEtape2$Phrases$infosDeLEtape, i18n, etape_))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('etiquettes')
								]),
							A2(
								$elm$core$List$map,
								$author$project$Components$Parametrage$PipeEtape2$View$etiquetteDe,
								_Utils_ap(
									A2($elm$core$List$map, etiquette, passagesDeCote),
									_Utils_ap(depuis, suit))))
						]))
				]));
	});
var $author$project$I18n$Cles$pipeEtape2DetailOuvrir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.detail.ouvrir', _List_Nil, 'Voir le parcours détaillé');
};
var $author$project$I18n$Cles$pipeEtape2ResumeChemin = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.resume.chemin',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' étape sur le chemin') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' étapes sur le chemin'));
	});
var $author$project$I18n$Cles$pipeEtape2ResumeFins = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.resume.fins',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fin hors chemin') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fins hors chemin'));
	});
var $author$project$I18n$Cles$pipeEtape2ResumeNoms = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.resume.noms',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'noms',
					$author$project$I18n$Traductions$Chaine(p.DG))
				]),
			' (' + (p.DG + ')'));
	});
var $author$project$I18n$Cles$pipeEtape2ResumeRetours = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.resume.retours',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' retour') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' retours'));
	});
var $author$project$Components$Parametrage$PipeEtape2$Phrases$resume = F2(
	function (i18n, parcours) {
		var sansLesFins = $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (etape) {
					return etape.g1 !== 3;
				},
				parcours.yL));
		var horsChemin = A2(
			$elm$core$List$filter,
			function (etape) {
				return etape.g1 === 3;
			},
			parcours.yL);
		return A2(
			$elm$core$String$join,
			', ',
			_List_fromArray(
				[
					A2(
					$author$project$I18n$Cles$pipeEtape2ResumeChemin,
					i18n,
					{w: sansLesFins}),
					_Utils_ap(
					A2(
						$author$project$I18n$Cles$pipeEtape2ResumeFins,
						i18n,
						{
							w: $elm$core$List$length(horsChemin)
						}),
					A2(
						$author$project$I18n$Cles$pipeEtape2ResumeNoms,
						i18n,
						{
							DG: A2(
								$elm$core$String$join,
								', ',
								A2(
									$elm$core$List$map,
									function (etape) {
										return $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(etape.R);
									},
									horsChemin))
						})),
					A2(
					$author$project$I18n$Cles$pipeEtape2ResumeRetours,
					i18n,
					{w: parcours.HX.DC})
				])) + '.';
	});
var $author$project$Components$Parametrage$PipeEtape2$View$enBref = F2(
	function (i18n, parcours) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('parcours-en-bref')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('parcours')
						]),
					A2(
						$elm$core$List$map,
						A2($author$project$Components$Parametrage$PipeEtape2$View$ligneDEtape, i18n, parcours),
						parcours.yL)),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('bas')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('resume')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Parametrage$PipeEtape2$Phrases$resume, i18n, parcours))
								])),
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape2$Update$DetailOuvert)
								]),
							$author$project$I18n$Cles$pipeEtape2DetailOuvrir(i18n))
						]))
				]));
	});
var $author$project$I18n$Cles$pipeEtape1EtatAVenir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.etat.a-venir', _List_Nil, 'À venir');
};
var $author$project$I18n$Cles$pipeEtape1EtatEnCours = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.etat.en-cours', _List_Nil, 'En cours');
};
var $author$project$Components$Parametrage$Common$Conception$etape = F5(
	function (i18n, code, actuelle, numero, intitule) {
		var contenu = function (avancement) {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('numero')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(numero))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(intitule)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('avancement')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(avancement)
						]))
				]);
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			_List_fromArray(
				[
					_Utils_eq(numero, actuelle) ? A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$href(
							A2($author$project$Components$Parametrage$Common$Conception$adresseDe, numero, code)),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('active'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-current', 'step')
						]),
					contenu(
						$author$project$I18n$Cles$pipeEtape1EtatEnCours(i18n))) : ($author$project$Components$Parametrage$Common$Conception$etapeOuvrable(numero) ? A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$href(
							A2($author$project$Components$Parametrage$Common$Conception$adresseDe, numero, code))
						]),
					contenu(
						$author$project$I18n$Cles$pipeEtape1EtatAVenir(i18n))) : A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('bientot'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-disabled', 'true')
						]),
					contenu(
						$author$project$I18n$Cles$pipeEtape1EtatAVenir(i18n))))
				]));
	});
var $author$project$Components$Parametrage$Common$Conception$etapes = F3(
	function (i18n, code, actuelle) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$nav,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('etapes'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					$author$project$I18n$Cles$pipeEtape1Etapes(i18n))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$ol,
					_List_Nil,
					A3(
						$elm$core$List$map2,
						A3($author$project$Components$Parametrage$Common$Conception$etape, i18n, code, actuelle),
						A2($elm$core$List$range, 1, 8),
						_List_fromArray(
							[
								$author$project$I18n$Cles$pipeEtape1Etape1(i18n),
								$author$project$I18n$Cles$pipeEtape1Etape2(i18n),
								$author$project$I18n$Cles$pipeEtape1Etape3(i18n),
								$author$project$I18n$Cles$pipeEtape1Etape4(i18n),
								$author$project$I18n$Cles$pipeEtape1Etape5(i18n),
								$author$project$I18n$Cles$pipeEtape1Etape6(i18n),
								$author$project$I18n$Cles$pipeEtape1Etape7(i18n),
								$author$project$I18n$Cles$pipeEtape1Etape8(i18n)
							])))
				]));
	});
var $author$project$I18n$Cles$pipeEtape2QuelEtape = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.quel.etape', _List_Nil, 'étape');
};
var $author$project$I18n$Cles$pipeEtape2QuelPassage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.quel.passage', _List_Nil, 'passage');
};
var $author$project$I18n$Cles$pipeEtape2QuelTexte1 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.quel.texte1', _List_Nil, 'Une ');
};
var $author$project$I18n$Cles$pipeEtape2QuelTexte2 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.quel.texte2', _List_Nil, ' est une phase du processus. Un ');
};
var $author$project$I18n$Cles$pipeEtape2QuelTexte3 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.quel.texte3', _List_Nil, ' mène d\'une étape à une autre, souvent à une condition.');
};
var $author$project$Components$Parametrage$PipeEtape2$View$explication = function (i18n) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$p,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('explication')
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$I18n$Cles$pipeEtape2QuelTexte1(i18n)),
				A2(
				$rtfeldman$elm_css$Html$Styled$strong,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$pipeEtape2QuelEtape(i18n))
					])),
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$I18n$Cles$pipeEtape2QuelTexte2(i18n)),
				A2(
				$rtfeldman$elm_css$Html$Styled$strong,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$pipeEtape2QuelPassage(i18n))
					])),
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$I18n$Cles$pipeEtape2QuelTexte3(i18n))
			]));
};
var $author$project$Components$Parametrage$PipeEtape2$Update$PassageDemande = function (a) {
	return {$: 7, a: a};
};
var $author$project$I18n$Cles$pipeEtape2DeclenchementAutomatique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.declenchement.automatique', _List_Nil, 'Automatique');
};
var $author$project$I18n$Cles$pipeEtape2DeclenchementCalculeSla = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.declenchement.calcule-sla', _List_Nil, 'Calculé (SLA)');
};
var $author$project$I18n$Cles$pipeEtape2DeclenchementParLeRegroupement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.declenchement.par-le-regroupement', _List_Nil, 'Piloté par la campagne');
};
var $author$project$Components$Parametrage$PipeEtape2$Phrases$declenchement = F3(
	function (i18n, roleDe, lue) {
		switch (lue.$) {
			case 0:
				return $author$project$I18n$Cles$pipeEtape2DeclenchementAutomatique(i18n);
			case 1:
				var uid = lue.a;
				return roleDe(uid);
			case 2:
				return $author$project$I18n$Cles$pipeEtape2DeclenchementCalculeSla(i18n);
			default:
				return $author$project$I18n$Cles$pipeEtape2DeclenchementParLeRegroupement(i18n);
		}
	});
var $author$project$Components$Parametrage$PipeEtape2$View$nomDuRole = F2(
	function (parcours, uid) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (role) {
							return _Utils_eq(role.r8, uid);
						},
						A2(
							$elm$core$List$concatMap,
							function ($) {
								return $.eX;
							},
							parcours.yL)))));
	});
var $author$project$Components$Parametrage$PipeEtape2$View$nomDuRoleDesOptions = F3(
	function (options, parcours, uid) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$Components$Parametrage$PipeEtape2$View$nomDuRole, parcours, uid),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (role) {
							return _Utils_eq(role.r8, uid);
						},
						options.H9))));
	});
var $author$project$I18n$Cles$pipeEtape2PassageDeVers = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.passage.de-vers',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'origine',
					$author$project$I18n$Traductions$Chaine(p.o4)),
					_Utils_Tuple2(
					'vers',
					$author$project$I18n$Traductions$Chaine(p.sn))
				]),
			p.o4 + (' → ' + p.sn));
	});
var $author$project$Components$Parametrage$PipeEtape2$View$passages = F3(
	function (i18n, options, parcours) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$ul,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('lignes')
				]),
			A2(
				$elm$core$List$map,
				function (passage) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$id(
										$author$project$Components$Parametrage$PipeEtape2$Model$idDuDeclencheur('passage-' + passage.r8)),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Parametrage$PipeEtape2$Update$PassageDemande(passage.r8))
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('textes')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2(
															$author$project$I18n$Cles$pipeEtape2PassageDeVers,
															i18n,
															{
																o4: A2($author$project$Components$Parametrage$PipeEtape2$View$nomDeLEtape, parcours, passage.wC),
																sn: A2($author$project$Components$Parametrage$PipeEtape2$View$nomDeLEtape, parcours, passage.sn)
															}))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A3($author$project$Components$Parametrage$PipeEtape2$Phrases$libelleDuPassage, i18n, options, passage))
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('etiquettes')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('etiquette')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A3(
															$author$project$Components$Parametrage$PipeEtape2$Phrases$declenchement,
															i18n,
															A2($author$project$Components$Parametrage$PipeEtape2$View$nomDuRoleDesOptions, options, parcours),
															passage.kw))
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('fleche'),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('›')
											]))
									]))
							]));
				},
				parcours.E5));
	});
var $author$project$I18n$Cles$pipeEtape2Precedente = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.precedente', _List_Nil, 'Étape précédente');
};
var $author$project$Components$Parametrage$PipeEtape2$View$pied = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pied')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$lien,
					1,
					$author$project$Routes$Route$adressePipeEtape1(model.vx),
					$author$project$I18n$Cles$pipeEtape2Precedente(i18n)),
					A3(
					$author$project$Components$Shared$Bouton$View$lien,
					0,
					$author$project$Routes$Route$adressePipeEtape3(model.vx),
					$author$project$I18n$Cles$pipeEtape1Suivante(i18n))
				]));
	});
var $author$project$I18n$Cles$pipeEtape2BrefTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.bref.titre', _List_Nil, 'Le parcours en bref');
};
var $author$project$I18n$Cles$pipeEtape2Conseil = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.conseil', _List_Nil, 'Cliquez une étape ou un passage pour le régler. Quand plusieurs passages partent d\'une étape, le premier dont la condition est vraie l\'emporte. Le dernier, « sinon », est obligatoire.');
};
var $author$project$I18n$Cles$pipeEtape2PassagesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.passages.titre', _List_Nil, 'Les passages');
};
var $author$project$I18n$Cles$pipeEtape2TitreQuel = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.titre-quel', _List_Nil, 'Par quelles étapes passe un dossier ?');
};
var $author$project$Components$Parametrage$PipeEtape2$View$section = F3(
	function (nom, titre, contenu) {
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_Nil,
			{fw: _List_Nil, fZ: contenu, Dj: nom, h6: titre});
	});
var $author$project$Components$Parametrage$PipeEtape2$View$corps = F3(
	function (i18n, messages, model) {
		var _v0 = _Utils_Tuple3(model.ex, model.o_, model.nf);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var parcours = _v0.a.a;
			var options = _v0.b.a;
			return _List_fromArray(
				[
					A3($author$project$Components$Parametrage$Common$Conception$etapes, i18n, model.vx, 2),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
						]),
					_List_fromArray(
						[
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('etape')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h2,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape2TitreQuel(i18n))
										])),
									$author$project$Components$Parametrage$PipeEtape2$View$explication(i18n),
									A3(
									$author$project$Components$Parametrage$PipeEtape2$View$section,
									'bref',
									$author$project$I18n$Cles$pipeEtape2BrefTitre(i18n),
									_List_fromArray(
										[
											A2($author$project$Components$Parametrage$PipeEtape2$View$enBref, i18n, parcours)
										])),
									A3($author$project$Components$Parametrage$PipeEtape2$View$ajouts, i18n, model, parcours),
									A3(
									$author$project$Components$Parametrage$PipeEtape2$View$section,
									'passages',
									$author$project$I18n$Cles$pipeEtape2PassagesTitre(i18n),
									_List_fromArray(
										[
											A3($author$project$Components$Parametrage$PipeEtape2$View$passages, i18n, options, parcours)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape2Conseil(i18n))
										]))
								])),
							A2($author$project$Components$Parametrage$PipeEtape2$View$pied, i18n, model)
						])),
					A3($author$project$Components$Parametrage$PipeEtape2$View$apercu, i18n, options, parcours)
				]);
		} else {
			if (_v0.c) {
				return _List_fromArray(
					[
						A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape1Introuvable(i18n))
							]))
					]);
			} else {
				return _List_fromArray(
					[
						A2($author$project$Components$Shared$Messages$View$view, i18n, messages)
					]);
			}
		}
	});
var $author$project$I18n$Cles$pipeEtape2DeclenchementDeclaratif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.declenchement.declaratif', _List_Nil, 'Déclaratif');
};
var $author$project$I18n$Cles$pipeEtape2LegendeAutomatique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.legende.automatique', _List_Nil, 'fait par le système');
};
var $author$project$I18n$Cles$pipeEtape2LegendeBranche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.legende.branche', _List_Nil, 'Embranchement vers une fin ou une étape à part');
};
var $author$project$I18n$Cles$pipeEtape2LegendeDeclaratif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.legende.declaratif', _List_Nil, 'fait par une personne');
};
var $author$project$I18n$Cles$pipeEtape2LegendeNominal = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.legende.nominal', _List_Nil, 'Parcours nominal');
};
var $author$project$I18n$Cles$pipeEtape2LegendeRetour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.legende.retour', _List_Nil, 'Retour en arrière');
};
var $author$project$I18n$Cles$pipeEtape2LegendeSla = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.legende.sla', _List_Nil, 'date calculée depuis les SLA du contrat');
};
var $author$project$Components$Parametrage$PipeEtape2$View$legende = function (i18n) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('legende')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$ul,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('traits')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('nominal')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape2LegendeNominal(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('branche')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape2LegendeBranche(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('retour')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape2LegendeRetour(i18n))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$ul,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('pastilles')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille-declaratif')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape2DeclenchementDeclaratif(i18n))
									])),
								$rtfeldman$elm_css$Html$Styled$text(
								' ' + $author$project$I18n$Cles$pipeEtape2LegendeDeclaratif(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille-automatique')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape2DeclenchementAutomatique(i18n))
									])),
								$rtfeldman$elm_css$Html$Styled$text(
								' ' + $author$project$I18n$Cles$pipeEtape2LegendeAutomatique(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille-sla')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape2DeclenchementCalculeSla(i18n))
									])),
								$rtfeldman$elm_css$Html$Styled$text(
								' ' + $author$project$I18n$Cles$pipeEtape2LegendeSla(i18n))
							]))
					]))
			]));
};
var $author$project$Components$Parametrage$PipeEtape2$Update$EtapeDuSchemaChoisie = function (a) {
	return {$: 28, a: a};
};
var $author$project$I18n$Cles$pipeEtape2PanneauAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.panneau.aucun', _List_Nil, 'Aucun : fin du parcours.');
};
var $author$project$I18n$Cles$pipeEtape2PanneauPassages = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.panneau.passages', _List_Nil, 'Passages qui partent');
};
var $author$project$I18n$Cles$pipeEtape2PanneauReafficher = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.panneau.reafficher', _List_Nil, 'Tout réafficher');
};
var $author$project$I18n$Cles$pipeEtape2PanneauRoles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.panneau.roles', _List_Nil, 'Rôles');
};
var $author$project$I18n$Cles$pipeEtape2PanneauSansRole = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.panneau.sans-role', _List_Nil, 'Aucun rôle');
};
var $author$project$I18n$Cles$pipeEtape2PanneauSansTache = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.panneau.sans-tache', _List_Nil, 'Aucune tâche');
};
var $author$project$I18n$Cles$pipeEtape2PanneauTaches = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.panneau.taches', _List_Nil, 'Tâches');
};
var $author$project$I18n$Cles$pipeEtape2PanneauTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.panneau.texte', _List_Nil, 'Cliquez une étape du schéma : ses passages sortants se colorent, ses passages, ses rôles et ses tâches s\'affichent ici.');
};
var $author$project$I18n$Cles$pipeEtape2PanneauTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.panneau.titre', _List_Nil, 'Choisissez une étape');
};
var $author$project$Components$Parametrage$PipeEtape2$View$panneau = F4(
	function (i18n, options, parcours, choisie) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (uid) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (lue) {
							return _Utils_eq(lue.r8, uid);
						},
						parcours.yL));
			},
			choisie);
		if (_v0.$ === 1) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('panneau'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'complementary')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h2,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape2PanneauTitre(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape2PanneauTexte(i18n))
							]))
					]));
		} else {
			var etape_ = _v0.a;
			var sortants = A2(
				$elm$core$List$filter,
				function (passage) {
					return _Utils_eq(passage.wC, etape_.r8);
				},
				parcours.E5);
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('panneau'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'complementary')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('numero')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$String$fromInt(etape_.bY))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$h2,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(etape_.R))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('sous-titre')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$Components$Parametrage$PipeEtape2$Phrases$infosDeLEtape, i18n, etape_))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$h3,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape2PanneauPassages(i18n))
							])),
						$elm$core$List$isEmpty(sortants) ? A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape2PanneauAucun(i18n))
							])) : A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('passages-de-l-etape')
							]),
						A2(
							$elm$core$List$map,
							function (passage) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$strong,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2($author$project$Components$Parametrage$PipeEtape2$View$nomDeLEtape, parcours, passage.sn))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A3($author$project$Components$Parametrage$PipeEtape2$Phrases$libelleDuPassage, i18n, options, passage))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('etiquette')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A3(
														$author$project$Components$Parametrage$PipeEtape2$Phrases$declenchement,
														i18n,
														A2($author$project$Components$Parametrage$PipeEtape2$View$nomDuRoleDesOptions, options, parcours),
														passage.kw))
												]))
										]));
							},
							sortants)),
						A2(
						$rtfeldman$elm_css$Html$Styled$h3,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape2PanneauRoles(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$List$isEmpty(etape_.eX) ? $author$project$I18n$Cles$pipeEtape2PanneauSansRole(i18n) : A2(
									$elm$core$String$join,
									', ',
									A2(
										$elm$core$List$map,
										function ($) {
											return $.Bl;
										},
										etape_.eX)))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$h3,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape2PanneauTaches(i18n))
							])),
						$elm$core$List$isEmpty(etape_.Jk) ? A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape2PanneauSansTache(i18n))
							])) : A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (tache) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(tache.Bl)
										]));
							},
							etape_.Jk)),
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Parametrage$PipeEtape2$Update$EtapeDuSchemaChoisie($elm$core$Maybe$Nothing))
							]),
						$author$project$I18n$Cles$pipeEtape2PanneauReafficher(i18n))
					]));
		}
	});
var $author$project$I18n$Cles$pipeEtape2DetailFermer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.detail.fermer', _List_Nil, 'Fermer');
};
var $author$project$I18n$Cles$pipeEtape2DetailNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.detail.note', _List_Nil, 'Quand plusieurs passages partent d\'une étape, ils sont essayés dans l\'ordre affiché : le premier dont la condition est vraie l\'emporte. Le dernier, « sinon », est obligatoire. Cliquez une étape pour voir ses passages, ses rôles et ses tâches.');
};
var $author$project$I18n$Cles$pipeEtape2DetailSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.detail.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'pipe',
					$author$project$I18n$Traductions$Chaine(p.Fs)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			'Pipe « ' + (p.Fs + (' » · ' + p.JE)));
	});
var $author$project$I18n$Cles$pipeEtape2DetailTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.detail.titre', _List_Nil, 'Le parcours détaillé');
};
var $elm$core$List$minimum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$min, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Parametrage$PipeEtape2$Phrases$listeAvecEt = F2(
	function (i18n, noms) {
		var _v0 = $elm$core$List$reverse(noms);
		if (_v0.b && _v0.b.b) {
			var dernier = _v0.a;
			var _v1 = _v0.b;
			var avant = _v1.a;
			var reste = _v1.b;
			return A2(
				$elm$core$String$join,
				', ',
				$elm$core$List$reverse(
					A2($elm$core$List$cons, avant, reste))) + (' ' + ($author$project$I18n$Cles$pipeEtape2LiaisonEt(i18n) + (' ' + dernier)));
		} else {
			return A2($elm$core$String$join, '', noms);
		}
	});
var $author$project$I18n$Cles$pipeEtape2DetailDepuis = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.detail.depuis',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etapes',
					$author$project$I18n$Traductions$Chaine(p.yL))
				]),
			'Depuis ' + p.yL);
	});
var $author$project$Components$Parametrage$PipeEtape2$Phrases$depuisDuNoeud = F3(
	function (i18n, noms, etape) {
		return A2(
			$elm$core$String$join,
			' · ',
			_List_fromArray(
				[
					A2(
					$author$project$I18n$Cles$pipeEtape2DetailDepuis,
					i18n,
					{
						yL: A2($author$project$Components$Parametrage$PipeEtape2$Phrases$listeAvecEt, i18n, noms)
					}),
					(!etape.DD) ? $author$project$I18n$Cles$pipeEtape2SansTache(i18n) : A2(
					$author$project$I18n$Cles$pipeEtape2Taches,
					i18n,
					{w: etape.DD})
				]));
	});
var $author$project$I18n$Cles$pipeEtape2DetailDelai = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.detail.delai',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' jour attendu') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' jours attendus'));
	});
var $author$project$Components$Parametrage$PipeEtape2$Phrases$precisionDuNoeud = F2(
	function (i18n, etape) {
		return A2(
			$elm$core$String$join,
			' · ',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$author$project$Components$Parametrage$Vocabulaire$natureDeLEtape,
						i18n,
						$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$codeDeLaNature(etape.g1)),
						A2(
						$elm$core$Maybe$map,
						$author$project$Components$Parametrage$Vocabulaire$resultatDeFin(i18n),
						etape.mK)
					])));
	});
var $author$project$Components$Parametrage$PipeEtape2$View$noeud = F4(
	function (i18n, parcours, choisie, etape_) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('noeud'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'data-nature',
					$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$codeDeLaNature(etape_.g1)),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'data-teinte',
					A2($author$project$Components$Parametrage$PipeEtape2$View$teinteDeLaFin, parcours, etape_.r8)),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'choisie',
							_Utils_eq(
								choisie,
								$elm$core$Maybe$Just(etape_.r8))),
							_Utils_Tuple2(
							'estompee',
							(!_Utils_eq(choisie, $elm$core$Maybe$Nothing)) && (!_Utils_eq(
								choisie,
								$elm$core$Maybe$Just(etape_.r8))))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-pressed',
					_Utils_eq(
						choisie,
						$elm$core$Maybe$Just(etape_.r8)) ? 'true' : 'false'),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Components$Parametrage$PipeEtape2$Update$EtapeDuSchemaChoisie(
						$elm$core$Maybe$Just(etape_.r8)))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							(etape_.g1 === 3) ? '–' : $elm$core$String$fromInt(etape_.bY))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(etape_.R))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$elm$core$Maybe$withDefault,
								A2($author$project$Components$Parametrage$PipeEtape2$Phrases$precisionDuNoeud, i18n, etape_),
								A2(
									$elm$core$Maybe$map,
									function (jours) {
										return A2(
											$author$project$I18n$Cles$pipeEtape2DetailDelai,
											i18n,
											{w: jours});
									},
									etape_.kB)))
						])),
					((etape_.g1 !== 3) || $elm$core$List$isEmpty(etape_.tM)) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A3(
								$author$project$Components$Parametrage$PipeEtape2$Phrases$depuisDuNoeud,
								i18n,
								A2(
									$elm$core$List$map,
									$author$project$Components$Parametrage$PipeEtape2$View$nomDeLEtape(parcours),
									etape_.tM),
								etape_))
						]))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$codeDuSens = function (sens) {
	switch (sens) {
		case 0:
			return 'avant';
		case 1:
			return 'branche';
		default:
			return 'retour';
	}
};
var $author$project$Components$Parametrage$PipeEtape2$View$passageDuSchema = F5(
	function (i18n, options, parcours, attributs, passage) {
		var _v0 = function () {
			var _v1 = passage.kw;
			switch (_v1.$) {
				case 0:
					return _Utils_Tuple2(
						$author$project$I18n$Cles$pipeEtape2DeclenchementAutomatique(i18n),
						'automatique');
				case 1:
					return _Utils_Tuple2(
						$author$project$I18n$Cles$pipeEtape2DeclenchementDeclaratif(i18n),
						'declaratif');
				case 2:
					return _Utils_Tuple2(
						$author$project$I18n$Cles$pipeEtape2DeclenchementCalculeSla(i18n),
						'sla');
				default:
					return _Utils_Tuple2(
						$author$project$I18n$Cles$pipeEtape2DeclenchementParLeRegroupement(i18n),
						'campagne');
			}
		}();
		var pastille = _v0.a;
		var classe = _v0.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$class('passage'),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'data-sens',
						$author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$codeDuSens(passage.IC)),
					attributs)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A3($author$project$Components$Parametrage$PipeEtape2$Phrases$libelleDuPassage, i18n, options, passage))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('declenche')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille-de-passage'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class(classe)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(pastille)
								])),
							function () {
							var _v2 = passage.kw;
							if (_v2.$ === 1) {
								var uid = _v2.a;
								return A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('role')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A3($author$project$Components$Parametrage$PipeEtape2$View$nomDuRoleDesOptions, options, parcours, uid))
										]));
							} else {
								return $rtfeldman$elm_css$Html$Styled$text('');
							}
						}()
						]))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape2$View$schema = F4(
	function (i18n, options, parcours, choisie) {
		var quitte = function (uid) {
			return A2(
				$elm$core$List$filter,
				function (passage) {
					return _Utils_eq(passage.wC, uid);
				},
				parcours.E5);
		};
		var horsChemin = A2(
			$elm$core$List$filter,
			function (lue) {
				return lue.g1 === 3;
			},
			parcours.yL);
		var duChemin = A2(
			$elm$core$List$filter,
			function (lue) {
				return lue.g1 !== 3;
			},
			parcours.yL);
		var position = function (uid) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$first,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (_v0) {
								var lue = _v0.b;
								return _Utils_eq(lue.r8, uid);
							},
							A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, duChemin)))));
		};
		var distanceDuRetour = function (passage) {
			return A2(
				$elm$core$Basics$max,
				1,
				position(passage.wC) - position(passage.sn));
		};
		var avecRetour = A2(
			$elm$core$List$any,
			function (passage) {
				return passage.IC === 2;
			},
			parcours.E5);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('schema'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'data-etapes',
					$elm$core$String$fromInt(
						$elm$core$List$length(duChemin)))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$ol,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('chemin'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('avec-retour', avecRetour)
								]))
						]),
					A2(
						$elm$core$List$concatMap,
						function (etape_) {
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('noeud-et-passage')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('retours')
												]),
											A2(
												$elm$core$List$map,
												function (passage) {
													return A5(
														$author$project$Components$Parametrage$PipeEtape2$View$passageDuSchema,
														i18n,
														options,
														parcours,
														_List_fromArray(
															[
																A2(
																$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
																'data-distance',
																$elm$core$String$fromInt(
																	distanceDuRetour(passage)))
															]),
														passage);
												},
												A2(
													$elm$core$List$filter,
													function (p) {
														return p.IC === 2;
													},
													quitte(etape_.r8)))),
											A4($author$project$Components$Parametrage$PipeEtape2$View$noeud, i18n, parcours, choisie, etape_),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('branches')
												]),
											A2(
												$elm$core$List$map,
												A4($author$project$Components$Parametrage$PipeEtape2$View$passageDuSchema, i18n, options, parcours, _List_Nil),
												A2(
													$elm$core$List$filter,
													function (p) {
														return p.IC === 1;
													},
													quitte(etape_.r8))))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('avant')
										]),
									A2(
										$elm$core$List$map,
										A4($author$project$Components$Parametrage$PipeEtape2$View$passageDuSchema, i18n, options, parcours, _List_Nil),
										A2(
											$elm$core$List$filter,
											function (p) {
												return !p.IC;
											},
											quitte(etape_.r8))))
								]);
						},
						duChemin)),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('fins')
						]),
					A2(
						$elm$core$List$map,
						function (etape_) {
							var sources = A2($elm$core$List$map, position, etape_.tM);
							var debut = A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$List$minimum(sources));
							var portee = (A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$List$maximum(sources)) - debut) + 1;
							return A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('fin'),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
										'data-debut',
										$elm$core$String$fromInt(debut)),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
										'data-portee',
										$elm$core$String$fromInt(portee))
									]),
								_List_fromArray(
									[
										A4($author$project$Components$Parametrage$PipeEtape2$View$noeud, i18n, parcours, choisie, etape_)
									]));
						},
						horsChemin))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape2$Model$etapesDuSchemaAuPlus = 12;
var $author$project$Components$Parametrage$PipeEtape2$Model$schemaTient = function (parcours) {
	return _Utils_cmp(
		$elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (etape) {
					return etape.g1 !== 3;
				},
				parcours.yL)),
		$author$project$Components$Parametrage$PipeEtape2$Model$etapesDuSchemaAuPlus) < 1;
};
var $author$project$Components$Parametrage$PipeEtape2$View$schemaOuListe = F4(
	function (i18n, options, parcours, choisie) {
		return $author$project$Components$Parametrage$PipeEtape2$Model$schemaTient(parcours) ? A4($author$project$Components$Parametrage$PipeEtape2$View$schema, i18n, options, parcours, choisie) : A2(
			$rtfeldman$elm_css$Html$Styled$ul,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('parcours')
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$Components$Parametrage$PipeEtape2$View$ligneDEtape, i18n, parcours),
				parcours.yL));
	});
var $author$project$Components$Parametrage$PipeEtape2$View$detail = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.ex, model.o_);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var parcours = _v0.a.a;
			var options = _v0.b.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id('drawer-pipe-etape-2-detail'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'dialog'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-modal', 'true'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-labelledby', 'titre-du-parcours-detaille'),
						$rtfeldman$elm_css$Html$Styled$Attributes$hidden(!model.bB)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('titres')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('sous-titre')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$pipeEtape2DetailSousTitre,
													i18n,
													{
														Fs: A2(
															$elm$core$Maybe$withDefault,
															'',
															A2(
																$elm$core$Maybe$map,
																function (e) {
																	return $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(e.R);
																},
																model.ge)),
														JE: A2($author$project$Components$Parametrage$PipeEtape2$View$total, i18n, parcours)
													}))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$h2,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id('titre-du-parcours-detaille')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$pipeEtape2DetailTitre(i18n))
											]))
									])),
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape2$Update$DetailFerme)
									]),
								$author$project$I18n$Cles$pipeEtape2DetailFermer(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('contenu')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('schema-et-notes')
									]),
								_List_fromArray(
									[
										A5($author$project$Components$Parametrage$Common$Conception$bandeau, i18n, $author$project$Routes$Route$adressePipeEtape2, model.vx, model.aS, model.nR),
										$author$project$Components$Parametrage$PipeEtape2$View$legende(i18n),
										A4($author$project$Components$Parametrage$PipeEtape2$View$schemaOuListe, i18n, options, parcours, model.ve),
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$pipeEtape2DetailNote(i18n))
											]))
									])),
								A4($author$project$Components$Parametrage$PipeEtape2$View$panneau, i18n, options, parcours, model.ve)
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$EnregistrementDemande = {$: 25};
var $author$project$Components$Parametrage$PipeEtape2$Update$Recharger = {$: 31};
var $author$project$Components$Parametrage$PipeEtape2$Update$RetraitConfirme = {$: 30};
var $author$project$Components$Parametrage$PipeEtape2$View$confirmerLe = F2(
	function (model, libelle) {
		return {
			sR: (!$author$project$API$Envoi$enCours(model.l2)) && _Utils_eq(model.pZ, $elm$core$Maybe$Nothing),
			Bl: libelle,
			C$: $author$project$Components$Parametrage$PipeEtape2$Update$RetraitConfirme
		};
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$ButDeLEtape = 1;
var $author$project$Components$Parametrage$PipeEtape2$Update$DelaiSaisi = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Parametrage$PipeEtape2$Update$FinaleBascule = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Parametrage$PipeEtape2$Update$LibelleDePortail = 2;
var $author$project$Components$Parametrage$PipeEtape2$Update$LibelleSaisi = F3(
	function (a, b, c) {
		return {$: 9, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$PipeEtape2$Model$NomATraduire = 0;
var $author$project$Components$Parametrage$PipeEtape2$Update$NomDeLEtape = 0;
var $author$project$Components$Parametrage$PipeEtape2$Model$PortailATraduire = 1;
var $author$project$Components$Parametrage$PipeEtape2$Update$PortailBascule = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Parametrage$PipeEtape2$Update$ResultatChoisi = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Parametrage$PipeEtape2$View$ajoutDePassage = F2(
	function (i18n, saisie) {
		var _v0 = saisie.r8;
		if (!_v0.$) {
			var uid = _v0.a;
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Parametrage$PipeEtape2$Update$PassageAjoutDemande(uid))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape2AjouterPassage(i18n))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$TraductionDemandee = function (a) {
	return {$: 11, a: a};
};
var $author$project$I18n$Cles$pipeEtape2TraductionARenseigner = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.traduction.a-renseigner', _List_Nil, 'À renseigner');
};
var $author$project$I18n$Cles$pipeEtape2TraductionAutreLangue = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.traduction.autre-langue',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'langue',
					$author$project$I18n$Traductions$Chaine(p.nn)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.nn + (' : ' + p.Dj));
	});
var $author$project$I18n$Cles$pipeEtape2Traduire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.traduire', _List_Nil, 'Traduire');
};
var $author$project$Components$Parametrage$PipeEtape2$View$carteDeTraduction = F3(
	function (i18n, champ, libelles) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('carte-traduction')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('textes')
						]),
					A2(
						$elm$core$List$map,
						function (langue) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('langue')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$pipeEtape2TraductionAutreLangue,
											i18n,
											{
												nn: A2($author$project$Referentiel$Langues$nom, i18n, langue.vx),
												Dj: A2(
													$elm$core$Maybe$withDefault,
													$author$project$I18n$Cles$pipeEtape2TraductionARenseigner(i18n),
													A2($elm$core$Dict$get, langue.vx, libelles))
											}))
									]));
						},
						A2(
							$elm$core$List$filter,
							function (langue) {
								return langue.vx !== 'fr';
							},
							$author$project$Referentiel$Langues$desLibelles))),
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('traduire'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Parametrage$PipeEtape2$Update$TraductionDemandee(champ))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape2Traduire(i18n))
						]))
				]));
	});
var $author$project$Components$Parametrage$Common$Conception$champDeTexte = F3(
	function (libelle, valeur, surSaisie) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('champ')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(valeur),
							$rtfeldman$elm_css$Html$Styled$Events$onInput(surSaisie)
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$Parametrage$PipeEtape2$View$libelleParDefaut = F2(
	function (_v0, _v1) {
		return '';
	});
var $author$project$I18n$Cles$pipeEtape2SortantsAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.sortants.aucun', _List_Nil, 'Aucun passage ne part de cette étape.');
};
var $author$project$I18n$Cles$pipeEtape2SortantsLigne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.sortants.ligne',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'ordre',
					$author$project$I18n$Traductions$Chaine(p.El)),
					_Utils_Tuple2(
					'vers',
					$author$project$I18n$Traductions$Chaine(p.sn))
				]),
			p.El + (' · ' + p.sn));
	});
var $author$project$I18n$Cles$pipeEtape2SortantsModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.sortants.modifier', _List_Nil, 'Modifier');
};
var $author$project$I18n$Cles$pipeEtape2SortantsParDefaut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.sortants.par-defaut', _List_Nil, 'Par défaut');
};
var $author$project$Components$Parametrage$PipeEtape2$View$passagesSortants = F3(
	function (i18n, parcours, saisie) {
		return $elm$core$List$isEmpty(saisie.pc) ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$pipeEtape2SortantsAucun(i18n))
					]))
			]) : _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$ul,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('lignes')
					]),
				A2(
					$elm$core$List$map,
					function (sortant) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Parametrage$PipeEtape2$Update$PassageDemande(sortant.r8))
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('textes')
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															A2(
																$author$project$I18n$Cles$pipeEtape2SortantsLigne,
																i18n,
																{
																	El: $elm$core$String$fromInt(sortant.El),
																	sn: sortant.sn.Bl
																}))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															A2(
																$elm$core$Maybe$withDefault,
																A2($author$project$Components$Parametrage$PipeEtape2$View$libelleParDefaut, parcours, sortant.r8),
																A2($elm$core$Dict$get, 'fr', sortant.Bl)))
														]))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('etiquettes')
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('etiquette'),
															$rtfeldman$elm_css$Html$Styled$Attributes$classList(
															_List_fromArray(
																[
																	_Utils_Tuple2('vert', sortant.o6),
																	_Utils_Tuple2('accent', !sortant.o6)
																]))
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															sortant.o6 ? $author$project$I18n$Cles$pipeEtape2SortantsParDefaut(i18n) : $author$project$I18n$Cles$pipeEtape2SortantsModifier(i18n))
														]))
												]))
										]))
								]));
					},
					saisie.pc))
			]);
	});
var $author$project$I18n$Cles$pipeEtape2ButLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.but.libelle', _List_Nil, 'Ce qu\'on y fait');
};
var $author$project$I18n$Cles$pipeEtape2ButTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.but.titre', _List_Nil, 'But et délai');
};
var $author$project$I18n$Cles$pipeEtape2DelaiLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.delai.libelle', _List_Nil, 'Délai attendu (jours)');
};
var $author$project$I18n$Cles$pipeEtape2FinFinale = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.fin.finale', _List_Nil, 'Cette étape est finale');
};
var $author$project$I18n$Cles$pipeEtape2FinFinaleAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.fin.finale-aide', _List_Nil, 'Un dossier arrivé ici est terminé.');
};
var $author$project$I18n$Cles$pipeEtape2FinResultat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.fin.resultat', _List_Nil, 'Résultat de la fin (si finale)');
};
var $author$project$I18n$Cles$pipeEtape2FinResultatAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.fin.resultat-aide', _List_Nil, 'Le résultat ne sert que si la case est cochée.');
};
var $author$project$I18n$Cles$pipeEtape2FinTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.fin.titre', _List_Nil, 'Fin du pipe');
};
var $author$project$I18n$Cles$pipeEtape2NomLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.nom.libelle', _List_Nil, 'Nom de l\'étape');
};
var $author$project$I18n$Cles$pipeEtape2NomTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.nom.titre', _List_Nil, 'Nom');
};
var $author$project$I18n$Cles$pipeEtape2PortailAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.portail.aide', _List_Nil, 'Laissé vide, le portail montre le nom de l\'étape. Deux étapes qui se suivent avec le même libellé n\'en font qu\'une pour le licencié.');
};
var $author$project$I18n$Cles$pipeEtape2PortailApercu = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.portail.apercu',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			'Sur le portail, la personne concernée voit : ' + (p.Bl + '. Un intervenant lié au dossier voit le même libellé, s\'il a accès à l\'étape.'));
	});
var $author$project$I18n$Cles$pipeEtape2PortailLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.portail.libelle', _List_Nil, 'Libellé sur le portail');
};
var $author$project$I18n$Cles$pipeEtape2PortailTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.portail.titre', _List_Nil, 'Ce que voient les rôles externes');
};
var $author$project$I18n$Cles$pipeEtape2PortailUnSeul = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.portail.un-seul', _List_Nil, 'Un seul libellé public par étape, remplaçable pour un rôle (par exemple Producteur ou Gestionnaire des licences).');
};
var $author$project$I18n$Cles$pipeEtape2PortailVisible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.portail.visible', _List_Nil, 'Cette étape apparaît sur le portail');
};
var $author$project$I18n$Cles$pipeEtape2SortantsAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.sortants.aide', _List_Nil, 'Dans cet ordre : le premier dont la condition est vraie l\'emporte.');
};
var $author$project$I18n$Cles$pipeEtape2SortantsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.sortants.titre', _List_Nil, 'Passages sortants');
};
var $author$project$Components$Parametrage$PipeEtape2$View$contenuDeLEtape = F3(
	function (i18n, parcours, saisie) {
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape2NomTitre(i18n),
				_List_fromArray(
					[
						A3(
						$author$project$Components$Parametrage$Common$Conception$champDeTexte,
						$author$project$I18n$Cles$pipeEtape2NomLibelle(i18n),
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Dict$get, 'fr', saisie.R)),
						A2($author$project$Components$Parametrage$PipeEtape2$Update$LibelleSaisi, 0, 'fr')),
						A3($author$project$Components$Parametrage$PipeEtape2$View$carteDeTraduction, i18n, 0, saisie.R)
					])),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape2ButTitre(i18n),
				_List_fromArray(
					[
						A3(
						$author$project$Components$Parametrage$Common$Conception$champDeTexte,
						$author$project$I18n$Cles$pipeEtape2ButLibelle(i18n),
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Dict$get, 'fr', saisie.uy)),
						A2($author$project$Components$Parametrage$PipeEtape2$Update$LibelleSaisi, 1, 'fr')),
						A3(
						$author$project$Components$Parametrage$Common$Conception$champDeTexte,
						$author$project$I18n$Cles$pipeEtape2DelaiLibelle(i18n),
						saisie.w2,
						$author$project$Components$Parametrage$PipeEtape2$Update$DelaiSaisi)
					])),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape2PortailTitre(i18n),
				_List_fromArray(
					[
						A3(
						$author$project$Components$Parametrage$Common$Conception$champDeTexte,
						$author$project$I18n$Cles$pipeEtape2PortailLibelle(i18n),
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Dict$get, 'fr', saisie.pr)),
						A2($author$project$Components$Parametrage$PipeEtape2$Update$LibelleSaisi, 2, 'fr')),
						A3($author$project$Components$Parametrage$PipeEtape2$View$carteDeTraduction, i18n, 1, saisie.pr),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape2PortailAide(i18n))
							])),
						A5(
						$author$project$Components$Parametrage$Common$Conception$caseACocher,
						'portail',
						saisie.ps,
						$author$project$I18n$Cles$pipeEtape2PortailVisible(i18n),
						'',
						$author$project$Components$Parametrage$PipeEtape2$Update$PortailBascule),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu-du-portail')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$pipeEtape2PortailApercu,
									i18n,
									{
										Bl: A2(
											$elm$core$Maybe$withDefault,
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2($elm$core$Dict$get, 'fr', saisie.R)),
											A2(
												$elm$core$Maybe$andThen,
												function (texte) {
													return (texte === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(texte);
												},
												A2($elm$core$Dict$get, 'fr', saisie.pr)))
									}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape2PortailUnSeul(i18n))
							]))
					])),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape2SortantsTitre(i18n),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape2SortantsAide(i18n))
							])),
					_Utils_ap(
						A3($author$project$Components$Parametrage$PipeEtape2$View$passagesSortants, i18n, parcours, saisie),
						A2($author$project$Components$Parametrage$PipeEtape2$View$ajoutDePassage, i18n, saisie)))),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape2FinTitre(i18n),
				_List_fromArray(
					[
						A5(
						$author$project$Components$Parametrage$Common$Conception$caseACocher,
						'finale',
						saisie.mK,
						$author$project$I18n$Cles$pipeEtape2FinFinale(i18n),
						$author$project$I18n$Cles$pipeEtape2FinFinaleAide(i18n),
						$author$project$Components$Parametrage$PipeEtape2$Update$FinaleBascule),
						A4(
						$author$project$Components$Parametrage$Common$Conception$liste,
						$author$project$I18n$Cles$pipeEtape2FinResultat(i18n),
						saisie.HW,
						A2(
							$elm$core$List$map,
							function (code) {
								return _Utils_Tuple2(
									code,
									A2($author$project$Components$Parametrage$Vocabulaire$resultatDeFin, i18n, code));
							},
							saisie.qG),
						$author$project$Components$Parametrage$PipeEtape2$Update$ResultatChoisi),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape2FinResultatAide(i18n))
							]))
					]))
			]);
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$DePassageChoisi = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Parametrage$PipeEtape2$Update$ModeChoisi = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Parametrage$PipeEtape2$Update$NomDuPassage = 3;
var $author$project$Components$Parametrage$PipeEtape2$Update$VersPassageChoisi = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Parametrage$PipeEtape2$Phrases$nomDe = function (lu) {
	var _v0 = lu.m$;
	if (!_v0.$) {
		return A2($elm$core$Maybe$withDefault, lu.Bl, lu.Dl);
	} else {
		return lu.Bl;
	}
};
var $author$project$Components$Parametrage$PipeEtape2$Phrases$avecArticleDuRole = function (role) {
	var _v0 = role.ud;
	if (!_v0.$) {
		var servi = _v0.a;
		return $author$project$Components$Parametrage$PipeEtape2$Phrases$lowerFirst(servi);
	} else {
		return role.D_ ? A2(
			$author$project$Catalogue$Formes$avecArticle,
			role.m$,
			$author$project$Components$Parametrage$PipeEtape2$Phrases$nomDe(role)) : A2(
			$author$project$Catalogue$Formes$avecUn,
			role.m$,
			$author$project$Components$Parametrage$PipeEtape2$Phrases$nomDe(role));
	}
};
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$liaisonDe = function (code) {
	return (code === 'ou') ? 1 : 0;
};
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$modeDe = function (code) {
	switch (code) {
		case 'si':
			return 1;
		case 'sinon':
			return 2;
		default:
			return 0;
	}
};
var $author$project$Components$Parametrage$PipeEtape2$Phrases$conditionDe = function (saisie) {
	return {
		Bk: $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$liaisonDe(saisie.Bk),
		n9: $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$modeDe(saisie.n9),
		rD: A2(
			$elm$core$List$map,
			function (t) {
				return {
					vP: t.vP,
					wg: $author$project$Components$Parametrage$PipeEtape2$Model$champOptionnel(t.wg),
					I9: t.I9,
					fm: t.fm
				};
			},
			saisie.rD)
	};
};
var $author$project$Components$Parametrage$PipeEtape2$Phrases$debutDeFort = '\uE000';
var $author$project$Components$Parametrage$PipeEtape2$Phrases$finDeFort = '\uE001';
var $author$project$Components$Parametrage$PipeEtape2$Phrases$enGras = function (texte) {
	return _Utils_ap(
		$author$project$Components$Parametrage$PipeEtape2$Phrases$debutDeFort,
		_Utils_ap(texte, $author$project$Components$Parametrage$PipeEtape2$Phrases$finDeFort));
};
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$FaconAutomatique = 0;
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$FaconCalculeSla = 2;
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$FaconParLeRegroupement = 3;
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$FaconParUnRole = 1;
var $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$faconDe = function (code) {
	switch (code) {
		case 'par-un-role':
			return 1;
		case 'calcule-sla':
			return 2;
		case 'par-le-regroupement':
			return 3;
		default:
			return 0;
	}
};
var $author$project$I18n$Cles$pipeEtape2ApercupQuiAutomatique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.apercup.qui-automatique', _List_Nil, 'tout seul');
};
var $author$project$I18n$Cles$pipeEtape2ApercupQuiCalculeSla = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.apercup.qui-calcule-sla',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'jours',
					$author$project$I18n$Traductions$Entier(p.ni))
				]),
			((!p.ni) || (p.ni === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.ni) + ' jour après son arrivée à l\'étape') : (A2($author$project$I18n$Nombre$formater, 0, p.ni) + ' jours après son arrivée à l\'étape'));
	});
var $author$project$I18n$Cles$pipeEtape2ApercupQuiParLeRegroupement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.apercup.qui-par-le-regroupement', _List_Nil, 'avec la campagne');
};
var $author$project$I18n$Cles$pipeEtape2ApercupQuiParUnRole = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.apercup.qui-par-un-role',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'quand ' + (p.bi + ' le fait avancer'));
	});
var $author$project$I18n$Cles$pipeEtape2ApercupSi = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.apercup.si',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'quand',
					$author$project$I18n$Traductions$Chaine(p.hz)),
					_Utils_Tuple2(
					'termine',
					$author$project$I18n$Traductions$Chaine(p.Jt)),
					_Utils_Tuple2(
					'condition',
					$author$project$I18n$Traductions$Chaine(p.j4)),
					_Utils_Tuple2(
					'origine',
					$author$project$I18n$Traductions$Chaine(p.o4)),
					_Utils_Tuple2(
					'vers',
					$author$project$I18n$Traductions$Chaine(p.sn)),
					_Utils_Tuple2(
					'qui',
					$author$project$I18n$Traductions$Chaine(p.GK))
				]),
			'Quand ' + (p.hz + (' est ' + (p.Jt + (', ' + (p.j4 + (', le dossier passe de ' + (p.o4 + (' à ' + (p.sn + (', ' + (p.GK + '.'))))))))))));
	});
var $author$project$I18n$Cles$pipeEtape2ApercupSinon = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.apercup.sinon',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'quand',
					$author$project$I18n$Traductions$Chaine(p.hz)),
					_Utils_Tuple2(
					'termine',
					$author$project$I18n$Traductions$Chaine(p.Jt)),
					_Utils_Tuple2(
					'origine',
					$author$project$I18n$Traductions$Chaine(p.o4)),
					_Utils_Tuple2(
					'vers',
					$author$project$I18n$Traductions$Chaine(p.sn)),
					_Utils_Tuple2(
					'qui',
					$author$project$I18n$Traductions$Chaine(p.GK))
				]),
			'Quand ' + (p.hz + (' est ' + (p.Jt + (' et qu\'aucun autre passage ne convient, le dossier passe de ' + (p.o4 + (' à ' + (p.sn + (', ' + (p.GK + '.'))))))))));
	});
var $author$project$I18n$Cles$pipeEtape2ApercupTermineFeminin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.apercup.termine-feminin', _List_Nil, 'terminée');
};
var $author$project$I18n$Cles$pipeEtape2ApercupTermineMasculin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.apercup.termine-masculin', _List_Nil, 'terminé');
};
var $author$project$I18n$Cles$pipeEtape2ApercupToujours = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.apercup.toujours',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'quand',
					$author$project$I18n$Traductions$Chaine(p.hz)),
					_Utils_Tuple2(
					'termine',
					$author$project$I18n$Traductions$Chaine(p.Jt)),
					_Utils_Tuple2(
					'origine',
					$author$project$I18n$Traductions$Chaine(p.o4)),
					_Utils_Tuple2(
					'vers',
					$author$project$I18n$Traductions$Chaine(p.sn)),
					_Utils_Tuple2(
					'qui',
					$author$project$I18n$Traductions$Chaine(p.GK))
				]),
			'Quand ' + (p.hz + (' est ' + (p.Jt + (', le dossier passe de ' + (p.o4 + (' à ' + (p.sn + (', ' + (p.GK + '.'))))))))));
	});
var $author$project$Components$Parametrage$PipeEtape2$Phrases$segments = function (texte) {
	return A2(
		$elm$core$List$filter,
		function (segment) {
			return segment.Jx !== '';
		},
		$elm$core$List$concat(
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (rang, morceau) {
						var _v0 = _Utils_Tuple2(
							rang,
							A2($elm$core$String$split, $author$project$Components$Parametrage$PipeEtape2$Phrases$finDeFort, morceau));
						if (!_v0.a) {
							return _List_fromArray(
								[
									{dX: false, Jx: morceau}
								]);
						} else {
							if ((_v0.b.b && _v0.b.b.b) && (!_v0.b.b.b.b)) {
								var _v1 = _v0.b;
								var gras = _v1.a;
								var _v2 = _v1.b;
								var reste = _v2.a;
								return _List_fromArray(
									[
										{dX: true, Jx: gras},
										{dX: false, Jx: reste}
									]);
							} else {
								return _List_fromArray(
									[
										{dX: false, Jx: morceau}
									]);
							}
						}
					}),
				A2($elm$core$String$split, $author$project$Components$Parametrage$PipeEtape2$Phrases$debutDeFort, texte))));
};
var $author$project$Components$Parametrage$PipeEtape2$Phrases$apercuDuPassage = F3(
	function (i18n, options, saisie) {
		var role = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$Parametrage$PipeEtape2$Phrases$avecArticleDuRole,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (lu) {
							return _Utils_eq(lu.r8, saisie.H6);
						},
						options.H9))));
		var qui = function () {
			var _v3 = $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$faconDe(saisie.kw);
			switch (_v3) {
				case 1:
					return A2(
						$author$project$I18n$Cles$pipeEtape2ApercupQuiParUnRole,
						i18n,
						{bi: role});
				case 2:
					return A2(
						$author$project$I18n$Cles$pipeEtape2ApercupQuiCalculeSla,
						i18n,
						{
							ni: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(saisie.ni))
						});
				case 3:
					return $author$project$I18n$Cles$pipeEtape2ApercupQuiParLeRegroupement(i18n);
				default:
					return $author$project$I18n$Cles$pipeEtape2ApercupQuiAutomatique(i18n);
			}
		}();
		var etape = function (uid) {
			return $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (lue) {
						return _Utils_eq(lue.r8, uid);
					},
					options.yL));
		};
		var nom = function (uid) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Bl;
					},
					etape(uid)));
		};
		var vers = $author$project$Components$Parametrage$PipeEtape2$Phrases$enGras(
			nom(saisie.sn));
		var quand = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (lue) {
					return A2(
						$author$project$Catalogue$Formes$avecArticle,
						lue.m$,
						$author$project$Components$Parametrage$PipeEtape2$Phrases$nomDe(lue));
				},
				etape(saisie.wC)));
		var termine = function () {
			var _v1 = A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.zX;
					},
					function ($) {
						return $.M;
					}),
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.m$;
					},
					etape(saisie.wC)));
			if ((!_v1.$) && (!_v1.a)) {
				var _v2 = _v1.a;
				return $author$project$I18n$Cles$pipeEtape2ApercupTermineMasculin(i18n);
			} else {
				return $author$project$I18n$Cles$pipeEtape2ApercupTermineFeminin(i18n);
			}
		}();
		var de = $author$project$Components$Parametrage$PipeEtape2$Phrases$enGras(
			nom(saisie.wC));
		return $author$project$Components$Parametrage$PipeEtape2$Phrases$segments(
			function () {
				var _v0 = $author$project$Components$Parametrage$PipeEtape2$API$QueryAPIModel$modeDe(saisie.n9);
				switch (_v0) {
					case 1:
						return A2(
							$author$project$I18n$Cles$pipeEtape2ApercupSi,
							i18n,
							{
								j4: $author$project$Components$Parametrage$PipeEtape2$Phrases$enGras(
									$author$project$Components$Parametrage$PipeEtape2$Phrases$lowerFirst(
										A3(
											$author$project$Components$Parametrage$PipeEtape2$Phrases$condition,
											i18n,
											options,
											$author$project$Components$Parametrage$PipeEtape2$Phrases$conditionDe(saisie)))),
								o4: de,
								hz: quand,
								GK: qui,
								Jt: termine,
								sn: vers
							});
					case 2:
						return A2(
							$author$project$I18n$Cles$pipeEtape2ApercupSinon,
							i18n,
							{o4: de, hz: quand, GK: qui, Jt: termine, sn: vers});
					default:
						return A2(
							$author$project$I18n$Cles$pipeEtape2ApercupToujours,
							i18n,
							{o4: de, hz: quand, GK: qui, Jt: termine, sn: vers});
				}
			}());
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$LiaisonChoisie = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Parametrage$PipeEtape2$Update$TermeAjoute = {$: 21};
var $author$project$I18n$Cles$pipeEtape2CondAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.cond.aide', _List_Nil, 'Pour plusieurs conditions, ajoutez-en une et choisissez « et » ou « ou ».');
};
var $author$project$I18n$Cles$pipeEtape2CondAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.cond.ajouter', _List_Nil, 'Ajouter : Condition');
};
var $author$project$I18n$Cles$pipeEtape2CondLiaison = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.cond.liaison', _List_Nil, 'Les conditions sont liées par');
};
var $author$project$Components$Parametrage$PipeEtape2$Update$Comparaison = 1;
var $author$project$Components$Parametrage$PipeEtape2$Update$Sujet = 0;
var $author$project$Components$Parametrage$PipeEtape2$Update$TermeModifie = F3(
	function (a, b, c) {
		return {$: 20, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$TermeRetire = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Parametrage$PipeEtape2$Update$Echelle = 3;
var $author$project$Components$Parametrage$PipeEtape2$Update$Valeur = 2;
var $author$project$I18n$Cles$pipeEtape2CondEchelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.cond.echelle', _List_Nil, 'Valeur dans');
};
var $author$project$I18n$Cles$pipeEtape2CondEchelleListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.cond.echelle-liste', _List_Nil, 'La liste du champ');
};
var $author$project$I18n$Cles$pipeEtape2CondValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.cond.valeur', _List_Nil, 'Valeur');
};
var $author$project$Components$Parametrage$PipeEtape2$View$echelleEtValeur = F4(
	function (i18n, options, position, lu) {
		var correspondances = A2(
			$elm$core$List$concatMap,
			function ($) {
				return $.wh;
			},
			A2(
				$elm$core$List$filter,
				function (sujet) {
					return _Utils_eq(sujet.vx, lu.I9) && (sujet.M === 'choix');
				},
				options.Ja));
		var choisie = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (c) {
					return _Utils_eq(c.Aq, lu.wg);
				},
				correspondances));
		return $author$project$Components$Parametrage$PipeEtape2$Model$sansValeur(lu.vP) ? $rtfeldman$elm_css$Html$Styled$text('') : ($elm$core$List$isEmpty(correspondances) ? A3(
			$author$project$Components$Parametrage$Common$Conception$champDeTexte,
			$author$project$I18n$Cles$pipeEtape2CondValeur(i18n),
			lu.fm,
			A2($author$project$Components$Parametrage$PipeEtape2$Update$TermeModifie, position, 2)) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('echelle-et-valeur')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A4(
						$author$project$Components$Parametrage$Common$Conception$liste,
						$author$project$I18n$Cles$pipeEtape2CondEchelle(i18n),
						lu.wg,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'',
								$author$project$I18n$Cles$pipeEtape2CondEchelleListe(i18n)),
							A2(
								$elm$core$List$map,
								function (c) {
									return _Utils_Tuple2(c.Aq, c.vf);
								},
								correspondances)),
						A2($author$project$Components$Parametrage$PipeEtape2$Update$TermeModifie, position, 3))
					]),
				function () {
					if (!choisie.$) {
						var c = choisie.a;
						return _List_fromArray(
							[
								A4(
								$author$project$Components$Parametrage$Common$Conception$liste,
								$author$project$I18n$Cles$pipeEtape2CondValeur(i18n),
								lu.fm,
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2('', '—'),
									A2(
										$elm$core$List$map,
										function (v) {
											return _Utils_Tuple2(v.Aq, v.Bl);
										},
										c.Ki)),
								A2($author$project$Components$Parametrage$PipeEtape2$Update$TermeModifie, position, 2))
							]);
					} else {
						return _List_fromArray(
							[
								A3(
								$author$project$Components$Parametrage$Common$Conception$champDeTexte,
								$author$project$I18n$Cles$pipeEtape2CondValeur(i18n),
								lu.fm,
								A2($author$project$Components$Parametrage$PipeEtape2$Update$TermeModifie, position, 2))
							]);
					}
				}())));
	});
var $author$project$I18n$Cles$pipeEtape2CondComparaison = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.cond.comparaison', _List_Nil, 'Comparaison');
};
var $author$project$I18n$Cles$pipeEtape2CondRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.cond.retirer', _List_Nil, 'Retirer la condition');
};
var $author$project$I18n$Cles$pipeEtape2CondSujet = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.cond.sujet', _List_Nil, 'Ce qu\'on regarde');
};
var $author$project$Components$Parametrage$PipeEtape2$View$terme = F5(
	function (i18n, options, retirable, position, lu) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('terme')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$Components$Parametrage$Common$Conception$liste,
					$author$project$I18n$Cles$pipeEtape2CondSujet(i18n),
					lu.I9,
					A2(
						$elm$core$List$map,
						function (sujet) {
							return _Utils_Tuple2(sujet.vx, sujet.Bl);
						},
						options.Ja),
					A2($author$project$Components$Parametrage$PipeEtape2$Update$TermeModifie, position, 0)),
					A4(
					$author$project$Components$Parametrage$Common$Conception$liste,
					$author$project$I18n$Cles$pipeEtape2CondComparaison(i18n),
					lu.vP,
					A2(
						$elm$core$List$map,
						function (code) {
							return _Utils_Tuple2(
								code,
								A2($author$project$Components$Parametrage$Vocabulaire$comparaison, i18n, code));
						},
						options.vQ),
					A2($author$project$Components$Parametrage$PipeEtape2$Update$TermeModifie, position, 1)),
					A4($author$project$Components$Parametrage$PipeEtape2$View$echelleEtValeur, i18n, options, position, lu),
					retirable ? A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Parametrage$PipeEtape2$Update$TermeRetire(position))
						]),
					$author$project$I18n$Cles$pipeEtape2CondRetirer(i18n)) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$Components$Parametrage$PipeEtape2$View$condition = F3(
	function (i18n, options, saisie) {
		return (saisie.n9 !== 'si') ? _List_Nil : _Utils_ap(
			A2(
				$elm$core$List$indexedMap,
				A3(
					$author$project$Components$Parametrage$PipeEtape2$View$terme,
					i18n,
					options,
					$elm$core$List$length(saisie.rD) > 1),
				saisie.rD),
			_List_fromArray(
				[
					($elm$core$List$length(saisie.rD) > 1) ? A4(
					$author$project$Components$Parametrage$Common$Conception$liste,
					$author$project$I18n$Cles$pipeEtape2CondLiaison(i18n),
					saisie.Bk,
					_List_fromArray(
						[
							_Utils_Tuple2(
							'et',
							$author$project$I18n$Cles$pipeEtape2LiaisonEt(i18n)),
							_Utils_Tuple2(
							'ou',
							$author$project$I18n$Cles$pipeEtape2LiaisonOu(i18n))
						]),
					$author$project$Components$Parametrage$PipeEtape2$Update$LiaisonChoisie) : $rtfeldman$elm_css$Html$Styled$text(''),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape2CondAide(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape2$Update$TermeAjoute)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape2CondAjouter(i18n))
						]))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$DeclenchementChoisi = F2(
	function (a, b) {
		return {$: 23, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$JoursSaisis = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$Parametrage$PipeEtape2$Phrases$libelleDuRole = function (role) {
	var _v0 = role.ud;
	if (!_v0.$) {
		var servi = _v0.a;
		return servi;
	} else {
		return $author$project$Components$Parametrage$PipeEtape2$Phrases$upperFirst(
			$author$project$Components$Parametrage$PipeEtape2$Phrases$avecArticleDuRole(role));
	}
};
var $author$project$I18n$Cles$pipeEtape2QuiAutomatique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.qui.automatique', _List_Nil, 'Le dossier, tout seul');
};
var $author$project$I18n$Cles$pipeEtape2QuiAutomatiqueAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.qui.automatique-aide', _List_Nil, 'Dès que la condition est vraie.');
};
var $author$project$I18n$Cles$pipeEtape2QuiCalculeSla = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.qui.calcule-sla', _List_Nil, 'Une échéance');
};
var $author$project$I18n$Cles$pipeEtape2QuiCalculeSlaAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.qui.calcule-sla-aide', _List_Nil, 'Après un délai, à compter de l\'arrivée à l\'étape.');
};
var $author$project$I18n$Cles$pipeEtape2QuiJours = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.qui.jours', _List_Nil, 'Délai (jours)');
};
var $author$project$I18n$Cles$pipeEtape2QuiParLeRegroupement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.qui.par-le-regroupement', _List_Nil, 'La campagne');
};
var $author$project$I18n$Cles$pipeEtape2QuiParLeRegroupementAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.qui.par-le-regroupement-aide', _List_Nil, 'Le passage suit une action de la campagne.');
};
var $author$project$I18n$Cles$pipeEtape2QuiParUnRoleAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.qui.par-un-role-aide', _List_Nil, 'Il clique « Faire avancer » et peut donner un motif.');
};
var $author$project$I18n$Cles$pipeEtape2QuiParUnRoleObjetViseAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.qui.par-un-role-objet-vise-aide', _List_Nil, 'Depuis son portail, par exemple pour accepter l\'offre.');
};
var $author$project$Components$Parametrage$PipeEtape2$View$declencheurs = F3(
	function (i18n, options, saisie) {
		return $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						A6(
						$author$project$Components$Parametrage$Common$Conception$choix,
						'qui',
						'automatique',
						saisie.kw === 'automatique',
						$author$project$I18n$Cles$pipeEtape2QuiAutomatique(i18n),
						$author$project$I18n$Cles$pipeEtape2QuiAutomatiqueAide(i18n),
						A2($author$project$Components$Parametrage$PipeEtape2$Update$DeclenchementChoisi, 'automatique', ''))
					]),
					A2($elm$core$List$member, 'par-un-role', options.wP) ? A2(
					$elm$core$List$map,
					function (role) {
						return A6(
							$author$project$Components$Parametrage$Common$Conception$choix,
							'qui',
							role.r8,
							(saisie.kw === 'par-un-role') && _Utils_eq(saisie.H6, role.r8),
							$author$project$Components$Parametrage$PipeEtape2$Phrases$libelleDuRole(role),
							A2(
								$elm$core$Maybe$withDefault,
								role.D_ ? $author$project$I18n$Cles$pipeEtape2QuiParUnRoleObjetViseAide(i18n) : $author$project$I18n$Cles$pipeEtape2QuiParUnRoleAide(i18n),
								role.bp),
							A2($author$project$Components$Parametrage$PipeEtape2$Update$DeclenchementChoisi, 'par-un-role', role.r8));
					},
					options.H9) : _List_Nil,
					A2($elm$core$List$member, 'calcule-sla', options.wP) ? _Utils_ap(
					_List_fromArray(
						[
							A6(
							$author$project$Components$Parametrage$Common$Conception$choix,
							'qui',
							'calcule-sla',
							saisie.kw === 'calcule-sla',
							$author$project$I18n$Cles$pipeEtape2QuiCalculeSla(i18n),
							$author$project$I18n$Cles$pipeEtape2QuiCalculeSlaAide(i18n),
							A2($author$project$Components$Parametrage$PipeEtape2$Update$DeclenchementChoisi, 'calcule-sla', ''))
						]),
					(saisie.kw === 'calcule-sla') ? _List_fromArray(
						[
							A3(
							$author$project$Components$Parametrage$Common$Conception$champDeTexte,
							$author$project$I18n$Cles$pipeEtape2QuiJours(i18n),
							saisie.ni,
							$author$project$Components$Parametrage$PipeEtape2$Update$JoursSaisis)
						]) : _List_Nil) : _List_Nil,
					(saisie.kw === 'par-le-regroupement') ? _List_fromArray(
					[
						A6(
						$author$project$Components$Parametrage$Common$Conception$choix,
						'qui',
						'par-le-regroupement',
						true,
						$author$project$I18n$Cles$pipeEtape2QuiParLeRegroupement(i18n),
						$author$project$I18n$Cles$pipeEtape2QuiParLeRegroupementAide(i18n),
						A2($author$project$Components$Parametrage$PipeEtape2$Update$DeclenchementChoisi, 'par-le-regroupement', ''))
					]) : _List_Nil
				]));
	});
var $author$project$I18n$Cles$pipeEtape2ApercupTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.apercup.titre', _List_Nil, 'Aperçu');
};
var $author$project$I18n$Cles$pipeEtape2CondTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.cond.titre', _List_Nil, 'La condition');
};
var $author$project$I18n$Cles$pipeEtape2DeVersDe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.de-vers.de', _List_Nil, 'De');
};
var $author$project$I18n$Cles$pipeEtape2DeVersRetour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.de-vers.retour', _List_Nil, 'Un passage peut aussi revenir en arrière : les données déjà saisies sont gardées.');
};
var $author$project$I18n$Cles$pipeEtape2DeVersTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.de-vers.titre', _List_Nil, 'De quelle étape à laquelle ?');
};
var $author$project$I18n$Cles$pipeEtape2DeVersVers = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.de-vers.vers', _List_Nil, 'Vers');
};
var $author$project$I18n$Cles$pipeEtape2NompAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.nomp.aide', _List_Nil, 'Affiché dans la liste des passages. Laissé vide, il est composé depuis la condition.');
};
var $author$project$I18n$Cles$pipeEtape2NompLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.nomp.libelle', _List_Nil, 'Nom du passage (facultatif)');
};
var $author$project$I18n$Cles$pipeEtape2NompTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.nomp.titre', _List_Nil, 'Nom du passage');
};
var $author$project$I18n$Cles$pipeEtape2QuandSi = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.quand.si', _List_Nil, 'Si une condition est vraie');
};
var $author$project$I18n$Cles$pipeEtape2QuandSiAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.quand.si-aide', _List_Nil, 'Vous la composez ci-dessous.');
};
var $author$project$I18n$Cles$pipeEtape2QuandSinon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.quand.sinon', _List_Nil, 'Sinon');
};
var $author$project$I18n$Cles$pipeEtape2QuandSinonAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.quand.sinon-aide', _List_Nil, 'Passage par défaut : pris quand aucun autre ne convient.');
};
var $author$project$I18n$Cles$pipeEtape2QuandTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.quand.titre', _List_Nil, 'Quand ?');
};
var $author$project$I18n$Cles$pipeEtape2QuandToujours = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.quand.toujours', _List_Nil, 'Toujours');
};
var $author$project$I18n$Cles$pipeEtape2QuandToujoursAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.quand.toujours-aide', _List_Nil, 'Dès que l\'étape est terminée.');
};
var $author$project$I18n$Cles$pipeEtape2QuiTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.qui.titre', _List_Nil, 'Qui le déclenche ?');
};
var $author$project$Components$Parametrage$PipeEtape2$View$contenuDuPassage = F3(
	function (i18n, options, saisie) {
		var etapesChoisies = A2(
			$elm$core$List$map,
			function (etape_) {
				return _Utils_Tuple2(etape_.r8, etape_.Bl);
			},
			options.yL);
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape2DeVersTitre(i18n),
				_List_fromArray(
					[
						A4(
						$author$project$Components$Parametrage$Common$Conception$liste,
						$author$project$I18n$Cles$pipeEtape2DeVersDe(i18n),
						saisie.wC,
						etapesChoisies,
						$author$project$Components$Parametrage$PipeEtape2$Update$DePassageChoisi),
						A4(
						$author$project$Components$Parametrage$Common$Conception$liste,
						$author$project$I18n$Cles$pipeEtape2DeVersVers(i18n),
						saisie.sn,
						etapesChoisies,
						$author$project$Components$Parametrage$PipeEtape2$Update$VersPassageChoisi),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape2DeVersRetour(i18n))
							]))
					])),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape2NompTitre(i18n),
				_List_fromArray(
					[
						A3(
						$author$project$Components$Parametrage$Common$Conception$champDeTexte,
						$author$project$I18n$Cles$pipeEtape2NompLibelle(i18n),
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Dict$get, 'fr', saisie.Bl)),
						A2($author$project$Components$Parametrage$PipeEtape2$Update$LibelleSaisi, 3, 'fr')),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape2NompAide(i18n))
							]))
					])),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape2QuandTitre(i18n),
				_List_fromArray(
					[
						A6(
						$author$project$Components$Parametrage$Common$Conception$choix,
						'quand',
						'toujours',
						saisie.n9 === 'toujours',
						$author$project$I18n$Cles$pipeEtape2QuandToujours(i18n),
						$author$project$I18n$Cles$pipeEtape2QuandToujoursAide(i18n),
						$author$project$Components$Parametrage$PipeEtape2$Update$ModeChoisi('toujours')),
						A6(
						$author$project$Components$Parametrage$Common$Conception$choix,
						'quand',
						'si',
						saisie.n9 === 'si',
						$author$project$I18n$Cles$pipeEtape2QuandSi(i18n),
						$author$project$I18n$Cles$pipeEtape2QuandSiAide(i18n),
						$author$project$Components$Parametrage$PipeEtape2$Update$ModeChoisi('si')),
						A6(
						$author$project$Components$Parametrage$Common$Conception$choix,
						'quand',
						'sinon',
						saisie.n9 === 'sinon',
						$author$project$I18n$Cles$pipeEtape2QuandSinon(i18n),
						$author$project$I18n$Cles$pipeEtape2QuandSinonAide(i18n),
						$author$project$Components$Parametrage$PipeEtape2$Update$ModeChoisi('sinon'))
					])),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape2CondTitre(i18n),
				A3($author$project$Components$Parametrage$PipeEtape2$View$condition, i18n, options, saisie)),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape2QuiTitre(i18n),
				A3($author$project$Components$Parametrage$PipeEtape2$View$declencheurs, i18n, options, saisie)),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape2ApercupTitre(i18n),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu-du-passage')
							]),
						A2(
							$elm$core$List$map,
							function (segment) {
								return segment.dX ? A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(segment.Jx)
										])) : $rtfeldman$elm_css$Html$Styled$text(segment.Jx);
							},
							A3($author$project$Components$Parametrage$PipeEtape2$Phrases$apercuDuPassage, i18n, options, saisie)))
					]))
			]);
	});
var $author$project$Components$Parametrage$PipeEtape2$View$nomEnregistre = F2(
	function (parcours, saisie) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Dict$get, 'fr', saisie.R)),
			A2(
				$elm$core$Maybe$map,
				function (lue) {
					return $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(lue.R);
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (lue) {
							return _Utils_eq(
								$elm$core$Maybe$Just(lue.r8),
								saisie.r8);
						},
						parcours.yL))));
	});
var $author$project$I18n$Cles$pipeEtape2DrawerEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.drawer.enregistrer', _List_Nil, 'Enregistrer l\'étape');
};
var $author$project$I18n$Cles$pipeEtape2DrawerKicker = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.drawer.kicker', _List_Nil, 'Étape');
};
var $author$project$I18n$Cles$pipeEtape2DrawerTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.drawer.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Étape « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$pipeEtape2DrawerTitreAjout = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.drawer.titre-ajout', _List_Nil, 'Nouvelle étape');
};
var $author$project$I18n$Cles$pipeEtape2PassageEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.passage.enregistrer', _List_Nil, 'Enregistrer le passage');
};
var $author$project$I18n$Cles$pipeEtape2PassageKicker = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.passage.kicker', _List_Nil, 'Passage');
};
var $author$project$I18n$Cles$pipeEtape2PassageTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.passage.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'origine',
					$author$project$I18n$Traductions$Chaine(p.o4)),
					_Utils_Tuple2(
					'vers',
					$author$project$I18n$Traductions$Chaine(p.sn))
				]),
			'Passage ' + (p.o4 + (' → ' + p.sn)));
	});
var $author$project$I18n$Cles$pipeEtape2PassageTitreAjout = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.passage.titre-ajout', _List_Nil, 'Nouveau passage');
};
var $author$project$I18n$Cles$pipeEtape2RetraitConfirmer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.retrait.confirmer', _List_Nil, 'Retirer l\'étape');
};
var $author$project$I18n$Cles$pipeEtape2RetraitKicker = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.retrait.kicker', _List_Nil, 'Étape');
};
var $author$project$I18n$Cles$pipeEtape2RetraitPassageConfirmer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.retrait-passage.confirmer', _List_Nil, 'Retirer le passage');
};
var $author$project$I18n$Cles$pipeEtape2RetraitPassageKicker = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.retrait-passage.kicker', _List_Nil, 'Passage');
};
var $author$project$I18n$Cles$pipeEtape2RetraitPassageTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.retrait-passage.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'origine',
					$author$project$I18n$Traductions$Chaine(p.o4)),
					_Utils_Tuple2(
					'vers',
					$author$project$I18n$Traductions$Chaine(p.sn))
				]),
			'Retirer le passage ' + (p.o4 + (' → ' + (p.sn + ' ?'))));
	});
var $author$project$I18n$Cles$pipeEtape2RetraitTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.retrait.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer l\'étape « ' + (p.Dj + ' » ?'));
	});
var $author$project$Components$Parametrage$Common$Conception$drawerSectionAvertissements = F2(
	function (titre, contenu) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('section-drawer'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('avertissements')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(titre)
						])),
				contenu));
	});
var $author$project$Components$Parametrage$Common$Conception$lignesDeRetrait = function (lignes) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$ul,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('lignes')
			]),
		A2(
			$elm$core$List$map,
			function (ligne) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('textes')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(ligne.AS)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(ligne.Gd)
										]))
								]))
						]));
			},
			lignes));
};
var $author$project$I18n$Cles$pipeEtape2RetraitARetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.retrait.a-retirer', _List_Nil, 'À retirer');
};
var $author$project$I18n$Cles$pipeEtape2RetraitAvertissement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.retrait.avertissement', _List_Nil, 'L\'étape disparaît du brouillon. Les dossiers déjà ouverts restent sur leur version.');
};
var $author$project$I18n$Cles$pipeEtape2RetraitDisparait = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.retrait.disparait', _List_Nil, 'Ce qui disparaît');
};
var $author$project$I18n$Cles$pipeEtape2RetraitEtape = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.retrait.etape',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Étape « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$pipeEtape2RetraitPassage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.retrait.passage',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'origine',
					$author$project$I18n$Traductions$Chaine(p.o4)),
					_Utils_Tuple2(
					'vers',
					$author$project$I18n$Traductions$Chaine(p.sn))
				]),
			'Passage ' + (p.o4 + (' → ' + p.sn)));
	});
var $author$project$Components$Parametrage$PipeEtape2$View$retraitDeLEtape = F3(
	function (i18n, parcours, saisie) {
		var uid = A2($elm$core$Maybe$withDefault, '', saisie.r8);
		var touches = A2(
			$elm$core$List$filter,
			function (passage) {
				return _Utils_eq(passage.wC, uid) || _Utils_eq(passage.sn, uid);
			},
			parcours.E5);
		var lue = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (etape) {
					return _Utils_eq(etape.r8, uid);
				},
				parcours.yL));
		var precision = A2(
			$elm$core$String$join,
			' · ',
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							$author$project$Components$Parametrage$PipeEtape2$Phrases$precisionDuNoeud(i18n),
							lue)),
						function () {
						var _v0 = A2(
							$elm$core$Maybe$withDefault,
							0,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.DD;
								},
								lue));
						if (!_v0) {
							return $author$project$I18n$Cles$pipeEtape2SansTache(i18n);
						} else {
							var nombre = _v0;
							return A2(
								$author$project$I18n$Cles$pipeEtape2Taches,
								i18n,
								{w: nombre});
						}
					}()
					])));
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape2RetraitARetirer(i18n),
				_List_fromArray(
					[
						$author$project$Components$Parametrage$Common$Conception$lignesDeRetrait(
						_List_fromArray(
							[
								{
								AS: A2(
									$author$project$I18n$Cles$pipeEtape2RetraitEtape,
									i18n,
									{
										Dj: A2(
											$elm$core$Maybe$withDefault,
											'',
											A2($elm$core$Dict$get, 'fr', saisie.R))
									}),
								Gd: precision
							}
							]))
					])),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSectionAvertissements,
				$author$project$I18n$Cles$pipeEtape2RetraitDisparait(i18n),
				_List_fromArray(
					[
						$elm$core$List$isEmpty(touches) ? $rtfeldman$elm_css$Html$Styled$text('') : $author$project$Components$Parametrage$Common$Conception$lignesDeRetrait(
						A2(
							$elm$core$List$map,
							function (passage) {
								return {
									AS: A2(
										$author$project$I18n$Cles$pipeEtape2RetraitPassage,
										i18n,
										{
											o4: A2($author$project$Components$Parametrage$PipeEtape2$View$nomDeLEtape, parcours, passage.wC),
											sn: A2($author$project$Components$Parametrage$PipeEtape2$View$nomDeLEtape, parcours, passage.sn)
										}),
									Gd: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(passage.Bl)
								};
							},
							touches)),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape2RetraitAvertissement(i18n))
							]))
					]))
			]);
	});
var $author$project$Components$Parametrage$PipeEtape2$Phrases$definiDuRole = function (role) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Components$Parametrage$PipeEtape2$Phrases$nomDe(role),
		role.wY);
};
var $author$project$Components$Parametrage$PipeEtape2$View$nomDuDeclencheur = F3(
	function (parcours, options, uid) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$Components$Parametrage$PipeEtape2$View$nomDuRole, parcours, uid),
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$Parametrage$PipeEtape2$Phrases$definiDuRole,
				A2(
					$elm$core$Maybe$andThen,
					function (lues) {
						return $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (role) {
									return _Utils_eq(role.r8, uid);
								},
								lues.H9));
					},
					options)));
	});
var $author$project$I18n$Cles$pipeEtape2RetraitPassageAvertissement = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.retrait-passage.avertissement',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'origine',
					$author$project$I18n$Traductions$Chaine(p.o4)),
					_Utils_Tuple2(
					'vers',
					$author$project$I18n$Traductions$Chaine(p.sn))
				]),
			'Le dossier ne pourra plus passer de ' + (p.o4 + (' à ' + (p.sn + '. Les deux étapes restent.'))));
	});
var $author$project$I18n$Cles$pipeEtape2RetraitPassageConsequences = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.retrait-passage.consequences', _List_Nil, 'Conséquences');
};
var $author$project$I18n$Cles$pipeEtape2RetraitPassageDeclenchePar = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.retrait-passage.declenche-par',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl)),
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			p.Bl + (' · déclenché par ' + p.bi));
	});
var $author$project$Components$Parametrage$PipeEtape2$View$retraitDuPassage = F4(
	function (i18n, parcours, options, saisie) {
		var vers = A2($author$project$Components$Parametrage$PipeEtape2$View$nomDeLEtape, parcours, saisie.sn);
		var lu = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (passage) {
					return _Utils_eq(
						$elm$core$Maybe$Just(passage.r8),
						saisie.r8);
				},
				parcours.E5));
		var precision = function () {
			if (!lu.$) {
				var passage = lu.a;
				var _v1 = passage.kw;
				if (_v1.$ === 1) {
					return A2(
						$author$project$I18n$Cles$pipeEtape2RetraitPassageDeclenchePar,
						i18n,
						{
							Bl: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(passage.Bl),
							bi: A3(
								$author$project$Components$Parametrage$PipeEtape2$Phrases$declenchement,
								i18n,
								A2($author$project$Components$Parametrage$PipeEtape2$View$nomDuDeclencheur, parcours, options),
								passage.kw)
						});
				} else {
					return $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(passage.Bl);
				}
			} else {
				return '';
			}
		}();
		var de = A2($author$project$Components$Parametrage$PipeEtape2$View$nomDeLEtape, parcours, saisie.wC);
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape2RetraitARetirer(i18n),
				_List_fromArray(
					[
						$author$project$Components$Parametrage$Common$Conception$lignesDeRetrait(
						_List_fromArray(
							[
								{
								AS: A2(
									$author$project$I18n$Cles$pipeEtape2RetraitPassage,
									i18n,
									{o4: de, sn: vers}),
								Gd: precision
							}
							]))
					])),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSectionAvertissements,
				$author$project$I18n$Cles$pipeEtape2RetraitPassageConsequences(i18n),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$pipeEtape2RetraitPassageAvertissement,
									i18n,
									{o4: de, sn: vers}))
							]))
					]))
			]);
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$RetraitDemande = {$: 29};
var $author$project$I18n$Cles$pipeEtape2RetirerAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.retirer.aide', _List_Nil, 'Aucun dossier n\'est lancé sur cette version : l\'étape se retire sans trace, avec ses passages.');
};
var $author$project$I18n$Cles$pipeEtape2RetirerBouton = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.retirer.bouton',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$pipeEtape2RetirerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.retirer.titre', _List_Nil, 'Retirer');
};
var $author$project$Components$Parametrage$PipeEtape2$View$sectionRetirerEtape = F3(
	function (i18n, model, saisie) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (etape) {
				return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerUneEtape, etape.nQ);
			},
			model.me);
		if (!_v0.$) {
			return _Utils_eq(saisie.r8, $elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape2RetirerTitre(i18n),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape2RetirerAide(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape2$Update$RetraitDemande)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$pipeEtape2RetirerBouton,
									i18n,
									{
										Dj: A2(
											$elm$core$Maybe$withDefault,
											'',
											A2($elm$core$Dict$get, 'fr', saisie.R))
									}))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$pipeEtape2RetirerPassageAide = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-2.retirer-passage.aide',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'origine',
					$author$project$I18n$Traductions$Chaine(p.o4)),
					_Utils_Tuple2(
					'vers',
					$author$project$I18n$Traductions$Chaine(p.sn))
				]),
			'Les étapes ' + (p.o4 + (' et ' + (p.sn + ' restent ; seul le passage disparaît du brouillon.'))));
	});
var $author$project$I18n$Cles$pipeEtape2RetirerPassageBouton = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.retirer-passage.bouton', _List_Nil, 'Retirer ce passage');
};
var $author$project$I18n$Cles$pipeEtape2RetirerPassageTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.retirer-passage.titre', _List_Nil, 'Retirer');
};
var $author$project$Components$Parametrage$PipeEtape2$View$sectionRetirerPassage = F4(
	function (i18n, parcours, model, saisie) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (passage) {
				return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerUnPassage, passage.nQ);
			},
			model.aH);
		if (!_v0.$) {
			return _Utils_eq(saisie.r8, $elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape2RetirerPassageTitre(i18n),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$pipeEtape2RetirerPassageAide,
									i18n,
									{
										o4: A2($author$project$Components$Parametrage$PipeEtape2$View$nomDeLEtape, parcours, saisie.wC),
										sn: A2($author$project$Components$Parametrage$PipeEtape2$View$nomDeLEtape, parcours, saisie.sn)
									}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape2$Update$RetraitDemande)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape2RetirerPassageBouton(i18n))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$PipeEtape2$Update$TraductionTerminee = {$: 12};
var $author$project$Components$Parametrage$PipeEtape2$View$libellesParLangue = F5(
	function (i18n, nom, libelle, champ, libelles) {
		return A3(
			$author$project$Components$Shared$LibellesParLangue$View$view,
			i18n,
			_List_Nil,
			{
				go: function (_v0) {
					return $elm$core$Maybe$Nothing;
				},
				Ba: $author$project$Referentiel$Langues$desLibelles,
				Bl: libelle,
				hg: $author$project$Components$Parametrage$PipeEtape2$Update$LibelleSaisi(champ),
				pv: $author$project$Components$Parametrage$PipeEtape2$Model$idDuDrawer(nom),
				fm: function (code) {
					return A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Dict$get, code, libelles));
				}
			});
	});
var $author$project$I18n$Cles$pipeEtape2TraductionTerminee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-2.traduction.terminee', _List_Nil, 'Terminé');
};
var $author$project$Components$Parametrage$PipeEtape2$View$traduction = F3(
	function (i18n, champ, saisie) {
		return _List_fromArray(
			[
				function () {
				if (!champ) {
					return A5(
						$author$project$Components$Parametrage$PipeEtape2$View$libellesParLangue,
						i18n,
						'nom',
						$author$project$I18n$Cles$pipeEtape2NomLibelle(i18n),
						0,
						saisie.R);
				} else {
					return A5(
						$author$project$Components$Parametrage$PipeEtape2$View$libellesParLangue,
						i18n,
						'portail',
						$author$project$I18n$Cles$pipeEtape2PortailLibelle(i18n),
						2,
						saisie.pr);
				}
			}(),
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape2$Update$TraductionTerminee)
					]),
				$author$project$I18n$Cles$pipeEtape2TraductionTerminee(i18n))
			]);
	});
var $author$project$Components$Parametrage$PipeEtape2$View$contenuDuDrawer = F2(
	function (i18n, model) {
		var vide = {
			fs: {sR: false, Bl: '', C$: $author$project$Components$Parametrage$PipeEtape2$Update$EnregistrementDemande},
			fZ: _List_Nil,
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: ''
		};
		var refus = A4($author$project$Components$Parametrage$Common$RefusDuParcours$vue, i18n, $author$project$Components$Parametrage$PipeEtape2$Update$Recharger, model.sr, model.pZ);
		var enregistrer = F2(
			function (libelle, valide) {
				return {
					sR: valide && ((!$author$project$API$Envoi$enCours(model.l2)) && (!model.sr)),
					Bl: libelle,
					C$: $author$project$Components$Parametrage$PipeEtape2$Update$EnregistrementDemande
				};
			});
		var _v0 = _Utils_Tuple2(
			model.mW,
			_Utils_Tuple2(model.ex, model.o_));
		_v0$4:
		while (true) {
			if ((!_v0.a.$) && (!_v0.b.a.$)) {
				switch (_v0.a.a.$) {
					case 0:
						var saisie = _v0.a.a.a;
						var _v1 = _v0.b;
						var parcours = _v1.a.a;
						return _Utils_update(
							vide,
							{
								fs: A2(
									enregistrer,
									$author$project$I18n$Cles$pipeEtape2DrawerEnregistrer(i18n),
									!_Utils_eq(
										$author$project$Components$Parametrage$PipeEtape2$Model$etapeVoulue(saisie),
										$elm$core$Maybe$Nothing)),
								fZ: function () {
									var _v2 = model.rP;
									if (!_v2.$) {
										var champ = _v2.a;
										return A2(
											$elm$core$List$cons,
											refus,
											A3($author$project$Components$Parametrage$PipeEtape2$View$traduction, i18n, champ, saisie));
									} else {
										return A2(
											$elm$core$List$cons,
											refus,
											_Utils_ap(
												A3($author$project$Components$Parametrage$PipeEtape2$View$contenuDeLEtape, i18n, parcours, saisie),
												_List_fromArray(
													[
														A3($author$project$Components$Parametrage$PipeEtape2$View$sectionRetirerEtape, i18n, model, saisie)
													])));
									}
								}(),
								A6: $elm$core$Maybe$Just(
									$author$project$I18n$Cles$pipeEtape2DrawerKicker(i18n)),
								h6: _Utils_eq(saisie.r8, $elm$core$Maybe$Nothing) ? $author$project$I18n$Cles$pipeEtape2DrawerTitreAjout(i18n) : A2(
									$author$project$I18n$Cles$pipeEtape2DrawerTitre,
									i18n,
									{
										Dj: A2($author$project$Components$Parametrage$PipeEtape2$View$nomEnregistre, parcours, saisie)
									})
							});
					case 1:
						if (!_v0.b.b.$) {
							var saisie = _v0.a.a.a;
							var _v3 = _v0.b;
							var parcours = _v3.a.a;
							var options = _v3.b.a;
							return _Utils_update(
								vide,
								{
									fs: A2(
										enregistrer,
										$author$project$I18n$Cles$pipeEtape2PassageEnregistrer(i18n),
										!_Utils_eq(
											A2($author$project$Components$Parametrage$PipeEtape2$Model$passageVoulu, options, saisie),
											$elm$core$Maybe$Nothing)),
									fZ: A2(
										$elm$core$List$cons,
										refus,
										_Utils_ap(
											A3($author$project$Components$Parametrage$PipeEtape2$View$contenuDuPassage, i18n, options, saisie),
											_List_fromArray(
												[
													A4($author$project$Components$Parametrage$PipeEtape2$View$sectionRetirerPassage, i18n, parcours, model, saisie)
												]))),
									A6: $elm$core$Maybe$Just(
										$author$project$I18n$Cles$pipeEtape2PassageKicker(i18n)),
									h6: _Utils_eq(saisie.r8, $elm$core$Maybe$Nothing) ? $author$project$I18n$Cles$pipeEtape2PassageTitreAjout(i18n) : A2(
										$author$project$I18n$Cles$pipeEtape2PassageTitre,
										i18n,
										{
											o4: A2($author$project$Components$Parametrage$PipeEtape2$View$nomDeLEtape, parcours, saisie.wC),
											sn: A2($author$project$Components$Parametrage$PipeEtape2$View$nomDeLEtape, parcours, saisie.sn)
										})
								});
						} else {
							break _v0$4;
						}
					case 2:
						var saisie = _v0.a.a.a;
						var _v4 = _v0.b;
						var parcours = _v4.a.a;
						return _Utils_update(
							vide,
							{
								fs: A2(
									$author$project$Components$Parametrage$PipeEtape2$View$confirmerLe,
									model,
									$author$project$I18n$Cles$pipeEtape2RetraitConfirmer(i18n)),
								fZ: A2(
									$elm$core$List$cons,
									refus,
									A3($author$project$Components$Parametrage$PipeEtape2$View$retraitDeLEtape, i18n, parcours, saisie)),
								A6: $elm$core$Maybe$Just(
									$author$project$I18n$Cles$pipeEtape2RetraitKicker(i18n)),
								h6: A2(
									$author$project$I18n$Cles$pipeEtape2RetraitTitre,
									i18n,
									{
										Dj: A2(
											$elm$core$Maybe$withDefault,
											'',
											A2($elm$core$Dict$get, 'fr', saisie.R))
									})
							});
					default:
						var saisie = _v0.a.a.a;
						var _v5 = _v0.b;
						var parcours = _v5.a.a;
						var options = _v5.b;
						return _Utils_update(
							vide,
							{
								fs: A2(
									$author$project$Components$Parametrage$PipeEtape2$View$confirmerLe,
									model,
									$author$project$I18n$Cles$pipeEtape2RetraitPassageConfirmer(i18n)),
								fZ: A2(
									$elm$core$List$cons,
									refus,
									A4($author$project$Components$Parametrage$PipeEtape2$View$retraitDuPassage, i18n, parcours, options, saisie)),
								A6: $elm$core$Maybe$Just(
									$author$project$I18n$Cles$pipeEtape2RetraitPassageKicker(i18n)),
								h6: A2(
									$author$project$I18n$Cles$pipeEtape2RetraitPassageTitre,
									i18n,
									{
										o4: A2($author$project$Components$Parametrage$PipeEtape2$View$nomDeLEtape, parcours, saisie.wC),
										sn: A2($author$project$Components$Parametrage$PipeEtape2$View$nomDeLEtape, parcours, saisie.sn)
									})
							});
				}
			} else {
				break _v0$4;
			}
		}
		return vide;
	});
var $author$project$Components$Parametrage$PipeEtape2$View$videSiFerme = F2(
	function (model, contenu) {
		return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) ? contenu : _Utils_update(
			contenu,
			{fZ: _List_Nil, A6: $elm$core$Maybe$Nothing, h6: ''});
	});
var $author$project$Components$Parametrage$PipeEtape2$View$drawer = F2(
	function (i18n, model) {
		var _v0 = model.mW;
		_v0$2:
		while (true) {
			if (!_v0.$) {
				switch (_v0.a.$) {
					case 2:
						return A4(
							$author$project$Components$Shared$Drawer$View$viewDestructif,
							i18n,
							$author$project$Components$Parametrage$PipeEtape2$Update$DuDrawer,
							A2($author$project$Components$Parametrage$PipeEtape2$View$contenuDuDrawer, i18n, model),
							model.kX);
					case 3:
						return A4(
							$author$project$Components$Shared$Drawer$View$viewDestructif,
							i18n,
							$author$project$Components$Parametrage$PipeEtape2$Update$DuDrawer,
							A2($author$project$Components$Parametrage$PipeEtape2$View$contenuDuDrawer, i18n, model),
							model.kX);
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Parametrage$PipeEtape2$Update$DuDrawer,
			A2(
				$author$project$Components$Parametrage$PipeEtape2$View$videSiFerme,
				model,
				A2($author$project$Components$Parametrage$PipeEtape2$View$contenuDuDrawer, i18n, model)),
			model.kX);
	});
var $author$project$I18n$Cles$pipeEtape1Exemple = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-1.exemple',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'pipe',
					$author$project$I18n$Traductions$Chaine(p.Fs))
				]),
			'Exemple suivi ici : le pipe « ' + (p.Fs + ' ».'));
	});
var $author$project$Components$Parametrage$PipeEtape2$View$view = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'parametrage-pipe-etape-2',
			{
				ut: A3($author$project$Components$Parametrage$PipeEtape2$View$corps, i18n, messages, model),
				xy: _List_fromArray(
					[
						A2($author$project$Components$Parametrage$PipeEtape2$View$drawer, i18n, model),
						A2($author$project$Components$Parametrage$PipeEtape2$View$detail, i18n, model)
					]),
				zM: _List_Nil,
				AK: $author$project$Components$Parametrage$PipeEtape2$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: A2(
							$elm$core$List$cons,
							A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$elm$core$String$join,
											' ',
											A2(
												$elm$core$List$cons,
												$author$project$I18n$Cles$pipeEtape1Introduction(i18n),
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													A2(
														$elm$core$Maybe$map,
														function (edition) {
															return _List_fromArray(
																[
																	A2(
																	$author$project$I18n$Cles$pipeEtape1Exemple,
																	i18n,
																	{
																		Fs: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(edition.R)
																	})
																]);
														},
														model.ge)))))
									])),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (_v0) {
										return _List_fromArray(
											[
												A5($author$project$Components$Parametrage$Common$Conception$bandeau, i18n, $author$project$Routes$Route$adressePipeEtape2, model.vx, model.aS, model.nR)
											]);
									},
									model.ge))),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adressePipes,
								Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
							},
								{
								aa: $author$project$Routes$Route$adressePipes,
								Dj: $author$project$I18n$Cles$pipesTitre(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$pipeEtape1Titre(i18n)
					})
			});
	});
var $author$project$I18n$Cles$pipeEtape3ApercuDepart = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.apercu.depart', _List_Nil, 'Un départ ne ferme pas le dossier : il reste accessible à ce rôle, qui y voit la relation passée');
};
var $author$project$I18n$Cles$pipeEtape3ApercuSousTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.apercu.sous-titre', _List_Nil, 'Dans un dossier réel');
};
var $author$project$Components$Parametrage$PipeEtape3$View$apercu = F2(
	function (i18n, roles) {
		return A3(
			$author$project$Components$Shared$Parcours$View$apercu,
			i18n,
			$author$project$I18n$Cles$pipeEtape1ApercuTitre(i18n),
			{
				gV: function () {
					var _v0 = roles.tq;
					if (!_v0.$) {
						var lu = _v0.a;
						return A2(
							$elm$core$List$cons,
							{dX: true, eW: 0, Jx: lu.h6},
							_Utils_ap(
								A2(
									$elm$core$List$map,
									function (ligne) {
										return {dX: false, eW: 1, Jx: ligne};
									},
									lu.gV),
								_List_fromArray(
									[
										{
										dX: false,
										eW: 0,
										Jx: $author$project$I18n$Cles$pipeEtape3ApercuDepart(i18n)
									}
									])));
					} else {
						return _List_Nil;
					}
				}(),
				h6: $elm$core$Maybe$Just(
					$author$project$I18n$Cles$pipeEtape3ApercuSousTitre(i18n))
			});
	});
var $author$project$I18n$Cles$pipeEtape3ANom = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.a-nom',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'article',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeArticle(p.i4))),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			function () {
				var _v0 = p.i4;
				switch (_v0) {
					case 0:
						return 'à ' + p.Dj;
					case 1:
						return 'à l\'' + p.Dj;
					case 2:
						return 'à la ' + p.Dj;
					case 3:
						return 'au ' + p.Dj;
					default:
						return 'à ' + p.Dj;
				}
			}());
	});
var $author$project$Components$Parametrage$PipeEtape3$Phrases$apres = F3(
	function (i18n, formes, nom) {
		return A2(
			$author$project$I18n$Cles$pipeEtape3ANom,
			i18n,
			{
				i4: $author$project$Catalogue$Formes$article(formes),
				Dj: nom
			});
	});
var $author$project$I18n$Cles$pipeEtape3AuDossier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.au-dossier', _List_Nil, 'à la personne du dossier');
};
var $author$project$Components$Parametrage$PipeEtape3$Phrases$auObjetVise = F2(
	function (i18n, objetVise) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Cles$pipeEtape3AuDossier(i18n),
			A2(
				$elm$core$Maybe$map,
				function (role) {
					return A3(
						$author$project$Components$Parametrage$PipeEtape3$Phrases$apres,
						i18n,
						role.m$,
						$elm$core$String$toLower(
							$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(role.R)));
				},
				objetVise));
	});
var $author$project$Components$Parametrage$PipeEtape3$View$objetViseDe = function (roles) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (role) {
				return role.D_;
			},
			roles.eX));
};
var $author$project$Components$Parametrage$PipeEtape3$View$parRelation = function (role) {
	var _v0 = role.Js;
	switch (_v0.$) {
		case 1:
			return true;
		case 0:
			return false;
		default:
			return false;
	}
};
var $author$project$I18n$Cles$pipeEtape3Conseil = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.conseil', _List_Nil, 'Interne : la personne a un compte dans votre équipe. Externe : elle passe par un portail. Une organisation peut tenir un rôle : le pipe désigne alors le poste qui agit pour elle, ou à défaut son contact principal.');
};
var $author$project$I18n$Cles$pipeEtape3ConseilRelation = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.conseil-relation',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'objet',
					$author$project$I18n$Traductions$Chaine(p.DZ))
				]),
			'Un rôle « Par relation » est tenu par la personne ou l\'organisation liée ' + (p.DZ + ' : il reçoit ses tâches, ses communications, et peut signer ou payer.'));
	});
var $author$project$Components$Parametrage$PipeEtape3$View$conseil = F2(
	function (i18n, roles) {
		return A2($elm$core$List$any, $author$project$Components$Parametrage$PipeEtape3$View$parRelation, roles.eX) ? ($author$project$I18n$Cles$pipeEtape3Conseil(i18n) + (' ' + A2(
			$author$project$I18n$Cles$pipeEtape3ConseilRelation,
			i18n,
			{
				DZ: A2(
					$author$project$Components$Parametrage$PipeEtape3$Phrases$auObjetVise,
					i18n,
					$author$project$Components$Parametrage$PipeEtape3$View$objetViseDe(roles))
			}))) : $author$project$I18n$Cles$pipeEtape3Conseil(i18n);
	});
var $author$project$I18n$Cles$pipeEtape3QuiRole = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.qui.role', _List_Nil, 'rôle dans le dossier');
};
var $author$project$I18n$Cles$pipeEtape3QuiTexte1 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.qui.texte1', _List_Nil, 'Un ');
};
var $author$project$I18n$Cles$pipeEtape3QuiTexte2 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.qui.texte2', _List_Nil, ' est une place : licencié, contrôleur, comité qualité... Le pipe dit les places ; chaque dossier dit qui les tient.');
};
var $author$project$Components$Parametrage$PipeEtape3$View$explication = function (i18n) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$p,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('explication')
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$I18n$Cles$pipeEtape3QuiTexte1(i18n)),
				A2(
				$rtfeldman$elm_css$Html$Styled$strong,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$pipeEtape3QuiRole(i18n))
					])),
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$I18n$Cles$pipeEtape3QuiTexte2(i18n))
			]));
};
var $author$project$Components$Parametrage$PipeEtape3$Update$RoleAjoutDemande = {$: 10};
var $author$project$I18n$Cles$pipeEtape3RelationsExigees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.relations-exigees', _List_Nil, 'Relations exigées par ce type de dossier');
};
var $author$project$Components$Parametrage$PipeEtape3$View$lienDesRelationsExigees = F3(
	function (i18n, code, roles) {
		var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$relationsExigeesDuPipe, roles.nQ);
		if (!_v0.$) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('relations-exigees'),
						$rtfeldman$elm_css$Html$Styled$Attributes$href(
						$author$project$Routes$Route$adresseRelationsExigees(code))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$pipeEtape3RelationsExigees(i18n))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$PipeEtape3$Update$RoleDemande = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Parametrage$Vocabulaire$genreGroupe = 'groupe';
var $author$project$I18n$Cles$pipeEtape3CardinaliteGroupe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.cardinalite.groupe', _List_Nil, 'Un groupe');
};
var $author$project$I18n$Cles$pipeEtape3CardinaliteOrganisation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.cardinalite.organisation', _List_Nil, 'Une organisation');
};
var $author$project$I18n$Cles$pipeEtape3CardinaliteOrganisations = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.cardinalite.organisations', _List_Nil, 'Plusieurs organisations');
};
var $author$project$I18n$Cles$pipeEtape3CardinalitePlusieurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.cardinalite.plusieurs', _List_Nil, 'Plusieurs personnes');
};
var $author$project$I18n$Cles$pipeEtape3CardinaliteUne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.cardinalite.une', _List_Nil, 'Une seule personne');
};
var $author$project$Components$Parametrage$Vocabulaire$tenuParOrganisation = 'organisation';
var $author$project$Components$Parametrage$PipeEtape3$Phrases$cardinalite = F2(
	function (i18n, role) {
		var _v0 = _Utils_Tuple2(role.Js, role.jz);
		switch (_v0.a.$) {
			case 1:
				if (!_v0.b) {
					var relation = _v0.a.a;
					var _v1 = _v0.b;
					return _Utils_eq(relation.e9, $author$project$Components$Parametrage$Vocabulaire$tenuParOrganisation) ? $author$project$I18n$Cles$pipeEtape3CardinaliteOrganisation(i18n) : $author$project$I18n$Cles$pipeEtape3CardinaliteUne(i18n);
				} else {
					var relation = _v0.a.a;
					var _v2 = _v0.b;
					return _Utils_eq(relation.e9, $author$project$Components$Parametrage$Vocabulaire$tenuParOrganisation) ? $author$project$I18n$Cles$pipeEtape3CardinaliteOrganisations(i18n) : $author$project$I18n$Cles$pipeEtape3CardinalitePlusieurs(i18n);
				}
			case 2:
				if (!_v0.b) {
					var _v3 = _v0.b;
					return $author$project$I18n$Cles$pipeEtape3CardinaliteUne(i18n);
				} else {
					var _v4 = _v0.b;
					return $author$project$I18n$Cles$pipeEtape3CardinalitePlusieurs(i18n);
				}
			default:
				var lus = _v0.a.a;
				var cardinalite_ = _v0.b;
				if (A2(
					$elm$core$List$any,
					function (lu) {
						return _Utils_eq(lu.M, $author$project$Components$Parametrage$Vocabulaire$genreGroupe);
					},
					lus)) {
					return $author$project$I18n$Cles$pipeEtape3CardinaliteGroupe(i18n);
				} else {
					if (!cardinalite_) {
						return $author$project$I18n$Cles$pipeEtape3CardinaliteUne(i18n);
					} else {
						return $author$project$I18n$Cles$pipeEtape3CardinalitePlusieurs(i18n);
					}
				}
		}
	});
var $author$project$I18n$Cles$pipeEtape3NatureExterne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.nature.externe', _List_Nil, 'Externe');
};
var $author$project$I18n$Cles$pipeEtape3NatureInterne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.nature.interne', _List_Nil, 'Interne');
};
var $author$project$I18n$Cles$pipeEtape3NatureLesDeux = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.nature.les-deux', _List_Nil, 'Interne ou externe');
};
var $author$project$Components$Parametrage$PipeEtape3$Phrases$natureDe = F2(
	function (i18n, nature) {
		switch (nature) {
			case 0:
				return $author$project$I18n$Cles$pipeEtape3NatureInterne(i18n);
			case 1:
				return $author$project$I18n$Cles$pipeEtape3NatureExterne(i18n);
			default:
				return $author$project$I18n$Cles$pipeEtape3NatureLesDeux(i18n);
		}
	});
var $author$project$I18n$Cles$pipeEtape3Ou = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.ou', _List_Nil, ' ou ');
};
var $author$project$I18n$Cles$pipeEtape3ParOrganisationContact = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.par-organisation-contact', _List_Nil, 'organisation, par son contact principal');
};
var $author$project$I18n$Cles$pipeEtape3ParOrganisationPoste = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.par-organisation-poste',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'poste',
					$author$project$I18n$Traductions$Chaine(p.F4))
				]),
			'organisation, par son poste « ' + (p.F4 + ' »'));
	});
var $author$project$I18n$Cles$pipeEtape3ParPersonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.par-personne', _List_Nil, 'personne');
};
var $author$project$I18n$Cles$pipeEtape3PeutEtre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.peut-etre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'qui',
					$author$project$I18n$Traductions$Chaine(p.GK))
				]),
			'Peut être : ' + p.GK);
	});
var $author$project$I18n$Cles$pipeEtape3TenuPar = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.tenu-par',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'relation',
					$author$project$I18n$Traductions$Chaine(p.Ht)),
					_Utils_Tuple2(
					'article',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeArticle(p.i4))),
					_Utils_Tuple2(
					'par',
					$author$project$I18n$Traductions$Chaine(p.EK)),
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Tenu par : la relation « ' + (p.Ht + (' » ' + (function () {
				var _v0 = p.i4;
				switch (_v0) {
					case 0:
						return 'de la personne du dossier';
					case 1:
						return 'de l\'' + $elm$core$String$toLower(p.bi);
					case 2:
						return 'de la ' + $elm$core$String$toLower(p.bi);
					case 3:
						return 'du ' + $elm$core$String$toLower(p.bi);
					default:
						return 'de ' + p.bi;
				}
			}() + (' (' + (p.EK + ')'))))));
	});
var $author$project$I18n$Cles$pipeEtape3TenuParChamp = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.tenu-par-champ',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'Tenu par : le champ « ' + (p.uN + ' » de la fiche visée'));
	});
var $author$project$Components$Parametrage$Vocabulaire$genreRoleDEquipe = 'role-d-equipe';
var $author$project$I18n$Cles$pipeEtape3SourceEquipe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.source-equipe',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			'le rôle d\'équipe « ' + (p.Bl + ' »'));
	});
var $author$project$I18n$Cles$pipeEtape3SourceEquipePlusieurs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.source-equipe-plusieurs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			'les utilisateurs du rôle d\'équipe « ' + (p.Bl + ' »'));
	});
var $author$project$I18n$Cles$pipeEtape3SourceGroupe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.source-groupe',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			'un groupe d\'intervenants (« ' + (p.Bl + ' », remplaçable pour un dossier)'));
	});
var $author$project$Components$Parametrage$PipeEtape3$Phrases$source = F3(
	function (i18n, cardinalite_, lu) {
		if (_Utils_eq(lu.M, $author$project$Components$Parametrage$Vocabulaire$genreRoleDEquipe)) {
			if (cardinalite_ === 1) {
				return A2(
					$author$project$I18n$Cles$pipeEtape3SourceEquipePlusieurs,
					i18n,
					{Bl: lu.Bl});
			} else {
				return A2(
					$author$project$I18n$Cles$pipeEtape3SourceEquipe,
					i18n,
					{Bl: lu.Bl});
			}
		} else {
			if (_Utils_eq(lu.M, $author$project$Components$Parametrage$Vocabulaire$genreGroupe)) {
				return A2(
					$author$project$I18n$Cles$pipeEtape3SourceGroupe,
					i18n,
					{Bl: lu.Bl});
			} else {
				return lu.Bl;
			}
		}
	});
var $author$project$Components$Parametrage$PipeEtape3$Phrases$peutEtre = F3(
	function (i18n, objetVise, role) {
		var _v0 = role.Js;
		switch (_v0.$) {
			case 0:
				var lus = _v0.a;
				return A2(
					$author$project$I18n$Cles$pipeEtape3PeutEtre,
					i18n,
					{
						GK: A2(
							$elm$core$String$join,
							$author$project$I18n$Cles$pipeEtape3Ou(i18n),
							A2(
								$elm$core$List$map,
								A2($author$project$Components$Parametrage$PipeEtape3$Phrases$source, i18n, role.jz),
								lus))
					});
			case 2:
				var champ = _v0.a;
				return A2(
					$author$project$I18n$Cles$pipeEtape3TenuParChamp,
					i18n,
					{uN: champ});
			default:
				var relation = _v0.a;
				return A2(
					$author$project$I18n$Cles$pipeEtape3TenuPar,
					i18n,
					{
						i4: A2(
							$elm$core$Maybe$withDefault,
							0,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.m$;
									},
									$author$project$Catalogue$Formes$article),
								objetVise)),
						EK: function () {
							if (_Utils_eq(relation.e9, $author$project$Components$Parametrage$Vocabulaire$tenuParOrganisation)) {
								var _v1 = relation.F4;
								if (!_v1.$) {
									var poste = _v1.a;
									return A2(
										$author$project$I18n$Cles$pipeEtape3ParOrganisationPoste,
										i18n,
										{F4: poste});
								} else {
									return $author$project$I18n$Cles$pipeEtape3ParOrganisationContact(i18n);
								}
							} else {
								return $author$project$I18n$Cles$pipeEtape3ParPersonne(i18n);
							}
						}(),
						Ht: relation.Bl,
						bi: A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								function (vise) {
									return $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(vise.R);
								},
								objetVise))
					});
		}
	});
var $author$project$I18n$Cles$pipeEtape3ParRelation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.par-relation', _List_Nil, 'Par relation');
};
var $author$project$Components$Parametrage$PipeEtape3$View$teinteDeLaNature = function (nature) {
	switch (nature) {
		case 0:
			return 'vert';
		case 1:
			return 'ambre';
		default:
			return 'accent';
	}
};
var $author$project$Components$Parametrage$PipeEtape3$View$ligneDeRole = F3(
	function (i18n, objetVise, role) {
		var contenu = _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('textes')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(role.R))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(role.dH))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A3($author$project$Components$Parametrage$PipeEtape3$Phrases$peutEtre, i18n, objetVise, role))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('etiquettes')
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('etiquette', true),
										_Utils_Tuple2(
										$author$project$Components$Parametrage$PipeEtape3$View$teinteDeLaNature(role.g1),
										true)
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$Components$Parametrage$PipeEtape3$Phrases$natureDe, i18n, role.g1))
							])),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('etiquette')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Parametrage$PipeEtape3$Phrases$cardinalite, i18n, role))
								])),
						$author$project$Components$Parametrage$PipeEtape3$View$parRelation(role) ? _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('etiquette', true),
												_Utils_Tuple2('violet', true)
											]))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape3ParRelation(i18n))
									]))
							]) : _List_Nil))),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('fleche'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('›')
					]))
			]);
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne')
				]),
			_List_fromArray(
				[
					function () {
					var _v0 = role.np;
					if (!_v0.$) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id(
									$author$project$Components$Parametrage$PipeEtape3$Model$idDuDeclencheur('role-' + role.r8)),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Parametrage$PipeEtape3$Update$RoleDemande(role.r8))
								]),
							contenu);
					} else {
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('inerte')
								]),
							contenu);
					}
				}()
				]));
	});
var $author$project$I18n$Cles$pipeEtape3AjouterRole = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.ajouter-role', _List_Nil, 'Ajouter : Rôle');
};
var $author$project$Components$Parametrage$PipeEtape3$View$listeDesRoles = F3(
	function (i18n, code, roles) {
		var objetVise = $author$project$Components$Parametrage$PipeEtape3$View$objetViseDe(roles);
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('roles')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('lignes-et-ajout')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$ul,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('lignes')
										]),
									A2(
										$elm$core$List$map,
										A2($author$project$Components$Parametrage$PipeEtape3$View$ligneDeRole, i18n, objetVise),
										roles.eX)),
									function () {
									var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ajouterUnRoleDuPipe, roles.nQ);
									if (!_v0.$) {
										return A2(
											$rtfeldman$elm_css$Html$Styled$button,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
													$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout'),
													$rtfeldman$elm_css$Html$Styled$Attributes$id(
													$author$project$Components$Parametrage$PipeEtape3$Model$idDuDeclencheur('role-ajout')),
													$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape3$Update$RoleAjoutDemande)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$pipeEtape3AjouterRole(i18n))
												]));
									} else {
										return $rtfeldman$elm_css$Html$Styled$text('');
									}
								}(),
									A3($author$project$Components$Parametrage$PipeEtape3$View$lienDesRelationsExigees, i18n, code, roles)
								]))
						]))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape3$View$pied = F2(
	function (i18n, code) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pied')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$lien,
					1,
					$author$project$Routes$Route$adressePipeEtape2(code),
					$author$project$I18n$Cles$pipeEtape2Precedente(i18n)),
					A3(
					$author$project$Components$Shared$Bouton$View$lien,
					0,
					$author$project$Routes$Route$adressePipeEtape4(code),
					$author$project$I18n$Cles$pipeEtape1Suivante(i18n))
				]));
	});
var $author$project$I18n$Cles$pipeEtape3TitreQui = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.titre-qui', _List_Nil, 'Qui intervient dans un dossier ?');
};
var $author$project$Components$Parametrage$PipeEtape3$View$corps = F3(
	function (i18n, messages, model) {
		var _v0 = _Utils_Tuple2(model.eX, model.nf);
		if (!_v0.a.$) {
			var roles = _v0.a.a;
			return _List_fromArray(
				[
					A3($author$project$Components$Parametrage$Common$Conception$etapes, i18n, model.vx, 3),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
						]),
					_List_fromArray(
						[
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('etape')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h2,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape3TitreQui(i18n))
										])),
									$author$project$Components$Parametrage$PipeEtape3$View$explication(i18n),
									A3($author$project$Components$Parametrage$PipeEtape3$View$listeDesRoles, i18n, model.vx, roles),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$Components$Parametrage$PipeEtape3$View$conseil, i18n, roles))
										]))
								])),
							A2($author$project$Components$Parametrage$PipeEtape3$View$pied, i18n, model.vx)
						])),
					A2($author$project$Components$Parametrage$PipeEtape3$View$apercu, i18n, roles)
				]);
		} else {
			if (_v0.b) {
				return _List_fromArray(
					[
						A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape1Introuvable(i18n))
							]))
					]);
			} else {
				return _List_fromArray(
					[
						A2($author$project$Components$Shared$Messages$View$view, i18n, messages)
					]);
			}
		}
	});
var $author$project$Components$Parametrage$PipeEtape3$Update$EnregistrementDemande = {$: 30};
var $author$project$Components$Parametrage$PipeEtape3$Update$Recharger = {$: 8};
var $author$project$Components$Parametrage$PipeEtape3$Update$RetraitConfirme = {$: 7};
var $author$project$Components$Parametrage$PipeEtape3$View$autreFiche = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function (uid) {
			return _Utils_Tuple2(
				uid,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.gV;
						},
						A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.tq;
							},
							model.eX))));
		},
		model.my);
};
var $author$project$Components$Parametrage$PipeEtape3$Update$CardinaliteChoisie = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Parametrage$PipeEtape3$Update$NatureChoisie = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Parametrage$PipeEtape3$Update$NomSaisi = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Catalogue$Formes$avecDe = F2(
	function (formes, nom) {
		if (formes.$ === 1) {
			return 'de ' + nom;
		} else {
			var lues = formes.a;
			return ((!lues.zX.M) && (!lues.zX.av)) ? ('du ' + $elm$core$String$toLower(nom)) : ('de ' + ($author$project$Catalogue$Formes$determinant(lues.zX) + $elm$core$String$toLower(nom)));
		}
	});
var $author$project$Components$Parametrage$PipeEtape3$Phrases$nomsDesPostes = function (postes) {
	return A2(
		$elm$core$String$join,
		', ',
		A2(
			$elm$core$List$map,
			function ($) {
				return $.Bl;
			},
			postes));
};
var $author$project$I18n$Cles$pipeEtape3ApercuAgitContact = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.apercu.agit-contact', _List_Nil, 'Son contact principal agit pour elle.');
};
var $author$project$I18n$Cles$pipeEtape3ApercuAgitPoste = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.apercu.agit-poste',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'poste',
					$author$project$I18n$Traductions$Chaine(p.F4))
				]),
			'Le poste « ' + (p.F4 + ' » agit pour elle.'));
	});
var $author$project$I18n$Cles$pipeEtape3ApercuAgitPosteDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.apercu.agit-poste-de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'poste',
					$author$project$I18n$Traductions$Chaine(p.F4)),
					_Utils_Tuple2(
					'organisation',
					$author$project$I18n$Traductions$Chaine(p.En))
				]),
			p.F4 + (' ' + (p.En + ' agit pour elle.')));
	});
var $author$project$Components$Parametrage$PipeEtape3$Phrases$postesChoisis = F2(
	function (options, saisie) {
		return A2(
			$elm$core$List$filterMap,
			function (uid) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (poste) {
							return _Utils_eq(poste.r8, uid);
						},
						options.F6));
			},
			saisie.F7);
	});
var $author$project$Components$Parametrage$PipeEtape3$Phrases$premiereEnMajuscule = function (mot) {
	return _Utils_ap(
		$elm$core$String$toUpper(
			A2($elm$core$String$left, 1, mot)),
		A2($elm$core$String$dropLeft, 1, mot));
};
var $author$project$Components$Parametrage$PipeEtape3$Phrases$premiereEnMinuscule = function (mot) {
	return _Utils_ap(
		$elm$core$String$toLower(
			A2($elm$core$String$left, 1, mot)),
		A2($elm$core$String$dropLeft, 1, mot));
};
var $author$project$Components$Parametrage$PipeEtape3$Phrases$agitPour = F4(
	function (i18n, options, saisie, organisation) {
		var _v0 = A2($author$project$Components$Parametrage$PipeEtape3$Phrases$postesChoisis, options, saisie);
		if (!_v0.b) {
			return $author$project$I18n$Cles$pipeEtape3ApercuAgitContact(i18n);
		} else {
			if (!_v0.b.b) {
				var poste = _v0.a;
				var _v1 = _Utils_Tuple2(poste.m$, organisation.r0);
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var formes = _v1.a.a;
					var type_ = _v1.b.a;
					return A2(
						$author$project$I18n$Cles$pipeEtape3ApercuAgitPosteDe,
						i18n,
						{
							En: A2($author$project$Catalogue$Formes$avecDe, type_.m$, type_.Bl),
							F4: $author$project$Components$Parametrage$PipeEtape3$Phrases$premiereEnMajuscule(
								_Utils_ap(
									$author$project$Catalogue$Formes$determinant(formes.zX),
									$author$project$Components$Parametrage$PipeEtape3$Phrases$premiereEnMinuscule(poste.Bl)))
						});
				} else {
					return A2(
						$author$project$I18n$Cles$pipeEtape3ApercuAgitPoste,
						i18n,
						{F4: poste.Bl});
				}
			} else {
				var postes = _v0;
				return A2(
					$author$project$I18n$Cles$pipeEtape3ApercuAgitPoste,
					i18n,
					{
						F4: $author$project$Components$Parametrage$PipeEtape3$Phrases$nomsDesPostes(postes)
					});
			}
		}
	});
var $author$project$Components$Parametrage$PipeEtape3$Phrases$agitSansExemple = F3(
	function (i18n, options, saisie) {
		var _v0 = A2($author$project$Components$Parametrage$PipeEtape3$Phrases$postesChoisis, options, saisie);
		if (!_v0.b) {
			return $author$project$I18n$Cles$pipeEtape3ApercuAgitContact(i18n);
		} else {
			var postes = _v0;
			return A2(
				$author$project$I18n$Cles$pipeEtape3ApercuAgitPoste,
				i18n,
				{
					F4: $author$project$Components$Parametrage$PipeEtape3$Phrases$nomsDesPostes(postes)
				});
		}
	});
var $author$project$Components$Parametrage$PipeEtape3$Phrases$avecUn = F2(
	function (saisie, nom) {
		return A2(
			$author$project$Catalogue$Formes$avecUn,
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.m$;
				},
				saisie.B0),
			nom);
	});
var $author$project$Components$Parametrage$PipeEtape3$Phrases$fort = function (morceau) {
	return {dX: true, Jx: morceau};
};
var $author$project$I18n$Cles$pipeEtape3LaPersonneDuDossier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.la-personne-du-dossier', _List_Nil, 'la personne du dossier');
};
var $author$project$Components$Parametrage$PipeEtape3$Phrases$laPersonne = F2(
	function (i18n, personne) {
		return (personne === '') ? $author$project$I18n$Cles$pipeEtape3LaPersonneDuDossier(i18n) : personne;
	});
var $author$project$I18n$Cles$pipeEtape3ApercuAucuneSource = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.apercu.aucune-source', _List_Nil, 'Aucune source n\'est cochée : personne ne peut tenir ce rôle.');
};
var $author$project$I18n$Cles$pipeEtape3ApercuDansLeDossier = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.apercu.dans-le-dossier',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'personne',
					$author$project$I18n$Traductions$Chaine(p.Fd))
				]),
			'Dans le dossier de ' + (p.Fd + ', '));
	});
var $author$project$I18n$Cles$pipeEtape3ApercuDansUnDossier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.apercu.dans-un-dossier', _List_Nil, 'Dans un dossier, ');
};
var $author$project$I18n$Cles$pipeEtape3ApercuLeRole = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.apercu.le-role', _List_Nil, 'le rôle ');
};
var $author$project$I18n$Cles$pipeEtape3ApercuLieePar = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.apercu.liee-par',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'personne',
					$author$project$I18n$Traductions$Chaine(p.Fd)),
					_Utils_Tuple2(
					'relation',
					$author$project$I18n$Traductions$Chaine(p.Ht))
				]),
			', liée à ' + (p.Fd + (' par « ' + (p.Ht + ' ». '))));
	});
var $author$project$I18n$Cles$pipeEtape3ApercuParChamp = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.apercu.par-champ',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			' revient à la fiche que désigne le champ « ' + (p.uN + ' ».'));
	});
var $author$project$I18n$Cles$pipeEtape3ApercuParmi = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.apercu.parmi',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'sources',
					$author$project$I18n$Traductions$Chaine(p.IT))
				]),
			'parmi ' + (p.IT + '.'));
	});
var $author$project$I18n$Cles$pipeEtape3ApercuPeutEtreChoisi = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.apercu.peut-etre-choisi', _List_Nil, ' peut être choisi ');
};
var $author$project$I18n$Cles$pipeEtape3ApercuPeuventEtreChoisis = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.apercu.peuvent-etre-choisis', _List_Nil, ' peuvent être choisis ');
};
var $author$project$I18n$Cles$pipeEtape3ApercuPlusieurs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.apercu.plusieurs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'plusieurs ' + p.Dj);
	});
var $author$project$I18n$Cles$pipeEtape3ApercuRevientA = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.apercu.revient-a', _List_Nil, ' revient à ');
};
var $author$project$I18n$Cles$pipeEtape3ApercuRevientOrganisation = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.apercu.revient-organisation',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'relation',
					$author$project$I18n$Traductions$Chaine(p.Ht))
				]),
			' revient à l\'organisation liée à la personne du dossier par « ' + (p.Ht + ' ». '));
	});
var $author$project$I18n$Cles$pipeEtape3ApercuRevientPersonne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.apercu.revient-personne',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'relation',
					$author$project$I18n$Traductions$Chaine(p.Ht))
				]),
			' revient à la personne liée à la personne du dossier par « ' + (p.Ht + ' ». '));
	});
var $author$project$Components$Parametrage$PipeEtape3$Phrases$pluriel = F2(
	function (saisie, nom) {
		return A2(
			$elm$core$Maybe$withDefault,
			nom,
			A2(
				$elm$core$Maybe$map,
				function (formes) {
					return $elm$core$String$toLower(formes.zX.bT);
				},
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.m$;
					},
					saisie.B0)));
	});
var $author$project$I18n$Cles$pipeEtape3ApercuEquipe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.apercu.equipe',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'pluriel',
					$author$project$I18n$Traductions$Chaine(p.bT))
				]),
			'les ' + (p.bT + ' de l\'équipe'));
	});
var $author$project$Components$Parametrage$Vocabulaire$genrePartiePrenante = 'partie-prenante';
var $author$project$I18n$Cles$pipeEtape3ApercuPartiePrenante = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.apercu.partie-prenante',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			'les personnes de type « ' + (p.Bl + ' »'));
	});
var $author$project$Components$Parametrage$PipeEtape3$Phrases$uneSourceHorsEquipe = F3(
	function (i18n, cardinalite_, lu) {
		return _Utils_eq(lu.M, $author$project$Components$Parametrage$Vocabulaire$genrePartiePrenante) ? A2(
			$author$project$I18n$Cles$pipeEtape3ApercuPartiePrenante,
			i18n,
			{Bl: lu.Bl}) : A3($author$project$Components$Parametrage$PipeEtape3$Phrases$source, i18n, cardinalite_, lu);
	});
var $author$project$Components$Parametrage$PipeEtape3$Phrases$uneSource = F4(
	function (i18n, options, cardinalite_, lu) {
		var equipe = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (candidate) {
					return _Utils_eq(
						$elm$core$Maybe$Just(candidate.r8),
						lu.r8);
				},
				options.H8));
		if (!equipe.$) {
			var trouve = equipe.a;
			if (_Utils_eq(lu.M, $author$project$Components$Parametrage$Vocabulaire$genreRoleDEquipe)) {
				var _v1 = trouve.m$;
				if (!_v1.$) {
					var formes = _v1.a;
					return A2(
						$author$project$I18n$Cles$pipeEtape3ApercuEquipe,
						i18n,
						{
							bT: $elm$core$String$toLower(formes.zX.bT)
						});
				} else {
					return A3(
						$author$project$Components$Parametrage$PipeEtape3$Phrases$source,
						i18n,
						cardinalite_,
						_Utils_update(
							lu,
							{Bl: trouve.Bl}));
				}
			} else {
				return A3($author$project$Components$Parametrage$PipeEtape3$Phrases$uneSourceHorsEquipe, i18n, cardinalite_, lu);
			}
		} else {
			return A3($author$project$Components$Parametrage$PipeEtape3$Phrases$uneSourceHorsEquipe, i18n, cardinalite_, lu);
		}
	});
var $author$project$Components$Parametrage$PipeEtape3$Phrases$sources = F3(
	function (i18n, options, saisie) {
		return A2(
			$elm$core$String$join,
			$author$project$I18n$Cles$pipeEtape3Ou(i18n),
			A2(
				$elm$core$List$map,
				A3($author$project$Components$Parametrage$PipeEtape3$Phrases$uneSource, i18n, options, saisie.jz),
				saisie.Fl));
	});
var $author$project$Components$Parametrage$PipeEtape3$Phrases$texte = function (morceau) {
	return {dX: false, Jx: morceau};
};
var $author$project$Components$Parametrage$PipeEtape3$Phrases$apercuDuRole = F4(
	function (i18n, personne, options, saisie) {
		var nom = $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(saisie.R);
		var debut = (personne === '') ? $author$project$I18n$Cles$pipeEtape3ApercuDansUnDossier(i18n) : A2(
			$author$project$I18n$Cles$pipeEtape3ApercuDansLeDossier,
			i18n,
			{Fd: personne});
		if (saisie.EW) {
			var relation = saisie.Ht;
			var nomDuRole = _List_fromArray(
				[
					$author$project$Components$Parametrage$PipeEtape3$Phrases$texte(debut),
					$author$project$Components$Parametrage$PipeEtape3$Phrases$texte(
					$author$project$I18n$Cles$pipeEtape3ApercuLeRole(i18n)),
					$author$project$Components$Parametrage$PipeEtape3$Phrases$fort(nom)
				]);
			var _v0 = _Utils_Tuple2(
				_Utils_eq(relation.e9, $author$project$Components$Parametrage$Vocabulaire$tenuParOrganisation),
				options.Ep);
			if (_v0.a) {
				if (!_v0.b.$) {
					var organisation = _v0.b.a;
					return _Utils_ap(
						nomDuRole,
						_List_fromArray(
							[
								$author$project$Components$Parametrage$PipeEtape3$Phrases$texte(
								$author$project$I18n$Cles$pipeEtape3ApercuRevientA(i18n)),
								$author$project$Components$Parametrage$PipeEtape3$Phrases$fort(organisation.Dj),
								$author$project$Components$Parametrage$PipeEtape3$Phrases$texte(
								A2(
									$author$project$I18n$Cles$pipeEtape3ApercuLieePar,
									i18n,
									{
										Fd: A2($author$project$Components$Parametrage$PipeEtape3$Phrases$laPersonne, i18n, personne),
										Ht: relation.Bl
									})),
								$author$project$Components$Parametrage$PipeEtape3$Phrases$texte(
								A4($author$project$Components$Parametrage$PipeEtape3$Phrases$agitPour, i18n, options, saisie, organisation))
							]));
				} else {
					var _v1 = _v0.b;
					return _Utils_ap(
						nomDuRole,
						_List_fromArray(
							[
								$author$project$Components$Parametrage$PipeEtape3$Phrases$texte(
								A2(
									$author$project$I18n$Cles$pipeEtape3ApercuRevientOrganisation,
									i18n,
									{Ht: relation.Bl})),
								$author$project$Components$Parametrage$PipeEtape3$Phrases$texte(
								A3($author$project$Components$Parametrage$PipeEtape3$Phrases$agitSansExemple, i18n, options, saisie))
							]));
				}
			} else {
				return _Utils_ap(
					nomDuRole,
					_List_fromArray(
						[
							$author$project$Components$Parametrage$PipeEtape3$Phrases$texte(
							A2(
								$author$project$I18n$Cles$pipeEtape3ApercuRevientPersonne,
								i18n,
								{Ht: relation.Bl}))
						]));
			}
		} else {
			if (saisie.EM) {
				return _List_fromArray(
					[
						$author$project$Components$Parametrage$PipeEtape3$Phrases$texte(debut),
						$author$project$Components$Parametrage$PipeEtape3$Phrases$texte(
						$author$project$I18n$Cles$pipeEtape3ApercuLeRole(i18n)),
						$author$project$Components$Parametrage$PipeEtape3$Phrases$fort(nom),
						$author$project$Components$Parametrage$PipeEtape3$Phrases$texte(
						A2(
							$author$project$I18n$Cles$pipeEtape3ApercuParChamp,
							i18n,
							{
								uN: A2(
									$elm$core$Maybe$withDefault,
									saisie.uN,
									A2(
										$elm$core$Maybe$map,
										$elm$core$Tuple$second,
										$elm$core$List$head(
											A2(
												$elm$core$List$filter,
												function (_v2) {
													var code = _v2.a;
													return _Utils_eq(code, saisie.uN);
												},
												options.dw))))
							}))
					]);
			} else {
				var sujet = function () {
					var _v4 = saisie.jz;
					if (!_v4) {
						return A2($author$project$Components$Parametrage$PipeEtape3$Phrases$avecUn, saisie, nom);
					} else {
						return A2(
							$author$project$I18n$Cles$pipeEtape3ApercuPlusieurs,
							i18n,
							{
								Dj: A2($author$project$Components$Parametrage$PipeEtape3$Phrases$pluriel, saisie, nom)
							});
					}
				}();
				return _Utils_eq(saisie.Fl, _List_Nil) ? _List_fromArray(
					[
						$author$project$Components$Parametrage$PipeEtape3$Phrases$texte(
						$author$project$I18n$Cles$pipeEtape3ApercuAucuneSource(i18n))
					]) : _List_fromArray(
					[
						$author$project$Components$Parametrage$PipeEtape3$Phrases$texte(debut),
						$author$project$Components$Parametrage$PipeEtape3$Phrases$fort(sujet),
						$author$project$Components$Parametrage$PipeEtape3$Phrases$texte(
						function () {
							var _v3 = saisie.jz;
							if (!_v3) {
								return $author$project$I18n$Cles$pipeEtape3ApercuPeutEtreChoisi(i18n);
							} else {
								return $author$project$I18n$Cles$pipeEtape3ApercuPeuventEtreChoisis(i18n);
							}
						}()),
						$author$project$Components$Parametrage$PipeEtape3$Phrases$texte(
						A2(
							$author$project$I18n$Cles$pipeEtape3ApercuParmi,
							i18n,
							{
								IT: A3($author$project$Components$Parametrage$PipeEtape3$Phrases$sources, i18n, options, saisie)
							}))
					]);
			}
		}
	});
var $author$project$Components$Parametrage$PipeEtape3$Update$FicheDExempleChoisie = function (a) {
	return {$: 6, a: a};
};
var $author$project$I18n$Cles$pipeEtape3ApercuAutreFiche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.apercu.autre-fiche', _List_Nil, 'Autre fiche');
};
var $author$project$I18n$Cles$pipeEtape3ApercuAutreFicheChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.apercu.autre-fiche-choisir', _List_Nil, 'Choisir une fiche d\'exemple');
};
var $author$project$Components$Parametrage$PipeEtape3$View$autresFiches = F3(
	function (i18n, choix, options) {
		return $elm$core$List$isEmpty(options.zw) ? _List_Nil : _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$fieldset,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('form-item', true),
								_Utils_Tuple2('autre-fiche', true)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$legend,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape3ApercuAutreFiche(i18n))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$select,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Parametrage$PipeEtape3$Update$FicheDExempleChoisie),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-label',
								$author$project$I18n$Cles$pipeEtape3ApercuAutreFiche(i18n))
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$rtfeldman$elm_css$Html$Styled$option,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value(''),
										$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true),
										$rtfeldman$elm_css$Html$Styled$Attributes$selected(
										_Utils_eq(choix, $elm$core$Maybe$Nothing))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape3ApercuAutreFicheChoisir(i18n))
									])),
							A2(
								$elm$core$List$map,
								function (f) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$option,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$value(f.r8),
												$rtfeldman$elm_css$Html$Styled$Attributes$selected(
												_Utils_eq(
													A2($elm$core$Maybe$map, $elm$core$Tuple$first, choix),
													$elm$core$Maybe$Just(f.r8)))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(f.Bl)
											]));
								},
								options.zw)))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$ul,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu-autre-fiche')
					]),
				A2(
					$elm$core$List$map,
					function (ligne) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(ligne)
								]));
					},
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Maybe$map, $elm$core$Tuple$second, choix))))
			]);
	});
var $author$project$Components$Parametrage$PipeEtape3$Update$TraductionDemandee = {$: 12};
var $author$project$I18n$Cles$pipeEtape3TraductionARenseigner = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.traduction.a-renseigner', _List_Nil, 'À renseigner');
};
var $author$project$I18n$Cles$pipeEtape3TraductionAutreLangue = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.traduction.autre-langue',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'langue',
					$author$project$I18n$Traductions$Chaine(p.nn)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.nn + (' : ' + p.Dj));
	});
var $author$project$I18n$Cles$pipeEtape3TraductionCatalogue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.traduction.catalogue', _List_Nil, 'Se traduit comme un nom du catalogue');
};
var $author$project$I18n$Cles$pipeEtape3Traduire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.traduire', _List_Nil, 'Traduire');
};
var $author$project$Components$Parametrage$PipeEtape3$View$carteDeTraduction = F2(
	function (i18n, saisie) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('carte-traduction')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('textes')
						]),
					_Utils_ap(
						A2(
							$elm$core$List$map,
							function (langue) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('langue')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$pipeEtape3TraductionAutreLangue,
												i18n,
												{
													nn: A2($author$project$Referentiel$Langues$nom, i18n, langue.vx),
													Dj: A2(
														$elm$core$Maybe$withDefault,
														$author$project$I18n$Cles$pipeEtape3TraductionARenseigner(i18n),
														A2($elm$core$Dict$get, langue.vx, saisie.R))
												}))
										]));
							},
							A2(
								$elm$core$List$filter,
								function (langue) {
									return langue.vx !== 'fr';
								},
								$author$project$Referentiel$Langues$desLibelles)),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape3TraductionCatalogue(i18n))
									]))
							]))),
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('traduire'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape3$Update$TraductionDemandee)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape3Traduire(i18n))
						]))
				]));
	});
var $author$project$I18n$Cles$pipeEtape3ApercuFicheDExemple = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.apercu.fiche-d-exemple', _List_Nil, 'Fiche d\'exemple');
};
var $author$project$Components$Parametrage$PipeEtape3$View$ficheDExemple = F2(
	function (i18n, personne) {
		return (personne === '') ? _List_Nil : _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$fieldset,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('form-item', true),
								_Utils_Tuple2('fiche-d-exemple', true)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$legend,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape3ApercuFicheDExemple(i18n))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('nom-de-la-fiche')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(personne)
							]))
					]))
			]);
	});
var $author$project$I18n$Cles$pipeEtape3FinDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.fin.debut', _List_Nil, 'Quand la relation prend fin en cours de dossier, ');
};
var $author$project$I18n$Cles$pipeEtape3FinReste = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.fin.reste', _List_Nil, 'le rôle reste');
};
var $author$project$I18n$Cles$pipeEtape3FinResteSuite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.fin.reste-suite', _List_Nil, ' jusqu\'à la fin du dossier.');
};
var $author$project$I18n$Cles$pipeEtape3FinRetire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.fin.retire', _List_Nil, 'le rôle est retiré');
};
var $author$project$I18n$Cles$pipeEtape3FinRetireSuite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.fin.retire-suite', _List_Nil, ' ; le dossier reste accessible à ce rôle, qui y voit la relation passée.');
};
var $author$project$I18n$Cles$pipeEtape3FinValide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.fin.valide', _List_Nil, 'le gestionnaire valide le retrait du rôle');
};
var $author$project$I18n$Cles$pipeEtape3FinValideSuite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.fin.valide-suite', _List_Nil, ' et désigne qui reprend les tâches ouvertes.');
};
var $author$project$Components$Parametrage$PipeEtape3$Phrases$noteDeFin = F2(
	function (i18n, code) {
		switch (code) {
			case 'le-role-est-retire-et-son-acces-se-ferme':
				return _List_fromArray(
					[
						$author$project$Components$Parametrage$PipeEtape3$Phrases$texte(
						$author$project$I18n$Cles$pipeEtape3FinDebut(i18n)),
						$author$project$Components$Parametrage$PipeEtape3$Phrases$fort(
						$author$project$I18n$Cles$pipeEtape3FinRetire(i18n)),
						$author$project$Components$Parametrage$PipeEtape3$Phrases$texte(
						$author$project$I18n$Cles$pipeEtape3FinRetireSuite(i18n))
					]);
			case 'le-role-reste-jusqu-a-la-fin-du-dossier':
				return _List_fromArray(
					[
						$author$project$Components$Parametrage$PipeEtape3$Phrases$texte(
						$author$project$I18n$Cles$pipeEtape3FinDebut(i18n)),
						$author$project$Components$Parametrage$PipeEtape3$Phrases$fort(
						$author$project$I18n$Cles$pipeEtape3FinReste(i18n)),
						$author$project$Components$Parametrage$PipeEtape3$Phrases$texte(
						$author$project$I18n$Cles$pipeEtape3FinResteSuite(i18n))
					]);
			default:
				return _List_fromArray(
					[
						$author$project$Components$Parametrage$PipeEtape3$Phrases$texte(
						$author$project$I18n$Cles$pipeEtape3FinDebut(i18n)),
						$author$project$Components$Parametrage$PipeEtape3$Phrases$fort(
						$author$project$I18n$Cles$pipeEtape3FinValide(i18n)),
						$author$project$Components$Parametrage$PipeEtape3$Phrases$texte(
						$author$project$I18n$Cles$pipeEtape3FinValideSuite(i18n))
					]);
		}
	});
var $author$project$I18n$Cles$pipeEtape3ApercuTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.apercu.titre', _List_Nil, 'Aperçu');
};
var $author$project$I18n$Cles$pipeEtape3ApercuTitreExemple = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.apercu.titre-exemple', _List_Nil, 'Aperçu pour une fiche d\'exemple');
};
var $author$project$I18n$Cles$pipeEtape3CombienPlusieurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.combien.plusieurs', _List_Nil, 'Plusieurs');
};
var $author$project$I18n$Cles$pipeEtape3CombienPlusieursAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.combien.plusieurs-aide', _List_Nil, 'Chacune reçoit sa part du travail ; leurs réponses sont rassemblées.');
};
var $author$project$I18n$Cles$pipeEtape3CombienTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.combien.titre', _List_Nil, 'Combien de personnes ?');
};
var $author$project$I18n$Cles$pipeEtape3CombienUne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.combien.une', _List_Nil, 'Une seule');
};
var $author$project$I18n$Cles$pipeEtape3CombienUneAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.combien.une-aide', _List_Nil, 'Une personne tient ce rôle dans le dossier.');
};
var $author$project$I18n$Cles$pipeEtape3CombienUneAideRelation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.combien.une-aide-relation', _List_Nil, 'Une organisation (ou une personne) tient ce rôle dans le dossier.');
};
var $author$project$I18n$Cles$pipeEtape3NatureExterneAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.nature.externe-aide', _List_Nil, 'Elle intervient par un portail, sans compte interne.');
};
var $author$project$I18n$Cles$pipeEtape3NatureInterneAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.nature.interne-aide', _List_Nil, 'La personne a un compte dans votre équipe.');
};
var $author$project$I18n$Cles$pipeEtape3NatureLesDeuxAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.nature.les-deux-aide', _List_Nil, 'On choisit à chaque dossier.');
};
var $author$project$I18n$Cles$pipeEtape3NatureLesDeuxIntitule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.nature.les-deux-intitule', _List_Nil, 'Les deux');
};
var $author$project$I18n$Cles$pipeEtape3NatureTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.nature.titre', _List_Nil, 'Interne ou externe ?');
};
var $author$project$I18n$Cles$pipeEtape3NomLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.nom.libelle', _List_Nil, 'Nom du rôle');
};
var $author$project$I18n$Cles$pipeEtape3NomTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.nom.titre', _List_Nil, 'Nom');
};
var $author$project$Components$Parametrage$PipeEtape3$Update$AucunContactChoisi = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Parametrage$PipeEtape3$Update$PerimetreBascule = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Parametrage$PipeEtape3$Update$PosteBascule = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$I18n$Cles$pipeEtape3PosteAucunContact = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.poste.aucun-contact',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'organisation',
					$author$project$I18n$Traductions$Chaine(p.En))
				]),
			'Aucun contact chez ' + p.En);
	});
var $author$project$I18n$Cles$pipeEtape3PosteContacts = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.poste.contacts',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w)),
					_Utils_Tuple2(
					'organisation',
					$author$project$I18n$Traductions$Chaine(p.En))
				]),
			p.w + (' contacts chez ' + p.En));
	});
var $author$project$I18n$Cles$pipeEtape3PosteUnContact = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.poste.un-contact',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'organisation',
					$author$project$I18n$Traductions$Chaine(p.En))
				]),
			'1 contact chez ' + p.En);
	});
var $author$project$Components$Parametrage$PipeEtape3$View$contactsDuPoste = F2(
	function (i18n, poste) {
		var _v0 = _Utils_Tuple2(poste.Dy, poste.va);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			switch (_v0.a.a) {
				case 0:
					var organisation = _v0.b.a;
					return A2(
						$author$project$I18n$Cles$pipeEtape3PosteAucunContact,
						i18n,
						{En: organisation});
				case 1:
					var organisation = _v0.b.a;
					return A2(
						$author$project$I18n$Cles$pipeEtape3PosteUnContact,
						i18n,
						{En: organisation});
				default:
					var nombre = _v0.a.a;
					var organisation = _v0.b.a;
					return A2(
						$author$project$I18n$Cles$pipeEtape3PosteContacts,
						i18n,
						{
							w: $elm$core$String$fromInt(nombre),
							En: organisation
						});
			}
		} else {
			return '';
		}
	});
var $author$project$I18n$Cles$pipeEtape3PerimetreAucunTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.perimetre.aucun-titre', _List_Nil, 'Si aucun contact ne couvre cette fiche');
};
var $author$project$I18n$Cles$pipeEtape3PerimetreContactPrincipal = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.perimetre.contact-principal', _List_Nil, 'Le contact principal agit');
};
var $author$project$I18n$Cles$pipeEtape3PerimetreContactPrincipalAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.perimetre.contact-principal-aide', _List_Nil, 'Le dossier reste traité, au prix d\'un contact hors périmètre.');
};
var $author$project$I18n$Cles$pipeEtape3PerimetrePersonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.perimetre.personne', _List_Nil, 'Personne n\'agit');
};
var $author$project$I18n$Cles$pipeEtape3PerimetrePersonneAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.perimetre.personne-aide', _List_Nil, 'Le rôle reste à remplir ; signalé sur le dossier.');
};
var $author$project$I18n$Cles$pipeEtape3PerimetreSelon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.perimetre.selon', _List_Nil, 'Selon le périmètre de chaque contact');
};
var $author$project$I18n$Cles$pipeEtape3PerimetreSelonAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.perimetre.selon-aide', _List_Nil, 'Un contact dont le périmètre ne contient pas la fiche n\'a ni le dossier, ni la liste, ni le portail de cette fiche. Un contact sans périmètre couvre tout.');
};
var $author$project$I18n$Cles$pipeEtape3PerimetreTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.perimetre.titre', _List_Nil, 'Périmètre de chaque contact');
};
var $author$project$I18n$Cles$pipeEtape3PosteIntro = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.poste.intro', _List_Nil, 'Les personnes de l\'organisation qui agissent pour elle sont celles qui ont l\'un de ces postes.');
};
var $author$project$I18n$Cles$pipeEtape3PosteOption = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.poste.option',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'poste',
					$author$project$I18n$Traductions$Chaine(p.F4))
				]),
			p.F4);
	});
var $author$project$I18n$Cles$pipeEtape3PosteSousTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.poste.sous-titre', _List_Nil, 'Postes qui agissent pour elle');
};
var $author$project$I18n$Cles$pipeEtape3PosteTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.poste.titre', _List_Nil, 'Si une organisation tient le rôle');
};
var $author$project$I18n$Cles$pipeEtape3PosteTitreFiche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.poste.titre-fiche', _List_Nil, 'Si la fiche désignée est une organisation');
};
var $author$project$I18n$Cles$pipeEtape3PostesAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.postes.aide', _List_Nil, 'Plusieurs postes se choisissent. Sans poste, le contact principal agit (sinon : publication refusée).');
};
var $author$project$I18n$Cles$pipeEtape3PostesAideChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.postes.aide-champ', _List_Nil, 'Mêmes réglages que pour une relation.');
};
var $author$project$Components$Parametrage$PipeEtape3$View$postesEtPerimetre = F3(
	function (i18n, options, saisie) {
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				saisie.EM ? $author$project$I18n$Cles$pipeEtape3PosteTitreFiche(i18n) : $author$project$I18n$Cles$pipeEtape3PosteTitre(i18n),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape3PosteIntro(i18n))
							])),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('sous-titre')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape3PosteSousTitre(i18n))
										]))
								])),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								function (poste) {
									return A5(
										$author$project$Components$Parametrage$Common$Conception$caseACocher,
										'poste',
										A2($elm$core$List$member, poste.r8, saisie.F7),
										A2(
											$author$project$I18n$Cles$pipeEtape3PosteOption,
											i18n,
											{F4: poste.Bl}),
										A2($author$project$Components$Parametrage$PipeEtape3$View$contactsDuPoste, i18n, poste),
										$author$project$Components$Parametrage$PipeEtape3$Update$PosteBascule(poste.r8));
								},
								options.F6),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											saisie.EM ? $author$project$I18n$Cles$pipeEtape3PostesAideChamp(i18n) : $author$project$I18n$Cles$pipeEtape3PostesAide(i18n))
										]))
								]))))),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape3PerimetreTitre(i18n),
				A2(
					$elm$core$List$cons,
					A5(
						$author$project$Components$Parametrage$Common$Conception$caseACocher,
						'selon-le-perimetre',
						saisie.IB,
						$author$project$I18n$Cles$pipeEtape3PerimetreSelon(i18n),
						$author$project$I18n$Cles$pipeEtape3PerimetreSelonAide(i18n),
						$author$project$Components$Parametrage$PipeEtape3$Update$PerimetreBascule),
					saisie.IB ? _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape3PerimetreAucunTitre(i18n))
										]))
								])),
							A6(
							$author$project$Components$Parametrage$Common$Conception$choix,
							'aucun-contact',
							'contact-principal',
							saisie.tZ === 'contact-principal',
							$author$project$I18n$Cles$pipeEtape3PerimetreContactPrincipal(i18n),
							$author$project$I18n$Cles$pipeEtape3PerimetreContactPrincipalAide(i18n),
							$author$project$Components$Parametrage$PipeEtape3$Update$AucunContactChoisi('contact-principal')),
							A6(
							$author$project$Components$Parametrage$Common$Conception$choix,
							'aucun-contact',
							'personne',
							saisie.tZ === 'personne',
							$author$project$I18n$Cles$pipeEtape3PerimetrePersonne(i18n),
							$author$project$I18n$Cles$pipeEtape3PerimetrePersonneAide(i18n),
							$author$project$Components$Parametrage$PipeEtape3$Update$AucunContactChoisi('personne'))
						]) : _List_Nil))
			]);
	});
var $author$project$Components$Parametrage$PipeEtape3$Update$TenueChoisie = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Parametrage$PipeEtape3$Update$TenueParUnChampChoisie = {$: 18};
var $author$project$Components$Parametrage$PipeEtape3$Update$AucuneValeurChoisie = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Parametrage$PipeEtape3$Update$ChampChoisi = function (a) {
	return {$: 19, a: a};
};
var $author$project$I18n$Cles$pipeEtape3ChampAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.champ.aide', _List_Nil, 'Un champ à plusieurs valeurs ne convient pas à un rôle « une seule ».');
};
var $author$project$I18n$Cles$pipeEtape3ChampAucuneValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.champ.aucune-valeur', _List_Nil, 'Si le champ est vide');
};
var $author$project$I18n$Cles$pipeEtape3ChampAucuneValeurOuvre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.champ.aucune-valeur-ouvre', _List_Nil, 'Le dossier s\'ouvre, le rôle reste à remplir');
};
var $author$project$I18n$Cles$pipeEtape3ChampAucuneValeurRefuse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.champ.aucune-valeur-refuse', _List_Nil, 'Le dossier ne peut pas s\'ouvrir');
};
var $author$project$I18n$Cles$pipeEtape3ChampLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.champ.libelle', _List_Nil, 'Champ partie prenante de la fiche visée');
};
var $author$project$I18n$Cles$pipeEtape3ChampTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.champ.titre', _List_Nil, 'Le champ');
};
var $author$project$I18n$Cles$pipeEtape3ChampVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.champ.vide', _List_Nil, 'Aucun champ de type partie prenante sur la fiche visée.');
};
var $author$project$Components$Parametrage$PipeEtape3$View$champDuRole = F3(
	function (i18n, options, saisie) {
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape3ChampTitre(i18n),
				A2(
					$elm$core$List$cons,
					$elm$core$List$isEmpty(options.dw) ? A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aucun-champ')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape3ChampVide(i18n))
							])) : A4(
						$author$project$Components$Parametrage$Common$Conception$liste,
						$author$project$I18n$Cles$pipeEtape3ChampLibelle(i18n),
						saisie.uN,
						options.dw,
						$author$project$Components$Parametrage$PipeEtape3$Update$ChampChoisi),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape3ChampAide(i18n))
								])),
						_List_fromArray(
							[
								A4(
								$author$project$Components$Parametrage$Common$Conception$liste,
								$author$project$I18n$Cles$pipeEtape3ChampAucuneValeur(i18n),
								saisie.t_,
								_List_fromArray(
									[
										_Utils_Tuple2(
										'le-dossier-s-ouvre-et-le-role-reste-a-remplir',
										$author$project$I18n$Cles$pipeEtape3ChampAucuneValeurOuvre(i18n)),
										_Utils_Tuple2(
										'le-dossier-ne-peut-pas-s-ouvrir',
										$author$project$I18n$Cles$pipeEtape3ChampAucuneValeurRefuse(i18n))
									]),
								$author$project$Components$Parametrage$PipeEtape3$Update$AucuneValeurChoisie)
							]))))
			]);
	});
var $author$project$I18n$Cles$pipeEtape3TenueAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.tenue.aide', _List_Nil, 'Choisissez comment le rôle est rempli dans chaque dossier.');
};
var $author$project$I18n$Cles$pipeEtape3TenueChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.tenue-champ', _List_Nil, 'Tenu par un champ de la fiche visée');
};
var $author$project$I18n$Cles$pipeEtape3TenueChampAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.tenue-champ-aide', _List_Nil, 'Le rôle revient à la fiche que le champ désigne. Il change quand la valeur du champ change.');
};
var $author$project$I18n$Cles$pipeEtape3TenueChoisi = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.tenue.choisi', _List_Nil, 'Choisi dans chaque dossier');
};
var $author$project$I18n$Cles$pipeEtape3TenueChoisiAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.tenue.choisi-aide', _List_Nil, 'Un utilisateur de l\'équipe, une partie prenante ou un groupe, comme pour les autres rôles.');
};
var $author$project$I18n$Cles$pipeEtape3TenueRelation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.tenue.relation', _List_Nil, 'Tenu par une relation de la personne du dossier');
};
var $author$project$I18n$Cles$pipeEtape3TenueRelationAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.tenue.relation-aide', _List_Nil, 'Le rôle revient à la personne ou à l\'organisation liée à celle du dossier par un type de relation. Personne n\'a à le remplir à la main.');
};
var $author$project$I18n$Cles$pipeEtape3TenueTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.tenue.titre', _List_Nil, 'Qui tient ce rôle ?');
};
var $author$project$Components$Parametrage$PipeEtape3$Update$AucuneRelationChoisie = function (a) {
	return {$: 27, a: a};
};
var $author$project$Components$Parametrage$PipeEtape3$Update$PlusieursRelationsChoisi = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$Parametrage$PipeEtape3$Update$RelationTermineeChoisie = function (a) {
	return {$: 28, a: a};
};
var $author$project$Components$Parametrage$PipeEtape3$Update$SensChoisi = function (a) {
	return {$: 25, a: a};
};
var $author$project$Components$Parametrage$PipeEtape3$Update$TypeDeRelationChoisi = function (a) {
	return {$: 24, a: a};
};
var $author$project$I18n$Cles$pipeEtape3CibleOrganisation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.cible.organisation', _List_Nil, 'une personne à une organisation');
};
var $author$project$I18n$Cles$pipeEtape3CiblePersonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.cible.personne', _List_Nil, 'une personne à une personne');
};
var $author$project$Components$Parametrage$PipeEtape3$View$cibleDe = F2(
	function (i18n, tenuPar) {
		return _Utils_eq(tenuPar, $author$project$Components$Parametrage$Vocabulaire$tenuParOrganisation) ? $author$project$I18n$Cles$pipeEtape3CibleOrganisation(i18n) : $author$project$I18n$Cles$pipeEtape3CiblePersonne(i18n);
	});
var $author$project$I18n$Cles$pipeEtape3AucuneLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.aucune.libelle', _List_Nil, 'Aucune relation à l\'ouverture');
};
var $author$project$I18n$Cles$pipeEtape3AucuneOuvre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.aucune.ouvre', _List_Nil, 'Le dossier s\'ouvre, le rôle reste à remplir (signalé sur la fiche)');
};
var $author$project$I18n$Cles$pipeEtape3AucuneRefuse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.aucune.refuse', _List_Nil, 'Le dossier ne peut pas s\'ouvrir');
};
var $author$project$I18n$Cles$pipeEtape3AucuneTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.aucune.titre', _List_Nil, 'Si elle n\'en a aucune, ou si la relation prend fin');
};
var $author$project$I18n$Cles$pipeEtape3PlusieursChoisit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.plusieurs.choisit', _List_Nil, 'Le gestionnaire choisit dans le dossier');
};
var $author$project$I18n$Cles$pipeEtape3PlusieursChoisitAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.plusieurs.choisit-aide', _List_Nil, 'La liste des relations est proposée à l\'ouverture.');
};
var $author$project$I18n$Cles$pipeEtape3PlusieursRecente = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.plusieurs.recente', _List_Nil, 'La plus récente seulement');
};
var $author$project$I18n$Cles$pipeEtape3PlusieursRecenteAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.plusieurs.recente-aide', _List_Nil, 'Les autres relations sont ignorées par ce pipe.');
};
var $author$project$I18n$Cles$pipeEtape3PlusieursTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.plusieurs.titre', _List_Nil, 'Si la personne a plusieurs relations de ce type');
};
var $author$project$I18n$Cles$pipeEtape3PlusieursToutes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.plusieurs.toutes', _List_Nil, 'Elles tiennent toutes le rôle');
};
var $author$project$I18n$Cles$pipeEtape3PlusieursToutesAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.plusieurs.toutes-aide', _List_Nil, 'Chacune reçoit ses tâches et ses communications.');
};
var $author$project$I18n$Cles$pipeEtape3RelationRelie = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.relation.relie',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'relation',
					$author$project$I18n$Traductions$Chaine(p.Ht)),
					_Utils_Tuple2(
					'cible',
					$author$project$I18n$Traductions$Chaine(p.vf))
				]),
			'Le type « ' + (p.Ht + (' » relie ' + (p.vf + ' : ce rôle est donc tenu par une '))));
	});
var $author$project$I18n$Cles$pipeEtape3RelationSens = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.relation.sens', _List_Nil, 'Sens');
};
var $author$project$I18n$Cles$pipeEtape3RelationTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.relation.titre', _List_Nil, 'La relation qui désigne le rôle');
};
var $author$project$I18n$Cles$pipeEtape3RelationType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.relation.type', _List_Nil, 'Type de relation');
};
var $author$project$I18n$Cles$pipeEtape3SensLie = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.sens.lie',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'relation',
					$author$project$I18n$Traductions$Chaine(p.Ht))
				]),
			'Celui qui est lié à la personne du dossier par « ' + (p.Ht + ' »'));
	});
var $author$project$I18n$Cles$pipeEtape3SensVers = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.sens.vers',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'relation',
					$author$project$I18n$Traductions$Chaine(p.Ht))
				]),
			'Celui vers qui la personne du dossier est liée par « ' + (p.Ht + ' »'));
	});
var $author$project$I18n$Cles$pipeEtape3TermineeLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.terminee.libelle', _List_Nil, 'Relation terminée en cours de dossier');
};
var $author$project$I18n$Cles$pipeEtape3TermineeReste = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.terminee.reste', _List_Nil, 'Le rôle reste jusqu\'à la fin du dossier');
};
var $author$project$I18n$Cles$pipeEtape3TermineeRetire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.terminee.retire', _List_Nil, 'Le rôle est retiré ; le dossier reste accessible, avec la relation passée');
};
var $author$project$I18n$Cles$pipeEtape3TermineeValide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.terminee.valide', _List_Nil, 'Le gestionnaire valide le retrait du rôle et désigne le repreneur des tâches');
};
var $author$project$I18n$Cles$pipeEtape3QualiteOrganisation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.qualite.organisation', _List_Nil, 'organisation');
};
var $author$project$I18n$Cles$pipeEtape3QualitePersonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.qualite.personne', _List_Nil, 'personne');
};
var $author$project$Components$Parametrage$PipeEtape3$View$qualiteDe = F2(
	function (i18n, tenuPar) {
		return _Utils_eq(tenuPar, $author$project$Components$Parametrage$Vocabulaire$tenuParOrganisation) ? $author$project$I18n$Cles$pipeEtape3QualiteOrganisation(i18n) : $author$project$I18n$Cles$pipeEtape3QualitePersonne(i18n);
	});
var $author$project$Components$Parametrage$PipeEtape3$View$relation = F3(
	function (i18n, options, saisie) {
		var lue = saisie.Ht;
		var types = A2(
			$elm$core$List$map,
			function (type_) {
				return _Utils_Tuple2(type_.r8, type_.Bl);
			},
			A2(
				$elm$core$List$filter,
				function (type_) {
					return (!type_.tE) || _Utils_eq(type_.r8, lue.JX);
				},
				options.J2));
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape3RelationTitre(i18n),
				_List_fromArray(
					[
						A4(
						$author$project$Components$Parametrage$Common$Conception$liste,
						$author$project$I18n$Cles$pipeEtape3RelationType(i18n),
						lue.JX,
						types,
						$author$project$Components$Parametrage$PipeEtape3$Update$TypeDeRelationChoisi),
						A4(
						$author$project$Components$Parametrage$Common$Conception$liste,
						$author$project$I18n$Cles$pipeEtape3RelationSens(i18n),
						lue.IC,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'vers-celui-lie',
								A2(
									$author$project$I18n$Cles$pipeEtape3SensVers,
									i18n,
									{Ht: lue.Bl})),
								_Utils_Tuple2(
								'lie-a-la-personne',
								A2(
									$author$project$I18n$Cles$pipeEtape3SensLie,
									i18n,
									{Ht: lue.Bl}))
							]),
						$author$project$Components$Parametrage$PipeEtape3$Update$SensChoisi),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$pipeEtape3RelationRelie,
									i18n,
									{
										vf: A2($author$project$Components$Parametrage$PipeEtape3$View$cibleDe, i18n, lue.e9),
										Ht: lue.Bl
									})),
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$Components$Parametrage$PipeEtape3$View$qualiteDe, i18n, lue.e9))
									])),
								$rtfeldman$elm_css$Html$Styled$text('.')
							]))
					])),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape3PlusieursTitre(i18n),
				_List_fromArray(
					[
						A6(
						$author$project$Components$Parametrage$Common$Conception$choix,
						'plusieurs-relations',
						'le-gestionnaire-choisit',
						lue.qT === 'le-gestionnaire-choisit',
						$author$project$I18n$Cles$pipeEtape3PlusieursChoisit(i18n),
						$author$project$I18n$Cles$pipeEtape3PlusieursChoisitAide(i18n),
						$author$project$Components$Parametrage$PipeEtape3$Update$PlusieursRelationsChoisi('le-gestionnaire-choisit')),
						A6(
						$author$project$Components$Parametrage$Common$Conception$choix,
						'plusieurs-relations',
						'toutes-tiennent-le-role',
						lue.qT === 'toutes-tiennent-le-role',
						$author$project$I18n$Cles$pipeEtape3PlusieursToutes(i18n),
						$author$project$I18n$Cles$pipeEtape3PlusieursToutesAide(i18n),
						$author$project$Components$Parametrage$PipeEtape3$Update$PlusieursRelationsChoisi('toutes-tiennent-le-role')),
						A6(
						$author$project$Components$Parametrage$Common$Conception$choix,
						'plusieurs-relations',
						'la-plus-recente-seulement',
						lue.qT === 'la-plus-recente-seulement',
						$author$project$I18n$Cles$pipeEtape3PlusieursRecente(i18n),
						$author$project$I18n$Cles$pipeEtape3PlusieursRecenteAide(i18n),
						$author$project$Components$Parametrage$PipeEtape3$Update$PlusieursRelationsChoisi('la-plus-recente-seulement'))
					])),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape3AucuneTitre(i18n),
				_List_fromArray(
					[
						A4(
						$author$project$Components$Parametrage$Common$Conception$liste,
						$author$project$I18n$Cles$pipeEtape3AucuneLibelle(i18n),
						lue.i9,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'le-dossier-s-ouvre-et-le-role-reste-a-remplir',
								$author$project$I18n$Cles$pipeEtape3AucuneOuvre(i18n)),
								_Utils_Tuple2(
								'le-dossier-ne-peut-pas-s-ouvrir',
								$author$project$I18n$Cles$pipeEtape3AucuneRefuse(i18n))
							]),
						$author$project$Components$Parametrage$PipeEtape3$Update$AucuneRelationChoisie),
						A4(
						$author$project$Components$Parametrage$Common$Conception$liste,
						$author$project$I18n$Cles$pipeEtape3TermineeLibelle(i18n),
						lue.qi,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'le-gestionnaire-valide-le-retrait-et-designe-le-repreneur',
								$author$project$I18n$Cles$pipeEtape3TermineeValide(i18n)),
								_Utils_Tuple2(
								'le-role-est-retire-et-son-acces-se-ferme',
								$author$project$I18n$Cles$pipeEtape3TermineeRetire(i18n)),
								_Utils_Tuple2(
								'le-role-reste-jusqu-a-la-fin-du-dossier',
								$author$project$I18n$Cles$pipeEtape3TermineeReste(i18n))
							]),
						$author$project$Components$Parametrage$PipeEtape3$Update$RelationTermineeChoisie)
					]))
			]);
	});
var $author$project$Components$Parametrage$PipeEtape3$Update$PeutEtreBascule = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Parametrage$PipeEtape3$View$case1 = F4(
	function (saisie, case_, titre, aide) {
		return A5(
			$author$project$Components$Parametrage$Common$Conception$caseACocher,
			'peut-etre',
			A3($author$project$Components$Parametrage$PipeEtape3$Model$estCoche, case_.M, case_.r8, saisie.Fl),
			titre,
			aide,
			function (_v0) {
				return $author$project$Components$Parametrage$PipeEtape3$Update$PeutEtreBascule(case_);
			});
	});
var $author$project$Components$Parametrage$PipeEtape3$View$groupe = F2(
	function (titre, cases) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$fieldset,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('groupe-de-cases')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$legend,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(titre)
						])),
				cases));
	});
var $author$project$I18n$Cles$pipeEtape3SourcesAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.sources.aide', _List_Nil, 'Cochez ce qui est permis. Le choix se fait ensuite dans chaque dossier.');
};
var $author$project$I18n$Cles$pipeEtape3SourcesGroupeExemple = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.sources.groupe-exemple',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			'Ex. : ' + p.Bl);
	});
var $author$project$I18n$Cles$pipeEtape3SourcesGroupeFixe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.sources.groupe-fixe', _List_Nil, 'Un groupe fixé par le pipe');
};
var $author$project$I18n$Cles$pipeEtape3SourcesGroupes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.sources.groupes', _List_Nil, 'Groupe d\'intervenants');
};
var $author$project$I18n$Cles$pipeEtape3SourcesPartiesPrenantes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.sources.parties-prenantes', _List_Nil, 'Parties prenantes');
};
var $author$project$I18n$Cles$pipeEtape3SourcesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.sources.titre', _List_Nil, 'Qui peut tenir ce rôle ?');
};
var $author$project$Components$Parametrage$PipeEtape3$View$sources = F3(
	function (i18n, options, saisie) {
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape3SourcesTitre(i18n),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape3SourcesAide(i18n))
							])),
						A2(
						$author$project$Components$Parametrage$PipeEtape3$View$groupe,
						$author$project$I18n$Cles$pipeEtape3SourcesPartiesPrenantes(i18n),
						A2(
							$elm$core$List$map,
							function (type_) {
								return A4(
									$author$project$Components$Parametrage$PipeEtape3$View$case1,
									saisie,
									{
										M: $author$project$Components$Parametrage$Vocabulaire$genrePartiePrenante,
										Bl: type_.Bl,
										r8: $elm$core$Maybe$Just(type_.r8)
									},
									type_.Bl,
									'');
							},
							options.J$)),
						A2(
						$author$project$Components$Parametrage$PipeEtape3$View$groupe,
						$author$project$I18n$Cles$pipeEtape3SourcesGroupes(i18n),
						A2(
							$elm$core$List$map,
							function (lu) {
								return A4(
									$author$project$Components$Parametrage$PipeEtape3$View$case1,
									saisie,
									{
										M: $author$project$Components$Parametrage$Vocabulaire$genreGroupe,
										Bl: lu.Bl,
										r8: $elm$core$Maybe$Just(lu.r8)
									},
									$author$project$I18n$Cles$pipeEtape3SourcesGroupeFixe(i18n),
									A2(
										$author$project$I18n$Cles$pipeEtape3SourcesGroupeExemple,
										i18n,
										{Bl: lu.Bl}));
							},
							options.Ac))
					]))
			]);
	});
var $author$project$Components$Parametrage$PipeEtape3$View$quiTientLeRole = F3(
	function (i18n, options, saisie) {
		return (saisie.EW || (saisie.EM || _Utils_eq(saisie.r8, $elm$core$Maybe$Nothing))) ? _Utils_ap(
			_List_fromArray(
				[
					A2(
					$author$project$Components$Parametrage$Common$Conception$drawerSection,
					$author$project$I18n$Cles$pipeEtape3TenueTitre(i18n),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape3TenueAide(i18n))
								])),
							A6(
							$author$project$Components$Parametrage$Common$Conception$choix,
							'tenue',
							'choisi',
							(!saisie.EW) && (!saisie.EM),
							$author$project$I18n$Cles$pipeEtape3TenueChoisi(i18n),
							$author$project$I18n$Cles$pipeEtape3TenueChoisiAide(i18n),
							$author$project$Components$Parametrage$PipeEtape3$Update$TenueChoisie(false)),
							A6(
							$author$project$Components$Parametrage$Common$Conception$choix,
							'tenue',
							'relation',
							saisie.EW,
							$author$project$I18n$Cles$pipeEtape3TenueRelation(i18n),
							$author$project$I18n$Cles$pipeEtape3TenueRelationAide(i18n),
							$author$project$Components$Parametrage$PipeEtape3$Update$TenueChoisie(true)),
							A6(
							$author$project$Components$Parametrage$Common$Conception$choix,
							'tenue',
							'champ',
							saisie.EM,
							$author$project$I18n$Cles$pipeEtape3TenueChamp(i18n),
							$author$project$I18n$Cles$pipeEtape3TenueChampAide(i18n),
							$author$project$Components$Parametrage$PipeEtape3$Update$TenueParUnChampChoisie)
						]))
				]),
			saisie.EW ? A3($author$project$Components$Parametrage$PipeEtape3$View$relation, i18n, options, saisie) : (saisie.EM ? A3($author$project$Components$Parametrage$PipeEtape3$View$champDuRole, i18n, options, saisie) : A3($author$project$Components$Parametrage$PipeEtape3$View$sources, i18n, options, saisie))) : A3($author$project$Components$Parametrage$PipeEtape3$View$sources, i18n, options, saisie);
	});
var $author$project$I18n$Cles$pipeEtape3RecoitTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.recoit.texte', _List_Nil, 'Ce rôle est un rôle comme un autre : ses tâches lui sont confiées à l\'étape 4, il reçoit les communications de l\'étape 7, il voit le dossier selon ses droits de l\'étape 6, il peut signer ou payer.');
};
var $author$project$I18n$Cles$pipeEtape3RecoitTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.recoit.titre', _List_Nil, 'Ce que le rôle reçoit');
};
var $author$project$Components$Parametrage$PipeEtape3$View$reception = function (i18n) {
	return _List_fromArray(
		[
			A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape3RecoitTitre(i18n),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape3RecoitTexte(i18n))
						]))
				]))
		]);
};
var $author$project$Components$Parametrage$PipeEtape3$View$segments = $elm$core$List$map(
	function (segment) {
		return segment.dX ? A2(
			$rtfeldman$elm_css$Html$Styled$strong,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(segment.Jx)
				])) : $rtfeldman$elm_css$Html$Styled$text(segment.Jx);
	});
var $author$project$Components$Parametrage$PipeEtape3$View$contenuDuRole = F6(
	function (i18n, choixDeFiche, objetVise, personne, options, saisie) {
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$author$project$Components$Parametrage$Common$Conception$drawerSection,
					$author$project$I18n$Cles$pipeEtape3NomTitre(i18n),
					_List_fromArray(
						[
							A3(
							$author$project$Components$Parametrage$Common$Conception$champDeTexte,
							$author$project$I18n$Cles$pipeEtape3NomLibelle(i18n),
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Dict$get, 'fr', saisie.R)),
							$author$project$Components$Parametrage$PipeEtape3$Update$NomSaisi('fr')),
							A2($author$project$Components$Parametrage$PipeEtape3$View$carteDeTraduction, i18n, saisie)
						])),
					A2(
					$author$project$Components$Parametrage$Common$Conception$drawerSection,
					$author$project$I18n$Cles$pipeEtape3NatureTitre(i18n),
					_List_fromArray(
						[
							A6(
							$author$project$Components$Parametrage$Common$Conception$choix,
							'nature',
							'interne',
							!saisie.g1,
							$author$project$I18n$Cles$pipeEtape3NatureInterne(i18n),
							$author$project$I18n$Cles$pipeEtape3NatureInterneAide(i18n),
							$author$project$Components$Parametrage$PipeEtape3$Update$NatureChoisie(0)),
							A6(
							$author$project$Components$Parametrage$Common$Conception$choix,
							'nature',
							'externe',
							saisie.g1 === 1,
							$author$project$I18n$Cles$pipeEtape3NatureExterne(i18n),
							$author$project$I18n$Cles$pipeEtape3NatureExterneAide(i18n),
							$author$project$Components$Parametrage$PipeEtape3$Update$NatureChoisie(1)),
							A6(
							$author$project$Components$Parametrage$Common$Conception$choix,
							'nature',
							'interne-ou-externe',
							saisie.g1 === 2,
							$author$project$I18n$Cles$pipeEtape3NatureLesDeuxIntitule(i18n),
							$author$project$I18n$Cles$pipeEtape3NatureLesDeuxAide(i18n),
							$author$project$Components$Parametrage$PipeEtape3$Update$NatureChoisie(2))
						])),
					A2(
					$author$project$Components$Parametrage$Common$Conception$drawerSection,
					$author$project$I18n$Cles$pipeEtape3CombienTitre(i18n),
					_List_fromArray(
						[
							A6(
							$author$project$Components$Parametrage$Common$Conception$choix,
							'cardinalite',
							'une-seule',
							!saisie.jz,
							$author$project$I18n$Cles$pipeEtape3CombienUne(i18n),
							saisie.EW ? $author$project$I18n$Cles$pipeEtape3CombienUneAideRelation(i18n) : $author$project$I18n$Cles$pipeEtape3CombienUneAide(i18n),
							$author$project$Components$Parametrage$PipeEtape3$Update$CardinaliteChoisie(0)),
							A6(
							$author$project$Components$Parametrage$Common$Conception$choix,
							'cardinalite',
							'plusieurs',
							saisie.jz === 1,
							$author$project$I18n$Cles$pipeEtape3CombienPlusieurs(i18n),
							$author$project$I18n$Cles$pipeEtape3CombienPlusieursAide(i18n),
							$author$project$Components$Parametrage$PipeEtape3$Update$CardinaliteChoisie(1))
						]))
				]),
			_Utils_ap(
				A3($author$project$Components$Parametrage$PipeEtape3$View$quiTientLeRole, i18n, options, saisie),
				_Utils_ap(
					(saisie.EW || saisie.EM) ? A3($author$project$Components$Parametrage$PipeEtape3$View$postesEtPerimetre, i18n, options, saisie) : _List_Nil,
					_Utils_ap(
						saisie.EW ? $author$project$Components$Parametrage$PipeEtape3$View$reception(i18n) : _List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$Parametrage$Common$Conception$drawerSection,
								(saisie.EW || saisie.EM) ? $author$project$I18n$Cles$pipeEtape3ApercuTitreExemple(i18n) : $author$project$I18n$Cles$pipeEtape3ApercuTitre(i18n),
								_Utils_ap(
									A2($author$project$Components$Parametrage$PipeEtape3$View$ficheDExemple, i18n, personne),
									A2(
										$elm$core$List$cons,
										A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu-du-role')
												]),
											$author$project$Components$Parametrage$PipeEtape3$View$segments(
												A4($author$project$Components$Parametrage$PipeEtape3$Phrases$apercuDuRole, i18n, personne, options, saisie))),
										_Utils_ap(
											saisie.EW ? _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
														]),
													$author$project$Components$Parametrage$PipeEtape3$View$segments(
														A2($author$project$Components$Parametrage$PipeEtape3$Phrases$noteDeFin, i18n, saisie.Ht.qi)))
												]) : _List_Nil,
											A3($author$project$Components$Parametrage$PipeEtape3$View$autresFiches, i18n, choixDeFiche, options)))))
							])))));
	});
var $author$project$Components$Parametrage$PipeEtape3$View$nomEnregistre = F2(
	function (model, saisie) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Dict$get, 'fr', saisie.R)),
			A2(
				$elm$core$Maybe$andThen,
				function (lu) {
					return A2($elm$core$Dict$get, 'fr', lu.R);
				},
				model.bi));
	});
var $author$project$I18n$Cles$pipeEtape3DrawerEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.drawer.enregistrer', _List_Nil, 'Enregistrer le rôle');
};
var $author$project$I18n$Cles$pipeEtape3DrawerKicker = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.drawer.kicker', _List_Nil, 'Rôle dans le dossier');
};
var $author$project$I18n$Cles$pipeEtape3DrawerTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.drawer.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Rôle « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$pipeEtape3DrawerTitreAjout = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.drawer.titre-ajout', _List_Nil, 'Ajouter un rôle');
};
var $author$project$Components$Parametrage$PipeEtape3$Update$RetraitDemande = {$: 5};
var $author$project$I18n$Cles$pipeEtape3RetirerAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.retirer.aide', _List_Nil, 'Aucun dossier n\'est lancé sur cette version : le rôle se retire sans trace.');
};
var $author$project$I18n$Cles$pipeEtape3RetirerBouton = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.retirer.bouton',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$pipeEtape3RetirerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.retirer.titre', _List_Nil, 'Retirer');
};
var $author$project$Components$Parametrage$PipeEtape3$View$sectionRetirer = F3(
	function (i18n, model, saisie) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (role) {
				return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerUnRole, role.nQ);
			},
			model.bi);
		if (!_v0.$) {
			return _Utils_eq(saisie.r8, $elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape3RetirerTitre(i18n),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape3RetirerAide(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape3$Update$RetraitDemande)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$pipeEtape3RetirerBouton,
									i18n,
									{
										Dj: A2(
											$elm$core$Maybe$withDefault,
											'',
											A2($elm$core$Dict$get, 'fr', saisie.R))
									}))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$PipeEtape3$Update$TraductionTerminee = {$: 13};
var $author$project$Components$Parametrage$PipeEtape3$View$libellesParLangue = F2(
	function (i18n, saisie) {
		return A3(
			$author$project$Components$Shared$LibellesParLangue$View$view,
			i18n,
			_List_Nil,
			{
				go: function (_v0) {
					return $elm$core$Maybe$Nothing;
				},
				Ba: $author$project$Referentiel$Langues$desLibelles,
				Bl: $author$project$I18n$Cles$pipeEtape3NomLibelle(i18n),
				hg: $author$project$Components$Parametrage$PipeEtape3$Update$NomSaisi,
				pv: $author$project$Components$Parametrage$PipeEtape3$Model$idDuDrawer('nom'),
				fm: function (code) {
					return A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Dict$get, code, saisie.R));
				}
			});
	});
var $author$project$I18n$Cles$pipeEtape3TraductionTerminee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.traduction.terminee', _List_Nil, 'Terminé');
};
var $author$project$Components$Parametrage$PipeEtape3$View$traduction = F2(
	function (i18n, saisie) {
		return _List_fromArray(
			[
				A2($author$project$Components$Parametrage$PipeEtape3$View$libellesParLangue, i18n, saisie),
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape3$Update$TraductionTerminee)
					]),
				$author$project$I18n$Cles$pipeEtape3TraductionTerminee(i18n))
			]);
	});
var $author$project$Components$Parametrage$PipeEtape3$View$contenuDeLaSaisie = F5(
	function (i18n, model, vide, refus, saisie) {
		var _v0 = model.o_;
		if (!_v0.$) {
			var options = _v0.a;
			return _Utils_update(
				vide,
				{
					fs: {
						sR: (!_Utils_eq(
							A2($author$project$Components$Parametrage$PipeEtape3$Model$roleVoulu, options, saisie),
							$elm$core$Maybe$Nothing)) && ((!$author$project$API$Envoi$enCours(model.l2)) && (!model.sr)),
						Bl: $author$project$I18n$Cles$pipeEtape3DrawerEnregistrer(i18n),
						C$: $author$project$Components$Parametrage$PipeEtape3$Update$EnregistrementDemande
					},
					fZ: A2(
						$elm$core$List$cons,
						refus,
						model.rP ? A2($author$project$Components$Parametrage$PipeEtape3$View$traduction, i18n, saisie) : _Utils_ap(
							A6(
								$author$project$Components$Parametrage$PipeEtape3$View$contenuDuRole,
								i18n,
								$author$project$Components$Parametrage$PipeEtape3$View$autreFiche(model),
								A2($elm$core$Maybe$andThen, $author$project$Components$Parametrage$PipeEtape3$View$objetViseDe, model.eX),
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.Fd;
										},
										model.ge)),
								options,
								saisie),
							_List_fromArray(
								[
									A3($author$project$Components$Parametrage$PipeEtape3$View$sectionRetirer, i18n, model, saisie)
								]))),
					A6: $elm$core$Maybe$Just(
						$author$project$I18n$Cles$pipeEtape3DrawerKicker(i18n)),
					h6: _Utils_eq(saisie.r8, $elm$core$Maybe$Nothing) ? $author$project$I18n$Cles$pipeEtape3DrawerTitreAjout(i18n) : A2(
						$author$project$I18n$Cles$pipeEtape3DrawerTitre,
						i18n,
						{
							Dj: A2($author$project$Components$Parametrage$PipeEtape3$View$nomEnregistre, model, saisie)
						})
				});
		} else {
			return vide;
		}
	});
var $author$project$I18n$Cles$pipeEtape3RetraitConfirmer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.retrait.confirmer', _List_Nil, 'Retirer le rôle');
};
var $author$project$I18n$Cles$pipeEtape3RetraitKicker = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.retrait.kicker', _List_Nil, 'Rôle dans le dossier');
};
var $author$project$I18n$Cles$pipeEtape3RetraitTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.retrait.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer le rôle « ' + (p.Dj + ' » ?'));
	});
var $author$project$Components$Parametrage$Vocabulaire$natureDuRole = F2(
	function (i18n, code) {
		switch (code) {
			case 'interne':
				return $author$project$I18n$Cles$pipeEtape3NatureInterne(i18n);
			case 'externe':
				return $author$project$I18n$Cles$pipeEtape3NatureExterne(i18n);
			case 'interne-ou-externe':
				return $author$project$I18n$Cles$pipeEtape3NatureLesDeux(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$I18n$Cles$pipeEtape3RetraitARetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.retrait.a-retirer', _List_Nil, 'À retirer');
};
var $author$project$I18n$Cles$pipeEtape3RetraitAvertissement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.retrait.avertissement', _List_Nil, 'Le rôle disparaît du brouillon. Les dossiers déjà ouverts gardent leurs intervenants.');
};
var $author$project$I18n$Cles$pipeEtape3RetraitDisparait = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-3.retrait.disparait', _List_Nil, 'Ce qui disparaît');
};
var $author$project$I18n$Cles$pipeEtape3RetraitRole = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-3.retrait.role',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Rôle « ' + (p.Dj + ' »'));
	});
var $author$project$Components$Parametrage$PipeEtape3$View$retraitDuRole = F2(
	function (i18n, saisie) {
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape3RetraitARetirer(i18n),
				_List_fromArray(
					[
						$author$project$Components$Parametrage$Common$Conception$lignesDeRetrait(
						_List_fromArray(
							[
								{
								AS: A2(
									$author$project$I18n$Cles$pipeEtape3RetraitRole,
									i18n,
									{
										Dj: A2(
											$elm$core$Maybe$withDefault,
											'',
											A2($elm$core$Dict$get, 'fr', saisie.R))
									}),
								Gd: A2(
									$elm$core$String$join,
									' · ',
									A2(
										$elm$core$List$filter,
										A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
										_List_fromArray(
											[
												A2(
												$author$project$Components$Parametrage$Vocabulaire$natureDuRole,
												i18n,
												$author$project$Components$Parametrage$PipeEtape3$API$QueryAPIModel$codeDeLaNature(saisie.g1)),
												A2(
												$elm$core$Maybe$withDefault,
												'',
												A2($elm$core$Dict$get, 'fr', saisie.dH))
											])))
							}
							]))
					])),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSectionAvertissements,
				$author$project$I18n$Cles$pipeEtape3RetraitDisparait(i18n),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape3RetraitAvertissement(i18n))
							]))
					]))
			]);
	});
var $author$project$Components$Parametrage$PipeEtape3$View$contenuDuDrawer = F2(
	function (i18n, model) {
		var vide = {
			fs: {sR: false, Bl: '', C$: $author$project$Components$Parametrage$PipeEtape3$Update$EnregistrementDemande},
			fZ: _List_Nil,
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: ''
		};
		var refus = A4($author$project$Components$Parametrage$Common$RefusDuParcours$vue, i18n, $author$project$Components$Parametrage$PipeEtape3$Update$Recharger, model.sr, model.pZ);
		var _v0 = _Utils_Tuple2(model.hP, model.o_);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var saisie = _v0.a.a;
			return model.eW ? _Utils_update(
				vide,
				{
					fs: {
						sR: (!$author$project$API$Envoi$enCours(model.l2)) && _Utils_eq(model.pZ, $elm$core$Maybe$Nothing),
						Bl: $author$project$I18n$Cles$pipeEtape3RetraitConfirmer(i18n),
						C$: $author$project$Components$Parametrage$PipeEtape3$Update$RetraitConfirme
					},
					fZ: A2(
						$elm$core$List$cons,
						refus,
						A2($author$project$Components$Parametrage$PipeEtape3$View$retraitDuRole, i18n, saisie)),
					A6: $elm$core$Maybe$Just(
						$author$project$I18n$Cles$pipeEtape3RetraitKicker(i18n)),
					h6: A2(
						$author$project$I18n$Cles$pipeEtape3RetraitTitre,
						i18n,
						{
							Dj: A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Dict$get, 'fr', saisie.R))
						})
				}) : A5($author$project$Components$Parametrage$PipeEtape3$View$contenuDeLaSaisie, i18n, model, vide, refus, saisie);
		} else {
			return vide;
		}
	});
var $author$project$Components$Parametrage$PipeEtape3$View$videSiFerme = F2(
	function (model, contenu) {
		return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) ? contenu : _Utils_update(
			contenu,
			{fZ: _List_Nil, A6: $elm$core$Maybe$Nothing, h6: ''});
	});
var $author$project$Components$Parametrage$PipeEtape3$View$drawer = F2(
	function (i18n, model) {
		return model.eW ? A4(
			$author$project$Components$Shared$Drawer$View$viewDestructif,
			i18n,
			$author$project$Components$Parametrage$PipeEtape3$Update$DuDrawer,
			A2($author$project$Components$Parametrage$PipeEtape3$View$contenuDuDrawer, i18n, model),
			model.kX) : A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Parametrage$PipeEtape3$Update$DuDrawer,
			A2(
				$author$project$Components$Parametrage$PipeEtape3$View$videSiFerme,
				model,
				A2($author$project$Components$Parametrage$PipeEtape3$View$contenuDuDrawer, i18n, model)),
			model.kX);
	});
var $author$project$Components$Parametrage$PipeEtape3$View$view = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'parametrage-pipe-etape-3',
			{
				ut: A3($author$project$Components$Parametrage$PipeEtape3$View$corps, i18n, messages, model),
				xy: _List_fromArray(
					[
						A2($author$project$Components$Parametrage$PipeEtape3$View$drawer, i18n, model)
					]),
				zM: _List_Nil,
				AK: $author$project$Components$Parametrage$PipeEtape3$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: A2(
							$elm$core$List$cons,
							A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$elm$core$String$join,
											' ',
											A2(
												$elm$core$List$cons,
												$author$project$I18n$Cles$pipeEtape1Introduction(i18n),
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													A2(
														$elm$core$Maybe$map,
														function (edition) {
															return _List_fromArray(
																[
																	A2(
																	$author$project$I18n$Cles$pipeEtape1Exemple,
																	i18n,
																	{
																		Fs: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(edition.R)
																	})
																]);
														},
														model.ge)))))
									])),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (_v0) {
										return _List_fromArray(
											[
												A5($author$project$Components$Parametrage$Common$Conception$bandeau, i18n, $author$project$Routes$Route$adressePipeEtape3, model.vx, model.aS, model.nR)
											]);
									},
									model.ge))),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adressePipes,
								Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
							},
								{
								aa: $author$project$Routes$Route$adressePipes,
								Dj: $author$project$I18n$Cles$pipesTitre(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$pipeEtape1Titre(i18n)
					})
			});
	});
var $author$project$I18n$Cles$pipeEtape4ViteAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.vite.aide', _List_Nil, 'Un modèle de tâche déjà réglé s\'insère par copie.');
};
var $author$project$I18n$Cles$pipeEtape4ViteBibliotheque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.vite.bibliotheque', _List_Nil, 'Choisir dans la bibliothèque');
};
var $author$project$I18n$Cles$pipeEtape4ViteTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.vite.titre', _List_Nil, 'Aller plus vite');
};
var $author$project$Components$Parametrage$PipeEtape4$View$allerPlusVite = function (i18n) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$section,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('vite')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h3,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape4ViteTitre(i18n))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout'),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape4ViteBibliotheque(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape4ViteAide(i18n))
							]))
					]))
			]));
};
var $author$project$I18n$Cles$pipeEtape4ApercuBranche = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.apercu.branche',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			p.d + ' branche sans tâche');
	});
var $author$project$I18n$Cles$pipeEtape4ApercuBranches = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.apercu.branches',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			p.d + ' branches sans tâche');
	});
var $author$project$I18n$Cles$pipeEtape4ApercuEtape = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.apercu.etape',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			p.d + ' étape');
	});
var $author$project$I18n$Cles$pipeEtape4ApercuEtapes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.apercu.etapes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			p.d + ' étapes');
	});
var $author$project$I18n$Cles$pipeEtape4ApercuTache = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.apercu.tache',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			p.d + ' tâche');
	});
var $author$project$I18n$Cles$pipeEtape4ApercuTaches = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.apercu.taches',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			p.d + ' tâches');
	});
var $author$project$Components$Parametrage$PipeEtape4$Phrases$pluriel = F3(
	function (un, plusieurs, n) {
		return (n <= 1) ? un(
			{
				d: $elm$core$String$fromInt(n)
			}) : plusieurs(
			{
				d: $elm$core$String$fromInt(n)
			});
	});
var $author$project$Components$Parametrage$PipeEtape4$Phrases$bilan = F3(
	function (i18n, etapesAvecTaches, resume) {
		return A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						A3(
							$author$project$Components$Parametrage$PipeEtape4$Phrases$pluriel,
							$author$project$I18n$Cles$pipeEtape4ApercuEtape(i18n),
							$author$project$I18n$Cles$pipeEtape4ApercuEtapes(i18n),
							etapesAvecTaches)),
						$elm$core$Maybe$Just(
						A3(
							$author$project$Components$Parametrage$PipeEtape4$Phrases$pluriel,
							$author$project$I18n$Cles$pipeEtape4ApercuTache(i18n),
							$author$project$I18n$Cles$pipeEtape4ApercuTaches(i18n),
							resume.DD)),
						(resume.Du > 0) ? $elm$core$Maybe$Just(
						A3(
							$author$project$Components$Parametrage$PipeEtape4$Phrases$pluriel,
							$author$project$I18n$Cles$pipeEtape4ApercuBranche(i18n),
							$author$project$I18n$Cles$pipeEtape4ApercuBranches(i18n),
							resume.Du)) : $elm$core$Maybe$Nothing
					])));
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$etapesAvecTaches = function (taches) {
	return A2(
		$elm$core$List$filter,
		function (etape) {
			return !etape.uu;
		},
		taches.yL);
};
var $author$project$I18n$Cles$pipeEtape4ApercuSousTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.apercu.sous-titre', _List_Nil, 'Ce que fera le dossier');
};
var $author$project$Components$Parametrage$PipeEtape4$View$apercu = F2(
	function (i18n, taches) {
		return A3(
			$author$project$Components$Shared$Parcours$View$apercu,
			i18n,
			$author$project$I18n$Cles$pipeEtape1ApercuTitre(i18n),
			{
				gV: function () {
					var _v0 = taches.tq;
					if (!_v0.$) {
						var lu = _v0.a;
						return _Utils_ap(
							A2(
								$elm$core$List$concatMap,
								function (etape) {
									return A2(
										$elm$core$List$cons,
										{dX: true, eW: 0, Jx: etape.Bl},
										A2(
											$elm$core$List$map,
											function (ligne) {
												return {dX: false, eW: 1, Jx: ligne};
											},
											etape.gV));
								},
								lu.yL),
							_List_fromArray(
								[
									{
									dX: false,
									eW: 0,
									Jx: A3(
										$author$project$Components$Parametrage$PipeEtape4$Phrases$bilan,
										i18n,
										$elm$core$List$length(
											$author$project$Components$Parametrage$PipeEtape4$Model$etapesAvecTaches(taches)),
										taches.HX)
								}
								]));
					} else {
						return _List_Nil;
					}
				}(),
				h6: $elm$core$Maybe$Just(
					$author$project$I18n$Cles$pipeEtape4ApercuSousTitre(i18n))
			});
	});
var $author$project$I18n$Cles$pipeEtape4Tache = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.tache', _List_Nil, 'tâche');
};
var $author$project$I18n$Cles$pipeEtape4Texte1 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.texte1', _List_Nil, 'Une ');
};
var $author$project$I18n$Cles$pipeEtape4Texte2 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.texte2', _List_Nil, ' est un travail à faire dans le dossier. Elle a un type, elle est confiée à un rôle, elle a une échéance. Cliquez une tâche pour la régler.');
};
var $author$project$Components$Parametrage$PipeEtape4$View$explication = function (i18n) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$p,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('explication')
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$I18n$Cles$pipeEtape4Texte1(i18n)),
				A2(
				$rtfeldman$elm_css$Html$Styled$strong,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$pipeEtape4Tache(i18n))
					])),
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$I18n$Cles$pipeEtape4Texte2(i18n))
			]));
};
var $author$project$Components$Parametrage$PipeEtape4$Update$AjoutDemande = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$Update$TacheDemandee = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$Phrases$avecLeDelai = F2(
	function (lue, texte) {
		return A2(
			$elm$core$Maybe$withDefault,
			lue.n9,
			A2($elm$core$Maybe$map, texte, lue.kB));
	});
var $author$project$I18n$Cles$pipeEtape4EcheanceJour = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.echeance.jour',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			p.d + ' jour');
	});
var $author$project$I18n$Cles$pipeEtape4EcheanceJours = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.echeance.jours',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			p.d + ' jours');
	});
var $author$project$Components$Parametrage$PipeEtape4$Phrases$joursTexte = F2(
	function (i18n, n) {
		return (n === 1) ? A2(
			$author$project$I18n$Cles$pipeEtape4EcheanceJour,
			i18n,
			{d: '1'}) : A2(
			$author$project$I18n$Cles$pipeEtape4EcheanceJours,
			i18n,
			{
				d: $elm$core$String$fromInt(n)
			});
	});
var $author$project$I18n$Cles$pipeEtape4EcheanceApresLaTache = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.echeance.apres-la-tache', _List_Nil, 'Après la fin de la tâche précédente');
};
var $author$project$I18n$Cles$pipeEtape4EcheanceAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.echeance.aucune', _List_Nil, 'Aucune');
};
var $author$project$I18n$Cles$pipeEtape4EcheanceDateFixe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.echeance.date-fixe', _List_Nil, 'À une date fixe');
};
var $author$project$I18n$Cles$pipeEtape4EcheanceFinDeLaPeriodeDOuverture = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.echeance.fin-de-la-periode-d-ouverture', _List_Nil, 'À la fin de la période d\'ouverture');
};
var $author$project$Components$Parametrage$Vocabulaire$modeDEcheance = F2(
	function (i18n, code) {
		switch (code) {
			case 'aucune':
				return $author$project$I18n$Cles$pipeEtape4EcheanceAucune(i18n);
			case 'apres-la-fin-de-la-tache-precedente':
				return $author$project$I18n$Cles$pipeEtape4EcheanceApresLaTache(i18n);
			case 'date-fixe':
				return $author$project$I18n$Cles$pipeEtape4EcheanceDateFixe(i18n);
			case 'fin-de-la-periode-d-ouverture':
				return $author$project$I18n$Cles$pipeEtape4EcheanceFinDeLaPeriodeDOuverture(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$I18n$Cles$pipeEtape4EcheanceApresOuverture = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.echeance.apres-ouverture', _List_Nil, ' après l\'ouverture');
};
var $author$project$Components$Parametrage$PipeEtape4$Phrases$echeance = F2(
	function (i18n, lue) {
		var _v0 = lue.n9;
		switch (_v0) {
			case 'apres-l-arrivee-a-l-etape':
				return A2(
					$author$project$Components$Parametrage$PipeEtape4$Phrases$avecLeDelai,
					lue,
					function (jours) {
						return A2($author$project$Components$Parametrage$PipeEtape4$Phrases$joursTexte, i18n, jours);
					});
			case 'apres-l-ouverture-du-dossier':
				return A2(
					$author$project$Components$Parametrage$PipeEtape4$Phrases$avecLeDelai,
					lue,
					function (jours) {
						return _Utils_ap(
							A2($author$project$Components$Parametrage$PipeEtape4$Phrases$joursTexte, i18n, jours),
							$author$project$I18n$Cles$pipeEtape4EcheanceApresOuverture(i18n));
					});
			default:
				var autre = _v0;
				return A2($author$project$Components$Parametrage$Vocabulaire$modeDEcheance, i18n, autre);
		}
	});
var $author$project$I18n$Cles$pipeEtape4EcheanceLibelle = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.echeance.libelle',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'texte',
					$author$project$I18n$Traductions$Chaine(p.Jx))
				]),
			'Échéance : ' + p.Jx);
	});
var $author$project$Components$Parametrage$Vocabulaire$teinteDuTypeDeTache = function (code) {
	switch (code) {
		case 'saisie':
			return 'bleu';
		case 'evaluation':
			return 'ambre';
		case 'validation':
			return 'vert';
		case 'paiement':
			return 'violet';
		case 'document':
			return 'turquoise';
		default:
			return '';
	}
};
var $author$project$Components$Parametrage$PipeEtape4$View$carte = F2(
	function (i18n, tache) {
		var contenu = _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(tache.R))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('etiquettes')
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('etiquette', true),
										_Utils_Tuple2(
										$author$project$Components$Parametrage$Vocabulaire$teinteDuTypeDeTache(tache.r0),
										true)
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$texte,
									i18n,
									$author$project$Components$Parametrage$Vocabulaire$typeDeTache(tache.r0)))
							])),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (role) {
								return _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('etiquette')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(role.Bl)
											])),
										role.EW ? A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2('etiquette', true),
														_Utils_Tuple2('violet', true)
													]))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$pipeEtape3ParRelation(i18n))
											])) : $rtfeldman$elm_css$Html$Styled$text('')
									]);
							},
							tache.bi)))),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('echeance')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$pipeEtape4EcheanceLibelle,
							i18n,
							{
								Jx: A2($author$project$Components$Parametrage$PipeEtape4$Phrases$echeance, i18n, tache.xY)
							}))
					]))
			]);
		var _v0 = tache.np;
		if (!_v0.$) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('tache'),
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						$author$project$Components$Parametrage$PipeEtape4$Model$idDuDeclencheur('tache-' + tache.r8)),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Parametrage$PipeEtape4$Update$TacheDemandee(tache.r8))
					]),
				contenu);
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('tache', true),
								_Utils_Tuple2('inerte', true)
							]))
					]),
				contenu);
		}
	});
var $author$project$I18n$Cles$pipeEtape4AjouterTache = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.ajouter-tache', _List_Nil, 'Ajouter : Tâche');
};
var $author$project$I18n$Cles$pipeEtape4ColonneAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.colonne.aucune', _List_Nil, 'Aucune tâche.');
};
var $author$project$I18n$Cles$pipeEtape4ColonneBranche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.colonne.branche', _List_Nil, 'Branche');
};
var $author$project$I18n$Cles$pipeEtape4ColonneEtape = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.colonne.etape',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'numero',
					$author$project$I18n$Traductions$Chaine(p.DX))
				]),
			'Étape ' + p.DX);
	});
var $author$project$Components$Parametrage$PipeEtape4$View$colonne = F2(
	function (i18n, etape) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('colonne', true),
							_Utils_Tuple2('branche', etape.uu)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('numero')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									etape.uu ? $author$project$I18n$Cles$pipeEtape4ColonneBranche(i18n) : A2(
										$author$project$I18n$Cles$pipeEtape4ColonneEtape,
										i18n,
										{
											DX: $elm$core$String$fromInt(etape.bY)
										}))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(etape.R))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('but')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									(etape.uu && ($author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(etape.uy) === '')) ? '' : $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(etape.uy))
								]))
						])),
					etape.uu ? A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('aucune')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape4ColonneAucune(i18n))
						])) : $rtfeldman$elm_css$Html$Styled$text(''),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('cartes')
						]),
					A2(
						$elm$core$List$map,
						$author$project$Components$Parametrage$PipeEtape4$View$carte(i18n),
						etape.Jk)),
					function () {
					var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ajouterUneTache, etape.nQ);
					if (!_v0.$) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id(
									$author$project$Components$Parametrage$PipeEtape4$Model$idDuDeclencheur('ajout-' + etape.r8)),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Parametrage$PipeEtape4$Update$AjoutDemande(etape.r8))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape4AjouterTache(i18n))
								]));
					} else {
						return $rtfeldman$elm_css$Html$Styled$text('');
					}
				}()
				]));
	});
var $author$project$I18n$Cles$pipeEtape4ListeDefiler = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.liste.defiler', _List_Nil, 'Faites défiler vers la droite pour voir toutes les étapes.');
};
var $author$project$I18n$Cles$pipeEtape4ListeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.liste.titre', _List_Nil, 'Les tâches, étape par étape');
};
var $author$project$Components$Parametrage$PipeEtape4$View$listeDesTaches = F2(
	function (i18n, taches) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('taches')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape4ListeTitre(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape4ListeDefiler(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('colonnes')
								]),
							A2(
								$elm$core$List$map,
								$author$project$Components$Parametrage$PipeEtape4$View$colonne(i18n),
								taches.yL))
						]))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape4$View$pied = F2(
	function (i18n, code) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pied')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$lien,
					1,
					$author$project$Routes$Route$adressePipeEtape3(code),
					$author$project$I18n$Cles$pipeEtape2Precedente(i18n)),
					A3(
					$author$project$Components$Shared$Bouton$View$lien,
					0,
					$author$project$Routes$Route$adressePipeEtape5(code),
					$author$project$I18n$Cles$pipeEtape1Suivante(i18n))
				]));
	});
var $author$project$I18n$Cles$pipeEtape4Conseil = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.conseil', _List_Nil, 'Les tâches d\'une étape se font en même temps ou l\'une après l\'autre : vous le réglez dans chaque tâche. L\'étape se termine quand ses tâches obligatoires sont terminées.');
};
var $author$project$I18n$Cles$pipeEtape4Question = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.question', _List_Nil, 'Que fait-on à chaque étape ?');
};
var $author$project$Components$Parametrage$PipeEtape4$View$corps = F3(
	function (i18n, messages, model) {
		var _v0 = _Utils_Tuple2(model.Jk, model.nf);
		if (!_v0.a.$) {
			var taches = _v0.a.a;
			return _List_fromArray(
				[
					A3($author$project$Components$Parametrage$Common$Conception$etapes, i18n, model.vx, 4),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
						]),
					_List_fromArray(
						[
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('etape')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h2,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape4Question(i18n))
										])),
									$author$project$Components$Parametrage$PipeEtape4$View$explication(i18n),
									A2($author$project$Components$Parametrage$PipeEtape4$View$listeDesTaches, i18n, taches),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape4Conseil(i18n))
										])),
									$author$project$Components$Parametrage$PipeEtape4$View$allerPlusVite(i18n)
								])),
							A2($author$project$Components$Parametrage$PipeEtape4$View$pied, i18n, model.vx)
						])),
					A2($author$project$Components$Parametrage$PipeEtape4$View$apercu, i18n, taches)
				]);
		} else {
			if (_v0.b) {
				return _List_fromArray(
					[
						A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape1Introuvable(i18n))
							]))
					]);
			} else {
				return _List_fromArray(
					[
						A2($author$project$Components$Shared$Messages$View$view, i18n, messages)
					]);
			}
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$AjoutEnregistre = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$Update$EnregistrementDemande = {$: 49};
var $author$project$Components$Parametrage$PipeEtape4$Update$InsertionDemandee = {$: 20};
var $author$project$Components$Parametrage$PipeEtape4$Update$BibliothequeOuverte = {$: 16};
var $author$project$I18n$Cles$pipeEtape4BandeDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.bande.debut', _List_Nil, 'Un type dont le module n\'est pas souscrit reste ');
};
var $author$project$I18n$Cles$pipeEtape4BandeFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.bande.fin', _List_Nil, ', avec la mention « module à souscrire ».');
};
var $author$project$I18n$Cles$pipeEtape4BandeFort = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.bande.fort', _List_Nil, 'visible en grisé');
};
var $author$project$Components$Parametrage$PipeEtape4$View$bandeDesModulesASouscrire = F2(
	function (i18n, ajout) {
		return A2(
			$elm$core$List$any,
			function (type_) {
				return !type_.kR;
			},
			ajout.jN.ib) ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('bande')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$pipeEtape4BandeDebut(i18n)),
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape4BandeFort(i18n))
							])),
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$pipeEtape4BandeFin(i18n))
					]))
			]) : _List_Nil;
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$FormulaireDeLAjoutChoisi = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$Model$formulairesCompatibles = F2(
	function (type_, formulaires) {
		return A2(
			$elm$core$List$filter,
			function (formulaire) {
				return _Utils_eq(formulaire.r0, type_);
			},
			formulaires);
	});
var $author$project$I18n$Cles$pipeEtape4FormulaireAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.formulaire.aucun', _List_Nil, 'Aucun formulaire');
};
var $author$project$I18n$Cles$pipeEtape4FormulaireChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.formulaire.choisir', _List_Nil, 'Formulaire');
};
var $author$project$I18n$Cles$pipeEtape4FormulaireTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.formulaire.titre', _List_Nil, 'Le formulaire utilisé');
};
var $author$project$Components$Parametrage$PipeEtape4$View$formulaireDeLAjout = F2(
	function (i18n, ajout) {
		var _v0 = A2($author$project$Components$Parametrage$PipeEtape4$Model$formulairesCompatibles, ajout.r0, ajout.aA);
		if (!_v0.b) {
			return _List_Nil;
		} else {
			var compatibles = _v0;
			return _List_fromArray(
				[
					A2(
					$author$project$Components$Parametrage$Common$Conception$drawerSection,
					$author$project$I18n$Cles$pipeEtape4FormulaireTitre(i18n),
					_List_fromArray(
						[
							A4(
							$author$project$Components$Parametrage$Common$Conception$liste,
							$author$project$I18n$Cles$pipeEtape4FormulaireChoisir(i18n),
							ajout.mR,
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'',
									$author$project$I18n$Cles$pipeEtape4FormulaireAucun(i18n)),
								A2(
									$elm$core$List$map,
									function (formulaire) {
										return _Utils_Tuple2(
											formulaire.r8,
											$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(formulaire.R));
									},
									compatibles)),
							$author$project$Components$Parametrage$PipeEtape4$Update$FormulaireDeLAjoutChoisi)
						]))
				]);
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$ModelePris = function (a) {
	return {$: 15, a: a};
};
var $author$project$I18n$Cles$pipeEtape4BibliothequeDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.bibliotheque.detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'version',
					$author$project$I18n$Traductions$Chaine(p.sq)),
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Modèle v' + (p.sq + (' · rôle attendu : ' + p.bi)));
	});
var $author$project$I18n$Cles$pipeEtape4BibliothequePrendre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.bibliotheque.prendre', _List_Nil, 'Prendre');
};
var $author$project$Components$Parametrage$PipeEtape4$View$modele = F3(
	function (i18n, ajout, lu) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('modele')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('textes')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(lu.R))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$pipeEtape4BibliothequeDetail,
										i18n,
										{
											bi: lu.qP,
											sq: $elm$core$String$fromInt(lu.sq)
										}))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('prendre'),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
							_Utils_eq(
								A2($author$project$Components$Parametrage$PipeEtape4$Model$roleDuModele, ajout, lu),
								$elm$core$Maybe$Nothing) || (!lu.kR)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Parametrage$PipeEtape4$Update$ModelePris(lu.r8))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape4BibliothequePrendre(i18n))
						]))
				]));
	});
var $author$project$I18n$Cles$pipeEtape4AjoutAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.ajout.aide', _List_Nil, 'Une tâche fait une seule chose. En gris : le module qui la fournit.');
};
var $author$project$I18n$Cles$pipeEtape4AjoutQuestion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.ajout.question', _List_Nil, 'Quel type de tâche ?');
};
var $author$project$I18n$Cles$pipeEtape4BibliothequeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.bibliotheque.titre', _List_Nil, 'Ou depuis la bibliothèque');
};
var $author$project$I18n$Cles$pipeEtape4BibliothequeToute = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.bibliotheque.toute', _List_Nil, 'Toute la bibliothèque');
};
var $author$project$Components$Parametrage$PipeEtape4$Update$PreuveChoisie = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$Update$RoleChoisi = function (a) {
	return {$: 10, a: a};
};
var $author$project$I18n$Cles$pipeEtape4RegleAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.regle.aide', _List_Nil, 'La tâche se termine quand le rôle déclare le geste fait. Les autres types ont leur fiche, une fois ajoutés.');
};
var $author$project$I18n$Cles$pipeEtape4ReglePreuve = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.regle.preuve', _List_Nil, 'Preuve demandée');
};
var $author$project$I18n$Cles$pipeEtape4RegleRole = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.regle.role', _List_Nil, 'Rôle qui la fait');
};
var $author$project$I18n$Cles$pipeEtape4RegleTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.regle.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Ce que règle « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$pipeEtape4RoleParRelation = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.role.par-relation',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			p.bi + ' (par relation)');
	});
var $author$project$I18n$Cles$pipeEtape4PreuveAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.preuve.aucune', _List_Nil, 'Aucune, un simple « fait »');
};
var $author$project$I18n$Cles$pipeEtape4PreuveCommentaire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.preuve.commentaire', _List_Nil, 'Un commentaire');
};
var $author$project$I18n$Cles$pipeEtape4PreuveFichier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.preuve.fichier', _List_Nil, 'Un fichier déposé');
};
var $author$project$Components$Parametrage$Vocabulaire$preuveDeTache = F2(
	function (i18n, code) {
		switch (code) {
			case 'aucune':
				return $author$project$I18n$Cles$pipeEtape4PreuveAucune(i18n);
			case 'fichier':
				return $author$project$I18n$Cles$pipeEtape4PreuveFichier(i18n);
			case 'commentaire':
				return $author$project$I18n$Cles$pipeEtape4PreuveCommentaire(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$View$reglageDeLActionManuelle = F2(
	function (i18n, ajout) {
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			A2(
				$author$project$I18n$Cles$pipeEtape4RegleTitre,
				i18n,
				{
					Dj: A2(
						$author$project$I18n$Cles$texte,
						i18n,
						$author$project$Components$Parametrage$Vocabulaire$typeDeTache(ajout.r0))
				}),
			_List_fromArray(
				[
					A4(
					$author$project$Components$Parametrage$Common$Conception$liste,
					$author$project$I18n$Cles$pipeEtape4RegleRole(i18n),
					ajout.H6,
					A2(
						$elm$core$List$map,
						function (role) {
							return _Utils_Tuple2(
								role.r8,
								role.EW ? A2(
									$author$project$I18n$Cles$pipeEtape4RoleParRelation,
									i18n,
									{bi: role.Bl}) : role.Bl);
						},
						ajout.jN.eX),
					$author$project$Components$Parametrage$PipeEtape4$Update$RoleChoisi),
					A4(
					$author$project$Components$Parametrage$Common$Conception$liste,
					$author$project$I18n$Cles$pipeEtape4ReglePreuve(i18n),
					ajout.eG,
					A2(
						$elm$core$List$map,
						function (code) {
							return _Utils_Tuple2(
								code,
								A2($author$project$Components$Parametrage$Vocabulaire$preuveDeTache, i18n, code));
						},
						_List_fromArray(
							['aucune', 'fichier', 'commentaire'])),
					$author$project$Components$Parametrage$PipeEtape4$Update$PreuveChoisie),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape4RegleAide(i18n))
						]))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$TypeChoisi = function (a) {
	return {$: 6, a: a};
};
var $author$project$I18n$Cles$pipeEtape4ModuleAgents = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.module.agents', _List_Nil, 'Agents');
};
var $author$project$I18n$Cles$pipeEtape4ModuleCommunication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.module.communication', _List_Nil, 'Communication');
};
var $author$project$I18n$Cles$pipeEtape4ModulePaiement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.module.paiement', _List_Nil, 'Paiement');
};
var $author$project$I18n$Cles$pipeEtape4ModulePipes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.module.pipes', _List_Nil, 'Pipes');
};
var $author$project$I18n$Cles$pipeEtape4ModulePublication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.module.publication', _List_Nil, 'Publication');
};
var $author$project$Components$Parametrage$Vocabulaire$moduleDeTache = F2(
	function (i18n, code) {
		switch (code) {
			case 'pipes':
				return $author$project$I18n$Cles$pipeEtape4ModulePipes(i18n);
			case 'communication':
				return $author$project$I18n$Cles$pipeEtape4ModuleCommunication(i18n);
			case 'paiement':
				return $author$project$I18n$Cles$pipeEtape4ModulePaiement(i18n);
			case 'publication':
				return $author$project$I18n$Cles$pipeEtape4ModulePublication(i18n);
			case 'agents':
				return $author$project$I18n$Cles$pipeEtape4ModuleAgents(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$I18n$Cles$pipeEtape4ModuleASouscrire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.module.a-souscrire', _List_Nil, ' · module à souscrire');
};
var $author$project$Components$Parametrage$PipeEtape4$View$typePropose = F3(
	function (i18n, ajout, type_) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('choix', true),
							_Utils_Tuple2('grise', !type_.kR)
						])),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-groupe', 'type')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
							$rtfeldman$elm_css$Html$Styled$Attributes$name('type'),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(type_.vx),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(
							_Utils_eq(ajout.r0, type_.vx)),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!type_.kR),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Parametrage$PipeEtape4$Update$TypeChoisi(type_.vx))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('textes')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$texte,
										i18n,
										$author$project$Components$Parametrage$Vocabulaire$typeDeTache(type_.vx))),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('module')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											_Utils_ap(
												A2($author$project$Components$Parametrage$Vocabulaire$moduleDeTache, i18n, type_.oe),
												type_.kR ? '' : $author$project$I18n$Cles$pipeEtape4ModuleASouscrire(i18n)))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(type_.dH)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('etat'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'coche',
									_Utils_eq(ajout.r0, type_.vx))
								])),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-type', 'radio')
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$Parametrage$PipeEtape4$View$contenuDeLAjoutParType = F2(
	function (i18n, ajout) {
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$author$project$Components$Parametrage$Common$Conception$drawerSection,
					$author$project$I18n$Cles$pipeEtape4AjoutQuestion(i18n),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape4AjoutAide(i18n))
								])),
						A2(
							$elm$core$List$map,
							A2($author$project$Components$Parametrage$PipeEtape4$View$typePropose, i18n, ajout),
							ajout.jN.ib)))
				]),
			_Utils_ap(
				_Utils_eq(ajout.cs, $elm$core$Maybe$Nothing) ? _List_fromArray(
					[
						A2(
						$author$project$Components$Parametrage$Common$Conception$drawerSection,
						$author$project$I18n$Cles$pipeEtape4BibliothequeTitre(i18n),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								A2($author$project$Components$Parametrage$PipeEtape4$View$modele, i18n, ajout),
								ajout.jN.CI),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('geste'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape4$Update$BibliothequeOuverte)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape4BibliothequeToute(i18n))
										]))
								])))
					]) : _List_Nil,
				_Utils_ap(
					(ajout.r0 === 'action-manuelle') ? _List_fromArray(
						[
							A2($author$project$Components$Parametrage$PipeEtape4$View$reglageDeLActionManuelle, i18n, ajout)
						]) : _List_Nil,
					_Utils_ap(
						A2($author$project$Components$Parametrage$PipeEtape4$View$formulaireDeLAjout, i18n, ajout),
						A2($author$project$Components$Parametrage$PipeEtape4$View$bandeDesModulesASouscrire, i18n, ajout)))));
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$BibliothequeFiltree = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$Update$BibliothequeRecherchee = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$Update$BibliothequeChoisie = function (a) {
	return {$: 19, a: a};
};
var $author$project$I18n$Cles$pipeEtape4BibliothequeCarte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.bibliotheque.carte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'version',
					$author$project$I18n$Traductions$Chaine(p.sq)),
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Version ' + (p.sq + (' · utilisé dans ' + (p.w + ' pipes'))));
	});
var $author$project$I18n$Cles$pipeEtape4BibliothequeCarteUn = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.bibliotheque.carte-un',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'version',
					$author$project$I18n$Traductions$Chaine(p.sq)),
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Version ' + (p.sq + (' · utilisé dans ' + (p.w + ' pipe'))));
	});
var $author$project$I18n$Cles$pipeEtape4BibliothequeChoisi = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.bibliotheque.choisi', _List_Nil, 'Choisi');
};
var $author$project$Components$Parametrage$PipeEtape4$View$carteDeModele = F3(
	function (i18n, bibliotheque, lu) {
		var selectionne = _Utils_eq(
			bibliotheque.vd,
			$elm$core$Maybe$Just(lu.r8));
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('carte-modele', true),
							_Utils_Tuple2('selected', selectionne),
							_Utils_Tuple2('grise', !lu.kR)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-pressed',
					selectionne ? 'true' : 'false'),
					$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!lu.kR),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Components$Parametrage$PipeEtape4$Update$BibliothequeChoisie(lu.r8))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(lu.R))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							3,
							A2(
								$author$project$I18n$Cles$texte,
								i18n,
								$author$project$Components$Parametrage$Vocabulaire$typeDeTache(lu.r0))),
							A2($author$project$Components$Shared$Tag$View$view, 3, lu.qP),
							$rtfeldman$elm_css$Html$Styled$text(
							((lu.sf > 1) ? $author$project$I18n$Cles$pipeEtape4BibliothequeCarte(i18n) : $author$project$I18n$Cles$pipeEtape4BibliothequeCarteUn(i18n))(
								{
									w: $elm$core$String$fromInt(lu.sf),
									sq: $elm$core$String$fromInt(lu.sq)
								}))
						])),
					selectionne ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('choisi')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape4BibliothequeChoisi(i18n))
						])) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$I18n$Cles$pipeEtape4BibliothequeCopie = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.bibliotheque.copie',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etape',
					$author$project$I18n$Traductions$Chaine(p.me))
				]),
			'La tâche est copiée dans l\'étape ' + (p.me + '. Vous pouvez la modifier sans toucher au modèle. Si le modèle change, une nouvelle version vous est proposée, jamais imposée.'));
	});
var $author$project$I18n$Cles$pipeEtape4BibliothequeListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.bibliotheque.liste', _List_Nil, 'Les modèles de votre bibliothèque');
};
var $author$project$I18n$Cles$pipeEtape4BibliothequeObtenez = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.bibliotheque.obtenez',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'genre',
					$author$project$I18n$Traductions$Chaine(p.M)),
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'« ' + (p.Dj + (' » : type ' + (p.M + (', rôle ' + (p.bi + '.'))))));
	});
var $author$project$I18n$Cles$pipeEtape4BibliothequeObtenezTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.bibliotheque.obtenez-titre', _List_Nil, 'Ce que vous obtenez');
};
var $author$project$I18n$Cles$pipeEtape4BibliothequeRecherche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.bibliotheque.recherche', _List_Nil, 'Chercher un modèle');
};
var $author$project$I18n$Cles$pipeEtape4BibliothequeTypeTous = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.bibliotheque.type-tous', _List_Nil, 'Tous les types');
};
var $author$project$I18n$Cles$pipeEtape4BibliothequeVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.bibliotheque.vide', _List_Nil, 'Aucun modèle ne correspond.');
};
var $author$project$Components$Parametrage$PipeEtape4$View$contenuDeLaBibliotheque = F3(
	function (i18n, ajout, bibliotheque) {
		var puce = F2(
			function (valeur, libelle) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('puce', true),
									_Utils_Tuple2(
									'selected',
									_Utils_eq(bibliotheque.M, valeur))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-pressed',
							_Utils_eq(bibliotheque.M, valeur) ? 'true' : 'false'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Parametrage$PipeEtape4$Update$BibliothequeFiltree(valeur))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						]));
			});
		var choisi = A2(
			$elm$core$Maybe$andThen,
			function (uid) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (m) {
							return _Utils_eq(m.r8, uid);
						},
						ajout.jN.CI));
			},
			bibliotheque.vd);
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('bibliotheque')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Champ$View$texte,
						{
							go: $elm$core$Maybe$Nothing,
							Aq: 'bibliotheque-recherche',
							Bl: $author$project$I18n$Cles$pipeEtape4BibliothequeRecherche(i18n),
							he: false
						},
						{hg: $author$project$Components$Parametrage$PipeEtape4$Update$BibliothequeRecherchee, fm: bibliotheque.hC}),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('puces')
							]),
						A2(
							$elm$core$List$cons,
							A2(
								puce,
								'',
								$author$project$I18n$Cles$pipeEtape4BibliothequeTypeTous(i18n)),
							A2(
								$elm$core$List$map,
								function (type_) {
									return A2(
										puce,
										type_.vx,
										A2(
											$author$project$I18n$Cles$texte,
											i18n,
											$author$project$Components$Parametrage$Vocabulaire$typeDeTache(type_.vx)));
								},
								A2(
									$elm$core$List$filter,
									function ($) {
										return $.kR;
									},
									ajout.jN.ib))))
					])),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4BibliothequeListe(i18n),
				$elm$core$List$isEmpty(ajout.jN.CI) ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape4BibliothequeVide(i18n))
							]))
					]) : A2(
					$elm$core$List$map,
					A2($author$project$Components$Parametrage$PipeEtape4$View$carteDeModele, i18n, bibliotheque),
					ajout.jN.CI)),
				function () {
				if (!choisi.$) {
					var lu = choisi.a;
					return A2(
						$author$project$Components$Parametrage$Common$Conception$drawerSection,
						$author$project$I18n$Cles$pipeEtape4BibliothequeObtenezTitre(i18n),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('obtenez')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$pipeEtape4BibliothequeObtenez,
											i18n,
											{
												M: A2(
													$author$project$I18n$Cles$texte,
													i18n,
													$author$project$Components$Parametrage$Vocabulaire$typeDeTache(lu.r0)),
												Dj: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(lu.R),
												bi: lu.qP
											}))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$pipeEtape4BibliothequeCopie,
											i18n,
											{me: ajout.mh}))
									]))
							]));
				} else {
					return $rtfeldman$elm_css$Html$Styled$text('');
				}
			}()
			]);
	});
var $author$project$Components$Parametrage$PipeEtape4$View$contenuDeLAjout = F2(
	function (i18n, ajout) {
		var _v0 = ajout.dq;
		if (!_v0.$) {
			var bibliotheque = _v0.a;
			return A3($author$project$Components$Parametrage$PipeEtape4$View$contenuDeLaBibliotheque, i18n, ajout, bibliotheque);
		} else {
			return A2($author$project$Components$Parametrage$PipeEtape4$View$contenuDeLAjoutParType, i18n, ajout);
		}
	});
var $author$project$I18n$Cles$pipeEtape4DocBandeDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.doc.bande.debut', _List_Nil, 'Un signataire externe ');
};
var $author$project$I18n$Cles$pipeEtape4DocBandeFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.doc.bande.fin', _List_Nil, ' ; le lien lui est envoyé par email.');
};
var $author$project$I18n$Cles$pipeEtape4DocBandeFort = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.doc.bande.fort', _List_Nil, 'signe dans son espace du portail');
};
var $author$project$Components$Parametrage$PipeEtape4$Blocs$bandeDuSignataire = function (i18n) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$p,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('bande')
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$I18n$Cles$pipeEtape4DocBandeDebut(i18n)),
				A2(
				$rtfeldman$elm_css$Html$Styled$strong,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$pipeEtape4DocBandeFort(i18n))
					])),
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$I18n$Cles$pipeEtape4DocBandeFin(i18n))
			]));
};
var $author$project$I18n$Cles$pipeEtape4PaiementPlusieurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.paiement.plusieurs', _List_Nil, ' une tâche de paiement par payeur, avec son montant et son état. Pour une commande partagée, une tâche pour le licencié et une pour le producteur.');
};
var $author$project$I18n$Cles$pipeEtape4PaiementPlusieursFort = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.paiement.plusieurs-fort', _List_Nil, 'Plusieurs payeurs :');
};
var $author$project$Components$Parametrage$PipeEtape4$Blocs$bandePlusieursPayeurs = function (i18n) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$p,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('bande')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$strong,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$pipeEtape4PaiementPlusieursFort(i18n))
					])),
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$I18n$Cles$pipeEtape4PaiementPlusieurs(i18n))
			]));
};
var $author$project$Components$Parametrage$PipeEtape4$Update$ParametreChoisi = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$ParametreEntierSaisi = F2(
	function (a, b) {
		return {$: 25, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$ImbriqueChoisi = F3(
	function (a, b, c) {
		return {$: 30, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$ImbriqueEntierSaisi = F3(
	function (a, b, c) {
		return {$: 31, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$ObligatoireBascule = function (a) {
	return {$: 47, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$Update$ParametreListeUniqueChoisie = F2(
	function (a, b) {
		return {$: 28, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$VisibleSurLePortailBascule = function (a) {
	return {$: 48, a: a};
};
var $author$project$I18n$Cles$pipeEtape4DateApercuApres = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.date.apercu.apres',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'jours',
					$author$project$I18n$Traductions$Chaine(p.ni))
				]),
			p.ni + ' après');
	});
var $author$project$I18n$Cles$pipeEtape4DateApercuAvant = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.date.apercu.avant',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'jours',
					$author$project$I18n$Traductions$Chaine(p.ni))
				]),
			p.ni + ' avant');
	});
var $author$project$I18n$Cles$pipeEtape4DateApercuDebut = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.date.apercu.debut',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'personne',
					$author$project$I18n$Traductions$Chaine(p.Fd))
				]),
			'Dans le dossier de ' + (p.Fd + ', la tâche se termine '));
	});
var $author$project$I18n$Cles$pipeEtape4DateApercuFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.date.apercu.fin', _List_Nil, '.');
};
var $author$project$I18n$Cles$pipeEtape4DateApercuLeJour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.date.apercu.le-jour', _List_Nil, 'le jour de');
};
var $author$project$I18n$Cles$pipeEtape4DateApercuMilieu = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.date.apercu.milieu',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			' la ' + (p.wv + ' chez '));
	});
var $author$project$Components$Parametrage$PipeEtape4$Phrases$apercuDeLaDate = F4(
	function (i18n, decalage, libelleDeLaDate, exemple) {
		return _List_fromArray(
			[
				A2(
				$author$project$I18n$Cles$pipeEtape4DateApercuDebut,
				i18n,
				{Fd: exemple.Fd}),
				(decalage < 0) ? A2(
				$author$project$I18n$Cles$pipeEtape4DateApercuAvant,
				i18n,
				{
					ni: A2(
						$author$project$Components$Parametrage$PipeEtape4$Phrases$joursTexte,
						i18n,
						$elm$core$Basics$abs(decalage))
				}) : ((decalage > 0) ? A2(
				$author$project$I18n$Cles$pipeEtape4DateApercuApres,
				i18n,
				{
					ni: A2($author$project$Components$Parametrage$PipeEtape4$Phrases$joursTexte, i18n, decalage)
				}) : $author$project$I18n$Cles$pipeEtape4DateApercuLeJour(i18n)),
				A2(
				$author$project$I18n$Cles$pipeEtape4DateApercuMilieu,
				i18n,
				{wv: libelleDeLaDate}),
				exemple.En,
				$author$project$I18n$Cles$pipeEtape4DateApercuFin(i18n)
			]);
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$entierDe = F2(
	function (chemin, saisie) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$fromInt,
				A3($author$project$Components$Parametrage$PipeEtape4$Model$lireChemin, $elm$json$Json$Decode$int, chemin, saisie)));
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$texteDe = F2(
	function (chemin, saisie) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A3($author$project$Components$Parametrage$PipeEtape4$Model$lireChemin, $elm$json$Json$Decode$string, chemin, saisie));
	});
var $author$project$Components$Parametrage$PipeEtape4$Blocs$apercuDeLaDate = F2(
	function (i18n, saisie) {
		var _v0 = saisie.B1.o_.yZ;
		if (!_v0.$) {
			var exemple = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu-date')
					]),
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (rang, morceau) {
							return ((rang === 1) || (rang === 3)) ? A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(morceau)
									])) : $rtfeldman$elm_css$Html$Styled$text(morceau);
						}),
					A4(
						$author$project$Components$Parametrage$PipeEtape4$Phrases$apercuDeLaDate,
						i18n,
						A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(
								A2(
									$author$project$Components$Parametrage$PipeEtape4$Model$entierDe,
									_List_fromArray(
										['date', 'decalageEnJours']),
									saisie))),
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.wu;
								},
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (champ) {
											return _Utils_eq(
												champ.fm,
												A2(
													$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
													_List_fromArray(
														['date', 'champ']),
													saisie));
										},
										saisie.B1.o_.uU)))),
						exemple)));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$Common$Conception$caseSimple = F4(
	function (groupe, estCochee, titre, msg) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('case-simple'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-groupe', groupe)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
							$rtfeldman$elm_css$Html$Styled$Attributes$name(groupe),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(estCochee),
							$rtfeldman$elm_css$Html$Styled$Events$onCheck(msg)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(titre)
						]))
				]));
	});
var $author$project$I18n$Cles$pipeEtape4AttendAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.attend.aide', _List_Nil, 'Une seule chose à la fois. Personne n\'a de geste à faire : le dossier reprend seul.');
};
var $author$project$I18n$Cles$pipeEtape4AttendDate = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.attend.date', _List_Nil, 'Une date');
};
var $author$project$I18n$Cles$pipeEtape4AttendDateAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.attend.date-aide', _List_Nil, 'Un jour précis, ou un décalage par rapport à une date du dossier.');
};
var $author$project$I18n$Cles$pipeEtape4AttendDelai = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.attend.delai', _List_Nil, 'Un délai');
};
var $author$project$I18n$Cles$pipeEtape4AttendDelaiAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.attend.delai-aide', _List_Nil, 'Un nombre de jours après l\'arrivée à l\'étape.');
};
var $author$project$I18n$Cles$pipeEtape4AttendEvenement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.attend.evenement', _List_Nil, 'Un événement');
};
var $author$project$I18n$Cles$pipeEtape4AttendEvenementAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.attend.evenement-aide', _List_Nil, 'Un document signé, un paiement reçu, un autre dossier terminé, une réponse reçue.');
};
var $author$project$I18n$Cles$pipeEtape4AttendTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.attend.titre', _List_Nil, 'Elle attend');
};
var $author$project$I18n$Cles$pipeEtape4DateChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.date.champ', _List_Nil, 'Date du dossier');
};
var $author$project$I18n$Cles$pipeEtape4DateDecalage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.date.decalage', _List_Nil, 'Décalage, en jours (négatif = avant)');
};
var $author$project$I18n$Cles$pipeEtape4DateTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.date.titre', _List_Nil, 'La date');
};
var $author$project$I18n$Cles$pipeEtape4DelaiAttenteLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.delai-attente.libelle', _List_Nil, 'Délai, en jours');
};
var $author$project$I18n$Cles$pipeEtape4DelaiAttenteTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.delai-attente.titre', _List_Nil, 'Le délai');
};
var $author$project$I18n$Cles$pipeEtape4EvenementLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.evenement.libelle', _List_Nil, 'Événement attendu');
};
var $author$project$I18n$Cles$pipeEtape4EvenementTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.evenement.titre', _List_Nil, 'L\'événement');
};
var $author$project$I18n$Cles$pipeEtape4PortailTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.portail.texte', _List_Nil, 'Ce que voit le licencié');
};
var $author$project$I18n$Cles$pipeEtape4PortailTexteAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.portail.texte-aide', _List_Nil, 'Les rôles tenus par une relation voient le même texte, s\'ils ont accès à cette étape (étape 6).');
};
var $author$project$I18n$Cles$pipeEtape4PortailTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.portail.titre', _List_Nil, 'Sur le portail');
};
var $author$project$I18n$Cles$pipeEtape4QuandObligatoire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.quand.obligatoire', _List_Nil, 'Obligatoire pour passer à l\'étape suivante');
};
var $author$project$I18n$Cles$pipeEtape4QuandTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.quand.titre', _List_Nil, 'Quand');
};
var $author$project$I18n$Cles$pipeEtape4QuandVisible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.quand.visible', _List_Nil, 'Visible sur le portail');
};
var $author$project$I18n$Cles$pipeEtape4TermineAttente = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.termine.attente', _List_Nil, 'La date est atteinte. La tâche suivante de l\'étape démarre alors, ou le dossier passe à l\'étape suivante.');
};
var $author$project$I18n$Cles$pipeEtape4TropLongApres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.trop-long.apres', _List_Nil, 'Prévenir après, en jours');
};
var $author$project$I18n$Cles$pipeEtape4TropLongEt = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.trop-long.et',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Gestionnaire et ' + p.bi);
	});
var $author$project$I18n$Cles$pipeEtape4TropLongGestionnaire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.trop-long.gestionnaire', _List_Nil, 'Gestionnaire');
};
var $author$project$I18n$Cles$pipeEtape4TropLongQui = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.trop-long.qui', _List_Nil, 'Qui est prévenu');
};
var $author$project$I18n$Cles$pipeEtape4TropLongTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.trop-long.titre', _List_Nil, 'Si elle dure trop longtemps');
};
var $author$project$Components$Parametrage$PipeEtape4$Blocs$references = $elm$core$List$map(
	function (reference) {
		return _Utils_Tuple2(reference.fm, reference.Bl);
	});
var $author$project$I18n$Cles$pipeEtape4TermineTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.termine.titre', _List_Nil, 'Ce qui la termine');
};
var $author$project$Components$Parametrage$PipeEtape4$Blocs$termine = F2(
	function (i18n, phrase) {
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape4TermineTitre(i18n),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu-compose')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(phrase)
						]))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape4$Blocs$attente = F2(
	function (i18n, saisie) {
		var attend = A2(
			$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
			_List_fromArray(
				['elleAttend']),
			saisie);
		var option = F3(
			function (code, titre, aide) {
				return A6(
					$author$project$Components$Parametrage$Common$Conception$choix,
					'attend',
					code,
					_Utils_eq(attend, code),
					titre,
					aide,
					A2($author$project$Components$Parametrage$PipeEtape4$Update$ParametreChoisi, 'elleAttend', code));
			});
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4AttendTitre(i18n),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape4AttendAide(i18n))
							])),
						A3(
						option,
						'date',
						$author$project$I18n$Cles$pipeEtape4AttendDate(i18n),
						$author$project$I18n$Cles$pipeEtape4AttendDateAide(i18n)),
						A3(
						option,
						'evenement',
						$author$project$I18n$Cles$pipeEtape4AttendEvenement(i18n),
						$author$project$I18n$Cles$pipeEtape4AttendEvenementAide(i18n)),
						A3(
						option,
						'delai',
						$author$project$I18n$Cles$pipeEtape4AttendDelai(i18n),
						$author$project$I18n$Cles$pipeEtape4AttendDelaiAide(i18n))
					])),
				function () {
				switch (attend) {
					case 'date':
						return A2(
							$author$project$Components$Parametrage$Common$Conception$drawerSection,
							$author$project$I18n$Cles$pipeEtape4DateTitre(i18n),
							_List_fromArray(
								[
									A4(
									$author$project$Components$Parametrage$Common$Conception$liste,
									$author$project$I18n$Cles$pipeEtape4DateChamp(i18n),
									A2(
										$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
										_List_fromArray(
											['date', 'champ']),
										saisie),
									A2(
										$elm$core$List$map,
										function (champ) {
											return _Utils_Tuple2(champ.fm, champ.Bl);
										},
										saisie.B1.o_.uU),
									A2($author$project$Components$Parametrage$PipeEtape4$Update$ImbriqueChoisi, 'date', 'champ')),
									A3(
									$author$project$Components$Parametrage$Common$Conception$champDeTexte,
									$author$project$I18n$Cles$pipeEtape4DateDecalage(i18n),
									A2(
										$author$project$Components$Parametrage$PipeEtape4$Model$entierDe,
										_List_fromArray(
											['date', 'decalageEnJours']),
										saisie),
									A2($author$project$Components$Parametrage$PipeEtape4$Update$ImbriqueEntierSaisi, 'date', 'decalageEnJours')),
									A2($author$project$Components$Parametrage$PipeEtape4$Blocs$apercuDeLaDate, i18n, saisie)
								]));
					case 'evenement':
						return A2(
							$author$project$Components$Parametrage$Common$Conception$drawerSection,
							$author$project$I18n$Cles$pipeEtape4EvenementTitre(i18n),
							_List_fromArray(
								[
									A4(
									$author$project$Components$Parametrage$Common$Conception$liste,
									$author$project$I18n$Cles$pipeEtape4EvenementLibelle(i18n),
									A2(
										$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
										_List_fromArray(
											['evenement', 'code']),
										saisie),
									$author$project$Components$Parametrage$PipeEtape4$Blocs$references(saisie.B1.o_.mk),
									A2($author$project$Components$Parametrage$PipeEtape4$Update$ImbriqueChoisi, 'evenement', 'code'))
								]));
					default:
						return A2(
							$author$project$Components$Parametrage$Common$Conception$drawerSection,
							$author$project$I18n$Cles$pipeEtape4DelaiAttenteTitre(i18n),
							_List_fromArray(
								[
									A3(
									$author$project$Components$Parametrage$Common$Conception$champDeTexte,
									$author$project$I18n$Cles$pipeEtape4DelaiAttenteLibelle(i18n),
									A2(
										$author$project$Components$Parametrage$PipeEtape4$Model$entierDe,
										_List_fromArray(
											['delaiEnJours']),
										saisie),
									$author$project$Components$Parametrage$PipeEtape4$Update$ParametreEntierSaisi('delaiEnJours'))
								]));
				}
			}(),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4TropLongTitre(i18n),
				_List_fromArray(
					[
						A3(
						$author$project$Components$Parametrage$Common$Conception$champDeTexte,
						$author$project$I18n$Cles$pipeEtape4TropLongApres(i18n),
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$entierDe,
							_List_fromArray(
								['preveniApresEnJours']),
							saisie),
						$author$project$Components$Parametrage$PipeEtape4$Update$ParametreEntierSaisi('preveniApresEnJours')),
						A4(
						$author$project$Components$Parametrage$Common$Conception$liste,
						$author$project$I18n$Cles$pipeEtape4TropLongQui(i18n),
						A2(
							$elm$core$Maybe$withDefault,
							'',
							$elm$core$List$head(
								A2(
									$author$project$Components$Parametrage$PipeEtape4$Model$listeDe,
									_List_fromArray(
										['preveniRoleUids']),
									saisie))),
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'',
								$author$project$I18n$Cles$pipeEtape4TropLongGestionnaire(i18n)),
							A2(
								$elm$core$List$map,
								function (role) {
									return _Utils_Tuple2(
										role.r8,
										A2(
											$author$project$I18n$Cles$pipeEtape4TropLongEt,
											i18n,
											{bi: role.Bl}));
								},
								A2(
									$elm$core$List$filter,
									function ($) {
										return $.EW;
									},
									saisie.B1.o_.eX))),
						$author$project$Components$Parametrage$PipeEtape4$Update$ParametreListeUniqueChoisie('preveniRoleUids'))
					])),
				A2(
				$author$project$Components$Parametrage$PipeEtape4$Blocs$termine,
				i18n,
				$author$project$I18n$Cles$pipeEtape4TermineAttente(i18n)),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4PortailTitre(i18n),
				_List_fromArray(
					[
						A4(
						$author$project$Components$Parametrage$Common$Conception$caseSimple,
						'visible',
						saisie.KS,
						$author$project$I18n$Cles$pipeEtape4QuandVisible(i18n),
						$author$project$Components$Parametrage$PipeEtape4$Update$VisibleSurLePortailBascule),
						A3(
						$author$project$Components$Parametrage$Common$Conception$champDeTexte,
						$author$project$I18n$Cles$pipeEtape4PortailTexte(i18n),
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
							_List_fromArray(
								['texteDuPortail', 'fr']),
							saisie),
						A2($author$project$Components$Parametrage$PipeEtape4$Update$ImbriqueChoisi, 'texteDuPortail', 'fr')),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape4PortailTexteAide(i18n))
							]))
					])),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4QuandTitre(i18n),
				_List_fromArray(
					[
						A4(
						$author$project$Components$Parametrage$Common$Conception$caseSimple,
						'obligatoire',
						saisie.he,
						$author$project$I18n$Cles$pipeEtape4QuandObligatoire(i18n),
						$author$project$Components$Parametrage$PipeEtape4$Update$ObligatoireBascule)
					]))
			]);
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$CommentaireObligatoireBascule = function (a) {
	return {$: 42, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$Update$DecisionBasculee = F2(
	function (a, b) {
		return {$: 41, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$EscaladeApresSaisie = function (a) {
	return {$: 39, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$Update$EscaladeVersChoisie = function (a) {
	return {$: 40, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$Update$QuiValideChoisi = function (a) {
	return {$: 36, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$Update$RelanceDeValidationChoisie = function (a) {
	return {$: 38, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$Model$booleenDe = F2(
	function (chemin, saisie) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A3($author$project$Components$Parametrage$PipeEtape4$Model$lireChemin, $elm$json$Json$Decode$bool, chemin, saisie));
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$QuiValideDesigne = F2(
	function (a, b) {
		return {$: 37, a: a, b: b};
	});
var $author$project$I18n$Cles$pipeEtape4QuiValideAChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.qui-valide.a-choisir', _List_Nil, 'À choisir');
};
var $author$project$Components$Parametrage$PipeEtape4$View$designation = F5(
	function (i18n, libelle, cle, saisie, proposes) {
		return A4(
			$author$project$Components$Parametrage$Common$Conception$liste,
			libelle,
			A2(
				$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
				_List_fromArray(
					['quiValide', cle]),
				saisie),
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'',
					$author$project$I18n$Cles$pipeEtape4QuiValideAChoisir(i18n)),
				A2(
					$elm$core$List$map,
					function (reference) {
						return _Utils_Tuple2(reference.fm, reference.Bl);
					},
					proposes)),
			$author$project$Components$Parametrage$PipeEtape4$Update$QuiValideDesigne(cle));
	});
var $author$project$I18n$Cles$pipeEtape4RoleParRelationNote = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.role.par-relation-note',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			p.bi + ' reçoit la tâche dans son espace du portail, sans compte interne.');
	});
var $author$project$I18n$Cles$pipeEtape4RoleParRelationNoteElide = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.role.par-relation-note-elide',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'L\'' + ($elm$core$String$toLower(p.bi) + ' reçoit la tâche dans son espace du portail, sans compte interne.'));
	});
var $author$project$I18n$Cles$pipeEtape4RoleParRelationNoteLa = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.role.par-relation-note-la',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'La ' + ($elm$core$String$toLower(p.bi) + ' reçoit la tâche dans son espace du portail, sans compte interne.'));
	});
var $author$project$I18n$Cles$pipeEtape4RoleParRelationNoteLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.role.par-relation-note-le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Le ' + ($elm$core$String$toLower(p.bi) + ' reçoit la tâche dans son espace du portail, sans compte interne.'));
	});
var $author$project$Components$Parametrage$PipeEtape4$Phrases$noteDuRoleParRelation = F2(
	function (i18n, role) {
		var _v0 = role.m$;
		if (!_v0.$) {
			var formes = _v0.a;
			if (formes.zX.av) {
				return A2(
					$author$project$I18n$Cles$pipeEtape4RoleParRelationNoteElide,
					i18n,
					{bi: role.Bl});
			} else {
				var _v1 = formes.zX.M;
				if (!_v1) {
					return A2(
						$author$project$I18n$Cles$pipeEtape4RoleParRelationNoteLe,
						i18n,
						{bi: role.Bl});
				} else {
					return A2(
						$author$project$I18n$Cles$pipeEtape4RoleParRelationNoteLa,
						i18n,
						{bi: role.Bl});
				}
			}
		} else {
			return A2(
				$author$project$I18n$Cles$pipeEtape4RoleParRelationNote,
				i18n,
				{bi: role.Bl});
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$View$noteDuRoleParRelation = F2(
	function (i18n, saisie) {
		return A2(
			$elm$core$List$map,
			function (role) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Parametrage$PipeEtape4$Phrases$noteDuRoleParRelation, i18n, role))
						]));
			},
			A2(
				$elm$core$List$filter,
				function (role) {
					return _Utils_eq(role.r8, saisie.H6) && role.EW;
				},
				saisie.B1.o_.eX));
	});
var $author$project$I18n$Cles$pipeEtape4DecisionMinimum = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.decision.minimum', _List_Nil, 'Nombre minimum de réponses');
};
var $author$project$I18n$Cles$pipeEtape4DecisionTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.decision.titre', _List_Nil, 'Règle de décision');
};
var $author$project$I18n$Cles$pipeEtape4DecisionsCommentaire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.decisions.commentaire', _List_Nil, 'Commentaire obligatoire en cas de refus ou de reprise');
};
var $author$project$I18n$Cles$pipeEtape4DecisionsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.decisions.titre', _List_Nil, 'Décisions possibles');
};
var $author$project$I18n$Cles$pipeEtape4DelaisAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.delais.aide', _List_Nil, 'Pendant une absence déclarée, la tâche va au délégué du valideur ; pour un producteur du portail, elle reste à son nom et le gestionnaire est averti.');
};
var $author$project$I18n$Cles$pipeEtape4DelaisEscaladeApres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.delais.escalade-apres', _List_Nil, 'Escalade après (jours)');
};
var $author$project$I18n$Cles$pipeEtape4DelaisEscaladeVers = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.delais.escalade-vers', _List_Nil, 'Escalade vers');
};
var $author$project$I18n$Cles$pipeEtape4DelaisReponse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.delais.reponse', _List_Nil, 'Délai de réponse en jours');
};
var $author$project$I18n$Cles$pipeEtape4DelaisTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.delais.titre', _List_Nil, 'Délais');
};
var $author$project$I18n$Cles$pipeEtape4QuandRelance = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.quand.relance', _List_Nil, 'Relance');
};
var $author$project$I18n$Cles$pipeEtape4QuiValideGroupeChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.qui-valide.groupe-choisir', _List_Nil, 'Groupe');
};
var $author$project$I18n$Cles$pipeEtape4QuiValidePersonneChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.qui-valide.personne-choisir', _List_Nil, 'Personne');
};
var $author$project$I18n$Cles$pipeEtape4QuiValideTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.qui-valide.titre', _List_Nil, 'Qui valide');
};
var $author$project$I18n$Cles$pipeEtape4RoleLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.role.libelle', _List_Nil, 'Rôle dans le dossier');
};
var $author$project$I18n$Cles$pipeEtape4SortieTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.sortie.texte', _List_Nil, 'La décision est disponible dans les conditions des passages : ');
};
var $author$project$I18n$Cles$pipeEtape4SortieTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.sortie.titre', _List_Nil, 'Ce qui en sort');
};
var $author$project$I18n$Cles$pipeEtape4SortieValeur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.sortie.valeur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'sortie',
					$author$project$I18n$Traductions$Chaine(p.IQ))
				]),
			p.IQ + ' = \"accepte\"');
	});
var $author$project$I18n$Cles$pipeEtape4QuiValideGroupe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.qui-valide.groupe', _List_Nil, 'Un groupe');
};
var $author$project$I18n$Cles$pipeEtape4QuiValideGroupeAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.qui-valide.groupe-aide', _List_Nil, 'Les membres d\'un groupe d\'intervenants.');
};
var $author$project$I18n$Cles$pipeEtape4QuiValidePersonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.qui-valide.personne', _List_Nil, 'Une personne nommée');
};
var $author$project$I18n$Cles$pipeEtape4QuiValidePersonneAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.qui-valide.personne-aide', _List_Nil, 'Toujours la même personne, quel que soit le dossier.');
};
var $author$project$I18n$Cles$pipeEtape4QuiValideRole = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.qui-valide.role', _List_Nil, 'Un rôle du dossier');
};
var $author$project$I18n$Cles$pipeEtape4QuiValideRoleAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.qui-valide.role-aide', _List_Nil, 'Le rôle choisi ci-dessous, tel que le dossier le remplit.');
};
var $author$project$Components$Parametrage$Vocabulaire$quiValideDeTache = F2(
	function (i18n, genre) {
		switch (genre) {
			case 'role':
				return _Utils_Tuple2(
					$author$project$I18n$Cles$pipeEtape4QuiValideRole(i18n),
					$author$project$I18n$Cles$pipeEtape4QuiValideRoleAide(i18n));
			case 'personne':
				return _Utils_Tuple2(
					$author$project$I18n$Cles$pipeEtape4QuiValidePersonne(i18n),
					$author$project$I18n$Cles$pipeEtape4QuiValidePersonneAide(i18n));
			case 'groupe':
				return _Utils_Tuple2(
					$author$project$I18n$Cles$pipeEtape4QuiValideGroupe(i18n),
					$author$project$I18n$Cles$pipeEtape4QuiValideGroupeAide(i18n));
			default:
				var autre = genre;
				return _Utils_Tuple2(autre, '');
		}
	});
var $author$project$I18n$Cles$pipeEtape4RelanceNombreDeJour = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.relance.nombre-de-jour',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			p.d + ' jour');
	});
var $author$project$I18n$Cles$pipeEtape4RelanceNombreDeJours = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.relance.nombre-de-jours',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			p.d + ' jours');
	});
var $author$project$Components$Parametrage$Vocabulaire$nombreDeJours = F2(
	function (i18n, jours) {
		return (jours <= 1) ? A2(
			$author$project$I18n$Cles$pipeEtape4RelanceNombreDeJour,
			i18n,
			{
				d: $elm$core$String$fromInt(jours)
			}) : A2(
			$author$project$I18n$Cles$pipeEtape4RelanceNombreDeJours,
			i18n,
			{
				d: $elm$core$String$fromInt(jours)
			});
	});
var $author$project$I18n$Cles$pipeEtape4RelanceAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.relance.aucune', _List_Nil, 'Aucune relance');
};
var $author$project$I18n$Cles$pipeEtape4RelancePuisA = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.relance.puis-a',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'avant',
					$author$project$I18n$Traductions$Chaine(p.je)),
					_Utils_Tuple2(
					'apres',
					$author$project$I18n$Traductions$Chaine(p.iY))
				]),
			p.je + (' puis à ' + p.iY));
	});
var $author$project$I18n$Cles$pipeEtape4RelanceRappelAvant = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.relance.rappel-avant',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			'Un rappel ' + (p.d + ' jours avant'));
	});
var $author$project$I18n$Cles$pipeEtape4RelanceRappelAvantJour = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.relance.rappel-avant-jour',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			'Un rappel ' + (p.d + ' jour avant'));
	});
var $author$project$I18n$Cles$pipeEtape4RelanceRappelPuisEscalade = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.relance.rappel-puis-escalade', _List_Nil, 'Rappel, puis escalade au gestionnaire');
};
var $author$project$I18n$Cles$pipeEtape4RelanceRappelsA = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.relance.rappels-a',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'liste',
					$author$project$I18n$Traductions$Chaine(p.nW))
				]),
			'Rappel à ' + p.nW);
	});
var $author$project$Components$Parametrage$Vocabulaire$relanceDeTache = F3(
	function (i18n, rappels, code) {
		switch (code) {
			case 'aucune':
				return $author$project$I18n$Cles$pipeEtape4RelanceAucune(i18n);
			case 'rappel-avant':
				if (rappels.b) {
					if (!rappels.b.b) {
						var jours = rappels.a;
						return (jours <= 1) ? A2(
							$author$project$I18n$Cles$pipeEtape4RelanceRappelAvantJour,
							i18n,
							{
								d: $elm$core$String$fromInt(jours)
							}) : A2(
							$author$project$I18n$Cles$pipeEtape4RelanceRappelAvant,
							i18n,
							{
								d: $elm$core$String$fromInt(jours)
							});
					} else {
						var premier = rappels.a;
						var suivants = rappels.b;
						return A2(
							$author$project$I18n$Cles$pipeEtape4RelanceRappelsA,
							i18n,
							{
								nW: A3(
									$elm$core$List$foldl,
									F2(
										function (jours, avant) {
											return A2(
												$author$project$I18n$Cles$pipeEtape4RelancePuisA,
												i18n,
												{
													iY: A2($author$project$Components$Parametrage$Vocabulaire$nombreDeJours, i18n, jours),
													je: avant
												});
										}),
									A2($author$project$Components$Parametrage$Vocabulaire$nombreDeJours, i18n, premier),
									suivants)
							});
					}
				} else {
					return A2(
						$author$project$I18n$Cles$pipeEtape4RelanceRappelAvant,
						i18n,
						{d: '0'});
				}
			case 'rappel-puis-escalade':
				return $author$project$I18n$Cles$pipeEtape4RelanceRappelPuisEscalade(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$I18n$Cles$pipeEtape4RoleTenuParRelation = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.role.tenu-par-relation',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi)),
					_Utils_Tuple2(
					'relation',
					$author$project$I18n$Traductions$Chaine(p.Ht))
				]),
			p.bi + (' (tenu par la relation « ' + (p.Ht + ' »)')));
	});
var $author$project$Components$Parametrage$PipeEtape4$Phrases$roleDOption = F2(
	function (i18n, role) {
		var _v0 = _Utils_Tuple2(role.EW, role.Ht);
		if (_v0.a) {
			if (!_v0.b.$) {
				var relation = _v0.b.a;
				return A2(
					$author$project$I18n$Cles$pipeEtape4RoleTenuParRelation,
					i18n,
					{Ht: relation, bi: role.Bl});
			} else {
				var _v1 = _v0.b;
				return A2(
					$author$project$I18n$Cles$pipeEtape4RoleParRelation,
					i18n,
					{bi: role.Bl});
			}
		} else {
			return role.Bl;
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$AvecLesAutresChoisi = function (a) {
	return {$: 46, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$Update$DelaiSaisi = function (a) {
	return {$: 44, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$Update$EcheanceChoisie = function (a) {
	return {$: 43, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$Update$RelanceChoisie = function (a) {
	return {$: 45, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$View$avecLeModeCourant = F2(
	function (courant, modes) {
		return A2($elm$core$List$member, courant, modes) ? modes : A2($elm$core$List$cons, courant, modes);
	});
var $author$project$I18n$Cles$pipeEtape4AvecLesAutresApresLaTache = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.avec-les-autres.apres-la-tache', _List_Nil, 'Après la tâche précédente');
};
var $author$project$I18n$Cles$pipeEtape4AvecLesAutresEnMemeTemps = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.avec-les-autres.en-meme-temps', _List_Nil, 'En même temps');
};
var $author$project$Components$Parametrage$Vocabulaire$avecLesAutresDeTache = F2(
	function (i18n, code) {
		switch (code) {
			case 'en-meme-temps':
				return $author$project$I18n$Cles$pipeEtape4AvecLesAutresEnMemeTemps(i18n);
			case 'apres-la-tache-precedente':
				return $author$project$I18n$Cles$pipeEtape4AvecLesAutresApresLaTache(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$I18n$Cles$pipeEtape4EcheanceApresLArrivee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.echeance.apres-l-arrivee', _List_Nil, 'Après l\'arrivée du dossier à l\'étape');
};
var $author$project$I18n$Cles$pipeEtape4EcheanceApresLOuverture = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.echeance.apres-l-ouverture', _List_Nil, 'Après l\'ouverture du dossier');
};
var $author$project$Components$Parametrage$Vocabulaire$echeanceDeTache = F2(
	function (i18n, code) {
		switch (code) {
			case 'apres-l-arrivee-a-l-etape':
				return $author$project$I18n$Cles$pipeEtape4EcheanceApresLArrivee(i18n);
			case 'apres-l-ouverture-du-dossier':
				return $author$project$I18n$Cles$pipeEtape4EcheanceApresLOuverture(i18n);
			case 'apres-la-fin-de-la-tache-precedente':
				return $author$project$I18n$Cles$pipeEtape4EcheanceApresLaTache(i18n);
			case 'date-fixe':
				return $author$project$I18n$Cles$pipeEtape4EcheanceDateFixe(i18n);
			case 'fin-de-la-periode-d-ouverture':
				return $author$project$I18n$Cles$pipeEtape4EcheanceFinDeLaPeriodeDOuverture(i18n);
			case 'aucune':
				return $author$project$I18n$Cles$pipeEtape4EcheanceAucune(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$I18n$Cles$pipeEtape4QuandAvecLesAutres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.quand.avec-les-autres', _List_Nil, 'Avec les autres tâches de l\'étape');
};
var $author$project$I18n$Cles$pipeEtape4QuandDelai = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.quand.delai', _List_Nil, 'Délai en jours');
};
var $author$project$I18n$Cles$pipeEtape4QuandEcheance = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.quand.echeance', _List_Nil, 'Échéance');
};
var $author$project$Components$Parametrage$PipeEtape4$View$sectionQuandComplete = F5(
	function (i18n, avecSelecteur, avecLesAutres, saisie, avecEcheance) {
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape4QuandTitre(i18n),
			_Utils_ap(
				avecEcheance ? _Utils_ap(
					avecSelecteur ? _List_fromArray(
						[
							A4(
							$author$project$Components$Parametrage$Common$Conception$liste,
							$author$project$I18n$Cles$pipeEtape4QuandEcheance(i18n),
							saisie.xY,
							A2(
								$elm$core$List$map,
								function (mode) {
									return _Utils_Tuple2(
										mode,
										A2($author$project$Components$Parametrage$Vocabulaire$echeanceDeTache, i18n, mode));
								},
								A2($author$project$Components$Parametrage$PipeEtape4$View$avecLeModeCourant, saisie.xY, saisie.B1.o_.x0)),
							$author$project$Components$Parametrage$PipeEtape4$Update$EcheanceChoisie)
						]) : _List_Nil,
					_Utils_ap(
						(saisie.xY === 'apres-l-arrivee-a-l-etape') ? _List_fromArray(
							[
								A3(
								$author$project$Components$Parametrage$Common$Conception$champDeTexte,
								$author$project$I18n$Cles$pipeEtape4QuandDelai(i18n),
								saisie.w2,
								$author$project$Components$Parametrage$PipeEtape4$Update$DelaiSaisi)
							]) : _List_Nil,
						_Utils_ap(
							_List_fromArray(
								[
									A4(
									$author$project$Components$Parametrage$Common$Conception$liste,
									$author$project$I18n$Cles$pipeEtape4QuandRelance(i18n),
									saisie.Hq,
									A2(
										$elm$core$List$map,
										function (mode) {
											return _Utils_Tuple2(
												mode,
												A3($author$project$Components$Parametrage$Vocabulaire$relanceDeTache, i18n, saisie.gN, mode));
										},
										saisie.B1.o_.Hr),
									$author$project$Components$Parametrage$PipeEtape4$Update$RelanceChoisie)
								]),
							avecLesAutres ? _List_fromArray(
								[
									A4(
									$author$project$Components$Parametrage$Common$Conception$liste,
									$author$project$I18n$Cles$pipeEtape4QuandAvecLesAutres(i18n),
									saisie.jg,
									A2(
										$elm$core$List$map,
										function (code) {
											return _Utils_Tuple2(
												code,
												A2($author$project$Components$Parametrage$Vocabulaire$avecLesAutresDeTache, i18n, code));
										},
										saisie.B1.o_.jg),
									$author$project$Components$Parametrage$PipeEtape4$Update$AvecLesAutresChoisi)
								]) : _List_Nil))) : _List_Nil,
				_List_fromArray(
					[
						A4(
						$author$project$Components$Parametrage$Common$Conception$caseSimple,
						'obligatoire',
						saisie.he,
						$author$project$I18n$Cles$pipeEtape4QuandObligatoire(i18n),
						$author$project$Components$Parametrage$PipeEtape4$Update$ObligatoireBascule),
						A4(
						$author$project$Components$Parametrage$Common$Conception$caseSimple,
						'visible',
						saisie.KS,
						$author$project$I18n$Cles$pipeEtape4QuandVisible(i18n),
						$author$project$Components$Parametrage$PipeEtape4$Update$VisibleSurLePortailBascule)
					])));
	});
var $author$project$Components$Parametrage$PipeEtape4$View$sectionQuandAvecSelecteur = F2(
	function (i18n, avecSelecteur) {
		return A3($author$project$Components$Parametrage$PipeEtape4$View$sectionQuandComplete, i18n, avecSelecteur, true);
	});
var $author$project$Components$Parametrage$PipeEtape4$View$sectionQuand = function (i18n) {
	return A2($author$project$Components$Parametrage$PipeEtape4$View$sectionQuandAvecSelecteur, i18n, true);
};
var $author$project$I18n$Cles$pipeEtape4ReutiliserModele = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.reutiliser.modele', _List_Nil, 'Enregistrer comme modèle de tâche');
};
var $author$project$I18n$Cles$pipeEtape4ReutiliserTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.reutiliser.titre', _List_Nil, 'Réutiliser');
};
var $author$project$Components$Parametrage$PipeEtape4$View$sectionReutiliser = function (i18n) {
	return A2(
		$author$project$Components$Parametrage$Common$Conception$drawerSection,
		$author$project$I18n$Cles$pipeEtape4ReutiliserTitre(i18n),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout'),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$pipeEtape4ReutiliserModele(i18n))
					]))
			]));
};
var $author$project$Components$Parametrage$PipeEtape4$Update$RoleDeLaTacheChoisi = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Parametrage$PipeEtape4$View$selectDeRole = F3(
	function (i18n, libelle, saisie) {
		return A4(
			$author$project$Components$Parametrage$Common$Conception$liste,
			libelle,
			saisie.H6,
			A2(
				$elm$core$List$map,
				function (role) {
					return _Utils_Tuple2(
						role.r8,
						A2($author$project$Components$Parametrage$PipeEtape4$Phrases$roleDOption, i18n, role));
				},
				saisie.B1.o_.eX),
			$author$project$Components$Parametrage$PipeEtape4$Update$RoleDeLaTacheChoisi);
	});
var $author$project$Components$Parametrage$PipeEtape4$View$blocDeLaValidation = F2(
	function (i18n, saisie) {
		var regle = A2(
			$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
			_List_fromArray(
				['regle']),
			saisie);
		var genre = A2(
			$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
			_List_fromArray(
				['quiValide', 'genre']),
			saisie);
		var decisions = A2(
			$author$project$Components$Parametrage$PipeEtape4$Model$listeDe,
			_List_fromArray(
				['decisions']),
			saisie);
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4QuiValideTitre(i18n),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						function (code) {
							var _v0 = A2($author$project$Components$Parametrage$Vocabulaire$quiValideDeTache, i18n, code);
							var titre = _v0.a;
							var aide = _v0.b;
							return A6(
								$author$project$Components$Parametrage$Common$Conception$choix,
								'qui-valide',
								code,
								_Utils_eq(genre, code),
								titre,
								aide,
								$author$project$Components$Parametrage$PipeEtape4$Update$QuiValideChoisi(code));
						},
						_List_fromArray(
							['role', 'personne', 'groupe'])),
					function () {
						switch (genre) {
							case 'role':
								return A2(
									$elm$core$List$cons,
									A3(
										$author$project$Components$Parametrage$PipeEtape4$View$selectDeRole,
										i18n,
										$author$project$I18n$Cles$pipeEtape4RoleLibelle(i18n),
										saisie),
									A2($author$project$Components$Parametrage$PipeEtape4$View$noteDuRoleParRelation, i18n, saisie));
							case 'personne':
								return _List_fromArray(
									[
										A5(
										$author$project$Components$Parametrage$PipeEtape4$View$designation,
										i18n,
										$author$project$I18n$Cles$pipeEtape4QuiValidePersonneChoisir(i18n),
										'personneUid',
										saisie,
										saisie.B1.o_.Fg)
									]);
							case 'groupe':
								return _List_fromArray(
									[
										A5(
										$author$project$Components$Parametrage$PipeEtape4$View$designation,
										i18n,
										$author$project$I18n$Cles$pipeEtape4QuiValideGroupeChoisir(i18n),
										'groupeUid',
										saisie,
										saisie.B1.o_.Ac)
									]);
							default:
								return _List_Nil;
						}
					}())),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4DecisionTitre(i18n),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						function (code) {
							var _v2 = A2($author$project$Components$Parametrage$Vocabulaire$regleDeDecision, i18n, code);
							var titre = _v2.a;
							var aide = _v2.b;
							return A6(
								$author$project$Components$Parametrage$Common$Conception$choix,
								'decision',
								code,
								_Utils_eq(regle, code),
								titre,
								aide,
								A2($author$project$Components$Parametrage$PipeEtape4$Update$ParametreChoisi, 'regle', code));
						},
						_List_fromArray(
							['un-seul-valideur', 'unanimite', 'majorite'])),
					_List_fromArray(
						[
							A3(
							$author$project$Components$Parametrage$Common$Conception$champDeTexte,
							$author$project$I18n$Cles$pipeEtape4DecisionMinimum(i18n),
							A2(
								$author$project$Components$Parametrage$PipeEtape4$Model$entierDe,
								_List_fromArray(
									['minimumDeReponses']),
								saisie),
							$author$project$Components$Parametrage$PipeEtape4$Update$ParametreEntierSaisi('minimumDeReponses'))
						]))),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4DelaisTitre(i18n),
				_List_fromArray(
					[
						A3(
						$author$project$Components$Parametrage$Common$Conception$champDeTexte,
						$author$project$I18n$Cles$pipeEtape4DelaisReponse(i18n),
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$entierDe,
							_List_fromArray(
								['delaiDeReponseEnJours']),
							saisie),
						$author$project$Components$Parametrage$PipeEtape4$Update$ParametreEntierSaisi('delaiDeReponseEnJours')),
						A4(
						$author$project$Components$Parametrage$Common$Conception$liste,
						$author$project$I18n$Cles$pipeEtape4QuandRelance(i18n),
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
							_List_fromArray(
								['relance', 'mode']),
							saisie),
						A2(
							$elm$core$List$map,
							function (mode) {
								return _Utils_Tuple2(
									mode,
									A3(
										$author$project$Components$Parametrage$Vocabulaire$relanceDeTache,
										i18n,
										A2(
											$elm$core$Maybe$withDefault,
											saisie.gN,
											A2(
												$elm$core$Maybe$map,
												$elm$core$List$singleton,
												$elm$core$String$toInt(
													A2(
														$author$project$Components$Parametrage$PipeEtape4$Model$entierDe,
														_List_fromArray(
															['relance', 'joursAvant']),
														saisie)))),
										mode));
							},
							saisie.B1.o_.Hs),
						$author$project$Components$Parametrage$PipeEtape4$Update$RelanceDeValidationChoisie),
						A3(
						$author$project$Components$Parametrage$Common$Conception$champDeTexte,
						$author$project$I18n$Cles$pipeEtape4DelaisEscaladeApres(i18n),
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$entierDe,
							_List_fromArray(
								['escalade', 'apresEnJours']),
							saisie),
						$author$project$Components$Parametrage$PipeEtape4$Update$EscaladeApresSaisie),
						A4(
						$author$project$Components$Parametrage$Common$Conception$liste,
						$author$project$I18n$Cles$pipeEtape4DelaisEscaladeVers(i18n),
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
							_List_fromArray(
								['escalade', 'vers', 'roleUid']),
							saisie),
						A2(
							$elm$core$List$map,
							function (role) {
								return _Utils_Tuple2(
									role.r8,
									A2($author$project$Components$Parametrage$PipeEtape4$Phrases$roleDOption, i18n, role));
							},
							saisie.B1.o_.eX),
						$author$project$Components$Parametrage$PipeEtape4$Update$EscaladeVersChoisie),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape4DelaisAide(i18n))
							]))
					])),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4DecisionsTitre(i18n),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						function (code) {
							return A4(
								$author$project$Components$Parametrage$Common$Conception$caseSimple,
								'decisions',
								A2($elm$core$List$member, code, decisions),
								A2($author$project$Components$Parametrage$Vocabulaire$decisionDeTache, i18n, code),
								$author$project$Components$Parametrage$PipeEtape4$Update$DecisionBasculee(code));
						},
						_List_fromArray(
							['accepter', 'refuser', 'demander-une-reprise'])),
					_List_fromArray(
						[
							A4(
							$author$project$Components$Parametrage$Common$Conception$caseSimple,
							'commentaire',
							A2(
								$author$project$Components$Parametrage$PipeEtape4$Model$booleenDe,
								_List_fromArray(
									['commentaireObligatoireSiRefusOuReprise']),
								saisie),
							$author$project$I18n$Cles$pipeEtape4DecisionsCommentaire(i18n),
							$author$project$Components$Parametrage$PipeEtape4$Update$CommentaireObligatoireBascule)
						]))),
				function () {
				var _v3 = saisie.B1.IQ;
				if (!_v3.$) {
					var sortie = _v3.a;
					return A2(
						$author$project$Components$Parametrage$Common$Conception$drawerSection,
						$author$project$I18n$Cles$pipeEtape4SortieTitre(i18n),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu-compose')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape4SortieTexte(i18n)),
										A2(
										$rtfeldman$elm_css$Html$Styled$strong,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$pipeEtape4SortieValeur,
													i18n,
													{IQ: sortie}))
											])),
										$rtfeldman$elm_css$Html$Styled$text('.')
									]))
							]));
				} else {
					return $rtfeldman$elm_css$Html$Styled$text('');
				}
			}(),
				A3($author$project$Components$Parametrage$PipeEtape4$View$sectionQuand, i18n, saisie, false),
				$author$project$Components$Parametrage$PipeEtape4$View$sectionReutiliser(i18n)
			]);
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$ImbriqueRelancesSaisies = F3(
	function (a, b, c) {
		return {$: 33, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$ParametreBascule = F2(
	function (a, b) {
		return {$: 27, a: a, b: b};
	});
var $author$project$I18n$Cles$pipeEtape4CreneauDisponibilites = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.creneau.disponibilites', _List_Nil, 'Chaque invité indique ses disponibilités');
};
var $author$project$I18n$Cles$pipeEtape4CreneauFixe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.creneau.fixe', _List_Nil, 'L\'organisateur fixe la date');
};
var $author$project$I18n$Cles$pipeEtape4CreneauPropose = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.creneau.propose', _List_Nil, 'L\'organisateur propose des créneaux');
};
var $author$project$I18n$Cles$pipeEtape4DroitEcritEtLit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.droit.ecrit-et-lit', _List_Nil, 'Écrit et lit');
};
var $author$project$I18n$Cles$pipeEtape4DroitLit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.droit.lit', _List_Nil, 'Lecture seule');
};
var $author$project$I18n$Cles$pipeEtape4EnvoiApresUnDelai = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.envoi.apres-un-delai', _List_Nil, 'Après un délai');
};
var $author$project$I18n$Cles$pipeEtape4EnvoiArrivee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.envoi.arrivee', _List_Nil, 'À l\'arrivée à l\'étape');
};
var $author$project$I18n$Cles$pipeEtape4FilFermeGestionnaire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.fil.ferme-gestionnaire', _List_Nil, 'Quand le gestionnaire le clôt');
};
var $author$project$I18n$Cles$pipeEtape4FilFermeJamais = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.fil.ferme-jamais', _List_Nil, 'Jamais, tant que le dossier est ouvert');
};
var $author$project$I18n$Cles$pipeEtape4FilFermeSortie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.fil.ferme-sortie', _List_Nil, 'À la sortie de l\'étape');
};
var $author$project$I18n$Cles$pipeEtape4FilOuvreGestionnaire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.fil.ouvre-gestionnaire', _List_Nil, 'Quand le gestionnaire l\'ouvre');
};
var $author$project$I18n$Cles$pipeEtape4LieuChezLEntreprise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.lieu.chez-l-entreprise', _List_Nil, 'Chez l\'entreprise d\'accueil');
};
var $author$project$I18n$Cles$pipeEtape4LieuSurPlace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.lieu.sur-place', _List_Nil, 'Sur place, à l\'atelier');
};
var $author$project$I18n$Cles$pipeEtape4LieuTelephone = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.lieu.telephone', _List_Nil, 'Téléphone');
};
var $author$project$I18n$Cles$pipeEtape4LieuVisioconference = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.lieu.visioconference', _List_Nil, 'Visioconférence');
};
var $author$project$I18n$Cles$pipeEtape4MontantFixe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.montant.fixe', _List_Nil, 'Un montant fixe');
};
var $author$project$I18n$Cles$pipeEtape4MontantListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.montant.liste', _List_Nil, 'Lu dans la liste de prix du public');
};
var $author$project$I18n$Cles$pipeEtape4MoyensEmail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.moyens.email', _List_Nil, 'Lien de paiement par email');
};
var $author$project$I18n$Cles$pipeEtape4MoyensPortail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.moyens.portail', _List_Nil, 'Lien de paiement dans le portail');
};
var $author$project$I18n$Cles$pipeEtape4MoyensVirement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.moyens.virement', _List_Nil, 'Virement, enregistré à la main');
};
var $author$project$I18n$Cles$pipeEtape4OrdreDansLOrdre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.ordre.dans-l-ordre', _List_Nil, 'Dans l\'ordre de la liste');
};
var $author$project$I18n$Cles$pipeEtape4OrdreTousEnsemble = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.ordre.tous-ensemble', _List_Nil, 'Tous en même temps');
};
var $author$project$I18n$Cles$pipeEtape4PayeurComptable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.payeur.comptable', _List_Nil, 'Comptable');
};
var $author$project$I18n$Cles$pipeEtape4PayeurGestionnaire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.payeur.gestionnaire', _List_Nil, 'Gestionnaire');
};
var $author$project$I18n$Cles$pipeEtape4SiVideAttend = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.si-vide.attend', _List_Nil, 'La tâche attend ; le gestionnaire est averti');
};
var $author$project$I18n$Cles$pipeEtape4SiVideIgnore = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.si-vide.ignore', _List_Nil, 'Le signataire est ignoré');
};
var $author$project$I18n$Cles$pipeEtape4SignataireContresigne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.signataire.contresigne', _List_Nil, 'Contresigne');
};
var $author$project$I18n$Cles$pipeEtape4SignataireSigne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.signataire.signe', _List_Nil, 'Signe');
};
var $author$project$I18n$Cles$pipeEtape4VuSiens = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.vu.siens', _List_Nil, 'Seulement ses messages et ceux du gestionnaire');
};
var $author$project$I18n$Cles$pipeEtape4VuTous = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.vu.tous', _List_Nil, 'Tous les messages du fil');
};
var $author$project$Components$Parametrage$Vocabulaire$reglageDeTache = F2(
	function (i18n, code) {
		switch (code) {
			case 'arrivee-a-l-etape':
				return $author$project$I18n$Cles$pipeEtape4EnvoiArrivee(i18n);
			case 'apres-un-delai':
				return $author$project$I18n$Cles$pipeEtape4EnvoiApresUnDelai(i18n);
			case 'le-gestionnaire-l-ouvre':
				return $author$project$I18n$Cles$pipeEtape4FilOuvreGestionnaire(i18n);
			case 'sortie-de-l-etape':
				return $author$project$I18n$Cles$pipeEtape4FilFermeSortie(i18n);
			case 'le-gestionnaire-le-clot':
				return $author$project$I18n$Cles$pipeEtape4FilFermeGestionnaire(i18n);
			case 'jamais':
				return $author$project$I18n$Cles$pipeEtape4FilFermeJamais(i18n);
			case 'tous':
				return $author$project$I18n$Cles$pipeEtape4VuTous(i18n);
			case 'les-siens-et-ceux-du-gestionnaire':
				return $author$project$I18n$Cles$pipeEtape4VuSiens(i18n);
			case 'ecrit-et-lit':
				return $author$project$I18n$Cles$pipeEtape4DroitEcritEtLit(i18n);
			case 'lit':
				return $author$project$I18n$Cles$pipeEtape4DroitLit(i18n);
			case 'visioconference':
				return $author$project$I18n$Cles$pipeEtape4LieuVisioconference(i18n);
			case 'sur-place':
				return $author$project$I18n$Cles$pipeEtape4LieuSurPlace(i18n);
			case 'chez-l-entreprise-d-accueil':
				return $author$project$I18n$Cles$pipeEtape4LieuChezLEntreprise(i18n);
			case 'telephone':
				return $author$project$I18n$Cles$pipeEtape4LieuTelephone(i18n);
			case 'l-organisateur-propose':
				return $author$project$I18n$Cles$pipeEtape4CreneauPropose(i18n);
			case 'chaque-invite-indique-ses-disponibilites':
				return $author$project$I18n$Cles$pipeEtape4CreneauDisponibilites(i18n);
			case 'l-organisateur-fixe-la-date':
				return $author$project$I18n$Cles$pipeEtape4CreneauFixe(i18n);
			case 'liste-de-prix-du-public':
				return $author$project$I18n$Cles$pipeEtape4MontantListe(i18n);
			case 'montant-fixe':
				return $author$project$I18n$Cles$pipeEtape4MontantFixe(i18n);
			case 'gestionnaire':
				return $author$project$I18n$Cles$pipeEtape4PayeurGestionnaire(i18n);
			case 'comptable':
				return $author$project$I18n$Cles$pipeEtape4PayeurComptable(i18n);
			case 'lien-portail':
				return $author$project$I18n$Cles$pipeEtape4MoyensPortail(i18n);
			case 'lien-email':
				return $author$project$I18n$Cles$pipeEtape4MoyensEmail(i18n);
			case 'virement':
				return $author$project$I18n$Cles$pipeEtape4MoyensVirement(i18n);
			case 'dans-l-ordre-de-la-liste':
				return $author$project$I18n$Cles$pipeEtape4OrdreDansLOrdre(i18n);
			case 'tous-en-meme-temps':
				return $author$project$I18n$Cles$pipeEtape4OrdreTousEnsemble(i18n);
			case 'la-tache-attend-et-le-gestionnaire-est-averti':
				return $author$project$I18n$Cles$pipeEtape4SiVideAttend(i18n);
			case 'le-signataire-est-ignore':
				return $author$project$I18n$Cles$pipeEtape4SiVideIgnore(i18n);
			case 'signe':
				return $author$project$I18n$Cles$pipeEtape4SignataireSigne(i18n);
			case 'contresigne':
				return $author$project$I18n$Cles$pipeEtape4SignataireContresigne(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$Blocs$codes = function (i18n) {
	return $elm$core$List$map(
		function (code) {
			return _Utils_Tuple2(
				code,
				A2($author$project$Components$Parametrage$Vocabulaire$reglageDeTache, i18n, code));
		});
};
var $author$project$Components$Parametrage$PipeEtape4$Blocs$libelleDe = F2(
	function (liste_, valeur) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (reference) {
							return _Utils_eq(reference.fm, valeur);
						},
						liste_))));
	});
var $author$project$I18n$Cles$pipeEtape4AQuiAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.a-qui.aide', _List_Nil, 'Les destinataires sont des rôles du dossier.');
};
var $author$project$I18n$Cles$pipeEtape4AQuiTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.a-qui.titre', _List_Nil, 'À qui');
};
var $author$project$I18n$Cles$pipeEtape4MessageCarteAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.message.carte-aide', _List_Nil, 'Modèle de communication · français et anglais');
};
var $author$project$I18n$Cles$pipeEtape4MessageTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.message.titre', _List_Nil, 'Le message');
};
var $author$project$I18n$Cles$pipeEtape4MessageVoir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.message.voir', _List_Nil, 'Voir le modèle');
};
var $author$project$I18n$Cles$pipeEtape4SequenceAttendre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.sequence.attendre', _List_Nil, 'Attendre une réponse');
};
var $author$project$I18n$Cles$pipeEtape4SequenceDelai = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.sequence.delai', _List_Nil, 'Délai, en jours');
};
var $author$project$I18n$Cles$pipeEtape4SequencePremier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.sequence.premier', _List_Nil, 'Premier envoi');
};
var $author$project$I18n$Cles$pipeEtape4SequenceRelances = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.sequence.relances', _List_Nil, 'Relances, en jours');
};
var $author$project$I18n$Cles$pipeEtape4SequenceReponse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.sequence.reponse', _List_Nil, 'Réponse attendue de');
};
var $author$project$I18n$Cles$pipeEtape4SequenceTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.sequence.titre', _List_Nil, 'Séquence');
};
var $author$project$I18n$Cles$pipeEtape4TermineCommunication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.termine.communication', _List_Nil, 'La réponse attendue est reçue, ou la dernière relance est partie.');
};
var $author$project$Components$Parametrage$PipeEtape4$Model$listeDEntiersDe = F2(
	function (chemin, saisie) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A3(
				$author$project$Components$Parametrage$PipeEtape4$Model$lireChemin,
				$elm$json$Json$Decode$list($elm$json$Json$Decode$int),
				chemin,
				saisie));
	});
var $author$project$Components$Parametrage$PipeEtape4$Model$relancesAffichees = F3(
	function (objet, champ, saisie) {
		var _v0 = A2($elm$core$Dict$get, objet + ('.' + champ), saisie.cp);
		if (!_v0.$) {
			var texte = _v0.a;
			return texte;
		} else {
			return A2(
				$elm$core$String$join,
				' puis ',
				A2(
					$elm$core$List$map,
					$elm$core$String$fromInt,
					A2(
						$author$project$Components$Parametrage$PipeEtape4$Model$listeDEntiersDe,
						_List_fromArray(
							[objet, champ]),
						saisie)));
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$ParametreListeBasculee = F3(
	function (a, b, c) {
		return {$: 29, a: a, b: b, c: c};
	});
var $author$project$I18n$Cles$pipeEtape4DetailPayeLicencie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.detail.paye-licencie', _List_Nil, 'Le rôle qui porte le dossier. Le lien de paiement lui est envoyé.');
};
var $author$project$I18n$Cles$pipeEtape4DetailPayeOrganisation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.detail.paye-organisation', _List_Nil, 'Une organisation paie par le contact désigné par son poste.');
};
var $author$project$I18n$Cles$pipeEtape4DetailPayePlusieurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.detail.paye-plusieurs', _List_Nil, 'S\'il y en a plusieurs, le lien va à chacun, le premier qui paie solde la tâche.');
};
var $author$project$I18n$Cles$pipeEtape4DetailPayeRelation = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.detail.paye-relation',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'relation',
					$author$project$I18n$Traductions$Chaine(p.Ht))
				]),
			'Rôle tenu par la relation « ' + (p.Ht + ' » du licencié.'));
	});
var $author$project$Components$Parametrage$PipeEtape4$Phrases$detailDuPayeur = F2(
	function (i18n, role) {
		var _v0 = role.Ht;
		if (_v0.$ === 1) {
			return $author$project$I18n$Cles$pipeEtape4DetailPayeLicencie(i18n);
		} else {
			var relation = _v0.a;
			return A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$elm$core$Maybe$Just(
							A2(
								$author$project$I18n$Cles$pipeEtape4DetailPayeRelation,
								i18n,
								{Ht: relation})),
							A2(
							$elm$core$Maybe$map,
							function (_v1) {
								return $author$project$I18n$Cles$pipeEtape4DetailPayeOrganisation(i18n);
							},
							role.F4),
							role.FU ? $elm$core$Maybe$Just(
							$author$project$I18n$Cles$pipeEtape4DetailPayePlusieurs(i18n)) : $elm$core$Maybe$Nothing
						])));
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$Phrases$orElse = F2(
	function (secours, choisi) {
		if (!choisi.$) {
			return choisi;
		} else {
			return secours;
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$Phrases$ouvrable = F3(
	function (debut, suite, ouvre) {
		return ouvre ? debut : suite;
	});
var $author$project$I18n$Cles$pipeEtape4DroitEcritEtLitSuite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.droit.ecrit-et-lit-suite', _List_Nil, 'écrit et lit');
};
var $author$project$I18n$Cles$pipeEtape4DroitLitSuite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.droit.lit-suite', _List_Nil, 'lecture seule');
};
var $author$project$Components$Parametrage$PipeEtape4$Phrases$droitDuParticipant = F3(
	function (i18n, droit, role) {
		var _v0 = A2($author$project$Components$Parametrage$PipeEtape4$Phrases$orElse, role.xQ, droit);
		_v0$2:
		while (true) {
			if (!_v0.$) {
				switch (_v0.a) {
					case 'ecrit-et-lit':
						return _List_fromArray(
							[
								A2(
								$author$project$Components$Parametrage$PipeEtape4$Phrases$ouvrable,
								$author$project$I18n$Cles$pipeEtape4DroitEcritEtLit(i18n),
								$author$project$I18n$Cles$pipeEtape4DroitEcritEtLitSuite(i18n))
							]);
					case 'lit':
						return _List_fromArray(
							[
								A2(
								$author$project$Components$Parametrage$PipeEtape4$Phrases$ouvrable,
								$author$project$I18n$Cles$pipeEtape4DroitLit(i18n),
								$author$project$I18n$Cles$pipeEtape4DroitLitSuite(i18n))
							]);
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return _List_Nil;
	});
var $author$project$I18n$Cles$pipeEtape4DetailFacultatif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.detail.facultatif', _List_Nil, 'seulement s\'il y en a un');
};
var $author$project$I18n$Cles$pipeEtape4DetailFacultatifDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.detail.facultatif-debut', _List_Nil, 'Seulement s\'il y en a un');
};
var $author$project$Components$Parametrage$PipeEtape4$Phrases$facultatif = F2(
	function (i18n, role) {
		return role.ze ? _List_fromArray(
			[
				A2(
				$author$project$Components$Parametrage$PipeEtape4$Phrases$ouvrable,
				$author$project$I18n$Cles$pipeEtape4DetailFacultatifDebut(i18n),
				$author$project$I18n$Cles$pipeEtape4DetailFacultatif(i18n))
			]) : _List_Nil;
	});
var $author$project$I18n$Cles$pipeEtape4DetailContact = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.detail.contact',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'poste',
					$author$project$I18n$Traductions$Chaine(p.F4))
				]),
			'le contact « ' + (p.F4 + ' »'));
	});
var $author$project$I18n$Cles$pipeEtape4DetailContactDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.detail.contact-de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'poste',
					$author$project$I18n$Traductions$Chaine(p.F4)),
					_Utils_Tuple2(
					'organisation',
					$author$project$I18n$Traductions$Chaine(p.En))
				]),
			'le contact « ' + (p.F4 + (' » de ' + p.En)));
	});
var $author$project$I18n$Cles$pipeEtape4DetailContactDeDebut = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.detail.contact-de-debut',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'poste',
					$author$project$I18n$Traductions$Chaine(p.F4)),
					_Utils_Tuple2(
					'organisation',
					$author$project$I18n$Traductions$Chaine(p.En))
				]),
			'Le contact « ' + (p.F4 + (' » de ' + p.En)));
	});
var $author$project$I18n$Cles$pipeEtape4DetailContactDebut = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.detail.contact-debut',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'poste',
					$author$project$I18n$Traductions$Chaine(p.F4))
				]),
			'Le contact « ' + (p.F4 + ' »'));
	});
var $author$project$Components$Parametrage$PipeEtape4$Phrases$tel = F2(
	function (texte, _v0) {
		return texte;
	});
var $author$project$Components$Parametrage$PipeEtape4$Phrases$identite = F3(
	function (i18n, avecOrganisation, role) {
		var _v0 = _Utils_Tuple2(role.Fd, role.F4);
		if (!_v0.a.$) {
			var personne = _v0.a.a;
			return _List_fromArray(
				[
					$author$project$Components$Parametrage$PipeEtape4$Phrases$tel(personne)
				]);
		} else {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var poste = _v0.b.a;
				var _v2 = avecOrganisation ? role.En : $elm$core$Maybe$Nothing;
				if (!_v2.$) {
					var organisation = _v2.a;
					return _List_fromArray(
						[
							function (ouvre) {
							return ouvre ? A2(
								$author$project$I18n$Cles$pipeEtape4DetailContactDeDebut,
								i18n,
								{En: organisation, F4: poste}) : A2(
								$author$project$I18n$Cles$pipeEtape4DetailContactDe,
								i18n,
								{En: organisation, F4: poste});
						}
						]);
				} else {
					return _List_fromArray(
						[
							function (ouvre) {
							return ouvre ? A2(
								$author$project$I18n$Cles$pipeEtape4DetailContactDebut,
								i18n,
								{F4: poste}) : A2(
								$author$project$I18n$Cles$pipeEtape4DetailContact,
								i18n,
								{F4: poste});
						}
						]);
				}
			} else {
				return _List_Nil;
			}
		}
	});
var $author$project$I18n$Cles$pipeEtape4RoleTenuPar = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.role.tenu-par',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'relation',
					$author$project$I18n$Traductions$Chaine(p.Ht))
				]),
			'Tenu par la relation « ' + (p.Ht + ' »'));
	});
var $author$project$I18n$Cles$pipeEtape4DetailContactParPoste = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.detail.contact-par-poste',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'poste',
					$author$project$I18n$Traductions$Chaine(p.F4))
				]),
			'le contact désigné par le poste « ' + (p.F4 + ' »'));
	});
var $author$project$I18n$Cles$pipeEtape4DetailContactParPosteDebut = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.detail.contact-par-poste-debut',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'poste',
					$author$project$I18n$Traductions$Chaine(p.F4))
				]),
			'Le contact désigné par le poste « ' + (p.F4 + ' »'));
	});
var $author$project$I18n$Cles$pipeEtape4DetailRecoitMessage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.detail.recoit-message', _List_Nil, 'reçoit le message sur son email et dans son espace');
};
var $author$project$I18n$Cles$pipeEtape4DetailRecoitMessageDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.detail.recoit-message-debut', _List_Nil, 'Reçoit le message sur son email et dans son espace');
};
var $author$project$Components$Parametrage$PipeEtape4$Phrases$pourLeMessage = F2(
	function (i18n, role) {
		var _v0 = _Utils_Tuple3(role.Fd, role.F4, role.EW);
		if (!_v0.a.$) {
			if (_v0.c) {
				return _List_fromArray(
					[
						A2(
						$author$project$Components$Parametrage$PipeEtape4$Phrases$ouvrable,
						$author$project$I18n$Cles$pipeEtape4DetailRecoitMessageDebut(i18n),
						$author$project$I18n$Cles$pipeEtape4DetailRecoitMessage(i18n))
					]);
			} else {
				var personne = _v0.a.a;
				return _List_fromArray(
					[
						$author$project$Components$Parametrage$PipeEtape4$Phrases$tel(personne)
					]);
			}
		} else {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var poste = _v0.b.a;
				return _List_fromArray(
					[
						A2(
						$author$project$Components$Parametrage$PipeEtape4$Phrases$ouvrable,
						A2(
							$author$project$I18n$Cles$pipeEtape4DetailContactParPosteDebut,
							i18n,
							{F4: poste}),
						A2(
							$author$project$I18n$Cles$pipeEtape4DetailContactParPoste,
							i18n,
							{F4: poste}))
					]);
			} else {
				return A2($author$project$Components$Parametrage$PipeEtape4$Phrases$facultatif, i18n, role);
			}
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$Phrases$detailDuRole = F4(
	function (i18n, typeDeTache, droit, role) {
		if (typeDeTache === 'paiement') {
			return A2($author$project$Components$Parametrage$PipeEtape4$Phrases$detailDuPayeur, i18n, role);
		} else {
			var prefixe = A2(
				$elm$core$Maybe$map,
				function (relation) {
					return A2(
						$author$project$I18n$Cles$pipeEtape4RoleTenuPar,
						i18n,
						{Ht: relation});
				},
				role.Ht);
			var reste = A2(
				$elm$core$List$indexedMap,
				F2(
					function (rang, morceau) {
						return morceau(
							_Utils_eq(prefixe, $elm$core$Maybe$Nothing) && (!rang));
					}),
				function () {
					switch (typeDeTache) {
						case 'communication':
							return A2($author$project$Components$Parametrage$PipeEtape4$Phrases$pourLeMessage, i18n, role);
						case 'echange':
							return _Utils_ap(
								A3($author$project$Components$Parametrage$PipeEtape4$Phrases$identite, i18n, true, role),
								_Utils_ap(
									A3($author$project$Components$Parametrage$PipeEtape4$Phrases$droitDuParticipant, i18n, droit, role),
									A2($author$project$Components$Parametrage$PipeEtape4$Phrases$facultatif, i18n, role)));
						default:
							return A3($author$project$Components$Parametrage$PipeEtape4$Phrases$identite, i18n, false, role);
					}
				}());
			var joint = function () {
				var _v1 = _Utils_Tuple2(prefixe, reste);
				if (!_v1.a.$) {
					if (_v1.b.b) {
						var debut = _v1.a.a;
						var _v2 = _v1.b;
						return debut + (' : ' + A2($elm$core$String$join, ', ', reste));
					} else {
						var debut = _v1.a.a;
						return debut;
					}
				} else {
					if (_v1.b.b) {
						var _v3 = _v1.a;
						var _v4 = _v1.b;
						var tete = _v4.a;
						var suite = _v4.b;
						return $elm$core$List$isEmpty(suite) ? tete : (tete + (' : ' + A2($elm$core$String$join, ', ', suite)));
					} else {
						var _v5 = _v1.a;
						return '';
					}
				}
			}();
			return joint;
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$Blocs$rolesCochables = F5(
	function (i18n, typeDeTache, groupe, cle, saisie) {
		return A2(
			$elm$core$List$map,
			function (role) {
				return A5(
					$author$project$Components$Parametrage$Common$Conception$caseACocher,
					groupe,
					A2(
						$elm$core$List$member,
						role.r8,
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$listeDe,
							_List_fromArray(
								[cle]),
							saisie)),
					role.Bl,
					A4($author$project$Components$Parametrage$PipeEtape4$Phrases$detailDuRole, i18n, typeDeTache, $elm$core$Maybe$Nothing, role),
					A2($author$project$Components$Parametrage$PipeEtape4$Update$ParametreListeBasculee, cle, role.r8));
			},
			saisie.B1.o_.If);
	});
var $author$project$Components$Parametrage$PipeEtape4$Blocs$rolesNommes = $elm$core$List$map(
	function (role) {
		return _Utils_Tuple2(role.r8, role.Bl);
	});
var $author$project$Components$Parametrage$PipeEtape4$Blocs$communication = F2(
	function (i18n, saisie) {
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4AQuiTitre(i18n),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape4AQuiAide(i18n))
							])),
					A5($author$project$Components$Parametrage$PipeEtape4$Blocs$rolesCochables, i18n, 'communication', 'destinataires', 'destinataireRoleUids', saisie))),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4MessageTitre(i18n),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('carte')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('textes')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$Components$Parametrage$PipeEtape4$Blocs$libelleDe,
													saisie.B1.o_.CJ,
													A2(
														$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
														_List_fromArray(
															['modeleDeCommunicationUid']),
														saisie)))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$pipeEtape4MessageCarteAide(i18n))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
										$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape4MessageVoir(i18n))
									]))
							]))
					])),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4SequenceTitre(i18n),
				_Utils_ap(
					_List_fromArray(
						[
							A4(
							$author$project$Components$Parametrage$Common$Conception$liste,
							$author$project$I18n$Cles$pipeEtape4SequencePremier(i18n),
							A2(
								$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
								_List_fromArray(
									['sequence', 'premierEnvoi']),
								saisie),
							A2(
								$author$project$Components$Parametrage$PipeEtape4$Blocs$codes,
								i18n,
								_List_fromArray(
									['arrivee-a-l-etape', 'apres-un-delai'])),
							A2($author$project$Components$Parametrage$PipeEtape4$Update$ImbriqueChoisi, 'sequence', 'premierEnvoi'))
						]),
					_Utils_ap(
						(A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
							_List_fromArray(
								['sequence', 'premierEnvoi']),
							saisie) === 'apres-un-delai') ? _List_fromArray(
							[
								A3(
								$author$project$Components$Parametrage$Common$Conception$champDeTexte,
								$author$project$I18n$Cles$pipeEtape4SequenceDelai(i18n),
								A2(
									$author$project$Components$Parametrage$PipeEtape4$Model$entierDe,
									_List_fromArray(
										['sequence', 'delaiEnJours']),
									saisie),
								A2($author$project$Components$Parametrage$PipeEtape4$Update$ImbriqueEntierSaisi, 'sequence', 'delaiEnJours'))
							]) : _List_Nil,
						_Utils_ap(
							_List_fromArray(
								[
									A3(
									$author$project$Components$Parametrage$Common$Conception$champDeTexte,
									$author$project$I18n$Cles$pipeEtape4SequenceRelances(i18n),
									A3($author$project$Components$Parametrage$PipeEtape4$Model$relancesAffichees, 'sequence', 'relancesEnJours', saisie),
									A2($author$project$Components$Parametrage$PipeEtape4$Update$ImbriqueRelancesSaisies, 'sequence', 'relancesEnJours')),
									A4(
									$author$project$Components$Parametrage$Common$Conception$caseSimple,
									'reponse',
									A2(
										$author$project$Components$Parametrage$PipeEtape4$Model$booleenDe,
										_List_fromArray(
											['attendreUneReponse']),
										saisie),
									$author$project$I18n$Cles$pipeEtape4SequenceAttendre(i18n),
									$author$project$Components$Parametrage$PipeEtape4$Update$ParametreBascule('attendreUneReponse'))
								]),
							A2(
								$author$project$Components$Parametrage$PipeEtape4$Model$booleenDe,
								_List_fromArray(
									['attendreUneReponse']),
								saisie) ? _List_fromArray(
								[
									A4(
									$author$project$Components$Parametrage$Common$Conception$liste,
									$author$project$I18n$Cles$pipeEtape4SequenceReponse(i18n),
									A2(
										$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
										_List_fromArray(
											['reponseAttendueDeRoleUid']),
										saisie),
									$author$project$Components$Parametrage$PipeEtape4$Blocs$rolesNommes(saisie.B1.o_.HK),
									$author$project$Components$Parametrage$PipeEtape4$Update$ParametreChoisi('reponseAttendueDeRoleUid'))
								]) : _List_Nil)))),
				A2(
				$author$project$Components$Parametrage$PipeEtape4$Blocs$termine,
				i18n,
				$author$project$I18n$Cles$pipeEtape4TermineCommunication(i18n))
			]);
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$SignataireAjoute = {$: 14};
var $author$project$I18n$Cles$pipeEtape4DocAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.doc.aide', _List_Nil, 'Le document signé est rangé avec les documents du dossier.');
};
var $author$project$I18n$Cles$pipeEtape4DocCarteAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.doc.carte-aide', _List_Nil, 'Modèle rempli avec les données du dossier');
};
var $author$project$I18n$Cles$pipeEtape4DocTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.doc.titre', _List_Nil, 'Le document');
};
var $author$project$I18n$Cles$pipeEtape4DocVoir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.doc.voir', _List_Nil, 'Voir le modèle');
};
var $author$project$I18n$Cles$pipeEtape4OrdreLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.ordre.libelle', _List_Nil, 'Ordre de signature');
};
var $author$project$I18n$Cles$pipeEtape4SiVideAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.si-vide.aide', _List_Nil, 'Un signataire par relation sans relation (pas de responsable légal) est ignoré si sa condition n\'est pas remplie.');
};
var $author$project$I18n$Cles$pipeEtape4SiVideLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.si-vide.libelle', _List_Nil, 'Alors');
};
var $author$project$I18n$Cles$pipeEtape4SiVideTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.si-vide.titre', _List_Nil, 'Si un rôle signataire n\'a personne');
};
var $author$project$I18n$Cles$pipeEtape4SignatairesAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.signataires.aide', _List_Nil, 'Les signataires sont des rôles du dossier. Un rôle tenu par une relation peut signer.');
};
var $author$project$I18n$Cles$pipeEtape4SignatairesAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.signataires.ajouter', _List_Nil, 'Ajouter : Signataire');
};
var $author$project$I18n$Cles$pipeEtape4SignatairesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.signataires.titre', _List_Nil, 'Signataires');
};
var $author$project$Components$Parametrage$PipeEtape4$Blocs$pastille = F2(
	function (teinte, texte) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(teinte)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(texte)
				]));
	});
var $author$project$I18n$Cles$pipeEtape4SignataireInterne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.signataire.interne', _List_Nil, 'Interne');
};
var $author$project$I18n$Cles$pipeEtape4SignataireIntitule = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.signataire.intitule',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rang',
					$author$project$I18n$Traductions$Chaine(p.bY)),
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			p.bY + (' · ' + p.bi));
	});
var $author$project$I18n$Cles$pipeEtape4SignataireParRelation = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.signataire.par-relation',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'relation',
					$author$project$I18n$Traductions$Chaine(p.Ht))
				]),
			'Par relation « ' + (p.Ht + ' »'));
	});
var $author$project$I18n$Cles$pipeEtape4SignataireParSonPoste = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.signataire.par-son-poste',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'poste',
					$author$project$I18n$Traductions$Chaine(p.F4))
				]),
			'Signe par son poste « ' + (p.F4 + ' »'));
	});
var $author$project$I18n$Cles$pipeEtape4SignataireRoleDuDossier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.signataire.role-du-dossier', _List_Nil, 'Rôle du dossier');
};
var $author$project$I18n$Cles$pipeEtape4SignataireToujours = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.signataire.toujours', _List_Nil, 'Toujours');
};
var $author$project$Components$Parametrage$PipeEtape4$Blocs$signataire = F4(
	function (i18n, saisie, rang, lu) {
		var role = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (option) {
					return _Utils_eq(option.r8, lu.H6);
				},
				saisie.B1.o_.eX));
		var poste = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.F4;
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (propose) {
						return _Utils_eq(propose.r8, lu.H6);
					},
					saisie.B1.o_.If)));
		var nature = function () {
			if (!role.$) {
				var relation = role.a.Ht;
				var parRelation = role.a.EW;
				var objetVise = role.a.D_;
				return parRelation ? _Utils_Tuple2(
					'violet',
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$I18n$Cles$pipeEtape4SignataireRoleDuDossier(i18n),
						A2(
							$elm$core$Maybe$map,
							function (nom) {
								return A2(
									$author$project$I18n$Cles$pipeEtape4SignataireParRelation,
									i18n,
									{Ht: nom});
							},
							relation))) : (objetVise ? _Utils_Tuple2(
					'bleu',
					$author$project$I18n$Cles$pipeEtape4SignataireRoleDuDossier(i18n)) : _Utils_Tuple2(
					'vert',
					$author$project$I18n$Cles$pipeEtape4SignataireInterne(i18n)));
			} else {
				return _Utils_Tuple2('gris', '');
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('carte'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('signataire')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$pipeEtape4SignataireIntitule,
										i18n,
										{
											bY: $elm$core$String$fromInt(rang + 1),
											bi: A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.Bl;
													},
													role))
										}))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('action')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									function () {
										var _v0 = _Utils_Tuple2(lu.fs, poste);
										if ((_v0.a === 'signe') && (!_v0.b.$)) {
											var nom = _v0.b.a;
											return A2(
												$author$project$I18n$Cles$pipeEtape4SignataireParSonPoste,
												i18n,
												{F4: nom});
										} else {
											return A2($author$project$Components$Parametrage$Vocabulaire$reglageDeTache, i18n, lu.fs);
										}
									}())
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('pastilles')
						]),
					_List_fromArray(
						[
							A2($author$project$Components$Parametrage$PipeEtape4$Blocs$pastille, nature.a, nature.b),
							(lu.j4 === 'toujours') ? A2(
							$author$project$Components$Parametrage$PipeEtape4$Blocs$pastille,
							'gris',
							$author$project$I18n$Cles$pipeEtape4SignataireToujours(i18n)) : A2($author$project$Components$Parametrage$PipeEtape4$Blocs$pastille, 'ambre', lu.j4)
						]))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape4$Blocs$document = F2(
	function (i18n, saisie) {
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4DocTitre(i18n),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('carte')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('textes')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$Components$Parametrage$PipeEtape4$Blocs$libelleDe,
													saisie.B1.o_.CK,
													A2(
														$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
														_List_fromArray(
															['modeleDeDocumentUid']),
														saisie)))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$pipeEtape4DocCarteAide(i18n))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
										$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape4DocVoir(i18n))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape4DocAide(i18n))
							]))
					])),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4SignatairesTitre(i18n),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape4SignatairesAide(i18n))
								]))
						]),
					_Utils_ap(
						A2(
							$elm$core$List$indexedMap,
							A2($author$project$Components$Parametrage$PipeEtape4$Blocs$signataire, i18n, saisie),
							$author$project$Components$Parametrage$PipeEtape4$Model$signatairesDe(saisie)),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('geste'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape4$Update$SignataireAjoute)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape4SignatairesAjouter(i18n))
									])),
								A4(
								$author$project$Components$Parametrage$Common$Conception$liste,
								$author$project$I18n$Cles$pipeEtape4OrdreLibelle(i18n),
								A2(
									$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
									_List_fromArray(
										['ordreDeSignature']),
									saisie),
								A2(
									$author$project$Components$Parametrage$PipeEtape4$Blocs$codes,
									i18n,
									_List_fromArray(
										['dans-l-ordre-de-la-liste', 'tous-en-meme-temps'])),
								$author$project$Components$Parametrage$PipeEtape4$Update$ParametreChoisi('ordreDeSignature'))
							])))),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4SiVideTitre(i18n),
				_List_fromArray(
					[
						A4(
						$author$project$Components$Parametrage$Common$Conception$liste,
						$author$project$I18n$Cles$pipeEtape4SiVideLibelle(i18n),
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
							_List_fromArray(
								['siUnRoleSignataireEstVide']),
							saisie),
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Blocs$codes,
							i18n,
							_List_fromArray(
								['la-tache-attend-et-le-gestionnaire-est-averti', 'le-signataire-est-ignore'])),
						$author$project$Components$Parametrage$PipeEtape4$Update$ParametreChoisi('siUnRoleSignataireEstVide')),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape4SiVideAide(i18n))
							]))
					]))
			]);
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$ImbriqueBascule = F3(
	function (a, b, c) {
		return {$: 32, a: a, b: b, c: c};
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$ParticipantBascule = F2(
	function (a, b) {
		return {$: 35, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$RappelSansReponseBascule = function (a) {
	return {$: 34, a: a};
};
var $author$project$I18n$Cles$pipeEtape4FilFerme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.fil.ferme', _List_Nil, 'Il se ferme');
};
var $author$project$I18n$Cles$pipeEtape4FilLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.fil.libelle', _List_Nil, 'Titre du fil');
};
var $author$project$I18n$Cles$pipeEtape4FilOuvre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.fil.ouvre', _List_Nil, 'Il s\'ouvre');
};
var $author$project$I18n$Cles$pipeEtape4FilTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.fil.titre', _List_Nil, 'Le fil');
};
var $author$project$I18n$Cles$pipeEtape4ParticipantsAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.participants.aide', _List_Nil, 'Les participants sont des rôles du dossier. Un rôle absent du fil ne le voit pas.');
};
var $author$project$I18n$Cles$pipeEtape4ParticipantsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.participants.titre', _List_Nil, 'Qui peut y participer');
};
var $author$project$I18n$Cles$pipeEtape4PrevenirEmail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.prevenir.email', _List_Nil, 'Un email à chaque nouveau message');
};
var $author$project$I18n$Cles$pipeEtape4PrevenirRappel = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.prevenir.rappel',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'jours',
					$author$project$I18n$Traductions$Chaine(p.ni))
				]),
			'Un rappel si personne n\'a répondu en ' + (p.ni + ' jours'));
	});
var $author$project$I18n$Cles$pipeEtape4PrevenirTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.prevenir.titre', _List_Nil, 'Prévenir');
};
var $author$project$I18n$Cles$pipeEtape4TermineEchange = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.termine.echange', _List_Nil, 'Le fil est fermé. Les messages restent consultables dans l\'onglet Échanges du dossier.');
};
var $author$project$I18n$Cles$pipeEtape4VuAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.vu.aide', _List_Nil, 'Un fil réservé à certains rôles reste invisible des autres, sur le portail comme dans le CRM (étape 6).');
};
var $author$project$I18n$Cles$pipeEtape4VuAutorisees = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.vu.autorisees',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'taille',
					$author$project$I18n$Traductions$Chaine(p.Jm))
				]),
			'Autorisées, ' + (p.Jm + ' Mo'));
	});
var $author$project$I18n$Cles$pipeEtape4VuInterdites = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.vu.interdites', _List_Nil, 'Interdites');
};
var $author$project$I18n$Cles$pipeEtape4VuMessages = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.vu.messages', _List_Nil, 'Messages visibles');
};
var $author$project$I18n$Cles$pipeEtape4VuPieces = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.vu.pieces', _List_Nil, 'Pièces jointes');
};
var $author$project$I18n$Cles$pipeEtape4VuTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.vu.titre', _List_Nil, 'Ce que chacun voit');
};
var $author$project$Components$Parametrage$PipeEtape4$Blocs$echange = F2(
	function (i18n, saisie) {
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4FilTitre(i18n),
				_List_fromArray(
					[
						A3(
						$author$project$Components$Parametrage$Common$Conception$champDeTexte,
						$author$project$I18n$Cles$pipeEtape4FilLibelle(i18n),
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
							_List_fromArray(
								['titre', 'fr']),
							saisie),
						A2($author$project$Components$Parametrage$PipeEtape4$Update$ImbriqueChoisi, 'titre', 'fr')),
						A4(
						$author$project$Components$Parametrage$Common$Conception$liste,
						$author$project$I18n$Cles$pipeEtape4FilOuvre(i18n),
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
							_List_fromArray(
								['ouverture']),
							saisie),
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Blocs$codes,
							i18n,
							_List_fromArray(
								['arrivee-a-l-etape', 'le-gestionnaire-l-ouvre'])),
						$author$project$Components$Parametrage$PipeEtape4$Update$ParametreChoisi('ouverture')),
						A4(
						$author$project$Components$Parametrage$Common$Conception$liste,
						$author$project$I18n$Cles$pipeEtape4FilFerme(i18n),
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
							_List_fromArray(
								['fermeture']),
							saisie),
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Blocs$codes,
							i18n,
							_List_fromArray(
								['sortie-de-l-etape', 'le-gestionnaire-le-clot', 'jamais'])),
						$author$project$Components$Parametrage$PipeEtape4$Update$ParametreChoisi('fermeture'))
					])),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4ParticipantsTitre(i18n),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape4ParticipantsAide(i18n))
							])),
					A2(
						$elm$core$List$map,
						function (role) {
							return A5(
								$author$project$Components$Parametrage$Common$Conception$caseACocher,
								'participants',
								!_Utils_eq(
									A2($author$project$Components$Parametrage$PipeEtape4$Model$droitDuParticipant, role.r8, saisie),
									$elm$core$Maybe$Nothing),
								role.Bl,
								A4(
									$author$project$Components$Parametrage$PipeEtape4$Phrases$detailDuRole,
									i18n,
									'echange',
									A2($author$project$Components$Parametrage$PipeEtape4$Model$droitDuParticipant, role.r8, saisie),
									role),
								$author$project$Components$Parametrage$PipeEtape4$Update$ParticipantBascule(role.r8));
						},
						saisie.B1.o_.If))),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4VuTitre(i18n),
				_List_fromArray(
					[
						A4(
						$author$project$Components$Parametrage$Common$Conception$liste,
						$author$project$I18n$Cles$pipeEtape4VuMessages(i18n),
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
							_List_fromArray(
								['messagesVisibles']),
							saisie),
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Blocs$codes,
							i18n,
							_List_fromArray(
								['tous', 'les-siens-et-ceux-du-gestionnaire'])),
						$author$project$Components$Parametrage$PipeEtape4$Update$ParametreChoisi('messagesVisibles')),
						A4(
						$author$project$Components$Parametrage$Common$Conception$liste,
						$author$project$I18n$Cles$pipeEtape4VuPieces(i18n),
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$booleenDe,
							_List_fromArray(
								['piecesJointes', 'autorisees']),
							saisie) ? 'autorisees' : 'interdites',
						_List_fromArray(
							[
								_Utils_Tuple2(
								'autorisees',
								A2(
									$author$project$I18n$Cles$pipeEtape4VuAutorisees,
									i18n,
									{
										Jm: A2(
											$author$project$Components$Parametrage$PipeEtape4$Model$entierDe,
											_List_fromArray(
												['piecesJointes', 'tailleMaxEnMo']),
											saisie)
									})),
								_Utils_Tuple2(
								'interdites',
								$author$project$I18n$Cles$pipeEtape4VuInterdites(i18n))
							]),
						function (code) {
							return A3($author$project$Components$Parametrage$PipeEtape4$Update$ImbriqueBascule, 'piecesJointes', 'autorisees', code === 'autorisees');
						}),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape4VuAide(i18n))
							]))
					])),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4PrevenirTitre(i18n),
				_List_fromArray(
					[
						A4(
						$author$project$Components$Parametrage$Common$Conception$caseSimple,
						'email-par-message',
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$booleenDe,
							_List_fromArray(
								['prevenir', 'emailParMessage']),
							saisie),
						$author$project$I18n$Cles$pipeEtape4PrevenirEmail(i18n),
						A2($author$project$Components$Parametrage$PipeEtape4$Update$ImbriqueBascule, 'prevenir', 'emailParMessage')),
						A4(
						$author$project$Components$Parametrage$Common$Conception$caseSimple,
						'rappel',
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$entierDe,
							_List_fromArray(
								['prevenir', 'rappelSansReponseEnJours']),
							saisie) !== '',
						A2(
							$author$project$I18n$Cles$pipeEtape4PrevenirRappel,
							i18n,
							{
								ni: function () {
									var _v0 = A2(
										$author$project$Components$Parametrage$PipeEtape4$Model$entierDe,
										_List_fromArray(
											['prevenir', 'rappelSansReponseEnJours']),
										saisie);
									if (_v0 === '') {
										return '3';
									} else {
										var jours = _v0;
										return jours;
									}
								}()
							}),
						$author$project$Components$Parametrage$PipeEtape4$Update$RappelSansReponseBascule)
					])),
				A2(
				$author$project$Components$Parametrage$PipeEtape4$Blocs$termine,
				i18n,
				$author$project$I18n$Cles$pipeEtape4TermineEchange(i18n))
			]);
	});
var $author$project$I18n$Cles$pipeEtape4NombreCinq = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.nombre.cinq', _List_Nil, 'cinq');
};
var $author$project$I18n$Cles$pipeEtape4NombreDeux = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.nombre.deux', _List_Nil, 'deux');
};
var $author$project$I18n$Cles$pipeEtape4NombreQuatre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.nombre.quatre', _List_Nil, 'quatre');
};
var $author$project$I18n$Cles$pipeEtape4NombreSix = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.nombre.six', _List_Nil, 'six');
};
var $author$project$I18n$Cles$pipeEtape4NombreTrois = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.nombre.trois', _List_Nil, 'trois');
};
var $author$project$I18n$Cles$pipeEtape4TermineEvaluation = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.termine.evaluation',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Les ' + (p.w + ' évaluateurs ont rendu leur note, ou la date limite est passée. Les champs obligatoires doivent être remplis.'));
	});
var $author$project$I18n$Cles$pipeEtape4TermineEvaluationUn = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.termine.evaluation-un', _List_Nil, 'L\'évaluateur a rendu sa note, ou la date limite est passée. Les champs obligatoires doivent être remplis.');
};
var $author$project$Components$Parametrage$PipeEtape4$Phrases$evaluateurs = F2(
	function (i18n, n) {
		switch (n) {
			case 1:
				return $author$project$I18n$Cles$pipeEtape4TermineEvaluationUn(i18n);
			case 2:
				return A2(
					$author$project$I18n$Cles$pipeEtape4TermineEvaluation,
					i18n,
					{
						w: $author$project$I18n$Cles$pipeEtape4NombreDeux(i18n)
					});
			case 3:
				return A2(
					$author$project$I18n$Cles$pipeEtape4TermineEvaluation,
					i18n,
					{
						w: $author$project$I18n$Cles$pipeEtape4NombreTrois(i18n)
					});
			case 4:
				return A2(
					$author$project$I18n$Cles$pipeEtape4TermineEvaluation,
					i18n,
					{
						w: $author$project$I18n$Cles$pipeEtape4NombreQuatre(i18n)
					});
			case 5:
				return A2(
					$author$project$I18n$Cles$pipeEtape4TermineEvaluation,
					i18n,
					{
						w: $author$project$I18n$Cles$pipeEtape4NombreCinq(i18n)
					});
			case 6:
				return A2(
					$author$project$I18n$Cles$pipeEtape4TermineEvaluation,
					i18n,
					{
						w: $author$project$I18n$Cles$pipeEtape4NombreSix(i18n)
					});
			default:
				return A2(
					$author$project$I18n$Cles$pipeEtape4TermineEvaluation,
					i18n,
					{
						w: $elm$core$String$fromInt(n)
					});
		}
	});
var $author$project$I18n$Cles$pipeEtape4NotesLaPlusBasse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.notes.la-plus-basse', _List_Nil, 'La note la plus basse');
};
var $author$project$I18n$Cles$pipeEtape4NotesMediane = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.notes.mediane', _List_Nil, 'Médiane');
};
var $author$project$I18n$Cles$pipeEtape4NotesMoyenne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.notes.moyenne', _List_Nil, 'Moyenne des notes');
};
var $author$project$Components$Parametrage$Vocabulaire$notesDeTache = F2(
	function (i18n, code) {
		switch (code) {
			case 'moyenne':
				return $author$project$I18n$Cles$pipeEtape4NotesMoyenne(i18n);
			case 'mediane':
				return $author$project$I18n$Cles$pipeEtape4NotesMediane(i18n);
			case 'la-plus-basse':
				return $author$project$I18n$Cles$pipeEtape4NotesLaPlusBasse(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$ParametreOuNulChoisi = F2(
	function (a, b) {
		return {$: 26, a: a, b: b};
	});
var $author$project$I18n$Cles$pipeEtape4PayeurPosteNom = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.payeur.poste-nom',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'poste',
					$author$project$I18n$Traductions$Chaine(p.F4))
				]),
			'Poste « ' + (p.F4 + ' »'));
	});
var $author$project$Components$Parametrage$PipeEtape4$Blocs$nomDuPoste = F2(
	function (i18n, poste) {
		return A2(
			$author$project$I18n$Cles$pipeEtape4PayeurPosteNom,
			i18n,
			{F4: poste.Bl});
	});
var $author$project$I18n$Cles$pipeEtape4MontantLitDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.montant.lit-debut', _List_Nil, 'La tâche lit l\'');
};
var $author$project$I18n$Cles$pipeEtape4MontantLitFin = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.montant.lit-fin',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'offre',
					$author$project$I18n$Traductions$Chaine(p.D1))
				]),
			' : ici, l\'offre ' + (p.D1 + '.'));
	});
var $author$project$I18n$Cles$pipeEtape4MontantLitFort = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.montant.lit-fort', _List_Nil, 'offre du dossier');
};
var $author$project$Components$Parametrage$PipeEtape4$Blocs$offreDuDossier = F2(
	function (i18n, saisie) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (tarif) {
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape4MontantLitDebut(i18n)),
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape4MontantLitFort(i18n))
										])),
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$pipeEtape4MontantLitFin,
										i18n,
										{D1: tarif.D1}))
								]))
						]);
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filterMap,
						function ($) {
							return $.F9;
						},
						saisie.B1.o_.BW))));
	});
var $author$project$I18n$Cles$pipeEtape4MontantFixeLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.montant.fixe-libelle', _List_Nil, 'Montant, en euros');
};
var $author$project$I18n$Cles$pipeEtape4MontantLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.montant.libelle', _List_Nil, 'Montant');
};
var $author$project$I18n$Cles$pipeEtape4MontantListeLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.montant.liste-libelle', _List_Nil, 'Liste de prix');
};
var $author$project$I18n$Cles$pipeEtape4MontantTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.montant.titre', _List_Nil, 'Ce qu\'on fait payer');
};
var $author$project$I18n$Cles$pipeEtape4MoyensTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.moyens.titre', _List_Nil, 'Comment il paie');
};
var $author$project$I18n$Cles$pipeEtape4PayeurAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.payeur.aide', _List_Nil, 'Le payeur est un rôle du dossier. Un rôle tenu par une relation peut payer.');
};
var $author$project$I18n$Cles$pipeEtape4PayeurContact = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.payeur.contact', _List_Nil, 'Son contact principal');
};
var $author$project$I18n$Cles$pipeEtape4PayeurOrganisation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.payeur.organisation', _List_Nil, 'Si le payeur est une organisation : la demande va au poste choisi ci-dessous. Sans poste désigné, la publication est refusée.');
};
var $author$project$I18n$Cles$pipeEtape4PayeurPoste = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.payeur.poste', _List_Nil, 'Poste qui paie pour l\'organisation');
};
var $author$project$I18n$Cles$pipeEtape4PayeurTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.payeur.titre', _List_Nil, 'Qui paie, qui enregistre');
};
var $author$project$I18n$Cles$pipeEtape4PayeurVirement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.payeur.virement', _List_Nil, 'Peut enregistrer un virement reçu');
};
var $author$project$I18n$Cles$pipeEtape4PrixDansProduits = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.prix.dans-produits', _List_Nil, 'Les prix se règlent dans le module produits, pas ici.');
};
var $author$project$I18n$Cles$pipeEtape4PaiementDossierDebut = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.paiement.dossier.debut',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'offre',
					$author$project$I18n$Traductions$Chaine(p.D1)),
					_Utils_Tuple2(
					'public',
					$author$project$I18n$Traductions$Chaine(p.pF))
				]),
			'Pour ce dossier : ' + (p.D1 + (', public « ' + (p.pF + ' » : '))));
	});
var $author$project$I18n$Cles$pipeEtape4PaiementDossierFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.paiement.dossier.fin', _List_Nil, '.');
};
var $author$project$Components$Parametrage$PipeEtape4$Phrases$pourCeDossier = F2(
	function (i18n, tarif) {
		return _List_fromArray(
			[
				A2(
				$author$project$I18n$Cles$pipeEtape4PaiementDossierDebut,
				i18n,
				{D1: tarif.D1, pF: tarif.pF}),
				tarif.oi,
				$author$project$I18n$Cles$pipeEtape4PaiementDossierFin(i18n)
			]);
	});
var $author$project$Components$Parametrage$PipeEtape4$Blocs$tableauDesPrix = F2(
	function (i18n, saisie) {
		var _v0 = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (l) {
					return _Utils_eq(
						l.fm,
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
							_List_fromArray(
								['montant', 'listeDePrixUid']),
							saisie));
				},
				saisie.B1.o_.BW));
		if (!_v0.$) {
			var choisie = _v0.a;
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('prix')
						]),
					A2(
						$elm$core$List$map,
						function (ligne) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(ligne.pF)
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$strong,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(ligne.oi)
											]))
									]));
						},
						choisie.gV)),
					function () {
					var _v1 = choisie.F9;
					if (!_v1.$) {
						var tarif = _v1.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('bande')
								]),
							A2(
								$elm$core$List$indexedMap,
								F2(
									function (rang, morceau) {
										return (rang === 1) ? A2(
											$rtfeldman$elm_css$Html$Styled$strong,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(morceau)
												])) : $rtfeldman$elm_css$Html$Styled$text(morceau);
									}),
								A2($author$project$Components$Parametrage$PipeEtape4$Phrases$pourCeDossier, i18n, tarif)));
					} else {
						return $rtfeldman$elm_css$Html$Styled$text('');
					}
				}(),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape4PrixDansProduits(i18n))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$Blocs$paiement = F2(
	function (i18n, saisie) {
		var payeur = A2(
			$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
			_List_fromArray(
				['payeurRoleUid']),
			saisie);
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4MontantTitre(i18n),
				_Utils_ap(
					A2($author$project$Components$Parametrage$PipeEtape4$Blocs$offreDuDossier, i18n, saisie),
					_Utils_ap(
						_List_fromArray(
							[
								A4(
								$author$project$Components$Parametrage$Common$Conception$liste,
								$author$project$I18n$Cles$pipeEtape4MontantLibelle(i18n),
								A2(
									$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
									_List_fromArray(
										['montant', 'source']),
									saisie),
								A2(
									$author$project$Components$Parametrage$PipeEtape4$Blocs$codes,
									i18n,
									_List_fromArray(
										['liste-de-prix-du-public', 'montant-fixe'])),
								A2($author$project$Components$Parametrage$PipeEtape4$Update$ImbriqueChoisi, 'montant', 'source'))
							]),
						(A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
							_List_fromArray(
								['montant', 'source']),
							saisie) === 'montant-fixe') ? _List_fromArray(
							[
								A3(
								$author$project$Components$Parametrage$Common$Conception$champDeTexte,
								$author$project$I18n$Cles$pipeEtape4MontantFixeLibelle(i18n),
								A2(
									$author$project$Components$Parametrage$PipeEtape4$Model$entierDe,
									_List_fromArray(
										['montant', 'montant']),
									saisie),
								A2($author$project$Components$Parametrage$PipeEtape4$Update$ImbriqueEntierSaisi, 'montant', 'montant'))
							]) : A2(
							$elm$core$List$cons,
							A4(
								$author$project$Components$Parametrage$Common$Conception$liste,
								$author$project$I18n$Cles$pipeEtape4MontantListeLibelle(i18n),
								A2(
									$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
									_List_fromArray(
										['montant', 'listeDePrixUid']),
									saisie),
								A2(
									$elm$core$List$map,
									function (l) {
										return _Utils_Tuple2(l.fm, l.Bl);
									},
									saisie.B1.o_.BW),
								A2($author$project$Components$Parametrage$PipeEtape4$Update$ImbriqueChoisi, 'montant', 'listeDePrixUid')),
							A2($author$project$Components$Parametrage$PipeEtape4$Blocs$tableauDesPrix, i18n, saisie))))),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4PayeurTitre(i18n),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape4PayeurAide(i18n))
							])),
					_Utils_ap(
						A2(
							$elm$core$List$map,
							function (role) {
								return A6(
									$author$project$Components$Parametrage$Common$Conception$choix,
									'payeur',
									role.r8,
									_Utils_eq(payeur, role.r8),
									role.Bl,
									A4($author$project$Components$Parametrage$PipeEtape4$Phrases$detailDuRole, i18n, 'paiement', $elm$core$Maybe$Nothing, role),
									A2($author$project$Components$Parametrage$PipeEtape4$Update$ParametreChoisi, 'payeurRoleUid', role.r8));
							},
							saisie.B1.o_.If),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu-compose')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape4PayeurOrganisation(i18n))
									])),
								A4(
								$author$project$Components$Parametrage$Common$Conception$liste,
								$author$project$I18n$Cles$pipeEtape4PayeurPoste(i18n),
								A2(
									$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
									_List_fromArray(
										['posteQuiPaieUid']),
									saisie),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'',
										$author$project$I18n$Cles$pipeEtape4PayeurContact(i18n)),
									A2(
										$elm$core$List$map,
										function (poste) {
											return _Utils_Tuple2(
												poste.fm,
												A2($author$project$Components$Parametrage$PipeEtape4$Blocs$nomDuPoste, i18n, poste));
										},
										saisie.B1.o_.F6)),
								$author$project$Components$Parametrage$PipeEtape4$Update$ParametreOuNulChoisi('posteQuiPaieUid')),
								A4(
								$author$project$Components$Parametrage$Common$Conception$liste,
								$author$project$I18n$Cles$pipeEtape4PayeurVirement(i18n),
								A2(
									$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
									_List_fromArray(
										['peutEnregistrerUnVirement']),
									saisie),
								A2(
									$author$project$Components$Parametrage$PipeEtape4$Blocs$codes,
									i18n,
									_List_fromArray(
										['gestionnaire', 'comptable'])),
								$author$project$Components$Parametrage$PipeEtape4$Update$ParametreChoisi('peutEnregistrerUnVirement'))
							])))),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4MoyensTitre(i18n),
				A2(
					$elm$core$List$map,
					function (code) {
						return A4(
							$author$project$Components$Parametrage$Common$Conception$caseSimple,
							'moyens',
							A2(
								$elm$core$List$member,
								code,
								A2(
									$author$project$Components$Parametrage$PipeEtape4$Model$listeDe,
									_List_fromArray(
										['moyens']),
									saisie)),
							A2($author$project$Components$Parametrage$Vocabulaire$reglageDeTache, i18n, code),
							A2($author$project$Components$Parametrage$PipeEtape4$Update$ParametreListeBasculee, 'moyens', code));
					},
					_List_fromArray(
						['lien-portail', 'lien-email', 'virement'])))
			]);
	});
var $author$project$I18n$Cles$pipeEtape4EvaluateursAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.evaluateurs.aide', _List_Nil, 'Chaque évaluateur reçoit sa part de la tâche.');
};
var $author$project$I18n$Cles$pipeEtape4EvaluateursLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.evaluateurs.libelle', _List_Nil, 'Nombre d\'évaluateurs requis');
};
var $author$project$I18n$Cles$pipeEtape4NotesLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.notes.libelle', _List_Nil, 'Si deux notes diffèrent');
};
var $author$project$I18n$Cles$pipeEtape4TerminePaiement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.termine.paiement', _List_Nil, 'Le prestataire de paiement confirme le paiement, ou le gestionnaire enregistre un paiement reçu hors ligne.');
};
var $author$project$I18n$Cles$pipeEtape4TermineSignature = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.termine.signature', _List_Nil, 'Tous les signataires attendus ont signé. Le document signé est alors rangé dans le dossier.');
};
var $author$project$I18n$Cles$pipeEtape4CreneauDans = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.creneau.dans', _List_Nil, 'Dans les, en jours après l\'arrivée à l\'étape');
};
var $author$project$I18n$Cles$pipeEtape4CreneauDisponibilitesAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.creneau.disponibilites-aide', _List_Nil, 'Le premier créneau commun est retenu.');
};
var $author$project$I18n$Cles$pipeEtape4CreneauFixeAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.creneau.fixe-aide', _List_Nil, 'Les invités la confirment.');
};
var $author$project$I18n$Cles$pipeEtape4CreneauProposeAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.creneau.propose-aide', _List_Nil, 'Les invités en choisissent un sur leur portail ou dans l\'email.');
};
var $author$project$I18n$Cles$pipeEtape4CreneauTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.creneau.titre', _List_Nil, 'Comment on choisit le créneau');
};
var $author$project$I18n$Cles$pipeEtape4LieuChezLEntrepriseAdresse = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.lieu.chez-l-entreprise-adresse',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'organisation',
					$author$project$I18n$Traductions$Chaine(p.En))
				]),
			'Chez l\'entreprise d\'accueil : l\'adresse est reprise de la fiche de ' + (p.En + '.'));
	});
var $author$project$I18n$Cles$pipeEtape4QuiInvites = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.qui.invites', _List_Nil, 'Les invités viennent du dossier.');
};
var $author$project$I18n$Cles$pipeEtape4QuiOrganisateur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.qui.organisateur', _List_Nil, 'Organisateur');
};
var $author$project$I18n$Cles$pipeEtape4QuiTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.qui.titre', _List_Nil, 'Qui');
};
var $author$project$I18n$Cles$pipeEtape4RappelsAvant = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.rappels.avant', _List_Nil, 'Rappel avant, en heures');
};
var $author$project$I18n$Cles$pipeEtape4RappelsRelancer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.rappels.relancer', _List_Nil, 'Relancer un invité qui n\'a pas répondu');
};
var $author$project$I18n$Cles$pipeEtape4RappelsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.rappels.titre', _List_Nil, 'Rappels');
};
var $author$project$I18n$Cles$pipeEtape4RdvDuree = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.rdv.duree', _List_Nil, 'Durée, en minutes');
};
var $author$project$I18n$Cles$pipeEtape4RdvLieu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.rdv.lieu', _List_Nil, 'Lieu');
};
var $author$project$I18n$Cles$pipeEtape4RdvTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.rdv.titre', _List_Nil, 'Le rendez-vous');
};
var $author$project$I18n$Cles$pipeEtape4TermineRendezVous = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.termine.rendez-vous', _List_Nil, 'Le rendez-vous a eu lieu et l\'organisateur l\'a déclaré tenu. S\'il est annulé, la tâche revient à « choisir un créneau ».');
};
var $author$project$I18n$Cles$pipeEtape4RoleParRelationCourt = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.role.par-relation-court',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			p.bi + ' (par relation)');
	});
var $author$project$Components$Parametrage$PipeEtape4$Blocs$rolesEnListe = function (i18n) {
	return $elm$core$List$map(
		function (role) {
			return _Utils_Tuple2(
				role.r8,
				role.EW ? A2(
					$author$project$I18n$Cles$pipeEtape4RoleParRelationCourt,
					i18n,
					{bi: role.Bl}) : role.Bl);
		});
};
var $author$project$Components$Parametrage$PipeEtape4$Blocs$rendezVous = F2(
	function (i18n, saisie) {
		var creneau = A2(
			$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
			_List_fromArray(
				['creneau']),
			saisie);
		var option = F3(
			function (code, titre, aide) {
				return A6(
					$author$project$Components$Parametrage$Common$Conception$choix,
					'creneau',
					code,
					_Utils_eq(creneau, code),
					titre,
					aide,
					A2($author$project$Components$Parametrage$PipeEtape4$Update$ParametreChoisi, 'creneau', code));
			});
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4QuiTitre(i18n),
				_Utils_ap(
					_List_fromArray(
						[
							A4(
							$author$project$Components$Parametrage$Common$Conception$liste,
							$author$project$I18n$Cles$pipeEtape4QuiOrganisateur(i18n),
							A2(
								$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
								_List_fromArray(
									['organisateurRoleUid']),
								saisie),
							A2($author$project$Components$Parametrage$PipeEtape4$Blocs$rolesEnListe, i18n, saisie.B1.o_.Em),
							$author$project$Components$Parametrage$PipeEtape4$Update$ParametreChoisi('organisateurRoleUid')),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape4QuiInvites(i18n))
								]))
						]),
					A5($author$project$Components$Parametrage$PipeEtape4$Blocs$rolesCochables, i18n, 'rendez-vous', 'invites', 'inviteRoleUids', saisie))),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4RdvTitre(i18n),
				_List_fromArray(
					[
						A3(
						$author$project$Components$Parametrage$Common$Conception$champDeTexte,
						$author$project$I18n$Cles$pipeEtape4RdvDuree(i18n),
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$entierDe,
							_List_fromArray(
								['dureeEnMinutes']),
							saisie),
						$author$project$Components$Parametrage$PipeEtape4$Update$ParametreEntierSaisi('dureeEnMinutes')),
						A4(
						$author$project$Components$Parametrage$Common$Conception$liste,
						$author$project$I18n$Cles$pipeEtape4RdvLieu(i18n),
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
							_List_fromArray(
								['lieu']),
							saisie),
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Blocs$codes,
							i18n,
							_List_fromArray(
								['visioconference', 'sur-place', 'chez-l-entreprise-d-accueil', 'telephone'])),
						$author$project$Components$Parametrage$PipeEtape4$Update$ParametreChoisi('lieu')),
						function () {
						var _v0 = _Utils_Tuple2(
							A2(
								$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
								_List_fromArray(
									['lieu']),
								saisie),
							saisie.B1.o_.yZ);
						if ((_v0.a === 'chez-l-entreprise-d-accueil') && (!_v0.b.$)) {
							var exemple = _v0.b.a;
							return A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$pipeEtape4LieuChezLEntrepriseAdresse,
											i18n,
											{En: exemple.En}))
									]));
						} else {
							return $rtfeldman$elm_css$Html$Styled$text('');
						}
					}()
					])),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4CreneauTitre(i18n),
				_List_fromArray(
					[
						A3(
						option,
						'l-organisateur-propose',
						$author$project$I18n$Cles$pipeEtape4CreneauPropose(i18n),
						$author$project$I18n$Cles$pipeEtape4CreneauProposeAide(i18n)),
						A3(
						option,
						'chaque-invite-indique-ses-disponibilites',
						$author$project$I18n$Cles$pipeEtape4CreneauDisponibilites(i18n),
						$author$project$I18n$Cles$pipeEtape4CreneauDisponibilitesAide(i18n)),
						A3(
						option,
						'l-organisateur-fixe-la-date',
						$author$project$I18n$Cles$pipeEtape4CreneauFixe(i18n),
						$author$project$I18n$Cles$pipeEtape4CreneauFixeAide(i18n)),
						A3(
						$author$project$Components$Parametrage$Common$Conception$champDeTexte,
						$author$project$I18n$Cles$pipeEtape4CreneauDans(i18n),
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$entierDe,
							_List_fromArray(
								['danslesEnJours']),
							saisie),
						$author$project$Components$Parametrage$PipeEtape4$Update$ParametreEntierSaisi('danslesEnJours'))
					])),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4RappelsTitre(i18n),
				_List_fromArray(
					[
						A3(
						$author$project$Components$Parametrage$Common$Conception$champDeTexte,
						$author$project$I18n$Cles$pipeEtape4RappelsAvant(i18n),
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$entierDe,
							_List_fromArray(
								['rappelAvantEnHeures']),
							saisie),
						$author$project$Components$Parametrage$PipeEtape4$Update$ParametreEntierSaisi('rappelAvantEnHeures')),
						A4(
						$author$project$Components$Parametrage$Common$Conception$caseSimple,
						'relancer',
						A2(
							$author$project$Components$Parametrage$PipeEtape4$Model$booleenDe,
							_List_fromArray(
								['relancerUnInviteSansReponse']),
							saisie),
						$author$project$I18n$Cles$pipeEtape4RappelsRelancer(i18n),
						$author$project$Components$Parametrage$PipeEtape4$Update$ParametreBascule('relancerUnInviteSansReponse'))
					])),
				A2(
				$author$project$Components$Parametrage$PipeEtape4$Blocs$termine,
				i18n,
				$author$project$I18n$Cles$pipeEtape4TermineRendezVous(i18n))
			]);
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$ChangerDeFormulaireDemande = {$: 9};
var $author$project$Components$Parametrage$PipeEtape4$Update$FormulaireChoisi = function (a) {
	return {$: 8, a: a};
};
var $author$project$I18n$Cles$pipeEtape4FormulaireChamps = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.formulaire.champs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			p.d + ' champs');
	});
var $author$project$I18n$Cles$pipeEtape4FormulaireChampsNotes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.formulaire.champs-notes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d)),
					_Utils_Tuple2(
					'notes',
					$author$project$I18n$Traductions$Chaine(p.oL))
				]),
			p.d + (' champs, dont ' + (p.oL + ' notés')));
	});
var $author$project$Components$Parametrage$PipeEtape4$Phrases$champsDuFormulaire = F2(
	function (i18n, formulaire) {
		return (formulaire.Dw > 0) ? A2(
			$author$project$I18n$Cles$pipeEtape4FormulaireChampsNotes,
			i18n,
			{
				d: $elm$core$String$fromInt(formulaire.Dv),
				oL: $elm$core$String$fromInt(formulaire.Dw)
			}) : A2(
			$author$project$I18n$Cles$pipeEtape4FormulaireChamps,
			i18n,
			{
				d: $elm$core$String$fromInt(formulaire.Dv)
			});
	});
var $author$project$I18n$Cles$pipeEtape4FormulaireChanger = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.formulaire.changer', _List_Nil, 'Changer de formulaire');
};
var $author$project$I18n$Cles$pipeEtape4FormulaireVoir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.formulaire.voir', _List_Nil, 'Voir le formulaire');
};
var $author$project$Components$Parametrage$PipeEtape4$View$sectionDuFormulaire = F2(
	function (i18n, saisie) {
		var compatibles = A2($author$project$Components$Parametrage$PipeEtape4$Model$formulairesCompatibles, saisie.B1.r0, saisie.aA);
		var choixDuFormulaire = ((!_Utils_eq(compatibles, _List_Nil)) && (saisie.jI || _Utils_eq(saisie.B1.zT, $elm$core$Maybe$Nothing))) ? _List_fromArray(
			[
				A4(
				$author$project$Components$Parametrage$Common$Conception$liste,
				$author$project$I18n$Cles$pipeEtape4FormulaireChoisir(i18n),
				saisie.mR,
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'',
						$author$project$I18n$Cles$pipeEtape4FormulaireAucun(i18n)),
					A2(
						$elm$core$List$map,
						function (formulaire) {
							return _Utils_Tuple2(
								formulaire.r8,
								$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(formulaire.R));
						},
						compatibles)),
				$author$project$Components$Parametrage$PipeEtape4$Update$FormulaireChoisi)
			]) : _List_Nil;
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape4FormulaireTitre(i18n),
			_Utils_ap(
				function () {
					var _v0 = saisie.B1.zT;
					if (!_v0.$) {
						var formulaire = _v0.a;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('carte')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('textes')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(formulaire.R))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2($author$project$Components$Parametrage$PipeEtape4$Phrases$champsDuFormulaire, i18n, formulaire))
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$button,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
												$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$pipeEtape4FormulaireVoir(i18n))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('geste'),
										$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
										_Utils_eq(compatibles, _List_Nil)),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape4$Update$ChangerDeFormulaireDemande)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape4FormulaireChanger(i18n))
									]))
							]);
					} else {
						return _List_Nil;
					}
				}(),
				choixDuFormulaire));
	});
var $author$project$Components$Parametrage$PipeEtape4$View$sectionQuandDuDocument = F2(
	function (i18n, saisie) {
		return A5($author$project$Components$Parametrage$PipeEtape4$View$sectionQuandComplete, i18n, false, false, saisie, true);
	});
var $author$project$I18n$Cles$pipeEtape4QuiLaFaitTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.qui-la-fait.titre', _List_Nil, 'Qui la fait');
};
var $author$project$Components$Parametrage$PipeEtape4$View$sectionQuiLaFait = F3(
	function (i18n, saisie, complements) {
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape4QuiLaFaitTitre(i18n),
			A2(
				$elm$core$List$cons,
				A3(
					$author$project$Components$Parametrage$PipeEtape4$View$selectDeRole,
					i18n,
					$author$project$I18n$Cles$pipeEtape4RoleLibelle(i18n),
					saisie),
				_Utils_ap(
					A2($author$project$Components$Parametrage$PipeEtape4$View$noteDuRoleParRelation, i18n, saisie),
					complements)));
	});
var $author$project$Components$Parametrage$PipeEtape4$View$blocDuType = F2(
	function (i18n, saisie) {
		var _v0 = saisie.B1.r0;
		switch (_v0) {
			case 'validation':
				return A2($author$project$Components$Parametrage$PipeEtape4$View$blocDeLaValidation, i18n, saisie);
			case 'evaluation':
				return _List_fromArray(
					[
						A3(
						$author$project$Components$Parametrage$PipeEtape4$View$sectionQuiLaFait,
						i18n,
						saisie,
						_List_fromArray(
							[
								A3(
								$author$project$Components$Parametrage$Common$Conception$champDeTexte,
								$author$project$I18n$Cles$pipeEtape4EvaluateursLibelle(i18n),
								A2(
									$author$project$Components$Parametrage$PipeEtape4$Model$entierDe,
									_List_fromArray(
										['nombreDEvaluateursRequis']),
									saisie),
								$author$project$Components$Parametrage$PipeEtape4$Update$ParametreEntierSaisi('nombreDEvaluateursRequis')),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape4EvaluateursAide(i18n))
									])),
								A4(
								$author$project$Components$Parametrage$Common$Conception$liste,
								$author$project$I18n$Cles$pipeEtape4NotesLibelle(i18n),
								A2(
									$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
									_List_fromArray(
										['siLesNotesDifferent']),
									saisie),
								A2(
									$elm$core$List$map,
									function (code) {
										return _Utils_Tuple2(
											code,
											A2($author$project$Components$Parametrage$Vocabulaire$notesDeTache, i18n, code));
									},
									_List_fromArray(
										['moyenne', 'mediane', 'la-plus-basse'])),
								$author$project$Components$Parametrage$PipeEtape4$Update$ParametreChoisi('siLesNotesDifferent'))
							])),
						A2($author$project$Components$Parametrage$PipeEtape4$View$sectionDuFormulaire, i18n, saisie),
						A3($author$project$Components$Parametrage$PipeEtape4$View$sectionQuand, i18n, saisie, true),
						A2(
						$author$project$Components$Parametrage$Common$Conception$drawerSection,
						$author$project$I18n$Cles$pipeEtape4TermineTitre(i18n),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu-compose')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$Components$Parametrage$PipeEtape4$Phrases$evaluateurs,
											i18n,
											A2(
												$elm$core$Maybe$withDefault,
												1,
												$elm$core$String$toInt(
													A2(
														$author$project$Components$Parametrage$PipeEtape4$Model$entierDe,
														_List_fromArray(
															['nombreDEvaluateursRequis']),
														saisie)))))
									]))
							])),
						$author$project$Components$Parametrage$PipeEtape4$View$sectionReutiliser(i18n)
					]);
			case 'action-manuelle':
				return _List_fromArray(
					[
						A3(
						$author$project$Components$Parametrage$PipeEtape4$View$sectionQuiLaFait,
						i18n,
						saisie,
						_List_fromArray(
							[
								A4(
								$author$project$Components$Parametrage$Common$Conception$liste,
								$author$project$I18n$Cles$pipeEtape4ReglePreuve(i18n),
								A2(
									$author$project$Components$Parametrage$PipeEtape4$Model$texteDe,
									_List_fromArray(
										['preuve']),
									saisie),
								A2(
									$elm$core$List$map,
									function (code) {
										return _Utils_Tuple2(
											code,
											A2($author$project$Components$Parametrage$Vocabulaire$preuveDeTache, i18n, code));
									},
									_List_fromArray(
										['aucune', 'fichier', 'commentaire'])),
								$author$project$Components$Parametrage$PipeEtape4$Update$ParametreChoisi('preuve'))
							])),
						A3($author$project$Components$Parametrage$PipeEtape4$View$sectionQuand, i18n, saisie, true),
						$author$project$Components$Parametrage$PipeEtape4$View$sectionReutiliser(i18n)
					]);
			case 'saisie':
				return _List_fromArray(
					[
						A3($author$project$Components$Parametrage$PipeEtape4$View$sectionQuiLaFait, i18n, saisie, _List_Nil),
						A2($author$project$Components$Parametrage$PipeEtape4$View$sectionDuFormulaire, i18n, saisie),
						A3($author$project$Components$Parametrage$PipeEtape4$View$sectionQuand, i18n, saisie, true),
						$author$project$Components$Parametrage$PipeEtape4$View$sectionReutiliser(i18n)
					]);
			case 'document-et-signature':
				return _Utils_ap(
					A2($author$project$Components$Parametrage$PipeEtape4$Blocs$document, i18n, saisie),
					_List_fromArray(
						[
							A2($author$project$Components$Parametrage$PipeEtape4$View$sectionQuandDuDocument, i18n, saisie),
							A2(
							$author$project$Components$Parametrage$PipeEtape4$Blocs$termine,
							i18n,
							$author$project$I18n$Cles$pipeEtape4TermineSignature(i18n))
						]));
			case 'attente':
				return A2($author$project$Components$Parametrage$PipeEtape4$Blocs$attente, i18n, saisie);
			case 'communication':
				return _Utils_ap(
					A2($author$project$Components$Parametrage$PipeEtape4$Blocs$communication, i18n, saisie),
					_List_fromArray(
						[
							A3($author$project$Components$Parametrage$PipeEtape4$View$sectionQuand, i18n, saisie, false)
						]));
			case 'echange':
				return _Utils_ap(
					A2($author$project$Components$Parametrage$PipeEtape4$Blocs$echange, i18n, saisie),
					_List_fromArray(
						[
							A3($author$project$Components$Parametrage$PipeEtape4$View$sectionQuand, i18n, saisie, false)
						]));
			case 'paiement':
				return _Utils_ap(
					A2($author$project$Components$Parametrage$PipeEtape4$Blocs$paiement, i18n, saisie),
					_List_fromArray(
						[
							A4($author$project$Components$Parametrage$PipeEtape4$View$sectionQuandAvecSelecteur, i18n, false, saisie, true),
							A2(
							$author$project$Components$Parametrage$PipeEtape4$Blocs$termine,
							i18n,
							$author$project$I18n$Cles$pipeEtape4TerminePaiement(i18n)),
							$author$project$Components$Parametrage$PipeEtape4$View$sectionReutiliser(i18n)
						]));
			case 'rendez-vous':
				return _Utils_ap(
					A2($author$project$Components$Parametrage$PipeEtape4$Blocs$rendezVous, i18n, saisie),
					_List_fromArray(
						[
							A3($author$project$Components$Parametrage$PipeEtape4$View$sectionQuand, i18n, saisie, false)
						]));
			default:
				return _Utils_ap(
					_Utils_eq(saisie.B1.bi, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
						[
							A3($author$project$Components$Parametrage$PipeEtape4$View$sectionQuiLaFait, i18n, saisie, _List_Nil)
						]),
					_List_fromArray(
						[
							A3($author$project$Components$Parametrage$PipeEtape4$View$sectionQuand, i18n, saisie, true),
							$author$project$Components$Parametrage$PipeEtape4$View$sectionReutiliser(i18n)
						]));
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$DifferencesDemandees = {$: 52};
var $author$project$Components$Parametrage$PipeEtape4$Update$VersionAppliquee = {$: 51};
var $author$project$I18n$Cles$pipeEtape4ModeleChampAvecLesAutres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.modele.champ.avec-les-autres', _List_Nil, 'Enchaînement');
};
var $author$project$I18n$Cles$pipeEtape4ModeleChampEcheance = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.modele.champ.echeance', _List_Nil, 'Échéance');
};
var $author$project$I18n$Cles$pipeEtape4ModeleChampFormulaire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.modele.champ.formulaire', _List_Nil, 'Formulaire');
};
var $author$project$I18n$Cles$pipeEtape4ModeleChampObligatoire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.modele.champ.obligatoire', _List_Nil, 'Obligatoire');
};
var $author$project$I18n$Cles$pipeEtape4ModeleChampParametres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.modele.champ.parametres', _List_Nil, 'Réglage');
};
var $author$project$I18n$Cles$pipeEtape4ModeleChampRelance = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.modele.champ.relance', _List_Nil, 'Relance');
};
var $author$project$I18n$Cles$pipeEtape4ModeleChampType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.modele.champ.type', _List_Nil, 'Type');
};
var $author$project$I18n$Cles$pipeEtape4ModeleChampVisible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.modele.champ.visible', _List_Nil, 'Visible sur le portail');
};
var $author$project$Components$Parametrage$Vocabulaire$champDeLaTacheDuModele = F2(
	function (i18n, code) {
		switch (code) {
			case 'type':
				return $author$project$I18n$Cles$pipeEtape4ModeleChampType(i18n);
			case 'formulaire':
				return $author$project$I18n$Cles$pipeEtape4ModeleChampFormulaire(i18n);
			case 'parametres':
				return $author$project$I18n$Cles$pipeEtape4ModeleChampParametres(i18n);
			case 'echeance':
				return $author$project$I18n$Cles$pipeEtape4ModeleChampEcheance(i18n);
			case 'relance':
				return $author$project$I18n$Cles$pipeEtape4ModeleChampRelance(i18n);
			case 'avec-les-autres':
				return $author$project$I18n$Cles$pipeEtape4ModeleChampAvecLesAutres(i18n);
			case 'obligatoire':
				return $author$project$I18n$Cles$pipeEtape4ModeleChampObligatoire(i18n);
			case 'visible-sur-le-portail':
				return $author$project$I18n$Cles$pipeEtape4ModeleChampVisible(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$I18n$Cles$pipeEtape4ModeleDifferencesAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.modele.differences.aucune', _List_Nil, 'Aucune différence : la tâche suit le modèle.');
};
var $author$project$I18n$Cles$pipeEtape4ModeleDifferencesLigne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.modele.differences.ligne',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN)),
					_Utils_Tuple2(
					'modele',
					$author$project$I18n$Traductions$Chaine(p.oa)),
					_Utils_Tuple2(
					'tache',
					$author$project$I18n$Traductions$Chaine(p.Jj))
				]),
			p.uN + (' : modèle ' + (p.oa + (', tâche ' + p.Jj))));
	});
var $author$project$I18n$Cles$pipeEtape4ModeleDifferencesTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.modele.differences.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'version',
					$author$project$I18n$Traductions$Chaine(p.sq))
				]),
			'Différences avec la v' + (p.sq + ' du modèle'));
	});
var $author$project$Components$Parametrage$PipeEtape4$View$differencesAffichees = F2(
	function (i18n, saisie) {
		var _v0 = saisie.kQ;
		if (!_v0.$) {
			var differences = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('differences')
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('section')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$pipeEtape4ModeleDifferencesTitre,
									i18n,
									{
										sq: $elm$core$String$fromInt(differences.KF)
									}))
							])),
					$elm$core$List$isEmpty(differences.aV) ? _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape4ModeleDifferencesAucune(i18n))
								]))
						]) : _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('lignes')
								]),
							A2(
								$elm$core$List$map,
								function (d) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$li,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$pipeEtape4ModeleDifferencesLigne,
													i18n,
													{
														uN: A2($author$project$Components$Parametrage$Vocabulaire$champDeLaTacheDuModele, i18n, d.uN),
														oa: d.wt,
														Jj: d.wr
													}))
											]));
								},
								differences.aV))
						])));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$pipeEtape4ModeleDisponible = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.modele.disponible',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'version',
					$author$project$I18n$Traductions$Chaine(p.sq))
				]),
			'La v' + (p.sq + ' est disponible.'));
	});
var $author$project$I18n$Cles$pipeEtape4ModeleDisponibleAvecNote = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.modele.disponible-avec-note',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'version',
					$author$project$I18n$Traductions$Chaine(p.sq)),
					_Utils_Tuple2(
					'note',
					$author$project$I18n$Traductions$Chaine(p.oJ))
				]),
			'La v' + (p.sq + (' est disponible : ' + p.oJ)));
	});
var $author$project$Components$Parametrage$PipeEtape4$View$noteDeLaVersion = F2(
	function (i18n, origine) {
		var _v0 = origine.DT;
		if (!_v0.$) {
			var note = _v0.a;
			return A2(
				$author$project$I18n$Cles$pipeEtape4ModeleDisponibleAvecNote,
				i18n,
				{
					oJ: note,
					sq: $elm$core$String$fromInt(origine.KH)
				});
		} else {
			return A2(
				$author$project$I18n$Cles$pipeEtape4ModeleDisponible,
				i18n,
				{
					sq: $elm$core$String$fromInt(origine.KH)
				});
		}
	});
var $author$project$I18n$Cles$pipeEtape4ModeleAppliquer = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.modele.appliquer',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'version',
					$author$project$I18n$Traductions$Chaine(p.sq))
				]),
			'Appliquer la v' + (p.sq + ' à la tâche'));
	});
var $author$project$I18n$Cles$pipeEtape4ModeleIssue = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.modele.issue',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'version',
					$author$project$I18n$Traductions$Chaine(p.sq))
				]),
			'Issue du modèle « ' + (p.Dj + (' » v' + p.sq)));
	});
var $author$project$I18n$Cles$pipeEtape4ModeleModifiee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.modele.modifiee', _List_Nil, 'Cette tâche a été modifiée depuis le modèle.');
};
var $author$project$I18n$Cles$pipeEtape4ModeleTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.modele.titre', _List_Nil, 'Modèle');
};
var $author$project$I18n$Cles$pipeEtape4ModeleVoir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.modele.voir', _List_Nil, 'Voir les différences');
};
var $author$project$Components$Parametrage$PipeEtape4$View$sectionDuModele = F3(
	function (i18n, saisie, origine) {
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4ModeleTitre(i18n),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('carte')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('textes')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$author$project$I18n$Cles$pipeEtape4ModeleIssue,
														i18n,
														{
															Dj: origine.Bl,
															sq: $elm$core$String$fromInt(origine.sq)
														}))
												])),
											(_Utils_cmp(origine.KH, origine.sq) > 0) ? A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2($author$project$Components$Parametrage$PipeEtape4$View$noteDeLaVersion, i18n, origine))
												])) : $rtfeldman$elm_css$Html$Styled$text('')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
											_Utils_eq(
												A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$voirLesDifferencesAvecLeModele, saisie.B1.nQ),
												$elm$core$Maybe$Nothing)),
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape4$Update$DifferencesDemandees)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape4ModeleVoir(i18n))
										]))
								])),
							A2($author$project$Components$Parametrage$PipeEtape4$View$differencesAffichees, i18n, saisie),
							origine.CO ? A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('bandeau')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape4ModeleModifiee(i18n))
								])) : $rtfeldman$elm_css$Html$Styled$text('')
						]),
					function () {
						var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$appliquerLaVersionDuModele, saisie.B1.nQ);
						if (!_v0.$) {
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('geste'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('pleine-largeur'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape4$Update$VersionAppliquee)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$pipeEtape4ModeleAppliquer,
												i18n,
												{
													sq: $elm$core$String$fromInt(origine.KH)
												}))
										]))
								]);
						} else {
							return _List_Nil;
						}
					}()))
			]);
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$NomSaisi = F2(
	function (a, b) {
		return {$: 22, a: a, b: b};
	});
var $author$project$I18n$Cles$pipeEtape4NomAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.nom.aide', _List_Nil, 'Les autres langues se renseignent ensuite par « Renommer ».');
};
var $author$project$I18n$Cles$pipeEtape4NomAnglais = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.nom.anglais', _List_Nil, 'Anglais');
};
var $author$project$I18n$Cles$pipeEtape4NomFrancais = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.nom.francais', _List_Nil, 'Français');
};
var $author$project$I18n$Cles$pipeEtape4NomTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.nom.titre', _List_Nil, 'Nom');
};
var $author$project$Components$Parametrage$PipeEtape4$View$sectionDuNom = F2(
	function (i18n, saisie) {
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape4NomTitre(i18n),
			_List_fromArray(
				[
					A3(
					$author$project$Components$Parametrage$Common$Conception$champDeTexte,
					$author$project$I18n$Cles$pipeEtape4NomFrancais(i18n),
					$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(saisie.R),
					$author$project$Components$Parametrage$PipeEtape4$Update$NomSaisi('fr')),
					A3(
					$author$project$Components$Parametrage$Common$Conception$champDeTexte,
					$author$project$I18n$Cles$pipeEtape4NomAnglais(i18n),
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Dict$get, 'en', saisie.R)),
					$author$project$Components$Parametrage$PipeEtape4$Update$NomSaisi('en')),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape4NomAide(i18n))
						]))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$ChangementDemande = {$: 13};
var $author$project$I18n$Cles$pipeEtape4TypeDescActionManuelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.type-desc.action-manuelle', _List_Nil, 'Quelqu\'un fait un geste hors du CRM et le déclare fait, avec une preuve si besoin.');
};
var $author$project$I18n$Cles$pipeEtape4TypeDescAgentIa = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.type-desc.agent-ia', _List_Nil, 'Un agent prépare une réponse ou un résumé, qu\'une personne relit.');
};
var $author$project$I18n$Cles$pipeEtape4TypeDescAttente = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.type-desc.attente', _List_Nil, 'Le dossier attend un événement ou une date, sans que personne n\'ait à agir.');
};
var $author$project$I18n$Cles$pipeEtape4TypeDescCommunication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.type-desc.communication', _List_Nil, 'Envoie un message à des rôles, avec relances ; peut attendre une réponse.');
};
var $author$project$I18n$Cles$pipeEtape4TypeDescDocumentEtSignature = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.type-desc.document-et-signature', _List_Nil, 'Génère un document à partir d\'un modèle et le fait signer.');
};
var $author$project$I18n$Cles$pipeEtape4TypeDescEchange = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.type-desc.echange', _List_Nil, 'Un fil de discussion entre des rôles choisis, réglé dans le pipe.');
};
var $author$project$I18n$Cles$pipeEtape4TypeDescEvaluation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.type-desc.evaluation', _List_Nil, 'Un formulaire noté, rempli par plusieurs personnes.');
};
var $author$project$I18n$Cles$pipeEtape4TypeDescPaiement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.type-desc.paiement', _List_Nil, 'Une demande de paiement, avec un lien dans le portail ou par email.');
};
var $author$project$I18n$Cles$pipeEtape4TypeDescRendezVous = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.type-desc.rendez-vous', _List_Nil, 'Fixe un créneau entre des rôles du dossier.');
};
var $author$project$I18n$Cles$pipeEtape4TypeDescSaisie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.type-desc.saisie', _List_Nil, 'Une personne remplit un formulaire.');
};
var $author$project$I18n$Cles$pipeEtape4TypeDescSousDossier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.type-desc.sous-dossier', _List_Nil, 'Ouvre un dossier d\'un autre pipe et attend qu\'il se termine.');
};
var $author$project$I18n$Cles$pipeEtape4TypeDescValidation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.type-desc.validation', _List_Nil, 'Une ou plusieurs personnes décident : accepter, refuser, demander une reprise.');
};
var $author$project$Components$Parametrage$Vocabulaire$descriptionDuType = F2(
	function (i18n, code) {
		switch (code) {
			case 'saisie':
				return $author$project$I18n$Cles$pipeEtape4TypeDescSaisie(i18n);
			case 'evaluation':
				return $author$project$I18n$Cles$pipeEtape4TypeDescEvaluation(i18n);
			case 'validation':
				return $author$project$I18n$Cles$pipeEtape4TypeDescValidation(i18n);
			case 'action-manuelle':
				return $author$project$I18n$Cles$pipeEtape4TypeDescActionManuelle(i18n);
			case 'attente':
				return $author$project$I18n$Cles$pipeEtape4TypeDescAttente(i18n);
			case 'sous-dossier':
				return $author$project$I18n$Cles$pipeEtape4TypeDescSousDossier(i18n);
			case 'echange':
				return $author$project$I18n$Cles$pipeEtape4TypeDescEchange(i18n);
			case 'communication':
				return $author$project$I18n$Cles$pipeEtape4TypeDescCommunication(i18n);
			case 'rendez-vous':
				return $author$project$I18n$Cles$pipeEtape4TypeDescRendezVous(i18n);
			case 'paiement':
				return $author$project$I18n$Cles$pipeEtape4TypeDescPaiement(i18n);
			case 'document-et-signature':
				return $author$project$I18n$Cles$pipeEtape4TypeDescDocumentEtSignature(i18n);
			case 'agent-ia':
				return $author$project$I18n$Cles$pipeEtape4TypeDescAgentIa(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$I18n$Cles$pipeEtape4FaitAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.fait.aide', _List_Nil, 'Le type ne change plus une fois des dossiers lancés.');
};
var $author$project$I18n$Cles$pipeEtape4FaitChanger = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.fait.changer', _List_Nil, 'Changer le type');
};
var $author$project$I18n$Cles$pipeEtape4FaitTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.fait.titre', _List_Nil, 'Ce qu\'elle fait');
};
var $author$project$Components$Parametrage$PipeEtape4$View$sectionDuType = F2(
	function (i18n, saisie) {
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape4FaitTitre(i18n),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('carte')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('textes')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$texte,
												i18n,
												$author$project$Components$Parametrage$Vocabulaire$typeDeTache(saisie.B1.r0)))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$Components$Parametrage$Vocabulaire$descriptionDuType, i18n, saisie.B1.r0))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
									_Utils_eq(
										A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$changerLeTypeDUneTache, saisie.B1.nQ),
										$elm$core$Maybe$Nothing)),
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape4$Update$ChangementDemande)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape4FaitChanger(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape4FaitAide(i18n))
						]))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape4$Update$RetraitDemande = {$: 50};
var $author$project$I18n$Cles$pipeEtape4RetirerAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.retirer.aide', _List_Nil, 'Aucun dossier n\'est lancé sur cette version : la tâche se retire sans trace.');
};
var $author$project$I18n$Cles$pipeEtape4RetirerBouton = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.retirer.bouton',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$pipeEtape4RetirerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.retirer.titre', _List_Nil, 'Retirer');
};
var $author$project$Components$Parametrage$PipeEtape4$View$sectionRetirer = F2(
	function (i18n, saisie) {
		var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerUneTache, saisie.B1.nQ);
		if (!_v0.$) {
			return A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape4RetirerTitre(i18n),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape4RetirerAide(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape4$Update$RetraitDemande)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$pipeEtape4RetirerBouton,
									i18n,
									{
										Dj: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(saisie.B1.R)
									}))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$View$contenuDeLaTache = F2(
	function (i18n, saisie) {
		return $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						A2($author$project$Components$Parametrage$PipeEtape4$View$sectionDuNom, i18n, saisie),
						A2($author$project$Components$Parametrage$PipeEtape4$View$sectionDuType, i18n, saisie)
					]),
					A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2($author$project$Components$Parametrage$PipeEtape4$View$sectionDuModele, i18n, saisie),
						saisie.B1.oa)),
					A2($author$project$Components$Parametrage$PipeEtape4$View$blocDuType, i18n, saisie),
					_List_fromArray(
					[
						A2($author$project$Components$Parametrage$PipeEtape4$View$sectionRetirer, i18n, saisie)
					]),
					(saisie.B1.r0 === 'document-et-signature') ? _List_fromArray(
					[
						$author$project$Components$Parametrage$PipeEtape4$Blocs$bandeDuSignataire(i18n)
					]) : _List_Nil,
					(saisie.B1.r0 === 'paiement') ? _List_fromArray(
					[
						$author$project$Components$Parametrage$PipeEtape4$Blocs$bandePlusieursPayeurs(i18n)
					]) : _List_Nil
				]));
	});
var $author$project$Components$Parametrage$PipeEtape4$View$libelleDuGeste = F3(
	function (i18n, ajout, deLAjout) {
		return _Utils_eq(ajout.cs, $elm$core$Maybe$Nothing) ? deLAjout : $author$project$I18n$Cles$pipeEtape4FaitChanger(i18n);
	});
var $author$project$I18n$Cles$pipeEtape4BibliothequeDrawerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.bibliotheque.drawer-titre', _List_Nil, 'Choisir dans la bibliothèque');
};
var $author$project$I18n$Cles$pipeEtape4BibliothequeInserer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.bibliotheque.inserer', _List_Nil, 'Insérer dans l\'étape');
};
var $author$project$I18n$Cles$pipeEtape4DrawerAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.drawer.ajouter', _List_Nil, 'Ajouter la tâche');
};
var $author$project$I18n$Cles$pipeEtape4DrawerKicker = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.drawer.kicker',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etape',
					$author$project$I18n$Traductions$Chaine(p.me))
				]),
			'Étape ' + p.me);
	});
var $author$project$I18n$Cles$pipeEtape4DrawerTitreAjout = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.drawer.titre-ajout', _List_Nil, 'Ajouter une tâche');
};
var $author$project$I18n$Cles$pipeEtape4TacheEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-4.tache.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$pipeEtape4TacheKicker = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-4.tache.kicker',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etape',
					$author$project$I18n$Traductions$Chaine(p.me))
				]),
			'Tâche · Étape ' + p.me);
	});
var $author$project$Components$Parametrage$PipeEtape4$View$refus = F2(
	function (i18n, model) {
		return A2(
			$author$project$Components$Shared$Messages$View$view,
			i18n,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $elm$core$List$singleton, model.pZ)));
	});
var $author$project$Components$Parametrage$PipeEtape4$View$contenuDuDrawer = F2(
	function (i18n, model) {
		var vide = {
			fs: {
				sR: false,
				Bl: '',
				C$: $author$project$Components$Parametrage$PipeEtape4$Update$AjoutEnregistre('')
			},
			fZ: _List_Nil,
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: ''
		};
		var _v0 = _Utils_Tuple2(model.fw, model.hP);
		if (!_v0.a.$) {
			var ajout = _v0.a.a;
			var nomDuType = A2(
				$author$project$I18n$Cles$texte,
				i18n,
				$author$project$Components$Parametrage$Vocabulaire$typeDeTache(ajout.r0));
			return _Utils_update(
				vide,
				{
					fs: function () {
						var _v1 = ajout.dq;
						if (!_v1.$) {
							var b = _v1.a;
							return {
								sR: (!_Utils_eq(b.vd, $elm$core$Maybe$Nothing)) && (!$author$project$API$Envoi$enCours(model.l2)),
								Bl: $author$project$I18n$Cles$pipeEtape4BibliothequeInserer(i18n),
								C$: $author$project$Components$Parametrage$PipeEtape4$Update$InsertionDemandee
							};
						} else {
							return {
								sR: (!_Utils_eq(
									A2($author$project$Components$Parametrage$PipeEtape4$Model$ajoutVoulu, nomDuType, ajout),
									$elm$core$Maybe$Nothing)) && (!$author$project$API$Envoi$enCours(model.l2)),
								Bl: A3(
									$author$project$Components$Parametrage$PipeEtape4$View$libelleDuGeste,
									i18n,
									ajout,
									$author$project$I18n$Cles$pipeEtape4DrawerAjouter(i18n)),
								C$: $author$project$Components$Parametrage$PipeEtape4$Update$AjoutEnregistre(nomDuType)
							};
						}
					}(),
					fZ: A2(
						$elm$core$List$cons,
						A2($author$project$Components$Parametrage$PipeEtape4$View$refus, i18n, model),
						A2($author$project$Components$Parametrage$PipeEtape4$View$contenuDeLAjout, i18n, ajout)),
					A6: $elm$core$Maybe$Just(
						A2(
							$author$project$I18n$Cles$pipeEtape4DrawerKicker,
							i18n,
							{me: ajout.mh})),
					h6: _Utils_eq(ajout.dq, $elm$core$Maybe$Nothing) ? A3(
						$author$project$Components$Parametrage$PipeEtape4$View$libelleDuGeste,
						i18n,
						ajout,
						$author$project$I18n$Cles$pipeEtape4DrawerTitreAjout(i18n)) : $author$project$I18n$Cles$pipeEtape4BibliothequeDrawerTitre(i18n)
				});
		} else {
			if (!_v0.b.$) {
				var _v2 = _v0.a;
				var saisie = _v0.b.a;
				return _Utils_update(
					vide,
					{
						fs: {
							sR: (!_Utils_eq(
								$author$project$Components$Parametrage$PipeEtape4$Model$tacheVoulue(saisie),
								$elm$core$Maybe$Nothing)) && (!$author$project$API$Envoi$enCours(model.l2)),
							Bl: $author$project$I18n$Cles$pipeEtape4TacheEnregistrer(i18n),
							C$: $author$project$Components$Parametrage$PipeEtape4$Update$EnregistrementDemande
						},
						fZ: A2(
							$elm$core$List$cons,
							A2($author$project$Components$Parametrage$PipeEtape4$View$refus, i18n, model),
							A2($author$project$Components$Parametrage$PipeEtape4$View$contenuDeLaTache, i18n, saisie)),
						A6: $elm$core$Maybe$Just(
							A2(
								$author$project$I18n$Cles$pipeEtape4TacheKicker,
								i18n,
								{me: saisie.B1.me})),
						h6: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(saisie.B1.R)
					});
			} else {
				return vide;
			}
		}
	});
var $author$project$Components$Parametrage$PipeEtape4$View$videSiFerme = F2(
	function (model, contenu) {
		return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) ? contenu : _Utils_update(
			contenu,
			{fZ: _List_Nil, A6: $elm$core$Maybe$Nothing, h6: ''});
	});
var $author$project$Components$Parametrage$PipeEtape4$View$drawer = F2(
	function (i18n, model) {
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Parametrage$PipeEtape4$Update$DuDrawer,
			A2(
				$author$project$Components$Parametrage$PipeEtape4$View$videSiFerme,
				model,
				A2($author$project$Components$Parametrage$PipeEtape4$View$contenuDuDrawer, i18n, model)),
			model.kX);
	});
var $author$project$Components$Parametrage$PipeEtape4$View$view = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'parametrage-pipe-etape-4',
			{
				ut: A3($author$project$Components$Parametrage$PipeEtape4$View$corps, i18n, messages, model),
				xy: _List_fromArray(
					[
						A2($author$project$Components$Parametrage$PipeEtape4$View$drawer, i18n, model)
					]),
				zM: _List_Nil,
				AK: $author$project$Components$Parametrage$PipeEtape4$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: A2(
							$elm$core$List$cons,
							A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$elm$core$String$join,
											' ',
											A2(
												$elm$core$List$cons,
												$author$project$I18n$Cles$pipeEtape1Introduction(i18n),
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													A2(
														$elm$core$Maybe$map,
														function (edition) {
															return _List_fromArray(
																[
																	A2(
																	$author$project$I18n$Cles$pipeEtape1Exemple,
																	i18n,
																	{
																		Fs: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(edition.R)
																	})
																]);
														},
														model.ge)))))
									])),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (_v0) {
										return _List_fromArray(
											[
												A5($author$project$Components$Parametrage$Common$Conception$bandeau, i18n, $author$project$Routes$Route$adressePipeEtape4, model.vx, model.aS, model.nR)
											]);
									},
									model.ge))),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adressePipes,
								Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
							},
								{
								aa: $author$project$Routes$Route$adressePipes,
								Dj: $author$project$I18n$Cles$pipesTitre(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$pipeEtape1Titre(i18n)
					})
			});
	});
var $author$project$Components$Parametrage$PipeEtape5$View$groupes = function (lignes) {
	return A3(
		$elm$core$List$foldr,
		F2(
			function (ligne, reste) {
				if (reste.b) {
					var _v1 = reste.a;
					var libelle = _v1.a;
					var suite = _v1.b;
					var autres = reste.b;
					return _Utils_eq(libelle, ligne.Bl) ? A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							libelle,
							A2($elm$core$List$cons, ligne.dw, suite)),
						autres) : A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							ligne.Bl,
							_List_fromArray(
								[ligne.dw])),
						reste);
				} else {
					return _List_fromArray(
						[
							_Utils_Tuple2(
							ligne.Bl,
							_List_fromArray(
								[ligne.dw]))
						]);
				}
			}),
		_List_Nil,
		lignes);
};
var $author$project$I18n$Cles$pipeEtape5ApercuFormulaires = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.apercu.formulaires',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' formulaire') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' formulaires'));
	});
var $author$project$I18n$Cles$pipeEtape5ApercuSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.apercu.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Ce que verra ' + p.bi);
	});
var $author$project$I18n$Cles$pipeEtape5Champs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.champs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' champ') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' champs'));
	});
var $author$project$Components$Parametrage$PipeEtape5$View$apercu = F2(
	function (i18n, formulaires) {
		return A3(
			$author$project$Components$Shared$Parcours$View$apercu,
			i18n,
			$author$project$I18n$Cles$pipeEtape1ApercuTitre(i18n),
			{
				gV: _Utils_ap(
					A2(
						$elm$core$List$concatMap,
						function (_v0) {
							var libelle = _v0.a;
							var lignes = _v0.b;
							return A2(
								$elm$core$List$cons,
								{dX: true, eW: 0, Jx: libelle},
								A2(
									$elm$core$List$map,
									function (ligne) {
										return {dX: false, eW: 1, Jx: ligne};
									},
									lignes));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (lu) {
									return $author$project$Components$Parametrage$PipeEtape5$View$groupes(lu.aA);
								},
								formulaires.tq))),
					_List_fromArray(
						[
							{
							dX: false,
							eW: 0,
							Jx: A2(
								$author$project$I18n$Cles$pipeEtape5ApercuFormulaires,
								i18n,
								{d: formulaires.HX.DA}) + (', ' + A2(
								$author$project$I18n$Cles$pipeEtape5Champs,
								i18n,
								{d: formulaires.HX.Dv}))
						}
						])),
				h6: A2(
					$elm$core$Maybe$map,
					function (lu) {
						return A2(
							$author$project$I18n$Cles$pipeEtape5ApercuSousTitre,
							i18n,
							{
								bi: A2($author$project$Catalogue$Formes$avecArticle, lu.F8.m$, lu.F8.Bl)
							});
					},
					formulaires.tq)
			});
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$FormulaireDemande = function (a) {
	return {$: 5, a: a};
};
var $author$project$I18n$Cles$pipeEtape5DontNotes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.dont-notes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? ('dont ' + (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' noté')) : ('dont ' + (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' notés')));
	});
var $author$project$Components$Parametrage$PipeEtape5$View$champs = F2(
	function (i18n, formulaire) {
		return (formulaire.Dw > 0) ? (A2(
			$author$project$I18n$Cles$pipeEtape5Champs,
			i18n,
			{d: formulaire.Dv}) + (', ' + A2(
			$author$project$I18n$Cles$pipeEtape5DontNotes,
			i18n,
			{d: formulaire.Dw}))) : A2(
			$author$project$I18n$Cles$pipeEtape5Champs,
			i18n,
			{d: formulaire.Dv});
	});
var $author$project$I18n$Cles$pipeEtape5EtatBrouillon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.etat.brouillon', _List_Nil, 'Brouillon');
};
var $author$project$I18n$Cles$pipeEtape5EtatFige = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.etat.fige',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'version',
					$author$project$I18n$Traductions$Chaine(p.sq))
				]),
			'Figé : v' + (p.sq + ' publiée'));
	});
var $author$project$Components$Parametrage$PipeEtape5$View$etat = F2(
	function (i18n, formulaire) {
		var _v0 = formulaire.mB;
		if (!_v0.$) {
			var version = _v0.a;
			return A2(
				$author$project$I18n$Cles$pipeEtape5EtatFige,
				i18n,
				{
					sq: $elm$core$String$fromInt(version)
				});
		} else {
			return $author$project$I18n$Cles$pipeEtape5EtatBrouillon(i18n);
		}
	});
var $author$project$I18n$Cles$pipeEtape5PorteeCePipeSeulement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.portee.ce-pipe-seulement', _List_Nil, 'Ce pipe seulement');
};
var $author$project$I18n$Cles$pipeEtape5PorteePartage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.portee.partage',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? ('Partagé avec ' + (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' pipe')) : ('Partagé avec ' + (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' pipes')));
	});
var $author$project$Components$Parametrage$PipeEtape5$View$portee = F2(
	function (i18n, p) {
		var _v0 = _Utils_Tuple2(p.r0, p.ug);
		if ((_v0.a === 'partage') && (!_v0.b.$)) {
			var n = _v0.b.a;
			return A2(
				$author$project$I18n$Cles$pipeEtape5PorteePartage,
				i18n,
				{d: n});
		} else {
			return $author$project$I18n$Cles$pipeEtape5PorteeCePipeSeulement(i18n);
		}
	});
var $author$project$I18n$Cles$pipeEtape5NeSertARien = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.ne-sert-a-rien', _List_Nil, 'Ne sert à aucune tâche');
};
var $author$project$I18n$Cles$pipeEtape5SertPour = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.sert-pour',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'usages',
					$author$project$I18n$Traductions$Chaine(p.Ke))
				]),
			'Sert pour : ' + p.Ke);
	});
var $author$project$I18n$Cles$pipeEtape5Usage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.usage',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etape',
					$author$project$I18n$Traductions$Chaine(p.me)),
					_Utils_Tuple2(
					'tache',
					$author$project$I18n$Traductions$Chaine(p.Jj))
				]),
			p.me + (' › ' + p.Jj));
	});
var $author$project$Components$Parametrage$PipeEtape5$View$usagesEnTexte = F2(
	function (i18n, usages) {
		return A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				function (usage) {
					return A2(
						$author$project$I18n$Cles$pipeEtape5Usage,
						i18n,
						{me: usage.me, Jj: usage.Jj});
				},
				usages));
	});
var $author$project$Components$Parametrage$PipeEtape5$View$sertPour = F2(
	function (i18n, usages) {
		return $elm$core$List$isEmpty(usages) ? $author$project$I18n$Cles$pipeEtape5NeSertARien(i18n) : A2(
			$author$project$I18n$Cles$pipeEtape5SertPour,
			i18n,
			{
				Ke: A2($author$project$Components$Parametrage$PipeEtape5$View$usagesEnTexte, i18n, usages)
			});
	});
var $author$project$Components$Parametrage$PipeEtape5$View$carte = F2(
	function (i18n, formulaire) {
		var contenu = _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('textes')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(formulaire.R))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('sert-pour')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$Components$Parametrage$PipeEtape5$View$sertPour, i18n, formulaire.IJ))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('bilan')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$elm$core$String$join,
									' · ',
									_List_fromArray(
										[
											A2($author$project$Components$Parametrage$PipeEtape5$View$champs, i18n, formulaire),
											A2($author$project$Components$Parametrage$PipeEtape5$View$portee, i18n, formulaire.F$)
										])))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('etiquettes')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('etiquette', true),
										_Utils_Tuple2(
										$author$project$Components$Parametrage$Vocabulaire$teinteDuTypeDeTache(formulaire.r0),
										true)
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$texte,
									i18n,
									$author$project$Components$Parametrage$Vocabulaire$typeDeTache(formulaire.r0)))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('etat', true),
										_Utils_Tuple2('fige', formulaire.gt === 'fige')
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$Components$Parametrage$PipeEtape5$View$etat, i18n, formulaire))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('chevron'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('›')
							]))
					]))
			]);
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var _v0 = formulaire.np;
					if (!_v0.$) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('formulaire'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id(
									$author$project$Components$Parametrage$PipeEtape5$Model$idDuDeclencheur('formulaire-' + formulaire.r8)),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Parametrage$PipeEtape5$Update$FormulaireDemande(formulaire.r8))
								]),
							contenu);
					} else {
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('formulaire', true),
											_Utils_Tuple2('inerte', true)
										]))
								]),
							contenu);
					}
				}()
				]));
	});
var $author$project$I18n$Cles$pipeEtape5Ajouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.ajouter', _List_Nil, 'Ajouter : Formulaire');
};
var $author$project$I18n$Cles$pipeEtape5Bibliotheque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.bibliotheque', _List_Nil, 'Choisir dans la bibliothèque');
};
var $author$project$I18n$Cles$pipeEtape5ListeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.liste.titre', _List_Nil, 'Formulaires du pipe');
};
var $author$project$Components$Parametrage$PipeEtape5$View$listeDesFormulaires = F2(
	function (i18n, formulaires) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('formulaires')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape5ListeTitre(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('liste')
								]),
							A2(
								$elm$core$List$map,
								$author$project$Components$Parametrage$PipeEtape5$View$carte(i18n),
								formulaires.aA)),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('gestes')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout'),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape5Ajouter(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout'),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape5Bibliotheque(i18n))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape5$View$pied = F2(
	function (i18n, code) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pied')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$lien,
					1,
					$author$project$Routes$Route$adressePipeEtape4(code),
					$author$project$I18n$Cles$pipeEtape2Precedente(i18n)),
					A3(
					$author$project$Components$Shared$Bouton$View$lien,
					0,
					$author$project$Routes$Route$adressePipeEtape6(code),
					$author$project$I18n$Cles$pipeEtape1Suivante(i18n))
				]));
	});
var $author$project$I18n$Cles$pipeEtape1Illisible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-1.illisible', _List_Nil, 'Cette étape ne peut pas être lue pour le moment. Les autres étapes restent ouvertes depuis le chemin de fer.');
};
var $author$project$I18n$Cles$pipeEtape5Conseil = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.conseil', _List_Nil, 'Un formulaire utilisé par une version publiée ne change plus : on le duplique pour le modifier. Les autres champs se règlent dans le formulaire, un par un.');
};
var $author$project$I18n$Cles$pipeEtape5Formulaire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.formulaire', _List_Nil, 'formulaire');
};
var $author$project$I18n$Cles$pipeEtape5Question = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.question', _List_Nil, 'Que remplissent les gens ?');
};
var $author$project$I18n$Cles$pipeEtape5Texte1 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.texte1', _List_Nil, 'Un ');
};
var $author$project$I18n$Cles$pipeEtape5Texte2 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.texte2', _List_Nil, ' regroupe les champs à remplir dans une tâche. Chaque champ dit où va sa réponse. Cliquez un formulaire pour le régler.');
};
var $author$project$Components$Parametrage$PipeEtape5$View$corps = F3(
	function (i18n, messages, model) {
		var _v0 = _Utils_Tuple2(model.aA, model.nf);
		if (!_v0.a.$) {
			var formulaires = _v0.a.a;
			return _List_fromArray(
				[
					A3($author$project$Components$Parametrage$Common$Conception$etapes, i18n, model.vx, 5),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
						]),
					_List_fromArray(
						[
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('etape')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h2,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape5Question(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('explication')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape5Texte1(i18n)),
											A2(
											$rtfeldman$elm_css$Html$Styled$strong,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$pipeEtape5Formulaire(i18n))
												])),
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape5Texte2(i18n))
										])),
									A2($author$project$Components$Parametrage$PipeEtape5$View$listeDesFormulaires, i18n, formulaires),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape5Conseil(i18n))
										]))
								])),
							A2($author$project$Components$Parametrage$PipeEtape5$View$pied, i18n, model.vx)
						])),
					A2($author$project$Components$Parametrage$PipeEtape5$View$apercu, i18n, formulaires)
				]);
		} else {
			if (_v0.b) {
				return _List_fromArray(
					[
						A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape1Introuvable(i18n))
							]))
					]);
			} else {
				return model.Ax ? _List_fromArray(
					[
						A3($author$project$Components$Parametrage$Common$Conception$etapes, i18n, model.vx, 5),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						_List_fromArray(
							[
								A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape1Illisible(i18n))
									]))
							]))
					]) : _List_fromArray(
					[
						A2($author$project$Components$Shared$Messages$View$view, i18n, messages)
					]);
			}
		}
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$AjoutDemande = {$: 64};
var $author$project$Components$Parametrage$PipeEtape5$Update$EnregistrementDemande = {$: 56};
var $author$project$Components$Parametrage$PipeEtape5$Update$RenommageDemande = {$: 9};
var $author$project$Components$Parametrage$PipeEtape5$Update$RetraitDeChampDemande = {$: 66};
var $author$project$Components$Parametrage$PipeEtape5$View$champRetirant = F2(
	function (saisie, uid) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (c) {
					return _Utils_eq(c.r8, uid);
				},
				saisie.B1.dw));
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$AjoutBorneSaisie = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$AjoutCalculSaisi = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$AjoutNomSaisi = F2(
	function (a, b) {
		return {$: 61, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$AjoutValeursSaisies = function (a) {
	return {$: 63, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$ChampRestaure = function (a) {
	return {$: 68, a: a};
};
var $author$project$I18n$Cles$pipeEtape5BornesAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.bornes.aide', _List_Nil, 'Facultatives : une seule borne suffit. Le minimum ne dépasse pas le maximum.');
};
var $author$project$I18n$Cles$pipeEtape5BornesMaximum = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.bornes.maximum', _List_Nil, 'Maximum');
};
var $author$project$I18n$Cles$pipeEtape5BornesMinimum = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.bornes.minimum', _List_Nil, 'Minimum');
};
var $author$project$I18n$Cles$pipeEtape5BornesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.bornes.titre', _List_Nil, 'Bornes');
};
var $author$project$Components$Parametrage$PipeEtape5$View$bornesDuNombre = F4(
	function (i18n, minimum, maximum, surSaisie) {
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape5BornesTitre(i18n),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('bornes')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Components$Parametrage$Common$Conception$champDeTexte,
							$author$project$I18n$Cles$pipeEtape5BornesMinimum(i18n),
							minimum,
							surSaisie(false)),
							A3(
							$author$project$Components$Parametrage$Common$Conception$champDeTexte,
							$author$project$I18n$Cles$pipeEtape5BornesMaximum(i18n),
							maximum,
							surSaisie(true))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape5BornesAide(i18n))
						]))
				]));
	});
var $author$project$I18n$Cles$pipeEtape5AjoutCodeApres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.ajout.code-apres', _List_Nil, '(non modifiable)');
};
var $author$project$I18n$Cles$pipeEtape5AjoutCodeAvant = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.ajout.code-avant', _List_Nil, 'Code dérivé du nom :');
};
var $author$project$Components$Parametrage$PipeEtape5$View$codeDerive = F2(
	function (i18n, nom) {
		return ($author$project$Components$Parametrage$PipeEtape5$Model$codeDuNom(nom) === '') ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('code-derive')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$I18n$Cles$pipeEtape5AjoutCodeAvant(i18n) + ' '),
					A2(
					$rtfeldman$elm_css$Html$Styled$code,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Components$Parametrage$PipeEtape5$Model$codeDuNom(nom))
						])),
					$rtfeldman$elm_css$Html$Styled$text(
					' ' + $author$project$I18n$Cles$pipeEtape5AjoutCodeApres(i18n))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$lignesDesValeurs = function (texte) {
	return A2(
		$elm$core$List$drop,
		1,
		A2($elm$core$String$split, '\n', texte));
};
var $author$project$Components$Parametrage$PipeEtape5$Update$AjoutChampDeLaFicheChoisi = F2(
	function (a, b) {
		return {$: 21, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$AjoutModeChoisi = function (a) {
	return {$: 20, a: a};
};
var $author$project$I18n$Cles$pipeEtape5AjoutMode = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.ajout.mode', _List_Nil, 'Comment ajouter le champ');
};
var $author$project$I18n$Cles$pipeEtape5AjoutModeCreer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.ajout.mode-creer', _List_Nil, 'Créer un champ');
};
var $author$project$I18n$Cles$pipeEtape5DestinationAucunCompatible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.aucun-compatible', _List_Nil, 'Aucun champ compatible');
};
var $author$project$I18n$Cles$pipeEtape5DestinationDejaAjoute = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.deja-ajoute', _List_Nil, 'déjà ajouté');
};
var $author$project$I18n$Cles$pipeEtape5DestinationFicheIllisible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.fiche-illisible', _List_Nil, 'Les champs de la fiche visée ne peuvent pas être lus pour le moment. Réessayez dans un instant.');
};
var $author$project$I18n$Cles$pipeEtape5DestinationFicheVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.fiche-vide', _List_Nil, 'La fiche visée n\'a aucun champ à choisir : créez-en un.');
};
var $author$project$I18n$Cles$pipeEtape5DestinationModeChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.mode.choisir', _List_Nil, 'Choisir un champ de la fiche');
};
var $author$project$Components$Parametrage$PipeEtape5$View$modeDAjout = F4(
	function (i18n, saisie, choisir, choisi) {
		var sUneFiche = function (t) {
			return (t === 'va-sur-la-fiche-visee') || (t === 'va-sur-la-fiche-d-un-autre-role');
		};
		var deja = function (code) {
			return A2(
				$elm$core$List$any,
				function (c) {
					return _Utils_eq(
						c.xw.uN,
						$elm$core$Maybe$Just(code)) && sUneFiche(c.xw.r0);
				},
				saisie.B1.dw);
		};
		var bouton = F2(
			function (titre, estChoisir) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('type'),
									$rtfeldman$elm_css$Html$Styled$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'choisi',
											_Utils_eq(choisir, estChoisir))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-pressed',
									_Utils_eq(choisir, estChoisir) ? 'true' : 'false'),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Parametrage$PipeEtape5$Update$AjoutModeChoisi(estChoisir))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(titre)
								]))
						]));
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('mode-d-ajout')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape5AjoutMode(i18n))
						])),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('types')
							]),
						_List_fromArray(
							[
								A2(
								bouton,
								$author$project$I18n$Cles$pipeEtape5AjoutModeCreer(i18n),
								false),
								A2(
								bouton,
								$author$project$I18n$Cles$pipeEtape5DestinationModeChoisir(i18n),
								true)
							])),
					function () {
						if (!choisir) {
							return _List_Nil;
						} else {
							var _v0 = saisie.B1.o_.uV;
							if (_v0.$ === 1) {
								return _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('illisible')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$pipeEtape5DestinationFicheIllisible(i18n))
											]))
									]);
							} else {
								if (!_v0.a.b) {
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('aucun-champ-compatible')
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$strong,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$pipeEtape5DestinationAucunCompatible(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$pipeEtape5DestinationFicheVide(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$button,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
															$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout'),
															$rtfeldman$elm_css$Html$Styled$Events$onClick(
															$author$project$Components$Parametrage$PipeEtape5$Update$AjoutModeChoisi(false))
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$pipeEtape5AjoutModeCreer(i18n))
														]))
												]))
										]);
								} else {
									var deLaFiche = _v0.a;
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$ul,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('champs-de-la-fiche')
												]),
											A2(
												$elm$core$List$map,
												function (c) {
													return A2(
														$rtfeldman$elm_css$Html$Styled$li,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$rtfeldman$elm_css$Html$Styled$button,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('champ-de-la-fiche'),
																		$rtfeldman$elm_css$Html$Styled$Attributes$classList(
																		_List_fromArray(
																			[
																				_Utils_Tuple2(
																				'choisi',
																				_Utils_eq(
																					choisi,
																					$elm$core$Maybe$Just(c.vx)))
																			])),
																		A2(
																		$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
																		'aria-pressed',
																		_Utils_eq(
																			choisi,
																			$elm$core$Maybe$Just(c.vx)) ? 'true' : 'false'),
																		$rtfeldman$elm_css$Html$Styled$Events$onClick(
																		A2($author$project$Components$Parametrage$PipeEtape5$Update$AjoutChampDeLaFicheChoisi, c.vx, c.Bl))
																	]),
																_List_fromArray(
																	[
																		A2(
																		$rtfeldman$elm_css$Html$Styled$strong,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(c.Bl)
																			])),
																		deja(c.vx) ? A2(
																		$rtfeldman$elm_css$Html$Styled$span,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('tag')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(
																				$author$project$I18n$Cles$pipeEtape5DestinationDejaAjoute(i18n))
																			])) : $rtfeldman$elm_css$Html$Styled$text('')
																	]))
															]));
												},
												deLaFiche))
										]);
								}
							}
						}
					}())));
	});
var $author$project$I18n$Cles$pipeEtape5AjoutAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.ajout.aide', _List_Nil, 'Le champ est ajouté avec la destination « Réponse seule ». Vous réglez ensuite où va la réponse (fiche, dossier).');
};
var $author$project$I18n$Cles$pipeEtape5AjoutFormule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.ajout.formule', _List_Nil, 'Formule');
};
var $author$project$I18n$Cles$pipeEtape5AjoutNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.ajout.nom', _List_Nil, 'Nom du champ');
};
var $author$project$I18n$Cles$pipeEtape5AjoutReglagesNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.ajout.reglages-note', _List_Nil, 'Chaque type à réglages montre les siens sous la liste, comme dans l\'éditeur de schéma et la bibliothèque de champs (Nombre : bornes ; Note, Niveaux, Lignes : échelle ; Calculé : formule).');
};
var $author$project$I18n$Cles$pipeEtape5AjoutReglagesTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.ajout.reglages-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'genre',
					$author$project$I18n$Traductions$Chaine(p.M))
				]),
			'Réglages du type « ' + (p.M + ' »'));
	});
var $author$project$I18n$Cles$pipeEtape5AjoutTypeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.ajout.type-titre', _List_Nil, 'Type de champ');
};
var $author$project$I18n$Cles$pipeEtape5AjoutValeurAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.ajout.valeur-ajouter', _List_Nil, 'Ajouter une valeur');
};
var $author$project$I18n$Cles$pipeEtape5AjoutValeurDescendre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.ajout.valeur-descendre', _List_Nil, 'Descendre');
};
var $author$project$I18n$Cles$pipeEtape5AjoutValeurMonter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.ajout.valeur-monter', _List_Nil, 'Monter');
};
var $author$project$I18n$Cles$pipeEtape5AjoutValeurRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.ajout.valeur-retirer', _List_Nil, 'Retirer');
};
var $author$project$I18n$Cles$pipeEtape5AjoutValeurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.ajout.valeurs', _List_Nil, 'Valeurs proposées');
};
var $author$project$I18n$Cles$pipeEtape5GroupeTypeCalcul = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.groupe-type.calcul', _List_Nil, 'Calcul');
};
var $author$project$I18n$Cles$pipeEtape5GroupeTypeChoix = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.groupe-type.choix', _List_Nil, 'Choix');
};
var $author$project$I18n$Cles$pipeEtape5GroupeTypeEchelles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.groupe-type.echelles', _List_Nil, 'Échelles et grilles');
};
var $author$project$I18n$Cles$pipeEtape5GroupeTypeLibres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.groupe-type.libres', _List_Nil, 'Réponses libres');
};
var $author$project$I18n$Cles$pipeEtape5GroupeTypeLiens = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.groupe-type.liens', _List_Nil, 'Liens');
};
var $author$project$I18n$Cles$pipeEtape5RetiresOffre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.retires.offre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'« ' + (p.Dj + ' » existe déjà, retiré'));
	});
var $author$project$I18n$Cles$pipeEtape5RetiresOffreAction = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.retires.offre-action',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Restaurer « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$pipeEtape5RetiresOffreAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.retires.offre-aide', _List_Nil, 'Le restaurer le remet dans le formulaire : rien n\'est créé en double.');
};
var $author$project$I18n$Cles$pipeEtape5RetiresOffreDate = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.retires.offre-date',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Retiré le ' + (p.wv + ', avec ses réglages.'));
	});
var $author$project$Components$Shared$LibellesParLangue$View$prefixeEtLangue = function (i18n) {
	return A3(
		$author$project$Components$Shared$LibellesParLangue$View$rendre,
		i18n,
		1,
		function (_v0) {
			return $elm$core$Maybe$Just(
				$author$project$I18n$Cles$pipeEtape2TraductionARenseigner(i18n));
		});
};
var $author$project$I18n$Cles$pipeEtape5ChampTypeCalculeFormule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.champ-type.calcule-formule', _List_Nil, 'Calculé (formule)');
};
var $author$project$I18n$Cles$pipeEtape5ChampTypeChoixMultipleCases = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.champ-type.choix-multiple-cases', _List_Nil, 'Choix multiples (cases à cocher)');
};
var $author$project$I18n$Cles$pipeEtape5ChampTypeMesureUnite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.champ-type.mesure-unite', _List_Nil, 'Mesure avec unité');
};
var $author$project$I18n$Cles$pipeEtape5ChampTypeOuiNonCase = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.champ-type.oui-non-case', _List_Nil, 'Oui/non (case à cocher)');
};
var $author$project$I18n$Cles$pipeEtape5ChampTypeCalcule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.champ.type.calcule', _List_Nil, 'Calculé');
};
var $author$project$I18n$Cles$pipeEtape5ChampTypeChoix = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.champ.type.choix', _List_Nil, 'Choix dans une liste');
};
var $author$project$I18n$Cles$pipeEtape5ChampTypeChoixUnique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.champ-type.choix-unique', _List_Nil, 'Choix unique dans une liste');
};
var $author$project$I18n$Cles$pipeEtape5ChampTypeDate = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.champ.type.date', _List_Nil, 'Date');
};
var $author$project$I18n$Cles$pipeEtape5ChampTypeFichier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.champ.type.fichier', _List_Nil, 'Fichier');
};
var $author$project$I18n$Cles$pipeEtape5ChampTypeImage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.champ-type.image', _List_Nil, 'Image');
};
var $author$project$I18n$Cles$pipeEtape5ChampTypeLignes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.champ.type.lignes', _List_Nil, 'Lignes');
};
var $author$project$I18n$Cles$pipeEtape5ChampTypeNiveaux = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.champ.type.niveaux', _List_Nil, 'Niveaux');
};
var $author$project$I18n$Cles$pipeEtape5ChampTypeNombre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.champ.type.nombre', _List_Nil, 'Nombre');
};
var $author$project$I18n$Cles$pipeEtape5ChampTypeNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.champ.type.note', _List_Nil, 'Note');
};
var $author$project$I18n$Cles$pipeEtape5ChampTypeTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.champ.type.texte', _List_Nil, 'Texte');
};
var $author$project$I18n$Cles$pipeEtape5ChampTypeTexteLong = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.champ.type.texte-long', _List_Nil, 'Texte long');
};
var $author$project$Components$Parametrage$Vocabulaire$typeDeChamp = F2(
	function (i18n, code) {
		switch (code) {
			case 'texte':
				return $author$project$I18n$Cles$pipeEtape5ChampTypeTexte(i18n);
			case 'texte-long':
				return $author$project$I18n$Cles$pipeEtape5ChampTypeTexteLong(i18n);
			case 'nombre':
				return $author$project$I18n$Cles$pipeEtape5ChampTypeNombre(i18n);
			case 'date':
				return $author$project$I18n$Cles$pipeEtape5ChampTypeDate(i18n);
			case 'choix':
				return $author$project$I18n$Cles$pipeEtape5ChampTypeChoix(i18n);
			case 'fichier':
				return $author$project$I18n$Cles$pipeEtape5ChampTypeFichier(i18n);
			case 'lignes':
				return $author$project$I18n$Cles$pipeEtape5ChampTypeLignes(i18n);
			case 'calcule':
				return $author$project$I18n$Cles$pipeEtape5ChampTypeCalcule(i18n);
			case 'note':
				return $author$project$I18n$Cles$pipeEtape5ChampTypeNote(i18n);
			case 'niveaux':
				return $author$project$I18n$Cles$pipeEtape5ChampTypeNiveaux(i18n);
			case 'montant':
				return $author$project$I18n$Cles$editeurDeSchemaTypeMontant(i18n);
			case 'mesure':
				return $author$project$I18n$Cles$editeurDeSchemaTypeMesure(i18n);
			case 'email':
				return $author$project$I18n$Cles$editeurDeSchemaTypeEmail(i18n);
			case 'telephone':
				return $author$project$I18n$Cles$editeurDeSchemaTypeTelephone(i18n);
			case 'adresse':
				return $author$project$I18n$Cles$editeurDeSchemaTypeAdresse(i18n);
			case 'image':
				return $author$project$I18n$Cles$pipeEtape5ChampTypeImage(i18n);
			case 'oui-non':
				return $author$project$I18n$Cles$editeurDeSchemaTypeOuiNon(i18n);
			case 'choix-unique':
				return $author$project$I18n$Cles$pipeEtape5ChampTypeChoixUnique(i18n);
			case 'choix-multiple':
				return $author$project$I18n$Cles$editeurDeSchemaTypeChoixMultiples(i18n);
			case 'pays':
				return $author$project$I18n$Cles$editeurDeSchemaTypePays(i18n);
			case 'langue':
				return $author$project$I18n$Cles$editeurDeSchemaTypeLangue(i18n);
			case 'partie-prenante':
				return $author$project$I18n$Cles$editeurDeSchemaTypePartiePrenante(i18n);
			case 'utilisateur':
				return $author$project$I18n$Cles$editeurDeSchemaTypeUtilisateur(i18n);
			default:
				return code;
		}
	});
var $author$project$Components$Parametrage$Vocabulaire$typeDeChampAjoute = F2(
	function (i18n, code) {
		switch (code) {
			case 'oui-non':
				return $author$project$I18n$Cles$pipeEtape5ChampTypeOuiNonCase(i18n);
			case 'choix-multiple':
				return $author$project$I18n$Cles$pipeEtape5ChampTypeChoixMultipleCases(i18n);
			case 'mesure':
				return $author$project$I18n$Cles$pipeEtape5ChampTypeMesureUnite(i18n);
			case 'calcule':
				return $author$project$I18n$Cles$pipeEtape5ChampTypeCalculeFormule(i18n);
			default:
				return A2($author$project$Components$Parametrage$Vocabulaire$typeDeChamp, i18n, code);
		}
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$AjoutTypeChoisi = function (a) {
	return {$: 62, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$View$typeOffert = F3(
	function (i18n, choisi, code) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('type'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'choisi',
									_Utils_eq(choisi, code))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-pressed',
							_Utils_eq(choisi, code) ? 'true' : 'false'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Parametrage$PipeEtape5$Update$AjoutTypeChoisi(code))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Parametrage$Vocabulaire$typeDeChampAjoute, i18n, code))
						]))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$enLignes = function (lignes) {
	return $elm$core$String$concat(
		A2(
			$elm$core$List$map,
			function (v) {
				return '\n' + v;
			},
			lignes));
};
var $author$project$Components$Parametrage$PipeEtape5$Model$valeurAjoutee = function (texte) {
	return $author$project$Components$Parametrage$PipeEtape5$Model$enLignes(
		_Utils_ap(
			$author$project$Components$Parametrage$PipeEtape5$Model$lignesDesValeurs(texte),
			_List_fromArray(
				[''])));
};
var $author$project$Components$Parametrage$PipeEtape5$Model$valeurDeplacee = F3(
	function (rang, sens, texte) {
		var lignes = $author$project$Components$Parametrage$PipeEtape5$Model$lignesDesValeurs(texte);
		var autre = rang + sens;
		return ((autre < 0) || (_Utils_cmp(
			autre,
			$elm$core$List$length(lignes)) > -1)) ? texte : $author$project$Components$Parametrage$PipeEtape5$Model$enLignes(
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (i, v) {
						return _Utils_eq(i, rang) ? A2(
							$elm$core$Maybe$withDefault,
							v,
							$elm$core$List$head(
								A2($elm$core$List$drop, autre, lignes))) : (_Utils_eq(i, autre) ? A2(
							$elm$core$Maybe$withDefault,
							v,
							$elm$core$List$head(
								A2($elm$core$List$drop, rang, lignes))) : v);
					}),
				lignes));
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$valeurModifiee = F3(
	function (rang, nouvelle, texte) {
		return $author$project$Components$Parametrage$PipeEtape5$Model$enLignes(
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (i, v) {
						return _Utils_eq(i, rang) ? A3($elm$core$String$replace, '\n', ' ', nouvelle) : v;
					}),
				$author$project$Components$Parametrage$PipeEtape5$Model$lignesDesValeurs(texte)));
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$valeurRetiree = F2(
	function (rang, texte) {
		return $author$project$Components$Parametrage$PipeEtape5$Model$enLignes(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$second,
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var i = _v0.a;
						return !_Utils_eq(i, rang);
					},
					A2(
						$elm$core$List$indexedMap,
						$elm$core$Tuple$pair,
						$author$project$Components$Parametrage$PipeEtape5$Model$lignesDesValeurs(texte)))));
	});
var $author$project$Components$Parametrage$PipeEtape5$View$contenuDeLAjout = F3(
	function (i18n, nomPris, saisie) {
		var offertes = saisie.B1.o_.ib;
		var ajout = A2(
			$elm$core$Maybe$withDefault,
			{uB: '', du: $elm$core$Maybe$Nothing, R: $elm$core$Dict$empty, Cj: '', CD: '', cW: false, r0: 'texte', Ki: ''},
			saisie.fw);
		var groupe = F2(
			function (titre, codes) {
				var _v1 = A2(
					$elm$core$List$filter,
					function (c) {
						return A2($elm$core$List$member, c, offertes);
					},
					codes);
				if (!_v1.b) {
					return $rtfeldman$elm_css$Html$Styled$text('');
				} else {
					var presents = _v1;
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('groupe-de-types')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$h3,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(titre)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$ul,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('types')
									]),
								A2(
									$elm$core$List$map,
									A2($author$project$Components$Parametrage$PipeEtape5$View$typeOffert, i18n, ajout.r0),
									presents))
							]));
				}
			});
		return _List_fromArray(
			[
				A4($author$project$Components$Parametrage$PipeEtape5$View$modeDAjout, i18n, saisie, ajout.cW, ajout.du),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('nom-du-champ'),
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('nom-pris', nomPris)
							]))
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Components$Shared$LibellesParLangue$View$prefixeEtLangue,
						i18n,
						_List_Nil,
						{
							go: function (_v0) {
								return $elm$core$Maybe$Nothing;
							},
							Ba: $author$project$Referentiel$Langues$desLibelles,
							Bl: $author$project$I18n$Cles$pipeEtape5AjoutNom(i18n),
							hg: $author$project$Components$Parametrage$PipeEtape5$Update$AjoutNomSaisi,
							pv: $author$project$Components$Parametrage$PipeEtape5$Model$idDuDrawer('ajout'),
							fm: function (code) {
								return A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Dict$get, code, ajout.R));
							}
						}),
						A2(
						$author$project$Components$Parametrage$PipeEtape5$View$codeDerive,
						i18n,
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Dict$get, 'fr', ajout.R)))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('retire-de-meme-nom')
					]),
				A2(
					$elm$core$List$map,
					function (c) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('offre')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$pipeEtape5RetiresOffre,
												i18n,
												{
													Dj: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(c.R)
												}))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											_Utils_ap(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2(
														$elm$core$Maybe$map,
														function (le) {
															return A2(
																$author$project$I18n$Cles$pipeEtape5RetiresOffreDate,
																i18n,
																{
																	wv: A2(
																		$author$project$Texte$Jour$horodateALHeure,
																		i18n,
																		$author$project$Texte$Jour$instantDeParis(le))
																}) + ' ';
														},
														c.H_)),
												$author$project$I18n$Cles$pipeEtape5RetiresOffreAide(i18n)))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('restaurer'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Parametrage$PipeEtape5$Update$ChampRestaure(c.r8))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$pipeEtape5RetiresOffreAction,
												i18n,
												{
													Dj: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(c.R)
												}))
										]))
								]));
					},
					$author$project$Components$Parametrage$PipeEtape5$Model$retiresDeMemeNom(saisie))),
				A2(
				$rtfeldman$elm_css$Html$Styled$h3,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('titre-de-section')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$pipeEtape5AjoutTypeTitre(i18n))
					])),
				A2(
				groupe,
				$author$project$I18n$Cles$pipeEtape5GroupeTypeLibres(i18n),
				_List_fromArray(
					['texte', 'texte-long', 'nombre', 'montant', 'mesure', 'date', 'email', 'telephone', 'adresse', 'fichier', 'image'])),
				A2(
				groupe,
				$author$project$I18n$Cles$pipeEtape5GroupeTypeChoix(i18n),
				_List_fromArray(
					['oui-non', 'choix-unique', 'choix-multiple', 'pays', 'langue'])),
				A2(
				groupe,
				$author$project$I18n$Cles$pipeEtape5GroupeTypeCalcul(i18n),
				_List_fromArray(
					['calcule'])),
				A2(
				groupe,
				$author$project$I18n$Cles$pipeEtape5GroupeTypeLiens(i18n),
				_List_fromArray(
					['partie-prenante', 'utilisateur'])),
				A2(
				groupe,
				$author$project$I18n$Cles$pipeEtape5GroupeTypeEchelles(i18n),
				_List_fromArray(
					['note', 'niveaux', 'lignes'])),
				((ajout.r0 === 'choix-unique') || (ajout.r0 === 'choix-multiple')) ? A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				A2(
					$author$project$I18n$Cles$pipeEtape5AjoutReglagesTitre,
					i18n,
					{
						M: A2($author$project$Components$Parametrage$Vocabulaire$typeDeChampAjoute, i18n, ajout.r0)
					}),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('valeurs')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape5AjoutValeurs(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$ul,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('liste-de-valeurs')
									]),
								A2(
									$elm$core$List$indexedMap,
									F2(
										function (rang, valeur) {
											return A2(
												$rtfeldman$elm_css$Html$Styled$li,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$input,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(valeur),
																$rtfeldman$elm_css$Html$Styled$Events$onInput(
																function (nouvelle) {
																	return $author$project$Components$Parametrage$PipeEtape5$Update$AjoutValeursSaisies(
																		A3($author$project$Components$Parametrage$PipeEtape5$Model$valeurModifiee, rang, nouvelle, ajout.Ki));
																}),
																$rtfeldman$elm_css$Html$Styled$Attributes$type_('text')
															]),
														_List_Nil),
														A2(
														$rtfeldman$elm_css$Html$Styled$button,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
																$rtfeldman$elm_css$Html$Styled$Attributes$class('monter'),
																$rtfeldman$elm_css$Html$Styled$Events$onClick(
																$author$project$Components$Parametrage$PipeEtape5$Update$AjoutValeursSaisies(
																	A3($author$project$Components$Parametrage$PipeEtape5$Model$valeurDeplacee, rang, -1, ajout.Ki)))
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$pipeEtape5AjoutValeurMonter(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$button,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
																$rtfeldman$elm_css$Html$Styled$Attributes$class('descendre'),
																$rtfeldman$elm_css$Html$Styled$Events$onClick(
																$author$project$Components$Parametrage$PipeEtape5$Update$AjoutValeursSaisies(
																	A3($author$project$Components$Parametrage$PipeEtape5$Model$valeurDeplacee, rang, 1, ajout.Ki)))
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$pipeEtape5AjoutValeurDescendre(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$button,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
																$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer'),
																$rtfeldman$elm_css$Html$Styled$Events$onClick(
																$author$project$Components$Parametrage$PipeEtape5$Update$AjoutValeursSaisies(
																	A2($author$project$Components$Parametrage$PipeEtape5$Model$valeurRetiree, rang, ajout.Ki)))
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$pipeEtape5AjoutValeurRetirer(i18n))
															]))
													]));
										}),
									$author$project$Components$Parametrage$PipeEtape5$Model$lignesDesValeurs(ajout.Ki))),
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('ajouter-une-valeur'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Parametrage$PipeEtape5$Update$AjoutValeursSaisies(
											$author$project$Components$Parametrage$PipeEtape5$Model$valeurAjoutee(ajout.Ki)))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape5AjoutValeurAjouter(i18n))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape5AjoutReglagesNote(i18n))
							]))
					])) : $rtfeldman$elm_css$Html$Styled$text(''),
				(ajout.r0 === 'calcule') ? A2(
				$rtfeldman$elm_css$Html$Styled$label,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('valeurs')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape5AjoutFormule(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$input,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(ajout.uB),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Parametrage$PipeEtape5$Update$AjoutCalculSaisi),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('text')
							]),
						_List_Nil)
					])) : $rtfeldman$elm_css$Html$Styled$text(''),
				(ajout.r0 === 'nombre') ? A4($author$project$Components$Parametrage$PipeEtape5$View$bornesDuNombre, i18n, ajout.CD, ajout.Cj, $author$project$Components$Parametrage$PipeEtape5$Update$AjoutBorneSaisie) : $rtfeldman$elm_css$Html$Styled$text(''),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('description'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('encart')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$pipeEtape5AjoutAide(i18n))
					]))
			]);
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$BorneSaisie = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$ObligatoireBascule = function (a) {
	return {$: 28, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$RequisPourPasserBascule = function (a) {
	return {$: 29, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$RetraitDeChampOuvert = function (a) {
	return {$: 65, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$RoleDeLaFicheChoisi = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$VisibleSurLePortailBascule = function (a) {
	return {$: 47, a: a};
};
var $author$project$I18n$Cles$pipeEtape5PassageAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.passage.aide', _List_Nil, 'Ce formulaire déclare seulement quels champs sont requis. La condition de passage (« tous les champs requis de l\'étape sont remplis ») et le forçage par l\'administrateur ne se règlent pas ici : ils relèvent de l\'étape 2 des pipes (conditions de passage) et du forçage d\'étape.');
};
var $author$project$I18n$Cles$pipeEtape5PassageCible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.passage.cible', _List_Nil, 'Champs requis de cette étape');
};
var $author$project$I18n$Cles$pipeEtape5PassageLien = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.passage.lien', _List_Nil, 'Régler la condition de passage (étape 2 du pipe)');
};
var $author$project$I18n$Cles$pipeEtape5PassageTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.passage.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etape',
					$author$project$I18n$Traductions$Chaine(p.me))
				]),
			'Pour passer de « ' + (p.me + ' » à l\'étape suivante'));
	});
var $author$project$Components$Parametrage$PipeEtape5$View$blocDePassage = F3(
	function (i18n, code, saisie) {
		var _v0 = saisie.B1.HL;
		if (!_v0.$) {
			var requis = _v0.a;
			return $elm$core$List$isEmpty(requis.dw) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				A2(
					$author$project$I18n$Cles$pipeEtape5PassageTitre,
					i18n,
					{
						me: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(requis.me)
					}),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('cible')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape5PassageCible(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$elm$core$String$join,
											' · ',
											A2($elm$core$List$map, $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle, requis.dw)))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('encart')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape5PassageAide(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('renommer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$href(
								$author$project$Routes$Route$adressePipeEtape2(code))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape5PassageLien(i18n))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$DestinationChoisie = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Phrases$ficheVisee = function (formulaire) {
	return A2(
		$elm$core$Maybe$withDefault,
		{i4: 0, bi: ''},
		A2(
			$elm$core$Maybe$map,
			function (role) {
				return {
					i4: $author$project$Catalogue$Formes$article(role.m$),
					bi: role.Bl
				};
			},
			formulaire.zt));
};
var $author$project$Components$Parametrage$PipeEtape5$Phrases$ou = function (elements) {
	var _v0 = $elm$core$List$reverse(elements);
	if (_v0.b && _v0.b.b) {
		var dernier = _v0.a;
		var _v1 = _v0.b;
		var avant = _v1.a;
		var debut = _v1.b;
		return A2(
			$elm$core$String$join,
			', ',
			$elm$core$List$reverse(
				A2($elm$core$List$cons, avant, debut))) + (' ou ' + dernier);
	} else {
		var reste = _v0;
		return A2($elm$core$String$join, '', reste);
	}
};
var $author$project$I18n$Cles$pipeEtape5DestinationAideVaSurLaFicheDUnAutreRole = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.aide.va-sur-la-fiche-d-un-autre-role', _List_Nil, 'Le champ propose les rôles du pipe (étape 3).');
};
var $author$project$I18n$Cles$pipeEtape5DestinationAideVaSurLaFicheDUnAutreRoleInterne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.destination.aide.va-sur-la-fiche-d-un-autre-role.interne',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'interne',
					$author$project$I18n$Traductions$Chaine(p.ne))
				]),
			'Par exemple ' + (p.ne + '. Le champ propose les rôles du pipe (étape 3).'));
	});
var $author$project$I18n$Cles$pipeEtape5DestinationAideVaSurLaFicheDUnAutreRoleRelation = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.destination.aide.va-sur-la-fiche-d-un-autre-role.relation',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'relation',
					$author$project$I18n$Traductions$Chaine(p.Ht)),
					_Utils_Tuple2(
					'article',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeArticle(p.i4))),
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Par exemple ' + (p.Ht + (', tenus par une relation ' + (function () {
				var _v0 = p.i4;
				switch (_v0) {
					case 0:
						return '';
					case 1:
						return 'de l\'' + $elm$core$String$toLower(p.bi);
					case 2:
						return 'de la ' + $elm$core$String$toLower(p.bi);
					case 3:
						return 'du ' + $elm$core$String$toLower(p.bi);
					default:
						return 'de ' + p.bi;
				}
			}() + '. Le champ propose les rôles du pipe (étape 3).'))));
	});
var $author$project$I18n$Cles$pipeEtape5DestinationAideVaSurLaFicheDUnAutreRoleRelationEtInterne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.destination.aide.va-sur-la-fiche-d-un-autre-role.relation-et-interne',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'relation',
					$author$project$I18n$Traductions$Chaine(p.Ht)),
					_Utils_Tuple2(
					'article',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeArticle(p.i4))),
					_Utils_Tuple2(
					'interne',
					$author$project$I18n$Traductions$Chaine(p.ne)),
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Par exemple ' + (p.Ht + (', tenus par une relation ' + (function () {
				var _v0 = p.i4;
				switch (_v0) {
					case 0:
						return '';
					case 1:
						return 'de l\'' + $elm$core$String$toLower(p.bi);
					case 2:
						return 'de la ' + $elm$core$String$toLower(p.bi);
					case 3:
						return 'du ' + $elm$core$String$toLower(p.bi);
					default:
						return 'de ' + p.bi;
				}
			}() + (', ou ' + (p.ne + '. Le champ propose les rôles du pipe (étape 3).'))))));
	});
var $author$project$I18n$Cles$pipeEtape5DestinationMembre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.destination.membre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'article',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeArticle(p.i4))),
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'un membre ' + function () {
				var _v0 = p.i4;
				switch (_v0) {
					case 0:
						return '';
					case 1:
						return 'de l\'' + $elm$core$String$toLower(p.bi);
					case 2:
						return 'de la ' + $elm$core$String$toLower(p.bi);
					case 3:
						return 'du ' + $elm$core$String$toLower(p.bi);
					default:
						return 'de ' + p.bi;
				}
			}());
	});
var $author$project$Components$Parametrage$PipeEtape5$Phrases$aideDUnAutreRole = F2(
	function (i18n, formulaire) {
		var parRelation = A2(
			$elm$core$List$map,
			function (role) {
				return A2($author$project$Catalogue$Formes$avecArticle, role.m$, role.Bl);
			},
			A2(
				$elm$core$List$filter,
				function ($) {
					return $.EW;
				},
				formulaire.o_.eX));
		var internes = A2(
			$elm$core$List$map,
			function (role) {
				return A2(
					$author$project$I18n$Cles$pipeEtape5DestinationMembre,
					i18n,
					{
						i4: $author$project$Catalogue$Formes$article(role.m$),
						bi: role.Bl
					});
			},
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Basics$not,
					function ($) {
						return $.EW;
					}),
				formulaire.o_.eX));
		var _v0 = _Utils_Tuple2(parRelation, internes);
		if (!_v0.a.b) {
			if (!_v0.b.b) {
				return $author$project$I18n$Cles$pipeEtape5DestinationAideVaSurLaFicheDUnAutreRole(i18n);
			} else {
				return A2(
					$author$project$I18n$Cles$pipeEtape5DestinationAideVaSurLaFicheDUnAutreRoleInterne,
					i18n,
					{
						ne: $author$project$Components$Parametrage$PipeEtape5$Phrases$ou(internes)
					});
			}
		} else {
			if (!_v0.b.b) {
				return A2(
					$author$project$I18n$Cles$pipeEtape5DestinationAideVaSurLaFicheDUnAutreRoleRelation,
					i18n,
					{
						i4: $author$project$Components$Parametrage$PipeEtape5$Phrases$ficheVisee(formulaire).i4,
						Ht: $author$project$Components$Parametrage$PipeEtape5$Phrases$ou(parRelation),
						bi: $author$project$Components$Parametrage$PipeEtape5$Phrases$ficheVisee(formulaire).bi
					});
			} else {
				return A2(
					$author$project$I18n$Cles$pipeEtape5DestinationAideVaSurLaFicheDUnAutreRoleRelationEtInterne,
					i18n,
					{
						i4: $author$project$Components$Parametrage$PipeEtape5$Phrases$ficheVisee(formulaire).i4,
						ne: $author$project$Components$Parametrage$PipeEtape5$Phrases$ou(internes),
						Ht: $author$project$Components$Parametrage$PipeEtape5$Phrases$ou(parRelation),
						bi: $author$project$Components$Parametrage$PipeEtape5$Phrases$ficheVisee(formulaire).bi
					});
			}
		}
	});
var $author$project$I18n$Cles$pipeEtape5DestinationAideVaSurLaFicheVisee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.aide.va-sur-la-fiche-visee', _List_Nil, 'La réponse s\'écrit sur sa fiche. Le champ est déjà rempli si la fiche la connaît.');
};
var $author$project$I18n$Cles$pipeEtape5DestinationAideVaSurLaFicheViseeChoix = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.aide.va-sur-la-fiche-visee.choix', _List_Nil, 'Le choix s\'écrit sur sa fiche. Le champ est déjà rempli si la fiche le connaît.');
};
var $author$project$I18n$Cles$pipeEtape5DestinationAideVaSurLaFicheViseeDate = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.aide.va-sur-la-fiche-visee.date', _List_Nil, 'La date s\'écrit sur sa fiche. Le champ est déjà rempli si la fiche la connaît.');
};
var $author$project$I18n$Cles$pipeEtape5DestinationAideVaSurLaFicheViseeNombre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.aide.va-sur-la-fiche-visee.nombre', _List_Nil, 'Le nombre s\'écrit sur sa fiche. Le champ est déjà rempli si la fiche le connaît.');
};
var $author$project$I18n$Cles$pipeEtape5DestinationAideVaSurLaFicheViseeTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.aide.va-sur-la-fiche-visee.texte', _List_Nil, 'Le texte s\'écrit sur sa fiche. Le champ est déjà rempli si la fiche le connaît.');
};
var $author$project$Components$Parametrage$Vocabulaire$aideDeLaFicheVisee = F2(
	function (i18n, code) {
		switch (code) {
			case 'date':
				return $author$project$I18n$Cles$pipeEtape5DestinationAideVaSurLaFicheViseeDate(i18n);
			case 'texte':
				return $author$project$I18n$Cles$pipeEtape5DestinationAideVaSurLaFicheViseeTexte(i18n);
			case 'texte-long':
				return $author$project$I18n$Cles$pipeEtape5DestinationAideVaSurLaFicheViseeTexte(i18n);
			case 'nombre':
				return $author$project$I18n$Cles$pipeEtape5DestinationAideVaSurLaFicheViseeNombre(i18n);
			case 'choix':
				return $author$project$I18n$Cles$pipeEtape5DestinationAideVaSurLaFicheViseeChoix(i18n);
			default:
				return $author$project$I18n$Cles$pipeEtape5DestinationAideVaSurLaFicheVisee(i18n);
		}
	});
var $author$project$I18n$Cles$pipeEtape5DestinationAideEstRangeAvecLesDocuments = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.aide.est-range-avec-les-documents', _List_Nil, 'Pour un fichier : convention, justificatif.');
};
var $author$project$I18n$Cles$pipeEtape5DestinationAideResteDansLaReponse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.aide.reste-dans-la-reponse', _List_Nil, 'Gardée avec les réponses de cette tâche, sans être recopiée ailleurs.');
};
var $author$project$I18n$Cles$pipeEtape5DestinationAideResteSurLeDossier = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.destination.aide.reste-sur-le-dossier',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'dossier',
					$author$project$I18n$Traductions$Chaine(p.xI))
				]),
			'Valable pour ' + (p.xI + ' seulement, pas sur la fiche.'));
	});
var $author$project$Components$Parametrage$Vocabulaire$aideDeLaDestination = F3(
	function (i18n, phrase, code) {
		switch (code) {
			case 'reste-dans-la-reponse':
				return $author$project$I18n$Cles$pipeEtape5DestinationAideResteDansLaReponse(i18n);
			case 'reste-sur-le-dossier':
				return A2(
					$author$project$I18n$Cles$pipeEtape5DestinationAideResteSurLeDossier,
					i18n,
					{xI: phrase.xI});
			case 'va-sur-la-fiche-visee':
				return A2($author$project$Components$Parametrage$Vocabulaire$aideDeLaFicheVisee, i18n, phrase.JR);
			case 'va-sur-la-fiche-d-un-autre-role':
				return phrase.t6;
			case 'va-sur-la-ressource-liee':
				return $author$project$I18n$Cles$pipeDestinationsRessourceAide(i18n);
			default:
				return $author$project$I18n$Cles$pipeEtape5DestinationAideEstRangeAvecLesDocuments(i18n);
		}
	});
var $author$project$Catalogue$Formes$avecCe = F2(
	function (formes, nom) {
		return A2(
			$elm$core$Maybe$withDefault,
			nom,
			A2(
				$elm$core$Maybe$map,
				function (lues) {
					return _Utils_ap(
						function () {
							var _v0 = _Utils_Tuple2(lues.zX.M, lues.zX.av);
							if (_v0.a === 1) {
								var _v1 = _v0.a;
								return 'cette ';
							} else {
								if (_v0.b) {
									var _v2 = _v0.a;
									return 'cet ';
								} else {
									var _v3 = _v0.a;
									return 'ce ';
								}
							}
						}(),
						$elm$core$String$toLower(nom));
				},
				formes));
	});
var $author$project$I18n$Cles$pipeEtape5DossierParDefaut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.dossier-par-defaut', _List_Nil, 'ce dossier');
};
var $author$project$Components$Parametrage$PipeEtape5$Phrases$ceDossier = F2(
	function (i18n, formulaire) {
		var _v0 = formulaire.CW;
		if (!_v0.$) {
			var mot = _v0.a;
			return A2(
				$elm$core$Maybe$withDefault,
				$author$project$I18n$Cles$pipeEtape5DossierParDefaut(i18n),
				A2(
					$elm$core$Maybe$map,
					function (_v1) {
						return A2($author$project$Catalogue$Formes$avecCe, mot.m$, mot.Bl);
					},
					mot.m$));
		} else {
			return $author$project$I18n$Cles$pipeEtape5DossierParDefaut(i18n);
		}
	});
var $author$project$Components$Parametrage$PipeEtape5$Phrases$aideDeLaDestination = F4(
	function (i18n, formulaire, typeDeChamp, code) {
		return A3(
			$author$project$Components$Parametrage$Vocabulaire$aideDeLaDestination,
			i18n,
			{
				t6: A2($author$project$Components$Parametrage$PipeEtape5$Phrases$aideDUnAutreRole, i18n, formulaire),
				xI: A2($author$project$Components$Parametrage$PipeEtape5$Phrases$ceDossier, i18n, formulaire),
				JR: typeDeChamp
			},
			code);
	});
var $author$project$I18n$Cles$pipeEtape5DestinationEstRangeAvecLesDocuments = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.est-range-avec-les-documents', _List_Nil, 'Est rangé avec les documents du dossier');
};
var $author$project$I18n$Cles$pipeEtape5DestinationResteDansLaReponse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.reste-dans-la-reponse', _List_Nil, 'Reste dans la réponse');
};
var $author$project$I18n$Cles$pipeEtape5DestinationResteSurLeDossier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.reste-sur-le-dossier', _List_Nil, 'Reste sur le dossier');
};
var $author$project$I18n$Cles$pipeEtape5DestinationVaSurLaFicheDUnAutreRole = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.destination.va-sur-la-fiche-d-un-autre-role',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Va sur la fiche du rôle « ' + (p.bi + ' »'));
	});
var $author$project$I18n$Cles$pipeEtape5DestinationVaSurLaFicheVisee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.destination.va-sur-la-fiche-visee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'article',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeArticle(p.i4))),
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Va sur la fiche ' + function () {
				var _v0 = p.i4;
				switch (_v0) {
					case 0:
						return '';
					case 1:
						return 'de l\'' + $elm$core$String$toLower(p.bi);
					case 2:
						return 'de la ' + $elm$core$String$toLower(p.bi);
					case 3:
						return 'du ' + $elm$core$String$toLower(p.bi);
					default:
						return 'de ' + p.bi;
				}
			}());
	});
var $author$project$I18n$Cles$pipeEtape5DestinationVaSurLaRessourceLiee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.va-sur-la-ressource-liee', _List_Nil, 'Va sur la ressource liée');
};
var $author$project$Components$Parametrage$Vocabulaire$destinationDuChamp = F3(
	function (i18n, phrase, code) {
		switch (code) {
			case 'reste-dans-la-reponse':
				return $author$project$I18n$Cles$pipeEtape5DestinationResteDansLaReponse(i18n);
			case 'reste-sur-le-dossier':
				return $author$project$I18n$Cles$pipeEtape5DestinationResteSurLeDossier(i18n);
			case 'va-sur-la-fiche-visee':
				return A2(
					$author$project$I18n$Cles$pipeEtape5DestinationVaSurLaFicheVisee,
					i18n,
					{i4: phrase.zo.i4, bi: phrase.zo.bi});
			case 'va-sur-la-fiche-d-un-autre-role':
				return A2(
					$author$project$I18n$Cles$pipeEtape5DestinationVaSurLaFicheDUnAutreRole,
					i18n,
					{bi: phrase.bi});
			case 'est-range-avec-les-documents':
				return $author$project$I18n$Cles$pipeEtape5DestinationEstRangeAvecLesDocuments(i18n);
			case 'va-sur-la-ressource-liee':
				return $author$project$I18n$Cles$pipeEtape5DestinationVaSurLaRessourceLiee(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$Components$Parametrage$PipeEtape5$View$roleDe = F2(
	function (roles, uid) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (role) {
					return _Utils_eq(role.r8, uid);
				},
				roles));
	});
var $author$project$Components$Parametrage$PipeEtape5$View$phraseDeDestination = F3(
	function (i18n, formulaire, destination) {
		return A3(
			$author$project$Components$Parametrage$Vocabulaire$destinationDuChamp,
			i18n,
			{
				zo: $author$project$Components$Parametrage$PipeEtape5$Phrases$ficheVisee(formulaire),
				bi: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.Bl;
						},
						A2(
							$elm$core$Maybe$andThen,
							$author$project$Components$Parametrage$PipeEtape5$View$roleDe(formulaire.o_.eX),
							destination.H6)))
			},
			destination.r0);
	});
var $author$project$I18n$Cles$pipeEtape5DestinationTitreAutreRole = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.titre-autre-role', _List_Nil, 'Va sur la fiche d\'une autre personne du dossier');
};
var $author$project$Components$Parametrage$PipeEtape5$View$destinationProposee = F4(
	function (i18n, saisie, champ, code) {
		return A6(
			$author$project$Components$Parametrage$Common$Conception$choix,
			'destination',
			code,
			_Utils_eq(champ.xw, code),
			(code === 'va-sur-la-fiche-d-un-autre-role') ? $author$project$I18n$Cles$pipeEtape5DestinationTitreAutreRole(i18n) : ((code === 'va-sur-la-ressource-liee') ? $author$project$I18n$Cles$pipeEtape5DestinationVaSurLaRessourceLiee(i18n) : A3(
				$author$project$Components$Parametrage$PipeEtape5$View$phraseDeDestination,
				i18n,
				saisie.B1,
				{uN: $elm$core$Maybe$Nothing, xI: false, y0: false, Bl: $elm$core$Maybe$Nothing, HN: $elm$core$Maybe$Nothing, H6: $elm$core$Maybe$Nothing, r0: code})),
			A4($author$project$Components$Parametrage$PipeEtape5$Phrases$aideDeLaDestination, i18n, saisie.B1, champ.B0.r0, code),
			$author$project$Components$Parametrage$PipeEtape5$Update$DestinationChoisie(code));
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$DossierBascule = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$FicheBasculee = function (a) {
	return {$: 12, a: a};
};
var $author$project$I18n$Cles$pipeEtape5FicheViseeNaturePartiePrenante = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.fiche-visee.nature.partie-prenante', _List_Nil, 'Partie prenante');
};
var $author$project$I18n$Cles$pipeEtape5FicheViseeNatureProduit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.fiche-visee.nature.produit', _List_Nil, 'Produit');
};
var $author$project$Components$Parametrage$Vocabulaire$natureDeLaFicheVisee = F2(
	function (i18n, code) {
		switch (code) {
			case 'produit':
				return $author$project$I18n$Cles$pipeEtape5FicheViseeNatureProduit(i18n);
			case 'partie-prenante':
				return $author$project$I18n$Cles$pipeEtape5FicheViseeNaturePartiePrenante(i18n);
			default:
				return code;
		}
	});
var $author$project$I18n$Cles$pipeEtape5DestinationAussiFicheAide = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.destination.aussi-fiche-aide',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fiche',
					$author$project$I18n$Traductions$Chaine(p.zo))
				]),
			'La réponse s\'écrit sur la fiche visée par le pipe (' + (p.zo + ').'));
	});
var $author$project$I18n$Cles$pipeEtape5DestinationAussiFicheAideSeule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.aussi-fiche-aide-seule', _List_Nil, 'La réponse s\'écrit sur la fiche visée par le pipe.');
};
var $author$project$I18n$Cles$pipeEtape5FicheViseeValeur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.fiche-visee.valeur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nature',
					$author$project$I18n$Traductions$Chaine(p.g1)),
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			p.g1 + (' · ' + p.bi));
	});
var $author$project$Components$Parametrage$PipeEtape5$View$aideDeLaFiche = F2(
	function (i18n, lue) {
		var _v0 = _Utils_Tuple2(lue.zt, lue.C3);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var fiche = _v0.a.a;
			var nature = _v0.b.a;
			return A2(
				$author$project$I18n$Cles$pipeEtape5DestinationAussiFicheAide,
				i18n,
				{
					zo: A2(
						$author$project$I18n$Cles$pipeEtape5FicheViseeValeur,
						i18n,
						{
							g1: A2($author$project$Components$Parametrage$Vocabulaire$natureDeLaFicheVisee, i18n, nature),
							bi: fiche.Bl
						})
				});
		} else {
			return $author$project$I18n$Cles$pipeEtape5DestinationAussiFicheAideSeule(i18n);
		}
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$ModeDeLaFicheChoisi = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$NomDeLaFicheSaisi = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$ChampDeLaFicheChoisi = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$RechercheSaisie = function (a) {
	return {$: 16, a: a};
};
var $author$project$I18n$Cles$pipeEtape5FicheViseeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.fiche-visee.titre', _List_Nil, 'Fiche visée par ce pipe');
};
var $author$project$Components$Parametrage$PipeEtape5$Phrases$nomDeLaFicheVisee = F2(
	function (i18n, formulaire) {
		var _v0 = _Utils_Tuple2(formulaire.zt, formulaire.C3);
		if (!_v0.a.$) {
			var role = _v0.a.a;
			return (role.Bl === '') ? $author$project$I18n$Cles$pipeEtape5FicheViseeTitre(i18n) : role.Bl;
		} else {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var nature = _v0.b.a;
				return A2($author$project$Components$Parametrage$Vocabulaire$natureDeLaFicheVisee, i18n, nature);
			} else {
				var _v2 = _v0.a;
				var _v3 = _v0.b;
				return $author$project$I18n$Cles$pipeEtape5FicheViseeTitre(i18n);
			}
		}
	});
var $author$project$I18n$Cles$pipeEtape5DestinationCreerSurLaFicheVisee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.creer-sur-la-fiche-visee', _List_Nil, 'Créer un champ de la fiche visée');
};
var $author$project$I18n$Cles$pipeEtape5DestinationFicheVideCreable = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.destination.fiche-vide-creable',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fiche',
					$author$project$I18n$Traductions$Chaine(p.zo)),
					_Utils_Tuple2(
					'genre',
					$author$project$I18n$Traductions$Chaine(p.M))
				]),
			'La fiche visée « ' + (p.zo + (' » n\'a aucun champ de type ' + (p.M + '. Créez-en un, ou n\'écrivez pas la réponse sur la fiche.'))));
	});
var $author$project$I18n$Cles$pipeEtape5DestinationFicheVideNonCreable = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.destination.fiche-vide-non-creable',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'genre',
					$author$project$I18n$Traductions$Chaine(p.M))
				]),
			'La fiche visée n\'a aucun champ de type ' + (p.M + ' à choisir.'));
	});
var $author$project$Components$Parametrage$PipeEtape5$View$aucunChampCompatible = F3(
	function (i18n, saisie, champ) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('aucun-champ-compatible')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape5DestinationAucunCompatible(i18n))
						])),
				$author$project$Components$Parametrage$PipeEtape5$Model$creableSurLaFiche(saisie) ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$pipeEtape5DestinationFicheVideCreable,
									i18n,
									{
										zo: A2($author$project$Components$Parametrage$PipeEtape5$Phrases$nomDeLaFicheVisee, i18n, saisie.B1),
										M: A2($author$project$Components$Parametrage$Vocabulaire$typeDeChamp, i18n, champ.B0.r0)
									}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Parametrage$PipeEtape5$Update$ModeDeLaFicheChoisi(false))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape5DestinationCreerSurLaFicheVisee(i18n))
							]))
					]) : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$pipeEtape5DestinationFicheVideNonCreable,
									i18n,
									{
										M: A2($author$project$Components$Parametrage$Vocabulaire$typeDeChamp, i18n, champ.B0.r0)
									}))
							]))
					])));
	});
var $author$project$I18n$Cles$pipeEtape5DestinationAucuneCorrespondance = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.aucune-correspondance', _List_Nil, 'Aucun champ de la fiche ne correspond à cette recherche.');
};
var $author$project$I18n$Cles$pipeEtape5DestinationCompte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.destination.compte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'affiches',
					$author$project$I18n$Traductions$Entier(p.s3)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE)),
					_Utils_Tuple2(
					'genre',
					$author$project$I18n$Traductions$Chaine(p.M))
				]),
			((!p.s3) || (p.s3 === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.s3) + (' champ sur ' + (p.JE + (' : seuls les champs de type ' + (p.M + ' sont proposés.'))))) : (A2($author$project$I18n$Nombre$formater, 0, p.s3) + (' champs sur ' + (p.JE + (' : seuls les champs de type ' + (p.M + ' sont proposés.'))))));
	});
var $author$project$I18n$Cles$pipeEtape5DestinationMemeType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.meme-type', _List_Nil, 'même type');
};
var $author$project$I18n$Cles$pipeEtape5DestinationRecherche = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.destination.recherche',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fiche',
					$author$project$I18n$Traductions$Chaine(p.zo))
				]),
			'Rechercher un champ de la fiche visée « ' + (p.zo + ' »'));
	});
var $author$project$I18n$Cles$pipeEtape5DestinationRecherchePlaceholder = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.recherche-placeholder', _List_Nil, 'Rechercher');
};
var $author$project$I18n$Cles$pipeEtape5DestinationTypeDeChampDeLaFiche = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.destination.type-de-champ-de-la-fiche',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'genre',
					$author$project$I18n$Traductions$Chaine(p.M))
				]),
			p.M + ' · champ de la fiche');
	});
var $author$project$Components$Parametrage$PipeEtape5$View$champsAChoisir = F3(
	function (i18n, saisie, champ) {
		var _v0 = saisie.B1.o_.uV;
		if (_v0.$ === 1) {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('illisible')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape5DestinationFicheIllisible(i18n))
						]))
				]);
		} else {
			if (!_v0.a.b) {
				return _List_fromArray(
					[
						A3($author$project$Components$Parametrage$PipeEtape5$View$aucunChampCompatible, i18n, saisie, champ)
					]);
			} else {
				var deLaFiche = _v0.a;
				var dumemeType = A2(
					$elm$core$List$filter,
					function (c) {
						return A2(
							$elm$core$Maybe$withDefault,
							true,
							A2(
								$elm$core$Maybe$map,
								function (t) {
									return _Utils_eq(t, champ.B0.r0);
								},
								c.r0));
					},
					deLaFiche);
				var cherche = $elm$core$String$toLower(
					$elm$core$String$trim(champ.hC));
				var affiches = A2(
					$elm$core$List$filter,
					function (c) {
						return (cherche === '') || A2(
							$elm$core$String$contains,
							cherche,
							$elm$core$String$toLower(c.Bl));
					},
					dumemeType);
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('champ'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('recherche')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$pipeEtape5DestinationRecherche,
											i18n,
											{
												zo: A2($author$project$Components$Parametrage$PipeEtape5$Phrases$nomDeLaFicheVisee, i18n, saisie.B1)
											}))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$input,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('search'),
										$rtfeldman$elm_css$Html$Styled$Attributes$value(champ.hC),
										$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(
										$author$project$I18n$Cles$pipeEtape5DestinationRecherchePlaceholder(i18n)),
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Parametrage$PipeEtape5$Update$RechercheSaisie)
									]),
								_List_Nil)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('champs-de-la-fiche')
							]),
						A2(
							$elm$core$List$map,
							function (c) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'choisi',
													_Utils_eq(
														champ.du,
														$elm$core$Maybe$Just(c.vx)))
												]))
										]),
									_List_fromArray(
										[
											A6(
											$author$project$Components$Parametrage$Common$Conception$choix,
											'champ-de-la-fiche',
											c.vx,
											_Utils_eq(
												champ.du,
												$elm$core$Maybe$Just(c.vx)),
											c.Bl,
											A2(
												$author$project$I18n$Cles$pipeEtape5DestinationTypeDeChampDeLaFiche,
												i18n,
												{
													M: A2($author$project$Components$Parametrage$Vocabulaire$typeDeChamp, i18n, champ.B0.r0)
												}),
											$author$project$Components$Parametrage$PipeEtape5$Update$ChampDeLaFicheChoisi(c.vx)),
											_Utils_eq(
											champ.du,
											$elm$core$Maybe$Just(c.vx)) ? A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('tag')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$pipeEtape5DestinationMemeType(i18n))
												])) : $rtfeldman$elm_css$Html$Styled$text('')
										]));
							},
							affiches)),
						$elm$core$List$isEmpty(dumemeType) ? A3($author$project$Components$Parametrage$PipeEtape5$View$aucunChampCompatible, i18n, saisie, champ) : ($elm$core$List$isEmpty(affiches) ? A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape5DestinationAucuneCorrespondance(i18n))
							])) : $rtfeldman$elm_css$Html$Styled$text('')),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$pipeEtape5DestinationCompte,
									i18n,
									{
										s3: $elm$core$List$length(dumemeType),
										M: A2($author$project$Components$Parametrage$Vocabulaire$typeDeChamp, i18n, champ.B0.r0),
										JE: $elm$core$String$fromInt(
											$elm$core$List$length(deLaFiche))
									}))
							]))
					]);
			}
		}
	});
var $author$project$I18n$Cles$pipeEtape5DestinationModeCreer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.mode.creer', _List_Nil, 'Créer un champ de la fiche');
};
var $author$project$I18n$Cles$pipeEtape5DestinationModeCreerAide = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.destination.mode.creer-aide',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'genre',
					$author$project$I18n$Traductions$Chaine(p.M))
				]),
			'Le champ est créé dans la bibliothèque, limité au type « ' + (p.M + ' ». Une autre fiche pourra le rattacher plus tard.'));
	});
var $author$project$I18n$Cles$pipeEtape5DestinationNomDeLaFiche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.nom-de-la-fiche', _List_Nil, 'Nom du champ sur la fiche · Français');
};
var $author$project$I18n$Cles$pipeEtape5DestinationNonCreable = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.destination.non-creable',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'genre',
					$author$project$I18n$Traductions$Chaine(p.M))
				]),
			'Un champ de type ' + (p.M + ' ne se crée pas depuis le pipe : choisissez un champ existant de la fiche visée.'));
	});
var $author$project$I18n$Cles$pipeEtape5DestinationTypeCeluiDuChamp = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.destination.type-celui-du-champ',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.Dj + ' · celui du champ');
	});
var $author$project$I18n$Cles$pipeEtape5DestinationTypeDeLaFiche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.type-de-la-fiche', _List_Nil, 'Type');
};
var $author$project$Components$Shared$Svg$svgLock = A3($author$project$Components$Shared$Svg$icone, 'lock', 'M5 11h14v10H5zM8 11V7a4 4 0 0 1 8 0v4', _List_Nil);
var $author$project$Components$Parametrage$PipeEtape5$View$choixDeLaFiche = F3(
	function (i18n, saisie, champ) {
		var creable = $author$project$Components$Parametrage$PipeEtape5$Model$creableSurLaFiche(saisie);
		var existant = champ.y0 || (!creable);
		var bouton = F2(
			function (titre, estChoisir) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'choisi',
									_Utils_eq(existant, estChoisir))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-pressed',
							_Utils_eq(existant, estChoisir) ? 'true' : 'false'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Parametrage$PipeEtape5$Update$ModeDeLaFicheChoisi(estChoisir))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(titre)
						]));
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('choix-de-la-fiche')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('bascule'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'group')
						]),
					creable ? _List_fromArray(
						[
							A2(
							bouton,
							$author$project$I18n$Cles$pipeEtape5DestinationModeChoisir(i18n),
							true),
							A2(
							bouton,
							$author$project$I18n$Cles$pipeEtape5DestinationModeCreer(i18n),
							false)
						]) : _List_fromArray(
						[
							A2(
							bouton,
							$author$project$I18n$Cles$pipeEtape5DestinationModeChoisir(i18n),
							true)
						])),
				_Utils_ap(
					(!creable) ? _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('non-creable')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$pipeEtape5DestinationNonCreable,
										i18n,
										{
											M: A2($author$project$Components$Parametrage$Vocabulaire$typeDeChamp, i18n, champ.B0.r0)
										}))
								]))
						]) : _List_Nil,
					existant ? A3($author$project$Components$Parametrage$PipeEtape5$View$champsAChoisir, i18n, saisie, champ) : _List_fromArray(
						[
							A3(
							$author$project$Components$Parametrage$Common$Conception$champDeTexte,
							$author$project$I18n$Cles$pipeEtape5DestinationNomDeLaFiche(i18n),
							(champ.cZ === '') ? A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Dict$get, 'fr', champ.R)) : champ.cZ,
							$author$project$Components$Parametrage$PipeEtape5$Update$NomDeLaFicheSaisi),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('type-de-la-fiche')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape5DestinationTypeDeLaFiche(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('champ-verrouille')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$author$project$I18n$Cles$pipeEtape5DestinationTypeCeluiDuChamp,
														i18n,
														{
															Dj: A2($author$project$Components$Parametrage$Vocabulaire$typeDeChamp, i18n, champ.B0.r0)
														}))
												])),
											$author$project$Components$Shared$Svg$svgLock
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('encart-info')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$pipeEtape5DestinationModeCreerAide,
												i18n,
												{
													M: A2($author$project$Components$Parametrage$PipeEtape5$Phrases$nomDeLaFicheVisee, i18n, saisie.B1)
												}))
										]))
								]))
						]))));
	});
var $author$project$I18n$Cles$pipeEtape5DestinationAussiDossier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.aussi-dossier', _List_Nil, 'Aussi dans le dossier');
};
var $author$project$I18n$Cles$pipeEtape5DestinationAussiDossierAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.aussi-dossier-aide', _List_Nil, 'Valable pour ce dossier seulement, visible dans sa fiche.');
};
var $author$project$I18n$Cles$pipeEtape5DestinationAussiFiche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.aussi-fiche', _List_Nil, 'Aussi sur la fiche visée');
};
var $author$project$Components$Parametrage$PipeEtape5$View$destinationsEnPlus = F3(
	function (i18n, saisie, champ) {
		var reponse = champ.xw === 'reste-dans-la-reponse';
		var ficheCochee = champ.xw === 'va-sur-la-fiche-visee';
		var exclusive = (!reponse) && (!ficheCochee);
		return exclusive ? _List_Nil : _List_fromArray(
			[
				A5(
				$author$project$Components$Parametrage$Common$Conception$caseACocher,
				'aussi-fiche',
				ficheCochee,
				$author$project$I18n$Cles$pipeEtape5DestinationAussiFiche(i18n),
				A2($author$project$Components$Parametrage$PipeEtape5$View$aideDeLaFiche, i18n, saisie.B1),
				$author$project$Components$Parametrage$PipeEtape5$Update$FicheBasculee),
				ficheCochee ? A3($author$project$Components$Parametrage$PipeEtape5$View$choixDeLaFiche, i18n, saisie, champ) : $rtfeldman$elm_css$Html$Styled$text(''),
				A5(
				$author$project$Components$Parametrage$Common$Conception$caseACocher,
				'aussi-dossier',
				champ.xI,
				$author$project$I18n$Cles$pipeEtape5DestinationAussiDossier(i18n),
				$author$project$I18n$Cles$pipeEtape5DestinationAussiDossierAide(i18n),
				$author$project$Components$Parametrage$PipeEtape5$Update$DossierBascule)
			]);
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$ChampDeRessourceChoisi = function (a) {
	return {$: 25, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$RessourceChoisie = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$View$listesDeLaRessource = F3(
	function (i18n, saisie, champ) {
		var ressources = saisie.B1.o_.HP;
		var choisie = A2($elm$core$Maybe$withDefault, '', champ.qC);
		return _List_fromArray(
			[
				A4(
				$author$project$Components$Parametrage$Common$Conception$liste,
				$author$project$I18n$Cles$pipeDestinationsRessourceRessource(i18n),
				choisie,
				A2(
					$elm$core$List$map,
					function (r) {
						return _Utils_Tuple2(r.r8, r.Bl);
					},
					ressources),
				$author$project$Components$Parametrage$PipeEtape5$Update$RessourceChoisie),
				A4(
				$author$project$Components$Parametrage$Common$Conception$liste,
				$author$project$I18n$Cles$pipeDestinationsRessourceChamp(i18n),
				A2($elm$core$Maybe$withDefault, '', champ.bx),
				A2(
					$elm$core$List$map,
					function (c) {
						return _Utils_Tuple2(c.vx, c.Bl);
					},
					A2(
						$elm$core$List$concatMap,
						function ($) {
							return $.dw;
						},
						A2(
							$elm$core$List$filter,
							function (r) {
								return _Utils_eq(r.r8, choisie);
							},
							ressources))),
				$author$project$Components$Parametrage$PipeEtape5$Update$ChampDeRessourceChoisi)
			]);
	});
var $author$project$I18n$Cles$pipeEtape5ChampTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.champ.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Champ « ' + (p.Dj + ' » : où va la réponse ?'));
	});
var $author$project$I18n$Cles$pipeEtape5DestinationReponseAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.reponse.aide', _List_Nil, 'La réponse est toujours gardée avec celles de cette tâche.');
};
var $author$project$I18n$Cles$pipeEtape5DestinationReponseTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.destination.reponse.titre', _List_Nil, 'Dans la réponse');
};
var $author$project$I18n$Cles$pipeEtape5ObligationEnvoyer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.obligation.envoyer', _List_Nil, 'Obligatoire pour envoyer le formulaire');
};
var $author$project$I18n$Cles$pipeEtape5ObligationEnvoyerAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.obligation.envoyer-aide', _List_Nil, 'Sans valeur, celui qui remplit ne peut pas envoyer. Réglage de la validation du champ.');
};
var $author$project$I18n$Cles$pipeEtape5ObligationPasser = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.obligation.passer', _List_Nil, 'Requis pour passer à l\'étape suivante');
};
var $author$project$I18n$Cles$pipeEtape5ObligationPasserAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.obligation.passer-aide', _List_Nil, 'Celui qui remplit peut envoyer le formulaire sans ce champ, mais le dossier ne passe pas à l\'étape suivante tant que la fiche n\'a pas de valeur. Une valeur déjà sur la fiche compte.');
};
var $author$project$I18n$Cles$pipeEtape5ObligationTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.obligation.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.Dj + ' : obligation');
	});
var $author$project$I18n$Cles$pipeEtape5RetraitChampBouton = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.retrait-champ.bouton',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer ' + p.Dj);
	});
var $author$project$I18n$Cles$pipeEtape5RetraitChampRestaurable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.retrait-champ.restaurable', _List_Nil, 'Un champ retiré peut être restauré.');
};
var $author$project$I18n$Cles$pipeEtape5RetraitChampSection = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.retrait-champ.section', _List_Nil, 'Retirer ce champ');
};
var $author$project$I18n$Cles$pipeEtape5SaisieTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.saisie.titre', _List_Nil, 'À la saisie');
};
var $author$project$I18n$Cles$pipeEtape5SaisieVisible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.saisie.visible', _List_Nil, 'Visible sur le portail');
};
var $author$project$I18n$Cles$pipeEtape5ValidationQui = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.validation.qui', _List_Nil, 'Qui valide');
};
var $author$project$Components$Parametrage$PipeEtape5$Update$DepotDeFichiersChoisi = function (a) {
	return {$: 31, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$ImportDesLignesChoisi = function (a) {
	return {$: 33, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$LignesImportablesBascule = function (a) {
	return {$: 32, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$QuandLaFicheARenseigneChoisi = function (a) {
	return {$: 30, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$ColonneAjoutee = {$: 34};
var $author$project$I18n$Cles$pipeEtape5LignesColonneAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.lignes.colonne-ajouter', _List_Nil, 'Ajouter une colonne');
};
var $author$project$I18n$Cles$pipeEtape5LignesColonnes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.lignes.colonnes', _List_Nil, 'Colonnes de la grille');
};
var $author$project$Components$Parametrage$PipeEtape5$Update$ColonneDeplacee = F2(
	function (a, b) {
		return {$: 41, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$ColonneFormuleSaisie = F2(
	function (a, b) {
		return {$: 39, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$ColonneRenommee = F2(
	function (a, b) {
		return {$: 35, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$ColonneRetiree = function (a) {
	return {$: 40, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$ColonneTypeViseChoisi = F2(
	function (a, b) {
		return {$: 38, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$ColonneTypee = F2(
	function (a, b) {
		return {$: 36, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$ColonneValeursSaisies = F2(
	function (a, b) {
		return {$: 37, a: a, b: b};
	});
var $author$project$Components$Shared$Svg$svgChevronUp = A3($author$project$Components$Shared$Svg$icone, 'chevron-up', 'M18 15l-6-6-6 6', _List_Nil);
var $author$project$Components$Shared$OrdreView$boutonDOrdre = F2(
	function (sens, attributs) {
		if (!sens) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$button,
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$class('monter'),
						attributs)),
				_List_fromArray(
					[$author$project$Components$Shared$Svg$svgChevronUp]));
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$button,
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$class('descendre'),
						attributs)),
				_List_fromArray(
					[$author$project$Components$Shared$Svg$svgChevronDown]));
		}
	});
var $author$project$Components$Parametrage$PipeEtape5$View$boutonDeColonne = F3(
	function (classe, nom, msg) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(classe),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', nom),
					$rtfeldman$elm_css$Html$Styled$Attributes$title(nom),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(nom)
				]));
	});
var $author$project$I18n$Cles$pipeEtape5LignesColonneDescendre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.lignes.colonne-descendre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Descendre la colonne ' + p.Dj);
	});
var $author$project$I18n$Cles$pipeEtape5LignesColonneFormule = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.lignes.colonne-formule',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Formule de la colonne ' + (p.Dj + ', sur les colonnes de la même ligne'));
	});
var $author$project$I18n$Cles$pipeEtape5LignesColonneLibelle = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.lignes.colonne-libelle',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'numero',
					$author$project$I18n$Traductions$Chaine(p.DX))
				]),
			'Nom de la colonne ' + p.DX);
	});
var $author$project$I18n$Cles$pipeEtape5LignesColonneMonter = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.lignes.colonne-monter',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Monter la colonne ' + p.Dj);
	});
var $author$project$I18n$Cles$pipeEtape5LignesColonneRetirer = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.lignes.colonne-retirer',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer la colonne ' + p.Dj);
	});
var $author$project$I18n$Cles$pipeEtape5LignesColonneType = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.lignes.colonne-type',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Type de la colonne ' + p.Dj);
	});
var $author$project$I18n$Cles$pipeEtape5LignesColonneTypeVise = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.lignes.colonne-type-vise',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Type de fiche visé par la colonne ' + p.Dj);
	});
var $author$project$I18n$Cles$pipeEtape5LignesColonneTypeViseChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.lignes.colonne-type-vise-choisir', _List_Nil, 'Choisir un type de fiche');
};
var $author$project$I18n$Cles$pipeEtape5LignesColonneValeurs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.lignes.colonne-valeurs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Valeurs de la colonne ' + (p.Dj + ', séparées par un point-virgule'));
	});
var $author$project$Components$Parametrage$PipeEtape5$Model$typesDeColonne = _List_fromArray(
	['texte', 'texte-long', 'nombre', 'montant', 'mesure', 'date', 'email', 'telephone', 'adresse', 'fichier', 'image', 'oui-non', 'choix-unique', 'choix-multiple', 'pays', 'langue', 'partie-prenante', 'utilisateur', 'note', 'niveaux', 'calcule']);
var $author$project$Components$Parametrage$PipeEtape5$View$uneColonne = F5(
	function (i18n, types, total, rang, colonne) {
		var nom = (colonne.Bl === '') ? $elm$core$String$fromInt(rang + 1) : colonne.Bl;
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('colonne')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$input,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(colonne.Bl),
								$rtfeldman$elm_css$Html$Styled$Events$onInput(
								$author$project$Components$Parametrage$PipeEtape5$Update$ColonneRenommee(rang)),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-label',
								A2(
									$author$project$I18n$Cles$pipeEtape5LignesColonneLibelle,
									i18n,
									{
										DX: $elm$core$String$fromInt(rang + 1)
									}))
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$select,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput(
								$author$project$Components$Parametrage$PipeEtape5$Update$ColonneTypee(rang)),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-label',
								A2(
									$author$project$I18n$Cles$pipeEtape5LignesColonneType,
									i18n,
									{Dj: nom}))
							]),
						A2(
							$elm$core$List$map,
							function (code) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$option,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(code),
											$rtfeldman$elm_css$Html$Styled$Attributes$selected(
											_Utils_eq(code, colonne.JR))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$Components$Parametrage$Vocabulaire$typeDeChamp, i18n, code))
										]));
							},
							$author$project$Components$Parametrage$PipeEtape5$Model$typesDeColonne))
					]),
				_Utils_ap(
					((colonne.JR === 'choix-unique') || (colonne.JR === 'choix-multiple')) ? _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(
									A2($elm$core$String$join, '; ', colonne.Ki)),
									$rtfeldman$elm_css$Html$Styled$Events$onInput(
									$author$project$Components$Parametrage$PipeEtape5$Update$ColonneValeursSaisies(rang)),
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									A2(
										$author$project$I18n$Cles$pipeEtape5LignesColonneValeurs,
										i18n,
										{Dj: nom}))
								]),
							_List_Nil)
						]) : _List_Nil,
					_Utils_ap(
						(colonne.JR === 'calcule') ? _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$input,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value(
										A2($elm$core$Maybe$withDefault, '', colonne.zU)),
										$rtfeldman$elm_css$Html$Styled$Events$onInput(
										$author$project$Components$Parametrage$PipeEtape5$Update$ColonneFormuleSaisie(rang)),
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
										'aria-label',
										A2(
											$author$project$I18n$Cles$pipeEtape5LignesColonneFormule,
											i18n,
											{Dj: nom}))
									]),
								_List_Nil)
							]) : _List_Nil,
						_Utils_ap(
							(colonne.JR === 'partie-prenante') ? _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$select,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onInput(
											$author$project$Components$Parametrage$PipeEtape5$Update$ColonneTypeViseChoisi(rang)),
											A2(
											$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
											'aria-label',
											A2(
												$author$project$I18n$Cles$pipeEtape5LignesColonneTypeVise,
												i18n,
												{Dj: nom}))
										]),
									A2(
										$elm$core$List$cons,
										A2(
											$rtfeldman$elm_css$Html$Styled$option,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$value('')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$pipeEtape5LignesColonneTypeViseChoisir(i18n))
												])),
										A2(
											$elm$core$List$map,
											function (t) {
												return A2(
													$rtfeldman$elm_css$Html$Styled$option,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$value(t.r8),
															$rtfeldman$elm_css$Html$Styled$Attributes$selected(
															_Utils_eq(
																colonne.r$,
																$elm$core$Maybe$Just(t.r8)))
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(t.Bl)
														]));
											},
											types)))
								]) : _List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Components$Shared$OrdreView$boutonDOrdre,
									0,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											A2($author$project$Components$Parametrage$PipeEtape5$Update$ColonneDeplacee, rang, -1)),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!rang),
											A2(
											$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
											'aria-label',
											A2(
												$author$project$I18n$Cles$pipeEtape5LignesColonneMonter,
												i18n,
												{Dj: nom})),
											$rtfeldman$elm_css$Html$Styled$Attributes$title(
											A2(
												$author$project$I18n$Cles$pipeEtape5LignesColonneMonter,
												i18n,
												{Dj: nom}))
										])),
									A2(
									$author$project$Components$Shared$OrdreView$boutonDOrdre,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											A2($author$project$Components$Parametrage$PipeEtape5$Update$ColonneDeplacee, rang, 1)),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
											_Utils_eq(rang, total - 1)),
											A2(
											$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
											'aria-label',
											A2(
												$author$project$I18n$Cles$pipeEtape5LignesColonneDescendre,
												i18n,
												{Dj: nom})),
											$rtfeldman$elm_css$Html$Styled$Attributes$title(
											A2(
												$author$project$I18n$Cles$pipeEtape5LignesColonneDescendre,
												i18n,
												{Dj: nom}))
										])),
									A3(
									$author$project$Components$Parametrage$PipeEtape5$View$boutonDeColonne,
									'retirer',
									A2(
										$author$project$I18n$Cles$pipeEtape5LignesColonneRetirer,
										i18n,
										{Dj: nom}),
									$author$project$Components$Parametrage$PipeEtape5$Update$ColonneRetiree(rang))
								]))))));
	});
var $author$project$Components$Parametrage$PipeEtape5$View$colonnesDeLaGrille = F3(
	function (i18n, types, colonnes) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('colonnes-de-la-grille')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape5LignesColonnes(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('liste-de-colonnes')
						]),
					A2(
						$elm$core$List$indexedMap,
						A3(
							$author$project$Components$Parametrage$PipeEtape5$View$uneColonne,
							i18n,
							types,
							$elm$core$List$length(colonnes)),
						colonnes)),
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ajouter-une-colonne'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape5$Update$ColonneAjoutee)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape5LignesColonneAjouter(i18n))
						]))
				]));
	});
var $author$project$I18n$Cles$pipeEtape5DepotAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.depot.aide', _List_Nil, 'La fiche a peut-être déjà des fichiers. Ce réglage dit ce que devient un dépôt.');
};
var $author$project$I18n$Cles$pipeEtape5DepotAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.depot.ajouter', _List_Nil, 'Ajouter aux fichiers de la fiche');
};
var $author$project$I18n$Cles$pipeEtape5DepotAjouterAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.depot.ajouter-aide', _List_Nil, 'Les fichiers déjà sur la fiche sont gardés ; ceux qui sont déposés s\'y ajoutent. Réglage par défaut.');
};
var $author$project$I18n$Cles$pipeEtape5DepotRemplacer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.depot.remplacer', _List_Nil, 'Remplacer les fichiers de la fiche');
};
var $author$project$I18n$Cles$pipeEtape5DepotRemplacerAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.depot.remplacer-aide', _List_Nil, 'Les fichiers déposés prennent la place de ceux de la fiche. Les anciens restent dans l\'historique de la fiche.');
};
var $author$project$I18n$Cles$pipeEtape5DepotTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.depot.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.Dj + ' : dépôt sur la fiche');
	});
var $author$project$I18n$Cles$pipeEtape5LignesAccepter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.lignes.accepter', _List_Nil, 'Accepter un fichier pour remplir les lignes');
};
var $author$project$I18n$Cles$pipeEtape5LignesAccepterAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.lignes.accepter-aide', _List_Nil, 'Une ligne du fichier devient une ligne de la grille.');
};
var $author$project$I18n$Cles$pipeEtape5LignesAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.lignes.ajouter', _List_Nil, 'Ajouter les lignes du fichier');
};
var $author$project$I18n$Cles$pipeEtape5LignesAjouterAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.lignes.ajouter-aide', _List_Nil, 'Les lignes saisies sont gardées.');
};
var $author$project$I18n$Cles$pipeEtape5LignesDejaSaisies = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.lignes.deja-saisies', _List_Nil, 'Si des lignes sont déjà saisies');
};
var $author$project$I18n$Cles$pipeEtape5LignesFeuille = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.lignes.feuille',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Dans un classeur, la feuille qui porte le nom du champ (« ' + (p.Dj + ' ») alimente ses lignes : c\'est le principe « une feuille, une cible » de l\'import global (M411).'));
	});
var $author$project$I18n$Cles$pipeEtape5LignesRemplacer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.lignes.remplacer', _List_Nil, 'Remplacer les lignes saisies');
};
var $author$project$I18n$Cles$pipeEtape5LignesRemplacerAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.lignes.remplacer-aide', _List_Nil, 'Le dossier garde l\'historique des lignes remplacées.');
};
var $author$project$I18n$Cles$pipeEtape5LignesTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.lignes.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.Dj + ' : remplir par import');
	});
var $author$project$I18n$Cles$pipeEtape5QuandAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.quand.aide', _List_Nil, 'Celui qui remplit voit toujours la valeur actuelle de la fiche. Ce réglage dit si le champ lui est demandé quand la fiche en a une.');
};
var $author$project$I18n$Cles$pipeEtape5QuandManque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.quand.manque', _List_Nil, 'Demander seulement si la fiche n\'a pas de valeur');
};
var $author$project$I18n$Cles$pipeEtape5QuandManqueAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.quand.manque-aide', _List_Nil, 'Le champ n\'apparaît que sur les fiches où il manque : le réglage pour compléter. Une fiche déjà renseignée ne le voit pas.');
};
var $author$project$I18n$Cles$pipeEtape5QuandNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.quand.note', _List_Nil, 'Ce réglage n\'existe que pour un champ qui va sur la fiche visée : un champ « Réponse seule » ou « Dossier » n\'a pas de valeur actuelle à montrer.');
};
var $author$project$I18n$Cles$pipeEtape5QuandTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.quand.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.Dj + ' : quand la fiche a déjà une valeur');
	});
var $author$project$I18n$Cles$pipeEtape5QuandToujours = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.quand.toujours', _List_Nil, 'Toujours demander, valeur actuelle pré-remplie');
};
var $author$project$I18n$Cles$pipeEtape5QuandToujoursAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.quand.toujours-aide', _List_Nil, 'Le champ est toujours présenté ; la valeur de la fiche est pré-remplie et se corrige. Réglage par défaut.');
};
var $author$project$Components$Parametrage$PipeEtape5$View$sectionsDImport = F3(
	function (i18n, saisie, champ) {
		var surLaFiche = (champ.xw === 'va-sur-la-fiche-visee') || (champ.xw === 'va-sur-la-fiche-d-un-autre-role');
		var r = champ.qc;
		var nom = {
			Dj: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(champ.R)
		};
		var depot = A2($elm$core$Maybe$withDefault, 'ajouter', r.xd);
		return function (sections) {
			return saisie.B1.g_ ? sections : _List_Nil;
		}(
			$elm$core$List$concat(
				_List_fromArray(
					[
						surLaFiche ? _List_fromArray(
						[
							A2(
							$author$project$Components$Parametrage$Common$Conception$drawerSection,
							A2($author$project$I18n$Cles$pipeEtape5QuandTitre, i18n, nom),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape5QuandAide(i18n))
										])),
									A6(
									$author$project$Components$Parametrage$Common$Conception$choix,
									'quand-la-fiche',
									'toujours-demander',
									r.GH !== 'seulement-si-manque',
									$author$project$I18n$Cles$pipeEtape5QuandToujours(i18n),
									$author$project$I18n$Cles$pipeEtape5QuandToujoursAide(i18n),
									$author$project$Components$Parametrage$PipeEtape5$Update$QuandLaFicheARenseigneChoisi('toujours-demander')),
									A6(
									$author$project$Components$Parametrage$Common$Conception$choix,
									'quand-la-fiche',
									'seulement-si-manque',
									r.GH === 'seulement-si-manque',
									$author$project$I18n$Cles$pipeEtape5QuandManque(i18n),
									$author$project$I18n$Cles$pipeEtape5QuandManqueAide(i18n),
									$author$project$Components$Parametrage$PipeEtape5$Update$QuandLaFicheARenseigneChoisi('seulement-si-manque')),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('description'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('encart')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape5QuandNote(i18n))
										]))
								]))
						]) : _List_Nil,
						(surLaFiche && ((champ.B0.r0 === 'fichier') || (champ.B0.r0 === 'image'))) ? _List_fromArray(
						[
							A2(
							$author$project$Components$Parametrage$Common$Conception$drawerSection,
							A2($author$project$I18n$Cles$pipeEtape5DepotTitre, i18n, nom),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape5DepotAide(i18n))
										])),
									A6(
									$author$project$Components$Parametrage$Common$Conception$choix,
									'depot-de-fichiers',
									'ajouter',
									depot === 'ajouter',
									$author$project$I18n$Cles$pipeEtape5DepotAjouter(i18n),
									$author$project$I18n$Cles$pipeEtape5DepotAjouterAide(i18n),
									$author$project$Components$Parametrage$PipeEtape5$Update$DepotDeFichiersChoisi('ajouter')),
									A6(
									$author$project$Components$Parametrage$Common$Conception$choix,
									'depot-de-fichiers',
									'remplacer',
									depot === 'remplacer',
									$author$project$I18n$Cles$pipeEtape5DepotRemplacer(i18n),
									$author$project$I18n$Cles$pipeEtape5DepotRemplacerAide(i18n),
									$author$project$Components$Parametrage$PipeEtape5$Update$DepotDeFichiersChoisi('remplacer'))
								]))
						]) : _List_Nil,
						(champ.B0.r0 === 'lignes') ? _List_fromArray(
						[
							A2(
							$author$project$Components$Parametrage$Common$Conception$drawerSection,
							A2($author$project$I18n$Cles$pipeEtape5LignesTitre, i18n, nom),
							_Utils_ap(
								_List_fromArray(
									[
										A5(
										$author$project$Components$Parametrage$Common$Conception$caseACocher,
										'lignes-importables',
										!_Utils_eq(r.Ay, $elm$core$Maybe$Nothing),
										$author$project$I18n$Cles$pipeEtape5LignesAccepter(i18n),
										$author$project$I18n$Cles$pipeEtape5LignesAccepterAide(i18n),
										$author$project$Components$Parametrage$PipeEtape5$Update$LignesImportablesBascule)
									]),
								_Utils_ap(
									function () {
										var _v0 = r.Ay;
										if (!_v0.$) {
											var mode = _v0.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('sous-titre')
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	$author$project$I18n$Cles$pipeEtape5LignesDejaSaisies(i18n))
																]))
														])),
													A6(
													$author$project$Components$Parametrage$Common$Conception$choix,
													'lignes-deja-saisies',
													'ajouter',
													mode === 'ajouter',
													$author$project$I18n$Cles$pipeEtape5LignesAjouter(i18n),
													$author$project$I18n$Cles$pipeEtape5LignesAjouterAide(i18n),
													$author$project$Components$Parametrage$PipeEtape5$Update$ImportDesLignesChoisi('ajouter')),
													A6(
													$author$project$Components$Parametrage$Common$Conception$choix,
													'lignes-deja-saisies',
													'remplacer',
													mode === 'remplacer',
													$author$project$I18n$Cles$pipeEtape5LignesRemplacer(i18n),
													$author$project$I18n$Cles$pipeEtape5LignesRemplacerAide(i18n),
													$author$project$Components$Parametrage$PipeEtape5$Update$ImportDesLignesChoisi('remplacer'))
												]);
										} else {
											return _List_Nil;
										}
									}(),
									_Utils_ap(
										_List_fromArray(
											[
												A3($author$project$Components$Parametrage$PipeEtape5$View$colonnesDeLaGrille, i18n, saisie.J$, r.j1)
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2($author$project$I18n$Cles$pipeEtape5LignesFeuille, i18n, nom))
													]))
											])))))
						]) : _List_Nil
					])));
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$CommentaireDeValidationChoisi = function (a) {
	return {$: 43, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$FormulaireDeValidationChoisi = function (a) {
	return {$: 42, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$ValidateurChoisi = function (a) {
	return {$: 27, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$ValidationBasculee = function (a) {
	return {$: 26, a: a};
};
var $author$project$I18n$Cles$pipeEtape5ValidationAValiderPar = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.validation.a-valider-par',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'À valider par ' + p.bi);
	});
var $author$project$Components$Parametrage$PipeEtape5$View$aValiderPar = F3(
	function (i18n, formulaire, roleUid) {
		var _v0 = A2($author$project$Components$Parametrage$PipeEtape5$View$roleDe, formulaire.o_.Kr, roleUid);
		if (!_v0.$) {
			var role = _v0.a;
			return A2(
				$author$project$I18n$Cles$pipeEtape5ValidationAValiderPar,
				i18n,
				{
					bi: A2($author$project$Catalogue$Formes$avecUn, role.m$, role.Bl)
				});
		} else {
			return '';
		}
	});
var $author$project$I18n$Cles$pipeEtape5ValidationAncienne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.validation.ancienne', _List_Nil, 'l\'ancienne valeur');
};
var $author$project$I18n$Cles$pipeEtape5ValidationAncienneChoix = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.validation.ancienne.choix', _List_Nil, 'l\'ancien choix');
};
var $author$project$I18n$Cles$pipeEtape5ValidationAncienneDate = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.validation.ancienne.date', _List_Nil, 'l\'ancienne date');
};
var $author$project$I18n$Cles$pipeEtape5ValidationAncienneNombre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.validation.ancienne.nombre', _List_Nil, 'l\'ancien nombre');
};
var $author$project$I18n$Cles$pipeEtape5ValidationAncienneTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.validation.ancienne.texte', _List_Nil, 'l\'ancien texte');
};
var $author$project$Components$Parametrage$Vocabulaire$ancienneValeur = F2(
	function (i18n, code) {
		switch (code) {
			case 'date':
				return $author$project$I18n$Cles$pipeEtape5ValidationAncienneDate(i18n);
			case 'texte':
				return $author$project$I18n$Cles$pipeEtape5ValidationAncienneTexte(i18n);
			case 'texte-long':
				return $author$project$I18n$Cles$pipeEtape5ValidationAncienneTexte(i18n);
			case 'nombre':
				return $author$project$I18n$Cles$pipeEtape5ValidationAncienneNombre(i18n);
			case 'choix':
				return $author$project$I18n$Cles$pipeEtape5ValidationAncienneChoix(i18n);
			default:
				return $author$project$I18n$Cles$pipeEtape5ValidationAncienne(i18n);
		}
	});
var $author$project$I18n$Choix$codePronom = function (choix) {
	if (!choix) {
		return 'elle';
	} else {
		return 'il';
	}
};
var $author$project$I18n$Cles$pipeEtape5ValidationAide = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.validation.aide',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'pronom',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codePronom(p.Gu))),
					_Utils_Tuple2(
					'ancienne',
					$author$project$I18n$Traductions$Chaine(p.iN)),
					_Utils_Tuple2(
					'article',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeArticle(p.i4))),
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Tant qu\'' + (function () {
				var _v0 = p.Gu;
				if (!_v0) {
					return 'elle';
				} else {
					return 'il';
				}
			}() + (' n\'a pas validé, la fiche garde ' + (p.iN + ('. La réponse ' + (function () {
				var _v1 = p.i4;
				switch (_v1) {
					case 0:
						return '';
					case 1:
						return 'de l\'' + $elm$core$String$toLower(p.bi);
					case 2:
						return 'de la ' + $elm$core$String$toLower(p.bi);
					case 3:
						return 'du ' + $elm$core$String$toLower(p.bi);
					default:
						return 'de ' + p.bi;
				}
			}() + ' reste visible dans la tâche.'))))));
	});
var $author$project$I18n$Choix$PronomElle = 0;
var $author$project$I18n$Choix$PronomIl = 1;
var $author$project$Catalogue$Formes$pronomDe = function (formes) {
	var _v0 = A2(
		$elm$core$Maybe$map,
		function (lues) {
			return lues.zX.M;
		},
		formes);
	if ((!_v0.$) && (_v0.a === 1)) {
		var _v1 = _v0.a;
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Components$Parametrage$PipeEtape5$Phrases$aideDeLaValidation = F4(
	function (i18n, formulaire, typeDeChamp, validateur) {
		return A2(
			$author$project$I18n$Cles$pipeEtape5ValidationAide,
			i18n,
			{
				iN: A2($author$project$Components$Parametrage$Vocabulaire$ancienneValeur, i18n, typeDeChamp),
				i4: $author$project$Components$Parametrage$PipeEtape5$Phrases$ficheVisee(formulaire).i4,
				Gu: $author$project$Catalogue$Formes$pronomDe(validateur.m$),
				bi: $author$project$Components$Parametrage$PipeEtape5$Phrases$ficheVisee(formulaire).bi
			});
	});
var $author$project$I18n$Cles$pipeEtape5ValidationCommentaireFacultatif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.validation.commentaire-facultatif', _List_Nil, 'Commentaire facultatif');
};
var $author$project$I18n$Cles$pipeEtape5ValidationCommentaireFacultatifAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.validation.commentaire-facultatif-aide', _List_Nil, 'Celui qui valide peut accepter ou refuser sans rien écrire.');
};
var $author$project$I18n$Cles$pipeEtape5ValidationCommentaireObligatoire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.validation.commentaire-obligatoire', _List_Nil, 'Commentaire obligatoire');
};
var $author$project$I18n$Cles$pipeEtape5ValidationCommentaireObligatoireAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.validation.commentaire-obligatoire-aide', _List_Nil, 'Celui qui valide écrit un commentaire pour accepter ou refuser.');
};
var $author$project$I18n$Cles$pipeEtape5ValidationFormulaire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.validation.formulaire', _List_Nil, 'Formulaire de validation');
};
var $author$project$I18n$Cles$pipeEtape5ValidationReportAttend = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.validation.report-attend', _List_Nil, 'Le report sur la fiche attend une validation');
};
var $author$project$I18n$Cles$pipeEtape5ValidationTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.validation.titre', _List_Nil, 'Avant d\'écrire sur la fiche');
};
var $author$project$Components$Parametrage$PipeEtape5$View$premierValidateur = function (saisie) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.r8;
			},
			$elm$core$List$head(saisie.B1.o_.Kr)));
};
var $author$project$Components$Parametrage$PipeEtape5$View$validation = F3(
	function (i18n, saisie, champ) {
		if ((champ.xw === 'va-sur-la-fiche-visee') || (champ.xw === 'va-sur-la-fiche-d-un-autre-role')) {
			var validateur = A2(
				$elm$core$Maybe$andThen,
				$author$project$Components$Parametrage$PipeEtape5$View$roleDe(saisie.B1.o_.Kr),
				champ.sI);
			var titre = function () {
				var _v3 = saisie.B1.o_.Kr;
				if (!_v3.b) {
					return $author$project$I18n$Cles$pipeEtape5ValidationReportAttend(i18n);
				} else {
					return A3(
						$author$project$Components$Parametrage$PipeEtape5$View$aValiderPar,
						i18n,
						saisie.B1,
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Components$Parametrage$PipeEtape5$View$premierValidateur(saisie),
							champ.sI));
				}
			}();
			var attend = (!_Utils_eq(champ.sI, $elm$core$Maybe$Nothing)) || (!_Utils_eq(champ.qc.Kt, $elm$core$Maybe$Nothing));
			return A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape5ValidationTitre(i18n),
				A2(
					$elm$core$List$cons,
					A4($author$project$Components$Parametrage$Common$Conception$caseSimple, 'validation', attend, titre, $author$project$Components$Parametrage$PipeEtape5$Update$ValidationBasculee),
					_Utils_ap(
						function () {
							if (!validateur.$) {
								var role = validateur.a;
								return _List_fromArray(
									[
										A4(
										$author$project$Components$Parametrage$Common$Conception$liste,
										$author$project$I18n$Cles$pipeEtape5ValidationQui(i18n),
										role.r8,
										A2(
											$elm$core$List$map,
											function (v) {
												return _Utils_Tuple2(v.r8, v.Bl);
											},
											saisie.B1.o_.Kr),
										$author$project$Components$Parametrage$PipeEtape5$Update$ValidateurChoisi),
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('description'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('encart')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A4($author$project$Components$Parametrage$PipeEtape5$Phrases$aideDeLaValidation, i18n, saisie.B1, champ.B0.r0, role))
											]))
									]);
							} else {
								return _List_Nil;
							}
						}(),
						function () {
							var _v1 = champ.qc.Kt;
							if (!_v1.$) {
								var report = _v1.a;
								return _List_fromArray(
									[
										A4(
										$author$project$Components$Parametrage$Common$Conception$liste,
										$author$project$I18n$Cles$pipeEtape5ValidationFormulaire(i18n),
										report.zT,
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2('', ''),
											A2(
												$elm$core$List$map,
												function (_v2) {
													var uid = _v2.a;
													var libelles = _v2.b;
													return _Utils_Tuple2(
														uid,
														$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(libelles));
												},
												saisie.fF)),
										$author$project$Components$Parametrage$PipeEtape5$Update$FormulaireDeValidationChoisi),
										A6(
										$author$project$Components$Parametrage$Common$Conception$choix,
										'commentaire-de-validation',
										'facultatif',
										report.vM === 'facultatif',
										$author$project$I18n$Cles$pipeEtape5ValidationCommentaireFacultatif(i18n),
										$author$project$I18n$Cles$pipeEtape5ValidationCommentaireFacultatifAide(i18n),
										$author$project$Components$Parametrage$PipeEtape5$Update$CommentaireDeValidationChoisi('facultatif')),
										A6(
										$author$project$Components$Parametrage$Common$Conception$choix,
										'commentaire-de-validation',
										'obligatoire',
										report.vM === 'obligatoire',
										$author$project$I18n$Cles$pipeEtape5ValidationCommentaireObligatoire(i18n),
										$author$project$I18n$Cles$pipeEtape5ValidationCommentaireObligatoireAide(i18n),
										$author$project$Components$Parametrage$PipeEtape5$Update$CommentaireDeValidationChoisi('obligatoire'))
									]);
							} else {
								return _List_Nil;
							}
						}())));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$PipeEtape5$View$reglageDuChamp = F4(
	function (i18n, code, saisie, champ) {
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$author$project$Components$Parametrage$Common$Conception$drawerSection,
					A2(
						$author$project$I18n$Cles$pipeEtape5ChampTitre,
						i18n,
						{
							Dj: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(champ.R)
						}),
					_Utils_ap(
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('dans-la-reponse')
									]),
								A2(
									$elm$core$List$cons,
									A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('destination-reponse')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$strong,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$pipeEtape5DestinationReponseTitre(i18n))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$pipeEtape5DestinationReponseAide(i18n))
													]))
											])),
									A3($author$project$Components$Parametrage$PipeEtape5$View$destinationsEnPlus, i18n, saisie, champ)))
							]),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								A3($author$project$Components$Parametrage$PipeEtape5$View$destinationProposee, i18n, saisie, champ),
								A2(
									$elm$core$List$filter,
									function (c) {
										return _Utils_eq(c, champ.xw) && A2(
											$elm$core$List$member,
											c,
											_List_fromArray(
												['est-range-avec-les-documents', 'va-sur-la-ressource-liee']));
									},
									saisie.B1.o_.kM)),
							_Utils_ap(
								(champ.xw === 'va-sur-la-fiche-d-un-autre-role') ? _List_fromArray(
									[
										A4(
										$author$project$Components$Parametrage$Common$Conception$liste,
										$author$project$I18n$Cles$pipeEtape5ValidationQui(i18n),
										A2($elm$core$Maybe$withDefault, '', champ.H6),
										A2(
											$elm$core$List$map,
											function (role) {
												return _Utils_Tuple2(role.r8, role.Bl);
											},
											saisie.B1.o_.eX),
										$author$project$Components$Parametrage$PipeEtape5$Update$RoleDeLaFicheChoisi)
									]) : _List_Nil,
								(champ.xw === 'va-sur-la-ressource-liee') ? A3($author$project$Components$Parametrage$PipeEtape5$View$listesDeLaRessource, i18n, saisie, champ) : _List_Nil)))),
					(champ.B0.r0 === 'nombre') ? A4($author$project$Components$Parametrage$PipeEtape5$View$bornesDuNombre, i18n, champ.CD, champ.Cj, $author$project$Components$Parametrage$PipeEtape5$Update$BorneSaisie) : $rtfeldman$elm_css$Html$Styled$text(''),
					A3($author$project$Components$Parametrage$PipeEtape5$View$validation, i18n, saisie, champ)
				]),
			_Utils_ap(
				A3($author$project$Components$Parametrage$PipeEtape5$View$sectionsDImport, i18n, saisie, champ),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$author$project$Components$Parametrage$Common$Conception$drawerSection,
							A2(
								$author$project$I18n$Cles$pipeEtape5ObligationTitre,
								i18n,
								{
									Dj: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(champ.R)
								}),
							_List_fromArray(
								[
									A5(
									$author$project$Components$Parametrage$Common$Conception$caseACocher,
									'obligatoire',
									champ.he,
									$author$project$I18n$Cles$pipeEtape5ObligationEnvoyer(i18n),
									$author$project$I18n$Cles$pipeEtape5ObligationEnvoyerAide(i18n),
									$author$project$Components$Parametrage$PipeEtape5$Update$ObligatoireBascule),
									A5(
									$author$project$Components$Parametrage$Common$Conception$caseACocher,
									'requis-pour-passer',
									champ.qc.HM,
									$author$project$I18n$Cles$pipeEtape5ObligationPasser(i18n),
									$author$project$I18n$Cles$pipeEtape5ObligationPasserAide(i18n),
									$author$project$Components$Parametrage$PipeEtape5$Update$RequisPourPasserBascule)
								])),
							A3($author$project$Components$Parametrage$PipeEtape5$View$blocDePassage, i18n, code, saisie),
							A2(
							$author$project$Components$Parametrage$Common$Conception$drawerSection,
							$author$project$I18n$Cles$pipeEtape5SaisieTitre(i18n),
							_List_fromArray(
								[
									A4(
									$author$project$Components$Parametrage$Common$Conception$caseSimple,
									'visible',
									champ.KS,
									$author$project$I18n$Cles$pipeEtape5SaisieVisible(i18n),
									$author$project$Components$Parametrage$PipeEtape5$Update$VisibleSurLePortailBascule)
								]))
						]),
					(!_Utils_eq(
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerUnChampDeFormulaire, saisie.B1.nQ),
						$elm$core$Maybe$Nothing)) ? _List_fromArray(
						[
							A2(
							$author$project$Components$Parametrage$Common$Conception$drawerSection,
							$author$project$I18n$Cles$pipeEtape5RetraitChampSection(i18n),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer-champ'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Parametrage$PipeEtape5$Update$RetraitDeChampOuvert(champ.B0.r8))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$pipeEtape5RetraitChampBouton,
												i18n,
												{
													Dj: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(champ.R)
												}))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape5RetraitChampRestaurable(i18n))
										]))
								]))
						]) : _List_Nil)));
	});
var $author$project$Components$Parametrage$PipeEtape5$View$phraseDuBlocage = F2(
	function (i18n, champ) {
		return A3(
			$elm$core$Maybe$map2,
			F2(
				function (role, etape) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('encart')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$pipeEtape5ControleNonModifiable,
											i18n,
											{bi: role.Bl}))
									])),
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$pipeEtape5ControleDetail,
									i18n,
									{
										uN: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(champ.R),
										me: etape,
										bi: role.Bl
									}))
							]));
				}),
			champ.wb.bi,
			champ.wb.me);
	});
var $author$project$Components$Parametrage$PipeEtape5$View$sectionControleCroise = F3(
	function (i18n, code, saisie) {
		var _v0 = A2(
			$elm$core$List$filter,
			function (champ) {
				return champ.wb.ur;
			},
			saisie.B1.dw);
		if (!_v0.b) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var bloques = _v0;
			return A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape5ControleTitre(i18n),
				_Utils_ap(
					A2(
						$elm$core$List$filterMap,
						$author$project$Components$Parametrage$PipeEtape5$View$phraseDuBlocage(i18n),
						bloques),
					_List_fromArray(
						[
							A2(
							$elm$core$List$all,
							function (champ) {
								return _Utils_eq(champ.wb.KQ, $elm$core$Maybe$Nothing);
							},
							bloques) ? A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('ouvrir'),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape5ControleOuvrir(i18n))
								])) : A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('ouvrir'),
									$rtfeldman$elm_css$Html$Styled$Attributes$href(
									$author$project$Routes$Route$adressePipeEtape6(code))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape5ControleOuvrir(i18n))
								]))
						])));
		}
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$AjoutOuvert = {$: 59};
var $author$project$Components$Parametrage$PipeEtape5$Update$RetiresBascules = {$: 67};
var $author$project$I18n$Cles$pipeEtape5PastilleDossier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.pastille.dossier', _List_Nil, 'Dossier');
};
var $author$project$I18n$Cles$pipeEtape5PastilleFiche = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.pastille.fiche',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Fiche · ' + p.Dj);
	});
var $author$project$I18n$Cles$pipeEtape5PastilleFicheNouveau = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.pastille.fiche-nouveau',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Fiche · ' + (p.Dj + ' (nouveau)'));
	});
var $author$project$I18n$Cles$pipeEtape5PastilleReponse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.pastille.reponse', _List_Nil, 'Réponse');
};
var $author$project$Components$Parametrage$Vocabulaire$teinteDeLaDestination = function (code) {
	switch (code) {
		case 'va-sur-la-fiche-visee':
			return 'bleu';
		case 'reste-sur-le-dossier':
			return 'vert';
		case 'va-sur-la-fiche-d-un-autre-role':
			return 'violet';
		case 'est-range-avec-les-documents':
			return 'turquoise';
		default:
			return '';
	}
};
var $author$project$Components$Parametrage$PipeEtape5$View$destinationEnPastilles = F3(
	function (i18n, lue, champ) {
		var pastille = F2(
			function (teinte, texte) {
				return _Utils_Tuple2(teinte, texte);
			});
		var d = champ.xw;
		var nomDeLaFiche = function () {
			var _v1 = _Utils_Tuple2(
				d.Bl,
				$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(champ.R));
			if (!_v1.a.$) {
				var libelle = _v1.a.a;
				return ((!_Utils_eq(
					$elm$core$Maybe$Just(libelle),
					d.uN)) || ($author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(champ.R) === '')) ? libelle : $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(champ.R);
			} else {
				if (_v1.b === '') {
					var _v2 = _v1.a;
					return A2($elm$core$Maybe$withDefault, '', d.uN);
				} else {
					var _v3 = _v1.a;
					var propre = _v1.b;
					return propre;
				}
			}
		}();
		var _v0 = d.r0;
		switch (_v0) {
			case 'reste-dans-la-reponse':
				return A2(
					$elm$core$List$cons,
					A2(
						pastille,
						'',
						$author$project$I18n$Cles$pipeEtape5PastilleReponse(i18n)),
					d.xI ? _List_fromArray(
						[
							A2(
							pastille,
							'vert',
							$author$project$I18n$Cles$pipeEtape5PastilleDossier(i18n))
						]) : _List_Nil);
			case 'va-sur-la-fiche-visee':
				return _Utils_ap(
					_List_fromArray(
						[
							A2(
							pastille,
							'',
							$author$project$I18n$Cles$pipeEtape5PastilleReponse(i18n)),
							A2(
							pastille,
							'bleu',
							d.y0 ? A2(
								$author$project$I18n$Cles$pipeEtape5PastilleFiche,
								i18n,
								{Dj: nomDeLaFiche}) : A2(
								$author$project$I18n$Cles$pipeEtape5PastilleFicheNouveau,
								i18n,
								{Dj: nomDeLaFiche}))
						]),
					d.xI ? _List_fromArray(
						[
							A2(
							pastille,
							'vert',
							$author$project$I18n$Cles$pipeEtape5PastilleDossier(i18n))
						]) : _List_Nil);
			case 'reste-sur-le-dossier':
				return _List_fromArray(
					[
						A2(
						pastille,
						'',
						$author$project$I18n$Cles$pipeEtape5PastilleReponse(i18n)),
						A2(
						pastille,
						'vert',
						$author$project$I18n$Cles$pipeEtape5PastilleDossier(i18n))
					]);
			default:
				return A2(
					$elm$core$List$cons,
					A2(
						pastille,
						$author$project$Components$Parametrage$Vocabulaire$teinteDeLaDestination(d.r0),
						A3($author$project$Components$Parametrage$PipeEtape5$View$phraseDeDestination, i18n, lue, d)),
					d.xI ? _List_fromArray(
						[
							A2(
							pastille,
							'vert',
							$author$project$I18n$Cles$pipeEtape5PastilleDossier(i18n))
						]) : _List_Nil);
		}
	});
var $author$project$I18n$Cles$pipeEtape5RetiresRestaurer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.retires.restaurer', _List_Nil, 'Restaurer');
};
var $author$project$I18n$Cles$pipeEtape5RetiresRetireLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.retires.retire-le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retiré le ' + (p.wv + (' par ' + p.Dj)));
	});
var $author$project$I18n$Cles$pipeEtape5RetiresRetireLeSeul = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.retires.retire-le-seul',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Retiré le ' + p.wv);
	});
var $author$project$I18n$Cles$pipeEtape5ChampTypePlusieursFichiers = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.champ-type.plusieurs-fichiers',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.Dj + ' · plusieurs fichiers');
	});
var $author$project$Components$Parametrage$PipeEtape5$View$typeAffiche = F3(
	function (i18n, lue, champ) {
		var plusieurs = A2(
			$elm$core$List$any,
			function (c) {
				return _Utils_eq(
					$elm$core$Maybe$Just(c.vx),
					champ.xw.uN) && c.FS;
			},
			A2($elm$core$Maybe$withDefault, _List_Nil, lue.o_.uV));
		var base = A2($author$project$Components$Parametrage$Vocabulaire$typeDeChamp, i18n, champ.r0);
		return (A2(
			$elm$core$List$member,
			champ.r0,
			_List_fromArray(
				['fichier', 'image'])) && plusieurs) ? A2(
			$author$project$I18n$Cles$pipeEtape5ChampTypePlusieursFichiers,
			i18n,
			{Dj: base}) : base;
	});
var $author$project$Components$Parametrage$PipeEtape5$View$ligneDeChampRetire = F3(
	function (i18n, saisie, champ) {
		var retire = function () {
			var _v0 = champ.H_;
			if (!_v0.$) {
				var le = _v0.a;
				var _v1 = champ.H$;
				if (!_v1.$) {
					var nom = _v1.a;
					return A2(
						$author$project$I18n$Cles$pipeEtape5RetiresRetireLe,
						i18n,
						{
							wv: A2(
								$author$project$Texte$Jour$horodateALHeure,
								i18n,
								$author$project$Texte$Jour$instantDeParis(le)),
							Dj: nom
						});
				} else {
					return A2(
						$author$project$I18n$Cles$pipeEtape5RetiresRetireLeSeul,
						i18n,
						{
							wv: A2(
								$author$project$Texte$Jour$horodateALHeure,
								i18n,
								$author$project$Texte$Jour$instantDeParis(le))
						});
				}
			} else {
				return '';
			}
		}();
		var destination = A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$second,
				A3($author$project$Components$Parametrage$PipeEtape5$View$destinationEnPastilles, i18n, saisie.B1, champ)));
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('champ-retire')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('textes')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(champ.R))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('type')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											' · ' + A3($author$project$Components$Parametrage$PipeEtape5$View$typeAffiche, i18n, saisie.B1, champ))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('retire-le')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$elm$core$String$join,
										' · ',
										A2(
											$elm$core$List$filter,
											function (t) {
												return t !== '';
											},
											_List_fromArray(
												[retire, destination]))))
								]))
						])),
					(!_Utils_eq(
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$restaurerUnChampDeFormulaire, saisie.B1.nQ),
					$elm$core$Maybe$Nothing)) ? A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('restaurer'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Parametrage$PipeEtape5$Update$ChampRestaure(champ.r8))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape5RetiresRestaurer(i18n))
						])) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$I18n$Cles$pipeEtape5RetiresAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.retires.aide', _List_Nil, 'Un champ restauré revient en dernier, avec ses réglages. Aucune confirmation : rien ne se perd.');
};
var $author$project$I18n$Cles$pipeEtape5RetiresMasquer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.retires.masquer', _List_Nil, 'Masquer les champs retirés');
};
var $author$project$I18n$Cles$pipeEtape5RetiresTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.retires.titre', _List_Nil, 'Champs retirés');
};
var $author$project$I18n$Cles$pipeEtape5RetiresVoir = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.retires.voir',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Voir les champs retirés (' + (p.w + ')'));
	});
var $author$project$Components$Parametrage$PipeEtape5$View$champsRetires = F2(
	function (i18n, saisie) {
		if ($elm$core$List$isEmpty(saisie.B1.u1)) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var bascule = A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('voir-retires'),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-expanded',
						saisie.qK ? 'true' : 'false'),
						$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape5$Update$RetiresBascules)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						saisie.qK ? $author$project$I18n$Cles$pipeEtape5RetiresMasquer(i18n) : A2(
							$author$project$I18n$Cles$pipeEtape5RetiresVoir,
							i18n,
							{
								w: $elm$core$String$fromInt(
									$elm$core$List$length(saisie.B1.u1))
							}))
					]));
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('champs-retires')
					]),
				saisie.qK ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h3,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape5RetiresTitre(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('champs')
							]),
						A2(
							$elm$core$List$map,
							A2($author$project$Components$Parametrage$PipeEtape5$View$ligneDeChampRetire, i18n, saisie),
							saisie.B1.u1)),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape5RetiresAide(i18n))
							])),
						bascule
					]) : _List_fromArray(
					[bascule]));
		}
	});
var $author$project$Components$Parametrage$PipeEtape5$View$ficheViseeDuPipe = F2(
	function (i18n, lue) {
		var valeur = function () {
			var _v1 = _Utils_Tuple2(lue.C3, lue.zt);
			if (!_v1.a.$) {
				if (!_v1.b.$) {
					var nature = _v1.a.a;
					var fiche = _v1.b.a;
					return $elm$core$Maybe$Just(
						A2(
							$author$project$I18n$Cles$pipeEtape5FicheViseeValeur,
							i18n,
							{
								g1: A2($author$project$Components$Parametrage$Vocabulaire$natureDeLaFicheVisee, i18n, nature),
								bi: fiche.Bl
							}));
				} else {
					var nature = _v1.a.a;
					var _v2 = _v1.b;
					return $elm$core$Maybe$Just(
						A2($author$project$Components$Parametrage$Vocabulaire$natureDeLaFicheVisee, i18n, nature));
				}
			} else {
				if (!_v1.b.$) {
					var _v3 = _v1.a;
					var fiche = _v1.b.a;
					return $elm$core$Maybe$Just(fiche.Bl);
				} else {
					var _v4 = _v1.a;
					var _v5 = _v1.b;
					return $elm$core$Maybe$Nothing;
				}
			}
		}();
		if (!valeur.$) {
			var texte = valeur.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('fiche-visee')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape5FicheViseeTitre(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(texte)
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$ChampChoisi = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$View$pastillesDeDestination = F3(
	function (i18n, lue, champ) {
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var teinte = _v0.a;
				var texte = _v0.b;
				return A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class(teinte)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(texte)
						]));
			},
			A3($author$project$Components$Parametrage$PipeEtape5$View$destinationEnPastilles, i18n, lue, champ));
	});
var $author$project$I18n$Cles$pipeEtape5ControlePrerempli = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.controle.prerempli', _List_Nil, 'Pré-rempli');
};
var $author$project$I18n$Cles$pipeEtape5PastilleRequisPourPasser = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.pastille.requis-pour-passer', _List_Nil, 'Requis pour passer');
};
var $author$project$Components$Parametrage$PipeEtape5$View$ligneDeChamp = F3(
	function (i18n, saisie, champ) {
		var ouvert = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (choisi) {
					return _Utils_eq(choisi.B0.r8, champ.r8);
				},
				saisie.uN));
		var contenu = _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(champ.R))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('type')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A3($author$project$Components$Parametrage$PipeEtape5$View$typeAffiche, i18n, saisie.B1, champ))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('pastilles')
					]),
				_Utils_ap(
					A3($author$project$Components$Parametrage$PipeEtape5$View$pastillesDeDestination, i18n, saisie.B1, champ),
					_Utils_ap(
						champ.HM ? _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape5PastilleRequisPourPasser(i18n))
									]))
							]) : _List_Nil,
						_Utils_ap(
							function () {
								var _v0 = champ.sI;
								if (!_v0.$) {
									var roleUid = _v0.a;
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille'),
													$rtfeldman$elm_css$Html$Styled$Attributes$class('ambre')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A3($author$project$Components$Parametrage$PipeEtape5$View$aValiderPar, i18n, saisie.B1, roleUid))
												]))
										]);
								} else {
									return _List_Nil;
								}
							}(),
							_Utils_ap(
								champ.Gi ? _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$pipeEtape5ControlePrerempli(i18n))
											]))
									]) : _List_Nil,
								champ.wb.ur ? _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('rouge')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$pipeEtape5ControleBloque(i18n))
											]))
									]) : _List_Nil)))))
			]);
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'champ-vise',
							_Utils_eq(
								saisie.eW,
								$elm$core$Maybe$Just(champ.r8)))
						]))
				]),
			_List_fromArray(
				[
					(saisie.B1.g_ && (champ.r0 !== 'calcule')) ? A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('champ-carte', true),
									_Utils_Tuple2('ouvert', ouvert)
								])),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Parametrage$PipeEtape5$Update$ChampChoisi(champ.r8))
						]),
					contenu) : A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('champ-carte', true),
									_Utils_Tuple2('inerte', true)
								]))
						]),
					contenu)
				]));
	});
var $author$project$I18n$Cles$pipeEtape5ChampsAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.champs.aide', _List_Nil, 'Chaque champ garde sa réponse ; il peut aussi aller sur la fiche visée par le pipe et dans le dossier. Touchez un champ pour le régler.');
};
var $author$project$I18n$Cles$pipeEtape5ChampsAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.champs.ajouter', _List_Nil, 'Ajouter : Champ');
};
var $author$project$I18n$Cles$pipeEtape5ChampsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.champs.titre', _List_Nil, 'Les champs');
};
var $author$project$I18n$Cles$pipeEtape5NoteTypeVoirLaSaisie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.type.voir-la-saisie', _List_Nil, 'Voir la saisie');
};
var $author$project$Components$Parametrage$PipeEtape5$View$voirLaSaisie = F3(
	function (i18n, code, formulaire) {
		var _v0 = formulaire.kM;
		if (!_v0.$) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('renommer'),
						$rtfeldman$elm_css$Html$Styled$Attributes$href(
						A2($author$project$Routes$Route$adresseDestinationsDesChamps, code, formulaire.r8))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$pipeEtape5NoteTypeVoirLaSaisie(i18n))
					]));
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('renommer'),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$pipeEtape5NoteTypeVoirLaSaisie(i18n))
					]));
		}
	});
var $author$project$Components$Parametrage$PipeEtape5$View$sectionDesChamps = F3(
	function (i18n, code, saisie) {
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape5ChampsTitre(i18n),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape5ChampsAide(i18n))
						])),
					A2($author$project$Components$Parametrage$PipeEtape5$View$ficheViseeDuPipe, i18n, saisie.B1),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('champs')
						]),
					A2(
						$elm$core$List$map,
						A2($author$project$Components$Parametrage$PipeEtape5$View$ligneDeChamp, i18n, saisie),
						saisie.B1.dw)),
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout'),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
							_Utils_eq(
								A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ajouterUnChampDeFormulaire, saisie.B1.nQ),
								$elm$core$Maybe$Nothing)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape5$Update$AjoutOuvert)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape5ChampsAjouter(i18n))
						])),
					A2($author$project$Components$Parametrage$PipeEtape5$View$champsRetires, i18n, saisie),
					A3($author$project$Components$Parametrage$PipeEtape5$View$voirLaSaisie, i18n, code, saisie.B1)
				]));
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$RenommageOuvert = {$: 7};
var $author$project$I18n$Cles$pipeEtape5NomAutreLangue = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.nom.autre-langue',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'langue',
					$author$project$I18n$Traductions$Chaine(p.nn)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.nn + (' : ' + p.Dj));
	});
var $author$project$I18n$Cles$pipeEtape5NomRenommer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.nom.renommer', _List_Nil, 'Renommer');
};
var $author$project$Components$Parametrage$PipeEtape5$View$sectionDuNom = F2(
	function (i18n, saisie) {
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape4NomTitre(i18n),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('carte-traduction')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('textes')
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(saisie.B1.R))
										])),
								A2(
									$elm$core$List$map,
									function (langue) {
										return A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('langue')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$author$project$I18n$Cles$pipeEtape5NomAutreLangue,
														i18n,
														{
															nn: A2($author$project$Referentiel$Langues$nom, i18n, langue.vx),
															Dj: A2(
																$elm$core$Maybe$withDefault,
																$author$project$I18n$Cles$pipeEtape2TraductionARenseigner(i18n),
																A2($elm$core$Dict$get, langue.vx, saisie.B1.R))
														}))
												]));
									},
									A2(
										$elm$core$List$filter,
										function (langue) {
											return langue.vx !== 'fr';
										},
										$author$project$Referentiel$Langues$desLibelles)))),
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('renommer'),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
									_Utils_eq(
										A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$renommerUnFormulaire, saisie.B1.nQ),
										$elm$core$Maybe$Nothing)),
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape5$Update$RenommageOuvert)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape5NomRenommer(i18n))
								]))
						]))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$ImportBascule = function (a) {
	return {$: 44, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$ImportParLesPortailsBascule = function (a) {
	return {$: 46, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$UneLigneEstChoisie = function (a) {
	return {$: 45, a: a};
};
var $author$project$I18n$Cles$pipeEtape5ImportAccepter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.import.accepter', _List_Nil, 'Ce formulaire accepte un import de fichier');
};
var $author$project$I18n$Cles$pipeEtape5ImportAccepterAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.import.accepter-aide', _List_Nil, 'CSV ou Excel (.xlsx). Le déposant choisit un fichier, puis suit la correspondance des colonnes, la simulation et le rapport.');
};
var $author$project$I18n$Cles$pipeEtape5ImportAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.import.aide', _List_Nil, 'Les utilisateurs du pipe, y compris ceux d\'un portail, peuvent déposer un fichier au lieu de tout saisir.');
};
var $author$project$I18n$Cles$pipeEtape5ImportDossierOuvert = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.import.dossier-ouvert', _List_Nil, 'Une ligne du fichier est un dossier déjà ouvert');
};
var $author$project$I18n$Cles$pipeEtape5ImportDossierOuvertAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.import.dossier-ouvert-aide', _List_Nil, 'La colonne « Référence » identifie le dossier ; les réponses s\'enregistrent sur lui (par exemple 40 fiches techniques d\'un coup).');
};
var $author$project$I18n$Cles$pipeEtape5ImportNouveauDossier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.import.nouveau-dossier', _List_Nil, 'Une ligne du fichier est un nouveau dossier');
};
var $author$project$I18n$Cles$pipeEtape5ImportNouveauDossierAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.import.nouveau-dossier-aide', _List_Nil, 'Chaque ligne ouvre un dossier de ce pipe. La fiche visée est créée en brouillon, ou retrouvée si sa référence existe déjà. Les réponses sont enregistrées selon la destination de chaque champ.');
};
var $author$project$I18n$Cles$pipeEtape5ImportPortails = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.import.portails', _List_Nil, 'Les visiteurs des portails qui servent ce pipe peuvent aussi importer');
};
var $author$project$I18n$Cles$pipeEtape5ImportTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.import.titre', _List_Nil, 'Remplir par import');
};
var $author$project$Components$Parametrage$PipeEtape5$View$sectionImportDuFormulaire = F2(
	function (i18n, saisie) {
		return (saisie.B1.g_ && (!_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reglerLImport, saisie.B1.nQ),
			$elm$core$Maybe$Nothing))) ? A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape5ImportTitre(i18n),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape5ImportAide(i18n))
							])),
						A5(
						$author$project$Components$Parametrage$Common$Conception$caseACocher,
						'import-du-formulaire',
						!_Utils_eq(saisie.bJ, $elm$core$Maybe$Nothing),
						$author$project$I18n$Cles$pipeEtape5ImportAccepter(i18n),
						$author$project$I18n$Cles$pipeEtape5ImportAccepterAide(i18n),
						$author$project$Components$Parametrage$PipeEtape5$Update$ImportBascule)
					]),
				function () {
					var _v0 = saisie.bJ;
					if (!_v0.$) {
						var importation = _v0.a;
						return _List_fromArray(
							[
								A6(
								$author$project$Components$Parametrage$Common$Conception$choix,
								'une-ligne-est',
								'nouveau-dossier',
								importation.J7 === 'nouveau-dossier',
								$author$project$I18n$Cles$pipeEtape5ImportNouveauDossier(i18n),
								$author$project$I18n$Cles$pipeEtape5ImportNouveauDossierAide(i18n),
								$author$project$Components$Parametrage$PipeEtape5$Update$UneLigneEstChoisie('nouveau-dossier')),
								A6(
								$author$project$Components$Parametrage$Common$Conception$choix,
								'une-ligne-est',
								'dossier-ouvert',
								importation.J7 === 'dossier-ouvert',
								$author$project$I18n$Cles$pipeEtape5ImportDossierOuvert(i18n),
								$author$project$I18n$Cles$pipeEtape5ImportDossierOuvertAide(i18n),
								$author$project$Components$Parametrage$PipeEtape5$Update$UneLigneEstChoisie('dossier-ouvert')),
								A5(
								$author$project$Components$Parametrage$Common$Conception$caseACocher,
								'import-par-les-portails',
								importation.ER,
								$author$project$I18n$Cles$pipeEtape5ImportPortails(i18n),
								'',
								$author$project$Components$Parametrage$PipeEtape5$Update$ImportParLesPortailsBascule)
							]);
					} else {
						return _List_Nil;
					}
				}())) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$DuplicationDemandee = {$: 57};
var $author$project$I18n$Cles$pipeEtape5Dupliquer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.dupliquer', _List_Nil, 'Dupliquer en version suivante');
};
var $author$project$I18n$Cles$pipeEtape5UsageFige = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.usage.fige', _List_Nil, 'Une version publiée l\'utilise : il est figé. Dupliquez-le pour le modifier.');
};
var $author$project$I18n$Cles$pipeEtape5UsageModifiable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.usage.modifiable', _List_Nil, 'Aucune version publiée ne l\'utilise : vous pouvez le modifier.');
};
var $author$project$I18n$Cles$pipeEtape5UsageTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.usage-titre', _List_Nil, 'Où sert-il');
};
var $author$project$Components$Parametrage$PipeEtape5$View$sectionOuSert = F2(
	function (i18n, saisie) {
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape5UsageTitre(i18n),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[
										$elm$core$List$isEmpty(saisie.B1.IJ) ? '' : (A2($author$project$Components$Parametrage$PipeEtape5$View$usagesEnTexte, i18n, saisie.B1.IJ) + '.'),
										saisie.B1.g_ ? $author$project$I18n$Cles$pipeEtape5UsageModifiable(i18n) : $author$project$I18n$Cles$pipeEtape5UsageFige(i18n)
									])))
						])),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (_v0) {
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('dupliquer'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape5$Update$DuplicationDemandee)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape5Dupliquer(i18n))
										]))
								]);
						},
						A2(
							$elm$core$Maybe$andThen,
							function (lien) {
								return saisie.B1.g_ ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(lien);
							},
							A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$dupliquerUnFormulaire, saisie.B1.nQ))))));
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$RetraitDemande = {$: 58};
var $author$project$I18n$Cles$pipeEtape5RetirerBouton = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.retirer.bouton',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$pipeEtape5RetirerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.retirer.titre', _List_Nil, 'Retirer');
};
var $author$project$Components$Parametrage$PipeEtape5$View$sectionRetirer = F2(
	function (i18n, saisie) {
		var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerUnFormulaire, saisie.B1.nQ);
		if (!_v0.$) {
			return A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape5RetirerTitre(i18n),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape5$Update$RetraitDemande)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$pipeEtape5RetirerBouton,
									i18n,
									{
										Dj: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(saisie.B1.R)
									}))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$PipeEtape5$View$contenuDuFormulaire = F3(
	function (i18n, code, saisie) {
		return $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						A2($author$project$Components$Parametrage$PipeEtape5$View$sectionDuNom, i18n, saisie),
						A3($author$project$Components$Parametrage$PipeEtape5$View$sectionDesChamps, i18n, code, saisie),
						A3($author$project$Components$Parametrage$PipeEtape5$View$sectionControleCroise, i18n, code, saisie)
					]),
					saisie.B1.g_ ? A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A3($author$project$Components$Parametrage$PipeEtape5$View$reglageDuChamp, i18n, code, saisie),
						saisie.uN)) : _List_Nil,
					_List_fromArray(
					[
						A2($author$project$Components$Parametrage$PipeEtape5$View$sectionImportDuFormulaire, i18n, saisie),
						A2($author$project$Components$Parametrage$PipeEtape5$View$sectionOuSert, i18n, saisie),
						A2($author$project$Components$Parametrage$PipeEtape5$View$sectionRetirer, i18n, saisie)
					])
				]));
	});
var $author$project$I18n$Cles$pipeEtape5NotePoidsAvertissement = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.note.poids.avertissement',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'somme',
					$author$project$I18n$Traductions$Chaine(p.IO))
				]),
			'La somme des poids fait ' + (p.IO + ' % ; elle doit faire 100 %.'));
	});
var $author$project$Components$Parametrage$PipeEtape5$View$avertissementDesPoids = F2(
	function (i18n, notation) {
		return (notation.IP === 100) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('description'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('encart'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('avertissement')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2(
						$author$project$I18n$Cles$pipeEtape5NotePoidsAvertissement,
						i18n,
						{
							IO: $elm$core$String$fromInt(notation.IP)
						}))
				]));
	});
var $author$project$I18n$Cles$pipeEtape5NoteEncart1 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.encart.1', _List_Nil, 'Un rôle tenu par une relation peut remplir un formulaire noté (l\'avis chiffré du producteur). ');
};
var $author$project$I18n$Cles$pipeEtape5NoteEncart2 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.encart.2', _List_Nil, 'Le réglage de la tâche dit si sa note compte dans la moyenne');
};
var $author$project$I18n$Cles$pipeEtape5NoteEncart3 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.encart.3', _List_Nil, ' des évaluateurs.');
};
var $author$project$Components$Parametrage$PipeEtape5$Update$CommentaireBascule = F2(
	function (a, b) {
		return {$: 54, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$PoidsSaisi = F2(
	function (a, b) {
		return {$: 53, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$SeuilSaisi = F2(
	function (a, b) {
		return {$: 55, a: a, b: b};
	});
var $author$project$I18n$Cles$pipeEtape5NoteChampCommentaire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.champ.commentaire', _List_Nil, 'Commentaire obligatoire si la note est inférieure à un seuil');
};
var $author$project$I18n$Cles$pipeEtape5NoteChampPoids = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.champ.poids', _List_Nil, 'Poids dans la note (%)');
};
var $author$project$I18n$Cles$pipeEtape5NoteChampSeuil = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.champ.seuil', _List_Nil, 'Seuil');
};
var $author$project$I18n$Cles$pipeEtape5NoteChampTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.note.champ.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Champ « ' + (p.Dj + ' »'));
	});
var $author$project$Components$Parametrage$PipeEtape5$View$reglageDuChampNote = F3(
	function (i18n, saisie, notation) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (champ) {
				return A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(champ),
					A2($elm$core$Dict$get, champ.B0.r8, notation.qc));
			},
			saisie.uN);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var champ = _v1.a;
			var reglage = _v1.b;
			return A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				A2(
					$author$project$I18n$Cles$pipeEtape5NoteChampTitre,
					i18n,
					{
						Dj: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(champ.R)
					}),
				_List_fromArray(
					[
						A3(
						$author$project$Components$Parametrage$Common$Conception$champDeTexte,
						$author$project$I18n$Cles$pipeEtape5NoteChampPoids(i18n),
						reglage.FV,
						$author$project$Components$Parametrage$PipeEtape5$Update$PoidsSaisi(champ.B0.r8)),
						A4(
						$author$project$Components$Parametrage$Common$Conception$caseSimple,
						'commentaire',
						!_Utils_eq(reglage.IL, $elm$core$Maybe$Nothing),
						$author$project$I18n$Cles$pipeEtape5NoteChampCommentaire(i18n),
						$author$project$Components$Parametrage$PipeEtape5$Update$CommentaireBascule(champ.B0.r8)),
						A3(
						$author$project$Components$Parametrage$Common$Conception$champDeTexte,
						$author$project$I18n$Cles$pipeEtape5NoteChampSeuil(i18n),
						A2($elm$core$Maybe$withDefault, '', reglage.IL),
						$author$project$Components$Parametrage$PipeEtape5$Update$SeuilSaisi(champ.B0.r8))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$pipeEtape5NoteApercuTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.apercu.titre', _List_Nil, 'Aperçu pour un répondant');
};
var $author$project$Components$Parametrage$PipeEtape5$View$sectionApercuDuRepondant = F2(
	function (i18n, lue) {
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape5NoteApercuTitre(i18n),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('encart')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(lue.tq.Jx + ' '),
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(lue.tq.DR)
								]))
						]))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$AnonymesBascule = function (a) {
	return {$: 52, a: a};
};
var $author$project$Components$Parametrage$PipeEtape5$Update$NonVuBascule = function (a) {
	return {$: 51, a: a};
};
var $author$project$I18n$Cles$pipeEtape5NoteConfidentialiteAide = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.note.confidentialite.aide',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			'Anonymes, les statistiques ne s\'affichent qu\'à partir de ' + (p.d + ' réponses. Une grille d\'évaluation reste nominative.'));
	});
var $author$project$I18n$Cles$pipeEtape5NoteConfidentialiteAnonymes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.confidentialite.anonymes', _List_Nil, 'Réponses anonymes');
};
var $author$project$I18n$Cles$pipeEtape5NoteConfidentialiteNonVu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.confidentialite.non-vu', _List_Nil, 'Un répondant ne voit pas les réponses des autres avant d\'avoir répondu');
};
var $author$project$I18n$Cles$pipeEtape5NoteConfidentialiteTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.confidentialite.titre', _List_Nil, 'Confidentialité');
};
var $author$project$Components$Parametrage$PipeEtape5$View$sectionConfidentialite = F3(
	function (i18n, lue, notation) {
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape5NoteConfidentialiteTitre(i18n),
			_List_fromArray(
				[
					A4(
					$author$project$Components$Parametrage$Common$Conception$caseSimple,
					'non-vu',
					notation.el,
					$author$project$I18n$Cles$pipeEtape5NoteConfidentialiteNonVu(i18n),
					$author$project$Components$Parametrage$PipeEtape5$Update$NonVuBascule),
					A4(
					$author$project$Components$Parametrage$Common$Conception$caseSimple,
					'anonymes',
					notation.dn,
					$author$project$I18n$Cles$pipeEtape5NoteConfidentialiteAnonymes(i18n),
					$author$project$Components$Parametrage$PipeEtape5$Update$AnonymesBascule),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$pipeEtape5NoteConfidentialiteAide,
								i18n,
								{
									d: $elm$core$String$fromInt(lue.I_)
								}))
						]))
				]));
	});
var $author$project$I18n$Cles$pipeEtape5NoteCommentaireFacultatif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.commentaire.facultatif', _List_Nil, 'Commentaire facultatif');
};
var $author$project$I18n$Cles$pipeEtape5NoteCommentaireObligatoire = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.note.commentaire.obligatoire',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'seuil',
					$author$project$I18n$Traductions$Chaine(p.IL))
				]),
			'Commentaire obligatoire sous ' + p.IL);
	});
var $author$project$I18n$Cles$pipeEtape5NoteConversion = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.note.conversion',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'niveau',
					$author$project$I18n$Traductions$Chaine(p.os)),
					_Utils_Tuple2(
					'note',
					$author$project$I18n$Traductions$Chaine(p.oJ))
				]),
			p.os + (' = ' + p.oJ));
	});
var $author$project$I18n$Cles$pipeEtape5NotePoids = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.note.poids',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			'Poids ' + (p.d + ' %'));
	});
var $author$project$Components$Parametrage$PipeEtape5$View$pastillesDuChampNote = F2(
	function (i18n, note) {
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('violet')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$pipeEtape5NotePoids,
							i18n,
							{
								d: $elm$core$String$fromInt(note.FV)
							}))
					])),
				function () {
				var _v0 = _Utils_Tuple2(note.IL, note.wd);
				if (!_v0.a.$) {
					var seuil = _v0.a.a;
					return A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('ambre')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$pipeEtape5NoteCommentaireObligatoire,
									i18n,
									{
										IL: $elm$core$String$fromInt(seuil)
									}))
							]));
				} else {
					if (_v0.b.b) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$elm$core$String$join,
										', ',
										A2(
											$elm$core$List$map,
											function (_v3) {
												var niveau = _v3.a;
												var valeur = _v3.b;
												return A2(
													$author$project$I18n$Cles$pipeEtape5NoteConversion,
													i18n,
													{
														os: niveau,
														oJ: $elm$core$String$fromInt(valeur)
													});
											},
											note.wd)))
								]));
					} else {
						var _v4 = _v0.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape5NoteCommentaireFacultatif(i18n))
								]));
					}
				}
			}()
			]);
	});
var $author$project$I18n$Cles$pipeEtape5NoteChampSansNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.champ.sans-note', _List_Nil, 'Sans note');
};
var $author$project$I18n$Cles$pipeEtape5NoteChampNiveaux = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.note.champ.niveaux',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'debut',
					$author$project$I18n$Traductions$Chaine(p.ku)),
					_Utils_Tuple2(
					'fin',
					$author$project$I18n$Traductions$Chaine(p.mI)),
					_Utils_Tuple2(
					'min',
					$author$project$I18n$Traductions$Chaine(p.Cx)),
					_Utils_Tuple2(
					'max',
					$author$project$I18n$Traductions$Chaine(p.Cg))
				]),
			'Niveaux ' + (p.ku + (' à ' + (p.mI + (', convertis ' + (p.Cx + (' à ' + p.Cg)))))));
	});
var $author$project$I18n$Cles$pipeEtape5NoteChampNote = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.note.champ.note',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'min',
					$author$project$I18n$Traductions$Chaine(p.Cx)),
					_Utils_Tuple2(
					'max',
					$author$project$I18n$Traductions$Chaine(p.Cg))
				]),
			'Note, ' + (p.Cx + (' à ' + p.Cg)));
	});
var $author$project$Components$Parametrage$PipeEtape5$View$typeDuChampNote = F2(
	function (i18n, champ) {
		var _v0 = _Utils_Tuple2(
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.lK;
				},
				champ.oJ),
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.C9;
				},
				champ.oJ));
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var echelle = _v0.a.a;
				var niveaux = _v0.b.a;
				var _v1 = A2($elm$core$String$split, '-', niveaux);
				if ((_v1.b && _v1.b.b) && (!_v1.b.b.b)) {
					var debut = _v1.a;
					var _v2 = _v1.b;
					var fin = _v2.a;
					return A2(
						$author$project$I18n$Cles$pipeEtape5NoteChampNiveaux,
						i18n,
						{
							ku: debut,
							mI: fin,
							Cg: $elm$core$String$fromInt(echelle.Cg),
							Cx: $elm$core$String$fromInt(echelle.Cx)
						});
				} else {
					return A2($author$project$Components$Parametrage$Vocabulaire$typeDeChamp, i18n, champ.r0);
				}
			} else {
				var echelle = _v0.a.a;
				var _v3 = _v0.b;
				return A2(
					$author$project$I18n$Cles$pipeEtape5NoteChampNote,
					i18n,
					{
						Cg: $elm$core$String$fromInt(echelle.Cg),
						Cx: $elm$core$String$fromInt(echelle.Cx)
					});
			}
		} else {
			return A2($author$project$Components$Parametrage$Vocabulaire$typeDeChamp, i18n, champ.r0);
		}
	});
var $author$project$Components$Parametrage$PipeEtape5$View$ligneDeChampNote = F3(
	function (i18n, saisie, champ) {
		var ouvert = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (choisi) {
					return _Utils_eq(choisi.B0.r8, champ.r8);
				},
				saisie.uN));
		var contenu = _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(champ.R))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('type')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$Components$Parametrage$PipeEtape5$View$typeDuChampNote, i18n, champ))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('pastilles')
					]),
				function () {
					var _v0 = champ.oJ;
					if (!_v0.$) {
						var note = _v0.a;
						return A2($author$project$Components$Parametrage$PipeEtape5$View$pastillesDuChampNote, i18n, note);
					} else {
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape5NoteChampSansNote(i18n))
									]))
							]);
					}
				}())
			]);
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			_List_fromArray(
				[
					(!_Utils_eq(champ.oJ, $elm$core$Maybe$Nothing)) ? A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('champ-carte', true),
									_Utils_Tuple2('ouvert', ouvert)
								])),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Parametrage$PipeEtape5$Update$ChampChoisi(champ.r8))
						]),
					contenu) : A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('champ-carte', true),
									_Utils_Tuple2('inerte', true)
								]))
						]),
					contenu)
				]));
	});
var $author$project$I18n$Cles$pipeEtape5NoteChampsAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.champs.aide', _List_Nil, 'Chaque champ dit son poids dans la note et si un commentaire est exigé.');
};
var $author$project$Components$Parametrage$PipeEtape5$View$sectionDesChampsNotes = F2(
	function (i18n, saisie) {
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape5ChampsTitre(i18n),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape5NoteChampsAide(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('champs')
						]),
					A2(
						$elm$core$List$map,
						A2($author$project$Components$Parametrage$PipeEtape5$View$ligneDeChampNote, i18n, saisie),
						saisie.B1.dw)),
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout'),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape5ChampsAjouter(i18n))
						]))
				]));
	});
var $author$project$I18n$Cles$pipeEtape5NoteTypeAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.type.aide', _List_Nil, 'Les champs « Note » et « Niveaux » calculent une note.');
};
var $author$project$I18n$Cles$pipeEtape5NoteTypeLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.type.libelle', _List_Nil, 'Formulaire noté');
};
var $author$project$I18n$Cles$pipeEtape5NoteTypeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.type.titre', _List_Nil, 'Type');
};
var $author$project$Components$Parametrage$PipeEtape5$View$sectionDuType = F3(
	function (i18n, code, formulaire) {
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape5NoteTypeTitre(i18n),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('carte-traduction')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('textes')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape5NoteTypeLibelle(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('langue')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape5NoteTypeAide(i18n))
										]))
								])),
							A3($author$project$Components$Parametrage$PipeEtape5$View$voirLaSaisie, i18n, code, formulaire)
						]))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$EntreRepondantsChoisi = function (a) {
	return {$: 49, a: a};
};
var $author$project$I18n$Cles$pipeEtape5NoteEntreFormule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.entre.formule', _List_Nil, 'Formule');
};
var $author$project$I18n$Cles$pipeEtape5NoteEntreLaPlusBasse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.entre.la-plus-basse', _List_Nil, 'Note la plus basse');
};
var $author$project$I18n$Cles$pipeEtape5NoteEntreMediane = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.entre.mediane', _List_Nil, 'Médiane');
};
var $author$project$I18n$Cles$pipeEtape5NoteEntreMoyenne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.entre.moyenne', _List_Nil, 'Moyenne');
};
var $author$project$I18n$Cles$pipeEtape5NoteEntreMoyenneAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.entre.moyenne.aide', _List_Nil, 'Moyenne des notes des répondants.');
};
var $author$project$Components$Parametrage$Vocabulaire$entreRepondants = F2(
	function (i18n, code) {
		switch (code) {
			case 'moyenne':
				return _Utils_Tuple2(
					$author$project$I18n$Cles$pipeEtape5NoteEntreMoyenne(i18n),
					$author$project$I18n$Cles$pipeEtape5NoteEntreMoyenneAide(i18n));
			case 'mediane':
				return _Utils_Tuple2(
					$author$project$I18n$Cles$pipeEtape5NoteEntreMediane(i18n),
					'');
			case 'la-plus-basse':
				return _Utils_Tuple2(
					$author$project$I18n$Cles$pipeEtape5NoteEntreLaPlusBasse(i18n),
					'');
			case 'formule':
				return _Utils_Tuple2(
					$author$project$I18n$Cles$pipeEtape5NoteEntreFormule(i18n),
					'');
			default:
				var autre = code;
				return _Utils_Tuple2(autre, '');
		}
	});
var $author$project$I18n$Cles$pipeEtape5NoteEntreTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.entre.titre', _List_Nil, 'Entre plusieurs répondants');
};
var $author$project$Components$Parametrage$PipeEtape5$View$sectionEntreRepondants = F2(
	function (i18n, notation) {
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape5NoteEntreTitre(i18n),
			A2(
				$elm$core$List$map,
				function (code) {
					var _v0 = A2($author$project$Components$Parametrage$Vocabulaire$entreRepondants, i18n, code);
					var titre = _v0.a;
					var aide = _v0.b;
					return A6(
						$author$project$Components$Parametrage$Common$Conception$choix,
						'entre-repondants',
						code,
						_Utils_eq(notation.yu, code),
						titre,
						aide,
						$author$project$Components$Parametrage$PipeEtape5$Update$EntreRepondantsChoisi(code));
				},
				_List_fromArray(
					['moyenne', 'mediane', 'la-plus-basse', 'formule'])));
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$NoteDUneReponseChoisie = function (a) {
	return {$: 48, a: a};
};
var $author$project$I18n$Cles$pipeEtape5NoteReponseFormule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.reponse.formule', _List_Nil, 'Formule');
};
var $author$project$I18n$Cles$pipeEtape5NoteReponseFormuleAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.reponse.formule.aide', _List_Nil, 'Écrite avec les champs du formulaire.');
};
var $author$project$I18n$Cles$pipeEtape5NoteReponseMoyenneSimple = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.reponse.moyenne-simple', _List_Nil, 'Moyenne simple');
};
var $author$project$I18n$Cles$pipeEtape5NoteReponseMoyenneSimpleAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.reponse.moyenne-simple.aide', _List_Nil, 'Les poids sont ignorés.');
};
var $author$project$I18n$Cles$pipeEtape5NoteReponseSommePondereeSur20 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.reponse.somme-ponderee-sur-20', _List_Nil, 'Somme pondérée, sur 20');
};
var $author$project$I18n$Cles$pipeEtape5NoteReponseSommePondereeSur20Aide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.reponse.somme-ponderee-sur-20.aide', _List_Nil, 'Chaque note multipliée par son poids.');
};
var $author$project$Components$Parametrage$Vocabulaire$noteDUneReponse = F2(
	function (i18n, code) {
		switch (code) {
			case 'somme-ponderee-sur-20':
				return _Utils_Tuple2(
					$author$project$I18n$Cles$pipeEtape5NoteReponseSommePondereeSur20(i18n),
					$author$project$I18n$Cles$pipeEtape5NoteReponseSommePondereeSur20Aide(i18n));
			case 'moyenne-simple':
				return _Utils_Tuple2(
					$author$project$I18n$Cles$pipeEtape5NoteReponseMoyenneSimple(i18n),
					$author$project$I18n$Cles$pipeEtape5NoteReponseMoyenneSimpleAide(i18n));
			case 'formule':
				return _Utils_Tuple2(
					$author$project$I18n$Cles$pipeEtape5NoteReponseFormule(i18n),
					$author$project$I18n$Cles$pipeEtape5NoteReponseFormuleAide(i18n));
			default:
				var autre = code;
				return _Utils_Tuple2(autre, '');
		}
	});
var $author$project$I18n$Cles$pipeEtape5NoteReponseTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.reponse.titre', _List_Nil, 'Note d\'une réponse');
};
var $author$project$Components$Parametrage$PipeEtape5$View$sectionNoteDUneReponse = F2(
	function (i18n, notation) {
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape5NoteReponseTitre(i18n),
			A2(
				$elm$core$List$map,
				function (code) {
					var _v0 = A2($author$project$Components$Parametrage$Vocabulaire$noteDUneReponse, i18n, code);
					var titre = _v0.a;
					var aide = _v0.b;
					return A6(
						$author$project$Components$Parametrage$Common$Conception$choix,
						'note-d-une-reponse',
						code,
						_Utils_eq(notation.DS, code),
						titre,
						aide,
						$author$project$Components$Parametrage$PipeEtape5$Update$NoteDUneReponseChoisie(code));
				},
				_List_fromArray(
					['somme-ponderee-sur-20', 'moyenne-simple', 'formule'])));
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$ChampDuDossierChoisi = function (a) {
	return {$: 50, a: a};
};
var $author$project$I18n$Cles$pipeEtape5NoteOuVaAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.ou-va.aucun', _List_Nil, 'Aucun');
};
var $author$project$I18n$Cles$pipeEtape5NoteOuVaChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.ou-va.champ', _List_Nil, 'Champ du dossier alimenté');
};
var $author$project$I18n$Cles$pipeEtape5NoteOuVaTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.ou-va.titre', _List_Nil, 'Où va la note');
};
var $author$project$Components$Parametrage$PipeEtape5$View$sectionOuVaLaNote = F4(
	function (i18n, saisie, lue, notation) {
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape5NoteOuVaTitre(i18n),
			_List_fromArray(
				[
					A4(
					$author$project$Components$Parametrage$Common$Conception$liste,
					$author$project$I18n$Cles$pipeEtape5NoteOuVaChamp(i18n),
					A2($elm$core$Maybe$withDefault, '', notation.dv),
					_Utils_ap(
						A2(
							$elm$core$List$map,
							function (champ) {
								return _Utils_Tuple2(champ.vx, champ.Bl);
							},
							saisie.B1.o_.uX),
						_List_fromArray(
							[
								_Utils_Tuple2(
								'',
								$author$project$I18n$Cles$pipeEtape5NoteOuVaAucun(i18n))
							])),
					$author$project$Components$Parametrage$PipeEtape5$Update$ChampDuDossierChoisi),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(lue.GI)
						]))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape5$View$contenuDuNote = F5(
	function (i18n, code, saisie, lue, notation) {
		return _List_fromArray(
			[
				A2($author$project$Components$Parametrage$PipeEtape5$View$sectionDuNom, i18n, saisie),
				A3($author$project$Components$Parametrage$PipeEtape5$View$sectionDuType, i18n, code, saisie.B1),
				A2($author$project$Components$Parametrage$PipeEtape5$View$sectionDesChampsNotes, i18n, saisie),
				A2($author$project$Components$Parametrage$PipeEtape5$View$avertissementDesPoids, i18n, lue),
				A2(
				$rtfeldman$elm_css$Html$Styled$fieldset,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('reglages'),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!saisie.B1.g_)
					]),
				_List_fromArray(
					[
						A3($author$project$Components$Parametrage$PipeEtape5$View$reglageDuChampNote, i18n, saisie, notation),
						A2($author$project$Components$Parametrage$PipeEtape5$View$sectionNoteDUneReponse, i18n, notation),
						A2($author$project$Components$Parametrage$PipeEtape5$View$sectionEntreRepondants, i18n, notation),
						A4($author$project$Components$Parametrage$PipeEtape5$View$sectionOuVaLaNote, i18n, saisie, lue, notation),
						A3($author$project$Components$Parametrage$PipeEtape5$View$sectionConfidentialite, i18n, lue, notation)
					])),
				A2($author$project$Components$Parametrage$PipeEtape5$View$sectionApercuDuRepondant, i18n, lue),
				A2($author$project$Components$Parametrage$PipeEtape5$View$sectionOuSert, i18n, saisie),
				A2($author$project$Components$Parametrage$PipeEtape5$View$sectionRetirer, i18n, saisie),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('description'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('encart')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$pipeEtape5NoteEncart1(i18n)),
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape5NoteEncart2(i18n))
							])),
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$pipeEtape5NoteEncart3(i18n))
					]))
			]);
	});
var $author$project$I18n$Cles$pipeEtape5RetraitChampAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.retrait-champ.aide', _List_Nil, 'Les réponses déjà données, sur la fiche et dans le dossier, sont conservées. Vous pourrez le restaurer depuis « Champs retirés ».');
};
var $author$project$I18n$Cles$pipeEtape5RetraitChampEncart = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.retrait-champ.encart',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'formulaire',
					$author$project$I18n$Traductions$Chaine(p.zT))
				]),
			'Le champ n\'est plus demandé dans « ' + (p.zT + ' ».'));
	});
var $author$project$Components$Parametrage$PipeEtape5$View$contenuDuRetrait = F2(
	function (i18n, saisie) {
		var lue = saisie.B1;
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('encart-info')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$pipeEtape5RetraitChampEncart,
									i18n,
									{
										zT: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(saisie.B1.R)
									}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape5RetraitChampAide(i18n))
							]))
					])),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape5ChampsTitre(i18n),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape5ChampsAide(i18n))
							])),
						A2($author$project$Components$Parametrage$PipeEtape5$View$ficheViseeDuPipe, i18n, saisie.B1),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('champs')
							]),
						A2(
							$elm$core$List$map,
							A2(
								$author$project$Components$Parametrage$PipeEtape5$View$ligneDeChamp,
								i18n,
								_Utils_update(
									saisie,
									{
										B1: _Utils_update(
											lue,
											{g_: false})
									})),
							lue.dw))
					]))
			]);
	});
var $author$project$Components$Parametrage$PipeEtape5$View$nomDeChampPris = F2(
	function (i18n, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (m) {
					return _Utils_eq(m.Jx, $author$project$I18n$Textes$pipeEtape5RefusNomDeChampPris);
				},
				model.pZ));
	});
var $author$project$I18n$Cles$pipeEtape5AjoutAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.ajout.action', _List_Nil, 'Ajouter le champ');
};
var $author$project$I18n$Cles$pipeEtape5AjoutTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.ajout.titre', _List_Nil, 'Ajouter un champ');
};
var $author$project$I18n$Cles$pipeEtape5DrawerEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.drawer.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$pipeEtape5DrawerKicker = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.drawer.kicker',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nature',
					$author$project$I18n$Traductions$Chaine(p.g1))
				]),
			'Formulaire · ' + p.g1);
	});
var $author$project$I18n$Cles$pipeEtape5NoteKickerNature = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.note.kicker-nature', _List_Nil, 'Noté');
};
var $author$project$I18n$Cles$pipeEtape5RetraitChampAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.retrait-champ.action', _List_Nil, 'Retirer le champ');
};
var $author$project$I18n$Cles$pipeEtape5RetraitChampTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-5.retrait-champ.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer le champ « ' + (p.Dj + ' » ?'));
	});
var $author$project$Components$Shared$Messages$View$vueEnErreur = F2(
	function (i18n, messages) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('messages'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
				]),
			A2(
				$elm$core$List$map,
				function (fourni) {
					return A2(
						$author$project$Components$Shared$Note$View$view,
						2,
						A2(
							$elm$core$List$cons,
							A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$I18n$Cles$texte, i18n, fourni.Jx))
									])),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									$author$project$Components$Shared$Messages$View$reference(i18n),
									fourni.b9))));
				},
				messages));
	});
var $author$project$Components$Parametrage$PipeEtape5$View$refus = F2(
	function (i18n, model) {
		return A2(
			$author$project$Components$Shared$Messages$View$vueEnErreur,
			i18n,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $elm$core$List$singleton, model.pZ)));
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$NomSaisi = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$RenommageAbandonne = {$: 8};
var $author$project$I18n$Cles$pipeEtape5NomLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.nom.libelle', _List_Nil, 'Nom du formulaire');
};
var $author$project$I18n$Cles$pipeEtape5NomRetour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.nom.retour', _List_Nil, 'Revenir au formulaire');
};
var $author$project$Components$Parametrage$PipeEtape5$View$traduction = F2(
	function (i18n, saisie) {
		return _List_fromArray(
			[
				A3(
				$author$project$Components$Shared$LibellesParLangue$View$view,
				i18n,
				_List_Nil,
				{
					go: function (_v0) {
						return $elm$core$Maybe$Nothing;
					},
					Ba: $author$project$Referentiel$Langues$desLibelles,
					Bl: $author$project$I18n$Cles$pipeEtape5NomLibelle(i18n),
					hg: $author$project$Components$Parametrage$PipeEtape5$Update$NomSaisi,
					pv: $author$project$Components$Parametrage$PipeEtape5$Model$idDuDrawer('nom'),
					fm: function (code) {
						return A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Dict$get, code, saisie.R));
					}
				}),
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape5$Update$RenommageAbandonne)
					]),
				$author$project$I18n$Cles$pipeEtape5NomRetour(i18n))
			]);
	});
var $author$project$Components$Parametrage$PipeEtape5$View$contenuDuDrawer = F2(
	function (i18n, model) {
		var _v0 = model.hP;
		if (!_v0.$) {
			var saisie = _v0.a;
			return {
				fs: (!_Utils_eq(saisie.fw, $elm$core$Maybe$Nothing)) ? {
					sR: (!_Utils_eq(
						$author$project$Components$Parametrage$PipeEtape5$Model$ajoutVoulu(saisie),
						$elm$core$Maybe$Nothing)) && (!$author$project$API$Envoi$enCours(model.l2)),
					Bl: $author$project$I18n$Cles$pipeEtape5AjoutAction(i18n),
					C$: $author$project$Components$Parametrage$PipeEtape5$Update$AjoutDemande
				} : ((!_Utils_eq(saisie.eW, $elm$core$Maybe$Nothing)) ? {
					sR: !$author$project$API$Envoi$enCours(model.l2),
					Bl: $author$project$I18n$Cles$pipeEtape5RetraitChampAction(i18n),
					C$: $author$project$Components$Parametrage$PipeEtape5$Update$RetraitDeChampDemande
				} : (model.qq ? {
					sR: (!_Utils_eq(
						$author$project$Components$Parametrage$PipeEtape5$Model$renommageVoulu(saisie),
						$elm$core$Maybe$Nothing)) && (!$author$project$API$Envoi$enCours(model.l2)),
					Bl: $author$project$I18n$Cles$pipeEtape5NomRenommer(i18n),
					C$: $author$project$Components$Parametrage$PipeEtape5$Update$RenommageDemande
				} : {
					sR: (!_Utils_eq(
						function () {
							if (!_Utils_eq(saisie.DQ, $elm$core$Maybe$Nothing)) {
								return $author$project$Components$Parametrage$PipeEtape5$Model$notationVoulue(saisie);
							} else {
								var _v1 = $author$project$Components$Parametrage$PipeEtape5$Model$champVoulu(saisie);
								if (!_v1.$) {
									var commande = _v1.a;
									return $elm$core$Maybe$Just(commande);
								} else {
									return $author$project$Components$Parametrage$PipeEtape5$Model$importVoulu(saisie);
								}
							}
						}(),
						$elm$core$Maybe$Nothing)) && (!$author$project$API$Envoi$enCours(model.l2)),
					Bl: $author$project$I18n$Cles$pipeEtape5DrawerEnregistrer(i18n),
					C$: $author$project$Components$Parametrage$PipeEtape5$Update$EnregistrementDemande
				})),
				fZ: function () {
					if (!_Utils_eq(saisie.fw, $elm$core$Maybe$Nothing)) {
						return A2(
							$elm$core$List$cons,
							A2($author$project$Components$Parametrage$PipeEtape5$View$refus, i18n, model),
							A3(
								$author$project$Components$Parametrage$PipeEtape5$View$contenuDeLAjout,
								i18n,
								A2($author$project$Components$Parametrage$PipeEtape5$View$nomDeChampPris, i18n, model),
								saisie));
					} else {
						if (!_Utils_eq(saisie.eW, $elm$core$Maybe$Nothing)) {
							return A2(
								$elm$core$List$cons,
								A2($author$project$Components$Parametrage$PipeEtape5$View$refus, i18n, model),
								A2($author$project$Components$Parametrage$PipeEtape5$View$contenuDuRetrait, i18n, saisie));
						} else {
							if (model.qq) {
								return A2(
									$elm$core$List$cons,
									A2($author$project$Components$Parametrage$PipeEtape5$View$refus, i18n, model),
									A2($author$project$Components$Parametrage$PipeEtape5$View$traduction, i18n, saisie));
							} else {
								var _v2 = _Utils_Tuple2(saisie.B1.DQ, saisie.DQ);
								if ((!_v2.a.$) && (!_v2.b.$)) {
									var notation = _v2.a.a;
									var saisieDeNotation = _v2.b.a;
									return A2(
										$elm$core$List$cons,
										A2($author$project$Components$Parametrage$PipeEtape5$View$refus, i18n, model),
										A5($author$project$Components$Parametrage$PipeEtape5$View$contenuDuNote, i18n, model.vx, saisie, notation, saisieDeNotation));
								} else {
									return A2(
										$elm$core$List$cons,
										A2($author$project$Components$Parametrage$PipeEtape5$View$refus, i18n, model),
										A3($author$project$Components$Parametrage$PipeEtape5$View$contenuDuFormulaire, i18n, model.vx, saisie));
								}
							}
						}
					}
				}(),
				A6: $elm$core$Maybe$Just(
					A2(
						$author$project$I18n$Cles$pipeEtape5DrawerKicker,
						i18n,
						{
							g1: (!_Utils_eq(saisie.DQ, $elm$core$Maybe$Nothing)) ? $author$project$I18n$Cles$pipeEtape5NoteKickerNature(i18n) : A2(
								$author$project$I18n$Cles$texte,
								i18n,
								$author$project$Components$Parametrage$Vocabulaire$typeDeTache(saisie.B1.r0))
						})),
				Bc: false,
				h6: function () {
					var _v3 = _Utils_Tuple2(saisie.fw, saisie.eW);
					if (!_v3.a.$) {
						return $author$project$I18n$Cles$pipeEtape5AjoutTitre(i18n);
					} else {
						if (!_v3.b.$) {
							var uid = _v3.b.a;
							return A2(
								$author$project$I18n$Cles$pipeEtape5RetraitChampTitre,
								i18n,
								{
									Dj: A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											function (c) {
												return $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(c.R);
											},
											A2($author$project$Components$Parametrage$PipeEtape5$View$champRetirant, saisie, uid)))
								});
						} else {
							return $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(saisie.B1.R);
						}
					}
				}()
			};
		} else {
			return {
				fs: {sR: false, Bl: '', C$: $author$project$Components$Parametrage$PipeEtape5$Update$EnregistrementDemande},
				fZ: _List_Nil,
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: ''
			};
		}
	});
var $author$project$Components$Parametrage$PipeEtape5$Update$AjoutAbandonne = {$: 60};
var $author$project$I18n$Cles$pipeEtape5AjoutRetour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-5.ajout.retour', _List_Nil, 'Revenir au formulaire');
};
var $author$project$Components$Parametrage$PipeEtape5$View$piedDeRetour = function (i18n) {
	return {
		oJ: $elm$core$Maybe$Nothing,
		HF: function (attributs) {
			return A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				1,
				_Utils_ap(
					attributs,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape5$Update$AjoutAbandonne)
						])),
				$author$project$I18n$Cles$pipeEtape5AjoutRetour(i18n));
		},
		Jb: _List_Nil
	};
};
var $author$project$Components$Parametrage$PipeEtape5$View$videSiFerme = F2(
	function (model, contenu) {
		return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) ? contenu : _Utils_update(
			contenu,
			{fZ: _List_Nil, A6: $elm$core$Maybe$Nothing, h6: ''});
	});
var $author$project$Components$Parametrage$PipeEtape5$View$drawer = F2(
	function (i18n, model) {
		var contenu = A2(
			$author$project$Components$Parametrage$PipeEtape5$View$videSiFerme,
			model,
			A2($author$project$Components$Parametrage$PipeEtape5$View$contenuDuDrawer, i18n, model));
		var _v0 = model.hP;
		if (!_v0.$) {
			var ajout = _v0.a.fw;
			return (!_Utils_eq(ajout, $elm$core$Maybe$Nothing)) ? A5(
				$author$project$Components$Shared$Drawer$View$viewAvecPiedLibre,
				i18n,
				$author$project$Components$Parametrage$PipeEtape5$View$piedDeRetour(i18n),
				$author$project$Components$Parametrage$PipeEtape5$Update$DuDrawer,
				contenu,
				model.kX) : ((!_Utils_eq(
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.eW;
					},
					model.hP),
				$elm$core$Maybe$Nothing)) ? A4($author$project$Components$Shared$Drawer$View$viewDestructif, i18n, $author$project$Components$Parametrage$PipeEtape5$Update$DuDrawer, contenu, model.kX) : A4($author$project$Components$Shared$Drawer$View$view, i18n, $author$project$Components$Parametrage$PipeEtape5$Update$DuDrawer, contenu, model.kX));
		} else {
			return A4($author$project$Components$Shared$Drawer$View$view, i18n, $author$project$Components$Parametrage$PipeEtape5$Update$DuDrawer, contenu, model.kX);
		}
	});
var $author$project$Components$Parametrage$PipeEtape5$View$view = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'parametrage-pipe-etape-5',
			{
				ut: A3($author$project$Components$Parametrage$PipeEtape5$View$corps, i18n, messages, model),
				xy: _List_fromArray(
					[
						A2($author$project$Components$Parametrage$PipeEtape5$View$drawer, i18n, model)
					]),
				zM: _List_Nil,
				AK: $author$project$Components$Parametrage$PipeEtape5$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: A2(
							$elm$core$List$cons,
							A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$elm$core$String$join,
											' ',
											A2(
												$elm$core$List$cons,
												$author$project$I18n$Cles$pipeEtape1Introduction(i18n),
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													A2(
														$elm$core$Maybe$map,
														function (edition) {
															return _List_fromArray(
																[
																	A2(
																	$author$project$I18n$Cles$pipeEtape1Exemple,
																	i18n,
																	{
																		Fs: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(edition.R)
																	})
																]);
														},
														model.ge)))))
									])),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (_v0) {
										return _List_fromArray(
											[
												A5($author$project$Components$Parametrage$Common$Conception$bandeau, i18n, $author$project$Routes$Route$adressePipeEtape5, model.vx, model.aS, model.nR)
											]);
									},
									model.ge))),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adressePipes,
								Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
							},
								{
								aa: $author$project$Routes$Route$adressePipes,
								Dj: $author$project$I18n$Cles$pipesTitre(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$pipeEtape1Titre(i18n)
					})
			});
	});
var $author$project$I18n$Cles$pipeEtape6ApercuRolesParRelation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.apercu.roles-par-relation', _List_Nil, 'Rôles par relation');
};
var $author$project$Components$Parametrage$PipeEtape6$View$apercu = F2(
	function (i18n, lu) {
		return A3(
			$author$project$Components$Shared$Parcours$View$apercu,
			i18n,
			$author$project$I18n$Cles$pipeEtape1ApercuTitre(i18n),
			{
				gV: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (apercuLu) {
							return _Utils_ap(
								A2(
									$elm$core$List$concatMap,
									function (etape) {
										return _List_fromArray(
											[
												{dX: true, eW: 0, Jx: etape.Bl},
												{dX: false, eW: 1, Jx: etape.Fp}
											]);
									},
									apercuLu.yL),
								_Utils_ap(
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											function (phrase) {
												return _List_fromArray(
													[
														{
														dX: true,
														eW: 0,
														Jx: $author$project$I18n$Cles$pipeEtape6ApercuRolesParRelation(i18n)
													},
														{dX: false, eW: 1, Jx: phrase}
													]);
											},
											apercuLu.Ie)),
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											function (phrase) {
												return _List_fromArray(
													[
														{dX: false, eW: 0, Jx: phrase}
													]);
											},
											apercuLu.fM))));
						},
						lu)),
				h6: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.h6;
					},
					lu)
			});
	});
var $author$project$Components$Parametrage$PipeEtape6$View$champMasque = function (champ) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$li,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('champ-masque')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('textes')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(champ.Bl)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('regle')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(champ.Hm)
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('etiquettes')
							]),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								function (role) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('etiquette')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(role.Bl)
											]));
								},
								champ.eX),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('chevron'),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('›')
										]))
								])))
					]))
			]));
};
var $author$project$I18n$Cles$pipeEtape6MasquesAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.masques.ajouter', _List_Nil, 'Ajouter : Champ masqué');
};
var $author$project$I18n$Cles$pipeEtape6MasquesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.masques.titre', _List_Nil, 'Champs masqués');
};
var $author$project$Components$Parametrage$PipeEtape6$View$champsMasques = F2(
	function (i18n, grille) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('champs-masques')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape6MasquesTitre(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('liste')
								]),
							A2($elm$core$List$map, $author$project$Components$Parametrage$PipeEtape6$View$champMasque, grille.fM)),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('gestes')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout'),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape6MasquesAjouter(i18n))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape6$Update$OptionsOuvertes = {$: 10};
var $author$project$I18n$Cles$pipeEtape6OptionsAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.options.aucune', _List_Nil, 'Aucune option réglée : tout est décoché par défaut.');
};
var $author$project$I18n$Cles$pipeEtape6OptionsDemandeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.options.demandeur', _List_Nil, 'Le candidat voit l\'étape en cours sur le portail, avec son libellé public');
};
var $author$project$I18n$Cles$pipeEtape6OptionsJury = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.options.jury', _List_Nil, 'Le jury voit les autres membres du jury');
};
var $author$project$Components$Parametrage$PipeEtape6$Phrases$optionsDeLEtape = F2(
	function (i18n, options) {
		var _v0 = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					options.kF ? $elm$core$Maybe$Just(
					$author$project$I18n$Cles$pipeEtape6OptionsDemandeur(i18n)) : $elm$core$Maybe$Nothing,
					options.n6 ? $elm$core$Maybe$Just(
					$author$project$I18n$Cles$pipeEtape6OptionsJury(i18n)) : $elm$core$Maybe$Nothing
				]));
		if (!_v0.b) {
			return $author$project$I18n$Cles$pipeEtape6OptionsAucune(i18n);
		} else {
			var phrases = _v0;
			return A2($elm$core$String$join, '. ', phrases) + '.';
		}
	});
var $author$project$I18n$Cles$pipeEtape6GrilleEtape = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-6.grille.etape',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rang',
					$author$project$I18n$Traductions$Chaine(p.bY)),
					_Utils_Tuple2(
					'etape',
					$author$project$I18n$Traductions$Chaine(p.me))
				]),
			p.bY + ('. ' + p.me));
	});
var $author$project$Components$Parametrage$PipeEtape6$View$phraseDeLEtape = F2(
	function (i18n, etape) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('options-de-l-etape')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('etape')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$pipeEtape6GrilleEtape,
								i18n,
								{
									me: etape.Bl,
									bY: $elm$core$String$fromInt(etape.bY)
								}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('phrase')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Parametrage$PipeEtape6$Phrases$optionsDeLEtape, i18n, etape.o_))
						]))
				]));
	});
var $author$project$I18n$Cles$pipeEtape6OptionsModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.options.modifier', _List_Nil, 'Modifier les options');
};
var $author$project$I18n$Cles$pipeEtape6OptionsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.options.titre', _List_Nil, 'Options de chaque étape');
};
var $author$project$Components$Parametrage$PipeEtape6$View$optionsDesEtapes = F2(
	function (i18n, grille) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('options-des-etapes')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape6OptionsTitre(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('liste')
								]),
							A2(
								$elm$core$List$map,
								$author$project$Components$Parametrage$PipeEtape6$View$phraseDeLEtape(i18n),
								grille.yL)),
							_Utils_eq(
							A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reglerLesOptionsDeLEtape, grille.nQ),
							$elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('gestes')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('secondary'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('modifier-les-options'),
											$rtfeldman$elm_css$Html$Styled$Attributes$id(
											$author$project$Components$Parametrage$PipeEtape6$Model$idDuDeclencheur('options')),
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape6$Update$OptionsOuvertes)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape6OptionsModifier(i18n))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape6$View$pied = F2(
	function (i18n, code) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pied')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$lien,
					1,
					$author$project$Routes$Route$adressePipeEtape5(code),
					$author$project$I18n$Cles$pipeEtape2Precedente(i18n)),
					A3(
					$author$project$Components$Shared$Bouton$View$lien,
					0,
					$author$project$Routes$Route$adressePipeEtape7(code),
					$author$project$I18n$Cles$pipeEtape1Suivante(i18n))
				]));
	});
var $author$project$I18n$Cles$pipeEtape6MasquesConseil = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.masques.conseil', _List_Nil, 'Par défaut, un nouveau champ est masqué aux rôles externes. Un champ masqué n\'est jamais envoyé, ni au portail ni au back-office. Les droits généraux de l\'utilisateur s\'appliquent en plus.');
};
var $author$project$I18n$Cles$pipeEtape6Question = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.question', _List_Nil, 'Qui voit quoi ?');
};
var $author$project$I18n$Cles$pipeEtape6Role = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.role', _List_Nil, 'rôle');
};
var $author$project$I18n$Cles$pipeEtape6Texte1 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.texte1', _List_Nil, 'Pour chaque étape, chaque ');
};
var $author$project$I18n$Cles$pipeEtape6Texte2 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.texte2', _List_Nil, ' du dossier voit, saisit ou ne voit rien. Par défaut, rien n\'est visible.');
};
var $author$project$Components$Parametrage$PipeEtape6$View$enteteDeRole = F2(
	function (i18n, role) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$th,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(role.Bl)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nature')
						]),
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Parametrage$Vocabulaire$natureDuRole, i18n, role.g1)),
						role.EW ? _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('etiquette', true),
												_Utils_Tuple2('violet', true)
											]))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape3ParRelation(i18n))
									]))
							]) : _List_Nil))
				]));
	});
var $author$project$I18n$Cles$pipeEtape6DroitRien = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.droit.rien', _List_Nil, 'Rien');
};
var $author$project$I18n$Cles$pipeEtape6DroitSaisit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.droit.saisit', _List_Nil, 'Saisit');
};
var $author$project$I18n$Cles$pipeEtape6DroitVoit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.droit.voit', _List_Nil, 'Voit');
};
var $author$project$Components$Parametrage$Vocabulaire$droit = F2(
	function (i18n, code) {
		switch (code) {
			case 'saisit':
				return $author$project$I18n$Cles$pipeEtape6DroitSaisit(i18n);
			case 'voit':
				return $author$project$I18n$Cles$pipeEtape6DroitVoit(i18n);
			case 'rien':
				return $author$project$I18n$Cles$pipeEtape6DroitRien(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$I18n$Cles$pipeEtape6LegendeRien = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.legende.rien', _List_Nil, ' : champ masqué, jamais envoyé');
};
var $author$project$I18n$Cles$pipeEtape6LegendeSaisit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.legende.saisit', _List_Nil, ' : remplit et modifie');
};
var $author$project$I18n$Cles$pipeEtape6LegendeVoit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.legende.voit', _List_Nil, ' : lecture seule');
};
var $author$project$Components$Parametrage$PipeEtape6$View$legende = function (i18n) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$p,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('legende')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$Components$Parametrage$Vocabulaire$droit, i18n, 'saisit'))
							])),
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$pipeEtape6LegendeSaisit(i18n))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$Components$Parametrage$Vocabulaire$droit, i18n, 'voit'))
							])),
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$pipeEtape6LegendeVoit(i18n))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$Components$Parametrage$Vocabulaire$droit, i18n, 'rien'))
							])),
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$pipeEtape6LegendeRien(i18n))
					]))
			]));
};
var $author$project$Components$Parametrage$PipeEtape6$Update$CaseDemandee = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$I18n$Cles$pipeEtape6GrilleCase = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-6.grille.case',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi)),
					_Utils_Tuple2(
					'etape',
					$author$project$I18n$Traductions$Chaine(p.me)),
					_Utils_Tuple2(
					'droit',
					$author$project$I18n$Traductions$Chaine(p.xP))
				]),
			p.bi + (', ' + (p.me + (' : ' + p.xP))));
	});
var $author$project$Components$Parametrage$PipeEtape6$View$celluleDe = F4(
	function (i18n, grille, etape, role) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$td,
			_List_Nil,
			function () {
				var _v0 = A3($author$project$Components$Parametrage$PipeEtape6$Model$caseDe, grille, role.r8, etape.r8);
				if (!_v0.$) {
					var case_ = _v0.a;
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('case', true),
											_Utils_Tuple2(case_.xP, true)
										])),
									$rtfeldman$elm_css$Html$Styled$Attributes$id(
									$author$project$Components$Parametrage$PipeEtape6$Model$idDuDeclencheur('case-' + (role.r8 + ('-' + etape.r8)))),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									A2(
										$author$project$I18n$Cles$pipeEtape6GrilleCase,
										i18n,
										{
											xP: A2($author$project$Components$Parametrage$Vocabulaire$droit, i18n, case_.xP),
											me: etape.Bl,
											bi: role.Bl
										})),
									$rtfeldman$elm_css$Html$Styled$Attributes$title(
									A2(
										$author$project$I18n$Cles$pipeEtape6GrilleCase,
										i18n,
										{
											xP: A2($author$project$Components$Parametrage$Vocabulaire$droit, i18n, case_.xP),
											me: etape.Bl,
											bi: role.Bl
										})),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
									_Utils_eq(case_.np, $elm$core$Maybe$Nothing)),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									A2($author$project$Components$Parametrage$PipeEtape6$Update$CaseDemandee, role.r8, etape.r8))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Parametrage$Vocabulaire$droit, i18n, case_.xP))
								]))
						]);
				} else {
					return _List_Nil;
				}
			}());
	});
var $author$project$Components$Parametrage$PipeEtape6$View$ligneDEtape = F3(
	function (i18n, grille, etape) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$th,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$scope('row')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$pipeEtape6GrilleEtape,
								i18n,
								{
									me: etape.Bl,
									bY: $elm$core$String$fromInt(etape.bY)
								}))
						])),
				A2(
					$elm$core$List$map,
					A3($author$project$Components$Parametrage$PipeEtape6$View$celluleDe, i18n, grille, etape),
					grille.eX)));
	});
var $author$project$I18n$Cles$pipeEtape6GrilleAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.grille.aide', _List_Nil, 'Cliquez une case pour régler les champs de ce rôle à cette étape. Un rôle sans droit ne voit rien des champs du dossier. Un rôle « Par relation » a sa propre colonne : ses droits valent pour la personne ou l\'organisation liée au licencié.');
};
var $author$project$I18n$Cles$pipeEtape6GrilleTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.grille.titre', _List_Nil, 'Qui voit quoi, étape par étape');
};
var $author$project$Components$Parametrage$PipeEtape6$View$tableauDesDroits = F2(
	function (i18n, grille) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('grille')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape6GrilleTitre(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape6GrilleAide(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('defilement')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$table,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$thead,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$tr,
													_List_Nil,
													A2(
														$elm$core$List$cons,
														A2($rtfeldman$elm_css$Html$Styled$th, _List_Nil, _List_Nil),
														A2(
															$elm$core$List$map,
															$author$project$Components$Parametrage$PipeEtape6$View$enteteDeRole(i18n),
															grille.eX)))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$tbody,
											_List_Nil,
											A2(
												$elm$core$List$map,
												A2($author$project$Components$Parametrage$PipeEtape6$View$ligneDEtape, i18n, grille),
												grille.yL))
										]))
								])),
							$author$project$Components$Parametrage$PipeEtape6$View$legende(i18n)
						]))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape6$View$corps = F3(
	function (i18n, messages, model) {
		var _v0 = _Utils_Tuple2(model.m1, model.nf);
		if (!_v0.a.$) {
			var grille = _v0.a.a;
			return _List_fromArray(
				[
					A3($author$project$Components$Parametrage$Common$Conception$etapes, i18n, model.vx, 6),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
						]),
					_List_fromArray(
						[
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('etape')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h2,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape6Question(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('explication')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape6Texte1(i18n)),
											A2(
											$rtfeldman$elm_css$Html$Styled$strong,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$pipeEtape6Role(i18n))
												])),
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape6Texte2(i18n))
										])),
									A2($author$project$Components$Parametrage$PipeEtape6$View$tableauDesDroits, i18n, grille),
									A2($author$project$Components$Parametrage$PipeEtape6$View$optionsDesEtapes, i18n, grille),
									A2($author$project$Components$Parametrage$PipeEtape6$View$champsMasques, i18n, grille),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape6MasquesConseil(i18n))
										]))
								])),
							A2($author$project$Components$Parametrage$PipeEtape6$View$pied, i18n, model.vx)
						])),
					A2($author$project$Components$Parametrage$PipeEtape6$View$apercu, i18n, grille.tq)
				]);
		} else {
			if (_v0.b) {
				return _List_fromArray(
					[
						A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape1Introuvable(i18n))
							]))
					]);
			} else {
				return model.Ax ? _List_fromArray(
					[
						A3($author$project$Components$Parametrage$Common$Conception$etapes, i18n, model.vx, 6),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						_List_fromArray(
							[
								A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape1Illisible(i18n))
									]))
							]))
					]) : _List_fromArray(
					[
						A2($author$project$Components$Shared$Messages$View$view, i18n, messages)
					]);
			}
		}
	});
var $author$project$Components$Parametrage$PipeEtape6$Update$EnregistrementDemande = {$: 13};
var $author$project$Components$Parametrage$PipeEtape6$Update$OptionsEnregistrement = {$: 12};
var $author$project$Components$Parametrage$PipeEtape6$Update$OptionsModifiees = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape6$View$optionsDeLEtape = F3(
	function (i18n, saisies, etape) {
		var options = A2(
			$elm$core$Maybe$withDefault,
			etape.o_,
			A2($elm$core$Dict$get, etape.r8, saisies));
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('options-de-l-etape')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('etape')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$pipeEtape6GrilleEtape,
								i18n,
								{
									me: etape.Bl,
									bY: $elm$core$String$fromInt(etape.bY)
								}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('cases')
						]),
					_List_fromArray(
						[
							A4(
							$author$project$Components$Parametrage$Common$Conception$caseSimple,
							'demandeur-' + etape.r8,
							options.kF,
							$author$project$I18n$Cles$pipeEtape6OptionsDemandeur(i18n),
							function (voit) {
								return A2(
									$author$project$Components$Parametrage$PipeEtape6$Update$OptionsModifiees,
									etape.r8,
									_Utils_update(
										options,
										{kF: voit}));
							}),
							A4(
							$author$project$Components$Parametrage$Common$Conception$caseSimple,
							'jury-' + etape.r8,
							options.n6,
							$author$project$I18n$Cles$pipeEtape6OptionsJury(i18n),
							function (voit) {
								return A2(
									$author$project$Components$Parametrage$PipeEtape6$Update$OptionsModifiees,
									etape.r8,
									_Utils_update(
										options,
										{n6: voit}));
							})
						]))
				]));
	});
var $author$project$I18n$Cles$pipeEtape6OptionsAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.options.aide', _List_Nil, 'Cochez ce qui vaut à l\'étape. Tout est décoché par défaut.');
};
var $author$project$Components$Parametrage$PipeEtape6$View$optionsDuDrawer = F3(
	function (i18n, grille, saisies) {
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$pipeEtape6OptionsAide(i18n))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$ul,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('liste')
					]),
				A2(
					$elm$core$List$map,
					A2($author$project$Components$Parametrage$PipeEtape6$View$optionsDeLEtape, i18n, saisies),
					grille.yL))
			]);
	});
var $author$project$I18n$Cles$pipeEtape6DrawerEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.drawer.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$pipeEtape6DrawerKicker = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-6.drawer.kicker',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi)),
					_Utils_Tuple2(
					'etape',
					$author$project$I18n$Traductions$Chaine(p.me))
				]),
			p.bi + (' à l\'étape « ' + (p.me + ' »')));
	});
var $author$project$I18n$Cles$pipeEtape6DrawerKickerRelation = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-6.drawer.kicker-relation',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi)),
					_Utils_Tuple2(
					'etape',
					$author$project$I18n$Traductions$Chaine(p.me))
				]),
			p.bi + (' (par relation) à l\'étape « ' + (p.me + ' »')));
	});
var $author$project$I18n$Cles$pipeEtape6DrawerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.drawer.titre', _List_Nil, 'Droits d\'un rôle à une étape');
};
var $author$project$I18n$Cles$pipeEtape6OptionsDrawerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.options.drawer.titre', _List_Nil, 'Options de chaque étape');
};
var $author$project$I18n$Cles$pipeEtape6OptionsEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.options.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$Components$Parametrage$PipeEtape6$View$refus = F2(
	function (i18n, model) {
		return A2(
			$author$project$Components$Shared$Messages$View$view,
			i18n,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $elm$core$List$singleton, model.pZ)));
	});
var $author$project$I18n$Cles$pipeEtape6DrawerDonneLit = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-6.drawer.donne.lit',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? ('lit ' + (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' champ')) : ('lit ' + (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' champs')));
	});
var $author$project$I18n$Cles$pipeEtape6DrawerDonnePhrase = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-6.drawer.donne.phrase',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etape',
					$author$project$I18n$Traductions$Chaine(p.me)),
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi)),
					_Utils_Tuple2(
					'saisit',
					$author$project$I18n$Traductions$Chaine(p.qW)),
					_Utils_Tuple2(
					'lit',
					$author$project$I18n$Traductions$Chaine(p.BY)),
					_Utils_Tuple2(
					'rien',
					$author$project$I18n$Traductions$Chaine(p.qO))
				]),
			'À « ' + (p.me + (' », ' + (p.bi + (' ' + (p.qW + (', ' + (p.BY + (' et ' + (p.qO + ('. ' + (p.bi + ' voit toujours le nom public de l\'étape.'))))))))))));
	});
var $author$project$I18n$Cles$pipeEtape6DrawerDonneRien = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-6.drawer.donne.rien',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? ('ne voit pas ' + (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' champ')) : ('ne voit pas ' + (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' champs')));
	});
var $author$project$I18n$Cles$pipeEtape6DrawerDonneSaisit = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-6.drawer.donne.saisit',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? ('saisit ' + (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' champ')) : ('saisit ' + (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' champs')));
	});
var $author$project$Components$Parametrage$PipeEtape6$Phrases$ceQueCelaDonne = F3(
	function (i18n, droits, resume) {
		return A2(
			$author$project$I18n$Cles$pipeEtape6DrawerDonnePhrase,
			i18n,
			{
				me: droits.me.Bl,
				BY: A2(
					$author$project$I18n$Cles$pipeEtape6DrawerDonneLit,
					i18n,
					{d: resume.sv}),
				qO: A2(
					$author$project$I18n$Cles$pipeEtape6DrawerDonneRien,
					i18n,
					{d: resume.qO}),
				bi: droits.bi.Bl,
				qW: A2(
					$author$project$I18n$Cles$pipeEtape6DrawerDonneSaisit,
					i18n,
					{d: resume.qW})
			});
	});
var $author$project$I18n$Cles$pipeEtape6DrawerDonneTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.drawer.donne.titre', _List_Nil, 'Ce que cela donne');
};
var $author$project$Components$Parametrage$PipeEtape6$Model$resume = function (saisie) {
	var nombre = function (droit) {
		return $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (champ) {
					return _Utils_eq(
						A2($author$project$Components$Parametrage$PipeEtape6$Model$droitDuChamp, saisie, champ.vx),
						droit);
				},
				saisie.B1.dw));
	};
	return {
		qO: nombre('rien'),
		qW: nombre('saisit'),
		sv: nombre('voit')
	};
};
var $author$project$Components$Parametrage$PipeEtape6$View$sectionCeQueCelaDonne = F2(
	function (i18n, saisie) {
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape6DrawerDonneTitre(i18n),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('donne')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A3(
								$author$project$Components$Parametrage$PipeEtape6$Phrases$ceQueCelaDonne,
								i18n,
								saisie.B1,
								$author$project$Components$Parametrage$PipeEtape6$Model$resume(saisie)))
						]))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape6$Update$DroitDeLaCaseChoisi = function (a) {
	return {$: 6, a: a};
};
var $author$project$I18n$Cles$pipeEtape6DrawerCaseRien = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.drawer.case.rien', _List_Nil, 'Le rôle ne voit aucun champ du dossier à cette étape.');
};
var $author$project$I18n$Cles$pipeEtape6DrawerCaseSaisit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.drawer.case.saisit', _List_Nil, 'Remplit et modifie les champs choisis ci-dessous.');
};
var $author$project$I18n$Cles$pipeEtape6DrawerCaseVoit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.drawer.case.voit', _List_Nil, 'Lecture seule, sur les champs choisis ci-dessous.');
};
var $author$project$Components$Parametrage$Vocabulaire$droitAide = F2(
	function (i18n, code) {
		switch (code) {
			case 'saisit':
				return $author$project$I18n$Cles$pipeEtape6DrawerCaseSaisit(i18n);
			case 'voit':
				return $author$project$I18n$Cles$pipeEtape6DrawerCaseVoit(i18n);
			case 'rien':
				return $author$project$I18n$Cles$pipeEtape6DrawerCaseRien(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$I18n$Cles$pipeEtape6DrawerCaseTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.drawer.case.titre', _List_Nil, 'Ce que ce rôle fait à cette étape');
};
var $author$project$Components$Parametrage$PipeEtape6$View$sectionDeLaCase = F2(
	function (i18n, saisie) {
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape6DrawerCaseTitre(i18n),
			A2(
				$elm$core$List$map,
				function (droit) {
					return A6(
						$author$project$Components$Parametrage$Common$Conception$choix,
						$author$project$Components$Parametrage$PipeEtape6$Model$idDuDrawer('case'),
						droit,
						_Utils_eq(saisie.xP, droit),
						A2($author$project$Components$Parametrage$Vocabulaire$droit, i18n, droit),
						A2($author$project$Components$Parametrage$Vocabulaire$droitAide, i18n, droit),
						$author$project$Components$Parametrage$PipeEtape6$Update$DroitDeLaCaseChoisi(droit));
				},
				$author$project$Components$Parametrage$PipeEtape6$Model$droitsPossibles));
	});
var $author$project$Components$Parametrage$PipeEtape6$Update$AutresRolesBascule = function (a) {
	return {$: 8, a: a};
};
var $author$project$I18n$Cles$pipeEtape6DrawerRelationAutresRoles = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-6.drawer.relation.autres-roles',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'roles',
					$author$project$I18n$Traductions$Chaine(p.eX))
				]),
			'Ce rôle voit les autres rôles du dossier (' + (p.eX + ')'));
	});
var $author$project$I18n$Cles$pipeEtape6DrawerRelationTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.drawer.relation.titre', _List_Nil, 'Rôle tenu par une relation');
};
var $author$project$Components$Parametrage$PipeEtape6$View$sectionDeLaRelation = F2(
	function (i18n, saisie) {
		var _v0 = saisie.B1.bi.e9;
		if (!_v0.$) {
			var tenu = _v0.a;
			return _List_fromArray(
				[
					A2(
					$author$project$Components$Parametrage$Common$Conception$drawerSection,
					$author$project$I18n$Cles$pipeEtape6DrawerRelationTitre(i18n),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('encart')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(tenu.Fp)
								])),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (_v1) {
									return _List_fromArray(
										[
											A4(
											$author$project$Components$Parametrage$Common$Conception$caseSimple,
											$author$project$Components$Parametrage$PipeEtape6$Model$idDuDrawer('autres-roles'),
											saisie.KU,
											A2(
												$author$project$I18n$Cles$pipeEtape6DrawerRelationAutresRoles,
												i18n,
												{
													eX: A2($elm$core$String$join, ', ', saisie.B1.t9)
												}),
											$author$project$Components$Parametrage$PipeEtape6$Update$AutresRolesBascule)
										]);
								},
								saisie.B1.KU))))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Parametrage$PipeEtape6$Update$EtapeACopierChoisie = function (a) {
	return {$: 9, a: a};
};
var $author$project$I18n$Cles$pipeEtape6DrawerRepriseChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.drawer.reprise.choisir', _List_Nil, 'Copier depuis l\'étape…');
};
var $author$project$I18n$Cles$pipeEtape6DrawerRepriseTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.drawer.reprise.titre', _List_Nil, 'Reprendre d\'une autre case');
};
var $author$project$Components$Parametrage$PipeEtape6$View$sectionDeLaReprise = F2(
	function (i18n, saisie) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('section-drawer'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('reprise')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape6DrawerRepriseTitre(i18n))
						])),
					A3(
					$rtfeldman$elm_css$Html$Styled$Keyed$node,
					'span',
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('selecteur')
						]),
					_List_fromArray(
						[
							_Utils_Tuple2(
							'reprise|' + saisie.B1.me.r8,
							A2(
								$rtfeldman$elm_css$Html$Styled$select,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('reprise-etape'),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
										'aria-label',
										$author$project$I18n$Cles$pipeEtape6DrawerRepriseChoisir(i18n)),
										$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
										_Utils_eq(
											A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reprendreLesDroitsDUneAutreEtape, saisie.B1.nQ),
											$elm$core$Maybe$Nothing)),
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Parametrage$PipeEtape6$Update$EtapeACopierChoisie)
									]),
								A2(
									$elm$core$List$cons,
									A2(
										$rtfeldman$elm_css$Html$Styled$option,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$value(''),
												$rtfeldman$elm_css$Html$Styled$Attributes$selected(true)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$pipeEtape6DrawerRepriseChoisir(i18n))
											])),
									A2(
										$elm$core$List$map,
										function (etape) {
											return A2(
												$rtfeldman$elm_css$Html$Styled$option,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$value(etape.r8)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(etape.Bl)
													]));
										},
										saisie.B1.yM))))
						]))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape6$Model$champsPersonnelsVisibles = function (saisie) {
	return A2(
		$elm$core$List$filter,
		function (champ) {
			return champ.Ff && (A2($author$project$Components$Parametrage$PipeEtape6$Model$droitDuChamp, saisie, champ.vx) !== 'rien');
		},
		saisie.B1.dw);
};
var $author$project$Components$Parametrage$PipeEtape6$Update$DroitDuChampChoisi = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape6$Model$droitPermis = F3(
	function (saisie, code, droit) {
		return _Utils_cmp(
			$author$project$Components$Parametrage$PipeEtape6$Model$rang(droit),
			$author$project$Components$Parametrage$PipeEtape6$Model$rang(
				A3($author$project$Components$Parametrage$PipeEtape6$Model$plafondDuChamp, saisie, code, saisie.xP))) < 1;
	});
var $author$project$I18n$Cles$pipeEtape6DrawerChampsCalcule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.drawer.champs.calcule', _List_Nil, 'calculé, non saisissable');
};
var $author$project$I18n$Cles$pipeEtape6DrawerChampsPerso = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.drawer.champs.perso', _List_Nil, 'perso');
};
var $author$project$Components$Parametrage$PipeEtape6$View$ligneDeChamp = F3(
	function (i18n, saisie, champ) {
		var courant = A2($author$project$Components$Parametrage$PipeEtape6$Model$droitDuChamp, saisie, champ.vx);
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('champ-de-droit')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(champ.Bl)
						])),
					champ.Ff ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('perso')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape6DrawerChampsPerso(i18n))
						])) : $rtfeldman$elm_css$Html$Styled$text(''),
					champ.uC ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('calcule')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape6DrawerChampsCalcule(i18n))
						])) : $rtfeldman$elm_css$Html$Styled$text(''),
					A3(
					$rtfeldman$elm_css$Html$Styled$Keyed$node,
					'span',
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('selecteur')
						]),
					_List_fromArray(
						[
							_Utils_Tuple2(
							courant + ('|' + saisie.xP),
							A2(
								$rtfeldman$elm_css$Html$Styled$select,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('droit-du-champ'),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', champ.Bl),
										$rtfeldman$elm_css$Html$Styled$Events$onInput(
										$author$project$Components$Parametrage$PipeEtape6$Update$DroitDuChampChoisi(champ.vx))
									]),
								A2(
									$elm$core$List$map,
									function (droit) {
										return A2(
											$rtfeldman$elm_css$Html$Styled$option,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$value(droit),
													$rtfeldman$elm_css$Html$Styled$Attributes$selected(
													_Utils_eq(droit, courant)),
													$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
													!A3($author$project$Components$Parametrage$PipeEtape6$Model$droitPermis, saisie, champ.vx, droit))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2($author$project$Components$Parametrage$Vocabulaire$droit, i18n, droit))
												]));
									},
									$author$project$Components$Parametrage$PipeEtape6$Model$droitsPossibles)))
						]))
				]));
	});
var $author$project$I18n$Cles$pipeEtape6DrawerChampsAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.drawer.champs.aide', _List_Nil, 'Les champs du dossier à cette étape. Un champ en « Rien » n\'est pas envoyé au portail.');
};
var $author$project$I18n$Cles$pipeEtape6DrawerChampsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.drawer.champs.titre', _List_Nil, 'Champs');
};
var $author$project$I18n$Cles$pipeEtape6DrawerChampsVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-6.drawer.champs.vide', _List_Nil, 'Aucun champ du dossier à cette étape.');
};
var $author$project$Components$Parametrage$PipeEtape6$View$sectionDesChamps = F2(
	function (i18n, saisie) {
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape6DrawerChampsTitre(i18n),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape6DrawerChampsAide(i18n))
						])),
					$elm$core$List$isEmpty(saisie.B1.dw) ? A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape6DrawerChampsVide(i18n))
						])) : A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('champs')
						]),
					A2(
						$elm$core$List$map,
						A2($author$project$Components$Parametrage$PipeEtape6$View$ligneDeChamp, i18n, saisie),
						saisie.B1.dw)),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('avertissements')
						]),
					A2(
						$elm$core$List$map,
						function (phrase) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('avertissement')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(phrase)
									]));
						},
						A2(
							$elm$core$List$filterMap,
							function ($) {
								return $.uj;
							},
							$author$project$Components$Parametrage$PipeEtape6$Model$champsPersonnelsVisibles(saisie))))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape6$View$contenuDuDrawer = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple3(model.o_, model.m1, model.hP);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var saisies = _v0.a.a;
			var grille = _v0.b.a;
			return {
				fs: {
					sR: !$author$project$API$Envoi$enCours(model.l2),
					Bl: $author$project$I18n$Cles$pipeEtape6OptionsEnregistrer(i18n),
					C$: $author$project$Components$Parametrage$PipeEtape6$Update$OptionsEnregistrement
				},
				fZ: A2(
					$elm$core$List$cons,
					A2($author$project$Components$Parametrage$PipeEtape6$View$refus, i18n, model),
					A3($author$project$Components$Parametrage$PipeEtape6$View$optionsDuDrawer, i18n, grille, saisies)),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$pipeEtape6OptionsDrawerTitre(i18n)
			};
		} else {
			if (!_v0.c.$) {
				var saisie = _v0.c.a;
				return {
					fs: {
						sR: (!_Utils_eq(
							$author$project$Components$Parametrage$PipeEtape6$Model$droitsVoulus(saisie),
							$elm$core$Maybe$Nothing)) && (!$author$project$API$Envoi$enCours(model.l2)),
						Bl: $author$project$I18n$Cles$pipeEtape6DrawerEnregistrer(i18n),
						C$: $author$project$Components$Parametrage$PipeEtape6$Update$EnregistrementDemande
					},
					fZ: $elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									A2($author$project$Components$Parametrage$PipeEtape6$View$refus, i18n, model),
									A2($author$project$Components$Parametrage$PipeEtape6$View$sectionDeLaCase, i18n, saisie),
									A2($author$project$Components$Parametrage$PipeEtape6$View$sectionDesChamps, i18n, saisie)
								]),
								A2($author$project$Components$Parametrage$PipeEtape6$View$sectionDeLaRelation, i18n, saisie),
								_List_fromArray(
								[
									A2($author$project$Components$Parametrage$PipeEtape6$View$sectionDeLaReprise, i18n, saisie),
									A2($author$project$Components$Parametrage$PipeEtape6$View$sectionCeQueCelaDonne, i18n, saisie)
								])
							])),
					A6: $elm$core$Maybe$Just(
						(saisie.B1.bi.EW ? $author$project$I18n$Cles$pipeEtape6DrawerKickerRelation(i18n) : $author$project$I18n$Cles$pipeEtape6DrawerKicker(i18n))(
							{me: saisie.B1.me.Bl, bi: saisie.B1.bi.Bl})),
					Bc: false,
					h6: $author$project$I18n$Cles$pipeEtape6DrawerTitre(i18n)
				};
			} else {
				return {
					fs: {sR: false, Bl: '', C$: $author$project$Components$Parametrage$PipeEtape6$Update$EnregistrementDemande},
					fZ: _List_Nil,
					A6: $elm$core$Maybe$Nothing,
					Bc: false,
					h6: ''
				};
			}
		}
	});
var $author$project$Components$Parametrage$PipeEtape6$View$videSiFerme = F2(
	function (model, contenu) {
		return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) ? contenu : _Utils_update(
			contenu,
			{fZ: _List_Nil, A6: $elm$core$Maybe$Nothing, h6: ''});
	});
var $author$project$Components$Parametrage$PipeEtape6$View$drawer = F2(
	function (i18n, model) {
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Parametrage$PipeEtape6$Update$DuDrawer,
			A2(
				$author$project$Components$Parametrage$PipeEtape6$View$videSiFerme,
				model,
				A2($author$project$Components$Parametrage$PipeEtape6$View$contenuDuDrawer, i18n, model)),
			model.kX);
	});
var $author$project$Components$Parametrage$PipeEtape6$View$view = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'parametrage-pipe-etape-6',
			{
				ut: A3($author$project$Components$Parametrage$PipeEtape6$View$corps, i18n, messages, model),
				xy: _List_fromArray(
					[
						A2($author$project$Components$Parametrage$PipeEtape6$View$drawer, i18n, model)
					]),
				zM: _List_Nil,
				AK: $author$project$Components$Parametrage$PipeEtape6$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: A2(
							$elm$core$List$cons,
							A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$elm$core$String$join,
											' ',
											A2(
												$elm$core$List$cons,
												$author$project$I18n$Cles$pipeEtape1Introduction(i18n),
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													A2(
														$elm$core$Maybe$map,
														function (edition) {
															return _List_fromArray(
																[
																	A2(
																	$author$project$I18n$Cles$pipeEtape1Exemple,
																	i18n,
																	{
																		Fs: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(edition.R)
																	})
																]);
														},
														model.ge)))))
									])),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (_v0) {
										return _List_fromArray(
											[
												A5($author$project$Components$Parametrage$Common$Conception$bandeau, i18n, $author$project$Routes$Route$adressePipeEtape6, model.vx, model.aS, model.nR)
											]);
									},
									model.ge))),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adressePipes,
								Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
							},
								{
								aa: $author$project$Routes$Route$adressePipes,
								Dj: $author$project$I18n$Cles$pipesTitre(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$pipeEtape1Titre(i18n)
					})
			});
	});
var $author$project$Components$Parametrage$PipeEtape7$View$apercu = F2(
	function (i18n, lu) {
		return A3(
			$author$project$Components$Shared$Parcours$View$apercu,
			i18n,
			$author$project$I18n$Cles$pipeEtape1ApercuTitre(i18n),
			{
				gV: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (apercuLu) {
							return _Utils_ap(
								A2(
									$elm$core$List$concatMap,
									function (groupe) {
										return A2(
											$elm$core$List$cons,
											{dX: true, eW: 0, Jx: groupe.h6},
											A2(
												$elm$core$List$map,
												function (phrase) {
													return {dX: false, eW: 1, Jx: phrase};
												},
												groupe.Fq));
									},
									apercuLu.gV),
								_List_fromArray(
									[
										{dX: false, eW: 0, Jx: apercuLu.uq}
									]));
						},
						lu)),
				h6: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.h6;
					},
					lu)
			});
	});
var $author$project$Components$Parametrage$PipeEtape7$Update$AjoutDemande = {$: 6};
var $author$project$Components$Parametrage$PipeEtape7$Update$AutomatismeDemande = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Parametrage$PipeEtape7$Update$EtatBascule = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Parametrage$Vocabulaire$automatismeActif = function (code) {
	return code === 'actif';
};
var $author$project$I18n$Cles$pipeEtape7EtatActif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.etat.actif', _List_Nil, 'Actif');
};
var $author$project$I18n$Cles$pipeEtape7EtatSuspendu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.etat.suspendu', _List_Nil, 'Suspendu');
};
var $author$project$Components$Parametrage$Vocabulaire$etatDAutomatisme = F2(
	function (i18n, code) {
		switch (code) {
			case 'actif':
				return $author$project$I18n$Cles$pipeEtape7EtatActif(i18n);
			case 'suspendu':
				return $author$project$I18n$Cles$pipeEtape7EtatSuspendu(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$Components$Parametrage$PipeEtape7$View$segments = $elm$core$List$map(
	function (segment) {
		return segment.dX ? A2(
			$rtfeldman$elm_css$Html$Styled$strong,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(segment.Jx)
				])) : $rtfeldman$elm_css$Html$Styled$text(segment.Jx);
	});
var $author$project$I18n$Cles$pipeEtape7TypeActionDuPipe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.type.action-du-pipe', _List_Nil, 'Action du pipe');
};
var $author$project$I18n$Cles$pipeEtape7TypeCalcul = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.type.calcul', _List_Nil, 'Calcul');
};
var $author$project$I18n$Cles$pipeEtape7TypeCalendrier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.type.calendrier', _List_Nil, 'Calendrier');
};
var $author$project$I18n$Cles$pipeEtape7TypeChangementDeRole = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.type.changement-de-role', _List_Nil, 'Changement de rôle');
};
var $author$project$I18n$Cles$pipeEtape7TypeCommunication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.type.communication', _List_Nil, 'Communication');
};
var $author$project$I18n$Cles$pipeEtape7TypeControle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.type.controle', _List_Nil, 'Contrôle');
};
var $author$project$I18n$Cles$pipeEtape7TypeFinDEtape = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.type.fin-d-etape', _List_Nil, 'Fin d\'étape');
};
var $author$project$I18n$Cles$pipeEtape7TypePassageAutomatique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.type.passage-automatique', _List_Nil, 'Passage automatique');
};
var $author$project$I18n$Cles$pipeEtape7TypeReceptionExterne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.type.reception-externe', _List_Nil, 'Réception externe');
};
var $author$project$I18n$Cles$pipeEtape7TypeRelance = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.type.relance', _List_Nil, 'Relance');
};
var $author$project$Components$Parametrage$Vocabulaire$typeDAutomatisme = F2(
	function (i18n, code) {
		switch (code) {
			case 'relance':
				return $author$project$I18n$Cles$pipeEtape7TypeRelance(i18n);
			case 'passage-automatique':
				return $author$project$I18n$Cles$pipeEtape7TypePassageAutomatique(i18n);
			case 'changement-de-role':
				return $author$project$I18n$Cles$pipeEtape7TypeChangementDeRole(i18n);
			case 'fin-d-etape':
				return $author$project$I18n$Cles$pipeEtape7TypeFinDEtape(i18n);
			case 'communication':
				return $author$project$I18n$Cles$pipeEtape7TypeCommunication(i18n);
			case 'calendrier':
				return $author$project$I18n$Cles$pipeEtape7TypeCalendrier(i18n);
			case 'controle':
				return $author$project$I18n$Cles$pipeEtape7TypeControle(i18n);
			case 'calcul':
				return $author$project$I18n$Cles$pipeEtape7TypeCalcul(i18n);
			case 'reception-externe':
				return $author$project$I18n$Cles$pipeEtape7TypeReceptionExterne(i18n);
			case 'action-du-pipe':
				return $author$project$I18n$Cles$pipeEtape7TypeActionDuPipe(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$Components$Parametrage$PipeEtape7$View$ligne = F2(
	function (i18n, automatisme) {
		var pointeur = (!_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$suspendreUnAutomatisme, automatisme.nQ),
			$elm$core$Maybe$Nothing)) || (!_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reprendreUnAutomatisme, automatisme.nQ),
			$elm$core$Maybe$Nothing));
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('automatisme'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'suspendu',
									!$author$project$Components$Parametrage$Vocabulaire$automatismeActif(automatisme.gt))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('ouvrir'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id(
									$author$project$Components$Parametrage$PipeEtape7$Model$idDuDeclencheur('ligne-' + automatisme.r8)),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Parametrage$PipeEtape7$Update$AutomatismeDemande(automatisme.r8))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('etiquette')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2($author$project$Components$Parametrage$Vocabulaire$typeDAutomatisme, i18n, automatisme.r0))
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('phrase')
										]),
									$author$project$Components$Parametrage$PipeEtape7$View$segments(automatisme.Fp.hz)),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('phrase')
										]),
									$author$project$Components$Parametrage$PipeEtape7$View$segments(automatisme.Fp.iM))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('droite')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('commutateur'),
											$rtfeldman$elm_css$Html$Styled$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'allume',
													$author$project$Components$Parametrage$Vocabulaire$automatismeActif(automatisme.gt))
												])),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'switch'),
											A2(
											$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
											'aria-checked',
											$author$project$Components$Parametrage$Vocabulaire$automatismeActif(automatisme.gt) ? 'true' : 'false'),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!pointeur),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Parametrage$PipeEtape7$Update$EtatBascule(automatisme.r8))
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('glissiere')
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('bouton')
														]),
													_List_Nil)
												])),
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$Components$Parametrage$Vocabulaire$etatDAutomatisme, i18n, automatisme.gt))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('chevron'),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('›')
										]))
								]))
						]))
				]));
	});
var $author$project$I18n$Cles$pipeEtape7ListeAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.liste.aide', _List_Nil, 'Chaque automatisme se lit « Quand… alors… ». Il s\'exécute une seule fois par dossier, même en cas de reprise.');
};
var $author$project$I18n$Cles$pipeEtape7ListeAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.liste.ajouter', _List_Nil, 'Ajouter : Automatisme');
};
var $author$project$I18n$Cles$pipeEtape7ListeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.liste.titre', _List_Nil, 'Ce qui se passe tout seul');
};
var $author$project$Components$Parametrage$PipeEtape7$View$automatismes = F3(
	function (i18n, model, lue) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('automatismes')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape7ListeTitre(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape7ListeAide(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('liste')
								]),
							A2(
								$elm$core$List$map,
								$author$project$Components$Parametrage$PipeEtape7$View$ligne(i18n),
								lue.gV)),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('gestes')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout'),
											$rtfeldman$elm_css$Html$Styled$Attributes$id(
											$author$project$Components$Parametrage$PipeEtape7$Model$idDuDeclencheur('ajouter')),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
											_Utils_eq(model.o_, $elm$core$Maybe$Nothing) || _Utils_eq(
												A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ajouterUnAutomatisme, lue.nQ),
												$elm$core$Maybe$Nothing)),
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape7$Update$AjoutDemande)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape7ListeAjouter(i18n))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape7$View$pied = F2(
	function (i18n, code) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pied')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$lien,
					1,
					$author$project$Routes$Route$adressePipeEtape6(code),
					$author$project$I18n$Cles$pipeEtape2Precedente(i18n)),
					A3(
					$author$project$Components$Shared$Bouton$View$lien,
					0,
					$author$project$Routes$Route$adressePipeEtape8(code),
					$author$project$I18n$Cles$pipeEtape1Suivante(i18n))
				]));
	});
var $author$project$I18n$Cles$pipeEtape7ListeConseil = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.liste.conseil', _List_Nil, 'Cliquez un automatisme pour régler son déclencheur, sa condition et son action. Un automatisme suspendu reste écrit, il ne s\'exécute plus.');
};
var $author$project$I18n$Cles$pipeEtape7Question = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.question', _List_Nil, 'Que se passe-t-il tout seul ?');
};
var $author$project$I18n$Cles$pipeEtape7Role = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.role', _List_Nil, 'relance');
};
var $author$project$I18n$Cles$pipeEtape7Texte1 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.texte1', _List_Nil, 'Une ');
};
var $author$project$I18n$Cles$pipeEtape7Texte2 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.texte2', _List_Nil, ', un passage d\'étape, un changement de rôle : vous écrivez quand cela arrive et ce que le dossier fait alors.');
};
var $author$project$Components$Parametrage$PipeEtape7$View$corps = F3(
	function (i18n, messages, model) {
		var _v0 = _Utils_Tuple2(model.nW, model.nf);
		if (!_v0.a.$) {
			var lue = _v0.a.a;
			return _List_fromArray(
				[
					A3($author$project$Components$Parametrage$Common$Conception$etapes, i18n, model.vx, 7),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
						]),
					_List_fromArray(
						[
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('etape')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h2,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape7Question(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('explication')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape7Texte1(i18n)),
											A2(
											$rtfeldman$elm_css$Html$Styled$strong,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$pipeEtape7Role(i18n))
												])),
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape7Texte2(i18n))
										])),
									A3($author$project$Components$Parametrage$PipeEtape7$View$automatismes, i18n, model, lue),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape7ListeConseil(i18n))
										]))
								])),
							A2($author$project$Components$Parametrage$PipeEtape7$View$pied, i18n, model.vx)
						])),
					A2($author$project$Components$Parametrage$PipeEtape7$View$apercu, i18n, lue.tq)
				]);
		} else {
			if (_v0.b) {
				return _List_fromArray(
					[
						A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape1Introuvable(i18n))
							]))
					]);
			} else {
				return model.Ax ? _List_fromArray(
					[
						A3($author$project$Components$Parametrage$Common$Conception$etapes, i18n, model.vx, 7),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						_List_fromArray(
							[
								A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape1Illisible(i18n))
									]))
							]))
					]) : _List_fromArray(
					[
						A2($author$project$Components$Shared$Messages$View$view, i18n, messages)
					]);
			}
		}
	});
var $author$project$Components$Parametrage$PipeEtape7$Update$EnregistrementDemande = {$: 21};
var $author$project$I18n$Cles$pipeEtape7DrawerEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$pipeEtape7DrawerKickerCommunication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.kicker-communication', _List_Nil, 'Envoi d\'une communication');
};
var $author$project$I18n$Cles$pipeEtape7DrawerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.titre', _List_Nil, 'Un automatisme');
};
var $author$project$Components$Parametrage$PipeEtape7$View$refus = F2(
	function (i18n, model) {
		return A2(
			$author$project$Components$Shared$Messages$View$view,
			i18n,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $elm$core$List$singleton, model.pZ)));
	});
var $author$project$Components$Parametrage$PipeEtape7$Update$DestinataireBascule = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape7$Update$SiVideChoisi = function (a) {
	return {$: 20, a: a};
};
var $author$project$I18n$Cles$pipeEtape7DrawerAquiAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.aqui.aide', _List_Nil, 'Un rôle tenu par une relation reçoit la communication comme les autres.');
};
var $author$project$I18n$Cles$pipeEtape7DrawerAquiTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.aqui.titre', _List_Nil, 'À qui');
};
var $author$project$I18n$Cles$pipeEtape7DrawerSivideAlors = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.sivide.alors', _List_Nil, 'Alors');
};
var $author$project$I18n$Cles$pipeEtape7DrawerSivideTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.sivide.titre', _List_Nil, 'Si un rôle n\'a personne');
};
var $author$project$I18n$Cles$pipeEtape7SivideLeMessageNePartPasLeGestionnaireEstAverti = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.sivide.le-message-ne-part-pas-le-gestionnaire-est-averti', _List_Nil, 'Le message ne part pas, le gestionnaire est averti');
};
var $author$project$I18n$Cles$pipeEtape7SivideLeMessagePartAuxAutresEtLaFicheSignaleLeRole = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.sivide.le-message-part-aux-autres-et-la-fiche-signale-le-role', _List_Nil, 'Le message part aux autres, la fiche du dossier signale le rôle manquant');
};
var $author$project$Components$Parametrage$Vocabulaire$siUnRoleEstVideDAutomatisme = F2(
	function (i18n, code) {
		switch (code) {
			case 'le-message-part-aux-autres-et-la-fiche-signale-le-role':
				return $author$project$I18n$Cles$pipeEtape7SivideLeMessagePartAuxAutresEtLaFicheSignaleLeRole(i18n);
			case 'le-message-ne-part-pas-le-gestionnaire-est-averti':
				return $author$project$I18n$Cles$pipeEtape7SivideLeMessageNePartPasLeGestionnaireEstAverti(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$Components$Parametrage$PipeEtape7$View$sectionAQui = F3(
	function (i18n, saisie, options) {
		return (saisie.fs === 'envoyer-une-communication') ? _List_fromArray(
			[
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape7DrawerAquiTitre(i18n),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape7DrawerAquiAide(i18n))
							])),
					A2(
						$elm$core$List$map,
						function (role) {
							return A5(
								$author$project$Components$Parametrage$Common$Conception$caseACocher,
								$author$project$Components$Parametrage$PipeEtape7$Model$idDuDrawer('destinataires'),
								A2($elm$core$List$member, role.H6, saisie.xv),
								role.Bl,
								role.Gd,
								$author$project$Components$Parametrage$PipeEtape7$Update$DestinataireBascule(role.H6));
						},
						options.Ib))),
				A2(
				$author$project$Components$Parametrage$Common$Conception$drawerSection,
				$author$project$I18n$Cles$pipeEtape7DrawerSivideTitre(i18n),
				_List_fromArray(
					[
						A4(
						$author$project$Components$Parametrage$Common$Conception$liste,
						$author$project$I18n$Cles$pipeEtape7DrawerSivideAlors(i18n),
						saisie.c8,
						A2(
							$elm$core$List$map,
							function (code) {
								return _Utils_Tuple2(
									code,
									A2($author$project$Components$Parametrage$Vocabulaire$siUnRoleEstVideDAutomatisme, i18n, code));
							},
							options.ra),
						$author$project$Components$Parametrage$PipeEtape7$Update$SiVideChoisi)
					]))
			]) : _List_Nil;
	});
var $author$project$Components$Parametrage$PipeEtape7$Update$ActionChoisie = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Parametrage$PipeEtape7$Update$DeChoisi = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Parametrage$PipeEtape7$Update$EtapeCibleChoisie = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Parametrage$PipeEtape7$Update$ModeleChoisi = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Parametrage$PipeEtape7$Update$VersChoisi = function (a) {
	return {$: 16, a: a};
};
var $author$project$I18n$Cles$pipeEtape7DrawerChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.choisir', _List_Nil, 'Choisir…');
};
var $author$project$Components$Parametrage$PipeEtape7$View$avecChoisir = F3(
	function (i18n, valeur, choix) {
		return (valeur === '') ? A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'',
				$author$project$I18n$Cles$pipeEtape7DrawerChoisir(i18n)),
			choix) : choix;
	});
var $author$project$I18n$Cles$pipeEtape7DrawerAlorsChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.alors.champ', _List_Nil, 'Champ');
};
var $author$project$I18n$Cles$pipeEtape7DrawerAlorsPour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.alors.pour', _List_Nil, 'Pour');
};
var $author$project$I18n$Cles$pipeEtape7DrawerAlorsValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.alors.valeur', _List_Nil, 'Valeur');
};
var $author$project$I18n$Cles$pipeEtape7ValeurDateDeLancementPlusDelaiDuPays = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.valeur.date-de-lancement-plus-delai-du-pays', _List_Nil, 'Date de lancement + délai du pays du licencié');
};
var $author$project$Components$Parametrage$Vocabulaire$valeurEcrite = F2(
	function (i18n, code) {
		if (code === 'date-de-lancement-plus-delai-du-pays') {
			return $author$project$I18n$Cles$pipeEtape7ValeurDateDeLancementPlusDelaiDuPays(i18n);
		} else {
			var autre = code;
			return autre;
		}
	});
var $author$project$Components$Parametrage$PipeEtape7$View$ecriture = F2(
	function (i18n, lue) {
		var enLecture = F2(
			function (libelle, texte) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('champ')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(libelle)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$select,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$option,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$selected(true)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(texte)
										]))
								]))
						]));
			});
		return _List_fromArray(
			[
				A2(
				enLecture,
				$author$project$I18n$Cles$pipeEtape7DrawerAlorsChamp(i18n),
				lue.uR),
				A2(
				enLecture,
				$author$project$I18n$Cles$pipeEtape7DrawerAlorsPour(i18n),
				lue.F8),
				A2(
				enLecture,
				$author$project$I18n$Cles$pipeEtape7DrawerAlorsValeur(i18n),
				A2($author$project$Components$Parametrage$Vocabulaire$valeurEcrite, i18n, lue.fm))
			]);
	});
var $author$project$I18n$Cles$pipeEtape7DrawerAlorsFourniePar = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-7.drawer.alors.fournie-par',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nomDuModule',
					$author$project$I18n$Traductions$Chaine(p.oA))
				]),
			'Fournie par : ' + p.oA);
	});
var $author$project$I18n$Cles$pipeEtape7DrawerAlorsModuleNonActive = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-7.drawer.alors.module-non-active',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nomDuModule',
					$author$project$I18n$Traductions$Chaine(p.oA))
				]),
			'Module ' + (p.oA + ' non activé'));
	});
var $author$project$Components$Parametrage$PipeEtape7$View$fourniePar = F3(
	function (i18n, saisie, options) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (proposee) {
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('fournie-par')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									(proposee.gt === 'disponible') ? A2(
										$author$project$I18n$Cles$pipeEtape7DrawerAlorsFourniePar,
										i18n,
										{oA: proposee.oe}) : A2(
										$author$project$I18n$Cles$pipeEtape7DrawerAlorsModuleNonActive,
										i18n,
										{oA: proposee.oe}))
								]))
						]);
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (proposee) {
							return _Utils_eq(proposee.fs, saisie.fs);
						},
						options.ft))));
	});
var $author$project$I18n$Cles$pipeEtape7ActionAjouterOuRetirerDUnGroupe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.action.ajouter-ou-retirer-d-un-groupe', _List_Nil, 'Ajouter ou retirer d\'un groupe');
};
var $author$project$I18n$Cles$pipeEtape7ActionAjouterOuRetirerUnTag = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.action.ajouter-ou-retirer-un-tag', _List_Nil, 'Ajouter ou retirer un tag');
};
var $author$project$I18n$Cles$pipeEtape7ActionChangerLeRoleDeLaFiche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.action.changer-le-role-de-la-fiche', _List_Nil, 'Changer le rôle de la fiche');
};
var $author$project$I18n$Cles$pipeEtape7ActionEcrireUneValeurDansUnChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.action.ecrire-une-valeur-dans-un-champ', _List_Nil, 'Écrire une valeur dans un champ');
};
var $author$project$I18n$Cles$pipeEtape7ActionEnvoyerUneCommunication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.action.envoyer-une-communication', _List_Nil, 'Envoyer une communication');
};
var $author$project$I18n$Cles$pipeEtape7ActionLancerUnAutrePipe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.action.lancer-un-autre-pipe', _List_Nil, 'Lancer un autre pipe');
};
var $author$project$I18n$Cles$pipeEtape7ActionPasserAUneEtape = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.action.passer-a-une-etape', _List_Nil, 'Passer à une étape');
};
var $author$project$Components$Parametrage$Vocabulaire$actionDAutomatisme = F2(
	function (i18n, code) {
		switch (code) {
			case 'changer-le-role-de-la-fiche':
				return $author$project$I18n$Cles$pipeEtape7ActionChangerLeRoleDeLaFiche(i18n);
			case 'passer-a-une-etape':
				return $author$project$I18n$Cles$pipeEtape7ActionPasserAUneEtape(i18n);
			case 'envoyer-une-communication':
				return $author$project$I18n$Cles$pipeEtape7ActionEnvoyerUneCommunication(i18n);
			case 'ecrire-une-valeur-dans-un-champ':
				return $author$project$I18n$Cles$pipeEtape7ActionEcrireUneValeurDansUnChamp(i18n);
			case 'ajouter-ou-retirer-un-tag':
				return $author$project$I18n$Cles$pipeEtape7ActionAjouterOuRetirerUnTag(i18n);
			case 'ajouter-ou-retirer-d-un-groupe':
				return $author$project$I18n$Cles$pipeEtape7ActionAjouterOuRetirerDUnGroupe(i18n);
			case 'lancer-un-autre-pipe':
				return $author$project$I18n$Cles$pipeEtape7ActionLancerUnAutrePipe(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$Components$Parametrage$PipeEtape7$View$libelleDAction = F2(
	function (i18n, proposee) {
		return (proposee.gt === 'disponible') ? A2($author$project$Components$Parametrage$Vocabulaire$actionDAutomatisme, i18n, proposee.fs) : (A2($author$project$Components$Parametrage$Vocabulaire$actionDAutomatisme, i18n, proposee.fs) + (' (' + (A2(
			$author$project$I18n$Cles$pipeEtape7DrawerAlorsModuleNonActive,
			i18n,
			{oA: proposee.oe}) + ')')));
	});
var $author$project$Components$Parametrage$PipeEtape7$View$parReference = $elm$core$List$map(
	function (reference) {
		return _Utils_Tuple2(reference.r8, reference.Bl);
	});
var $author$project$I18n$Cles$pipeEtape7DrawerAlorsAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.alors.action', _List_Nil, 'Action');
};
var $author$project$I18n$Cles$pipeEtape7DrawerAlorsDe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.alors.de', _List_Nil, 'De');
};
var $author$project$I18n$Cles$pipeEtape7DrawerAlorsEtape = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.alors.etape', _List_Nil, 'Étape');
};
var $author$project$I18n$Cles$pipeEtape7DrawerAlorsMessage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.alors.message', _List_Nil, 'Message');
};
var $author$project$I18n$Cles$pipeEtape7DrawerAlorsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.alors.titre', _List_Nil, 'Alors');
};
var $author$project$I18n$Cles$pipeEtape7DrawerAlorsVers = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.alors.vers', _List_Nil, 'Vers');
};
var $author$project$Components$Parametrage$PipeEtape7$View$sectionAlors = F3(
	function (i18n, saisie, options) {
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape7DrawerAlorsTitre(i18n),
			A2(
				$elm$core$List$cons,
				A3(
					$rtfeldman$elm_css$Html$Styled$Keyed$node,
					'label',
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('champ')
						]),
					_List_fromArray(
						[
							_Utils_Tuple2(
							'libelle',
							A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape7DrawerAlorsAction(i18n))
									]))),
							_Utils_Tuple2(
							A2(
								$elm$core$String$join,
								'|',
								A2(
									$elm$core$List$cons,
									saisie.fs,
									A2(
										$elm$core$List$map,
										function ($) {
											return $.fs;
										},
										options.ft))),
							A2(
								$rtfeldman$elm_css$Html$Styled$select,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Parametrage$PipeEtape7$Update$ActionChoisie)
									]),
								A2(
									$elm$core$List$map,
									function (proposee) {
										return A2(
											$rtfeldman$elm_css$Html$Styled$option,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$value(proposee.fs),
													$rtfeldman$elm_css$Html$Styled$Attributes$selected(
													_Utils_eq(proposee.fs, saisie.fs)),
													$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
													((!$author$project$Components$Parametrage$PipeEtape7$Model$actionReglable(proposee.fs)) && (!_Utils_eq(proposee.fs, saisie.fs))) || (proposee.gt !== 'disponible'))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2($author$project$Components$Parametrage$PipeEtape7$View$libelleDAction, i18n, proposee))
												]));
									},
									options.ft)))
						])),
				_Utils_ap(
					A3($author$project$Components$Parametrage$PipeEtape7$View$fourniePar, i18n, saisie, options),
					function () {
						var _v0 = saisie.fs;
						switch (_v0) {
							case 'changer-le-role-de-la-fiche':
								return _List_fromArray(
									[
										A4(
										$author$project$Components$Parametrage$Common$Conception$liste,
										$author$project$I18n$Cles$pipeEtape7DrawerAlorsDe(i18n),
										saisie.wC,
										A3(
											$author$project$Components$Parametrage$PipeEtape7$View$avecChoisir,
											i18n,
											saisie.wC,
											$author$project$Components$Parametrage$PipeEtape7$View$parReference(options.Ig)),
										$author$project$Components$Parametrage$PipeEtape7$Update$DeChoisi),
										A4(
										$author$project$Components$Parametrage$Common$Conception$liste,
										$author$project$I18n$Cles$pipeEtape7DrawerAlorsVers(i18n),
										saisie.sn,
										A3(
											$author$project$Components$Parametrage$PipeEtape7$View$avecChoisir,
											i18n,
											saisie.sn,
											$author$project$Components$Parametrage$PipeEtape7$View$parReference(options.Ig)),
										$author$project$Components$Parametrage$PipeEtape7$Update$VersChoisi)
									]);
							case 'passer-a-une-etape':
								return _List_fromArray(
									[
										A4(
										$author$project$Components$Parametrage$Common$Conception$liste,
										$author$project$I18n$Cles$pipeEtape7DrawerAlorsEtape(i18n),
										saisie.cH,
										A3(
											$author$project$Components$Parametrage$PipeEtape7$View$avecChoisir,
											i18n,
											saisie.cH,
											$author$project$Components$Parametrage$PipeEtape7$View$parReference(options.yL)),
										$author$project$Components$Parametrage$PipeEtape7$Update$EtapeCibleChoisie)
									]);
							case 'envoyer-une-communication':
								return _List_fromArray(
									[
										A4(
										$author$project$Components$Parametrage$Common$Conception$liste,
										$author$project$I18n$Cles$pipeEtape7DrawerAlorsMessage(i18n),
										saisie.oa,
										A3(
											$author$project$Components$Parametrage$PipeEtape7$View$avecChoisir,
											i18n,
											saisie.oa,
											$author$project$Components$Parametrage$PipeEtape7$View$parReference(options.CI)),
										$author$project$Components$Parametrage$PipeEtape7$Update$ModeleChoisi)
									]);
							case 'ecrire-une-valeur-dans-un-champ':
								return A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										$author$project$Components$Parametrage$PipeEtape7$View$ecriture(i18n),
										saisie.x4));
							default:
								return _List_Nil;
						}
					}())));
	});
var $author$project$Components$Parametrage$PipeEtape7$Update$DelaiDePaysSaisi = F2(
	function (a, b) {
		return {$: 23, a: a, b: b};
	});
var $author$project$Components$Parametrage$PipeEtape7$Update$DelaisEnregistres = {$: 26};
var $author$project$Components$Parametrage$PipeEtape7$Update$PaysAjoute = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$Parametrage$PipeEtape7$Update$PaysRetire = function (a) {
	return {$: 25, a: a};
};
var $author$project$Components$Parametrage$PipeEtape7$View$origineDesDelais = function (saisie) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (phrase) {
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('origine-des-delais')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(phrase)
							]))
					]);
			},
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.Eq;
				},
				saisie.x4)));
};
var $author$project$I18n$Cles$pipeEtape7EtaAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.eta.ajouter', _List_Nil, 'Ajouter un pays');
};
var $author$project$I18n$Cles$pipeEtape7EtaEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.eta.enregistrer', _List_Nil, 'Enregistrer les délais');
};
var $author$project$I18n$Cles$pipeEtape7EtaRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.eta.retirer', _List_Nil, 'Retirer');
};
var $author$project$I18n$Cles$pipeEtape7EtaSansDelai = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.eta.sans-delai', _List_Nil, 'Si un pays n\'a pas de délai, l\'ETA reste vide et un avertissement l\'indique au collaborateur.');
};
var $author$project$I18n$Cles$pipeEtape7EtaSemaines = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-7.eta.semaines',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'pays',
					$author$project$I18n$Traductions$Chaine(p.ho))
				]),
			'Délai en semaines pour ' + p.ho);
	});
var $author$project$I18n$Cles$pipeEtape7EtaTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.eta.titre', _List_Nil, 'Délais par pays');
};
var $author$project$I18n$Cles$pipeEtape7EtaUnite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.eta.unite', _List_Nil, 'semaines');
};
var $author$project$Components$Parametrage$PipeEtape7$View$sectionDelais = F3(
	function (i18n, saisie, options) {
		var _v0 = _Utils_Tuple2(
			saisie.w5,
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reglerLesDelaisParPays, saisie.nQ));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var delais = _v0.a.a;
			return _List_fromArray(
				[
					A2(
					$author$project$Components$Parametrage$Common$Conception$drawerSection,
					$author$project$I18n$Cles$pipeEtape7EtaTitre(i18n),
					_Utils_ap(
						$author$project$Components$Parametrage$PipeEtape7$View$origineDesDelais(saisie),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								function (d) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('delai-de-pays')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$strong,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(d.ho.Bl)
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('semaines')
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$input,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(d.w3)),
																$rtfeldman$elm_css$Html$Styled$Events$onInput(
																$author$project$Components$Parametrage$PipeEtape7$Update$DelaiDePaysSaisi(d.ho.vx)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
																'aria-label',
																A2(
																	$author$project$I18n$Cles$pipeEtape7EtaSemaines,
																	i18n,
																	{ho: d.ho.Bl}))
															]),
														_List_Nil),
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$pipeEtape7EtaUnite(i18n)),
														A2(
														$rtfeldman$elm_css$Html$Styled$button,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
																$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer'),
																$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
																$rtfeldman$elm_css$Html$Styled$Events$onClick(
																$author$project$Components$Parametrage$PipeEtape7$Update$PaysRetire(d.ho.vx))
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$pipeEtape7EtaRetirer(i18n))
															]))
													]))
											]));
								},
								delais),
							_List_fromArray(
								[
									A4(
									$author$project$Components$Parametrage$Common$Conception$liste,
									$author$project$I18n$Cles$pipeEtape7EtaAjouter(i18n),
									'',
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'',
											$author$project$I18n$Cles$pipeEtape7DrawerChoisir(i18n)),
										A2(
											$elm$core$List$map,
											function (p) {
												return _Utils_Tuple2(p.vx, p.Bl);
											},
											A2(
												$elm$core$List$filter,
												function (p) {
													return !A2(
														$elm$core$List$any,
														function (d) {
															return _Utils_eq(d.ho.vx, p.vx);
														},
														delais);
												},
												options.ho))),
									$author$project$Components$Parametrage$PipeEtape7$Update$PaysAjoute),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('description'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('encart')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape7EtaSansDelai(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('primary'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape7$Update$DelaisEnregistres)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape7EtaEnregistrer(i18n))
										]))
								]))))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$I18n$Cles$pipeEtape7DrawerEnclairTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.enclair.titre', _List_Nil, 'En clair');
};
var $author$project$Components$Parametrage$PipeEtape7$View$enClair = F2(
	function (i18n, saisie) {
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape7DrawerEnclairTitre(i18n),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('donne'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('encart')
						]),
					$author$project$Components$Parametrage$PipeEtape7$View$segments(saisie.yh)),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (note) {
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('description'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('encart')
										]),
									$author$project$Components$Parametrage$PipeEtape7$View$segments(note))
								]);
						},
						saisie.oJ))));
	});
var $author$project$Components$Parametrage$PipeEtape7$View$sectionEnClair = F2(
	function (i18n, saisie) {
		return $elm$core$List$isEmpty(saisie.yh) ? $rtfeldman$elm_css$Html$Styled$text('') : A2($author$project$Components$Parametrage$PipeEtape7$View$enClair, i18n, saisie);
	});
var $author$project$Components$Parametrage$PipeEtape7$Update$DateSaisie = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Parametrage$PipeEtape7$Update$DeclencheurChoisi = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Parametrage$PipeEtape7$Update$DelaiSaisi = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Parametrage$PipeEtape7$Update$EtapeChoisie = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Parametrage$PipeEtape7$Update$TacheChoisie = function (a) {
	return {$: 10, a: a};
};
var $author$project$I18n$Cles$pipeEtape7DrawerQuandEtape = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.quand.etape', _List_Nil, 'Étape');
};
var $author$project$Components$Parametrage$PipeEtape7$View$choixDEtape = F4(
	function (i18n, valeur, options, msg) {
		return A4(
			$author$project$Components$Parametrage$Common$Conception$liste,
			$author$project$I18n$Cles$pipeEtape7DrawerQuandEtape(i18n),
			valeur,
			A3(
				$author$project$Components$Parametrage$PipeEtape7$View$avecChoisir,
				i18n,
				valeur,
				$author$project$Components$Parametrage$PipeEtape7$View$parReference(options.yL)),
			msg);
	});
var $author$project$I18n$Cles$pipeEtape7DeclencheurArriveAUneEtape = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.declencheur.arrive-a-une-etape', _List_Nil, 'Un dossier arrive à une étape');
};
var $author$project$I18n$Cles$pipeEtape7DeclencheurQuitteUneEtape = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.declencheur.quitte-une-etape', _List_Nil, 'Un dossier quitte une étape');
};
var $author$project$I18n$Cles$pipeEtape7DeclencheurResteSansAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.declencheur.reste-sans-action', _List_Nil, 'Un délai passe sans action');
};
var $author$project$I18n$Cles$pipeEtape7DeclencheurUneDateEstAtteinte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.declencheur.une-date-est-atteinte', _List_Nil, 'Une date est atteinte');
};
var $author$project$I18n$Cles$pipeEtape7DeclencheurUneTacheEstTerminee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.declencheur.une-tache-est-terminee', _List_Nil, 'Une tâche est terminée');
};
var $author$project$Components$Parametrage$Vocabulaire$declencheurDAutomatisme = F2(
	function (i18n, code) {
		switch (code) {
			case 'arrive-a-une-etape':
				return $author$project$I18n$Cles$pipeEtape7DeclencheurArriveAUneEtape(i18n);
			case 'quitte-une-etape':
				return $author$project$I18n$Cles$pipeEtape7DeclencheurQuitteUneEtape(i18n);
			case 'une-tache-est-terminee':
				return $author$project$I18n$Cles$pipeEtape7DeclencheurUneTacheEstTerminee(i18n);
			case 'reste-sans-action':
				return $author$project$I18n$Cles$pipeEtape7DeclencheurResteSansAction(i18n);
			case 'une-date-est-atteinte':
				return $author$project$I18n$Cles$pipeEtape7DeclencheurUneDateEstAtteinte(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$I18n$Cles$pipeEtape7DrawerQuandDate = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.quand.date', _List_Nil, 'Date');
};
var $author$project$I18n$Cles$pipeEtape7DrawerQuandDeclencheur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.quand.declencheur', _List_Nil, 'Déclencheur');
};
var $author$project$I18n$Cles$pipeEtape7DrawerQuandDelai = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.quand.delai', _List_Nil, 'Nombre de jours');
};
var $author$project$I18n$Cles$pipeEtape7DrawerQuandTache = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.quand.tache', _List_Nil, 'Tâche');
};
var $author$project$I18n$Cles$pipeEtape7DrawerQuandTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.quand.titre', _List_Nil, 'Quand');
};
var $author$project$Components$Parametrage$PipeEtape7$View$sectionQuand = F3(
	function (i18n, saisie, options) {
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape7DrawerQuandTitre(i18n),
			A2(
				$elm$core$List$cons,
				A4(
					$author$project$Components$Parametrage$Common$Conception$liste,
					$author$project$I18n$Cles$pipeEtape7DrawerQuandDeclencheur(i18n),
					saisie.wQ,
					A2(
						$elm$core$List$map,
						function (code) {
							return _Utils_Tuple2(
								code,
								A2($author$project$Components$Parametrage$Vocabulaire$declencheurDAutomatisme, i18n, code));
						},
						options.wR),
					$author$project$Components$Parametrage$PipeEtape7$Update$DeclencheurChoisi),
				function () {
					var _v0 = saisie.wQ;
					switch (_v0) {
						case 'une-tache-est-terminee':
							return _List_fromArray(
								[
									A4(
									$author$project$Components$Parametrage$Common$Conception$liste,
									$author$project$I18n$Cles$pipeEtape7DrawerQuandTache(i18n),
									saisie.Jj,
									A3(
										$author$project$Components$Parametrage$PipeEtape7$View$avecChoisir,
										i18n,
										saisie.Jj,
										A2(
											$elm$core$List$map,
											function (t) {
												return _Utils_Tuple2(t.r8, t.Bl);
											},
											options.Jk)),
									$author$project$Components$Parametrage$PipeEtape7$Update$TacheChoisie)
								]);
						case 'une-date-est-atteinte':
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$label,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('champ')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$pipeEtape7DrawerQuandDate(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$input,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$type_('date'),
													$rtfeldman$elm_css$Html$Styled$Attributes$value(saisie.wv),
													$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Parametrage$PipeEtape7$Update$DateSaisie)
												]),
											_List_Nil)
										]))
								]);
						case 'reste-sans-action':
							return _List_fromArray(
								[
									A4($author$project$Components$Parametrage$PipeEtape7$View$choixDEtape, i18n, saisie.me, options, $author$project$Components$Parametrage$PipeEtape7$Update$EtapeChoisie),
									A3(
									$author$project$Components$Parametrage$Common$Conception$champDeTexte,
									$author$project$I18n$Cles$pipeEtape7DrawerQuandDelai(i18n),
									saisie.w2,
									$author$project$Components$Parametrage$PipeEtape7$Update$DelaiSaisi)
								]);
						default:
							return _List_fromArray(
								[
									A4($author$project$Components$Parametrage$PipeEtape7$View$choixDEtape, i18n, saisie.me, options, $author$project$Components$Parametrage$PipeEtape7$Update$EtapeChoisie)
								]);
					}
				}()));
	});
var $author$project$Components$Parametrage$PipeEtape7$Update$ConditionSaisie = function (a) {
	return {$: 13, a: a};
};
var $author$project$I18n$Cles$pipeEtape7DrawerSiAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.si.aide', _List_Nil, 'Laissez vide pour agir à chaque fois.');
};
var $author$project$I18n$Cles$pipeEtape7DrawerSiCondition = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.si.condition', _List_Nil, 'Condition');
};
var $author$project$I18n$Cles$pipeEtape7DrawerSiFormules = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.si.formules', _List_Nil, 'Écrite avec les formules des champs du dossier.');
};
var $author$project$I18n$Cles$pipeEtape7DrawerSiTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.si.titre', _List_Nil, 'Seulement si');
};
var $author$project$Components$Parametrage$PipeEtape7$View$sectionSi = F2(
	function (i18n, saisie) {
		return A2(
			$author$project$Components$Parametrage$Common$Conception$drawerSection,
			$author$project$I18n$Cles$pipeEtape7DrawerSiTitre(i18n),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape7DrawerSiAide(i18n))
						])),
					A3(
					$author$project$Components$Parametrage$Common$Conception$champDeTexte,
					$author$project$I18n$Cles$pipeEtape7DrawerSiCondition(i18n),
					saisie.j4,
					$author$project$Components$Parametrage$PipeEtape7$Update$ConditionSaisie),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape7DrawerSiFormules(i18n))
						]))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape7$Update$SuppressionDemandee = {$: 22};
var $author$project$I18n$Cles$pipeEtape7DrawerSupprimer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-7.drawer.supprimer', _List_Nil, 'Supprimer');
};
var $author$project$Components$Parametrage$PipeEtape7$View$sectionSupprimer = F2(
	function (i18n, saisie) {
		var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$supprimerUnAutomatisme, saisie.nQ);
		if (!_v0.$) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$section,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('section-drawer')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape7$Update$SuppressionDemandee)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape7DrawerSupprimer(i18n))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$PipeEtape7$View$contenuDuDrawer = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.hP, model.o_);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var saisie = _v0.a.a;
			var options = _v0.b.a;
			return {
				fs: {
					sR: (!_Utils_eq(
						$author$project$Components$Parametrage$PipeEtape7$Model$aEnregistrer(saisie),
						$elm$core$Maybe$Nothing)) && (!$author$project$API$Envoi$enCours(model.l2)),
					Bl: $author$project$I18n$Cles$pipeEtape7DrawerEnregistrer(i18n),
					C$: $author$project$Components$Parametrage$PipeEtape7$Update$EnregistrementDemande
				},
				fZ: $elm$core$List$concat(
					_List_fromArray(
						[
							_List_fromArray(
							[
								A2($author$project$Components$Parametrage$PipeEtape7$View$refus, i18n, model),
								A3($author$project$Components$Parametrage$PipeEtape7$View$sectionQuand, i18n, saisie, options),
								A2($author$project$Components$Parametrage$PipeEtape7$View$sectionSi, i18n, saisie),
								A3($author$project$Components$Parametrage$PipeEtape7$View$sectionAlors, i18n, saisie, options)
							]),
							A3($author$project$Components$Parametrage$PipeEtape7$View$sectionAQui, i18n, saisie, options),
							A3($author$project$Components$Parametrage$PipeEtape7$View$sectionDelais, i18n, saisie, options),
							_List_fromArray(
							[
								A2($author$project$Components$Parametrage$PipeEtape7$View$sectionEnClair, i18n, saisie),
								A2($author$project$Components$Parametrage$PipeEtape7$View$sectionSupprimer, i18n, saisie)
							])
						])),
				A6: (saisie.r0 === '') ? $elm$core$Maybe$Nothing : ((saisie.r0 === 'communication') ? $elm$core$Maybe$Just(
					$author$project$I18n$Cles$pipeEtape7DrawerKickerCommunication(i18n)) : $elm$core$Maybe$Just(
					A2($author$project$Components$Parametrage$Vocabulaire$typeDAutomatisme, i18n, saisie.r0))),
				Bc: false,
				h6: $author$project$I18n$Cles$pipeEtape7DrawerTitre(i18n)
			};
		} else {
			return {
				fs: {sR: false, Bl: '', C$: $author$project$Components$Parametrage$PipeEtape7$Update$EnregistrementDemande},
				fZ: _List_Nil,
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: ''
			};
		}
	});
var $author$project$Components$Parametrage$PipeEtape7$View$videSiFerme = F2(
	function (model, contenu) {
		return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) ? contenu : _Utils_update(
			contenu,
			{fZ: _List_Nil, A6: $elm$core$Maybe$Nothing, h6: ''});
	});
var $author$project$Components$Parametrage$PipeEtape7$View$drawer = F2(
	function (i18n, model) {
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Parametrage$PipeEtape7$Update$DuDrawer,
			A2(
				$author$project$Components$Parametrage$PipeEtape7$View$videSiFerme,
				model,
				A2($author$project$Components$Parametrage$PipeEtape7$View$contenuDuDrawer, i18n, model)),
			model.kX);
	});
var $author$project$Components$Parametrage$PipeEtape7$View$view = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'parametrage-pipe-etape-7',
			{
				ut: A3($author$project$Components$Parametrage$PipeEtape7$View$corps, i18n, messages, model),
				xy: _List_fromArray(
					[
						A2($author$project$Components$Parametrage$PipeEtape7$View$drawer, i18n, model)
					]),
				zM: _List_Nil,
				AK: $author$project$Components$Parametrage$PipeEtape7$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: A2(
							$elm$core$List$cons,
							A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$elm$core$String$join,
											' ',
											A2(
												$elm$core$List$cons,
												$author$project$I18n$Cles$pipeEtape1Introduction(i18n),
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													A2(
														$elm$core$Maybe$map,
														function (edition) {
															return _List_fromArray(
																[
																	A2(
																	$author$project$I18n$Cles$pipeEtape1Exemple,
																	i18n,
																	{
																		Fs: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(edition.R)
																	})
																]);
														},
														model.ge)))))
									])),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (_v0) {
										return _List_fromArray(
											[
												A5($author$project$Components$Parametrage$Common$Conception$bandeau, i18n, $author$project$Routes$Route$adressePipeEtape7, model.vx, model.aS, model.nR)
											]);
									},
									model.ge))),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adressePipes,
								Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
							},
								{
								aa: $author$project$Routes$Route$adressePipes,
								Dj: $author$project$I18n$Cles$pipesTitre(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$pipeEtape1Titre(i18n)
					})
			});
	});
var $author$project$I18n$Cles$pipeEtape8ApercuErreurs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-8.apercu.erreurs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' erreur à corriger avant de publier') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' erreurs à corriger avant de publier'));
	});
var $author$project$I18n$Cles$pipeEtape8ApercuPret = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-8.apercu.pret', _List_Nil, 'Aucune erreur : prêt à publier');
};
var $author$project$Components$Parametrage$PipeEtape8$View$bilanDeLApercu = F2(
	function (i18n, lue) {
		return (!lue.uq.gp) ? $author$project$I18n$Cles$pipeEtape8ApercuPret(i18n) : A2(
			$author$project$I18n$Cles$pipeEtape8ApercuErreurs,
			i18n,
			{w: lue.uq.gp});
	});
var $author$project$I18n$Cles$pipeEtape8ApercuAPublier = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-8.apercu.a-publier',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'version',
					$author$project$I18n$Traductions$Chaine(p.sq))
				]),
			'Version ' + (p.sq + ' (à publier)'));
	});
var $author$project$I18n$Cles$pipeEtape8ApercuAucunNeBouge = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-8.apercu.aucun-ne-bouge', _List_Nil, 'Aucun ne bouge sans votre geste');
};
var $author$project$I18n$Cles$pipeEtape8ApercuDossiersEnCours = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-8.apercu.dossiers-en-cours',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Entier(p.JE))
				]),
			((!p.JE) || (p.JE === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.JE) + ' dossier en cours, aucun nouveau') : (A2($author$project$I18n$Nombre$formater, 0, p.JE) + ' dossiers en cours, aucun nouveau'));
	});
var $author$project$I18n$Cles$pipeEtape8ApercuEnLigne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-8.apercu.en-ligne',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'version',
					$author$project$I18n$Traductions$Chaine(p.sq))
				]),
			'Version ' + (p.sq + ' (en ligne)'));
	});
var $author$project$I18n$Cles$pipeEtape8ApercuExistants = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-8.apercu.existants', _List_Nil, 'Dossiers existants');
};
var $author$project$I18n$Cles$pipeEtape8ApercuNouveaux = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-8.apercu.nouveaux', _List_Nil, 'Tous les nouveaux dossiers');
};
var $author$project$I18n$Cles$pipeEtape8ApercuTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-8.apercu.titre', _List_Nil, 'Ce que la publication change');
};
var $author$project$Components$Parametrage$PipeEtape8$View$apercu = F2(
	function (i18n, lue) {
		return A3(
			$author$project$Components$Shared$Parcours$View$apercu,
			i18n,
			$author$project$I18n$Cles$pipeEtape1ApercuTitre(i18n),
			{
				gV: $elm$core$List$concat(
					_List_fromArray(
						[
							function () {
							var _v0 = lue.xJ.KG;
							if (!_v0.$) {
								var reference = _v0.a;
								return _List_fromArray(
									[
										{
										dX: true,
										eW: 0,
										Jx: A2(
											$author$project$I18n$Cles$pipeEtape8ApercuEnLigne,
											i18n,
											{
												sq: $elm$core$String$fromInt(reference)
											})
									},
										{
										dX: false,
										eW: 1,
										Jx: A2(
											$author$project$I18n$Cles$pipeEtape8ApercuDossiersEnCours,
											i18n,
											{JE: lue.xJ.JE})
									}
									]);
							} else {
								return _List_Nil;
							}
						}(),
							_List_fromArray(
							[
								{
								dX: true,
								eW: 0,
								Jx: A2(
									$author$project$I18n$Cles$pipeEtape8ApercuAPublier,
									i18n,
									{
										sq: $elm$core$String$fromInt(lue.DX)
									})
							},
								{
								dX: false,
								eW: 1,
								Jx: $author$project$I18n$Cles$pipeEtape8ApercuNouveaux(i18n)
							},
								{
								dX: true,
								eW: 0,
								Jx: $author$project$I18n$Cles$pipeEtape8ApercuExistants(i18n)
							},
								{
								dX: false,
								eW: 1,
								Jx: $author$project$I18n$Cles$pipeEtape8ApercuAucunNeBouge(i18n)
							},
								{
								dX: true,
								eW: 0,
								Jx: A2($author$project$Components$Parametrage$PipeEtape8$View$bilanDeLApercu, i18n, lue)
							}
							])
						])),
				h6: $elm$core$Maybe$Just(
					$author$project$I18n$Cles$pipeEtape8ApercuTitre(i18n))
			});
	});
var $author$project$I18n$Cles$pipeEtape8ChangementsPremiere = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-8.changements.premiere', _List_Nil, 'Première version : il n\'y a pas de version précédente à comparer.');
};
var $author$project$I18n$Cles$pipeEtape8ChangementsTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-8.changements.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'version',
					$author$project$I18n$Traductions$Chaine(p.sq))
				]),
			'Ce qui change depuis la version ' + p.sq);
	});
var $author$project$Components$Parametrage$PipeEtape8$View$changements = F2(
	function (i18n, lue) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('changements')
				]),
			function () {
				var _v0 = _Utils_Tuple2(lue.KF, lue.u3);
				if (!_v0.a.$) {
					if (_v0.b.b) {
						var reference = _v0.a.a;
						var _v1 = _v0.b;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$h3,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$pipeEtape8ChangementsTitre,
													i18n,
													{
														sq: $elm$core$String$fromInt(reference)
													}))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$ul,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('liste')
									]),
								A2(
									$elm$core$List$map,
									function (c) {
										return A2(
											$rtfeldman$elm_css$Html$Styled$li,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(c.Jx)
												]));
									},
									lue.u3))
							]);
					} else {
						return _List_Nil;
					}
				} else {
					var _v2 = _v0.a;
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape8ChangementsPremiere(i18n))
								]))
						]);
				}
			}());
	});
var $author$project$Components$Parametrage$PipeEtape8$View$classeDuNiveau = function (niveau) {
	switch (niveau) {
		case 0:
			return 'erreur';
		case 1:
			return 'avertissement';
		default:
			return 'ok';
	}
};
var $author$project$Components$Parametrage$PipeEtape8$View$couleurDuNiveau = function (niveau) {
	switch (niveau) {
		case 0:
			return 2;
		case 1:
			return 1;
		default:
			return 0;
	}
};
var $author$project$API$NavLinksDictionary$corriger = 'corriger';
var $author$project$I18n$Cles$pipeEtape8GesteCorriger = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-8.geste.corriger', _List_Nil, 'Corriger');
};
var $author$project$I18n$Cles$pipeEtape8GesteRegler = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-8.geste.regler', _List_Nil, 'Régler');
};
var $author$project$I18n$Cles$pipeEtape8GesteVoir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-8.geste.voir', _List_Nil, 'Voir');
};
var $author$project$API$NavLinksDictionary$regler = 'regler';
var $author$project$API$NavLinksDictionary$voir = 'voir';
var $author$project$Components$Parametrage$PipeEtape8$View$libelleDuGeste = F2(
	function (i18n, c) {
		return (!_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$corriger, c.nQ),
			$elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(
			$author$project$I18n$Cles$pipeEtape8GesteCorriger(i18n)) : ((!_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$regler, c.nQ),
			$elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(
			$author$project$I18n$Cles$pipeEtape8GesteRegler(i18n)) : ((!_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$voir, c.nQ),
			$elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(
			$author$project$I18n$Cles$pipeEtape8GesteVoir(i18n)) : $elm$core$Maybe$Nothing));
	});
var $author$project$Components$Parametrage$PipeEtape8$View$geste = F3(
	function (i18n, code, c) {
		var _v0 = _Utils_Tuple2(
			c.me,
			A2($author$project$Components$Parametrage$PipeEtape8$View$libelleDuGeste, i18n, c));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var etape = _v0.a.a;
			var libelle = _v0.b.a;
			return A3(
				$author$project$Components$Shared$Bouton$View$lien,
				1,
				A2($author$project$Components$Parametrage$Common$Conception$adresseDe, etape, code),
				libelle);
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$pipeEtape8NiveauAvertissement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-8.niveau.avertissement', _List_Nil, 'Avertissement');
};
var $author$project$I18n$Cles$pipeEtape8NiveauErreur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-8.niveau.erreur', _List_Nil, 'Erreur');
};
var $author$project$I18n$Cles$pipeEtape8NiveauOk = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-8.niveau.ok', _List_Nil, 'OK');
};
var $author$project$Components$Parametrage$PipeEtape8$View$libelleDuNiveau = F2(
	function (i18n, niveau) {
		switch (niveau) {
			case 0:
				return $author$project$I18n$Cles$pipeEtape8NiveauErreur(i18n);
			case 1:
				return $author$project$I18n$Cles$pipeEtape8NiveauAvertissement(i18n);
			default:
				return $author$project$I18n$Cles$pipeEtape8NiveauOk(i18n);
		}
	});
var $author$project$Components$Parametrage$PipeEtape8$View$controle = F3(
	function (i18n, code, c) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('controle'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					$author$project$Components$Parametrage$PipeEtape8$View$classeDuNiveau(c.os))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							$author$project$Components$Parametrage$PipeEtape8$View$couleurDuNiveau(c.os),
							A2($author$project$Components$Parametrage$PipeEtape8$View$libelleDuNiveau, i18n, c.os)),
							$rtfeldman$elm_css$Html$Styled$text(c.Jx)
						])),
					A3($author$project$Components$Parametrage$PipeEtape8$View$geste, i18n, code, c)
				]));
	});
var $author$project$I18n$Cles$pipeEtape8ControlesAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-8.controles.aide', _List_Nil, 'Une erreur bloque la publication. Un avertissement ne la bloque pas.');
};
var $author$project$I18n$Cles$pipeEtape8ControlesTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-8.controles.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'version',
					$author$project$I18n$Traductions$Chaine(p.sq))
				]),
			'Contrôles de la version ' + p.sq);
	});
var $author$project$Components$Parametrage$PipeEtape8$View$controles = F3(
	function (i18n, code, lue) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('controles-de-la-version')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$pipeEtape8ControlesTitre,
										i18n,
										{
											sq: $elm$core$String$fromInt(lue.DX)
										}))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape8ControlesAide(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('controles')
								]),
							A2(
								$elm$core$List$map,
								A2($author$project$Components$Parametrage$PipeEtape8$View$controle, i18n, code),
								lue.wc))
						]))
				]));
	});
var $author$project$I18n$Cles$pipeEtape8DossiersNombre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-8.dossiers.nombre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' dossier') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' dossiers'));
	});
var $author$project$I18n$Cles$pipeEtape8DossiersTexte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-8.dossiers.texte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Entier(p.JE)),
					_Utils_Tuple2(
					'version',
					$author$project$I18n$Traductions$Chaine(p.sq)),
					_Utils_Tuple2(
					'nouvelle',
					$author$project$I18n$Traductions$Chaine(p.oS))
				]),
			((!p.JE) || (p.JE === 1)) ? ('À la publication, ce dossier reste sur la version ' + (p.sq + ('. Vous les passez à la version ' + (p.oS + ' ensuite, un par un, en groupe ou tous d\'un coup.')))) : ('À la publication, ces ' + (A2($author$project$I18n$Nombre$formater, 0, p.JE) + (' dossiers restent sur la version ' + (p.sq + ('. Vous les passez à la version ' + (p.oS + ' ensuite, un par un, en groupe ou tous d\'un coup.')))))));
	});
var $author$project$I18n$Cles$pipeEtape8DossiersTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-8.dossiers.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'version',
					$author$project$I18n$Traductions$Chaine(p.sq))
				]),
			'Dossiers en cours sur la version ' + p.sq);
	});
var $author$project$I18n$Cles$pipeEtape8Migration = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-8.migration', _List_Nil, 'Préparer la migration des dossiers');
};
var $author$project$Components$Parametrage$PipeEtape8$View$dossiers = F2(
	function (i18n, lue) {
		var _v0 = lue.xJ.KG;
		if (!_v0.$) {
			var reference = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$section,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('dossiers')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$h3,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$pipeEtape8DossiersTitre,
											i18n,
											{
												sq: $elm$core$String$fromInt(reference)
											}))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$pipeEtape8DossiersTexte,
									i18n,
									{
										oS: $elm$core$String$fromInt(lue.DX),
										JE: lue.xJ.JE,
										sq: $elm$core$String$fromInt(reference)
									}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('liste')
							]),
						A2(
							$elm$core$List$map,
							function (etape) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(etape.Bl)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('nombre')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$author$project$I18n$Cles$pipeEtape8DossiersNombre,
														i18n,
														{w: etape.w}))
												]))
										]));
							},
							lue.xJ.EO)),
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('migration'),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
							]),
						$author$project$I18n$Cles$pipeEtape8Migration(i18n))
					]));
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$section,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('dossiers')
					]),
				_List_Nil);
		}
	});
var $author$project$Components$Parametrage$PipeEtape8$Update$PublicationDemandee = {$: 5};
var $author$project$Components$Parametrage$PipeEtape8$Update$VerificationRelancee = {$: 4};
var $author$project$I18n$Cles$pipeEtape8AucuneErreur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-8.aucune-erreur', _List_Nil, 'Aucune erreur : la version peut être publiée.');
};
var $author$project$I18n$Cles$pipeEtape8ErreursARecorriger = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-8.erreurs-a-recorriger',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' erreur à corriger') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' erreurs à corriger'));
	});
var $author$project$Components$Parametrage$PipeEtape8$View$bilan = F2(
	function (i18n, erreurs) {
		return (!erreurs) ? $author$project$I18n$Cles$pipeEtape8AucuneErreur(i18n) : A2(
			$author$project$I18n$Cles$pipeEtape8ErreursARecorriger,
			i18n,
			{w: erreurs});
	});
var $author$project$Components$Parametrage$PipeEtape8$View$enLigne = function (lue) {
	return lue.ri === 'publiee';
};
var $author$project$Components$Parametrage$PipeEtape8$Model$peutPublier = function (model) {
	return !_Utils_eq(
		A2(
			$elm$core$Maybe$andThen,
			function (verification) {
				return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$publierLaVersion, verification.nQ);
			},
			model.ij),
		$elm$core$Maybe$Nothing);
};
var $author$project$I18n$Cles$pipeEtape8Publiee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-8.publiee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'version',
					$author$project$I18n$Traductions$Chaine(p.sq))
				]),
			'La version ' + (p.sq + ' est en ligne : les nouveaux dossiers l\'utilisent.'));
	});
var $author$project$I18n$Cles$pipeEtape8Publier = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-8.publier',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'version',
					$author$project$I18n$Traductions$Chaine(p.sq))
				]),
			'Publier la version ' + p.sq);
	});
var $author$project$I18n$Cles$pipeEtape8Relancer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-8.relancer', _List_Nil, 'Relancer la vérification');
};
var $author$project$I18n$Cles$pipeEtape8VoirLesVersions = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-8.voir-les-versions', _List_Nil, 'Voir les versions');
};
var $author$project$Components$Parametrage$PipeEtape8$View$gestes = F3(
	function (i18n, model, lue) {
		return $author$project$Components$Parametrage$PipeEtape8$View$enLigne(lue) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('gestes')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('publiee')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$pipeEtape8Publiee,
								i18n,
								{
									sq: $elm$core$String$fromInt(lue.DX)
								}))
						])),
					A3(
					$author$project$Components$Shared$Bouton$View$lien,
					1,
					$author$project$Routes$Route$adresseVersionsDuPipe(model.vx),
					$author$project$I18n$Cles$pipeEtape8VoirLesVersions(i18n))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('gestes')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					0,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('publier'),
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
							!$author$project$Components$Parametrage$PipeEtape8$Model$peutPublier(model)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape8$Update$PublicationDemandee)
						]),
					A2(
						$author$project$I18n$Cles$pipeEtape8Publier,
						i18n,
						{
							sq: $elm$core$String$fromInt(lue.DX)
						})),
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('relancer'),
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeEtape8$Update$VerificationRelancee)
						]),
					$author$project$I18n$Cles$pipeEtape8Relancer(i18n)),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('bilan')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Parametrage$PipeEtape8$View$bilan, i18n, lue.uq.gp))
						]))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape8$View$pied = F2(
	function (i18n, code) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pied')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$lien,
					1,
					$author$project$Routes$Route$adressePipeEtape7(code),
					$author$project$I18n$Cles$pipeEtape2Precedente(i18n))
				]));
	});
var $author$project$I18n$Cles$pipeEtape8Question = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-8.question', _List_Nil, 'Le pipe est-il prêt ?');
};
var $author$project$I18n$Cles$pipeEtape8Role = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-8.role', _List_Nil, 'vérification');
};
var $author$project$I18n$Cles$pipeEtape8Texte1 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-8.texte-1', _List_Nil, 'La ');
};
var $author$project$I18n$Cles$pipeEtape8Texte2 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-8.texte-2', _List_Nil, ' relit tout le pipe. Quand il n\'y a plus d\'erreur, vous publiez : la version devient celle des nouveaux dossiers.');
};
var $author$project$I18n$Cles$pipeEtape8VersionsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-8.versions.titre', _List_Nil, 'Versions');
};
var $author$project$I18n$Cles$pipeEtape8VersionsNumero = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-8.versions.numero',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'numero',
					$author$project$I18n$Traductions$Chaine(p.DX))
				]),
			'Version ' + p.DX);
	});
var $author$project$I18n$Cles$pipeEtape8VersionsDossiers = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-8.versions.dossiers',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' dossier en cours') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' dossiers en cours'));
	});
var $author$project$Components$Parametrage$PipeEtape8$View$dossiersDeLaVersion = F2(
	function (i18n, v) {
		return A2(
			$author$project$I18n$Cles$pipeEtape8VersionsDossiers,
			i18n,
			{w: v.xK});
	});
var $author$project$I18n$Cles$pipeEtape8VersionsBasee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-8.versions.basee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'base',
					$author$project$I18n$Traductions$Chaine(p.jo))
				]),
			'Basée sur la version ' + p.jo);
	});
var $author$project$I18n$Cles$pipeEtape8VersionsPublieePar = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-etape-8.versions.publiee-par',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'par',
					$author$project$I18n$Traductions$Chaine(p.EK))
				]),
			'Publiée par ' + p.EK);
	});
var $author$project$Components$Parametrage$PipeEtape8$View$publieePar = F2(
	function (i18n, v) {
		return (v.GE === '') ? '' : A2(
			$author$project$I18n$Cles$pipeEtape8VersionsPublieePar,
			i18n,
			{EK: v.GE});
	});
var $author$project$Components$Parametrage$PipeEtape8$View$precisionDeLaVersion = F2(
	function (i18n, v) {
		var _v0 = _Utils_Tuple2(v.ri, v.jp);
		if (_v0.a === 'brouillon') {
			if (!_v0.b.$) {
				var base = _v0.b.a;
				return A2(
					$author$project$I18n$Cles$pipeEtape8VersionsBasee,
					i18n,
					{
						jo: $elm$core$String$fromInt(base)
					});
			} else {
				var _v1 = _v0.b;
				return '';
			}
		} else {
			return A2(
				$elm$core$String$join,
				' · ',
				A2(
					$elm$core$List$filter,
					function (texte) {
						return texte !== '';
					},
					_List_fromArray(
						[
							A2($author$project$Components$Parametrage$PipeEtape8$View$publieePar, i18n, v),
							A2($author$project$Components$Parametrage$PipeEtape8$View$dossiersDeLaVersion, i18n, v)
						])));
		}
	});
var $author$project$I18n$Cles$pipeEtape8StatutEnLigne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-etape-8.statut-en-ligne', _List_Nil, 'En ligne');
};
var $author$project$I18n$Cles$pipeVersionsStatutArchivee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.statut-archivee', _List_Nil, 'Archivée');
};
var $author$project$I18n$Cles$pipeVersionsStatutBrouillon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.statut-brouillon', _List_Nil, 'Brouillon');
};
var $author$project$Components$Parametrage$PipeEtape8$View$statut = F2(
	function (i18n, code) {
		switch (code) {
			case 'brouillon':
				return A2(
					$author$project$Components$Shared$Tag$View$view,
					1,
					$author$project$I18n$Cles$pipeVersionsStatutBrouillon(i18n));
			case 'publiee':
				return A2(
					$author$project$Components$Shared$Tag$View$view,
					0,
					$author$project$I18n$Cles$pipeEtape8StatutEnLigne(i18n));
			case 'retiree':
				return A2(
					$author$project$Components$Shared$Tag$View$view,
					3,
					$author$project$I18n$Cles$pipeVersionsStatutArchivee(i18n));
			default:
				var autre = code;
				return $rtfeldman$elm_css$Html$Styled$text(autre);
		}
	});
var $author$project$Components$Parametrage$PipeEtape8$View$version = F2(
	function (i18n, v) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('version')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('numero')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$pipeEtape8VersionsNumero,
								i18n,
								{
									DX: $elm$core$String$fromInt(v.DX)
								}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Parametrage$PipeEtape8$View$precisionDeLaVersion, i18n, v))
						])),
					A2($author$project$Components$Parametrage$PipeEtape8$View$statut, i18n, v.ri)
				]));
	});
var $author$project$Components$Parametrage$PipeEtape8$View$versions = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('versions')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape8VersionsTitre(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('voir-les-versions'),
									$rtfeldman$elm_css$Html$Styled$Attributes$href(
									$author$project$Routes$Route$adresseVersionsDuPipe(model.vx))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeEtape8VoirLesVersions(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('liste')
						]),
					A2(
						$elm$core$List$map,
						$author$project$Components$Parametrage$PipeEtape8$View$version(i18n),
						model.ss))
				]));
	});
var $author$project$Components$Parametrage$PipeEtape8$View$corps = F3(
	function (i18n, messages, model) {
		var _v0 = _Utils_Tuple2(model.ij, model.nf);
		if (!_v0.a.$) {
			var lue = _v0.a.a;
			return _List_fromArray(
				[
					A3($author$project$Components$Parametrage$Common$Conception$etapes, i18n, model.vx, 8),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Messages$View$view,
							i18n,
							_Utils_ap(
								messages,
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2($elm$core$Maybe$map, $elm$core$List$singleton, model.pZ)))),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('etape')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h2,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape8Question(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('explication')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape8Texte1(i18n)),
											A2(
											$rtfeldman$elm_css$Html$Styled$strong,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$pipeEtape8Role(i18n))
												])),
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeEtape8Texte2(i18n))
										])),
									A3($author$project$Components$Parametrage$PipeEtape8$View$controles, i18n, model.vx, lue),
									A3($author$project$Components$Parametrage$PipeEtape8$View$gestes, i18n, model, lue),
									A2($author$project$Components$Parametrage$PipeEtape8$View$changements, i18n, lue),
									A2($author$project$Components$Parametrage$PipeEtape8$View$versions, i18n, model),
									A2($author$project$Components$Parametrage$PipeEtape8$View$dossiers, i18n, lue)
								])),
							A2($author$project$Components$Parametrage$PipeEtape8$View$pied, i18n, model.vx)
						])),
					A2($author$project$Components$Parametrage$PipeEtape8$View$apercu, i18n, lue)
				]);
		} else {
			if (_v0.b) {
				return _List_fromArray(
					[
						A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeEtape1Introuvable(i18n))
							]))
					]);
			} else {
				return _List_fromArray(
					[
						A2($author$project$Components$Shared$Messages$View$view, i18n, messages)
					]);
			}
		}
	});
var $author$project$Components$Parametrage$PipeEtape8$View$view = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'parametrage-pipe-etape-8',
			{
				ut: A3($author$project$Components$Parametrage$PipeEtape8$View$corps, i18n, messages, model),
				xy: _List_Nil,
				zM: _List_Nil,
				AK: false,
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: A2(
							$elm$core$List$cons,
							A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$elm$core$String$join,
											' ',
											A2(
												$elm$core$List$cons,
												$author$project$I18n$Cles$pipeEtape1Introduction(i18n),
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													A2(
														$elm$core$Maybe$map,
														function (edition) {
															return _List_fromArray(
																[
																	A2(
																	$author$project$I18n$Cles$pipeEtape1Exemple,
																	i18n,
																	{
																		Fs: $author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(edition.R)
																	})
																]);
														},
														model.ge)))))
									])),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (_v0) {
										return _List_fromArray(
											[
												A5($author$project$Components$Parametrage$Common$Conception$bandeau, i18n, $author$project$Routes$Route$adressePipeEtape8, model.vx, model.aS, model.nR)
											]);
									},
									model.ge))),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adressePipes,
								Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
							},
								{
								aa: $author$project$Routes$Route$adressePipes,
								Dj: $author$project$I18n$Cles$pipesTitre(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$pipeEtape1Titre(i18n)
					})
			});
	});
var $author$project$Components$Parametrage$PipeOffreUsage$View$couleurDeLaSource = function (code) {
	return (code === 'offre-fixe') ? 3 : 5;
};
var $author$project$I18n$Cles$pipeOffreUsageObjetAutomatisme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-offre-usage.objet-automatisme', _List_Nil, 'automatisme');
};
var $author$project$I18n$Cles$pipeOffreUsageObjetTache = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-offre-usage.objet-tache', _List_Nil, 'tâche');
};
var $author$project$Components$Parametrage$Vocabulaire$objetDeLOffre = F2(
	function (i18n, code) {
		switch (code) {
			case 'tache':
				return $author$project$I18n$Cles$pipeOffreUsageObjetTache(i18n);
			case 'automatisme':
				return $author$project$I18n$Cles$pipeOffreUsageObjetAutomatisme(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$Components$Parametrage$PipeOffreUsage$View$objet = F2(
	function (i18n, code) {
		return A2($author$project$Components$Parametrage$Vocabulaire$objetDeLOffre, i18n, code);
	});
var $author$project$I18n$Cles$pipeOffreUsageOu = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-offre-usage.ou',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etape',
					$author$project$I18n$Traductions$Chaine(p.me)),
					_Utils_Tuple2(
					'objet',
					$author$project$I18n$Traductions$Chaine(p.DZ)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Étape « ' + (p.me + (' » · ' + (p.DZ + (' ' + p.Dj)))));
	});
var $author$project$Components$Parametrage$PipeOffreUsage$View$ou = F2(
	function (i18n, usage) {
		return A2(
			$author$project$I18n$Cles$pipeOffreUsageOu,
			i18n,
			{
				me: usage.me,
				Dj: usage.Dj,
				DZ: A2($author$project$Components$Parametrage$PipeOffreUsage$View$objet, i18n, usage.DZ)
			});
	});
var $author$project$I18n$Cles$pipeOffreUsagePayeurParRelation = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-offre-usage.payeur-par-relation',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'payeur',
					$author$project$I18n$Traductions$Chaine(p.E7))
				]),
			p.E7 + ' (par relation)');
	});
var $author$project$Components$Parametrage$PipeOffreUsage$View$payeur = F2(
	function (i18n, usage) {
		return $elm$core$String$isEmpty(usage.E7) ? $author$project$I18n$Cles$pipesSansValeur(i18n) : (usage.E8 ? A2(
			$author$project$I18n$Cles$pipeOffreUsagePayeurParRelation,
			i18n,
			{E7: usage.E7}) : usage.E7);
	});
var $author$project$I18n$Cles$pipeOffreUsageSourceDuDossier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-offre-usage.source-du-dossier', _List_Nil, 'Offre du dossier');
};
var $author$project$I18n$Cles$pipeOffreUsageSourceFixe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-offre-usage.source-fixe', _List_Nil, 'Offre fixe');
};
var $author$project$Components$Parametrage$Vocabulaire$sourceDeLOffre = F2(
	function (i18n, code) {
		switch (code) {
			case 'offre-fixe':
				return $author$project$I18n$Cles$pipeOffreUsageSourceFixe(i18n);
			case 'offre-du-dossier':
				return $author$project$I18n$Cles$pipeOffreUsageSourceDuDossier(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$Components$Parametrage$PipeOffreUsage$View$source = F2(
	function (i18n, code) {
		return A2($author$project$Components$Parametrage$Vocabulaire$sourceDeLOffre, i18n, code);
	});
var $author$project$I18n$Cles$pipeOffreUsageUtilise = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-offre-usage.utilise',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl)),
					_Utils_Tuple2(
					'montant',
					$author$project$I18n$Traductions$Chaine(p.oi))
				]),
			p.Bl + (' · ' + p.oi));
	});
var $author$project$Components$Parametrage$PipeOffreUsage$View$utilise = F2(
	function (i18n, usage) {
		return $elm$core$String$isEmpty(usage.oi) ? usage.uL : A2(
			$author$project$I18n$Cles$pipeOffreUsageUtilise,
			i18n,
			{Bl: usage.uL, oi: usage.oi});
	});
var $author$project$Components$Parametrage$PipeOffreUsage$View$ligne = F2(
	function (i18n, usage) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$th,
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'scope', 'row')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Parametrage$PipeOffreUsage$View$ou, i18n, usage))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Parametrage$PipeOffreUsage$View$utilise, i18n, usage))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							$author$project$Components$Parametrage$PipeOffreUsage$View$couleurDeLaSource(usage.IR),
							A2($author$project$Components$Parametrage$PipeOffreUsage$View$source, i18n, usage.IR))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Parametrage$PipeOffreUsage$View$payeur, i18n, usage))
						]))
				]));
	});
var $author$project$I18n$Cles$pipeOffreUsageAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-offre-usage.aucun', _List_Nil, 'Aucune tâche ni aucun automatisme ne se sert de l\'offre.');
};
var $author$project$I18n$Cles$pipeOffreUsageColonneOu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-offre-usage.colonne-ou', _List_Nil, 'Où');
};
var $author$project$I18n$Cles$pipeOffreUsageColonnePayeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-offre-usage.colonne-payeur', _List_Nil, 'Payeur');
};
var $author$project$I18n$Cles$pipeOffreUsageColonneSource = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-offre-usage.colonne-source', _List_Nil, 'Source');
};
var $author$project$I18n$Cles$pipeOffreUsageColonneUtilise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-offre-usage.colonne-utilise', _List_Nil, 'Ce qui est utilisé');
};
var $author$project$I18n$Cles$pipeOffreUsageListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-offre-usage.liste', _List_Nil, 'Où l\'offre est utilisée dans le pipe');
};
var $author$project$Components$Parametrage$PipeOffreUsage$View$liste = F2(
	function (i18n, usages) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('section-usages')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeOffreUsageListe(i18n))
						])),
					$elm$core$List$isEmpty(usages) ? A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeOffreUsageAucun(i18n))
						])) : A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$table,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$thead,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$tr,
											_List_Nil,
											A2(
												$elm$core$List$map,
												function (titre) {
													return A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'scope', 'col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(titre)
															]));
												},
												_List_fromArray(
													[
														$author$project$I18n$Cles$pipeOffreUsageColonneOu(i18n),
														$author$project$I18n$Cles$pipeOffreUsageColonneUtilise(i18n),
														$author$project$I18n$Cles$pipeOffreUsageColonneSource(i18n),
														$author$project$I18n$Cles$pipeOffreUsageColonnePayeur(i18n)
													])))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$tbody,
									_List_Nil,
									A2(
										$elm$core$List$map,
										$author$project$Components$Parametrage$PipeOffreUsage$View$ligne(i18n),
										usages))
								]))
						]))
				]));
	});
var $author$project$I18n$Cles$pipeOffreUsageTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-offre-usage.texte', _List_Nil, 'Chaque dossier porte l\'une des offres servies. Ce tableau dit où le pipe s\'en sert.');
};
var $author$project$I18n$Cles$pipeOffreUsageTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-offre-usage.titre', _List_Nil, 'Où l\'offre est utilisée');
};
var $author$project$Components$Parametrage$PipeOffreUsage$View$view = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'parametrage-pipe-offre-usage',
			{
				ut: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('main')
							]),
						A2(
							$elm$core$List$cons,
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							function () {
								var _v0 = _Utils_Tuple2(model.EE, model.nf);
								if (!_v0.a.$) {
									var usages = _v0.a.a;
									return _List_fromArray(
										[
											A2($author$project$Components$Parametrage$PipeOffreUsage$View$liste, i18n, usages)
										]);
								} else {
									if (_v0.b) {
										var _v1 = _v0.a;
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$pipeEtape1Introuvable(i18n))
													]))
											]);
									} else {
										var _v2 = _v0.a;
										return _List_Nil;
									}
								}
							}()))
					]),
				xy: _List_Nil,
				zM: _List_Nil,
				AK: false,
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeOffreUsageTexte(i18n))
									]))
							]),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adressePipes,
								Dj: $author$project$I18n$Cles$pipesTitre(i18n)
							},
								{
								aa: $author$project$Routes$Route$adressePipeEtape1(model.vx),
								Dj: model.Bl
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$pipeOffreUsageTitre(i18n)
					})
			});
	});
var $author$project$I18n$Cles$pipeRelationsExigeesAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-relations-exigees.ajouter', _List_Nil, 'Ajouter une exigence');
};
var $author$project$I18n$Cles$pipeRelationsExigeesVoirLePack = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-relations-exigees.voir-le-pack', _List_Nil, 'Voir le pack');
};
var $author$project$Components$Parametrage$PipeRelationsExigees$View$actions = F2(
	function (i18n, page) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
				]),
			A2(
				$elm$core$List$cons,
				A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
						]),
					$author$project$I18n$Cles$pipeRelationsExigeesVoirLePack(i18n)),
				function () {
					var _v0 = A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.s7;
						},
						page);
					if (!_v0.$) {
						return _List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								0,
								_List_Nil,
								$author$project$I18n$Cles$pipeRelationsExigeesAjouter(i18n))
							]);
					} else {
						return _List_Nil;
					}
				}()));
	});
var $author$project$I18n$Cles$pipeRelationsExigeesEspaceArchive = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-relations-exigees.espace-archive', _List_Nil, 'Archivé');
};
var $author$project$I18n$Cles$pipeRelationsExigeesEspaceManquant = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-relations-exigees.espace-manquant', _List_Nil, 'Manquant');
};
var $author$project$I18n$Cles$pipeRelationsExigeesEspacePresent = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-relations-exigees.espace-present', _List_Nil, 'Présent');
};
var $author$project$Components$Parametrage$Vocabulaire$dansLEspace = F2(
	function (i18n, code) {
		switch (code) {
			case 'present':
				return _Utils_Tuple2(
					0,
					$author$project$I18n$Cles$pipeRelationsExigeesEspacePresent(i18n));
			case 'manquant':
				return _Utils_Tuple2(
					2,
					$author$project$I18n$Cles$pipeRelationsExigeesEspaceManquant(i18n));
			case 'archive':
				return _Utils_Tuple2(
					1,
					$author$project$I18n$Cles$pipeRelationsExigeesEspaceArchive(i18n));
			default:
				var autre = code;
				return _Utils_Tuple2(3, autre);
		}
	});
var $author$project$I18n$Cles$pipeRelationsExigeesSansPack = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-relations-exigees.sans-pack', _List_Nil, 'Pas dans ce pack');
};
var $author$project$I18n$Cles$pipeRelationsExigeesSensOrganisationVersOrganisation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-relations-exigees.sens-organisation-vers-organisation', _List_Nil, 'Organisation → organisation');
};
var $author$project$I18n$Cles$pipeRelationsExigeesSensPersonneVersOrganisation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-relations-exigees.sens-personne-vers-organisation', _List_Nil, 'Personne → organisation');
};
var $author$project$I18n$Cles$pipeRelationsExigeesSensPersonneVersPersonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-relations-exigees.sens-personne-vers-personne', _List_Nil, 'Personne → personne');
};
var $author$project$Components$Parametrage$Vocabulaire$sensDeRelation = F2(
	function (i18n, code) {
		switch (code) {
			case 'personne-vers-organisation':
				return $author$project$I18n$Cles$pipeRelationsExigeesSensPersonneVersOrganisation(i18n);
			case 'personne-vers-personne':
				return $author$project$I18n$Cles$pipeRelationsExigeesSensPersonneVersPersonne(i18n);
			case 'organisation-vers-organisation':
				return $author$project$I18n$Cles$pipeRelationsExigeesSensOrganisationVersOrganisation(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$Components$Parametrage$PipeRelationsExigees$View$ligne = F2(
	function (i18n, exigence) {
		var _v0 = A2($author$project$Components$Parametrage$Vocabulaire$dansLEspace, i18n, exigence.wq);
		var couleur = _v0.a;
		var mot = _v0.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$th,
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'scope', 'row')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(exigence.r0)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Parametrage$Vocabulaire$sensDeRelation, i18n, exigence.IC))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(exigence.bi)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Components$Shared$Tag$View$view, couleur, mot)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$I18n$Cles$pipeRelationsExigeesSansPack(i18n),
								exigence.BZ))
						]))
				]));
	});
var $author$project$I18n$Cles$pipeRelationsExigeesAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-relations-exigees.aucun', _List_Nil, 'Ce pipe n\'exige aucun type de relation.');
};
var $author$project$I18n$Cles$pipeRelationsExigeesColonneEspace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-relations-exigees.colonne-espace', _List_Nil, 'Dans votre espace');
};
var $author$project$I18n$Cles$pipeRelationsExigeesColonnePack = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-relations-exigees.colonne-pack', _List_Nil, 'Livré par le pack');
};
var $author$project$I18n$Cles$pipeRelationsExigeesColonneRole = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-relations-exigees.colonne-role', _List_Nil, 'Exigé par le rôle');
};
var $author$project$I18n$Cles$pipeRelationsExigeesColonneSens = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-relations-exigees.colonne-sens', _List_Nil, 'Sens');
};
var $author$project$I18n$Cles$pipeRelationsExigeesColonneType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-relations-exigees.colonne-type', _List_Nil, 'Type de relation');
};
var $author$project$I18n$Cles$pipeRelationsExigeesListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-relations-exigees.liste', _List_Nil, 'Exigés par ce pipe');
};
var $author$project$I18n$Cles$pipeRelationsExigeesNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-relations-exigees.note', _List_Nil, 'Un type absent ou archivé bloque la publication du pipe (étape 8, « Contrôles »). Un type présent mais sans aucune relation n\'empêche rien : les dossiers s\'ouvrent avec le rôle à remplir.');
};
var $author$project$Components$Parametrage$PipeRelationsExigees$View$liste = F2(
	function (i18n, exigences) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('section-exigences')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeRelationsExigeesListe(i18n))
						])),
					$elm$core$List$isEmpty(exigences) ? A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeRelationsExigeesAucun(i18n))
						])) : A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$table,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$thead,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$tr,
											_List_Nil,
											A2(
												$elm$core$List$map,
												function (titre) {
													return A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'scope', 'col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(titre)
															]));
												},
												_List_fromArray(
													[
														$author$project$I18n$Cles$pipeRelationsExigeesColonneType(i18n),
														$author$project$I18n$Cles$pipeRelationsExigeesColonneSens(i18n),
														$author$project$I18n$Cles$pipeRelationsExigeesColonneRole(i18n),
														$author$project$I18n$Cles$pipeRelationsExigeesColonneEspace(i18n),
														$author$project$I18n$Cles$pipeRelationsExigeesColonnePack(i18n)
													])))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$tbody,
									_List_Nil,
									A2(
										$elm$core$List$map,
										$author$project$Components$Parametrage$PipeRelationsExigees$View$ligne(i18n),
										exigences))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeRelationsExigeesNote(i18n))
						]))
				]));
	});
var $author$project$I18n$Cles$pipeRelationsExigeesInstallationSimuler = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-relations-exigees.installation-simuler', _List_Nil, 'Simuler l\'installation');
};
var $author$project$I18n$Cles$pipeRelationsExigeesInstallationTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-relations-exigees.installation-texte', _List_Nil, 'Le client reçoit le pipe, ses rôles et les types de relation qu\'ils exigent. S\'il a déjà un type de même nom, il choisit de le réutiliser ou de le renommer.');
};
var $author$project$I18n$Cles$pipeRelationsExigeesInstallationTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-relations-exigees.installation-titre', _List_Nil, 'À l\'installation du pack chez un client');
};
var $author$project$I18n$Cles$pipeRelationsExigeesPackAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-relations-exigees.pack-aide', _List_Nil, 'Les dépendances sont ajoutées automatiquement quand on construit le pack. Les données (fiches, relations) ne sont jamais incluses.');
};
var $author$project$I18n$Cles$pipeRelationsExigeesPackContenuParties = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-relations-exigees.pack-contenu-parties', _List_Nil, 'Types de parties prenantes : Licencié · Producteur · Fournisseur (ajouté : requis par « Campagne de production »)');
};
var $author$project$I18n$Cles$pipeRelationsExigeesPackContenuRelations = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-relations-exigees.pack-contenu-relations', _List_Nil, 'Types de relation : Producteur de · Licencié de (ajoutés : requis par « Campagne de production »)');
};
var $author$project$I18n$Cles$pipeRelationsExigeesPackTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-relations-exigees.pack-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'pack',
					$author$project$I18n$Traductions$Chaine(p.ED))
				]),
			'Dans le pack « ' + (p.ED + ' »'));
	});
var $author$project$Components$Parametrage$PipeRelationsExigees$View$pack = F2(
	function (i18n, nom) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('panneaux-de-pack'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-disabled', 'true')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('panneau')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$pipeRelationsExigeesPackTitre,
										i18n,
										{ED: nom}))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('contenu')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeRelationsExigeesPackContenuParties(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeRelationsExigeesPackContenuRelations(i18n))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeRelationsExigeesPackAide(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('panneau')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$pipeRelationsExigeesInstallationTitre(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('contenu')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$pipeRelationsExigeesInstallationTexte(i18n))
										]))
								])),
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
								]),
							$author$project$I18n$Cles$pipeRelationsExigeesInstallationSimuler(i18n))
						]))
				]));
	});
var $author$project$Components$Parametrage$PipeRelationsExigees$View$packsDe = function (exigences) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$elm$core$List$singleton,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$split(' · '),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$head,
						$elm$core$Maybe$withDefault(''))),
				$elm$core$List$head(
					A2(
						$elm$core$List$filterMap,
						function ($) {
							return $.BZ;
						},
						exigences)))));
};
var $author$project$Components$Parametrage$PipeRelationsExigees$View$contenu = F2(
	function (i18n, page) {
		return A2(
			$elm$core$List$cons,
			A2($author$project$Components$Parametrage$PipeRelationsExigees$View$liste, i18n, page.y$),
			A2(
				$elm$core$List$map,
				$author$project$Components$Parametrage$PipeRelationsExigees$View$pack(i18n),
				$author$project$Components$Parametrage$PipeRelationsExigees$View$packsDe(page.y$)));
	});
var $author$project$I18n$Cles$pipeRelationsExigeesTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-relations-exigees.texte', _List_Nil, 'Un rôle tenu par une relation ne fonctionne que si le type de relation existe. Le pipe dit lesquels il exige ; le pack sectoriel les livre.');
};
var $author$project$I18n$Cles$pipeRelationsExigeesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-relations-exigees.titre', _List_Nil, 'Les types de relation dont le pipe a besoin');
};
var $author$project$Components$Parametrage$PipeRelationsExigees$View$view = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'parametrage-pipe-relations-exigees',
			{
				ut: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('main')
							]),
						A2(
							$elm$core$List$cons,
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							function () {
								var _v0 = _Utils_Tuple2(model.EE, model.nf);
								if (!_v0.a.$) {
									var page = _v0.a.a;
									return A2($author$project$Components$Parametrage$PipeRelationsExigees$View$contenu, i18n, page);
								} else {
									if (_v0.b) {
										var _v1 = _v0.a;
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$pipeEtape1Introuvable(i18n))
													]))
											]);
									} else {
										var _v2 = _v0.a;
										return _List_Nil;
									}
								}
							}()))
					]),
				xy: _List_Nil,
				zM: _List_Nil,
				AK: false,
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeRelationsExigeesTexte(i18n))
									])),
								A2($author$project$Components$Parametrage$PipeRelationsExigees$View$actions, i18n, model.EE)
							]),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adressePipes,
								Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
							},
								{
								aa: $author$project$Routes$Route$adressePipes,
								Dj: $author$project$I18n$Cles$pipesTitre(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$pipeRelationsExigeesTitre(i18n)
					})
			});
	});
var $author$project$Components$Parametrage$PipeVersions$Update$BrouillonDemande = {$: 7};
var $author$project$Components$Parametrage$PipeVersions$Update$ExportDemande = function (a) {
	return {$: 8, a: a};
};
var $author$project$I18n$Cles$pipeVersionsExporter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.exporter', _List_Nil, 'Exporter (JSON)');
};
var $author$project$I18n$Cles$pipeVersionsMigrationGroupee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.migration-groupee', _List_Nil, 'Migration groupée');
};
var $author$project$I18n$Cles$pipeVersionsOuvrirLeBrouillon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.ouvrir-le-brouillon', _List_Nil, 'Ouvrir le brouillon');
};
var $author$project$I18n$Cles$pipeVersionsPublierEtMigrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.publier-et-migrer', _List_Nil, 'Publier et migrer');
};
var $author$project$Components$Parametrage$PipeVersions$View$versionExportable = function (versions) {
	var exportables = A2(
		$elm$core$List$filterMap,
		function (version) {
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$pair(version),
				version.za);
		},
		versions);
	var _v0 = A2(
		$elm$core$List$filter,
		function (_v1) {
			var version = _v1.a;
			return version.ri === 'publiee';
		},
		exportables);
	if (_v0.b) {
		var premiere = _v0.a;
		return $elm$core$Maybe$Just(premiere);
	} else {
		return $elm$core$List$head(exportables);
	}
};
var $author$project$Components$Parametrage$PipeVersions$View$actionsDeTete = F3(
	function (i18n, brouillonAOuvrir, versions) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('actions-tete')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('migration-groupee'),
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
						]),
					$author$project$I18n$Cles$pipeVersionsMigrationGroupee(i18n)),
					function () {
					if (!brouillonAOuvrir.$) {
						return A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('ouvrir-le-brouillon'),
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$PipeVersions$Update$BrouillonDemande)
								]),
							$author$project$I18n$Cles$pipeVersionsOuvrirLeBrouillon(i18n));
					} else {
						return $rtfeldman$elm_css$Html$Styled$text('');
					}
				}(),
					function () {
					var _v1 = $author$project$Components$Parametrage$PipeVersions$View$versionExportable(versions);
					if (!_v1.$) {
						var _v2 = _v1.a;
						var version = _v2.a;
						return A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('exporter'),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Parametrage$PipeVersions$Update$ExportDemande(version.DX))
								]),
							$author$project$I18n$Cles$pipeVersionsExporter(i18n));
					} else {
						return $rtfeldman$elm_css$Html$Styled$text('');
					}
				}(),
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					0,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('publier-et-migrer'),
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
						]),
					$author$project$I18n$Cles$pipeVersionsPublierEtMigrer(i18n))
				]));
	});
var $author$project$Components$Parametrage$PipeVersions$View$blocComparer = F2(
	function (i18n, comparaison) {
		if (!comparaison.$) {
			var versionComparee = comparaison.a.KF;
			var changements = comparaison.a.u3;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('section-versions', true),
								_Utils_Tuple2('bloc-comparer', true)
							]))
					]),
				function () {
					if (!versionComparee.$) {
						var reference = versionComparee.a;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$h2,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$pipeEtape8ChangementsTitre,
											i18n,
											{
												sq: $elm$core$String$fromInt(reference)
											}))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$ul,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('liste')
									]),
								A2(
									$elm$core$List$map,
									function (texte) {
										return A2(
											$rtfeldman$elm_css$Html$Styled$li,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(texte)
												]));
									},
									changements))
							]);
					} else {
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeEtape8ChangementsPremiere(i18n))
									]))
							]);
					}
				}());
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$pipeVersionsExporterContenu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.exporter-contenu', _List_Nil, 'Parcours, rôles (dont ceux tenus par une relation), tâches, formulaires, visibilité, automatismes, offres. Aucune donnée de dossier.');
};
var $author$project$I18n$Cles$pipeVersionsExporterFichier = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-versions.exporter-fichier',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'numero',
					$author$project$I18n$Traductions$Chaine(p.DX))
				]),
			'Fichier JSON de la v' + p.DX);
	});
var $author$project$I18n$Cles$pipeVersionsExporterRelations = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.exporter-relations', _List_Nil, 'L\'export liste aussi les types de relation que les rôles exigent : un autre espace qui l\'importe sait ce qu\'il doit créer.');
};
var $author$project$I18n$Cles$pipeVersionsExporterTelecharger = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.exporter-telecharger', _List_Nil, 'Télécharger');
};
var $author$project$I18n$Cles$pipeVersionsExporterTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.exporter-titre', _List_Nil, 'Exporter une version');
};
var $author$project$Components$Parametrage$PipeVersions$View$blocExporter = F2(
	function (i18n, versions) {
		var _v0 = $author$project$Components$Parametrage$PipeVersions$View$versionExportable(versions);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var version = _v1.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('section-versions', true),
								_Utils_Tuple2('bloc-exporter', true)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h2,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeVersionsExporterTitre(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('fichier')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$pipeVersionsExporterFichier,
													i18n,
													{
														DX: $elm$core$String$fromInt(version.DX)
													}))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('contenu')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$pipeVersionsExporterContenu(i18n))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('exporter'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Parametrage$PipeVersions$Update$ExportDemande(version.DX))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipeVersionsExporterTelecharger(i18n))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeVersionsExporterRelations(i18n))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$PipeVersions$Update$RetraitDemande = function (a) {
	return {$: 5, a: a};
};
var $author$project$I18n$Cles$pipeVersionsRetraitConfirmer = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-versions.retrait.confirmer',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'numero',
					$author$project$I18n$Traductions$Chaine(p.DX))
				]),
			'Retirer la v' + p.DX);
	});
var $author$project$I18n$Cles$pipeVersionsRetraitTexte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-versions.retrait.texte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'numero',
					$author$project$I18n$Traductions$Chaine(p.DX))
				]),
			'Retirer la v' + (p.DX + ' : plus aucun dossier ne pourra être ouvert sur ce pipe. Les dossiers en cours restent inchangés.'));
	});
var $author$project$I18n$Cles$pipeVersionsRetraitTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.retrait.titre', _List_Nil, 'Retirer une version');
};
var $author$project$Components$Parametrage$PipeVersions$View$blocRetirer = F2(
	function (i18n, versions) {
		var _v0 = A2(
			$elm$core$List$filter,
			function (version) {
				return !_Utils_eq(version.H0, $elm$core$Maybe$Nothing);
			},
			versions);
		if (_v0.b) {
			var version = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('section-versions', true),
								_Utils_Tuple2('bloc-retirer', true)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h2,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$pipeVersionsRetraitTitre(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$pipeVersionsRetraitTexte,
									i18n,
									{
										DX: $elm$core$String$fromInt(version.DX)
									}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								3,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer-version'),
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Parametrage$PipeVersions$Update$RetraitDemande(version.DX))
									]),
								A2(
									$author$project$I18n$Cles$pipeVersionsRetraitConfirmer,
									i18n,
									{
										DX: $elm$core$String$fromInt(version.DX)
									}))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$PipeVersions$Update$RetraitConfirme = {$: 6};
var $author$project$Components$Parametrage$PipeVersions$View$contenuDuDrawer = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(
			$author$project$Components$Shared$Drawer$Model$estOuvert(model.kX),
			model.dh);
		if (_v0.a && (!_v0.b.$)) {
			var numero = _v0.b.a;
			return {
				fs: {
					sR: !$author$project$API$Envoi$enCours(model.l2),
					Bl: A2(
						$author$project$I18n$Cles$pipeVersionsRetraitConfirmer,
						i18n,
						{
							DX: $elm$core$String$fromInt(numero)
						}),
					C$: $author$project$Components$Parametrage$PipeVersions$Update$RetraitConfirme
				},
				fZ: _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Messages$View$view,
						i18n,
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2($elm$core$Maybe$map, $elm$core$List$singleton, model.pZ))),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$pipeVersionsRetraitTexte,
									i18n,
									{
										DX: $elm$core$String$fromInt(numero)
									}))
							]))
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$pipeVersionsRetraitTitre(i18n)
			};
		} else {
			return {
				fs: {sR: false, Bl: '', C$: $author$project$Components$Parametrage$PipeVersions$Update$RetraitConfirme},
				fZ: _List_Nil,
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: ''
			};
		}
	});
var $author$project$Components$Parametrage$PipeVersions$View$drawer = F2(
	function (i18n, model) {
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Parametrage$PipeVersions$Update$DuDrawer,
			A2($author$project$Components$Parametrage$PipeVersions$View$contenuDuDrawer, i18n, model),
			model.kX);
	});
var $author$project$Components$Parametrage$PipeVersions$Update$ComparaisonDemandee = function (a) {
	return {$: 9, a: a};
};
var $author$project$I18n$Cles$pipeVersionsMoisCourt01 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.mois-court.01', _List_Nil, 'janv.');
};
var $author$project$I18n$Cles$pipeVersionsMoisCourt02 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.mois-court.02', _List_Nil, 'févr.');
};
var $author$project$I18n$Cles$pipeVersionsMoisCourt03 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.mois-court.03', _List_Nil, 'mars');
};
var $author$project$I18n$Cles$pipeVersionsMoisCourt04 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.mois-court.04', _List_Nil, 'avr.');
};
var $author$project$I18n$Cles$pipeVersionsMoisCourt05 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.mois-court.05', _List_Nil, 'mai');
};
var $author$project$I18n$Cles$pipeVersionsMoisCourt06 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.mois-court.06', _List_Nil, 'juin');
};
var $author$project$I18n$Cles$pipeVersionsMoisCourt07 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.mois-court.07', _List_Nil, 'juil.');
};
var $author$project$I18n$Cles$pipeVersionsMoisCourt08 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.mois-court.08', _List_Nil, 'août');
};
var $author$project$I18n$Cles$pipeVersionsMoisCourt09 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.mois-court.09', _List_Nil, 'sept.');
};
var $author$project$I18n$Cles$pipeVersionsMoisCourt10 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.mois-court.10', _List_Nil, 'oct.');
};
var $author$project$I18n$Cles$pipeVersionsMoisCourt11 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.mois-court.11', _List_Nil, 'nov.');
};
var $author$project$I18n$Cles$pipeVersionsMoisCourt12 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.mois-court.12', _List_Nil, 'déc.');
};
var $author$project$Components$Parametrage$PipeVersions$View$moisCourt = F2(
	function (i18n, numero) {
		switch (numero) {
			case 1:
				return $author$project$I18n$Cles$pipeVersionsMoisCourt01(i18n);
			case 2:
				return $author$project$I18n$Cles$pipeVersionsMoisCourt02(i18n);
			case 3:
				return $author$project$I18n$Cles$pipeVersionsMoisCourt03(i18n);
			case 4:
				return $author$project$I18n$Cles$pipeVersionsMoisCourt04(i18n);
			case 5:
				return $author$project$I18n$Cles$pipeVersionsMoisCourt05(i18n);
			case 6:
				return $author$project$I18n$Cles$pipeVersionsMoisCourt06(i18n);
			case 7:
				return $author$project$I18n$Cles$pipeVersionsMoisCourt07(i18n);
			case 8:
				return $author$project$I18n$Cles$pipeVersionsMoisCourt08(i18n);
			case 9:
				return $author$project$I18n$Cles$pipeVersionsMoisCourt09(i18n);
			case 10:
				return $author$project$I18n$Cles$pipeVersionsMoisCourt10(i18n);
			case 11:
				return $author$project$I18n$Cles$pipeVersionsMoisCourt11(i18n);
			default:
				return $author$project$I18n$Cles$pipeVersionsMoisCourt12(i18n);
		}
	});
var $author$project$Components$Parametrage$PipeVersions$View$dateFrancaise = F2(
	function (i18n, iso) {
		var _v0 = A2(
			$elm$core$String$split,
			'-',
			A2($elm$core$String$left, 10, iso));
		if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
			var annee = _v0.a;
			var _v1 = _v0.b;
			var mois = _v1.a;
			var _v2 = _v1.b;
			var jour = _v2.a;
			var _v3 = _Utils_Tuple2(
				$elm$core$String$toInt(mois),
				$elm$core$String$toInt(jour));
			if ((!_v3.a.$) && (!_v3.b.$)) {
				var numero = _v3.a.a;
				var numeroDuJour = _v3.b.a;
				return A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[
							$elm$core$String$fromInt(numeroDuJour),
							A2($author$project$Components$Parametrage$PipeVersions$View$moisCourt, i18n, numero),
							annee
						]));
			} else {
				return iso;
			}
		} else {
			return iso;
		}
	});
var $author$project$I18n$Cles$pipeVersionsComparer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.comparer', _List_Nil, 'Comparer');
};
var $author$project$I18n$Cles$pipeVersionsNumero = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-versions.numero',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'numero',
					$author$project$I18n$Traductions$Chaine(p.DX))
				]),
			'v' + p.DX);
	});
var $author$project$I18n$Cles$pipeVersionsRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.retirer', _List_Nil, 'Retirer');
};
var $author$project$Components$Parametrage$PipeVersions$View$sansValeur = F2(
	function (i18n, texte) {
		return $elm$core$String$isEmpty(texte) ? $author$project$I18n$Cles$pipesSansValeur(i18n) : texte;
	});
var $author$project$I18n$Cles$pipeVersionsStatutPubliee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.statut-publiee', _List_Nil, 'Publiée');
};
var $author$project$Components$Parametrage$PipeVersions$View$statut = F2(
	function (i18n, code) {
		switch (code) {
			case 'brouillon':
				return A2(
					$author$project$Components$Shared$Tag$View$view,
					1,
					$author$project$I18n$Cles$pipeVersionsStatutBrouillon(i18n));
			case 'publiee':
				return A2(
					$author$project$Components$Shared$Tag$View$view,
					0,
					$author$project$I18n$Cles$pipeVersionsStatutPubliee(i18n));
			case 'retiree':
				return A2(
					$author$project$Components$Shared$Tag$View$view,
					3,
					$author$project$I18n$Cles$pipeVersionsStatutArchivee(i18n));
			default:
				var autre = code;
				return $rtfeldman$elm_css$Html$Styled$text(autre);
		}
	});
var $author$project$Components$Parametrage$PipeVersions$View$ligne = F2(
	function (i18n, version) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$th,
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'scope', 'row')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$pipeVersionsNumero,
								i18n,
								{
									DX: $elm$core$String$fromInt(version.DX)
								}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Components$Parametrage$PipeVersions$View$statut, i18n, version.ri)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$Components$Parametrage$PipeVersions$View$sansValeur,
								i18n,
								A2(
									$author$project$Components$Parametrage$PipeVersions$View$dateFrancaise,
									i18n,
									A2($elm$core$Maybe$withDefault, '', version.GD))))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Parametrage$PipeVersions$View$sansValeur, i18n, version.GE))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(version.xK))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									function () {
									var _v0 = version.vR;
									if (!_v0.$) {
										return A2(
											$rtfeldman$elm_css$Html$Styled$button,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
													$rtfeldman$elm_css$Html$Styled$Attributes$class('comparer'),
													$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
													$rtfeldman$elm_css$Html$Styled$Events$onClick(
													$author$project$Components$Parametrage$PipeVersions$Update$ComparaisonDemandee(version.DX))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$pipeVersionsComparer(i18n))
												]));
									} else {
										return A2(
											$rtfeldman$elm_css$Html$Styled$button,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
													$rtfeldman$elm_css$Html$Styled$Attributes$class('comparer'),
													$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
													$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$pipeVersionsComparer(i18n))
												]));
									}
								}()
								]),
								function () {
								var _v1 = version.za;
								if (!_v1.$) {
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$button,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
													$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
													$rtfeldman$elm_css$Html$Styled$Attributes$class('exporter'),
													$rtfeldman$elm_css$Html$Styled$Events$onClick(
													$author$project$Components$Parametrage$PipeVersions$Update$ExportDemande(version.DX))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$pipeVersionsExporter(i18n))
												]))
										]);
								} else {
									return _List_Nil;
								}
							}(),
								function () {
								var _v2 = version.H0;
								if (!_v2.$) {
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$button,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
													$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer'),
													$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
													$rtfeldman$elm_css$Html$Styled$Attributes$id(
													$author$project$Components$Parametrage$PipeVersions$Model$idDuDeclencheur(version.DX)),
													$rtfeldman$elm_css$Html$Styled$Events$onClick(
													$author$project$Components$Parametrage$PipeVersions$Update$RetraitDemande(version.DX))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$pipeVersionsRetirer(i18n))
												]))
										]);
								} else {
									return _List_Nil;
								}
							}()
							])))
				]));
	});
var $author$project$I18n$Cles$pipeVersionsNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.note', _List_Nil, 'Une version qui porte encore des dossiers ne se retire pas : on migre d\'abord ses dossiers.');
};
var $author$project$I18n$Cles$pipeVersionsNoteDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-versions.note-detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'detail',
					$author$project$I18n$Traductions$Chaine(p.bB))
				]),
			'Une version qui porte encore des dossiers ne se retire pas : on migre d\'abord ses dossiers (' + (p.bB + ').'));
	});
var $author$project$I18n$Cles$pipeVersionsNoteDetailVersion = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-versions.note-detail-version',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'numero',
					$author$project$I18n$Traductions$Chaine(p.DX)),
					_Utils_Tuple2(
					'dossiers',
					$author$project$I18n$Traductions$Entier(p.xJ))
				]),
			((!p.xJ) || (p.xJ === 1)) ? ('v' + (p.DX + (' : ' + (A2($author$project$I18n$Nombre$formater, 0, p.xJ) + ' dossier')))) : ('v' + (p.DX + (' : ' + (A2($author$project$I18n$Nombre$formater, 0, p.xJ) + ' dossiers')))));
	});
var $author$project$Components$Parametrage$PipeVersions$View$noteDesDossiers = F2(
	function (i18n, versions) {
		var _v0 = A2(
			$elm$core$List$map,
			function (version) {
				return A2(
					$author$project$I18n$Cles$pipeVersionsNoteDetailVersion,
					i18n,
					{
						xJ: version.xK,
						DX: $elm$core$String$fromInt(version.DX)
					});
			},
			A2(
				$elm$core$List$filter,
				function (version) {
					return (version.ri === 'retiree') && (version.xK > 0);
				},
				versions));
		if (!_v0.b) {
			return $author$project$I18n$Cles$pipeVersionsNote(i18n);
		} else {
			var detail = _v0;
			return A2(
				$author$project$I18n$Cles$pipeVersionsNoteDetail,
				i18n,
				{
					bB: A2($elm$core$String$join, ', ', detail)
				});
		}
	});
var $author$project$I18n$Cles$pipeVersionsColonneActions = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.colonne-actions', _List_Nil, 'Actions');
};
var $author$project$I18n$Cles$pipeVersionsColonneDossiers = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.colonne-dossiers', _List_Nil, 'Dossiers');
};
var $author$project$I18n$Cles$pipeVersionsColonnePar = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.colonne-par', _List_Nil, 'Par');
};
var $author$project$I18n$Cles$pipeVersionsColonnePubliee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.colonne-publiee', _List_Nil, 'Publiée le');
};
var $author$project$I18n$Cles$pipeVersionsColonneStatut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.colonne-statut', _List_Nil, 'Statut');
};
var $author$project$I18n$Cles$pipeVersionsColonneVersion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.colonne-version', _List_Nil, 'Version');
};
var $author$project$I18n$Cles$pipeVersionsListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.liste', _List_Nil, 'Versions');
};
var $author$project$Components$Parametrage$PipeVersions$View$liste = F2(
	function (i18n, versions) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('section-versions')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeVersionsListe(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$table,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$thead,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$tr,
											_List_Nil,
											A2(
												$elm$core$List$map,
												function (titre) {
													return A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'scope', 'col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(titre)
															]));
												},
												_List_fromArray(
													[
														$author$project$I18n$Cles$pipeVersionsColonneVersion(i18n),
														$author$project$I18n$Cles$pipeVersionsColonneStatut(i18n),
														$author$project$I18n$Cles$pipeVersionsColonnePubliee(i18n),
														$author$project$I18n$Cles$pipeVersionsColonnePar(i18n),
														$author$project$I18n$Cles$pipeVersionsColonneDossiers(i18n),
														$author$project$I18n$Cles$pipeVersionsColonneActions(i18n)
													])))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$tbody,
									_List_Nil,
									A2(
										$elm$core$List$map,
										$author$project$Components$Parametrage$PipeVersions$View$ligne(i18n),
										versions))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Parametrage$PipeVersions$View$noteDesDossiers, i18n, versions))
						]))
				]));
	});
var $author$project$I18n$Cles$pipeVersionsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.titre', _List_Nil, 'Versions et publication');
};
var $author$project$I18n$Cles$pipeVersionsResume = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-versions.resume',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'brouillon',
					$author$project$I18n$Traductions$Chaine(p.uw)),
					_Utils_Tuple2(
					'base',
					$author$project$I18n$Traductions$Chaine(p.jo)),
					_Utils_Tuple2(
					'dossiers',
					$author$project$I18n$Traductions$Entier(p.xJ)),
					_Utils_Tuple2(
					'publiee',
					$author$project$I18n$Traductions$Chaine(p.pG))
				]),
			((!p.xJ) || (p.xJ === 1)) ? ('v' + (p.uw + (' brouillon, basée sur la v' + (p.jo + (' publiée. À la publication, le dossier en cours reste sur la v' + (p.pG + '.')))))) : ('v' + (p.uw + (' brouillon, basée sur la v' + (p.jo + (' publiée. À la publication, les ' + (A2($author$project$I18n$Nombre$formater, 0, p.xJ) + (' dossiers en cours restent sur la v' + (p.pG + '.')))))))));
	});
var $author$project$I18n$Cles$pipeVersionsResumeSansBase = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-versions.resume-sans-base',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'brouillon',
					$author$project$I18n$Traductions$Chaine(p.uw))
				]),
			'v' + (p.uw + ' brouillon, sans version publiée.'));
	});
var $author$project$I18n$Cles$pipeVersionsResumeSansBrouillon = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipe-versions.resume-sans-brouillon',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'publiee',
					$author$project$I18n$Traductions$Chaine(p.pG)),
					_Utils_Tuple2(
					'dossiers',
					$author$project$I18n$Traductions$Entier(p.xJ))
				]),
			((!p.xJ) || (p.xJ === 1)) ? ('Aucun brouillon : la v' + (p.pG + (' publiée porte ' + (A2($author$project$I18n$Nombre$formater, 0, p.xJ) + ' dossier en cours.')))) : ('Aucun brouillon : la v' + (p.pG + (' publiée porte ' + (A2($author$project$I18n$Nombre$formater, 0, p.xJ) + ' dossiers en cours.')))));
	});
var $author$project$I18n$Cles$pipeVersionsResumeVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipe-versions.resume-vide', _List_Nil, 'Aucune version pour ce pipe.');
};
var $author$project$Components$Parametrage$PipeVersions$View$versionDeStatut = F2(
	function (statut_, versions) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (version) {
					return _Utils_eq(version.ri, statut_);
				},
				versions));
	});
var $author$project$Components$Parametrage$PipeVersions$View$resume = F2(
	function (i18n, versions) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$Components$Parametrage$PipeVersions$View$versionDeStatut, 'brouillon', versions),
			A2($author$project$Components$Parametrage$PipeVersions$View$versionDeStatut, 'publiee', versions));
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var brouillon = _v0.a.a;
				var publiee = _v0.b.a;
				var _v1 = brouillon.jp;
				if (!_v1.$) {
					var base = _v1.a;
					return A2(
						$author$project$I18n$Cles$pipeVersionsResume,
						i18n,
						{
							jo: $elm$core$String$fromInt(base),
							uw: $elm$core$String$fromInt(brouillon.DX),
							xJ: publiee.xK,
							pG: $elm$core$String$fromInt(publiee.DX)
						});
				} else {
					return A2(
						$author$project$I18n$Cles$pipeVersionsResumeSansBase,
						i18n,
						{
							uw: $elm$core$String$fromInt(brouillon.DX)
						});
				}
			} else {
				var brouillon = _v0.a.a;
				var _v2 = _v0.b;
				return A2(
					$author$project$I18n$Cles$pipeVersionsResumeSansBase,
					i18n,
					{
						uw: $elm$core$String$fromInt(brouillon.DX)
					});
			}
		} else {
			if (!_v0.b.$) {
				var _v3 = _v0.a;
				var publiee = _v0.b.a;
				return A2(
					$author$project$I18n$Cles$pipeVersionsResumeSansBrouillon,
					i18n,
					{
						xJ: publiee.xK,
						pG: $elm$core$String$fromInt(publiee.DX)
					});
			} else {
				var _v4 = _v0.a;
				var _v5 = _v0.b;
				return $author$project$I18n$Cles$pipeVersionsResumeVide(i18n);
			}
		}
	});
var $author$project$Components$Parametrage$PipeVersions$View$view = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'parametrage-pipe-versions',
			{
				ut: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('main')
							]),
						A2(
							$elm$core$List$cons,
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							function () {
								var _v0 = _Utils_Tuple2(model.EE, model.nf);
								if (!_v0.a.$) {
									var versions = _v0.a.a;
									return _List_fromArray(
										[
											A2($author$project$Components$Parametrage$PipeVersions$View$liste, i18n, versions),
											A2($author$project$Components$Parametrage$PipeVersions$View$blocComparer, i18n, model.vP),
											A2($author$project$Components$Parametrage$PipeVersions$View$blocExporter, i18n, versions),
											A2($author$project$Components$Parametrage$PipeVersions$View$blocRetirer, i18n, versions)
										]);
								} else {
									if (_v0.b) {
										var _v1 = _v0.a;
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$pipeEtape1Introuvable(i18n))
													]))
											]);
									} else {
										var _v2 = _v0.a;
										return _List_Nil;
									}
								}
							}()))
					]),
				xy: _List_fromArray(
					[
						A2($author$project$Components$Parametrage$PipeVersions$View$drawer, i18n, model)
					]),
				zM: _List_Nil,
				AK: $author$project$Components$Parametrage$PipeVersions$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (versions) {
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2($author$project$Components$Parametrage$PipeVersions$View$resume, i18n, versions))
												])),
											A3($author$project$Components$Parametrage$PipeVersions$View$actionsDeTete, i18n, model.jv, versions)
										]);
								},
								model.EE)),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adressePipes,
								Dj: $author$project$I18n$Cles$pipesTitre(i18n)
							},
								{
								aa: $author$project$Routes$Route$adressePipeEtape1(model.vx),
								Dj: model.Bl
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$pipeVersionsTitre(i18n)
					})
			});
	});
var $author$project$Components$Parametrage$Pipes$View$ajoutDUnType = F2(
	function (i18n, liens) {
		var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ajouterUnTypeDeDossier, liens);
		if (!_v0.$) {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout-de-type'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('primary'),
							$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Routes$Route$adresseNouveauPipe)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipeEtape1LienAjouterType(i18n))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Parametrage$Pipes$Model$Cartes = 0;
var $author$project$Components$Parametrage$Pipes$Update$AffichageChoisi = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Parametrage$Pipes$View$boutonDAffichage = F3(
	function (model, affichage, libelle) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'active',
							_Utils_eq(model.iF, affichage))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-pressed',
					_Utils_eq(model.iF, affichage) ? 'true' : 'false'),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Components$Parametrage$Pipes$Update$AffichageChoisi(affichage))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(libelle)
				]));
	});
var $author$project$I18n$Cles$pipesAffichage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipes.affichage', _List_Nil, 'Affichage de l\'annuaire');
};
var $author$project$I18n$Cles$pipesAffichageCartes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipes.affichage-cartes', _List_Nil, 'Cartes');
};
var $author$project$I18n$Cles$pipesAffichageTableau = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipes.affichage-tableau', _List_Nil, 'Tableau');
};
var $author$project$Components$Parametrage$Pipes$View$bascule = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('bascule'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'group'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					$author$project$I18n$Cles$pipesAffichage(i18n))
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Components$Parametrage$Pipes$View$boutonDAffichage,
					model,
					0,
					$author$project$I18n$Cles$pipesAffichageCartes(i18n)),
					A3(
					$author$project$Components$Parametrage$Pipes$View$boutonDAffichage,
					model,
					1,
					$author$project$I18n$Cles$pipesAffichageTableau(i18n))
				]));
	});
var $author$project$I18n$Cles$pipesLienModeles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipes.lien-modeles', _List_Nil, 'Modèles de tâches');
};
var $author$project$Components$Parametrage$Pipes$View$lienDesModeles = F2(
	function (i18n, liens) {
		var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modelesDeTaches, liens);
		if (!_v0.$) {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('lien-modeles'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('secondary'),
							$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Routes$Route$adresseModelesDeTache)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$pipesLienModeles(i18n))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Parametrage$Pipes$View$couleurDeLEtat = function (etat) {
	return (etat === 'brouillon') ? 1 : 0;
};
var $author$project$I18n$Cles$pipesEtatBrouillon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipes.etat.brouillon', _List_Nil, 'Brouillon');
};
var $author$project$I18n$Cles$pipesEtatPublie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipes.etat.publie', _List_Nil, 'Publié');
};
var $author$project$I18n$Cles$pipesEtatPublieAvecBrouillon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipes.etat.publie-avec-brouillon', _List_Nil, 'Publié, brouillon en cours');
};
var $author$project$Components$Parametrage$Vocabulaire$etatDuPipe = F2(
	function (i18n, etat) {
		switch (etat) {
			case 'brouillon':
				return $author$project$I18n$Cles$pipesEtatBrouillon(i18n);
			case 'publie':
				return $author$project$I18n$Cles$pipesEtatPublie(i18n);
			case 'publie-avec-brouillon':
				return $author$project$I18n$Cles$pipesEtatPublieAvecBrouillon(i18n);
			default:
				var autre = etat;
				return autre;
		}
	});
var $author$project$Components$Parametrage$Pipes$View$nomDuPipe = F2(
	function (tous, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			code,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.R;
					},
					$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (pipe) {
							return _Utils_eq(pipe.vx, code);
						},
						tous))));
	});
var $author$project$Components$Parametrage$Pipes$View$lienDeLaLigne = F3(
	function (i18n, tous, pipe) {
		var _v0 = pipe.nB;
		if (!_v0.$) {
			var lien = _v0.a;
			return $rtfeldman$elm_css$Html$Styled$text(
				A3(
					$author$project$Components$Parametrage$Vocabulaire$lienEntrePipes,
					i18n,
					A2($author$project$Components$Parametrage$Pipes$View$nomDuPipe, tous, lien.t5),
					lien));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text(
				$author$project$I18n$Cles$pipesLienAucun(i18n));
		}
	});
var $author$project$Components$Parametrage$Pipes$View$lienEntrePipes = F3(
	function (i18n, tous, pipe) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('lien')
				]),
			_List_fromArray(
				[
					A3($author$project$Components$Parametrage$Pipes$View$lienDeLaLigne, i18n, tous, pipe)
				]));
	});
var $author$project$I18n$Cles$pipesVersionBrouillon = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipes.version.brouillon',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'numero',
					$author$project$I18n$Traductions$Chaine(p.DX))
				]),
			'v' + (p.DX + ' brouillon'));
	});
var $author$project$I18n$Cles$pipesVersionPubliee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'pipes.version.publiee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'numero',
					$author$project$I18n$Traductions$Chaine(p.DX))
				]),
			'v' + p.DX);
	});
var $author$project$Components$Parametrage$Vocabulaire$versions = F2(
	function (i18n, pipe) {
		return A2(
			$elm$core$String$join,
			' · ',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function (numero) {
							return A2(
								$author$project$I18n$Cles$pipesVersionPubliee,
								i18n,
								{
									DX: $elm$core$String$fromInt(numero)
								});
						},
						pipe.KM),
						A2(
						$elm$core$Maybe$map,
						function (numero) {
							return A2(
								$author$project$I18n$Cles$pipesVersionBrouillon,
								i18n,
								{
									DX: $elm$core$String$fromInt(numero)
								});
						},
						pipe.KE)
					])));
	});
var $author$project$Components$Parametrage$Pipes$View$ligne = F3(
	function (i18n, tous, pipe) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('item')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('cartouche-pipe')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('content')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('main')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('title'),
													$rtfeldman$elm_css$Html$Styled$Attributes$href(
													$author$project$Routes$Route$adressePipeEtape1(pipe.vx))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(pipe.R))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$ul,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('infos')
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(pipe.CW))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															A2(
																$author$project$I18n$Cles$pipesEtapes,
																i18n,
																{yL: pipe.Dt}))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															A2(
																$author$project$I18n$Cles$pipesPassages,
																i18n,
																{E5: pipe.DE}))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	A2($author$project$Components$Parametrage$Vocabulaire$versions, i18n, pipe))
																]))
														])),
													A3($author$project$Components$Parametrage$Pipes$View$lienEntrePipes, i18n, tous, pipe)
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('aside')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Components$Shared$Tag$View$view,
											$author$project$Components$Parametrage$Pipes$View$couleurDeLEtat(pipe.gt),
											A2($author$project$Components$Parametrage$Vocabulaire$etatDuPipe, i18n, pipe.gt))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Components$Parametrage$Pipes$Update$PageChoisie = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Parametrage$Pipes$View$pied = F3(
	function (i18n, model, affiches) {
		var vers = function (rel) {
			return A2(
				$elm$core$Maybe$map,
				$author$project$Components$Parametrage$Pipes$Update$PageChoisie,
				A2($author$project$API$Liens$trouver, rel, model.nQ));
		};
		var debut = ((model.EE - 1) * model.Jm) + 1;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pied-de-liste')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('plage')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$annuairePaginationPlage,
								i18n,
								{
									ku: $elm$core$String$fromInt(debut),
									mI: $elm$core$String$fromInt((debut + affiches) - 1),
									JE: $elm$core$String$fromInt(model.JE)
								}))
						])),
					A2(
					$author$project$Components$Shared$Annuaire$View$pagination,
					i18n,
					$author$project$Components$Shared$Annuaire$View$PaginationTenue(
						{
							Gc: vers($author$project$API$NavLinksDictionary$pagePrecedente),
							I7: vers($author$project$API$NavLinksDictionary$pageSuivante)
						}))
				]));
	});
var $author$project$I18n$Cles$pipesNoteAffichage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipes.note-affichage', _List_Nil, 'Une seule version publiée par pipe ; les dossiers en cours restent sur leur version. Les cartes et le tableau montrent les mêmes pipes.');
};
var $author$project$I18n$Cles$pipesVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipes.vide', _List_Nil, 'Aucun pipe.');
};
var $author$project$I18n$Cles$pipesColonneCible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipes.colonne-cible', _List_Nil, 'Cible');
};
var $author$project$I18n$Cles$pipesColonneDossiers = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipes.colonne-dossiers', _List_Nil, 'Dossiers en cours');
};
var $author$project$I18n$Cles$pipesColonneEtat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipes.colonne-etat', _List_Nil, 'État');
};
var $author$project$I18n$Cles$pipesColonneLien = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipes.colonne-lien', _List_Nil, 'Lien');
};
var $author$project$I18n$Cles$pipesColonnePipe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipes.colonne-pipe', _List_Nil, 'Pipe');
};
var $author$project$I18n$Cles$pipesColonnePortails = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipes.colonne-portails', _List_Nil, 'Portails');
};
var $author$project$I18n$Cles$pipesColonneType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipes.colonne-type', _List_Nil, 'Type de dossier');
};
var $author$project$I18n$Cles$pipesColonneVersion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipes.colonne-version', _List_Nil, 'Version');
};
var $author$project$Components$Parametrage$Pipes$View$entetes = function (i18n) {
	return _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (titre) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$th,
								_List_fromArray(
									[
										A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'scope', 'col')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(titre)
									]));
						},
						_List_fromArray(
							[
								$author$project$I18n$Cles$pipesColonnePipe(i18n),
								$author$project$I18n$Cles$pipesColonneVersion(i18n),
								$author$project$I18n$Cles$pipesColonneType(i18n),
								$author$project$I18n$Cles$pipesColonneCible(i18n),
								$author$project$I18n$Cles$pipesColonneEtat(i18n),
								$author$project$I18n$Cles$pipesColonneDossiers(i18n),
								$author$project$I18n$Cles$pipesColonnePortails(i18n),
								$author$project$I18n$Cles$pipesColonneLien(i18n)
							])))
				]))
		]);
};
var $author$project$I18n$Cles$pipesEtatTableauBrouillon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipes.etat-tableau.brouillon', _List_Nil, 'Brouillon');
};
var $author$project$I18n$Cles$pipesEtatTableauPublie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipes.etat-tableau.publie', _List_Nil, 'Publiée');
};
var $author$project$Components$Parametrage$Vocabulaire$etatDansLeTableau = F2(
	function (i18n, etat) {
		return (etat === 'brouillon') ? $author$project$I18n$Cles$pipesEtatTableauBrouillon(i18n) : $author$project$I18n$Cles$pipesEtatTableauPublie(i18n);
	});
var $author$project$Components$Parametrage$Pipes$View$sansValeur = F2(
	function (i18n, texte) {
		return $elm$core$String$isEmpty(texte) ? $author$project$I18n$Cles$pipesSansValeur(i18n) : texte;
	});
var $author$project$Components$Parametrage$Pipes$View$ligneDuTableau = F3(
	function (i18n, tous, pipe) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$th,
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'scope', 'row')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href(
									$author$project$Routes$Route$adressePipeEtape1(pipe.vx))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(pipe.R))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Parametrage$Vocabulaire$versions, i18n, pipe))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Components$Parametrage$Common$API$QueryAPIModel$libelle(pipe.CW))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Parametrage$Pipes$View$sansValeur, i18n, pipe.vf))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							$author$project$Components$Parametrage$Pipes$View$couleurDeLEtat(pipe.gt),
							A2($author$project$Components$Parametrage$Vocabulaire$etatDansLeTableau, i18n, pipe.gt))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(pipe.xK))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$Components$Parametrage$Pipes$View$sansValeur,
								i18n,
								A2($elm$core$String$join, ', ', pipe.F_)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A3($author$project$Components$Parametrage$Pipes$View$lienDeLaLigne, i18n, tous, pipe)
						]))
				]));
	});
var $author$project$Components$Parametrage$Pipes$View$tableau = F3(
	function (i18n, masque, pipes) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau'),
					$rtfeldman$elm_css$Html$Styled$Attributes$hidden(masque)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$table,
					_List_Nil,
					_Utils_ap(
						$author$project$Components$Parametrage$Pipes$View$entetes(i18n),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$tbody,
								_List_Nil,
								A2(
									$elm$core$List$map,
									A2($author$project$Components$Parametrage$Pipes$View$ligneDuTableau, i18n, pipes),
									pipes))
							])))
				]));
	});
var $author$project$Components$Parametrage$Pipes$View$liste = F3(
	function (i18n, model, pipes) {
		var affichage = model.iF;
		return $elm$core$List$isEmpty(pipes) ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$pipesVide(i18n))
					]))
			]) : _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$ul,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('list'),
						$rtfeldman$elm_css$Html$Styled$Attributes$hidden(!(!affichage))
					]),
				A2(
					$elm$core$List$map,
					A2($author$project$Components$Parametrage$Pipes$View$ligne, i18n, pipes),
					pipes)),
				A3($author$project$Components$Parametrage$Pipes$View$tableau, i18n, affichage !== 1, pipes),
				A3(
				$author$project$Components$Parametrage$Pipes$View$pied,
				i18n,
				model,
				$elm$core$List$length(pipes)),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('description'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$pipesNoteAffichage(i18n))
					]))
			]);
	});
var $author$project$I18n$Cles$pipesSousTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'pipes.sous-titre', _List_Nil, 'Les processus du client : un type de dossier, un parcours versionné.');
};
var $author$project$Components$Parametrage$Pipes$View$view = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'parametrage-pipes',
			{
				ut: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('main')
							]),
						A2(
							$elm$core$List$cons,
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							A2(
								$elm$core$List$cons,
								A2($author$project$Components$Parametrage$Pipes$View$bascule, i18n, model),
								A3(
									$author$project$Components$Parametrage$Pipes$View$liste,
									i18n,
									model,
									A2($elm$core$Maybe$withDefault, _List_Nil, model.FM)))))
					]),
				xy: _List_Nil,
				zM: _List_Nil,
				AK: false,
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: A2(
							$elm$core$List$cons,
							A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$pipesSousTitre(i18n))
									])),
							_Utils_ap(
								A2($author$project$Components$Parametrage$Pipes$View$ajoutDUnType, i18n, model.nQ),
								A2($author$project$Components$Parametrage$Pipes$View$lienDesModeles, i18n, model.nQ))),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adressePipes,
								Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
							},
								{
								aa: $author$project$Routes$Route$adressePipes,
								Dj: $author$project$I18n$Cles$pipesTitre(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$pipesTitre(i18n)
					})
			});
	});
var $author$project$Components$Parametrage$Utilisateurs$OngletsDeLAnnuaire$Annuaire = 0;
var $author$project$Components$Parametrage$Utilisateurs$Update$InvitationDemandee = {$: 8};
var $author$project$Components$Parametrage$Utilisateurs$Update$AnnulationConfirmee = {$: 29};
var $author$project$Components$Parametrage$Utilisateurs$Update$FocusDemande = function (a) {
	return {$: 31, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Update$tabulation = function (ids) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			var touche = _v0.a;
			var maj = _v0.b;
			var vers = _v0.c;
			return (touche !== 'Tab') ? $elm$json$Json$Decode$fail('') : ((maj && A2(
				$elm$core$List$member,
				vers,
				_List_fromArray(
					[ids.GN, ids.Cs]))) ? $elm$json$Json$Decode$succeed(
				_Utils_Tuple2(
					$author$project$Components$Parametrage$Utilisateurs$Update$FocusDemande(ids.j7),
					true)) : (((!maj) && A2(
				$elm$core$List$member,
				vers,
				_List_fromArray(
					[ids.GN, ids.j7]))) ? $elm$json$Json$Decode$succeed(
				_Utils_Tuple2(
					$author$project$Components$Parametrage$Utilisateurs$Update$FocusDemande(ids.Cs),
					true)) : $elm$json$Json$Decode$fail('')));
		},
		A4(
			$elm$json$Json$Decode$map3,
			F3(
				function (touche, maj, vers) {
					return _Utils_Tuple3(touche, maj, vers);
				}),
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['target', 'id']),
				$elm$json$Json$Decode$string)));
};
var $author$project$Components$Parametrage$Utilisateurs$Update$clavierDeLaConfirmation = $author$project$Components$Parametrage$Utilisateurs$Update$tabulation($author$project$Components$Parametrage$Utilisateurs$Model$idsDeLaConfirmation);
var $author$project$I18n$Cles$utilisateursAnnulationConfirmer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.annulation.confirmer', _List_Nil, 'Annuler l\'invitation');
};
var $author$project$I18n$Cles$utilisateursAnnulationGarder = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.annulation.garder', _List_Nil, 'Garder l\'invitation');
};
var $author$project$I18n$Cles$utilisateursAnnulationMessage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.annulation.message',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Le lien reçu ne fonctionnera plus et ' + (p.Dj + ' disparaîtra de l\'annuaire. Vous pourrez l\'inviter de nouveau.'));
	});
var $author$project$I18n$Cles$utilisateursAnnulationTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.annulation.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Annuler l\'invitation de ' + (p.Dj + ' ?'));
	});
var $author$project$Components$Parametrage$Utilisateurs$View$boite = F4(
	function (i18n, ids, nom, model) {
		return A2(
			$author$project$Components$Shared$Confirmation$View$view,
			i18n,
			{
				vl: $author$project$Components$Parametrage$Utilisateurs$Update$clavierDeLaConfirmation,
				j7: {
					Aq: ids.j7,
					Bl: $author$project$I18n$Cles$utilisateursAnnulationConfirmer(i18n),
					C$: $author$project$Components$Parametrage$Utilisateurs$Update$AnnulationConfirmee
				},
				Aq: ids.GN,
				As: ids.Cs,
				At: ids.h6,
				Cs: A2(
					$author$project$I18n$Cles$utilisateursAnnulationMessage,
					i18n,
					{Dj: nom}),
				Et: !_Utils_eq(model.iq, $elm$core$Maybe$Nothing),
				HG: {
					Aq: ids.z7,
					Bl: $author$project$I18n$Cles$utilisateursAnnulationGarder(i18n),
					C$: $author$project$Components$Parametrage$Utilisateurs$Update$AnnulationRenoncee
				},
				h6: A2(
					$author$project$I18n$Cles$utilisateursAnnulationTitre,
					i18n,
					{Dj: nom}),
				sl: 0
			});
	});
var $author$project$Components$Parametrage$Utilisateurs$View$confirmation = F2(
	function (i18n, model) {
		var nom = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Dj;
				},
				model.iq));
		var ids = $author$project$Components$Parametrage$Utilisateurs$Model$idsDeLaConfirmation;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'opened',
							!_Utils_eq(model.iq, $elm$core$Maybe$Nothing))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('overlay'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$Utilisateurs$Update$AnnulationRenoncee)
						]),
					_List_Nil),
					A4($author$project$Components$Parametrage$Utilisateurs$View$boite, i18n, ids, nom, model)
				]));
	});
var $author$project$I18n$Cles$utilisateursDescription = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.description',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.yz)))
				]),
			'Les collaborateurs ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.yz);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.yz);
					default:
						return 'de ' + $elm$core$String$trim(p.yz);
				}
			}() + ' qui ont accès au CRM.'));
	});
var $author$project$I18n$Cles$utilisateursDescriptionSansEspace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.description.sans-espace', _List_Nil, 'Les collaborateurs de l\'espace qui ont accès au CRM.');
};
var $author$project$Components$Parametrage$Utilisateurs$View$description = F2(
	function (i18n, espace) {
		if (!espace.$) {
			var nom = espace.a;
			return A2(
				$author$project$I18n$Cles$utilisateursDescription,
				i18n,
				{
					av: $author$project$Texte$Elision$elision(nom),
					yz: nom
				});
		} else {
			return $author$project$I18n$Cles$utilisateursDescriptionSansEspace(i18n);
		}
	});
var $author$project$Components$Parametrage$Utilisateurs$Update$EmailSaisi = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Update$InvitationValidee = {$: 14};
var $author$project$Components$Parametrage$Utilisateurs$Update$LangueChoisie = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Update$NomSaisi = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Update$PrenomSaisi = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Update$RoleCoche = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$Parametrage$Utilisateurs$View$caseDuRole = F2(
	function (coches, role) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('role'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'coche',
							A2($elm$core$List$member, role.Aq, coches))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id('utilisateurs-inviter-role-' + role.Aq),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(
							A2($elm$core$List$member, role.Aq, coches)),
							$rtfeldman$elm_css$Html$Styled$Events$onCheck(
							$author$project$Components$Parametrage$Utilisateurs$Update$RoleCoche(role.Aq))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(role.Dj)
						]))
				]));
	});
var $author$project$I18n$Cles$utilisateursInviterDClient = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.inviter.d-client',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'client',
					$author$project$I18n$Traductions$Chaine(p.jV))
				]),
			'd\'' + p.jV);
	});
var $author$project$I18n$Cles$utilisateursInviterDeClient = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.inviter.de-client',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'client',
					$author$project$I18n$Traductions$Chaine(p.jV))
				]),
			'de ' + p.jV);
	});
var $author$project$I18n$Cles$utilisateursInviterDuClient = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.inviter.du-client', _List_Nil, 'de l\'espace');
};
var $author$project$Components$Parametrage$Utilisateurs$View$voyelles = A2(
	$elm$core$List$map,
	$elm$core$Maybe$Just,
	_List_fromArray(
		['A', 'E', 'I', 'O', 'U', 'Y', 'É', 'È', 'Ê', 'Ë', 'À', 'Â', 'Î', 'Ï', 'Ô', 'Û']));
var $author$project$Components$Parametrage$Utilisateurs$View$duClient = F2(
	function (i18n, nom) {
		if (!nom.$) {
			var client = nom.a;
			return A2(
				$elm$core$List$member,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$first,
					$elm$core$String$uncons(
						$elm$core$String$toUpper(client))),
				$author$project$Components$Parametrage$Utilisateurs$View$voyelles) ? A2(
				$author$project$I18n$Cles$utilisateursInviterDClient,
				i18n,
				{jV: client}) : A2(
				$author$project$I18n$Cles$utilisateursInviterDeClient,
				i18n,
				{jV: client});
		} else {
			return $author$project$I18n$Cles$utilisateursInviterDuClient(i18n);
		}
	});
var $author$project$Components$Parametrage$Utilisateurs$Model$nomSaisi = function (saisie) {
	return $elm$core$String$trim(
		$elm$core$String$trim(saisie.Gg) + (' ' + $elm$core$String$trim(saisie.Dj)));
};
var $author$project$I18n$Cles$utilisateursInviter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.inviter', _List_Nil, 'Inviter un utilisateur');
};
var $author$project$I18n$Cles$utilisateursInviterAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.inviter.action', _List_Nil, 'Inviter');
};
var $author$project$I18n$Cles$utilisateursInviterDejaMembre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.inviter.deja-membre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'duClient',
					$author$project$I18n$Traductions$Chaine(p.xT))
				]),
			p.Dj + (' fait déjà partie ' + (p.xT + '.')));
	});
var $author$project$I18n$Cles$utilisateursInviterEmail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.inviter.email', _List_Nil, 'Email professionnel');
};
var $author$project$I18n$Cles$utilisateursInviterEmailInvalide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.inviter.email-invalide', _List_Nil, 'Adresse email invalide.');
};
var $author$project$I18n$Cles$utilisateursInviterEmailNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.inviter.email.note', _List_Nil, 'Si cette adresse a déjà un compte Asria, la personne est seulement ajoutée à l\'espace.');
};
var $author$project$I18n$Cles$utilisateursInviterIndisponible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.inviter.indisponible', _List_Nil, 'Aucun utilisateur n\'a été créé.');
};
var $author$project$I18n$Cles$utilisateursInviterIndisponibleTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.inviter.indisponible.titre', _List_Nil, 'L\'invitation n\'a pas pu être envoyée, réessayez dans quelques minutes.');
};
var $author$project$I18n$Cles$utilisateursInviterInfo = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.inviter.info', _List_Nil, 'La personne reçoit un email d\'Asria avec un lien valable 72 heures pour définir son mot de passe. L\'email n\'indique pas ses rôles.');
};
var $author$project$I18n$Cles$utilisateursInviterLangue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.inviter.langue', _List_Nil, 'Langue de l\'invitation et de l\'interface');
};
var $author$project$I18n$Cles$utilisateursInviterLangueEn = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.inviter.langue.en', _List_Nil, 'English');
};
var $author$project$I18n$Cles$utilisateursInviterLangueFr = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.inviter.langue.fr', _List_Nil, 'Français');
};
var $author$project$I18n$Cles$utilisateursInviterNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.inviter.nom', _List_Nil, 'Nom');
};
var $author$project$I18n$Cles$utilisateursInviterPrenom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.inviter.prenom', _List_Nil, 'Prénom');
};
var $author$project$I18n$Cles$utilisateursInviterRoles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.inviter.roles', _List_Nil, 'Rôles');
};
var $author$project$I18n$Cles$utilisateursInviterSansRole = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.inviter.sans-role',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.Dj + ' pourra se connecter mais ne verra rien dans le CRM tant qu\'un rôle ne lui est pas attribué.');
	});
var $author$project$I18n$Cles$utilisateursInviterSansRoleTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.inviter.sans-role.titre', _List_Nil, 'Aucun rôle coché.');
};
var $author$project$I18n$Cles$utilisateursRefusAutre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.refus-autre', _List_Nil, 'L\'opération n\'a pas abouti. Rien n\'a été modifié.');
};
var $author$project$I18n$Cles$utilisateursRefusEnvoiEnCours = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.refus-envoi-en-cours', _List_Nil, 'L\'envoi est déjà en cours. Rien de plus n\'a été envoyé : patientez un instant avant de réessayer.');
};
var $author$project$I18n$Cles$utilisateursRefusTropDInvitations = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.refus-trop-d-invitations', _List_Nil, 'Trop d\'invitations ont été envoyées dans l\'heure. Rien n\'a été envoyé : réessayez plus tard.');
};
var $author$project$Components$Parametrage$Utilisateurs$View$drawer = F2(
	function (i18n, model) {
		var saisie = model.hP;
		var erreurDeLEmail = function () {
			var _v5 = model.pZ;
			_v5$2:
			while (true) {
				if (!_v5.$) {
					switch (_v5.a) {
						case 1:
							var _v6 = _v5.a;
							return $elm$core$Maybe$Just(
								$author$project$I18n$Cles$utilisateursInviterEmailInvalide(i18n));
						case 0:
							var _v7 = _v5.a;
							return $elm$core$Maybe$Just(
								A2(
									$author$project$I18n$Cles$utilisateursInviterDejaMembre,
									i18n,
									{
										xT: A2($author$project$Components$Parametrage$Utilisateurs$View$duClient, i18n, model.g5),
										Dj: $author$project$Components$Parametrage$Utilisateurs$Model$nomSaisi(saisie)
									}));
						default:
							break _v5$2;
					}
				} else {
					break _v5$2;
				}
			}
			return $elm$core$Maybe$Nothing;
		}();
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Parametrage$Utilisateurs$Update$DuDrawer,
			{
				fs: {
					sR: (!_Utils_eq(
						$author$project$Components$Parametrage$Utilisateurs$Model$personne(saisie),
						$elm$core$Maybe$Nothing)) && (!$author$project$API$Envoi$enCours(model.l2)),
					Bl: $author$project$I18n$Cles$utilisateursInviterAction(i18n),
					C$: $author$project$Components$Parametrage$Utilisateurs$Update$InvitationValidee
				},
				fZ: _List_fromArray(
					[
						function () {
						var _v0 = model.pZ;
						_v0$4:
						while (true) {
							if (!_v0.$) {
								switch (_v0.a) {
									case 2:
										var _v1 = _v0.a;
										return A2(
											$author$project$Components$Shared$Note$View$view,
											2,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$strong,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$utilisateursInviterIndisponibleTitre(i18n))
														])),
													$rtfeldman$elm_css$Html$Styled$text(' '),
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$utilisateursInviterIndisponible(i18n))
												]));
									case 12:
										var _v2 = _v0.a;
										return A2(
											$author$project$Components$Shared$Note$View$view,
											1,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$utilisateursRefusAutre(i18n))
												]));
									case 4:
										var _v3 = _v0.a;
										return A2(
											$author$project$Components$Shared$Note$View$view,
											1,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$utilisateursRefusTropDInvitations(i18n))
												]));
									case 5:
										var _v4 = _v0.a;
										return A2(
											$author$project$Components$Shared$Note$View$view,
											1,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$utilisateursRefusEnvoiEnCours(i18n))
												]));
									default:
										break _v0$4;
								}
							} else {
								break _v0$4;
							}
						}
						return $rtfeldman$elm_css$Html$Styled$text('');
					}(),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('identite')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Champ$View$texte,
								{
									go: $elm$core$Maybe$Nothing,
									Aq: 'utilisateurs-inviter-prenom',
									Bl: $author$project$I18n$Cles$utilisateursInviterPrenom(i18n),
									he: true
								},
								{hg: $author$project$Components$Parametrage$Utilisateurs$Update$PrenomSaisi, fm: saisie.Gg}),
								A2(
								$author$project$Components$Shared$Champ$View$texte,
								{
									go: $elm$core$Maybe$Nothing,
									Aq: 'utilisateurs-inviter-nom',
									Bl: $author$project$I18n$Cles$utilisateursInviterNom(i18n),
									he: true
								},
								{hg: $author$project$Components$Parametrage$Utilisateurs$Update$NomSaisi, fm: saisie.Dj})
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('email')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Champ$View$texteDecritPar,
								{
									go: erreurDeLEmail,
									Aq: 'utilisateurs-inviter-email',
									Bl: $author$project$I18n$Cles$utilisateursInviterEmail(i18n),
									he: true
								},
								{wV: 'utilisateurs-inviter-email-note', hg: $author$project$Components$Parametrage$Utilisateurs$Update$EmailSaisi, fm: saisie.yb}),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('utilisateurs-inviter-email-note'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('note'),
										$rtfeldman$elm_css$Html$Styled$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'hidden',
												!_Utils_eq(erreurDeLEmail, $elm$core$Maybe$Nothing))
											]))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$utilisateursInviterEmailNote(i18n))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$fieldset,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('roles')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$legend,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$utilisateursInviterRoles(i18n))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('bloc')
									]),
								A2(
									$elm$core$List$map,
									$author$project$Components$Parametrage$Utilisateurs$View$caseDuRole(saisie.eX),
									$author$project$Components$Parametrage$Utilisateurs$Model$rolesAttribuables(model)))
							])),
						A2(
						$author$project$Components$Shared$Champ$View$compose,
						{
							go: $elm$core$Maybe$Nothing,
							Aq: 'utilisateurs-inviter-langue',
							Bl: $author$project$I18n$Cles$utilisateursInviterLangue(i18n),
							he: false
						},
						_List_fromArray(
							[
								$author$project$Components$Shared$Segment$View$view(
								{
									vd: saisie.nn,
									Bi: $author$project$I18n$Cles$utilisateursInviterLangue(i18n),
									Dj: 'utilisateurs-inviter-langue',
									Ea: $author$project$Components$Parametrage$Utilisateurs$Update$LangueChoisie,
									o_: _List_fromArray(
										[
											{
											vx: 'fr',
											Bl: $author$project$I18n$Cles$utilisateursInviterLangueFr(i18n)
										},
											{
											vx: 'en',
											Bl: $author$project$I18n$Cles$utilisateursInviterLangueEn(i18n)
										}
										])
								})
							])),
						_Utils_eq(
						model.pZ,
						$elm$core$Maybe$Just(0)) ? $rtfeldman$elm_css$Html$Styled$text('') : ($elm$core$List$isEmpty(saisie.eX) ? A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$utilisateursInviterSansRoleTitre(i18n))
									])),
								$rtfeldman$elm_css$Html$Styled$text(' '),
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$utilisateursInviterSansRole,
									i18n,
									{
										Dj: $author$project$Components$Parametrage$Utilisateurs$Model$nomSaisi(saisie)
									}))
							])) : A2(
						$author$project$Components$Shared$Note$View$view,
						0,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$utilisateursInviterInfo(i18n))
							])))
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$utilisateursInviter(i18n)
			},
			model.kX);
	});
var $author$project$Components$Parametrage$Utilisateurs$Update$DoubleAuthentificationFiltree = function (a) {
	return {$: 34, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Update$EtatFiltre = function (a) {
	return {$: 32, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Update$FiltreDeLEtatRetire = {$: 35};
var $author$project$Components$Parametrage$Utilisateurs$Update$FiltreDeLaDoubleAuthentificationRetire = {$: 37};
var $author$project$Components$Parametrage$Utilisateurs$Update$FiltreDuRoleRetire = {$: 36};
var $author$project$Components$Parametrage$Utilisateurs$Update$FiltresEffaces = {$: 38};
var $author$project$Components$Parametrage$Utilisateurs$Update$RoleFiltre = function (a) {
	return {$: 33, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Model$filtresActifs = function (filtres) {
	return !_Utils_eq(filtres, $author$project$Components$Parametrage$Utilisateurs$Model$filtresVides);
};
var $author$project$I18n$Cles$utilisateursEtatActif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.etat.actif', _List_Nil, 'Actif');
};
var $author$project$I18n$Cles$utilisateursEtatDesactive = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.etat.desactive', _List_Nil, 'Désactivé');
};
var $author$project$I18n$Cles$utilisateursEtatEnvoyee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.etat.envoyee', _List_Nil, 'Invitation envoyée');
};
var $author$project$I18n$Cles$utilisateursEtatExpiree = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.etat.expiree', _List_Nil, 'Expirée');
};
var $author$project$Components$Parametrage$Utilisateurs$View$libelleDeLEtat = F2(
	function (i18n, valeur) {
		switch (valeur) {
			case 0:
				return $author$project$I18n$Cles$utilisateursEtatActif(i18n);
			case 1:
				return $author$project$I18n$Cles$utilisateursEtatDesactive(i18n);
			case 2:
				return $author$project$I18n$Cles$utilisateursEtatEnvoyee(i18n);
			default:
				return $author$project$I18n$Cles$utilisateursEtatExpiree(i18n);
		}
	});
var $author$project$I18n$Cles$utilisateursDoubleAuthentificationActivee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.double-authentification.activee', _List_Nil, 'Activée');
};
var $author$project$I18n$Cles$utilisateursDoubleAuthentificationNonActivee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.double-authentification.non-activee', _List_Nil, 'Non activée');
};
var $author$project$Components$Parametrage$Utilisateurs$View$libelleDeLaDoubleAuthentification = F2(
	function (i18n, active) {
		return active ? $author$project$I18n$Cles$utilisateursDoubleAuthentificationActivee(i18n) : $author$project$I18n$Cles$utilisateursDoubleAuthentificationNonActivee(i18n);
	});
var $author$project$Components$Parametrage$Utilisateurs$Model$rolesDeLAnnuaire = function (model) {
	return A3(
		$elm$core$List$foldr,
		F2(
			function (role, vus) {
				return _Utils_eq(
					$elm$core$List$head(vus),
					$elm$core$Maybe$Just(role)) ? vus : A2($elm$core$List$cons, role, vus);
			}),
		_List_Nil,
		$elm$core$List$sort(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Kf;
						},
						$elm$core$List$concatMap(
							function ($) {
								return $.eX;
							})),
					model.aS))));
};
var $author$project$I18n$Cles$utilisateursFiltreRetirer = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.filtre.retirer',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'filtre',
					$author$project$I18n$Traductions$Chaine(p.zH))
				]),
			'Retirer le filtre « ' + (p.zH + ' »'));
	});
var $author$project$Components$Parametrage$Utilisateurs$View$tagDeFiltre = F3(
	function (libelle, retirer, i18n) {
		var nom = A2(
			$author$project$I18n$Cles$utilisateursFiltreRetirer,
			i18n,
			{zH: libelle});
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('filtre-actif')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(libelle),
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('button-icon'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', nom),
							$rtfeldman$elm_css$Html$Styled$Attributes$title(nom),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(retirer)
						]),
					_List_fromArray(
						[$author$project$Components$Shared$Svg$svgClose]))
				]));
	});
var $author$project$I18n$Cles$utilisateursFiltreDoubleAuthentification = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.filtre.double-authentification', _List_Nil, 'Double authentification');
};
var $author$project$I18n$Cles$utilisateursFiltreEtat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.filtre.etat', _List_Nil, 'État');
};
var $author$project$I18n$Cles$utilisateursFiltreRole = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.filtre.role', _List_Nil, 'Rôle');
};
var $author$project$I18n$Cles$utilisateursFiltreTagDoubleAuthentification = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.filtre.tag.double-authentification',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			'Double authentification : ' + p.fm);
	});
var $author$project$I18n$Cles$utilisateursFiltreTagEtat = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.filtre.tag.etat',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			'État : ' + p.fm);
	});
var $author$project$I18n$Cles$utilisateursFiltreTagRole = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.filtre.tag.role',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			'Rôle : ' + p.fm);
	});
var $author$project$I18n$Cles$utilisateursFiltreTous = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.filtre.tous', _List_Nil, 'Tous');
};
var $author$project$I18n$Cles$utilisateursFiltres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.filtres', _List_Nil, 'Filtres');
};
var $author$project$I18n$Cles$utilisateursFiltresEffacer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.filtres.effacer', _List_Nil, 'Tout effacer');
};
var $author$project$I18n$Cles$utilisateursNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.note', _List_Nil, 'Les rôles se règlent aussi dans Rôles et droits. Nom, email et mot de passe restent ceux du compte Asria de chacun.');
};
var $author$project$Components$Parametrage$Utilisateurs$View$filtres = F2(
	function (i18n, model) {
		var tous = {
			Bl: $author$project$I18n$Cles$utilisateursFiltreTous(i18n),
			fm: ''
		};
		var doubleAuthentification = function () {
			var _v0 = model.mG.kV;
			if (!_v0.$) {
				if (_v0.a) {
					return 'activee';
				} else {
					return 'non-activee';
				}
			} else {
				return '';
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id('filters')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$utilisateursFiltres(i18n))
						])),
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: 'utilisateurs-filtre-etat',
						Bl: $author$project$I18n$Cles$utilisateursFiltreEtat(i18n),
						he: false
					},
					{
						hg: $author$project$Components$Parametrage$Utilisateurs$Update$EtatFiltre,
						o_: A2(
							$elm$core$List$cons,
							tous,
							A2(
								$elm$core$List$map,
								function (e) {
									return {
										Bl: A2($author$project$Components$Parametrage$Utilisateurs$View$libelleDeLEtat, i18n, e),
										fm: $author$project$Components$Parametrage$Utilisateurs$Model$codeDeLEtat(e)
									};
								},
								_List_fromArray(
									[0, 1, 2, 3]))),
						fm: A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, $author$project$Components$Parametrage$Utilisateurs$Model$codeDeLEtat, model.mG.gt))
					}),
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: 'utilisateurs-filtre-role',
						Bl: $author$project$I18n$Cles$utilisateursFiltreRole(i18n),
						he: false
					},
					{
						hg: $author$project$Components$Parametrage$Utilisateurs$Update$RoleFiltre,
						o_: A2(
							$elm$core$List$cons,
							tous,
							A2(
								$elm$core$List$map,
								function (role) {
									return {Bl: role, fm: role};
								},
								$author$project$Components$Parametrage$Utilisateurs$Model$rolesDeLAnnuaire(model))),
						fm: A2($elm$core$Maybe$withDefault, '', model.mG.bi)
					}),
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: 'utilisateurs-filtre-double-authentification',
						Bl: $author$project$I18n$Cles$utilisateursFiltreDoubleAuthentification(i18n),
						he: false
					},
					{
						hg: $author$project$Components$Parametrage$Utilisateurs$Update$DoubleAuthentificationFiltree,
						o_: _List_fromArray(
							[
								tous,
								{
								Bl: $author$project$I18n$Cles$utilisateursDoubleAuthentificationActivee(i18n),
								fm: 'activee'
							},
								{
								Bl: $author$project$I18n$Cles$utilisateursDoubleAuthentificationNonActivee(i18n),
								fm: 'non-activee'
							}
							]),
						fm: doubleAuthentification
					}),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('filtres-actifs'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'hidden',
									!$author$project$Components$Parametrage$Utilisateurs$Model$filtresActifs(model.mG))
								]))
						]),
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$map,
								function (e) {
									return A3(
										$author$project$Components$Parametrage$Utilisateurs$View$tagDeFiltre,
										A2(
											$author$project$I18n$Cles$utilisateursFiltreTagEtat,
											i18n,
											{
												fm: A2($author$project$Components$Parametrage$Utilisateurs$View$libelleDeLEtat, i18n, e)
											}),
										$author$project$Components$Parametrage$Utilisateurs$Update$FiltreDeLEtatRetire,
										i18n);
								},
								model.mG.gt),
								A2(
								$elm$core$Maybe$map,
								function (role) {
									return A3(
										$author$project$Components$Parametrage$Utilisateurs$View$tagDeFiltre,
										A2(
											$author$project$I18n$Cles$utilisateursFiltreTagRole,
											i18n,
											{fm: role}),
										$author$project$Components$Parametrage$Utilisateurs$Update$FiltreDuRoleRetire,
										i18n);
								},
								model.mG.bi),
								A2(
								$elm$core$Maybe$map,
								function (active) {
									return A3(
										$author$project$Components$Parametrage$Utilisateurs$View$tagDeFiltre,
										A2(
											$author$project$I18n$Cles$utilisateursFiltreTagDoubleAuthentification,
											i18n,
											{
												fm: A2($author$project$Components$Parametrage$Utilisateurs$View$libelleDeLaDoubleAuthentification, i18n, active)
											}),
										$author$project$Components$Parametrage$Utilisateurs$Update$FiltreDeLaDoubleAuthentificationRetire,
										i18n);
								},
								model.mG.kV),
								$elm$core$Maybe$Just(
								A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									2,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('effacer'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$Utilisateurs$Update$FiltresEffaces)
										]),
									$author$project$I18n$Cles$utilisateursFiltresEffacer(i18n)))
							]))),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$utilisateursNote(i18n))
						]))
				]));
	});
var $author$project$Components$Parametrage$Utilisateurs$Update$RelectureDemandee = {$: 39};
var $author$project$Components$Parametrage$Utilisateurs$Model$decompte = function (lignes) {
	var compter = function (etat) {
		return $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.gt;
					},
					$elm$core$Basics$eq(etat)),
				lignes));
	};
	return {
		xq: compter(1),
		y6: compter(3),
		Kf: $elm$core$List$length(lignes)
	};
};
var $author$project$Components$Parametrage$Utilisateurs$Update$AnnulationDemandee = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Update$RenvoiDemande = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Model$cibleDeLaLigne = function (ligne) {
	return {kh: ligne.kh, nQ: ligne.nQ, Dj: ligne.Dj, fl: ligne.fl};
};
var $author$project$Components$Parametrage$Utilisateurs$Model$datesDeLInvitation = F2(
	function (model, utilisateur) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.fl;
					},
					$elm$core$Basics$eq(utilisateur)),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.AU;
						},
						model.AU))));
	});
var $author$project$Components$Parametrage$Utilisateurs$View$geste = F6(
	function (rel, utilisateur, classe, libelle, nom, msg) {
		return A2(
			$elm$core$Maybe$map,
			function (_v0) {
				return A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class(classe),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', nom),
							$rtfeldman$elm_css$Html$Styled$Attributes$title(nom),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
						]),
					libelle);
			},
			A2($author$project$API$Liens$trouver, rel, utilisateur.nQ));
	});
var $author$project$I18n$Cles$utilisateursAnnuler = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.annuler', _List_Nil, 'Annuler');
};
var $author$project$I18n$Cles$utilisateursAnnulerNom = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.annuler.nom',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Annuler l\'invitation de ' + p.Dj);
	});
var $author$project$I18n$Cles$utilisateursExpireLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.expire-le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv)),
					_Utils_Tuple2(
					'heure',
					$author$project$I18n$Traductions$Chaine(p.Ah))
				]),
			'Expire le ' + (p.wv + (' à ' + p.Ah)));
	});
var $author$project$I18n$Cles$utilisateursExpireeLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.expiree-le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Expirée le ' + p.wv);
	});
var $author$project$I18n$Cles$utilisateursInviteLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.invite-le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Invité(e) le ' + p.wv);
	});
var $author$project$I18n$Cles$utilisateursRenvoyer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.renvoyer', _List_Nil, 'Renvoyer');
};
var $author$project$I18n$Cles$utilisateursRenvoyerNom = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.renvoyer.nom',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Renvoyer l\'invitation de ' + p.Dj);
	});
var $author$project$Components$Parametrage$Utilisateurs$View$datesEtGestes = F3(
	function (i18n, model, utilisateur) {
		var jour = function (instant) {
			return A2(
				$author$project$Texte$Jour$enFrancais,
				i18n,
				A2($elm$core$String$left, 10, instant));
		};
		return _List_fromArray(
			[
				function () {
				var _v0 = A2($author$project$Components$Parametrage$Utilisateurs$Model$datesDeLInvitation, model, utilisateur.fl);
				if (!_v0.$) {
					var invitation = _v0.a;
					return A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('dates')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$utilisateursInviteLe,
									i18n,
									{
										wv: jour(invitation.yw)
									})),
								A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text(
								(utilisateur.gt === 3) ? A2(
									$author$project$I18n$Cles$utilisateursExpireeLe,
									i18n,
									{
										wv: jour(invitation.y3)
									}) : A2(
									$author$project$I18n$Cles$utilisateursExpireLe,
									i18n,
									{
										wv: jour(invitation.y3),
										Ah: A3($elm$core$String$slice, 11, 16, invitation.y3)
									}))
							]));
				} else {
					return $rtfeldman$elm_css$Html$Styled$text('');
				}
			}(),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
					]),
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A6(
							$author$project$Components$Parametrage$Utilisateurs$View$geste,
							$author$project$API$NavLinksDictionary$renvoyerUneInvitation,
							utilisateur,
							'renvoyer',
							$author$project$I18n$Cles$utilisateursRenvoyer(i18n),
							A2(
								$author$project$I18n$Cles$utilisateursRenvoyerNom,
								i18n,
								{Dj: utilisateur.Dj}),
							$author$project$Components$Parametrage$Utilisateurs$Update$RenvoiDemande(
								$author$project$Components$Parametrage$Utilisateurs$Model$cibleDeLaLigne(utilisateur))),
							A6(
							$author$project$Components$Parametrage$Utilisateurs$View$geste,
							$author$project$API$NavLinksDictionary$annulerUneInvitation,
							utilisateur,
							'annuler',
							$author$project$I18n$Cles$utilisateursAnnuler(i18n),
							A2(
								$author$project$I18n$Cles$utilisateursAnnulerNom,
								i18n,
								{Dj: utilisateur.Dj}),
							$author$project$Components$Parametrage$Utilisateurs$Update$AnnulationDemandee(
								$author$project$Components$Parametrage$Utilisateurs$Model$cibleDeLaLigne(utilisateur)))
						])))
			]);
	});
var $author$project$I18n$Cles$utilisateursDesactiveLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.desactive-le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Désactivé le ' + p.wv);
	});
var $author$project$I18n$Cles$utilisateursSansValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.sans-valeur', _List_Nil, '—');
};
var $author$project$Components$Parametrage$Utilisateurs$View$desactiveLe = F2(
	function (i18n, le) {
		if (!le.$) {
			var instant = le.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('desactive-le')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$utilisateursDesactiveLe,
							i18n,
							{
								wv: A2(
									$author$project$Texte$Jour$enFrancais,
									i18n,
									A2($elm$core$String$left, 10, instant))
							}))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text(
				$author$project$I18n$Cles$utilisateursSansValeur(i18n));
		}
	});
var $author$project$Components$Parametrage$Utilisateurs$View$etat = F2(
	function (i18n, valeur) {
		switch (valeur) {
			case 0:
				return A2(
					$author$project$Components$Shared$Tag$View$view,
					0,
					A2($author$project$Components$Parametrage$Utilisateurs$View$libelleDeLEtat, i18n, valeur));
			case 1:
				return A2(
					$author$project$Components$Shared$Tag$View$view,
					3,
					A2($author$project$Components$Parametrage$Utilisateurs$View$libelleDeLEtat, i18n, valeur));
			case 2:
				return A2(
					$author$project$Components$Shared$Tag$View$view,
					5,
					A2($author$project$Components$Parametrage$Utilisateurs$View$libelleDeLEtat, i18n, valeur));
			default:
				return A2(
					$author$project$Components$Shared$Tag$View$view,
					1,
					A2($author$project$Components$Parametrage$Utilisateurs$View$libelleDeLEtat, i18n, valeur));
		}
	});
var $author$project$I18n$Cles$utilisateursVous = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.vous', _List_Nil, 'Vous');
};
var $author$project$Components$Parametrage$Utilisateurs$View$ligne = F3(
	function (i18n, model, utilisateur) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('utilisateur'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('desactive', utilisateur.gt === 1)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('identite')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href(
											$author$project$Routes$Route$adresseDUnUtilisateur(utilisateur.fl))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(utilisateur.Dj)
										])),
									utilisateur.KX ? A2(
									$author$project$Components$Shared$Tag$View$view,
									3,
									$author$project$I18n$Cles$utilisateursVous(i18n)) : $rtfeldman$elm_css$Html$Styled$text('')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('email')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(utilisateur.kh)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('roles')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$String$join, ', ', utilisateur.eX))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('etat')
						]),
					_List_fromArray(
						[
							A2($author$project$Components$Parametrage$Utilisateurs$View$etat, i18n, utilisateur.gt)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('double-authentification')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$I18n$Cles$utilisateursSansValeur(i18n),
								A2(
									$elm$core$Maybe$map,
									$author$project$Components$Parametrage$Utilisateurs$View$libelleDeLaDoubleAuthentification(i18n),
									utilisateur.kV)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('connexion')
						]),
					function () {
						var _v0 = utilisateur.gt;
						switch (_v0) {
							case 2:
								return A3($author$project$Components$Parametrage$Utilisateurs$View$datesEtGestes, i18n, model, utilisateur);
							case 3:
								return A3($author$project$Components$Parametrage$Utilisateurs$View$datesEtGestes, i18n, model, utilisateur);
							case 1:
								return _List_fromArray(
									[
										A2($author$project$Components$Parametrage$Utilisateurs$View$desactiveLe, i18n, utilisateur.xp)
									]);
							default:
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$elm$core$Maybe$withDefault,
											$author$project$I18n$Cles$utilisateursSansValeur(i18n),
											A2(
												$elm$core$Maybe$map,
												$author$project$Texte$Jour$horodateALHeure(i18n),
												utilisateur.kJ)))
									]);
						}
					}())
				]));
	});
var $author$project$I18n$Cles$utilisateursSeul = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.seul',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(p.yz))
				]),
			'Personne d\'autre que vous n\'a accès à ' + (p.yz + '. Invitez vos collègues : ils recevront un email pour définir leur mot de passe.'));
	});
var $author$project$I18n$Cles$utilisateursSeulSansEspace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.seul.sans-espace', _List_Nil, 'Personne d\'autre que vous n\'a accès à cet espace. Invitez vos collègues : ils recevront un email pour définir leur mot de passe.');
};
var $author$project$Components$Parametrage$Utilisateurs$View$seul = F2(
	function (i18n, espace) {
		if (!espace.$) {
			var nom = espace.a;
			return A2(
				$author$project$I18n$Cles$utilisateursSeul,
				i18n,
				{yz: nom});
		} else {
			return $author$project$I18n$Cles$utilisateursSeulSansEspace(i18n);
		}
	});
var $author$project$Components$Parametrage$Utilisateurs$Model$seulDansLEspace = function (model) {
	var _v0 = A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.Kf;
		},
		model.aS);
	if (((!_v0.$) && _v0.a.b) && (!_v0.a.b.b)) {
		var _v1 = _v0.a;
		var seul = _v1.a;
		return seul.KX;
	} else {
		return false;
	}
};
var $author$project$Components$Parametrage$Utilisateurs$View$siPresent = F2(
	function (nombre, libelle) {
		return (nombre > 0) ? $elm$core$Maybe$Just(
			libelle(nombre)) : $elm$core$Maybe$Nothing;
	});
var $author$project$I18n$Cles$utilisateursAucunResultat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.aucun-resultat', _List_Nil, 'Aucun utilisateur ne correspond à ces filtres.');
};
var $author$project$I18n$Cles$utilisateursColonneConnexion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.colonne.connexion', _List_Nil, 'Dernière connexion');
};
var $author$project$I18n$Cles$utilisateursColonneDoubleAuthentification = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.colonne.double-authentification', _List_Nil, 'Double auth.');
};
var $author$project$I18n$Cles$utilisateursColonneEtat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.colonne.etat', _List_Nil, 'État');
};
var $author$project$I18n$Cles$utilisateursColonneRoles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.colonne.roles', _List_Nil, 'Rôles');
};
var $author$project$I18n$Cles$utilisateursColonneUtilisateur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.colonne.utilisateur', _List_Nil, 'Utilisateur');
};
var $author$project$I18n$Cles$utilisateursCompte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.compte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' utilisateur') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' utilisateurs'));
	});
var $author$project$I18n$Cles$utilisateursCompteDesactives = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.compte.desactives',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' désactivé') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' désactivés'));
	});
var $author$project$I18n$Cles$utilisateursCompteExpirees = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.compte.expirees',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' invitation expirée') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' invitations expirées'));
	});
var $author$project$I18n$Cles$utilisateursIndisponible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.indisponible', _List_Nil, 'La liste des utilisateurs est momentanément indisponible. Réessayez dans quelques minutes.');
};
var $author$project$I18n$Cles$utilisateursReessayer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.reessayer', _List_Nil, 'Réessayer');
};
var $author$project$Components$Parametrage$Utilisateurs$Model$visibles = function (model) {
	var retenu = F2(
		function (choix, valeur) {
			return _Utils_eq(choix, $elm$core$Maybe$Nothing) || _Utils_eq(choix, valeur);
		});
	var filtres = model.mG;
	return A2(
		$elm$core$List$filter,
		function (u) {
			return A2(
				retenu,
				filtres.gt,
				$elm$core$Maybe$Just(u.gt)) && ((_Utils_eq(filtres.bi, $elm$core$Maybe$Nothing) || A2(
				$elm$core$List$any,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$Just,
					$elm$core$Basics$eq(filtres.bi)),
				u.eX)) && A2(retenu, filtres.kV, u.kV));
		},
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Kf;
				},
				model.aS)));
};
var $author$project$Components$Parametrage$Utilisateurs$View$liste = F2(
	function (i18n, model) {
		var lignes = $author$project$Components$Parametrage$Utilisateurs$Model$visibles(model);
		var disponible = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.kR;
				},
				model.aS));
		var compte = $author$project$Components$Parametrage$Utilisateurs$Model$decompte(lignes);
		var decompte = A2(
			$elm$core$List$cons,
			A2(
				$author$project$I18n$Cles$utilisateursCompte,
				i18n,
				{w: compte.Kf}),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$author$project$Components$Parametrage$Utilisateurs$View$siPresent,
						compte.y6,
						function (n) {
							return A2(
								$author$project$I18n$Cles$utilisateursCompteExpirees,
								i18n,
								{w: n});
						}),
						A2(
						$author$project$Components$Parametrage$Utilisateurs$View$siPresent,
						compte.xq,
						function (n) {
							return A2(
								$author$project$I18n$Cles$utilisateursCompteDesactives,
								i18n,
								{w: n});
						})
					])));
		return (!disponible) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('liste'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('indisponible')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Note$View$view,
					2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$utilisateursIndisponible(i18n)),
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('reessayer'),
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$Utilisateurs$Update$RelectureDemandee)
								]),
							$author$project$I18n$Cles$utilisateursReessayer(i18n))
						]))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('liste')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$String$join, ' · ', decompte))
						])),
					($elm$core$List$isEmpty(lignes) && $author$project$Components$Parametrage$Utilisateurs$Model$filtresActifs(model.mG)) ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('aucun-resultat')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$utilisateursAucunResultat(i18n))
								])),
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							2,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$Utilisateurs$Update$FiltresEffaces)
								]),
							$author$project$I18n$Cles$utilisateursFiltresEffacer(i18n))
						])) : A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$table,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$thead,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$tr,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$utilisateursColonneUtilisateur(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$utilisateursColonneRoles(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$utilisateursColonneEtat(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$utilisateursColonneDoubleAuthentification(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$utilisateursColonneConnexion(i18n))
														]))
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$tbody,
									_List_Nil,
									A2(
										$elm$core$List$map,
										A2($author$project$Components$Parametrage$Utilisateurs$View$ligne, i18n, model),
										lignes))
								]))
						])),
					$author$project$Components$Parametrage$Utilisateurs$Model$seulDansLEspace(model) ? A2(
					$author$project$Components$Shared$Note$View$view,
					0,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Parametrage$Utilisateurs$View$seul, i18n, model.g5))
						])) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$Components$Parametrage$Utilisateurs$OngletsDeLAnnuaire$Connexions = 2;
var $author$project$Components$Parametrage$Utilisateurs$OngletsDeLAnnuaire$Securite = 1;
var $author$project$I18n$Cles$utilisateursOngletConnexions = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.onglet.connexions', _List_Nil, 'Connexions');
};
var $author$project$I18n$Cles$utilisateursOngletSecurite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.onglet.securite', _List_Nil, 'Sécurité');
};
var $author$project$I18n$Cles$utilisateursOngletUtilisateurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.onglet.utilisateurs', _List_Nil, 'Utilisateurs');
};
var $author$project$Components$Parametrage$Utilisateurs$OngletsDeLAnnuaire$onglets = F3(
	function (i18n, actif, model) {
		var propose = F2(
			function (lien, onglet_) {
				if (!lien.$) {
					return _List_fromArray(
						[onglet_]);
				} else {
					return _List_Nil;
				}
			});
		var onglet = F3(
			function (nom, adresse, estActif) {
				return {sO: estActif, aa: adresse, vW: $elm$core$Maybe$Nothing, Dj: nom};
			});
		var tous = A2(
			$elm$core$List$cons,
			A3(
				onglet,
				$author$project$I18n$Cles$utilisateursOngletUtilisateurs(i18n),
				$author$project$Routes$Route$adresseDesUtilisateurs,
				!actif),
			_Utils_ap(
				A2(
					propose,
					model.nr,
					A3(
						onglet,
						$author$project$I18n$Cles$utilisateursOngletSecurite(i18n),
						$author$project$Routes$Route$adresseDeLaSecuriteDesUtilisateurs,
						actif === 1)),
				A2(
					propose,
					model.a$.nB,
					A3(
						onglet,
						$author$project$I18n$Cles$utilisateursOngletConnexions(i18n),
						$author$project$Routes$Route$adresseDuJournalDesConnexions($elm$core$Maybe$Nothing),
						actif === 2))));
		return ($elm$core$List$length(tous) > 1) ? _List_fromArray(
			[
				$author$project$Components$Shared$Onglets$View$view(tous)
			]) : _List_Nil;
	});
var $author$project$I18n$Cles$utilisateursRefusCompteActif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.refus-compte-actif', _List_Nil, 'La personne a déjà activé son compte : l\'invitation ne se renvoie ni ne s\'annule.');
};
var $author$project$Components$Parametrage$Utilisateurs$View$refusDUnGeste = F2(
	function (i18n, model) {
		if ($author$project$Components$Parametrage$Utilisateurs$Update$dialogueOuvert(model)) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var _v0 = model.pZ;
			if (!_v0.$) {
				switch (_v0.a) {
					case 2:
						var _v1 = _v0.a;
						return A2(
							$author$project$Components$Shared$Note$View$view,
							2,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$utilisateursInviterIndisponibleTitre(i18n))
								]));
					case 3:
						var _v2 = _v0.a;
						return A2(
							$author$project$Components$Shared$Note$View$view,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$utilisateursRefusCompteActif(i18n))
								]));
					case 4:
						var _v3 = _v0.a;
						return A2(
							$author$project$Components$Shared$Note$View$view,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$utilisateursRefusTropDInvitations(i18n))
								]));
					case 5:
						var _v4 = _v0.a;
						return A2(
							$author$project$Components$Shared$Note$View$view,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$utilisateursRefusEnvoiEnCours(i18n))
								]));
					default:
						return A2(
							$author$project$Components$Shared$Note$View$view,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$utilisateursRefusAutre(i18n))
								]));
				}
			} else {
				return $rtfeldman$elm_css$Html$Styled$text('');
			}
		}
	});
var $author$project$I18n$Cles$utilisateursRoleNonAttribue = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.role-non-attribue',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Le rôle « ' + (p.bi + (' » n\'a pas été attribué à ' + (p.Dj + ' : attribuez-le dans Rôles et droits.'))));
	});
var $author$project$Components$Parametrage$Utilisateurs$View$rolesNonAttribues = F2(
	function (i18n, model) {
		var _v0 = model.i7;
		if (!_v0.$) {
			var attribution = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('roles-non-attribues')
					]),
				A2(
					$elm$core$List$map,
					function (role) {
						return A2(
							$author$project$Components$Shared$Note$View$view,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$utilisateursRoleNonAttribue,
										i18n,
										{Dj: attribution.Dj, bi: role}))
								]));
					},
					attribution.x3));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$utilisateursFil = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fil', _List_Nil, 'Utilisateurs');
};
var $author$project$I18n$Cles$utilisateursTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.titre', _List_Nil, 'Utilisateurs');
};
var $author$project$Components$Parametrage$Utilisateurs$View$annuaire = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'parametrage-utilisateurs',
			{
				ut: model.qa ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('acces-refuse')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Note$View$view,
										1,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$coquilleAccesRefuse(i18n))
													]))
											]))
									]))
							]))
					]) : _List_fromArray(
					[
						A2($author$project$Components$Parametrage$Utilisateurs$View$filtres, i18n, model),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						_List_fromArray(
							[
								A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('annonces')
									]),
								A2(
									$elm$core$List$map,
									function (annonce) {
										return A2(
											$author$project$Components$Shared$Note$View$view,
											3,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2($author$project$I18n$Cles$texte, i18n, annonce))
												]));
									},
									model.tn)),
								A2($author$project$Components$Parametrage$Utilisateurs$View$rolesNonAttribues, i18n, model),
								A2($author$project$Components$Parametrage$Utilisateurs$View$refusDUnGeste, i18n, model),
								A2($author$project$Components$Parametrage$Utilisateurs$View$liste, i18n, model)
							]))
					]),
				xy: _List_fromArray(
					[
						A2($author$project$Components$Parametrage$Utilisateurs$View$drawer, i18n, model),
						A2($author$project$Components$Parametrage$Utilisateurs$View$confirmation, i18n, model)
					]),
				zM: function () {
					var _v0 = $author$project$Components$Parametrage$Utilisateurs$Model$lienDeLInvitation(model);
					if (!_v0.$) {
						return _List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								0,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('utilisateurs-inviter-ouvrir'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$Utilisateurs$Update$InvitationDemandee)
									]),
								$author$project$I18n$Cles$utilisateursInviter(i18n))
							]);
					} else {
						return _List_Nil;
					}
				}(),
				AK: $author$project$Components$Parametrage$Utilisateurs$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$Components$Parametrage$Utilisateurs$View$description, i18n, model.g5))
									]))
							]),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adresseTypesDePartiesPrenantes,
								Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
							},
								{
								aa: '',
								Dj: $author$project$I18n$Cles$utilisateursFil(i18n)
							}
							]),
						Ef: A3($author$project$Components$Parametrage$Utilisateurs$OngletsDeLAnnuaire$onglets, i18n, 0, model),
						h6: $author$project$I18n$Cles$utilisateursTitre(i18n)
					})
			});
	});
var $author$project$Components$Parametrage$Utilisateurs$Update$ExportDemande = {$: 48};
var $author$project$I18n$Cles$utilisateursConnexionsAExporter = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.connexions.a-exporter',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' ligne à exporter') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' lignes à exporter'));
	});
var $author$project$I18n$Cles$utilisateursConnexionsExportEnCours = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.connexions.export-en-cours', _List_Nil, 'Export en cours…');
};
var $author$project$I18n$Cles$utilisateursConnexionsExporter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.connexions.exporter', _List_Nil, 'Exporter (CSV)');
};
var $author$project$I18n$Cles$utilisateursConnexionsTropVolumineux = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.connexions.trop-volumineux', _List_Nil, 'Plus de 5 000 connexions : réduisez la période pour exporter.');
};
var $author$project$Components$Parametrage$Utilisateurs$ConnexionsView$actions = F2(
	function (i18n, journal) {
		var lignes = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.JE;
				},
				journal.B0));
		var lien = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					return !_Utils_eq(
						$author$project$Components$Parametrage$Utilisateurs$Model$lienDeLExport(journal),
						$elm$core$Maybe$Nothing);
				},
				journal.B0));
		var enCours = _Utils_eq(journal.ms, $author$project$Components$Parametrage$Utilisateurs$Model$ExportEnCours);
		return (!lien) ? _List_Nil : _List_fromArray(
			[
				enCours ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('a-exporter')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$utilisateursConnexionsAExporter,
							i18n,
							{w: lignes}))
					])) : ((_Utils_cmp(lignes, $author$project$Components$Parametrage$Utilisateurs$Model$plafondDExport) > 0) ? A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('raison')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$utilisateursConnexionsTropVolumineux(i18n))
					])) : $rtfeldman$elm_css$Html$Styled$text('')),
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				0,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('exporter'),
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('loading', enCours)
							])),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
						!$author$project$Components$Parametrage$Utilisateurs$Model$exportPossible(journal)),
						$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$Utilisateurs$Update$ExportDemande)
					]),
				enCours ? $author$project$I18n$Cles$utilisateursConnexionsExportEnCours(i18n) : $author$project$I18n$Cles$utilisateursConnexionsExporter(i18n))
			]);
	});
var $author$project$Components$Parametrage$Utilisateurs$ConnexionsView$description = F2(
	function (i18n, espace) {
		if (!espace.$) {
			var nom = espace.a;
			return A2(
				$author$project$I18n$Cles$utilisateursDescription,
				i18n,
				{
					av: $author$project$Texte$Elision$elision(nom),
					yz: nom
				});
		} else {
			return $author$project$I18n$Cles$utilisateursDescriptionSansEspace(i18n);
		}
	});
var $author$project$I18n$Cles$utilisateursConnexionsExporte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.connexions.exporte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fichier',
					$author$project$I18n$Traductions$Chaine(p.gw))
				]),
			'Export terminé : ' + (p.gw + '.'));
	});
var $author$project$I18n$Cles$utilisateursConnexionsExporteLignes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.connexions.exporte.lignes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' ligne.') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' lignes.'));
	});
var $author$project$Components$Parametrage$Utilisateurs$ConnexionsView$exporte = F2(
	function (i18n, journal) {
		var _v0 = journal.ms;
		switch (_v0.$) {
			case 2:
				var fichier = _v0.a;
				var lignes = _v0.b;
				return A2(
					$author$project$Components$Shared$Note$View$view,
					3,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$utilisateursConnexionsExporte,
										i18n,
										{gw: fichier}))
								])),
							$rtfeldman$elm_css$Html$Styled$text(
							' ' + A2(
								$author$project$I18n$Cles$utilisateursConnexionsExporteLignes,
								i18n,
								{w: lignes}))
						]));
			case 3:
				return A2(
					$author$project$Components$Shared$Note$View$view,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$utilisateursConnexionsTropVolumineux(i18n))
						]));
			default:
				return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$Utilisateurs$Update$AuChoisi = function (a) {
	return {$: 42, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Update$DuChoisi = function (a) {
	return {$: 41, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Update$FiltreDeLUtilisateurDuJournalRetire = {$: 44};
var $author$project$Components$Parametrage$Utilisateurs$Update$FiltreDeLaPeriodeRetire = {$: 45};
var $author$project$Components$Parametrage$Utilisateurs$Update$FiltresDuJournalEffaces = {$: 46};
var $author$project$Components$Parametrage$Utilisateurs$Update$RechercheDuJournalSaisie = function (a) {
	return {$: 43, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Update$UtilisateurDuJournalChoisi = function (a) {
	return {$: 40, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Model$filtresDuJournalActifs = function (journal) {
	return !$elm$core$List$isEmpty(
		$author$project$Components$Parametrage$Utilisateurs$Model$filtresDuJournal(journal));
};
var $author$project$Components$Parametrage$Utilisateurs$Model$membres = function (model) {
	return A2(
		$elm$core$List$filter,
		function (u) {
			return A2(
				$elm$core$List$member,
				u.gt,
				_List_fromArray(
					[0, 1]));
		},
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Kf;
				},
				model.aS)));
};
var $author$project$Components$Parametrage$Utilisateurs$ConnexionsView$nomDuMembre = F2(
	function (model, uid) {
		return A2(
			$elm$core$Maybe$withDefault,
			uid,
			$elm$core$List$head(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.Dj;
					},
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.fl;
							},
							$elm$core$Basics$eq(uid)),
						$author$project$Components$Parametrage$Utilisateurs$Model$membres(model)))));
	});
var $author$project$I18n$Cles$utilisateursConnexionsPeriodeDefaut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.connexions.periode.defaut', _List_Nil, 'sur les 30 derniers jours');
};
var $author$project$I18n$Cles$utilisateursConnexionsPeriodeDepuis = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.connexions.periode.depuis',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'du',
					$author$project$I18n$Traductions$Chaine(p.cE))
				]),
			'depuis le ' + p.cE);
	});
var $author$project$I18n$Cles$utilisateursConnexionsPeriodeEntre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.connexions.periode.entre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'du',
					$author$project$I18n$Traductions$Chaine(p.cE)),
					_Utils_Tuple2(
					'au',
					$author$project$I18n$Traductions$Chaine(p.cm))
				]),
			'du ' + (p.cE + (' au ' + p.cm)));
	});
var $author$project$I18n$Cles$utilisateursConnexionsPeriodeJusqua = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.connexions.periode.jusqua',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'au',
					$author$project$I18n$Traductions$Chaine(p.cm))
				]),
			'jusqu\'au ' + p.cm);
	});
var $author$project$Components$Parametrage$Utilisateurs$ConnexionsView$periode = F2(
	function (i18n, journal) {
		var _v0 = _Utils_Tuple2(journal.cE, journal.cm);
		if (_v0.a === '') {
			if (_v0.b === '') {
				return $author$project$I18n$Cles$utilisateursConnexionsPeriodeDefaut(i18n);
			} else {
				var au = _v0.b;
				return A2(
					$author$project$I18n$Cles$utilisateursConnexionsPeriodeJusqua,
					i18n,
					{
						cm: A2($author$project$Texte$Jour$enFrancais, i18n, au)
					});
			}
		} else {
			if (_v0.b === '') {
				var du = _v0.a;
				return A2(
					$author$project$I18n$Cles$utilisateursConnexionsPeriodeDepuis,
					i18n,
					{
						cE: A2($author$project$Texte$Jour$enFrancais, i18n, du)
					});
			} else {
				var du = _v0.a;
				var au = _v0.b;
				return A2(
					$author$project$I18n$Cles$utilisateursConnexionsPeriodeEntre,
					i18n,
					{
						cm: A2($author$project$Texte$Jour$enFrancais, i18n, au),
						cE: A2($author$project$Texte$Jour$enFrancais, i18n, du)
					});
			}
		}
	});
var $author$project$Components$Parametrage$Utilisateurs$Model$rechercheBornee = function (journal) {
	return !$elm$core$String$isEmpty(
		$elm$core$String$trim(journal.hC));
};
var $author$project$Components$Parametrage$Utilisateurs$ConnexionsView$tagDeFiltre = F3(
	function (i18n, libelle, retirer) {
		var nom = A2(
			$author$project$I18n$Cles$utilisateursFiltreRetirer,
			i18n,
			{zH: libelle});
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('filtre-actif')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(libelle),
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('button-icon'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', nom),
							$rtfeldman$elm_css$Html$Styled$Attributes$title(nom),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(retirer)
						]),
					_List_fromArray(
						[$author$project$Components$Shared$Svg$svgClose]))
				]));
	});
var $author$project$I18n$Cles$utilisateursConnexionsConservation = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.connexions.conservation',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'mois',
					$author$project$I18n$Traductions$Chaine(p.CQ))
				]),
			'Conservé ' + (p.CQ + ' mois.'));
	});
var $author$project$I18n$Cles$utilisateursConnexionsFiltreAu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.connexions.filtre.au', _List_Nil, 'Au');
};
var $author$project$I18n$Cles$utilisateursConnexionsFiltreDu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.connexions.filtre.du', _List_Nil, 'Du');
};
var $author$project$I18n$Cles$utilisateursConnexionsFiltreUtilisateur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.connexions.filtre.utilisateur', _List_Nil, 'Utilisateur');
};
var $author$project$I18n$Cles$utilisateursConnexionsNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.connexions.note', _List_Nil, 'Une ligne par session ouverte dans Asria CRM. Les échecs de connexion n\'y figurent pas. L\'adresse IP est une donnée personnelle, visible du seul paramétreur.');
};
var $author$project$I18n$Cles$utilisateursConnexionsRecherche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.connexions.recherche', _List_Nil, 'Rechercher (adresse IP, appareil)');
};
var $author$project$I18n$Cles$utilisateursConnexionsRechercheBornee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.connexions.recherche.bornee', _List_Nil, 'La recherche remonte au plus à 31 jours avant la fin de la période.');
};
var $author$project$I18n$Cles$utilisateursConnexionsTagRecherche = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.connexions.tag.recherche',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			'Recherche : ' + p.fm);
	});
var $author$project$Components$Parametrage$Utilisateurs$ConnexionsView$filtres = F2(
	function (i18n, model) {
		var journal = model.a$;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id('filters')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$utilisateursFiltres(i18n))
						])),
					A2(
					$author$project$Components$Shared$Champ$View$texteAvecIndication,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: 'connexions-recherche',
						Bl: $author$project$I18n$Cles$utilisateursConnexionsRecherche(i18n),
						he: false
					},
					{
						na: $author$project$Components$Parametrage$Utilisateurs$Model$rechercheBornee(journal) ? $elm$core$Maybe$Just(
							$author$project$I18n$Cles$utilisateursConnexionsRechercheBornee(i18n)) : $elm$core$Maybe$Nothing,
						hg: $author$project$Components$Parametrage$Utilisateurs$Update$RechercheDuJournalSaisie,
						fm: journal.hC
					}),
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: 'connexions-filtre-utilisateur',
						Bl: $author$project$I18n$Cles$utilisateursConnexionsFiltreUtilisateur(i18n),
						he: false
					},
					{
						hg: $author$project$Components$Parametrage$Utilisateurs$Update$UtilisateurDuJournalChoisi,
						o_: A2(
							$elm$core$List$cons,
							{
								Bl: $author$project$I18n$Cles$utilisateursFiltreTous(i18n),
								fm: ''
							},
							A2(
								$elm$core$List$map,
								function (u) {
									return {Bl: u.Dj, fm: u.fl};
								},
								$author$project$Components$Parametrage$Utilisateurs$Model$membres(model))),
						fm: A2($elm$core$Maybe$withDefault, '', journal.fl)
					}),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('periode')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Champ$View$date,
							{
								go: $elm$core$Maybe$Nothing,
								Aq: 'connexions-filtre-du',
								Bl: $author$project$I18n$Cles$utilisateursConnexionsFiltreDu(i18n),
								he: false
							},
							{hg: $author$project$Components$Parametrage$Utilisateurs$Update$DuChoisi, fm: journal.cE}),
							A2(
							$author$project$Components$Shared$Champ$View$date,
							{
								go: $elm$core$Maybe$Nothing,
								Aq: 'connexions-filtre-au',
								Bl: $author$project$I18n$Cles$utilisateursConnexionsFiltreAu(i18n),
								he: false
							},
							{hg: $author$project$Components$Parametrage$Utilisateurs$Update$AuChoisi, fm: journal.cm})
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('filtres-actifs'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'hidden',
									!$author$project$Components$Parametrage$Utilisateurs$Model$filtresDuJournalActifs(journal))
								]))
						]),
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$map,
								function (uid) {
									return A3(
										$author$project$Components$Parametrage$Utilisateurs$ConnexionsView$tagDeFiltre,
										i18n,
										A2($author$project$Components$Parametrage$Utilisateurs$ConnexionsView$nomDuMembre, model, uid),
										$author$project$Components$Parametrage$Utilisateurs$Update$FiltreDeLUtilisateurDuJournalRetire);
								},
								journal.fl),
								($elm$core$String$isEmpty(journal.cE) && $elm$core$String$isEmpty(journal.cm)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
								A3(
									$author$project$Components$Parametrage$Utilisateurs$ConnexionsView$tagDeFiltre,
									i18n,
									A2($author$project$Components$Parametrage$Utilisateurs$ConnexionsView$periode, i18n, journal),
									$author$project$Components$Parametrage$Utilisateurs$Update$FiltreDeLaPeriodeRetire)),
								$author$project$Components$Parametrage$Utilisateurs$Model$rechercheBornee(journal) ? $elm$core$Maybe$Just(
								A3(
									$author$project$Components$Parametrage$Utilisateurs$ConnexionsView$tagDeFiltre,
									i18n,
									A2(
										$author$project$I18n$Cles$utilisateursConnexionsTagRecherche,
										i18n,
										{
											fm: $elm$core$String$trim(journal.hC)
										}),
									$author$project$Components$Parametrage$Utilisateurs$Update$RechercheDuJournalSaisie(''))) : $elm$core$Maybe$Nothing,
								$elm$core$Maybe$Just(
								A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									2,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('effacer'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$Utilisateurs$Update$FiltresDuJournalEffaces)
										]),
									$author$project$I18n$Cles$utilisateursFiltresEffacer(i18n)))
							]))),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$elm$core$String$join,
								' ',
								A2(
									$elm$core$List$cons,
									$author$project$I18n$Cles$utilisateursConnexionsNote(i18n),
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											function (lu) {
												return _List_fromArray(
													[
														A2(
														$author$project$I18n$Cles$utilisateursConnexionsConservation,
														i18n,
														{
															CQ: $elm$core$String$fromInt(lu.v6)
														})
													]);
											},
											journal.B0)))))
						]))
				]));
	});
var $author$project$I18n$Cles$utilisateursConnexionsUtilisateurRetire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.connexions.utilisateur-retire', _List_Nil, 'Utilisateur retiré');
};
var $author$project$Components$Parametrage$Utilisateurs$ConnexionsView$nomDeLaConnexion = F3(
	function (i18n, model, connexion) {
		var _v0 = _Utils_Tuple2(connexion.Dj, connexion.HZ);
		if (!_v0.a.$) {
			var nom = _v0.a.a;
			return nom;
		} else {
			if (_v0.b) {
				var _v1 = _v0.a;
				return $author$project$I18n$Cles$utilisateursConnexionsUtilisateurRetire(i18n);
			} else {
				var _v2 = _v0.a;
				return A2($author$project$Components$Parametrage$Utilisateurs$ConnexionsView$nomDuMembre, model, connexion.fl);
			}
		}
	});
var $author$project$I18n$Cles$utilisateursConnexionsRetire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.connexions.retire', _List_Nil, 'Retiré');
};
var $author$project$Components$Parametrage$Utilisateurs$ConnexionsView$ligne = F3(
	function (i18n, model, connexion) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('connexion'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('retire', connexion.HZ)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('le')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Texte$Jour$horodateALHeure, i18n, connexion.Bf))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('utilisateur')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A3($author$project$Components$Parametrage$Utilisateurs$ConnexionsView$nomDeLaConnexion, i18n, model, connexion)),
							connexion.HZ ? A2(
							$author$project$Components$Shared$Tag$View$view,
							3,
							$author$project$I18n$Cles$utilisateursConnexionsRetire(i18n)) : $rtfeldman$elm_css$Html$Styled$text('')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('navigateur')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', connexion.C4))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('adresse')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', connexion.aa))
						]))
				]));
	});
var $author$project$Components$Parametrage$Utilisateurs$ConnexionsView$ligneFantome = A2(
	$rtfeldman$elm_css$Html$Styled$tr,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$class('fantome')
		]),
	A2(
		$elm$core$List$repeat,
		4,
		A2(
			$rtfeldman$elm_css$Html$Styled$td,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('fantome')
						]),
					_List_Nil)
				]))));
var $author$project$Components$Parametrage$Utilisateurs$Update$PageDuJournalChoisie = function (a) {
	return {$: 47, a: a};
};
var $author$project$I18n$Cles$utilisateursConnexionsPagePrecedente = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.connexions.page-precedente', _List_Nil, 'Page précédente');
};
var $author$project$I18n$Cles$utilisateursConnexionsPageSuivante = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.connexions.page-suivante', _List_Nil, 'Page suivante');
};
var $author$project$I18n$Cles$utilisateursConnexionsPagination = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.connexions.pagination',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'debut',
					$author$project$I18n$Traductions$Chaine(p.ku)),
					_Utils_Tuple2(
					'fin',
					$author$project$I18n$Traductions$Chaine(p.mI)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			p.ku + ('–' + (p.mI + (' sur ' + p.JE))));
	});
var $author$project$Components$Parametrage$Utilisateurs$ConnexionsView$pagination = F2(
	function (i18n, lu) {
		var debut = ((lu.EE - 1) * lu.Jm) + 1;
		var fin = (debut + $elm$core$List$length(lu.j8)) - 1;
		return (_Utils_cmp(lu.JE, lu.Jm) < 1) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pagination')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$utilisateursConnexionsPagination,
								i18n,
								{
									ku: $elm$core$String$fromInt(debut),
									mI: $elm$core$String$fromInt(fin),
									JE: $elm$core$String$fromInt(lu.JE)
								}))
						])),
					(lu.EE > 1) ? A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Parametrage$Utilisateurs$Update$PageDuJournalChoisie(lu.EE - 1))
						]),
					$author$project$I18n$Cles$utilisateursConnexionsPagePrecedente(i18n)) : $rtfeldman$elm_css$Html$Styled$text(''),
					(_Utils_cmp(fin, lu.JE) < 0) ? A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Parametrage$Utilisateurs$Update$PageDuJournalChoisie(lu.EE + 1))
						]),
					$author$project$I18n$Cles$utilisateursConnexionsPageSuivante(i18n)) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$I18n$Cles$utilisateursConnexionsColonneAdresse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.connexions.colonne.adresse', _List_Nil, 'Adresse IP');
};
var $author$project$I18n$Cles$utilisateursConnexionsColonneAppareil = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.connexions.colonne.appareil', _List_Nil, 'Appareil et navigateur');
};
var $author$project$I18n$Cles$utilisateursConnexionsColonneDate = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.connexions.colonne.date', _List_Nil, 'Date et heure');
};
var $author$project$I18n$Cles$utilisateursConnexionsColonneUtilisateur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.connexions.colonne.utilisateur', _List_Nil, 'Utilisateur');
};
var $author$project$Components$Parametrage$Utilisateurs$ConnexionsView$tableau = F2(
	function (i18n, lignes) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$table,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$utilisateursConnexionsColonneDate(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$utilisateursConnexionsColonneUtilisateur(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$utilisateursConnexionsColonneAppareil(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$utilisateursConnexionsColonneAdresse(i18n))
												]))
										]))
								])),
							A2($rtfeldman$elm_css$Html$Styled$tbody, _List_Nil, lignes)
						]))
				]));
	});
var $author$project$I18n$Cles$utilisateursConnexionsCompte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.connexions.compte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' connexion') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' connexions'));
	});
var $author$project$I18n$Cles$utilisateursConnexionsVideDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.connexions.vide.de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'periode',
					$author$project$I18n$Traductions$Chaine(p.pi))
				]),
			'Aucune session de ' + (p.Dj + (' ' + (p.pi + '.'))));
	});
var $author$project$I18n$Cles$utilisateursConnexionsVideTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.connexions.vide.titre', _List_Nil, 'Aucune connexion sur cette période');
};
var $author$project$I18n$Cles$utilisateursConnexionsVideTous = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.connexions.vide.tous',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'periode',
					$author$project$I18n$Traductions$Chaine(p.pi))
				]),
			'Aucune session ' + (p.pi + '.'));
	});
var $author$project$Components$Parametrage$Utilisateurs$ConnexionsView$vide = F2(
	function (i18n, model) {
		var laPeriode = A2($author$project$Components$Parametrage$Utilisateurs$ConnexionsView$periode, i18n, model.a$);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('aucun-resultat')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$utilisateursConnexionsVideTitre(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							function () {
								var _v0 = model.a$.fl;
								if (!_v0.$) {
									var uid = _v0.a;
									return A2(
										$author$project$I18n$Cles$utilisateursConnexionsVideDe,
										i18n,
										{
											Dj: A2($author$project$Components$Parametrage$Utilisateurs$ConnexionsView$nomDuMembre, model, uid),
											pi: laPeriode
										});
								} else {
									return A2(
										$author$project$I18n$Cles$utilisateursConnexionsVideTous,
										i18n,
										{pi: laPeriode});
								}
							}())
						])),
					$author$project$Components$Parametrage$Utilisateurs$Model$filtresDuJournalActifs(model.a$) ? A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$Utilisateurs$Update$FiltresDuJournalEffaces)
						]),
					$author$project$I18n$Cles$utilisateursFiltresEffacer(i18n)) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$Components$Parametrage$Utilisateurs$ConnexionsView$liste = F2(
	function (i18n, model) {
		var _v0 = model.a$.B0;
		if (_v0.$ === 1) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('liste'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('loading')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('fantome')
									]),
								_List_Nil)
							])),
						A2(
						$author$project$Components$Parametrage$Utilisateurs$ConnexionsView$tableau,
						i18n,
						A2($elm$core$List$repeat, 6, $author$project$Components$Parametrage$Utilisateurs$ConnexionsView$ligneFantome))
					]));
		} else {
			var lu = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('liste')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$utilisateursConnexionsCompte,
									i18n,
									{w: lu.JE}))
							])),
						$elm$core$List$isEmpty(lu.j8) ? A2($author$project$Components$Parametrage$Utilisateurs$ConnexionsView$vide, i18n, model) : A2(
						$author$project$Components$Parametrage$Utilisateurs$ConnexionsView$tableau,
						i18n,
						A2(
							$elm$core$List$map,
							A2($author$project$Components$Parametrage$Utilisateurs$ConnexionsView$ligne, i18n, model),
							lu.j8)),
						A2($author$project$Components$Parametrage$Utilisateurs$ConnexionsView$pagination, i18n, lu)
					]));
		}
	});
var $author$project$Components$Parametrage$Utilisateurs$ConnexionsView$view = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'parametrage-utilisateurs-connexions',
			{
				ut: model.qa ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Note$View$view,
								1,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$coquilleAccesRefuse(i18n))
											]))
									]))
							]))
					]) : _List_fromArray(
					[
						A2($author$project$Components$Parametrage$Utilisateurs$ConnexionsView$filtres, i18n, model),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						_List_fromArray(
							[
								A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
								A2($author$project$Components$Parametrage$Utilisateurs$ConnexionsView$exporte, i18n, model.a$),
								A2($author$project$Components$Parametrage$Utilisateurs$ConnexionsView$liste, i18n, model)
							]))
					]),
				xy: _List_Nil,
				zM: model.qa ? _List_Nil : A2($author$project$Components$Parametrage$Utilisateurs$ConnexionsView$actions, i18n, model.a$),
				AK: false,
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$Components$Parametrage$Utilisateurs$ConnexionsView$description, i18n, model.g5))
									]))
							]),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adresseTypesDePartiesPrenantes,
								Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
							},
								{
								aa: '',
								Dj: $author$project$I18n$Cles$utilisateursFil(i18n)
							}
							]),
						Ef: A3($author$project$Components$Parametrage$Utilisateurs$OngletsDeLAnnuaire$onglets, i18n, 2, model),
						h6: $author$project$I18n$Cles$utilisateursTitre(i18n)
					})
			});
	});
var $author$project$Components$Parametrage$Utilisateurs$FicheView$etat = F2(
	function (i18n, valeur) {
		switch (valeur) {
			case 0:
				return A2(
					$author$project$Components$Shared$Tag$View$view,
					0,
					$author$project$I18n$Cles$utilisateursEtatActif(i18n));
			case 1:
				return A2(
					$author$project$Components$Shared$Tag$View$view,
					1,
					$author$project$I18n$Cles$utilisateursEtatDesactive(i18n));
			case 2:
				return A2(
					$author$project$Components$Shared$Tag$View$view,
					5,
					$author$project$I18n$Cles$utilisateursEtatEnvoyee(i18n));
			default:
				return A2(
					$author$project$Components$Shared$Tag$View$view,
					1,
					$author$project$I18n$Cles$utilisateursEtatExpiree(i18n));
		}
	});
var $author$project$Components$Parametrage$Utilisateurs$FicheView$jour = F2(
	function (i18n, instant) {
		return A2(
			$author$project$Texte$Jour$enFrancais,
			i18n,
			A2($elm$core$String$left, 10, instant));
	});
var $author$project$I18n$Cles$utilisateursFicheAcces = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.acces', _List_Nil, 'Accès');
};
var $author$project$I18n$Cles$utilisateursFicheAccesAccepteLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.fiche.acces.accepte-le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Accepté le ' + p.wv);
	});
var $author$project$I18n$Cles$utilisateursFicheAccesDerniereConnexion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.acces.derniere-connexion', _List_Nil, 'Dernière connexion');
};
var $author$project$I18n$Cles$utilisateursFicheAccesDesactiveLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.fiche.acces.desactive-le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Désactivé le ' + p.wv);
	});
var $author$project$I18n$Cles$utilisateursFicheAccesDesactivePar = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.fiche.acces.desactive-par',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Désactivé le ' + (p.wv + (' par ' + p.Dj)));
	});
var $author$project$I18n$Cles$utilisateursFicheAccesDoubleAuthentification = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.acces.double-authentification', _List_Nil, 'Double auth.');
};
var $author$project$I18n$Cles$utilisateursFicheAccesEtat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.acces.etat', _List_Nil, 'État');
};
var $author$project$I18n$Cles$utilisateursFicheAccesReactiveLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.fiche.acces.reactive-le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Réactivé le ' + p.wv);
	});
var $author$project$I18n$Cles$utilisateursFicheAccesReactivePar = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.fiche.acces.reactive-par',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Réactivé le ' + (p.wv + (' par ' + p.Dj)));
	});
var $author$project$Components$Parametrage$Utilisateurs$FicheView$acces = F2(
	function (i18n, fiche) {
		var trace = F3(
			function (avecAuteur, sansAuteur, valeur) {
				return A2(
					$elm$core$Maybe$map,
					function (t) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('trace')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									function () {
										var _v1 = t.EK;
										if (!_v1.$) {
											var par = _v1.a;
											return avecAuteur(
												{
													wv: A2($author$project$Texte$Jour$horodateALHeure, i18n, t.Bf),
													Dj: par
												});
										} else {
											return sansAuteur(
												{
													wv: A2($author$project$Texte$Jour$horodateALHeure, i18n, t.Bf)
												});
										}
									}())
								]));
					},
					valeur);
			});
		var ligne = F2(
			function (libelle, valeur) {
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$dt,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(libelle)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$dd,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(valeur)
							]))
					]);
			});
		var datee = F2(
			function (libelle, le) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('trace')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							libelle(
								{
									wv: A2($author$project$Components$Parametrage$Utilisateurs$FicheView$jour, i18n, le)
								}))
						]));
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('acces')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$utilisateursFicheAcces(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$elm$core$Maybe$Just(
								A2(
									$rtfeldman$elm_css$Html$Styled$dl,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$dt,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$utilisateursFicheAccesEtat(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$dd,
											_List_Nil,
											_List_fromArray(
												[
													A2($author$project$Components$Parametrage$Utilisateurs$FicheView$etat, i18n, fiche.gt)
												]))
										]))),
								A3(
								trace,
								$author$project$I18n$Cles$utilisateursFicheAccesReactivePar(i18n),
								$author$project$I18n$Cles$utilisateursFicheAccesReactiveLe(i18n),
								fiche.G_),
								A3(
								trace,
								$author$project$I18n$Cles$utilisateursFicheAccesDesactivePar(i18n),
								$author$project$I18n$Cles$utilisateursFicheAccesDesactiveLe(i18n),
								fiche.xn),
								A2(
								$elm$core$Maybe$map,
								datee(
									$author$project$I18n$Cles$utilisateursInviteLe(i18n)),
								fiche.AW),
								A2(
								$elm$core$Maybe$map,
								datee(
									$author$project$I18n$Cles$utilisateursFicheAccesAccepteLe(i18n)),
								fiche.sL),
								$elm$core$Maybe$Just(
								A2(
									$rtfeldman$elm_css$Html$Styled$dl,
									_List_Nil,
									_Utils_ap(
										A2(
											ligne,
											$author$project$I18n$Cles$utilisateursFicheAccesDerniereConnexion(i18n),
											A2(
												$elm$core$Maybe$withDefault,
												$author$project$I18n$Cles$utilisateursSansValeur(i18n),
												A2(
													$elm$core$Maybe$map,
													$author$project$Texte$Jour$horodateALHeure(i18n),
													fiche.kJ))),
										A2(
											ligne,
											$author$project$I18n$Cles$utilisateursFicheAccesDoubleAuthentification(i18n),
											function () {
												var _v0 = fiche.kV;
												if (!_v0.$) {
													if (_v0.a) {
														return $author$project$I18n$Cles$utilisateursDoubleAuthentificationActivee(i18n);
													} else {
														return $author$project$I18n$Cles$utilisateursDoubleAuthentificationNonActivee(i18n);
													}
												} else {
													return $author$project$I18n$Cles$utilisateursSansValeur(i18n);
												}
											}()))))
							])))
				]));
	});
var $author$project$I18n$Cles$utilisateursDepannageAnnonceLien = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.depannage.annonce.lien',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'email',
					$author$project$I18n$Traductions$Chaine(p.yb)),
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Lien envoyé à ' + (p.yb + ('. Valable jusqu\'au ' + (p.wv + '.'))));
	});
var $author$project$I18n$Cles$utilisateursDepannageAnnonceLienSansEcheance = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.depannage.annonce.lien.sans-echeance',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'email',
					$author$project$I18n$Traductions$Chaine(p.yb))
				]),
			'Lien envoyé à ' + (p.yb + ', valable 24 heures.'));
	});
var $author$project$Components$Parametrage$Utilisateurs$FicheView$annonceDuLien = F3(
	function (i18n, model, fiche) {
		return model.BL ? _List_fromArray(
			[
				function () {
				var _v0 = fiche.q1.BM;
				if (!_v0.$) {
					var echeance = _v0.a;
					return A2(
						$author$project$I18n$Cles$utilisateursDepannageAnnonceLien,
						i18n,
						{
							wv: A2($author$project$Texte$Jour$horodateALHeure, i18n, echeance),
							yb: fiche.kh
						});
				} else {
					return A2(
						$author$project$I18n$Cles$utilisateursDepannageAnnonceLienSansEcheance,
						i18n,
						{yb: fiche.kh});
				}
			}()
			]) : _List_Nil;
	});
var $author$project$I18n$Cles$utilisateursFicheDesactive = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.fiche.desactive',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv)),
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(p.yz))
				]),
			p.Dj + (' est désactivé depuis le ' + (p.wv + ('. Il n\'a plus accès à ' + (p.yz + '. Ses rôles sont gardés.')))));
	});
var $author$project$I18n$Cles$utilisateursFicheDesactiveSansEspace = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.fiche.desactive.sans-espace',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			p.Dj + (' est désactivé depuis le ' + (p.wv + '. Il n\'a plus accès à cet espace. Ses rôles sont gardés.')));
	});
var $author$project$Components$Parametrage$Utilisateurs$FicheView$bandeauDuDesactive = F3(
	function (i18n, espace, fiche) {
		var _v0 = _Utils_Tuple2(fiche.gt, fiche.xn);
		if ((_v0.a === 1) && (!_v0.b.$)) {
			var _v1 = _v0.a;
			var trace = _v0.b.a;
			var date = A2($author$project$Texte$Jour$horodateALHeure, i18n, trace.Bf);
			return A2(
				$author$project$Components$Shared$Note$View$view,
				1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						function () {
							if (!espace.$) {
								var nom = espace.a;
								return A2(
									$author$project$I18n$Cles$utilisateursFicheDesactive,
									i18n,
									{wv: date, yz: nom, Dj: fiche.Dj});
							} else {
								return A2(
									$author$project$I18n$Cles$utilisateursFicheDesactiveSansEspace,
									i18n,
									{wv: date, Dj: fiche.Dj});
							}
						}())
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$Utilisateurs$Update$GesteConfirme = {$: 19};
var $author$project$Components$Parametrage$Utilisateurs$Update$FermetureDesSessionsCochee = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$FicheView$idDeLaCase = 'utilisateur-geste-fermer-les-sessions';
var $author$project$I18n$Cles$utilisateursReinitialisationFermer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.reinitialisation.fermer', _List_Nil, 'Fermer aussi ses sessions ouvertes');
};
var $author$project$I18n$Cles$utilisateursReinitialisationFermerAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.reinitialisation.fermer.aide', _List_Nil, 'Conseillé si le téléphone a été perdu ou volé.');
};
var $author$project$I18n$Cles$utilisateursReinitialisationFermerNombre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.reinitialisation.fermer.nombre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? 'Fermer aussi sa session ouverte' : ('Fermer aussi ses ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' sessions ouvertes')));
	});
var $author$project$Components$Parametrage$Utilisateurs$FicheView$caseDesSessions = F2(
	function (i18n, model) {
		var ouvertes = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$length,
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.q1;
						},
						function ($) {
							return $.IK;
						}),
					model.zo)));
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('case')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Parametrage$Utilisateurs$FicheView$idDeLaCase),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(model.zl),
							$rtfeldman$elm_css$Html$Styled$Events$onCheck($author$project$Components$Parametrage$Utilisateurs$Update$FermetureDesSessionsCochee)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									(ouvertes > 0) ? A2(
										$author$project$I18n$Cles$utilisateursReinitialisationFermerNombre,
										i18n,
										{w: ouvertes}) : $author$project$I18n$Cles$utilisateursReinitialisationFermer(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$utilisateursReinitialisationFermerAide(i18n))
								]))
						]))
				]));
	});
var $author$project$Components$Parametrage$Utilisateurs$Update$clavierDuGeste = $author$project$Components$Parametrage$Utilisateurs$Update$tabulation($author$project$Components$Parametrage$Utilisateurs$Model$idsDuGeste);
var $author$project$I18n$Cles$utilisateursDepannageTrace = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.depannage.trace',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'L\'action est tracée : vous, maintenant, pour ' + (p.Dj + '.'));
	});
var $author$project$I18n$Cles$utilisateursDesactivationConfirmer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.desactivation.confirmer', _List_Nil, 'Désactiver');
};
var $author$project$I18n$Cles$utilisateursDesactivationMessage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.desactivation.message',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(p.yz))
				]),
			'Il perd l\'accès à ' + (p.yz + ' immédiatement ; ses autres espaces, s\'il en a, ne changent pas. Ses rôles sont gardés : vous pourrez le réactiver.'));
	});
var $author$project$I18n$Cles$utilisateursDesactivationMessageSansEspace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.desactivation.message.sans-espace', _List_Nil, 'Il perd l\'accès à cet espace immédiatement ; ses autres espaces, s\'il en a, ne changent pas. Ses rôles sont gardés : vous pourrez le réactiver.');
};
var $author$project$I18n$Cles$utilisateursDesactivationTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.desactivation.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Désactiver ' + (p.Dj + ' ?'));
	});
var $author$project$I18n$Cles$utilisateursGesteGarder = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.geste.garder', _List_Nil, 'Annuler');
};
var $author$project$I18n$Cles$utilisateursLienConfirmer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.lien.confirmer', _List_Nil, 'Envoyer le lien');
};
var $author$project$I18n$Cles$utilisateursLienMessage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.lien.message',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'email',
					$author$project$I18n$Traductions$Chaine(p.yb))
				]),
			p.Dj + (' recevra à ' + (p.yb + ' un email d\'Asria avec un lien valable 24 heures, pour choisir son nouveau mot de passe : vous ne le verrez pas.')));
	});
var $author$project$I18n$Cles$utilisateursLienTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.lien.titre', _List_Nil, 'Envoyer un lien de réinitialisation du mot de passe ?');
};
var $author$project$I18n$Cles$utilisateursReinitialisationConfirmer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.reinitialisation.confirmer', _List_Nil, 'Réinitialiser');
};
var $author$project$I18n$Cles$utilisateursReinitialisationMessage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.reinitialisation.message',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Ses moyens de double authentification sont retirés. À sa prochaine connexion, ' + (p.Dj + ' enregistrera un nouveau moyen avant d\'entrer, dans toute la suite Asria.'));
	});
var $author$project$I18n$Cles$utilisateursReinitialisationMessageApplication = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.reinitialisation.message.application',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Son application d\'authentification est retirée. À sa prochaine connexion, ' + (p.Dj + ' enregistrera un nouveau moyen avant d\'entrer, dans toute la suite Asria.'));
	});
var $author$project$I18n$Cles$utilisateursReinitialisationTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.reinitialisation.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Réinitialiser la double authentification de ' + (p.Dj + ' ?'));
	});
var $author$project$I18n$Cles$utilisateursRetraitConfirmer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.retrait.confirmer', _List_Nil, 'Retirer');
};
var $author$project$I18n$Cles$utilisateursRetraitMessage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.retrait.message', _List_Nil, 'Il perdra son accès et disparaîtra de l\'annuaire. Son nom restera affiché comme auteur dans l\'historique des fiches. Pour revenir, il devra être invité de nouveau.');
};
var $author$project$I18n$Cles$utilisateursRetraitTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.retrait.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.yz)))
				]),
			'Retirer ' + (p.Dj + (' ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.yz);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.yz);
					default:
						return 'de ' + $elm$core$String$trim(p.yz);
				}
			}() + ' ?'))));
	});
var $author$project$I18n$Cles$utilisateursRetraitTitreSansEspace = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.retrait.titre.sans-espace',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer ' + (p.Dj + ' de l\'espace ?'));
	});
var $author$project$I18n$Cles$utilisateursSessionsConfirmer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.sessions.confirmer', _List_Nil, 'Fermer les sessions');
};
var $author$project$I18n$Cles$utilisateursSessionsMessage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.sessions.message',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Les sessions de ' + (p.Dj + ' sont fermées dans toute la suite Asria, Asria Cockpit compris : une nouvelle connexion sera demandée. Une page déjà ouverte peut rester utilisable quelques minutes, le temps que son accès expire.'));
	});
var $author$project$I18n$Cles$utilisateursSessionsTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.sessions.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Fermer toutes les sessions de ' + (p.Dj + ' ?'));
	});
var $author$project$Components$Shared$Confirmation$View$viewAvecContenu = F3(
	function (_v0, contenu, boite) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			$author$project$Components$Shared$Confirmation$View$racine(boite),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id(boite.At)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(boite.h6)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id(boite.As),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('message'),
							$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(0)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(boite.Cs)
								])),
						contenu)),
					$author$project$Components$Shared$Confirmation$View$actions(boite)
				]));
	});
var $author$project$Components$Parametrage$Utilisateurs$FicheView$confirmation = F2(
	function (i18n, model) {
		var nom = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Dj;
				},
				model.zo));
		var trace = A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2(
						$author$project$I18n$Cles$utilisateursDepannageTrace,
						i18n,
						{Dj: nom}))
				]));
		var ids = $author$project$Components$Parametrage$Utilisateurs$Model$idsDuGeste;
		var boite = F4(
			function (variante, titre, message, confirmer) {
				return {
					vl: $author$project$Components$Parametrage$Utilisateurs$Update$clavierDuGeste,
					j7: {Aq: ids.j7, Bl: confirmer, C$: $author$project$Components$Parametrage$Utilisateurs$Update$GesteConfirme},
					Aq: ids.GN,
					As: ids.Cs,
					At: ids.h6,
					Cs: message,
					Et: !_Utils_eq(model.iu, $elm$core$Maybe$Nothing),
					HG: {
						Aq: ids.z7,
						Bl: $author$project$I18n$Cles$utilisateursGesteGarder(i18n),
						C$: $author$project$Components$Parametrage$Utilisateurs$Update$GesteRenonce
					},
					h6: titre,
					sl: variante
				};
			});
		var rendue = function () {
			var _v0 = _Utils_Tuple2(model.iu, model.g5);
			_v0$5:
			while (true) {
				_v0$6:
				while (true) {
					if (!_v0.a.$) {
						switch (_v0.a.a) {
							case 4:
								var _v1 = _v0.a.a;
								return A3(
									$author$project$Components$Shared$Confirmation$View$viewAvecContenu,
									i18n,
									_List_fromArray(
										[
											A2($author$project$Components$Parametrage$Utilisateurs$FicheView$caseDesSessions, i18n, model),
											trace
										]),
									A4(
										boite,
										3,
										A2(
											$author$project$I18n$Cles$utilisateursReinitialisationTitre,
											i18n,
											{Dj: nom}),
										_Utils_eq(
											A2(
												$elm$core$Maybe$andThen,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.q1;
													},
													function ($) {
														return $.CZ;
													}),
												model.zo),
											$elm$core$Maybe$Just(0)) ? A2(
											$author$project$I18n$Cles$utilisateursReinitialisationMessageApplication,
											i18n,
											{Dj: nom}) : A2(
											$author$project$I18n$Cles$utilisateursReinitialisationMessage,
											i18n,
											{Dj: nom}),
										$author$project$I18n$Cles$utilisateursReinitialisationConfirmer(i18n)));
							case 5:
								var _v2 = _v0.a.a;
								return A3(
									$author$project$Components$Shared$Confirmation$View$viewAvecContenu,
									i18n,
									_List_fromArray(
										[trace]),
									A4(
										boite,
										3,
										$author$project$I18n$Cles$utilisateursLienTitre(i18n),
										A2(
											$author$project$I18n$Cles$utilisateursLienMessage,
											i18n,
											{
												yb: A2(
													$elm$core$Maybe$withDefault,
													'',
													A2(
														$elm$core$Maybe$map,
														function ($) {
															return $.kh;
														},
														model.zo)),
												Dj: nom
											}),
										$author$project$I18n$Cles$utilisateursLienConfirmer(i18n)));
							case 6:
								var _v3 = _v0.a.a;
								return A3(
									$author$project$Components$Shared$Confirmation$View$viewAvecContenu,
									i18n,
									_List_fromArray(
										[trace]),
									A4(
										boite,
										3,
										A2(
											$author$project$I18n$Cles$utilisateursSessionsTitre,
											i18n,
											{Dj: nom}),
										A2(
											$author$project$I18n$Cles$utilisateursSessionsMessage,
											i18n,
											{Dj: nom}),
										$author$project$I18n$Cles$utilisateursSessionsConfirmer(i18n)));
							case 1:
								if (!_v0.b.$) {
									var _v4 = _v0.a.a;
									var espace = _v0.b.a;
									return A2(
										$author$project$Components$Shared$Confirmation$View$view,
										i18n,
										A4(
											boite,
											0,
											A2(
												$author$project$I18n$Cles$utilisateursRetraitTitre,
												i18n,
												{
													av: $author$project$Texte$Elision$elision(espace),
													yz: espace,
													Dj: nom
												}),
											$author$project$I18n$Cles$utilisateursRetraitMessage(i18n),
											$author$project$I18n$Cles$utilisateursRetraitConfirmer(i18n)));
								} else {
									var _v5 = _v0.a.a;
									var _v6 = _v0.b;
									return A2(
										$author$project$Components$Shared$Confirmation$View$view,
										i18n,
										A4(
											boite,
											0,
											A2(
												$author$project$I18n$Cles$utilisateursRetraitTitreSansEspace,
												i18n,
												{Dj: nom}),
											$author$project$I18n$Cles$utilisateursRetraitMessage(i18n),
											$author$project$I18n$Cles$utilisateursRetraitConfirmer(i18n)));
								}
							default:
								if (!_v0.b.$) {
									break _v0$5;
								} else {
									break _v0$6;
								}
						}
					} else {
						if (!_v0.b.$) {
							break _v0$5;
						} else {
							break _v0$6;
						}
					}
				}
				var _v7 = _v0.b;
				return A2(
					$author$project$Components$Shared$Confirmation$View$view,
					i18n,
					A4(
						boite,
						0,
						A2(
							$author$project$I18n$Cles$utilisateursDesactivationTitre,
							i18n,
							{Dj: nom}),
						$author$project$I18n$Cles$utilisateursDesactivationMessageSansEspace(i18n),
						$author$project$I18n$Cles$utilisateursDesactivationConfirmer(i18n)));
			}
			var espace = _v0.b.a;
			return A2(
				$author$project$Components$Shared$Confirmation$View$view,
				i18n,
				A4(
					boite,
					0,
					A2(
						$author$project$I18n$Cles$utilisateursDesactivationTitre,
						i18n,
						{Dj: nom}),
					A2(
						$author$project$I18n$Cles$utilisateursDesactivationMessage,
						i18n,
						{yz: espace}),
					$author$project$I18n$Cles$utilisateursDesactivationConfirmer(i18n)));
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'opened',
							!_Utils_eq(model.iu, $elm$core$Maybe$Nothing))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('overlay'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$Utilisateurs$Update$GesteRenonce)
						]),
					_List_Nil),
					rendue
				]));
	});
var $author$project$I18n$Cles$utilisateursFicheConnexions = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.connexions', _List_Nil, 'Dernières connexions');
};
var $author$project$I18n$Cles$utilisateursFicheConnexionsAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.connexions.aucune', _List_Nil, 'Aucune connexion sur les 30 derniers jours.');
};
var $author$project$I18n$Cles$utilisateursFicheConnexionsJournal = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.connexions.journal', _List_Nil, 'Voir le journal des connexions');
};
var $author$project$Components$Parametrage$Utilisateurs$FicheView$dernieresConnexions = F3(
	function (i18n, model, fiche) {
		var _v0 = model.xm;
		if (!_v0.$) {
			var lues = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$section,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('dernieres-connexions')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$h3,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$utilisateursFicheConnexions(i18n))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
							]),
						_List_fromArray(
							[
								$elm$core$List$isEmpty(lues.j8) ? A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('aucune')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$utilisateursFicheConnexionsAucune(i18n))
									])) : A2(
								$rtfeldman$elm_css$Html$Styled$table,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$utilisateursConnexionsColonneDate(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$utilisateursConnexionsColonneAppareil(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$utilisateursConnexionsColonneAdresse(i18n))
															]))
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$tbody,
										_List_Nil,
										A2(
											$elm$core$List$map,
											function (connexion) {
												return A2(
													$rtfeldman$elm_css$Html$Styled$tr,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$td,
															_List_Nil,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	A2($author$project$Texte$Jour$horodateALHeure, i18n, connexion.Bf))
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$td,
															_List_Nil,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	A2($elm$core$Maybe$withDefault, '', connexion.C4))
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$td,
															_List_Nil,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	A2($elm$core$Maybe$withDefault, '', connexion.aa))
																]))
														]));
											},
											lues.j8))
									])),
								function () {
								var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$journalDesConnexions, fiche.nQ);
								if (!_v1.$) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('journal'),
												$rtfeldman$elm_css$Html$Styled$Attributes$href(
												$author$project$Routes$Route$adresseDuJournalDesConnexions(
													$elm$core$Maybe$Just(fiche.fl)))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$utilisateursFicheConnexionsJournal(i18n))
											]));
								} else {
									return $rtfeldman$elm_css$Html$Styled$text('');
								}
							}()
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$Utilisateurs$Update$LiaisonValidee = {$: 26};
var $author$project$Components$Parametrage$Utilisateurs$Update$RechercheSaisie = function (a) {
	return {$: 24, a: a};
};
var $author$project$I18n$Cles$utilisateursRefusDepannageImpossible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.refus.depannage-impossible', _List_Nil, 'Ce dépannage n\'est pas possible pour ce compte : un compte désactivé, une invitation en attente ou votre propre compte ne se dépannent pas ici. Rien n\'a été modifié.');
};
var $author$project$I18n$Cles$utilisateursRefusDernierAdministrateur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.refus.dernier-administrateur', _List_Nil, 'C\'est le seul compte administrateur actif de l\'espace : nommez-en un autre d\'abord. Rien n\'a été modifié.');
};
var $author$project$I18n$Cles$utilisateursRefusFicheDejaLiee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.refus.fiche-deja-liee', _List_Nil, 'Cette fiche collaborateur est déjà liée à un autre compte. Rien n\'a été modifié.');
};
var $author$project$I18n$Cles$utilisateursRefusFicheIntrouvable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.refus.fiche-introuvable', _List_Nil, 'Cette fiche collaborateur n\'existe pas dans l\'espace. Rien n\'a été modifié.');
};
var $author$project$I18n$Cles$utilisateursRefusTropDeLiens = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.refus.trop-de-liens', _List_Nil, 'Trop de liens et d\'invitations ont été envoyés dans l\'heure pour cet espace. Aucun lien n\'est parti : réessayez plus tard.');
};
var $author$project$I18n$Cles$utilisateursRefusUtilisateurIntrouvable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.refus.utilisateur-introuvable', _List_Nil, 'Cet utilisateur ne fait plus partie de l\'espace. Rien n\'a été modifié.');
};
var $author$project$Components$Parametrage$Utilisateurs$FicheView$noteDuRefus = F2(
	function (i18n, erreur) {
		if (!erreur.$) {
			switch (erreur.a) {
				case 6:
					var _v1 = erreur.a;
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$utilisateursRefusDernierAdministrateur(i18n))
							]));
				case 7:
					var _v2 = erreur.a;
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$utilisateursRefusUtilisateurIntrouvable(i18n))
							]));
				case 8:
					var _v3 = erreur.a;
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$utilisateursRefusFicheIntrouvable(i18n))
							]));
				case 9:
					var _v4 = erreur.a;
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$utilisateursRefusFicheDejaLiee(i18n))
							]));
				case 2:
					var _v5 = erreur.a;
					return A2(
						$author$project$Components$Shared$Note$View$view,
						2,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$utilisateursInviterIndisponibleTitre(i18n))
							]));
				case 3:
					var _v6 = erreur.a;
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$utilisateursRefusCompteActif(i18n))
							]));
				case 4:
					var _v7 = erreur.a;
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$utilisateursRefusTropDInvitations(i18n))
							]));
				case 5:
					var _v8 = erreur.a;
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$utilisateursRefusEnvoiEnCours(i18n))
							]));
				case 10:
					var _v9 = erreur.a;
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$utilisateursRefusDepannageImpossible(i18n))
							]));
				case 11:
					var _v10 = erreur.a;
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$utilisateursRefusTropDeLiens(i18n))
							]));
				default:
					return A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$utilisateursRefusAutre(i18n))
							]));
			}
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Parametrage$Utilisateurs$Update$FicheChoisie = function (a) {
	return {$: 25, a: a};
};
var $author$project$I18n$Cles$utilisateursLierDejaLiee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.lier.deja-liee', _List_Nil, 'déjà lié à un compte');
};
var $author$project$I18n$Cles$utilisateursLierMemeNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.lier.meme-nom', _List_Nil, 'même nom');
};
var $author$project$Components$Parametrage$Utilisateurs$FicheView$proposee = F3(
	function (i18n, model, fiche) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('fiche'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'choisie',
									_Utils_eq(
										model.ve,
										$elm$core$Maybe$Just(fiche.zo))),
									_Utils_Tuple2('deja-liee', fiche.w0)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-pressed',
							_Utils_eq(
								model.ve,
								$elm$core$Maybe$Just(fiche.zo)) ? 'true' : 'false'),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(fiche.w0),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Parametrage$Utilisateurs$Update$FicheChoisie(fiche.zo))
						]),
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$elm$core$Maybe$Just(
								A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('avatar'),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Texte$Initiales$initiales(fiche.Dj))
										]))),
								$elm$core$Maybe$Just(
								A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(fiche.Dj)
										]))),
								fiche.Cp ? $elm$core$Maybe$Just(
								A2(
									$author$project$Components$Shared$Tag$View$view,
									5,
									$author$project$I18n$Cles$utilisateursLierMemeNom(i18n))) : $elm$core$Maybe$Nothing,
								fiche.w0 ? $elm$core$Maybe$Just(
								A2(
									$author$project$Components$Shared$Tag$View$view,
									3,
									$author$project$I18n$Cles$utilisateursLierDejaLiee(i18n))) : $elm$core$Maybe$Nothing
							])))
				]));
	});
var $author$project$I18n$Cles$utilisateursLierAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.lier.action', _List_Nil, 'Lier');
};
var $author$project$I18n$Cles$utilisateursLierAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.lier.aucune', _List_Nil, 'Aucune fiche collaborateur ne correspond à cette recherche.');
};
var $author$project$I18n$Cles$utilisateursLierCompte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.lier.compte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiche collaborateur · une fiche ne se lie qu\'à un seul compte.') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiches collaborateur · une fiche ne se lie qu\'à un seul compte.'));
	});
var $author$project$I18n$Cles$utilisateursLierRecherche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.lier.recherche', _List_Nil, 'Rechercher une fiche collaborateur');
};
var $author$project$I18n$Cles$utilisateursLierTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.lier.titre', _List_Nil, 'Lier une fiche collaborateur');
};
var $author$project$Components$Parametrage$Utilisateurs$FicheView$drawerDeLiaison = F2(
	function (i18n, model) {
		var fiches = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.zu;
				},
				model.pE));
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Parametrage$Utilisateurs$Update$DuDrawerDeLiaison,
			{
				fs: {
					sR: (!_Utils_eq(model.ve, $elm$core$Maybe$Nothing)) && (!$author$project$API$Envoi$enCours(model.l2)),
					Bl: $author$project$I18n$Cles$utilisateursLierAction(i18n),
					C$: $author$project$Components$Parametrage$Utilisateurs$Update$LiaisonValidee
				},
				fZ: _List_fromArray(
					[
						A2($author$project$Components$Parametrage$Utilisateurs$FicheView$noteDuRefus, i18n, model.pZ),
						A2(
						$author$project$Components$Shared$Champ$View$texte,
						{
							go: $elm$core$Maybe$Nothing,
							Aq: 'utilisateur-lier-recherche',
							Bl: $author$project$I18n$Cles$utilisateursLierRecherche(i18n),
							he: false
						},
						{hg: $author$project$Components$Parametrage$Utilisateurs$Update$RechercheSaisie, fm: model.hC}),
						((!_Utils_eq(model.pE, $elm$core$Maybe$Nothing)) && $elm$core$List$isEmpty(fiches)) ? A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aucune')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$utilisateursLierAucune(i18n))
							])) : A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('fiches')
							]),
						A2(
							$elm$core$List$map,
							A2($author$project$Components$Parametrage$Utilisateurs$FicheView$proposee, i18n, model),
							fiches)),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$utilisateursLierCompte,
									i18n,
									{
										w: $elm$core$List$length(fiches)
									}))
							]))
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$utilisateursLierTitre(i18n)
			},
			model.xO);
	});
var $author$project$Components$Parametrage$Utilisateurs$Update$DeliaisonDemandee = {$: 27};
var $author$project$Components$Parametrage$Utilisateurs$Update$LiaisonDemandee = {$: 22};
var $author$project$I18n$Cles$utilisateursFicheLien = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.lien', _List_Nil, 'Fiche collaborateur liée');
};
var $author$project$I18n$Cles$utilisateursFicheLienAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.lien.aucun', _List_Nil, 'Aucune fiche collaborateur liée.');
};
var $author$project$I18n$Cles$utilisateursFicheLienChanger = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.lien.changer', _List_Nil, 'Changer de fiche');
};
var $author$project$I18n$Cles$utilisateursFicheLienLier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.lien.lier', _List_Nil, 'Lier une fiche');
};
var $author$project$I18n$Cles$utilisateursFicheLienNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.lien.note', _List_Nil, 'Facultatif. Relie le compte à la fiche du collaborateur dans les parties prenantes.');
};
var $author$project$I18n$Cles$utilisateursFicheLienRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.lien.retirer', _List_Nil, 'Retirer le lien');
};
var $author$project$Components$Parametrage$Utilisateurs$FicheView$ficheLiee = F2(
	function (i18n, fiche) {
		var lier = !_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$lierUneFicheCollaborateur, fiche.nQ),
			$elm$core$Maybe$Nothing);
		var geste = F4(
			function (present, classe, msg, libelle) {
				return present ? $elm$core$Maybe$Just(
					A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						2,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class(classe),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
							]),
						libelle)) : $elm$core$Maybe$Nothing;
			});
		var delier = !_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$delierLaFicheCollaborateur, fiche.nQ),
			$elm$core$Maybe$Nothing);
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('fiche-collaborateur')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$utilisateursFicheLien(i18n))
								])),
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									A4(
									geste,
									lier && _Utils_eq(fiche.zq, $elm$core$Maybe$Nothing),
									'lier',
									$author$project$Components$Parametrage$Utilisateurs$Update$LiaisonDemandee,
									$author$project$I18n$Cles$utilisateursFicheLienLier(i18n))
								])))),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					_List_fromArray(
						[
							function () {
							var _v0 = fiche.zq;
							if (!_v0.$) {
								var liee = _v0.a;
								return A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('liee')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('avatar'),
													A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$Texte$Initiales$initiales(liee.Dj))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(liee.Dj)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
												]),
											A2(
												$elm$core$List$filterMap,
												$elm$core$Basics$identity,
												_List_fromArray(
													[
														A4(
														geste,
														lier,
														'changer',
														$author$project$Components$Parametrage$Utilisateurs$Update$LiaisonDemandee,
														$author$project$I18n$Cles$utilisateursFicheLienChanger(i18n)),
														A4(
														geste,
														delier,
														'delier',
														$author$project$Components$Parametrage$Utilisateurs$Update$DeliaisonDemandee,
														$author$project$I18n$Cles$utilisateursFicheLienRetirer(i18n))
													])))
										]));
							} else {
								return A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('aucune')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$utilisateursFicheLienAucun(i18n))
										]));
							}
						}(),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$utilisateursFicheLienNote(i18n))
								]))
						]))
				]));
	});
var $author$project$Components$Parametrage$Utilisateurs$Model$Desactivation = 0;
var $author$project$Components$Parametrage$Utilisateurs$Update$GesteDemande = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Parametrage$Utilisateurs$Update$ReactivationDemandee = {$: 21};
var $author$project$Components$Parametrage$Utilisateurs$Model$Retrait = 1;
var $author$project$Components$Parametrage$Utilisateurs$Model$cibleDeLaFiche = function (fiche) {
	return {kh: fiche.kh, nQ: fiche.nQ, Dj: fiche.Dj, fl: fiche.fl};
};
var $author$project$I18n$Cles$utilisateursFicheDernierAdministrateur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.fiche.dernier-administrateur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.yz)))
				]),
			'Seul compte administrateur actif ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.yz);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.yz);
					default:
						return 'de ' + $elm$core$String$trim(p.yz);
				}
			}() + ' : nommez un autre administrateur pour le désactiver ou le retirer.'));
	});
var $author$project$I18n$Cles$utilisateursFicheDernierAdministrateurSansEspace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.dernier-administrateur.sans-espace', _List_Nil, 'Seul compte administrateur actif de l\'espace : nommez un autre administrateur pour le désactiver ou le retirer.');
};
var $author$project$I18n$Cles$utilisateursFicheDernierAdministrateurVous = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.fiche.dernier-administrateur.vous',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.yz)))
				]),
			'Seul compte administrateur actif ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.yz);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.yz);
					default:
						return 'de ' + $elm$core$String$trim(p.yz);
				}
			}() + ' : nommez un autre administrateur pour vous désactiver ou vous retirer.'));
	});
var $author$project$I18n$Cles$utilisateursFicheDernierAdministrateurVousSansEspace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.dernier-administrateur.vous.sans-espace', _List_Nil, 'Seul compte administrateur actif de l\'espace : nommez un autre administrateur pour vous désactiver ou vous retirer.');
};
var $author$project$Components$Parametrage$Utilisateurs$FicheView$raisonDuDernierAdministrateur = F3(
	function (i18n, espace, vous) {
		var _v0 = _Utils_Tuple2(espace, vous);
		if (!_v0.a.$) {
			if (_v0.b) {
				var nom = _v0.a.a;
				return A2(
					$author$project$I18n$Cles$utilisateursFicheDernierAdministrateurVous,
					i18n,
					{
						av: $author$project$Texte$Elision$elision(nom),
						yz: nom
					});
			} else {
				var nom = _v0.a.a;
				return A2(
					$author$project$I18n$Cles$utilisateursFicheDernierAdministrateur,
					i18n,
					{
						av: $author$project$Texte$Elision$elision(nom),
						yz: nom
					});
			}
		} else {
			if (_v0.b) {
				var _v1 = _v0.a;
				return $author$project$I18n$Cles$utilisateursFicheDernierAdministrateurVousSansEspace(i18n);
			} else {
				var _v2 = _v0.a;
				return $author$project$I18n$Cles$utilisateursFicheDernierAdministrateurSansEspace(i18n);
			}
		}
	});
var $author$project$Components$Parametrage$Utilisateurs$Model$raisonDuDernierAdministrateur = function (fiche) {
	return fiche.xh && (!_Utils_eq(
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$lierUneFicheCollaborateur, fiche.nQ),
		$elm$core$Maybe$Nothing));
};
var $author$project$I18n$Cles$utilisateursFicheAnnulerLInvitation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.annuler-l-invitation', _List_Nil, 'Annuler l\'invitation…');
};
var $author$project$I18n$Cles$utilisateursFicheDesactiver = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.desactiver', _List_Nil, 'Désactiver…');
};
var $author$project$I18n$Cles$utilisateursFicheReactiver = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.reactiver', _List_Nil, 'Réactiver');
};
var $author$project$I18n$Cles$utilisateursFicheRenvoyerLInvitation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.renvoyer-l-invitation', _List_Nil, 'Renvoyer l\'invitation');
};
var $author$project$I18n$Cles$utilisateursFicheRetirer = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.fiche.retirer',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.yz)))
				]),
			'Retirer ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.yz);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.yz);
					default:
						return 'de ' + $elm$core$String$trim(p.yz);
				}
			}() + '…'));
	});
var $author$project$I18n$Cles$utilisateursFicheRetirerSansEspace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.retirer.sans-espace', _List_Nil, 'Retirer de l\'espace…');
};
var $author$project$Components$Parametrage$Utilisateurs$FicheView$gestes = F3(
	function (i18n, espace, fiche) {
		var retirer = function () {
			if (!espace.$) {
				var nom = espace.a;
				return A2(
					$author$project$I18n$Cles$utilisateursFicheRetirer,
					i18n,
					{
						av: $author$project$Texte$Elision$elision(nom),
						yz: nom
					});
			} else {
				return $author$project$I18n$Cles$utilisateursFicheRetirerSansEspace(i18n);
			}
		}();
		var present = function (rel) {
			return !_Utils_eq(
				A2($author$project$API$Liens$trouver, rel, fiche.nQ),
				$elm$core$Maybe$Nothing);
		};
		var cible = $author$project$Components$Parametrage$Utilisateurs$Model$cibleDeLaFiche(fiche);
		return $author$project$Components$Parametrage$Utilisateurs$Model$raisonDuDernierAdministrateur(fiche) ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('raison')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A3($author$project$Components$Parametrage$Utilisateurs$FicheView$raisonDuDernierAdministrateur, i18n, espace, fiche.KX))
					])),
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				3,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer'),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
					]),
				retirer),
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('desactiver'),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
					]),
				$author$project$I18n$Cles$utilisateursFicheDesactiver(i18n))
			]) : A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					present($author$project$API$NavLinksDictionary$annulerUneInvitation) ? $elm$core$Maybe$Just(
					A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						3,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('annuler'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Parametrage$Utilisateurs$Update$AnnulationDemandee(cible))
							]),
						$author$project$I18n$Cles$utilisateursFicheAnnulerLInvitation(i18n))) : $elm$core$Maybe$Nothing,
					present($author$project$API$NavLinksDictionary$renvoyerUneInvitation) ? $elm$core$Maybe$Just(
					A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						0,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('renvoyer'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Parametrage$Utilisateurs$Update$RenvoiDemande(cible))
							]),
						$author$project$I18n$Cles$utilisateursFicheRenvoyerLInvitation(i18n))) : $elm$core$Maybe$Nothing,
					present($author$project$API$NavLinksDictionary$retirerUnUtilisateur) ? $elm$core$Maybe$Just(
					A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						3,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Parametrage$Utilisateurs$Update$GesteDemande(1))
							]),
						retirer)) : $elm$core$Maybe$Nothing,
					present($author$project$API$NavLinksDictionary$desactiverUnUtilisateur) ? $elm$core$Maybe$Just(
					A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('desactiver'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Parametrage$Utilisateurs$Update$GesteDemande(0))
							]),
						$author$project$I18n$Cles$utilisateursFicheDesactiver(i18n))) : $elm$core$Maybe$Nothing,
					present($author$project$API$NavLinksDictionary$reactiverUnUtilisateur) ? $elm$core$Maybe$Just(
					A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						0,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('reactiver'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$Utilisateurs$Update$ReactivationDemandee)
							]),
						$author$project$I18n$Cles$utilisateursFicheReactiver(i18n))) : $elm$core$Maybe$Nothing
				]));
	});
var $author$project$I18n$Cles$utilisateursFicheEmail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.email', _List_Nil, 'Email');
};
var $author$project$I18n$Cles$utilisateursFicheIdentite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.identite', _List_Nil, 'Identité');
};
var $author$project$I18n$Cles$utilisateursFicheIdentiteNote = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.fiche.identite.note',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Nom, photo, fonction et téléphone sont tenus par ' + (p.Dj + ' dans « Mon compte ».'));
	});
var $author$project$Components$Parametrage$Utilisateurs$FicheView$identite = F2(
	function (i18n, fiche) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('identite')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$utilisateursFicheIdentite(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$dl,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$dt,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$utilisateursFicheEmail(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$dd,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(fiche.kh)
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$utilisateursFicheIdentiteNote,
										i18n,
										{Dj: fiche.Dj}))
								]))
						]))
				]));
	});
var $author$project$Components$Parametrage$Utilisateurs$FicheView$refus = F2(
	function (i18n, model) {
		return $author$project$Components$Parametrage$Utilisateurs$Update$dialogueOuvert(model) ? $rtfeldman$elm_css$Html$Styled$text('') : A2($author$project$Components$Parametrage$Utilisateurs$FicheView$noteDuRefus, i18n, model.pZ);
	});
var $author$project$API$NavLinksDictionary$rolesEtDroits = 'roles-et-droits';
var $author$project$I18n$Cles$utilisateursFicheRoles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.roles', _List_Nil, 'Rôles');
};
var $author$project$I18n$Cles$utilisateursFicheRolesAttribuePar = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.fiche.roles.attribue-par',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.wv + (' par ' + p.Dj));
	});
var $author$project$I18n$Cles$utilisateursFicheRolesColonneAttribue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.roles.colonne.attribue', _List_Nil, 'Attribué');
};
var $author$project$I18n$Cles$utilisateursFicheRolesColonneRole = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.roles.colonne.role', _List_Nil, 'Rôle');
};
var $author$project$I18n$Cles$utilisateursFicheRolesGerer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.roles.gerer', _List_Nil, 'Gérer dans Rôles et droits');
};
var $author$project$Components$Parametrage$Utilisateurs$FicheView$roles = F2(
	function (i18n, fiche) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('roles')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$utilisateursFicheRoles(i18n)),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('nombre')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$elm$core$String$fromInt(
												$elm$core$List$length(fiche.eX)))
										]))
								])),
							function () {
							var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rolesEtDroits, fiche.nQ);
							if (!_v0.$) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('gerer'),
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Routes$Route$adresseDesDroits)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$utilisateursFicheRolesGerer(i18n))
										]));
							} else {
								return $rtfeldman$elm_css$Html$Styled$text('');
							}
						}()
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$table,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$thead,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$tr,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$utilisateursFicheRolesColonneRole(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$utilisateursFicheRolesColonneAttribue(i18n))
														]))
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$tbody,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (role) {
											return A2(
												$rtfeldman$elm_css$Html$Styled$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$td,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(role.Dj)
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$td,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('attribue')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																function () {
																	var _v1 = _Utils_Tuple2(role.tT, role.tU);
																	if (!_v1.a.$) {
																		if (!_v1.b.$) {
																			var le = _v1.a.a;
																			var par = _v1.b.a;
																			return A2(
																				$author$project$I18n$Cles$utilisateursFicheRolesAttribuePar,
																				i18n,
																				{
																					wv: A2($author$project$Components$Parametrage$Utilisateurs$FicheView$jour, i18n, le),
																					Dj: par
																				});
																		} else {
																			var le = _v1.a.a;
																			var _v2 = _v1.b;
																			return A2($author$project$Components$Parametrage$Utilisateurs$FicheView$jour, i18n, le);
																		}
																	} else {
																		var _v3 = _v1.a;
																		return $author$project$I18n$Cles$utilisateursSansValeur(i18n);
																	}
																}())
															]))
													]));
										},
										fiche.eX))
								]))
						]))
				]));
	});
var $author$project$Components$Parametrage$Utilisateurs$Model$EnvoiDuLien = 5;
var $author$project$Components$Parametrage$Utilisateurs$Model$FermetureDesSessions = 6;
var $author$project$Components$Parametrage$Utilisateurs$Model$Reinitialisation = 4;
var $author$project$I18n$Cles$utilisateursFicheSecuriteApplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.securite.application', _List_Nil, 'Application d\'authentification');
};
var $author$project$I18n$Cles$utilisateursFicheSecuriteApplicationDepuis = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.fiche.securite.application.depuis',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Application d\'authentification, depuis le ' + p.wv);
	});
var $author$project$I18n$Cles$utilisateursFicheSecuriteCle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.securite.cle', _List_Nil, 'Clé de sécurité');
};
var $author$project$I18n$Cles$utilisateursFicheSecuriteCleDepuis = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.fiche.securite.cle.depuis',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Clé de sécurité, depuis le ' + p.wv);
	});
var $author$project$I18n$Cles$utilisateursFicheSecuriteImposeePar = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.fiche.securite.imposee-par',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(p.yz)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'imposée par ' + (p.yz + (' : ' + (p.Dj + ' l\'enregistrera à sa prochaine connexion'))));
	});
var $author$project$I18n$Cles$utilisateursFicheSecuriteImposeeParSansEspace = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.fiche.securite.imposee-par.sans-espace',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'imposée par l\'espace : ' + (p.Dj + ' l\'enregistrera à sa prochaine connexion'));
	});
var $author$project$I18n$Cles$utilisateursFicheSecuriteReinitialisee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.securite.reinitialisee', _List_Nil, 'Réinitialisée');
};
var $author$project$I18n$Cles$utilisateursFicheSecuriteReinitialiseeLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.fiche.securite.reinitialisee-le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'le ' + (p.wv + (' · ' + (p.Dj + ' en enregistrera une nouvelle à sa prochaine connexion'))));
	});
var $author$project$I18n$Cles$utilisateursFicheSecuriteReinitialiseePar = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.fiche.securite.reinitialisee-par',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv)),
					_Utils_Tuple2(
					'auteur',
					$author$project$I18n$Traductions$Chaine(p.t1)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'le ' + (p.wv + (' par ' + (p.t1 + (' · ' + (p.Dj + ' en enregistrera une nouvelle à sa prochaine connexion'))))));
	});
var $author$project$Components$Parametrage$Utilisateurs$FicheView$etatDeLaDoubleAuthentification = F3(
	function (i18n, model, fiche) {
		var precision = function (texte) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(texte)
					]));
		};
		var imposee = fiche.q1.AD;
		var _v0 = fiche.q1.gt;
		if (!_v0.$) {
			switch (_v0.a) {
				case 0:
					var _v1 = _v0.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							0,
							$author$project$I18n$Cles$utilisateursDoubleAuthentificationActivee(i18n)),
							precision(
							function () {
								var _v2 = _Utils_Tuple2(fiche.q1.CZ, fiche.q1.sS);
								if (!_v2.a.$) {
									if (!_v2.a.a) {
										if (!_v2.b.$) {
											var _v3 = _v2.a.a;
											var le = _v2.b.a;
											return A2(
												$author$project$I18n$Cles$utilisateursFicheSecuriteApplicationDepuis,
												i18n,
												{
													wv: A2($author$project$Components$Parametrage$Utilisateurs$FicheView$jour, i18n, le)
												});
										} else {
											var _v4 = _v2.a.a;
											var _v5 = _v2.b;
											return $author$project$I18n$Cles$utilisateursFicheSecuriteApplication(i18n);
										}
									} else {
										if (!_v2.b.$) {
											var _v6 = _v2.a.a;
											var le = _v2.b.a;
											return A2(
												$author$project$I18n$Cles$utilisateursFicheSecuriteCleDepuis,
												i18n,
												{
													wv: A2($author$project$Components$Parametrage$Utilisateurs$FicheView$jour, i18n, le)
												});
										} else {
											var _v7 = _v2.a.a;
											var _v8 = _v2.b;
											return $author$project$I18n$Cles$utilisateursFicheSecuriteCle(i18n);
										}
									}
								} else {
									var _v9 = _v2.a;
									return '';
								}
							}())
						]);
				case 1:
					var _v10 = _v0.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							1,
							$author$project$I18n$Cles$utilisateursFicheSecuriteReinitialisee(i18n)),
							precision(
							function () {
								var _v11 = fiche.q1.Hp;
								if (!_v11.$) {
									var le = _v11.a.Bf;
									var par = _v11.a.EK;
									if (!par.$) {
										var auteur = par.a;
										return A2(
											$author$project$I18n$Cles$utilisateursFicheSecuriteReinitialiseePar,
											i18n,
											{
												t1: auteur,
												wv: A2($author$project$Texte$Jour$horodateALHeure, i18n, le),
												Dj: fiche.Dj
											});
									} else {
										return A2(
											$author$project$I18n$Cles$utilisateursFicheSecuriteReinitialiseeLe,
											i18n,
											{
												wv: A2($author$project$Texte$Jour$horodateALHeure, i18n, le),
												Dj: fiche.Dj
											});
									}
								} else {
									return '';
								}
							}())
						]);
				default:
					var _v13 = _v0.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							3,
							$author$project$I18n$Cles$utilisateursDoubleAuthentificationNonActivee(i18n)),
							imposee ? precision(
							function () {
								var _v14 = model.g5;
								if (!_v14.$) {
									var espace = _v14.a;
									return A2(
										$author$project$I18n$Cles$utilisateursFicheSecuriteImposeePar,
										i18n,
										{yz: espace, Dj: fiche.Dj});
								} else {
									return A2(
										$author$project$I18n$Cles$utilisateursFicheSecuriteImposeeParSansEspace,
										i18n,
										{Dj: fiche.Dj});
								}
							}()) : $rtfeldman$elm_css$Html$Styled$text('')
						]);
			}
		} else {
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$I18n$Cles$utilisateursSansValeur(i18n))
				]);
		}
	});
var $author$project$Components$Parametrage$Utilisateurs$Model$sessionsOuvertes = function (sessions) {
	return {
		tz: A3(
			$elm$core$List$foldl,
			F2(
				function (application, vues) {
					return A2($elm$core$List$member, application, vues) ? vues : _Utils_ap(
						vues,
						_List_fromArray(
							[application]));
				}),
			_List_Nil,
			$elm$core$List$concat(sessions)),
		w: $elm$core$List$length(sessions)
	};
};
var $author$project$I18n$Cles$utilisateursFicheSecuriteSessionsAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.securite.sessions.aucune', _List_Nil, 'Aucune');
};
var $author$project$I18n$Cles$utilisateursFicheSecuriteSessionsNombre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.fiche.securite.sessions.nombre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w)),
					_Utils_Tuple2(
					'applications',
					$author$project$I18n$Traductions$Chaine(p.tz))
				]),
			p.w + (' (' + (p.tz + ')')));
	});
var $author$project$Components$Parametrage$Utilisateurs$FicheView$sessions = F2(
	function (i18n, lues) {
		if (!lues.$) {
			if (!lues.a.b) {
				return $author$project$I18n$Cles$utilisateursFicheSecuriteSessionsAucune(i18n);
			} else {
				var ouvertes = lues.a;
				var vues = $author$project$Components$Parametrage$Utilisateurs$Model$sessionsOuvertes(ouvertes);
				return A2(
					$author$project$I18n$Cles$utilisateursFicheSecuriteSessionsNombre,
					i18n,
					{
						tz: A2($elm$core$String$join, ', ', vues.tz),
						w: $elm$core$String$fromInt(vues.w)
					});
			}
		} else {
			return $author$project$I18n$Cles$utilisateursSansValeur(i18n);
		}
	});
var $author$project$I18n$Cles$utilisateursFicheSecurite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.securite', _List_Nil, 'Sécurité');
};
var $author$project$I18n$Cles$utilisateursFicheSecuriteDoubleAuthentification = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.securite.double-authentification', _List_Nil, 'Double authentification');
};
var $author$project$I18n$Cles$utilisateursFicheSecuriteEnvoyerUnLien = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.securite.envoyer-un-lien', _List_Nil, 'Envoyer un lien de réinitialisation du mot de passe…');
};
var $author$project$I18n$Cles$utilisateursFicheSecuriteFermerLesSessions = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.securite.fermer-les-sessions', _List_Nil, 'Fermer toutes ses sessions…');
};
var $author$project$I18n$Cles$utilisateursFicheSecuriteNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.securite.note', _List_Nil, 'Dépannage : vous ne voyez jamais le mot de passe ni le secret de l\'utilisateur, et vous ne pouvez pas les définir à sa place. Chaque action est tracée.');
};
var $author$project$I18n$Cles$utilisateursFicheSecuriteReinitialiser = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.securite.reinitialiser', _List_Nil, 'Réinitialiser la double authentification…');
};
var $author$project$I18n$Cles$utilisateursFicheSecuriteSessions = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.securite.sessions', _List_Nil, 'Sessions ouvertes');
};
var $author$project$Components$Parametrage$Utilisateurs$FicheView$securite = F3(
	function (i18n, model, fiche) {
		var geste = F4(
			function (rel, classe, msg, libelle) {
				return A2(
					$elm$core$Maybe$map,
					function (_v0) {
						return A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class(classe),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
								]),
							libelle);
					},
					A2($author$project$API$Liens$trouver, rel, fiche.nQ));
			});
		var depannages = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A4(
					geste,
					$author$project$API$NavLinksDictionary$envoyerUneReinitialisationDuMotDePasse,
					'envoyer-un-lien',
					$author$project$Components$Parametrage$Utilisateurs$Update$GesteDemande(5),
					$author$project$I18n$Cles$utilisateursFicheSecuriteEnvoyerUnLien(i18n)),
					A4(
					geste,
					$author$project$API$NavLinksDictionary$reinitialiserLaDoubleAuthentification,
					'reinitialiser',
					$author$project$Components$Parametrage$Utilisateurs$Update$GesteDemande(4),
					$author$project$I18n$Cles$utilisateursFicheSecuriteReinitialiser(i18n)),
					A4(
					geste,
					$author$project$API$NavLinksDictionary$fermerLesSessions,
					'fermer-les-sessions',
					$author$project$Components$Parametrage$Utilisateurs$Update$GesteDemande(6),
					$author$project$I18n$Cles$utilisateursFicheSecuriteFermerLesSessions(i18n))
				]));
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('securite')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$utilisateursFicheSecurite(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$dl,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$dt,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$utilisateursFicheSecuriteDoubleAuthentification(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$dd,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('double-authentification')
										]),
									A3($author$project$Components$Parametrage$Utilisateurs$FicheView$etatDeLaDoubleAuthentification, i18n, model, fiche)),
									A2(
									$rtfeldman$elm_css$Html$Styled$dt,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$utilisateursFicheSecuriteSessions(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$dd,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('sessions')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$Components$Parametrage$Utilisateurs$FicheView$sessions, i18n, fiche.q1.IK))
										]))
								])),
						$elm$core$List$isEmpty(depannages) ? _List_Nil : _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$utilisateursFicheSecuriteNote(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('depannages')
									]),
								depannages)
							])))
				]));
	});
var $author$project$I18n$Cles$utilisateursFicheInvitationA = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.fiche.invitation-a',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(p.yz))
				]),
			'invitation à ' + p.yz);
	});
var $author$project$I18n$Cles$utilisateursFicheInvitationASansEspace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.invitation-a.sans-espace', _List_Nil, 'invitation à l\'espace');
};
var $author$project$I18n$Cles$utilisateursFicheUtilisateurDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.fiche.utilisateur-de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.yz)))
				]),
			'utilisateur ' + function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.yz);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.yz);
					default:
						return 'de ' + $elm$core$String$trim(p.yz);
				}
			}());
	});
var $author$project$I18n$Cles$utilisateursFicheUtilisateurDeSansEspace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.utilisateur-de.sans-espace', _List_Nil, 'utilisateur de l\'espace');
};
var $author$project$Components$Parametrage$Utilisateurs$FicheView$sousTitre = F3(
	function (i18n, espace, fiche) {
		var invitation = A2(
			$elm$core$List$member,
			fiche.gt,
			_List_fromArray(
				[2, 3]));
		var place = function () {
			var _v0 = _Utils_Tuple2(espace, invitation);
			if (!_v0.a.$) {
				if (!_v0.b) {
					var nom = _v0.a.a;
					return A2(
						$author$project$I18n$Cles$utilisateursFicheUtilisateurDe,
						i18n,
						{
							av: $author$project$Texte$Elision$elision(nom),
							yz: nom
						});
				} else {
					var nom = _v0.a.a;
					return A2(
						$author$project$I18n$Cles$utilisateursFicheInvitationA,
						i18n,
						{yz: nom});
				}
			} else {
				if (!_v0.b) {
					var _v1 = _v0.a;
					return $author$project$I18n$Cles$utilisateursFicheUtilisateurDeSansEspace(i18n);
				} else {
					var _v2 = _v0.a;
					return $author$project$I18n$Cles$utilisateursFicheInvitationASansEspace(i18n);
				}
			}
		}();
		return A2(
			$elm$core$String$join,
			' · ',
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not),
				_List_fromArray(
					[
						A2(
						$elm$core$String$join,
						', ',
						A2(
							$elm$core$List$map,
							function ($) {
								return $.Dj;
							},
							fiche.eX)),
						place
					])));
	});
var $author$project$I18n$Cles$utilisateursFicheIntrouvable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.fiche.introuvable', _List_Nil, 'Cet utilisateur ne fait pas partie de l\'espace.');
};
var $author$project$Components$Parametrage$Utilisateurs$FicheView$view = F4(
	function (i18n, messages, dialogues, model) {
		var nom = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Dj;
				},
				model.zo));
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'parametrage-utilisateur-detail',
			{
				ut: function () {
					if (model.qa) {
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Note$View$view,
										1,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$coquilleAccesRefuse(i18n))
													]))
											]))
									]))
							]);
					} else {
						if (model.nf) {
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Components$Shared$Note$View$view,
											1,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$utilisateursFicheIntrouvable(i18n))
														]))
												]))
										]))
								]);
						} else {
							var _v0 = model.zo;
							if (!_v0.$) {
								var fiche = _v0.a;
								return _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
											]),
										_List_fromArray(
											[
												A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('annonces')
													]),
												_Utils_ap(
													A2(
														$elm$core$List$map,
														function (annonce) {
															return A2(
																$author$project$Components$Shared$Note$View$view,
																3,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(
																		A2($author$project$I18n$Cles$texte, i18n, annonce))
																	]));
														},
														model.tn),
													A2(
														$elm$core$List$map,
														function (annonce) {
															return A2(
																$author$project$Components$Shared$Note$View$view,
																3,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(annonce)
																	]));
														},
														A3($author$project$Components$Parametrage$Utilisateurs$FicheView$annonceDuLien, i18n, model, fiche)))),
												A2($author$project$Components$Parametrage$Utilisateurs$FicheView$refus, i18n, model),
												A3($author$project$Components$Parametrage$Utilisateurs$FicheView$bandeauDuDesactive, i18n, model.g5, fiche),
												A2($author$project$Components$Parametrage$Utilisateurs$FicheView$identite, i18n, fiche),
												A3($author$project$Components$Parametrage$Utilisateurs$FicheView$securite, i18n, model, fiche),
												A2($author$project$Components$Parametrage$Utilisateurs$FicheView$roles, i18n, fiche),
												A2($author$project$Components$Parametrage$Utilisateurs$FicheView$ficheLiee, i18n, fiche),
												A3($author$project$Components$Parametrage$Utilisateurs$FicheView$dernieresConnexions, i18n, model, fiche)
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id('aside')
											]),
										_List_fromArray(
											[
												A2($author$project$Components$Parametrage$Utilisateurs$FicheView$acces, i18n, fiche)
											]))
									]);
							} else {
								return _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
											]),
										_List_fromArray(
											[
												A2($author$project$Components$Shared$Messages$View$view, i18n, messages)
											]))
									]);
							}
						}
					}
				}(),
				xy: A2(
					$elm$core$List$cons,
					A2($author$project$Components$Parametrage$Utilisateurs$FicheView$confirmation, i18n, model),
					A2(
						$elm$core$List$cons,
						A2($author$project$Components$Parametrage$Utilisateurs$FicheView$drawerDeLiaison, i18n, model),
						dialogues)),
				zM: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2($author$project$Components$Parametrage$Utilisateurs$FicheView$gestes, i18n, model.g5),
						model.zo)),
				AK: $author$project$Components$Parametrage$Utilisateurs$Update$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: function () {
							var _v1 = model.zo;
							if (!_v1.$) {
								var fiche = _v1.a;
								return _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('avatar'),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$Texte$Initiales$initiales(nom))
											])),
										A2($author$project$Components$Parametrage$Utilisateurs$FicheView$etat, i18n, fiche.gt),
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A3($author$project$Components$Parametrage$Utilisateurs$FicheView$sousTitre, i18n, model.g5, fiche))
											]))
									]);
							} else {
								return _List_Nil;
							}
						}(),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adresseTypesDePartiesPrenantes,
								Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
							},
								{
								aa: $author$project$Routes$Route$adresseDesUtilisateurs,
								Dj: $author$project$I18n$Cles$utilisateursFil(i18n)
							},
								{aa: '', Dj: nom}
							]),
						Ef: _List_Nil,
						h6: nom
					})
			});
	});
var $author$project$Components$Parametrage$Utilisateurs$Model$Imposition = 2;
var $author$project$Components$Parametrage$Utilisateurs$Model$Levee = 3;
var $author$project$I18n$Cles$utilisateursSecuriteImposerConfirmer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.securite.imposer.confirmer', _List_Nil, 'Imposer');
};
var $author$project$I18n$Cles$utilisateursSecuriteImposerMessage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.securite.imposer.message',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w)),
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.yz)))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' utilisateur devra l\'activer à sa prochaine connexion, avant d\'entrer. L\'obligation vaut pour les utilisateurs ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.yz);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.yz);
					default:
						return 'de ' + $elm$core$String$trim(p.yz);
				}
			}() + ' dans toute la suite Asria, Asria Cockpit compris. Les comptes qui l\'ont déjà ne voient aucun changement.'))) : (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' utilisateurs devront l\'activer à leur prochaine connexion, avant d\'entrer. L\'obligation vaut pour les utilisateurs ' + (function () {
				var _v1 = p.av;
				switch (_v1) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.yz);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.yz);
					default:
						return 'de ' + $elm$core$String$trim(p.yz);
				}
			}() + ' dans toute la suite Asria, Asria Cockpit compris. Les comptes qui l\'ont déjà ne voient aucun changement.'))));
	});
var $author$project$I18n$Cles$utilisateursSecuriteImposerMessageSansEspace = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.securite.imposer.message.sans-espace',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' utilisateur devra l\'activer à sa prochaine connexion, avant d\'entrer. L\'obligation vaut pour les utilisateurs de l\'espace dans toute la suite Asria, Asria Cockpit compris. Les comptes qui l\'ont déjà ne voient aucun changement.') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' utilisateurs devront l\'activer à leur prochaine connexion, avant d\'entrer. L\'obligation vaut pour les utilisateurs de l\'espace dans toute la suite Asria, Asria Cockpit compris. Les comptes qui l\'ont déjà ne voient aucun changement.'));
	});
var $author$project$I18n$Cles$utilisateursSecuriteImposerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.securite.imposer.titre', _List_Nil, 'Imposer la double authentification ?');
};
var $author$project$I18n$Cles$utilisateursSecuriteLeverConfirmer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.securite.lever.confirmer', _List_Nil, 'Lever l\'obligation');
};
var $author$project$I18n$Cles$utilisateursSecuriteLeverMessage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.securite.lever.message',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.yz)))
				]),
			'Chaque membre ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.yz);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.yz);
					default:
						return 'de ' + $elm$core$String$trim(p.yz);
				}
			}() + ' pourra de nouveau choisir de l\'activer ou non dans « Mon compte ». Les comptes qui l\'ont déjà la gardent ; les autres n\'ont plus à l\'enregistrer, sauf pour un autre espace qui l\'impose.'));
	});
var $author$project$I18n$Cles$utilisateursSecuriteLeverMessageSansEspace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.securite.lever.message.sans-espace', _List_Nil, 'Chaque membre de l\'espace pourra de nouveau choisir de l\'activer ou non dans « Mon compte ». Les comptes qui l\'ont déjà la gardent ; les autres n\'ont plus à l\'enregistrer, sauf pour un autre espace qui l\'impose.');
};
var $author$project$I18n$Cles$utilisateursSecuriteLeverTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.securite.lever.titre', _List_Nil, 'Lever l\'obligation de double authentification ?');
};
var $author$project$Components$Parametrage$Utilisateurs$SecuriteView$confirmation = F2(
	function (i18n, model) {
		var ouverte = A2(
			$elm$core$List$member,
			model.iu,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(2),
					$elm$core$Maybe$Just(3)
				]));
		var nombre = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.JE;
				},
				model.q1));
		var ids = $author$project$Components$Parametrage$Utilisateurs$Model$idsDuGeste;
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(model.iu, model.g5);
			if (!_v1.b.$) {
				if ((!_v1.a.$) && (_v1.a.a === 3)) {
					var _v2 = _v1.a.a;
					var espace = _v1.b.a;
					return _Utils_Tuple3(
						$author$project$I18n$Cles$utilisateursSecuriteLeverTitre(i18n),
						A2(
							$author$project$I18n$Cles$utilisateursSecuriteLeverMessage,
							i18n,
							{
								av: $author$project$Texte$Elision$elision(espace),
								yz: espace
							}),
						$author$project$I18n$Cles$utilisateursSecuriteLeverConfirmer(i18n));
				} else {
					var espace = _v1.b.a;
					return _Utils_Tuple3(
						$author$project$I18n$Cles$utilisateursSecuriteImposerTitre(i18n),
						A2(
							$author$project$I18n$Cles$utilisateursSecuriteImposerMessage,
							i18n,
							{
								av: $author$project$Texte$Elision$elision(espace),
								yz: espace,
								w: nombre
							}),
						$author$project$I18n$Cles$utilisateursSecuriteImposerConfirmer(i18n));
				}
			} else {
				if ((!_v1.a.$) && (_v1.a.a === 3)) {
					var _v3 = _v1.a.a;
					var _v4 = _v1.b;
					return _Utils_Tuple3(
						$author$project$I18n$Cles$utilisateursSecuriteLeverTitre(i18n),
						$author$project$I18n$Cles$utilisateursSecuriteLeverMessageSansEspace(i18n),
						$author$project$I18n$Cles$utilisateursSecuriteLeverConfirmer(i18n));
				} else {
					var _v5 = _v1.b;
					return _Utils_Tuple3(
						$author$project$I18n$Cles$utilisateursSecuriteImposerTitre(i18n),
						A2(
							$author$project$I18n$Cles$utilisateursSecuriteImposerMessageSansEspace,
							i18n,
							{w: nombre}),
						$author$project$I18n$Cles$utilisateursSecuriteImposerConfirmer(i18n));
				}
			}
		}();
		var titre = _v0.a;
		var message = _v0.b;
		var confirmer = _v0.c;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('opened', ouverte)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('overlay'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$Utilisateurs$Update$GesteRenonce)
						]),
					_List_Nil),
					A2(
					$author$project$Components$Shared$Confirmation$View$view,
					i18n,
					{
						vl: $author$project$Components$Parametrage$Utilisateurs$Update$clavierDuGeste,
						j7: {Aq: ids.j7, Bl: confirmer, C$: $author$project$Components$Parametrage$Utilisateurs$Update$GesteConfirme},
						Aq: ids.GN,
						As: ids.Cs,
						At: ids.h6,
						Cs: message,
						Et: ouverte,
						HG: {
							Aq: ids.z7,
							Bl: $author$project$I18n$Cles$utilisateursGesteGarder(i18n),
							C$: $author$project$Components$Parametrage$Utilisateurs$Update$GesteRenonce
						},
						h6: titre,
						sl: 3
					})
				]));
	});
var $author$project$Components$Parametrage$Utilisateurs$SecuriteView$description = F2(
	function (i18n, espace) {
		if (!espace.$) {
			var nom = espace.a;
			return A2(
				$author$project$I18n$Cles$utilisateursDescription,
				i18n,
				{
					av: $author$project$Texte$Elision$elision(nom),
					yz: nom
				});
		} else {
			return $author$project$I18n$Cles$utilisateursDescriptionSansEspace(i18n);
		}
	});
var $author$project$Components$Parametrage$Utilisateurs$Model$apercu = function (lignes) {
	return {
		t7: A2(
			$elm$core$Basics$max,
			0,
			$elm$core$List$length(lignes) - 4),
		gV: A2($elm$core$List$take, 4, lignes)
	};
};
var $author$project$Components$Parametrage$Utilisateurs$SecuriteView$ligne = F2(
	function (i18n, utilisateur) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href(
									$author$project$Routes$Route$adresseDUnUtilisateur(utilisateur.fl))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(utilisateur.Dj)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('roles')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$String$join, ', ', utilisateur.eX))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('connexion')
						]),
					_List_fromArray(
						[
							function () {
							var _v0 = utilisateur.gt;
							switch (_v0) {
								case 2:
									return A2(
										$author$project$Components$Shared$Tag$View$view,
										5,
										$author$project$I18n$Cles$utilisateursEtatEnvoyee(i18n));
								case 3:
									return A2(
										$author$project$Components$Shared$Tag$View$view,
										1,
										$author$project$I18n$Cles$utilisateursEtatExpiree(i18n));
								default:
									return $rtfeldman$elm_css$Html$Styled$text(
										A2(
											$elm$core$Maybe$withDefault,
											$author$project$I18n$Cles$utilisateursSansValeur(i18n),
											A2(
												$elm$core$Maybe$map,
												$author$project$Texte$Jour$horodateALHeure(i18n),
												utilisateur.kJ)));
							}
						}()
						]))
				]));
	});
var $author$project$I18n$Cles$utilisateursSecuriteAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.securite.aucun', _List_Nil, 'Tous les utilisateurs de l\'espace ont la double authentification.');
};
var $author$project$I18n$Cles$utilisateursSecuriteAutres = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.securite.autres',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('… et ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' autre.')) : ('… et ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' autres.')));
	});
var $author$project$I18n$Cles$utilisateursSecuriteEnAttente = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.securite.en-attente', _List_Nil, 'En attente d\'activation');
};
var $author$project$I18n$Cles$utilisateursSecuriteEnAttenteNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.securite.en-attente.note', _List_Nil, 'Chaque compte l\'enregistrera à sa prochaine connexion.');
};
var $author$project$I18n$Cles$utilisateursSecuriteSansDoubleAuthentification = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.securite.sans-double-authentification', _List_Nil, 'Utilisateurs sans double authentification');
};
var $author$project$Components$Parametrage$Utilisateurs$SecuriteView$enAttente = F2(
	function (i18n, securite) {
		var vus = $author$project$Components$Parametrage$Utilisateurs$Model$apercu(securite.lU);
		return A2(
			$author$project$Components$Shared$Page$View$sectionAvecCompte,
			_List_Nil,
			{
				fw: _List_Nil,
				vW: $elm$core$Maybe$Just(
					$elm$core$String$fromInt(securite.JE)),
				fZ: (!securite.kR) ? _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Note$View$view,
						2,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$utilisateursIndisponible(i18n)),
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('reessayer'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Parametrage$Utilisateurs$Update$RelectureDemandee)
									]),
								$author$project$I18n$Cles$utilisateursReessayer(i18n))
							]))
					]) : ($elm$core$List$isEmpty(securite.lU) ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aucun')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$utilisateursSecuriteAucun(i18n))
							]))
					]) : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$table,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$utilisateursColonneUtilisateur(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$utilisateursColonneRoles(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$utilisateursColonneConnexion(i18n))
															]))
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$tbody,
										_List_Nil,
										A2(
											$elm$core$List$map,
											$author$project$Components$Parametrage$Utilisateurs$SecuriteView$ligne(i18n),
											vus.gV))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									(vus.t7 > 0) ? $elm$core$Maybe$Just(
									$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$utilisateursSecuriteAutres,
											i18n,
											{w: vus.t7}))) : $elm$core$Maybe$Nothing,
									securite.AD ? $elm$core$Maybe$Just(
									$rtfeldman$elm_css$Html$Styled$text(
										' ' + $author$project$I18n$Cles$utilisateursSecuriteEnAttenteNote(i18n))) : $elm$core$Maybe$Nothing
								])))
					])),
				Ar: $elm$core$Maybe$Nothing,
				Dj: 'en-attente',
				h6: securite.AD ? $author$project$I18n$Cles$utilisateursSecuriteEnAttente(i18n) : $author$project$I18n$Cles$utilisateursSecuriteSansDoubleAuthentification(i18n)
			});
	});
var $author$project$I18n$Cles$utilisateursSecuriteMotDePasseTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.securite.mot-de-passe.texte', _List_Nil, 'La politique de mot de passe (longueur, renouvellement) est commune à toute la suite Asria et réglée par Asria. Pour dépanner un utilisateur, ouvrez sa fiche.');
};
var $author$project$I18n$Cles$utilisateursSecuriteMotDePasseTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.securite.mot-de-passe.titre', _List_Nil, 'Mot de passe');
};
var $author$project$Components$Parametrage$Utilisateurs$SecuriteView$motDePasse = function (i18n) {
	return A2(
		$author$project$Components$Shared$Page$View$section,
		_List_Nil,
		{
			fw: _List_Nil,
			fZ: _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$utilisateursSecuriteMotDePasseTexte(i18n))
						]))
				]),
			Dj: 'mot-de-passe',
			h6: $author$project$I18n$Cles$utilisateursSecuriteMotDePasseTitre(i18n)
		});
};
var $author$project$I18n$Cles$utilisateursSecuriteObligationImposeeDepuis = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.securite.obligation.imposee-depuis',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'depuis le ' + (p.wv + (', par ' + p.Dj)));
	});
var $author$project$I18n$Cles$utilisateursSecuriteObligationImposeeDepuisSansAuteur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.securite.obligation.imposee-depuis.sans-auteur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'depuis le ' + p.wv);
	});
var $author$project$Components$Parametrage$Utilisateurs$SecuriteView$depuis = F2(
	function (i18n, securite) {
		var _v0 = securite.AE;
		if (!_v0.$) {
			var trace = _v0.a;
			var _v1 = trace.EK;
			if (!_v1.$) {
				var par = _v1.a;
				return A2(
					$author$project$I18n$Cles$utilisateursSecuriteObligationImposeeDepuis,
					i18n,
					{
						wv: A2($author$project$Texte$Jour$horodateALHeure, i18n, trace.Bf),
						Dj: par
					});
			} else {
				return A2(
					$author$project$I18n$Cles$utilisateursSecuriteObligationImposeeDepuisSansAuteur,
					i18n,
					{
						wv: A2($author$project$Texte$Jour$horodateALHeure, i18n, trace.Bf)
					});
			}
		} else {
			return '';
		}
	});
var $author$project$Components$Parametrage$Utilisateurs$SecuriteView$idDuLibelle = 'utilisateurs-securite-obligation';
var $author$project$I18n$Cles$utilisateursSecuriteObligationImposee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.securite.obligation.imposee', _List_Nil, 'Imposée');
};
var $author$project$I18n$Cles$utilisateursSecuriteObligationLevee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.securite.obligation.levee', _List_Nil, 'Aujourd\'hui, chaque membre de l\'espace choisit de l\'activer ou non dans « Mon compte ».');
};
var $author$project$I18n$Cles$utilisateursSecuriteObligationLibelle = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'utilisateurs.securite.obligation.libelle',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'espace',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.yz)))
				]),
			'Imposer la double authentification à tous les utilisateurs ' + function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.yz);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.yz);
					default:
						return 'de ' + $elm$core$String$trim(p.yz);
				}
			}());
	});
var $author$project$I18n$Cles$utilisateursSecuriteObligationLibelleSansEspace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.securite.obligation.libelle.sans-espace', _List_Nil, 'Imposer la double authentification à tous les utilisateurs de l\'espace');
};
var $author$project$I18n$Cles$utilisateursSecuriteObligationNoteImposee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.securite.obligation.note.imposee', _List_Nil, 'Chaque membre l\'enregistre à sa prochaine connexion, avant d\'entrer : une application d\'authentification, puis, au besoin, une clé de sécurité ajoutée dans « Mon compte ». L\'obligation vaut dans toute la suite Asria, Asria Cockpit compris.');
};
var $author$project$I18n$Cles$utilisateursSecuriteObligationNoteLevee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.securite.obligation.note.levee', _List_Nil, 'Chaque membre l\'enregistrera à sa prochaine connexion, avant d\'entrer : une application d\'authentification, puis, au besoin, une clé de sécurité ajoutée dans « Mon compte ». L\'obligation vaudra dans toute la suite Asria, Asria Cockpit compris.');
};
var $author$project$I18n$Cles$utilisateursSecuriteObligationTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'utilisateurs.securite.obligation.titre', _List_Nil, 'Double authentification obligatoire');
};
var $author$project$Components$Parametrage$Utilisateurs$SecuriteView$obligation = F3(
	function (i18n, model, securite) {
		var libelle = function () {
			var _v1 = model.g5;
			if (!_v1.$) {
				var nom = _v1.a;
				return A2(
					$author$project$I18n$Cles$utilisateursSecuriteObligationLibelle,
					i18n,
					{
						av: $author$project$Texte$Elision$elision(nom),
						yz: nom
					});
			} else {
				return $author$project$I18n$Cles$utilisateursSecuriteObligationLibelleSansEspace(i18n);
			}
		}();
		var _v0 = securite.AD ? _Utils_Tuple2($author$project$API$NavLinksDictionary$leverLaDoubleAuthentification, 3) : _Utils_Tuple2($author$project$API$NavLinksDictionary$imposerLaDoubleAuthentification, 2);
		var rel = _v0.a;
		var geste = _v0.b;
		var actif = (!_Utils_eq(
			A2($author$project$API$Liens$trouver, rel, securite.nQ),
			$elm$core$Maybe$Nothing)) && (!$author$project$API$Envoi$enCours(model.l2));
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_Nil,
			{
				fw: _List_Nil,
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('reglage')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('commutateur'),
										$rtfeldman$elm_css$Html$Styled$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('allume', securite.AD)
											])),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'switch'),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
										'aria-checked',
										securite.AD ? 'true' : 'false'),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-labelledby', $author$project$Components$Parametrage$Utilisateurs$SecuriteView$idDuLibelle),
										$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!actif),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Parametrage$Utilisateurs$Update$GesteDemande(geste))
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('glissiere')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('bouton')
													]),
												_List_Nil)
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$strong,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Parametrage$Utilisateurs$SecuriteView$idDuLibelle)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(libelle)
											])),
										securite.AD ? A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('etat')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Components$Shared$Tag$View$view,
												0,
												$author$project$I18n$Cles$utilisateursSecuriteObligationImposee(i18n)),
												$rtfeldman$elm_css$Html$Styled$text(
												A2($author$project$Components$Parametrage$Utilisateurs$SecuriteView$depuis, i18n, securite))
											])) : A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('etat')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$utilisateursSecuriteObligationLevee(i18n))
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								securite.AD ? $author$project$I18n$Cles$utilisateursSecuriteObligationNoteImposee(i18n) : $author$project$I18n$Cles$utilisateursSecuriteObligationNoteLevee(i18n))
							]))
					]),
				Dj: 'obligation',
				h6: $author$project$I18n$Cles$utilisateursSecuriteObligationTitre(i18n)
			});
	});
var $author$project$Components$Parametrage$Utilisateurs$SecuriteView$view = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'parametrage-utilisateurs-securite',
			{
				ut: model.qa ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Note$View$view,
								1,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$coquilleAccesRefuse(i18n))
											]))
									]))
							]))
					]) : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						A2(
							$elm$core$List$cons,
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							A2(
								$elm$core$List$cons,
								A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('annonces')
										]),
									A2(
										$elm$core$List$map,
										function (annonce) {
											return A2(
												$author$project$Components$Shared$Note$View$view,
												3,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2($author$project$I18n$Cles$texte, i18n, annonce))
													]));
										},
										model.tn)),
								function () {
									var _v0 = model.q1;
									if (!_v0.$) {
										var securite = _v0.a;
										return _List_fromArray(
											[
												A3($author$project$Components$Parametrage$Utilisateurs$SecuriteView$obligation, i18n, model, securite),
												A2($author$project$Components$Parametrage$Utilisateurs$SecuriteView$enAttente, i18n, securite),
												$author$project$Components$Parametrage$Utilisateurs$SecuriteView$motDePasse(i18n)
											]);
									} else {
										return _List_Nil;
									}
								}())))
					]),
				xy: _List_fromArray(
					[
						A2($author$project$Components$Parametrage$Utilisateurs$SecuriteView$confirmation, i18n, model)
					]),
				zM: _List_Nil,
				AK: $author$project$Components$Parametrage$Utilisateurs$Update$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$Components$Parametrage$Utilisateurs$SecuriteView$description, i18n, model.g5))
									]))
							]),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adresseTypesDePartiesPrenantes,
								Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
							},
								{
								aa: '',
								Dj: $author$project$I18n$Cles$utilisateursFil(i18n)
							}
							]),
						Ef: A3($author$project$Components$Parametrage$Utilisateurs$OngletsDeLAnnuaire$onglets, i18n, 1, model),
						h6: $author$project$I18n$Cles$utilisateursTitre(i18n)
					})
			});
	});
var $author$project$Components$Parametrage$Utilisateurs$View$view = F3(
	function (i18n, messages, model) {
		return (!_Utils_eq(model.vf, $elm$core$Maybe$Nothing)) ? A4(
			$author$project$Components$Parametrage$Utilisateurs$FicheView$view,
			i18n,
			messages,
			_List_fromArray(
				[
					A2($author$project$Components$Parametrage$Utilisateurs$View$confirmation, i18n, model)
				]),
			model) : (model.a$.Es ? A3($author$project$Components$Parametrage$Utilisateurs$ConnexionsView$view, i18n, messages, model) : ((model.oZ === 1) ? A3($author$project$Components$Parametrage$Utilisateurs$SecuriteView$view, i18n, messages, model) : A3($author$project$Components$Parametrage$Utilisateurs$View$annuaire, i18n, messages, model)));
	});
var $author$project$Components$Produits$Alertes$Update$Relue = {$: 6};
var $author$project$Components$Produits$Alertes$Update$InformationChoisie = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$Alertes$Update$TypeChoisi = function (a) {
	return {$: 4, a: a};
};
var $author$project$I18n$Cles$produitsAlertesFiltreInformation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.alertes.filtre-information', _List_Nil, 'Information');
};
var $author$project$I18n$Cles$produitsAlertesFiltreOption = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.alertes.filtre-option',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl)),
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			p.Bl + (' · ' + p.w));
	});
var $author$project$I18n$Cles$produitsAlertesFiltreTous = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.alertes.filtre-tous', _List_Nil, 'Tous');
};
var $author$project$I18n$Cles$produitsAlertesFiltreToutes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.alertes.filtre-toutes', _List_Nil, 'Toutes');
};
var $author$project$I18n$Cles$produitsAlertesFiltreType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.alertes.filtre-type', _List_Nil, 'Type de produit');
};
var $author$project$Components$Produits$Alertes$View$filtre = F3(
	function (i18n, model, lues) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('filtres')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsAlertesFiltreInformation(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$select,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Produits$Alertes$Update$InformationChoisie)
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$rtfeldman$elm_css$Html$Styled$option,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(''),
											$rtfeldman$elm_css$Html$Styled$Attributes$selected(model.AL === '')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsAlertesFiltreToutes(i18n))
										])),
								A2(
									$elm$core$List$map,
									function (information) {
										return A2(
											$rtfeldman$elm_css$Html$Styled$option,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$value(information.dy),
													$rtfeldman$elm_css$Html$Styled$Attributes$selected(
													_Utils_eq(model.AL, information.dy))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$author$project$I18n$Cles$produitsAlertesFiltreOption,
														i18n,
														{
															Bl: information.Bl,
															w: $elm$core$String$fromInt(information.w)
														}))
												]));
									},
									lues.AM)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsAlertesFiltreType(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$select,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Produits$Alertes$Update$TypeChoisi)
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$rtfeldman$elm_css$Html$Styled$option,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(''),
											$rtfeldman$elm_css$Html$Styled$Attributes$selected(model.fh === '')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsAlertesFiltreTous(i18n))
										])),
								A2(
									$elm$core$List$map,
									function (leType) {
										return A2(
											$rtfeldman$elm_css$Html$Styled$option,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$value(leType.Aq),
													$rtfeldman$elm_css$Html$Styled$Attributes$selected(
													_Utils_eq(model.fh, leType.Aq))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$author$project$I18n$Cles$produitsAlertesFiltreOption,
														i18n,
														{
															Bl: leType.Bl,
															w: $elm$core$String$fromInt(leType.w)
														}))
												]));
									},
									lues.ib)))
						]))
				]));
	});
var $author$project$Components$Produits$Alertes$Update$PageChoisie = function (a) {
	return {$: 5, a: a};
};
var $author$project$I18n$Cles$produitsAlertesAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.alertes.aide', _List_Nil, 'Cliquez un produit pour ouvrir sa fiche et corriger la valeur. Il quitte la liste dès qu’il est conforme.');
};
var $author$project$I18n$Cles$produitsAlertesPagePrecedente = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.alertes.page-precedente', _List_Nil, 'Page précédente');
};
var $author$project$I18n$Cles$produitsAlertesPageSuivante = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.alertes.page-suivante', _List_Nil, 'Page suivante');
};
var $author$project$I18n$Cles$produitsAlertesPagination = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.alertes.pagination',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'debut',
					$author$project$I18n$Traductions$Chaine(p.ku)),
					_Utils_Tuple2(
					'fin',
					$author$project$I18n$Traductions$Chaine(p.mI)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			p.ku + (' à ' + (p.mI + (' sur ' + p.JE))));
	});
var $author$project$I18n$Cles$produitsAlertesPaginationPlus = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.alertes.pagination-plus',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'debut',
					$author$project$I18n$Traductions$Chaine(p.ku)),
					_Utils_Tuple2(
					'fin',
					$author$project$I18n$Traductions$Chaine(p.mI)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			p.ku + (' à ' + (p.mI + (' sur au moins ' + p.JE))));
	});
var $author$project$Components$Produits$Alertes$View$pied = F3(
	function (i18n, model, lues) {
		var debut = ((model.EE - 1) * $author$project$Components$Produits$Alertes$Model$taillePage) + 1;
		var fin = (debut + $elm$core$List$length(lues.tb)) - 1;
		var compte = lues.tW ? A2(
			$author$project$I18n$Cles$produitsAlertesPaginationPlus,
			i18n,
			{
				ku: $elm$core$String$fromInt(debut),
				mI: $elm$core$String$fromInt(fin),
				JE: $elm$core$String$fromInt(lues.JE)
			}) : A2(
			$author$project$I18n$Cles$produitsAlertesPagination,
			i18n,
			{
				ku: $elm$core$String$fromInt(debut),
				mI: $elm$core$String$fromInt(fin),
				JE: $elm$core$String$fromInt(lues.JE)
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pied')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsAlertesAide(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('pagination')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(compte)
								])),
							(model.EE > 1) ? A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							2,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Produits$Alertes$Update$PageChoisie(model.EE - 1))
								]),
							$author$project$I18n$Cles$produitsAlertesPagePrecedente(i18n)) : $rtfeldman$elm_css$Html$Styled$text(''),
							(_Utils_cmp(fin, lues.JE) < 0) ? A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							2,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Produits$Alertes$Update$PageChoisie(model.EE + 1))
								]),
							$author$project$I18n$Cles$produitsAlertesPageSuivante(i18n)) : $rtfeldman$elm_css$Html$Styled$text('')
						]))
				]));
	});
var $author$project$I18n$Cles$produitsAlertesErreur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.alertes.erreur', _List_Nil, 'Les alertes n’ont pas pu être lues. Réessayez dans un instant.');
};
var $author$project$I18n$Cles$produitsAlertesReessayer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.alertes.reessayer', _List_Nil, 'Réessayer');
};
var $author$project$I18n$Cles$produitsAlertesVideTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.alertes.vide-texte', _List_Nil, 'Quand une limite est resserrée, les produits qui n’y entrent plus s’affichent ici.');
};
var $author$project$I18n$Cles$produitsAlertesVideTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.alertes.vide-titre', _List_Nil, 'Tous les produits respectent les limites de leurs informations');
};
var $author$project$Components$Produits$Alertes$Model$fiche = function (alerte) {
	return A2(
		$elm$core$Maybe$andThen,
		function (_v0) {
			return $author$project$Catalogue$Identifiants$referenceIdFromString(alerte.Hc);
		},
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$self, alerte.nQ));
};
var $author$project$Components$Shared$EditeurDeSchema$Limites$borne = function (b) {
	switch (b.$) {
		case 0:
			var n = b.a;
			return $elm$core$Maybe$Just(
				$elm$core$String$fromFloat(n));
		case 1:
			var jour = b.a;
			return $elm$core$Maybe$Just(jour);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$I18n$Cles$produitsAlertesLimiteEntre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.alertes.limite-entre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'min',
					$author$project$I18n$Traductions$Chaine(p.Cx)),
					_Utils_Tuple2(
					'max',
					$author$project$I18n$Traductions$Chaine(p.Cg)),
					_Utils_Tuple2(
					'unite',
					$author$project$I18n$Traductions$Chaine(p.sa))
				]),
			'de ' + (p.Cx + (' à ' + (p.Cg + p.sa))));
	});
var $author$project$I18n$Cles$produitsAlertesLimiteMax = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.alertes.limite-max',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'max',
					$author$project$I18n$Traductions$Chaine(p.Cg)),
					_Utils_Tuple2(
					'unite',
					$author$project$I18n$Traductions$Chaine(p.sa))
				]),
			'au plus ' + (p.Cg + p.sa));
	});
var $author$project$I18n$Cles$produitsAlertesLimiteMin = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.alertes.limite-min',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'min',
					$author$project$I18n$Traductions$Chaine(p.Cx)),
					_Utils_Tuple2(
					'unite',
					$author$project$I18n$Traductions$Chaine(p.sa))
				]),
			'au moins ' + (p.Cx + p.sa));
	});
var $author$project$Components$Shared$EditeurDeSchema$Limites$bornes = F4(
	function (i18n, unite_, mini, maxi) {
		var _v0 = _Utils_Tuple2(mini, maxi);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var a = _v0.a.a;
				var b = _v0.b.a;
				return A2(
					$author$project$I18n$Cles$produitsAlertesLimiteEntre,
					i18n,
					{Cg: b, Cx: a, sa: unite_});
			} else {
				var a = _v0.a.a;
				var _v1 = _v0.b;
				return A2(
					$author$project$I18n$Cles$produitsAlertesLimiteMin,
					i18n,
					{Cx: a, sa: unite_});
			}
		} else {
			if (!_v0.b.$) {
				var _v2 = _v0.a;
				var b = _v0.b.a;
				return A2(
					$author$project$I18n$Cles$produitsAlertesLimiteMax,
					i18n,
					{Cg: b, sa: unite_});
			} else {
				var _v3 = _v0.a;
				var _v4 = _v0.b;
				return '';
			}
		}
	});
var $author$project$I18n$Cles$produitsAlertesLimiteListe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.alertes.limite-liste',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeurs',
					$author$project$I18n$Traductions$Chaine(p.Ki))
				]),
			p.Ki);
	});
var $author$project$I18n$Cles$produitsAlertesLimiteLongueurEntre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.alertes.limite-longueur-entre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'min',
					$author$project$I18n$Traductions$Chaine(p.Cx)),
					_Utils_Tuple2(
					'max',
					$author$project$I18n$Traductions$Chaine(p.Cg))
				]),
			p.Cx + (' à ' + (p.Cg + ' caractères')));
	});
var $author$project$I18n$Cles$produitsAlertesLimiteLongueurMax = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.alertes.limite-longueur-max',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'max',
					$author$project$I18n$Traductions$Chaine(p.Cg))
				]),
			'au plus ' + (p.Cg + ' caractères'));
	});
var $author$project$I18n$Cles$produitsAlertesLimiteLongueurMin = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.alertes.limite-longueur-min',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'min',
					$author$project$I18n$Traductions$Chaine(p.Cx))
				]),
			'au moins ' + (p.Cx + ' caractères'));
	});
var $author$project$I18n$Cles$produitsAlertesLimiteMotif = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.alertes.limite-motif',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'motif',
					$author$project$I18n$Traductions$Chaine(p.cX))
				]),
			'motif ' + p.cX);
	});
var $author$project$Components$Shared$EditeurDeSchema$Limites$unite = function (champ) {
	var _v0 = champ.r0;
	if (_v0.$ === 10) {
		var mesure = _v0.a;
		return ' ' + A2(
			$elm$core$Maybe$withDefault,
			mesure.sa,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v1) {
							var langue = _v1.a;
							return langue === 'fr';
						},
						mesure.iF))));
	} else {
		return '';
	}
};
var $author$project$Components$Shared$EditeurDeSchema$Limites$limiteDe = F2(
	function (i18n, champ) {
		var desRegles = $elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (regle) {
					switch (regle.$) {
						case 0:
							var mini = regle.a;
							var maxi = regle.b;
							return _List_fromArray(
								[
									A4(
									$author$project$Components$Shared$EditeurDeSchema$Limites$bornes,
									i18n,
									$author$project$Components$Shared$EditeurDeSchema$Limites$unite(champ),
									A2($elm$core$Maybe$andThen, $author$project$Components$Shared$EditeurDeSchema$Limites$borne, mini),
									A2($elm$core$Maybe$andThen, $author$project$Components$Shared$EditeurDeSchema$Limites$borne, maxi))
								]);
						case 1:
							var mini = regle.a;
							var maxi = regle.b;
							var _v3 = _Utils_Tuple2(mini, maxi);
							if (!_v3.a.$) {
								if (!_v3.b.$) {
									var a = _v3.a.a;
									var b = _v3.b.a;
									return _List_fromArray(
										[
											A2(
											$author$project$I18n$Cles$produitsAlertesLimiteLongueurEntre,
											i18n,
											{
												Cg: $elm$core$String$fromInt(b),
												Cx: $elm$core$String$fromInt(a)
											})
										]);
								} else {
									var a = _v3.a.a;
									var _v4 = _v3.b;
									return _List_fromArray(
										[
											A2(
											$author$project$I18n$Cles$produitsAlertesLimiteLongueurMin,
											i18n,
											{
												Cx: $elm$core$String$fromInt(a)
											})
										]);
								}
							} else {
								if (!_v3.b.$) {
									var _v5 = _v3.a;
									var b = _v3.b.a;
									return _List_fromArray(
										[
											A2(
											$author$project$I18n$Cles$produitsAlertesLimiteLongueurMax,
											i18n,
											{
												Cg: $elm$core$String$fromInt(b)
											})
										]);
								} else {
									var _v6 = _v3.a;
									var _v7 = _v3.b;
									return _List_Nil;
								}
							}
						case 2:
							var motif = regle.b;
							return _List_fromArray(
								[
									A2(
									$author$project$I18n$Cles$produitsAlertesLimiteMotif,
									i18n,
									{cX: motif})
								]);
						default:
							return _List_Nil;
					}
				},
				champ.hJ));
		var deLaMesure = function () {
			var _v1 = champ.r0;
			if (_v1.$ === 10) {
				var mesure = _v1.a;
				return _List_fromArray(
					[
						A4(
						$author$project$Components$Shared$EditeurDeSchema$Limites$bornes,
						i18n,
						$author$project$Components$Shared$EditeurDeSchema$Limites$unite(champ),
						A2($elm$core$Maybe$map, $elm$core$String$fromFloat, mesure.Cx),
						A2($elm$core$Maybe$map, $elm$core$String$fromFloat, mesure.Cg))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var deLaListe = function () {
			var _v0 = champ.r0;
			if (_v0.$ === 7) {
				var valeurs = _v0.a;
				return _List_fromArray(
					[
						A2(
						$author$project$I18n$Cles$produitsAlertesLimiteListe,
						i18n,
						{
							Ki: A2($elm$core$String$join, ', ', valeurs)
						})
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$filter,
				function (texte) {
					return texte !== '';
				},
				_Utils_ap(
					deLaListe,
					_Utils_ap(deLaMesure, desRegles))));
	});
var $author$project$I18n$Cles$produitsAlertesProduit = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.alertes.produit',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'code',
					$author$project$I18n$Traductions$Chaine(p.vx)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.vx + (' · ' + p.Dj));
	});
var $author$project$I18n$Cles$produitsAlertesValeurNon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.alertes.valeur-non', _List_Nil, 'Non');
};
var $author$project$I18n$Cles$produitsAlertesValeurOui = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.alertes.valeur-oui', _List_Nil, 'Oui');
};
var $author$project$Components$Shared$EditeurDeSchema$Limites$valeurDe = F3(
	function (i18n, champ, valeurs) {
		var _v0 = A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v1) {
						var cle = _v1.a;
						return _Utils_eq(cle, champ.dy);
					},
					valeurs)));
		_v0$5:
		while (true) {
			if (!_v0.$) {
				switch (_v0.a.$) {
					case 1:
						var texte = _v0.a.a;
						return texte;
					case 2:
						var nombre = _v0.a.a;
						return _Utils_ap(
							$elm$core$String$fromFloat(nombre),
							$author$project$Components$Shared$EditeurDeSchema$Limites$unite(champ));
					case 3:
						if (_v0.a.a) {
							return $author$project$I18n$Cles$produitsAlertesValeurOui(i18n);
						} else {
							return $author$project$I18n$Cles$produitsAlertesValeurNon(i18n);
						}
					case 4:
						var textes = _v0.a.a;
						return A2($elm$core$String$join, ', ', textes);
					default:
						break _v0$5;
				}
			} else {
				break _v0$5;
			}
		}
		return '';
	});
var $author$project$I18n$Cles$produitsAlertesVerrouille = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.alertes.verrouille', _List_Nil, 'Fiche verrouillée');
};
var $author$project$I18n$Cles$produitsAlertesVerrouilleRaison = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.alertes.verrouille-raison',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etat',
					$author$project$I18n$Traductions$Chaine(p.gt))
				]),
			'Fiche verrouillée à l’état « ' + (p.gt + ' » : elle ne se corrige plus tant que son verrou n’est pas levé. Ouvrez-la pour changer son état.'));
	});
var $author$project$Components$Produits$Alertes$View$verrou = F2(
	function (i18n, alerte) {
		if (alerte.KB) {
			var raison = A2(
				$author$project$I18n$Cles$produitsAlertesVerrouilleRaison,
				i18n,
				{
					gt: A2($elm$core$Maybe$withDefault, alerte.gt, alerte.yR)
				});
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('verrouillee-raison'),
						$rtfeldman$elm_css$Html$Styled$Attributes$title(raison)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('tag')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsAlertesVerrouille(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('raison')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(raison)
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Produits$Alertes$View$ligne = F2(
	function (i18n, alerte) {
		var nom = (_Utils_eq(alerte.Dj, $elm$core$Maybe$Nothing) ? $elm$core$Basics$always(alerte.vx) : $elm$core$Basics$identity)(
			A2(
				$author$project$I18n$Cles$produitsAlertesProduit,
				i18n,
				{
					vx: alerte.vx,
					Dj: A2($elm$core$Maybe$withDefault, '', alerte.Dj)
				}));
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'cliquable',
							!_Utils_eq(
								$author$project$Components$Produits$Alertes$Model$fiche(alerte),
								$elm$core$Maybe$Nothing)),
							_Utils_Tuple2('verrouillee', alerte.KB)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom-du-produit')
						]),
					function () {
						var _v0 = $author$project$Components$Produits$Alertes$Model$fiche(alerte);
						if (!_v0.$) {
							var reference = _v0.a;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href(
											$author$project$Routes$Route$toString(
												$author$project$Routes$Route$FicheReference(reference)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(nom)
										])),
									A2($author$project$Components$Produits$Alertes$View$verrou, i18n, alerte)
								]);
						} else {
							return _List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(nom),
									A2($author$project$Components$Produits$Alertes$View$verrou, i18n, alerte)
								]);
						}
					}()),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('information')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(alerte.uN.Bl)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('hors-limite')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A3($author$project$Components$Shared$EditeurDeSchema$Limites$valeurDe, i18n, alerte.uN, alerte.Ki))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('limite')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Shared$EditeurDeSchema$Limites$limiteDe, i18n, alerte.uN))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('depuis')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$author$project$Texte$Jour$enFrancais(i18n),
									alerte.xe)))
						]))
				]));
	});
var $author$project$I18n$Cles$produitsAlertesColonneDepuis = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.alertes.colonne-depuis', _List_Nil, 'Depuis le');
};
var $author$project$I18n$Cles$produitsAlertesColonneInformation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.alertes.colonne-information', _List_Nil, 'Information hors limite');
};
var $author$project$I18n$Cles$produitsAlertesColonneLimite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.alertes.colonne-limite', _List_Nil, 'Limite');
};
var $author$project$I18n$Cles$produitsAlertesColonneProduit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.alertes.colonne-produit', _List_Nil, 'Produit');
};
var $author$project$I18n$Cles$produitsAlertesColonneValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.alertes.colonne-valeur', _List_Nil, 'Valeur saisie');
};
var $author$project$Components$Produits$Alertes$View$tableau = F2(
	function (i18n, lues) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$table,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$produitsAlertesColonneProduit(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$produitsAlertesColonneInformation(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$produitsAlertesColonneValeur(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$produitsAlertesColonneLimite(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$produitsAlertesColonneDepuis(i18n))
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$tbody,
							_List_Nil,
							A2(
								$elm$core$List$map,
								$author$project$Components$Produits$Alertes$View$ligne(i18n),
								lues.tb))
						]))
				]));
	});
var $author$project$Components$Produits$Alertes$View$corps = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.n3, model.lV);
		if (_v0.b) {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('alertes-erreur'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsAlertesErreur(i18n))
								])),
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Alertes$Update$Relue)
								]),
							$author$project$I18n$Cles$produitsAlertesReessayer(i18n))
						]))
				]);
		} else {
			if (!_v0.a.$) {
				var lues = _v0.a.a;
				return (!lues.ys) ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('alertes-vide')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsAlertesVideTitre(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsAlertesVideTexte(i18n))
									]))
							]))
					]) : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('alertes')
							]),
						_List_fromArray(
							[
								A3($author$project$Components$Produits$Alertes$View$filtre, i18n, model, lues),
								A2($author$project$Components$Produits$Alertes$View$tableau, i18n, lues),
								A3($author$project$Components$Produits$Alertes$View$pied, i18n, model, lues)
							]))
					]);
			} else {
				var _v1 = _v0.a;
				return _List_Nil;
			}
		}
	});
var $author$project$I18n$Cles$produitsAlertesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.alertes.titre', _List_Nil, 'Alertes');
};
var $author$project$I18n$Cles$produitsAlertesSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.alertes.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' produit non conforme · enregistré, mais non publiable tant qu’il n’est pas corrigé') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' produits non conformes · enregistrés, mais non publiables tant qu’ils ne sont pas corrigés'));
	});
var $author$project$I18n$Cles$produitsAlertesSousTitrePlus = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.alertes.sous-titre-plus',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Au moins ' + (p.w + ' produits non conformes · enregistrés, mais non publiables tant qu’ils ne sont pas corrigés'));
	});
var $author$project$I18n$Cles$produitsAlertesSousTitreVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.alertes.sous-titre-vide', _List_Nil, 'Aucun produit non conforme');
};
var $author$project$Components$Produits$Alertes$View$sousTitre = F2(
	function (i18n, model) {
		var _v0 = model.n3;
		if (!_v0.$) {
			var lues = _v0.a;
			return (!lues.ys) ? $author$project$I18n$Cles$produitsAlertesSousTitreVide(i18n) : (lues.tW ? A2(
				$author$project$I18n$Cles$produitsAlertesSousTitrePlus,
				i18n,
				{
					w: $elm$core$String$fromInt(lues.ys)
				}) : A2(
				$author$project$I18n$Cles$produitsAlertesSousTitre,
				i18n,
				{w: lues.ys}));
		} else {
			return '';
		}
	});
var $author$project$Components$Produits$Alertes$View$view = F4(
	function (i18n, onglets, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'produits-alertes',
			{
				ut: _Utils_eq(model.dZ, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						A2(
							$elm$core$List$cons,
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							A2($author$project$Components$Produits$Alertes$View$corps, i18n, model)))
					]),
				xy: _List_Nil,
				zM: _List_Nil,
				AK: false,
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$Components$Produits$Alertes$View$sousTitre, i18n, model))
									]))
							]),
						zE: _List_fromArray(
							[
								{
								aa: '',
								Dj: $author$project$I18n$Cles$produitsAlertesTitre(i18n)
							}
							]),
						Ef: _List_fromArray(
							[
								$author$project$Components$Shared$Onglets$View$view(onglets)
							]),
						h6: $author$project$I18n$Cles$produitsAlertesTitre(i18n)
					})
			});
	});
var $author$project$I18n$Cles$produitsReferencesCreationPageCeQuOnSaisit = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.creation.page-ce-qu-on-saisit',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'categorie',
					$author$project$I18n$Traductions$Chaine(p.uK))
				]),
			'Ce qu\'on saisit pour « ' + (p.uK + ' »'));
	});
var $author$project$I18n$Cles$produitsReferencesCreationPageCeQuOnSaisitSansNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.page-ce-qu-on-saisit-sans-nom', _List_Nil, 'Ce qu\'on saisit');
};
var $author$project$I18n$Cles$produitsReferencesCreationPageCommuns = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.page-communs', _List_Nil, 'Communs à tout le catalogue');
};
var $author$project$I18n$Cles$produitsReferencesCreationPageCommunsAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.page-communs-aide', _List_Nil, 'Définis une seule fois');
};
var $author$project$I18n$Cles$produitsReferencesCreationPageOuSeRange = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.page-ou-se-range', _List_Nil, '1 · Où se range-t-elle ?');
};
var $author$project$I18n$Cles$produitsReferencesCreationPageSousTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.page-sous-titre', _List_Nil, 'Choisissez où elle se range, étage par étage : chaque choix restreint le suivant. La catégorie décide ensuite des informations à saisir.');
};
var $author$project$I18n$Cles$produitsReferencesCreationTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.titre', _List_Nil, 'Nouvelle référence');
};
var $author$project$I18n$Cles$produitsReferencesCreationValider = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.creation.valider', _List_Nil, 'Créer la référence');
};
var $author$project$I18n$Cles$produitsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.titre', _List_Nil, 'Produits');
};
var $author$project$Components$Produits$Catalogue$View$pageDeCreation = F3(
	function (i18n, model, catalogue) {
		var parties = A3($author$project$Components$Produits$Catalogue$View$formulaire, i18n, model, catalogue);
		var nomDeLaCategorie = A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Dj;
				},
				function ($) {
					return $.zX;
				}),
			A2(
				$elm$core$Maybe$andThen,
				function (schema) {
					return $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(schema.r0)),
							catalogue.ib));
				},
				model.hP.aN));
		var actif = (!$author$project$Components$Produits$Common$Envoi$enCours(model.l2)) && (_Utils_eq(
			$author$project$Components$Produits$Catalogue$Creation$etageManquant(model.hP),
			$elm$core$Maybe$Nothing) && (!A2($author$project$Components$Produits$Catalogue$Creation$schemaEnAttente, catalogue, model.hP)));
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'produits-reference-creer',
			{
				ut: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('deux-colonnes')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$section,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('rangement')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$h2,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$produitsReferencesCreationPageOuSeRange(i18n))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer-content')
											]),
										A2(
											$elm$core$List$map,
											$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Produits$Catalogue$Update$Saisi),
											parties.hA))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$section,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('saisie')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$h2,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												function () {
													if (!nomDeLaCategorie.$) {
														var nom = nomDeLaCategorie.a;
														return A2(
															$author$project$I18n$Cles$produitsReferencesCreationPageCeQuOnSaisit,
															i18n,
															{uK: nom});
													} else {
														return $author$project$I18n$Cles$produitsReferencesCreationPageCeQuOnSaisitSansNom(i18n);
													}
												}())
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('bloc'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('communs')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('en-tete')
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$strong,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$produitsReferencesCreationPageCommuns(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$produitsReferencesCreationPageCommunsAide(i18n))
															]))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer-content')
													]),
												A2(
													$elm$core$List$map,
													$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Produits$Catalogue$Update$Saisi),
													parties.fT))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer-content')
											]),
										A2(
											$elm$core$List$map,
											$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Produits$Catalogue$Update$Saisi),
											A3($author$project$Components$Produits$Catalogue$View$informationsDuType, i18n, model, catalogue)))
									]))
							]))
					]),
				xy: _List_Nil,
				zM: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('secondary'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Produits$Catalogue$Update$DuDrawer($author$project$Components$Shared$Drawer$Update$Fermer))
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$drawerAnnuler(i18n))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('primary'),
										$rtfeldman$elm_css$Html$Styled$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'loading',
												$author$project$Components$Produits$Common$Envoi$enCours(model.l2))
											])),
										$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!actif),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Catalogue$Update$CreationDemandee)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$produitsReferencesCreationValider(i18n))
											]))
									]))
							]))
					]),
				AK: false,
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('sous-titre')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsReferencesCreationPageSousTitre(i18n))
									]))
							]),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adresseCatalogue,
								Dj: $author$project$I18n$Cles$produitsTitre(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$produitsReferencesCreationTitre(i18n)
					})
			});
	});
var $author$project$Components$Produits$Catalogue$Update$DeLaListe = function (a) {
	return {$: 6, a: a};
};
var $author$project$I18n$Cles$produitsReferencesARangerAcces = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.a-ranger.acces',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w)),
					_Utils_Tuple2(
					'typologie',
					$author$project$I18n$Traductions$Chaine(p.r3))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' référence à ranger dans ' + p.r3)) : (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' références à ranger dans ' + p.r3)));
	});
var $author$project$Components$Produits$Catalogue$View$accesARanger = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('acces-a-ranger')
				]),
			function () {
				var _v0 = model.jB;
				if (!_v0.$) {
					var catalogue = _v0.a;
					return _Utils_eq(
						A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$referencesARanger, catalogue.gF),
						$elm$core$Maybe$Nothing) ? _List_Nil : A2(
						$elm$core$List$filterMap,
						function (typologie) {
							return A2(
								$elm$core$Maybe$andThen,
								function (nombre) {
									return (nombre > 0) ? $elm$core$Maybe$Just(
										A2(
											$rtfeldman$elm_css$Html$Styled$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$href(
													$author$project$Routes$Route$adresseARanger(typologie.Aq)),
													$rtfeldman$elm_css$Html$Styled$Attributes$class('a-ranger')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$author$project$I18n$Cles$produitsReferencesARangerAcces,
														i18n,
														{w: nombre, r3: typologie.Dj}))
												]))) : $elm$core$Maybe$Nothing;
								},
								A2(
									$elm$core$Maybe$map,
									$elm$core$Tuple$second,
									$elm$core$List$head(
										A2(
											$elm$core$List$filter,
											A2(
												$elm$core$Basics$composeR,
												$elm$core$Tuple$first,
												$elm$core$Basics$eq(typologie.Aq)),
											model.ha))));
						},
						model.r7);
				} else {
					return _List_Nil;
				}
			}());
	});
var $author$project$Components$Produits$Catalogue$Update$RangementDemande = {$: 45};
var $author$project$I18n$Cles$produitsReferencesRangerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.ranger.titre', _List_Nil, 'Ranger la référence');
};
var $author$project$I18n$Cles$produitsReferencesRangerValider = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.ranger.valider', _List_Nil, 'Ranger');
};
var $author$project$I18n$Cles$produitsReferencesRangerAide = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.ranger.aide',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'categorie',
					$author$project$I18n$Traductions$Chaine(p.uK))
				]),
			'Choisissez sa place, étage par étage. Sa catégorie, « ' + (p.uK + ' », ne change pas : elle décide de ce qui est saisi.'));
	});
var $author$project$Components$Produits$Catalogue$View$volet = F4(
	function (i18n, model, catalogue, reference) {
		return A2(
			$elm$core$List$cons,
			A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$produitsReferencesRangerAide,
							i18n,
							{
								uK: A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.Dj;
											},
											function ($) {
												return $.zX;
											}),
										$elm$core$List$head(
											A2(
												$elm$core$List$filter,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.Aq;
													},
													$elm$core$Basics$eq(reference.fh)),
												catalogue.ib))))
							}))
					])),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Components$Shared$Messages$View$view,
					i18n,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Maybe$map, $elm$core$List$singleton, model.hP.pZ))),
				A4($author$project$Components$Produits$Catalogue$View$rangementDe, i18n, true, model, catalogue)));
	});
var $author$project$Components$Produits$Catalogue$View$creation = F2(
	function (i18n, model) {
		var ferme = {
			fs: {sR: false, Bl: '', C$: $author$project$Components$Produits$Catalogue$Update$CreationDemandee},
			fZ: _List_Nil,
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: $author$project$I18n$Cles$produitsReferencesCreationTitre(i18n)
		};
		var contenu = function () {
			var _v0 = _Utils_Tuple2(
				$author$project$Components$Produits$Catalogue$Model$creable(model),
				model.hA);
			if (!_v0.a.$) {
				if (!_v0.b.$) {
					var catalogue = _v0.a.a;
					var reference = _v0.b.a;
					return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) ? {
						fs: {
							sR: (!$author$project$Components$Produits$Common$Envoi$enCours(model.l2)) && A2(
								$elm$core$Maybe$withDefault,
								false,
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.jK;
										},
										$author$project$Catalogue$Chemin$complet),
									model.hP.r3)),
							Bl: $author$project$I18n$Cles$produitsReferencesRangerValider(i18n),
							C$: $author$project$Components$Produits$Catalogue$Update$RangementDemande
						},
						fZ: A2(
							$elm$core$List$map,
							$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Produits$Catalogue$Update$Saisi),
							A4($author$project$Components$Produits$Catalogue$View$volet, i18n, model, catalogue, reference)),
						A6: $elm$core$Maybe$Just(reference.vx + (' · ' + reference.Gp.zX)),
						Bc: false,
						h6: $author$project$I18n$Cles$produitsReferencesRangerTitre(i18n)
					} : ferme;
				} else {
					var _v1 = _v0.b;
					return ferme;
				}
			} else {
				var _v2 = _v0.a;
				return ferme;
			}
		}();
		return A4($author$project$Components$Shared$Drawer$View$view, i18n, $author$project$Components$Produits$Catalogue$Update$DuDrawer, contenu, model.kX);
	});
var $author$project$Components$Produits$Catalogue$Update$NouvelleReferenceDemandee = {$: 30};
var $author$project$I18n$Cles$produitsReferencesImporter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.importer', _List_Nil, 'Importer');
};
var $author$project$Components$Produits$Catalogue$View$boutonDImport = F2(
	function (i18n, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (lien) {
					return _List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Bouton$View$lien,
							1,
							A2(
								$author$project$Routes$Route$adresseImporterAvec,
								A2($author$project$API$Liens$parametre, 'domaine', lien),
								A2($author$project$API$Liens$parametre, 'type', lien)),
							$author$project$I18n$Cles$produitsReferencesImporter(i18n))
						]);
				},
				A2(
					$elm$core$Maybe$andThen,
					function (liste) {
						return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$importer, liste.nQ.h0);
					},
					model.bh)));
	});
var $author$project$Components$Produits$Catalogue$Update$LotOuvert = {$: 47};
var $author$project$I18n$Cles$produitsCatalogueLotDebrayer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.lot.debrayer', _List_Nil, 'Débrayer le recalcul d\'un lot');
};
var $author$project$Components$Produits$Catalogue$View$boutonDuLot = F2(
	function (i18n, model) {
		var _v0 = A2($elm$core$Maybe$andThen, $author$project$Components$Produits$Catalogue$Lot$ouvrir, model.bh);
		if (!_v0.$) {
			return _List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Catalogue$Model$idDuLot),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Catalogue$Update$LotOuvert),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'dialog')
						]),
					$author$project$I18n$Cles$produitsCatalogueLotDebrayer(i18n))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Produits$Catalogue$View$creation_ = F2(
	function (i18n, model) {
		return _Utils_ap(
			function () {
				var _v0 = A2($elm$core$Maybe$andThen, $author$project$Components$Produits$Catalogue$Model$creation, model.jB);
				if (!_v0.$) {
					return _List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							0,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Catalogue$Model$idDeLaCreation),
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Catalogue$Update$NouvelleReferenceDemandee)
								]),
							$author$project$I18n$Cles$produitsReferencesCreationTitre(i18n))
						]);
				} else {
					return _List_Nil;
				}
			}(),
			_Utils_ap(
				A2($author$project$Components$Produits$Catalogue$View$boutonDImport, i18n, model),
				A2($author$project$Components$Produits$Catalogue$View$boutonDuLot, i18n, model)));
	});
var $author$project$Components$Produits$Catalogue$Update$ColonnesDemandees = {$: 20};
var $author$project$Components$Produits$Catalogue$Update$PageDemandee = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Shared$Annuaire$View$RechercheTenue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$Catalogue$Update$TailleDemandee = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Produits$Catalogue$Update$TermeSaisi = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Produits$Catalogue$Update$ArchivageDeLaSelectionDemande = {$: 13};
var $author$project$I18n$Cles$produitsReferencesArchivageSelection = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.archivage.selection', _List_Nil, 'Archiver / migrer');
};
var $author$project$Components$Produits$Catalogue$View$actionsSurLaSelection = F2(
	function (i18n, model) {
		var _v0 = $author$project$Components$Produits$Catalogue$Model$archivageDeLaSelection(model);
		switch (_v0.$) {
			case 1:
				return _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						0,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('archiver-la-selection'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Catalogue$Update$ArchivageDeLaSelectionDemande)
							]),
						$author$project$I18n$Cles$produitsReferencesArchivageSelection(i18n))
					]);
			case 2:
				return _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						0,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('archiver-la-selection'),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-disabled', 'true')
							]),
						$author$project$I18n$Cles$produitsReferencesArchivageSelection(i18n))
					]);
			default:
				return _List_Nil;
		}
	});
var $author$project$I18n$Cles$produitsReferencesListeCompletudeTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.liste.completude.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'remplis',
					$author$project$I18n$Traductions$Chaine(p.HB)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			p.HB + (' critères sur ' + p.JE));
	});
var $author$project$I18n$Cles$produitsReferencesListeCompletudeValeur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.liste.completude.valeur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'remplis',
					$author$project$I18n$Traductions$Chaine(p.HB)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			p.HB + (' / ' + p.JE));
	});
var $author$project$Components$Produits$Catalogue$View$barreDeCompletude = F2(
	function (i18n, completude) {
		if (completude.$ === 1) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var remplis = completude.a.HB;
			var total = completude.a.JE;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('completude-barre'),
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'complete',
								_Utils_cmp(remplis, total) > -1)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$progress,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('barre'),
								$rtfeldman$elm_css$Html$Styled$Attributes$max(
								$elm$core$String$fromInt(total)),
								$rtfeldman$elm_css$Html$Styled$Attributes$value(
								$elm$core$String$fromInt(remplis)),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-label',
								A2(
									$author$project$I18n$Cles$produitsReferencesListeCompletudeTitre,
									i18n,
									{
										HB: $elm$core$String$fromInt(remplis),
										JE: $elm$core$String$fromInt(total)
									}))
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$produitsReferencesListeCompletudeValeur,
									i18n,
									{
										HB: $elm$core$String$fromInt(remplis),
										JE: $elm$core$String$fromInt(total)
									}))
							]))
					]));
		}
	});
var $author$project$Components$Shared$Tableau$View$colonneDeTexte = function (colonne) {
	return {
		uM: function (entree) {
			return $rtfeldman$elm_css$Html$Styled$text(
				colonne.fm(entree));
		},
		f5: colonne.f5,
		Aq: colonne.Aq,
		Bl: colonne.Bl,
		he: false
	};
};
var $author$project$Components$Shared$Tableau$View$colonneDuTitre = F2(
	function (id, libelle) {
		return {
			uM: function (entree) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$a,
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$class('title'),
						$author$project$Components$Shared$Cartouche$View$versLaFiche(entree)),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(entree.h6)
						]));
			},
			f5: true,
			Aq: id,
			Bl: libelle,
			he: true
		};
	});
var $author$project$Components$Produits$Catalogue$View$ligneDe = F2(
	function (libelle, entree_) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$eq(libelle)),
						entree_.gL))));
	});
var $author$project$I18n$Cles$produitsReferencesListeColonneCategorie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.colonne.categorie', _List_Nil, 'Catégorie');
};
var $author$project$I18n$Cles$produitsReferencesListeColonneCode = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.colonne.code', _List_Nil, 'Code');
};
var $author$project$I18n$Cles$produitsReferencesListeColonneCompletude = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.colonne.completude', _List_Nil, 'Complétude');
};
var $author$project$I18n$Cles$produitsReferencesListeColonneEtat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.colonne.etat', _List_Nil, 'État');
};
var $author$project$I18n$Cles$produitsReferencesListeColonneGamme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.colonne.gamme', _List_Nil, 'Gamme');
};
var $author$project$I18n$Cles$produitsReferencesListeColonneMarque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.colonne.marque', _List_Nil, 'Marque');
};
var $author$project$I18n$Cles$produitsReferencesListeColonneNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.colonne.nom', _List_Nil, 'Nom');
};
var $author$project$I18n$Cles$produitsReferencesListeColonneTypologie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.colonne.typologie', _List_Nil, 'Typologie');
};
var $author$project$Components$Produits$Catalogue$View$typologieDe = function (entree_) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$eq(5)),
					entree_.ry))));
};
var $author$project$Components$Produits$Catalogue$View$colonnes = F2(
	function (i18n, completudes) {
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Components$Shared$Tableau$View$colonneDuTitre,
				'code',
				$author$project$I18n$Cles$produitsReferencesListeColonneCode(i18n)),
			_Utils_ap(
				A2(
					$elm$core$List$map,
					function (_v0) {
						var id = _v0.a;
						var libelle = _v0.b;
						return $author$project$Components$Shared$Tableau$View$colonneDeTexte(
							{
								f5: true,
								Aq: id,
								Bl: libelle,
								fm: $author$project$Components$Produits$Catalogue$View$ligneDe(libelle)
							});
					},
					_List_fromArray(
						[
							_Utils_Tuple2(
							'nom',
							$author$project$I18n$Cles$produitsReferencesListeColonneNom(i18n)),
							_Utils_Tuple2(
							'colonne-marque',
							$author$project$I18n$Cles$produitsReferencesListeColonneMarque(i18n)),
							_Utils_Tuple2(
							'colonne-gamme',
							$author$project$I18n$Cles$produitsReferencesListeColonneGamme(i18n)),
							_Utils_Tuple2(
							'categorie',
							$author$project$I18n$Cles$produitsReferencesListeColonneCategorie(i18n)),
							_Utils_Tuple2(
							'etat',
							$author$project$I18n$Cles$produitsReferencesListeColonneEtat(i18n))
						])),
				_List_fromArray(
					[
						$author$project$Components$Shared$Tableau$View$colonneDeTexte(
						{
							f5: true,
							Aq: 'typologie',
							Bl: $author$project$I18n$Cles$produitsReferencesListeColonneTypologie(i18n),
							fm: $author$project$Components$Produits$Catalogue$View$typologieDe
						}),
						{
						uM: function (entree_) {
							return A2(
								$author$project$Components$Produits$Catalogue$View$barreDeCompletude,
								i18n,
								A2($elm$core$Dict$get, entree_.Aq, completudes));
						},
						f5: true,
						Aq: 'completude',
						Bl: $author$project$I18n$Cles$produitsReferencesListeColonneCompletude(i18n),
						he: false
					}
					])));
	});
var $author$project$Components$Produits$Catalogue$View$completudesDe = function (cartes) {
	return $elm$core$Dict$fromList(
		A2(
			$elm$core$List$filterMap,
			function (carte) {
				return A2(
					$elm$core$Maybe$map,
					function (completude) {
						return _Utils_Tuple2(
							$author$project$Routes$Route$toString(
								$author$project$Routes$Route$FicheReference(carte.Aq)),
							completude);
					},
					carte.fU);
			},
			cartes));
};
var $author$project$I18n$Cles$produitsReferencesListeCompteur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.liste.compteur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' référence sur ' + p.JE)) : (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' références sur ' + p.JE)));
	});
var $author$project$Components$Produits$Catalogue$View$compteur = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.bh, model.jB);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var liste = _v0.a.a;
			var catalogue = _v0.b.a;
			return A2(
				$author$project$I18n$Cles$produitsReferencesListeCompteur,
				i18n,
				{
					w: liste.JE,
					JE: $elm$core$String$fromInt(catalogue.rJ.hD)
				});
		} else {
			return '';
		}
	});
var $author$project$Components$Produits$Common$Facettes$nomDe = F2(
	function (options, id) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Traductions$tel(id),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Dj;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(id)),
						options))));
	});
var $author$project$I18n$Cles$produitsReferencesCarteArretee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.carte.arretee', _List_Nil, 'Arrêtée');
};
var $author$project$I18n$Cles$produitsReferencesCarteCompletude = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.carte.completude',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'remplis',
					$author$project$I18n$Traductions$Chaine(p.HB)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			p.HB + (' sur ' + p.JE));
	});
var $author$project$I18n$Cles$produitsPublicationBrouillon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.publication.brouillon', _List_Nil, 'Brouillon');
};
var $author$project$I18n$Cles$produitsPublicationPubliee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.publication.publiee', _List_Nil, 'Publiée');
};
var $author$project$I18n$Cles$produitsPublicationValidee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.publication.validee', _List_Nil, 'Validée');
};
var $author$project$Components$Produits$Catalogue$View$publication = F2(
	function (i18n, code) {
		switch (code) {
			case 'publiee':
				return _Utils_Tuple2(
					0,
					$author$project$I18n$Cles$produitsPublicationPubliee(i18n));
			case 'validee':
				return _Utils_Tuple2(
					4,
					$author$project$I18n$Cles$produitsPublicationValidee(i18n));
			case 'brouillon':
				return _Utils_Tuple2(
					3,
					$author$project$I18n$Cles$produitsPublicationBrouillon(i18n));
			default:
				var autre = code;
				return _Utils_Tuple2(3, autre);
		}
	});
var $author$project$Components$Produits$Catalogue$View$entree = F4(
	function (i18n, catalogue, facettes, carte) {
		var adresse = $author$project$Routes$Route$toString(
			$author$project$Routes$Route$FicheReference(carte.Aq));
		var absent = $author$project$I18n$Cles$produitsCatalogueInfoSansValeur(i18n);
		var nomDe_ = F2(
			function (options, id) {
				return A2(
					$elm$core$Maybe$withDefault,
					absent,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Catalogue$Identifiants$elementIdToString,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Components$Produits$Common$Facettes$nomDe(options),
								$author$project$I18n$Cles$texte(i18n))),
						id));
			});
		return {
			aa: carte.Ex ? $elm$core$Maybe$Just(adresse) : $elm$core$Maybe$Nothing,
			Aq: adresse,
			m9: A2(
				$elm$core$Maybe$map,
				function (completude) {
					return A2(
						$author$project$I18n$Cles$produitsReferencesCarteCompletude,
						i18n,
						{
							HB: $elm$core$String$fromInt(completude.HB),
							JE: $elm$core$String$fromInt(completude.JE)
						});
				},
				carte.fU),
			gL: _List_fromArray(
				[
					function () {
					var _v0 = carte.Dj;
					if (!_v0.$) {
						var nom = _v0.a;
						return _Utils_Tuple2(
							$author$project$I18n$Cles$produitsReferencesListeColonneNom(i18n),
							nom.zX);
					} else {
						return _Utils_Tuple2(
							A2($author$project$Components$Produits$Catalogue$Model$libelleDuProduit, i18n, catalogue),
							A2(
								$elm$core$Maybe$withDefault,
								absent,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.zX;
									},
									carte.Gp)));
					}
				}(),
					_Utils_Tuple2(
					$author$project$I18n$Cles$produitsReferencesListeColonneMarque(i18n),
					A2(nomDe_, facettes.cU, carte.gX)),
					_Utils_Tuple2(
					$author$project$I18n$Cles$produitsReferencesListeColonneGamme(i18n),
					A2(nomDe_, facettes.gG, carte.z3)),
					_Utils_Tuple2(
					$author$project$I18n$Cles$produitsReferencesListeColonneCategorie(i18n),
					A2(
						$elm$core$Maybe$withDefault,
						absent,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.zX;
							},
							carte.uK))),
					_Utils_Tuple2(
					$author$project$I18n$Cles$produitsReferencesListeColonneEtat(i18n),
					A3($author$project$Components$Produits$Catalogue$Model$libelleDeLEtat, i18n, catalogue.mj, carte.gt))
				]),
			ry: A2(
				$elm$core$List$cons,
				A2($author$project$Components$Produits$Catalogue$View$publication, i18n, carte.Gz),
				carte.tL ? _List_fromArray(
					[
						_Utils_Tuple2(
						3,
						$author$project$I18n$Cles$produitsReferencesCarteArretee(i18n))
					]) : _List_Nil),
			rz: A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (typologie) {
						return _List_fromArray(
							[
								_Utils_Tuple2(5, typologie.Dj.zX)
							]);
					},
					carte.r3)),
			h6: carte.vx
		};
	});
var $author$project$Components$Produits$Catalogue$View$facettesDe = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function (catalogue) {
			return A2($author$project$Components$Produits$Common$Facettes$depuis, catalogue, model.r7);
		},
		model.jB);
};
var $author$project$Components$Produits$Catalogue$Model$nomDeLaTypologieDuFiltre = function (model) {
	var _v0 = A2($elm$core$List$filterMap, $author$project$Catalogue$Identifiants$classificationIdFromString, model.kC.r7);
	if (_v0.b && (!_v0.b.b)) {
		var seule = _v0.a;
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.Dj;
					},
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(seule)),
						model.r7))));
	} else {
		return '';
	}
};
var $author$project$Components$Produits$Catalogue$Model$pagePrecedente = function (model) {
	return (model.kC.EE > 1) ? $elm$core$Maybe$Just(model.kC.EE - 1) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$Produits$Catalogue$Model$pageSuivante = function (model) {
	var _v0 = model.bh;
	if (!_v0.$) {
		var liste = _v0.a;
		return (_Utils_cmp(model.kC.EE * model.kC.Jm, liste.JE) < 0) ? $elm$core$Maybe$Just(model.kC.EE + 1) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$Catalogue$Model$tranche = function (model) {
	var _v0 = model.bh;
	if (!_v0.$) {
		var liste = _v0.a;
		return ((!liste.JE) || (_Utils_cmp((model.kC.EE - 1) * model.kC.Jm, liste.JE) > -1)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			_Utils_Tuple2(
				((model.kC.EE - 1) * model.kC.Jm) + 1,
				A2($elm$core$Basics$min, liste.JE, model.kC.EE * model.kC.Jm)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Produits$Catalogue$View$plage = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(
			$author$project$Components$Produits$Catalogue$Model$tranche(model),
			model.bh);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var _v1 = _v0.a.a;
			var debut = _v1.a;
			var fin = _v1.b;
			var liste = _v0.b.a;
			return A2(
				$author$project$I18n$Cles$annuairePaginationPlage,
				i18n,
				{
					ku: $elm$core$String$fromInt(debut),
					mI: $elm$core$String$fromInt(fin),
					JE: $elm$core$String$fromInt(liste.JE)
				});
		} else {
			return '';
		}
	});
var $author$project$I18n$Cles$produitsArchetypeReference = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.archetype.reference', _List_Nil, 'Référence');
};
var $author$project$I18n$Cles$produitsReferencesAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.aucune', _List_Nil, 'Aucune référence ne répond à ces critères.');
};
var $author$project$I18n$Cles$produitsReferencesRecherche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.recherche', _List_Nil, 'Code, produit, variante');
};
var $author$project$I18n$Cles$produitsReferencesSelection = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.selection',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' référence sélectionnée') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' références sélectionnées'));
	});
var $author$project$I18n$Cles$produitsReferencesSelectionCase = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.selection.case',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'code',
					$author$project$I18n$Traductions$Chaine(p.vx))
				]),
			'Sélectionner ' + p.vx);
	});
var $author$project$I18n$Cles$produitsReferencesSelectionDeLaPage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.selection.de-la-page',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' référence de cette page sélectionnée') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' références de cette page sélectionnées'));
	});
var $author$project$I18n$Cles$produitsReferencesSelectionDuFiltre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.selection.du-filtre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? 'La référence du filtre est sélectionnée' : ('Les ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' références du filtre sont sélectionnées')));
	});
var $author$project$I18n$Cles$produitsReferencesSelectionToutLeFiltre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.selection.tout-le-filtre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE)),
					_Utils_Tuple2(
					'typologie',
					$author$project$I18n$Traductions$Chaine(p.r3))
				]),
			'Sélectionner les ' + (p.JE + (' références du filtre « ' + (p.r3 + ' »'))));
	});
var $author$project$I18n$Cles$produitsReferencesArchivageRaison = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.archivage.raison',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Les références choisies sont rangées dans ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' typologie')) : ('Les références choisies sont rangées dans ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' typologies : choisissez-en dans une seule.')));
	});
var $author$project$Components$Produits$Catalogue$View$raisonSurLaSelection = F2(
	function (i18n, model) {
		var _v0 = $author$project$Components$Produits$Catalogue$Model$archivageDeLaSelection(model);
		if (_v0.$ === 2) {
			var nombre = _v0.a;
			return $elm$core$Maybe$Just(
				A2(
					$author$project$I18n$Cles$produitsReferencesArchivageRaison,
					i18n,
					{w: nombre}));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$Catalogue$Update$TriChoisi = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Produits$Catalogue$Update$TriMenuBascule = {$: 16};
var $author$project$I18n$Cles$annuaireTrierOrdre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'annuaire.trier.ordre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'ordre',
					$author$project$I18n$Traductions$Chaine(p.El))
				]),
			'Trier par : ' + p.El);
	});
var $author$project$I18n$Cles$produitsReferencesListeTriCodeDesc = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.tri.code-desc', _List_Nil, 'Code (Z → A)');
};
var $author$project$I18n$Cles$produitsReferencesListeTriEtat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.tri.etat', _List_Nil, 'État (A → Z)');
};
var $author$project$I18n$Cles$produitsReferencesListeTriEtatDesc = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.tri.etat-desc', _List_Nil, 'État (Z → A)');
};
var $author$project$I18n$Cles$produitsReferencesListeTriNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.tri.nom', _List_Nil, 'Nom (A → Z)');
};
var $author$project$I18n$Cles$produitsReferencesListeTriNomDesc = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.tri.nom-desc', _List_Nil, 'Nom (Z → A)');
};
var $author$project$Components$Produits$Catalogue$View$libellesDesOrdres = function (i18n) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'-code',
			$author$project$I18n$Cles$produitsReferencesListeTriCodeDesc(i18n)),
			_Utils_Tuple2(
			'nom',
			$author$project$I18n$Cles$produitsReferencesListeTriNom(i18n)),
			_Utils_Tuple2(
			'-nom',
			$author$project$I18n$Cles$produitsReferencesListeTriNomDesc(i18n)),
			_Utils_Tuple2(
			'etat',
			$author$project$I18n$Cles$produitsReferencesListeTriEtat(i18n)),
			_Utils_Tuple2(
			'-etat',
			$author$project$I18n$Cles$produitsReferencesListeTriEtatDesc(i18n))
		]);
};
var $author$project$I18n$Cles$produitsReferencesListeTriCode = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.tri.code', _List_Nil, 'Code (A → Z)');
};
var $author$project$Components$Produits$Catalogue$View$libelleDeLOrdre = F2(
	function (i18n, ordre) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Cles$produitsReferencesListeTriCode(i18n),
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$eq(ordre)),
						$author$project$Components$Produits$Catalogue$View$libellesDesOrdres(i18n)))));
	});
var $author$project$Components$Produits$Catalogue$Model$ordresProposes = $author$project$Routes$Route$trisDesReferences;
var $author$project$Components$Produits$Catalogue$View$tri = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('toggle-menu'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('tri'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('opened', model.gY)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Catalogue$Model$idDuDeclencheurDuTri),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('toggle'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'menu'),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-expanded',
							model.gY ? 'true' : 'false'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Catalogue$Update$TriMenuBascule)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$annuaireTrierOrdre,
								i18n,
								{
									El: A2($author$project$Components$Produits$Catalogue$View$libelleDeLOrdre, i18n, model.kC.rS)
								}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('menu'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'menu'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-labelledby', $author$project$Components$Produits$Catalogue$Model$idDuDeclencheurDuTri)
						]),
					A2(
						$elm$core$List$map,
						function (ordre) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'none')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$button,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
												$rtfeldman$elm_css$Html$Styled$Attributes$id(
												$author$project$Components$Produits$Catalogue$Model$idDeLOrdre(ordre)),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'menuitemradio'),
												A2(
												$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
												'aria-checked',
												_Utils_eq(ordre, model.kC.rS) ? 'true' : 'false'),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												$author$project$Components$Produits$Catalogue$Update$TriChoisi(ordre))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2($author$project$Components$Produits$Catalogue$View$libelleDeLOrdre, i18n, ordre))
											]))
									]));
						},
						$author$project$Components$Produits$Catalogue$Model$ordresProposes))
				]));
	});
var $author$project$Components$Produits$Catalogue$View$donnees = F2(
	function (i18n, model) {
		var total = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.JE;
				},
				model.bh));
		var facettes = $author$project$Components$Produits$Catalogue$View$facettesDe(model);
		var cartes = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.hD;
				},
				model.bh));
		return {
			sQ: A2($author$project$Components$Produits$Catalogue$View$actionsSurLaSelection, i18n, model),
			ue: true,
			uf: true,
			uh: true,
			ui: false,
			uH: true,
			u7: _Utils_eq(model.bh, $elm$core$Maybe$Nothing),
			vG: A2(
				$author$project$Components$Produits$Catalogue$View$colonnes,
				i18n,
				$author$project$Components$Produits$Catalogue$View$completudesDe(cartes)),
			wl: _List_Nil,
			xs: $author$project$I18n$Cles$annuaireDeselectionner(i18n),
			yt: 'reference-du-catalogue',
			yv: function () {
				var _v0 = _Utils_Tuple2(model.jB, facettes);
				if ((!_v0.a.$) && (!_v0.b.$)) {
					var catalogue = _v0.a.a;
					var lues = _v0.b.a;
					return A2(
						$elm$core$List$map,
						A3($author$project$Components$Produits$Catalogue$View$entree, i18n, catalogue, lues),
						cartes);
				} else {
					return _List_Nil;
				}
			}(),
			mG: _List_Nil,
			R: {
				jA: function (code) {
					return A2(
						$author$project$I18n$Cles$produitsReferencesSelectionCase,
						i18n,
						{vx: code});
				},
				j1: {
					m9: $elm$core$Maybe$Nothing,
					ry: $author$project$I18n$Cles$produitsCatalogueColonneEtat(i18n),
					h6: $author$project$I18n$Cles$produitsArchetypeReference(i18n)
				},
				fV: A2($author$project$Components$Produits$Catalogue$View$compteur, i18n, model),
				hC: $author$project$I18n$Cles$produitsReferencesRecherche(i18n),
				q3: function (nombre) {
					return A2(
						$author$project$I18n$Cles$produitsReferencesSelection,
						i18n,
						{w: nombre});
				},
				q4: function (nombre) {
					return A2(
						$author$project$I18n$Cles$produitsReferencesSelectionDeLaPage,
						i18n,
						{w: nombre});
				},
				q5: function (nombre) {
					return A2(
						$author$project$I18n$Cles$produitsReferencesSelectionDuFiltre,
						i18n,
						{w: nombre});
				},
				rN: $author$project$Components$Produits$Catalogue$Model$selectionDuFiltreOfferte(model) ? A2(
					$author$project$I18n$Cles$produitsReferencesSelectionToutLeFiltre,
					i18n,
					{
						JE: A2(
							$author$project$I18n$Nombre$formater,
							$author$project$I18n$Traductions$langue(i18n),
							total),
						r3: $author$project$Components$Produits$Catalogue$Model$nomDeLaTypologieDuFiltre(model)
					}) : ''
			},
			Cs: ((!_Utils_eq(model.bh, $elm$core$Maybe$Nothing)) && $elm$core$List$isEmpty(cartes)) ? _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsReferencesAucune(i18n))
						]))
				]) : _List_Nil,
			EB: $elm$core$Maybe$Just($author$project$Components$Produits$Catalogue$Update$ColonnesDemandees),
			EH: $author$project$Components$Shared$Annuaire$View$PaginationAvecPlage(
				{
					FQ: A2($author$project$Components$Produits$Catalogue$View$plage, i18n, model),
					Gc: A2(
						$elm$core$Maybe$map,
						$author$project$Components$Produits$Catalogue$Update$PageDemandee,
						$author$project$Components$Produits$Catalogue$Model$pagePrecedente(model)),
					I7: A2(
						$elm$core$Maybe$map,
						$author$project$Components$Produits$Catalogue$Update$PageDemandee,
						$author$project$Components$Produits$Catalogue$Model$pageSuivante(model)),
					Jf: $author$project$Components$Produits$Catalogue$Update$TailleDemandee,
					Jm: model.kC.Jm,
					Jo: $author$project$Routes$Route$taillesPermises
				}),
			GS: A2($author$project$Components$Produits$Catalogue$View$raisonSurLaSelection, i18n, model),
			hC: $author$project$Components$Shared$Annuaire$View$RechercheTenue(
				{hg: $author$project$Components$Produits$Catalogue$Update$TermeSaisi, fm: model.h3}),
			Iz: true,
			JE: total,
			rS: _List_fromArray(
				[
					A2($author$project$Components$Produits$Catalogue$View$tri, i18n, model)
				])
		};
	});
var $author$project$Components$Produits$Catalogue$Update$ChampDuLotChoisi = function (a) {
	return {$: 48, a: a};
};
var $author$project$Components$Produits$Catalogue$Update$DuDrawerDuLot = function (a) {
	return {$: 46, a: a};
};
var $author$project$Components$Produits$Catalogue$Update$GesteDuLotChoisi = function (a) {
	return {$: 49, a: a};
};
var $author$project$Components$Produits$Catalogue$Update$LotDemande = {$: 51};
var $author$project$Components$Produits$Catalogue$Lot$concernees = F2(
	function (voulu, comptes) {
		return (voulu === 'rebrancher') ? comptes.wF : (comptes.hD - comptes.wF);
	});
var $author$project$I18n$Cles$produitsCatalogueLotChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.lot.champ', _List_Nil, 'Champ');
};
var $author$project$I18n$Cles$produitsCatalogueLotConcernees = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.lot.concernees',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' référence concernée') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' références concernées'));
	});
var $author$project$I18n$Cles$produitsCatalogueLotDejaDebrayees = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.lot.deja-debrayees',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' est déjà débrayée et ne bouge pas.') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' sont déjà débrayées et ne bougent pas.'));
	});
var $author$project$I18n$Cles$produitsCatalogueLotDroit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.lot.droit', _List_Nil, 'Droit « Débrayer le recalcul »');
};
var $author$project$I18n$Cles$produitsCatalogueLotGeste = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.lot.geste', _List_Nil, 'Geste');
};
var $author$project$I18n$Cles$produitsCatalogueLotGesteDebrayer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.lot.geste-debrayer', _List_Nil, 'Débrayer');
};
var $author$project$I18n$Cles$produitsCatalogueLotGesteDebrayerAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.lot.geste-debrayer-aide', _List_Nil, 'les valeurs restent, plus aucun recalcul automatique');
};
var $author$project$I18n$Cles$produitsCatalogueLotGesteRebrancher = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.lot.geste-rebrancher', _List_Nil, 'Rebrancher');
};
var $author$project$I18n$Cles$produitsCatalogueLotGesteRebrancherAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.lot.geste-rebrancher-aide', _List_Nil, 'recalcule et reprend le recalcul');
};
var $author$project$I18n$Cles$produitsCatalogueLotIllisible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.lot.illisible', _List_Nil, 'Le nombre de références n\'a pas pu être lu.');
};
var $author$project$I18n$Cles$produitsCatalogueLotNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.lot.note', _List_Nil, 'Par lots de 1 000, rejouable.');
};
var $author$project$I18n$Cles$produitsCatalogueLotRebrancher = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.lot.rebrancher', _List_Nil, 'Rebrancher');
};
var $author$project$I18n$Cles$produitsCatalogueLotRefus = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.lot.refus', _List_Nil, 'Le geste n\'a pas pu être appliqué aux références de ce type.');
};
var $author$project$I18n$Cles$produitsCatalogueLotSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.lot.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typeDeProduit',
					$author$project$I18n$Traductions$Chaine(p.fh)),
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			p.fh + (' · ' + p.uN));
	});
var $author$project$I18n$Cles$produitsReferencesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.titre', _List_Nil, 'Catalogue');
};
var $author$project$Components$Produits$Catalogue$View$titreDeLaListe = F2(
	function (i18n, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Cles$produitsReferencesTitre(i18n),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.zX;
				},
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.Dp;
					},
					model.bh)));
	});
var $author$project$Components$Produits$Catalogue$View$drawerDuLot = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.bh, model.n0);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var liste = _v0.a.a;
			var lot = _v0.b.a;
			var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.dP);
			var nomDuChamp = A2(
				$elm$core$Maybe$withDefault,
				lot.uN,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Dj;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (c) {
								return _Utils_eq(c.dy, lot.uN);
							},
							liste.uS))));
			var choix = F5(
				function (nom, legende, options, choisi, onChoisir) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$fieldset,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$legend,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(legende)
											]))
									])),
								$author$project$Components$Shared$ChoixEnListe$View$view(
								{
									vd: choisi,
									Bi: legende,
									Dj: _Utils_ap(prefixe, nom),
									Ea: onChoisir,
									o_: options
								})
							]));
				});
			return A6(
				$author$project$Components$Shared$Drawer$View$viewAvecPiedLibreEtSousTitre,
				i18n,
				A2(
					$author$project$I18n$Cles$produitsCatalogueLotSousTitre,
					i18n,
					{
						uN: nomDuChamp,
						fh: A2($author$project$Components$Produits$Catalogue$View$titreDeLaListe, i18n, model)
					}),
				{
					oJ: $elm$core$Maybe$Just(
						$author$project$I18n$Cles$produitsCatalogueLotDroit(i18n)),
					HF: function (attributs) {
						return A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_Utils_ap(
								attributs,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Produits$Catalogue$Update$DuDrawerDuLot($author$project$Components$Shared$Drawer$Update$Fermer))
									])),
							$author$project$I18n$Cles$drawerAnnuler(i18n));
					},
					Jb: _List_Nil
				},
				$author$project$Components$Produits$Catalogue$Update$DuDrawerDuLot,
				{
					fs: {
						sR: (!$author$project$Components$Produits$Common$Envoi$enCours(model.l2)) && (!_Utils_eq(lot.tq, $elm$core$Maybe$Nothing)),
						Bl: (lot.mW === 'rebrancher') ? $author$project$I18n$Cles$produitsCatalogueLotRebrancher(i18n) : $author$project$I18n$Cles$produitsCatalogueLotGesteDebrayer(i18n),
						C$: $author$project$Components$Produits$Catalogue$Update$LotDemande
					},
					fZ: _List_fromArray(
						[
							lot.pZ ? A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('refus'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsCatalogueLotRefus(i18n))
								])) : $rtfeldman$elm_css$Html$Styled$text(''),
							function () {
							var _v1 = liste.uS;
							if (_v1.b && (!_v1.b.b)) {
								var champ = {
									go: $elm$core$Maybe$Nothing,
									Aq: prefixe + '-champ',
									Bl: $author$project$I18n$Cles$produitsCatalogueLotChamp(i18n),
									he: false
								};
								return A2(
									$author$project$Components$Shared$Champ$View$compose,
									champ,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$input,
											A2(
												$elm$core$List$cons,
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
												A2(
													$elm$core$List$cons,
													$rtfeldman$elm_css$Html$Styled$Attributes$value(nomDuChamp),
													A2(
														$elm$core$List$cons,
														$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true),
														$author$project$Components$Shared$Champ$View$attributs(champ)))),
											_List_Nil)
										]));
							} else {
								return A5(
									choix,
									'-champ',
									$author$project$I18n$Cles$produitsCatalogueLotChamp(i18n),
									A2(
										$elm$core$List$map,
										function (c) {
											return {bp: '', vx: c.dy, Bl: c.Dj};
										},
										liste.uS),
									lot.uN,
									$author$project$Components$Produits$Catalogue$Update$ChampDuLotChoisi);
							}
						}(),
							A5(
							choix,
							'-geste',
							$author$project$I18n$Cles$produitsCatalogueLotGeste(i18n),
							_List_fromArray(
								[
									{
									bp: $author$project$I18n$Cles$produitsCatalogueLotGesteDebrayerAide(i18n),
									vx: 'debrayer',
									Bl: $author$project$I18n$Cles$produitsCatalogueLotGesteDebrayer(i18n)
								},
									{
									bp: $author$project$I18n$Cles$produitsCatalogueLotGesteRebrancherAide(i18n),
									vx: 'rebrancher',
									Bl: $author$project$I18n$Cles$produitsCatalogueLotGesteRebrancher(i18n)
								}
								]),
							lot.mW,
							$author$project$Components$Produits$Catalogue$Update$GesteDuLotChoisi),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu-du-lot')
								]),
							function () {
								var _v2 = lot.tq;
								if (!_v2.$) {
									var comptes = _v2.a;
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$strong,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$author$project$I18n$Cles$produitsCatalogueLotConcernees,
														i18n,
														{
															d: A2($author$project$Components$Produits$Catalogue$Lot$concernees, lot.mW, comptes)
														}))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$author$project$I18n$Cles$produitsCatalogueLotDejaDebrayees,
														i18n,
														{d: comptes.wF}) + (' ' + $author$project$I18n$Cles$produitsCatalogueLotNote(i18n)))
												]))
										]);
								} else {
									return lot.Ax ? _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$produitsCatalogueLotIllisible(i18n))
												]))
										]) : _List_Nil;
								}
							}())
						]),
					A6: $elm$core$Maybe$Nothing,
					Bc: false,
					h6: $author$project$I18n$Cles$produitsCatalogueLotDebrayer(i18n)
				},
				model.dP);
		} else {
			return A4(
				$author$project$Components$Shared$Drawer$View$view,
				i18n,
				$author$project$Components$Produits$Catalogue$Update$DuDrawerDuLot,
				{
					fs: {sR: false, Bl: '', C$: $author$project$Components$Produits$Catalogue$Update$LotDemande},
					fZ: _List_Nil,
					A6: $elm$core$Maybe$Nothing,
					Bc: false,
					h6: ''
				},
				model.dP);
		}
	});
var $author$project$Catalogue$Chemin$designations = function (_v0) {
	var etages = _v0.a;
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.xt;
		},
		etages);
};
var $author$project$I18n$Cles$produitsReferencesArbreSeparateur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.arbre.separateur', _List_Nil, ' › ');
};
var $author$project$Components$Produits$Catalogue$View$etagesDesTypologies = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('etages-des-typologies')
				]),
			A2(
				$elm$core$List$map,
				function (typologie) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('etages')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(typologie.Dj)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('chemin')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$elm$core$String$join,
											$author$project$I18n$Cles$produitsReferencesArbreSeparateur(i18n),
											A2(
												$elm$core$List$map,
												$author$project$I18n$Cles$texte(i18n),
												$author$project$Catalogue$Chemin$designations(typologie.jK))))
									]))
							]));
				},
				A2(
					$elm$core$List$filterMap,
					function (code) {
						return $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (typologie) {
									return _Utils_eq(
										$author$project$Catalogue$Identifiants$classificationIdToString(typologie.Aq),
										code);
								},
								model.r7));
					},
					model.kC.r7)));
	});
var $author$project$Components$Produits$Catalogue$Update$FiltresEffaces = {$: 14};
var $author$project$I18n$Cles$annuaireFiltreActif = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'annuaire.filtre.actif',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'filtre',
					$author$project$I18n$Traductions$Chaine(p.zH)),
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			p.zH + (' : ' + p.fm));
	});
var $author$project$I18n$Cles$annuaireFiltreRetirer = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'annuaire.filtre.retirer',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'filtre',
					$author$project$I18n$Traductions$Chaine(p.zH))
				]),
			'Retirer le filtre ' + p.zH);
	});
var $author$project$I18n$Cles$annuaireFiltresToutEffacer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'annuaire.filtres.tout-effacer', _List_Nil, 'Tout effacer');
};
var $author$project$Components$Produits$Catalogue$Update$ArreteesBascule = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Produits$Catalogue$Update$CompletudeChoisie = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Produits$Catalogue$Update$FiltreBascule = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$Produits$Catalogue$Update$ParCategorie = {$: 5};
var $author$project$Components$Produits$Catalogue$Update$ParEtat = {$: 0};
var $author$project$Components$Produits$Catalogue$Update$ParFamille = {$: 4};
var $author$project$Components$Produits$Catalogue$Update$ParGamme = {$: 2};
var $author$project$Components$Produits$Catalogue$Update$ParMarque = {$: 1};
var $author$project$Components$Produits$Catalogue$Update$ParTypologie = {$: 3};
var $author$project$I18n$Cles$produitsReferencesListeCompletudeCompletes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.completude.completes', _List_Nil, 'Complètes');
};
var $author$project$I18n$Cles$produitsReferencesListeCompletudeIncompletes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.completude.incompletes', _List_Nil, 'Incomplètes');
};
var $author$project$Components$Produits$Catalogue$View$libelleDeLaCompletude = F2(
	function (i18n, code) {
		return (code === 'completes') ? $author$project$I18n$Cles$produitsReferencesListeCompletudeCompletes(i18n) : $author$project$I18n$Cles$produitsReferencesListeCompletudeIncompletes(i18n);
	});
var $author$project$Components$Produits$Catalogue$Update$ParChamp = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Produits$Catalogue$View$facettesDeChamps = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.mt;
				},
				function ($) {
					return $.dw;
				}),
			model.bh));
};
var $author$project$I18n$Cles$produitsReferencesListeFiltreChampNon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.filtre.champ-non', _List_Nil, 'Non');
};
var $author$project$I18n$Cles$produitsReferencesListeFiltreChampOui = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.filtre.champ-oui', _List_Nil, 'Oui');
};
var $author$project$Components$Produits$Catalogue$View$libelleDeLaValeur = F2(
	function (i18n, valeur) {
		var _v0 = A2($elm$core$Dict$get, 'fr', valeur.R);
		if (!_v0.$) {
			var libelle = _v0.a;
			return libelle;
		} else {
			return (valeur.fm === 'true') ? $author$project$I18n$Cles$produitsReferencesListeFiltreChampOui(i18n) : ((valeur.fm === 'false') ? $author$project$I18n$Cles$produitsReferencesListeFiltreChampNon(i18n) : valeur.fm);
		}
	});
var $author$project$Components$Produits$Catalogue$View$pastillesDesChamps = F2(
	function (i18n, model) {
		return A2(
			$elm$core$List$filterMap,
			function (coche) {
				return A2(
					$elm$core$Maybe$map,
					function (_v0) {
						var cle = _v0.a;
						var code = _v0.b;
						var facette = $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.dy;
									},
									$elm$core$Basics$eq(cle)),
								$author$project$Components$Produits$Catalogue$View$facettesDeChamps(model)));
						return {
							zH: A2(
								$elm$core$Maybe$withDefault,
								cle,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.Bl;
									},
									facette)),
							eW: A2(
								$author$project$Components$Produits$Catalogue$Update$FiltreBascule,
								$author$project$Components$Produits$Catalogue$Update$ParChamp(cle),
								code),
							fm: A2(
								$elm$core$Maybe$withDefault,
								code,
								A2(
									$elm$core$Maybe$map,
									$author$project$Components$Produits$Catalogue$View$libelleDeLaValeur(i18n),
									A2(
										$elm$core$Maybe$andThen,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.Ki;
											},
											A2(
												$elm$core$Basics$composeR,
												$elm$core$List$filter(
													A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.fm;
														},
														$elm$core$Basics$eq(code))),
												$elm$core$List$head)),
										facette)))
						};
					},
					$author$project$Routes$Route$champCoche(coche));
			},
			model.kC.dw);
	});
var $author$project$Components$Produits$Catalogue$Update$GroupeVide = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Produits$Catalogue$Update$ParPlage = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Produits$Catalogue$View$plagesOffertes = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.pn;
			},
			model.bh));
};
var $author$project$I18n$Cles$produitsReferencesListeFiltrePlageAuMoins = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.liste.filtre.plage-au-moins',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'minimum',
					$author$project$I18n$Traductions$Chaine(p.CD)),
					_Utils_Tuple2(
					'unite',
					$author$project$I18n$Traductions$Chaine(p.sa))
				]),
			p.CD + (' ' + (p.sa + ' et plus')));
	});
var $author$project$I18n$Cles$produitsReferencesListeFiltrePlageAuPlus = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.liste.filtre.plage-au-plus',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'maximum',
					$author$project$I18n$Traductions$Chaine(p.Cj)),
					_Utils_Tuple2(
					'unite',
					$author$project$I18n$Traductions$Chaine(p.sa))
				]),
			'jusqu\'à ' + (p.Cj + (' ' + p.sa)));
	});
var $author$project$I18n$Cles$produitsReferencesListeFiltrePlageEntre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.liste.filtre.plage-entre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'minimum',
					$author$project$I18n$Traductions$Chaine(p.CD)),
					_Utils_Tuple2(
					'maximum',
					$author$project$I18n$Traductions$Chaine(p.Cj)),
					_Utils_Tuple2(
					'unite',
					$author$project$I18n$Traductions$Chaine(p.sa))
				]),
			p.CD + (' à ' + (p.Cj + (' ' + p.sa))));
	});
var $author$project$Components$Produits$Catalogue$View$pastillesDesPlages = F2(
	function (i18n, model) {
		return A2(
			$elm$core$List$filterMap,
			function (posee) {
				return A2(
					$elm$core$Maybe$map,
					function (_v0) {
						var cle = _v0.a;
						var _v1 = _v0.b;
						var minimum = _v1.a;
						var maximum = _v1.b;
						var offerte = $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.dy;
									},
									$elm$core$Basics$eq(cle)),
								$author$project$Components$Produits$Catalogue$View$plagesOffertes(model)));
						var unite = A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.sa;
								},
								offerte));
						var nombre = A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$map($elm$core$String$fromFloat),
							$elm$core$Maybe$withDefault(''));
						return {
							zH: A2(
								$elm$core$Maybe$withDefault,
								cle,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.Bl;
									},
									offerte)),
							eW: $author$project$Components$Produits$Catalogue$Update$GroupeVide(
								$author$project$Components$Produits$Catalogue$Update$ParPlage(cle)),
							fm: function () {
								var _v2 = _Utils_Tuple2(minimum, maximum);
								if (!_v2.a.$) {
									if (!_v2.b.$) {
										var bas = _v2.a.a;
										var haut = _v2.b.a;
										return A2(
											$author$project$I18n$Cles$produitsReferencesListeFiltrePlageEntre,
											i18n,
											{
												Cj: nombre(
													$elm$core$Maybe$Just(haut)),
												CD: nombre(
													$elm$core$Maybe$Just(bas)),
												sa: unite
											});
									} else {
										var bas = _v2.a.a;
										var _v3 = _v2.b;
										return A2(
											$author$project$I18n$Cles$produitsReferencesListeFiltrePlageAuMoins,
											i18n,
											{
												CD: nombre(
													$elm$core$Maybe$Just(bas)),
												sa: unite
											});
									}
								} else {
									return A2(
										$author$project$I18n$Cles$produitsReferencesListeFiltrePlageAuPlus,
										i18n,
										{
											Cj: nombre(maximum),
											sa: unite
										});
								}
							}()
						};
					},
					$author$project$Routes$Route$plageLue(posee));
			},
			model.kC.pn);
	});
var $author$project$I18n$Cles$produitsReferencesFiltreArretees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.filtre.arretees', _List_Nil, 'Arrêtées');
};
var $author$project$I18n$Cles$produitsReferencesListeFiltreCategorie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.filtre.categorie', _List_Nil, 'Catégorie');
};
var $author$project$I18n$Cles$produitsReferencesListeFiltreCompletude = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.filtre.completude', _List_Nil, 'Complétude');
};
var $author$project$I18n$Cles$produitsReferencesListeFiltreEtat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.filtre.etat', _List_Nil, 'État');
};
var $author$project$I18n$Cles$produitsReferencesListeFiltreFamille = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.filtre.famille', _List_Nil, 'Famille');
};
var $author$project$I18n$Cles$produitsReferencesListeFiltreGamme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.filtre.gamme', _List_Nil, 'Gamme');
};
var $author$project$I18n$Cles$produitsReferencesListeFiltreMarque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.filtre.marque', _List_Nil, 'Marque');
};
var $author$project$I18n$Cles$produitsReferencesListeFiltreTypologie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.filtre.typologie', _List_Nil, 'Typologie');
};
var $author$project$Components$Produits$Catalogue$View$pastilles = F3(
	function (i18n, model, facettes) {
		var etats = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.mj;
				},
				model.jB));
		var demande = model.kC;
		var deGroupe = F4(
			function (groupe, filtre, options, codes) {
				return A2(
					$elm$core$List$map,
					function (code) {
						return {
							zH: filtre,
							eW: A2($author$project$Components$Produits$Catalogue$Update$FiltreBascule, groupe, code),
							fm: A2(
								$author$project$I18n$Cles$texte,
								i18n,
								A2($author$project$Components$Produits$Common$Facettes$nomDe, options, code))
						};
					},
					codes);
			});
		return _Utils_ap(
			A4(
				deGroupe,
				$author$project$Components$Produits$Catalogue$Update$ParTypologie,
				$author$project$I18n$Cles$produitsReferencesListeFiltreTypologie(i18n),
				facettes.r7,
				demande.r7),
			_Utils_ap(
				A4(
					deGroupe,
					$author$project$Components$Produits$Catalogue$Update$ParMarque,
					$author$project$I18n$Cles$produitsReferencesListeFiltreMarque(i18n),
					facettes.cU,
					demande.cU),
				_Utils_ap(
					A4(
						deGroupe,
						$author$project$Components$Produits$Catalogue$Update$ParGamme,
						$author$project$I18n$Cles$produitsReferencesListeFiltreGamme(i18n),
						facettes.gG,
						demande.gG),
					_Utils_ap(
						A4(
							deGroupe,
							$author$project$Components$Produits$Catalogue$Update$ParFamille,
							$author$project$I18n$Cles$produitsReferencesListeFiltreFamille(i18n),
							facettes.mu,
							demande.mu),
						_Utils_ap(
							A4(
								deGroupe,
								$author$project$Components$Produits$Catalogue$Update$ParCategorie,
								$author$project$I18n$Cles$produitsReferencesListeFiltreCategorie(i18n),
								facettes.dt,
								demande.dt),
							_Utils_ap(
								A2($author$project$Components$Produits$Catalogue$View$pastillesDesChamps, i18n, model),
								_Utils_ap(
									A2($author$project$Components$Produits$Catalogue$View$pastillesDesPlages, i18n, model),
									_Utils_ap(
										A2(
											$elm$core$List$map,
											function (code) {
												return {
													zH: $author$project$I18n$Cles$produitsReferencesListeFiltreEtat(i18n),
													eW: A2($author$project$Components$Produits$Catalogue$Update$FiltreBascule, $author$project$Components$Produits$Catalogue$Update$ParEtat, code),
													fm: A2(
														$elm$core$Maybe$withDefault,
														code,
														A2(
															$elm$core$Maybe$map,
															A2($author$project$Components$Produits$Catalogue$Model$libelleDeLEtat, i18n, etats),
															$author$project$Catalogue$Identifiants$etatCodeFromString(code)))
												};
											},
											demande.mj),
										_Utils_ap(
											demande.i2 ? _List_fromArray(
												[
													{
													zH: $author$project$I18n$Cles$produitsReferencesListeFiltreEtat(i18n),
													eW: $author$project$Components$Produits$Catalogue$Update$ArreteesBascule(false),
													fm: $author$project$I18n$Cles$produitsReferencesFiltreArretees(i18n)
												}
												]) : _List_Nil,
											A2(
												$elm$core$Maybe$withDefault,
												_List_Nil,
												A2(
													$elm$core$Maybe$map,
													function (code) {
														return _List_fromArray(
															[
																{
																zH: $author$project$I18n$Cles$produitsReferencesListeFiltreCompletude(i18n),
																eW: $author$project$Components$Produits$Catalogue$Update$CompletudeChoisie($elm$core$Maybe$Nothing),
																fm: A2($author$project$Components$Produits$Catalogue$View$libelleDeLaCompletude, i18n, code)
															}
															]);
													},
													demande.fU)))))))))));
	});
var $author$project$I18n$Cles$produitsReferencesListeFiltresActifs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.filtres.actifs', _List_Nil, 'Filtres actifs');
};
var $author$project$Components$Produits$Catalogue$View$filtresActifs = F3(
	function (i18n, model, facettes) {
		var posees = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Components$Produits$Catalogue$View$pastilles, i18n, model),
				facettes));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('filtres-actifs')
				]),
			$elm$core$List$isEmpty(posees) ? _List_Nil : _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsReferencesListeFiltresActifs(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (pastille) {
							var nom = A2(
								$author$project$I18n$Cles$annuaireFiltreActif,
								i18n,
								{zH: pastille.zH, fm: pastille.fm});
							var retirer = A2(
								$author$project$I18n$Cles$annuaireFiltreRetirer,
								i18n,
								{zH: nom});
							return A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$button,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('filtre-actif'),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', retirer),
												$rtfeldman$elm_css$Html$Styled$Attributes$title(retirer),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(pastille.eW)
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(nom)
													])),
												$author$project$Components$Shared$Svg$svgClose
											]))
									]));
						},
						posees)),
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('tout-effacer'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Catalogue$Update$FiltresEffaces)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$annuaireFiltresToutEffacer(i18n))
								]))
						]))
				]));
	});
var $author$project$Components$Produits$Catalogue$Update$FiltresDemandes = {$: 18};
var $author$project$I18n$Cles$produitsReferencesListeFiltresBouton = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.liste.filtres.bouton',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Filtres (' + (p.w + ')'));
	});
var $author$project$I18n$Cles$produitsReferencesListeFiltresBoutonSans = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.filtres.bouton-sans', _List_Nil, 'Filtres');
};
var $author$project$I18n$Cles$produitsReferencesListeRechercheEtiquette = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.recherche.etiquette', _List_Nil, 'Rechercher');
};
var $author$project$Components$Produits$Catalogue$View$recherche = F2(
	function (i18n, model) {
		var nombre = $author$project$Components$Produits$Catalogue$Model$nombreDeFiltres(model.kC);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('recherche-et-filtres')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('recherche'),
							$rtfeldman$elm_css$Html$Styled$Attributes$for('references-recherche')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsReferencesListeRechercheEtiquette(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('search'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id('references-recherche'),
									$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(
									$author$project$I18n$Cles$produitsReferencesRecherche(i18n)),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									$author$project$I18n$Cles$annuaireRecherche(i18n)),
									$rtfeldman$elm_css$Html$Styled$Attributes$value(model.h3),
									$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Produits$Catalogue$Update$TermeSaisi)
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Catalogue$Model$idDuDeclencheurDeFiltres),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('secondary'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('filtres'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'dialog'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Catalogue$Update$FiltresDemandes)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									(!nombre) ? $author$project$I18n$Cles$produitsReferencesListeFiltresBoutonSans(i18n) : A2(
										$author$project$I18n$Cles$produitsReferencesListeFiltresBouton,
										i18n,
										{
											w: $elm$core$String$fromInt(nombre)
										}))
								]))
						]))
				]));
	});
var $author$project$I18n$Cles$produitsReferencesListeSousTitreMarques = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.liste.sous-titre.marques',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' marque') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' marques'));
	});
var $author$project$I18n$Cles$produitsReferencesListeSousTitreTypologies = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.liste.sous-titre.typologies',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' typologie') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' typologies'));
	});
var $author$project$Components$Produits$Catalogue$View$sousTitre = F2(
	function (i18n, facettes) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (lues) {
					return A2(
						$elm$core$String$join,
						' · ',
						_List_fromArray(
							[
								A2(
								$author$project$I18n$Cles$produitsReferencesListeSousTitreTypologies,
								i18n,
								{
									w: $elm$core$List$length(lues.r7)
								}),
								A2(
								$author$project$I18n$Cles$produitsReferencesListeSousTitreMarques,
								i18n,
								{
									w: $elm$core$List$length(lues.cU)
								})
							]));
				},
				facettes));
	});
var $author$project$I18n$Cles$produitsReferencesListeTotalDuType = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.liste.total-du-type',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Entier(p.d))
				]),
			((!p.d) || (p.d === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' référence') : (A2($author$project$I18n$Nombre$formater, 0, p.d) + ' références'));
	});
var $author$project$Components$Produits$Catalogue$View$totalDuType = F2(
	function (i18n, model) {
		var _v0 = model.bh;
		if (!_v0.$) {
			var liste = _v0.a;
			return _Utils_eq(liste.Dp, $elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('tag')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$produitsReferencesListeTotalDuType,
							i18n,
							{d: liste.JE}))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$jourDansLaPhrase = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'jour.dans-la-phrase',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'jour',
					$author$project$I18n$Traductions$Chaine(p.A_)),
					_Utils_Tuple2(
					'mois',
					$author$project$I18n$Traductions$Chaine(p.CQ))
				]),
			p.A_ + (' ' + p.CQ));
	});
var $author$project$Texte$Jour$enFrancaisCourt = F2(
	function (i18n, jour) {
		var _v0 = A2($author$project$Texte$Jour$lire, $author$project$Texte$Jour$mois, jour);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var quantieme = _v1.a;
			var nom = _v1.b;
			return A2(
				$author$project$I18n$Cles$jourDansLaPhrase,
				i18n,
				{
					A_: quantieme,
					CQ: A2($author$project$I18n$Cles$texte, i18n, nom)
				});
		} else {
			return jour;
		}
	});
var $author$project$I18n$Cles$produitsReferencesListeTuileAffichees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.tuile.affichees', _List_Nil, 'affichées');
};
var $author$project$I18n$Cles$produitsReferencesListeTuileCompletes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.tuile.completes', _List_Nil, 'complètes');
};
var $author$project$I18n$Cles$produitsReferencesListeTuileDerniereModification = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.tuile.derniere-modification', _List_Nil, 'dernière modification');
};
var $author$project$I18n$Cles$produitsReferencesListeTuileIncompletes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.tuile.incompletes', _List_Nil, 'incomplètes');
};
var $author$project$I18n$Cles$produitsReferencesListeTuileReferences = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.tuile.references', _List_Nil, 'références');
};
var $author$project$I18n$Cles$produitsReferencesListeTuilesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.tuiles.titre', _List_Nil, 'Chiffres du catalogue');
};
var $author$project$Components$Shared$Svg$svgHistory = A3(
	$author$project$Components$Shared$Svg$icone,
	'history',
	'M19.396 3L15.5317 3.05291L15.5839 6.89604 M15.586 3.7207C20.0494 5.6645 22.1681 10.8377 20.3168 15.3732C18.445 19.991 13.1794 22.2124 8.56152 20.3304 M14.8467 14.7984L11.6719 12.9011V8.80298',
	_List_fromArray(
		[
			$author$project$Components$Shared$Svg$traceSecondaire('M10.8496 3L10.8414 3.0072M6.52084 4.7541L6.5126 4.76232M3.66444 8.43759L3.65622 8.44479M3.02165 13.047L3.01343 13.0552M4.77526 17.3764L4.76703 17.3836')
		]));
var $author$project$Components$Shared$Svg$svgProducts = A3($author$project$Components$Shared$Svg$icone, 'products', 'M12 3l8 4.3v9.4L12 21l-8-4.3V7.3zM4 7.3l8 4.4 8-4.4M12 11.7V21', _List_Nil);
var $author$project$Components$Shared$Svg$svgWarning = A3($author$project$Components$Shared$Svg$icone, 'warning', 'M12 4l9 16H3zM12 10v4.5M12 17.5v.2', _List_Nil);
var $author$project$Components$Produits$Catalogue$View$idDuTableau = 'main';
var $author$project$Components$Produits$Catalogue$View$tuile = F4(
	function (nom, icone, libelle, valeur) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('tuile'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(nom),
					$rtfeldman$elm_css$Html$Styled$Attributes$href('#' + $author$project$Components$Produits$Catalogue$View$idDuTableau),
					$rtfeldman$elm_css$Html$Styled$Attributes$title(libelle + (' : ' + valeur))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('icone')
						]),
					_List_fromArray(
						[icone])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(valeur)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(libelle)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('suite')
						]),
					_List_fromArray(
						[$author$project$Components$Shared$Svg$svgChevronRight]))
				]));
	});
var $author$project$Components$Produits$Catalogue$View$tuiles = F2(
	function (i18n, model) {
		var servies = function () {
			var _v0 = model.bh;
			if (_v0.$ === 1) {
				return _List_Nil;
			} else {
				var liste = _v0.a;
				var totaux = liste.rJ;
				return _Utils_ap(
					_List_fromArray(
						[
							A4(
							$author$project$Components$Produits$Catalogue$View$tuile,
							'references',
							$author$project$Components$Shared$Svg$svgProducts,
							$author$project$I18n$Cles$produitsReferencesListeTuileReferences(i18n),
							$elm$core$String$fromInt(totaux.hD)),
							A4(
							$author$project$Components$Produits$Catalogue$View$tuile,
							'affichees',
							$author$project$Components$Shared$Svg$svgShowFilters,
							$author$project$I18n$Cles$produitsReferencesListeTuileAffichees(i18n),
							$elm$core$String$fromInt(totaux.dk)),
							A4(
							$author$project$Components$Produits$Catalogue$View$tuile,
							'completes',
							$author$project$Components$Shared$Svg$svgCheck,
							$author$project$I18n$Cles$produitsReferencesListeTuileCompletes(i18n),
							$elm$core$String$fromInt(totaux.vT)),
							A4(
							$author$project$Components$Produits$Catalogue$View$tuile,
							'incompletes',
							$author$project$Components$Shared$Svg$svgWarning,
							$author$project$I18n$Cles$produitsReferencesListeTuileIncompletes(i18n),
							$elm$core$String$fromInt(totaux.AG))
						]),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (jour) {
								return _List_fromArray(
									[
										A4(
										$author$project$Components$Produits$Catalogue$View$tuile,
										'derniere-modification',
										$author$project$Components$Shared$Svg$svgHistory,
										$author$project$I18n$Cles$produitsReferencesListeTuileDerniereModification(i18n),
										A2($author$project$Texte$Jour$enFrancaisCourt, i18n, jour))
									]);
							},
							totaux.xl)));
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$nav,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('tuiles'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					$author$project$I18n$Cles$produitsReferencesListeTuilesTitre(i18n))
				]),
			servies);
	});
var $author$project$Components$Produits$Catalogue$Update$ColonnesAppliquees = {$: 24};
var $author$project$Components$Produits$Catalogue$Update$ColonnesRetablies = {$: 23};
var $author$project$Components$Shared$Drawer$View$filtrage = F4(
	function (i18n, versMsg, contenu, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'opened',
							$author$project$Components$Shared$Drawer$Model$estOuvert(model))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('overlay'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							versMsg($author$project$Components$Shared$Drawer$Update$SortieDemandee))
						]),
					_List_Nil),
					A5(
					$author$project$Components$Shared$Drawer$View$panneau,
					i18n,
					versMsg,
					{
						vl: A2(
							$author$project$Components$Shared$Drawer$Update$clavierDuDrawer,
							{sP: true},
							model),
						fZ: contenu.fZ,
						AK: false,
						A6: $elm$core$Maybe$Nothing,
						aO: $elm$core$Maybe$Nothing,
						h6: contenu.h6
					},
					_List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id(
									$author$project$Components$Shared$Drawer$Model$idAnnuler(model)),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!contenu.q0.sR),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(contenu.q0.C$)
								]),
							contenu.q0.Bl),
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							0,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id(
									$author$project$Components$Shared$Drawer$Model$idAction(model)),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(contenu.fs.C$)
								]),
							contenu.fs.Bl)
						]),
					model)
				]));
	});
var $author$project$Components$Produits$Catalogue$Update$ColonnesBasculee = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Produits$Catalogue$Update$ColonnesDeplacee = F2(
	function (a, b) {
		return {$: 22, a: a, b: b};
	});
var $author$project$Components$Produits$Catalogue$View$libelleDeColonne = F2(
	function (i18n, id) {
		return A2(
			$elm$core$Maybe$withDefault,
			id,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(id)),
						A2($author$project$Components$Produits$Catalogue$View$colonnes, i18n, $elm$core$Dict$empty)))));
	});
var $author$project$I18n$Cles$produitsReferencesListeColonnesDescendre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.liste.colonnes.descendre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Descendre ' + p.Dj);
	});
var $author$project$I18n$Cles$produitsReferencesListeColonnesMonter = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.liste.colonnes.monter',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Monter ' + p.Dj);
	});
var $author$project$Components$Produits$Catalogue$View$ligneDeColonne = F3(
	function (i18n, model, colonne) {
		var libelle = A2($author$project$Components$Produits$Catalogue$View$libelleDeColonne, i18n, colonne);
		var idDeCase = 'colonne-' + colonne;
		var fleche = F4(
			function (sens, message, nom, bord) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class(
							(!sens) ? 'monter' : 'descendre'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(
							_Utils_ap(
								idDeCase,
								$author$project$Components$Shared$Ordre$suffixe(sens))),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(message),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(bord),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', nom),
							$rtfeldman$elm_css$Html$Styled$Attributes$title(nom)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							(!sens) ? '↑' : '↓')
						]));
			});
		var cochees = model.dA;
		var cochee = A2($elm$core$List$member, colonne, cochees);
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('colonne'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('cochee', cochee)
						]))
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$input,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
								$rtfeldman$elm_css$Html$Styled$Attributes$id(idDeCase),
								$rtfeldman$elm_css$Html$Styled$Attributes$checked(cochee),
								$rtfeldman$elm_css$Html$Styled$Events$onCheck(
								function (_v0) {
									return $author$project$Components$Produits$Catalogue$Update$ColonnesBasculee(colonne);
								})
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('nom'),
								$rtfeldman$elm_css$Html$Styled$Attributes$for(idDeCase)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(libelle)
							]))
					]),
				cochee ? _List_fromArray(
					[
						A4(
						fleche,
						0,
						A2($author$project$Components$Produits$Catalogue$Update$ColonnesDeplacee, 0, colonne),
						A2(
							$author$project$I18n$Cles$produitsReferencesListeColonnesMonter,
							i18n,
							{Dj: libelle}),
						_Utils_eq(
							$elm$core$List$head(cochees),
							$elm$core$Maybe$Just(colonne))),
						A4(
						fleche,
						1,
						A2($author$project$Components$Produits$Catalogue$Update$ColonnesDeplacee, 1, colonne),
						A2(
							$author$project$I18n$Cles$produitsReferencesListeColonnesDescendre,
							i18n,
							{Dj: libelle}),
						_Utils_eq(
							$elm$core$List$head(
								$elm$core$List$reverse(cochees)),
							$elm$core$Maybe$Just(colonne)))
					]) : _List_Nil));
	});
var $author$project$I18n$Cles$produitsReferencesListeColonnesCodeToujoursAffichee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.colonnes.code-toujours-affichee', _List_Nil, 'toujours affichée');
};
var $author$project$Components$Produits$Catalogue$View$ligneDuCode = function (i18n) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$li,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('colonne'),
				$rtfeldman$elm_css$Html$Styled$Attributes$class('obligatoire'),
				$rtfeldman$elm_css$Html$Styled$Attributes$class('cochee')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$input,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
						$rtfeldman$elm_css$Html$Styled$Attributes$id('colonne-code'),
						$rtfeldman$elm_css$Html$Styled$Attributes$checked(true),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$label,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('nom'),
						$rtfeldman$elm_css$Html$Styled$Attributes$for('colonne-code')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsReferencesListeColonneCode(i18n))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsReferencesListeColonnesCodeToujoursAffichee(i18n))
					]))
			]));
};
var $author$project$Components$Produits$Catalogue$Model$ordre = function (cochees) {
	var connues = A2(
		$elm$core$List$filter,
		function (colonne) {
			return A2($elm$core$List$member, colonne, $author$project$Components$Produits$Catalogue$Model$colonnesProposees);
		},
		cochees);
	return _Utils_ap(
		connues,
		A2(
			$elm$core$List$filter,
			function (colonne) {
				return !A2($elm$core$List$member, colonne, connues);
			},
			$author$project$Components$Produits$Catalogue$Model$colonnesProposees));
};
var $author$project$I18n$Cles$produitsReferencesListeColonnesAppliquer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.colonnes.appliquer', _List_Nil, 'Appliquer');
};
var $author$project$I18n$Cles$produitsReferencesListeColonnesExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.colonnes.explication', _List_Nil, 'Choisir les colonnes du tableau et leur ordre.');
};
var $author$project$I18n$Cles$produitsReferencesListeColonnesRetablir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.colonnes.retablir', _List_Nil, 'Rétablir par défaut');
};
var $author$project$I18n$Cles$produitsReferencesListeColonnesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.colonnes.titre', _List_Nil, 'Colonnes');
};
var $author$project$Components$Produits$Catalogue$View$voletDesColonnes = F2(
	function (i18n, model) {
		return A4(
			$author$project$Components$Shared$Drawer$View$filtrage,
			i18n,
			$author$project$Components$Produits$Catalogue$Update$VoletColonnesMsg,
			{
				fs: {
					Bl: $author$project$I18n$Cles$produitsReferencesListeColonnesAppliquer(i18n),
					C$: $author$project$Components$Produits$Catalogue$Update$ColonnesAppliquees
				},
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('explication')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsReferencesListeColonnesExplication(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('colonnes-a-choisir')
							]),
						A2(
							$elm$core$List$cons,
							$author$project$Components$Produits$Catalogue$View$ligneDuCode(i18n),
							A2(
								$elm$core$List$map,
								A2($author$project$Components$Produits$Catalogue$View$ligneDeColonne, i18n, model),
								$author$project$Components$Produits$Catalogue$Model$ordre(model.dA))))
					]),
				q0: {
					sR: true,
					Bl: $author$project$I18n$Cles$produitsReferencesListeColonnesRetablir(i18n),
					C$: $author$project$Components$Produits$Catalogue$Update$ColonnesRetablies
				},
				h6: $author$project$I18n$Cles$produitsReferencesListeColonnesTitre(i18n)
			},
			model.$9);
	});
var $author$project$Components$Produits$Catalogue$Model$aDesFiltres = function (demande) {
	return $author$project$Components$Produits$Catalogue$Model$nombreDeFiltres(demande) > 0;
};
var $author$project$Components$Produits$Catalogue$View$arretees = F2(
	function (i18n, posee) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$fieldset,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('cases-a-cocher'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('arretees')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$legend,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsReferencesFiltreArretees(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('valeurs')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('case'),
									$rtfeldman$elm_css$Html$Styled$Attributes$for('filtre-arretees')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$input,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
											$rtfeldman$elm_css$Html$Styled$Attributes$id('filtre-arretees'),
											$rtfeldman$elm_css$Html$Styled$Attributes$checked(posee),
											$rtfeldman$elm_css$Html$Styled$Events$onCheck($author$project$Components$Produits$Catalogue$Update$ArreteesBascule)
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsReferencesFiltreArretees(i18n))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Produits$Catalogue$View$nomDuGroupe = function (groupe) {
	switch (groupe.$) {
		case 0:
			return 'etat';
		case 1:
			return 'marques';
		case 2:
			return 'gammes';
		case 3:
			return 'typologie';
		case 4:
			return 'famille';
		case 5:
			return 'categorie';
		case 6:
			var cle = groupe.a;
			return 'champ-' + cle;
		default:
			var cle = groupe.a;
			return 'plage-' + cle;
	}
};
var $author$project$Components$Produits$Catalogue$View$nombreAffiche = function (nombre) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (n) {
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('nombre')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$String$fromInt(n))
							]))
					]);
			},
			nombre));
};
var $author$project$Components$Produits$Catalogue$View$nombreDe = F2(
	function (nombres, valeur) {
		return A2(
			$elm$core$Maybe$map,
			function (comptees) {
				return A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.w;
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.fm;
									},
									$elm$core$Basics$eq(valeur)),
								comptees))));
			},
			nombres);
	});
var $author$project$Components$Produits$Catalogue$View$cases = F7(
	function (i18n, groupe, legende, options, cochees, note, nombres) {
		return $elm$core$List$isEmpty(options) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A2(
				$rtfeldman$elm_css$Html$Styled$fieldset,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('cases-a-cocher'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						$author$project$Components$Produits$Catalogue$View$nomDuGroupe(groupe))
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$legend,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(legende)
									]))
							])),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('valeurs')
								]),
							A2(
								$elm$core$List$map,
								function (option) {
									var idDeCase = 'filtre-' + ($author$project$Components$Produits$Catalogue$View$nomDuGroupe(groupe) + ('-' + option.Aq));
									return A2(
										$rtfeldman$elm_css$Html$Styled$label,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('case'),
												$rtfeldman$elm_css$Html$Styled$Attributes$for(idDeCase)
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$input,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
														$rtfeldman$elm_css$Html$Styled$Attributes$id(idDeCase),
														$rtfeldman$elm_css$Html$Styled$Attributes$checked(
														A2($elm$core$List$member, option.Aq, cochees)),
														$rtfeldman$elm_css$Html$Styled$Events$onCheck(
														function (_v0) {
															return A2($author$project$Components$Produits$Catalogue$Update$FiltreBascule, groupe, option.Aq);
														})
													]),
												_List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2($author$project$I18n$Cles$texte, i18n, option.Dj))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('nombre-ligne')
													]),
												$author$project$Components$Produits$Catalogue$View$nombreAffiche(
													A2($author$project$Components$Produits$Catalogue$View$nombreDe, nombres, option.Aq)))
											]));
								},
								options)),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (texte) {
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(texte)
												]))
										]);
								},
								note))))));
	});
var $author$project$Components$Produits$Catalogue$View$boutonDeChoix = F4(
	function (pose, libelle, nombre, msg) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('choix-bouton'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-pressed',
					pose ? 'true' : 'false'),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						])),
				$author$project$Components$Produits$Catalogue$View$nombreAffiche(nombre)));
	});
var $author$project$I18n$Cles$produitsReferencesListeToutes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.toutes', _List_Nil, 'Toutes');
};
var $author$project$Components$Produits$Catalogue$View$completudeChoix = F3(
	function (i18n, posee, nombres) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$fieldset,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('boutons-a-choisir'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('completude')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$legend,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsReferencesListeFiltreCompletude(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('choix')
						]),
					_List_fromArray(
						[
							A4(
							$author$project$Components$Produits$Catalogue$View$boutonDeChoix,
							_Utils_eq(posee, $elm$core$Maybe$Nothing),
							$author$project$I18n$Cles$produitsReferencesListeToutes(i18n),
							$elm$core$Maybe$Nothing,
							$author$project$Components$Produits$Catalogue$Update$CompletudeChoisie($elm$core$Maybe$Nothing)),
							A4(
							$author$project$Components$Produits$Catalogue$View$boutonDeChoix,
							_Utils_eq(
								posee,
								$elm$core$Maybe$Just('completes')),
							$author$project$I18n$Cles$produitsReferencesListeCompletudeCompletes(i18n),
							A2($author$project$Components$Produits$Catalogue$View$nombreDe, nombres, 'complete'),
							$author$project$Components$Produits$Catalogue$Update$CompletudeChoisie(
								$elm$core$Maybe$Just('completes'))),
							A4(
							$author$project$Components$Produits$Catalogue$View$boutonDeChoix,
							_Utils_eq(
								posee,
								$elm$core$Maybe$Just('incompletes')),
							$author$project$I18n$Cles$produitsReferencesListeCompletudeIncompletes(i18n),
							A2($author$project$Components$Produits$Catalogue$View$nombreDe, nombres, 'incomplete'),
							$author$project$Components$Produits$Catalogue$Update$CompletudeChoisie(
								$elm$core$Maybe$Just('incompletes')))
						]))
				]));
	});
var $author$project$Components$Produits$Catalogue$View$groupeDeBoutons = F6(
	function (i18n, groupe, legende, options, cochees, nombres) {
		return $elm$core$List$isEmpty(options) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A2(
				$rtfeldman$elm_css$Html$Styled$fieldset,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('boutons-a-choisir'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						$author$project$Components$Produits$Catalogue$View$nomDuGroupe(groupe))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$legend,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(legende)
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('choix')
							]),
						A2(
							$elm$core$List$cons,
							A4(
								$author$project$Components$Produits$Catalogue$View$boutonDeChoix,
								$elm$core$List$isEmpty(cochees),
								$author$project$I18n$Cles$produitsReferencesListeToutes(i18n),
								$elm$core$Maybe$Nothing,
								$author$project$Components$Produits$Catalogue$Update$GroupeVide(groupe)),
							A2(
								$elm$core$List$map,
								function (option) {
									return A4(
										$author$project$Components$Produits$Catalogue$View$boutonDeChoix,
										A2($elm$core$List$member, option.Aq, cochees),
										A2($author$project$I18n$Cles$texte, i18n, option.Dj),
										A2($author$project$Components$Produits$Catalogue$View$nombreDe, nombres, option.Aq),
										A2($author$project$Components$Produits$Catalogue$Update$FiltreBascule, groupe, option.Aq));
								},
								options)))
					])));
	});
var $author$project$Components$Produits$Catalogue$View$nomAvecSonCode = F2(
	function (i18n, valeur) {
		return (valeur.DO && (!$elm$core$Dict$isEmpty(valeur.R))) ? (A2($author$project$Components$Produits$Catalogue$View$libelleDeLaValeur, i18n, valeur) + (' ' + valeur.fm)) : A2($author$project$Components$Produits$Catalogue$View$libelleDeLaValeur, i18n, valeur);
	});
var $author$project$Components$Produits$Catalogue$View$groupesDeChamps = F2(
	function (i18n, model) {
		return A2(
			$elm$core$List$map,
			function (facette) {
				var servies = A2(
					$elm$core$List$map,
					function ($) {
						return $.fm;
					},
					facette.Ki);
				var cochees = A2(
					$elm$core$List$map,
					$elm$core$Tuple$second,
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$eq(facette.dy)),
						A2($elm$core$List$filterMap, $author$project$Routes$Route$champCoche, model.kC.dw)));
				var absentes = A2(
					$elm$core$List$filter,
					function (code) {
						return !A2($elm$core$List$member, code, servies);
					},
					cochees);
				return A7(
					$author$project$Components$Produits$Catalogue$View$cases,
					i18n,
					$author$project$Components$Produits$Catalogue$Update$ParChamp(facette.dy),
					facette.Bl,
					_Utils_ap(
						A2(
							$elm$core$List$map,
							function (valeur) {
								return {
									Aq: valeur.fm,
									Dj: $author$project$I18n$Traductions$tel(
										A2($author$project$Components$Produits$Catalogue$View$nomAvecSonCode, i18n, valeur)),
									hl: _List_Nil
								};
							},
							facette.Ki),
						A2(
							$elm$core$List$map,
							function (code) {
								return {
									Aq: code,
									Dj: $author$project$I18n$Traductions$tel(code),
									hl: _List_Nil
								};
							},
							absentes)),
					cochees,
					$elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(
						A2(
							$elm$core$List$map,
							function (valeur) {
								return {w: valeur.w, fm: valeur.fm};
							},
							facette.Ki)));
			},
			$author$project$Components$Produits$Catalogue$View$facettesDeChamps(model));
	});
var $author$project$Components$Produits$Catalogue$Update$Maximum = 1;
var $author$project$Components$Produits$Catalogue$Update$Minimum = 0;
var $author$project$Components$Produits$Catalogue$Update$PlageSaisie = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$I18n$Cles$produitsReferencesListeFiltrePlageGroupe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.liste.filtre.plage-groupe',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'groupe',
					$author$project$I18n$Traductions$Chaine(p.m2))
				]),
			p.m2 + ' · plage par mesure');
	});
var $author$project$I18n$Cles$produitsReferencesListeFiltrePlageMaximum = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.filtre.plage-maximum', _List_Nil, 'max');
};
var $author$project$I18n$Cles$produitsReferencesListeFiltrePlageMaximumDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.liste.filtre.plage-maximum-de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'mesure',
					$author$project$I18n$Traductions$Chaine(p.Cu))
				]),
			p.Cu + ', maximum');
	});
var $author$project$I18n$Cles$produitsReferencesListeFiltrePlageMesure = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.liste.filtre.plage-mesure',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl)),
					_Utils_Tuple2(
					'unite',
					$author$project$I18n$Traductions$Chaine(p.sa))
				]),
			p.Bl + (' (' + (p.sa + ')')));
	});
var $author$project$I18n$Cles$produitsReferencesListeFiltrePlageMinimum = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.liste.filtre.plage-minimum', _List_Nil, 'min');
};
var $author$project$I18n$Cles$produitsReferencesListeFiltrePlageMinimumDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.liste.filtre.plage-minimum-de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'mesure',
					$author$project$I18n$Traductions$Chaine(p.Cu))
				]),
			p.Cu + ', minimum');
	});
var $author$project$Components$Produits$Catalogue$View$groupesDePlages = F2(
	function (i18n, model) {
		var posees = A2($elm$core$List$filterMap, $author$project$Routes$Route$plageLue, model.kC.pn);
		var groupes = A3(
			$elm$core$List$foldl,
			F2(
				function (offerte, vus) {
					return A2($elm$core$List$member, offerte.m2, vus) ? vus : _Utils_ap(
						vus,
						_List_fromArray(
							[offerte.m2]));
				}),
			_List_Nil,
			$author$project$Components$Produits$Catalogue$View$plagesOffertes(model));
		var borne = F4(
			function (cle, cote, lire, texte) {
				var valeurPosee = A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						$elm$core$String$fromFloat,
						A2(
							$elm$core$Maybe$andThen,
							A2($elm$core$Basics$composeR, $elm$core$Tuple$second, lire),
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Tuple$first,
										$elm$core$Basics$eq(cle)),
									posees)))));
				return A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'inputmode', 'decimal'),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(valeurPosee),
							$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(
							(!cote) ? $author$project$I18n$Cles$produitsReferencesListeFiltrePlageMinimum(i18n) : $author$project$I18n$Cles$produitsReferencesListeFiltrePlageMaximum(i18n)),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', texte),
							$rtfeldman$elm_css$Html$Styled$Attributes$title(texte),
							A2(
							$rtfeldman$elm_css$Html$Styled$Events$on,
							'change',
							A2(
								$elm$json$Json$Decode$map,
								A2($author$project$Components$Produits$Catalogue$Update$PlageSaisie, cle, cote),
								$rtfeldman$elm_css$Html$Styled$Events$targetValue))
						]),
					_List_Nil);
			});
		var mesure = function (offerte) {
			var nom = A2(
				$author$project$I18n$Cles$produitsReferencesListeFiltrePlageMesure,
				i18n,
				{Bl: offerte.Bl, sa: offerte.sa});
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('plage')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(nom)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('bornes')
							]),
						_List_fromArray(
							[
								A4(
								borne,
								offerte.dy,
								0,
								$elm$core$Tuple$first,
								A2(
									$author$project$I18n$Cles$produitsReferencesListeFiltrePlageMinimumDe,
									i18n,
									{Cu: nom})),
								A4(
								borne,
								offerte.dy,
								1,
								$elm$core$Tuple$second,
								A2(
									$author$project$I18n$Cles$produitsReferencesListeFiltrePlageMaximumDe,
									i18n,
									{Cu: nom}))
							]))
					]));
		};
		return A2(
			$elm$core$List$map,
			function (groupe) {
				return $elm$core$Maybe$Just(
					A2(
						$rtfeldman$elm_css$Html$Styled$fieldset,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('plages-de-mesures')
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$rtfeldman$elm_css$Html$Styled$legend,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$produitsReferencesListeFiltrePlageGroupe,
													i18n,
													{m2: groupe}))
											]))
									])),
							A2(
								$elm$core$List$map,
								mesure,
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.m2;
										},
										$elm$core$Basics$eq(groupe)),
									$author$project$Components$Produits$Catalogue$View$plagesOffertes(model))))));
			},
			groupes);
	});
var $author$project$Components$Produits$Catalogue$View$noteDe = F4(
	function (i18n, note, options, cochees) {
		return $elm$core$List$isEmpty(cochees) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			note(
				{
					Ki: A2(
						$elm$core$String$join,
						', ',
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Components$Produits$Common$Facettes$nomDe(options),
								$author$project$I18n$Cles$texte(i18n)),
							cochees))
				}));
	});
var $author$project$I18n$Cles$produitsReferencesListeCategoriesDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.liste.categories-de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeurs',
					$author$project$I18n$Traductions$Chaine(p.Ki))
				]),
			'Catégories de la famille ' + (p.Ki + ' seulement.'));
	});
var $author$project$I18n$Cles$produitsReferencesListeFiltresAfficher = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.liste.filtres.afficher',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Afficher ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' résultat')) : ('Afficher ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' résultats')));
	});
var $author$project$I18n$Cles$produitsReferencesListeGammesDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.liste.gammes-de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeurs',
					$author$project$I18n$Traductions$Chaine(p.Ki))
				]),
			'Gammes ouvertes à ' + (p.Ki + '.'));
	});
var $author$project$Components$Produits$Catalogue$View$voletDesFiltres = F3(
	function (i18n, model, facettes) {
		var total = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.JE;
				},
				model.bh));
		var nombresDe = function (groupe) {
			return A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.mt;
					},
					groupe),
				model.bh);
		};
		var etats = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.mj;
				},
				model.jB));
		var demande = model.kC;
		return A4(
			$author$project$Components$Shared$Drawer$View$filtrage,
			i18n,
			$author$project$Components$Produits$Catalogue$Update$VoletMsg,
			{
				fs: {
					Bl: A2(
						$author$project$I18n$Cles$produitsReferencesListeFiltresAfficher,
						i18n,
						{w: total}),
					C$: $author$project$Components$Produits$Catalogue$Update$VoletMsg($author$project$Components$Shared$Drawer$Update$Fermer)
				},
				fZ: function () {
					if (facettes.$ === 1) {
						return _List_Nil;
					} else {
						var lues = facettes.a;
						return A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_Utils_ap(
								_List_fromArray(
									[
										A6(
										$author$project$Components$Produits$Catalogue$View$groupeDeBoutons,
										i18n,
										$author$project$Components$Produits$Catalogue$Update$ParTypologie,
										$author$project$I18n$Cles$produitsReferencesListeFiltreTypologie(i18n),
										lues.r7,
										demande.r7,
										nombresDe(
											function ($) {
												return $.r7;
											})),
										A7(
										$author$project$Components$Produits$Catalogue$View$cases,
										i18n,
										$author$project$Components$Produits$Catalogue$Update$ParMarque,
										$author$project$I18n$Cles$produitsReferencesListeFiltreMarque(i18n),
										lues.cU,
										demande.cU,
										$elm$core$Maybe$Nothing,
										nombresDe(
											function ($) {
												return $.cU;
											})),
										A7(
										$author$project$Components$Produits$Catalogue$View$cases,
										i18n,
										$author$project$Components$Produits$Catalogue$Update$ParGamme,
										$author$project$I18n$Cles$produitsReferencesListeFiltreGamme(i18n),
										A2($author$project$Components$Produits$Common$Facettes$gammesVisibles, demande.cU, lues),
										demande.gG,
										A4(
											$author$project$Components$Produits$Catalogue$View$noteDe,
											i18n,
											$author$project$I18n$Cles$produitsReferencesListeGammesDe(i18n),
											lues.cU,
											demande.cU),
										nombresDe(
											function ($) {
												return $.gG;
											})),
										A7(
										$author$project$Components$Produits$Catalogue$View$cases,
										i18n,
										$author$project$Components$Produits$Catalogue$Update$ParFamille,
										$author$project$I18n$Cles$produitsReferencesListeFiltreFamille(i18n),
										lues.mu,
										demande.mu,
										$elm$core$Maybe$Nothing,
										nombresDe(
											function ($) {
												return $.mu;
											})),
										A7(
										$author$project$Components$Produits$Catalogue$View$cases,
										i18n,
										$author$project$Components$Produits$Catalogue$Update$ParCategorie,
										$author$project$I18n$Cles$produitsReferencesListeFiltreCategorie(i18n),
										A2($author$project$Components$Produits$Common$Facettes$categoriesVisibles, demande.mu, lues),
										demande.dt,
										A4(
											$author$project$Components$Produits$Catalogue$View$noteDe,
											i18n,
											$author$project$I18n$Cles$produitsReferencesListeCategoriesDe(i18n),
											lues.mu,
											demande.mu),
										nombresDe(
											function ($) {
												return $.dt;
											})),
										A6(
										$author$project$Components$Produits$Catalogue$View$groupeDeBoutons,
										i18n,
										$author$project$Components$Produits$Catalogue$Update$ParEtat,
										$author$project$I18n$Cles$produitsReferencesListeFiltreEtat(i18n),
										A2(
											$elm$core$List$map,
											function (etat) {
												return {
													Aq: $author$project$Catalogue$Identifiants$etatCodeToString(etat.vx),
													Dj: $author$project$I18n$Traductions$tel(
														A3($author$project$Components$Produits$Catalogue$Model$libelleDeLEtat, i18n, etats, etat.vx)),
													hl: _List_Nil
												};
											},
											etats),
										demande.mj,
										nombresDe(
											function ($) {
												return $.mj;
											})),
										$elm$core$Maybe$Just(
										A3(
											$author$project$Components$Produits$Catalogue$View$completudeChoix,
											i18n,
											demande.fU,
											nombresDe(
												function ($) {
													return $.fU;
												})))
									]),
								_Utils_ap(
									A2($author$project$Components$Produits$Catalogue$View$groupesDeChamps, i18n, model),
									_Utils_ap(
										A2($author$project$Components$Produits$Catalogue$View$groupesDePlages, i18n, model),
										_List_fromArray(
											[
												$elm$core$Maybe$Just(
												A2($author$project$Components$Produits$Catalogue$View$arretees, i18n, demande.i2))
											])))));
					}
				}(),
				q0: {
					sR: $author$project$Components$Produits$Catalogue$Model$aDesFiltres(demande),
					Bl: $author$project$I18n$Cles$annuaireFiltresToutEffacer(i18n),
					C$: $author$project$Components$Produits$Catalogue$Update$FiltresEffaces
				},
				h6: $author$project$I18n$Cles$annuaireFiltresTitre(i18n)
			},
			model.im);
	});
var $author$project$Components$Produits$Catalogue$View$viewDeLaListe = F3(
	function (i18n, messages, model) {
		var fournies = A2($author$project$Components$Produits$Catalogue$View$donnees, i18n, model);
		var facettes = $author$project$Components$Produits$Catalogue$View$facettesDe(model);
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'produits-catalogue-list',
			{
				ut: _Utils_eq(model.np, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Produits$Catalogue$View$tuiles, i18n, model),
						A2($author$project$Components$Produits$Catalogue$View$recherche, i18n, model),
						A3($author$project$Components$Produits$Catalogue$View$filtresActifs, i18n, model, facettes),
						A2($author$project$Components$Produits$Catalogue$View$etagesDesTypologies, i18n, model),
						A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						A4($author$project$Components$Shared$Annuaire$View$liste, i18n, $author$project$Components$Produits$Catalogue$Update$DeLaListe, fournies, model.nW))
					]),
				xy: _List_fromArray(
					[
						A3($author$project$Components$Produits$Catalogue$View$voletDesFiltres, i18n, model, facettes),
						A2($author$project$Components$Produits$Catalogue$View$voletDesColonnes, i18n, model),
						A2($author$project$Components$Produits$Catalogue$View$creation, i18n, model),
						A2($author$project$Components$Produits$Catalogue$View$drawerDuLot, i18n, model)
					]),
				zM: _List_Nil,
				AK: $author$project$Components$Produits$Catalogue$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2($author$project$Components$Produits$Catalogue$View$totalDuType, i18n, model),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('sous-titre')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$Components$Produits$Catalogue$View$sousTitre, i18n, facettes))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
									]),
								A2($author$project$Components$Produits$Catalogue$View$creation_, i18n, model)),
								A2($author$project$Components$Produits$Catalogue$View$accesARanger, i18n, model)
							]),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adresseCatalogue,
								Dj: $author$project$I18n$Cles$produitsTitre(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: A2($author$project$Components$Produits$Catalogue$View$titreDeLaListe, i18n, model)
					})
			});
	});
var $author$project$Components$Produits$Catalogue$View$view = F3(
	function (i18n, messages, model) {
		var _v0 = $author$project$Components$Produits$Catalogue$View$enCreation(model);
		if (!_v0.$) {
			var catalogue = _v0.a;
			return A3($author$project$Components$Produits$Catalogue$View$pageDeCreation, i18n, model, catalogue);
		} else {
			return A3($author$project$Components$Produits$Catalogue$View$viewDeLaListe, i18n, messages, model);
		}
	});
var $author$project$Components$Produits$Correspondances$Update$GesteOuvert = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Produits$Correspondances$Update$GesteDemande = {$: 14};
var $author$project$Components$Produits$Correspondances$Model$Retrait = {$: 5};
var $author$project$Components$Produits$Correspondances$Update$ValeurDeDepartChoisie = function (a) {
	return {$: 9, a: a};
};
var $author$project$I18n$Cles$correspondancesCreationValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.creation.valeur', _List_Nil, 'La valeur de départ');
};
var $author$project$Components$Produits$Correspondances$View$choixDeLaValeurListe = F3(
	function (i18n, prefixe, model) {
		return A2(
			$author$project$Components$Shared$Champ$View$liste,
			{
				go: $elm$core$Maybe$Nothing,
				Aq: prefixe + '-valeur',
				Bl: $author$project$I18n$Cles$correspondancesCreationValeur(i18n),
				he: true
			},
			{
				hg: $author$project$Components$Produits$Correspondances$Update$ValeurDeDepartChoisie,
				o_: A2(
					$elm$core$List$map,
					function (v) {
						return {Bl: v.Bl, fm: v.Aq};
					},
					$author$project$Components$Produits$Correspondances$Model$valeursDeDepart(model)),
				fm: model.sg
			});
	});
var $author$project$I18n$Cles$correspondancesCreationValeurAide = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'correspondances.creation.valeur-aide',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'liste',
					$author$project$I18n$Traductions$Chaine(p.nW))
				]),
			'Les valeurs de « ' + (p.nW + ' » qui n\'ont encore aucune ligne.'));
	});
var $author$project$Components$Produits$Correspondances$View$nomDeLaListeDeDepart = function (model) {
	var _v0 = model.zo;
	if (!_v0.$) {
		var fiche = _v0.a;
		return fiche.wg.cx.Bl;
	} else {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Dj;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (liste) {
							return _Utils_eq(liste.Aq, model.dG);
						},
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.n_;
								},
								model.n_))))));
	}
};
var $author$project$Components$Produits$Correspondances$View$choixDeLaValeur = F3(
	function (i18n, prefixe, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur-de-depart')
				]),
			_List_fromArray(
				[
					A3($author$project$Components$Produits$Correspondances$View$choixDeLaValeurListe, i18n, prefixe, model),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$correspondancesCreationValeurAide,
								i18n,
								{
									nW: $author$project$Components$Produits$Correspondances$View$nomDeLaListeDeDepart(model)
								}))
						]))
				]));
	});
var $author$project$Components$Produits$Correspondances$Update$Recherche = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Produits$Correspondances$Update$ValeurBasculee = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$I18n$Cles$correspondancesCreationAssociee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.creation.associee', _List_Nil, 'Associée à');
};
var $author$project$I18n$Cles$correspondancesCreationCompte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'correspondances.creation.compte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'choisies',
					$author$project$I18n$Traductions$Chaine(p.L)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			'(' + (p.L + (' sur ' + (p.JE + ')'))));
	});
var $author$project$I18n$Cles$correspondancesCreationRechercher = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.creation.rechercher', _List_Nil, 'Rechercher une valeur');
};
var $author$project$Components$Produits$Correspondances$Model$cibleDuGeste = function (model) {
	var _v0 = _Utils_Tuple2(model.mW, model.zo);
	if ((!_v0.a.$) && (!_v0.a.a.$)) {
		var _v1 = _v0.a.a;
		return model.dx;
	} else {
		if (!_v0.b.$) {
			var fiche = _v0.b.a;
			return fiche.wg.vf.Aq;
		} else {
			return '';
		}
	}
};
var $author$project$Components$Produits$Correspondances$Model$valeursDeLaCible = function (model) {
	return A2(
		$author$project$Components$Produits$Correspondances$Model$actives,
		$author$project$Components$Produits$Correspondances$Model$cibleDuGeste(model),
		model);
};
var $author$project$Components$Produits$Correspondances$View$choixDesCibles = F3(
	function (i18n, prefixe, model) {
		var toutes = $author$project$Components$Produits$Correspondances$Model$valeursDeLaCible(model);
		var trouvees = A2(
			$elm$core$List$take,
			50,
			A2(
				$elm$core$List$filter,
				function (v) {
					return A2(
						$elm$core$String$contains,
						$elm$core$String$toLower(model.hC),
						$elm$core$String$toLower(v.Bl));
				},
				toutes));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('choix-des-cibles')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$correspondancesCreationAssociee(i18n)),
							$rtfeldman$elm_css$Html$Styled$text(' '),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$correspondancesCreationCompte,
										i18n,
										{
											L: $elm$core$String$fromInt(
												$elm$core$List$length(model.L)),
											JE: $elm$core$String$fromInt(
												$elm$core$List$length(toutes))
										}))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('search'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(prefixe + '-recherche'),
							$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(
							$author$project$I18n$Cles$correspondancesCreationRechercher(i18n)),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-label',
							$author$project$I18n$Cles$correspondancesCreationRechercher(i18n)),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(model.hC),
							$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Produits$Correspondances$Update$Recherche)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('pick')
						]),
					A2(
						$elm$core$List$map,
						function (v) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$label,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('pick-ligne')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$input,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
												$rtfeldman$elm_css$Html$Styled$Attributes$checked(
												A2($elm$core$List$member, v.Aq, model.L)),
												$rtfeldman$elm_css$Html$Styled$Events$onCheck(
												$author$project$Components$Produits$Correspondances$Update$ValeurBasculee(v.Aq))
											]),
										_List_Nil),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(v.Bl)
											]))
									]));
						},
						trouvees))
				]));
	});
var $author$project$I18n$Cles$correspondancesCreationApercuLigne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'correspondances.creation.apercu-ligne',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'depart',
					$author$project$I18n$Traductions$Chaine(p.cx)),
					_Utils_Tuple2(
					'cibles',
					$author$project$I18n$Traductions$Chaine(p.jS))
				]),
			p.cx + (' → ' + p.jS));
	});
var $author$project$I18n$Cles$correspondancesCreationCreer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.creation.creer', _List_Nil, 'Créer la correspondance');
};
var $author$project$I18n$Cles$correspondancesCreationPied = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.creation.pied', _List_Nil, 'Refus nommés sous le champ : mêmes listes · couple déjà défini');
};
var $author$project$I18n$Cles$correspondancesCreationSousTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.creation.sous-titre', _List_Nil, 'Relier les valeurs de deux listes.');
};
var $author$project$I18n$Cles$correspondancesCreationTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.creation.titre', _List_Nil, 'Nouvelle correspondance');
};
var $author$project$I18n$Cles$correspondancesIntituleSousTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.intitule.sous-titre', _List_Nil, 'Intitulé de la correspondance, par langue.');
};
var $author$project$I18n$Cles$correspondancesIntituleTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.intitule.titre', _List_Nil, 'Renommer et traduire');
};
var $author$project$I18n$Cles$correspondancesModificationEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.modification.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$correspondancesModificationTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.modification.titre', _List_Nil, 'Modifier les valeurs associées');
};
var $author$project$I18n$Cles$correspondancesRetraitAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.retrait.action', _List_Nil, 'Retirer la correspondance');
};
var $author$project$I18n$Cles$correspondancesRetraitLigneAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.retrait-ligne.action', _List_Nil, 'Retirer la ligne');
};
var $author$project$I18n$Cles$correspondancesRetraitLignePied = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.retrait-ligne.pied', _List_Nil, 'Rétablir les liens plus tard : « Nouvelle valeur de départ »');
};
var $author$project$I18n$Cles$correspondancesRetraitLigneTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'correspondances.retrait-ligne.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer la ligne « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$correspondancesRetraitTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.retrait.titre', _List_Nil, 'Retirer la correspondance');
};
var $author$project$I18n$Cles$correspondancesValeurDeDepartNouvelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.valeur-de-depart.nouvelle', _List_Nil, 'Nouvelle valeur de départ');
};
var $author$project$Components$Produits$Correspondances$Update$CibleChoisie = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Produits$Correspondances$Update$DepartChoisi = function (a) {
	return {$: 7, a: a};
};
var $author$project$I18n$Cles$correspondancesCreationApercu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.creation.apercu', _List_Nil, 'Aperçu');
};
var $author$project$I18n$Cles$correspondancesCreationCible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.creation.cible', _List_Nil, 'Liste cible');
};
var $author$project$I18n$Cles$correspondancesCreationDepart = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.creation.depart', _List_Nil, 'Liste de départ');
};
var $author$project$I18n$Cles$correspondancesCreationSens = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'correspondances.creation.sens',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'depart',
					$author$project$I18n$Traductions$Chaine(p.cx)),
					_Utils_Tuple2(
					'cible',
					$author$project$I18n$Traductions$Chaine(p.vf))
				]),
			'Se lit : pour une valeur de « ' + (p.cx + (' », dans quelles valeurs de « ' + (p.vf + ' » est-elle reconnue. Les deux listes doivent être différentes, et le couple ne doit pas exister déjà.'))));
	});
var $author$project$I18n$Cles$correspondancesCreationSuite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.creation.suite', _List_Nil, 'Les autres lignes s\'ajoutent ensuite depuis la fiche.');
};
var $author$project$Components$Produits$Correspondances$View$valeurDeDepartChoisie = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.Bl;
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (v) {
						return _Utils_eq(v.Aq, model.sg);
					},
					$author$project$Components$Produits$Correspondances$Model$valeursDeDepart(model)))));
};
var $author$project$Components$Produits$Correspondances$View$creation = F3(
	function (i18n, prefixe, model) {
		var listes = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.n_;
				},
				model.n_));
		var nomDe = function (id) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Dj;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (liste) {
								return _Utils_eq(liste.Aq, id);
							},
							listes))));
		};
		var options = A2(
			$elm$core$List$map,
			function (liste) {
				return {Bl: liste.Dj, fm: liste.Aq};
			},
			listes);
		var apercu = A2(
			$elm$core$List$map,
			function ($) {
				return $.Bl;
			},
			A2(
				$elm$core$List$filterMap,
				function (id) {
					return $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (v) {
								return _Utils_eq(v.Aq, id);
							},
							$author$project$Components$Produits$Correspondances$Model$valeursDeLaCible(model)));
				},
				model.L));
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('deux')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Champ$View$liste,
						{
							go: $elm$core$Maybe$Nothing,
							Aq: prefixe + '-depart',
							Bl: $author$project$I18n$Cles$correspondancesCreationDepart(i18n),
							he: true
						},
						{hg: $author$project$Components$Produits$Correspondances$Update$DepartChoisi, o_: options, fm: model.dG}),
						A2(
						$author$project$Components$Shared$Champ$View$liste,
						{
							go: $elm$core$Maybe$Nothing,
							Aq: prefixe + '-cible',
							Bl: $author$project$I18n$Cles$correspondancesCreationCible(i18n),
							he: true
						},
						{hg: $author$project$Components$Produits$Correspondances$Update$CibleChoisie, o_: options, fm: model.dx})
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('alerte'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('info')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								nomDe(model.dG) + (' → ' + nomDe(model.dx)))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$correspondancesCreationSens,
									i18n,
									{
										vf: nomDe(model.dx),
										cx: nomDe(model.dG)
									}))
							]))
					])),
				A3($author$project$Components$Produits$Correspondances$View$choixDeLaValeur, i18n, prefixe, model),
				A3($author$project$Components$Produits$Correspondances$View$choixDesCibles, i18n, prefixe, model),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$correspondancesCreationApercu(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$correspondancesCreationApercuLigne,
									i18n,
									{
										jS: A2($elm$core$String$join, ', ', apercu),
										cx: $author$project$Components$Produits$Correspondances$View$valeurDeDepartChoisie(model)
									}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$correspondancesCreationSuite(i18n))
							]))
					]))
			]);
	});
var $author$project$Components$Produits$Correspondances$Update$LibelleSaisi = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$I18n$Cles$correspondancesIntituleEncadre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.intitule.encadre', _List_Nil, 'Les noms des listes se renomment dans leur propre drawer, sur l\'onglet Listes.');
};
var $author$project$I18n$Cles$correspondancesIntituleEncadreTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.intitule.encadre-titre', _List_Nil, 'Sans intitulé, l\'écran écrit « liste de départ → liste cible ».');
};
var $author$project$I18n$Cles$correspondancesIntituleLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.intitule.libelle', _List_Nil, 'Intitulé');
};
var $author$project$I18n$Cles$correspondancesIntituleNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.intitule.note', _List_Nil, 'Une langue laissée vide est retirée.');
};
var $author$project$Components$Shared$LibellesParLangue$View$NomsDeLangueSeuls = 3;
var $author$project$Components$Shared$LibellesParLangue$View$nomsDeLangueSeuls = function (i18n) {
	return A3(
		$author$project$Components$Shared$LibellesParLangue$View$rendre,
		i18n,
		3,
		function (_v0) {
			return $elm$core$Maybe$Nothing;
		});
};
var $author$project$Components$Produits$Correspondances$View$intitule = F3(
	function (i18n, prefixe, model) {
		return _List_fromArray(
			[
				A3(
				$author$project$Components$Shared$LibellesParLangue$View$nomsDeLangueSeuls,
				i18n,
				_List_Nil,
				{
					go: function (_v0) {
						return $elm$core$Maybe$Nothing;
					},
					Ba: $author$project$Referentiel$Langues$desLibelles,
					Bl: $author$project$I18n$Cles$correspondancesIntituleLibelle(i18n),
					hg: $author$project$Components$Produits$Correspondances$Update$LibelleSaisi,
					pv: prefixe,
					fm: function (code) {
						return A2($author$project$Components$Shared$LibellesParLangue$Model$lire, code, model.R);
					}
				}),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$correspondancesIntituleNote(i18n))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('alerte'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('info')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$correspondancesIntituleEncadreTitre(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$correspondancesIntituleEncadre(i18n))
							]))
					]))
			]);
	});
var $author$project$Components$Produits$Correspondances$View$libelleDeDepart = F2(
	function (model, depart) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.sg;
					},
					function ($) {
						return $.Bl;
					}),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (ligne) {
							return _Utils_eq(ligne.sg.Aq, depart);
						},
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.gV;
								},
								model.zo))))));
	});
var $author$project$Components$Produits$Correspondances$View$libelleDeLaCible = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.wg;
				},
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.vf;
					},
					function ($) {
						return $.Bl;
					})),
			model.zo));
};
var $author$project$I18n$Cles$correspondancesModificationAjouter = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'correspondances.modification.ajouter',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'liste',
					$author$project$I18n$Traductions$Chaine(p.nW))
				]),
			'Ajouter des ' + $elm$core$String$toLower(p.nW));
	});
var $author$project$I18n$Cles$correspondancesModificationLiees = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'correspondances.modification.liees',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w)),
					_Utils_Tuple2(
					'liste',
					$author$project$I18n$Traductions$Chaine(p.nW))
				]),
			'Reconnue sur (' + (p.w + (' ' + ($elm$core$String$toLower(p.nW) + ')'))));
	});
var $author$project$I18n$Cles$correspondancesModificationNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.modification.note', _List_Nil, 'Il enlève seulement le lien entre les deux. Une ligne sans valeur se retire avec « Retirer ».');
};
var $author$project$I18n$Cles$correspondancesModificationNoteTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.modification.note-titre', _List_Nil, 'Un retrait ne supprime ni la valeur de départ ni la valeur cible.');
};
var $author$project$I18n$Cles$correspondancesModificationRetablir = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'correspondances.modification.retablir',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.Dj + ' (retiré) · rétablir');
	});
var $author$project$I18n$Cles$correspondancesModificationRetirer = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'correspondances.modification.retirer',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer ' + p.Dj);
	});
var $author$project$Components$Produits$Correspondances$Model$retirees = function (model) {
	var _v0 = _Utils_Tuple2(model.mW, model.zo);
	if (((!_v0.a.$) && (_v0.a.a.$ === 2)) && (!_v0.b.$)) {
		var depart = _v0.a.a.a;
		var fiche = _v0.b.a;
		return A2(
			$elm$core$List$filter,
			function (cible) {
				return !A2($elm$core$List$member, cible.Aq, model.L);
			},
			A2(
				$elm$core$List$concatMap,
				function ($) {
					return $.jS;
				},
				A2(
					$elm$core$List$filter,
					function (ligne) {
						return _Utils_eq(ligne.sg.Aq, depart);
					},
					fiche.gV)));
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Produits$Correspondances$View$modification = F3(
	function (i18n, prefixe, model) {
		var toutes = $author$project$Components$Produits$Correspondances$Model$valeursDeLaCible(model);
		var libres = A2(
			$elm$core$List$take,
			50,
			A2(
				$elm$core$List$filter,
				function (v) {
					return A2(
						$elm$core$String$contains,
						$elm$core$String$toLower(model.hC),
						$elm$core$String$toLower(v.Bl));
				},
				A2(
					$elm$core$List$filter,
					function (v) {
						return !A2($elm$core$List$member, v.Aq, model.L);
					},
					toutes)));
		var libelleDe = function (id) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Bl;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (v) {
								return _Utils_eq(v.Aq, id);
							},
							toutes))));
		};
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('choix-des-cibles')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$correspondancesModificationLiees,
									i18n,
									{
										nW: $author$project$Components$Produits$Correspondances$View$libelleDeLaCible(model),
										w: $elm$core$String$fromInt(
											$elm$core$List$length(model.L))
									}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('chips')
							]),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								function (id) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$button,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('chip'),
												A2(
												$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
												'aria-label',
												A2(
													$author$project$I18n$Cles$correspondancesModificationRetirer,
													i18n,
													{
														Dj: libelleDe(id)
													})),
												$rtfeldman$elm_css$Html$Styled$Attributes$title(
												A2(
													$author$project$I18n$Cles$correspondancesModificationRetirer,
													i18n,
													{
														Dj: libelleDe(id)
													})),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												A2($author$project$Components$Produits$Correspondances$Update$ValeurBasculee, id, false))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												libelleDe(id) + ' ×')
											]));
								},
								model.L),
							A2(
								$elm$core$List$map,
								function (v) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$button,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('chip'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('retiree'),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												A2($author$project$Components$Produits$Correspondances$Update$ValeurBasculee, v.Aq, true))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$correspondancesModificationRetablir,
													i18n,
													{Dj: v.Bl}))
											]));
								},
								$author$project$Components$Produits$Correspondances$Model$retirees(model))))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('choix-des-cibles')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$correspondancesModificationAjouter,
									i18n,
									{
										nW: $author$project$Components$Produits$Correspondances$View$libelleDeLaCible(model)
									}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$input,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('search'),
								$rtfeldman$elm_css$Html$Styled$Attributes$id(prefixe + '-recherche'),
								$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(
								$author$project$I18n$Cles$correspondancesCreationRechercher(i18n)),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-label',
								$author$project$I18n$Cles$correspondancesCreationRechercher(i18n)),
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.hC),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Produits$Correspondances$Update$Recherche)
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('pick')
							]),
						A2(
							$elm$core$List$map,
							function (v) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$label,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('pick-ligne')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$input,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
													$rtfeldman$elm_css$Html$Styled$Attributes$checked(false),
													$rtfeldman$elm_css$Html$Styled$Events$onCheck(
													$author$project$Components$Produits$Correspondances$Update$ValeurBasculee(v.Aq))
												]),
											_List_Nil),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(v.Bl)
												]))
										]));
							},
							libres))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('alerte'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('info')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$correspondancesModificationNoteTitre(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$correspondancesModificationNote(i18n))
							]))
					]))
			]);
	});
var $author$project$Components$Produits$Correspondances$Model$ajoutees = function (model) {
	var _v0 = _Utils_Tuple2(model.mW, model.zo);
	if (((!_v0.a.$) && (_v0.a.a.$ === 2)) && (!_v0.b.$)) {
		var depart = _v0.a.a.a;
		var fiche = _v0.b.a;
		var avant = A2(
			$elm$core$List$map,
			function ($) {
				return $.Aq;
			},
			A2(
				$elm$core$List$concatMap,
				function ($) {
					return $.jS;
				},
				A2(
					$elm$core$List$filter,
					function (ligne) {
						return _Utils_eq(ligne.sg.Aq, depart);
					},
					fiche.gV)));
		return $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (id) {
					return !A2($elm$core$List$member, id, avant);
				},
				model.L));
	} else {
		return 0;
	}
};
var $author$project$I18n$Cles$correspondancesModificationPiedAjoutes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'correspondances.modification.pied-ajoutes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' ajouté') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' ajoutés'));
	});
var $author$project$I18n$Cles$correspondancesModificationPiedRetires = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'correspondances.modification.pied-retires',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' retiré') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' retirés'));
	});
var $author$project$Components$Produits$Correspondances$View$piedDeModification = F2(
	function (i18n, model) {
		var retirees = $elm$core$List$length(
			$author$project$Components$Produits$Correspondances$Model$retirees(model));
		var ajoutees = $author$project$Components$Produits$Correspondances$Model$ajoutees(model);
		return function (texte) {
			return (texte === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(texte);
		}(
			A2(
				$elm$core$String$join,
				' · ',
				A2(
					$elm$core$List$map,
					$elm$core$Tuple$second,
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var n = _v0.a;
							return n > 0;
						},
						_List_fromArray(
							[
								_Utils_Tuple2(
								ajoutees,
								A2(
									$author$project$I18n$Cles$correspondancesModificationPiedAjoutes,
									i18n,
									{w: ajoutees})),
								_Utils_Tuple2(
								retirees,
								A2(
									$author$project$I18n$Cles$correspondancesModificationPiedRetires,
									i18n,
									{w: retirees}))
							])))));
	});
var $author$project$I18n$Cles$correspondancesIntitulePied = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'correspondances.intitule.pied',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'langues',
					$author$project$I18n$Traductions$Chaine(p.Ba))
				]),
			'Langues renseignées : ' + p.Ba);
	});
var $author$project$Components$Produits$Correspondances$View$piedDesLangues = F2(
	function (i18n, model) {
		return function (langues) {
			return A2(
				$author$project$I18n$Cles$correspondancesIntitulePied,
				i18n,
				{Ba: langues});
		}(
			A2(
				$elm$core$String$join,
				' · ',
				A2(
					$elm$core$List$map,
					function (langue) {
						return _Utils_ap(
							$elm$core$String$toUpper(
								A2($elm$core$String$left, 1, langue.vx)),
							A2($elm$core$String$dropLeft, 1, langue.vx));
					},
					A2(
						$elm$core$List$filter,
						function (langue) {
							return $elm$core$String$trim(
								A2($author$project$Components$Shared$LibellesParLangue$Model$lire, langue.vx, model.R)) !== '';
						},
						$author$project$Referentiel$Langues$desLibelles))));
	});
var $author$project$I18n$Cles$correspondancesRefusSansCible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.refus.sans-cible', _List_Nil, 'Une ligne garde au moins une valeur : pour la vider, retirez la ligne.');
};
var $author$project$Components$Produits$Correspondances$View$refus = F2(
	function (i18n, model) {
		var _v0 = model.pZ;
		if (!_v0.$) {
			var texte = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('refus'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$I18n$Cles$texte, i18n, texte))
					]));
		} else {
			return model.b5 ? A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('refus'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$correspondancesRefusSansCible(i18n))
					])) : $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$correspondancesRetraitTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.retrait.texte', _List_Nil, 'La correspondance et ses lignes sont retirées. Les deux listes ne changent pas.');
};
var $author$project$I18n$Cles$correspondancesRetraitUtilisee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.retrait.utilisee', _List_Nil, 'Cette correspondance est utilisée ; retirez d\'abord ce qui la consulte.');
};
var $author$project$I18n$Cles$correspondancesRetraitUtiliseeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.retrait.utilisee-titre', _List_Nil, 'Retrait impossible pour l\'instant.');
};
var $author$project$Components$Produits$Correspondances$View$retrait = F2(
	function (i18n, model) {
		var noms = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.wg;
					},
					function ($) {
						return $.Ke;
					}),
				model.zo));
		return $elm$core$List$isEmpty(noms) ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$correspondancesRetraitTexte(i18n))
					]))
			]) : _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Note$View$view,
				1,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$correspondancesRetraitUtiliseeTitre(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$correspondancesRetraitUtilisee(i18n))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$ul,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('usages')
					]),
				A2(
					$elm$core$List$map,
					function (nom) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(nom)
								]));
					},
					noms))
			]);
	});
var $author$project$I18n$Cles$correspondancesRetraitLigneAlerteTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'correspondances.retrait-ligne.alerte-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'La ligne ' + (p.Dj + ' est retirée.'));
	});
var $author$project$I18n$Cles$correspondancesRetraitLignePerdra = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.retrait-ligne.perdra', _List_Nil, 'Perdra sa correspondance');
};
var $author$project$I18n$Cles$correspondancesRetraitLigneTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.retrait-ligne.texte', _List_Nil, 'Les liens de la ligne sont déliés. La valeur reste dans sa liste.');
};
var $author$project$Components$Produits$Correspondances$View$retraitDeLaLigne = F3(
	function (i18n, model, depart) {
		var cibles = A2(
			$elm$core$List$concatMap,
			function ($) {
				return $.jS;
			},
			A2(
				$elm$core$List$filter,
				function (ligne) {
					return _Utils_eq(ligne.sg.Aq, depart);
				},
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.gV;
						},
						model.zo))));
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Note$View$view,
				1,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$correspondancesRetraitLigneAlerteTitre,
									i18n,
									{
										Dj: A2($author$project$Components$Produits$Correspondances$View$libelleDeDepart, model, depart)
									}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$correspondancesRetraitLigneTexte(i18n))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$correspondancesRetraitLignePerdra(i18n))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('chips')
					]),
				A2(
					$elm$core$List$map,
					function (cible) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('chip')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(cible.Bl)
								]));
					},
					cibles))
			]);
	});
var $author$project$Components$Produits$Correspondances$View$sensDeLaFiche = F2(
	function (i18n, model) {
		return A2(
			$author$project$I18n$Cles$correspondancesCreationApercuLigne,
			i18n,
			{
				jS: $author$project$Components$Produits$Correspondances$View$libelleDeLaCible(model),
				cx: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.wg;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.cx;
								},
								function ($) {
									return $.Bl;
								})),
						model.zo))
			});
	});
var $author$project$Components$Produits$Correspondances$View$utilisee = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (fiche) {
				return !$elm$core$List$isEmpty(fiche.wg.Ke);
			},
			model.zo));
};
var $author$project$Components$Shared$Drawer$View$viewDestructifAvecSousTitreEtNote = function (i18n) {
	return A2($author$project$Components$Shared$Drawer$View$avecSousTitreEtNote, i18n, 3);
};
var $author$project$Components$Produits$Correspondances$View$drawerDuGeste = F2(
	function (i18n, model) {
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.kX);
		var geste = function () {
			var _v0 = model.mW;
			if (!_v0.$) {
				switch (_v0.a.$) {
					case 0:
						var _v1 = _v0.a;
						return {
							fs: $author$project$I18n$Cles$correspondancesCreationCreer(i18n),
							f$: A3($author$project$Components$Produits$Correspondances$View$creation, i18n, prefixe, model),
							au: false,
							aj: $elm$core$Maybe$Just(
								$author$project$I18n$Cles$correspondancesCreationPied(i18n)),
							aO: $elm$core$Maybe$Just(
								$author$project$I18n$Cles$correspondancesCreationSousTitre(i18n)),
							h6: $author$project$I18n$Cles$correspondancesCreationTitre(i18n)
						};
					case 1:
						var _v2 = _v0.a;
						return {
							fs: $author$project$I18n$Cles$correspondancesModificationEnregistrer(i18n),
							f$: _List_fromArray(
								[
									A3($author$project$Components$Produits$Correspondances$View$choixDeLaValeur, i18n, prefixe, model),
									A3($author$project$Components$Produits$Correspondances$View$choixDesCibles, i18n, prefixe, model)
								]),
							au: false,
							aj: $elm$core$Maybe$Nothing,
							aO: $elm$core$Maybe$Nothing,
							h6: $author$project$I18n$Cles$correspondancesValeurDeDepartNouvelle(i18n)
						};
					case 2:
						var depart = _v0.a.a;
						return {
							fs: $author$project$I18n$Cles$correspondancesModificationEnregistrer(i18n),
							f$: A3($author$project$Components$Produits$Correspondances$View$modification, i18n, prefixe, model),
							au: false,
							aj: A2($author$project$Components$Produits$Correspondances$View$piedDeModification, i18n, model),
							aO: $elm$core$Maybe$Just(
								A2(
									$author$project$I18n$Cles$correspondancesCreationApercuLigne,
									i18n,
									{
										jS: $author$project$Components$Produits$Correspondances$View$libelleDeLaCible(model),
										cx: A2($author$project$Components$Produits$Correspondances$View$libelleDeDepart, model, depart)
									})),
							h6: $author$project$I18n$Cles$correspondancesModificationTitre(i18n)
						};
					case 3:
						var _v3 = _v0.a;
						return {
							fs: $author$project$I18n$Cles$correspondancesModificationEnregistrer(i18n),
							f$: A3($author$project$Components$Produits$Correspondances$View$intitule, i18n, prefixe, model),
							au: false,
							aj: $elm$core$Maybe$Just(
								A2($author$project$Components$Produits$Correspondances$View$piedDesLangues, i18n, model)),
							aO: $elm$core$Maybe$Just(
								$author$project$I18n$Cles$correspondancesIntituleSousTitre(i18n)),
							h6: $author$project$I18n$Cles$correspondancesIntituleTitre(i18n)
						};
					case 4:
						var depart = _v0.a.a;
						return {
							fs: $author$project$I18n$Cles$correspondancesRetraitLigneAction(i18n),
							f$: A3($author$project$Components$Produits$Correspondances$View$retraitDeLaLigne, i18n, model, depart),
							au: true,
							aj: $elm$core$Maybe$Just(
								$author$project$I18n$Cles$correspondancesRetraitLignePied(i18n)),
							aO: $elm$core$Maybe$Just(
								A2($author$project$Components$Produits$Correspondances$View$sensDeLaFiche, i18n, model)),
							h6: A2(
								$author$project$I18n$Cles$correspondancesRetraitLigneTitre,
								i18n,
								{
									Dj: A2($author$project$Components$Produits$Correspondances$View$libelleDeDepart, model, depart)
								})
						};
					default:
						var _v4 = _v0.a;
						return {
							fs: $author$project$I18n$Cles$correspondancesRetraitAction(i18n),
							f$: A2($author$project$Components$Produits$Correspondances$View$retrait, i18n, model),
							au: true,
							aj: $elm$core$Maybe$Nothing,
							aO: $elm$core$Maybe$Just(
								A2($author$project$Components$Produits$Correspondances$View$sensDeLaFiche, i18n, model)),
							h6: $author$project$I18n$Cles$correspondancesRetraitTitre(i18n)
						};
				}
			} else {
				return {fs: '', f$: _List_Nil, au: false, aj: $elm$core$Maybe$Nothing, aO: $elm$core$Maybe$Nothing, h6: ''};
			}
		}();
		var contenu = {
			fs: {
				sR: (!$author$project$API$Envoi$enCours(model.l2)) && ((!_Utils_eq(model.mW, $elm$core$Maybe$Nothing)) && (!(_Utils_eq(
					model.mW,
					$elm$core$Maybe$Just($author$project$Components$Produits$Correspondances$Model$Retrait)) && ((!_Utils_eq(
					A2($author$project$Components$Produits$Correspondances$Model$lienDe, $author$project$API$NavLinksDictionary$retirerUneCorrespondance, model),
					$elm$core$Maybe$Nothing)) && $author$project$Components$Produits$Correspondances$View$utilisee(model))))),
				Bl: geste.fs,
				C$: $author$project$Components$Produits$Correspondances$Update$GesteDemande
			},
			fZ: _Utils_ap(
				geste.f$,
				_List_fromArray(
					[
						A2($author$project$Components$Produits$Correspondances$View$refus, i18n, model)
					])),
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: geste.h6
		};
		return geste.au ? A6($author$project$Components$Shared$Drawer$View$viewDestructifAvecSousTitreEtNote, i18n, geste.aO, geste.aj, $author$project$Components$Produits$Correspondances$Update$DuDrawer, contenu, model.kX) : A6($author$project$Components$Shared$Drawer$View$viewAvecSousTitreEtNote, i18n, geste.aO, geste.aj, $author$project$Components$Produits$Correspondances$Update$DuDrawer, contenu, model.kX);
	});
var $author$project$I18n$Cles$listesPageTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.page-titre', _List_Nil, 'Listes et correspondances');
};
var $author$project$Components$Produits$Correspondances$View$cadre = F8(
	function (i18n, page, fil, titre, complements, entete, bottom, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			page,
			{
				ut: bottom,
				xy: _List_fromArray(
					[
						A2($author$project$Components$Produits$Correspondances$View$drawerDuGeste, i18n, model)
					]),
				zM: _List_Nil,
				AK: $author$project$Components$Produits$Correspondances$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: complements,
						zE: _Utils_ap(
							_List_fromArray(
								[
									{
									aa: $author$project$Routes$Route$adresseTypesDePartiesPrenantes,
									Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
								},
									{
									aa: $author$project$Routes$Route$adresseListes,
									Dj: $author$project$I18n$Cles$listesPageTitre(i18n)
								}
								]),
							fil),
						Ef: entete,
						h6: titre
					})
			});
	});
var $author$project$I18n$Cles$correspondancesNombre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'correspondances.nombre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' correspondance') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' correspondances'));
	});
var $author$project$I18n$Cles$correspondancesNouvelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.nouvelle', _List_Nil, 'Nouvelle correspondance');
};
var $author$project$I18n$Cles$correspondancesOnglet = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.onglet', _List_Nil, 'Correspondances');
};
var $author$project$I18n$Cles$correspondancesSensTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.sens.texte', _List_Nil, '« Certifications → Pays » dit dans quels pays une certification est reconnue ; la lecture inverse (les certifications acceptées dans un pays) se fait sur la même correspondance.');
};
var $author$project$I18n$Cles$correspondancesSensTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.sens.titre', _List_Nil, 'Une correspondance se lit dans un sens.');
};
var $author$project$I18n$Cles$correspondancesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.titre', _List_Nil, 'Correspondances');
};
var $author$project$I18n$Cles$correspondancesVideAllerAuxListes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.vide.aller-aux-listes', _List_Nil, 'Aller aux listes');
};
var $author$project$I18n$Cles$correspondancesVideTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.vide.texte', _List_Nil, 'Une correspondance relie les valeurs de deux listes : par exemple, les pays où chaque certification est reconnue. Les périmètres d\'offre s\'en servent pour ne proposer à un licencié que les références qu\'il peut vendre.');
};
var $author$project$I18n$Cles$correspondancesVideTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.vide.titre', _List_Nil, 'Aucune correspondance');
};
var $author$project$I18n$Cles$correspondancesVideUneListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.vide.une-liste', _List_Nil, 'Il faut au moins deux listes pour relier leurs valeurs.');
};
var $author$project$I18n$Cles$listesPageDescription = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.page-description', _List_Nil, 'Les listes de choix du catalogue et des parties prenantes, et les correspondances qui les relient.');
};
var $author$project$I18n$Cles$listesOnglet = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.onglet', _List_Nil, 'Listes');
};
var $author$project$Components$Produits$Correspondances$View$onglets = F2(
	function (i18n, model) {
		return _List_fromArray(
			[
				$author$project$Components$Shared$Onglets$View$view(
				_List_fromArray(
					[
						{
						sO: false,
						aa: $author$project$Routes$Route$adresseListes,
						vW: A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.n_;
								},
								A2($elm$core$Basics$composeR, $elm$core$List$length, $elm$core$String$fromInt)),
							model.n_),
						Dj: $author$project$I18n$Cles$listesOnglet(i18n)
					},
						{
						sO: true,
						aa: $author$project$Routes$Route$adresseCorrespondances,
						vW: A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.wh;
								},
								A2($elm$core$Basics$composeR, $elm$core$List$length, $elm$core$String$fromInt)),
							model.aS),
						Dj: $author$project$I18n$Cles$correspondancesOnglet(i18n)
					}
					]))
			]);
	});
var $author$project$I18n$Cles$correspondancesColonneDeVers = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.colonne.de-vers', _List_Nil, 'De → vers');
};
var $author$project$I18n$Cles$correspondancesColonneLignes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.colonne.lignes', _List_Nil, 'Lignes');
};
var $author$project$I18n$Cles$correspondancesColonneUtiliseePar = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.colonne.utilisee-par', _List_Nil, 'Utilisée par');
};
var $author$project$I18n$Cles$correspondancesLignesDeDepart = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'correspondances.lignes-de-depart',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w)),
					_Utils_Tuple2(
					'liste',
					$author$project$I18n$Traductions$Chaine(p.nW))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' ligne') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' ' + $elm$core$String$toLower(p.nW))));
	});
var $author$project$I18n$Cles$correspondancesUtiliseeParAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.utilisee-par.aucun', _List_Nil, 'aucun périmètre');
};
var $author$project$Components$Produits$Correspondances$View$ligneDeCorrespondance = F2(
	function (i18n, resume) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('correspondance')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$correspondance, resume.nQ.h0);
							if (!_v0.$) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('title'),
											$rtfeldman$elm_css$Html$Styled$Attributes$href(
											$author$project$Routes$Route$adresseDeLaCorrespondance(resume.Aq))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(resume.AS)
										]));
							} else {
								return $rtfeldman$elm_css$Html$Styled$text(resume.AS);
							}
						}()
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('lignes')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$correspondancesLignesDeDepart,
								i18n,
								{nW: resume.cx.Bl, w: resume.gV}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'aucun',
									$elm$core$List$isEmpty(resume.Ke))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$List$isEmpty(resume.Ke) ? $author$project$I18n$Cles$correspondancesUtiliseeParAucun(i18n) : A2($elm$core$String$join, ', ', resume.Ke))
						]))
				]));
	});
var $author$project$Components$Produits$Correspondances$View$tableDesCorrespondances = F2(
	function (i18n, correspondances) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$table,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (nom) {
											return A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(nom)
													]));
										},
										_List_fromArray(
											[
												$author$project$I18n$Cles$correspondancesColonneDeVers(i18n),
												$author$project$I18n$Cles$correspondancesColonneLignes(i18n),
												$author$project$I18n$Cles$correspondancesColonneUtiliseePar(i18n)
											])))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$tbody,
							_List_Nil,
							A2(
								$elm$core$List$map,
								$author$project$Components$Produits$Correspondances$View$ligneDeCorrespondance(i18n),
								correspondances))
						]))
				]));
	});
var $author$project$Components$Produits$Correspondances$View$annuaire = F3(
	function (i18n, messages, model) {
		var nombreDeListes = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.n_;
					},
					$elm$core$List$length),
				model.n_));
		var creer = _Utils_eq(
			A2($author$project$Components$Produits$Correspondances$Model$lienDe, $author$project$API$NavLinksDictionary$creerUneCorrespondance, model),
			$elm$core$Maybe$Nothing) ? _List_Nil : ((nombreDeListes >= 2) ? _List_fromArray(
			[
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				0,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						$author$project$Components$Produits$Correspondances$Model$idDuDeclencheur($author$project$Components$Produits$Correspondances$Model$Creation)),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$Correspondances$Update$GesteOuvert($author$project$Components$Produits$Correspondances$Model$Creation))
					]),
				$author$project$I18n$Cles$correspondancesNouvelle(i18n))
			]) : _List_Nil);
		var vide = A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h3,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$correspondancesVideTitre(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$correspondancesVideTexte(i18n))
							]))
					]),
				($elm$core$List$isEmpty(creer) && ((!_Utils_eq(
					A2($author$project$Components$Produits$Correspondances$Model$lienDe, $author$project$API$NavLinksDictionary$creerUneCorrespondance, model),
					$elm$core$Maybe$Nothing)) && (!_Utils_eq(model.n_, $elm$core$Maybe$Nothing)))) ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('primary'),
								$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Routes$Route$adresseListes)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$correspondancesVideAllerAuxListes(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$correspondancesVideUneListe(i18n))
							]))
					]) : ($elm$core$List$isEmpty(creer) ? _List_Nil : _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						0,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Produits$Correspondances$Update$GesteOuvert($author$project$Components$Produits$Correspondances$Model$Creation))
							]),
						$author$project$I18n$Cles$correspondancesNouvelle(i18n))
					]))));
		var correspondances = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.wh;
				},
				model.aS));
		return A8(
			$author$project$Components$Produits$Correspondances$View$cadre,
			i18n,
			'parametrage-correspondances-list',
			_List_fromArray(
				[
					{
					aa: '',
					Dj: $author$project$I18n$Cles$correspondancesOnglet(i18n)
				}
				]),
			$author$project$I18n$Cles$listesPageTitre(i18n),
			_Utils_ap(
				_Utils_eq(model.aS, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Tag$View$view,
						5,
						A2(
							$author$project$I18n$Cles$correspondancesNombre,
							i18n,
							{
								w: $elm$core$List$length(correspondances)
							}))
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('actions-page')
								]),
							creer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$listesPageDescription(i18n))
								]))
						]))),
			A2($author$project$Components$Produits$Correspondances$View$onglets, i18n, model),
			_Utils_eq(model.np, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
						]),
					A2(
						$elm$core$List$cons,
						A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
						((!_Utils_eq(model.aS, $elm$core$Maybe$Nothing)) && _Utils_eq(correspondances, _List_Nil)) ? _List_fromArray(
							[vide]) : _List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Page$View$sectionAvecCompte,
								_List_Nil,
								{
									fw: _List_Nil,
									vW: $elm$core$Maybe$Just(
										$elm$core$String$fromInt(
											$elm$core$List$length(correspondances))),
									fZ: _List_fromArray(
										[
											A2($author$project$Components$Produits$Correspondances$View$tableDesCorrespondances, i18n, correspondances)
										]),
									Ar: $elm$core$Maybe$Nothing,
									Dj: 'correspondances',
									h6: $author$project$I18n$Cles$correspondancesTitre(i18n)
								}),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('alerte'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('info')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$correspondancesSensTitre(i18n))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$correspondancesSensTexte(i18n))
											]))
									]))
							])))
				]),
			model);
	});
var $author$project$I18n$Cles$correspondancesRetour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.retour', _List_Nil, 'Retour aux correspondances');
};
var $author$project$Components$Produits$Correspondances$Update$VueChoisie = function (a) {
	return {$: 6, a: a};
};
var $author$project$I18n$Cles$correspondancesEtiquette = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.etiquette', _List_Nil, 'Correspondance');
};
var $author$project$I18n$Cles$correspondancesLectureSeule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.lecture-seule', _List_Nil, 'Lecture seule : vous pouvez consulter cette correspondance, pas la modifier. Aucun geste n\'est offert car le serveur n\'en donne aucun lien.');
};
var $author$project$I18n$Cles$correspondancesRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.retirer', _List_Nil, 'Retirer la correspondance');
};
var $author$project$I18n$Cles$correspondancesSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'correspondances.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'depart',
					$author$project$I18n$Traductions$Chaine(p.cx)),
					_Utils_Tuple2(
					'cible',
					$author$project$I18n$Traductions$Chaine(p.vf))
				]),
			'Pour chaque valeur de « ' + (p.cx + (' », les valeurs de « ' + (p.vf + ' » auxquelles elle correspond.'))));
	});
var $author$project$I18n$Cles$correspondancesVueChoix = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.vue.choix', _List_Nil, 'Vue de la correspondance');
};
var $author$project$I18n$Cles$correspondancesVueLignes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.vue.lignes', _List_Nil, 'Lignes');
};
var $author$project$I18n$Cles$correspondancesVueMatrice = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.vue.matrice', _List_Nil, 'Matrice');
};
var $author$project$Components$Produits$Correspondances$Model$Renommage = {$: 3};
var $author$project$I18n$Cles$correspondancesIdentiteCible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.identite.cible', _List_Nil, 'Liste cible');
};
var $author$project$I18n$Cles$correspondancesIdentiteDepart = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.identite.depart', _List_Nil, 'Liste de départ');
};
var $author$project$I18n$Cles$correspondancesIdentiteIntitule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.identite.intitule', _List_Nil, 'Intitulé');
};
var $author$project$I18n$Cles$correspondancesIdentiteTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.identite.titre', _List_Nil, 'Identité');
};
var $author$project$I18n$Cles$correspondancesRenommer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.renommer', _List_Nil, 'Renommer et traduire');
};
var $author$project$Components$Produits$Correspondances$View$identite = F3(
	function (i18n, model, fiche) {
		var resume = fiche.wg;
		return A2(
			$author$project$Components$Shared$Page$View$sectionAvecCompte,
			_List_Nil,
			{
				fw: _Utils_eq(
					A2($author$project$Components$Produits$Correspondances$Model$lienDe, $author$project$API$NavLinksDictionary$modifierLIntituleDUneCorrespondance, model),
					$elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id(
								$author$project$Components$Produits$Correspondances$Model$idDuDeclencheur($author$project$Components$Produits$Correspondances$Model$Renommage)),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Produits$Correspondances$Update$GesteOuvert($author$project$Components$Produits$Correspondances$Model$Renommage))
							]),
						$author$project$I18n$Cles$correspondancesRenommer(i18n))
					]),
				vW: $elm$core$Maybe$Nothing,
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('identite')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$correspondancesIdentiteIntitule(i18n))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(resume.AS)
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$correspondancesIdentiteDepart(i18n))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href(
												$author$project$Routes$Route$adresseDeLaListe(resume.cx.Aq))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(resume.cx.Bl)
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$correspondancesIdentiteCible(i18n))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href(
												$author$project$Routes$Route$adresseDeLaListe(resume.vf.Aq))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(resume.vf.Bl)
											]))
									]))
							]))
					]),
				Ar: $elm$core$Maybe$Nothing,
				Dj: 'identite',
				h6: $author$project$I18n$Cles$correspondancesIdentiteTitre(i18n)
			});
	});
var $author$project$I18n$Cles$correspondancesLignesAssociee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'correspondances.lignes.associee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'cible',
					$author$project$I18n$Traductions$Chaine(p.vf))
				]),
			'Associée à (' + (p.vf + ')'));
	});
var $author$project$I18n$Cles$correspondancesLignesAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.lignes.aucune', _List_Nil, 'Cette correspondance n\'a aucune ligne : ajoutez une valeur de départ.');
};
var $author$project$I18n$Cles$correspondancesLignesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.lignes.titre', _List_Nil, 'Lignes');
};
var $author$project$Components$Produits$Correspondances$Model$ModifierLesValeurs = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$Correspondances$Model$RetraitDeLaLigne = function (a) {
	return {$: 4, a: a};
};
var $author$project$I18n$Cles$correspondancesLignesMasquees = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'correspondances.lignes.masquees',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeur masquée garde son lien, qui n\'est pas affiché.') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeurs masquées gardent leur lien, qui n\'est pas affiché.'));
	});
var $author$project$I18n$Cles$correspondancesModifierValeurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.modifier-valeurs', _List_Nil, 'Modifier les valeurs');
};
var $author$project$I18n$Cles$correspondancesModifierValeursDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'correspondances.modifier-valeurs-de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Modifier les valeurs de ' + p.Dj);
	});
var $author$project$I18n$Cles$correspondancesRetirerLigne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.retirer-ligne', _List_Nil, 'Retirer');
};
var $author$project$I18n$Cles$correspondancesRetirerLigneDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'correspondances.retirer-ligne-de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer la ligne ' + p.Dj);
	});
var $author$project$Components$Produits$Correspondances$View$uneLigne = F3(
	function (i18n, offert, ligne) {
		var depart = ligne.sg.Aq;
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('depart')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(ligne.sg.Bl)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('chips')
								]),
							A2(
								$elm$core$List$map,
								function (cible) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('chip')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(cible.Bl)
											]));
								},
								ligne.jS)),
							(ligne.Cb > 0) ? A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$correspondancesLignesMasquees,
										i18n,
										{w: ligne.Cb}))
								])) : $rtfeldman$elm_css$Html$Styled$text('')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('gestes')
						]),
					_Utils_ap(
						offert($author$project$API$NavLinksDictionary$modifierLesValeursAssociees) ? _List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id(
										$author$project$Components$Produits$Correspondances$Model$idDuDeclencheur(
											$author$project$Components$Produits$Correspondances$Model$ModifierLesValeurs(depart))),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Produits$Correspondances$Update$GesteOuvert(
											$author$project$Components$Produits$Correspondances$Model$ModifierLesValeurs(depart))),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
										'aria-label',
										A2(
											$author$project$I18n$Cles$correspondancesModifierValeursDe,
											i18n,
											{Dj: ligne.sg.Bl}))
									]),
								$author$project$I18n$Cles$correspondancesModifierValeurs(i18n))
							]) : _List_Nil,
						offert($author$project$API$NavLinksDictionary$retirerUneLigneDeCorrespondance) ? _List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								2,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id(
										$author$project$Components$Produits$Correspondances$Model$idDuDeclencheur(
											$author$project$Components$Produits$Correspondances$Model$RetraitDeLaLigne(depart))),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Produits$Correspondances$Update$GesteOuvert(
											$author$project$Components$Produits$Correspondances$Model$RetraitDeLaLigne(depart))),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
										'aria-label',
										A2(
											$author$project$I18n$Cles$correspondancesRetirerLigneDe,
											i18n,
											{Dj: ligne.sg.Bl}))
									]),
								$author$project$I18n$Cles$correspondancesRetirerLigne(i18n))
							]) : _List_Nil))
				]));
	});
var $author$project$Components$Produits$Correspondances$View$lignes = F3(
	function (i18n, model, fiche) {
		var resume = fiche.wg;
		var offert = function (rel) {
			return !_Utils_eq(
				A2($author$project$Components$Produits$Correspondances$Model$lienDe, rel, model),
				$elm$core$Maybe$Nothing);
		};
		return A2(
			$author$project$Components$Shared$Page$View$sectionAvecCompte,
			_List_Nil,
			{
				fw: _List_Nil,
				vW: $elm$core$Maybe$Just(
					$elm$core$String$fromInt(
						$elm$core$List$length(fiche.gV))),
				fZ: _List_fromArray(
					[
						$elm$core$List$isEmpty(fiche.gV) ? A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$correspondancesLignesAucune(i18n))
							])) : A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$table,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(resume.cx.Bl)
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																A2(
																	$author$project$I18n$Cles$correspondancesLignesAssociee,
																	i18n,
																	{vf: resume.vf.Bl}))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_Nil)
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$tbody,
										_List_Nil,
										A2(
											$elm$core$List$map,
											A2($author$project$Components$Produits$Correspondances$View$uneLigne, i18n, offert),
											fiche.gV))
									]))
							]))
					]),
				Ar: $elm$core$Maybe$Nothing,
				Dj: 'lignes',
				h6: $author$project$I18n$Cles$correspondancesLignesTitre(i18n)
			});
	});
var $author$project$Components$Produits$Correspondances$Update$CaseCliquee = F3(
	function (a, b, c) {
		return {$: 13, a: a, b: b, c: c};
	});
var $author$project$I18n$Cles$correspondancesMatriceCaseLibre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'correspondances.matrice.case-libre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'depart',
					$author$project$I18n$Traductions$Chaine(p.cx)),
					_Utils_Tuple2(
					'cible',
					$author$project$I18n$Traductions$Chaine(p.vf))
				]),
			p.cx + (' → ' + (p.vf + ' : relier')));
	});
var $author$project$I18n$Cles$correspondancesMatriceCaseReliee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'correspondances.matrice.case-reliee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'depart',
					$author$project$I18n$Traductions$Chaine(p.cx)),
					_Utils_Tuple2(
					'cible',
					$author$project$I18n$Traductions$Chaine(p.vf))
				]),
			p.cx + (' → ' + (p.vf + ' : délier')));
	});
var $author$project$I18n$Cles$correspondancesMatriceLimitee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'correspondances.matrice.limitee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'liste',
					$author$project$I18n$Traductions$Chaine(p.nW))
				]),
			p.nW + ' compte plus de 12 valeurs : la matrice ne montre en colonne que les valeurs déjà reliées. Pour relier une autre valeur, ouvrir « Modifier les valeurs » de la ligne (vue Lignes). Une liste cible de 12 valeurs ou moins s\'affiche en entier.');
	});
var $author$project$I18n$Cles$correspondancesMatriceNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.matrice.note', _List_Nil, 'Un clic sur une case relie ou délie, sans drawer.');
};
var $author$project$I18n$Cles$correspondancesMatriceTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.matrice.titre', _List_Nil, 'Matrice');
};
var $author$project$Components$Produits$Correspondances$View$matrice = F3(
	function (i18n, model, fiche) {
		var peutRelier = !_Utils_eq(
			A2($author$project$Components$Produits$Correspondances$Model$lienDe, $author$project$API$NavLinksDictionary$relierDesValeurs, model),
			$elm$core$Maybe$Nothing);
		var peutDelier = !_Utils_eq(
			A2($author$project$Components$Produits$Correspondances$Model$lienDe, $author$project$API$NavLinksDictionary$delierDesValeurs, model),
			$elm$core$Maybe$Nothing);
		var m = fiche.Cf;
		var libelleDe = function (id) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Bl;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (c) {
								return _Utils_eq(c.Aq, id);
							},
							m.j1))));
		};
		var uneCase = F2(
			function (depart, c) {
				var nom = c.Hx ? A2(
					$author$project$I18n$Cles$correspondancesMatriceCaseReliee,
					i18n,
					{
						vf: libelleDe(c.vf),
						cx: depart.Bl
					}) : A2(
					$author$project$I18n$Cles$correspondancesMatriceCaseLibre,
					i18n,
					{
						vf: libelleDe(c.vf),
						cx: depart.Bl
					});
				var actif = c.Hx ? peutDelier : peutRelier;
				return A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_Utils_ap(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('cell'),
										$rtfeldman$elm_css$Html$Styled$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('on', c.Hx),
												_Utils_Tuple2('ro', !actif)
											])),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', nom),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
										'aria-pressed',
										c.Hx ? 'true' : 'false'),
										$rtfeldman$elm_css$Html$Styled$Attributes$title(nom)
									]),
								actif ? _List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										A3($author$project$Components$Produits$Correspondances$Update$CaseCliquee, depart.Aq, c.vf, c.Hx))
									]) : _List_fromArray(
									[
										A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'disabled', 'disabled')
									])),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									c.Hx ? '✓' : '')
								]))
						]));
			});
		var colonne = function (cible) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$th,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(cible.Bl)
					]));
		};
		return A2(
			$author$project$Components$Shared$Page$View$sectionAvecCompte,
			_List_Nil,
			{
				fw: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$correspondancesMatriceNote(i18n))
							]))
					]),
				vW: $elm$core$Maybe$Just(
					$elm$core$String$fromInt(
						$elm$core$List$length(m.gV)) + (' × ' + $elm$core$String$fromInt(
						$elm$core$List$length(m.j1)))),
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$table,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('matrice')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$tr,
												_List_Nil,
												A2(
													$elm$core$List$cons,
													A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(fiche.wg.cx.Bl)
															])),
													A2($elm$core$List$map, colonne, m.j1)))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$tbody,
										_List_Nil,
										A2(
											$elm$core$List$map,
											function (ligne) {
												return A2(
													$rtfeldman$elm_css$Html$Styled$tr,
													_List_Nil,
													A2(
														$elm$core$List$cons,
														A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$scope('row')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(ligne.sg.Bl)
																])),
														A2(
															$elm$core$List$map,
															uneCase(ligne.sg),
															ligne.uJ)));
											},
											m.gV))
									]))
							])),
						m.BU ? A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$correspondancesMatriceLimitee,
									i18n,
									{nW: fiche.wg.vf.Bl}))
							])) : $rtfeldman$elm_css$Html$Styled$text('')
					]),
				Ar: $elm$core$Maybe$Nothing,
				Dj: 'matrice',
				h6: $author$project$I18n$Cles$correspondancesMatriceTitre(i18n)
			});
	});
var $author$project$I18n$Cles$correspondancesUsagesAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.usages.aucun', _List_Nil, 'Aucun périmètre d\'offre ne l\'utilise pour l\'instant.');
};
var $author$project$I18n$Cles$correspondancesUsagesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'correspondances.usages.titre', _List_Nil, 'Où elle est utilisée');
};
var $author$project$Components$Produits$Correspondances$View$usages = F2(
	function (i18n, resume) {
		return A2(
			$author$project$Components$Shared$Page$View$sectionAvecCompte,
			_List_Nil,
			{
				fw: _List_Nil,
				vW: $elm$core$Maybe$Just(
					$elm$core$String$fromInt(
						$elm$core$List$length(resume.Ke))),
				fZ: _List_fromArray(
					[
						$elm$core$List$isEmpty(resume.Ke) ? A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$correspondancesUsagesAucun(i18n))
							])) : A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('usages')
							]),
						A2(
							$elm$core$List$map,
							function (nom) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(nom)
										]));
							},
							resume.Ke))
					]),
				Ar: $elm$core$Maybe$Nothing,
				Dj: 'usages',
				h6: $author$project$I18n$Cles$correspondancesUsagesTitre(i18n)
			});
	});
var $author$project$Components$Produits$Correspondances$View$pageDeLaFiche = F4(
	function (i18n, messages, model, fiche) {
		var resume = fiche.wg;
		var offert = function (rel) {
			return !_Utils_eq(
				A2($author$project$Components$Produits$Correspondances$Model$lienDe, rel, model),
				$elm$core$Maybe$Nothing);
		};
		var gestes = _List_fromArray(
			[$author$project$API$NavLinksDictionary$relierDesValeurs, $author$project$API$NavLinksDictionary$delierDesValeurs, $author$project$API$NavLinksDictionary$modifierLesValeursAssociees, $author$project$API$NavLinksDictionary$retirerUneLigneDeCorrespondance, $author$project$API$NavLinksDictionary$retirerUneCorrespondance, $author$project$API$NavLinksDictionary$modifierLIntituleDUneCorrespondance]);
		var enLectureSeule = !A2($elm$core$List$any, offert, gestes);
		var action = F4(
			function (rel, geste, libelle, variante) {
				return offert(rel) ? _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						variante,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id(
								$author$project$Components$Produits$Correspondances$Model$idDuDeclencheur(geste)),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Produits$Correspondances$Update$GesteOuvert(geste))
							]),
						libelle)
					]) : _List_Nil;
			});
		var nouvelle = $elm$core$List$isEmpty(fiche.Kl) ? _List_Nil : A4(
			action,
			$author$project$API$NavLinksDictionary$relierDesValeurs,
			$author$project$Components$Produits$Correspondances$Model$NouvelleLigne,
			$author$project$I18n$Cles$correspondancesValeurDeDepartNouvelle(i18n),
			0);
		var actions = _Utils_ap(
			nouvelle,
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$Components$Shared$Segment$View$view(
						{
							vd: (model.io === 1) ? 'matrice' : 'lignes',
							Bi: $author$project$I18n$Cles$correspondancesVueChoix(i18n),
							Dj: 'correspondance-vue',
							Ea: $author$project$Components$Produits$Correspondances$Update$VueChoisie,
							o_: _List_fromArray(
								[
									{
									vx: 'lignes',
									Bl: $author$project$I18n$Cles$correspondancesVueLignes(i18n)
								},
									{
									vx: 'matrice',
									Bl: $author$project$I18n$Cles$correspondancesVueMatrice(i18n)
								}
								])
						})
					]),
				A4(
					action,
					$author$project$API$NavLinksDictionary$retirerUneCorrespondance,
					$author$project$Components$Produits$Correspondances$Model$Retrait,
					$author$project$I18n$Cles$correspondancesRetirer(i18n),
					1)));
		return A8(
			$author$project$Components$Produits$Correspondances$View$cadre,
			i18n,
			'parametrage-correspondance-detail',
			_List_fromArray(
				[
					{aa: '', Dj: resume.AS}
				]),
			resume.AS,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('tags')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							5,
							$author$project$I18n$Cles$correspondancesEtiquette(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions-page')
						]),
					actions),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$correspondancesSousTitre,
								i18n,
								{vf: resume.vf.Bl, cx: resume.cx.Bl}))
						]))
				]),
			_List_Nil,
			$author$project$Components$Shared$Page$View$fiche(
				{
					tQ: _List_fromArray(
						[
							A2($author$project$Components$Produits$Correspondances$View$usages, i18n, resume),
							A3($author$project$Components$Produits$Correspondances$View$identite, i18n, model, fiche)
						]),
					B2: A2(
						$elm$core$List$cons,
						A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
						_Utils_ap(
							enLectureSeule ? _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('lecture-seule')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$correspondancesLectureSeule(i18n))
										]))
								]) : _List_Nil,
							_List_fromArray(
								[
									function () {
									var _v0 = model.io;
									if (!_v0) {
										return A3($author$project$Components$Produits$Correspondances$View$lignes, i18n, model, fiche);
									} else {
										return A3($author$project$Components$Produits$Correspondances$View$matrice, i18n, model, fiche);
									}
								}()
								])))
				}),
			model);
	});
var $author$project$Components$Produits$Correspondances$View$view = F3(
	function (i18n, messages, model) {
		var _v0 = _Utils_Tuple3(model.nf, model.vf, model.zo);
		if (_v0.a) {
			return A2(
				$author$project$Components$Shared$Introuvable$View$view,
				i18n,
				{
					aa: $author$project$Routes$Route$adresseCorrespondances,
					Bl: $author$project$I18n$Cles$correspondancesRetour(i18n)
				});
		} else {
			if (!_v0.b.$) {
				if (!_v0.c.$) {
					var fiche = _v0.c.a;
					return A4($author$project$Components$Produits$Correspondances$View$pageDeLaFiche, i18n, messages, model, fiche);
				} else {
					var _v1 = _v0.c;
					return A3(
						$author$project$Components$Produits$Correspondances$View$annuaire,
						i18n,
						messages,
						_Utils_update(
							model,
							{aS: $elm$core$Maybe$Nothing}));
				}
			} else {
				var _v2 = _v0.b;
				return A3($author$project$Components$Produits$Correspondances$View$annuaire, i18n, messages, model);
			}
		}
	});
var $author$project$Components$Produits$FicheElement$View$nomDeLaPage = 'produits-marque-detail';
var $author$project$I18n$Cles$produitsCatalogueChampSousLicence = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.champ.sous-licence', _List_Nil, 'Sous licence');
};
var $author$project$I18n$Cles$produitsCatalogueMarqueAPropos = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.marque.a-propos', _List_Nil, 'À propos de la marque');
};
var $author$project$I18n$Cles$produitsCatalogueMarqueLicenceNon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.marque.licence-non', _List_Nil, 'Non');
};
var $author$project$I18n$Cles$produitsCatalogueMarqueLicenceOui = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.marque.licence-oui', _List_Nil, 'Oui');
};
var $author$project$Components$Produits$FicheElement$View$aPropos = F2(
	function (i18n, fiche) {
		return _Utils_eq(fiche.lQ.fA, $author$project$Catalogue$Vocabulaire$codeMarque) ? _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Page$View$section,
				_List_Nil,
				{
					fw: _List_Nil,
					fZ: _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$dl,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('infos')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$dt,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$produitsCatalogueChampNom(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$dd,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$Components$Produits$Common$Elements$nom(fiche.lQ))
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('licence')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$dt,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$produitsCatalogueChampSousLicence(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$dd,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													_Utils_eq(
														fiche.lQ.IY,
														$elm$core$Maybe$Just(true)) ? $author$project$I18n$Cles$produitsCatalogueMarqueLicenceOui(i18n) : $author$project$I18n$Cles$produitsCatalogueMarqueLicenceNon(i18n))
												]))
										]))
								]))
						]),
					Dj: 'a-propos',
					h6: $author$project$I18n$Cles$produitsCatalogueMarqueAPropos(i18n)
				})
			]) : _List_Nil;
	});
var $author$project$Components$Produits$FicheElement$Update$ArchivageDemande = function (a) {
	return {$: 18, a: a};
};
var $author$project$I18n$Cles$produitsCatalogueActionsArchiver = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.actions.archiver', _List_Nil, 'Archiver');
};
var $author$project$I18n$Cles$produitsCatalogueActionsArchiverDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.actions.archiver.de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Archiver ' + p.Dj);
	});
var $author$project$Components$Produits$FicheElement$View$archiver = F2(
	function (i18n, element) {
		return A2(
			$elm$core$List$any,
			function (rel) {
				return !_Utils_eq(
					A2($author$project$API$Liens$trouver, rel, element.nQ),
					$elm$core$Maybe$Nothing);
			},
			_List_fromArray(
				[$author$project$API$NavLinksDictionary$archiverUneMarque, $author$project$API$NavLinksDictionary$archiverUneGamme])) ? _List_fromArray(
			[
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						$author$project$Components$Produits$FicheElement$Model$idDeLArchivage(element.Aq)),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$FicheElement$Update$ArchivageDemande(element.Aq)),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-label',
						A2(
							$author$project$I18n$Cles$produitsCatalogueActionsArchiverDe,
							i18n,
							{
								Dj: $author$project$Components$Produits$Common$Elements$nom(element)
							})),
						$rtfeldman$elm_css$Html$Styled$Attributes$title(
						A2(
							$author$project$I18n$Cles$produitsCatalogueActionsArchiverDe,
							i18n,
							{
								Dj: $author$project$Components$Produits$Common$Elements$nom(element)
							}))
					]),
				$author$project$I18n$Cles$produitsCatalogueActionsArchiver(i18n))
			]) : _List_Nil;
	});
var $author$project$Components$Produits$FicheElement$Update$ArchivageConfirme = {$: 20};
var $author$project$Components$Produits$FicheElement$Update$FocusDemande = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Produits$FicheElement$Update$clavierDeLaConfirmation = function () {
	var ids = $author$project$Components$Produits$FicheElement$Model$idsDeLaConfirmation;
	return A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			var touche = _v0.a;
			var maj = _v0.b;
			var vers = _v0.c;
			return (touche !== 'Tab') ? $elm$json$Json$Decode$fail('') : ((maj && A2(
				$elm$core$List$member,
				vers,
				_List_fromArray(
					[ids.GN, ids.Cs]))) ? $elm$json$Json$Decode$succeed(
				_Utils_Tuple2(
					$author$project$Components$Produits$FicheElement$Update$FocusDemande(ids.j7),
					true)) : (((!maj) && A2(
				$elm$core$List$member,
				vers,
				_List_fromArray(
					[ids.GN, ids.j7]))) ? $elm$json$Json$Decode$succeed(
				_Utils_Tuple2(
					$author$project$Components$Produits$FicheElement$Update$FocusDemande(ids.Cs),
					true)) : $elm$json$Json$Decode$fail('')));
		},
		A4(
			$elm$json$Json$Decode$map3,
			F3(
				function (touche, maj, vers) {
					return _Utils_Tuple3(touche, maj, vers);
				}),
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['target', 'id']),
				$elm$json$Json$Decode$string)));
}();
var $author$project$I18n$Cles$produitsCatalogueArchivageAnnuler = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.archivage.annuler', _List_Nil, 'Annuler');
};
var $author$project$I18n$Cles$produitsCatalogueArchivageConfirmer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.archivage.confirmer', _List_Nil, 'Archiver');
};
var $author$project$I18n$Cles$produitsCatalogueArchivageTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.archivage.titre', _List_Nil, 'Confirmer l\'archivage');
};
var $author$project$Components$Produits$FicheElement$View$boite = F3(
	function (i18n, model, question) {
		var ids = $author$project$Components$Produits$FicheElement$Model$idsDeLaConfirmation;
		return A2(
			$author$project$Components$Shared$Confirmation$View$view,
			i18n,
			{
				vl: $author$project$Components$Produits$FicheElement$Update$clavierDeLaConfirmation,
				j7: {
					Aq: ids.j7,
					Bl: $author$project$I18n$Cles$produitsCatalogueArchivageConfirmer(i18n),
					C$: $author$project$Components$Produits$FicheElement$Update$ArchivageConfirme
				},
				Aq: ids.GN,
				As: ids.Cs,
				At: ids.h6,
				Cs: question,
				Et: !_Utils_eq(model.ir, $elm$core$Maybe$Nothing),
				HG: {
					Aq: ids.to,
					Bl: $author$project$I18n$Cles$produitsCatalogueArchivageAnnuler(i18n),
					C$: $author$project$Components$Produits$FicheElement$Update$ArchivageAnnule
				},
				h6: $author$project$I18n$Cles$produitsCatalogueArchivageTitre(i18n),
				sl: 0
			});
	});
var $author$project$I18n$Cles$produitsCatalogueNeutreArchiverQuestion = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.neutre.archiver.question',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Archiver « ' + (p.Dj + ' » ? L\'élément restera dans la liste, marqué archivé.'));
	});
var $author$project$Components$Produits$FicheElement$View$confirmation = F3(
	function (i18n, model, fiche) {
		var question = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var element = _v0.a;
					var niveau = _v0.b;
					return function (dire) {
						return dire(
							$author$project$Components$Produits$Common$Elements$nom(element));
					}(
						A2(
							$elm$core$Maybe$withDefault,
							function (nom) {
								return A2(
									$author$project$I18n$Cles$produitsCatalogueNeutreArchiverQuestion,
									i18n,
									{Dj: nom});
							},
							A2(
								$elm$core$Maybe$map,
								F2(
									function (connu, nom) {
										return A2(
											$author$project$I18n$Cles$texte,
											i18n,
											A2($author$project$Components$Produits$Common$Elements$tournures, i18n, connu).$7(nom));
									}),
								niveau)));
				},
				A2(
					$elm$core$Maybe$andThen,
					function (id) {
						return A2($author$project$Components$Produits$FicheElement$Model$cible, id, fiche);
					},
					model.ir)));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'opened',
							!_Utils_eq(model.ir, $elm$core$Maybe$Nothing))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('overlay'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$FicheElement$Update$ArchivageAnnule)
						]),
					_List_Nil),
					A3($author$project$Components$Produits$FicheElement$View$boite, i18n, model, question)
				]));
	});
var $author$project$Components$Produits$FicheElement$Update$DrawerValide = {$: 11};
var $author$project$Components$Produits$FicheElement$Update$Saisi = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Produits$FicheElement$Update$DeLaSaisieDesValeurs = function (a) {
	return {$: 27, a: a};
};
var $author$project$Components$Produits$FicheElement$Update$ValeurRetiree = function (a) {
	return {$: 28, a: a};
};
var $author$project$Components$Produits$FicheElement$Update$IssueDesValeurs = function (a) {
	return {$: 29, a: a};
};
var $author$project$I18n$Cles$produitsFicheElementValeursRefusEtageIssue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.fiche-element.valeurs.refus-etage-issue', _List_Nil, 'Fermer');
};
var $author$project$I18n$Cles$produitsFicheElementValeursRefusNiveauIssue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.fiche-element.valeurs.refus-niveau-issue', _List_Nil, 'Saisir sur un autre niveau');
};
var $author$project$I18n$Cles$produitsFicheElementValeursRefusRestrictionIssue = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.fiche-element.valeurs.refus-restriction-issue',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? 'Choisir la seule valeur' : ('Choisir une des ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeurs')));
	});
var $author$project$I18n$Cles$produitsFicheElementValeursRefusValeurIssue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.fiche-element.valeurs.refus-valeur-issue', _List_Nil, 'Corriger la valeur');
};
var $author$project$Components$Produits$FicheElement$View$issueDuRefus = F2(
	function (i18n, issue) {
		var libelle = function () {
			switch (issue.$) {
				case 0:
					return $author$project$I18n$Cles$produitsFicheElementValeursRefusValeurIssue(i18n);
				case 1:
					var n = issue.b;
					return A2(
						$author$project$I18n$Cles$produitsFicheElementValeursRefusRestrictionIssue,
						i18n,
						{w: n});
				case 2:
					return $author$project$I18n$Cles$produitsFicheElementValeursRefusNiveauIssue(i18n);
				default:
					return $author$project$I18n$Cles$produitsFicheElementValeursRefusEtageIssue(i18n);
			}
		}();
		return A3(
			$author$project$Components$Shared$Bouton$View$bouton,
			2,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('dash'),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Components$Produits$FicheElement$Update$IssueDesValeurs(issue))
				]),
			libelle);
	});
var $author$project$Components$Produits$FicheElement$Valeurs$presentation = F4(
	function (normes, lecture, fiche, page) {
		return {
			fr: function (_v0) {
				return 0;
			},
			dw: $author$project$Components$Produits$FicheElement$Valeurs$champs(page),
			jN: page.jN,
			Ba: fiche.Ba,
			np: lecture,
			hd: normes,
			pv: $author$project$Components$Produits$FicheElement$Valeurs$prefixe,
			sb: fiche.sb
		};
	});
var $author$project$I18n$Cles$produitsCatalogueActionsEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.actions.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$produitsFicheElementValeursDrawerSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.fiche-element.valeurs.drawer-sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'typologie',
					$author$project$I18n$Traductions$Chaine(p.r3))
				]),
			p.Dj + (' · typologie ' + p.r3));
	});
var $author$project$I18n$Cles$produitsFicheElementValeursDrawerTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.fiche-element.valeurs.drawer-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typologie',
					$author$project$I18n$Traductions$Chaine(p.r3))
				]),
			'Modifier : ' + p.r3);
	});
var $author$project$I18n$Cles$produitsFicheElementValeursInformation = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.fiche-element.valeurs.information',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Ces valeurs sont lues, sans ressaisie, par les références de ' + (p.Dj + '. Un champ vide se lit « Non renseigné ».'));
	});
var $author$project$I18n$Cles$produitsFicheElementValeursPied = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.fiche-element.valeurs.pied',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Enregistré pour ' + (p.Dj + ' seulement'));
	});
var $author$project$I18n$Cles$produitsFicheElementValeursRetirer = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.fiche-element.valeurs.retirer',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'Retirer la valeur de ' + p.uN);
	});
var $author$project$I18n$Cles$produitsFicheElementValeursRetirerNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.fiche-element.valeurs.retirer-note', _List_Nil, 'Retirer remet « Non renseigné » sur la marque et sur ses références.');
};
var $author$project$Components$Shared$Messages$View$messageAvecTitre = F3(
	function (i18n, titre, fourni) {
		return A2(
			$author$project$Components$Shared$Note$View$view,
			1,
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							function (t) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$b,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(t)
												]))
										]));
							},
							titre)
						])),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$I18n$Cles$texte, i18n, fourni.Jx))
							])),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							$author$project$Components$Shared$Messages$View$reference(i18n),
							fourni.b9)))));
	});
var $author$project$Components$Shared$Messages$View$vueAvecTitre = F3(
	function (i18n, titre, messages) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('messages'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$Components$Shared$Messages$View$messageAvecTitre, i18n, titre),
				messages));
	});
var $author$project$Components$Produits$FicheElement$View$contenuDesValeurs = F5(
	function (i18n, model, fiche, lot, actif) {
		var retraits = A2(
			$elm$core$List$map,
			function (champ) {
				return A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('dash'),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!actif),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Produits$FicheElement$Update$ValeurRetiree(champ.uN.dy))
						]),
					A2(
						$author$project$I18n$Cles$produitsFicheElementValeursRetirer,
						i18n,
						{uN: champ.uN.Bl}));
			},
			A2(
				$elm$core$List$filter,
				function (champ) {
					return !_Utils_eq(
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerLaValeurDUnChampHerite, champ.nQ),
						$elm$core$Maybe$Nothing);
				},
				lot.dw));
		var refus = function () {
			var _v0 = A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.pZ;
				},
				model.Ki);
			if (!_v0.$) {
				var dit = _v0.a;
				return _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Messages$View$vueAvecTitre,
						i18n,
						A2(
							$elm$core$Maybe$map,
							$author$project$I18n$Cles$texte(i18n),
							dit.h6),
						_List_fromArray(
							[dit.Cs])),
						A2($author$project$Components$Produits$FicheElement$View$issueDuRefus, i18n, dit.nh)
					]);
			} else {
				return _List_Nil;
			}
		}();
		var nom = $author$project$Components$Produits$Common$Elements$nom(fiche.lQ);
		return {
			fs: {
				sR: actif,
				Bl: $author$project$I18n$Cles$produitsCatalogueActionsEnregistrer(i18n),
				C$: $author$project$Components$Produits$FicheElement$Update$DrawerValide
			},
			fZ: _Utils_ap(
				refus,
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('information')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$produitsFicheElementValeursInformation,
										i18n,
										{Dj: nom}))
								]))
						]),
					_Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (saisie) {
									return A2(
										$elm$core$List$map,
										$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Produits$FicheElement$Update$DeLaSaisieDesValeurs),
										A4(
											$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$viewAvecIndications,
											i18n,
											{bB: true, yS: $elm$core$Maybe$Nothing, ou: nom},
											A4($author$project$Components$Produits$FicheElement$Valeurs$presentation, model.hd, false, fiche, lot),
											saisie));
								},
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.hP;
									},
									model.Ki))),
						_Utils_ap(
							retraits,
							_Utils_ap(
								$elm$core$List$isEmpty(retraits) ? _List_Nil : _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$produitsFicheElementValeursRetirerNote(i18n))
											]))
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('pied')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$produitsFicheElementValeursPied,
													i18n,
													{Dj: nom}))
											]))
									])))))),
			A6: $elm$core$Maybe$Just(
				A2(
					$author$project$I18n$Cles$produitsFicheElementValeursDrawerSousTitre,
					i18n,
					{Dj: nom, r3: lot.r3})),
			Bc: false,
			h6: A2(
				$author$project$I18n$Cles$produitsFicheElementValeursDrawerTitre,
				i18n,
				{r3: lot.r3})
		};
	});
var $author$project$I18n$Cles$produitsCatalogueGammesExisteSeparateur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.gammes.existe.separateur', _List_Nil, ' et à ');
};
var $author$project$I18n$Cles$produitsCatalogueGammesExisteTexte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.gammes.existe.texte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'marques',
					$author$project$I18n$Traductions$Chaine(p.cU)),
					_Utils_Tuple2(
					'marque',
					$author$project$I18n$Traductions$Chaine(p.gX))
				]),
			'Elle appartient à ' + (p.cU + ('. Elle sera aussi rangée sous ' + (p.gX + ' : c\'est la même gamme, avec son millésime et ses informations. Rien n\'est créé en double.'))));
	});
var $author$project$I18n$Cles$produitsCatalogueGammesExisteTexteSansMarque = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.gammes.existe.texte-sans-marque',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'marques',
					$author$project$I18n$Traductions$Chaine(p.cU))
				]),
			'Elle appartient à ' + (p.cU + '. Elle sera ouverte à toutes les marques : c\'est la même gamme, avec son millésime et ses informations. Rien n\'est créé en double.'));
	});
var $author$project$I18n$Cles$produitsCatalogueGammesExisteTexteSansMarqueToutes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.gammes.existe.texte-sans-marque-toutes', _List_Nil, 'Elle appartient déjà à toutes les marques : c\'est la même gamme, avec son millésime et ses informations. Rien n\'est créé en double.');
};
var $author$project$I18n$Cles$produitsCatalogueGammesExisteTexteToutes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.gammes.existe.texte-toutes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'marque',
					$author$project$I18n$Traductions$Chaine(p.gX))
				]),
			'Elle appartient à toutes les marques. Elle sera aussi rangée sous ' + (p.gX + ' : c\'est la même gamme, avec son millésime et ses informations. Rien n\'est créé en double.'));
	});
var $author$project$I18n$Cles$produitsCatalogueGammesExisteTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.gammes.existe.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'« ' + (p.Dj + ' » existe déjà'));
	});
var $author$project$Components$Produits$Common$GammeAAjouter$existe = F4(
	function (i18n, marque, gamme, chez) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('existe'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$produitsCatalogueGammesExisteTitre,
								i18n,
								{Dj: gamme.R.zX}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							function () {
								var _v0 = _Utils_Tuple2(marque, chez);
								if (!_v0.a.$) {
									if (!_v0.b.b) {
										var sous = _v0.a.a;
										return A2(
											$author$project$I18n$Cles$produitsCatalogueGammesExisteTexteToutes,
											i18n,
											{gX: sous});
									} else {
										var sous = _v0.a.a;
										return A2(
											$author$project$I18n$Cles$produitsCatalogueGammesExisteTexte,
											i18n,
											{
												gX: sous,
												cU: A2(
													$elm$core$String$join,
													$author$project$I18n$Cles$produitsCatalogueGammesExisteSeparateur(i18n),
													chez)
											});
									}
								} else {
									if (!_v0.b.b) {
										var _v1 = _v0.a;
										return $author$project$I18n$Cles$produitsCatalogueGammesExisteTexteSansMarqueToutes(i18n);
									} else {
										var _v2 = _v0.a;
										return A2(
											$author$project$I18n$Cles$produitsCatalogueGammesExisteTexteSansMarque,
											i18n,
											{
												cU: A2(
													$elm$core$String$join,
													$author$project$I18n$Cles$produitsCatalogueGammesExisteSeparateur(i18n),
													chez)
											});
									}
								}
							}())
						]))
				]));
	});
var $author$project$Components$Produits$Common$Gammes$marquesDeLaGamme = F2(
	function (deReference, gamme) {
		return gamme.rO ? _List_Nil : A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.R;
				},
				function ($) {
					return $.zX;
				}),
			A2(
				$elm$core$List$filter,
				function (marque) {
					return (!gamme.tx) || (!_Utils_eq(marque.Aq, deReference));
				},
				gamme.cU));
	});
var $author$project$Components$Produits$Common$Gammes$millesimeDeLaGamme = F2(
	function (portees, gamme) {
		var _v0 = gamme.n8;
		if (!_v0.$) {
			var annee = _v0.a;
			return $elm$core$Maybe$Just(annee);
		} else {
			return A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.n8;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(gamme.Aq)),
						portees)));
		}
	});
var $author$project$I18n$Cles$produitsCatalogueGammesExisteMillesime = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.gammes.existe.millesime', _List_Nil, 'Celui de la gamme existante ; il se modifie sur sa fiche.');
};
var $author$project$Components$Produits$Common$GammeAAjouter$millesimeGrise = F3(
	function (i18n, prefixe, millesime) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$fieldset,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('disabled')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$legend,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id(prefixe + '-millesime-libelle')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsCatalogueChampMillesime(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(prefixe + '-millesime'),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(
							A2($elm$core$Maybe$withDefault, '', millesime)),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-labelledby', prefixe + '-millesime-libelle')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsCatalogueGammesExisteMillesime(i18n))
						]))
				]));
	});
var $author$project$Components$Produits$Common$Saisie$Libelle = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Produits$Common$GammeAAjouter$nomsDeLaGamme = F5(
	function (i18n, prefixe, saisie, saisi, gamme) {
		var langue = function (code) {
			return A2($author$project$Referentiel$Langues$nom, i18n, code);
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('noms')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$map,
					saisi,
					A2(
						$author$project$Components$Shared$Champ$View$texte,
						{
							go: $elm$core$Maybe$Nothing,
							Aq: A2($author$project$Components$Produits$Common$Formulaire$idDuNom, 1, prefixe),
							Bl: A2(
								$author$project$I18n$Cles$saisieDeChampParNomDeLangue,
								i18n,
								{
									nn: langue('fr'),
									Bl: $author$project$I18n$Cles$produitsCatalogueChampNom(i18n)
								}),
							he: true
						},
						{
							hg: $author$project$Components$Produits$Common$Saisie$Libelle('fr'),
							fm: A2($author$project$Components$Shared$LibellesParLangue$Model$lire, 'fr', saisie.R)
						})),
					A2(
					$rtfeldman$elm_css$Html$Styled$fieldset,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('disabled')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$legend,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id(prefixe + '-nom-en-libelle')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$saisieDeChampParNomDeLangue,
												i18n,
												{
													nn: langue('en'),
													Bl: $author$project$I18n$Cles$produitsCatalogueChampNom(i18n)
												}))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id(prefixe + '-nom-en'),
									$rtfeldman$elm_css$Html$Styled$Attributes$value(
									A2($elm$core$Maybe$withDefault, '', gamme.R.yg)),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-labelledby', prefixe + '-nom-en-libelle')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$I18n$Cles$produitsCatalogueGammesRangeeApres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.gammes.rangee-apres', _List_Nil, ', la marque choisie.');
};
var $author$project$I18n$Cles$produitsCatalogueGammesRangeeAvant = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.gammes.rangee-avant', _List_Nil, 'La gamme sera rangée sous ');
};
var $author$project$I18n$Cles$produitsCatalogueGammesToutesApres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.gammes.toutes-apres', _List_Nil, ', y compris celles créées plus tard. Vous pourrez la retirer d\'une marque en décochant la gamme dans le volet de cette marque.');
};
var $author$project$I18n$Cles$produitsCatalogueGammesToutesAvant = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.gammes.toutes-avant', _List_Nil, 'Aucune marque n\'est choisie : la gamme appartiendra à ');
};
var $author$project$I18n$Cles$produitsCatalogueGammesToutesMilieu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.gammes.toutes-milieu', _List_Nil, 'toutes les marques');
};
var $author$project$Components$Produits$Common$GammeAAjouter$ou = F2(
	function (i18n, presentation) {
		var _v0 = presentation.gX;
		if (!_v0.$) {
			var marque = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('rangee')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsCatalogueGammesRangeeAvant(i18n)),
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(marque)
							])),
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsCatalogueGammesRangeeApres(i18n))
					]));
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('rangee'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('toutes')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsCatalogueGammesToutesAvant(i18n)),
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsCatalogueGammesToutesMilieu(i18n))
							])),
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsCatalogueGammesToutesApres(i18n))
					]));
		}
	});
var $author$project$I18n$Cles$produitsCatalogueActionsOuvrir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.actions.ouvrir', _List_Nil, 'Ouvrir à toutes les marques');
};
var $author$project$I18n$Cles$produitsCatalogueGammesAjouter = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.gammes.ajouter',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'niveau',
					$author$project$I18n$Traductions$Chaine(p.os))
				]),
			'Ajouter : ' + p.os);
	});
var $author$project$I18n$Cles$produitsCatalogueGammesDejaPortee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.gammes.deja-portee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'La marque porte déjà la gamme ' + (p.Dj + '.'));
	});
var $author$project$I18n$Cles$produitsCatalogueGammesRanger = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.gammes.ranger',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'marque',
					$author$project$I18n$Traductions$Chaine(p.gX))
				]),
			'Ranger sous ' + p.gX);
	});
var $author$project$Components$Produits$Common$Saisie$Millesime = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$Common$Saisie$Nom = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$Common$Saisie$SousLicence = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$Common$Saisie$erreurDuMillesime = function (saisie) {
	return saisie.b5 && _Utils_eq(
		$author$project$Components$Produits$Common$Saisie$millesimeValide(saisie),
		$elm$core$Maybe$Nothing);
};
var $author$project$Components$Produits$Common$Saisie$erreurDuNom = function (saisie) {
	return saisie.b5 && _Utils_eq(
		$author$project$Components$Produits$Common$Saisie$nonVide(saisie.Dj),
		$elm$core$Maybe$Nothing);
};
var $author$project$I18n$Cles$produitsCatalogueChampNomObligatoire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.champ.nom.obligatoire', _List_Nil, 'Le nom est obligatoire.');
};
var $author$project$Components$Produits$Common$Formulaire$nomParLangue = F3(
	function (i18n, presentation, saisie) {
		return A3(
			$author$project$Components$Shared$LibellesParLangue$View$view,
			i18n,
			_List_Nil,
			{
				go: function (code) {
					return A3($author$project$Components$Produits$Common$LibellesSaisis$manque, saisie.b5, saisie.R, code) ? $elm$core$Maybe$Just(
						$author$project$I18n$Cles$produitsCatalogueChampNomObligatoire(i18n)) : ((saisie.gi && _Utils_eq(
						$author$project$Components$Produits$Common$LibellesSaisis$premiereObligatoire,
						$elm$core$Maybe$Just(code))) ? $elm$core$Maybe$Just(presentation.gi) : $elm$core$Maybe$Nothing);
				},
				Ba: $author$project$Referentiel$Langues$desLibelles,
				Bl: $author$project$I18n$Cles$produitsCatalogueChampNom(i18n),
				hg: $author$project$Components$Produits$Common$Saisie$Libelle,
				pv: presentation.pv + '-nom',
				fm: function (code) {
					return A2($author$project$Components$Shared$LibellesParLangue$Model$lire, code, saisie.R);
				}
			});
	});
var $author$project$I18n$Cles$produitsCatalogueChampNomAnglais = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.champ.nom-anglais', _List_Nil, 'Nom (anglais)');
};
var $author$project$I18n$Cles$produitsCatalogueChampNomFrancais = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.champ.nom-francais', _List_Nil, 'Nom (français)');
};
var $author$project$Components$Produits$Common$Formulaire$champs = F4(
	function (i18n, enDeuxLangues, presentation, saisie) {
		var _v0 = presentation.gB;
		switch (_v0) {
			case 2:
				return _List_fromArray(
					[
						A3($author$project$Components$Produits$Common$Formulaire$nomParLangue, i18n, presentation, saisie)
					]);
			case 0:
				var nom = A2(
					$author$project$Components$Shared$Champ$View$texte,
					{
						go: $author$project$Components$Produits$Common$Saisie$erreurDuNom(saisie) ? $elm$core$Maybe$Just(
							$author$project$I18n$Cles$produitsCatalogueChampNomObligatoire(i18n)) : (saisie.gi ? $elm$core$Maybe$Just(presentation.gi) : $elm$core$Maybe$Nothing),
						Aq: A2($author$project$Components$Produits$Common$Formulaire$idDuNom, 0, presentation.pv),
						Bl: enDeuxLangues ? $author$project$I18n$Cles$produitsCatalogueChampNomFrancais(i18n) : $author$project$I18n$Cles$produitsCatalogueChampNom(i18n),
						he: true
					},
					{hg: $author$project$Components$Produits$Common$Saisie$Nom, fm: saisie.Dj});
				return _List_fromArray(
					[
						enDeuxLangues ? A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('deux-champs')
							]),
						_List_fromArray(
							[
								nom,
								A2(
								$author$project$Components$Shared$Champ$View$texteEnLectureSeule,
								{
									go: $elm$core$Maybe$Nothing,
									Aq: presentation.pv + '-nom-anglais',
									Bl: $author$project$I18n$Cles$produitsCatalogueChampNomAnglais(i18n),
									he: false
								},
								{fm: saisie.Dj})
							])) : nom,
						A2(
						$author$project$Components$Shared$Champ$View$caseACocher,
						{
							go: $elm$core$Maybe$Nothing,
							Aq: presentation.pv + '-sous-licence',
							Bl: $author$project$I18n$Cles$produitsCatalogueChampSousLicence(i18n),
							he: false
						},
						{vt: saisie.IY, D9: $author$project$Components$Produits$Common$Saisie$SousLicence})
					]);
			default:
				return _List_fromArray(
					[
						A3($author$project$Components$Produits$Common$Formulaire$nomParLangue, i18n, presentation, saisie),
						A2(
						$author$project$Components$Shared$Champ$View$texte,
						{
							go: $author$project$Components$Produits$Common$Saisie$erreurDuMillesime(saisie) ? $elm$core$Maybe$Just(
								$author$project$I18n$Cles$produitsCatalogueChampMillesimeInvalide(i18n)) : $elm$core$Maybe$Nothing,
							Aq: presentation.pv + '-millesime',
							Bl: $author$project$I18n$Cles$produitsCatalogueChampMillesime(i18n),
							he: false
						},
						{hg: $author$project$Components$Produits$Common$Saisie$Millesime, fm: saisie.n8})
					]);
		}
	});
var $author$project$Components$Produits$Common$Formulaire$parent = F2(
	function (prefixe, fourni) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$fieldset,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('disabled')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$legend,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id(prefixe + '-parent-libelle')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(fourni.Bl)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(prefixe + '-parent'),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(fourni.Dj),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-labelledby', prefixe + '-parent-libelle')
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$Shared$Messages$View$vueAvecFoyer = F3(
	function (i18n, identifiant, messages) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id(identifiant),
					$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('messages'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
				]),
			A2(
				$elm$core$List$map,
				$author$project$Components$Shared$Messages$View$message(i18n),
				messages));
	});
var $author$project$Components$Produits$Common$Formulaire$vueAvec = F4(
	function (i18n, enDeuxLangues, presentation, saisie) {
		return A2(
			$elm$core$List$cons,
			A3(
				$author$project$Components$Shared$Messages$View$vueAvecFoyer,
				i18n,
				$author$project$Components$Produits$Common$Formulaire$idDuRefus(presentation.pv),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $elm$core$List$singleton, saisie.pZ))),
			_Utils_ap(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Produits$Common$Formulaire$parent(presentation.pv),
							$elm$core$List$singleton),
						presentation.ey)),
				_Utils_ap(
					A4($author$project$Components$Produits$Common$Formulaire$champs, i18n, enDeuxLangues, presentation, saisie),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(presentation.oJ)
								]))
						]))));
	});
var $author$project$Components$Produits$Common$Formulaire$view = function (i18n) {
	return A2($author$project$Components$Produits$Common$Formulaire$vueAvec, i18n, false);
};
var $author$project$Components$Produits$Common$GammeAAjouter$contenu = F4(
	function (i18n, presentation, messages, saisie) {
		var marques = function (gamme) {
			return A2(
				$elm$core$Maybe$withDefault,
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.R;
						},
						function ($) {
							return $.zX;
						}),
					gamme.cU),
				A2(
					$elm$core$Maybe$map,
					function (reference) {
						return A2($author$project$Components$Produits$Common$Gammes$marquesDeLaGamme, reference, gamme);
					},
					presentation.f4));
		};
		var existante = A2($author$project$Components$Produits$Common$Gammes$gammeExistante, presentation.gG, saisie);
		var dejaPortee = (!_Utils_eq(presentation.f4, $elm$core$Maybe$Nothing)) && A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.tx;
				},
				existante));
		var champs = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$Html$Styled$map(messages.hO),
			A3(
				$author$project$Components$Produits$Common$Formulaire$view,
				i18n,
				{
					gi: A2($author$project$I18n$Cles$texte, i18n, presentation.gi),
					gB: 1,
					oJ: '',
					ey: $elm$core$Maybe$Nothing,
					pv: presentation.pv
				},
				saisie));
		return {
			fs: {
				sR: presentation.sO && (!dejaPortee),
				Bl: function () {
					var _v0 = _Utils_Tuple2(existante, presentation.gX);
					if (!_v0.a.$) {
						if (!_v0.b.$) {
							var marque = _v0.b.a;
							return dejaPortee ? A2($author$project$I18n$Cles$texte, i18n, presentation.fd.dC) : A2(
								$author$project$I18n$Cles$produitsCatalogueGammesRanger,
								i18n,
								{gX: marque});
						} else {
							var _v1 = _v0.b;
							return $author$project$I18n$Cles$produitsCatalogueActionsOuvrir(i18n);
						}
					} else {
						var _v2 = _v0.a;
						return A2($author$project$I18n$Cles$texte, i18n, presentation.fd.dC);
					}
				}(),
				C$: messages.sj
			},
			fZ: function () {
				var _v3 = _Utils_Tuple2(champs, existante);
				_v3$2:
				while (true) {
					if (_v3.a.b && _v3.a.b.b) {
						if (!_v3.b.$) {
							if ((_v3.a.b.b.b && _v3.a.b.b.b.b) && (!_v3.a.b.b.b.b.b)) {
								var _v4 = _v3.a;
								var refus = _v4.a;
								var _v5 = _v4.b;
								var _v6 = _v5.b;
								var _v7 = _v6.b;
								var aide = _v7.a;
								var gamme = _v3.b.a;
								return dejaPortee ? _List_fromArray(
									[
										refus,
										A2($author$project$Components$Produits$Common$GammeAAjouter$ou, i18n, presentation),
										A5($author$project$Components$Produits$Common$GammeAAjouter$nomsDeLaGamme, i18n, presentation.pv, saisie, messages.hO, gamme),
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('existe'),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$produitsCatalogueGammesDejaPortee,
													i18n,
													{Dj: gamme.R.zX}))
											])),
										A3(
										$author$project$Components$Produits$Common$GammeAAjouter$millesimeGrise,
										i18n,
										presentation.pv,
										A2($author$project$Components$Produits$Common$Gammes$millesimeDeLaGamme, presentation.hu, gamme)),
										aide
									]) : _List_fromArray(
									[
										refus,
										A2($author$project$Components$Produits$Common$GammeAAjouter$ou, i18n, presentation),
										A5($author$project$Components$Produits$Common$GammeAAjouter$nomsDeLaGamme, i18n, presentation.pv, saisie, messages.hO, gamme),
										A4(
										$author$project$Components$Produits$Common$GammeAAjouter$existe,
										i18n,
										presentation.gX,
										gamme,
										marques(gamme)),
										A3(
										$author$project$Components$Produits$Common$GammeAAjouter$millesimeGrise,
										i18n,
										presentation.pv,
										A2($author$project$Components$Produits$Common$Gammes$millesimeDeLaGamme, presentation.hu, gamme)),
										aide
									]);
							} else {
								break _v3$2;
							}
						} else {
							var _v8 = _v3.a;
							var refus = _v8.a;
							var _v9 = _v8.b;
							var noms = _v9.a;
							var suite = _v9.b;
							var _v10 = _v3.b;
							return A2(
								$elm$core$List$cons,
								refus,
								A2(
									$elm$core$List$cons,
									A2($author$project$Components$Produits$Common$GammeAAjouter$ou, i18n, presentation),
									A2($elm$core$List$cons, noms, suite)));
						}
					} else {
						break _v3$2;
					}
				}
				return A2(
					$elm$core$List$cons,
					A2($author$project$Components$Produits$Common$GammeAAjouter$ou, i18n, presentation),
					champs);
			}(),
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: A2(
				$author$project$I18n$Cles$produitsCatalogueGammesAjouter,
				i18n,
				{
					os: A2($author$project$I18n$Cles$texte, i18n, presentation.fd.Dj)
				})
		};
	});
var $author$project$Components$Produits$FicheElement$View$creationSousUneMarque = F5(
	function (i18n, model, fiche, niveau, actif) {
		return A4(
			$author$project$Components$Produits$Common$GammeAAjouter$contenu,
			i18n,
			{
				sO: actif,
				f4: $elm$core$Maybe$Just(fiche.lQ.Aq),
				gi: A2($author$project$Components$Produits$FicheElement$Model$sousLElement, i18n, fiche).gi,
				gG: fiche.z4,
				gX: $elm$core$Maybe$Just(
					$author$project$Components$Produits$Common$Elements$nom(fiche.lQ)),
				hu: fiche.yp,
				pv: $author$project$Components$Shared$Drawer$Model$idRacine(model.kX),
				fd: A2($author$project$Components$Produits$Common$Elements$tournures, i18n, niveau)
			},
			{hO: $author$project$Components$Produits$FicheElement$Update$Saisi, sj: $author$project$Components$Produits$FicheElement$Update$DrawerValide},
			model.hP);
	});
var $author$project$Components$Produits$FicheElement$Update$Descendu = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Produits$FicheElement$Update$Monte = function (a) {
	return {$: 12, a: a};
};
var $author$project$I18n$Cles$produitsStructureOrdreDescendreDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.structure.ordre.descendre-de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Descendre ' + p.Dj);
	});
var $author$project$I18n$Cles$produitsStructureOrdreMonterDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.structure.ordre.monter-de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Monter ' + p.Dj);
	});
var $author$project$Components$Produits$FicheElement$View$flechesDOrdre = F3(
	function (i18n, place, element) {
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$OrdreView$boutonDOrdre,
				0,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						A2($author$project$Components$Produits$FicheElement$Model$idDuBoutonDOrdre, element.Aq, 0)),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$FicheElement$Update$Monte(element.Aq)),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
						_Utils_eq(
							place.Ge,
							$elm$core$Maybe$Just(element.Aq)) || place.cF),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-label',
						A2(
							$author$project$I18n$Cles$produitsStructureOrdreMonterDe,
							i18n,
							{
								Dj: $author$project$Components$Produits$Common$Elements$nom(element)
							})),
						$rtfeldman$elm_css$Html$Styled$Attributes$title(
						A2(
							$author$project$I18n$Cles$produitsStructureOrdreMonterDe,
							i18n,
							{
								Dj: $author$project$Components$Produits$Common$Elements$nom(element)
							}))
					])),
				A2(
				$author$project$Components$Shared$OrdreView$boutonDOrdre,
				1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						A2($author$project$Components$Produits$FicheElement$Model$idDuBoutonDOrdre, element.Aq, 1)),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$FicheElement$Update$Descendu(element.Aq)),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
						_Utils_eq(
							place.xg,
							$elm$core$Maybe$Just(element.Aq)) || place.cF),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-label',
						A2(
							$author$project$I18n$Cles$produitsStructureOrdreDescendreDe,
							i18n,
							{
								Dj: $author$project$Components$Produits$Common$Elements$nom(element)
							})),
						$rtfeldman$elm_css$Html$Styled$Attributes$title(
						A2(
							$author$project$I18n$Cles$produitsStructureOrdreDescendreDe,
							i18n,
							{
								Dj: $author$project$Components$Produits$Common$Elements$nom(element)
							}))
					]))
			]);
	});
var $author$project$Components$Produits$FicheElement$Update$OuvertureDemandee = function (a) {
	return {$: 8, a: a};
};
var $author$project$I18n$Cles$produitsCatalogueActionsOuvrirDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.actions.ouvrir.de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Ouvrir ' + (p.Dj + ' à toutes les marques'));
	});
var $author$project$Components$Produits$FicheElement$View$ouvrir = F3(
	function (i18n, fiche, element) {
		return _Utils_eq(
			A2($author$project$Components$Produits$FicheElement$Model$commandeDOuverture, element.Aq, fiche),
			$elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
			[
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						$author$project$Components$Produits$FicheElement$Model$idDeLOuverture(element.Aq)),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$FicheElement$Update$OuvertureDemandee(element.Aq)),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-label',
						A2(
							$author$project$I18n$Cles$produitsCatalogueActionsOuvrirDe,
							i18n,
							{
								Dj: $author$project$Components$Produits$Common$Elements$nom(element)
							})),
						$rtfeldman$elm_css$Html$Styled$Attributes$title(
						A2(
							$author$project$I18n$Cles$produitsCatalogueActionsOuvrirDe,
							i18n,
							{
								Dj: $author$project$Components$Produits$Common$Elements$nom(element)
							}))
					]),
				$author$project$I18n$Cles$produitsCatalogueActionsOuvrir(i18n))
			]);
	});
var $author$project$Components$Produits$FicheElement$View$placement = F2(
	function (model, fiche) {
		var places = A2(
			$elm$core$List$map,
			function ($) {
				return $.Aq;
			},
			$author$project$Components$Produits$FicheElement$Model$ordonnables(fiche));
		return {
			xg: $elm$core$List$head(
				$elm$core$List$reverse(places)),
			cF: $author$project$Components$Produits$Common$Envoi$enCours(model.l2),
			m_: model.m_,
			bP: !_Utils_eq(
				A2($author$project$Components$Produits$FicheElement$Model$commandeDOrdre, fiche.yp, fiche),
				$elm$core$Maybe$Nothing),
			Ge: $elm$core$List$head(places)
		};
	});
var $author$project$Components$Produits$FicheElement$View$gestes = F4(
	function (i18n, model, fiche, id) {
		var _v0 = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Aq;
					},
					$elm$core$Basics$eq(id)),
				fiche.yp));
		if (!_v0.$) {
			var gamme = _v0.a;
			if (_Utils_eq(fiche.lQ.fA, $author$project$Catalogue$Vocabulaire$codeMarque)) {
				var place = A2($author$project$Components$Produits$FicheElement$View$placement, model, fiche);
				var ordonner = (place.bP && (!$author$project$Components$Produits$Common$Elements$archive(gamme))) ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('ordre')
							]),
						A3($author$project$Components$Produits$FicheElement$View$flechesDOrdre, i18n, place, gamme))
					]) : _List_Nil;
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('gestes')
							]),
						_Utils_ap(
							ordonner,
							_Utils_ap(
								A3($author$project$Components$Produits$FicheElement$View$ouvrir, i18n, fiche, gamme),
								A2($author$project$Components$Produits$FicheElement$View$archiver, i18n, gamme))))
					]);
			} else {
				return _List_Nil;
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Produits$FicheElement$Update$Depose = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Produits$FicheElement$Update$GlisserCommence = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Produits$FicheElement$Update$GlisserFini = {$: 17};
var $author$project$Components$Produits$FicheElement$Update$GlisserSurvole = {$: 15};
var $rtfeldman$elm_css$Html$Styled$Attributes$draggable = $rtfeldman$elm_css$VirtualDom$Styled$attribute('draggable');
var $author$project$Components$Produits$FicheElement$View$glisser = F2(
	function (place, element) {
		return (place.bP && (!$author$project$Components$Produits$Common$Elements$archive(element))) ? _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$draggable('true'),
				A2(
				$rtfeldman$elm_css$Html$Styled$Events$on,
				'dragstart',
				$elm$json$Json$Decode$succeed(
					$author$project$Components$Produits$FicheElement$Update$GlisserCommence(element.Aq))),
				A2(
				$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
				'dragover',
				$elm$json$Json$Decode$succeed(
					_Utils_Tuple2($author$project$Components$Produits$FicheElement$Update$GlisserSurvole, true))),
				A2(
				$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
				'drop',
				$elm$json$Json$Decode$succeed(
					_Utils_Tuple2(
						$author$project$Components$Produits$FicheElement$Update$Depose(element.Aq),
						true))),
				A2(
				$rtfeldman$elm_css$Html$Styled$Events$on,
				'dragend',
				$elm$json$Json$Decode$succeed($author$project$Components$Produits$FicheElement$Update$GlisserFini))
			]) : _List_Nil;
	});
var $author$project$I18n$Cles$produitsCatalogueGammesOrdonnerIntro = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.gammes.ordonner-intro',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'marque',
					$author$project$I18n$Traductions$Chaine(p.gX))
				]),
			'Glissez une gamme par sa poignée, ou montez-la et descendez-la avec les flèches. L\'ordre vaut pour ' + (p.gX + ' seulement.'));
	});
var $author$project$Components$Shared$Svg$svgDragHandle = A3($author$project$Components$Shared$Svg$icone, 'drag-handle', 'M9 6h0M15 6h0M9 12h0M15 12h0M9 18h0M15 18h0', _List_Nil);
var $author$project$Components$Produits$FicheElement$View$ordreDesGammes = F3(
	function (i18n, model, fiche) {
		var place = A2($author$project$Components$Produits$FicheElement$View$placement, model, fiche);
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('intro')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$produitsCatalogueGammesOrdonnerIntro,
							i18n,
							{
								gX: $author$project$Components$Produits$Common$Elements$nom(fiche.lQ)
							}))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$ul,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ordre-des-gammes')
					]),
				A2(
					$elm$core$List$map,
					function (gamme) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$li,
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne'),
								A2($author$project$Components$Produits$FicheElement$View$glisser, place, gamme)),
							A2(
								$elm$core$List$cons,
								A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('poignee')
										]),
									_List_fromArray(
										[$author$project$Components$Shared$Svg$svgDragHandle])),
								A2(
									$elm$core$List$cons,
									A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$Components$Produits$Common$Elements$nom(gamme))
											])),
									A3($author$project$Components$Produits$FicheElement$View$flechesDOrdre, i18n, place, gamme))));
					},
					$author$project$Components$Produits$FicheElement$Model$ordonnables(fiche)))
			]);
	});
var $author$project$I18n$Cles$produitsCatalogueGammesOrdonnerTermine = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.gammes.ordonner-termine', _List_Nil, 'Terminé');
};
var $author$project$I18n$Cles$produitsCatalogueGammesOrdonnerTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.gammes.ordonner-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'marque',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.gX)))
				]),
			'Ordonner les gammes ' + function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.gX);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.gX);
					default:
						return 'de ' + $elm$core$String$trim(p.gX);
				}
			}());
	});
var $author$project$Components$Produits$FicheElement$View$drawer = F3(
	function (i18n, model, fiche) {
		var sous = A2($author$project$Components$Produits$FicheElement$Model$sousLElement, i18n, fiche);
		var sansContenu = {
			fs: {sR: false, Bl: '', C$: $author$project$Components$Produits$FicheElement$Update$DrawerValide},
			fZ: _List_Nil,
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: ''
		};
		var modifiable = function (_v7) {
			var element = _v7.a;
			var niveau = _v7.b;
			return A3(
				$elm$core$Maybe$map2,
				F2(
					function (_v6, servi) {
						var forme = _v6.a;
						return {
							gB: forme,
							fd: A2($author$project$Components$Produits$Common$Elements$tournures, i18n, servi)
						};
					}),
				$author$project$Components$Produits$FicheElement$Model$formeDeLaModification(element),
				niveau);
		};
		var formulaire = F2(
			function (forme, parent) {
				return A2(
					$elm$core$List$map,
					$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Produits$FicheElement$Update$Saisi),
					A3(
						$author$project$Components$Produits$Common$Formulaire$view,
						i18n,
						{
							gi: A2($author$project$I18n$Cles$texte, i18n, sous.gi),
							gB: forme,
							oJ: _Utils_eq(parent, $elm$core$Maybe$Nothing) ? '' : A2($author$project$I18n$Cles$texte, i18n, sous.oJ),
							ey: parent,
							pv: $author$project$Components$Shared$Drawer$Model$idRacine(model.kX)
						},
						model.hP));
			});
		var actif = !$author$project$Components$Produits$Common$Envoi$enCours(model.l2);
		var contenu = function () {
			var _v0 = _Utils_Tuple3(
				model.mW,
				$author$project$Components$Produits$FicheElement$Model$formeDeLaCreation(fiche),
				fiche.C8);
			_v0$4:
			while (true) {
				switch (_v0.a.$) {
					case 1:
						if ((!_v0.b.$) && (!_v0.c.$)) {
							var _v1 = _v0.a;
							var _v2 = _v0.b.a;
							var forme = _v2.a;
							var niveau = _v0.c.a;
							return _Utils_eq(fiche.lQ.fA, $author$project$Catalogue$Vocabulaire$codeMarque) ? A5($author$project$Components$Produits$FicheElement$View$creationSousUneMarque, i18n, model, fiche, niveau, actif) : {
								fs: {
									sR: actif,
									Bl: A2(
										$author$project$I18n$Cles$texte,
										i18n,
										A2($author$project$Components$Produits$Common$Elements$tournures, i18n, niveau).dC),
									C$: $author$project$Components$Produits$FicheElement$Update$DrawerValide
								},
								fZ: A2(
									formulaire,
									forme,
									$elm$core$Maybe$Just(
										{
											Bl: A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													A2(
														$elm$core$Basics$composeR,
														$author$project$Components$Produits$Common$Elements$tournures(i18n),
														A2(
															$elm$core$Basics$composeR,
															function ($) {
																return $.Dj;
															},
															$author$project$I18n$Cles$texte(i18n))),
													fiche.os)),
											Dj: $author$project$Components$Produits$Common$Elements$nom(fiche.lQ)
										})),
								A6: $elm$core$Maybe$Nothing,
								Bc: false,
								h6: A2(
									$author$project$I18n$Cles$texte,
									i18n,
									A2($author$project$Components$Produits$Common$Elements$tournures, i18n, niveau).en)
							};
						} else {
							break _v0$4;
						}
					case 3:
						var _v3 = _v0.a;
						return {
							fs: {
								sR: true,
								Bl: $author$project$I18n$Cles$produitsCatalogueGammesOrdonnerTermine(i18n),
								C$: $author$project$Components$Produits$FicheElement$Update$DrawerValide
							},
							fZ: A3($author$project$Components$Produits$FicheElement$View$ordreDesGammes, i18n, model, fiche),
							A6: $elm$core$Maybe$Nothing,
							Bc: false,
							h6: A2(
								$author$project$I18n$Cles$produitsCatalogueGammesOrdonnerTitre,
								i18n,
								{
									av: $author$project$Texte$Elision$elision(
										$author$project$Components$Produits$Common$Elements$nom(fiche.lQ)),
									gX: $author$project$Components$Produits$Common$Elements$nom(fiche.lQ)
								})
						};
					case 2:
						var id = _v0.a.a;
						var _v4 = A2(
							$elm$core$Maybe$andThen,
							modifiable,
							A2($author$project$Components$Produits$FicheElement$Model$cible, id, fiche));
						if (!_v4.$) {
							var modification = _v4.a;
							return {
								fs: {
									sR: actif,
									Bl: $author$project$I18n$Cles$produitsCatalogueActionsEnregistrer(i18n),
									C$: $author$project$Components$Produits$FicheElement$Update$DrawerValide
								},
								fZ: function (formulaire_) {
									return _Utils_ap(
										formulaire_,
										A4($author$project$Components$Produits$FicheElement$View$gestes, i18n, model, fiche, id));
								}(
									A2(
										$elm$core$List$map,
										$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Produits$FicheElement$Update$Saisi),
										A3(
											$author$project$Components$Produits$Common$Formulaire$view,
											i18n,
											{
												gi: A2(
													$author$project$I18n$Cles$texte,
													i18n,
													_Utils_eq(id, fiche.lQ.Aq) ? modification.fd.gi : sous.gi),
												gB: modification.gB,
												oJ: '',
												ey: $elm$core$Maybe$Nothing,
												pv: $author$project$Components$Shared$Drawer$Model$idRacine(model.kX)
											},
											model.hP))),
								A6: $elm$core$Maybe$Nothing,
								Bc: false,
								h6: A2($author$project$I18n$Cles$texte, i18n, modification.fd.ei)
							};
						} else {
							return sansContenu;
						}
					case 4:
						var rang = _v0.a.a;
						var _v5 = A2($author$project$Components$Produits$FicheElement$Valeurs$bloc, rang, fiche);
						if (!_v5.$) {
							var lot = _v5.a;
							return A5($author$project$Components$Produits$FicheElement$View$contenuDesValeurs, i18n, model, fiche, lot, actif);
						} else {
							return sansContenu;
						}
					default:
						break _v0$4;
				}
			}
			return sansContenu;
		}();
		return A4($author$project$Components$Shared$Drawer$View$view, i18n, $author$project$Components$Produits$FicheElement$Update$DuDrawer, contenu, model.kX);
	});
var $author$project$I18n$Cles$produitsCatalogueEtatActive = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.etat.active', _List_Nil, 'Active');
};
var $author$project$I18n$Cles$produitsCatalogueEtatArchivee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.etat.archivee', _List_Nil, 'Archivée');
};
var $author$project$Catalogue$Vocabulaire$etatDElement = F2(
	function (i18n, code) {
		return _Utils_eq(code, $author$project$Catalogue$Vocabulaire$etatActif) ? $author$project$I18n$Cles$produitsCatalogueEtatActive(i18n) : (_Utils_eq(code, $author$project$Catalogue$Vocabulaire$etatArchive) ? $author$project$I18n$Cles$produitsCatalogueEtatArchivee(i18n) : code);
	});
var $author$project$Components$Produits$FicheElement$View$etat = F2(
	function (i18n, element) {
		return $author$project$Components$Produits$Common$Elements$archive(element) ? _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Tag$View$view,
				3,
				A2($author$project$Catalogue$Vocabulaire$etatDElement, i18n, element.gt))
			]) : _List_Nil;
	});
var $author$project$Components$Produits$FicheElement$Update$ModificationOuverte = function (a) {
	return {$: 7, a: a};
};
var $author$project$I18n$Cles$produitsCatalogueActionsModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.actions.modifier', _List_Nil, 'Modifier');
};
var $author$project$I18n$Cles$produitsCatalogueActionsModifierDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.actions.modifier.de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Modifier ' + p.Dj);
	});
var $author$project$Components$Produits$FicheElement$View$modifier = F3(
	function (i18n, variante, element) {
		var _v0 = $author$project$Components$Produits$FicheElement$Model$formeDeLaModification(element);
		if (!_v0.$) {
			return _List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					variante,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id(
							$author$project$Components$Produits$FicheElement$Model$idDeLaModification(element.Aq)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Produits$FicheElement$Update$ModificationOuverte(element.Aq)),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-label',
							A2(
								$author$project$I18n$Cles$produitsCatalogueActionsModifierDe,
								i18n,
								{
									Dj: $author$project$Components$Produits$Common$Elements$nom(element)
								})),
							$rtfeldman$elm_css$Html$Styled$Attributes$title(
							A2(
								$author$project$I18n$Cles$produitsCatalogueActionsModifierDe,
								i18n,
								{
									Dj: $author$project$Components$Produits$Common$Elements$nom(element)
								}))
						]),
					$author$project$I18n$Cles$produitsCatalogueActionsModifier(i18n))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Shared$OrdreDesBlocs$Update$Enregistre = {$: 9};
var $author$project$Components$Shared$OrdreDesBlocs$Update$RepriseDemandee = {$: 8};
var $author$project$Components$Shared$OrdreDesBlocs$Model$herite = function (model) {
	var _v0 = model.B0;
	if (!_v0.$) {
		var lu = _v0.a;
		return (!_Utils_eq(lu.IR, $elm$core$Maybe$Nothing)) && (!_Utils_eq(
			lu.IR,
			$elm$core$Maybe$Just(lu.c0)));
	} else {
		return false;
	}
};
var $author$project$I18n$Cles$ordreDesBlocsAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'ordre-des-blocs.aucun', _List_Nil, 'Aucun ordre n\'est réglé : les collections suivent l\'ordre du client. Modifier l\'ordre ci-dessous lui donne un ordre propre (liste complète).');
};
var $author$project$I18n$Cles$ordreDesBlocsHerite = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'ordre-des-blocs.herite',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'porteur',
					$author$project$I18n$Traductions$Chaine(p.c0)),
					_Utils_Tuple2(
					'parent',
					$author$project$I18n$Traductions$Chaine(p.ey))
				]),
			p.c0 + (' hérite de l\'ordre de ' + (p.ey + ('. Il suit tout changement fait sur ' + (p.ey + '. Modifier l\'ordre ci-dessous lui donne un ordre propre (liste complète).')))));
	});
var $author$project$I18n$Cles$ordreDesBlocsPropre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'ordre-des-blocs.propre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Ordre propre à « ' + (p.Dj + ' ».'));
	});
var $author$project$I18n$Cles$ordreDesBlocsPropreAide = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'ordre-des-blocs.propre-aide',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'porteur',
					$author$project$I18n$Traductions$Chaine(p.c0)),
					_Utils_Tuple2(
					'parent',
					$author$project$I18n$Traductions$Chaine(p.ey))
				]),
			p.c0 + (' ne suit plus l\'ordre de ' + (p.ey + ('. Une collection ajoutée plus tard à ' + (p.ey + ' se placera en fin de liste ici.')))));
	});
var $author$project$I18n$Cles$ordreDesBlocsPropreAideClient = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'ordre-des-blocs.propre-aide-client',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'porteur',
					$author$project$I18n$Traductions$Chaine(p.c0))
				]),
			p.c0 + ' ne suit plus l\'ordre du client. Une collection ajoutée plus tard se placera en fin de liste ici.');
	});
var $author$project$I18n$Cles$ordreDesBlocsPropreAideSansParent = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'ordre-des-blocs.propre-aide-sans-parent', _List_Nil, 'Une collection ajoutée plus tard au type se placera en fin de liste.');
};
var $author$project$I18n$Cles$ordreDesBlocsReprendre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'ordre-des-blocs.reprendre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'parent',
					$author$project$I18n$Traductions$Chaine(p.ey))
				]),
			'Reprendre l\'ordre de ' + p.ey);
	});
var $author$project$I18n$Cles$ordreDesBlocsReprendreClient = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'ordre-des-blocs.reprendre-client', _List_Nil, 'Reprendre l\'ordre du client');
};
var $author$project$I18n$Cles$ordreDesBlocsRepriseAnnoncee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'ordre-des-blocs.reprise-annoncee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'parent',
					$author$project$I18n$Traductions$Chaine(p.ey))
				]),
			'À l\'enregistrement, « ' + (p.Dj + (' » suivra de nouveau l\'ordre de ' + (p.ey + '.'))));
	});
var $author$project$I18n$Cles$ordreDesBlocsRepriseAnnonceeClient = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'ordre-des-blocs.reprise-annoncee-client',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'À l\'enregistrement, « ' + (p.Dj + ' » suivra de nouveau l\'ordre du client.'));
	});
var $author$project$I18n$Cles$ordreDesBlocsSonParent = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'ordre-des-blocs.son-parent', _List_Nil, 'son parent');
};
var $author$project$Components$Shared$OrdreDesBlocs$Model$propre = function (model) {
	var _v0 = model.B0;
	if (!_v0.$) {
		var lu = _v0.a;
		return _Utils_eq(
			lu.IR,
			$elm$core$Maybe$Just(lu.c0));
	} else {
		return false;
	}
};
var $author$project$Components$Shared$OrdreDesBlocs$Model$peutReprendre = function (model) {
	return $author$project$Components$Shared$OrdreDesBlocs$Model$propre(model) && A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				$elm$core$List$any(
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.eP;
						},
						$elm$core$Basics$eq('reprendre-l-ordre-du-parent')))),
			model.B0));
};
var $author$project$Components$Shared$OrdreDesBlocs$View$ligneDEtat = F3(
	function (i18n, config, model) {
		var nomDuParent = A2(
			$elm$core$Maybe$withDefault,
			config.ey,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Maybe$Just,
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.EZ;
					},
					model.B0)));
		var entre = function (nom) {
			return '« ' + (nom + ' »');
		};
		var parent = A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Cles$ordreDesBlocsSonParent(i18n),
			A2($elm$core$Maybe$map, entre, nomDuParent));
		var source = A2(
			$elm$core$Maybe$withDefault,
			parent,
			A2(
				$elm$core$Maybe$map,
				entre,
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.IS;
					},
					model.B0)));
		var duClient = _Utils_eq(nomDuParent, $elm$core$Maybe$Nothing) && (!config.Io);
		return model.qx ? A2(
			$author$project$Components$Shared$Note$View$view,
			0,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							duClient ? A2(
								$author$project$I18n$Cles$ordreDesBlocsRepriseAnnonceeClient,
								i18n,
								{Dj: config.Dj}) : A2(
								$author$project$I18n$Cles$ordreDesBlocsRepriseAnnoncee,
								i18n,
								{Dj: config.Dj, ey: parent}))
						]))
				])) : ($author$project$Components$Shared$OrdreDesBlocs$Model$propre(model) ? A2(
			$author$project$Components$Shared$Note$View$view,
			1,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$ordreDesBlocsPropre,
								i18n,
								{Dj: config.Dj}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							config.Io ? $author$project$I18n$Cles$ordreDesBlocsPropreAideSansParent(i18n) : (duClient ? A2(
								$author$project$I18n$Cles$ordreDesBlocsPropreAideClient,
								i18n,
								{c0: config.c0}) : A2(
								$author$project$I18n$Cles$ordreDesBlocsPropreAide,
								i18n,
								{ey: parent, c0: config.c0})))
						])),
					$author$project$Components$Shared$OrdreDesBlocs$Model$peutReprendre(model) ? A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('reprendre'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							config.KD($author$project$Components$Shared$OrdreDesBlocs$Update$RepriseDemandee))
						]),
					function () {
						if (!nomDuParent.$) {
							var nom = nomDuParent.a;
							return A2(
								$author$project$I18n$Cles$ordreDesBlocsReprendre,
								i18n,
								{ey: nom});
						} else {
							return $author$project$I18n$Cles$ordreDesBlocsReprendreClient(i18n);
						}
					}()) : $rtfeldman$elm_css$Html$Styled$text('')
				])) : ($author$project$Components$Shared$OrdreDesBlocs$Model$herite(model) ? A2(
			$author$project$Components$Shared$Note$View$view,
			0,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$ordreDesBlocsHerite,
								i18n,
								{ey: source, c0: config.c0}))
						]))
				])) : A2(
			$author$project$Components$Shared$Note$View$view,
			0,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$ordreDesBlocsAucun(i18n))
						]))
				]))));
	});
var $author$project$Components$Shared$OrdreDesBlocs$Update$DeposeSur = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Shared$OrdreDesBlocs$Update$Descend = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Shared$OrdreDesBlocs$Update$Glisse = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Shared$OrdreDesBlocs$Update$Monte = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Shared$OrdreDesBlocs$Update$Survol = {$: 7};
var $author$project$Components$Shared$OrdreDesBlocs$Model$deplacees = function (model) {
	return model.Q;
};
var $author$project$I18n$Cles$ordreDesBlocsChamps = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'ordre-des-blocs.champs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champ') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champs'));
	});
var $author$project$I18n$Cles$ordreDesBlocsDeplacee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'ordre-des-blocs.deplacee', _List_Nil, 'déplacée');
};
var $author$project$Components$Shared$OrdreDesBlocs$View$uneLigne = F4(
	function (i18n, config, model, bloc) {
		var vers = function (geste) {
			return config.KD(geste);
		};
		var figee = model.qx;
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'deplacee',
							A2(
								$elm$core$List$member,
								bloc.dy,
								$author$project$Components$Shared$OrdreDesBlocs$Model$deplacees(model)))
						])),
					$rtfeldman$elm_css$Html$Styled$Attributes$draggable(
					figee ? 'false' : 'true'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Events$on,
					'dragstart',
					$elm$json$Json$Decode$succeed(
						vers(
							$author$project$Components$Shared$OrdreDesBlocs$Update$Glisse(bloc.dy)))),
					A2(
					$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
					'dragover',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2(
							vers($author$project$Components$Shared$OrdreDesBlocs$Update$Survol),
							true))),
					A2(
					$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
					'drop',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2(
							vers(
								$author$project$Components$Shared$OrdreDesBlocs$Update$DeposeSur(bloc.dy)),
							true)))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('poignee')
						]),
					_List_fromArray(
						[$author$project$Components$Shared$Svg$svgDragHandle])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('fleches')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$OrdreView$boutonDOrdre,
							0,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id('ordre-des-blocs-' + (bloc.dy + '-monter')),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									A2(
										$author$project$I18n$Cles$produitsStructureOrdreMonterDe,
										i18n,
										{Dj: bloc.Bl})),
									$rtfeldman$elm_css$Html$Styled$Attributes$title(
									A2(
										$author$project$I18n$Cles$produitsStructureOrdreMonterDe,
										i18n,
										{Dj: bloc.Bl})),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									vers(
										$author$project$Components$Shared$OrdreDesBlocs$Update$Monte(bloc.dy))),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(figee)
								])),
							A2(
							$author$project$Components$Shared$OrdreView$boutonDOrdre,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id('ordre-des-blocs-' + (bloc.dy + '-descendre')),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									A2(
										$author$project$I18n$Cles$produitsStructureOrdreDescendreDe,
										i18n,
										{Dj: bloc.Bl})),
									$rtfeldman$elm_css$Html$Styled$Attributes$title(
									A2(
										$author$project$I18n$Cles$produitsStructureOrdreDescendreDe,
										i18n,
										{Dj: bloc.Bl})),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									vers(
										$author$project$Components$Shared$OrdreDesBlocs$Update$Descend(bloc.dy))),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(figee)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(bloc.Bl)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nombre')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$ordreDesBlocsChamps,
										i18n,
										{w: bloc.dw}))
								]))
						])),
					A2(
					$elm$core$List$member,
					bloc.dy,
					$author$project$Components$Shared$OrdreDesBlocs$Model$deplacees(model)) ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('tag'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('deplacee')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$ordreDesBlocsDeplacee(i18n))
						])) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$Components$Shared$OrdreDesBlocs$View$contenu = F3(
	function (i18n, config, model) {
		return _List_fromArray(
			[
				A3($author$project$Components$Shared$OrdreDesBlocs$View$ligneDEtat, i18n, config, model),
				A2(
				$rtfeldman$elm_css$Html$Styled$ul,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ordre-des-blocs')
					]),
				A2(
					$elm$core$List$map,
					A3($author$project$Components$Shared$OrdreDesBlocs$View$uneLigne, i18n, config, model),
					model.El))
			]);
	});
var $author$project$I18n$Cles$ordreDesBlocsAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'ordre-des-blocs.action', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$ordreDesBlocsSousTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'ordre-des-blocs.sous-titre', _List_Nil, 'Ordre des collections sur la fiche.');
};
var $author$project$I18n$Cles$ordreDesBlocsTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'ordre-des-blocs.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Ordonner les blocs de « ' + (p.Dj + ' »'));
	});
var $author$project$Components$Shared$OrdreDesBlocs$View$drawer = F3(
	function (i18n, config, model) {
		var versLeDrawer = function (geste) {
			return config.KD(
				$author$project$Components$Shared$OrdreDesBlocs$Update$DuDrawer(geste));
		};
		return A6(
			$author$project$Components$Shared$Drawer$View$viewAvecPiedLibreEtSousTitre,
			i18n,
			$author$project$I18n$Cles$ordreDesBlocsSousTitre(i18n),
			{
				oJ: $elm$core$Maybe$Just(config.aj),
				HF: function (attributs) {
					return A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_Utils_ap(
							attributs,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									versLeDrawer($author$project$Components$Shared$Drawer$Update$Fermer))
								])),
						$author$project$I18n$Cles$drawerAnnuler(i18n));
				},
				Jb: _List_Nil
			},
			versLeDrawer,
			{
				fs: {
					sR: $author$project$Components$Shared$OrdreDesBlocs$Model$modifie(model) && (!config.cF),
					Bl: $author$project$I18n$Cles$ordreDesBlocsAction(i18n),
					C$: config.KD($author$project$Components$Shared$OrdreDesBlocs$Update$Enregistre)
				},
				fZ: A3($author$project$Components$Shared$OrdreDesBlocs$View$contenu, i18n, config, model),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: A2(
					$author$project$I18n$Cles$ordreDesBlocsTitre,
					i18n,
					{Dj: config.Dj})
			},
			model.kX);
	});
var $author$project$I18n$Cles$ordreDesBlocsCetEtage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'ordre-des-blocs.cet-etage', _List_Nil, 'Cet étage');
};
var $author$project$I18n$Cles$ordreDesBlocsPiedEtage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'ordre-des-blocs.pied-etage',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Valable pour les fiches de ' + (p.Dj + ' et de ses enfants'));
	});
var $author$project$Components$Produits$FicheElement$View$ordreDesBlocs = F3(
	function (i18n, model, fiche) {
		var nom = $author$project$Components$Produits$Common$Elements$nom(fiche.lQ);
		return A3(
			$author$project$Components$Shared$OrdreDesBlocs$View$drawer,
			i18n,
			{
				cF: $author$project$Components$Produits$Common$Envoi$enCours(model.l2),
				Dj: nom,
				ey: A2(
					$elm$core$Maybe$map,
					function (parent) {
						return parent.R.zX;
					},
					fiche.ey),
				aj: A2(
					$author$project$I18n$Cles$ordreDesBlocsPiedEtage,
					i18n,
					{Dj: nom}),
				c0: $author$project$I18n$Cles$ordreDesBlocsCetEtage(i18n),
				Io: false,
				KD: $author$project$Components$Produits$FicheElement$Update$DesBlocs
			},
			model.o1);
	});
var $author$project$Components$Produits$FicheElement$Update$CreationOuverte = {$: 5};
var $author$project$Components$Produits$FicheElement$View$ajout = F3(
	function (i18n, fiche, tournures) {
		var _v0 = $author$project$Components$Produits$FicheElement$Model$formeDeLaCreation(fiche);
		if (!_v0.$) {
			return _List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$FicheElement$Model$idDeLaCreation),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$FicheElement$Update$CreationOuverte)
						]),
					A2($author$project$I18n$Cles$texte, i18n, tournures.en))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Produits$FicheElement$View$versLaFiche = A2($elm$core$Basics$composeR, $author$project$Routes$Route$FicheElement, $author$project$Routes$Route$toString);
var $author$project$Components$Produits$FicheElement$View$lienDuNom = function (element) {
	var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$self, element.nQ);
	if (!_v0.$) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$href(
					$author$project$Components$Produits$FicheElement$View$versLaFiche(element.Aq))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Components$Produits$Common$Elements$nom(element))
						]))
				]));
	} else {
		return A2(
			$rtfeldman$elm_css$Html$Styled$strong,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$Components$Produits$Common$Elements$nom(element))
				]));
	}
};
var $author$project$Components$Produits$FicheElement$View$ordre = F3(
	function (i18n, place, element) {
		return (!place.bP) ? _List_Nil : ($author$project$Components$Produits$Common$Elements$archive(element) ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ordre')
					]),
				_List_Nil)
			]) : _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ordre')
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('poignee')
							]),
						_List_fromArray(
							[$author$project$Components$Shared$Svg$svgDragHandle])),
					A3($author$project$Components$Produits$FicheElement$View$flechesDOrdre, i18n, place, element)))
			]));
	});
var $author$project$Components$Produits$FicheElement$View$ligne = F3(
	function (i18n, place, element) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'archive',
							$author$project$Components$Produits$Common$Elements$archive(element)),
							_Utils_Tuple2(
							'glisse',
							_Utils_eq(
								place.m_,
								$elm$core$Maybe$Just(element.Aq)))
						])),
				A2($author$project$Components$Produits$FicheElement$View$glisser, place, element)),
			_Utils_ap(
				A3($author$project$Components$Produits$FicheElement$View$ordre, i18n, place, element),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
							]),
						_List_fromArray(
							[
								$author$project$Components$Produits$FicheElement$View$lienDuNom(element)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('millesime')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$elm$core$Maybe$withDefault,
									$author$project$I18n$Cles$produitsCatalogueInfoSansValeur(i18n),
									element.n8))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('references-actives')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$String$fromInt(element.Hd))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('etat')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Tag$View$view,
								$author$project$Components$Produits$Common$Elements$archive(element) ? 3 : 0,
								A2($author$project$Catalogue$Vocabulaire$etatDElement, i18n, element.gt))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
							]),
						_Utils_ap(
							A3($author$project$Components$Produits$FicheElement$View$modifier, i18n, 1, element),
							A2($author$project$Components$Produits$FicheElement$View$archiver, i18n, element)))
					])));
	});
var $author$project$I18n$Cles$produitsCatalogueColonneActions = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.colonne.actions', _List_Nil, 'Actions');
};
var $author$project$I18n$Cles$produitsCatalogueColonneOrdre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.colonne.ordre', _List_Nil, 'Ordre');
};
var $author$project$I18n$Cles$produitsCatalogueColonneReferencesActives = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.colonne.references-actives', _List_Nil, 'Références actives');
};
var $author$project$Components$Produits$FicheElement$View$elementsPortes = F4(
	function (i18n, tournures, model, fiche) {
		var place = A2($author$project$Components$Produits$FicheElement$View$placement, model, fiche);
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$FicheElement$Model$idDeLaSection),
					$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1)
				]),
			{
				fw: A3($author$project$Components$Produits$FicheElement$View$ajout, i18n, fiche, tournures),
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau'),
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'loading',
										$author$project$Components$Produits$Common$Envoi$enCours(model.l2)),
										_Utils_Tuple2(
										'en-cours',
										!_Utils_eq(model.o2, $elm$core$Maybe$Nothing))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-busy',
								$author$project$Components$Produits$Common$Envoi$enCours(model.l2) ? 'true' : 'false')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$table,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$tr,
												_List_Nil,
												A2(
													$elm$core$List$map,
													function (nom) {
														return A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(nom)
																]));
													},
													_Utils_ap(
														place.bP ? _List_fromArray(
															[
																$author$project$I18n$Cles$produitsCatalogueColonneOrdre(i18n)
															]) : _List_Nil,
														_List_fromArray(
															[
																A2($author$project$I18n$Cles$texte, i18n, tournures.Dj),
																$author$project$I18n$Cles$produitsCatalogueChampMillesime(i18n),
																$author$project$I18n$Cles$produitsCatalogueColonneReferencesActives(i18n),
																$author$project$I18n$Cles$produitsCatalogueColonneEtat(i18n),
																$author$project$I18n$Cles$produitsCatalogueColonneActions(i18n)
															]))))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$tbody,
										_List_Nil,
										A2(
											$elm$core$List$map,
											A2($author$project$Components$Produits$FicheElement$View$ligne, i18n, place),
											fiche.yp))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('annonce'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-live', 'polite')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$I18n$Cles$texte, i18n, model.iP))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$List$isEmpty(fiche.yp) ? A2($author$project$I18n$Cles$texte, i18n, tournures.dp) : '')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Components$Produits$Common$Elements$tournures(i18n),
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.em;
												},
												$author$project$I18n$Cles$texte(i18n))),
										fiche.os)))
							]))
					]),
				Dj: 'elements',
				h6: A2($author$project$I18n$Cles$texte, i18n, tournures.bT)
			});
	});
var $author$project$Components$Produits$FicheElement$Update$GammeCochee = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Produits$FicheElement$Model$marquesDeLaGamme = function (fiche) {
	return $author$project$Components$Produits$Common$Gammes$marquesDeLaGamme(fiche.lQ.Aq);
};
var $author$project$Components$Produits$FicheElement$Model$millesimeDeLaGamme = function (fiche) {
	return $author$project$Components$Produits$Common$Gammes$millesimeDeLaGamme(fiche.yp);
};
var $author$project$I18n$Cles$produitsCatalogueGammesAussiChez = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.gammes.aussi-chez',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'marques',
					$author$project$I18n$Traductions$Chaine(p.cU))
				]),
			'aussi chez ' + p.cU);
	});
var $author$project$I18n$Cles$produitsCatalogueGammesChez = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.gammes.chez',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'marques',
					$author$project$I18n$Traductions$Chaine(p.cU))
				]),
			'chez ' + p.cU);
	});
var $author$project$I18n$Cles$produitsCatalogueGammesMillesime = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.gammes.millesime',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'annee',
					$author$project$I18n$Traductions$Chaine(p.tk))
				]),
			'millésime ' + p.tk);
	});
var $author$project$I18n$Cles$produitsCatalogueGammesSeparateur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.gammes.separateur', _List_Nil, ' · ');
};
var $author$project$I18n$Cles$produitsCatalogueGammesSeparateurDeMarques = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.gammes.separateur-de-marques', _List_Nil, ', ');
};
var $author$project$Components$Produits$FicheElement$View$detail = F3(
	function (i18n, fiche, gamme) {
		var millesime = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (annee) {
					return _List_fromArray(
						[
							A2(
							$author$project$I18n$Cles$produitsCatalogueGammesMillesime,
							i18n,
							{tk: annee})
						]);
				},
				A2($author$project$Components$Produits$FicheElement$Model$millesimeDeLaGamme, fiche, gamme)));
		var marques = function () {
			var _v1 = A2($author$project$Components$Produits$FicheElement$Model$marquesDeLaGamme, fiche, gamme);
			if (!_v1.b) {
				return _List_Nil;
			} else {
				var noms = _v1;
				return _List_fromArray(
					[
						(gamme.tx ? $author$project$I18n$Cles$produitsCatalogueGammesAussiChez(i18n) : $author$project$I18n$Cles$produitsCatalogueGammesChez(i18n))(
						{
							cU: A2(
								$elm$core$String$join,
								$author$project$I18n$Cles$produitsCatalogueGammesSeparateurDeMarques(i18n),
								noms)
						})
					]);
			}
		}();
		var _v0 = _Utils_ap(marques, millesime);
		if (!_v0.b) {
			return _List_Nil;
		} else {
			var parties = _v0;
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('detail')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$concat(
								A2(
									$elm$core$List$map,
									$elm$core$Basics$append(
										$author$project$I18n$Cles$produitsCatalogueGammesSeparateur(i18n)),
									parties)))
						]))
				]);
		}
	});
var $author$project$Components$Produits$FicheElement$Update$MenuDeGammeBascule = function (a) {
	return {$: 22, a: a};
};
var $author$project$I18n$Cles$produitsCatalogueGammesMenu = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.gammes.menu',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Actions de ' + p.Dj);
	});
var $author$project$Components$Shared$Svg$svgEllipsis = A3(
	$author$project$Components$Shared$Svg$icone,
	'ellipsis',
	'',
	_List_fromArray(
		[
			A3($author$project$Components$Shared$Svg$cercle, 5, 12, 1),
			A3($author$project$Components$Shared$Svg$cercle, 12, 12, 1),
			A3($author$project$Components$Shared$Svg$cercle, 19, 12, 1)
		]));
var $author$project$Components$Produits$FicheElement$View$menuDeLaGamme = F4(
	function (i18n, model, fiche, gamme) {
		var porte = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (element) {
					return _Utils_eq(element.Aq, gamme.Aq);
				},
				fiche.yp));
		var ouvert = _Utils_eq(
			model.n7,
			$elm$core$Maybe$Just(gamme.Aq));
		var action = F3(
			function (suffixe, msg, cle) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'none')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id(
									$author$project$Components$Produits$FicheElement$Model$idDuMenuDeLaGamme(gamme.Aq) + ('-' + suffixe)),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'menuitem'),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(cle)
								]))
						]));
			});
		var actions = _Utils_ap(
			(!_Utils_eq(
				A2($author$project$Components$Produits$FicheElement$Model$commandeDOuverture, gamme.Aq, fiche),
				$elm$core$Maybe$Nothing)) ? _List_fromArray(
				[
					A3(
					action,
					'ouvrir',
					$author$project$Components$Produits$FicheElement$Update$OuvertureDemandee(gamme.Aq),
					$author$project$I18n$Cles$produitsCatalogueActionsOuvrir(i18n))
				]) : _List_Nil,
			_Utils_ap(
				(!_Utils_eq(
					A2($author$project$Components$Produits$FicheElement$Model$commandeDArchivage, gamme.Aq, fiche),
					$elm$core$Maybe$Nothing)) ? _List_fromArray(
					[
						A3(
						action,
						'archiver',
						$author$project$Components$Produits$FicheElement$Update$ArchivageDemande(gamme.Aq),
						$author$project$I18n$Cles$produitsCatalogueActionsArchiver(i18n))
					]) : _List_Nil,
				function () {
					var _v0 = A2($elm$core$Maybe$andThen, $author$project$Components$Produits$FicheElement$Model$formeDeLaModification, porte);
					if (!_v0.$) {
						return _List_fromArray(
							[
								A3(
								action,
								'modifier',
								$author$project$Components$Produits$FicheElement$Update$ModificationOuverte(gamme.Aq),
								$author$project$I18n$Cles$produitsCatalogueActionsModifier(i18n))
							]);
					} else {
						return _List_Nil;
					}
				}()));
		return $elm$core$List$isEmpty(actions) ? _List_Nil : _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('toggle-menu'),
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('opened', ouvert)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('button-icon'),
								$rtfeldman$elm_css$Html$Styled$Attributes$id(
								$author$project$Components$Produits$FicheElement$Model$idDuMenuDeLaGamme(gamme.Aq)),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'menu'),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-expanded',
								ouvert ? 'true' : 'false'),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-label',
								A2(
									$author$project$I18n$Cles$produitsCatalogueGammesMenu,
									i18n,
									{Dj: gamme.R.zX})),
								$rtfeldman$elm_css$Html$Styled$Attributes$title(
								A2(
									$author$project$I18n$Cles$produitsCatalogueGammesMenu,
									i18n,
									{Dj: gamme.R.zX})),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Produits$FicheElement$Update$MenuDeGammeBascule(gamme.Aq))
							]),
						_List_fromArray(
							[$author$project$Components$Shared$Svg$svgEllipsis])),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('menu'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'menu')
							]),
						actions)
					]))
			]);
	});
var $author$project$Components$Produits$FicheElement$View$nomDeLaGamme = F2(
	function (fiche, gamme) {
		return A2(
			$elm$core$List$any,
			function (porte) {
				return _Utils_eq(porte.Aq, gamme.Aq) && (!_Utils_eq(
					$author$project$Components$Produits$FicheElement$Model$formeDeLaModification(porte),
					$elm$core$Maybe$Nothing));
			},
			fiche.yp) ? A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('nom'),
					$rtfeldman$elm_css$Html$Styled$Attributes$id(
					$author$project$Components$Produits$FicheElement$Model$idDeLaModification(gamme.Aq)),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Components$Produits$FicheElement$Update$ModificationOuverte(gamme.Aq))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(gamme.R.zX)
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(gamme.R.zX)
				]));
	});
var $author$project$I18n$Cles$produitsCatalogueAppartenanceToutes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.appartenance.toutes', _List_Nil, 'toutes les marques');
};
var $author$project$Components$Produits$FicheElement$View$caseDeGamme = F4(
	function (i18n, model, fiche, gamme) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('choix'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('cochee', gamme.tx)
						]))
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$input,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
								$rtfeldman$elm_css$Html$Styled$Attributes$id(
								$author$project$Components$Produits$FicheElement$Model$idDeLaCase(gamme.Aq)),
								$rtfeldman$elm_css$Html$Styled$Attributes$checked(gamme.tx),
								$rtfeldman$elm_css$Html$Styled$Events$onCheck(
								$author$project$Components$Produits$FicheElement$Update$GammeCochee(gamme.Aq)),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
								$author$project$Components$Produits$Common$Envoi$enCours(model.l2) || _Utils_eq(gamme.nQ, _List_Nil)),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', gamme.R.zX)
							]),
						_List_Nil),
						A2($author$project$Components$Produits$FicheElement$View$nomDeLaGamme, fiche, gamme)
					]),
				_Utils_ap(
					gamme.rO ? _List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							5,
							$author$project$I18n$Cles$produitsCatalogueAppartenanceToutes(i18n))
						]) : _List_Nil,
					_Utils_ap(
						A3($author$project$Components$Produits$FicheElement$View$detail, i18n, fiche, gamme),
						A4($author$project$Components$Produits$FicheElement$View$menuDeLaGamme, i18n, model, fiche, gamme)))));
	});
var $author$project$I18n$Cles$produitsCatalogueGammesNote = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.gammes.note',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'marque',
					$author$project$I18n$Traductions$Chaine(p.gX))
				]),
			'Une gamme créée ici appartient à ' + (p.gX + ('. Si son nom existe déjà, la gamme existante est étendue à ' + (p.gX + ', comme à l\'étape 3.'))));
	});
var $author$project$Components$Produits$FicheElement$View$note = F2(
	function (i18n, fiche) {
		var _v0 = $author$project$Components$Produits$FicheElement$Model$formeDeLaCreation(fiche);
		if (!_v0.$) {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$produitsCatalogueGammesNote,
								i18n,
								{
									gX: $author$project$Components$Produits$Common$Elements$nom(fiche.lQ)
								}))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Produits$FicheElement$Update$OrdreOuvert = {$: 6};
var $author$project$I18n$Cles$produitsCatalogueGammesOrdonner = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.gammes.ordonner', _List_Nil, 'Ordonner');
};
var $author$project$Components$Produits$FicheElement$View$ordonnerLesGammes = F3(
	function (i18n, _v0, fiche) {
		var _v1 = A2($author$project$Components$Produits$FicheElement$Model$commandeDOrdre, _List_Nil, fiche);
		if (!_v1.$) {
			return _List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$FicheElement$Model$idDeLOrdre),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$FicheElement$Update$OrdreOuvert)
						]),
					$author$project$I18n$Cles$produitsCatalogueGammesOrdonner(i18n))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$I18n$Cles$produitsCatalogueGammesIntro = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.gammes.intro',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'marque',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.gX))),
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av)))
				]),
			'Les mêmes que sous ' + (p.gX + (' à l\'étape 3 du catalogue. Décochez une gamme pour la retirer ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.gX);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.gX);
					default:
						return 'de ' + $elm$core$String$trim(p.gX);
				}
			}() + ' : elle reste chez ses autres marques.'))));
	});
var $author$project$I18n$Cles$produitsCatalogueGammesLegende = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.gammes.legende',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'marque',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.gX)))
				]),
			'Gammes ' + function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.gX);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.gX);
					default:
						return 'de ' + $elm$core$String$trim(p.gX);
				}
			}());
	});
var $author$project$I18n$Cles$produitsCatalogueGammesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.gammes.titre', _List_Nil, 'Ses gammes');
};
var $author$project$Components$Produits$FicheElement$View$proposition = F3(
	function (i18n, fiche, tournures) {
		var _v0 = $author$project$Components$Produits$FicheElement$Model$formeDeLaCreation(fiche);
		if (!_v0.$) {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('proposition'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$FicheElement$Model$idDeLaCreation),
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$FicheElement$Update$CreationOuverte)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$produitsCatalogueGammesAjouter,
										i18n,
										{
											os: A2($author$project$I18n$Cles$texte, i18n, tournures.Dj)
										}))
								]))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Produits$FicheElement$View$gammesDeLaMarque = F4(
	function (i18n, tournures, model, fiche) {
		var marque = $author$project$Components$Produits$Common$Elements$nom(fiche.lQ);
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$FicheElement$Model$idDeLaSection),
					$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1)
				]),
			{
				fw: A3($author$project$Components$Produits$FicheElement$View$ordonnerLesGammes, i18n, model, fiche),
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('intro')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$produitsCatalogueGammesIntro,
									i18n,
									{
										av: $author$project$Texte$Elision$elision(marque),
										gX: marque
									}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$fieldset,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('gammes'),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-busy',
								$author$project$Components$Produits$Common$Envoi$enCours(model.l2) ? 'true' : 'false')
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$rtfeldman$elm_css$Html$Styled$legend,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$produitsCatalogueGammesLegende,
											i18n,
											{
												av: $author$project$Texte$Elision$elision(marque),
												gX: marque
											}))
									])),
							A2(
								$elm$core$List$map,
								A3($author$project$Components$Produits$FicheElement$View$caseDeGamme, i18n, model, fiche),
								fiche.z4))),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$List$isEmpty(fiche.z4) ? A2($author$project$I18n$Cles$texte, i18n, tournures.dp) : '')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout')
							]),
						_Utils_ap(
							A3($author$project$Components$Produits$FicheElement$View$proposition, i18n, fiche, tournures),
							A2($author$project$Components$Produits$FicheElement$View$note, i18n, fiche))),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('annonce'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-live', 'polite')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$I18n$Cles$texte, i18n, model.iP))
							]))
					]),
				Dj: 'elements',
				h6: _Utils_eq(
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.R;
						},
						fiche.C8),
					$elm$core$Maybe$Nothing) ? $author$project$I18n$Cles$produitsCatalogueGammesTitre(i18n) : A2($author$project$I18n$Cles$texte, i18n, tournures.bT)
			});
	});
var $author$project$Components$Produits$FicheElement$View$portes = F4(
	function (i18n, tournures, model, fiche) {
		return _Utils_eq(fiche.lQ.fA, $author$project$Catalogue$Vocabulaire$codeMarque) ? A4($author$project$Components$Produits$FicheElement$View$gammesDeLaMarque, i18n, tournures, model, fiche) : A4($author$project$Components$Produits$FicheElement$View$elementsPortes, i18n, tournures, model, fiche);
	});
var $author$project$I18n$Cles$produitsMarquesEtGammesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.marques-et-gammes.titre', _List_Nil, 'Marques et gammes');
};
var $author$project$I18n$Cles$produitsStructureEnvoiEnCours = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.structure.envoi.en-cours', _List_Nil, 'Enregistrement en cours…');
};
var $author$project$I18n$Cles$produitsCatalogueReferences = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.references',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' référence') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' références'));
	});
var $author$project$I18n$Cles$produitsCatalogueResume = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.resume',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nature',
					$author$project$I18n$Traductions$Chaine(p.g1)),
					_Utils_Tuple2(
					'enfants',
					$author$project$I18n$Traductions$Chaine(p.yp)),
					_Utils_Tuple2(
					'references',
					$author$project$I18n$Traductions$Chaine(p.hD))
				]),
			p.g1 + (' · ' + (p.yp + (' · ' + p.hD))));
	});
var $author$project$I18n$Cles$produitsCatalogueResumeSansEnfants = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.resume.sans-enfants',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nature',
					$author$project$I18n$Traductions$Chaine(p.g1)),
					_Utils_Tuple2(
					'references',
					$author$project$I18n$Traductions$Chaine(p.hD))
				]),
			p.g1 + (' · ' + p.hD));
	});
var $author$project$Components$Produits$FicheElement$Model$resume = F2(
	function (i18n, fiche) {
		var references = A2(
			$author$project$I18n$Cles$produitsCatalogueReferences,
			i18n,
			{w: fiche.lQ.hD});
		var nature = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (niveau) {
					return A2(
						$author$project$I18n$Cles$texte,
						i18n,
						A2($author$project$Components$Produits$Common$Elements$tournures, i18n, niveau).g1(fiche.lQ.IY));
				},
				fiche.os));
		var _v0 = fiche.C8;
		if (!_v0.$) {
			var niveau = _v0.a;
			return A2(
				$author$project$I18n$Cles$produitsCatalogueResume,
				i18n,
				{
					yp: A2(
						$author$project$I18n$Cles$texte,
						i18n,
						A2($author$project$Components$Produits$Common$Elements$tournures, i18n, niveau).w(fiche.lQ.yp)),
					g1: nature,
					hD: references
				});
		} else {
			return A2(
				$author$project$I18n$Cles$produitsCatalogueResumeSansEnfants,
				i18n,
				{g1: nature, hD: references});
		}
	});
var $author$project$Components$Produits$FicheElement$View$aucunTypeRange = function (lots) {
	return A2(
		$elm$core$List$all,
		function (lot) {
			return !lot.J4;
		},
		lots);
};
var $author$project$Components$Shared$OrdreDesBlocs$Update$Demander = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$FicheElement$Update$ValeursOuvertes = function (a) {
	return {$: 24, a: a};
};
var $author$project$API$NavLinksDictionary$poserLaValeurDUnChampHerite = 'poser-la-valeur-d-un-champ-herite';
var $author$project$Components$Produits$FicheElement$Valeurs$modifiable = function (page) {
	return A2(
		$elm$core$List$any,
		function (champ) {
			return !_Utils_eq(
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$poserLaValeurDUnChampHerite, champ.nQ),
				$elm$core$Maybe$Nothing);
		},
		page.dw);
};
var $author$project$API$NavLinksDictionary$ordreDesBlocs = 'ordre-des-blocs';
var $author$project$I18n$Cles$ordreDesBlocsOuvrir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'ordre-des-blocs.ouvrir', _List_Nil, 'Ordonner les blocs');
};
var $author$project$I18n$Cles$produitsFicheElementValeursHerite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.fiche-element.valeurs.herite', _List_Nil, 'hérité par les références');
};
var $author$project$I18n$Cles$produitsFicheElementValeursModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.fiche-element.valeurs.modifier', _List_Nil, 'Modifier');
};
var $author$project$I18n$Cles$produitsFicheElementValeursModifierTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.fiche-element.valeurs.modifier-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typologie',
					$author$project$I18n$Traductions$Chaine(p.r3))
				]),
			'Modifier ' + p.r3);
	});
var $author$project$Components$Produits$FicheElement$View$blocDeValeurs = F5(
	function (i18n, normes, fiche, rang, lot) {
		var nom = A2(
			$author$project$I18n$Cles$produitsFicheElementValeursModifierTitre,
			i18n,
			{r3: lot.r3});
		var lue = A2(
			$elm$core$Maybe$withDefault,
			A2(
				$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$depuis,
				{
					dw: $author$project$Components$Produits$FicheElement$Valeurs$champs(lot),
					Ba: fiche.Ba
				},
				_List_Nil),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.hP;
				},
				A2($author$project$Components$Produits$FicheElement$Valeurs$ouvrir, rang, fiche)));
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_Nil,
			{
				fw: _Utils_ap(
					$author$project$Components$Produits$FicheElement$Valeurs$modifiable(lot) ? _List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id(
									$author$project$Components$Produits$FicheElement$Model$idDuBoutonDesValeurs(rang)),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', nom),
									$rtfeldman$elm_css$Html$Styled$Attributes$title(nom),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Produits$FicheElement$Update$ValeursOuvertes(rang))
								]),
							$author$project$I18n$Cles$produitsFicheElementValeursModifier(i18n))
						]) : _List_Nil,
					function () {
						var _v0 = A2(
							$elm$core$Maybe$andThen,
							function (_v1) {
								return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ordreDesBlocs, lot.nQ);
							},
							A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ordonnerLesBlocs, lot.nQ));
						if (!_v0.$) {
							var lien = _v0.a;
							return _List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Shared$OrdreDesBlocs$Model$idDuDeclencheur),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('ordonner-les-blocs'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Produits$FicheElement$Update$DesBlocs(
												$author$project$Components$Shared$OrdreDesBlocs$Update$Demander(lien)))
										]),
									$author$project$I18n$Cles$ordreDesBlocsOuvrir(i18n))
								]);
						} else {
							return _List_Nil;
						}
					}()),
				fZ: A2(
					$elm$core$List$map,
					$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Produits$FicheElement$Update$DeLaSaisieDesValeurs),
					A4(
						$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$viewAvecIndications,
						i18n,
						{
							bB: false,
							yS: $elm$core$Maybe$Just(
								$author$project$I18n$Cles$produitsFicheElementValeursHerite(i18n)),
							ou: ''
						},
						A4($author$project$Components$Produits$FicheElement$Valeurs$presentation, normes, true, fiche, lot),
						lue)),
				Dj: 'valeurs-de-la-typologie',
				h6: lot.r3
			});
	});
var $author$project$I18n$Cles$produitsFicheElementValeursVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.fiche-element.valeurs.vide', _List_Nil, 'Aucun type de produit n\'est rangé sous cette gamme : il n\'y a donc aucune information à lui transmettre. Ce bloc apparaîtra dès qu\'un type y sera rangé, avec les valeurs à renseigner pour ce type.');
};
var $author$project$I18n$Cles$produitsFicheElementValeursVideTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.fiche-element.valeurs.vide-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typologie',
					$author$project$I18n$Traductions$Chaine(p.r3))
				]),
			'Rangement · ' + p.r3);
	});
var $author$project$Components$Produits$FicheElement$View$blocVideDuRangement = F2(
	function (i18n, lot) {
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_Nil,
			{
				fw: _List_Nil,
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsFicheElementValeursVide(i18n))
							]))
					]),
				Dj: 'valeurs-de-la-typologie',
				h6: A2(
					$author$project$I18n$Cles$produitsFicheElementValeursVideTitre,
					i18n,
					{r3: lot.r3})
			});
	});
var $author$project$I18n$Cles$produitsFicheElementValeursCompletudeComplete = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.fiche-element.valeurs.completude-complete', _List_Nil, 'Calculée à chaque modification.');
};
var $author$project$I18n$Cles$produitsFicheElementValeursCompletudeManque = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.fiche-element.valeurs.completude-manque',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champs',
					$author$project$I18n$Traductions$Chaine(p.dw))
				]),
			'Manque : ' + (p.dw + ' (champ saisi sur cet étage).'));
	});
var $author$project$I18n$Cles$produitsFicheElementValeursCompletudeTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.fiche-element.valeurs.completude-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'remplis',
					$author$project$I18n$Traductions$Chaine(p.HB)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			'Complétude · ' + (p.HB + (' critères sur ' + p.JE)));
	});
var $author$project$Components$Produits$FicheElement$View$completudeDeLEtage = F2(
	function (i18n, lots) {
		var total = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.fU;
					},
					function ($) {
						return $.JE;
					}),
				lots));
		var remplis = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.fU;
					},
					function ($) {
						return $.HB;
					}),
				lots));
		var manquants = A2(
			$elm$core$List$concatMap,
			function (lot) {
				return A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.uN;
						},
						function ($) {
							return $.Bl;
						}),
					A2(
						$elm$core$List$filter,
						function (champ) {
							return A2($elm$core$List$member, champ.uN.dy, lot.fU.B5);
						},
						lot.dw));
			},
			lots);
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_Nil,
			{
				fw: _List_Nil,
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$List$isEmpty(manquants) ? $author$project$I18n$Cles$produitsFicheElementValeursCompletudeComplete(i18n) : A2(
									$author$project$I18n$Cles$produitsFicheElementValeursCompletudeManque,
									i18n,
									{
										dw: A2($elm$core$String$join, ', ', manquants)
									}))
							]))
					]),
				Dj: 'completude',
				h6: A2(
					$author$project$I18n$Cles$produitsFicheElementValeursCompletudeTitre,
					i18n,
					{
						HB: $elm$core$String$fromInt(remplis),
						JE: $elm$core$String$fromInt(total)
					})
			});
	});
var $author$project$I18n$Cles$produitsFicheElementValeursTransmetNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.fiche-element.valeurs.transmet-note', _List_Nil, 'Un champ saisi ici n\'est jamais ressaisi sur les références.');
};
var $author$project$I18n$Cles$produitsFicheElementValeursTransmetTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.fiche-element.valeurs.transmet-titre', _List_Nil, 'Ce que cette marque transmet');
};
var $author$project$I18n$Cles$produitsFicheElementValeursTransmetTitreGamme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.fiche-element.valeurs.transmet-titre-gamme', _List_Nil, 'Ce que cette gamme transmet');
};
var $author$project$Components$Produits$FicheElement$View$valeursDEtage = F3(
	function (i18n, normes, fiche) {
		return $elm$core$List$isEmpty(fiche.Kk) ? _List_Nil : ((_Utils_eq(fiche.lQ.fA, $author$project$Catalogue$Vocabulaire$codeGamme) && $author$project$Components$Produits$FicheElement$View$aucunTypeRange(fiche.Kk)) ? A2(
			$elm$core$List$map,
			$author$project$Components$Produits$FicheElement$View$blocVideDuRangement(i18n),
			fiche.Kk) : _Utils_ap(
			A2(
				$elm$core$List$indexedMap,
				A3($author$project$Components$Produits$FicheElement$View$blocDeValeurs, i18n, normes, fiche),
				fiche.Kk),
			_List_fromArray(
				[
					A2($author$project$Components$Produits$FicheElement$View$completudeDeLEtage, i18n, fiche.Kk),
					A2(
					$author$project$Components$Shared$Page$View$section,
					_List_Nil,
					{
						fw: _List_Nil,
						fZ: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsFicheElementValeursTransmetNote(i18n))
									]))
							]),
						Dj: 'transmet',
						h6: _Utils_eq(fiche.lQ.fA, $author$project$Catalogue$Vocabulaire$codeMarque) ? $author$project$I18n$Cles$produitsFicheElementValeursTransmetTitre(i18n) : $author$project$I18n$Cles$produitsFicheElementValeursTransmetTitreGamme(i18n)
					})
				])));
	});
var $author$project$Components$Produits$FicheElement$View$page = F4(
	function (i18n, messages, model, fiche) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			$author$project$Components$Produits$FicheElement$View$nomDeLaPage,
			{
				ut: A2(
					$elm$core$List$cons,
					A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('envoi'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Components$Produits$Common$Envoi$enCours(model.l2) ? $author$project$I18n$Cles$produitsStructureEnvoiEnCours(i18n) : '')
								])),
						_Utils_ap(
							A2($author$project$Components$Produits$FicheElement$View$aPropos, i18n, fiche),
							_Utils_ap(
								A3($author$project$Components$Produits$FicheElement$View$valeursDEtage, i18n, model.hd, fiche),
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function (niveau) {
											return _List_fromArray(
												[
													A4(
													$author$project$Components$Produits$FicheElement$View$portes,
													i18n,
													A2($author$project$Components$Produits$Common$Elements$tournures, i18n, niveau),
													model,
													fiche)
												]);
										},
										fiche.C8)))))),
				xy: _List_fromArray(
					[
						A3($author$project$Components$Produits$FicheElement$View$drawer, i18n, model, fiche),
						A3($author$project$Components$Produits$FicheElement$View$confirmation, i18n, model, fiche),
						A3($author$project$Components$Produits$FicheElement$View$ordreDesBlocs, i18n, model, fiche)
					]),
				zM: _Utils_ap(
					A2($author$project$Components$Produits$FicheElement$View$archiver, i18n, fiche.lQ),
					A3($author$project$Components$Produits$FicheElement$View$modifier, i18n, 0, fiche.lQ)),
				AK: $author$project$Components$Produits$FicheElement$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: A2(
							$elm$core$List$cons,
							A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('resume')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$Components$Produits$FicheElement$Model$resume, i18n, fiche))
									])),
							A2($author$project$Components$Produits$FicheElement$View$etat, i18n, fiche.lQ)),
						zE: _Utils_ap(
							_List_fromArray(
								[
									{
									aa: $author$project$Routes$Route$adresseMarquesEtGammes,
									Dj: $author$project$I18n$Cles$produitsTitre(i18n)
								},
									{
									aa: $author$project$Routes$Route$adresseMarquesEtGammes,
									Dj: $author$project$I18n$Cles$produitsMarquesEtGammesTitre(i18n)
								}
								]),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (parent) {
										return parent.Ex ? _List_fromArray(
											[
												{
												aa: $author$project$Components$Produits$FicheElement$View$versLaFiche(parent.Aq),
												Dj: parent.R.zX
											}
											]) : _List_Nil;
									},
									fiche.ey))),
						Ef: _List_Nil,
						h6: $author$project$Components$Produits$Common$Elements$nom(fiche.lQ)
					})
			});
	});
var $author$project$Components$Produits$FicheElement$View$view = F3(
	function (i18n, messages, model) {
		var _v0 = _Utils_Tuple2(model.nf, model.zo);
		if (_v0.a) {
			return A2(
				$author$project$Components$Shared$Introuvable$View$view,
				i18n,
				{
					aa: $author$project$Routes$Route$adresseMarquesEtGammes,
					Bl: $author$project$I18n$Cles$produitsCatalogueRetour(i18n)
				});
		} else {
			if (!_v0.b.$) {
				var fiche = _v0.b.a;
				return A4($author$project$Components$Produits$FicheElement$View$page, i18n, messages, model, fiche);
			} else {
				var _v1 = _v0.b;
				return A2(
					$author$project$Components$Shared$Page$View$page,
					$author$project$Components$Produits$FicheElement$View$nomDeLaPage,
					{
						ut: _List_fromArray(
							[
								A2($author$project$Components$Shared$Messages$View$view, i18n, messages)
							]),
						xy: _List_Nil,
						zM: _List_Nil,
						AK: false,
						JD: _List_Nil
					});
			}
		}
	});
var $author$project$Components$Produits$FicheType$View$adresseDesCategories = $author$project$Routes$Route$toString(
	A2($author$project$Routes$Route$ParametrageCatalogue, 2, $elm$core$Maybe$Nothing));
var $author$project$Components$Produits$FicheType$View$nomDeLaPage = 'produits-type-detail';
var $author$project$Components$Produits$FicheType$Update$ArchivageDemande = {$: 13};
var $author$project$Components$Produits$FicheType$Update$HistoriqueDemande = {$: 12};
var $author$project$Components$Produits$FicheType$View$adresseDesValeursDuChamp = F2(
	function (fiche, cles) {
		var premiere = $author$project$Routes$Route$premiereListeDeReferences;
		return A2(
			$elm$core$Maybe$map,
			function (_v0) {
				return $author$project$Routes$Route$toString(
					$author$project$Routes$Route$Catalogue(
						_Utils_update(
							premiere,
							{
								qs: cles,
								fh: $elm$core$Maybe$Just(
									$author$project$Catalogue$Identifiants$typeDeProduitIdToString(fiche.fh.Aq))
							})));
			},
			A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$rechercherDesReferences, fiche.gF));
	});
var $author$project$Components$Produits$FicheType$Update$ArchivageConfirme = {$: 15};
var $author$project$Components$Produits$FicheType$Update$FocusDemande = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Produits$FicheType$Update$clavierDeLArchivage = A2($author$project$Components$Shared$Confirmation$Clavier$clavier, $author$project$Components$Produits$FicheType$Model$idsDeLArchivage, $author$project$Components$Produits$FicheType$Update$FocusDemande);
var $author$project$I18n$Cles$produitsTypesArchivageAucuneReference = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.archivage.aucune-reference', _List_Nil, 'Aucune référence ne porte cette catégorie.');
};
var $author$project$I18n$Cles$produitsTypesArchivageMessage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.archivage.message',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'references',
					$author$project$I18n$Traductions$Chaine(p.hD))
				]),
			'Archiver « ' + (p.Dj + (' » ? ' + (p.hD + ' Elle ne sera plus proposée à la création et n\'évoluera plus. Cette action est sans retour.'))));
	});
var $author$project$I18n$Cles$produitsTypesArchivageReferences = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.archivage.references',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' référence porte cette catégorie et la garde.') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' références portent cette catégorie et la gardent.'));
	});
var $author$project$I18n$Cles$produitsTypesArchivageTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.archivage.titre', _List_Nil, 'Archiver la catégorie');
};
var $author$project$Components$Produits$FicheType$View$archivage = F3(
	function (i18n, model, fiche) {
		var type_ = fiche.fh;
		var ids = $author$project$Components$Produits$FicheType$Model$idsDeLArchivage;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('opened', model.ir)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('overlay'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$FicheType$Update$ArchivageAnnule)
						]),
					_List_Nil),
					A2(
					$author$project$Components$Shared$Confirmation$View$view,
					i18n,
					{
						vl: $author$project$Components$Produits$FicheType$Update$clavierDeLArchivage,
						j7: {
							Aq: ids.j7,
							Bl: $author$project$I18n$Cles$produitsCatalogueArchivageConfirmer(i18n),
							C$: $author$project$Components$Produits$FicheType$Update$ArchivageConfirme
						},
						Aq: ids.GN,
						As: ids.Cs,
						At: ids.h6,
						Cs: A2(
							$author$project$I18n$Cles$produitsTypesArchivageMessage,
							i18n,
							{
								Dj: type_.Dj.zX,
								hD: (!type_.hD) ? $author$project$I18n$Cles$produitsTypesArchivageAucuneReference(i18n) : A2(
									$author$project$I18n$Cles$produitsTypesArchivageReferences,
									i18n,
									{w: type_.hD})
							}),
						Et: model.ir,
						HG: {
							Aq: ids.to,
							Bl: $author$project$I18n$Cles$produitsCatalogueArchivageAnnuler(i18n),
							C$: $author$project$Components$Produits$FicheType$Update$ArchivageAnnule
						},
						h6: $author$project$I18n$Cles$produitsTypesArchivageTitre(i18n),
						sl: 0
					})
				]));
	});
var $author$project$Components$Produits$FicheType$Update$AjoutOuvert = {$: 6};
var $author$project$Components$Produits$FicheType$Update$DuTableau = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Produits$FicheType$Update$RattachementOuvert = {$: 7};
var $author$project$I18n$Cles$editeurDeSchemaAjouterTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.ajouter.titre', _List_Nil, 'Ajouter un champ');
};
var $author$project$Components$Produits$FicheType$Model$idDeLAjout = 'champs-ajouter';
var $author$project$Components$Produits$FicheType$Model$idDeLaSection = 'caracteristiques';
var $author$project$I18n$Cles$editeurDeSchemaOrigineBibliotheque = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.origine.bibliotheque',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('bibliothèque · ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' type')) : ('bibliothèque · ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' types')));
	});
var $author$project$I18n$Cles$editeurDeSchemaOriginePropre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.origine.propre', _List_Nil, 'propre à ce type');
};
var $author$project$Components$Produits$FicheType$Model$origineDuChamp = F3(
	function (i18n, fiche, cle) {
		return A2(
			$elm$core$Maybe$map,
			function (lu) {
				return lu.hm ? {
					hm: true,
					Jx: A2(
						$author$project$I18n$Cles$editeurDeSchemaOrigineBibliotheque,
						i18n,
						{w: lu.sf})
				} : {
					hm: false,
					Jx: $author$project$I18n$Cles$editeurDeSchemaOriginePropre(i18n)
				};
			},
			A2($elm$core$Dict$get, cle, fiche.dq));
	});
var $author$project$Components$Produits$FicheType$Model$lignes = F2(
	function (i18n, fiche) {
		return A2(
			$elm$core$List$map,
			function (lu) {
				return {
					s$: !_Utils_eq(
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$afficherUnChamp, lu.nQ),
						$elm$core$Maybe$Nothing),
					uN: lu.uN,
					B8: !_Utils_eq(
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$masquerUnChamp, lu.nQ),
						$elm$core$Maybe$Nothing),
					n4: lu.n4,
					o4: A3($author$project$Components$Produits$FicheType$Model$origineDuChamp, i18n, fiche, lu.uN.dy),
					Hk: A2($author$project$Components$Produits$FicheType$Reglages$reglable, fiche, lu),
					JR: lu.JR
				};
			},
			fiche.dw);
	});
var $author$project$I18n$Cles$editeurDeSchemaColonneActions = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.colonne.actions', _List_Nil, 'Actions');
};
var $author$project$I18n$Cles$editeurDeSchemaColonneChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.colonne.champ', _List_Nil, 'Champ');
};
var $author$project$I18n$Cles$editeurDeSchemaColonneExigence = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.colonne.exigence', _List_Nil, 'Exigence');
};
var $author$project$I18n$Cles$editeurDeSchemaColonneOrdre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.colonne.ordre', _List_Nil, 'Ordre');
};
var $author$project$I18n$Cles$editeurDeSchemaColonneOrigine = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.colonne.origine', _List_Nil, 'Origine');
};
var $author$project$I18n$Cles$editeurDeSchemaColonneTraduit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.colonne.traduit', _List_Nil, 'Traduit');
};
var $author$project$I18n$Cles$editeurDeSchemaColonneType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.colonne.type', _List_Nil, 'Type');
};
var $author$project$Components$Shared$EditeurDeSchema$View$Depose = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$View$Descendu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$View$GlisserCommence = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$View$GlisserFini = {$: 5};
var $author$project$Components$Shared$EditeurDeSchema$View$GlisserSurvole = {$: 3};
var $author$project$Components$Shared$EditeurDeSchema$View$Monte = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$View$ReglagesDemandes = function (a) {
	return {$: 9, a: a};
};
var $author$project$I18n$Cles$editeurDeSchemaActionsMasquer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.actions.masquer', _List_Nil, 'Masquer');
};
var $author$project$I18n$Cles$editeurDeSchemaActionsMasquerDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.actions.masquer.de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Masquer ' + p.Dj);
	});
var $author$project$I18n$Cles$editeurDeSchemaActionsModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.actions.modifier', _List_Nil, 'Modifier');
};
var $author$project$I18n$Cles$editeurDeSchemaActionsModifierDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.actions.modifier.de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Modifier ' + p.Dj);
	});
var $author$project$I18n$Cles$editeurDeSchemaActionsReafficher = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.actions.reafficher', _List_Nil, 'Réafficher');
};
var $author$project$I18n$Cles$editeurDeSchemaActionsReafficherDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.actions.reafficher.de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Réafficher ' + p.Dj);
	});
var $author$project$I18n$Cles$editeurDeSchemaActionsRegler = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.actions.regler', _List_Nil, 'Régler');
};
var $author$project$I18n$Cles$editeurDeSchemaActionsReglerDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.actions.regler.de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Régler ' + p.Dj);
	});
var $author$project$I18n$Cles$editeurDeSchemaOrdreDescendreDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.ordre.descendre.de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Descendre ' + p.Dj);
	});
var $author$project$I18n$Cles$editeurDeSchemaOrdreMonterDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.ordre.monter.de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Monter ' + p.Dj);
	});
var $author$project$I18n$Cles$editeurDeSchemaExigenceALEnregistrement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.exigence.a-l-enregistrement', _List_Nil, 'à l\'enregistrement');
};
var $author$project$I18n$Cles$editeurDeSchemaExigenceALaPublication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.exigence.a-la-publication', _List_Nil, 'à la publication');
};
var $author$project$I18n$Cles$editeurDeSchemaExigenceChoixALEnregistrement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.exigence.choix.a-l-enregistrement', _List_Nil, 'Obligatoire à l\'enregistrement');
};
var $author$project$I18n$Cles$editeurDeSchemaExigenceChoixALaPublication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.exigence.choix.a-la-publication', _List_Nil, 'Obligatoire à la publication');
};
var $author$project$I18n$Cles$editeurDeSchemaExigenceChoixFacultatif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.exigence.choix.facultatif', _List_Nil, 'Facultatif');
};
var $author$project$I18n$Cles$editeurDeSchemaExigenceFacultatif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.exigence.facultatif', _List_Nil, 'facultatif');
};
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigences = function (i18n) {
	return $elm$core$Dict$fromList(
		_List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceFacultative,
				{
					jN: $author$project$I18n$Cles$editeurDeSchemaExigenceChoixFacultatif(i18n),
					Dj: $author$project$I18n$Cles$editeurDeSchemaExigenceFacultatif(i18n)
				}),
				_Utils_Tuple2(
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceALEnregistrement,
				{
					jN: $author$project$I18n$Cles$editeurDeSchemaExigenceChoixALEnregistrement(i18n),
					Dj: $author$project$I18n$Cles$editeurDeSchemaExigenceALEnregistrement(i18n)
				}),
				_Utils_Tuple2(
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceALaPublication,
				{
					jN: $author$project$I18n$Cles$editeurDeSchemaExigenceChoixALaPublication(i18n),
					Dj: $author$project$I18n$Cles$editeurDeSchemaExigenceALaPublication(i18n)
				})
			]));
};
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigence = F2(
	function (i18n, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			code,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Dj;
				},
				A2(
					$elm$core$Dict$get,
					code,
					$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigences(i18n))));
	});
var $author$project$Components$Shared$EditeurDeSchema$View$ecrire = function (nombre) {
	return A3(
		$elm$core$String$replace,
		'.',
		',',
		$elm$core$String$fromFloat(nombre));
};
var $author$project$I18n$Cles$editeurDeSchemaResumeAffichage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.resume.affichage',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'unite',
					$author$project$I18n$Traductions$Chaine(p.sa)),
					_Utils_Tuple2(
					'affichee',
					$author$project$I18n$Traductions$Chaine(p.fv)),
					_Utils_Tuple2(
					'langue',
					$author$project$I18n$Traductions$Chaine(p.nn))
				]),
			p.sa + (' (' + (p.fv + (' pour ' + (p.nn + ')')))));
	});
var $author$project$I18n$Cles$editeurDeSchemaResumeBornes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.resume.bornes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'min',
					$author$project$I18n$Traductions$Chaine(p.Cx)),
					_Utils_Tuple2(
					'max',
					$author$project$I18n$Traductions$Chaine(p.Cg))
				]),
			'bornes ' + (p.Cx + (' à ' + p.Cg)));
	});
var $author$project$I18n$Cles$editeurDeSchemaResumeBornesMax = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.resume.bornes.max',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'max',
					$author$project$I18n$Traductions$Chaine(p.Cg))
				]),
			'au plus ' + p.Cg);
	});
var $author$project$I18n$Cles$editeurDeSchemaResumeBornesMin = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.resume.bornes.min',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'min',
					$author$project$I18n$Traductions$Chaine(p.Cx))
				]),
			'au moins ' + p.Cx);
	});
var $author$project$I18n$Cles$editeurDeSchemaResumeDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.resume.detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'detail',
					$author$project$I18n$Traductions$Chaine(p.bB))
				]),
			p.Dj + (' · ' + p.bB));
	});
var $author$project$I18n$Cles$editeurDeSchemaResumeLongueur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.resume.longueur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'maximum',
					$author$project$I18n$Traductions$Chaine(p.Cj))
				]),
			p.Cj + ' caractères au plus');
	});
var $author$project$I18n$Cles$editeurDeSchemaResumeValeurs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.resume.valeurs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'valeurs',
					$author$project$I18n$Traductions$Chaine(p.Ki))
				]),
			p.Dj + (' : ' + p.Ki));
	});
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeCourt = F2(
	function (i18n, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			code,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ad;
				},
				A2(
					$elm$core$Dict$get,
					code,
					$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$types(i18n))));
	});
var $author$project$Components$Shared$EditeurDeSchema$View$resumeDuType = F4(
	function (i18n, unites, typeDeChamp, champ) {
		var nom = A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Cles$editeurDeSchemaTypeInconnu(i18n),
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeCourt(i18n),
				typeDeChamp));
		var longueur = A2(
			$elm$core$List$filterMap,
			function (regle) {
				if ((regle.$ === 1) && (!regle.b.$)) {
					var max = regle.b.a;
					return $elm$core$Maybe$Just(
						A2(
							$author$project$I18n$Cles$editeurDeSchemaResumeLongueur,
							i18n,
							{
								Cj: $elm$core$String$fromInt(max)
							}));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			champ.hJ);
		var bornes = F2(
			function (min, max) {
				var _v3 = _Utils_Tuple2(min, max);
				if (!_v3.a.$) {
					if (!_v3.b.$) {
						var basse = _v3.a.a;
						var haute = _v3.b.a;
						return _List_fromArray(
							[
								A2(
								$author$project$I18n$Cles$editeurDeSchemaResumeBornes,
								i18n,
								{
									Cg: $author$project$Components$Shared$EditeurDeSchema$View$ecrire(haute),
									Cx: $author$project$Components$Shared$EditeurDeSchema$View$ecrire(basse)
								})
							]);
					} else {
						var basse = _v3.a.a;
						var _v4 = _v3.b;
						return _List_fromArray(
							[
								A2(
								$author$project$I18n$Cles$editeurDeSchemaResumeBornesMin,
								i18n,
								{
									Cx: $author$project$Components$Shared$EditeurDeSchema$View$ecrire(basse)
								})
							]);
					}
				} else {
					if (!_v3.b.$) {
						var _v5 = _v3.a;
						var haute = _v3.b.a;
						return _List_fromArray(
							[
								A2(
								$author$project$I18n$Cles$editeurDeSchemaResumeBornesMax,
								i18n,
								{
									Cg: $author$project$Components$Shared$EditeurDeSchema$View$ecrire(haute)
								})
							]);
					} else {
						var _v6 = _v3.a;
						var _v7 = _v3.b;
						return _List_Nil;
					}
				}
			});
		var details = function () {
			var _v1 = champ.r0;
			if (_v1.$ === 10) {
				var mesure = _v1.a;
				return A2(
					$elm$core$List$cons,
					A3(
						$elm$core$List$foldl,
						F2(
							function (_v2, unite) {
								var langue = _v2.a;
								var affichee = _v2.b;
								return A2(
									$author$project$I18n$Cles$editeurDeSchemaResumeAffichage,
									i18n,
									{
										fv: A2($author$project$Components$Shared$EditeurDeSchema$Propositions$symbole, unites, affichee),
										nn: A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$langue, i18n, langue),
										sa: unite
									});
							}),
						A2($author$project$Components$Shared$EditeurDeSchema$Propositions$symbole, unites, mesure.sa),
						mesure.iF),
					A2(bornes, mesure.Cx, mesure.Cg));
			} else {
				return longueur;
			}
		}();
		var detaille = A3(
			$elm$core$List$foldl,
			F2(
				function (detail, dit) {
					return A2(
						$author$project$I18n$Cles$editeurDeSchemaResumeDetail,
						i18n,
						{bB: detail, Dj: dit});
				}),
			nom,
			details);
		var _v0 = champ.r0;
		switch (_v0.$) {
			case 7:
				var valeurs = _v0.a;
				return A2(
					$author$project$I18n$Cles$editeurDeSchemaResumeValeurs,
					i18n,
					{
						Dj: nom,
						Ki: A2($elm$core$String$join, ', ', valeurs)
					});
			case 8:
				var choix = _v0.a;
				return A2(
					$author$project$I18n$Cles$editeurDeSchemaResumeValeurs,
					i18n,
					{
						Dj: nom,
						Ki: A2($elm$core$String$join, ', ', choix.Ki)
					});
			default:
				return detaille;
		}
	});
var $author$project$I18n$Cles$editeurDeSchemaSansValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.sans-valeur', _List_Nil, '—');
};
var $author$project$I18n$Cles$editeurDeSchemaTraduitOui = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.traduit.oui', _List_Nil, 'oui');
};
var $author$project$I18n$Cles$editeurDeSchemaTraduitValeurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.traduit.valeurs', _List_Nil, 'valeurs');
};
var $author$project$Components$Shared$EditeurDeSchema$View$traduit = F2(
	function (i18n, champ) {
		return champ.h8 ? $author$project$I18n$Cles$editeurDeSchemaTraduitOui(i18n) : ((!$elm$core$List$isEmpty(champ.Bt)) ? $author$project$I18n$Cles$editeurDeSchemaTraduitValeurs(i18n) : $author$project$I18n$Cles$editeurDeSchemaSansValeur(i18n));
	});
var $author$project$Components$Shared$EditeurDeSchema$View$ligne = F5(
	function (i18n, tableau, avecOrigine, bouts, fournie) {
		var champ = fournie.uN;
		var cle = champ.dy;
		var glisser = tableau.bP ? _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$draggable('true'),
				A2(
				$rtfeldman$elm_css$Html$Styled$Events$on,
				'dragstart',
				$elm$json$Json$Decode$succeed(
					tableau.h1(
						$author$project$Components$Shared$EditeurDeSchema$View$GlisserCommence(cle)))),
				A2(
				$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
				'dragover',
				$elm$json$Json$Decode$succeed(
					_Utils_Tuple2(
						tableau.h1($author$project$Components$Shared$EditeurDeSchema$View$GlisserSurvole),
						true))),
				A2(
				$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
				'drop',
				$elm$json$Json$Decode$succeed(
					_Utils_Tuple2(
						tableau.h1(
							$author$project$Components$Shared$EditeurDeSchema$View$Depose(cle)),
						true))),
				A2(
				$rtfeldman$elm_css$Html$Styled$Events$on,
				'dragend',
				$elm$json$Json$Decode$succeed(
					tableau.h1($author$project$Components$Shared$EditeurDeSchema$View$GlisserFini)))
			]) : _List_Nil;
		var fleche = F5(
			function (classe, icone, geste, nomme, inactive) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class(classe),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							tableau.h1(geste)),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactive),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-label',
							nomme(
								{Dj: champ.Bl})),
							$rtfeldman$elm_css$Html$Styled$Attributes$title(
							nomme(
								{Dj: champ.Bl}))
						]),
					_List_fromArray(
						[icone]));
			});
		var ordre = tableau.bP ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ordre')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('poignee')
							]),
						_List_fromArray(
							[$author$project$Components$Shared$Svg$svgDragHandle])),
						A5(
						fleche,
						'monter',
						$author$project$Components$Shared$Svg$svgChevronUp,
						$author$project$Components$Shared$EditeurDeSchema$View$Monte(cle),
						$author$project$I18n$Cles$editeurDeSchemaOrdreMonterDe(i18n),
						_Utils_eq(
							bouts.Ge,
							$elm$core$Maybe$Just(cle))),
						A5(
						fleche,
						'descendre',
						$author$project$Components$Shared$Svg$svgChevronDown,
						$author$project$Components$Shared$EditeurDeSchema$View$Descendu(cle),
						$author$project$I18n$Cles$editeurDeSchemaOrdreDescendreDe(i18n),
						_Utils_eq(
							bouts.xg,
							$elm$core$Maybe$Just(cle)))
					]))
			]) : _List_Nil;
		var action = F5(
			function (permise, identifiant, geste, libelle, nomme) {
				return permise ? _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_Utils_ap(
							identifiant,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									tableau.h1(geste)),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									nomme(
										{Dj: champ.Bl})),
									$rtfeldman$elm_css$Html$Styled$Attributes$title(
									nomme(
										{Dj: champ.Bl}))
								])),
						libelle)
					]) : _List_Nil;
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('masque', fournie.n4),
							_Utils_Tuple2(
							'glisse',
							_Utils_eq(
								tableau.m_,
								$elm$core$Maybe$Just(cle)))
						])),
				glisser),
			_Utils_ap(
				ordre,
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$td,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('champ')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(champ.Bl)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('cle')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(cle)
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$td,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('type')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A4($author$project$Components$Shared$EditeurDeSchema$View$resumeDuType, i18n, tableau.sb, fournie.JR, champ))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$td,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('exigence')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigence,
										i18n,
										$author$project$Components$Shared$EditeurDeSchema$Model$exigenceDe(champ)))
								]))
						]),
					_Utils_ap(
						avecOrigine ? _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$td,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('origine')
									]),
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function (dit) {
											return _List_fromArray(
												[
													A2(
													$author$project$Components$Shared$Tag$View$view,
													dit.hm ? 5 : 3,
													dit.Jx)
												]);
										},
										fournie.o4)))
							]) : _List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$td,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('traduit')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$Components$Shared$EditeurDeSchema$View$traduit, i18n, champ))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$td,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
									]),
								_Utils_ap(
									A5(
										action,
										tableau.g_ && (!_Utils_eq(fournie.JR, $elm$core$Maybe$Nothing)),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id(
												$author$project$Components$Shared$EditeurDeSchema$View$idDeLaModification(cle))
											]),
										$author$project$Components$Shared$EditeurDeSchema$View$ModificationDemandee(cle),
										$author$project$I18n$Cles$editeurDeSchemaActionsModifier(i18n),
										$author$project$I18n$Cles$editeurDeSchemaActionsModifierDe(i18n)),
									_Utils_ap(
										A5(
											action,
											fournie.Hk,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$id(
													$author$project$Components$Shared$EditeurDeSchema$View$idDesReglages(cle))
												]),
											$author$project$Components$Shared$EditeurDeSchema$View$ReglagesDemandes(cle),
											$author$project$I18n$Cles$editeurDeSchemaActionsRegler(i18n),
											$author$project$I18n$Cles$editeurDeSchemaActionsReglerDe(i18n)),
										_Utils_ap(
											A5(
												action,
												fournie.B8,
												_List_Nil,
												$author$project$Components$Shared$EditeurDeSchema$View$MasquageDemande(cle),
												$author$project$I18n$Cles$editeurDeSchemaActionsMasquer(i18n),
												$author$project$I18n$Cles$editeurDeSchemaActionsMasquerDe(i18n)),
											A5(
												action,
												fournie.s$,
												_List_Nil,
												$author$project$Components$Shared$EditeurDeSchema$View$AffichageDemande(cle),
												$author$project$I18n$Cles$editeurDeSchemaActionsReafficher(i18n),
												$author$project$I18n$Cles$editeurDeSchemaActionsReafficherDe(i18n))))))
							])))));
	});
var $author$project$Components$Shared$EditeurDeSchema$View$liste = F3(
	function (i18n, tableau, lignes) {
		var cles = A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.uN;
				},
				function ($) {
					return $.dy;
				}),
			lignes);
		var avecOrigine = A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.o4;
				},
				$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
			lignes);
		var colonnes = _Utils_ap(
			tableau.bP ? _List_fromArray(
				[
					$author$project$I18n$Cles$editeurDeSchemaColonneOrdre(i18n)
				]) : _List_Nil,
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$I18n$Cles$editeurDeSchemaColonneChamp(i18n),
						$author$project$I18n$Cles$editeurDeSchemaColonneType(i18n),
						$author$project$I18n$Cles$editeurDeSchemaColonneExigence(i18n)
					]),
				_Utils_ap(
					avecOrigine ? _List_fromArray(
						[
							$author$project$I18n$Cles$editeurDeSchemaColonneOrigine(i18n)
						]) : _List_Nil,
					_List_fromArray(
						[
							$author$project$I18n$Cles$editeurDeSchemaColonneTraduit(i18n),
							$author$project$I18n$Cles$editeurDeSchemaColonneActions(i18n)
						]))));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('editeur-de-schema'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('loading', tableau.yj)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-busy',
					tableau.yj ? 'true' : 'false')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$table,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (nom) {
											return A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(nom)
													]));
										},
										colonnes))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$tbody,
							_List_Nil,
							A2(
								$elm$core$List$map,
								A4(
									$author$project$Components$Shared$EditeurDeSchema$View$ligne,
									i18n,
									tableau,
									avecOrigine,
									{
										xg: $elm$core$List$head(
											$elm$core$List$reverse(cles)),
										Ge: $elm$core$List$head(cles)
									}),
								lignes))
						]))
				]));
	});
var $author$project$I18n$Cles$produitsTypesCaracteristiques = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.caracteristiques', _List_Nil, 'Informations');
};
var $author$project$I18n$Cles$produitsTypesCaracteristiquesAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.caracteristiques.aide', _List_Nil, '« À la publication » : la référence s\'enregistre sans la valeur, mais n\'est pas publiable tant qu\'elle manque (indicateur de complétude). « Traduit » : une valeur par langue ; absente, la langue principale s\'affiche.');
};
var $author$project$I18n$Cles$produitsTypesCaracteristiquesAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.caracteristiques.aucune', _List_Nil, 'Aucune information');
};
var $author$project$Components$Produits$FicheType$View$caracteristiques = F3(
	function (i18n, model, fiche) {
		var modifiable = !_Utils_eq(
			$author$project$Components$Produits$FicheType$Model$evolution(fiche),
			$elm$core$Maybe$Nothing);
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$FicheType$Model$idDeLaSection),
					$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1)
				]),
			{
				fw: modifiable ? _Utils_ap(
					_List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$FicheType$Model$idDeLAjout),
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$FicheType$Update$AjoutOuvert)
								]),
							$author$project$I18n$Cles$editeurDeSchemaAjouterTitre(i18n))
						]),
					(!_Utils_eq(
						$author$project$Components$Produits$FicheType$Model$rattachement(fiche),
						$elm$core$Maybe$Nothing)) ? _List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$FicheType$Model$idDuRattachement),
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$FicheType$Update$RattachementOuvert)
								]),
							$author$project$I18n$Cles$produitsTypesAjoutRattacher(i18n))
						]) : _List_Nil) : _List_Nil,
				fZ: _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$EditeurDeSchema$View$liste,
						i18n,
						{
							yj: $author$project$Components$Produits$Common$Envoi$enCours(model.l2),
							m_: model.m_,
							g_: modifiable,
							bP: !_Utils_eq(
								A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ordonnerLesChamps, fiche.nQ),
								$elm$core$Maybe$Nothing),
							h1: $author$project$Components$Produits$FicheType$Update$DuTableau,
							sb: fiche.x5.sb
						},
						A2($author$project$Components$Produits$FicheType$Model$lignes, i18n, fiche)),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('annonce'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-live', 'polite')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$I18n$Cles$texte, i18n, model.iP))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$List$isEmpty(fiche.dw) ? $author$project$I18n$Cles$produitsTypesCaracteristiquesAucune(i18n) : '')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsTypesCaracteristiquesAide(i18n))
							]))
					]),
				Dj: 'caracteristiques',
				h6: $author$project$I18n$Cles$produitsTypesCaracteristiques(i18n)
			});
	});
var $author$project$Components$Shared$CollectionsDuType$Update$OuvrirAjout = function (a) {
	return {$: 0, a: a};
};
var $author$project$I18n$Cles$collectionsTypeAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.type.aide', _List_Nil, 'Tout ou partie des champs d\'une collection se rattachent au type en un seul geste.');
};
var $author$project$I18n$Cles$collectionsTypeAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.type.ajouter', _List_Nil, 'Ajouter une collection');
};
var $author$project$I18n$Cles$collectionsTypeAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.type.aucune', _List_Nil, 'Aucune collection n\'est proposée pour ce type.');
};
var $author$project$I18n$Cles$collectionsTypeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.type.titre', _List_Nil, 'Collections du type');
};
var $author$project$Components$Shared$CollectionsDuType$Update$OuvrirRetrait = function (a) {
	return {$: 1, a: a};
};
var $author$project$I18n$Cles$collectionsTypeChampsSurLeType = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'collections.type.champs-sur-le-type',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champ sur le type') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champs sur le type'));
	});
var $author$project$I18n$Cles$collectionsTypeRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.type.retirer', _List_Nil, 'Retirer');
};
var $author$project$I18n$Cles$collectionsTypeRetirerNom = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'collections.type.retirer-nom',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer la collection « ' + (p.Dj + ' »'));
	});
var $author$project$Components$Shared$CollectionsDuType$View$uneCollection = F3(
	function (i18n, config, collection) {
		var surLeType = $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function ($) {
					return $.e6;
				},
				collection.dw));
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('collection'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('sur-le-type', collection.e6)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(collection.Bl)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('tag')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$collectionsTypeChampsSurLeType,
								i18n,
								{w: surLeType}))
						])),
					(config.Fo && collection.e6) ? A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(
							$author$project$Components$Shared$CollectionsDuType$Model$idDuRetrait(collection.dy)),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer'),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-label',
							A2(
								$author$project$I18n$Cles$collectionsTypeRetirerNom,
								i18n,
								{Dj: collection.Bl})),
							$rtfeldman$elm_css$Html$Styled$Attributes$title(
							A2(
								$author$project$I18n$Cles$collectionsTypeRetirerNom,
								i18n,
								{Dj: collection.Bl})),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							config.KD(
								$author$project$Components$Shared$CollectionsDuType$Update$OuvrirRetrait(collection.dy)))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$collectionsTypeRetirer(i18n))
						])) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$Components$Shared$CollectionsDuType$View$carte = F3(
	function (i18n, config, collections) {
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_Nil,
			{
				fw: _Utils_ap(
					(config.Fj && (!$elm$core$List$isEmpty(collections))) ? _List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Shared$CollectionsDuType$Model$idDeLAjout),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('ajouter-une-collection'),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									config.KD(
										$author$project$Components$Shared$CollectionsDuType$Update$OuvrirAjout($elm$core$Maybe$Nothing)))
								]),
							$author$project$I18n$Cles$collectionsTypeAjouter(i18n))
						]) : _List_Nil,
					function () {
						var _v0 = config.Ek;
						if (!_v0.$) {
							var geste = _v0.a;
							return _List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Shared$OrdreDesBlocs$Model$idDuDeclencheur),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('ordonner-les-blocs'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(geste)
										]),
									$author$project$I18n$Cles$ordreDesBlocsOuvrir(i18n))
								]);
						} else {
							return _List_Nil;
						}
					}()),
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('lead')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$collectionsTypeAide(i18n))
							])),
						$elm$core$List$isEmpty(collections) ? A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aucune')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$collectionsTypeAucune(i18n))
							])) : A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('collections')
							]),
						A2(
							$elm$core$List$map,
							A2($author$project$Components$Shared$CollectionsDuType$View$uneCollection, i18n, config),
							collections))
					]),
				Dj: 'collections-du-type',
				h6: $author$project$I18n$Cles$collectionsTypeTitre(i18n)
			});
	});
var $author$project$I18n$Cles$collectionsTypeDroit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.type.droit', _List_Nil, 'Droit requis : Paramétrage du catalogue');
};
var $author$project$Components$Produits$FicheType$RegleDeCode$Enregistrer = {$: 12};
var $author$project$Components$Produits$FicheType$RegleDeCode$AjoutAnnule = {$: 6};
var $author$project$Components$Produits$FicheType$RegleDeCode$AjoutChamp = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Produits$FicheType$RegleDeCode$AjoutGenre = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Produits$FicheType$RegleDeCode$AjoutOuvert = {$: 5};
var $author$project$Components$Produits$FicheType$RegleDeCode$AjoutTexte = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Produits$FicheType$RegleDeCode$AjoutTranche = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Produits$FicheType$RegleDeCode$AjoutValide = {$: 11};
var $author$project$Components$Produits$FicheType$RegleDeCodeView$genreEnCode = function (genre) {
	switch (genre) {
		case 0:
			return '1';
		case 1:
			return '2';
		case 2:
			return '3';
		default:
			return '4';
	}
};
var $author$project$I18n$Cles$produitsTypesCodeAjoutAnnuler = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.ajout.annuler', _List_Nil, 'Annuler l\'ajout');
};
var $author$project$I18n$Cles$produitsTypesCodeAjoutChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.ajout.champ', _List_Nil, 'Champ');
};
var $author$project$I18n$Cles$produitsTypesCodeAjoutGenre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.ajout.genre', _List_Nil, 'Type de segment');
};
var $author$project$I18n$Cles$produitsTypesCodeAjoutTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.ajout.texte', _List_Nil, 'Texte');
};
var $author$project$I18n$Cles$produitsTypesCodeAjoutTranche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.ajout.tranche', _List_Nil, 'Premiers caractères (facultatif)');
};
var $author$project$I18n$Cles$produitsTypesCodeAjoutValider = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.ajout.valider', _List_Nil, 'Ajouter');
};
var $author$project$I18n$Cles$produitsTypesCodeAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.ajouter', _List_Nil, 'Ajouter un segment');
};
var $author$project$I18n$Cles$produitsTypesCodeSegmentCompteur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.segment.compteur', _List_Nil, 'Compteur');
};
var $author$project$I18n$Cles$produitsTypesCodeSegmentMarque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.segment.marque', _List_Nil, 'Code de la marque');
};
var $author$project$I18n$Cles$produitsTypesCodeSegmentTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.segment.texte', _List_Nil, 'Texte fixe');
};
var $author$project$I18n$Cles$produitsTypesCodeSegmentValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.segment.valeur', _List_Nil, 'Code d\'une valeur');
};
var $author$project$Components$Produits$FicheType$RegleDeCodeView$ajout = F5(
	function (i18n, versLeParent, fiche, prefixe, courante) {
		var _v0 = courante.fw;
		if (_v0.$ === 1) {
			return A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ajouter-un-segment'),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						versLeParent($author$project$Components$Produits$FicheType$RegleDeCode$AjoutOuvert))
					]),
				$author$project$I18n$Cles$produitsTypesCodeAjouter(i18n));
		} else {
			var saisie = _v0.a;
			var champs = A2($author$project$Components$Produits$FicheType$RegleDeCode$champsDeType, saisie.M, fiche);
			var champ = F2(
				function (id, libelle) {
					return {
						go: $elm$core$Maybe$Nothing,
						Aq: _Utils_ap(prefixe, id),
						Bl: libelle,
						he: false
					};
				});
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout')
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Champ$View$liste,
							A2(
								champ,
								'-ajout-genre',
								$author$project$I18n$Cles$produitsTypesCodeAjoutGenre(i18n)),
							{
								hg: A2($elm$core$Basics$composeR, $author$project$Components$Produits$FicheType$RegleDeCode$AjoutGenre, versLeParent),
								o_: _List_fromArray(
									[
										{
										Bl: $author$project$I18n$Cles$produitsTypesCodeSegmentTexte(i18n),
										fm: '1'
									},
										{
										Bl: $author$project$I18n$Cles$produitsTypesCodeSegmentMarque(i18n),
										fm: '2'
									},
										{
										Bl: $author$project$I18n$Cles$produitsTypesCodeSegmentValeur(i18n),
										fm: '3'
									},
										{
										Bl: $author$project$I18n$Cles$produitsTypesCodeSegmentCompteur(i18n),
										fm: '4'
									}
									]),
								fm: $author$project$Components$Produits$FicheType$RegleDeCodeView$genreEnCode(saisie.M)
							})
						]),
					_Utils_ap(
						function () {
							var _v1 = saisie.M;
							switch (_v1) {
								case 0:
									return _List_fromArray(
										[
											A2(
											$author$project$Components$Shared$Champ$View$texte,
											A2(
												champ,
												'-ajout-texte',
												$author$project$I18n$Cles$produitsTypesCodeAjoutTexte(i18n)),
											{
												hg: A2($elm$core$Basics$composeR, $author$project$Components$Produits$FicheType$RegleDeCode$AjoutTexte, versLeParent),
												fm: saisie.Jx
											})
										]);
								case 3:
									return _List_Nil;
								default:
									return A2(
										$elm$core$List$cons,
										A2(
											$author$project$Components$Shared$Champ$View$liste,
											A2(
												champ,
												'-ajout-champ',
												$author$project$I18n$Cles$produitsTypesCodeAjoutChamp(i18n)),
											{
												hg: A2($elm$core$Basics$composeR, $author$project$Components$Produits$FicheType$RegleDeCode$AjoutChamp, versLeParent),
												o_: A2(
													$elm$core$List$cons,
													{Bl: '', fm: ''},
													A2(
														$elm$core$List$map,
														function (lu) {
															return {Bl: lu.Bl, fm: lu.dy};
														},
														champs)),
												fm: saisie.uN
											}),
										(saisie.M === 2) ? _List_fromArray(
											[
												A2(
												$author$project$Components$Shared$Champ$View$texte,
												A2(
													champ,
													'-ajout-tranche',
													$author$project$I18n$Cles$produitsTypesCodeAjoutTranche(i18n)),
												{
													hg: A2($elm$core$Basics$composeR, $author$project$Components$Produits$FicheType$RegleDeCode$AjoutTranche, versLeParent),
													fm: saisie.ff
												})
											]) : _List_Nil);
							}
						}(),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('gestes')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Components$Shared$Bouton$View$bouton,
										1,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												versLeParent($author$project$Components$Produits$FicheType$RegleDeCode$AjoutAnnule))
											]),
										$author$project$I18n$Cles$produitsTypesCodeAjoutAnnuler(i18n)),
										A3(
										$author$project$Components$Shared$Bouton$View$bouton,
										0,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												versLeParent($author$project$Components$Produits$FicheType$RegleDeCode$AjoutValide))
											]),
										$author$project$I18n$Cles$produitsTypesCodeAjoutValider(i18n))
									]))
							]))));
		}
	});
var $author$project$Components$Produits$FicheType$RegleDeCodeView$morceau = F2(
	function (segment, texte) {
		if (!segment.$) {
			return $rtfeldman$elm_css$Html$Styled$text(texte);
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('tok')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(texte)
					]));
		}
	});
var $author$project$I18n$Cles$produitsTypesCodeApercu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.apercu', _List_Nil, 'Aperçu');
};
var $author$project$I18n$Cles$produitsTypesCodeApercuIndisponible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.apercu-indisponible', _List_Nil, 'un code de marque ou de valeur manque');
};
var $author$project$Components$Produits$FicheType$RegleDeCodeView$apercuDuDrawer = F2(
	function (i18n, courante) {
		var _v0 = courante.tq;
		if (_v0.$ === 1) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var lu = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$b,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsTypesCodeApercu(i18n))
							])),
						function () {
						var _v1 = _Utils_Tuple2(
							lu.vx,
							_Utils_eq(
								$elm$core$List$length(lu.E0),
								$elm$core$List$length(courante.Iy)));
						if (!_v1.a.$) {
							if (_v1.b) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('regle')
										]),
									A3($elm$core$List$map2, $author$project$Components$Produits$FicheType$RegleDeCodeView$morceau, courante.Iy, lu.E0));
							} else {
								var code = _v1.a.a;
								return A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('regle')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(code)
										]));
							}
						} else {
							var _v2 = _v1.a;
							return _Utils_eq(lu.pZ, $elm$core$Maybe$Nothing) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('indisponible')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsTypesCodeApercuIndisponible(i18n))
									])) : $rtfeldman$elm_css$Html$Styled$text('');
						}
					}()
					]));
		}
	});
var $author$project$I18n$Cles$produitsTypesCodeDrawerEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.drawer.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$produitsTypesCodeDrawerJugee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.drawer.jugee', _List_Nil, 'Jugée à l\'enregistrement. Le numéro du compteur est attribué à la création d\'une référence, pas avant.');
};
var $author$project$I18n$Cles$produitsTypesCodeDrawerSegments = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.drawer.segments', _List_Nil, 'Segments, dans l\'ordre');
};
var $author$project$I18n$Cles$produitsTypesCodeDrawerSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.code.drawer.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.Dj + ' · Code de référence');
	});
var $author$project$I18n$Cles$produitsTypesCodeDrawerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.drawer.titre', _List_Nil, 'Modifier la règle de code');
};
var $author$project$I18n$Cles$produitsTypesCodeDrawerVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.drawer.vide', _List_Nil, 'Aucun segment : ajoutez-en un.');
};
var $author$project$Components$Produits$FicheType$RegleDeCodeView$libelleDuChamp = F2(
	function (fiche, cle) {
		return A2(
			$elm$core$Maybe$withDefault,
			cle,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.uN;
					},
					function ($) {
						return $.Bl;
					}),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.uN;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.dy;
								},
								$elm$core$Basics$eq(cle))),
						fiche.dw))));
	});
var $author$project$I18n$Cles$produitsTypesCodeRefusAutre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.refus.autre', _List_Nil, 'La règle n\'a pas pu être enregistrée.');
};
var $author$project$I18n$Cles$produitsTypesCodeRefusChampAbsent = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.code.refus.champ-absent',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rang',
					$author$project$I18n$Traductions$Chaine(p.bY)),
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'Segment ' + (p.bY + (' : le champ « ' + (p.uN + ' » n\'est pas sur ce type.'))));
	});
var $author$project$I18n$Cles$produitsTypesCodeRefusChampNonListe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.code.refus.champ-non-liste',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rang',
					$author$project$I18n$Traductions$Chaine(p.bY)),
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'Segment ' + (p.bY + (' : le champ « ' + (p.uN + ' » n\'est pas une liste.'))));
	});
var $author$project$I18n$Cles$produitsTypesCodeRefusChampNonTexte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.code.refus.champ-non-texte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rang',
					$author$project$I18n$Traductions$Chaine(p.bY)),
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'Segment ' + (p.bY + (' : le champ « ' + (p.uN + ' » n\'est pas un texte.'))));
	});
var $author$project$I18n$Cles$produitsTypesCodeRefusCompteurEnDouble = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.refus.compteur-en-double', _List_Nil, 'Un seul compteur par règle.');
};
var $author$project$I18n$Cles$produitsTypesCodeRefusListeSansCode = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.code.refus.liste-sans-code',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rang',
					$author$project$I18n$Traductions$Chaine(p.bY)),
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'Segment ' + (p.bY + (' : la liste du champ « ' + (p.uN + ' » n\'a pas d\'attribut « code ».'))));
	});
var $author$project$I18n$Cles$produitsTypesCodeRefusRegleVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.refus.regle-vide', _List_Nil, 'La règle est vide : ajoutez au moins un segment.');
};
var $author$project$I18n$Cles$produitsTypesCodeRefusTrancheNulle = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.code.refus.tranche-nulle',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rang',
					$author$project$I18n$Traductions$Chaine(p.bY))
				]),
			'Segment ' + (p.bY + ' : la tranche doit garder au moins un caractère.'));
	});
var $author$project$Catalogue$Vocabulaire$refusDeRegleDeCode = F3(
	function (i18n, motif, cite) {
		switch (motif) {
			case 'regle-vide':
				return $author$project$I18n$Cles$produitsTypesCodeRefusRegleVide(i18n);
			case 'champ-absent':
				return A2($author$project$I18n$Cles$produitsTypesCodeRefusChampAbsent, i18n, cite);
			case 'champ-non-texte':
				return A2($author$project$I18n$Cles$produitsTypesCodeRefusChampNonTexte, i18n, cite);
			case 'champ-non-liste':
				return A2($author$project$I18n$Cles$produitsTypesCodeRefusChampNonListe, i18n, cite);
			case 'liste-sans-code':
				return A2($author$project$I18n$Cles$produitsTypesCodeRefusListeSansCode, i18n, cite);
			case 'tranche-nulle':
				return A2(
					$author$project$I18n$Cles$produitsTypesCodeRefusTrancheNulle,
					i18n,
					{bY: cite.bY});
			case 'compteur-en-double':
				return $author$project$I18n$Cles$produitsTypesCodeRefusCompteurEnDouble(i18n);
			default:
				return $author$project$I18n$Cles$produitsTypesCodeRefusAutre(i18n);
		}
	});
var $author$project$Components$Produits$FicheType$RegleDeCodeView$refus = F3(
	function (i18n, fiche, lu) {
		var rang = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Maybe$map, $elm$core$String$fromInt, lu.Ix));
		var champ = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$Produits$FicheType$RegleDeCodeView$libelleDuChamp(fiche),
				lu.uN));
		var dit = A3(
			$author$project$Catalogue$Vocabulaire$refusDeRegleDeCode,
			i18n,
			lu.cX,
			{uN: champ, bY: rang});
		return A2(
			$author$project$Components$Shared$Note$View$view,
			2,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(dit)
				]));
	});
var $author$project$Components$Produits$FicheType$RegleDeCode$Descendre = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Produits$FicheType$RegleDeCode$Monter = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$FicheType$RegleDeCode$Retirer = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$FicheType$RegleDeCodeView$nomDuSegment = F2(
	function (i18n, segment) {
		switch (segment.$) {
			case 0:
				return $author$project$I18n$Cles$produitsTypesCodeSegmentTexte(i18n);
			case 1:
				return $author$project$I18n$Cles$produitsTypesCodeSegmentMarque(i18n);
			case 2:
				return $author$project$I18n$Cles$produitsTypesCodeSegmentValeur(i18n);
			default:
				return $author$project$I18n$Cles$produitsTypesCodeSegmentCompteur(i18n);
		}
	});
var $author$project$I18n$Cles$produitsTypesCodeDescendre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.code.descendre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rang',
					$author$project$I18n$Traductions$Chaine(p.bY))
				]),
			'Descendre le segment ' + p.bY);
	});
var $author$project$I18n$Cles$produitsTypesCodeMonter = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.code.monter',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rang',
					$author$project$I18n$Traductions$Chaine(p.bY))
				]),
			'Monter le segment ' + p.bY);
	});
var $author$project$I18n$Cles$produitsTypesCodeRetirer = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.code.retirer',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rang',
					$author$project$I18n$Traductions$Chaine(p.bY))
				]),
			'Retirer le segment ' + p.bY);
	});
var $author$project$I18n$Cles$produitsTypesCodeReglageCompteur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.reglage.compteur', _List_Nil, '4 chiffres, à partir de 1');
};
var $author$project$I18n$Cles$produitsTypesCodeReglageMarque = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.code.reglage.marque',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'champ « ' + (p.uN + ' » de l\'étage marque'));
	});
var $author$project$I18n$Cles$produitsTypesCodeReglageTexte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.code.reglage.texte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'texte',
					$author$project$I18n$Traductions$Chaine(p.Jx))
				]),
			'« ' + (p.Jx + ' »'));
	});
var $author$project$I18n$Cles$produitsTypesCodeReglageValeur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.code.reglage.valeur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			p.uN + ' · attribut « code »');
	});
var $author$project$I18n$Cles$produitsTypesCodeReglageValeurTranche = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.code.reglage.valeur-tranche',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN)),
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			p.uN + (' · attribut « code » · ' + (p.d + ' premiers caractères')));
	});
var $author$project$Components$Produits$FicheType$RegleDeCodeView$reglageDuSegment = F3(
	function (i18n, fiche, segment) {
		switch (segment.$) {
			case 0:
				var texte = segment.a;
				return A2(
					$author$project$I18n$Cles$produitsTypesCodeReglageTexte,
					i18n,
					{Jx: texte});
			case 1:
				var champ = segment.a;
				return A2(
					$author$project$I18n$Cles$produitsTypesCodeReglageMarque,
					i18n,
					{
						uN: A2($author$project$Components$Produits$FicheType$RegleDeCodeView$libelleDuChamp, fiche, champ)
					});
			case 2:
				if (segment.b.$ === 1) {
					var champ = segment.a;
					var _v1 = segment.b;
					return A2(
						$author$project$I18n$Cles$produitsTypesCodeReglageValeur,
						i18n,
						{
							uN: A2($author$project$Components$Produits$FicheType$RegleDeCodeView$libelleDuChamp, fiche, champ)
						});
				} else {
					var champ = segment.a;
					var n = segment.b.a;
					return A2(
						$author$project$I18n$Cles$produitsTypesCodeReglageValeurTranche,
						i18n,
						{
							uN: A2($author$project$Components$Produits$FicheType$RegleDeCodeView$libelleDuChamp, fiche, champ),
							d: $elm$core$String$fromInt(n)
						});
				}
			default:
				return $author$project$I18n$Cles$produitsTypesCodeReglageCompteur(i18n);
		}
	});
var $author$project$Components$Produits$FicheType$RegleDeCodeView$segmentDuDrawer = F6(
	function (i18n, versLeParent, fiche, total, index, lu) {
		var rang = index + 1;
		var nom = $elm$core$String$fromInt(rang) + (' · ' + A2($author$project$Components$Produits$FicheType$RegleDeCodeView$nomDuSegment, i18n, lu));
		var geste = F2(
			function (cle, msg) {
				return A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					2,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-label',
							cle(
								{
									bY: $elm$core$String$fromInt(rang)
								})),
							$rtfeldman$elm_css$Html$Styled$Attributes$title(
							cle(
								{
									bY: $elm$core$String$fromInt(rang)
								})),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							versLeParent(msg))
						]),
					cle(
						{
							bY: $elm$core$String$fromInt(rang)
						}));
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('segment')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(nom)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A3($author$project$Components$Produits$FicheType$RegleDeCodeView$reglageDuSegment, i18n, fiche, lu))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('gestes')
						]),
					_Utils_ap(
						(rang > 1) ? _List_fromArray(
							[
								A2(
								geste,
								$author$project$I18n$Cles$produitsTypesCodeMonter(i18n),
								$author$project$Components$Produits$FicheType$RegleDeCode$Monter(rang))
							]) : _List_Nil,
						_Utils_ap(
							(_Utils_cmp(rang, total) < 0) ? _List_fromArray(
								[
									A2(
									geste,
									$author$project$I18n$Cles$produitsTypesCodeDescendre(i18n),
									$author$project$Components$Produits$FicheType$RegleDeCode$Descendre(rang))
								]) : _List_Nil,
							_List_fromArray(
								[
									A2(
									geste,
									$author$project$I18n$Cles$produitsTypesCodeRetirer(i18n),
									$author$project$Components$Produits$FicheType$RegleDeCode$Retirer(rang))
								]))))
				]));
	});
var $author$project$Components$Produits$FicheType$RegleDeCodeView$drawer = F5(
	function (i18n, options, fiche, saisie, drawerModel) {
		var courante = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$Produits$FicheType$RegleDeCode$enCoursDe(fiche),
			saisie);
		return A5(
			$author$project$Components$Shared$Drawer$View$viewAvecSousTitre,
			i18n,
			A2(
				$author$project$I18n$Cles$produitsTypesCodeDrawerSousTitre,
				i18n,
				{Dj: fiche.fh.Dj.zX}),
			A2($elm$core$Basics$composeR, $author$project$Components$Produits$FicheType$RegleDeCode$DuDrawer, options.KD),
			{
				fs: {
					sR: !options.yj,
					Bl: $author$project$I18n$Cles$produitsTypesCodeDrawerEnregistrer(i18n),
					C$: options.KD($author$project$Components$Produits$FicheType$RegleDeCode$Enregistrer)
				},
				fZ: _List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						$rtfeldman$elm_css$Html$Styled$text(''),
						A2(
							$elm$core$Maybe$map,
							A2($author$project$Components$Produits$FicheType$RegleDeCodeView$refus, i18n, fiche),
							function () {
								var _v0 = courante.pZ;
								if (!_v0.$) {
									var dit = _v0.a;
									return $elm$core$Maybe$Just(dit);
								} else {
									return A2(
										$elm$core$Maybe$andThen,
										function ($) {
											return $.pZ;
										},
										courante.tq);
								}
							}())),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsTypesCodeDrawerSegments(i18n))
							])),
						$elm$core$List$isEmpty(courante.Iy) ? A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aucune')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsTypesCodeDrawerVide(i18n))
							])) : A2(
						$rtfeldman$elm_css$Html$Styled$ol,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('segments')
							]),
						A2(
							$elm$core$List$indexedMap,
							A4(
								$author$project$Components$Produits$FicheType$RegleDeCodeView$segmentDuDrawer,
								i18n,
								options.KD,
								fiche,
								$elm$core$List$length(courante.Iy)),
							courante.Iy)),
						A5(
						$author$project$Components$Produits$FicheType$RegleDeCodeView$ajout,
						i18n,
						options.KD,
						fiche,
						$author$project$Components$Shared$Drawer$Model$idRacine(drawerModel),
						courante),
						A2($author$project$Components$Produits$FicheType$RegleDeCodeView$apercuDuDrawer, i18n, courante),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsTypesCodeDrawerJugee(i18n))
							]))
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$produitsTypesCodeDrawerTitre(i18n)
			},
			drawerModel);
	});
var $author$project$Components$Produits$FicheType$Update$DrawerValide = {$: 11};
var $author$project$Components$Produits$FicheType$Model$champEnModification = F2(
	function (saisie, fiche) {
		return A2(
			$elm$core$Maybe$andThen,
			function (enregistre) {
				return A2($elm$core$Dict$get, enregistre.dy, fiche.dq);
			},
			saisie.lZ);
	});
var $author$project$I18n$Cles$editeurDeSchemaAjouterValider = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.ajouter.valider', _List_Nil, 'Ajouter le champ');
};
var $author$project$I18n$Cles$editeurDeSchemaModifierValider = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.modifier.valider', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$editeurDeSchemaPartageValider = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.partage.valider', _List_Nil, 'Enregistrer le rattachement');
};
var $author$project$Components$Produits$FicheType$Update$DeLEditeur = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Resserrage$DesProduits = 0;
var $author$project$I18n$Cles$produitsTypesResserrageConsequence = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.resserrage.consequence', _List_Nil, 'Ils restent enregistrés et modifiables, mais ne sont plus publiables tant que la valeur n\'est pas corrigée. Ils apparaîtront dans Produits › Alertes. Aucune valeur saisie n\'est modifiée.');
};
var $author$project$I18n$Cles$produitsTypesResserrageTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.resserrage.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' produit ne sera plus conforme') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' produits ne seront plus conformes'));
	});
var $author$project$I18n$Cles$produitsTypesResserrageTitreAuMoins = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.resserrage.titre-au-moins',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Au moins ' + (p.w + ' produits ne seront plus conformes'));
	});
var $author$project$I18n$Cles$referentielTypesResserrageConsequence = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.resserrage.consequence', _List_Nil, 'Elles restent enregistrées et modifiables, mais apparaîtront dans Alertes › Parties prenantes. Aucune valeur saisie n’est modifiée.');
};
var $author$project$I18n$Cles$referentielTypesResserrageTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.types.resserrage.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' partie prenante ne sera plus conforme') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' parties prenantes ne seront plus conformes'));
	});
var $author$project$I18n$Cles$referentielTypesResserrageTitreAuMoins = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.types.resserrage.titre-au-moins',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Au moins ' + (p.w + ' parties prenantes ne seront plus conformes'));
	});
var $author$project$Components$Shared$EditeurDeSchema$Resserrage$avertissement = F4(
	function (i18n, sujet, prefixe, apercu) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id(
					$author$project$Components$Shared$EditeurDeSchema$Resserrage$idDeLApercu(prefixe)),
					$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('note', true),
							_Utils_Tuple2('avertissement', true)
						])),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'note')
				]),
			function () {
				if (apercu.$ === 2) {
					var nonConformes = apercu.a.oF;
					var auMoins = apercu.a.tW;
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									function () {
										var _v1 = _Utils_Tuple2(sujet, auMoins);
										if (!_v1.a) {
											if (_v1.b) {
												var _v2 = _v1.a;
												return A2(
													$author$project$I18n$Cles$produitsTypesResserrageTitreAuMoins,
													i18n,
													{
														w: $elm$core$String$fromInt(nonConformes)
													});
											} else {
												var _v3 = _v1.a;
												return A2(
													$author$project$I18n$Cles$produitsTypesResserrageTitre,
													i18n,
													{w: nonConformes});
											}
										} else {
											if (_v1.b) {
												var _v4 = _v1.a;
												return A2(
													$author$project$I18n$Cles$referentielTypesResserrageTitreAuMoins,
													i18n,
													{
														w: $elm$core$String$fromInt(nonConformes)
													});
											} else {
												var _v5 = _v1.a;
												return A2(
													$author$project$I18n$Cles$referentielTypesResserrageTitre,
													i18n,
													{w: nonConformes});
											}
										}
									}())
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									function () {
										if (!sujet) {
											return $author$project$I18n$Cles$produitsTypesResserrageConsequence(i18n);
										} else {
											return $author$project$I18n$Cles$referentielTypesResserrageConsequence(i18n);
										}
									}())
								]))
						]);
				} else {
					return _List_Nil;
				}
			}());
	});
var $author$project$Components$Produits$FicheType$View$contexteDuDrawer = F2(
	function (model, fiche) {
		return {
			sZ: $author$project$Routes$Route$adresseBibliothequeDeChamps,
			cC: 0,
			Dp: fiche.fh.Dj.zX,
			pv: $author$project$Components$Shared$Drawer$Model$idRacine(model.kX)
		};
	});
var $author$project$Components$Shared$Bibliotheque$View$filtrableAdmis = function (code) {
	return A2(
		$elm$core$List$member,
		code,
		_List_fromArray(
			['liste', 'choix-multiples', 'choix-dans-une-liste', 'choix-dans-une-liste-partagee', 'oui-non']));
};
var $author$project$Components$Shared$Bibliotheque$View$existantRattachable = F3(
	function (contexte, entree, existant) {
		return A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$Shared$Bibliotheque$Rattachement$rattachable(contexte.cC),
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$filter(
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(existant))),
						$elm$core$List$head),
					entree.pN.dq)));
	});
var $author$project$I18n$Cles$produitsTypesErreurChampDansLaBibliotheque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.erreur.champ-dans-la-bibliotheque', _List_Nil, 'Un champ de la bibliothèque porte déjà ce nom ou cette clé.');
};
var $author$project$I18n$Cles$produitsTypesErreurChampDansLaBibliothequeAutreNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.erreur.champ-dans-la-bibliotheque.autre-nom', _List_Nil, 'Choisir un autre nom');
};
var $author$project$I18n$Cles$produitsTypesErreurChampDansLaBibliothequeHorsPortee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.erreur.champ-dans-la-bibliotheque.hors-portee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nomDuType',
					$author$project$I18n$Traductions$Chaine(p.Dp))
				]),
			'Un champ de la bibliothèque porte déjà ce nom, mais sa portée exclut « ' + (p.Dp + ' » : il ne peut pas lui être rattaché.'));
	});
var $author$project$I18n$Cles$produitsTypesErreurChampDansLaBibliothequeIssue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.erreur.champ-dans-la-bibliotheque.issue', _List_Nil, 'Rattacher le champ existant');
};
var $author$project$Components$Shared$Bibliotheque$View$issueDeLaCreation = F4(
	function (i18n, contexte, msgs, entree) {
		var _v0 = _Utils_Tuple2(entree.kz, entree.hB);
		if ((!_v0.a.$) && _v0.b) {
			var existant = _v0.a.a;
			return A3($author$project$Components$Shared$Bibliotheque$View$existantRattachable, contexte, entree, existant) ? A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('refus'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsTypesErreurChampDansLaBibliotheque(i18n)),
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								msgs.uQ(existant))
							]),
						$author$project$I18n$Cles$produitsTypesErreurChampDansLaBibliothequeIssue(i18n))
					])) : A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('refus'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$produitsTypesErreurChampDansLaBibliothequeHorsPortee,
							i18n,
							{Dp: contexte.Dp})),
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick(msgs.t4)
							]),
						$author$project$I18n$Cles$produitsTypesErreurChampDansLaBibliothequeAutreNom(i18n))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$produitsTypesAjoutBandeauDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.ajout.bandeau.detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nomDuType',
					$author$project$I18n$Traductions$Chaine(p.Dp))
				]),
			'Sa portée est limitée au type « ' + (p.Dp + ' ». Un autre type pourra le rattacher plus tard si la portée est élargie.'));
	});
var $author$project$I18n$Cles$produitsTypesAjoutFiltrableNonAdmis = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.ajout.filtrable-non-admis', _List_Nil, 'Réservé aux champs liste, choix multiple, choix dans une liste partagée et oui/non.');
};
var $author$project$I18n$Cles$produitsTypesAjoutFiltrableNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.ajout.filtrable-note', _List_Nil, 'Décidé une fois pour toute la plateforme.');
};
var $author$project$I18n$Cles$produitsTypesAjoutRecherchableNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.ajout.recherchable-note', _List_Nil, 'Retrouver une fiche à partir de la valeur complète.');
};
var $author$project$I18n$Cles$produitsTypesAjoutSansLibellePropre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.ajout.sans-libelle-propre', _List_Nil, 'Pas de libellé propre à ce type : le nom est celui de la bibliothèque.');
};
var $author$project$Components$Shared$Bibliotheque$View$creation = F4(
	function (i18n, contexte, msgs, entree) {
		var uneCase = F6(
			function (suffixe, libelle, note, permis, cochee, onCheck) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('reglage')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Components$Shared$Champ$View$caseACocherInactivable,
							{go: $elm$core$Maybe$Nothing, Aq: contexte.pv + ('-' + suffixe), Bl: libelle, he: false},
							{vt: cochee && permis, d4: !permis, D9: onCheck}),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(note)
									]))
							])));
			});
		var admis = $author$project$Components$Shared$Bibliotheque$View$filtrableAdmis(entree.JR);
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Components$Shared$Note$View$view,
				0,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsTypesAjoutBandeauTitre(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$produitsTypesAjoutBandeauDetail,
									i18n,
									{Dp: contexte.Dp}))
							]))
					])),
			A2(
				$elm$core$List$cons,
				A4($author$project$Components$Shared$Bibliotheque$View$issueDeLaCreation, i18n, contexte, msgs, entree),
				_Utils_ap(
					entree.zT,
					_Utils_ap(
						_Utils_eq(entree.JR, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeGroupe) ? _List_Nil : _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('recherche')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('overline')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$bibliothequeReglagesRecherche(i18n))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('carte')
											]),
										_List_fromArray(
											[
												A6(
												uneCase,
												'filtrable',
												$author$project$I18n$Cles$bibliothequeReglagesFiltrable(i18n),
												admis ? $author$project$I18n$Cles$produitsTypesAjoutFiltrableNote(i18n) : $author$project$I18n$Cles$produitsTypesAjoutFiltrableNonAdmis(i18n),
												admis,
												entree.wZ.zG,
												msgs.zG),
												A6(
												uneCase,
												'recherchable',
												$author$project$I18n$Cles$bibliothequeReglagesRecherchable(i18n),
												$author$project$I18n$Cles$produitsTypesAjoutRecherchableNote(i18n),
												true,
												entree.wZ.G1,
												msgs.G1)
											]))
									]))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsTypesAjoutSansLibellePropre(i18n))
									]))
							])))));
	});
var $author$project$I18n$Cles$produitsTypesAjoutAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.ajout.aucun', _List_Nil, 'Aucun champ de la bibliothèque ne correspond.');
};
var $author$project$I18n$Cles$produitsTypesAjoutHorsPorteeAide = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.ajout.hors-portee.aide',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nomDuType',
					$author$project$I18n$Traductions$Chaine(p.Dp))
				]),
			'Un champ dont la portée exclut « ' + (p.Dp + ' » n\'est pas rattachable ; il faut d\'abord élargir sa portée dans la bibliothèque.'));
	});
var $author$project$I18n$Cles$produitsTypesAjoutRecherche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.ajout.recherche', _List_Nil, 'Rechercher dans la bibliothèque');
};
var $author$project$Components$Shared$Bibliotheque$Rattachement$proposes = function (rattachement) {
	var cherche = $elm$core$String$toLower(
		$elm$core$String$trim(rattachement.hC));
	return A2(
		$elm$core$List$filter,
		function (lu) {
			return A2(
				$elm$core$String$contains,
				cherche,
				$elm$core$String$toLower(lu.Bl));
		},
		A2($elm$core$Maybe$withDefault, _List_Nil, rattachement.dq));
};
var $author$project$I18n$Cles$produitsTypesAjoutPorteeCatalogue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.ajout.portee.catalogue', _List_Nil, 'Catalogue');
};
var $author$project$I18n$Cles$produitsTypesAjoutPorteePartiesPrenantes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.ajout.portee.parties-prenantes', _List_Nil, 'Parties prenantes');
};
var $author$project$Components$Shared$Bibliotheque$Vocabulaire$porteeDeLaBibliotheque = F2(
	function (i18n, code) {
		if (code === 'parties-prenantes') {
			return $author$project$I18n$Cles$produitsTypesAjoutPorteePartiesPrenantes(i18n);
		} else {
			return $author$project$I18n$Cles$produitsTypesAjoutPorteeCatalogue(i18n);
		}
	});
var $author$project$Components$Shared$Bibliotheque$View$porteeAffichee = F2(
	function (i18n, lu) {
		var _v0 = lu.o4;
		if (!_v0.$) {
			var origine = _v0.a;
			return origine.Dj;
		} else {
			return A2($author$project$Components$Shared$Bibliotheque$Vocabulaire$porteeDeLaBibliotheque, i18n, lu.F$);
		}
	});
var $author$project$Components$Shared$Bibliotheque$Vocabulaire$porteeElargie = F2(
	function (i18n, code) {
		switch (code) {
			case 'parties-prenantes':
				return $author$project$I18n$Cles$bibliothequePorteePartiesPrenantes(i18n);
			case 'catalogue-et-parties-prenantes':
				return $author$project$I18n$Cles$bibliothequePorteeProduitsEtPartiesPrenantes(i18n);
			default:
				return $author$project$I18n$Cles$bibliothequePorteeProduits(i18n);
		}
	});
var $author$project$I18n$Cles$produitsTypesAjoutHorsPortee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.ajout.hors-portee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'portee',
					$author$project$I18n$Traductions$Chaine(p.F$))
				]),
			'portée limitée à ' + p.F$);
	});
var $author$project$I18n$Cles$produitsTypesAjoutUtilise = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.ajout.utilise',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typeAffiche',
					$author$project$I18n$Traductions$Chaine(p.rU)),
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (p.rU + (' · utilisé par ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' type'))) : (p.rU + (' · utilisé par ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' types'))));
	});
var $author$project$Components$Shared$Bibliotheque$Vocabulaire$typeDeChamp = F2(
	function (i18n, code) {
		return A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeCourt, i18n, code);
	});
var $author$project$Components$Shared$Bibliotheque$View$proposition = F4(
	function (i18n, msgs, choix, lu) {
		var rattachable = A2($author$project$Components$Shared$Bibliotheque$Rattachement$rattachable, choix.cC, lu);
		var choisi = _Utils_eq(
			choix.vd,
			$elm$core$Maybe$Just(lu.Aq));
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('proposition'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('on', choisi),
							_Utils_Tuple2('hors-portee', !rattachable)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-pressed',
					choisi ? 'true' : 'false'),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					msgs.uN(lu.Aq))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('case'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('on', choisi)
								])),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(lu.Bl)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$produitsTypesAjoutUtilise,
										i18n,
										{
											w: lu.sf,
											rU: A2($author$project$Components$Shared$Bibliotheque$Vocabulaire$typeDeChamp, i18n, lu.rU)
										}))
								]))
						])),
					rattachable ? A2(
					$author$project$Components$Shared$Tag$View$view,
					5,
					A2($author$project$Components$Shared$Bibliotheque$Vocabulaire$porteeElargie, i18n, lu.F$)) : A2(
					$author$project$Components$Shared$Tag$View$view,
					1,
					A2(
						$author$project$I18n$Cles$produitsTypesAjoutHorsPortee,
						i18n,
						{
							F$: A2($author$project$Components$Shared$Bibliotheque$View$porteeAffichee, i18n, lu)
						}))
				]));
	});
var $author$project$Components$Shared$Bibliotheque$View$idDeLElargissement = F2(
	function (origine, identifiant) {
		return 'elargir-' + (origine + ('-' + identifiant));
	});
var $author$project$I18n$Cles$produitsTypesAjoutRefusAutre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.ajout.refus.autre', _List_Nil, 'Le champ n\'a pas pu être rattaché.');
};
var $author$project$I18n$Cles$produitsTypesAjoutRefusHorsPorteeIssue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.ajout.refus.hors-portee.issue', _List_Nil, 'Élargir la portée dans la bibliothèque');
};
var $author$project$I18n$Cles$produitsTypesAjoutRefusLimiteAUnType = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.ajout.refus.limite-a-un-type',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'La portée de ce champ est limitée à « ' + (p.Dj + ' » : il ne se rattache pas à un autre type.'));
	});
var $author$project$I18n$Cles$produitsTypesElargirHorsPorteeCorps = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.elargir.hors-portee.corps',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'limite',
					$author$project$I18n$Traductions$Chaine(p.nV)),
					_Utils_Tuple2(
					'nomDuType',
					$author$project$I18n$Traductions$Chaine(p.Dp))
				]),
			'Ce champ est limité ' + (p.nV + (' : il ne peut pas être rattaché à « ' + (p.Dp + ' » tant que sa portée n\'est pas élargie.'))));
	});
var $author$project$I18n$Cles$produitsTypesElargirLimiteOrigine = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.elargir.limite.origine',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'à « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$produitsTypesElargirLimitePartiesPrenantes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.elargir.limite.parties-prenantes', _List_Nil, 'aux parties prenantes');
};
var $author$project$I18n$Cles$produitsTypesElargirOuvrir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.elargir.ouvrir', _List_Nil, 'Élargir la portée…');
};
var $author$project$I18n$Cles$referentielTypesElargirLimiteCatalogue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.elargir.limite.catalogue', _List_Nil, 'au catalogue');
};
var $author$project$I18n$Cles$produitsTypesAjoutRefusHorsPortee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.ajout.refus.hors-portee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'portee',
					$author$project$I18n$Traductions$Chaine(p.F$))
				]),
			'La portée de ce champ (' + (p.F$ + ') n\'inclut pas les types de produit.'));
	});
var $author$project$I18n$Cles$referentielTypesAjoutRefusHorsPortee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.types.ajout.refus.hors-portee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'portee',
					$author$project$I18n$Traductions$Chaine(p.F$))
				]),
			'La portée de ce champ (' + (p.F$ + ') n\'inclut pas les types de partie prenante.'));
	});
var $author$project$Components$Shared$Bibliotheque$View$refusDePortee = F3(
	function (i18n, contexte, portee) {
		var _v0 = contexte.cC;
		if (!_v0) {
			return A2(
				$author$project$I18n$Cles$produitsTypesAjoutRefusHorsPortee,
				i18n,
				{F$: portee});
		} else {
			return A2(
				$author$project$I18n$Cles$referentielTypesAjoutRefusHorsPortee,
				i18n,
				{F$: portee});
		}
	});
var $author$project$I18n$Cles$produitsTypesElargirSansDroit = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.elargir.sans-droit',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'limite',
					$author$project$I18n$Traductions$Chaine(p.nV)),
					_Utils_Tuple2(
					'nomDuType',
					$author$project$I18n$Traductions$Chaine(p.Dp))
				]),
			'Ce champ est limité ' + (p.nV + ('. Il ne peut pas être rattaché à « ' + (p.Dp + ' » sans élargir sa portée, et votre profil n\'a pas le droit de l\'élargir aux types de produit. Demandez à une personne qui gère le paramétrage du catalogue.'))));
	});
var $author$project$I18n$Cles$referentielTypesElargirSansDroit = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.types.elargir.sans-droit',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'limite',
					$author$project$I18n$Traductions$Chaine(p.nV)),
					_Utils_Tuple2(
					'nomDuType',
					$author$project$I18n$Traductions$Chaine(p.Dp))
				]),
			'Ce champ est limité ' + (p.nV + ('. Il ne peut pas être rattaché à « ' + (p.Dp + ' » sans élargir sa portée aux types de partie prenante, et votre profil n\'a pas le droit de le faire. Demandez à une personne qui gère le paramétrage.'))));
	});
var $author$project$Components$Shared$Bibliotheque$View$sansDroit = F3(
	function (i18n, contexte, limite) {
		var _v0 = contexte.cC;
		if (!_v0) {
			return A2(
				$author$project$I18n$Cles$produitsTypesElargirSansDroit,
				i18n,
				{nV: limite, Dp: contexte.Dp});
		} else {
			return A2(
				$author$project$I18n$Cles$referentielTypesElargirSansDroit,
				i18n,
				{nV: limite, Dp: contexte.Dp});
		}
	});
var $author$project$I18n$Cles$produitsTypesElargirHorsPorteeTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.elargir.hors-portee.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			'La portée de « ' + (p.Bl + ' » ne couvre pas les types de produit.'));
	});
var $author$project$I18n$Cles$referentielTypesElargirHorsPorteeTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.types.elargir.hors-portee.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			'La portée de « ' + (p.Bl + ' » ne couvre pas les types de partie prenante.'));
	});
var $author$project$Components$Shared$Bibliotheque$View$titreHorsPortee = F3(
	function (i18n, contexte, lu) {
		var _v0 = contexte.cC;
		if (!_v0) {
			return A2(
				$author$project$I18n$Cles$produitsTypesElargirHorsPorteeTitre,
				i18n,
				{Bl: lu.Bl});
		} else {
			return A2(
				$author$project$I18n$Cles$referentielTypesElargirHorsPorteeTitre,
				i18n,
				{Bl: lu.Bl});
		}
	});
var $author$project$Components$Shared$Bibliotheque$View$refusDuRattachement = F4(
	function (i18n, contexte, msgs, choix) {
		var refusHorsPortee = function (portee) {
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A3(
						$author$project$Components$Shared$Bibliotheque$View$refusDePortee,
						i18n,
						contexte,
						A2($author$project$Components$Shared$Bibliotheque$Vocabulaire$porteeDeLaBibliotheque, i18n, portee))),
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$href(contexte.sZ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsTypesAjoutRefusHorsPorteeIssue(i18n))
						]))
				]);
		};
		var nomDuType = contexte.Dp;
		var limite = function (lu) {
			var _v4 = _Utils_Tuple2(lu.o4, contexte.cC);
			if (!_v4.a.$) {
				var origine = _v4.a.a;
				return A2(
					$author$project$I18n$Cles$produitsTypesElargirLimiteOrigine,
					i18n,
					{Dj: origine.Dj});
			} else {
				if (!_v4.b) {
					var _v5 = _v4.a;
					var _v6 = _v4.b;
					return $author$project$I18n$Cles$produitsTypesElargirLimitePartiesPrenantes(i18n);
				} else {
					var _v7 = _v4.a;
					var _v8 = _v4.b;
					return $author$project$I18n$Cles$referentielTypesElargirLimiteCatalogue(i18n);
				}
			}
		};
		var duChamp = function (champ) {
			return A2($author$project$Components$Shared$Bibliotheque$Rattachement$champ, champ, choix);
		};
		var explication = function (champ) {
			var _v3 = duChamp(champ);
			if (!_v3.$) {
				var lu = _v3.a;
				return $author$project$Components$Shared$Bibliotheque$Elargissement$peutElargir(lu) ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('alerte'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('warn')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A3($author$project$Components$Shared$Bibliotheque$View$titreHorsPortee, i18n, contexte, lu))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$produitsTypesElargirHorsPorteeCorps,
											i18n,
											{
												nV: limite(lu),
												Dp: nomDuType
											}))
									])),
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id(
										A2($author$project$Components$Shared$Bibliotheque$View$idDeLElargissement, 'refus', lu.Aq)),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										A2(
											msgs.ya,
											lu.Aq,
											A2($author$project$Components$Shared$Bibliotheque$View$idDeLElargissement, 'refus', lu.Aq)))
									]),
								$author$project$I18n$Cles$produitsTypesElargirOuvrir(i18n))
							]))
					]) : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('verrou')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A3(
									$author$project$Components$Shared$Bibliotheque$View$sansDroit,
									i18n,
									contexte,
									limite(lu)))
							]))
					]);
			} else {
				return _List_Nil;
			}
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Shared$Bibliotheque$View$idDuRefusDeRattachement),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('refus'),
					$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
				]),
			function () {
				var _v0 = choix.pZ;
				if (_v0.$ === 1) {
					var _v1 = $author$project$Components$Shared$Bibliotheque$Rattachement$choisiHorsPortee(choix);
					if (!_v1.$) {
						var lu = _v1.a;
						return explication(lu.Aq);
					} else {
						return _List_Nil;
					}
				} else {
					switch (_v0.a.$) {
						case 1:
							var refuse = _v0.a.a;
							return _Utils_eq(
								duChamp(refuse.uN),
								$elm$core$Maybe$Nothing) ? _List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$produitsTypesAjoutRefusLimiteAUnType,
										i18n,
										{Dj: refuse.Dj})),
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href(contexte.sZ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsTypesAjoutRefusHorsPorteeIssue(i18n))
										]))
								]) : explication(refuse.uN);
						case 0:
							var refuse = _v0.a.a;
							return _Utils_eq(
								duChamp(refuse.uN),
								$elm$core$Maybe$Nothing) ? refusHorsPortee(refuse.F$) : explication(refuse.uN);
						default:
							var _v2 = _v0.a;
							return _List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsTypesAjoutRefusAutre(i18n))
								]);
					}
				}
			}());
	});
var $author$project$Components$Shared$Bibliotheque$View$rattachement = F4(
	function (i18n, contexte, msgs, entree) {
		var choix = entree.pN;
		var horsPortee = $author$project$Components$Shared$Bibliotheque$Rattachement$horsPortee(choix);
		var proposes = $author$project$Components$Shared$Bibliotheque$Rattachement$proposes(choix);
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Champ$View$texte,
				{
					go: $elm$core$Maybe$Nothing,
					Aq: $author$project$Components$Shared$Bibliotheque$View$idDeLaRechercheDeLaBibliotheque,
					Bl: $author$project$I18n$Cles$produitsTypesAjoutRecherche(i18n),
					he: false
				},
				{hg: msgs.hC, fm: choix.hC}),
				A2(
				$rtfeldman$elm_css$Html$Styled$ul,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('propositions-de-champs')
					]),
				$elm$core$List$isEmpty(proposes) ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsTypesAjoutAucun(i18n))
							]))
					]) : A2(
					$elm$core$List$map,
					function (lu) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A4($author$project$Components$Shared$Bibliotheque$View$proposition, i18n, msgs, choix, lu)
								]));
					},
					proposes)),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note'),
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('masques', horsPortee)
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$produitsTypesAjoutHorsPorteeAide,
							i18n,
							{Dp: contexte.Dp}))
					])),
				A4($author$project$Components$Shared$Bibliotheque$View$refusDuRattachement, i18n, contexte, msgs, choix),
				A4(
				$author$project$Components$Shared$Bibliotheque$View$reglagesDuRattachement,
				i18n,
				{Cd: horsPortee, pv: contexte.pv},
				{mo: msgs.mo, np: msgs.np, n4: msgs.n4, Ff: msgs.Ff},
				choix.qc)
			]);
	});
var $author$project$I18n$Cles$produitsTypesAjoutSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.ajout.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nomDuType',
					$author$project$I18n$Traductions$Chaine(p.Dp))
				]),
			'Type de produit « ' + (p.Dp + ' »'));
	});
var $author$project$I18n$Cles$referentielTypesAjoutSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.types.ajout.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nomDuType',
					$author$project$I18n$Traductions$Chaine(p.Dp))
				]),
			'Type de partie prenante « ' + (p.Dp + ' »'));
	});
var $author$project$Components$Shared$Bibliotheque$View$sousTitre = F2(
	function (i18n, contexte) {
		var _v0 = contexte.cC;
		if (!_v0) {
			return A2(
				$author$project$I18n$Cles$produitsTypesAjoutSousTitre,
				i18n,
				{Dp: contexte.Dp});
		} else {
			return A2(
				$author$project$I18n$Cles$referentielTypesAjoutSousTitre,
				i18n,
				{Dp: contexte.Dp});
		}
	});
var $author$project$Components$Shared$Bibliotheque$View$entrees = F4(
	function (i18n, contexte, msgs, entree) {
		return A2(
			$elm$core$List$cons,
			A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$Components$Shared$Bibliotheque$View$sousTitre, i18n, contexte))
					])),
			_Utils_ap(
				entree.hB ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsTypesAjoutMode(i18n))
									])),
								$author$project$Components$Shared$Segment$View$view(
								{
									vd: (entree.n9 === 1) ? 'rattacher' : 'creer',
									Bi: $author$project$I18n$Cles$produitsTypesAjoutMode(i18n),
									Dj: contexte.pv + '-mode',
									Ea: function (code) {
										return msgs.n9(
											(code === 'rattacher') ? 1 : 0);
									},
									o_: _List_fromArray(
										[
											{
											vx: 'creer',
											Bl: $author$project$I18n$Cles$produitsTypesAjoutCreer(i18n)
										},
											{
											vx: 'rattacher',
											Bl: $author$project$I18n$Cles$produitsTypesAjoutRattacher(i18n)
										}
										])
								})
							]))
					]) : _List_Nil,
				function () {
					var _v0 = entree.n9;
					if (!_v0) {
						return A4($author$project$Components$Shared$Bibliotheque$View$creation, i18n, contexte, msgs, entree);
					} else {
						return A4($author$project$Components$Shared$Bibliotheque$View$rattachement, i18n, contexte, msgs, entree);
					}
				}()));
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$Libelle = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$I18n$Cles$editeurDeSchemaChampCleDejaUtilisee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.champ.cle.deja-utilisee', _List_Nil, 'Cette clé existe déjà');
};
var $author$project$I18n$Cles$editeurDeSchemaChampLibelleObligatoire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.champ.libelle.obligatoire', _List_Nil, 'Le libellé est obligatoire.');
};
var $author$project$I18n$Cles$editeurDeSchemaChampNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.champ.nom', _List_Nil, 'Nom du champ');
};
var $author$project$I18n$Cles$editeurDeSchemaChampTypeDeChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.champ.type-de-champ', _List_Nil, 'Type de champ');
};
var $author$project$I18n$Cles$editeurDeSchemaReferentielsFournisTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.referentiels-fournis.texte', _List_Nil, 'pays ISO 3166-1, langues BCP 47 (langue seule, ex. fr). Ils ne se modifient pas ; un pays ou une langue ne s\'ajoute pas à la main.');
};
var $author$project$I18n$Cles$editeurDeSchemaReferentielsFournisTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.referentiels-fournis.titre', _List_Nil, 'Référentiels fournis par le système :');
};
var $author$project$Components$Shared$EditeurDeSchema$View$estNorme = function (saisie) {
	return _Utils_eq(saisie.zT.JR, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typePays) || _Utils_eq(saisie.zT.JR, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeLangue);
};
var $author$project$Components$Shared$EditeurDeSchema$View$encadreDesReferentiels = F2(
	function (i18n, saisie) {
		return $author$project$Components$Shared$EditeurDeSchema$View$estNorme(saisie) ? _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Note$View$view,
				0,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$editeurDeSchemaReferentielsFournisTitre(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$editeurDeSchemaReferentielsFournisTexte(i18n))
							]))
					]))
			]) : _List_Nil;
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$libelleExige = F2(
	function (langue, saisie) {
		return _Utils_eq(
			$elm$core$List$head(saisie.Ba),
			$elm$core$Maybe$Just(langue));
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$erreurDuLibelle = F2(
	function (langue, saisie) {
		return saisie.b5 && (A2($author$project$Components$Shared$EditeurDeSchema$Model$libelleExige, langue, saisie) && (A2($author$project$Components$Shared$EditeurDeSchema$Model$libelleDe, langue, saisie) === ''));
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$ModeleDeGroupe = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$View$modelesDeGroupe = F2(
	function (i18n, presentation) {
		return A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.vx;
				},
				$elm$core$Basics$eq($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeGroupe)),
			presentation.Gw.J_) ? A3($author$project$Components$Shared$EditeurDeSchema$View$choixDeModele, i18n, presentation.pv + '-modele', $author$project$Components$Shared$EditeurDeSchema$Model$ModeleDeGroupe) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$I18n$Cles$editeurDeSchemaReferentielNorme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.referentiel.norme', _List_Nil, 'Référentiel normé : la valeur gardée est le code (FR, en). Aucune valeur à saisir dans la définition.');
};
var $author$project$Components$Shared$EditeurDeSchema$View$noteDuReferentiel = F2(
	function (i18n, saisie) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$Components$Shared$EditeurDeSchema$View$estNorme(saisie) ? $author$project$I18n$Cles$editeurDeSchemaReferentielNorme(i18n) : '')
				]));
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$Option = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$OptionCochee = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$SousChamp = function (a) {
	return {$: 13, a: a};
};
var $author$project$I18n$Cles$editeurDeSchemaChampTypeChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.champ.type.choisir', _List_Nil, 'Choisir…');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionAffichageParLangue = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.option.affichage-par-langue',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'langue',
					$author$project$I18n$Traductions$Chaine(p.nn))
				]),
			'Unité affichée (' + (p.nn + ')'));
	});
var $author$project$I18n$Cles$editeurDeSchemaOptionAffichageParLangueAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.affichage-par-langue.aucune', _List_Nil, 'Unité de saisie');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionBornesDeDateMax = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.bornes-de-date.max', _List_Nil, 'Date au plus tard');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionBornesDeDateMin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.bornes-de-date.min', _List_Nil, 'Date au plus tôt');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionBornesMax = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.bornes.max', _List_Nil, 'Valeur maximale');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionBornesMin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.bornes.min', _List_Nil, 'Valeur minimale');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionBornesPlausiblesMax = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.bornes-plausibles.max', _List_Nil, 'Borne plausible maximale');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionBornesPlausiblesMin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.bornes-plausibles.min', _List_Nil, 'Borne plausible minimale');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionBornesPlausiblesResserree = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.bornes-plausibles.resserree', _List_Nil, 'Une borne enregistrée s\'élargit ou se retire, elle ne se resserre pas : des valeurs déjà saisies pourraient en sortir.');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionDecimales = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.decimales', _List_Nil, 'Décimales');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionFormule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.formule', _List_Nil, 'Formule');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionLibellesDesValeurs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.option.libelles-des-valeurs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm)),
					_Utils_Tuple2(
					'langue',
					$author$project$I18n$Traductions$Chaine(p.nn))
				]),
			'Libellé de « ' + (p.fm + (' » (' + (p.nn + ')'))));
	});
var $author$project$I18n$Cles$editeurDeSchemaOptionLongueur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.longueur', _List_Nil, 'Longueur maximale (caractères)');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionMotif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.motif', _List_Nil, 'Format (expression régulière)');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionMotifMessage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.motif.message', _List_Nil, 'Message si le format n\'est pas respecté');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionNombreDeChoixMax = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.nombre-de-choix.max', _List_Nil, 'Nombre maximal de choix');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionNombreDeChoixMin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.nombre-de-choix.min', _List_Nil, 'Nombre minimal de choix');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionTailleMaximale = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.taille-maximale', _List_Nil, 'Taille maximale (octets)');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionTraduisible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.traduisible', _List_Nil, 'Valeur traduite, une par langue');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionTypeDuResultat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.type-du-resultat', _List_Nil, 'Type du résultat');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionTypeVise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.type-vise', _List_Nil, 'Type de partie prenante visé');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionTypeViseNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.type-vise.note', _List_Nil, 'Obligatoire. Seules les fiches de ce type seront proposées. Figé après la création du champ.');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionTypesDeMedia = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.types-de-media', _List_Nil, 'Types de média admis (séparés par des virgules)');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionUnique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.unique', _List_Nil, 'Valeur unique');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionUnite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.unite', _List_Nil, 'Unité de saisie');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionValeurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.valeurs', _List_Nil, 'Valeurs (une par ligne)');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionValeursRetiree = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.valeurs.retiree', _List_Nil, 'Une valeur enregistrée ne se retire pas et ne se renomme pas : des fiches peuvent déjà la porter. Vous pouvez en ajouter.');
};
var $author$project$Components$Shared$EditeurDeSchema$Model$erreurDeLaBorne = F2(
	function (cote, saisie) {
		return saisie.b5 && ($author$project$Components$Shared$EditeurDeSchema$Model$resserrageRefuse(saisie) && A2($author$project$Components$Shared$EditeurDeSchema$Model$borneResserree, cote, saisie));
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$erreurDesValeurs = function (saisie) {
	return saisie.b5 && ($author$project$Components$Shared$EditeurDeSchema$Model$resserrageRefuse(saisie) && $author$project$Components$Shared$EditeurDeSchema$Model$valeursRetirees(saisie));
};
var $author$project$Components$Shared$EditeurDeSchema$Model$figee = function (saisie) {
	return (saisie.F$ === 2) && $author$project$Components$Shared$EditeurDeSchema$Model$resserrageRefuse(saisie);
};
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionSousChamps = 'sous-champs';
var $author$project$I18n$Cles$editeurDeSchemaOptionPlusieursChoixNoteLangue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.plusieurs-choix.note-langue', _List_Nil, 'Plusieurs langues, sans doublon.');
};
var $author$project$I18n$Cles$editeurDeSchemaOptionPlusieursChoixNotePays = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.option.plusieurs-choix.note-pays', _List_Nil, 'Plusieurs pays, sans doublon.');
};
var $author$project$Components$Shared$EditeurDeSchema$View$aideDuNombreDeChoix = F2(
	function (i18n, saisie) {
		return _Utils_eq(saisie.zT.JR, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeLangue) ? $author$project$I18n$Cles$editeurDeSchemaOptionPlusieursChoixNoteLangue(i18n) : $author$project$I18n$Cles$editeurDeSchemaOptionPlusieursChoixNotePays(i18n);
	});
var $author$project$Components$Shared$EditeurDeSchema$View$plusieursChoix = F3(
	function (i18n, presentation, saisie) {
		var nom = presentation.pv + ('-' + $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionPlusieursChoix);
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$editeurDeSchemaOptionPlusieursChoix(i18n))
							])),
						$author$project$Components$Shared$Segment$View$view(
						{
							vd: _Utils_eq(
								A2($author$project$Components$Shared$EditeurDeSchema$Model$option, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionPlusieursChoix, saisie.zT),
								$author$project$Components$Shared$EditeurDeSchema$Model$oui) ? $author$project$Components$Shared$EditeurDeSchema$Model$oui : 'non',
							Bi: $author$project$I18n$Cles$editeurDeSchemaOptionPlusieursChoix(i18n),
							Dj: nom,
							Ea: $author$project$Components$Shared$EditeurDeSchema$Model$Option($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionPlusieursChoix),
							o_: _List_fromArray(
								[
									{
									vx: $author$project$Components$Shared$EditeurDeSchema$Model$oui,
									Bl: $author$project$I18n$Cles$editeurDeSchemaOptionPlusieursChoixOui(i18n)
								},
									{
									vx: 'non',
									Bl: $author$project$I18n$Cles$editeurDeSchemaOptionPlusieursChoixNon(i18n)
								}
								])
						})
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$Components$Shared$EditeurDeSchema$View$aideDuNombreDeChoix, i18n, saisie))
					]))
			]);
	});
var $author$project$I18n$Cles$editeurDeSchemaGroupeRepetable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.groupe.repetable', _List_Nil, 'Répétable');
};
var $author$project$I18n$Cles$editeurDeSchemaGroupeRepetableNote = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.groupe.repetable.note',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Une fiche peut porter plusieurs ' + (p.Dj + '.'));
	});
var $author$project$Components$Shared$EditeurDeSchema$View$repetable = F3(
	function (i18n, presentation, saisie) {
		var saisi = saisie.zT;
		var prefixe = presentation.pv;
		var segment = F4(
			function (suffixe, libelle, options, choisi) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(libelle)
								])),
							$author$project$Components$Shared$Segment$View$view(
							{
								vd: choisi,
								Bi: libelle,
								Dj: prefixe + ('-' + suffixe),
								Ea: $author$project$Components$Shared$EditeurDeSchema$Model$Option(suffixe),
								o_: options
							})
						]));
			});
		var nom = function () {
			var _v0 = $elm$core$String$trim(
				A2(
					$author$project$Components$Shared$EditeurDeSchema$Model$libelleSaisi,
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(saisie.Ba)),
					saisi));
			if (_v0 === '') {
				return 'occurrences';
			} else {
				var saisi_ = _v0;
				return $elm$core$String$toLower(saisi_);
			}
		}();
		return _List_fromArray(
			[
				A4(
				segment,
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionRepetable,
				$author$project$I18n$Cles$editeurDeSchemaGroupeRepetable(i18n),
				_List_fromArray(
					[
						{
						vx: 'oui',
						Bl: $author$project$I18n$Cles$editeurDeSchemaGroupeRepetableOui(i18n)
					},
						{
						vx: $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$nonRepetable,
						Bl: $author$project$I18n$Cles$editeurDeSchemaGroupeRepetableNon(i18n)
					}
					]),
				_Utils_eq(
					A2($author$project$Components$Shared$EditeurDeSchema$Model$option, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionRepetable, saisi),
					$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$nonRepetable) ? $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$nonRepetable : 'oui'),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$editeurDeSchemaGroupeRepetableNote,
							i18n,
							{Dj: nom}))
					])),
				A2(
				$author$project$Components$Shared$Champ$View$texte,
				{
					go: $elm$core$Maybe$Nothing,
					Aq: prefixe + ('-' + $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionLibelleOccurrence),
					Bl: $author$project$I18n$Cles$editeurDeSchemaGroupeOccurrence(i18n),
					he: false
				},
				{
					hg: $author$project$Components$Shared$EditeurDeSchema$Model$Option($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionLibelleOccurrence),
					fm: A2($author$project$Components$Shared$EditeurDeSchema$Model$option, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionLibelleOccurrence, saisi)
				}),
				A4(
				segment,
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionGenreOccurrence,
				$author$project$I18n$Cles$editeurDeSchemaGroupeGenre(i18n),
				_List_fromArray(
					[
						{
						vx: $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$genreFeminin,
						Bl: $author$project$I18n$Cles$editeurDeSchemaGroupeGenreFeminin(i18n)
					},
						{
						vx: $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$genreMasculin,
						Bl: $author$project$I18n$Cles$editeurDeSchemaGroupeGenreMasculin(i18n)
					}
					]),
				_Utils_eq(
					A2($author$project$Components$Shared$EditeurDeSchema$Model$option, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionGenreOccurrence, saisi),
					$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$genreFeminin) ? $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$genreFeminin : $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$genreMasculin)
			]);
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$typesDuResultat = A2($elm$core$List$map, $elm$core$Tuple$first, $author$project$Components$Shared$EditeurDeSchema$Model$typesSimples);
var $author$project$Components$Shared$EditeurDeSchema$Propositions$unitesDeMemeGrandeur = F2(
	function (unites, code) {
		var _v0 = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.vx;
					},
					$elm$core$Basics$eq(code)),
				unites));
		if (!_v0.$) {
			var unite = _v0.a;
			return A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.m0;
					},
					$elm$core$Basics$eq(unite.m0)),
				unites);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$View$optionDuType = F4(
	function (i18n, presentation, saisie, code) {
		var unites = presentation.Gw.sb;
		var saisi = saisie.zT;
		var retenue = function (suffixe) {
			return (_Utils_eq(suffixe, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionValeurs) && $author$project$Components$Shared$EditeurDeSchema$Model$erreurDesValeurs(saisie)) ? $elm$core$Maybe$Just(
				$author$project$I18n$Cles$editeurDeSchemaOptionValeursRetiree(i18n)) : (A2(
				$elm$core$List$any,
				function (cote) {
					return _Utils_eq(
						suffixe,
						A2($author$project$Components$Shared$EditeurDeSchema$Model$sousOption, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionBornesPlausibles, cote)) && A2($author$project$Components$Shared$EditeurDeSchema$Model$erreurDeLaBorne, cote, saisie);
				},
				_List_fromArray(
					['min', 'max'])) ? $elm$core$Maybe$Just(
				$author$project$I18n$Cles$editeurDeSchemaOptionBornesPlausiblesResserree(i18n)) : $elm$core$Maybe$Nothing);
		};
		var figee = $author$project$Components$Shared$EditeurDeSchema$Model$figee(saisie);
		var enregistre = !_Utils_eq(saisie.lZ, $elm$core$Maybe$Nothing);
		var deuxBornes = F3(
			function (controle, libelleMin, libelleMax) {
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('bornes')
							]),
						_List_fromArray(
							[
								A2(
								controle,
								A2($author$project$Components$Shared$EditeurDeSchema$Model$sousOption, code, 'min'),
								libelleMin),
								A2(
								controle,
								A2($author$project$Components$Shared$EditeurDeSchema$Model$sousOption, code, 'max'),
								libelleMax)
							]))
					]);
			});
		var choisie = A2($author$project$Components$Shared$EditeurDeSchema$Model$option, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionUnite, saisi);
		var champ = F2(
			function (suffixe, libelle) {
				return {
					go: retenue(suffixe),
					Aq: presentation.pv + ('-' + suffixe),
					Bl: libelle,
					he: false
				};
			});
		var fige = F3(
			function (suffixe, libelle, controle) {
				return A2(
					$author$project$Components$Shared$Champ$View$compose,
					A2(champ, suffixe, libelle),
					_List_fromArray(
						[
							controle(
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true),
								$author$project$Components$Shared$Champ$View$attributs(
									A2(champ, suffixe, libelle))))
						]));
			});
		var saisieFigee = F3(
			function (sous, libelle, typeDeControle) {
				return A3(
					fige,
					sous,
					libelle,
					function (attributs) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$input,
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_css$Html$Styled$Attributes$type_(typeDeControle),
								A2(
									$elm$core$List$cons,
									$rtfeldman$elm_css$Html$Styled$Attributes$value(
										A2($author$project$Components$Shared$EditeurDeSchema$Model$option, sous, saisi)),
									attributs)),
							_List_Nil);
					});
			});
		var unTexte = F2(
			function (sous, libelle) {
				return figee ? A3(saisieFigee, sous, libelle, 'text') : A2(
					$author$project$Components$Shared$Champ$View$texte,
					A2(champ, sous, libelle),
					{
						hg: $author$project$Components$Shared$EditeurDeSchema$Model$Option(sous),
						fm: A2($author$project$Components$Shared$EditeurDeSchema$Model$option, sous, saisi)
					});
			});
		var uneCase = function (libelle) {
			return A2(
				$author$project$Components$Shared$Champ$View$caseACocher,
				A2(champ, code, libelle),
				{
					vt: A2($author$project$Components$Shared$EditeurDeSchema$Model$coche, code, saisi),
					D9: $author$project$Components$Shared$EditeurDeSchema$Model$OptionCochee(code)
				});
		};
		var uneDate = F2(
			function (sous, libelle) {
				return figee ? A3(saisieFigee, sous, libelle, 'date') : A2(
					$author$project$Components$Shared$Champ$View$date,
					A2(champ, sous, libelle),
					{
						hg: $author$project$Components$Shared$EditeurDeSchema$Model$Option(sous),
						fm: A2($author$project$Components$Shared$EditeurDeSchema$Model$option, sous, saisi)
					});
			});
		var autresLangues = A2($elm$core$List$drop, 1, saisie.Ba);
		return _Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionLongueur) ? _List_fromArray(
			[
				A2(
				unTexte,
				code,
				$author$project$I18n$Cles$editeurDeSchemaOptionLongueur(i18n))
			]) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionMotif) ? _List_fromArray(
			[
				A2(
				unTexte,
				code,
				$author$project$I18n$Cles$editeurDeSchemaOptionMotif(i18n)),
				A2(
				unTexte,
				A2($author$project$Components$Shared$EditeurDeSchema$Model$sousOption, code, 'message'),
				$author$project$I18n$Cles$editeurDeSchemaOptionMotifMessage(i18n))
			]) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionTraduisible) ? _List_fromArray(
			[
				uneCase(
				$author$project$I18n$Cles$editeurDeSchemaOptionTraduisible(i18n))
			]) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionUnique) ? _List_fromArray(
			[
				uneCase(
				$author$project$I18n$Cles$editeurDeSchemaOptionUnique(i18n))
			]) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionBornes) ? A3(
			deuxBornes,
			unTexte,
			$author$project$I18n$Cles$editeurDeSchemaOptionBornesMin(i18n),
			$author$project$I18n$Cles$editeurDeSchemaOptionBornesMax(i18n)) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionBornesDeDate) ? A3(
			deuxBornes,
			uneDate,
			$author$project$I18n$Cles$editeurDeSchemaOptionBornesDeDateMin(i18n),
			$author$project$I18n$Cles$editeurDeSchemaOptionBornesDeDateMax(i18n)) : ((_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionTypeVise) && enregistre) ? _List_fromArray(
			[
				A3(
				fige,
				code,
				$author$project$I18n$Cles$editeurDeSchemaOptionTypeVise(i18n),
				function (attributs) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$select,
						attributs,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$option,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$selected(true)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.Dj;
												},
												$elm$core$List$head(
													A2(
														$elm$core$List$filter,
														A2(
															$elm$core$Basics$composeR,
															function ($) {
																return $.Aq;
															},
															$elm$core$Basics$eq(
																A2($author$project$Components$Shared$EditeurDeSchema$Model$option, code, saisi))),
														presentation.ib)))))
									]))
							]));
				})
			]) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionTypeVise) ? _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Champ$View$liste,
				A2(
					champ,
					code,
					$author$project$I18n$Cles$editeurDeSchemaOptionTypeVise(i18n)),
				{
					hg: $author$project$Components$Shared$EditeurDeSchema$Model$Option(code),
					o_: A2(
						$elm$core$List$cons,
						{
							Bl: $author$project$I18n$Cles$editeurDeSchemaChampTypeChoisir(i18n),
							fm: ''
						},
						A2(
							$elm$core$List$map,
							function (type_) {
								return {Bl: type_.Dj, fm: type_.Aq};
							},
							presentation.ib)),
					fm: A2($author$project$Components$Shared$EditeurDeSchema$Model$option, code, saisi)
				}),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$editeurDeSchemaOptionTypeViseNote(i18n))
					]))
			]) : ((_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionUnite) && enregistre) ? _List_fromArray(
			[
				A3(
				fige,
				code,
				$author$project$I18n$Cles$editeurDeSchemaOptionUnite(i18n),
				function (attributs) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$select,
						attributs,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$option,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$selected(true)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$Components$Shared$EditeurDeSchema$Propositions$symbole, unites, choisie))
									]))
							]));
				})
			]) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionUnite) ? _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Champ$View$liste,
				A2(
					champ,
					code,
					$author$project$I18n$Cles$editeurDeSchemaOptionUnite(i18n)),
				{
					hg: $author$project$Components$Shared$EditeurDeSchema$Model$Option(code),
					o_: A2(
						$elm$core$List$cons,
						{
							Bl: $author$project$I18n$Cles$editeurDeSchemaChampTypeChoisir(i18n),
							fm: ''
						},
						A2(
							$elm$core$List$map,
							function (unite) {
								return {Bl: unite.Jh, fm: unite.vx};
							},
							unites)),
					fm: choisie
				})
			]) : ((_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionDecimales) && enregistre) ? _List_fromArray(
			[
				A3(
				fige,
				code,
				$author$project$I18n$Cles$editeurDeSchemaOptionDecimales(i18n),
				function (attributs) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$input,
						A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_css$Html$Styled$Attributes$value(
									A2($author$project$Components$Shared$EditeurDeSchema$Model$option, code, saisi)),
								attributs)),
						_List_Nil);
				})
			]) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionDecimales) ? _List_fromArray(
			[
				A2(
				unTexte,
				code,
				$author$project$I18n$Cles$editeurDeSchemaOptionDecimales(i18n))
			]) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionBornesPlausibles) ? A3(
			deuxBornes,
			unTexte,
			$author$project$I18n$Cles$editeurDeSchemaOptionBornesPlausiblesMin(i18n),
			$author$project$I18n$Cles$editeurDeSchemaOptionBornesPlausiblesMax(i18n)) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionAffichageParLangue) ? A2(
			$elm$core$List$map,
			function (langue) {
				var sous = A2($author$project$Components$Shared$EditeurDeSchema$Model$sousOption, code, langue);
				return A2(
					$author$project$Components$Shared$Champ$View$liste,
					A2(
						champ,
						sous,
						A2(
							$author$project$I18n$Cles$editeurDeSchemaOptionAffichageParLangue,
							i18n,
							{
								nn: A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$langue, i18n, langue)
							})),
					{
						hg: $author$project$Components$Shared$EditeurDeSchema$Model$Option(sous),
						o_: A2(
							$elm$core$List$cons,
							{
								Bl: $author$project$I18n$Cles$editeurDeSchemaOptionAffichageParLangueAucune(i18n),
								fm: ''
							},
							A2(
								$elm$core$List$map,
								function (unite) {
									return {Bl: unite.Jh, fm: unite.vx};
								},
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.vx;
										},
										$elm$core$Basics$neq(choisie)),
									A2($author$project$Components$Shared$EditeurDeSchema$Propositions$unitesDeMemeGrandeur, unites, choisie)))),
						fm: A2($author$project$Components$Shared$EditeurDeSchema$Model$option, sous, saisi)
					});
			},
			autresLangues) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionValeurs) ? _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Champ$View$zoneDeTexte,
				A2(
					champ,
					code,
					$author$project$I18n$Cles$editeurDeSchemaOptionValeurs(i18n)),
				{
					hg: $author$project$Components$Shared$EditeurDeSchema$Model$Option(code),
					fm: A2($author$project$Components$Shared$EditeurDeSchema$Model$option, code, saisi)
				})
			]) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionLibellesDesValeurs) ? A2(
			$elm$core$List$concatMap,
			function (langue) {
				return A2(
					$elm$core$List$indexedMap,
					F2(
						function (rang, valeur) {
							var sous = A2($author$project$Components$Shared$EditeurDeSchema$Model$sousOption, code, langue + ('.' + valeur));
							return A2(
								$author$project$Components$Shared$Champ$View$texte,
								{
									go: $elm$core$Maybe$Nothing,
									Aq: presentation.pv + ('-' + (code + ('-' + (langue + ('-' + $elm$core$String$fromInt(rang)))))),
									Bl: A2(
										$author$project$I18n$Cles$editeurDeSchemaOptionLibellesDesValeurs,
										i18n,
										{
											nn: $elm$core$String$toLower(
												A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$langue, i18n, langue)),
											fm: valeur
										}),
									he: false
								},
								{
									hg: $author$project$Components$Shared$EditeurDeSchema$Model$Option(sous),
									fm: A2($author$project$Components$Shared$EditeurDeSchema$Model$option, sous, saisi)
								});
						}),
					$author$project$Components$Shared$EditeurDeSchema$Model$valeursDeLaListe(saisi));
			},
			A2(
				$elm$core$List$drop,
				1,
				$author$project$Components$Shared$EditeurDeSchema$Model$languesDesLibelles(saisie.Ba))) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionNombreDeChoix) ? A3(
			deuxBornes,
			unTexte,
			$author$project$I18n$Cles$editeurDeSchemaOptionNombreDeChoixMin(i18n),
			$author$project$I18n$Cles$editeurDeSchemaOptionNombreDeChoixMax(i18n)) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionTypesDeMedia) ? _List_fromArray(
			[
				A2(
				unTexte,
				code,
				$author$project$I18n$Cles$editeurDeSchemaOptionTypesDeMedia(i18n))
			]) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionTailleMaximale) ? _List_fromArray(
			[
				A2(
				unTexte,
				code,
				$author$project$I18n$Cles$editeurDeSchemaOptionTailleMaximale(i18n))
			]) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionFormule) ? _List_fromArray(
			[
				A2(
				unTexte,
				code,
				$author$project$I18n$Cles$editeurDeSchemaOptionFormule(i18n))
			]) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionRepetable) ? A3($author$project$Components$Shared$EditeurDeSchema$View$repetable, i18n, presentation, saisie) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionPlusieursChoix) ? A3($author$project$Components$Shared$EditeurDeSchema$View$plusieursChoix, i18n, presentation, saisie) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionSousChamps) ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$map,
				$author$project$Components$Shared$EditeurDeSchema$Model$SousChamp,
				A3(
					$author$project$Components$Shared$EditeurDeSchema$SousChamps$view,
					i18n,
					{
						n_: presentation.n_,
						pv: presentation.pv,
						HI: !_Utils_eq(
							A2($author$project$Components$Shared$EditeurDeSchema$Model$option, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionRepetable, saisi),
							$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$nonRepetable),
						ib: presentation.ib
					},
					saisi.IX))
			]) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionTypeDuResultat) ? _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Champ$View$liste,
				A2(
					champ,
					code,
					$author$project$I18n$Cles$editeurDeSchemaOptionTypeDuResultat(i18n)),
				{
					hg: $author$project$Components$Shared$EditeurDeSchema$Model$Option(code),
					o_: A2(
						$elm$core$List$map,
						function (simple) {
							return {
								Bl: A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeDeChamp, i18n, simple),
								fm: simple
							};
						},
						$author$project$Components$Shared$EditeurDeSchema$Model$typesDuResultat),
					fm: A2($author$project$Components$Shared$EditeurDeSchema$Model$option, code, saisi)
				})
			]) : _List_Nil)))))))))))))))))))))));
	});
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$conservationDuType = 'du-type';
var $author$project$I18n$Cles$editeurDeSchemaConservationDuType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.conservation.du-type', _List_Nil, 'Conservation : celle du type.');
};
var $author$project$Components$Shared$EditeurDeSchema$View$optionPropre = F4(
	function (i18n, presentation, saisie, propre) {
		var personnelle = _Utils_eq(propre.vx, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionDonneePersonnelle);
		var duType = _Utils_eq(
			presentation.Gw.v7,
			_List_fromArray(
				[$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$conservationDuType]));
		var cochee = A2($author$project$Components$Shared$EditeurDeSchema$Model$coche, propre.vx, saisie.zT);
		var champ = {go: $elm$core$Maybe$Nothing, Aq: presentation.pv + ('-' + propre.vx), Bl: propre.Bl, he: false};
		return propre.vs ? A2(
			$elm$core$List$cons,
			A2(
				$author$project$Components$Shared$Champ$View$caseACocherInactivable,
				champ,
				{
					vt: cochee,
					d4: personnelle && (!$author$project$Components$Shared$EditeurDeSchema$Model$donneePersonnelleCochable(saisie)),
					D9: $author$project$Components$Shared$EditeurDeSchema$Model$OptionCochee(propre.vx)
				}),
			(personnelle && (cochee && duType)) ? _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('conservation')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$editeurDeSchemaConservationDuType(i18n))
						]))
				]) : _List_Nil) : _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Champ$View$texte,
				champ,
				{
					hg: $author$project$Components$Shared$EditeurDeSchema$Model$Option(propre.vx),
					fm: A2($author$project$Components$Shared$EditeurDeSchema$Model$option, propre.vx, saisie.zT)
				})
			]);
	});
var $author$project$I18n$Cles$editeurDeSchemaDefautBornesPlausiblesIncoherentes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.bornes-plausibles-incoherentes', _List_Nil, 'les bornes plausibles sont incohérentes');
};
var $author$project$I18n$Cles$editeurDeSchemaDefautCleEnDouble = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.cle-en-double', _List_Nil, 'cette clé revient deux fois');
};
var $author$project$I18n$Cles$editeurDeSchemaDefautCleMalFormee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.cle-mal-formee', _List_Nil, 'la clé est mal formée');
};
var $author$project$I18n$Cles$editeurDeSchemaDefautCleReservee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.cle-reservee', _List_Nil, 'cette clé est réservée');
};
var $author$project$I18n$Cles$editeurDeSchemaDefautConditionSurChampInconnu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.condition-sur-champ-inconnu', _List_Nil, 'la condition d\'affichage vise un champ inconnu');
};
var $author$project$I18n$Cles$editeurDeSchemaDefautConservationRefusee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.conservation-refusee', _List_Nil, 'un champ de cette ressource ne porte pas de durée de conservation');
};
var $author$project$I18n$Cles$editeurDeSchemaDefautCycleDeFormules = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.cycle-de-formules', _List_Nil, 'les formules forment une boucle');
};
var $author$project$I18n$Cles$editeurDeSchemaDefautCycleDeVisibilite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.cycle-de-visibilite', _List_Nil, 'les conditions d\'affichage forment une boucle');
};
var $author$project$I18n$Cles$editeurDeSchemaDefautDecimalesHorsBornes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.decimales-hors-bornes', _List_Nil, 'le nombre de décimales n\'est pas admis');
};
var $author$project$I18n$Cles$editeurDeSchemaDefautDonneePersonnelleRefusee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.donnee-personnelle-refusee', _List_Nil, 'un champ de cette ressource ne peut pas être une donnée personnelle');
};
var $author$project$I18n$Cles$editeurDeSchemaDefautExigenceALaPublicationRefusee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.exigence-a-la-publication-refusee', _List_Nil, 'un champ de cette ressource ne peut pas être exigé à la publication');
};
var $author$project$I18n$Cles$editeurDeSchemaDefautExigenceSurChampCalcule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.exigence-sur-champ-calcule', _List_Nil, 'un champ calculé ne peut pas être exigé');
};
var $author$project$I18n$Cles$editeurDeSchemaDefautFormuleInvalide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.formule-invalide', _List_Nil, 'la formule est invalide');
};
var $author$project$I18n$Cles$editeurDeSchemaDefautLangueNonAdmise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.langue-non-admise', _List_Nil, 'une langue n\'est pas admise');
};
var $author$project$I18n$Cles$editeurDeSchemaDefautLibelleAbsent = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.libelle-absent', _List_Nil, 'le libellé manque');
};
var $author$project$I18n$Cles$editeurDeSchemaDefautListeSansValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.liste-sans-valeur', _List_Nil, 'la liste n\'a aucune valeur');
};
var $author$project$I18n$Cles$editeurDeSchemaDefautMotifNonAdmis = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.motif-non-admis', _List_Nil, 'le format n\'est pas admis');
};
var $author$project$I18n$Cles$editeurDeSchemaDefautMotifTropLong = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.motif-trop-long', _List_Nil, 'le format est trop long');
};
var $author$project$I18n$Cles$editeurDeSchemaDefautRegleIncoherente = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.regle-incoherente', _List_Nil, 'une règle est incohérente');
};
var $author$project$I18n$Cles$editeurDeSchemaDefautRegleSansObjet = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.regle-sans-objet', _List_Nil, 'une règle ne s\'applique pas à ce type');
};
var $author$project$I18n$Cles$editeurDeSchemaDefautTexteTropLong = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.texte-trop-long', _List_Nil, 'un texte est trop long');
};
var $author$project$I18n$Cles$editeurDeSchemaDefautTraduisibleUnique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.traduisible-unique', _List_Nil, 'une valeur traduite ne peut pas être unique');
};
var $author$project$I18n$Cles$editeurDeSchemaDefautTropDeChamps = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.trop-de-champs', _List_Nil, 'le nombre maximal de champs est atteint');
};
var $author$project$I18n$Cles$editeurDeSchemaDefautTropDeValeurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.trop-de-valeurs', _List_Nil, 'la liste a trop de valeurs');
};
var $author$project$I18n$Cles$editeurDeSchemaDefautTropDeValeursDansLeSchema = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.trop-de-valeurs-dans-le-schema', _List_Nil, 'les listes du schéma portent ensemble trop de valeurs');
};
var $author$project$I18n$Cles$editeurDeSchemaDefautTypeNonPropose = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.type-non-propose', _List_Nil, 'ce type de champ n\'est pas proposé');
};
var $author$project$I18n$Cles$editeurDeSchemaDefautUniteDAffichageDUneAutreGrandeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.unite-d-affichage-d-une-autre-grandeur', _List_Nil, 'l\'unité affichée ne mesure pas la même chose que l\'unité de saisie');
};
var $author$project$I18n$Cles$editeurDeSchemaDefautValeursEnDouble = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.defaut.valeurs-en-double', _List_Nil, 'une valeur de la liste revient deux fois');
};
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$defauts = function (i18n) {
	return $elm$core$Dict$fromList(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'CleMalFormee',
				$author$project$I18n$Cles$editeurDeSchemaDefautCleMalFormee(i18n)),
				_Utils_Tuple2(
				'CleReservee',
				$author$project$I18n$Cles$editeurDeSchemaDefautCleReservee(i18n)),
				_Utils_Tuple2(
				'CleEnDouble',
				$author$project$I18n$Cles$editeurDeSchemaDefautCleEnDouble(i18n)),
				_Utils_Tuple2(
				'LibelleAbsent',
				$author$project$I18n$Cles$editeurDeSchemaDefautLibelleAbsent(i18n)),
				_Utils_Tuple2(
				'TypeNonPropose',
				$author$project$I18n$Cles$editeurDeSchemaDefautTypeNonPropose(i18n)),
				_Utils_Tuple2(
				'ListeSansValeur',
				$author$project$I18n$Cles$editeurDeSchemaDefautListeSansValeur(i18n)),
				_Utils_Tuple2(
				'ValeursEnDouble',
				$author$project$I18n$Cles$editeurDeSchemaDefautValeursEnDouble(i18n)),
				_Utils_Tuple2(
				'DonneePersonnelleRefusee',
				$author$project$I18n$Cles$editeurDeSchemaDefautDonneePersonnelleRefusee(i18n)),
				_Utils_Tuple2(
				'ConservationRefusee',
				$author$project$I18n$Cles$editeurDeSchemaDefautConservationRefusee(i18n)),
				_Utils_Tuple2(
				'ExigenceALaPublicationRefusee',
				$author$project$I18n$Cles$editeurDeSchemaDefautExigenceALaPublicationRefusee(i18n)),
				_Utils_Tuple2(
				'TropDeChamps',
				$author$project$I18n$Cles$editeurDeSchemaDefautTropDeChamps(i18n)),
				_Utils_Tuple2(
				'TropDeValeurs',
				$author$project$I18n$Cles$editeurDeSchemaDefautTropDeValeurs(i18n)),
				_Utils_Tuple2(
				'TropDeValeursDansLeSchema',
				$author$project$I18n$Cles$editeurDeSchemaDefautTropDeValeursDansLeSchema(i18n)),
				_Utils_Tuple2(
				'TexteTropLong',
				$author$project$I18n$Cles$editeurDeSchemaDefautTexteTropLong(i18n)),
				_Utils_Tuple2(
				'MotifTropLong',
				$author$project$I18n$Cles$editeurDeSchemaDefautMotifTropLong(i18n)),
				_Utils_Tuple2(
				'MotifNonAdmis',
				$author$project$I18n$Cles$editeurDeSchemaDefautMotifNonAdmis(i18n)),
				_Utils_Tuple2(
				'RegleSansObjet',
				$author$project$I18n$Cles$editeurDeSchemaDefautRegleSansObjet(i18n)),
				_Utils_Tuple2(
				'RegleIncoherente',
				$author$project$I18n$Cles$editeurDeSchemaDefautRegleIncoherente(i18n)),
				_Utils_Tuple2(
				'LangueNonAdmise',
				$author$project$I18n$Cles$editeurDeSchemaDefautLangueNonAdmise(i18n)),
				_Utils_Tuple2(
				'ConditionSurChampInconnu',
				$author$project$I18n$Cles$editeurDeSchemaDefautConditionSurChampInconnu(i18n)),
				_Utils_Tuple2(
				'CycleDeVisibilite',
				$author$project$I18n$Cles$editeurDeSchemaDefautCycleDeVisibilite(i18n)),
				_Utils_Tuple2(
				'FormuleInvalide',
				$author$project$I18n$Cles$editeurDeSchemaDefautFormuleInvalide(i18n)),
				_Utils_Tuple2(
				'CycleDeFormules',
				$author$project$I18n$Cles$editeurDeSchemaDefautCycleDeFormules(i18n)),
				_Utils_Tuple2(
				'UniteDAffichageDUneAutreGrandeur',
				$author$project$I18n$Cles$editeurDeSchemaDefautUniteDAffichageDUneAutreGrandeur(i18n)),
				_Utils_Tuple2(
				'DecimalesHorsBornes',
				$author$project$I18n$Cles$editeurDeSchemaDefautDecimalesHorsBornes(i18n)),
				_Utils_Tuple2(
				'BornesPlausiblesIncoherentes',
				$author$project$I18n$Cles$editeurDeSchemaDefautBornesPlausiblesIncoherentes(i18n)),
				_Utils_Tuple2(
				'TraduisibleUnique',
				$author$project$I18n$Cles$editeurDeSchemaDefautTraduisibleUnique(i18n)),
				_Utils_Tuple2(
				'ExigenceSurChampCalcule',
				$author$project$I18n$Cles$editeurDeSchemaDefautExigenceSurChampCalcule(i18n))
			]));
};
var $author$project$I18n$Cles$editeurDeSchemaDefautAutre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.defaut.autre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'code',
					$author$project$I18n$Traductions$Chaine(p.vx))
				]),
			'le schéma n\'est pas admis (code ' + (p.vx + ')'));
	});
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$defaut = F2(
	function (i18n, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2(
				$author$project$I18n$Cles$editeurDeSchemaDefautAutre,
				i18n,
				{vx: code}),
			A2(
				$elm$core$Dict$get,
				code,
				$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$defauts(i18n)));
	});
var $author$project$I18n$Cles$editeurDeSchemaErreurDefautDuChamp = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.erreur.defaut-du-champ',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN)),
					_Utils_Tuple2(
					'defaut',
					$author$project$I18n$Traductions$Chaine(p.f5))
				]),
			'« ' + (p.uN + (' » : ' + p.f5)));
	});
var $author$project$I18n$Cles$editeurDeSchemaErreurSchemaInvalide = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.erreur.schema-invalide',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'defauts',
					$author$project$I18n$Traductions$Chaine(p.wX))
				]),
			'Le schéma est refusé : ' + (p.wX + '.'));
	});
var $author$project$I18n$Cles$editeurDeSchemaErreurSeparateur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.erreur.separateur', _List_Nil, ' ; ');
};
var $author$project$Components$Shared$EditeurDeSchema$View$refus = F3(
	function (i18n, prefixe, saisie) {
		var dire = function (texte) {
			return _List_fromArray(
				[
					{
					Jx: $author$project$I18n$Traductions$tel(texte),
					b9: $elm$core$Maybe$Nothing
				}
				]);
		};
		return A3(
			$author$project$Components$Shared$Messages$View$vueAvecFoyer,
			i18n,
			$author$project$Components$Shared$EditeurDeSchema$View$idDuRefus(prefixe),
			function () {
				var _v0 = saisie.pZ;
				if (!_v0.$) {
					switch (_v0.a.$) {
						case 1:
							var raison = _v0.a.a;
							return _List_fromArray(
								[
									{
									Jx: $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$raisonNonAdditive(raison),
									b9: $elm$core$Maybe$Nothing
								}
								]);
						case 2:
							var defauts = _v0.a.a;
							return dire(
								A2(
									$author$project$I18n$Cles$editeurDeSchemaErreurSchemaInvalide,
									i18n,
									{
										wX: A2(
											$elm$core$String$join,
											$author$project$I18n$Cles$editeurDeSchemaErreurSeparateur(i18n),
											A2(
												$elm$core$List$map,
												function (defaut) {
													return (defaut.uN === '') ? A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$defaut, i18n, defaut.vx) : A2(
														$author$project$I18n$Cles$editeurDeSchemaErreurDefautDuChamp,
														i18n,
														{
															uN: defaut.uN,
															f5: A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$defaut, i18n, defaut.vx)
														});
												},
												defauts))
									}));
						case 3:
							var message = _v0.a.a;
							return _List_fromArray(
								[message]);
						default:
							var _v1 = _v0.a;
							return _List_Nil;
					}
				} else {
					return _List_Nil;
				}
			}());
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$TypeChoisi = function (a) {
	return {$: 3, a: a};
};
var $author$project$I18n$Cles$editeurDeSchemaChampTypeObligatoire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.champ.type.obligatoire', _List_Nil, 'Le type est obligatoire.');
};
var $author$project$Components$Shared$EditeurDeSchema$Model$erreurDuType = function (saisie) {
	return saisie.b5 && (_Utils_eq(saisie.lZ, $elm$core$Maybe$Nothing) && (saisie.zT.JR === ''));
};
var $author$project$Components$Shared$EditeurDeSchema$View$typeDuChamp = F5(
	function (i18n, libelle, presentation, enregistre, saisie) {
		var choisi = saisie.zT.JR;
		var champ = {
			go: $author$project$Components$Shared$EditeurDeSchema$Model$erreurDuType(saisie) ? $elm$core$Maybe$Just(
				$author$project$I18n$Cles$editeurDeSchemaChampTypeObligatoire(i18n)) : $elm$core$Maybe$Nothing,
			Aq: presentation.pv + '-type',
			Bl: libelle,
			he: !enregistre
		};
		return enregistre ? A2(
			$author$project$Components$Shared$Champ$View$compose,
			champ,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$select,
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true),
						$author$project$Components$Shared$Champ$View$attributs(champ)),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$option,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(true)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									(choisi === '') ? $author$project$I18n$Cles$editeurDeSchemaTypeInconnu(i18n) : A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeDeChamp, i18n, choisi))
								]))
						]))
				])) : A2(
			$author$project$Components$Shared$Champ$View$liste,
			champ,
			{
				hg: $author$project$Components$Shared$EditeurDeSchema$Model$TypeChoisi,
				o_: A2(
					$elm$core$List$cons,
					{
						Bl: $author$project$I18n$Cles$editeurDeSchemaChampTypeChoisir(i18n),
						fm: ''
					},
					A2(
						$elm$core$List$map,
						function (propose) {
							return {
								Bl: A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeDeChamp, i18n, propose.vx),
								fm: propose.vx
							};
						},
						presentation.Gw.J_)),
				fm: choisi
			});
	});
var $author$project$Components$Shared$EditeurDeSchema$View$formulaireDeCreation = F3(
	function (i18n, presentation, saisie) {
		var saisi = saisie.zT;
		var proposes = A2(
			$elm$core$List$sortBy,
			function (code) {
				return _Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionSousChamps) ? 1 : 0;
			},
			A2(
				$elm$core$List$concatMap,
				function ($) {
					return $.o_;
				},
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.vx;
						},
						$elm$core$Basics$eq(saisi.JR)),
					presentation.Gw.J_)));
		var prefixe = presentation.pv;
		var nom = function (langue) {
			return A2(
				$author$project$Components$Shared$Champ$View$texte,
				{
					go: A2($author$project$Components$Shared$EditeurDeSchema$Model$erreurDuLibelle, langue, saisie) ? $elm$core$Maybe$Just(
						$author$project$I18n$Cles$editeurDeSchemaChampLibelleObligatoire(i18n)) : (_Utils_eq(
						saisie.pZ,
						$elm$core$Maybe$Just($author$project$Components$Shared$EditeurDeSchema$Model$CleDejaUtilisee)) ? $elm$core$Maybe$Just(
						$author$project$I18n$Cles$editeurDeSchemaChampCleDejaUtilisee(i18n)) : $elm$core$Maybe$Nothing),
					Aq: A2($author$project$Components$Shared$EditeurDeSchema$View$idDuLibelle, prefixe, langue),
					Bl: $author$project$I18n$Cles$editeurDeSchemaChampNom(i18n),
					he: true
				},
				{
					hg: $author$project$Components$Shared$EditeurDeSchema$Model$Libelle(langue),
					fm: A2($author$project$Components$Shared$EditeurDeSchema$Model$libelleSaisi, langue, saisi)
				});
		};
		return _List_fromArray(
			[
				A3($author$project$Components$Shared$EditeurDeSchema$View$refus, i18n, prefixe, saisie),
				A2($author$project$Components$Shared$EditeurDeSchema$View$modelesDeGroupe, i18n, presentation),
				A5(
				$author$project$Components$Shared$EditeurDeSchema$View$typeDuChamp,
				i18n,
				$author$project$I18n$Cles$editeurDeSchemaChampTypeDeChamp(i18n),
				presentation,
				false,
				saisie),
				A2($author$project$Components$Shared$EditeurDeSchema$View$noteDuReferentiel, i18n, saisie),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('libelles')
					]),
				A2(
					$elm$core$List$map,
					nom,
					A2(
						$elm$core$List$take,
						1,
						$author$project$Components$Shared$EditeurDeSchema$Model$languesDesLibelles(saisie.Ba)))),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('options')
					]),
				_Utils_ap(
					A2(
						$elm$core$List$concatMap,
						A3($author$project$Components$Shared$EditeurDeSchema$View$optionDuType, i18n, presentation, saisie),
						proposes),
					_Utils_ap(
						_Utils_eq(saisi.JR, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeGroupe) ? _List_Nil : A2(
							$elm$core$List$concatMap,
							A3($author$project$Components$Shared$EditeurDeSchema$View$optionPropre, i18n, presentation, saisie),
							presentation.HN.Ej),
						A2($author$project$Components$Shared$EditeurDeSchema$View$encadreDesReferentiels, i18n, saisie))))
			]);
	});
var $author$project$Components$Produits$FicheType$Update$AutreNomAChoisir = {$: 63};
var $author$project$Components$Produits$FicheType$Update$ChampChoisi = function (a) {
	return {$: 56, a: a};
};
var $author$project$Components$Produits$FicheType$Update$ChampExistantAChoisir = function (a) {
	return {$: 62, a: a};
};
var $author$project$Components$Produits$FicheType$Update$ElargissementConfirme = function (a) {
	return {$: 66, a: a};
};
var $author$project$Components$Produits$FicheType$Update$ElargissementDemande = F2(
	function (a, b) {
		return {$: 64, a: a, b: b};
	});
var $author$project$Components$Produits$FicheType$Update$ElargissementValide = {$: 67};
var $author$project$Components$Produits$FicheType$Update$ExigenceDuRattachement = function (a) {
	return {$: 57, a: a};
};
var $author$project$Components$Produits$FicheType$Update$FiltrableCoche = function (a) {
	return {$: 60, a: a};
};
var $author$project$Components$Produits$FicheType$Update$LectureDuRattachement = function (a) {
	return {$: 58, a: a};
};
var $author$project$Components$Produits$FicheType$Update$MasqueDuRattachement = function (a) {
	return {$: 59, a: a};
};
var $author$project$Components$Produits$FicheType$Update$ModeChoisi = function (a) {
	return {$: 53, a: a};
};
var $author$project$Components$Produits$FicheType$Update$RecherchableCoche = function (a) {
	return {$: 61, a: a};
};
var $author$project$Components$Produits$FicheType$Update$RechercheSaisie = function (a) {
	return {$: 55, a: a};
};
var $author$project$Components$Produits$FicheType$View$messagesDuDrawer = {t4: $author$project$Components$Produits$FicheType$Update$AutreNomAChoisir, uN: $author$project$Components$Produits$FicheType$Update$ChampChoisi, uQ: $author$project$Components$Produits$FicheType$Update$ChampExistantAChoisir, j7: $author$project$Components$Produits$FicheType$Update$ElargissementConfirme, xU: $author$project$Components$Produits$FicheType$Update$DuDrawer, xV: $author$project$Components$Produits$FicheType$Update$DuElargissement, ya: $author$project$Components$Produits$FicheType$Update$ElargissementDemande, mo: $author$project$Components$Produits$FicheType$Update$ExigenceDuRattachement, zG: $author$project$Components$Produits$FicheType$Update$FiltrableCoche, np: $author$project$Components$Produits$FicheType$Update$LectureDuRattachement, n4: $author$project$Components$Produits$FicheType$Update$MasqueDuRattachement, n9: $author$project$Components$Produits$FicheType$Update$ModeChoisi, Ff: $elm$core$Maybe$Nothing, G1: $author$project$Components$Produits$FicheType$Update$RecherchableCoche, hC: $author$project$Components$Produits$FicheType$Update$RechercheSaisie, Kv: $author$project$Components$Produits$FicheType$Update$ElargissementValide};
var $author$project$Components$Produits$FicheType$Model$autresChamps = F2(
	function (saisie, fiche) {
		return A2(
			$elm$core$List$filter,
			function (autre) {
				return !_Utils_eq(
					$elm$core$Maybe$Just(autre.dy),
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.dy;
						},
						saisie.lZ));
			},
			A2(
				$elm$core$List$map,
				function (lu) {
					return {dy: lu.uN.dy, Bl: lu.uN.Bl};
				},
				fiche.dw));
	});
var $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$choixDExigence = F2(
	function (i18n, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			code,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.jN;
				},
				A2(
					$elm$core$Dict$get,
					code,
					$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigences(i18n))));
	});
var $author$project$I18n$Cles$produitsTypesExigenceALaPublication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.exigence.a-la-publication', _List_Nil, 'Obligatoire à la publication : la référence reste en brouillon tant qu\'elle manque');
};
var $author$project$I18n$Cles$produitsTypesExigenceAvertissementALEnregistrement = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.exigence.avertissement.a-l-enregistrement',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? 'La référence existante n\'a pas de valeur ; elle sera demandée à sa prochaine modification.' : ('Les ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' références existantes n\'ont pas de valeur ; elle sera demandée à leur prochaine modification.')));
	});
var $author$project$I18n$Cles$produitsTypesExigenceAvertissementALaPublication = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.exigence.avertissement.a-la-publication',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' référence deviendra non publiable tant qu\'elle manque.') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' références deviendront non publiables tant qu\'elle manque.'));
	});
var $author$project$Components$Produits$FicheType$Model$ressource = F2(
	function (i18n, fiche) {
		var references = fiche.fh.hD;
		return {
			uj: function (code) {
				return (!references) ? $elm$core$Maybe$Nothing : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceALEnregistrement) ? $elm$core$Maybe$Just(
					A2(
						$author$project$I18n$Cles$produitsTypesExigenceAvertissementALEnregistrement,
						i18n,
						{w: references})) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceALaPublication) ? $elm$core$Maybe$Just(
					A2(
						$author$project$I18n$Cles$produitsTypesExigenceAvertissementALaPublication,
						i18n,
						{w: references})) : $elm$core$Maybe$Nothing));
			},
			mo: function (code) {
				return _Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceALaPublication) ? $author$project$I18n$Cles$produitsTypesExigenceALaPublication(i18n) : A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$choixDExigence, i18n, code);
			},
			Ej: _List_Nil
		};
	});
var $author$project$Components$Produits$FicheType$View$presentation = F3(
	function (i18n, model, fiche) {
		return {
			t8: A2($author$project$Components$Produits$FicheType$Model$autresChamps, model.hP, fiche),
			n_: model.n_,
			pv: $author$project$Components$Shared$Drawer$Model$idRacine(model.kX),
			Gw: fiche.x5,
			HN: A2($author$project$Components$Produits$FicheType$Model$ressource, i18n, fiche),
			ib: model.r2
		};
	});
var $author$project$Components$Produits$FicheType$View$entreesDeLAjout = F3(
	function (i18n, model, fiche) {
		return A4(
			$author$project$Components$Shared$Bibliotheque$View$entrees,
			i18n,
			A2($author$project$Components$Produits$FicheType$View$contexteDuDrawer, model, fiche),
			$author$project$Components$Produits$FicheType$View$messagesDuDrawer,
			{
				wZ: model.wZ,
				kz: model.kz,
				zT: _Utils_ap(
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Produits$FicheType$Update$DeLEditeur),
						A3(
							$author$project$Components$Shared$EditeurDeSchema$View$formulaireDeCreation,
							i18n,
							A3($author$project$Components$Produits$FicheType$View$presentation, i18n, model, fiche),
							model.hP)),
					_List_fromArray(
						[
							A4(
							$author$project$Components$Shared$EditeurDeSchema$Resserrage$avertissement,
							i18n,
							0,
							$author$project$Components$Shared$Drawer$Model$idRacine(model.kX),
							model.tq)
						])),
				n9: model.n9,
				hB: !_Utils_eq(
					$author$project$Components$Produits$FicheType$Model$rattachement(fiche),
					$elm$core$Maybe$Nothing),
				pN: model.pN,
				JR: model.hP.zT.JR
			});
	});
var $author$project$Components$Produits$FicheType$Update$FiltrableDuChamp = function (a) {
	return {$: 70, a: a};
};
var $author$project$Components$Produits$FicheType$Update$LectureDuChamp = function (a) {
	return {$: 68, a: a};
};
var $author$project$Components$Produits$FicheType$Update$MasqueDuChamp = function (a) {
	return {$: 69, a: a};
};
var $author$project$Components$Produits$FicheType$Update$RecherchableDuChamp = function (a) {
	return {$: 71, a: a};
};
var $author$project$Components$Produits$FicheType$ChampDeBibliotheque$droits = F2(
	function (cle, fiche) {
		var ouvert = F2(
			function (rel, liens) {
				return !_Utils_eq(
					A2($author$project$API$Liens$trouver, rel, liens),
					$elm$core$Maybe$Nothing);
			});
		var duChamp = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.nQ;
				},
				A2($author$project$Components$Produits$FicheType$ChampDeBibliotheque$champDe, cle, fiche)));
		var deLaFiche = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.nQ;
				},
				A2($elm$core$Dict$get, cle, fiche.dq)));
		return {
			zG: A2(ouvert, $author$project$API$NavLinksDictionary$reglerLeFiltrable, deLaFiche),
			np: A2(ouvert, $author$project$API$NavLinksDictionary$reglerLeRattachement, duChamp),
			n4: A2(ouvert, $author$project$API$NavLinksDictionary$masquerUnChamp, duChamp) || A2(ouvert, $author$project$API$NavLinksDictionary$afficherUnChamp, duChamp),
			G1: A2(ouvert, $author$project$API$NavLinksDictionary$reglerLeRecherchable, deLaFiche)
		};
	});
var $author$project$Components$Produits$FicheType$Model$filtrableAdmis = $author$project$Components$Shared$Bibliotheque$View$filtrableAdmis;
var $author$project$I18n$Cles$editeurDeSchemaChampCle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.champ.cle', _List_Nil, 'Clé');
};
var $author$project$I18n$Cles$editeurDeSchemaChampFiltrable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.champ.filtrable', _List_Nil, 'Filtrable');
};
var $author$project$I18n$Cles$editeurDeSchemaChampNomCourt = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.champ.nom-court', _List_Nil, 'Nom');
};
var $author$project$I18n$Cles$editeurDeSchemaChampType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.champ.type', _List_Nil, 'Type');
};
var $author$project$I18n$Cles$editeurDeSchemaPartageDefinition = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.partage.definition', _List_Nil, 'Définition (bibliothèque)');
};
var $author$project$I18n$Cles$editeurDeSchemaPartageLectureSeule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.partage.lecture-seule', _List_Nil, 'lecture seule');
};
var $author$project$I18n$Cles$editeurDeSchemaPartageModifierDansLaBibliotheque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.partage.modifier-dans-la-bibliotheque', _List_Nil, 'Modifier dans la bibliothèque');
};
var $author$project$I18n$Cles$editeurDeSchemaPartageNote = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.partage.note',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? 'Un changement de la définition vaut pour l\'unique type. Il se fait dans la bibliothèque, pas ici.' : ('Un changement de la définition vaut pour les ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' types. Il se fait dans la bibliothèque, pas ici.')));
	});
var $author$project$I18n$Cles$editeurDeSchemaPartageUtilisePar = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.partage.utilise-par',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('utilisé par ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' type')) : ('utilisé par ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' types')));
	});
var $author$project$I18n$Cles$editeurDeSchemaTypeMesureAvecUnite = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.type.mesure.avec-unite',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'unite',
					$author$project$I18n$Traductions$Chaine(p.sa))
				]),
			p.Dj + (' · ' + p.sa));
	});
var $author$project$Components$Produits$FicheType$FormulaireDeChamp$typeLu = F2(
	function (i18n, donnees) {
		var _v0 = donnees.hP.zT.JR;
		if (_v0 === '') {
			return $author$project$I18n$Cles$editeurDeSchemaTypeInconnu(i18n);
		} else {
			var choisi = _v0;
			return A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeDeChamp, i18n, choisi);
		}
	});
var $author$project$Components$Produits$FicheType$FormulaireDeChamp$typeEtUnite = F2(
	function (i18n, donnees) {
		var saisi = donnees.hP.zT;
		var unite = A2($author$project$Components$Shared$EditeurDeSchema$Model$option, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionUnite, saisi);
		return (_Utils_eq(saisi.JR, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeMesure) && (unite !== '')) ? A2(
			$author$project$I18n$Cles$editeurDeSchemaTypeMesureAvecUnite,
			i18n,
			{
				Dj: A2(
					$elm$core$Maybe$withDefault,
					A2($author$project$Components$Produits$FicheType$FormulaireDeChamp$typeLu, i18n, donnees),
					A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeConnu, i18n, saisi.JR)),
				sa: unite
			}) : A2($author$project$Components$Produits$FicheType$FormulaireDeChamp$typeLu, i18n, donnees);
	});
var $author$project$Components$Produits$FicheType$FormulaireDeChamp$definitionPartagee = F2(
	function (i18n, donnees) {
		var ligne = F2(
			function (libelle, contenu) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$dt,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(libelle)
								])),
							A2($rtfeldman$elm_css$Html$Styled$dd, _List_Nil, contenu)
						]));
			});
		var enregistre = donnees.hP.lZ;
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('titre-de-groupe')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('overline')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$editeurDeSchemaPartageDefinition(i18n))
							])),
						A2(
						$author$project$Components$Shared$Tag$View$view,
						3,
						$author$project$I18n$Cles$editeurDeSchemaPartageLectureSeule(i18n))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$dl,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('definition-lue')
					]),
				_List_fromArray(
					[
						A2(
						ligne,
						$author$project$I18n$Cles$editeurDeSchemaChampNomCourt(i18n),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.Bl;
										},
										enregistre)))
							])),
						A2(
						ligne,
						$author$project$I18n$Cles$editeurDeSchemaChampType(i18n),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$Components$Produits$FicheType$FormulaireDeChamp$typeEtUnite, i18n, donnees))
							])),
						A2(
						ligne,
						$author$project$I18n$Cles$editeurDeSchemaChampCle(i18n),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$code,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(donnees.hP.zT.dy)
									]))
							])),
						A2(
						ligne,
						$author$project$I18n$Cles$editeurDeSchemaChampFiltrable(i18n),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								donnees.gt.zG ? $author$project$I18n$Cles$editeurDeSchemaChampOui(i18n) : $author$project$I18n$Cles$editeurDeSchemaChampNon(i18n))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('partage')
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Components$Shared$Tag$View$view,
						5,
						A2(
							$author$project$I18n$Cles$editeurDeSchemaPartageUtilisePar,
							i18n,
							{w: donnees.sf})),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (adresse) {
								return _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
												$rtfeldman$elm_css$Html$Styled$Attributes$href(adresse)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$editeurDeSchemaPartageModifierDansLaBibliotheque(i18n))
											]))
									]);
							},
							donnees.sp)))),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$editeurDeSchemaPartageNote,
							i18n,
							{w: donnees.sf}))
					]))
			]);
	});
var $author$project$I18n$Cles$editeurDeSchemaChampFiltrableNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.champ.filtrable-note', _List_Nil, 'Apparaît dans les filtres de recherche.');
};
var $author$project$I18n$Cles$editeurDeSchemaChampTypeFige = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.champ.type-fige', _List_Nil, 'Ne change plus après enregistrement.');
};
var $author$project$I18n$Cles$editeurDeSchemaPropreDefinition = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.propre.definition', _List_Nil, 'Définition');
};
var $author$project$Components$Produits$FicheType$FormulaireDeChamp$definitionPropre = F3(
	function (i18n, gestes, donnees) {
		var saisie = donnees.hP;
		var prefixe = donnees.ak.pv;
		var uneCase = F6(
			function (suffixe, libelle, note, admis, cochee, onCheck) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('reglage')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Components$Shared$Champ$View$caseACocherInactivable,
							{go: $elm$core$Maybe$Nothing, Aq: prefixe + ('-' + suffixe), Bl: libelle, he: false},
							{vt: cochee && admis, d4: !admis, D9: onCheck}),
						(note === '') ? _List_Nil : _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(note)
									]))
							])));
			});
		var langue = A2(
			$elm$core$Maybe$withDefault,
			'fr',
			$elm$core$List$head(
				$author$project$Components$Shared$EditeurDeSchema$Model$languesDesLibelles(saisie.Ba)));
		var enLecture = F3(
			function (suffixe, libelle, valeur) {
				var champ = {go: $elm$core$Maybe$Nothing, Aq: prefixe + ('-' + suffixe), Bl: libelle, he: false};
				return A2(
					$author$project$Components$Shared$Champ$View$compose,
					champ,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$input,
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
								A2(
									$elm$core$List$cons,
									$rtfeldman$elm_css$Html$Styled$Attributes$value(valeur),
									A2(
										$elm$core$List$cons,
										$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true),
										$author$project$Components$Shared$Champ$View$attributs(champ)))),
							_List_Nil)
						]));
			});
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('overline')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$editeurDeSchemaPropreDefinition(i18n))
					])),
				A2(
				$author$project$Components$Shared$Champ$View$texte,
				{
					go: A2($author$project$Components$Shared$EditeurDeSchema$Model$erreurDuLibelle, langue, saisie) ? $elm$core$Maybe$Just(
						$author$project$I18n$Cles$editeurDeSchemaChampLibelleObligatoire(i18n)) : $elm$core$Maybe$Nothing,
					Aq: A2($author$project$Components$Shared$EditeurDeSchema$View$idDuLibelle, prefixe, langue),
					Bl: $author$project$I18n$Cles$editeurDeSchemaChampNom(i18n),
					he: true
				},
				{
					hg: function (texte) {
						return gestes.dD(
							A2($author$project$Components$Shared$EditeurDeSchema$Model$Libelle, langue, texte));
					},
					fm: A2($author$project$Components$Shared$EditeurDeSchema$Model$libelleSaisi, langue, saisie.zT)
				}),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('type-et-cle')
					]),
				_List_fromArray(
					[
						A3(
						enLecture,
						'type',
						$author$project$I18n$Cles$editeurDeSchemaChampTypeDeChamp(i18n),
						A2($author$project$Components$Produits$FicheType$FormulaireDeChamp$typeLu, i18n, donnees)),
						A3(
						enLecture,
						'cle',
						$author$project$I18n$Cles$editeurDeSchemaChampCle(i18n),
						saisie.zT.dy)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$editeurDeSchemaChampTypeFige(i18n))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('carte')
					]),
				_List_fromArray(
					[
						A6(
						uneCase,
						'filtrable',
						$author$project$I18n$Cles$editeurDeSchemaChampFiltrable(i18n),
						$author$project$I18n$Cles$editeurDeSchemaChampFiltrableNote(i18n),
						donnees.mC && donnees.xS.zG,
						donnees.gt.zG,
						gestes.zG),
						A6(
						uneCase,
						'recherchable',
						$author$project$I18n$Cles$bibliothequeReglagesRecherchable(i18n),
						'',
						donnees.xS.G1,
						donnees.gt.G1,
						gestes.G1)
					]))
			]);
	});
var $author$project$I18n$Cles$editeurDeSchemaPartageReglages = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.partage.reglages', _List_Nil, 'Réglages pour ce type');
};
var $author$project$I18n$Cles$editeurDeSchemaPropreBandeauDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.propre.bandeau.detail', _List_Nil, 'Il se modifie directement ici. S\'il est rattaché à un autre type, il passe en lecture et se modifie dans la bibliothèque.');
};
var $author$project$I18n$Cles$editeurDeSchemaPropreBandeauTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.propre.bandeau.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Ce champ ne sert que sur « ' + (p.Dj + ' »'));
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$Exigence = function (a) {
	return {$: 6, a: a};
};
var $author$project$I18n$Cles$editeurDeSchemaExigenceTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.exigence.titre', _List_Nil, 'Exigence');
};
var $author$project$Components$Produits$FicheType$FormulaireDeChamp$exigence = F3(
	function (i18n, gestes, donnees) {
		var choisie = donnees.hP.zT.mo;
		var avertissement = _Utils_eq(choisie, donnees.hP.cx.mo) ? $elm$core$Maybe$Nothing : donnees.ak.HN.uj(choisie);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('exigence')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Components$Shared$Champ$View$liste,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: donnees.ak.pv + '-exigence',
						Bl: $author$project$I18n$Cles$editeurDeSchemaExigenceTitre(i18n),
						he: false
					},
					{
						hg: function (code) {
							return gestes.dD(
								$author$project$Components$Shared$EditeurDeSchema$Model$Exigence(code));
						},
						o_: A2(
							$elm$core$List$map,
							function (code) {
								return {
									Bl: donnees.ak.HN.mo(code),
									fm: code
								};
							},
							donnees.ak.Gw.y$),
						fm: choisie
					}),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (dit) {
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('consequence')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Components$Shared$Note$View$view,
											1,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(dit)
														]))
												]))
										]))
								]);
						},
						avertissement))));
	});
var $author$project$Components$Produits$FicheType$FormulaireDeChamp$lecture = F3(
	function (i18n, gestes, donnees) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsTypesAjoutLecture(i18n))
						])),
					$author$project$Components$Shared$Segment$View$view(
					{
						vd: donnees.gt.np,
						Bi: $author$project$I18n$Cles$produitsTypesAjoutLecture(i18n),
						Dj: donnees.ak.pv + '-lecture',
						Ea: gestes.np,
						o_: _List_fromArray(
							[
								{
								vx: 'essentiel',
								Bl: $author$project$I18n$Cles$produitsTypesAjoutLectureEssentiel(i18n)
							},
								{
								vx: 'detail',
								Bl: $author$project$I18n$Cles$produitsTypesAjoutLectureDetail(i18n)
							}
							])
					})
				]));
	});
var $author$project$Components$Produits$FicheType$FormulaireDeChamp$masque = F3(
	function (i18n, gestes, donnees) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('reglage')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Champ$View$caseACocherInactivable,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: donnees.ak.pv + '-masque',
						Bl: $author$project$I18n$Cles$produitsTypesAjoutMasque(i18n),
						he: false
					},
					{vt: donnees.gt.n4, d4: !donnees.xS.n4, D9: gestes.n4}),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsTypesAjoutMasqueNote(i18n))
						]))
				]));
	});
var $author$project$Components$Produits$FicheType$FormulaireDeChamp$formulaire = F3(
	function (i18n, gestes, donnees) {
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$map,
				gestes.dD,
				A3($author$project$Components$Shared$EditeurDeSchema$View$refus, i18n, donnees.ak.pv, donnees.hP)),
				donnees.hm ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
				$author$project$Components$Shared$Note$View$view,
				0,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$editeurDeSchemaPropreBandeauTitre,
									i18n,
									{Dj: donnees.Dp}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$editeurDeSchemaPropreBandeauDetail(i18n))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('definition')
					]),
				donnees.hm ? A2($author$project$Components$Produits$FicheType$FormulaireDeChamp$definitionPartagee, i18n, donnees) : A3($author$project$Components$Produits$FicheType$FormulaireDeChamp$definitionPropre, i18n, gestes, donnees)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('reglages-du-rattachement')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('overline')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$editeurDeSchemaPartageReglages(i18n))
							])),
						A3($author$project$Components$Produits$FicheType$FormulaireDeChamp$exigence, i18n, gestes, donnees),
						A3($author$project$Components$Produits$FicheType$FormulaireDeChamp$lecture, i18n, gestes, donnees),
						A3($author$project$Components$Produits$FicheType$FormulaireDeChamp$masque, i18n, gestes, donnees)
					]))
			]);
	});
var $author$project$API$NavLinksDictionary$modifierDansLaBibliotheque = 'modifier-dans-la-bibliotheque';
var $author$project$Components$Shared$EditeurDeSchema$Model$Aide = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$AffichageChoisi = function (a) {
	return {$: 7, a: a};
};
var $author$project$I18n$Cles$editeurDeSchemaAffichage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.affichage', _List_Nil, 'Affichage');
};
var $author$project$I18n$Cles$editeurDeSchemaAffichageAutre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.affichage.autre', _List_Nil, 'Condition définie hors de cet écran');
};
var $author$project$I18n$Cles$editeurDeSchemaAffichageSiRempli = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.affichage.si-rempli',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'Visible si « ' + (p.uN + ' » est rempli'));
	});
var $author$project$I18n$Cles$editeurDeSchemaAffichageToujours = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.affichage.toujours', _List_Nil, 'Toujours visible');
};
var $author$project$Components$Shared$EditeurDeSchema$View$affichage = F3(
	function (i18n, presentation, saisie) {
		var courante = saisie.zT.KQ;
		var autre = '*';
		var valeur = function () {
			switch (courante.$) {
				case 0:
					return '';
				case 1:
					var champ = courante.a;
					return champ;
				default:
					return autre;
			}
		}();
		return A2(
			$author$project$Components$Shared$Champ$View$liste,
			{
				go: $elm$core$Maybe$Nothing,
				Aq: presentation.pv + '-affichage',
				Bl: $author$project$I18n$Cles$editeurDeSchemaAffichage(i18n),
				he: false
			},
			{
				hg: function (choisie) {
					return $author$project$Components$Shared$EditeurDeSchema$Model$AffichageChoisi(
						(choisie === '') ? $author$project$Components$Shared$EditeurDeSchema$Champ$Toujours : (_Utils_eq(choisie, autre) ? courante : $author$project$Components$Shared$EditeurDeSchema$Champ$SiRempli(choisie)));
				},
				o_: A2(
					$elm$core$List$cons,
					{
						Bl: $author$project$I18n$Cles$editeurDeSchemaAffichageToujours(i18n),
						fm: ''
					},
					_Utils_ap(
						A2(
							$elm$core$List$map,
							function (champ) {
								return {
									Bl: A2(
										$author$project$I18n$Cles$editeurDeSchemaAffichageSiRempli,
										i18n,
										{uN: champ.Bl}),
									fm: champ.dy
								};
							},
							presentation.t8),
						_Utils_eq(valeur, autre) ? _List_fromArray(
							[
								{
								Bl: $author$project$I18n$Cles$editeurDeSchemaAffichageAutre(i18n),
								fm: autre
							}
							]) : _List_Nil)),
				fm: valeur
			});
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$Apercu = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$View$apercuDuChamp = function (saisie) {
	var voulu = $author$project$Components$Shared$EditeurDeSchema$Model$champVoulu(saisie);
	return _Utils_update(
		voulu,
		{he: false});
};
var $author$project$I18n$Cles$editeurDeSchemaApercu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.apercu', _List_Nil, 'Aperçu');
};
var $author$project$Components$Shared$EditeurDeSchema$View$apercu = F3(
	function (i18n, presentation, saisie) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu')
				]),
			((saisie.zT.JR === '') && _Utils_eq(saisie.lZ, $elm$core$Maybe$Nothing)) ? _List_Nil : _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$editeurDeSchemaApercu(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Components$Shared$EditeurDeSchema$Model$Apercu,
					A4(
						$author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$view,
						i18n,
						{
							Aq: presentation.pv + '-apercu',
							Ba: $author$project$Components$Shared$EditeurDeSchema$Model$languesDesLibelles(saisie.Ba),
							hd: saisie.hd,
							sb: presentation.Gw.sb
						},
						$author$project$Components$Shared$EditeurDeSchema$View$apercuDuChamp(saisie),
						saisie.tq))
				]));
	});
var $author$project$I18n$Cles$editeurDeSchemaFigeeRepere = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.figee.repere', _List_Nil, 'Information personnelle');
};
var $author$project$I18n$Cles$editeurDeSchemaFigeeTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.figee.texte', _List_Nil, 'Une information personnelle est protégée : ses limites ne se modifient pas, et elle n’est jamais comptée dans les alertes. Pour changer ses règles, créez une nouvelle information.');
};
var $author$project$I18n$Cles$editeurDeSchemaFigeeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.figee.titre', _List_Nil, 'Cette information ne peut pas être resserrée.');
};
var $author$project$Components$Shared$EditeurDeSchema$View$champFige = F2(
	function (i18n, saisie) {
		return $author$project$Components$Shared$EditeurDeSchema$Model$figee(saisie) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('note', true),
							_Utils_Tuple2('information', true)
						])),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'note')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('repere')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$editeurDeSchemaFigeeRepere(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$editeurDeSchemaFigeeTitre(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$editeurDeSchemaFigeeTexte(i18n))
						]))
				])) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$Cle = function (a) {
	return {$: 2, a: a};
};
var $author$project$I18n$Cles$editeurDeSchemaChampCleObligatoire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.champ.cle.obligatoire', _List_Nil, 'La clé est obligatoire.');
};
var $author$project$Components$Shared$EditeurDeSchema$Model$erreurDeLaCle = function (saisie) {
	return saisie.b5 && (saisie.zT.dy === '');
};
var $author$project$Components$Shared$EditeurDeSchema$View$cleDuChamp = F4(
	function (i18n, prefixe, enregistre, saisie) {
		var champ = {
			go: $author$project$Components$Shared$EditeurDeSchema$Model$erreurDeLaCle(saisie) ? $elm$core$Maybe$Just(
				$author$project$I18n$Cles$editeurDeSchemaChampCleObligatoire(i18n)) : (_Utils_eq(
				saisie.pZ,
				$elm$core$Maybe$Just($author$project$Components$Shared$EditeurDeSchema$Model$CleDejaUtilisee)) ? $elm$core$Maybe$Just(
				$author$project$I18n$Cles$editeurDeSchemaChampCleDejaUtilisee(i18n)) : $elm$core$Maybe$Nothing),
			Aq: prefixe + '-cle',
			Bl: $author$project$I18n$Cles$editeurDeSchemaChampCle(i18n),
			he: !enregistre
		};
		return enregistre ? A2(
			$author$project$Components$Shared$Champ$View$compose,
			champ,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
						A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Attributes$value(saisie.zT.dy),
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true),
								$author$project$Components$Shared$Champ$View$attributs(champ)))),
					_List_Nil)
				])) : A2(
			$author$project$Components$Shared$Champ$View$texte,
			champ,
			{hg: $author$project$Components$Shared$EditeurDeSchema$Model$Cle, fm: saisie.zT.dy});
	});
var $author$project$I18n$Cles$editeurDeSchemaChampAide = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.champ.aide',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'langue',
					$author$project$I18n$Traductions$Chaine(p.nn))
				]),
			'Aide (' + (p.nn + ')'));
	});
var $author$project$I18n$Cles$editeurDeSchemaChampLibelle = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.champ.libelle',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'langue',
					$author$project$I18n$Traductions$Chaine(p.nn))
				]),
			'Libellé (' + (p.nn + ')'));
	});
var $author$project$I18n$Cles$editeurDeSchemaNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.note', _List_Nil, 'Après l\'enregistrement, le champ ne se supprime plus et ne change ni de type ni de clé ; il peut être masqué.');
};
var $author$project$Components$Shared$EditeurDeSchema$View$exigence = F3(
	function (i18n, presentation, saisie) {
		var prefixe = presentation.pv + '-exigence';
		var choisie = saisie.zT.mo;
		var choix = function (code) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('choix')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$input,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
								$rtfeldman$elm_css$Html$Styled$Attributes$name(prefixe),
								$rtfeldman$elm_css$Html$Styled$Attributes$id(prefixe + ('-' + code)),
								$rtfeldman$elm_css$Html$Styled$Attributes$checked(
								_Utils_eq(code, choisie)),
								$rtfeldman$elm_css$Html$Styled$Events$onCheck(
								function (_v0) {
									return $author$project$Components$Shared$EditeurDeSchema$Model$Exigence(code);
								})
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for(prefixe + ('-' + code))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								presentation.HN.mo(code))
							]))
					]));
		};
		var avertissement = _Utils_eq(choisie, saisie.cx.mo) ? $elm$core$Maybe$Nothing : presentation.HN.uj(choisie);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('exigence')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Champ$View$compose,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: prefixe,
						Bl: $author$project$I18n$Cles$editeurDeSchemaExigenceTitre(i18n),
						he: false
					},
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('liste-de-choix'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'radiogroup'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-labelledby', prefixe + '-libelle')
								]),
							A2($elm$core$List$map, choix, presentation.Gw.y$))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('consequence')
						]),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (dit) {
								return _List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Note$View$view,
										1,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(dit)
													]))
											]))
									]);
							},
							avertissement)))
				]));
	});
var $author$project$Components$Shared$EditeurDeSchema$Model$MinimaEnregistres = {$: 12};
var $author$project$Components$Shared$EditeurDeSchema$Model$MinimaHauteur = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Model$MinimaLargeur = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Model$MinimaTexteAlternatif = function (a) {
	return {$: 11, a: a};
};
var $author$project$I18n$Cles$editeurDeSchemaMinimaEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.minima.enregistrer', _List_Nil, 'Enregistrer les minima');
};
var $author$project$I18n$Cles$editeurDeSchemaMinimaHauteur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.minima.hauteur', _List_Nil, 'Hauteur minimale (px)');
};
var $author$project$I18n$Cles$editeurDeSchemaMinimaInvalides = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.minima.invalides', _List_Nil, 'Les dimensions minimales sont des nombres entiers strictement positifs.');
};
var $author$project$I18n$Cles$editeurDeSchemaMinimaLargeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.minima.largeur', _List_Nil, 'Largeur minimale (px)');
};
var $author$project$I18n$Cles$editeurDeSchemaMinimaTexteAlternatif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.minima.texte-alternatif', _List_Nil, 'Texte alternatif exigé dans les deux langues');
};
var $author$project$I18n$Cles$editeurDeSchemaMinimaTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.minima.titre', _List_Nil, 'Minima du fichier');
};
var $author$project$Components$Shared$EditeurDeSchema$View$minimaDuChamp = F3(
	function (i18n, prefixe, saisie) {
		var _v0 = saisie.CC;
		if (_v0.$ === 1) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('minima')
					]),
				_List_Nil);
		} else {
			var saisis = _v0.a;
			var invalide = _Utils_eq(
				$author$project$Components$Shared$EditeurDeSchema$Model$minimaVoulus(saisie),
				$elm$core$Maybe$Nothing);
			var champ = F3(
				function (nom, libelle, erreur) {
					return {go: erreur, Aq: prefixe + ('-minima-' + nom), Bl: libelle, he: false};
				});
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('minima')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h3,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$editeurDeSchemaMinimaTitre(i18n))
							])),
						A2(
						$author$project$Components$Shared$Champ$View$texte,
						A3(
							champ,
							'largeur',
							$author$project$I18n$Cles$editeurDeSchemaMinimaLargeur(i18n),
							$elm$core$Maybe$Nothing),
						{hg: $author$project$Components$Shared$EditeurDeSchema$Model$MinimaLargeur, fm: saisis.Bd}),
						A2(
						$author$project$Components$Shared$Champ$View$texte,
						A3(
							champ,
							'hauteur',
							$author$project$I18n$Cles$editeurDeSchemaMinimaHauteur(i18n),
							invalide ? $elm$core$Maybe$Just(
								$author$project$I18n$Cles$editeurDeSchemaMinimaInvalides(i18n)) : $elm$core$Maybe$Nothing),
						{hg: $author$project$Components$Shared$EditeurDeSchema$Model$MinimaHauteur, fm: saisis.Ae}),
						A2(
						$author$project$Components$Shared$Champ$View$caseACocher,
						A3(
							champ,
							'texte',
							$author$project$I18n$Cles$editeurDeSchemaMinimaTexteAlternatif(i18n),
							$elm$core$Maybe$Nothing),
						{vt: saisis.Jz, D9: $author$project$Components$Shared$EditeurDeSchema$Model$MinimaTexteAlternatif}),
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Shared$EditeurDeSchema$Model$MinimaEnregistres),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(invalide)
							]),
						$author$project$I18n$Cles$editeurDeSchemaMinimaEnregistrer(i18n))
					]));
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$View$minima = F3(
	function (i18n, presentation, saisie) {
		return A3($author$project$Components$Shared$EditeurDeSchema$View$minimaDuChamp, i18n, presentation.pv, saisie);
	});
var $author$project$Components$Shared$EditeurDeSchema$View$typeFige = F2(
	function (i18n, enregistre) {
		return enregistre ? A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$I18n$Cles$editeurDeSchemaChampTypeFige(i18n))
				])) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$Components$Shared$EditeurDeSchema$View$formulaire = F3(
	function (i18n, presentation, saisie) {
		var saisi = saisie.zT;
		var proposes = A2(
			$elm$core$List$concatMap,
			function ($) {
				return $.o_;
			},
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.vx;
					},
					$elm$core$Basics$eq(saisi.JR)),
				presentation.Gw.J_));
		var prefixe = presentation.pv;
		var langues = $author$project$Components$Shared$EditeurDeSchema$Model$languesDesLibelles(saisie.Ba);
		var enregistre = !_Utils_eq(saisie.lZ, $elm$core$Maybe$Nothing);
		return _List_fromArray(
			[
				A2($author$project$Components$Shared$EditeurDeSchema$View$champFige, i18n, saisie),
				A3($author$project$Components$Shared$EditeurDeSchema$View$refus, i18n, prefixe, saisie),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('libelles')
					]),
				A2(
					$elm$core$List$map,
					function (langue) {
						return A2(
							$author$project$Components$Shared$Champ$View$texte,
							{
								go: A2($author$project$Components$Shared$EditeurDeSchema$Model$erreurDuLibelle, langue, saisie) ? $elm$core$Maybe$Just(
									$author$project$I18n$Cles$editeurDeSchemaChampLibelleObligatoire(i18n)) : $elm$core$Maybe$Nothing,
								Aq: A2($author$project$Components$Shared$EditeurDeSchema$View$idDuLibelle, prefixe, langue),
								Bl: A2(
									$author$project$I18n$Cles$editeurDeSchemaChampLibelle,
									i18n,
									{
										nn: $elm$core$String$toLower(
											A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$langue, i18n, langue))
									}),
								he: A2($author$project$Components$Shared$EditeurDeSchema$Model$libelleExige, langue, saisie)
							},
							{
								hg: $author$project$Components$Shared$EditeurDeSchema$Model$Libelle(langue),
								fm: A2($author$project$Components$Shared$EditeurDeSchema$Model$libelleSaisi, langue, saisi)
							});
					},
					langues)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('aides')
					]),
				A2(
					$elm$core$List$map,
					function (langue) {
						return A2(
							$author$project$Components$Shared$Champ$View$zoneDeTexte,
							{
								go: $elm$core$Maybe$Nothing,
								Aq: prefixe + ('-aide-' + langue),
								Bl: A2(
									$author$project$I18n$Cles$editeurDeSchemaChampAide,
									i18n,
									{
										nn: $elm$core$String$toLower(
											A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$langue, i18n, langue))
									}),
								he: false
							},
							{
								hg: $author$project$Components$Shared$EditeurDeSchema$Model$Aide(langue),
								fm: A2($author$project$Components$Shared$EditeurDeSchema$Model$aideSaisie, langue, saisi)
							});
					},
					langues)),
				A4($author$project$Components$Shared$EditeurDeSchema$View$cleDuChamp, i18n, prefixe, enregistre, saisie),
				A5(
				$author$project$Components$Shared$EditeurDeSchema$View$typeDuChamp,
				i18n,
				$author$project$I18n$Cles$editeurDeSchemaChampType(i18n),
				presentation,
				enregistre,
				saisie),
				A2($author$project$Components$Shared$EditeurDeSchema$View$typeFige, i18n, enregistre),
				A2($author$project$Components$Shared$EditeurDeSchema$View$noteDuReferentiel, i18n, saisie),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('options')
					]),
				_Utils_ap(
					A2(
						$elm$core$List$concatMap,
						A3($author$project$Components$Shared$EditeurDeSchema$View$optionDuType, i18n, presentation, saisie),
						proposes),
					_Utils_ap(
						A2(
							$elm$core$List$concatMap,
							A3($author$project$Components$Shared$EditeurDeSchema$View$optionPropre, i18n, presentation, saisie),
							presentation.HN.Ej),
						A2($author$project$Components$Shared$EditeurDeSchema$View$encadreDesReferentiels, i18n, saisie)))),
				A3($author$project$Components$Shared$EditeurDeSchema$View$exigence, i18n, presentation, saisie),
				A3($author$project$Components$Shared$EditeurDeSchema$View$affichage, i18n, presentation, saisie),
				A3($author$project$Components$Shared$EditeurDeSchema$View$apercu, i18n, presentation, saisie),
				A3($author$project$Components$Shared$EditeurDeSchema$View$minima, i18n, presentation, saisie),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$editeurDeSchemaNote(i18n))
					]))
			]);
	});
var $author$project$Components$Produits$FicheType$View$propre = F3(
	function (i18n, model, fiche) {
		return A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Produits$FicheType$Update$DeLEditeur),
			A3(
				$author$project$Components$Shared$EditeurDeSchema$View$formulaire,
				i18n,
				A3($author$project$Components$Produits$FicheType$View$presentation, i18n, model, fiche),
				model.hP));
	});
var $author$project$I18n$Cles$niveauDeSaisieEtageCatalogue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'niveau-de-saisie.etage.catalogue', _List_Nil, 'Catalogue');
};
var $author$project$I18n$Cles$niveauDeSaisieEtageCatalogueAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'niveau-de-saisie.etage.catalogue.aide', _List_Nil, 'une valeur pour tout le catalogue');
};
var $author$project$I18n$Cles$niveauDeSaisieEtageGamme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'niveau-de-saisie.etage.gamme', _List_Nil, 'Gamme');
};
var $author$project$I18n$Cles$niveauDeSaisieEtageGammeAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'niveau-de-saisie.etage.gamme.aide', _List_Nil, 'une valeur par gamme');
};
var $author$project$I18n$Cles$niveauDeSaisieEtageMarque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'niveau-de-saisie.etage.marque', _List_Nil, 'Marque');
};
var $author$project$I18n$Cles$niveauDeSaisieEtageMarqueAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'niveau-de-saisie.etage.marque.aide', _List_Nil, 'une valeur par marque');
};
var $author$project$I18n$Cles$niveauDeSaisieEtageProduit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'niveau-de-saisie.etage.produit', _List_Nil, 'Produit');
};
var $author$project$I18n$Cles$niveauDeSaisieEtageProduitAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'niveau-de-saisie.etage.produit.aide', _List_Nil, 'une valeur par référence');
};
var $author$project$I18n$Cles$niveauDeSaisieEtageType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'niveau-de-saisie.etage.type', _List_Nil, 'Type');
};
var $author$project$I18n$Cles$niveauDeSaisieEtageTypeAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'niveau-de-saisie.etage.type.aide', _List_Nil, 'une valeur par type de produit');
};
var $author$project$I18n$Cles$niveauDeSaisieEtageTypologie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'niveau-de-saisie.etage.typologie', _List_Nil, 'Typologie');
};
var $author$project$I18n$Cles$niveauDeSaisieEtageTypologieAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'niveau-de-saisie.etage.typologie.aide', _List_Nil, 'une valeur par typologie');
};
var $author$project$Catalogue$Vocabulaire$etageDeSaisie = F2(
	function (i18n, code) {
		switch (code) {
			case 'catalogue':
				return {
					bp: $author$project$I18n$Cles$niveauDeSaisieEtageCatalogueAide(i18n),
					Bl: $author$project$I18n$Cles$niveauDeSaisieEtageCatalogue(i18n)
				};
			case 'typologie':
				return {
					bp: $author$project$I18n$Cles$niveauDeSaisieEtageTypologieAide(i18n),
					Bl: $author$project$I18n$Cles$niveauDeSaisieEtageTypologie(i18n)
				};
			case 'marque':
				return {
					bp: $author$project$I18n$Cles$niveauDeSaisieEtageMarqueAide(i18n),
					Bl: $author$project$I18n$Cles$niveauDeSaisieEtageMarque(i18n)
				};
			case 'gamme':
				return {
					bp: $author$project$I18n$Cles$niveauDeSaisieEtageGammeAide(i18n),
					Bl: $author$project$I18n$Cles$niveauDeSaisieEtageGamme(i18n)
				};
			case 'type':
				return {
					bp: $author$project$I18n$Cles$niveauDeSaisieEtageTypeAide(i18n),
					Bl: $author$project$I18n$Cles$niveauDeSaisieEtageType(i18n)
				};
			default:
				return {
					bp: $author$project$I18n$Cles$niveauDeSaisieEtageProduitAide(i18n),
					Bl: $author$project$I18n$Cles$niveauDeSaisieEtageProduit(i18n)
				};
		}
	});
var $author$project$I18n$Cles$reglagesDuChampRefusAutre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'reglages-du-champ.refus.autre', _List_Nil, 'Les réglages n\'ont pas été enregistrés.');
};
var $author$project$I18n$Cles$reglagesDuChampRefusFige = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'reglages-du-champ.refus.fige',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeurs',
					$author$project$I18n$Traductions$Entier(p.Ki)),
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md)),
					_Utils_Tuple2(
					'exemple',
					$author$project$I18n$Traductions$Chaine(p.yY))
				]),
			((!p.Ki) || (p.Ki === 1)) ? ('Le niveau ne peut plus changer : ' + (A2($author$project$I18n$Nombre$formater, 0, p.Ki) + (' valeur est déjà saisie à l\'étage « ' + (p.md + (' ».' + p.yY))))) : ('Le niveau ne peut plus changer : ' + (A2($author$project$I18n$Nombre$formater, 0, p.Ki) + (' valeurs sont déjà saisies à l\'étage « ' + (p.md + (' ».' + p.yY))))));
	});
var $author$project$I18n$Cles$reglagesDuChampRefusFigeExemple = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'reglages-du-champ.refus.fige-exemple',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'exemple',
					$author$project$I18n$Traductions$Chaine(p.yY))
				]),
			' Par exemple : ' + (p.yY + '.'));
	});
var $author$project$I18n$Cles$reglagesDuChampRefusHorsPortee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'reglages-du-champ.refus.hors-portee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md))
				]),
			'L\'étage « ' + (p.md + ' » est hors de la portée du champ : choisissez un autre étage.'));
	});
var $author$project$Components$Produits$FicheType$View$refusDesReglages = F2(
	function (i18n, reglage) {
		var _v0 = reglage.pZ;
		if (_v0.$ === 1) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var motif = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('refus'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						function () {
							switch (motif.$) {
								case 0:
									var etage = motif.a;
									return A2(
										$author$project$I18n$Cles$reglagesDuChampRefusHorsPortee,
										i18n,
										{
											md: A2($author$project$Catalogue$Vocabulaire$etageDeSaisie, i18n, etage).Bl
										});
								case 1:
									var figee = motif.a;
									return A2(
										$author$project$I18n$Cles$reglagesDuChampRefusFige,
										i18n,
										{
											md: A2($author$project$Catalogue$Vocabulaire$etageDeSaisie, i18n, figee.md).Bl,
											yY: A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													function (exemple) {
														return A2(
															$author$project$I18n$Cles$reglagesDuChampRefusFigeExemple,
															i18n,
															{yY: exemple});
													},
													figee.yY)),
											Ki: figee.Ki
										});
								default:
									return $author$project$I18n$Cles$reglagesDuChampRefusAutre(i18n);
							}
						}())
					]));
		}
	});
var $author$project$Components$Produits$FicheType$View$formulaireDuChamp = F3(
	function (i18n, model, fiche) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$Components$Produits$FicheType$Model$champEnModification, model.hP, fiche),
			model.qd);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var lu = _v0.a.a;
			var etat = _v0.b.a;
			return _Utils_ap(
				A3(
					$author$project$Components$Produits$FicheType$FormulaireDeChamp$formulaire,
					i18n,
					{dD: $author$project$Components$Produits$FicheType$Update$DeLEditeur, zG: $author$project$Components$Produits$FicheType$Update$FiltrableDuChamp, np: $author$project$Components$Produits$FicheType$Update$LectureDuChamp, n4: $author$project$Components$Produits$FicheType$Update$MasqueDuChamp, G1: $author$project$Components$Produits$FicheType$Update$RecherchableDuChamp},
					{
						xS: A2($author$project$Components$Produits$FicheType$ChampDeBibliotheque$droits, etat.dy, fiche),
						gt: etat,
						mC: $author$project$Components$Produits$FicheType$Model$filtrableAdmis(model.hP.zT.JR),
						Dp: fiche.fh.Dj.zX,
						hm: lu.hm,
						ak: A3($author$project$Components$Produits$FicheType$View$presentation, i18n, model, fiche),
						hP: model.hP,
						sf: lu.sf,
						sp: A2(
							$elm$core$Maybe$map,
							function (_v1) {
								return $author$project$Routes$Route$adresseDuChampDeLaBibliotheque(lu.Aq);
							},
							A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierDansLaBibliotheque, lu.nQ))
					}),
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						$rtfeldman$elm_css$Html$Styled$text(''),
						A2(
							$elm$core$Maybe$map,
							$author$project$Components$Produits$FicheType$View$refusDesReglages(i18n),
							model.eO)),
						A4(
						$author$project$Components$Shared$EditeurDeSchema$Resserrage$avertissement,
						i18n,
						0,
						$author$project$Components$Shared$Drawer$Model$idRacine(model.kX),
						model.tq)
					]));
		} else {
			return _Utils_ap(
				A3($author$project$Components$Produits$FicheType$View$propre, i18n, model, fiche),
				_List_fromArray(
					[
						A4(
						$author$project$Components$Shared$EditeurDeSchema$Resserrage$avertissement,
						i18n,
						0,
						$author$project$Components$Shared$Drawer$Model$idRacine(model.kX),
						model.tq)
					]));
		}
	});
var $author$project$I18n$Cles$produitsTypesAjoutRattacherValider = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.ajout.rattacher.valider',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nomDuType',
					$author$project$I18n$Traductions$Chaine(p.Dp))
				]),
			'Rattacher à ' + p.Dp);
	});
var $author$project$I18n$Cles$produitsTypesResserrageEnregistrerQuandMeme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.resserrage.enregistrer-quand-meme', _List_Nil, 'Enregistrer quand même');
};
var $author$project$I18n$Cles$editeurDeSchemaPartageSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.partage.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Champ de « ' + (p.Dj + ' » · rattachement'));
	});
var $author$project$I18n$Cles$editeurDeSchemaPropreSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'editeur-de-schema.propre.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Champ de « ' + (p.Dj + ' » · ne sert qu\'ici'));
	});
var $author$project$I18n$Cles$produitsTypesAjoutFermer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.ajout.fermer', _List_Nil, 'Fermer');
};
var $author$project$I18n$Cles$produitsTypesAjoutHorsPorteePied = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.ajout.hors-portee.pied', _List_Nil, 'Rattachement impossible hors portée');
};
var $author$project$Components$Shared$Bibliotheque$View$piedDeLAjout = F5(
	function (i18n, msgs, mode, enModification, choix) {
		var sansLeDroit = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $author$project$Components$Shared$Bibliotheque$Elargissement$peutElargir, $elm$core$Basics$not),
				$author$project$Components$Shared$Bibliotheque$Rattachement$choisiHorsPortee(choix)));
		var horsPortee = (mode === 1) && ((!enModification) && $author$project$Components$Shared$Bibliotheque$Rattachement$horsPortee(choix));
		return {
			oJ: horsPortee ? $elm$core$Maybe$Just(
				$author$project$I18n$Cles$produitsTypesAjoutHorsPorteePied(i18n)) : $elm$core$Maybe$Nothing,
			HF: function (attributs) {
				return A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_Utils_ap(
						attributs,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								msgs.xU($author$project$Components$Shared$Drawer$Update$Fermer))
							])),
					sansLeDroit ? $author$project$I18n$Cles$produitsTypesAjoutFermer(i18n) : $author$project$I18n$Cles$drawerAnnuler(i18n));
			},
			Jb: _List_Nil
		};
	});
var $author$project$Components$Produits$FicheType$View$piedDeLAjout = F3(
	function (i18n, model, _v0) {
		return A5(
			$author$project$Components$Shared$Bibliotheque$View$piedDeLAjout,
			i18n,
			$author$project$Components$Produits$FicheType$View$messagesDuDrawer,
			model.n9,
			!_Utils_eq(model.hP.lZ, $elm$core$Maybe$Nothing),
			model.pN);
	});
var $author$project$Components$Produits$FicheType$View$sousTitreEtVue = F7(
	function (i18n, enregistre, partage, model, fiche, contenu, drawerModel) {
		var nomDuType = fiche.fh.Dj.zX;
		return (enregistre && $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX)) ? A6(
			$author$project$Components$Shared$Drawer$View$viewAvecPiedLibreEtSousTitre,
			i18n,
			partage ? A2(
				$author$project$I18n$Cles$editeurDeSchemaPartageSousTitre,
				i18n,
				{Dj: nomDuType}) : A2(
				$author$project$I18n$Cles$editeurDeSchemaPropreSousTitre,
				i18n,
				{Dj: nomDuType}),
			A3($author$project$Components$Produits$FicheType$View$piedDeLAjout, i18n, model, fiche),
			$author$project$Components$Produits$FicheType$Update$DuDrawer,
			contenu,
			drawerModel) : A5(
			$author$project$Components$Shared$Drawer$View$viewAvecPiedLibre,
			i18n,
			A3($author$project$Components$Produits$FicheType$View$piedDeLAjout, i18n, model, fiche),
			$author$project$Components$Produits$FicheType$Update$DuDrawer,
			contenu,
			drawerModel);
	});
var $author$project$I18n$Cles$editeurDeSchemaModifierTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'editeur-de-schema.modifier.titre', _List_Nil, 'Modifier le champ');
};
var $author$project$Components$Produits$FicheType$View$titreDuChamp = F2(
	function (i18n, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Cles$editeurDeSchemaModifierTitre(i18n),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				model.hP.lZ));
	});
var $author$project$Components$Produits$FicheType$View$drawer = F3(
	function (i18n, model, fiche) {
		var partage = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.hm;
				},
				A2($author$project$Components$Produits$FicheType$Model$champEnModification, model.hP, fiche)));
		var ouvert = $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) && (!_Utils_eq(
			$author$project$Components$Produits$FicheType$Model$evolution(fiche),
			$elm$core$Maybe$Nothing));
		var enregistre = !_Utils_eq(model.hP.lZ, $elm$core$Maybe$Nothing);
		return A7(
			$author$project$Components$Produits$FicheType$View$sousTitreEtVue,
			i18n,
			enregistre,
			partage,
			model,
			fiche,
			ouvert ? {
				fs: ((model.n9 === 1) && (!enregistre)) ? {
					sR: (!_Utils_eq(model.pN.vd, $elm$core$Maybe$Nothing)) && ((!$author$project$Components$Shared$Bibliotheque$Rattachement$horsPortee(model.pN)) && (!$author$project$Components$Produits$Common$Envoi$enCours(model.l2))),
					Bl: A2(
						$author$project$I18n$Cles$produitsTypesAjoutRattacherValider,
						i18n,
						{Dp: fiche.fh.Dj.zX}),
					C$: $author$project$Components$Produits$FicheType$Update$DrawerValide
				} : {
					sR: !$author$project$Components$Produits$Common$Envoi$enCours(model.l2),
					Bl: function () {
						var _v0 = model.tq;
						if (_v0.$ === 2) {
							return $author$project$I18n$Cles$produitsTypesResserrageEnregistrerQuandMeme(i18n);
						} else {
							return partage ? $author$project$I18n$Cles$editeurDeSchemaPartageValider(i18n) : (enregistre ? $author$project$I18n$Cles$editeurDeSchemaModifierValider(i18n) : $author$project$I18n$Cles$editeurDeSchemaAjouterValider(i18n));
						}
					}(),
					C$: $author$project$Components$Produits$FicheType$Update$DrawerValide
				},
				fZ: enregistre ? A3($author$project$Components$Produits$FicheType$View$formulaireDuChamp, i18n, model, fiche) : A3($author$project$Components$Produits$FicheType$View$entreesDeLAjout, i18n, model, fiche),
				A6: $elm$core$Maybe$Nothing,
				Bc: true,
				h6: enregistre ? A2($author$project$Components$Produits$FicheType$View$titreDuChamp, i18n, model) : $author$project$I18n$Cles$editeurDeSchemaAjouterTitre(i18n)
			} : {
				fs: {sR: false, Bl: '', C$: $author$project$Components$Produits$FicheType$Update$DrawerValide},
				fZ: _List_Nil,
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: ''
			},
			model.kX);
	});
var $author$project$Components$Shared$CollectionsDuType$Update$AjoutConfirme = {$: 8};
var $author$project$I18n$Cles$collectionsTypeAjoutAction = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'collections.type.ajout.action',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Ajouter ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champ')) : ('Ajouter ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champs')));
	});
var $author$project$I18n$Cles$collectionsTypeAjoutCompte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'collections.type.ajout.compte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champ sera ajouté') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champs seront ajoutés'));
	});
var $author$project$I18n$Cles$collectionsTypeAjoutSousTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.type.ajout.sous-titre', _List_Nil, 'Tout ou partie des champs d\'une collection, en un seul geste.');
};
var $author$project$I18n$Cles$collectionsTypeAjoutTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'collections.type.ajout.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Ajouter une collection à « ' + (p.Dj + ' »'));
	});
var $author$project$Components$Shared$CollectionsDuType$Update$CollectionChoisie = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Shared$CollectionsDuType$Update$ModeChoisi = function (a) {
	return {$: 5, a: a};
};
var $author$project$I18n$Cles$collectionsTypeAjoutChamps = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.type.ajout.champs', _List_Nil, 'Champs à ajouter');
};
var $author$project$I18n$Cles$collectionsTypeAjoutCollection = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.type.ajout.collection', _List_Nil, 'Collection');
};
var $author$project$I18n$Cles$collectionsTypeAjoutNiveauTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.type.ajout.niveau-texte', _List_Nil, '« Essentiel » apparaît dans le résumé de la fiche ; « Détail » dans la partie repliable. Réglable champ par champ.');
};
var $author$project$I18n$Cles$collectionsTypeAjoutNiveauTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.type.ajout.niveau-titre', _List_Nil, 'Niveau de lecture');
};
var $author$project$I18n$Cles$collectionsTypeAjoutNote = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'collections.type.ajout.note',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Les fiches existantes de ' + (p.Dj + ' reçoivent les champs vides ; rien n\'est supprimé.'));
	});
var $author$project$I18n$Cles$collectionsTypeAjoutPartie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.type.ajout.partie', _List_Nil, 'Une partie');
};
var $author$project$I18n$Cles$collectionsTypeAjoutRefus = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.type.ajout.refus', _List_Nil, 'L\'ajout n\'a pas pu être fait. La fiche du type vient d\'être relue : reprenez la sélection.');
};
var $author$project$I18n$Cles$collectionsTypeAjoutToute = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.type.ajout.toute', _List_Nil, 'Toute la collection');
};
var $author$project$Components$Shared$CollectionsDuType$Update$ChampBascule = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Shared$CollectionsDuType$Update$NiveauChoisi = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$I18n$Cles$collectionsTypeAjoutDeja = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'collections.type.ajout.deja',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'déjà sur ' + p.Dj);
	});
var $author$project$I18n$Cles$collectionsTypeAjoutDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.type.ajout.detail', _List_Nil, 'Détail');
};
var $author$project$I18n$Cles$collectionsTypeAjoutEssentiel = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.type.ajout.essentiel', _List_Nil, 'Essentiel');
};
var $author$project$Components$Shared$CollectionsDuType$View$unChamp = F4(
	function (i18n, config, ajout, champ) {
		var niveau = A2(
			$elm$core$Maybe$withDefault,
			'essentiel',
			A2($elm$core$Dict$get, champ.Aq, ajout.C9));
		var coche = champ.e6 ? false : ((!ajout.n9) || A2($elm$core$List$member, champ.Aq, ajout.jL));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('champ-a-ajouter'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('deja', champ.e6)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id('collections-type-champ-' + champ.Aq),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(coche),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(champ.e6 || (!ajout.n9)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							config.KD(
								$author$project$Components$Shared$CollectionsDuType$Update$ChampBascule(champ.Aq)))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$for('collections-type-champ-' + champ.Aq),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(champ.Bl)
						])),
					champ.e6 ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('tag'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('deja-sur-le-type')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$collectionsTypeAjoutDeja,
								i18n,
								{Dj: config.Dp}))
						])) : $rtfeldman$elm_css$Html$Styled$text(''),
					$author$project$Components$Shared$Segment$View$view(
					{
						vd: niveau,
						Bi: $author$project$I18n$Cles$collectionsTypeAjoutNiveauTitre(i18n),
						Dj: 'collections-type-niveau-' + champ.Aq,
						Ea: A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Shared$CollectionsDuType$Update$NiveauChoisi(champ.Aq),
							config.KD),
						o_: _List_fromArray(
							[
								{
								vx: 'essentiel',
								Bl: $author$project$I18n$Cles$collectionsTypeAjoutEssentiel(i18n)
							},
								{
								vx: 'detail',
								Bl: $author$project$I18n$Cles$collectionsTypeAjoutDetail(i18n)
							}
							])
					})
				]));
	});
var $author$project$I18n$Cles$collectionsTypeAjoutOption = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'collections.type.ajout.option',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'collection',
					$author$project$I18n$Traductions$Chaine(p.vD)),
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (p.vD + (' · ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champ'))) : (p.vD + (' · ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champs'))));
	});
var $author$project$Components$Shared$CollectionsDuType$View$uneOptionDeCollection = F3(
	function (i18n, choisie, collection) {
		var nombre = $elm$core$List$length(collection.dw);
		return A2(
			$rtfeldman$elm_css$Html$Styled$option,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$value(collection.dy),
					$rtfeldman$elm_css$Html$Styled$Attributes$selected(
					_Utils_eq(collection.dy, choisie.dy))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2(
						$author$project$I18n$Cles$collectionsTypeAjoutOption,
						i18n,
						{vD: collection.Bl, w: nombre}))
				]));
	});
var $author$project$Components$Shared$CollectionsDuType$View$contenuDeLAjout = F5(
	function (i18n, config, collections, ajout, collection) {
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('collections-type-collection')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$collectionsTypeAjoutCollection(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$select,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('collections-type-collection'),
								$rtfeldman$elm_css$Html$Styled$Events$onInput(
								A2($elm$core$Basics$composeR, $author$project$Components$Shared$CollectionsDuType$Update$CollectionChoisie, config.KD))
							]),
						A2(
							$elm$core$List$map,
							A2($author$project$Components$Shared$CollectionsDuType$View$uneOptionDeCollection, i18n, collection),
							collections))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('legende')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$collectionsTypeAjoutChamps(i18n))
							])),
						$author$project$Components$Shared$Segment$View$view(
						{
							vd: (!ajout.n9) ? 'toute' : 'partie',
							Bi: $author$project$I18n$Cles$collectionsTypeAjoutChamps(i18n),
							Dj: 'collections-type-mode',
							Ea: A2($elm$core$Basics$composeR, $author$project$Components$Shared$CollectionsDuType$Update$ModeChoisi, config.KD),
							o_: _List_fromArray(
								[
									{
									vx: 'toute',
									Bl: $author$project$I18n$Cles$collectionsTypeAjoutToute(i18n)
								},
									{
									vx: 'partie',
									Bl: $author$project$I18n$Cles$collectionsTypeAjoutPartie(i18n)
								}
								])
						})
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('champs-a-ajouter')
					]),
				A2(
					$elm$core$List$map,
					A3($author$project$Components$Shared$CollectionsDuType$View$unChamp, i18n, config, ajout),
					collection.dw)),
				A2(
				$author$project$Components$Shared$Note$View$view,
				0,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h3,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$collectionsTypeAjoutNiveauTitre(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$collectionsTypeAjoutNiveauTexte(i18n))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$collectionsTypeAjoutNote,
							i18n,
							{Dj: config.Dp}))
					])),
				ajout.qa ? A2(
				$author$project$Components$Shared$Note$View$view,
				2,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$collectionsTypeAjoutRefus(i18n))
							]))
					])) : $rtfeldman$elm_css$Html$Styled$text(''),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('droit-requis')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(config.xR)
					]))
			]);
	});
var $author$project$Components$Shared$CollectionsDuType$View$drawerDAjout = F4(
	function (i18n, config, collections, model) {
		var nombre = $elm$core$List$length(
			A2($author$project$Components$Shared$CollectionsDuType$Model$champsAAjouter, collections, model));
		return A6(
			$author$project$Components$Shared$Drawer$View$viewAvecPiedLibreEtSousTitre,
			i18n,
			$author$project$I18n$Cles$collectionsTypeAjoutSousTitre(i18n),
			{
				oJ: $elm$core$Maybe$Just(
					A2(
						$author$project$I18n$Cles$collectionsTypeAjoutCompte,
						i18n,
						{w: nombre})),
				HF: function (attributs) {
					return A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_Utils_ap(
							attributs,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									config.KD(
										$author$project$Components$Shared$CollectionsDuType$Update$DuDrawerDAjout($author$project$Components$Shared$Drawer$Update$Fermer)))
								])),
						$author$project$I18n$Cles$drawerAnnuler(i18n));
				},
				Jb: _List_Nil
			},
			function (geste) {
				return config.KD(
					$author$project$Components$Shared$CollectionsDuType$Update$DuDrawerDAjout(geste));
			},
			{
				fs: {
					sR: (nombre > 0) && (!config.cF),
					Bl: A2(
						$author$project$I18n$Cles$collectionsTypeAjoutAction,
						i18n,
						{w: nombre}),
					C$: config.KD($author$project$Components$Shared$CollectionsDuType$Update$AjoutConfirme)
				},
				fZ: function () {
					var _v0 = _Utils_Tuple2(
						model.fw,
						A2($author$project$Components$Shared$CollectionsDuType$Model$collectionDeLAjout, collections, model));
					if ((!_v0.a.$) && (!_v0.b.$)) {
						var ajout = _v0.a.a;
						var collection = _v0.b.a;
						return A5($author$project$Components$Shared$CollectionsDuType$View$contenuDeLAjout, i18n, config, collections, ajout, collection);
					} else {
						return _List_Nil;
					}
				}(),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: A2(
					$author$project$I18n$Cles$collectionsTypeAjoutTitre,
					i18n,
					{Dj: config.Dp})
			},
			model.kY);
	});
var $author$project$Components$Shared$CollectionsDuType$Update$RetraitConfirme = {$: 9};
var $author$project$I18n$Cles$collectionsTypeRetraitAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.type.retrait.action', _List_Nil, 'Retirer la collection');
};
var $author$project$I18n$Cles$collectionsTypeRetraitFermer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.type.retrait.fermer', _List_Nil, 'Fermer');
};
var $author$project$I18n$Cles$collectionsTypeRetraitPied = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.type.retrait.pied', _List_Nil, 'Retrait impossible tant qu\'une valeur existe');
};
var $author$project$I18n$Cles$collectionsTypeRetraitSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'collections.type.retrait.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Du type « ' + (p.Dj + ' ».'));
	});
var $author$project$I18n$Cles$collectionsTypeRetraitTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.type.retrait.titre', _List_Nil, 'Retirer une collection');
};
var $author$project$Components$Shared$CollectionsDuType$View$adresseDesValeurs = F2(
	function (config, champs) {
		return config.s_(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.dy;
				},
				champs));
	});
var $author$project$I18n$Cles$collectionsTypeRetraitAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.type.retrait.aide', _List_Nil, 'Les champs restent dans la bibliothèque et dans la collection.');
};
var $author$project$I18n$Cles$collectionsTypeRetraitAidePartiesPrenantes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.type.retrait.aide-parties-prenantes', _List_Nil, 'Les champs sont masqués sur le type ; ils restent dans la bibliothèque et dans la collection.');
};
var $author$project$I18n$Cles$collectionsTypeRetraitAvecValeurs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'collections.type.retrait.avec-valeurs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champs',
					$author$project$I18n$Traductions$Entier(p.dw)),
					_Utils_Tuple2(
					'valeurs',
					$author$project$I18n$Traductions$Chaine(p.Ki))
				]),
			((!p.dw) || (p.dw === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.dw) + (' champ de cette collection a des valeurs sur des fiches (' + (p.Ki + ').'))) : (A2($author$project$I18n$Nombre$formater, 0, p.dw) + (' champs de cette collection ont des valeurs sur des fiches (' + (p.Ki + ').'))));
	});
var $author$project$I18n$Cles$collectionsTypeRetraitImpossible = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'collections.type.retrait.impossible',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'collection',
					$author$project$I18n$Traductions$Chaine(p.vD)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Impossible de retirer « ' + (p.vD + (' » de « ' + (p.Dj + ' ».'))));
	});
var $author$project$I18n$Cles$collectionsTypeRetraitPossible = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'collections.type.retrait.possible',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'collection',
					$author$project$I18n$Traductions$Chaine(p.vD)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer « ' + (p.vD + (' » de « ' + (p.Dj + ' ».'))));
	});
var $author$project$I18n$Cles$collectionsTypeRetraitSansValeur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'collections.type.retrait.sans-valeur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? 'Le champ est détaché du type. Aucune fiche n\'a de valeur : rien n\'est perdu.' : ('Les ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champs sont détachés du type. Aucune fiche n\'a de valeur : rien n\'est perdu.')));
	});
var $author$project$I18n$Cles$collectionsTypeRetraitSansValeurPartiesPrenantes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'collections.type.retrait.sans-valeur-parties-prenantes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? 'Le champ est masqué sur le type. Aucune fiche n\'a de valeur : rien n\'est perdu.' : ('Les ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champs sont masqués sur le type. Aucune fiche n\'a de valeur : rien n\'est perdu.')));
	});
var $author$project$I18n$Cles$collectionsTypeRetraitValeurs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'collections.type.retrait.valeurs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeur') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeurs'));
	});
var $author$project$I18n$Cles$collectionsTypeRetraitVoirLesValeurs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'collections.type.retrait.voir-les-valeurs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? 'Voir la valeur' : ('Voir les ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeurs')));
	});
var $author$project$Components$Shared$CollectionsDuType$View$unChampARetirer = F2(
	function (i18n, champ) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('champ-a-retirer'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('avec-valeurs', champ.Ki > 0)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(true),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', champ.Bl)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(champ.Bl)
								])),
							$rtfeldman$elm_css$Html$Styled$text(' '),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$collectionsTypeRetraitValeurs,
										i18n,
										{w: champ.Ki}))
								]))
						]))
				]));
	});
var $author$project$Components$Shared$CollectionsDuType$View$contenuDuRetrait = F5(
	function (i18n, config, collections, model, collection) {
		var valeurs = A2($author$project$Components$Shared$CollectionsDuType$Model$valeursDuRetrait, collections, model);
		var champs = A2(
			$elm$core$List$filter,
			function ($) {
				return $.e6;
			},
			collection.dw);
		return _List_fromArray(
			[
				(valeurs > 0) ? A2(
				$author$project$Components$Shared$Note$View$view,
				1,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$collectionsTypeRetraitImpossible,
									i18n,
									{vD: collection.Bl, Dj: config.Dp}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$collectionsTypeRetraitAvecValeurs,
									i18n,
									{
										dw: $elm$core$List$length(
											A2(
												$elm$core$List$filter,
												function (champ) {
													return champ.Ki > 0;
												},
												champs)),
										Ki: A2(
											$author$project$I18n$Cles$collectionsTypeRetraitValeurs,
											i18n,
											{w: valeurs})
									}))
							])),
						function () {
						var _v0 = A2(
							$author$project$Components$Shared$CollectionsDuType$View$adresseDesValeurs,
							config,
							A2(
								$elm$core$List$filter,
								function (champ) {
									return champ.Ki > 0;
								},
								champs));
						if (!_v0.$) {
							var adresse = _v0.a;
							return A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('secondary'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('pale'),
										$rtfeldman$elm_css$Html$Styled$Attributes$href(adresse)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$collectionsTypeRetraitVoirLesValeurs,
											i18n,
											{w: valeurs}))
									]));
						} else {
							return $rtfeldman$elm_css$Html$Styled$text('');
						}
					}()
					])) : A2(
				$author$project$Components$Shared$Note$View$view,
				0,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$collectionsTypeRetraitPossible,
									i18n,
									{vD: collection.Bl, Dj: config.Dp}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								config.eA ? A2(
									$author$project$I18n$Cles$collectionsTypeRetraitSansValeurPartiesPrenantes,
									i18n,
									{
										w: $elm$core$List$length(champs)
									}) : A2(
									$author$project$I18n$Cles$collectionsTypeRetraitSansValeur,
									i18n,
									{
										w: $elm$core$List$length(champs)
									}))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$ul,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('champs-a-retirer')
					]),
				A2(
					$elm$core$List$map,
					$author$project$Components$Shared$CollectionsDuType$View$unChampARetirer(i18n),
					champs)),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						config.eA ? $author$project$I18n$Cles$collectionsTypeRetraitAidePartiesPrenantes(i18n) : $author$project$I18n$Cles$collectionsTypeRetraitAide(i18n))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('droit-requis')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(config.xR)
					]))
			]);
	});
var $author$project$Components$Shared$CollectionsDuType$View$drawerDeRetrait = F4(
	function (i18n, config, collections, model) {
		var versLeDrawer = function (geste) {
			return config.KD(
				$author$project$Components$Shared$CollectionsDuType$Update$DuDrawerDeRetrait(geste));
		};
		var possible = A2($author$project$Components$Shared$CollectionsDuType$Model$retraitPossible, collections, model);
		return A6(
			$author$project$Components$Shared$Drawer$View$viewAvecPiedLibreEtSousTitre,
			i18n,
			A2(
				$author$project$I18n$Cles$collectionsTypeRetraitSousTitre,
				i18n,
				{Dj: config.Dp}),
			{
				oJ: possible ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$I18n$Cles$collectionsTypeRetraitPied(i18n)),
				HF: function (attributs) {
					return A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_Utils_ap(
							attributs,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									versLeDrawer($author$project$Components$Shared$Drawer$Update$Fermer))
								])),
						possible ? $author$project$I18n$Cles$drawerAnnuler(i18n) : $author$project$I18n$Cles$collectionsTypeRetraitFermer(i18n));
				},
				Jb: _List_Nil
			},
			versLeDrawer,
			{
				fs: {
					sR: possible && (!config.cF),
					Bl: $author$project$I18n$Cles$collectionsTypeRetraitAction(i18n),
					C$: config.KD($author$project$Components$Shared$CollectionsDuType$Update$RetraitConfirme)
				},
				fZ: function () {
					var _v0 = A2($author$project$Components$Shared$CollectionsDuType$Model$collectionDuRetrait, collections, model);
					if (!_v0.$) {
						var collection = _v0.a;
						return A5($author$project$Components$Shared$CollectionsDuType$View$contenuDuRetrait, i18n, config, collections, model, collection);
					} else {
						return _List_Nil;
					}
				}(),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$collectionsTypeRetraitTitre(i18n)
			},
			model.lD);
	});
var $author$project$Components$Shared$CollectionsDuType$View$drawers = F4(
	function (i18n, config, collections, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('collections-du-type-drawers')
				]),
			_List_fromArray(
				[
					A4($author$project$Components$Shared$CollectionsDuType$View$drawerDAjout, i18n, config, collections, model),
					A4($author$project$Components$Shared$CollectionsDuType$View$drawerDeRetrait, i18n, config, collections, model)
				]));
	});
var $author$project$I18n$Cles$produitsTypesElargirConfirmation = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.elargir.confirmation',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			'Je confirme : « ' + (p.Bl + ' » devient proposable sur les types de produit.'));
	});
var $author$project$I18n$Cles$referentielTypesElargirConfirmation = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.types.elargir.confirmation',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			'Je confirme : « ' + (p.Bl + ' » devient proposable sur les types de partie prenante.'));
	});
var $author$project$Components$Shared$Bibliotheque$View$confirmation = F3(
	function (i18n, contexte, libelle) {
		var _v0 = contexte.cC;
		if (!_v0) {
			return A2(
				$author$project$I18n$Cles$produitsTypesElargirConfirmation,
				i18n,
				{Bl: libelle});
		} else {
			return A2(
				$author$project$I18n$Cles$referentielTypesElargirConfirmation,
				i18n,
				{Bl: libelle});
		}
	});
var $author$project$I18n$Cles$produitsTypesElargirConsequenceDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.elargir.consequence.detail', _List_Nil, 'Le champ devient proposable sur les types de produit du catalogue, en plus des types de partie prenante. Ses rattachements actuels, ses valeurs et son nom ne bougent pas.');
};
var $author$project$I18n$Cles$referentielTypesElargirConsequenceDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.elargir.consequence.detail', _List_Nil, 'Le champ devient proposable sur les types de partie prenante. Ses rattachements actuels, ses valeurs et son nom ne bougent pas.');
};
var $author$project$Components$Shared$Bibliotheque$View$consequence = F2(
	function (i18n, contexte) {
		var _v0 = contexte.cC;
		if (!_v0) {
			return $author$project$I18n$Cles$produitsTypesElargirConsequenceDetail(i18n);
		} else {
			return $author$project$I18n$Cles$referentielTypesElargirConsequenceDetail(i18n);
		}
	});
var $author$project$I18n$Cles$produitsTypesElargirDroit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.elargir.droit', _List_Nil, 'Droit requis : Paramétrage du catalogue');
};
var $author$project$Components$Shared$Bibliotheque$View$droitRequis = F2(
	function (i18n, contexte) {
		var _v0 = contexte.cC;
		if (!_v0) {
			return $elm$core$Maybe$Just(
				$author$project$I18n$Cles$produitsTypesElargirDroit(i18n));
		} else {
			return $elm$core$Maybe$Just(
				$author$project$I18n$Cles$bibliothequeDefinitionDroitPartiesPrenantes(i18n));
		}
	});
var $author$project$I18n$Cles$produitsTypesElargirUniquement = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.elargir.uniquement',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.Dj + ' uniquement');
	});
var $author$project$Components$Shared$Bibliotheque$Elargissement$porteeActuelle = F2(
	function (i18n, champ) {
		var _v0 = champ.o4;
		if (!_v0.$) {
			var origine = _v0.a;
			return A2(
				$author$project$I18n$Cles$produitsTypesElargirUniquement,
				i18n,
				{Dj: origine.Dj});
		} else {
			return A2($author$project$Components$Shared$Bibliotheque$Vocabulaire$porteeElargie, i18n, champ.F$);
		}
	});
var $author$project$I18n$Cles$produitsTypesElargirActuelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.elargir.actuelle', _List_Nil, 'Actuelle');
};
var $author$project$I18n$Cles$produitsTypesElargirConsequence = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.elargir.consequence', _List_Nil, 'Ce que ça change.');
};
var $author$project$I18n$Cles$produitsTypesElargirPortee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.elargir.portee', _List_Nil, 'Portée');
};
var $author$project$I18n$Cles$produitsTypesElargirProposee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.elargir.proposee', _List_Nil, 'Proposée');
};
var $author$project$I18n$Cles$produitsTypesElargirReduire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.elargir.reduire', _List_Nil, 'La portée pourra être réduite plus tard, tant qu\'aucun rattachement ne sort de la nouvelle portée.');
};
var $author$project$I18n$Cles$produitsTypesElargirRefus = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.elargir.refus', _List_Nil, 'La portée n\'a pas pu être élargie.');
};
var $author$project$I18n$Cles$produitsTypesElargirSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.elargir.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			'« ' + (p.Bl + ' », champ de la bibliothèque.'));
	});
var $author$project$I18n$Cles$produitsTypesElargirTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.elargir.titre', _List_Nil, 'Élargir la portée');
};
var $author$project$I18n$Cles$produitsTypesElargirValider = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.elargir.valider', _List_Nil, 'Élargir la portée');
};
var $author$project$Components$Shared$Bibliotheque$View$elargir = F6(
	function (i18n, contexte, msgs, enCours, elargissement, drawerModel) {
		var vide = {
			fs: {sR: false, Bl: '', C$: msgs.Kv},
			fZ: _List_Nil,
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: ''
		};
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(drawerModel);
		var contenu = function () {
			if (!elargissement.$) {
				var courant = elargissement.a;
				var lu = courant.uN;
				return _Utils_update(
					vide,
					{
						fs: {
							sR: courant.dB && (!enCours),
							Bl: $author$project$I18n$Cles$produitsTypesElargirValider(i18n),
							C$: msgs.Kv
						},
						fZ: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$produitsTypesElargirSousTitre,
											i18n,
											{Bl: lu.Bl}))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$produitsTypesElargirPortee(i18n))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('portees')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('portee'),
														$rtfeldman$elm_css$Html$Styled$Attributes$class('actuelle')
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$produitsTypesElargirActuelle(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$strong,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																A2($author$project$Components$Shared$Bibliotheque$Elargissement$porteeActuelle, i18n, lu))
															]))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('fleche'),
														A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('›')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('portee'),
														$rtfeldman$elm_css$Html$Styled$Attributes$class('proposee')
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$produitsTypesElargirProposee(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$strong,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																A2(
																	$author$project$Components$Shared$Bibliotheque$Vocabulaire$porteeElargie,
																	i18n,
																	A2($author$project$Components$Shared$Bibliotheque$Elargissement$porteeProposee, contexte.cC, lu)))
															]))
													]))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('consequence')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$strong,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$produitsTypesElargirConsequence(i18n))
											])),
										$rtfeldman$elm_css$Html$Styled$text(' '),
										$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$Components$Shared$Bibliotheque$View$consequence, i18n, contexte)),
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$produitsTypesElargirReduire(i18n))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('confirmation-de-l-elargissement')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Champ$View$caseACocher,
										{
											go: $elm$core$Maybe$Nothing,
											Aq: prefixe + '-confirmation',
											Bl: A3($author$project$Components$Shared$Bibliotheque$View$confirmation, i18n, contexte, lu.Bl),
											he: false
										},
										{vt: courant.dB, D9: msgs.j7})
									])),
								courant.qa ? A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('refus'),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsTypesElargirRefus(i18n))
									])) : $rtfeldman$elm_css$Html$Styled$text('')
							]),
						h6: $author$project$I18n$Cles$produitsTypesElargirTitre(i18n)
					});
			} else {
				return vide;
			}
		}();
		return A5(
			$author$project$Components$Shared$Drawer$View$viewAvecPiedLibre,
			i18n,
			{
				oJ: A2($author$project$Components$Shared$Bibliotheque$View$droitRequis, i18n, contexte),
				HF: function (attributs) {
					return A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_Utils_ap(
							attributs,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									msgs.xV($author$project$Components$Shared$Drawer$Update$Fermer))
								])),
						$author$project$I18n$Cles$drawerAnnuler(i18n));
				},
				Jb: _List_Nil
			},
			msgs.xV,
			contenu,
			drawerModel);
	});
var $author$project$Components$Produits$FicheType$View$elargir = F3(
	function (i18n, model, fiche) {
		return A6(
			$author$project$Components$Shared$Bibliotheque$View$elargir,
			i18n,
			A2($author$project$Components$Produits$FicheType$View$contexteDuDrawer, model, fiche),
			$author$project$Components$Produits$FicheType$View$messagesDuDrawer,
			$author$project$Components$Produits$Common$Envoi$enCours(model.l2),
			model.lP,
			model.lx);
	});
var $author$project$I18n$Cles$produitsTypesFicheResumeOffres = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.fiche.resume.offres',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' offre') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' offres'));
	});
var $author$project$Catalogue$Vocabulaire$nombreDeReferencesDUnType = F3(
	function (i18n, code, nombre) {
		return (code === 'service') ? A2(
			$author$project$I18n$Cles$produitsTypesFicheResumeOffres,
			i18n,
			{w: nombre}) : A2(
			$author$project$I18n$Cles$produitsCatalogueReferences,
			i18n,
			{w: nombre});
	});
var $author$project$I18n$Cles$ordreDesBlocsCeType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'ordre-des-blocs.ce-type', _List_Nil, 'Ce type');
};
var $author$project$I18n$Cles$ordreDesBlocsPiedType = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'ordre-des-blocs.pied-type',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Valable pour les fiches de ' + p.Dj);
	});
var $author$project$I18n$Cles$produitsTypesArchivage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.archivage', _List_Nil, 'Archiver la catégorie');
};
var $author$project$I18n$Cles$produitsTypesArchive = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.archive', _List_Nil, 'Archivé');
};
var $author$project$I18n$Cles$produitsTypesFicheResume = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.fiche.resume',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'references',
					$author$project$I18n$Traductions$Chaine(p.hD))
				]),
			'Catégorie · ' + p.hD);
	});
var $author$project$I18n$Cles$produitsTypesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.titre', _List_Nil, 'Catégories');
};
var $author$project$I18n$Cles$produitsTypesVersion = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.version',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'version',
					$author$project$I18n$Traductions$Chaine(p.sq))
				]),
			'v' + p.sq);
	});
var $author$project$I18n$Cles$produitsTypesVersionsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.versions.titre', _List_Nil, 'Historique des versions');
};
var $author$project$Components$Produits$FicheType$Update$ReglagesEnregistres = {$: 29};
var $author$project$Components$Produits$FicheType$Update$ExigenceReglee = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$Produits$FicheType$Update$LectureReglee = function (a) {
	return {$: 27, a: a};
};
var $author$project$Components$Produits$FicheType$Update$SaisieReglee = function (a) {
	return {$: 28, a: a};
};
var $author$project$Components$Produits$FicheType$Update$ValeursPoseesDemandees = function (a) {
	return {$: 42, a: a};
};
var $author$project$Catalogue$Vocabulaire$etageDeSaisieParDefaut = 'produit';
var $author$project$Catalogue$Vocabulaire$etagesDeSaisie = _List_fromArray(
	['catalogue', 'typologie', 'marque', 'gamme', 'type', 'produit']);
var $author$project$Components$Produits$FicheType$Reglages$etages = F2(
	function (i18n, actuel) {
		return A2(
			$elm$core$List$map,
			function (code) {
				var mots = A2($author$project$Catalogue$Vocabulaire$etageDeSaisie, i18n, code);
				return {
					bp: mots.bp,
					vx: code,
					f5: _Utils_eq(code, $author$project$Catalogue$Vocabulaire$etageDeSaisieParDefaut),
					Ao: !A2($elm$core$List$member, code, actuel.yH),
					Bl: mots.Bl
				};
			},
			$author$project$Catalogue$Vocabulaire$etagesDeSaisie);
	});
var $author$project$Catalogue$Vocabulaire$exigenceDuReglage = F2(
	function (i18n, code) {
		switch (code) {
			case 'a-l-enregistrement':
				return $author$project$I18n$Cles$reglagesDuChampExigenceALEnregistrement(i18n);
			case 'a-la-publication':
				return $author$project$I18n$Cles$reglagesDuChampExigenceALaPublication(i18n);
			default:
				return $author$project$I18n$Cles$reglagesDuChampExigenceFacultative(i18n);
		}
	});
var $author$project$Components$Produits$FicheType$Update$RestrictionDemandee = function (a) {
	return {$: 30, a: a};
};
var $author$project$Components$Produits$FicheType$RestrictionDuChamp$nombreRetenues = F2(
	function (cle, fiche) {
		return $elm$core$List$length(
			A2($author$project$Components$Produits$FicheType$RestrictionDuChamp$retenuesDe, cle, fiche));
	});
var $author$project$I18n$Cles$produitsTypesRestrictionAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.restriction.aucune', _List_Nil, 'Aucune restriction : toutes les valeurs de la liste.');
};
var $author$project$I18n$Cles$produitsTypesRestrictionLigne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.restriction.ligne', _List_Nil, 'Restriction');
};
var $author$project$I18n$Cles$produitsTypesRestrictionModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.restriction.modifier', _List_Nil, 'Modifier la restriction…');
};
var $author$project$I18n$Cles$produitsTypesRestrictionPoser = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.restriction.poser', _List_Nil, 'Restreindre les valeurs…');
};
var $author$project$I18n$Cles$produitsTypesRestrictionRetenues = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.restriction.retenues',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'retenues',
					$author$project$I18n$Traductions$Entier(p.hN))
				]),
			((!p.hN) || (p.hN === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.hN) + ' valeur retenue') : (A2($author$project$I18n$Nombre$formater, 0, p.hN) + ' valeurs retenues'));
	});
var $author$project$Components$Produits$FicheType$View$ligneDeRestriction = F3(
	function (i18n, fiche, reglage) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (lu) {
				return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$restreindreLesValeurs, lu.nQ);
			},
			A2($author$project$Components$Produits$FicheType$Model$champ, reglage.dy, fiche));
		if (!_v0.$) {
			var retenues = A2($author$project$Components$Produits$FicheType$RestrictionDuChamp$nombreRetenues, reglage.dy, fiche);
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsTypesRestrictionLigne(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('champ')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								(!retenues) ? $author$project$I18n$Cles$produitsTypesRestrictionAucune(i18n) : A2(
									$author$project$I18n$Cles$produitsTypesRestrictionRetenues,
									i18n,
									{hN: retenues}))
							])),
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Produits$FicheType$Update$RestrictionDemandee(reglage.dy))
							]),
						(!retenues) ? $author$project$I18n$Cles$produitsTypesRestrictionPoser(i18n) : $author$project$I18n$Cles$produitsTypesRestrictionModifier(i18n))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$reglagesDuChampLectureDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'reglages-du-champ.lecture.detail', _List_Nil, 'Détail : affiché dans la partie repliable');
};
var $author$project$I18n$Cles$reglagesDuChampLectureEssentiel = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'reglages-du-champ.lecture.essentiel', _List_Nil, 'Essentiel : affiché dans le résumé de la fiche');
};
var $author$project$Catalogue$Vocabulaire$niveauDeLecture = F2(
	function (i18n, code) {
		if (code === 'detail') {
			return $author$project$I18n$Cles$reglagesDuChampLectureDetail(i18n);
		} else {
			return $author$project$I18n$Cles$reglagesDuChampLectureEssentiel(i18n);
		}
	});
var $author$project$I18n$Cles$niveauDeSaisieTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'niveau-de-saisie.titre', _List_Nil, 'Niveau de saisie');
};
var $author$project$Catalogue$Vocabulaire$niveauxDeLecture = _List_fromArray(
	['essentiel', 'detail']);
var $author$project$I18n$Cles$reglagesDuChampChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'reglages-du-champ.champ', _List_Nil, 'Champ');
};
var $author$project$I18n$Cles$reglagesDuChampDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'reglages-du-champ.detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN)),
					_Utils_Tuple2(
					'nomDuType',
					$author$project$I18n$Traductions$Chaine(p.Dp))
				]),
			'« ' + (p.uN + (' » sur le type ' + (p.Dp + '.'))));
	});
var $author$project$I18n$Cles$reglagesDuChampEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'reglages-du-champ.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$reglagesDuChampExigence = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'reglages-du-champ.exigence', _List_Nil, 'Exigence');
};
var $author$project$I18n$Cles$reglagesDuChampLecture = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'reglages-du-champ.lecture', _List_Nil, 'Niveau de lecture');
};
var $author$project$I18n$Cles$reglagesDuChampRattache = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'reglages-du-champ.rattache',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nomDuType',
					$author$project$I18n$Traductions$Chaine(p.Dp))
				]),
			'Rattaché au type « ' + (p.Dp + ' ». Le nom et les valeurs se règlent dans la bibliothèque.'));
	});
var $author$project$I18n$Cles$reglagesDuChampTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'reglages-du-champ.titre', _List_Nil, 'Réglages du champ');
};
var $author$project$Components$Produits$FicheType$Reglages$verrou = F2(
	function (voir, actuel) {
		return actuel.zC ? $elm$core$Maybe$Just(
			{Ki: actuel.Kp, KT: voir}) : $elm$core$Maybe$Nothing;
	});
var $author$project$I18n$Cles$niveauDeSaisieAideDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'niveau-de-saisie.aide.detail', _List_Nil, 'La valeur se saisit une seule fois, sur la fiche de l\'étage choisi. Elle est ensuite héritée vers le bas, sans ressaisie.');
};
var $author$project$I18n$Cles$niveauDeSaisieAideHorsPortee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'niveau-de-saisie.aide.hors-portee', _List_Nil, 'Les étages grisés sont hors de la portée du champ : ils ne se choisissent pas. Pour les ouvrir, élargir la portée dans la bibliothèque.');
};
var $author$project$I18n$Cles$niveauDeSaisieAideTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'niveau-de-saisie.aide.titre', _List_Nil, 'Ce que ce réglage change.');
};
var $author$project$I18n$Cles$niveauDeSaisieChaineSaisie = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'niveau-de-saisie.chaine.saisie',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md))
				]),
			p.md + ' : saisie');
	});
var $author$project$I18n$Cles$niveauDeSaisieFigeNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'niveau-de-saisie.fige.note', _List_Nil, 'Tant que des valeurs sont saisies à cet étage, le choix reste figé. Les autres réglages (exigence, lecture) restent modifiables.');
};
var $author$project$I18n$Cles$niveauDeSaisiePortails = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'niveau-de-saisie.portails', _List_Nil, 'Portails');
};
var $author$project$Components$Shared$NiveauDeSaisie$View$aide = F2(
	function (i18n, config) {
		var suivants = A3(
			$elm$core$List$foldl,
			F2(
				function (etage, _v1) {
					var trouve = _v1.a;
					var acc = _v1.b;
					return trouve ? _Utils_Tuple2(
						true,
						_Utils_ap(
							acc,
							_List_fromArray(
								[etage.Bl]))) : _Utils_Tuple2(
						_Utils_eq(etage.vx, config.vd),
						acc);
				}),
			_Utils_Tuple2(false, _List_Nil),
			config.yG).b;
		var choisiLibelle = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (e) {
							return _Utils_eq(e.vx, config.vd);
						},
						config.yG))));
		var _v0 = config.Ky;
		if (!_v0.$) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('aide'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$niveauDeSaisieFigeNote(i18n))
					]));
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$niveauDeSaisieAideTitre(i18n))
									])),
								$rtfeldman$elm_css$Html$Styled$text(' '),
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$niveauDeSaisieAideDetail(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('chaine')
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('maillon'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('courant')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$niveauDeSaisieChaineSaisie,
											i18n,
											{md: choisiLibelle}))
									])),
							A2(
								$elm$core$List$concatMap,
								function (libelle) {
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$i,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('›')
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('maillon')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(libelle)
												]))
										]);
								},
								_Utils_ap(
									suivants,
									_List_fromArray(
										[
											$author$project$I18n$Cles$niveauDeSaisiePortails(i18n)
										]))))),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$niveauDeSaisieAideHorsPortee(i18n))
							]))
					]));
		}
	});
var $author$project$I18n$Cles$niveauDeSaisieChoisi = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'niveau-de-saisie.choisi', _List_Nil, 'choisi');
};
var $author$project$I18n$Cles$niveauDeSaisieDefaut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'niveau-de-saisie.defaut', _List_Nil, 'par défaut');
};
var $author$project$I18n$Cles$niveauDeSaisieHorsPortee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'niveau-de-saisie.hors-portee', _List_Nil, 'hors portée du champ');
};
var $author$project$I18n$Cles$niveauDeSaisieVerrouille = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'niveau-de-saisie.verrouille', _List_Nil, 'verrouillé');
};
var $author$project$Components$Shared$NiveauDeSaisie$View$etiquette = F4(
	function (i18n, fige, choisi, etage) {
		return etage.Ao ? A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('etiquette'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$I18n$Cles$niveauDeSaisieHorsPortee(i18n))
				])) : ((choisi && fige) ? A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('etiquette'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('verrouille')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$I18n$Cles$niveauDeSaisieVerrouille(i18n))
				])) : ((choisi && (!etage.f5)) ? A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('etiquette'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('choisi')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$I18n$Cles$niveauDeSaisieChoisi(i18n))
				])) : (etage.f5 ? A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('etiquette'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('defaut')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$I18n$Cles$niveauDeSaisieDefaut(i18n))
				])) : $rtfeldman$elm_css$Html$Styled$text(''))));
	});
var $author$project$Components$Shared$NiveauDeSaisie$View$unEtage = F3(
	function (i18n, config, etage) {
		var fige = !_Utils_eq(config.Ky, $elm$core$Maybe$Nothing);
		var choisi = _Utils_eq(etage.vx, config.vd);
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('etage'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					choisi ? 'on' : ''),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					etage.Ao ? 'hors-portee' : ''),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					(fige && choisi) ? 'fige' : '')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
							$rtfeldman$elm_css$Html$Styled$Attributes$name(config.Dj),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(etage.vx),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(choisi),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(etage.Ao || fige),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							config.Ea(etage.vx))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(etage.Bl)
								])),
							(choisi && fige) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aide-etage')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(etage.bp)
								]))
						])),
					A4($author$project$Components$Shared$NiveauDeSaisie$View$etiquette, i18n, fige, choisi, etage)
				]));
	});
var $author$project$I18n$Cles$niveauDeSaisieFigeDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'niveau-de-saisie.fige.detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeur est déjà saisie pour ce champ à cet étage. Changer d\'étage ferait perdre ou contredire ces valeurs.') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeurs sont déjà saisies pour ce champ à cet étage. Changer d\'étage ferait perdre ou contredire ces valeurs.'));
	});
var $author$project$I18n$Cles$niveauDeSaisieFigeIssueApres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'niveau-de-saisie.fige.issue.apres', _List_Nil, ', les retirer, puis revenir ici.');
};
var $author$project$I18n$Cles$niveauDeSaisieFigeIssueAvant = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'niveau-de-saisie.fige.issue.avant', _List_Nil, 'Pour changer d\'étage :');
};
var $author$project$I18n$Cles$niveauDeSaisieFigeLien = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'niveau-de-saisie.fige.lien',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? 'voir la valeur' : ('voir les ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeurs')));
	});
var $author$project$I18n$Cles$niveauDeSaisieFigeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'niveau-de-saisie.fige.titre', _List_Nil, 'Le niveau ne peut plus changer.');
};
var $author$project$Components$Shared$NiveauDeSaisie$View$verrouillage = F2(
	function (i18n, verrou) {
		if (!verrou.$) {
			var v = verrou.a;
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('verrou'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'note')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$niveauDeSaisieFigeTitre(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$niveauDeSaisieFigeDetail,
										i18n,
										{w: v.Ki}))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('issue')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$niveauDeSaisieFigeIssueAvant(i18n)),
									$rtfeldman$elm_css$Html$Styled$text(' '),
									function () {
									var _v1 = v.KT;
									if (!_v1.$) {
										var geste = _v1.a;
										return A2(
											$rtfeldman$elm_css$Html$Styled$button,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
													$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
													$rtfeldman$elm_css$Html$Styled$Attributes$id(geste.Aq),
													$rtfeldman$elm_css$Html$Styled$Events$onClick(geste.C$)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$author$project$I18n$Cles$niveauDeSaisieFigeLien,
														i18n,
														{w: v.Ki}))
												]));
									} else {
										return $rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$niveauDeSaisieFigeLien,
												i18n,
												{w: v.Ki}));
									}
								}(),
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$niveauDeSaisieFigeIssueApres(i18n))
								]))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Shared$NiveauDeSaisie$View$view = F2(
	function (i18n, config) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('niveau-de-saisie'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					_Utils_eq(config.Ky, $elm$core$Maybe$Nothing) ? 'libre' : 'fige')
				]),
			_Utils_ap(
				A2($author$project$Components$Shared$NiveauDeSaisie$View$verrouillage, i18n, config.Ky),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('etages'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'radiogroup'),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									$author$project$I18n$Cles$niveauDeSaisieTitre(i18n))
								]),
							A2(
								$elm$core$List$map,
								A2($author$project$Components$Shared$NiveauDeSaisie$View$unEtage, i18n, config),
								config.yG))
						]),
					_List_fromArray(
						[
							A2($author$project$Components$Shared$NiveauDeSaisie$View$aide, i18n, config)
						]))));
	});
var $author$project$Components$Produits$FicheType$View$corpsDesReglages = F6(
	function (i18n, model, fiche, reglage, lu, actuel) {
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.lA);
		var nomDuType = fiche.fh.Dj.zX;
		return {
			fs: {
				sR: (!_Utils_eq(
					A2($author$project$Components$Produits$FicheType$Reglages$commandes, reglage, fiche),
					_List_Nil)) && (!$author$project$Components$Produits$Common$Envoi$enCours(model.l2)),
				Bl: $author$project$I18n$Cles$reglagesDuChampEnregistrer(i18n),
				C$: $author$project$Components$Produits$FicheType$Update$ReglagesEnregistres
			},
			fZ: _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$reglagesDuChampDetail,
								i18n,
								{uN: lu.uN.Bl, Dp: nomDuType}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$reglagesDuChampChamp(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('champ')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(lu.uN.Bl)
										])),
									A2(
									$author$project$Components$Shared$Tag$View$view,
									3,
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$I18n$Cles$editeurDeSchemaTypeInconnu(i18n),
										A2(
											$elm$core$Maybe$map,
											$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeCourt(i18n),
											lu.JR)))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$reglagesDuChampRattache,
										i18n,
										{Dp: nomDuType}))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$reglagesDuChampExigence(i18n))
								])),
							$author$project$Components$Shared$Segment$View$view(
							{
								vd: reglage.mo,
								Bi: $author$project$I18n$Cles$reglagesDuChampExigence(i18n),
								Dj: prefixe + '-exigence',
								Ea: $author$project$Components$Produits$FicheType$Update$ExigenceReglee,
								o_: A2(
									$elm$core$List$map,
									function (code) {
										return {
											vx: code,
											Bl: A2($author$project$Catalogue$Vocabulaire$exigenceDuReglage, i18n, code)
										};
									},
									_List_fromArray(
										[$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceFacultative, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceALEnregistrement, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceALaPublication]))
							})
						])),
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: prefixe + '-lecture',
						Bl: $author$project$I18n$Cles$reglagesDuChampLecture(i18n),
						he: false
					},
					{
						hg: $author$project$Components$Produits$FicheType$Update$LectureReglee,
						o_: A2(
							$elm$core$List$map,
							function (code) {
								return {
									Bl: A2($author$project$Catalogue$Vocabulaire$niveauDeLecture, i18n, code),
									fm: code
								};
							},
							$author$project$Catalogue$Vocabulaire$niveauxDeLecture),
						fm: reglage.np
					}),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$niveauDeSaisieTitre(i18n))
								])),
							A2(
							$author$project$Components$Shared$NiveauDeSaisie$View$view,
							i18n,
							{
								vd: reglage.hP,
								yG: A2($author$project$Components$Produits$FicheType$Reglages$etages, i18n, actuel),
								Dj: prefixe + '-saisie',
								Ea: $author$project$Components$Produits$FicheType$Update$SaisieReglee,
								Ky: A2(
									$author$project$Components$Produits$FicheType$Reglages$verrou,
									A2(
										$elm$core$Maybe$map,
										function (_v0) {
											return {
												Aq: $author$project$Components$Produits$FicheType$Model$idDeLOuvreurDesValeursPosees,
												C$: $author$project$Components$Produits$FicheType$Update$ValeursPoseesDemandees(reglage.dy)
											};
										},
										A2($author$project$Components$Produits$FicheType$ValeursPosees$demander, reglage.dy, fiche)),
									actuel)
							}),
							A2($author$project$Components$Produits$FicheType$View$refusDesReglages, i18n, reglage)
						])),
					A3($author$project$Components$Produits$FicheType$View$ligneDeRestriction, i18n, fiche, reglage)
				]),
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: $author$project$I18n$Cles$reglagesDuChampTitre(i18n)
		};
	});
var $author$project$Components$Produits$FicheType$View$reglages = F3(
	function (i18n, model, fiche) {
		var vide = {
			fs: {sR: false, Bl: '', C$: $author$project$Components$Produits$FicheType$Update$ReglagesEnregistres},
			fZ: _List_Nil,
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: ''
		};
		var contenu = function () {
			var _v0 = _Utils_Tuple2(
				model.eO,
				A2(
					$elm$core$Maybe$andThen,
					function (r) {
						return A2($author$project$Components$Produits$FicheType$Model$champ, r.dy, fiche);
					},
					model.eO));
			if ((!_v0.a.$) && (!_v0.b.$)) {
				var reglage = _v0.a.a;
				var lu = _v0.b.a;
				var _v1 = A2($author$project$Components$Produits$FicheType$Reglages$rattachement, reglage.dy, fiche);
				if (!_v1.$) {
					var actuel = _v1.a;
					return A6($author$project$Components$Produits$FicheType$View$corpsDesReglages, i18n, model, fiche, reglage, lu, actuel);
				} else {
					return vide;
				}
			} else {
				return vide;
			}
		}();
		return A4($author$project$Components$Shared$Drawer$View$view, i18n, $author$project$Components$Produits$FicheType$Update$DuDrawerDesReglages, contenu, model.lA);
	});
var $author$project$Components$Produits$FicheType$Update$ChampMasqueDepuisLaRestriction = {$: 40};
var $author$project$Components$Produits$FicheType$Update$RestrictionEnregistree = {$: 38};
var $author$project$Components$Produits$FicheType$Update$RestrictionLevee = {$: 39};
var $author$project$Components$Produits$FicheType$Update$ToutCoche = {$: 36};
var $author$project$Components$Produits$FicheType$Update$ToutDecoche = {$: 37};
var $author$project$Components$Produits$FicheType$Update$ValeurCochee = F2(
	function (a, b) {
		return {$: 35, a: a, b: b};
	});
var $author$project$Components$Produits$FicheType$RestrictionDuChamp$peutLever = F2(
	function (enCours, fiche) {
		return (!_Utils_eq(
			A2($author$project$Components$Produits$FicheType$RestrictionDuChamp$retenuesDe, enCours.dy, fiche),
			_List_Nil)) && (!_Utils_eq(
			A2($author$project$Components$Produits$FicheType$RestrictionDuChamp$lever, enCours, fiche),
			$elm$core$Maybe$Nothing));
	});
var $author$project$Components$Produits$FicheType$RestrictionDuChamp$peutMasquer = F2(
	function (enCours, fiche) {
		return !_Utils_eq(
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nQ;
					},
					$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$masquerUnChamp)),
				A2($author$project$Components$Produits$FicheType$RestrictionDuChamp$champDe, enCours.dy, fiche)),
			$elm$core$Maybe$Nothing);
	});
var $author$project$I18n$Cles$produitsTypesRestrictionDroit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.restriction.droit', _List_Nil, 'Droit requis : Paramétrage du catalogue');
};
var $author$project$Components$Shared$Bibliotheque$RestrictionView$view = function (i18n) {
	return A2($author$project$Components$Shared$Bibliotheque$RestrictionView$viewSousUnParent, i18n, $elm$core$Maybe$Nothing);
};
var $author$project$Components$Produits$FicheType$View$restriction = F3(
	function (i18n, model, fiche) {
		return A5(
			$author$project$Components$Shared$Bibliotheque$RestrictionView$view,
			i18n,
			{
				xP: $author$project$I18n$Cles$produitsTypesRestrictionDroit(i18n),
				yj: $author$project$Components$Produits$Common$Envoi$enCours(model.l2),
				E$: false,
				Fm: A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (r) {
							return A2($author$project$Components$Produits$FicheType$RestrictionDuChamp$peutLever, r, fiche);
						},
						model.al)),
				Fn: A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (r) {
							return A2($author$project$Components$Produits$FicheType$RestrictionDuChamp$peutMasquer, r, fiche);
						},
						model.al))
			},
			{vw: $author$project$Components$Produits$FicheType$Update$ValeurCochee, xU: $author$project$Components$Produits$FicheType$Update$DuDrawerRestriction, Bj: $author$project$Components$Produits$FicheType$Update$RestrictionLevee, Cc: $author$project$Components$Produits$FicheType$Update$ChampMasqueDepuisLaRestriction, HV: $author$project$Components$Produits$FicheType$Update$RestrictionEnregistree, JI: $author$project$Components$Produits$FicheType$Update$ToutCoche, JJ: $author$project$Components$Produits$FicheType$Update$ToutDecoche},
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.gt;
				},
				model.al),
			model.lC);
	});
var $author$project$Components$Produits$FicheType$Update$RetraitConfirme = {$: 18};
var $author$project$I18n$Cles$produitsValeursCategorieTypologieRetirerArbre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.categorie.typologie.retirer.arbre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Elle quitte aussi ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' emplacement de l\'arbre')) : ('Elle quitte aussi ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' emplacements de l\'arbre')));
	});
var $author$project$Components$Produits$FicheType$View$cheminsRetires = F3(
	function (i18n, model, fiche) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (typologie) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (e) {
							return _Utils_eq(e.r3, typologie);
						},
						fiche.ye));
			},
			model.dh);
		if (!_v0.$) {
			var emplacement = _v0.a;
			return $elm$core$List$isEmpty(emplacement.u9) ? _List_Nil : _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Note$View$view,
					1,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$produitsValeursCategorieTypologieRetirerArbre,
										i18n,
										{
											w: $elm$core$List$length(emplacement.u9)
										}))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									function () {
										var _v1 = A2(
											$elm$core$List$filter,
											A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not),
											emplacement.u9);
										if (!_v1.b) {
											return '';
										} else {
											var chemins = _v1;
											return A2($elm$core$String$join, ', ', chemins) + '.';
										}
									}())
								]))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$I18n$Cles$produitsValeursCategorieTypologieRetirerConfirmation = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.categorie.typologie.retirer.confirmation',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Sa ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' référence redevient à ranger ; vous pourrez ranger la catégorie dans une autre typologie.')) : ('Ses ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' références redeviennent à ranger ; vous pourrez ranger la catégorie dans une autre typologie.')));
	});
var $author$project$I18n$Cles$produitsValeursCategorieTypologieRetirerConfirmationSansnombre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.categorie.typologie.retirer.confirmation.sansnombre', _List_Nil, 'Ses références redeviennent à ranger ; vous pourrez ranger la catégorie dans une autre typologie.');
};
var $author$project$I18n$Cles$produitsValeursCategorieTypologieRetirerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.categorie.typologie.retirer.titre', _List_Nil, 'Retirer la catégorie de sa typologie');
};
var $author$project$I18n$Cles$produitsValeursCategorieTypologieRetirerValider = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.categorie.typologie.retirer.valider', _List_Nil, 'Retirer de la typologie');
};
var $author$project$I18n$Cles$produitsValeursCategorieTypologieRetirer = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.categorie.typologie.retirer',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer de la typologie ' + p.Dj);
	});
var $author$project$Components$Produits$FicheType$View$typologieVisee = F3(
	function (i18n, model, fiche) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (emplacement) {
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('typologie-visee')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$produitsValeursCategorieTypologieRetirer,
												i18n,
												{Dj: emplacement.Dj}))
										]))
								]))
						]);
				},
				A2(
					$elm$core$Maybe$andThen,
					function (typologie) {
						return $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (e) {
									return _Utils_eq(e.r3, typologie);
								},
								fiche.ye));
					},
					model.dh)));
	});
var $author$project$Components$Produits$FicheType$View$retrait = F3(
	function (i18n, model, fiche) {
		var references = fiche.fh.hD;
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Produits$FicheType$Update$DuRetrait,
			$author$project$Components$Shared$Drawer$Model$estOuvert(model.eW) ? {
				fs: {
					sR: !$author$project$Components$Produits$Common$Envoi$enCours(model.l2),
					Bl: $author$project$I18n$Cles$produitsValeursCategorieTypologieRetirerValider(i18n),
					C$: $author$project$Components$Produits$FicheType$Update$RetraitConfirme
				},
				fZ: _Utils_ap(
					A3($author$project$Components$Produits$FicheType$View$typologieVisee, i18n, model, fiche),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									(references > 0) ? A2(
										$author$project$I18n$Cles$produitsValeursCategorieTypologieRetirerConfirmation,
										i18n,
										{w: references}) : $author$project$I18n$Cles$produitsValeursCategorieTypologieRetirerConfirmationSansnombre(i18n))
								])),
						A3($author$project$Components$Produits$FicheType$View$cheminsRetires, i18n, model, fiche))),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$produitsValeursCategorieTypologieRetirerTitre(i18n)
			} : {
				fs: {sR: false, Bl: '', C$: $author$project$Components$Produits$FicheType$Update$RetraitConfirme},
				fZ: _List_Nil,
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: ''
			},
			model.eW);
	});
var $author$project$Components$Produits$FicheType$RegleDeCode$Ouvrir = {$: 0};
var $author$project$Components$Produits$FicheType$RegleDeCodeView$ligne = F4(
	function (i18n, fiche, rang, segment) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(rang + 1))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Produits$FicheType$RegleDeCodeView$nomDuSegment, i18n, segment))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A3($author$project$Components$Produits$FicheType$RegleDeCodeView$reglageDuSegment, i18n, fiche, segment))
						]))
				]));
	});
var $author$project$Components$Produits$FicheType$RegleDeCode$peutDefinir = function (fiche) {
	return !_Utils_eq(
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$definirLaRegleDeCode, fiche.nQ),
		$elm$core$Maybe$Nothing);
};
var $author$project$I18n$Cles$produitsTypesCodeAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.aucune', _List_Nil, 'Aucune règle : le code de chaque référence se saisit à la main.');
};
var $author$project$I18n$Cles$produitsTypesCodeColonneRang = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.colonne.rang', _List_Nil, '#');
};
var $author$project$I18n$Cles$produitsTypesCodeColonneReglage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.colonne.reglage', _List_Nil, 'Réglage');
};
var $author$project$I18n$Cles$produitsTypesCodeColonneSegment = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.colonne.segment', _List_Nil, 'Segment');
};
var $author$project$I18n$Cles$produitsTypesCodeDefinir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.definir', _List_Nil, 'Définir la règle');
};
var $author$project$I18n$Cles$produitsTypesCodeModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.modifier', _List_Nil, 'Modifier la règle');
};
var $author$project$I18n$Cles$produitsTypesCodeNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.note', _List_Nil, 'Un séparateur est un texte fixe placé où l\'on veut ; sans texte entre deux segments, les codes se collent.');
};
var $author$project$I18n$Cles$produitsTypesCodeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.code.titre', _List_Nil, 'Règle de code de référence');
};
var $author$project$Components$Produits$FicheType$RegleDeCodeView$section = F3(
	function (i18n, versLeParent, fiche) {
		var _v0 = _Utils_Tuple2(
			fiche.hI,
			$author$project$Components$Produits$FicheType$RegleDeCode$peutDefinir(fiche));
		if ((_v0.a.$ === 1) && (!_v0.b)) {
			var _v1 = _v0.a;
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var regle = _v0.a;
			var peutDefinir = _v0.b;
			var segments = A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Iy;
					},
					regle));
			return A2(
				$author$project$Components$Shared$Page$View$sectionAvecCompte,
				_List_Nil,
				{
					fw: peutDefinir ? _List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id('produits-type-code-ouvrir'),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									versLeParent($author$project$Components$Produits$FicheType$RegleDeCode$Ouvrir))
								]),
							_Utils_eq(regle, $elm$core$Maybe$Nothing) ? $author$project$I18n$Cles$produitsTypesCodeDefinir(i18n) : $author$project$I18n$Cles$produitsTypesCodeModifier(i18n))
						]) : _List_Nil,
					vW: A2(
						$elm$core$Maybe$map,
						function (_v2) {
							return $elm$core$String$fromInt(
								$elm$core$List$length(segments));
						},
						regle),
					fZ: function () {
						if (regle.$ === 1) {
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('aucune')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsTypesCodeAucune(i18n))
										]))
								]);
						} else {
							var lue = regle.a;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$table,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('segments')
										]),
									A2(
										$elm$core$List$cons,
										A2(
											$rtfeldman$elm_css$Html$Styled$tr,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$produitsTypesCodeColonneRang(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$produitsTypesCodeColonneSegment(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$produitsTypesCodeColonneReglage(i18n))
														]))
												])),
										A2(
											$elm$core$List$indexedMap,
											A2($author$project$Components$Produits$FicheType$RegleDeCodeView$ligne, i18n, fiche),
											segments))),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$produitsTypesCodeApercu(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$b,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('code')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$elm$core$Maybe$withDefault,
														$author$project$I18n$Cles$produitsTypesCodeApercuIndisponible(i18n),
														lue.tq))
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsTypesCodeNote(i18n))
										]))
								]);
						}
					}(),
					Ar: $elm$core$Maybe$Nothing,
					Dj: 'regle-de-code',
					h6: $author$project$I18n$Cles$produitsTypesCodeTitre(i18n)
				});
		}
	});
var $author$project$Components$Produits$FicheType$Update$RetraitDemande = function (a) {
	return {$: 16, a: a};
};
var $author$project$I18n$Cles$produitsTypesArchiveEmplacements = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.archive.emplacements',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typologie',
					$author$project$I18n$Traductions$Chaine(p.r3)),
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md)),
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Rangé dans « ' + (p.r3 + (' », étage ' + (p.md + (', ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' emplacement dans l\'arbre.')))))) : ('Rangé dans « ' + (p.r3 + (' », étage ' + (p.md + (', ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' emplacements dans l\'arbre.')))))));
	});
var $author$project$Components$Produits$FicheType$View$emplacementArchive = F2(
	function (i18n, emplacement) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('emplacement')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('lead')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$produitsTypesArchiveEmplacements,
								i18n,
								{
									md: A2(
										$elm$core$Maybe$withDefault,
										$author$project$I18n$Cles$produitsArchetypeTypeDeProduit(i18n),
										emplacement.md),
									w: emplacement.Di,
									r3: emplacement.Dj
								}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(
							$author$project$Components$Produits$FicheType$Model$idDuRetrait(emplacement.r3)),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer-de-la-typologie'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Produits$FicheType$Update$RetraitDemande(emplacement.r3))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsValeursCategorieTypologieRetirerValider(i18n))
						]))
				]));
	});
var $author$project$Components$Produits$FicheType$Model$emplacementsRetirables = function (fiche) {
	return A2(
		$elm$core$List$filter,
		function (emplacement) {
			return !_Utils_eq(
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerUnTypeDUneTypologie, emplacement.nQ),
				$elm$core$Maybe$Nothing);
		},
		fiche.ye);
};
var $author$project$I18n$Cles$produitsTypesArchiveBandeauTexte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.archive.bandeau.texte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typologies',
					$author$project$I18n$Traductions$Chaine(p.r7))
				]),
			'Lecture seule. Il reste rangé dans ' + (p.r7 + '.'));
	});
var $author$project$I18n$Cles$produitsTypesArchiveBandeauTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.archive.bandeau.titre', _List_Nil, 'Type archivé');
};
var $author$project$Components$Produits$FicheType$View$typeArchive = F2(
	function (i18n, fiche) {
		var _v0 = $author$project$Components$Produits$FicheType$Model$emplacementsRetirables(fiche);
		if (!_v0.b) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var emplacements = _v0;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('type-archive')
					]),
				_Utils_ap(
					fiche.fh.tE ? _List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Note$View$view,
							1,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsTypesArchiveBandeauTitre(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$produitsTypesArchiveBandeauTexte,
												i18n,
												{
													r7: A2(
														$elm$core$String$join,
														', ',
														A2(
															$elm$core$List$map,
															function (e) {
																return '« ' + (e.Dj + ' »');
															},
															emplacements))
												}))
										]))
								]))
						]) : _List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Components$Produits$FicheType$View$emplacementArchive(i18n),
						emplacements)));
		}
	});
var $author$project$Components$Produits$FicheType$Update$RetraitDeValeurAnnule = {$: 47};
var $author$project$Components$Produits$FicheType$Update$RetraitDeValeurConfirme = {$: 48};
var $author$project$Components$Produits$FicheType$Update$RetraitDeValeurDemande = function (a) {
	return {$: 46, a: a};
};
var $author$project$Components$Produits$FicheType$Update$ValeursSuivantesDemandees = {$: 45};
var $author$project$Components$Shared$Drawer$View$consultationDetaillee = F3(
	function (i18n, versMsg, contenu) {
		return A6(
			$author$project$Components$Shared$Drawer$View$consultationAvec,
			i18n,
			versMsg,
			0,
			$author$project$I18n$Cles$drawerFermer(i18n),
			{
				oJ: $elm$core$Maybe$Just(contenu.oJ),
				aO: $elm$core$Maybe$Just(contenu.aO)
			},
			{fZ: contenu.fZ, G8: contenu.G8, h6: contenu.h6});
	});
var $author$project$Components$Produits$FicheType$ValeursPosees$lignesCachees = function (enCours) {
	return A2(
		$elm$core$Basics$max,
		0,
		$elm$core$List$length(enCours.gV) - enCours.a8);
};
var $author$project$Components$Produits$FicheType$ValeursPosees$lignesVisibles = function (enCours) {
	return A2(
		$elm$core$List$take,
		enCours.a8,
		A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, enCours.gV));
};
var $author$project$I18n$Cles$produitsTypesValeursPoseesAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.valeurs-posees.aucune', _List_Nil, 'Plus aucune valeur n\'est posée : le niveau redevient modifiable.');
};
var $author$project$I18n$Cles$produitsTypesValeursPoseesBandeau = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.valeurs-posees.bandeau',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' étage porte une valeur de ce champ.') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' étages portent une valeur de ce champ.'));
	});
var $author$project$I18n$Cles$produitsTypesValeursPoseesPremieres = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.valeurs-posees.premieres',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'affichees',
					$author$project$I18n$Traductions$Chaine(p.dk)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			p.dk + (' premières sur ' + (p.JE + ('. Retirer une valeur demande confirmation ; il n\'y a pas de retrait en masse (' + (p.JE + ' gestes).')))));
	});
var $author$project$I18n$Cles$produitsTypesValeursPoseesSuivantes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.valeurs-posees.suivantes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? 'Voir la suivante' : ('Voir les ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' suivantes')));
	});
var $author$project$Components$Produits$FicheType$ValeursPosees$nomDeLaLigne = function (ligne) {
	return A2($elm$core$Maybe$withDefault, '', ligne.Dj);
};
var $author$project$Components$Produits$FicheType$ValeursPoseesView$pointille = F2(
	function (attributs, libelle) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
					attributs)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						]))
				]));
	});
var $author$project$I18n$Cles$produitsTypesValeursPoseesConfirmer = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.valeurs-posees.confirmer',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer la valeur de ' + (p.Dj + ' ? Elle est effacée de cet étage.'));
	});
var $author$project$I18n$Cles$produitsTypesValeursPoseesConfirmerNon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.valeurs-posees.confirmer-non', _List_Nil, 'Garder la valeur');
};
var $author$project$I18n$Cles$produitsTypesValeursPoseesConfirmerOui = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.valeurs-posees.confirmer-oui', _List_Nil, 'Retirer la valeur');
};
var $author$project$I18n$Cles$produitsTypesValeursPoseesEtage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.valeurs-posees.etage',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md))
				]),
			'étage ' + p.md);
	});
var $author$project$I18n$Cles$produitsTypesValeursPoseesRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.valeurs-posees.retirer', _List_Nil, 'Retirer');
};
var $author$project$I18n$Cles$produitsTypesValeursPoseesRetirerNom = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.valeurs-posees.retirer-nom',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer la valeur de ' + p.Dj);
	});
var $author$project$Components$Produits$FicheType$ValeursPosees$valeurDeLaLigne = function (ligne) {
	var _v0 = ligne.AS;
	if (!_v0.$) {
		var intitule = _v0.a;
		return intitule;
	} else {
		var _v1 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, ligne.fm);
		if (!_v1.$) {
			var texte = _v1.a;
			return texte;
		} else {
			return A2($elm$json$Json$Encode$encode, 0, ligne.fm);
		}
	}
};
var $author$project$Components$Produits$FicheType$ValeursPoseesView$uneLigne = F4(
	function (i18n, gestes, enCours, _v0) {
		var rang = _v0.a;
		var ligne = _v0.b;
		var nom = ($author$project$Components$Produits$FicheType$ValeursPosees$nomDeLaLigne(ligne) === '') ? A2($author$project$Catalogue$Vocabulaire$etageDeSaisie, i18n, ligne.md).Bl : $author$project$Components$Produits$FicheType$ValeursPosees$nomDeLaLigne(ligne);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'a-confirmer',
							_Utils_eq(
								enCours.dh,
								$elm$core$Maybe$Just(rang)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('corps')
						]),
					_Utils_ap(
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('porteur')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$b,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(nom)
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$produitsTypesValeursPoseesEtage,
													i18n,
													{
														md: A2($author$project$Catalogue$Vocabulaire$etageDeSaisie, i18n, ligne.md).Bl
													}))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$Components$Produits$FicheType$ValeursPosees$valeurDeLaLigne(ligne))
									]))
							]),
						(_Utils_eq(
							enCours.dh,
							$elm$core$Maybe$Just(rang)) || _Utils_eq(ligne.eW, $elm$core$Maybe$Nothing)) ? _List_Nil : _List_fromArray(
							[
								A2(
								$author$project$Components$Produits$FicheType$ValeursPoseesView$pointille,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										gestes.H0(rang)),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
										'aria-label',
										A2(
											$author$project$I18n$Cles$produitsTypesValeursPoseesRetirerNom,
											i18n,
											{Dj: nom})),
										$rtfeldman$elm_css$Html$Styled$Attributes$title(
										A2(
											$author$project$I18n$Cles$produitsTypesValeursPoseesRetirerNom,
											i18n,
											{Dj: nom}))
									]),
								$author$project$I18n$Cles$produitsTypesValeursPoseesRetirer(i18n))
							]))),
					_Utils_eq(
					enCours.dh,
					$elm$core$Maybe$Just(rang)) ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('confirmation'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$produitsTypesValeursPoseesConfirmer,
										i18n,
										{Dj: nom}))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('gestes')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(gestes.z7)
										]),
									$author$project$I18n$Cles$produitsTypesValeursPoseesConfirmerNon(i18n)),
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									3,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(gestes.j7)
										]),
									$author$project$I18n$Cles$produitsTypesValeursPoseesConfirmerOui(i18n))
								]))
						])) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$Components$Produits$FicheType$ValeursPoseesView$contenu = F3(
	function (i18n, gestes, enCours) {
		var total = $elm$core$List$length(enCours.gV);
		return (!total) ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsTypesValeursPoseesAucune(i18n))
					]))
			]) : _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('verrou'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'note')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$niveauDeSaisieFigeTitre(i18n))
									])),
								$rtfeldman$elm_css$Html$Styled$text(' '),
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$produitsTypesValeursPoseesBandeau,
									i18n,
									{w: total}))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('bloc')
					]),
				A2(
					$elm$core$List$map,
					A3($author$project$Components$Produits$FicheType$ValeursPoseesView$uneLigne, i18n, gestes, enCours),
					$author$project$Components$Produits$FicheType$ValeursPosees$lignesVisibles(enCours))),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$produitsTypesValeursPoseesPremieres,
							i18n,
							{
								dk: $elm$core$String$fromInt(
									A2($elm$core$Basics$min, total, enCours.a8)),
								JE: $elm$core$String$fromInt(total)
							}))
					])),
				($author$project$Components$Produits$FicheType$ValeursPosees$lignesCachees(enCours) > 0) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('suite')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						2,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick(gestes.rq)
							]),
						A2(
							$author$project$I18n$Cles$produitsTypesValeursPoseesSuivantes,
							i18n,
							{
								w: $author$project$Components$Produits$FicheType$ValeursPosees$lignesCachees(enCours)
							}))
					])) : $rtfeldman$elm_css$Html$Styled$text('')
			]);
	});
var $author$project$I18n$Cles$produitsTypesValeursPoseesDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.valeurs-posees.detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' étage porte une valeur') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' étages portent une valeur'));
	});
var $author$project$I18n$Cles$produitsTypesValeursPoseesPied = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.valeurs-posees.pied', _List_Nil, 'Quand toutes les valeurs sont retirées, le niveau redevient modifiable.');
};
var $author$project$I18n$Cles$produitsTypesValeursPoseesTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.valeurs-posees.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'Valeurs posées · ' + p.uN);
	});
var $author$project$Components$Produits$FicheType$ValeursPoseesView$view = F4(
	function (i18n, gestes, enCours, drawer) {
		return A4(
			$author$project$Components$Shared$Drawer$View$consultationDetaillee,
			i18n,
			gestes.xU,
			{
				fZ: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2($author$project$Components$Produits$FicheType$ValeursPoseesView$contenu, i18n, gestes),
						enCours)),
				oJ: $author$project$I18n$Cles$produitsTypesValeursPoseesPied(i18n),
				G8: false,
				aO: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function (lu) {
							return A2(
								$author$project$I18n$Cles$produitsTypesValeursPoseesDetail,
								i18n,
								{
									w: $elm$core$List$length(lu.gV)
								});
						},
						enCours)),
				h6: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function (lu) {
							return A2(
								$author$project$I18n$Cles$produitsTypesValeursPoseesTitre,
								i18n,
								{uN: lu.Bl});
						},
						enCours))
			},
			drawer);
	});
var $author$project$Components$Produits$FicheType$View$valeursPosees = F2(
	function (i18n, model) {
		return A4(
			$author$project$Components$Produits$FicheType$ValeursPoseesView$view,
			i18n,
			{
				j7: $author$project$Components$Produits$FicheType$Update$RetraitDeValeurConfirme,
				xU: $author$project$Components$Produits$FicheType$Update$DuDrawerValeursPosees,
				yj: $author$project$Components$Produits$Common$Envoi$enCours(model.l2),
				z7: $author$project$Components$Produits$FicheType$Update$RetraitDeValeurAnnule,
				H0: $author$project$Components$Produits$FicheType$Update$RetraitDeValeurDemande,
				rq: $author$project$Components$Produits$FicheType$Update$ValeursSuivantesDemandees
			},
			model.si,
			model.lE);
	});
var $author$project$I18n$Cles$produitsTypesVersionsAjouts = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.versions.ajouts',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champs',
					$author$project$I18n$Traductions$Chaine(p.dw))
				]),
			'Informations ajoutées : ' + p.dw);
	});
var $author$project$I18n$Cles$produitsTypesVersionsCreation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.versions.creation', _List_Nil, 'Création de la catégorie');
};
var $author$project$I18n$Cles$produitsTypesVersionsModifications = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.versions.modifications',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champs',
					$author$project$I18n$Traductions$Chaine(p.dw))
				]),
			'Informations modifiées : ' + p.dw);
	});
var $author$project$I18n$Cles$produitsTypesVersionsVersion = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.types.versions.version',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'version',
					$author$project$I18n$Traductions$Chaine(p.sq))
				]),
			'Version ' + p.sq);
	});
var $author$project$Components$Produits$FicheType$View$version = F2(
	function (i18n, lue) {
		var cles = F2(
			function (nommer, champs) {
				return $elm$core$List$isEmpty(champs) ? _List_Nil : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								nommer(
									{
										dw: A2($elm$core$String$join, ', ', champs)
									}))
							]))
					]);
			});
		var changements = _Utils_ap(
			A2(
				cles,
				$author$project$I18n$Cles$produitsTypesVersionsAjouts(i18n),
				lue.fx),
			A2(
				cles,
				$author$project$I18n$Cles$produitsTypesVersionsModifications(i18n),
				lue.g$));
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$produitsTypesVersionsVersion,
								i18n,
								{
									sq: $elm$core$String$fromInt(lue.sq)
								}))
						])),
				A2(
					$elm$core$List$cons,
					A3(
						$rtfeldman$elm_css$Html$Styled$node,
						'time',
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'datetime', lue.wv)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(lue.wv)
							])),
					$elm$core$List$isEmpty(changements) ? _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsTypesVersionsCreation(i18n))
								]))
						]) : changements)));
	});
var $author$project$Components$Produits$FicheType$View$versions = F2(
	function (i18n, model) {
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'hidden',
							_Utils_eq(model.ss, $elm$core$Maybe$Nothing))
						]))
				]),
			{
				fw: _List_Nil,
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('historique')
							]),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.ss;
									},
									A2(
										$elm$core$Basics$composeR,
										$elm$core$List$reverse,
										$elm$core$List$map(
											$author$project$Components$Produits$FicheType$View$version(i18n)))),
								model.ss)))
					]),
				Dj: 'versions',
				h6: $author$project$I18n$Cles$produitsTypesVersionsTitre(i18n)
			});
	});
var $author$project$Components$Produits$FicheType$View$page = F4(
	function (i18n, messages, model, fiche) {
		var type_ = fiche.fh;
		return A2(
			$author$project$Components$Shared$Page$View$page,
			$author$project$Components$Produits$FicheType$View$nomDeLaPage,
			{
				ut: _List_fromArray(
					[
						A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('envoi'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Components$Produits$Common$Envoi$enCours(model.l2) ? $author$project$I18n$Cles$produitsStructureEnvoiEnCours(i18n) : '')
							])),
						A2($author$project$Components$Produits$FicheType$View$typeArchive, i18n, fiche),
						A3($author$project$Components$Produits$FicheType$View$caracteristiques, i18n, model, fiche),
						A3(
						$author$project$Components$Shared$CollectionsDuType$View$carte,
						i18n,
						{
							Ek: A2(
								$elm$core$Maybe$map,
								function (lien) {
									return $author$project$Components$Produits$FicheType$Update$DesBlocs(
										$author$project$Components$Shared$OrdreDesBlocs$Update$Demander(lien));
								},
								A2(
									$elm$core$Maybe$andThen,
									function (_v0) {
										return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ordreDesBlocs, fiche.nQ);
									},
									A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ordonnerLesBlocs, fiche.nQ))),
							Fj: !_Utils_eq(
								A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ajouterUneCollectionAUnType, fiche.nQ),
								$elm$core$Maybe$Nothing),
							Fo: !_Utils_eq(
								A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerUneCollectionDUnType, fiche.nQ),
								$elm$core$Maybe$Nothing),
							KD: $author$project$Components$Produits$FicheType$Update$DesCollections
						},
						fiche.vE),
						A3($author$project$Components$Produits$FicheType$RegleDeCodeView$section, i18n, $author$project$Components$Produits$FicheType$Update$DesLaRegleDeCode, fiche),
						A2($author$project$Components$Produits$FicheType$View$versions, i18n, model)
					]),
				xy: _Utils_ap(
					_List_fromArray(
						[
							A3($author$project$Components$Produits$FicheType$View$drawer, i18n, model, fiche),
							A3($author$project$Components$Produits$FicheType$View$reglages, i18n, model, fiche),
							A3($author$project$Components$Produits$FicheType$View$restriction, i18n, model, fiche),
							A5(
							$author$project$Components$Produits$FicheType$RegleDeCodeView$drawer,
							i18n,
							{
								yj: $author$project$Components$Produits$Common$Envoi$enCours(model.l2),
								KD: $author$project$Components$Produits$FicheType$Update$DesLaRegleDeCode
							},
							fiche,
							model.hI,
							model.lB),
							A2($author$project$Components$Produits$FicheType$View$valeursPosees, i18n, model),
							A3($author$project$Components$Produits$FicheType$View$archivage, i18n, model, fiche),
							A3($author$project$Components$Produits$FicheType$View$retrait, i18n, model, fiche),
							A3($author$project$Components$Produits$FicheType$View$elargir, i18n, model, fiche),
							A4(
							$author$project$Components$Shared$CollectionsDuType$View$drawers,
							i18n,
							{
								s_: $author$project$Components$Produits$FicheType$View$adresseDesValeursDuChamp(fiche),
								xR: $author$project$I18n$Cles$collectionsTypeDroit(i18n),
								cF: $author$project$Components$Produits$Common$Envoi$enCours(model.l2),
								Dp: type_.Dj.zX,
								eA: false,
								KD: $author$project$Components$Produits$FicheType$Update$DesCollections
							},
							fiche.vE,
							model.vE),
							A3(
							$author$project$Components$Shared$OrdreDesBlocs$View$drawer,
							i18n,
							{
								cF: $author$project$Components$Produits$Common$Envoi$enCours(model.l2),
								Dj: type_.Dj.zX,
								ey: $elm$core$Maybe$Nothing,
								aj: A2(
									$author$project$I18n$Cles$ordreDesBlocsPiedType,
									i18n,
									{Dj: type_.Dj.zX}),
								c0: $author$project$I18n$Cles$ordreDesBlocsCeType(i18n),
								Io: false,
								KD: $author$project$Components$Produits$FicheType$Update$DesBlocs
							},
							model.o1)
						]),
					A3($author$project$Components$Parametrage$NouveauChamp$View$dialogues, i18n, $author$project$Components$Produits$FicheType$Update$DuNouveauChamp, model.oP)),
				zM: _Utils_ap(
					function () {
						var _v1 = $author$project$Components$Produits$FicheType$Model$commandeDArchivage(fiche);
						if (!_v1.$) {
							return _List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									3,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$FicheType$Model$idDeLArchivage),
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$FicheType$Update$ArchivageDemande)
										]),
									$author$project$I18n$Cles$produitsTypesArchivage(i18n))
								]);
						} else {
							return _List_Nil;
						}
					}(),
					function () {
						var _v2 = $author$project$Components$Produits$FicheType$Model$historique(fiche);
						if (!_v2.$) {
							return _List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$FicheType$Update$HistoriqueDemande)
										]),
									$author$project$I18n$Cles$produitsTypesVersionsTitre(i18n))
								]);
						} else {
							return _List_Nil;
						}
					}()),
				AK: $author$project$Components$Produits$FicheType$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Tag$View$view,
								3,
								A2(
									$author$project$I18n$Cles$produitsTypesVersion,
									i18n,
									{
										sq: $elm$core$String$fromInt(type_.sq)
									})),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('archive')
									]),
								type_.tE ? _List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Tag$View$view,
										3,
										$author$project$I18n$Cles$produitsTypesArchive(i18n))
									]) : _List_Nil),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('resume')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$produitsTypesFicheResume,
											i18n,
											{
												hD: A3($author$project$Catalogue$Vocabulaire$nombreDeReferencesDUnType, i18n, type_.g1, type_.hD)
											}))
									]))
							]),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adresseParametrageCatalogue,
								Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
							},
								{
								aa: $author$project$Components$Produits$FicheType$View$adresseDesCategories,
								Dj: $author$project$I18n$Cles$produitsTypesTitre(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: type_.Dj.zX
					})
			});
	});
var $author$project$Components$Produits$FicheType$View$view = F3(
	function (i18n, messages, model) {
		var _v0 = _Utils_Tuple2(model.nf, model.zo);
		if (_v0.a) {
			return A2(
				$author$project$Components$Shared$Introuvable$View$view,
				i18n,
				{
					aa: $author$project$Components$Produits$FicheType$View$adresseDesCategories,
					Bl: $author$project$I18n$Cles$produitsTypesRetour(i18n)
				});
		} else {
			if (!_v0.b.$) {
				var fiche = _v0.b.a;
				return A4($author$project$Components$Produits$FicheType$View$page, i18n, messages, model, fiche);
			} else {
				var _v1 = _v0.b;
				return A2(
					$author$project$Components$Shared$Page$View$page,
					$author$project$Components$Produits$FicheType$View$nomDeLaPage,
					{
						ut: _List_fromArray(
							[
								A2($author$project$Components$Shared$Messages$View$view, i18n, messages)
							]),
						xy: _List_Nil,
						zM: _List_Nil,
						AK: false,
						JD: _List_Nil
					});
			}
		}
	});
var $author$project$Components$Produits$ListeDePrix$View$nomDeLaPage = 'produits-liste-de-prix-detail';
var $author$project$Components$Produits$ListeDePrix$Update$EnregistrementDemande = {$: 6};
var $author$project$Components$Produits$ListeDePrix$Update$PublicsDemandes = {$: 15};
var $author$project$I18n$Cles$produitsListeDePrixPublicsModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.liste-de-prix.publics.modifier', _List_Nil, 'Modifier les publics');
};
var $author$project$Components$Produits$ListeDePrix$View$actions = F2(
	function (i18n, fiche) {
		return _Utils_ap(
			_Utils_eq(
				$author$project$Components$Produits$ListeDePrix$Model$lienDesPublics(fiche),
				$elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$ListeDePrix$Model$idDesPublics),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$ListeDePrix$Update$PublicsDemandes)
						]),
					$author$project$I18n$Cles$produitsListeDePrixPublicsModifier(i18n))
				]),
			_Utils_eq(
				$author$project$Components$Produits$ListeDePrix$Model$lienDeLaSaisie(fiche),
				$elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					0,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$ListeDePrix$Update$EnregistrementDemande)
						]),
					$author$project$I18n$Cles$produitsCatalogueActionsEnregistrer(i18n))
				]));
	});
var $author$project$Components$Produits$ListeDePrix$View$enEnvoi = function (model) {
	return $author$project$Components$Produits$Common$Envoi$enCours(model.l2) || (!$elm$core$List$isEmpty(model.iv));
};
var $author$project$Components$Produits$ListeDePrix$Update$AjoutFerme = {$: 9};
var $author$project$Components$Produits$ListeDePrix$Update$AjoutOuvert = {$: 8};
var $author$project$Components$Produits$ListeDePrix$Update$ReferenceChoisie = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Produits$ListeDePrix$Update$TermeSaisi = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Produits$ListeDePrix$Model$nomDeLaReference = function (reference) {
	return A2(
		$elm$core$Maybe$withDefault,
		reference.vx,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.zX;
			},
			reference.Dj));
};
var $author$project$I18n$Cles$produitsListeDePrixAjoutAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.liste-de-prix.ajout.aucune', _List_Nil, 'Aucune offre ni référence à ajouter.');
};
var $author$project$I18n$Cles$produitsListeDePrixAjoutRecherche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.liste-de-prix.ajout.recherche', _List_Nil, 'Rechercher une offre ou une référence');
};
var $author$project$I18n$Cles$produitsListeDePrixAjoutTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.liste-de-prix.ajout.titre', _List_Nil, 'Ajouter une offre ou une référence');
};
var $author$project$Components$Produits$ListeDePrix$View$ajout = F3(
	function (i18n, model, fiche) {
		var proposition = function (proposee) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$li,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('proposition'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Produits$ListeDePrix$Update$ReferenceChoisie(proposee.Aq))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$Components$Produits$ListeDePrix$Model$nomDeLaReference(proposee))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('nature')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(proposee.vx)
									]))
							]))
					]));
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'opened',
							!_Utils_eq(model.fw, $elm$core$Maybe$Nothing))
						]))
				]),
			function () {
				var _v0 = _Utils_Tuple2(
					$author$project$Components$Produits$ListeDePrix$Model$lienDeLaSaisie(fiche),
					model.fw);
				if (_v0.a.$ === 1) {
					var _v1 = _v0.a;
					return _List_Nil;
				} else {
					if (_v0.b.$ === 1) {
						var _v2 = _v0.b;
						return _List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$ListeDePrix$Model$idDeLAjout),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$ListeDePrix$Update$AjoutOuvert)
									]),
								$author$project$I18n$Cles$produitsListeDePrixAjoutTitre(i18n))
							]);
					} else {
						var ouvert = _v0.b.a;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$input,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('search'),
										$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$ListeDePrix$Model$idDeLaRecherche),
										$rtfeldman$elm_css$Html$Styled$Attributes$value(ouvert.h3),
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Produits$ListeDePrix$Update$TermeSaisi),
										$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(
										$author$project$I18n$Cles$produitsListeDePrixAjoutRecherche(i18n)),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
										'aria-label',
										$author$project$I18n$Cles$produitsListeDePrixAjoutRecherche(i18n))
									]),
								_List_Nil),
								A2(
								$rtfeldman$elm_css$Html$Styled$ul,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('propositions')
									]),
								A2(
									$elm$core$List$map,
									proposition,
									A2($author$project$Components$Produits$ListeDePrix$Model$proposees, model, fiche))),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										((!_Utils_eq(ouvert.fg, $elm$core$Maybe$Nothing)) && $elm$core$List$isEmpty(
											A2($author$project$Components$Produits$ListeDePrix$Model$proposees, model, fiche))) ? $author$project$I18n$Cles$produitsListeDePrixAjoutAucune(i18n) : '')
									])),
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$ListeDePrix$Update$AjoutFerme)
									]),
								$author$project$I18n$Cles$drawerAnnuler(i18n))
							]);
					}
				}
			}());
	});
var $author$project$Components$Produits$ListeDePrix$View$idDeLaColonneDeLUnite = 'colonne-de-prix-unite';
var $author$project$Components$Produits$ListeDePrix$View$idDeLaColonneDuPrix = 'colonne-de-prix-prix';
var $author$project$Components$Produits$ListeDePrix$Update$RetraitDemande = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Produits$ListeDePrix$Model$idDuNom = function (id) {
	return 'ligne-de-prix-' + ($author$project$Catalogue$Identifiants$referenceIdToString(id) + '-nom');
};
var $author$project$Components$Produits$Common$Prix$nombre = F2(
	function (i18n, ecrit) {
		var _v0 = A2($elm$core$String$split, '.', ecrit);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var entier = _v0.a;
			var _v1 = _v0.b;
			var decimales = _v1.a;
			return A2(
				$elm$core$Maybe$withDefault,
				ecrit,
				A2(
					$elm$core$Maybe$map,
					function (lu) {
						return A2(
							$author$project$I18n$Nombre$formater,
							$author$project$I18n$Traductions$langue(i18n),
							lu) + (',' + decimales);
					},
					$elm$core$String$toInt(entier)));
		} else {
			return ecrit;
		}
	});
var $author$project$I18n$Cles$produitsPrixMontant = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.prix.montant',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'montant',
					$author$project$I18n$Traductions$Chaine(p.oi)),
					_Utils_Tuple2(
					'devise',
					$author$project$I18n$Traductions$Chaine(p.kO))
				]),
			p.oi + (' ' + p.kO));
	});
var $author$project$I18n$Cles$produitsPrixDeviseEuro = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.prix.devise.euro', _List_Nil, '€');
};
var $author$project$Catalogue$Vocabulaire$symboleDeDevise = F2(
	function (i18n, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			code,
			A2(
				$elm$core$Dict$get,
				code,
				$elm$core$Dict$fromList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'EUR',
							$author$project$I18n$Cles$produitsPrixDeviseEuro(i18n))
						]))));
	});
var $author$project$Components$Produits$Common$Prix$montant = F3(
	function (i18n, liste, ecrit) {
		return A2(
			$author$project$I18n$Cles$produitsPrixMontant,
			i18n,
			{
				kO: A2($author$project$Catalogue$Vocabulaire$symboleDeDevise, i18n, liste.kO),
				oi: A2($author$project$Components$Produits$Common$Prix$nombre, i18n, ecrit)
			});
	});
var $author$project$Components$Produits$ListeDePrix$Update$MontantSaisi = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$I18n$Cles$produitsListeDePrixLignesMontantInvalide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.liste-de-prix.lignes.montant-invalide', _List_Nil, 'Un montant positif ou nul, à deux décimales au plus.');
};
var $author$project$Components$Produits$ListeDePrix$Model$erreurDuMontant = F4(
	function (i18n, model, fiche, id) {
		return ((model.b5 && A2(
			$elm$core$List$member,
			id,
			A2($author$project$Components$Produits$ListeDePrix$Model$fautives, model, fiche))) || _Utils_eq(
			model.b_,
			$elm$core$Maybe$Just(id))) ? $elm$core$Maybe$Just(
			$author$project$I18n$Cles$produitsListeDePrixLignesMontantInvalide(i18n)) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$Produits$ListeDePrix$View$montant = F5(
	function (i18n, model, fiche, reference, saisi) {
		var erreur = A4($author$project$Components$Produits$ListeDePrix$Model$erreurDuMontant, i18n, model, fiche, reference);
		return A2(
			$rtfeldman$elm_css$Html$Styled$fieldset,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'error',
							!_Utils_eq(erreur, $elm$core$Maybe$Nothing))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(
							$author$project$Components$Produits$ListeDePrix$Model$idDuMontant(reference)),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(saisi),
							$rtfeldman$elm_css$Html$Styled$Events$onInput(
							$author$project$Components$Produits$ListeDePrix$Update$MontantSaisi(reference)),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'inputmode', 'decimal'),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-labelledby',
							$author$project$Components$Produits$ListeDePrix$Model$idDuNom(reference) + (' ' + $author$project$Components$Produits$ListeDePrix$View$idDeLaColonneDuPrix)),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-invalid',
							_Utils_eq(erreur, $elm$core$Maybe$Nothing) ? 'false' : 'true')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('devise')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Catalogue$Vocabulaire$symboleDeDevise, i18n, fiche.kO))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('errors')
						]),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (texte) {
								return _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$li,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(texte)
											]))
									]);
							},
							erreur)))
				]));
	});
var $author$project$I18n$Cles$produitsListeDePrixLignesRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.liste-de-prix.lignes.retirer', _List_Nil, 'Retirer');
};
var $author$project$Components$Produits$ListeDePrix$Update$UniteChoisie = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$I18n$Cles$produitsPrixUniteParAn = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.prix.unite.par-an', _List_Nil, 'Par an');
};
var $author$project$I18n$Cles$produitsPrixUniteParMois = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.prix.unite.par-mois', _List_Nil, 'Par mois');
};
var $author$project$I18n$Cles$produitsPrixUniteParUnite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.prix.unite.par-unite', _List_Nil, 'Par unité');
};
var $author$project$I18n$Cles$produitsPrixUniteUnique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.prix.unite.unique', _List_Nil, 'Unique');
};
var $author$project$Catalogue$Vocabulaire$unitesDePrixNommees = function (i18n) {
	return $elm$core$Dict$fromList(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'unique',
				$author$project$I18n$Cles$produitsPrixUniteUnique(i18n)),
				_Utils_Tuple2(
				'par-an',
				$author$project$I18n$Cles$produitsPrixUniteParAn(i18n)),
				_Utils_Tuple2(
				'par-mois',
				$author$project$I18n$Cles$produitsPrixUniteParMois(i18n)),
				_Utils_Tuple2(
				'par-unite',
				$author$project$I18n$Cles$produitsPrixUniteParUnite(i18n))
			]));
};
var $author$project$Catalogue$Vocabulaire$uniteDePrix = F2(
	function (i18n, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			code,
			A2(
				$elm$core$Dict$get,
				code,
				$author$project$Catalogue$Vocabulaire$unitesDePrixNommees(i18n)));
	});
var $author$project$Components$Produits$ListeDePrix$View$unite = F3(
	function (i18n, reference, choisie) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$select,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onInput(
					$author$project$Components$Produits$ListeDePrix$Update$UniteChoisie(reference)),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-labelledby',
					$author$project$Components$Produits$ListeDePrix$Model$idDuNom(reference) + (' ' + $author$project$Components$Produits$ListeDePrix$View$idDeLaColonneDeLUnite))
				]),
			A2(
				$elm$core$List$map,
				function (code) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$option,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'value', code),
								$rtfeldman$elm_css$Html$Styled$Attributes$selected(
								_Utils_eq(code, choisie))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$Catalogue$Vocabulaire$uniteDePrix, i18n, code))
							]));
				},
				$author$project$Catalogue$Vocabulaire$unitesDePrix));
	});
var $author$project$Components$Produits$ListeDePrix$View$ligne = F4(
	function (i18n, model, fiche, portee) {
		var saisie = A2($author$project$Components$Produits$ListeDePrix$Model$saisieDe, model, portee);
		var reference = portee.Hc.Aq;
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('arretee', portee.Hc.tL)
						]))
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$th,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$scope('row'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(
							$author$project$Components$Produits$ListeDePrix$Model$idDuNom(reference))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Components$Produits$ListeDePrix$Model$nomDeLaReference(portee.Hc))
						])),
				_Utils_ap(
					_Utils_eq(
						$author$project$Components$Produits$ListeDePrix$Model$lienDeLaSaisie(fiche),
						$elm$core$Maybe$Nothing) ? _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$td,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('prix')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A3(
										$author$project$Components$Produits$Common$Prix$montant,
										i18n,
										{kO: fiche.kO},
										portee.oi))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$td,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('unite')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Catalogue$Vocabulaire$uniteDePrix, i18n, portee.sa))
								]))
						]) : _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$td,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('prix')
								]),
							_List_fromArray(
								[
									A5(
									$author$project$Components$Produits$ListeDePrix$View$montant,
									i18n,
									model,
									fiche,
									reference,
									A2(
										$elm$core$Maybe$withDefault,
										A2($author$project$Components$Produits$Common$Prix$nombre, i18n, portee.oi),
										saisie.oi))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$td,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('unite')
								]),
							_List_fromArray(
								[
									A3($author$project$Components$Produits$ListeDePrix$View$unite, i18n, reference, saisie.sa)
								]))
						]),
					_Utils_eq(
						$author$project$Components$Produits$ListeDePrix$Model$lienDuRetrait(fiche),
						$elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$td,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Produits$ListeDePrix$Update$RetraitDemande(reference))
										]),
									$author$project$I18n$Cles$produitsListeDePrixLignesRetirer(i18n))
								]))
						]))));
	});
var $author$project$I18n$Cles$produitsListeDePrixLignesActions = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.liste-de-prix.lignes.actions', _List_Nil, 'Actions');
};
var $author$project$I18n$Cles$produitsListeDePrixLignesAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.liste-de-prix.lignes.aucune', _List_Nil, 'Aucune ligne pour l\'instant.');
};
var $author$project$I18n$Cles$produitsListeDePrixLignesPrix = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.liste-de-prix.lignes.prix', _List_Nil, 'Prix');
};
var $author$project$I18n$Cles$produitsListeDePrixLignesReference = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.liste-de-prix.lignes.reference', _List_Nil, 'Offre ou référence');
};
var $author$project$I18n$Cles$produitsListeDePrixLignesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.liste-de-prix.lignes.titre', _List_Nil, 'Lignes');
};
var $author$project$I18n$Cles$produitsListeDePrixLignesUnite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.liste-de-prix.lignes.unite', _List_Nil, 'Unité');
};
var $author$project$Components$Produits$ListeDePrix$View$lignes = F3(
	function (i18n, model, fiche) {
		var montrees = A2($author$project$Components$Produits$ListeDePrix$Model$lignesMontrees, model, fiche);
		var avecRetrait = !_Utils_eq(
			$author$project$Components$Produits$ListeDePrix$Model$lienDuRetrait(fiche),
			$elm$core$Maybe$Nothing);
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_Nil,
			{
				fw: _List_Nil,
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$table,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$tr,
												_List_Nil,
												A2(
													$elm$core$List$map,
													function (_v0) {
														var nom = _v0.a;
														var ancre = _v0.b;
														return A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$scope('col'),
																	$rtfeldman$elm_css$Html$Styled$Attributes$id(ancre)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(nom)
																]));
													},
													_Utils_ap(
														_List_fromArray(
															[
																_Utils_Tuple2(
																$author$project$I18n$Cles$produitsListeDePrixLignesReference(i18n),
																'colonne-de-prix-reference'),
																_Utils_Tuple2(
																$author$project$I18n$Cles$produitsListeDePrixLignesPrix(i18n),
																$author$project$Components$Produits$ListeDePrix$View$idDeLaColonneDuPrix),
																_Utils_Tuple2(
																$author$project$I18n$Cles$produitsListeDePrixLignesUnite(i18n),
																$author$project$Components$Produits$ListeDePrix$View$idDeLaColonneDeLUnite)
															]),
														avecRetrait ? _List_fromArray(
															[
																_Utils_Tuple2(
																$author$project$I18n$Cles$produitsListeDePrixLignesActions(i18n),
																'colonne-de-prix-actions')
															]) : _List_Nil)))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$tbody,
										_List_Nil,
										A2(
											$elm$core$List$map,
											A3($author$project$Components$Produits$ListeDePrix$View$ligne, i18n, model, fiche),
											montrees))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$List$isEmpty(montrees) ? $author$project$I18n$Cles$produitsListeDePrixLignesAucune(i18n) : '')
							])),
						A3($author$project$Components$Produits$ListeDePrix$View$ajout, i18n, model, fiche)
					]),
				Dj: 'lignes',
				h6: $author$project$I18n$Cles$produitsListeDePrixLignesTitre(i18n)
			});
	});
var $author$project$Components$Produits$ListeDePrix$Update$PubliciteChoisie = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Produits$ListeDePrix$Model$idDeLaPublicite = 'liste-de-prix-publique';
var $author$project$I18n$Cles$produitsListeDePrixPrixPublicBascule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.liste-de-prix.prix-public.bascule', _List_Nil, 'Liste publique : ses prix s\'appliquent aux visiteurs non connectés');
};
var $author$project$I18n$Cles$produitsListeDePrixPrixPublicNote = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.liste-de-prix.prix-public.note',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'liste',
					$author$project$I18n$Traductions$Chaine(p.nW))
				]),
			'Une seule liste publique est valide à une date : aujourd\'hui « ' + (p.nW + ' ». Une personne dont le type n\'a pas de liste n\'en hérite pas.'));
	});
var $author$project$I18n$Cles$produitsListeDePrixPrixPublicNoteSansListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.liste-de-prix.prix-public.note.sans-liste', _List_Nil, 'Une seule liste publique est valide à une date. Une personne dont le type n\'a pas de liste n\'en hérite pas.');
};
var $author$project$I18n$Cles$produitsListeDePrixPrixPublicTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.liste-de-prix.prix-public.titre', _List_Nil, 'Prix public');
};
var $author$project$Components$Produits$ListeDePrix$View$prixPublic = F3(
	function (i18n, model, fiche) {
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_Nil,
			{
				fw: _List_Nil,
				fZ: _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Messages$View$view,
						i18n,
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2($elm$core$Maybe$map, $elm$core$List$singleton, model.p3))),
						A2(
						$rtfeldman$elm_css$Html$Styled$fieldset,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$input,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
										$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$ListeDePrix$Model$idDeLaPublicite),
										$rtfeldman$elm_css$Html$Styled$Attributes$checked(fiche.GF),
										$rtfeldman$elm_css$Html$Styled$Events$onCheck($author$project$Components$Produits$ListeDePrix$Update$PubliciteChoisie),
										$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
										_Utils_eq(
											$author$project$Components$Produits$ListeDePrix$Model$lienDeLaPublicite(fiche),
											$elm$core$Maybe$Nothing) || $author$project$Components$Produits$ListeDePrix$View$enEnvoi(model))
									]),
								_List_Nil),
								A2(
								$rtfeldman$elm_css$Html$Styled$label,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$for($author$project$Components$Produits$ListeDePrix$Model$idDeLaPublicite)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsListeDePrixPrixPublicBascule(i18n))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$elm$core$Maybe$withDefault,
									$author$project$I18n$Cles$produitsListeDePrixPrixPublicNoteSansListe(i18n),
									A2(
										$elm$core$Maybe$map,
										function (publique) {
											return A2(
												$author$project$I18n$Cles$produitsListeDePrixPrixPublicNote,
												i18n,
												{nW: publique.Dj.zX});
										},
										fiche.BV)))
							]))
					]),
				Dj: 'prix-public',
				h6: $author$project$I18n$Cles$produitsListeDePrixPrixPublicTitre(i18n)
			});
	});
var $author$project$I18n$Cles$produitsListesDePrixTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.titre', _List_Nil, 'Listes de prix');
};
var $author$project$Components$Produits$ListeDePrix$Update$PublicCoche = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Components$Produits$ListeDePrix$Update$PublicsValides = {$: 17};
var $author$project$I18n$Cles$produitsListesDePrixCartePublics = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.carte.publics', _List_Nil, 'Publics (types de parties prenantes)');
};
var $author$project$I18n$Cles$produitsPrixPublicArchive = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.prix.public.archive',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			p.Bl + ' (archivé)');
	});
var $author$project$I18n$Cles$produitsPrixPublicIndisponible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.prix.public.indisponible', _List_Nil, 'Public indisponible');
};
var $author$project$Components$Produits$Common$Prix$nomDuPublic = F2(
	function (i18n, _public) {
		return _public.AJ ? $author$project$I18n$Cles$produitsPrixPublicIndisponible(i18n) : (_public.tE ? A2(
			$author$project$I18n$Cles$produitsPrixPublicArchive,
			i18n,
			{Bl: _public.Bl}) : _public.Bl);
	});
var $author$project$Components$Produits$Common$Prix$publics = F2(
	function (i18n, portes) {
		return A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				$author$project$Components$Produits$Common$Prix$nomDuPublic(i18n),
				portes));
	});
var $author$project$Components$Produits$Common$Publics$cases = F2(
	function (i18n, groupe) {
		var uneCase = F2(
			function (rang, _public) {
				var ancre = groupe.pv + ('-public-' + $elm$core$String$fromInt(rang));
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('choix')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id(ancre),
									$rtfeldman$elm_css$Html$Styled$Attributes$checked(
									A2($elm$core$List$member, _public.Hb, groupe.at)),
									$rtfeldman$elm_css$Html$Styled$Events$onCheck(
									groupe.D9(_public.Hb))
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$for(ancre)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$Components$Produits$Common$Prix$publics,
										i18n,
										_List_fromArray(
											[_public])))
								]))
						]));
			});
		return A2(
			$author$project$Components$Shared$Champ$View$compose,
			{
				go: $elm$core$Maybe$Nothing,
				Aq: groupe.pv + '-publics',
				Bl: $author$project$I18n$Cles$produitsListesDePrixCartePublics(i18n),
				he: false
			},
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('liste-de-choix')
						]),
					A2($elm$core$List$indexedMap, uneCase, groupe.Gv))
				]));
	});
var $author$project$I18n$Cles$produitsListeDePrixPublicsValider = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.liste-de-prix.publics.valider', _List_Nil, 'Enregistrer les publics');
};
var $author$project$Components$Produits$ListeDePrix$View$publics = F3(
	function (i18n, model, fiche) {
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.kX);
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Produits$ListeDePrix$Update$DuDrawer,
			$author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) ? {
				fs: {
					sR: !$author$project$Components$Produits$ListeDePrix$View$enEnvoi(model),
					Bl: $author$project$I18n$Cles$produitsListeDePrixPublicsValider(i18n),
					C$: $author$project$Components$Produits$ListeDePrix$Update$PublicsValides
				},
				fZ: _List_fromArray(
					[
						A2($author$project$Components$Shared$Messages$View$view, i18n, model.p7),
						A2(
						$author$project$Components$Produits$Common$Publics$cases,
						i18n,
						{
							at: model.X,
							D9: $author$project$Components$Produits$ListeDePrix$Update$PublicCoche,
							pv: prefixe,
							Gv: $author$project$Components$Produits$ListeDePrix$Model$publicsAChoisir(fiche)
						})
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$produitsListeDePrixPublicsModifier(i18n)
			} : {
				fs: {sR: false, Bl: '', C$: $author$project$Components$Produits$ListeDePrix$Update$PublicsValides},
				fZ: _List_Nil,
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: ''
			},
			model.kX);
	});
var $author$project$Catalogue$Vocabulaire$etatDeListeEchue = 'echue';
var $author$project$I18n$Cles$produitsListeDePrixNature = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.liste-de-prix.nature', _List_Nil, 'Liste de prix');
};
var $author$project$I18n$Cles$produitsListeDePrixPublics = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.liste-de-prix.publics',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'publics',
					$author$project$I18n$Traductions$Chaine(p.GA))
				]),
			'publics : ' + p.GA);
	});
var $author$project$I18n$Cles$produitsListesDePrixCarteEnConflit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.carte.en-conflit', _List_Nil, 'En conflit');
};
var $author$project$I18n$Cles$produitsListesDePrixCartePublique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.carte.publique', _List_Nil, 'Liste publique');
};
var $author$project$I18n$Cles$produitsListesDePrixCarteVisiteurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.carte.visiteurs', _List_Nil, 'visiteurs non connectés (prix public)');
};
var $author$project$I18n$Cles$produitsPrixEtatEchue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.prix.etat.echue', _List_Nil, 'Échue');
};
var $author$project$I18n$Cles$produitsPrixTaxesExonerees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.prix.taxes.exonerees', _List_Nil, 'TVA exonérée');
};
var $author$project$I18n$Cles$produitsPrixTaxesHorsTaxe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.prix.taxes.hors-taxe',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'taux',
					$author$project$I18n$Traductions$Chaine(p.rA))
				]),
			'HT, TVA ' + (p.rA + ' %'));
	});
var $author$project$I18n$Cles$produitsPrixTaxesToutesTaxesComprises = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.prix.taxes.toutes-taxes-comprises',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'taux',
					$author$project$I18n$Traductions$Chaine(p.rA))
				]),
			'TTC, TVA ' + (p.rA + ' %'));
	});
var $author$project$Components$Produits$Common$Prix$taux = function (ecrit) {
	var sansZeroFinal = F2(
		function (chiffre, garde) {
			return ((garde === '') && (chiffre === '0')) ? '' : A2($elm$core$String$cons, chiffre, garde);
		});
	var _v0 = A2($elm$core$String$split, '.', ecrit);
	if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
		var entier = _v0.a;
		var _v1 = _v0.b;
		var decimales = _v1.a;
		var _v2 = A3($elm$core$String$foldr, sansZeroFinal, '', decimales);
		if (_v2 === '') {
			return entier;
		} else {
			var utiles = _v2;
			return entier + (',' + utiles);
		}
	} else {
		return ecrit;
	}
};
var $author$project$Components$Produits$Common$Prix$taxes = F2(
	function (i18n, portees) {
		switch (portees.$) {
			case 0:
				return $author$project$I18n$Cles$produitsPrixTaxesExonerees(i18n);
			case 1:
				var ecrit = portees.a;
				return A2(
					$author$project$I18n$Cles$produitsPrixTaxesHorsTaxe,
					i18n,
					{
						rA: $author$project$Components$Produits$Common$Prix$taux(ecrit)
					});
			default:
				var ecrit = portees.a;
				return A2(
					$author$project$I18n$Cles$produitsPrixTaxesToutesTaxesComprises,
					i18n,
					{
						rA: $author$project$Components$Produits$Common$Prix$taux(ecrit)
					});
		}
	});
var $author$project$Components$Produits$ListeDePrix$View$resume = F2(
	function (i18n, fiche) {
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsListeDePrixNature(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('publics')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$produitsListeDePrixPublics,
								i18n,
								{
									GA: (!$elm$core$List$isEmpty(fiche.GA)) ? A2($author$project$Components$Produits$Common$Prix$publics, i18n, fiche.GA) : (fiche.GF ? $author$project$I18n$Cles$produitsListesDePrixCarteVisiteurs(i18n) : $author$project$I18n$Cles$produitsCatalogueInfoSansValeur(i18n))
								}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('taxes')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Produits$Common$Prix$taxes, i18n, fiche.rB))
						]))
				]),
			_Utils_ap(
				fiche.GF ? _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Tag$View$view,
						0,
						$author$project$I18n$Cles$produitsListesDePrixCartePublique(i18n))
					]) : _List_Nil,
				_Utils_ap(
					_Utils_eq(fiche.gt, $author$project$Catalogue$Vocabulaire$etatDeListeEchue) ? _List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							3,
							$author$project$I18n$Cles$produitsPrixEtatEchue(i18n))
						]) : _List_Nil,
					fiche.yi ? _List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							1,
							$author$project$I18n$Cles$produitsListesDePrixCarteEnConflit(i18n))
						]) : _List_Nil)));
	});
var $author$project$Components$Produits$ListeDePrix$View$page = F4(
	function (i18n, messages, model, fiche) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			$author$project$Components$Produits$ListeDePrix$View$nomDeLaPage,
			{
				ut: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						_List_fromArray(
							[
								A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('envoi'),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$Components$Produits$ListeDePrix$View$enEnvoi(model) ? $author$project$I18n$Cles$produitsStructureEnvoiEnCours(i18n) : '')
									])),
								A3($author$project$Components$Produits$ListeDePrix$View$prixPublic, i18n, model, fiche),
								A3($author$project$Components$Produits$ListeDePrix$View$lignes, i18n, model, fiche)
							]))
					]),
				xy: _List_fromArray(
					[
						A3($author$project$Components$Produits$ListeDePrix$View$publics, i18n, model, fiche)
					]),
				zM: A2($author$project$Components$Produits$ListeDePrix$View$actions, i18n, fiche),
				AK: $author$project$Components$Produits$ListeDePrix$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('resume')
									]),
								A2($author$project$Components$Produits$ListeDePrix$View$resume, i18n, fiche))
							]),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adresseListesDePrix,
								Dj: $author$project$I18n$Cles$produitsTitre(i18n)
							},
								{
								aa: $author$project$Routes$Route$adresseListesDePrix,
								Dj: $author$project$I18n$Cles$produitsListesDePrixTitre(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: fiche.Dj.zX
					})
			});
	});
var $author$project$Components$Produits$ListeDePrix$View$view = F3(
	function (i18n, messages, model) {
		var _v0 = _Utils_Tuple2(model.nf, model.zo);
		if (_v0.a) {
			return A2(
				$author$project$Components$Shared$Introuvable$View$view,
				i18n,
				{
					aa: $author$project$Routes$Route$adresseListesDePrix,
					Bl: $author$project$I18n$Cles$produitsListeDePrixRetour(i18n)
				});
		} else {
			if (!_v0.b.$) {
				var fiche = _v0.b.a;
				return A4($author$project$Components$Produits$ListeDePrix$View$page, i18n, messages, model, fiche);
			} else {
				var _v1 = _v0.b;
				return A2(
					$author$project$Components$Shared$Page$View$page,
					$author$project$Components$Produits$ListeDePrix$View$nomDeLaPage,
					{
						ut: _List_fromArray(
							[
								A2($author$project$Components$Shared$Messages$View$view, i18n, messages)
							]),
						xy: _List_Nil,
						zM: _List_Nil,
						AK: false,
						JD: _List_Nil
					});
			}
		}
	});
var $author$project$Components$Produits$Listes$Model$Creation = {$: 0};
var $author$project$Components$Produits$Listes$Update$GesteOuvert = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Produits$Listes$Update$GesteDemande = {$: 12};
var $author$project$Components$Produits$Listes$Update$PaysChoisis = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Produits$Listes$Update$Saisi = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Produits$Listes$Update$AttributDeLaValeurSaisi = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$I18n$Cles$listesRefusAttributInvalide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.refus.attribut-invalide', _List_Nil, 'Cet attribut n\'est pas valide.');
};
var $author$project$Components$Produits$Listes$View$attributsDeLaValeur = F3(
	function (i18n, prefixe, model) {
		return A2(
			$elm$core$List$map,
			function (attribut) {
				return A2(
					$author$project$Components$Shared$Champ$View$texte,
					{
						go: A2($elm$core$List$member, attribut.dy, model.fL) ? $elm$core$Maybe$Just(
							$author$project$I18n$Cles$listesRefusAttributInvalide(i18n)) : $elm$core$Maybe$Nothing,
						Aq: prefixe + ('-attribut-' + attribut.dy),
						Bl: attribut.Bl,
						he: false
					},
					{
						hg: $author$project$Components$Produits$Listes$Update$AttributDeLaValeurSaisi(attribut.dy),
						fm: A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Dict$get, attribut.dy, model.fC))
					});
			},
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ho;
					},
					$elm$core$Basics$not),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.i8;
						},
						model.nW))));
	});
var $author$project$I18n$Cles$listesCreer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.creer', _List_Nil, 'Créer la liste');
};
var $author$project$I18n$Cles$listesNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.nom', _List_Nil, 'Nom de la liste');
};
var $author$project$I18n$Cles$listesNouvelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.nouvelle', _List_Nil, 'Nouvelle liste');
};
var $author$project$I18n$Cles$listesPaysChamp = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'listes.pays.champ',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Zone « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$listesPaysRenseigner = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.pays.renseigner', _List_Nil, 'Renseigner les pays');
};
var $author$project$I18n$Cles$listesRefusNomVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.refus.nom-vide', _List_Nil, 'Saisissez le nom de la liste.');
};
var $author$project$I18n$Cles$listesSchemaEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.schema.enregistrer', _List_Nil, 'Enregistrer les attributs');
};
var $author$project$I18n$Cles$listesSchemaTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.schema.titre', _List_Nil, 'Attributs des valeurs');
};
var $author$project$I18n$Cles$listesValeurAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.valeur.ajouter', _List_Nil, 'Ajouter une valeur');
};
var $author$project$I18n$Cles$listesValeurAjouterAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.valeur.ajouter-action', _List_Nil, 'Ajouter');
};
var $author$project$I18n$Cles$listesValeurArchiver = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.valeur.archiver', _List_Nil, 'Archiver la valeur');
};
var $author$project$I18n$Cles$listesValeurArchiverAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.valeur.archiver-action', _List_Nil, 'Archiver');
};
var $author$project$I18n$Cles$listesValeurArchiverNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.valeur.archiver-note', _List_Nil, 'Une valeur archivée n\'est plus proposée. Les fiches qui l\'ont choisie la gardent.');
};
var $author$project$I18n$Cles$listesValeurEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.valeur.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$listesValeurLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.valeur.libelle', _List_Nil, 'Libellé');
};
var $author$project$I18n$Cles$listesValeurRenommer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.valeur.renommer', _List_Nil, 'Renommer la valeur');
};
var $author$project$Components$Produits$Listes$Update$PorteeChoisie = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Produits$Listes$View$libelleDeLaPortee = F2(
	function (i18n, portee) {
		switch (portee) {
			case 0:
				return $author$project$I18n$Cles$listesPorteeCatalogue(i18n);
			case 1:
				return $author$project$I18n$Cles$listesPorteePartiesPrenantes(i18n);
			default:
				return $author$project$I18n$Cles$listesPorteeCatalogueEtPartiesPrenantes(i18n);
		}
	});
var $author$project$I18n$Cles$listesPortee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.portee', _List_Nil, 'Portée');
};
var $author$project$Components$Produits$Listes$Model$portees = _List_fromArray(
	[0, 1, 2]);
var $author$project$Components$Produits$Listes$View$porteeChoisie = F3(
	function (i18n, prefixe, model) {
		return A2(
			$author$project$Components$Shared$Champ$View$liste,
			{
				go: $elm$core$Maybe$Nothing,
				Aq: prefixe + '-portee',
				Bl: $author$project$I18n$Cles$listesPortee(i18n),
				he: true
			},
			{
				hg: $author$project$Components$Produits$Listes$Update$PorteeChoisie,
				o_: A2(
					$elm$core$List$map,
					function (portee) {
						return {
							Bl: A2($author$project$Components$Produits$Listes$View$libelleDeLaPortee, i18n, portee),
							fm: $author$project$Components$Produits$Listes$Model$porteeEnCle(portee)
						};
					},
					$author$project$Components$Produits$Listes$Model$portees),
				fm: $author$project$Components$Produits$Listes$Model$porteeEnCle(model.F$)
			});
	});
var $author$project$Components$Produits$Listes$Update$AttributAjoute = {$: 9};
var $author$project$Components$Produits$Listes$Update$AttributSaisi = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$I18n$Cles$listesSchemaAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.schema.ajouter', _List_Nil, 'Ajouter un attribut');
};
var $author$project$I18n$Cles$listesSchemaLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.schema.libelle', _List_Nil, 'Libellé de la colonne');
};
var $author$project$I18n$Cles$listesSchemaNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.schema.nom', _List_Nil, 'Nom technique');
};
var $author$project$I18n$Cles$listesSchemaNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.schema.note', _List_Nil, 'Chaque attribut devient une colonne de la liste. Un attribut n\'est jamais supprimé.');
};
var $author$project$Components$Produits$Listes$View$schema = F3(
	function (i18n, prefixe, model) {
		return A2(
			$elm$core$List$cons,
			A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$listesSchemaNote(i18n))
					])),
			_Utils_ap(
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (rang, attribut) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('attribut')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Champ$View$texte,
										{
											go: $elm$core$Maybe$Nothing,
											Aq: prefixe + ('-cle-' + $elm$core$String$fromInt(rang)),
											Bl: $author$project$I18n$Cles$listesSchemaNom(i18n),
											he: true
										},
										{
											hg: function (cle) {
												return A3($author$project$Components$Produits$Listes$Update$AttributSaisi, rang, cle, attribut.Bl);
											},
											fm: attribut.dy
										}),
										A2(
										$author$project$Components$Shared$Champ$View$texte,
										{
											go: A2(
												$elm$core$Maybe$map,
												$author$project$I18n$Cles$texte(i18n),
												model.pZ),
											Aq: prefixe + ('-libelle-' + $elm$core$String$fromInt(rang)),
											Bl: $author$project$I18n$Cles$listesSchemaLibelle(i18n),
											he: true
										},
										{
											hg: function (libelle) {
												return A3($author$project$Components$Produits$Listes$Update$AttributSaisi, rang, attribut.dy, libelle);
											},
											fm: attribut.Bl
										})
									]));
						}),
					model.i8),
				_List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						2,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Listes$Update$AttributAjoute)
							]),
						$author$project$I18n$Cles$listesSchemaAjouter(i18n))
					])));
	});
var $author$project$Components$Produits$Listes$View$drawerDuGeste = F2(
	function (i18n, model) {
		var refus = A2(
			$elm$core$Maybe$map,
			$author$project$I18n$Cles$texte(i18n),
			model.pZ);
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.kX);
		var erreurDuChamp = function (vide) {
			return (model.b5 && vide) ? $elm$core$Maybe$Just(
				$author$project$I18n$Cles$listesRefusNomVide(i18n)) : refus;
		};
		var champDeTexte = function (libelle) {
			return A2(
				$author$project$Components$Shared$Champ$View$texte,
				{
					go: erreurDuChamp(
						$elm$core$String$trim(model.hP) === ''),
					Aq: prefixe + '-saisie',
					Bl: libelle,
					he: true
				},
				{hg: $author$project$Components$Produits$Listes$Update$Saisi, fm: model.hP});
		};
		var contenu = function () {
			var _v0 = model.mW;
			if (!_v0.$) {
				switch (_v0.a.$) {
					case 0:
						var _v1 = _v0.a;
						return {
							fs: $author$project$I18n$Cles$listesCreer(i18n),
							f$: _List_fromArray(
								[
									champDeTexte(
									$author$project$I18n$Cles$listesNom(i18n)),
									A3($author$project$Components$Produits$Listes$View$porteeChoisie, i18n, prefixe, model)
								]),
							h6: $author$project$I18n$Cles$listesNouvelle(i18n)
						};
					case 1:
						var _v2 = _v0.a;
						return {
							fs: $author$project$I18n$Cles$listesValeurAjouterAction(i18n),
							f$: A2(
								$elm$core$List$cons,
								champDeTexte(
									$author$project$I18n$Cles$listesValeurLibelle(i18n)),
								A3($author$project$Components$Produits$Listes$View$attributsDeLaValeur, i18n, prefixe, model)),
							h6: $author$project$I18n$Cles$listesValeurAjouter(i18n)
						};
					case 2:
						return {
							fs: $author$project$I18n$Cles$listesValeurEnregistrer(i18n),
							f$: A2(
								$elm$core$List$cons,
								champDeTexte(
									$author$project$I18n$Cles$listesValeurLibelle(i18n)),
								(!_Utils_eq(
									A2($author$project$Components$Produits$Listes$Model$lienDe, $author$project$API$NavLinksDictionary$renseignerLesAttributs, model),
									$elm$core$Maybe$Nothing)) ? A3($author$project$Components$Produits$Listes$View$attributsDeLaValeur, i18n, prefixe, model) : _List_Nil),
							h6: $author$project$I18n$Cles$listesValeurRenommer(i18n)
						};
					case 3:
						return {
							fs: $author$project$I18n$Cles$listesValeurArchiverAction(i18n),
							f$: _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.Bl;
													},
													$author$project$Components$Produits$Listes$Model$valeurDuGeste(model))))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$listesValeurArchiverNote(i18n))
										]))
								]),
							h6: $author$project$I18n$Cles$listesValeurArchiver(i18n)
						};
					case 5:
						var _v3 = _v0.a;
						return {
							fs: $author$project$I18n$Cles$listesValeurEnregistrer(i18n),
							f$: _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$map,
									$author$project$Components$Produits$Listes$Update$PaysChoisis,
									A2(
										$author$project$Components$Shared$Champ$SelecteurNorme$view,
										i18n,
										{
											uN: {
												go: refus,
												Aq: prefixe + '-pays',
												Bl: A2(
													$author$project$I18n$Cles$listesPaysChamp,
													i18n,
													{
														Dj: A2(
															$elm$core$Maybe$withDefault,
															'',
															A2(
																$elm$core$Maybe$map,
																function ($) {
																	return $.Bl;
																},
																$author$project$Components$Produits$Listes$Model$valeurDuGeste(model)))
													}),
												he: false
											},
											yv: $author$project$Referentiel$Normes$entreesDePays(model.hd),
											oJ: $author$project$I18n$Cles$selecteurNormePaysNote(i18n),
											G3: $author$project$I18n$Cles$selecteurNormePaysRechercher(i18n),
											q3: model.hp
										}))
								]),
							h6: A2(
								$elm$core$Maybe$withDefault,
								$author$project$I18n$Cles$listesPaysRenseigner(i18n),
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.Bl;
									},
									$author$project$Components$Produits$Listes$Model$attributDuGeste(model)))
						};
					default:
						var _v4 = _v0.a;
						return {
							fs: $author$project$I18n$Cles$listesSchemaEnregistrer(i18n),
							f$: A3($author$project$Components$Produits$Listes$View$schema, i18n, prefixe, model),
							h6: $author$project$I18n$Cles$listesSchemaTitre(i18n)
						};
				}
			} else {
				return {fs: '', f$: _List_Nil, h6: ''};
			}
		}();
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Produits$Listes$Update$DuDrawer,
			{
				fs: {
					sR: (!$author$project$API$Envoi$enCours(model.l2)) && (!_Utils_eq(model.mW, $elm$core$Maybe$Nothing)),
					Bl: contenu.fs,
					C$: $author$project$Components$Produits$Listes$Update$GesteDemande
				},
				fZ: contenu.f$,
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: contenu.h6
			},
			model.kX);
	});
var $author$project$Components$Produits$Listes$View$ongletsDeLaPage = F2(
	function (i18n, model) {
		return ((!_Utils_eq(model.vf, $elm$core$Maybe$Nothing)) || _Utils_eq(model.np, $elm$core$Maybe$Nothing)) ? _List_Nil : _List_fromArray(
			[
				$author$project$Components$Shared$Onglets$View$view(
				_List_fromArray(
					[
						{
						sO: true,
						aa: $author$project$Routes$Route$adresseListes,
						vW: A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.n_;
								},
								A2($elm$core$Basics$composeR, $elm$core$List$length, $elm$core$String$fromInt)),
							model.aS),
						Dj: $author$project$I18n$Cles$listesOnglet(i18n)
					},
						{
						sO: false,
						aa: $author$project$Routes$Route$adresseCorrespondances,
						vW: A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.wh;
								},
								$elm$core$String$fromInt),
							model.aS),
						Dj: $author$project$I18n$Cles$correspondancesOnglet(i18n)
					}
					]))
			]);
	});
var $author$project$Components$Produits$Listes$View$cadre = F6(
	function (i18n, page, fil, complements, bottom, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			page,
			{
				ut: bottom,
				xy: _List_fromArray(
					[
						A2($author$project$Components$Produits$Listes$View$drawerDuGeste, i18n, model)
					]),
				zM: _List_Nil,
				AK: $author$project$Components$Produits$Listes$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: complements,
						zE: _Utils_ap(
							_List_fromArray(
								[
									{
									aa: $author$project$Routes$Route$adresseTypesDePartiesPrenantes,
									Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
								},
									{
									aa: $author$project$Routes$Route$adresseListes,
									Dj: $author$project$I18n$Cles$listesPageTitre(i18n)
								}
								]),
							fil),
						Ef: A2($author$project$Components$Produits$Listes$View$ongletsDeLaPage, i18n, model),
						h6: $author$project$I18n$Cles$listesPageTitre(i18n)
					})
			});
	});
var $author$project$I18n$Cles$listesNombre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'listes.nombre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' liste') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' listes'));
	});
var $author$project$I18n$Cles$listesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.titre', _List_Nil, 'Listes');
};
var $author$project$I18n$Cles$listesVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.vide', _List_Nil, 'Aucune liste pour le moment.');
};
var $author$project$I18n$Cles$listesUtiliseeParCorrespondances = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'listes.utilisee-par.correspondances',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' correspondance') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' correspondances'));
	});
var $author$project$Components$Produits$Listes$View$correspondances = F2(
	function (i18n, resume) {
		return (!resume.wh) ? '' : (' · ' + A2(
			$author$project$I18n$Cles$listesUtiliseeParCorrespondances,
			i18n,
			{w: resume.wh}));
	});
var $author$project$I18n$Cles$listesUtiliseeParAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.utilisee-par.aucun', _List_Nil, 'aucun champ');
};
var $author$project$I18n$Cles$listesUtiliseeParChamps = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'listes.utilisee-par.champs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w)),
					_Utils_Tuple2(
					'noms',
					$author$project$I18n$Traductions$Chaine(p.DG))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' champ : ' + p.DG)) : (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' champs : ' + p.DG)));
	});
var $author$project$I18n$Cles$listesUtiliseeParChampsSansNoms = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'listes.utilisee-par.champs-sans-noms',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champ') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champs'));
	});
var $author$project$I18n$Cles$listesUtiliseeParPartiesPrenantes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'listes.utilisee-par.parties-prenantes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' type de partie prenante') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' types de partie prenante'));
	});
var $author$project$Components$Produits$Listes$View$utilisation = F2(
	function (i18n, resume) {
		var types = A2(
			$author$project$I18n$Cles$listesUtiliseeParPartiesPrenantes,
			i18n,
			{w: resume.J$});
		var champs = A2(
			$author$project$I18n$Cles$listesUtiliseeParChamps,
			i18n,
			{
				w: resume.Kh,
				DG: A2($elm$core$String$join, ', ', resume.dw)
			});
		return (!resume.J$) ? ((!resume.Kh) ? $author$project$I18n$Cles$listesUtiliseeParAucun(i18n) : champs) : ((!resume.Kh) ? types : (A2(
			$author$project$I18n$Cles$listesUtiliseeParChampsSansNoms,
			i18n,
			{w: resume.Kh}) + (', ' + types)));
	});
var $author$project$Components$Produits$Listes$View$ligneDeListe = F2(
	function (i18n, resume) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('liste')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$liste, resume.nQ.h0);
							if (!_v0.$) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('title'),
											$rtfeldman$elm_css$Html$Styled$Attributes$href(
											$author$project$Routes$Route$adresseDeLaListe(resume.Aq))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(resume.Dj)
										]));
							} else {
								return $rtfeldman$elm_css$Html$Styled$text(resume.Dj);
							}
						}()
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('valeurs')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(resume.Ki))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$Components$Produits$Listes$View$libelleDeLaPortee,
								i18n,
								$author$project$Components$Produits$Listes$Model$porteeDeLaCle(resume.F$)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('aucun', (!resume.Kh) && (!resume.J$))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							_Utils_ap(
								A2($author$project$Components$Produits$Listes$View$utilisation, i18n, resume),
								A2($author$project$Components$Produits$Listes$View$correspondances, i18n, resume)))
						]))
				]));
	});
var $author$project$I18n$Cles$listesColonneListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.colonne-liste', _List_Nil, 'Liste');
};
var $author$project$I18n$Cles$listesUtiliseePar = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.utilisee-par', _List_Nil, 'Utilisée par');
};
var $author$project$I18n$Cles$listesValeurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.valeurs', _List_Nil, 'Valeurs');
};
var $author$project$Components$Produits$Listes$View$tableDesListes = F2(
	function (i18n, listes) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$table,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (nom) {
											return A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(nom)
													]));
										},
										_List_fromArray(
											[
												$author$project$I18n$Cles$listesColonneListe(i18n),
												$author$project$I18n$Cles$listesValeurs(i18n),
												$author$project$I18n$Cles$listesPortee(i18n),
												$author$project$I18n$Cles$listesUtiliseePar(i18n)
											])))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$tbody,
							_List_Nil,
							A2(
								$elm$core$List$map,
								$author$project$Components$Produits$Listes$View$ligneDeListe(i18n),
								listes))
						]))
				]));
	});
var $author$project$Components$Produits$Listes$View$annuaire = F3(
	function (i18n, messages, model) {
		var listes = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.n_;
				},
				model.aS));
		var creer = function () {
			var _v0 = A2($author$project$Components$Produits$Listes$Model$lienDe, $author$project$API$NavLinksDictionary$creerUneListe, model);
			if (!_v0.$) {
				return _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						0,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Listes$Model$idDeLaCreation),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Produits$Listes$Update$GesteOuvert($author$project$Components$Produits$Listes$Model$Creation))
							]),
						$author$project$I18n$Cles$listesNouvelle(i18n))
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A6(
			$author$project$Components$Produits$Listes$View$cadre,
			i18n,
			'parametrage-listes-list',
			_List_fromArray(
				[
					{
					aa: '',
					Dj: $author$project$I18n$Cles$listesOnglet(i18n)
				}
				]),
			_Utils_ap(
				_Utils_eq(model.aS, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Tag$View$view,
						5,
						A2(
							$author$project$I18n$Cles$listesNombre,
							i18n,
							{
								w: $elm$core$List$length(listes)
							}))
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('actions-page')
								]),
							creer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$listesPageDescription(i18n))
								]))
						]))),
			_Utils_eq(model.np, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
						]),
					A2(
						$elm$core$List$cons,
						A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
						_List_fromArray(
							[
								((!_Utils_eq(model.aS, $elm$core$Maybe$Nothing)) && _Utils_eq(listes, _List_Nil)) ? A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$listesVide(i18n))
									])) : A2(
								$author$project$Components$Shared$Page$View$sectionAvecCompte,
								_List_Nil,
								{
									fw: _List_Nil,
									vW: $elm$core$Maybe$Just(
										$elm$core$String$fromInt(
											$elm$core$List$length(listes))),
									fZ: _List_fromArray(
										[
											A2($author$project$Components$Produits$Listes$View$tableDesListes, i18n, listes)
										]),
									Ar: $elm$core$Maybe$Nothing,
									Dj: 'listes',
									h6: $author$project$I18n$Cles$listesTitre(i18n)
								})
							])))
				]),
			model);
	});
var $author$project$Components$Produits$Listes$Model$Ajout = {$: 1};
var $author$project$Components$Produits$Listes$Model$Schema = {$: 4};
var $author$project$I18n$Cles$listesSchemaDefinir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.schema.definir', _List_Nil, 'Définir les attributs');
};
var $author$project$I18n$Cles$listesValeurAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.valeur.aucune', _List_Nil, 'Cette liste n\'a pas encore de valeur.');
};
var $author$project$I18n$Cles$listesValeurArchivees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.valeur.archivees', _List_Nil, 'Archivées');
};
var $author$project$Components$Produits$Listes$Update$ValeurReactivee = function (a) {
	return {$: 14, a: a};
};
var $author$project$I18n$Cles$listesValeurReactiver = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.valeur.reactiver', _List_Nil, 'Réactiver');
};
var $author$project$I18n$Cles$listesValeurReactiverDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'listes.valeur.reactiver-de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Réactiver ' + p.Dj);
	});
var $author$project$Components$Produits$Listes$View$valeurArchivee = F2(
	function (i18n, valeur) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
				]),
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$text(valeur.Bl),
				function () {
					var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reactiverUneValeur, valeur.nQ.h0);
					if (!_v0.$) {
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(' · '),
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('reactiver'),
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
										'aria-label',
										A2(
											$author$project$I18n$Cles$listesValeurReactiverDe,
											i18n,
											{Dj: valeur.Bl})),
										$rtfeldman$elm_css$Html$Styled$Attributes$title(
										A2(
											$author$project$I18n$Cles$listesValeurReactiverDe,
											i18n,
											{Dj: valeur.Bl})),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Produits$Listes$Update$ValeurReactivee(valeur.Aq))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$listesValeurReactiver(i18n))
									]))
							]);
					} else {
						return _List_Nil;
					}
				}()));
	});
var $author$project$Components$Produits$Listes$View$sectionArchivees = F2(
	function (i18n, archivees) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('archivees')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$listesValeurArchivees(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('liste')
						]),
					A2(
						$elm$core$List$map,
						$author$project$Components$Produits$Listes$View$valeurArchivee(i18n),
						archivees))
				]));
	});
var $author$project$Components$Produits$Listes$Model$Masquage = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$Listes$Model$Renommage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$Listes$Update$ValeurRangee = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Components$Produits$Listes$Model$Pays = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$I18n$Cles$listesPaysRenseignerAttributDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'listes.pays.renseigner-attribut-de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'attribut',
					$author$project$I18n$Traductions$Chaine(p.tV)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Renseigner « ' + (p.tV + (' » de ' + p.Dj)));
	});
var $author$project$Components$Produits$Listes$View$boutonDesPays = F3(
	function (i18n, valeur, attribut) {
		var nom = A2(
			$author$project$I18n$Cles$listesPaysRenseignerAttributDe,
			i18n,
			{tV: attribut.Bl, Dj: valeur.Bl});
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('secondary'),
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$id(
					$author$project$Components$Produits$Listes$Model$idDuDeclencheur(
						A2($author$project$Components$Produits$Listes$Model$Pays, valeur.Aq, attribut.dy))),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', nom),
					$rtfeldman$elm_css$Html$Styled$Attributes$title(nom),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Components$Produits$Listes$Update$GesteOuvert(
						A2($author$project$Components$Produits$Listes$Model$Pays, valeur.Aq, attribut.dy)))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(attribut.Bl)
						]))
				]));
	});
var $author$project$I18n$Cles$listesValeurArchiverDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'listes.valeur.archiver-de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Archiver ' + p.Dj);
	});
var $author$project$I18n$Cles$listesValeurDescendreDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'listes.valeur.descendre-de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Descendre ' + p.Dj);
	});
var $author$project$I18n$Cles$listesValeurMonterDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'listes.valeur.monter-de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Monter ' + p.Dj);
	});
var $author$project$I18n$Cles$listesValeurRenommerDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'listes.valeur.renommer-de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Renommer ' + p.Dj);
	});
var $author$project$I18n$Cles$listesPaysAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.pays.aucun', _List_Nil, 'Aucun pays renseigné');
};
var $author$project$Components$Produits$Listes$View$paysDeLaValeur = F3(
	function (i18n, normes, codes) {
		return $elm$core$List$isEmpty(codes) ? A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$I18n$Cles$listesPaysAucun(i18n))
				])) : A3(
			$author$project$Components$Shared$Champ$SelecteurNorme$lecture,
			i18n,
			$author$project$Referentiel$Normes$entreesDePays(normes),
			codes);
	});
var $author$project$Components$Produits$Listes$View$ligne = F6(
	function (i18n, model, liste, rangs, rang, valeur) {
		var offert = function (rel) {
			return !_Utils_eq(
				A2($author$project$Components$Produits$Listes$Model$lienDe, rel, model),
				$elm$core$Maybe$Nothing);
		};
		var iconeDe = F4(
			function (attributs, nom, msg, svg) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_Utils_ap(
						attributs,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('button-icon'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', nom),
								$rtfeldman$elm_css$Html$Styled$Attributes$title(nom),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
							])),
					_List_fromArray(
						[svg]));
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('masquee', valeur.Ca)
						]))
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(valeur.Bl)
						])),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						function (attribut) {
							return attribut.ho ? A2(
								$rtfeldman$elm_css$Html$Styled$td,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('attribut'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('pays')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Components$Produits$Listes$View$paysDeLaValeur,
										i18n,
										model.hd,
										A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2($elm$core$Dict$get, attribut.dy, valeur.ho)))
									])) : A2(
								$rtfeldman$elm_css$Html$Styled$td,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('attribut')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2($elm$core$Dict$get, attribut.dy, valeur.i8)))
									]));
						},
						liste.i8),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$td,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('gestes')
								]),
							_Utils_ap(
								(offert($author$project$API$NavLinksDictionary$rangerUneValeur) && (rang > 0)) ? _List_fromArray(
									[
										A4(
										iconeDe,
										_List_Nil,
										A2(
											$author$project$I18n$Cles$listesValeurMonterDe,
											i18n,
											{Dj: valeur.Bl}),
										A2($author$project$Components$Produits$Listes$Update$ValeurRangee, valeur.Aq, rang - 1),
										$author$project$Components$Shared$Svg$svgChevronUp)
									]) : _List_Nil,
								_Utils_ap(
									(offert($author$project$API$NavLinksDictionary$rangerUneValeur) && (_Utils_cmp(rang, rangs - 1) < 0)) ? _List_fromArray(
										[
											A4(
											iconeDe,
											_List_Nil,
											A2(
												$author$project$I18n$Cles$listesValeurDescendreDe,
												i18n,
												{Dj: valeur.Bl}),
											A2($author$project$Components$Produits$Listes$Update$ValeurRangee, valeur.Aq, rang + 1),
											$author$project$Components$Shared$Svg$svgChevronDown)
										]) : _List_Nil,
									_Utils_ap(
										offert($author$project$API$NavLinksDictionary$renseignerLesAttributs) ? A2(
											$elm$core$List$map,
											A2($author$project$Components$Produits$Listes$View$boutonDesPays, i18n, valeur),
											$author$project$Components$Produits$Listes$Model$attributsDePays(model)) : _List_Nil,
										_Utils_ap(
											offert($author$project$API$NavLinksDictionary$renommerUneValeur) ? _List_fromArray(
												[
													A4(
													iconeDe,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$id(
															$author$project$Components$Produits$Listes$Model$idDuDeclencheur(
																$author$project$Components$Produits$Listes$Model$Renommage(valeur.Aq)))
														]),
													A2(
														$author$project$I18n$Cles$listesValeurRenommerDe,
														i18n,
														{Dj: valeur.Bl}),
													$author$project$Components$Produits$Listes$Update$GesteOuvert(
														$author$project$Components$Produits$Listes$Model$Renommage(valeur.Aq)),
													$author$project$Components$Shared$Svg$svgEdit)
												]) : _List_Nil,
											(offert($author$project$API$NavLinksDictionary$masquerUneValeur) && (!valeur.Ca)) ? _List_fromArray(
												[
													A4(
													iconeDe,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$id(
															$author$project$Components$Produits$Listes$Model$idDuDeclencheur(
																$author$project$Components$Produits$Listes$Model$Masquage(valeur.Aq)))
														]),
													A2(
														$author$project$I18n$Cles$listesValeurArchiverDe,
														i18n,
														{Dj: valeur.Bl}),
													$author$project$Components$Produits$Listes$Update$GesteOuvert(
														$author$project$Components$Produits$Listes$Model$Masquage(valeur.Aq)),
													$author$project$Components$Shared$Svg$svgHideFilters)
												]) : _List_Nil)))))
						]))));
	});
var $author$project$Components$Produits$Listes$View$tableDesActives = F4(
	function (i18n, model, liste, rangs) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$table,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('valeurs')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$tr,
							_List_Nil,
							A2(
								$elm$core$List$cons,
								A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$listesValeurLibelle(i18n))
										])),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										function (attribut) {
											return A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(attribut.Bl)
													]));
										},
										liste.i8),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_Nil)
										]))))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (_v0) {
							var rang = _v0.a;
							var valeur = _v0.b;
							return A6($author$project$Components$Produits$Listes$View$ligne, i18n, model, liste, rangs, rang, valeur);
						},
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$second,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.Ca;
									},
									$elm$core$Basics$not)),
							A2(
								$elm$core$List$indexedMap,
								F2(
									function (rang, valeur) {
										return _Utils_Tuple2(rang, valeur);
									}),
								liste.Ki))))
				]));
	});
var $author$project$Components$Produits$Listes$View$tableau = F3(
	function (i18n, model, liste) {
		var rangs = $elm$core$List$length(liste.Ki);
		var archivees = A2(
			$elm$core$List$filter,
			function ($) {
				return $.Ca;
			},
			liste.Ki);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('valeurs-de-la-liste')
				]),
			_List_fromArray(
				[
					A4($author$project$Components$Produits$Listes$View$tableDesActives, i18n, model, liste, rangs),
					_Utils_eq(archivees, _List_Nil) ? $rtfeldman$elm_css$Html$Styled$text('') : A2($author$project$Components$Produits$Listes$View$sectionArchivees, i18n, archivees)
				]));
	});
var $author$project$Components$Produits$Listes$View$fiche = F4(
	function (i18n, messages, model, liste) {
		var offert = function (rel) {
			return !_Utils_eq(
				A2($author$project$Components$Produits$Listes$Model$lienDe, rel, model),
				$elm$core$Maybe$Nothing);
		};
		var action = F3(
			function (rel, geste, libelle) {
				return offert(rel) ? _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id(
								$author$project$Components$Produits$Listes$Model$idDuDeclencheur(geste)),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Produits$Listes$Update$GesteOuvert(geste))
							]),
						libelle)
					]) : _List_Nil;
			});
		var actions = _Utils_ap(
			A3(
				action,
				$author$project$API$NavLinksDictionary$ajouterUneValeur,
				$author$project$Components$Produits$Listes$Model$Ajout,
				$author$project$I18n$Cles$listesValeurAjouter(i18n)),
			A3(
				action,
				$author$project$API$NavLinksDictionary$definirLeSchemaDAttributs,
				$author$project$Components$Produits$Listes$Model$Schema,
				$author$project$I18n$Cles$listesSchemaDefinir(i18n)));
		return A6(
			$author$project$Components$Produits$Listes$View$cadre,
			i18n,
			'parametrage-liste-detail',
			_List_fromArray(
				[
					{aa: '', Dj: liste.Dj}
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('tags')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							5,
							A2(
								$author$project$Components$Produits$Listes$View$libelleDeLaPortee,
								i18n,
								$author$project$Components$Produits$Listes$Model$porteeDeLaCle(liste.F$)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
						]),
					A2(
						$elm$core$List$cons,
						A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
									]),
								actions),
								_Utils_eq(liste.Ki, _List_Nil) ? A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$listesValeurAucune(i18n))
									])) : A3($author$project$Components$Produits$Listes$View$tableau, i18n, model, liste)
							])))
				]),
			model);
	});
var $author$project$I18n$Cles$listesRetour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.retour', _List_Nil, 'Retour aux listes');
};
var $author$project$Components$Produits$Listes$View$view = F3(
	function (i18n, messages, model) {
		var _v0 = _Utils_Tuple3(model.nf, model.vf, model.nW);
		if (_v0.a) {
			return A2(
				$author$project$Components$Shared$Introuvable$View$view,
				i18n,
				{
					aa: $author$project$Routes$Route$adresseListes,
					Bl: $author$project$I18n$Cles$listesRetour(i18n)
				});
		} else {
			if (!_v0.b.$) {
				if (!_v0.c.$) {
					var liste = _v0.c.a;
					return A4($author$project$Components$Produits$Listes$View$fiche, i18n, messages, model, liste);
				} else {
					var _v1 = _v0.c;
					return A3(
						$author$project$Components$Produits$Listes$View$annuaire,
						i18n,
						messages,
						_Utils_update(
							model,
							{aS: $elm$core$Maybe$Nothing}));
				}
			} else {
				var _v2 = _v0.b;
				return A3($author$project$Components$Produits$Listes$View$annuaire, i18n, messages, model);
			}
		}
	});
var $author$project$Components$Produits$ListesDePrix$Update$DeLaListe = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Produits$ListesDePrix$Update$CreationDemandee = {$: 8};
var $author$project$Components$Produits$ListesDePrix$Update$Saisi = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Produits$ListesDePrix$Creation$Debut = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Produits$ListesDePrix$Creation$Devise = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$ListesDePrix$Creation$Fin = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Produits$ListesDePrix$Creation$Nom = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Produits$ListesDePrix$Creation$PublicCoche = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Produits$ListesDePrix$Creation$Regime = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$ListesDePrix$Creation$Taux = function (a) {
	return {$: 4, a: a};
};
var $author$project$I18n$Cles$produitsListesDePrixCreationFinAvantLeDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.creation.fin.avant-le-debut', _List_Nil, 'La fin précède le début.');
};
var $author$project$I18n$Cles$produitsListesDePrixCreationTauxInvalide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.creation.taux.invalide', _List_Nil, 'Un taux entre 0 et 100, à deux décimales au plus.');
};
var $author$project$Components$Produits$ListesDePrix$Creation$erreur = F3(
	function (i18n, saisie, zone) {
		return (saisie.b5 && A2(
			$elm$core$List$member,
			zone,
			$author$project$Components$Produits$ListesDePrix$Creation$fautes(saisie))) ? $elm$core$Maybe$Just(
			function () {
				switch (zone) {
					case 0:
						return $author$project$I18n$Cles$produitsCatalogueChampNomObligatoire(i18n);
					case 2:
						return $author$project$I18n$Cles$produitsListesDePrixCreationTauxInvalide(i18n);
					case 4:
						return $author$project$Components$Produits$ListesDePrix$Creation$blanc(saisie.mI) ? $author$project$I18n$Cles$saisieDeChampObligatoire(i18n) : $author$project$I18n$Cles$produitsListesDePrixCreationFinAvantLeDebut(i18n);
					default:
						return $author$project$I18n$Cles$saisieDeChampObligatoire(i18n);
				}
			}()) : A2(
			$elm$core$Maybe$andThen,
			function (_v1) {
				var fautive = _v1.a;
				var texte = _v1.b;
				return _Utils_eq(fautive, zone) ? $elm$core$Maybe$Just(
					A2($author$project$I18n$Cles$texte, i18n, texte)) : $elm$core$Maybe$Nothing;
			},
			saisie.bf);
	});
var $author$project$Components$Produits$ListesDePrix$Creation$erreurDuNom = F3(
	function (i18n, saisie, code) {
		return A3($author$project$Components$Produits$Common$LibellesSaisis$manque, saisie.b5, saisie.Dj, code) ? $elm$core$Maybe$Just(
			$author$project$I18n$Cles$produitsCatalogueChampNomObligatoire(i18n)) : (_Utils_eq(
			$author$project$Components$Produits$Common$LibellesSaisis$premiereObligatoire,
			$elm$core$Maybe$Just(code)) ? A2(
			$elm$core$Maybe$andThen,
			function (_v0) {
				var fautive = _v0.a;
				var texte = _v0.b;
				return (!fautive) ? $elm$core$Maybe$Just(
					A2($author$project$I18n$Cles$texte, i18n, texte)) : $elm$core$Maybe$Nothing;
			},
			saisie.bf) : $elm$core$Maybe$Nothing);
	});
var $author$project$I18n$Cles$produitsListesDePrixCarteTaxes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.carte.taxes', _List_Nil, 'Taxes');
};
var $author$project$I18n$Cles$produitsListesDePrixCreationDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.creation.debut', _List_Nil, 'Début');
};
var $author$project$I18n$Cles$produitsListesDePrixCreationDevise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.creation.devise', _List_Nil, 'Devise');
};
var $author$project$I18n$Cles$produitsListesDePrixCreationFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.creation.fin', _List_Nil, 'Fin');
};
var $author$project$I18n$Cles$produitsListesDePrixCreationHorsTaxe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.creation.hors-taxe', _List_Nil, 'HT');
};
var $author$project$I18n$Cles$produitsListesDePrixCreationTaux = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.creation.taux', _List_Nil, 'Taux de TVA (%)');
};
var $author$project$I18n$Cles$produitsListesDePrixCreationToutesTaxesComprises = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.creation.toutes-taxes-comprises', _List_Nil, 'TTC');
};
var $author$project$Components$Produits$ListesDePrix$View$formulaire = F3(
	function (i18n, model, annuaire) {
		var saisie = model.hP;
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.kX);
		var sansErreur = F2(
			function (suffixe, libelle) {
				return {go: $elm$core$Maybe$Nothing, Aq: prefixe + ('-' + suffixe), Bl: libelle, he: false};
			});
		var champ = F3(
			function (zone, libelle, obligatoire) {
				return {
					go: A3($author$project$Components$Produits$ListesDePrix$Creation$erreur, i18n, saisie, zone),
					Aq: A2($author$project$Components$Produits$ListesDePrix$Creation$idDe, prefixe, zone),
					Bl: libelle,
					he: obligatoire
				};
			});
		var avecTaux = !_Utils_eq(saisie.c4, $author$project$Catalogue$Vocabulaire$taxesExonerees);
		return _Utils_ap(
			_List_fromArray(
				[
					A2($author$project$Components$Shared$Messages$View$view, i18n, saisie.pZ),
					A3(
					$author$project$Components$Shared$LibellesParLangue$View$view,
					i18n,
					_List_Nil,
					{
						go: A2($author$project$Components$Produits$ListesDePrix$Creation$erreurDuNom, i18n, saisie),
						Ba: $author$project$Referentiel$Langues$desLibelles,
						Bl: $author$project$I18n$Cles$produitsCatalogueChampNom(i18n),
						hg: $author$project$Components$Produits$ListesDePrix$Creation$Nom,
						pv: $author$project$Components$Produits$ListesDePrix$Creation$prefixeDuNom(prefixe),
						fm: function (code) {
							return A2($author$project$Components$Shared$LibellesParLangue$Model$lire, code, saisie.Dj);
						}
					}),
					A2(
					$author$project$Components$Produits$Common$Publics$cases,
					i18n,
					{
						at: saisie.GA,
						D9: $author$project$Components$Produits$ListesDePrix$Creation$PublicCoche,
						pv: prefixe,
						Gv: $author$project$Components$Produits$ListesDePrix$Creation$proposes(annuaire)
					}),
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					A3(
						champ,
						1,
						$author$project$I18n$Cles$produitsListesDePrixCreationDevise(i18n),
						true),
					{
						hg: $author$project$Components$Produits$ListesDePrix$Creation$Devise,
						o_: A2(
							$elm$core$List$map,
							function (code) {
								return {
									Bl: A2($author$project$Catalogue$Vocabulaire$symboleDeDevise, i18n, code),
									fm: code
								};
							},
							annuaire.xx),
						fm: A2($elm$core$List$member, saisie.kO, annuaire.xx) ? saisie.kO : ''
					}),
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					A2(
						sansErreur,
						'taxes',
						$author$project$I18n$Cles$produitsListesDePrixCarteTaxes(i18n)),
					{
						hg: $author$project$Components$Produits$ListesDePrix$Creation$Regime,
						o_: _List_fromArray(
							[
								{
								Bl: $author$project$I18n$Cles$produitsPrixTaxesExonerees(i18n),
								fm: $author$project$Catalogue$Vocabulaire$taxesExonerees
							},
								{
								Bl: $author$project$I18n$Cles$produitsListesDePrixCreationHorsTaxe(i18n),
								fm: $author$project$Catalogue$Vocabulaire$taxesHorsTaxe
							},
								{
								Bl: $author$project$I18n$Cles$produitsListesDePrixCreationToutesTaxesComprises(i18n),
								fm: $author$project$Catalogue$Vocabulaire$taxesToutesTaxesComprises
							}
							]),
						fm: saisie.c4
					})
				]),
			_Utils_ap(
				avecTaux ? _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Champ$View$texte,
						A3(
							champ,
							2,
							$author$project$I18n$Cles$produitsListesDePrixCreationTaux(i18n),
							true),
						{hg: $author$project$Components$Produits$ListesDePrix$Creation$Taux, fm: saisie.rA})
					]) : _List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Champ$View$date,
						A3(
							champ,
							3,
							$author$project$I18n$Cles$produitsListesDePrixCreationDebut(i18n),
							true),
						{hg: $author$project$Components$Produits$ListesDePrix$Creation$Debut, fm: saisie.ku}),
						A2(
						$author$project$Components$Shared$Champ$View$date,
						A3(
							champ,
							4,
							$author$project$I18n$Cles$produitsListesDePrixCreationFin(i18n),
							true),
						{hg: $author$project$Components$Produits$ListesDePrix$Creation$Fin, fm: saisie.mI})
					])));
	});
var $author$project$I18n$Cles$produitsListesDePrixCreationTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.creation.titre', _List_Nil, 'Nouvelle liste');
};
var $author$project$I18n$Cles$produitsListesDePrixCreationValider = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.creation.valider', _List_Nil, 'Créer la liste');
};
var $author$project$Components$Produits$ListesDePrix$View$creation = F2(
	function (i18n, model) {
		var ferme = {
			fs: {sR: false, Bl: '', C$: $author$project$Components$Produits$ListesDePrix$Update$CreationDemandee},
			fZ: _List_Nil,
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: $author$project$I18n$Cles$produitsListesDePrixCreationTitre(i18n)
		};
		var contenu = function () {
			var _v0 = _Utils_Tuple2(
				model.aS,
				A2($elm$core$Maybe$andThen, $author$project$Components$Produits$ListesDePrix$Model$creation, model.aS));
			if ((!_v0.a.$) && (!_v0.b.$)) {
				var annuaire = _v0.a.a;
				return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) ? {
					fs: {
						sR: !$author$project$Components$Produits$Common$Envoi$enCours(model.l2),
						Bl: $author$project$I18n$Cles$produitsListesDePrixCreationValider(i18n),
						C$: $author$project$Components$Produits$ListesDePrix$Update$CreationDemandee
					},
					fZ: A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Produits$ListesDePrix$Update$Saisi),
						A3($author$project$Components$Produits$ListesDePrix$View$formulaire, i18n, model, annuaire)),
					A6: $elm$core$Maybe$Nothing,
					Bc: false,
					h6: $author$project$I18n$Cles$produitsListesDePrixCreationTitre(i18n)
				} : ferme;
			} else {
				return ferme;
			}
		}();
		return A4($author$project$Components$Shared$Drawer$View$view, i18n, $author$project$Components$Produits$ListesDePrix$Update$DuDrawer, contenu, model.kX);
	});
var $author$project$Components$Produits$ListesDePrix$Update$CreationOuverte = {$: 6};
var $author$project$I18n$Cles$produitsListesDePrixCarteLignes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.carte.lignes', _List_Nil, 'Lignes');
};
var $author$project$I18n$Cles$produitsListesDePrixCartePublicsSansType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.carte.publics.sans-type', _List_Nil, 'Publics');
};
var $author$project$I18n$Cles$produitsListesDePrixCarteValidite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.carte.validite', _List_Nil, 'Validité');
};
var $author$project$I18n$Cles$produitsPrixValidite = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.prix.validite',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'debut',
					$author$project$I18n$Traductions$Chaine(p.ku)),
					_Utils_Tuple2(
					'fin',
					$author$project$I18n$Traductions$Chaine(p.mI))
				]),
			p.ku + (' → ' + p.mI));
	});
var $author$project$Components$Produits$Common$Prix$validite = F2(
	function (i18n, periode) {
		return A2(
			$author$project$I18n$Cles$produitsPrixValidite,
			i18n,
			{
				ku: A2($author$project$Texte$Jour$enFrancais, i18n, periode.ku),
				mI: A2($author$project$Texte$Jour$enFrancais, i18n, periode.mI)
			});
	});
var $author$project$Components$Produits$ListesDePrix$View$entree = F2(
	function (i18n, liste) {
		return {
			aa: liste.Ex ? $elm$core$Maybe$Just(
				$author$project$Routes$Route$adresseListeDePrix(liste.Aq)) : $elm$core$Maybe$Nothing,
			Aq: $author$project$Catalogue$Identifiants$listeDePrixIdToString(liste.Aq),
			m9: $elm$core$Maybe$Nothing,
			gL: _List_fromArray(
				[
					(liste.GF && $elm$core$List$isEmpty(liste.GA)) ? _Utils_Tuple2(
					$author$project$I18n$Cles$produitsListesDePrixCartePublicsSansType(i18n),
					$author$project$I18n$Cles$produitsListesDePrixCarteVisiteurs(i18n)) : _Utils_Tuple2(
					$author$project$I18n$Cles$produitsListesDePrixCartePublics(i18n),
					$elm$core$List$isEmpty(liste.GA) ? $author$project$I18n$Cles$produitsCatalogueInfoSansValeur(i18n) : A2($author$project$Components$Produits$Common$Prix$publics, i18n, liste.GA)),
					_Utils_Tuple2(
					$author$project$I18n$Cles$produitsListesDePrixCarteTaxes(i18n),
					A2($author$project$Components$Produits$Common$Prix$taxes, i18n, liste.rB)),
					_Utils_Tuple2(
					$author$project$I18n$Cles$produitsListesDePrixCarteValidite(i18n),
					A2($author$project$Components$Produits$Common$Prix$validite, i18n, liste.sk)),
					_Utils_Tuple2(
					$author$project$I18n$Cles$produitsListesDePrixCarteLignes(i18n),
					$elm$core$String$fromInt(liste.gV))
				]),
			ry: A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						liste.GF ? $elm$core$Maybe$Just(
						_Utils_Tuple2(
							0,
							$author$project$I18n$Cles$produitsListesDePrixCartePublique(i18n))) : $elm$core$Maybe$Nothing,
						_Utils_eq(liste.gt, $author$project$Catalogue$Vocabulaire$etatDeListeEchue) ? $elm$core$Maybe$Just(
						_Utils_Tuple2(
							3,
							$author$project$I18n$Cles$produitsPrixEtatEchue(i18n))) : $elm$core$Maybe$Nothing,
						liste.yi ? $elm$core$Maybe$Just(
						_Utils_Tuple2(
							1,
							$author$project$I18n$Cles$produitsListesDePrixCarteEnConflit(i18n))) : $elm$core$Maybe$Nothing
					])),
			rz: _List_Nil,
			h6: liste.Dj.zX
		};
	});
var $author$project$I18n$Cles$produitsListesDePrixAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.aucune', _List_Nil, 'Aucune liste de prix pour l\'instant.');
};
var $author$project$I18n$Cles$produitsListesDePrixNombre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.listes-de-prix.nombre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' liste de prix') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' listes de prix'));
	});
var $author$project$Components$Produits$ListesDePrix$View$donnees = F2(
	function (i18n, model) {
		return {
			sQ: _List_Nil,
			ue: true,
			uf: false,
			uh: false,
			ui: false,
			uH: false,
			u7: _Utils_eq(model.aS, $elm$core$Maybe$Nothing),
			vG: _List_Nil,
			wl: function () {
				var _v0 = A2($elm$core$Maybe$andThen, $author$project$Components$Produits$ListesDePrix$Model$creation, model.aS);
				if (!_v0.$) {
					return _List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							0,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$ListesDePrix$Model$idDeLaCreation),
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$ListesDePrix$Update$CreationOuverte)
								]),
							$author$project$I18n$Cles$produitsListesDePrixCreationTitre(i18n))
						]);
				} else {
					return _List_Nil;
				}
			}(),
			xs: $author$project$I18n$Cles$annuaireAnnulerLaSelection(i18n),
			yt: 'liste-de-prix',
			yv: A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.n_;
						},
						$elm$core$List$map(
							$author$project$Components$Produits$ListesDePrix$View$entree(i18n))),
					model.aS)),
			mG: _List_Nil,
			R: {
				jA: $elm$core$Basics$identity,
				j1: {
					m9: $elm$core$Maybe$Nothing,
					ry: $author$project$I18n$Cles$produitsCatalogueColonneEtat(i18n),
					h6: $author$project$I18n$Cles$produitsListesDePrixTitre(i18n)
				},
				fV: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function (annuaire) {
							return A2(
								$author$project$I18n$Cles$produitsListesDePrixNombre,
								i18n,
								{w: annuaire.w});
						},
						model.aS)),
				hC: '',
				q3: function (_v1) {
					return '';
				},
				q4: function (nombre) {
					return A2(
						$author$project$I18n$Cles$annuaireSelectionDeLaPage,
						i18n,
						{w: nombre});
				},
				q5: function (nombre) {
					return A2(
						$author$project$I18n$Cles$annuaireSelectionDuFiltre,
						i18n,
						{w: nombre});
				},
				rN: ''
			},
			Cs: _Utils_eq(
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.n_;
						},
						$elm$core$List$isEmpty),
					model.aS),
				$elm$core$Maybe$Just(true)) ? _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsListesDePrixAucune(i18n))
						]))
				]) : _List_Nil,
			EB: $elm$core$Maybe$Nothing,
			EH: $author$project$Components$Shared$Annuaire$View$PaginationEnPresentation,
			GS: $elm$core$Maybe$Nothing,
			hC: $author$project$Components$Shared$Annuaire$View$RechercheEnPresentation,
			Iz: false,
			JE: A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.w;
					},
					model.aS)),
			rS: _List_Nil
		};
	});
var $author$project$I18n$Cles$produitsListesDePrixDescription = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.description', _List_Nil, 'Le prix de chaque offre ou référence, selon le type de partie prenante qui paie.');
};
var $author$project$I18n$Cles$produitsListesDePrixNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.note', _List_Nil, 'Chaque type de partie prenante a au plus une liste valide à une date donnée.');
};
var $author$project$I18n$Cles$produitsListesDePrixQuelPrixAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.quel-prix.aucune', _List_Nil, 'aucune');
};
var $author$project$I18n$Cles$produitsListesDePrixQuelPrixListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.quel-prix.liste', _List_Nil, 'Liste appliquée');
};
var $author$project$I18n$Cles$produitsListesDePrixQuelPrixPublique = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.listes-de-prix.quel-prix.publique',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'liste',
					$author$project$I18n$Traductions$Chaine(p.nW))
				]),
			p.nW + ' (liste publique)');
	});
var $author$project$I18n$Cles$produitsListesDePrixQuelPrixRegleFige = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.quel-prix.regle.fige', _List_Nil, 'Le prix est figé au moment du paiement.');
};
var $author$project$I18n$Cles$produitsListesDePrixQuelPrixReglePublique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.quel-prix.regle.publique', _List_Nil, 'Une seule liste publique valide à une date : elle porte le prix public des visiteurs non connectés.');
};
var $author$project$I18n$Cles$produitsListesDePrixQuelPrixRegleType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.quel-prix.regle.type', _List_Nil, 'Une personne paie le prix de la liste de son type ; quand elle agit pour une organisation, celui du type de l\'organisation.');
};
var $author$project$I18n$Cles$produitsListesDePrixQuelPrixTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.quel-prix.titre', _List_Nil, 'Quel prix pour qui');
};
var $author$project$I18n$Cles$produitsListesDePrixQuelPrixType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.quel-prix.type', _List_Nil, 'Type');
};
var $author$project$I18n$Cles$produitsListesDePrixQuelPrixVisiteur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.listes-de-prix.quel-prix.visiteur', _List_Nil, 'Visiteur non connecté');
};
var $author$project$Components$Produits$ListesDePrix$View$quelPrixPourQui = F2(
	function (i18n, lignes) {
		var ligne = function (prix) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$th,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$scope('row')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$elm$core$Maybe$withDefault,
									$author$project$I18n$Cles$produitsListesDePrixQuelPrixVisiteur(i18n),
									A2(
										$elm$core$Maybe$map,
										function (_public) {
											return A2(
												$author$project$Components$Produits$Common$Prix$publics,
												i18n,
												_List_fromArray(
													[_public]));
										},
										prix.pF)))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								function () {
									var _v0 = _Utils_Tuple2(prix.pF, prix.nW);
									if (_v0.b.$ === 1) {
										var _v1 = _v0.b;
										return $author$project$I18n$Cles$produitsListesDePrixQuelPrixAucune(i18n);
									} else {
										if (!_v0.a.$) {
											var liste = _v0.b.a;
											return liste.Dj.zX;
										} else {
											var _v2 = _v0.a;
											var liste = _v0.b.a;
											return A2(
												$author$project$I18n$Cles$produitsListesDePrixQuelPrixPublique,
												i18n,
												{nW: liste.Dj.zX});
										}
									}
								}())
							]))
					]));
		};
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_Nil,
			{
				fw: _List_Nil,
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$table,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$produitsListesDePrixQuelPrixType(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$produitsListesDePrixQuelPrixListe(i18n))
															]))
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$tbody,
										_List_Nil,
										A2($elm$core$List$map, ligne, lignes))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsListesDePrixQuelPrixRegleType(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsListesDePrixQuelPrixRegleFige(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsListesDePrixQuelPrixReglePublique(i18n))
							]))
					]),
				Dj: 'quel-prix-pour-qui',
				h6: $author$project$I18n$Cles$produitsListesDePrixQuelPrixTitre(i18n)
			});
	});
var $author$project$Components$Produits$ListesDePrix$View$view = F3(
	function (i18n, messages, model) {
		var fournies = A2($author$project$Components$Produits$ListesDePrix$View$donnees, i18n, model);
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'produits-listes-de-prix-list',
			{
				ut: _Utils_eq(model.np, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						A2(
							$elm$core$List$cons,
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							_Utils_ap(
								A4($author$project$Components$Shared$Annuaire$View$liste, i18n, $author$project$Components$Produits$ListesDePrix$Update$DeLaListe, fournies, model.nW),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$produitsListesDePrixNote(i18n))
											])),
										A2(
										$author$project$Components$Produits$ListesDePrix$View$quelPrixPourQui,
										i18n,
										A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.Gm;
												},
												model.aS)))
									]))))
					]),
				xy: _List_fromArray(
					[
						A2($author$project$Components$Produits$ListesDePrix$View$creation, i18n, model)
					]),
				zM: A4($author$project$Components$Shared$Annuaire$View$fixed, i18n, $author$project$Components$Produits$ListesDePrix$Update$DeLaListe, fournies, model.nW),
				AK: $author$project$Components$Produits$ListesDePrix$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsListesDePrixDescription(i18n))
									]))
							]),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adresseListesDePrix,
								Dj: $author$project$I18n$Cles$produitsTitre(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$produitsListesDePrixTitre(i18n)
					})
			});
	});
var $author$project$Components$Produits$MarquesEtGammes$Update$DeLaListe = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Produits$MarquesEtGammes$Update$CreationDemandee = {$: 8};
var $author$project$Components$Produits$MarquesEtGammes$Update$Saisi = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Produits$MarquesEtGammes$View$creation = F3(
	function (i18n, tournures, model) {
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.kX);
		var contenu = function () {
			var _v0 = _Utils_Tuple2(
				A2($elm$core$Maybe$andThen, $author$project$Components$Produits$MarquesEtGammes$Model$forme, model.aS),
				tournures);
			if ((!_v0.a.$) && (!_v0.b.$)) {
				var _v1 = _v0.a.a;
				var forme = _v1.a;
				var fournies = _v0.b.a;
				return {
					fs: {
						sR: !$author$project$Components$Produits$Common$Envoi$enCours(model.l2),
						Bl: A2($author$project$I18n$Cles$texte, i18n, fournies.dC),
						C$: $author$project$Components$Produits$MarquesEtGammes$Update$CreationDemandee
					},
					fZ: A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Produits$MarquesEtGammes$Update$Saisi),
						A3(
							$author$project$Components$Produits$Common$Formulaire$view,
							i18n,
							{
								gi: A2($author$project$I18n$Cles$texte, i18n, fournies.gi),
								gB: forme,
								oJ: '',
								ey: $elm$core$Maybe$Nothing,
								pv: prefixe
							},
							model.hP)),
					A6: $elm$core$Maybe$Nothing,
					Bc: false,
					h6: A2($author$project$I18n$Cles$texte, i18n, fournies.en)
				};
			} else {
				return {
					fs: {sR: false, Bl: '', C$: $author$project$Components$Produits$MarquesEtGammes$Update$CreationDemandee},
					fZ: _List_Nil,
					A6: $elm$core$Maybe$Nothing,
					Bc: false,
					h6: ''
				};
			}
		}();
		return A4($author$project$Components$Shared$Drawer$View$view, i18n, $author$project$Components$Produits$MarquesEtGammes$Update$DuDrawer, contenu, model.kX);
	});
var $author$project$Components$Produits$MarquesEtGammes$Update$CreationOuverte = {$: 6};
var $author$project$I18n$Cles$produitsCatalogueEnDouble = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.en-double', _List_Nil, 'En double');
};
var $author$project$I18n$Cles$produitsCatalogueInfoLicence = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.info.licence', _List_Nil, 'Licence et redevances');
};
var $author$project$I18n$Cles$produitsCatalogueInfoNature = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.info.nature', _List_Nil, 'Nature');
};
var $author$project$I18n$Cles$produitsCatalogueInfoNaturePropre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.info.nature.propre', _List_Nil, 'propre');
};
var $author$project$I18n$Cles$produitsCatalogueInfoNatureSousLicence = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.info.nature.sous-licence', _List_Nil, 'sous licence');
};
var $author$project$I18n$Cles$produitsCatalogueInfoReferences = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.info.references', _List_Nil, 'Références');
};
var $author$project$Components$Produits$MarquesEtGammes$View$entree = F3(
	function (i18n, tournures, element) {
		var absent = $author$project$I18n$Cles$produitsCatalogueInfoSansValeur(i18n);
		var propres = function () {
			var _v1 = element.IY;
			if (!_v1.$) {
				var sousLicence = _v1.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$I18n$Cles$produitsCatalogueInfoNature(i18n),
						sousLicence ? $author$project$I18n$Cles$produitsCatalogueInfoNatureSousLicence(i18n) : $author$project$I18n$Cles$produitsCatalogueInfoNaturePropre(i18n))
					]);
			} else {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$I18n$Cles$produitsCatalogueChampMillesime(i18n),
						A2($elm$core$Maybe$withDefault, absent, element.n8))
					]);
			}
		}();
		return {
			aa: A2(
				$elm$core$Maybe$map,
				function (_v0) {
					return $author$project$Routes$Route$toString(
						$author$project$Routes$Route$FicheElement(element.Aq));
				},
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$self, element.nQ)),
			Aq: $author$project$Routes$Route$toString(
				$author$project$Routes$Route$FicheElement(element.Aq)),
			m9: $elm$core$Maybe$Nothing,
			gL: _Utils_ap(
				propres,
				_Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple2(
							A2($author$project$I18n$Cles$texte, i18n, tournures.yp),
							$elm$core$String$fromInt(element.yp)),
							_Utils_Tuple2(
							$author$project$I18n$Cles$produitsCatalogueInfoReferences(i18n),
							$elm$core$String$fromInt(element.hD))
						]),
					_Utils_eq(element.IY, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$I18n$Cles$produitsCatalogueInfoLicence(i18n),
							absent)
						]))),
			ry: _Utils_ap(
				$author$project$Components$Produits$Common$Elements$archive(element) ? _List_fromArray(
					[
						_Utils_Tuple2(
						3,
						A2($author$project$Catalogue$Vocabulaire$etatDElement, i18n, element.gt))
					]) : _List_Nil,
				element.gi ? _List_fromArray(
					[
						_Utils_Tuple2(
						1,
						$author$project$I18n$Cles$produitsCatalogueEnDouble(i18n))
					]) : _List_Nil),
			rz: _List_Nil,
			h6: $author$project$Components$Produits$Common$Elements$nom(element)
		};
	});
var $author$project$I18n$Cles$produitsCatalogueSansNiveau = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.sans-niveau', _List_Nil, 'La structure de votre catalogue n\'utilise ni marque ni gamme.');
};
var $author$project$Components$Produits$MarquesEtGammes$View$vide = F3(
	function (i18n, tournures, annuaire) {
		var _v0 = _Utils_Tuple2(tournures, annuaire.aV);
		if (_v0.a.$ === 1) {
			var _v1 = _v0.a;
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsCatalogueSansNiveau(i18n))
						]))
				]);
		} else {
			if (!_v0.b.b) {
				var fournies = _v0.a.a;
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$I18n$Cles$texte, i18n, fournies.dp))
							]))
					]);
			} else {
				return _List_Nil;
			}
		}
	});
var $author$project$Components$Produits$MarquesEtGammes$View$donnees = F3(
	function (i18n, tournures, model) {
		var elements = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.aV;
				},
				model.aS));
		return {
			sQ: _List_Nil,
			ue: true,
			uf: false,
			uh: false,
			ui: false,
			uH: false,
			u7: _Utils_eq(model.aS, $elm$core$Maybe$Nothing),
			vG: _List_Nil,
			wl: function () {
				var _v0 = _Utils_Tuple2(
					A2($elm$core$Maybe$andThen, $author$project$Components$Produits$MarquesEtGammes$Model$forme, model.aS),
					tournures);
				if ((!_v0.a.$) && (!_v0.b.$)) {
					var fournies = _v0.b.a;
					return _List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							0,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$MarquesEtGammes$Model$idDeLaCreation),
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$MarquesEtGammes$Update$CreationOuverte)
								]),
							A2($author$project$I18n$Cles$texte, i18n, fournies.en))
						]);
				} else {
					return _List_Nil;
				}
			}(),
			xs: $author$project$I18n$Cles$annuaireAnnulerLaSelection(i18n),
			yt: 'element-du-catalogue',
			yv: A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (fournies) {
						return A2(
							$elm$core$List$map,
							A2($author$project$Components$Produits$MarquesEtGammes$View$entree, i18n, fournies),
							elements);
					},
					tournures)),
			mG: _List_Nil,
			R: {
				jA: $elm$core$Basics$identity,
				j1: {
					m9: $elm$core$Maybe$Nothing,
					ry: $author$project$I18n$Cles$produitsCatalogueColonneEtat(i18n),
					h6: A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Dj;
								},
								$author$project$I18n$Cles$texte(i18n)),
							tournures))
				},
				fV: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function (fournies) {
							return A2(
								$author$project$I18n$Cles$texte,
								i18n,
								fournies.w(
									$elm$core$List$length(elements)));
						},
						tournures)),
				hC: '',
				q3: function (_v1) {
					return '';
				},
				q4: function (nombre) {
					return A2(
						$author$project$I18n$Cles$annuaireSelectionDeLaPage,
						i18n,
						{w: nombre});
				},
				q5: function (nombre) {
					return A2(
						$author$project$I18n$Cles$annuaireSelectionDuFiltre,
						i18n,
						{w: nombre});
				},
				rN: ''
			},
			Cs: A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Components$Produits$MarquesEtGammes$View$vide, i18n, tournures),
					model.aS)),
			EB: $elm$core$Maybe$Nothing,
			EH: $author$project$Components$Shared$Annuaire$View$PaginationEnPresentation,
			GS: $elm$core$Maybe$Nothing,
			hC: $author$project$Components$Shared$Annuaire$View$RechercheEnPresentation,
			Iz: false,
			JE: $elm$core$List$length(elements),
			rS: _List_Nil
		};
	});
var $author$project$Components$Produits$MarquesEtGammes$View$view = F3(
	function (i18n, messages, model) {
		var tournures = A2(
			$elm$core$Maybe$map,
			$author$project$Components$Produits$Common$Elements$tournures(i18n),
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.os;
				},
				model.aS));
		var fournies = A3($author$project$Components$Produits$MarquesEtGammes$View$donnees, i18n, tournures, model);
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'produits-marques-list',
			{
				ut: _Utils_eq(model.np, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						A2(
							$elm$core$List$cons,
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							A4($author$project$Components$Shared$Annuaire$View$liste, i18n, $author$project$Components$Produits$MarquesEtGammes$Update$DeLaListe, fournies, model.nW)))
					]),
				xy: _List_fromArray(
					[
						A3($author$project$Components$Produits$MarquesEtGammes$View$creation, i18n, tournures, model)
					]),
				zM: A4($author$project$Components$Shared$Annuaire$View$fixed, i18n, $author$project$Components$Produits$MarquesEtGammes$Update$DeLaListe, fournies, model.nW),
				AK: $author$project$Components$Produits$MarquesEtGammes$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$I18n$Cles$texte(i18n),
												A2(
													$elm$core$Maybe$andThen,
													function ($) {
														return $.dH;
													},
													tournures))))
									]))
							]),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adresseMarquesEtGammes,
								Dj: $author$project$I18n$Cles$produitsTitre(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$produitsMarquesEtGammesTitre(i18n)
					})
			});
	});
var $author$project$Components$Produits$Offre$View$nomDeLaPage = 'produits-offre-detail';
var $author$project$Components$Produits$Offre$Update$ArretDemande = {$: 15};
var $author$project$Components$Produits$Offre$Update$EtatDemande = {$: 12};
var $author$project$Components$Produits$Offre$Update$ModificationDemandee = {$: 8};
var $author$project$I18n$Cles$produitsOffreArret = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.offre.arret', _List_Nil, 'Arrêter l\'offre');
};
var $author$project$I18n$Cles$produitsOffreFicheModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.offre.fiche.modifier', _List_Nil, 'Modifier la fiche');
};
var $author$project$I18n$Cles$produitsReferenceEtatChanger = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.etat.changer', _List_Nil, 'Changer l\'état…');
};
var $author$project$Components$Produits$Offre$View$actions = F2(
	function (i18n, fiche) {
		return _Utils_ap(
			_Utils_eq(
				$author$project$Components$Produits$Offre$Model$commandeDArret(fiche),
				$elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					3,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Offre$Model$idDeLArret),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Offre$Update$ArretDemande)
						]),
					$author$project$I18n$Cles$produitsOffreArret(i18n))
				]),
			_Utils_ap(
				_Utils_eq(
					$author$project$Components$Produits$Common$Etat$lien(fiche),
					$elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Offre$Model$idDeLEtat),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Offre$Update$EtatDemande)
							]),
						$author$project$I18n$Cles$produitsReferenceEtatChanger(i18n))
					]),
				$author$project$Components$Produits$Offre$Model$saisissable(fiche) ? _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						0,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Offre$Model$idDeLaModification),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Offre$Update$ModificationDemandee)
							]),
						$author$project$I18n$Cles$produitsOffreFicheModifier(i18n))
					]) : _List_Nil));
	});
var $author$project$Components$Produits$Offre$Update$ArretConfirme = {$: 17};
var $author$project$Components$Produits$Offre$Update$FocusDemande = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Produits$Offre$Update$clavierDeLArret = A2($author$project$Components$Shared$Confirmation$Clavier$clavier, $author$project$Components$Produits$Offre$Model$idsDeLArret, $author$project$Components$Produits$Offre$Update$FocusDemande);
var $author$project$I18n$Cles$produitsOffreArretRolesDuType = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.offre.arret.roles-du-type',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' rôle ' + (p.Dj + ' ouvert'))) : (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' rôles ' + (p.Dj + ' ouverts'))));
	});
var $author$project$I18n$Cles$produitsOffreArretRolesSeparateur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.offre.arret.roles-separateur', _List_Nil, ' et ');
};
var $author$project$Components$Produits$Common$RolesParOffre$detailDesOuverts = F2(
	function (i18n, comptes) {
		return A2(
			$elm$core$String$join,
			$author$project$I18n$Cles$produitsOffreArretRolesSeparateur(i18n),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var nom = _v1.a;
					var nombre = _v1.b;
					return A2(
						$author$project$I18n$Cles$produitsOffreArretRolesDuType,
						i18n,
						{Dj: nom, w: nombre});
				},
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var nombre = _v0.b;
						return nombre > 0;
					},
					comptes)));
	});
var $author$project$Components$Produits$Common$RolesParOffre$ouverts = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map($elm$core$Tuple$second),
	$elm$core$List$sum);
var $author$project$I18n$Cles$produitsOffreArretMessage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.offre.arret.message', _List_Nil, 'L\'offre reste valable pour les rôles ouverts et pour les dossiers en cours. Elle ne sera plus proposée aux nouveaux dossiers ni aux nouvelles versions de pipe, ni affichée sur les portails.');
};
var $author$project$I18n$Cles$produitsOffreArretMessageRoles = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.offre.arret.message-roles',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'detail',
					$author$project$I18n$Traductions$Chaine(p.bB))
				]),
			'L\'offre reste valable pour les ' + (p.bB + ' et pour les dossiers en cours. Elle ne sera plus proposée aux nouveaux dossiers ni aux nouvelles versions de pipe, ni affichée sur les portails.'));
	});
var $author$project$I18n$Cles$produitsOffreArretRefus = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.offre.arret.refus',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'message',
					$author$project$I18n$Traductions$Chaine(p.Cs)),
					_Utils_Tuple2(
					'reference',
					$author$project$I18n$Traductions$Chaine(p.Hc))
				]),
			p.Cs + (' ' + p.Hc));
	});
var $author$project$I18n$Cles$produitsOffreArretTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.offre.arret.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Arrêter « ' + (p.Dj + ' » ?'));
	});
var $author$project$I18n$Cles$referentielArchetypeClient = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.archetype.client', _List_Nil, 'Client');
};
var $author$project$I18n$Cles$referentielArchetypeCollaborateur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.archetype.collaborateur', _List_Nil, 'Collaborateur');
};
var $author$project$I18n$Cles$referentielArchetypeFournisseur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.archetype.fournisseur', _List_Nil, 'Fournisseur');
};
var $author$project$I18n$Cles$referentielArchetypePartenaire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.archetype.partenaire', _List_Nil, 'Partenaire');
};
var $author$project$I18n$Cles$referentielArchetypePrescripteur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.archetype.prescripteur', _List_Nil, 'Prescripteur');
};
var $author$project$I18n$Cles$referentielArchetypeProspect = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.archetype.prospect', _List_Nil, 'Prospect');
};
var $author$project$I18n$Cles$referentielArchetypeRelationPresse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.archetype.relation-presse', _List_Nil, 'Contact presse');
};
var $author$project$I18n$Cles$referentielArchetypeSuspect = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.archetype.suspect', _List_Nil, 'Suspect');
};
var $author$project$Catalogue$Vocabulaire$archetypeDeRole = F2(
	function (i18n, code) {
		switch (code) {
			case 'Suspect':
				return $author$project$I18n$Cles$referentielArchetypeSuspect(i18n);
			case 'Prospect':
				return $author$project$I18n$Cles$referentielArchetypeProspect(i18n);
			case 'Client':
				return $author$project$I18n$Cles$referentielArchetypeClient(i18n);
			case 'Collaborateur':
				return $author$project$I18n$Cles$referentielArchetypeCollaborateur(i18n);
			case 'Fournisseur':
				return $author$project$I18n$Cles$referentielArchetypeFournisseur(i18n);
			case 'Partenaire':
				return $author$project$I18n$Cles$referentielArchetypePartenaire(i18n);
			case 'Prescripteur':
				return $author$project$I18n$Cles$referentielArchetypePrescripteur(i18n);
			case 'RelationPresse':
				return $author$project$I18n$Cles$referentielArchetypeRelationPresse(i18n);
			default:
				return code;
		}
	});
var $author$project$Components$Produits$Common$RolesParOffre$nomDuType = F2(
	function (i18n, ligne_) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$Catalogue$Vocabulaire$archetypeDeRole, i18n, ligne_.fA),
			ligne_.Dp);
	});
var $author$project$Components$Produits$Common$RolesParOffre$pourUneOffre = F3(
	function (i18n, offre, lignes) {
		return A2(
			$elm$core$List$map,
			function (ligne_) {
				return _Utils_Tuple2(
					A2($author$project$Components$Produits$Common$RolesParOffre$nomDuType, i18n, ligne_),
					ligne_.Ev);
			},
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.D1;
					},
					$elm$core$Basics$eq(offre)),
				lignes));
	});
var $author$project$Components$Produits$Offre$View$rolesDeLOffre = F2(
	function (i18n, fiche) {
		return A2(
			$author$project$Components$Produits$Common$RolesParOffre$pourUneOffre,
			i18n,
			$author$project$Catalogue$Identifiants$referenceIdToString(fiche.Aq));
	});
var $author$project$Components$Produits$Offre$View$arret = F3(
	function (i18n, model, fiche) {
		var ids = $author$project$Components$Produits$Offre$Model$idsDeLArret;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('opened', model.is)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('overlay'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Offre$Update$ArretAnnule)
						]),
					_List_Nil),
					A2(
					$author$project$Components$Shared$Confirmation$View$view,
					i18n,
					{
						vl: $author$project$Components$Produits$Offre$Update$clavierDeLArret,
						j7: {
							Aq: ids.j7,
							Bl: $author$project$I18n$Cles$produitsOffreArret(i18n),
							C$: $author$project$Components$Produits$Offre$Update$ArretConfirme
						},
						Aq: ids.GN,
						As: ids.Cs,
						At: ids.h6,
						Cs: function () {
							var _v0 = model.p_;
							if (_v0.$ === 1) {
								var _v1 = A2(
									$elm$core$Maybe$map,
									A2($author$project$Components$Produits$Offre$View$rolesDeLOffre, i18n, fiche),
									model.eX);
								if (!_v1.$) {
									var comptes = _v1.a;
									return ($author$project$Components$Produits$Common$RolesParOffre$ouverts(comptes) > 0) ? A2(
										$author$project$I18n$Cles$produitsOffreArretMessageRoles,
										i18n,
										{
											bB: A2($author$project$Components$Produits$Common$RolesParOffre$detailDesOuverts, i18n, comptes)
										}) : $author$project$I18n$Cles$produitsOffreArretMessage(i18n);
								} else {
									return $author$project$I18n$Cles$produitsOffreArretMessage(i18n);
								}
							} else {
								var refus = _v0.a;
								var dit = A2($author$project$I18n$Cles$texte, i18n, refus.Jx);
								return A2(
									$elm$core$Maybe$withDefault,
									dit,
									A2(
										$elm$core$Maybe$map,
										function (traceId) {
											return A2(
												$author$project$I18n$Cles$produitsOffreArretRefus,
												i18n,
												{
													Cs: dit,
													Hc: A2(
														$author$project$I18n$Cles$erreurApiReference,
														i18n,
														{b9: traceId})
												});
										},
										refus.b9));
							}
						}(),
						Et: model.is,
						HG: {
							Aq: ids.to,
							Bl: $author$project$I18n$Cles$produitsCatalogueArchivageAnnuler(i18n),
							C$: $author$project$Components$Produits$Offre$Update$ArretAnnule
						},
						h6: A2(
							$author$project$I18n$Cles$produitsOffreArretTitre,
							i18n,
							{
								Dj: A2(
									$elm$core$Maybe$withDefault,
									fiche.vx,
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.zX;
										},
										fiche.Dj))
							}),
						sl: 2
					})
				]));
	});
var $author$project$Components$Produits$Offre$Update$DeLaSaisie = function (a) {
	return {$: 7, a: a};
};
var $author$project$I18n$Cles$produitsOffreFicheNote = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.offre.fiche.note',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'version',
					$author$project$I18n$Traductions$Chaine(p.sq))
				]),
			'Informations de la catégorie « ' + (p.Dj + (' » v' + (p.sq + '.'))));
	});
var $author$project$Components$Produits$Offre$View$note = F2(
	function (i18n, fiche) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2(
						$author$project$I18n$Cles$produitsOffreFicheNote,
						i18n,
						{
							Dj: fiche.r0.Dj.zX,
							sq: $elm$core$String$fromInt(fiche.r0.sq)
						}))
				]));
	});
var $author$project$Components$Produits$Offre$View$presentation = F3(
	function (normes, lecture, fiche) {
		return {
			fr: function (_v0) {
				return 0;
			},
			dw: $author$project$Components$Produits$Offre$Model$champs(fiche),
			jN: _List_Nil,
			Ba: fiche.Ba,
			np: lecture,
			hd: normes,
			pv: $author$project$Components$Produits$Offre$Model$prefixeDesChamps,
			sb: fiche.sb
		};
	});
var $author$project$I18n$Cles$produitsOffreFicheTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.offre.fiche.titre', _List_Nil, 'Fiche de l\'offre');
};
var $author$project$I18n$Cles$produitsReferenceCaracteristiquesAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.caracteristiques.aucune', _List_Nil, 'Cette catégorie n\'a aucune information.');
};
var $author$project$Components$Produits$Offre$View$champs = F3(
	function (i18n, model, fiche) {
		var montree = $author$project$Components$Shared$Drawer$Model$estOuvert(model.lb) ? A2($author$project$Components$Produits$Offre$Model$retablie, fiche, model).hP : model.hP;
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Offre$Model$idDeLaSection),
					$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1)
				]),
			{
				fw: _List_Nil,
				fZ: _Utils_ap(
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Produits$Offre$Update$DeLaSaisie),
						A3(
							$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$view,
							i18n,
							A3($author$project$Components$Produits$Offre$View$presentation, model.hd, true, fiche),
							montree)),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$elm$core$List$isEmpty(
										$author$project$Components$Produits$Offre$Model$champs(fiche)) ? $author$project$I18n$Cles$produitsReferenceCaracteristiquesAucune(i18n) : '')
								])),
							A2($author$project$Components$Produits$Offre$View$note, i18n, fiche)
						])),
				Dj: 'fiche-de-l-offre',
				h6: $author$project$I18n$Cles$produitsOffreFicheTitre(i18n)
			});
	});
var $author$project$Components$Produits$Offre$Update$EtatChoisi = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Produits$Offre$Update$EtatValide = {$: 14};
var $author$project$Components$Produits$Common$Etat$libelle = F3(
	function (i18n, etats, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2(
				$author$project$I18n$Cles$texte,
				i18n,
				$author$project$Catalogue$Vocabulaire$etat(
					$author$project$Catalogue$Identifiants$etatCodeToString(code))),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.zX;
				},
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.R;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.vx;
								},
								$elm$core$Basics$eq(code)),
							etats)))));
	});
var $author$project$Components$Produits$Common$Etat$options = F2(
	function (i18n, porteur) {
		return A2(
			$elm$core$List$map,
			function (etat) {
				return {
					Bl: A3($author$project$Components$Produits$Common$Etat$libelle, i18n, porteur.mj, etat.vx),
					fm: $author$project$Catalogue$Identifiants$etatCodeToString(etat.vx)
				};
			},
			porteur.mj);
	});
var $author$project$I18n$Cles$produitsReferenceEtatTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.etat.titre', _List_Nil, 'Changer l\'état');
};
var $author$project$I18n$Cles$produitsReferenceEtatValider = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.etat.valider', _List_Nil, 'Changer l\'état');
};
var $author$project$Components$Produits$Common$Etat$drawer = F3(
	function (i18n, geste, porteur) {
		var porte = A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.vx;
				},
				$elm$core$Basics$eq(porteur.gt)),
			porteur.mj) ? _List_Nil : _List_fromArray(
			[
				{
				Bl: A3($author$project$Components$Produits$Common$Etat$libelle, i18n, porteur.mj, porteur.gt),
				fm: $author$project$Catalogue$Identifiants$etatCodeToString(porteur.gt)
			}
			]);
		return {
			fs: {
				sR: geste.sO,
				Bl: $author$project$I18n$Cles$produitsReferenceEtatValider(i18n),
				C$: geste.sj
			},
			fZ: _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Messages$View$view,
					i18n,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Maybe$map, $elm$core$List$singleton, geste.pZ))),
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: geste.pv + '-etat',
						Bl: $author$project$I18n$Cles$produitsCatalogueColonneEtat(i18n),
						he: true
					},
					{
						hg: geste.vd,
						o_: _Utils_ap(
							porte,
							A2($author$project$Components$Produits$Common$Etat$options, i18n, porteur)),
						fm: A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, $author$project$Catalogue$Identifiants$etatCodeToString, geste.KV))
					})
				]),
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: $author$project$I18n$Cles$produitsReferenceEtatTitre(i18n)
		};
	});
var $author$project$Components$Produits$Offre$View$etat = F3(
	function (i18n, model, fiche) {
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Produits$Offre$Update$DuDrawer,
			$author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) ? A3(
				$author$project$Components$Produits$Common$Etat$drawer,
				i18n,
				{
					sO: !$author$project$Components$Produits$Common$Envoi$enCours(model.l2),
					vd: $author$project$Components$Produits$Offre$Update$EtatChoisi,
					pv: $author$project$Components$Shared$Drawer$Model$idRacine(model.kX),
					pZ: model.p$,
					sj: $author$project$Components$Produits$Offre$Update$EtatValide,
					KV: model.mi
				},
				fiche) : {
				fs: {sR: false, Bl: '', C$: $author$project$Components$Produits$Offre$Update$EtatValide},
				fZ: _List_Nil,
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: ''
			},
			model.kX);
	});
var $author$project$I18n$Cles$produitsPrixCourtHorsTaxe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.prix.court.hors-taxe',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'prix',
					$author$project$I18n$Traductions$Chaine(p.py))
				]),
			p.py + ' HT');
	});
var $author$project$I18n$Cles$produitsPrixCourtToutesTaxesComprises = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.prix.court.toutes-taxes-comprises',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'prix',
					$author$project$I18n$Traductions$Chaine(p.py))
				]),
			p.py + ' TTC');
	});
var $author$project$I18n$Cles$produitsPrixCourtParAn = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.prix.court.par-an',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'montant',
					$author$project$I18n$Traductions$Chaine(p.oi))
				]),
			p.oi + ' / an');
	});
var $author$project$I18n$Cles$produitsPrixCourtParMois = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.prix.court.par-mois',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'montant',
					$author$project$I18n$Traductions$Chaine(p.oi))
				]),
			p.oi + ' / mois');
	});
var $author$project$I18n$Cles$produitsPrixCourtUnique = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.prix.court.unique',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'montant',
					$author$project$I18n$Traductions$Chaine(p.oi))
				]),
			p.oi + ' · unique');
	});
var $author$project$Catalogue$Vocabulaire$uniteDePrixCourte = F2(
	function (i18n, code) {
		switch (code) {
			case 'unique':
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$produitsPrixCourtUnique(i18n));
			case 'par-an':
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$produitsPrixCourtParAn(i18n));
			case 'par-mois':
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$produitsPrixCourtParMois(i18n));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Produits$Common$Prix$court = F3(
	function (i18n, liste, prix) {
		var ecrit = A2($elm$core$String$endsWith, '.00', prix.oi) ? A2(
			$author$project$I18n$Cles$produitsPrixMontant,
			i18n,
			{
				kO: A2($author$project$Catalogue$Vocabulaire$symboleDeDevise, i18n, liste.kO),
				oi: A2(
					$elm$core$String$dropRight,
					3,
					A2($author$project$Components$Produits$Common$Prix$nombre, i18n, prix.oi))
			}) : A3(
			$author$project$Components$Produits$Common$Prix$montant,
			i18n,
			{kO: liste.kO},
			prix.oi);
		var avecUnite = function () {
			var _v1 = A2($author$project$Catalogue$Vocabulaire$uniteDePrixCourte, i18n, prix.sa);
			if (!_v1.$) {
				var dire = _v1.a;
				return dire(
					{oi: ecrit});
			} else {
				return ecrit;
			}
		}();
		var _v0 = liste.rB;
		_v0$2:
		while (true) {
			if (!_v0.$) {
				switch (_v0.a.$) {
					case 1:
						return A2(
							$author$project$I18n$Cles$produitsPrixCourtHorsTaxe,
							i18n,
							{py: avecUnite});
					case 2:
						return A2(
							$author$project$I18n$Cles$produitsPrixCourtToutesTaxesComprises,
							i18n,
							{py: avecUnite});
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return avecUnite;
	});
var $author$project$I18n$Cles$produitsOffrePrixDeLaListe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.offre.prix.de-la-liste',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'liste',
					$author$project$I18n$Traductions$Chaine(p.nW)),
					_Utils_Tuple2(
					'prix',
					$author$project$I18n$Traductions$Chaine(p.py))
				]),
			p.nW + (' : ' + p.py));
	});
var $author$project$I18n$Cles$produitsOffrePrixSeparateur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.offre.prix.separateur', _List_Nil, ' · ');
};
var $author$project$I18n$Cles$produitsOffrePrixTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.offre.prix.titre', _List_Nil, 'Listes de prix');
};
var $author$project$Components$Produits$Offre$View$listesDePrix = F2(
	function (i18n, prix) {
		if (!prix.$) {
			var lus = prix.a;
			return A2(
				$author$project$Components$Shared$Page$View$section,
				_List_Nil,
				{
					fw: _List_Nil,
					fZ: _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$elm$core$List$isEmpty(lus.ES) ? $author$project$I18n$Cles$produitsCatalogueInfoSansValeur(i18n) : A2(
										$elm$core$String$join,
										$author$project$I18n$Cles$produitsOffrePrixSeparateur(i18n),
										A2(
											$elm$core$List$map,
											function (ligne) {
												return A2(
													$author$project$I18n$Cles$produitsOffrePrixDeLaListe,
													i18n,
													{
														nW: ligne.nW.Dj.zX,
														py: A3(
															$author$project$Components$Produits$Common$Prix$court,
															i18n,
															{
																kO: ligne.py.kO,
																rB: $elm$core$Maybe$Just(ligne.py.rB)
															},
															ligne.py)
													});
											},
											lus.ES)))
								]))
						]),
					Dj: 'listes-de-prix',
					h6: $author$project$I18n$Cles$produitsOffrePrixTitre(i18n)
				});
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Produits$Offre$Update$EnregistrementDemande = {$: 10};
var $author$project$Components$Produits$Offre$View$modification = F3(
	function (i18n, model, fiche) {
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Produits$Offre$Update$DuDrawerDeLaFiche,
			$author$project$Components$Shared$Drawer$Model$estOuvert(model.lb) ? {
				fs: {
					sR: !$author$project$Components$Produits$Common$Envoi$enCours(model.l2),
					Bl: $author$project$I18n$Cles$produitsCatalogueActionsEnregistrer(i18n),
					C$: $author$project$Components$Produits$Offre$Update$EnregistrementDemande
				},
				fZ: A2(
					$elm$core$List$cons,
					A2(
						$author$project$Components$Shared$Messages$View$view,
						i18n,
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2($elm$core$Maybe$map, $elm$core$List$singleton, model.hE))),
					_Utils_ap(
						A2(
							$elm$core$List$map,
							$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Produits$Offre$Update$DeLaSaisie),
							A3(
								$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$view,
								i18n,
								A3($author$project$Components$Produits$Offre$View$presentation, model.hd, false, fiche),
								model.hP)),
						_List_fromArray(
							[
								A2($author$project$Components$Produits$Offre$View$note, i18n, fiche)
							]))),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$produitsOffreFicheModifier(i18n)
			} : {
				fs: {sR: false, Bl: '', C$: $author$project$Components$Produits$Offre$Update$EnregistrementDemande},
				fZ: _List_Nil,
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: ''
			},
			model.lb);
	});
var $author$project$I18n$Cles$produitsOffresTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.offres.titre', _List_Nil, 'Offres de service');
};
var $author$project$I18n$Cles$produitsOffreNature = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.offre.nature', _List_Nil, 'Offre de service');
};
var $author$project$Components$Produits$Offre$View$resume = F2(
	function (i18n, fiche) {
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsOffreNature(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('code')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(fiche.vx)
						]))
				]),
			_Utils_ap(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (lie) {
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('rattachement')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(lie.R.zX)
										]))
								]);
						},
						fiche.pN)),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							0,
							A3($author$project$Components$Produits$Common$Etat$libelle, i18n, fiche.mj, fiche.gt))
						]),
					fiche.tL ? _List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							3,
							$author$project$I18n$Cles$produitsReferencesCarteArretee(i18n))
						]) : _List_Nil)));
	});
var $author$project$I18n$Cles$produitsOffresRolesLigne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.offres.roles.ligne',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			p.Dj + (' · ' + p.w));
	});
var $author$project$I18n$Cles$produitsOffresRolesSeparateur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.offres.roles.separateur', _List_Nil, ' ; ');
};
var $author$project$Components$Produits$Common$RolesParOffre$ligne = F2(
	function (i18n, comptes) {
		return $elm$core$List$isEmpty(comptes) ? $author$project$I18n$Cles$produitsCatalogueInfoSansValeur(i18n) : A2(
			$elm$core$String$join,
			$author$project$I18n$Cles$produitsOffresRolesSeparateur(i18n),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var nom = _v0.a;
					var nombre = _v0.b;
					return A2(
						$author$project$I18n$Cles$produitsOffresRolesLigne,
						i18n,
						{
							Dj: nom,
							w: $elm$core$String$fromInt(nombre)
						});
				},
				comptes));
	});
var $author$project$I18n$Cles$produitsOffreUtiliseeParRoles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.offre.utilisee-par.roles', _List_Nil, 'Rôles par offre');
};
var $author$project$I18n$Cles$produitsOffreUtiliseeParTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.offre.utilisee-par.titre', _List_Nil, 'Utilisée par');
};
var $author$project$Components$Produits$Offre$View$utiliseePar = F3(
	function (i18n, roles, fiche) {
		if (!roles.$) {
			var lus = roles.a;
			return A2(
				$author$project$Components$Shared$Page$View$section,
				_List_Nil,
				{
					fw: _List_Nil,
					fZ: _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$dl,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('roles-par-offre')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$dt,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsOffreUtiliseeParRoles(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$dd,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$Components$Produits$Common$RolesParOffre$ligne,
												i18n,
												A3($author$project$Components$Produits$Offre$View$rolesDeLOffre, i18n, fiche, lus)))
										]))
								]))
						]),
					Dj: 'utilisee-par',
					h6: $author$project$I18n$Cles$produitsOffreUtiliseeParTitre(i18n)
				});
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Produits$Offre$View$page = F4(
	function (i18n, messages, model, fiche) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			$author$project$Components$Produits$Offre$View$nomDeLaPage,
			{
				ut: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						_List_fromArray(
							[
								A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('envoi'),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$Components$Produits$Common$Envoi$enCours(model.l2) ? $author$project$I18n$Cles$produitsStructureEnvoiEnCours(i18n) : '')
									])),
								A3($author$project$Components$Produits$Offre$View$champs, i18n, model, fiche),
								A2($author$project$Components$Produits$Offre$View$listesDePrix, i18n, model.py),
								A3($author$project$Components$Produits$Offre$View$utiliseePar, i18n, model.eX, fiche)
							]))
					]),
				xy: _List_fromArray(
					[
						A3($author$project$Components$Produits$Offre$View$etat, i18n, model, fiche),
						A3($author$project$Components$Produits$Offre$View$modification, i18n, model, fiche),
						A3($author$project$Components$Produits$Offre$View$arret, i18n, model, fiche)
					]),
				zM: A2($author$project$Components$Produits$Offre$View$actions, i18n, fiche),
				AK: $author$project$Components$Produits$Offre$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('resume')
									]),
								A2($author$project$Components$Produits$Offre$View$resume, i18n, fiche))
							]),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adresseOffres,
								Dj: $author$project$I18n$Cles$produitsTitre(i18n)
							},
								{
								aa: $author$project$Routes$Route$adresseOffres,
								Dj: $author$project$I18n$Cles$produitsOffresTitre(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: A2(
							$elm$core$Maybe$withDefault,
							fiche.vx,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.zX;
								},
								fiche.Dj))
					})
			});
	});
var $author$project$Components$Produits$Offre$View$view = F3(
	function (i18n, messages, model) {
		var _v0 = _Utils_Tuple2(model.nf, model.zo);
		if (_v0.a) {
			return A2(
				$author$project$Components$Shared$Introuvable$View$view,
				i18n,
				{
					aa: $author$project$Routes$Route$adresseOffres,
					Bl: $author$project$I18n$Cles$produitsOffresRetour(i18n)
				});
		} else {
			if (!_v0.b.$) {
				var fiche = _v0.b.a;
				return A4($author$project$Components$Produits$Offre$View$page, i18n, messages, model, fiche);
			} else {
				var _v1 = _v0.b;
				return A2(
					$author$project$Components$Shared$Page$View$page,
					$author$project$Components$Produits$Offre$View$nomDeLaPage,
					{
						ut: _List_fromArray(
							[
								A2($author$project$Components$Shared$Messages$View$view, i18n, messages)
							]),
						xy: _List_Nil,
						zM: _List_Nil,
						AK: false,
						JD: _List_Nil
					});
			}
		}
	});
var $author$project$Components$Produits$Offres$Update$DeLaListe = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Produits$Offres$Update$CreationDemandee = {$: 10};
var $author$project$Components$Produits$Offres$Update$Saisi = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Produits$Offres$Creation$Code = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Produits$Offres$Creation$Nom = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Produits$Offres$Creation$Rattachement = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$Offres$Creation$Type = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$Offres$Creation$erreur = F3(
	function (i18n, saisie, zone) {
		return (saisie.b5 && A2(
			$elm$core$List$member,
			zone,
			$author$project$Components$Produits$Offres$Creation$fautes(saisie))) ? $elm$core$Maybe$Just(
			(zone === 2) ? $author$project$I18n$Cles$produitsCatalogueChampNomObligatoire(i18n) : $author$project$I18n$Cles$saisieDeChampObligatoire(i18n)) : A2(
			$elm$core$Maybe$andThen,
			function (_v0) {
				var fautive = _v0.a;
				var texte = _v0.b;
				return _Utils_eq(fautive, zone) ? $elm$core$Maybe$Just(
					A2($author$project$I18n$Cles$texte, i18n, texte)) : $elm$core$Maybe$Nothing;
			},
			saisie.bf);
	});
var $author$project$Components$Produits$Offres$Creation$erreurDuNom = F3(
	function (i18n, saisie, code) {
		return A3($author$project$Components$Produits$Common$LibellesSaisis$manque, saisie.b5, saisie.Dj, code) ? $elm$core$Maybe$Just(
			$author$project$I18n$Cles$produitsCatalogueChampNomObligatoire(i18n)) : (_Utils_eq(
			$author$project$Components$Produits$Common$LibellesSaisis$premiereObligatoire,
			$elm$core$Maybe$Just(code)) ? A2(
			$elm$core$Maybe$andThen,
			function (_v0) {
				var fautive = _v0.a;
				var texte = _v0.b;
				return (fautive === 2) ? $elm$core$Maybe$Just(
					A2($author$project$I18n$Cles$texte, i18n, texte)) : $elm$core$Maybe$Nothing;
			},
			saisie.bf) : $elm$core$Maybe$Nothing);
	});
var $author$project$Components$Produits$Offres$Model$libelleDuNiveau = F3(
	function (i18n, annuaire, niveau) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Cles$produitsReferencesCreationRattachement(i18n),
			A2(
				$elm$core$Maybe$map,
				function (connu) {
					return A2(
						$elm$core$Maybe$withDefault,
						A2(
							$author$project$I18n$Cles$texte,
							i18n,
							$author$project$Catalogue$Vocabulaire$archetype(connu.fA)),
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.zX;
							},
							connu.R));
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(niveau)),
						annuaire.Da))));
	});
var $author$project$I18n$Cles$produitsReferencesCreationRattachementOption = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.creation.rattachement.option',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'niveau',
					$author$project$I18n$Traductions$Chaine(p.os)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.os + (' · ' + p.Dj));
	});
var $author$project$Components$Produits$Offres$View$formulaire = F3(
	function (i18n, model, annuaire) {
		var saisie = model.hP;
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.kX);
		var libelleDuRattachement = function () {
			var _v0 = annuaire.Da;
			if (_v0.b && (!_v0.b.b)) {
				var seul = _v0.a;
				return A3($author$project$Components$Produits$Offres$Model$libelleDuNiveau, i18n, annuaire, seul.Aq);
			} else {
				return $author$project$I18n$Cles$produitsReferencesCreationRattachement(i18n);
			}
		}();
		var champ = F3(
			function (zone, libelle, obligatoire) {
				return {
					go: A3($author$project$Components$Produits$Offres$Creation$erreur, i18n, saisie, zone),
					Aq: A2($author$project$Components$Produits$Offres$Creation$idDe, prefixe, zone),
					Bl: libelle,
					he: obligatoire
				};
			});
		var rattachement = $elm$core$List$isEmpty(annuaire.Da) ? _List_Nil : _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Champ$View$liste,
				A3(champ, 1, libelleDuRattachement, false),
				{
					hg: $author$project$Components$Produits$Offres$Creation$Rattachement,
					o_: A2(
						$elm$core$List$cons,
						{
							Bl: $author$project$I18n$Cles$produitsReferencesCreationAucun(i18n),
							fm: ''
						},
						A2(
							$elm$core$List$map,
							function (element) {
								return {
									Bl: A2(
										$author$project$I18n$Cles$produitsReferencesCreationRattachementOption,
										i18n,
										{
											os: A3($author$project$Components$Produits$Offres$Model$libelleDuNiveau, i18n, annuaire, element.os),
											Dj: element.R.zX
										}),
									fm: $author$project$Catalogue$Identifiants$elementIdToString(element.Aq)
								};
							},
							annuaire.GX)),
					fm: A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $author$project$Catalogue$Identifiants$elementIdToString, saisie.pN))
				})
			]);
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Messages$View$view,
					i18n,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Maybe$map, $elm$core$List$singleton, saisie.pZ))),
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					A3(
						champ,
						0,
						$author$project$I18n$Cles$produitsArchetypeTypeDeProduit(i18n),
						true),
					{
						hg: $author$project$Components$Produits$Offres$Creation$Type,
						o_: A2(
							$elm$core$List$cons,
							{
								Bl: $author$project$I18n$Cles$saisieDeChampListeAucune(i18n),
								fm: ''
							},
							A2(
								$elm$core$List$map,
								function (type_) {
									return {
										Bl: type_.Dj.zX,
										fm: $author$project$Catalogue$Identifiants$typeDeProduitIdToString(type_.Aq)
									};
								},
								annuaire.ib)),
						fm: A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, $author$project$Catalogue$Identifiants$typeDeProduitIdToString, saisie.fh))
					})
				]),
			_Utils_ap(
				rattachement,
				_List_fromArray(
					[
						A3(
						$author$project$Components$Shared$LibellesParLangue$View$view,
						i18n,
						_List_Nil,
						{
							go: A2($author$project$Components$Produits$Offres$Creation$erreurDuNom, i18n, saisie),
							Ba: $author$project$Referentiel$Langues$desLibelles,
							Bl: $author$project$I18n$Cles$produitsCatalogueChampNom(i18n),
							hg: $author$project$Components$Produits$Offres$Creation$Nom,
							pv: $author$project$Components$Produits$Offres$Creation$prefixeDuNom(prefixe),
							fm: function (code) {
								return A2($author$project$Components$Shared$LibellesParLangue$Model$lire, code, saisie.Dj);
							}
						}),
						A2(
						$author$project$Components$Shared$Champ$View$texte,
						A3(
							champ,
							3,
							$author$project$I18n$Cles$produitsReferencesCreationCode(i18n),
							true),
						{hg: $author$project$Components$Produits$Offres$Creation$Code, fm: saisie.vx})
					])));
	});
var $author$project$I18n$Cles$produitsOffresCreationTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.offres.creation.titre', _List_Nil, 'Nouvelle offre');
};
var $author$project$I18n$Cles$produitsOffresCreationValider = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.offres.creation.valider', _List_Nil, 'Créer l\'offre');
};
var $author$project$Components$Produits$Offres$View$creation = F2(
	function (i18n, model) {
		var ferme = {
			fs: {sR: false, Bl: '', C$: $author$project$Components$Produits$Offres$Update$CreationDemandee},
			fZ: _List_Nil,
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: $author$project$I18n$Cles$produitsOffresCreationTitre(i18n)
		};
		var contenu = function () {
			var _v0 = _Utils_Tuple2(
				model.aS,
				A2($elm$core$Maybe$andThen, $author$project$Components$Produits$Offres$Model$creation, model.aS));
			if ((!_v0.a.$) && (!_v0.b.$)) {
				var annuaire = _v0.a.a;
				return $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) ? {
					fs: {
						sR: !$author$project$Components$Produits$Common$Envoi$enCours(model.l2),
						Bl: $author$project$I18n$Cles$produitsOffresCreationValider(i18n),
						C$: $author$project$Components$Produits$Offres$Update$CreationDemandee
					},
					fZ: A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Produits$Offres$Update$Saisi),
						A3($author$project$Components$Produits$Offres$View$formulaire, i18n, model, annuaire)),
					A6: $elm$core$Maybe$Nothing,
					Bc: false,
					h6: $author$project$I18n$Cles$produitsOffresCreationTitre(i18n)
				} : ferme;
			} else {
				return ferme;
			}
		}();
		return A4($author$project$Components$Shared$Drawer$View$view, i18n, $author$project$Components$Produits$Offres$Update$DuDrawer, contenu, model.kX);
	});
var $author$project$Components$Produits$Offres$Update$CreationOuverte = {$: 8};
var $author$project$I18n$Cles$produitsOffresCartePrix = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.offres.carte.prix',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'liste',
					$author$project$I18n$Traductions$Chaine(p.nW))
				]),
			'Prix « ' + (p.nW + ' »'));
	});
var $author$project$Components$Produits$Offres$View$prixPublic = F3(
	function (i18n, prix, offre) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (lus) {
				return A3(
					$elm$core$Maybe$map2,
					F2(
						function (liste, devise) {
							return _Utils_Tuple3(lus, liste, devise);
						}),
					lus.nW,
					lus.kO);
			},
			prix);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var lus = _v1.a;
			var liste = _v1.b;
			var devise = _v1.c;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$author$project$I18n$Cles$produitsOffresCartePrix,
						i18n,
						{nW: liste.Dj.zX}),
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$I18n$Cles$produitsCatalogueInfoSansValeur(i18n),
						A2(
							$elm$core$Maybe$map,
							A2(
								$author$project$Components$Produits$Common$Prix$court,
								i18n,
								{kO: devise, rB: lus.rB}),
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.Hc;
										},
										$elm$core$Basics$eq(offre.Aq)),
									lus.py)))))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$I18n$Cles$produitsOffresCarteType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.offres.carte.type', _List_Nil, 'Catégorie');
};
var $author$project$I18n$Cles$produitsOffresCarteRoles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.offres.carte.roles', _List_Nil, 'Rôles ouverts');
};
var $author$project$Components$Produits$Offres$View$rolesOuverts = F3(
	function (i18n, roles, offre) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (lus) {
					return _List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$I18n$Cles$produitsOffresCarteRoles(i18n),
							A2(
								$author$project$Components$Produits$Common$RolesParOffre$ligne,
								i18n,
								A3(
									$author$project$Components$Produits$Common$RolesParOffre$pourUneOffre,
									i18n,
									$author$project$Catalogue$Identifiants$referenceIdToString(offre.Aq),
									lus)))
						]);
				},
				roles));
	});
var $author$project$Components$Produits$Offres$View$entree = F5(
	function (i18n, prix, roles, annuaire, offre) {
		var adresse = $author$project$Routes$Route$toString(
			$author$project$Routes$Route$FicheOffre(offre.Aq));
		return {
			aa: offre.Ex ? $elm$core$Maybe$Just(adresse) : $elm$core$Maybe$Nothing,
			Aq: $author$project$Catalogue$Identifiants$referenceIdToString(offre.Aq),
			m9: $elm$core$Maybe$Nothing,
			gL: A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$I18n$Cles$produitsOffresCarteType(i18n),
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$I18n$Cles$produitsCatalogueInfoSansValeur(i18n),
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.zX;
							},
							offre.r0.Dj))),
				_Utils_ap(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (lie) {
								return _List_fromArray(
									[
										_Utils_Tuple2(
										A3($author$project$Components$Produits$Offres$Model$libelleDuNiveau, i18n, annuaire, lie.os),
										lie.R.zX)
									]);
							},
							offre.pN)),
					_Utils_ap(
						A3($author$project$Components$Produits$Offres$View$prixPublic, i18n, prix, offre),
						A3($author$project$Components$Produits$Offres$View$rolesOuverts, i18n, roles, offre)))),
			ry: offre.tL ? _List_fromArray(
				[
					_Utils_Tuple2(
					3,
					$author$project$I18n$Cles$produitsReferencesCarteArretee(i18n))
				]) : _List_fromArray(
				[
					_Utils_Tuple2(
					0,
					A3($author$project$Components$Produits$Common$Etat$libelle, i18n, annuaire.mj, offre.gt))
				]),
			rz: _List_Nil,
			h6: A2(
				$elm$core$Maybe$withDefault,
				offre.vx,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.zX;
					},
					offre.Dj))
		};
	});
var $author$project$I18n$Cles$produitsOffresAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.offres.aucune', _List_Nil, 'Aucune offre de service pour l\'instant.');
};
var $author$project$I18n$Cles$produitsOffresNombre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.offres.nombre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' offre de service') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' offres de service'));
	});
var $author$project$Components$Produits$Offres$View$donnees = F2(
	function (i18n, model) {
		var offres = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.D3;
				},
				model.aS));
		return {
			sQ: _List_Nil,
			ue: false,
			uf: false,
			uh: false,
			ui: false,
			uH: false,
			u7: _Utils_eq(model.aS, $elm$core$Maybe$Nothing),
			vG: _List_Nil,
			wl: function () {
				var _v0 = A2($elm$core$Maybe$andThen, $author$project$Components$Produits$Offres$Model$creation, model.aS);
				if (!_v0.$) {
					return _List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							0,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Offres$Model$idDeLaCreation),
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Offres$Update$CreationOuverte)
								]),
							$author$project$I18n$Cles$produitsOffresCreationTitre(i18n))
						]);
				} else {
					return _List_Nil;
				}
			}(),
			xs: $author$project$I18n$Cles$annuaireAnnulerLaSelection(i18n),
			yt: 'offre',
			yv: A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (annuaire) {
						return A2(
							$elm$core$List$map,
							A4($author$project$Components$Produits$Offres$View$entree, i18n, model.py, model.eX, annuaire),
							offres);
					},
					model.aS)),
			mG: _List_Nil,
			R: {
				jA: $elm$core$Basics$identity,
				j1: {
					m9: $elm$core$Maybe$Nothing,
					ry: $author$project$I18n$Cles$produitsCatalogueColonneEtat(i18n),
					h6: $author$project$I18n$Cles$produitsOffresTitre(i18n)
				},
				fV: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function (annuaire) {
							return A2(
								$author$project$I18n$Cles$produitsOffresNombre,
								i18n,
								{w: annuaire.w});
						},
						model.aS)),
				hC: '',
				q3: function (_v1) {
					return '';
				},
				q4: function (nombre) {
					return A2(
						$author$project$I18n$Cles$annuaireSelectionDeLaPage,
						i18n,
						{w: nombre});
				},
				q5: function (nombre) {
					return A2(
						$author$project$I18n$Cles$annuaireSelectionDuFiltre,
						i18n,
						{w: nombre});
				},
				rN: ''
			},
			Cs: _Utils_eq(
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.D3;
						},
						$elm$core$List$isEmpty),
					model.aS),
				$elm$core$Maybe$Just(true)) ? _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsOffresAucune(i18n))
						]))
				]) : _List_Nil,
			EB: $elm$core$Maybe$Nothing,
			EH: $author$project$Components$Shared$Annuaire$View$PaginationEnPresentation,
			GS: $elm$core$Maybe$Nothing,
			hC: $author$project$Components$Shared$Annuaire$View$RechercheEnPresentation,
			Iz: false,
			JE: A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.w;
					},
					model.aS)),
			rS: _List_Nil
		};
	});
var $author$project$I18n$Cles$produitsOffresDescription = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.offres.description', _List_Nil, 'Ce que l\'organisation vend sans stock : frais, programmes, abonnements, prestations.');
};
var $author$project$I18n$Cles$produitsOffresNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.offres.note', _List_Nil, 'Une offre de service est une référence de nature « Service » : sans stock ni nomenclature, avec des prix, des rôles et des paiements.');
};
var $author$project$Components$Produits$Offres$View$view = F3(
	function (i18n, messages, model) {
		var fournies = A2($author$project$Components$Produits$Offres$View$donnees, i18n, model);
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'produits-offres-list',
			{
				ut: _Utils_eq(model.np, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						A2(
							$elm$core$List$cons,
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							_Utils_ap(
								A4($author$project$Components$Shared$Annuaire$View$liste, i18n, $author$project$Components$Produits$Offres$Update$DeLaListe, fournies, model.nW),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$produitsOffresNote(i18n))
											]))
									]))))
					]),
				xy: _List_fromArray(
					[
						A2($author$project$Components$Produits$Offres$View$creation, i18n, model)
					]),
				zM: A4($author$project$Components$Shared$Annuaire$View$fixed, i18n, $author$project$Components$Produits$Offres$Update$DeLaListe, fournies, model.nW),
				AK: $author$project$Components$Produits$Offres$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsOffresDescription(i18n))
									]))
							]),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adresseOffres,
								Dj: $author$project$I18n$Cles$produitsTitre(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$produitsOffresTitre(i18n)
					})
			});
	});
var $author$project$Components$Produits$Perimetres$Model$Creation = {$: 0};
var $author$project$Components$Produits$Perimetres$Update$GesteOuvert = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Produits$Perimetres$Update$GesteDemande = {$: 25};
var $author$project$I18n$Cles$perimetresArchiverAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.archiver.action', _List_Nil, 'Archiver');
};
var $author$project$I18n$Cles$perimetresArchiverTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.archiver.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Archiver « ' + (p.Dj + ' » ?'));
	});
var $author$project$I18n$Cles$perimetresArchiverTexte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.archiver.texte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'pipes',
					$author$project$I18n$Traductions$Chaine(p.FM)),
					_Utils_Tuple2(
					'champs',
					$author$project$I18n$Traductions$Chaine(p.dw))
				]),
			'Ce périmètre est utilisé par ' + (p.FM + (' et ' + (p.dw + '. Ils le gardent et continuent de l\'évaluer. Il ne sera plus proposé pour une nouvelle valeur ni dans un nouveau pipe. Vous pourrez le restaurer.'))));
	});
var $author$project$I18n$Cles$perimetresUtiliseChamps = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.utilise.champs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champ') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champs'));
	});
var $author$project$I18n$Cles$perimetresUtilisePipes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.utilise.pipes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' pipe') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' pipes'));
	});
var $author$project$Components$Produits$Perimetres$View$texteDArchivage = F2(
	function (i18n, model) {
		var apercu = model.tq;
		return A2(
			$author$project$I18n$Cles$perimetresArchiverTexte,
			i18n,
			{
				dw: A2(
					$author$project$I18n$Cles$perimetresUtiliseChamps,
					i18n,
					{
						w: A2(
							$elm$core$Maybe$withDefault,
							0,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.JF;
								},
								apercu))
					}),
				FM: A2(
					$author$project$I18n$Cles$perimetresUtilisePipes,
					i18n,
					{
						w: A2(
							$elm$core$Maybe$withDefault,
							0,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.JG;
								},
								apercu))
					})
			});
	});
var $author$project$Components$Produits$Perimetres$View$confirmationDArchivage = F2(
	function (i18n, model) {
		var ouverte = _Utils_eq(
			model.mW,
			$elm$core$Maybe$Just($author$project$Components$Produits$Perimetres$Model$Archivage)) && $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX);
		var nom = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Dj;
				},
				model.zo));
		var ids = $author$project$Components$Shared$Confirmation$Clavier$ids('perimetres-archiver');
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('opened', ouverte)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('overlay'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Produits$Perimetres$Update$DuDrawer($author$project$Components$Shared$Drawer$Update$Fermer))
						]),
					_List_Nil),
					_Utils_eq(
					model.mW,
					$elm$core$Maybe$Just($author$project$Components$Produits$Perimetres$Model$Archivage)) ? A2(
					$author$project$Components$Shared$Confirmation$View$view,
					i18n,
					{
						vl: A2(
							$author$project$Components$Shared$Confirmation$Clavier$clavier,
							ids,
							function (vers) {
								return $author$project$Components$Produits$Perimetres$Update$DuDrawer(
									$author$project$Components$Shared$Drawer$Update$FocusDemande(vers));
							}),
						j7: {
							Aq: ids.j7,
							Bl: $author$project$I18n$Cles$perimetresArchiverAction(i18n),
							C$: $author$project$Components$Produits$Perimetres$Update$GesteDemande
						},
						Aq: ids.GN,
						As: ids.Cs,
						At: ids.h6,
						Cs: A2($author$project$Components$Produits$Perimetres$View$texteDArchivage, i18n, model),
						Et: ouverte,
						HG: {
							Aq: ids.to,
							Bl: $author$project$I18n$Cles$drawerAnnuler(i18n),
							C$: $author$project$Components$Produits$Perimetres$Update$DuDrawer($author$project$Components$Shared$Drawer$Update$Fermer)
						},
						h6: A2(
							$author$project$I18n$Cles$perimetresArchiverTitre,
							i18n,
							{Dj: nom}),
						sl: 1
					}) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$Components$Produits$Perimetres$Model$ApercuDUnClient = {$: 13};
var $author$project$I18n$Cles$perimetresApercuException = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.apercu.exception',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'avant',
					$author$project$I18n$Traductions$Chaine(p.je)),
					_Utils_Tuple2(
					'apres',
					$author$project$I18n$Traductions$Entier(p.iY))
				]),
			((!p.iY) || (p.iY === 1)) ? ('Aperçu : ' + (p.je + (' → ' + (A2($author$project$I18n$Nombre$formater, 0, p.iY) + ' référence')))) : ('Aperçu : ' + (p.je + (' → ' + (A2($author$project$I18n$Nombre$formater, 0, p.iY) + ' références')))));
	});
var $author$project$Components$Produits$Perimetres$View$apercuDException = F2(
	function (i18n, apercu) {
		return A2(
			$author$project$I18n$Cles$perimetresApercuException,
			i18n,
			{
				iY: apercu.iY,
				je: $elm$core$String$fromInt(apercu.je)
			});
	});
var $author$project$I18n$Cles$perimetresCreationSource = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.creation.source', _List_Nil, 'Catalogue source : Catalogue produits');
};
var $author$project$I18n$Cles$perimetresCriteresNoteSansValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.criteres.note.sans.valeur', _List_Nil, 'Un critère sans valeur est refusé.');
};
var $author$project$Components$Produits$Perimetres$View$apercuChiffre = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.mW, model.iT);
		_v0$4:
		while (true) {
			if (!_v0.a.$) {
				switch (_v0.a.a.$) {
					case 0:
						var _v1 = _v0.a.a;
						return $elm$core$Maybe$Just(
							$author$project$I18n$Cles$perimetresCreationSource(i18n));
					case 2:
						var _v2 = _v0.a.a;
						return $elm$core$Maybe$Just(
							$author$project$I18n$Cles$perimetresCriteresNoteSansValeur(i18n));
					case 5:
						if (!_v0.b.$) {
							var _v3 = _v0.a.a;
							var apercu = _v0.b.a;
							return $elm$core$Maybe$Just(
								A2($author$project$Components$Produits$Perimetres$View$apercuDException, i18n, apercu));
						} else {
							break _v0$4;
						}
					case 6:
						if (!_v0.b.$) {
							var _v4 = _v0.a.a;
							var apercu = _v0.b.a;
							return $elm$core$Maybe$Just(
								A2($author$project$Components$Produits$Perimetres$View$apercuDException, i18n, apercu));
						} else {
							break _v0$4;
						}
					default:
						break _v0$4;
				}
			} else {
				break _v0$4;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Components$Shared$Drawer$View$consultationAnnulable = F3(
	function (i18n, versMsg, contenu) {
		return A6(
			$author$project$Components$Shared$Drawer$View$consultationAvec,
			i18n,
			versMsg,
			1,
			$author$project$I18n$Cles$drawerAnnuler(i18n),
			{oJ: $elm$core$Maybe$Nothing, aO: contenu.aO},
			{fZ: contenu.fZ, G8: contenu.G8, h6: contenu.h6});
	});
var $author$project$Components$Shared$Drawer$View$consultationAvecSousTitre = F3(
	function (i18n, versMsg, contenu) {
		return A6(
			$author$project$Components$Shared$Drawer$View$consultationAvec,
			i18n,
			versMsg,
			1,
			$author$project$I18n$Cles$drawerFermer(i18n),
			{oJ: $elm$core$Maybe$Nothing, aO: contenu.aO},
			{fZ: contenu.fZ, G8: contenu.G8, h6: contenu.h6});
	});
var $author$project$Components$Produits$Perimetres$Update$NomSaisi = function (a) {
	return {$: 7, a: a};
};
var $author$project$I18n$Cles$perimetresCreationEncartTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.creation.encart-texte', _List_Nil, 'Le périmètre est créé « En cours » et s\'ouvre à l\'étape 1.');
};
var $author$project$I18n$Cles$perimetresCreationEncartTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.creation.encart-titre', _List_Nil, 'Rien n\'est encore sélectionné.');
};
var $author$project$I18n$Cles$perimetresCreationNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.creation.nom', _List_Nil, 'Nom');
};
var $author$project$I18n$Cles$perimetresCreationNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.creation.note', _List_Nil, 'En français ; les autres langues se renseignent ensuite avec « Renommer et traduire ».');
};
var $author$project$Components$Produits$Perimetres$View$creation = F3(
	function (i18n, prefixe, model) {
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Champ$View$texte,
				{
					go: $elm$core$Maybe$Nothing,
					Aq: prefixe + '-nom',
					Bl: $author$project$I18n$Cles$perimetresCreationNom(i18n),
					he: true
				},
				{hg: $author$project$Components$Produits$Perimetres$Update$NomSaisi, fm: model.Dj}),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$perimetresCreationNote(i18n))
					])),
				A2(
				$author$project$Components$Shared$Note$View$view,
				0,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$perimetresCreationEncartTitre(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$perimetresCreationEncartTexte(i18n))
							]))
					]))
			]);
	});
var $author$project$Components$Produits$Perimetres$Update$Attribut = 0;
var $author$project$Components$Produits$Perimetres$Update$ChampDeLaFiche = 2;
var $author$project$Components$Produits$Perimetres$Update$Correspondance = 3;
var $author$project$Components$Produits$Perimetres$Update$CritereLieSaisi = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Components$Produits$Perimetres$Update$Nature = 1;
var $author$project$I18n$Cles$perimetresFicheAttribut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.fiche.attribut', _List_Nil, 'Attribut');
};
var $author$project$I18n$Cles$perimetresFicheAucuneCombinaison = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.fiche.aucune.combinaison', _List_Nil, 'Aucune combinaison n\'est encore permise : elle dépend des correspondances de votre bibliothèque de champs.');
};
var $author$project$I18n$Cles$perimetresFicheChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.fiche.champ', _List_Nil, 'Valeur de la fiche');
};
var $author$project$I18n$Cles$perimetresFicheCorrespondance = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.fiche.correspondance', _List_Nil, 'Par la correspondance');
};
var $author$project$I18n$Cles$perimetresFicheCorrespondanceAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.fiche.correspondance.aucune', _List_Nil, 'Comparaison directe');
};
var $author$project$I18n$Cles$perimetresFicheIntertitreFiche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.fiche.intertitre.fiche', _List_Nil, 'Comparer à la fiche visée');
};
var $author$project$I18n$Cles$perimetresFicheIntertitreReference = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.fiche.intertitre.reference', _List_Nil, 'Sur la référence');
};
var $author$project$I18n$Cles$perimetresFicheNature = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.fiche.nature', _List_Nil, 'Fiche visée');
};
var $author$project$I18n$Cles$perimetresRegleApercu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.regle.apercu', _List_Nil, 'Aperçu');
};
var $author$project$Components$Produits$Perimetres$View$phraseEnSegments = function (segments) {
	return A2(
		$elm$core$List$map,
		function (segment) {
			return segment.dX ? A2(
				$rtfeldman$elm_css$Html$Styled$strong,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(segment.Jx)
					])) : $rtfeldman$elm_css$Html$Styled$text(segment.Jx);
		},
		segments);
};
var $author$project$Components$Produits$Perimetres$View$critereLie = F2(
	function (i18n, model) {
		var options = model.hh;
		var liste = F6(
			function (id, libelle, rubrique, valeur, proposes, sansChoix) {
				return A2(
					$author$project$Components$Shared$Champ$View$liste,
					{go: $elm$core$Maybe$Nothing, Aq: id, Bl: libelle, he: true},
					{
						hg: $author$project$Components$Produits$Perimetres$Update$CritereLieSaisi(rubrique),
						o_: A2(
							$elm$core$List$cons,
							{Bl: sansChoix, fm: ''},
							A2(
								$elm$core$List$map,
								function (_v1) {
									var code = _v1.a;
									var nom = _v1.b;
									return {Bl: nom, fm: code};
								},
								proposes)),
						fm: valeur
					});
			});
		var choix = model.fP;
		return _List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.vH;
						},
						$elm$core$List$isEmpty),
					options)) ? A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$perimetresFicheAucuneCombinaison(i18n))
					])) : $rtfeldman$elm_css$Html$Styled$text(''),
				A2(
				$rtfeldman$elm_css$Html$Styled$h3,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('intertitre')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$perimetresFicheIntertitreReference(i18n))
					])),
				A6(
				liste,
				'perimetres-critere-attribut',
				$author$project$I18n$Cles$perimetresFicheAttribut(i18n),
				0,
				choix.tV,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.i8;
						},
						options)),
				'—'),
				A2(
				$rtfeldman$elm_css$Html$Styled$h3,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('intertitre')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$perimetresFicheIntertitreFiche(i18n))
					])),
				A6(
				liste,
				'perimetres-critere-nature',
				$author$project$I18n$Cles$perimetresFicheNature(i18n),
				1,
				choix.g1,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.oo;
						},
						options)),
				'—'),
				A6(
				liste,
				'perimetres-critere-champ',
				$author$project$I18n$Cles$perimetresFicheChamp(i18n),
				2,
				choix.uN,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.dw;
						},
						options)),
				'—'),
				A6(
				liste,
				'perimetres-critere-correspondance',
				$author$project$I18n$Cles$perimetresFicheCorrespondance(i18n),
				3,
				choix.wg,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.wh;
						},
						options)),
				$author$project$I18n$Cles$perimetresFicheCorrespondanceAucune(i18n)),
				function () {
				var _v0 = $author$project$Components$Produits$Perimetres$Model$combinaisonChoisie(model);
				if (!_v0.$) {
					var combinaison = _v0.a;
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu-de-regle'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-live', 'polite')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$perimetresRegleApercu(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								$author$project$Components$Produits$Perimetres$View$phraseEnSegments(combinaison.Fp))
							]));
				} else {
					return _Utils_eq(choix, $author$project$Components$Produits$Perimetres$Model$choixVide) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('refus'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$perimetresFicheAucuneCombinaison(i18n))
							]));
				}
			}()
			]);
	});
var $author$project$Components$Produits$Perimetres$Update$DimensionAjoutee = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Produits$Perimetres$Update$DimensionChangee = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$Produits$Perimetres$Update$DimensionRetiree = function (a) {
	return {$: 10, a: a};
};
var $author$project$I18n$Cles$perimetresCriteresCritere = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.criteres.critere',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Critère · ' + p.Dj);
	});
var $author$project$I18n$Cles$perimetresCriteresEtage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.criteres.etage', _List_Nil, 'Étage');
};
var $author$project$I18n$Cles$perimetresCriteresRetirer = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.criteres.retirer',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer le critère ' + p.Dj);
	});
var $author$project$I18n$Cles$perimetresCriteresRetirerCourt = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.criteres.retirer-court', _List_Nil, 'Retirer');
};
var $author$project$I18n$Cles$perimetresCriteresTypeAttribut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.criteres.type-attribut', _List_Nil, 'Attribut');
};
var $author$project$I18n$Cles$perimetresCriteresTypeEtage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.criteres.type-etage', _List_Nil, 'Étage');
};
var $author$project$I18n$Cles$perimetresCriteresUneSuffit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.criteres.une-suffit', _List_Nil, '(l\'une d\'elles suffit)');
};
var $author$project$I18n$Cles$perimetresCriteresValeursEtage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.criteres.valeurs-etage', _List_Nil, 'Valeurs de cet étage');
};
var $author$project$Components$Produits$Perimetres$Update$ValeurBasculee = F3(
	function (a, b, c) {
		return {$: 12, a: a, b: b, c: c};
	});
var $author$project$I18n$Cles$perimetresCriteresReferences = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.criteres.references',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			p.w + ' réf.');
	});
var $author$project$Components$Produits$Perimetres$View$valeurDeCritere = F4(
	function (i18n, model, dimension, _v0) {
		var code = _v0.a;
		var libelle = _v0.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pick-ligne')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-valeur', code),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(
							A2(
								$elm$core$List$member,
								code,
								A2($author$project$Components$Produits$Perimetres$Model$valeursChoisies, dimension.dy, model))),
							$rtfeldman$elm_css$Html$Styled$Events$onCheck(
							A2($author$project$Components$Produits$Perimetres$Update$ValeurBasculee, dimension.dy, code))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						])),
					function () {
					var _v1 = $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (_v2) {
								var autre = _v2.a;
								return _Utils_eq(autre, code);
							},
							dimension.hD));
					if (!_v1.$) {
						var _v3 = _v1.a;
						var nombre = _v3.b;
						return A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('references')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$perimetresCriteresReferences,
										i18n,
										{
											w: $elm$core$String$fromInt(nombre)
										}))
								]));
					} else {
						return $rtfeldman$elm_css$Html$Styled$text('');
					}
				}()
				]));
	});
var $author$project$Components$Produits$Perimetres$View$carteDeCritere = F4(
	function (i18n, model, dimensions, dimension) {
		var etages = A2(
			$elm$core$List$filter,
			function (autre) {
				return A2($elm$core$String$startsWith, 'etage:', autre.dy);
			},
			dimensions);
		var estEtage = A2($elm$core$String$startsWith, 'etage:', dimension.dy);
		var genre = estEtage ? $elm$core$Maybe$Just(
			$author$project$I18n$Cles$perimetresCriteresTypeEtage(i18n)) : (A2($elm$core$String$startsWith, 'attribut:', dimension.dy) ? $elm$core$Maybe$Just(
			$author$project$I18n$Cles$perimetresCriteresTypeAttribut(i18n)) : $elm$core$Maybe$Nothing);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('critere'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-critere', dimension.dy)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('critere-entete')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$perimetresCriteresCritere,
										i18n,
										{Dj: dimension.Bl}))
								])),
							function () {
							if (!genre.$) {
								var libelle = genre.a;
								return A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('tag')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(libelle)
										]));
							} else {
								return $rtfeldman$elm_css$Html$Styled$text('');
							}
						}(),
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									A2(
										$author$project$I18n$Cles$perimetresCriteresRetirer,
										i18n,
										{Dj: dimension.Bl})),
									$rtfeldman$elm_css$Html$Styled$Attributes$title(
									A2(
										$author$project$I18n$Cles$perimetresCriteresRetirer,
										i18n,
										{Dj: dimension.Bl})),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Produits$Perimetres$Update$DimensionRetiree(dimension.dy))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$perimetresCriteresRetirerCourt(i18n))
								]))
						])),
					estEtage ? A2(
					$rtfeldman$elm_css$Html$Styled$fieldset,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$legend,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$perimetresCriteresEtage(i18n))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$select,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									$author$project$I18n$Cles$perimetresCriteresEtage(i18n)),
									$rtfeldman$elm_css$Html$Styled$Events$onInput(
									$author$project$Components$Produits$Perimetres$Update$DimensionChangee(dimension.dy))
								]),
							A2(
								$elm$core$List$map,
								function (autre) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$option,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$value(autre.dy),
												$rtfeldman$elm_css$Html$Styled$Attributes$selected(
												_Utils_eq(autre.dy, dimension.dy))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(autre.Bl)
											]));
								},
								etages))
						])) : $rtfeldman$elm_css$Html$Styled$text(''),
					estEtage ? A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('valeurs-titre')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$perimetresCriteresValeursEtage(i18n))
								])),
							$rtfeldman$elm_css$Html$Styled$text(' '),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('une-suffit')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$perimetresCriteresUneSuffit(i18n))
								]))
						])) : $rtfeldman$elm_css$Html$Styled$text(''),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('pick')
						]),
					A2(
						$elm$core$List$map,
						A3($author$project$Components$Produits$Perimetres$View$valeurDeCritere, i18n, model, dimension),
						dimension.Ki))
				]));
	});
var $author$project$I18n$Cles$perimetresCriteresAjouter = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.criteres.ajouter',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Ajouter : ' + p.Dj);
	});
var $author$project$I18n$Cles$perimetresCriteresAjouterCritere = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.criteres.ajouter-critere', _List_Nil, '+ Critère');
};
var $author$project$I18n$Cles$perimetresCriteresDecompteSelection = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.criteres.decompte-selection',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Valeurs masquées exclues. ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' référence correspond avec cette sélection.')) : ('Valeurs masquées exclues. ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' références correspondent avec cette sélection.')));
	});
var $author$project$I18n$Cles$perimetresCriteresNoteEtagesTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.criteres.note-etages-texte', _List_Nil, 'On choisit d\'abord l\'étage, puis ses valeurs.');
};
var $author$project$I18n$Cles$perimetresCriteresNoteEtagesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.criteres.note-etages-titre', _List_Nil, 'Marque et gamme sont des étages du catalogue.');
};
var $author$project$I18n$Cles$perimetresCriteresProposeTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.criteres.propose-texte', _List_Nil, 'un étage du catalogue (marque, gamme, famille…) · typologie · nature · attribut du catalogue filtrable.');
};
var $author$project$I18n$Cles$perimetresCriteresProposeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.criteres.propose-titre', _List_Nil, 'Ajouter un critère propose :');
};
var $author$project$I18n$Cles$perimetresCriteresRetablir = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.criteres.retablir',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.Dj + ' (retiré) · rétablir');
	});
var $author$project$Components$Produits$Perimetres$View$criteres = F2(
	function (i18n, model) {
		var dimensions = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.xz;
				},
				model.et));
		var inactives = A2(
			$elm$core$List$filter,
			function (dimension) {
				return !A2($elm$core$List$member, dimension.dy, model.dj);
			},
			dimensions);
		var prochaine = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (dimension) {
					return A2($elm$core$String$startsWith, 'etage:', dimension.dy);
				},
				inactives));
		var retirees = A2(
			$elm$core$List$filterMap,
			function (cle) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (dimension) {
							return _Utils_eq(dimension.dy, cle);
						},
						dimensions));
			},
			model.qJ);
		var autres = A2(
			$elm$core$List$filter,
			function (dimension) {
				return !A2($elm$core$List$member, dimension.dy, model.qJ);
			},
			A2(
				$elm$core$List$filter,
				function (dimension) {
					return !A2($elm$core$String$startsWith, 'etage:', dimension.dy);
				},
				inactives));
		var actives = A2(
			$elm$core$List$filterMap,
			function (cle) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (dimension) {
							return _Utils_eq(dimension.dy, cle);
						},
						dimensions));
			},
			model.dj);
		return _Utils_ap(
			_List_fromArray(
				[
					function () {
					var _v0 = model.kx;
					if (!_v0.$) {
						var nombre = _v0.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('decompte')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$perimetresCriteresDecompteSelection,
										i18n,
										{w: nombre}))
								]));
					} else {
						return $rtfeldman$elm_css$Html$Styled$text('');
					}
				}(),
					A2(
					$author$project$Components$Shared$Note$View$view,
					0,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$perimetresCriteresNoteEtagesTitre(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$perimetresCriteresNoteEtagesTexte(i18n))
								]))
						]))
				]),
			_Utils_ap(
				A2(
					$elm$core$List$map,
					A3($author$project$Components$Produits$Perimetres$View$carteDeCritere, i18n, model, dimensions),
					actives),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('chips')
							]),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								function (dimension) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$button,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('chip'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('retiree'),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												$author$project$Components$Produits$Perimetres$Update$DimensionAjoutee(dimension.dy))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$perimetresCriteresRetablir,
													i18n,
													{Dj: dimension.Bl}))
											]));
								},
								retirees),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									function (dimension) {
										return A2(
											$rtfeldman$elm_css$Html$Styled$button,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
													$rtfeldman$elm_css$Html$Styled$Attributes$class('chip'),
													$rtfeldman$elm_css$Html$Styled$Attributes$class('retiree'),
													$rtfeldman$elm_css$Html$Styled$Events$onClick(
													$author$project$Components$Produits$Perimetres$Update$DimensionAjoutee(dimension.dy))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$author$project$I18n$Cles$perimetresCriteresAjouter,
														i18n,
														{Dj: dimension.Bl}))
												]));
									},
									autres),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$button,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('chip'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('retiree'),
												$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
												_Utils_eq(prochaine, $elm$core$Maybe$Nothing)),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												$author$project$Components$Produits$Perimetres$Update$DimensionAjoutee(
													A2(
														$elm$core$Maybe$withDefault,
														'',
														A2(
															$elm$core$Maybe$map,
															function ($) {
																return $.dy;
															},
															prochaine))))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$perimetresCriteresAjouterCritere(i18n))
											]))
									])))),
						A2(
						$author$project$Components$Shared$Note$View$view,
						0,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$perimetresCriteresProposeTitre(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$perimetresCriteresProposeTexte(i18n))
									]))
							]))
					])));
	});
var $author$project$Components$Produits$Perimetres$Update$MotifChoisi = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Produits$Perimetres$Update$RechercheSaisie = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Produits$Perimetres$Update$ReferenceChoisie = function (a) {
	return {$: 17, a: a};
};
var $author$project$I18n$Cles$perimetresReferenceAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.reference.aucune', _List_Nil, 'Aucune référence ne correspond.');
};
var $author$project$I18n$Cles$perimetresReferencePlus = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.reference.plus', _List_Nil, 'D\'autres références existent : précisez la recherche.');
};
var $author$project$I18n$Cles$perimetresReferenceRecherche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.reference.recherche', _List_Nil, 'Référence');
};
var $author$project$I18n$Cles$perimetresReferenceRechercheAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.reference.recherche.aide', _List_Nil, 'Cherchez par code ou par désignation.');
};
var $author$project$Components$Produits$Perimetres$View$choixDeReference = F3(
	function (i18n, prefixe, model) {
		var propositions = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.hD;
				},
				model.Gw));
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Champ$View$texte,
				{
					go: $elm$core$Maybe$Nothing,
					Aq: prefixe + '-recherche',
					Bl: $author$project$I18n$Cles$perimetresReferenceRecherche(i18n),
					he: true
				},
				{hg: $author$project$Components$Produits$Perimetres$Update$RechercheSaisie, fm: model.hC}),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$perimetresReferenceRechercheAide(i18n))
					])),
				((!_Utils_eq(model.Gw, $elm$core$Maybe$Nothing)) && $elm$core$List$isEmpty(propositions)) ? A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$perimetresReferenceAucune(i18n))
					])) : A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('pick')
					]),
				A2(
					$elm$core$List$map,
					function (proposee) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('pick-ligne')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$input,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
											$rtfeldman$elm_css$Html$Styled$Attributes$name('choix-reference'),
											$rtfeldman$elm_css$Html$Styled$Attributes$checked(
											_Utils_eq(
												model.Hc,
												$elm$core$Maybe$Just(proposee.r8))),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Produits$Perimetres$Update$ReferenceChoisie(proposee.r8))
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('reference-proposee')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('nom-du-type')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(proposee.xt)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('code')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(proposee.vx)
												]))
										]))
								]));
					},
					propositions)),
				A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.pp;
					},
					model.Gw)) ? A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$perimetresReferencePlus(i18n))
					])) : $rtfeldman$elm_css$Html$Styled$text('')
			]);
	});
var $author$project$I18n$Cles$perimetresExclusionMotif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.exclusion.motif', _List_Nil, 'Motif');
};
var $author$project$I18n$Cles$perimetresExclusionNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.exclusion.note', _List_Nil, 'Une référence des critères (ou des inclusions) à retirer du périmètre.');
};
var $author$project$I18n$Cles$perimetresMotifNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.motif.note', _List_Nil, 'Visible de vos collègues, jamais du client.');
};
var $author$project$Components$Produits$Perimetres$View$drawerExclusion = F3(
	function (i18n, prefixe, model) {
		return A2(
			$elm$core$List$cons,
			A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$perimetresExclusionNote(i18n))
					])),
			_Utils_ap(
				A3($author$project$Components$Produits$Perimetres$View$choixDeReference, i18n, prefixe, model),
				_List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Champ$View$liste,
						{
							go: $elm$core$Maybe$Nothing,
							Aq: prefixe + '-motif-exclusion',
							Bl: $author$project$I18n$Cles$perimetresExclusionMotif(i18n),
							he: false
						},
						{
							hg: $author$project$Components$Produits$Perimetres$Update$MotifChoisi,
							o_: A2(
								$elm$core$List$cons,
								{Bl: '—', fm: ''},
								A2(
									$elm$core$List$map,
									function (_v0) {
										var code = _v0.a;
										var libelle = _v0.b;
										return {Bl: libelle, fm: code};
									},
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.CY;
											},
											model.cI)))),
							fm: A2($elm$core$Maybe$withDefault, '', model.ek)
						}),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$perimetresMotifNote(i18n))
							]))
					])));
	});
var $author$project$Components$Produits$Perimetres$Update$MotifSaisi = function (a) {
	return {$: 18, a: a};
};
var $author$project$I18n$Cles$perimetresColonneMotifFacultatif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.colonne.motif.facultatif', _List_Nil, 'Motif (facultatif)');
};
var $author$project$I18n$Cles$perimetresInclusionNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.inclusion.note', _List_Nil, 'Une référence qui ne répond pas aux critères mais doit faire partie du périmètre.');
};
var $author$project$Components$Produits$Perimetres$View$drawerInclusion = F3(
	function (i18n, prefixe, model) {
		return A2(
			$elm$core$List$cons,
			A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$perimetresInclusionNote(i18n))
					])),
			_Utils_ap(
				A3($author$project$Components$Produits$Perimetres$View$choixDeReference, i18n, prefixe, model),
				_List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Champ$View$texte,
						{
							go: $elm$core$Maybe$Nothing,
							Aq: prefixe + '-motif',
							Bl: $author$project$I18n$Cles$perimetresColonneMotifFacultatif(i18n),
							he: false
						},
						{hg: $author$project$Components$Produits$Perimetres$Update$MotifSaisi, fm: model.cX}),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$perimetresMotifNote(i18n))
							]))
					])));
	});
var $author$project$Components$Produits$Perimetres$Update$BaseChoisie = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Produits$Perimetres$Update$PeriodeChoisie = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$Produits$Perimetres$Update$PorteeChoisie = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Produits$Perimetres$Update$ValeurSaisie = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Produits$Perimetres$Update$TypeChoisi = function (a) {
	return {$: 20, a: a};
};
var $author$project$I18n$Cles$typesDeQuantiteComportementMaximum = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.comportement.maximum', _List_Nil, 'Maximum');
};
var $author$project$I18n$Cles$typesDeQuantiteComportementMinimum = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.comportement.minimum', _List_Nil, 'Minimum');
};
var $author$project$I18n$Cles$typesDeQuantiteComportementMultiple = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.comportement.multiple', _List_Nil, 'Multiple de');
};
var $author$project$Components$Produits$Vocabulaire$libelleDuComportement = F2(
	function (i18n, comportement) {
		switch (comportement) {
			case 'maximum':
				return $author$project$I18n$Cles$typesDeQuantiteComportementMaximum(i18n);
			case 'multiple':
				return $author$project$I18n$Cles$typesDeQuantiteComportementMultiple(i18n);
			default:
				return $author$project$I18n$Cles$typesDeQuantiteComportementMinimum(i18n);
		}
	});
var $author$project$Components$Produits$Perimetres$View$choixDeType = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pick')
				]),
			A2(
				$elm$core$List$map,
				function (proposee) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('pick-ligne')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$input,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
										$rtfeldman$elm_css$Html$Styled$Attributes$name('type'),
										$rtfeldman$elm_css$Html$Styled$Attributes$checked(
										_Utils_eq(
											model.dc,
											$elm$core$Maybe$Just(proposee.r8))),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Produits$Perimetres$Update$TypeChoisi(proposee.r8))
									]),
								_List_Nil),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('nom-du-type')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(proposee.Dj)
									])),
								A2(
								$author$project$Components$Shared$Tag$View$view,
								5,
								A2($author$project$Components$Produits$Vocabulaire$libelleDuComportement, i18n, proposee.vV))
							]));
				},
				$author$project$Components$Produits$Perimetres$Model$typesProposes(model)));
	});
var $author$project$Components$Produits$Perimetres$View$choixUnique = F2(
	function (reglage, options) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pick')
				]),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var code = _v0.a;
					var libelle = _v0.b;
					return A2(
						$rtfeldman$elm_css$Html$Styled$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('pick-ligne'),
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'indisponible',
										reglage.AJ(code))
									]))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$input,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
										$rtfeldman$elm_css$Html$Styled$Attributes$name(reglage.Dj),
										$rtfeldman$elm_css$Html$Styled$Attributes$checked(
										_Utils_eq(
											reglage.vd,
											$elm$core$Maybe$Just(code))),
										$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
										reglage.AJ(code)),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										reglage.Eb(code))
									]),
								_List_Nil),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(libelle)
									]))
							]));
				},
				options));
	});
var $author$project$I18n$Cles$perimetresRegleBaseCommandeConsolidee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.regle.base.commande.consolidee', _List_Nil, 'Sur la commande consolidée');
};
var $author$project$I18n$Cles$perimetresRegleBaseParCommande = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.regle.base.par.commande', _List_Nil, 'Par commande');
};
var $author$project$I18n$Cles$perimetresRegleBaseParPeriode = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.regle.base.par.periode', _List_Nil, 'Par période');
};
var $author$project$Components$Produits$Vocabulaire$libelleDeLaBase = F2(
	function (i18n, base) {
		switch (base) {
			case 'par-periode':
				return $author$project$I18n$Cles$perimetresRegleBaseParPeriode(i18n);
			case 'commande-consolidee':
				return $author$project$I18n$Cles$perimetresRegleBaseCommandeConsolidee(i18n);
			default:
				return $author$project$I18n$Cles$perimetresRegleBaseParCommande(i18n);
		}
	});
var $author$project$I18n$Cles$perimetresReglePeriodeAnnee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.regle.periode.annee', _List_Nil, 'Année');
};
var $author$project$I18n$Cles$perimetresReglePeriodeMois = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.regle.periode.mois', _List_Nil, 'Mois');
};
var $author$project$I18n$Cles$perimetresReglePeriodeTrimestre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.regle.periode.trimestre', _List_Nil, 'Trimestre');
};
var $author$project$Components$Produits$Vocabulaire$libelleDeLaPeriode = F2(
	function (i18n, periode) {
		switch (periode) {
			case 'trimestre':
				return $author$project$I18n$Cles$perimetresReglePeriodeTrimestre(i18n);
			case 'annee':
				return $author$project$I18n$Cles$perimetresReglePeriodeAnnee(i18n);
			default:
				return $author$project$I18n$Cles$perimetresReglePeriodeMois(i18n);
		}
	});
var $author$project$I18n$Cles$perimetresReglePorteeParReference = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.regle.portee.par.reference', _List_Nil, 'Chaque référence');
};
var $author$project$I18n$Cles$perimetresReglePorteeToutesReferences = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.regle.portee.toutes.references', _List_Nil, 'Toutes références');
};
var $author$project$Components$Produits$Vocabulaire$libelleDeLaPortee = F2(
	function (i18n, portee) {
		if (portee === 'par-reference') {
			return $author$project$I18n$Cles$perimetresReglePorteeParReference(i18n);
		} else {
			return $author$project$I18n$Cles$perimetresReglePorteeToutesReferences(i18n);
		}
	});
var $author$project$I18n$Cles$perimetresRegleBase = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.regle.base', _List_Nil, 'S\'entend');
};
var $author$project$I18n$Cles$perimetresRegleBaseUniqueNote = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.regle.base.unique.note',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'« ' + (p.Dj + ' » n\'a qu\'une base permise : aucune autre n\'est proposée.'));
	});
var $author$project$I18n$Cles$perimetresRegleParametrerLesTypesLien = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.regle.parametrer.les.types.lien', _List_Nil, 'Paramétrer les types');
};
var $author$project$I18n$Cles$perimetresReglePeriode = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.regle.periode', _List_Nil, 'Période civile');
};
var $author$project$I18n$Cles$perimetresReglePortee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.regle.portee', _List_Nil, 'S\'applique à');
};
var $author$project$I18n$Cles$perimetresRegleRemplace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.regle.remplace', _List_Nil, 'Remplace la règle existante :');
};
var $author$project$I18n$Cles$perimetresRegleType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.regle.type', _List_Nil, 'Type de règle');
};
var $author$project$I18n$Cles$perimetresRegleTypesNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.regle.types.note', _List_Nil, 'Les types paramétrés pour cet espace.');
};
var $author$project$I18n$Cles$perimetresRegleValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.regle.valeur', _List_Nil, 'Nombre de pièces');
};
var $author$project$Components$Produits$Perimetres$View$formulaireDeRegle = F3(
	function (i18n, prefixe, model) {
		var type_ = $author$project$Components$Produits$Perimetres$Model$typeDeLaRegle(model);
		var options = F2(
			function (codes, libelle) {
				return A2(
					$elm$core$List$map,
					function (code) {
						return _Utils_Tuple2(
							code,
							libelle(code));
					},
					codes);
			});
		var bases = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.uo;
				},
				type_));
		var baseUnique = function () {
			var _v3 = _Utils_Tuple2(type_, bases);
			if (((!_v3.a.$) && _v3.b.b) && (!_v3.b.b.b)) {
				var choisi = _v3.a.a;
				var _v4 = _v3.b;
				return $elm$core$Maybe$Just(choisi.Dj);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$perimetresRegleType(i18n))
					])),
				A2($author$project$Components$Produits$Perimetres$View$choixDeType, i18n, model),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$perimetresRegleTypesNote(i18n)),
						$rtfeldman$elm_css$Html$Styled$text(' '),
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Routes$Route$adresseDesTypesDeQuantite)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$perimetresRegleParametrerLesTypesLien(i18n))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur-et-portee')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Champ$View$texte,
						{
							go: $elm$core$Maybe$Nothing,
							Aq: prefixe + '-valeur',
							Bl: $author$project$I18n$Cles$perimetresRegleValeur(i18n),
							he: true
						},
						{hg: $author$project$Components$Produits$Perimetres$Update$ValeurSaisie, fm: model.fm}),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('portee')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$perimetresReglePortee(i18n))
									])),
								$author$project$Components$Shared$Segment$View$view(
								{
									vd: model.F$,
									Bi: $author$project$I18n$Cles$perimetresReglePortee(i18n),
									Dj: 'portee',
									Ea: $author$project$Components$Produits$Perimetres$Update$PorteeChoisie,
									o_: A2(
										$elm$core$List$map,
										function (code) {
											return {
												vx: code,
												Bl: A2($author$project$Components$Produits$Vocabulaire$libelleDeLaPortee, i18n, code)
											};
										},
										_List_fromArray(
											['toutes-references', 'par-reference']))
								})
							]))
					])),
				_Utils_eq(type_, $elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('base-du-type')
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$perimetresRegleBase(i18n))
								])),
							A2(
							$author$project$Components$Produits$Perimetres$View$choixUnique,
							{
								vd: $elm$core$Maybe$Just(model.jo),
								AJ: function (_v0) {
									return false;
								},
								Dj: 'base',
								Eb: $author$project$Components$Produits$Perimetres$Update$BaseChoisie
							},
							A2(
								options,
								bases,
								$author$project$Components$Produits$Vocabulaire$libelleDeLaBase(i18n)))
						]),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (nom) {
								return _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$perimetresRegleBaseUniqueNote,
													i18n,
													{Dj: nom}))
											]))
									]);
							},
							baseUnique)))),
				(model.jo === 'par-periode') ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('periode'),
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('invalide', model.hq)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$perimetresReglePeriode(i18n))
							])),
						$author$project$Components$Shared$Segment$View$view(
						{
							vd: A2($elm$core$Maybe$withDefault, '', model.pi),
							Bi: $author$project$I18n$Cles$perimetresReglePeriode(i18n),
							Dj: 'periode',
							Ea: $author$project$Components$Produits$Perimetres$Update$PeriodeChoisie,
							o_: A2(
								$elm$core$List$map,
								function (code) {
									return {
										vx: code,
										Bl: A2($author$project$Components$Produits$Vocabulaire$libelleDeLaPeriode, i18n, code)
									};
								},
								_List_fromArray(
									['mois', 'trimestre', 'annee']))
						})
					])) : $rtfeldman$elm_css$Html$Styled$text(''),
				function () {
				var _v1 = model.fy;
				if (!_v1.$) {
					var apercu = _v1.a;
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu-de-regle'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-live', 'polite')
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$perimetresRegleApercu(i18n))
									])),
							A2(
								$elm$core$List$cons,
								A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									$author$project$Components$Produits$Perimetres$View$phraseEnSegments(apercu.Fp)),
								function () {
									var _v2 = apercu.Hz;
									if (!_v2.$) {
										var ancienne = _v2.a;
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('remplace')
													]),
												A2(
													$elm$core$List$cons,
													A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$perimetresRegleRemplace(i18n))
															])),
													A2(
														$elm$core$List$cons,
														$rtfeldman$elm_css$Html$Styled$text(' '),
														$author$project$Components$Produits$Perimetres$View$phraseEnSegments(ancienne))))
											]);
									} else {
										return _List_Nil;
									}
								}())));
				} else {
					return $rtfeldman$elm_css$Html$Styled$text('');
				}
			}()
			]);
	});
var $author$project$I18n$Cles$perimetresRegleAucunType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.regle.aucun.type', _List_Nil, 'Aucun type de règle de quantité n\'est paramétré.');
};
var $author$project$I18n$Cles$perimetresRegleAucunTypeTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.regle.aucun.type.texte', _List_Nil, 'Créez d\'abord un type (MOQ, colisage, maximum…) dans le paramétrage, puis revenez ajouter la règle.');
};
var $author$project$I18n$Cles$perimetresRegleParametrerLesTypes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.regle.parametrer.les.types', _List_Nil, 'Paramétrer les types de règles de quantité');
};
var $author$project$Components$Produits$Perimetres$View$drawerRegle = F3(
	function (i18n, prefixe, model) {
		var _v0 = model.ib;
		if (_v0.$ === 1) {
			return _List_Nil;
		} else {
			return $elm$core$List$isEmpty(
				$author$project$Components$Produits$Perimetres$Model$typesProposes(model)) ? _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$perimetresRegleAucunType(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$perimetresRegleAucunTypeTexte(i18n))
								])),
							A3(
							$author$project$Components$Shared$Bouton$View$lien,
							0,
							$author$project$Routes$Route$adresseDesTypesDeQuantite,
							$author$project$I18n$Cles$perimetresRegleParametrerLesTypes(i18n))
						]))
				]) : A3($author$project$Components$Produits$Perimetres$View$formulaireDeRegle, i18n, prefixe, model);
		}
	});
var $author$project$Components$Produits$Perimetres$Update$ClientChoisi = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Produits$Perimetres$Update$RechercheDuClientSaisie = function (a) {
	return {$: 15, a: a};
};
var $author$project$I18n$Cles$perimetresApercuClient = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.apercu.client', _List_Nil, 'Client');
};
var $author$project$I18n$Cles$perimetresApercuClientAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.apercu.client.aucun', _List_Nil, 'Aucun client ne correspond.');
};
var $author$project$I18n$Cles$perimetresApercuClientPlus = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.apercu.client.plus', _List_Nil, 'D\'autres clients correspondent : précisez la recherche.');
};
var $author$project$I18n$Cles$perimetresApercuClientRecherche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.apercu.client.recherche', _List_Nil, 'Chercher un autre client');
};
var $author$project$I18n$Cles$perimetresApercuExempleDecompte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.apercu.exemple.decompte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (p.Dj + (' peut commander ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' référence.'))) : (p.Dj + (' peut commander ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' références.'))));
	});
var $author$project$I18n$Cles$perimetresApercuExempleExclues = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.apercu.exemple.exclues',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'codes',
					$author$project$I18n$Traductions$Chaine(p.vC)),
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (p.vC + ' est exclue.') : (p.vC + ' sont exclues.'));
	});
var $author$project$Components$Produits$Perimetres$View$exempleParClient = F3(
	function (i18n, model, apercu) {
		var proposes = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.vn;
				},
				model.vn));
		var courant = apercu.yY;
		var choisi = function (exemple) {
			return _Utils_eq(
				$elm$core$Maybe$Just(exemple.r8),
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.r8;
					},
					courant));
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('section'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('exemple')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('clients')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$perimetresApercuClient(i18n))
								])),
						A2(
							$elm$core$List$map,
							function (exemple) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('client'),
											$rtfeldman$elm_css$Html$Styled$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'choisi',
													choisi(exemple))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
											'aria-pressed',
											choisi(exemple) ? 'true' : 'false'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Produits$Perimetres$Update$ClientChoisi(exemple.r8))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(exemple.Dj)
										]));
							},
							apercu.y_))),
					A2(
					$author$project$Components$Shared$Champ$View$texte,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: 'perimetres-apercu-client',
						Bl: $author$project$I18n$Cles$perimetresApercuClientRecherche(i18n),
						he: false
					},
					{hg: $author$project$Components$Produits$Perimetres$Update$RechercheDuClientSaisie, fm: model.pS}),
					((!_Utils_eq(model.vn, $elm$core$Maybe$Nothing)) && $elm$core$List$isEmpty(proposes)) ? A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$perimetresApercuClientAucun(i18n))
						])) : A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('clients-proposes')
						]),
					A2(
						$elm$core$List$map,
						function (_v0) {
							var uid = _v0.a;
							var nom = _v0.b;
							return A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('client'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Produits$Perimetres$Update$ClientChoisi(uid))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(nom)
									]));
						},
						proposes)),
					A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.pp;
						},
						model.vn)) ? A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$perimetresApercuClientPlus(i18n))
						])) : $rtfeldman$elm_css$Html$Styled$text(''),
					function () {
					if (courant.$ === 1) {
						return $rtfeldman$elm_css$Html$Styled$text('');
					} else {
						var exemple = courant.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('exemple')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('decompte')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$perimetresApercuExempleDecompte,
												i18n,
												{Dj: exemple.Dj, w: exemple.hD}))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$ul,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('references')
										]),
									A2(
										$elm$core$List$map,
										function (_v2) {
											var code = _v2.a;
											var designation = _v2.b;
											return A2(
												$rtfeldman$elm_css$Html$Styled$li,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('code')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(code + (' · ' + designation))
															]))
													]));
										},
										exemple.lJ)),
									$elm$core$List$isEmpty(exemple.mn) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('exclues')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$perimetresApercuExempleExclues,
												i18n,
												{
													vC: A2($elm$core$String$join, ', ', exemple.mn),
													w: $elm$core$List$length(exemple.mn)
												}))
										]))
								]));
					}
				}()
				]));
	});
var $author$project$I18n$Cles$perimetresApercuExempleSansClient = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.apercu.exemple.sans.client', _List_Nil, 'Un exemple');
};
var $author$project$I18n$Cles$perimetresApercuExempleTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.apercu.exemple.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Un exemple · ' + p.Dj);
	});
var $author$project$I18n$Cles$perimetresCreationAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.creation.action', _List_Nil, 'Créer le périmètre');
};
var $author$project$I18n$Cles$perimetresCreationTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.creation.titre', _List_Nil, 'Nouveau périmètre');
};
var $author$project$I18n$Cles$perimetresCriteresEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.criteres.enregistrer', _List_Nil, 'Enregistrer les critères');
};
var $author$project$I18n$Cles$perimetresCriteresModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.criteres.modifier', _List_Nil, 'Modifier les critères');
};
var $author$project$I18n$Cles$perimetresEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$perimetresExclusionAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.exclusion.action', _List_Nil, 'Ajouter l\'exclusion');
};
var $author$project$I18n$Cles$perimetresExclusionTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.exclusion.titre', _List_Nil, 'Ajouter une exclusion');
};
var $author$project$I18n$Cles$perimetresFicheAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.fiche.ajouter', _List_Nil, 'Ajouter un critère lié à la fiche');
};
var $author$project$I18n$Cles$perimetresFicheAjouterAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.fiche.ajouter.action', _List_Nil, 'Ajouter le critère');
};
var $author$project$I18n$Cles$perimetresFicheRetirerAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.fiche.retirer.action', _List_Nil, 'Retirer le critère');
};
var $author$project$I18n$Cles$perimetresFicheRetraitTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.fiche.retrait.texte', _List_Nil, 'Ce critère ne filtrera plus les références selon la fiche de celui qui commande.');
};
var $author$project$I18n$Cles$perimetresFicheRetraitTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.fiche.retrait.titre', _List_Nil, 'Retirer le critère lié ?');
};
var $author$project$I18n$Cles$perimetresInclusionAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.inclusion.action', _List_Nil, 'Ajouter l\'inclusion');
};
var $author$project$I18n$Cles$perimetresInclusionTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.inclusion.titre', _List_Nil, 'Ajouter une inclusion');
};
var $author$project$I18n$Cles$perimetresRegleAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.regle.action', _List_Nil, 'Ajouter la règle');
};
var $author$project$I18n$Cles$perimetresRegleTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.regle.titre', _List_Nil, 'Ajouter une règle de quantité');
};
var $author$project$I18n$Cles$perimetresRenommerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.renommer.titre', _List_Nil, 'Renommer et traduire');
};
var $author$project$I18n$Cles$perimetresRestaurer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.restaurer', _List_Nil, 'Restaurer le périmètre');
};
var $author$project$I18n$Cles$perimetresRetraitExclusionAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.retrait.exclusion.action', _List_Nil, 'Retirer l\'exclusion');
};
var $author$project$I18n$Cles$perimetresRetraitExclusionTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.retrait.exclusion.titre', _List_Nil, 'Retirer l\'exclusion ?');
};
var $author$project$I18n$Cles$perimetresRetraitInclusionAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.retrait.inclusion.action', _List_Nil, 'Retirer l\'inclusion');
};
var $author$project$I18n$Cles$perimetresRetraitInclusionTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.retrait.inclusion.titre', _List_Nil, 'Retirer l\'inclusion ?');
};
var $author$project$I18n$Cles$perimetresRetraitRegleAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.retrait.regle.action', _List_Nil, 'Retirer la règle');
};
var $author$project$I18n$Cles$perimetresRetraitRegleTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.retrait.regle.titre', _List_Nil, 'Retirer la règle de quantité ?');
};
var $author$project$I18n$Cles$perimetresRefusSaisieVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.refus.saisie.vide', _List_Nil, 'Complétez la saisie avant d\'enregistrer.');
};
var $author$project$Components$Produits$Perimetres$View$refusDException = function (texte) {
	return A2(
		$author$project$Components$Shared$Note$View$view,
		1,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('titre'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(texte)
					]))
			]));
};
var $author$project$Components$Produits$Perimetres$View$refusDansLeCorps = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(
			model.mW,
			A2(
				$elm$core$Maybe$map,
				$author$project$I18n$Cles$texte(i18n),
				model.pZ));
		_v0$3:
		while (true) {
			if (!_v0.b.$) {
				if (!_v0.a.$) {
					switch (_v0.a.a.$) {
						case 7:
							var _v1 = _v0.a.a;
							return _List_Nil;
						case 5:
							var _v2 = _v0.a.a;
							var texte = _v0.b.a;
							return _List_fromArray(
								[
									$author$project$Components$Produits$Perimetres$View$refusDException(texte)
								]);
						case 6:
							var _v3 = _v0.a.a;
							var texte = _v0.b.a;
							return _List_fromArray(
								[
									$author$project$Components$Produits$Perimetres$View$refusDException(texte)
								]);
						default:
							break _v0$3;
					}
				} else {
					break _v0$3;
				}
			} else {
				var _v4 = _v0.b;
				return model.b5 ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('refus'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$perimetresRefusSaisieVide(i18n))
							]))
					]) : _List_Nil;
			}
		}
		var texte = _v0.b.a;
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('refus'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(texte)
					]))
			]);
	});
var $author$project$I18n$Cles$perimetresRefusPeriodeManquanteCode = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.refus.periode.manquante.code', _List_Nil, '422 PeriodeManquante');
};
var $author$project$I18n$Cles$perimetresRefusPeriodeManquanteDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.refus.periode.manquante.detail', _List_Nil, 'Une base « Par période » demande le mois, le trimestre ou l\'année.');
};
var $author$project$Components$Produits$Perimetres$View$refusEnTete = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(
			model.mW,
			A2(
				$elm$core$Maybe$map,
				$author$project$I18n$Cles$texte(i18n),
				model.pZ));
		if (((!_v0.a.$) && (_v0.a.a.$ === 7)) && (!_v0.b.$)) {
			var _v1 = _v0.a.a;
			var texte = _v0.b.a;
			return _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Note$View$view,
					2,
					_Utils_ap(
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_fromArray(
									[
										A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(texte)
									]))
							]),
						model.hq ? _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$perimetresRefusPeriodeManquanteDetail(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$code,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$perimetresRefusPeriodeManquanteCode(i18n))
									]))
							]) : _List_Nil))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Produits$Perimetres$Update$LibelleSaisi = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$I18n$Cles$perimetresRenommerLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.renommer.libelle', _List_Nil, 'Nom du périmètre, par langue');
};
var $author$project$I18n$Cles$perimetresRenommerNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.renommer.note', _List_Nil, 'Une langue laissée vide est retirée.');
};
var $author$project$Components$Produits$Perimetres$View$renommage = F3(
	function (i18n, prefixe, model) {
		return _List_fromArray(
			[
				A3(
				$author$project$Components$Shared$LibellesParLangue$View$nomsDeLangueSeuls,
				i18n,
				_List_Nil,
				{
					go: function (_v0) {
						return $elm$core$Maybe$Nothing;
					},
					Ba: $author$project$Referentiel$Langues$desLibelles,
					Bl: $author$project$I18n$Cles$perimetresRenommerLibelle(i18n),
					hg: $author$project$Components$Produits$Perimetres$Update$LibelleSaisi,
					pv: prefixe,
					fm: function (code) {
						return A2($author$project$Components$Shared$LibellesParLangue$Model$lire, code, model.R);
					}
				}),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$perimetresRenommerNote(i18n))
					]))
			]);
	});
var $author$project$I18n$Cles$perimetresRetraitExclusionAlerteDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.retrait.exclusion.alerte.detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'avant',
					$author$project$I18n$Traductions$Chaine(p.je)),
					_Utils_Tuple2(
					'apres',
					$author$project$I18n$Traductions$Entier(p.iY)),
					_Utils_Tuple2(
					'motif',
					$author$project$I18n$Traductions$Chaine(p.cX))
				]),
			((!p.iY) || (p.iY === 1)) ? ('si elle répond toujours aux critères : ' + (p.je + (' → ' + (A2($author$project$I18n$Nombre$formater, 0, p.iY) + (' référence. Le motif « ' + (p.cX + ' » est effacé avec l\'exclusion.')))))) : ('si elle répond toujours aux critères : ' + (p.je + (' → ' + (A2($author$project$I18n$Nombre$formater, 0, p.iY) + (' références. Le motif « ' + (p.cX + ' » est effacé avec l\'exclusion.')))))));
	});
var $author$project$I18n$Cles$perimetresRetraitExclusionAlerteTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.retrait.exclusion.alerte.titre', _List_Nil, 'La référence réintègre le périmètre');
};
var $author$project$I18n$Cles$perimetresRetraitExclusionRetiree = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.retrait.exclusion.retiree',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'motif',
					$author$project$I18n$Traductions$Chaine(p.cX))
				]),
			'Exclusion retirée · ' + p.cX);
	});
var $author$project$I18n$Cles$perimetresRetraitExclusionTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.retrait.exclusion.texte', _List_Nil, 'La référence réintègre le périmètre si elle répond toujours aux critères. Le motif est effacé avec l\'exclusion.');
};
var $author$project$I18n$Cles$perimetresRetraitInclusionNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.retrait.inclusion.note', _List_Nil, 'Retirer une inclusion se fait de la même façon, par « Retirer » en bout de ligne : la référence quitte le périmètre si elle ne répond pas aux critères.');
};
var $author$project$Components$Produits$Perimetres$View$retraitDExclusion = F3(
	function (i18n, uid, model) {
		var motif = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bp;
				},
				A2(
					$elm$core$Maybe$andThen,
					function (fiche) {
						return $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (e) {
									return _Utils_eq(e.pX, uid);
								},
								fiche.yX));
					},
					model.zo)));
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Note$View$view,
				0,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$perimetresRetraitExclusionAlerteTitre(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								function () {
									var _v0 = model.iT;
									if (!_v0.$) {
										var apercu = _v0.a;
										return A2(
											$author$project$I18n$Cles$perimetresRetraitExclusionAlerteDetail,
											i18n,
											{
												iY: apercu.iY,
												je: $elm$core$String$fromInt(apercu.je),
												cX: motif
											});
									} else {
										return $author$project$I18n$Cles$perimetresRetraitExclusionTexte(i18n);
									}
								}())
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('chips')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('retiree')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$perimetresRetraitExclusionRetiree,
									i18n,
									{cX: motif}))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$perimetresRetraitInclusionNote(i18n))
					]))
			]);
	});
var $author$project$I18n$Cles$perimetresRetraitInclusionAlerteDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.retrait.inclusion.alerte.detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'avant',
					$author$project$I18n$Traductions$Chaine(p.je)),
					_Utils_Tuple2(
					'apres',
					$author$project$I18n$Traductions$Entier(p.iY))
				]),
			((!p.iY) || (p.iY === 1)) ? ('si elle ne répond pas aux critères : ' + (p.je + (' → ' + (A2($author$project$I18n$Nombre$formater, 0, p.iY) + ' référence.')))) : ('si elle ne répond pas aux critères : ' + (p.je + (' → ' + (A2($author$project$I18n$Nombre$formater, 0, p.iY) + ' références.')))));
	});
var $author$project$I18n$Cles$perimetresRetraitInclusionAlerteTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.retrait.inclusion.alerte.titre', _List_Nil, 'La référence quitte le périmètre');
};
var $author$project$I18n$Cles$perimetresRetraitInclusionRetiree = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.retrait.inclusion.retiree',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'motif',
					$author$project$I18n$Traductions$Chaine(p.cX))
				]),
			'Inclusion retirée · ' + p.cX);
	});
var $author$project$I18n$Cles$perimetresRetraitInclusionTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.retrait.inclusion.texte', _List_Nil, 'La référence quitte le périmètre si elle ne répond pas aux critères.');
};
var $author$project$Components$Produits$Perimetres$View$retraitDInclusion = F3(
	function (i18n, uid, model) {
		var motif = A2(
			$elm$core$Maybe$withDefault,
			'—',
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.cX;
				},
				A2(
					$elm$core$Maybe$andThen,
					function (fiche) {
						return $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (i) {
									return _Utils_eq(i.pX, uid);
								},
								fiche.m8));
					},
					model.zo)));
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Note$View$view,
				0,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$perimetresRetraitInclusionAlerteTitre(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								function () {
									var _v0 = model.iT;
									if (!_v0.$) {
										var apercu = _v0.a;
										return A2(
											$author$project$I18n$Cles$perimetresRetraitInclusionAlerteDetail,
											i18n,
											{
												iY: apercu.iY,
												je: $elm$core$String$fromInt(apercu.je)
											});
									} else {
										return $author$project$I18n$Cles$perimetresRetraitInclusionTexte(i18n);
									}
								}())
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('chips')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('retiree')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$perimetresRetraitInclusionRetiree,
									i18n,
									{cX: motif}))
							]))
					]))
			]);
	});
var $author$project$I18n$Cles$perimetresRetraitRegleAlerteDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.retrait.regle.alerte.detail', _List_Nil, 'Les autres règles du périmètre restent.');
};
var $author$project$I18n$Cles$perimetresRetraitRegleRetiree = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.retrait.regle.retiree',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Règle retirée · ' + p.Dj);
	});
var $author$project$I18n$Cles$perimetresRetraitRegleTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.retrait.regle.texte', _List_Nil, 'La règle de quantité ne s\'applique plus.');
};
var $author$project$Components$Produits$Perimetres$View$regleDeLaFiche = F2(
	function (uid, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (fiche) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (r) {
							return _Utils_eq(r.r8, uid);
						},
						fiche.hJ));
			},
			model.zo);
	});
var $author$project$Components$Produits$Perimetres$View$retraitDeRegle = F3(
	function (i18n, uid, model) {
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Note$View$view,
				0,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$perimetresRetraitRegleTexte(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$perimetresRetraitRegleAlerteDetail(i18n))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('chips')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('retiree')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$perimetresRetraitRegleRetiree,
									i18n,
									{
										Dj: A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.Bl;
												},
												A2($author$project$Components$Produits$Perimetres$View$regleDeLaFiche, uid, model)))
									}))
							]))
					]))
			]);
	});
var $author$project$Components$Produits$Perimetres$View$sansTypeAChoisir = function (model) {
	return _Utils_eq(
		model.mW,
		$elm$core$Maybe$Just($author$project$Components$Produits$Perimetres$Model$AjoutDeRegle)) && ((!_Utils_eq(model.ib, $elm$core$Maybe$Nothing)) && $elm$core$List$isEmpty(
		$author$project$Components$Produits$Perimetres$Model$typesProposes(model)));
};
var $author$project$I18n$Cles$perimetresRetraitReference = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.retrait.reference',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'designation',
					$author$project$I18n$Traductions$Chaine(p.xt)),
					_Utils_Tuple2(
					'code',
					$author$project$I18n$Traductions$Chaine(p.vx))
				]),
			p.xt + (' · ' + p.vx));
	});
var $author$project$Components$Produits$Perimetres$View$designationEtCode = F3(
	function (i18n, designation, code) {
		return A2(
			$author$project$I18n$Cles$perimetresRetraitReference,
			i18n,
			{vx: code, xt: designation});
	});
var $author$project$I18n$Cles$perimetresCreationSousTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.creation.sous-titre', _List_Nil, 'Vous le définirez ensuite, étape par étape.');
};
var $author$project$I18n$Cles$perimetresReglePieces = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.regle.pieces',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' pièce') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' pièces'));
	});
var $author$project$Components$Produits$Perimetres$View$resumeDeRegle = F2(
	function (i18n, regle) {
		return A2(
			$elm$core$String$join,
			' · ',
			_List_fromArray(
				[
					regle.Bl,
					A2(
					$author$project$I18n$Cles$perimetresReglePieces,
					i18n,
					{w: regle.fm}),
					$elm$core$String$toLower(
					A2($author$project$Components$Produits$Vocabulaire$libelleDeLaPortee, i18n, regle.F$)),
					$elm$core$String$toLower(regle.Bm)
				]));
	});
var $author$project$Components$Produits$Perimetres$View$sousTitreDuGeste = F2(
	function (i18n, model) {
		var _v0 = model.mW;
		_v0$8:
		while (true) {
			if (!_v0.$) {
				switch (_v0.a.$) {
					case 0:
						var _v1 = _v0.a;
						return $elm$core$Maybe$Just(
							$author$project$I18n$Cles$perimetresCreationSousTitre(i18n));
					case 7:
						var _v2 = _v0.a;
						return A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.Dj;
							},
							model.zo);
					case 3:
						var _v3 = _v0.a;
						return A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.Dj;
							},
							model.zo);
					case 2:
						var _v4 = _v0.a;
						return A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.Dj;
							},
							model.zo);
					case 13:
						var _v5 = _v0.a;
						return A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.Dj;
							},
							model.zo);
					case 9:
						var uid = _v0.a.a;
						return A2(
							$elm$core$Maybe$map,
							function (e) {
								return A3($author$project$Components$Produits$Perimetres$View$designationEtCode, i18n, e.xt, e.vx);
							},
							A2(
								$elm$core$Maybe$andThen,
								function (fiche) {
									return $elm$core$List$head(
										A2(
											$elm$core$List$filter,
											function (e) {
												return _Utils_eq(e.pX, uid);
											},
											fiche.yX));
								},
								model.zo));
					case 10:
						var uid = _v0.a.a;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Components$Produits$Perimetres$View$resumeDeRegle(i18n),
							A2($author$project$Components$Produits$Perimetres$View$regleDeLaFiche, uid, model));
					case 8:
						var uid = _v0.a.a;
						return A2(
							$elm$core$Maybe$map,
							function (i) {
								return A3($author$project$Components$Produits$Perimetres$View$designationEtCode, i18n, i.xt, i.vx);
							},
							A2(
								$elm$core$Maybe$andThen,
								function (fiche) {
									return $elm$core$List$head(
										A2(
											$elm$core$List$filter,
											function (i) {
												return _Utils_eq(i.pX, uid);
											},
											fiche.m8));
								},
								model.zo));
					default:
						break _v0$8;
				}
			} else {
				break _v0$8;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Components$Produits$Perimetres$View$drawerDuGeste = F2(
	function (i18n, model) {
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.kX);
		var geste = function () {
			var _v0 = model.mW;
			_v0$12:
			while (true) {
				if (!_v0.$) {
					switch (_v0.a.$) {
						case 0:
							var _v1 = _v0.a;
							return {
								fs: $author$project$I18n$Cles$perimetresCreationAction(i18n),
								f$: A3($author$project$Components$Produits$Perimetres$View$creation, i18n, prefixe, model),
								au: false,
								h6: $author$project$I18n$Cles$perimetresCreationTitre(i18n)
							};
						case 1:
							var _v2 = _v0.a;
							return {
								fs: $author$project$I18n$Cles$perimetresEnregistrer(i18n),
								f$: A3($author$project$Components$Produits$Perimetres$View$renommage, i18n, prefixe, model),
								au: false,
								h6: $author$project$I18n$Cles$perimetresRenommerTitre(i18n)
							};
						case 2:
							var _v3 = _v0.a;
							return {
								fs: $author$project$I18n$Cles$perimetresCriteresEnregistrer(i18n),
								f$: A2($author$project$Components$Produits$Perimetres$View$criteres, i18n, model),
								au: false,
								h6: $author$project$I18n$Cles$perimetresCriteresModifier(i18n)
							};
						case 3:
							var _v4 = _v0.a;
							return {
								fs: $author$project$I18n$Cles$perimetresFicheAjouterAction(i18n),
								f$: A2($author$project$Components$Produits$Perimetres$View$critereLie, i18n, model),
								au: false,
								h6: $author$project$I18n$Cles$perimetresFicheAjouter(i18n)
							};
						case 4:
							return {
								fs: $author$project$I18n$Cles$perimetresFicheRetirerAction(i18n),
								f$: _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$perimetresFicheRetraitTexte(i18n))
											]))
									]),
								au: true,
								h6: $author$project$I18n$Cles$perimetresFicheRetraitTitre(i18n)
							};
						case 5:
							var _v5 = _v0.a;
							return {
								fs: $author$project$I18n$Cles$perimetresInclusionAction(i18n),
								f$: A3($author$project$Components$Produits$Perimetres$View$drawerInclusion, i18n, prefixe, model),
								au: false,
								h6: $author$project$I18n$Cles$perimetresInclusionTitre(i18n)
							};
						case 6:
							var _v6 = _v0.a;
							return {
								fs: $author$project$I18n$Cles$perimetresExclusionAction(i18n),
								f$: A3($author$project$Components$Produits$Perimetres$View$drawerExclusion, i18n, prefixe, model),
								au: false,
								h6: $author$project$I18n$Cles$perimetresExclusionTitre(i18n)
							};
						case 8:
							var uid = _v0.a.a;
							return {
								fs: $author$project$I18n$Cles$perimetresRetraitInclusionAction(i18n),
								f$: A3($author$project$Components$Produits$Perimetres$View$retraitDInclusion, i18n, uid, model),
								au: true,
								h6: $author$project$I18n$Cles$perimetresRetraitInclusionTitre(i18n)
							};
						case 9:
							var uid = _v0.a.a;
							return {
								fs: $author$project$I18n$Cles$perimetresRetraitExclusionAction(i18n),
								f$: A3($author$project$Components$Produits$Perimetres$View$retraitDExclusion, i18n, uid, model),
								au: true,
								h6: $author$project$I18n$Cles$perimetresRetraitExclusionTitre(i18n)
							};
						case 13:
							var _v7 = _v0.a;
							return {
								fs: '',
								f$: A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										A2(
											$elm$core$Basics$composeR,
											A2($author$project$Components$Produits$Perimetres$View$exempleParClient, i18n, model),
											$elm$core$List$singleton),
										model.tq)),
								au: false,
								h6: A2(
									$elm$core$Maybe$withDefault,
									$author$project$I18n$Cles$perimetresApercuExempleSansClient(i18n),
									A2(
										$elm$core$Maybe$map,
										function (exemple) {
											return A2(
												$author$project$I18n$Cles$perimetresApercuExempleTitre,
												i18n,
												{Dj: exemple.Dj});
										},
										A2(
											$elm$core$Maybe$andThen,
											function ($) {
												return $.yY;
											},
											model.tq)))
							};
						case 7:
							var _v8 = _v0.a;
							return {
								fs: $author$project$I18n$Cles$perimetresRegleAction(i18n),
								f$: A3($author$project$Components$Produits$Perimetres$View$drawerRegle, i18n, prefixe, model),
								au: false,
								h6: $author$project$I18n$Cles$perimetresRegleTitre(i18n)
							};
						case 10:
							var uid = _v0.a.a;
							return {
								fs: $author$project$I18n$Cles$perimetresRetraitRegleAction(i18n),
								f$: A3($author$project$Components$Produits$Perimetres$View$retraitDeRegle, i18n, uid, model),
								au: true,
								h6: $author$project$I18n$Cles$perimetresRetraitRegleTitre(i18n)
							};
						default:
							break _v0$12;
					}
				} else {
					break _v0$12;
				}
			}
			return {
				fs: $author$project$I18n$Cles$perimetresRestaurer(i18n),
				f$: _List_Nil,
				au: false,
				h6: $author$project$I18n$Cles$perimetresRestaurer(i18n)
			};
		}();
		var contenu = {
			fs: {
				sR: (!$author$project$API$Envoi$enCours(model.l2)) && ((!_Utils_eq(model.mW, $elm$core$Maybe$Nothing)) && (!$author$project$Components$Produits$Perimetres$View$sansTypeAChoisir(model))),
				Bl: geste.fs,
				C$: $author$project$Components$Produits$Perimetres$Update$GesteDemande
			},
			fZ: _Utils_ap(
				A2($author$project$Components$Produits$Perimetres$View$refusEnTete, i18n, model),
				_Utils_ap(
					geste.f$,
					A2($author$project$Components$Produits$Perimetres$View$refusDansLeCorps, i18n, model))),
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: geste.h6
		};
		return _Utils_eq(
			model.mW,
			$elm$core$Maybe$Just($author$project$Components$Produits$Perimetres$Model$Archivage)) ? $rtfeldman$elm_css$Html$Styled$text('') : (_Utils_eq(
			model.mW,
			$elm$core$Maybe$Just($author$project$Components$Produits$Perimetres$Model$ApercuDUnClient)) ? A4(
			$author$project$Components$Shared$Drawer$View$consultationAvecSousTitre,
			i18n,
			$author$project$Components$Produits$Perimetres$Update$DuDrawer,
			{
				fZ: contenu.fZ,
				G8: false,
				aO: A2($author$project$Components$Produits$Perimetres$View$sousTitreDuGeste, i18n, model),
				h6: geste.h6
			},
			model.kX) : ($author$project$Components$Produits$Perimetres$View$sansTypeAChoisir(model) ? A4(
			$author$project$Components$Shared$Drawer$View$consultationAnnulable,
			i18n,
			$author$project$Components$Produits$Perimetres$Update$DuDrawer,
			{
				fZ: contenu.fZ,
				G8: false,
				aO: A2($author$project$Components$Produits$Perimetres$View$sousTitreDuGeste, i18n, model),
				h6: geste.h6
			},
			model.kX) : (geste.au ? A6(
			$author$project$Components$Shared$Drawer$View$viewDestructifAvecSousTitreEtNote,
			i18n,
			A2($author$project$Components$Produits$Perimetres$View$sousTitreDuGeste, i18n, model),
			$elm$core$Maybe$Nothing,
			$author$project$Components$Produits$Perimetres$Update$DuDrawer,
			contenu,
			model.kX) : A6(
			$author$project$Components$Shared$Drawer$View$viewAvecSousTitreEtNote,
			i18n,
			A2($author$project$Components$Produits$Perimetres$View$sousTitreDuGeste, i18n, model),
			A2($author$project$Components$Produits$Perimetres$View$apercuChiffre, i18n, model),
			$author$project$Components$Produits$Perimetres$Update$DuDrawer,
			contenu,
			model.kX))));
	});
var $author$project$Components$Produits$Perimetres$View$cadre = F8(
	function (i18n, page, fil, titre, complements, bottom, fixed, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			page,
			{
				ut: bottom,
				xy: _List_fromArray(
					[
						A2($author$project$Components$Produits$Perimetres$View$drawerDuGeste, i18n, model),
						A2($author$project$Components$Produits$Perimetres$View$confirmationDArchivage, i18n, model)
					]),
				zM: fixed,
				AK: $author$project$Components$Produits$Perimetres$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: complements,
						zE: _Utils_ap(
							_List_fromArray(
								[
									{
									aa: $author$project$Routes$Route$adresseTypesDePartiesPrenantes,
									Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
								}
								]),
							fil),
						Ef: _List_Nil,
						h6: titre
					})
			});
	});
var $author$project$Components$Produits$Perimetres$View$offert = F2(
	function (rel, model) {
		return !_Utils_eq(
			A2($author$project$Components$Produits$Perimetres$Model$lienDe, rel, model),
			$elm$core$Maybe$Nothing);
	});
var $author$project$I18n$Cles$perimetresNombre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.nombre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' périmètre') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' périmètres'));
	});
var $author$project$I18n$Cles$perimetresNouveau = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.nouveau', _List_Nil, 'Nouveau périmètre');
};
var $author$project$I18n$Cles$perimetresPageDescription = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.page.description', _List_Nil, 'Un périmètre dit quelles références peuvent être proposées à celui qui commande.');
};
var $author$project$I18n$Cles$perimetresPageTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.page.titre', _List_Nil, 'Périmètres d\'offre');
};
var $author$project$I18n$Cles$perimetresVideTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.vide.texte', _List_Nil, 'Un périmètre regroupe des références du catalogue par critères, pour les proposer à ceux qui commandent.');
};
var $author$project$I18n$Cles$perimetresVideTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.vide.titre', _List_Nil, 'Aucun périmètre');
};
var $author$project$I18n$Cles$perimetresStatutComplet = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.statut.complet', _List_Nil, 'Complet');
};
var $author$project$I18n$Cles$perimetresStatutEnCours = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.statut.en.cours', _List_Nil, 'En cours');
};
var $author$project$Components$Produits$Vocabulaire$libelleDuStatutDePerimetre = F2(
	function (i18n, statut) {
		if (statut === 'complet') {
			return $author$project$I18n$Cles$perimetresStatutComplet(i18n);
		} else {
			return $author$project$I18n$Cles$perimetresStatutEnCours(i18n);
		}
	});
var $author$project$Components$Produits$Perimetres$View$statut = F2(
	function (i18n, code) {
		return A2(
			$author$project$Components$Shared$Tag$View$view,
			(code === 'complet') ? 0 : 1,
			A2($author$project$Components$Produits$Vocabulaire$libelleDuStatutDePerimetre, i18n, code));
	});
var $author$project$Components$Produits$Perimetres$View$ligneDePerimetre = F2(
	function (i18n, resume) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							_Utils_eq(
							A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$perimetre, resume.nQ.h0),
							$elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text(resume.Dj) : A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href(
									$author$project$Routes$Route$adresseDuPerimetre(resume.r8))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(resume.Dj)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Components$Produits$Perimetres$View$statut, i18n, resume.ri)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nombre')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(resume.wp + resume.ko))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nombre')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(resume.m8))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nombre')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(resume.yX))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nombre')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(resume.hJ))
						]))
				]));
	});
var $author$project$I18n$Cles$perimetresColonneCriteres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.colonne.criteres', _List_Nil, 'Critères');
};
var $author$project$I18n$Cles$perimetresColonneExclusions = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.colonne.exclusions', _List_Nil, 'Exclusions');
};
var $author$project$I18n$Cles$perimetresColonneInclusions = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.colonne.inclusions', _List_Nil, 'Inclusions');
};
var $author$project$I18n$Cles$perimetresColonneNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.colonne.nom', _List_Nil, 'Nom');
};
var $author$project$I18n$Cles$perimetresColonneRegles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.colonne.regles', _List_Nil, 'Règles de quantité');
};
var $author$project$I18n$Cles$perimetresColonneStatut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.colonne.statut', _List_Nil, 'Statut');
};
var $author$project$Components$Produits$Perimetres$View$tableDesPerimetres = F2(
	function (i18n, perimetres) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$table,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('perimetres')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$tr,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (cle) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(cle)
											]));
								},
								_List_fromArray(
									[
										$author$project$I18n$Cles$perimetresColonneNom(i18n),
										$author$project$I18n$Cles$perimetresColonneStatut(i18n),
										$author$project$I18n$Cles$perimetresColonneCriteres(i18n),
										$author$project$I18n$Cles$perimetresColonneInclusions(i18n),
										$author$project$I18n$Cles$perimetresColonneExclusions(i18n),
										$author$project$I18n$Cles$perimetresColonneRegles(i18n)
									])))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Components$Produits$Perimetres$View$ligneDePerimetre(i18n),
						perimetres))
				]));
	});
var $author$project$Components$Produits$Perimetres$View$annuaire = F3(
	function (i18n, messages, model) {
		var perimetres = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.pg;
				},
				model.aS));
		var creer = A2($author$project$Components$Produits$Perimetres$View$offert, $author$project$API$NavLinksDictionary$creerUnPerimetre, model) ? _List_fromArray(
			[
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				0,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						$author$project$Components$Produits$Perimetres$Model$idDuDeclencheur($author$project$Components$Produits$Perimetres$Model$Creation)),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$Perimetres$Update$GesteOuvert($author$project$Components$Produits$Perimetres$Model$Creation))
					]),
				$author$project$I18n$Cles$perimetresNouveau(i18n))
			]) : _List_Nil;
		return A8(
			$author$project$Components$Produits$Perimetres$View$cadre,
			i18n,
			'parametrage-perimetres-list',
			_List_fromArray(
				[
					{
					aa: '',
					Dj: $author$project$I18n$Cles$perimetresPageTitre(i18n)
				}
				]),
			$author$project$I18n$Cles$perimetresPageTitre(i18n),
			_Utils_ap(
				_Utils_eq(model.aS, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Tag$View$view,
						5,
						A2(
							$author$project$I18n$Cles$perimetresNombre,
							i18n,
							{
								w: $elm$core$List$length(perimetres)
							}))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('actions-page')
							]),
						creer),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$perimetresPageDescription(i18n))
							]))
					])),
			_Utils_eq(model.np, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
						]),
					A2(
						$elm$core$List$cons,
						A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
						((!_Utils_eq(model.aS, $elm$core$Maybe$Nothing)) && _Utils_eq(perimetres, _List_Nil)) ? _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$h3,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$perimetresVideTitre(i18n))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$perimetresVideTexte(i18n))
											]))
									]))
							]) : _List_fromArray(
							[
								A2($author$project$Components$Produits$Perimetres$View$tableDesPerimetres, i18n, perimetres)
							])))
				]),
			_List_Nil,
			model);
	});
var $author$project$I18n$Cles$perimetresArchiveUsagesGardes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.archive.usages-gardes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? 'L\'usage le garde.' : ('Les ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' usages le gardent.')));
	});
var $author$project$I18n$Cles$perimetresArchiveLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.archive.le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv)),
					_Utils_Tuple2(
					'heure',
					$author$project$I18n$Traductions$Chaine(p.Ah))
				]),
			'Archivé le ' + (p.wv + (' à ' + (p.Ah + '.'))));
	});
var $author$project$I18n$Cles$perimetresArchiveLePar = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.archive.le-par',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv)),
					_Utils_Tuple2(
					'heure',
					$author$project$I18n$Traductions$Chaine(p.Ah)),
					_Utils_Tuple2(
					'par',
					$author$project$I18n$Traductions$Chaine(p.EK))
				]),
			'Archivé le ' + (p.wv + (' à ' + (p.Ah + (' par ' + (p.EK + '.'))))));
	});
var $author$project$Components$Produits$Perimetres$View$quandArchive = F2(
	function (i18n, fiche) {
		var _v0 = _Utils_Tuple2(
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$split('T'),
				fiche.tF),
			fiche.tG);
		if ((((!_v0.a.$) && _v0.a.a.b) && _v0.a.a.b.b) && (!_v0.a.a.b.b.b)) {
			var _v1 = _v0.a.a;
			var jour = _v1.a;
			var _v2 = _v1.b;
			var heure = _v2.a;
			var par = _v0.b;
			var repere = '\u0000';
			var heures = A2($elm$core$String$left, 5, heure);
			var date = A2($author$project$Texte$Jour$enFrancais, i18n, jour);
			if (!par.$) {
				var nom = par.a;
				return A2(
					$elm$core$List$intersperse,
					A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('par'),
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('retire', fiche.tH)
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(nom)
							])),
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$text,
						A2(
							$elm$core$String$split,
							repere,
							A2(
								$author$project$I18n$Cles$perimetresArchiveLePar,
								i18n,
								{wv: date, Ah: heures, EK: repere}))));
			} else {
				return _List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$perimetresArchiveLe,
							i18n,
							{wv: date, Ah: heures}))
					]);
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Produits$Perimetres$View$bandeauDArchivage = F3(
	function (i18n, model, fiche) {
		var usages = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function (a) {
					return a.JG + a.JF;
				},
				model.tq));
		return _Utils_ap(
			A2($author$project$Components$Produits$Perimetres$View$quandArchive, i18n, fiche),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					' ' + A2(
						$author$project$I18n$Cles$perimetresArchiveUsagesGardes,
						i18n,
						{w: usages}))
				]));
	});
var $author$project$Components$Produits$Perimetres$Update$RestaurationDemandee = {$: 6};
var $author$project$I18n$Cles$perimetresArchiveAideRestaurer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.archive.aide-restaurer', _List_Nil, 'Archivé : il n\'est plus proposé pour une nouvelle valeur.');
};
var $author$project$I18n$Cles$perimetresArchiver = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.archiver', _List_Nil, 'Archiver le périmètre…');
};
var $author$project$I18n$Cles$perimetresArchiverAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.archiver.aide', _List_Nil, 'Archivé = plus proposé pour une nouvelle valeur ; les usages existants le gardent.');
};
var $author$project$Components$Produits$Perimetres$View$barreDuBas = F3(
	function (i18n, model, fiche) {
		return fiche.tE ? (A2($author$project$Components$Produits$Perimetres$View$offert, $author$project$API$NavLinksDictionary$restaurerUnPerimetre, model) ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$perimetresArchiveAideRestaurer(i18n))
					])),
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				0,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						$author$project$Components$Produits$Perimetres$Model$idDuDeclencheur($author$project$Components$Produits$Perimetres$Model$Restauration)),
						$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Perimetres$Update$RestaurationDemandee)
					]),
				$author$project$I18n$Cles$perimetresRestaurer(i18n))
			]) : _List_Nil) : (A2($author$project$Components$Produits$Perimetres$View$offert, $author$project$API$NavLinksDictionary$archiverUnPerimetre, model) ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$perimetresArchiverAide(i18n))
					])),
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				3,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						$author$project$Components$Produits$Perimetres$Model$idDuDeclencheur($author$project$Components$Produits$Perimetres$Model$Archivage)),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$Perimetres$Update$GesteOuvert($author$project$Components$Produits$Perimetres$Model$Archivage))
					]),
				$author$project$I18n$Cles$perimetresArchiver(i18n))
			]) : _List_Nil);
	});
var $author$project$I18n$Cles$perimetresArchive = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.archive', _List_Nil, 'Archivé');
};
var $author$project$Components$Produits$Perimetres$View$archive = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.tE;
			},
			model.zo));
};
var $author$project$Components$Produits$Perimetres$View$action = F5(
	function (rel, geste, libelle, variante, model) {
		return (A2($author$project$Components$Produits$Perimetres$View$offert, rel, model) && (!$author$project$Components$Produits$Perimetres$View$archive(model))) ? _List_fromArray(
			[
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				variante,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						$author$project$Components$Produits$Perimetres$Model$idDuDeclencheur(geste)),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$Perimetres$Update$GesteOuvert(geste))
					]),
				libelle)
			]) : _List_Nil;
	});
var $author$project$I18n$Cles$perimetresApercuOuvrir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.apercu.ouvrir', _List_Nil, 'Voir un exemple pour un client');
};
var $author$project$I18n$Cles$perimetresApercuTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.apercu.titre', _List_Nil, 'Aperçu');
};
var $author$project$I18n$Cles$perimetresDecompteTotal = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.decompte.total',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' référence') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' références'));
	});
var $author$project$Components$Produits$Perimetres$View$sectionDeLApercu = F3(
	function (i18n, model, fiche) {
		var _v0 = model.tq;
		if (_v0.$ === 1) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var apercu = _v0.a;
			return A2(
				$author$project$Components$Shared$Page$View$sectionAvecCompte,
				_List_Nil,
				{
					fw: A5(
						$author$project$Components$Produits$Perimetres$View$action,
						$author$project$API$NavLinksDictionary$apercuDuPerimetre,
						$author$project$Components$Produits$Perimetres$Model$ApercuDUnClient,
						$author$project$I18n$Cles$perimetresApercuOuvrir(i18n),
						2,
						model),
					vW: $elm$core$Maybe$Nothing,
					fZ: _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('decompte')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$perimetresDecompteTotal,
										i18n,
										{w: fiche.hD}))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('references')
								]),
							A2(
								$elm$core$List$map,
								function (_v1) {
									var code = _v1.a;
									var designation = _v1.b;
									return A2(
										$rtfeldman$elm_css$Html$Styled$li,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('code')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(code + (' · ' + designation))
													]))
											]));
								},
								apercu.lJ))
						]),
					Ar: $elm$core$Maybe$Nothing,
					Dj: 'apercu',
					h6: $author$project$I18n$Cles$perimetresApercuTitre(i18n)
				});
		}
	});
var $author$project$Components$Produits$Perimetres$Model$Renommage = {$: 1};
var $author$project$Components$Produits$Perimetres$View$langues = function (fiche) {
	var codes = $elm$core$Dict$keys(fiche.DG);
	return _Utils_ap(
		A2(
			$elm$core$List$filter,
			function (code) {
				return code === 'fr';
			},
			codes),
		A2(
			$elm$core$List$filter,
			function (code) {
				return code !== 'fr';
			},
			codes));
};
var $author$project$I18n$Cles$perimetresIdentiteDescription = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.identite.description', _List_Nil, 'Description');
};
var $author$project$I18n$Cles$perimetresIdentiteNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.identite.nom', _List_Nil, 'Nom');
};
var $author$project$I18n$Cles$perimetresIdentiteTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.identite.titre', _List_Nil, 'Identité');
};
var $author$project$I18n$Cles$perimetresRenommer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.renommer', _List_Nil, 'Renommer et traduire');
};
var $author$project$Components$Produits$Perimetres$View$sectionDeLIdentite = F3(
	function (i18n, model, fiche) {
		return A2(
			$author$project$Components$Shared$Page$View$sectionAvecCompte,
			_List_Nil,
			{
				fw: A5(
					$author$project$Components$Produits$Perimetres$View$action,
					$author$project$API$NavLinksDictionary$renommerUnPerimetre,
					$author$project$Components$Produits$Perimetres$Model$Renommage,
					$author$project$I18n$Cles$perimetresRenommer(i18n),
					2,
					model),
				vW: $elm$core$Maybe$Nothing,
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('identite')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$perimetresIdentiteNom(i18n))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(fiche.Dj),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('langues')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2(
															$elm$core$String$join,
															' · ',
															A2(
																$elm$core$List$map,
																$elm$core$String$toUpper,
																$author$project$Components$Produits$Perimetres$View$langues(fiche))))
													]))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$perimetresIdentiteDescription(i18n))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2($elm$core$Maybe$withDefault, '', fiche.dH))
											]))
									]))
							]))
					]),
				Ar: $elm$core$Maybe$Nothing,
				Dj: 'identite',
				h6: $author$project$I18n$Cles$perimetresIdentiteTitre(i18n)
			});
	});
var $author$project$Components$Produits$Perimetres$Model$libelleDeDimension = F2(
	function (model, cle) {
		return A2(
			$elm$core$Maybe$withDefault,
			cle,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (dimension) {
							return _Utils_eq(dimension.dy, cle);
						},
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.xz;
								},
								model.et))))));
	});
var $author$project$Components$Produits$Perimetres$Model$libelleDeValeur = F3(
	function (model, cle, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			code,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var c = _v0.a;
							return _Utils_eq(c, code);
						},
						A2(
							$elm$core$List$concatMap,
							function ($) {
								return $.Ki;
							},
							A2(
								$elm$core$List$filter,
								function (dimension) {
									return _Utils_eq(dimension.dy, cle);
								},
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.xz;
										},
										model.et))))))));
	});
var $author$project$I18n$Cles$perimetresCriteresCatalogue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.criteres.catalogue', _List_Nil, 'Les critères du catalogue');
};
var $author$project$I18n$Cles$perimetresCriteresVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.criteres.vide', _List_Nil, 'Aucun critère : toutes les références du catalogue sont retenues.');
};
var $author$project$I18n$Cles$perimetresDecompteAujourdhui = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.decompte.aujourdhui',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' référence aujourd\'hui.') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' références aujourd\'hui.'));
	});
var $author$project$Components$Produits$Perimetres$View$sectionDesCriteres = F3(
	function (i18n, model, fiche) {
		return A2(
			$author$project$Components$Shared$Page$View$sectionAvecCompte,
			_List_Nil,
			{
				fw: _Utils_eq(model.et, $elm$core$Maybe$Nothing) ? _List_Nil : A5(
					$author$project$Components$Produits$Perimetres$View$action,
					$author$project$API$NavLinksDictionary$definirLesCriteresDuCatalogue,
					$author$project$Components$Produits$Perimetres$Model$Criteres,
					$author$project$I18n$Cles$perimetresCriteresModifier(i18n),
					2,
					model),
				vW: $elm$core$Maybe$Nothing,
				fZ: _List_fromArray(
					[
						$elm$core$List$isEmpty(fiche.wp) ? A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$perimetresCriteresVide(i18n))
							])) : A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('regle')
							]),
						A2(
							$elm$core$List$map,
							function (_v0) {
								var cle = _v0.a;
								var valeurs = _v0.b;
								return A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$Components$Produits$Perimetres$Model$libelleDeDimension, model, cle) + ' = '),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('chips')
												]),
											A2(
												$elm$core$List$map,
												function (code) {
													return A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('jeton')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																A3($author$project$Components$Produits$Perimetres$Model$libelleDeValeur, model, cle, code))
															]));
												},
												valeurs))
										]));
							},
							$author$project$Components$Produits$Perimetres$Model$criteresRegroupes(model))),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$perimetresDecompteAujourdhui,
									i18n,
									{w: fiche.hD}))
							]))
					]),
				Ar: $elm$core$Maybe$Nothing,
				Dj: 'criteres',
				h6: $author$project$I18n$Cles$perimetresCriteresCatalogue(i18n)
			});
	});
var $author$project$Components$Produits$Perimetres$Model$CritereLie = {$: 3};
var $author$project$Components$Produits$Perimetres$Model$RetraitDuCritereLie = function (a) {
	return {$: 4, a: a};
};
var $author$project$I18n$Cles$perimetresFicheNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.fiche.note', _List_Nil, 'Ces critères comparent la référence à la fiche de celui qui commande, par les correspondances de votre bibliothèque.');
};
var $author$project$I18n$Cles$perimetresFicheRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.fiche.retirer', _List_Nil, 'Retirer');
};
var $author$project$I18n$Cles$perimetresFicheTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.fiche.titre', _List_Nil, 'Critères relatifs à la fiche visée');
};
var $author$project$I18n$Cles$perimetresFicheVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.fiche.vide', _List_Nil, 'Aucun critère lié à la fiche visée.');
};
var $author$project$Components$Produits$Perimetres$View$retraitDeLigne = F6(
	function (_v0, model, geste, rel, liens, libelle) {
		return ($author$project$Components$Produits$Perimetres$View$archive(model) || _Utils_eq(
			A2($author$project$API$Liens$trouver, rel, liens.h0),
			$elm$core$Maybe$Nothing)) ? _List_Nil : _List_fromArray(
			[
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				2,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						$author$project$Components$Produits$Perimetres$Model$idDuDeclencheur(geste)),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$Perimetres$Update$GesteOuvert(geste))
					]),
				libelle)
			]);
	});
var $author$project$Components$Produits$Perimetres$View$sectionDesCriteresLies = F3(
	function (i18n, model, fiche) {
		return A2(
			$author$project$Components$Shared$Page$View$sectionAvecCompte,
			_List_Nil,
			{
				fw: _Utils_eq(model.hh, $elm$core$Maybe$Nothing) ? _List_Nil : A5(
					$author$project$Components$Produits$Perimetres$View$action,
					$author$project$API$NavLinksDictionary$ajouterUnCritereLieALaFiche,
					$author$project$Components$Produits$Perimetres$Model$CritereLie,
					$author$project$I18n$Cles$perimetresFicheAjouter(i18n),
					2,
					model),
				vW: $elm$core$Maybe$Just(
					$elm$core$String$fromInt(
						$elm$core$List$length(fiche.ko))),
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$perimetresFicheNote(i18n))
							])),
						$elm$core$List$isEmpty(fiche.ko) ? A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$perimetresFicheVide(i18n))
							])) : A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('criteres-lies')
							]),
						A2(
							$elm$core$List$map,
							function (critere) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_Nil,
									A2(
										$elm$core$List$cons,
										A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											$author$project$Components$Produits$Perimetres$View$phraseEnSegments(critere.Fp)),
										A6(
											$author$project$Components$Produits$Perimetres$View$retraitDeLigne,
											i18n,
											model,
											$author$project$Components$Produits$Perimetres$Model$RetraitDuCritereLie(critere.r8),
											$author$project$API$NavLinksDictionary$retirerUnCritereLieALaFiche,
											critere.nQ,
											$author$project$I18n$Cles$perimetresFicheRetirer(i18n))));
							},
							fiche.ko))
					]),
				Ar: $elm$core$Maybe$Nothing,
				Dj: 'criteres-lies',
				h6: $author$project$I18n$Cles$perimetresFicheTitre(i18n)
			});
	});
var $author$project$Components$Produits$Perimetres$Model$RetraitDExclusion = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Produits$Perimetres$View$celluleDeReference = F2(
	function (code, designation) {
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('code')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$code,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(code)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(designation)
					]))
			]);
	});
var $author$project$Components$Produits$Perimetres$View$enteteDeReferences = function (cles) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$thead,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$tr,
				_List_Nil,
				A2(
					$elm$core$List$map,
					function (cle) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$th,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(cle)
								]));
					},
					_Utils_ap(
						cles,
						_List_fromArray(
							['']))))
			]));
};
var $author$project$I18n$Cles$perimetresColonneDesignation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.colonne.designation', _List_Nil, 'Désignation');
};
var $author$project$I18n$Cles$perimetresColonneMotif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.colonne.motif', _List_Nil, 'Motif');
};
var $author$project$I18n$Cles$perimetresColonneReference = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.colonne.reference', _List_Nil, 'Référence');
};
var $author$project$I18n$Cles$perimetresExclusionsAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.exclusions.ajouter', _List_Nil, 'Ajouter : une exclusion');
};
var $author$project$I18n$Cles$perimetresExclusionsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.exclusions.titre', _List_Nil, 'Exclusions');
};
var $author$project$I18n$Cles$perimetresExclusionsVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.exclusions.vide', _List_Nil, 'Aucune exclusion.');
};
var $author$project$I18n$Cles$perimetresLigneRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.ligne.retirer', _List_Nil, 'Retirer');
};
var $author$project$Components$Produits$Perimetres$View$sectionDesExclusions = F3(
	function (i18n, model, fiche) {
		return A2(
			$author$project$Components$Shared$Page$View$sectionAvecCompte,
			_List_Nil,
			{
				fw: _Utils_eq(model.cI, $elm$core$Maybe$Nothing) ? _List_Nil : A5(
					$author$project$Components$Produits$Perimetres$View$action,
					$author$project$API$NavLinksDictionary$exclureUneReference,
					$author$project$Components$Produits$Perimetres$Model$AjoutDExclusion,
					$author$project$I18n$Cles$perimetresExclusionsAjouter(i18n),
					2,
					model),
				vW: $elm$core$Maybe$Just(
					$elm$core$String$fromInt(
						$elm$core$List$length(fiche.yX))),
				fZ: _List_fromArray(
					[
						$elm$core$List$isEmpty(fiche.yX) ? A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$perimetresExclusionsVide(i18n))
							])) : A2(
						$rtfeldman$elm_css$Html$Styled$table,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('references'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('exclusions')
							]),
						_List_fromArray(
							[
								$author$project$Components$Produits$Perimetres$View$enteteDeReferences(
								_List_fromArray(
									[
										$author$project$I18n$Cles$perimetresColonneReference(i18n),
										$author$project$I18n$Cles$perimetresColonneDesignation(i18n),
										$author$project$I18n$Cles$perimetresColonneMotif(i18n)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$tbody,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (exclusion) {
										return A2(
											$rtfeldman$elm_css$Html$Styled$tr,
											_List_Nil,
											_Utils_ap(
												A2($author$project$Components$Produits$Perimetres$View$celluleDeReference, exclusion.vx, exclusion.xt),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$td,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('motif')
															]),
														_List_fromArray(
															[
																A2($author$project$Components$Shared$Tag$View$view, 3, exclusion.Bp)
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$td,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
															]),
														A6(
															$author$project$Components$Produits$Perimetres$View$retraitDeLigne,
															i18n,
															model,
															$author$project$Components$Produits$Perimetres$Model$RetraitDExclusion(exclusion.pX),
															$author$project$API$NavLinksDictionary$retirerUneExclusion,
															exclusion.nQ,
															$author$project$I18n$Cles$perimetresLigneRetirer(i18n)))
													])));
									},
									fiche.yX))
							]))
					]),
				Ar: $elm$core$Maybe$Nothing,
				Dj: 'exclusions',
				h6: $author$project$I18n$Cles$perimetresExclusionsTitre(i18n)
			});
	});
var $author$project$Components$Produits$Perimetres$Model$RetraitDInclusion = function (a) {
	return {$: 8, a: a};
};
var $author$project$I18n$Cles$perimetresInclusionsAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.inclusions.ajouter', _List_Nil, 'Ajouter : une inclusion');
};
var $author$project$I18n$Cles$perimetresInclusionsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.inclusions.titre', _List_Nil, 'Inclusions manuelles');
};
var $author$project$I18n$Cles$perimetresInclusionsVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.inclusions.vide', _List_Nil, 'Aucune inclusion manuelle.');
};
var $author$project$Components$Produits$Perimetres$View$sectionDesInclusions = F3(
	function (i18n, model, fiche) {
		return A2(
			$author$project$Components$Shared$Page$View$sectionAvecCompte,
			_List_Nil,
			{
				fw: _Utils_eq(model.cI, $elm$core$Maybe$Nothing) ? _List_Nil : A5(
					$author$project$Components$Produits$Perimetres$View$action,
					$author$project$API$NavLinksDictionary$inclureUneReference,
					$author$project$Components$Produits$Perimetres$Model$AjoutDInclusion,
					$author$project$I18n$Cles$perimetresInclusionsAjouter(i18n),
					2,
					model),
				vW: $elm$core$Maybe$Just(
					$elm$core$String$fromInt(
						$elm$core$List$length(fiche.m8))),
				fZ: _List_fromArray(
					[
						$elm$core$List$isEmpty(fiche.m8) ? A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$perimetresInclusionsVide(i18n))
							])) : A2(
						$rtfeldman$elm_css$Html$Styled$table,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('references'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('inclusions')
							]),
						_List_fromArray(
							[
								$author$project$Components$Produits$Perimetres$View$enteteDeReferences(
								_List_fromArray(
									[
										$author$project$I18n$Cles$perimetresColonneReference(i18n),
										$author$project$I18n$Cles$perimetresColonneDesignation(i18n),
										$author$project$I18n$Cles$perimetresColonneMotifFacultatif(i18n)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$tbody,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (inclusion) {
										return A2(
											$rtfeldman$elm_css$Html$Styled$tr,
											_List_Nil,
											_Utils_ap(
												A2($author$project$Components$Produits$Perimetres$View$celluleDeReference, inclusion.vx, inclusion.xt),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$td,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('motif')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																A2($elm$core$Maybe$withDefault, '—', inclusion.cX))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$td,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
															]),
														A6(
															$author$project$Components$Produits$Perimetres$View$retraitDeLigne,
															i18n,
															model,
															$author$project$Components$Produits$Perimetres$Model$RetraitDInclusion(inclusion.pX),
															$author$project$API$NavLinksDictionary$retirerUneInclusion,
															inclusion.nQ,
															$author$project$I18n$Cles$perimetresLigneRetirer(i18n)))
													])));
									},
									fiche.m8))
							]))
					]),
				Ar: $elm$core$Maybe$Nothing,
				Dj: 'inclusions',
				h6: $author$project$I18n$Cles$perimetresInclusionsTitre(i18n)
			});
	});
var $author$project$Components$Produits$Perimetres$Model$RetraitDeRegle = function (a) {
	return {$: 10, a: a};
};
var $author$project$I18n$Cles$perimetresColonneBase = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.colonne.base', _List_Nil, 'S\'entend');
};
var $author$project$I18n$Cles$perimetresColonnePortee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.colonne.portee', _List_Nil, 'Portée');
};
var $author$project$I18n$Cles$perimetresColonneRegle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.colonne.regle', _List_Nil, 'Règle');
};
var $author$project$I18n$Cles$perimetresColonneValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.colonne.valeur', _List_Nil, 'Valeur');
};
var $author$project$I18n$Cles$perimetresRegleArchivee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.regle.archivee', _List_Nil, 'archivé');
};
var $author$project$I18n$Cles$perimetresReglesAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.regles.ajouter', _List_Nil, 'Ajouter : une règle de quantité');
};
var $author$project$I18n$Cles$perimetresReglesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.regles.titre', _List_Nil, 'Quantités');
};
var $author$project$I18n$Cles$perimetresReglesVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.regles.vide', _List_Nil, 'Aucune règle de quantité.');
};
var $author$project$Components$Produits$Perimetres$View$sectionDesRegles = F3(
	function (i18n, model, fiche) {
		var retrait = function (regle) {
			return (_Utils_eq(
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerUneRegleDeQuantite, regle.nQ.h0),
				$elm$core$Maybe$Nothing) || fiche.tE) ? $rtfeldman$elm_css$Html$Styled$text('') : A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				2,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						$author$project$Components$Produits$Perimetres$Model$idDuDeclencheur(
							$author$project$Components$Produits$Perimetres$Model$RetraitDeRegle(regle.r8))),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$Perimetres$Update$GesteOuvert(
							$author$project$Components$Produits$Perimetres$Model$RetraitDeRegle(regle.r8)))
					]),
				$author$project$I18n$Cles$perimetresLigneRetirer(i18n));
		};
		return A2(
			$author$project$Components$Shared$Page$View$sectionAvecCompte,
			_List_Nil,
			{
				fw: A5(
					$author$project$Components$Produits$Perimetres$View$action,
					$author$project$API$NavLinksDictionary$ajouterUneRegleDeQuantite,
					$author$project$Components$Produits$Perimetres$Model$AjoutDeRegle,
					$author$project$I18n$Cles$perimetresReglesAjouter(i18n),
					2,
					model),
				vW: $elm$core$Maybe$Just(
					$elm$core$String$fromInt(
						$elm$core$List$length(fiche.hJ))),
				fZ: _List_fromArray(
					[
						$elm$core$List$isEmpty(fiche.hJ) ? A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$perimetresReglesVide(i18n))
							])) : A2(
						$rtfeldman$elm_css$Html$Styled$table,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('references'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('regles')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$thead,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$tr,
										_List_Nil,
										A2(
											$elm$core$List$map,
											function (cle) {
												return A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(cle)
														]));
											},
											_List_fromArray(
												[
													$author$project$I18n$Cles$perimetresColonneRegle(i18n),
													$author$project$I18n$Cles$perimetresColonneValeur(i18n),
													$author$project$I18n$Cles$perimetresColonnePortee(i18n),
													$author$project$I18n$Cles$perimetresColonneBase(i18n),
													''
												])))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$tbody,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (regle) {
										return A2(
											$rtfeldman$elm_css$Html$Styled$tr,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
														]),
													A2(
														$elm$core$List$cons,
														$rtfeldman$elm_css$Html$Styled$text(regle.Bl),
														regle.tE ? _List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(' '),
																A2(
																$author$project$Components$Shared$Tag$View$view,
																3,
																$author$project$I18n$Cles$perimetresRegleArchivee(i18n))
															]) : _List_Nil)),
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('nombre')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															A2(
																$author$project$I18n$Cles$perimetresReglePieces,
																i18n,
																{w: regle.fm}))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															A2($author$project$Components$Produits$Vocabulaire$libelleDeLaPortee, i18n, regle.F$))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(regle.Bm)
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
														]),
													_List_fromArray(
														[
															retrait(regle)
														]))
												]));
									},
									fiche.hJ))
							]))
					]),
				Ar: $elm$core$Maybe$Nothing,
				Dj: 'regles',
				h6: $author$project$I18n$Cles$perimetresReglesTitre(i18n)
			});
	});
var $author$project$I18n$Cles$perimetresUtilisePlusieurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.utilise.plusieurs', _List_Nil, 'plusieurs');
};
var $author$project$I18n$Cles$perimetresUtiliseUnSeul = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.utilise.un-seul', _List_Nil, 'un seul');
};
var $author$project$Components$Produits$Vocabulaire$libelleDeLOptionPlusieurs = F2(
	function (i18n, plusieurs) {
		return plusieurs ? $author$project$I18n$Cles$perimetresUtilisePlusieurs(i18n) : $author$project$I18n$Cles$perimetresUtiliseUnSeul(i18n);
	});
var $author$project$I18n$Cles$perimetresUtilisePorteurEtage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.utilise.porteur.etage',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'étage ' + p.Dj);
	});
var $author$project$I18n$Cles$perimetresUtilisePorteurReference = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.utilise.porteur.reference',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'référence ' + p.Dj);
	});
var $author$project$Components$Produits$Vocabulaire$libelleDuPorteurDUnUsage = F3(
	function (i18n, usage, valeurs) {
		if (usage === 'champ-d-etage') {
			return A2($author$project$I18n$Cles$perimetresUtilisePorteurEtage, i18n, valeurs);
		} else {
			return A2($author$project$I18n$Cles$perimetresUtilisePorteurReference, i18n, valeurs);
		}
	});
var $author$project$I18n$Cles$perimetresUtiliseChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.utilise.champ', _List_Nil, 'Champ');
};
var $author$project$I18n$Cles$perimetresUtiliseChampLien = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.utilise.champ.lien',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'option',
					$author$project$I18n$Traductions$Chaine(p.Eh))
				]),
			'Lien vers des articles · ' + p.Eh);
	});
var $author$project$API$NavLinksDictionary$porteurDUnUsage = 'porteur';
var $author$project$Components$Produits$Perimetres$View$ligneDeChamp = F2(
	function (i18n, champ) {
		var adresse = function () {
			var _v1 = _Utils_Tuple2(
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$porteurDUnUsage, champ.nQ.h0),
				champ.F2);
			if (!_v1.a.$) {
				if (!_v1.b.$) {
					var uid = _v1.b.a;
					return A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $author$project$Routes$Route$FicheReference, $author$project$Routes$Route$toString),
						$author$project$Catalogue$Identifiants$referenceIdFromString(uid));
				} else {
					var _v2 = _v1.b;
					return $elm$core$Maybe$Just(
						$author$project$Routes$Route$toString(
							A2($author$project$Routes$Route$ParametrageCatalogue, 3, $elm$core$Maybe$Nothing)));
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('type')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							3,
							$author$project$I18n$Cles$perimetresUtiliseChamp(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ou')
						]),
					_List_fromArray(
						[
							function () {
							if (!adresse.$) {
								var lien = adresse.a;
								return A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href(lien)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(champ.Dj)
										]));
							} else {
								return $rtfeldman$elm_css$Html$Styled$text(champ.Dj);
							}
						}(),
							$rtfeldman$elm_css$Html$Styled$text(' · '),
							$rtfeldman$elm_css$Html$Styled$text(
							A3(
								$author$project$Components$Produits$Vocabulaire$libelleDuPorteurDUnUsage,
								i18n,
								champ.sd,
								{Dj: champ.c0}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('detail')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$perimetresUtiliseChampLien,
								i18n,
								{
									Eh: A2($author$project$Components$Produits$Vocabulaire$libelleDeLOptionPlusieurs, i18n, champ.FS)
								}))
						]))
				]));
	});
var $author$project$I18n$Cles$perimetresUtiliseUsagePipeLignes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.utilise.usage-pipe.lignes', _List_Nil, 'Lignes dans ce périmètre');
};
var $author$project$I18n$Cles$perimetresUtiliseUsagePipeOffre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.utilise.usage-pipe.offre', _List_Nil, 'Offre choisie parmi ce périmètre');
};
var $author$project$Components$Produits$Vocabulaire$libelleDeLUsageDUnPipe = F2(
	function (i18n, usage) {
		if (usage === 'lignes-dans-le-perimetre') {
			return $author$project$I18n$Cles$perimetresUtiliseUsagePipeLignes(i18n);
		} else {
			return $author$project$I18n$Cles$perimetresUtiliseUsagePipeOffre(i18n);
		}
	});
var $author$project$I18n$Cles$perimetresUtilisePipe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.utilise.pipe', _List_Nil, 'Pipe');
};
var $author$project$Components$Produits$Perimetres$View$ligneDePipe = F2(
	function (i18n, pipe) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('type')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							3,
							$author$project$I18n$Cles$perimetresUtilisePipe(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ou')
						]),
					_List_fromArray(
						[
							function () {
							var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$porteurDUnUsage, pipe.nQ.h0);
							if (!_v0.$) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href(
											$author$project$Routes$Route$toString(
												$author$project$Routes$Route$PipeEtape1(pipe.vx)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(pipe.Dj)
										]));
							} else {
								return $rtfeldman$elm_css$Html$Styled$text(pipe.Dj);
							}
						}()
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('detail')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Produits$Vocabulaire$libelleDeLUsageDUnPipe, i18n, pipe.sd))
						]))
				]));
	});
var $author$project$I18n$Cles$perimetresUtiliseCompte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'perimetres.utilise.compte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' usage') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' usages'));
	});
var $author$project$I18n$Cles$perimetresUtiliseDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.utilise.detail', _List_Nil, 'Détail');
};
var $author$project$I18n$Cles$perimetresUtiliseOu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.utilise.ou', _List_Nil, 'Où');
};
var $author$project$I18n$Cles$perimetresUtilisePar = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.utilise.par', _List_Nil, 'Où ce périmètre est utilisé');
};
var $author$project$I18n$Cles$perimetresUtiliseParVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.utilise.par.vide', _List_Nil, 'Aucun pipe ni aucun champ n\'utilise encore ce périmètre.');
};
var $author$project$I18n$Cles$perimetresUtiliseType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.utilise.type', _List_Nil, 'Type');
};
var $author$project$Components$Produits$Perimetres$View$sectionDesUsages = F2(
	function (i18n, model) {
		var _v0 = model.tq;
		if (_v0.$ === 1) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var apercu = _v0.a;
			return A2(
				$author$project$Components$Shared$Page$View$sectionAvecCompte,
				_List_Nil,
				{
					fw: _List_Nil,
					vW: $elm$core$Maybe$Just(
						A2(
							$author$project$I18n$Cles$perimetresUtiliseCompte,
							i18n,
							{w: apercu.JG + apercu.JF})),
					fZ: _List_fromArray(
						[
							((!apercu.JG) && (!apercu.JF)) ? A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$perimetresUtiliseParVide(i18n))
								])) : A2(
							$rtfeldman$elm_css$Html$Styled$table,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('usages')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$thead,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$tr,
											_List_Nil,
											A2(
												$elm$core$List$map,
												function (cle) {
													return A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(cle)
															]));
												},
												_List_fromArray(
													[
														$author$project$I18n$Cles$perimetresUtiliseType(i18n),
														$author$project$I18n$Cles$perimetresUtiliseOu(i18n),
														$author$project$I18n$Cles$perimetresUtiliseDetail(i18n)
													])))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$tbody,
									_List_Nil,
									_Utils_ap(
										A2(
											$elm$core$List$map,
											$author$project$Components$Produits$Perimetres$View$ligneDePipe(i18n),
											apercu.FM),
										A2(
											$elm$core$List$map,
											$author$project$Components$Produits$Perimetres$View$ligneDeChamp(i18n),
											apercu.dw)))
								]))
						]),
					Ar: $elm$core$Maybe$Nothing,
					Dj: 'utilise-par',
					h6: $author$project$I18n$Cles$perimetresUtilisePar(i18n)
				});
		}
	});
var $author$project$Components$Produits$Perimetres$View$critereEnClair = F2(
	function (model, critere) {
		return A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$cons,
				A2($author$project$Components$Produits$Perimetres$Model$libelleDeDimension, model, critere.dy),
				A2(
					$elm$core$List$map,
					A2($author$project$Components$Produits$Perimetres$Model$libelleDeValeur, model, critere.dy),
					critere.Ki)));
	});
var $author$project$Components$Produits$Perimetres$View$sousTitreDeLaFiche = F3(
	function (i18n, model, fiche) {
		return A2(
			$elm$core$String$join,
			' · ',
			_Utils_ap(
				A2(
					$elm$core$List$map,
					$author$project$Components$Produits$Perimetres$View$critereEnClair(model),
					fiche.wp),
				_List_fromArray(
					[
						A2(
						$author$project$I18n$Cles$perimetresDecompteTotal,
						i18n,
						{w: fiche.hD})
					])));
	});
var $author$project$Components$Produits$Perimetres$View$pageDeLaFiche = F4(
	function (i18n, messages, model, fiche) {
		return A8(
			$author$project$Components$Produits$Perimetres$View$cadre,
			i18n,
			'parametrage-perimetre-detail',
			_List_fromArray(
				[
					{
					aa: $author$project$Routes$Route$adresseDesPerimetres,
					Dj: $author$project$I18n$Cles$perimetresPageTitre(i18n)
				},
					{aa: '', Dj: fiche.Dj}
				]),
			fiche.Dj,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('tags')
						]),
					fiche.tE ? _List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							1,
							$author$project$I18n$Cles$perimetresArchive(i18n))
						]) : _List_fromArray(
						[
							A2($author$project$Components$Produits$Perimetres$View$statut, i18n, fiche.ri)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A3($author$project$Components$Produits$Perimetres$View$sousTitreDeLaFiche, i18n, model, fiche))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
						]),
					_List_fromArray(
						[
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							fiche.tE ? A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('archive-le')
								]),
							A3($author$project$Components$Produits$Perimetres$View$bandeauDArchivage, i18n, model, fiche)) : $rtfeldman$elm_css$Html$Styled$text(''),
							A3($author$project$Components$Produits$Perimetres$View$sectionDeLIdentite, i18n, model, fiche),
							A3($author$project$Components$Produits$Perimetres$View$sectionDesCriteres, i18n, model, fiche),
							A3($author$project$Components$Produits$Perimetres$View$sectionDesCriteresLies, i18n, model, fiche),
							A3($author$project$Components$Produits$Perimetres$View$sectionDesInclusions, i18n, model, fiche),
							A3($author$project$Components$Produits$Perimetres$View$sectionDesExclusions, i18n, model, fiche),
							A3($author$project$Components$Produits$Perimetres$View$sectionDesRegles, i18n, model, fiche),
							A3($author$project$Components$Produits$Perimetres$View$sectionDeLApercu, i18n, model, fiche),
							A2($author$project$Components$Produits$Perimetres$View$sectionDesUsages, i18n, model)
						]))
				]),
			A3($author$project$Components$Produits$Perimetres$View$barreDuBas, i18n, model, fiche),
			model);
	});
var $author$project$I18n$Cles$perimetresRetour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.retour', _List_Nil, 'Retour aux périmètres');
};
var $author$project$Components$Produits$Perimetres$View$view = F3(
	function (i18n, messages, model) {
		var _v0 = _Utils_Tuple3(model.nf, model.vf, model.zo);
		if (_v0.a) {
			return A2(
				$author$project$Components$Shared$Introuvable$View$view,
				i18n,
				{
					aa: $author$project$Routes$Route$adresseDesPerimetres,
					Bl: $author$project$I18n$Cles$perimetresRetour(i18n)
				});
		} else {
			if (!_v0.b.$) {
				if (!_v0.c.$) {
					var fiche = _v0.c.a;
					return A4($author$project$Components$Produits$Perimetres$View$pageDeLaFiche, i18n, messages, model, fiche);
				} else {
					var _v1 = _v0.c;
					return A3(
						$author$project$Components$Produits$Perimetres$View$annuaire,
						i18n,
						messages,
						_Utils_update(
							model,
							{aS: $elm$core$Maybe$Nothing}));
				}
			} else {
				var _v2 = _v0.b;
				return A3($author$project$Components$Produits$Perimetres$View$annuaire, i18n, messages, model);
			}
		}
	});
var $author$project$Components$Produits$Reference$View$nomDeLaPage = 'produits-reference-detail';
var $author$project$Components$Produits$Reference$Update$ArretDemande = {$: 20};
var $author$project$Components$Produits$Reference$View$horsLimites = function (fiche) {
	var duManque = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.dw;
		},
		A2(
			$elm$core$List$filter,
			function (m) {
				return m.bw === 'ValeurHorsLimites';
			},
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.B5;
					},
					fiche.fU))));
	var dates = $elm$core$Dict$keys(fiche.Am);
	return _Utils_ap(
		duManque,
		A2(
			$elm$core$List$filter,
			function (cle) {
				return !A2($elm$core$List$member, cle, duManque);
			},
			dates));
};
var $author$project$I18n$Cles$produitsReferencePiedNonPubliable = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.pied.non-publiable',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Non publiable : ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' manque')) : ('Non publiable : ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' manques')));
	});
var $author$project$I18n$Cles$produitsReferencePublier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.publier', _List_Nil, 'Publier');
};
var $author$project$Components$Produits$Reference$View$piedNonPubliable = F2(
	function (i18n, fiche) {
		var _v0 = $author$project$Components$Produits$Reference$View$horsLimites(fiche);
		if (!_v0.b) {
			return _List_Nil;
		} else {
			var cles = _v0;
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('non-publiable')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$produitsReferencePiedNonPubliable,
								i18n,
								{
									w: $elm$core$List$length(cles)
								}))
						])),
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
						]),
					$author$project$I18n$Cles$produitsReferencePublier(i18n))
				]);
		}
	});
var $author$project$I18n$Cles$produitsReferenceArret = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.arret', _List_Nil, 'Arrêter la référence');
};
var $author$project$Components$Produits$Reference$View$actions = F2(
	function (i18n, fiche) {
		return _Utils_ap(
			A2($author$project$Components$Produits$Reference$View$piedNonPubliable, i18n, fiche),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (_v0) {
						return _List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								3,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Reference$Model$idDeLArret),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Reference$Update$ArretDemande)
									]),
								$author$project$I18n$Cles$produitsReferenceArret(i18n))
							]);
					},
					$author$project$Components$Produits$Reference$Model$commandeDArret(fiche))));
	});
var $author$project$Components$Produits$Reference$Update$CodeDemande = {$: 30};
var $author$project$Components$Produits$Reference$Update$CodeRecalculDemande = {$: 31};
var $author$project$Components$Produits$Reference$Update$EtatDemande = {$: 11};
var $author$project$Components$Produits$Reference$Update$ModificationDemandee = {$: 14};
var $author$project$Components$Shared$Bouton$View$boutonAvecIcone = F4(
	function (variante, icone, attributs, libelle) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Html$Styled$Attributes$class('button'),
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
							$author$project$Components$Shared$Bouton$View$classe(variante)),
						A2(
							$elm$core$List$cons,
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', libelle),
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_css$Html$Styled$Attributes$title(libelle),
								attributs))))),
			_List_fromArray(
				[
					icone,
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						]))
				]));
	});
var $author$project$I18n$Cles$produitsReferenceCodeChanger = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.code.changer', _List_Nil, 'Changer le code');
};
var $author$project$I18n$Cles$produitsReferenceCodeRecalculer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.code.recalculer', _List_Nil, 'Recalculer ce code');
};
var $author$project$I18n$Cles$produitsReferenceFicheModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fiche.modifier', _List_Nil, 'Modifier');
};
var $author$project$Components$Produits$Reference$View$saisissable = function (fiche) {
	return !_Utils_eq(
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierLesAttributsDUneReference, fiche.nQ),
		$elm$core$Maybe$Nothing);
};
var $author$project$Components$Produits$Reference$View$actionsDEnTete = F2(
	function (i18n, fiche) {
		var si = F2(
			function (lien, bouton) {
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (_v0) {
							return _List_fromArray(
								[bouton]);
						},
						lien));
			});
		return _Utils_ap(
			A2(
				si,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$second,
					A2($author$project$Components$Produits$Reference$Model$commandeDuCode, fiche, $elm$core$Maybe$Nothing)),
				A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Reference$Model$idDuCode),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Reference$Update$CodeDemande)
						]),
					$author$project$I18n$Cles$produitsReferenceCodeChanger(i18n))),
			_Utils_ap(
				A2(
					si,
					$author$project$Components$Produits$Reference$Model$lienDeLApercuDuCode(fiche),
					A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('reference-recalculer-le-code'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'dialog'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Reference$Update$CodeRecalculDemande)
							]),
						$author$project$I18n$Cles$produitsReferenceCodeRecalculer(i18n))),
				_Utils_ap(
					A2(
						si,
						$author$project$Components$Produits$Common$Etat$lien(fiche),
						A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Reference$Model$idDeLEtat),
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Reference$Update$EtatDemande)
								]),
							$author$project$I18n$Cles$produitsReferenceEtatChanger(i18n))),
					$author$project$Components$Produits$Reference$View$saisissable(fiche) ? _List_fromArray(
						[
							A4(
							$author$project$Components$Shared$Bouton$View$boutonAvecIcone,
							0,
							$author$project$Components$Shared$Svg$svgEdit,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Reference$Update$ModificationDemandee)
								]),
							$author$project$I18n$Cles$produitsReferenceFicheModifier(i18n))
						]) : _List_Nil)));
	});
var $author$project$Components$Produits$Reference$Update$HistoriqueDemande = {$: 4};
var $author$project$I18n$Cles$produitsReferenceActiviteDateEtAuteur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.activite.date-et-auteur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv)),
					_Utils_Tuple2(
					'auteur',
					$author$project$I18n$Traductions$Chaine(p.t1))
				]),
			p.wv + (' · ' + p.t1));
	});
var $author$project$Components$Produits$Reference$Lecture$dateEtAuteur = F2(
	function (i18n, evenement) {
		var _v0 = evenement.t1;
		if (!_v0.$) {
			var auteur = _v0.a;
			return A2(
				$author$project$I18n$Cles$produitsReferenceActiviteDateEtAuteur,
				i18n,
				{
					t1: auteur,
					wv: A2($author$project$Texte$Jour$horodate, i18n, evenement.wv)
				});
		} else {
			return A2($author$project$Texte$Jour$horodate, i18n, evenement.wv);
		}
	});
var $author$project$I18n$Cles$produitsReferenceActiviteArretee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.activite.arretee', _List_Nil, 'Référence arrêtée');
};
var $author$project$I18n$Cles$produitsReferenceActiviteAttributModifie = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.activite.attribut-modifie',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'cle',
					$author$project$I18n$Traductions$Chaine(p.dy))
				]),
			'Information modifiée · ' + p.dy);
	});
var $author$project$I18n$Cles$produitsReferenceActiviteAttributTraduit = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.activite.attribut-traduit',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'cle',
					$author$project$I18n$Traductions$Chaine(p.dy)),
					_Utils_Tuple2(
					'langue',
					$author$project$I18n$Traductions$Chaine(p.nn))
				]),
			'Information traduite · ' + (p.dy + (' (' + (p.nn + ')'))));
	});
var $author$project$I18n$Cles$produitsReferenceActiviteCreee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.activite.creee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etat',
					$author$project$I18n$Traductions$Chaine(p.gt))
				]),
			'Référence créée · état ' + p.gt);
	});
var $author$project$I18n$Cles$produitsReferenceActiviteEtatChange = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.activite.etat-change',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etat',
					$author$project$I18n$Traductions$Chaine(p.gt))
				]),
			'État changé · ' + p.gt);
	});
var $author$project$I18n$Cles$produitsReferenceActiviteModification = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.activite.modification', _List_Nil, 'Référence modifiée');
};
var $author$project$I18n$Cles$produitsReferenceActiviteRangee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.activite.rangee', _List_Nil, 'Référence rangée');
};
var $author$project$I18n$Cles$produitsReferenceActiviteValeurConvertie = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.activite.valeur-convertie',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'ancienne',
					$author$project$I18n$Traductions$Chaine(p.iN)),
					_Utils_Tuple2(
					'origine',
					$author$project$I18n$Traductions$Chaine(p.o4)),
					_Utils_Tuple2(
					'nouvelle',
					$author$project$I18n$Traductions$Chaine(p.oS)),
					_Utils_Tuple2(
					'vers',
					$author$project$I18n$Traductions$Chaine(p.sn))
				]),
			'Valeur convertie de ' + (p.iN + (' ' + (p.o4 + (' en ' + (p.oS + (' ' + p.sn)))))));
	});
var $author$project$Catalogue$Vocabulaire$activiteDeReference = F3(
	function (i18n, natureDuBack, mots) {
		switch (natureDuBack) {
			case 'creee':
				return A2(
					$author$project$I18n$Cles$produitsReferenceActiviteCreee,
					i18n,
					{gt: mots.gt});
			case 'etat-change':
				return A2(
					$author$project$I18n$Cles$produitsReferenceActiviteEtatChange,
					i18n,
					{gt: mots.gt});
			case 'arretee':
				return $author$project$I18n$Cles$produitsReferenceActiviteArretee(i18n);
			case 'attribut-modifie':
				return A2(
					$author$project$I18n$Cles$produitsReferenceActiviteAttributModifie,
					i18n,
					{dy: mots.dy});
			case 'attribut-traduit':
				return A2(
					$author$project$I18n$Cles$produitsReferenceActiviteAttributTraduit,
					i18n,
					{dy: mots.dy, nn: mots.nn});
			case 'rangee':
				return $author$project$I18n$Cles$produitsReferenceActiviteRangee(i18n);
			case 'valeur-convertie':
				return A2(
					$author$project$I18n$Cles$produitsReferenceActiviteValeurConvertie,
					i18n,
					{iN: mots.iN, oS: mots.oS, o4: mots.wC, sn: mots.sn});
			default:
				return $author$project$I18n$Cles$produitsReferenceActiviteModification(i18n);
		}
	});
var $author$project$Components$Produits$Common$Etat$libelleDuCode = F3(
	function (i18n, etats, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2(
				$author$project$I18n$Cles$texte,
				i18n,
				$author$project$Catalogue$Vocabulaire$etat(code)),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.zX;
				},
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.R;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.vx;
								},
								A2(
									$elm$core$Basics$composeR,
									$author$project$Catalogue$Identifiants$etatCodeToString,
									$elm$core$Basics$eq(code))),
							etats)))));
	});
var $author$project$Components$Produits$Reference$Lecture$nombreRendu = F2(
	function (i18n, rendu) {
		return A2(
			$elm$core$Maybe$withDefault,
			rendu,
			A2(
				$elm$core$Maybe$map,
				A2(
					$author$project$I18n$Nombre$formaterFlottant,
					$author$project$I18n$Traductions$langue(i18n),
					0),
				$elm$core$String$toFloat(rendu)));
	});
var $author$project$Components$Produits$Reference$Lecture$phrase = F3(
	function (i18n, fiche, evenement) {
		var parametre = function (cle) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Dict$get, cle, evenement.EX));
		};
		var etat = A3(
			$author$project$Components$Produits$Common$Etat$libelleDuCode,
			i18n,
			fiche.mj,
			parametre('etat'));
		var champ = A2(
			$elm$core$Maybe$withDefault,
			parametre('cle'),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dy;
							},
							$elm$core$Basics$eq(
								parametre('cle'))),
						fiche.r0.dw))));
		return A3(
			$author$project$Catalogue$Vocabulaire$activiteDeReference,
			i18n,
			evenement.g1,
			{
				iN: A2(
					$author$project$Components$Produits$Reference$Lecture$nombreRendu,
					i18n,
					parametre('ancienne')),
				dy: champ,
				wC: parametre('de'),
				gt: etat,
				nn: A2(
					$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$langue,
					i18n,
					parametre('langue')),
				oS: A2(
					$author$project$Components$Produits$Reference$Lecture$nombreRendu,
					i18n,
					parametre('nouvelle')),
				sn: parametre('vers')
			});
	});
var $author$project$Components$Produits$Reference$View$frise = F3(
	function (i18n, fiche, evenements) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$ol,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('frise')
				]),
			A2(
				$elm$core$List$map,
				function (evenement) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('point'),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
									]),
								_List_Nil),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('date')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2($author$project$Components$Produits$Reference$Lecture$dateEtAuteur, i18n, evenement))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('phrase')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A3($author$project$Components$Produits$Reference$Lecture$phrase, i18n, fiche, evenement))
											]))
									]))
							]));
				},
				evenements));
	});
var $author$project$Components$Produits$Reference$Model$idDeLActivite = 'section-activite';
var $author$project$I18n$Cles$produitsReferenceActiviteAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.activite.aucune', _List_Nil, 'Aucune activité pour l\'instant.');
};
var $author$project$I18n$Cles$produitsReferenceActiviteTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.activite.titre', _List_Nil, 'Activité récente');
};
var $author$project$I18n$Cles$produitsReferenceActiviteTout = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.activite.tout', _List_Nil, 'Voir tout l\'historique');
};
var $author$project$Components$Produits$Reference$View$activite = F2(
	function (i18n, fiche) {
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Reference$Model$idDeLActivite),
					$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1)
				]),
			{
				fw: _List_Nil,
				fZ: _List_fromArray(
					[
						A3($author$project$Components$Produits$Reference$View$frise, i18n, fiche, fiche.sT),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$List$isEmpty(fiche.sT) ? $author$project$I18n$Cles$produitsReferenceActiviteAucune(i18n) : '')
							])),
						_Utils_eq(
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$historique, fiche.nQ),
						$elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('lien-texte'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Reference$Model$idDeLHistorique),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Reference$Update$HistoriqueDemande)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsReferenceActiviteTout(i18n))
							]))
					]),
				Dj: 'activite',
				h6: $author$project$I18n$Cles$produitsReferenceActiviteTitre(i18n)
			});
	});
var $author$project$Components$Produits$Reference$Update$ArretConfirme = {$: 22};
var $author$project$Components$Produits$Reference$Update$FocusDemande = function (a) {
	return {$: 39, a: a};
};
var $author$project$Components$Produits$Reference$Update$clavierDeLArret = A2($author$project$Components$Shared$Confirmation$Clavier$clavier, $author$project$Components$Produits$Reference$Model$idsDeLArret, $author$project$Components$Produits$Reference$Update$FocusDemande);
var $author$project$I18n$Cles$produitsReferenceArretConfirmer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.arret.confirmer', _List_Nil, 'Arrêter');
};
var $author$project$I18n$Cles$produitsReferenceArretMessage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.arret.message',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'code',
					$author$project$I18n$Traductions$Chaine(p.vx))
				]),
			'Arrêter ' + (p.vx + ' ? Elle ne sera plus proposée aux nouveaux dossiers ni aux listes de prix, et restera lisible. Cette action est sans retour.'));
	});
var $author$project$I18n$Cles$produitsReferenceArretTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.arret.titre', _List_Nil, 'Arrêter la référence');
};
var $author$project$Components$Produits$Reference$View$arret = F3(
	function (i18n, model, fiche) {
		var ids = $author$project$Components$Produits$Reference$Model$idsDeLArret;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('opened', model.is)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('overlay'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Reference$Update$ArretAnnule)
						]),
					_List_Nil),
					A2(
					$author$project$Components$Shared$Confirmation$View$view,
					i18n,
					{
						vl: $author$project$Components$Produits$Reference$Update$clavierDeLArret,
						j7: {
							Aq: ids.j7,
							Bl: $author$project$I18n$Cles$produitsReferenceArretConfirmer(i18n),
							C$: $author$project$Components$Produits$Reference$Update$ArretConfirme
						},
						Aq: ids.GN,
						As: ids.Cs,
						At: ids.h6,
						Cs: A2(
							$author$project$I18n$Cles$produitsReferenceArretMessage,
							i18n,
							{vx: fiche.vx}),
						Et: model.is,
						HG: {
							Aq: ids.to,
							Bl: $author$project$I18n$Cles$produitsCatalogueArchivageAnnuler(i18n),
							C$: $author$project$Components$Produits$Reference$Update$ArretAnnule
						},
						h6: $author$project$I18n$Cles$produitsReferenceArretTitre(i18n),
						sl: 0
					})
				]));
	});
var $author$project$Components$Produits$Reference$Update$ImageADefinir = {$: 83};
var $author$project$I18n$Cles$produitsReferenceImageMotifDimensions = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.motif-dimensions', _List_Nil, 'l\'image dépasse les dimensions admises.');
};
var $author$project$I18n$Cles$produitsReferenceImageMotifIllisible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.motif-illisible', _List_Nil, 'le fichier n\'est pas une image lisible.');
};
var $author$project$I18n$Cles$produitsReferenceImageMotifRejete = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.motif-rejete', _List_Nil, 'le fichier a été refusé.');
};
var $author$project$I18n$Cles$produitsReferenceImageNonUtilisable = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.image.non-utilisable',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'cause',
					$author$project$I18n$Traductions$Chaine(p.bw))
				]),
			'L\'image n\'a pas pu être utilisée : ' + p.bw);
	});
var $author$project$I18n$Cles$produitsReferenceImageNonUtilisableNom = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.image.non-utilisable-nom',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'cause',
					$author$project$I18n$Traductions$Chaine(p.bw))
				]),
			'L\'image « ' + (p.Dj + (' » n\'a pas pu être utilisée : ' + p.bw)));
	});
var $author$project$Components$Produits$Reference$ImageView$nonUtilisable = F3(
	function (i18n, source, motif) {
		var cause = function () {
			switch (motif) {
				case 1:
					return $author$project$I18n$Cles$produitsReferenceImageMotifIllisible(i18n);
				case 0:
					return $author$project$I18n$Cles$produitsReferenceImageMotifRejete(i18n);
				default:
					return $author$project$I18n$Cles$produitsReferenceImageMotifDimensions(i18n);
			}
		}();
		if (((!source.$) && (!source.a.$)) && (!source.a.a.$)) {
			var nom = source.a.a.a;
			return A2(
				$author$project$I18n$Cles$produitsReferenceImageNonUtilisableNom,
				i18n,
				{bw: cause, Dj: nom});
		} else {
			return A2(
				$author$project$I18n$Cles$produitsReferenceImageNonUtilisable,
				i18n,
				{bw: cause});
		}
	});
var $author$project$Components$Produits$Reference$ImageView$offert = F2(
	function (rel, image) {
		return !_Utils_eq(
			A2($author$project$API$Liens$trouver, rel, image.nQ.h0),
			$elm$core$Maybe$Nothing);
	});
var $author$project$I18n$Cles$produitsReferenceImageAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.ajouter', _List_Nil, 'Ajouter une image');
};
var $author$project$I18n$Cles$produitsReferenceImageAlt = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.alt', _List_Nil, 'Image de présentation de la fiche');
};
var $author$project$I18n$Cles$produitsReferenceImageAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.aucune', _List_Nil, 'Aucune image');
};
var $author$project$I18n$Cles$produitsReferenceImageChampRetire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.champ-retire', _List_Nil, 'L\'image choisie n\'est plus dans la fiche.');
};
var $author$project$I18n$Cles$produitsReferenceImageChanger = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.changer', _List_Nil, 'Changer');
};
var $author$project$I18n$Cles$produitsReferenceImageDefinir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.definir', _List_Nil, 'Définir une image');
};
var $author$project$I18n$Cles$produitsReferenceImageEnPreparation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.en-preparation', _List_Nil, 'Vignette en préparation');
};
var $author$project$I18n$Cles$produitsReferenceImageEnPreparationDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.en-preparation-detail', _List_Nil, 'Image reçue. La vignette s\'affiche dès qu\'elle est prête.');
};
var $author$project$Components$Produits$Reference$ImageView$avecLeNom = function (nom) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (n) {
				return ' · ' + n;
			},
			nom));
};
var $author$project$Components$Produits$Reference$ImageView$libelleDuChamp = F2(
	function (model, cle) {
		return A2(
			$elm$core$Maybe$withDefault,
			cle,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (image) {
							return _Utils_eq(image.uN, cle);
						},
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (fiche) {
									return A2(
										$author$project$Components$Produits$Reference$Image$imagesDeLaFiche,
										$author$project$Components$Produits$Reference$Model$champs(fiche),
										fiche);
								},
								model.zo))))));
	});
var $author$project$I18n$Cles$produitsReferenceImageSourceChamp = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.image.source-champ',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'Image du champ « ' + (p.uN + ' »'));
	});
var $author$project$I18n$Cles$produitsReferenceImageSourceDeposee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.source-deposee', _List_Nil, 'Image déposée');
};
var $author$project$Components$Produits$Reference$ImageView$sourceDeLImage = F3(
	function (i18n, model, source) {
		if (!source.$) {
			if (!source.a.$) {
				var nom = source.a.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('source')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							_Utils_ap(
								$author$project$I18n$Cles$produitsReferenceImageSourceDeposee(i18n),
								$author$project$Components$Produits$Reference$ImageView$avecLeNom(nom)))
						]));
			} else {
				var _v1 = source.a;
				var cle = _v1.a;
				var nom = _v1.b;
				return A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('source')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							_Utils_ap(
								A2(
									$author$project$I18n$Cles$produitsReferenceImageSourceChamp,
									i18n,
									{
										uN: A2($author$project$Components$Produits$Reference$ImageView$libelleDuChamp, model, cle)
									}),
								$author$project$Components$Produits$Reference$ImageView$avecLeNom(nom)))
						]));
			}
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Shared$Svg$svgImage = A3($author$project$Components$Shared$Svg$icone, 'image', 'M5 4h14a1.5 1.5 0 0 1 1.5 1.5v13A1.5 1.5 0 0 1 19 20H5a1.5 1.5 0 0 1-1.5-1.5v-13A1.5 1.5 0 0 1 5 4zM3.5 16.5l5-5 4 4 2.5-2.5 5.5 5.5M9 9.5h.01', _List_Nil);
var $author$project$Components$Produits$Reference$ImageView$bandeau = F2(
	function (i18n, model) {
		var _v0 = model.af;
		if (_v0.$ === 1) {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('image-presentation'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
						]),
					_List_fromArray(
						[$author$project$Components$Shared$Svg$svgImage]))
				]);
		} else {
			var image = _v0.a;
			var peutDefinir = A2($author$project$Components$Produits$Reference$ImageView$offert, $author$project$API$NavLinksDictionary$definirLImage, image);
			var vide = peutDefinir ? A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('image-presentation'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('vide'),
						$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Reference$Model$idDeLImage),
						$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Reference$Update$ImageADefinir)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('plus')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('+')
							])),
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsReferenceImageAjouter(i18n))
					])) : A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('image-presentation'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('vide'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('neutre')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsReferenceImageAucune(i18n))
					]));
			var changer = peutDefinir ? _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Reference$Model$idDeLImage),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Reference$Update$ImageADefinir)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsReferenceImageChanger(i18n))
						]))
				]) : _List_Nil;
			var _v1 = image.gt;
			switch (_v1.$) {
				case 2:
					var adresse = _v1.a;
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('image-presentation'),
									$rtfeldman$elm_css$Html$Styled$Attributes$src(adresse),
									$rtfeldman$elm_css$Html$Styled$Attributes$alt(
									$author$project$I18n$Cles$produitsReferenceImageAlt(i18n))
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('image-source')
								]),
							peutDefinir ? A2(
								$elm$core$List$cons,
								A3($author$project$Components$Produits$Reference$ImageView$sourceDeLImage, i18n, model, image.IR),
								A2(
									$elm$core$List$cons,
									$rtfeldman$elm_css$Html$Styled$text(' · '),
									changer)) : _List_Nil)
						]);
				case 1:
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('image-presentation'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('en-preparation'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsReferenceImageEnPreparation(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('image-source')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsReferenceImageEnPreparationDetail(i18n))
								]))
						]);
				case 3:
					var motif = _v1.a;
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('image-presentation'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('vide'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('neutre')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsReferenceImageAucune(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('image-source'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('refus')
								]),
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_css$Html$Styled$text(
									A3($author$project$Components$Produits$Reference$ImageView$nonUtilisable, i18n, image.IR, motif)),
								peutDefinir ? _List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(' '),
										A2(
										$rtfeldman$elm_css$Html$Styled$button,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
												$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Reference$Update$ImageADefinir)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$produitsReferenceImageDefinir(i18n))
											]))
									]) : _List_Nil))
						]);
				case 4:
					return _List_fromArray(
						[
							vide,
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('image-source')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsReferenceImageChampRetire(i18n))
								]))
						]);
				default:
					return _List_fromArray(
						[
							vide,
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('image-source')
								]),
							_List_Nil)
						]);
			}
		}
	});
var $author$project$I18n$Cles$produitsReferenceInformationsCategorie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.informations.categorie', _List_Nil, 'Catégorie');
};
var $author$project$I18n$Cles$produitsReferenceInformationsEtageSansNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.informations.etage-sans-nom', _List_Nil, 'Étage');
};
var $author$project$Components$Produits$Reference$Lecture$libelleDeLEtage = F2(
	function (i18n, etage) {
		var _v0 = _Utils_Tuple2(etage.R, etage.g1);
		if (!_v0.a.$) {
			var libelles = _v0.a.a;
			return libelles.zX;
		} else {
			switch (_v0.b) {
				case 'libre':
					var _v1 = _v0.a;
					return $author$project$I18n$Cles$produitsReferenceInformationsEtageSansNom(i18n);
				case 'categorie':
					var _v2 = _v0.a;
					return $author$project$I18n$Cles$produitsReferenceInformationsCategorie(i18n);
				default:
					var _v3 = _v0.a;
					var nature = _v0.b;
					return A2(
						$author$project$I18n$Cles$texte,
						i18n,
						$author$project$Catalogue$Vocabulaire$archetype(nature));
			}
		}
	});
var $author$project$I18n$Cles$produitsReferenceCheminTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.chemin.titre', _List_Nil, 'Chemin de rangement');
};
var $author$project$Components$Produits$Reference$View$chemin = F2(
	function (i18n, etapes) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$ol,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('chemin'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					$author$project$I18n$Cles$produitsReferenceCheminTitre(i18n))
				]),
			A2(
				$elm$core$List$map,
				function (etape) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('etage')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$Components$Produits$Reference$Lecture$libelleDeLEtage, i18n, etape.md))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.zX;
												},
												etape.R)))
									]))
							]));
				},
				etapes));
	});
var $author$project$Catalogue$Vocabulaire$critereDeChamp = 'Champ';
var $author$project$I18n$Cles$produitsReferenceCompletudeCritereCode = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.completude.critere.code', _List_Nil, 'Code unique dans la marque');
};
var $author$project$I18n$Cles$produitsReferenceCompletudeCritereMesures = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.completude.critere.mesures', _List_Nil, 'Informations obligatoires remplies');
};
var $author$project$I18n$Cles$produitsReferenceCompletudeCritereRattachement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.completude.critere.rattachement', _List_Nil, 'Chemin complet');
};
var $author$project$I18n$Cles$produitsReferenceCompletudeCritereValeursDansLeursLimites = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.completude.critere.valeurs-dans-leurs-limites', _List_Nil, 'Valeurs dans les limites des champs');
};
var $author$project$Catalogue$Vocabulaire$critereDeCompletude = F2(
	function (i18n, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			code,
			A2(
				$elm$core$Dict$get,
				code,
				$elm$core$Dict$fromList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'CodeUnique',
							$author$project$I18n$Cles$produitsReferenceCompletudeCritereCode(i18n)),
							_Utils_Tuple2(
							'RattachementDansLaHierarchie',
							$author$project$I18n$Cles$produitsReferenceCompletudeCritereRattachement(i18n)),
							_Utils_Tuple2(
							'MesuresPlausibles',
							$author$project$I18n$Cles$produitsReferenceCompletudeCritereMesures(i18n)),
							_Utils_Tuple2(
							'ValeursDansLeursLimites',
							$author$project$I18n$Cles$produitsReferenceCompletudeCritereValeursDansLeursLimites(i18n))
						]))));
	});
var $author$project$Catalogue$Vocabulaire$critereDeFichier = 'Fichier';
var $author$project$Catalogue$Vocabulaire$criteresDeCoherence = _List_fromArray(
	['RattachementDansLaHierarchie', 'CodeUnique', 'MesuresPlausibles', 'ValeursDansLeursLimites']);
var $author$project$I18n$Cles$produitsReferenceCompletudeCauseAutre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.completude.cause.autre', _List_Nil, 'à compléter');
};
var $author$project$I18n$Cles$produitsReferenceCompletudeCauseCodeEnDouble = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.completude.cause.code-en-double', _List_Nil, 'déjà porté par une autre référence de la marque');
};
var $author$project$I18n$Cles$produitsReferenceCompletudeCauseMesuresHorsBornes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.completude.cause.mesures-hors-bornes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champs',
					$author$project$I18n$Traductions$Chaine(p.dw))
				]),
			p.dw + ' hors des bornes plausibles');
	});
var $author$project$I18n$Cles$produitsReferenceCompletudeCauseObligatoireALaPublication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.completude.cause.obligatoire-a-la-publication', _List_Nil, 'obligatoire à la publication');
};
var $author$project$I18n$Cles$produitsReferenceCompletudeCauseRattachementHorsHierarchie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.completude.cause.rattachement-hors-hierarchie', _List_Nil, 'ne suit plus la hiérarchie du catalogue');
};
var $author$project$I18n$Cles$produitsReferenceCompletudeCauseRegleEnfreinte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.completude.cause.regle-enfreinte', _List_Nil, 'ne respecte pas la règle de l\'information');
};
var $author$project$I18n$Cles$produitsReferenceCompletudeCauseValeurHorsLimites = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.completude.cause.valeur-hors-limites',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champs',
					$author$project$I18n$Traductions$Chaine(p.dw))
				]),
			p.dw + ' hors des limites du champ');
	});
var $author$project$Catalogue$Vocabulaire$reglesDeLaBibliotheque = _List_fromArray(
	['Format', 'HorsListe', 'CleInconnue', 'Bornes', 'Longueur', 'Motif', 'NombreDeChoix', 'ChoixEnDouble', 'TypeDeFichier', 'TailleDeFichier']);
var $author$project$Catalogue$Vocabulaire$causeDeManque = F2(
	function (i18n, manque) {
		return (manque.bw === 'Obligatoire') ? $author$project$I18n$Cles$produitsReferenceCompletudeCauseObligatoireALaPublication(i18n) : (A2($elm$core$List$member, manque.bw, $author$project$Catalogue$Vocabulaire$reglesDeLaBibliotheque) ? $author$project$I18n$Cles$produitsReferenceCompletudeCauseRegleEnfreinte(i18n) : ((manque.bw === 'CodeEnDouble') ? $author$project$I18n$Cles$produitsReferenceCompletudeCauseCodeEnDouble(i18n) : ((manque.bw === 'RattachementHorsHierarchie') ? $author$project$I18n$Cles$produitsReferenceCompletudeCauseRattachementHorsHierarchie(i18n) : ((manque.bw === 'MesuresHorsBornes') ? A2(
			$author$project$I18n$Cles$produitsReferenceCompletudeCauseMesuresHorsBornes,
			i18n,
			{dw: manque.dw}) : ((manque.bw === 'ValeurHorsLimites') ? A2(
			$author$project$I18n$Cles$produitsReferenceCompletudeCauseValeurHorsLimites,
			i18n,
			{dw: manque.dw}) : $author$project$I18n$Cles$produitsReferenceCompletudeCauseAutre(i18n))))));
	});
var $author$project$I18n$Cles$produitsReferenceCompletudeCauseFichierFormatRefuse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.completude.cause.fichier-format-refuse', _List_Nil, 'format du fichier refusé');
};
var $author$project$I18n$Cles$produitsReferenceCompletudeCauseFichierResolutionInsuffisante = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.completude.cause.fichier-resolution-insuffisante',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'lue',
					$author$project$I18n$Traductions$Chaine(p.B1)),
					_Utils_Tuple2(
					'attendue',
					$author$project$I18n$Traductions$Chaine(p.tS))
				]),
			p.B1 + (', ' + (p.tS + ' attendus')));
	});
var $author$project$I18n$Cles$produitsReferenceCompletudeCauseFichierTexteAlternatifAbsent = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.completude.cause.fichier-texte-alternatif-absent', _List_Nil, 'texte alternatif anglais manquant');
};
var $author$project$I18n$Cles$produitsReferenceCompletudeCauseFichierTropLourd = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.completude.cause.fichier-trop-lourd', _List_Nil, 'fichier trop lourd');
};
var $author$project$Components$Produits$Reference$View$causeDuFichier = F3(
	function (i18n, fiche, lu) {
		var nombre = A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$core$String$fromInt),
			$elm$core$Maybe$withDefault('—'));
		var dimensions = F2(
			function (largeur, hauteur) {
				return largeur + ('×' + hauteur);
			});
		var cle = A2($elm$core$Maybe$withDefault, '', lu.uN);
		var lues = A2(
			$elm$core$Maybe$withDefault,
			'—',
			A2(
				$elm$core$Maybe$map,
				function (d) {
					return A2(
						dimensions,
						$elm$core$String$fromInt(d.Bd),
						$elm$core$String$fromInt(d.Ae));
				},
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.xz;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.uN;
								},
								$elm$core$Basics$eq(cle)),
							fiche.zB)))));
		var attendues = A2(
			$elm$core$Maybe$withDefault,
			'—',
			A2(
				$elm$core$Maybe$map,
				function (_v1) {
					var m = _v1.b;
					return A2(
						dimensions,
						nombre(m.Be),
						nombre(m.Af));
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$eq(cle)),
						fiche.r0.CC))));
		var _v0 = lu.bw;
		switch (_v0) {
			case 'FichierAbsent':
				return $author$project$I18n$Cles$produitsReferenceCompletudeCauseObligatoireALaPublication(i18n);
			case 'FormatRefuse':
				return $author$project$I18n$Cles$produitsReferenceCompletudeCauseFichierFormatRefuse(i18n);
			case 'FichierTropLourd':
				return $author$project$I18n$Cles$produitsReferenceCompletudeCauseFichierTropLourd(i18n);
			case 'TexteAlternatifAbsent':
				return $author$project$I18n$Cles$produitsReferenceCompletudeCauseFichierTexteAlternatifAbsent(i18n);
			case 'ResolutionInsuffisante':
				return A2(
					$author$project$I18n$Cles$produitsReferenceCompletudeCauseFichierResolutionInsuffisante,
					i18n,
					{tS: attendues, B1: lues});
			default:
				return $author$project$I18n$Cles$produitsReferenceCompletudeCauseAutre(i18n);
		}
	});
var $author$project$I18n$Cles$produitsReferenceCompletudeManque = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.completude.manque',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'critere',
					$author$project$I18n$Traductions$Chaine(p.km)),
					_Utils_Tuple2(
					'cause',
					$author$project$I18n$Traductions$Chaine(p.bw))
				]),
			p.km + (' : ' + p.bw));
	});
var $author$project$Components$Produits$Reference$View$texteDuManque = F3(
	function (i18n, fiche, lu) {
		var libelle = function (cle) {
			return A2(
				$elm$core$Maybe$withDefault,
				cle,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Bl;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.dy;
								},
								$elm$core$Basics$eq(cle)),
							fiche.r0.dw))));
		};
		var critere = function () {
			var _v0 = _Utils_Tuple3(
				_Utils_eq(lu.km, $author$project$Catalogue$Vocabulaire$critereDeChamp),
				lu.uN,
				lu.nn);
			if (_v0.a && (!_v0.b.$)) {
				if (!_v0.c.$) {
					var cle = _v0.b.a;
					var langue = _v0.c.a;
					return A2(
						$author$project$I18n$Cles$saisieDeChampParLangue,
						i18n,
						{
							nn: A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$langue, i18n, langue),
							Bl: libelle(cle)
						});
				} else {
					var cle = _v0.b.a;
					var _v1 = _v0.c;
					return libelle(cle);
				}
			} else {
				var _v2 = _Utils_Tuple2(
					_Utils_eq(lu.km, $author$project$Catalogue$Vocabulaire$critereDeFichier),
					lu.uN);
				if (_v2.a && (!_v2.b.$)) {
					var cle = _v2.b.a;
					return libelle(cle);
				} else {
					return A2($author$project$Catalogue$Vocabulaire$critereDeCompletude, i18n, lu.km);
				}
			}
		}();
		return A2(
			$author$project$I18n$Cles$produitsReferenceCompletudeManque,
			i18n,
			{
				bw: _Utils_eq(lu.km, $author$project$Catalogue$Vocabulaire$critereDeFichier) ? A3($author$project$Components$Produits$Reference$View$causeDuFichier, i18n, fiche, lu) : A2(
					$author$project$Catalogue$Vocabulaire$causeDeManque,
					i18n,
					{
						bw: lu.bw,
						dw: A2(
							$elm$core$String$join,
							', ',
							A2($elm$core$List$map, libelle, lu.dw))
					}),
				km: critere
			});
	});
var $author$project$Components$Produits$Reference$View$criteres = F3(
	function (i18n, fiche, lue) {
		var manquesDeChamp = A2(
			$elm$core$List$filter,
			function (m) {
				return _Utils_eq(m.km, $author$project$Catalogue$Vocabulaire$critereDeChamp) || _Utils_eq(m.km, $author$project$Catalogue$Vocabulaire$critereDeFichier);
			},
			lue.B5);
		var ligne = F2(
			function (rempli, texte) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('rempli', rempli),
									_Utils_Tuple2('manquant', !rempli)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('case'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
								]),
							rempli ? _List_fromArray(
								[$author$project$Components$Shared$Svg$svgCheck]) : _List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('critere')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(texte)
								]))
						]));
			});
		var coherence = function (code) {
			var _v0 = A2(
				$elm$core$List$filter,
				function (m) {
					return _Utils_eq(m.km, code);
				},
				lue.B5);
			if (!_v0.b) {
				return A2(
					ligne,
					true,
					A2($author$project$Catalogue$Vocabulaire$critereDeCompletude, i18n, code));
			} else {
				var premier = _v0.a;
				return A2(
					ligne,
					false,
					A3($author$project$Components$Produits$Reference$View$texteDuManque, i18n, fiche, premier));
			}
		};
		return _Utils_ap(
			A2($elm$core$List$map, coherence, $author$project$Catalogue$Vocabulaire$criteresDeCoherence),
			A2(
				$elm$core$List$map,
				function (m) {
					return A2(
						ligne,
						false,
						A3($author$project$Components$Produits$Reference$View$texteDuManque, i18n, fiche, m));
				},
				manquesDeChamp));
	});
var $author$project$Components$Produits$Reference$Model$idDeLaCompletude = 'section-completude';
var $author$project$I18n$Cles$produitsReferenceCompletudeHorsLimitesDepuis = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.completude.hors-limites-depuis',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm)),
					_Utils_Tuple2(
					'limite',
					$author$project$I18n$Traductions$Chaine(p.nV)),
					_Utils_Tuple2(
					'jour',
					$author$project$I18n$Traductions$Chaine(p.A_))
				]),
			' : valeur hors limites. ' + (p.fm + (' saisis, la limite est ' + (p.nV + (' depuis le ' + (p.A_ + '.'))))));
	});
var $author$project$I18n$Cles$produitsReferenceCompletudeHorsLimitesSansDate = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.completude.hors-limites-sans-date',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm)),
					_Utils_Tuple2(
					'limite',
					$author$project$I18n$Traductions$Chaine(p.nV))
				]),
			' : valeur hors limites. ' + (p.fm + (' saisis, la limite est ' + (p.nV + '.'))));
	});
var $author$project$Components$Produits$Reference$View$horsLimitesDuChamp = F3(
	function (i18n, fiche, cle) {
		var champ = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.dy;
					},
					$elm$core$Basics$eq(cle)),
				fiche.r0.dw));
		var limite = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$Shared$EditeurDeSchema$Limites$limiteDe(i18n),
				champ));
		var valeur = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (c) {
					return A3($author$project$Components$Shared$EditeurDeSchema$Limites$valeurDe, i18n, c, fiche.Ki);
				},
				champ));
		return A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$href(
							'#' + A2($author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$idDuChamp, $author$project$Components$Produits$Reference$Model$prefixeDesChamps, cle))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$elm$core$Maybe$withDefault,
								cle,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.Bl;
									},
									champ)))
						])),
					$rtfeldman$elm_css$Html$Styled$text(
					function () {
						var _v0 = A2($elm$core$Dict$get, cle, fiche.Am);
						if (!_v0.$) {
							var jour = _v0.a;
							return A2(
								$author$project$I18n$Cles$produitsReferenceCompletudeHorsLimitesDepuis,
								i18n,
								{
									A_: A2($author$project$Texte$Jour$enFrancais, i18n, jour),
									nV: limite,
									fm: valeur
								});
						} else {
							return A2(
								$author$project$I18n$Cles$produitsReferenceCompletudeHorsLimitesSansDate,
								i18n,
								{nV: limite, fm: valeur});
						}
					}())
				]));
	});
var $author$project$I18n$Cles$produitsReferenceCompletudeHorsLimitesCompte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.completude.hors-limites-compte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' manque') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' manques'));
	});
var $author$project$I18n$Cles$produitsReferenceCompletudeNonPubliableSuite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.completude.non-publiable-suite', _List_Nil, ' tant que ce manque n’est pas corrigé. Le produit reste enregistrable : vous pouvez le modifier et l’enregistrer.');
};
var $author$project$I18n$Cles$produitsReferenceNonPubliable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.non-publiable', _List_Nil, 'Non publiable');
};
var $author$project$Components$Produits$Reference$View$nonPubliable = F2(
	function (i18n, fiche) {
		var _v0 = $author$project$Components$Produits$Reference$View$horsLimites(fiche);
		if (!_v0.b) {
			return _List_Nil;
		} else {
			var cles = _v0;
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('hors-limites-compte')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$produitsReferenceCompletudeHorsLimitesCompte,
										i18n,
										{
											w: $elm$core$List$length(cles)
										}))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('note', true),
									_Utils_Tuple2('erreur', true),
									_Utils_Tuple2('hors-limites', true)
								])),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'note')
						]),
					A2(
						$elm$core$List$map,
						A2($author$project$Components$Produits$Reference$View$horsLimitesDuChamp, i18n, fiche),
						cles)),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('note', true),
									_Utils_Tuple2('avertissement', true),
									_Utils_Tuple2('non-publiable', true)
								])),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'note')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsReferenceNonPubliable(i18n))
								])),
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsReferenceCompletudeNonPubliableSuite(i18n))
						]))
				]);
		}
	});
var $author$project$I18n$Cles$produitsReferenceCompletudeTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.completude.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'compte',
					$author$project$I18n$Traductions$Chaine(p.vW))
				]),
			'Complétude ' + p.vW);
	});
var $author$project$I18n$Cles$produitsReferenceFicheCompte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.fiche.compte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'remplis',
					$author$project$I18n$Traductions$Chaine(p.HB)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			p.HB + (' / ' + p.JE));
	});
var $author$project$I18n$Cles$produitsReferencesFiltreCompletude = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.filtre.completude', _List_Nil, 'Complétude');
};
var $author$project$Components$Produits$Reference$View$completude = F2(
	function (i18n, fiche) {
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Reference$Model$idDeLaCompletude),
					$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1)
				]),
			{
				fw: _List_Nil,
				fZ: _Utils_ap(
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('criteres')
								]),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A2($author$project$Components$Produits$Reference$View$criteres, i18n, fiche),
									fiche.fU)))
						]),
					A2($author$project$Components$Produits$Reference$View$nonPubliable, i18n, fiche)),
				Dj: 'completude',
				h6: A2(
					$elm$core$Maybe$withDefault,
					$author$project$I18n$Cles$produitsReferencesFiltreCompletude(i18n),
					A2(
						$elm$core$Maybe$map,
						function (lue) {
							return A2(
								$author$project$I18n$Cles$produitsReferenceCompletudeTitre,
								i18n,
								{
									vW: A2(
										$author$project$I18n$Cles$produitsReferenceFicheCompte,
										i18n,
										{
											HB: $elm$core$String$fromInt(lue.HB),
											JE: $elm$core$String$fromInt(lue.JE)
										})
								});
						},
						fiche.fU))
			});
	});
var $author$project$Catalogue$Vocabulaire$couleurDEtat = function (code) {
	switch (code) {
		case 'actif':
			return 0;
		case 'conception':
			return 1;
		case 'prototype':
			return 1;
		case 'homologation':
			return 5;
		case 'fin-de-serie':
			return 2;
		default:
			return 3;
	}
};
var $author$project$Components$Produits$Common$Etat$couleur = function (code) {
	return $author$project$Catalogue$Vocabulaire$couleurDEtat(
		$author$project$Catalogue$Identifiants$etatCodeToString(code));
};
var $author$project$Components$Produits$Reference$Model$CodeDeVariante = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$Reference$Update$DeLaSaisie = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Produits$Reference$Update$DrawerValide = {$: 19};
var $author$project$Components$Produits$Reference$Update$EtatChoisi = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Produits$Reference$Model$EtatDeVariante = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$Reference$Model$NomDeVariante = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$Reference$Update$VarianteSaisie = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Produits$Reference$Model$aTraduire = F2(
	function (fiche, langue) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.B5;
					},
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$filter(
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.nn;
								},
								$elm$core$Basics$eq(
									$elm$core$Maybe$Just(langue)))),
						$elm$core$List$length)),
				fiche.fU));
	});
var $author$project$Components$Produits$Reference$View$articlesEnDrawer = function (propose) {
	if (!propose.$) {
		var lu = propose.a;
		return {fs: lu.fs, fZ: lu.fZ, A6: $elm$core$Maybe$Nothing, Bc: true, h6: lu.h6};
	} else {
		return {
			fs: {sR: false, Bl: '', C$: $author$project$Components$Produits$Reference$Update$DrawerValide},
			fZ: _List_Nil,
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: ''
		};
	}
};
var $author$project$Components$Produits$Reference$Update$CreationDUnPerimetreDemandee = {$: 46};
var $author$project$Components$Produits$Reference$Update$PerimetreSelectionne = function (a) {
	return {$: 45, a: a};
};
var $author$project$Components$Produits$Reference$Update$TermeDePerimetreSaisi = function (a) {
	return {$: 43, a: a};
};
var $author$project$I18n$Cles$produitsReferenceLiensArchivesNonProposes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.archives-non-proposes', _List_Nil, 'Les périmètres archivés ne sont pas proposés.');
};
var $author$project$I18n$Cles$produitsReferenceLiensArchivesTrouves = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.liens.archives-trouves',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w)),
					_Utils_Tuple2(
					'terme',
					$author$project$I18n$Traductions$Chaine(p.h3))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' périmètre correspond à « ' + (p.h3 + ' » mais est archivé.'))) : (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' périmètres correspondent à « ' + (p.h3 + ' » mais sont archivés.'))));
	});
var $author$project$Components$Produits$Reference$ArticlesView$noteDesArchives = F3(
	function (i18n, terme, trouves) {
		return (($elm$core$String$trim(terme) !== '') && (trouves > 0)) ? A2(
			$author$project$I18n$Cles$produitsReferenceLiensArchivesTrouves,
			i18n,
			{
				w: trouves,
				h3: $elm$core$String$trim(terme)
			}) : $author$project$I18n$Cles$produitsReferenceLiensArchivesNonProposes(i18n);
	});
var $author$project$Components$Produits$Reference$ArticlesView$pointille = F2(
	function (attributs, libelle) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
					attributs)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						]))
				]));
	});
var $author$project$I18n$Cles$produitsReferenceLiensAucunPerimetre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.aucun-perimetre', _List_Nil, 'Aucun périmètre d\'offre');
};
var $author$project$I18n$Cles$produitsReferenceLiensAucunPerimetreAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.aucun-perimetre-aide', _List_Nil, 'Un périmètre dit quelles références du catalogue sont concernées. Aucun n\'existe dans cet espace : créez-en un à partir d\'un filtre du catalogue.');
};
var $author$project$I18n$Cles$produitsReferenceLiensChoisirCePerimetre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.choisir-ce-perimetre', _List_Nil, 'Choisir ce périmètre');
};
var $author$project$I18n$Cles$produitsReferenceLiensChoisirUnPerimetre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.choisir-un-perimetre', _List_Nil, 'Choisir un périmètre');
};
var $author$project$I18n$Cles$produitsReferenceLiensCreerDUnFiltre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.creer-d-un-filtre', _List_Nil, 'Créer un périmètre à partir d\'un filtre');
};
var $author$project$I18n$Cles$produitsReferenceLiensPerimetreChoisiNote = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.liens.perimetre-choisi-note',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' article aujourd\'hui. Ajouter un périmètre n\'enregistre rien : « Enregistrer » se fait dans le drawer précédent.') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' articles aujourd\'hui. Ajouter un périmètre n\'enregistre rien : « Enregistrer » se fait dans le drawer précédent.'));
	});
var $author$project$I18n$Cles$produitsReferenceLiensPerimetreDecompte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.liens.perimetre-decompte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' article') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' articles'));
	});
var $author$project$I18n$Cles$produitsReferenceLiensRechercherUnPerimetre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.rechercher-un-perimetre', _List_Nil, 'Rechercher un périmètre');
};
var $author$project$Components$Produits$Common$ChoixDUnPerimetre$proposables = $elm$core$List$filter(
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.tE;
		},
		$elm$core$Basics$not));
var $author$project$Components$Produits$Reference$ArticlesView$resume = function (segments) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$span,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('criteres')
			]),
		A2(
			$elm$core$List$map,
			function (segment) {
				return segment.dX ? A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(segment.Jx)
						])) : A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(segment.Jx)
						]));
			},
			segments));
};
var $author$project$Components$Produits$Reference$ArticlesView$choisirUnPerimetre = F2(
	function (i18n, model) {
		var terme = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.h3;
				},
				model.fO));
		var proposes = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.pg;
					},
					$author$project$Components$Produits$Common$ChoixDUnPerimetre$proposables),
				model.cl));
		var creation = A2(
			$author$project$Components$Produits$Reference$ArticlesView$pointille,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Reference$Update$CreationDUnPerimetreDemandee),
					$rtfeldman$elm_css$Html$Styled$Attributes$id('creer-un-perimetre')
				]),
			$author$project$I18n$Cles$produitsReferenceLiensCreerDUnFiltre(i18n));
		var choisi = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.vd;
			},
			model.fO);
		var encartDuChoisi = A2(
			$elm$core$Maybe$withDefault,
			$rtfeldman$elm_css$Html$Styled$text(''),
			A2(
				$elm$core$Maybe$map,
				function (lu) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('perimetre-choisi')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(lu.Dj)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$produitsReferenceLiensPerimetreChoisiNote,
											i18n,
											{w: lu.wT}))
									]))
							]));
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (lu) {
							return _Utils_eq(
								$elm$core$Maybe$Just(lu.Aq),
								choisi);
						},
						proposes))));
		var lignePerimetre = function (lu) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$li,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'selectionne',
								_Utils_eq(
									$elm$core$Maybe$Just(lu.Aq),
									choisi))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('perimetre-propose')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$input,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
										$rtfeldman$elm_css$Html$Styled$Attributes$name('perimetre-a-choisir'),
										$rtfeldman$elm_css$Html$Styled$Attributes$checked(
										_Utils_eq(
											$elm$core$Maybe$Just(lu.Aq),
											choisi)),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Produits$Reference$Update$PerimetreSelectionne(lu.Aq))
									]),
								_List_Nil),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('main')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$strong,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('title')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(lu.Dj)
											])),
										$author$project$Components$Produits$Reference$ArticlesView$resume(lu.wp)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('infos')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$produitsReferenceLiensPerimetreDecompte,
											i18n,
											{w: lu.wT}))
									]))
							]))
					]));
		};
		return {
			fs: {
				sR: !_Utils_eq(choisi, $elm$core$Maybe$Nothing),
				Bl: $author$project$I18n$Cles$produitsReferenceLiensChoisirCePerimetre(i18n),
				C$: $author$project$Components$Produits$Reference$Update$DrawerValide
			},
			fZ: ($elm$core$List$isEmpty(proposes) && ((terme === '') && (!_Utils_eq(model.cl, $elm$core$Maybe$Nothing)))) ? _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsReferenceLiensAucunPerimetre(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsReferenceLiensAucunPerimetreAide(i18n))
								])),
							creation
						]))
				]) : _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Champ$View$texte,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: 'terme-de-perimetre',
						Bl: $author$project$I18n$Cles$produitsReferenceLiensRechercherUnPerimetre(i18n),
						he: false
					},
					{hg: $author$project$Components$Produits$Reference$Update$TermeDePerimetreSaisi, fm: terme}),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('perimetres')
						]),
					A2($elm$core$List$map, lignePerimetre, proposes)),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A3(
								$author$project$Components$Produits$Reference$ArticlesView$noteDesArchives,
								i18n,
								terme,
								A2(
									$elm$core$Maybe$withDefault,
									0,
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.i1;
										},
										model.cl))))
						])),
					encartDuChoisi,
					creation
				]),
			h6: $author$project$I18n$Cles$produitsReferenceLiensChoisirUnPerimetre(i18n)
		};
	});
var $author$project$Components$Produits$Common$ChoixDArticles$plage = function (choix) {
	return A2(
		$elm$core$Maybe$andThen,
		function (trouvees) {
			var _v0 = $elm$core$List$length(trouvees.hD);
			if (!_v0) {
				return $elm$core$Maybe$Nothing;
			} else {
				var affichees = _v0;
				var debut = ((choix.EE - 1) * $author$project$Components$Produits$Common$ChoixDArticles$tailleDePage) + 1;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(debut, (debut + affichees) - 1));
			}
		},
		choix.fg);
};
var $author$project$I18n$Cles$produitsReferenceLiensRechercheIndisponible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.recherche-indisponible', _List_Nil, 'La recherche n\'a pas abouti.');
};
var $author$project$I18n$Cles$produitsReferenceLiensTotal = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.liens.total',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' article correspond') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' articles correspondent'));
	});
var $author$project$I18n$Cles$produitsReferenceLiensTotalAffiches = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.liens.total-affiches',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w)),
					_Utils_Tuple2(
					'debut',
					$author$project$I18n$Traductions$Chaine(p.ku)),
					_Utils_Tuple2(
					'fin',
					$author$project$I18n$Traductions$Chaine(p.mI))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' article correspond · ' + (p.ku + ('–' + (p.mI + ' affichés'))))) : (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' articles correspondent · ' + (p.ku + ('–' + (p.mI + ' affichés'))))));
	});
var $author$project$Components$Produits$Common$ChoixDArticlesView$compte = F3(
	function (i18n, lu, total) {
		if (lu.AJ) {
			return $author$project$I18n$Cles$produitsReferenceLiensRechercheIndisponible(i18n);
		} else {
			var _v0 = $author$project$Components$Produits$Common$ChoixDArticles$plage(lu);
			if (!_v0.$) {
				var _v1 = _v0.a;
				var debut = _v1.a;
				var fin = _v1.b;
				return A2(
					$author$project$I18n$Cles$produitsReferenceLiensTotalAffiches,
					i18n,
					{
						ku: $elm$core$String$fromInt(debut),
						mI: $elm$core$String$fromInt(fin),
						w: total
					});
			} else {
				return A2(
					$author$project$I18n$Cles$produitsReferenceLiensTotal,
					i18n,
					{w: total});
			}
		}
	});
var $author$project$I18n$Cles$produitsReferenceLiensFiltreEtageFamille = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.filtre-etage-famille', _List_Nil, 'Étage · Famille');
};
var $author$project$I18n$Cles$produitsReferenceLiensFiltreTous = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.filtre-tous', _List_Nil, 'Tous');
};
var $author$project$Components$Produits$Common$ChoixDArticlesView$groupeDeFiltres = F3(
	function (i18n, messages, _v0) {
		var groupe = _v0.m2;
		var legende = _v0.Bi;
		var options = _v0.o_;
		var cochees = _v0.vv;
		var nomDuGroupe = function () {
			switch (groupe) {
				case 0:
					return 'famille';
				case 1:
					return 'categorie';
				case 2:
					return 'marques';
				case 3:
					return 'gammes';
				case 4:
					return 'typologie';
				default:
					return 'etat';
			}
		}();
		var libelle = function () {
			if (!groupe) {
				return $author$project$I18n$Cles$produitsReferenceLiensFiltreEtageFamille(i18n);
			} else {
				return legende;
			}
		}();
		return A2(
			$author$project$Components$Shared$Champ$View$liste,
			{go: $elm$core$Maybe$Nothing, Aq: 'articles-filtre-' + nomDuGroupe, Bl: libelle, he: false},
			{
				hg: messages.mE(groupe),
				o_: A2(
					$elm$core$List$cons,
					{
						Bl: $author$project$I18n$Cles$produitsReferenceLiensFiltreTous(i18n),
						fm: ''
					},
					A2(
						$elm$core$List$map,
						function (option) {
							return {
								Bl: A2($author$project$I18n$Cles$texte, i18n, option.Dj),
								fm: option.Aq
							};
						},
						options)),
				fm: A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(cochees))
			});
	});
var $author$project$Components$Produits$Common$ChoixDArticles$ParCategorie = 1;
var $author$project$Components$Produits$Common$ChoixDArticles$ParEtat = 5;
var $author$project$Components$Produits$Common$ChoixDArticles$ParFamille = 0;
var $author$project$Components$Produits$Common$ChoixDArticles$ParGamme = 3;
var $author$project$Components$Produits$Common$ChoixDArticles$ParMarque = 2;
var $author$project$Components$Produits$Common$ChoixDArticles$ParTypologie = 4;
var $author$project$Components$Produits$Common$ChoixDArticlesView$groupesDeFiltres = F4(
	function (i18n, catalogue, model, lu) {
		var facettes = A2($author$project$Components$Produits$Common$Facettes$depuis, catalogue, model.r7);
		var etats = A2(
			$elm$core$List$map,
			function (etat) {
				return {
					Aq: $author$project$Catalogue$Identifiants$etatCodeToString(etat.vx),
					Dj: A2(
						$elm$core$Maybe$withDefault,
						$author$project$Catalogue$Vocabulaire$etat(
							$author$project$Catalogue$Identifiants$etatCodeToString(etat.vx)),
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.zX;
								},
								$author$project$I18n$Traductions$tel),
							etat.R)),
					hl: _List_Nil
				};
			},
			catalogue.mj);
		var groupes = _List_fromArray(
			[
				{
				vv: lu.mu,
				m2: 0,
				Bi: $author$project$I18n$Cles$produitsReferencesListeFiltreFamille(i18n),
				o_: facettes.mu
			},
				{
				vv: lu.dt,
				m2: 1,
				Bi: $author$project$I18n$Cles$produitsReferencesListeFiltreCategorie(i18n),
				o_: A2($author$project$Components$Produits$Common$Facettes$categoriesVisibles, lu.mu, facettes)
			},
				{
				vv: lu.cU,
				m2: 2,
				Bi: $author$project$I18n$Cles$produitsReferencesListeFiltreMarque(i18n),
				o_: facettes.cU
			},
				{
				vv: lu.gG,
				m2: 3,
				Bi: $author$project$I18n$Cles$produitsReferencesListeFiltreGamme(i18n),
				o_: A2($author$project$Components$Produits$Common$Facettes$gammesVisibles, lu.cU, facettes)
			},
				{
				vv: lu.r7,
				m2: 4,
				Bi: $author$project$I18n$Cles$produitsReferencesListeFiltreTypologie(i18n),
				o_: facettes.r7
			},
				{
				vv: lu.mj,
				m2: 5,
				Bi: $author$project$I18n$Cles$produitsReferencesListeFiltreEtat(i18n),
				o_: etats
			}
			]);
		return groupes;
	});
var $author$project$Components$Produits$Common$ChoixDArticlesView$listeDeroulante = function (groupe) {
	return A2(
		$elm$core$List$member,
		groupe,
		_List_fromArray(
			[0, 2, 4, 5]));
};
var $author$project$Components$Produits$Common$ChoixDArticles$filtresPoses = function (choix) {
	return _Utils_ap(
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$pair(4),
			choix.r7),
		_Utils_ap(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$pair(2),
				choix.cU),
			_Utils_ap(
				A2(
					$elm$core$List$map,
					$elm$core$Tuple$pair(3),
					choix.gG),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$pair(0),
						choix.mu),
					_Utils_ap(
						A2(
							$elm$core$List$map,
							$elm$core$Tuple$pair(1),
							choix.dt),
						A2(
							$elm$core$List$map,
							$elm$core$Tuple$pair(5),
							choix.mj))))));
};
var $author$project$Components$Produits$Common$ChoixDArticlesView$pastilles = F4(
	function (i18n, messages, optionsDe, lu) {
		var posees = $author$project$Components$Produits$Common$ChoixDArticles$filtresPoses(lu);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('filtres-actifs')
				]),
			$elm$core$List$isEmpty(posees) ? _List_Nil : _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (_v0) {
							var identite = _v0.a;
							var id = _v0.b;
							var _v1 = optionsDe(identite);
							var legende = _v1.a;
							var options = _v1.b;
							var nom = A2(
								$author$project$I18n$Cles$annuaireFiltreActif,
								i18n,
								{
									zH: legende,
									fm: A2(
										$author$project$I18n$Cles$texte,
										i18n,
										A2($author$project$Components$Produits$Common$Facettes$nomDe, options, id))
								});
							var retirer = A2(
								$author$project$I18n$Cles$annuaireFiltreRetirer,
								i18n,
								{zH: nom});
							return A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$button,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('filtre-actif'),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', retirer),
												$rtfeldman$elm_css$Html$Styled$Attributes$title(retirer),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												A2(messages.mD, identite, id))
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(nom)
													])),
												$author$project$Components$Shared$Svg$svgClose
											]))
									]));
						},
						posees))
				]));
	});
var $author$project$Components$Produits$Common$ChoixDArticlesView$filtres = F4(
	function (i18n, model, messages, lu) {
		var _v0 = model.jB;
		if (_v0.$ === 1) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('filtres')
					]),
				_List_Nil);
		} else {
			var catalogue = _v0.a;
			var groupes = A4($author$project$Components$Produits$Common$ChoixDArticlesView$groupesDeFiltres, i18n, catalogue, model, lu);
			var optionsDe = function (identite) {
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2('', _List_Nil),
					A2(
						$elm$core$Maybe$map,
						function (g) {
							return _Utils_Tuple2(g.Bi, g.o_);
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.m2;
									},
									$elm$core$Basics$eq(identite)),
								groupes))));
			};
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('filtres')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('groupes')
							]),
						A2(
							$elm$core$List$map,
							A2($author$project$Components$Produits$Common$ChoixDArticlesView$groupeDeFiltres, i18n, messages),
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.m2;
									},
									$author$project$Components$Produits$Common$ChoixDArticlesView$listeDeroulante),
								groupes))),
						A4($author$project$Components$Produits$Common$ChoixDArticlesView$pastilles, i18n, messages, optionsDe, lu)
					]));
		}
	});
var $author$project$I18n$Cles$produitsReferenceLiensBientot = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.bientot', _List_Nil, 'bientôt');
};
var $author$project$I18n$Cles$produitsReferenceLiensPage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.liens.page',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'page',
					$author$project$I18n$Traductions$Chaine(p.EE)),
					_Utils_Tuple2(
					'pages',
					$author$project$I18n$Traductions$Chaine(p.EG))
				]),
			'Page ' + (p.EE + (' sur ' + p.EG)));
	});
var $author$project$I18n$Cles$produitsReferenceLiensPerimetre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.perimetre', _List_Nil, 'Créer un périmètre à partir de ce filtre');
};
var $author$project$I18n$Cles$produitsReferenceLiensPerimetreAideFiltre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.perimetre-aide-filtre', _List_Nil, 'Plus de 200 résultats ? Pas de « tout sélectionner » : créez un périmètre à partir de ce filtre. Les articles choisis un par un se limitent à la page cochée.');
};
var $author$project$I18n$Cles$produitsReferenceLiensPrecedent = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.precedent', _List_Nil, 'Précédent');
};
var $author$project$I18n$Cles$produitsReferenceLiensSuivant = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.suivant', _List_Nil, 'Suivant');
};
var $author$project$I18n$Cles$produitsReferenceLiensTerme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.terme', _List_Nil, 'Rechercher un article');
};
var $author$project$Components$Produits$Common$ChoixDArticles$aCocher = F2(
	function (deja, trouvee) {
		return (!trouvee.tL) && (!A2($elm$core$List$member, trouvee.Aq, deja));
	});
var $author$project$Components$Produits$Common$ChoixDArticlesView$libelleDeLEtat = F3(
	function (i18n, etats, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2(
				$author$project$I18n$Cles$texte,
				i18n,
				$author$project$Catalogue$Vocabulaire$etat(code)),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.zX;
				},
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.R;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.vx;
								},
								A2(
									$elm$core$Basics$composeR,
									$author$project$Catalogue$Identifiants$etatCodeToString,
									$elm$core$Basics$eq(code))),
							etats)))));
	});
var $author$project$I18n$Cles$produitsReferenceLiensArrete = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.arrete', _List_Nil, '(arrêté)');
};
var $author$project$I18n$Cles$produitsReferenceLiensSelectionner = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.liens.selectionner',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Sélectionner ' + p.Dj);
	});
var $author$project$Components$Produits$Common$ChoixDArticlesView$resultat = F6(
	function (i18n, model, messages, deja, lu, trouvee) {
		var liee = A2($elm$core$List$member, trouvee.Aq, deja);
		var etat = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (catalogue) {
					return A3($author$project$Components$Produits$Common$ChoixDArticlesView$libelleDeLEtat, i18n, catalogue.mj, trouvee.gt);
				},
				model.jB));
		var categorie = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.zX;
				},
				trouvee.uK));
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('resultat'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					trouvee.tL ? $author$project$Catalogue$Vocabulaire$etatArrete : 'disponible')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('case')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
									$rtfeldman$elm_css$Html$Styled$Attributes$checked(
									liee || A2($elm$core$List$member, trouvee.Aq, lu.at)),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
									!A2($author$project$Components$Produits$Common$ChoixDArticles$aCocher, deja, trouvee)),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									A2(
										$author$project$I18n$Cles$produitsReferenceLiensSelectionner,
										i18n,
										{
											Dj: $author$project$Components$Produits$Common$ChoixDArticles$nomDe(trouvee)
										})),
									$rtfeldman$elm_css$Html$Styled$Events$onCheck(
									messages.i5(trouvee.Aq))
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('main')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('title')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Components$Produits$Common$ChoixDArticles$nomDe(trouvee))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('infos')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$elm$core$String$join,
										' · ',
										A2(
											$elm$core$List$filter,
											A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
											_List_fromArray(
												[trouvee.vx, categorie]))))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('etat')
						]),
					_List_fromArray(
						[
							trouvee.tL ? A2(
							$author$project$Components$Shared$Tag$View$view,
							1,
							$author$project$I18n$Cles$produitsReferenceLiensArrete(i18n)) : A2($author$project$Components$Shared$Tag$View$view, 0, etat)
						]))
				]));
	});
var $author$project$Components$Produits$Common$ChoixDArticlesView$contenu = F5(
	function (i18n, model, messages, deja, lu) {
		var total = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.JE;
				},
				lu.fg));
		var pages = A2(
			$elm$core$Basics$max,
			1,
			$elm$core$Basics$ceiling(total / $author$project$Components$Produits$Common$ChoixDArticles$tailleDePage));
		var lignes = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.hD;
				},
				lu.fg));
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Champ$View$texte,
				{
					go: $elm$core$Maybe$Nothing,
					Aq: $author$project$Components$Produits$Common$ChoixDArticles$idDuChoix + '-terme',
					Bl: $author$project$I18n$Cles$produitsReferenceLiensTerme(i18n),
					he: false
				},
				{hg: messages.rC, fm: lu.h3}),
				A4($author$project$Components$Produits$Common$ChoixDArticlesView$filtres, i18n, model, messages, lu),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('count'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A3($author$project$Components$Produits$Common$ChoixDArticlesView$compte, i18n, lu, total))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('resultats')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$tbody,
						_List_Nil,
						A2(
							$elm$core$List$map,
							A5($author$project$Components$Produits$Common$ChoixDArticlesView$resultat, i18n, model, messages, deja, lu),
							lignes))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('pagination')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
								messages.EE(lu.EE - 1)),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(lu.EE <= 1)
								])),
						$author$project$I18n$Cles$produitsReferenceLiensPrecedent(i18n)),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$produitsReferenceLiensPage,
									i18n,
									{
										EE: $elm$core$String$fromInt(lu.EE),
										EG: $elm$core$String$fromInt(pages)
									}))
							])),
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
								messages.EE(lu.EE + 1)),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
									_Utils_cmp(lu.EE, pages) > -1)
								])),
						$author$project$I18n$Cles$produitsReferenceLiensSuivant(i18n))
					])),
				function () {
				var _v0 = messages.kl;
				if (!_v0.$) {
					var creer = _v0.a;
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('perimetre')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsReferenceLiensPerimetreAideFiltre(i18n))
									])),
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick(creer),
										$rtfeldman$elm_css$Html$Styled$Attributes$id('creer-un-perimetre-depuis-le-filtre')
									]),
								$author$project$I18n$Cles$produitsReferenceLiensPerimetre(i18n))
							]));
				} else {
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('perimetre')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
									]),
								$author$project$I18n$Cles$produitsReferenceLiensPerimetre(i18n)),
								A2(
								$author$project$Components$Shared$Tag$View$view,
								3,
								$author$project$I18n$Cles$produitsReferenceLiensBientot(i18n))
							]));
				}
			}()
			]);
	});
var $author$project$Components$Produits$Reference$Update$ArticleCoche = F2(
	function (a, b) {
		return {$: 51, a: a, b: b};
	});
var $author$project$Components$Produits$Reference$Update$FiltreDArticlesBascule = F2(
	function (a, b) {
		return {$: 60, a: a, b: b};
	});
var $author$project$Components$Produits$Reference$Update$FiltreDArticlesChoisi = F2(
	function (a, b) {
		return {$: 61, a: a, b: b};
	});
var $author$project$Components$Produits$Reference$Update$PageDArticles = function (a) {
	return {$: 52, a: a};
};
var $author$project$Components$Produits$Reference$Update$TermeDArticlesSaisi = function (a) {
	return {$: 50, a: a};
};
var $author$project$Components$Produits$Reference$ArticlesView$messages = {
	i5: $author$project$Components$Produits$Reference$Update$ArticleCoche,
	kl: $elm$core$Maybe$Just($author$project$Components$Produits$Reference$Update$CreationDUnPerimetreDemandee),
	mD: $author$project$Components$Produits$Reference$Update$FiltreDArticlesBascule,
	mE: $author$project$Components$Produits$Reference$Update$FiltreDArticlesChoisi,
	EE: $author$project$Components$Produits$Reference$Update$PageDArticles,
	rC: $author$project$Components$Produits$Reference$Update$TermeDArticlesSaisi
};
var $author$project$Components$Produits$Common$ChoixDArticles$nombreCoche = function (choix) {
	return $elm$core$List$length(choix.at);
};
var $author$project$I18n$Cles$produitsReferenceLiensAjouterN = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.liens.ajouter-n',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Ajouter ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' article')) : ('Ajouter ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' articles')));
	});
var $author$project$I18n$Cles$produitsReferenceLiensChoisirTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.choisir-titre', _List_Nil, 'Choisir des articles');
};
var $author$project$Components$Produits$Reference$ArticlesView$choix = F4(
	function (i18n, model, fiche, lu) {
		return {
			fs: {
				sR: $author$project$Components$Produits$Common$ChoixDArticles$nombreCoche(lu) > 0,
				Bl: A2(
					$author$project$I18n$Cles$produitsReferenceLiensAjouterN,
					i18n,
					{
						w: $author$project$Components$Produits$Common$ChoixDArticles$nombreCoche(lu)
					}),
				C$: $author$project$Components$Produits$Reference$Update$DrawerValide
			},
			fZ: A5(
				$author$project$Components$Produits$Common$ChoixDArticlesView$contenu,
				i18n,
				model,
				$author$project$Components$Produits$Reference$ArticlesView$messages,
				A2($author$project$Components$Produits$Reference$Model$articlesDuLien, fiche, lu.dy),
				lu),
			h6: $author$project$I18n$Cles$produitsReferenceLiensChoisirTitre(i18n)
		};
	});
var $author$project$Components$Produits$Reference$Model$choixAvecLesFiches = F2(
	function (model, fiche) {
		var proposees = function (visee) {
			return A2(
				$elm$core$List$map,
				function (p) {
					return {
						tI: false,
						Aq: p.r8,
						R: _List_fromArray(
							[
								_Utils_Tuple2('fr', p.Dj)
							])
					};
				},
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$second,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Tuple$first,
									$elm$core$Basics$eq(visee)),
								model.Gw)))));
		};
		var choix = F2(
			function (cle, visee) {
				return {
					dy: cle,
					nW: '',
					Ca: false,
					Fk: false,
					FS: false,
					hu: _List_Nil,
					pE: proposees(visee),
					al: $elm$core$Maybe$Nothing
				};
			});
		var deLaFiche = A2(
			$elm$core$List$filterMap,
			function (champ) {
				return A2(
					$elm$core$Maybe$map,
					choix(champ.dy),
					$author$project$Components$Produits$Reference$Model$typeViseDe(champ));
			},
			$author$project$Components$Produits$Reference$Model$champs(fiche));
		var desGroupes = A2(
			$elm$core$List$concatMap,
			function (champ) {
				return A2(
					$elm$core$List$filterMap,
					function (sous) {
						return A2(
							$elm$core$Maybe$map,
							choix(champ.dy + ('.' + sous.dy)),
							$author$project$Components$Produits$Reference$Model$typeViseDe(sous));
					},
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.IX;
							},
							$author$project$Components$Shared$EditeurDeSchema$Groupe$sousChampsDe(champ))));
			},
			$author$project$Components$Produits$Reference$Model$champs(fiche));
		return _Utils_ap(
			fiche.jN,
			_Utils_ap(deLaFiche, desGroupes));
	});
var $author$project$Components$Produits$Reference$Update$CodeApplique = function (a) {
	return {$: 33, a: a};
};
var $author$project$Components$Produits$Reference$Update$CodeSaisi = function (a) {
	return {$: 32, a: a};
};
var $author$project$I18n$Cles$produitsReferenceCodeEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.code.enregistrer', _List_Nil, 'Enregistrer le code');
};
var $author$project$I18n$Cles$produitsReferenceCodeNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.code.note', _List_Nil, 'Tapez le code voulu, ou laissez la règle du type le proposer. Le numéro attribué est gardé tant que le début du code ne change pas.');
};
var $author$project$Components$Produits$Reference$View$codeEnDrawer = F3(
	function (i18n, model, refus) {
		var saisi = $elm$core$String$trim(model.jY);
		var libre = !$author$project$Components$Produits$Common$Envoi$enCours(model.l2);
		return {
			fs: {
				sR: libre && ((saisi !== '') && (!_Utils_eq(
					saisi,
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.vx;
							},
							model.zo))))),
				Bl: $author$project$I18n$Cles$produitsReferenceCodeEnregistrer(i18n),
				C$: $author$project$Components$Produits$Reference$Update$CodeApplique(
					$elm$core$Maybe$Just(saisi))
			},
			fZ: _List_fromArray(
				[
					refus,
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsReferenceCodeNote(i18n))
						])),
					A2(
					$author$project$Components$Shared$Champ$View$texte,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: 'reference-code-saisi',
						Bl: $author$project$I18n$Cles$produitsReferencesCreationCode(i18n),
						he: true
					},
					{hg: $author$project$Components$Produits$Reference$Update$CodeSaisi, fm: model.jY})
				]),
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: $author$project$I18n$Cles$produitsReferenceCodeChanger(i18n)
		};
	});
var $author$project$Components$Produits$Reference$Update$NomDePerimetreSaisi = function (a) {
	return {$: 47, a: a};
};
var $author$project$Components$Produits$Common$ChoixDArticlesView$optionsDesFiltres = F4(
	function (i18n, model, lu, identite) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2('', _List_Nil),
			A2(
				$elm$core$Maybe$map,
				function (g) {
					return _Utils_Tuple2(g.Bi, g.o_);
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.m2;
							},
							$elm$core$Basics$eq(identite)),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (catalogue) {
									return A4($author$project$Components$Produits$Common$ChoixDArticlesView$groupesDeFiltres, i18n, catalogue, model, lu);
								},
								model.jB))))));
	});
var $author$project$I18n$Cles$produitsReferenceLiensCreationAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.creation-aide', _List_Nil, 'Après « Créer », le périmètre est ajouté à la valeur du champ. Ses critères se modifient ensuite depuis sa fiche (Paramétrage › Périmètres d\'offre).');
};
var $author$project$I18n$Cles$produitsReferenceLiensCreerDepuisUnFiltre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.creer-depuis-un-filtre', _List_Nil, 'Créer un périmètre à partir de ce filtre');
};
var $author$project$I18n$Cles$produitsReferenceLiensCreerLePerimetre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.creer-le-perimetre', _List_Nil, 'Créer le périmètre');
};
var $author$project$I18n$Cles$produitsReferenceLiensCriteresRepris = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.criteres-repris', _List_Nil, 'Critères du catalogue (repris du filtre)');
};
var $author$project$I18n$Cles$produitsReferenceLiensDecompteAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.decompte-aide', _List_Nil, 'Identique au nombre de résultats du filtre. Le périmètre suivra ensuite le catalogue : un article de plus dans la famille entre dans le périmètre.');
};
var $author$project$I18n$Cles$produitsReferenceLiensNomAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.nom-aide', _List_Nil, 'Dans la langue de référence (français). Les traductions viennent après la création.');
};
var $author$project$I18n$Cles$produitsReferenceLiensNomDuPerimetre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.nom-du-perimetre', _List_Nil, 'Nom du périmètre');
};
var $author$project$I18n$Cles$produitsReferenceLiensNomRequis = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.nom-requis', _List_Nil, 'Le nom du périmètre est obligatoire.');
};
var $author$project$I18n$Cles$produitsReferenceLiensRefusCritereInconnu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.refus-critere-inconnu', _List_Nil, 'Une valeur du filtre n\'est plus connue du catalogue. Rechargez le filtre, puis recommencez.');
};
var $author$project$I18n$Cles$produitsReferenceLiensRefusFiltreNonConvertible = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.liens.refus-filtre-non-convertible',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'Ce filtre ne peut pas devenir un périmètre : le critère « ' + (p.uN + ' » n\'en est pas un. Retirez-le du filtre, puis recommencez.'));
	});
var $author$project$I18n$Cles$produitsReferenceLiensRefusFiltreVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.refus-filtre-vide', _List_Nil, 'Le filtre est vide : posez au moins un critère avant de créer un périmètre.');
};
var $author$project$I18n$Cles$produitsReferenceLiensRefusNomPris = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.refus-nom-pris', _List_Nil, 'Ce nom de périmètre est déjà utilisé. Choisissez-en un autre.');
};
var $author$project$Components$Produits$Reference$ArticlesView$refusDeCreation = F2(
	function (i18n, refus) {
		switch (refus.$) {
			case 0:
				return $author$project$I18n$Cles$produitsReferenceLiensRefusNomPris(i18n);
			case 1:
				return $author$project$I18n$Cles$produitsReferenceLiensRefusFiltreVide(i18n);
			case 2:
				var champ = refus.a;
				return A2(
					$author$project$I18n$Cles$produitsReferenceLiensRefusFiltreNonConvertible,
					i18n,
					{uN: champ});
			default:
				return $author$project$I18n$Cles$produitsReferenceLiensRefusCritereInconnu(i18n);
		}
	});
var $author$project$Components$Produits$Reference$ArticlesView$creerUnPerimetre = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.wl, model.tP);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var creation = _v0.a.a;
			var filtre = _v0.b.a;
			return {
				fs: {
					sR: !$author$project$Components$Produits$Common$Envoi$enCours(model.l2),
					Bl: $author$project$I18n$Cles$produitsReferenceLiensCreerLePerimetre(i18n),
					C$: $author$project$Components$Produits$Reference$Update$DrawerValide
				},
				fZ: _List_fromArray(
					[
						function () {
						var _v1 = creation.pZ;
						if (!_v1.$) {
							var refus = _v1.a;
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('refus'),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$strong,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2($author$project$Components$Produits$Reference$ArticlesView$refusDeCreation, i18n, refus))
											]))
									]));
						} else {
							return $rtfeldman$elm_css$Html$Styled$text('');
						}
					}(),
						A2(
						$author$project$Components$Shared$Champ$View$texte,
						{
							go: (creation.b5 && ($elm$core$String$trim(creation.Dj) === '')) ? $elm$core$Maybe$Just(
								$author$project$I18n$Cles$produitsReferenceLiensNomRequis(i18n)) : $elm$core$Maybe$Nothing,
							Aq: $author$project$Components$Produits$Reference$Model$idDuNomDePerimetre,
							Bl: $author$project$I18n$Cles$produitsReferenceLiensNomDuPerimetre(i18n),
							he: true
						},
						{hg: $author$project$Components$Produits$Reference$Update$NomDePerimetreSaisi, fm: creation.Dj}),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsReferenceLiensNomAide(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$fieldset,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('criteres-repris')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$legend,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$produitsReferenceLiensCriteresRepris(i18n))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$ul,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (_v2) {
										var groupe = _v2.a;
										var id = _v2.b;
										var _v3 = A4($author$project$Components$Produits$Common$ChoixDArticlesView$optionsDesFiltres, i18n, model, filtre, groupe);
										var legende = _v3.a;
										var options = _v3.b;
										return A2(
											$rtfeldman$elm_css$Html$Styled$li,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(legende + ' = '),
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('jeton')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															A2(
																$author$project$I18n$Cles$texte,
																i18n,
																A2($author$project$Components$Produits$Common$Facettes$nomDe, options, id)))
														]))
												]));
									},
									$author$project$Components$Produits$Common$ChoixDArticles$filtresPoses(filtre)))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$produitsReferenceLiensPerimetreDecompte,
											i18n,
											{w: creation.wT}))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsReferenceLiensDecompteAide(i18n))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('encadree')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsReferenceLiensCreationAide(i18n))
							]))
					]),
				h6: $author$project$I18n$Cles$produitsReferenceLiensCreerDepuisUnFiltre(i18n)
			};
		} else {
			return {
				fs: {sR: false, Bl: '', C$: $author$project$Components$Produits$Reference$Update$DrawerValide},
				fZ: _List_Nil,
				h6: ''
			};
		}
	});
var $author$project$Components$Produits$Reference$Update$FichierAChoisir = {$: 65};
var $author$project$Components$Produits$Reference$Update$TexteAlternatifSaisi = F2(
	function (a, b) {
		return {$: 67, a: a, b: b};
	});
var $author$project$I18n$Cles$produitsReferenceFichiersDrawerAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fichiers.drawer-aucun', _List_Nil, 'Aucun fichier choisi.');
};
var $author$project$I18n$Cles$produitsReferenceFichiersDrawerChanger = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fichiers.drawer-changer', _List_Nil, 'Choisir un autre fichier');
};
var $author$project$I18n$Cles$produitsReferenceFichiersDrawerChoisi = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.fichiers.drawer-choisi',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Fichier choisi : ' + p.Dj);
	});
var $author$project$I18n$Cles$produitsReferenceFichiersDrawerChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fichiers.drawer-choisir', _List_Nil, 'Choisir un fichier');
};
var $author$project$I18n$Cles$produitsReferenceFichiersDrawerTitreDeposer = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.fichiers.drawer-titre-deposer',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'Déposer un fichier : ' + p.uN);
	});
var $author$project$I18n$Cles$produitsReferenceFichiersDrawerTitreRemplacer = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.fichiers.drawer-titre-remplacer',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'Remplacer le fichier : ' + p.uN);
	});
var $author$project$I18n$Cles$produitsReferenceFichiersDrawerTypes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.fichiers.drawer-types',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'types',
					$author$project$I18n$Traductions$Chaine(p.ib))
				]),
			'Types acceptés : ' + p.ib);
	});
var $author$project$I18n$Cles$produitsReferenceFichiersDrawerValiderDeposer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fichiers.drawer-valider-deposer', _List_Nil, 'Déposer le fichier');
};
var $author$project$I18n$Cles$produitsReferenceFichiersDrawerValiderRemplacer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fichiers.drawer-valider-remplacer', _List_Nil, 'Remplacer le fichier');
};
var $author$project$I18n$Cles$produitsReferenceFichiersTexteAlternatif = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.fichiers.texte-alternatif',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'langue',
					$author$project$I18n$Traductions$Chaine(p.nn))
				]),
			'Texte alternatif (' + (p.nn + ')'));
	});
var $author$project$I18n$Cles$produitsReferenceFichiersDepotEnCours = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.fichiers.depot-en-cours',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fait',
					$author$project$I18n$Traductions$Chaine(p.zf)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			'Dépôt en cours : morceau ' + (p.zf + (' sur ' + (p.JE + '.'))));
	});
var $author$project$Components$Produits$Reference$FichiersView$progression = F2(
	function (i18n, depot) {
		var _v0 = depot.me;
		switch (_v0.$) {
			case 1:
				var fait = _v0.a.zf;
				var total = _v0.a.JE;
				return A2(
					$author$project$I18n$Cles$produitsReferenceFichiersDepotEnCours,
					i18n,
					{
						zf: $elm$core$String$fromInt(fait),
						JE: $elm$core$String$fromInt(total)
					});
			case 2:
				var morceaux = _v0.a.CU;
				return A2(
					$author$project$I18n$Cles$produitsReferenceFichiersDepotEnCours,
					i18n,
					{
						zf: $elm$core$String$fromInt(morceaux),
						JE: $elm$core$String$fromInt(morceaux)
					});
			default:
				return '';
		}
	});
var $author$project$Components$Shared$Svg$svgFile = A3($author$project$Components$Shared$Svg$icone, 'file', 'M6 3h8l4 4v13a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM14 3v4h4M8.5 12h7M8.5 16h7', _List_Nil);
var $author$project$I18n$Cles$produitsReferenceFichiersChampNonFichier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fichiers.champ-non-fichier', _List_Nil, 'Ce champ n\'est pas un champ fichier : la fiche va être relue.');
};
var $author$project$I18n$Cles$produitsReferenceFichiersDepotIncomplet = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fichiers.depot-incomplet', _List_Nil, 'Le dépôt est incomplet : le fichier n\'est pas parvenu en entier. Choisissez-le de nouveau et déposez-le encore.');
};
var $author$project$I18n$Cles$produitsReferenceFichiersDepotsFermes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fichiers.depots-fermes', _List_Nil, 'Le dépôt de fichiers n\'est pas ouvert sur cet environnement.');
};
var $author$project$I18n$Cles$produitsReferenceFichiersFichierIndisponible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fichiers.fichier-indisponible', _List_Nil, 'Ce fichier n\'est pas disponible : il est refusé ou n\'est plus lisible. Choisissez-le de nouveau et déposez-le encore.');
};
var $author$project$I18n$Cles$produitsReferenceFichiersFichierTropGros = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fichiers.fichier-trop-gros', _List_Nil, 'Ce fichier est trop gros : 20 Mo au plus. Choisissez un autre fichier.');
};
var $author$project$I18n$Cles$produitsReferenceFichiersFichierVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fichiers.fichier-vide', _List_Nil, 'Le fichier est vide : choisissez un fichier qui contient des données.');
};
var $author$project$I18n$Cles$produitsReferenceFichiersTypeNonReconnu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fichiers.type-non-reconnu', _List_Nil, 'Ce type de fichier n\'est pas reconnu. Choisissez un PDF, un PNG, un JPEG, un GIF ou un WebP.');
};
var $author$project$I18n$Cles$produitsReferenceFichiersTypeRefuse = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.fichiers.type-refuse',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'types',
					$author$project$I18n$Traductions$Chaine(p.ib))
				]),
			'Ce champ n\'accepte pas ce type de fichier. Types acceptés : ' + (p.ib + '.'));
	});
var $author$project$Components$Produits$Reference$FichiersView$texteDuRefus = F3(
	function (i18n, types, refus) {
		switch (refus.$) {
			case 0:
				return $author$project$I18n$Cles$produitsReferenceFichiersTypeNonReconnu(i18n);
			case 1:
				return $author$project$I18n$Cles$produitsReferenceFichiersFichierVide(i18n);
			case 2:
				return $author$project$I18n$Cles$produitsReferenceFichiersFichierTropGros(i18n);
			case 3:
				return $author$project$I18n$Cles$produitsReferenceFichiersDepotIncomplet(i18n);
			case 4:
				return $author$project$I18n$Cles$produitsReferenceFichiersDepotsFermes(i18n);
			case 5:
				return A2(
					$author$project$I18n$Cles$produitsReferenceFichiersTypeRefuse,
					i18n,
					{
						ib: A2(
							$elm$core$String$join,
							', ',
							A2($elm$core$List$map, $author$project$Components$Produits$Reference$Fichiers$formatDuType, types))
					});
			case 6:
				return $author$project$I18n$Cles$produitsReferenceFichiersFichierIndisponible(i18n);
			default:
				return $author$project$I18n$Cles$produitsReferenceFichiersChampNonFichier(i18n);
		}
	});
var $author$project$Components$Produits$Reference$FichiersView$drawer = F4(
	function (i18n, model, fiche, cle) {
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.kX);
		var lu = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.dy;
					},
					$elm$core$Basics$eq(cle)),
				$author$project$Components$Produits$Reference$Fichiers$champsFichier(
					$author$project$Components$Produits$Reference$Model$champs(fiche))));
		var types = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.r1;
				},
				lu));
		var libelle = A2(
			$elm$core$Maybe$withDefault,
			cle,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				lu));
		var exige = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$second,
					function ($) {
						return $.Jz;
					}),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$eq(cle)),
						fiche.r0.CC))));
		var depot = A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$Components$Produits$Reference$Fichiers$nouveau, cle, false),
			model.xc);
		var enCours = !_Utils_eq(depot.me, $author$project$Components$Produits$Reference$Fichiers$Saisie);
		return {
			fs: {
				sR: (!_Utils_eq(depot.vd, $elm$core$Maybe$Nothing)) && (!enCours),
				Bl: depot.Hz ? $author$project$I18n$Cles$produitsReferenceFichiersDrawerValiderRemplacer(i18n) : $author$project$I18n$Cles$produitsReferenceFichiersDrawerValiderDeposer(i18n),
				C$: $author$project$Components$Produits$Reference$Update$DrawerValide
			},
			fZ: _Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('errors'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
							]),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (refus) {
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$li,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A3($author$project$Components$Produits$Reference$FichiersView$texteDuRefus, i18n, types, refus))
												]))
										]);
								},
								depot.pZ))),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$produitsReferenceFichiersDrawerTypes,
									i18n,
									{
										ib: A2(
											$elm$core$String$join,
											', ',
											A2($elm$core$List$map, $author$project$Components$Produits$Reference$Fichiers$formatDuType, types))
									}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('choix')
							]),
						_List_fromArray(
							[
								A4(
								$author$project$Components$Shared$Bouton$View$boutonAvecIcone,
								1,
								$author$project$Components$Shared$Svg$svgFile,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id(prefixe + '-choisir'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Reference$Update$FichierAChoisir)
									]),
								_Utils_eq(depot.vd, $elm$core$Maybe$Nothing) ? $author$project$I18n$Cles$produitsReferenceFichiersDrawerChoisir(i18n) : $author$project$I18n$Cles$produitsReferenceFichiersDrawerChanger(i18n)),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('choisi')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$elm$core$Maybe$withDefault,
											$author$project$I18n$Cles$produitsReferenceFichiersDrawerAucun(i18n),
											A2(
												$elm$core$Maybe$map,
												function (choisi) {
													return A2(
														$author$project$I18n$Cles$produitsReferenceFichiersDrawerChoisi,
														i18n,
														{Dj: choisi.Dj});
												},
												depot.vd)))
									]))
							]))
					]),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						function (langue) {
							return A2(
								$author$project$Components$Shared$Champ$View$texte,
								{
									go: $elm$core$Maybe$Nothing,
									Aq: prefixe + ('-texte-' + langue),
									Bl: A2(
										$author$project$I18n$Cles$produitsReferenceFichiersTexteAlternatif,
										i18n,
										{
											nn: A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$langue, i18n, langue)
										}),
									he: exige
								},
								{
									hg: $author$project$Components$Produits$Reference$Update$TexteAlternatifSaisi(langue),
									fm: A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$elm$core$Tuple$second,
											$elm$core$List$head(
												A2(
													$elm$core$List$filter,
													A2(
														$elm$core$Basics$composeR,
														$elm$core$Tuple$first,
														$elm$core$Basics$eq(langue)),
													depot.rF))))
								});
						},
						fiche.Ba),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('envoi'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Produits$Reference$FichiersView$progression, i18n, depot))
								]))
						]))),
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: depot.Hz ? A2(
				$author$project$I18n$Cles$produitsReferenceFichiersDrawerTitreRemplacer,
				i18n,
				{uN: libelle}) : A2(
				$author$project$I18n$Cles$produitsReferenceFichiersDrawerTitreDeposer,
				i18n,
				{uN: libelle})
		};
	});
var $author$project$Components$Produits$Reference$Update$DeLOccurrence = function (a) {
	return {$: 56, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$EnBoutons = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$Serie = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$boutonsDe = F3(
	function (langue, presentation, champ) {
		var retenues = function (options) {
			return ($elm$core$List$isEmpty(options) || ($elm$core$List$length(options) > 4)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(options);
		};
		var proposees = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (choix) {
					return A2(
						$elm$core$List$map,
						function (valeur) {
							return {
								vx: valeur.Aq,
								Bl: A2($author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$libelle, langue, valeur)
							};
						},
						$author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$montrees(choix));
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (choix) {
							return _Utils_eq(choix.dy, champ.dy) && ((!choix.FS) && (!choix.Ca));
						},
						presentation.jN))));
		var _v0 = champ.r0;
		switch (_v0.$) {
			case 7:
				var valeurs = _v0.a;
				return retenues(
					A2(
						$elm$core$List$map,
						function (v) {
							return {
								vx: v,
								Bl: A2(
									$elm$core$Maybe$withDefault,
									v,
									A3($author$project$Components$Shared$EditeurDeSchema$Champ$libelleDeLaValeur, langue, champ, v))
							};
						},
						valeurs));
			case 17:
				return retenues(proposees);
			case 21:
				return retenues(proposees);
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$blocs = F3(
	function (langue, presentation, champs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (champ, suite) {
					var _v0 = _Utils_Tuple2(
						A3($author$project$Components$Shared$EditeurDeSchema$Groupe$boutonsDe, langue, presentation, champ),
						suite);
					if (!_v0.a.$) {
						var options = _v0.a.a;
						return A2(
							$elm$core$List$cons,
							A2($author$project$Components$Shared$EditeurDeSchema$Groupe$EnBoutons, champ, options),
							suite);
					} else {
						if (_v0.b.b && (!_v0.b.a.$)) {
							var _v1 = _v0.a;
							var _v2 = _v0.b;
							var autres = _v2.a.a;
							var reste = _v2.b;
							return A2(
								$elm$core$List$cons,
								$author$project$Components$Shared$EditeurDeSchema$Groupe$Serie(
									A2($elm$core$List$cons, champ, autres)),
								reste);
						} else {
							var _v3 = _v0.a;
							return A2(
								$elm$core$List$cons,
								$author$project$Components$Shared$EditeurDeSchema$Groupe$Serie(
									_List_fromArray(
										[champ])),
								suite);
						}
					}
				}),
			_List_Nil,
			champs);
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$codesDeValeurEnDouble = _List_fromArray(
	['ValeurEnDouble', 'ValeurDeGroupeEnDouble']);
var $author$project$Components$Shared$EditeurDeSchema$Groupe$cleDuDoublon = function (brouillon) {
	return A2(
		$elm$core$List$any,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.vx;
			},
			$elm$core$Basics$eq('ValeurNonCreee')),
		brouillon.pZ) ? $elm$core$Maybe$Nothing : A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.IW;
		},
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (refus) {
					return A2($elm$core$List$member, refus.vx, $author$project$Components$Shared$EditeurDeSchema$Groupe$codesDeValeurEnDouble);
				},
				brouillon.pZ)));
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$coupeApres = F2(
	function (cle, champs) {
		var avant = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$second,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dy;
						},
						$elm$core$Basics$eq(cle))),
				A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, champs)));
		if (!avant.$) {
			var _v1 = avant.a;
			var rang = _v1.a;
			return _Utils_Tuple2(
				A2($elm$core$List$take, rang + 1, champs),
				A2($elm$core$List$drop, rang + 1, champs));
		} else {
			return _Utils_Tuple2(_List_Nil, champs);
		}
	});
var $author$project$I18n$Cles$groupeDeSousChampsNoteModification = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'groupe-de-sous-champs.note.modification', _List_Nil, 'Les champs reprennent la valeur actuelle de cette occurrence. Seuls ceux que vous changez sont enregistrés.');
};
var $author$project$I18n$Cles$groupeDeSousChampsNoteUnique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'groupe-de-sous-champs.note.unique', _List_Nil, 'Une seule valeur sur ce champ : la modifier remplace l\'actuelle.');
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$note = F2(
	function (i18n, brouillon) {
		var _v0 = _Utils_Tuple2(brouillon.r8, brouillon.HI);
		if (!_v0.a.$) {
			if (_v0.b) {
				return A2(
					$author$project$Components$Shared$Note$View$view,
					0,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$groupeDeSousChampsNoteModification(i18n))
						]));
			} else {
				return A2(
					$author$project$Components$Shared$Note$View$view,
					0,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$groupeDeSousChampsNoteUnique(i18n))
						]));
			}
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$groupeDeSousChampsRefusObligatoire = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.refus.obligatoire',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'sousChamp',
					$author$project$I18n$Traductions$Chaine(p.IW))
				]),
			'« ' + (p.IW + ' » est obligatoire.'));
	});
var $author$project$I18n$Cles$groupeDeSousChampsRefusObligatoires = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.refus.obligatoires',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'sousChamps',
					$author$project$I18n$Traductions$Chaine(p.IX))
				]),
			'Renseignez : ' + (p.IX + '. Les autres sous-champs restent facultatifs.'));
	});
var $author$project$I18n$Cles$groupeDeSousChampsRefusSansSousChamp = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.refus.sans-sous-champ',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'code',
					$author$project$I18n$Traductions$Chaine(p.vx))
				]),
			'Le serveur refuse l\'occurrence (' + (p.vx + ').'));
	});
var $author$project$I18n$Cles$groupeDeSousChampsRefusSousChamp = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.refus.sous-champ',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'sousChamp',
					$author$project$I18n$Traductions$Chaine(p.IW)),
					_Utils_Tuple2(
					'code',
					$author$project$I18n$Traductions$Chaine(p.vx))
				]),
			'Le serveur refuse « ' + (p.IW + (' » (' + (p.vx + ').'))));
	});
var $author$project$I18n$Cles$groupeDeSousChampsRefusTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'groupe-de-sous-champs.refus.titre', _List_Nil, 'L\'occurrence n\'est pas enregistrée.');
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$ValeurTapee = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$I18n$Cles$groupeDeSousChampsRefusValeurNonCreeeAction = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.refus.valeur-non-creee.action',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'sousChamp',
					$author$project$I18n$Traductions$Chaine(p.IW))
				]),
			'Choisir une valeur de la liste pour « ' + (p.IW + ' »'));
	});
var $author$project$I18n$Cles$groupeDeSousChampsRefusValeurNonCreeeExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'groupe-de-sous-champs.refus.valeur-non-creee.explication', _List_Nil, 'L\'occurrence n\'est pas enregistrée. Choisissez une valeur de la liste.');
};
var $author$project$I18n$Cles$groupeDeSousChampsRefusValeurNonCreeeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'groupe-de-sous-champs.refus.valeur-non-creee.titre', _List_Nil, 'La valeur tapée n\'a pas pu être créée dans la liste.');
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$valeurNonCreeeAffichee = F2(
	function (i18n, brouillon) {
		var libelleDe = function (cle) {
			return A2(
				$elm$core$Maybe$withDefault,
				cle,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Bl;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.dy;
								},
								$elm$core$Basics$eq(cle)),
							brouillon.IX))));
		};
		var issue = function (_v0) {
			var cle = _v0.a;
			var libelle = _v0.b;
			return A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						A2($author$project$Components$Shared$EditeurDeSchema$Groupe$ValeurTapee, cle, ''))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$groupeDeSousChampsRefusValeurNonCreeeAction,
									i18n,
									{
										IW: libelleDe(cle)
									}))
							]))
					]));
		};
		return A2(
			$author$project$Components$Shared$Note$View$view,
			1,
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$b,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$groupeDeSousChampsRefusValeurNonCreeeTitre(i18n))
						])),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$groupeDeSousChampsRefusValeurNonCreeeExplication(i18n))
							])),
					A2($elm$core$List$map, issue, brouillon.Z))));
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$refusAffiche = F2(
	function (i18n, brouillon) {
		var manquants = brouillon.b5 ? $author$project$Components$Shared$EditeurDeSchema$Groupe$obligatoiresManquants(brouillon) : _List_Nil;
		var libelleDe = function (cle) {
			return A2(
				$elm$core$Maybe$withDefault,
				cle,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Bl;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.dy;
								},
								$elm$core$Basics$eq(cle)),
							brouillon.IX))));
		};
		var ligneDeRefus = function (refus) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						(refus.vx === 'Obligatoire') ? A2(
							$author$project$I18n$Cles$groupeDeSousChampsRefusObligatoire,
							i18n,
							{
								IW: libelleDe(refus.IW)
							}) : ((refus.IW === '') ? A2(
							$author$project$I18n$Cles$groupeDeSousChampsRefusSansSousChamp,
							i18n,
							{vx: refus.vx}) : A2(
							$author$project$I18n$Cles$groupeDeSousChampsRefusSousChamp,
							i18n,
							{
								vx: refus.vx,
								IW: libelleDe(refus.IW)
							})))
					]));
		};
		return ($elm$core$List$isEmpty(brouillon.pZ) && $elm$core$List$isEmpty(manquants)) ? $rtfeldman$elm_css$Html$Styled$text('') : (A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.vx;
				},
				$elm$core$Basics$eq('ValeurNonCreee')),
			brouillon.pZ) ? A2($author$project$Components$Shared$EditeurDeSchema$Groupe$valeurNonCreeeAffichee, i18n, brouillon) : A2(
			$author$project$Components$Shared$Note$View$view,
			1,
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$b,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$groupeDeSousChampsRefusTitre(i18n))
						])),
				$elm$core$List$isEmpty(brouillon.pZ) ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$groupeDeSousChampsRefusObligatoires,
									i18n,
									{
										IX: A2($elm$core$String$join, ', ', manquants)
									}))
							]))
					]) : A2($elm$core$List$map, ligneDeRefus, brouillon.pZ))));
	});
var $author$project$I18n$Cles$groupeDeSousChampsValeurACreerLegende = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.valeur-a-creer.legende',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'sousChamp',
					$author$project$I18n$Traductions$Chaine(p.IW))
				]),
			'Autre valeur pour « ' + (p.IW + ' »'));
	});
var $author$project$I18n$Cles$groupeDeSousChampsValeurACreerNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'groupe-de-sous-champs.valeur-a-creer.note', _List_Nil, 'Liste ouverte : taper pour créer une valeur absente.');
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$uneListeOuverte = F3(
	function (presentation, brouillon, champ) {
		return brouillon.cv && (function () {
			var _v0 = champ.r0;
			switch (_v0.$) {
				case 17:
					return true;
				case 21:
					return true;
				default:
					return false;
			}
		}() && A2(
			$elm$core$List$any,
			function (choix) {
				return _Utils_eq(choix.dy, champ.dy) && ((!choix.FS) && ((!choix.Ca) && choix.Fk));
			},
			presentation.jN));
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$autreValeur = F4(
	function (i18n, presentation, brouillon, champ) {
		return A3($author$project$Components$Shared$EditeurDeSchema$Groupe$uneListeOuverte, presentation, brouillon, champ) ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$fieldset,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur-a-creer')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$legend,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$groupeDeSousChampsValeurACreerLegende,
											i18n,
											{IW: champ.Bl}))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$input,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
								$rtfeldman$elm_css$Html$Styled$Attributes$id(presentation.pv + ('-' + (champ.dy + '-a-creer'))),
								$rtfeldman$elm_css$Html$Styled$Attributes$value(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										$elm$core$Tuple$second,
										$elm$core$List$head(
											A2(
												$elm$core$List$filter,
												A2(
													$elm$core$Basics$composeR,
													$elm$core$Tuple$first,
													$elm$core$Basics$eq(champ.dy)),
												brouillon.Z))))),
								$rtfeldman$elm_css$Html$Styled$Events$onInput(
								$author$project$Components$Shared$EditeurDeSchema$Groupe$ValeurTapee(champ.dy))
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$groupeDeSousChampsValeurACreerNote(i18n))
							]))
					]))
			]) : _List_Nil;
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$DeSaisie = function (a) {
	return {$: 0, a: a};
};
var $author$project$I18n$Cles$groupeDeSousChampsSousChampFacultatif = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.sous-champ.facultatif',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			p.Bl + ' (facultatif)');
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$libelleAffiche = F2(
	function (i18n, champ) {
		return champ.he ? champ.Bl : A2(
			$author$project$I18n$Cles$groupeDeSousChampsSousChampFacultatif,
			i18n,
			{Bl: champ.Bl});
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$boutons = F5(
	function (i18n, presentation, brouillon, champ, options) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$fieldset,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('mandatory', champ.he)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$legend,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Shared$EditeurDeSchema$Groupe$libelleAffiche, i18n, champ))
								]))
						])),
					$author$project$Components$Shared$Segment$View$view(
					{
						vd: function () {
							var _v0 = A2(
								$elm$core$Maybe$map,
								$elm$core$Tuple$second,
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$Tuple$first,
											$elm$core$Basics$eq(champ.dy)),
										brouillon.hP.Ki)));
							if ((!_v0.$) && (_v0.a.$ === 1)) {
								var code = _v0.a.a;
								return code;
							} else {
								return '';
							}
						}(),
						Bi: champ.Bl,
						Dj: presentation.pv + ('-' + champ.dy),
						Ea: function (code) {
							return $author$project$Components$Shared$EditeurDeSchema$Groupe$DeSaisie(
								A2(
									$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$Saisi,
									champ.dy,
									$author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Ecrit(code)));
						},
						o_: options
					})
				]));
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$separerLesListesOuvertes = F3(
	function (presentation, brouillon, champs) {
		return brouillon.cv ? A3(
			$elm$core$List$foldr,
			F2(
				function (champ, suite) {
					if (A3($author$project$Components$Shared$EditeurDeSchema$Groupe$uneListeOuverte, presentation, brouillon, champ)) {
						return A2(
							$elm$core$List$cons,
							_List_fromArray(
								[champ]),
							suite);
					} else {
						if (suite.b && suite.a.b) {
							var _v1 = suite.a;
							var premiere = _v1.a;
							var reste = _v1.b;
							var autres = suite.b;
							return A2(
								$elm$core$List$any,
								A2($author$project$Components$Shared$EditeurDeSchema$Groupe$uneListeOuverte, presentation, brouillon),
								_List_fromArray(
									[premiere])) ? A2(
								$elm$core$List$cons,
								_List_fromArray(
									[champ]),
								suite) : A2(
								$elm$core$List$cons,
								A2(
									$elm$core$List$cons,
									champ,
									A2($elm$core$List$cons, premiere, reste)),
								autres);
						} else {
							return A2(
								$elm$core$List$cons,
								_List_fromArray(
									[champ]),
								suite);
						}
					}
				}),
			_List_Nil,
			champs) : _List_fromArray(
			[champs]);
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$estUnePartiePrenante = function (champ) {
	var _v0 = champ.r0;
	if (_v0.$ === 19) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$separerLesPartiesPrenantes = function (series) {
	return A2(
		$elm$core$List$concatMap,
		function (serie) {
			return A2($elm$core$List$any, $author$project$Components$Shared$EditeurDeSchema$Groupe$estUnePartiePrenante, serie) ? A3(
				$elm$core$List$foldr,
				F2(
					function (champ, suite) {
						var _v0 = _Utils_Tuple2(
							$author$project$Components$Shared$EditeurDeSchema$Groupe$estUnePartiePrenante(champ),
							suite);
						if (((!_v0.a) && _v0.b.b) && _v0.b.a.b) {
							var _v1 = _v0.b;
							var _v2 = _v1.a;
							var premiere = _v2.a;
							var reste = _v2.b;
							var autres = _v1.b;
							return $author$project$Components$Shared$EditeurDeSchema$Groupe$estUnePartiePrenante(premiere) ? A2(
								$elm$core$List$cons,
								_List_fromArray(
									[champ]),
								suite) : A2(
								$elm$core$List$cons,
								A2(
									$elm$core$List$cons,
									champ,
									A2($elm$core$List$cons, premiere, reste)),
								autres);
						} else {
							return A2(
								$elm$core$List$cons,
								_List_fromArray(
									[champ]),
								suite);
						}
					}),
				_List_Nil,
				serie) : _List_fromArray(
				[serie]);
		},
		series);
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$avecLaMentionFacultatif = F2(
	function (i18n, champ) {
		return _Utils_update(
			champ,
			{
				Bl: A2($author$project$Components$Shared$EditeurDeSchema$Groupe$libelleAffiche, i18n, champ)
			});
	});
var $author$project$I18n$Cles$groupeDeSousChampsNoteTypesProposes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.note.types-proposes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typeDeFiche',
					$author$project$I18n$Traductions$Chaine(p.ca)),
					_Utils_Tuple2(
					'proposees',
					$author$project$I18n$Traductions$Chaine(p.pE)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			'Seuls les types de partie prenante « ' + (p.ca + (' » sont proposés. ' + (p.pE + (' sur ' + (p.JE + '.'))))));
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$typeViseDuGroupe = function (brouillon) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filterMap,
			function (champ) {
				var _v0 = champ.r0;
				if (_v0.$ === 19) {
					var typeVise = _v0.a.r$;
					return A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$second,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Tuple$first,
									$elm$core$Basics$eq(typeVise)),
								brouillon.r2)));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			brouillon.IX));
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$notePartiePrenante = F4(
	function (i18n, presentation, brouillon, champ) {
		var _v0 = _Utils_Tuple2(
			$author$project$Components$Shared$EditeurDeSchema$Groupe$typeViseDuGroupe(brouillon),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dy;
						},
						$elm$core$Basics$eq(champ.dy)),
					presentation.jN)));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var typeDeFiche = _v0.a.a;
			var choix = _v0.b.a;
			var compte = $elm$core$String$fromInt(
				$elm$core$List$length(choix.pE));
			return A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note-types-proposes')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$groupeDeSousChampsNoteTypesProposes,
							i18n,
							{pE: compte, JE: compte, ca: typeDeFiche}))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$uneSerie = F4(
	function (i18n, presentation, brouillon, champs) {
		return A2(
			$elm$core$List$cons,
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('serie')
					]),
				A2(
					$elm$core$List$map,
					$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Shared$EditeurDeSchema$Groupe$DeSaisie),
					A3(
						$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$view,
						i18n,
						_Utils_update(
							presentation,
							{
								dw: A2(
									$elm$core$List$map,
									$author$project$Components$Shared$EditeurDeSchema$Groupe$avecLaMentionFacultatif(i18n),
									champs),
								np: false
							}),
						brouillon.hP))),
			_Utils_ap(
				A2(
					$elm$core$List$concatMap,
					A3($author$project$Components$Shared$EditeurDeSchema$Groupe$autreValeur, i18n, presentation, brouillon),
					champs),
				A2(
					$elm$core$List$map,
					A3($author$project$Components$Shared$EditeurDeSchema$Groupe$notePartiePrenante, i18n, presentation, brouillon),
					A2($elm$core$List$filter, $author$project$Components$Shared$EditeurDeSchema$Groupe$estUnePartiePrenante, champs))));
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$unBloc = F4(
	function (i18n, presentation, brouillon, morceau) {
		if (!morceau.$) {
			var champs = morceau.a;
			return A2(
				$elm$core$List$concatMap,
				A3($author$project$Components$Shared$EditeurDeSchema$Groupe$uneSerie, i18n, presentation, brouillon),
				$author$project$Components$Shared$EditeurDeSchema$Groupe$separerLesPartiesPrenantes(
					A3($author$project$Components$Shared$EditeurDeSchema$Groupe$separerLesListesOuvertes, presentation, brouillon, champs)));
		} else {
			var champ = morceau.a;
			var options = morceau.b;
			return A2(
				$elm$core$List$cons,
				A5($author$project$Components$Shared$EditeurDeSchema$Groupe$boutons, i18n, presentation, brouillon, champ, options),
				A4($author$project$Components$Shared$EditeurDeSchema$Groupe$autreValeur, i18n, presentation, brouillon, champ));
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$ModifierLaValeur = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$Autre = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$Mesure = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$Monnaie = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$Somme = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$estUneDevise = function (champ) {
	var _v0 = champ.r0;
	if (_v0.$ === 13) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$estUneMesure = function (champ) {
	var _v0 = champ.r0;
	if (_v0.$ === 10) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$centimes = function (n) {
	var total = $elm$core$Basics$round(
		$elm$core$Basics$abs(n) * 100);
	var reste = A2($elm$core$Basics$modBy, 100, total);
	var groupes = function (texte) {
		return ($elm$core$String$length(texte) <= 3) ? texte : (groupes(
			A2($elm$core$String$dropRight, 3, texte)) + ('\u00A0' + A2($elm$core$String$right, 3, texte)));
	};
	var entier = (total / 100) | 0;
	return ((n < 0) ? '-' : '') + (groupes(
		$elm$core$String$fromInt(entier)) + (',' + A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(reste))));
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$spanMesures = F2(
	function (unite, jetons) {
		if (jetons.b && (!jetons.a.$)) {
			var _v1 = jetons.a;
			var n = _v1.a;
			var u = _v1.b;
			var suite = jetons.b;
			return _Utils_eq(u, unite) ? function (_v2) {
				var memes = _v2.a;
				var reste = _v2.b;
				return _Utils_Tuple2(
					A2($elm$core$List$cons, n, memes),
					reste);
			}(
				A2($author$project$Components$Shared$EditeurDeSchema$Groupe$spanMesures, unite, suite)) : _Utils_Tuple2(_List_Nil, jetons);
		} else {
			return _Utils_Tuple2(_List_Nil, jetons);
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$symbole = function (code) {
	return (code === 'EUR') ? '€' : code;
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$virgule = function (n) {
	return A3(
		$elm$core$String$replace,
		'.',
		',',
		$elm$core$String$fromFloat(n));
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$rassembler = function (jetons) {
	if (jetons.b) {
		switch (jetons.a.$) {
			case 0:
				var _v1 = jetons.a;
				var n = _v1.a;
				var unite = _v1.b;
				var suite = jetons.b;
				var _v2 = A2($author$project$Components$Shared$EditeurDeSchema$Groupe$spanMesures, unite, suite);
				var memes = _v2.a;
				var reste = _v2.b;
				var nombres = A2($elm$core$List$cons, n, memes);
				return ($elm$core$List$length(nombres) > 1) ? A2(
					$elm$core$List$cons,
					A2(
						$elm$core$String$join,
						' × ',
						A2($elm$core$List$map, $author$project$Components$Shared$EditeurDeSchema$Groupe$virgule, nombres)) + (' ' + unite),
					$author$project$Components$Shared$EditeurDeSchema$Groupe$rassembler(reste)) : A2(
					$elm$core$List$cons,
					$author$project$Components$Shared$EditeurDeSchema$Groupe$virgule(n) + (' ' + unite),
					$author$project$Components$Shared$EditeurDeSchema$Groupe$rassembler(reste));
			case 1:
				if (jetons.b.b && (jetons.b.a.$ === 2)) {
					var n = jetons.a.a;
					var _v3 = jetons.b;
					var code = _v3.a.a;
					var suite = _v3.b;
					return A2(
						$elm$core$List$cons,
						$author$project$Components$Shared$EditeurDeSchema$Groupe$centimes(n) + (' ' + $author$project$Components$Shared$EditeurDeSchema$Groupe$symbole(code)),
						$author$project$Components$Shared$EditeurDeSchema$Groupe$rassembler(suite));
				} else {
					var n = jetons.a.a;
					var suite = jetons.b;
					return A2(
						$elm$core$List$cons,
						$author$project$Components$Shared$EditeurDeSchema$Groupe$centimes(n),
						$author$project$Components$Shared$EditeurDeSchema$Groupe$rassembler(suite));
				}
			case 2:
				var code = jetons.a.a;
				var suite = jetons.b;
				return A2(
					$elm$core$List$cons,
					code,
					$author$project$Components$Shared$EditeurDeSchema$Groupe$rassembler(suite));
			default:
				var texte = jetons.a.a;
				var suite = jetons.b;
				return A2(
					$elm$core$List$cons,
					texte,
					$author$project$Components$Shared$EditeurDeSchema$Groupe$rassembler(suite));
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$libelleDeValeur = F3(
	function (i18n, langue, valeur) {
		return valeur.tI ? A2(
			$author$project$I18n$Cles$produitsReferenceSaisieChoixArchivee,
			i18n,
			{
				Bl: A2($author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$libelle, langue, valeur)
			}) : A2($author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$libelle, langue, valeur);
	});
var $author$project$Referentiel$Normes$nomDeLangue = F2(
	function (_v0, code) {
		var normes = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			code,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Dj;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.vx;
							},
							$elm$core$Basics$eq(code)),
						normes.Ba))));
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$orElse = F2(
	function (autre, premier) {
		if (!premier.$) {
			return premier;
		} else {
			return autre;
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$libelleDuTexte = F4(
	function (i18n, contexte, champ, texte) {
		var _v0 = champ.r0;
		switch (_v0.$) {
			case 5:
				return A2($author$project$Texte$Jour$enFrancais, i18n, texte);
			case 15:
				return A2($author$project$Referentiel$Normes$nomDePays, contexte.hd, texte);
			case 16:
				return A2($author$project$Referentiel$Normes$nomDeLangue, contexte.hd, texte);
			default:
				return A2(
					$elm$core$Maybe$withDefault,
					texte,
					A2(
						$author$project$Components$Shared$EditeurDeSchema$Groupe$orElse,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Tuple$second,
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Tuple$first,
										$elm$core$Basics$eq(champ.dy + ('.' + texte))),
									contexte.R))),
						A2(
							$author$project$Components$Shared$EditeurDeSchema$Groupe$orElse,
							A3($author$project$Components$Shared$EditeurDeSchema$Champ$libelleDeLaValeur, contexte.nn, champ, texte),
							A2(
								$elm$core$Maybe$map,
								A2($author$project$Components$Shared$EditeurDeSchema$Groupe$libelleDeValeur, i18n, contexte.nn),
								A2(
									$elm$core$Maybe$andThen,
									function (choix) {
										return $elm$core$List$head(
											A2(
												$elm$core$List$filter,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.Aq;
													},
													$elm$core$Basics$eq(texte)),
												$author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$montrees(choix)));
									},
									$elm$core$List$head(
										A2(
											$elm$core$List$filter,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.dy;
												},
												$elm$core$Basics$eq(champ.dy)),
											contexte.jN)))))));
		}
	});
var $author$project$I18n$Cles$groupeDeSousChampsFicheEffacee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'groupe-de-sous-champs.fiche.effacee', _List_Nil, 'Donnée effacée');
};
var $author$project$I18n$Cles$groupeDeSousChampsFicheIndisponible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'groupe-de-sous-champs.fiche.indisponible', _List_Nil, 'Indisponible');
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$texteDeLaFiche = F3(
	function (i18n, fiches, uid) {
		var _v0 = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.r8;
					},
					$elm$core$Basics$eq(uid)),
				fiches));
		if (!_v0.$) {
			var nom = _v0.a.Dj;
			var etat = _v0.a.gt;
			var _v1 = _Utils_Tuple2(etat, nom);
			_v1$0:
			while (true) {
				_v1$1:
				while (true) {
					if (!_v1.b.$) {
						switch (_v1.a) {
							case 2:
								break _v1$0;
							case 3:
								break _v1$1;
							default:
								var nomDuJour = _v1.b.a;
								return nomDuJour;
						}
					} else {
						switch (_v1.a) {
							case 2:
								break _v1$0;
							case 3:
								break _v1$1;
							default:
								var _v4 = _v1.b;
								return $author$project$I18n$Cles$groupeDeSousChampsFicheIndisponible(i18n);
						}
					}
				}
				var _v3 = _v1.a;
				return $author$project$I18n$Cles$groupeDeSousChampsFicheIndisponible(i18n);
			}
			var _v2 = _v1.a;
			return $author$project$I18n$Cles$groupeDeSousChampsFicheEffacee(i18n);
		} else {
			return $author$project$I18n$Cles$groupeDeSousChampsFicheIndisponible(i18n);
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$texteDeLaValeur = F4(
	function (i18n, contexte, champ, valeur) {
		switch (valeur.$) {
			case 0:
				return $elm$core$Maybe$Nothing;
			case 1:
				var texte = valeur.a;
				if ($elm$core$String$trim(texte) === '') {
					return $elm$core$Maybe$Nothing;
				} else {
					var _v1 = champ.r0;
					if (_v1.$ === 19) {
						return $elm$core$Maybe$Just(
							A3($author$project$Components$Shared$EditeurDeSchema$Groupe$texteDeLaFiche, i18n, contexte.zu, texte));
					} else {
						return $elm$core$Maybe$Just(
							A4($author$project$Components$Shared$EditeurDeSchema$Groupe$libelleDuTexte, i18n, contexte, champ, texte));
					}
				}
			case 2:
				var nombre = valeur.a;
				return $elm$core$Maybe$Just(
					A3(
						$elm$core$String$replace,
						'.',
						',',
						$elm$core$String$fromFloat(nombre)));
			case 3:
				var coche = valeur.a;
				return $elm$core$Maybe$Just(
					coche ? $author$project$I18n$Cles$editeurDeSchemaChampOui(i18n) : $author$project$I18n$Cles$editeurDeSchemaChampNon(i18n));
			case 4:
				if (!valeur.a.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					var textes = valeur.a;
					return $elm$core$Maybe$Just(
						A2(
							$elm$core$String$join,
							', ',
							A2(
								$elm$core$List$map,
								A3($author$project$Components$Shared$EditeurDeSchema$Groupe$libelleDuTexte, i18n, contexte, champ),
								textes)));
				}
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$composee = F4(
	function (i18n, contexte, sousChamps, lue) {
		var valeurDe = function (champ) {
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$eq(champ.dy)),
						lue.Ki)));
		};
		var nombreDe = function (champ) {
			var _v2 = valeurDe(champ);
			if ((!_v2.$) && (_v2.a.$ === 2)) {
				var n = _v2.a.a;
				return $elm$core$Maybe$Just(n);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		var jeton = function (champ) {
			var _v0 = champ.r0;
			switch (_v0.$) {
				case 10:
					var mesure = _v0.a;
					return A2(
						$elm$core$Maybe$map,
						function (n) {
							return A2($author$project$Components$Shared$EditeurDeSchema$Groupe$Mesure, n, mesure.sa);
						},
						nombreDe(champ));
				case 4:
					return A2(
						$elm$core$Maybe$map,
						function (n) {
							return $author$project$Components$Shared$EditeurDeSchema$Groupe$Somme(n);
						},
						nombreDe(champ));
				default:
					if ($author$project$Components$Shared$EditeurDeSchema$Groupe$estUneDevise(champ)) {
						var _v1 = valeurDe(champ);
						if ((!_v1.$) && (_v1.a.$ === 1)) {
							var code = _v1.a.a;
							return ($elm$core$String$trim(code) === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
								$author$project$Components$Shared$EditeurDeSchema$Groupe$Monnaie(code));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					} else {
						return A2(
							$elm$core$Maybe$map,
							$author$project$Components$Shared$EditeurDeSchema$Groupe$Autre,
							A2(
								$elm$core$Maybe$andThen,
								A3($author$project$Components$Shared$EditeurDeSchema$Groupe$texteDeLaValeur, i18n, contexte, champ),
								valeurDe(champ)));
					}
			}
		};
		return A2(
			$elm$core$List$any,
			function (champ) {
				return $author$project$Components$Shared$EditeurDeSchema$Groupe$estUneDevise(champ) || $author$project$Components$Shared$EditeurDeSchema$Groupe$estUneMesure(champ);
			},
			sousChamps) ? function (phrase) {
			return (phrase === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(phrase);
		}(
			A2(
				$elm$core$String$join,
				' · ',
				$author$project$Components$Shared$EditeurDeSchema$Groupe$rassembler(
					A2($elm$core$List$filterMap, jeton, sousChamps)))) : $elm$core$Maybe$Nothing;
	});
var $author$project$I18n$Cles$groupeDeSousChampsRefusValeurEnDouble = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.refus.valeur-en-double',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			p.fm + ' existe déjà sur cette fiche. Une valeur ne se répète pas.');
	});
var $author$project$I18n$Cles$groupeDeSousChampsRefusValeurEnDoubleAction = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.refus.valeur-en-double.action',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			'Modifier la valeur ' + p.fm);
	});
var $author$project$I18n$Cles$groupeDeSousChampsRefusValeurEnDoubleAvecValeur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.refus.valeur-en-double.avec-valeur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm)),
					_Utils_Tuple2(
					'existante',
					$author$project$I18n$Traductions$Chaine(p.y1))
				]),
			p.fm + (' existe déjà sur cette fiche (' + (p.y1 + '). Une valeur ne se répète pas.')));
	});
var $author$project$I18n$Cles$groupeDeSousChampsRefusValeurEnDoubleOu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'groupe-de-sous-champs.refus.valeur-en-double.ou', _List_Nil, 'ou choisissez une autre valeur.');
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$valeurEnDoubleAffichee = F3(
	function (i18n, presentation, brouillon) {
		var cle = A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Components$Shared$EditeurDeSchema$Groupe$cleDuDoublon(brouillon));
		var saisie = A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$eq(cle)),
					brouillon.hP.Ki)));
		var tapee = function () {
			if ((!saisie.$) && (saisie.a.$ === 1)) {
				var texte = saisie.a.a;
				return $elm$core$String$trim(texte);
			} else {
				return '';
			}
		}();
		var memeValeur = function (lue) {
			var _v2 = A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$eq(cle)),
						lue.Ki)));
			_v2$2:
			while (true) {
				if (!_v2.$) {
					switch (_v2.a.$) {
						case 2:
							var n = _v2.a.a;
							return _Utils_eq(
								$elm$core$String$toFloat(
									A3($elm$core$String$replace, ',', '.', tapee)),
								$elm$core$Maybe$Just(n));
						case 1:
							var t = _v2.a.a;
							return _Utils_eq(t, tapee);
						default:
							break _v2$2;
					}
				} else {
					break _v2$2;
				}
			}
			return false;
		};
		var occurrenceDeLaValeur = $elm$core$List$head(
			A2($elm$core$List$filter, memeValeur, brouillon.mp));
		var valeurExistante = A2(
			$elm$core$Maybe$andThen,
			A3(
				$author$project$Components$Shared$EditeurDeSchema$Groupe$composee,
				i18n,
				{jN: presentation.jN, zu: _List_Nil, nn: brouillon.hP.nn, R: _List_Nil, hd: $author$project$Referentiel$Normes$vide},
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dy;
						},
						$elm$core$Basics$neq(cle)),
					brouillon.IX)),
			occurrenceDeLaValeur);
		return A2(
			$author$project$Components$Shared$Note$View$view,
			1,
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							function () {
								if (!valeurExistante.$) {
									var existante = valeurExistante.a;
									return A2(
										$author$project$I18n$Cles$groupeDeSousChampsRefusValeurEnDoubleAvecValeur,
										i18n,
										{y1: existante, fm: tapee});
								} else {
									return A2(
										$author$project$I18n$Cles$groupeDeSousChampsRefusValeurEnDouble,
										i18n,
										{fm: tapee});
								}
							}())
						])),
				function () {
					if (!occurrenceDeLaValeur.$) {
						var lue = occurrenceDeLaValeur.a;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('issue')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$button,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('pale'),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												$author$project$Components$Shared$EditeurDeSchema$Groupe$ModifierLaValeur(lue.r8))
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2(
															$author$project$I18n$Cles$groupeDeSousChampsRefusValeurEnDoubleAction,
															i18n,
															{fm: tapee}))
													]))
											])),
										$rtfeldman$elm_css$Html$Styled$text(
										' ' + $author$project$I18n$Cles$groupeDeSousChampsRefusValeurEnDoubleOu(i18n))
									]))
							]);
					} else {
						return _List_Nil;
					}
				}()));
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$corps = F3(
	function (i18n, presentationDeLaFiche, brouillon) {
		var presentation = _Utils_update(
			presentationDeLaFiche,
			{
				jN: A2($author$project$Components$Shared$EditeurDeSchema$Groupe$choixDuGroupe, brouillon.uN, presentationDeLaFiche.jN)
			});
		var blocsDe = function (champs) {
			return A2(
				$elm$core$List$concatMap,
				A3($author$project$Components$Shared$EditeurDeSchema$Groupe$unBloc, i18n, presentation, brouillon),
				A3($author$project$Components$Shared$EditeurDeSchema$Groupe$blocs, brouillon.hP.nn, presentation, champs));
		};
		var _v0 = $author$project$Components$Shared$EditeurDeSchema$Groupe$cleDuDoublon(brouillon);
		if (!_v0.$) {
			var cle = _v0.a;
			var _v1 = A2($author$project$Components$Shared$EditeurDeSchema$Groupe$coupeApres, cle, brouillon.IX);
			var jusqueLa = _v1.a;
			var ensuite = _v1.b;
			return _Utils_ap(
				blocsDe(jusqueLa),
				_Utils_ap(
					_List_fromArray(
						[
							A3($author$project$Components$Shared$EditeurDeSchema$Groupe$valeurEnDoubleAffichee, i18n, presentation, brouillon)
						]),
					_Utils_ap(
						blocsDe(ensuite),
						_List_fromArray(
							[
								A2($author$project$Components$Shared$EditeurDeSchema$Groupe$note, i18n, brouillon)
							]))));
		} else {
			return _Utils_ap(
				_List_fromArray(
					[
						A2($author$project$Components$Shared$EditeurDeSchema$Groupe$refusAffiche, i18n, brouillon)
					]),
				_Utils_ap(
					blocsDe(brouillon.IX),
					_List_fromArray(
						[
							A2($author$project$Components$Shared$EditeurDeSchema$Groupe$note, i18n, brouillon)
						])));
		}
	});
var $author$project$I18n$Cles$groupeDeSousChampsActionAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'groupe-de-sous-champs.action.ajouter', _List_Nil, 'Ajouter');
};
var $author$project$I18n$Cles$groupeDeSousChampsActionEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'groupe-de-sous-champs.action.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$Components$Produits$Reference$GroupesView$presentation = F2(
	function (model, fiche) {
		return {
			fr: $author$project$Components$Produits$Reference$Model$aTraduire(fiche),
			dw: _List_Nil,
			jN: A2($author$project$Components$Produits$Reference$Model$choixAvecLesFiches, model, fiche),
			Ba: fiche.Ba,
			np: false,
			hd: model.hd,
			pv: $author$project$Components$Produits$Reference$Model$prefixeDesOccurrences,
			sb: fiche.sb
		};
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$commenceParUneVoyelle = function (libelle) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$first,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Char$toLower,
					function (c) {
						return A2(
							$elm$core$List$member,
							c,
							_List_fromArray(
								['a', 'e', 'i', 'o', 'u', 'h', 'é', 'è', 'ê', 'à', 'â', 'î', 'ô', 'û']));
					})),
			$elm$core$String$uncons(libelle)));
};
var $author$project$I18n$Cles$groupeDeSousChampsOccurrenceDefinie = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.occurrence-definie',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'article',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeArticle(p.i4))),
					_Utils_Tuple2(
					'occurrence',
					$author$project$I18n$Traductions$Chaine(p.D$))
				]),
			function () {
				var _v0 = p.i4;
				switch (_v0) {
					case 0:
						return 'le ' + p.D$;
					case 1:
						return 'l\'' + p.D$;
					case 2:
						return 'la ' + p.D$;
					case 3:
						return 'le ' + p.D$;
					default:
						return 'le ' + p.D$;
				}
			}());
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$avecArticleDefini = F3(
	function (i18n, genre, libelle) {
		return A2(
			$author$project$I18n$Cles$groupeDeSousChampsOccurrenceDefinie,
			i18n,
			{
				i4: function () {
					if ($author$project$Components$Shared$EditeurDeSchema$Groupe$commenceParUneVoyelle(libelle)) {
						return 1;
					} else {
						if (!genre) {
							return 2;
						} else {
							return 3;
						}
					}
				}(),
				D$: libelle
			});
	});
var $author$project$I18n$Cles$groupeDeSousChampsTitreAjouter = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.titre.ajouter',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'occurrence',
					$author$project$I18n$Traductions$Chaine(p.D$))
				]),
			'Ajouter ' + p.D$);
	});
var $author$project$I18n$Cles$groupeDeSousChampsTitreModifier = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.titre.modifier',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'occurrence',
					$author$project$I18n$Traductions$Chaine(p.D$))
				]),
			'Modifier ' + p.D$);
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$titre = F2(
	function (i18n, brouillon) {
		var _v0 = _Utils_Tuple2(brouillon.r8, brouillon.HI);
		if (!_v0.a.$) {
			return A2(
				$author$project$I18n$Cles$groupeDeSousChampsTitreModifier,
				i18n,
				{
					D$: A2(
						$author$project$I18n$Cles$texte,
						i18n,
						A2($author$project$Components$Shared$EditeurDeSchema$Groupe$avecArticle, brouillon.z9, brouillon.Bq))
				});
		} else {
			if (_v0.b) {
				var _v1 = _v0.a;
				return A2(
					$author$project$I18n$Cles$groupeDeSousChampsTitreAjouter,
					i18n,
					{
						D$: A2(
							$author$project$I18n$Cles$texte,
							i18n,
							A2($author$project$Components$Shared$EditeurDeSchema$Groupe$avecArticle, brouillon.z9, brouillon.Bq))
					});
			} else {
				var _v2 = _v0.a;
				return A2(
					$author$project$I18n$Cles$groupeDeSousChampsTitreAjouter,
					i18n,
					{
						D$: A3($author$project$Components$Shared$EditeurDeSchema$Groupe$avecArticleDefini, i18n, brouillon.z9, brouillon.Bq)
					});
			}
		}
	});
var $author$project$Components$Produits$Reference$Update$OccurrenceDemandee = F2(
	function (a, b) {
		return {$: 55, a: a, b: b};
	});
var $author$project$I18n$Cles$groupeDeSousChampsRefusUneSeuleAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'groupe-de-sous-champs.refus.une-seule.action', _List_Nil, 'Modifier l\'occurrence');
};
var $author$project$I18n$Cles$groupeDeSousChampsRefusUneSeuleExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'groupe-de-sous-champs.refus.une-seule.explication', _List_Nil, 'Celle de cette fiche existe déjà : modifiez-la.');
};
var $author$project$I18n$Cles$groupeDeSousChampsRefusUneSeuleTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.refus.une-seule.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'« ' + (p.uN + ' » ne porte qu\'une occurrence.'));
	});
var $author$project$Components$Produits$Reference$GroupesView$uneSeule = F4(
	function (i18n, model, fiche, brouillon) {
		var _v0 = _Utils_Tuple2(
			model.J8,
			$elm$core$List$head(
				$author$project$Components$Shared$EditeurDeSchema$Groupe$occurrences(
					A2($author$project$Components$Produits$Reference$Model$valeurDuGroupe, fiche, brouillon.uN))));
		if (_v0.a && (!_v0.b.$)) {
			var existante = _v0.b.a;
			return A2(
				$author$project$Components$Shared$Note$View$view,
				1,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$b,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$groupeDeSousChampsRefusUneSeuleTitre,
									i18n,
									{uN: brouillon.Dj}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$groupeDeSousChampsRefusUneSeuleExplication(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								A2(
									$author$project$Components$Produits$Reference$Update$OccurrenceDemandee,
									brouillon.uN,
									$elm$core$Maybe$Just(existante.r8)))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$groupeDeSousChampsRefusUneSeuleAction(i18n))
									]))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Produits$Reference$GroupesView$vide = {
	fs: {sR: false, Bl: '', C$: $author$project$Components$Produits$Reference$Update$DrawerValide},
	fZ: _List_Nil,
	h6: ''
};
var $author$project$Components$Produits$Reference$GroupesView$drawer = F3(
	function (i18n, model, fiche) {
		var _v0 = model.D$;
		if (!_v0.$) {
			var brouillon = _v0.a;
			return {
				fs: {
					sR: true,
					Bl: (brouillon.HI && _Utils_eq(brouillon.r8, $elm$core$Maybe$Nothing)) ? $author$project$I18n$Cles$groupeDeSousChampsActionAjouter(i18n) : $author$project$I18n$Cles$groupeDeSousChampsActionEnregistrer(i18n),
					C$: $author$project$Components$Produits$Reference$Update$DrawerValide
				},
				fZ: _Utils_ap(
					_List_fromArray(
						[
							A4($author$project$Components$Produits$Reference$GroupesView$uneSeule, i18n, model, fiche, brouillon)
						]),
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Produits$Reference$Update$DeLOccurrence),
						A3(
							$author$project$Components$Shared$EditeurDeSchema$Groupe$corps,
							i18n,
							A2($author$project$Components$Produits$Reference$GroupesView$presentation, model, fiche),
							brouillon))),
				h6: A2($author$project$Components$Shared$EditeurDeSchema$Groupe$titre, i18n, brouillon)
			};
		} else {
			return $author$project$Components$Produits$Reference$GroupesView$vide;
		}
	});
var $author$project$Components$Produits$Reference$ImageView$alerte = F2(
	function (titre, message) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('alerte'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$b,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(titre)
						])),
					$rtfeldman$elm_css$Html$Styled$text(message)
				]));
	});
var $author$project$Components$Produits$Reference$Update$ImageDuChampChoisie = function (a) {
	return {$: 85, a: a};
};
var $author$project$Components$Produits$Reference$Model$documentDuChamp = F2(
	function (model, champ) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.uN;
					},
					$elm$core$Basics$eq(champ)),
				model.gb));
	});
var $author$project$Components$Produits$Reference$ImageView$legendeDeLaVignette = function (nom) {
	if (!nom.$) {
		var n = nom.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('legende')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(n)
				]));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Components$Produits$Reference$ImageView$nomDuFichierDuChamp = F2(
	function (model, champ) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.IR;
			},
			model.af);
		if ((!_v0.$) && (_v0.a.$ === 1)) {
			var _v1 = _v0.a;
			var cle = _v1.a;
			var nom = _v1.b;
			return _Utils_eq(cle, champ) ? nom : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$I18n$Cles$produitsReferenceImageChoisie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.choisie', _List_Nil, 'Choisie');
};
var $author$project$I18n$Cles$produitsReferenceImageImagesDeLaFiche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.images-de-la-fiche', _List_Nil, 'Images de la fiche');
};
var $author$project$I18n$Cles$produitsReferenceImageVignetteAlt = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.image.vignette-alt',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			'Image de la fiche : ' + p.Bl);
	});
var $author$project$Components$Produits$Reference$ImageView$choisir = F4(
	function (i18n, model, definition, images) {
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('images-de-la-fiche')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsReferenceImageImagesDeLaFiche(i18n)),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										' · ' + $elm$core$String$fromInt(
											$elm$core$List$length(images)))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('galerie')
							]),
						A2(
							$elm$core$List$map,
							function (image) {
								var choisie = _Utils_eq(
									definition.uN,
									$elm$core$Maybe$Just(image.uN));
								return A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('choix-image'),
											$rtfeldman$elm_css$Html$Styled$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('on', choisie)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
											'aria-pressed',
											choisie ? 'true' : 'false'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Produits$Reference$Update$ImageDuChampChoisie(image.uN))
										]),
									_List_fromArray(
										[
											function () {
											var _v0 = A2($author$project$Components$Produits$Reference$Model$documentDuChamp, model, image.uN);
											if (!_v0.$) {
												var document = _v0.a;
												return A2(
													$rtfeldman$elm_css$Html$Styled$img,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('vignette'),
															$rtfeldman$elm_css$Html$Styled$Attributes$src(document.aa),
															$rtfeldman$elm_css$Html$Styled$Attributes$alt(
															A2(
																$author$project$I18n$Cles$produitsReferenceImageVignetteAlt,
																i18n,
																{Bl: image.Bl}))
														]),
													_List_Nil);
											} else {
												return A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('vignette'),
															A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
														]),
													_List_fromArray(
														[$author$project$Components$Shared$Svg$svgImage]));
											}
										}(),
											choisie ? A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('choisie')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$produitsReferenceImageChoisie(i18n))
												])) : $rtfeldman$elm_css$Html$Styled$text(''),
											A2(
											$rtfeldman$elm_css$Html$Styled$b,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(image.Bl)
												])),
											$author$project$Components$Produits$Reference$ImageView$legendeDeLaVignette(
											A2($author$project$Components$Produits$Reference$ImageView$nomDuFichierDuChamp, model, image.uN))
										]));
							},
							images))
					]))
			]);
	});
var $author$project$I18n$Cles$produitsReferenceImageActuelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.actuelle', _List_Nil, 'Image actuelle');
};
var $author$project$Components$Produits$Reference$ImageView$actuelle = F3(
	function (i18n, adresse, detail) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('image-actuelle')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('miniature'),
							$rtfeldman$elm_css$Html$Styled$Attributes$src(adresse),
							$rtfeldman$elm_css$Html$Styled$Attributes$alt(
							$author$project$I18n$Cles$produitsReferenceImageAlt(i18n))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsReferenceImageActuelle(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(detail)
								]))
						]))
				]));
	});
var $author$project$I18n$Cles$produitsReferenceImageActuelleChamp = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.image.actuelle-champ',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'Champ « ' + (p.uN + ' »'));
	});
var $author$project$Components$Produits$Reference$ImageView$imageActuelle = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.gt;
				},
				model.af),
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.IR;
				},
				model.af));
		if (((!_v0.a.$) && (_v0.a.a.$ === 2)) && (!_v0.b.$)) {
			if (!_v0.b.a.$) {
				var adresse = _v0.a.a.a;
				var nom = _v0.b.a.a;
				return _List_fromArray(
					[
						A3(
						$author$project$Components$Produits$Reference$ImageView$actuelle,
						i18n,
						adresse,
						_Utils_ap(
							$author$project$I18n$Cles$produitsReferenceImageSourceDeposee(i18n),
							$author$project$Components$Produits$Reference$ImageView$avecLeNom(nom)))
					]);
			} else {
				var adresse = _v0.a.a.a;
				var _v1 = _v0.b.a;
				var cle = _v1.a;
				var nom = _v1.b;
				return _List_fromArray(
					[
						A3(
						$author$project$Components$Produits$Reference$ImageView$actuelle,
						i18n,
						adresse,
						_Utils_ap(
							A2(
								$author$project$I18n$Cles$produitsReferenceImageActuelleChamp,
								i18n,
								{
									uN: A2($author$project$Components$Produits$Reference$ImageView$libelleDuChamp, model, cle)
								}),
							$author$project$Components$Produits$Reference$ImageView$avecLeNom(nom)))
					]);
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Produits$Reference$Update$OrigineDeLImageChoisie = function (a) {
	return {$: 84, a: a};
};
var $author$project$I18n$Cles$produitsReferenceImageChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.choisir', _List_Nil, 'Choisir parmi les images de la fiche');
};
var $author$project$I18n$Cles$produitsReferenceImageChoisirDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.choisir-detail', _List_Nil, 'Une image déjà présente dans un champ de la fiche. Le bandeau suit l\'image de ce champ.');
};
var $author$project$I18n$Cles$produitsReferenceImageChoisirInactif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.choisir-inactif', _List_Nil, 'Aucun champ image sur cette fiche. Ajoutez un champ de type Image depuis la bibliothèque de champs pour pouvoir choisir.');
};
var $author$project$I18n$Cles$produitsReferenceImageOrigine = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.origine', _List_Nil, 'Origine de l\'image');
};
var $author$project$I18n$Cles$produitsReferenceImageTeleverser = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.televerser', _List_Nil, 'Téléverser une image');
};
var $author$project$I18n$Cles$produitsReferenceImageTeleverserDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.televerser-detail', _List_Nil, 'Un fichier JPEG, PNG ou WebP de votre ordinateur.');
};
var $author$project$Components$Produits$Reference$ImageView$origine = F3(
	function (i18n, definition, peutChoisir) {
		var choix = F5(
			function (actif, active, msg, libelle, detail) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('choix-origine'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('on', active),
									_Utils_Tuple2('off', !actif)
								])),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'radio'),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-checked',
							active ? 'true' : 'false'),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!actif),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('rb')
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$b,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(libelle)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('detail')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(detail)
										]))
								]))
						]));
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('origine'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'radiogroup'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					$author$project$I18n$Cles$produitsReferenceImageOrigine(i18n))
				]),
			_List_fromArray(
				[
					A5(
					choix,
					true,
					!definition.o4,
					$author$project$Components$Produits$Reference$Update$OrigineDeLImageChoisie(0),
					$author$project$I18n$Cles$produitsReferenceImageTeleverser(i18n),
					$author$project$I18n$Cles$produitsReferenceImageTeleverserDetail(i18n)),
					A5(
					choix,
					peutChoisir,
					definition.o4 === 1,
					$author$project$Components$Produits$Reference$Update$OrigineDeLImageChoisie(1),
					$author$project$I18n$Cles$produitsReferenceImageChoisir(i18n),
					peutChoisir ? $author$project$I18n$Cles$produitsReferenceImageChoisirDetail(i18n) : $author$project$I18n$Cles$produitsReferenceImageChoisirInactif(i18n))
				]));
	});
var $author$project$I18n$Cles$produitsReferenceImageDrawerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.drawer-titre', _List_Nil, 'Définir l\'image de présentation');
};
var $author$project$I18n$Cles$produitsReferenceImageEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$produitsReferenceImageNonUtilisableTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.non-utilisable-titre', _List_Nil, 'Image non utilisable');
};
var $author$project$Components$Produits$Reference$Update$ImageARemplacer = {$: 87};
var $author$project$Components$Produits$Reference$Update$ImageARessayer = {$: 86};
var $author$project$Components$Produits$Reference$Update$ImageEnvoiAnnule = {$: 80};
var $author$project$Components$Produits$Reference$Update$ImageGlissee = function (a) {
	return {$: 81, a: a};
};
var $author$project$Components$Produits$Reference$Update$ImageSurvolee = {$: 82};
var $elm$file$File$decoder = _File_decoder;
var $author$project$Components$Produits$Reference$ImageView$fichier = F4(
	function (_v0, nom, detail, complement) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('fichier')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('vignette'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
						]),
					_List_fromArray(
						[$author$project$Components$Shared$Svg$svgImage])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(nom)
								])),
						A2(
							$elm$core$List$cons,
							A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(detail)
									])),
							complement)))
				]));
	});
var $author$project$Components$Produits$Reference$Image$formatDe = function (choisi) {
	return $author$project$Components$Produits$Reference$Fichiers$formatDuType(choisi.Ck);
};
var $author$project$I18n$Cles$produitsReferenceImageAnnulerEnvoi = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.annuler-envoi', _List_Nil, 'Annuler l\'envoi');
};
var $author$project$I18n$Cles$produitsReferenceImageDeposer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.deposer', _List_Nil, 'Déposer une image ici');
};
var $author$project$I18n$Cles$produitsReferenceImageEnvoiEnCours = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.image.envoi-en-cours',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'taille',
					$author$project$I18n$Traductions$Chaine(p.Jm))
				]),
			p.Jm + ' · envoi en cours');
	});
var $author$project$I18n$Cles$produitsReferenceImageEnvoiInterrompu = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.image.envoi-interrompu',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'taille',
					$author$project$I18n$Traductions$Chaine(p.Jm))
				]),
			p.Jm + ' · envoi interrompu');
	});
var $author$project$I18n$Cles$produitsReferenceImageEnvoiProgression = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.image.envoi-progression',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'taille',
					$author$project$I18n$Traductions$Chaine(p.Jm)),
					_Utils_Tuple2(
					'pourcent',
					$author$project$I18n$Traductions$Chaine(p.Ga))
				]),
			p.Jm + (' · envoi en cours, ' + (p.Ga + ' %')));
	});
var $author$project$I18n$Cles$produitsReferenceImageFormat = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.image.format',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'format',
					$author$project$I18n$Traductions$Chaine(p.zP))
				]),
			'Le fichier « ' + (p.Dj + (' » est un ' + (p.zP + '. Formats acceptés : JPEG, PNG, WebP.'))));
	});
var $author$project$I18n$Cles$produitsReferenceImageFormatTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.format-titre', _List_Nil, 'Format non accepté');
};
var $author$project$I18n$Cles$produitsReferenceImageFormats = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.image.formats',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'taille',
					$author$project$I18n$Traductions$Chaine(p.Jm))
				]),
			'JPEG, PNG ou WebP · ' + (p.Jm + ' au plus'));
	});
var $author$project$I18n$Cles$produitsReferenceImageInterrompu = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.image.interrompu',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'L\'envoi de « ' + (p.Dj + ' » n\'a pas abouti : la connexion a été perdue. Rien n\'a été enregistré.'));
	});
var $author$project$I18n$Cles$produitsReferenceImageInterrompuTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.interrompu-titre', _List_Nil, 'Envoi interrompu');
};
var $author$project$I18n$Cles$produitsReferenceImageLourd = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.image.lourd',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'poids',
					$author$project$I18n$Traductions$Chaine(p.FV)),
					_Utils_Tuple2(
					'maximum',
					$author$project$I18n$Traductions$Chaine(p.Cj))
				]),
			'Le fichier « ' + (p.Dj + (' » pèse ' + (p.FV + ('. Taille maximale : ' + (p.Cj + '. Il n\'a pas été envoyé.'))))));
	});
var $author$project$I18n$Cles$produitsReferenceImageLourdTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.lourd-titre', _List_Nil, 'Fichier trop lourd');
};
var $author$project$I18n$Cles$produitsReferenceImageOu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.ou', _List_Nil, 'ou');
};
var $author$project$I18n$Cles$produitsReferenceImageParcourir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.parcourir', _List_Nil, 'Parcourir…');
};
var $author$project$I18n$Cles$produitsReferenceImageRecu = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.image.recu',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'taille',
					$author$project$I18n$Traductions$Chaine(p.Jm)),
					_Utils_Tuple2(
					'format',
					$author$project$I18n$Traductions$Chaine(p.zP))
				]),
			p.Jm + (' · ' + p.zP));
	});
var $author$project$I18n$Cles$produitsReferenceImageReessayer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.reessayer', _List_Nil, 'Réessayer');
};
var $author$project$I18n$Cles$produitsReferenceImageRefusServeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.refus-serveur', _List_Nil, 'Le serveur n\'a pas pu enregistrer cette image. Rien n\'a été modifié.');
};
var $author$project$I18n$Cles$produitsReferenceImageRefusServeurTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.refus-serveur-titre', _List_Nil, 'Image refusée');
};
var $author$project$I18n$Cles$produitsReferenceImageRemplacer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.remplacer', _List_Nil, 'Remplacer le fichier');
};
var $author$project$I18n$Cles$produitsReferenceFichiersTailleKo = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.fichiers.taille-ko',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			p.w + ' Ko');
	});
var $author$project$I18n$Cles$produitsReferenceFichiersTailleMo = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.fichiers.taille-mo',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			p.w + ' Mo');
	});
var $author$project$I18n$Cles$produitsReferenceFichiersTailleO = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.fichiers.taille-o',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			p.w + ' o');
	});
var $author$project$Components$Produits$Reference$FichiersView$taille = F2(
	function (i18n, octets) {
		return (octets < 1024) ? A2(
			$author$project$I18n$Cles$produitsReferenceFichiersTailleO,
			i18n,
			{
				w: $elm$core$String$fromInt(octets)
			}) : ((octets < 1048576) ? A2(
			$author$project$I18n$Cles$produitsReferenceFichiersTailleKo,
			i18n,
			{
				w: $elm$core$String$fromInt(
					$elm$core$Basics$round(octets / 1024))
			}) : A2(
			$author$project$I18n$Cles$produitsReferenceFichiersTailleMo,
			i18n,
			{
				w: A3(
					$author$project$I18n$Nombre$formaterFlottant,
					$author$project$I18n$Traductions$langue(i18n),
					0,
					$elm$core$Basics$round(octets / 104857.6) / 10)
			}));
	});
var $author$project$Components$Produits$Reference$ImageView$televerser = F2(
	function (i18n, definition) {
		var refus = function () {
			var _v7 = definition.pZ;
			if (!_v7.$) {
				switch (_v7.a.$) {
					case 0:
						var nom = _v7.a.a.Dj;
						var format = _v7.a.a.zP;
						return _List_fromArray(
							[
								A2(
								$author$project$Components$Produits$Reference$ImageView$alerte,
								$author$project$I18n$Cles$produitsReferenceImageFormatTitre(i18n),
								A2(
									$author$project$I18n$Cles$produitsReferenceImageFormat,
									i18n,
									{zP: format, Dj: nom}))
							]);
					case 1:
						var lourd = _v7.a.a;
						return _List_fromArray(
							[
								A2(
								$author$project$Components$Produits$Reference$ImageView$alerte,
								$author$project$I18n$Cles$produitsReferenceImageLourdTitre(i18n),
								A2(
									$author$project$I18n$Cles$produitsReferenceImageLourd,
									i18n,
									{
										Cj: A2($author$project$Components$Produits$Reference$FichiersView$taille, i18n, lourd.Cj),
										Dj: lourd.Dj,
										FV: A2($author$project$Components$Produits$Reference$FichiersView$taille, i18n, lourd.FV)
									}))
							]);
					default:
						var _v8 = _v7.a;
						return _List_fromArray(
							[
								A2(
								$author$project$Components$Produits$Reference$ImageView$alerte,
								$author$project$I18n$Cles$produitsReferenceImageRefusServeurTitre(i18n),
								$author$project$I18n$Cles$produitsReferenceImageRefusServeur(i18n))
							]);
				}
			} else {
				return _List_Nil;
			}
		}();
		var maximum = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$Produits$Reference$Image$tailleAnnoncee,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Jn;
				},
				definition.kC));
		var zoneDeDepot = A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('depot'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
					'dragenter',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($author$project$Components$Produits$Reference$Update$ImageSurvolee, true))),
					A2(
					$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
					'dragover',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($author$project$Components$Produits$Reference$Update$ImageSurvolee, true))),
					A2(
					$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
					'drop',
					A2(
						$elm$json$Json$Decode$map,
						function (f) {
							return _Utils_Tuple2(
								$author$project$Components$Produits$Reference$Update$ImageGlissee(f),
								true);
						},
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['dataTransfer', 'files']),
							A2($elm$json$Json$Decode$index, 0, $elm$file$File$decoder))))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$b,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsReferenceImageDeposer(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsReferenceImageOu(i18n))
						])),
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('reference-image-parcourir'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Reference$Update$FichierAChoisir)
						]),
					$author$project$I18n$Cles$produitsReferenceImageParcourir(i18n)),
					A2(
					$rtfeldman$elm_css$Html$Styled$small,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$produitsReferenceImageFormats,
								i18n,
								{
									Jm: A2($author$project$Components$Produits$Reference$FichiersView$taille, i18n, maximum)
								}))
						]))
				]));
		var _v0 = _Utils_Tuple2(definition.vd, definition.me);
		_v0$6:
		while (true) {
			if (!_v0.a.$) {
				switch (_v0.b) {
					case 2:
						var choisi = _v0.a.a;
						var _v1 = _v0.b;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('fichier')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$b,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(choisi.Dj)
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2(
															$author$project$I18n$Cles$produitsReferenceImageEnvoiProgression,
															i18n,
															{
																Ga: $elm$core$String$fromInt(definition.pD),
																Jm: A2($author$project$Components$Produits$Reference$FichiersView$taille, i18n, choisi.Jm)
															}))
													])),
												A3(
												$rtfeldman$elm_css$Html$Styled$node,
												'progress',
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('barre'),
														$rtfeldman$elm_css$Html$Styled$Attributes$value(
														$elm$core$String$fromInt(definition.pD)),
														A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'max', '100')
													]),
												_List_Nil)
											])),
										A3(
										$author$project$Components$Shared$Bouton$View$bouton,
										1,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Reference$Update$ImageEnvoiAnnule)
											]),
										$author$project$I18n$Cles$produitsReferenceImageAnnulerEnvoi(i18n))
									]))
							]);
					case 1:
						var choisi = _v0.a.a;
						var _v2 = _v0.b;
						return _List_fromArray(
							[
								A4(
								$author$project$Components$Produits$Reference$ImageView$fichier,
								i18n,
								choisi.Dj,
								A2(
									$author$project$I18n$Cles$produitsReferenceImageEnvoiEnCours,
									i18n,
									{
										Jm: A2($author$project$Components$Produits$Reference$FichiersView$taille, i18n, choisi.Jm)
									}),
								_List_Nil)
							]);
					case 3:
						var choisi = _v0.a.a;
						var _v3 = _v0.b;
						return _List_fromArray(
							[
								A4(
								$author$project$Components$Produits$Reference$ImageView$fichier,
								i18n,
								choisi.Dj,
								A2(
									$author$project$I18n$Cles$produitsReferenceImageEnvoiEnCours,
									i18n,
									{
										Jm: A2($author$project$Components$Produits$Reference$FichiersView$taille, i18n, choisi.Jm)
									}),
								_List_Nil)
							]);
					case 5:
						var choisi = _v0.a.a;
						var _v4 = _v0.b;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('fichier')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$b,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(choisi.Dj)
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2(
															$author$project$I18n$Cles$produitsReferenceImageEnvoiInterrompu,
															i18n,
															{
																Jm: A2($author$project$Components$Produits$Reference$FichiersView$taille, i18n, choisi.Jm)
															}))
													]))
											])),
										A3(
										$author$project$Components$Shared$Bouton$View$bouton,
										1,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Reference$Update$ImageARessayer)
											]),
										$author$project$I18n$Cles$produitsReferenceImageReessayer(i18n))
									])),
								A2(
								$author$project$Components$Produits$Reference$ImageView$alerte,
								$author$project$I18n$Cles$produitsReferenceImageInterrompuTitre(i18n),
								A2(
									$author$project$I18n$Cles$produitsReferenceImageInterrompu,
									i18n,
									{Dj: choisi.Dj}))
							]);
					case 4:
						var choisi = _v0.a.a;
						var _v5 = _v0.b;
						return _List_fromArray(
							[
								A4(
								$author$project$Components$Produits$Reference$ImageView$fichier,
								i18n,
								choisi.Dj,
								A2(
									$author$project$I18n$Cles$produitsReferenceImageRecu,
									i18n,
									{
										zP: $author$project$Components$Produits$Reference$Image$formatDe(choisi),
										Jm: A2($author$project$Components$Produits$Reference$FichiersView$taille, i18n, choisi.Jm)
									}),
								_List_Nil),
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								2,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('remplacer'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Reference$Update$ImageARemplacer)
									]),
								$author$project$I18n$Cles$produitsReferenceImageRemplacer(i18n))
							]);
					case 6:
						var choisi = _v0.a.a;
						var _v6 = _v0.b;
						return _List_fromArray(
							[
								A4(
								$author$project$Components$Produits$Reference$ImageView$fichier,
								i18n,
								choisi.Dj,
								A2(
									$author$project$I18n$Cles$produitsReferenceImageRecu,
									i18n,
									{
										zP: $author$project$Components$Produits$Reference$Image$formatDe(choisi),
										Jm: A2($author$project$Components$Produits$Reference$FichiersView$taille, i18n, choisi.Jm)
									}),
								_List_Nil)
							]);
					default:
						break _v0$6;
				}
			} else {
				break _v0$6;
			}
		}
		return A2($elm$core$List$cons, zoneDeDepot, refus);
	});
var $author$project$Components$Produits$Reference$ImageView$drawer = F3(
	function (i18n, model, fiche) {
		var refusInitial = function () {
			var _v1 = A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.gt;
				},
				model.af);
			if ((!_v1.$) && (_v1.a.$ === 3)) {
				var motif = _v1.a.a;
				return _List_fromArray(
					[
						A2(
						$author$project$Components$Produits$Reference$ImageView$alerte,
						$author$project$I18n$Cles$produitsReferenceImageNonUtilisableTitre(i18n),
						A3(
							$author$project$Components$Produits$Reference$ImageView$nonUtilisable,
							i18n,
							A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.IR;
								},
								model.af),
							motif))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var images = A2(
			$author$project$Components$Produits$Reference$Image$imagesDeLaFiche,
			$author$project$Components$Produits$Reference$Model$champs(fiche),
			fiche);
		var peutChoisir = (!$elm$core$List$isEmpty(images)) && A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$Produits$Reference$ImageView$offert($author$project$API$NavLinksDictionary$choisirLImageDUnChamp),
				model.af));
		var definition = A2($elm$core$Maybe$withDefault, $author$project$Components$Produits$Reference$Image$nouvelle, model.wZ);
		return {
			fs: {
				sR: $author$project$Components$Produits$Reference$Image$peutEnregistrer(definition),
				Bl: $author$project$I18n$Cles$produitsReferenceImageEnregistrer(i18n),
				C$: $author$project$Components$Produits$Reference$Update$DrawerValide
			},
			fZ: _Utils_ap(
				refusInitial,
				_Utils_ap(
					A2($author$project$Components$Produits$Reference$ImageView$imageActuelle, i18n, model),
					_Utils_ap(
						_List_fromArray(
							[
								A3($author$project$Components$Produits$Reference$ImageView$origine, i18n, definition, peutChoisir)
							]),
						function () {
							var _v0 = definition.o4;
							if (!_v0) {
								return A2($author$project$Components$Produits$Reference$ImageView$televerser, i18n, definition);
							} else {
								return A4($author$project$Components$Produits$Reference$ImageView$choisir, i18n, model, definition, images);
							}
						}()))),
			A6: $elm$core$Maybe$Just(fiche.vx),
			Bc: false,
			h6: $author$project$I18n$Cles$produitsReferenceImageDrawerTitre(i18n)
		};
	});
var $author$project$Components$Produits$Reference$Update$UtilisateurRecherche = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Produits$Reference$Update$UtilisateurChoisi = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$I18n$Cles$produitsReferenceUtilisateurActif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.utilisateur-actif', _List_Nil, 'actif');
};
var $author$project$I18n$Cles$produitsReferenceUtilisateurInactifNonPropose = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.utilisateur-inactif-non-propose', _List_Nil, 'inactif · non proposé');
};
var $author$project$Components$Produits$Reference$UtilisateurView$ligne = F4(
	function (i18n, cle, choisi, proposee) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'selectionnee',
							_Utils_eq(
								choisi,
								$author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Ecrit(proposee.r8))),
							_Utils_Tuple2(
							'inactif',
							_Utils_eq(
								proposee.sO,
								$elm$core$Maybe$Just(false)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
							$rtfeldman$elm_css$Html$Styled$Attributes$name('utilisateur'),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(
							_Utils_eq(
								choisi,
								$author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Ecrit(proposee.r8))),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							A2($author$project$Components$Produits$Reference$Update$UtilisateurChoisi, cle, proposee.r8))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(proposee.Dj)
								])),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (role) {
									return _List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(' '),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('mut')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(role)
												]))
										]);
								},
								proposee.bi)))),
					function () {
					var _v0 = proposee.sO;
					if (!_v0.$) {
						if (_v0.a) {
							return A2(
								$author$project$Components$Shared$Tag$View$view,
								5,
								$author$project$I18n$Cles$produitsReferenceUtilisateurActif(i18n));
						} else {
							return A2(
								$author$project$Components$Shared$Tag$View$view,
								3,
								$author$project$I18n$Cles$produitsReferenceUtilisateurInactifNonPropose(i18n));
						}
					} else {
						return $rtfeldman$elm_css$Html$Styled$text('');
					}
				}()
				]));
	});
var $author$project$I18n$Cles$produitsReferenceUtilisateurAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.utilisateur-aucun', _List_Nil, 'Aucun utilisateur ne correspond.');
};
var $author$project$Components$Produits$Reference$UtilisateurView$lignes = F4(
	function (i18n, cle, choisi, proposes) {
		return $elm$core$List$isEmpty(proposes) ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('aucun')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsReferenceUtilisateurAucun(i18n))
					]))
			]) : A2(
			$elm$core$List$map,
			A3($author$project$Components$Produits$Reference$UtilisateurView$ligne, i18n, cle, choisi),
			proposes);
	});
var $author$project$I18n$Cles$produitsReferenceUtilisateurChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.utilisateur-champ', _List_Nil, 'Utilisateur');
};
var $author$project$I18n$Cles$produitsReferenceUtilisateurChoisirSousTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.utilisateur-choisir-sous-titre', _List_Nil, 'Un utilisateur de l\'application.');
};
var $author$project$I18n$Cles$produitsReferenceUtilisateurNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.utilisateur-note', _List_Nil, 'Un utilisateur devenu inactif reste affiché sur les fiches qui le portent, avec la mention « inactif ».');
};
var $author$project$I18n$Cles$produitsReferenceUtilisateurRecherche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.utilisateur-recherche', _List_Nil, 'Rechercher un utilisateur');
};
var $author$project$I18n$Cles$produitsReferenceUtilisateurChoisirTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.utilisateur-choisir-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'article',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeArticle(p.i4))),
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			'Choisir ' + function () {
				var _v0 = p.i4;
				switch (_v0) {
					case 0:
						return 'le ' + ($elm$core$String$toLower(
							A2($elm$core$String$left, 1, p.Bl)) + A2($elm$core$String$dropLeft, 1, p.Bl));
					case 1:
						return 'l\'' + ($elm$core$String$toLower(
							A2($elm$core$String$left, 1, p.Bl)) + A2($elm$core$String$dropLeft, 1, p.Bl));
					case 2:
						return 'la ' + ($elm$core$String$toLower(
							A2($elm$core$String$left, 1, p.Bl)) + A2($elm$core$String$dropLeft, 1, p.Bl));
					case 3:
						return 'le ' + ($elm$core$String$toLower(
							A2($elm$core$String$left, 1, p.Bl)) + A2($elm$core$String$dropLeft, 1, p.Bl));
					default:
						return 'le ' + ($elm$core$String$toLower(
							A2($elm$core$String$left, 1, p.Bl)) + A2($elm$core$String$dropLeft, 1, p.Bl));
				}
			}());
	});
var $author$project$Components$Produits$Reference$UtilisateurView$titreDuChoix = F3(
	function (i18n, genre, libelle) {
		var elide = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (c) {
					return A2(
						$elm$core$List$member,
						c,
						_List_fromArray(
							['a', 'e', 'i', 'o', 'u', 'y', 'h', 'é', 'è', 'ê', 'à', 'â', 'î', 'ô']));
				},
				$elm$core$List$head(
					$elm$core$String$toList(
						$elm$core$String$toLower(libelle)))));
		return A2(
			$author$project$I18n$Cles$produitsReferenceUtilisateurChoisirTitre,
			i18n,
			{
				i4: elide ? 1 : (_Utils_eq(
					genre,
					$elm$core$Maybe$Just(0)) ? 2 : 3),
				Bl: libelle
			});
	});
var $author$project$Components$Produits$Reference$Model$utilisateursProposes = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$eq($author$project$Components$Produits$Reference$Model$typeUtilisateur)),
					model.Gw))));
};
var $author$project$Components$Produits$Reference$UtilisateurView$drawer = F5(
	function (i18n, model, cle, libelle, genre) {
		var choisi = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$Shared$EditeurDeSchema$SaisieDeChamp$Vide,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$eq(cle)),
						model.hP.Ki))));
		return {
			fs: {
				sR: true,
				Bl: $author$project$I18n$Cles$produitsCatalogueActionsEnregistrer(i18n),
				C$: $author$project$Components$Produits$Reference$Update$DrawerValide
			},
			fZ: _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('sous-titre')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsReferenceUtilisateurChoisirSousTitre(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$fieldset,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$legend,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsReferenceUtilisateurChamp(i18n))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('search'),
									$rtfeldman$elm_css$Html$Styled$Attributes$value(model.pP),
									$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Produits$Reference$Update$UtilisateurRecherche),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									$author$project$I18n$Cles$produitsReferenceUtilisateurRecherche(i18n))
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('bloc')
								]),
							A4(
								$author$project$Components$Produits$Reference$UtilisateurView$lignes,
								i18n,
								cle,
								choisi,
								$author$project$Components$Produits$Reference$Model$utilisateursProposes(model))),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsReferenceUtilisateurNote(i18n))
								]))
						]))
				]),
			h6: A3($author$project$Components$Produits$Reference$UtilisateurView$titreDuChoix, i18n, genre, libelle)
		};
	});
var $author$project$Components$Produits$Reference$Model$genreDuChamp = F2(
	function (fiche, cle) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$eq(cle)),
					fiche.Aa)));
	});
var $author$project$Components$Produits$Reference$Update$HistoriquePage = function (a) {
	return {$: 5, a: a};
};
var $author$project$I18n$Cles$produitsReferenceHistoriqueChargement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.historique.chargement', _List_Nil, 'Chargement de l\'historique…');
};
var $author$project$I18n$Cles$produitsReferenceHistoriquePage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.historique.page',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'page',
					$author$project$I18n$Traductions$Chaine(p.EE)),
					_Utils_Tuple2(
					'pages',
					$author$project$I18n$Traductions$Chaine(p.EG))
				]),
			'Page ' + (p.EE + (' sur ' + p.EG)));
	});
var $author$project$I18n$Cles$produitsReferenceHistoriquePrecedent = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.historique.precedent', _List_Nil, 'Page précédente');
};
var $author$project$I18n$Cles$produitsReferenceHistoriqueSuivant = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.historique.suivant', _List_Nil, 'Page suivante');
};
var $author$project$I18n$Cles$produitsReferenceHistoriqueTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.historique.titre', _List_Nil, 'Historique de la référence');
};
var $author$project$Components$Produits$Reference$View$historique = F3(
	function (i18n, model, fiche) {
		var _v0 = model.m6;
		if (!_v0.$) {
			var ouvert = _v0.a;
			var _v1 = ouvert.B0;
			if (!_v1.$) {
				var lue = _v1.a;
				var pages = A2(
					$elm$core$Basics$max,
					1,
					$elm$core$Basics$ceiling(lue.JE / $author$project$Components$Produits$Reference$Model$taillePageHistorique));
				return _List_fromArray(
					[
						A3($author$project$Components$Produits$Reference$View$frise, i18n, fiche, lue.sT),
						A2(
						$rtfeldman$elm_css$Html$Styled$nav,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('pagination'),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-label',
								$author$project$I18n$Cles$produitsReferenceHistoriqueTitre(i18n))
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Produits$Reference$Update$HistoriquePage(ouvert.EE - 1)),
										$rtfeldman$elm_css$Html$Styled$Attributes$disabled(ouvert.EE <= 1)
									]),
								$author$project$I18n$Cles$produitsReferenceHistoriquePrecedent(i18n)),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('page')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$produitsReferenceHistoriquePage,
											i18n,
											{
												EE: $elm$core$String$fromInt(ouvert.EE),
												EG: $elm$core$String$fromInt(pages)
											}))
									])),
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Produits$Reference$Update$HistoriquePage(ouvert.EE + 1)),
										$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
										_Utils_cmp(ouvert.EE, pages) > -1)
									]),
								$author$project$I18n$Cles$produitsReferenceHistoriqueSuivant(i18n))
							]))
					]);
			} else {
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsReferenceHistoriqueChargement(i18n))
							]))
					]);
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Produits$Reference$Model$libelleDuChamp = F2(
	function (fiche, cle) {
		return A2(
			$elm$core$Maybe$withDefault,
			cle,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dy;
							},
							$elm$core$Basics$eq(cle)),
						$author$project$Components$Produits$Reference$Model$champs(fiche)))));
	});
var $author$project$Components$Produits$Reference$View$limitesDepassees = F2(
	function (i18n, fiche) {
		return A2(
			$elm$core$List$filterMap,
			function (cle) {
				return A2(
					$elm$core$Maybe$map,
					function (champ) {
						return _Utils_Tuple2(
							cle,
							A2($author$project$Components$Shared$EditeurDeSchema$Limites$limiteDe, i18n, champ));
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.dy;
								},
								$elm$core$Basics$eq(cle)),
							fiche.r0.dw)));
			},
			$author$project$Components$Produits$Reference$View$horsLimites(fiche));
	});
var $author$project$Components$Produits$Reference$Update$ArticleRetireDuBrouillon = function (a) {
	return {$: 48, a: a};
};
var $author$project$Components$Produits$Reference$Update$ChoixDUnPerimetreDemande = {$: 42};
var $author$project$Components$Produits$Reference$Update$ChoixDesArticlesDemande = {$: 41};
var $author$project$Components$Produits$Reference$Update$PerimetreRetireDuBrouillon = {$: 49};
var $author$project$I18n$Cles$produitsReferenceLiensArticleLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.article-libelle', _List_Nil, 'Article');
};
var $author$project$I18n$Cles$produitsReferenceLiensArticlesChoisis = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.liens.articles-choisis',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Articles choisis un par un · ' + p.w);
	});
var $author$project$I18n$Cles$produitsReferenceLiensChoisirDesArticles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.choisir-des-articles', _List_Nil, 'Choisir des articles');
};
var $author$project$I18n$Cles$produitsReferenceLiensDejaDansLePerimetre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.deja-dans-le-perimetre', _List_Nil, 'Déjà dans le périmètre : compté une fois');
};
var $author$project$I18n$Cles$produitsReferenceLiensEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$produitsReferenceLiensHorsPerimetreResteDansLaValeur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.liens.hors-perimetre-reste-dans-la-valeur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'marque',
					$author$project$I18n$Traductions$Chaine(p.gX))
				]),
			'Hors périmètre (' + (p.gX + ') : reste dans la valeur'));
	});
var $author$project$I18n$Cles$produitsReferenceLiensIndisponible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.indisponible', _List_Nil, 'Article indisponible');
};
var $author$project$I18n$Cles$produitsReferenceLiensModifierTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.modifier-titre', _List_Nil, 'Modifier les articles liés');
};
var $author$project$I18n$Cles$produitsReferenceLiensModifierTitreUnSeul = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.modifier-titre-un-seul', _List_Nil, 'Modifier l\'article lié');
};
var $author$project$I18n$Cles$produitsReferenceLiensPerimetreAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.perimetre-aide', _List_Nil, 'Un seul périmètre par valeur. Tous les articles qu\'il contient (aujourd\'hui et demain) font partie de la valeur.');
};
var $author$project$I18n$Cles$produitsReferenceLiensPerimetreCree = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.liens.perimetre-cree',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Périmètre « ' + (p.Dj + (' » créé : ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' article. Il est mis dans la valeur ci-dessous ; rien n\'est enregistré sur le champ avant « Enregistrer ».')))) : ('Périmètre « ' + (p.Dj + (' » créé : ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' articles. Il est mis dans la valeur ci-dessous ; rien n\'est enregistré sur le champ avant « Enregistrer ».')))));
	});
var $author$project$I18n$Cles$produitsReferenceLiensPerimetreLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.perimetre-libelle', _List_Nil, 'Périmètre');
};
var $author$project$I18n$Cles$produitsReferenceLiensPerimetreNouveau = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.perimetre-nouveau', _List_Nil, 'Nouveau');
};
var $author$project$I18n$Cles$produitsReferenceLiensRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.retirer', _List_Nil, 'Retirer');
};
var $author$project$I18n$Cles$produitsReferenceLiensRetirerNom = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.liens.retirer-nom',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer le lien vers ' + p.Dj);
	});
var $author$project$I18n$Cles$produitsCatalogueErreurPerime = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.erreur.perime', _List_Nil, 'Le catalogue a changé entre-temps : la page vient d\'être relue. Recommencez si nécessaire.');
};
var $author$project$I18n$Cles$produitsReferenceLiensRefusPerimetreIndisponible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.refus-perimetre-indisponible', _List_Nil, 'Ce périmètre n\'est plus disponible (supprimé ou archivé). Choisissez-en un autre. Rien n\'a été enregistré.');
};
var $author$project$I18n$Cles$produitsReferenceLiensRefusUnSeulArticle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.refus-un-seul-article', _List_Nil, 'Ce champ n\'accepte qu\'un seul article. Un périmètre contient plusieurs articles. Choisissez un article, ou demandez à un administrateur de passer le champ à « plusieurs articles ». Rien n\'a été enregistré.');
};
var $author$project$Components$Produits$Reference$ArticlesView$refusDuBrouillon = F2(
	function (i18n, code) {
		switch (code) {
			case 'PerimetreSurUnChampUnSeul':
				return $author$project$I18n$Cles$produitsReferenceLiensRefusUnSeulArticle(i18n);
			case 'PerimetreIndisponible':
				return $author$project$I18n$Cles$produitsReferenceLiensRefusPerimetreIndisponible(i18n);
			default:
				return $author$project$I18n$Cles$produitsCatalogueErreurPerime(i18n);
		}
	});
var $author$project$I18n$Cles$produitsReferenceLiensTotalAuTotal = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.liens.total-au-total',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' article au total') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' articles au total'));
	});
var $author$project$Components$Produits$Reference$ArticlesView$totalAuTotal = F3(
	function (i18n, apercu, brouillon) {
		var dit = function (nombre) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('tot'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$produitsReferenceLiensTotalAuTotal,
							i18n,
							{w: nombre}))
					]));
		};
		var _v0 = _Utils_Tuple2(brouillon.E9, brouillon.tP);
		if (_v0.a.$ === 1) {
			if (!_v0.b.b) {
				var _v1 = _v0.a;
				return $rtfeldman$elm_css$Html$Styled$text('');
			} else {
				var _v2 = _v0.a;
				var articles = _v0.b;
				return dit(
					$elm$core$List$length(articles));
			}
		} else {
			return A2(
				$elm$core$Maybe$withDefault,
				$rtfeldman$elm_css$Html$Styled$text(''),
				A2($elm$core$Maybe$map, dit, apercu));
		}
	});
var $author$project$Components$Produits$Reference$ArticlesView$modification = F3(
	function (i18n, model, fiche) {
		var _v0 = model.uw;
		if (!_v0.$) {
			var brouillon = _v0.a;
			var total = $elm$core$List$length(brouillon.tP);
			var nomDe = function (id) {
				return A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map(
							$author$project$I18n$Cles$texte(i18n)),
						$elm$core$String$join(' \u00B7 ')),
					A2($elm$core$Dict$get, id, brouillon.DG));
			};
			var connu = function (id) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(id)),
						A2(
							$elm$core$List$concatMap,
							function ($) {
								return $.tP;
							},
							fiche.BQ)));
			};
			var marque = function (id) {
				return A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.zX;
					},
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.gX;
						},
						connu(id)));
			};
			var codeDe = function (id) {
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.vx;
						},
						connu(id)));
			};
			var apercu = A2(
				$elm$core$Maybe$andThen,
				function (choisi) {
					return _Utils_eq(
						model.tt,
						$elm$core$Maybe$Just(
							_Utils_Tuple2(choisi.Aq, brouillon.tP))) ? A2(
						$elm$core$Dict$get,
						$author$project$Components$Produits$Reference$Model$cleDeLApercu(choisi.Aq),
						model.ih) : $elm$core$Maybe$Nothing;
				},
				brouillon.E9);
			var dejaDansLePerimetre = function (id) {
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.jL;
							},
							$elm$core$List$any(
								function (choisi) {
									return _Utils_eq(choisi.r8, id) && choisi.w_;
								})),
						apercu));
			};
			var lignePropre = function (id) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('article-lie')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('main')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('title')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$elm$core$Maybe$withDefault,
												$author$project$I18n$Cles$produitsReferenceLiensIndisponible(i18n),
												nomDe(id)))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('infos')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$elm$core$String$join,
												' \u00B7 ',
												A2(
													$elm$core$List$filter,
													function (t) {
														return t !== '';
													},
													_List_fromArray(
														[
															codeDe(id),
															A2(
															$elm$core$Maybe$withDefault,
															'',
															marque(id))
														]))))
										])),
									(_Utils_eq(brouillon.E9, $elm$core$Maybe$Nothing) || _Utils_eq(apercu, $elm$core$Maybe$Nothing)) ? $rtfeldman$elm_css$Html$Styled$text('') : (dejaDansLePerimetre(id) ? A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('infos'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('deja-dans-le-perimetre')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsReferenceLiensDejaDansLePerimetre(i18n))
										])) : A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('infos'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('hors-perimetre')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$produitsReferenceLiensHorsPerimetreResteDansLaValeur,
												i18n,
												{
													gX: A2(
														$elm$core$Maybe$withDefault,
														'',
														marque(id))
												}))
										])))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									2,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
											'aria-label',
											A2(
												$author$project$I18n$Cles$produitsReferenceLiensRetirerNom,
												i18n,
												{
													Dj: A2(
														$elm$core$Maybe$withDefault,
														id,
														nomDe(id))
												})),
											$rtfeldman$elm_css$Html$Styled$Attributes$title(
											A2(
												$author$project$I18n$Cles$produitsReferenceLiensRetirerNom,
												i18n,
												{
													Dj: A2(
														$elm$core$Maybe$withDefault,
														id,
														nomDe(id))
												})),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Produits$Reference$Update$ArticleRetireDuBrouillon(id))
										]),
									$author$project$I18n$Cles$produitsReferenceLiensRetirer(i18n))
								]))
						]));
			};
			return {
				fs: {
					sR: true,
					Bl: $author$project$I18n$Cles$produitsReferenceLiensEnregistrer(i18n),
					C$: $author$project$Components$Produits$Reference$Update$DrawerValide
				},
				fZ: _List_fromArray(
					[
						function () {
						var _v1 = brouillon.kk;
						if (!_v1.$) {
							var nom = _v1.a;
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('bandeau'),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$produitsReferenceLiensPerimetreCree,
											i18n,
											{
												Dj: nom,
												w: A2(
													$elm$core$Maybe$withDefault,
													0,
													A2(
														$elm$core$Maybe$andThen,
														function ($) {
															return $.wT;
														},
														brouillon.E9))
											}))
									]));
						} else {
							return $rtfeldman$elm_css$Html$Styled$text('');
						}
					}(),
						function () {
						var _v2 = brouillon.pZ;
						if (!_v2.$) {
							var code = _v2.a;
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('refus'),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$strong,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2($author$project$Components$Produits$Reference$ArticlesView$refusDuBrouillon, i18n, code))
											]))
									]));
						} else {
							return $rtfeldman$elm_css$Html$Styled$text('');
						}
					}(),
						((!brouillon.FS) && _Utils_eq(brouillon.E9, $elm$core$Maybe$Nothing)) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
						$rtfeldman$elm_css$Html$Styled$fieldset,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('perimetre-choisi'),
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'error',
										!_Utils_eq(brouillon.pZ, $elm$core$Maybe$Nothing))
									]))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$legend,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$produitsReferenceLiensPerimetreLibelle(i18n))
											]))
									])),
								function () {
								var _v3 = brouillon.E9;
								if (_v3.$ === 1) {
									return brouillon.FS ? A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Components$Produits$Reference$ArticlesView$pointille,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Reference$Update$ChoixDUnPerimetreDemande),
														$rtfeldman$elm_css$Html$Styled$Attributes$id('choisir-un-perimetre')
													]),
												$author$project$I18n$Cles$produitsReferenceLiensChoisirUnPerimetre(i18n)),
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$produitsReferenceLiensPerimetreAide(i18n))
													]))
											])) : $rtfeldman$elm_css$Html$Styled$text('');
								} else {
									var choisi = _v3.a;
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('main')
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$strong,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('title')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(choisi.Dj)
															])),
														(!_Utils_eq(brouillon.kk, $elm$core$Maybe$Nothing)) ? A2(
														$author$project$Components$Shared$Tag$View$view,
														5,
														$author$project$I18n$Cles$produitsReferenceLiensPerimetreNouveau(i18n)) : $rtfeldman$elm_css$Html$Styled$text(''),
														$author$project$Components$Produits$Reference$ArticlesView$resume(
														$elm$core$List$isEmpty(choisi.wp) ? A2(
															$elm$core$Maybe$withDefault,
															_List_Nil,
															A2(
																$elm$core$Maybe$map,
																function ($) {
																	return $.wp;
																},
																apercu)) : choisi.wp),
														function () {
														var _v4 = choisi.wT;
														if (!_v4.$) {
															var nombre = _v4.a;
															return A2(
																$rtfeldman$elm_css$Html$Styled$span,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('infos')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(
																		A2(
																			$author$project$I18n$Cles$produitsReferenceLiensPerimetreDecompte,
																			i18n,
																			{w: nombre}))
																	]));
														} else {
															return $rtfeldman$elm_css$Html$Styled$text('');
														}
													}()
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
													]),
												_List_fromArray(
													[
														A3(
														$author$project$Components$Shared$Bouton$View$bouton,
														2,
														_List_fromArray(
															[
																A2(
																$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
																'aria-label',
																A2(
																	$author$project$I18n$Cles$produitsReferenceLiensRetirerNom,
																	i18n,
																	{Dj: choisi.Dj})),
																$rtfeldman$elm_css$Html$Styled$Attributes$title(
																A2(
																	$author$project$I18n$Cles$produitsReferenceLiensRetirerNom,
																	i18n,
																	{Dj: choisi.Dj})),
																$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Reference$Update$PerimetreRetireDuBrouillon)
															]),
														$author$project$I18n$Cles$produitsReferenceLiensRetirer(i18n))
													]))
											]));
								}
							}()
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$fieldset,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('articles-choisis')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$legend,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												brouillon.FS ? A2(
													$author$project$I18n$Cles$produitsReferenceLiensArticlesChoisis,
													i18n,
													{
														w: $elm$core$String$fromInt(total)
													}) : $author$project$I18n$Cles$produitsReferenceLiensArticleLibelle(i18n))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$ul,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('articles-lies')
									]),
								A2($elm$core$List$map, lignePropre, brouillon.tP)),
								(brouillon.FS || (!total)) ? A2(
								$author$project$Components$Produits$Reference$ArticlesView$pointille,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Reference$Update$ChoixDesArticlesDemande),
										$rtfeldman$elm_css$Html$Styled$Attributes$id('choisir-des-articles')
									]),
								$author$project$I18n$Cles$produitsReferenceLiensChoisirDesArticles(i18n)) : $rtfeldman$elm_css$Html$Styled$text('')
							])),
						A3(
						$author$project$Components$Produits$Reference$ArticlesView$totalAuTotal,
						i18n,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.JE;
							},
							apercu),
						brouillon)
					]),
				h6: brouillon.FS ? $author$project$I18n$Cles$produitsReferenceLiensModifierTitre(i18n) : $author$project$I18n$Cles$produitsReferenceLiensModifierTitreUnSeul(i18n)
			};
		} else {
			return {
				fs: {sR: false, Bl: '', C$: $author$project$Components$Produits$Reference$Update$DrawerValide},
				fZ: _List_Nil,
				h6: ''
			};
		}
	});
var $author$project$Components$Produits$Reference$Lecture$ordreDeLaFiche = function (groupes) {
	var nature = function (section) {
		return A2(
			$elm$core$Maybe$withDefault,
			'categorie',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.F$;
					},
					function ($) {
						return $.g1;
					}),
				section.AL));
	};
	var de = function (voulue) {
		return A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				nature,
				$elm$core$Basics$eq(voulue)),
			groupes);
	};
	return _Utils_ap(
		de('categorie'),
		_Utils_ap(
			de('noeud'),
			_Utils_ap(
				de('typologie'),
				de('catalogue'))));
};
var $author$project$Components$Produits$Reference$Update$ImageARetirerDemandee = {$: 88};
var $author$project$Components$Produits$Reference$ImageView$estNonUtilisable = function (etat) {
	if (etat.$ === 3) {
		return true;
	} else {
		return false;
	}
};
var $author$project$I18n$Cles$produitsReferenceImageRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.retirer', _List_Nil, 'Retirer l\'image…');
};
var $author$project$Components$Produits$Reference$ImageView$pied = F2(
	function (i18n, model) {
		return {
			oJ: $elm$core$Maybe$Nothing,
			HF: function (attributs) {
				return A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_Utils_ap(
						attributs,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Produits$Reference$Update$DuDrawer($author$project$Components$Shared$Drawer$Update$Fermer))
							])),
					$author$project$I18n$Cles$drawerAnnuler(i18n));
			},
			Jb: A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (image) {
						return A2($author$project$Components$Produits$Reference$ImageView$offert, $author$project$API$NavLinksDictionary$retirerLImage, image) && (!$author$project$Components$Produits$Reference$ImageView$estNonUtilisable(image.gt));
					},
					model.af)) ? _List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					3,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('reference-image-retirer'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Reference$Update$ImageARetirerDemandee)
						]),
					$author$project$I18n$Cles$produitsReferenceImageRetirer(i18n))
				]) : _List_Nil
		};
	});
var $author$project$I18n$Cles$produitsValeursArchivageAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.archivage.action', _List_Nil, 'Archiver le produit');
};
var $author$project$I18n$Cles$produitsValeursArchivageEtat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.archivage.etat', _List_Nil, 'Archivé');
};
var $author$project$Components$Produits$Common$ArchivageDuProduitView$action = F3(
	function (i18n, gestes, archivage) {
		var _v0 = _Utils_Tuple2(archivage.tE, archivage.nB);
		if (_v0.a) {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('etat')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							3,
							$author$project$I18n$Cles$produitsValeursArchivageEtat(i18n))
						]))
				]);
		} else {
			if (!_v0.b.$) {
				return _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						2,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('archiver-le-produit'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(gestes.kE)
							]),
						$author$project$I18n$Cles$produitsValeursArchivageAction(i18n))
					]);
			} else {
				return _List_Nil;
			}
		}
	});
var $author$project$I18n$Cles$produitsValeursArchivageQuestion = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.archivage.question',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Archiver « ' + (p.Dj + ' » ? Le produit restera dans la liste, marqué archivé.'));
	});
var $author$project$Components$Produits$Common$ArchivageDuProduitView$confirmation = F3(
	function (i18n, gestes, ouverte) {
		return {
			fs: {
				sR: ouverte.sR,
				Bl: $author$project$I18n$Cles$produitsCatalogueArchivageConfirmer(i18n),
				C$: gestes.j7
			},
			fZ: _List_fromArray(
				[
					ouverte.pZ,
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('question')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$produitsValeursArchivageQuestion,
										i18n,
										{Dj: ouverte.Dj}))
								]))
						])),
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('annuler-l-archivage-du-produit'),
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(gestes.to)
						]),
					$author$project$I18n$Cles$produitsCatalogueArchivageAnnuler(i18n))
				]),
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: $author$project$I18n$Cles$produitsCatalogueArchivageTitre(i18n)
		};
	});
var $author$project$Components$Produits$Reference$Update$ProduitArchivageAnnule = {$: 37};
var $author$project$Components$Produits$Reference$Update$ProduitArchivageConfirme = {$: 38};
var $author$project$Components$Produits$Reference$Update$ProduitArchivageDemande = {$: 36};
var $author$project$Components$Produits$Reference$View$gestesDArchivage = {to: $author$project$Components$Produits$Reference$Update$ProduitArchivageAnnule, j7: $author$project$Components$Produits$Reference$Update$ProduitArchivageConfirme, kE: $author$project$Components$Produits$Reference$Update$ProduitArchivageDemande};
var $author$project$I18n$Cles$produitsReferenceHistoriqueFermer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.historique.fermer', _List_Nil, 'Fermer');
};
var $author$project$I18n$Cles$produitsReferenceProduitIllisible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.produit.illisible', _List_Nil, 'La fiche du produit n\'a pas pu être lue.');
};
var $author$project$I18n$Cles$produitsReferenceProduitTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.produit.titre', _List_Nil, 'Produit de la référence');
};
var $author$project$Components$Produits$Reference$View$produitEnDrawer = F3(
	function (i18n, model, refus) {
		var _v0 = model.pC;
		if (!_v0.$) {
			var ouvert = _v0.a;
			return ouvert.tD.aW ? A3(
				$author$project$Components$Produits$Common$ArchivageDuProduitView$confirmation,
				i18n,
				$author$project$Components$Produits$Reference$View$gestesDArchivage,
				{
					sR: !$author$project$Components$Produits$Common$Envoi$enCours(model.l2),
					Dj: ouvert.Dj,
					pZ: refus
				}) : {
				fs: {
					sR: true,
					Bl: $author$project$I18n$Cles$produitsReferenceHistoriqueFermer(i18n),
					C$: $author$project$Components$Produits$Reference$Update$DrawerValide
				},
				fZ: A2(
					$elm$core$List$cons,
					refus,
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('explication')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(ouvert.Dj)
								])),
						ouvert.Ax ? _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsReferenceProduitIllisible(i18n))
									]))
							]) : A3($author$project$Components$Produits$Common$ArchivageDuProduitView$action, i18n, $author$project$Components$Produits$Reference$View$gestesDArchivage, ouvert.tD))),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$produitsReferenceProduitTitre(i18n)
			};
		} else {
			return {
				fs: {sR: false, Bl: '', C$: $author$project$Components$Produits$Reference$Update$DrawerValide},
				fZ: _List_Nil,
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: ''
			};
		}
	});
var $author$project$I18n$Cles$produitsReferenceDupliquer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.dupliquer', _List_Nil, 'Dupliquer en variante');
};
var $author$project$I18n$Cles$produitsReferenceDupliquerCodeNouveau = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.dupliquer.code.nouveau', _List_Nil, 'Un nouveau code est attendu.');
};
var $author$project$I18n$Cles$produitsReferenceDupliquerNote = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.dupliquer.note',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'code',
					$author$project$I18n$Traductions$Chaine(p.vx))
				]),
			'Les informations de ' + (p.vx + ' sont copiées. La variante prend un nouveau code et une nouvelle variante.'));
	});
var $author$project$I18n$Cles$produitsReferenceDupliquerValider = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.dupliquer.valider', _List_Nil, 'Créer la variante');
};
var $author$project$I18n$Cles$produitsReferenceDupliquerVarianteNouvelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.dupliquer.variante.nouvelle', _List_Nil, 'Une nouvelle variante est attendue.');
};
var $author$project$I18n$Cles$produitsReferenceFicheDrawerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fiche.drawer-titre', _List_Nil, 'Modifier la fiche d\'information');
};
var $author$project$I18n$Cles$produitsReferenceCalculAppliquer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.calcul.appliquer', _List_Nil, 'Appliquer');
};
var $author$project$I18n$Cles$produitsReferenceCalculApres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.calcul.apres', _List_Nil, 'Après');
};
var $author$project$I18n$Cles$produitsReferenceCalculAvant = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.calcul.avant', _List_Nil, 'Avant');
};
var $author$project$I18n$Cles$produitsReferenceCalculIllisible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.calcul.illisible', _List_Nil, 'L\'aperçu du recalcul n\'a pas pu être lu.');
};
var $author$project$I18n$Cles$produitsReferenceCodeRecalculNumeroGarde = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.code.recalcul.numero-garde', _List_Nil, 'Le début du code ne change pas : le numéro actuel est conservé.');
};
var $author$project$I18n$Cles$produitsReferenceCodeRecalculNumeroNouveau = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.code.recalcul.numero-nouveau', _List_Nil, 'Le début du code change : un nouveau numéro est attribué dans le nouveau préfixe, à l\'application.');
};
var $author$project$Components$Produits$Reference$View$recalculDuCodeEnDrawer = F3(
	function (i18n, model, refus) {
		var lu = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.B0;
			},
			model.iV);
		var libre = !$author$project$Components$Produits$Common$Envoi$enCours(model.l2);
		return {
			fs: {
				sR: libre && (!_Utils_eq(lu, $elm$core$Maybe$Nothing)),
				Bl: $author$project$I18n$Cles$produitsReferenceCalculAppliquer(i18n),
				C$: $author$project$Components$Produits$Reference$Update$CodeApplique($elm$core$Maybe$Nothing)
			},
			fZ: A2(
				$elm$core$List$cons,
				refus,
				function () {
					var _v0 = model.iV;
					if (!_v0.$) {
						var illisible = _v0.a.Ax;
						if (illisible) {
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsReferenceCalculIllisible(i18n))
										]))
								]);
						} else {
							if (!lu.$) {
								var apercu = lu.a;
								return _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('avant-apres')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('avant')
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$produitsReferenceCalculAvant(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(apercu.ti)
															]))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('apres')
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$produitsReferenceCalculApres(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(apercu.en)
															]))
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												apercu.DY ? $author$project$I18n$Cles$produitsReferenceCodeRecalculNumeroGarde(i18n) : $author$project$I18n$Cles$produitsReferenceCodeRecalculNumeroNouveau(i18n))
											]))
									]);
							} else {
								return _List_Nil;
							}
						}
					} else {
						return _List_Nil;
					}
				}()),
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: $author$project$I18n$Cles$produitsReferenceCodeRecalculer(i18n)
		};
	});
var $author$project$Components$Produits$Reference$Update$RecalculApplique = {$: 29};
var $author$project$I18n$Cles$produitsReferenceCalculDrawerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.calcul.drawer-titre', _List_Nil, 'Recalculer ce champ');
};
var $author$project$I18n$Cles$produitsReferenceCalculNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.calcul.note', _List_Nil, 'Rien ne change tant que vous ne confirmez pas.');
};
var $author$project$I18n$Cles$produitsReferenceCalculSourceChangee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.calcul.source-changee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'avant',
					$author$project$I18n$Traductions$Chaine(p.je)),
					_Utils_Tuple2(
					'apres',
					$author$project$I18n$Traductions$Chaine(p.iY))
				]),
			'Recalcul sur demande : « ' + (p.Dj + (' » est passé de ' + (p.je + (' à ' + (p.iY + '.'))))));
	});
var $author$project$I18n$Cles$produitsReferenceCalculVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.calcul.vide', _List_Nil, 'non renseigné');
};
var $author$project$I18n$Cles$produitsReferenceUtilisateurInactif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.utilisateur-inactif', _List_Nil, 'Utilisateur inactif');
};
var $author$project$I18n$Cles$produitsReferenceUtilisateurIndisponible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.utilisateur-indisponible', _List_Nil, 'Utilisateur indisponible');
};
var $author$project$Components$Produits$Vocabulaire$libelleDeLUtilisateurSansNom = F2(
	function (i18n, etat) {
		if (etat === 'indisponible') {
			return $author$project$I18n$Cles$produitsReferenceUtilisateurIndisponible(i18n);
		} else {
			return $author$project$I18n$Cles$produitsReferenceUtilisateurInactif(i18n);
		}
	});
var $author$project$Components$Produits$Reference$Model$nomDeLUtilisateur = F3(
	function (i18n, fiche, uid) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Cles$produitsReferenceUtilisateurInactif(i18n),
			A2(
				$elm$core$Maybe$map,
				function (lu) {
					return A2(
						$elm$core$Maybe$withDefault,
						A2($author$project$Components$Produits$Vocabulaire$libelleDeLUtilisateurSansNom, i18n, lu.gt),
						lu.Dj);
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.r8;
							},
							$elm$core$Basics$eq(uid)),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.Kf;
								},
								fiche.eA))))));
	});
var $author$project$Components$Produits$Reference$Lecture$texte = F5(
	function (i18n, normes, fiche, champ, valeur) {
		var unite = function (code) {
			return A2(
				$elm$core$Maybe$withDefault,
				code,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Jh;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.vx;
								},
								$elm$core$Basics$eq(code)),
							fiche.sb))));
		};
		var simple = function (t) {
			return ($elm$core$String$trim(t) === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				_Utils_Tuple2(t, $elm$core$Maybe$Nothing));
		};
		var nomme = F2(
			function (nomDe, codes) {
				return $elm$core$List$isEmpty(codes) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					_Utils_Tuple2(
						A2(
							$elm$core$String$join,
							', ',
							A2($elm$core$List$map, nomDe, codes)),
						$elm$core$Maybe$Nothing));
			});
		var langue = A2(
			$elm$core$Maybe$withDefault,
			'fr',
			$elm$core$List$head(fiche.Ba));
		var choix = function (id) {
			return A2(
				$elm$core$Maybe$withDefault,
				id,
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$libelle(langue),
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(id)),
							A2(
								$elm$core$List$concatMap,
								function (c) {
									return _Utils_ap(c.hu, c.pE);
								},
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.dy;
										},
										$elm$core$Basics$eq(champ.dy)),
									fiche.jN))))));
		};
		var enChoix = function (ids) {
			return $elm$core$List$isEmpty(ids) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				_Utils_Tuple2(
					A2(
						$elm$core$String$join,
						', ',
						A2($elm$core$List$map, choix, ids)),
					$elm$core$Maybe$Nothing));
		};
		var _v0 = _Utils_Tuple2(champ.r0, valeur);
		switch (_v0.b.$) {
			case 0:
				var _v1 = _v0.b;
				return $elm$core$Maybe$Nothing;
			case 6:
				var _v2 = _v0.b;
				return $elm$core$Maybe$Nothing;
			case 7:
				var _v3 = _v0.b;
				return $elm$core$Maybe$Nothing;
			case 8:
				return $elm$core$Maybe$Nothing;
			case 9:
				var lue = _v0.b.a;
				return simple(
					A2(
						$elm$core$String$join,
						', ',
						_Utils_ap(
							lue.gV,
							A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(''),
								_List_fromArray(
									[
										$elm$core$String$trim(
										A2($elm$core$Maybe$withDefault, '', lue.vz) + (' ' + lue.B_)),
										A2($elm$core$Maybe$withDefault, '', lue.Hj),
										A2($author$project$Referentiel$Normes$nomDePays, normes, lue.ho)
									])))));
			case 2:
				if (_v0.a.$ === 10) {
					var mesure = _v0.a.a;
					var n = _v0.b.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							_Utils_ap(
								((n > 0) && ((mesure.sa === 'pct') && A2(
									$elm$core$List$any,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.uN;
										},
										$elm$core$Basics$eq(champ.dy)),
									fiche.uD))) ? '+' : '',
								A3(
									$author$project$I18n$Nombre$formaterFlottant,
									$author$project$I18n$Traductions$langue(i18n),
									mesure.kv,
									n)),
							$elm$core$Maybe$Just(
								unite(mesure.sa))));
				} else {
					var n = _v0.b.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							A2(
								$author$project$Components$Produits$Reference$Lecture$nombreRendu,
								i18n,
								$elm$core$String$fromFloat(n)),
							$elm$core$Maybe$Nothing));
				}
			case 3:
				if (_v0.b.a) {
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							$author$project$I18n$Cles$produitsReferenceSaisieOui(i18n),
							$elm$core$Maybe$Nothing));
				} else {
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							$author$project$I18n$Cles$produitsReferenceSaisieNon(i18n),
							$elm$core$Maybe$Nothing));
				}
			case 4:
				switch (_v0.a.$) {
					case 17:
						var ids = _v0.b.a;
						return enChoix(ids);
					case 15:
						var codes = _v0.b.a;
						return A2(
							nomme,
							$author$project$Referentiel$Normes$nomDePays(normes),
							codes);
					case 16:
						var codes = _v0.b.a;
						return A2(
							nomme,
							$author$project$Referentiel$Normes$nomDeLangue(normes),
							codes);
					default:
						var ids = _v0.b.a;
						return $elm$core$List$isEmpty(ids) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							_Utils_Tuple2(
								A2($elm$core$String$join, ', ', ids),
								$elm$core$Maybe$Nothing));
				}
			case 1:
				switch (_v0.a.$) {
					case 17:
						var id = _v0.b.a;
						return enChoix(
							_List_fromArray(
								[id]));
					case 15:
						var code = _v0.b.a;
						return simple(
							A2($author$project$Referentiel$Normes$nomDePays, normes, code));
					case 16:
						var code = _v0.b.a;
						return simple(
							A2($author$project$Referentiel$Normes$nomDeLangue, normes, code));
					case 5:
						var _v4 = _v0.a;
						var iso = _v0.b.a;
						return simple(
							A2($author$project$Texte$Jour$enFrancais, i18n, iso));
					case 20:
						var _v5 = _v0.a;
						var uid = _v0.b.a;
						return simple(
							A3($author$project$Components$Produits$Reference$Model$nomDeLUtilisateur, i18n, fiche, uid));
					case 19:
						var uid = _v0.b.a;
						return simple(
							A3(
								$author$project$Components$Shared$EditeurDeSchema$Groupe$texteDeLaFiche,
								i18n,
								$author$project$Components$Produits$Reference$Model$fichesCitees(fiche),
								uid));
					default:
						var t = _v0.b.a;
						return simple(
							A2(
								$elm$core$Maybe$withDefault,
								t,
								A2($elm$core$Dict$get, champ.dy, fiche.Br)));
				}
			default:
				var parLangue = _v0.b.a;
				return A2(
					$elm$core$Maybe$map,
					function (t) {
						return _Utils_Tuple2(t, $elm$core$Maybe$Nothing);
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filterMap,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$second,
								$elm$core$Maybe$andThen(
									function (t) {
										return ($elm$core$String$trim(t) === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(t);
									})),
							_Utils_ap(
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Tuple$first,
										$elm$core$Basics$eq(langue)),
									parLangue),
								parLangue))));
		}
	});
var $author$project$Components$Produits$Reference$Lecture$valeurDuCalcul = F5(
	function (i18n, normes, fiche, cle, dite) {
		var _v0 = _Utils_Tuple2(
			$elm$core$String$toFloat(dite),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dy;
						},
						$elm$core$Basics$eq(cle)),
					fiche.r0.dw)));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var n = _v0.a.a;
			var champ = _v0.b.a;
			return A2(
				$elm$core$Maybe$withDefault,
				dite,
				A2(
					$elm$core$Maybe$map,
					function (_v1) {
						var valeur = _v1.a;
						var unite = _v1.b;
						return _Utils_ap(
							valeur,
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$elm$core$Basics$append('\u00A0'),
									unite)));
					},
					A5(
						$author$project$Components$Produits$Reference$Lecture$texte,
						i18n,
						normes,
						fiche,
						champ,
						$author$project$Components$Shared$EditeurDeSchema$ValeurDAttribut$Nombre(n))));
		} else {
			return A2($author$project$Components$Produits$Reference$Lecture$nombreRendu, i18n, dite);
		}
	});
var $author$project$Components$Produits$Reference$View$recalculEnDrawer = F3(
	function (i18n, model, refus) {
		var valeur = F2(
			function (cle, v) {
				var _v4 = _Utils_Tuple2(model.zo, v);
				if ((!_v4.a.$) && (!_v4.b.$)) {
					var fiche = _v4.a.a;
					var dite = _v4.b.a;
					return A5($author$project$Components$Produits$Reference$Lecture$valeurDuCalcul, i18n, model.hd, fiche, cle, dite);
				} else {
					return A2(
						$elm$core$Maybe$withDefault,
						$author$project$I18n$Cles$produitsReferenceCalculVide(i18n),
						v);
				}
			});
		var sourcesChangees = F2(
			function (fiche, apercu) {
				return A2(
					$elm$core$List$filterMap,
					function (_v2) {
						var cle = _v2.a;
						var apres = _v2.b;
						return A2(
							$elm$core$Maybe$andThen,
							function (_v3) {
								var avant = _v3.b;
								return _Utils_eq(avant, apres) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
									A2(
										$author$project$I18n$Cles$produitsReferenceCalculSourceChangee,
										i18n,
										{
											iY: A5($author$project$Components$Produits$Reference$Lecture$valeurDuCalcul, i18n, model.hd, fiche, cle, apres),
											je: A5($author$project$Components$Produits$Reference$Lecture$valeurDuCalcul, i18n, model.hd, fiche, cle, avant),
											Dj: A2(
												$elm$core$Maybe$withDefault,
												cle,
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.Bl;
													},
													$elm$core$List$head(
														A2(
															$elm$core$List$filter,
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.dy;
																},
																$elm$core$Basics$eq(cle)),
															fiche.r0.dw))))
										}));
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Tuple$first,
										$elm$core$Basics$eq(cle)),
									apercu.IU)));
					},
					apercu.IT);
			});
		return {
			fs: {
				sR: (!$author$project$Components$Produits$Common$Envoi$enCours(model.l2)) && (!_Utils_eq(
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.B0;
						},
						model.tq),
					$elm$core$Maybe$Nothing)),
				Bl: $author$project$I18n$Cles$produitsReferenceCalculAppliquer(i18n),
				C$: $author$project$Components$Produits$Reference$Update$RecalculApplique
			},
			fZ: A2(
				$elm$core$List$cons,
				refus,
				function () {
					var _v0 = model.tq;
					if (!_v0.$) {
						var ouvert = _v0.a;
						var lu = ouvert.B0;
						var illisible = ouvert.Ax;
						if (illisible) {
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsReferenceCalculIllisible(i18n))
										]))
								]);
						} else {
							if (!lu.$) {
								var apercu = lu.a;
								return _Utils_ap(
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('avant-apres')
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$div,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('avant')
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$span,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	$author$project$I18n$Cles$produitsReferenceCalculAvant(i18n))
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$span,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	A2(valeur, ouvert.uN, apercu.iN))
																]))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$div,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('apres')
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$span,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	$author$project$I18n$Cles$produitsReferenceCalculApres(i18n))
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$span,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	A2(valeur, ouvert.uN, apercu.oS))
																]))
														]))
												]))
										]),
									_Utils_ap(
										A2(
											$elm$core$List$map,
											function (phrase) {
												return A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(phrase)
														]));
											},
											A2(
												$elm$core$Maybe$withDefault,
												_List_Nil,
												A2(
													$elm$core$Maybe$map,
													function (fiche) {
														return A2(sourcesChangees, fiche, apercu);
													},
													model.zo))),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$produitsReferenceCalculNote(i18n))
													]))
											])));
							} else {
								return _List_Nil;
							}
						}
					} else {
						return _List_Nil;
					}
				}()),
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: $author$project$I18n$Cles$produitsReferenceCalculDrawerTitre(i18n)
		};
	});
var $author$project$I18n$Cles$produitsReferenceLiensRetirerAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.retirer-action', _List_Nil, 'Retirer le lien');
};
var $author$project$I18n$Cles$produitsReferenceLiensRetirerExplication = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.liens.retirer-explication',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'« ' + (p.Dj + ' » ne sera plus lié à cette référence ; l\'article lui-même n\'est pas modifié.'));
	});
var $author$project$I18n$Cles$produitsReferenceLiensRetirerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.retirer-titre', _List_Nil, 'Retirer un article lié');
};
var $author$project$Components$Produits$Reference$ArticlesView$retrait = F3(
	function (i18n, model, fiche) {
		var lu = A2(
			$elm$core$Maybe$andThen,
			function (demande) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(demande.i4)),
						A2(
							$elm$core$List$concatMap,
							function ($) {
								return $.tP;
							},
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.dy;
									},
									$elm$core$Basics$eq(demande.dy)),
								fiche.BQ))));
			},
			model.eW);
		var nom = A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Cles$produitsReferenceLiensIndisponible(i18n),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.zX;
				},
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.Dj;
					},
					lu)));
		return {
			fs: {
				sR: true,
				Bl: $author$project$I18n$Cles$produitsReferenceLiensRetirerAction(i18n),
				C$: $author$project$Components$Produits$Reference$Update$DrawerValide
			},
			fZ: _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$produitsReferenceLiensRetirerExplication,
								i18n,
								{Dj: nom}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('article-lie')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('title')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(nom)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('infos')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$andThen,
											function ($) {
												return $.vx;
											},
											lu)))
								]))
						]))
				]),
			h6: $author$project$I18n$Cles$produitsReferenceLiensRetirerTitre(i18n)
		};
	});
var $author$project$I18n$Cles$groupeDeSousChampsRetraitExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'groupe-de-sous-champs.retrait.explication', _List_Nil, 'Cette occurrence disparaît de la fiche. Les autres ne changent pas, et les valeurs des listes restent dans leur liste.');
};
var $author$project$I18n$Cles$groupeDeSousChampsRetraitTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.retrait.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer « ' + (p.Dj + ' » ?'));
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$montres = function (contenu) {
	return A2(
		$elm$core$List$filter,
		function (champ) {
			return !A2($elm$core$List$member, champ.dy, contenu.Cd);
		},
		contenu.IX);
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$portee = F2(
	function (groupe, contexte) {
		var prefixe = groupe + '.';
		return _Utils_update(
			contexte,
			{
				jN: A2($author$project$Components$Shared$EditeurDeSchema$Groupe$choixDuGroupe, groupe, contexte.jN),
				R: A2(
					$elm$core$List$filterMap,
					function (_v0) {
						var cle = _v0.a;
						var libelle = _v0.b;
						return A2($elm$core$String$startsWith, prefixe, cle) ? $elm$core$Maybe$Just(
							_Utils_Tuple2(
								A2(
									$elm$core$String$dropLeft,
									$elm$core$String$length(prefixe),
									cle),
								libelle)) : $elm$core$Maybe$Nothing;
					},
					contexte.R)
			});
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$estUnChoix = function (champ) {
	var _v0 = champ.r0;
	switch (_v0.$) {
		case 17:
			return true;
		case 21:
			return true;
		case 7:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$tonDe = F3(
	function (contexte, champ, lue) {
		var identifiants = function () {
			var _v2 = champ.r0;
			if (_v2.$ === 7) {
				var valeurs = _v2.a;
				return valeurs;
			} else {
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$montrees,
							$elm$core$List$map(
								function ($) {
									return $.Aq;
								})),
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.dy;
									},
									$elm$core$Basics$eq(champ.dy)),
								contexte.jN))));
			}
		}();
		var rang = function () {
			var _v1 = A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$eq(champ.dy)),
						lue.Ki)));
			if ((!_v1.$) && (_v1.a.$ === 1)) {
				var brut = _v1.a.a;
				return A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$first,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$second,
								$elm$core$Basics$eq(brut)),
							A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, identifiants))));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		_v0$2:
		while (true) {
			if (!rang.$) {
				switch (rang.a) {
					case 0:
						return 'succes';
					case 1:
						return 'attention';
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return 'neutre';
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$resume = F4(
	function (i18n, contexte, sousChamps, lue) {
		var renseignes = A2(
			$elm$core$List$filterMap,
			function (champ) {
				return A2(
					$elm$core$Maybe$map,
					function (valeur) {
						return {
							gt: $author$project$Components$Shared$EditeurDeSchema$Groupe$estUnChoix(champ),
							Bl: champ.Bl,
							rH: A3($author$project$Components$Shared$EditeurDeSchema$Groupe$tonDe, contexte, champ, lue),
							fm: valeur
						};
					},
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$second,
							A3($author$project$Components$Shared$EditeurDeSchema$Groupe$texteDeLaValeur, i18n, contexte, champ)),
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Tuple$first,
									$elm$core$Basics$eq(champ.dy)),
								lue.Ki))));
			},
			sousChamps);
		var _v0 = _Utils_Tuple2(
			A4($author$project$Components$Shared$EditeurDeSchema$Groupe$composee, i18n, contexte, sousChamps, lue),
			renseignes);
		if (!_v0.a.$) {
			var phrase = _v0.a.a;
			return {cz: _List_Nil, h6: phrase};
		} else {
			if (_v0.b.b) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				var premier = _v2.a;
				var suite = _v2.b;
				return {cz: suite, h6: premier.fm};
			} else {
				var _v3 = _v0.a;
				return {cz: _List_Nil, h6: ''};
			}
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$nomDeLOccurrence = F2(
	function (i18n, _v0) {
		var contexte = _v0.ka;
		var champ = _v0.uN;
		var occurrence = _v0.D$;
		var sousChamps = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$Shared$EditeurDeSchema$Groupe$montres,
				$author$project$Components$Shared$EditeurDeSchema$Groupe$sousChampsDe(champ)));
		var contexteDuGroupe = A2($author$project$Components$Shared$EditeurDeSchema$Groupe$portee, champ.dy, contexte);
		var _v1 = A4($author$project$Components$Shared$EditeurDeSchema$Groupe$resume, i18n, contexteDuGroupe, sousChamps, occurrence);
		var lu = _v1;
		var _v2 = _Utils_Tuple2(
			lu.h6,
			A2(
				$elm$core$List$filter,
				function ($) {
					return $.gt;
				},
				lu.cz));
		if (_v2.a === '') {
			return champ.Bl;
		} else {
			if (!_v2.b.b) {
				var nom = _v2.a;
				return nom;
			} else {
				var nom = _v2.a;
				var etats = _v2.b;
				return nom + (' (' + (A2(
					$elm$core$String$join,
					', ',
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.fm;
							},
							$elm$core$String$toLower),
						etats)) + ')'));
			}
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$confirmationDeRetrait = F2(
	function (i18n, retiree) {
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Note$View$view,
				1,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$b,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$groupeDeSousChampsRetraitTitre,
									i18n,
									{
										Dj: A2($author$project$Components$Shared$EditeurDeSchema$Groupe$nomDeLOccurrence, i18n, retiree)
									}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$groupeDeSousChampsRetraitExplication(i18n))
							]))
					]))
			]);
	});
var $author$project$I18n$Cles$groupeDeSousChampsActionRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'groupe-de-sous-champs.action.retirer', _List_Nil, 'Retirer l\'occurrence');
};
var $author$project$I18n$Cles$groupeDeSousChampsTitreRetirer = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.titre.retirer',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'occurrence',
					$author$project$I18n$Traductions$Chaine(p.D$))
				]),
			'Retirer ' + p.D$);
	});
var $author$project$Components$Produits$Reference$GroupesView$retrait = F2(
	function (i18n, model) {
		var _v0 = model.D0;
		if (!_v0.$) {
			var ouvert = _v0.a;
			return {
				fs: {
					sR: true,
					Bl: $author$project$I18n$Cles$groupeDeSousChampsActionRetirer(i18n),
					C$: $author$project$Components$Produits$Reference$Update$DrawerValide
				},
				fZ: A2($author$project$Components$Shared$EditeurDeSchema$Groupe$confirmationDeRetrait, i18n, ouvert.Dj),
				h6: A2(
					$author$project$I18n$Cles$groupeDeSousChampsTitreRetirer,
					i18n,
					{
						D$: A2($author$project$I18n$Cles$texte, i18n, ouvert.D$)
					})
			};
		} else {
			return $author$project$Components$Produits$Reference$GroupesView$vide;
		}
	});
var $author$project$I18n$Cles$produitsReferenceImageRetraitConfirmer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.retrait-confirmer', _List_Nil, 'Retirer l\'image');
};
var $author$project$I18n$Cles$produitsReferenceImageRetraitNoteChamp = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.image.retrait-note-champ',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'L\'image reste dans le champ « ' + (p.uN + ' » de la fiche. Vous pourrez en définir une autre à tout moment.'));
	});
var $author$project$I18n$Cles$produitsReferenceImageRetraitNoteDeposee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.retrait-note-deposee', _List_Nil, 'Le fichier déposé n\'est plus affiché ; il reste restaurable.');
};
var $author$project$I18n$Cles$produitsReferenceImageRetraitNoteTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.retrait-note-titre', _List_Nil, 'Le bandeau n\'aura plus d\'image.');
};
var $author$project$I18n$Cles$produitsReferenceImageRetraitTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.image.retrait-titre', _List_Nil, 'Retirer l\'image de présentation ?');
};
var $author$project$Components$Produits$Reference$ImageView$retraitEnDrawer = F3(
	function (i18n, model, fiche) {
		var suite = function () {
			var _v0 = A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.IR;
				},
				model.af);
			if ((!_v0.$) && (_v0.a.$ === 1)) {
				var _v1 = _v0.a;
				var cle = _v1.a;
				return A2(
					$author$project$I18n$Cles$produitsReferenceImageRetraitNoteChamp,
					i18n,
					{
						uN: A2($author$project$Components$Produits$Reference$ImageView$libelleDuChamp, model, cle)
					});
			} else {
				return $author$project$I18n$Cles$produitsReferenceImageRetraitNoteDeposee(i18n);
			}
		}();
		return {
			fs: {
				sR: true,
				Bl: $author$project$I18n$Cles$produitsReferenceImageRetraitConfirmer(i18n),
				C$: $author$project$Components$Produits$Reference$Update$DrawerValide
			},
			fZ: _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('alerte'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('warn'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'note')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsReferenceImageRetraitNoteTitre(i18n))
								])),
							$rtfeldman$elm_css$Html$Styled$text(suite)
						]))
				]),
			A6: $elm$core$Maybe$Just(fiche.vx),
			Bc: false,
			h6: $author$project$I18n$Cles$produitsReferenceImageRetraitTitre(i18n)
		};
	});
var $author$project$Components$Produits$Reference$ArticlesView$sansPerimetre = function (model) {
	return _Utils_eq(model.mW, $author$project$Components$Produits$Reference$Model$ChoixDUnPerimetre) && ((!_Utils_eq(model.cl, $elm$core$Maybe$Nothing)) && (_Utils_eq(
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.pg;
					},
					$author$project$Components$Produits$Common$ChoixDUnPerimetre$proposables),
				model.cl)),
		_List_Nil) && (A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.h3;
			},
			model.fO)) === '')));
};
var $author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$signalerHorsLimites = F2(
	function (limites, saisie) {
		return _Utils_update(
			saisie,
			{d1: limites});
	});
var $author$project$I18n$Cles$produitsReferenceLiensNouveauPerimetre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.nouveau-perimetre', _List_Nil, 'Nouveau périmètre d\'offre');
};
var $author$project$Components$Produits$Reference$ArticlesView$libelleDe = F2(
	function (fiche, lien) {
		return A2(
			$elm$core$Maybe$withDefault,
			lien.dy,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dy;
							},
							$elm$core$Basics$eq(lien.dy)),
						$author$project$Components$Produits$Reference$Model$champs(fiche)))));
	});
var $author$project$I18n$Cles$produitsReferenceLiensSousTitreDuChamp = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.liens.sous-titre-du-champ',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN)),
					_Utils_Tuple2(
					'option',
					$author$project$I18n$Traductions$Chaine(p.Eh))
				]),
			p.uN + (' · Lien vers des articles · ' + p.Eh));
	});
var $author$project$Components$Produits$Reference$ArticlesView$sousTitreDuChamp = F3(
	function (i18n, model, fiche) {
		return A2(
			$elm$core$Maybe$map,
			function (brouillon) {
				var champ = A2(
					$elm$core$Maybe$withDefault,
					brouillon.dy,
					A2(
						$elm$core$Maybe$map,
						$author$project$Components$Produits$Reference$ArticlesView$libelleDe(fiche),
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.dy;
									},
									$elm$core$Basics$eq(brouillon.dy)),
								fiche.BQ))));
				return A2(
					$author$project$I18n$Cles$produitsReferenceLiensSousTitreDuChamp,
					i18n,
					{
						uN: champ,
						Eh: A2($author$project$Components$Produits$Vocabulaire$libelleDeLOptionPlusieurs, i18n, brouillon.FS)
					});
			},
			model.uw);
	});
var $author$project$Components$Produits$Reference$ArticlesView$sousTitreDuDrawer = F3(
	function (i18n, model, fiche) {
		var _v0 = model.mW;
		switch (_v0.$) {
			case 10:
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$produitsReferenceLiensNouveauPerimetre(i18n));
			case 8:
				return A3($author$project$Components$Produits$Reference$ArticlesView$sousTitreDuChamp, i18n, model, fiche);
			case 9:
				return A3($author$project$Components$Produits$Reference$ArticlesView$sousTitreDuChamp, i18n, model, fiche);
			case 11:
				return A3($author$project$Components$Produits$Reference$ArticlesView$sousTitreDuChamp, i18n, model, fiche);
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$I18n$Cles$groupeDeSousChampsSousTitrePartiePrenante = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.sous-titre.partie-prenante',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typeDeFiche',
					$author$project$I18n$Traductions$Chaine(p.ca))
				]),
			'Une partie prenante de type ' + (p.ca + ', avec ses informations liées.'));
	});
var $author$project$I18n$Cles$groupeDeSousChampsSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'Une occurrence du champ « ' + (p.uN + ' ».'));
	});
var $author$project$I18n$Cles$groupeDeSousChampsSousTitreUnique = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.sous-titre.unique',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'Champ « ' + (p.uN + ' » (une seule valeur).'));
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$sousTitreDuGroupe = F2(
	function (i18n, brouillon) {
		return brouillon.HI ? A2(
			$author$project$I18n$Cles$groupeDeSousChampsSousTitre,
			i18n,
			{uN: brouillon.Dj}) : A2(
			$author$project$I18n$Cles$groupeDeSousChampsSousTitreUnique,
			i18n,
			{uN: brouillon.Dj});
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$sousTitre = F2(
	function (i18n, brouillon) {
		var _v0 = $author$project$Components$Shared$EditeurDeSchema$Groupe$typeViseDuGroupe(brouillon);
		if (!_v0.$) {
			var typeDeFiche = _v0.a;
			return A2(
				$author$project$I18n$Cles$groupeDeSousChampsSousTitrePartiePrenante,
				i18n,
				{ca: typeDeFiche});
		} else {
			return A2($author$project$Components$Shared$EditeurDeSchema$Groupe$sousTitreDuGroupe, i18n, brouillon);
		}
	});
var $author$project$Components$Produits$Reference$GroupesView$sousTitreDuDrawer = F2(
	function (i18n, model) {
		return A2(
			$elm$core$Maybe$map,
			$author$project$Components$Shared$EditeurDeSchema$Groupe$sousTitre(i18n),
			model.D$);
	});
var $author$project$I18n$Cles$produitsReferenceInformationsEtage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.informations.etage',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md)),
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			p.md + (' · ' + p.fm));
	});
var $author$project$I18n$Cles$produitsReferenceInformationsCatalogue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.informations.catalogue', _List_Nil, 'Catalogue');
};
var $author$project$I18n$Cles$produitsReferenceInformationsTypologie = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.informations.typologie',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Typologie · ' + p.Dj);
	});
var $author$project$Components$Produits$Reference$Lecture$titreDeLInformation = F2(
	function (i18n, information) {
		var nom = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.zX;
				},
				information.R));
		var _v0 = _Utils_Tuple2(information.F$.g1, information.md);
		switch (_v0.a) {
			case 'catalogue':
				return $author$project$I18n$Cles$produitsReferenceInformationsCatalogue(i18n);
			case 'typologie':
				return A2(
					$author$project$I18n$Cles$produitsReferenceInformationsTypologie,
					i18n,
					{Dj: nom});
			case 'categorie':
				return A2(
					$author$project$I18n$Cles$produitsReferenceInformationsEtage,
					i18n,
					{
						md: $author$project$I18n$Cles$produitsReferenceInformationsCategorie(i18n),
						fm: nom
					});
			default:
				if (!_v0.b.$) {
					var etage = _v0.b.a;
					return A2(
						$author$project$I18n$Cles$produitsReferenceInformationsEtage,
						i18n,
						{
							md: A2($author$project$Components$Produits$Reference$Lecture$libelleDeLEtage, i18n, etage),
							fm: nom
						});
				} else {
					var _v1 = _v0.b;
					return nom;
				}
		}
	});
var $author$project$Components$Produits$Reference$Lecture$titreDuGroupe = F3(
	function (i18n, fiche, information) {
		if (information.$ === 1) {
			return A2(
				$author$project$I18n$Cles$produitsReferenceInformationsEtage,
				i18n,
				{
					md: $author$project$I18n$Cles$produitsReferenceInformationsCategorie(i18n),
					fm: fiche.r0.Dj.zX
				});
		} else {
			var lue = information.a;
			return A2($author$project$Components$Produits$Reference$Lecture$titreDeLInformation, i18n, lue);
		}
	});
var $author$project$Components$Produits$Reference$View$drawer = F3(
	function (i18n, model, fiche) {
		var variante = model.sl;
		var refus = A2(
			$author$project$Components$Shared$Messages$View$view,
			i18n,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $elm$core$List$singleton, model.pZ)));
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.kX);
		var fautif = function (zone) {
			return variante.b5 && A2(
				$elm$core$List$member,
				zone,
				A2($author$project$Components$Produits$Reference$Model$fautesDeVariante, fiche, variante));
		};
		var choisi = function (etat) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $author$project$Catalogue$Identifiants$etatCodeToString, etat));
		};
		var contenu = function () {
			var _v4 = _Utils_Tuple2(
				$author$project$Components$Shared$Drawer$Model$estOuvert(model.kX),
				model.mW);
			_v4$19:
			while (true) {
				if (_v4.a) {
					switch (_v4.b.$) {
						case 1:
							var voulu = _v4.b.a;
							return A3(
								$author$project$Components$Produits$Common$Etat$drawer,
								i18n,
								{
									sO: !$author$project$Components$Produits$Common$Envoi$enCours(model.l2),
									vd: $author$project$Components$Produits$Reference$Update$EtatChoisi,
									pv: prefixe,
									pZ: model.pZ,
									sj: $author$project$Components$Produits$Reference$Update$DrawerValide,
									KV: voulu
								},
								fiche);
						case 3:
							var _v5 = _v4.b;
							return {
								fs: {
									sR: !$author$project$Components$Produits$Common$Envoi$enCours(model.l2),
									Bl: $author$project$I18n$Cles$produitsCatalogueActionsEnregistrer(i18n),
									C$: $author$project$Components$Produits$Reference$Update$DrawerValide
								},
								fZ: A2(
									$elm$core$List$cons,
									refus,
									A2(
										$elm$core$List$concatMap,
										function (section) {
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$h3,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('groupe')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															A3($author$project$Components$Produits$Reference$Lecture$titreDuGroupe, i18n, fiche, section.AL))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$div,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('groupe-saisie')
														]),
													A2(
														$elm$core$List$map,
														$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Produits$Reference$Update$DeLaSaisie),
														A3(
															$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$view,
															i18n,
															{
																fr: $author$project$Components$Produits$Reference$Model$aTraduire(fiche),
																dw: section.dw,
																jN: A2($author$project$Components$Produits$Reference$Model$choixAvecLesFiches, model, fiche),
																Ba: fiche.Ba,
																np: false,
																hd: model.hd,
																pv: $author$project$Components$Produits$Reference$Model$prefixeDesChamps,
																sb: fiche.sb
															},
															A2(
																$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$signalerHorsLimites,
																A2($author$project$Components$Produits$Reference$View$limitesDepassees, i18n, fiche),
																model.hP))))
												]);
										},
										A2(
											$elm$core$List$filter,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.dw;
												},
												A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)),
											$author$project$Components$Produits$Reference$Lecture$ordreDeLaFiche(
												$author$project$Components$Produits$Reference$Model$sections(fiche))))),
								A6: $elm$core$Maybe$Nothing,
								Bc: true,
								h6: $author$project$I18n$Cles$produitsReferenceFicheDrawerTitre(i18n)
							};
						case 5:
							var cle = _v4.b.a;
							return A4($author$project$Components$Produits$Reference$FichiersView$drawer, i18n, model, fiche, cle);
						case 6:
							var _v6 = _v4.b;
							return A3($author$project$Components$Produits$Reference$ImageView$drawer, i18n, model, fiche);
						case 7:
							var _v7 = _v4.b;
							return A3($author$project$Components$Produits$Reference$ImageView$retraitEnDrawer, i18n, model, fiche);
						case 2:
							var _v8 = _v4.b;
							return {
								fs: {
									sR: !$author$project$Components$Produits$Common$Envoi$enCours(model.l2),
									Bl: $author$project$I18n$Cles$produitsReferenceDupliquerValider(i18n),
									C$: $author$project$Components$Produits$Reference$Update$DrawerValide
								},
								fZ: _List_fromArray(
									[
										refus,
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$produitsReferenceDupliquerNote,
													i18n,
													{vx: fiche.vx}))
											])),
										A2(
										$author$project$Components$Shared$Champ$View$texte,
										{
											go: fautif(0) ? $elm$core$Maybe$Just(
												$author$project$I18n$Cles$produitsReferenceDupliquerCodeNouveau(i18n)) : A2(
												$elm$core$Maybe$map,
												$author$project$I18n$Cles$texte(i18n),
												variante.fR),
											Aq: A2($author$project$Components$Produits$Reference$Model$idDeVariante, prefixe, 0),
											Bl: $author$project$I18n$Cles$produitsReferencesCreationCode(i18n),
											he: true
										},
										{
											hg: A2($elm$core$Basics$composeR, $author$project$Components$Produits$Reference$Model$CodeDeVariante, $author$project$Components$Produits$Reference$Update$VarianteSaisie),
											fm: variante.vx
										}),
										A2(
										$author$project$Components$Shared$Champ$View$texte,
										{
											go: fautif(1) ? $elm$core$Maybe$Just(
												$author$project$I18n$Cles$produitsReferenceDupliquerVarianteNouvelle(i18n)) : $elm$core$Maybe$Nothing,
											Aq: A2($author$project$Components$Produits$Reference$Model$idDeVariante, prefixe, 1),
											Bl: $author$project$I18n$Cles$produitsReferencesCarteVariante(i18n),
											he: true
										},
										{
											hg: A2($elm$core$Basics$composeR, $author$project$Components$Produits$Reference$Model$NomDeVariante, $author$project$Components$Produits$Reference$Update$VarianteSaisie),
											fm: variante.sl
										}),
										A2(
										$author$project$Components$Shared$Champ$View$liste,
										{
											go: fautif(2) ? $elm$core$Maybe$Just(
												$author$project$I18n$Cles$saisieDeChampObligatoire(i18n)) : $elm$core$Maybe$Nothing,
											Aq: A2($author$project$Components$Produits$Reference$Model$idDeVariante, prefixe, 2),
											Bl: $author$project$I18n$Cles$produitsCatalogueColonneEtat(i18n),
											he: true
										},
										{
											hg: A2($elm$core$Basics$composeR, $author$project$Components$Produits$Reference$Model$EtatDeVariante, $author$project$Components$Produits$Reference$Update$VarianteSaisie),
											o_: _Utils_ap(
												_Utils_eq(variante.gt, $elm$core$Maybe$Nothing) ? _List_fromArray(
													[
														{
														Bl: $author$project$I18n$Cles$saisieDeChampListeAucune(i18n),
														fm: ''
													}
													]) : _List_Nil,
												A2($author$project$Components$Produits$Common$Etat$options, i18n, fiche)),
											fm: choisi(variante.gt)
										})
									]),
								A6: $elm$core$Maybe$Nothing,
								Bc: false,
								h6: $author$project$I18n$Cles$produitsReferenceDupliquer(i18n)
							};
						case 4:
							var _v9 = _v4.b;
							return {
								fs: {
									sR: true,
									Bl: $author$project$I18n$Cles$produitsReferenceHistoriqueFermer(i18n),
									C$: $author$project$Components$Produits$Reference$Update$DrawerValide
								},
								fZ: A3($author$project$Components$Produits$Reference$View$historique, i18n, model, fiche),
								A6: $elm$core$Maybe$Nothing,
								Bc: false,
								h6: $author$project$I18n$Cles$produitsReferenceHistoriqueTitre(i18n)
							};
						case 13:
							var _v10 = _v4.b;
							return A3($author$project$Components$Produits$Reference$View$produitEnDrawer, i18n, model, refus);
						case 17:
							return A3($author$project$Components$Produits$Reference$View$recalculEnDrawer, i18n, model, refus);
						case 18:
							var _v11 = _v4.b;
							return A3($author$project$Components$Produits$Reference$View$codeEnDrawer, i18n, model, refus);
						case 19:
							var _v12 = _v4.b;
							return A3($author$project$Components$Produits$Reference$View$recalculDuCodeEnDrawer, i18n, model, refus);
						case 8:
							var _v13 = _v4.b;
							return $author$project$Components$Produits$Reference$View$articlesEnDrawer(
								$elm$core$Maybe$Just(
									A3($author$project$Components$Produits$Reference$ArticlesView$modification, i18n, model, fiche)));
						case 9:
							var _v14 = _v4.b;
							return $author$project$Components$Produits$Reference$View$articlesEnDrawer(
								$elm$core$Maybe$Just(
									A2($author$project$Components$Produits$Reference$ArticlesView$choisirUnPerimetre, i18n, model)));
						case 10:
							var _v15 = _v4.b;
							return $author$project$Components$Produits$Reference$View$articlesEnDrawer(
								$elm$core$Maybe$Just(
									A2($author$project$Components$Produits$Reference$ArticlesView$creerUnPerimetre, i18n, model)));
						case 11:
							var _v16 = _v4.b;
							return $author$project$Components$Produits$Reference$View$articlesEnDrawer(
								A2(
									$elm$core$Maybe$map,
									A3($author$project$Components$Produits$Reference$ArticlesView$choix, i18n, model, fiche),
									model.tP));
						case 12:
							var _v17 = _v4.b;
							return $author$project$Components$Produits$Reference$View$articlesEnDrawer(
								$elm$core$Maybe$Just(
									A3($author$project$Components$Produits$Reference$ArticlesView$retrait, i18n, model, fiche)));
						case 14:
							var _v18 = _v4.b;
							var occurrence = A3($author$project$Components$Produits$Reference$GroupesView$drawer, i18n, model, fiche);
							return {
								fs: occurrence.fs,
								fZ: A2($elm$core$List$cons, refus, occurrence.fZ),
								A6: $elm$core$Maybe$Nothing,
								Bc: false,
								h6: occurrence.h6
							};
						case 16:
							var cle = _v4.b.a;
							var choix = A5(
								$author$project$Components$Produits$Reference$UtilisateurView$drawer,
								i18n,
								model,
								cle,
								A2($author$project$Components$Produits$Reference$Model$libelleDuChamp, fiche, cle),
								A2($author$project$Components$Produits$Reference$Model$genreDuChamp, fiche, cle));
							return {
								fs: choix.fs,
								fZ: A2($elm$core$List$cons, refus, choix.fZ),
								A6: $elm$core$Maybe$Nothing,
								Bc: false,
								h6: choix.h6
							};
						case 15:
							var _v19 = _v4.b;
							var retrait = A2($author$project$Components$Produits$Reference$GroupesView$retrait, i18n, model);
							return {
								fs: retrait.fs,
								fZ: A2($elm$core$List$cons, refus, retrait.fZ),
								A6: $elm$core$Maybe$Nothing,
								Bc: false,
								h6: retrait.h6
							};
						default:
							break _v4$19;
					}
				} else {
					break _v4$19;
				}
			}
			return {
				fs: {sR: false, Bl: '', C$: $author$project$Components$Produits$Reference$Update$DrawerValide},
				fZ: _List_Nil,
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: ''
			};
		}();
		if (_Utils_eq(model.mW, $author$project$Components$Produits$Reference$Model$RetraitDUneOccurrence) || _Utils_eq(model.mW, $author$project$Components$Produits$Reference$Model$RetraitDeLImage)) {
			return A4($author$project$Components$Shared$Drawer$View$viewDestructif, i18n, $author$project$Components$Produits$Reference$Update$DuDrawer, contenu, model.kX);
		} else {
			var _v0 = _Utils_Tuple2(
				model.mW,
				A2($author$project$Components$Produits$Reference$GroupesView$sousTitreDuDrawer, i18n, model));
			_v0$2:
			while (true) {
				switch (_v0.a.$) {
					case 6:
						var _v1 = _v0.a;
						return A5(
							$author$project$Components$Shared$Drawer$View$viewAvecPiedLibre,
							i18n,
							A2($author$project$Components$Produits$Reference$ImageView$pied, i18n, model),
							$author$project$Components$Produits$Reference$Update$DuDrawer,
							contenu,
							model.kX);
					case 14:
						if (!_v0.b.$) {
							var _v2 = _v0.a;
							var sousTitre = _v0.b.a;
							return A5($author$project$Components$Shared$Drawer$View$viewAvecSousTitre, i18n, sousTitre, $author$project$Components$Produits$Reference$Update$DuDrawer, contenu, model.kX);
						} else {
							break _v0$2;
						}
					default:
						break _v0$2;
				}
			}
			if ($author$project$Components$Produits$Reference$ArticlesView$sansPerimetre(model)) {
				return A4(
					$author$project$Components$Shared$Drawer$View$consultationAnnulable,
					i18n,
					$author$project$Components$Produits$Reference$Update$DuDrawer,
					{
						fZ: contenu.fZ,
						G8: false,
						aO: A3($author$project$Components$Produits$Reference$ArticlesView$sousTitreDuDrawer, i18n, model, fiche),
						h6: contenu.h6
					},
					model.kX);
			} else {
				var _v3 = A3($author$project$Components$Produits$Reference$ArticlesView$sousTitreDuDrawer, i18n, model, fiche);
				if (!_v3.$) {
					var sousTitre = _v3.a;
					return A5($author$project$Components$Shared$Drawer$View$viewAvecSousTitre, i18n, sousTitre, $author$project$Components$Produits$Reference$Update$DuDrawer, contenu, model.kX);
				} else {
					return A4($author$project$Components$Shared$Drawer$View$view, i18n, $author$project$Components$Produits$Reference$Update$DuDrawer, contenu, model.kX);
				}
			}
		}
	});
var $author$project$Components$Produits$Reference$View$UnGroupe = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$Reference$View$UneHeritee = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$Reference$View$UneInformation = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Produits$Reference$View$cleDeLElement = function (element) {
	switch (element.$) {
		case 0:
			var rangee = element.a;
			return rangee.dy;
		case 1:
			var champ = element.a;
			return champ.dy;
		default:
			var lue = element.a;
			return lue.dy;
	}
};
var $author$project$Components$Produits$Reference$GroupesView$groupes = function (fiche) {
	return A2(
		$elm$core$List$filter,
		function (champ) {
			return !_Utils_eq(
				$author$project$Components$Shared$EditeurDeSchema$Groupe$sousChampsDe(champ),
				$elm$core$Maybe$Nothing);
		},
		$author$project$Components$Produits$Reference$Model$champs(fiche));
};
var $author$project$Components$Produits$Reference$Lecture$estUnLien = function (champ) {
	var _v0 = champ.r0;
	switch (_v0.$) {
		case 18:
			return true;
		case 22:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Produits$Reference$Lecture$orElse = F2(
	function (autre, premier) {
		if (!premier.$) {
			return premier;
		} else {
			return autre(0);
		}
	});
var $author$project$I18n$Cles$produitsReferenceCalculACalculer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.calcul.a-calculer', _List_Nil, '— à calculer');
};
var $author$project$I18n$Cles$produitsReferenceFicheOrigine = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.fiche.origine',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'origine',
					$author$project$I18n$Traductions$Chaine(p.o4))
				]),
			'Information de ' + p.o4);
	});
var $author$project$Components$Produits$Reference$Lecture$lire = F3(
	function (i18n, normes, fiche) {
		var lignes = A2(
			$elm$core$List$concatMap,
			function (section) {
				return A2(
					$elm$core$List$map,
					function (champ) {
						return _Utils_Tuple2(
							champ,
							A2(
								$author$project$I18n$Cles$produitsReferenceFicheOrigine,
								i18n,
								{
									o4: A3($author$project$Components$Produits$Reference$Lecture$titreDuGroupe, i18n, fiche, section.AL)
								}));
					},
					A2(
						$elm$core$List$filter,
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$Reference$Lecture$estUnLien, $elm$core$Basics$not),
						section.dw));
			},
			$author$project$Components$Produits$Reference$Lecture$ordreDeLaFiche(
				$author$project$Components$Produits$Reference$Model$sections(fiche)));
		var herite = function (lu) {
			return A2(
				$elm$core$Maybe$map,
				function (champ) {
					return {
						dy: lu.uN,
						Bl: champ.Bl,
						Dj: lu.Dj.zX,
						IR: lu.IR,
						fm: A2(
							$elm$core$Maybe$andThen,
							A4($author$project$Components$Produits$Reference$Lecture$texte, i18n, normes, fiche, champ),
							lu.fm)
					};
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dy;
							},
							$elm$core$Basics$eq(lu.uN)),
						_Utils_ap(
							fiche.r0.dw,
							A2(
								$elm$core$List$concatMap,
								function ($) {
									return $.dw;
								},
								fiche.AM)))));
		};
		var fichierDuChamp = function (champ) {
			return $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.uN;
						},
						$elm$core$Basics$eq(champ.dy)),
					fiche.zB));
		};
		var estUneImage = function (fichier) {
			return A2($elm$core$String$startsWith, 'image/', fichier.r0);
		};
		var valeurDuFichier = function (champ) {
			return A2(
				$elm$core$Maybe$map,
				function (fichier) {
					return _Utils_Tuple2(
						estUneImage(fichier) ? '' : $author$project$Components$Produits$Reference$Fichiers$formatDuType(fichier.r0),
						$elm$core$Maybe$Nothing);
				},
				fichierDuChamp(champ));
		};
		var valeurDuChamp = function (champ) {
			var _v7 = valeurDuFichier(champ);
			if (!_v7.$) {
				var fichier = _v7.a;
				return $elm$core$Maybe$Just(fichier);
			} else {
				return A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$second,
						A4($author$project$Components$Produits$Reference$Lecture$texte, i18n, normes, fiche, champ)),
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$first,
								$elm$core$Basics$eq(champ.dy)),
							fiche.Ki)));
			}
		};
		var vignetteDuChamp = function (champ) {
			return A2(
				$elm$core$Maybe$andThen,
				function (fichier) {
					return estUneImage(fichier) ? $elm$core$Maybe$Just(champ.dy) : $elm$core$Maybe$Nothing;
				},
				fichierDuChamp(champ));
		};
		var codesDuChamp = function (champ) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (valeur) {
						switch (valeur.$) {
							case 4:
								var codes = valeur.a;
								return codes;
							case 1:
								var code = valeur.a;
								return _List_fromArray(
									[code]);
							default:
								return _List_Nil;
						}
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$second,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Tuple$first,
									$elm$core$Basics$eq(champ.dy)),
								fiche.Ki)))));
		};
		var puces = function (champ) {
			var _v5 = champ.r0;
			switch (_v5.$) {
				case 15:
					var choix = _v5.a;
					return choix.FS ? $elm$core$Maybe$Just(
						_Utils_Tuple2(
							$author$project$Referentiel$Normes$entreesDePays(normes),
							codesDuChamp(champ))) : $elm$core$Maybe$Nothing;
				case 16:
					var choix = _v5.a;
					return choix.FS ? $elm$core$Maybe$Just(
						_Utils_Tuple2(
							$author$project$Referentiel$Normes$entreesDeLangues(normes),
							codesDuChamp(champ))) : $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		};
		var lue = function (_v4) {
			var champ = _v4.a;
			var origine = _v4.b;
			return A2(
				$elm$core$Maybe$map,
				function (_v3) {
					var valeur = _v3.a;
					var unite = _v3.b;
					return {
						dy: champ.dy,
						gH: A2($elm$core$List$member, champ.dy, fiche.Kn),
						Bl: champ.Bl,
						hb: A2($elm$core$List$member, champ.dy, fiche.Ko),
						o4: origine,
						hx: puces(champ),
						sa: unite,
						fm: valeur,
						ik: vignetteDuChamp(champ)
					};
				},
				valeurDuChamp(champ));
		};
		var aCalculer = function (_v2) {
			var champ = _v2.a;
			var origine = _v2.b;
			return A2(
				$elm$core$List$any,
				function (c) {
					return _Utils_eq(c.uN, champ.dy);
				},
				fiche.uD) ? $elm$core$Maybe$Just(
				{
					dy: champ.dy,
					gH: false,
					Bl: champ.Bl,
					hb: false,
					o4: origine,
					hx: $elm$core$Maybe$Nothing,
					sa: $elm$core$Maybe$Nothing,
					fm: $author$project$I18n$Cles$produitsReferenceCalculACalculer(i18n),
					ik: $elm$core$Maybe$Nothing
				}) : $elm$core$Maybe$Nothing;
		};
		var renseignees = A2(
			$elm$core$List$filterMap,
			function (ligne) {
				return A2(
					$author$project$Components$Produits$Reference$Lecture$orElse,
					function (_v1) {
						return aCalculer(ligne);
					},
					lue(ligne));
			},
			lignes);
		return {
			m5: A2($elm$core$List$filterMap, herite, fiche.Km),
			pI: A2(
				$elm$core$List$map,
				function (_v0) {
					var champ = _v0.a;
					var origine = _v0.b;
					return {
						dy: champ.dy,
						Bl: champ.Bl,
						ea: $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.dy;
									},
									$elm$core$Basics$eq(champ.dy)),
								renseignees)),
						o4: origine
					};
				},
				lignes),
			qr: renseignees,
			JE: $elm$core$List$length(lignes),
			st: A2(
				$elm$core$List$map,
				function ($) {
					return $.Bl;
				},
				A2(
					$elm$core$List$filter,
					function (champ) {
						return !A2(
							$elm$core$List$any,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.dy;
								},
								$elm$core$Basics$eq(champ.dy)),
							renseignees);
					},
					A2($elm$core$List$map, $elm$core$Tuple$first, lignes)))
		};
	});
var $author$project$Components$Shared$CollectionDeLaFiche$repartir = F3(
	function (cleDe, collections, elements) {
		var deLaCollection = function (collection) {
			return A2(
				$elm$core$List$filterMap,
				function (cle) {
					return $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (element) {
								return _Utils_eq(
									cleDe(element),
									cle);
							},
							elements));
				},
				collection.dw);
		};
		var blocs = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$second,
				A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)),
			A2(
				$elm$core$List$map,
				function (collection) {
					return _Utils_Tuple2(
						collection,
						deLaCollection(collection));
				},
				collections));
		var rangees = A2(
			$elm$core$List$concatMap,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$first,
				function ($) {
					return $.dw;
				}),
			blocs);
		return {
			t7: A2(
				$elm$core$List$filter,
				function (element) {
					return !A2(
						$elm$core$List$member,
						cleDe(element),
						rangees);
				},
				elements),
			js: blocs
		};
	});
var $author$project$Components$Produits$Reference$View$repartitionDeLaFiche = F3(
	function (i18n, normes, fiche) {
		var lecture = A3($author$project$Components$Produits$Reference$Lecture$lire, i18n, normes, fiche);
		return A3(
			$author$project$Components$Shared$CollectionDeLaFiche$repartir,
			$author$project$Components$Produits$Reference$View$cleDeLElement,
			fiche.vE,
			_Utils_ap(
				A2($elm$core$List$map, $author$project$Components$Produits$Reference$View$UneInformation, lecture.pI),
				_Utils_ap(
					A2($elm$core$List$map, $author$project$Components$Produits$Reference$View$UneHeritee, lecture.m5),
					A2(
						$elm$core$List$map,
						$author$project$Components$Produits$Reference$View$UnGroupe,
						$author$project$Components$Produits$Reference$GroupesView$groupes(fiche)))));
	});
var $author$project$Components$Produits$Reference$View$enBlocs = F2(
	function (i18n, fiche) {
		return !$elm$core$List$isEmpty(
			A3($author$project$Components$Produits$Reference$View$repartitionDeLaFiche, i18n, $author$project$Referentiel$Normes$vide, fiche).js);
	});
var $author$project$Components$Produits$Reference$Update$ChoixDUtilisateurDemande = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Produits$Reference$View$estUnChampUtilisateur = F2(
	function (fiche, cle) {
		return A2(
			$elm$core$List$any,
			function (champ) {
				return _Utils_eq(champ.dy, cle) && _Utils_eq(champ.r0, $author$project$Components$Shared$EditeurDeSchema$Champ$Utilisateur);
			},
			$author$project$Components$Produits$Reference$Model$champs(fiche));
	});
var $author$project$I18n$Cles$produitsReferenceUtilisateurChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.utilisateur-choisir', _List_Nil, 'Choisir');
};
var $author$project$Components$Produits$Reference$View$boutonDUtilisateur = F3(
	function (i18n, fiche, cle) {
		return (A2($author$project$Components$Produits$Reference$View$estUnChampUtilisateur, fiche, cle) && (!_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierLesAttributsDUneReference, fiche.nQ),
			$elm$core$Maybe$Nothing))) ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('choisir'),
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$Reference$Update$ChoixDUtilisateurDemande(cle))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsReferenceUtilisateurChoisir(i18n))
					]))
			]) : _List_Nil;
	});
var $rtfeldman$elm_css$Html$Styled$details = $rtfeldman$elm_css$Html$Styled$node('details');
var $author$project$Components$Produits$Reference$Model$calculDuChamp = F2(
	function (fiche, cle) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (c) {
					return _Utils_eq(c.uN, cle);
				},
				fiche.uD));
	});
var $author$project$Components$Produits$Reference$Update$DebrayageDemande = function (a) {
	return {$: 35, a: a};
};
var $author$project$Components$Produits$Reference$Update$RecalculDemande = function (a) {
	return {$: 27, a: a};
};
var $author$project$Components$Produits$Reference$Update$RetourAuCalculDemande = function (a) {
	return {$: 34, a: a};
};
var $author$project$I18n$Cles$produitsReferenceCalculALaMain = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.calcul.a-la-main', _List_Nil, 'à la main');
};
var $author$project$I18n$Cles$produitsReferenceCalculCalcule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.calcul.calcule', _List_Nil, 'calculé');
};
var $author$project$I18n$Cles$produitsReferenceCalculDebrayer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.calcul.debrayer', _List_Nil, 'Débrayer');
};
var $author$project$I18n$Cles$produitsReferenceCalculImpose = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.calcul.impose', _List_Nil, 'imposé');
};
var $author$project$I18n$Cles$produitsReferenceCalculRecalculer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.calcul.recalculer', _List_Nil, 'Recalculer');
};
var $author$project$I18n$Cles$produitsReferenceCalculRevenir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.calcul.revenir', _List_Nil, 'Revenir au calcul');
};
var $author$project$Components$Produits$Reference$View$etatDuCalcul = F3(
	function (i18n, fiche, cle) {
		var _v0 = A2($author$project$Components$Produits$Reference$Model$calculDuChamp, fiche, cle);
		if (!_v0.$) {
			var calcul = _v0.a;
			return (calcul.gt === 'a-la-main') ? A2(
				$elm$core$List$cons,
				A2(
					$author$project$Components$Shared$Tag$View$view,
					1,
					$author$project$I18n$Cles$produitsReferenceCalculALaMain(i18n)),
				_Utils_eq(
					A2($author$project$Components$Produits$Reference$Model$commandeDeRetourAuCalcul, fiche, cle),
					$elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Produits$Reference$Update$RetourAuCalculDemande(cle))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsReferenceCalculRevenir(i18n))
							]))
					])) : A2(
				$elm$core$List$cons,
				A2(
					$author$project$Components$Shared$Tag$View$view,
					(calcul.fm === 'imposee') ? 3 : 0,
					(calcul.fm === 'imposee') ? $author$project$I18n$Cles$produitsReferenceCalculImpose(i18n) : $author$project$I18n$Cles$produitsReferenceCalculCalcule(i18n)),
				_Utils_ap(
					(_Utils_eq(
						A2($author$project$Components$Produits$Reference$Model$lienDeLApercu, fiche, cle),
						$elm$core$Maybe$Nothing) || _Utils_eq(
						A2($author$project$Components$Produits$Reference$Model$commandeDeRecalcul, fiche, cle),
						$elm$core$Maybe$Nothing)) ? _List_Nil : _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id(
									$author$project$Components$Produits$Reference$Model$idDuRecalcul(cle)),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'dialog'),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Produits$Reference$Update$RecalculDemande(cle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsReferenceCalculRecalculer(i18n))
								]))
						]),
					_Utils_eq(
						A2($author$project$Components$Produits$Reference$Model$commandeDeDebrayage, fiche, cle),
						$elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Produits$Reference$Update$DebrayageDemande(cle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsReferenceCalculDebrayer(i18n))
								]))
						])));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Produits$Reference$View$pastilleDUtilisateur = F3(
	function (i18n, fiche, lue) {
		return A2($author$project$Components$Produits$Reference$View$estUnChampUtilisateur, fiche, lue.dy) ? _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Tag$View$view,
				3,
				$author$project$I18n$Cles$produitsReferenceUtilisateurChamp(i18n))
			]) : _List_Nil;
	});
var $author$project$I18n$Cles$restrictionHorsChoix = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'restriction.hors-choix', _List_Nil, 'hors choix');
};
var $author$project$I18n$Cles$referenceNonReconnue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'reference.non-reconnue', _List_Nil, 'non reconnue');
};
var $author$project$I18n$Cles$referenceNonReconnueChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'reference.non-reconnue-choisir', _List_Nil, 'Choisir dans la liste');
};
var $author$project$I18n$Cles$referenceNonReconnueNote = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'reference.non-reconnue-note',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'liste',
					$author$project$I18n$Traductions$Chaine(p.nW))
				]),
			'Valeur saisie avant la reprise de la liste « ' + (p.nW + ' ». Elle est conservée telle quelle, la fiche n\'est pas modifiée.'));
	});
var $author$project$Components$Produits$Reference$View$valeurNonReconnue = F3(
	function (i18n, fiche, lue) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$dd,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('non-reconnue')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
						]),
					_List_fromArray(
						[
							A2($author$project$Components$Shared$Tag$View$view, 1, lue.fm),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('puce')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referenceNonReconnue(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$referenceNonReconnueNote,
								i18n,
								{nW: lue.Bl}))
						])),
					$author$project$Components$Produits$Reference$View$saisissable(fiche) ? A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Reference$Update$ModificationDemandee)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$referenceNonReconnueChoisir(i18n))
						])) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$Components$Produits$Reference$Update$AdresseExpiree = {$: 75};
var $author$project$Components$Produits$Reference$View$vignetteDeLInformation = F2(
	function (model, lue) {
		var _v0 = lue.ik;
		if (_v0.$ === 1) {
			return _List_Nil;
		} else {
			var cle = _v0.a;
			return _List_fromArray(
				[
					function () {
					var _v1 = A2($author$project$Components$Produits$Reference$Model$documentDuChamp, model, cle);
					if (!_v1.$) {
						var document = _v1.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('vignette'),
									$rtfeldman$elm_css$Html$Styled$Attributes$src(document.aa),
									$rtfeldman$elm_css$Html$Styled$Attributes$alt(lue.Bl),
									A2(
									$rtfeldman$elm_css$Html$Styled$Events$on,
									'error',
									$elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$Update$AdresseExpiree))
								]),
							_List_Nil);
					} else {
						return A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('vignette'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
								]),
							_List_fromArray(
								[$author$project$Components$Shared$Svg$svgFile]));
					}
				}()
				]);
		}
	});
var $author$project$Components$Produits$Reference$View$ligneDInformation = F4(
	function (i18n, model, fiche, lue) {
		var valeur = _Utils_ap(
			A2(
				$elm$core$Maybe$withDefault,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(lue.fm)
					]),
				A2(
					$elm$core$Maybe$map,
					function (_v0) {
						var entrees = _v0.a;
						var codes = _v0.b;
						return _List_fromArray(
							[
								A3($author$project$Components$Shared$Champ$SelecteurNorme$lecture, i18n, entrees, codes)
							]);
					},
					lue.hx)),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (unite) {
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('unite')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(unite)
									]))
							]);
					},
					lue.sa)));
		var calcule = !_Utils_eq(
			A2($author$project$Components$Produits$Reference$Model$calculDuChamp, fiche, lue.dy),
			$elm$core$Maybe$Nothing);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('information'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					calcule ? 'calcule' : '')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$dt,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$title(lue.o4)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(lue.Bl)
						])),
					lue.hb ? A3($author$project$Components$Produits$Reference$View$valeurNonReconnue, i18n, fiche, lue) : A2(
					$rtfeldman$elm_css$Html$Styled$dd,
					_List_Nil,
					_Utils_ap(
						A2($author$project$Components$Produits$Reference$View$vignetteDeLInformation, model, lue),
						_Utils_ap(
							calcule ? _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
										]),
									valeur)
								]) : valeur,
							_Utils_ap(
								lue.gH ? _List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Tag$View$view,
										1,
										$author$project$I18n$Cles$restrictionHorsChoix(i18n))
									]) : _List_Nil,
								_Utils_ap(
									A3($author$project$Components$Produits$Reference$View$pastilleDUtilisateur, i18n, fiche, lue),
									_Utils_ap(
										A3($author$project$Components$Produits$Reference$View$boutonDUtilisateur, i18n, fiche, lue.dy),
										A3($author$project$Components$Produits$Reference$View$etatDuCalcul, i18n, fiche, lue.dy)))))))
				]));
	});
var $author$project$I18n$Cles$produitsReferenceFicheHeriteDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.fiche.herite-de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'hérité de ' + p.Dj);
	});
var $author$project$I18n$Cles$produitsReferenceFicheNonRenseigne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fiche.non-renseigne', _List_Nil, 'Non renseigné');
};
var $author$project$I18n$Cles$produitsReferenceFicheVoirLaSource = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.fiche.voir-la-source',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Voir ' + p.Dj);
	});
var $author$project$Components$Produits$Reference$View$ligneHeritee = F2(
	function (i18n, lue) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('information'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('heritee')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$dt,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(lue.Bl)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$dd,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('heritee')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$I18n$Cles$produitsReferenceFicheNonRenseigne(i18n),
								A2($elm$core$Maybe$map, $elm$core$Tuple$first, lue.fm))),
							function () {
							var _v0 = A2($elm$core$Maybe$andThen, $elm$core$Tuple$second, lue.fm);
							if (!_v0.$) {
								var unite = _v0.a;
								return A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('unite')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(unite)
										]));
							} else {
								return $rtfeldman$elm_css$Html$Styled$text('');
							}
						}(),
							A2(
							$author$project$Components$Shared$Tag$View$view,
							3,
							A2(
								$author$project$I18n$Cles$produitsReferenceFicheHeriteDe,
								i18n,
								{Dj: lue.Dj})),
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('lien-discret'),
									$rtfeldman$elm_css$Html$Styled$Attributes$href(
									$author$project$Routes$Route$toString(
										$author$project$Routes$Route$FicheElement(lue.IR)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$produitsReferenceFicheVoirLaSource,
										i18n,
										{Dj: lue.Dj}))
								]))
						]))
				]));
	});
var $author$project$I18n$Cles$produitsReferenceFicheBlocCompte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.fiche.bloc-compte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champ') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champs'));
	});
var $author$project$I18n$Cles$produitsReferenceFicheBlocDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.fiche.bloc-detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Voir le détail (' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champ de plus)')) : ('Voir le détail (' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champs de plus)')));
	});
var $author$project$Components$Produits$Reference$Update$RetraitDOccurrenceDemande = F2(
	function (a, b) {
		return {$: 57, a: a, b: b};
	});
var $author$project$I18n$Cles$groupeDeSousChampsVideFeminin = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.vide.feminin',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'occurrence',
					$author$project$I18n$Traductions$Chaine(p.D$))
				]),
			'Aucune ' + (p.D$ + ' saisie.'));
	});
var $author$project$I18n$Cles$groupeDeSousChampsVideMasculin = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.vide.masculin',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'occurrence',
					$author$project$I18n$Traductions$Chaine(p.D$))
				]),
			'Aucun ' + (p.D$ + ' saisi.'));
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$aucuneOccurrence = F2(
	function (i18n, contenu) {
		var _v0 = contenu.z9;
		if (!_v0) {
			return A2(
				$author$project$I18n$Cles$groupeDeSousChampsVideFeminin,
				i18n,
				{D$: contenu.Bq});
		} else {
			return A2(
				$author$project$I18n$Cles$groupeDeSousChampsVideMasculin,
				i18n,
				{D$: contenu.Bq});
		}
	});
var $author$project$I18n$Cles$groupeDeSousChampsAjouter = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.ajouter',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'occurrence',
					$author$project$I18n$Traductions$Chaine(p.D$))
				]),
			'Ajouter ' + p.D$);
	});
var $author$project$I18n$Cles$groupeDeSousChampsRenseigner = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.renseigner',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'occurrence',
					$author$project$I18n$Traductions$Chaine(p.D$))
				]),
			'Renseigner ' + p.D$);
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$condition = function (precision) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('condition')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$small,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(precision.Bl)
					])),
				precision.gt ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('etat'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(precision.rH)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(precision.fm)
					])) : A2(
				$rtfeldman$elm_css$Html$Styled$b,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(precision.fm)
					]))
			]));
};
var $author$project$I18n$Cles$groupeDeSousChampsSansCondition = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'groupe-de-sous-champs.sans-condition', _List_Nil, 'Aucune condition saisie.');
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$conditions = F2(
	function (i18n, details) {
		return $elm$core$List$isEmpty(details) ? A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('sans-condition')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$I18n$Cles$groupeDeSousChampsSansCondition(i18n))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('conditions')
				]),
			A2($elm$core$List$map, $author$project$Components$Shared$EditeurDeSchema$Groupe$condition, details));
	});
var $author$project$I18n$Cles$groupeDeSousChampsFicheEffaceeNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'groupe-de-sous-champs.fiche.effacee.note', _List_Nil, 'La fiche a été effacée : le nom ne se restitue plus, la référence et le prix restent.');
};
var $author$project$I18n$Cles$groupeDeSousChampsFicheIndisponibleNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'groupe-de-sous-champs.fiche.indisponible.note', _List_Nil, 'Vous n\'avez pas le droit de lire les parties prenantes : ni nom, ni lien. L\'identifiant n\'est jamais affiché.');
};
var $author$project$I18n$Cles$groupeDeSousChampsFichePlusDuType = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.fiche.plus-du-type',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typeDeFiche',
					$author$project$I18n$Traductions$Chaine(p.ca))
				]),
			'n\'est plus ' + p.ca);
	});
var $author$project$I18n$Cles$groupeDeSousChampsFichePlusDuTypeNote = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.fiche.plus-du-type.note',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typeDeFiche',
					$author$project$I18n$Traductions$Chaine(p.ca))
				]),
			'Le rôle ' + (p.ca + ' de cette fiche a pris fin. La valeur est gardée : on ne peut plus la choisir pour un autre produit.'));
	});
var $author$project$I18n$Cles$groupeDeSousChampsVoirLaFiche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'groupe-de-sous-champs.voir-la-fiche', _List_Nil, 'Voir la fiche');
};
var $author$project$Components$Shared$EditeurDeSchema$Groupe$ficheCitee = F2(
	function (i18n, fiche) {
		var mention = function (texte) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note-de-la-fiche')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(texte)
					]));
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('fiche-citee'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('indisponible', fiche.gt === 3),
							_Utils_Tuple2('effacee', fiche.gt === 2)
						]))
				]),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function (libelle) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('tag'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class(
										(fiche.gt === 1) ? 'attention' : 'info')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										(fiche.gt === 1) ? A2(
											$author$project$I18n$Cles$groupeDeSousChampsFichePlusDuType,
											i18n,
											{ca: libelle}) : libelle)
									]));
						},
						fiche.JV),
						A2(
						$elm$core$Maybe$map,
						function (adresse) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('voir-la-fiche'),
										$rtfeldman$elm_css$Html$Styled$Attributes$href(adresse)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$groupeDeSousChampsVoirLaFiche(i18n))
									]));
						},
						fiche.aa),
						function () {
						var _v0 = fiche.gt;
						switch (_v0) {
							case 1:
								return $elm$core$Maybe$Just(
									mention(
										A2(
											$author$project$I18n$Cles$groupeDeSousChampsFichePlusDuTypeNote,
											i18n,
											{
												ca: A2($elm$core$Maybe$withDefault, '', fiche.JV)
											})));
							case 2:
								return $elm$core$Maybe$Just(
									mention(
										$author$project$I18n$Cles$groupeDeSousChampsFicheEffaceeNote(i18n)));
							case 3:
								return $elm$core$Maybe$Just(
									mention(
										$author$project$I18n$Cles$groupeDeSousChampsFicheIndisponibleNote(i18n)));
							default:
								return $elm$core$Maybe$Nothing;
						}
					}()
					])));
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$ficheDeLOccurrence = F3(
	function (contexte, sousChamps, lue) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (champ) {
					var _v0 = champ.r0;
					if (_v0.$ === 19) {
						var _v1 = A2(
							$elm$core$Maybe$map,
							$elm$core$Tuple$second,
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Tuple$first,
										$elm$core$Basics$eq(champ.dy)),
									lue.Ki)));
						if ((!_v1.$) && (_v1.a.$ === 1)) {
							var uid = _v1.a.a;
							return $elm$core$Maybe$Just(
								A2(
									$elm$core$Maybe$withDefault,
									{aa: $elm$core$Maybe$Nothing, gt: 3, Dj: $elm$core$Maybe$Nothing, JV: $elm$core$Maybe$Nothing, r8: uid},
									$elm$core$List$head(
										A2(
											$elm$core$List$filter,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.r8;
												},
												$elm$core$Basics$eq(uid)),
											contexte.zu))));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				sousChamps));
	});
var $author$project$I18n$Cles$groupeDeSousChampsModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'groupe-de-sous-champs.modifier', _List_Nil, 'Modifier');
};
var $author$project$I18n$Cles$groupeDeSousChampsModifierNom = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.modifier.nom',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Modifier ' + p.Dj);
	});
var $author$project$I18n$Cles$groupeDeSousChampsRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'groupe-de-sous-champs.retirer', _List_Nil, 'Retirer');
};
var $author$project$I18n$Cles$groupeDeSousChampsRetirerNom = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'groupe-de-sous-champs.retirer.nom',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer ' + p.Dj);
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$ligne = F6(
	function (i18n, contexte, actions, contenu, champ, lue) {
		var pointille = F3(
			function (libelle, libelleDuNom, msg) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', libelleDuNom),
							$rtfeldman$elm_css$Html$Styled$Attributes$title(libelleDuNom),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(libelle)
								]))
						]));
			});
		var dit = A4(
			$author$project$Components$Shared$EditeurDeSchema$Groupe$resume,
			i18n,
			contexte,
			$author$project$Components$Shared$EditeurDeSchema$Groupe$montres(contenu),
			lue);
		var nom = (dit.h6 === '') ? champ.Bl : dit.h6;
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('occurrence')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(dit.h6)
								])),
							A2(
							$elm$core$Maybe$withDefault,
							$rtfeldman$elm_css$Html$Styled$text(''),
							A2(
								$elm$core$Maybe$map,
								$author$project$Components$Shared$EditeurDeSchema$Groupe$ficheCitee(i18n),
								A3($author$project$Components$Shared$EditeurDeSchema$Groupe$ficheDeLOccurrence, contexte, contenu.IX, lue)))
						])),
					A2($author$project$Components$Shared$EditeurDeSchema$Groupe$conditions, i18n, dit.cz),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$map,
								function (modif) {
									return A3(
										pointille,
										$author$project$I18n$Cles$groupeDeSousChampsModifier(i18n),
										A2(
											$author$project$I18n$Cles$groupeDeSousChampsModifierNom,
											i18n,
											{Dj: nom}),
										modif(lue.r8));
								},
								actions.ei),
								contenu.HI ? A2(
								$elm$core$Maybe$map,
								function (retrait) {
									return A3(
										pointille,
										$author$project$I18n$Cles$groupeDeSousChampsRetirer(i18n),
										A2(
											$author$project$I18n$Cles$groupeDeSousChampsRetirerNom,
											i18n,
											{Dj: nom}),
										retrait(lue.r8));
								},
								actions.H0) : $elm$core$Maybe$Nothing
							])))
				]));
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$pointilleDAjout = F2(
	function (msg, libelle) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('+ ' + libelle)
						]))
				]));
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$triees = F2(
	function (contenu, lues) {
		var _v0 = contenu.r9;
		if (_v0.b) {
			var cle = _v0.a;
			var rang = function (lue) {
				var _v1 = A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$second,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$first,
								$elm$core$Basics$eq(cle)),
							lue.Ki)));
				if ((!_v1.$) && (_v1.a.$ === 2)) {
					var n = _v1.a.a;
					return -n;
				} else {
					return 0;
				}
			};
			return A2($elm$core$List$sortBy, rang, lues);
		} else {
			return lues;
		}
	});
var $author$project$Components$Shared$EditeurDeSchema$Groupe$bloc = F5(
	function (i18n, contexteDeLaFiche, actions, champ, valeur) {
		var contexte = A2($author$project$Components$Shared$EditeurDeSchema$Groupe$portee, champ.dy, contexteDeLaFiche);
		var contenu = A2(
			$elm$core$Maybe$withDefault,
			{z9: 1, Bq: '', Cd: _List_Nil, HI: true, IX: _List_Nil, r9: _List_Nil},
			$author$project$Components$Shared$EditeurDeSchema$Groupe$sousChampsDe(champ));
		var lues = A2(
			$author$project$Components$Shared$EditeurDeSchema$Groupe$triees,
			contenu,
			$author$project$Components$Shared$EditeurDeSchema$Groupe$occurrences(valeur));
		var geste = function () {
			var _v0 = _Utils_Tuple3(contenu.HI, lues, actions.s7);
			_v0$2:
			while (true) {
				if (_v0.a) {
					if (!_v0.c.$) {
						var ajout = _v0.c.a;
						return _List_fromArray(
							[
								A2(
								$author$project$Components$Shared$EditeurDeSchema$Groupe$pointilleDAjout,
								ajout,
								A2(
									$author$project$I18n$Cles$groupeDeSousChampsAjouter,
									i18n,
									{
										D$: A2(
											$author$project$I18n$Cles$texte,
											i18n,
											$author$project$Components$Shared$EditeurDeSchema$Groupe$occurrenceAvecArticle(contenu))
									}))
							]);
					} else {
						break _v0$2;
					}
				} else {
					if ((!_v0.b.b) && (!_v0.c.$)) {
						var ajout = _v0.c.a;
						return _List_fromArray(
							[
								A2(
								$author$project$Components$Shared$EditeurDeSchema$Groupe$pointilleDAjout,
								ajout,
								A2(
									$author$project$I18n$Cles$groupeDeSousChampsRenseigner,
									i18n,
									{D$: contenu.Bq}))
							]);
					} else {
						break _v0$2;
					}
				}
			}
			return _List_Nil;
		}();
		var lignes = A2(
			$elm$core$List$map,
			A5($author$project$Components$Shared$EditeurDeSchema$Groupe$ligne, i18n, contexte, actions, contenu, champ),
			lues);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('groupe-de-sous-champs'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'vide',
							$elm$core$List$isEmpty(lues))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('occurrences')
						]),
					lignes),
					$elm$core$List$isEmpty(lues) ? A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Shared$EditeurDeSchema$Groupe$aucuneOccurrence, i18n, contenu))
						])) : $rtfeldman$elm_css$Html$Styled$text(''),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout')
						]),
					geste)
				]));
	});
var $author$project$Components$Produits$Reference$GroupesView$section = F4(
	function (i18n, normes, fiche, champ) {
		var valeur = A2($author$project$Components$Produits$Reference$Model$valeurDuGroupe, fiche, champ.dy);
		var servi = function (rel) {
			return !_Utils_eq(
				A2(
					$author$project$API$Liens$trouver,
					rel,
					A2($author$project$Components$Produits$Reference$Model$liensDuGroupe, fiche, champ.dy)),
				$elm$core$Maybe$Nothing);
		};
		var actions = {
			s7: servi($author$project$API$NavLinksDictionary$ajouterUneOccurrenceDUnGroupe) ? $elm$core$Maybe$Just(
				A2($author$project$Components$Produits$Reference$Update$OccurrenceDemandee, champ.dy, $elm$core$Maybe$Nothing)) : $elm$core$Maybe$Nothing,
			ei: servi($author$project$API$NavLinksDictionary$modifierUneOccurrenceDUnGroupe) ? $elm$core$Maybe$Just(
				function (uid) {
					return A2(
						$author$project$Components$Produits$Reference$Update$OccurrenceDemandee,
						champ.dy,
						$elm$core$Maybe$Just(uid));
				}) : $elm$core$Maybe$Nothing,
			H0: servi($author$project$API$NavLinksDictionary$retirerUneOccurrenceDUnGroupe) ? $elm$core$Maybe$Just(
				$author$project$Components$Produits$Reference$Update$RetraitDOccurrenceDemande(champ.dy)) : $elm$core$Maybe$Nothing
		};
		return A2(
			$author$project$Components$Shared$Page$View$sectionAvecCompte,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id('groupe-' + champ.dy)
				]),
			{
				fw: _List_Nil,
				vW: $elm$core$Maybe$Just(
					$elm$core$String$fromInt(
						$elm$core$List$length(
							$author$project$Components$Shared$EditeurDeSchema$Groupe$occurrences(valeur)))),
				fZ: _List_fromArray(
					[
						A5(
						$author$project$Components$Shared$EditeurDeSchema$Groupe$bloc,
						i18n,
						A2($author$project$Components$Produits$Reference$Model$contexteDesGroupes, normes, fiche),
						actions,
						champ,
						valeur)
					]),
				Ar: $elm$core$Maybe$Nothing,
				Dj: 'champ-groupe',
				h6: champ.Bl
			});
	});
var $rtfeldman$elm_css$Html$Styled$summary = $rtfeldman$elm_css$Html$Styled$node('summary');
var $author$project$Components$Produits$Reference$View$blocDeLaFiche = F5(
	function (i18n, model, fiche, rang, _v0) {
		var libelle = _v0.a;
		var _v1 = _v0.b;
		var resumes = _v1.a;
		var details = _v1.b;
		var rangee = function (element) {
			switch (element.$) {
				case 1:
					return $rtfeldman$elm_css$Html$Styled$text('');
				case 2:
					var lue = element.a;
					return A2($author$project$Components$Produits$Reference$View$ligneHeritee, i18n, lue);
				default:
					var r = element.a;
					var _v4 = r.ea;
					if (!_v4.$) {
						var lue = _v4.a;
						return A4($author$project$Components$Produits$Reference$View$ligneDInformation, i18n, model, fiche, lue);
					} else {
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('information')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$dt,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$title(r.o4)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(r.Bl)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$dd,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
										]),
									A2(
										$elm$core$List$cons,
										$rtfeldman$elm_css$Html$Styled$text('—'),
										A3($author$project$Components$Produits$Reference$View$boutonDUtilisateur, i18n, fiche, r.dy)))
								]));
					}
			}
		};
		var groupes = function (elements) {
			return A2(
				$elm$core$List$filterMap,
				function (element) {
					switch (element.$) {
						case 1:
							var champ = element.a;
							return $elm$core$Maybe$Just(
								A4($author$project$Components$Produits$Reference$GroupesView$section, i18n, model.hd, fiche, champ));
						case 0:
							return $elm$core$Maybe$Nothing;
						default:
							return $elm$core$Maybe$Nothing;
					}
				},
				elements);
		};
		return A2(
			$author$project$Components$Shared$Page$View$section,
			(!rang) ? _List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Reference$Model$idDeLaSection),
					$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1)
				]) : _List_Nil,
			{
				fw: A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$produitsReferenceFicheBlocCompte,
									i18n,
									{
										w: $elm$core$List$length(resumes) + $elm$core$List$length(details)
									}))
							])),
					$author$project$Components$Produits$Reference$View$saisissable(fiche) ? _List_fromArray(
						[
							A4(
							$author$project$Components$Shared$Bouton$View$boutonAvecIcone,
							2,
							$author$project$Components$Shared$Svg$svgEdit,
							_Utils_ap(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Reference$Update$ModificationDemandee)
									]),
								(!rang) ? _List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Reference$Model$idDeLaModification)
									]) : _List_Nil),
							$author$project$I18n$Cles$produitsReferenceFicheModifier(i18n))
						]) : _List_Nil),
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$dl,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('informations')
							]),
						A2($elm$core$List$map, rangee, resumes)),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('groupes-du-bloc')
							]),
						groupes(
							_Utils_ap(resumes, details))),
						$elm$core$List$isEmpty(details) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
						$rtfeldman$elm_css$Html$Styled$details,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('detail-du-bloc')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$summary,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$produitsReferenceFicheBlocDetail,
											i18n,
											{
												w: $elm$core$List$length(details)
											}))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$dl,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('informations')
									]),
								A2($elm$core$List$map, rangee, details))
							]))
					]),
				Dj: 'bloc-de-collection',
				h6: libelle
			});
	});
var $author$project$I18n$Cles$produitsReferenceFicheHeriteesNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fiche.heritees-note', _List_Nil, 'Ces valeurs se modifient sur la page de la marque.');
};
var $author$project$I18n$Cles$produitsReferenceFicheNonRenseignes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.fiche.non-renseignes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w)),
					_Utils_Tuple2(
					'noms',
					$author$project$I18n$Traductions$Chaine(p.DG))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' champ non renseigné : ' + p.DG)) : (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' champs non renseignés : ' + p.DG)));
	});
var $author$project$I18n$Cles$produitsReferenceFicheTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fiche.titre', _List_Nil, 'Fiche d\'information');
};
var $author$project$Components$Produits$Reference$View$utilisateurVide = F3(
	function (i18n, fiche, r) {
		return (_Utils_eq(r.ea, $elm$core$Maybe$Nothing) && (A2($author$project$Components$Produits$Reference$View$estUnChampUtilisateur, fiche, r.dy) && (!$elm$core$List$isEmpty(
			A3($author$project$Components$Produits$Reference$View$boutonDUtilisateur, i18n, fiche, r.dy))))) ? $elm$core$Maybe$Just(
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('information')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$dt,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$title(r.o4)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(r.Bl)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$dd,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						A3($author$project$Components$Produits$Reference$View$boutonDUtilisateur, i18n, fiche, r.dy))
					]))) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$Produits$Reference$View$ficheEnUneListe = F4(
	function (i18n, model, fiche, lecture) {
		var nonRenseignes = A2(
			$author$project$I18n$Cles$produitsReferenceFicheNonRenseignes,
			i18n,
			{
				w: $elm$core$List$length(lecture.st),
				DG: A2($elm$core$String$join, ', ', lecture.st)
			});
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Reference$Model$idDeLaSection),
					$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1)
				]),
			{
				fw: A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('archive')
							]),
						fiche.r0.tE ? _List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Tag$View$view,
								3,
								$author$project$I18n$Cles$produitsTypesArchive(i18n))
							]) : _List_Nil),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$produitsReferenceFicheCompte,
										i18n,
										{
											HB: $elm$core$String$fromInt(
												$elm$core$List$length(lecture.qr)),
											JE: $elm$core$String$fromInt(lecture.JE)
										}))
								])),
						$author$project$Components$Produits$Reference$View$saisissable(fiche) ? _List_fromArray(
							[
								A4(
								$author$project$Components$Shared$Bouton$View$boutonAvecIcone,
								2,
								$author$project$Components$Shared$Svg$svgEdit,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Reference$Model$idDeLaModification),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Reference$Update$ModificationDemandee)
									]),
								$author$project$I18n$Cles$produitsReferenceFicheModifier(i18n))
							]) : _List_Nil)),
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$dl,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('informations')
							]),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								A3($author$project$Components$Produits$Reference$View$ligneDInformation, i18n, model, fiche),
								lecture.qr),
							_Utils_ap(
								A2(
									$elm$core$List$filterMap,
									A2($author$project$Components$Produits$Reference$View$utilisateurVide, i18n, fiche),
									lecture.pI),
								A2(
									$elm$core$List$map,
									$author$project$Components$Produits$Reference$View$ligneHeritee(i18n),
									lecture.m5)))),
						$elm$core$List$isEmpty(lecture.m5) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note-heritees')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsReferenceFicheHeriteesNote(i18n))
							])),
						$elm$core$List$isEmpty(lecture.st) ? $rtfeldman$elm_css$Html$Styled$text('') : ($author$project$Components$Produits$Reference$View$saisissable(fiche) ? A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Reference$Update$ModificationDemandee)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(nonRenseignes)
							])) : A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('non-renseignes')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(nonRenseignes)
							]))),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								((!lecture.JE) && $elm$core$List$isEmpty(lecture.m5)) ? $author$project$I18n$Cles$produitsReferenceCaracteristiquesAucune(i18n) : '')
							]))
					]),
				Dj: 'fiche-d-information',
				h6: $author$project$I18n$Cles$produitsReferenceFicheTitre(i18n)
			});
	});
var $author$project$I18n$Cles$produitsReferenceFicheAutresChamps = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fiche.autres-champs', _List_Nil, 'Autres champs');
};
var $author$project$Components$Shared$CollectionDeLaFiche$separerLeDetail = F3(
	function (cleDe, collection, elements) {
		return A2(
			$elm$core$List$partition,
			function (element) {
				return !A2(
					$elm$core$List$member,
					cleDe(element),
					collection.cz);
			},
			elements);
	});
var $author$project$Components$Produits$Reference$View$ficheDInformation = F3(
	function (i18n, model, fiche) {
		var repartition = A3($author$project$Components$Produits$Reference$View$repartitionDeLaFiche, i18n, model.hd, fiche);
		var lecture = A3($author$project$Components$Produits$Reference$Lecture$lire, i18n, model.hd, fiche);
		return $elm$core$List$isEmpty(repartition.js) ? A4($author$project$Components$Produits$Reference$View$ficheEnUneListe, i18n, model, fiche, lecture) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('blocs-de-la-fiche')
				]),
			_Utils_ap(
				A2(
					$elm$core$List$indexedMap,
					A3($author$project$Components$Produits$Reference$View$blocDeLaFiche, i18n, model, fiche),
					_Utils_ap(
						A2(
							$elm$core$List$map,
							function (_v0) {
								var collection = _v0.a;
								var elements = _v0.b;
								return _Utils_Tuple2(
									collection.Bl,
									A3($author$project$Components$Shared$CollectionDeLaFiche$separerLeDetail, $author$project$Components$Produits$Reference$View$cleDeLElement, collection, elements));
							},
							repartition.js),
						$elm$core$List$isEmpty(repartition.t7) ? _List_Nil : _List_fromArray(
							[
								_Utils_Tuple2(
								$author$project$I18n$Cles$produitsReferenceFicheAutresChamps(i18n),
								_Utils_Tuple2(repartition.t7, _List_Nil))
							]))),
				_List_fromArray(
					[
						$elm$core$List$isEmpty(lecture.m5) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note-heritees')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsReferenceFicheHeriteesNote(i18n))
							]))
					])));
	});
var $author$project$Components$Produits$Reference$Model$idDesFichiers = 'section-fichiers';
var $author$project$Components$Produits$Reference$Model$idDesOffres = 'section-offres';
var $author$project$Components$Produits$Reference$Model$idDesVariantes = 'section-variantes';
var $author$project$Components$Produits$Reference$Model$plafondDeLActivite = 5;
var $author$project$I18n$Cles$produitsReferenceOngletCaracteristiques = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.onglet.caracteristiques', _List_Nil, 'Informations');
};
var $author$project$I18n$Cles$produitsReferenceOngletCoutsEtMarges = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.onglet.couts-et-marges', _List_Nil, 'Coûts et marges · réservé (Epic 14)');
};
var $author$project$I18n$Cles$produitsReferenceOngletFichiers = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.onglet.fichiers', _List_Nil, 'Fichiers');
};
var $author$project$I18n$Cles$produitsReferenceOngletHistorique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.onglet.historique', _List_Nil, 'Historique');
};
var $author$project$I18n$Cles$produitsReferenceOngletOffres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.onglet.offres', _List_Nil, 'Offres et prix');
};
var $author$project$I18n$Cles$produitsReferenceOngletVariantes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.onglet.variantes', _List_Nil, 'Variantes');
};
var $author$project$I18n$Cles$produitsReferenceOnglets = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.onglets', _List_Nil, 'Sections de la fiche');
};
var $author$project$Components$Produits$Reference$View$onglets = F3(
	function (i18n, model, fiche) {
		var vers = F4(
			function (premier, cible, libelle, compteur) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_Utils_ap(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$href('#' + cible),
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('active', premier)
									]))
							]),
						premier ? _List_fromArray(
							[
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-current', 'page')
							]) : _List_Nil),
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$text(libelle),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (nombre) {
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('compteur')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$elm$core$String$fromInt(nombre))
												]))
										]);
								},
								compteur))));
			});
		var activiteComplete = _Utils_cmp(
			$elm$core$List$length(fiche.sT),
			$author$project$Components$Produits$Reference$Model$plafondDeLActivite) < 0;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('tabs'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					$author$project$I18n$Cles$produitsReferenceOnglets(i18n))
				]),
			_List_fromArray(
				[
					A4(
					vers,
					true,
					$author$project$Components$Produits$Reference$Model$idDeLaSection,
					$author$project$I18n$Cles$produitsReferenceOngletCaracteristiques(i18n),
					$elm$core$Maybe$Just(
						A3($author$project$Components$Produits$Reference$Lecture$lire, i18n, model.hd, fiche).JE)),
					A4(
					vers,
					false,
					$author$project$Components$Produits$Reference$Model$idDesFichiers,
					$author$project$I18n$Cles$produitsReferenceOngletFichiers(i18n),
					$elm$core$Maybe$Just(
						$elm$core$List$length(fiche.zB))),
					A4(
					vers,
					false,
					$author$project$Components$Produits$Reference$Model$idDesVariantes,
					$author$project$I18n$Cles$produitsReferenceOngletVariantes(i18n),
					$elm$core$Maybe$Just(
						$elm$core$List$length(fiche.Kw))),
					A4(
					vers,
					false,
					$author$project$Components$Produits$Reference$Model$idDesOffres,
					$author$project$I18n$Cles$produitsReferenceOngletOffres(i18n),
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.ES;
							},
							$elm$core$List$length),
						model.py)),
					A4(
					vers,
					false,
					$author$project$Components$Produits$Reference$Model$idDeLActivite,
					$author$project$I18n$Cles$produitsReferenceOngletHistorique(i18n),
					activiteComplete ? $elm$core$Maybe$Just(
						$elm$core$List$length(fiche.sT)) : $elm$core$Maybe$Nothing),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('reserve'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-disabled', 'true')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsReferenceOngletCoutsEtMarges(i18n))
						]))
				]));
	});
var $author$project$I18n$Cles$produitsReferencePrixAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.prix.aucun', _List_Nil, 'aucun prix · « Prix sur demande »');
};
var $author$project$I18n$Cles$produitsReferencePrixListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.prix.liste', _List_Nil, 'Liste de prix');
};
var $author$project$I18n$Cles$produitsReferencePrixNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.prix.note', _List_Nil, 'Les prix se saisissent dans les listes de prix (« Listes de prix »).');
};
var $author$project$I18n$Cles$produitsReferencePrixPrix = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.prix.prix', _List_Nil, 'Prix');
};
var $author$project$I18n$Cles$produitsReferencePrixPublic = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.prix.public', _List_Nil, 'Public');
};
var $author$project$I18n$Cles$produitsReferencePrixTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.prix.titre', _List_Nil, 'Offres et prix');
};
var $author$project$Components$Produits$Reference$View$prix = F2(
	function (i18n, lus) {
		var ligne = F3(
			function (liste, _public, montant) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$th,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$scope('row')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(liste)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$td,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(_public)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$td,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('prix')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(montant)
								]))
						]));
			});
		if (!lus.$) {
			var servis = lus.a;
			return A2(
				$author$project$Components$Shared$Page$View$section,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Reference$Model$idDesOffres),
						$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1)
					]),
				{
					fw: _List_Nil,
					fZ: _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$table,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$thead,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$tr,
													_List_Nil,
													A2(
														$elm$core$List$map,
														function (nom) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$th,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(nom)
																	]));
														},
														_List_fromArray(
															[
																$author$project$I18n$Cles$produitsReferencePrixListe(i18n),
																$author$project$I18n$Cles$produitsReferencePrixPublic(i18n),
																$author$project$I18n$Cles$produitsReferencePrixPrix(i18n)
															])))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$tbody,
											_List_Nil,
											_Utils_ap(
												A2(
													$elm$core$List$map,
													function (parListe) {
														return A3(
															ligne,
															parListe.nW.Dj.zX,
															(parListe.GF && $elm$core$List$isEmpty(parListe.GA)) ? $author$project$I18n$Cles$produitsListesDePrixCarteVisiteurs(i18n) : A2($author$project$Components$Produits$Common$Prix$publics, i18n, parListe.GA),
															A3(
																$author$project$Components$Produits$Common$Prix$court,
																i18n,
																{
																	kO: parListe.py.kO,
																	rB: $elm$core$Maybe$Just(parListe.py.rB)
																},
																parListe.py));
													},
													servis.ES),
												A2(
													$elm$core$List$map,
													function (_public) {
														return A3(
															ligne,
															$author$project$I18n$Cles$produitsCatalogueInfoSansValeur(i18n),
															A2(
																$author$project$Components$Produits$Common$Prix$publics,
																i18n,
																_List_fromArray(
																	[_public])),
															$author$project$I18n$Cles$produitsReferencePrixAucun(i18n));
													},
													servis.GC)))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsReferencePrixNote(i18n))
								]))
						]),
					Dj: 'prix-de-la-reference',
					h6: $author$project$I18n$Cles$produitsReferencePrixTitre(i18n)
				});
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Produits$Reference$Update$ProduitDemande = {$: 23};
var $author$project$I18n$Cles$produitsReferenceProduitLigne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.produit.ligne',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Produit : ' + p.Dj);
	});
var $author$project$Components$Produits$Reference$View$produitDeLaReference = F2(
	function (i18n, fiche) {
		var _v0 = $author$project$Components$Produits$Reference$Model$lienDuProduit(fiche);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var produit = _v1.b;
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('lien-texte'),
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Reference$Model$idDuProduit),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Reference$Update$ProduitDemande)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$produitsReferenceProduitLigne,
								i18n,
								{Dj: produit.Dj}))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$I18n$Cles$produitsReferenceTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'code',
					$author$project$I18n$Traductions$Chaine(p.vx)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.vx + (' · ' + p.Dj));
	});
var $author$project$I18n$Cles$produitsReferenceCompletudeCompte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.completude.compte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'remplis',
					$author$project$I18n$Traductions$Entier(p.HB)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			((!p.HB) || (p.HB === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.HB) + (' critère sur ' + p.JE)) : (A2($author$project$I18n$Nombre$formater, 0, p.HB) + (' critères sur ' + p.JE)));
	});
var $author$project$Components$Produits$Reference$View$compte = F2(
	function (i18n, lue) {
		return A2(
			$author$project$I18n$Cles$produitsReferenceCompletudeCompte,
			i18n,
			{
				HB: lue.HB,
				JE: $elm$core$String$fromInt(lue.JE)
			});
	});
var $author$project$Components$Produits$Reference$View$marqueDe = function (fiche) {
	var _v0 = A2(
		$elm$core$List$filter,
		function (etape) {
			return _Utils_eq(etape.md.g1, $author$project$Catalogue$Vocabulaire$codeMarque);
		},
		fiche.jK);
	if (_v0.b) {
		var etape = _v0.a;
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.zX;
			},
			etape.R);
	} else {
		return A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.R;
				},
				function ($) {
					return $.zX;
				}),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (etape) {
						return _Utils_eq(
							$author$project$Catalogue$Identifiants$niveauIdToString(etape.os),
							$author$project$Catalogue$Vocabulaire$codeMarque);
					},
					fiche.zD)));
	}
};
var $author$project$I18n$Cles$produitsReferenceDeLaMarque = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.de-la-marque',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'marque',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.gX)))
				]),
			'Référence ' + function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.gX);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.gX);
					default:
						return 'de ' + $elm$core$String$trim(p.gX);
				}
			}());
	});
var $author$project$I18n$Cles$produitsReferenceEan = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.ean',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'ean',
					$author$project$I18n$Traductions$Chaine(p.lI))
				]),
			'EAN ' + p.lI);
	});
var $author$project$I18n$Cles$produitsReferenceMillesime = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.millesime',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'millesime',
					$author$project$I18n$Traductions$Chaine(p.n8))
				]),
			'Millésime ' + p.n8);
	});
var $author$project$I18n$Cles$produitsReferenceVariante = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.variante',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'variante',
					$author$project$I18n$Traductions$Chaine(p.sl))
				]),
			'Variante ' + p.sl);
	});
var $author$project$I18n$Cles$produitsReferenceVerrouillee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.verrouillee', _List_Nil, 'Fiche verrouillée');
};
var $author$project$I18n$Cles$produitsReferenceVerrouilleeAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.verrouillee-aide', _List_Nil, 'Ses informations, sa place dans l\'arbre et ses valeurs de liste ne se modifient plus. Repassez la référence à un état antérieur pour la corriger.');
};
var $author$project$Components$Produits$Reference$View$resume = F2(
	function (i18n, fiche) {
		var dit = F2(
			function (nommer, valeur) {
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (donnee) {
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											nommer(donnee))
										]))
								]);
						},
						valeur));
			});
		return _Utils_ap(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (marque) {
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('fabricant')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$produitsReferenceDeLaMarque,
											i18n,
											{
												av: $author$project$Texte$Elision$elision(marque),
												gX: marque
											}))
									]))
							]);
					},
					$author$project$Components$Produits$Reference$View$marqueDe(fiche))),
			_Utils_ap(
				A2(
					dit,
					function (millesime) {
						return A2(
							$author$project$I18n$Cles$produitsReferenceMillesime,
							i18n,
							{n8: millesime});
					},
					fiche.n8),
				_Utils_ap(
					A2(
						dit,
						function (variante) {
							return A2(
								$author$project$I18n$Cles$produitsReferenceVariante,
								i18n,
								{sl: variante});
						},
						fiche.sl),
					_Utils_ap(
						A2(
							dit,
							function (ean) {
								return A2(
									$author$project$I18n$Cles$produitsReferenceEan,
									i18n,
									{lI: ean});
							},
							fiche.lI),
						_Utils_ap(
							fiche.tL ? _List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Tag$View$view,
									3,
									$author$project$I18n$Cles$produitsReferencesCarteArretee(i18n))
								]) : _List_Nil,
							_Utils_ap(
								fiche.KB ? _List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Tag$View$view,
										1,
										$author$project$I18n$Cles$produitsReferenceVerrouillee(i18n)),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('verrouillee-aide')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$produitsReferenceVerrouilleeAide(i18n))
											]))
									]) : _List_Nil,
								_Utils_ap(
									(!_Utils_eq(
										$author$project$Components$Produits$Reference$View$horsLimites(fiche),
										_List_Nil)) ? _List_fromArray(
										[
											A2(
											$author$project$Components$Shared$Tag$View$view,
											2,
											$author$project$I18n$Cles$produitsReferenceNonPubliable(i18n))
										]) : _List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('completude')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$elm$core$Maybe$withDefault,
														'',
														A2(
															$elm$core$Maybe$map,
															$author$project$Components$Produits$Reference$View$compte(i18n),
															fiche.fU)))
												]))
										]))))))));
	});
var $author$project$Components$Produits$Reference$Update$RetraitConfirme = {$: 72};
var $author$project$Components$Produits$Reference$Update$clavierDuRetrait = A2($author$project$Components$Shared$Confirmation$Clavier$clavier, $author$project$Components$Produits$Reference$Model$idsDuRetrait, $author$project$Components$Produits$Reference$Update$FocusDemande);
var $author$project$I18n$Cles$produitsReferenceFichiersRetraitConfirmer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fichiers.retrait-confirmer', _List_Nil, 'Retirer');
};
var $author$project$I18n$Cles$produitsReferenceFichiersRetraitMessage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.fichiers.retrait-message',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN)),
					_Utils_Tuple2(
					'code',
					$author$project$I18n$Traductions$Chaine(p.vx))
				]),
			'Retirer le fichier du champ ' + (p.uN + (' de ' + (p.vx + ' ? Le champ n\'aura plus de fichier ; vous pourrez en déposer un autre.'))));
	});
var $author$project$I18n$Cles$produitsReferenceFichiersRetraitTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fichiers.retrait-titre', _List_Nil, 'Retirer le fichier');
};
var $author$project$Components$Produits$Reference$FichiersView$retrait = F3(
	function (i18n, model, fiche) {
		var libelle = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				function (cle) {
					return A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.Bl;
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.dy;
									},
									$elm$core$Basics$eq(cle)),
								$author$project$Components$Produits$Reference$Fichiers$champsFichier(
									$author$project$Components$Produits$Reference$Model$champs(fiche)))));
				},
				model.dh));
		var ids = $author$project$Components$Produits$Reference$Model$idsDuRetrait;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'opened',
							!_Utils_eq(model.dh, $elm$core$Maybe$Nothing))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('overlay'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Reference$Update$RetraitAnnule)
						]),
					_List_Nil),
					A2(
					$author$project$Components$Shared$Confirmation$View$view,
					i18n,
					{
						vl: $author$project$Components$Produits$Reference$Update$clavierDuRetrait,
						j7: {
							Aq: ids.j7,
							Bl: $author$project$I18n$Cles$produitsReferenceFichiersRetraitConfirmer(i18n),
							C$: $author$project$Components$Produits$Reference$Update$RetraitConfirme
						},
						Aq: ids.GN,
						As: ids.Cs,
						At: ids.h6,
						Cs: A2(
							$author$project$I18n$Cles$produitsReferenceFichiersRetraitMessage,
							i18n,
							{uN: libelle, vx: fiche.vx}),
						Et: !_Utils_eq(model.dh, $elm$core$Maybe$Nothing),
						HG: {
							Aq: ids.to,
							Bl: $author$project$I18n$Cles$produitsCatalogueArchivageAnnuler(i18n),
							C$: $author$project$Components$Produits$Reference$Update$RetraitAnnule
						},
						h6: $author$project$I18n$Cles$produitsReferenceFichiersRetraitTitre(i18n),
						sl: 0
					})
				]));
	});
var $author$project$Components$Produits$Reference$Update$DepotDemande = function (a) {
	return {$: 64, a: a};
};
var $author$project$Components$Produits$Reference$Update$RetraitDemande = function (a) {
	return {$: 70, a: a};
};
var $author$project$I18n$Cles$produitsReferenceFichiersDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.fichiers.detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'format',
					$author$project$I18n$Traductions$Chaine(p.zP)),
					_Utils_Tuple2(
					'taille',
					$author$project$I18n$Traductions$Chaine(p.Jm))
				]),
			p.zP + (' · ' + p.Jm));
	});
var $author$project$I18n$Cles$produitsReferenceFichiersDimensions = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.fichiers.dimensions',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'largeur',
					$author$project$I18n$Traductions$Chaine(p.Bd)),
					_Utils_Tuple2(
					'hauteur',
					$author$project$I18n$Traductions$Chaine(p.Ae))
				]),
			p.Bd + (' × ' + (p.Ae + ' px')));
	});
var $author$project$Components$Produits$Reference$FichiersView$apercu = F5(
	function (i18n, model, _v0, libelle, fichier) {
		var texte = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(fichier.Jy)));
		var image = A2($elm$core$String$startsWith, 'image/', fichier.r0);
		var adresse = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.aa;
			},
			A2($author$project$Components$Produits$Reference$Model$documentDuChamp, model, fichier.uN));
		return _List_fromArray(
			[
				function () {
				var _v1 = _Utils_Tuple2(image, adresse);
				if (_v1.a && (!_v1.b.$)) {
					var lue = _v1.b.a;
					return A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vignette'),
								$rtfeldman$elm_css$Html$Styled$Attributes$src(lue),
								$rtfeldman$elm_css$Html$Styled$Attributes$alt(texte),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-champ', fichier.uN),
								A2(
								$rtfeldman$elm_css$Html$Styled$Events$on,
								'error',
								$elm$json$Json$Decode$succeed($author$project$Components$Produits$Reference$Update$AdresseExpiree))
							]),
						_List_Nil);
				} else {
					return A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vignette'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
							]),
						_List_fromArray(
							[$author$project$Components$Shared$Svg$svgFile]));
				}
			}(),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('infos')
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$produitsReferenceFichiersDetail,
										i18n,
										{
											zP: $author$project$Components$Produits$Reference$Fichiers$formatDuType(fichier.r0),
											Jm: A2($author$project$Components$Produits$Reference$FichiersView$taille, i18n, fichier.Jm)
										}))
								]))
						]),
					_Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (d) {
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('dimensions')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$author$project$I18n$Cles$produitsReferenceFichiersDimensions,
														i18n,
														{
															Ae: $elm$core$String$fromInt(d.Ae),
															Bd: $elm$core$String$fromInt(d.Bd)
														}))
												]))
										]);
								},
								fichier.xz)),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$ul,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('textes-alternatifs')
									]),
								A2(
									$elm$core$List$map,
									function (_v2) {
										var langue = _v2.a;
										var contenu = _v2.b;
										return A2(
											$rtfeldman$elm_css$Html$Styled$li,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															A2(
																$author$project$I18n$Cles$produitsReferenceFichiersTexteAlternatif,
																i18n,
																{
																	nn: A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$langue, i18n, langue)
																}))
														])),
													$rtfeldman$elm_css$Html$Styled$text(' : ' + contenu)
												]));
									},
									fichier.Jy))
							]))))
			]);
	});
var $author$project$I18n$Cles$produitsReferenceFichiersMinimaHauteur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.fichiers.minima-hauteur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'hauteur',
					$author$project$I18n$Traductions$Chaine(p.Ae))
				]),
			'Hauteur minimale : ' + (p.Ae + ' px'));
	});
var $author$project$I18n$Cles$produitsReferenceFichiersMinimaLargeur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.fichiers.minima-largeur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'largeur',
					$author$project$I18n$Traductions$Chaine(p.Bd))
				]),
			'Largeur minimale : ' + (p.Bd + ' px'));
	});
var $author$project$I18n$Cles$produitsReferenceFichiersMinimaTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fichiers.minima-texte', _List_Nil, 'Texte alternatif exigé');
};
var $author$project$Components$Produits$Reference$FichiersView$minimaDuChamp = F2(
	function (i18n, minima) {
		if (!minima.$) {
			var lus = minima.a;
			return A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function (n) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$produitsReferenceFichiersMinimaLargeur,
											i18n,
											{
												Bd: $elm$core$String$fromInt(n)
											}))
									]));
						},
						lus.Be),
						A2(
						$elm$core$Maybe$map,
						function (n) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$produitsReferenceFichiersMinimaHauteur,
											i18n,
											{
												Ae: $elm$core$String$fromInt(n)
											}))
									]));
						},
						lus.Af),
						lus.Jz ? $elm$core$Maybe$Just(
						A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsReferenceFichiersMinimaTexte(i18n))
								]))) : $elm$core$Maybe$Nothing
					]));
		} else {
			return _List_Nil;
		}
	});
var $author$project$I18n$Cles$produitsReferenceFichiersDeposer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fichiers.deposer', _List_Nil, 'Déposer');
};
var $author$project$I18n$Cles$produitsReferenceFichiersOuvrir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fichiers.ouvrir', _List_Nil, 'Ouvrir');
};
var $author$project$I18n$Cles$produitsReferenceFichiersRemplacer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fichiers.remplacer', _List_Nil, 'Remplacer');
};
var $author$project$I18n$Cles$produitsReferenceFichiersRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fichiers.retirer', _List_Nil, 'Retirer');
};
var $author$project$I18n$Cles$produitsReferenceFichiersSansFichier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fichiers.sans-fichier', _List_Nil, 'Aucun fichier.');
};
var $author$project$Components$Shared$Svg$svgAdd = A3(
	$author$project$Components$Shared$Svg$icone,
	'add',
	'M12.0001,8.4394 L12.0001,15.5608 M15.5644,12.0001 L8.4356,12.0001',
	_List_fromArray(
		[
			$author$project$Components$Shared$Svg$traceSecondaire('M2.3001,12.0001 C2.3001,4.7256 4.7256,2.3001 12.0001,2.3001 C19.2746,2.3001 21.7001,4.7256 21.7001,12.0001 C21.7001,19.2746 19.2746,21.7001 12.0001,21.7001 C4.7256,21.7001 2.3001,19.2746 2.3001,12.0001 Z')
		]));
var $author$project$Components$Produits$Reference$FichiersView$champ = F4(
	function (i18n, model, fiche, lu) {
		var retirer = (!_Utils_eq(
			A2($author$project$Components$Produits$Reference$Model$lienDuRetrait, fiche, lu.dy),
			$elm$core$Maybe$Nothing)) ? _List_fromArray(
			[
				A4(
				$author$project$Components$Shared$Bouton$View$boutonAvecIcone,
				3,
				$author$project$Components$Shared$Svg$svgClose,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$Reference$Update$RetraitDemande(lu.dy))
					]),
				$author$project$I18n$Cles$produitsReferenceFichiersRetirer(i18n))
			]) : _List_Nil;
		var minima = A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$eq(lu.dy)),
					fiche.r0.CC)));
		var courant = A2($author$project$Components$Produits$Reference$Fichiers$fichierDuChamp, fiche, lu.dy);
		var deposer = A3($author$project$Components$Produits$Reference$Model$depotPossible, model, fiche, lu.dy) ? _List_fromArray(
			[
				A4(
				$author$project$Components$Shared$Bouton$View$boutonAvecIcone,
				1,
				$author$project$Components$Shared$Svg$svgAdd,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$Reference$Update$DepotDemande(lu.dy)),
						$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Reference$Model$idDuDepot + ('-' + lu.dy))
					]),
				_Utils_eq(courant, $elm$core$Maybe$Nothing) ? $author$project$I18n$Cles$produitsReferenceFichiersDeposer(i18n) : $author$project$I18n$Cles$produitsReferenceFichiersRemplacer(i18n))
			]) : _List_Nil;
		var ouvrir = function () {
			var _v1 = A2(
				$elm$core$Maybe$andThen,
				function (fichier) {
					return A2($author$project$Components$Produits$Reference$Model$documentDuChamp, model, fichier.uN);
				},
				courant);
			if (!_v1.$) {
				var document = _v1.a;
				return _List_fromArray(
					[
						A4(
						$author$project$Components$Shared$Bouton$View$lienAvec,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'rel', 'noopener'),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-label',
								$author$project$I18n$Cles$produitsReferenceFichiersOuvrir(i18n)),
								$rtfeldman$elm_css$Html$Styled$Attributes$title(
								$author$project$I18n$Cles$produitsReferenceFichiersOuvrir(i18n))
							]),
						document.aa,
						$author$project$I18n$Cles$produitsReferenceFichiersOuvrir(i18n))
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$fieldset,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('fichier'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'vide',
							_Utils_eq(courant, $elm$core$Maybe$Nothing))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$legend,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(lu.Bl)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('courant')
						]),
					function () {
						if (!courant.$) {
							var fichier = courant.a;
							return A5($author$project$Components$Produits$Reference$FichiersView$apercu, i18n, model, fiche, lu.Bl, fichier);
						} else {
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsReferenceFichiersSansFichier(i18n))
										]))
								]);
						}
					}()),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('minima')
						]),
					A2($author$project$Components$Produits$Reference$FichiersView$minimaDuChamp, i18n, minima)),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					_Utils_ap(
						deposer,
						_Utils_ap(ouvrir, retirer)))
				]));
	});
var $author$project$I18n$Cles$produitsReferenceFichiersAucunChamp = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.fichiers.aucun-champ',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'categorie',
					$author$project$I18n$Traductions$Chaine(p.uK))
				]),
			'Aucun champ fichier n\'est défini pour ' + (p.uK + '. '));
	});
var $author$project$I18n$Cles$produitsReferenceFichiersAucunChampLien = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fichiers.aucun-champ.lien', _List_Nil, 'Ajoutez-en un dans le paramétrage du catalogue.');
};
var $author$project$I18n$Cles$produitsReferenceFichiersTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.fichiers.titre', _List_Nil, 'Fichiers');
};
var $author$project$Components$Produits$Reference$FichiersView$section = F3(
	function (i18n, model, fiche) {
		var champs = $author$project$Components$Produits$Reference$Fichiers$champsFichier(
			$author$project$Components$Produits$Reference$Model$champs(fiche));
		return A2(
			$author$project$Components$Shared$Page$View$sectionAvecCompte,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Reference$Model$idDesFichiers),
					$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1)
				]),
			{
				fw: _List_Nil,
				vW: $elm$core$Maybe$Just(
					$elm$core$String$fromInt(
						$elm$core$List$length(fiche.zB))),
				fZ: $elm$core$List$isEmpty(champs) ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$produitsReferenceFichiersAucunChamp,
									i18n,
									{uK: fiche.r0.Dj.zX})),
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href(
										$author$project$Routes$Route$toString(
											A2($author$project$Routes$Route$ParametrageCatalogue, 3, $elm$core$Maybe$Nothing)))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsReferenceFichiersAucunChampLien(i18n))
									]))
							]))
					]) : A2(
					$elm$core$List$map,
					A3($author$project$Components$Produits$Reference$FichiersView$champ, i18n, model, fiche),
					champs),
				Ar: $elm$core$Maybe$Nothing,
				Dj: 'fichiers',
				h6: $author$project$I18n$Cles$produitsReferenceFichiersTitre(i18n)
			});
	});
var $author$project$Components$Produits$Reference$Update$ArticlesDemandes = function (a) {
	return {$: 40, a: a};
};
var $author$project$Components$Produits$Reference$Update$RetraitDArticleDemande = F2(
	function (a, b) {
		return {$: 54, a: a, b: b};
	});
var $author$project$Components$Produits$Reference$ArticlesView$classeDeLEtat = function (etat) {
	switch (etat) {
		case 0:
			return 'disponible';
		case 1:
			return $author$project$Catalogue$Vocabulaire$etatArrete;
		default:
			return 'indisponible';
	}
};
var $author$project$I18n$Cles$produitsReferenceLiensHerite = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.liens.herite',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'portee',
					$author$project$I18n$Traductions$Chaine(p.F$))
				]),
			'Hérité · ' + p.F$);
	});
var $author$project$I18n$Cles$produitsReferenceLiensHeriteCatalogue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.herite-catalogue', _List_Nil, 'Catalogue');
};
var $author$project$I18n$Cles$produitsReferenceLiensHeriteEtage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.liens.herite-etage',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Hérité · ' + (p.md + (' « ' + (p.Dj + ' »'))));
	});
var $author$project$I18n$Cles$produitsReferenceLiensPropre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.propre', _List_Nil, 'Lien propre');
};
var $author$project$Components$Produits$Reference$ArticlesView$etiquette = F2(
	function (i18n, origine) {
		if (origine.$ === 1) {
			return A2(
				$author$project$Components$Shared$Tag$View$view,
				5,
				$author$project$I18n$Cles$produitsReferenceLiensPropre(i18n));
		} else {
			var herite = origine.a;
			var nom = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.zX;
					},
					herite.Dj));
			return A2(
				$author$project$Components$Shared$Tag$View$view,
				3,
				function () {
					var _v1 = _Utils_Tuple2(herite.F$, herite.md);
					_v1$0:
					while (true) {
						if (!_v1.b.$) {
							if (!_v1.a.$) {
								break _v1$0;
							} else {
								var etage = _v1.b.a;
								return A2(
									$author$project$I18n$Cles$produitsReferenceLiensHeriteEtage,
									i18n,
									{md: etage.zX, Dj: nom});
							}
						} else {
							if (!_v1.a.$) {
								break _v1$0;
							} else {
								var _v3 = _v1.b;
								return A2(
									$author$project$I18n$Cles$produitsReferenceLiensHerite,
									i18n,
									{F$: nom});
							}
						}
					}
					var _v2 = _v1.a;
					return A2(
						$author$project$I18n$Cles$produitsReferenceLiensHerite,
						i18n,
						{
							F$: $author$project$I18n$Cles$produitsReferenceLiensHeriteCatalogue(i18n)
						});
				}());
		}
	});
var $author$project$Components$Produits$Reference$ArticlesView$ligneSecondaire = function (lu) {
	return A2(
		$elm$core$String$join,
		' \u00B7 ',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					lu.vx,
					A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.zX;
					},
					lu.gX),
					A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.zX;
					},
					lu.fh)
				])));
};
var $author$project$Components$Produits$Reference$ArticlesView$article = F4(
	function (i18n, modifiable, lien, lu) {
		var nom = A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Cles$produitsReferenceLiensIndisponible(i18n),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.zX;
				},
				lu.Dj));
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('article-lie'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					$author$project$Components$Produits$Reference$ArticlesView$classeDeLEtat(lu.gt))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('main')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('title')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(nom)
								])),
							function () {
							var _v0 = lu.gt;
							switch (_v0) {
								case 1:
									return A2(
										$author$project$Components$Shared$Tag$View$view,
										1,
										$author$project$I18n$Cles$produitsReferenceLiensArrete(i18n));
								case 2:
									return A2(
										$author$project$Components$Shared$Tag$View$view,
										3,
										$author$project$I18n$Cles$produitsReferenceLiensIndisponible(i18n));
								default:
									return $rtfeldman$elm_css$Html$Styled$text('');
							}
						}(),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('infos')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Components$Produits$Reference$ArticlesView$ligneSecondaire(lu))
								]))
						])),
					A2($author$project$Components$Produits$Reference$ArticlesView$etiquette, i18n, lu.o4),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					(modifiable && _Utils_eq(lu.o4, $elm$core$Maybe$Nothing)) ? _List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							2,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									A2(
										$author$project$I18n$Cles$produitsReferenceLiensRetirerNom,
										i18n,
										{Dj: nom})),
									$rtfeldman$elm_css$Html$Styled$Attributes$title(
									A2(
										$author$project$I18n$Cles$produitsReferenceLiensRetirerNom,
										i18n,
										{Dj: nom})),
									$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Common$ChoixDArticles$idDuRetrait + ('-' + lu.Aq)),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									A2($author$project$Components$Produits$Reference$Update$RetraitDArticleDemande, lien.dy, lu.Aq))
								]),
							$author$project$I18n$Cles$produitsReferenceLiensRetirer(i18n))
						]) : _List_Nil)
				]));
	});
var $author$project$I18n$Cles$produitsReferenceLiensChoisisUnParUn = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.liens.choisis-un-par-un',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Articles choisis un par un · ' + p.w);
	});
var $author$project$I18n$Cles$produitsReferenceLiensPastilleHors = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.liens.pastille-hors',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'designation',
					$author$project$I18n$Traductions$Chaine(p.xt))
				]),
			p.xt + ' · hors périmètre');
	});
var $author$project$Components$Produits$Reference$ArticlesView$articlesChoisis = F3(
	function (i18n, valeur, lien) {
		var propres = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.o4;
				},
				$elm$core$Basics$eq($elm$core$Maybe$Nothing)),
			lien.tP);
		var horsPerimetre = function (lu) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.jL;
						},
						$elm$core$List$any(
							function (c) {
								return _Utils_eq(c.r8, lu.Aq) && (!c.w_);
							})),
					valeur));
		};
		var pastille = function (lu) {
			var texte = A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							lu.vx,
							A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.zX;
							},
							lu.Dj)
						])));
			return horsPerimetre(lu) ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('hors-perimetre')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$produitsReferenceLiensPastilleHors,
							i18n,
							{xt: texte}))
					])) : A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(texte)
					]));
		};
		return $elm$core$List$isEmpty(propres) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('articles-choisis')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$produitsReferenceLiensChoisisUnParUn,
										i18n,
										{
											w: $elm$core$String$fromInt(
												$elm$core$List$length(propres))
										}))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('pastilles')
						]),
					A2($elm$core$List$map, pastille, propres))
				]));
	});
var $author$project$Components$Produits$Reference$ArticlesView$heritesPuisPropres = function (articles) {
	var _v0 = A2(
		$elm$core$List$partition,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.o4;
			},
			$elm$core$Basics$eq($elm$core$Maybe$Nothing)),
		articles);
	var propres = _v0.a;
	var herites = _v0.b;
	return _Utils_ap(herites, propres);
};
var $author$project$I18n$Cles$produitsReferenceLiensPerimetreArchiveGarde = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.perimetre-archive-garde', _List_Nil, 'Archivé : la valeur le garde ; il n\'est plus proposé pour une nouvelle valeur.');
};
var $author$project$I18n$Cles$produitsReferenceLiensPerimetreArchiveLeGarde = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.liens.perimetre-archive-le-garde',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Archivé le ' + (p.wv + ' : la valeur le garde ; il n\'est plus proposé pour une nouvelle valeur.'));
	});
var $author$project$I18n$Cles$produitsReferenceLiensPerimetreIndisponible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.perimetre-indisponible', _List_Nil, 'Périmètre indisponible');
};
var $author$project$I18n$Cles$produitsReferenceLiensPerimetreIndisponibleEtiquette = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.perimetre-indisponible-etiquette', _List_Nil, 'Indisponible');
};
var $author$project$I18n$Cles$produitsReferenceLiensPerimetreIndisponibleExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.perimetre-indisponible-explication', _List_Nil, 'Il n\'existe plus, ou vous n\'avez pas le droit de le lire. La valeur le garde.');
};
var $author$project$I18n$Cles$produitsReferenceLiensPerimetreSuit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.perimetre-suit', _List_Nil, 'Le résultat suit le périmètre : il est recalculé à chaque lecture.');
};
var $author$project$Components$Produits$Reference$ArticlesView$perimetre = F3(
	function (i18n, valeur, lu) {
		var _v0 = _Utils_Tuple2(lu.gt, lu.Dj);
		if ((!_v0.a) && (!_v0.b.$)) {
			var _v1 = _v0.a;
			var nom = _v0.b.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('perimetre-lie'),
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('archive', lu.tE)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('main')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('title'),
												$rtfeldman$elm_css$Html$Styled$Attributes$href(
												$author$project$Routes$Route$adresseDuPerimetre(lu.Aq))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(nom)
											])),
										lu.tE ? A2(
										$author$project$Components$Shared$Tag$View$view,
										1,
										$author$project$I18n$Cles$perimetresArchive(i18n)) : $rtfeldman$elm_css$Html$Styled$text('')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('criteres')
									]),
								_List_fromArray(
									[
										$author$project$Components$Produits$Reference$ArticlesView$resume(
										A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.wp;
												},
												valeur))),
										$rtfeldman$elm_css$Html$Styled$text(
										' ' + function () {
											if (lu.tE) {
												var _v2 = lu.tF;
												if (!_v2.$) {
													var instant = _v2.a;
													return A2(
														$author$project$I18n$Cles$produitsReferenceLiensPerimetreArchiveLeGarde,
														i18n,
														{
															wv: A2(
																$author$project$Texte$Jour$enFrancais,
																i18n,
																$author$project$Texte$Jour$jourDeParis(instant))
														});
												} else {
													return $author$project$I18n$Cles$produitsReferenceLiensPerimetreArchiveGarde(i18n);
												}
											} else {
												return $author$project$I18n$Cles$produitsReferenceLiensPerimetreSuit(i18n);
											}
										}())
									]))
							])),
						function () {
						if (!valeur.$) {
							var v = valeur.a;
							return A2(
								$author$project$Components$Shared$Tag$View$view,
								5,
								A2(
									$author$project$I18n$Cles$produitsReferenceLiensPerimetreDecompte,
									i18n,
									{w: v.wT}));
						} else {
							return $rtfeldman$elm_css$Html$Styled$text('');
						}
					}()
					]));
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('perimetre-lie'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('indisponible')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('main')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('title')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsReferenceLiensPerimetreIndisponible(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('criteres')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsReferenceLiensPerimetreIndisponibleExplication(i18n))
									]))
							])),
						A2(
						$author$project$Components$Shared$Tag$View$view,
						3,
						$author$project$I18n$Cles$produitsReferenceLiensPerimetreIndisponibleEtiquette(i18n))
					]));
		}
	});
var $author$project$I18n$Cles$produitsReferenceLiensAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.aucun', _List_Nil, 'Aucun article lié');
};
var $author$project$I18n$Cles$produitsReferenceLiensChoisisSansPerimetre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.liens.choisis-sans-perimetre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' article choisi (le périmètre indisponible n\'est pas compté)') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' articles choisis (le périmètre indisponible n\'est pas compté)'));
	});
var $author$project$I18n$Cles$produitsReferenceLiensResume = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.liens.resume',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Articles liés à cette référence : ' + (p.w + '. Les liens hérités viennent de l\'étage et ne se retirent pas ici ; les liens propres s\'ajoutent et se retirent.'));
	});
var $author$project$Components$Produits$Reference$Update$PageDeLaValeur = F3(
	function (a, b, c) {
		return {$: 26, a: a, b: b, c: c};
	});
var $author$project$I18n$Cles$produitsReferenceLiensOrigineChoisi = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.origine-choisi', _List_Nil, 'Choisi');
};
var $author$project$I18n$Cles$produitsReferenceLiensOrigineHorsPerimetre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.origine-hors-perimetre', _List_Nil, 'Choisi · hors périmètre');
};
var $author$project$I18n$Cles$produitsReferenceLiensOriginePerimetre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.origine-perimetre', _List_Nil, 'Périmètre');
};
var $author$project$Components$Produits$Reference$ArticlesView$ligne = F2(
	function (i18n, lue) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('code')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(lue.vx)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(lue.xt)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('fabricant')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', lue.gX))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('origine')
						]),
					function () {
						var _v0 = lue.o4;
						switch (_v0) {
							case 0:
								return _List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Tag$View$view,
										3,
										$author$project$I18n$Cles$produitsReferenceLiensOriginePerimetre(i18n))
									]);
							case 1:
								return _List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Tag$View$view,
										3,
										$author$project$I18n$Cles$produitsReferenceLiensOrigineChoisi(i18n))
									]);
							case 2:
								return _List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Tag$View$view,
										3,
										$author$project$I18n$Cles$produitsReferenceLiensOriginePerimetre(i18n)),
										A2(
										$author$project$Components$Shared$Tag$View$view,
										3,
										$author$project$I18n$Cles$produitsReferenceLiensOrigineChoisi(i18n))
									]);
							default:
								return _List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Tag$View$view,
										1,
										$author$project$I18n$Cles$produitsReferenceLiensOrigineHorsPerimetre(i18n))
									]);
						}
					}())
				]));
	});
var $author$project$I18n$Cles$produitsReferenceLiensValeurArticle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.valeur-article', _List_Nil, 'Article');
};
var $author$project$I18n$Cles$produitsReferenceLiensValeurDesignation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.valeur-designation', _List_Nil, 'Désignation');
};
var $author$project$I18n$Cles$produitsReferenceLiensValeurHors = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.liens.valeur-hors',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' choisi hors périmètre') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' choisis hors périmètre'));
	});
var $author$project$I18n$Cles$produitsReferenceLiensValeurOrigine = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.liens.valeur-origine', _List_Nil, 'Origine');
};
var $author$project$I18n$Cles$produitsReferenceLiensValeurPlage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.liens.valeur-plage',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'debut',
					$author$project$I18n$Traductions$Chaine(p.ku)),
					_Utils_Tuple2(
					'fin',
					$author$project$I18n$Traductions$Chaine(p.mI)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			p.ku + ('–' + (p.mI + (' sur ' + (p.JE + ' · pages de 200 articles au plus')))));
	});
var $author$project$I18n$Cles$produitsReferenceLiensValeurTotal = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.liens.valeur-total',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			p.JE + ' du périmètre');
	});
var $author$project$I18n$Cles$produitsReferenceLiensValeurTotalHors = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.liens.valeur-total-hors',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE)),
					_Utils_Tuple2(
					'perimetre',
					$author$project$I18n$Traductions$Chaine(p.E9)),
					_Utils_Tuple2(
					'hors',
					$author$project$I18n$Traductions$Chaine(p.Al))
				]),
			p.JE + (' : ' + (p.E9 + (' du périmètre + ' + p.Al))));
	});
var $author$project$Components$Produits$Reference$ArticlesView$valeurResolue = F4(
	function (i18n, model, cle, perimetreId) {
		var _v0 = A2($elm$core$Dict$get, perimetreId, model.ih);
		if (_v0.$ === 1) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var valeur = _v0.a;
			var total = valeur.wT + valeur.An;
			var nombre = function (n) {
				return A2(
					$author$project$I18n$Cles$produitsReferenceLiensPerimetreDecompte,
					i18n,
					{w: n});
			};
			var fin = valeur.ku + $elm$core$List$length(valeur.gV);
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur-resolue')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('total')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										(valeur.An > 0) ? A2(
											$author$project$I18n$Cles$produitsReferenceLiensValeurTotalHors,
											i18n,
											{
												Al: A2(
													$author$project$I18n$Cles$produitsReferenceLiensValeurHors,
													i18n,
													{w: valeur.An}),
												E9: $elm$core$String$fromInt(valeur.wT),
												JE: nombre(total)
											}) : A2(
											$author$project$I18n$Cles$produitsReferenceLiensValeurTotal,
											i18n,
											{
												JE: nombre(total)
											}))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$table,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('lignes')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$thead,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$produitsReferenceLiensValeurArticle(i18n))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$produitsReferenceLiensValeurDesignation(i18n))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$produitsReferencesListeColonneMarque(i18n))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$produitsReferenceLiensValeurOrigine(i18n))
													]))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$tbody,
								_List_Nil,
								A2(
									$elm$core$List$map,
									$author$project$Components$Produits$Reference$ArticlesView$ligne(i18n),
									valeur.gV))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('plage')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$produitsReferenceLiensValeurPlage,
									i18n,
									{
										ku: $elm$core$String$fromInt(valeur.ku + 1),
										mI: $elm$core$String$fromInt(fin),
										JE: $elm$core$String$fromInt(valeur.JE)
									}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('pages')
							]),
						_List_fromArray(
							[
								(valeur.ku > 0) ? A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										A3(
											$author$project$Components$Produits$Reference$Update$PageDeLaValeur,
											cle,
											perimetreId,
											A2($elm$core$Basics$max, 0, valeur.ku - valeur.Jm)))
									]),
								$author$project$I18n$Cles$produitsReferenceLiensPrecedent(i18n)) : $rtfeldman$elm_css$Html$Styled$text(''),
								(_Utils_cmp(fin, valeur.JE) < 0) ? A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										A3($author$project$Components$Produits$Reference$Update$PageDeLaValeur, cle, perimetreId, fin))
									]),
								$author$project$I18n$Cles$produitsReferenceLiensSuivant(i18n)) : $rtfeldman$elm_css$Html$Styled$text('')
							]))
					]));
		}
	});
var $author$project$Components$Produits$Reference$ArticlesView$section = F4(
	function (i18n, model, fiche, lien) {
		var valeur = A2(
			$elm$core$Maybe$andThen,
			function (lu) {
				return A2($elm$core$Dict$get, lu.Aq, model.ih);
			},
			$elm$core$List$head(lien.pg));
		var modifiable = (!lien.n4) && (!_Utils_eq(
			$author$project$Components$Produits$Reference$Model$lienDeModification(fiche),
			$elm$core$Maybe$Nothing));
		var indisponible = A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.gt;
				},
				$elm$core$Basics$eq(1)),
			lien.pg);
		var avecPerimetre = !$elm$core$List$isEmpty(lien.pg);
		return A2(
			$author$project$Components$Shared$Page$View$sectionAvecCompte,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id('lien-' + lien.dy)
				]),
			{
				fw: modifiable ? _List_fromArray(
					[
						A2(
						$author$project$Components$Produits$Reference$ArticlesView$pointille,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Produits$Reference$Update$ArticlesDemandes(lien.dy)),
								$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Common$ChoixDArticles$idDuChoix + ('-' + lien.dy))
							]),
						lien.FS ? $author$project$I18n$Cles$produitsReferenceLiensModifierTitre(i18n) : $author$project$I18n$Cles$produitsReferenceLiensModifierTitreUnSeul(i18n))
					]) : _List_Nil,
				vW: $elm$core$Maybe$Nothing,
				fZ: A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$perimetresUtiliseChampLien,
									i18n,
									{
										Eh: A2($author$project$Components$Produits$Vocabulaire$libelleDeLOptionPlusieurs, i18n, lien.FS)
									}))
							])),
					($elm$core$List$isEmpty(lien.tP) && $elm$core$List$isEmpty(lien.pg)) ? _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsReferenceLiensAucun(i18n))
								]))
						]) : _Utils_ap(
						A2(
							$elm$core$List$map,
							A2($author$project$Components$Produits$Reference$ArticlesView$perimetre, i18n, valeur),
							lien.pg),
						indisponible ? _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$produitsReferenceLiensChoisisSansPerimetre,
											i18n,
											{
												w: $elm$core$List$length(lien.tP)
											}))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$ul,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('articles-lies')
									]),
								A2(
									$elm$core$List$map,
									A3($author$project$Components$Produits$Reference$ArticlesView$article, i18n, modifiable, lien),
									$author$project$Components$Produits$Reference$ArticlesView$heritesPuisPropres(lien.tP)))
							]) : (avecPerimetre ? _Utils_ap(
							_List_fromArray(
								[
									A3($author$project$Components$Produits$Reference$ArticlesView$articlesChoisis, i18n, valeur, lien)
								]),
							function () {
								var _v0 = $elm$core$List$head(lien.pg);
								if (!_v0.$) {
									var lu = _v0.a;
									return _List_fromArray(
										[
											A4($author$project$Components$Produits$Reference$ArticlesView$valeurResolue, i18n, model, lien.dy, lu.Aq)
										]);
								} else {
									return _List_Nil;
								}
							}()) : _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('resume')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$produitsReferenceLiensResume,
											i18n,
											{
												w: $elm$core$String$fromInt(
													$elm$core$List$length(lien.tP))
											}))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$ul,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('articles-lies')
									]),
								A2(
									$elm$core$List$map,
									A3($author$project$Components$Produits$Reference$ArticlesView$article, i18n, modifiable, lien),
									$author$project$Components$Produits$Reference$ArticlesView$heritesPuisPropres(lien.tP)))
							])))),
				Ar: $elm$core$Maybe$Nothing,
				Dj: 'lien-vers-des-articles',
				h6: A2($author$project$Components$Produits$Reference$ArticlesView$libelleDe, fiche, lien)
			});
	});
var $author$project$Components$Produits$Reference$ArticlesView$sections = F3(
	function (i18n, model, fiche) {
		return A2(
			$elm$core$List$map,
			A3($author$project$Components$Produits$Reference$ArticlesView$section, i18n, model, fiche),
			fiche.BQ);
	});
var $author$project$Components$Produits$Reference$GroupesView$sections = F3(
	function (i18n, model, fiche) {
		return A2(
			$elm$core$List$map,
			A3($author$project$Components$Produits$Reference$GroupesView$section, i18n, model.hd, fiche),
			$author$project$Components$Produits$Reference$GroupesView$groupes(fiche));
	});
var $author$project$I18n$Cles$produitsReferenceTuilesCompletude = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.tuiles.completude', _List_Nil, 'complétude');
};
var $author$project$I18n$Cles$produitsReferenceTuilesEtat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.tuiles.etat', _List_Nil, 'état');
};
var $author$project$I18n$Cles$produitsReferenceTuilesFichiers = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.tuiles.fichiers',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? 'fichier' : 'fichiers');
	});
var $author$project$I18n$Cles$produitsReferenceTuilesIndisponible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.tuiles.indisponible', _List_Nil, 'Pas encore servi par le back');
};
var $author$project$I18n$Cles$produitsReferenceTuilesListesDePrix = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.tuiles.listes-de-prix',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? 'liste de prix' : 'listes de prix');
	});
var $author$project$I18n$Cles$produitsReferenceTuilesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.tuiles.titre', _List_Nil, 'Chiffres de la fiche');
};
var $author$project$I18n$Cles$produitsReferenceTuilesVariantes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.tuiles.variantes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? 'variante' : 'variantes');
	});
var $author$project$Components$Shared$Svg$svgCopy = A3($author$project$Components$Shared$Svg$icone, 'copy', 'M10 8h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2zM16 8V5.5A1.5 1.5 0 0 0 14.5 4h-9A1.5 1.5 0 0 0 4 5.5v9A1.5 1.5 0 0 0 5.5 16H8', _List_Nil);
var $author$project$Components$Shared$Svg$svgFolders = A3($author$project$Components$Shared$Svg$icone, 'folders', 'M3.5 7.5a2 2 0 0 1 2-2h4l2 2.2h7a2 2 0 0 1 2 2V17a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2zM8 13.5h8', _List_Nil);
var $author$project$Components$Shared$Svg$svgPriceTag = A3($author$project$Components$Shared$Svg$icone, 'price-tag', 'M4 4h7.2l8.8 8.8-7.2 7.2L4 11.2zM8.5 8.5h.01', _List_Nil);
var $author$project$Components$Produits$Reference$View$tuiles = F3(
	function (i18n, model, fiche) {
		var tuile = F5(
			function (icone, cible, valeur, libelle, titre) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('tuile'),
							$rtfeldman$elm_css$Html$Styled$Attributes$href('#' + cible),
							$rtfeldman$elm_css$Html$Styled$Attributes$title(titre)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('icone')
								]),
							_List_fromArray(
								[icone])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(valeur)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(libelle)
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('fleche')
								]),
							_List_fromArray(
								[$author$project$Components$Shared$Svg$svgChevronRight]))
						]));
			});
		var inconnue = F3(
			function (icone, cible, libelle) {
				return A5(
					tuile,
					icone,
					cible,
					'—',
					libelle,
					$author$project$I18n$Cles$produitsReferenceTuilesIndisponible(i18n));
			});
		var etat = A3($author$project$Components$Produits$Common$Etat$libelle, i18n, fiche.mj, fiche.gt);
		return A2(
			$rtfeldman$elm_css$Html$Styled$nav,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('tuiles'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					$author$project$I18n$Cles$produitsReferenceTuilesTitre(i18n))
				]),
			_List_fromArray(
				[
					A5(
					tuile,
					$author$project$Components$Shared$Svg$svgPriceTag,
					$author$project$Components$Produits$Reference$Model$idDeLActivite,
					etat,
					$author$project$I18n$Cles$produitsReferenceTuilesEtat(i18n),
					etat),
					function () {
					var _v0 = fiche.fU;
					if (!_v0.$) {
						var lue = _v0.a;
						return A5(
							tuile,
							$author$project$Components$Shared$Svg$svgCheck,
							$author$project$Components$Produits$Reference$Model$idDeLaCompletude,
							A2(
								$author$project$I18n$Cles$produitsReferenceFicheCompte,
								i18n,
								{
									HB: $elm$core$String$fromInt(lue.HB),
									JE: $elm$core$String$fromInt(lue.JE)
								}),
							$author$project$I18n$Cles$produitsReferenceTuilesCompletude(i18n),
							A2($author$project$Components$Produits$Reference$View$compte, i18n, lue));
					} else {
						return A3(
							inconnue,
							$author$project$Components$Shared$Svg$svgCheck,
							$author$project$Components$Produits$Reference$Model$idDeLaCompletude,
							$author$project$I18n$Cles$produitsReferenceTuilesCompletude(i18n));
					}
				}(),
					function () {
					var nombre = $elm$core$List$length(fiche.zB);
					return A5(
						tuile,
						$author$project$Components$Shared$Svg$svgFile,
						$author$project$Components$Produits$Reference$Model$idDesFichiers,
						$elm$core$String$fromInt(nombre),
						A2(
							$author$project$I18n$Cles$produitsReferenceTuilesFichiers,
							i18n,
							{w: nombre}),
						A2(
							$author$project$I18n$Cles$produitsReferenceTuilesFichiers,
							i18n,
							{w: nombre}));
				}(),
					function () {
					var nombre = $elm$core$List$length(fiche.Kw);
					return A5(
						tuile,
						$author$project$Components$Shared$Svg$svgCopy,
						$author$project$Components$Produits$Reference$Model$idDesVariantes,
						$elm$core$String$fromInt(nombre),
						A2(
							$author$project$I18n$Cles$produitsReferenceTuilesVariantes,
							i18n,
							{w: nombre}),
						A2(
							$author$project$I18n$Cles$produitsReferenceTuilesVariantes,
							i18n,
							{w: nombre}));
				}(),
					function () {
					var _v1 = model.py;
					if (!_v1.$) {
						var servis = _v1.a;
						var nombre = $elm$core$List$length(servis.ES);
						return A5(
							tuile,
							$author$project$Components$Shared$Svg$svgFolders,
							$author$project$Components$Produits$Reference$Model$idDesOffres,
							$elm$core$String$fromInt(nombre),
							A2(
								$author$project$I18n$Cles$produitsReferenceTuilesListesDePrix,
								i18n,
								{w: nombre}),
							A2(
								$author$project$I18n$Cles$produitsReferenceTuilesListesDePrix,
								i18n,
								{w: nombre}));
					} else {
						return A3(
							inconnue,
							$author$project$Components$Shared$Svg$svgFolders,
							$author$project$Components$Produits$Reference$Model$idDesOffres,
							A2(
								$author$project$I18n$Cles$produitsReferenceTuilesListesDePrix,
								i18n,
								{w: 0}));
					}
				}()
				]));
	});
var $author$project$Components$Produits$Reference$Update$DuplicationDemandee = {$: 13};
var $author$project$I18n$Cles$produitsReferenceVariantesAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.variantes.aucune', _List_Nil, 'Aucune variante.');
};
var $author$project$I18n$Cles$produitsReferenceVariantesMemeChemin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.variantes.meme-chemin', _List_Nil, 'Même chemin');
};
var $author$project$I18n$Cles$produitsReferenceVariantesMemeCheminReste = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.reference.variantes.meme-chemin-reste',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('et ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' autre')) : ('et ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' autres')));
	});
var $author$project$I18n$Cles$produitsReferenceVariantesOrigine = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.variantes.origine', _List_Nil, 'Variante de');
};
var $author$project$I18n$Cles$produitsReferenceVariantesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.reference.variantes.titre', _List_Nil, 'Variantes');
};
var $author$project$Components$Produits$Reference$View$variantes = F2(
	function (i18n, fiche) {
		var voisine = function (v) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$li,
				_List_Nil,
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('code'),
									$rtfeldman$elm_css$Html$Styled$Attributes$href(
									$author$project$Routes$Route$toString(
										$author$project$Routes$Route$FicheReference(v.Aq)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(v.vx)
								]))
						]),
					_Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (nom) {
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(nom.zX)
												]))
										]);
								},
								v.Dj)),
						_Utils_ap(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (nom) {
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('variante')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2(
															$author$project$I18n$Cles$produitsReferenceVariante,
															i18n,
															{sl: nom}))
													]))
											]);
									},
									v.sl)),
							_List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Tag$View$view,
									$author$project$Components$Produits$Common$Etat$couleur(v.gt),
									A3($author$project$Components$Produits$Common$Etat$libelle, i18n, fiche.mj, v.gt))
								])))));
		};
		var reste = fiche.Co - $elm$core$List$length(fiche.Cn);
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Reference$Model$idDesVariantes),
					$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1)
				]),
			{
				fw: A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$String$fromInt(
									$elm$core$List$length(fiche.Kw)))
							])),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (_v0) {
								return _List_fromArray(
									[
										A4(
										$author$project$Components$Shared$Bouton$View$boutonAvecIcone,
										2,
										$author$project$Components$Shared$Svg$svgCopy,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$Reference$Model$idDeLaDuplication),
												$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$Reference$Update$DuplicationDemandee)
											]),
										$author$project$I18n$Cles$produitsReferenceDupliquer(i18n))
									]);
							},
							$author$project$Components$Produits$Reference$Model$lienDeDuplication(fiche)))),
				fZ: _List_fromArray(
					[
						function () {
						var _v1 = fiche.o4;
						if (!_v1.$) {
							var origine = _v1.a;
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('origine')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('etiquette')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$produitsReferenceVariantesOrigine(i18n))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$ul,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('voisines')
											]),
										_List_fromArray(
											[
												voisine(origine)
											]))
									]));
						} else {
							return $rtfeldman$elm_css$Html$Styled$text('');
						}
					}(),
						$elm$core$List$isEmpty(fiche.Kw) ? A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsReferenceVariantesAucune(i18n))
							])) : A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('voisines')
							]),
						A2($elm$core$List$map, voisine, fiche.Kw)),
						$elm$core$List$isEmpty(fiche.Cn) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('meme-chemin')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('etiquette')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsReferenceVariantesMemeChemin(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$ul,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('voisines')
									]),
								A2($elm$core$List$map, voisine, fiche.Cn)),
								(reste > 0) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('reste')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$produitsReferenceVariantesMemeCheminReste,
											i18n,
											{w: reste}))
									])) : $rtfeldman$elm_css$Html$Styled$text('')
							]))
					]),
				Dj: 'variantes',
				h6: $author$project$I18n$Cles$produitsReferenceVariantesTitre(i18n)
			});
	});
var $author$project$Components$Produits$Reference$View$page = F4(
	function (i18n, messages, model, fiche) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			$author$project$Components$Produits$Reference$View$nomDeLaPage,
			{
				ut: A2(
					$elm$core$List$cons,
					A3($author$project$Components$Produits$Reference$View$tuiles, i18n, model, fiche),
					$author$project$Components$Shared$Page$View$fiche(
						{
							tQ: _List_fromArray(
								[
									A2($author$project$Components$Produits$Reference$View$activite, i18n, fiche),
									A2($author$project$Components$Produits$Reference$View$completude, i18n, fiche)
								]),
							B2: _Utils_ap(
								_List_fromArray(
									[
										A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('envoi'),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$Components$Produits$Common$Envoi$enCours(model.l2) ? $author$project$I18n$Cles$produitsStructureEnvoiEnCours(i18n) : '')
											])),
										A3($author$project$Components$Produits$Reference$View$ficheDInformation, i18n, model, fiche)
									]),
								_Utils_ap(
									A3($author$project$Components$Produits$Reference$ArticlesView$sections, i18n, model, fiche),
									_Utils_ap(
										A2($author$project$Components$Produits$Reference$View$enBlocs, i18n, fiche) ? _List_Nil : A3($author$project$Components$Produits$Reference$GroupesView$sections, i18n, model, fiche),
										_List_fromArray(
											[
												A3($author$project$Components$Produits$Reference$FichiersView$section, i18n, model, fiche),
												A2($author$project$Components$Produits$Reference$View$variantes, i18n, fiche),
												A2($author$project$Components$Produits$Reference$View$prix, i18n, model.py)
											]))))
						})),
				xy: _List_fromArray(
					[
						A3($author$project$Components$Produits$Reference$View$drawer, i18n, model, fiche),
						A3($author$project$Components$Produits$Reference$View$arret, i18n, model, fiche),
						A3($author$project$Components$Produits$Reference$FichiersView$retrait, i18n, model, fiche)
					]),
				zM: A2($author$project$Components$Produits$Reference$View$actions, i18n, fiche),
				AK: $author$project$Components$Produits$Reference$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _Utils_ap(
							A2($author$project$Components$Produits$Reference$ImageView$bandeau, i18n, model),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('etat')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Components$Shared$Tag$View$view,
											$author$project$Components$Produits$Common$Etat$couleur(fiche.gt),
											A3($author$project$Components$Produits$Common$Etat$libelle, i18n, fiche.mj, fiche.gt))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('produit-de-la-reference')
										]),
									A2($author$project$Components$Produits$Reference$View$produitDeLaReference, i18n, fiche)),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('resume')
										]),
									A2($author$project$Components$Produits$Reference$View$resume, i18n, fiche)),
									A2($author$project$Components$Produits$Reference$View$chemin, i18n, fiche.jK),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
										]),
									A2($author$project$Components$Produits$Reference$View$actionsDEnTete, i18n, fiche))
								])),
						zE: _Utils_ap(
							_List_fromArray(
								[
									{
									aa: $author$project$Routes$Route$adresseCatalogue,
									Dj: $author$project$I18n$Cles$produitsTitre(i18n)
								},
									{
									aa: $author$project$Routes$Route$adresseCatalogue,
									Dj: $author$project$I18n$Cles$produitsReferencesTitre(i18n)
								}
								]),
							A2(
								$elm$core$List$map,
								function (etape) {
									return {
										aa: _Utils_eq(
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.Aq;
												},
												fiche.Gp),
											$elm$core$Maybe$Just(etape.lQ)) ? $author$project$Routes$Route$adresseCatalogue : $author$project$Routes$Route$toString(
											$author$project$Routes$Route$FicheElement(etape.lQ)),
										Dj: etape.R.zX
									};
								},
								fiche.zD)),
						Ef: _List_fromArray(
							[
								A3($author$project$Components$Produits$Reference$View$onglets, i18n, model, fiche)
							]),
						h6: function () {
							var _v0 = _Utils_Tuple2(fiche.Gp, fiche.Dj);
							if (!_v0.a.$) {
								var produit = _v0.a.a;
								return A2(
									$author$project$I18n$Cles$produitsReferenceTitre,
									i18n,
									{vx: fiche.vx, Dj: produit.R.zX});
							} else {
								if (!_v0.b.$) {
									var _v1 = _v0.a;
									var nom = _v0.b.a;
									return A2(
										$author$project$I18n$Cles$produitsReferenceTitre,
										i18n,
										{vx: fiche.vx, Dj: nom.zX});
								} else {
									var _v2 = _v0.a;
									var _v3 = _v0.b;
									return fiche.vx;
								}
							}
						}()
					})
			});
	});
var $author$project$Components$Produits$Reference$View$view = F3(
	function (i18n, messages, model) {
		var _v0 = _Utils_Tuple2(model.nf, model.zo);
		if (_v0.a) {
			return A2(
				$author$project$Components$Shared$Introuvable$View$view,
				i18n,
				{
					aa: $author$project$Routes$Route$adresseCatalogue,
					Bl: $author$project$I18n$Cles$produitsReferencesRetour(i18n)
				});
		} else {
			if (!_v0.b.$) {
				var fiche = _v0.b.a;
				return A4($author$project$Components$Produits$Reference$View$page, i18n, messages, model, fiche);
			} else {
				var _v1 = _v0.b;
				return A2(
					$author$project$Components$Shared$Page$View$page,
					$author$project$Components$Produits$Reference$View$nomDeLaPage,
					{
						ut: _List_fromArray(
							[
								A2($author$project$Components$Shared$Messages$View$view, i18n, messages)
							]),
						xy: _List_Nil,
						zM: _List_Nil,
						AK: false,
						JD: _List_Nil
					});
			}
		}
	});
var $author$project$Components$Produits$SchemaDeNiveau$View$nomDeLaPage = 'produits-niveau-schema-detail';
var $author$project$Components$Produits$SchemaDeNiveau$Update$AjoutOuvert = {$: 6};
var $author$project$Components$Produits$SchemaDeNiveau$Update$DuTableau = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Produits$SchemaDeNiveau$Model$idDeLaSection = 'champs';
var $author$project$Components$Produits$SchemaDeNiveau$Model$lignes = function (schema) {
	return A2(
		$elm$core$List$map,
		function (lu) {
			return {
				s$: !_Utils_eq(
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$afficherUnChampDUnNiveau, lu.nQ),
					$elm$core$Maybe$Nothing),
				uN: lu.uN,
				B8: !_Utils_eq(
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$masquerUnChampDUnNiveau, lu.nQ),
					$elm$core$Maybe$Nothing),
				n4: lu.n4,
				o4: $elm$core$Maybe$Nothing,
				Hk: false,
				JR: lu.JR
			};
		},
		schema.dw);
};
var $author$project$I18n$Cles$produitsSchemaDeNiveauAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.schema-de-niveau.aucun', _List_Nil, 'Aucune information');
};
var $author$project$I18n$Cles$produitsSchemaDeNiveauTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.schema-de-niveau.titre', _List_Nil, 'Informations');
};
var $author$project$Components$Produits$SchemaDeNiveau$View$champs = F3(
	function (i18n, model, schema) {
		var modifiable = !_Utils_eq(
			$author$project$Components$Produits$SchemaDeNiveau$Model$evolution(schema),
			$elm$core$Maybe$Nothing);
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$SchemaDeNiveau$Model$idDeLaSection),
					$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1)
				]),
			{
				fw: modifiable ? _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$SchemaDeNiveau$Model$idDeLAjout),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$SchemaDeNiveau$Update$AjoutOuvert)
							]),
						$author$project$I18n$Cles$editeurDeSchemaAjouterTitre(i18n))
					]) : _List_Nil,
				fZ: _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$EditeurDeSchema$View$liste,
						i18n,
						{
							yj: $author$project$Components$Produits$Common$Envoi$enCours(model.l2),
							m_: model.m_,
							g_: modifiable,
							bP: !_Utils_eq(
								A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ordonnerLesChampsDUnNiveau, schema.nQ),
								$elm$core$Maybe$Nothing),
							h1: $author$project$Components$Produits$SchemaDeNiveau$Update$DuTableau,
							sb: schema.x5.sb
						},
						$author$project$Components$Produits$SchemaDeNiveau$Model$lignes(schema)),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('annonce'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-live', 'polite')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$I18n$Cles$texte, i18n, model.iP))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$List$isEmpty(schema.dw) ? $author$project$I18n$Cles$produitsSchemaDeNiveauAucun(i18n) : '')
							]))
					]),
				Dj: 'champs',
				h6: $author$project$I18n$Cles$produitsSchemaDeNiveauTitre(i18n)
			});
	});
var $author$project$Components$Produits$SchemaDeNiveau$Update$DeLEditeur = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Produits$SchemaDeNiveau$Update$DrawerValide = {$: 9};
var $author$project$Components$Produits$SchemaDeNiveau$Model$autresChamps = F2(
	function (saisie, schema) {
		return A2(
			$elm$core$List$filter,
			function (autre) {
				return !_Utils_eq(
					$elm$core$Maybe$Just(autre.dy),
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.dy;
						},
						saisie.lZ));
			},
			A2(
				$elm$core$List$map,
				function (lu) {
					return {dy: lu.uN.dy, Bl: lu.uN.Bl};
				},
				schema.dw));
	});
var $author$project$Components$Produits$SchemaDeNiveau$Model$propositions = F2(
	function (saisie, schema) {
		var editeur = schema.x5;
		var dejaPortee = _Utils_eq(saisie.cx.mo, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceALaPublication);
		return _Utils_update(
			editeur,
			{
				y$: _Utils_ap(
					A2(
						$elm$core$List$filter,
						function (exigence) {
							return !_Utils_eq(exigence, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceALaPublication);
						},
						editeur.y$),
					dejaPortee ? _List_fromArray(
						[$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceALaPublication]) : _List_Nil)
			});
	});
var $author$project$Components$Produits$SchemaDeNiveau$Model$ressource = function (i18n) {
	return {
		uj: function (_v0) {
			return $elm$core$Maybe$Nothing;
		},
		mo: $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$choixDExigence(i18n),
		Ej: _List_Nil
	};
};
var $author$project$Components$Produits$SchemaDeNiveau$View$drawer = F3(
	function (i18n, model, schema) {
		var ouvert = $author$project$Components$Shared$Drawer$Model$estOuvert(model.kX) && (!_Utils_eq(
			$author$project$Components$Produits$SchemaDeNiveau$Model$evolution(schema),
			$elm$core$Maybe$Nothing));
		var enregistre = !_Utils_eq(model.hP.lZ, $elm$core$Maybe$Nothing);
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Produits$SchemaDeNiveau$Update$DuDrawer,
			ouvert ? {
				fs: {
					sR: !$author$project$Components$Produits$Common$Envoi$enCours(model.l2),
					Bl: enregistre ? $author$project$I18n$Cles$editeurDeSchemaModifierValider(i18n) : $author$project$I18n$Cles$editeurDeSchemaAjouterValider(i18n),
					C$: $author$project$Components$Produits$SchemaDeNiveau$Update$DrawerValide
				},
				fZ: A2(
					$elm$core$List$map,
					$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Produits$SchemaDeNiveau$Update$DeLEditeur),
					A3(
						$author$project$Components$Shared$EditeurDeSchema$View$formulaire,
						i18n,
						{
							t8: A2($author$project$Components$Produits$SchemaDeNiveau$Model$autresChamps, model.hP, schema),
							n_: _List_Nil,
							pv: $author$project$Components$Shared$Drawer$Model$idRacine(model.kX),
							Gw: A2($author$project$Components$Produits$SchemaDeNiveau$Model$propositions, model.hP, schema),
							HN: $author$project$Components$Produits$SchemaDeNiveau$Model$ressource(i18n),
							ib: _List_Nil
						},
						model.hP)),
				A6: $elm$core$Maybe$Nothing,
				Bc: true,
				h6: enregistre ? $author$project$I18n$Cles$editeurDeSchemaModifierTitre(i18n) : $author$project$I18n$Cles$editeurDeSchemaAjouterTitre(i18n)
			} : {
				fs: {sR: false, Bl: '', C$: $author$project$Components$Produits$SchemaDeNiveau$Update$DrawerValide},
				fZ: _List_Nil,
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: ''
			},
			model.kX);
	});
var $author$project$Components$Produits$SchemaDeNiveau$Model$nom = F2(
	function (i18n, niveau) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2(
				$author$project$I18n$Cles$texte,
				i18n,
				$author$project$Catalogue$Vocabulaire$archetype(niveau.fA)),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.zX;
				},
				niveau.R));
	});
var $author$project$I18n$Cles$produitsStructureTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.structure.titre', _List_Nil, 'Catalogue');
};
var $author$project$Components$Produits$SchemaDeNiveau$View$page = F5(
	function (i18n, messages, model, niveau, schema) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			$author$project$Components$Produits$SchemaDeNiveau$View$nomDeLaPage,
			{
				ut: _List_fromArray(
					[
						A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('envoi'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Components$Produits$Common$Envoi$enCours(model.l2) ? $author$project$I18n$Cles$produitsStructureEnvoiEnCours(i18n) : '')
							])),
						A3($author$project$Components$Produits$SchemaDeNiveau$View$champs, i18n, model, schema)
					]),
				xy: _List_fromArray(
					[
						A3($author$project$Components$Produits$SchemaDeNiveau$View$drawer, i18n, model, schema)
					]),
				zM: _List_Nil,
				AK: $author$project$Components$Produits$SchemaDeNiveau$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Tag$View$view,
								3,
								A2(
									$author$project$I18n$Cles$produitsTypesVersion,
									i18n,
									{
										sq: $elm$core$String$fromInt(schema.sq)
									}))
							]),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adresseParametrageCatalogue,
								Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
							},
								{
								aa: $author$project$Routes$Route$adresseParametrageCatalogue,
								Dj: $author$project$I18n$Cles$produitsStructureTitre(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: A2($author$project$Components$Produits$SchemaDeNiveau$Model$nom, i18n, niveau)
					})
			});
	});
var $author$project$I18n$Cles$produitsSchemaDeNiveauRetour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.schema-de-niveau.retour', _List_Nil, 'Retour à « Catalogue »');
};
var $author$project$Components$Produits$SchemaDeNiveau$View$view = F3(
	function (i18n, messages, model) {
		var _v0 = _Utils_Tuple3(model.nf, model.os, model.aN);
		if (_v0.a) {
			return A2(
				$author$project$Components$Shared$Introuvable$View$view,
				i18n,
				{
					aa: $author$project$Routes$Route$adresseParametrageCatalogue,
					Bl: $author$project$I18n$Cles$produitsSchemaDeNiveauRetour(i18n)
				});
		} else {
			if ((!_v0.b.$) && (!_v0.c.$)) {
				var niveau = _v0.b.a;
				var schema = _v0.c.a;
				return A5($author$project$Components$Produits$SchemaDeNiveau$View$page, i18n, messages, model, niveau, schema);
			} else {
				return A2(
					$author$project$Components$Shared$Page$View$page,
					$author$project$Components$Produits$SchemaDeNiveau$View$nomDeLaPage,
					{
						ut: _List_fromArray(
							[
								A2($author$project$Components$Shared$Messages$View$view, i18n, messages)
							]),
						xy: _List_Nil,
						zM: _List_Nil,
						AK: false,
						JD: _List_Nil
					});
			}
		}
	});
var $author$project$Components$Produits$TypesDeQuantite$Update$GesteOuvert = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Produits$TypesDeQuantite$Model$Ordonnance = {$: 3};
var $author$project$Components$Produits$TypesDeQuantite$Update$Restauration = function (a) {
	return {$: 17, a: a};
};
var $author$project$I18n$Cles$typesDeQuantiteArchiveLigne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'types.de.quantite.archive.ligne',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'comportement',
					$author$project$I18n$Traductions$Chaine(p.vV))
				]),
			p.Dj + (' · ' + (p.vV + ' · archivé')));
	});
var $author$project$I18n$Cles$typesDeQuantiteRestaurerLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'types.de.quantite.restaurer.le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.Dj + ', archivé, restaurer');
	});
var $author$project$Components$Produits$TypesDeQuantite$View$archive = F3(
	function (i18n, model, leType) {
		var libelle = A2(
			$author$project$I18n$Cles$typesDeQuantiteArchiveLigne,
			i18n,
			{
				vV: A2($author$project$Components$Produits$Vocabulaire$libelleDuComportement, i18n, leType.vV),
				Dj: leType.Dj
			});
		return $author$project$Components$Produits$TypesDeQuantite$Model$modifiable(leType) ? A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('archive'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					A2(
						$author$project$I18n$Cles$typesDeQuantiteRestaurerLe,
						i18n,
						{Dj: leType.Dj})),
					$rtfeldman$elm_css$Html$Styled$Attributes$title(
					A2(
						$author$project$I18n$Cles$typesDeQuantiteRestaurerLe,
						i18n,
						{Dj: leType.Dj})),
					$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
					$author$project$API$Envoi$enCours(model.l2)),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Components$Produits$TypesDeQuantite$Update$Restauration(leType.r8))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(libelle)
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('archive'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('inerte')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(libelle)
				]));
	});
var $author$project$I18n$Cles$typesDeQuantiteBaseCommandeConsolidee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.base.commande.consolidee', _List_Nil, 'Commande consolidée');
};
var $author$project$I18n$Cles$typesDeQuantiteBaseParCommande = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.base.par.commande', _List_Nil, 'Par commande');
};
var $author$project$I18n$Cles$typesDeQuantiteBaseParPeriode = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.base.par.periode', _List_Nil, 'Par période');
};
var $author$project$Components$Produits$Vocabulaire$libelleDeLaBaseDeType = F2(
	function (i18n, base) {
		switch (base) {
			case 'par-periode':
				return $author$project$I18n$Cles$typesDeQuantiteBaseParPeriode(i18n);
			case 'commande-consolidee':
				return $author$project$I18n$Cles$typesDeQuantiteBaseCommandeConsolidee(i18n);
			default:
				return $author$project$I18n$Cles$typesDeQuantiteBaseParCommande(i18n);
		}
	});
var $author$project$I18n$Cles$typesDeQuantiteLangues = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'types.de.quantite.langues',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' langue') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' langues'));
	});
var $author$project$I18n$Cles$typesDeQuantiteModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.modifier', _List_Nil, 'Modifier…');
};
var $author$project$I18n$Cles$typesDeQuantiteModifierLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'types.de.quantite.modifier.le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Modifier le type ' + p.Dj);
	});
var $author$project$I18n$Cles$typesDeQuantiteSansValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.sans.valeur', _List_Nil, '—');
};
var $author$project$I18n$Cles$typesDeQuantiteSeparateur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.separateur', _List_Nil, ' · ');
};
var $author$project$I18n$Cles$typesDeQuantiteUtilisePar = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'types.de.quantite.utilise.par',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' règle') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' règles'));
	});
var $author$project$Components$Produits$TypesDeQuantite$View$ligne = F2(
	function (i18n, leType) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('type')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('title')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(leType.Dj)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('langues')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$typesDeQuantiteLangues,
										i18n,
										{
											w: $elm$core$List$length(leType.DG)
										}))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('comportement')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							5,
							A2($author$project$Components$Produits$Vocabulaire$libelleDuComportement, i18n, leType.vV))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$elm$core$String$join,
								$author$project$I18n$Cles$typesDeQuantiteSeparateur(i18n),
								A2(
									$elm$core$List$map,
									$author$project$Components$Produits$Vocabulaire$libelleDeLaBaseDeType(i18n),
									leType.uo)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$I18n$Cles$typesDeQuantiteSansValeur(i18n),
								A2(
									$elm$core$Maybe$map,
									$author$project$Components$Produits$Vocabulaire$libelleDeLaPeriode(i18n),
									leType.Fb)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nombre')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$typesDeQuantiteUtilisePar,
								i18n,
								{w: leType.sf}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					$author$project$Components$Produits$TypesDeQuantite$Model$modifiable(leType) ? _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id(
									$author$project$Components$Produits$TypesDeQuantite$Model$idDuDeclencheur(
										$author$project$Components$Produits$TypesDeQuantite$Model$Modification(leType.r8))),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									A2(
										$author$project$I18n$Cles$typesDeQuantiteModifierLe,
										i18n,
										{Dj: leType.Dj})),
									$rtfeldman$elm_css$Html$Styled$Attributes$title(
									A2(
										$author$project$I18n$Cles$typesDeQuantiteModifierLe,
										i18n,
										{Dj: leType.Dj})),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Produits$TypesDeQuantite$Update$GesteOuvert(
										$author$project$Components$Produits$TypesDeQuantite$Model$Modification(leType.r8)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$typesDeQuantiteModifier(i18n))
								]))
						]) : _List_Nil)
				]));
	});
var $author$project$I18n$Cles$typesDeQuantiteArchives = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.archives', _List_Nil, 'Archivés');
};
var $author$project$I18n$Cles$typesDeQuantiteColonneBases = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.colonne.bases', _List_Nil, 'Bases permises');
};
var $author$project$I18n$Cles$typesDeQuantiteColonneComportement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.colonne.comportement', _List_Nil, 'Comportement');
};
var $author$project$I18n$Cles$typesDeQuantiteColonnePeriode = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.colonne.periode', _List_Nil, 'Période par défaut');
};
var $author$project$I18n$Cles$typesDeQuantiteColonneType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.colonne.type', _List_Nil, 'Type');
};
var $author$project$I18n$Cles$typesDeQuantiteColonneUtilisePar = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.colonne.utilise.par', _List_Nil, 'Utilisé par');
};
var $author$project$I18n$Cles$typesDeQuantiteOrdonner = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.ordonner', _List_Nil, 'Ordonner…');
};
var $author$project$I18n$Cles$typesDeQuantiteSectionTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.section.titre', _List_Nil, 'Types de règles de quantité');
};
var $author$project$Components$Produits$TypesDeQuantite$View$annuaire = F4(
	function (i18n, model, actifs, archives) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('types')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
						]),
					_Utils_ap(
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$h3,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$typesDeQuantiteSectionTitre(i18n)),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$elm$core$String$fromInt(
													$elm$core$List$length(actifs)))
											]))
									]))
							]),
						_Utils_eq(
							A2($author$project$Components$Produits$TypesDeQuantite$Model$lienDe, $author$project$API$NavLinksDictionary$ordonnerLesTypesDeQuantite, model),
							$elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id(
										$author$project$Components$Produits$TypesDeQuantite$Model$idDuDeclencheur($author$project$Components$Produits$TypesDeQuantite$Model$Ordonnance)),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Produits$TypesDeQuantite$Update$GesteOuvert($author$project$Components$Produits$TypesDeQuantite$Model$Ordonnance))
									]),
								$author$project$I18n$Cles$typesDeQuantiteOrdonner(i18n))
							]))),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$table,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$thead,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$tr,
													_List_Nil,
													_Utils_ap(
														A2(
															$elm$core$List$map,
															function (cle) {
																return A2(
																	$rtfeldman$elm_css$Html$Styled$th,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
																		]),
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text(cle)
																		]));
															},
															_List_fromArray(
																[
																	$author$project$I18n$Cles$typesDeQuantiteColonneType(i18n),
																	$author$project$I18n$Cles$typesDeQuantiteColonneComportement(i18n),
																	$author$project$I18n$Cles$typesDeQuantiteColonneBases(i18n),
																	$author$project$I18n$Cles$typesDeQuantiteColonnePeriode(i18n),
																	$author$project$I18n$Cles$typesDeQuantiteColonneUtilisePar(i18n)
																])),
														_List_fromArray(
															[
																A2(
																$rtfeldman$elm_css$Html$Styled$th,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$scope('col'),
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
																	]),
																_List_Nil)
															])))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$tbody,
											_List_Nil,
											A2(
												$elm$core$List$map,
												$author$project$Components$Produits$TypesDeQuantite$View$ligne(i18n),
												actifs))
										]))
								])),
							$elm$core$List$isEmpty(archives) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('archives')
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$typesDeQuantiteArchives(i18n))
										])),
								A2(
									$elm$core$List$map,
									A2($author$project$Components$Produits$TypesDeQuantite$View$archive, i18n, model),
									archives)))
						]))
				]));
	});
var $author$project$Components$Produits$TypesDeQuantite$Model$Archivage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$TypesDeQuantite$Update$GesteDemande = {$: 18};
var $author$project$Components$Produits$TypesDeQuantite$Update$RetourALaModification = {$: 6};
var $author$project$I18n$Cles$typesDeQuantiteArchivageAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.archivage.aide', _List_Nil, 'Un type archivé reste visible en pointillé dans l\'annuaire. Un clic le restaure.');
};
var $author$project$I18n$Cles$typesDeQuantiteArchivageAvertissementTexte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'types.de.quantite.archivage.avertissement.texte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Elles continuent de s\'appliquer et gardent le nom « ' + (p.Dj + ' » avec l\'étiquette « archivé ». Seul le choix du type pour une nouvelle règle disparaît.'));
	});
var $author$project$I18n$Cles$typesDeQuantiteArchivageAvertissementTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.archivage.avertissement.titre', _List_Nil, 'Les règles existantes sont conservées.');
};
var $author$project$I18n$Cles$typesDeQuantiteArchivagePerimetresRegles = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'types.de.quantite.archivage.perimetres.regles',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' règle') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' règles'));
	});
var $author$project$I18n$Cles$typesDeQuantiteArchivagePerimetresTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.archivage.perimetres.titre', _List_Nil, 'Périmètres concernés');
};
var $author$project$Components$Produits$TypesDeQuantite$View$archivage = F2(
	function (i18n, leType) {
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Note$View$view,
				1,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$typesDeQuantiteArchivageAvertissementTitre(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$typesDeQuantiteArchivageAvertissementTexte,
									i18n,
									{Dj: leType.Dj}))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('perimetres-concernes')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$typesDeQuantiteArchivagePerimetresTitre(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (usage) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$href(
													$author$project$Routes$Route$adresseDuPerimetre(usage.Fa))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(usage.Dj)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('regles')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$author$project$I18n$Cles$typesDeQuantiteArchivagePerimetresRegles,
														i18n,
														{w: usage.hJ}))
												]))
										]));
							},
							leType.Ke))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$typesDeQuantiteArchivageAide(i18n))
					]))
			]);
	});
var $author$project$Components$Produits$TypesDeQuantite$Update$ComportementChoisi = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Produits$TypesDeQuantite$Update$NomSaisi = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Produits$TypesDeQuantite$Update$BaseBasculee = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$I18n$Cles$typesDeQuantiteBaseCommandeConsolideeAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.base.commande.consolidee.aide', _List_Nil, 'Cumul des commandes regroupées dans un dossier consolidé, tous clients confondus.');
};
var $author$project$I18n$Cles$typesDeQuantiteBaseParCommandeAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.base.par.commande.aide', _List_Nil, 'Chaque commande du client, prise seule.');
};
var $author$project$I18n$Cles$typesDeQuantiteBaseParPeriodeAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.base.par.periode.aide', _List_Nil, 'Cumul des commandes du client sur une période civile (mois, trimestre, année).');
};
var $author$project$Components$Produits$Vocabulaire$aideDeLaBase = F2(
	function (i18n, base) {
		switch (base) {
			case 'par-periode':
				return $author$project$I18n$Cles$typesDeQuantiteBaseParPeriodeAide(i18n);
			case 'commande-consolidee':
				return $author$project$I18n$Cles$typesDeQuantiteBaseCommandeConsolideeAide(i18n);
			default:
				return $author$project$I18n$Cles$typesDeQuantiteBaseParCommandeAide(i18n);
		}
	});
var $author$project$I18n$Cles$typesDeQuantiteBasesLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.bases.libelle', _List_Nil, 'Bases permises');
};
var $author$project$I18n$Cles$typesDeQuantiteMultipleNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.multiple.note', _List_Nil, '« Multiple de » ne s\'entend que par commande : les autres bases ne sont pas proposées.');
};
var $author$project$Components$Produits$TypesDeQuantite$View$bases = F3(
	function (i18n, avecAide, model) {
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$typesDeQuantiteBasesLibelle(i18n))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('pick')
					]),
				A2(
					$elm$core$List$map,
					function (code) {
						var permise = !_Utils_eq(
							A2(
								$author$project$Components$Produits$TypesDeQuantite$Model$basesDuComportement,
								model.vV,
								_List_fromArray(
									[code])),
							_List_Nil);
						return A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('pick-ligne'),
									$rtfeldman$elm_css$Html$Styled$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('indisponible', !permise)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$input,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
											$rtfeldman$elm_css$Html$Styled$Attributes$checked(
											A2($elm$core$List$member, code, model.uo)),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!permise),
											$rtfeldman$elm_css$Html$Styled$Events$onCheck(
											$author$project$Components$Produits$TypesDeQuantite$Update$BaseBasculee(code))
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('base')
										]),
									A2(
										$elm$core$List$cons,
										A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('nom-de-base')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2($author$project$Components$Produits$Vocabulaire$libelleDeLaBaseDeType, i18n, code))
												])),
										avecAide ? _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2($author$project$Components$Produits$Vocabulaire$aideDeLaBase, i18n, code))
													]))
											]) : _List_Nil))
								]));
					},
					_List_fromArray(
						['par-commande', 'par-periode', 'commande-consolidee']))),
				(model.vV === 'multiple') ? A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$typesDeQuantiteMultipleNote(i18n))
					])) : $rtfeldman$elm_css$Html$Styled$text('')
			]);
	});
var $author$project$Components$Produits$TypesDeQuantite$View$nomDejaPris = function (model) {
	var _v0 = model.pZ;
	if ((!_v0.$) && (!_v0.a.$)) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Produits$TypesDeQuantite$Update$PeriodeChoisie = function (a) {
	return {$: 10, a: a};
};
var $author$project$I18n$Cles$typesDeQuantitePeriodeAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.periode.aide', _List_Nil, 'Période civile. Préremplie dans le drawer de quantité, modifiable à chaque règle.');
};
var $author$project$I18n$Cles$typesDeQuantitePeriodeAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.periode.aucune', _List_Nil, 'Aucune');
};
var $author$project$I18n$Cles$typesDeQuantitePeriodeLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.periode.libelle', _List_Nil, 'Période par défaut (facultative)');
};
var $author$project$Components$Produits$TypesDeQuantite$View$periode = F2(
	function (i18n, model) {
		return A2($elm$core$List$member, 'par-periode', model.uo) ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$typesDeQuantitePeriodeLibelle(i18n))
					])),
				$author$project$Components$Shared$Segment$View$view(
				{
					vd: A2($elm$core$Maybe$withDefault, '', model.pi),
					Bi: $author$project$I18n$Cles$typesDeQuantitePeriodeLibelle(i18n),
					Dj: 'periode',
					Ea: $author$project$Components$Produits$TypesDeQuantite$Update$PeriodeChoisie,
					o_: A2(
						$elm$core$List$cons,
						{
							vx: '',
							Bl: $author$project$I18n$Cles$typesDeQuantitePeriodeAucune(i18n)
						},
						A2(
							$elm$core$List$map,
							function (code) {
								return {
									vx: code,
									Bl: A2($author$project$Components$Produits$Vocabulaire$libelleDeLaPeriode, i18n, code)
								};
							},
							_List_fromArray(
								['mois', 'trimestre', 'annee'])))
				}),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$typesDeQuantitePeriodeAide(i18n))
					]))
			]) : _List_Nil;
	});
var $author$project$I18n$Cles$typesDeQuantiteComportementAideCreation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.comportement.aide.creation', _List_Nil, 'Fixe après la création : le CRM sait appliquer un minimum, un maximum ou un multiple.');
};
var $author$project$I18n$Cles$typesDeQuantiteComportementLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.comportement.libelle', _List_Nil, 'Comportement');
};
var $author$project$I18n$Cles$typesDeQuantiteCreationNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.creation.nom', _List_Nil, 'Nom du type');
};
var $author$project$I18n$Cles$typesDeQuantiteCreationNomAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.creation.nom.aide', _List_Nil, 'Dans la langue de référence (français). Les traductions viennent après la création.');
};
var $author$project$I18n$Cles$typesDeQuantiteRefusNomDejaPrisChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.refus.nom.deja.pris.champ', _List_Nil, 'Ce nom est déjà pris.');
};
var $author$project$Components$Produits$TypesDeQuantite$View$creation = F3(
	function (i18n, prefixe, model) {
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Champ$View$texte,
					{
						go: $author$project$Components$Produits$TypesDeQuantite$View$nomDejaPris(model) ? $elm$core$Maybe$Just(
							$author$project$I18n$Cles$typesDeQuantiteRefusNomDejaPrisChamp(i18n)) : $elm$core$Maybe$Nothing,
						Aq: prefixe + '-nom',
						Bl: $author$project$I18n$Cles$typesDeQuantiteCreationNom(i18n),
						he: true
					},
					{
						hg: $author$project$Components$Produits$TypesDeQuantite$Update$NomSaisi('fr'),
						fm: A2($author$project$Components$Shared$LibellesParLangue$Model$lire, 'fr', model.R)
					}),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$typesDeQuantiteCreationNomAide(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$typesDeQuantiteComportementLibelle(i18n))
						])),
					$author$project$Components$Shared$Segment$View$view(
					{
						vd: model.vV,
						Bi: $author$project$I18n$Cles$typesDeQuantiteComportementLibelle(i18n),
						Dj: 'comportement',
						Ea: $author$project$Components$Produits$TypesDeQuantite$Update$ComportementChoisi,
						o_: A2(
							$elm$core$List$map,
							function (code) {
								return {
									vx: code,
									Bl: A2($author$project$Components$Produits$Vocabulaire$libelleDuComportement, i18n, code)
								};
							},
							_List_fromArray(
								['minimum', 'maximum', 'multiple']))
					}),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$typesDeQuantiteComportementAideCreation(i18n))
						]))
				]),
			_Utils_ap(
				A3($author$project$Components$Produits$TypesDeQuantite$View$bases, i18n, true, model),
				A2($author$project$Components$Produits$TypesDeQuantite$View$periode, i18n, model)));
	});
var $author$project$Components$Produits$TypesDeQuantite$Model$langueDeReference = 'fr';
var $author$project$I18n$Cles$typesDeQuantiteNomsLangueDe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.noms.langue-de', _List_Nil, 'Deutsch');
};
var $author$project$I18n$Cles$typesDeQuantiteNomsLangueEn = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.noms.langue-en', _List_Nil, 'English');
};
var $author$project$I18n$Cles$typesDeQuantiteNomsLangueEs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.noms.langue-es', _List_Nil, 'Español');
};
var $author$project$I18n$Cles$typesDeQuantiteNomsLangueFr = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.noms.langue-fr', _List_Nil, 'Français');
};
var $author$project$Components$Produits$Vocabulaire$nomDeLaLangueDUnNom = F2(
	function (i18n, code) {
		switch (code) {
			case 'en':
				return $author$project$I18n$Cles$typesDeQuantiteNomsLangueEn(i18n);
			case 'es':
				return $author$project$I18n$Cles$typesDeQuantiteNomsLangueEs(i18n);
			case 'de':
				return $author$project$I18n$Cles$typesDeQuantiteNomsLangueDe(i18n);
			default:
				return $author$project$I18n$Cles$typesDeQuantiteNomsLangueFr(i18n);
		}
	});
var $author$project$I18n$Cles$typesDeQuantiteNomsLangueReference = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.noms.langue-reference', _List_Nil, 'Langue de référence · obligatoire');
};
var $author$project$Components$Produits$TypesDeQuantite$View$nomDansUneLangue = F4(
	function (i18n, prefixe, model, langue) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('nom-par-langue'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'de-reference',
							_Utils_eq(langue, $author$project$Components$Produits$TypesDeQuantite$Model$langueDeReference))
						]))
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Components$Shared$Champ$View$texte,
					{
						go: (_Utils_eq(langue, $author$project$Components$Produits$TypesDeQuantite$Model$langueDeReference) && $author$project$Components$Produits$TypesDeQuantite$View$nomDejaPris(model)) ? $elm$core$Maybe$Just(
							$author$project$I18n$Cles$typesDeQuantiteRefusNomDejaPrisChamp(i18n)) : $elm$core$Maybe$Nothing,
						Aq: prefixe + ('-' + langue),
						Bl: A2($author$project$Components$Produits$Vocabulaire$nomDeLaLangueDUnNom, i18n, langue),
						he: false
					},
					{
						hg: $author$project$Components$Produits$TypesDeQuantite$Update$NomSaisi(langue),
						fm: A2($author$project$Components$Shared$LibellesParLangue$Model$lire, langue, model.R)
					}),
				_Utils_eq(langue, $author$project$Components$Produits$TypesDeQuantite$Model$langueDeReference) ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('langue-reference')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$typesDeQuantiteNomsLangueReference(i18n))
							]))
					]) : _List_Nil));
	});
var $author$project$I18n$Cles$typesDeQuantiteComportementAideFixe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.comportement.aide.fixe', _List_Nil, 'Fixe depuis la création. Une base utilisée par une règle ne peut pas être retirée.');
};
var $author$project$I18n$Cles$typesDeQuantiteNomsAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.noms.aide', _List_Nil, 'Le nom est celui que voient les utilisateurs dans le drawer de quantité d\'un périmètre, dans leur langue.');
};
var $author$project$I18n$Cles$typesDeQuantiteNomsLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.noms.libelle', _List_Nil, 'Nom et traductions');
};
var $author$project$I18n$Cles$typesDeQuantiteNomsNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.noms.note', _List_Nil, 'Seul le français est obligatoire, les autres langues retombent sur lui.');
};
var $author$project$Components$Produits$TypesDeQuantite$View$modification = F4(
	function (i18n, prefixe, leType, model) {
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$typesDeQuantiteComportementLibelle(i18n))
						])),
					$author$project$Components$Shared$Segment$View$view(
					{
						vd: leType.vV,
						Bi: $author$project$I18n$Cles$typesDeQuantiteComportementLibelle(i18n),
						Dj: 'comportement-fixe',
						Ea: $author$project$Components$Produits$TypesDeQuantite$Update$ComportementChoisi,
						o_: _List_fromArray(
							[
								{
								vx: leType.vV,
								Bl: A2($author$project$Components$Produits$Vocabulaire$libelleDuComportement, i18n, leType.vV)
							}
							])
					}),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$typesDeQuantiteComportementAideFixe(i18n))
						]))
				]),
			_Utils_ap(
				A3($author$project$Components$Produits$TypesDeQuantite$View$bases, i18n, false, model),
				_Utils_ap(
					A2($author$project$Components$Produits$TypesDeQuantite$View$periode, i18n, model),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$typesDeQuantiteNomsLibelle(i18n))
								])),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								A3($author$project$Components$Produits$TypesDeQuantite$View$nomDansUneLangue, i18n, prefixe, model),
								$author$project$Components$Produits$TypesDeQuantite$Model$langues),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$typesDeQuantiteNomsNote(i18n))
										])),
									A2(
									$author$project$Components$Shared$Note$View$view,
									0,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$typesDeQuantiteNomsAide(i18n))
												]))
										]))
								]))))));
	});
var $author$project$Components$Produits$TypesDeQuantite$Update$TypeDescendu = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Produits$TypesDeQuantite$Update$TypeMonte = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Produits$TypesDeQuantite$View$actifsDe = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ib;
				},
				$elm$core$List$filter(
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.tE;
						},
						$elm$core$Basics$not))),
			model.aS));
};
var $author$project$Components$Produits$TypesDeQuantite$Update$Depose = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Produits$TypesDeQuantite$Update$GlisserCommence = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Produits$TypesDeQuantite$Update$GlisserFini = {$: 16};
var $author$project$Components$Produits$TypesDeQuantite$Update$GlisserSurvole = {$: 14};
var $author$project$Components$Produits$TypesDeQuantite$View$glisser = function (uid) {
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$draggable('true'),
			A2(
			$rtfeldman$elm_css$Html$Styled$Events$on,
			'dragstart',
			$elm$json$Json$Decode$succeed(
				$author$project$Components$Produits$TypesDeQuantite$Update$GlisserCommence(uid))),
			A2(
			$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
			'dragover',
			$elm$json$Json$Decode$succeed(
				_Utils_Tuple2($author$project$Components$Produits$TypesDeQuantite$Update$GlisserSurvole, true))),
			A2(
			$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
			'drop',
			$elm$json$Json$Decode$succeed(
				_Utils_Tuple2(
					$author$project$Components$Produits$TypesDeQuantite$Update$Depose(uid),
					true))),
			A2(
			$rtfeldman$elm_css$Html$Styled$Events$on,
			'dragend',
			$elm$json$Json$Decode$succeed($author$project$Components$Produits$TypesDeQuantite$Update$GlisserFini))
		]);
};
var $author$project$Components$Produits$TypesDeQuantite$View$ordre = F2(
	function (i18n, model) {
		var types = A2(
			$elm$core$List$filterMap,
			function (uid) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (t) {
							return _Utils_eq(t.r8, uid);
						},
						$author$project$Components$Produits$TypesDeQuantite$View$actifsDe(model)));
			},
			model.El);
		var premier = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.r8;
			},
			$elm$core$List$head(types));
		var dernier = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.r8;
			},
			$elm$core$List$head(
				$elm$core$List$reverse(types)));
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$ul,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ordre-des-types')
					]),
				A2(
					$elm$core$List$map,
					function (t) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$li,
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne'),
								A2(
									$elm$core$List$cons,
									$rtfeldman$elm_css$Html$Styled$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'glisse',
												_Utils_eq(
													model.m_,
													$elm$core$Maybe$Just(t.r8)))
											])),
									$author$project$Components$Produits$TypesDeQuantite$View$glisser(t.r8))),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('poignee')
										]),
									_List_fromArray(
										[$author$project$Components$Shared$Svg$svgDragHandle])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('deplacer')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Components$Shared$OrdreView$boutonDOrdre,
											0,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$id('type-de-quantite-' + (t.r8 + '-monter')),
													$rtfeldman$elm_css$Html$Styled$Events$onClick(
													$author$project$Components$Produits$TypesDeQuantite$Update$TypeMonte(t.r8)),
													$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
													_Utils_eq(
														premier,
														$elm$core$Maybe$Just(t.r8))),
													A2(
													$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
													'aria-label',
													A2(
														$author$project$I18n$Cles$produitsStructureOrdreMonterDe,
														i18n,
														{Dj: t.Dj})),
													$rtfeldman$elm_css$Html$Styled$Attributes$title(
													A2(
														$author$project$I18n$Cles$produitsStructureOrdreMonterDe,
														i18n,
														{Dj: t.Dj}))
												])),
											A2(
											$author$project$Components$Shared$OrdreView$boutonDOrdre,
											1,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$id('type-de-quantite-' + (t.r8 + '-descendre')),
													$rtfeldman$elm_css$Html$Styled$Events$onClick(
													$author$project$Components$Produits$TypesDeQuantite$Update$TypeDescendu(t.r8)),
													$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
													_Utils_eq(
														dernier,
														$elm$core$Maybe$Just(t.r8))),
													A2(
													$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
													'aria-label',
													A2(
														$author$project$I18n$Cles$produitsStructureOrdreDescendreDe,
														i18n,
														{Dj: t.Dj})),
													$rtfeldman$elm_css$Html$Styled$Attributes$title(
													A2(
														$author$project$I18n$Cles$produitsStructureOrdreDescendreDe,
														i18n,
														{Dj: t.Dj}))
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(t.Dj),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('comportement')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2($author$project$Components$Produits$Vocabulaire$libelleDuComportement, i18n, t.vV))
												]))
										]))
								]));
					},
					types))
			]);
	});
var $author$project$I18n$Cles$typesDeQuantiteRefusAucuneBase = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.refus.aucune.base', _List_Nil, 'Permettez au moins une base.');
};
var $author$project$I18n$Cles$typesDeQuantiteRefusAutre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.refus.autre', _List_Nil, 'Le type n\'a pas pu être enregistré.');
};
var $author$project$I18n$Cles$typesDeQuantiteRefusBaseNonPermise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.refus.base.non.permise', _List_Nil, 'Un multiple ne s\'entend que par commande.');
};
var $author$project$I18n$Cles$typesDeQuantiteRefusBaseUtilisee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.refus.base.utilisee', _List_Nil, 'Une règle utilise cette base : elle ne peut pas être retirée.');
};
var $author$project$I18n$Cles$typesDeQuantiteRefusNomDejaPrisTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.refus.nom.deja.pris.texte', _List_Nil, 'Choisissez un autre nom, ou modifiez le type existant.');
};
var $author$project$I18n$Cles$typesDeQuantiteRefusNomVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.refus.nom.vide', _List_Nil, 'Le nom du type est obligatoire.');
};
var $author$project$I18n$Cles$typesDeQuantiteRefusPeriodeSansBase = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.refus.periode.sans.base', _List_Nil, 'La période par défaut demande la base « Par période ».');
};
var $author$project$Components$Produits$TypesDeQuantite$View$libelleDuRefus = F2(
	function (i18n, erreur) {
		switch (erreur.$) {
			case 0:
				return $author$project$I18n$Cles$typesDeQuantiteRefusNomDejaPrisTexte(i18n);
			case 1:
				return $author$project$I18n$Cles$typesDeQuantiteRefusNomVide(i18n);
			case 2:
				return $author$project$I18n$Cles$typesDeQuantiteRefusAucuneBase(i18n);
			case 3:
				return $author$project$I18n$Cles$typesDeQuantiteRefusBaseNonPermise(i18n);
			case 4:
				return $author$project$I18n$Cles$typesDeQuantiteRefusBaseUtilisee(i18n);
			case 5:
				return $author$project$I18n$Cles$typesDeQuantiteRefusPeriodeSansBase(i18n);
			default:
				return $author$project$I18n$Cles$typesDeQuantiteRefusAutre(i18n);
		}
	});
var $author$project$I18n$Cles$typesDeQuantiteRefusSaisieVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.refus.saisie.vide', _List_Nil, 'Complétez la saisie avant d\'enregistrer.');
};
var $author$project$Components$Produits$TypesDeQuantite$View$refus = F2(
	function (i18n, model) {
		var _v0 = model.pZ;
		if (!_v0.$) {
			if (!_v0.a.$) {
				return $rtfeldman$elm_css$Html$Styled$text('');
			} else {
				var erreur = _v0.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('refus'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Produits$TypesDeQuantite$View$libelleDuRefus, i18n, erreur))
						]));
			}
		} else {
			return model.b5 ? A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('refus'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$typesDeQuantiteRefusSaisieVide(i18n))
					])) : $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Produits$TypesDeQuantite$View$nomDuRefus = F2(
	function (existant, model) {
		return (existant === '') ? $elm$core$String$trim(
			A2($author$project$Components$Shared$LibellesParLangue$Model$lire, 'fr', model.R)) : existant;
	});
var $author$project$I18n$Cles$typesDeQuantiteRefusNomDejaPrisCode = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.refus.nom.deja.pris.code', _List_Nil, '422 NomDeTypeDejaPris');
};
var $author$project$I18n$Cles$typesDeQuantiteRefusNomDejaPrisTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'types.de.quantite.refus.nom.deja.pris.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Un type « ' + (p.Dj + ' » existe déjà.'));
	});
var $author$project$Components$Produits$TypesDeQuantite$View$refusEnTete = F2(
	function (i18n, model) {
		var _v0 = model.pZ;
		if ((!_v0.$) && (!_v0.a.$)) {
			var existant = _v0.a.a;
			return _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Note$View$view,
					2,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$typesDeQuantiteRefusNomDejaPrisTitre,
										i18n,
										{
											Dj: A2($author$project$Components$Produits$TypesDeQuantite$View$nomDuRefus, existant, model)
										}))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$typesDeQuantiteRefusNomDejaPrisTexte(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$code,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$typesDeQuantiteRefusNomDejaPrisCode(i18n))
								]))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$I18n$Cles$typesDeQuantiteArchivageAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.archivage.action', _List_Nil, 'Archiver le type');
};
var $author$project$I18n$Cles$typesDeQuantiteArchivagePerimetresNombre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'types.de.quantite.archivage.perimetres.nombre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' périmètre') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' périmètres'));
	});
var $author$project$I18n$Cles$typesDeQuantiteArchivageRetour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.archivage.retour', _List_Nil, 'Retour');
};
var $author$project$I18n$Cles$typesDeQuantiteArchivageSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'types.de.quantite.archivage.sous.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'regles',
					$author$project$I18n$Traductions$Chaine(p.hJ))
				]),
			p.Dj + (' · ' + p.hJ));
	});
var $author$project$I18n$Cles$typesDeQuantiteArchivageSousTitreUsages = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'types.de.quantite.archivage.sous.titre.usages',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'regles',
					$author$project$I18n$Traductions$Chaine(p.hJ)),
					_Utils_Tuple2(
					'perimetres',
					$author$project$I18n$Traductions$Chaine(p.pg))
				]),
			p.Dj + (' · ' + (p.hJ + (', ' + p.pg))));
	});
var $author$project$I18n$Cles$typesDeQuantiteArchivageTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.archivage.titre', _List_Nil, 'Archiver le type');
};
var $author$project$I18n$Cles$typesDeQuantiteArchiverOuvrir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.archiver.ouvrir', _List_Nil, 'Archiver le type…');
};
var $author$project$I18n$Cles$typesDeQuantiteCreationAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.creation.action', _List_Nil, 'Créer le type');
};
var $author$project$I18n$Cles$typesDeQuantiteCreationSousTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.creation.sous.titre', _List_Nil, 'Type de règle de quantité');
};
var $author$project$I18n$Cles$typesDeQuantiteCreationTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.creation.titre', _List_Nil, 'Nouveau type');
};
var $author$project$I18n$Cles$typesDeQuantiteEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$typesDeQuantiteModificationSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'types.de.quantite.modification.sous.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'comportement',
					$author$project$I18n$Traductions$Chaine(p.vV))
				]),
			p.Dj + (' · ' + p.vV));
	});
var $author$project$I18n$Cles$typesDeQuantiteModificationTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.modification.titre', _List_Nil, 'Modifier le type');
};
var $author$project$I18n$Cles$typesDeQuantiteOrdonnerAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.ordonner.action', _List_Nil, 'Enregistrer l\'ordre');
};
var $author$project$I18n$Cles$typesDeQuantiteOrdonnerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.ordonner.titre', _List_Nil, 'Ordonner les types');
};
var $author$project$I18n$Cles$typesDeQuantitePageTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.page.titre', _List_Nil, 'Types de règles de quantité');
};
var $author$project$Components$Shared$Drawer$View$viewDestructifAvecPiedLibreEtSousTitre = F3(
	function (i18n, sousTitre, pied) {
		return A4(
			$author$project$Components$Shared$Drawer$View$viewAvecPied,
			i18n,
			3,
			$elm$core$Maybe$Just(sousTitre),
			function (_v0) {
				return pied;
			});
	});
var $author$project$Components$Produits$TypesDeQuantite$View$drawerDuGeste = F2(
	function (i18n, model) {
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.kX);
		var actif = (!$author$project$API$Envoi$enCours(model.l2)) && (_Utils_eq(
			model.mW,
			$elm$core$Maybe$Just($author$project$Components$Produits$TypesDeQuantite$Model$Creation)) || (!_Utils_eq(
			$author$project$Components$Produits$TypesDeQuantite$Model$commandes(model),
			_List_Nil)));
		var contenu = F3(
			function (titre, corps, action) {
				return {
					fs: {sR: actif, Bl: action, C$: $author$project$Components$Produits$TypesDeQuantite$Update$GesteDemande},
					fZ: _Utils_ap(
						A2($author$project$Components$Produits$TypesDeQuantite$View$refusEnTete, i18n, model),
						_Utils_ap(
							corps,
							_List_fromArray(
								[
									A2($author$project$Components$Produits$TypesDeQuantite$View$refus, i18n, model)
								]))),
					A6: $elm$core$Maybe$Nothing,
					Bc: false,
					h6: titre
				};
			});
		var _v0 = _Utils_Tuple2(
			model.mW,
			$author$project$Components$Produits$TypesDeQuantite$Model$typeDuGeste(model));
		_v0$4:
		while (true) {
			if (!_v0.a.$) {
				switch (_v0.a.a.$) {
					case 0:
						var _v1 = _v0.a.a;
						return A5(
							$author$project$Components$Shared$Drawer$View$viewAvecSousTitre,
							i18n,
							$author$project$I18n$Cles$typesDeQuantiteCreationSousTitre(i18n),
							$author$project$Components$Produits$TypesDeQuantite$Update$DuDrawer,
							A3(
								contenu,
								$author$project$I18n$Cles$typesDeQuantiteCreationTitre(i18n),
								A3($author$project$Components$Produits$TypesDeQuantite$View$creation, i18n, prefixe, model),
								$author$project$I18n$Cles$typesDeQuantiteCreationAction(i18n)),
							model.kX);
					case 1:
						if (!_v0.b.$) {
							var uid = _v0.a.a.a;
							var leType = _v0.b.a;
							return A6(
								$author$project$Components$Shared$Drawer$View$viewAvecPiedLibreEtSousTitre,
								i18n,
								A2(
									$author$project$I18n$Cles$typesDeQuantiteModificationSousTitre,
									i18n,
									{
										vV: A2($author$project$Components$Produits$Vocabulaire$libelleDuComportement, i18n, leType.vV),
										Dj: leType.Dj
									}),
								{
									oJ: $elm$core$Maybe$Nothing,
									HF: function (attributs) {
										return A3(
											$author$project$Components$Shared$Bouton$View$bouton,
											1,
											_Utils_ap(
												attributs,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Events$onClick(
														$author$project$Components$Produits$TypesDeQuantite$Update$DuDrawer($author$project$Components$Shared$Drawer$Update$Fermer))
													])),
											$author$project$I18n$Cles$drawerAnnuler(i18n));
									},
									Jb: _List_fromArray(
										[
											A3(
											$author$project$Components$Shared$Bouton$View$bouton,
											3,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$id(prefixe + '-archiver'),
													$rtfeldman$elm_css$Html$Styled$Attributes$class('archiver'),
													$rtfeldman$elm_css$Html$Styled$Events$onClick(
													$author$project$Components$Produits$TypesDeQuantite$Update$GesteOuvert(
														$author$project$Components$Produits$TypesDeQuantite$Model$Archivage(uid)))
												]),
											$author$project$I18n$Cles$typesDeQuantiteArchiverOuvrir(i18n))
										])
								},
								$author$project$Components$Produits$TypesDeQuantite$Update$DuDrawer,
								A3(
									contenu,
									$author$project$I18n$Cles$typesDeQuantiteModificationTitre(i18n),
									A4($author$project$Components$Produits$TypesDeQuantite$View$modification, i18n, prefixe, leType, model),
									$author$project$I18n$Cles$typesDeQuantiteEnregistrer(i18n)),
								model.kX);
						} else {
							break _v0$4;
						}
					case 2:
						if (!_v0.b.$) {
							var leType = _v0.b.a;
							return A6(
								$author$project$Components$Shared$Drawer$View$viewDestructifAvecPiedLibreEtSousTitre,
								i18n,
								$elm$core$List$isEmpty(leType.Ke) ? A2(
									$author$project$I18n$Cles$typesDeQuantiteArchivageSousTitre,
									i18n,
									{
										Dj: leType.Dj,
										hJ: A2(
											$author$project$I18n$Cles$typesDeQuantiteUtilisePar,
											i18n,
											{w: leType.sf})
									}) : A2(
									$author$project$I18n$Cles$typesDeQuantiteArchivageSousTitreUsages,
									i18n,
									{
										Dj: leType.Dj,
										pg: A2(
											$author$project$I18n$Cles$typesDeQuantiteArchivagePerimetresNombre,
											i18n,
											{
												w: $elm$core$List$length(leType.Ke)
											}),
										hJ: A2(
											$author$project$I18n$Cles$typesDeQuantiteUtilisePar,
											i18n,
											{w: leType.sf})
									}),
								{
									oJ: $elm$core$Maybe$Nothing,
									HF: function (attributs) {
										return A3(
											$author$project$Components$Shared$Bouton$View$bouton,
											1,
											_Utils_ap(
												attributs,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$TypesDeQuantite$Update$RetourALaModification)
													])),
											$author$project$I18n$Cles$typesDeQuantiteArchivageRetour(i18n));
									},
									Jb: _List_Nil
								},
								$author$project$Components$Produits$TypesDeQuantite$Update$DuDrawer,
								A3(
									contenu,
									$author$project$I18n$Cles$typesDeQuantiteArchivageTitre(i18n),
									A2($author$project$Components$Produits$TypesDeQuantite$View$archivage, i18n, leType),
									$author$project$I18n$Cles$typesDeQuantiteArchivageAction(i18n)),
								model.kX);
						} else {
							break _v0$4;
						}
					default:
						var _v2 = _v0.a.a;
						return A5(
							$author$project$Components$Shared$Drawer$View$viewAvecSousTitre,
							i18n,
							$author$project$I18n$Cles$typesDeQuantitePageTitre(i18n),
							$author$project$Components$Produits$TypesDeQuantite$Update$DuDrawer,
							A3(
								contenu,
								$author$project$I18n$Cles$typesDeQuantiteOrdonnerTitre(i18n),
								A2($author$project$Components$Produits$TypesDeQuantite$View$ordre, i18n, model),
								$author$project$I18n$Cles$typesDeQuantiteOrdonnerAction(i18n)),
							model.kX);
				}
			} else {
				break _v0$4;
			}
		}
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Produits$TypesDeQuantite$Update$DuDrawer,
			A3(contenu, '', _List_Nil, ''),
			model.kX);
	});
var $author$project$I18n$Cles$typesDeQuantiteLectureSeuleTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.lecture.seule.texte', _List_Nil, 'Seul un administrateur de l\'espace crée, modifie ou archive les types de règles de quantité.');
};
var $author$project$I18n$Cles$typesDeQuantiteLectureSeuleTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.lecture.seule.titre', _List_Nil, 'Lecture seule.');
};
var $author$project$Components$Produits$TypesDeQuantite$View$lectureSeule = function (i18n) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('alerte'),
				$rtfeldman$elm_css$Html$Styled$Attributes$class('info')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$typesDeQuantiteLectureSeuleTitre(i18n))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$typesDeQuantiteLectureSeuleTexte(i18n))
					]))
			]));
};
var $author$project$I18n$Cles$typesDeQuantiteNouveau = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.nouveau', _List_Nil, 'Nouveau type');
};
var $author$project$I18n$Cles$typesDeQuantiteOrdreNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.ordre.note', _List_Nil, 'L\'ordre ci-dessus est celui du drawer de quantité d\'un périmètre.');
};
var $author$project$Components$Produits$TypesDeQuantite$View$pied = F2(
	function (i18n, model) {
		return _Utils_ap(
			($elm$core$List$length(
				$author$project$Components$Produits$TypesDeQuantite$View$actifsDe(model)) > 1) ? _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$typesDeQuantiteOrdreNote(i18n))
						]))
				]) : _List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					0,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id(
							$author$project$Components$Produits$TypesDeQuantite$Model$idDuDeclencheur($author$project$Components$Produits$TypesDeQuantite$Model$Creation)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Produits$TypesDeQuantite$Update$GesteOuvert($author$project$Components$Produits$TypesDeQuantite$Model$Creation))
						]),
					$author$project$I18n$Cles$typesDeQuantiteNouveau(i18n))
				]));
	});
var $author$project$I18n$Cles$typesDeQuantiteLectureSeule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.lecture.seule', _List_Nil, 'Lecture seule');
};
var $author$project$I18n$Cles$typesDeQuantitePageDescription = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.page.description', _List_Nil, 'Ce que les périmètres d\'offre peuvent imposer comme quantité : MOQ, colisage, maximum…');
};
var $author$project$I18n$Cles$typesDeQuantiteVideTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.vide.texte', _List_Nil, 'Créez les types que vos périmètres d\'offre pourront utiliser : MOQ, colisage, quantité maximale… Sans type, l\'étape 4 d\'un périmètre ne propose aucune règle de quantité.');
};
var $author$project$I18n$Cles$typesDeQuantiteVideTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.vide.titre', _List_Nil, 'Aucun type de règle de quantité');
};
var $author$project$Components$Produits$TypesDeQuantite$View$vide = function (i18n) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$section,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('types')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h3,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$typesDeQuantiteSectionTitre(i18n)),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('0')
									]))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$h3,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$typesDeQuantiteVideTitre(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$typesDeQuantiteVideTexte(i18n))
									]))
							]))
					]))
			]));
};
var $author$project$Components$Produits$TypesDeQuantite$View$view = F3(
	function (i18n, messages, model) {
		var types = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ib;
				},
				model.aS));
		var peutCreer = !_Utils_eq(
			A2($author$project$Components$Produits$TypesDeQuantite$Model$lienDe, $author$project$API$NavLinksDictionary$creerUnTypeDeQuantite, model),
			$elm$core$Maybe$Nothing);
		var enLectureSeule = (!_Utils_eq(model.aS, $elm$core$Maybe$Nothing)) && ((!peutCreer) && (!A2($elm$core$List$any, $author$project$Components$Produits$TypesDeQuantite$Model$modifiable, types)));
		var archives = A2(
			$elm$core$List$filter,
			function ($) {
				return $.tE;
			},
			types);
		var actifs = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.tE;
				},
				$elm$core$Basics$not),
			types);
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'parametrage-types-de-quantite-list',
			{
				ut: _Utils_eq(model.np, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						A2(
							$elm$core$List$cons,
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							_Utils_ap(
								enLectureSeule ? _List_fromArray(
									[
										$author$project$Components$Produits$TypesDeQuantite$View$lectureSeule(i18n)
									]) : _List_Nil,
								((!_Utils_eq(model.aS, $elm$core$Maybe$Nothing)) && _Utils_eq(types, _List_Nil)) ? _List_fromArray(
									[
										$author$project$Components$Produits$TypesDeQuantite$View$vide(i18n)
									]) : _List_fromArray(
									[
										A4($author$project$Components$Produits$TypesDeQuantite$View$annuaire, i18n, model, actifs, archives)
									]))))
					]),
				xy: _List_fromArray(
					[
						A2($author$project$Components$Produits$TypesDeQuantite$View$drawerDuGeste, i18n, model)
					]),
				zM: peutCreer ? A2($author$project$Components$Produits$TypesDeQuantite$View$pied, i18n, model) : _List_Nil,
				AK: $author$project$Components$Produits$TypesDeQuantite$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _Utils_ap(
							enLectureSeule ? _List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Tag$View$view,
									3,
									$author$project$I18n$Cles$typesDeQuantiteLectureSeule(i18n))
								]) : _List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$typesDeQuantitePageDescription(i18n))
										]))
								])),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adresseTypesDePartiesPrenantes,
								Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
							},
								{
								aa: '',
								Dj: $author$project$I18n$Cles$typesDeQuantitePageTitre(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$typesDeQuantitePageTitre(i18n)
					})
			});
	});
var $author$project$Components$Referentiel$Alertes$Update$Relue = {$: 6};
var $author$project$Components$Referentiel$Alertes$Update$InformationChoisie = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Referentiel$Alertes$Update$TypeChoisi = function (a) {
	return {$: 4, a: a};
};
var $author$project$I18n$Cles$referentielAlertesFiltreType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.alertes.filtre-type', _List_Nil, 'Type de partie prenante');
};
var $author$project$Components$Referentiel$Alertes$View$filtre = F3(
	function (i18n, model, lues) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('filtres')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsAlertesFiltreInformation(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$select,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Referentiel$Alertes$Update$InformationChoisie)
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$rtfeldman$elm_css$Html$Styled$option,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(''),
											$rtfeldman$elm_css$Html$Styled$Attributes$selected(model.AL === '')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsAlertesFiltreToutes(i18n))
										])),
								A2(
									$elm$core$List$map,
									function (information) {
										return A2(
											$rtfeldman$elm_css$Html$Styled$option,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$value(information.dy),
													$rtfeldman$elm_css$Html$Styled$Attributes$selected(
													_Utils_eq(model.AL, information.dy))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$author$project$I18n$Cles$produitsAlertesFiltreOption,
														i18n,
														{
															Bl: information.Bl,
															w: $elm$core$String$fromInt(information.w)
														}))
												]));
									},
									lues.AM)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielAlertesFiltreType(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$select,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Referentiel$Alertes$Update$TypeChoisi)
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$rtfeldman$elm_css$Html$Styled$option,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(''),
											$rtfeldman$elm_css$Html$Styled$Attributes$selected(model.JT === '')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsAlertesFiltreTous(i18n))
										])),
								A2(
									$elm$core$List$map,
									function (leType) {
										return A2(
											$rtfeldman$elm_css$Html$Styled$option,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$value(leType.Aq),
													$rtfeldman$elm_css$Html$Styled$Attributes$selected(
													_Utils_eq(model.JT, leType.Aq))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$author$project$I18n$Cles$produitsAlertesFiltreOption,
														i18n,
														{
															Bl: leType.Bl,
															w: $elm$core$String$fromInt(leType.w)
														}))
												]));
									},
									lues.ib)))
						]))
				]));
	});
var $author$project$Components$Referentiel$Alertes$Update$PageChoisie = function (a) {
	return {$: 5, a: a};
};
var $author$project$I18n$Cles$referentielAlertesAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.alertes.aide', _List_Nil, 'Cliquez une partie prenante pour ouvrir sa fiche et corriger la valeur. Elle quitte la liste dès qu’elle est conforme.');
};
var $author$project$Components$Referentiel$Alertes$View$pied = F3(
	function (i18n, model, lues) {
		var debut = ((model.EE - 1) * $author$project$Components$Referentiel$Alertes$Model$taillePage) + 1;
		var fin = (debut + $elm$core$List$length(lues.tb)) - 1;
		var nombres = {
			ku: $elm$core$String$fromInt(debut),
			mI: $elm$core$String$fromInt(fin),
			JE: $elm$core$String$fromInt(lues.JE)
		};
		var compte = lues.tW ? A2($author$project$I18n$Cles$produitsAlertesPaginationPlus, i18n, nombres) : A2($author$project$I18n$Cles$produitsAlertesPagination, i18n, nombres);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pied')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$referentielAlertesAide(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('pagination')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(compte)
								])),
							(model.EE > 1) ? A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							2,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Referentiel$Alertes$Update$PageChoisie(model.EE - 1))
								]),
							$author$project$I18n$Cles$produitsAlertesPagePrecedente(i18n)) : $rtfeldman$elm_css$Html$Styled$text(''),
							(_Utils_cmp(fin, lues.JE) < 0) ? A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							2,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Referentiel$Alertes$Update$PageChoisie(model.EE + 1))
								]),
							$author$project$I18n$Cles$produitsAlertesPageSuivante(i18n)) : $rtfeldman$elm_css$Html$Styled$text('')
						]))
				]));
	});
var $author$project$I18n$Cles$referentielAlertesVideTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.alertes.vide-texte', _List_Nil, 'Toutes les valeurs saisies respectent les limites des informations de leur type.');
};
var $author$project$I18n$Cles$referentielAlertesVideTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.alertes.vide-titre', _List_Nil, 'Aucune alerte sur les parties prenantes.');
};
var $author$project$Components$Referentiel$Alertes$Model$ficheOuverte = function (alerte) {
	return A2(
		$elm$core$Maybe$andThen,
		function (_v0) {
			return $author$project$Components$Referentiel$Identifiants$entiteUidFromString(alerte.zo);
		},
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$entite, alerte.nQ));
};
var $author$project$I18n$Cles$referentielFicheTitreEffacee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.titre-effacee', _List_Nil, 'Personne effacée');
};
var $author$project$Components$Referentiel$Alertes$View$ligne = F2(
	function (i18n, alerte) {
		var nom = function () {
			var _v1 = _Utils_Tuple2(alerte.Dj, alerte.gt);
			if (!_v1.a.$) {
				var lu = _v1.a.a;
				return lu;
			} else {
				if (_v1.b === 4) {
					var _v2 = _v1.a;
					var _v3 = _v1.b;
					return $author$project$I18n$Cles$referentielFicheTitreEffacee(i18n);
				} else {
					var _v4 = _v1.a;
					return $author$project$I18n$Cles$referentielFicheNomMasque(i18n);
				}
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'cliquable',
							!_Utils_eq(
								$author$project$Components$Referentiel$Alertes$Model$ficheOuverte(alerte),
								$elm$core$Maybe$Nothing))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom-de-la-partie-prenante')
						]),
					function () {
						var _v0 = $author$project$Components$Referentiel$Alertes$Model$ficheOuverte(alerte);
						if (!_v0.$) {
							var uid = _v0.a;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href(
											$author$project$Routes$Route$toString(
												A2($author$project$Routes$Route$Fiche, uid, 0)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(nom)
										]))
								]);
						} else {
							return _List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(nom)
								]);
						}
					}()),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('type')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(alerte.nA)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('information')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(alerte.uN.Bl)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('hors-limite')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A3($author$project$Components$Shared$EditeurDeSchema$Limites$valeurDe, i18n, alerte.uN, alerte.Ki))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('limite')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Shared$EditeurDeSchema$Limites$limiteDe, i18n, alerte.uN))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('depuis')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$author$project$Texte$Jour$enFrancais(i18n),
									alerte.xe)))
						]))
				]));
	});
var $author$project$I18n$Cles$referentielAlertesColonnePartiePrenante = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.alertes.colonne-partie-prenante', _List_Nil, 'Partie prenante');
};
var $author$project$I18n$Cles$referentielAlertesColonneType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.alertes.colonne-type', _List_Nil, 'Type');
};
var $author$project$Components$Referentiel$Alertes$View$tableau = F2(
	function (i18n, lues) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$table,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$referentielAlertesColonnePartiePrenante(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$referentielAlertesColonneType(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$produitsAlertesColonneInformation(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$produitsAlertesColonneValeur(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$produitsAlertesColonneLimite(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$produitsAlertesColonneDepuis(i18n))
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$tbody,
							_List_Nil,
							A2(
								$elm$core$List$map,
								$author$project$Components$Referentiel$Alertes$View$ligne(i18n),
								lues.tb))
						]))
				]));
	});
var $author$project$Components$Referentiel$Alertes$View$corps = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.n3, model.lV);
		if (_v0.b) {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('alertes-erreur'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsAlertesErreur(i18n))
								])),
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Alertes$Update$Relue)
								]),
							$author$project$I18n$Cles$produitsAlertesReessayer(i18n))
						]))
				]);
		} else {
			if (!_v0.a.$) {
				var lues = _v0.a.a;
				return (!lues.ys) ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('alertes')
							]),
						_List_fromArray(
							[
								A3($author$project$Components$Referentiel$Alertes$View$filtre, i18n, model, lues),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('alertes-vide')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$strong,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$referentielAlertesVideTitre(i18n))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$referentielAlertesVideTexte(i18n))
											]))
									]))
							]))
					]) : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('alertes')
							]),
						_List_fromArray(
							[
								A3($author$project$Components$Referentiel$Alertes$View$filtre, i18n, model, lues),
								A2($author$project$Components$Referentiel$Alertes$View$tableau, i18n, lues),
								A3($author$project$Components$Referentiel$Alertes$View$pied, i18n, model, lues)
							]))
					]);
			} else {
				var _v1 = _v0.a;
				return _List_Nil;
			}
		}
	});
var $author$project$I18n$Cles$referentielAlertesSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.alertes.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' partie prenante non conforme · enregistrée et modifiable ; la valeur est à corriger') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' parties prenantes non conformes · enregistrées et modifiables ; la valeur est à corriger'));
	});
var $author$project$I18n$Cles$referentielAlertesSousTitrePlus = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.alertes.sous-titre-plus',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Au moins ' + (p.w + ' parties prenantes non conformes · enregistrées et modifiables ; la valeur est à corriger'));
	});
var $author$project$I18n$Cles$referentielAlertesSousTitreVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.alertes.sous-titre-vide', _List_Nil, 'Aucune partie prenante non conforme');
};
var $author$project$Components$Referentiel$Alertes$View$sousTitre = F2(
	function (i18n, model) {
		var _v0 = model.n3;
		if (!_v0.$) {
			var lues = _v0.a;
			return (!lues.ys) ? $author$project$I18n$Cles$referentielAlertesSousTitreVide(i18n) : (lues.tW ? A2(
				$author$project$I18n$Cles$referentielAlertesSousTitrePlus,
				i18n,
				{
					w: $elm$core$String$fromInt(lues.ys)
				}) : A2(
				$author$project$I18n$Cles$referentielAlertesSousTitre,
				i18n,
				{w: lues.ys}));
		} else {
			return '';
		}
	});
var $author$project$Components$Referentiel$Alertes$View$view = F4(
	function (i18n, onglets, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'referentiel-alertes',
			{
				ut: _Utils_eq(model.dZ, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						A2(
							$elm$core$List$cons,
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							A2($author$project$Components$Referentiel$Alertes$View$corps, i18n, model)))
					]),
				xy: _List_Nil,
				zM: _List_Nil,
				AK: false,
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$Components$Referentiel$Alertes$View$sousTitre, i18n, model))
									]))
							]),
						zE: _List_fromArray(
							[
								{
								aa: '',
								Dj: $author$project$I18n$Cles$produitsAlertesTitre(i18n)
							}
							]),
						Ef: _List_fromArray(
							[
								$author$project$Components$Shared$Onglets$View$view(onglets)
							]),
						h6: $author$project$I18n$Cles$produitsAlertesTitre(i18n)
					})
			});
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.titre', _List_Nil, 'Parties prenantes');
};
var $author$project$Components$Referentiel$Fiche$View$filDAriane = function (i18n) {
	return _List_fromArray(
		[
			{
			aa: $author$project$Routes$Route$adressePartiesPrenantes,
			Dj: $author$project$I18n$Cles$referentielPartiesPrenantesTitre(i18n)
		}
		]);
};
var $author$project$Components$Referentiel$Fiche$View$racine = 'referentiel-partie-prenante-detail';
var $author$project$Components$Referentiel$Fiche$View$attente = F4(
	function (i18n, messages, titre, contenu) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			$author$project$Components$Referentiel$Fiche$View$racine,
			{
				ut: $author$project$Components$Shared$Page$View$fiche(
					{
						tQ: _List_Nil,
						B2: A2(
							$elm$core$List$cons,
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							contenu)
					}),
				xy: _List_Nil,
				zM: _List_Nil,
				AK: false,
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_Nil,
						zE: $author$project$Components$Referentiel$Fiche$View$filDAriane(i18n),
						Ef: _List_Nil,
						h6: titre
					})
			});
	});
var $author$project$Components$Referentiel$Fiche$Update$RelectureDemandee = {$: 5};
var $author$project$I18n$Cles$referentielFicheEnRetardMessage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.en-retard.message', _List_Nil, 'La fiche est créée. Son affichage n\'est pas encore prêt.');
};
var $author$project$I18n$Cles$referentielFicheEnRetardRelire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.en-retard.relire', _List_Nil, 'Actualiser');
};
var $author$project$Components$Referentiel$Fiche$View$enRetard = function (i18n) {
	return A2(
		$author$project$Components$Shared$Note$View$view,
		0,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$referentielFicheEnRetardMessage(i18n))
					])),
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Fiche$Update$RelectureDemandee)
					]),
				$author$project$I18n$Cles$referentielFicheEnRetardRelire(i18n))
			]));
};
var $author$project$Components$Referentiel$Fiche$Update$BlocDemande = {$: 8};
var $author$project$Components$Referentiel$Fiche$Update$FusionVoulue = {$: 110};
var $author$project$Components$Referentiel$Fiche$View$nomDeLaFusion = F2(
	function (i18n, fusion) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Cles$referentielFicheNomMasque(i18n),
			A2(
				$elm$core$Maybe$map,
				$author$project$I18n$Cles$texte(i18n),
				fusion.Dj));
	});
var $author$project$I18n$Cles$referentielFusionImpossibleOuvrir = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fusion.impossible.ouvrir',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Ouvrir la fiche ' + p.Dj);
	});
var $author$project$Components$Referentiel$Fiche$View$ouvrirLaFicheGardee = F2(
	function (i18n, fusion) {
		return A4(
			$author$project$Components$Shared$Bouton$View$lienAvec,
			1,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ouvrir')
				]),
			$author$project$Routes$Route$toString(
				A2($author$project$Routes$Route$Fiche, fusion.r8, 0)),
			A2(
				$author$project$I18n$Cles$referentielFusionImpossibleOuvrir,
				i18n,
				{
					Dj: A2($author$project$Components$Referentiel$Fiche$View$nomDeLaFusion, i18n, fusion)
				}));
	});
var $author$project$I18n$Cles$referentielFicheActionEmail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.action.email', _List_Nil, 'Envoyer un email');
};
var $author$project$I18n$Cles$referentielFicheEnteteModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.entete.modifier', _List_Nil, 'Modifier');
};
var $author$project$I18n$Cles$referentielFusionAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.action', _List_Nil, 'Fusionner avec une autre fiche…');
};
var $author$project$Components$Referentiel$Fiche$View$actionsDeLaFiche = F3(
	function (i18n, fiche, model) {
		return (fiche.gt === 4) ? _List_Nil : ((fiche.gt === 5) ? A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Referentiel$Fiche$View$ouvrirLaFicheGardee(i18n),
					$elm$core$List$singleton),
				fiche.z1)) : _Utils_ap(
			function () {
				var _v0 = fiche.z2;
				if (!_v0.$) {
					return _List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id('fusion-declencheur'),
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Fiche$Update$FusionVoulue)
								]),
							$author$project$I18n$Cles$referentielFusionAction(i18n))
						]);
				} else {
					return _List_Nil;
				}
			}(),
			A2(
				$elm$core$List$cons,
				A4(
					$author$project$Components$Shared$Bouton$View$boutonAvecIcone,
					1,
					$author$project$Components$Shared$Svg$svgMail,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
						]),
					$author$project$I18n$Cles$referentielFicheActionEmail(i18n)),
				($author$project$Components$Referentiel$Fiche$Model$peutModifier(fiche) && _Utils_eq(model.ge, $author$project$Components$Referentiel$Fiche$Model$Fermee)) ? _List_fromArray(
					[
						A4(
						$author$project$Components$Shared$Bouton$View$boutonAvecIcone,
						0,
						$author$project$Components$Shared$Svg$svgEdit,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('modifier-la-fiche'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Fiche$Update$BlocDemande)
							]),
						$author$project$I18n$Cles$referentielFicheEnteteModifier(i18n))
					]) : _List_Nil)));
	});
var $author$project$Components$Referentiel$Fiche$Model$initialesDe = F2(
	function (nature, champs) {
		var valeur = function (cle) {
			return A2(
				$elm$core$Maybe$andThen,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v1) {
							var de = _v1.a;
							return _Utils_eq(de, cle);
						},
						champs)));
		};
		if (!nature) {
			return $author$project$Texte$Initiales$initiales(
				A2(
					$elm$core$String$join,
					' ',
					A2(
						$elm$core$List$filterMap,
						valeur,
						_List_fromArray(
							[1, 2]))));
		} else {
			return $author$project$Texte$Initiales$initialesDOrganisation(
				A2(
					$elm$core$String$join,
					' ',
					A2(
						$elm$core$List$filterMap,
						valeur,
						_List_fromArray(
							[3]))));
		}
	});
var $author$project$Components$Referentiel$Fiche$View$avatar = function (fiche) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('avatar'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				A2($author$project$Components$Referentiel$Fiche$Model$initialesDe, fiche.g1, fiche.dw))
			]));
};
var $author$project$Components$Referentiel$Fiche$Update$GesteDemande = function (a) {
	return {$: 60, a: a};
};
var $author$project$Components$Referentiel$Fiche$CycleDeVie$Restaurer = 3;
var $author$project$Components$Referentiel$Fiche$CycleDeVie$Rouvrir = 1;
var $author$project$I18n$Cles$referentielFicheEffacementMotifAutre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacement.motif-autre', _List_Nil, 'Autre');
};
var $author$project$I18n$Cles$referentielFicheEffacementMotifDemande = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacement.motif-demande', _List_Nil, 'Demande de la personne');
};
var $author$project$I18n$Cles$referentielFicheEffacementMotifEcheanceDeConservation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacement.motif-echeance-de-conservation', _List_Nil, 'Échéance de conservation');
};
var $author$project$Components$Referentiel$Fiche$View$motifLisible = F2(
	function (i18n, code) {
		switch (code) {
			case 'Demande':
				return $author$project$I18n$Cles$referentielFicheEffacementMotifDemande(i18n);
			case 'EcheanceDeConservation':
				return $author$project$I18n$Cles$referentielFicheEffacementMotifEcheanceDeConservation(i18n);
			case 'Autre':
				return $author$project$I18n$Cles$referentielFicheEffacementMotifAutre(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$I18n$Cles$referentielFicheEffaceeBandeau = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.effacee.bandeau',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Données effacées le ' + (p.wv + ' (RGPD).'));
	});
var $author$project$I18n$Cles$referentielFicheEffaceeMotif = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.effacee.motif',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'motif',
					$author$project$I18n$Traductions$Chaine(p.cX)),
					_Utils_Tuple2(
					'precision',
					$author$project$I18n$Traductions$Chaine(p.Gd))
				]),
			'Motif : ' + (p.cX + (' · ' + p.Gd)));
	});
var $author$project$I18n$Cles$referentielFicheEffaceeMotifSeul = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.effacee.motif-seul',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'motif',
					$author$project$I18n$Traductions$Chaine(p.cX))
				]),
			'Motif : ' + p.cX);
	});
var $author$project$I18n$Cles$referentielFicheEffaceeProgramme = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.effacee.programme',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			' · Programmé par ' + (p.Dj + (' le ' + (p.wv + '.'))));
	});
var $author$project$I18n$Cles$referentielFicheEffaceeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacee.titre', _List_Nil, 'Données effacées');
};
var $author$project$Components$Referentiel$Fiche$View$bandeauDeLaFicheEffacee = F2(
	function (i18n, fiche) {
		var _v0 = fiche.x6;
		if (_v0.$ === 1) {
			return _List_Nil;
		} else {
			var effacee = _v0.a;
			var motif = A2($author$project$Components$Referentiel$Fiche$View$motifLisible, i18n, effacee.cX);
			return _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Note$View$view,
					0,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielFicheEffaceeTitre(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('date')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$referentielFicheEffaceeBandeau,
										i18n,
										{
											wv: A2($author$project$I18n$Cles$texte, i18n, effacee.x7)
										}))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('motif')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									_Utils_ap(
										function () {
											var _v1 = effacee.Gd;
											if (!_v1.$) {
												var precision = _v1.a;
												return A2(
													$author$project$I18n$Cles$referentielFicheEffaceeMotif,
													i18n,
													{cX: motif, Gd: precision});
											} else {
												return A2(
													$author$project$I18n$Cles$referentielFicheEffaceeMotifSeul,
													i18n,
													{cX: motif});
											}
										}(),
										function () {
											var _v2 = effacee.Gr;
											if (!_v2.$) {
												var nom = _v2.a;
												return A2(
													$author$project$I18n$Cles$referentielFicheEffaceeProgramme,
													i18n,
													{
														wv: A2($author$project$I18n$Cles$texte, i18n, effacee.Gq),
														Dj: nom
													});
											} else {
												return '';
											}
										}()))
								]))
						]))
				]);
		}
	});
var $author$project$Components$Referentiel$Fiche$View$dateDeLaFusion = F2(
	function (i18n, fusion) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Texte$Jour$horodateALHeure(i18n),
				fusion.Bf));
	});
var $author$project$I18n$Cles$referentielFusionFusionneeDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fusion.fusionnee.detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Cette fiche a été absorbée le ' + (p.wv + '. Elle reste consultable, mais ne peut plus être modifiée.'));
	});
var $author$project$I18n$Cles$referentielFusionFusionneeTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fusion.fusionnee.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Fusionnée dans ' + p.Dj);
	});
var $author$project$Components$Referentiel$Fiche$View$bandeauDeLaFicheFusionnee = F2(
	function (i18n, fiche) {
		var _v0 = fiche.z1;
		if (!_v0.$) {
			var fusion = _v0.a;
			var nom = A2($author$project$Components$Referentiel$Fiche$View$nomDeLaFusion, i18n, fusion);
			return _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Note$View$view,
					0,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$referentielFusionFusionneeTitre,
										i18n,
										{Dj: nom}))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('date')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$referentielFusionFusionneeDetail,
										i18n,
										{
											wv: A2($author$project$Components$Referentiel$Fiche$View$dateDeLaFusion, i18n, fusion)
										}))
								])),
							A2($author$project$Components$Referentiel$Fiche$View$ouvrirLaFicheGardee, i18n, fusion)
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$I18n$Cles$referentielFicheBandeauClose = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.bandeau.close',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Fiche close le ' + p.wv);
	});
var $author$project$I18n$Cles$referentielFicheBandeauSupprimee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.bandeau.supprimee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Fiche supprimée le ' + p.wv);
	});
var $author$project$I18n$Cles$referentielFicheEffacementAnnulerBouton = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacement.annuler-bouton', _List_Nil, 'Annuler l\'effacement');
};
var $author$project$I18n$Cles$referentielFicheEffacementProgramme = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.effacement.programme',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv)),
					_Utils_Tuple2(
					'motif',
					$author$project$I18n$Traductions$Chaine(p.cX))
				]),
			'Effacement prévu le ' + (p.wv + ('. Motif : ' + (p.cX + '. Annulable jusque-là.'))));
	});
var $author$project$I18n$Cles$referentielFicheEtatEffacementProgramme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.etat.effacement-programme', _List_Nil, 'Effacement programmé');
};
var $author$project$I18n$Cles$referentielFicheGesteRestaurer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.geste.restaurer', _List_Nil, 'Restaurer');
};
var $author$project$I18n$Cles$referentielFicheGesteRouvrir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.geste.rouvrir', _List_Nil, 'Rouvrir la fiche');
};
var $author$project$Components$Referentiel$Fiche$View$bandeau = F2(
	function (i18n, fiche) {
		var geste = F3(
			function (libelle, msg, lien) {
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (_v2) {
							return _List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
										]),
									libelle)
								]);
						},
						lien));
			});
		var date = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$I18n$Cles$texte(i18n),
				fiche.yQ));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('bandeau-etat')
				]),
			function () {
				var _v0 = fiche.gt;
				switch (_v0) {
					case 0:
						return _List_Nil;
					case 1:
						return _List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Note$View$view,
								0,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$referentielFicheBandeauClose,
													i18n,
													{wv: date}))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
									]),
								A3(
									geste,
									$author$project$I18n$Cles$referentielFicheGesteRouvrir(i18n),
									$author$project$Components$Referentiel$Fiche$Update$GesteDemande(1),
									fiche.Ii))
							]);
					case 2:
						return _List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Note$View$view,
								1,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$referentielFicheBandeauSupprimee,
													i18n,
													{wv: date}))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
									]),
								A3(
									geste,
									$author$project$I18n$Cles$referentielFicheGesteRestaurer(i18n),
									$author$project$Components$Referentiel$Fiche$Update$GesteDemande(3),
									fiche.HS))
							]);
					case 4:
						return A2($author$project$Components$Referentiel$Fiche$View$bandeauDeLaFicheEffacee, i18n, fiche);
					case 5:
						return A2($author$project$Components$Referentiel$Fiche$View$bandeauDeLaFicheFusionnee, i18n, fiche);
					default:
						return _List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Note$View$view,
								1,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												function () {
													var _v1 = fiche.x9;
													if (!_v1.$) {
														var effacement = _v1.a;
														return A2(
															$author$project$I18n$Cles$referentielFicheEffacementProgramme,
															i18n,
															{
																wv: A2($author$project$I18n$Cles$texte, i18n, effacement.xY),
																cX: A2($author$project$Components$Referentiel$Fiche$View$motifLisible, i18n, effacement.cX)
															});
													} else {
														return $author$project$I18n$Cles$referentielFicheEtatEffacementProgramme(i18n);
													}
												}())
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
									]),
								A3(
									geste,
									$author$project$I18n$Cles$referentielFicheEffacementAnnulerBouton(i18n),
									$author$project$Components$Referentiel$Fiche$Update$GesteDemande(4),
									fiche.tp))
							]);
				}
			}());
	});
var $author$project$I18n$Cles$referentielFicheDoublonMotifMemeEmail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.doublon.motif.meme-email', _List_Nil, 'même email');
};
var $author$project$I18n$Cles$referentielFicheDoublonMotifMemeNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.doublon.motif.meme-nom', _List_Nil, 'même nom');
};
var $author$project$I18n$Cles$referentielFicheDoublonMotifMemeRaisonSociale = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.doublon.motif.meme-raison-sociale', _List_Nil, 'même raison sociale');
};
var $author$project$I18n$Cles$referentielFicheDoublonMotifMemeTelephone = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.doublon.motif.meme-telephone', _List_Nil, 'même téléphone');
};
var $author$project$Components$Referentiel$Fiche$View$motifDeDoublon = F2(
	function (i18n, motif) {
		switch (motif) {
			case 'MemeEmail':
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$referentielFicheDoublonMotifMemeEmail(i18n));
			case 'MemeTelephone':
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$referentielFicheDoublonMotifMemeTelephone(i18n));
			case 'MemeNom':
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$referentielFicheDoublonMotifMemeNom(i18n));
			case 'MemeRaisonSociale':
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$referentielFicheDoublonMotifMemeRaisonSociale(i18n));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$I18n$Cles$referentielFicheDoublonBandeau = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.doublon.bandeau',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Doublon possible avec ' + p.Dj);
	});
var $author$project$I18n$Cles$referentielFicheDoublonComparer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.doublon.comparer', _List_Nil, 'Comparer les deux fiches');
};
var $author$project$I18n$Cles$referentielFicheDoublonRolesSeparateur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.doublon.roles-separateur', _List_Nil, ', ');
};
var $author$project$I18n$Cles$referentielRoleLibelle = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.role.libelle',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typeDeRole',
					$author$project$I18n$Traductions$Chaine(p.rX)),
					_Utils_Tuple2(
					'offre',
					$author$project$I18n$Traductions$Chaine(p.D1))
				]),
			p.rX + (' · ' + p.D1));
	});
var $author$project$Components$Referentiel$Fiche$View$roleDuDoublon = F2(
	function (i18n, role) {
		var _v0 = role.D1;
		if (!_v0.$) {
			var offre = _v0.a;
			return A2(
				$author$project$I18n$Cles$referentielRoleLibelle,
				i18n,
				{
					D1: A2($author$project$I18n$Cles$texte, i18n, offre),
					rX: A2($author$project$I18n$Cles$texte, i18n, role.Bl)
				});
		} else {
			return A2($author$project$I18n$Cles$texte, i18n, role.Bl);
		}
	});
var $author$project$Components$Referentiel$Fiche$View$bandeauxDeDoublon = F2(
	function (i18n, fiche) {
		return ((!fiche.g1) && (fiche.gt !== 4)) ? A2(
			$elm$core$List$map,
			function (doublon) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('bandeau-doublon'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('note'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('avertissement'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'note')
						]),
					_List_fromArray(
						[
							$author$project$Components$Shared$Svg$svgWarning,
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$referentielFicheDoublonBandeau,
												i18n,
												{
													Dj: A2($author$project$I18n$Cles$texte, i18n, doublon.Dj)
												}))
										])),
									$rtfeldman$elm_css$Html$Styled$text(
									' : ' + (A2(
										$elm$core$String$join,
										', ',
										A2(
											$elm$core$List$filterMap,
											$author$project$Components$Referentiel$Fiche$View$motifDeDoublon(i18n),
											doublon.CY)) + '.')),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('offre-du-role')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$elm$core$String$join,
												$author$project$I18n$Cles$referentielFicheDoublonRolesSeparateur(i18n),
												A2(
													$elm$core$List$map,
													$author$project$Components$Referentiel$Fiche$View$roleDuDoublon(i18n),
													doublon.eX)))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
								]),
							doublon.rp ? _List_fromArray(
								[
									A4(
									$author$project$Components$Shared$Bouton$View$lienAvec,
									1,
									_List_Nil,
									$author$project$Routes$Route$toString(
										A2($author$project$Routes$Route$Fiche, doublon.r8, 0)),
									$author$project$I18n$Cles$referentielFicheDoublonComparer(i18n))
								]) : _List_Nil)
						]));
			},
			fiche.kW) : _List_Nil;
	});
var $author$project$I18n$Cles$referentielFusionBlocLigne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fusion.bloc.ligne',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'auteur',
					$author$project$I18n$Traductions$Chaine(p.t1))
				]),
			p.wv + (' · « ' + (p.Dj + (' » absorbée par ' + p.t1))));
	});
var $author$project$I18n$Cles$referentielFusionBlocLigneSansAuteur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fusion.bloc.ligne-sans-auteur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.wv + (' · « ' + (p.Dj + ' » absorbée')));
	});
var $author$project$Components$Referentiel$Fiche$View$ligneDeFusion = F2(
	function (i18n, fusion) {
		var _v0 = fusion.EK;
		if (!_v0.$) {
			var auteur = _v0.a;
			return A2(
				$author$project$I18n$Cles$referentielFusionBlocLigne,
				i18n,
				{
					t1: auteur,
					wv: A2($author$project$Components$Referentiel$Fiche$View$dateDeLaFusion, i18n, fusion),
					Dj: A2($author$project$Components$Referentiel$Fiche$View$nomDeLaFusion, i18n, fusion)
				});
		} else {
			return A2(
				$author$project$I18n$Cles$referentielFusionBlocLigneSansAuteur,
				i18n,
				{
					wv: A2($author$project$Components$Referentiel$Fiche$View$dateDeLaFusion, i18n, fusion),
					Dj: A2($author$project$Components$Referentiel$Fiche$View$nomDeLaFusion, i18n, fusion)
				});
		}
	});
var $author$project$I18n$Cles$referentielFusionBlocConsulter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.bloc.consulter', _List_Nil, 'Consulter la fiche absorbée');
};
var $author$project$I18n$Cles$referentielFusionBlocTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.bloc.titre', _List_Nil, 'Fusion');
};
var $author$project$Components$Referentiel$Fiche$View$blocDeFusion = F2(
	function (i18n, fiche) {
		return $elm$core$List$isEmpty(fiche.zx) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$author$project$Components$Shared$Page$View$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('fusion')
				]),
			{
				fw: _List_Nil,
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('fusions')
							]),
						A2(
							$elm$core$List$map,
							function (fusion) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2($author$project$Components$Referentiel$Fiche$View$ligneDeFusion, i18n, fusion))
												])),
											A4(
											$author$project$Components$Shared$Bouton$View$lienAvec,
											2,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('consulter')
												]),
											$author$project$Routes$Route$toString(
												A2($author$project$Routes$Route$Fiche, fusion.r8, 0)),
											$author$project$I18n$Cles$referentielFusionBlocConsulter(i18n))
										]));
							},
							fiche.zx))
					]),
				Dj: 'fusion',
				h6: $author$project$I18n$Cles$referentielFusionBlocTitre(i18n)
			});
	});
var $author$project$I18n$Cles$referentielFicheCompteUtilisateur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.compte-utilisateur', _List_Nil, 'Compte utilisateur');
};
var $author$project$Components$Referentiel$Fiche$View$blocDuCompte = F2(
	function (i18n, fiche) {
		var _v0 = fiche.vZ;
		if (!_v0.$) {
			var compte = _v0.a;
			return A2(
				$author$project$Components$Shared$Page$View$section,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('compte-utilisateur')
					]),
				{
					fw: _List_Nil,
					fZ: _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('avatar'),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Texte$Initiales$initiales(compte.kh))
										])),
									function () {
									var _v1 = compte.fl;
									if (!_v1.$) {
										var uid = _v1.a;
										return A2(
											$rtfeldman$elm_css$Html$Styled$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('courriel'),
													$rtfeldman$elm_css$Html$Styled$Attributes$href(
													$author$project$Routes$Route$adresseDUnUtilisateur(uid))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(compte.kh)
												]));
									} else {
										return A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('courriel')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(compte.kh)
												]));
									}
								}(),
									compte.xo ? A2(
									$author$project$Components$Shared$Tag$View$view,
									1,
									$author$project$I18n$Cles$utilisateursEtatDesactive(i18n)) : A2(
									$author$project$Components$Shared$Tag$View$view,
									0,
									$author$project$I18n$Cles$utilisateursEtatActif(i18n)),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('roles')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($elm$core$String$join, ', ', compte.eX))
										]))
								]))
						]),
					Dj: 'compte-utilisateur',
					h6: $author$project$I18n$Cles$referentielFicheCompteUtilisateur(i18n)
				});
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$referentielFicheGesteClore = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.geste.clore', _List_Nil, 'Clore la fiche');
};
var $author$project$I18n$Cles$referentielFicheGesteSupprimer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.geste.supprimer', _List_Nil, 'Supprimer la fiche');
};
var $author$project$Components$Referentiel$Fiche$View$gestesDuCycle = F2(
	function (i18n, fiche) {
		var geste = F3(
			function (libelle, cycle, lien) {
				var msg = $author$project$Components$Referentiel$Fiche$Update$GesteDemande(cycle);
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (_v0) {
							return _List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id(
											$author$project$Components$Referentiel$Fiche$CycleDeVie$idDuDeclencheur(cycle)),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
										]),
									libelle)
								]);
						},
						lien));
			});
		return (fiche.gt === 4) ? _List_Nil : _Utils_ap(
			A3(
				geste,
				$author$project$I18n$Cles$referentielFicheGesteClore(i18n),
				0,
				fiche.vo),
			A3(
				geste,
				$author$project$I18n$Cles$referentielFicheGesteSupprimer(i18n),
				2,
				fiche.Jc));
	});
var $author$project$I18n$Cles$referentielFicheCycleTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.cycle.titre', _List_Nil, 'Clôture et suppression');
};
var $author$project$Components$Referentiel$Fiche$View$blocDuCycle = F2(
	function (i18n, fiche) {
		var _v0 = A2($author$project$Components$Referentiel$Fiche$View$gestesDuCycle, i18n, fiche);
		if (!_v0.b) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var boutons = _v0;
			return A2(
				$author$project$Components$Shared$Page$View$section,
				_List_Nil,
				{
					fw: _List_Nil,
					fZ: _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
								]),
							boutons)
						]),
					Dj: 'cycle',
					h6: $author$project$I18n$Cles$referentielFicheCycleTitre(i18n)
				});
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$EffacementDemande = {$: 100};
var $author$project$Components$Referentiel$Fiche$View$aLeDroitRgpd = function (fiche) {
	return (!_Utils_eq(fiche.za, $elm$core$Maybe$Nothing)) || (!_Utils_eq(fiche.lM, $elm$core$Maybe$Nothing));
};
var $author$project$I18n$Cles$referentielFicheEffacementBouton = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacement.bouton', _List_Nil, 'Effacer la fiche…');
};
var $author$project$I18n$Cles$referentielFicheEffacementIntroduction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacement.introduction', _List_Nil, 'Programme l\'effacement des données personnelles. Un délai de rétractation s\'applique ; il peut être annulé jusque-là.');
};
var $author$project$I18n$Cles$referentielFicheEffacementMentionFicheActive = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacement.mention-fiche-active', _List_Nil, 'Clore ou supprimer la fiche avant de l\'effacer');
};
var $author$project$I18n$Cles$referentielFicheEffacementTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacement.titre', _List_Nil, 'Effacer la fiche');
};
var $author$project$Components$Referentiel$Fiche$View$blocEffacement = F2(
	function (i18n, fiche) {
		return (!$author$project$Components$Referentiel$Fiche$View$aLeDroitRgpd(fiche)) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$author$project$Components$Shared$Page$View$section,
			_List_Nil,
			{
				fw: _List_Nil,
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielFicheEffacementIntroduction(i18n))
							])),
						function () {
						var _v0 = _Utils_Tuple2(fiche.lM, fiche.gt);
						if (!_v0.a.$) {
							return A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								3,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Fiche$Effacement$idDuDeclencheur),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Fiche$Update$EffacementDemande)
									]),
								$author$project$I18n$Cles$referentielFicheEffacementBouton(i18n));
						} else {
							if (!_v0.b) {
								var _v1 = _v0.a;
								var _v2 = _v0.b;
								return A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mention')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$referentielFicheEffacementMentionFicheActive(i18n))
										]));
							} else {
								return $rtfeldman$elm_css$Html$Styled$text('');
							}
						}
					}()
					]),
				Dj: 'effacement',
				h6: $author$project$I18n$Cles$referentielFicheEffacementTitre(i18n)
			});
	});
var $author$project$Components$Referentiel$Fiche$Update$ExportDemande = {$: 109};
var $author$project$I18n$Cles$referentielFicheExportBouton = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.export.bouton', _List_Nil, 'Exporter les données…');
};
var $author$project$I18n$Cles$referentielFicheExportIntroduction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.export.introduction', _List_Nil, 'Remettre à la personne une copie de ses données (portabilité, droit d\'accès). Réponse due sous 1 mois.');
};
var $author$project$I18n$Cles$referentielFicheExportTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.export.titre', _List_Nil, 'Exporter les données');
};
var $author$project$Components$Referentiel$Fiche$View$blocExport = F2(
	function (i18n, fiche) {
		return (!$author$project$Components$Referentiel$Fiche$View$aLeDroitRgpd(fiche)) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$author$project$Components$Shared$Page$View$section,
			_List_Nil,
			{
				fw: _List_Nil,
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielFicheExportIntroduction(i18n))
							])),
						function () {
						var _v0 = fiche.za;
						if (!_v0.$) {
							return A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Fiche$Export$idDuDeclencheur),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Fiche$Update$ExportDemande)
									]),
								$author$project$I18n$Cles$referentielFicheExportBouton(i18n));
						} else {
							return $rtfeldman$elm_css$Html$Styled$text('');
						}
					}()
					]),
				Dj: 'export',
				h6: $author$project$I18n$Cles$referentielFicheExportTitre(i18n)
			});
	});
var $author$project$Components$Referentiel$Fiche$View$idDeSection = function (nom) {
	return 'section-' + nom;
};
var $author$project$Components$Referentiel$Fiche$View$ancre = function (nom) {
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$id(
			$author$project$Components$Referentiel$Fiche$View$idDeSection(nom)),
			$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1)
		]);
};
var $author$project$Components$Referentiel$Fiche$Historique$emplacementDeLaFiche = '\uE000';
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneFicheSansNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.fiche-sans-nom', _List_Nil, 'Fiche sans nom');
};
var $author$project$Components$Referentiel$Fiche$View$avecLaFicheCitee = F3(
	function (i18n, citee, composee) {
		var nom = A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Cles$referentielFicheHistoriqueLigneFicheSansNom(i18n),
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.Dj;
				},
				citee));
		var fiche = function () {
			if (!citee.$) {
				var connue = citee.a;
				return connue.rp ? A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('fiche-citee'),
							$rtfeldman$elm_css$Html$Styled$Attributes$href(
							$author$project$Routes$Route$toString(
								A2($author$project$Routes$Route$Fiche, connue.r8, 0)))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(nom)
						])) : A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('fiche-citee')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(nom)
						]));
			} else {
				return A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('fiche-citee')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(nom)
						]));
			}
		}();
		var _v0 = A2($elm$core$String$split, $author$project$Components$Referentiel$Fiche$Historique$emplacementDeLaFiche, composee);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var avant = _v0.a;
			var _v1 = _v0.b;
			var apres = _v1.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(avant),
					fiche,
					$rtfeldman$elm_css$Html$Styled$text(apres)
				]);
		} else {
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(composee)
				]);
		}
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueChampRetire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.champ-retire', _List_Nil, 'champ retiré');
};
var $author$project$Components$Referentiel$Fiche$View$champDuTypeCite = F2(
	function (i18n, ligne) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('champ-du-type'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'retire',
							_Utils_eq(
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.HZ;
									},
									ligne.uP),
								$elm$core$Maybe$Just(true)))
						]))
				]),
			function () {
				var _v0 = ligne.uP;
				if (!_v0.$) {
					var cite = _v0.a;
					return cite.HZ ? _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('tag-retire')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielFicheHistoriqueChampRetire(i18n))
								]))
						]) : _List_Nil;
				} else {
					return _List_Nil;
				}
			}());
	});
var $author$project$Components$Referentiel$Fiche$Historique$estRetire = function (auteur) {
	if (auteur.$ === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$I18n$Cles$referentielFicheHistoriqueAuteurAgent = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.auteur.agent', _List_Nil, 'Agent IA');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueAuteurApi = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.auteur.api', _List_Nil, 'API');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueAuteurImport = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.auteur.import', _List_Nil, 'Import');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueAuteurInterne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.auteur.interne', _List_Nil, 'Utilisateur');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueAuteurPersonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.auteur.personne', _List_Nil, 'La personne elle-même');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueAuteurSysteme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.auteur.systeme', _List_Nil, 'Système');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueAuteurVous = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.auteur.vous', _List_Nil, 'Vous');
};
var $author$project$Components$Referentiel$Fiche$Historique$libelleDeLAuteur = F2(
	function (i18n, auteur) {
		switch (auteur.$) {
			case 0:
				return $author$project$I18n$Cles$referentielFicheHistoriqueAuteurVous(i18n);
			case 1:
				if (!auteur.a.$) {
					var nom = auteur.a.a;
					return nom;
				} else {
					var _v1 = auteur.a;
					return $author$project$I18n$Cles$referentielFicheHistoriqueAuteurInterne(i18n);
				}
			case 2:
				if (!auteur.a.$) {
					var nom = auteur.a.a;
					return nom;
				} else {
					var _v2 = auteur.a;
					return $author$project$I18n$Cles$referentielFicheHistoriqueAuteurInterne(i18n);
				}
			case 3:
				return $author$project$I18n$Cles$referentielFicheHistoriqueAuteurPersonne(i18n);
			case 4:
				return $author$project$I18n$Cles$referentielFicheHistoriqueAuteurAgent(i18n);
			case 5:
				return $author$project$I18n$Cles$referentielFicheHistoriqueAuteurImport(i18n);
			case 6:
				return $author$project$I18n$Cles$referentielFicheHistoriqueAuteurApi(i18n);
			default:
				return $author$project$I18n$Cles$referentielFicheHistoriqueAuteurSysteme(i18n);
		}
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueSourceAgent = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.source.agent', _List_Nil, 'Agent IA');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueSourceApi = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.source.api', _List_Nil, 'API');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueSourceImport = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.source.import', _List_Nil, 'Import');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueSourceInterface = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.source.interface', _List_Nil, 'Interface');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueSourcePortail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.source.portail', _List_Nil, 'Portail');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueSourceToutes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.source.toutes', _List_Nil, 'Toutes');
};
var $author$project$Components$Referentiel$Fiche$Historique$libelleDeLaSource = F2(
	function (i18n, source) {
		if (source.$ === 1) {
			return $author$project$I18n$Cles$referentielFicheHistoriqueSourceToutes(i18n);
		} else {
			switch (source.a) {
				case 0:
					var _v1 = source.a;
					return $author$project$I18n$Cles$referentielFicheHistoriqueSourceInterface(i18n);
				case 1:
					var _v2 = source.a;
					return $author$project$I18n$Cles$referentielFicheHistoriqueSourcePortail(i18n);
				case 2:
					var _v3 = source.a;
					return $author$project$I18n$Cles$referentielFicheHistoriqueSourceAgent(i18n);
				case 3:
					var _v4 = source.a;
					return $author$project$I18n$Cles$referentielFicheHistoriqueSourceImport(i18n);
				default:
					var _v5 = source.a;
					return $author$project$I18n$Cles$referentielFicheHistoriqueSourceApi(i18n);
			}
		}
	});
var $author$project$I18n$Cles$referentielFicheHistoriquePar = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.par',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'auteur',
					$author$project$I18n$Traductions$Chaine(p.t1)),
					_Utils_Tuple2(
					'source',
					$author$project$I18n$Traductions$Chaine(p.IR))
				]),
			p.t1 + (' · ' + p.IR));
	});
var $author$project$Components$Referentiel$Fiche$View$par = F3(
	function (i18n, auteur, source) {
		if (!source.$) {
			var connue = source.a;
			return A2(
				$author$project$I18n$Cles$referentielFicheHistoriquePar,
				i18n,
				{
					t1: A2($author$project$Components$Referentiel$Fiche$Historique$libelleDeLAuteur, i18n, auteur),
					IR: A2(
						$author$project$Components$Referentiel$Fiche$Historique$libelleDeLaSource,
						i18n,
						$elm$core$Maybe$Just(connue))
				});
		} else {
			return A2($author$project$Components$Referentiel$Fiche$Historique$libelleDeLAuteur, i18n, auteur);
		}
	});
var $author$project$Components$Referentiel$Fiche$View$libelleDArchetype = F2(
	function (i18n, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			code,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Referentiel$Archetype$libelle,
					$author$project$I18n$Cles$texte(i18n)),
				$author$project$Components$Referentiel$Archetype$fromCode(code)));
	});
var $author$project$Components$Referentiel$Fiche$View$libelleDUsage = F2(
	function (i18n, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			code,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Referentiel$Fiche$Contacts$libelleDeLUsage,
					$author$project$I18n$Cles$texte(i18n)),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (usage) {
							return _Utils_eq(
								$author$project$Components$Referentiel$Common$Contact$usageCode(usage),
								code);
						},
						$author$project$Components$Referentiel$Common$Contact$usages))));
	});
var $author$project$I18n$Cles$referentielFicheContacts = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.contacts', _List_Nil, 'Moyens de contact');
};
var $author$project$Components$Referentiel$Fiche$View$nomDuContact = F3(
	function (i18n, fiche, uid) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Cles$referentielFicheContacts(i18n),
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.uF;
					},
					$author$project$I18n$Cles$texte(i18n)),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (connu) {
							return _Utils_eq(connu.r8, uid);
						},
						fiche.wa))));
	});
var $author$project$Components$Referentiel$Fiche$Roles$nomDuResultat = F4(
	function (i18n, type_, etat, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$Components$Referentiel$Vocabulaire$resultatDeRole, i18n, code),
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.DI;
					},
					$elm$core$Dict$get(code)),
				A2($author$project$Components$Referentiel$Fiche$Roles$typeDe, type_, etat)));
	});
var $author$project$Components$Referentiel$Vocabulaire$statutDeRole = F2(
	function (i18n, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			code,
			A2(
				$elm$core$Dict$get,
				code,
				$author$project$Components$Referentiel$Vocabulaire$statutsDeRole(i18n)));
	});
var $author$project$Components$Referentiel$Fiche$Roles$nomDuStatut = F4(
	function (i18n, type_, etat, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$Components$Referentiel$Vocabulaire$statutDeRole, i18n, code),
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.DJ;
					},
					$elm$core$Dict$get(code)),
				A2($author$project$Components$Referentiel$Fiche$Roles$typeDe, type_, etat)));
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneAdresseAjoutee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.adresse-ajoutee', _List_Nil, 'Adresse ajoutée');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneAdresseModifiee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.adresse-modifiee', _List_Nil, 'Adresse modifiée');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneAncienneVersionSupprimee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.ancienne-version-supprimee', _List_Nil, 'Ancienne version supprimée');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneChampModifie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.champ-modifie', _List_Nil, 'Champ modifié');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneCiviliteModifiee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.civilite-modifiee', _List_Nil, 'Civilité modifiée');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneClasseExpiree = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.classe-expiree', _List_Nil, 'Classe de conservation expirée');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneConsentementDonne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.consentement-donne',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'contact',
					$author$project$I18n$Traductions$Chaine(p.v8))
				]),
			'Consentement donné · ' + p.v8);
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneConsentementRetire = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.consentement-retire',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'contact',
					$author$project$I18n$Traductions$Chaine(p.v8))
				]),
			'Consentement retiré · ' + p.v8);
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneContactAncien = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.contact-ancien',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'contact',
					$author$project$I18n$Traductions$Chaine(p.v8))
				]),
			p.v8 + ' passé en ancien');
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneContactEfface = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.contact-efface',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'contact',
					$author$project$I18n$Traductions$Chaine(p.v8))
				]),
			p.v8 + ' effacé');
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneContactInvalide = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.contact-invalide',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'contact',
					$author$project$I18n$Traductions$Chaine(p.v8))
				]),
			p.v8 + ' marqué invalide');
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneContactPrincipal = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.contact-principal',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'contact',
					$author$project$I18n$Traductions$Chaine(p.v8))
				]),
			p.v8 + ' rendu principal');
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneContactPrincipalDesigne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.contact-principal-designe',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fiche',
					$author$project$I18n$Traductions$Chaine(p.zo))
				]),
			'Contact principal désigné · ' + p.zo);
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneContactPrincipalRetire = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.contact-principal-retire',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fiche',
					$author$project$I18n$Traductions$Chaine(p.zo))
				]),
			'Contact principal retiré · ' + p.zo);
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneContactReactive = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.contact-reactive',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'contact',
					$author$project$I18n$Traductions$Chaine(p.v8))
				]),
			p.v8 + ' réactivé');
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneDonneesExportees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.donnees-exportees', _List_Nil, 'Données exportées');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneDoublonEcarte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.doublon-ecarte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fiche',
					$author$project$I18n$Traductions$Chaine(p.zo))
				]),
			'Doublon écarté · ' + p.zo);
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneEffacementAnnule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.effacement-annule', _List_Nil, 'Effacement annulé');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneEffacementProgramme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.effacement-programme', _List_Nil, 'Effacement programmé');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneEmailAjoute = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.email-ajoute', _List_Nil, 'Email ajouté');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneEmailModifie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.email-modifie', _List_Nil, 'Email modifié');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneEmpreinteLeveeSurDemande = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.empreinte-levee-sur-demande', _List_Nil, 'Fiche recréée à la demande de la personne');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneFicheClose = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.fiche-close', _List_Nil, 'Fiche close');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneFicheCreee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.fiche-creee', _List_Nil, 'Fiche créée');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneFicheCreeeAvecRole = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.fiche-creee-avec-role',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Fiche créée · rôle ' + (p.bi + ' ouvert'));
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneFicheRestauree = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.fiche-restauree', _List_Nil, 'Fiche restaurée');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneFicheRouverte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.fiche-rouverte', _List_Nil, 'Fiche rouverte');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneFicheSupprimee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.fiche-supprimee', _List_Nil, 'Fiche supprimée');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneFinDuRattachementModifiee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.fin-du-rattachement-modifiee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fiche',
					$author$project$I18n$Traductions$Chaine(p.zo))
				]),
			'Fin du rattachement modifiée · ' + p.zo);
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneFinDuRoleModifiee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.fin-du-role-modifiee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Fin du rôle ' + (p.bi + ' modifiée'));
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneFinDuRoleModifieeSansDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.fin-du-role-modifiee-sans-detail', _List_Nil, 'Fin du rôle modifiée');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneFormeDefinie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.forme-definie', _List_Nil, 'Forme juridique définie');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneIdentifiantLegalModifie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.identifiant-legal-modifie', _List_Nil, 'Identifiant légal modifié');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneIntituleChange = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.intitule-change',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fiche',
					$author$project$I18n$Traductions$Chaine(p.zo))
				]),
			'Intitulé de poste modifié · ' + p.zo);
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneLangueModifiee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.langue-modifiee', _List_Nil, 'Langue modifiée');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneNatureInconnue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.nature-inconnue', _List_Nil, 'Événement de la fiche');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneNomModifie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.nom-modifie', _List_Nil, 'Nom modifié');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLignePaysModifie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.pays-modifie', _List_Nil, 'Pays modifié');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLignePersonneEffacee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.personne-effacee', _List_Nil, 'Personne effacée');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLignePosteChange = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.poste-change',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fiche',
					$author$project$I18n$Traductions$Chaine(p.zo))
				]),
			'Poste modifié · ' + p.zo);
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLignePrenomModifie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.prenom-modifie', _List_Nil, 'Prénom modifié');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneQualiteModifiee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.qualite-modifiee', _List_Nil, 'Qualité modifiée');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneRaisonSocialeModifiee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.raison-sociale-modifiee', _List_Nil, 'Raison sociale modifiée');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneRattachementCree = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.rattachement-cree',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fiche',
					$author$project$I18n$Traductions$Chaine(p.zo))
				]),
			'Rattachement créé · ' + p.zo);
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneRattachementTermine = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.rattachement-termine',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fiche',
					$author$project$I18n$Traductions$Chaine(p.zo))
				]),
			'Rattachement terminé · ' + p.zo);
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneRelationCreee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.relation-creee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'relation',
					$author$project$I18n$Traductions$Chaine(p.Ht)),
					_Utils_Tuple2(
					'fiche',
					$author$project$I18n$Traductions$Chaine(p.zo))
				]),
			'Relation ajoutée · ' + (p.Ht + (' ' + p.zo)));
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneRelationCreeeSansDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.relation-creee-sans-detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fiche',
					$author$project$I18n$Traductions$Chaine(p.zo))
				]),
			'Relation ajoutée · ' + p.zo);
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneRelationSupprimee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.relation-supprimee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'relation',
					$author$project$I18n$Traductions$Chaine(p.Ht)),
					_Utils_Tuple2(
					'fiche',
					$author$project$I18n$Traductions$Chaine(p.zo))
				]),
			'Relation supprimée · ' + (p.Ht + (' ' + p.zo)));
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneRelationSupprimeeSansDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.relation-supprimee-sans-detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fiche',
					$author$project$I18n$Traductions$Chaine(p.zo))
				]),
			'Relation supprimée · ' + p.zo);
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneReseauAjoute = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.reseau-ajoute', _List_Nil, 'Réseau ajouté');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneReseauModifie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.reseau-modifie', _List_Nil, 'Réseau modifié');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneResponsableChange = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.responsable-change', _List_Nil, 'Responsable modifié');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneRoleFerme = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.role-ferme',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Rôle ' + (p.bi + ' clos'));
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneRoleFermeAvecResultat = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.role-ferme-avec-resultat',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi)),
					_Utils_Tuple2(
					'resultat',
					$author$project$I18n$Traductions$Chaine(p.HW))
				]),
			'Rôle ' + (p.bi + (' clos · ' + p.HW)));
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneRoleFermeSansDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.role-ferme-sans-detail', _List_Nil, 'Rôle clos');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneRoleOuvert = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.role-ouvert',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Rôle ' + (p.bi + ' ouvert'));
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneSiteWebAjoute = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.site-web-ajoute', _List_Nil, 'Site web ajouté');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneSiteWebModifie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.site-web-modifie', _List_Nil, 'Site web modifié');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneStatutDuRoleChange = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.statut-du-role-change',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi)),
					_Utils_Tuple2(
					'statut',
					$author$project$I18n$Traductions$Chaine(p.ri))
				]),
			'Statut du rôle ' + (p.bi + (' : ' + p.ri)));
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneStatutDuRoleChangeSansDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.statut-du-role-change-sans-detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'statut',
					$author$project$I18n$Traductions$Chaine(p.ri))
				]),
			'Statut du rôle : ' + p.ri);
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneTelephoneAjoute = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.telephone-ajoute', _List_Nil, 'Téléphone ajouté');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneTelephoneModifie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.ligne.telephone-modifie', _List_Nil, 'Téléphone modifié');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneUsageModifie = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.usage-modifie',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'contact',
					$author$project$I18n$Traductions$Chaine(p.v8)),
					_Utils_Tuple2(
					'usage',
					$author$project$I18n$Traductions$Chaine(p.sd))
				]),
			'Usage modifié · ' + (p.v8 + (' : ' + p.sd)));
	});
var $author$project$Components$Referentiel$Fiche$View$phrase = F5(
	function (i18n, fiche, etatDesRoles, offre, fourni) {
		var relationCitee = function (cite) {
			var _v22 = cite.Bl;
			if (!_v22.$) {
				var libelle = _v22.a;
				return $elm$core$Maybe$Just(libelle);
			} else {
				return A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Bl;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (connue) {
								return _Utils_eq(
									$elm$core$Maybe$Just(connue.r8),
									cite.Ht);
							},
							fiche.Hu)));
			}
		};
		var leRoleCite = function (uid) {
			return $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (connu) {
						return _Utils_eq(
							$elm$core$Maybe$Just(connu.r8),
							uid);
					},
					_Utils_ap(fiche.eX, fiche.H7)));
		};
		var typeCite = function (uid) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.r0;
					},
					leRoleCite(uid)));
		};
		var citee = {zo: $author$project$Components$Referentiel$Fiche$Historique$emplacementDeLaFiche};
		var avecLOffre = function (nom) {
			if (!offre.$) {
				var nomDeLOffre = offre.a;
				return A2(
					$author$project$I18n$Cles$referentielRoleLibelle,
					i18n,
					{D1: nomDeLOffre, rX: nom});
			} else {
				return nom;
			}
		};
		var nomDuRoleOuvert = F2(
			function (nom, archetype) {
				return A2(
					$elm$core$Maybe$withDefault,
					avecLOffre(
						A2($author$project$Components$Referentiel$Fiche$View$libelleDArchetype, i18n, archetype)),
					nom);
			});
		var roleCite = function (uid) {
			return A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Bl;
					},
					A2(
						$elm$core$Basics$composeR,
						$author$project$I18n$Cles$texte(i18n),
						avecLOffre)),
				leRoleCite(uid));
		};
		var typeDuRole = function (type_) {
			return A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Bl;
					},
					A2(
						$elm$core$Basics$composeR,
						$author$project$I18n$Cles$texte(i18n),
						avecLOffre)),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (connu) {
							return _Utils_eq(
								$elm$core$Maybe$Just(connu.r0),
								type_);
						},
						_Utils_ap(fiche.eX, fiche.H7))));
		};
		switch (fourni.$) {
			case 0:
				if (fourni.a.$ === 1) {
					var _v1 = fourni.a;
					return $author$project$I18n$Cles$referentielFicheHistoriqueLigneFicheCreee(i18n);
				} else {
					var archetype = fourni.a.a;
					var type_ = fourni.b;
					return A2(
						$author$project$I18n$Cles$referentielFicheHistoriqueLigneFicheCreeeAvecRole,
						i18n,
						{
							bi: A2(
								nomDuRoleOuvert,
								typeDuRole(type_),
								archetype)
						});
				}
			case 1:
				var nom = fourni.a;
				var _v2 = $author$project$Components$Referentiel$Fiche$Model$cleDuContrat(nom);
				if (!_v2.$) {
					switch (_v2.a) {
						case 0:
							var _v3 = _v2.a;
							return $author$project$I18n$Cles$referentielFicheHistoriqueLigneCiviliteModifiee(i18n);
						case 1:
							var _v4 = _v2.a;
							return $author$project$I18n$Cles$referentielFicheHistoriqueLignePrenomModifie(i18n);
						case 2:
							var _v5 = _v2.a;
							return $author$project$I18n$Cles$referentielFicheHistoriqueLigneNomModifie(i18n);
						case 3:
							var _v6 = _v2.a;
							return $author$project$I18n$Cles$referentielFicheHistoriqueLigneRaisonSocialeModifiee(i18n);
						case 4:
							var _v7 = _v2.a;
							return $author$project$I18n$Cles$referentielFicheHistoriqueLigneQualiteModifiee(i18n);
						case 5:
							var _v8 = _v2.a;
							return $author$project$I18n$Cles$referentielFicheHistoriqueLignePaysModifie(i18n);
						case 6:
							var _v9 = _v2.a;
							return $author$project$I18n$Cles$referentielFicheHistoriqueLigneLangueModifiee(i18n);
						default:
							var _v10 = _v2.a;
							return $author$project$I18n$Cles$referentielFicheHistoriqueLigneIdentifiantLegalModifie(i18n);
					}
				} else {
					return $author$project$I18n$Cles$referentielFicheHistoriqueLigneChampModifie(i18n);
				}
			case 2:
				var canal = fourni.a;
				switch (canal) {
					case 'Email':
						return $author$project$I18n$Cles$referentielFicheHistoriqueLigneEmailAjoute(i18n);
					case 'Telephone':
						return $author$project$I18n$Cles$referentielFicheHistoriqueLigneTelephoneAjoute(i18n);
					case 'Adresse':
						return $author$project$I18n$Cles$referentielFicheHistoriqueLigneAdresseAjoutee(i18n);
					case 'SiteWeb':
						return $author$project$I18n$Cles$referentielFicheHistoriqueLigneSiteWebAjoute(i18n);
					case 'Reseau':
						return $author$project$I18n$Cles$referentielFicheHistoriqueLigneReseauAjoute(i18n);
					default:
						return canal;
				}
			case 3:
				var canal = fourni.a;
				switch (canal) {
					case 'Email':
						return $author$project$I18n$Cles$referentielFicheHistoriqueLigneEmailModifie(i18n);
					case 'Telephone':
						return $author$project$I18n$Cles$referentielFicheHistoriqueLigneTelephoneModifie(i18n);
					case 'Adresse':
						return $author$project$I18n$Cles$referentielFicheHistoriqueLigneAdresseModifiee(i18n);
					case 'SiteWeb':
						return $author$project$I18n$Cles$referentielFicheHistoriqueLigneSiteWebModifie(i18n);
					case 'Reseau':
						return $author$project$I18n$Cles$referentielFicheHistoriqueLigneReseauModifie(i18n);
					default:
						return canal;
				}
			case 4:
				var uid = fourni.a;
				var usage = fourni.b;
				return A2(
					$author$project$I18n$Cles$referentielFicheHistoriqueLigneUsageModifie,
					i18n,
					{
						v8: A3($author$project$Components$Referentiel$Fiche$View$nomDuContact, i18n, fiche, uid),
						sd: A2($author$project$Components$Referentiel$Fiche$View$libelleDUsage, i18n, usage)
					});
			case 5:
				var uid = fourni.a;
				return A2(
					$author$project$I18n$Cles$referentielFicheHistoriqueLigneContactPrincipal,
					i18n,
					{
						v8: A3($author$project$Components$Referentiel$Fiche$View$nomDuContact, i18n, fiche, uid)
					});
			case 6:
				var uid = fourni.a;
				var statut = fourni.b;
				switch (statut) {
					case 'Invalide':
						return A2(
							$author$project$I18n$Cles$referentielFicheHistoriqueLigneContactInvalide,
							i18n,
							{
								v8: A3($author$project$Components$Referentiel$Fiche$View$nomDuContact, i18n, fiche, uid)
							});
					case 'Ancien':
						return A2(
							$author$project$I18n$Cles$referentielFicheHistoriqueLigneContactAncien,
							i18n,
							{
								v8: A3($author$project$Components$Referentiel$Fiche$View$nomDuContact, i18n, fiche, uid)
							});
					default:
						return A2(
							$author$project$I18n$Cles$referentielFicheHistoriqueLigneContactReactive,
							i18n,
							{
								v8: A3($author$project$Components$Referentiel$Fiche$View$nomDuContact, i18n, fiche, uid)
							});
				}
			case 7:
				if (fourni.b) {
					var uid = fourni.a;
					return A2(
						$author$project$I18n$Cles$referentielFicheHistoriqueLigneConsentementDonne,
						i18n,
						{
							v8: A3($author$project$Components$Referentiel$Fiche$View$nomDuContact, i18n, fiche, uid)
						});
				} else {
					var uid = fourni.a;
					return A2(
						$author$project$I18n$Cles$referentielFicheHistoriqueLigneConsentementRetire,
						i18n,
						{
							v8: A3($author$project$Components$Referentiel$Fiche$View$nomDuContact, i18n, fiche, uid)
						});
				}
			case 8:
				var archetype = fourni.a;
				var uid = fourni.b;
				return A2(
					$author$project$I18n$Cles$referentielFicheHistoriqueLigneRoleOuvert,
					i18n,
					{
						bi: A2(
							nomDuRoleOuvert,
							roleCite(uid),
							archetype)
					});
			case 9:
				var uid = fourni.a;
				var resultat = fourni.b;
				var _v14 = _Utils_Tuple2(
					roleCite(uid),
					resultat);
				if (!_v14.a.$) {
					if (!_v14.b.$) {
						var nomDuRole = _v14.a.a;
						var code = _v14.b.a;
						return A2(
							$author$project$I18n$Cles$referentielFicheHistoriqueLigneRoleFermeAvecResultat,
							i18n,
							{
								HW: A4(
									$author$project$Components$Referentiel$Fiche$Roles$nomDuResultat,
									i18n,
									typeCite(uid),
									etatDesRoles,
									code),
								bi: nomDuRole
							});
					} else {
						var nomDuRole = _v14.a.a;
						var _v15 = _v14.b;
						return A2(
							$author$project$I18n$Cles$referentielFicheHistoriqueLigneRoleFerme,
							i18n,
							{bi: nomDuRole});
					}
				} else {
					var _v16 = _v14.a;
					return $author$project$I18n$Cles$referentielFicheHistoriqueLigneRoleFermeSansDetail(i18n);
				}
			case 10:
				var uid = fourni.a;
				var _v17 = roleCite(uid);
				if (!_v17.$) {
					var nomDuRole = _v17.a;
					return A2(
						$author$project$I18n$Cles$referentielFicheHistoriqueLigneFinDuRoleModifiee,
						i18n,
						{bi: nomDuRole});
				} else {
					return $author$project$I18n$Cles$referentielFicheHistoriqueLigneFinDuRoleModifieeSansDetail(i18n);
				}
			case 11:
				var uid = fourni.a;
				var code = fourni.b;
				var _v18 = roleCite(uid);
				if (!_v18.$) {
					var nomDuRole = _v18.a;
					return A2(
						$author$project$I18n$Cles$referentielFicheHistoriqueLigneStatutDuRoleChange,
						i18n,
						{
							bi: nomDuRole,
							ri: A4(
								$author$project$Components$Referentiel$Fiche$Roles$nomDuStatut,
								i18n,
								typeCite(uid),
								etatDesRoles,
								code)
						});
				} else {
					return A2(
						$author$project$I18n$Cles$referentielFicheHistoriqueLigneStatutDuRoleChangeSansDetail,
						i18n,
						{
							ri: A4(
								$author$project$Components$Referentiel$Fiche$Roles$nomDuStatut,
								i18n,
								typeCite(uid),
								etatDesRoles,
								code)
						});
				}
			case 12:
				return A2($author$project$I18n$Cles$referentielFicheHistoriqueLigneDoublonEcarte, i18n, citee);
			case 13:
				return A2($author$project$I18n$Cles$referentielFicheHistoriqueLigneRattachementCree, i18n, citee);
			case 14:
				return A2($author$project$I18n$Cles$referentielFicheHistoriqueLigneRattachementTermine, i18n, citee);
			case 15:
				return A2($author$project$I18n$Cles$referentielFicheHistoriqueLigneFinDuRattachementModifiee, i18n, citee);
			case 16:
				return A2($author$project$I18n$Cles$referentielFicheHistoriqueLignePosteChange, i18n, citee);
			case 17:
				return A2($author$project$I18n$Cles$referentielFicheHistoriqueLigneIntituleChange, i18n, citee);
			case 18:
				return A2($author$project$I18n$Cles$referentielFicheHistoriqueLigneContactPrincipalDesigne, i18n, citee);
			case 19:
				return A2($author$project$I18n$Cles$referentielFicheHistoriqueLigneContactPrincipalRetire, i18n, citee);
			case 20:
				var cite = fourni.a;
				var _v19 = relationCitee(cite);
				if (!_v19.$) {
					var libelle = _v19.a;
					return A2(
						$author$project$I18n$Cles$referentielFicheHistoriqueLigneRelationCreee,
						i18n,
						{zo: $author$project$Components$Referentiel$Fiche$Historique$emplacementDeLaFiche, Ht: libelle});
				} else {
					return A2($author$project$I18n$Cles$referentielFicheHistoriqueLigneRelationCreeeSansDetail, i18n, citee);
				}
			case 21:
				var cite = fourni.a;
				var _v20 = relationCitee(cite);
				if (!_v20.$) {
					var libelle = _v20.a;
					return A2(
						$author$project$I18n$Cles$referentielFicheHistoriqueLigneRelationSupprimee,
						i18n,
						{zo: $author$project$Components$Referentiel$Fiche$Historique$emplacementDeLaFiche, Ht: libelle});
				} else {
					return A2($author$project$I18n$Cles$referentielFicheHistoriqueLigneRelationSupprimeeSansDetail, i18n, citee);
				}
			case 22:
				return $author$project$I18n$Cles$referentielFicheHistoriqueLigneResponsableChange(i18n);
			case 23:
				return $author$project$I18n$Cles$referentielFicheHistoriqueLigneFormeDefinie(i18n);
			case 24:
				return $author$project$I18n$Cles$referentielFicheHistoriqueLigneFicheClose(i18n);
			case 25:
				return $author$project$I18n$Cles$referentielFicheHistoriqueLigneFicheRouverte(i18n);
			case 26:
				return $author$project$I18n$Cles$referentielFicheHistoriqueLigneFicheSupprimee(i18n);
			case 27:
				return $author$project$I18n$Cles$referentielFicheHistoriqueLigneFicheRestauree(i18n);
			case 28:
				return $author$project$I18n$Cles$referentielFicheHistoriqueLigneEffacementProgramme(i18n);
			case 29:
				return $author$project$I18n$Cles$referentielFicheHistoriqueLigneEffacementAnnule(i18n);
			case 30:
				return $author$project$I18n$Cles$referentielFicheHistoriqueLignePersonneEffacee(i18n);
			case 31:
				var uid = fourni.a;
				return A2(
					$author$project$I18n$Cles$referentielFicheHistoriqueLigneContactEfface,
					i18n,
					{
						v8: A2(
							$elm$core$Maybe$withDefault,
							$author$project$I18n$Cles$referentielFicheContacts(i18n),
							A2(
								$elm$core$Maybe$map,
								A2($author$project$Components$Referentiel$Fiche$View$nomDuContact, i18n, fiche),
								uid))
					});
			case 32:
				return $author$project$I18n$Cles$referentielFicheHistoriqueLigneAncienneVersionSupprimee(i18n);
			case 33:
				return $author$project$I18n$Cles$referentielFicheHistoriqueLigneDonneesExportees(i18n);
			case 34:
				return $author$project$I18n$Cles$referentielFicheHistoriqueLigneEmpreinteLeveeSurDemande(i18n);
			case 35:
				return $author$project$I18n$Cles$referentielFicheHistoriqueLigneClasseExpiree(i18n);
			default:
				return $author$project$I18n$Cles$referentielFicheHistoriqueLigneNatureInconnue(i18n);
		}
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueLigneChampDuTypeModifie = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.ligne.champ-du-type-modifie',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'Champ « ' + (p.uN + ' » modifié'));
	});
var $author$project$Components$Referentiel$Fiche$View$phraseDeLaLigne = F4(
	function (i18n, fiche, etatDesRoles, ligne) {
		var _v0 = ligne.yT;
		if (_v0.$ === 1) {
			var nom = _v0.a;
			if (_Utils_eq(
				$author$project$Components$Referentiel$Fiche$Model$cleDuContrat(nom),
				$elm$core$Maybe$Nothing)) {
				var _v1 = ligne.uP;
				if (!_v1.$) {
					var cite = _v1.a;
					return A2(
						$author$project$I18n$Cles$referentielFicheHistoriqueLigneChampDuTypeModifie,
						i18n,
						{uN: cite.Bl});
				} else {
					return $author$project$I18n$Cles$referentielFicheHistoriqueLigneChampModifie(i18n);
				}
			} else {
				return A5(
					$author$project$Components$Referentiel$Fiche$View$phrase,
					i18n,
					fiche,
					etatDesRoles,
					A2(
						$elm$core$Maybe$map,
						$author$project$I18n$Cles$texte(i18n),
						ligne.D1),
					ligne.yT);
			}
		} else {
			return A5(
				$author$project$Components$Referentiel$Fiche$View$phrase,
				i18n,
				fiche,
				etatDesRoles,
				A2(
					$elm$core$Maybe$map,
					$author$project$I18n$Cles$texte(i18n),
					ligne.D1),
				ligne.yT);
		}
	});
var $author$project$I18n$Cles$referentielQualiteParticulier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.qualite.particulier', _List_Nil, 'Particulier');
};
var $author$project$I18n$Cles$referentielQualiteProfessionnel = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.qualite.professionnel', _List_Nil, 'Professionnel');
};
var $author$project$Components$Referentiel$Fiche$View$affichee = F4(
	function (i18n, normes, cle, valeur) {
		var _v0 = _Utils_Tuple2(cle, valeur);
		_v0$5:
		while (true) {
			switch (_v0.a) {
				case 0:
					var _v1 = _v0.a;
					var code = _v0.b;
					return A2(
						$author$project$I18n$Cles$texte,
						i18n,
						$author$project$Referentiel$Civilites$nom(code));
				case 4:
					switch (_v0.b) {
						case 'Particulier':
							var _v2 = _v0.a;
							return $author$project$I18n$Cles$referentielQualiteParticulier(i18n);
						case 'Professionnel':
							var _v3 = _v0.a;
							return $author$project$I18n$Cles$referentielQualiteProfessionnel(i18n);
						default:
							break _v0$5;
					}
				case 5:
					var _v4 = _v0.a;
					var code = _v0.b;
					return A2($author$project$Referentiel$Normes$nomDePays, normes, code);
				case 6:
					var _v5 = _v0.a;
					var code = _v0.b;
					return A2($author$project$Referentiel$Langues$nom, i18n, code);
				default:
					break _v0$5;
			}
		}
		return valeur;
	});
var $author$project$Components$Referentiel$Fiche$Historique$adresse = A6(
	$elm$json$Json$Decode$map5,
	F5(
		function (lignes, codePostal, localite, region, pays) {
			return A2(
				$elm$core$String$join,
				', ',
				A2(
					$elm$core$List$filter,
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
					_List_fromArray(
						[
							A2($elm$core$String$join, ', ', lignes),
							A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$filter,
								A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
								_List_fromArray(
									[codePostal, localite]))),
							region,
							pays
						])));
		}),
	A2(
		$elm$json$Json$Decode$field,
		'lignes',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'codePostal', $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$succeed('')
			])),
	A2($elm$json$Json$Decode$field, 'localite', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'region', $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$succeed('')
			])),
	A2($elm$json$Json$Decode$field, 'pays', $elm$json$Json$Decode$string));
var $author$project$I18n$Cles$referentielFicheResumeNon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.non', _List_Nil, 'non');
};
var $author$project$I18n$Cles$referentielFicheResumeOui = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.oui', _List_Nil, 'oui');
};
var $author$project$Components$Referentiel$Fiche$Historique$lisible = F2(
	function (i18n, texte) {
		var simple = $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$elm$json$Json$Decode$string,
					A2(
					$elm$json$Json$Decode$map,
					function (vrai) {
						return vrai ? $author$project$I18n$Cles$referentielFicheResumeOui(i18n) : $author$project$I18n$Cles$referentielFicheResumeNon(i18n);
					},
					$elm$json$Json$Decode$bool),
					A2($elm$json$Json$Decode$map, $elm$core$String$fromFloat, $elm$json$Json$Decode$float)
				]));
		return A2(
			$elm$core$Result$withDefault,
			texte,
			A2(
				$elm$json$Json$Decode$decodeString,
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							simple,
							A2(
							$elm$json$Json$Decode$map,
							$elm$core$String$join(', '),
							$elm$json$Json$Decode$list(simple)),
							$author$project$Components$Referentiel$Fiche$Historique$adresse
						])),
				texte));
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueValeurEffacee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.valeur.effacee', _List_Nil, 'Donnée effacée');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueValeurExpiree = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.valeur.expiree', _List_Nil, 'Donnée expirée');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueValeurVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.valeur.vide', _List_Nil, '(vide)');
};
var $author$project$I18n$Cles$referentielLienSansNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.lien.sans-nom', _List_Nil, 'Nom non visible');
};
var $author$project$Components$Referentiel$Fiche$Historique$libelleDeLaValeur = F2(
	function (i18n, valeur) {
		switch (valeur.$) {
			case 0:
				return $author$project$I18n$Cles$referentielFicheHistoriqueValeurVide(i18n);
			case 1:
				var texte = valeur.a;
				return A2($author$project$Components$Referentiel$Fiche$Historique$lisible, i18n, texte);
			case 2:
				return $author$project$I18n$Cles$referentielFicheHistoriqueValeurEffacee(i18n);
			case 3:
				return $author$project$I18n$Cles$referentielFicheHistoriqueValeurExpiree(i18n);
			default:
				var noms = valeur.a;
				return A2(
					$elm$core$String$join,
					', ',
					A2(
						$elm$core$List$map,
						$elm$core$Maybe$withDefault(
							$author$project$I18n$Cles$referentielLienSansNom(i18n)),
						noms));
		}
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueValeurIndisponible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.valeur.indisponible', _List_Nil, 'Valeur indisponible');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueValeurs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.valeurs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'avant',
					$author$project$I18n$Traductions$Chaine(p.je)),
					_Utils_Tuple2(
					'apres',
					$author$project$I18n$Traductions$Chaine(p.iY))
				]),
			p.je + (' → ' + p.iY));
	});
var $author$project$Components$Referentiel$Fiche$View$valeurs = F3(
	function (i18n, normes, ligne) {
		var lisible = function (valeur) {
			var _v2 = _Utils_Tuple2(
				valeur,
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Dj;
						},
						$author$project$Components$Referentiel$Fiche$Model$cleDuContrat),
					ligne.uN));
			if ((_v2.a.$ === 1) && (!_v2.b.$)) {
				var code = _v2.a.a;
				var cle = _v2.b.a;
				return A4($author$project$Components$Referentiel$Fiche$View$affichee, i18n, normes, cle, code);
			} else {
				return A2($author$project$Components$Referentiel$Fiche$Historique$libelleDeLaValeur, i18n, valeur);
			}
		};
		var _v0 = ligne.Ki;
		switch (_v0.$) {
			case 0:
				return $elm$core$Maybe$Nothing;
			case 1:
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$referentielFicheHistoriqueValeurIndisponible(i18n));
			default:
				if (_v0.a.$ === 1) {
					var _v1 = _v0.a;
					var apres = _v0.b;
					return $elm$core$Maybe$Just(
						lisible(apres));
				} else {
					var avant = _v0.a.a;
					var apres = _v0.b;
					return $elm$core$Maybe$Just(
						A2(
							$author$project$I18n$Cles$referentielFicheHistoriqueValeurs,
							i18n,
							{
								iY: lisible(apres),
								je: lisible(avant)
							}));
				}
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$HistoriqueDuChampDemande = F2(
	function (a, b) {
		return {$: 92, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$View$idDuDeclencheur = F2(
	function (ou, nomDuChamp) {
		return 'historique-' + (ou + ('-' + A3($elm$core$String$replace, '.', '-', nomDuChamp)));
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueChampDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.champ.de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'Historique du champ : ' + p.uN);
	});
var $author$project$Components$Referentiel$Fiche$View$versLHistoriqueDuChamp = F5(
	function (i18n, fiche, ou, nomDuChamp, libelle) {
		return _Utils_eq(fiche.Ak, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						A2($author$project$Components$Referentiel$Fiche$View$idDuDeclencheur, ou, nomDuChamp)),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('button-icon'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('historique-du-champ'),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-label',
						A2(
							$author$project$I18n$Cles$referentielFicheHistoriqueChampDe,
							i18n,
							{uN: libelle})),
						$rtfeldman$elm_css$Html$Styled$Attributes$title(
						A2(
							$author$project$I18n$Cles$referentielFicheHistoriqueChampDe,
							i18n,
							{uN: libelle})),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						A2(
							$author$project$Components$Referentiel$Fiche$Update$HistoriqueDuChampDemande,
							nomDuChamp,
							A2($author$project$Components$Referentiel$Fiche$View$idDuDeclencheur, ou, nomDuChamp)))
					]),
				_List_fromArray(
					[$author$project$Components$Shared$Svg$svgHistory]))
			]);
	});
var $author$project$Components$Referentiel$Fiche$View$evenement = F7(
	function (i18n, normes, avecLaSource, fiche, etatDesRoles, ou, ligne) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('evenement')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('quand')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$I18n$Cles$texte, i18n, ligne.hz))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('par'),
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'retire',
										$author$project$Components$Referentiel$Fiche$Historique$estRetire(ligne.t1))
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								avecLaSource ? A3($author$project$Components$Referentiel$Fiche$View$par, i18n, ligne.t1, ligne.IR) : A2($author$project$Components$Referentiel$Fiche$Historique$libelleDeLAuteur, i18n, ligne.t1))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('phrase')
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								A3(
									$author$project$Components$Referentiel$Fiche$View$avecLaFicheCitee,
									i18n,
									ligne.zp,
									A4($author$project$Components$Referentiel$Fiche$View$phraseDeLaLigne, i18n, fiche, etatDesRoles, ligne))),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (lues) {
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('valeurs')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(lues)
													]))
											]);
									},
									A3($author$project$Components$Referentiel$Fiche$View$valeurs, i18n, normes, ligne))))),
						A2($author$project$Components$Referentiel$Fiche$View$champDuTypeCite, i18n, ligne)
					]),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (touche) {
							return A5(
								$author$project$Components$Referentiel$Fiche$View$versLHistoriqueDuChamp,
								i18n,
								fiche,
								ou,
								touche.Dj,
								A4($author$project$Components$Referentiel$Fiche$View$phraseDeLaLigne, i18n, fiche, etatDesRoles, ligne));
						},
						ligne.uN))));
	});
var $author$project$Components$Referentiel$Fiche$View$ouDeLaLigne = F2(
	function (ou, rang) {
		return ou + ('-' + $elm$core$String$fromInt(rang));
	});
var $author$project$Components$Referentiel$Fiche$Historique$recentes = function (etat) {
	return A2($elm$core$List$take, 5, etat.gV);
};
var $author$project$I18n$Cles$referentielFicheAucunEvenement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.aucun-evenement', _List_Nil, 'Aucun événement');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueToutLHistorique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.tout-l-historique', _List_Nil, 'Tout l\'historique');
};
var $author$project$I18n$Cles$referentielFicheResumeActiviteRecente = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.activite-recente', _List_Nil, 'Activité récente');
};
var $author$project$Components$Referentiel$Fiche$View$chronologieDuResume = F3(
	function (i18n, fiche, model) {
		return A2(
			$author$project$Components$Shared$Page$View$section,
			$author$project$Components$Referentiel$Fiche$View$ancre('activite'),
			{
				fw: _List_Nil,
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('evenements')
							]),
						A2(
							$elm$core$List$indexedMap,
							function (rang) {
								return A6(
									$author$project$Components$Referentiel$Fiche$View$evenement,
									i18n,
									model.hd,
									false,
									fiche,
									model.bi,
									A2($author$project$Components$Referentiel$Fiche$View$ouDeLaLigne, 'resume-chronologie', rang));
							},
							$author$project$Components$Referentiel$Fiche$Historique$recentes(model.m6))),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$List$isEmpty(model.m6.gV) ? $author$project$I18n$Cles$referentielFicheAucunEvenement(i18n) : '')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('tout-l-historique'),
								$rtfeldman$elm_css$Html$Styled$Attributes$href(
								$author$project$Routes$Route$toString(
									A2($author$project$Routes$Route$Fiche, fiche.r8, 3)))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielFicheHistoriqueToutLHistorique(i18n))
							]))
					]),
				Dj: 'chronologie',
				h6: $author$project$I18n$Cles$referentielFicheResumeActiviteRecente(i18n)
			});
	});
var $author$project$Components$Referentiel$Fiche$Update$LiaisonValidee = {$: 56};
var $author$project$I18n$Cles$referentielRattachementPrincipalConfirmationConfirmer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.principal.confirmation.confirmer', _List_Nil, 'Confirmer');
};
var $author$project$I18n$Cles$referentielRattachementPrincipalConfirmationMessage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.rattachement.principal.confirmation.message',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.Dj + ' ne sera plus le contact principal de l\'organisation.');
	});
var $author$project$I18n$Cles$referentielRattachementPrincipalConfirmationMessageSansNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.principal.confirmation.message.sans-nom', _List_Nil, 'Cette organisation a déjà un contact principal. Le remplacer ?');
};
var $author$project$I18n$Cles$referentielRattachementPrincipalConfirmationTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.principal.confirmation.titre', _List_Nil, 'Changer de contact principal ?');
};
var $author$project$I18n$Cles$referentielRelationSupprimer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.relation.supprimer', _List_Nil, 'Supprimer');
};
var $author$project$I18n$Cles$referentielRelationSupprimerMessage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.relation.supprimer.message',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.Bl + (' ' + p.Dj));
	});
var $author$project$I18n$Cles$referentielRelationSupprimerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.relation.supprimer.titre', _List_Nil, 'Supprimer la relation ?');
};
var $author$project$Components$Referentiel$Fiche$View$confirmationDeLiaison = F2(
	function (i18n, model) {
		var racineDeLaBoite = $author$project$Components$Referentiel$Fiche$Liaisons$idDeLaBoite(model.Bk);
		var ouverte = !_Utils_eq(
			$author$project$Components$Referentiel$Fiche$Liaisons$declencheurDeLaConfirmation(model.Bk),
			$elm$core$Maybe$Nothing);
		var dite = function () {
			var _v0 = model.Bk.mW;
			if (_v0.$ === 2) {
				var lien = _v0.a;
				return {
					j7: $author$project$I18n$Cles$referentielRelationSupprimer(i18n),
					Cs: A2(
						$author$project$I18n$Cles$referentielRelationSupprimerMessage,
						i18n,
						{
							Bl: lien.Bl,
							Dj: A2($author$project$I18n$Cles$texte, i18n, lien.Dj)
						}),
					h6: $author$project$I18n$Cles$referentielRelationSupprimerTitre(i18n)
				};
			} else {
				var _v1 = model.Bk.j6;
				if (_v1.$ === 1) {
					var enPlace = _v1.a;
					return {
						j7: $author$project$I18n$Cles$referentielRattachementPrincipalConfirmationConfirmer(i18n),
						Cs: function () {
							if (!enPlace.$) {
								var nom = enPlace.a;
								return A2(
									$author$project$I18n$Cles$referentielRattachementPrincipalConfirmationMessage,
									i18n,
									{
										Dj: A2($author$project$I18n$Cles$texte, i18n, nom)
									});
							} else {
								return $author$project$I18n$Cles$referentielRattachementPrincipalConfirmationMessageSansNom(i18n);
							}
						}(),
						h6: $author$project$I18n$Cles$referentielRattachementPrincipalConfirmationTitre(i18n)
					};
				} else {
					return {j7: '', Cs: '', h6: ''};
				}
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('opened', ouverte)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('overlay'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Fiche$Update$ConfirmationAnnulee)
						]),
					_List_Nil),
					A2(
					$author$project$Components$Shared$Confirmation$View$view,
					i18n,
					{
						vl: $elm$json$Json$Decode$fail(''),
						j7: {Aq: racineDeLaBoite + '-confirmer', Bl: dite.j7, C$: $author$project$Components$Referentiel$Fiche$Update$LiaisonValidee},
						Aq: racineDeLaBoite,
						As: racineDeLaBoite + '-message',
						At: racineDeLaBoite + '-titre',
						Cs: dite.Cs,
						Et: ouverte,
						HG: {
							Aq: $author$project$Components$Referentiel$Fiche$Liaisons$idDuRenoncement(model.Bk),
							Bl: $author$project$I18n$Cles$drawerAnnuler(i18n),
							C$: $author$project$Components$Referentiel$Fiche$Update$ConfirmationAnnulee
						},
						h6: dite.h6,
						sl: 0
					})
				]));
	});
var $author$project$Components$Referentiel$Fiche$Update$RechargementDemande = {$: 19};
var $author$project$I18n$Cles$referentielFicheConflitMessage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.conflit.message', _List_Nil, 'Cette fiche a été modifiée.');
};
var $author$project$I18n$Cles$referentielFicheConflitRecharger = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.conflit.recharger', _List_Nil, 'Recharger');
};
var $author$project$Components$Referentiel$Fiche$View$conflit = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('conflit')
				]),
			model.fX ? _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Note$View$view,
					1,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielFicheConflitMessage(i18n))
								])),
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Fiche$Update$RechargementDemande)
								]),
							$author$project$I18n$Cles$referentielFicheConflitRecharger(i18n))
						]))
				]) : _List_Nil);
	});
var $author$project$Components$Referentiel$Fiche$Update$AjoutDeContactDemande = {$: 20};
var $author$project$Components$Referentiel$Fiche$Update$AnciensBascules = {$: 33};
var $author$project$Components$Referentiel$Fiche$Resume$Contacts = 0;
var $author$project$Components$Referentiel$Fiche$Resume$limite = 5;
var $author$project$Components$Referentiel$Fiche$Resume$borner = F2(
	function (depliee, lignes) {
		var total = $elm$core$List$length(lignes);
		return (depliee || (_Utils_cmp(total, $author$project$Components$Referentiel$Fiche$Resume$limite) < 1)) ? {t7: 0, g0: lignes, JE: total} : {
			t7: total - $author$project$Components$Referentiel$Fiche$Resume$limite,
			g0: A2($elm$core$List$take, $author$project$Components$Referentiel$Fiche$Resume$limite, lignes),
			JE: total
		};
	});
var $author$project$Components$Referentiel$Fiche$Resume$estDepliee = F2(
	function (liste, depliees) {
		switch (liste) {
			case 0:
				return depliees.wa;
			case 1:
				return depliees.GY;
			default:
				return depliees.Hu;
		}
	});
var $author$project$I18n$Cles$referentielFicheContactGroupeDeLOrganisation = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.contact.groupe-de-l-organisation',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'usage',
					$author$project$I18n$Traductions$Chaine(p.sd)),
					_Utils_Tuple2(
					'organisation',
					$author$project$I18n$Traductions$Chaine(p.En))
				]),
			p.sd + (' · ' + p.En));
	});
var $author$project$Components$Referentiel$Fiche$Contacts$groupes = F2(
	function (i18n, contacts) {
		var uneFois = F2(
			function (valeur, vus) {
				return A2($elm$core$List$member, valeur, vus) ? vus : _Utils_ap(
					vus,
					_List_fromArray(
						[valeur]));
			});
		var titre = function (contact) {
			var _v0 = contact.En;
			if (!_v0.$) {
				var organisation = _v0.a;
				return A2(
					$author$project$I18n$Cles$referentielFicheContactGroupeDeLOrganisation,
					i18n,
					{
						En: A2($author$project$I18n$Cles$texte, i18n, organisation),
						sd: A2($author$project$I18n$Cles$texte, i18n, contact.sd)
					});
			} else {
				return A2($author$project$I18n$Cles$texte, i18n, contact.sd);
			}
		};
		var enService = A2(
			$elm$core$List$filter,
			function (contact) {
				return contact.ri !== 2;
			},
			contacts);
		return {
			iO: A2(
				$elm$core$List$filter,
				function (contact) {
					return contact.ri === 2;
				},
				contacts),
			o3: A3(
				$elm$core$List$foldl,
				uneFois,
				_List_Nil,
				A2(
					$elm$core$List$filterMap,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.En;
						},
						$elm$core$Maybe$map(
							$author$project$I18n$Cles$texte(i18n))),
					enService)),
			o8: A2(
				$elm$core$List$map,
				function (voulu) {
					return _Utils_Tuple2(
						voulu,
						A2(
							$elm$core$List$filter,
							function (contact) {
								return _Utils_eq(
									titre(contact),
									voulu);
							},
							enService));
				},
				A3(
					$elm$core$List$foldl,
					A2($elm$core$Basics$composeR, titre, uneFois),
					_List_Nil,
					enService))
		};
	});
var $author$project$Components$Referentiel$Fiche$Update$ListeBasculee = function (a) {
	return {$: 129, a: a};
};
var $author$project$I18n$Cles$referentielFicheResumeNSurTotal = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.resume.n-sur-total',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			p.d + (' sur ' + p.JE));
	});
var $author$project$I18n$Cles$referentielFicheResumeReplier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.replier', _List_Nil, 'Replier');
};
var $author$project$I18n$Cles$referentielFicheResumeVoirLAutre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.voir-l-autre', _List_Nil, 'Voir l\'autre');
};
var $author$project$I18n$Cles$referentielFicheResumeVoirLesAutres = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.resume.voir-les-autres',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			'Voir les ' + (p.d + ' autres'));
	});
var $author$project$Components$Referentiel$Fiche$View$pied = F4(
	function (i18n, liste, bornes, depliee) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pied-de-liste')
				]),
			(_Utils_cmp(bornes.JE, $author$project$Components$Referentiel$Fiche$Resume$limite) < 1) ? _List_Nil : _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$referentielFicheResumeNSurTotal,
								i18n,
								{
									d: $elm$core$String$fromInt(
										$elm$core$List$length(bornes.g0)),
									JE: $elm$core$String$fromInt(bornes.JE)
								}))
						])),
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('voir-plus'),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-expanded',
							depliee ? 'true' : 'false'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Referentiel$Fiche$Update$ListeBasculee(liste))
						]),
					depliee ? $author$project$I18n$Cles$referentielFicheResumeReplier(i18n) : ((bornes.t7 === 1) ? $author$project$I18n$Cles$referentielFicheResumeVoirLAutre(i18n) : A2(
						$author$project$I18n$Cles$referentielFicheResumeVoirLesAutres,
						i18n,
						{
							d: $elm$core$String$fromInt(bornes.t7)
						})))
				]));
	});
var $author$project$I18n$Cles$referentielFicheAucunContact = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.aucun-contact', _List_Nil, 'Aucun moyen de contact');
};
var $author$project$I18n$Cles$referentielFicheContactAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.contact.ajouter', _List_Nil, 'Ajouter');
};
var $author$project$I18n$Cles$referentielFicheContactAnciens = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.contact.anciens', _List_Nil, 'Anciens');
};
var $author$project$I18n$Cles$referentielFicheContactNoteDeLOrganisation = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.contact.note-de-l-organisation',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'organisation',
					$author$project$I18n$Traductions$Chaine(p.En))
				]),
			'Un dossier ou un échange qui concerne ' + (p.En + ' utilise ses contacts professionnels.'));
	});
var $author$project$I18n$Cles$referentielFicheResumeContacts = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.contacts', _List_Nil, 'Contacts');
};
var $author$project$Components$Referentiel$Fiche$Update$MenuDeContactBascule = function (a) {
	return {$: 29, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$ModificationDeContactDemandee = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$PrincipalDemande = function (a) {
	return {$: 30, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$ProspectionDemandee = F2(
	function (a, b) {
		return {$: 32, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Update$StatutDemande = F2(
	function (a, b) {
		return {$: 31, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Update$EffacerUnContactDemande = function (a) {
	return {$: 101, a: a};
};
var $author$project$I18n$Cles$referentielFicheContactEffacerBouton = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.contact.effacer-bouton', _List_Nil, 'Effacer ce contact');
};
var $author$project$Components$Referentiel$Fiche$View$effacerLeContact = F2(
	function (i18n, fourni) {
		var _v0 = fourni.lM;
		if (!_v0.$) {
			return _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Components$Referentiel$Fiche$Effacement$idDuDeclencheurDuContact(fourni.r8),
					A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id(
								$author$project$Components$Referentiel$Fiche$Effacement$idDuDeclencheurDuContact(fourni.r8)),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('effacer-le-contact'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Referentiel$Fiche$Update$EffacerUnContactDemande(fourni.r8))
							]),
						$author$project$I18n$Cles$referentielFicheContactEffacerBouton(i18n)))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$I18n$Cles$referentielFicheContactAccepterLaProspection = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.contact.accepter-la-prospection', _List_Nil, 'Accepter la prospection');
};
var $author$project$I18n$Cles$referentielFicheContactExclureDeLaProspection = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.contact.exclure-de-la-prospection', _List_Nil, 'Exclure de la prospection');
};
var $author$project$I18n$Cles$referentielFicheContactMarquerInvalide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.contact.marquer-invalide', _List_Nil, 'Marquer invalide');
};
var $author$project$I18n$Cles$referentielFicheContactModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.contact.modifier', _List_Nil, 'Modifier');
};
var $author$project$I18n$Cles$referentielFicheContactPasserEnAncien = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.contact.passer-en-ancien', _List_Nil, 'Passer en ancien');
};
var $author$project$I18n$Cles$referentielFicheContactReactiver = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.contact.reactiver', _List_Nil, 'Réactiver');
};
var $author$project$I18n$Cles$referentielFicheContactRendrePrincipal = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.contact.rendre-principal', _List_Nil, 'Rendre principal');
};
var $author$project$Components$Referentiel$Fiche$View$gestesDeContact = F2(
	function (i18n, fourni) {
		var entree = F4(
			function (lien, classe, msg, libelle) {
				return A2(
					$elm$core$Maybe$map,
					function (_v1) {
						return _Utils_Tuple2(
							'fiche-contact-geste-' + classe,
							A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('fiche-contact-geste-' + classe),
										$rtfeldman$elm_css$Html$Styled$Attributes$class(classe),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
									]),
								libelle));
					},
					lien);
			});
		var reactiver = A4(
			entree,
			fourni.B6,
			'reactiver',
			A2($author$project$Components$Referentiel$Fiche$Update$StatutDemande, fourni.r8, 0),
			$author$project$I18n$Cles$referentielFicheContactReactiver(i18n));
		return _Utils_ap(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				function () {
					var _v0 = fourni.ri;
					if (_v0 === 2) {
						return _List_fromArray(
							[reactiver]);
					} else {
						return _List_fromArray(
							[
								A4(
								entree,
								fourni.ei,
								'modifier-le-contact',
								$author$project$Components$Referentiel$Fiche$Update$ModificationDeContactDemandee(fourni.r8),
								$author$project$I18n$Cles$referentielFicheContactModifier(i18n)),
								A4(
								entree,
								fourni.HE,
								'rendre-principal',
								$author$project$Components$Referentiel$Fiche$Update$PrincipalDemande(fourni.r8),
								$author$project$I18n$Cles$referentielFicheContactRendrePrincipal(i18n)),
								(!fourni.ri) ? A4(
								entree,
								fourni.B6,
								'marquer-invalide',
								A2($author$project$Components$Referentiel$Fiche$Update$StatutDemande, fourni.r8, 1),
								$author$project$I18n$Cles$referentielFicheContactMarquerInvalide(i18n)) : reactiver,
								A4(
								entree,
								fourni.B6,
								'passer-en-ancien',
								A2($author$project$Components$Referentiel$Fiche$Update$StatutDemande, fourni.r8, 2),
								$author$project$I18n$Cles$referentielFicheContactPasserEnAncien(i18n)),
								fourni.Gx ? A4(
								entree,
								fourni.Hn,
								'exclure-de-la-prospection',
								A2($author$project$Components$Referentiel$Fiche$Update$ProspectionDemandee, fourni.r8, false),
								$author$project$I18n$Cles$referentielFicheContactExclureDeLaProspection(i18n)) : A4(
								entree,
								fourni.Hn,
								'accepter-la-prospection',
								A2($author$project$Components$Referentiel$Fiche$Update$ProspectionDemandee, fourni.r8, true),
								$author$project$I18n$Cles$referentielFicheContactAccepterLaProspection(i18n))
							]);
					}
				}()),
			A2($author$project$Components$Referentiel$Fiche$View$effacerLeContact, i18n, fourni));
	});
var $author$project$I18n$Cles$referentielFicheContactActions = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.contact.actions',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'contact',
					$author$project$I18n$Traductions$Chaine(p.v8))
				]),
			'Actions : ' + p.v8);
	});
var $author$project$Components$Referentiel$Fiche$View$boutonDesGestes = F2(
	function (i18n, fourni) {
		var valeur = A2($author$project$I18n$Cles$texte, i18n, fourni.fm);
		return $elm$core$List$isEmpty(
			A2($author$project$Components$Referentiel$Fiche$View$gestesDeContact, i18n, fourni)) ? _List_Nil : _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						$author$project$Components$Referentiel$Fiche$Update$idDesGestesDeContact(fourni.r8)),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('button-icon'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('gerer-le-contact'),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-label',
						A2(
							$author$project$I18n$Cles$referentielFicheContactActions,
							i18n,
							{v8: valeur})),
						$rtfeldman$elm_css$Html$Styled$Attributes$title(
						A2(
							$author$project$I18n$Cles$referentielFicheContactActions,
							i18n,
							{v8: valeur})),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Referentiel$Fiche$Update$MenuDeContactBascule(fourni.r8))
					]),
				_List_fromArray(
					[$author$project$Components$Shared$Svg$svgEdit]))
			]);
	});
var $author$project$Components$Referentiel$Fiche$View$champDuContact = function (uid) {
	return 'crm.entite.contact.' + uid;
};
var $author$project$Components$Shared$Svg$svgPhone = A3($author$project$Components$Shared$Svg$icone, 'phone', 'M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a1.5 1.5 0 0 1-1.5 1.5A16.5 16.5 0 0 1 3.5 5.5 1.5 1.5 0 0 1 5 4z', _List_Nil);
var $author$project$Components$Referentiel$Fiche$View$coordonnee = F2(
	function (i18n, fourni) {
		var devant = function () {
			var _v0 = fourni.hP.uF;
			switch (_v0) {
				case 0:
					return $author$project$Components$Shared$Svg$svgMail;
				case 1:
					return $author$project$Components$Shared$Svg$svgPhone;
				default:
					return A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('canal')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$I18n$Cles$texte, i18n, fourni.uF))
							]));
			}
		}();
		var contenu = _List_fromArray(
			[
				devant,
				$rtfeldman$elm_css$Html$Styled$text(
				A2($author$project$I18n$Cles$texte, i18n, fourni.fm))
			]);
		return ((!fourni.hP.uF) && (fourni.hP.fm !== '')) ? A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$href('mailto:' + fourni.hP.fm),
					$rtfeldman$elm_css$Html$Styled$Attributes$title(
					A2($author$project$I18n$Cles$texte, i18n, fourni.uF))
				]),
			contenu) : A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$title(
					A2($author$project$I18n$Cles$texte, i18n, fourni.uF))
				]),
			contenu);
	});
var $author$project$I18n$Cles$referentielFicheContactFinDuRattachement = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.contact.fin-du-rattachement',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'fin du rattachement · ' + p.wv);
	});
var $author$project$I18n$Cles$referentielFicheContactInvalide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.contact.invalide', _List_Nil, 'invalide');
};
var $author$project$I18n$Cles$referentielFicheContactPrincipal = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.contact.principal', _List_Nil, 'principal');
};
var $author$project$I18n$Cles$referentielFicheContactStatutDepuis = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.contact.statut-depuis',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'depuis le ' + p.wv);
	});
var $author$project$Components$Referentiel$Fiche$View$ligneDeContact = F4(
	function (i18n, fiche, usage, fourni) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('contact'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('invalide', fourni.ri === 1)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('usage')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(usage)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('coordonnee')
						]),
					_List_fromArray(
						[
							A2($author$project$Components$Referentiel$Fiche$View$coordonnee, i18n, fourni)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('marques')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('pills')
								]),
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_List_fromArray(
									[
										fourni.px ? $elm$core$Maybe$Just(
										A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('tag'),
													$rtfeldman$elm_css$Html$Styled$Attributes$class('principal')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$referentielFicheContactPrincipal(i18n))
												]))) : $elm$core$Maybe$Nothing,
										(fourni.ri === 1) ? $elm$core$Maybe$Just(
										A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('tag'),
													$rtfeldman$elm_css$Html$Styled$Attributes$class('rouge')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$referentielFicheContactInvalide(i18n))
												]))) : $elm$core$Maybe$Nothing
									]))),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('statut-le')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									function () {
										var _v0 = _Utils_Tuple3(fourni.ri, fourni.zI, fourni.I0);
										_v0$0:
										while (true) {
											_v0$1:
											while (true) {
												_v0$2:
												while (true) {
													_v0$3:
													while (true) {
														if (!_v0.c.$) {
															switch (_v0.a) {
																case 0:
																	break _v0$0;
																case 2:
																	if (!_v0.b.$) {
																		break _v0$1;
																	} else {
																		break _v0$2;
																	}
																default:
																	break _v0$2;
															}
														} else {
															switch (_v0.a) {
																case 0:
																	break _v0$0;
																case 2:
																	if (!_v0.b.$) {
																		break _v0$1;
																	} else {
																		break _v0$3;
																	}
																default:
																	break _v0$3;
															}
														}
													}
													var _v3 = _v0.c;
													return '';
												}
												var date = _v0.c.a;
												return A2(
													$author$project$I18n$Cles$referentielFicheContactStatutDepuis,
													i18n,
													{
														wv: A2($author$project$I18n$Cles$texte, i18n, date)
													});
											}
											var _v2 = _v0.a;
											var fin = _v0.b.a;
											return A2(
												$author$project$I18n$Cles$referentielFicheContactFinDuRattachement,
												i18n,
												{
													wv: A2($author$project$I18n$Cles$texte, i18n, fin)
												});
										}
										var _v1 = _v0.a;
										return '';
									}())
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					_Utils_ap(
						A5(
							$author$project$Components$Referentiel$Fiche$View$versLHistoriqueDuChamp,
							i18n,
							fiche,
							'resume',
							$author$project$Components$Referentiel$Fiche$View$champDuContact(fourni.r8),
							A2($author$project$I18n$Cles$texte, i18n, fourni.uF)),
						A2($author$project$Components$Referentiel$Fiche$View$boutonDesGestes, i18n, fourni)))
				]));
	});
var $author$project$I18n$Cles$referentielFicheResumeColonneCoordonnee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.colonne-coordonnee', _List_Nil, 'Coordonnée');
};
var $author$project$I18n$Cles$referentielFicheResumeColonneUsage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.colonne-usage', _List_Nil, 'Usage');
};
var $author$project$Components$Referentiel$Fiche$View$tableauDeContacts = F3(
	function (i18n, fiche, lignes) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$table,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$tr,
							_List_Nil,
							_Utils_ap(
								A2(
									$elm$core$List$map,
									function (titre) {
										return A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(titre)
												]));
									},
									_List_fromArray(
										[
											$author$project$I18n$Cles$referentielFicheResumeColonneUsage(i18n),
											$author$project$I18n$Cles$referentielFicheResumeColonneCoordonnee(i18n)
										])),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
											]),
										_List_Nil),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
											]),
										_List_Nil)
									])))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (_v0) {
							var usage = _v0.a;
							var fourni = _v0.b;
							return A4($author$project$Components$Referentiel$Fiche$View$ligneDeContact, i18n, fiche, usage, fourni);
						},
						lignes))
				]));
	});
var $author$project$Components$Referentiel$Fiche$View$contacts = F3(
	function (i18n, fiche, model) {
		var ranges = A2($author$project$Components$Referentiel$Fiche$Contacts$groupes, i18n, fiche.wa);
		var depliee = A2($author$project$Components$Referentiel$Fiche$Resume$estDepliee, 0, model.kH);
		var bornes = A2(
			$author$project$Components$Referentiel$Fiche$Resume$borner,
			depliee,
			A2($elm$core$List$concatMap, $elm$core$Tuple$second, ranges.o8));
		var gardes = A2(
			$elm$core$List$map,
			function ($) {
				return $.r8;
			},
			bornes.g0);
		var montres = A2(
			$elm$core$List$filter,
			function (_v1) {
				var fourni = _v1.b;
				return A2($elm$core$List$member, fourni.r8, gardes);
			},
			A2(
				$elm$core$List$concatMap,
				function (_v0) {
					var usage = _v0.a;
					var lignes = _v0.b;
					return A2(
						$elm$core$List$map,
						$elm$core$Tuple$pair(usage),
						lignes);
				},
				ranges.o8));
		return A2(
			$author$project$Components$Shared$Page$View$sectionAvecCompte,
			$author$project$Components$Referentiel$Fiche$View$ancre('contacts'),
			{
				fw: (!_Utils_eq(fiche.s8, $elm$core$Maybe$Nothing)) ? _List_fromArray(
					[
						A4(
						$author$project$Components$Shared$Bouton$View$boutonAvecIcone,
						2,
						$author$project$Components$Shared$Svg$svgAdd,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Fiche$Update$idDeLAjoutDeContact),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('ajouter'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Fiche$Update$AjoutDeContactDemande)
							]),
						$author$project$I18n$Cles$referentielFicheContactAjouter(i18n))
					]) : _List_Nil,
				vW: $elm$core$Maybe$Just(
					$elm$core$String$fromInt(bornes.JE)),
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau'),
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'hidden',
										$elm$core$List$isEmpty(montres))
									]))
							]),
						_List_fromArray(
							[
								A3($author$project$Components$Referentiel$Fiche$View$tableauDeContacts, i18n, fiche, montres)
							])),
						A4($author$project$Components$Referentiel$Fiche$View$pied, i18n, 0, bornes, depliee),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('anciens'),
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('opened', model.v8.dl)
									]))
							]),
						$elm$core$List$isEmpty(ranges.iO) ? _List_Nil : _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('toggle'),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
										'aria-expanded',
										model.v8.dl ? 'true' : 'false'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Fiche$Update$AnciensBascules)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$referentielFicheContactAnciens(i18n))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Components$Referentiel$Fiche$View$tableauDeContacts,
										i18n,
										fiche,
										A2(
											$elm$core$List$map,
											function (fourni) {
												return _Utils_Tuple2(
													A2($author$project$I18n$Cles$texte, i18n, fourni.sd),
													fourni);
											},
											ranges.iO))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('notes')
							]),
						A2(
							$elm$core$List$map,
							function (organisation) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$referentielFicheContactNoteDeLOrganisation,
												i18n,
												{En: organisation}))
										]));
							},
							ranges.o3)),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aucun-contact')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$List$isEmpty(fiche.wa) ? $author$project$I18n$Cles$referentielFicheAucunContact(i18n) : '')
							]))
					]),
				Ar: $elm$core$Maybe$Just($author$project$Components$Referentiel$Fiche$Update$idDuTitreDesContacts),
				Dj: 'contacts',
				h6: $author$project$I18n$Cles$referentielFicheResumeContacts(i18n)
			});
	});
var $author$project$I18n$Cles$referentielFicheBaseLegale = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.base-legale', _List_Nil, 'Base légale');
};
var $author$project$I18n$Cles$referentielFicheDonneesPersonnelles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.donnees-personnelles', _List_Nil, 'Données personnelles');
};
var $author$project$Components$Referentiel$Fiche$View$donneesPersonnelles = F2(
	function (i18n, fiche) {
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_Nil,
			{
				fw: _List_Nil,
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('infos')
							]),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (base) {
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$li,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$referentielFicheBaseLegale(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$strong,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															A2($author$project$I18n$Cles$texte, i18n, base))
														]))
												]))
										]);
								},
								fiche.fI)))
					]),
				Dj: 'donnees-personnelles',
				h6: $author$project$I18n$Cles$referentielFicheDonneesPersonnelles(i18n)
			});
	});
var $author$project$I18n$Cles$referentielFicheHorsLimitesDepuis = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.hors-limites.depuis',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'jour',
					$author$project$I18n$Traductions$Chaine(p.A_))
				]),
			'hors limites depuis le ' + p.A_);
	});
var $author$project$Components$Referentiel$Fiche$View$ligneDInformation = F2(
	function (i18n, ligne) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('champ')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$dt,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(ligne.Bl)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$dd,
					_List_Nil,
					_Utils_ap(
						(ligne.eB || ($elm$core$List$length(ligne.Ki) > 1)) ? _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('pills')
									]),
								A2(
									$elm$core$List$map,
									function (valeur) {
										return A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('pill'),
													$rtfeldman$elm_css$Html$Styled$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('accent', ligne.di)
														]))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(valeur)
												]));
									},
									ligne.Ki))
							]) : A2($elm$core$List$map, $rtfeldman$elm_css$Html$Styled$text, ligne.Ki),
						_Utils_ap(
							function () {
								var _v0 = ligne.Am;
								if (!_v0.$) {
									var jour = _v0.a;
									return _List_fromArray(
										[
											A2(
											$author$project$Components$Shared$Tag$View$view,
											2,
											A2(
												$author$project$I18n$Cles$referentielFicheHorsLimitesDepuis,
												i18n,
												{
													A_: A2($author$project$Texte$Jour$enFrancais, i18n, jour)
												}))
										]);
								} else {
									return _List_Nil;
								}
							}(),
							ligne.gH ? _List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Tag$View$view,
									1,
									$author$project$I18n$Cles$restrictionHorsChoix(i18n))
								]) : _List_Nil)))
				]));
	});
var $author$project$I18n$Cles$referentielFicheResumeDonneesAucunProgramme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.donnees.aucun-programme', _List_Nil, 'Aucun programmé');
};
var $author$project$I18n$Cles$referentielFicheResumeDonneesEffacement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.donnees.effacement', _List_Nil, 'Effacement');
};
var $author$project$I18n$Cles$referentielFicheResumeDonneesExporter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.donnees.exporter', _List_Nil, 'Exporter');
};
var $author$project$I18n$Cles$referentielFicheResumeDonneesProgrammer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.donnees.programmer', _List_Nil, 'Programmer l\'effacement');
};
var $author$project$I18n$Cles$referentielFicheResumeDonneesStockage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.donnees.stockage', _List_Nil, 'Stockage');
};
var $author$project$I18n$Cles$referentielFicheResumeDonneesStockageCoffre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.donnees.stockage-coffre', _List_Nil, 'Coffre chiffré');
};
var $author$project$Components$Referentiel$Fiche$View$donneesPersonnellesDuResume = F2(
	function (i18n, fiche) {
		var ligne = F2(
			function (libelle, valeur) {
				return A2(
					$author$project$Components$Referentiel$Fiche$View$ligneDInformation,
					i18n,
					{
						di: false,
						dy: '',
						gH: false,
						Am: $elm$core$Maybe$Nothing,
						Bl: libelle,
						eB: false,
						Ki: _List_fromArray(
							[valeur])
					});
			});
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_Nil,
			{
				fw: _List_Nil,
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$dl,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('champs')
							]),
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$I18n$Cles$texte(i18n),
										ligne(
											$author$project$I18n$Cles$referentielFicheBaseLegale(i18n))),
									fiche.fI),
									$elm$core$Maybe$Just(
									A2(
										ligne,
										$author$project$I18n$Cles$referentielFicheResumeDonneesStockage(i18n),
										$author$project$I18n$Cles$referentielFicheResumeDonneesStockageCoffre(i18n))),
									$elm$core$Maybe$Just(
									A2(
										ligne,
										$author$project$I18n$Cles$referentielFicheResumeDonneesEffacement(i18n),
										function () {
											var _v0 = fiche.x9;
											if (!_v0.$) {
												var effacement = _v0.a;
												return A2(
													$author$project$I18n$Cles$referentielFicheEffacementProgramme,
													i18n,
													{
														wv: A2($author$project$I18n$Cles$texte, i18n, effacement.xY),
														cX: A2($author$project$Components$Referentiel$Fiche$View$motifLisible, i18n, effacement.cX)
													});
											} else {
												return $author$project$I18n$Cles$referentielFicheResumeDonneesAucunProgramme(i18n);
											}
										}()))
								]))),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
							]),
						_Utils_ap(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (_v1) {
										return _List_fromArray(
											[
												A3(
												$author$project$Components$Shared$Bouton$View$bouton,
												1,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Fiche$Export$idDuDeclencheur),
														$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Fiche$Update$ExportDemande)
													]),
												$author$project$I18n$Cles$referentielFicheResumeDonneesExporter(i18n))
											]);
									},
									fiche.za)),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (_v2) {
										return _List_fromArray(
											[
												A3(
												$author$project$Components$Shared$Bouton$View$bouton,
												1,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Fiche$Effacement$idDuDeclencheur),
														$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Fiche$Update$EffacementDemande)
													]),
												$author$project$I18n$Cles$referentielFicheResumeDonneesProgrammer(i18n))
											]);
									},
									fiche.lM))))
					]),
				Dj: 'donnees-personnelles',
				h6: $author$project$I18n$Cles$referentielFicheDonneesPersonnelles(i18n)
			});
	});
var $author$project$I18n$Cles$referentielFicheEchanges = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.echanges', _List_Nil, 'Échanges récents');
};
var $author$project$I18n$Cles$referentielFicheResumeAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.aucun', _List_Nil, 'Aucun');
};
var $author$project$I18n$Cles$referentielFicheResumeDossiersEnCours = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.dossiers-en-cours', _List_Nil, 'Dossiers en cours');
};
var $author$project$I18n$Cles$referentielFicheResumeDossiersEtEchanges = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.dossiers-et-echanges', _List_Nil, 'Dossiers et échanges');
};
var $author$project$Components$Referentiel$Fiche$View$dossiersEtEchanges = function (i18n) {
	return A2(
		$author$project$Components$Shared$Page$View$section,
		$author$project$Components$Referentiel$Fiche$View$ancre('dossiers'),
		{
			fw: _List_Nil,
			fZ: _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$dl,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('champs')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('champ')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$dt,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$referentielFicheResumeDossiersEnCours(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$dd,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('aucun')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$referentielFicheResumeAucun(i18n))
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('champ')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$dt,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$referentielFicheEchanges(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$dd,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('aucun')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$referentielFicheResumeAucun(i18n))
												]))
										]))
								]))
						]))
				]),
			Dj: 'dossiers',
			h6: $author$project$I18n$Cles$referentielFicheResumeDossiersEtEchanges(i18n)
		});
};
var $author$project$Components$Referentiel$Fiche$Update$EffacementConfirme = {$: 106};
var $author$project$Components$Referentiel$Fiche$Update$MotifDEffacementChoisi = function (a) {
	return {$: 103, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$SaisieDEffacementChangee = function (a) {
	return {$: 105, a: a};
};
var $author$project$I18n$Cles$referentielFicheEffacementCoordonnees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacement.coordonnees', _List_Nil, 'E-mails, téléphones, adresses');
};
var $author$project$I18n$Cles$referentielFicheEffacementHistoriqueSansIdentite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacement.historique-sans-identite', _List_Nil, 'Historique des échanges, sans identité');
};
var $author$project$I18n$Cles$referentielFicheEffacementIdentite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacement.identite', _List_Nil, 'Nom, prénom, civilité');
};
var $author$project$I18n$Cles$referentielFicheEffacementPrecisionsSaisies = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacement.precisions-saisies', _List_Nil, 'Précisions saisies à la création');
};
var $author$project$I18n$Cles$referentielFicheEffacementRelationsEtDates = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacement.relations-et-dates', _List_Nil, 'Relations et dates');
};
var $author$project$I18n$Cles$referentielFicheEffacementRolesEtRattachements = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacement.roles-et-rattachements', _List_Nil, 'Rôles et rattachements (sans identité)');
};
var $author$project$Components$Referentiel$Vocabulaire$elementDeLEffacement = F2(
	function (i18n, code) {
		switch (code) {
			case 'identite':
				return $author$project$I18n$Cles$referentielFicheEffacementIdentite(i18n);
			case 'coordonnees':
				return $author$project$I18n$Cles$referentielFicheEffacementCoordonnees(i18n);
			case 'precisions-saisies':
				return $author$project$I18n$Cles$referentielFicheEffacementPrecisionsSaisies(i18n);
			case 'roles-et-rattachements':
				return $author$project$I18n$Cles$referentielFicheEffacementRolesEtRattachements(i18n);
			case 'relations-et-dates':
				return $author$project$I18n$Cles$referentielFicheEffacementRelationsEtDates(i18n);
			case 'historique-sans-identite':
				return $author$project$I18n$Cles$referentielFicheEffacementHistoriqueSansIdentite(i18n);
			default:
				var autre = code;
				return autre;
		}
	});
var $rtfeldman$elm_css$Html$Styled$h4 = $rtfeldman$elm_css$Html$Styled$node('h4');
var $author$project$Components$Referentiel$Fiche$Effacement$idDeLaSaisie = 'fiche-effacer-saisie';
var $author$project$Components$Referentiel$Fiche$Effacement$idDuMotif = 'fiche-effacer-motif';
var $author$project$I18n$Cles$referentielFicheContactEffacerMessageCoordonnee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.contact.effacer-message-coordonnee', _List_Nil, 'Cette coordonnée sera effacée de la fiche. Les autres coordonnées ne sont pas touchées.');
};
var $author$project$I18n$Cles$referentielFicheContactEffacerMessageEmail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.contact.effacer-message-email', _List_Nil, 'Cette adresse e-mail sera effacée de la fiche. Les autres coordonnées ne sont pas touchées.');
};
var $author$project$I18n$Cles$referentielFicheContactEffacerMessageTelephone = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.contact.effacer-message-telephone', _List_Nil, 'Ce numéro sera effacé de la fiche. Les autres coordonnées ne sont pas touchées.');
};
var $author$project$Components$Referentiel$Fiche$View$messageDEffacement = F2(
	function (i18n, canal) {
		switch (canal) {
			case 0:
				return $author$project$I18n$Cles$referentielFicheContactEffacerMessageEmail(i18n);
			case 1:
				return $author$project$I18n$Cles$referentielFicheContactEffacerMessageTelephone(i18n);
			default:
				return $author$project$I18n$Cles$referentielFicheContactEffacerMessageCoordonnee(i18n);
		}
	});
var $author$project$Components$Referentiel$Fiche$Effacement$organisationsLiees = function (etat) {
	var _v0 = etat.v8;
	if (!_v0.$) {
		return A2(
			$elm$core$List$map,
			$elm$core$Tuple$second,
			A3(
				$elm$core$List$foldl,
				F2(
					function (liee, vues) {
						return A2(
							$elm$core$List$any,
							function (_v1) {
								var organisation = _v1.a;
								return _Utils_eq(organisation, liee.En);
							},
							vues) ? vues : _Utils_ap(
							vues,
							_List_fromArray(
								[
									_Utils_Tuple2(liee.En, liee.Dj)
								]));
					}),
				_List_Nil,
				etat.gS));
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Referentiel$Fiche$Update$PrecisionDEffacementSaisie = function (a) {
	return {$: 104, a: a};
};
var $author$project$Components$Referentiel$Fiche$Effacement$idDeLaPrecision = 'fiche-effacer-precision';
var $author$project$I18n$Cles$referentielFicheEffacementCompteur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.effacement.compteur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			p.d + ' / 500');
	});
var $author$project$I18n$Cles$referentielFicheEffacementPrecision = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacement.precision', _List_Nil, 'Précision (obligatoire si « Autre »), 500 caractères au plus');
};
var $author$project$I18n$Cles$referentielFicheEffacementPrecisionAvertissement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacement.precision-avertissement', _List_Nil, 'N\'y écrivez ni le nom ni les coordonnées de la personne.');
};
var $author$project$Components$Referentiel$Fiche$View$precisionDeLEffacement = F2(
	function (i18n, etat) {
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Champ$View$zoneDeTexte,
				{
					go: $elm$core$Maybe$Nothing,
					Aq: $author$project$Components$Referentiel$Fiche$Effacement$idDeLaPrecision,
					Bl: $author$project$I18n$Cles$referentielFicheEffacementPrecision(i18n),
					he: true
				},
				{hg: $author$project$Components$Referentiel$Fiche$Update$PrecisionDEffacementSaisie, fm: etat.Gd}),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$referentielFicheEffacementPrecisionAvertissement(i18n))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('compteur')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$referentielFicheEffacementCompteur,
							i18n,
							{
								d: $elm$core$String$fromInt(
									$elm$core$String$length(etat.Gd))
							}))
					]))
			]);
	});
var $author$project$I18n$Cles$referentielFicheContactEffacerAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.contact.effacer-action', _List_Nil, 'Effacer ce contact');
};
var $author$project$I18n$Cles$referentielFicheContactEffacerLieesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.contact.effacer-liees-titre', _List_Nil, 'Coordonnées liées');
};
var $author$project$I18n$Cles$referentielFicheContactEffacerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.contact.effacer-titre', _List_Nil, 'Effacer ce contact');
};
var $author$project$I18n$Cles$referentielFicheContactEffacerValeur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.contact.effacer-valeur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm)),
					_Utils_Tuple2(
					'canal',
					$author$project$I18n$Traductions$Chaine(p.uF))
				]),
			p.fm + (' · ' + p.uF));
	});
var $author$project$I18n$Cles$referentielFicheContactEffacerValeurTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.contact.effacer-valeur-titre', _List_Nil, 'Valeur concernée');
};
var $author$project$I18n$Cles$referentielFicheEffacementAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacement.action', _List_Nil, 'Programmer l\'effacement');
};
var $author$project$I18n$Cles$referentielFicheEffacementAvertissement = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.effacement.avertissement',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.Dj)))
				]),
			'Les données personnelles ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.Dj);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.Dj);
					default:
						return 'de ' + $elm$core$String$trim(p.Dj);
				}
			}() + ' seront effacées de façon définitive.'));
	});
var $author$project$I18n$Cles$referentielFicheEffacementDateDEffet = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.effacement.date-d-effet',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv)),
					_Utils_Tuple2(
					'demande',
					$author$project$I18n$Traductions$Chaine(p.kC)),
					_Utils_Tuple2(
					'delai',
					$author$project$I18n$Traductions$Chaine(p.w2))
				]),
			'Effacement le ' + (p.wv + (', annulable jusque-là (demande du ' + (p.kC + (', délai de rétractation : ' + (p.w2 + ').'))))));
	});
var $author$project$I18n$Cles$referentielFicheEffacementDelaiJours = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.effacement.delai-jours',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' jour') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' jours'));
	});
var $author$project$I18n$Cles$referentielFicheEffacementDelaiMoinsDUnJour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacement.delai-moins-d-un-jour', _List_Nil, 'moins d\'un jour');
};
var $author$project$I18n$Cles$referentielFicheEffacementMotif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacement.motif', _List_Nil, 'Motif');
};
var $author$project$I18n$Cles$referentielFicheEffacementMotifAChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacement.motif-a-choisir', _List_Nil, 'Choisir un motif');
};
var $author$project$I18n$Cles$referentielFicheEffacementRestera = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacement.restera', _List_Nil, 'Restera');
};
var $author$project$I18n$Cles$referentielFicheEffacementSaisie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacement.saisie', _List_Nil, 'Pour confirmer, tapez EFFACER');
};
var $author$project$I18n$Cles$referentielFicheEffacementSeraEfface = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacement.sera-efface', _List_Nil, 'Sera effacé');
};
var $author$project$I18n$Cles$referentielFicheContactEffacerLieesPlurielCoordonnee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.contact.effacer-liees-pluriel-coordonnee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			'Cette coordonnée figure aussi, à l\'identique, dans les contacts de ' + (p.d + ' organisations. Elle y sera effacée aussi.'));
	});
var $author$project$I18n$Cles$referentielFicheContactEffacerLieesPlurielEmail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.contact.effacer-liees-pluriel-email',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			'Cette adresse figure aussi, à l\'identique, dans les contacts de ' + (p.d + ' organisations. Elle y sera effacée aussi.'));
	});
var $author$project$I18n$Cles$referentielFicheContactEffacerLieesPlurielTelephone = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.contact.effacer-liees-pluriel-telephone',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			'Ce numéro figure aussi, à l\'identique, dans les contacts de ' + (p.d + ' organisations. Il y sera effacé aussi.'));
	});
var $author$project$I18n$Cles$referentielFicheContactEffacerLieesSingulierCoordonnee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.contact.effacer-liees-singulier-coordonnee', _List_Nil, 'Cette coordonnée figure aussi, à l\'identique, dans les contacts d\'une organisation. Elle y sera effacée aussi.');
};
var $author$project$I18n$Cles$referentielFicheContactEffacerLieesSingulierEmail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.contact.effacer-liees-singulier-email', _List_Nil, 'Cette adresse figure aussi, à l\'identique, dans les contacts d\'une organisation. Elle y sera effacée aussi.');
};
var $author$project$I18n$Cles$referentielFicheContactEffacerLieesSingulierTelephone = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.contact.effacer-liees-singulier-telephone', _List_Nil, 'Ce numéro figure aussi, à l\'identique, dans les contacts d\'une organisation. Il y sera effacé aussi.');
};
var $author$project$Components$Referentiel$Fiche$View$texteDesLiees = F3(
	function (i18n, canal, n) {
		var _v0 = _Utils_Tuple2(canal, n);
		switch (_v0.a) {
			case 0:
				if (_v0.b === 1) {
					var _v1 = _v0.a;
					return $author$project$I18n$Cles$referentielFicheContactEffacerLieesSingulierEmail(i18n);
				} else {
					var _v2 = _v0.a;
					return A2(
						$author$project$I18n$Cles$referentielFicheContactEffacerLieesPlurielEmail,
						i18n,
						{
							d: $elm$core$String$fromInt(n)
						});
				}
			case 1:
				if (_v0.b === 1) {
					var _v3 = _v0.a;
					return $author$project$I18n$Cles$referentielFicheContactEffacerLieesSingulierTelephone(i18n);
				} else {
					var _v4 = _v0.a;
					return A2(
						$author$project$I18n$Cles$referentielFicheContactEffacerLieesPlurielTelephone,
						i18n,
						{
							d: $elm$core$String$fromInt(n)
						});
				}
			default:
				if (_v0.b === 1) {
					return $author$project$I18n$Cles$referentielFicheContactEffacerLieesSingulierCoordonnee(i18n);
				} else {
					return A2(
						$author$project$I18n$Cles$referentielFicheContactEffacerLieesPlurielCoordonnee,
						i18n,
						{
							d: $elm$core$String$fromInt(n)
						});
				}
		}
	});
var $author$project$Components$Referentiel$Fiche$Model$texteDuTitre = F2(
	function (i18n, mots) {
		return A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$author$project$I18n$Cles$texte(i18n),
				mots));
	});
var $author$project$Components$Referentiel$Fiche$View$titreDeLaFiche = F2(
	function (i18n, fiche) {
		return A2(
			$author$project$Components$Referentiel$Fiche$Model$texteDuTitre,
			i18n,
			$author$project$Components$Referentiel$Fiche$Model$titre(fiche));
	});
var $author$project$Components$Referentiel$Fiche$View$drawerDEffacement = F4(
	function (i18n, messages, fiche, model) {
		var liste = F2(
			function (titre, codes) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('liste')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h4,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(titre)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (code) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$li,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2($author$project$Components$Referentiel$Vocabulaire$elementDeLEffacement, i18n, code))
											]));
								},
								codes))
						]));
			});
		var etat = model.x9;
		var enCours = function () {
			var _v3 = model.l2;
			if (_v3.$ === 2) {
				return true;
			} else {
				return false;
			}
		}();
		var corpsDuContact = function (ligne) {
			return _Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('message')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$Components$Referentiel$Fiche$View$messageDEffacement, i18n, ligne.hP.uF))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$section,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur-concernee')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$h4,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielFicheContactEffacerValeurTitre(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$referentielFicheContactEffacerValeur,
											i18n,
											{
												uF: A2($author$project$I18n$Cles$texte, i18n, ligne.uF),
												fm: A2($author$project$I18n$Cles$texte, i18n, ligne.fm)
											}))
									]))
							]))
					]),
				_Utils_ap(
					function () {
						var _v2 = $author$project$Components$Referentiel$Fiche$Effacement$organisationsLiees(etat);
						if (!_v2.b) {
							return _List_Nil;
						} else {
							var noms = _v2;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$section,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('coordonnees-liees')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$h4,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$referentielFicheContactEffacerLieesTitre(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A3(
														$author$project$Components$Referentiel$Fiche$View$texteDesLiees,
														i18n,
														ligne.hP.uF,
														$elm$core$List$length(noms)))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$ul,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('organisations')
												]),
											A2(
												$elm$core$List$map,
												function (nom) {
													return A2(
														$rtfeldman$elm_css$Html$Styled$li,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(nom)
															]));
												},
												noms))
										]))
								]);
						}
					}(),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Champ$View$texte,
							{
								go: $elm$core$Maybe$Nothing,
								Aq: $author$project$Components$Referentiel$Fiche$Effacement$idDeLaSaisie,
								Bl: $author$project$I18n$Cles$referentielFicheEffacementSaisie(i18n),
								he: true
							},
							{hg: $author$project$Components$Referentiel$Fiche$Update$SaisieDEffacementChangee, fm: etat.hP})
						])));
		};
		var apercu = function () {
			var _v1 = etat.tq;
			if (!_v1.$) {
				var lu = _v1.a;
				return _List_fromArray(
					[
						A2(
						liste,
						$author$project$I18n$Cles$referentielFicheEffacementSeraEfface(i18n),
						lu.II),
						A2(
						liste,
						$author$project$I18n$Cles$referentielFicheEffacementRestera(i18n),
						lu.HU),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('date-d-effet')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$referentielFicheEffacementDateDEffet,
									i18n,
									{
										wv: A2($author$project$Texte$Jour$enFrancais, i18n, lu.wx),
										w2: (lu.kB < 1) ? $author$project$I18n$Cles$referentielFicheEffacementDelaiMoinsDUnJour(i18n) : A2(
											$author$project$I18n$Cles$referentielFicheEffacementDelaiJours,
											i18n,
											{w: lu.kB}),
										kC: A2($author$project$Texte$Jour$enFrancais, i18n, lu.wy)
									}))
							]))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var corpsDeLaFiche = _Utils_ap(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('message')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$referentielFicheEffacementAvertissement,
								i18n,
								{
									av: $author$project$Texte$Elision$elision(
										A2($author$project$Components$Referentiel$Fiche$View$titreDeLaFiche, i18n, fiche)),
									Dj: A2($author$project$Components$Referentiel$Fiche$View$titreDeLaFiche, i18n, fiche)
								}))
						]))
				]),
			_Utils_ap(
				apercu,
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Champ$View$liste,
							{
								go: $elm$core$Maybe$Nothing,
								Aq: $author$project$Components$Referentiel$Fiche$Effacement$idDuMotif,
								Bl: $author$project$I18n$Cles$referentielFicheEffacementMotif(i18n),
								he: true
							},
							{
								hg: $author$project$Components$Referentiel$Fiche$Update$MotifDEffacementChoisi,
								o_: _List_fromArray(
									[
										{
										Bl: $author$project$I18n$Cles$referentielFicheEffacementMotifAChoisir(i18n),
										fm: ''
									},
										{
										Bl: $author$project$I18n$Cles$referentielFicheEffacementMotifDemande(i18n),
										fm: 'demande'
									},
										{
										Bl: $author$project$I18n$Cles$referentielFicheEffacementMotifAutre(i18n),
										fm: 'autre'
									}
									]),
								fm: A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Maybe$map, $author$project$Components$Referentiel$Fiche$Effacement$codeDuMotif, etat.cX))
							})
						]),
					_Utils_ap(
						$author$project$Components$Referentiel$Fiche$Effacement$motifPrecise(etat) ? A2($author$project$Components$Referentiel$Fiche$View$precisionDeLEffacement, i18n, etat) : _List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Champ$View$texte,
								{
									go: $elm$core$Maybe$Nothing,
									Aq: $author$project$Components$Referentiel$Fiche$Effacement$idDeLaSaisie,
									Bl: $author$project$I18n$Cles$referentielFicheEffacementSaisie(i18n),
									he: true
								},
								{hg: $author$project$Components$Referentiel$Fiche$Update$SaisieDEffacementChangee, fm: etat.hP})
							])))));
		var corps = function () {
			var _v0 = etat.v8;
			if (!_v0.$) {
				var ligne = _v0.a;
				return corpsDuContact(ligne);
			} else {
				return corpsDeLaFiche;
			}
		}();
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$Fiche$Update$DrawerDEffacementMsg,
			{
				fs: {
					sR: $author$project$Components$Referentiel$Fiche$Effacement$peutConfirmer(etat) && (!enCours),
					Bl: _Utils_eq(etat.v8, $elm$core$Maybe$Nothing) ? $author$project$I18n$Cles$referentielFicheEffacementAction(i18n) : $author$project$I18n$Cles$referentielFicheContactEffacerAction(i18n),
					C$: $author$project$Components$Referentiel$Fiche$Update$EffacementConfirme
				},
				fZ: _Utils_ap(
					$author$project$Components$Shared$Drawer$Model$estOuvert(etat.kX) ? _List_fromArray(
						[
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages)
						]) : _List_Nil,
					corps),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: _Utils_eq(etat.v8, $elm$core$Maybe$Nothing) ? $author$project$I18n$Cles$referentielFicheEffacementTitre(i18n) : $author$project$I18n$Cles$referentielFicheContactEffacerTitre(i18n)
			},
			etat.kX);
	});
var $author$project$Components$Referentiel$Fiche$Update$ChoixDeRoleFait = function (a) {
	return {$: 41, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$RetraitDeLaFinCoche = function (a) {
	return {$: 44, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$StatutDeRoleChoisi = function (a) {
	return {$: 45, a: a};
};
var $author$project$I18n$Cles$referentielRoleDrawerChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.drawer.choisir', _List_Nil, 'Choisir');
};
var $author$project$Components$Referentiel$Fiche$View$aChoisir = function (i18n) {
	return {
		Bl: $author$project$I18n$Cles$referentielRoleDrawerChoisir(i18n),
		fm: ''
	};
};
var $author$project$Components$Referentiel$Fiche$Update$RoleValide = {$: 48};
var $author$project$Components$Referentiel$Fiche$Roles$statutsProposes = F2(
	function (role, etat) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (fourni) {
					return A2(
						$elm$core$List$filter,
						function (code) {
							return !_Utils_eq(code, role.ri);
						},
						fourni.I1);
				},
				A2($author$project$Components$Referentiel$Fiche$Roles$typeDe, role.r0, etat)));
	});
var $author$project$Components$Referentiel$Fiche$Roles$peutValider = F2(
	function (roles, etat) {
		var _v0 = _Utils_Tuple2(
			etat.zT,
			A2($author$project$Components$Referentiel$Fiche$Roles$roleVise, roles, etat));
		if (((_v0.a.$ === 2) && (!_v0.a.b)) && (!_v0.b.$)) {
			var _v1 = _v0.a;
			var _v2 = _v1.b;
			var role = _v0.b.a;
			return !$elm$core$List$isEmpty(
				A2($author$project$Components$Referentiel$Fiche$Roles$statutsProposes, role, etat));
		} else {
			return true;
		}
	});
var $author$project$I18n$Cles$referentielRoleDrawerValider = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.drawer.valider', _List_Nil, 'Valider');
};
var $author$project$Components$Referentiel$Fiche$View$actionDuDrawer = F3(
	function (i18n, fiche, model) {
		return {
			sR: function () {
				var _v0 = model.l2;
				if (_v0.$ === 2) {
					return false;
				} else {
					return A2(
						$author$project$Components$Referentiel$Fiche$Roles$peutValider,
						_Utils_ap(fiche.eX, fiche.H7),
						model.bi);
				}
			}(),
			Bl: $author$project$I18n$Cles$referentielRoleDrawerValider(i18n),
			C$: $author$project$Components$Referentiel$Fiche$Update$RoleValide
		};
	});
var $author$project$Components$Referentiel$Fiche$Update$DateDeRoleSaisie = function (a) {
	return {$: 43, a: a};
};
var $author$project$Components$Referentiel$Fiche$View$champDeLaDate = F5(
	function (i18n, libelle, vise, enCours, model) {
		return A2(
			$author$project$Components$Shared$Champ$View$date,
			{
				go: A2(
					$elm$core$Maybe$map,
					$author$project$I18n$Cles$texte(i18n),
					A2($author$project$Components$Referentiel$Fiche$Roles$erreurDeLaDate, vise, model.bi)),
				Aq: 'role-date',
				Bl: libelle,
				he: $author$project$Components$Referentiel$Fiche$Roles$dateObligatoire(model.bi)
			},
			{hg: $author$project$Components$Referentiel$Fiche$Update$DateDeRoleSaisie, fm: enCours});
	});
var $author$project$Components$Referentiel$Fiche$Update$TypeDeRoleChoisi = function (a) {
	return {$: 42, a: a};
};
var $author$project$Components$Referentiel$Fiche$Roles$typesProposes = F2(
	function (vise, etat) {
		var proposables = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Basics$not,
				function ($) {
					return $.tE;
				}),
			etat.ib);
		if (!vise.$) {
			var role = vise.a;
			return A2(
				$elm$core$List$filter,
				function (fourni) {
					return !_Utils_eq(fourni.r8, role.r0);
				},
				proposables);
		} else {
			return proposables;
		}
	});
var $author$project$Components$Referentiel$Fiche$View$champDuType = F5(
	function (i18n, libelle, vise, choisi, model) {
		return A2(
			$author$project$Components$Shared$Champ$View$liste,
			{
				go: A2(
					$elm$core$Maybe$map,
					$author$project$I18n$Cles$texte(i18n),
					A2($author$project$Components$Referentiel$Fiche$Roles$erreurDuType, vise, model.bi)),
				Aq: 'role-type',
				Bl: libelle,
				he: true
			},
			{
				hg: $author$project$Components$Referentiel$Fiche$Update$TypeDeRoleChoisi,
				o_: A2(
					$elm$core$List$cons,
					$author$project$Components$Referentiel$Fiche$View$aChoisir(i18n),
					A2(
						$elm$core$List$map,
						function (fourni) {
							return {Bl: fourni.Bl, fm: fourni.r8};
						},
						A2($author$project$Components$Referentiel$Fiche$Roles$typesProposes, vise, model.bi))),
				fm: choisi
			});
	});
var $author$project$Components$Referentiel$Fiche$Update$CommentaireDeRoleSaisi = function (a) {
	return {$: 47, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$ResultatDeRoleChoisi = function (a) {
	return {$: 46, a: a};
};
var $author$project$I18n$Cles$referentielRoleDrawerCommentaire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.drawer.commentaire', _List_Nil, 'Commentaire');
};
var $author$project$I18n$Cles$referentielRoleDrawerDateDEffet = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.drawer.date-d-effet', _List_Nil, 'Date d\'effet');
};
var $author$project$I18n$Cles$referentielRoleDrawerResultat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.drawer.resultat', _List_Nil, 'Résultat du rôle clos');
};
var $author$project$Components$Referentiel$Fiche$Roles$resultatsProposes = F2(
	function (role, etat) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.bh;
				},
				A2($author$project$Components$Referentiel$Fiche$Roles$typeDe, role.r0, etat)));
	});
var $author$project$Components$Referentiel$Fiche$View$champsDeCloture = F4(
	function (i18n, fourni, enCours, model) {
		return _List_fromArray(
			[
				A5(
				$author$project$Components$Referentiel$Fiche$View$champDeLaDate,
				i18n,
				$author$project$I18n$Cles$referentielRoleDrawerDateDEffet(i18n),
				$elm$core$Maybe$Just(fourni),
				enCours.wv,
				model),
				A2(
				$author$project$Components$Shared$Champ$View$liste,
				{
					go: A2(
						$elm$core$Maybe$map,
						$author$project$I18n$Cles$texte(i18n),
						$author$project$Components$Referentiel$Fiche$Roles$erreurDuResultat(model.bi)),
					Aq: 'role-resultat',
					Bl: $author$project$I18n$Cles$referentielRoleDrawerResultat(i18n),
					he: true
				},
				{
					hg: $author$project$Components$Referentiel$Fiche$Update$ResultatDeRoleChoisi,
					o_: A2(
						$elm$core$List$cons,
						$author$project$Components$Referentiel$Fiche$View$aChoisir(i18n),
						A2(
							$elm$core$List$map,
							function (code) {
								return {
									Bl: A4($author$project$Components$Referentiel$Fiche$Roles$nomDuResultat, i18n, fourni.r0, model.bi, code),
									fm: code
								};
							},
							A2($author$project$Components$Referentiel$Fiche$Roles$resultatsProposes, fourni, model.bi))),
					fm: enCours.HW
				}),
				A2(
				$author$project$Components$Shared$Champ$View$zoneDeTexte,
				{
					go: A2(
						$elm$core$Maybe$map,
						$author$project$I18n$Cles$texte(i18n),
						$author$project$Components$Referentiel$Fiche$Roles$erreurDuCommentaire(model.bi)),
					Aq: 'role-commentaire',
					Bl: $author$project$I18n$Cles$referentielRoleDrawerCommentaire(i18n),
					he: false
				},
				{hg: $author$project$Components$Referentiel$Fiche$Update$CommentaireDeRoleSaisi, fm: enCours.vM})
			]);
	});
var $author$project$I18n$Textes$referentielRoleLibelle = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'referentiel.role.libelle',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'typeDeRole',
				$author$project$I18n$Traductions$Sous(p.rX)),
				_Utils_Tuple2(
				'offre',
				$author$project$I18n$Traductions$Sous(p.D1))
			]),
		'{typeDeRole} · {offre}');
};
var $author$project$Components$Referentiel$Fiche$Roles$libelleDe = function (role) {
	return $author$project$I18n$Textes$referentielRoleLibelle(
		{
			D1: $author$project$Components$Referentiel$Fiche$Roles$nomDeLOffre(role),
			rX: role.Bl
		});
};
var $author$project$Components$Referentiel$Fiche$View$libelleDuRole = F2(
	function (i18n, role) {
		return A2(
			$author$project$I18n$Cles$texte,
			i18n,
			$author$project$Components$Referentiel$Fiche$Roles$libelleDe(role));
	});
var $author$project$Components$Referentiel$Fiche$Roles$erreurDeLOffre = function (etat) {
	return A2(
		$elm$core$Maybe$andThen,
		function (enCours) {
			var _v0 = enCours.pZ;
			_v0$3:
			while (true) {
				if (!_v0.$) {
					switch (_v0.a) {
						case 3:
							var _v1 = _v0.a;
							return $elm$core$Maybe$Just($author$project$I18n$Textes$referentielRoleErreurOffreNonAutorisee);
						case 4:
							var _v2 = _v0.a;
							return $elm$core$Maybe$Just($author$project$I18n$Textes$referentielRoleErreurOffreRequise);
						case 5:
							var _v3 = _v0.a;
							return $elm$core$Maybe$Just($author$project$I18n$Textes$referentielRoleErreurOffreRefusee);
						default:
							break _v0$3;
					}
				} else {
					break _v0$3;
				}
			}
			return $elm$core$Maybe$Nothing;
		},
		$author$project$Components$Referentiel$Fiche$Roles$montrees(etat));
};
var $author$project$I18n$Cles$referentielRoleDrawerOffre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.drawer.offre', _List_Nil, 'Offre');
};
var $author$project$Components$Referentiel$Fiche$View$offreGardee = F3(
	function (i18n, role, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$fieldset,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('disabled'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('offre-gardee')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$legend,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielRoleDrawerOffre(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$texte,
								i18n,
								$author$project$Components$Referentiel$Fiche$Roles$nomDeLOffre(role)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('erreur')
						]),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (m) {
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$I18n$Cles$texte, i18n, m))
									]);
							},
							$author$project$Components$Referentiel$Fiche$Roles$erreurDeLOffre(model.bi))))
				]));
	});
var $author$project$I18n$Cles$referentielRoleDrawerEvoluerTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.role.drawer.evoluer-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Faire évoluer le rôle « ' + (p.bi + ' »'));
	});
var $author$project$I18n$Cles$referentielRoleDrawerNouveauType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.drawer.nouveau-type', _List_Nil, 'Nouveau type');
};
var $author$project$I18n$Cles$referentielRoleDrawerNouvelleFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.drawer.nouvelle-fin', _List_Nil, 'Nouvelle date de fin');
};
var $author$project$I18n$Cles$referentielRoleDrawerNouvelleFinAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.drawer.nouvelle-fin-aide', _List_Nil, 'Une date à venir programme la fin du rôle : il reste actif jusqu\'à cette date incluse.');
};
var $author$project$I18n$Cles$referentielRoleDrawerQuestion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.drawer.question', _List_Nil, 'Que voulez-vous faire ?');
};
var $author$project$I18n$Cles$referentielRoleDrawerRetirerLaFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.drawer.retirer-la-fin', _List_Nil, 'Retirer la date de fin');
};
var $author$project$I18n$Cles$referentielRoleDrawerStatut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.drawer.statut', _List_Nil, 'Statut');
};
var $author$project$I18n$Cles$referentielRoleFaireEvoluer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.faire-evoluer', _List_Nil, 'Faire évoluer');
};
var $author$project$Components$Referentiel$Fiche$Roles$offreDuRoleSaisie = F2(
	function (roles, etat) {
		var _v0 = etat.zT;
		_v0$2:
		while (true) {
			switch (_v0.$) {
				case 1:
					var enCours = _v0.a;
					return enCours.D1;
				case 2:
					if (_v0.b === 1) {
						var uid = _v0.a;
						var _v1 = _v0.b;
						return A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.Aq;
								},
								A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.D1;
									},
									$elm$core$List$head(
										A2(
											$elm$core$List$filter,
											function (role) {
												return _Utils_eq(role.r8, uid);
											},
											roles)))));
					} else {
						break _v0$2;
					}
				default:
					break _v0$2;
			}
		}
		return '';
	});
var $author$project$Components$Referentiel$Fiche$Roles$roleDejaOuvert = F2(
	function (roles, etat) {
		var offre = A2($author$project$Components$Referentiel$Fiche$Roles$offreDuRoleSaisie, roles, etat);
		var surLaMemeOffre = function (role) {
			return _Utils_eq(
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.Aq;
						},
						role.D1)),
				offre);
		};
		return A2(
			$elm$core$Maybe$andThen,
			function (enCours) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (role) {
							return _Utils_eq(role.r0, enCours.r0) && (_Utils_eq(role.vq, $elm$core$Maybe$Nothing) && surLaMemeOffre(role));
						},
						roles));
			},
			$author$project$Components$Referentiel$Fiche$Roles$saisie(etat));
	});
var $author$project$Components$Referentiel$Fiche$View$roleExistant = F3(
	function (i18n, fiche, model) {
		var refuse = function () {
			var _v1 = model.bi.zT;
			switch (_v1.$) {
				case 1:
					var enCours = _v1.a;
					return _Utils_eq(
						enCours.pZ,
						$elm$core$Maybe$Just(0));
				case 2:
					var enCours = _v1.c;
					return _Utils_eq(
						enCours.pZ,
						$elm$core$Maybe$Just(0));
				default:
					return false;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('role-existant')
				]),
			function () {
				var _v0 = _Utils_Tuple2(
					refuse,
					A2($author$project$Components$Referentiel$Fiche$Roles$roleDejaOuvert, fiche.eX, model.bi));
				if (_v0.a && (!_v0.b.$)) {
					var ouvert = _v0.b.a;
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href(
									$author$project$Routes$Route$toString(
										A2($author$project$Routes$Route$Fiche, fiche.r8, 1)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Referentiel$Fiche$View$libelleDuRole, i18n, ouvert))
								]))
						]);
				} else {
					return _List_Nil;
				}
			}());
	});
var $author$project$I18n$Cles$referentielRoleDrawerChoixClore = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.drawer.choix-clore', _List_Nil, 'Clore le rôle');
};
var $author$project$I18n$Cles$referentielRoleDrawerChoixFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.drawer.choix-fin', _List_Nil, 'Modifier la fin');
};
var $author$project$I18n$Cles$referentielRoleDrawerChoixRemplacer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.drawer.choix-remplacer', _List_Nil, 'Remplacer par un autre type de rôle');
};
var $author$project$I18n$Cles$referentielRoleDrawerChoixStatut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.drawer.choix-statut', _List_Nil, 'Changer le statut (même rôle)');
};
var $author$project$Components$Referentiel$Fiche$View$titreDuChoix = F2(
	function (i18n, choix) {
		switch (choix) {
			case 0:
				return $author$project$I18n$Cles$referentielRoleDrawerChoixStatut(i18n);
			case 1:
				return $author$project$I18n$Cles$referentielRoleDrawerChoixRemplacer(i18n);
			case 2:
				return $author$project$I18n$Cles$referentielRoleDrawerChoixClore(i18n);
			default:
				return $author$project$I18n$Cles$referentielRoleDrawerChoixFin(i18n);
		}
	});
var $author$project$Components$Referentiel$Fiche$View$drawerDEvolution = F3(
	function (i18n, fiche, model) {
		var vise = A2(
			$author$project$Components$Referentiel$Fiche$Roles$roleVise,
			_Utils_ap(fiche.eX, fiche.H7),
			model.bi);
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$Fiche$Update$DrawerDEvolutionMsg,
			{
				fs: A3($author$project$Components$Referentiel$Fiche$View$actionDuDrawer, i18n, fiche, model),
				fZ: function () {
					var _v0 = _Utils_Tuple2(model.bi.zT, vise);
					if ((_v0.a.$ === 2) && (!_v0.b.$)) {
						var _v1 = _v0.a;
						var choix = _v1.b;
						var enCours = _v1.c;
						var fourni = _v0.b.a;
						return A2(
							$elm$core$List$cons,
							A2(
								$author$project$Components$Shared$Tuiles$View$view,
								{
									ve: $elm$core$Maybe$Just(
										$author$project$Components$Referentiel$Fiche$Roles$choixCode(choix)),
									Bi: $author$project$I18n$Cles$referentielRoleDrawerQuestion(i18n),
									Dj: 'role-choix',
									Eb: $author$project$Components$Referentiel$Fiche$Update$ChoixDeRoleFait
								},
								A2(
									$elm$core$List$map,
									function (offert) {
										return {
											dH: '',
											h6: A2($author$project$Components$Referentiel$Fiche$View$titreDuChoix, i18n, offert),
											fm: $author$project$Components$Referentiel$Fiche$Roles$choixCode(offert)
										};
									},
									$author$project$Components$Referentiel$Fiche$Roles$choixOfferts(fourni))),
							function () {
								switch (choix) {
									case 0:
										return _List_fromArray(
											[
												A2(
												$author$project$Components$Shared$Champ$View$liste,
												{
													go: A2(
														$elm$core$Maybe$map,
														$author$project$I18n$Cles$texte(i18n),
														$author$project$Components$Referentiel$Fiche$Roles$erreurDuStatut(model.bi)),
													Aq: 'role-statut',
													Bl: $author$project$I18n$Cles$referentielRoleDrawerStatut(i18n),
													he: true
												},
												{
													hg: $author$project$Components$Referentiel$Fiche$Update$StatutDeRoleChoisi,
													o_: A2(
														$elm$core$List$cons,
														$author$project$Components$Referentiel$Fiche$View$aChoisir(i18n),
														A2(
															$elm$core$List$map,
															function (code) {
																return {
																	Bl: A4($author$project$Components$Referentiel$Fiche$Roles$nomDuStatut, i18n, fourni.r0, model.bi, code),
																	fm: code
																};
															},
															A2($author$project$Components$Referentiel$Fiche$Roles$statutsProposes, fourni, model.bi))),
													fm: enCours.ri
												})
											]);
									case 1:
										return _Utils_ap(
											_List_fromArray(
												[
													A5(
													$author$project$Components$Referentiel$Fiche$View$champDuType,
													i18n,
													$author$project$I18n$Cles$referentielRoleDrawerNouveauType(i18n),
													$elm$core$Maybe$Just(fourni),
													enCours.r0,
													model),
													A3($author$project$Components$Referentiel$Fiche$View$offreGardee, i18n, fourni, model),
													A3($author$project$Components$Referentiel$Fiche$View$roleExistant, i18n, fiche, model)
												]),
											A4($author$project$Components$Referentiel$Fiche$View$champsDeCloture, i18n, fourni, enCours, model));
									case 2:
										return A4($author$project$Components$Referentiel$Fiche$View$champsDeCloture, i18n, fourni, enCours, model);
									default:
										return _List_fromArray(
											[
												A5(
												$author$project$Components$Referentiel$Fiche$View$champDeLaDate,
												i18n,
												$author$project$I18n$Cles$referentielRoleDrawerNouvelleFin(i18n),
												$elm$core$Maybe$Just(fourni),
												enCours.wv,
												model),
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$referentielRoleDrawerNouvelleFinAide(i18n))
													])),
												A2(
												$author$project$Components$Shared$Champ$View$caseACocher,
												{
													go: $elm$core$Maybe$Nothing,
													Aq: 'role-retirer-la-fin',
													Bl: $author$project$I18n$Cles$referentielRoleDrawerRetirerLaFin(i18n),
													he: false
												},
												{vt: enCours.b$, D9: $author$project$Components$Referentiel$Fiche$Update$RetraitDeLaFinCoche})
											]);
								}
							}());
					} else {
						return _List_Nil;
					}
				}(),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: A2(
					$elm$core$Maybe$withDefault,
					$author$project$I18n$Cles$referentielRoleFaireEvoluer(i18n),
					A2(
						$elm$core$Maybe$map,
						function (fourni) {
							return A2(
								$author$project$I18n$Cles$referentielRoleDrawerEvoluerTitre,
								i18n,
								{
									bi: A2($author$project$Components$Referentiel$Fiche$View$libelleDuRole, i18n, fourni)
								});
						},
						vise))
			},
			model.k1);
	});
var $author$project$Components$Referentiel$Fiche$Update$DateDExportSaisie = function (a) {
	return {$: 111, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$ExportConfirme = {$: 113};
var $author$project$Components$Referentiel$Fiche$Update$FormatDExportCoche = F2(
	function (a, b) {
		return {$: 112, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Export$idDeLaDate = 'fiche-exporter-date';
var $author$project$I18n$Cles$referentielFicheExportAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.export.action', _List_Nil, 'Générer l\'export');
};
var $author$project$I18n$Cles$referentielFicheExportDate = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.export.date', _List_Nil, 'Date de la demande');
};
var $author$project$I18n$Cles$referentielFicheExportEcheance = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.export.echeance',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Réponse due avant le ' + (p.wv + ' (1 mois).'));
	});
var $author$project$I18n$Cles$referentielFicheExportFormatCsv = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.export.format-csv', _List_Nil, 'CSV (tableur) — un fichier par rubrique');
};
var $author$project$I18n$Cles$referentielFicheExportFormatJson = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.export.format-json', _List_Nil, 'JSON (portabilité) — lisible par une machine, versionné');
};
var $author$project$I18n$Cles$referentielFicheExportPerimetre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.export.perimetre', _List_Nil, 'Le contenu exporté est celui de la fiche et de son coffre : identité, coordonnées, rôles, rattachements. Rien d\'une autre fiche.');
};
var $author$project$Components$Referentiel$Fiche$View$drawerDExport = F3(
	function (i18n, messages, model) {
		var etat = model.ms;
		var enCours = function () {
			var _v0 = model.l2;
			if (_v0.$ === 2) {
				return true;
			} else {
				return false;
			}
		}();
		var echeance = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (apercu) {
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('echeance')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$referentielFicheExportEcheance,
										i18n,
										{
											wv: A2($author$project$Texte$Jour$enFrancais, i18n, apercu.xY)
										}))
								]))
						]);
				},
				etat.tq));
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$Fiche$Update$DrawerDExportMsg,
			{
				fs: {
					sR: $author$project$Components$Referentiel$Fiche$Export$peutConfirmer(etat) && (!enCours),
					Bl: $author$project$I18n$Cles$referentielFicheExportAction(i18n),
					C$: $author$project$Components$Referentiel$Fiche$Update$ExportConfirme
				},
				fZ: _Utils_ap(
					$author$project$Components$Shared$Drawer$Model$estOuvert(etat.kX) ? _List_fromArray(
						[
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages)
						]) : _List_Nil,
					_Utils_ap(
						_List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Champ$View$texte,
								{
									go: $elm$core$Maybe$Nothing,
									Aq: $author$project$Components$Referentiel$Fiche$Export$idDeLaDate,
									Bl: $author$project$I18n$Cles$referentielFicheExportDate(i18n),
									he: true
								},
								{hg: $author$project$Components$Referentiel$Fiche$Update$DateDExportSaisie, fm: etat.wv})
							]),
						_Utils_ap(
							echeance,
							_List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Champ$View$caseACocher,
									{
										go: $elm$core$Maybe$Nothing,
										Aq: 'fiche-export-json',
										Bl: $author$project$I18n$Cles$referentielFicheExportFormatJson(i18n),
										he: false
									},
									{
										vt: etat.gO,
										D9: $author$project$Components$Referentiel$Fiche$Update$FormatDExportCoche('json')
									}),
									A2(
									$author$project$Components$Shared$Champ$View$caseACocher,
									{
										go: $elm$core$Maybe$Nothing,
										Aq: 'fiche-export-csv',
										Bl: $author$project$I18n$Cles$referentielFicheExportFormatCsv(i18n),
										he: false
									},
									{
										vt: etat.f3,
										D9: $author$project$Components$Referentiel$Fiche$Update$FormatDExportCoche('csv')
									}),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$referentielFicheExportPerimetre(i18n))
										]))
								])))),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$referentielFicheExportTitre(i18n)
			},
			etat.kX);
	});
var $author$project$Components$Referentiel$Fiche$Update$DrawerDIdentiteMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$IdentiteValidee = {$: 14};
var $author$project$Components$Referentiel$Fiche$Update$SaisieChangee = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Update$DoublonsGardes = {$: 17};
var $author$project$I18n$Cles$referentielFicheIdentifiantLegalSiren = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.identifiant-legal.siren', _List_Nil, 'SIREN');
};
var $author$project$I18n$Cles$referentielFicheIdentifiantLegalSiret = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.identifiant-legal.siret', _List_Nil, 'SIRET');
};
var $author$project$I18n$Cles$referentielFicheIdentiteDoublonGarder = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.identite.doublon.garder', _List_Nil, 'Garder les deux');
};
var $author$project$I18n$Cles$referentielFicheIdentiteDoublonMention = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.identite.doublon.mention', _List_Nil, 'Aucune fusion automatique. Enregistrer reste possible.');
};
var $author$project$I18n$Cles$referentielFicheIdentiteDoublonOuvrir = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.identite.doublon.ouvrir',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Ouvrir la fiche ' + p.Dj);
	});
var $author$project$I18n$Cles$referentielFicheIdentiteDoublonTexte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.identite.doublon.texte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'sorte',
					$author$project$I18n$Traductions$Chaine(p.rg)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			'Une autre fiche porte déjà ce ' + (p.rg + (' : ' + (p.Dj + (' (' + (p.rg + (' ' + (p.fm + '). Deux fiches ne devraient pas avoir le même identifiant.'))))))));
	});
var $author$project$I18n$Cles$referentielFicheIdentiteDoublonTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.identite.doublon.titre', _List_Nil, 'Doublon possible');
};
var $author$project$Components$Referentiel$Fiche$View$alerteDeDoublon = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.cD, model.dI);
		if ((!_v0.a.$) && (!_v0.b)) {
			var autre = _v0.a.a;
			var saisi = $elm$core$String$trim(
				A2($author$project$Components$Referentiel$Fiche$Model$saisieDe, 7, model));
			var sorte = ((A2($author$project$Components$Referentiel$Fiche$Model$saisieDe, 5, model) === 'FR') && ($elm$core$String$length(
				A2($elm$core$String$filter, $elm$core$Char$isDigit, saisi)) === 14)) ? $author$project$I18n$Cles$referentielFicheIdentifiantLegalSiret(i18n) : $author$project$I18n$Cles$referentielFicheIdentifiantLegalSiren(i18n);
			return A2(
				$author$project$Components$Shared$Note$View$view,
				1,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielFicheIdentiteDoublonTitre(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$referentielFicheIdentiteDoublonTexte,
									i18n,
									{Dj: autre.Dj, rg: sorte, fm: saisi}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('issue')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
										$rtfeldman$elm_css$Html$Styled$Attributes$href(
										$author$project$Routes$Route$toString(
											A2($author$project$Routes$Route$Fiche, autre.r8, 0))),
										$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank'),
										$rtfeldman$elm_css$Html$Styled$Attributes$rel('noopener')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$referentielFicheIdentiteDoublonOuvrir,
											i18n,
											{Dj: autre.Dj}))
									])),
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								2,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Fiche$Update$DoublonsGardes)
									]),
								$author$project$I18n$Cles$referentielFicheIdentiteDoublonGarder(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mention')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielFicheIdentiteDoublonMention(i18n))
							]))
					]));
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
					]),
				_List_Nil);
		}
	});
var $author$project$Components$Referentiel$Fiche$View$formeDe = F2(
	function (fiche, model) {
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.Bl;
			},
			A2(
				$elm$core$Maybe$andThen,
				function (uid) {
					return $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (forme) {
								return _Utils_eq(forme.r8, uid);
							},
							model.zS));
				},
				fiche.gB));
	});
var $author$project$Components$Referentiel$Fiche$View$idDuChamp = function (cle) {
	return 'fiche-champ-' + A3(
		$elm$core$String$replace,
		'.',
		'-',
		$author$project$Components$Referentiel$Fiche$Model$nomAuContrat(cle));
};
var $author$project$I18n$Cles$referentielFicheChampCivilite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.champ.civilite', _List_Nil, 'Civilité');
};
var $author$project$I18n$Cles$referentielFicheChampIdentifiantLegal = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.champ.identifiant-legal', _List_Nil, 'Identifiant légal');
};
var $author$project$I18n$Cles$referentielFicheChampLangue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.champ.langue', _List_Nil, 'Langue');
};
var $author$project$I18n$Cles$referentielFicheChampNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.champ.nom', _List_Nil, 'Nom');
};
var $author$project$I18n$Cles$referentielFicheChampPays = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.champ.pays', _List_Nil, 'Pays');
};
var $author$project$I18n$Cles$referentielFicheChampPrenom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.champ.prenom', _List_Nil, 'Prénom');
};
var $author$project$I18n$Cles$referentielFicheChampQualite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.champ.qualite', _List_Nil, 'Qualité');
};
var $author$project$I18n$Cles$referentielFicheChampRaisonSociale = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.champ.raison-sociale', _List_Nil, 'Raison sociale');
};
var $author$project$Components$Referentiel$Fiche$View$libelleDe = F2(
	function (i18n, cle) {
		switch (cle) {
			case 0:
				return $author$project$I18n$Cles$referentielFicheChampCivilite(i18n);
			case 1:
				return $author$project$I18n$Cles$referentielFicheChampPrenom(i18n);
			case 2:
				return $author$project$I18n$Cles$referentielFicheChampNom(i18n);
			case 3:
				return $author$project$I18n$Cles$referentielFicheChampRaisonSociale(i18n);
			case 4:
				return $author$project$I18n$Cles$referentielFicheChampQualite(i18n);
			case 5:
				return $author$project$I18n$Cles$referentielFicheChampPays(i18n);
			case 6:
				return $author$project$I18n$Cles$referentielFicheChampLangue(i18n);
			default:
				return $author$project$I18n$Cles$referentielFicheChampIdentifiantLegal(i18n);
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$SocieteCochee = function (a) {
	return {$: 18, a: a};
};
var $author$project$I18n$Cles$referentielCreationSocieteCase = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.creation.societe.case',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Rattacher cet établissement à ' + p.Dj);
	});
var $author$project$I18n$Cles$referentielCreationSocieteMention = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.societe.mention', _List_Nil, 'Établissement et société restent deux fiches ; le rattachement se défait depuis la fiche.');
};
var $author$project$I18n$Cles$referentielCreationSocieteTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.societe.texte', _List_Nil, 'Ce SIRET est celui d’un établissement de cette société.');
};
var $author$project$I18n$Cles$referentielCreationSocieteTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.creation.societe.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'siren',
					$author$project$I18n$Traductions$Chaine(p.rc))
				]),
			'Cette société existe déjà : ' + (p.Dj + (' (SIREN ' + (p.rc + ')'))));
	});
var $author$project$Components$Referentiel$Fiche$View$propositionDeSociete = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.b3, model.gt);
		if ((!_v0.a.$) && (_v0.b.$ === 1)) {
			var societe = _v0.a.a;
			var fiche = _v0.b.a;
			return _Utils_eq(fiche.Hy, $elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
				$author$project$Components$Shared$Note$View$view,
				0,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$referentielCreationSocieteTitre,
									i18n,
									{
										Dj: societe.Dj,
										rc: $author$project$Components$Referentiel$Fiche$Model$groupe(
											A2(
												$elm$core$String$left,
												9,
												A2(
													$elm$core$String$filter,
													$elm$core$Char$isDigit,
													A2($author$project$Components$Referentiel$Fiche$Model$saisieDe, 7, model))))
									}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielCreationSocieteTexte(i18n))
							])),
						A2(
						$author$project$Components$Shared$Champ$View$caseACocher,
						{
							go: $elm$core$Maybe$Nothing,
							Aq: 'identite-societe-a-rattacher',
							Bl: A2(
								$author$project$I18n$Cles$referentielCreationSocieteCase,
								i18n,
								{Dj: societe.Dj}),
							he: false
						},
						{vt: !model.b2, D9: $author$project$Components$Referentiel$Fiche$Update$SocieteCochee}),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mention')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielCreationSocieteMention(i18n))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$referentielCreationIdentifiantLegalAideLibre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.identifiant-legal.aide-libre', _List_Nil, 'Numéro libre, 32 caractères au plus. Espaces, points et tirets acceptés.');
};
var $author$project$I18n$Cles$referentielCreationIdentifiantLegalCompteur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.creation.identifiant-legal.compteur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w)),
					_Utils_Tuple2(
					'sur',
					$author$project$I18n$Traductions$Chaine(p.h1))
				]),
			p.w + (' / ' + p.h1));
	});
var $author$project$I18n$Cles$referentielFicheIdentiteDrawerEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.identite.drawer.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$referentielFicheIdentiteDrawerIdentifiantAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.identite.drawer.identifiant-aide', _List_Nil, 'SIREN (9 chiffres) ou SIRET (14 chiffres). Espaces, points et tirets acceptés.');
};
var $author$project$I18n$Cles$referentielFicheIdentiteDrawerNatureNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.identite.drawer.nature-note', _List_Nil, 'La nature (organisation) ne se modifie pas. Vider l\'identifiant le retire de la fiche.');
};
var $author$project$I18n$Cles$referentielFicheIdentiteDrawerPaysModifie = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.identite.drawer.pays-modifie',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'avant',
					$author$project$I18n$Traductions$Chaine(p.je)),
					_Utils_Tuple2(
					'apres',
					$author$project$I18n$Traductions$Chaine(p.iY))
				]),
			'Pays modifié : ' + (p.je + (' devient ' + (p.iY + '. L\'identifiant légal est revérifié pour ce pays.'))));
	});
var $author$project$I18n$Cles$referentielFicheIdentiteDrawerRienModifie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.identite.drawer.rien-modifie', _List_Nil, 'Rien n\'a été modifié');
};
var $author$project$I18n$Cles$referentielFicheIdentiteDrawerSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.identite.drawer.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.Dj + ' · organisation');
	});
var $author$project$I18n$Cles$referentielFicheIdentiteModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.identite.modifier', _List_Nil, 'Modifier l\'identité');
};
var $author$project$I18n$Cles$referentielFicheResumeChampForme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.champ-forme', _List_Nil, 'Forme');
};
var $author$project$Components$Referentiel$Fiche$View$drawerDIdentite = F3(
	function (i18n, fiche, model) {
		var paysAvant = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($author$project$Components$Referentiel$Fiche$Model$valeurDe, 5, fiche));
		var pays = A2($author$project$Components$Referentiel$Fiche$Model$saisieDe, 5, model);
		var ouvert = _Utils_eq(model.ge, $author$project$Components$Referentiel$Fiche$Model$DansLeDrawerDIdentite);
		var formeFixe = A2(
			$author$project$Components$Shared$Champ$View$compose,
			{
				go: $elm$core$Maybe$Nothing,
				Aq: 'fiche-identite-forme',
				Bl: $author$project$I18n$Cles$referentielFicheResumeChampForme(i18n),
				he: false
			},
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$select,
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true),
						$author$project$Components$Shared$Champ$View$attributs(
							{
								go: $elm$core$Maybe$Nothing,
								Aq: 'fiche-identite-forme',
								Bl: $author$project$I18n$Cles$referentielFicheResumeChampForme(i18n),
								he: false
							})),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$option,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(true)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2($author$project$Components$Referentiel$Fiche$View$formeDe, fiche, model)))
								]))
						]))
				]));
		var enCours = function () {
			var _v0 = model.l2;
			if (_v0.$ === 2) {
				return true;
			} else {
				return false;
			}
		}();
		var champDe = function (cle) {
			return {
				go: A2(
					$elm$core$Maybe$map,
					$author$project$I18n$Cles$texte(i18n),
					A2($author$project$Components$Referentiel$Fiche$Model$erreurDe, cle, model)),
				Aq: $author$project$Components$Referentiel$Fiche$View$idDuChamp(cle),
				Bl: A2($author$project$Components$Referentiel$Fiche$View$libelleDe, i18n, cle),
				he: false
			};
		};
		return A6(
			$author$project$Components$Shared$Drawer$View$viewAvecSousTitreEtNote,
			i18n,
			$elm$core$Maybe$Just(
				A2(
					$author$project$I18n$Cles$referentielFicheIdentiteDrawerSousTitre,
					i18n,
					{
						Dj: A2(
							$author$project$Components$Referentiel$Fiche$Model$texteDuTitre,
							i18n,
							A2($author$project$Components$Referentiel$Fiche$Model$titreDe, fiche.g1, fiche.dw))
					})),
			(ouvert && $author$project$Components$Referentiel$Fiche$Model$sansSaisieEnCours(model)) ? $elm$core$Maybe$Just(
				$author$project$I18n$Cles$referentielFicheIdentiteDrawerRienModifie(i18n)) : $elm$core$Maybe$Nothing,
			$author$project$Components$Referentiel$Fiche$Update$DrawerDIdentiteMsg,
			{
				fs: {
					sR: !enCours,
					Bl: $author$project$I18n$Cles$referentielFicheIdentiteDrawerEnregistrer(i18n),
					C$: $author$project$Components$Referentiel$Fiche$Update$IdentiteValidee
				},
				fZ: ouvert ? _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Champ$View$texte,
						champDe(3),
						{
							hg: $author$project$Components$Referentiel$Fiche$Update$SaisieChangee(3),
							fm: A2($author$project$Components$Referentiel$Fiche$Model$saisieDe, 3, model)
						}),
						formeFixe,
						A2(
						$author$project$Components$Shared$Champ$View$liste,
						champDe(5),
						{
							hg: $author$project$Components$Referentiel$Fiche$Update$SaisieChangee(5),
							o_: A2(
								$elm$core$List$map,
								function (p) {
									return {Bl: p.Dj, fm: p.vx};
								},
								$author$project$Referentiel$Normes$entreesDePays(model.hd)),
							fm: pays
						}),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide'),
								$rtfeldman$elm_css$Html$Styled$Attributes$id('fiche-identite-pays-aide')
							]),
						((!_Utils_eq(pays, paysAvant)) && (pays !== '')) ? _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$referentielFicheIdentiteDrawerPaysModifie,
									i18n,
									{
										iY: A2($author$project$Referentiel$Normes$nomDePays, model.hd, pays),
										je: A2($author$project$Referentiel$Normes$nomDePays, model.hd, paysAvant)
									}))
							]) : _List_Nil),
						A2(
						$author$project$Components$Shared$Champ$View$texteDecritPar,
						champDe(7),
						{
							wV: 'fiche-identite-identifiant-aide',
							hg: $author$project$Components$Referentiel$Fiche$Update$SaisieChangee(7),
							fm: A2($author$project$Components$Referentiel$Fiche$Model$saisieDe, 7, model)
						}),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('compteur')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								((pays === 'FR') || (pays === '')) ? '' : A2(
									$author$project$I18n$Cles$referentielCreationIdentifiantLegalCompteur,
									i18n,
									{
										w: $elm$core$String$fromInt(
											$elm$core$String$length(
												A2($author$project$Components$Referentiel$Fiche$Model$saisieDe, 7, model))),
										h1: '32'
									}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide'),
								$rtfeldman$elm_css$Html$Styled$Attributes$id('fiche-identite-identifiant-aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								((pays === 'FR') || (pays === '')) ? $author$project$I18n$Cles$referentielFicheIdentiteDrawerIdentifiantAide(i18n) : $author$project$I18n$Cles$referentielCreationIdentifiantLegalAideLibre(i18n))
							])),
						A2($author$project$Components$Referentiel$Fiche$View$alerteDeDoublon, i18n, model),
						A2($author$project$Components$Referentiel$Fiche$View$propositionDeSociete, i18n, model),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielFicheIdentiteDrawerNatureNote(i18n))
							]))
					]) : _List_Nil,
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$referentielFicheIdentiteModifier(i18n)
			},
			model.k2);
	});
var $author$project$Components$Referentiel$Fiche$Update$OffreDeRoleChoisie = function (a) {
	return {$: 38, a: a};
};
var $author$project$I18n$Cles$referentielRoleDrawerOffreAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.drawer.offre-aucune', _List_Nil, 'Aucune (relation générale)');
};
var $author$project$I18n$Cles$referentielRoleDrawerOffresIllisibles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.drawer.offres-illisibles', _List_Nil, 'Les offres n\'ont pas pu être lues. Le rôle peut s\'ouvrir sans offre.');
};
var $author$project$Components$Referentiel$Fiche$View$champDeLOffre = F4(
	function (i18n, fiche, choisie, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('offre-du-role')
				]),
			function () {
				var _v0 = _Utils_Tuple2(fiche.D6, model.bi.D3);
				if (_v0.a.$ === 1) {
					var _v1 = _v0.a;
					return _List_Nil;
				} else {
					if (_v0.b.$ === 2) {
						var _v2 = _v0.b;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('erreur')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielRoleDrawerOffresIllisibles(i18n))
									]))
							]);
					} else {
						return _List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Champ$View$liste,
								{
									go: $elm$core$Maybe$Nothing,
									Aq: 'role-offre',
									Bl: $author$project$I18n$Cles$referentielRoleDrawerOffre(i18n),
									he: false
								},
								{
									hg: $author$project$Components$Referentiel$Fiche$Update$OffreDeRoleChoisie,
									o_: A2(
										$elm$core$List$cons,
										{
											Bl: $author$project$I18n$Cles$referentielRoleDrawerOffreAucune(i18n),
											fm: ''
										},
										A2(
											$elm$core$List$map,
											function (offre) {
												return {
													Bl: A2($author$project$I18n$Cles$texte, i18n, offre.Dj),
													fm: offre.Aq
												};
											},
											$author$project$Components$Referentiel$Fiche$Roles$offresProposees(model.bi))),
									fm: choisie
								})
							]);
					}
				}
			}());
	});
var $author$project$I18n$Cles$referentielRoleDrawerDateDeDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.drawer.date-de-debut', _List_Nil, 'Date de début');
};
var $author$project$I18n$Cles$referentielRoleDrawerDateDeDebutAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.drawer.date-de-debut-aide', _List_Nil, 'Sans date, le rôle est sans date de début. Avec une date à venir, il prendra effet à cette date.');
};
var $author$project$I18n$Cles$referentielRoleDrawerOuvrirTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.drawer.ouvrir-titre', _List_Nil, 'Ouvrir un rôle');
};
var $author$project$I18n$Cles$referentielRoleDrawerType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.drawer.type', _List_Nil, 'Type');
};
var $author$project$Components$Referentiel$Fiche$View$refusDeLOffre = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('refus'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
				]),
			function () {
				var _v0 = $author$project$Components$Referentiel$Fiche$Roles$erreurDeLOffre(model.bi);
				if (!_v0.$) {
					var message = _v0.a;
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$I18n$Cles$texte, i18n, message))
								]))
						]);
				} else {
					return _List_Nil;
				}
			}());
	});
var $author$project$Components$Referentiel$Fiche$View$drawerDOuverture = F3(
	function (i18n, fiche, model) {
		return A5(
			$author$project$Components$Shared$Drawer$View$viewAvecSousTitre,
			i18n,
			A2($author$project$Components$Referentiel$Fiche$View$titreDeLaFiche, i18n, fiche),
			$author$project$Components$Referentiel$Fiche$Update$DrawerDOuvertureMsg,
			{
				fs: A3($author$project$Components$Referentiel$Fiche$View$actionDuDrawer, i18n, fiche, model),
				fZ: function () {
					var _v0 = model.bi.zT;
					if (_v0.$ === 1) {
						var enCours = _v0.a;
						return _List_fromArray(
							[
								A2($author$project$Components$Referentiel$Fiche$View$refusDeLOffre, i18n, model),
								A5(
								$author$project$Components$Referentiel$Fiche$View$champDuType,
								i18n,
								$author$project$I18n$Cles$referentielRoleDrawerType(i18n),
								$elm$core$Maybe$Nothing,
								enCours.r0,
								model),
								A4($author$project$Components$Referentiel$Fiche$View$champDeLOffre, i18n, fiche, enCours.D1, model),
								A3($author$project$Components$Referentiel$Fiche$View$roleExistant, i18n, fiche, model),
								A5(
								$author$project$Components$Referentiel$Fiche$View$champDeLaDate,
								i18n,
								$author$project$I18n$Cles$referentielRoleDrawerDateDeDebut(i18n),
								$elm$core$Maybe$Nothing,
								enCours.wv,
								model),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielRoleDrawerDateDeDebutAide(i18n))
									]))
							]);
					} else {
						return _List_Nil;
					}
				}(),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$referentielRoleDrawerOuvrirTitre(i18n)
			},
			model.k4);
	});
var $author$project$Components$Referentiel$Fiche$View$libelleDuChampDuType = F2(
	function (nom, lignes) {
		return A2(
			$elm$core$Maybe$withDefault,
			nom,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filterMap,
						function ($) {
							return $.uP;
						},
						A2(
							$elm$core$List$filter,
							function (ligne) {
								return _Utils_eq(
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.Dj;
										},
										ligne.uN),
									$elm$core$Maybe$Just(nom));
							},
							lignes)))));
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueChampColonneDate = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.champ.colonne.date', _List_Nil, 'Date');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueChampColonnePar = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.champ.colonne.par', _List_Nil, 'Par · source');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueChampColonneValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.champ.colonne.valeur', _List_Nil, 'Valeur');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueChampConsultationTracee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.champ.consultation-tracee', _List_Nil, 'Consultation tracée.');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueChampExpiree = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.champ.expiree',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Expirée le ' + p.wv);
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueChampIntrouvable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.champ.introuvable', _List_Nil, 'Cet historique est introuvable.');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueChampTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.historique.champ.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'Historique du champ « ' + (p.uN + ' »'));
	});
var $author$project$Components$Referentiel$Fiche$View$drawerDeLHistorique = F3(
	function (i18n, fiche, model) {
		var panneau = model.m6.bR;
		var introuvable = _Utils_eq(
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.u7;
				},
				panneau),
			$elm$core$Maybe$Just(4));
		var cle = A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.uN;
				},
				$author$project$Components$Referentiel$Fiche$Model$cleDuContrat),
			panneau);
		var lisible = function (valeur) {
			var _v4 = _Utils_Tuple2(valeur, cle);
			if ((_v4.a.$ === 1) && (!_v4.b.$)) {
				var code = _v4.a.a;
				var connue = _v4.b.a;
				return A4($author$project$Components$Referentiel$Fiche$View$affichee, i18n, model.hd, connue, code);
			} else {
				return A2($author$project$Components$Referentiel$Fiche$Historique$libelleDeLaValeur, i18n, valeur);
			}
		};
		var nom = function () {
			var _v0 = _Utils_Tuple2(cle, panneau);
			if (!_v0.a.$) {
				var connue = _v0.a.a;
				return A2($author$project$Components$Referentiel$Fiche$View$libelleDe, i18n, connue);
			} else {
				if (!_v0.b.$) {
					var _v1 = _v0.a;
					var ouvert = _v0.b.a;
					return A2(
						$elm$core$Maybe$withDefault,
						A2($author$project$Components$Referentiel$Fiche$View$libelleDuChampDuType, ouvert.uN, model.m6.gV),
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.uF;
								},
								$author$project$I18n$Cles$texte(i18n)),
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (connu) {
										return _Utils_eq(
											$author$project$Components$Referentiel$Fiche$View$champDuContact(connu.r8),
											ouvert.uN);
									},
									fiche.wa))));
				} else {
					var _v2 = _v0.a;
					var _v3 = _v0.b;
					return '';
				}
			}
		}();
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$Fiche$Update$DrawerDeLHistoriqueMsg,
			{
				fs: {
					sR: true,
					Bl: $author$project$I18n$Cles$drawerFermer(i18n),
					C$: $author$project$Components$Referentiel$Fiche$Update$DrawerDeLHistoriqueMsg($author$project$Components$Shared$Drawer$Update$Fermer)
				},
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('consultation-tracee')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$elm$core$Maybe$withDefault,
									false,
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.Fe;
										},
										panneau)) ? $author$project$I18n$Cles$referentielFicheHistoriqueChampConsultationTracee(i18n) : '')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('introuvable'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
							]),
						introuvable ? _List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Note$View$view,
								1,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$referentielFicheHistoriqueChampIntrouvable(i18n))
											]))
									]))
							]) : _List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau'),
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'loading',
										_Utils_eq(
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.u7;
												},
												panneau),
											$elm$core$Maybe$Just(1))),
										_Utils_Tuple2('hidden', introuvable)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$table,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$referentielFicheHistoriqueChampColonneValeur(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$referentielFicheHistoriqueChampColonnePar(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$referentielFicheHistoriqueChampColonneDate(i18n))
															]))
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$tbody,
										_List_Nil,
										A2(
											$elm$core$List$map,
											function (valeur) {
												return A2(
													$rtfeldman$elm_css$Html$Styled$tr,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$classList(
															_List_fromArray(
																[
																	_Utils_Tuple2('actuelle', valeur.sV)
																]))
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$td,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
																]),
															A2(
																$elm$core$List$cons,
																$rtfeldman$elm_css$Html$Styled$text(
																	lisible(valeur.fm)),
																A2(
																	$elm$core$Maybe$withDefault,
																	_List_Nil,
																	A2(
																		$elm$core$Maybe$map,
																		function (jour) {
																			return _List_fromArray(
																				[
																					A2(
																					$rtfeldman$elm_css$Html$Styled$span,
																					_List_fromArray(
																						[
																							$rtfeldman$elm_css$Html$Styled$Attributes$class('expiree')
																						]),
																					_List_fromArray(
																						[
																							$rtfeldman$elm_css$Html$Styled$text(
																							A2(
																								$author$project$I18n$Cles$referentielFicheHistoriqueChampExpiree,
																								i18n,
																								{
																									wv: A2($author$project$I18n$Cles$texte, i18n, jour)
																								}))
																						]))
																				]);
																		},
																		valeur.y5)))),
															A2(
															$rtfeldman$elm_css$Html$Styled$td,
															_List_Nil,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	A3($author$project$Components$Referentiel$Fiche$View$par, i18n, valeur.t1, valeur.IR))
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$td,
															_List_Nil,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	A2($author$project$I18n$Cles$texte, i18n, valeur.hz))
																]))
														]));
											},
											A2(
												$elm$core$Maybe$withDefault,
												_List_Nil,
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.Ki;
													},
													panneau))))
									]))
							]))
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: true,
				h6: A2(
					$author$project$I18n$Cles$referentielFicheHistoriqueChampTitre,
					i18n,
					{uN: nom})
			},
			model.k9);
	});
var $author$project$Components$Referentiel$Fiche$Update$DeLOccurrence = function (a) {
	return {$: 121, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$DrawerDeLOccurrenceMsg = function (a) {
	return {$: 125, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$OccurrenceValidee = {$: 123};
var $author$project$Components$Referentiel$Fiche$Update$OccurrenceDemandee = F3(
	function (a, b, c) {
		return {$: 120, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Fiche$View$uneSeuleOccurrence = F4(
	function (i18n, fiche, model, ouverte) {
		var existante = A2(
			$elm$core$Maybe$andThen,
			function (bloc) {
				return $elm$core$List$head(
					$author$project$Components$Shared$EditeurDeSchema$Groupe$occurrences(
						A2($author$project$Components$Referentiel$Fiche$Occurrences$valeurDe, bloc, ouverte.uw.uN)));
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.r0;
						},
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.r8;
							},
							$elm$core$Basics$eq(ouverte.r0))),
					fiche.uW)));
		var _v0 = _Utils_Tuple2(model.oV.J8, existante);
		if (_v0.a && (!_v0.b.$)) {
			var premiere = _v0.b.a;
			return A2(
				$author$project$Components$Shared$Note$View$view,
				1,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$b,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$groupeDeSousChampsRefusUneSeuleTitre,
									i18n,
									{uN: ouverte.uw.Dj}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$groupeDeSousChampsRefusUneSeuleExplication(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								A3(
									$author$project$Components$Referentiel$Fiche$Update$OccurrenceDemandee,
									ouverte.r0,
									ouverte.uw.uN,
									$elm$core$Maybe$Just(premiere.r8)))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$groupeDeSousChampsRefusUneSeuleAction(i18n))
									]))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Referentiel$Fiche$View$drawerDeLOccurrence = F3(
	function (i18n, fiche, model) {
		var sansGeste = {
			fs: {sR: false, Bl: '', C$: $author$project$Components$Referentiel$Fiche$Update$OccurrenceValidee},
			fZ: _List_Nil,
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: ''
		};
		var etat = model.oV;
		var envoiPossible = function () {
			var _v4 = model.l2;
			if (_v4.$ === 2) {
				return false;
			} else {
				return true;
			}
		}();
		var choixDuType = function (type_) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.jN;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.r0;
								},
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.r8;
									},
									$elm$core$Basics$eq(type_))),
							fiche.uW))));
		};
		var presentation = F2(
			function (type_, schema) {
				return {
					fr: function (_v3) {
						return 0;
					},
					dw: _List_Nil,
					jN: choixDuType(type_),
					Ba: schema.Ba,
					np: false,
					hd: model.hd,
					pv: $author$project$Components$Referentiel$Fiche$Update$prefixeDesOccurrences,
					sb: schema.sb
				};
			});
		var contenu = function () {
			var _v0 = _Utils_Tuple2(etat.Et, etat.dh);
			if (!_v0.a.$) {
				var ouverte = _v0.a.a;
				var _v1 = A2($author$project$Components$Referentiel$Fiche$Model$schemaDuType, ouverte.r0, model);
				if (!_v1.$) {
					var schema = _v1.a;
					return {
						fs: {
							sR: envoiPossible,
							Bl: (ouverte.uw.HI && _Utils_eq(ouverte.uw.r8, $elm$core$Maybe$Nothing)) ? $author$project$I18n$Cles$groupeDeSousChampsActionAjouter(i18n) : $author$project$I18n$Cles$groupeDeSousChampsActionEnregistrer(i18n),
							C$: $author$project$Components$Referentiel$Fiche$Update$OccurrenceValidee
						},
						fZ: _Utils_ap(
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('sous-titre')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$Components$Shared$EditeurDeSchema$Groupe$sousTitre, i18n, ouverte.uw))
										])),
									A4($author$project$Components$Referentiel$Fiche$View$uneSeuleOccurrence, i18n, fiche, model, ouverte)
								]),
							A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Referentiel$Fiche$Update$DeLOccurrence),
								A3(
									$author$project$Components$Shared$EditeurDeSchema$Groupe$corps,
									i18n,
									A2(presentation, ouverte.r0, schema),
									ouverte.uw))),
						A6: $elm$core$Maybe$Nothing,
						Bc: true,
						h6: A2($author$project$Components$Shared$EditeurDeSchema$Groupe$titre, i18n, ouverte.uw)
					};
				} else {
					return sansGeste;
				}
			} else {
				if (!_v0.b.$) {
					var _v2 = _v0.a;
					var retrait = _v0.b.a;
					return {
						fs: {
							sR: envoiPossible,
							Bl: $author$project$I18n$Cles$groupeDeSousChampsActionRetirer(i18n),
							C$: $author$project$Components$Referentiel$Fiche$Update$OccurrenceValidee
						},
						fZ: A2($author$project$Components$Shared$EditeurDeSchema$Groupe$confirmationDeRetrait, i18n, retrait.Dj),
						A6: $elm$core$Maybe$Nothing,
						Bc: false,
						h6: A2(
							$author$project$I18n$Cles$groupeDeSousChampsTitreRetirer,
							i18n,
							{
								D$: A2($author$project$I18n$Cles$texte, i18n, retrait.D$)
							})
					};
				} else {
					return sansGeste;
				}
			}
		}();
		return (!_Utils_eq(etat.dh, $elm$core$Maybe$Nothing)) ? A4($author$project$Components$Shared$Drawer$View$viewDestructif, i18n, $author$project$Components$Referentiel$Fiche$Update$DrawerDeLOccurrenceMsg, contenu, etat.kX) : A4($author$project$Components$Shared$Drawer$View$view, i18n, $author$project$Components$Referentiel$Fiche$Update$DrawerDeLOccurrenceMsg, contenu, etat.kX);
	});
var $author$project$Components$Referentiel$Fiche$Update$FinSaisie = function (a) {
	return {$: 54, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$IntituleSaisi = function (a) {
	return {$: 67, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$PhraseChoisie = function (a) {
	return {$: 82, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$PosteChoisi = function (a) {
	return {$: 66, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$PrincipalCoche = function (a) {
	return {$: 68, a: a};
};
var $author$project$Components$Shared$Champ$View$idAide = function (champ) {
	return champ.Aq + '-aide';
};
var $author$project$Components$Shared$Champ$View$dateAvecAide = F2(
	function (champ, saisie) {
		var aide = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Maybe$map, $elm$core$List$singleton, saisie.bp));
		return A2(
			$author$project$Components$Shared$Champ$View$formItem,
			champ,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('date'),
						A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Attributes$value(saisie.fm),
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_css$Html$Styled$Events$onInput(saisie.hg),
								A2(
									$elm$core$List$cons,
									$rtfeldman$elm_css$Html$Styled$Attributes$id(champ.Aq),
									A2(
										$elm$core$List$cons,
										A2(
											$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
											'aria-labelledby',
											$author$project$Components$Shared$Champ$View$idLibelle(champ)),
										A2(
											$author$project$Components$Shared$Champ$View$etatsDecrits,
											A2(
												$elm$core$List$map,
												function (_v0) {
													return $author$project$Components$Shared$Champ$View$idAide(champ);
												},
												aide),
											champ)))))),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('aide'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(
							$author$project$Components$Shared$Champ$View$idAide(champ))
						]),
					A2($elm$core$List$map, $rtfeldman$elm_css$Html$Styled$text, aide))
				]));
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$erreurDeLaFin = function (etat) {
	return etat.P ? $author$project$Components$Referentiel$Fiche$Liaisons$erreurDeLaSaisie(etat.mW) : $elm$core$Maybe$Nothing;
};
var $author$project$I18n$Cles$referentielRelationRefusDejaRattache = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.relation.refus.deja-rattache', _List_Nil, 'Cet établissement est déjà rattaché à une société : déliez-le d\'abord de sa société actuelle, puis reliez-le à la nouvelle.');
};
var $author$project$I18n$Cles$referentielRelationRefusHorsPerimetreCetteFiche = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.relation.refus.hors-perimetre.cette-fiche',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			'Cette fiche n\'est pas dans le périmètre de « ' + (p.Bl + ' » : choisissez un autre type, ou modifiez son périmètre dans le paramétrage.'));
	});
var $author$project$I18n$Cles$referentielRelationRefusHorsPerimetreFicheChoisie = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.relation.refus.hors-perimetre.fiche-choisie',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			'La fiche choisie n\'est pas dans le périmètre de « ' + (p.Bl + ' » : choisissez une autre fiche ou un autre type, ou modifiez son périmètre dans le paramétrage.'));
	});
var $author$project$I18n$Cles$referentielRelationRefusQualiteInconnue = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.relation.refus.qualite-inconnue',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			'Le périmètre de « ' + (p.Bl + ' » ne peut pas être vérifié : la qualité de l\'une des deux personnes (professionnelle ou particulière) n\'est pas renseignée. Renseignez-la sur sa fiche, puis réessayez.'));
	});
var $author$project$I18n$Cles$referentielRelationRefusSirenDifferent = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.relation.refus.siren-different', _List_Nil, 'Le SIRET de l\'établissement n\'a pas le SIREN de la société : corrigez l\'identifiant légal de l\'une des deux fiches, puis reliez à nouveau.');
};
var $author$project$I18n$Cles$referentielRelationRefusSocieteDejaEtablissement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.relation.refus.societe-deja-etablissement', _List_Nil, 'Un seul étage : cette société est elle-même l\'établissement d\'une autre, ou l\'établissement choisi est déjà une société. Déliez le lien existant, puis reliez à nouveau.');
};
var $author$project$I18n$Cles$referentielRelationRefusTypeArchive = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.relation.refus.type-archive',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			'Le type « ' + (p.Bl + ' » est archivé : choisissez un autre type, ou restaurez-le dans le paramétrage.'));
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$direLeRefus = F2(
	function (i18n, refus) {
		var _v0 = refus.pH;
		switch (_v0.$) {
			case 0:
				var cote = _v0.a;
				return _Utils_eq(!cote, refus.xA) ? A2(
					$author$project$I18n$Cles$referentielRelationRefusHorsPerimetreCetteFiche,
					i18n,
					{Bl: refus.Bl}) : A2(
					$author$project$I18n$Cles$referentielRelationRefusHorsPerimetreFicheChoisie,
					i18n,
					{Bl: refus.Bl});
			case 1:
				return A2(
					$author$project$I18n$Cles$referentielRelationRefusTypeArchive,
					i18n,
					{Bl: refus.Bl});
			case 2:
				return A2(
					$author$project$I18n$Cles$referentielRelationRefusQualiteInconnue,
					i18n,
					{Bl: refus.Bl});
			case 3:
				return $author$project$I18n$Cles$referentielRelationRefusDejaRattache(i18n);
			case 4:
				return $author$project$I18n$Cles$referentielRelationRefusSocieteDejaEtablissement(i18n);
			default:
				return $author$project$I18n$Cles$referentielRelationRefusSirenDifferent(i18n);
		}
	});
var $author$project$I18n$Cles$referentielFicheChampObligatoire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.champ.obligatoire', _List_Nil, 'Ce champ est obligatoire.');
};
var $author$project$Components$Referentiel$Fiche$Liaisons$erreurDeLaPhrase = F2(
	function (i18n, etat) {
		var _v0 = etat.pZ;
		if (!_v0.$) {
			var refus = _v0.a;
			return $elm$core$Maybe$Just(
				A2($author$project$Components$Referentiel$Fiche$Liaisons$direLeRefus, i18n, refus));
		} else {
			var _v1 = _Utils_Tuple2(etat.P, etat.mW);
			if (_v1.a && (_v1.b.$ === 5)) {
				var _v2 = _v1.b;
				var saisie = _v2.b;
				return A2(
					$elm$core$List$any,
					function (proposee) {
						return _Utils_eq(proposee.fm, saisie.Fp);
					},
					$author$project$Components$Referentiel$Fiche$Liaisons$phrases(etat)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$I18n$Cles$referentielFicheChampObligatoire(i18n));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$I18n$Cles$posteRattachementRefusArchive = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'poste.rattachement.refus-archive', _List_Nil, 'Ce poste n\'est plus proposé : il a été archivé. Les postes proposés sont relus ; choisissez-en un autre ou laissez le poste vide.');
};
var $author$project$I18n$Cles$posteRattachementRefusDejaPris = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'poste.rattachement.refus-deja-pris', _List_Nil, 'Cette personne est déjà rattachée à cette organisation sur ce poste. Choisissez un autre poste, ou terminez d\'abord le rattachement en cours.');
};
var $author$project$Components$Referentiel$Fiche$Liaisons$erreurDuPoste = F2(
	function (i18n, etat) {
		return etat.bU ? $elm$core$Maybe$Just(
			$author$project$I18n$Cles$posteRattachementRefusArchive(i18n)) : (etat.bV ? $elm$core$Maybe$Just(
			$author$project$I18n$Cles$posteRattachementRefusDejaPris(i18n)) : $elm$core$Maybe$Nothing);
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$idDeLIntitule = 'rattachement-intitule';
var $author$project$Components$Referentiel$Fiche$Liaisons$idDeLaFin = 'rattachement-fin';
var $author$project$I18n$Cles$referentielRelationPhrase = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.relation.phrase',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'phrase',
					$author$project$I18n$Traductions$Chaine(p.Fp))
				]),
			p.Dj + (' · ' + (p.Fp + '…')));
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$phrasesProposees = F2(
	function (i18n, etat) {
		var _v0 = etat.mW;
		if (_v0.$ === 5) {
			var contexte = _v0.a;
			return A2(
				$elm$core$List$cons,
				{Bl: '', fm: ''},
				A2(
					$elm$core$List$map,
					function (proposee) {
						return {
							Bl: A2(
								$author$project$I18n$Cles$referentielRelationPhrase,
								i18n,
								{
									Dj: A2(
										$elm$core$String$join,
										' ',
										A2(
											$elm$core$List$map,
											$author$project$I18n$Cles$texte(i18n),
											contexte.Dj)),
									Fp: proposee.Bl
								}),
							fm: proposee.fm
						};
					},
					$author$project$Components$Referentiel$Fiche$Liaisons$phrases(etat)));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$proposerLePoste = F2(
	function (i18n, poste) {
		return {
			Bl: A2($author$project$I18n$Cles$texte, i18n, poste.Bl),
			fm: $author$project$Components$Referentiel$Identifiants$posteUidToString(poste.r8)
		};
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$postesProposes = F2(
	function (i18n, etat) {
		var _v0 = etat.mW;
		switch (_v0.$) {
			case 3:
				var rattachement = _v0.a;
				var duRattachement = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$elm$core$List$singleton,
						A3(
							$elm$core$Maybe$map2,
							F2(
								function (uid, libelle) {
									return {Bl: libelle, r8: uid};
								}),
							rattachement.F5,
							rattachement.F4)));
				var connus = $elm$core$List$isEmpty(etat.F6) ? duRattachement : etat.F6;
				return _Utils_ap(
					_Utils_eq(rattachement.F5, $elm$core$Maybe$Nothing) ? _List_fromArray(
						[
							{Bl: '', fm: ''}
						]) : _List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Components$Referentiel$Fiche$Liaisons$proposerLePoste(i18n),
						connus));
			case 4:
				return A2(
					$elm$core$List$cons,
					{Bl: '', fm: ''},
					A2(
						$elm$core$List$map,
						$author$project$Components$Referentiel$Fiche$Liaisons$proposerLePoste(i18n),
						etat.F6));
			default:
				return _List_Nil;
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$PersonneACreerDemandee = {$: 84};
var $author$project$Components$Referentiel$Fiche$Update$PropositionChoisie = function (a) {
	return {$: 75, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$RechercheSaisie = function (a) {
	return {$: 72, a: a};
};
var $author$project$I18n$Cles$referentielRelationExisteDeja = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.relation.existe-deja', _List_Nil, 'Cette relation existe déjà');
};
var $author$project$Components$Referentiel$Fiche$Liaisons$erreurDeLaRecherche = F2(
	function (i18n, etat) {
		var _v0 = _Utils_Tuple2(
			etat.P,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ve;
				},
				$author$project$Components$Referentiel$Fiche$Liaisons$saisieDeLaRecherche(etat)));
		if ((_v0.a && (!_v0.b.$)) && (_v0.b.a.$ === 1)) {
			var _v1 = _v0.b.a;
			return $elm$core$Maybe$Just(
				$author$project$I18n$Cles$referentielFicheChampObligatoire(i18n));
		} else {
			return etat.aX ? $elm$core$Maybe$Just(
				$author$project$I18n$Cles$referentielRelationExisteDeja(i18n)) : $elm$core$Maybe$Nothing;
		}
	});
var $author$project$I18n$Cles$referentielRattachementRattacherCreerUnePersonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.rattacher.creer-une-personne', _List_Nil, '+ Créer une nouvelle personne');
};
var $author$project$Components$Referentiel$Common$RechercheDeFiche$valeurDuChamp = F2(
	function (i18n, recherche) {
		return A2(
			$elm$core$Maybe$withDefault,
			recherche.h3,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Dj;
					},
					$author$project$I18n$Cles$texte(i18n)),
				recherche.ve));
	});
var $author$project$Components$Referentiel$Fiche$View$recherche = F4(
	function (i18n, model, libelle, saisie_) {
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Champ$View$texte,
				{
					go: A2($author$project$Components$Referentiel$Fiche$Liaisons$erreurDeLaRecherche, i18n, model.Bk),
					Aq: $author$project$Components$Referentiel$Fiche$Liaisons$idDeLaRecherche,
					Bl: libelle,
					he: true
				},
				{
					hg: $author$project$Components$Referentiel$Fiche$Update$RechercheSaisie,
					fm: A2($author$project$Components$Referentiel$Common$RechercheDeFiche$valeurDuChamp, i18n, saisie_)
				}),
				A2(
				$rtfeldman$elm_css$Html$Styled$ul,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('propositions')
					]),
				A2(
					$elm$core$List$map,
					function (proposee) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('proposition'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Referentiel$Fiche$Update$PropositionChoisie(proposee.r8))
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$strong,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2($author$project$I18n$Cles$texte, i18n, proposee.Dj))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('nature')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2($author$project$I18n$Cles$texte, i18n, proposee.g1))
												]))
										]))
								]));
					},
					saisie_.Gw)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('creer')
					]),
				$author$project$Components$Referentiel$Fiche$Model$personneACreer(model) ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('creer-une-personne'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Fiche$Update$PersonneACreerDemandee)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielRattachementRattacherCreerUnePersonne(i18n))
							]))
					]) : _List_Nil)
			]);
	});
var $author$project$I18n$Cles$referentielRattachementContactPrincipalDeLOrganisation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.contact-principal-de-l-organisation', _List_Nil, 'Contact principal de l\'organisation');
};
var $author$project$I18n$Cles$referentielRattachementFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.fin', _List_Nil, 'Fin');
};
var $author$project$I18n$Cles$referentielRattachementFinAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.fin.aide', _List_Nil, 'Vide : le rattachement n\'a plus de fin.');
};
var $author$project$I18n$Cles$referentielRattachementIntituleFacultatif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.intitule-facultatif', _List_Nil, 'Intitulé (facultatif)');
};
var $author$project$I18n$Cles$referentielRattachementModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.modifier', _List_Nil, 'Modifier');
};
var $author$project$I18n$Cles$referentielRattachementModifierLaFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.modifier-la-fin', _List_Nil, 'Modifier la fin');
};
var $author$project$I18n$Cles$referentielRattachementPoste = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.poste', _List_Nil, 'Poste');
};
var $author$project$I18n$Cles$referentielRattachementRattacherAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.rattacher.action', _List_Nil, 'Rattacher');
};
var $author$project$I18n$Cles$referentielRattachementRattacherTitreOrganisation = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.rattachement.rattacher.titre.organisation',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'personne',
					$author$project$I18n$Traductions$Chaine(p.Fd))
				]),
			'Rattacher ' + (p.Fd + ' à une organisation'));
	});
var $author$project$I18n$Cles$referentielRattachementRattacherTitrePersonne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.rattachement.rattacher.titre.personne',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'organisation',
					$author$project$I18n$Traductions$Chaine(p.En))
				]),
			'Rattacher une personne à ' + p.En);
	});
var $author$project$I18n$Cles$referentielRattachementTerminer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.terminer', _List_Nil, 'Terminer');
};
var $author$project$I18n$Cles$referentielRelationAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.relation.ajouter', _List_Nil, 'Ajouter une relation');
};
var $author$project$I18n$Cles$referentielRelationCible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.relation.cible', _List_Nil, 'Partie prenante');
};
var $author$project$I18n$Cles$referentielRelationRelation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.relation.relation', _List_Nil, 'Relation');
};
var $author$project$Components$Referentiel$Fiche$Update$ContactDeRattachementAjoute = {$: 80};
var $author$project$Components$Referentiel$Fiche$Update$DebutSaisi = function (a) {
	return {$: 77, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$DepartementSaisi = function (a) {
	return {$: 76, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$CanalDeContactDeRattachementChoisi = F2(
	function (a, b) {
		return {$: 79, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Update$ContactDeRattachementSaisi = F2(
	function (a, b) {
		return {$: 78, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Rattacher$erreurDuContact = F2(
	function (rang, saisie) {
		var saisies = $author$project$Components$Referentiel$Fiche$Rattacher$remplies(saisie);
		return $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (_v0) {
					var parmiLesRemplies = _v0.a;
					var erreur = _v0.b;
					return A2(
						$elm$core$Maybe$andThen,
						function (_v1) {
							var aLEcran = _v1.a;
							return _Utils_eq(aLEcran, rang) ? $elm$core$Maybe$Just(erreur) : $elm$core$Maybe$Nothing;
						},
						$elm$core$List$head(
							A2($elm$core$List$drop, parmiLesRemplies, saisies)));
				},
				$author$project$Components$Referentiel$Common$Contact$erreurs(
					A2($elm$core$List$map, $elm$core$Tuple$second, saisies))));
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$idDuCanal = function (rang) {
	return 'rattacher-canal-' + $elm$core$String$fromInt(rang);
};
var $author$project$Components$Referentiel$Fiche$Liaisons$idDuContact = function (rang) {
	return 'rattacher-contact-' + $elm$core$String$fromInt(rang);
};
var $author$project$I18n$Cles$referentielCreationChampObligatoire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.champ-obligatoire', _List_Nil, 'Ce champ est obligatoire.');
};
var $author$project$I18n$Cles$referentielCreationContactAdresseWebInvalide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.contact.adresse-web-invalide', _List_Nil, 'Adresse web invalide : saisissez-la en entier, avec https:// (par exemple https://www.exemple.fr).');
};
var $author$project$I18n$Cles$referentielCreationContactEmailEnDouble = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.contact.email-en-double', _List_Nil, 'Cet email est déjà saisi sur une ligne précédente.');
};
var $author$project$I18n$Cles$referentielCreationContactEmailInvalide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.contact.email-invalide', _List_Nil, 'Format d\'email invalide');
};
var $author$project$I18n$Cles$referentielCreationContactTelephoneInvalide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.contact.telephone-invalide', _List_Nil, 'Numéro invalide : saisissez-le au format international, avec l\'indicatif du pays (par exemple +33 6 39 98 12 34).');
};
var $author$project$Components$Referentiel$Fiche$Contacts$libelleDeLErreur = F2(
	function (i18n, erreur) {
		switch (erreur.$) {
			case 0:
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$referentielCreationChampObligatoire(i18n));
			case 1:
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$referentielCreationContactEmailInvalide(i18n));
			case 2:
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$referentielCreationContactTelephoneInvalide(i18n));
			case 3:
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$referentielCreationContactAdresseWebInvalide(i18n));
			case 4:
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$referentielCreationContactEmailEnDouble(i18n));
			case 5:
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Referentiel$Fiche$View$libelleDuCanal = F2(
	function (i18n, canal) {
		return A2(
			$author$project$I18n$Cles$texte,
			i18n,
			$author$project$Components$Referentiel$Fiche$Contacts$libelleDuCanal(canal));
	});
var $author$project$I18n$Cles$referentielCreationContactCanal = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.contact.canal', _List_Nil, 'Canal');
};
var $author$project$I18n$Cles$referentielRattachementContactsEmail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.contacts.email', _List_Nil, 'Email professionnel');
};
var $author$project$I18n$Cles$referentielRattachementContactsTelephone = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.contacts.telephone', _List_Nil, 'Téléphone professionnel');
};
var $author$project$Components$Referentiel$Fiche$View$contactDuRattachement = F5(
	function (i18n, model, rattache, rang, ligne) {
		var erreur = model.Bk.P ? A2(
			$elm$core$Maybe$andThen,
			$author$project$Components$Referentiel$Fiche$Contacts$libelleDeLErreur(i18n),
			A2($author$project$Components$Referentiel$Fiche$Rattacher$erreurDuContact, rang, rattache)) : $elm$core$Maybe$Nothing;
		var valeur = A2(
			$author$project$Components$Shared$Champ$View$texte,
			{
				go: erreur,
				Aq: $author$project$Components$Referentiel$Fiche$Liaisons$idDuContact(rang),
				Bl: (ligne.uF === 1) ? $author$project$I18n$Cles$referentielRattachementContactsTelephone(i18n) : $author$project$I18n$Cles$referentielRattachementContactsEmail(i18n),
				he: false
			},
			{
				hg: $author$project$Components$Referentiel$Fiche$Update$ContactDeRattachementSaisi(rang),
				fm: ligne.fm
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('contact')
				]),
			(rang < 2) ? _List_fromArray(
				[valeur]) : _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: $author$project$Components$Referentiel$Fiche$Liaisons$idDuCanal(rang),
						Bl: $author$project$I18n$Cles$referentielCreationContactCanal(i18n),
						he: false
					},
					{
						hg: $author$project$Components$Referentiel$Fiche$Update$CanalDeContactDeRattachementChoisi(rang),
						o_: A2(
							$elm$core$List$map,
							function (canal) {
								return {
									Bl: A2($author$project$Components$Referentiel$Fiche$View$libelleDuCanal, i18n, canal),
									fm: $author$project$Components$Referentiel$Common$Contact$canalCode(canal)
								};
							},
							_List_fromArray(
								[0, 1])),
						fm: $author$project$Components$Referentiel$Common$Contact$canalCode(ligne.uF)
					}),
					valeur
				]));
	});
var $author$project$Components$Referentiel$Fiche$Liaisons$idDuDebut = 'rattacher-debut';
var $author$project$Components$Referentiel$Fiche$Liaisons$idDuDepartement = 'rattacher-departement';
var $author$project$I18n$Cles$referentielNatureOrganisation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.nature.organisation', _List_Nil, 'Organisation');
};
var $author$project$I18n$Cles$referentielNaturePersonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.nature.personne', _List_Nil, 'Personne');
};
var $author$project$I18n$Cles$referentielRattachementContactsAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.contacts.ajouter', _List_Nil, 'Autre email ou téléphone');
};
var $author$project$I18n$Cles$referentielRattachementContactsNote = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.rattachement.contacts.note',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'organisation',
					$author$project$I18n$Traductions$Chaine(p.En))
				]),
			'Utilisés pour tout ce qui concerne ' + (p.En + '. Ils passeront en « ancien » à la fin du rattachement.'));
	});
var $author$project$I18n$Cles$referentielRattachementContactsTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.rattachement.contacts.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'personne',
					$author$project$I18n$Traductions$Chaine(p.Fd)),
					_Utils_Tuple2(
					'organisation',
					$author$project$I18n$Traductions$Chaine(p.En))
				]),
			'Contacts de ' + (p.Fd + (' chez ' + p.En)));
	});
var $author$project$I18n$Cles$referentielRattachementDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.debut', _List_Nil, 'Début');
};
var $author$project$I18n$Cles$referentielRattachementDebutAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.debut.aide', _List_Nil, 'Vide : à partir d\'aujourd\'hui. Une date à venir : le rattachement prendra effet à cette date.');
};
var $author$project$I18n$Cles$referentielRattachementDepartement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.departement', _List_Nil, 'Service');
};
var $author$project$Components$Referentiel$Fiche$View$saisieDuRattachement = F4(
	function (i18n, model, contexte, rattache) {
		var ouverte = A2($author$project$Components$Referentiel$Fiche$Model$texteDuTitre, i18n, contexte.Dj);
		var facultatif = F2(
			function (idDuChamp_, libelle) {
				return {go: $elm$core$Maybe$Nothing, Aq: idDuChamp_, Bl: libelle, he: false};
			});
		var duPoste = {
			go: A2($author$project$Components$Referentiel$Fiche$Liaisons$erreurDuPoste, i18n, model.Bk),
			Aq: $author$project$Components$Referentiel$Fiche$Liaisons$idDuPoste,
			Bl: $author$project$I18n$Cles$referentielRattachementPoste(i18n),
			he: false
		};
		var choisie = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Dj;
					},
					$author$project$I18n$Cles$texte(i18n)),
				rattache.hC.ve));
		var _v0 = (!contexte.fN) ? _Utils_Tuple2(choisie, ouverte) : _Utils_Tuple2(ouverte, choisie);
		var personne = _v0.a;
		var organisation = _v0.b;
		return _Utils_ap(
			A4(
				$author$project$Components$Referentiel$Fiche$View$recherche,
				i18n,
				model,
				(!contexte.fN) ? $author$project$I18n$Cles$referentielNaturePersonne(i18n) : $author$project$I18n$Cles$referentielNatureOrganisation(i18n),
				rattache.hC),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					duPoste,
					{
						hg: $author$project$Components$Referentiel$Fiche$Update$PosteChoisi,
						o_: A2($author$project$Components$Referentiel$Fiche$Liaisons$postesProposes, i18n, model.Bk),
						fm: rattache.F4
					}),
					A2(
					$author$project$Components$Shared$Champ$View$texte,
					A2(
						facultatif,
						$author$project$Components$Referentiel$Fiche$Liaisons$idDeLIntitule,
						$author$project$I18n$Cles$referentielRattachementIntituleFacultatif(i18n)),
					{hg: $author$project$Components$Referentiel$Fiche$Update$IntituleSaisi, fm: rattache.AS}),
					A2(
					$author$project$Components$Shared$Champ$View$texte,
					A2(
						facultatif,
						$author$project$Components$Referentiel$Fiche$Liaisons$idDuDepartement,
						$author$project$I18n$Cles$referentielRattachementDepartement(i18n)),
					{hg: $author$project$Components$Referentiel$Fiche$Update$DepartementSaisi, fm: rattache.xb}),
					A2(
					$author$project$Components$Shared$Champ$View$dateAvecAide,
					A2(
						facultatif,
						$author$project$Components$Referentiel$Fiche$Liaisons$idDuDebut,
						$author$project$I18n$Cles$referentielRattachementDebut(i18n)),
					{
						bp: $elm$core$Maybe$Just(
							$author$project$I18n$Cles$referentielRattachementDebutAide(i18n)),
						hg: $author$project$Components$Referentiel$Fiche$Update$DebutSaisi,
						fm: rattache.ku
					}),
					A2(
					$rtfeldman$elm_css$Html$Styled$section,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('contacts'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'hidden',
									_Utils_eq(rattache.hC.ve, $elm$core$Maybe$Nothing))
								]))
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$h4,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$referentielRattachementContactsTitre,
										i18n,
										{En: organisation, Fd: personne}))
								])),
						_Utils_ap(
							A2(
								$elm$core$List$indexedMap,
								A3($author$project$Components$Referentiel$Fiche$View$contactDuRattachement, i18n, model, rattache),
								rattache.wa),
							_List_fromArray(
								[
									A4(
									$author$project$Components$Shared$Bouton$View$boutonAvecIcone,
									2,
									$author$project$Components$Shared$Svg$svgAdd,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('add'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Fiche$Update$ContactDeRattachementAjoute),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
											$author$project$Components$Referentiel$Fiche$Rattacher$complet(rattache))
										]),
									$author$project$I18n$Cles$referentielRattachementContactsAjouter(i18n)),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$referentielRattachementContactsNote,
												i18n,
												{En: organisation}))
										]))
								])))),
					A2(
					$author$project$Components$Shared$Champ$View$caseACocher,
					A2(
						facultatif,
						$author$project$Components$Referentiel$Fiche$Liaisons$idDuPrincipal,
						$author$project$I18n$Cles$referentielRattachementContactPrincipalDeLOrganisation(i18n)),
					{vt: rattache.px, D9: $author$project$Components$Referentiel$Fiche$Update$PrincipalCoche})
				]));
	});
var $author$project$Components$Referentiel$Fiche$View$drawerDeLiaison = F3(
	function (i18n, messages, model) {
		var memeAction = F2(
			function (titre, contenu) {
				return {fs: titre, fZ: contenu, h6: titre};
			});
		var enCours = function () {
			var _v2 = model.l2;
			if (_v2.$ === 2) {
				return true;
			} else {
				return false;
			}
		}();
		var dit = function () {
			var _v0 = model.Bk.mW;
			switch (_v0.$) {
				case 4:
					var contexte = _v0.a;
					var rattache = _v0.b;
					return {
						fs: $author$project$I18n$Cles$referentielRattachementRattacherAction(i18n),
						fZ: A4($author$project$Components$Referentiel$Fiche$View$saisieDuRattachement, i18n, model, contexte, rattache),
						h6: (!contexte.fN) ? A2(
							$author$project$I18n$Cles$referentielRattachementRattacherTitrePersonne,
							i18n,
							{
								En: A2($author$project$Components$Referentiel$Fiche$Model$texteDuTitre, i18n, contexte.Dj)
							}) : A2(
							$author$project$I18n$Cles$referentielRattachementRattacherTitreOrganisation,
							i18n,
							{
								Fd: A2($author$project$Components$Referentiel$Fiche$Model$texteDuTitre, i18n, contexte.Dj)
							})
					};
				case 5:
					var reliee = _v0.b;
					return A2(
						memeAction,
						$author$project$I18n$Cles$referentielRelationAjouter(i18n),
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$Components$Shared$Champ$View$liste,
								{
									go: A2($author$project$Components$Referentiel$Fiche$Liaisons$erreurDeLaPhrase, i18n, model.Bk),
									Aq: $author$project$Components$Referentiel$Fiche$Liaisons$idDeLaPhrase,
									Bl: $author$project$I18n$Cles$referentielRelationRelation(i18n),
									he: true
								},
								{
									hg: $author$project$Components$Referentiel$Fiche$Update$PhraseChoisie,
									o_: A2($author$project$Components$Referentiel$Fiche$Liaisons$phrasesProposees, i18n, model.Bk),
									fm: reliee.Fp
								}),
							A4(
								$author$project$Components$Referentiel$Fiche$View$recherche,
								i18n,
								model,
								$author$project$I18n$Cles$referentielRelationCible(i18n),
								reliee.hC)));
				case 1:
					var lien = _v0.a;
					var date = _v0.b;
					return A2(
						memeAction,
						_Utils_eq(lien.zK, $elm$core$Maybe$Nothing) ? $author$project$I18n$Cles$referentielRattachementTerminer(i18n) : $author$project$I18n$Cles$referentielRattachementModifierLaFin(i18n),
						_List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Champ$View$dateAvecAide,
								{
									go: A2(
										$elm$core$Maybe$map,
										$author$project$I18n$Cles$texte(i18n),
										$author$project$Components$Referentiel$Fiche$Liaisons$erreurDeLaFin(model.Bk)),
									Aq: $author$project$Components$Referentiel$Fiche$Liaisons$idDeLaFin,
									Bl: $author$project$I18n$Cles$referentielRattachementFin(i18n),
									he: _Utils_eq(lien.zK, $elm$core$Maybe$Nothing)
								},
								{
									bp: _Utils_eq(lien.zK, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
										$author$project$I18n$Cles$referentielRattachementFinAide(i18n)),
									hg: $author$project$Components$Referentiel$Fiche$Update$FinSaisie,
									fm: date
								})
							]));
				case 3:
					var lien = _v0.a;
					var modifiee = _v0.b;
					return A2(
						memeAction,
						$author$project$I18n$Cles$referentielRattachementModifier(i18n),
						_Utils_ap(
							_List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Champ$View$liste,
									{
										go: A2($author$project$Components$Referentiel$Fiche$Liaisons$erreurDuPoste, i18n, model.Bk),
										Aq: $author$project$Components$Referentiel$Fiche$Liaisons$idDuPoste,
										Bl: $author$project$I18n$Cles$referentielRattachementPoste(i18n),
										he: false
									},
									{
										hg: $author$project$Components$Referentiel$Fiche$Update$PosteChoisi,
										o_: A2($author$project$Components$Referentiel$Fiche$Liaisons$postesProposes, i18n, model.Bk),
										fm: modifiee.F4
									}),
									A2(
									$author$project$Components$Shared$Champ$View$texte,
									{
										go: $elm$core$Maybe$Nothing,
										Aq: $author$project$Components$Referentiel$Fiche$Liaisons$idDeLIntitule,
										Bl: $author$project$I18n$Cles$referentielRattachementIntituleFacultatif(i18n),
										he: false
									},
									{hg: $author$project$Components$Referentiel$Fiche$Update$IntituleSaisi, fm: modifiee.AS})
								]),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (_v1) {
										return _List_fromArray(
											[
												A2(
												$author$project$Components$Shared$Champ$View$caseACocher,
												{
													go: $elm$core$Maybe$Nothing,
													Aq: $author$project$Components$Referentiel$Fiche$Liaisons$idDuPrincipal,
													Bl: $author$project$I18n$Cles$referentielRattachementContactPrincipalDeLOrganisation(i18n),
													he: false
												},
												{vt: modifiee.px, D9: $author$project$Components$Referentiel$Fiche$Update$PrincipalCoche})
											]);
									},
									lien.xu))));
				default:
					return A2(memeAction, '', _List_Nil);
			}
		}();
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$Fiche$Update$DrawerMsg,
			{
				fs: {sR: !enCours, Bl: dit.fs, C$: $author$project$Components$Referentiel$Fiche$Update$LiaisonValidee},
				fZ: _Utils_ap(
					$author$project$Components$Shared$Drawer$Model$estOuvert(model.Bk.kX) ? _List_fromArray(
						[
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages)
						]) : _List_Nil,
					dit.fZ),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: dit.h6
			},
			model.Bk.kX);
	});
var $author$project$Components$Referentiel$Fiche$Update$BlocValide = {$: 118};
var $author$project$Components$Referentiel$Fiche$Update$ChampDuBlocSaisi = function (a) {
	return {$: 117, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$DrawerDuBlocMsg = function (a) {
	return {$: 126, a: a};
};
var $author$project$Components$Referentiel$Common$ChoixDeLien$choixDesLiens = F4(
	function (sansNom, etat, portees, champs) {
		var valeurDe = function (nommee) {
			return {
				tI: false,
				Aq: nommee.r8,
				R: _List_fromArray(
					[
						_Utils_Tuple2(
						'fr',
						A2($elm$core$Maybe$withDefault, sansNom, nommee.Dj))
					])
			};
		};
		var deLaCle = F2(
			function (cle, liste) {
				return A2(
					$elm$core$List$concatMap,
					$elm$core$Tuple$second,
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$eq(cle)),
						liste));
			});
		var fusion = function (cle) {
			var lues = A2(deLaCle, cle, portees);
			return _Utils_ap(
				lues,
				A2(
					$elm$core$List$filter,
					function (autre) {
						return !A2(
							$elm$core$List$any,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.r8;
								},
								$elm$core$Basics$eq(autre.r8)),
							lues);
					},
					A2(deLaCle, cle, etat.hN)));
		};
		var choix = F2(
			function (champ, genre) {
				return {
					dy: champ.dy,
					nW: _Utils_eq(
						A2($author$project$Components$Referentiel$Common$ChoixDeLien$gabaritDe, genre, etat.gF),
						$elm$core$Maybe$Nothing) ? '' : $author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$listeDeRecherche,
					Ca: false,
					Fk: false,
					FS: _Utils_eq(genre, $author$project$Components$Referentiel$Common$ChoixDeLien$DArticles) && $author$project$Components$Referentiel$Common$ChoixDeLien$plusieursDe(champ),
					hu: A2(
						$elm$core$List$map,
						valeurDe,
						A2(deLaCle, champ.dy, portees)),
					pE: A2(
						$elm$core$List$map,
						valeurDe,
						fusion(champ.dy)),
					al: $elm$core$Maybe$Nothing
				};
			});
		return A2(
			$elm$core$List$filterMap,
			function (champ) {
				return A2(
					$elm$core$Maybe$map,
					choix(champ),
					$author$project$Components$Referentiel$Common$ChoixDeLien$genreDe(champ));
			},
			champs);
	});
var $author$project$Components$Referentiel$Fiche$View$prefixeDuBloc = $author$project$Components$Referentiel$Common$ChampsDuType$prefixe('referentiel-fiche');
var $author$project$Components$Referentiel$Common$ChampsDuType$presentation = F6(
	function (normes, prefixeDesChamps, lecture, choix, schema, saisie) {
		return {
			fr: function (_v0) {
				return 0;
			},
			dw: A2(
				$author$project$Components$Referentiel$Common$ChampsDuType$champsAPresenter,
				$author$project$Components$Referentiel$Common$ChampsDuType$tousLesChamps(schema),
				saisie),
			jN: choix,
			Ba: schema.Ba,
			np: lecture,
			hd: normes,
			pv: prefixeDesChamps,
			sb: schema.sb
		};
	});
var $author$project$I18n$Cles$referentielFicheChampValider = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.champ.valider', _List_Nil, 'Valider');
};
var $author$project$I18n$Cles$referentielFicheChampsDuTypeTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.champs-du-type.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			'Champs du type « ' + (p.Bl + ' »'));
	});
var $author$project$Components$Referentiel$Common$ChoixDeLien$Choisie = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Referentiel$Common$ChoixDeLien$Cochee = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Referentiel$Common$ChoixDeLien$Fermee = {$: 5};
var $author$project$Components$Referentiel$Common$ChoixDeLien$PageDemandee = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Common$ChoixDeLien$TermeSaisi = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$Common$ChoixDeLien$Validee = {$: 4};
var $author$project$I18n$Cles$referentielLienAucunResultat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.lien.aucun-resultat', _List_Nil, 'Aucun résultat.');
};
var $author$project$I18n$Cles$referentielLienChoisirLaValeur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.lien.choisir-la-valeur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Choisir ' + p.Dj);
	});
var $author$project$I18n$Cles$referentielLienColonneNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.lien.colonne-nom', _List_Nil, 'Nom');
};
var $author$project$I18n$Cles$referentielLienIndisponible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.lien.indisponible', _List_Nil, 'La recherche est indisponible, réessayez.');
};
var $author$project$I18n$Cles$referentielLienRechercher = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.lien.rechercher', _List_Nil, 'Rechercher par nom');
};
var $author$project$I18n$Cles$referentielLienRetour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.lien.retour', _List_Nil, 'Retour aux champs');
};
var $author$project$I18n$Cles$referentielLienTitreArticles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.lien.titre-articles', _List_Nil, 'Choisir des articles');
};
var $author$project$I18n$Cles$referentielLienTitrePartiePrenante = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.lien.titre-partie-prenante', _List_Nil, 'Choisir une partie prenante');
};
var $author$project$I18n$Cles$referentielLienTitreUtilisateur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.lien.titre-utilisateur', _List_Nil, 'Choisir un utilisateur');
};
var $author$project$I18n$Cles$referentielLienTotalPlusieurs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.lien.total.plusieurs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			p.JE + ' résultats');
	});
var $author$project$I18n$Cles$referentielLienTotalUn = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.lien.total.un', _List_Nil, '1 résultat');
};
var $author$project$I18n$Cles$referentielLienValider = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.lien.valider', _List_Nil, 'Valider le choix');
};
var $author$project$Components$Referentiel$Common$ChoixDeLien$view = F3(
	function (i18n, sansNom, recherche) {
		var titre = function () {
			var _v3 = recherche.M;
			switch (_v3.$) {
				case 0:
					return $author$project$I18n$Cles$referentielLienTitrePartiePrenante(i18n);
				case 1:
					return $author$project$I18n$Cles$referentielLienTitreUtilisateur(i18n);
				default:
					return $author$project$I18n$Cles$referentielLienTitreArticles(i18n);
			}
		}();
		var pages = function (total) {
			return A2(
				$elm$core$Basics$max,
				1,
				$elm$core$Basics$ceiling(total / $author$project$Components$Referentiel$Common$ChoixDeLien$tailleDePage));
		};
		var pied = F2(
			function (total, nombre) {
				return A2(
					$author$project$Components$Shared$Annuaire$View$pagination,
					i18n,
					$author$project$Components$Shared$Annuaire$View$PaginationAvecPlage(
						{
							FQ: A2(
								$author$project$I18n$Cles$annuairePaginationPlage,
								i18n,
								{
									ku: $elm$core$String$fromInt(((recherche.EE - 1) * $author$project$Components$Referentiel$Common$ChoixDeLien$tailleDePage) + 1),
									mI: $elm$core$String$fromInt(((recherche.EE - 1) * $author$project$Components$Referentiel$Common$ChoixDeLien$tailleDePage) + nombre),
									JE: $elm$core$String$fromInt(total)
								}),
							Gc: (recherche.EE <= 1) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
								$author$project$Components$Referentiel$Common$ChoixDeLien$PageDemandee(recherche.EE - 1)),
							I7: (_Utils_cmp(
								recherche.EE,
								pages(total)) > -1) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
								$author$project$Components$Referentiel$Common$ChoixDeLien$PageDemandee(recherche.EE + 1)),
							Jf: function (_v2) {
								return $author$project$Components$Referentiel$Common$ChoixDeLien$PageDemandee(1);
							},
							Jm: $author$project$Components$Referentiel$Common$ChoixDeLien$tailleDePage,
							Jo: _List_fromArray(
								[$author$project$Components$Referentiel$Common$ChoixDeLien$tailleDePage])
						}));
			});
		var nom = function (nommee) {
			return A2($elm$core$Maybe$withDefault, sansNom, nommee.Dj);
		};
		var ligne = function (nommee) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$tr,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('resultat')
					]),
				recherche.FS ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('selection')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$input,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
										'aria-label',
										nom(nommee)),
										$rtfeldman$elm_css$Html$Styled$Attributes$checked(
										A2($elm$core$List$member, nommee.r8, recherche.at)),
										$rtfeldman$elm_css$Html$Styled$Events$onCheck(
										$author$project$Components$Referentiel$Common$ChoixDeLien$Cochee(nommee.r8))
									]),
								_List_Nil)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								nom(nommee))
							]))
					]) : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								nom(nommee))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('action')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
										'aria-label',
										A2(
											$author$project$I18n$Cles$referentielLienChoisirLaValeur,
											i18n,
											{
												Dj: nom(nommee)
											})),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Referentiel$Common$ChoixDeLien$Choisie(nommee))
									]),
								A2(
									$author$project$I18n$Cles$referentielLienChoisirLaValeur,
									i18n,
									{
										Dj: nom(nommee)
									}))
							]))
					]));
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('recherche-de-lien')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(titre)
						])),
					A2(
					$author$project$Components$Shared$Champ$View$texte,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: 'recherche-de-lien-terme',
						Bl: $author$project$I18n$Cles$referentielLienRechercher(i18n),
						he: false
					},
					{hg: $author$project$Components$Referentiel$Common$ChoixDeLien$TermeSaisi, fm: recherche.h3}),
					function () {
					var _v0 = _Utils_Tuple2(recherche.AJ, recherche.fg);
					if (_v0.a) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('refus')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielLienIndisponible(i18n))
								]));
					} else {
						if (_v0.b.$ === 1) {
							var _v1 = _v0.b;
							return $rtfeldman$elm_css$Html$Styled$text('');
						} else {
							var trouvees = _v0.b.a;
							return $elm$core$List$isEmpty(trouvees.DF) ? A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielLienAucunResultat(i18n))
									])) : A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('resultats')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('count'),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												(trouvees.JE === 1) ? $author$project$I18n$Cles$referentielLienTotalUn(i18n) : A2(
													$author$project$I18n$Cles$referentielLienTotalPlusieurs,
													i18n,
													{
														JE: $elm$core$String$fromInt(trouvees.JE)
													}))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$table,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$thead,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$rtfeldman$elm_css$Html$Styled$tr,
																_List_Nil,
																_Utils_ap(
																	recherche.FS ? _List_fromArray(
																		[
																			A2(
																			$rtfeldman$elm_css$Html$Styled$td,
																			_List_fromArray(
																				[
																					$rtfeldman$elm_css$Html$Styled$Attributes$class('selection')
																				]),
																			_List_Nil)
																		]) : _List_Nil,
																	_Utils_ap(
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$th,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(
																						$author$project$I18n$Cles$referentielLienColonneNom(i18n))
																					]))
																			]),
																		recherche.FS ? _List_Nil : _List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$td,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$class('action')
																					]),
																				_List_Nil)
																			]))))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$tbody,
														_List_Nil,
														A2($elm$core$List$map, ligne, trouvees.DF))
													]))
											])),
										A2(
										pied,
										trouvees.JE,
										$elm$core$List$length(trouvees.DF))
									]));
						}
					}
				}(),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					_Utils_ap(
						_List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Common$ChoixDeLien$Fermee)
									]),
								$author$project$I18n$Cles$referentielLienRetour(i18n))
							]),
						recherche.FS ? _List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								0,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Common$ChoixDeLien$Validee)
									]),
								$author$project$I18n$Cles$referentielLienValider(i18n))
							]) : _List_Nil))
				]));
	});
var $author$project$Components$Referentiel$Fiche$View$drawerDuBloc = F3(
	function (i18n, fiche, model) {
		var sansNom = $author$project$I18n$Cles$referentielLienSansNom(i18n);
		var ouvert = A2(
			$elm$core$Maybe$andThen,
			function (bloc) {
				return A2(
					$elm$core$Maybe$map,
					function (schema) {
						return _Utils_Tuple2(bloc, schema);
					},
					A2($author$project$Components$Referentiel$Fiche$Model$schemaDuType, bloc.r0, model));
			},
			model.jq);
		var libelle = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				function (_v5) {
					var bloc = _v5.a;
					return A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.r0;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.R;
								},
								function ($) {
									return $.zX;
								})),
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.r0;
									},
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.r8;
										},
										$elm$core$Basics$eq(bloc.r0))),
								fiche.uW)));
				},
				ouvert));
		var choix = F2(
			function (type_, schema) {
				var bloc = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.r0;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.r8;
								},
								$elm$core$Basics$eq(type_))),
						fiche.uW));
				return _Utils_ap(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.jN;
							},
							bloc)),
					A4(
						$author$project$Components$Referentiel$Common$ChoixDeLien$choixDesLiens,
						sansNom,
						model.nQ,
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.dw;
									},
									$elm$core$List$map(
										function (lu) {
											return _Utils_Tuple2(lu.uN, lu.DF);
										})),
								bloc)),
						schema.dw));
			});
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$Fiche$Update$DrawerDuBlocMsg,
			{
				fs: {
					sR: function () {
						var _v0 = model.l2;
						if (_v0.$ === 2) {
							return false;
						} else {
							return true;
						}
					}(),
					Bl: $author$project$I18n$Cles$referentielFicheChampValider(i18n),
					C$: $author$project$Components$Referentiel$Fiche$Update$BlocValide
				},
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('champs')
							]),
						function () {
							var _v1 = _Utils_Tuple2(ouvert, model.nQ.Et);
							if (!_v1.a.$) {
								if (!_v1.b.$) {
									var ouverteLa = _v1.b.a;
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$map,
											$author$project$Components$Referentiel$Fiche$Update$LienDeChamp,
											A3($author$project$Components$Referentiel$Common$ChoixDeLien$view, i18n, sansNom, ouverteLa))
										]);
								} else {
									var _v2 = _v1.a.a;
									var bloc = _v2.a;
									var schema = _v2.b;
									var _v3 = _v1.b;
									return A2(
										$elm$core$List$map,
										$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Referentiel$Fiche$Update$ChampDuBlocSaisi),
										A3(
											$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$view,
											i18n,
											A6(
												$author$project$Components$Referentiel$Common$ChampsDuType$presentation,
												model.hd,
												$author$project$Components$Referentiel$Fiche$View$prefixeDuBloc,
												false,
												A2(choix, bloc.r0, schema),
												schema,
												bloc.hP),
											bloc.hP));
								}
							} else {
								var _v4 = _v1.a;
								return _List_Nil;
							}
						}())
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: A2(
					$author$project$I18n$Cles$referentielFicheChampsDuTypeTitre,
					i18n,
					{Bl: libelle})
			},
			model.lo);
	});
var $author$project$Components$Referentiel$Fiche$Update$ContactValide = {$: 28};
var $author$project$I18n$Cles$referentielFicheContactValider = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.contact.valider', _List_Nil, 'Valider');
};
var $author$project$I18n$Cles$referentielFicheResumeContactAjouterTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.contact-ajouter-titre', _List_Nil, 'Ajouter un contact');
};
var $author$project$I18n$Cles$referentielFicheResumeContactGererTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.contact-gerer-titre', _List_Nil, 'Gérer le contact');
};
var $author$project$I18n$Cles$referentielFicheResumeContactModifierTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.contact-modifier-titre', _List_Nil, 'Modifier le contact');
};
var $author$project$Components$Referentiel$Fiche$Update$CanalDeContactChoisi = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$ChampDAdresseSaisi = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$Update$ProspectionDeContactCochee = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$UsageDeContactChoisi = function (a) {
	return {$: 25, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$ValeurDeContactSaisie = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Referentiel$Fiche$Contacts$erreurs = function (etat) {
	var tente = function () {
		var _v0 = etat.zT;
		switch (_v0.$) {
			case 0:
				return false;
			case 1:
				var dejaTente = _v0.b;
				return dejaTente;
			default:
				var dejaTente = _v0.c;
				return dejaTente;
		}
	}();
	return tente ? A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (saisie) {
				return A2(
					$elm$core$List$map,
					$elm$core$Tuple$second,
					$author$project$Components$Referentiel$Common$Contact$erreurs(
						_List_fromArray(
							[saisie])));
			},
			$author$project$Components$Referentiel$Fiche$Contacts$ligne(etat))) : _List_Nil;
};
var $author$project$I18n$Cles$referentielCreationContactAdresseTropLongue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.contact.adresse.trop-longue', _List_Nil, 'Ce champ est trop long.');
};
var $author$project$Components$Referentiel$Fiche$Contacts$erreurDeLAdresse = F3(
	function (i18n, champ, etat) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (erreur) {
					switch (erreur.$) {
						case 5:
							var fautif = erreur.a;
							return _Utils_eq(fautif, champ) ? $elm$core$Maybe$Just(
								$author$project$I18n$Cles$referentielCreationChampObligatoire(i18n)) : $elm$core$Maybe$Nothing;
						case 6:
							var fautif = erreur.a;
							return _Utils_eq(fautif, champ) ? $elm$core$Maybe$Just(
								$author$project$I18n$Cles$referentielCreationContactAdresseTropLongue(i18n)) : $elm$core$Maybe$Nothing;
						default:
							return $elm$core$Maybe$Nothing;
					}
				},
				$author$project$Components$Referentiel$Fiche$Contacts$erreurs(etat)));
	});
var $author$project$I18n$Cles$referentielFicheContactEmailDejaPresent = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.contact.email-deja-present', _List_Nil, 'La fiche porte déjà cet email.');
};
var $author$project$Components$Referentiel$Fiche$Contacts$erreurDeLaValeur = F2(
	function (i18n, etat) {
		return etat.ae ? $elm$core$Maybe$Just(
			$author$project$I18n$Cles$referentielFicheContactEmailDejaPresent(i18n)) : $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				$author$project$Components$Referentiel$Fiche$Contacts$libelleDeLErreur(i18n),
				$author$project$Components$Referentiel$Fiche$Contacts$erreurs(etat)));
	});
var $author$project$Components$Referentiel$Fiche$View$libelleDeLUsage = F2(
	function (i18n, usage) {
		return A2(
			$author$project$I18n$Cles$texte,
			i18n,
			$author$project$Components$Referentiel$Fiche$Contacts$libelleDeLUsage(usage));
	});
var $author$project$I18n$Cles$referentielCreationContactProspectionEmail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.contact.prospection-email', _List_Nil, 'Accepte la prospection par email');
};
var $author$project$I18n$Cles$referentielCreationContactProspectionTelephone = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.contact.prospection-telephone', _List_Nil, 'Accepte la prospection par téléphone');
};
var $author$project$Components$Referentiel$Fiche$View$libelleDeLaProspection = F2(
	function (i18n, canal) {
		return (canal === 1) ? $author$project$I18n$Cles$referentielCreationContactProspectionTelephone(i18n) : $author$project$I18n$Cles$referentielCreationContactProspectionEmail(i18n);
	});
var $author$project$I18n$Cles$referentielCreationContactAdresse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.contact.adresse', _List_Nil, 'Adresse postale');
};
var $author$project$I18n$Cles$referentielCreationContactUsage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.contact.usage', _List_Nil, 'Usage');
};
var $author$project$I18n$Cles$referentielCreationContactValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.contact.valeur', _List_Nil, 'Valeur');
};
var $author$project$I18n$Cles$referentielCreationContactUsageLie = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.creation.contact.usage.lie',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'organisation',
					$author$project$I18n$Traductions$Chaine(p.En))
				]),
			'Professionnel · ' + p.En);
	});
var $author$project$Components$Referentiel$Fiche$View$usagesLies = F2(
	function (i18n, model) {
		return A2(
			$elm$core$List$map,
			function (porte) {
				return {
					Bl: A2(
						$author$project$I18n$Cles$referentielCreationContactUsageLie,
						i18n,
						{
							En: A2($author$project$I18n$Cles$texte, i18n, porte.Dj)
						}),
					fm: _Utils_ap(
						$author$project$Components$Referentiel$Fiche$Contacts$prefixeDUsageLie,
						$author$project$Components$Referentiel$Identifiants$rattachementUidToString(porte.r8))
				};
			},
			$author$project$Components$Referentiel$Fiche$Model$rattachementsLiables(model));
	});
var $author$project$Components$Referentiel$Fiche$View$saisieDeContact = F4(
	function (i18n, model, ligne, ajout) {
		var decrit = F4(
			function (nom, libelle, obligatoire, erreur) {
				return {go: erreur, Aq: 'fiche-contact-' + nom, Bl: libelle, he: obligatoire};
			});
		var champDAdresse = F5(
			function (partie, nom, libelle, obligatoire, valeur) {
				return A2(
					$author$project$Components$Shared$Champ$View$texte,
					A4(
						decrit,
						nom,
						libelle,
						obligatoire,
						A3($author$project$Components$Referentiel$Fiche$Contacts$erreurDeLAdresse, i18n, partie, model.v8)),
					{
						hg: $author$project$Components$Referentiel$Fiche$Update$ChampDAdresseSaisi(partie),
						fm: valeur
					});
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('saisie-de-contact'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('postale', ligne.uF === 2)
						]))
				]),
			_List_fromArray(
				[
					ajout ? A2(
					$author$project$Components$Shared$Champ$View$liste,
					A4(
						decrit,
						'canal',
						$author$project$I18n$Cles$referentielCreationContactCanal(i18n),
						false,
						$elm$core$Maybe$Nothing),
					{
						hg: $author$project$Components$Referentiel$Fiche$Update$CanalDeContactChoisi,
						o_: A2(
							$elm$core$List$map,
							function (canal) {
								return {
									Bl: A2($author$project$Components$Referentiel$Fiche$View$libelleDuCanal, i18n, canal),
									fm: $author$project$Components$Referentiel$Common$Contact$canalCode(canal)
								};
							},
							$author$project$Components$Referentiel$Common$Contact$canaux),
						fm: $author$project$Components$Referentiel$Common$Contact$canalCode(ligne.uF)
					}) : $rtfeldman$elm_css$Html$Styled$text(''),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Champ$View$texte,
							A4(
								decrit,
								'valeur',
								$author$project$I18n$Cles$referentielCreationContactValeur(i18n),
								true,
								A2($author$project$Components$Referentiel$Fiche$Contacts$erreurDeLaValeur, i18n, model.v8)),
							{hg: $author$project$Components$Referentiel$Fiche$Update$ValeurDeContactSaisie, fm: ligne.fm})
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$fieldset,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('adresse')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$legend,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$referentielCreationContactAdresse(i18n))
										]))
								])),
							A5(
							champDAdresse,
							0,
							'ligne1',
							$author$project$I18n$Cles$referentielCreationContactAdresseLigne1(i18n),
							true,
							ligne.aa.a3),
							A5(
							champDAdresse,
							1,
							'ligne2',
							$author$project$I18n$Cles$referentielCreationContactAdresseLigne2(i18n),
							false,
							ligne.aa.a4),
							A5(
							champDAdresse,
							2,
							'ligne3',
							$author$project$I18n$Cles$referentielCreationContactAdresseLigne3(i18n),
							false,
							ligne.aa.a5),
							A5(
							champDAdresse,
							3,
							'code-postal',
							$author$project$I18n$Cles$referentielCreationContactAdresseCodePostal(i18n),
							false,
							ligne.aa.vz),
							A5(
							champDAdresse,
							4,
							'localite',
							$author$project$I18n$Cles$referentielCreationContactAdresseLocalite(i18n),
							true,
							ligne.aa.B_),
							A5(
							champDAdresse,
							5,
							'region',
							$author$project$I18n$Cles$referentielCreationContactAdresseRegion(i18n),
							false,
							ligne.aa.Hj),
							A2(
							$author$project$Components$Shared$Champ$View$liste,
							A4(
								decrit,
								'pays',
								$author$project$I18n$Cles$referentielCreationContactAdressePays(i18n),
								true,
								A3($author$project$Components$Referentiel$Fiche$Contacts$erreurDeLAdresse, i18n, 6, model.v8)),
							{
								hg: $author$project$Components$Referentiel$Fiche$Update$ChampDAdresseSaisi(6),
								o_: A2(
									$elm$core$List$cons,
									{
										Bl: $author$project$I18n$Cles$referentielCreationChoisir(i18n),
										fm: ''
									},
									A2(
										$elm$core$List$map,
										function (pays) {
											return {Bl: pays.Dj, fm: pays.vx};
										},
										$author$project$Referentiel$Normes$entreesDePays(model.hd))),
								fm: ligne.aa.ho
							})
						])),
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					A4(
						decrit,
						'usage',
						$author$project$I18n$Cles$referentielCreationContactUsage(i18n),
						false,
						$elm$core$Maybe$Nothing),
					{
						hg: $author$project$Components$Referentiel$Fiche$Update$UsageDeContactChoisi,
						o_: _Utils_ap(
							A2(
								$elm$core$List$map,
								function (usage) {
									return {
										Bl: A2($author$project$Components$Referentiel$Fiche$View$libelleDeLUsage, i18n, usage),
										fm: $author$project$Components$Referentiel$Common$Contact$usageCode(usage)
									};
								},
								$author$project$Components$Referentiel$Common$Contact$usages),
							(ajout && A2(
								$elm$core$List$member,
								ligne.uF,
								_List_fromArray(
									[0, 1]))) ? A2($author$project$Components$Referentiel$Fiche$View$usagesLies, i18n, model) : _List_Nil),
						fm: A2(
							$elm$core$Maybe$withDefault,
							$author$project$Components$Referentiel$Common$Contact$usageCode(ligne.sd),
							A2(
								$elm$core$Maybe$map,
								function (uid) {
									return _Utils_ap(
										$author$project$Components$Referentiel$Fiche$Contacts$prefixeDUsageLie,
										$author$project$Components$Referentiel$Identifiants$rattachementUidToString(uid));
								},
								model.v8.pN))
					}),
					(ajout && $author$project$Components$Referentiel$Common$Contact$accepteLaProspection(ligne.uF)) ? A2(
					$author$project$Components$Shared$Champ$View$caseACocher,
					A4(
						decrit,
						'prospection',
						A2($author$project$Components$Referentiel$Fiche$View$libelleDeLaProspection, i18n, ligne.uF),
						false,
						$elm$core$Maybe$Nothing),
					{vt: ligne.Gx, D9: $author$project$Components$Referentiel$Fiche$Update$ProspectionDeContactCochee}) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$Components$Shared$Drawer$Update$clavierSansPied = F2(
	function (dernier, model) {
		return $author$project$Components$Shared$Drawer$Update$clavier(
			{
				xg: dernier,
				Ge: $author$project$Components$Shared$Drawer$Model$idFermer(model),
				GN: $author$project$Components$Shared$Drawer$Model$idRacine(model),
				h6: $author$project$Components$Shared$Drawer$Model$idTitre(model)
			});
	});
var $author$project$Components$Shared$Drawer$View$sansPied = F4(
	function (i18n, versMsg, contenu, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'opened',
							$author$project$Components$Shared$Drawer$Model$estOuvert(model))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('overlay'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							versMsg($author$project$Components$Shared$Drawer$Update$SortieDemandee))
						]),
					_List_Nil),
					A5(
					$author$project$Components$Shared$Drawer$View$panneau,
					i18n,
					versMsg,
					{
						vl: A2($author$project$Components$Shared$Drawer$Update$clavierSansPied, contenu.xg, model),
						fZ: contenu.fZ,
						AK: false,
						A6: contenu.A6,
						aO: $elm$core$Maybe$Nothing,
						h6: contenu.h6
					},
					_List_Nil,
					model)
				]));
	});
var $author$project$Components$Referentiel$Fiche$View$drawerDuContact = F3(
	function (i18n, fiche, model) {
		var enCours = function () {
			var _v2 = model.l2;
			if (_v2.$ === 2) {
				return true;
			} else {
				return false;
			}
		}();
		var avecSaisie = F3(
			function (titre, ligne, ajout) {
				return A4(
					$author$project$Components$Shared$Drawer$View$view,
					i18n,
					$author$project$Components$Referentiel$Fiche$Update$DrawerDuContactMsg,
					{
						fs: {
							sR: !enCours,
							Bl: $author$project$I18n$Cles$referentielFicheContactValider(i18n),
							C$: $author$project$Components$Referentiel$Fiche$Update$ContactValide
						},
						fZ: _List_fromArray(
							[
								A4($author$project$Components$Referentiel$Fiche$View$saisieDeContact, i18n, model, ligne, ajout)
							]),
						A6: $elm$core$Maybe$Nothing,
						Bc: false,
						h6: titre
					},
					model.lq);
			});
		var _v0 = model.v8.zT;
		switch (_v0.$) {
			case 1:
				var ligne = _v0.a;
				return A3(
					avecSaisie,
					$author$project$I18n$Cles$referentielFicheResumeContactAjouterTitre(i18n),
					ligne,
					true);
			case 2:
				var ligne = _v0.b;
				return A3(
					avecSaisie,
					$author$project$I18n$Cles$referentielFicheResumeContactModifierTitre(i18n),
					ligne,
					false);
			default:
				var ouvert = A2(
					$elm$core$Maybe$andThen,
					function (uid) {
						return $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (fourni) {
									return _Utils_eq(fourni.r8, uid);
								},
								fiche.wa));
					},
					model.v8.a7);
				return A4(
					$author$project$Components$Shared$Drawer$View$sansPied,
					i18n,
					$author$project$Components$Referentiel$Fiche$Update$DrawerDuContactMsg,
					{
						fZ: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('gestes-du-contact')
									]),
								function () {
									if (!ouvert.$) {
										var fourni = ouvert.a;
										return A2(
											$elm$core$List$cons,
											A2(
												$rtfeldman$elm_css$Html$Styled$strong,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2($author$project$I18n$Cles$texte, i18n, fourni.fm))
													])),
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$second,
												A2($author$project$Components$Referentiel$Fiche$View$gestesDeContact, i18n, fourni)));
									} else {
										return _List_Nil;
									}
								}())
							]),
						xg: A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$andThen,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Components$Referentiel$Fiche$View$gestesDeContact(i18n),
									A2(
										$elm$core$Basics$composeR,
										$elm$core$List$reverse,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$List$head,
											$elm$core$Maybe$map($elm$core$Tuple$first)))),
								ouvert)),
						A6: A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.uF;
								},
								$author$project$I18n$Cles$texte(i18n)),
							ouvert),
						h6: $author$project$I18n$Cles$referentielFicheResumeContactGererTitre(i18n)
					},
					model.lq);
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$GesteConfirme = {$: 61};
var $author$project$Components$Referentiel$Fiche$Update$CloreAussiCochee = function (a) {
	return {$: 98, a: a};
};
var $author$project$I18n$Cles$referentielFicheCloreCocherAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.clore.cocher-aide', _List_Nil, 'Seulement celles qui ne sont rattachées qu\'à cette organisation. Les autres restent actives.');
};
var $author$project$I18n$Cles$referentielFicheCloreCocherEffet = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.clore.cocher-effet', _List_Nil, 'Cochée, chaque personne reçoit sa propre clôture ; chacune peut être rouverte séparément.');
};
var $author$project$I18n$Cles$referentielFicheCloreCocherPluriel = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.clore.cocher-pluriel',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			'Clore aussi les ' + (p.d + ' personnes rattachées'));
	});
var $author$project$I18n$Cles$referentielFicheCloreCocherSingulier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.clore.cocher-singulier', _List_Nil, 'Clore aussi la personne rattachée');
};
var $author$project$Components$Referentiel$Fiche$View$caseDeLaCloture = F2(
	function (i18n, model) {
		var _v0 = model.ts;
		if (!_v0.$) {
			var apercu = _v0.a;
			return (apercu.Fh > 0) ? _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Champ$View$caseACocher,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: 'fiche-cloture-aussi',
						Bl: (apercu.Fh === 1) ? $author$project$I18n$Cles$referentielFicheCloreCocherSingulier(i18n) : A2(
							$author$project$I18n$Cles$referentielFicheCloreCocherPluriel,
							i18n,
							{
								d: $elm$core$String$fromInt(apercu.Fh)
							}),
						he: false
					},
					{vt: model.vp, D9: $author$project$Components$Referentiel$Fiche$Update$CloreAussiCochee}),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$referentielFicheCloreCocherAide(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$referentielFicheCloreCocherEffet(i18n))
						]))
				]) : _List_Nil;
		} else {
			return _List_Nil;
		}
	});
var $author$project$I18n$Cles$referentielFicheEffacementAnnulerMessage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.effacement.annuler-message',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etat',
					$author$project$I18n$Traductions$Chaine(p.gt))
				]),
			'La fiche retrouve son état d\'avant (' + (p.gt + '). Rien n\'aura été effacé.'));
	});
var $author$project$I18n$Cles$referentielFicheEffacementEtatAvantClose = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacement.etat-avant-close', _List_Nil, 'close');
};
var $author$project$I18n$Cles$referentielFicheEffacementEtatAvantSupprimee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacement.etat-avant-supprimee', _List_Nil, 'supprimée');
};
var $author$project$Components$Referentiel$Fiche$View$messageDAnnulation = F2(
	function (i18n, fiche) {
		return A2(
			$author$project$I18n$Cles$referentielFicheEffacementAnnulerMessage,
			i18n,
			{
				gt: function () {
					var _v0 = A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.yN;
						},
						fiche.x9);
					if ((!_v0.$) && (_v0.a === 2)) {
						var _v1 = _v0.a;
						return $author$project$I18n$Cles$referentielFicheEffacementEtatAvantSupprimee(i18n);
					} else {
						return $author$project$I18n$Cles$referentielFicheEffacementEtatAvantClose(i18n);
					}
				}()
			});
	});
var $author$project$I18n$Cles$referentielFicheCloreAnnonce = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.clore.annonce',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.Dj)))
				]),
			'La fiche ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.Dj);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.Dj);
					default:
						return 'de ' + $elm$core$String$trim(p.Dj);
				}
			}() + ' sera close. Elle reste consultable et peut être rouverte.'));
	});
var $author$project$I18n$Cles$referentielFicheCloreTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.clore.titre', _List_Nil, 'Clore la fiche');
};
var $author$project$I18n$Cles$referentielFicheEffacementAnnulerRenoncer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacement.annuler-renoncer', _List_Nil, 'Ne pas annuler');
};
var $author$project$I18n$Cles$referentielFicheEffacementAnnulerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.effacement.annuler-titre', _List_Nil, 'Annuler l\'effacement ?');
};
var $author$project$I18n$Cles$referentielFicheSupprimerAnnonce = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.supprimer.annonce',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.Dj)))
				]),
			'La fiche ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.Dj);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.Dj);
					default:
						return 'de ' + $elm$core$String$trim(p.Dj);
				}
			}() + ' sera supprimée.'));
	});
var $author$project$I18n$Cles$referentielFicheSupprimerMessage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.supprimer.message', _List_Nil, 'La fiche sort de l\'usage courant ; ses données sont conservées et un administrateur pourra la restaurer.');
};
var $author$project$I18n$Cles$referentielFicheSupprimerRattacheesPluriel = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.supprimer.rattachees-pluriel',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			p.d + ' personnes y sont rattachées ; elles ne sont pas supprimées.');
	});
var $author$project$I18n$Cles$referentielFicheSupprimerRattacheesSingulier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.supprimer.rattachees-singulier', _List_Nil, 'Une personne y est rattachée ; elle n\'est pas supprimée.');
};
var $author$project$I18n$Cles$referentielFicheSupprimerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.supprimer.titre', _List_Nil, 'Supprimer la fiche');
};
var $author$project$Components$Referentiel$Fiche$View$drawerDuCycle = F3(
	function (i18n, fiche, model) {
		var supprime = _Utils_eq(
			model.kp,
			$elm$core$Maybe$Just(2));
		var rattachees = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Fi;
				},
				fiche.wT));
		var nombre = function (n) {
			return $elm$core$String$fromInt(n);
		};
		var annule = _Utils_eq(
			model.kp,
			$elm$core$Maybe$Just(4));
		var annonce = supprime ? A2(
			$author$project$I18n$Cles$referentielFicheSupprimerAnnonce,
			i18n,
			{
				av: $author$project$Texte$Elision$elision(
					A2($author$project$Components$Referentiel$Fiche$View$titreDeLaFiche, i18n, fiche)),
				Dj: A2($author$project$Components$Referentiel$Fiche$View$titreDeLaFiche, i18n, fiche)
			}) : A2(
			$author$project$I18n$Cles$referentielFicheCloreAnnonce,
			i18n,
			{
				av: $author$project$Texte$Elision$elision(
					A2($author$project$Components$Referentiel$Fiche$View$titreDeLaFiche, i18n, fiche)),
				Dj: A2($author$project$Components$Referentiel$Fiche$View$titreDeLaFiche, i18n, fiche)
			});
		var contenu = annule ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('message')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$Components$Referentiel$Fiche$View$messageDAnnulation, i18n, fiche))
					]))
			]) : (supprime ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('message')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(annonce)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('message')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$referentielFicheSupprimerMessage(i18n))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('rattachees')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						(!rattachees) ? '' : ((rattachees === 1) ? $author$project$I18n$Cles$referentielFicheSupprimerRattacheesSingulier(i18n) : A2(
							$author$project$I18n$Cles$referentielFicheSupprimerRattacheesPluriel,
							i18n,
							{
								d: nombre(rattachees)
							})))
					]))
			]) : A2(
			$elm$core$List$cons,
			A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('message')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(annonce)
					])),
			A2($author$project$Components$Referentiel$Fiche$View$caseDeLaCloture, i18n, model)));
		return A5(
			$author$project$Components$Shared$Drawer$View$viewAvecRenoncement,
			i18n,
			annule ? $author$project$I18n$Cles$referentielFicheEffacementAnnulerRenoncer(i18n) : $author$project$I18n$Cles$drawerAnnuler(i18n),
			$author$project$Components$Referentiel$Fiche$Update$DrawerDuCycleMsg,
			{
				fs: {
					sR: !_Utils_eq(model.kp, $elm$core$Maybe$Nothing),
					Bl: annule ? $author$project$I18n$Cles$referentielFicheEffacementAnnulerBouton(i18n) : (supprime ? $author$project$I18n$Cles$referentielFicheGesteSupprimer(i18n) : $author$project$I18n$Cles$referentielFicheGesteClore(i18n)),
					C$: $author$project$Components$Referentiel$Fiche$Update$GesteConfirme
				},
				fZ: contenu,
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: annule ? $author$project$I18n$Cles$referentielFicheEffacementAnnulerTitre(i18n) : (supprime ? $author$project$I18n$Cles$referentielFicheSupprimerTitre(i18n) : $author$project$I18n$Cles$referentielFicheCloreTitre(i18n))
			},
			model.lr);
	});
var $author$project$I18n$Cles$referentielFicheHorsLimitesEncartTexte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.hors-limites.encart-texte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm)),
					_Utils_Tuple2(
					'limite',
					$author$project$I18n$Traductions$Chaine(p.nV)),
					_Utils_Tuple2(
					'jour',
					$author$project$I18n$Traductions$Chaine(p.A_))
				]),
			' ' + (p.fm + (' saisie, la limite est ' + (p.nV + (' depuis le ' + (p.A_ + '. La fiche reste enregistrée : vous pouvez la modifier et l’enregistrer.'))))));
	});
var $author$project$I18n$Cles$referentielFicheHorsLimitesEncartTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.hors-limites.encart-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			p.Bl + ' : valeur hors limites.');
	});
var $author$project$Components$Referentiel$Fiche$View$encartHorsLimites = F2(
	function (i18n, horsLimites) {
		return $elm$core$List$isEmpty(horsLimites) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('note', true),
							_Utils_Tuple2('erreur', true),
							_Utils_Tuple2('hors-limites', true)
						])),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'note')
				]),
			A2(
				$elm$core$List$map,
				function (horsLimite) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$referentielFicheHorsLimitesEncartTitre,
											i18n,
											{Bl: horsLimite.Bl}))
									])),
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$referentielFicheHorsLimitesEncartTexte,
									i18n,
									{
										A_: A2($author$project$Texte$Jour$enFrancais, i18n, horsLimite.A_),
										nV: horsLimite.nV,
										fm: horsLimite.fm
									}))
							]));
				},
				horsLimites));
	});
var $author$project$Components$Referentiel$Fiche$Update$RelationDemandee = {$: 81};
var $author$project$Components$Referentiel$Fiche$View$codeEtablissement = 'etablissement-de';
var $author$project$Components$Referentiel$Fiche$View$identifiantAffiche = F2(
	function (lien, identifiant) {
		return _Utils_eq(
			lien.ho,
			$elm$core$Maybe$Just('FR')) ? $author$project$Components$Referentiel$Common$IdentifiantLegal$groupe(identifiant) : identifiant;
	});
var $author$project$I18n$Cles$referentielRelationIncoherent = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.relation.incoherent', _List_Nil, 'Incohérent');
};
var $author$project$I18n$Cles$referentielRelationIncoherentExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.relation.incoherent.explication', _List_Nil, 'Le SIRET de l\'établissement n\'a plus le SIREN de la société ; le lien est gardé.');
};
var $author$project$Components$Referentiel$Fiche$View$pastilleIncoherente = function (i18n) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('tag'),
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ambre'),
				$rtfeldman$elm_css$Html$Styled$Attributes$class('incoherent'),
				$rtfeldman$elm_css$Html$Styled$Attributes$title(
				$author$project$I18n$Cles$referentielRelationIncoherentExplication(i18n))
			]),
		_List_fromArray(
			[
				$author$project$Components$Shared$Svg$svgWarning,
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$I18n$Cles$referentielRelationIncoherent(i18n))
			]));
};
var $author$project$Components$Referentiel$Fiche$View$etablissement = F3(
	function (i18n, normes, lien) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('item'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('hors-perimetre', lien.An)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('title'),
							$rtfeldman$elm_css$Html$Styled$Attributes$href(
							$author$project$Routes$Route$toString(
								A2($author$project$Routes$Route$Fiche, lien.zo, 0)))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$I18n$Cles$texte, i18n, lien.Dj))
						])),
					A2(
					$elm$core$Maybe$withDefault,
					$rtfeldman$elm_css$Html$Styled$text(''),
					A2(
						$elm$core$Maybe$map,
						function (identifiant) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('identifiant-legal')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$Components$Referentiel$Fiche$View$identifiantAffiche, lien, identifiant))
									]));
						},
						lien.m7)),
					_Utils_eq(
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$String$filter($elm$core$Char$isDigit),
							$elm$core$String$length),
						lien.m7),
					$elm$core$Maybe$Just(14)) ? A2(
					$author$project$Components$Shared$Tag$View$view,
					5,
					$author$project$I18n$Cles$referentielFicheIdentifiantLegalSiret(i18n)) : $rtfeldman$elm_css$Html$Styled$text(''),
					A2(
					$elm$core$Maybe$withDefault,
					$rtfeldman$elm_css$Html$Styled$text(''),
					A2(
						$elm$core$Maybe$map,
						function (pays) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('pays')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$Referentiel$Normes$nomDePays, normes, pays))
									]));
						},
						lien.ho)),
					lien.AF ? $author$project$Components$Referentiel$Fiche$View$pastilleIncoherente(i18n) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$I18n$Cles$referentielEtablissementsAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.etablissements.aucun', _List_Nil, 'Aucun établissement rattaché.');
};
var $author$project$I18n$Cles$referentielEtablissementsRattacher = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.etablissements.rattacher', _List_Nil, 'Rattacher un établissement');
};
var $author$project$I18n$Cles$referentielEtablissementsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.etablissements.titre', _List_Nil, 'Établissements');
};
var $author$project$Components$Referentiel$Fiche$View$etablissementsDuResume = F3(
	function (i18n, normes, fiche) {
		var etablissements = A2(
			$elm$core$List$filter,
			function (lien) {
				return _Utils_eq(lien.vx, $author$project$Components$Referentiel$Fiche$View$codeEtablissement) && (!lien.xA);
			},
			fiche.Hu);
		var estUnEtablissement = A2(
			$elm$core$List$any,
			function (lien) {
				return _Utils_eq(lien.vx, $author$project$Components$Referentiel$Fiche$View$codeEtablissement) && lien.xA;
			},
			fiche.Hu);
		return ((fiche.g1 !== 1) || estUnEtablissement) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$author$project$Components$Shared$Page$View$sectionAvecCompte,
			$author$project$Components$Referentiel$Fiche$View$ancre('etablissements'),
			{
				fw: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (_v0) {
							return _List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									2,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Fiche$Update$RelationDemandee)
										]),
									$author$project$I18n$Cles$referentielEtablissementsRattacher(i18n))
								]);
						},
						fiche.Hy)),
				vW: $elm$core$Maybe$Just(
					$elm$core$String$fromInt(
						$elm$core$List$length(etablissements))),
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('list')
							]),
						A2(
							$elm$core$List$map,
							A2($author$project$Components$Referentiel$Fiche$View$etablissement, i18n, normes),
							etablissements)),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$List$isEmpty(etablissements) ? $author$project$I18n$Cles$referentielEtablissementsAucun(i18n) : '')
							]))
					]),
				Ar: $elm$core$Maybe$Nothing,
				Dj: 'etablissements',
				h6: $author$project$I18n$Cles$referentielEtablissementsTitre(i18n)
			});
	});
var $author$project$Components$Referentiel$Fiche$Update$OuvertureDeRoleDemandee = function (a) {
	return {$: 39, a: a};
};
var $author$project$Components$Referentiel$Fiche$View$UnGroupe = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$View$UneLigne = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$Fiche$View$avecLesLibellesDuChoix = F2(
	function (choix, lu) {
		var _v0 = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.dy;
					},
					$elm$core$Basics$eq(lu.dy)),
				choix));
		if (!_v0.$) {
			var liste = _v0.a;
			return _Utils_update(
				lu,
				{
					Bt: A2(
						$elm$core$List$map,
						function (valeur) {
							return _Utils_Tuple2(valeur.Aq, valeur.R);
						},
						$author$project$Components$Shared$EditeurDeSchema$ChoixDeListe$montrees(liste))
				});
		} else {
			return lu;
		}
	});
var $author$project$Components$Referentiel$Fiche$View$cleDeLElement = function (element) {
	if (!element.$) {
		var ligne = element.a;
		return ligne.dy;
	} else {
		var cle = element.a;
		return cle;
	}
};
var $author$project$Components$Referentiel$Fiche$View$groupeDuBloc = function (element) {
	if (!element.$) {
		return $elm$core$Maybe$Nothing;
	} else {
		var html = element.b;
		return $elm$core$Maybe$Just(html);
	}
};
var $rtfeldman$elm_css$Html$Styled$h5 = $rtfeldman$elm_css$Html$Styled$node('h5');
var $author$project$Components$Referentiel$Fiche$View$ligneOuTiret = F2(
	function (i18n, ligne) {
		return $elm$core$List$isEmpty(ligne.Ki) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('champ')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$dt,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(ligne.Bl)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$dd,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('—')
						]))
				])) : A2($author$project$Components$Referentiel$Fiche$View$ligneDInformation, i18n, ligne);
	});
var $author$project$Components$Referentiel$Fiche$View$ligneDuBloc = F2(
	function (i18n, element) {
		if (!element.$) {
			var ligne = element.a;
			return $elm$core$Maybe$Just(
				A2($author$project$Components$Referentiel$Fiche$View$ligneOuTiret, i18n, ligne));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$BlocDuTypeDemande = F2(
	function (a, b) {
		return {$: 116, a: a, b: b};
	});
var $author$project$I18n$Cles$referentielFicheChampsDuTypeModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.champs-du-type.modifier', _List_Nil, 'Modifier le bloc');
};
var $author$project$Components$Referentiel$Fiche$View$modifierLeBloc = F4(
	function (i18n, type_, declencheur, libre) {
		return libre ? _List_fromArray(
			[
				A4(
				$author$project$Components$Shared$Bouton$View$boutonAvecIcone,
				2,
				$author$project$Components$Shared$Svg$svgEdit,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id(declencheur),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('modifier-le-bloc'),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						A2($author$project$Components$Referentiel$Fiche$Update$BlocDuTypeDemande, type_, declencheur))
					]),
				$author$project$I18n$Cles$referentielFicheChampsDuTypeModifier(i18n))
			]) : _List_Nil;
	});
var $author$project$I18n$Cles$referentielFicheAutresChamps = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.autres-champs', _List_Nil, 'Autres champs');
};
var $author$project$I18n$Cles$referentielFicheBlocCompte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.bloc-compte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champ') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champs'));
	});
var $author$project$I18n$Cles$referentielFicheBlocDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.bloc-detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Voir le détail (' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champ de plus)')) : ('Voir le détail (' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' champs de plus)')));
	});
var $author$project$I18n$Cles$referentielFicheResumeType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.type', _List_Nil, 'type');
};
var $author$project$Components$Referentiel$Fiche$View$blocDInformationParCollection = F5(
	function (i18n, bloc, declencheur, modifiable, repartition) {
		var sousBlocs = _Utils_ap(
			A2(
				$elm$core$List$map,
				function (_v2) {
					var collection = _v2.a;
					var lignes = _v2.b;
					return _Utils_Tuple2(
						collection.Bl,
						A3($author$project$Components$Shared$CollectionDeLaFiche$separerLeDetail, $author$project$Components$Referentiel$Fiche$View$cleDeLElement, collection, lignes));
				},
				repartition.js),
			$elm$core$List$isEmpty(repartition.t7) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$I18n$Cles$referentielFicheAutresChamps(i18n),
					_Utils_Tuple2(repartition.t7, _List_Nil))
				]));
		var sousBloc = F2(
			function (rang, _v0) {
				var libelle = _v0.a;
				var _v1 = _v0.b;
				var resume = _v1.a;
				var details = _v1.b;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('bloc-de-collection')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$rtfeldman$elm_css$Html$Styled$h5,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(libelle)
										])),
								A2(
									$elm$core$List$cons,
									A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$referentielFicheBlocCompte,
													i18n,
													{
														w: $elm$core$List$length(resume) + $elm$core$List$length(details)
													}))
											])),
									A4(
										$author$project$Components$Referentiel$Fiche$View$modifierLeBloc,
										i18n,
										bloc.r0.r8,
										(!rang) ? declencheur : (declencheur + ('-' + $elm$core$String$fromInt(rang))),
										modifiable)))),
							A2(
							$rtfeldman$elm_css$Html$Styled$dl,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('champs')
								]),
							A2(
								$elm$core$List$filterMap,
								$author$project$Components$Referentiel$Fiche$View$ligneDuBloc(i18n),
								resume)),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('groupes')
								]),
							A2(
								$elm$core$List$filterMap,
								$author$project$Components$Referentiel$Fiche$View$groupeDuBloc,
								_Utils_ap(resume, details))),
							$elm$core$List$isEmpty(details) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
							$rtfeldman$elm_css$Html$Styled$details,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('detail-du-bloc')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$summary,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$referentielFicheBlocDetail,
												i18n,
												{
													w: $elm$core$List$length(details)
												}))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$dl,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('champs')
										]),
									A2(
										$elm$core$List$filterMap,
										$author$project$Components$Referentiel$Fiche$View$ligneDuBloc(i18n),
										details))
								]))
						]));
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('bloc-du-type'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('clos', !bloc.yj)
						]))
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h4,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(bloc.r0.R.zX)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('type')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielFicheResumeType(i18n))
								]))
						])),
				A2($elm$core$List$indexedMap, sousBloc, sousBlocs)));
	});
var $author$project$I18n$Cles$referentielFicheResumeChampNonRenseigne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.resume.champ-non-renseigne',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'liste',
					$author$project$I18n$Traductions$Chaine(p.nW))
				]),
			'1 champ non renseigné : ' + p.nW);
	});
var $author$project$I18n$Cles$referentielFicheResumeChampsNonRenseignes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.resume.champs-non-renseignes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d)),
					_Utils_Tuple2(
					'liste',
					$author$project$I18n$Traductions$Chaine(p.nW))
				]),
			p.d + (' champs non renseignés : ' + p.nW));
	});
var $author$project$Components$Referentiel$Fiche$View$champsVides = F5(
	function (i18n, modifiable, declencheur, bloc, libelles) {
		var texte = ($elm$core$List$length(libelles) === 1) ? A2(
			$author$project$I18n$Cles$referentielFicheResumeChampNonRenseigne,
			i18n,
			{
				nW: A2($elm$core$String$join, ', ', libelles)
			}) : A2(
			$author$project$I18n$Cles$referentielFicheResumeChampsNonRenseignes,
			i18n,
			{
				nW: A2($elm$core$String$join, ', ', libelles),
				d: $elm$core$String$fromInt(
					$elm$core$List$length(libelles))
			});
		return modifiable ? A4(
			$author$project$Components$Shared$Bouton$View$boutonAvecIcone,
			2,
			$author$project$Components$Shared$Svg$svgAdd,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id(declencheur + '-vides'),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					A2($author$project$Components$Referentiel$Fiche$Update$BlocDuTypeDemande, bloc.r0.r8, declencheur + '-vides'))
				]),
			texte) : A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('vides-texte')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(texte)
				]));
	});
var $author$project$Components$Referentiel$Fiche$View$blocSansCollection = F7(
	function (i18n, bloc, declencheur, modifiable, remplies, vides, groupes) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('bloc-du-type'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('clos', !bloc.yj)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$h4,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(bloc.r0.R.zX)
								])),
						A2(
							$elm$core$List$cons,
							A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('type')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielFicheResumeType(i18n))
									])),
							A4($author$project$Components$Referentiel$Fiche$View$modifierLeBloc, i18n, bloc.r0.r8, declencheur, modifiable)))),
					A2(
					$rtfeldman$elm_css$Html$Styled$dl,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('champs')
						]),
					A2(
						$elm$core$List$map,
						$author$project$Components$Referentiel$Fiche$View$ligneDInformation(i18n),
						remplies)),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('groupes')
						]),
					groupes),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('vides')
						]),
					$elm$core$List$isEmpty(vides) ? _List_Nil : _List_fromArray(
						[
							A5(
							$author$project$Components$Referentiel$Fiche$View$champsVides,
							i18n,
							modifiable,
							declencheur,
							bloc,
							A2(
								$elm$core$List$map,
								function ($) {
									return $.Bl;
								},
								vides))
						]))
				]));
	});
var $author$project$Components$Referentiel$Fiche$View$champsModifiables = function (bloc) {
	return bloc.yj && A2(
		$elm$core$List$any,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.uC;
			},
			$elm$core$Basics$not),
		bloc.dw);
};
var $author$project$Components$Referentiel$Common$ChoixDeLien$choixDesNommees = F2(
	function (sansNom, champs) {
		return A2(
			$elm$core$List$map,
			function (lu) {
				return {
					dy: lu.uN,
					nW: '',
					Ca: false,
					Fk: false,
					FS: false,
					hu: _List_Nil,
					pE: A2(
						$elm$core$List$map,
						function (n) {
							return {
								tI: false,
								Aq: n.r8,
								R: _List_fromArray(
									[
										_Utils_Tuple2(
										'fr',
										A2($elm$core$Maybe$withDefault, sansNom, n.Dj))
									])
							};
						},
						lu.DF),
					al: $elm$core$Maybe$Nothing
				};
			},
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.DF;
					},
					A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)),
				champs));
	});
var $author$project$Components$Referentiel$Fiche$Update$RetraitDOccurrenceDemande = F3(
	function (a, b, c) {
		return {$: 122, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$Fiche$View$groupeDeLaFiche = F4(
	function (i18n, normes, bloc, definition) {
		var servi = function (rel) {
			return !_Utils_eq(
				A3($author$project$Components$Referentiel$Fiche$Occurrences$lienDe, rel, bloc, definition.dy),
				$elm$core$Maybe$Nothing);
		};
		var quand = F2(
			function (rel, msg) {
				return servi(rel) ? $elm$core$Maybe$Just(msg) : $elm$core$Maybe$Nothing;
			});
		var actions = {
			s7: A2(
				quand,
				$author$project$API$NavLinksDictionary$ajouterUneOccurrence,
				A3($author$project$Components$Referentiel$Fiche$Update$OccurrenceDemandee, bloc.r0.r8, definition.dy, $elm$core$Maybe$Nothing)),
			ei: servi($author$project$API$NavLinksDictionary$modifierUneOccurrence) ? $elm$core$Maybe$Just(
				function (uid) {
					return A3(
						$author$project$Components$Referentiel$Fiche$Update$OccurrenceDemandee,
						bloc.r0.r8,
						definition.dy,
						$elm$core$Maybe$Just(uid));
				}) : $elm$core$Maybe$Nothing,
			H0: servi($author$project$API$NavLinksDictionary$retirerUneOccurrence) ? $elm$core$Maybe$Just(
				A2($author$project$Components$Referentiel$Fiche$Update$RetraitDOccurrenceDemande, bloc.r0.r8, definition.dy)) : $elm$core$Maybe$Nothing
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('champ-groupe'),
					$rtfeldman$elm_css$Html$Styled$Attributes$id('groupe-' + definition.dy)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h5,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(definition.Bl)
						])),
					A5(
					$author$project$Components$Shared$EditeurDeSchema$Groupe$bloc,
					i18n,
					{jN: bloc.jN, zu: _List_Nil, nn: 'fr', R: _List_Nil, hd: normes},
					actions,
					definition,
					A2($author$project$Components$Referentiel$Fiche$Occurrences$valeurDe, bloc, definition.dy))
				]));
	});
var $author$project$Components$Referentiel$Fiche$Resume$valeursLisibles = F4(
	function (i18n, reponses, champ, valeur) {
		var libelle = function (code) {
			return A2(
				$elm$core$Maybe$withDefault,
				code,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$second,
					A2(
						$elm$core$Maybe$andThen,
						function (_v4) {
							var traductions = _v4.b;
							return $elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (_v5) {
										var langue = _v5.a;
										return langue === 'fr';
									},
									traductions));
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (_v3) {
									var de = _v3.a;
									return _Utils_eq(de, code);
								},
								champ.Bt)))));
		};
		switch (valeur.$) {
			case 0:
				return _List_Nil;
			case 1:
				var texte = valeur.a;
				if ($elm$core$String$isEmpty(texte)) {
					return _List_Nil;
				} else {
					var _v1 = champ.r0;
					switch (_v1.$) {
						case 15:
							return _List_fromArray(
								[
									A2($author$project$Referentiel$Normes$nomDePays, reponses.hd, texte)
								]);
						case 16:
							return _List_fromArray(
								[
									A2($author$project$Referentiel$Normes$nomDeLangue, reponses.hd, texte)
								]);
						case 5:
							return _List_fromArray(
								[
									A2($author$project$Texte$Jour$enFrancais, i18n, texte)
								]);
						default:
							return _List_fromArray(
								[
									libelle(texte)
								]);
					}
				}
			case 2:
				var nombre = valeur.a;
				return _List_fromArray(
					[
						$elm$core$String$fromFloat(nombre)
					]);
			case 3:
				var vrai = valeur.a;
				return _List_fromArray(
					[
						vrai ? reponses.Er : reponses.DK
					]);
			case 4:
				var textes = valeur.a;
				var _v2 = champ.r0;
				switch (_v2.$) {
					case 15:
						return A2(
							$elm$core$List$map,
							$author$project$Referentiel$Normes$nomDePays(reponses.hd),
							textes);
					case 16:
						return A2(
							$elm$core$List$map,
							$author$project$Referentiel$Normes$nomDeLangue(reponses.hd),
							textes);
					default:
						return A2($elm$core$List$map, libelle, textes);
				}
			case 5:
				var traductions = valeur.a;
				return A2(
					$elm$core$List$take,
					1,
					A2($elm$core$List$filterMap, $elm$core$Tuple$second, traductions));
			case 6:
				var uids = valeur.b;
				return A2($elm$core$List$map, libelle, uids);
			case 7:
				var uids = valeur.b;
				return A2($elm$core$List$map, libelle, uids);
			case 8:
				return _List_Nil;
			default:
				var lue = valeur.a;
				return _List_fromArray(
					[
						A2(
						$elm$core$String$join,
						', ',
						A2(
							$elm$core$List$filter,
							$elm$core$Basics$neq(''),
							_Utils_ap(
								lue.gV,
								_List_fromArray(
									[
										$elm$core$String$trim(
										A2($elm$core$Maybe$withDefault, '', lue.vz) + (' ' + lue.B_)),
										A2($elm$core$Maybe$withDefault, '', lue.Hj),
										A2($author$project$Referentiel$Normes$nomDePays, reponses.hd, lue.ho)
									]))))
					]);
		}
	});
var $author$project$Components$Referentiel$Fiche$View$blocDInformation = F4(
	function (i18n, peutModifierLeBloc, model, bloc) {
		var modifiable = peutModifierLeBloc && $author$project$Components$Referentiel$Fiche$View$champsModifiables(bloc);
		var declencheur = 'modifier-le-bloc-' + $author$project$Components$Referentiel$Identifiants$typeUidToString(bloc.r0.r8);
		var connus = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.dw;
				},
				A2($author$project$Components$Referentiel$Fiche$Model$schemaDuType, bloc.r0.r8, model)));
		var groupesServis = A2(
			$elm$core$List$map,
			function (connu) {
				return _Utils_Tuple2(
					connu.dy,
					A4($author$project$Components$Referentiel$Fiche$View$groupeDeLaFiche, i18n, model.hd, bloc, connu));
			},
			A2(
				$elm$core$List$filter,
				function (connu) {
					return A2(
						$elm$core$List$any,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.uN;
							},
							$elm$core$Basics$eq(connu.dy)),
						bloc.dw);
				},
				A2(
					$elm$core$List$filter,
					function (connu) {
						return !_Utils_eq(
							$author$project$Components$Shared$EditeurDeSchema$Groupe$sousChampsDe(connu),
							$elm$core$Maybe$Nothing);
					},
					connus)));
		var groupes = A2($elm$core$List$map, $elm$core$Tuple$second, groupesServis);
		var lignes = A2(
			$elm$core$List$filterMap,
			function (lu) {
				return A2(
					$elm$core$Maybe$map,
					function (connu) {
						return {
							di: function () {
								var _v2 = connu.r0;
								if (_v2.$ === 17) {
									return true;
								} else {
									return false;
								}
							}(),
							dy: connu.dy,
							gH: lu.gH,
							Am: lu.Am,
							Bl: connu.Bl,
							eB: (!$elm$core$List$isEmpty(connu.Bt)) || function () {
								var _v3 = connu.r0;
								if (_v3.$ === 8) {
									return true;
								} else {
									return false;
								}
							}(),
							Ki: A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A3(
										$author$project$Components$Referentiel$Fiche$Resume$valeursLisibles,
										i18n,
										{
											DK: $author$project$I18n$Cles$referentielFicheResumeNon(i18n),
											hd: model.hd,
											Er: $author$project$I18n$Cles$referentielFicheResumeOui(i18n)
										},
										A2(
											$author$project$Components$Referentiel$Fiche$View$avecLesLibellesDuChoix,
											_Utils_ap(
												bloc.jN,
												A2(
													$author$project$Components$Referentiel$Common$ChoixDeLien$choixDesNommees,
													$author$project$I18n$Cles$referentielLienSansNom(i18n),
													bloc.dw)),
											connu)),
									lu.fm))
						};
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (connu) {
								return _Utils_eq(connu.dy, lu.uN) && _Utils_eq(
									$author$project$Components$Shared$EditeurDeSchema$Groupe$sousChampsDe(connu),
									$elm$core$Maybe$Nothing);
							},
							connus)));
			},
			bloc.dw);
		var repartition = A3(
			$author$project$Components$Shared$CollectionDeLaFiche$repartir,
			$author$project$Components$Referentiel$Fiche$View$cleDeLElement,
			bloc.vE,
			_Utils_ap(
				A2($elm$core$List$map, $author$project$Components$Referentiel$Fiche$View$UneLigne, lignes),
				A2(
					$elm$core$List$map,
					function (_v1) {
						var cle = _v1.a;
						var html = _v1.b;
						return A2($author$project$Components$Referentiel$Fiche$View$UnGroupe, cle, html);
					},
					groupesServis)));
		var _v0 = A2(
			$elm$core$List$partition,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Ki;
				},
				A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)),
			lignes);
		var remplies = _v0.a;
		var vides = _v0.b;
		return $elm$core$List$isEmpty(repartition.js) ? A7($author$project$Components$Referentiel$Fiche$View$blocSansCollection, i18n, bloc, declencheur, modifiable, remplies, vides, groupes) : A5($author$project$Components$Referentiel$Fiche$View$blocDInformationParCollection, i18n, bloc, declencheur, modifiable, repartition);
	});
var $author$project$Components$Referentiel$Fiche$Resume$renseigne = function (valeur) {
	switch (valeur.$) {
		case 0:
			return false;
		case 1:
			var texte = valeur.a;
			return !$elm$core$String$isEmpty(texte);
		case 2:
			return true;
		case 3:
			return true;
		case 4:
			var textes = valeur.a;
			return !$elm$core$List$isEmpty(textes);
		case 5:
			var traductions = valeur.a;
			return A2(
				$elm$core$List$any,
				function (_v1) {
					var texte = _v1.b;
					return A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not),
							texte));
				},
				traductions);
		case 6:
			return false;
		case 7:
			return false;
		case 8:
			var occurrences = valeur.a;
			return !$elm$core$List$isEmpty(occurrences);
		default:
			return true;
	}
};
var $author$project$Components$Referentiel$Fiche$View$champsRenseignesDesTypes = function (fiche) {
	return A2(
		$elm$core$List$concatMap,
		function (bloc) {
			return A2(
				$elm$core$List$map,
				function (lu) {
					return A2(
						$elm$core$Maybe$withDefault,
						false,
						A2($elm$core$Maybe$map, $author$project$Components$Referentiel$Fiche$Resume$renseigne, lu.fm));
				},
				bloc.dw);
		},
		fiche.uW);
};
var $author$project$Components$Referentiel$Fiche$View$idOuvrirUnRole = 'role-ouvrir';
var $author$project$I18n$Cles$referentielFicheResumeAucunType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.aucun-type', _List_Nil, 'Aucun type : la fiche n\'a pas de champ complémentaire.');
};
var $author$project$I18n$Cles$referentielFicheResumeFicheDInformation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.fiche-d-information', _List_Nil, 'Fiche d\'information');
};
var $author$project$I18n$Cles$referentielRoleOuvrir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.ouvrir', _List_Nil, 'Ouvrir un rôle');
};
var $author$project$Components$Referentiel$Fiche$View$ficheDInformation = F3(
	function (i18n, fiche, model) {
		var renseignes = $author$project$Components$Referentiel$Fiche$View$champsRenseignesDesTypes(fiche);
		var libre = $author$project$Components$Referentiel$Fiche$Model$peutModifier(fiche) && _Utils_eq(model.ge, $author$project$Components$Referentiel$Fiche$Model$Fermee);
		return A2(
			$author$project$Components$Shared$Page$View$sectionAvecCompte,
			$author$project$Components$Referentiel$Fiche$View$ancre('information'),
			{
				fw: _List_Nil,
				vW: $elm$core$List$isEmpty(fiche.uW) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$elm$core$String$fromInt(
						$elm$core$List$length(
							A2($elm$core$List$filter, $elm$core$Basics$identity, renseignes))) + (' / ' + $elm$core$String$fromInt(
						$elm$core$List$length(renseignes)))),
				fZ: $elm$core$List$isEmpty(fiche.uW) ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielFicheResumeAucunType(i18n))
							])),
						(!_Utils_eq(fiche.EC, $elm$core$Maybe$Nothing)) ? A4(
						$author$project$Components$Shared$Bouton$View$boutonAvecIcone,
						2,
						$author$project$Components$Shared$Svg$svgAdd,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Fiche$View$idOuvrirUnRole),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Referentiel$Fiche$Update$OuvertureDeRoleDemandee($author$project$Components$Referentiel$Fiche$View$idOuvrirUnRole))
							]),
						$author$project$I18n$Cles$referentielRoleOuvrir(i18n)) : $rtfeldman$elm_css$Html$Styled$text('')
					]) : A2(
					$elm$core$List$map,
					A3($author$project$Components$Referentiel$Fiche$View$blocDInformation, i18n, libre, model),
					fiche.uW),
				Ar: $elm$core$Maybe$Nothing,
				Dj: 'fiche-d-information',
				h6: $author$project$I18n$Cles$referentielFicheResumeFicheDInformation(i18n)
			});
	});
var $author$project$Components$Referentiel$Fiche$View$nomSansCivilite = F2(
	function (i18n, fiche) {
		return A2(
			$author$project$Components$Referentiel$Fiche$Model$texteDuTitre,
			i18n,
			A2(
				$elm$core$List$take,
				1,
				$elm$core$List$reverse(
					$author$project$Components$Referentiel$Fiche$Model$titre(fiche))));
	});
var $author$project$I18n$Cles$referentielFicheFilOrganisations = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.fil.organisations', _List_Nil, 'Organisations');
};
var $author$project$I18n$Cles$referentielFicheFilPersonnes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.fil.personnes', _List_Nil, 'Personnes');
};
var $author$project$Components$Referentiel$Fiche$View$filDArianeDe = F2(
	function (i18n, fiche) {
		var liste = $author$project$Routes$Route$premierePage;
		var aucunFiltreDeListe = $author$project$Routes$Route$aucunFiltre;
		var _v0 = function () {
			var _v1 = fiche.g1;
			if (!_v1) {
				return _Utils_Tuple2(
					$author$project$I18n$Cles$referentielFicheFilPersonnes(i18n),
					'Personne');
			} else {
				return _Utils_Tuple2(
					$author$project$I18n$Cles$referentielFicheFilOrganisations(i18n),
					'Organisation');
			}
		}();
		var libelle = _v0.a;
		var code = _v0.b;
		return _Utils_ap(
			$author$project$Components$Referentiel$Fiche$View$filDAriane(i18n),
			_List_fromArray(
				[
					{
					aa: $author$project$Routes$Route$toString(
						$author$project$Routes$Route$PartiesPrenantesListe(
							_Utils_update(
								liste,
								{
									mG: _Utils_update(
										aucunFiltreDeListe,
										{
											g1: $elm$core$Maybe$Just(code)
										})
								}))),
					Dj: libelle
				},
					{
					aa: '',
					Dj: A2($author$project$Components$Referentiel$Fiche$View$nomSansCivilite, i18n, fiche)
				}
				]));
	});
var $author$project$Components$Referentiel$Fiche$Update$FamilleChoisie = function (a) {
	return {$: 85, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$SourceChoisie = function (a) {
	return {$: 86, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$ToutAfficherDemande = {$: 87};
var $author$project$Components$Referentiel$Fiche$Historique$DonneesPersonnelles = 4;
var $author$project$Components$Referentiel$Fiche$Historique$Modifications = 0;
var $author$project$Components$Referentiel$Fiche$Historique$Roles = 1;
var $author$project$Components$Referentiel$Fiche$Historique$familles = _List_fromArray(
	[0, 1, 2, 3, 4]);
var $author$project$Components$Referentiel$Fiche$View$filtre = F4(
	function (choisi, actif, msg, libelle) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('filtre'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('active', choisi)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-pressed',
					choisi ? 'true' : 'false'),
					$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!actif),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						]))
				]));
	});
var $author$project$Components$Referentiel$Fiche$View$filtres = F3(
	function (nom, classe, boutons) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('filtres'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(classe),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'group'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', nom)
				]),
			boutons);
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueFamilleDonneesPersonnelles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.famille.donnees-personnelles', _List_Nil, 'Données personnelles');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueFamilleDossiers = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.famille.dossiers', _List_Nil, 'Dossiers');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueFamilleEchanges = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.famille.echanges', _List_Nil, 'Échanges');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueFamilleModifications = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.famille.modifications', _List_Nil, 'Modifications');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueFamilleRoles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.famille.roles', _List_Nil, 'Rôles');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueFamilleTout = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.famille.tout', _List_Nil, 'Tout');
};
var $author$project$Components$Referentiel$Fiche$Historique$libelleDeLaFamille = F2(
	function (i18n, famille) {
		if (famille.$ === 1) {
			return $author$project$I18n$Cles$referentielFicheHistoriqueFamilleTout(i18n);
		} else {
			switch (famille.a) {
				case 0:
					var _v1 = famille.a;
					return $author$project$I18n$Cles$referentielFicheHistoriqueFamilleModifications(i18n);
				case 1:
					var _v2 = famille.a;
					return $author$project$I18n$Cles$referentielFicheHistoriqueFamilleRoles(i18n);
				case 2:
					var _v3 = famille.a;
					return $author$project$I18n$Cles$referentielFicheHistoriqueFamilleDossiers(i18n);
				case 3:
					var _v4 = famille.a;
					return $author$project$I18n$Cles$referentielFicheHistoriqueFamilleEchanges(i18n);
				default:
					var _v5 = famille.a;
					return $author$project$I18n$Cles$referentielFicheHistoriqueFamilleDonneesPersonnelles(i18n);
			}
		}
	});
var $author$project$I18n$Cles$referentielFicheHistoriqueAucunDeCeType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.aucun-de-ce-type', _List_Nil, 'Aucun événement de ce type');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueFiltresFamille = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.filtres.famille', _List_Nil, 'Famille d\'événements');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueFiltresSource = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.filtres.source', _List_Nil, 'Source');
};
var $author$project$I18n$Cles$referentielFicheHistoriqueToutAfficher = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.historique.tout-afficher', _List_Nil, 'Tout afficher');
};
var $author$project$I18n$Cles$referentielFicheOngletHistorique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.onglet.historique', _List_Nil, 'Historique');
};
var $author$project$I18n$Cles$referentielFicheOngletVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.onglet.vide', _List_Nil, 'Cette partie de la fiche n\'est pas encore disponible.');
};
var $author$project$Components$Referentiel$Fiche$Historique$sansResultat = function (etat) {
	return (etat.u7 === 2) && ($elm$core$List$isEmpty(etat.gV) && (!$author$project$Components$Referentiel$Fiche$Historique$sansFiltre(etat)));
};
var $author$project$Components$Referentiel$Fiche$Historique$sources = _List_fromArray(
	[0, 1, 2, 3, 4]);
var $author$project$Components$Referentiel$Fiche$View$vide = F3(
	function (nom, titre, message) {
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_Nil,
			{
				fw: _List_Nil,
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(message)
							]))
					]),
				Dj: nom,
				h6: titre
			});
	});
var $author$project$Components$Referentiel$Fiche$View$historique = F3(
	function (i18n, fiche, model) {
		return _Utils_eq(fiche.m6, $elm$core$Maybe$Nothing) ? A3(
			$author$project$Components$Referentiel$Fiche$View$vide,
			'a-venir',
			$author$project$I18n$Cles$referentielFicheOngletHistorique(i18n),
			$author$project$I18n$Cles$referentielFicheOngletVide(i18n)) : A2(
			$author$project$Components$Shared$Page$View$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('loading', model.m6.u7 === 1)
						]))
				]),
			{
				fw: _List_Nil,
				fZ: _List_fromArray(
					[
						A3(
						$author$project$Components$Referentiel$Fiche$View$filtres,
						$author$project$I18n$Cles$referentielFicheHistoriqueFiltresFamille(i18n),
						'familles',
						A2(
							$elm$core$List$cons,
							A4(
								$author$project$Components$Referentiel$Fiche$View$filtre,
								_Utils_eq(model.m6.zj, $elm$core$Maybe$Nothing),
								true,
								$author$project$Components$Referentiel$Fiche$Update$FamilleChoisie($elm$core$Maybe$Nothing),
								A2($author$project$Components$Referentiel$Fiche$Historique$libelleDeLaFamille, i18n, $elm$core$Maybe$Nothing)),
							A2(
								$elm$core$List$map,
								function (famille) {
									return A4(
										$author$project$Components$Referentiel$Fiche$View$filtre,
										_Utils_eq(
											model.m6.zj,
											$elm$core$Maybe$Just(famille)),
										$author$project$Components$Referentiel$Fiche$Historique$estActive(famille),
										$author$project$Components$Referentiel$Fiche$Update$FamilleChoisie(
											$elm$core$Maybe$Just(famille)),
										A2(
											$author$project$Components$Referentiel$Fiche$Historique$libelleDeLaFamille,
											i18n,
											$elm$core$Maybe$Just(famille)));
								},
								$author$project$Components$Referentiel$Fiche$Historique$familles))),
						A3(
						$author$project$Components$Referentiel$Fiche$View$filtres,
						$author$project$I18n$Cles$referentielFicheHistoriqueFiltresSource(i18n),
						'sources',
						A2(
							$elm$core$List$cons,
							A4(
								$author$project$Components$Referentiel$Fiche$View$filtre,
								_Utils_eq(model.m6.IR, $elm$core$Maybe$Nothing),
								true,
								$author$project$Components$Referentiel$Fiche$Update$SourceChoisie($elm$core$Maybe$Nothing),
								A2($author$project$Components$Referentiel$Fiche$Historique$libelleDeLaSource, i18n, $elm$core$Maybe$Nothing)),
							A2(
								$elm$core$List$map,
								function (source) {
									return A4(
										$author$project$Components$Referentiel$Fiche$View$filtre,
										_Utils_eq(
											model.m6.IR,
											$elm$core$Maybe$Just(source)),
										true,
										$author$project$Components$Referentiel$Fiche$Update$SourceChoisie(
											$elm$core$Maybe$Just(source)),
										A2(
											$author$project$Components$Referentiel$Fiche$Historique$libelleDeLaSource,
											i18n,
											$elm$core$Maybe$Just(source)));
								},
								$author$project$Components$Referentiel$Fiche$Historique$sources))),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('evenements')
							]),
						A2(
							$elm$core$List$indexedMap,
							function (rang) {
								return A6(
									$author$project$Components$Referentiel$Fiche$View$evenement,
									i18n,
									model.hd,
									true,
									fiche,
									model.bi,
									A2($author$project$Components$Referentiel$Fiche$View$ouDeLaLigne, 'chronologie', rang));
							},
							model.m6.gV)),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('sans-resultat')
							]),
						$author$project$Components$Referentiel$Fiche$Historique$sansResultat(model.m6) ? _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielFicheHistoriqueAucunDeCeType(i18n))
									])),
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('tout-afficher'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Fiche$Update$ToutAfficherDemande)
									]),
								$author$project$I18n$Cles$referentielFicheHistoriqueToutAfficher(i18n))
							]) : _List_Nil)
					]),
				Dj: 'historique',
				h6: $author$project$I18n$Cles$referentielFicheOngletHistorique(i18n)
			});
	});
var $author$project$Components$Referentiel$Fiche$HorsLimites$valeursDe = function (lu) {
	var _v0 = lu.fm;
	if (!_v0.$) {
		var valeur = _v0.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(lu.uN, valeur)
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Referentiel$Fiche$HorsLimites$de = F3(
	function (i18n, schemaDe, blocs) {
		return A2(
			$elm$core$List$concatMap,
			function (bloc) {
				return A2(
					$elm$core$List$filterMap,
					function (lu) {
						return A3(
							$elm$core$Maybe$map2,
							F2(
								function (jour, champ) {
									return {
										dy: lu.uN,
										A_: jour,
										Bl: champ.Bl,
										nV: A2($author$project$Components$Shared$EditeurDeSchema$Limites$limiteDe, i18n, champ),
										fm: A3(
											$author$project$Components$Shared$EditeurDeSchema$Limites$valeurDe,
											i18n,
											champ,
											$author$project$Components$Referentiel$Fiche$HorsLimites$valeursDe(lu))
									};
								}),
							lu.Am,
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.dy;
										},
										$elm$core$Basics$eq(lu.uN)),
									schemaDe(bloc.r0.r8))));
					},
					bloc.dw);
			},
			blocs);
	});
var $author$project$Components$Referentiel$Fiche$View$horsLimitesDe = F3(
	function (i18n, model, fiche) {
		return A3(
			$author$project$Components$Referentiel$Fiche$HorsLimites$de,
			i18n,
			function (type_) {
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.dw;
						},
						A2($author$project$Components$Referentiel$Fiche$Model$schemaDuType, type_, model)));
			},
			fiche.uW);
	});
var $author$project$Components$Referentiel$Fiche$View$effectifs = function (fiche) {
	return A2(
		$elm$core$List$filter,
		function (fourni) {
			return fourni.gt === 1;
		},
		fiche.eX);
};
var $author$project$Components$Referentiel$Fiche$View$libelleDeNature = F2(
	function (i18n, nature) {
		if (!nature) {
			return $author$project$I18n$Cles$referentielNaturePersonne(i18n);
		} else {
			return $author$project$I18n$Cles$referentielNatureOrganisation(i18n);
		}
	});
var $author$project$I18n$Cles$referentielFicheEntetePosteChez = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.entete.poste-chez',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'poste',
					$author$project$I18n$Traductions$Chaine(p.F4))
				]),
			p.F4 + ' chez');
	});
var $author$project$I18n$Cles$referentielFicheEnteteSansType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.entete.sans-type', _List_Nil, 'sans type');
};
var $author$project$Components$Referentiel$Fiche$Rattachements$visibles = F2(
	function (avecLesTermines, rattachements) {
		return avecLesTermines ? rattachements : A2(
			$elm$core$List$filter,
			function (rattachement) {
				return rattachement.gt !== 2;
			},
			rattachements);
	});
var $author$project$Components$Referentiel$Fiche$View$identite = F3(
	function (i18n, fiche, model) {
		var posteChez = (!fiche.g1) ? A2(
			$elm$core$Maybe$andThen,
			function (lien) {
				return A2(
					$elm$core$Maybe$map,
					function (poste) {
						return A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$referentielFicheEntetePosteChez,
									i18n,
									{F4: poste})),
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_css$Html$Styled$text(' '),
								(lien.yP === 4) ? _List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$I18n$Cles$texte, i18n, lien.Dj))
									]) : _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href(
												$author$project$Routes$Route$toString(
													A2($author$project$Routes$Route$Fiche, lien.zo, 0)))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2($author$project$I18n$Cles$texte, i18n, lien.Dj))
											]))
									])));
					},
					function () {
						var _v1 = lien.F4;
						if (!_v1.$) {
							var poste = _v1.a;
							return $elm$core$Maybe$Just(
								A2($author$project$I18n$Cles$texte, i18n, poste));
						} else {
							return lien.AS;
						}
					}());
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (lien) {
						return lien.gt === 1;
					},
					A2($author$project$Components$Referentiel$Fiche$Rattachements$visibles, false, fiche.GY)))) : $elm$core$Maybe$Nothing;
		var nature = function () {
			var _v0 = fiche.g1;
			if (_v0 === 1) {
				return A2(
					$elm$core$List$cons,
					A2($author$project$Components$Referentiel$Fiche$View$libelleDeNature, i18n, fiche.g1),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							$elm$core$List$singleton,
							A2($author$project$Components$Referentiel$Fiche$View$formeDe, fiche, model))));
			} else {
				return A2(
					$elm$core$List$cons,
					A2($author$project$Components$Referentiel$Fiche$View$libelleDeNature, i18n, fiche.g1),
					$elm$core$List$isEmpty(
						$author$project$Components$Referentiel$Fiche$View$effectifs(fiche)) ? _List_fromArray(
						[
							$author$project$I18n$Cles$referentielFicheEnteteSansType(i18n)
						]) : _List_Nil);
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$ul,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('infos')
				]),
			A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Html$Styled$li(_List_Nil),
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$elm$core$Maybe$Just(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$String$join, ' · ', nature))
								])),
							posteChez,
							A2(
							$elm$core$Maybe$map,
							function (pays) {
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A4($author$project$Components$Referentiel$Fiche$View$affichee, i18n, model.hd, 5, pays))
									]);
							},
							A2($author$project$Components$Referentiel$Fiche$Model$valeurDe, 5, fiche))
						]))));
	});
var $author$project$Components$Referentiel$Fiche$Update$EditionDemandee = function (a) {
	return {$: 7, a: a};
};
var $author$project$I18n$Cles$referentielFicheChampModifier = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.champ.modifier',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN))
				]),
			'Modifier : ' + p.uN);
	});
var $author$project$Components$Referentiel$Fiche$View$crayon = F2(
	function (i18n, cle) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('button-icon'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('modifier'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					A2(
						$author$project$I18n$Cles$referentielFicheChampModifier,
						i18n,
						{
							uN: A2($author$project$Components$Referentiel$Fiche$View$libelleDe, i18n, cle)
						})),
					$rtfeldman$elm_css$Html$Styled$Attributes$title(
					A2(
						$author$project$I18n$Cles$referentielFicheChampModifier,
						i18n,
						{
							uN: A2($author$project$Components$Referentiel$Fiche$View$libelleDe, i18n, cle)
						})),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Components$Referentiel$Fiche$Update$EditionDemandee(cle))
				]),
			_List_fromArray(
				[$author$project$Components$Shared$Svg$svgEdit]));
	});
var $author$project$Components$Referentiel$Fiche$View$dansLIdentiteDUneOrganisation = F2(
	function (fiche, cle) {
		return (fiche.g1 === 1) && A2(
			$elm$core$List$member,
			cle,
			_List_fromArray(
				[3, 5, 7]));
	});
var $author$project$Components$Referentiel$Fiche$View$languesProposees = function (courante) {
	return ((courante === '') || A2(
		$elm$core$List$any,
		function (langue) {
			return _Utils_eq(langue.vx, courante);
		},
		$author$project$Referentiel$Langues$toutes)) ? $author$project$Referentiel$Langues$toutes : _Utils_ap(
		$author$project$Referentiel$Langues$toutes,
		_List_fromArray(
			[
				{
				vx: courante,
				Bl: $author$project$I18n$Traductions$tel(courante)
			}
			]));
};
var $author$project$Components$Referentiel$Fiche$View$qualites = _List_fromArray(
	['Particulier', 'Professionnel']);
var $author$project$I18n$Cles$referentielFicheChampAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.champ.aucune', _List_Nil, 'Aucune');
};
var $author$project$Components$Referentiel$Fiche$View$saisie = F3(
	function (i18n, model, cle) {
		var valeur = A2($author$project$Components$Referentiel$Fiche$Model$saisieDe, cle, model);
		var decrit = {
			go: A2(
				$elm$core$Maybe$map,
				$author$project$I18n$Cles$texte(i18n),
				A2($author$project$Components$Referentiel$Fiche$Model$erreurDe, cle, model)),
			Aq: $author$project$Components$Referentiel$Fiche$View$idDuChamp(cle),
			Bl: A2($author$project$Components$Referentiel$Fiche$View$libelleDe, i18n, cle),
			he: (cle !== 6) && (!(!cle))
		};
		var choix = function (options) {
			return A2(
				$author$project$Components$Shared$Champ$View$liste,
				decrit,
				{
					hg: $author$project$Components$Referentiel$Fiche$Update$SaisieChangee(cle),
					o_: options,
					fm: valeur
				});
		};
		switch (cle) {
			case 0:
				return choix(
					A2(
						$elm$core$List$cons,
						{
							Bl: $author$project$I18n$Cles$referentielFicheChampAucune(i18n),
							fm: ''
						},
						A2(
							$elm$core$List$map,
							function (code) {
								return {
									Bl: A2(
										$author$project$I18n$Cles$texte,
										i18n,
										$author$project$Referentiel$Civilites$nom(code)),
									fm: code
								};
							},
							$author$project$Referentiel$Civilites$toutes)));
			case 4:
				return choix(
					A2(
						$elm$core$List$map,
						function (code) {
							return {
								Bl: A4($author$project$Components$Referentiel$Fiche$View$affichee, i18n, model.hd, 4, code),
								fm: code
							};
						},
						$author$project$Components$Referentiel$Fiche$View$qualites));
			case 5:
				return choix(
					A2(
						$elm$core$List$map,
						function (pays) {
							return {Bl: pays.Dj, fm: pays.vx};
						},
						$author$project$Referentiel$Normes$entreesDePays(model.hd)));
			case 6:
				return choix(
					A2(
						$elm$core$List$cons,
						{
							Bl: $author$project$I18n$Cles$referentielFicheChampAucune(i18n),
							fm: ''
						},
						A2(
							$elm$core$List$map,
							function (langue) {
								return {
									Bl: A2($author$project$I18n$Cles$texte, i18n, langue.Bl),
									fm: langue.vx
								};
							},
							$author$project$Components$Referentiel$Fiche$View$languesProposees(valeur))));
			default:
				return A2(
					$author$project$Components$Shared$Champ$View$texte,
					decrit,
					{
						hg: $author$project$Components$Referentiel$Fiche$Update$SaisieChangee(cle),
						fm: valeur
					});
		}
	});
var $author$project$Components$Referentiel$Fiche$View$memeIdentifiant = function (fiche) {
	return A2(
		$elm$core$List$any,
		function (doublon) {
			return A2($elm$core$List$member, 'MemeIdentifiantLegal', doublon.CY);
		},
		fiche.kW);
};
var $author$project$I18n$Cles$referentielFicheIdentiteDoublonPastille = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.identite.doublon.pastille', _List_Nil, 'Doublon possible');
};
var $author$project$Components$Referentiel$Fiche$View$valeurDuChamp = F5(
	function (i18n, fiche, model, cle, valeur) {
		var pastilleDIdentifiant = function () {
			var _v2 = _Utils_Tuple2(
				cle,
				$author$project$Components$Referentiel$Fiche$View$memeIdentifiant(fiche));
			if ((_v2.a === 7) && _v2.b) {
				var _v3 = _v2.a;
				return _List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(' '),
						A2(
						$author$project$Components$Shared$Tag$View$view,
						1,
						$author$project$I18n$Cles$referentielFicheIdentiteDoublonPastille(i18n))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var _v0 = _Utils_Tuple2(
			cle,
			A2($author$project$Components$Referentiel$Fiche$Model$valeurDe, 5, fiche));
		if (((_v0.a === 7) && (!_v0.b.$)) && (_v0.b.a === 'FR')) {
			var _v1 = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$strong,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('value')
					]),
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Html$Styled$text(
						$author$project$Components$Referentiel$Fiche$Model$groupe(valeur)),
					_Utils_ap(
						($elm$core$String$length(valeur) === 14) ? _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(' '),
								A2(
								$author$project$Components$Shared$Tag$View$view,
								3,
								$author$project$I18n$Cles$referentielFicheIdentifiantLegalSiret(i18n))
							]) : _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(' '),
								A2(
								$author$project$Components$Shared$Tag$View$view,
								3,
								$author$project$I18n$Cles$referentielFicheIdentifiantLegalSiren(i18n))
							]),
						pastilleDIdentifiant)));
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$strong,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('value')
					]),
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Html$Styled$text(
						A4($author$project$Components$Referentiel$Fiche$View$affichee, i18n, model.hd, cle, valeur)),
					pastilleDIdentifiant));
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$EditionAnnulee = {$: 10};
var $author$project$Components$Referentiel$Fiche$Update$Validee = {$: 11};
var $author$project$I18n$Cles$referentielFicheChampAnnuler = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.champ.annuler', _List_Nil, 'Annuler');
};
var $author$project$Components$Referentiel$Fiche$View$validation = F2(
	function (i18n, model) {
		var enCours = function () {
			var _v0 = model.l2;
			if (_v0.$ === 2) {
				return true;
			} else {
				return false;
			}
		}();
		return _List_fromArray(
			[
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('annuler'),
						$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Fiche$Update$EditionAnnulee),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(enCours)
					]),
				$author$project$I18n$Cles$referentielFicheChampAnnuler(i18n)),
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				0,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('valider'),
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('loading', enCours)
							])),
						$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Fiche$Update$Validee),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(enCours)
					]),
				$author$project$I18n$Cles$referentielFicheChampValider(i18n))
			]);
	});
var $author$project$Components$Referentiel$Fiche$View$champ = F5(
	function (i18n, fiche, model, libre, cle) {
		return (A2($author$project$Components$Referentiel$Fiche$Model$enEdition, cle, model) && (!(_Utils_eq(model.ge, $author$project$Components$Referentiel$Fiche$Model$DansLeDrawerDIdentite) && A2($author$project$Components$Referentiel$Fiche$View$dansLIdentiteDUneOrganisation, fiche, cle)))) ? $elm$core$Maybe$Just(
			A2(
				$rtfeldman$elm_css$Html$Styled$li,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('champ'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('en-saisie')
					]),
				_List_fromArray(
					[
						A3($author$project$Components$Referentiel$Fiche$View$saisie, i18n, model, cle),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('field-actions')
							]),
						_Utils_eq(
							model.ge,
							$author$project$Components$Referentiel$Fiche$Model$DUnChamp(cle)) ? A2($author$project$Components$Referentiel$Fiche$View$validation, i18n, model) : _List_Nil)
					]))) : A2(
			$elm$core$Maybe$map,
			function (valeur) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('champ')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('field')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('label')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$Components$Referentiel$Fiche$View$libelleDe, i18n, cle))
										])),
									A5($author$project$Components$Referentiel$Fiche$View$valeurDuChamp, i18n, fiche, model, cle, valeur)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('field-actions')
								]),
							_Utils_ap(
								(libre && (A2($author$project$Components$Referentiel$Fiche$Model$peutModifierLeChamp, fiche, cle) && (!A2($author$project$Components$Referentiel$Fiche$View$dansLIdentiteDUneOrganisation, fiche, cle)))) ? _List_fromArray(
									[
										A2($author$project$Components$Referentiel$Fiche$View$crayon, i18n, cle)
									]) : _List_Nil,
								A5(
									$author$project$Components$Referentiel$Fiche$View$versLHistoriqueDuChamp,
									i18n,
									fiche,
									'resume',
									$author$project$Components$Referentiel$Fiche$Model$nomAuContrat(cle),
									A2($author$project$Components$Referentiel$Fiche$View$libelleDe, i18n, cle))))
						]));
			},
			A2($author$project$Components$Referentiel$Fiche$Model$valeurDe, cle, fiche));
	});
var $author$project$Components$Referentiel$Fiche$View$formeDeLaFiche = F3(
	function (i18n, fiche, model) {
		return A2(
			$elm$core$Maybe$map,
			function (forme) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('champ')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('field')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('label')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$referentielFicheResumeChampForme(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('value')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(forme)
										]))
								]))
						]));
			},
			A2($author$project$Components$Referentiel$Fiche$View$formeDe, fiche, model));
	});
var $author$project$Components$Referentiel$Fiche$View$isDUnChamp = function (edition) {
	if (edition.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$I18n$Cles$referentielFicheResumeChampNature = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.champ-nature', _List_Nil, 'Nature');
};
var $author$project$Components$Referentiel$Fiche$View$natureDeLaFiche = F2(
	function (i18n, fiche) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('champ')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('field')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('label')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielFicheResumeChampNature(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('value')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Referentiel$Fiche$View$libelleDeNature, i18n, fiche.g1))
								]))
						]))
				]));
	});
var $author$project$I18n$Cles$referentielFicheIdentiteModifierCourt = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.identite.modifier-court', _List_Nil, 'Modifier');
};
var $author$project$I18n$Cles$referentielFicheResumeIdentite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.identite', _List_Nil, 'Identité');
};
var $author$project$I18n$Cles$referentielFicheSociete = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.societe', _List_Nil, 'Société');
};
var $author$project$I18n$Cles$referentielFicheSocieteSiren = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.societe.siren',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'siren',
					$author$project$I18n$Traductions$Chaine(p.rc))
				]),
			'SIREN ' + p.rc);
	});
var $author$project$Components$Referentiel$Fiche$View$societeDeLEtablissement = F2(
	function (i18n, fiche) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Maybe$map,
					function (lien) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('champ'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('societe')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('field')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('label')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$referentielFicheSociete(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$strong,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('value')
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$a,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$href(
															$author$project$Routes$Route$toString(
																A2($author$project$Routes$Route$Fiche, lien.zo, 0)))
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															A2($author$project$I18n$Cles$texte, i18n, lien.Dj))
														])),
													A2(
													$elm$core$Maybe$withDefault,
													$rtfeldman$elm_css$Html$Styled$text(''),
													A2(
														$elm$core$Maybe$map,
														function (siren) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$span,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('siren')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(
																		A2(
																			$author$project$I18n$Cles$referentielFicheSocieteSiren,
																			i18n,
																			{
																				rc: $author$project$Components$Referentiel$Fiche$Model$groupe(siren)
																			}))
																	]));
														},
														lien.m7))
												]))
										]))
								]));
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (lien) {
								return _Utils_eq(lien.vx, $author$project$Components$Referentiel$Fiche$View$codeEtablissement) && lien.xA;
							},
							fiche.Hu)))));
	});
var $author$project$Components$Referentiel$Fiche$View$informations = F3(
	function (i18n, fiche, model) {
		var libre = $author$project$Components$Referentiel$Fiche$Model$peutModifier(fiche) && _Utils_eq(model.ge, $author$project$Components$Referentiel$Fiche$Model$Fermee);
		return A2(
			$author$project$Components$Shared$Page$View$section,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'edition',
							_Utils_eq(model.ge, $author$project$Components$Referentiel$Fiche$Model$DuBloc) || $author$project$Components$Referentiel$Fiche$View$isDUnChamp(model.ge))
						])),
				$author$project$Components$Referentiel$Fiche$View$ancre('identite')),
			{
				fw: (libre && $author$project$Components$Referentiel$Fiche$Model$peutModifierUnChamp(fiche)) ? _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						2,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('modifier-le-bloc'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('pale'),
								$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Fiche$Model$idDuDeclencheurDIdentite),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Fiche$Update$BlocDemande),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-label',
								$author$project$I18n$Cles$referentielFicheIdentiteModifier(i18n)),
								$rtfeldman$elm_css$Html$Styled$Attributes$title(
								$author$project$I18n$Cles$referentielFicheIdentiteModifier(i18n))
							]),
						$author$project$I18n$Cles$referentielFicheIdentiteModifierCourt(i18n))
					]) : _List_Nil,
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('champs')
							]),
						function () {
							var _v0 = function () {
								var _v1 = fiche.g1;
								if (!_v1) {
									return _Utils_Tuple2(
										A2(
											$elm$core$List$take,
											3,
											$author$project$Components$Referentiel$Fiche$Model$champsDe(fiche.g1)),
										A2(
											$elm$core$List$drop,
											3,
											$author$project$Components$Referentiel$Fiche$Model$champsDe(fiche.g1)));
								} else {
									return _Utils_Tuple2(
										A2(
											$elm$core$List$take,
											1,
											$author$project$Components$Referentiel$Fiche$Model$champsDe(fiche.g1)),
										A2(
											$elm$core$List$drop,
											1,
											$author$project$Components$Referentiel$Fiche$Model$champsDe(fiche.g1)));
								}
							}();
							var avant = _v0.a;
							var apres = _v0.b;
							return _Utils_ap(
								A2(
									$elm$core$List$filterMap,
									$elm$core$Basics$identity,
									A2(
										$elm$core$List$map,
										A4($author$project$Components$Referentiel$Fiche$View$champ, i18n, fiche, model, libre),
										avant)),
								_Utils_ap(
									_List_fromArray(
										[
											A2($author$project$Components$Referentiel$Fiche$View$natureDeLaFiche, i18n, fiche)
										]),
									_Utils_ap(
										A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2(
												$elm$core$Maybe$map,
												$elm$core$List$singleton,
												A3($author$project$Components$Referentiel$Fiche$View$formeDeLaFiche, i18n, fiche, model))),
										A2(
											$elm$core$List$concatMap,
											function (cle) {
												return _Utils_ap(
													(cle === 7) ? A2($author$project$Components$Referentiel$Fiche$View$societeDeLEtablissement, i18n, fiche) : _List_Nil,
													A2(
														$elm$core$Maybe$withDefault,
														_List_Nil,
														A2(
															$elm$core$Maybe$map,
															$elm$core$List$singleton,
															A5($author$project$Components$Referentiel$Fiche$View$champ, i18n, fiche, model, libre, cle))));
											},
											apres))));
						}()),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('section-actions')
							]),
						_Utils_eq(model.ge, $author$project$Components$Referentiel$Fiche$Model$DuBloc) ? A2($author$project$Components$Referentiel$Fiche$View$validation, i18n, model) : _List_Nil)
					]),
				Dj: 'informations',
				h6: $author$project$I18n$Cles$referentielFicheResumeIdentite(i18n)
			});
	});
var $author$project$Components$Referentiel$Fiche$View$compteDOnglet = F3(
	function (fiche, model, onglet) {
		switch (onglet) {
			case 2:
				return $elm$core$Maybe$Just(
					$elm$core$String$fromInt(
						$elm$core$List$length(
							A2($author$project$Components$Referentiel$Fiche$Rattachements$visibles, false, fiche.GY)) + $elm$core$List$length(fiche.Hu)));
			case 3:
				return ((model.m6.u7 === 2) && _Utils_eq(model.m6.I6, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(
					$elm$core$String$fromInt(
						$elm$core$List$length(model.m6.gV))) : $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$I18n$Cles$referentielFicheOngletDonneesPersonnelles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.onglet.donnees-personnelles', _List_Nil, 'Données personnelles');
};
var $author$project$I18n$Cles$referentielFicheOngletRattachements = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.onglet.rattachements', _List_Nil, 'Rattachements et relations');
};
var $author$project$I18n$Cles$referentielFicheOngletResume = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.onglet.resume', _List_Nil, 'Résumé');
};
var $author$project$I18n$Cles$referentielFicheOngletRoles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.onglet.roles', _List_Nil, 'Rôles');
};
var $author$project$Components$Referentiel$Fiche$View$nomDOnglet = F2(
	function (i18n, onglet) {
		switch (onglet) {
			case 0:
				return $author$project$I18n$Cles$referentielFicheOngletResume(i18n);
			case 1:
				return $author$project$I18n$Cles$referentielFicheOngletRoles(i18n);
			case 2:
				return $author$project$I18n$Cles$referentielFicheOngletRattachements(i18n);
			case 3:
				return $author$project$I18n$Cles$referentielFicheOngletHistorique(i18n);
			default:
				return $author$project$I18n$Cles$referentielFicheOngletDonneesPersonnelles(i18n);
		}
	});
var $author$project$Components$Referentiel$Fiche$View$lienDOnglet = F5(
	function (i18n, fiche, model, courant, onglet) {
		return {
			sO: _Utils_eq(onglet, courant),
			aa: $author$project$Routes$Route$toString(
				A2($author$project$Routes$Route$Fiche, fiche.r8, onglet)),
			vW: A3($author$project$Components$Referentiel$Fiche$View$compteDOnglet, fiche, model, onglet),
			Dj: A2($author$project$Components$Referentiel$Fiche$View$nomDOnglet, i18n, onglet)
		};
	});
var $author$project$Components$Referentiel$Fiche$Update$EvolutionDeRoleDemandee = F2(
	function (a, b) {
		return {$: 40, a: a, b: b};
	});
var $author$project$Components$Referentiel$Fiche$View$idFaireEvoluer = function (fourni) {
	return 'role-evoluer-' + fourni.r8;
};
var $author$project$I18n$Cles$referentielFicheRoleDepuis = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.role.depuis',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'depuis le ' + p.wv);
	});
var $author$project$I18n$Cles$referentielRoleAVenir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.a-venir', _List_Nil, 'À venir');
};
var $author$project$I18n$Cles$referentielRoleArchetypeEntreParentheses = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.role.archetype-entre-parentheses',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'archetype',
					$author$project$I18n$Traductions$Chaine(p.fA))
				]),
			'(' + (p.fA + ')'));
	});
var $author$project$I18n$Cles$referentielRoleFaireEvoluerLeRole = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.role.faire-evoluer-le-role',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Faire évoluer le rôle ' + p.bi);
	});
var $author$project$I18n$Cles$referentielRoleManuel = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.manuel', _List_Nil, 'Manuel');
};
var $author$project$I18n$Cles$referentielRolePeriodeClose = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.role.periode-close',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'debut',
					$author$project$I18n$Traductions$Chaine(p.ku)),
					_Utils_Tuple2(
					'fin',
					$author$project$I18n$Traductions$Chaine(p.mI))
				]),
			p.ku + (' → ' + p.mI));
	});
var $author$project$I18n$Cles$referentielRoleSansDateDeDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.sans-date-de-debut', _List_Nil, 'Sans date de début');
};
var $author$project$I18n$Cles$referentielRoleSeTermineLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.role.se-termine-le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Se termine le ' + p.wv);
	});
var $author$project$I18n$Cles$referentielRoleStatutClos = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.statut.clos', _List_Nil, 'Clos');
};
var $author$project$I18n$Cles$referentielRoleStatutClosAvecResultat = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.role.statut.clos-avec-resultat',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'resultat',
					$author$project$I18n$Traductions$Chaine(p.HW))
				]),
			'Clos — ' + p.HW);
	});
var $author$project$Components$Referentiel$Fiche$View$ligneDeRole = F3(
	function (i18n, etatDesRoles, fourni) {
		var depuis = _Utils_eq(
			fourni.ku,
			$author$project$I18n$Traductions$tel('')) ? $author$project$I18n$Cles$referentielRoleSansDateDeDebut(i18n) : A2(
			$author$project$I18n$Cles$referentielFicheRoleDepuis,
			i18n,
			{
				wv: A2($author$project$I18n$Cles$texte, i18n, fourni.ku)
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('clos', fourni.gt === 2),
							_Utils_Tuple2('a-venir', !fourni.gt)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$I18n$Cles$texte, i18n, fourni.Bl))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('archetype')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$referentielRoleArchetypeEntreParentheses,
										i18n,
										{
											fA: $elm$core$String$toLower(
												A2($author$project$I18n$Cles$texte, i18n, fourni.fA))
										}))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$texte,
								i18n,
								$author$project$Components$Referentiel$Fiche$Roles$nomDeLOffre(fourni)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('statut')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							function () {
								var _v0 = _Utils_Tuple2(fourni.gt, fourni.vq);
								if ((_v0.a === 2) && (!_v0.b.$)) {
									var _v1 = _v0.a;
									var close = _v0.b.a;
									var _v2 = close.HW;
									if (!_v2.$) {
										var code = _v2.a;
										return A2(
											$author$project$I18n$Cles$referentielRoleStatutClosAvecResultat,
											i18n,
											{
												HW: $elm$core$String$toLower(
													A4($author$project$Components$Referentiel$Fiche$Roles$nomDuResultat, i18n, fourni.r0, etatDesRoles, code))
											});
									} else {
										return $author$project$I18n$Cles$referentielRoleStatutClos(i18n);
									}
								} else {
									return A4($author$project$Components$Referentiel$Fiche$Roles$nomDuStatut, i18n, fourni.r0, etatDesRoles, fourni.ri);
								}
							}()),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('tag')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									(!fourni.gt) ? $author$project$I18n$Cles$referentielRoleAVenir(i18n) : '')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('periode')
						]),
					function () {
						var _v3 = _Utils_Tuple2(fourni.gt, fourni.vq);
						if (!_v3.b.$) {
							if (_v3.a === 2) {
								var _v4 = _v3.a;
								var close = _v3.b.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$referentielRolePeriodeClose,
											i18n,
											{
												ku: A2($author$project$I18n$Cles$texte, i18n, fourni.ku),
												mI: A2($author$project$I18n$Cles$texte, i18n, close.mI)
											})),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('fin-programmee')
											]),
										_List_Nil)
									]);
							} else {
								var programmee = _v3.b.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(depuis),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('fin-programmee')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$referentielRoleSeTermineLe,
													i18n,
													{
														wv: A2($author$project$I18n$Cles$texte, i18n, programmee.mI)
													}))
											]))
									]);
							}
						} else {
							var _v5 = _v3.b;
							return _List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(depuis),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('fin-programmee')
										]),
									_List_Nil)
								]);
						}
					}()),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$referentielRoleManuel(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					(!$elm$core$List$isEmpty(
						$author$project$Components$Referentiel$Fiche$Roles$choixOfferts(fourni))) ? _List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id(
									$author$project$Components$Referentiel$Fiche$View$idFaireEvoluer(fourni)),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									A2(
										$author$project$I18n$Cles$referentielRoleFaireEvoluerLeRole,
										i18n,
										{
											bi: A2($author$project$Components$Referentiel$Fiche$View$libelleDuRole, i18n, fourni)
										})),
									$rtfeldman$elm_css$Html$Styled$Attributes$title(
									A2(
										$author$project$I18n$Cles$referentielRoleFaireEvoluerLeRole,
										i18n,
										{
											bi: A2($author$project$Components$Referentiel$Fiche$View$libelleDuRole, i18n, fourni)
										})),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									A2(
										$author$project$Components$Referentiel$Fiche$Update$EvolutionDeRoleDemandee,
										fourni.r8,
										$author$project$Components$Referentiel$Fiche$View$idFaireEvoluer(fourni)))
								]),
							$author$project$I18n$Cles$referentielRoleFaireEvoluer(i18n))
						]) : _List_Nil)
				]));
	});
var $author$project$I18n$Cles$referentielRoleAucunActif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.aucun-actif', _List_Nil, 'Aucun rôle actif');
};
var $author$project$I18n$Cles$referentielRoleColonneActions = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.colonne.actions', _List_Nil, 'Actions');
};
var $author$project$I18n$Cles$referentielRoleColonneOffre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.colonne.offre', _List_Nil, 'Offre');
};
var $author$project$I18n$Cles$referentielRoleColonnePeriode = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.colonne.periode', _List_Nil, 'Période');
};
var $author$project$I18n$Cles$referentielRoleColonnePilotePar = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.colonne.pilote-par', _List_Nil, 'Piloté par');
};
var $author$project$I18n$Cles$referentielRoleColonneStatut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.colonne.statut', _List_Nil, 'Statut');
};
var $author$project$I18n$Cles$referentielRoleColonneType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.colonne.type', _List_Nil, 'Type (archétype)');
};
var $author$project$I18n$Cles$referentielRoleRegle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.regle', _List_Nil, 'Un seul rôle ouvert par type et par offre. Passer d\'un archétype à l\'autre ferme l\'ancien rôle et ouvre le nouveau, à la même date.');
};
var $author$project$I18n$Cles$referentielRoleTitreAvecNombre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.role.titre-avec-nombre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Rôles · ' + p.w);
	});
var $author$project$Components$Referentiel$Fiche$View$ongletRoles = F3(
	function (i18n, fiche, etatDesRoles) {
		var tous = _Utils_ap(fiche.eX, fiche.H7);
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_Nil,
			{
				fw: (!_Utils_eq(fiche.EC, $elm$core$Maybe$Nothing)) ? _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Fiche$View$idOuvrirUnRole),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Referentiel$Fiche$Update$OuvertureDeRoleDemandee($author$project$Components$Referentiel$Fiche$View$idOuvrirUnRole))
							]),
						$author$project$I18n$Cles$referentielRoleOuvrir(i18n))
					]) : _List_Nil,
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aucun-role')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$List$isEmpty(
									$author$project$Components$Referentiel$Fiche$View$effectifs(fiche)) ? $author$project$I18n$Cles$referentielRoleAucunActif(i18n) : '')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau'),
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'hidden',
										$elm$core$List$isEmpty(tous))
									]))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$table,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$tr,
												_List_Nil,
												A2(
													$elm$core$List$map,
													function (titre) {
														return A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(titre)
																]));
													},
													_List_fromArray(
														[
															$author$project$I18n$Cles$referentielRoleColonneType(i18n),
															$author$project$I18n$Cles$referentielRoleColonneOffre(i18n),
															$author$project$I18n$Cles$referentielRoleColonneStatut(i18n),
															$author$project$I18n$Cles$referentielRoleColonnePeriode(i18n),
															$author$project$I18n$Cles$referentielRoleColonnePilotePar(i18n),
															$author$project$I18n$Cles$referentielRoleColonneActions(i18n)
														])))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$tbody,
										_List_Nil,
										A2(
											$elm$core$List$map,
											A2($author$project$Components$Referentiel$Fiche$View$ligneDeRole, i18n, etatDesRoles),
											tous))
									]))
							])),
						A2(
						$author$project$Components$Shared$Note$View$view,
						0,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielRoleRegle(i18n))
									]))
							]))
					]),
				Dj: 'liste-des-roles',
				h6: A2(
					$author$project$I18n$Cles$referentielRoleTitreAvecNombre,
					i18n,
					{
						w: $elm$core$String$fromInt(
							$elm$core$List$length(tous))
					})
			});
	});
var $author$project$Components$Referentiel$Fiche$View$ongletsDe = function (fiche) {
	return (fiche.gt === 4) ? A2(
		$elm$core$List$filter,
		function (onglet) {
			return onglet !== 4;
		},
		$author$project$Routes$Route$ongletsDeFiche) : $author$project$Routes$Route$ongletsDeFiche;
};
var $author$project$I18n$Cles$referentielFicheHorsLimitesPastille = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.hors-limites.pastille',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeur hors limites') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeurs hors limites'));
	});
var $author$project$Components$Referentiel$Fiche$View$pastilleHorsLimites = F2(
	function (i18n, horsLimites) {
		return $elm$core$List$isEmpty(horsLimites) ? _List_Nil : _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Tag$View$view,
				2,
				A2(
					$author$project$I18n$Cles$referentielFicheHorsLimitesPastille,
					i18n,
					{
						w: $elm$core$List$length(horsLimites)
					}))
			]);
	});
var $author$project$I18n$Cles$apparenceCouleurAmbre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'apparence.couleur.ambre', _List_Nil, 'Ambre');
};
var $author$project$I18n$Cles$apparenceCouleurBrun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'apparence.couleur.brun', _List_Nil, 'Brun');
};
var $author$project$I18n$Cles$apparenceCouleurEncre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'apparence.couleur.encre', _List_Nil, 'Encre');
};
var $author$project$I18n$Cles$apparenceCouleurGris = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'apparence.couleur.gris', _List_Nil, 'Gris');
};
var $author$project$I18n$Cles$apparenceCouleurRouge = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'apparence.couleur.rouge', _List_Nil, 'Rouge');
};
var $author$project$I18n$Cles$apparenceCouleurVert = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'apparence.couleur.vert', _List_Nil, 'Vert');
};
var $author$project$I18n$Cles$apparenceCouleurViolet = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'apparence.couleur.violet', _List_Nil, 'Violet');
};
var $author$project$I18n$Cles$apparenceCouleurVioletPlein = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'apparence.couleur.violet-plein', _List_Nil, 'Violet soutenu');
};
var $author$project$Components$Shared$Apparence$couleurs = function (i18n) {
	return _List_fromArray(
		[
			{
			vx: 'violet',
			Bl: $author$project$I18n$Cles$apparenceCouleurViolet(i18n)
		},
			{
			vx: 'vert',
			Bl: $author$project$I18n$Cles$apparenceCouleurVert(i18n)
		},
			{
			vx: 'ambre',
			Bl: $author$project$I18n$Cles$apparenceCouleurAmbre(i18n)
		},
			{
			vx: 'rouge',
			Bl: $author$project$I18n$Cles$apparenceCouleurRouge(i18n)
		},
			{
			vx: 'gris',
			Bl: $author$project$I18n$Cles$apparenceCouleurGris(i18n)
		},
			{
			vx: 'brun',
			Bl: $author$project$I18n$Cles$apparenceCouleurBrun(i18n)
		},
			{
			vx: 'encre',
			Bl: $author$project$I18n$Cles$apparenceCouleurEncre(i18n)
		},
			{
			vx: 'violet-plein',
			Bl: $author$project$I18n$Cles$apparenceCouleurVioletPlein(i18n)
		}
		]);
};
var $author$project$Components$Shared$Apparence$classeDeCouleur = F2(
	function (i18n, code) {
		return 'couleur-' + A2(
			$elm$core$Maybe$withDefault,
			'gris',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.vx;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (couleur) {
							return _Utils_eq(
								$elm$core$Maybe$Just(couleur.vx),
								code);
						},
						$author$project$Components$Shared$Apparence$couleurs(i18n)))));
	});
var $author$project$I18n$Cles$apparenceIconeBulle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'apparence.icone.bulle', _List_Nil, 'Bulle');
};
var $author$project$I18n$Cles$apparenceIconeColis = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'apparence.icone.colis', _List_Nil, 'Colis');
};
var $author$project$I18n$Cles$apparenceIconeCrayon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'apparence.icone.crayon', _List_Nil, 'Crayon');
};
var $author$project$I18n$Cles$apparenceIconeDossier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'apparence.icone.dossier', _List_Nil, 'Dossier');
};
var $author$project$I18n$Cles$apparenceIconeEtincelles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'apparence.icone.etincelles', _List_Nil, 'Étincelles');
};
var $author$project$I18n$Cles$apparenceIconeGlobe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'apparence.icone.globe', _List_Nil, 'Globe');
};
var $author$project$I18n$Cles$apparenceIconeGrille = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'apparence.icone.grille', _List_Nil, 'Grille');
};
var $author$project$I18n$Cles$apparenceIconeGroupe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'apparence.icone.groupe', _List_Nil, 'Groupe');
};
var $author$project$I18n$Cles$apparenceIconeLoupe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'apparence.icone.loupe', _List_Nil, 'Loupe');
};
var $author$project$I18n$Cles$apparenceIconePersonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'apparence.icone.personne', _List_Nil, 'Personne');
};
var $author$project$I18n$Cles$apparenceIconeReglages = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'apparence.icone.reglages', _List_Nil, 'Réglages');
};
var $author$project$I18n$Cles$apparenceIconeRobot = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'apparence.icone.robot', _List_Nil, 'Robot');
};
var $author$project$Components$Shared$Svg$svgAgents = A3(
	$author$project$Components$Shared$Svg$icone,
	'agents',
	'M8 8h8a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3v-5a3 3 0 0 1 3-3zM12 4.5V8M9.5 13v.5M14.5 13v.5M10 16.2h4',
	_List_fromArray(
		[
			A3($author$project$Components$Shared$Svg$cercle, 12, 4, 1)
		]));
var $author$project$Components$Shared$Svg$svgCommunication = A3($author$project$Components$Shared$Svg$icone, 'communication', 'M4 5.5h16v10H9l-5 4z', _List_Nil);
var $author$project$Components$Shared$Svg$svgDashboard = A3($author$project$Components$Shared$Svg$icone, 'dashboard', 'M5 3.5h4a1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 0 1-1.5 1.5h-4a1.5 1.5 0 0 1-1.5-1.5v-4a1.5 1.5 0 0 1 1.5-1.5zM15 3.5h4a1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 0 1-1.5 1.5h-4a1.5 1.5 0 0 1-1.5-1.5v-4a1.5 1.5 0 0 1 1.5-1.5zM5 13.5h4a1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 0 1-1.5 1.5h-4a1.5 1.5 0 0 1-1.5-1.5v-4a1.5 1.5 0 0 1 1.5-1.5zM15 13.5h4a1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 0 1-1.5 1.5h-4a1.5 1.5 0 0 1-1.5-1.5v-4a1.5 1.5 0 0 1 1.5-1.5z', _List_Nil);
var $author$project$Components$Shared$Svg$svgPortals = A3(
	$author$project$Components$Shared$Svg$icone,
	'portals',
	'M3.5 12h17M12 3.5c2.4 2.4 3.4 5.2 3.4 8.5s-1 6.1-3.4 8.5c-2.4-2.4-3.4-5.2-3.4-8.5s1-6.1 3.4-8.5z',
	_List_fromArray(
		[
			A3($author$project$Components$Shared$Svg$cercle, 12, 12, 8.5)
		]));
var $author$project$Components$Shared$Svg$svgSettings = A3(
	$author$project$Components$Shared$Svg$icone,
	'settings',
	'M4 6h7M15 6h5M4 12h3M11 12h9M4 18h9M17 18h3',
	_List_fromArray(
		[
			A3($author$project$Components$Shared$Svg$cercle, 13, 6, 2),
			A3($author$project$Components$Shared$Svg$cercle, 9, 12, 2),
			A3($author$project$Components$Shared$Svg$cercle, 15, 18, 2)
		]));
var $author$project$Components$Shared$Svg$svgSparkles = A3($author$project$Components$Shared$Svg$icone, 'sparkles', 'M10 3l1.6 4.4L16 9l-4.4 1.6L10 15l-1.6-4.4L4 9l4.4-1.6zM18 14l.8 2.2L21 17l-2.2.8L18 20l-.8-2.2L15 17l2.2-.8z', _List_Nil);
var $author$project$Components$Shared$Svg$svgUser = A3(
	$author$project$Components$Shared$Svg$icone,
	'user',
	'M5.5 19.5c1.2-3 3.6-4.5 6.5-4.5s5.3 1.5 6.5 4.5',
	_List_fromArray(
		[
			A3($author$project$Components$Shared$Svg$cercle, 12, 9, 3.6),
			A3($author$project$Components$Shared$Svg$cercle, 12, 12, 9.5)
		]));
var $author$project$Components$Shared$Svg$svgUsers = A3(
	$author$project$Components$Shared$Svg$icone,
	'users',
	'M3 19c.6-3.3 3-5 6-5s5.4 1.7 6 5M16 14.2c2.6.2 4.4 1.8 5 4.3',
	_List_fromArray(
		[
			A3($author$project$Components$Shared$Svg$cercle, 9, 8, 3.2),
			A3($author$project$Components$Shared$Svg$cercle, 17, 9, 2.4)
		]));
var $author$project$Components$Shared$Apparence$icones = function (i18n) {
	return _List_fromArray(
		[
			{
			vx: 'groupe',
			z: $author$project$Components$Shared$Svg$svgUsers,
			Bl: $author$project$I18n$Cles$apparenceIconeGroupe(i18n)
		},
			{
			vx: 'personne',
			z: $author$project$Components$Shared$Svg$svgUser,
			Bl: $author$project$I18n$Cles$apparenceIconePersonne(i18n)
		},
			{
			vx: 'dossier',
			z: $author$project$Components$Shared$Svg$svgFolders,
			Bl: $author$project$I18n$Cles$apparenceIconeDossier(i18n)
		},
			{
			vx: 'colis',
			z: $author$project$Components$Shared$Svg$svgProducts,
			Bl: $author$project$I18n$Cles$apparenceIconeColis(i18n)
		},
			{
			vx: 'globe',
			z: $author$project$Components$Shared$Svg$svgPortals,
			Bl: $author$project$I18n$Cles$apparenceIconeGlobe(i18n)
		},
			{
			vx: 'bulle',
			z: $author$project$Components$Shared$Svg$svgCommunication,
			Bl: $author$project$I18n$Cles$apparenceIconeBulle(i18n)
		},
			{
			vx: 'robot',
			z: $author$project$Components$Shared$Svg$svgAgents,
			Bl: $author$project$I18n$Cles$apparenceIconeRobot(i18n)
		},
			{
			vx: 'etincelles',
			z: $author$project$Components$Shared$Svg$svgSparkles,
			Bl: $author$project$I18n$Cles$apparenceIconeEtincelles(i18n)
		},
			{
			vx: 'grille',
			z: $author$project$Components$Shared$Svg$svgDashboard,
			Bl: $author$project$I18n$Cles$apparenceIconeGrille(i18n)
		},
			{
			vx: 'crayon',
			z: $author$project$Components$Shared$Svg$svgEdit,
			Bl: $author$project$I18n$Cles$apparenceIconeCrayon(i18n)
		},
			{
			vx: 'loupe',
			z: $author$project$Components$Shared$Svg$svgSearch,
			Bl: $author$project$I18n$Cles$apparenceIconeLoupe(i18n)
		},
			{
			vx: 'reglages',
			z: $author$project$Components$Shared$Svg$svgSettings,
			Bl: $author$project$I18n$Cles$apparenceIconeReglages(i18n)
		}
		]);
};
var $author$project$Components$Shared$Apparence$dessin = F2(
	function (i18n, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$Shared$Svg$svgUsers,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.z;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (icone) {
							return _Utils_eq(
								$elm$core$Maybe$Just(icone.vx),
								code);
						},
						$author$project$Components$Shared$Apparence$icones(i18n)))));
	});
var $author$project$Components$Shared$Apparence$etiquette = F4(
	function (i18n, attributs, type_, libelle) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$a,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$class('etiquette-de-type'),
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
						A2($author$project$Components$Shared$Apparence$classeDeCouleur, i18n, type_.kf)),
					attributs)),
			_List_fromArray(
				[
					A2($author$project$Components$Shared$Apparence$dessin, i18n, type_.aC),
					$rtfeldman$elm_css$Html$Styled$text(libelle)
				]));
	});
var $author$project$Components$Referentiel$Fiche$View$pastille = F3(
	function (i18n, fiche, fourni) {
		return A4(
			$author$project$Components$Shared$Apparence$etiquette,
			i18n,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class(fourni.jT),
					$rtfeldman$elm_css$Html$Styled$Attributes$href(
					$author$project$Routes$Route$toString(
						A2($author$project$Routes$Route$Fiche, fiche.r8, 1)))
				]),
			{kf: fourni.kf, aC: fourni.aC},
			A2($author$project$I18n$Cles$texte, i18n, fourni.Bl));
	});
var $author$project$I18n$Cles$referentielFicheEtatActive = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.etat.active', _List_Nil, 'Active');
};
var $author$project$I18n$Cles$referentielFicheEtatFusionnee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.etat.fusionnee', _List_Nil, 'Fusionnée');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesMarqueClose = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.marque-close', _List_Nil, 'close');
};
var $author$project$I18n$Cles$referentielFicheDoublonPastille = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.doublon.pastille', _List_Nil, 'Doublon possible');
};
var $author$project$Components$Referentiel$Fiche$View$signalDeDoublon = function (i18n) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('tag'),
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ambre'),
				$rtfeldman$elm_css$Html$Styled$Attributes$class('doublon-possible')
			]),
		_List_fromArray(
			[
				$author$project$Components$Shared$Svg$svgWarning,
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$I18n$Cles$referentielFicheDoublonPastille(i18n))
			]));
};
var $author$project$Components$Referentiel$Fiche$View$pastillesDeLEntete = F2(
	function (i18n, fiche) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				A2($author$project$Components$Referentiel$Fiche$View$pastille, i18n, fiche),
				$author$project$Components$Referentiel$Fiche$View$effectifs(fiche)),
			_Utils_ap(
				function () {
					var _v0 = _Utils_Tuple2(
						fiche.g1,
						A2($author$project$Components$Referentiel$Fiche$Model$valeurDe, 4, fiche));
					if ((!_v0.a) && (!_v0.b.$)) {
						var _v1 = _v0.a;
						var qualite = _v0.b.a;
						return _List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Tag$View$view,
								3,
								A4($author$project$Components$Referentiel$Fiche$View$affichee, i18n, $author$project$Referentiel$Normes$vide, 4, qualite))
							]);
					} else {
						return _List_Nil;
					}
				}(),
				_Utils_ap(
					function () {
						var _v2 = fiche.gt;
						switch (_v2) {
							case 0:
								return _List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Tag$View$view,
										0,
										$author$project$I18n$Cles$referentielFicheEtatActive(i18n))
									]);
							case 1:
								return _List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Tag$View$view,
										3,
										$author$project$I18n$Cles$referentielPartiesPrenantesMarqueClose(i18n))
									]);
							case 5:
								return _List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Tag$View$view,
										3,
										$author$project$I18n$Cles$referentielFicheEtatFusionnee(i18n))
									]);
							default:
								return _List_Nil;
						}
					}(),
					A2(
						$elm$core$List$any,
						function (doublon) {
							return A2(
								$elm$core$List$any,
								$elm$core$Basics$neq('MemeIdentifiantLegal'),
								doublon.CY);
						},
						fiche.kW) ? _List_fromArray(
						[
							$author$project$Components$Referentiel$Fiche$View$signalDeDoublon(i18n)
						]) : _List_Nil)));
	});
var $author$project$Components$Referentiel$Fiche$Update$RattachementDemande = {$: 71};
var $author$project$Components$Referentiel$Fiche$Update$TerminesAffiches = function (a) {
	return {$: 52, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$SupprimeesBasculees = {$: 99};
var $author$project$I18n$Cles$referentielFicheDecompteAfficherLesSupprimees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.decompte.afficher-les-supprimees', _List_Nil, 'Afficher les fiches supprimées');
};
var $author$project$I18n$Cles$referentielFicheDecompteClosesPluriel = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.decompte.closes-pluriel',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			p.d + ' closes');
	});
var $author$project$I18n$Cles$referentielFicheDecompteClosesSingulier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.decompte.closes-singulier', _List_Nil, '1 close');
};
var $author$project$I18n$Cles$referentielFicheDecompteDont = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.decompte.dont',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE)),
					_Utils_Tuple2(
					'liste',
					$author$project$I18n$Traductions$Chaine(p.nW))
				]),
			p.JE + (', dont ' + p.nW));
	});
var $author$project$I18n$Cles$referentielFicheDecompteEffaceesPluriel = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.decompte.effacees-pluriel',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			p.d + ' effacées');
	});
var $author$project$I18n$Cles$referentielFicheDecompteEffaceesSingulier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.decompte.effacees-singulier', _List_Nil, '1 effacée');
};
var $author$project$I18n$Cles$referentielFicheDecompteMasquerLesSupprimees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.decompte.masquer-les-supprimees', _List_Nil, 'Masquer les fiches supprimées');
};
var $author$project$I18n$Cles$referentielFicheDecompteSupprimeesPluriel = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.decompte.supprimees-pluriel',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			p.d + ' supprimées');
	});
var $author$project$I18n$Cles$referentielFicheDecompteSupprimeesSingulier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.decompte.supprimees-singulier', _List_Nil, '1 supprimée');
};
var $author$project$I18n$Cles$referentielFicheDecompteTotalPluriel = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.decompte.total-pluriel',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			p.d + ' personnes rattachées');
	});
var $author$project$I18n$Cles$referentielFicheDecompteTotalSingulier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.decompte.total-singulier', _List_Nil, '1 personne rattachée');
};
var $author$project$Components$Referentiel$Fiche$View$decompteDesRattachees = F3(
	function (i18n, fiche, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('decompte')
				]),
			function () {
				var _v0 = fiche.wT;
				if (_v0.$ === 1) {
					return _List_Nil;
				} else {
					var decompte = _v0.a;
					var accorde = F3(
						function (singulier, pluriel, n) {
							return (n === 1) ? singulier : pluriel(
								{
									d: $elm$core$String$fromInt(n)
								});
						});
					var closes = A2(
						accorde,
						$author$project$I18n$Cles$referentielFicheDecompteClosesSingulier(i18n),
						$author$project$I18n$Cles$referentielFicheDecompteClosesPluriel(i18n));
					var effacees = A2(
						accorde,
						$author$project$I18n$Cles$referentielFicheDecompteEffaceesSingulier(i18n),
						$author$project$I18n$Cles$referentielFicheDecompteEffaceesPluriel(i18n));
					var supprimees = A2(
						accorde,
						$author$project$I18n$Cles$referentielFicheDecompteSupprimeesSingulier(i18n),
						$author$project$I18n$Cles$referentielFicheDecompteSupprimeesPluriel(i18n));
					var parties = A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								(decompte.xF > 0) ? $elm$core$Maybe$Just(
								closes(decompte.xF)) : $elm$core$Maybe$Nothing,
								(decompte.xH > 0) ? $elm$core$Maybe$Just(
								supprimees(decompte.xH)) : $elm$core$Maybe$Nothing,
								(decompte.xG > 0) ? $elm$core$Maybe$Just(
								effacees(decompte.xG)) : $elm$core$Maybe$Nothing
							]));
					var total = A3(
						accorde,
						$author$project$I18n$Cles$referentielFicheDecompteTotalSingulier(i18n),
						$author$project$I18n$Cles$referentielFicheDecompteTotalPluriel(i18n),
						decompte.Fi);
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('total')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$elm$core$List$isEmpty(parties) ? total : A2(
										$author$project$I18n$Cles$referentielFicheDecompteDont,
										i18n,
										{
											nW: A2($elm$core$String$join, ', ', parties),
											JE: total
										}))
								])),
							A2(
							$elm$core$Maybe$withDefault,
							$rtfeldman$elm_css$Html$Styled$text(''),
							A2(
								$elm$core$Maybe$map,
								function (_v1) {
									return A3(
										$author$project$Components$Shared$Bouton$View$bouton,
										1,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Fiche$Update$SupprimeesBasculees),
												A2(
												$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
												'aria-pressed',
												model.rt ? 'true' : 'false')
											]),
										model.rt ? $author$project$I18n$Cles$referentielFicheDecompteMasquerLesSupprimees(i18n) : $author$project$I18n$Cles$referentielFicheDecompteAfficherLesSupprimees(i18n));
								},
								fiche.s2))
						]);
				}
			}());
	});
var $author$project$Components$Referentiel$Fiche$View$idDesTermines = 'rattachements-termines';
var $author$project$I18n$Cles$referentielRattachementDepuis = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.rattachement.depuis',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'depuis le ' + p.wv);
	});
var $author$project$I18n$Cles$referentielRattachementIntitule = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.rattachement.intitule',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'intitule',
					$author$project$I18n$Traductions$Chaine(p.AS))
				]),
			'« ' + (p.AS + ' »'));
	});
var $author$project$I18n$Cles$referentielRattachementSeparateur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.separateur', _List_Nil, ' · ');
};
var $author$project$Components$Referentiel$Fiche$Rattachements$description = F2(
	function (i18n, rattachement) {
		return A2(
			$elm$core$String$join,
			$author$project$I18n$Cles$referentielRattachementSeparateur(i18n),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						$author$project$I18n$Cles$texte(i18n),
						rattachement.F4),
						A2(
						$elm$core$Maybe$map,
						function (intitule) {
							return A2(
								$author$project$I18n$Cles$referentielRattachementIntitule,
								i18n,
								{AS: intitule});
						},
						rattachement.AS),
						rattachement.xb,
						$elm$core$Maybe$Just(
						A2(
							$author$project$I18n$Cles$referentielRattachementDepuis,
							i18n,
							{
								wv: A2($author$project$I18n$Cles$texte, i18n, rattachement.ku)
							}))
					])));
	});
var $author$project$I18n$Cles$referentielRattachementAVenir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.a-venir', _List_Nil, 'À venir');
};
var $author$project$I18n$Cles$referentielRattachementSeTermineLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.rattachement.se-termine-le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Se termine le ' + p.wv);
	});
var $author$project$I18n$Cles$referentielRattachementTermineLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.rattachement.termine-le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Terminé le ' + p.wv);
	});
var $author$project$Components$Referentiel$Fiche$Rattachements$echeance = F2(
	function (i18n, rattachement) {
		var _v0 = _Utils_Tuple2(rattachement.gt, rattachement.mI);
		switch (_v0.a) {
			case 0:
				var _v1 = _v0.a;
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$referentielRattachementAVenir(i18n));
			case 1:
				if (!_v0.b.$) {
					var _v2 = _v0.a;
					var fin = _v0.b.a;
					return $elm$core$Maybe$Just(
						A2(
							$author$project$I18n$Cles$referentielRattachementSeTermineLe,
							i18n,
							{
								wv: A2($author$project$I18n$Cles$texte, i18n, fin)
							}));
				} else {
					var _v3 = _v0.a;
					var _v4 = _v0.b;
					return $elm$core$Maybe$Nothing;
				}
			default:
				if (!_v0.b.$) {
					var _v5 = _v0.a;
					var fin = _v0.b.a;
					return $elm$core$Maybe$Just(
						A2(
							$author$project$I18n$Cles$referentielRattachementTermineLe,
							i18n,
							{
								wv: A2($author$project$I18n$Cles$texte, i18n, fin)
							}));
				} else {
					var _v6 = _v0.a;
					var _v7 = _v0.b;
					return $elm$core$Maybe$Nothing;
				}
		}
	});
var $author$project$Components$Referentiel$Fiche$Update$FinDemandee = function (a) {
	return {$: 53, a: a};
};
var $author$project$Components$Referentiel$Fiche$Update$ModificationDemandee = function (a) {
	return {$: 65, a: a};
};
var $author$project$Components$Referentiel$Fiche$View$gestes = F2(
	function (i18n, lien) {
		var fin = function (libelle) {
			return A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						$author$project$Components$Referentiel$Fiche$Liaisons$idDuDeclencheurDeFin(lien.r8)),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Referentiel$Fiche$Update$FinDemandee(lien.r8))
					]),
				libelle);
		};
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					function (_v0) {
						return A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id(
									$author$project$Components$Referentiel$Fiche$Liaisons$idDuDeclencheurDeModification(lien.r8)),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Referentiel$Fiche$Update$ModificationDemandee(lien.r8))
								]),
							$author$project$I18n$Cles$referentielRattachementModifier(i18n));
					},
					lien.u5),
					A2(
					$elm$core$Maybe$map,
					function (_v1) {
						return fin(
							$author$project$I18n$Cles$referentielRattachementTerminer(i18n));
					},
					lien.Jw),
					A2(
					$elm$core$Maybe$map,
					function (_v2) {
						return fin(
							$author$project$I18n$Cles$referentielRattachementModifierLaFin(i18n));
					},
					lien.od)
				]));
	});
var $author$project$I18n$Cles$referentielRattachementMarqueClose = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.marque-close', _List_Nil, 'close');
};
var $author$project$I18n$Cles$referentielRattachementMarqueEffacee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.marque-effacee', _List_Nil, 'effacée');
};
var $author$project$I18n$Cles$referentielRattachementMarqueSupprimee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.marque-supprimee', _List_Nil, 'supprimée');
};
var $author$project$Components$Referentiel$Fiche$View$marqueDeLEtat = F2(
	function (i18n, etat) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('etat-de-la-fiche')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					function () {
						switch (etat) {
							case 1:
								return $author$project$I18n$Cles$referentielRattachementMarqueClose(i18n);
							case 2:
								return $author$project$I18n$Cles$referentielRattachementMarqueSupprimee(i18n);
							case 4:
								return $author$project$I18n$Cles$referentielRattachementMarqueEffacee(i18n);
							default:
								return '';
						}
					}())
				]));
	});
var $author$project$I18n$Cles$referentielRattachementContactPrincipal = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.contact-principal', _List_Nil, 'Contact principal');
};
var $author$project$Components$Referentiel$Fiche$View$rattachement = F2(
	function (i18n, lien) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('cartouche-rattachement'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('a-venir', !lien.gt),
							_Utils_Tuple2('termine', lien.gt === 2),
							_Utils_Tuple2('principal', lien.px)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('content')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('main')
								]),
							_List_fromArray(
								[
									(lien.yP === 4) ? A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('title')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$I18n$Cles$texte, i18n, lien.Dj))
										])) : A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('title'),
											$rtfeldman$elm_css$Html$Styled$Attributes$href(
											$author$project$Routes$Route$toString(
												A2($author$project$Routes$Route$Fiche, lien.zo, 0)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$I18n$Cles$texte, i18n, lien.Dj))
										])),
									A2($author$project$Components$Referentiel$Fiche$View$marqueDeLEtat, i18n, lien.yP),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$Components$Referentiel$Fiche$Rattachements$description, i18n, lien))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$ul,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('infos')
										]),
									A2(
										$elm$core$List$map,
										function (porte) {
											return A2(
												$rtfeldman$elm_css$Html$Styled$li,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$strong,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(porte.fm)
															]))
													]));
										},
										lien.wa))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aside')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('tag'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('contact-principal')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											lien.px ? $author$project$I18n$Cles$referentielRattachementContactPrincipal(i18n) : '')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('tag'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('echeance')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2($author$project$Components$Referentiel$Fiche$Rattachements$echeance, i18n, lien)))
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					A2($author$project$Components$Referentiel$Fiche$View$gestes, i18n, lien))
				]));
	});
var $author$project$I18n$Cles$referentielRattachementAfficherLesTermines = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.afficher-les-termines', _List_Nil, 'Afficher aussi les rattachements terminés');
};
var $author$project$I18n$Cles$referentielRattachementAucuneOrganisation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.aucune-organisation', _List_Nil, 'Aucune organisation');
};
var $author$project$I18n$Cles$referentielRattachementAucunePersonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.aucune-personne', _List_Nil, 'Aucune personne rattachée');
};
var $author$project$I18n$Cles$referentielRattachementOrganisations = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.rattachement.organisations',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Organisations · ' + p.w);
	});
var $author$project$I18n$Cles$referentielRattachementPersonnesRattachees = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.rattachement.personnes-rattachees',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Personnes rattachées · ' + p.w);
	});
var $author$project$I18n$Cles$referentielRattachementRattacherAUneOrganisation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.rattacher.a-une-organisation', _List_Nil, 'Rattacher à une organisation');
};
var $author$project$I18n$Cles$referentielRattachementRattacherUnePersonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.rattachement.rattacher.une-personne', _List_Nil, 'Rattacher une personne');
};
var $author$project$Components$Referentiel$Fiche$View$rattachements = F3(
	function (i18n, fiche, model) {
		var montres = A2(
			$elm$core$List$filter,
			function (lien) {
				return model.rt || (lien.yP !== 2);
			},
			A2($author$project$Components$Referentiel$Fiche$Rattachements$visibles, model.ji, fiche.GY));
		var enCours = A2($author$project$Components$Referentiel$Fiche$Rattachements$visibles, false, fiche.GY);
		var nombre = {
			w: $elm$core$String$fromInt(
				$elm$core$List$length(enCours))
		};
		var _v0 = function () {
			var _v1 = fiche.g1;
			if (_v1 === 1) {
				return _Utils_Tuple3(
					A2($author$project$I18n$Cles$referentielRattachementPersonnesRattachees, i18n, nombre),
					$author$project$I18n$Cles$referentielRattachementAucunePersonne(i18n),
					$author$project$I18n$Cles$referentielRattachementRattacherUnePersonne(i18n));
			} else {
				return _Utils_Tuple3(
					A2($author$project$I18n$Cles$referentielRattachementOrganisations, i18n, nombre),
					$author$project$I18n$Cles$referentielRattachementAucuneOrganisation(i18n),
					$author$project$I18n$Cles$referentielRattachementRattacherAUneOrganisation(i18n));
			}
		}();
		var titre = _v0.a;
		var aucun = _v0.b;
		var rattacher = _v0.c;
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_Nil,
			{
				fw: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (_v2) {
							return _List_fromArray(
								[
									A4(
									$author$project$Components$Shared$Bouton$View$boutonAvecIcone,
									2,
									$author$project$Components$Shared$Svg$svgAdd,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Fiche$Liaisons$idDuDeclencheurDeRattachement),
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Fiche$Update$RattachementDemande)
										]),
									rattacher)
								]);
						},
						fiche.GZ)),
				fZ: _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Champ$View$caseACocher,
						{
							go: $elm$core$Maybe$Nothing,
							Aq: $author$project$Components$Referentiel$Fiche$View$idDesTermines,
							Bl: $author$project$I18n$Cles$referentielRattachementAfficherLesTermines(i18n),
							he: false
						},
						{vt: model.ji, D9: $author$project$Components$Referentiel$Fiche$Update$TerminesAffiches}),
						A3($author$project$Components$Referentiel$Fiche$View$decompteDesRattachees, i18n, fiche, model),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('list')
							]),
						A2(
							$elm$core$List$map,
							function (lien) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('item')
										]),
									_List_fromArray(
										[
											A2($author$project$Components$Referentiel$Fiche$View$rattachement, i18n, lien)
										]));
							},
							montres)),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$List$isEmpty(montres) ? aucun : '')
							]))
					]),
				Dj: 'rattachements',
				h6: titre
			});
	});
var $author$project$Components$Referentiel$Fiche$Resume$Rattachements = 1;
var $author$project$Components$Shared$Apparence$etiquetteSansIcone = F3(
	function (i18n, type_, libelle) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('etiquette-de-type'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					A2($author$project$Components$Shared$Apparence$classeDeCouleur, i18n, type_.kf))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(libelle)
				]));
	});
var $author$project$Components$Referentiel$Fiche$View$typeDeLOrganisation = F2(
	function (i18n, type_) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Apparence$etiquetteSansIcone,
					i18n,
					{kf: type_.kf, aC: type_.aC},
					type_.Bl)
				]));
	});
var $author$project$Components$Referentiel$Fiche$View$autreDuRattachement = F3(
	function (i18n, nature, lien) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$td,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('autre')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('contenu')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('avatar'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									(!nature) ? $author$project$Texte$Initiales$initialesDOrganisation(
										A2($author$project$I18n$Cles$texte, i18n, lien.Dj)) : $author$project$Texte$Initiales$initiales(
										A2($author$project$I18n$Cles$texte, i18n, lien.Dj)))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('identite')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
										]),
									_List_fromArray(
										[
											(lien.yP === 4) ? $rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$I18n$Cles$texte, i18n, lien.Dj)) : A2(
											$rtfeldman$elm_css$Html$Styled$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$href(
													$author$project$Routes$Route$toString(
														A2($author$project$Routes$Route$Fiche, lien.zo, 0)))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2($author$project$I18n$Cles$texte, i18n, lien.Dj))
												])),
											A2($author$project$Components$Referentiel$Fiche$View$marqueDeLEtat, i18n, lien.yP),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('tag'),
													$rtfeldman$elm_css$Html$Styled$Attributes$class('contact-principal')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													lien.px ? $author$project$I18n$Cles$referentielRattachementContactPrincipal(i18n) : '')
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('tag'),
													$rtfeldman$elm_css$Html$Styled$Attributes$class('echeance')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$elm$core$Maybe$withDefault,
														'',
														A2($author$project$Components$Referentiel$Fiche$Rattachements$echeance, i18n, lien)))
												]))
										])),
									(lien.xL && (nature === 1)) ? $author$project$Components$Referentiel$Fiche$View$signalDeDoublon(i18n) : $rtfeldman$elm_css$Html$Styled$text(''),
									A2(
									$rtfeldman$elm_css$Html$Styled$ul,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('types')
										]),
									A2(
										$elm$core$List$map,
										$author$project$Components$Referentiel$Fiche$View$typeDeLOrganisation(i18n),
										lien.ib)),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											(nature === 1) ? A2($elm$core$Maybe$withDefault, '', lien.AS) : '')
										]))
								]))
						]))
				]));
	});
var $author$project$I18n$Cles$referentielFicheResumeAucunTelephone = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.aucun-telephone', _List_Nil, '—');
};
var $author$project$Components$Referentiel$Fiche$View$ligneDeRattachement = F3(
	function (i18n, nature, lien) {
		var coordonneeDuCanal = F2(
			function (canal, icone) {
				return A2(
					$elm$core$Maybe$withDefault,
					$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$referentielFicheResumeAucunTelephone(i18n)),
					A2(
						$elm$core$Maybe$map,
						function (porte) {
							return (!canal) ? A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href('mailto:' + porte.fm)
									]),
								_List_fromArray(
									[
										icone,
										$rtfeldman$elm_css$Html$Styled$text(porte.fm)
									])) : A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										icone,
										$rtfeldman$elm_css$Html$Styled$text(porte.fm)
									]));
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (porte) {
									return _Utils_eq(porte.uF, canal);
								},
								lien.wa))));
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('rattachement'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('a-venir', !lien.gt),
							_Utils_Tuple2('termine', lien.gt === 2),
							_Utils_Tuple2('principal', lien.px)
						]))
				]),
			A2(
				$elm$core$List$cons,
				A3($author$project$Components$Referentiel$Fiche$View$autreDuRattachement, i18n, nature, lien),
				function () {
					if (nature === 1) {
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$td,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('poste')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$I18n$Cles$texte(i18n),
												lien.F4)))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$td,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('email')
									]),
								_List_fromArray(
									[
										A2(coordonneeDuCanal, 0, $author$project$Components$Shared$Svg$svgMail)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$td,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('telephone')
									]),
								_List_fromArray(
									[
										A2(coordonneeDuCanal, 1, $author$project$Components$Shared$Svg$svgPhone)
									]))
							]);
					} else {
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$td,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('poste')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$I18n$Cles$texte(i18n),
												lien.F4)))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$td,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($elm$core$Maybe$withDefault, '', lien.AS))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$td,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('depuis')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$I18n$Cles$texte, i18n, lien.ku))
									]))
							]);
					}
				}()));
	});
var $author$project$I18n$Cles$referentielFicheResumeColonneDepuis = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.colonne-depuis', _List_Nil, 'Depuis');
};
var $author$project$I18n$Cles$referentielFicheResumeColonneEmail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.colonne-email', _List_Nil, 'Email');
};
var $author$project$I18n$Cles$referentielFicheResumeColonneIntitule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.colonne-intitule', _List_Nil, 'Intitulé');
};
var $author$project$I18n$Cles$referentielFicheResumeColonneOrganisation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.colonne-organisation', _List_Nil, 'Organisation');
};
var $author$project$I18n$Cles$referentielFicheResumeColonnePersonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.colonne-personne', _List_Nil, 'Personne');
};
var $author$project$I18n$Cles$referentielFicheResumeColonnePoste = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.colonne-poste', _List_Nil, 'Poste');
};
var $author$project$I18n$Cles$referentielFicheResumeColonneTelephone = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.colonne-telephone', _List_Nil, 'Téléphone');
};
var $author$project$Components$Referentiel$Fiche$View$rattachementsEnTableau = F3(
	function (i18n, nature, lignes) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$table,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$tr,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (titre) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(titre)
											]));
								},
								function () {
									if (nature === 1) {
										return _List_fromArray(
											[
												$author$project$I18n$Cles$referentielFicheResumeColonnePersonne(i18n),
												$author$project$I18n$Cles$referentielFicheResumeColonnePoste(i18n),
												$author$project$I18n$Cles$referentielFicheResumeColonneEmail(i18n),
												$author$project$I18n$Cles$referentielFicheResumeColonneTelephone(i18n)
											]);
									} else {
										return _List_fromArray(
											[
												$author$project$I18n$Cles$referentielFicheResumeColonneOrganisation(i18n),
												$author$project$I18n$Cles$referentielFicheResumeColonnePoste(i18n),
												$author$project$I18n$Cles$referentielFicheResumeColonneIntitule(i18n),
												$author$project$I18n$Cles$referentielFicheResumeColonneDepuis(i18n)
											]);
									}
								}()))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						A2($author$project$Components$Referentiel$Fiche$View$ligneDeRattachement, i18n, nature),
						lignes))
				]));
	});
var $author$project$I18n$Cles$referentielFicheResumeAncienRattachement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.ancien-rattachement', _List_Nil, '1 ancien rattachement');
};
var $author$project$I18n$Cles$referentielFicheResumeAnciensRattachements = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fiche.resume.anciens-rattachements',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'n',
					$author$project$I18n$Traductions$Chaine(p.d))
				]),
			p.d + ' anciens rattachements');
	});
var $author$project$I18n$Cles$referentielFicheResumeMasquerLesAnciensRattachements = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.masquer-les-anciens-rattachements', _List_Nil, 'Masquer les anciens rattachements');
};
var $author$project$I18n$Cles$referentielFicheResumePersonnesRattachees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.personnes-rattachees', _List_Nil, 'Personnes rattachées');
};
var $author$project$I18n$Cles$referentielFicheResumeRattacheA = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.rattache-a', _List_Nil, 'Rattaché à');
};
var $author$project$I18n$Cles$referentielFicheResumeRattacheANeutre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.rattache-a-neutre', _List_Nil, 'Rattaché(e) à');
};
var $author$project$I18n$Cles$referentielFicheResumeRattacheeA = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.rattachee-a', _List_Nil, 'Rattachée à');
};
var $author$project$Components$Referentiel$Fiche$View$rattachementsDuResume = F3(
	function (i18n, fiche, model) {
		var garde = function (lien) {
			return model.rt || (lien.yP !== 2);
		};
		var tous = A2(
			$elm$core$List$filter,
			garde,
			A2($author$project$Components$Referentiel$Fiche$Rattachements$visibles, true, fiche.GY));
		var depliee = A2($author$project$Components$Referentiel$Fiche$Resume$estDepliee, 1, model.kH);
		var actifs = A2(
			$elm$core$List$filter,
			garde,
			A2($author$project$Components$Referentiel$Fiche$Rattachements$visibles, false, fiche.GY));
		var anciens = $elm$core$List$length(tous) - $elm$core$List$length(actifs);
		var bornes = A2(
			$author$project$Components$Referentiel$Fiche$Resume$borner,
			depliee,
			model.ji ? tous : actifs);
		var _v0 = function () {
			var _v1 = fiche.g1;
			if (_v1 === 1) {
				return _Utils_Tuple3(
					$author$project$I18n$Cles$referentielFicheResumePersonnesRattachees(i18n),
					$author$project$I18n$Cles$referentielRattachementAucunePersonne(i18n),
					$author$project$I18n$Cles$referentielRattachementRattacherUnePersonne(i18n));
			} else {
				return _Utils_Tuple3(
					function () {
						var _v2 = A2($author$project$Components$Referentiel$Fiche$Model$valeurDe, 0, fiche);
						_v2$2:
						while (true) {
							if (!_v2.$) {
								switch (_v2.a) {
									case 'Madame':
										return $author$project$I18n$Cles$referentielFicheResumeRattacheeA(i18n);
									case 'Monsieur':
										return $author$project$I18n$Cles$referentielFicheResumeRattacheA(i18n);
									default:
										break _v2$2;
								}
							} else {
								break _v2$2;
							}
						}
						return $author$project$I18n$Cles$referentielFicheResumeRattacheANeutre(i18n);
					}(),
					$author$project$I18n$Cles$referentielRattachementAucuneOrganisation(i18n),
					$author$project$I18n$Cles$referentielRattachementRattacherAUneOrganisation(i18n));
			}
		}();
		var titre = _v0.a;
		var aucun = _v0.b;
		var rattacher = _v0.c;
		return A2(
			$author$project$Components$Shared$Page$View$sectionAvecCompte,
			$author$project$Components$Referentiel$Fiche$View$ancre('rattachements'),
			{
				fw: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (_v3) {
							return _List_fromArray(
								[
									A4(
									$author$project$Components$Shared$Bouton$View$boutonAvecIcone,
									2,
									$author$project$Components$Shared$Svg$svgAdd,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Fiche$Liaisons$idDuDeclencheurDeRattachement),
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Fiche$Update$RattachementDemande)
										]),
									rattacher)
								]);
						},
						fiche.GZ)),
				vW: $elm$core$Maybe$Just(
					$elm$core$String$fromInt(
						$elm$core$List$length(actifs))),
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau'),
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'hidden',
										$elm$core$List$isEmpty(bornes.g0))
									]))
							]),
						_List_fromArray(
							[
								A3($author$project$Components$Referentiel$Fiche$View$rattachementsEnTableau, i18n, fiche.g1, bornes.g0)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$List$isEmpty(bornes.g0) ? aucun : '')
							])),
						A4($author$project$Components$Referentiel$Fiche$View$pied, i18n, 1, bornes, depliee),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('anciens-rattachements')
							]),
						(anciens > 0) ? _List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								2,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('toggle'),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
										'aria-expanded',
										model.ji ? 'true' : 'false'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Referentiel$Fiche$Update$TerminesAffiches(!model.ji))
									]),
								model.ji ? $author$project$I18n$Cles$referentielFicheResumeMasquerLesAnciensRattachements(i18n) : ((anciens === 1) ? $author$project$I18n$Cles$referentielFicheResumeAncienRattachement(i18n) : A2(
									$author$project$I18n$Cles$referentielFicheResumeAnciensRattachements,
									i18n,
									{
										d: $elm$core$String$fromInt(anciens)
									})))
							]) : _List_Nil)
					]),
				Ar: $elm$core$Maybe$Nothing,
				Dj: 'rattachements',
				h6: titre
			});
	});
var $author$project$I18n$Cles$referentielRelationAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.relation.aucune', _List_Nil, 'Aucune relation');
};
var $author$project$I18n$Cles$referentielRelationTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.relation.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Relations · ' + p.w);
	});
var $author$project$Components$Referentiel$Fiche$Update$SuppressionDemandee = function (a) {
	return {$: 58, a: a};
};
var $author$project$I18n$Cles$referentielRelationHorsPerimetre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.relation.hors-perimetre', _List_Nil, 'Hors périmètre');
};
var $author$project$I18n$Cles$referentielRelationHorsPerimetreExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.relation.hors-perimetre.explication', _List_Nil, 'Une des deux fiches n\'est plus dans le périmètre de ce type ; la relation est gardée.');
};
var $author$project$Components$Referentiel$Fiche$View$pastilleHorsPerimetre = function (i18n) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('tag'),
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ambre'),
				$rtfeldman$elm_css$Html$Styled$Attributes$class('hors-perimetre'),
				$rtfeldman$elm_css$Html$Styled$Attributes$title(
				$author$project$I18n$Cles$referentielRelationHorsPerimetreExplication(i18n))
			]),
		_List_fromArray(
			[
				$author$project$Components$Shared$Svg$svgWarning,
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$I18n$Cles$referentielRelationHorsPerimetre(i18n))
			]));
};
var $author$project$Components$Referentiel$Fiche$View$relation = F2(
	function (i18n, lien) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('item'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('hors-perimetre', lien.An)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('type')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(lien.Bl)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('title'),
							$rtfeldman$elm_css$Html$Styled$Attributes$href(
							$author$project$Routes$Route$toString(
								A2($author$project$Routes$Route$Fiche, lien.zo, 0)))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$I18n$Cles$texte, i18n, lien.Dj))
						])),
					A2(
					$elm$core$Maybe$withDefault,
					$rtfeldman$elm_css$Html$Styled$text(''),
					A2(
						$elm$core$Maybe$map,
						function (identifiant) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('identifiant-legal')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$Components$Referentiel$Fiche$View$identifiantAffiche, lien, identifiant))
									]));
						},
						lien.m7)),
					lien.An ? $author$project$Components$Referentiel$Fiche$View$pastilleHorsPerimetre(i18n) : $rtfeldman$elm_css$Html$Styled$text(''),
					lien.AF ? $author$project$Components$Referentiel$Fiche$View$pastilleIncoherente(i18n) : $rtfeldman$elm_css$Html$Styled$text(''),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (_v0) {
								return _List_fromArray(
									[
										A3(
										$author$project$Components$Shared$Bouton$View$bouton,
										1,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id(
												$author$project$Components$Referentiel$Fiche$Liaisons$idDuDeclencheurDeSuppression(lien.r8)),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												$author$project$Components$Referentiel$Fiche$Update$SuppressionDemandee(lien.r8))
											]),
										$author$project$I18n$Cles$referentielRelationSupprimer(i18n))
									]);
							},
							lien.w6)))
				]));
	});
var $author$project$Components$Referentiel$Fiche$View$relations = F2(
	function (i18n, fiche) {
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_Nil,
			{
				fw: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (_v0) {
							return _List_fromArray(
								[
									A4(
									$author$project$Components$Shared$Bouton$View$boutonAvecIcone,
									2,
									$author$project$Components$Shared$Svg$svgAdd,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Fiche$Liaisons$idDuDeclencheurDeRelation),
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Fiche$Update$RelationDemandee)
										]),
									$author$project$I18n$Cles$referentielRelationAjouter(i18n))
								]);
						},
						fiche.Hy)),
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('list')
							]),
						A2(
							$elm$core$List$map,
							$author$project$Components$Referentiel$Fiche$View$relation(i18n),
							fiche.Hu)),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$List$isEmpty(fiche.Hu) ? $author$project$I18n$Cles$referentielRelationAucune(i18n) : '')
							]))
					]),
				Dj: 'relations',
				h6: A2(
					$author$project$I18n$Cles$referentielRelationTitre,
					i18n,
					{
						w: $elm$core$String$fromInt(
							$elm$core$List$length(fiche.Hu))
					})
			});
	});
var $author$project$Components$Referentiel$Fiche$Resume$Relations = 2;
var $author$project$I18n$Cles$referentielFicheResumeRelations = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.relations', _List_Nil, 'Relations');
};
var $author$project$Components$Referentiel$Fiche$View$relationsDuResume = F3(
	function (i18n, fiche, model) {
		var depliee = A2($author$project$Components$Referentiel$Fiche$Resume$estDepliee, 2, model.kH);
		var bornes = A2($author$project$Components$Referentiel$Fiche$Resume$borner, depliee, fiche.Hu);
		return A2(
			$author$project$Components$Shared$Page$View$sectionAvecCompte,
			$author$project$Components$Referentiel$Fiche$View$ancre('relations'),
			{
				fw: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (_v0) {
							return _List_fromArray(
								[
									A4(
									$author$project$Components$Shared$Bouton$View$boutonAvecIcone,
									2,
									$author$project$Components$Shared$Svg$svgAdd,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Fiche$Liaisons$idDuDeclencheurDeRelation),
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Fiche$Update$RelationDemandee)
										]),
									$author$project$I18n$Cles$referentielRelationAjouter(i18n))
								]);
						},
						fiche.Hy)),
				vW: $elm$core$Maybe$Just(
					$elm$core$String$fromInt(bornes.JE)),
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('list')
							]),
						A2(
							$elm$core$List$map,
							$author$project$Components$Referentiel$Fiche$View$relation(i18n),
							bornes.g0)),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$List$isEmpty(fiche.Hu) ? $author$project$I18n$Cles$referentielRelationAucune(i18n) : '')
							])),
						A4($author$project$Components$Referentiel$Fiche$View$pied, i18n, 2, bornes, depliee)
					]),
				Ar: $elm$core$Maybe$Nothing,
				Dj: 'relations',
				h6: $author$project$I18n$Cles$referentielFicheResumeRelations(i18n)
			});
	});
var $author$project$I18n$Cles$referentielFicheEnteteCiviliteMadame = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.entete.civilite-madame', _List_Nil, 'Mme');
};
var $author$project$I18n$Cles$referentielFicheEnteteCiviliteMonsieur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.entete.civilite-monsieur', _List_Nil, 'M.');
};
var $author$project$Components$Referentiel$Fiche$View$titreDeLEntete = F2(
	function (i18n, fiche) {
		var abrege = function (abreviation) {
			return abreviation + (' ' + A2($author$project$Components$Referentiel$Fiche$View$nomSansCivilite, i18n, fiche));
		};
		var _v0 = _Utils_Tuple2(
			fiche.g1,
			A2($author$project$Components$Referentiel$Fiche$Model$valeurDe, 0, fiche));
		_v0$2:
		while (true) {
			if ((!_v0.a) && (!_v0.b.$)) {
				switch (_v0.b.a) {
					case 'Madame':
						var _v1 = _v0.a;
						return abrege(
							$author$project$I18n$Cles$referentielFicheEnteteCiviliteMadame(i18n));
					case 'Monsieur':
						var _v2 = _v0.a;
						return abrege(
							$author$project$I18n$Cles$referentielFicheEnteteCiviliteMonsieur(i18n));
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return A2($author$project$Components$Referentiel$Fiche$View$titreDeLaFiche, i18n, fiche);
	});
var $author$project$I18n$Cles$referentielFicheIdentiteEnregistree = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.identite.enregistree', _List_Nil, 'Identité enregistrée');
};
var $author$project$Components$Referentiel$Fiche$View$toastDIdentite = F2(
	function (i18n, model) {
		return model.gI ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('toast'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$I18n$Cles$referentielFicheIdentiteEnregistree(i18n))
				])) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$I18n$Cles$referentielFusionFusionnees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.fusionnees', _List_Nil, 'Fiches fusionnées');
};
var $author$project$Components$Referentiel$Fiche$View$toastDeFusion = F2(
	function (i18n, model) {
		return model.mT ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('toast'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$I18n$Cles$referentielFusionFusionnees(i18n))
				])) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$Components$Referentiel$Fiche$Update$SectionDemandee = function (a) {
	return {$: 130, a: a};
};
var $author$project$Components$Referentiel$Fiche$Resume$compter = function (champs) {
	return {
		qs: $elm$core$List$length(
			A2($elm$core$List$filter, $elm$core$Basics$identity, champs)),
		JE: $elm$core$List$length(champs)
	};
};
var $author$project$I18n$Cles$referentielFicheResumeTuileChampsRenseignes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.tuile-champs-renseignes', _List_Nil, 'champs renseignés');
};
var $author$project$I18n$Cles$referentielFicheResumeTuileContact = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.tuile-contact', _List_Nil, 'contact');
};
var $author$project$I18n$Cles$referentielFicheResumeTuileContacts = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.tuile-contacts', _List_Nil, 'contacts');
};
var $author$project$I18n$Cles$referentielFicheResumeTuileDossierEnCours = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.tuile-dossier-en-cours', _List_Nil, 'dossier en cours');
};
var $author$project$I18n$Cles$referentielFicheResumeTuileDossiersEnCours = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.tuile-dossiers-en-cours', _List_Nil, 'dossiers en cours');
};
var $author$project$I18n$Cles$referentielFicheResumeTuileOrganisation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.tuile-organisation', _List_Nil, 'organisation');
};
var $author$project$I18n$Cles$referentielFicheResumeTuileOrganisations = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.tuile-organisations', _List_Nil, 'organisations');
};
var $author$project$I18n$Cles$referentielFicheResumeTuilePersonneRattachee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.tuile-personne-rattachee', _List_Nil, 'personne rattachée');
};
var $author$project$I18n$Cles$referentielFicheResumeTuilePersonnesRattachees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.tuile-personnes-rattachees', _List_Nil, 'personnes rattachées');
};
var $author$project$I18n$Cles$referentielFicheResumeTuileRelation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.tuile-relation', _List_Nil, 'relation');
};
var $author$project$I18n$Cles$referentielFicheResumeTuileRelations = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.tuile-relations', _List_Nil, 'relations');
};
var $author$project$I18n$Cles$referentielFicheResumeTuiles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.resume.tuiles', _List_Nil, 'Chiffres de la fiche');
};
var $author$project$Components$Shared$Svg$svgBuilding = A3($author$project$Components$Shared$Svg$icone, 'building', 'M5.5 3.5h8A1.5 1.5 0 0 1 15 5v15.5H4V5a1.5 1.5 0 0 1 1.5-1.5zM15 9h4a1 1 0 0 1 1 1v10.5h-5M7.5 7.5h4M7.5 11h4M7.5 14.5h4', _List_Nil);
var $author$project$Components$Shared$Svg$svgLink = A3($author$project$Components$Shared$Svg$icone, 'link', 'M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1', _List_Nil);
var $author$project$Components$Referentiel$Fiche$View$tuiles = F2(
	function (i18n, fiche) {
		var tuile = F4(
			function (nom, icone, valeur, libelle) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('tuile-lien'),
							$rtfeldman$elm_css$Html$Styled$Attributes$href(
							'#' + $author$project$Components$Referentiel$Fiche$View$idDeSection(nom)),
							$rtfeldman$elm_css$Html$Styled$Attributes$title(valeur + (' ' + libelle)),
							A2(
							$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
							'click',
							$elm$json$Json$Decode$succeed(
								_Utils_Tuple2(
									$author$project$Components$Referentiel$Fiche$Update$SectionDemandee(
										$author$project$Components$Referentiel$Fiche$View$idDeSection(nom)),
									true)))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('icone')
								]),
							_List_fromArray(
								[icone])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(valeur)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(libelle)
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('chevron')
								]),
							_List_fromArray(
								[$author$project$Components$Shared$Svg$svgChevronRight]))
						]));
			});
		var rattachees = $elm$core$List$length(
			A2($author$project$Components$Referentiel$Fiche$Rattachements$visibles, false, fiche.GY));
		var enService = $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (fourni) {
					return fourni.ri !== 2;
				},
				fiche.wa));
		var compte = $author$project$Components$Referentiel$Fiche$Resume$compter(
			_Utils_ap(
				A2(
					$elm$core$List$map,
					function (cle) {
						return !_Utils_eq(
							A2($author$project$Components$Referentiel$Fiche$Model$valeurDe, cle, fiche),
							$elm$core$Maybe$Nothing);
					},
					$author$project$Components$Referentiel$Fiche$Model$champsDe(fiche.g1)),
				$author$project$Components$Referentiel$Fiche$View$champsRenseignesDesTypes(fiche)));
		var accorde = F3(
			function (singulier, pluriel, n) {
				return (n > 1) ? pluriel : singulier;
			});
		var nombre = F5(
			function (nom, icone, n, singulier, pluriel) {
				return A4(
					tuile,
					nom,
					icone,
					$elm$core$String$fromInt(n),
					A3(accorde, singulier, pluriel, n));
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$nav,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('tuiles-liens'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					$author$project$I18n$Cles$referentielFicheResumeTuiles(i18n))
				]),
			_List_fromArray(
				[
					A5(
					nombre,
					'contacts',
					$author$project$Components$Shared$Svg$svgPhone,
					enService,
					$author$project$I18n$Cles$referentielFicheResumeTuileContact(i18n),
					$author$project$I18n$Cles$referentielFicheResumeTuileContacts(i18n)),
					function () {
					var _v0 = fiche.g1;
					if (_v0 === 1) {
						return A5(
							nombre,
							'rattachements',
							$author$project$Components$Shared$Svg$svgUsers,
							rattachees,
							$author$project$I18n$Cles$referentielFicheResumeTuilePersonneRattachee(i18n),
							$author$project$I18n$Cles$referentielFicheResumeTuilePersonnesRattachees(i18n));
					} else {
						return A5(
							nombre,
							'rattachements',
							$author$project$Components$Shared$Svg$svgBuilding,
							rattachees,
							$author$project$I18n$Cles$referentielFicheResumeTuileOrganisation(i18n),
							$author$project$I18n$Cles$referentielFicheResumeTuileOrganisations(i18n));
					}
				}(),
					A5(
					nombre,
					'relations',
					$author$project$Components$Shared$Svg$svgLink,
					$elm$core$List$length(fiche.Hu),
					$author$project$I18n$Cles$referentielFicheResumeTuileRelation(i18n),
					$author$project$I18n$Cles$referentielFicheResumeTuileRelations(i18n)),
					A5(
					nombre,
					'dossiers',
					$author$project$Components$Shared$Svg$svgFolders,
					0,
					$author$project$I18n$Cles$referentielFicheResumeTuileDossierEnCours(i18n),
					$author$project$I18n$Cles$referentielFicheResumeTuileDossiersEnCours(i18n)),
					A4(
					tuile,
					'information',
					$author$project$Components$Shared$Svg$svgCheck,
					$elm$core$String$fromInt(compte.qs) + (' / ' + $elm$core$String$fromInt(compte.JE)),
					$author$project$I18n$Cles$referentielFicheResumeTuileChampsRenseignes(i18n))
				]));
	});
var $author$project$Components$Referentiel$Fiche$View$lue = F5(
	function (i18n, onglet, recus, fiche, model) {
		var dansLeDrawer = $author$project$Components$Shared$Drawer$Model$estOuvert(model.Bk.kX);
		var messages = (dansLeDrawer || $author$project$Components$Shared$Drawer$Model$estOuvert(model.x9.kX)) ? _List_Nil : recus;
		return A2(
			$author$project$Components$Shared$Page$View$page,
			$author$project$Components$Referentiel$Fiche$View$racine,
			{
				ut: function () {
					switch (onglet) {
						case 0:
							return _Utils_ap(
								A2($author$project$Components$Referentiel$Fiche$View$bandeauxDeDoublon, i18n, fiche),
								A2(
									$elm$core$List$cons,
									A2($author$project$Components$Referentiel$Fiche$View$tuiles, i18n, fiche),
									$author$project$Components$Shared$Page$View$fiche(
										{
											tQ: _List_fromArray(
												[
													A2(
													$author$project$Components$Referentiel$Fiche$View$encartHorsLimites,
													i18n,
													A3($author$project$Components$Referentiel$Fiche$View$horsLimitesDe, i18n, model, fiche)),
													A3($author$project$Components$Referentiel$Fiche$View$chronologieDuResume, i18n, fiche, model),
													((!fiche.g1) && (fiche.gt !== 4)) ? A2($author$project$Components$Referentiel$Fiche$View$donneesPersonnellesDuResume, i18n, fiche) : $rtfeldman$elm_css$Html$Styled$text('')
												]),
											B2: _List_fromArray(
												[
													A2($author$project$Components$Referentiel$Fiche$View$toastDIdentite, i18n, model),
													A2($author$project$Components$Referentiel$Fiche$View$toastDeFusion, i18n, model),
													A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
													A2($author$project$Components$Referentiel$Fiche$View$bandeau, i18n, fiche),
													A2($author$project$Components$Referentiel$Fiche$View$conflit, i18n, model),
													A3($author$project$Components$Referentiel$Fiche$View$informations, i18n, fiche, model),
													A2($author$project$Components$Referentiel$Fiche$View$blocDeFusion, i18n, fiche),
													A2($author$project$Components$Referentiel$Fiche$View$blocDuCompte, i18n, fiche),
													A3($author$project$Components$Referentiel$Fiche$View$etablissementsDuResume, i18n, model.hd, fiche),
													A3($author$project$Components$Referentiel$Fiche$View$contacts, i18n, fiche, model),
													A3($author$project$Components$Referentiel$Fiche$View$rattachementsDuResume, i18n, fiche, model),
													A3($author$project$Components$Referentiel$Fiche$View$ficheDInformation, i18n, fiche, model),
													A3($author$project$Components$Referentiel$Fiche$View$relationsDuResume, i18n, fiche, model),
													$author$project$Components$Referentiel$Fiche$View$dossiersEtEchanges(i18n)
												])
										})));
						case 1:
							return $author$project$Components$Shared$Page$View$fiche(
								{
									tQ: _List_Nil,
									B2: _List_fromArray(
										[
											A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
											A2($author$project$Components$Referentiel$Fiche$View$bandeau, i18n, fiche),
											A3($author$project$Components$Referentiel$Fiche$View$ongletRoles, i18n, fiche, model.bi)
										])
								});
						case 2:
							return $author$project$Components$Shared$Page$View$fiche(
								{
									tQ: _List_fromArray(
										[
											A2($author$project$Components$Referentiel$Fiche$View$relations, i18n, fiche)
										]),
									B2: _List_fromArray(
										[
											A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
											A2($author$project$Components$Referentiel$Fiche$View$bandeau, i18n, fiche),
											A3($author$project$Components$Referentiel$Fiche$View$rattachements, i18n, fiche, model)
										])
								});
						case 3:
							return $author$project$Components$Shared$Page$View$fiche(
								{
									tQ: _List_Nil,
									B2: _List_fromArray(
										[
											A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
											A2($author$project$Components$Referentiel$Fiche$View$bandeau, i18n, fiche),
											A3($author$project$Components$Referentiel$Fiche$View$historique, i18n, fiche, model)
										])
								});
						default:
							return $author$project$Components$Shared$Page$View$fiche(
								{
									tQ: _List_Nil,
									B2: A2(
										$elm$core$List$cons,
										A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
										A2(
											$elm$core$List$cons,
											A2($author$project$Components$Referentiel$Fiche$View$bandeau, i18n, fiche),
											(fiche.g1 === 1) ? _List_fromArray(
												[
													A2($author$project$Components$Referentiel$Fiche$View$blocDuCycle, i18n, fiche)
												]) : _List_fromArray(
												[
													A2($author$project$Components$Referentiel$Fiche$View$donneesPersonnelles, i18n, fiche),
													A2($author$project$Components$Referentiel$Fiche$View$blocExport, i18n, fiche),
													A2($author$project$Components$Referentiel$Fiche$View$blocDuCycle, i18n, fiche),
													A2($author$project$Components$Referentiel$Fiche$View$blocEffacement, i18n, fiche)
												])))
								});
					}
				}(),
				xy: _List_fromArray(
					[
						A3($author$project$Components$Referentiel$Fiche$View$drawerDOuverture, i18n, fiche, model),
						A3($author$project$Components$Referentiel$Fiche$View$drawerDEvolution, i18n, fiche, model),
						A3(
						$author$project$Components$Referentiel$Fiche$View$drawerDeLiaison,
						i18n,
						dansLeDrawer ? recus : _List_Nil,
						model),
						A3($author$project$Components$Referentiel$Fiche$View$drawerDeLHistorique, i18n, fiche, model),
						A3($author$project$Components$Referentiel$Fiche$View$drawerDuBloc, i18n, fiche, model),
						A3($author$project$Components$Referentiel$Fiche$View$drawerDIdentite, i18n, fiche, model),
						A3($author$project$Components$Referentiel$Fiche$View$drawerDeLOccurrence, i18n, fiche, model),
						A3($author$project$Components$Referentiel$Fiche$View$drawerDuContact, i18n, fiche, model),
						A2($author$project$Components$Referentiel$Fiche$View$confirmationDeLiaison, i18n, model),
						A3($author$project$Components$Referentiel$Fiche$View$drawerDuCycle, i18n, fiche, model),
						A3(
						$author$project$Components$Referentiel$Fiche$View$drawerDExport,
						i18n,
						$author$project$Components$Shared$Drawer$Model$estOuvert(model.ms.kX) ? recus : _List_Nil,
						model),
						A4(
						$author$project$Components$Referentiel$Fiche$View$drawerDEffacement,
						i18n,
						$author$project$Components$Shared$Drawer$Model$estOuvert(model.x9.kX) ? recus : _List_Nil,
						fiche,
						model)
					]),
				zM: A3($author$project$Components$Referentiel$Fiche$View$actionsDeLaFiche, i18n, fiche, model),
				AK: $author$project$Components$Referentiel$Fiche$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								$author$project$Components$Referentiel$Fiche$View$avatar(fiche),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('pills')
									]),
								_Utils_ap(
									A2($author$project$Components$Referentiel$Fiche$View$pastillesDeLEntete, i18n, fiche),
									A2(
										$author$project$Components$Referentiel$Fiche$View$pastilleHorsLimites,
										i18n,
										A3($author$project$Components$Referentiel$Fiche$View$horsLimitesDe, i18n, model, fiche)))),
								A3($author$project$Components$Referentiel$Fiche$View$identite, i18n, fiche, model)
							]),
						zE: A2($author$project$Components$Referentiel$Fiche$View$filDArianeDe, i18n, fiche),
						Ef: _List_fromArray(
							[
								$author$project$Components$Shared$Onglets$View$view(
								A2(
									$elm$core$List$map,
									A4($author$project$Components$Referentiel$Fiche$View$lienDOnglet, i18n, fiche, model, onglet),
									$author$project$Components$Referentiel$Fiche$View$ongletsDe(fiche)))
							]),
						h6: A2($author$project$Components$Referentiel$Fiche$View$titreDeLEntete, i18n, fiche)
					})
			});
	});
var $author$project$I18n$Cles$referentielFicheEnRetardTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.en-retard.titre', _List_Nil, 'Fiche en cours d\'enregistrement');
};
var $author$project$I18n$Cles$referentielFicheTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.titre', _List_Nil, 'Fiche');
};
var $author$project$Components$Referentiel$Fiche$View$view = F4(
	function (i18n, onglet, messages, model) {
		var _v0 = model.gt;
		switch (_v0.$) {
			case 2:
				return A2(
					$author$project$Components$Shared$Introuvable$View$view,
					i18n,
					{
						aa: $author$project$Routes$Route$adressePartiesPrenantes,
						Bl: $author$project$I18n$Cles$referentielFicheRetour(i18n)
					});
			case 1:
				var fiche = _v0.a;
				return A5($author$project$Components$Referentiel$Fiche$View$lue, i18n, onglet, messages, fiche, model);
			case 3:
				return A4(
					$author$project$Components$Referentiel$Fiche$View$attente,
					i18n,
					messages,
					$author$project$I18n$Cles$referentielFicheEnRetardTitre(i18n),
					_List_fromArray(
						[
							$author$project$Components$Referentiel$Fiche$View$enRetard(i18n)
						]));
			case 0:
				return A4(
					$author$project$Components$Referentiel$Fiche$View$attente,
					i18n,
					messages,
					$author$project$I18n$Cles$referentielFicheTitre(i18n),
					_List_Nil);
			default:
				return A4(
					$author$project$Components$Referentiel$Fiche$View$attente,
					i18n,
					messages,
					$author$project$I18n$Cles$referentielFicheTitre(i18n),
					_List_Nil);
		}
	});
var $author$project$Components$Referentiel$Fusion$Update$ChampChoisi = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Components$Referentiel$Vocabulaire$champStandard = F2(
	function (i18n, cle) {
		var _v0 = A3($elm$core$String$replace, 'crm.entite.', '', cle);
		switch (_v0) {
			case 'civilite':
				return $author$project$I18n$Cles$referentielFicheChampCivilite(i18n);
			case 'prenom':
				return $author$project$I18n$Cles$referentielFicheChampPrenom(i18n);
			case 'nom':
				return $author$project$I18n$Cles$referentielFicheChampNom(i18n);
			case 'pays':
				return $author$project$I18n$Cles$referentielFicheChampPays(i18n);
			case 'langue':
				return $author$project$I18n$Cles$referentielFicheChampLangue(i18n);
			case 'raisonSociale':
				return $author$project$I18n$Cles$referentielFicheChampRaisonSociale(i18n);
			default:
				var autre = _v0;
				return autre;
		}
	});
var $author$project$I18n$Cles$referentielFusionChampsReprise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.champs.reprise', _List_Nil, 'Reprise');
};
var $author$project$I18n$Cles$referentielFusionChampsNonRenseigne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.champs.non-renseigne', _List_Nil, 'Non renseigné');
};
var $author$project$Components$Referentiel$Fusion$View$valeurAffichee = F4(
	function (i18n, model, cle, valeur) {
		var _v0 = _Utils_Tuple2(
			A3($elm$core$String$replace, 'crm.entite.', '', cle),
			valeur);
		if (_v0.b.$ === 1) {
			var _v1 = _v0.b;
			return $author$project$I18n$Cles$referentielFusionChampsNonRenseigne(i18n);
		} else {
			switch (_v0.a) {
				case 'pays':
					var code = _v0.b.a;
					return A2($author$project$Referentiel$Normes$nomDePays, model.hd, code);
				case 'langue':
					var code = _v0.b.a;
					return A2($author$project$Referentiel$Langues$nom, i18n, code);
				case 'civilite':
					var code = _v0.b.a;
					return A2(
						$author$project$I18n$Cles$texte,
						i18n,
						$author$project$Referentiel$Civilites$nom(code));
				default:
					var texte = _v0.b.a;
					return texte;
			}
		}
	});
var $author$project$Components$Referentiel$Fusion$View$ligneDeChamp = F3(
	function (i18n, model, ligne) {
		var reprise = A2($author$project$Components$Referentiel$Fusion$Model$priseSurAbsorbee, model.jN, ligne);
		var choix = F2(
			function (cote, valeur) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'selected',
									_Utils_eq(reprise, cote)),
									_Utils_Tuple2(
									'vide',
									_Utils_eq(valeur, $elm$core$Maybe$Nothing))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$input,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
											$rtfeldman$elm_css$Html$Styled$Attributes$name(ligne.dy),
											$rtfeldman$elm_css$Html$Styled$Attributes$checked(
											_Utils_eq(reprise, cote)),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
											(!ligne.g_) || _Utils_eq(valeur, $elm$core$Maybe$Nothing)),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											A2($author$project$Components$Referentiel$Fusion$Update$ChampChoisi, ligne.dy, cote))
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A4($author$project$Components$Referentiel$Fusion$View$valeurAffichee, i18n, model, ligne.dy, valeur))
										])),
									(cote && (_Utils_eq(ligne.z5, $elm$core$Maybe$Nothing) && reprise)) ? A2(
									$author$project$Components$Shared$Tag$View$view,
									0,
									$author$project$I18n$Cles$referentielFusionChampsReprise(i18n)) : $rtfeldman$elm_css$Html$Styled$text('')
								]))
						]));
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$th,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$scope('row')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Referentiel$Vocabulaire$champStandard, i18n, ligne.dy))
						])),
					A2(choix, false, ligne.z5),
					A2(choix, true, ligne.sK)
				]));
	});
var $author$project$I18n$Cles$referentielFusionChampsIdentique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.champs.identique', _List_Nil, 'Identique');
};
var $author$project$Components$Referentiel$Fusion$View$ligneIdentique = F3(
	function (i18n, model, identiques) {
		var renseignees = A2(
			$elm$core$List$filter,
			function (l) {
				return !_Utils_eq(l.z5, $elm$core$Maybe$Nothing);
			},
			identiques);
		return $elm$core$List$isEmpty(renseignees) ? _List_Nil : _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$tr,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('identiques')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$th,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$scope('row')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$elm$core$String$join,
									', ',
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.dy;
											},
											$author$project$Components$Referentiel$Vocabulaire$champStandard(i18n)),
										renseignees)))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'colspan', '2')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$elm$core$String$join,
									' · ',
									A2(
										$elm$core$List$map,
										function (l) {
											return A4($author$project$Components$Referentiel$Fusion$View$valeurAffichee, i18n, model, l.dy, l.z5);
										},
										renseignees))),
								A2(
								$author$project$Components$Shared$Tag$View$view,
								3,
								$author$project$I18n$Cles$referentielFusionChampsIdentique(i18n))
							]))
					]))
			]);
	});
var $author$project$Components$Referentiel$Fusion$Model$nom = function (fiche) {
	var _v0 = fiche.Av;
	if (!_v0.$) {
		var personne = _v0.a;
		var _v1 = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[personne.Gg, personne.Dj]));
		if (!_v1.b) {
			return '';
		} else {
			var presents = _v1;
			return A2($elm$core$String$join, ' ', presents);
		}
	} else {
		var organisation = _v0.a;
		return A2($elm$core$Maybe$withDefault, '', organisation.GR);
	}
};
var $author$project$Components$Referentiel$Fusion$View$nomLong = F2(
	function (i18n, fiche) {
		var _v0 = $author$project$Components$Referentiel$Fusion$Model$nom(fiche);
		if (_v0 === '') {
			return $author$project$I18n$Cles$referentielFicheNomMasque(i18n);
		} else {
			var nom = _v0;
			return nom;
		}
	});
var $author$project$I18n$Cles$referentielFusionChampsAbsorbee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fusion.champs.absorbee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.Dj + ' · absorbée');
	});
var $author$project$I18n$Cles$referentielFusionChampsChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.champs.champ', _List_Nil, 'Champ');
};
var $author$project$I18n$Cles$referentielFusionChampsDroit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.champs.droit', _List_Nil, 'Un champ que vous n\'avez pas le droit de modifier n\'est pas proposé : il garde la valeur de la fiche gardée.');
};
var $author$project$I18n$Cles$referentielFusionChampsGardee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fusion.champs.gardee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.Dj + ' · gardée');
	});
var $author$project$I18n$Cles$referentielFusionChampsIntro = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.champs.intro', _List_Nil, 'Par défaut, la valeur de la fiche gardée est retenue ; si elle est vide, celle de l\'autre fiche est reprise. Les champs identiques ne demandent aucun choix.');
};
var $author$project$I18n$Cles$referentielFusionChampsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.champs.titre', _List_Nil, 'Choisir la valeur de chaque champ');
};
var $author$project$Components$Referentiel$Fusion$View$etapeChamps = F4(
	function (i18n, model, gardeeFiche, absorbeeFiche) {
		var lignes = A2($author$project$Components$Referentiel$Fusion$Model$lignesDeChamps, gardeeFiche, absorbeeFiche);
		var _v0 = A2(
			$elm$core$List$partition,
			function (l) {
				return _Utils_eq(l.z5, l.sK);
			},
			lignes);
		var identiques = _v0.a;
		var differentes = _v0.b;
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Page$View$section,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('champs')
					]),
				{
					fw: _List_Nil,
					fZ: _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('intro')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielFusionChampsIntro(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$table,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('choix-de-champs')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$thead,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$tr,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$referentielFusionChampsChamp(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															A2(
																$author$project$I18n$Cles$referentielFusionChampsGardee,
																i18n,
																{
																	Dj: A2($author$project$Components$Referentiel$Fusion$View$nomLong, i18n, gardeeFiche)
																}))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															A2(
																$author$project$I18n$Cles$referentielFusionChampsAbsorbee,
																i18n,
																{
																	Dj: A2($author$project$Components$Referentiel$Fusion$View$nomLong, i18n, absorbeeFiche)
																}))
														]))
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$tbody,
									_List_Nil,
									_Utils_ap(
										A2(
											$elm$core$List$map,
											A2($author$project$Components$Referentiel$Fusion$View$ligneDeChamp, i18n, model),
											differentes),
										A3($author$project$Components$Referentiel$Fusion$View$ligneIdentique, i18n, model, identiques)))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielFusionChampsDroit(i18n))
								]))
						]),
					Dj: 'champs',
					h6: $author$project$I18n$Cles$referentielFusionChampsTitre(i18n)
				})
			]);
	});
var $author$project$Components$Referentiel$Fusion$Update$GardeeChoisie = function (a) {
	return {$: 13, a: a};
};
var $author$project$I18n$Cles$jourEnClair = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'jour.en-clair',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'jour',
					$author$project$I18n$Traductions$Chaine(p.A_)),
					_Utils_Tuple2(
					'mois',
					$author$project$I18n$Traductions$Chaine(p.CQ)),
					_Utils_Tuple2(
					'annee',
					$author$project$I18n$Traductions$Chaine(p.tk))
				]),
			p.A_ + (' ' + (p.CQ + (' ' + p.tk))));
	});
var $author$project$I18n$Cles$jourMoisEntier01 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'jour.mois-entier.01', _List_Nil, 'janvier');
};
var $author$project$I18n$Cles$jourMoisEntier02 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'jour.mois-entier.02', _List_Nil, 'février');
};
var $author$project$I18n$Cles$jourMoisEntier03 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'jour.mois-entier.03', _List_Nil, 'mars');
};
var $author$project$I18n$Cles$jourMoisEntier04 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'jour.mois-entier.04', _List_Nil, 'avril');
};
var $author$project$I18n$Cles$jourMoisEntier05 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'jour.mois-entier.05', _List_Nil, 'mai');
};
var $author$project$I18n$Cles$jourMoisEntier06 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'jour.mois-entier.06', _List_Nil, 'juin');
};
var $author$project$I18n$Cles$jourMoisEntier07 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'jour.mois-entier.07', _List_Nil, 'juillet');
};
var $author$project$I18n$Cles$jourMoisEntier08 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'jour.mois-entier.08', _List_Nil, 'août');
};
var $author$project$I18n$Cles$jourMoisEntier09 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'jour.mois-entier.09', _List_Nil, 'septembre');
};
var $author$project$I18n$Cles$jourMoisEntier10 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'jour.mois-entier.10', _List_Nil, 'octobre');
};
var $author$project$I18n$Cles$jourMoisEntier11 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'jour.mois-entier.11', _List_Nil, 'novembre');
};
var $author$project$I18n$Cles$jourMoisEntier12 = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'jour.mois-entier.12', _List_Nil, 'décembre');
};
var $author$project$Texte$Jour$moisEntiers = function (i18n) {
	return $elm$core$Array$fromList(
		_List_fromArray(
			[
				$author$project$I18n$Cles$jourMoisEntier01(i18n),
				$author$project$I18n$Cles$jourMoisEntier02(i18n),
				$author$project$I18n$Cles$jourMoisEntier03(i18n),
				$author$project$I18n$Cles$jourMoisEntier04(i18n),
				$author$project$I18n$Cles$jourMoisEntier05(i18n),
				$author$project$I18n$Cles$jourMoisEntier06(i18n),
				$author$project$I18n$Cles$jourMoisEntier07(i18n),
				$author$project$I18n$Cles$jourMoisEntier08(i18n),
				$author$project$I18n$Cles$jourMoisEntier09(i18n),
				$author$project$I18n$Cles$jourMoisEntier10(i18n),
				$author$project$I18n$Cles$jourMoisEntier11(i18n),
				$author$project$I18n$Cles$jourMoisEntier12(i18n)
			]));
};
var $author$project$Texte$Jour$enFrancaisLong = F2(
	function (i18n, jour) {
		var _v0 = A2(
			$author$project$Texte$Jour$lire,
			$author$project$Texte$Jour$moisEntiers(i18n),
			jour);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var quantieme = _v1.a;
			var nom = _v1.b;
			var annee = _v1.c;
			return A2(
				$author$project$I18n$Cles$jourEnClair,
				i18n,
				{tk: annee, A_: quantieme, CQ: nom});
		} else {
			return jour;
		}
	});
var $author$project$Components$Referentiel$Fusion$View$libelleDuRole = F2(
	function (i18n, role) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.Dj;
			},
			role.D1);
		if (!_v0.$) {
			var offre = _v0.a;
			return A2(
				$author$project$I18n$Cles$texte,
				i18n,
				$author$project$Components$Referentiel$Archetype$libelle(role.fA)) + (' · ' + offre);
		} else {
			return A2(
				$author$project$I18n$Cles$texte,
				i18n,
				$author$project$Components$Referentiel$Archetype$libelle(role.fA));
		}
	});
var $author$project$I18n$Cles$referentielFusionDossiersAVenir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.dossiers.a-venir', _List_Nil, 'À venir');
};
var $author$project$I18n$Cles$referentielFusionGardeeContacts = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.gardee.contacts', _List_Nil, 'Contacts');
};
var $author$project$I18n$Cles$referentielFusionGardeeCreeeLe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.gardee.creee-le', _List_Nil, 'Créée le');
};
var $author$project$I18n$Cles$referentielFusionGardeeDossiers = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.gardee.dossiers', _List_Nil, 'Dossiers');
};
var $author$project$I18n$Cles$referentielFusionGardeeEcheance = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.gardee.echeance', _List_Nil, 'Échéance de conservation');
};
var $author$project$I18n$Cles$referentielFusionGardeePlusAncienne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.gardee.plus-ancienne', _List_Nil, 'Plus ancienne');
};
var $author$project$I18n$Cles$referentielFusionGardeeRattachements = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.gardee.rattachements', _List_Nil, 'Rattachements');
};
var $author$project$I18n$Cles$referentielFusionGardeeRoles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.gardee.roles', _List_Nil, 'Rôles');
};
var $author$project$Components$Referentiel$Fusion$View$carte = F5(
	function (i18n, model, place, fiche, plusAncienne) {
		var rattachements = A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				function (r) {
					return A2(
						$author$project$I18n$Cles$texte,
						i18n,
						$author$project$Components$Referentiel$Common$RechercheDeFiche$nomDe(r.t3));
				},
				fiche.GY));
		var ligne = F2(
			function (libelle, valeur) {
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$dt,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(libelle)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$dd,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(valeur)
							]))
					]);
			});
		var libellesDesRoles = $elm$core$List$isEmpty(fiche.eX) ? '0' : ($elm$core$String$fromInt(
			$elm$core$List$length(fiche.eX)) + (' · ' + A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				$author$project$Components$Referentiel$Fusion$View$libelleDuRole(i18n),
				fiche.eX))));
		var echeance = A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$String$left(10),
				$author$project$Texte$Jour$enFrancais(i18n)),
			(!place) ? A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.x_;
				},
				model.tq) : A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.xZ;
				},
				model.tq));
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('carte-fiche', true),
							_Utils_Tuple2(
							'selected',
							_Utils_eq(model.z5, place))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
									$rtfeldman$elm_css$Html$Styled$Attributes$name('fusion-gardee'),
									$rtfeldman$elm_css$Html$Styled$Attributes$checked(
									_Utils_eq(model.z5, place)),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Referentiel$Fusion$Update$GardeeChoisie(place))
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Referentiel$Fusion$View$nomLong, i18n, fiche))
								])),
							plusAncienne ? A2(
							$author$project$Components$Shared$Tag$View$view,
							5,
							$author$project$I18n$Cles$referentielFusionGardeePlusAncienne(i18n)) : $rtfeldman$elm_css$Html$Styled$text('')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$dl,
					_List_Nil,
					_Utils_ap(
						A2(
							ligne,
							$author$project$I18n$Cles$referentielFusionGardeeCreeeLe(i18n),
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$String$left(10),
										$author$project$Texte$Jour$enFrancaisLong(i18n)),
									fiche.wn))),
						_Utils_ap(
							A2(
								ligne,
								$author$project$I18n$Cles$referentielFusionGardeeContacts(i18n),
								$elm$core$String$fromInt(
									$elm$core$List$length(fiche.wa))),
							_Utils_ap(
								A2(
									ligne,
									$author$project$I18n$Cles$referentielFusionGardeeRoles(i18n),
									libellesDesRoles),
								_Utils_ap(
									A2(
										ligne,
										$author$project$I18n$Cles$referentielFusionGardeeRattachements(i18n),
										rattachements),
									_Utils_ap(
										A2(
											ligne,
											$author$project$I18n$Cles$referentielFusionGardeeDossiers(i18n),
											$author$project$I18n$Cles$referentielFusionDossiersAVenir(i18n)),
										A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2(
												$elm$core$Maybe$map,
												ligne(
													$author$project$I18n$Cles$referentielFusionGardeeEcheance(i18n)),
												echeance))))))))
				]));
	});
var $author$project$I18n$Cles$referentielFusionGardeeIntro = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.gardee.intro', _List_Nil, 'La fiche gardée conserve son identité. L\'autre est absorbée : elle reste consultable, mais ne peut plus être modifiée.');
};
var $author$project$I18n$Cles$referentielFusionGardeeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.gardee.titre', _List_Nil, 'Quelle fiche garder ?');
};
var $author$project$Components$Referentiel$Fusion$View$etapeFiche = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.Gf, model.Iv);
		if ((_v0.a.$ === 1) && (_v0.b.$ === 1)) {
			var premiere = _v0.a.a;
			var seconde = _v0.b.a;
			var ancienne = $author$project$Components$Referentiel$Fusion$Model$plusAncienne(model);
			return _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Page$View$section,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('gardee')
						]),
					{
						fw: _List_Nil,
						fZ: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('intro')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielFusionGardeeIntro(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('choix-de-fiche')
									]),
								_List_fromArray(
									[
										A5($author$project$Components$Referentiel$Fusion$View$carte, i18n, model, 0, premiere, !ancienne),
										A5($author$project$Components$Referentiel$Fusion$View$carte, i18n, model, 1, seconde, ancienne === 1)
									]))
							]),
						Dj: 'gardee',
						h6: $author$project$I18n$Cles$referentielFusionGardeeTitre(i18n)
					})
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$I18n$Cles$referentielFusionRecapAccepte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.recap.accepte', _List_Nil, 'Accepté');
};
var $author$project$I18n$Cles$referentielFusionRecapColonneAbsorbee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.recap.colonne-absorbee', _List_Nil, 'Absorbée');
};
var $author$project$I18n$Cles$referentielFusionRecapColonneGardee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.recap.colonne-gardee', _List_Nil, 'Gardée');
};
var $author$project$I18n$Cles$referentielFusionRecapColonneRetenu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.recap.colonne-retenu', _List_Nil, 'Retenu');
};
var $author$project$I18n$Cles$referentielFusionRecapConsentements = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.recap.consentements', _List_Nil, 'Consentements : le plus restrictif est gardé');
};
var $author$project$I18n$Cles$referentielFusionRecapFinalite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.recap.finalite', _List_Nil, 'Finalité');
};
var $author$project$I18n$Cles$referentielFusionRecapNonDemande = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.recap.non-demande', _List_Nil, 'Non demandé');
};
var $author$project$I18n$Cles$referentielFusionRecapProspection = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fusion.recap.prospection',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			'Prospection · ' + p.fm);
	});
var $author$project$I18n$Cles$referentielFusionRecapRefuse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.recap.refuse', _List_Nil, 'Refusé');
};
var $author$project$Components$Referentiel$Fusion$View$consentements = F2(
	function (i18n, model) {
		var _v0 = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.v4;
			},
			model.tq);
		if ((!_v0.$) && _v0.a.b) {
			var lignes = _v0.a;
			var valeur = function (v) {
				if (!v.$) {
					if (v.a) {
						return $author$project$I18n$Cles$referentielFusionRecapAccepte(i18n);
					} else {
						return $author$project$I18n$Cles$referentielFusionRecapRefuse(i18n);
					}
				} else {
					return $author$project$I18n$Cles$referentielFusionRecapNonDemande(i18n);
				}
			};
			var _v1 = (!model.z5) ? _Utils_Tuple2(
				function ($) {
					return $.zo;
				},
				function ($) {
					return $.t3;
				}) : _Utils_Tuple2(
				function ($) {
					return $.t3;
				},
				function ($) {
					return $.zo;
				});
			var deLaGardee = _v1.a;
			var deLAbsorbee = _v1.b;
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('consentements')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielFusionRecapConsentements(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$table,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('choix-de-champs')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$referentielFusionRecapFinalite(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$referentielFusionRecapColonneGardee(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$referentielFusionRecapColonneAbsorbee(i18n))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$referentielFusionRecapColonneRetenu(i18n))
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$tbody,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (ligne) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$scope('row')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2(
															$author$project$I18n$Cles$referentielFusionRecapProspection,
															i18n,
															{fm: ligne.fm}))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$td,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														valeur(
															deLaGardee(ligne)))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$td,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														valeur(
															deLAbsorbee(ligne)))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$td,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														valeur(
															$elm$core$Maybe$Just(ligne.HY)))
													]))
											]));
								},
								lignes))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$I18n$Cles$referentielFusionAvancementAbsorbeeMarquee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fusion.avancement.absorbee-marquee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Fiche « ' + (p.Dj + ' » marquée absorbée'));
	});
var $author$project$I18n$Cles$referentielFusionAvancementChampsRepris = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.avancement.champs-repris', _List_Nil, 'Valeurs des champs reprises');
};
var $author$project$I18n$Cles$referentielFusionAvancementContactsReunis = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.avancement.contacts-reunis', _List_Nil, 'Contacts réunis');
};
var $author$project$I18n$Cles$referentielFusionAvancementGardeePreparee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.avancement.gardee-preparee', _List_Nil, 'Fiche gardée préparée');
};
var $author$project$I18n$Cles$referentielFusionAvancementRolesEtRattachements = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.avancement.roles-et-rattachements', _List_Nil, 'Rôles et rattachements');
};
var $author$project$Components$Referentiel$Vocabulaire$etapeDeLaFusion = F3(
	function (i18n, nom, code) {
		switch (code) {
			case 'gardee-preparee':
				return $author$project$I18n$Cles$referentielFusionAvancementGardeePreparee(i18n);
			case 'champs-repris':
				return $author$project$I18n$Cles$referentielFusionAvancementChampsRepris(i18n);
			case 'contacts-reunis':
				return $author$project$I18n$Cles$referentielFusionAvancementContactsReunis(i18n);
			case 'roles-et-rattachements':
				return $author$project$I18n$Cles$referentielFusionAvancementRolesEtRattachements(i18n);
			case 'absorbee-marquee':
				return A2(
					$author$project$I18n$Cles$referentielFusionAvancementAbsorbeeMarquee,
					i18n,
					{Dj: nom});
			default:
				var autre = code;
				return autre;
		}
	});
var $author$project$I18n$Cles$referentielFusionAvancementTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.avancement.titre', _List_Nil, 'Avancement');
};
var $author$project$I18n$Cles$referentielFusionInterrompueDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fusion.interrompue.detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etape',
					$author$project$I18n$Traductions$Chaine(p.me)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Une erreur est survenue à l\'étape « ' + (p.me + (' ». Aucune fiche n\'est perdue et « ' + (p.Dj + ' » n\'est pas encore absorbée. Relancer la fusion reprend où elle s\'est arrêtée.'))));
	});
var $author$project$I18n$Cles$referentielFusionInterrompueTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.interrompue.titre', _List_Nil, 'La fusion n\'a pas pu se terminer');
};
var $author$project$Components$Referentiel$Fusion$View$interrompue = F3(
	function (i18n, model, absorbeeFiche) {
		var nom = A2($author$project$Components$Referentiel$Fusion$View$nomLong, i18n, absorbeeFiche);
		var libelle = A2($author$project$Components$Referentiel$Vocabulaire$etapeDeLaFusion, i18n, nom);
		var etapes = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.yL;
				},
				model.ua));
		var arret = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.zg;
					},
					$elm$core$Basics$not),
				etapes));
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Note$View$view,
				1,
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielFusionInterrompueTitre(i18n))
							])),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (etape) {
								return _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$referentielFusionInterrompueDetail,
													i18n,
													{
														me: libelle(etape.vx),
														Dj: nom
													}))
											]))
									]);
							},
							arret)))),
				A2(
				$author$project$Components$Shared$Page$View$section,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('avancement')
					]),
				{
					fw: _List_Nil,
					fZ: _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('recap')
								]),
							A2(
								$elm$core$List$map,
								function (etape) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$li,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2('faite', etape.zg)
													]))
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('coche'),
														A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
													]),
												etape.zg ? _List_fromArray(
													[$author$project$Components$Shared$Svg$svgCheck]) : _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														libelle(etape.vx))
													]))
											]));
								},
								etapes))
						]),
					Dj: 'avancement',
					h6: $author$project$I18n$Cles$referentielFusionAvancementTitre(i18n)
				})
			]);
	});
var $author$project$I18n$Cles$referentielFusionRecapAbsorbee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.recap.absorbee', _List_Nil, 'Fiche absorbée :');
};
var $author$project$I18n$Cles$referentielFusionRecapAbsorbeeSuite = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fusion.recap.absorbee-suite',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			', consultable, marquée « Fusionnée dans ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$referentielFusionRecapEcheance = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.recap.echeance', _List_Nil, 'Échéance de conservation :');
};
var $author$project$I18n$Cles$referentielFusionRecapEcheanceSuite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.recap.echeance-suite', _List_Nil, ', la plus proche des deux');
};
var $author$project$I18n$Cles$referentielFusionRecapGardee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.recap.gardee', _List_Nil, 'Fiche gardée :');
};
var $author$project$I18n$Cles$referentielFusionRecapSansRetour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.recap.sans-retour', _List_Nil, 'La fusion est sans retour.');
};
var $author$project$I18n$Cles$referentielFusionRecapSansRetourDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.recap.sans-retour-detail', _List_Nil, 'Rien n\'est supprimé : l\'historique des deux fiches est conservé. Mais les deux fiches ne pourront plus être séparées.');
};
var $author$project$I18n$Cles$referentielFusionRecapTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.recap.titre', _List_Nil, 'Ce qui va changer');
};
var $author$project$Components$Referentiel$Fusion$View$etapeRecapitulatif = F4(
	function (i18n, model, gardeeFiche, absorbeeFiche) {
		return _Utils_eq(model.l2, $author$project$Components$Referentiel$Fusion$Model$Interrompue) ? A3($author$project$Components$Referentiel$Fusion$View$interrompue, i18n, model, absorbeeFiche) : _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Page$View$section,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('recapitulatif')
					]),
				{
					fw: _List_Nil,
					fZ: _Utils_ap(
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$ul,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('recap')
									]),
								_Utils_ap(
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$li,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$referentielFusionRecapGardee(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$strong,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															A2($author$project$Components$Referentiel$Fusion$View$nomLong, i18n, gardeeFiche))
														]))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$li,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$referentielFusionRecapAbsorbee(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$strong,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															A2($author$project$Components$Referentiel$Fusion$View$nomLong, i18n, absorbeeFiche))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															A2(
																$author$project$I18n$Cles$referentielFusionRecapAbsorbeeSuite,
																i18n,
																{
																	Dj: A2($author$project$Components$Referentiel$Fusion$View$nomLong, i18n, gardeeFiche)
																}))
														]))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$li,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$referentielFusionGardeeDossiers(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$strong,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$referentielFusionDossiersAVenir(i18n))
														]))
												]))
										]),
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											function (echeance) {
												return _List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$li,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$rtfeldman$elm_css$Html$Styled$span,
																_List_Nil,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(
																		$author$project$I18n$Cles$referentielFusionRecapEcheance(i18n))
																	])),
																A2(
																$rtfeldman$elm_css$Html$Styled$strong,
																_List_Nil,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(
																		A2(
																			$author$project$Texte$Jour$enFrancais,
																			i18n,
																			A2($elm$core$String$left, 10, echeance)))
																	])),
																A2(
																$rtfeldman$elm_css$Html$Styled$span,
																_List_Nil,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(
																		$author$project$I18n$Cles$referentielFusionRecapEcheanceSuite(i18n))
																	]))
															]))
													]);
											},
											A2(
												$elm$core$Maybe$andThen,
												function ($) {
													return $.x$;
												},
												model.tq)))))
							]),
						A2($author$project$Components$Referentiel$Fusion$View$consentements, i18n, model)),
					Dj: 'recapitulatif',
					h6: $author$project$I18n$Cles$referentielFusionRecapTitre(i18n)
				}),
				A2(
				$author$project$Components$Shared$Note$View$view,
				1,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielFusionRecapSansRetour(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielFusionRecapSansRetourDetail(i18n))
							]))
					]))
			]);
	});
var $author$project$Components$Referentiel$Fusion$Model$ConserveGardee = {$: 1};
var $author$project$Components$Referentiel$Fusion$Model$NonRecopie = {$: 3};
var $author$project$Components$Referentiel$Fusion$Model$PrincipalGardee = {$: 0};
var $author$project$Components$Referentiel$Fusion$Model$Repris = {$: 2};
var $author$project$Components$Referentiel$Fusion$Model$normalise = function (valeur) {
	return A2(
		$elm$core$String$filter,
		function (c) {
			return c !== ' ';
		},
		$elm$core$String$toLower(
			$elm$core$String$trim(valeur)));
};
var $author$project$Components$Referentiel$Fusion$Model$valeurDuContact = function (contact) {
	var _v0 = _Utils_Tuple2(contact.fm, contact.aa);
	if (!_v0.a.$) {
		var valeur = _v0.a.a;
		return valeur;
	} else {
		if (!_v0.b.$) {
			var _v1 = _v0.a;
			var adresse = _v0.b.a;
			return adresse.B_;
		} else {
			return '';
		}
	}
};
var $author$project$Components$Referentiel$Fusion$Model$contactsReunis = F2(
	function (gardeeFiche, absorbeeFiche) {
		var presents = A2(
			$elm$core$List$map,
			A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Fusion$Model$valeurDuContact, $author$project$Components$Referentiel$Fusion$Model$normalise),
			gardeeFiche.wa);
		var deLaGardee = function (contact) {
			return {
				Bl: $author$project$Components$Referentiel$Fusion$Model$valeurDuContact(contact),
				bj: contact.px ? $author$project$Components$Referentiel$Fusion$Model$PrincipalGardee : $author$project$Components$Referentiel$Fusion$Model$ConserveGardee
			};
		};
		var deLAbsorbee = function (contact) {
			return {
				Bl: $author$project$Components$Referentiel$Fusion$Model$valeurDuContact(contact),
				bj: A2(
					$elm$core$List$member,
					$author$project$Components$Referentiel$Fusion$Model$normalise(
						$author$project$Components$Referentiel$Fusion$Model$valeurDuContact(contact)),
					presents) ? $author$project$Components$Referentiel$Fusion$Model$NonRecopie : $author$project$Components$Referentiel$Fusion$Model$Repris
			};
		};
		return _Utils_ap(
			A2($elm$core$List$map, deLaGardee, gardeeFiche.wa),
			A2($elm$core$List$map, deLAbsorbee, absorbeeFiche.wa));
	});
var $author$project$Components$Referentiel$Fusion$View$estUnSeul = function (sort) {
	if (sort.$ === 4) {
		return true;
	} else {
		return false;
	}
};
var $author$project$I18n$Cles$referentielFusionReunionDejaPresent = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.reunion.deja-present', _List_Nil, 'déjà présent');
};
var $author$project$I18n$Cles$referentielFusionReunionDesDeuxCotes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.reunion.des-deux-cotes', _List_Nil, 'présent des deux côtés');
};
var $author$project$I18n$Cles$referentielFusionReunionGardee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.reunion.gardee', _List_Nil, 'Gardée');
};
var $author$project$I18n$Cles$referentielFusionReunionNonRecopie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.reunion.non-recopie', _List_Nil, 'Non recopié');
};
var $author$project$I18n$Cles$referentielFusionReunionPrincipalGardee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.reunion.principal-gardee', _List_Nil, 'Principal · gardée');
};
var $author$project$I18n$Cles$referentielFusionReunionRepris = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.reunion.repris', _List_Nil, 'Repris');
};
var $author$project$I18n$Cles$referentielFusionReunionUnSeulDebut = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fusion.reunion.un-seul-debut',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'debut',
					$author$project$I18n$Traductions$Chaine(p.ku))
				]),
			'Un seul · début ' + p.ku);
	});
var $author$project$I18n$Cles$referentielFusionReunionUnSeulPlusAncien = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.reunion.un-seul-plus-ancien', _List_Nil, 'Un seul · début le plus ancien');
};
var $author$project$Components$Referentiel$Fusion$View$ligneDeReunion = F2(
	function (i18n, ligne) {
		var _v0 = function () {
			var _v1 = ligne.bj;
			switch (_v1.$) {
				case 0:
					return _Utils_Tuple2(
						$author$project$I18n$Cles$referentielFusionReunionPrincipalGardee(i18n),
						5);
				case 1:
					return _Utils_Tuple2(
						$author$project$I18n$Cles$referentielFusionReunionGardee(i18n),
						3);
				case 2:
					return _Utils_Tuple2(
						$author$project$I18n$Cles$referentielFusionReunionRepris(i18n),
						0);
				case 3:
					return _Utils_Tuple2(
						$author$project$I18n$Cles$referentielFusionReunionNonRecopie(i18n),
						3);
				default:
					if (!_v1.a.$) {
						var debut = _v1.a.a;
						return _Utils_Tuple2(
							A2(
								$author$project$I18n$Cles$referentielFusionReunionUnSeulDebut,
								i18n,
								{
									ku: A2($author$project$Texte$Jour$enFrancaisLong, i18n, debut)
								}),
							5);
					} else {
						var _v2 = _v1.a;
						return _Utils_Tuple2(
							$author$project$I18n$Cles$referentielFusionReunionUnSeulPlusAncien(i18n),
							5);
					}
			}
		}();
		var etiquette = _v0.a;
		var couleur = _v0.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(ligne.Bl)
						])),
					_Utils_eq(ligne.bj, $author$project$Components$Referentiel$Fusion$Model$NonRecopie) ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$referentielFusionReunionDejaPresent(i18n))
						])) : $rtfeldman$elm_css$Html$Styled$text(''),
					$author$project$Components$Referentiel$Fusion$View$estUnSeul(ligne.bj) ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('precision')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$referentielFusionReunionDesDeuxCotes(i18n))
						])) : $rtfeldman$elm_css$Html$Styled$text(''),
					A2($author$project$Components$Shared$Tag$View$view, couleur, etiquette)
				]));
	});
var $author$project$Components$Referentiel$Fusion$Model$nombreDeContacts = F2(
	function (gardeeFiche, absorbeeFiche) {
		return $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (ligne) {
					return !_Utils_eq(ligne.bj, $author$project$Components$Referentiel$Fusion$Model$NonRecopie);
				},
				A2($author$project$Components$Referentiel$Fusion$Model$contactsReunis, gardeeFiche, absorbeeFiche)));
	});
var $author$project$I18n$Cles$referentielFusionReunionContacts = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.reunion.contacts', _List_Nil, 'Contacts réunis');
};
var $author$project$I18n$Cles$referentielFusionReunionRattacheeA = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fusion.reunion.rattachee-a',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Rattachée à ' + p.Dj);
	});
var $author$project$I18n$Cles$referentielFusionReunionRoles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.reunion.roles', _List_Nil, 'Rôles et rattachements');
};
var $author$project$Components$Referentiel$Fusion$Model$UnSeul = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Referentiel$Fusion$Model$reunionDesRattachements = F2(
	function (gardeeFiche, absorbeeFiche) {
		var repris = function (r) {
			return A2(
				$elm$core$List$any,
				function (g) {
					return _Utils_eq(g.t3.r8, r.t3.r8);
				},
				gardeeFiche.GY) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(r, $author$project$Components$Referentiel$Fusion$Model$Repris)
				]);
		};
		var correspondant = function (r) {
			return A2(
				$elm$core$List$filter,
				function (a) {
					return _Utils_eq(a.t3.r8, r.t3.r8);
				},
				absorbeeFiche.GY);
		};
		var deLaGardee = function (r) {
			var _v0 = correspondant(r);
			if (!_v0.b) {
				return _Utils_Tuple2(r, $author$project$Components$Referentiel$Fusion$Model$ConserveGardee);
			} else {
				return _Utils_Tuple2(
					r,
					$author$project$Components$Referentiel$Fusion$Model$UnSeul($elm$core$Maybe$Nothing));
			}
		};
		return _Utils_ap(
			A2($elm$core$List$map, deLaGardee, gardeeFiche.GY),
			A2($elm$core$List$concatMap, repris, absorbeeFiche.GY));
	});
var $author$project$Components$Referentiel$Fusion$Model$memeRole = F2(
	function (a, b) {
		return _Utils_eq(a.r0, b.r0) && _Utils_eq(
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Aq;
				},
				a.D1),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Aq;
				},
				b.D1));
	});
var $author$project$Components$Referentiel$Fusion$Model$reunionDesRoles = F3(
	function (libelle, gardeeFiche, absorbeeFiche) {
		var repris = function (role) {
			return A2(
				$elm$core$List$any,
				$author$project$Components$Referentiel$Fusion$Model$memeRole(role),
				gardeeFiche.eX) ? _List_Nil : _List_fromArray(
				[
					{
					Bl: libelle(role),
					bj: $author$project$Components$Referentiel$Fusion$Model$Repris
				}
				]);
		};
		var ligneDeLaGardee = function (role) {
			var _v0 = A2(
				$elm$core$List$filter,
				$author$project$Components$Referentiel$Fusion$Model$memeRole(role),
				absorbeeFiche.eX);
			if (!_v0.b) {
				return {
					Bl: libelle(role),
					bj: $author$project$Components$Referentiel$Fusion$Model$ConserveGardee
				};
			} else {
				var autres = _v0;
				return {
					Bl: libelle(role),
					bj: $author$project$Components$Referentiel$Fusion$Model$UnSeul(
						$elm$core$List$minimum(
							A2(
								$elm$core$List$filter,
								function (d) {
									return d !== '';
								},
								A2(
									$elm$core$List$map,
									function ($) {
										return $.ku;
									},
									A2($elm$core$List$cons, role, autres)))))
				};
			}
		};
		return _Utils_ap(
			A2($elm$core$List$map, ligneDeLaGardee, gardeeFiche.eX),
			A2($elm$core$List$concatMap, repris, absorbeeFiche.eX));
	});
var $author$project$Components$Referentiel$Fusion$View$etapeReunion = F3(
	function (i18n, gardeeFiche, absorbeeFiche) {
		var roles = A3(
			$author$project$Components$Referentiel$Fusion$Model$reunionDesRoles,
			$author$project$Components$Referentiel$Fusion$View$libelleDuRole(i18n),
			gardeeFiche,
			absorbeeFiche);
		var rattachements = A2($author$project$Components$Referentiel$Fusion$Model$reunionDesRattachements, gardeeFiche, absorbeeFiche);
		var contacts = A2($author$project$Components$Referentiel$Fusion$Model$contactsReunis, gardeeFiche, absorbeeFiche);
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Page$View$sectionAvecCompte,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('contacts-reunis')
					]),
				{
					fw: _List_Nil,
					vW: $elm$core$Maybe$Just(
						$elm$core$String$fromInt(
							A2($author$project$Components$Referentiel$Fusion$Model$nombreDeContacts, gardeeFiche, absorbeeFiche))),
					fZ: _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('reunion')
								]),
							A2(
								$elm$core$List$map,
								$author$project$Components$Referentiel$Fusion$View$ligneDeReunion(i18n),
								contacts))
						]),
					Ar: $elm$core$Maybe$Nothing,
					Dj: 'contacts-reunis',
					h6: $author$project$I18n$Cles$referentielFusionReunionContacts(i18n)
				}),
				A2(
				$author$project$Components$Shared$Page$View$section,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('roles-reunis')
					]),
				{
					fw: _List_Nil,
					fZ: _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('reunion')
								]),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									$author$project$Components$Referentiel$Fusion$View$ligneDeReunion(i18n),
									roles),
								A2(
									$elm$core$List$map,
									function (_v0) {
										var r = _v0.a;
										var sort = _v0.b;
										return A2(
											$author$project$Components$Referentiel$Fusion$View$ligneDeReunion,
											i18n,
											{
												Bl: A2(
													$author$project$I18n$Cles$referentielFusionReunionRattacheeA,
													i18n,
													{
														Dj: A2(
															$author$project$I18n$Cles$texte,
															i18n,
															$author$project$Components$Referentiel$Common$RechercheDeFiche$nomDe(r.t3))
													}),
												bj: sort
											});
									},
									rattachements)))
						]),
					Dj: 'roles-reunis',
					h6: $author$project$I18n$Cles$referentielFusionReunionRoles(i18n)
				})
			]);
	});
var $author$project$Components$Referentiel$Fusion$View$etapeDe = F4(
	function (i18n, model, gardeeFiche, absorbeeFiche) {
		var _v0 = model.me;
		switch (_v0) {
			case 0:
				return A2($author$project$Components$Referentiel$Fusion$View$etapeFiche, i18n, model);
			case 1:
				return A4($author$project$Components$Referentiel$Fusion$View$etapeChamps, i18n, model, gardeeFiche, absorbeeFiche);
			case 2:
				return A3($author$project$Components$Referentiel$Fusion$View$etapeReunion, i18n, gardeeFiche, absorbeeFiche);
			default:
				return A4($author$project$Components$Referentiel$Fusion$View$etapeRecapitulatif, i18n, model, gardeeFiche, absorbeeFiche);
		}
	});
var $author$project$Components$Referentiel$Fusion$Update$FusionAnnulee = {$: 17};
var $author$project$Components$Referentiel$Fusion$Update$EtapeAtteinte = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Referentiel$Fusion$Model$EtapeChamps = 1;
var $author$project$Components$Referentiel$Fusion$Model$EtapeRecapitulatif = 3;
var $author$project$Components$Referentiel$Fusion$Model$EtapeReunion = 2;
var $author$project$Components$Referentiel$Fusion$Update$FusionConfirmee = {$: 18};
var $author$project$Components$Referentiel$Fusion$Update$FusionDemandee = {$: 16};
var $author$project$I18n$Cles$referentielFusionAnnuler = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.annuler', _List_Nil, 'Annuler');
};
var $author$project$I18n$Cles$referentielFusionInterrompueReprendre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.interrompue.reprendre', _List_Nil, 'Reprendre la fusion');
};
var $author$project$I18n$Cles$referentielFusionPrecedent = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.precedent', _List_Nil, 'Précédent');
};
var $author$project$I18n$Cles$referentielFusionRecapFusionner = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.recap.fusionner', _List_Nil, 'Fusionner…');
};
var $author$project$I18n$Cles$referentielFusionSuivant = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.suivant', _List_Nil, 'Suivant');
};
var $author$project$I18n$Cles$referentielFusionImpossibleRetour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.impossible.retour', _List_Nil, 'Retour à la fiche');
};
var $author$project$Components$Referentiel$Fusion$View$retour = F2(
	function (i18n, depart) {
		return A3(
			$author$project$Components$Shared$Bouton$View$lien,
			1,
			$author$project$Routes$Route$toString(
				A2($author$project$Routes$Route$Fiche, depart.r8, 0)),
			$author$project$I18n$Cles$referentielFusionImpossibleRetour(i18n));
	});
var $author$project$Components$Referentiel$Fusion$View$actions = F4(
	function (i18n, model, depart, refuse) {
		var suivant = function (cible) {
			return A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				0,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Referentiel$Fusion$Update$EtapeAtteinte(cible))
					]),
				$author$project$I18n$Cles$referentielFusionSuivant(i18n));
		};
		var precedent = function (cible) {
			return A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Referentiel$Fusion$Update$EtapeAtteinte(cible))
					]),
				$author$project$I18n$Cles$referentielFusionPrecedent(i18n));
		};
		var annuler = A3(
			$author$project$Components$Shared$Bouton$View$lien,
			1,
			$author$project$Routes$Route$toString(
				A2($author$project$Routes$Route$Fiche, depart.r8, 0)),
			$author$project$I18n$Cles$referentielFusionAnnuler(i18n));
		if (refuse) {
			return _List_fromArray(
				[
					A2($author$project$Components$Referentiel$Fusion$View$retour, i18n, depart)
				]);
		} else {
			var _v0 = model.me;
			switch (_v0) {
				case 0:
					return _List_fromArray(
						[
							annuler,
							suivant(1)
						]);
				case 1:
					return _List_fromArray(
						[
							precedent(0),
							suivant(2)
						]);
				case 2:
					return _List_fromArray(
						[
							precedent(1),
							suivant(3)
						]);
				default:
					return _Utils_eq(model.l2, $author$project$Components$Referentiel$Fusion$Model$Interrompue) ? _List_fromArray(
						[
							annuler,
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							0,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Fusion$Update$FusionConfirmee)
								]),
							$author$project$I18n$Cles$referentielFusionInterrompueReprendre(i18n))
						]) : _List_fromArray(
						[
							precedent(2),
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							0,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Fusion$Update$FusionDemandee),
									$rtfeldman$elm_css$Html$Styled$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'loading',
											_Utils_eq(model.l2, $author$project$Components$Referentiel$Fusion$Model$EnCours))
										]))
								]),
							$author$project$I18n$Cles$referentielFusionRecapFusionner(i18n))
						]);
			}
		}
	});
var $author$project$I18n$Cles$referentielFusionConfirmationAnnuler = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.confirmation.annuler', _List_Nil, 'Annuler');
};
var $author$project$I18n$Cles$referentielFusionConfirmationConfirmer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.confirmation.confirmer', _List_Nil, 'Fusionner sans retour');
};
var $author$project$I18n$Cles$referentielFusionConfirmationMessage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fusion.confirmation.message',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'absorbee',
					$author$project$I18n$Traductions$Chaine(p.sK))
				]),
			'La fusion ne peut pas être annulée. Rien n\'est supprimé : « ' + (p.sK + ' » reste consultable, mais ne peut plus être modifiée.'));
	});
var $author$project$I18n$Cles$referentielFusionConfirmationTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fusion.confirmation.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'gardee',
					$author$project$I18n$Traductions$Chaine(p.z5)),
					_Utils_Tuple2(
					'absorbee',
					$author$project$I18n$Traductions$Chaine(p.sK))
				]),
			'Fusionner ' + (p.z5 + (' et ' + (p.sK + ' ?'))));
	});
var $author$project$I18n$Cles$referentielFusionConfirmationContacts = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fusion.confirmation.contacts',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' contact') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' contacts'));
	});
var $author$project$I18n$Cles$referentielFusionConfirmationRattachements = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fusion.confirmation.rattachements',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' rôle ou rattachement') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' rôles et rattachements'));
	});
var $author$project$I18n$Cles$referentielFusionConfirmationResume = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fusion.confirmation.resume',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'gardee',
					$author$project$I18n$Traductions$Chaine(p.z5)),
					_Utils_Tuple2(
					'contacts',
					$author$project$I18n$Traductions$Chaine(p.wa)),
					_Utils_Tuple2(
					'rattachements',
					$author$project$I18n$Traductions$Chaine(p.GY))
				]),
			'Fiche gardée : ' + (p.z5 + (' · ' + (p.wa + (', ' + (p.GY + '.'))))));
	});
var $author$project$Components$Referentiel$Fusion$View$resume = F3(
	function (i18n, gardeeFiche, absorbeeFiche) {
		return A2(
			$author$project$I18n$Cles$referentielFusionConfirmationResume,
			i18n,
			{
				wa: A2(
					$author$project$I18n$Cles$referentielFusionConfirmationContacts,
					i18n,
					{
						w: A2($author$project$Components$Referentiel$Fusion$Model$nombreDeContacts, gardeeFiche, absorbeeFiche)
					}),
				z5: A2($author$project$Components$Referentiel$Fusion$View$nomLong, i18n, gardeeFiche),
				GY: A2(
					$author$project$I18n$Cles$referentielFusionConfirmationRattachements,
					i18n,
					{
						w: $elm$core$List$length(
							A3(
								$author$project$Components$Referentiel$Fusion$Model$reunionDesRoles,
								$author$project$Components$Referentiel$Fusion$View$libelleDuRole(i18n),
								gardeeFiche,
								absorbeeFiche)) + $elm$core$List$length(
							A2($author$project$Components$Referentiel$Fusion$Model$reunionDesRattachements, gardeeFiche, absorbeeFiche))
					})
			});
	});
var $author$project$Components$Referentiel$Fusion$View$confirmation = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(
			$author$project$Components$Referentiel$Fusion$Model$gardee(model),
			$author$project$Components$Referentiel$Fusion$Model$absorbee(model));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var gardeeFiche = _v0.a.a;
			var absorbeeFiche = _v0.b.a;
			return A3(
				$author$project$Components$Shared$Confirmation$View$viewAvecResume,
				i18n,
				A3($author$project$Components$Referentiel$Fusion$View$resume, i18n, gardeeFiche, absorbeeFiche),
				{
					vl: $elm$json$Json$Decode$fail(''),
					j7: {
						Aq: 'confirmation-fusion-confirmer',
						Bl: $author$project$I18n$Cles$referentielFusionConfirmationConfirmer(i18n),
						C$: $author$project$Components$Referentiel$Fusion$Update$FusionConfirmee
					},
					Aq: 'confirmation-fusion',
					As: 'confirmation-fusion-message',
					At: 'confirmation-fusion-titre',
					Cs: A2(
						$author$project$I18n$Cles$referentielFusionConfirmationMessage,
						i18n,
						{
							sK: A2($author$project$Components$Referentiel$Fusion$View$nomLong, i18n, absorbeeFiche)
						}),
					Et: model.j6,
					HG: {
						Aq: 'confirmation-fusion-renoncer',
						Bl: $author$project$I18n$Cles$referentielFusionConfirmationAnnuler(i18n),
						C$: $author$project$Components$Referentiel$Fusion$Update$FusionAnnulee
					},
					h6: A2(
						$author$project$I18n$Cles$referentielFusionConfirmationTitre,
						i18n,
						{
							sK: A2($author$project$Components$Referentiel$Fusion$View$nomLong, i18n, absorbeeFiche),
							z5: A2($author$project$Components$Referentiel$Fusion$View$nomLong, i18n, gardeeFiche)
						}),
					sl: 1
				});
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$referentielFusionFil = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.fil', _List_Nil, 'Fusion');
};
var $author$project$Components$Referentiel$Fusion$View$fil = F2(
	function (i18n, depart) {
		return _List_fromArray(
			[
				{
				aa: $author$project$Routes$Route$adressePartiesPrenantes,
				Dj: $author$project$I18n$Cles$referentielPartiesPrenantesTitre(i18n)
			},
				{
				aa: $author$project$Routes$Route$toString(
					A2($author$project$Routes$Route$Fiche, depart.r8, 0)),
				Dj: A2($author$project$Components$Referentiel$Fusion$View$nomLong, i18n, depart)
			},
				{
				aa: '',
				Dj: $author$project$I18n$Cles$referentielFusionFil(i18n)
			}
			]);
	});
var $author$project$Components$Referentiel$Fusion$View$natureDe = F2(
	function (i18n, nature) {
		if (!nature) {
			return $author$project$I18n$Cles$referentielNaturePersonne(i18n);
		} else {
			return $author$project$I18n$Cles$referentielNatureOrganisation(i18n);
		}
	});
var $author$project$Components$Referentiel$Fusion$View$natureDeLaFiche = function (fiche) {
	var _v0 = fiche.Av;
	if (!_v0.$) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$I18n$Cles$referentielFusionEtapeChamps = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.etape.champs', _List_Nil, '2 · Champs');
};
var $author$project$I18n$Cles$referentielFusionEtapeGardee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.etape.gardee', _List_Nil, '1 · Fiche gardée');
};
var $author$project$I18n$Cles$referentielFusionEtapeRecapitulatif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.etape.recapitulatif', _List_Nil, '4 · Récapitulatif');
};
var $author$project$I18n$Cles$referentielFusionEtapeReunion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.etape.reunion', _List_Nil, '3 · Contacts, rôles et rattachements');
};
var $author$project$Components$Referentiel$Fusion$View$onglets = F2(
	function (i18n, etape) {
		var un = F2(
			function (cible, libelle) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'active',
									_Utils_eq(etape, cible))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-current',
							_Utils_eq(etape, cible) ? 'step' : 'false'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Referentiel$Fusion$Update$EtapeAtteinte(cible))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						]));
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('tabs')
				]),
			_List_fromArray(
				[
					A2(
					un,
					0,
					$author$project$I18n$Cles$referentielFusionEtapeGardee(i18n)),
					A2(
					un,
					1,
					$author$project$I18n$Cles$referentielFusionEtapeChamps(i18n)),
					A2(
					un,
					2,
					$author$project$I18n$Cles$referentielFusionEtapeReunion(i18n)),
					A2(
					un,
					3,
					$author$project$I18n$Cles$referentielFusionEtapeRecapitulatif(i18n))
				]));
	});
var $author$project$I18n$Cles$referentielFusionSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fusion.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'gardee',
					$author$project$I18n$Traductions$Chaine(p.z5)),
					_Utils_Tuple2(
					'absorbee',
					$author$project$I18n$Traductions$Chaine(p.sK)),
					_Utils_Tuple2(
					'nature',
					$author$project$I18n$Traductions$Chaine(p.g1))
				]),
			p.z5 + (' et ' + (p.sK + (' · ' + p.g1))));
	});
var $author$project$I18n$Cles$referentielFusionTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.titre', _List_Nil, 'Fusionner deux fiches');
};
var $author$project$Components$Referentiel$Fusion$View$pageDe = F7(
	function (i18n, messages, model, premiere, seconde, refus, contenu) {
		var sousTitre = A2(
			$author$project$I18n$Cles$referentielFusionSousTitre,
			i18n,
			{
				sK: A2($author$project$Components$Referentiel$Fusion$View$nomLong, i18n, seconde),
				z5: A2($author$project$Components$Referentiel$Fusion$View$nomLong, i18n, premiere),
				g1: A2(
					$author$project$Components$Referentiel$Fusion$View$natureDe,
					i18n,
					$author$project$Components$Referentiel$Fusion$View$natureDeLaFiche(premiere))
			});
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'referentiel-fusion',
			{
				ut: A2(
					$elm$core$List$cons,
					A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
					A2(
						$elm$core$Maybe$withDefault,
						contenu,
						A2($elm$core$Maybe$map, $elm$core$List$singleton, refus))),
				xy: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('opened', model.j6)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('overlay'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Fusion$Update$FusionAnnulee)
									]),
								_List_Nil),
								A2($author$project$Components$Referentiel$Fusion$View$confirmation, i18n, model)
							]))
					]),
				zM: A4(
					$author$project$Components$Referentiel$Fusion$View$actions,
					i18n,
					model,
					premiere,
					!_Utils_eq(refus, $elm$core$Maybe$Nothing)),
				AK: model.j6,
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('sous-titre')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(sousTitre)
									]))
							]),
						zE: A2($author$project$Components$Referentiel$Fusion$View$fil, i18n, premiere),
						Ef: _List_fromArray(
							[
								A2($author$project$Components$Referentiel$Fusion$View$onglets, i18n, model.me)
							]),
						h6: $author$project$I18n$Cles$referentielFusionTitre(i18n)
					})
			});
	});
var $author$project$Components$Referentiel$Fusion$View$pageNue = F3(
	function (i18n, messages, contenu) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'referentiel-fusion',
			{
				ut: A2(
					$elm$core$List$cons,
					A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
					contenu),
				xy: _List_Nil,
				zM: _List_Nil,
				AK: false,
				JD: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h1,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielFusionTitre(i18n))
							]))
					])
			});
	});
var $author$project$I18n$Cles$referentielFusionSansDroitDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.sans-droit.detail', _List_Nil, 'Ce geste demande le droit « Fusionner des fiches ». Demandez-le à un administrateur de votre espace.');
};
var $author$project$I18n$Cles$referentielFusionSansDroitTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.sans-droit.titre', _List_Nil, 'Vous ne pouvez pas fusionner des fiches');
};
var $author$project$Components$Referentiel$Fusion$View$pageSansDroit = F3(
	function (i18n, messages, depart) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'referentiel-fusion',
			{
				ut: _List_fromArray(
					[
						A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
						A2(
						$author$project$Components$Shared$Note$View$view,
						1,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielFusionSansDroitTitre(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielFusionSansDroitDetail(i18n))
									]))
							]))
					]),
				xy: _List_Nil,
				zM: _List_fromArray(
					[
						A2($author$project$Components$Referentiel$Fusion$View$retour, i18n, depart)
					]),
				AK: false,
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_Nil,
						zE: A2($author$project$Components$Referentiel$Fusion$View$fil, i18n, depart),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$referentielFusionTitre(i18n)
					})
			});
	});
var $author$project$I18n$Cles$referentielFusionImpossibleClose = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fusion.impossible.close',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Fusion impossible : « ' + (p.Dj + ' » est close'));
	});
var $author$project$I18n$Cles$referentielFusionImpossibleCloseLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fusion.impossible.close-le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Un collègue a clos cette fiche le ' + (p.wv + '.'));
	});
var $author$project$I18n$Cles$referentielFusionImpossibleDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.impossible.detail', _List_Nil, 'Rouvrez-la avant de fusionner, ou choisissez une autre fiche. Rien n\'a été modifié.');
};
var $author$project$I18n$Cles$referentielFusionImpossibleSupprimee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fusion.impossible.supprimee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Fusion impossible : « ' + (p.Dj + ' » est supprimée'));
	});
var $author$project$I18n$Cles$referentielFusionImpossibleSupprimeeLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fusion.impossible.supprimee-le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Un collègue a supprimé cette fiche le ' + (p.wv + '.'));
	});
var $author$project$Components$Referentiel$Fusion$View$refusDEtat = F4(
	function (i18n, model, place, etat) {
		var fiche = function () {
			if (!place) {
				return model.Gf;
			} else {
				return model.Iv;
			}
		}();
		var quand = function () {
			if (fiche.$ === 1) {
				var etatLe = fiche.a.yQ;
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						$author$project$Texte$Jour$horodateALHeure(i18n),
						etatLe));
			} else {
				return '';
			}
		}();
		var _v0 = function () {
			if (fiche.$ === 1) {
				var f = fiche.a;
				return _Utils_Tuple2(
					A2($author$project$Components$Referentiel$Fusion$View$nomLong, i18n, f),
					$elm$core$Maybe$Just(f.r8));
			} else {
				return _Utils_Tuple2('', $elm$core$Maybe$Nothing);
			}
		}();
		var nom = _v0.a;
		var uid = _v0.b;
		return A2(
			$author$project$Components$Shared$Note$View$view,
			1,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							(etat === 1) ? A2(
								$author$project$I18n$Cles$referentielFusionImpossibleClose,
								i18n,
								{Dj: nom}) : A2(
								$author$project$I18n$Cles$referentielFusionImpossibleSupprimee,
								i18n,
								{Dj: nom}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							_Utils_ap(
								(quand === '') ? '' : ((etat === 1) ? (A2(
									$author$project$I18n$Cles$referentielFusionImpossibleCloseLe,
									i18n,
									{wv: quand}) + ' ') : (A2(
									$author$project$I18n$Cles$referentielFusionImpossibleSupprimeeLe,
									i18n,
									{wv: quand}) + ' ')),
								$author$project$I18n$Cles$referentielFusionImpossibleDetail(i18n)))
						])),
					function () {
					if (!uid.$) {
						var u = uid.a;
						return A4(
							$author$project$Components$Shared$Bouton$View$lienAvec,
							2,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('ouvrir')
								]),
							$author$project$Routes$Route$toString(
								A2($author$project$Routes$Route$Fiche, u, 0)),
							A2(
								$author$project$I18n$Cles$referentielFusionImpossibleOuvrir,
								i18n,
								{Dj: nom}));
					} else {
						return $rtfeldman$elm_css$Html$Styled$text('');
					}
				}()
				]));
	});
var $author$project$Components$Referentiel$Fusion$Model$refusDeLEtat = function (model) {
	var refus = F2(
		function (place, lecture) {
			if (lecture.$ === 1) {
				var fiche = lecture.a;
				return ((fiche.gt === 1) || (fiche.gt === 2)) ? $elm$core$Maybe$Just(
					_Utils_Tuple2(place, fiche.gt)) : $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
	var _v0 = A2(refus, 1, model.Iv);
	if (!_v0.$) {
		var trouve = _v0.a;
		return $elm$core$Maybe$Just(trouve);
	} else {
		return A2(refus, 0, model.Gf);
	}
};
var $author$project$Components$Referentiel$Fusion$View$view = F3(
	function (i18n, messages, model) {
		var _v0 = _Utils_Tuple2(model.Gf, model.Iv);
		_v0$2:
		while (true) {
			_v0$3:
			while (true) {
				switch (_v0.a.$) {
					case 1:
						switch (_v0.b.$) {
							case 1:
								var premiere = _v0.a.a;
								var seconde = _v0.b.a;
								var _v1 = _Utils_Tuple2(
									$author$project$Components$Referentiel$Fusion$Model$refusDeLEtat(model),
									A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$fusionner, premiere.nQ.h0));
								if (!_v1.a.$) {
									var _v2 = _v1.a.a;
									var place = _v2.a;
									var etat = _v2.b;
									return A7(
										$author$project$Components$Referentiel$Fusion$View$pageDe,
										i18n,
										messages,
										model,
										premiere,
										seconde,
										$elm$core$Maybe$Just(
											A4($author$project$Components$Referentiel$Fusion$View$refusDEtat, i18n, model, place, etat)),
										_List_Nil);
								} else {
									if (_v1.b.$ === 1) {
										var _v3 = _v1.a;
										var _v4 = _v1.b;
										return A3($author$project$Components$Referentiel$Fusion$View$pageSansDroit, i18n, messages, premiere);
									} else {
										var _v5 = _v1.a;
										return A7(
											$author$project$Components$Referentiel$Fusion$View$pageDe,
											i18n,
											messages,
											model,
											premiere,
											seconde,
											$elm$core$Maybe$Nothing,
											A4(
												$author$project$Components$Referentiel$Fusion$View$etapeDe,
												i18n,
												model,
												A2(
													$elm$core$Maybe$withDefault,
													premiere,
													$author$project$Components$Referentiel$Fusion$Model$gardee(model)),
												A2(
													$elm$core$Maybe$withDefault,
													seconde,
													$author$project$Components$Referentiel$Fusion$Model$absorbee(model))));
									}
								}
							case 0:
								break _v0$2;
							default:
								break _v0$3;
						}
					case 0:
						var _v6 = _v0.a;
						return A3($author$project$Components$Referentiel$Fusion$View$pageNue, i18n, messages, _List_Nil);
					default:
						if (!_v0.b.$) {
							break _v0$2;
						} else {
							break _v0$3;
						}
				}
			}
			return A2(
				$author$project$Components$Shared$Introuvable$View$view,
				i18n,
				{
					aa: $author$project$Routes$Route$adressePartiesPrenantes,
					Bl: $author$project$I18n$Cles$referentielFicheRetour(i18n)
				});
		}
		var _v7 = _v0.b;
		return A3($author$project$Components$Referentiel$Fusion$View$pageNue, i18n, messages, _List_Nil);
	});
var $author$project$Components$Referentiel$Groupe$Update$AjoutDemande = {$: 18};
var $author$project$Components$Referentiel$Groupe$Update$EntreeSaisie = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Referentiel$Groupe$Update$RechercheSaisie = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Referentiel$Groupe$Update$PropositionCochee = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Referentiel$Groupe$View$proposition = F3(
	function (i18n, saisie, proposee) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Champ$View$caseACocher,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: 'ajout-' + $author$project$Components$Referentiel$Identifiants$entiteUidToString(proposee.r8),
						Bl: A2($author$project$I18n$Cles$texte, i18n, proposee.Dj),
						he: false
					},
					{
						vt: A2(
							$elm$core$List$any,
							function (choisie) {
								return _Utils_eq(choisie.r8, proposee.r8);
							},
							saisie.L),
						D9: function (_v0) {
							return $author$project$Components$Referentiel$Groupe$Update$PropositionCochee(proposee.r8);
						}
					})
				]));
	});
var $author$project$I18n$Cles$referentielGroupeAjoutAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.ajout.action', _List_Nil, 'Ajouter');
};
var $author$project$I18n$Cles$referentielGroupeAjoutEntree = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.ajout.entree', _List_Nil, 'Date d\'entrée');
};
var $author$project$I18n$Cles$referentielGroupeAjoutEntreeManquante = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.ajout.entree-manquante', _List_Nil, 'Indiquez la date d\'entrée.');
};
var $author$project$I18n$Cles$referentielGroupeAjoutFicheManquante = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.ajout.fiche-manquante', _List_Nil, 'Cochez au moins une fiche.');
};
var $author$project$I18n$Cles$referentielGroupeAjoutRecherche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.ajout.recherche', _List_Nil, 'Rechercher une fiche');
};
var $author$project$I18n$Cles$referentielGroupeAjoutTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.ajout.titre', _List_Nil, 'Ajouter des fiches');
};
var $author$project$Components$Referentiel$Groupe$View$avantEntree = function (detail) {
	return _Utils_eq(
		detail,
		$author$project$API$Reponse$Metier('SortieAvantEntree')) || _Utils_eq(
		detail,
		$author$project$API$Reponse$Metier('PasMembre'));
};
var $author$project$Components$Referentiel$Groupe$View$entreeDuMembreEnRetrait = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		$elm$core$Basics$identity,
		A3(
			$elm$core$Maybe$map2,
			F2(
				function (saisie, fiche) {
					return $elm$core$List$head(
						A2(
							$elm$core$List$map,
							function ($) {
								return $.xe;
							},
							A2(
								$elm$core$List$filter,
								function (m) {
									return _Utils_eq(m.zo, saisie.Cl);
								},
								fiche.Cm)));
				}),
			model.eW,
			model.zo));
};
var $author$project$I18n$Textes$referentielGroupeAjoutDejaMembre = A3($author$project$I18n$Traductions$texte, 'referentiel.groupe.ajout.deja-membre', _List_Nil, 'Une des fiches est déjà membre du groupe à cette date. Décochez-la, puis recommencez.');
var $author$project$I18n$Textes$referentielGroupeErreurArchive = A3($author$project$I18n$Traductions$texte, 'referentiel.groupe.erreur.archive', _List_Nil, 'Ce groupe a été archivé : il ne se modifie plus. Rechargez la page pour le voir tel qu\'il est.');
var $author$project$I18n$Textes$referentielGroupeErreurFicheInconnue = A3($author$project$I18n$Traductions$texte, 'referentiel.groupe.erreur.fiche-inconnue', _List_Nil, 'Une des fiches choisies n\'existe plus. Retirez-la de votre sélection, puis recommencez.');
var $author$project$I18n$Textes$referentielGroupeRetraitAvantEntree = function (p) {
	return A3(
		$author$project$I18n$Traductions$texte,
		'referentiel.groupe.retrait.avant-entree',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'date',
				$author$project$I18n$Traductions$Sous(p.wv))
			]),
		'Cette fiche n\'est membre qu\'à partir du {date} : choisissez une date de sortie à partir de cette date.');
};
var $author$project$Components$Referentiel$Groupe$View$messageDuRefus = F3(
	function (i18n, model, refus_) {
		return ((refus_.ri === 409) && _Utils_eq(
			refus_.bB,
			$author$project$API$Reponse$Metier('DejaMembre'))) ? {Jx: $author$project$I18n$Textes$referentielGroupeAjoutDejaMembre, b9: refus_.b9} : (((refus_.ri === 409) && _Utils_eq(
			refus_.bB,
			$author$project$API$Reponse$Metier('GroupeEstArchive'))) ? {Jx: $author$project$I18n$Textes$referentielGroupeErreurArchive, b9: refus_.b9} : (((refus_.ri === 422) && _Utils_eq(
			refus_.bB,
			$author$project$API$Reponse$Metier('FicheInconnue'))) ? {Jx: $author$project$I18n$Textes$referentielGroupeErreurFicheInconnue, b9: refus_.b9} : (((refus_.ri === 409) && $author$project$Components$Referentiel$Groupe$View$avantEntree(refus_.bB)) ? A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$Shared$Messages$Model$duRefus(refus_),
			A2(
				$elm$core$Maybe$map,
				function (depuis) {
					return {
						Jx: $author$project$I18n$Textes$referentielGroupeRetraitAvantEntree(
							{
								wv: $author$project$I18n$Traductions$tel(
									A2($author$project$Texte$Jour$enFrancaisCourt, i18n, depuis))
							}),
						b9: refus_.b9
					};
				},
				$author$project$Components$Referentiel$Groupe$View$entreeDuMembreEnRetrait(model))) : $author$project$Components$Shared$Messages$Model$duRefus(refus_))));
	});
var $author$project$Components$Referentiel$Groupe$View$refus = F2(
	function (i18n, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					A2($author$project$Components$Referentiel$Groupe$View$messageDuRefus, i18n, model),
					$elm$core$List$singleton),
				model.pZ));
	});
var $author$project$Components$Referentiel$Groupe$View$ajout = F2(
	function (i18n, model) {
		var ouvert = model.fw;
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$Groupe$Update$DuAjout,
			{
				fs: {
					sR: !_Utils_eq(ouvert, $elm$core$Maybe$Nothing),
					Bl: $author$project$I18n$Cles$referentielGroupeAjoutAction(i18n),
					C$: $author$project$Components$Referentiel$Groupe$Update$AjoutDemande
				},
				fZ: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (saisie) {
							return _List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Champ$View$texte,
									{
										go: (saisie.b5 && $elm$core$List$isEmpty(saisie.L)) ? $elm$core$Maybe$Just(
											$author$project$I18n$Cles$referentielGroupeAjoutFicheManquante(i18n)) : $elm$core$Maybe$Nothing,
										Aq: $author$project$Components$Referentiel$Groupe$Model$idDeLAjout,
										Bl: $author$project$I18n$Cles$referentielGroupeAjoutRecherche(i18n),
										he: false
									},
									{
										hg: $author$project$Components$Referentiel$Groupe$Update$RechercheSaisie,
										fm: A2($author$project$Components$Referentiel$Common$RechercheDeFiche$valeurDuChamp, i18n, saisie.hC)
									}),
									A2(
									$rtfeldman$elm_css$Html$Styled$ul,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('propositions')
										]),
									A2(
										$elm$core$List$map,
										A2($author$project$Components$Referentiel$Groupe$View$proposition, i18n, saisie),
										saisie.hC.Gw)),
									A2(
									$author$project$Components$Shared$Champ$View$date,
									{
										go: (saisie.b5 && $elm$core$String$isEmpty(saisie.l1)) ? $elm$core$Maybe$Just(
											$author$project$I18n$Cles$referentielGroupeAjoutEntreeManquante(i18n)) : $elm$core$Maybe$Nothing,
										Aq: 'groupe-entree',
										Bl: $author$project$I18n$Cles$referentielGroupeAjoutEntree(i18n),
										he: true
									},
									{hg: $author$project$Components$Referentiel$Groupe$Update$EntreeSaisie, fm: saisie.l1}),
									A2(
									$author$project$Components$Shared$Messages$View$view,
									i18n,
									A2($author$project$Components$Referentiel$Groupe$View$refus, i18n, model))
								]);
						},
						ouvert)),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$referentielGroupeAjoutTitre(i18n)
			},
			model.iH);
	});
var $author$project$Components$Referentiel$Groupe$Update$ResponsableChoisi = function (a) {
	return {$: 25, a: a};
};
var $author$project$Components$Referentiel$Groupe$Update$ResponsableDemande = {$: 26};
var $author$project$Components$Referentiel$Common$Equipe$candidats = function (equipe) {
	if (!equipe.$) {
		return _List_Nil;
	} else {
		var membres = equipe.a;
		return membres;
	}
};
var $author$project$I18n$Cles$referentielGroupeResponsableChangementAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.responsable-changement.action', _List_Nil, 'Changer le responsable');
};
var $author$project$I18n$Cles$referentielGroupeResponsableChangementAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.responsable-changement.aucun', _List_Nil, 'Choisissez un membre de l\'équipe');
};
var $author$project$I18n$Cles$referentielGroupeResponsableChangementChamp = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.responsable-changement.champ', _List_Nil, 'Nouveau responsable');
};
var $author$project$I18n$Cles$referentielGroupeResponsableChangementIndisponible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.responsable-changement.indisponible', _List_Nil, 'L\'équipe n\'a pas pu être lue : le responsable ne peut pas être choisi pour l\'instant.');
};
var $author$project$I18n$Cles$referentielGroupeResponsableChangementManquant = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.responsable-changement.manquant', _List_Nil, 'Choisissez le nouveau responsable.');
};
var $author$project$I18n$Cles$referentielGroupeResponsableChangementTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.responsable-changement.titre', _List_Nil, 'Changer le responsable');
};
var $author$project$Components$Referentiel$Groupe$View$changementDeResponsable = F2(
	function (i18n, model) {
		var ouvert = model.cs;
		var candidats = $author$project$Components$Referentiel$Common$Equipe$candidats(model.l5);
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$Groupe$Update$DuChangementDeResponsable,
			{
				fs: {
					sR: (!_Utils_eq(ouvert, $elm$core$Maybe$Nothing)) && (!$elm$core$List$isEmpty(candidats)),
					Bl: $author$project$I18n$Cles$referentielGroupeResponsableChangementAction(i18n),
					C$: $author$project$Components$Referentiel$Groupe$Update$ResponsableDemande
				},
				fZ: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (saisie) {
							return $elm$core$List$isEmpty(candidats) ? _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('indisponible')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$referentielGroupeResponsableChangementIndisponible(i18n))
										]))
								]) : _List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Champ$View$liste,
									{
										go: (saisie.b5 && $elm$core$String$isEmpty(saisie.qB)) ? $elm$core$Maybe$Just(
											$author$project$I18n$Cles$referentielGroupeResponsableChangementManquant(i18n)) : $elm$core$Maybe$Nothing,
										Aq: 'groupe-responsable',
										Bl: $author$project$I18n$Cles$referentielGroupeResponsableChangementChamp(i18n),
										he: true
									},
									{
										hg: $author$project$Components$Referentiel$Groupe$Update$ResponsableChoisi,
										o_: A2(
											$elm$core$List$cons,
											{
												Bl: $author$project$I18n$Cles$referentielGroupeResponsableChangementAucun(i18n),
												fm: ''
											},
											A2(
												$elm$core$List$map,
												function (c) {
													return {Bl: c.Dj, fm: c.r8};
												},
												candidats)),
										fm: saisie.qB
									}),
									A2(
									$author$project$Components$Shared$Messages$View$view,
									i18n,
									A2($author$project$Components$Referentiel$Groupe$View$refus, i18n, model))
								]);
						},
						ouvert)),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$referentielGroupeResponsableChangementTitre(i18n)
			},
			model.jH);
	});
var $author$project$Components$Referentiel$Groupe$Update$ArchivageConfirme = {$: 29};
var $author$project$Components$Referentiel$Groupe$Update$FocusDemande = function (a) {
	return {$: 30, a: a};
};
var $author$project$Components$Referentiel$Groupe$Update$clavierDeLaConfirmation = function () {
	var ids = $author$project$Components$Referentiel$Groupe$Model$idsDeLaConfirmation;
	return A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			var touche = _v0.a;
			var maj = _v0.b;
			var vers = _v0.c;
			return (touche !== 'Tab') ? $elm$json$Json$Decode$fail('') : ((maj && A2(
				$elm$core$List$member,
				vers,
				_List_fromArray(
					[ids.GN, ids.Cs]))) ? $elm$json$Json$Decode$succeed(
				_Utils_Tuple2(
					$author$project$Components$Referentiel$Groupe$Update$FocusDemande(ids.j7),
					true)) : (((!maj) && A2(
				$elm$core$List$member,
				vers,
				_List_fromArray(
					[ids.GN, ids.j7]))) ? $elm$json$Json$Decode$succeed(
				_Utils_Tuple2(
					$author$project$Components$Referentiel$Groupe$Update$FocusDemande(ids.Cs),
					true)) : $elm$json$Json$Decode$fail('')));
		},
		A4(
			$elm$json$Json$Decode$map3,
			F3(
				function (touche, maj, vers) {
					return _Utils_Tuple3(touche, maj, vers);
				}),
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['target', 'id']),
				$elm$json$Json$Decode$string)));
}();
var $author$project$I18n$Cles$referentielGroupeArchivageAnnuler = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.archivage.annuler', _List_Nil, 'Annuler');
};
var $author$project$I18n$Cles$referentielGroupeArchivageConfirmer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.archivage.confirmer', _List_Nil, 'Archiver');
};
var $author$project$I18n$Cles$referentielGroupeArchivageMessage = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.archivage.message', _List_Nil, 'Le groupe ne se modifie plus et ne paraît dans l\'annuaire que parmi les archives.');
};
var $author$project$I18n$Cles$referentielGroupeArchivageTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.groupe.archivage.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Archiver « ' + (p.Dj + ' » ?'));
	});
var $author$project$Components$Referentiel$Groupe$View$confirmation = F3(
	function (i18n, model, fiche) {
		var ids = $author$project$Components$Referentiel$Groupe$Model$idsDeLaConfirmation;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('opened', model.ir)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('overlay'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Groupe$Update$ArchivageAnnule)
						]),
					_List_Nil),
					A2(
					$author$project$Components$Shared$Confirmation$View$view,
					i18n,
					{
						vl: $author$project$Components$Referentiel$Groupe$Update$clavierDeLaConfirmation,
						j7: {
							Aq: ids.j7,
							Bl: $author$project$I18n$Cles$referentielGroupeArchivageConfirmer(i18n),
							C$: $author$project$Components$Referentiel$Groupe$Update$ArchivageConfirme
						},
						Aq: ids.GN,
						As: ids.Cs,
						At: ids.h6,
						Cs: $author$project$I18n$Cles$referentielGroupeArchivageMessage(i18n),
						Et: model.ir,
						HG: {
							Aq: ids.to,
							Bl: $author$project$I18n$Cles$referentielGroupeArchivageAnnuler(i18n),
							C$: $author$project$Components$Referentiel$Groupe$Update$ArchivageAnnule
						},
						h6: A2(
							$author$project$I18n$Cles$referentielGroupeArchivageTitre,
							i18n,
							{Dj: fiche.Dj}),
						sl: 0
					})
				]));
	});
var $author$project$Components$Referentiel$Groupe$Update$CriteresEnregistres = {$: 36};
var $author$project$Components$Referentiel$Groupe$Update$ProposesBascules = {$: 38};
var $author$project$Components$Referentiel$Groupe$View$gras = function (texte) {
	return A2(
		$elm$core$List$indexedMap,
		F2(
			function (rang, morceau) {
				return (A2($elm$core$Basics$modBy, 2, rang) === 1) ? A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(morceau)
						])) : $rtfeldman$elm_css$Html$Styled$text(morceau);
			}),
		A2($elm$core$String$split, '*', texte));
};
var $author$project$Components$Referentiel$Groupe$Update$CritereRetire = function (a) {
	return {$: 33, a: a};
};
var $author$project$I18n$Cles$referentielGroupeCriteresTypeNature = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.criteres.type.nature', _List_Nil, 'Nature');
};
var $author$project$I18n$Cles$referentielGroupeCriteresTypeQualite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.criteres.type.qualite', _List_Nil, 'Qualité');
};
var $author$project$I18n$Cles$referentielGroupeCriteresTypeRoleNonOuvert = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.criteres.type.role-non-ouvert', _List_Nil, 'Rôle non ouvert');
};
var $author$project$I18n$Cles$referentielGroupeCriteresTypeRoleOuvert = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.criteres.type.role-ouvert', _List_Nil, 'Rôle ouvert');
};
var $author$project$Components$Referentiel$Groupe$View$nomDuCritere = F2(
	function (i18n, critere) {
		switch (critere.$) {
			case 0:
				return $author$project$I18n$Cles$referentielGroupeCriteresTypeNature(i18n);
			case 1:
				return $author$project$I18n$Cles$referentielGroupeCriteresTypeQualite(i18n);
			case 2:
				return $author$project$I18n$Cles$referentielGroupeCriteresTypeRoleOuvert(i18n);
			default:
				return $author$project$I18n$Cles$referentielGroupeCriteresTypeRoleNonOuvert(i18n);
		}
	});
var $author$project$I18n$Cles$referentielGroupeCriteresEt = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.criteres.et', _List_Nil, 'et');
};
var $author$project$I18n$Cles$referentielGroupeCriteresRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.criteres.retirer', _List_Nil, 'Retirer');
};
var $author$project$Components$Referentiel$Groupe$Update$CritereRemplace = F2(
	function (a, b) {
		return {$: 34, a: a, b: b};
	});
var $author$project$Components$Referentiel$Groupe$Model$Nature = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$Groupe$Model$Qualite = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Groupe$Model$RoleNonOuvert = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Referentiel$Groupe$Model$RoleOuvert = function (a) {
	return {$: 2, a: a};
};
var $author$project$I18n$Cles$referentielAdmissionOrganisation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.admission.organisation', _List_Nil, 'Une organisation');
};
var $author$project$I18n$Cles$referentielAdmissionPersonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.admission.personne', _List_Nil, 'Une personne');
};
var $author$project$Components$Referentiel$Admission$libelleDeNature = F2(
	function (i18n, nature) {
		if (!nature) {
			return $author$project$I18n$Cles$referentielAdmissionPersonne(i18n);
		} else {
			return $author$project$I18n$Cles$referentielAdmissionOrganisation(i18n);
		}
	});
var $author$project$I18n$Cles$referentielAdmissionParticulier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.admission.particulier', _List_Nil, 'Un particulier');
};
var $author$project$I18n$Cles$referentielAdmissionProfessionnel = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.admission.professionnel', _List_Nil, 'Un professionnel');
};
var $author$project$Components$Referentiel$Admission$libelleDeQualite = F2(
	function (i18n, qualite) {
		if (!qualite) {
			return $author$project$I18n$Cles$referentielAdmissionParticulier(i18n);
		} else {
			return $author$project$I18n$Cles$referentielAdmissionProfessionnel(i18n);
		}
	});
var $author$project$Components$Referentiel$Groupe$View$valeurs = F2(
	function (i18n, critere) {
		var remplacer = F3(
			function (fabrique, ancien, code) {
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Components$Referentiel$Groupe$Update$FocusDemande(''),
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							fabrique,
							$author$project$Components$Referentiel$Groupe$Update$CritereRemplace(ancien)),
						$author$project$Components$Referentiel$Archetype$fromCode(code)));
			});
		var qualites = A2(
			$elm$core$List$map,
			function (q) {
				return {
					Bl: A2($author$project$Components$Referentiel$Admission$libelleDeQualite, i18n, q),
					fm: $author$project$Components$Referentiel$Admission$codeDeQualite(q)
				};
			},
			$author$project$Components$Referentiel$Admission$qualites);
		var natures = A2(
			$elm$core$List$map,
			function (n) {
				return {
					Bl: A2($author$project$Components$Referentiel$Admission$libelleDeNature, i18n, n),
					fm: $author$project$Components$Referentiel$Admission$codeDeNature(n)
				};
			},
			$author$project$Components$Referentiel$Admission$natures);
		var archetypes = A2(
			$elm$core$List$map,
			function (a) {
				return {
					Bl: A2(
						$author$project$I18n$Cles$texte,
						i18n,
						$author$project$Components$Referentiel$Archetype$libelle(a)),
					fm: $author$project$Components$Referentiel$Archetype$code(a)
				};
			},
			$author$project$Components$Referentiel$Archetype$tous);
		switch (critere.$) {
			case 0:
				var valeur = critere.a;
				return {
					hg: A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Referentiel$Groupe$Model$Nature,
						$author$project$Components$Referentiel$Groupe$Update$CritereRemplace(critere)),
					o_: natures,
					fm: valeur
				};
			case 1:
				var valeur = critere.a;
				return {
					hg: A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Referentiel$Groupe$Model$Qualite,
						$author$project$Components$Referentiel$Groupe$Update$CritereRemplace(critere)),
					o_: qualites,
					fm: valeur
				};
			case 2:
				var role = critere.a;
				return {
					hg: A2(remplacer, $author$project$Components$Referentiel$Groupe$Model$RoleOuvert, critere),
					o_: archetypes,
					fm: $author$project$Components$Referentiel$Archetype$code(role)
				};
			default:
				var role = critere.a;
				return {
					hg: A2(remplacer, $author$project$Components$Referentiel$Groupe$Model$RoleNonOuvert, critere),
					o_: archetypes,
					fm: $author$project$Components$Referentiel$Archetype$code(role)
				};
		}
	});
var $author$project$Components$Referentiel$Groupe$View$ligneDeCritere = F3(
	function (i18n, rang, critere) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('critere')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('et')
						]),
					(!rang) ? _List_Nil : _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielGroupeCriteresEt(i18n))
								]))
						])),
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: 'groupe-critere-' + $elm$core$String$fromInt(rang),
						Bl: A2($author$project$Components$Referentiel$Groupe$View$nomDuCritere, i18n, critere),
						he: false
					},
					A2($author$project$Components$Referentiel$Groupe$View$valeurs, i18n, critere)),
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer-le-critere'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Referentiel$Groupe$Update$CritereRetire(critere))
						]),
					$author$project$I18n$Cles$referentielGroupeCriteresRetirer(i18n))
				]));
	});
var $author$project$Components$Referentiel$Groupe$View$nomDuPays = F2(
	function (normes, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2($elm$core$Maybe$withDefault, '', code),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Dj;
				},
				A2(
					$elm$core$Maybe$andThen,
					function (c) {
						return $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (pays) {
									return _Utils_eq(pays.vx, c);
								},
								$author$project$Referentiel$Normes$entreesDePays(normes)));
					},
					code)));
	});
var $author$project$I18n$Cles$referentielGroupeCriteresPays = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.groupe.criteres.pays',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			'Le *pays* est : ' + p.fm);
	});
var $author$project$I18n$Cles$referentielGroupeCriteresPaysLectureSeule = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.criteres.pays-lecture-seule', _List_Nil, 'Lecture seule · non modifiable ici');
};
var $author$project$Components$Referentiel$Groupe$View$lignePaysEnLectureSeule = F4(
	function (i18n, normes, rang, code) {
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$li,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('critere'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('pays-lecture-seule')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('et')
							]),
						(!rang) ? _List_Nil : _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielGroupeCriteresEt(i18n))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('phrase')
							]),
						$author$project$Components$Referentiel$Groupe$View$gras(
							A2(
								$author$project$I18n$Cles$referentielGroupeCriteresPays,
								i18n,
								{
									fm: A2(
										$author$project$Components$Referentiel$Groupe$View$nomDuPays,
										normes,
										$elm$core$Maybe$Just(code))
								}))),
						A2(
						$author$project$Components$Shared$Tag$View$view,
						3,
						$author$project$I18n$Cles$referentielGroupeCriteresPaysLectureSeule(i18n))
					]))
			]);
	});
var $author$project$Components$Referentiel$Groupe$View$lignes = function (filtre) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					$elm$core$List$singleton,
					A2($elm$core$Maybe$map, $author$project$Components$Referentiel$Groupe$Model$Nature, filtre.g1))),
				A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					$elm$core$List$singleton,
					A2($elm$core$Maybe$map, $author$project$Components$Referentiel$Groupe$Model$Qualite, filtre.hy))),
				A2($elm$core$List$map, $author$project$Components$Referentiel$Groupe$Model$RoleOuvert, filtre.Id),
				A2($elm$core$List$map, $author$project$Components$Referentiel$Groupe$Model$RoleNonOuvert, filtre.Ic)
			]));
};
var $author$project$Components$Referentiel$Groupe$Update$CritereAjoute = function (a) {
	return {$: 32, a: a};
};
var $author$project$I18n$Cles$referentielGroupeCriteresProposeNature = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.criteres.propose.nature', _List_Nil, 'La *nature* de la fiche est : Personne ou Organisation');
};
var $author$project$I18n$Cles$referentielGroupeCriteresProposeQualite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.criteres.propose.qualite', _List_Nil, 'La *qualité* est : Professionnel ou Particulier');
};
var $author$project$I18n$Cles$referentielGroupeCriteresProposeRoleNonOuvert = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.criteres.propose.role-non-ouvert', _List_Nil, 'Le rôle *n\'est pas* ouvert : [type de rôle]');
};
var $author$project$I18n$Cles$referentielGroupeCriteresProposeRoleOuvert = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.criteres.propose.role-ouvert', _List_Nil, 'Le *rôle* est ouvert : [type de rôle]');
};
var $author$project$Components$Referentiel$Groupe$View$texteProposeDe = F2(
	function (i18n, critere) {
		switch (critere.$) {
			case 0:
				return $author$project$I18n$Cles$referentielGroupeCriteresProposeNature(i18n);
			case 1:
				return $author$project$I18n$Cles$referentielGroupeCriteresProposeQualite(i18n);
			case 2:
				return $author$project$I18n$Cles$referentielGroupeCriteresProposeRoleOuvert(i18n);
			default:
				return $author$project$I18n$Cles$referentielGroupeCriteresProposeRoleNonOuvert(i18n);
		}
	});
var $author$project$Components$Referentiel$Groupe$View$propose = F2(
	function (i18n, critere) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('propose'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Referentiel$Groupe$Update$CritereAjoute(critere))
						]),
					$author$project$Components$Referentiel$Groupe$View$gras(
						A2($author$project$Components$Referentiel$Groupe$View$texteProposeDe, i18n, critere)))
				]));
	});
var $author$project$I18n$Cles$referentielGroupeCriteresProposePays = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.criteres.propose.pays', _List_Nil, 'Le *pays* est : …');
};
var $author$project$Components$Referentiel$Groupe$View$proposePays = function (i18n) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$li,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('lecture-seule')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				$author$project$Components$Referentiel$Groupe$View$gras(
					$author$project$I18n$Cles$referentielGroupeCriteresProposePays(i18n))),
				A2(
				$author$project$Components$Shared$Tag$View$view,
				3,
				$author$project$I18n$Cles$referentielGroupeCriteresPaysLectureSeule(i18n))
			]));
};
var $author$project$Components$Referentiel$Groupe$Model$proposes = function (filtre) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_Utils_eq(filtre.g1, $elm$core$Maybe$Nothing) ? A2(
				$elm$core$List$map,
				A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Admission$codeDeNature, $author$project$Components$Referentiel$Groupe$Model$Nature),
				A2($elm$core$List$take, 1, $author$project$Components$Referentiel$Admission$natures)) : _List_Nil,
				_Utils_eq(filtre.hy, $elm$core$Maybe$Nothing) ? A2(
				$elm$core$List$map,
				A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Admission$codeDeQualite, $author$project$Components$Referentiel$Groupe$Model$Qualite),
				A2($elm$core$List$take, 1, $author$project$Components$Referentiel$Admission$qualites)) : _List_Nil,
				A2(
				$elm$core$List$map,
				$author$project$Components$Referentiel$Groupe$Model$RoleOuvert,
				A2(
					$elm$core$List$take,
					1,
					A2(
						$elm$core$List$filter,
						function (a) {
							return !A2($elm$core$List$member, a, filtre.Id);
						},
						$author$project$Components$Referentiel$Archetype$tous))),
				A2(
				$elm$core$List$map,
				$author$project$Components$Referentiel$Groupe$Model$RoleNonOuvert,
				A2(
					$elm$core$List$take,
					1,
					A2(
						$elm$core$List$filter,
						function (a) {
							return !A2($elm$core$List$member, a, filtre.Ic);
						},
						$author$project$Components$Referentiel$Archetype$tous)))
			]));
};
var $author$project$I18n$Cles$referentielGroupeCriteresAAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.criteres.a-ajouter', _List_Nil, 'Critères à ajouter');
};
var $author$project$I18n$Cles$referentielGroupeCriteresAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.criteres.ajouter', _List_Nil, '+ Critère');
};
var $author$project$I18n$Cles$referentielGroupeCriteresNombre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.groupe.criteres.nombre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'*' + (p.w + ' fiches correspondent aujourd\'hui*, recalculé à chaque usage. Les fiches sont celles de votre périmètre.'));
	});
var $author$project$I18n$Cles$referentielGroupeCriteresNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.criteres.note', _List_Nil, 'Les membres sont recalculés à chaque modification d\'une fiche. Un groupe dynamique ne garde que des critères de fiche ; la recherche texte libre reste dans la liste.');
};
var $author$project$I18n$Cles$referentielGroupeCriteresTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.criteres.titre', _List_Nil, 'Critères');
};
var $author$project$Components$Referentiel$Groupe$View$refusDesCriteres = F2(
	function (i18n, model) {
		return A2(
			$author$project$Components$Shared$Messages$View$view,
			i18n,
			A2($author$project$Components$Referentiel$Groupe$View$refus, i18n, model));
	});
var $author$project$Components$Referentiel$Groupe$View$contenuDesCriteres = F4(
	function (i18n, model, fiche, edition) {
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('groupe')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(fiche.Dj)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$section,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('criteres-saisis')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$h3,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielGroupeCriteresTitre(i18n))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('lignes-de-criteres')
							]),
						_Utils_ap(
							A2(
								$elm$core$List$indexedMap,
								$author$project$Components$Referentiel$Groupe$View$ligneDeCritere(i18n),
								$author$project$Components$Referentiel$Groupe$View$lignes(edition.zH)),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A3(
										$author$project$Components$Referentiel$Groupe$View$lignePaysEnLectureSeule,
										i18n,
										model.hd,
										$elm$core$List$length(
											$author$project$Components$Referentiel$Groupe$View$lignes(edition.zH))),
									edition.zH.ho)))),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout-de-critere')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('ajouter-un-critere'),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
										'aria-expanded',
										edition.Gv ? 'true' : 'false'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Groupe$Update$ProposesBascules)
									]),
								$author$project$I18n$Cles$referentielGroupeCriteresAjouter(i18n))
							]))
					])),
				edition.Gv ? A2(
				$rtfeldman$elm_css$Html$Styled$section,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('a-ajouter'),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-label',
						$author$project$I18n$Cles$referentielGroupeCriteresAAjouter(i18n))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_Nil,
						_Utils_ap(
							A2(
								$elm$core$List$map,
								$author$project$Components$Referentiel$Groupe$View$propose(i18n),
								$author$project$Components$Referentiel$Groupe$Model$proposes(edition.zH)),
							_List_fromArray(
								[
									$author$project$Components$Referentiel$Groupe$View$proposePays(i18n)
								])))
					])) : $rtfeldman$elm_css$Html$Styled$text(''),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('nombre'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
					]),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (n) {
							return $author$project$Components$Referentiel$Groupe$View$gras(
								A2(
									$author$project$I18n$Cles$referentielGroupeCriteresNombre,
									i18n,
									{
										w: $elm$core$String$fromInt(n)
									}));
						},
						edition.w))),
				A2($author$project$Components$Referentiel$Groupe$View$refusDesCriteres, i18n, model),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$referentielGroupeCriteresNote(i18n))
					]))
			]);
	});
var $author$project$I18n$Cles$referentielGroupeCriteresEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.criteres.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$referentielGroupeCriteresModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.criteres.modifier', _List_Nil, 'Modifier les critères');
};
var $author$project$Components$Referentiel$Groupe$View$drawerDesCriteres = F3(
	function (i18n, model, fiche) {
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$Groupe$Update$DesCriteres,
			{
				fs: {
					sR: !_Utils_eq(model.wp, $elm$core$Maybe$Nothing),
					Bl: $author$project$I18n$Cles$referentielGroupeCriteresEnregistrer(i18n),
					C$: $author$project$Components$Referentiel$Groupe$Update$CriteresEnregistres
				},
				fZ: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A3($author$project$Components$Referentiel$Groupe$View$contenuDesCriteres, i18n, model, fiche),
						model.wp)),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$referentielGroupeCriteresModifier(i18n)
			},
			model.kn);
	});
var $author$project$Components$Referentiel$Groupe$View$adresseDeLaListe = function (fiche) {
	return $author$project$Routes$Route$toString(
		$author$project$Routes$Route$PartiesPrenantesListe(
			_Utils_update(
				$author$project$Routes$Route$premierePage,
				{
					mG: _Utils_update(
						$author$project$Routes$Route$aucunFiltre,
						{
							m2: $elm$core$Maybe$Just(
								$author$project$Components$Referentiel$Identifiants$groupeUidToString(fiche.r8))
						})
				})));
};
var $author$project$Components$Referentiel$Groupe$View$nomDuMembre = F2(
	function (i18n, membre) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Referentiel$Common$RechercheDeFiche$nomDe,
					$author$project$I18n$Cles$texte(i18n)),
				membre.Av));
	});
var $author$project$Components$Referentiel$Groupe$View$lienDuMembre = F2(
	function (i18n, membre) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('nom'),
					$rtfeldman$elm_css$Html$Styled$Attributes$href(
					$author$project$Routes$Route$toString(
						A2($author$project$Routes$Route$Fiche, membre.zo, 0)))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2($author$project$Components$Referentiel$Groupe$View$nomDuMembre, i18n, membre))
				]));
	});
var $author$project$Components$Referentiel$Groupe$View$rolesDuMembre = function (membre) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ib;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map(
						function ($) {
							return $.Bl;
						}),
					$elm$core$String$join(' · '))),
			membre.Av));
};
var $author$project$Components$Referentiel$Groupe$View$apercu = F3(
	function (i18n, normes, membre) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('membre')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Components$Referentiel$Groupe$View$lienDuMembre, i18n, membre)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('qualite')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Components$Referentiel$Groupe$View$rolesDuMembre(membre))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('pays')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Referentiel$Groupe$View$nomDuPays, normes, membre.ho))
						]))
				]));
	});
var $author$project$Components$Referentiel$Groupe$Update$CriteresOuverts = {$: 31};
var $author$project$I18n$Cles$referentielGroupeCriteresAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.criteres.aucun', _List_Nil, 'Aucun critère : le groupe n\'a aucun membre. Ajoutez un critère pour le remplir.');
};
var $author$project$Components$Referentiel$Groupe$View$aucunCritere = function (i18n) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$li,
		_List_Nil,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$I18n$Cles$referentielGroupeCriteresAucun(i18n))
			]));
};
var $author$project$I18n$Cles$referentielGroupeCriteresNature = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.groupe.criteres.nature',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			'La *nature* de la fiche est : ' + p.fm);
	});
var $author$project$I18n$Cles$referentielGroupeCriteresQualite = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.groupe.criteres.qualite',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			'La *qualité* est : ' + p.fm);
	});
var $author$project$I18n$Cles$referentielGroupeCriteresRoleNonOuvert = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.groupe.criteres.role-non-ouvert',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'archetype',
					$author$project$I18n$Traductions$Chaine(p.fA))
				]),
			'Le rôle *n\'est pas* ouvert : ' + p.fA);
	});
var $author$project$I18n$Cles$referentielGroupeCriteresRoleOuvert = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.groupe.criteres.role-ouvert',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'archetype',
					$author$project$I18n$Traductions$Chaine(p.fA))
				]),
			'Le *rôle* est ouvert : ' + p.fA);
	});
var $author$project$Components$Referentiel$Groupe$View$roles = F3(
	function (i18n, cle, archetypes) {
		return $elm$core$List$isEmpty(archetypes) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			cle(
				{
					fA: A2(
						$elm$core$String$join,
						' · ',
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Components$Referentiel$Archetype$libelle,
								$author$project$I18n$Cles$texte(i18n)),
							archetypes))
				}));
	});
var $author$project$Components$Referentiel$Groupe$View$suite = F2(
	function (i18n, phrase) {
		var nue = A3($elm$core$String$replace, '*', '', phrase);
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$strong,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$referentielGroupeCriteresEt(i18n))
					])),
				$rtfeldman$elm_css$Html$Styled$text(
				' ' + ($elm$core$String$toLower(
					A2($elm$core$String$left, 1, nue)) + A2($elm$core$String$dropLeft, 1, nue)))
			]);
	});
var $author$project$Components$Referentiel$Groupe$View$phrases = F3(
	function (i18n, normes, filtre) {
		var textes = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					function (valeur) {
						return A2(
							$author$project$I18n$Cles$referentielGroupeCriteresNature,
							i18n,
							{fm: valeur});
					},
					filtre.g1),
					A2(
					$elm$core$Maybe$map,
					function (valeur) {
						return A2(
							$author$project$I18n$Cles$referentielGroupeCriteresQualite,
							i18n,
							{fm: valeur});
					},
					filtre.hy),
					A2(
					$elm$core$Maybe$map,
					function (valeur) {
						return A2(
							$author$project$I18n$Cles$referentielGroupeCriteresPays,
							i18n,
							{
								fm: A2(
									$author$project$Components$Referentiel$Groupe$View$nomDuPays,
									normes,
									$elm$core$Maybe$Just(valeur))
							});
					},
					filtre.ho),
					A3(
					$author$project$Components$Referentiel$Groupe$View$roles,
					i18n,
					$author$project$I18n$Cles$referentielGroupeCriteresRoleOuvert(i18n),
					filtre.Id),
					A3(
					$author$project$Components$Referentiel$Groupe$View$roles,
					i18n,
					$author$project$I18n$Cles$referentielGroupeCriteresRoleNonOuvert(i18n),
					filtre.Ic)
				]));
		return $elm$core$List$isEmpty(textes) ? _List_fromArray(
			[
				$author$project$Components$Referentiel$Groupe$View$aucunCritere(i18n)
			]) : A2(
			$elm$core$List$indexedMap,
			F2(
				function (rang, phrase) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						(!rang) ? $author$project$Components$Referentiel$Groupe$View$gras(phrase) : A2($author$project$Components$Referentiel$Groupe$View$suite, i18n, phrase));
				}),
			textes);
	});
var $author$project$Components$Referentiel$Groupe$View$criteres = F3(
	function (i18n, model, fiche) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('criteres')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielGroupeCriteresTitre(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('modifier')
								]),
							function () {
								var _v0 = $author$project$Components$Referentiel$Groupe$Model$modifierLeFiltre(model);
								if (!_v0.$) {
									return _List_fromArray(
										[
											A3(
											$author$project$Components$Shared$Bouton$View$bouton,
											1,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Groupe$Model$idDesCriteres),
													$rtfeldman$elm_css$Html$Styled$Attributes$class('modifier-les-criteres'),
													$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Groupe$Update$CriteresOuverts)
												]),
											$author$project$I18n$Cles$referentielGroupeCriteresModifier(i18n))
										]);
								} else {
									return _List_Nil;
								}
							}())
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('phrases')
						]),
					A2(
						$elm$core$Maybe$withDefault,
						_List_fromArray(
							[
								$author$project$Components$Referentiel$Groupe$View$aucunCritere(i18n)
							]),
						A2(
							$elm$core$Maybe$map,
							A2($author$project$Components$Referentiel$Groupe$View$phrases, i18n, model.hd),
							fiche.zH)))
				]));
	});
var $author$project$I18n$Cles$referentielGroupeApercuColonneFiche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.apercu.colonne-fiche', _List_Nil, 'Fiche');
};
var $author$project$I18n$Cles$referentielGroupeApercuColonnePays = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.apercu.colonne-pays', _List_Nil, 'Pays');
};
var $author$project$I18n$Cles$referentielGroupeApercuTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.apercu.titre', _List_Nil, 'Aperçu des membres');
};
var $author$project$I18n$Cles$referentielGroupeApercuVoir = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.groupe.apercu.voir',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Voir les ' + (p.w + ' fiches dans la liste'));
	});
var $author$project$I18n$Cles$referentielGroupeMembresColonneQualite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.membres.colonne-qualite', _List_Nil, 'Qualité');
};
var $author$project$Components$Referentiel$Groupe$View$dynamique = F3(
	function (i18n, model, fiche) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('dynamique')
				]),
			_List_fromArray(
				[
					A3($author$project$Components$Referentiel$Groupe$View$criteres, i18n, model, fiche),
					A2(
					$rtfeldman$elm_css$Html$Styled$section,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h2,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$referentielGroupeApercuTitre(i18n))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$table,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$thead,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$tr,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	$author$project$I18n$Cles$referentielGroupeApercuColonneFiche(i18n))
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	$author$project$I18n$Cles$referentielGroupeMembresColonneQualite(i18n))
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	$author$project$I18n$Cles$referentielGroupeApercuColonnePays(i18n))
																]))
														]))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$tbody,
											_List_Nil,
											A2(
												$elm$core$List$map,
												A2($author$project$Components$Referentiel$Groupe$View$apercu, i18n, model.hd),
												A2($elm$core$List$take, 5, fiche.Cm)))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('voir')
								]),
							function () {
								var _v0 = A2($author$project$API$Liens$trouverGabarit, 'voir-la-liste', fiche.gF);
								if (!_v0.$) {
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$href(
													$author$project$Components$Referentiel$Groupe$View$adresseDeLaListe(fiche))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$author$project$I18n$Cles$referentielGroupeApercuVoir,
														i18n,
														{
															w: $elm$core$String$fromInt(fiche.n5)
														}))
												]))
										]);
								} else {
									return _List_Nil;
								}
							}())
						]))
				]));
	});
var $author$project$I18n$Cles$referentielGroupeExplicationDynamique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.explication.dynamique', _List_Nil, 'Les membres sont recalculés à chaque modification d\'une fiche. Vous ne les ajoutez pas à la main.');
};
var $author$project$I18n$Cles$referentielGroupeExplicationStatique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.explication.statique', _List_Nil, 'Seules les personnes ajoutées ici en font partie.');
};
var $author$project$Components$Referentiel$Groupe$View$explication = F2(
	function (i18n, fiche) {
		var _v0 = fiche.rg;
		if (!_v0) {
			return $author$project$I18n$Cles$referentielGroupeExplicationStatique(i18n);
		} else {
			return $author$project$I18n$Cles$referentielGroupeExplicationDynamique(i18n);
		}
	});
var $author$project$Components$Referentiel$Groupe$Update$ArchivageDemande = {$: 27};
var $author$project$Components$Referentiel$Groupe$Update$RenommageOuvert = {$: 19};
var $author$project$Components$Referentiel$Groupe$Update$ResponsableOuvert = {$: 23};
var $author$project$I18n$Cles$referentielGroupeArchiver = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.archiver', _List_Nil, 'Archiver');
};
var $author$project$I18n$Cles$referentielGroupeRenommer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.renommer', _List_Nil, 'Renommer');
};
var $author$project$I18n$Cles$referentielGroupeResponsableChanger = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.responsable-changer', _List_Nil, 'Changer le responsable');
};
var $author$project$Components$Referentiel$Groupe$View$gestes = F2(
	function (i18n, model) {
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					function (_v0) {
						return A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Groupe$Model$idDuRenommer),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('geste'),
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Groupe$Update$RenommageOuvert)
								]),
							$author$project$I18n$Cles$referentielGroupeRenommer(i18n));
					},
					$author$project$Components$Referentiel$Groupe$Model$renommer(model)),
					A2(
					$elm$core$Maybe$map,
					function (_v1) {
						return A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Groupe$Model$idDuChangementDeResponsable),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('geste'),
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Groupe$Update$ResponsableOuvert)
								]),
							$author$project$I18n$Cles$referentielGroupeResponsableChanger(i18n));
					},
					$author$project$Components$Referentiel$Groupe$Model$changerLeResponsable(model)),
					A2(
					$elm$core$Maybe$map,
					function (_v2) {
						return A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Groupe$Model$idDeLArchivage),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('geste'),
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Groupe$Update$ArchivageDemande)
								]),
							$author$project$I18n$Cles$referentielGroupeArchiver(i18n));
					},
					$author$project$Components$Referentiel$Groupe$Model$archivage(model))
				]));
	});
var $author$project$Components$Referentiel$Groupe$Update$AjoutOuvert = {$: 11};
var $author$project$Components$Referentiel$Groupe$Update$DateChoisie = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Referentiel$Groupe$Update$RetraitDesFichesOuvert = {$: 6};
var $author$project$I18n$Cles$referentielGroupeMembresDepuis = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.groupe.membres.depuis',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			p.wv);
	});
var $author$project$I18n$Cles$referentielGroupeMembresJusquau = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.groupe.membres.jusquau',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'jusqu\'au ' + p.wv);
	});
var $author$project$I18n$Cles$referentielGroupeMembresSortLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.groupe.membres.sort-le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'sort le ' + p.wv);
	});
var $author$project$Components$Referentiel$Groupe$View$periode = F2(
	function (i18n, membre) {
		return _Utils_ap(
			A2(
				$author$project$I18n$Cles$referentielGroupeMembresDepuis,
				i18n,
				{
					wv: A2($author$project$Texte$Jour$enFrancais, i18n, membre.xe)
				}),
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (jour) {
						return membre.sO ? (' · ' + A2(
							$author$project$I18n$Cles$referentielGroupeMembresSortLe,
							i18n,
							{
								wv: A2($author$project$Texte$Jour$enFrancais, i18n, jour)
							})) : (' ' + A2(
							$author$project$I18n$Cles$referentielGroupeMembresJusquau,
							i18n,
							{
								wv: A2($author$project$Texte$Jour$enFrancais, i18n, jour)
							}));
					},
					membre.A4)));
	});
var $author$project$Components$Referentiel$Groupe$View$qualite = function (membre) {
	return A2($elm$core$Maybe$withDefault, '', membre.hy);
};
var $author$project$Components$Referentiel$Groupe$View$ligne = F2(
	function (i18n, membre) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('membre'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('sorti', !membre.sO)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Components$Referentiel$Groupe$View$lienDuMembre, i18n, membre)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('qualite')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Components$Referentiel$Groupe$View$qualite(membre))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('periode')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Referentiel$Groupe$View$periode, i18n, membre))
						]))
				]));
	});
var $author$project$I18n$Cles$referentielGroupeMembresAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.membres.ajouter', _List_Nil, '+ Ajouter des fiches');
};
var $author$project$I18n$Cles$referentielGroupeMembresAu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.membres.au', _List_Nil, 'Membres au');
};
var $author$project$I18n$Cles$referentielGroupeMembresColonneMembre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.membres.colonne-membre', _List_Nil, 'Membre');
};
var $author$project$I18n$Cles$referentielGroupeMembresColonnePeriode = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.membres.colonne-periode', _List_Nil, 'Depuis');
};
var $author$project$I18n$Cles$referentielGroupeMembresHistorique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.membres.historique', _List_Nil, 'Un membre retiré reste dans l\'historique, avec ses dates.');
};
var $author$project$I18n$Cles$referentielGroupeMembresRetirerDesFiches = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.membres.retirer-des-fiches', _List_Nil, 'Retirer des fiches');
};
var $author$project$I18n$Cles$referentielGroupeMembresTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.membres.titre', _List_Nil, 'Membres');
};
var $author$project$Components$Referentiel$Groupe$View$membres = F3(
	function (i18n, model, fiche) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('membres')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielGroupeMembresTitre(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('gestes-de-section')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Champ$View$date,
									{
										go: $elm$core$Maybe$Nothing,
										Aq: 'groupe-date',
										Bl: $author$project$I18n$Cles$referentielGroupeMembresAu(i18n),
										he: false
									},
									{hg: $author$project$Components$Referentiel$Groupe$Update$DateChoisie, fm: fiche.wv}),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout')
										]),
									function () {
										var _v0 = $author$project$Components$Referentiel$Groupe$Model$ajouter(model);
										if (!_v0.$) {
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$button,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
															$rtfeldman$elm_css$Html$Styled$Attributes$class('ajouter'),
															$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Groupe$Update$AjoutOuvert)
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$referentielGroupeMembresAjouter(i18n))
														]))
												]);
										} else {
											return _List_Nil;
										}
									}()),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('retrait-de-fiches')
										]),
									A2(
										$elm$core$List$any,
										function (membre) {
											return !_Utils_eq(
												$author$project$Components$Referentiel$Groupe$Model$retrait(membre),
												$elm$core$Maybe$Nothing);
										},
										fiche.Cm) ? _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$button,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
													$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer-des-fiches'),
													$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Groupe$Update$RetraitDesFichesOuvert)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$referentielGroupeMembresRetirerDesFiches(i18n))
												]))
										]) : _List_Nil)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$table,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$thead,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$tr,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$referentielGroupeMembresColonneMembre(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$referentielGroupeMembresColonneQualite(i18n))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$th,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$referentielGroupeMembresColonnePeriode(i18n))
														]))
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$tbody,
									_List_Nil,
									A2(
										$elm$core$List$map,
										$author$project$Components$Referentiel$Groupe$View$ligne(i18n),
										fiche.Cm))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('historique')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$referentielGroupeMembresHistorique(i18n))
						]))
				]));
	});
var $author$project$Components$Referentiel$Groupe$View$nomDeLaPage = 'referentiel-groupe-detail';
var $author$project$I18n$Cles$referentielGroupeTraitementNonAjouteesFiche = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.groupe.traitement.non-ajoutees.fiche',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'uid',
					$author$project$I18n$Traductions$Chaine(p.r8))
				]),
			'Fiche ' + p.r8);
	});
var $author$project$I18n$Cles$referentielGroupeTraitementNonAjouteesFicheRaison = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.groupe.traitement.non-ajoutees.fiche-raison',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'uid',
					$author$project$I18n$Traductions$Chaine(p.r8)),
					_Utils_Tuple2(
					'raison',
					$author$project$I18n$Traductions$Chaine(p.pH))
				]),
			'Fiche ' + (p.r8 + (' · ' + p.pH)));
	});
var $author$project$I18n$Cles$referentielGroupeTraitementNonAjouteesRaisonEffacee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.traitement.non-ajoutees.raison-effacee', _List_Nil, 'effacée en cours de route');
};
var $author$project$I18n$Cles$referentielGroupeTraitementNonAjouteesRaisonSupprimee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.traitement.non-ajoutees.raison-supprimee', _List_Nil, 'supprimée en cours de route');
};
var $author$project$Components$Referentiel$Groupe$View$ficheNonAjoutee = F2(
	function (i18n, fiche) {
		var uid = A2($elm$core$String$left, 8, fiche.r8);
		var _v0 = fiche.pH;
		if (!_v0.$) {
			if (!_v0.a) {
				var _v1 = _v0.a;
				return A2(
					$author$project$I18n$Cles$referentielGroupeTraitementNonAjouteesFicheRaison,
					i18n,
					{
						pH: $author$project$I18n$Cles$referentielGroupeTraitementNonAjouteesRaisonEffacee(i18n),
						r8: uid
					});
			} else {
				var _v2 = _v0.a;
				return A2(
					$author$project$I18n$Cles$referentielGroupeTraitementNonAjouteesFicheRaison,
					i18n,
					{
						pH: $author$project$I18n$Cles$referentielGroupeTraitementNonAjouteesRaisonSupprimee(i18n),
						r8: uid
					});
			}
		} else {
			return A2(
				$author$project$I18n$Cles$referentielGroupeTraitementNonAjouteesFiche,
				i18n,
				{r8: uid});
		}
	});
var $author$project$I18n$Cles$referentielGroupeTraitementNonAjouteesFermer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.traitement.non-ajoutees.fermer', _List_Nil, 'Fermer');
};
var $author$project$I18n$Cles$referentielGroupeTraitementNonAjouteesIntro = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.traitement.non-ajoutees.intro', _List_Nil, 'Ces fiches n\'ont pas été ajoutées au groupe. Leur nom n\'est pas affiché.');
};
var $author$project$I18n$Cles$referentielGroupeTraitementNonAjouteesTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.groupe.traitement.non-ajoutees.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiche non ajoutée') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiches non ajoutées'));
	});
var $author$project$Components$Referentiel$Groupe$View$nonAjoutees = F2(
	function (i18n, model) {
		var fiches = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.zu;
				},
				model.oD));
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$Groupe$Update$DesNonAjoutees,
			{
				fs: {
					sR: true,
					Bl: $author$project$I18n$Cles$referentielGroupeTraitementNonAjouteesFermer(i18n),
					C$: $author$project$Components$Referentiel$Groupe$Update$DesNonAjoutees($author$project$Components$Shared$Drawer$Update$Fermer)
				},
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('intro')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielGroupeTraitementNonAjouteesIntro(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('fiches-non-ajoutees')
							]),
						A2(
							$elm$core$List$map,
							function (fiche) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$Components$Referentiel$Groupe$View$ficheNonAjoutee, i18n, fiche))
										]));
							},
							fiches))
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: A2(
					$author$project$I18n$Cles$referentielGroupeTraitementNonAjouteesTitre,
					i18n,
					{
						w: $elm$core$List$length(fiches)
					})
			},
			model.oE);
	});
var $author$project$I18n$Cles$referentielGroupeIntrouvable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.introuvable', _List_Nil, 'Ce groupe n\'existe pas ou n\'est plus accessible.');
};
var $author$project$I18n$Cles$referentielGroupesFil = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupes.fil', _List_Nil, 'Parties prenantes');
};
var $author$project$I18n$Cles$referentielGroupesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupes.titre', _List_Nil, 'Groupes');
};
var $author$project$Components$Referentiel$Groupe$Update$NomSaisi = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Referentiel$Groupe$Update$RenommageDemande = {$: 22};
var $author$project$I18n$Cles$referentielGroupeRenommageAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.renommage.action', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$referentielGroupeRenommageNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.renommage.nom', _List_Nil, 'Nom du groupe');
};
var $author$project$I18n$Cles$referentielGroupeRenommageNomVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.renommage.nom-vide', _List_Nil, 'Indiquez un nom.');
};
var $author$project$I18n$Cles$referentielGroupeRenommageTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.renommage.titre', _List_Nil, 'Renommer le groupe');
};
var $author$project$Components$Referentiel$Groupe$View$renommage = F2(
	function (i18n, model) {
		var ouvert = model.hL;
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$Groupe$Update$DuRenommage,
			{
				fs: {
					sR: !_Utils_eq(ouvert, $elm$core$Maybe$Nothing),
					Bl: $author$project$I18n$Cles$referentielGroupeRenommageAction(i18n),
					C$: $author$project$Components$Referentiel$Groupe$Update$RenommageDemande
				},
				fZ: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (saisie) {
							return _List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Champ$View$texte,
									{
										go: (saisie.b5 && $elm$core$String$isEmpty(
											$elm$core$String$trim(saisie.Dj))) ? $elm$core$Maybe$Just(
											$author$project$I18n$Cles$referentielGroupeRenommageNomVide(i18n)) : $elm$core$Maybe$Nothing,
										Aq: 'groupe-nom',
										Bl: $author$project$I18n$Cles$referentielGroupeRenommageNom(i18n),
										he: true
									},
									{hg: $author$project$Components$Referentiel$Groupe$Update$NomSaisi, fm: saisie.Dj}),
									A2(
									$author$project$Components$Shared$Messages$View$view,
									i18n,
									A2($author$project$Components$Referentiel$Groupe$View$refus, i18n, model))
								]);
						},
						ouvert)),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$referentielGroupeRenommageTitre(i18n)
			},
			model.qp);
	});
var $author$project$I18n$Cles$referentielGroupeArchive = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.archive', _List_Nil, 'Archivé');
};
var $author$project$I18n$Cles$referentielGroupeMembresActifsPlusieurs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.groupe.membres-actifs.plusieurs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			p.w + ' membres');
	});
var $author$project$I18n$Cles$referentielGroupeMembresActifsUn = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.membres-actifs.un', _List_Nil, '1 membre');
};
var $author$project$I18n$Cles$referentielGroupesSorteDynamique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupes.sorte.dynamique', _List_Nil, 'Dynamique');
};
var $author$project$I18n$Cles$referentielGroupesSorteStatique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupes.sorte.statique', _List_Nil, 'Statique');
};
var $author$project$I18n$Cles$referentielGroupeResponsable = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.groupe.responsable',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Responsable : ' + p.Dj);
	});
var $author$project$Components$Referentiel$Common$Equipe$nomDe = F2(
	function (uid, equipe) {
		if (!equipe.$) {
			return $elm$core$Maybe$Nothing;
		} else {
			var membres = equipe.a;
			return $elm$core$Maybe$Just(
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Dj;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (membre) {
								return _Utils_eq(membre.r8, uid);
							},
							membres))));
		}
	});
var $author$project$I18n$Cles$referentielGroupesResponsableParti = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupes.responsable-parti', _List_Nil, 'Responsable parti');
};
var $author$project$Components$Referentiel$Common$Equipe$responsableAffiche = F3(
	function (i18n, uid, equipe) {
		var _v0 = A2($author$project$Components$Referentiel$Common$Equipe$nomDe, uid, equipe);
		if (!_v0.$) {
			if (!_v0.a.$) {
				var nom = _v0.a.a;
				return nom;
			} else {
				var _v1 = _v0.a;
				return $author$project$I18n$Cles$referentielGroupesResponsableParti(i18n);
			}
		} else {
			return '';
		}
	});
var $author$project$Components$Referentiel$Groupe$View$responsable = F3(
	function (i18n, equipe, fiche) {
		var _v0 = A3($author$project$Components$Referentiel$Common$Equipe$responsableAffiche, i18n, fiche.qB, equipe);
		if (_v0 === '') {
			return _List_Nil;
		} else {
			var nom = _v0;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2(
						$author$project$I18n$Cles$referentielGroupeResponsable,
						i18n,
						{Dj: nom}))
				]);
		}
	});
var $author$project$Components$Referentiel$Groupe$View$resume = F3(
	function (i18n, equipe, fiche) {
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Tag$View$view,
					(!fiche.rg) ? 4 : 5,
					(!fiche.rg) ? $author$project$I18n$Cles$referentielGroupesSorteStatique(i18n) : $author$project$I18n$Cles$referentielGroupesSorteDynamique(i18n)),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('compteur')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							(fiche.n5 === 1) ? $author$project$I18n$Cles$referentielGroupeMembresActifsUn(i18n) : A2(
								$author$project$I18n$Cles$referentielGroupeMembresActifsPlusieurs,
								i18n,
								{
									w: $elm$core$String$fromInt(fiche.n5)
								}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('responsable')
						]),
					A3($author$project$Components$Referentiel$Groupe$View$responsable, i18n, equipe, fiche))
				]),
			fiche.tE ? _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Tag$View$view,
					3,
					$author$project$I18n$Cles$referentielGroupeArchive(i18n))
				]) : _List_Nil);
	});
var $author$project$Components$Referentiel$Groupe$Update$DateDeSortieSaisie = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Referentiel$Groupe$Update$RetraitDemande = {$: 10};
var $author$project$Components$Referentiel$Groupe$Update$RetraitOuvert = function (a) {
	return {$: 7, a: a};
};
var $author$project$I18n$Cles$referentielGroupeRetraitAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.retrait.action', _List_Nil, 'Retirer');
};
var $author$project$I18n$Cles$referentielGroupeRetraitDate = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.retrait.date', _List_Nil, 'Date de sortie');
};
var $author$project$I18n$Cles$referentielGroupeRetraitDateManquante = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.retrait.date-manquante', _List_Nil, 'Indiquez la date de sortie.');
};
var $author$project$I18n$Cles$referentielGroupeRetraitTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.retrait.titre', _List_Nil, 'Retirer un membre');
};
var $author$project$Components$Referentiel$Groupe$View$retrait = F2(
	function (i18n, model) {
		var ouvert = model.eW;
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$Groupe$Update$DuRetrait,
			{
				fs: {
					sR: !_Utils_eq(ouvert, $elm$core$Maybe$Nothing),
					Bl: $author$project$I18n$Cles$referentielGroupeRetraitAction(i18n),
					C$: $author$project$Components$Referentiel$Groupe$Update$RetraitDemande
				},
				fZ: function () {
					if (!ouvert.$) {
						var saisie = ouvert.a;
						return _List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Champ$View$date,
								{
									go: (saisie.b5 && $elm$core$String$isEmpty(saisie.IQ)) ? $elm$core$Maybe$Just(
										$author$project$I18n$Cles$referentielGroupeRetraitDateManquante(i18n)) : $elm$core$Maybe$Nothing,
									Aq: 'groupe-sortie',
									Bl: $author$project$I18n$Cles$referentielGroupeRetraitDate(i18n),
									he: true
								},
								{hg: $author$project$Components$Referentiel$Groupe$Update$DateDeSortieSaisie, fm: saisie.IQ}),
								A2(
								$author$project$Components$Shared$Messages$View$view,
								i18n,
								A2($author$project$Components$Referentiel$Groupe$View$refus, i18n, model))
							]);
					} else {
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$ul,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('membres-a-retirer')
									]),
								A2(
									$elm$core$List$map,
									function (membre) {
										return A2(
											$rtfeldman$elm_css$Html$Styled$li,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$button,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
															$rtfeldman$elm_css$Html$Styled$Attributes$class('choisir-membre'),
															$rtfeldman$elm_css$Html$Styled$Events$onClick(
															$author$project$Components$Referentiel$Groupe$Update$RetraitOuvert(membre.zo))
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															A2($author$project$Components$Referentiel$Groupe$View$nomDuMembre, i18n, membre))
														]))
												]));
									},
									A2(
										$elm$core$List$filter,
										function (membre) {
											return !_Utils_eq(
												$author$project$Components$Referentiel$Groupe$Model$retrait(membre),
												$elm$core$Maybe$Nothing);
										},
										A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.Cm;
												},
												model.zo)))))
							]);
					}
				}(),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$referentielGroupeRetraitTitre(i18n)
			},
			model.qN);
	});
var $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$finLue = F2(
	function (groupe, fins) {
		var _v0 = A2(
			$elm$core$List$filter,
			function (fin) {
				return _Utils_eq(fin.m2, groupe);
			},
			fins);
		if (!_v0.b) {
			return false;
		} else {
			var deCeGroupe = _v0;
			return A2(
				$elm$core$List$all,
				function ($) {
					return $.B1;
				},
				deCeGroupe);
		}
	});
var $author$project$Components$Referentiel$Groupe$View$aLuLaFin = F2(
	function (model, traitement) {
		return (traitement.gt === 2) && A2(
			$author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$finLue,
			$author$project$Components$Referentiel$Identifiants$groupeUidToString(traitement.m2),
			model.oO);
	});
var $author$project$Components$Referentiel$Groupe$Update$NonAjouteesDemandees = {$: 44};
var $author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$aDesNonAjoutees = function (traitement) {
	return !_Utils_eq(
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$fichesNonAjoutees, traitement.nQ),
		$elm$core$Maybe$Nothing);
};
var $author$project$I18n$Cles$referentielGroupeTraitementAvancement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.traitement.avancement', _List_Nil, 'Avancement de l\'ajout en lot');
};
var $author$project$Components$Referentiel$Groupe$View$barreDAvancement = F2(
	function (i18n, traitement) {
		return (traitement.gt === 1) ? A3(
			$rtfeldman$elm_css$Html$Styled$node,
			'progress',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('barre-d-avancement'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					$author$project$I18n$Cles$referentielGroupeTraitementAvancement(i18n)),
					$rtfeldman$elm_css$Html$Styled$Attributes$max(
					$elm$core$String$fromInt(traitement.JE)),
					$rtfeldman$elm_css$Html$Styled$Attributes$value(
					$elm$core$String$fromInt(traitement.JN))
				]),
			_List_Nil) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$I18n$Cles$referentielGroupeTraitementTermineLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.groupe.traitement.termine-le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'instant',
					$author$project$I18n$Traductions$Chaine(p.cO))
				]),
			'Terminé le ' + p.cO);
	});
var $author$project$Components$Referentiel$Groupe$View$heureDeFin = F2(
	function (i18n, traitement) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (instant) {
					return A2(
						$author$project$I18n$Cles$referentielGroupeTraitementTermineLe,
						i18n,
						{
							cO: A2($author$project$Texte$Jour$horodate, i18n, instant)
						});
				},
				traitement.Ju));
	});
var $author$project$Components$Referentiel$Groupe$View$nombre = function (i18n) {
	return $author$project$I18n$Nombre$formater(
		$author$project$I18n$Traductions$langue(i18n));
};
var $author$project$I18n$Cles$referentielGroupeTraitementDemandeDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.traitement.demande.detail', _List_Nil, 'Il démarre dans un instant. Vous pouvez quitter cette page.');
};
var $author$project$I18n$Cles$referentielGroupeTraitementDemandeTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.groupe.traitement.demande.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Ajout demandé : ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiche')) : ('Ajout demandé : ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiches')));
	});
var $author$project$I18n$Cles$referentielGroupeTraitementEchecPartielTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.groupe.traitement.echec-partiel.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'ajoutees',
					$author$project$I18n$Traductions$Chaine(p.iI)),
					_Utils_Tuple2(
					'echecs',
					$author$project$I18n$Traductions$Chaine(p.x2))
				]),
			'Ajout terminé : ' + (p.iI + (' ajoutées, ' + (p.x2 + ' non ajoutées'))));
	});
var $author$project$I18n$Cles$referentielGroupeTraitementEnCoursDetail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.traitement.en-cours.detail', _List_Nil, 'Les membres apparaissent au fur et à mesure.');
};
var $author$project$I18n$Cles$referentielGroupeTraitementEnCoursTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.groupe.traitement.en-cours.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'traitees',
					$author$project$I18n$Traductions$Chaine(p.JN)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			'Ajout en cours : ' + (p.JN + (' / ' + (p.JE + ' fiches'))));
	});
var $author$project$I18n$Cles$referentielGroupeTraitementNonAjouteesAppel = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.traitement.non-ajoutees.appel', _List_Nil, 'Voir les fiches non ajoutées');
};
var $author$project$I18n$Cles$referentielGroupeTraitementReussiteTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.groupe.traitement.reussite.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Ajout terminé : ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiche ajoutée')) : ('Ajout terminé : ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiches ajoutées')));
	});
var $author$project$I18n$Cles$referentielGroupeTraitementVisibleDeVousSeul = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupe.traitement.visible-de-vous-seul', _List_Nil, 'Demandé par vous · visible de vous seul');
};
var $author$project$Components$Referentiel$Groupe$View$bandeauDuTraitement = F2(
	function (i18n, traitement) {
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(traitement.gt, traitement.nh);
			switch (_v1.a) {
				case 0:
					var _v2 = _v1.a;
					return _Utils_Tuple2(
						A2(
							$author$project$I18n$Cles$referentielGroupeTraitementDemandeTitre,
							i18n,
							{w: traitement.JE}),
						$author$project$I18n$Cles$referentielGroupeTraitementDemandeDetail(i18n));
				case 1:
					var _v3 = _v1.a;
					return _Utils_Tuple2(
						A2(
							$author$project$I18n$Cles$referentielGroupeTraitementEnCoursTitre,
							i18n,
							{
								JE: A2($author$project$Components$Referentiel$Groupe$View$nombre, i18n, traitement.JE),
								JN: A2($author$project$Components$Referentiel$Groupe$View$nombre, i18n, traitement.JN)
							}),
						$author$project$I18n$Cles$referentielGroupeTraitementEnCoursDetail(i18n));
				default:
					if ((!_v1.b.$) && (_v1.b.a === 1)) {
						var _v4 = _v1.a;
						var _v5 = _v1.b.a;
						return _Utils_Tuple2(
							A2(
								$author$project$I18n$Cles$referentielGroupeTraitementEchecPartielTitre,
								i18n,
								{
									iI: A2($author$project$Components$Referentiel$Groupe$View$nombre, i18n, traitement.JN),
									x2: A2($author$project$Components$Referentiel$Groupe$View$nombre, i18n, traitement.x2)
								}),
							A2($author$project$Components$Referentiel$Groupe$View$heureDeFin, i18n, traitement));
					} else {
						var _v6 = _v1.a;
						return _Utils_Tuple2(
							A2(
								$author$project$I18n$Cles$referentielGroupeTraitementReussiteTitre,
								i18n,
								{w: traitement.JN}),
							A2($author$project$Components$Referentiel$Groupe$View$heureDeFin, i18n, traitement));
					}
			}
		}();
		var titre = _v0.a;
		var detail = _v0.b;
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('traitement'),
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('termine', traitement.gt === 2)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(titre)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('detail')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(detail)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('visible')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielGroupeTraitementVisibleDeVousSeul(i18n))
									]))
							])),
						A2($author$project$Components$Referentiel$Groupe$View$barreDAvancement, i18n, traitement),
						$author$project$Components$Referentiel$Common$API$Traitements$QueryAPIModel$aDesNonAjoutees(traitement) ? A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('voir-non-ajoutees'),
								$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Groupe$Model$idDesNonAjoutees),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Groupe$Update$NonAjouteesDemandees)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielGroupeTraitementNonAjouteesAppel(i18n))
							])) : $rtfeldman$elm_css$Html$Styled$text('')
					]))
			]);
	});
var $author$project$Components$Referentiel$Groupe$View$suivi = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('suivi-du-traitement')
				]),
			function () {
				var _v0 = model.rr;
				if (!_v0.$) {
					var traitement = _v0.a;
					return A2($author$project$Components$Referentiel$Groupe$View$aLuLaFin, model, traitement) ? _List_Nil : _List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Note$View$view,
							0,
							A2($author$project$Components$Referentiel$Groupe$View$bandeauDuTraitement, i18n, traitement))
						]);
				} else {
					return _List_Nil;
				}
			}());
	});
var $author$project$Components$Referentiel$Groupe$View$view = F3(
	function (i18n, messages, model) {
		var _v0 = model.zo;
		if (!_v0.$) {
			var fiche = _v0.a;
			return A2(
				$author$project$Components$Shared$Page$View$page,
				$author$project$Components$Referentiel$Groupe$View$nomDeLaPage,
				{
					ut: _List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Messages$View$view,
							i18n,
							_Utils_ap(
								messages,
								A2($author$project$Components$Referentiel$Groupe$View$refus, i18n, model))),
							A2($author$project$Components$Referentiel$Groupe$View$suivi, i18n, model),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('presentation')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($elm$core$Maybe$withDefault, '', fiche.dH))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('explication')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$Components$Referentiel$Groupe$View$explication, i18n, fiche))
										]))
								])),
							function () {
							var _v1 = fiche.rg;
							if (!_v1) {
								return A3($author$project$Components$Referentiel$Groupe$View$membres, i18n, model, fiche);
							} else {
								return A3($author$project$Components$Referentiel$Groupe$View$dynamique, i18n, model, fiche);
							}
						}()
						]),
					xy: _List_fromArray(
						[
							A3($author$project$Components$Referentiel$Groupe$View$confirmation, i18n, model, fiche),
							A2($author$project$Components$Referentiel$Groupe$View$retrait, i18n, model),
							A2($author$project$Components$Referentiel$Groupe$View$renommage, i18n, model),
							A2($author$project$Components$Referentiel$Groupe$View$changementDeResponsable, i18n, model),
							A2($author$project$Components$Referentiel$Groupe$View$ajout, i18n, model),
							A3($author$project$Components$Referentiel$Groupe$View$drawerDesCriteres, i18n, model, fiche),
							A2($author$project$Components$Referentiel$Groupe$View$nonAjoutees, i18n, model)
						]),
					zM: _List_Nil,
					AK: $author$project$Components$Referentiel$Groupe$View$dialogueOuvert(model),
					JD: A2(
						$author$project$Components$Shared$Page$View$enTete,
						i18n,
						{
							vS: _Utils_ap(
								A3($author$project$Components$Referentiel$Groupe$View$resume, i18n, model.l5, fiche),
								A2($author$project$Components$Referentiel$Groupe$View$gestes, i18n, model)),
							zE: _List_fromArray(
								[
									{
									aa: $author$project$Routes$Route$adressePartiesPrenantes,
									Dj: $author$project$I18n$Cles$referentielGroupesFil(i18n)
								},
									{
									aa: $author$project$Routes$Route$adresseGroupes,
									Dj: $author$project$I18n$Cles$referentielGroupesTitre(i18n)
								}
								]),
							Ef: _List_Nil,
							h6: fiche.Dj
						})
				});
		} else {
			return A2(
				$author$project$Components$Shared$Page$View$page,
				$author$project$Components$Referentiel$Groupe$View$nomDeLaPage,
				{
					ut: _List_fromArray(
						[
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('introuvable')
								]),
							model.nf ? _List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielGroupeIntrouvable(i18n))
								]) : _List_Nil)
						]),
					xy: _List_Nil,
					zM: _List_Nil,
					AK: false,
					JD: A2(
						$author$project$Components$Shared$Page$View$enTete,
						i18n,
						{
							vS: _List_Nil,
							zE: _List_fromArray(
								[
									{
									aa: $author$project$Routes$Route$adressePartiesPrenantes,
									Dj: $author$project$I18n$Cles$referentielGroupesFil(i18n)
								},
									{
									aa: $author$project$Routes$Route$adresseGroupes,
									Dj: $author$project$I18n$Cles$referentielGroupesTitre(i18n)
								}
								]),
							Ef: _List_Nil,
							h6: $author$project$I18n$Cles$referentielGroupesTitre(i18n)
						})
				});
		}
	});
var $author$project$I18n$Cles$referentielGroupesCompteurPlusieurs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.groupes.compteur.plusieurs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			p.w + ' groupes · fiches réunies à la main ou par des critères');
	});
var $author$project$I18n$Cles$referentielGroupesCompteurUn = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupes.compteur.un', _List_Nil, '1 groupe · fiches réunies à la main ou par des critères');
};
var $author$project$Components$Referentiel$Groupes$View$compteur = F2(
	function (i18n, annuaire) {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				(annuaire.JE === 1) ? $author$project$I18n$Cles$referentielGroupesCompteurUn(i18n) : A2(
					$author$project$I18n$Cles$referentielGroupesCompteurPlusieurs,
					i18n,
					{
						w: $elm$core$String$fromInt(annuaire.JE)
					}))
			]);
	});
var $author$project$Components$Referentiel$Groupes$Update$CreationDemandee = {$: 12};
var $author$project$Components$Referentiel$Groupes$Update$DuDrawer = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Referentiel$Groupes$Update$DescriptionSaisie = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Referentiel$Groupes$Update$NomSaisi = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Referentiel$Groupes$Update$SorteChoisie = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Referentiel$Groupes$View$libelleDeLaSorte = F2(
	function (i18n, sorte) {
		if (!sorte) {
			return $author$project$I18n$Cles$referentielGroupesSorteStatique(i18n);
		} else {
			return $author$project$I18n$Cles$referentielGroupesSorteDynamique(i18n);
		}
	});
var $author$project$Components$Referentiel$Groupes$View$choix = F4(
	function (i18n, saisie, sorte, aide) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('sorte'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'selected',
							_Utils_eq(
								saisie.rg,
								$elm$core$Maybe$Just(sorte)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-pressed',
					_Utils_eq(
						saisie.rg,
						$elm$core$Maybe$Just(sorte)) ? 'true' : 'false'),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Components$Referentiel$Groupes$Update$SorteChoisie(sorte))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Referentiel$Groupes$View$libelleDeLaSorte, i18n, sorte))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(aide)
						]))
				]));
	});
var $author$project$I18n$Cles$referentielGroupesCreationDescription = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupes.creation.description', _List_Nil, 'Description');
};
var $author$project$I18n$Cles$referentielGroupesCreationDynamique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupes.creation.dynamique', _List_Nil, 'Vous décrivez des critères (type, qualité, pays…). La liste se met à jour toute seule.');
};
var $author$project$I18n$Cles$referentielGroupesCreationNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupes.creation.nom', _List_Nil, 'Nom');
};
var $author$project$I18n$Cles$referentielGroupesCreationNomVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupes.creation.nom-vide', _List_Nil, 'Le nom du groupe est obligatoire.');
};
var $author$project$I18n$Cles$referentielGroupesCreationSorte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupes.creation.sorte', _List_Nil, 'Comment le groupe se remplit-il ?');
};
var $author$project$I18n$Cles$referentielGroupesCreationSorteManquante = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupes.creation.sorte-manquante', _List_Nil, 'Choisissez comment le groupe se remplit.');
};
var $author$project$I18n$Cles$referentielGroupesCreationStatique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupes.creation.statique', _List_Nil, 'Vous ajoutez les fiches vous-même. La liste ne change que si vous la changez.');
};
var $author$project$Components$Referentiel$Groupes$Update$ResponsableChoisi = function (a) {
	return {$: 10, a: a};
};
var $author$project$I18n$Cles$referentielGroupesCreationResponsable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupes.creation.responsable', _List_Nil, 'Responsable');
};
var $author$project$I18n$Cles$referentielGroupesCreationResponsableDefaut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupes.creation.responsable-defaut', _List_Nil, 'Moi (par défaut)');
};
var $author$project$Components$Referentiel$Groupes$View$responsable = F3(
	function (i18n, model, saisie) {
		var _v0 = $author$project$Components$Referentiel$Common$Equipe$candidats(model.l5);
		if (!_v0.b) {
			return _List_Nil;
		} else {
			var candidats = _v0;
			return _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: 'groupe-responsable',
						Bl: $author$project$I18n$Cles$referentielGroupesCreationResponsable(i18n),
						he: false
					},
					{
						hg: $author$project$Components$Referentiel$Groupes$Update$ResponsableChoisi,
						o_: A2(
							$elm$core$List$cons,
							{
								Bl: $author$project$I18n$Cles$referentielGroupesCreationResponsableDefaut(i18n),
								fm: ''
							},
							A2(
								$elm$core$List$map,
								function (c) {
									return {Bl: c.Dj, fm: c.r8};
								},
								candidats)),
						fm: saisie.qB
					})
				]);
		}
	});
var $author$project$Components$Referentiel$Groupes$Model$sorteManquante = function (creation) {
	return _Utils_eq(creation.rg, $elm$core$Maybe$Nothing);
};
var $author$project$Components$Referentiel$Groupes$View$champs = F3(
	function (i18n, model, saisie) {
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Champ$View$texte,
					{
						go: (saisie.b5 && $elm$core$String$isEmpty(
							$elm$core$String$trim(saisie.Dj))) ? $elm$core$Maybe$Just(
							$author$project$I18n$Cles$referentielGroupesCreationNomVide(i18n)) : $elm$core$Maybe$Nothing,
						Aq: 'groupe-nom',
						Bl: $author$project$I18n$Cles$referentielGroupesCreationNom(i18n),
						he: true
					},
					{hg: $author$project$Components$Referentiel$Groupes$Update$NomSaisi, fm: saisie.Dj}),
					A2(
					$author$project$Components$Shared$Champ$View$zoneDeTexte,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: 'groupe-description',
						Bl: $author$project$I18n$Cles$referentielGroupesCreationDescription(i18n),
						he: false
					},
					{hg: $author$project$Components$Referentiel$Groupes$Update$DescriptionSaisie, fm: saisie.dH})
				]),
			_Utils_ap(
				A3($author$project$Components$Referentiel$Groupes$View$responsable, i18n, model, saisie),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$fieldset,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('mandatory', true),
										_Utils_Tuple2(
										'error',
										saisie.b5 && $author$project$Components$Referentiel$Groupes$Model$sorteManquante(saisie))
									]))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$legend,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$referentielGroupesCreationSorte(i18n))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('sortes')
									]),
								_List_fromArray(
									[
										A4(
										$author$project$Components$Referentiel$Groupes$View$choix,
										i18n,
										saisie,
										0,
										$author$project$I18n$Cles$referentielGroupesCreationStatique(i18n)),
										A4(
										$author$project$Components$Referentiel$Groupes$View$choix,
										i18n,
										saisie,
										1,
										$author$project$I18n$Cles$referentielGroupesCreationDynamique(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$ul,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('errors')
									]),
								(saisie.b5 && $author$project$Components$Referentiel$Groupes$Model$sorteManquante(saisie)) ? _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$li,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$referentielGroupesCreationSorteManquante(i18n))
											]))
									]) : _List_Nil)
							])),
						A2(
						$author$project$Components$Shared$Messages$View$view,
						i18n,
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeR, $author$project$Components$Shared$Messages$Model$duRefus, $elm$core$List$singleton),
								model.pZ)))
					])));
	});
var $author$project$I18n$Cles$referentielGroupesCreationAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupes.creation.action', _List_Nil, 'Créer le groupe');
};
var $author$project$I18n$Cles$referentielGroupesCreationTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupes.creation.titre', _List_Nil, 'Nouveau groupe');
};
var $author$project$Components$Referentiel$Groupes$View$creation = F2(
	function (i18n, model) {
		var ouvert = model.wl;
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$Groupes$Update$DuDrawer,
			{
				fs: {
					sR: !_Utils_eq(ouvert, $elm$core$Maybe$Nothing),
					Bl: $author$project$I18n$Cles$referentielGroupesCreationAction(i18n),
					C$: $author$project$Components$Referentiel$Groupes$Update$CreationDemandee
				},
				fZ: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (saisie) {
							return A3($author$project$Components$Referentiel$Groupes$View$champs, i18n, model, saisie);
						},
						ouvert)),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$referentielGroupesCreationTitre(i18n)
			},
			model.kX);
	});
var $author$project$Components$Referentiel$Groupes$Update$CreationOuverte = {$: 6};
var $author$project$Components$Referentiel$Groupes$Model$peutCreer = function (model) {
	return A2(
		$elm$core$List$any,
		function (rel) {
			return !_Utils_eq(
				A2(
					$author$project$API$Liens$trouver,
					rel,
					$author$project$Components$Referentiel$Groupes$Model$liensDeLAnnuaire(model)),
				$elm$core$Maybe$Nothing);
		},
		_List_fromArray(
			[$author$project$API$NavLinksDictionary$creerUnGroupeStatique, $author$project$API$NavLinksDictionary$creerUnGroupeDynamique]));
};
var $author$project$I18n$Cles$referentielGroupesNouveau = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupes.nouveau', _List_Nil, 'Nouveau groupe');
};
var $author$project$Components$Referentiel$Groupes$View$nouveauGroupe = F2(
	function (i18n, model) {
		return $author$project$Components$Referentiel$Groupes$Model$peutCreer(model) ? _List_fromArray(
			[
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				0,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Groupes$Model$idDeLaCreation),
						$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Groupes$Update$CreationOuverte)
					]),
				$author$project$I18n$Cles$referentielGroupesNouveau(i18n))
			]) : _List_Nil;
	});
var $author$project$Components$Referentiel$Groupes$Update$ArchivesDemandees = {$: 5};
var $author$project$Components$Referentiel$Groupes$View$couleur = function (sorte) {
	if (!sorte) {
		return 4;
	} else {
		return 5;
	}
};
var $author$project$I18n$Cles$referentielGroupesOuvrir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupes.ouvrir', _List_Nil, 'Ouvrir');
};
var $author$project$Components$Referentiel$Groupes$View$ligne = F3(
	function (i18n, equipe, groupe) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('groupe'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('archive', groupe.tE)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('intitule')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom'),
									$rtfeldman$elm_css$Html$Styled$Attributes$href(
									$author$project$Routes$Route$toString(
										A2($author$project$Routes$Route$FicheDeGroupe, groupe.r8, $elm$core$Maybe$Nothing)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(groupe.Dj)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$Maybe$withDefault, '', groupe.dH))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('sorte')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							$author$project$Components$Referentiel$Groupes$View$couleur(groupe.rg),
							A2($author$project$Components$Referentiel$Groupes$View$libelleDeLaSorte, i18n, groupe.rg))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('membres')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(groupe.n5))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('responsable')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A3($author$project$Components$Referentiel$Common$Equipe$responsableAffiche, i18n, groupe.qB, equipe))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href(
									$author$project$Routes$Route$toString(
										A2($author$project$Routes$Route$FicheDeGroupe, groupe.r8, $elm$core$Maybe$Nothing)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielGroupesOuvrir(i18n))
								]))
						]))
				]));
	});
var $author$project$I18n$Cles$referentielGroupesArchives = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.groupes.archives',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Voir les groupes archivés (' + (p.w + ')'));
	});
var $author$project$I18n$Cles$referentielGroupesAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupes.aucun', _List_Nil, 'Aucun groupe pour l\'instant. Un groupe réunit des fiches à la main ou par des critères.');
};
var $author$project$I18n$Cles$referentielGroupesColonneGroupe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupes.colonne.groupe', _List_Nil, 'Groupe');
};
var $author$project$I18n$Cles$referentielGroupesColonneMembres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupes.colonne.membres', _List_Nil, 'Membres');
};
var $author$project$I18n$Cles$referentielGroupesColonneResponsable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupes.colonne.responsable', _List_Nil, 'Responsable');
};
var $author$project$I18n$Cles$referentielGroupesColonneType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupes.colonne.type', _List_Nil, 'Type');
};
var $author$project$I18n$Cles$referentielGroupesTous = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.groupes.tous', _List_Nil, 'Tous les groupes');
};
var $author$project$Components$Referentiel$Groupes$View$tableau = F3(
	function (i18n, model, annuaire) {
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$section,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('groupes'),
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'vide',
								$elm$core$List$isEmpty(annuaire.Ac))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$h2,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielGroupesTous(i18n))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('tableau')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$table,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$referentielGroupesColonneGroupe(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$referentielGroupesColonneType(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$referentielGroupesColonneMembres(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$scope('col')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$referentielGroupesColonneResponsable(i18n))
															])),
														A2($rtfeldman$elm_css$Html$Styled$th, _List_Nil, _List_Nil)
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$tbody,
										_List_Nil,
										A2(
											$elm$core$List$map,
											A2($author$project$Components$Referentiel$Groupes$View$ligne, i18n, model.l5),
											annuaire.Ac))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aucun')
							]),
						$elm$core$List$isEmpty(annuaire.Ac) ? _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielGroupesAucun(i18n))
							]) : _List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('archives')
							]),
						function () {
							var _v0 = _Utils_Tuple2(
								$author$project$Components$Referentiel$Groupes$Model$lienDesArchives(model),
								annuaire.i$ > 0);
							if ((!_v0.a.$) && _v0.b) {
								return _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$button,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('archives-afficher'),
												$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Groupes$Update$ArchivesDemandees)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$referentielGroupesArchives,
													i18n,
													{
														w: $elm$core$String$fromInt(annuaire.i$)
													}))
											]))
									]);
							} else {
								return _List_Nil;
							}
						}())
					]))
			]);
	});
var $author$project$Components$Referentiel$Groupes$View$view = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'referentiel-groupes-list',
			{
				ut: A2(
					$elm$core$List$cons,
					A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2($author$project$Components$Referentiel$Groupes$View$tableau, i18n, model),
							model.aS))),
				xy: _List_fromArray(
					[
						A2($author$project$Components$Referentiel$Groupes$View$creation, i18n, model)
					]),
				zM: _List_Nil,
				AK: $author$project$Components$Referentiel$Groupes$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: A2(
							$elm$core$List$cons,
							A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('compteur')
									]),
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										$author$project$Components$Referentiel$Groupes$View$compteur(i18n),
										model.aS))),
							A2($author$project$Components$Referentiel$Groupes$View$nouveauGroupe, i18n, model)),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adressePartiesPrenantes,
								Dj: $author$project$I18n$Cles$referentielGroupesFil(i18n)
							},
								{
								aa: $author$project$Routes$Route$adresseGroupes,
								Dj: $author$project$I18n$Cles$referentielGroupesTitre(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$referentielGroupesTitre(i18n)
					})
			});
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$CreationDemandee = function (a) {
	return {$: 40, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$Ouvrir = 0;
var $author$project$Components$Referentiel$NouvelleFiche$Model$EnAjouterUneAutre = 1;
var $author$project$Components$Referentiel$NouvelleFiche$View$enCours = function (model) {
	var _v0 = model.l2;
	if (_v0.$ === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$I18n$Cles$referentielCreationCreerEtAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.creer-et-ajouter', _List_Nil, 'Créer et en ajouter une autre');
};
var $author$project$Components$Referentiel$NouvelleFiche$View$actionSecondaire = F2(
	function (i18n, model) {
		return _List_fromArray(
			[
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Referentiel$NouvelleFiche$Update$CreationDemandee(1)),
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'loading',
								$author$project$Components$Referentiel$NouvelleFiche$View$enCours(model))
							])),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
						$author$project$Components$Referentiel$NouvelleFiche$View$enCours(model))
					]),
				$author$project$I18n$Cles$referentielCreationCreerEtAjouter(i18n))
			]);
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$ChampDuTypeSaisi = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$choixDuType = F3(
	function (sansNom, model, uid) {
		return _Utils_ap(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.jN;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.r8;
								},
								$elm$core$Basics$eq(uid)),
							model.ib)))),
			A4(
				$author$project$Components$Referentiel$Common$ChoixDeLien$choixDesLiens,
				sansNom,
				model.nQ,
				_List_Nil,
				$author$project$Components$Referentiel$NouvelleFiche$Model$champsDuTypeASaisir(model)));
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$codeDeType = $author$project$Components$Referentiel$Identifiants$typeUidToString;
var $author$project$Components$Referentiel$Common$TypesServis$libelle = function (servi) {
	return servi.R.zX;
};
var $author$project$Components$Referentiel$Common$TypesServis$proposables = $elm$core$List$filter(
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Basics$not,
		function ($) {
			return $.tE;
		}));
var $author$project$Components$Referentiel$NouvelleFiche$Model$optionsDeType = function (types) {
	return A2(
		$elm$core$List$map,
		function (servi) {
			return {
				Bl: $author$project$Components$Referentiel$Common$TypesServis$libelle(servi),
				fm: $author$project$Components$Referentiel$Identifiants$typeUidToString(servi.r8)
			};
		},
		$author$project$Components$Referentiel$Common$TypesServis$proposables(types));
};
var $author$project$Components$Referentiel$NouvelleFiche$View$libelleDuTypeChoisi = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.Bl;
			},
			A2(
				$elm$core$Maybe$andThen,
				function (choisi) {
					return $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (fournie) {
								return _Utils_eq(
									fournie.fm,
									$author$project$Components$Referentiel$NouvelleFiche$Model$codeDeType(choisi));
							},
							$author$project$Components$Referentiel$NouvelleFiche$Model$optionsDeType(model.ib)));
				},
				model.hP.r0)));
};
var $author$project$I18n$Cles$referentielCreationSectionChampsDuType = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.creation.section.champs-du-type',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			'Champs du type « ' + (p.Bl + ' »'));
	});
var $author$project$Components$Referentiel$NouvelleFiche$View$champsDuType = F2(
	function (i18n, model) {
		var champs = $author$project$Components$Referentiel$NouvelleFiche$Model$champsDuTypeASaisir(model);
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'hidden',
							$elm$core$List$isEmpty(champs))
						]))
				]),
			{
				fw: _List_Nil,
				fZ: function () {
					var _v0 = _Utils_Tuple2(model.hQ, model.nQ.Et);
					if (!_v0.a.$) {
						if (!_v0.b.$) {
							var recherche = _v0.b.a;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$map,
									$author$project$Components$Referentiel$NouvelleFiche$Update$LienDeChamp,
									A3(
										$author$project$Components$Referentiel$Common$ChoixDeLien$view,
										i18n,
										$author$project$I18n$Cles$referentielLienSansNom(i18n),
										recherche))
								]);
						} else {
							var lu = _v0.a.a;
							var _v1 = _v0.b;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('champs')
										]),
									A2(
										$elm$core$List$map,
										$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Referentiel$NouvelleFiche$Update$ChampDuTypeSaisi),
										A3(
											$author$project$Components$Shared$EditeurDeSchema$SaisieParSchema$view,
											i18n,
											A6(
												$author$project$Components$Referentiel$Common$ChampsDuType$presentation,
												model.hd,
												$author$project$Components$Referentiel$Common$ChampsDuType$prefixe('referentiel-nouvelle-fiche'),
												false,
												A3(
													$author$project$Components$Referentiel$NouvelleFiche$Model$choixDuType,
													$author$project$I18n$Cles$referentielLienSansNom(i18n),
													model,
													lu.r0),
												lu.aN,
												model.jE),
											model.jE)))
								]);
						}
					} else {
						var _v2 = _v0.a;
						return _List_Nil;
					}
				}(),
				Dj: 'champs-du-type',
				h6: A2(
					$author$project$I18n$Cles$referentielCreationSectionChampsDuType,
					i18n,
					{
						Bl: $author$project$Components$Referentiel$NouvelleFiche$View$libelleDuTypeChoisi(model)
					})
			});
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$IdentifiantLegalSaisi = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$LangueChoisie = function (a) {
	return {$: 25, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$DoublonEcarte = function (a) {
	return {$: 46, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$forts = function (doublons) {
	return A2(
		$elm$core$List$filter,
		function (candidat) {
			return !candidat.os;
		},
		$author$project$Components$Referentiel$NouvelleFiche$Doublons$offerts(doublons));
};
var $author$project$Components$Referentiel$NouvelleFiche$View$memeIdentifiantSeul = function (candidat) {
	return _Utils_eq(
		candidat.CY,
		_List_fromArray(
			[4]));
};
var $author$project$I18n$Cles$referentielCreationDoublonsNomMasque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.doublons.nom-masque', _List_Nil, 'Nom masqué');
};
var $author$project$Components$Referentiel$NouvelleFiche$View$nomDuCandidat = F2(
	function (i18n, candidat) {
		var _v0 = _Utils_Tuple2(candidat.Dj, candidat.gt);
		if (!_v0.a.$) {
			var nom = _v0.a.a;
			return nom;
		} else {
			if (_v0.b === 4) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return $author$project$I18n$Cles$referentielFicheTitreEffacee(i18n);
			} else {
				var _v3 = _v0.a;
				return $author$project$I18n$Cles$referentielCreationDoublonsNomMasque(i18n);
			}
		}
	});
var $author$project$I18n$Cles$referentielCreationIdentifiantLegalNumero = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.identifiant-legal.numero', _List_Nil, 'numéro');
};
var $author$project$Components$Referentiel$NouvelleFiche$View$alerteDeLIdentifiant = F2(
	function (i18n, model) {
		var _v0 = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				$author$project$Components$Referentiel$NouvelleFiche$View$memeIdentifiantSeul,
				$author$project$Components$Referentiel$NouvelleFiche$Doublons$forts(model.xM)));
		if (!_v0.$) {
			var autre = _v0.a;
			var saisi = $elm$core$String$trim(model.hP.m7);
			var sorte = (model.hP.ho !== 'FR') ? $author$project$I18n$Cles$referentielCreationIdentifiantLegalNumero(i18n) : (($elm$core$String$length(
				A2($elm$core$String$filter, $elm$core$Char$isDigit, saisi)) === 14) ? $author$project$I18n$Cles$referentielFicheIdentifiantLegalSiret(i18n) : $author$project$I18n$Cles$referentielFicheIdentifiantLegalSiren(i18n));
			var nom = A2($author$project$Components$Referentiel$NouvelleFiche$View$nomDuCandidat, i18n, autre);
			return A2(
				$author$project$Components$Shared$Note$View$view,
				1,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielFicheIdentiteDoublonTitre(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$referentielFicheIdentiteDoublonTexte,
									i18n,
									{Dj: nom, rg: sorte, fm: saisi}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('issue')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
										$rtfeldman$elm_css$Html$Styled$Attributes$href(
										$author$project$Routes$Route$toString(
											A2($author$project$Routes$Route$Fiche, autre.r8, 0))),
										$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank'),
										$rtfeldman$elm_css$Html$Styled$Attributes$rel('noopener')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$referentielFicheIdentiteDoublonOuvrir,
											i18n,
											{Dj: nom}))
									])),
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								2,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Referentiel$NouvelleFiche$Update$DoublonEcarte(autre.r8))
									]),
								$author$project$I18n$Cles$referentielFicheIdentiteDoublonGarder(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mention')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielFicheIdentiteDoublonMention(i18n))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$referentielCreationAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.aucune', _List_Nil, 'Aucune');
};
var $author$project$Components$Referentiel$NouvelleFiche$View$aucune = function (i18n) {
	return {
		Bl: $author$project$I18n$Cles$referentielCreationAucune(i18n),
		fm: ''
	};
};
var $author$project$Components$Referentiel$NouvelleFiche$View$compteurDuNumeroLibre = F3(
	function (i18n, pays, saisie) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('compteur')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					((pays === 'FR') || (pays === '')) ? '' : A2(
						$author$project$I18n$Cles$referentielCreationIdentifiantLegalCompteur,
						i18n,
						{
							w: $elm$core$String$fromInt(
								$elm$core$String$length(saisie)),
							h1: '32'
						}))
				]));
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$ContactAjoute = {$: 32};
var $author$project$Components$Referentiel$NouvelleFiche$Update$CanalChoisi = F2(
	function (a, b) {
		return {$: 34, a: a, b: b};
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$ContactRetire = function (a) {
	return {$: 33, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$PrincipalChoisi = function (a) {
	return {$: 38, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$ProspectionChoisie = F2(
	function (a, b) {
		return {$: 39, a: a, b: b};
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$UsageChoisi = F2(
	function (a, b) {
		return {$: 37, a: a, b: b};
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$ValeurDeContactSaisie = F2(
	function (a, b) {
		return {$: 35, a: a, b: b};
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$ChampDAdresseSaisi = F3(
	function (a, b, c) {
		return {$: 36, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$NouvelleFiche$View$aChoisir = function (i18n) {
	return {
		Bl: $author$project$I18n$Cles$referentielCreationChoisir(i18n),
		fm: ''
	};
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$dUneAdresse = F2(
	function (rang, saisie) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (ligne) {
					return ligne.uF === 2;
				},
				$elm$core$List$head(
					A2($elm$core$List$drop, rang, saisie.wa))));
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$erreursDeLaLigne = F2(
	function (rang, saisie) {
		return A2(
			$elm$core$List$map,
			$elm$core$Tuple$second,
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var ligne = _v0.a;
					return _Utils_eq(ligne, rang);
				},
				$author$project$Components$Referentiel$Common$Contact$erreurs(saisie.wa)));
	});
var $author$project$I18n$Cles$referentielCreationPrenomOuEmail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.prenom-ou-email', _List_Nil, 'Saisissez un prénom ou un email.');
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$messageDuChamp = F3(
	function (i18n, saisie, champ) {
		switch (champ.$) {
			case 0:
				return $author$project$I18n$Cles$referentielCreationPrenomOuEmail(i18n);
			case 7:
				var rang = champ.a;
				var _v1 = A2($author$project$Components$Referentiel$NouvelleFiche$Model$erreursDeLaLigne, rang, saisie);
				_v1$4:
				while (true) {
					if (_v1.b) {
						switch (_v1.a.$) {
							case 1:
								var _v2 = _v1.a;
								return $author$project$I18n$Cles$referentielCreationContactEmailInvalide(i18n);
							case 2:
								var _v3 = _v1.a;
								return $author$project$I18n$Cles$referentielCreationContactTelephoneInvalide(i18n);
							case 3:
								var _v4 = _v1.a;
								return $author$project$I18n$Cles$referentielCreationContactAdresseWebInvalide(i18n);
							case 4:
								var _v5 = _v1.a;
								return $author$project$I18n$Cles$referentielCreationContactEmailEnDouble(i18n);
							default:
								break _v1$4;
						}
					} else {
						break _v1$4;
					}
				}
				return $author$project$I18n$Cles$referentielCreationChampObligatoire(i18n);
			case 8:
				var rang = champ.a;
				var _v6 = A2($author$project$Components$Referentiel$NouvelleFiche$Model$erreursDeLaLigne, rang, saisie);
				if (_v6.b && (_v6.a.$ === 6)) {
					return $author$project$I18n$Cles$referentielCreationContactAdresseTropLongue(i18n);
				} else {
					return $author$project$I18n$Cles$referentielCreationChampObligatoire(i18n);
				}
			default:
				return $author$project$I18n$Cles$referentielCreationChampObligatoire(i18n);
		}
	});
var $author$project$I18n$Cles$referentielCreationContactRefuse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.contact.refuse', _List_Nil, 'Cette valeur a été refusée par le serveur.');
};
var $author$project$I18n$Cles$referentielCreationIdentifiantLegalInvalide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.identifiant-legal-invalide', _List_Nil, 'Identifiant légal invalide : ce n\'est ni un SIREN ni un SIRET valide. Vérifiez les chiffres.');
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$erreurDuChamp = F3(
	function (i18n, model, champ) {
		if (model.gm && A2(
			$elm$core$List$member,
			champ,
			$author$project$Components$Referentiel$NouvelleFiche$Model$enErreur(model.hP))) {
			return $elm$core$Maybe$Just(
				A3($author$project$Components$Referentiel$NouvelleFiche$Model$messageDuChamp, i18n, model.hP, champ));
		} else {
			_v0$3:
			while (true) {
				switch (champ.$) {
					case 6:
						return model.bI ? $elm$core$Maybe$Just(
							$author$project$I18n$Cles$referentielCreationIdentifiantLegalInvalide(i18n)) : $elm$core$Maybe$Nothing;
					case 7:
						var rang = champ.a;
						return _Utils_eq(
							model.gU,
							$elm$core$Maybe$Just(rang)) ? $elm$core$Maybe$Just(
							$author$project$I18n$Cles$referentielCreationContactEmailEnDouble(i18n)) : ((A2($elm$core$List$member, rang, model.eb) && (!A2($author$project$Components$Referentiel$NouvelleFiche$Model$dUneAdresse, rang, model.hP))) ? $elm$core$Maybe$Just(
							$author$project$I18n$Cles$referentielCreationContactRefuse(i18n)) : $elm$core$Maybe$Nothing);
					case 8:
						if (!champ.b) {
							var rang = champ.a;
							var _v1 = champ.b;
							return (A2($elm$core$List$member, rang, model.eb) && A2($author$project$Components$Referentiel$NouvelleFiche$Model$dUneAdresse, rang, model.hP)) ? $elm$core$Maybe$Just(
								$author$project$I18n$Cles$referentielCreationContactRefuse(i18n)) : $elm$core$Maybe$Nothing;
						} else {
							break _v0$3;
						}
					default:
						break _v0$3;
				}
			}
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$View$adresse = F4(
	function (i18n, model, rang, ligne) {
		var unChamp = F3(
			function (partie, libelle, obligatoire) {
				return {
					go: A3(
						$author$project$Components$Referentiel$NouvelleFiche$Model$erreurDuChamp,
						i18n,
						model,
						A2($author$project$Components$Referentiel$NouvelleFiche$Model$ChampAdresse, rang, partie)),
					Aq: $author$project$Components$Referentiel$NouvelleFiche$Model$idDuChamp(
						A2($author$project$Components$Referentiel$NouvelleFiche$Model$ChampAdresse, rang, partie)),
					Bl: libelle,
					he: obligatoire
				};
			});
		var texteDe = F4(
			function (partie, libelle, obligatoire, valeur) {
				return A2(
					$author$project$Components$Shared$Champ$View$texte,
					A3(unChamp, partie, libelle, obligatoire),
					{
						hg: A2($author$project$Components$Referentiel$NouvelleFiche$Update$ChampDAdresseSaisi, rang, partie),
						fm: valeur
					});
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$fieldset,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('adresse')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$legend,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielCreationContactAdresse(i18n))
								]))
						])),
					A4(
					texteDe,
					0,
					$author$project$I18n$Cles$referentielCreationContactAdresseLigne1(i18n),
					true,
					ligne.aa.a3),
					A4(
					texteDe,
					1,
					$author$project$I18n$Cles$referentielCreationContactAdresseLigne2(i18n),
					false,
					ligne.aa.a4),
					A4(
					texteDe,
					2,
					$author$project$I18n$Cles$referentielCreationContactAdresseLigne3(i18n),
					false,
					ligne.aa.a5),
					A4(
					texteDe,
					3,
					$author$project$I18n$Cles$referentielCreationContactAdresseCodePostal(i18n),
					false,
					ligne.aa.vz),
					A4(
					texteDe,
					4,
					$author$project$I18n$Cles$referentielCreationContactAdresseLocalite(i18n),
					true,
					ligne.aa.B_),
					A4(
					texteDe,
					5,
					$author$project$I18n$Cles$referentielCreationContactAdresseRegion(i18n),
					false,
					ligne.aa.Hj),
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					A3(
						unChamp,
						6,
						$author$project$I18n$Cles$referentielCreationContactAdressePays(i18n),
						true),
					{
						hg: A2($author$project$Components$Referentiel$NouvelleFiche$Update$ChampDAdresseSaisi, rang, 6),
						o_: A2(
							$elm$core$List$cons,
							$author$project$Components$Referentiel$NouvelleFiche$View$aChoisir(i18n),
							A2(
								$elm$core$List$map,
								function (pays) {
									return {Bl: pays.Dj, fm: pays.vx};
								},
								$author$project$Referentiel$Normes$entreesDePays(model.hd))),
						fm: ligne.aa.ho
					})
				]));
	});
var $author$project$Components$Referentiel$NouvelleFiche$View$champ = F4(
	function (i18n, model, fourni, libelle) {
		return {
			go: A3($author$project$Components$Referentiel$NouvelleFiche$Model$erreurDuChamp, i18n, model, fourni),
			Aq: $author$project$Components$Referentiel$NouvelleFiche$Model$idDuChamp(fourni),
			Bl: libelle,
			he: !(_Utils_eq(fourni, $author$project$Components$Referentiel$NouvelleFiche$Model$ChampPrenom) && $author$project$Components$Referentiel$NouvelleFiche$Model$prenomFacultatif(model.hP))
		};
	});
var $author$project$I18n$Cles$referentielContactUsageAutre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.contact.usage.autre', _List_Nil, 'Autre');
};
var $author$project$I18n$Cles$referentielContactUsageFacturation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.contact.usage.facturation', _List_Nil, 'Facturation');
};
var $author$project$I18n$Cles$referentielContactUsageLivraison = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.contact.usage.livraison', _List_Nil, 'Livraison');
};
var $author$project$I18n$Cles$referentielContactUsagePersonnel = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.contact.usage.personnel', _List_Nil, 'Personnel');
};
var $author$project$I18n$Cles$referentielContactUsageProfessionnel = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.contact.usage.professionnel', _List_Nil, 'Professionnel');
};
var $author$project$I18n$Cles$referentielContactUsageSiege = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.contact.usage.siege', _List_Nil, 'Siège');
};
var $author$project$Components$Referentiel$NouvelleFiche$View$libelleDeLUsage = F2(
	function (i18n, usage) {
		switch (usage) {
			case 0:
				return $author$project$I18n$Cles$referentielContactUsagePersonnel(i18n);
			case 1:
				return $author$project$I18n$Cles$referentielContactUsageProfessionnel(i18n);
			case 2:
				return $author$project$I18n$Cles$referentielContactUsageFacturation(i18n);
			case 3:
				return $author$project$I18n$Cles$referentielContactUsageLivraison(i18n);
			case 4:
				return $author$project$I18n$Cles$referentielContactUsageSiege(i18n);
			default:
				return $author$project$I18n$Cles$referentielContactUsageAutre(i18n);
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$View$libelleDeLaProspection = F2(
	function (i18n, canal) {
		switch (canal) {
			case 0:
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$referentielCreationContactProspectionEmail(i18n));
			case 1:
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$referentielCreationContactProspectionTelephone(i18n));
			case 2:
				return $elm$core$Maybe$Nothing;
			case 3:
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$I18n$Cles$referentielContactCanalAdresse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.contact.canal.adresse', _List_Nil, 'Adresse postale');
};
var $author$project$I18n$Cles$referentielContactCanalEmail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.contact.canal.email', _List_Nil, 'Email');
};
var $author$project$I18n$Cles$referentielContactCanalReseau = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.contact.canal.reseau', _List_Nil, 'Réseau');
};
var $author$project$I18n$Cles$referentielContactCanalSiteWeb = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.contact.canal.site-web', _List_Nil, 'Site web');
};
var $author$project$I18n$Cles$referentielContactCanalTelephone = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.contact.canal.telephone', _List_Nil, 'Téléphone');
};
var $author$project$Components$Referentiel$NouvelleFiche$View$libelleDuCanal = F2(
	function (i18n, canal) {
		switch (canal) {
			case 0:
				return $author$project$I18n$Cles$referentielContactCanalEmail(i18n);
			case 1:
				return $author$project$I18n$Cles$referentielContactCanalTelephone(i18n);
			case 2:
				return $author$project$I18n$Cles$referentielContactCanalAdresse(i18n);
			case 3:
				return $author$project$I18n$Cles$referentielContactCanalSiteWeb(i18n);
			default:
				return $author$project$I18n$Cles$referentielContactCanalReseau(i18n);
		}
	});
var $author$project$I18n$Cles$referentielCreationContactLigne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.creation.contact.ligne',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rang',
					$author$project$I18n$Traductions$Chaine(p.bY))
				]),
			'Moyen de contact ' + p.bY);
	});
var $author$project$I18n$Cles$referentielCreationContactPrincipal = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.contact.principal', _List_Nil, 'Principal');
};
var $author$project$I18n$Cles$referentielCreationContactRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.contact.retirer', _List_Nil, 'Retirer');
};
var $author$project$I18n$Cles$referentielCreationContactRetirerLaLigne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.creation.contact.retirer-la-ligne',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rang',
					$author$project$I18n$Traductions$Chaine(p.bY))
				]),
			'Retirer le moyen de contact ' + p.bY);
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$rattachementOffert = function (model) {
	return (!model.hP.g1) && ((!_Utils_eq(model.gT, $elm$core$Maybe$Nothing)) && (!_Utils_eq(
		$author$project$Components$Referentiel$NouvelleFiche$Model$lienDeLaRecherche(model),
		$elm$core$Maybe$Nothing)));
};
var $author$project$Components$Referentiel$NouvelleFiche$View$usageLie = F3(
	function (i18n, model, rang) {
		var _v0 = _Utils_Tuple2(
			$author$project$Components$Referentiel$NouvelleFiche$Model$rattachementOffert(model) && A2($author$project$Components$Referentiel$NouvelleFiche$Model$liable, rang, model.hP),
			$author$project$Components$Referentiel$NouvelleFiche$Model$organisationChoisie(model.hP));
		if (_v0.a && (!_v0.b.$)) {
			var organisation = _v0.b.a;
			return _List_fromArray(
				[
					{
					Bl: A2(
						$author$project$I18n$Cles$referentielCreationContactUsageLie,
						i18n,
						{
							En: A2($author$project$I18n$Cles$texte, i18n, organisation.Dj)
						}),
					fm: $author$project$Components$Referentiel$NouvelleFiche$Model$codeDUsageLie
				}
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$View$contact = F4(
	function (i18n, model, rang, ligne) {
		var numero = $elm$core$String$fromInt(rang + 1);
		var idDe = $author$project$Components$Referentiel$NouvelleFiche$Model$idDuContact(rang);
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('contact'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('postale', ligne.uF === 2)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					A2(
						$author$project$I18n$Cles$referentielCreationContactLigne,
						i18n,
						{bY: numero}))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: idDe('canal'),
						Bl: $author$project$I18n$Cles$referentielCreationContactCanal(i18n),
						he: false
					},
					{
						hg: $author$project$Components$Referentiel$NouvelleFiche$Update$CanalChoisi(rang),
						o_: A2(
							$elm$core$List$map,
							function (canal) {
								return {
									Bl: A2($author$project$Components$Referentiel$NouvelleFiche$View$libelleDuCanal, i18n, canal),
									fm: $author$project$Components$Referentiel$Common$Contact$canalCode(canal)
								};
							},
							$author$project$Components$Referentiel$Common$Contact$canaux),
						fm: $author$project$Components$Referentiel$Common$Contact$canalCode(ligne.uF)
					}),
					A2(
					$author$project$Components$Shared$Champ$View$texte,
					A4(
						$author$project$Components$Referentiel$NouvelleFiche$View$champ,
						i18n,
						model,
						$author$project$Components$Referentiel$NouvelleFiche$Model$ChampContact(rang),
						$author$project$I18n$Cles$referentielCreationContactValeur(i18n)),
					{
						hg: $author$project$Components$Referentiel$NouvelleFiche$Update$ValeurDeContactSaisie(rang),
						fm: ligne.fm
					}),
					A4($author$project$Components$Referentiel$NouvelleFiche$View$adresse, i18n, model, rang, ligne),
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: idDe('usage'),
						Bl: $author$project$I18n$Cles$referentielCreationContactUsage(i18n),
						he: false
					},
					{
						hg: $author$project$Components$Referentiel$NouvelleFiche$Update$UsageChoisi(rang),
						o_: _Utils_ap(
							A2(
								$elm$core$List$map,
								function (usage) {
									return {
										Bl: A2($author$project$Components$Referentiel$NouvelleFiche$View$libelleDeLUsage, i18n, usage),
										fm: $author$project$Components$Referentiel$Common$Contact$usageCode(usage)
									};
								},
								$author$project$Components$Referentiel$Common$Contact$usages),
							A3($author$project$Components$Referentiel$NouvelleFiche$View$usageLie, i18n, model, rang)),
						fm: A2($author$project$Components$Referentiel$NouvelleFiche$Model$estLie, rang, model.hP) ? $author$project$Components$Referentiel$NouvelleFiche$Model$codeDUsageLie : $author$project$Components$Referentiel$Common$Contact$usageCode(ligne.sd)
					}),
					A3(
					$rtfeldman$elm_css$Html$Styled$Keyed$node,
					'label',
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('principal')
						]),
					_List_fromArray(
						[
							_Utils_Tuple2(
							A2(
								$elm$core$String$join,
								'-',
								A2(
									$elm$core$List$map,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.uF;
										},
										$author$project$Components$Referentiel$Common$Contact$canalCode),
									model.hP.wa)),
							A2(
								$rtfeldman$elm_css$Html$Styled$input,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
										$rtfeldman$elm_css$Html$Styled$Attributes$id(
										idDe('principal')),
										$rtfeldman$elm_css$Html$Styled$Attributes$name(
										'nouvelle-fiche-principal-' + $author$project$Components$Referentiel$Common$Contact$canalCode(ligne.uF)),
										$rtfeldman$elm_css$Html$Styled$Attributes$checked(ligne.px),
										$rtfeldman$elm_css$Html$Styled$Events$onCheck(
										function (_v0) {
											return $author$project$Components$Referentiel$NouvelleFiche$Update$PrincipalChoisi(rang);
										})
									]),
								_List_Nil)),
							_Utils_Tuple2(
							'libelle',
							A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielCreationContactPrincipal(i18n))
									])))
						])),
					function () {
					var _v1 = A2($author$project$Components$Referentiel$NouvelleFiche$View$libelleDeLaProspection, i18n, ligne.uF);
					if (!_v1.$) {
						var libelle = _v1.a;
						return A2(
							$author$project$Components$Shared$Champ$View$caseACocher,
							{
								go: $elm$core$Maybe$Nothing,
								Aq: idDe('prospection'),
								Bl: libelle,
								he: false
							},
							{
								vt: ligne.Gx,
								D9: $author$project$Components$Referentiel$NouvelleFiche$Update$ProspectionChoisie(rang)
							});
					} else {
						return $rtfeldman$elm_css$Html$Styled$text('');
					}
				}(),
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(
							idDe('retirer')),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-label',
							A2(
								$author$project$I18n$Cles$referentielCreationContactRetirerLaLigne,
								i18n,
								{bY: numero})),
							$rtfeldman$elm_css$Html$Styled$Attributes$title(
							A2(
								$author$project$I18n$Cles$referentielCreationContactRetirerLaLigne,
								i18n,
								{bY: numero})),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Referentiel$NouvelleFiche$Update$ContactRetire(rang))
						]),
					$author$project$I18n$Cles$referentielCreationContactRetirer(i18n))
				]));
	});
var $author$project$I18n$Cles$referentielCreationContactAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.contact.ajouter', _List_Nil, 'Ajouter un email, un téléphone ou une adresse');
};
var $author$project$I18n$Cles$referentielCreationContactMaximum = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.contact.maximum', _List_Nil, 'Vingt moyens de contact au plus.');
};
var $author$project$I18n$Cles$referentielCreationContacts = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.contacts', _List_Nil, 'Moyens de contact');
};
var $author$project$Components$Referentiel$NouvelleFiche$View$contacts = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$fieldset,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('contacts')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$legend,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielCreationContacts(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ol,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('lignes')
						]),
					A2(
						$elm$core$List$indexedMap,
						A2($author$project$Components$Referentiel$NouvelleFiche$View$contact, i18n, model),
						model.hP.wa)),
					A4(
					$author$project$Components$Shared$Bouton$View$boutonAvecIcone,
					2,
					$author$project$Components$Shared$Svg$svgAdd,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ajouter'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$NouvelleFiche$Model$idDeLAjoutDeContact),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$NouvelleFiche$Update$ContactAjoute),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
							$author$project$Components$Referentiel$Common$Contact$complet(model.hP.wa))
						]),
					$author$project$I18n$Cles$referentielCreationContactAjouter(i18n)),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('maximum')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Components$Referentiel$Common$Contact$complet(model.hP.wa) ? $author$project$I18n$Cles$referentielCreationContactMaximum(i18n) : '')
						]))
				]));
	});
var $author$project$Components$Referentiel$NouvelleFiche$View$facultatif = F2(
	function (id, libelle) {
		return {go: $elm$core$Maybe$Nothing, Aq: id, Bl: libelle, he: false};
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$ChampIdentifiantLegal = {$: 6};
var $author$project$I18n$Cles$referentielCreationIdentifiantLegal = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.identifiant-legal', _List_Nil, 'Identifiant légal');
};
var $author$project$Components$Referentiel$NouvelleFiche$View$identifiantLegal = F2(
	function (i18n, model) {
		return {
			go: A3($author$project$Components$Referentiel$NouvelleFiche$Model$erreurDuChamp, i18n, model, $author$project$Components$Referentiel$NouvelleFiche$Model$ChampIdentifiantLegal),
			Aq: $author$project$Components$Referentiel$NouvelleFiche$Model$idDuChamp($author$project$Components$Referentiel$NouvelleFiche$Model$ChampIdentifiantLegal),
			Bl: $author$project$I18n$Cles$referentielCreationIdentifiantLegal(i18n),
			he: false
		};
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$SocieteCochee = function (a) {
	return {$: 48, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$View$propositionDeSociete = F2(
	function (i18n, model) {
		var _v0 = $author$project$Components$Referentiel$NouvelleFiche$Doublons$societeProposee(model.xM);
		if (!_v0.$) {
			var societe = _v0.a;
			var nom = A2($author$project$Components$Referentiel$NouvelleFiche$View$nomDuCandidat, i18n, societe);
			return A2(
				$author$project$Components$Shared$Note$View$view,
				0,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$referentielCreationSocieteTitre,
									i18n,
									{
										Dj: nom,
										rc: $author$project$Components$Referentiel$Common$IdentifiantLegal$groupe(
											A2(
												$elm$core$String$left,
												9,
												A2($elm$core$String$filter, $elm$core$Char$isDigit, model.hP.m7)))
									}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielCreationSocieteTexte(i18n))
							])),
						A2(
						$author$project$Components$Shared$Champ$View$caseACocher,
						{
							go: $elm$core$Maybe$Nothing,
							Aq: 'creation-societe-a-rattacher',
							Bl: A2(
								$author$project$I18n$Cles$referentielCreationSocieteCase,
								i18n,
								{Dj: nom}),
							he: false
						},
						{vt: !model.xM.b2, D9: $author$project$Components$Referentiel$NouvelleFiche$Update$SocieteCochee}),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mention')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielCreationSocieteMention(i18n))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$IntituleSaisi = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$OrganisationChoisie = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$OrganisationSaisie = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$PosteChoisi = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$View$idDeLOrganisation = 'nouvelle-fiche-organisation';
var $author$project$Components$Referentiel$NouvelleFiche$Model$optionsDePoste = F2(
	function (i18n, postes) {
		return A2(
			$elm$core$List$map,
			function (poste) {
				return {
					Bl: A2(
						$author$project$I18n$Cles$texte,
						i18n,
						$author$project$Components$Referentiel$Vocabulaire$libelleDuPoste(poste)),
					fm: $author$project$Components$Referentiel$Identifiants$posteUidToString(poste.r8)
				};
			},
			postes);
	});
var $author$project$Components$Referentiel$NouvelleFiche$View$rattachement = F2(
	function (i18n, model) {
		var saisi = model.hP.pN;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('rattachement'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'hidden',
							!$author$project$Components$Referentiel$NouvelleFiche$Model$rattachementOffert(model))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Champ$View$texte,
					A2(
						$author$project$Components$Referentiel$NouvelleFiche$View$facultatif,
						$author$project$Components$Referentiel$NouvelleFiche$View$idDeLOrganisation,
						$author$project$I18n$Cles$referentielRattachementRattacherAUneOrganisation(i18n)),
					{
						hg: $author$project$Components$Referentiel$NouvelleFiche$Update$OrganisationSaisie,
						fm: A2($author$project$Components$Referentiel$Common$RechercheDeFiche$valeurDuChamp, i18n, saisi.hC)
					}),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('propositions')
						]),
					A2(
						$elm$core$List$map,
						function (proposee) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$button,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('proposition'),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												$author$project$Components$Referentiel$NouvelleFiche$Update$OrganisationChoisie(proposee.r8))
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$strong,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2($author$project$I18n$Cles$texte, i18n, proposee.Dj))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('nature')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2($author$project$I18n$Cles$texte, i18n, proposee.g1))
													]))
											]))
									]));
						},
						saisi.hC.Gw)),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('poste'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'hidden',
									_Utils_eq(
										$author$project$Components$Referentiel$NouvelleFiche$Model$organisationChoisie(model.hP),
										$elm$core$Maybe$Nothing))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Champ$View$liste,
							A4(
								$author$project$Components$Referentiel$NouvelleFiche$View$champ,
								i18n,
								model,
								$author$project$Components$Referentiel$NouvelleFiche$Model$ChampPoste,
								$author$project$I18n$Cles$referentielRattachementPoste(i18n)),
							{
								hg: $author$project$Components$Referentiel$NouvelleFiche$Update$PosteChoisi,
								o_: A2(
									$elm$core$List$cons,
									$author$project$Components$Referentiel$NouvelleFiche$View$aChoisir(i18n),
									A2($author$project$Components$Referentiel$NouvelleFiche$Model$optionsDePoste, i18n, model.F6)),
								fm: A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Maybe$map, $author$project$Components$Referentiel$Identifiants$posteUidToString, saisi.F4))
							}),
							A2(
							$author$project$Components$Shared$Champ$View$texte,
							A2(
								$author$project$Components$Referentiel$NouvelleFiche$View$facultatif,
								'nouvelle-fiche-intitule',
								$author$project$I18n$Cles$referentielRattachementIntituleFacultatif(i18n)),
							{hg: $author$project$Components$Referentiel$NouvelleFiche$Update$IntituleSaisi, fm: saisi.AS})
						]))
				]));
	});
var $author$project$I18n$Cles$referentielCreationLangue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.langue', _List_Nil, 'Langue');
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$ResponsableChoisi = function (a) {
	return {$: 26, a: a};
};
var $author$project$I18n$Cles$referentielCreationResponsable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.responsable', _List_Nil, 'Responsable');
};
var $author$project$I18n$Cles$referentielCreationResponsableMoi = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.responsable.moi', _List_Nil, 'Moi');
};
var $author$project$I18n$Cles$referentielCreationResponsableMoiNomme = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.creation.responsable.moi-nomme',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.Dj + ' (moi)');
	});
var $author$project$Components$Referentiel$NouvelleFiche$View$responsable = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('responsable'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'hidden',
							$elm$core$List$isEmpty(
								$author$project$Components$Referentiel$Common$Equipe$candidats(model.l5)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					A2(
						$author$project$Components$Referentiel$NouvelleFiche$View$facultatif,
						'nouvelle-fiche-responsable',
						$author$project$I18n$Cles$referentielCreationResponsable(i18n)),
					{
						hg: $author$project$Components$Referentiel$NouvelleFiche$Update$ResponsableChoisi,
						o_: A2(
							$elm$core$List$cons,
							{
								Bl: function () {
									var _v0 = $elm$core$List$head(
										A2(
											$elm$core$List$filter,
											function ($) {
												return $.og;
											},
											$author$project$Components$Referentiel$Common$Equipe$candidats(model.l5)));
									if (!_v0.$) {
										var moi = _v0.a;
										return A2(
											$author$project$I18n$Cles$referentielCreationResponsableMoiNomme,
											i18n,
											{Dj: moi.Dj});
									} else {
										return $author$project$I18n$Cles$referentielCreationResponsableMoi(i18n);
									}
								}(),
								fm: ''
							},
							A2(
								$elm$core$List$map,
								function (membre) {
									return {Bl: membre.Dj, fm: membre.r8};
								},
								A2(
									$elm$core$List$filter,
									function (membre) {
										return !membre.og;
									},
									$author$project$Components$Referentiel$Common$Equipe$candidats(model.l5)))),
						fm: model.hP.qB
					})
				]));
	});
var $author$project$Components$Referentiel$NouvelleFiche$View$sansTitre = F2(
	function (nom, contenu) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class(nom)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					contenu)
				]));
	});
var $author$project$Components$Referentiel$NouvelleFiche$View$complements = F2(
	function (i18n, model) {
		return A2(
			$author$project$Components$Referentiel$NouvelleFiche$View$sansTitre,
			'complements',
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('identifiant-legal'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('hidden', model.hP.g1 !== 1)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Champ$View$texteDecritPar,
							A2($author$project$Components$Referentiel$NouvelleFiche$View$identifiantLegal, i18n, model),
							{wV: 'nouvelle-fiche-identifiant-legal-aide', hg: $author$project$Components$Referentiel$NouvelleFiche$Update$IdentifiantLegalSaisi, fm: model.hP.m7}),
							A3($author$project$Components$Referentiel$NouvelleFiche$View$compteurDuNumeroLibre, i18n, model.hP.ho, model.hP.m7),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aide'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id('nouvelle-fiche-identifiant-legal-aide')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									((model.hP.ho === 'FR') || (model.hP.ho === '')) ? $author$project$I18n$Cles$referentielFicheIdentiteDrawerIdentifiantAide(i18n) : $author$project$I18n$Cles$referentielCreationIdentifiantLegalAideLibre(i18n))
								])),
							A2($author$project$Components$Referentiel$NouvelleFiche$View$alerteDeLIdentifiant, i18n, model),
							A2($author$project$Components$Referentiel$NouvelleFiche$View$propositionDeSociete, i18n, model)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('langue')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Champ$View$liste,
							A2(
								$author$project$Components$Referentiel$NouvelleFiche$View$facultatif,
								'nouvelle-fiche-langue',
								$author$project$I18n$Cles$referentielCreationLangue(i18n)),
							{
								hg: $author$project$Components$Referentiel$NouvelleFiche$Update$LangueChoisie,
								o_: A2(
									$elm$core$List$cons,
									$author$project$Components$Referentiel$NouvelleFiche$View$aucune(i18n),
									A2(
										$elm$core$List$map,
										function (langue) {
											return {
												Bl: A2($author$project$I18n$Cles$texte, i18n, langue.Bl),
												fm: langue.vx
											};
										},
										$author$project$Referentiel$Langues$toutes)),
								fm: model.hP.nn
							})
						])),
					A2($author$project$Components$Referentiel$NouvelleFiche$View$contacts, i18n, model),
					A2($author$project$Components$Referentiel$NouvelleFiche$View$rattachement, i18n, model),
					A2($author$project$Components$Referentiel$NouvelleFiche$View$responsable, i18n, model)
				]));
	});
var $author$project$I18n$Cles$referentielCreationRejeuCorrectionsPerdues = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.rejeu.corrections-perdues', _List_Nil, 'La fiche précédente avait déjà été créée avec votre première saisie. Vos corrections n\'ont pas été appliquées.');
};
var $author$project$I18n$Cles$referentielCreationRejeuOuvrir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.rejeu.ouvrir', _List_Nil, 'Ouvrir la fiche');
};
var $author$project$Components$Referentiel$NouvelleFiche$View$correctionsPerdues = F2(
	function (i18n, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (entite) {
					return _List_fromArray(
						[
							{
							aa: $author$project$Routes$Route$toString(
								A2($author$project$Routes$Route$Fiche, entite, 0)),
							Bl: $author$project$I18n$Cles$referentielCreationRejeuOuvrir(i18n),
							Jx: $author$project$I18n$Cles$referentielCreationRejeuCorrectionsPerdues(i18n)
						}
						]);
				},
				model.kd));
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$BaseLegaleChoisie = function (a) {
	return {$: 28, a: a};
};
var $author$project$I18n$Cles$referentielBaseLegaleConsentement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.base-legale.consentement', _List_Nil, 'Consentement');
};
var $author$project$I18n$Cles$referentielBaseLegaleContrat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.base-legale.contrat', _List_Nil, 'Contrat');
};
var $author$project$I18n$Cles$referentielBaseLegaleInteretLegitime = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.base-legale.interet-legitime', _List_Nil, 'Intérêt légitime');
};
var $author$project$I18n$Cles$referentielBaseLegaleObligationLegale = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.base-legale.obligation-legale', _List_Nil, 'Obligation légale');
};
var $author$project$Components$Referentiel$NouvelleFiche$View$libelleDeBaseLegale = F2(
	function (i18n, base) {
		switch (base) {
			case 0:
				return $author$project$I18n$Cles$referentielBaseLegaleConsentement(i18n);
			case 1:
				return $author$project$I18n$Cles$referentielBaseLegaleInteretLegitime(i18n);
			case 2:
				return $author$project$I18n$Cles$referentielBaseLegaleContrat(i18n);
			default:
				return $author$project$I18n$Cles$referentielBaseLegaleObligationLegale(i18n);
		}
	});
var $author$project$I18n$Cles$referentielCreationBaseLegale = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.base-legale', _List_Nil, 'Base légale');
};
var $author$project$I18n$Cles$referentielCreationSectionDonneesPersonnelles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.section.donnees-personnelles', _List_Nil, 'Données personnelles');
};
var $author$project$Components$Referentiel$NouvelleFiche$View$donneesPersonnelles = F2(
	function (i18n, model) {
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('hidden', !(!model.hP.g1))
						]))
				]),
			{
				fw: _List_Nil,
				fZ: _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Champ$View$liste,
						A4(
							$author$project$Components$Referentiel$NouvelleFiche$View$champ,
							i18n,
							model,
							$author$project$Components$Referentiel$NouvelleFiche$Model$ChampBaseLegale,
							$author$project$I18n$Cles$referentielCreationBaseLegale(i18n)),
						{
							hg: $author$project$Components$Referentiel$NouvelleFiche$Update$BaseLegaleChoisie,
							o_: A2(
								$elm$core$List$cons,
								$author$project$Components$Referentiel$NouvelleFiche$View$aChoisir(i18n),
								A2(
									$elm$core$List$map,
									function (base) {
										return {
											Bl: A2($author$project$Components$Referentiel$NouvelleFiche$View$libelleDeBaseLegale, i18n, base),
											fm: $author$project$Components$Referentiel$NouvelleFiche$Model$baseLegaleCode(base)
										};
									},
									$author$project$Components$Referentiel$NouvelleFiche$Model$basesLegales)),
							fm: A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Maybe$map, $author$project$Components$Referentiel$NouvelleFiche$Model$baseLegaleCode, model.hP.fI))
						})
					]),
				Dj: 'donnees-personnelles',
				h6: $author$project$I18n$Cles$referentielCreationSectionDonneesPersonnelles(i18n)
			});
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$HomonymesBascules = {$: 52};
var $author$project$Components$Referentiel$NouvelleFiche$View$boolEnTexte = function (vrai) {
	return vrai ? 'true' : 'false';
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$RoleAjouteDemande = function (a) {
	return {$: 53, a: a};
};
var $author$project$I18n$Cles$referentielCreationDoublonsMotifMemeEmail = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.doublons.motif.meme-email', _List_Nil, 'Même email');
};
var $author$project$I18n$Cles$referentielCreationDoublonsMotifMemeIdentifiantLegal = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.doublons.motif.meme-identifiant-legal', _List_Nil, 'Même identifiant légal');
};
var $author$project$I18n$Cles$referentielCreationDoublonsMotifMemeNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.doublons.motif.meme-nom', _List_Nil, 'Même nom et prénom');
};
var $author$project$I18n$Cles$referentielCreationDoublonsMotifMemeRaisonSociale = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.doublons.motif.meme-raison-sociale', _List_Nil, 'Même raison sociale');
};
var $author$project$I18n$Cles$referentielCreationDoublonsMotifMemeTelephone = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.doublons.motif.meme-telephone', _List_Nil, 'Même téléphone');
};
var $author$project$Components$Referentiel$NouvelleFiche$View$libelleDuMotif = F2(
	function (i18n, motif) {
		switch (motif) {
			case 0:
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$referentielCreationDoublonsMotifMemeEmail(i18n));
			case 1:
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$referentielCreationDoublonsMotifMemeTelephone(i18n));
			case 2:
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$referentielCreationDoublonsMotifMemeNom(i18n));
			case 3:
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$referentielCreationDoublonsMotifMemeRaisonSociale(i18n));
			case 4:
				return $elm$core$Maybe$Just(
					$author$project$I18n$Cles$referentielCreationDoublonsMotifMemeIdentifiantLegal(i18n));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Referentiel$Common$TypesServis$nommer = F3(
	function (types, uid, archetype) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$Referentiel$Archetype$libelle(archetype),
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$TypesServis$libelle, $author$project$I18n$Traductions$tel),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (servi) {
							return _Utils_eq(
								$elm$core$Maybe$Just(servi.r8),
								uid);
						},
						types))));
	});
var $author$project$Components$Referentiel$NouvelleFiche$View$nomDuRoleDeCandidat = F3(
	function (i18n, model, role) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.Dj;
			},
			role.D1);
		if (!_v0.$) {
			var offre = _v0.a;
			return A2(
				$author$project$I18n$Cles$referentielRoleLibelle,
				i18n,
				{
					D1: offre,
					rX: A2(
						$author$project$I18n$Cles$texte,
						i18n,
						A3($author$project$Components$Referentiel$Common$TypesServis$nommer, model.ib, role.r0, role.fA))
				});
		} else {
			return A2(
				$author$project$I18n$Cles$texte,
				i18n,
				A3($author$project$Components$Referentiel$Common$TypesServis$nommer, model.ib, role.r0, role.fA));
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$View$rangDuMotif = function (motif) {
	switch (motif) {
		case 2:
			return 0;
		case 3:
			return 1;
		case 4:
			return 1;
		case 0:
			return 2;
		case 1:
			return 3;
		default:
			return 4;
	}
};
var $author$project$I18n$Cles$referentielCreationDoublonsAjouterLeRole = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.doublons.ajouter-le-role', _List_Nil, 'Ajouter le rôle à cette fiche');
};
var $author$project$I18n$Cles$referentielCreationDoublonsOuvrir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.doublons.ouvrir', _List_Nil, 'Ouvrir la fiche');
};
var $author$project$I18n$Cles$referentielCreationDoublonsOuvrirLaFicheDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.creation.doublons.ouvrir-la-fiche-de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.Dj)))
				]),
			'Ouvrir la fiche ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.Dj);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.Dj);
					default:
						return 'de ' + $elm$core$String$trim(p.Dj);
				}
			}() + ' dans un nouvel onglet'));
	});
var $author$project$I18n$Cles$referentielCreationDoublonsPasLaMemePersonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.doublons.pas-la-meme-personne', _List_Nil, 'Ce n\'est pas la même personne');
};
var $author$project$I18n$Cles$referentielRoleErreurDejaOuvert = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.role.erreur.deja-ouvert',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typeDeRole',
					$author$project$I18n$Traductions$Chaine(p.rX)),
					_Utils_Tuple2(
					'offre',
					$author$project$I18n$Traductions$Chaine(p.D1))
				]),
			'Un rôle ' + (p.rX + (' est déjà ouvert pour ' + p.D1)));
	});
var $author$project$I18n$Cles$referentielRoleErreurRecouvrement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.erreur.recouvrement', _List_Nil, 'Un rôle de ce type couvre déjà cette période');
};
var $author$project$I18n$Cles$referentielRoleRelationGenerale = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.relation-generale', _List_Nil, 'Relation générale');
};
var $author$project$Components$Referentiel$NouvelleFiche$View$refusDeLAjout = F3(
	function (i18n, model, candidat) {
		var _v0 = model.xM.pZ;
		if (!_v0.$) {
			var _v1 = _v0.a;
			var fiche = _v1.a;
			var refus = _v1.b;
			if (!_Utils_eq(fiche, candidat.r8)) {
				return '';
			} else {
				if (!refus) {
					return A2(
						$author$project$I18n$Cles$referentielRoleErreurDejaOuvert,
						i18n,
						{
							D1: $author$project$I18n$Cles$referentielRoleRelationGenerale(i18n),
							rX: $author$project$Components$Referentiel$NouvelleFiche$View$libelleDuTypeChoisi(model)
						});
				} else {
					return $author$project$I18n$Cles$referentielRoleErreurRecouvrement(i18n);
				}
			}
		} else {
			return '';
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$View$ficheRapprochee = F3(
	function (i18n, model, candidat) {
		var roleChoisi = !_Utils_eq(model.hP.r0, $elm$core$Maybe$Nothing);
		var nom = A2($author$project$Components$Referentiel$NouvelleFiche$View$nomDuCandidat, i18n, candidat);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('cartouche-doublon')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('content')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('main')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('title')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(nom)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('pills')
										]),
									(candidat.gt === 1) ? _List_fromArray(
										[
											A2(
											$author$project$Components$Shared$Tag$View$view,
											3,
											$author$project$I18n$Cles$referentielPartiesPrenantesMarqueClose(i18n))
										]) : _List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$ul,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('infos')
										]),
									_Utils_ap(
										A2(
											$elm$core$List$filterMap,
											A2(
												$elm$core$Basics$composeR,
												$author$project$Components$Referentiel$NouvelleFiche$View$libelleDuMotif(i18n),
												$elm$core$Maybe$map(
													function (libelle) {
														return A2(
															$rtfeldman$elm_css$Html$Styled$li,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$class('motif')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(libelle)
																]));
													})),
											A2($elm$core$List$sortBy, $author$project$Components$Referentiel$NouvelleFiche$View$rangDuMotif, candidat.CY)),
										A2(
											$elm$core$List$map,
											function (role) {
												return A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('role')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															A3($author$project$Components$Referentiel$NouvelleFiche$View$nomDuRoleDeCandidat, i18n, model, role))
														]));
											},
											candidat.eX))),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('refus-de-l-ajout'),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A3($author$project$Components$Referentiel$NouvelleFiche$View$refusDeLAjout, i18n, model, candidat))
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					_Utils_ap(
						candidat.Ex ? _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('secondary'),
										$rtfeldman$elm_css$Html$Styled$Attributes$href(
										$author$project$Routes$Route$toString(
											A2($author$project$Routes$Route$Fiche, candidat.r8, 0))),
										$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank'),
										$rtfeldman$elm_css$Html$Styled$Attributes$rel('noopener'),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
										'aria-label',
										A2(
											$author$project$I18n$Cles$referentielCreationDoublonsOuvrirLaFicheDe,
											i18n,
											{
												av: $author$project$Texte$Elision$elision(nom),
												Dj: nom
											}))
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$referentielCreationDoublonsOuvrir(i18n))
											]))
									]))
							]) : _List_Nil,
						_Utils_ap(
							((!_Utils_eq(candidat.s9, $elm$core$Maybe$Nothing)) && ((candidat.gt !== 1) && roleChoisi)) ? _List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('ajouter-le-role'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Referentiel$NouvelleFiche$Update$RoleAjouteDemande(candidat.r8))
										]),
									$author$project$I18n$Cles$referentielCreationDoublonsAjouterLeRole(i18n))
								]) : _List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('pas-la-meme-personne'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Referentiel$NouvelleFiche$Update$DoublonEcarte(candidat.r8))
										]),
									$author$project$I18n$Cles$referentielCreationDoublonsPasLaMemePersonne(i18n))
								]))))
				]));
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$FicheRestaureeDemandee = function (a) {
	return {$: 55, a: a};
};
var $author$project$I18n$Cles$referentielCreationDoublonsFicheSupprimee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.doublons.fiche-supprimee', _List_Nil, 'Fiche supprimée — la restaurer ?');
};
var $author$project$I18n$Cles$referentielCreationDoublonsRestaurer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.doublons.restaurer', _List_Nil, 'Restaurer la fiche');
};
var $author$project$Components$Referentiel$NouvelleFiche$View$ficheSupprimee = F2(
	function (i18n, candidat) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('cartouche-doublon'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('fiche-supprimee')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('content')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('main')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('title')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$referentielCreationDoublonsFicheSupprimee(i18n))
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('restaurer-la-fiche'),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Referentiel$NouvelleFiche$Update$FicheRestaureeDemandee(candidat.r8))
								]),
							$author$project$I18n$Cles$referentielCreationDoublonsRestaurer(i18n))
						]))
				]));
	});
var $author$project$Components$Referentiel$NouvelleFiche$View$doublon = F3(
	function (i18n, model, candidat) {
		return (candidat.gt === 2) ? A2($author$project$Components$Referentiel$NouvelleFiche$View$ficheSupprimee, i18n, candidat) : A3($author$project$Components$Referentiel$NouvelleFiche$View$ficheRapprochee, i18n, model, candidat);
	});
var $author$project$Components$Referentiel$NouvelleFiche$Doublons$homonymes = function (doublons) {
	return A2(
		$elm$core$List$filter,
		function (candidat) {
			return candidat.os === 1;
		},
		$author$project$Components$Referentiel$NouvelleFiche$Doublons$offerts(doublons));
};
var $author$project$I18n$Cles$referentielCreationDoublonsHomonymesPlusieurs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.creation.doublons.homonymes.plusieurs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			p.w + ' homonymes');
	});
var $author$project$I18n$Cles$referentielCreationDoublonsHomonymesUn = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.doublons.homonymes.un', _List_Nil, '1 homonyme');
};
var $author$project$Components$Referentiel$NouvelleFiche$View$libelleDesHomonymes = F2(
	function (i18n, nombre) {
		return (nombre === 1) ? $author$project$I18n$Cles$referentielCreationDoublonsHomonymesUn(i18n) : A2(
			$author$project$I18n$Cles$referentielCreationDoublonsHomonymesPlusieurs,
			i18n,
			{
				w: $elm$core$String$fromInt(nombre)
			});
	});
var $author$project$Components$Referentiel$NouvelleFiche$View$nomDuPays = F2(
	function (normes, code) {
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.Dj;
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (pays) {
						return _Utils_eq(pays.vx, code);
					},
					$author$project$Referentiel$Normes$entreesDePays(normes))));
	});
var $author$project$Components$Referentiel$NouvelleFiche$View$ligneDHomonyme = F3(
	function (i18n, model, candidat) {
		var nom = A2($author$project$Components$Referentiel$NouvelleFiche$View$nomDuCandidat, i18n, candidat);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne-homonyme')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('title')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(nom)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('pills')
								]),
							(candidat.gt === 1) ? _List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Tag$View$view,
									3,
									$author$project$I18n$Cles$referentielPartiesPrenantesMarqueClose(i18n))
								]) : _List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('roles')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$elm$core$String$concat(
										A2(
											$elm$core$List$map,
											function (partie) {
												return ' · ' + partie;
											},
											_Utils_ap(
												A2(
													$elm$core$List$map,
													A2($author$project$Components$Referentiel$NouvelleFiche$View$nomDuRoleDeCandidat, i18n, model),
													candidat.eX),
												A2(
													$elm$core$List$filterMap,
													$elm$core$Basics$identity,
													_List_fromArray(
														[
															A2(
															$elm$core$Maybe$andThen,
															$author$project$Components$Referentiel$NouvelleFiche$View$nomDuPays(model.hd),
															candidat.ho)
														]))))))
								]))
						])),
					candidat.Ex ? A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$href(
							$author$project$Routes$Route$toString(
								A2($author$project$Routes$Route$Fiche, candidat.r8, 0))),
							$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank'),
							$rtfeldman$elm_css$Html$Styled$Attributes$rel('noopener'),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-label',
							A2(
								$author$project$I18n$Cles$referentielCreationDoublonsOuvrirLaFicheDe,
								i18n,
								{
									av: $author$project$Texte$Elision$elision(nom),
									Dj: nom
								}))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$referentielCreationDoublonsOuvrir(i18n))
						])) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$I18n$Cles$referentielCreationDoublonsHomonymesChevronFerme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.doublons.homonymes.chevron-ferme', _List_Nil, '›');
};
var $author$project$I18n$Cles$referentielCreationDoublonsHomonymesChevronOuvert = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.doublons.homonymes.chevron-ouvert', _List_Nil, '▾');
};
var $author$project$I18n$Cles$referentielCreationDoublonsHomonymesMasquer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.doublons.homonymes.masquer', _List_Nil, ' — masquer');
};
var $author$project$I18n$Cles$referentielCreationDoublonsHomonymesVoir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.doublons.homonymes.voir', _List_Nil, ' — voir');
};
var $author$project$I18n$Cles$referentielCreationDoublonsMention = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.doublons.mention', _List_Nil, 'Signal fort : même email, même téléphone ou même identifiant légal, ou un homonyme avec un second indice concordant. Même nom et prénom seuls : simple signal faible, replié. Jamais de fusion automatique.');
};
var $author$project$I18n$Cles$referentielCreationDoublonsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.doublons.titre', _List_Nil, 'Une fiche existe peut-être déjà');
};
var $author$project$Components$Referentiel$NouvelleFiche$View$doublons = F2(
	function (i18n, model) {
		var homonymes = $author$project$Components$Referentiel$NouvelleFiche$Doublons$homonymes(model.xM);
		var forts = A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Components$Referentiel$NouvelleFiche$View$memeIdentifiantSeul),
			$author$project$Components$Referentiel$NouvelleFiche$Doublons$forts(model.xM));
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'hidden',
							$elm$core$List$isEmpty(forts) && $elm$core$List$isEmpty(homonymes))
						])),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
				]),
			{
				fw: _List_Nil,
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('cartes'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('fiches-a-signal-fort')
							]),
						A2(
							$elm$core$List$map,
							function (candidat) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_Nil,
									_List_fromArray(
										[
											A3($author$project$Components$Referentiel$NouvelleFiche$View$doublon, i18n, model, candidat)
										]));
							},
							forts)),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('homonymes'),
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'hidden',
										$elm$core$List$isEmpty(homonymes))
									]))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('voir-les-homonymes'),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
										'aria-expanded',
										$author$project$Components$Referentiel$NouvelleFiche$View$boolEnTexte(model.xM.d0)),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$NouvelleFiche$Update$HomonymesBascules)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$strong,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2(
															$author$project$Components$Referentiel$NouvelleFiche$View$libelleDesHomonymes,
															i18n,
															$elm$core$List$length(homonymes)))
													])),
												$rtfeldman$elm_css$Html$Styled$text(
												model.xM.d0 ? $author$project$I18n$Cles$referentielCreationDoublonsHomonymesMasquer(i18n) : $author$project$I18n$Cles$referentielCreationDoublonsHomonymesVoir(i18n))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('chevron'),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												model.xM.d0 ? $author$project$I18n$Cles$referentielCreationDoublonsHomonymesChevronOuvert(i18n) : $author$project$I18n$Cles$referentielCreationDoublonsHomonymesChevronFerme(i18n))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$ul,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('liste-des-homonymes'),
										$rtfeldman$elm_css$Html$Styled$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('hidden', !model.xM.d0)
											]))
									]),
								A2(
									$elm$core$List$map,
									function (candidat) {
										return A2(
											$rtfeldman$elm_css$Html$Styled$li,
											_List_Nil,
											_List_fromArray(
												[
													A3($author$project$Components$Referentiel$NouvelleFiche$View$ligneDHomonyme, i18n, model, candidat)
												]));
									},
									homonymes))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mention')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielCreationDoublonsMention(i18n))
							]))
					]),
				Dj: 'doublons',
				h6: $author$project$I18n$Cles$referentielCreationDoublonsTitre(i18n)
			});
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$CiviliteChoisie = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$FormeChoisie = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$NomSaisi = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$PaysChoisi = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$PrenomSaisi = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$Professionnel = 1;
var $author$project$Components$Referentiel$NouvelleFiche$Update$QualiteChoisie = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$RaisonSocialeSaisie = function (a) {
	return {$: 21, a: a};
};
var $author$project$I18n$Cles$referentielCreationQualiteParticulierDescription = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.qualite.particulier.description', _List_Nil, 'Agit à titre personnel.');
};
var $author$project$I18n$Cles$referentielCreationQualiteProfessionnelDescription = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.qualite.professionnel.description', _List_Nil, 'Agit dans le cadre de son activité.');
};
var $author$project$Components$Referentiel$NouvelleFiche$View$descriptionDeQualite = F2(
	function (i18n, qualite) {
		if (!qualite) {
			return $author$project$I18n$Cles$referentielCreationQualiteParticulierDescription(i18n);
		} else {
			return $author$project$I18n$Cles$referentielCreationQualiteProfessionnelDescription(i18n);
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$View$libelleDeQualite = F2(
	function (i18n, qualite) {
		if (!qualite) {
			return $author$project$I18n$Cles$referentielQualiteParticulier(i18n);
		} else {
			return $author$project$I18n$Cles$referentielQualiteProfessionnel(i18n);
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$optionsDeForme = function (formes) {
	return A2(
		$elm$core$List$map,
		function (forme) {
			return {
				Bl: forme.Bl,
				fm: $author$project$Components$Referentiel$Identifiants$formeUidToString(forme.r8)
			};
		},
		A2(
			$elm$core$List$filter,
			function (forme) {
				return !forme.tI;
			},
			formes));
};
var $author$project$Components$Referentiel$NouvelleFiche$View$qualiteDe = function (code) {
	return _Utils_eq(
		code,
		$author$project$Components$Referentiel$NouvelleFiche$Model$qualiteCode(1)) ? 1 : 0;
};
var $author$project$I18n$Cles$referentielCreationCivilite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.civilite', _List_Nil, 'Civilité');
};
var $author$project$I18n$Cles$referentielCreationForme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.forme', _List_Nil, 'Forme');
};
var $author$project$I18n$Cles$referentielCreationFormeAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.forme-aucune', _List_Nil, 'Choisir une forme');
};
var $author$project$I18n$Cles$referentielCreationNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.nom', _List_Nil, 'Nom');
};
var $author$project$I18n$Cles$referentielCreationPays = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.pays', _List_Nil, 'Pays');
};
var $author$project$I18n$Cles$referentielCreationPrenom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.prenom', _List_Nil, 'Prénom');
};
var $author$project$I18n$Cles$referentielCreationQualite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.qualite', _List_Nil, 'Qualité');
};
var $author$project$I18n$Cles$referentielCreationRaisonSociale = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.raison-sociale', _List_Nil, 'Raison sociale');
};
var $author$project$Components$Referentiel$NouvelleFiche$View$tuile = F3(
	function (valeur, titre, description) {
		return {dH: description, h6: titre, fm: valeur};
	});
var $author$project$Components$Referentiel$NouvelleFiche$View$identite = F2(
	function (i18n, model) {
		return A2(
			$author$project$Components$Referentiel$NouvelleFiche$View$sansTitre,
			'identite',
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('personne'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('hidden', !(!model.hP.g1))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Champ$View$liste,
							A2(
								$author$project$Components$Referentiel$NouvelleFiche$View$facultatif,
								'nouvelle-fiche-civilite',
								$author$project$I18n$Cles$referentielCreationCivilite(i18n)),
							{
								hg: $author$project$Components$Referentiel$NouvelleFiche$Update$CiviliteChoisie,
								o_: A2(
									$elm$core$List$cons,
									$author$project$Components$Referentiel$NouvelleFiche$View$aucune(i18n),
									A2(
										$elm$core$List$map,
										function (code) {
											return {
												Bl: A2(
													$author$project$I18n$Cles$texte,
													i18n,
													$author$project$Referentiel$Civilites$nom(code)),
												fm: code
											};
										},
										$author$project$Referentiel$Civilites$toutes)),
								fm: model.hP.vh
							}),
							A2(
							$author$project$Components$Shared$Champ$View$texte,
							A4(
								$author$project$Components$Referentiel$NouvelleFiche$View$champ,
								i18n,
								model,
								$author$project$Components$Referentiel$NouvelleFiche$Model$ChampPrenom,
								$author$project$I18n$Cles$referentielCreationPrenom(i18n)),
							{hg: $author$project$Components$Referentiel$NouvelleFiche$Update$PrenomSaisi, fm: model.hP.Gg}),
							A2(
							$author$project$Components$Shared$Champ$View$texte,
							A4(
								$author$project$Components$Referentiel$NouvelleFiche$View$champ,
								i18n,
								model,
								$author$project$Components$Referentiel$NouvelleFiche$Model$ChampNom,
								$author$project$I18n$Cles$referentielCreationNom(i18n)),
							{hg: $author$project$Components$Referentiel$NouvelleFiche$Update$NomSaisi, fm: model.hP.Dj}),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('qualite')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Tuiles$View$view,
									{
										ve: $elm$core$Maybe$Just(
											$author$project$Components$Referentiel$NouvelleFiche$Model$qualiteCode(model.hP.hy)),
										Bi: $author$project$I18n$Cles$referentielCreationQualite(i18n),
										Dj: 'nouvelle-fiche-qualite',
										Eb: A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$NouvelleFiche$View$qualiteDe, $author$project$Components$Referentiel$NouvelleFiche$Update$QualiteChoisie)
									},
									A2(
										$elm$core$List$map,
										function (qualite) {
											return A3(
												$author$project$Components$Referentiel$NouvelleFiche$View$tuile,
												$author$project$Components$Referentiel$NouvelleFiche$Model$qualiteCode(qualite),
												A2($author$project$Components$Referentiel$NouvelleFiche$View$libelleDeQualite, i18n, qualite),
												A2($author$project$Components$Referentiel$NouvelleFiche$View$descriptionDeQualite, i18n, qualite));
										},
										_List_fromArray(
											[1, 0])))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('organisation'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('hidden', model.hP.g1 !== 1)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Champ$View$texte,
							A4(
								$author$project$Components$Referentiel$NouvelleFiche$View$champ,
								i18n,
								model,
								$author$project$Components$Referentiel$NouvelleFiche$Model$ChampRaisonSociale,
								$author$project$I18n$Cles$referentielCreationRaisonSociale(i18n)),
							{hg: $author$project$Components$Referentiel$NouvelleFiche$Update$RaisonSocialeSaisie, fm: model.hP.GR}),
							A2(
							$author$project$Components$Shared$Champ$View$liste,
							A4(
								$author$project$Components$Referentiel$NouvelleFiche$View$champ,
								i18n,
								model,
								$author$project$Components$Referentiel$NouvelleFiche$Model$ChampForme,
								$author$project$I18n$Cles$referentielCreationForme(i18n)),
							{
								hg: $author$project$Components$Referentiel$NouvelleFiche$Update$FormeChoisie,
								o_: A2(
									$elm$core$List$cons,
									{
										Bl: $author$project$I18n$Cles$referentielCreationFormeAucune(i18n),
										fm: ''
									},
									$author$project$Components$Referentiel$NouvelleFiche$Model$optionsDeForme(model.zS)),
								fm: A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Maybe$map, $author$project$Components$Referentiel$Identifiants$formeUidToString, model.hP.gB))
							})
						])),
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					A4(
						$author$project$Components$Referentiel$NouvelleFiche$View$champ,
						i18n,
						model,
						$author$project$Components$Referentiel$NouvelleFiche$Model$ChampPays,
						$author$project$I18n$Cles$referentielCreationPays(i18n)),
					{
						hg: $author$project$Components$Referentiel$NouvelleFiche$Update$PaysChoisi,
						o_: A2(
							$elm$core$List$cons,
							$author$project$Components$Referentiel$NouvelleFiche$View$aChoisir(i18n),
							A2(
								$elm$core$List$map,
								function (pays) {
									return {Bl: pays.Dj, fm: pays.vx};
								},
								$author$project$Referentiel$Normes$entreesDePays(model.hd))),
						fm: model.hP.ho
					})
				]));
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$NatureChoisie = function (a) {
	return {$: 17, a: a};
};
var $author$project$I18n$Cles$referentielCreationNatureOrganisationDescription = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.nature.organisation.description', _List_Nil, 'Une entité : entreprise, association, administration.');
};
var $author$project$I18n$Cles$referentielCreationNaturePersonneDescription = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.nature.personne.description', _List_Nil, 'Un individu : candidat, étudiant, contact.');
};
var $author$project$Components$Referentiel$NouvelleFiche$View$descriptionDeNature = F2(
	function (i18n, nature) {
		if (!nature) {
			return $author$project$I18n$Cles$referentielCreationNaturePersonneDescription(i18n);
		} else {
			return $author$project$I18n$Cles$referentielCreationNatureOrganisationDescription(i18n);
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$View$libelleDeNature = F2(
	function (i18n, nature) {
		if (!nature) {
			return $author$project$I18n$Cles$referentielNaturePersonne(i18n);
		} else {
			return $author$project$I18n$Cles$referentielNatureOrganisation(i18n);
		}
	});
var $author$project$Components$Referentiel$NouvelleFiche$Model$natureCode = function (nature) {
	if (!nature) {
		return 'personne';
	} else {
		return 'organisation';
	}
};
var $author$project$Components$Referentiel$NouvelleFiche$View$natureDe = function (code) {
	return _Utils_eq(
		code,
		$author$project$Components$Referentiel$NouvelleFiche$Model$natureCode(1)) ? 1 : 0;
};
var $author$project$Components$Referentiel$NouvelleFiche$Model$nomDuGroupeNature = 'nouvelle-fiche-nature';
var $author$project$I18n$Cles$referentielCreationNature = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.nature', _List_Nil, 'Nature');
};
var $author$project$Components$Shared$Tuiles$View$viewObligatoire = F2(
	function (groupe, tuiles) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$fieldset,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('tuiles'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('mandatory')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$legend,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(groupe.Bi),
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('asterisque')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('*')
										]))
								]))
						])),
				A2(
					$elm$core$List$map,
					$author$project$Components$Shared$Tuiles$View$tuile(groupe),
					tuiles)));
	});
var $author$project$Components$Referentiel$NouvelleFiche$View$natureEtRole = F2(
	function (i18n, model) {
		return A2(
			$author$project$Components$Referentiel$NouvelleFiche$View$sansTitre,
			'nature-et-role',
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Tuiles$View$viewObligatoire,
					{
						ve: $elm$core$Maybe$Just(
							$author$project$Components$Referentiel$NouvelleFiche$Model$natureCode(model.hP.g1)),
						Bi: $author$project$I18n$Cles$referentielCreationNature(i18n),
						Dj: $author$project$Components$Referentiel$NouvelleFiche$Model$nomDuGroupeNature,
						Eb: A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$NouvelleFiche$View$natureDe, $author$project$Components$Referentiel$NouvelleFiche$Update$NatureChoisie)
					},
					A2(
						$elm$core$List$map,
						function (nature) {
							return A3(
								$author$project$Components$Referentiel$NouvelleFiche$View$tuile,
								$author$project$Components$Referentiel$NouvelleFiche$Model$natureCode(nature),
								A2($author$project$Components$Referentiel$NouvelleFiche$View$libelleDeNature, i18n, nature),
								A2($author$project$Components$Referentiel$NouvelleFiche$View$descriptionDeNature, i18n, nature));
						},
						_List_fromArray(
							[0, 1])))
				]));
	});
var $author$project$I18n$Cles$referentielCreationRejeuNonVerifiee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.rejeu.non-verifiee', _List_Nil, 'La fiche précédente avait déjà été créée. Vos corrections n\'ont pas pu être vérifiées.');
};
var $author$project$Components$Referentiel$NouvelleFiche$View$nonVerifiee = F2(
	function (i18n, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (entite) {
					return _List_fromArray(
						[
							{
							aa: $author$project$Routes$Route$toString(
								A2($author$project$Routes$Route$Fiche, entite, 0)),
							Bl: $author$project$I18n$Cles$referentielCreationRejeuOuvrir(i18n),
							Jx: $author$project$I18n$Cles$referentielCreationRejeuNonVerifiee(i18n)
						}
						]);
				},
				model.oI));
	});
var $author$project$Components$Referentiel$NouvelleFiche$Update$PersonneEffaceeCochee = function (a) {
	return {$: 47, a: a};
};
var $author$project$I18n$Cles$referentielCreationPersonneEffaceeAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.personne-effacee.aide', _List_Nil, 'La recréation est inscrite au journal des effacements. La nouvelle fiche repart de zéro, sans lien avec l\'ancienne.');
};
var $author$project$I18n$Cles$referentielCreationPersonneEffaceeCase = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.personne-effacee.case', _List_Nil, 'La personne me le demande elle-même');
};
var $author$project$I18n$Cles$referentielCreationPersonneEffaceeMessage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.creation.personne-effacee.message',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Cette personne a demandé l\'effacement de ses données le ' + (p.wv + '. Ne recréez sa fiche que si elle le demande elle-même.'));
	});
var $author$project$I18n$Cles$referentielCreationPersonneEffaceeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.personne-effacee.titre', _List_Nil, 'Personne effacée');
};
var $author$project$Components$Referentiel$NouvelleFiche$View$personneEffacee = F2(
	function (i18n, model) {
		var reconnue = model.xM.bb;
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'hidden',
							_Utils_eq(reconnue, $elm$core$Maybe$Nothing))
						])),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
				]),
			{
				fw: _List_Nil,
				fZ: function () {
					if (!reconnue.$) {
						var personne = reconnue.a;
						return _Utils_ap(
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('message')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$referentielCreationPersonneEffaceeMessage,
												i18n,
												{
													wv: A2(
														$author$project$Texte$Jour$enFrancais,
														i18n,
														A2($elm$core$String$left, 10, personne.AQ))
												}))
										]))
								]),
							_Utils_eq(personne.f2, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Champ$View$caseACocher,
									{
										go: $elm$core$Maybe$Nothing,
										Aq: 'creation-personne-effacee',
										Bl: $author$project$I18n$Cles$referentielCreationPersonneEffaceeCase(i18n),
										he: false
									},
									{vt: model.xM.a0, D9: $author$project$Components$Referentiel$NouvelleFiche$Update$PersonneEffaceeCochee}),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$referentielCreationPersonneEffaceeAide(i18n))
										]))
								]));
					} else {
						return _List_Nil;
					}
				}(),
				Dj: 'personne-effacee',
				h6: $author$project$I18n$Cles$referentielCreationPersonneEffaceeTitre(i18n)
			});
	});
var $author$project$I18n$Cles$referentielCreationCreer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.creer', _List_Nil, 'Créer la fiche');
};
var $author$project$I18n$Cles$referentielCreationTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.titre', _List_Nil, 'Nouvelle fiche');
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$DebutDuRoleSaisi = function (a) {
	return {$: 31, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$TypeChoisi = function (a) {
	return {$: 29, a: a};
};
var $author$project$Components$Referentiel$NouvelleFiche$Update$OffreChoisie = function (a) {
	return {$: 30, a: a};
};
var $author$project$Components$Referentiel$Common$Offres$nom = function (offre) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$I18n$Textes$referentielRoleOffreIndisponible,
		A2($elm$core$Maybe$map, $author$project$I18n$Traductions$tel, offre.Dj));
};
var $author$project$Components$Referentiel$Common$Offres$proposables = function (lecture) {
	if (lecture.$ === 1) {
		var offres = lecture.a;
		return A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.tL;
				},
				$elm$core$Basics$not),
			offres);
	} else {
		return _List_Nil;
	}
};
var $author$project$I18n$Cles$referentielCreationOffreConcernee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.offre-concernee', _List_Nil, 'Offre concernée');
};
var $author$project$Components$Referentiel$NouvelleFiche$View$offreConcernee = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('offre-concernee')
				]),
			function () {
				var _v0 = model.D3;
				switch (_v0.$) {
					case 0:
						return _List_Nil;
					case 2:
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('erreur')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielRoleDrawerOffresIllisibles(i18n))
									]))
							]);
					default:
						return _List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Champ$View$liste,
								{
									go: $elm$core$Maybe$Nothing,
									Aq: 'nouvelle-fiche-offre',
									Bl: $author$project$I18n$Cles$referentielCreationOffreConcernee(i18n),
									he: false
								},
								{
									hg: $author$project$Components$Referentiel$NouvelleFiche$Update$OffreChoisie,
									o_: A2(
										$elm$core$List$cons,
										{
											Bl: $author$project$I18n$Cles$referentielRoleDrawerOffreAucune(i18n),
											fm: ''
										},
										A2(
											$elm$core$List$map,
											function (offre) {
												return {
													Bl: A2(
														$author$project$I18n$Cles$texte,
														i18n,
														$author$project$Components$Referentiel$Common$Offres$nom(offre)),
													fm: offre.Aq
												};
											},
											$author$project$Components$Referentiel$Common$Offres$proposables(model.D3))),
									fm: model.hP.D1
								})
							]);
				}
			}());
	});
var $author$project$I18n$Cles$referentielCreationDebutDuRole = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.debut-du-role', _List_Nil, 'Date de début du rôle');
};
var $author$project$I18n$Cles$referentielCreationType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.type', _List_Nil, 'Type de partie prenante');
};
var $author$project$I18n$Cles$referentielCreationTypeAucunCreable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.creation.type.aucun-creable', _List_Nil, 'Votre rôle ne permet de créer aucun type de partie prenante : la fiche se crée sans type.');
};
var $author$project$Components$Referentiel$NouvelleFiche$View$typeEtOffre = F2(
	function (i18n, model) {
		return A2(
			$author$project$Components$Referentiel$NouvelleFiche$View$sansTitre,
			'type-et-offre',
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					{
						go: A3($author$project$Components$Referentiel$NouvelleFiche$Model$erreurDuChamp, i18n, model, $author$project$Components$Referentiel$NouvelleFiche$Model$ChampType),
						Aq: 'nouvelle-fiche-type',
						Bl: $author$project$I18n$Cles$referentielCreationType(i18n),
						he: true
					},
					{
						hg: $author$project$Components$Referentiel$NouvelleFiche$Update$TypeChoisi,
						o_: A2(
							$elm$core$List$cons,
							{
								Bl: $author$project$I18n$Cles$referentielCreationChoisir(i18n),
								fm: ''
							},
							$author$project$Components$Referentiel$NouvelleFiche$Model$optionsDeType(model.ib)),
						fm: A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, $author$project$Components$Referentiel$NouvelleFiche$Model$codeDeType, model.hP.r0))
					}),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('aide'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'hidden',
									!$elm$core$List$isEmpty(model.ib))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$referentielCreationTypeAucunCreable(i18n))
						])),
					A2($author$project$Components$Referentiel$NouvelleFiche$View$offreConcernee, i18n, model),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('debut-du-role'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'hidden',
									_Utils_eq(model.hP.r0, $elm$core$Maybe$Nothing))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Champ$View$date,
							{
								go: $elm$core$Maybe$Nothing,
								Aq: 'nouvelle-fiche-debut-du-role',
								Bl: $author$project$I18n$Cles$referentielCreationDebutDuRole(i18n),
								he: false
							},
							{hg: $author$project$Components$Referentiel$NouvelleFiche$Update$DebutDuRoleSaisi, fm: model.hP.dE}),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielRoleDrawerDateDeDebutAide(i18n))
								]))
						]))
				]));
	});
var $author$project$Components$Referentiel$NouvelleFiche$View$view = F3(
	function (i18n, messages, model) {
		var offert = !_Utils_eq(model.dC, $elm$core$Maybe$Nothing);
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$NouvelleFiche$Update$VoletMsg,
			{
				fs: {
					sR: offert && ((!$author$project$Components$Referentiel$NouvelleFiche$View$enCours(model)) && (!$author$project$Components$Referentiel$NouvelleFiche$Doublons$creationRetenue(model.xM))),
					Bl: $author$project$I18n$Cles$referentielCreationCreer(i18n),
					C$: $author$project$Components$Referentiel$NouvelleFiche$Update$CreationDemandee(0)
				},
				fZ: A2(
					$elm$core$List$cons,
					$author$project$Components$Shared$Drawer$Model$estOuvert(model.im) ? A3(
						$author$project$Components$Shared$Messages$View$avec,
						i18n,
						_Utils_ap(
							A2($author$project$Components$Referentiel$NouvelleFiche$View$correctionsPerdues, i18n, model),
							A2($author$project$Components$Referentiel$NouvelleFiche$View$nonVerifiee, i18n, model)),
						messages) : $rtfeldman$elm_css$Html$Styled$text(''),
					offert ? _Utils_ap(
						_List_fromArray(
							[
								A2($author$project$Components$Referentiel$NouvelleFiche$View$natureEtRole, i18n, model),
								A2($author$project$Components$Referentiel$NouvelleFiche$View$identite, i18n, model),
								A2($author$project$Components$Referentiel$NouvelleFiche$View$typeEtOffre, i18n, model),
								A2($author$project$Components$Referentiel$NouvelleFiche$View$complements, i18n, model),
								A2($author$project$Components$Referentiel$NouvelleFiche$View$champsDuType, i18n, model),
								A2($author$project$Components$Referentiel$NouvelleFiche$View$donneesPersonnelles, i18n, model),
								A2($author$project$Components$Referentiel$NouvelleFiche$View$doublons, i18n, model),
								A2($author$project$Components$Referentiel$NouvelleFiche$View$personneEffacee, i18n, model)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('actions-secondaires')
									]),
								A2($author$project$Components$Referentiel$NouvelleFiche$View$actionSecondaire, i18n, model))
							])) : _List_Nil),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$referentielCreationTitre(i18n)
			},
			model.im);
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$AnnuaireMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$AjoutConfirme = {$: 41};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$VoletAjoutMsg = function (a) {
	return {$: 35, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Groupage$dejaCochees = F2(
	function (cochees, fiche) {
		return $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (membre) {
					return A2(
						$elm$core$Set$member,
						$author$project$Components$Referentiel$Identifiants$entiteUidToString(membre.zo),
						cochees);
				},
				A2(
					$elm$core$List$filter,
					function ($) {
						return $.sO;
					},
					fiche.Cm)));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Groupage$dejaMembres = F2(
	function (annuaire, fiche) {
		return $author$project$Components$Referentiel$PartiesPrenantes$Groupage$filtreEntier(annuaire) ? 0 : A2($author$project$Components$Referentiel$PartiesPrenantes$Groupage$dejaCochees, annuaire.vv, fiche);
	});
var $author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$nomDOrganisation = function (i18n) {
	return $elm$core$Maybe$withDefault(
		$author$project$I18n$Cles$referentielFicheNomMasque(i18n));
};
var $author$project$I18n$Cles$referentielPartiesPrenantesOrganisation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.organisation', _List_Nil, 'Organisation');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesOrganisationEtAutres = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parties-prenantes.organisation-et-autres',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'organisation',
					$author$project$I18n$Traductions$Chaine(p.En)),
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			p.En + (' +' + p.w));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$ligneDOrganisation = F2(
	function (i18n, lue) {
		return _Utils_Tuple2(
			$author$project$I18n$Cles$referentielPartiesPrenantesOrganisation(i18n),
			(lue.t7 > 0) ? A2(
				$author$project$I18n$Cles$referentielPartiesPrenantesOrganisationEtAutres,
				i18n,
				{
					w: $elm$core$String$fromInt(lue.t7),
					En: A2($author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$nomDOrganisation, i18n, lue.GR)
				}) : A2($author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$nomDOrganisation, i18n, lue.GR));
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesColonnesCreation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.colonnes.creation', _List_Nil, 'Création');
};
var $author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$ligneDeCreation = F2(
	function (i18n, instant) {
		return _Utils_Tuple2(
			$author$project$I18n$Cles$referentielPartiesPrenantesColonnesCreation(i18n),
			A2(
				$author$project$Texte$Jour$enFrancais,
				i18n,
				A2($elm$core$String$left, 10, instant)));
	});
var $author$project$I18n$Cles$referentielFicheEtatClose = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.etat.close', _List_Nil, 'Close');
};
var $author$project$I18n$Cles$referentielFicheEtatEffacee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.etat.effacee', _List_Nil, 'Effacée');
};
var $author$project$I18n$Cles$referentielFicheEtatSupprimee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.etat.supprimee', _List_Nil, 'Supprimée');
};
var $author$project$Components$Referentiel$Vocabulaire$etatDeLaFiche = F2(
	function (i18n, etat) {
		switch (etat) {
			case 0:
				return $author$project$I18n$Cles$referentielFicheEtatActive(i18n);
			case 1:
				return $author$project$I18n$Cles$referentielFicheEtatClose(i18n);
			case 2:
				return $author$project$I18n$Cles$referentielFicheEtatSupprimee(i18n);
			case 3:
				return $author$project$I18n$Cles$referentielFicheEtatEffacementProgramme(i18n);
			case 4:
				return $author$project$I18n$Cles$referentielFicheEtatEffacee(i18n);
			default:
				return $author$project$I18n$Cles$referentielFicheEtatFusionnee(i18n);
		}
	});
var $author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$libelleDeLaMarque = F2(
	function (i18n, etat) {
		if (etat === 1) {
			return $author$project$I18n$Cles$referentielPartiesPrenantesMarqueClose(i18n);
		} else {
			return A2($author$project$Components$Referentiel$Vocabulaire$etatDeLaFiche, i18n, etat);
		}
	});
var $author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$marquesDEtat = F2(
	function (i18n, etat) {
		if (!etat) {
			return _List_Nil;
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(
					3,
					A2($author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$libelleDeLaMarque, i18n, etat))
				]);
		}
	});
var $author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$nature = F2(
	function (i18n, identite) {
		if (!identite.$) {
			return $author$project$I18n$Cles$referentielNaturePersonne(i18n);
		} else {
			return $author$project$I18n$Cles$referentielNatureOrganisation(i18n);
		}
	});
var $author$project$I18n$Cles$referentielRoleOffreIndisponible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.role.offre-indisponible', _List_Nil, 'Offre non disponible');
};
var $author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$nomDuRole = F3(
	function (i18n, types, role) {
		var type_ = A2(
			$author$project$I18n$Cles$texte,
			i18n,
			A3($author$project$Components$Referentiel$Common$TypesServis$nommer, types, role.r0, role.fA));
		var _v0 = role.D1;
		if (!_v0.$) {
			var offre = _v0.a;
			return A2(
				$author$project$I18n$Cles$referentielRoleLibelle,
				i18n,
				{
					D1: A2(
						$elm$core$Maybe$withDefault,
						$author$project$I18n$Cles$referentielRoleOffreIndisponible(i18n),
						offre.Dj),
					rX: type_
				});
		} else {
			return type_;
		}
	});
var $author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$pays = F2(
	function (normes, code) {
		return A2($author$project$Referentiel$Normes$nomDePays, normes, code);
	});
var $author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$qualite = F2(
	function (i18n, code) {
		switch (code) {
			case 'Particulier':
				return $author$project$I18n$Cles$referentielQualiteParticulier(i18n);
			case 'Professionnel':
				return $author$project$I18n$Cles$referentielQualiteProfessionnel(i18n);
			default:
				return code;
		}
	});
var $author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$titre = F2(
	function (i18n, identite) {
		if (identite.$ === 1) {
			var organisation = identite.a;
			return A2($author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$nomDOrganisation, i18n, organisation.GR);
		} else {
			var personne = identite.a;
			var _v1 = A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[personne.Gg, personne.Dj]));
			if (!_v1.b) {
				return $author$project$I18n$Cles$referentielFicheNomMasque(i18n);
			} else {
				var restants = _v1;
				return A2($elm$core$String$join, ' ', restants);
			}
		}
	});
var $author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$entree = F4(
	function (i18n, normes, types, fiche) {
		return {
			aa: fiche.Ex ? $elm$core$Maybe$Just(
				$author$project$Routes$Route$toString(
					A2($author$project$Routes$Route$Fiche, fiche.r8, 0))) : $elm$core$Maybe$Nothing,
			Aq: $author$project$Components$Referentiel$Identifiants$entiteUidToString(fiche.r8),
			m9: $elm$core$Maybe$Nothing,
			gL: _Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$I18n$Cles$referentielCreationNature(i18n),
						A2($author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$nature, i18n, fiche.Av))
					]),
				_Utils_ap(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (code) {
								return _List_fromArray(
									[
										_Utils_Tuple2(
										$author$project$I18n$Cles$referentielCreationQualite(i18n),
										A2($author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$qualite, i18n, code))
									]);
							},
							fiche.hy)),
					_Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (code) {
									return _List_fromArray(
										[
											_Utils_Tuple2(
											$author$project$I18n$Cles$referentielCreationPays(i18n),
											A2($author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$pays, normes, code))
										]);
								},
								fiche.ho)),
						_Utils_ap(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$ligneDOrganisation(i18n),
										$elm$core$List$singleton),
									fiche.En)),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$ligneDeCreation(i18n),
										$elm$core$List$singleton),
									fiche.wn)))))),
			ry: _Utils_ap(
				A2($author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$marquesDEtat, i18n, fiche.gt),
				A2(
					$elm$core$List$map,
					function (role) {
						return _Utils_Tuple2(
							3,
							A3($author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$nomDuRole, i18n, types, role));
					},
					fiche.eX)),
			rz: _List_Nil,
			h6: A2($author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$titre, i18n, fiche.Av)
		};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$toModel = F4(
	function (i18n, normes, types, vue) {
		return {
			yv: A2(
				$elm$core$List$map,
				A3($author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$entree, i18n, normes, types),
				vue.zu),
			JE: vue.JE
		};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$entreesLues = F2(
	function (i18n, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					A3($author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$toModel, i18n, model.hd, model.ib),
					function ($) {
						return $.yv;
					}),
				model.B1));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Groupage$nomDuDejaMembre = F3(
	function (annuaire, entrees, fiche) {
		var _v0 = A2(
			$elm$core$List$filter,
			function (id) {
				return A2($elm$core$Set$member, id, annuaire.vv);
			},
			A2(
				$elm$core$List$map,
				function (membre) {
					return $author$project$Components$Referentiel$Identifiants$entiteUidToString(membre.zo);
				},
				A2(
					$elm$core$List$filter,
					function ($) {
						return $.sO;
					},
					fiche.Cm)));
		if (_v0.b && (!_v0.b.b)) {
			var id = _v0.a;
			return A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.h6;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (entree) {
							return _Utils_eq(entree.Aq, id);
						},
						entrees)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesAjoutDejaMembreNomme = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parties-prenantes.ajout.deja-membre-nomme',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.Dj + ' est déjà membre de ce groupe. Elle ne sera pas ajoutée deux fois.');
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesAjoutDejaMembres = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parties-prenantes.ajout.deja-membres',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiche est déjà membre de ce groupe : elle ne sera pas ajoutée deux fois.') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiches sont déjà membres de ce groupe : elles ne seront pas ajoutées deux fois.'));
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesAjoutDejaMembresFiltre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.ajout.deja-membres-filtre', _List_Nil, 'Les fiches déjà membres de ce groupe ne seront pas ajoutées deux fois.');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesAjoutSerontAjoutees = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parties-prenantes.ajout.seront-ajoutees',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiche sera ajoutée.') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiches seront ajoutées.'));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$annonce = F4(
	function (i18n, model, nombre, ajout) {
		var _v0 = ajout.B1;
		if (_v0.$ === 1) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var fiche = _v0.a;
			var deja = A2($author$project$Components$Referentiel$PartiesPrenantes$Groupage$dejaMembres, model.aS, fiche);
			var ligneDejaMembres = (deja > 0) ? _List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					function () {
						var _v1 = A3(
							$author$project$Components$Referentiel$PartiesPrenantes$Groupage$nomDuDejaMembre,
							model.aS,
							A2($author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$entreesLues, i18n, model),
							fiche);
						if (!_v1.$) {
							var nom = _v1.a;
							return A2(
								$author$project$I18n$Cles$referentielPartiesPrenantesAjoutDejaMembreNomme,
								i18n,
								{Dj: nom});
						} else {
							return A2(
								$author$project$I18n$Cles$referentielPartiesPrenantesAjoutDejaMembres,
								i18n,
								{w: deja});
						}
					}() + ' ')
				]) : ($author$project$Components$Referentiel$PartiesPrenantes$Groupage$filtreEntier(model.aS) ? _List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$I18n$Cles$referentielPartiesPrenantesAjoutDejaMembresFiltre(i18n) + ' ')
				]) : _List_Nil);
			return A2(
				$author$project$Components$Shared$Note$View$view,
				0,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('annonce')
							]),
						_Utils_ap(
							ligneDejaMembres,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('seront-ajoutees')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$referentielPartiesPrenantesAjoutSerontAjoutees,
												i18n,
												{w: nombre - deja}))
										]))
								])))
					]));
		}
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$NouveauGroupeCree = {$: 40};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$NouveauGroupeDemande = {$: 38};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$NouveauGroupeNomme = function (a) {
	return {$: 39, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$peutCreerUnStatique = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (annuaire) {
				return A2(
					$elm$core$List$any,
					function (lien) {
						return lien.eP === 'creer-un-groupe-statique';
					},
					annuaire.nQ);
			},
			model.iR));
};
var $author$project$I18n$Cles$referentielPartiesPrenantesAjoutNouveau = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.ajout.nouveau', _List_Nil, '+ Nouveau groupe statique');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesAjoutNouveauCreer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.ajout.nouveau-creer', _List_Nil, 'Créer le groupe');
};
var $author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$nouveauGroupe = F3(
	function (i18n, model, ajout) {
		var _v0 = ajout.en;
		if (_v0.$ === 1) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('nouveau-groupe')
					]),
				$author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$peutCreerUnStatique(model) ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('geste'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$PartiesPrenantes$Update$NouveauGroupeDemande)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielPartiesPrenantesAjoutNouveau(i18n))
									]))
							]))
					]) : _List_Nil);
		} else {
			var nom = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('nouveau-groupe'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ouvert')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Champ$View$texte,
						{
							go: (ajout.b5 && $elm$core$String$isEmpty(
								$elm$core$String$trim(nom))) ? $elm$core$Maybe$Just(
								$author$project$I18n$Cles$referentielGroupesCreationNomVide(i18n)) : $elm$core$Maybe$Nothing,
							Aq: 'ajout-nouveau-groupe',
							Bl: $author$project$I18n$Cles$referentielGroupesCreationNom(i18n),
							he: true
						},
						{hg: $author$project$Components$Referentiel$PartiesPrenantes$Update$NouveauGroupeNomme, fm: nom}),
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$PartiesPrenantes$Update$NouveauGroupeCree)
							]),
						$author$project$I18n$Cles$referentielPartiesPrenantesAjoutNouveauCreer(i18n))
					]));
		}
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesAjoutDuFiltre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parties-prenantes.ajout.du-filtre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiche du filtre est sélectionnée.') : ('Les ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiches du filtre sont sélectionnées.')));
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesAjoutNomsEt = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parties-prenantes.ajout.noms-et',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'debut',
					$author$project$I18n$Traductions$Chaine(p.ku)),
					_Utils_Tuple2(
					'dernier',
					$author$project$I18n$Traductions$Chaine(p.xg))
				]),
			p.ku + (' et ' + p.xg));
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesAjoutSelection = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parties-prenantes.ajout.selection',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiche sélectionnée.') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiches sélectionnées.'));
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesAjoutSelectionNombre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parties-prenantes.ajout.selection-nombre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiche') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiches'));
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesAjoutSelectionNommee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parties-prenantes.ajout.selection-nommee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w)),
					_Utils_Tuple2(
					'noms',
					$author$project$I18n$Traductions$Chaine(p.DG))
				]),
			((!p.w) || (p.w === 1)) ? ('sélectionnée : ' + (p.DG + '.')) : ('sélectionnées : ' + (p.DG + '.')));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$portee = F3(
	function (i18n, model, nombre) {
		var cochees = A2(
			$elm$core$List$map,
			function ($) {
				return $.h6;
			},
			A2(
				$elm$core$List$filter,
				function (entree) {
					return A2($author$project$Components$Shared$Annuaire$Model$estCochee, entree.Aq, model.aS);
				},
				A2($author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$entreesLues, i18n, model)));
		var noms = function () {
			var _v0 = $elm$core$List$reverse(cochees);
			if (_v0.b) {
				if (!_v0.b.b) {
					var dernier = _v0.a;
					return dernier;
				} else {
					var dernier = _v0.a;
					var debut = _v0.b;
					return A2(
						$author$project$I18n$Cles$referentielPartiesPrenantesAjoutNomsEt,
						i18n,
						{
							ku: A2(
								$elm$core$String$join,
								', ',
								$elm$core$List$reverse(debut)),
							xg: dernier
						});
				}
			} else {
				return '';
			}
		}();
		return $author$project$Components$Referentiel$PartiesPrenantes$Groupage$filtreEntier(model.aS) ? A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('portee')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2(
						$author$project$I18n$Cles$referentielPartiesPrenantesAjoutDuFiltre,
						i18n,
						{w: nombre}))
				])) : (((!_Utils_eq(
			$elm$core$List$length(cochees),
			nombre)) || (!nombre)) ? A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('portee')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2(
						$author$project$I18n$Cles$referentielPartiesPrenantesAjoutSelection,
						i18n,
						{w: nombre}))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('portee')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$referentielPartiesPrenantesAjoutSelectionNombre,
								i18n,
								{w: nombre}))
						])),
					$rtfeldman$elm_css$Html$Styled$text(
					' ' + A2(
						$author$project$I18n$Cles$referentielPartiesPrenantesAjoutSelectionNommee,
						i18n,
						{w: nombre, DG: noms}))
				])));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$GroupeChoisi = function (a) {
	return {$: 36, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$libelleDeLaSorte = F2(
	function (i18n, groupe) {
		return (!groupe.rg) ? $author$project$I18n$Cles$referentielGroupesSorteStatique(i18n) : $author$project$I18n$Cles$referentielGroupesSorteDynamique(i18n);
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesAjoutDynamique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.ajout.dynamique', _List_Nil, 'Se remplit par critères : on ne peut pas y ajouter une fiche à la main.');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesAjoutMembres = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parties-prenantes.ajout.membres',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' membre') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' membres'));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$proposition = F3(
	function (i18n, ajout, _v0) {
		var groupe = _v0.m2;
		var choisissable = _v0.jM;
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('groupe'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'selected',
									_Utils_eq(
										ajout.vd,
										$elm$core$Maybe$Just(groupe.r8))),
									_Utils_Tuple2('grise', !choisissable)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-pressed',
							_Utils_eq(
								ajout.vd,
								$elm$core$Maybe$Just(groupe.r8)) ? 'true' : 'false'),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!choisissable),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Referentiel$PartiesPrenantes$Update$GroupeChoisi(groupe.r8))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(groupe.Dj)
										])),
									A2(
									$author$project$Components$Shared$Tag$View$view,
									choisissable ? 4 : 5,
									A2($author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$libelleDeLaSorte, i18n, groupe))
								])),
							choisissable ? A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('membres')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$referentielPartiesPrenantesAjoutMembres,
										i18n,
										{w: groupe.n5}))
								])) : A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('motif')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielPartiesPrenantesAjoutDynamique(i18n))
								]))
						]))
				]));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Groupage$propositions = function (annuaire) {
	return A2(
		$elm$core$List$map,
		function (groupe) {
			return {
				jM: (!groupe.rg) && (!_Utils_eq(
					$author$project$Components$Referentiel$PartiesPrenantes$Groupage$lienDAjout(annuaire),
					$elm$core$Maybe$Nothing)),
				m2: groupe
			};
		},
		A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.tE;
				},
				$elm$core$Basics$not),
			annuaire.Ac));
};
var $author$project$I18n$Cles$referentielPartiesPrenantesAjoutQuestion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.ajout.question', _List_Nil, 'Dans quel groupe ?');
};
var $author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$contenuDeLAjout = F4(
	function (i18n, model, nombre, ajout) {
		return _List_fromArray(
			[
				A3($author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$portee, i18n, model, nombre),
				A2(
				$rtfeldman$elm_css$Html$Styled$fieldset,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('groupes-proposes')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$legend,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielPartiesPrenantesAjoutQuestion(i18n))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('groupes')
							]),
						A2(
							$elm$core$List$map,
							A2($author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$proposition, i18n, ajout),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2($elm$core$Maybe$map, $author$project$Components$Referentiel$PartiesPrenantes$Groupage$propositions, model.iR))))
					])),
				A3($author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$nouveauGroupe, i18n, model, ajout),
				A4($author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$annonce, i18n, model, nombre, ajout),
				A2(
				$author$project$Components$Shared$Messages$View$view,
				i18n,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $author$project$Components$Shared$Messages$Model$duRefus, $elm$core$List$singleton),
						model.p0)))
			]);
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesAjoutAction = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parties-prenantes.ajout.action',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Ajouter ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiche')) : ('Ajouter ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiches')));
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesAjoutTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.ajout.titre', _List_Nil, 'Ajouter au groupe');
};
var $author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$ajoutAuGroupe = F2(
	function (i18n, model) {
		var total = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.JE;
				},
				model.B1));
		var nombre = A2($author$project$Components$Shared$Annuaire$Model$nombreSelectionne, total, model.aS);
		var aAjouter = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function (fiche) {
					return nombre - A2($author$project$Components$Referentiel$PartiesPrenantes$Groupage$dejaMembres, model.aS, fiche);
				},
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.B1;
					},
					model.fw)));
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$PartiesPrenantes$Update$VoletAjoutMsg,
			{
				fs: {
					sR: (aAjouter > 0) && (!$author$project$API$Envoi$enCours(model.l3)),
					Bl: A2(
						$author$project$I18n$Cles$referentielPartiesPrenantesAjoutAction,
						i18n,
						{w: aAjouter}),
					C$: $author$project$Components$Referentiel$PartiesPrenantes$Update$AjoutConfirme
				},
				fZ: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A3($author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$contenuDeLAjout, i18n, model, nombre),
						model.fw)),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$referentielPartiesPrenantesAjoutTitre(i18n)
			},
			model.sw);
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesAjoutEnArrierePlan = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parties-prenantes.ajout-en-arriere-plan',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'groupe',
					$author$project$I18n$Traductions$Chaine(p.m2))
				]),
			'L\'ajout dans le groupe « ' + (p.m2 + ' » se fait en arrière-plan. Son avancement s\'affiche sur la fiche du groupe, pour vous seul.'));
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesAjoutFait = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parties-prenantes.ajout.fait',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w)),
					_Utils_Tuple2(
					'groupe',
					$author$project$I18n$Traductions$Chaine(p.m2))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' fiche ajoutée au groupe « ' + (p.m2 + ' ».'))) : (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' fiches ajoutées au groupe « ' + (p.m2 + ' ».'))));
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesAjoutFaitDejaMembres = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parties-prenantes.ajout.fait-deja-membres',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiche était déjà membre du groupe : elle n\'a pas été ajoutée deux fois.') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiches étaient déjà membres du groupe : elles n\'ont pas été ajoutées deux fois.'));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$avis = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('avis-de-groupe')
				]),
			function () {
				var _v0 = model.jk;
				if (!_v0.$) {
					var fait = _v0.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Note$View$view,
							0,
							A2(
								$elm$core$List$cons,
								A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$referentielPartiesPrenantesAjoutFait,
												i18n,
												{m2: fait.m2, w: fait.iI}))
										])),
								(fait.w1 > 0) ? _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('deja-membres')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$referentielPartiesPrenantesAjoutFaitDejaMembres,
													i18n,
													{w: fait.w1}))
											]))
									]) : _List_Nil))
						]);
				} else {
					var _v1 = model.iP;
					if (!_v1.$) {
						var groupe = _v1.a;
						return _List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Note$View$view,
								0,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('en-arriere-plan')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$referentielPartiesPrenantesAjoutEnArrierePlan,
													i18n,
													{m2: groupe}))
											]))
									]))
							]);
					} else {
						return _List_Nil;
					}
				}
			}());
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$CopieConfirmee = {$: 48};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$VoletCopieMsg = function (a) {
	return {$: 44, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$CopieDecrite = function (a) {
	return {$: 46, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$CopieNommee = function (a) {
	return {$: 45, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$CriterePourModifier = {$: 49};
var $author$project$I18n$Cles$referentielPartiesPrenantesCopieCritere = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parties-prenantes.copie.critere',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'critere',
					$author$project$I18n$Traductions$Chaine(p.km)),
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			p.km + (' : ' + p.fm));
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesCopieModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.copie.modifier', _List_Nil, 'Modifier');
};
var $author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$critere = F2(
	function (i18n, _v0) {
		var nom = _v0.a;
		var valeur = _v0.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('phrase')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$referentielPartiesPrenantesCopieCritere,
								i18n,
								{km: nom, fm: valeur}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('geste'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$PartiesPrenantes$Update$CriterePourModifier)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielPartiesPrenantesCopieModifier(i18n))
								]))
						]))
				]));
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesCopieEcarteChamps = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.copie.ecarte-champs', _List_Nil, 'Les filtres « Groupe » et « Champs du type » ne sont pas repris.');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesCopieEcarteEtat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.copie.ecarte-etat', _List_Nil, 'Le filtre « État » n\'est pas un critère de groupe : il n\'est pas repris.');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesCopieEcarteRecherche = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parties-prenantes.copie.ecarte-recherche',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'terme',
					$author$project$I18n$Traductions$Chaine(p.h3))
				]),
			'La recherche « ' + (p.h3 + ' » n\'est pas reprise : un groupe dynamique ne garde que des critères de fiche.'));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$ecartes = F3(
	function (i18n, terme, model) {
		var lignes = _Utils_ap(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (saisi) {
						return _List_fromArray(
							[
								A2(
								$author$project$I18n$Cles$referentielPartiesPrenantesCopieEcarteRecherche,
								i18n,
								{h3: saisi})
							]);
					},
					terme)),
			_Utils_ap(
				(!_Utils_eq(model.EE.mG.gt, $elm$core$Maybe$Nothing)) ? _List_fromArray(
					[
						$author$project$I18n$Cles$referentielPartiesPrenantesCopieEcarteEtat(i18n)
					]) : _List_Nil,
				($elm$core$List$isEmpty(model.EE.mG.dw) && _Utils_eq(model.EE.mG.m2, $elm$core$Maybe$Nothing)) ? _List_Nil : _List_fromArray(
					[
						$author$project$I18n$Cles$referentielPartiesPrenantesCopieEcarteChamps(i18n)
					])));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ecartes')
				]),
			$elm$core$List$isEmpty(lignes) ? _List_Nil : _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Note$View$view,
					1,
					A2(
						$elm$core$List$map,
						function (ligne) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(ligne)
									]));
						},
						lignes))
				]));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$nombreDeLaCopie = F2(
	function (phrases, model) {
		return $elm$core$List$isEmpty(phrases) ? 0 : A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.JE;
				},
				model.B1));
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesCopieCompteur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parties-prenantes.copie.compteur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiche aujourd\'hui, recalculé à chaque usage. Les fiches sont celles de votre périmètre.') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiches aujourd\'hui, recalculé à chaque usage. Les fiches sont celles de votre périmètre.'));
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesCopieCriteres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.copie.criteres', _List_Nil, 'Critères');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesCopieSorteFixee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.copie.sorte-fixee', _List_Nil, 'Fixé : les critères viennent du filtre de la liste. La sorte ne peut pas être changée.');
};
var $author$project$I18n$Textes$referentielPartiesPrenantesCopieAucunCritere = A3($author$project$I18n$Traductions$texte, 'referentiel.parties-prenantes.copie.aucun-critere', _List_Nil, 'Aucun critère de la liste ne peut devenir un critère de groupe. Posez un filtre de nature, de qualité, de pays ou de type, puis recommencez.');
var $author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$refusDeLaCopie = function (refus) {
	return _Utils_eq(
		refus.bB,
		$author$project$API$Reponse$Metier('AucunCritereAdmis')) ? _List_fromArray(
		[
			{Jx: $author$project$I18n$Textes$referentielPartiesPrenantesCopieAucunCritere, b9: refus.b9}
		]) : _List_fromArray(
		[
			$author$project$Components$Shared$Messages$Model$duRefus(refus)
		]);
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$CopieResponsable = function (a) {
	return {$: 47, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$responsable = F3(
	function (i18n, model, saisie) {
		var _v0 = $author$project$Components$Referentiel$Common$Equipe$candidats(model.l5);
		if (!_v0.b) {
			return _List_Nil;
		} else {
			var candidats = _v0;
			return _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: 'copie-responsable',
						Bl: $author$project$I18n$Cles$referentielGroupesCreationResponsable(i18n),
						he: false
					},
					{
						hg: $author$project$Components$Referentiel$PartiesPrenantes$Update$CopieResponsable,
						o_: A2(
							$elm$core$List$cons,
							{
								Bl: $author$project$I18n$Cles$referentielGroupesCreationResponsableDefaut(i18n),
								fm: ''
							},
							A2(
								$elm$core$List$map,
								function (c) {
									return {Bl: c.Dj, fm: c.r8};
								},
								candidats)),
						fm: saisie.qB
					})
				]);
		}
	});
var $author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$contenuDeLaCopie = F5(
	function (i18n, phrases, terme, model, saisie) {
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Champ$View$texte,
					{
						go: (saisie.b5 && $elm$core$String$isEmpty(
							$elm$core$String$trim(saisie.Dj))) ? $elm$core$Maybe$Just(
							$author$project$I18n$Cles$referentielGroupesCreationNomVide(i18n)) : $elm$core$Maybe$Nothing,
						Aq: 'copie-nom',
						Bl: $author$project$I18n$Cles$referentielGroupesCreationNom(i18n),
						he: true
					},
					{hg: $author$project$Components$Referentiel$PartiesPrenantes$Update$CopieNommee, fm: saisie.Dj}),
					A2(
					$author$project$Components$Shared$Champ$View$zoneDeTexte,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: 'copie-description',
						Bl: $author$project$I18n$Cles$referentielGroupesCreationDescription(i18n),
						he: false
					},
					{hg: $author$project$Components$Referentiel$PartiesPrenantes$Update$CopieDecrite, fm: saisie.dH})
				]),
			_Utils_ap(
				A3($author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$responsable, i18n, model, saisie),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('sorte-fixee')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielGroupesSorteDynamique(i18n))
									])),
								$rtfeldman$elm_css$Html$Styled$text(
								' · ' + $author$project$I18n$Cles$referentielPartiesPrenantesCopieSorteFixee(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('criteres')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielPartiesPrenantesCopieCriteres(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$ul,
								_List_Nil,
								A2(
									$elm$core$List$map,
									$author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$critere(i18n),
									phrases))
							])),
						A3($author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$ecartes, i18n, terme, model),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('compteur')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$referentielPartiesPrenantesCopieCompteur,
									i18n,
									{
										w: A2($author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$nombreDeLaCopie, phrases, model)
									}))
							])),
						A2(
						$author$project$Components$Shared$Messages$View$view,
						i18n,
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2($elm$core$Maybe$map, $author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$refusDeLaCopie, model.p0)))
					])));
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesCopieAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.copie.action', _List_Nil, 'Créer le groupe');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesCopieTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.copie.titre', _List_Nil, 'Enregistrer le filtre comme groupe');
};
var $author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$copie = F4(
	function (i18n, phrases, terme, model) {
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$PartiesPrenantes$Update$VoletCopieMsg,
			{
				fs: {
					sR: (!_Utils_eq(model.kc, $elm$core$Maybe$Nothing)) && (!$author$project$API$Envoi$enCours(model.l3)),
					Bl: $author$project$I18n$Cles$referentielPartiesPrenantesCopieAction(i18n),
					C$: $author$project$Components$Referentiel$PartiesPrenantes$Update$CopieConfirmee
				},
				fZ: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A4($author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$contenuDeLaCopie, i18n, phrases, terme, model),
						model.kc)),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$referentielPartiesPrenantesCopieTitre(i18n)
			},
			model.sx);
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$CreationDemandee = {$: 20};
var $author$project$I18n$Cles$referentielPartiesPrenantesNouvelleFiche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.nouvelle-fiche', _List_Nil, 'Nouvelle fiche');
};
var $author$project$Components$Referentiel$PartiesPrenantes$View$creation = F3(
	function (i18n, identifiant, liens) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					return _List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							0,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id(identifiant),
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$PartiesPrenantes$Update$CreationDemandee)
								]),
							$author$project$I18n$Cles$referentielPartiesPrenantesNouvelleFiche(i18n))
						]);
				},
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerEntite, liens)));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Model$ParNature = 0;
var $author$project$Components$Referentiel$PartiesPrenantes$Model$ParPays = 2;
var $author$project$Components$Referentiel$PartiesPrenantes$Model$ParQualite = 1;
var $author$project$Components$Referentiel$PartiesPrenantes$Model$ParRole = 3;
var $author$project$Components$Referentiel$PartiesPrenantes$Model$ParEtat = 4;
var $author$project$Components$Referentiel$PartiesPrenantes$Model$ParGroupe = 5;
var $author$project$Components$Referentiel$PartiesPrenantes$Model$ParOffre = 6;
var $author$project$Components$Referentiel$PartiesPrenantes$Model$filtrePose = F2(
	function (filtre, filtres) {
		switch (filtre) {
			case 0:
				return filtres.g1;
			case 1:
				return filtres.hy;
			case 2:
				return filtres.ho;
			case 4:
				return filtres.gt;
			case 5:
				return filtres.m2;
			case 6:
				return filtres.D1;
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Model$filtresPoses = function (filtres) {
	return _Utils_ap(
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$pair(3),
			filtres.ib),
		_Utils_ap(
			A2(
				$elm$core$List$filterMap,
				function (filtre) {
					return A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$pair(filtre),
						A2($author$project$Components$Referentiel$PartiesPrenantes$Model$filtrePose, filtre, filtres));
				},
				_List_fromArray(
					[0, 1, 2, 5, 6])),
			_List_fromArray(
				[
					_Utils_Tuple2(
					4,
					A2($elm$core$Maybe$withDefault, '', filtres.gt))
				])));
};
var $author$project$I18n$Cles$referentielPartiesPrenantesFiltreGroupe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.filtre.groupe', _List_Nil, 'Groupe');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesFiltreOffre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.filtre.offre', _List_Nil, 'Offre');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesFiltreRole = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.filtre.role', _List_Nil, 'Type');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesFiltresEtatNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.filtres.etat-nom', _List_Nil, 'État');
};
var $author$project$Components$Referentiel$PartiesPrenantes$View$nomDuFiltre = F2(
	function (i18n, choisi) {
		switch (choisi) {
			case 0:
				return $author$project$I18n$Cles$referentielCreationNature(i18n);
			case 1:
				return $author$project$I18n$Cles$referentielCreationQualite(i18n);
			case 2:
				return $author$project$I18n$Cles$referentielCreationPays(i18n);
			case 4:
				return $author$project$I18n$Cles$referentielPartiesPrenantesFiltresEtatNom(i18n);
			case 5:
				return $author$project$I18n$Cles$referentielPartiesPrenantesFiltreGroupe(i18n);
			case 6:
				return $author$project$I18n$Cles$referentielPartiesPrenantesFiltreOffre(i18n);
			default:
				return $author$project$I18n$Cles$referentielPartiesPrenantesFiltreRole(i18n);
		}
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesFiltresEtatActivesEtCloses = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.filtres.etat-actives-et-closes', _List_Nil, 'Actives et closes');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesFiltreGroupeHomonyme = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parties-prenantes.filtre.groupe.homonyme',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'sorte',
					$author$project$I18n$Traductions$Chaine(p.rg)),
					_Utils_Tuple2(
					'membres',
					$author$project$I18n$Traductions$Chaine(p.Cm))
				]),
			p.Dj + (' (' + (p.rg + (', ' + (p.Cm + ')')))));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$View$libelleDuGroupe = F3(
	function (i18n, groupes, groupe) {
		return ($elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (autre) {
					return _Utils_eq(autre.Dj, groupe.Dj);
				},
				groupes)) > 1) ? A2(
			$author$project$I18n$Cles$referentielPartiesPrenantesFiltreGroupeHomonyme,
			i18n,
			{
				Cm: (groupe.Cm === 1) ? $author$project$I18n$Cles$referentielGroupeMembresActifsUn(i18n) : A2(
					$author$project$I18n$Cles$referentielGroupeMembresActifsPlusieurs,
					i18n,
					{
						w: $elm$core$String$fromInt(groupe.Cm)
					}),
				Dj: groupe.Dj,
				rg: groupe.xW ? $author$project$I18n$Cles$referentielGroupesSorteDynamique(i18n) : $author$project$I18n$Cles$referentielGroupesSorteStatique(i18n)
			}) : groupe.Dj;
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesFiltresEtatCloses = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.filtres.etat-closes', _List_Nil, 'Closes');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesFiltresEtatSupprimees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.filtres.etat-supprimees', _List_Nil, 'Supprimées');
};
var $author$project$Components$Referentiel$PartiesPrenantes$View$valeursDuFiltre = F3(
	function (i18n, model, choisi) {
		switch (choisi) {
			case 0:
				return _List_fromArray(
					[
						{
						Bl: $author$project$I18n$Cles$referentielNaturePersonne(i18n),
						fm: 'Personne'
					},
						{
						Bl: $author$project$I18n$Cles$referentielNatureOrganisation(i18n),
						fm: 'Organisation'
					}
					]);
			case 1:
				return _List_fromArray(
					[
						{
						Bl: $author$project$I18n$Cles$referentielQualiteParticulier(i18n),
						fm: 'Particulier'
					},
						{
						Bl: $author$project$I18n$Cles$referentielQualiteProfessionnel(i18n),
						fm: 'Professionnel'
					}
					]);
			case 2:
				return A2(
					$elm$core$List$map,
					function (pays) {
						return {Bl: pays.Dj, fm: pays.vx};
					},
					$author$project$Referentiel$Normes$entreesDePays(model.hd));
			case 4:
				return _List_fromArray(
					[
						{
						Bl: $author$project$I18n$Cles$referentielPartiesPrenantesFiltresEtatCloses(i18n),
						fm: 'closes'
					},
						{
						Bl: $author$project$I18n$Cles$referentielPartiesPrenantesFiltresEtatSupprimees(i18n),
						fm: 'supprimees'
					}
					]);
			case 5:
				return A2(
					$elm$core$List$map,
					function (groupe) {
						return {
							Bl: A3($author$project$Components$Referentiel$PartiesPrenantes$View$libelleDuGroupe, i18n, model.Ac, groupe),
							fm: groupe.r8
						};
					},
					model.Ac);
			case 6:
				var _v1 = model.D3;
				if (_v1.$ === 1) {
					var offres = _v1.a;
					return A2(
						$elm$core$List$map,
						function (offre) {
							return {
								Bl: A2(
									$author$project$I18n$Cles$texte,
									i18n,
									$author$project$Components$Referentiel$Common$Offres$nom(offre)),
								fm: offre.Aq
							};
						},
						offres);
				} else {
					return _List_Nil;
				}
			default:
				return A2(
					$elm$core$List$map,
					function (servi) {
						return {
							Bl: $author$project$Components$Referentiel$Common$TypesServis$libelle(servi),
							fm: $author$project$Components$Referentiel$Identifiants$typeUidToString(servi.r8)
						};
					},
					model.ib);
		}
	});
var $author$project$Components$Referentiel$PartiesPrenantes$View$libelleDuCode = F4(
	function (i18n, model, choisi, code) {
		return ((choisi === 4) && (code === '')) ? $author$project$I18n$Cles$referentielPartiesPrenantesFiltresEtatActivesEtCloses(i18n) : A2(
			$elm$core$Maybe$withDefault,
			(choisi === 3) ? '' : code,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (valeur) {
							return _Utils_eq(valeur.fm, code);
						},
						A3($author$project$Components$Referentiel$PartiesPrenantes$View$valeursDuFiltre, i18n, model, choisi)))));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$View$valeurAffichee = F4(
	function (i18n, model, pose, code) {
		return (pose === 4) ? $elm$core$String$toLower(
			A4($author$project$Components$Referentiel$PartiesPrenantes$View$libelleDuCode, i18n, model, pose, code)) : A4($author$project$Components$Referentiel$PartiesPrenantes$View$libelleDuCode, i18n, model, pose, code);
	});
var $author$project$Components$Referentiel$PartiesPrenantes$View$criteresDeLaCopie = F2(
	function (i18n, model) {
		return A2(
			$elm$core$List$map,
			function (_v1) {
				var pose = _v1.a;
				var code = _v1.b;
				return _Utils_Tuple2(
					A2($author$project$Components$Referentiel$PartiesPrenantes$View$nomDuFiltre, i18n, pose),
					A4($author$project$Components$Referentiel$PartiesPrenantes$View$valeurAffichee, i18n, model, pose, code));
			},
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var pose = _v0.a;
					return A2(
						$elm$core$List$member,
						pose,
						_List_fromArray(
							[0, 1, 2, 3]));
				},
				$author$project$Components$Referentiel$PartiesPrenantes$Model$filtresPoses(model.EE.mG)));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$ColonnesDemandees = {$: 23};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$PageDemandee = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$TailleDemandee = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$TermeSaisi = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$AjoutDemande = {$: 34};
var $author$project$Components$Referentiel$PartiesPrenantes$Groupage$quiPeutFaireLEnsemble = function (annuaire) {
	return !_Utils_eq(
		$author$project$Components$Referentiel$PartiesPrenantes$Groupage$lienDAjout(annuaire),
		$elm$core$Maybe$Nothing);
};
var $author$project$I18n$Cles$referentielPartiesPrenantesAjoutBouton = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.ajout.bouton', _List_Nil, 'Ajouter à un groupe');
};
var $author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$boutonAjout = F2(
	function (i18n, model) {
		var _v0 = model.iR;
		if (!_v0.$) {
			var annuaire = _v0.a;
			return $author$project$Components$Referentiel$PartiesPrenantes$Groupage$quiPeutFaireLEnsemble(annuaire) ? _List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$PartiesPrenantes$Model$idDuDeclencheurDAjout),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$PartiesPrenantes$Update$AjoutDemande)
						]),
					$author$project$I18n$Cles$referentielPartiesPrenantesAjoutBouton(i18n))
				]) : _List_Nil;
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$estUneMarque = F2(
	function (i18n, libelle) {
		return A2(
			$elm$core$List$member,
			libelle,
			_List_fromArray(
				[
					A2($author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$libelleDeLaMarque, i18n, 1),
					A2($author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$libelleDeLaMarque, i18n, 2),
					A2($author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$libelleDeLaMarque, i18n, 3)
				]));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$marqueDEtat = F2(
	function (i18n, ligne) {
		var _v0 = ligne.ry;
		if (_v0.b) {
			var _v1 = _v0.a;
			var couleur = _v1.a;
			var libelle = _v1.b;
			return A2($author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$estUneMarque, i18n, libelle) ? _List_fromArray(
				[
					_Utils_Tuple2(couleur, libelle)
				]) : _List_Nil;
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Referentiel$PartiesPrenantes$View$marques = $elm$core$List$map(
	function (_v0) {
		var couleur = _v0.a;
		var nom = _v0.b;
		return A2($author$project$Components$Shared$Tag$View$view, couleur, nom);
	});
var $author$project$Components$Referentiel$PartiesPrenantes$View$colonneDuNom = function (i18n) {
	var titre = A2(
		$author$project$Components$Shared$Tableau$View$colonneDuTitre,
		'nom',
		$author$project$I18n$Cles$referentielCreationNom(i18n));
	return _Utils_update(
		titre,
		{
			uM: function (entree) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							titre.uM(entree),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('pills')
								]),
							$author$project$Components$Referentiel$PartiesPrenantes$View$marques(
								A2($author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$marqueDEtat, i18n, entree)))
						]));
			}
		});
};
var $author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$pastillesDeRoles = F2(
	function (i18n, ligne) {
		return A2(
			$elm$core$List$drop,
			$elm$core$List$length(
				A2($author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$marqueDEtat, i18n, ligne)),
			ligne.ry);
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesColonnesQualite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.colonnes.qualite', _List_Nil, 'Qualité ou forme');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesColonnesTypes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.colonnes.types', _List_Nil, 'Types');
};
var $author$project$Components$Referentiel$PartiesPrenantes$View$valeurDInfo = F2(
	function (ligne, entree) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$eq(ligne)),
						entree.gL))));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$View$texteDInfo = F3(
	function (id, libelle, ligne) {
		return $author$project$Components$Shared$Tableau$View$colonneDeTexte(
			{
				f5: true,
				Aq: id,
				Bl: libelle,
				fm: $author$project$Components$Referentiel$PartiesPrenantes$View$valeurDInfo(ligne)
			});
	});
var $author$project$Components$Referentiel$PartiesPrenantes$View$colonnes = function (i18n) {
	return _List_fromArray(
		[
			$author$project$Components$Referentiel$PartiesPrenantes$View$colonneDuNom(i18n),
			A3(
			$author$project$Components$Referentiel$PartiesPrenantes$View$texteDInfo,
			'nature',
			$author$project$I18n$Cles$referentielCreationNature(i18n),
			$author$project$I18n$Cles$referentielCreationNature(i18n)),
			A3(
			$author$project$Components$Referentiel$PartiesPrenantes$View$texteDInfo,
			'qualite',
			$author$project$I18n$Cles$referentielPartiesPrenantesColonnesQualite(i18n),
			$author$project$I18n$Cles$referentielCreationQualite(i18n)),
			{
			uM: function (entree) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('pills')
						]),
					$author$project$Components$Referentiel$PartiesPrenantes$View$marques(
						A2($author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$pastillesDeRoles, i18n, entree)));
			},
			f5: true,
			Aq: 'types',
			Bl: $author$project$I18n$Cles$referentielPartiesPrenantesColonnesTypes(i18n),
			he: false
		},
			A3(
			$author$project$Components$Referentiel$PartiesPrenantes$View$texteDInfo,
			'pays',
			$author$project$I18n$Cles$referentielCreationPays(i18n),
			$author$project$I18n$Cles$referentielCreationPays(i18n)),
			$author$project$Components$Shared$Tableau$View$colonneDeTexte(
			{
				f5: false,
				Aq: 'creation',
				Bl: $author$project$I18n$Cles$referentielPartiesPrenantesColonnesCreation(i18n),
				fm: $author$project$Components$Referentiel$PartiesPrenantes$View$valeurDInfo(
					$author$project$I18n$Cles$referentielPartiesPrenantesColonnesCreation(i18n))
			})
		]);
};
var $author$project$I18n$Cles$referentielPartiesPrenantesCompteur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parties-prenantes.compteur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' partie prenante') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' parties prenantes'));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Model$tranche = F2(
	function (page, liste) {
		var debut = ((page.EE - 1) * page.Jm) + 1;
		return $elm$core$List$isEmpty(liste.zu) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			_Utils_Tuple2(
				debut,
				(debut + $elm$core$List$length(liste.zu)) - 1));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$View$compteur = F2(
	function (i18n, model) {
		var _v0 = model.B1;
		if (_v0.$ === 1) {
			return '';
		} else {
			var liste = _v0.a;
			var nombre = A2(
				$author$project$I18n$Cles$referentielPartiesPrenantesCompteur,
				i18n,
				{w: liste.JE});
			return (!liste.JE) ? '' : A2(
				$elm$core$Maybe$withDefault,
				nombre,
				A2(
					$elm$core$Maybe$map,
					function (_v1) {
						var debut = _v1.a;
						var fin = _v1.b;
						return A2(
							$author$project$I18n$Cles$annuaireCompteurAffichees,
							i18n,
							{
								fV: nombre,
								ku: A2(
									$author$project$I18n$Nombre$formater,
									$author$project$I18n$Traductions$langue(i18n),
									debut),
								mI: A2(
									$author$project$I18n$Nombre$formater,
									$author$project$I18n$Traductions$langue(i18n),
									fin)
							});
					},
					A2($author$project$Components$Referentiel$PartiesPrenantes$Model$tranche, model.EE, liste)));
		}
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesRecherche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.recherche', _List_Nil, 'Nom, prénom, raison sociale · 2 caractères minimum');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesSelectionToutLeFiltre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parties-prenantes.selection.tout-le-filtre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Sélectionner les ' + (p.w + ' fiches du filtre'));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$View$libelles = F2(
	function (i18n, model) {
		return {
			jA: $elm$core$Basics$identity,
			j1: {
				m9: $elm$core$Maybe$Nothing,
				ry: $author$project$I18n$Cles$referentielPartiesPrenantesColonnesTypes(i18n),
				h6: $author$project$I18n$Cles$referentielCreationNom(i18n)
			},
			fV: A2($author$project$Components$Referentiel$PartiesPrenantes$View$compteur, i18n, model),
			hC: $author$project$I18n$Cles$referentielPartiesPrenantesRecherche(i18n),
			q3: function (nombre) {
				return A2(
					$author$project$I18n$Cles$annuaireSelectionFiches,
					i18n,
					{w: nombre});
			},
			q4: function (nombre) {
				return A2(
					$author$project$I18n$Cles$annuaireSelectionDeLaPage,
					i18n,
					{w: nombre});
			},
			q5: function (nombre) {
				return A2(
					$author$project$I18n$Cles$annuaireSelectionDuFiltre,
					i18n,
					{w: nombre});
			},
			rN: A2(
				$author$project$I18n$Cles$referentielPartiesPrenantesSelectionToutLeFiltre,
				i18n,
				{
					w: A2(
						$author$project$I18n$Nombre$formater,
						$author$project$I18n$Traductions$langue(i18n),
						A2(
							$elm$core$Maybe$withDefault,
							0,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.JE;
								},
								model.B1)))
				})
		};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Model$idDuDeclencheurDeCreationSansFiche = 'parties-prenantes-nouvelle-fiche-sans-fiche';
var $author$project$I18n$Cles$referentielPartiesPrenantesSansResultat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.sans-resultat', _List_Nil, 'Aucune fiche ne correspond à votre recherche.');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.vide', _List_Nil, 'Aucune partie prenante pour l\'instant.');
};
var $author$project$Components$Referentiel$PartiesPrenantes$Model$AucunResultat = 2;
var $author$project$Components$Referentiel$PartiesPrenantes$Model$AucuneFiche = 1;
var $author$project$Components$Referentiel$PartiesPrenantes$Model$NonVide = 0;
var $author$project$Components$Referentiel$PartiesPrenantes$Model$vide = function (model) {
	var _v0 = _Utils_Tuple2(model.gt, model.B1);
	if ((_v0.a === 3) && (!_v0.b.$)) {
		var _v1 = _v0.a;
		var liste = _v0.b.a;
		return (liste.JE > 0) ? 0 : ((_Utils_eq(model.kC, $elm$core$Maybe$Nothing) && _Utils_eq(model.EE.mG, $author$project$Routes$Route$aucunFiltre)) ? 1 : 2);
	} else {
		return 0;
	}
};
var $author$project$Components$Referentiel$PartiesPrenantes$View$message = F3(
	function (i18n, liens, model) {
		var _v0 = $author$project$Components$Referentiel$PartiesPrenantes$Model$vide(model);
		switch (_v0) {
			case 0:
				return _List_Nil;
			case 1:
				return A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielPartiesPrenantesVide(i18n))
							])),
					A3($author$project$Components$Referentiel$PartiesPrenantes$View$creation, i18n, $author$project$Components$Referentiel$PartiesPrenantes$Model$idDuDeclencheurDeCreationSansFiche, liens));
			default:
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielPartiesPrenantesSansResultat(i18n))
							]))
					]);
		}
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Model$pagePrecedente = function (model) {
	var page = model.EE;
	return (page.EE > 1) ? $elm$core$Maybe$Just(
		_Utils_update(
			page,
			{EE: page.EE - 1})) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$Referentiel$PartiesPrenantes$Model$pageSuivante = function (model) {
	var page = model.EE;
	return A2(
		$elm$core$Maybe$andThen,
		function (liste) {
			return (_Utils_cmp(page.EE * page.Jm, liste.JE) < 0) ? $elm$core$Maybe$Just(
				_Utils_update(
					page,
					{EE: page.EE + 1})) : $elm$core$Maybe$Nothing;
		},
		model.B1);
};
var $author$project$Components$Referentiel$PartiesPrenantes$View$plage = F2(
	function (i18n, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				function (liste) {
					return A2(
						$elm$core$Maybe$map,
						function (_v0) {
							var debut = _v0.a;
							var fin = _v0.b;
							return A2(
								$author$project$I18n$Cles$annuairePaginationPlage,
								i18n,
								{
									ku: A2(
										$author$project$I18n$Nombre$formater,
										$author$project$I18n$Traductions$langue(i18n),
										debut),
									mI: A2(
										$author$project$I18n$Nombre$formater,
										$author$project$I18n$Traductions$langue(i18n),
										fin),
									JE: A2(
										$author$project$I18n$Nombre$formater,
										$author$project$I18n$Traductions$langue(i18n),
										liste.JE)
								});
						},
						A2($author$project$Components$Referentiel$PartiesPrenantes$Model$tranche, model.EE, liste));
				},
				model.B1));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$View$totalSelectionnable = function (model) {
	var filtres = model.EE.mG;
	return (_Utils_eq(filtres.gt, $elm$core$Maybe$Nothing) && (_Utils_eq(filtres.m2, $elm$core$Maybe$Nothing) && (_Utils_eq(filtres.D1, $elm$core$Maybe$Nothing) && $elm$core$List$isEmpty(filtres.dw)))) ? A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.JE;
			},
			model.B1)) : 0;
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$TriMenuBascule = {$: 16};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$TriChoisi = function (a) {
	return {$: 15, a: a};
};
var $author$project$I18n$Cles$referentielPartiesPrenantesTriNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.tri.nom', _List_Nil, 'Nom (A → Z)');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesTriNomDesc = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.tri.nom-desc', _List_Nil, 'Nom (Z → A)');
};
var $author$project$Components$Referentiel$PartiesPrenantes$View$libelleDeLOrdre = F2(
	function (i18n, ordre) {
		if (!ordre) {
			return $author$project$I18n$Cles$referentielPartiesPrenantesTriNom(i18n);
		} else {
			return $author$project$I18n$Cles$referentielPartiesPrenantesTriNomDesc(i18n);
		}
	});
var $author$project$Components$Referentiel$PartiesPrenantes$View$entreeDeTri = F3(
	function (i18n, courant, ordre) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'none')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(
							$author$project$Components$Referentiel$PartiesPrenantes$Model$idDeLOrdre(ordre)),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'menuitemradio'),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-checked',
							_Utils_eq(ordre, courant) ? 'true' : 'false'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Referentiel$PartiesPrenantes$Update$TriChoisi(
								$author$project$Routes$Route$codeDuTri(ordre)))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Referentiel$PartiesPrenantes$View$libelleDeLOrdre, i18n, ordre))
						]))
				]));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$TriMenuDeplace = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$View$toucheDuMenuDuTri = function (touche) {
	switch (touche) {
		case 'ArrowDown':
			return $elm$json$Json$Decode$succeed(
				_Utils_Tuple2(
					$author$project$Components$Referentiel$PartiesPrenantes$Update$TriMenuDeplace(1),
					true));
		case 'ArrowUp':
			return $elm$json$Json$Decode$succeed(
				_Utils_Tuple2(
					$author$project$Components$Referentiel$PartiesPrenantes$Update$TriMenuDeplace(-1),
					true));
		case 'Escape':
			return $elm$json$Json$Decode$succeed(
				_Utils_Tuple2($author$project$Components$Referentiel$PartiesPrenantes$Update$TriMenuFerme, true));
		default:
			return $elm$json$Json$Decode$fail('');
	}
};
var $author$project$Components$Referentiel$PartiesPrenantes$View$tri = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('toggle-menu'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('tri'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('opened', model.gY)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$PartiesPrenantes$Model$idDuDeclencheurDuTri),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('toggle'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'menu'),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-expanded',
							model.gY ? 'true' : 'false'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$PartiesPrenantes$Update$TriMenuBascule)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$annuaireTrierOrdre,
								i18n,
								{
									El: A2($author$project$Components$Referentiel$PartiesPrenantes$View$libelleDeLOrdre, i18n, model.EE.rS)
								}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('menu'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'menu'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-labelledby', $author$project$Components$Referentiel$PartiesPrenantes$Model$idDuDeclencheurDuTri),
							A2(
							$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
							'keydown',
							A2(
								$elm$json$Json$Decode$andThen,
								$author$project$Components$Referentiel$PartiesPrenantes$View$toucheDuMenuDuTri,
								A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)))
						]),
					A2(
						$elm$core$List$map,
						A2($author$project$Components$Referentiel$PartiesPrenantes$View$entreeDeTri, i18n, model.EE.rS),
						$author$project$Components$Referentiel$PartiesPrenantes$Model$ordresProposes))
				]));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$View$donnees = F3(
	function (i18n, liens, model) {
		return {
			sQ: A2($author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$boutonAjout, i18n, model),
			ue: true,
			uf: true,
			uh: true,
			ui: false,
			uH: false,
			u7: model.gt === 2,
			vG: $author$project$Components$Referentiel$PartiesPrenantes$View$colonnes(i18n),
			wl: _List_Nil,
			xs: $author$project$I18n$Cles$annuaireAnnulerLaSelection(i18n),
			yt: 'partie-prenante',
			yv: A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						A3($author$project$Components$Referentiel$PartiesPrenantes$API$ToModel$toModel, i18n, model.hd, model.ib),
						function ($) {
							return $.yv;
						}),
					model.B1)),
			mG: _List_Nil,
			R: A2($author$project$Components$Referentiel$PartiesPrenantes$View$libelles, i18n, model),
			Cs: A3($author$project$Components$Referentiel$PartiesPrenantes$View$message, i18n, liens, model),
			EB: $elm$core$Maybe$Just($author$project$Components$Referentiel$PartiesPrenantes$Update$ColonnesDemandees),
			EH: $author$project$Components$Shared$Annuaire$View$PaginationAvecPlage(
				{
					FQ: A2($author$project$Components$Referentiel$PartiesPrenantes$View$plage, i18n, model),
					Gc: A2(
						$elm$core$Maybe$map,
						$author$project$Components$Referentiel$PartiesPrenantes$Update$PageDemandee,
						$author$project$Components$Referentiel$PartiesPrenantes$Model$pagePrecedente(model)),
					I7: A2(
						$elm$core$Maybe$map,
						$author$project$Components$Referentiel$PartiesPrenantes$Update$PageDemandee,
						$author$project$Components$Referentiel$PartiesPrenantes$Model$pageSuivante(model)),
					Jf: $author$project$Components$Referentiel$PartiesPrenantes$Update$TailleDemandee,
					Jm: model.EE.Jm,
					Jo: $author$project$Routes$Route$taillesPermises
				}),
			GS: $elm$core$Maybe$Nothing,
			hC: $author$project$Components$Shared$Annuaire$View$RechercheTenue(
				{hg: $author$project$Components$Referentiel$PartiesPrenantes$Update$TermeSaisi, fm: model.h3}),
			Iz: true,
			JE: $author$project$Components$Referentiel$PartiesPrenantes$View$totalSelectionnable(model),
			rS: _List_fromArray(
				[
					A2($author$project$Components$Referentiel$PartiesPrenantes$View$tri, i18n, model)
				])
		};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$FiltresEffaces = {$: 11};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$CopieDemandee = {$: 43};
var $author$project$I18n$Cles$referentielPartiesPrenantesCopieBouton = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.copie.bouton', _List_Nil, 'Enregistrer comme groupe dynamique');
};
var $author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$boutonCopie = F2(
	function (i18n, model) {
		var _v0 = A2($elm$core$Maybe$andThen, $author$project$Components$Referentiel$PartiesPrenantes$Groupage$lienDeLaCopie, model.iR);
		if (!_v0.$) {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$PartiesPrenantes$Model$idDuDeclencheurDeCopie),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('secondary'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('enregistrer-comme-groupe'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$PartiesPrenantes$Update$CopieDemandee)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielPartiesPrenantesCopieBouton(i18n))
								]))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$FiltreChoisi = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$View$filtreActif = F3(
	function (i18n, model, _v0) {
		var pose = _v0.a;
		var code = _v0.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('filtre-actif'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					A2(
						$author$project$I18n$Cles$annuaireFiltreRetirer,
						i18n,
						{
							zH: A2($author$project$Components$Referentiel$PartiesPrenantes$View$nomDuFiltre, i18n, pose)
						})),
					$rtfeldman$elm_css$Html$Styled$Attributes$title(
					A2(
						$author$project$I18n$Cles$annuaireFiltreRetirer,
						i18n,
						{
							zH: A2($author$project$Components$Referentiel$PartiesPrenantes$View$nomDuFiltre, i18n, pose)
						})),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					A2(
						$author$project$Components$Referentiel$PartiesPrenantes$Update$FiltreChoisi,
						pose,
						(pose === 3) ? code : ''))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$annuaireFiltreActif,
								i18n,
								{
									zH: A2($author$project$Components$Referentiel$PartiesPrenantes$View$nomDuFiltre, i18n, pose),
									fm: A4($author$project$Components$Referentiel$PartiesPrenantes$View$valeurAffichee, i18n, model, pose, code)
								}))
						])),
					$author$project$Components$Shared$Svg$svgClose
				]));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$ChampRetire = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$ChoixBascule = F3(
	function (a, b, c) {
		return {$: 13, a: a, b: b, c: c};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Model$ChampFiltrable = F3(
	function (cle, libelle, reglage) {
		return {dy: cle, Bl: libelle, eO: reglage};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Model$ChoixDeListe = F2(
	function (valeur, libelle) {
		return {Bl: libelle, fm: valeur};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Model$ParCases = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Model$ParListe = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Model$ParOuiNon = {$: 2};
var $author$project$Components$Referentiel$PartiesPrenantes$Model$libelleDeLaValeur = F2(
	function (champ, valeur) {
		return A2(
			$elm$core$Maybe$withDefault,
			valeur,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$second,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$filter(
								function (_v1) {
									var langue = _v1.a;
									return langue === 'fr';
								}),
							$elm$core$List$head)),
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (_v0) {
								var code = _v0.a;
								return _Utils_eq(code, valeur);
							},
							champ.Bt)))));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Model$reglageDuChamp = function (servi) {
	if (!servi.zG) {
		return $elm$core$Maybe$Nothing;
	} else {
		var _v0 = servi.uN.r0;
		switch (_v0.$) {
			case 7:
				var valeurs = _v0.a;
				return $elm$core$Maybe$Just(
					A3(
						$author$project$Components$Referentiel$PartiesPrenantes$Model$ChampFiltrable,
						servi.dy,
						servi.uN.Bl,
						$author$project$Components$Referentiel$PartiesPrenantes$Model$ParListe(
							A2(
								$elm$core$List$map,
								function (valeur) {
									return A2(
										$author$project$Components$Referentiel$PartiesPrenantes$Model$ChoixDeListe,
										valeur,
										A2($author$project$Components$Referentiel$PartiesPrenantes$Model$libelleDeLaValeur, servi.uN, valeur));
								},
								valeurs))));
			case 8:
				var choix = _v0.a;
				return $elm$core$Maybe$Just(
					A3(
						$author$project$Components$Referentiel$PartiesPrenantes$Model$ChampFiltrable,
						servi.dy,
						servi.uN.Bl,
						$author$project$Components$Referentiel$PartiesPrenantes$Model$ParCases(
							A2(
								$elm$core$List$map,
								function (valeur) {
									return A2(
										$author$project$Components$Referentiel$PartiesPrenantes$Model$ChoixDeListe,
										valeur,
										A2($author$project$Components$Referentiel$PartiesPrenantes$Model$libelleDeLaValeur, servi.uN, valeur));
								},
								choix.Ki))));
			case 6:
				return $elm$core$Maybe$Just(
					A3($author$project$Components$Referentiel$PartiesPrenantes$Model$ChampFiltrable, servi.dy, servi.uN.Bl, $author$project$Components$Referentiel$PartiesPrenantes$Model$ParOuiNon));
			default:
				return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$Components$Referentiel$PartiesPrenantes$Model$champsFiltrables = function (model) {
	var _v0 = model.EE.mG.ib;
	if (_v0.b && (!_v0.b.b)) {
		var code = _v0.a;
		return A2(
			$elm$core$Maybe$map,
			function (servi) {
				return _Utils_Tuple2(
					servi,
					A2($elm$core$List$filterMap, $author$project$Components$Referentiel$PartiesPrenantes$Model$reglageDuChamp, servi.dw));
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (servi) {
						return _Utils_eq(
							$author$project$Components$Referentiel$Identifiants$typeUidToString(servi.r8),
							code);
					},
					model.ib)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$I18n$Cles$referentielPartiesPrenantesFiltresChampNon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.filtres.champ-non', _List_Nil, 'Non');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesFiltresChampOui = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.filtres.champ-oui', _List_Nil, 'Oui');
};
var $author$project$Components$Referentiel$PartiesPrenantes$View$filtreDeChampActif = F3(
	function (i18n, model, posee) {
		var valeur = function () {
			var _v1 = posee.fm;
			if (!_v1.$) {
				var texte = _v1.a;
				return texte;
			} else {
				if (_v1.a) {
					return $author$project$I18n$Cles$referentielPartiesPrenantesFiltresChampOui(i18n);
				} else {
					return $author$project$I18n$Cles$referentielPartiesPrenantesFiltresChampNon(i18n);
				}
			}
		}();
		var retrait = function () {
			var _v0 = posee.fm;
			if (!_v0.$) {
				var texte = _v0.a;
				return A3($author$project$Components$Referentiel$PartiesPrenantes$Update$ChoixBascule, posee.r0, posee.dy, texte);
			} else {
				return $author$project$Components$Referentiel$PartiesPrenantes$Update$ChampRetire(posee.dy);
			}
		}();
		var libelleDuChamp = A2(
			$elm$core$Maybe$withDefault,
			posee.dy,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bl;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (champ) {
							return _Utils_eq(champ.dy, posee.dy);
						},
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								$elm$core$Tuple$second,
								$author$project$Components$Referentiel$PartiesPrenantes$Model$champsFiltrables(model)))))));
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('filtre-actif'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					A2(
						$author$project$I18n$Cles$annuaireFiltreRetirer,
						i18n,
						{zH: libelleDuChamp})),
					$rtfeldman$elm_css$Html$Styled$Attributes$title(
					A2(
						$author$project$I18n$Cles$annuaireFiltreRetirer,
						i18n,
						{zH: libelleDuChamp})),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(retrait)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$annuaireFiltreActif,
								i18n,
								{zH: libelleDuChamp, fm: valeur}))
						])),
					$author$project$Components$Shared$Svg$svgClose
				]));
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesFiltresActifs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.filtres.actifs', _List_Nil, 'Filtres actifs');
};
var $author$project$Components$Referentiel$PartiesPrenantes$View$filtresActifs = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('filtres-actifs')
				]),
			function () {
				var _v0 = _Utils_Tuple2(
					$author$project$Components$Referentiel$PartiesPrenantes$Model$filtresPoses(model.EE.mG),
					model.dw);
				if ((!_v0.a.b) && (!_v0.b.b)) {
					return _List_Nil;
				} else {
					var poses = _v0.a;
					var champs = _v0.b;
					return A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielPartiesPrenantesFiltresActifs(i18n))
								])),
						A2(
							$elm$core$List$cons,
							A2(
								$rtfeldman$elm_css$Html$Styled$ul,
								_List_Nil,
								_Utils_ap(
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeL,
											A2(
												$elm$core$Basics$composeL,
												$rtfeldman$elm_css$Html$Styled$li(_List_Nil),
												$elm$core$List$singleton),
											A2($author$project$Components$Referentiel$PartiesPrenantes$View$filtreActif, i18n, model)),
										poses),
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeL,
											A2(
												$elm$core$Basics$composeL,
												$rtfeldman$elm_css$Html$Styled$li(_List_Nil),
												$elm$core$List$singleton),
											A2($author$project$Components$Referentiel$PartiesPrenantes$View$filtreDeChampActif, i18n, model)),
										champs))),
							_Utils_ap(
								A2($author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$boutonCopie, i18n, model),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$button,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('tout-effacer'),
												$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$PartiesPrenantes$Update$FiltresEffaces)
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$annuaireFiltresToutEffacer(i18n))
													]))
											]))
									]))));
				}
			}());
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesImporter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.importer', _List_Nil, 'Importer');
};
var $author$project$Components$Referentiel$PartiesPrenantes$View$importer = F2(
	function (i18n, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (lien) {
					return _List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Bouton$View$lien,
							1,
							A2(
								$author$project$Routes$Route$adresseImporterAvec,
								A2($author$project$API$Liens$parametre, 'domaine', lien),
								A2($author$project$API$Liens$parametre, 'type', lien)),
							$author$project$I18n$Cles$referentielPartiesPrenantesImporter(i18n))
						]);
				},
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.AB;
					},
					model.B1)));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$FiltresDemandes = {$: 21};
var $author$project$Components$Referentiel$PartiesPrenantes$Model$nombreDeFiltres = A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$PartiesPrenantes$Model$filtresPoses, $elm$core$List$length);
var $author$project$I18n$Cles$referentielPartiesPrenantesFiltresBouton = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parties-prenantes.filtres.bouton',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Filtres (' + (p.w + ')'));
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesFiltresBoutonSans = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.filtres.bouton-sans', _List_Nil, 'Filtres');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesRechercheEtiquette = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.recherche.etiquette', _List_Nil, 'Rechercher');
};
var $author$project$Components$Referentiel$PartiesPrenantes$View$recherche = F2(
	function (i18n, model) {
		var nombre = $author$project$Components$Referentiel$PartiesPrenantes$Model$nombreDeFiltres(model.EE.mG) + $elm$core$List$length(model.dw);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('recherche-et-filtres')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('recherche'),
							$rtfeldman$elm_css$Html$Styled$Attributes$for('parties-prenantes-recherche')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielPartiesPrenantesRechercheEtiquette(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('search'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id('parties-prenantes-recherche'),
									$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(
									$author$project$I18n$Cles$referentielPartiesPrenantesRecherche(i18n)),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									$author$project$I18n$Cles$annuaireRecherche(i18n)),
									$rtfeldman$elm_css$Html$Styled$Attributes$value(model.h3),
									$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Referentiel$PartiesPrenantes$Update$TermeSaisi)
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$PartiesPrenantes$Model$idDuDeclencheurDeFiltres),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('secondary'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('filtres'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'dialog'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$PartiesPrenantes$Update$FiltresDemandes)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									(!nombre) ? $author$project$I18n$Cles$referentielPartiesPrenantesFiltresBoutonSans(i18n) : A2(
										$author$project$I18n$Cles$referentielPartiesPrenantesFiltresBouton,
										i18n,
										{
											w: $elm$core$String$fromInt(nombre)
										}))
								]))
						]))
				]));
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesFilArianeListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.fil-ariane.liste', _List_Nil, 'Liste');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesSansDroit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.sans-droit', _List_Nil, 'Vous n\'avez pas le droit de lire les parties prenantes. Demandez à un administrateur de vous donner ce droit.');
};
var $author$project$Components$Referentiel$PartiesPrenantes$View$libelleDeLEtat = F2(
	function (i18n, etat) {
		_v0$2:
		while (true) {
			if (!etat.$) {
				switch (etat.a) {
					case 'closes':
						return $author$project$I18n$Cles$referentielPartiesPrenantesFiltresEtatCloses(i18n);
					case 'supprimees':
						return $author$project$I18n$Cles$referentielPartiesPrenantesFiltresEtatSupprimees(i18n);
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return $author$project$I18n$Cles$referentielPartiesPrenantesFiltresEtatActivesEtCloses(i18n);
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesSousTitreEtat = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parties-prenantes.sous-titre-etat',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w)),
					_Utils_Tuple2(
					'etat',
					$author$project$I18n$Traductions$Chaine(p.gt))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' fiche · ' + p.gt)) : (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' fiches · ' + p.gt)));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$View$sousTitre = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('sous-titre')
				]),
			function () {
				var _v0 = model.B1;
				if (_v0.$ === 1) {
					return _List_Nil;
				} else {
					var liste = _v0.a;
					return _List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$referentielPartiesPrenantesSousTitreEtat,
								i18n,
								{
									gt: $elm$core$String$toLower(
										A2($author$project$Components$Referentiel$PartiesPrenantes$View$libelleDeLEtat, i18n, model.EE.mG.gt)),
									w: liste.JE
								}))
						]);
				}
			}());
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Model$aDesFiltresChoisis = function (filtres) {
	return A2(
		$elm$core$List$any,
		function (_v0) {
			var filtre = _v0.a;
			var code = _v0.b;
			return (filtre !== 4) || (code !== '');
		},
		$author$project$Components$Referentiel$PartiesPrenantes$Model$filtresPoses(filtres));
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$ChampPoseEnTexte = F3(
	function (a, b, c) {
		return {$: 12, a: a, b: b, c: c};
	});
var $author$project$I18n$Cles$annuaireFiltreTous = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'annuaire.filtre.tous', _List_Nil, 'Tous');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesFiltresChampTous = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.filtres.champ-tous', _List_Nil, 'Tous');
};
var $author$project$Components$Referentiel$PartiesPrenantes$View$texteDe = function (valeur) {
	if (!valeur.$) {
		var texte = valeur.a;
		return $elm$core$Maybe$Just(texte);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Referentiel$PartiesPrenantes$View$champFiltrable = F4(
	function (i18n, model, code, champ) {
		var poses = A2($author$project$Components$Referentiel$PartiesPrenantes$Model$valeurPosee, champ.dy, model.dw);
		var idDuChamp = 'parties-prenantes-filtre-champ-' + champ.dy;
		var _v0 = champ.eO;
		switch (_v0.$) {
			case 0:
				var valeurs = _v0.a;
				return A2(
					$author$project$Components$Shared$Champ$View$liste,
					{go: $elm$core$Maybe$Nothing, Aq: idDuChamp, Bl: champ.Bl, he: false},
					{
						hg: function (choisi) {
							return A3(
								$author$project$Components$Referentiel$PartiesPrenantes$Update$ChampPoseEnTexte,
								code,
								champ.dy,
								(choisi === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
									$author$project$Components$Referentiel$Common$API$QueryAPIModel$Texte(choisi)));
						},
						o_: A2(
							$elm$core$List$cons,
							{
								Bl: $author$project$I18n$Cles$annuaireFiltreTous(i18n),
								fm: ''
							},
							valeurs),
						fm: A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$andThen,
								$author$project$Components$Referentiel$PartiesPrenantes$View$texteDe,
								$elm$core$List$head(poses)))
					});
			case 1:
				var choix = _v0.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$fieldset,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('cases-a-cocher'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(idDuChamp)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$legend,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(champ.Bl)
										]))
								])),
						A2(
							$elm$core$List$map,
							function (unChoix) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$label,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('case'),
											$rtfeldman$elm_css$Html$Styled$Attributes$for(idDuChamp + ('-' + unChoix.fm))
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$input,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
													$rtfeldman$elm_css$Html$Styled$Attributes$id(idDuChamp + ('-' + unChoix.fm)),
													$rtfeldman$elm_css$Html$Styled$Attributes$checked(
													A2(
														$elm$core$List$member,
														$author$project$Components$Referentiel$Common$API$QueryAPIModel$Texte(unChoix.fm),
														poses)),
													$rtfeldman$elm_css$Html$Styled$Events$onCheck(
													function (_v1) {
														return A3($author$project$Components$Referentiel$PartiesPrenantes$Update$ChoixBascule, code, champ.dy, unChoix.fm);
													})
												]),
											_List_Nil),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(unChoix.Bl)
												]))
										]));
							},
							choix)));
			default:
				var code_ = function (valeur) {
					if ((!valeur.$) && (valeur.a.$ === 1)) {
						if (valeur.a.a) {
							return 'oui';
						} else {
							return 'non';
						}
					} else {
						return '';
					}
				};
				return A2(
					$author$project$Components$Shared$Tuiles$View$view,
					{
						ve: $elm$core$Maybe$Just(
							code_(
								$elm$core$List$head(poses))),
						Bi: champ.Bl,
						Dj: idDuChamp,
						Eb: function (choisi) {
							return A3(
								$author$project$Components$Referentiel$PartiesPrenantes$Update$ChampPoseEnTexte,
								code,
								champ.dy,
								function () {
									switch (choisi) {
										case 'oui':
											return $elm$core$Maybe$Just(
												$author$project$Components$Referentiel$Common$API$QueryAPIModel$OuiNon(true));
										case 'non':
											return $elm$core$Maybe$Just(
												$author$project$Components$Referentiel$Common$API$QueryAPIModel$OuiNon(false));
										default:
											return $elm$core$Maybe$Nothing;
									}
								}());
						}
					},
					_List_fromArray(
						[
							{
							dH: '',
							h6: $author$project$I18n$Cles$referentielPartiesPrenantesFiltresChampTous(i18n),
							fm: ''
						},
							{
							dH: '',
							h6: $author$project$I18n$Cles$referentielPartiesPrenantesFiltresChampOui(i18n),
							fm: 'oui'
						},
							{
							dH: '',
							h6: $author$project$I18n$Cles$referentielPartiesPrenantesFiltresChampNon(i18n),
							fm: 'non'
						}
						]));
		}
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesFiltresChampsDuType = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parties-prenantes.filtres.champs-du-type',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Champs du type ' + p.Dj);
	});
var $author$project$Components$Referentiel$PartiesPrenantes$View$champsDuType = F2(
	function (i18n, model) {
		var _v0 = $author$project$Components$Referentiel$PartiesPrenantes$Model$champsFiltrables(model);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var servi = _v1.a;
			var champs = _v1.b;
			var code = $author$project$Components$Referentiel$Identifiants$typeUidToString(servi.r8);
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('filtre-champs-du-type'),
						$rtfeldman$elm_css$Html$Styled$Attributes$id('parties-prenantes-filtre-champs')
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$h3,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$referentielPartiesPrenantesFiltresChampsDuType,
									i18n,
									{
										Dj: $author$project$Components$Referentiel$Common$TypesServis$libelle(servi)
									}))
							])),
					A2(
						$elm$core$List$map,
						A3($author$project$Components$Referentiel$PartiesPrenantes$View$champFiltrable, i18n, model, code),
						champs)));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Referentiel$PartiesPrenantes$View$idDuFiltre = function (choisi) {
	switch (choisi) {
		case 0:
			return 'parties-prenantes-filtre-nature';
		case 1:
			return 'parties-prenantes-filtre-qualite';
		case 2:
			return 'parties-prenantes-filtre-pays';
		case 4:
			return 'parties-prenantes-filtre-etat';
		case 5:
			return 'parties-prenantes-filtre-groupe';
		case 6:
			return 'parties-prenantes-filtre-offre';
		default:
			return 'parties-prenantes-filtre-role';
	}
};
var $author$project$I18n$Cles$referentielPartiesPrenantesFiltresEtat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.filtres.etat', _List_Nil, 'État de la fiche');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesFiltresQualitePersonne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.filtres.qualite-personne', _List_Nil, 'Qualité (personne)');
};
var $author$project$Components$Referentiel$PartiesPrenantes$View$legendeDuVolet = F2(
	function (i18n, choisi) {
		switch (choisi) {
			case 1:
				return $author$project$I18n$Cles$referentielPartiesPrenantesFiltresQualitePersonne(i18n);
			case 4:
				return $author$project$I18n$Cles$referentielPartiesPrenantesFiltresEtat(i18n);
			default:
				return A2($author$project$Components$Referentiel$PartiesPrenantes$View$nomDuFiltre, i18n, choisi);
		}
	});
var $author$project$Components$Referentiel$PartiesPrenantes$View$choixExclusif = F4(
	function (i18n, model, choisi, choix) {
		return A2(
			$author$project$Components$Shared$Tuiles$View$view,
			{
				ve: $elm$core$Maybe$Just(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($author$project$Components$Referentiel$PartiesPrenantes$Model$filtrePose, choisi, model.EE.mG))),
				Bi: A2($author$project$Components$Referentiel$PartiesPrenantes$View$legendeDuVolet, i18n, choisi),
				Dj: $author$project$Components$Referentiel$PartiesPrenantes$View$idDuFiltre(choisi),
				Eb: $author$project$Components$Referentiel$PartiesPrenantes$Update$FiltreChoisi(choisi)
			},
			A2(
				$elm$core$List$map,
				function (_v0) {
					var valeur = _v0.a;
					var libelle = _v0.b;
					return {dH: '', h6: libelle, fm: valeur};
				},
				choix));
	});
var $author$project$API$NavLinksDictionary$fichesSupprimees = 'fiches-supprimees';
var $author$project$Components$Referentiel$PartiesPrenantes$Model$peutVoirLesSupprimees = function (model) {
	return !_Utils_eq(
		A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$fichesSupprimees, model.gF),
		$elm$core$Maybe$Nothing);
};
var $author$project$Components$Referentiel$PartiesPrenantes$View$proposee = F2(
	function (model, choix) {
		return (choix.fm !== 'supprimees') || $author$project$Components$Referentiel$PartiesPrenantes$Model$peutVoirLesSupprimees(model);
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesFiltresEtatParDefaut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.filtres.etat-par-defaut', _List_Nil, 'par défaut');
};
var $author$project$Components$Referentiel$PartiesPrenantes$View$filtreDEtat = F2(
	function (i18n, model) {
		return A2(
			$author$project$Components$Shared$Tuiles$View$view,
			{
				ve: $elm$core$Maybe$Just(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($author$project$Components$Referentiel$PartiesPrenantes$Model$filtrePose, 4, model.EE.mG))),
				Bi: A2($author$project$Components$Referentiel$PartiesPrenantes$View$legendeDuVolet, i18n, 4),
				Dj: $author$project$Components$Referentiel$PartiesPrenantes$View$idDuFiltre(4),
				Eb: $author$project$Components$Referentiel$PartiesPrenantes$Update$FiltreChoisi(4)
			},
			A2(
				$elm$core$List$cons,
				{
					dH: $author$project$I18n$Cles$referentielPartiesPrenantesFiltresEtatParDefaut(i18n),
					h6: $author$project$I18n$Cles$referentielPartiesPrenantesFiltresEtatActivesEtCloses(i18n),
					fm: ''
				},
				A2(
					$elm$core$List$map,
					function (choix) {
						return {dH: '', h6: choix.Bl, fm: choix.fm};
					},
					A2(
						$elm$core$List$filter,
						$author$project$Components$Referentiel$PartiesPrenantes$View$proposee(model),
						A3($author$project$Components$Referentiel$PartiesPrenantes$View$valeursDuFiltre, i18n, model, 4)))));
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesFiltresType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.filtres.type', _List_Nil, 'Type (rôle)');
};
var $author$project$Components$Referentiel$PartiesPrenantes$View$filtreParType = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$fieldset,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('cases-a-cocher'),
					$rtfeldman$elm_css$Html$Styled$Attributes$id(
					$author$project$Components$Referentiel$PartiesPrenantes$View$idDuFiltre(3))
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$legend,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielPartiesPrenantesFiltresType(i18n))
								]))
						])),
				A2(
					$elm$core$List$map,
					function (servi) {
						var code = $author$project$Components$Referentiel$Identifiants$typeUidToString(servi.r8);
						return A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('case'),
									$rtfeldman$elm_css$Html$Styled$Attributes$for(
									$author$project$Components$Referentiel$PartiesPrenantes$View$idDuFiltre(3) + ('-' + code))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$input,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
											$rtfeldman$elm_css$Html$Styled$Attributes$id(
											$author$project$Components$Referentiel$PartiesPrenantes$View$idDuFiltre(3) + ('-' + code)),
											$rtfeldman$elm_css$Html$Styled$Attributes$checked(
											A2($elm$core$List$member, code, model.EE.mG.ib)),
											$rtfeldman$elm_css$Html$Styled$Events$onCheck(
											function (_v0) {
												return A2($author$project$Components$Referentiel$PartiesPrenantes$Update$FiltreChoisi, 3, code);
											})
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Components$Referentiel$Common$TypesServis$libelle(servi))
										]))
								]));
					},
					model.ib)));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$View$filtre = F3(
	function (i18n, model, choisi) {
		var pose = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($author$project$Components$Referentiel$PartiesPrenantes$Model$filtrePose, choisi, model.EE.mG));
		var champ = {
			go: $elm$core$Maybe$Nothing,
			Aq: $author$project$Components$Referentiel$PartiesPrenantes$View$idDuFiltre(choisi),
			Bl: A2($author$project$Components$Referentiel$PartiesPrenantes$View$nomDuFiltre, i18n, choisi),
			he: false
		};
		switch (choisi) {
			case 3:
				return A2($author$project$Components$Referentiel$PartiesPrenantes$View$filtreParType, i18n, model);
			case 4:
				return A2($author$project$Components$Referentiel$PartiesPrenantes$View$filtreDEtat, i18n, model);
			default:
				return A2(
					$author$project$Components$Shared$Champ$View$liste,
					champ,
					{
						hg: $author$project$Components$Referentiel$PartiesPrenantes$Update$FiltreChoisi(choisi),
						o_: A2(
							$elm$core$List$cons,
							{
								Bl: $author$project$I18n$Cles$annuaireFiltreTous(i18n),
								fm: ''
							},
							A3($author$project$Components$Referentiel$PartiesPrenantes$View$valeursDuFiltre, i18n, model, choisi)),
						fm: pose
					});
		}
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesFiltresAfficher = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parties-prenantes.filtres.afficher',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Afficher ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' résultat')) : ('Afficher ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' résultats')));
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesFiltresNatureToutes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.filtres.nature-toutes', _List_Nil, 'Toutes');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesFiltresQualiteNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.filtres.qualite-note', _List_Nil, 'Forme (SAS, association…) à la place de la qualité quand la nature choisie est « Organisation ».');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesFiltresTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.filtres.titre', _List_Nil, 'Filtres');
};
var $author$project$Components$Referentiel$PartiesPrenantes$View$volet = F2(
	function (i18n, model) {
		return A4(
			$author$project$Components$Shared$Drawer$View$filtrage,
			i18n,
			$author$project$Components$Referentiel$PartiesPrenantes$Update$VoletMsg,
			{
				fs: {
					Bl: A2(
						$author$project$I18n$Cles$referentielPartiesPrenantesFiltresAfficher,
						i18n,
						{
							w: A2(
								$elm$core$Maybe$withDefault,
								0,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.JE;
									},
									model.B1))
						}),
					C$: $author$project$Components$Referentiel$PartiesPrenantes$Update$VoletMsg($author$project$Components$Shared$Drawer$Update$Fermer)
				},
				fZ: _Utils_ap(
					_List_fromArray(
						[
							A3($author$project$Components$Referentiel$PartiesPrenantes$View$filtre, i18n, model, 3),
							A2($author$project$Components$Referentiel$PartiesPrenantes$View$champsDuType, i18n, model),
							A4(
							$author$project$Components$Referentiel$PartiesPrenantes$View$choixExclusif,
							i18n,
							model,
							0,
							_List_fromArray(
								[
									_Utils_Tuple2(
									'',
									$author$project$I18n$Cles$referentielPartiesPrenantesFiltresNatureToutes(i18n)),
									_Utils_Tuple2(
									'Personne',
									$author$project$I18n$Cles$referentielNaturePersonne(i18n)),
									_Utils_Tuple2(
									'Organisation',
									$author$project$I18n$Cles$referentielNatureOrganisation(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('filtre-qualite')
								]),
							_List_fromArray(
								[
									A4(
									$author$project$Components$Referentiel$PartiesPrenantes$View$choixExclusif,
									i18n,
									model,
									1,
									_List_fromArray(
										[
											_Utils_Tuple2(
											'Professionnel',
											$author$project$I18n$Cles$referentielQualiteProfessionnel(i18n)),
											_Utils_Tuple2(
											'Particulier',
											$author$project$I18n$Cles$referentielQualiteParticulier(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$referentielPartiesPrenantesFiltresQualiteNote(i18n))
										]))
								])),
							A3($author$project$Components$Referentiel$PartiesPrenantes$View$filtre, i18n, model, 2)
						]),
					_Utils_ap(
						$elm$core$List$isEmpty(model.Ac) ? _List_Nil : _List_fromArray(
							[
								A3($author$project$Components$Referentiel$PartiesPrenantes$View$filtre, i18n, model, 5)
							]),
						_Utils_ap(
							$elm$core$List$isEmpty(
								$author$project$Components$Referentiel$Common$Offres$proposables(model.D3)) ? _List_Nil : _List_fromArray(
								[
									A3($author$project$Components$Referentiel$PartiesPrenantes$View$filtre, i18n, model, 6)
								]),
							_List_fromArray(
								[
									A2($author$project$Components$Referentiel$PartiesPrenantes$View$filtreDEtat, i18n, model),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('filtres-a-venir')
										]),
									_List_Nil)
								])))),
				q0: {
					sR: $author$project$Components$Referentiel$PartiesPrenantes$Model$aDesFiltresChoisis(model.EE.mG) || (!$elm$core$List$isEmpty(model.dw)),
					Bl: $author$project$I18n$Cles$annuaireFiltresToutEffacer(i18n),
					C$: $author$project$Components$Referentiel$PartiesPrenantes$Update$FiltresEffaces
				},
				h6: $author$project$I18n$Cles$referentielPartiesPrenantesFiltresTitre(i18n)
			},
			model.im);
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$ColonnesAppliquees = {$: 27};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$ColonnesRetablies = {$: 26};
var $author$project$Components$Referentiel$PartiesPrenantes$View$colonnePropre = F2(
	function (i18n, id) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (colonne) {
					return _Utils_eq(colonne.Aq, id) && (!colonne.he);
				},
				$author$project$Components$Referentiel$PartiesPrenantes$View$colonnes(i18n)));
	});
var $author$project$Components$Referentiel$PartiesPrenantes$Update$ColonnesBasculee = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$Referentiel$PartiesPrenantes$Update$ColonnesDeplacee = F2(
	function (a, b) {
		return {$: 25, a: a, b: b};
	});
var $author$project$Components$Referentiel$PartiesPrenantes$View$flecheDOrdre = F2(
	function (sens, attributs) {
		if (!sens) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$button,
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$class('monter'),
						attributs)),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('↑')
					]));
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$button,
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$class('descendre'),
						attributs)),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('↓')
					]));
		}
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesColonnesDescendre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parties-prenantes.colonnes.descendre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Descendre ' + p.Dj);
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesColonnesMonter = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parties-prenantes.colonnes.monter',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Monter ' + p.Dj);
	});
var $author$project$Components$Referentiel$PartiesPrenantes$View$ligneDeColonne = F3(
	function (i18n, model, colonne) {
		var idDeCase = 'colonne-' + colonne.Aq;
		var cochees = model.dA;
		var cochee = A2($elm$core$List$member, colonne.Aq, cochees);
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('colonne'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('cochee', cochee)
						]))
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$input,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
								$rtfeldman$elm_css$Html$Styled$Attributes$id(idDeCase),
								$rtfeldman$elm_css$Html$Styled$Attributes$checked(cochee),
								$rtfeldman$elm_css$Html$Styled$Events$onCheck(
								function (_v0) {
									return $author$project$Components$Referentiel$PartiesPrenantes$Update$ColonnesBasculee(colonne.Aq);
								})
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('nom'),
								$rtfeldman$elm_css$Html$Styled$Attributes$for(idDeCase)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(colonne.Bl)
							]))
					]),
				cochee ? _List_fromArray(
					[
						A2(
						$author$project$Components$Referentiel$PartiesPrenantes$View$flecheDOrdre,
						0,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id(
								_Utils_ap(
									idDeCase,
									$author$project$Components$Shared$Ordre$suffixe(0))),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								A2($author$project$Components$Referentiel$PartiesPrenantes$Update$ColonnesDeplacee, 0, colonne.Aq)),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
								_Utils_eq(
									$elm$core$List$head(cochees),
									$elm$core$Maybe$Just(colonne.Aq))),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-label',
								A2(
									$author$project$I18n$Cles$referentielPartiesPrenantesColonnesMonter,
									i18n,
									{Dj: colonne.Bl}))
							])),
						A2(
						$author$project$Components$Referentiel$PartiesPrenantes$View$flecheDOrdre,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id(
								_Utils_ap(
									idDeCase,
									$author$project$Components$Shared$Ordre$suffixe(1))),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								A2($author$project$Components$Referentiel$PartiesPrenantes$Update$ColonnesDeplacee, 1, colonne.Aq)),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
								_Utils_eq(
									$elm$core$List$head(
										$elm$core$List$reverse(cochees)),
									$elm$core$Maybe$Just(colonne.Aq))),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-label',
								A2(
									$author$project$I18n$Cles$referentielPartiesPrenantesColonnesDescendre,
									i18n,
									{Dj: colonne.Bl}))
							]))
					]) : _List_Nil));
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesColonnesNomToujoursAffichee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.colonnes.nom-toujours-affichee', _List_Nil, 'toujours affichée');
};
var $author$project$Components$Referentiel$PartiesPrenantes$View$ligneDuNom = function (i18n) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$li,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('colonne'),
				$rtfeldman$elm_css$Html$Styled$Attributes$class('obligatoire'),
				$rtfeldman$elm_css$Html$Styled$Attributes$class('cochee')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$input,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
						$rtfeldman$elm_css$Html$Styled$Attributes$id('colonne-nom'),
						$rtfeldman$elm_css$Html$Styled$Attributes$checked(true),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$label,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('nom'),
						$rtfeldman$elm_css$Html$Styled$Attributes$for('colonne-nom')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$referentielCreationNom(i18n))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$referentielPartiesPrenantesColonnesNomToujoursAffichee(i18n))
					]))
			]));
};
var $author$project$Components$Referentiel$PartiesPrenantes$Model$uniques = A2(
	$elm$core$List$foldl,
	F2(
		function (colonne, vues) {
			return A2($elm$core$List$member, colonne, vues) ? vues : _Utils_ap(
				vues,
				_List_fromArray(
					[colonne]));
		}),
	_List_Nil);
var $author$project$Components$Referentiel$PartiesPrenantes$Model$ordre = F2(
	function (catalogue, cochees) {
		var connues = $author$project$Components$Referentiel$PartiesPrenantes$Model$uniques(
			A2(
				$elm$core$List$filter,
				function (colonne) {
					return A2($elm$core$List$member, colonne, catalogue);
				},
				cochees));
		return _Utils_ap(
			connues,
			A2(
				$elm$core$List$filter,
				function (colonne) {
					return !A2($elm$core$List$member, colonne, connues);
				},
				catalogue));
	});
var $author$project$I18n$Cles$referentielPartiesPrenantesColonnesAppliquer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.colonnes.appliquer', _List_Nil, 'Appliquer');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesColonnesExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.colonnes.explication', _List_Nil, 'Choisir les colonnes du tableau et leur ordre. Le choix est gardé pour vous.');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesColonnesRetablir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.colonnes.retablir', _List_Nil, 'Rétablir par défaut');
};
var $author$project$I18n$Cles$referentielPartiesPrenantesColonnesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parties-prenantes.colonnes.titre', _List_Nil, 'Colonnes');
};
var $author$project$Components$Referentiel$PartiesPrenantes$View$voletDesColonnes = F2(
	function (i18n, model) {
		return A4(
			$author$project$Components$Shared$Drawer$View$filtrage,
			i18n,
			$author$project$Components$Referentiel$PartiesPrenantes$Update$VoletColonnesMsg,
			{
				fs: {
					Bl: $author$project$I18n$Cles$referentielPartiesPrenantesColonnesAppliquer(i18n),
					C$: $author$project$Components$Referentiel$PartiesPrenantes$Update$ColonnesAppliquees
				},
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('explication')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielPartiesPrenantesColonnesExplication(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('colonnes-a-choisir')
							]),
						A2(
							$elm$core$List$cons,
							$author$project$Components$Referentiel$PartiesPrenantes$View$ligneDuNom(i18n),
							A2(
								$elm$core$List$filterMap,
								function (id) {
									return A2(
										$elm$core$Maybe$map,
										A2($author$project$Components$Referentiel$PartiesPrenantes$View$ligneDeColonne, i18n, model),
										A2($author$project$Components$Referentiel$PartiesPrenantes$View$colonnePropre, i18n, id));
								},
								A2($author$project$Components$Referentiel$PartiesPrenantes$Model$ordre, $author$project$Components$Referentiel$PartiesPrenantes$Model$colonnesDuCatalogue, model.dA))))
					]),
				q0: {
					sR: true,
					Bl: $author$project$I18n$Cles$referentielPartiesPrenantesColonnesRetablir(i18n),
					C$: $author$project$Components$Referentiel$PartiesPrenantes$Update$ColonnesRetablies
				},
				h6: $author$project$I18n$Cles$referentielPartiesPrenantesColonnesTitre(i18n)
			},
			model.$9);
	});
var $author$project$Components$Referentiel$PartiesPrenantes$View$view = F6(
	function (i18n, versMsg, messages, liens, model, dialogues) {
		var fournies = A3($author$project$Components$Referentiel$PartiesPrenantes$View$donnees, i18n, liens, model);
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'referentiel-parties-prenantes-list',
			{
				ut: (model.gt === 1) ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('acces-refuse')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Note$View$view,
										1,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$referentielPartiesPrenantesSansDroit(i18n))
													]))
											]))
									]))
							]))
					]) : ((!model.gt) ? _List_Nil : A2(
					$elm$core$List$map,
					$rtfeldman$elm_css$Html$Styled$map(versMsg),
					_List_fromArray(
						[
							A2($author$project$Components$Referentiel$PartiesPrenantes$View$recherche, i18n, model),
							A2($author$project$Components$Referentiel$PartiesPrenantes$View$filtresActifs, i18n, model),
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							A2($author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$avis, i18n, model),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
								]),
							A4($author$project$Components$Shared$Annuaire$View$liste, i18n, $author$project$Components$Referentiel$PartiesPrenantes$Update$AnnuaireMsg, fournies, model.aS))
						]))),
				xy: _Utils_ap(
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$map(versMsg),
						_List_fromArray(
							[
								A2($author$project$Components$Referentiel$PartiesPrenantes$View$volet, i18n, model),
								A2($author$project$Components$Referentiel$PartiesPrenantes$View$voletDesColonnes, i18n, model),
								A2($author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$ajoutAuGroupe, i18n, model),
								A4(
								$author$project$Components$Referentiel$PartiesPrenantes$ViewGroupes$copie,
								i18n,
								A2($author$project$Components$Referentiel$PartiesPrenantes$View$criteresDeLaCopie, i18n, model),
								$author$project$Components$Referentiel$PartiesPrenantes$Model$termeCherche(model),
								model)
							])),
					dialogues),
				zM: A2(
					$elm$core$List$map,
					$rtfeldman$elm_css$Html$Styled$map(versMsg),
					A4($author$project$Components$Shared$Annuaire$View$fixed, i18n, $author$project$Components$Referentiel$PartiesPrenantes$Update$AnnuaireMsg, fournies, model.aS)),
				AK: false,
				JD: A2(
					$elm$core$List$map,
					$rtfeldman$elm_css$Html$Styled$map(versMsg),
					A2(
						$author$project$Components$Shared$Page$View$enTete,
						i18n,
						{
							vS: _List_fromArray(
								[
									A2($author$project$Components$Referentiel$PartiesPrenantes$View$sousTitre, i18n, model),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
										]),
									_Utils_ap(
										A3($author$project$Components$Referentiel$PartiesPrenantes$View$creation, i18n, $author$project$Components$Referentiel$PartiesPrenantes$Model$idDuDeclencheurDeCreation, liens),
										A2($author$project$Components$Referentiel$PartiesPrenantes$View$importer, i18n, model)))
								]),
							zE: _List_fromArray(
								[
									{
									aa: $author$project$Routes$Route$adressePartiesPrenantes,
									Dj: $author$project$I18n$Cles$referentielPartiesPrenantesTitre(i18n)
								},
									{
									aa: $author$project$Routes$Route$adressePartiesPrenantes,
									Dj: $author$project$I18n$Cles$referentielPartiesPrenantesFilArianeListe(i18n)
								}
								]),
							Ef: _List_Nil,
							h6: $author$project$I18n$Cles$referentielPartiesPrenantesTitre(i18n)
						}))
			});
	});
var $author$project$Components$Referentiel$Type$View$nomDeLaPage = 'referentiel-type-detail';
var $author$project$Components$Referentiel$Type$Update$AjoutOuvert = {$: 29};
var $author$project$I18n$Cles$referentielFicheChampsDuType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fiche.champs-du-type', _List_Nil, 'Champs du type');
};
var $author$project$I18n$Cles$referentielTypeChampsVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.champs.vide', _List_Nil, 'Aucun champ spécifique pour l\'instant.');
};
var $author$project$I18n$Cles$referentielTypeOngletChamps = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.onglet.champs', _List_Nil, 'Champs');
};
var $author$project$I18n$Cles$referentielInformationsPersonnelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.informations.personnelle', _List_Nil, 'Donnée personnelle');
};
var $author$project$I18n$Cles$referentielTypeChampsMasque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.champs.masque', _List_Nil, 'Masqué');
};
var $author$project$Components$Referentiel$Type$View$unChamp = F2(
	function (i18n, lu) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('masquee', lu.n4)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(lu.uN.Bl)
						])),
					lu.uN.xD ? A2(
					$author$project$Components$Shared$Tag$View$view,
					3,
					$author$project$I18n$Cles$referentielInformationsPersonnelle(i18n)) : $rtfeldman$elm_css$Html$Styled$text(''),
					lu.n4 ? A2(
					$author$project$Components$Shared$Tag$View$view,
					3,
					$author$project$I18n$Cles$referentielTypeChampsMasque(i18n)) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$Components$Referentiel$Type$View$champs = F4(
	function (i18n, masquee, model, fiche) {
		var lus = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.dw;
				},
				fiche.aN));
		return A2(
			$author$project$Components$Shared$Page$View$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('hidden', masquee)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					$author$project$I18n$Cles$referentielTypeOngletChamps(i18n))
				]),
			{
				fw: (!_Utils_eq(
					$author$project$Components$Referentiel$Type$Model$creation(fiche),
					$elm$core$Maybe$Nothing)) ? _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Type$Model$idDeLAjout),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Type$Update$AjoutOuvert)
							]),
						$author$project$I18n$Cles$editeurDeSchemaAjouterTitre(i18n))
					]) : _List_Nil,
				fZ: _List_fromArray(
					[
						_Utils_eq(lus, _List_Nil) ? A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielTypeChampsVide(i18n))
							])) : A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('informations')
							]),
						A2(
							$elm$core$List$map,
							$author$project$Components$Referentiel$Type$View$unChamp(i18n),
							lus))
					]),
				Dj: 'champs',
				h6: $author$project$I18n$Cles$referentielFicheChampsDuType(i18n)
			});
	});
var $author$project$Components$Referentiel$Type$Update$RechargementDemande = {$: 23};
var $author$project$I18n$Cles$referentielTypeConcurrente = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.concurrente', _List_Nil, 'Ce type a été modifié.');
};
var $author$project$I18n$Cles$referentielTypeRecharger = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.recharger', _List_Nil, 'Recharger');
};
var $author$project$Components$Referentiel$Type$View$concurrence = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('concurrence')
				]),
			model.fW ? _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Note$View$view,
					1,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielTypeConcurrente(i18n))
								]))
						])),
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Type$Model$idDuRechargement),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Type$Update$RechargementDemande)
						]),
					$author$project$I18n$Cles$referentielTypeRecharger(i18n))
				]) : _List_Nil);
	});
var $author$project$Components$Referentiel$Type$Update$ArchivageConfirme = {$: 20};
var $author$project$Components$Referentiel$Type$Update$FocusDemande = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Referentiel$Type$Update$clavierDeLaConfirmation = function () {
	var ids = $author$project$Components$Referentiel$Type$Model$idsDeLaConfirmation;
	return A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			var touche = _v0.a;
			var maj = _v0.b;
			var vers = _v0.c;
			return (touche !== 'Tab') ? $elm$json$Json$Decode$fail('') : ((maj && A2(
				$elm$core$List$member,
				vers,
				_List_fromArray(
					[ids.GN, ids.Cs]))) ? $elm$json$Json$Decode$succeed(
				_Utils_Tuple2(
					$author$project$Components$Referentiel$Type$Update$FocusDemande(ids.j7),
					true)) : (((!maj) && A2(
				$elm$core$List$member,
				vers,
				_List_fromArray(
					[ids.GN, ids.j7]))) ? $elm$json$Json$Decode$succeed(
				_Utils_Tuple2(
					$author$project$Components$Referentiel$Type$Update$FocusDemande(ids.Cs),
					true)) : $elm$json$Json$Decode$fail('')));
		},
		A4(
			$elm$json$Json$Decode$map3,
			F3(
				function (touche, maj, vers) {
					return _Utils_Tuple3(touche, maj, vers);
				}),
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['target', 'id']),
				$elm$json$Json$Decode$string)));
}();
var $author$project$I18n$Cles$referentielTypeArchivageAnnuler = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.archivage.annuler', _List_Nil, 'Annuler');
};
var $author$project$I18n$Cles$referentielTypeArchivageConfirmer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.archivage.confirmer', _List_Nil, 'Archiver');
};
var $author$project$I18n$Cles$referentielTypeArchivageMessage = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.type.archivage.message',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Ce type ne sera plus proposé à l\'ouverture d\'un rôle. ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' rôle ouvert reste affiché sur sa fiche.')) : ('Ce type ne sera plus proposé à l\'ouverture d\'un rôle. Les ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' rôles ouverts restent affichés sur les fiches.')));
	});
var $author$project$I18n$Cles$referentielTypeArchivageMessageSansRole = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.archivage.message.sans-role', _List_Nil, 'Ce type ne sera plus proposé à l\'ouverture d\'un rôle. Il n\'a aucun rôle ouvert.');
};
var $author$project$I18n$Cles$referentielTypeArchivageTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.type.archivage.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Archiver « ' + (p.Dj + ' » ?'));
	});
var $author$project$Components$Referentiel$Type$View$confirmation = F3(
	function (i18n, model, fiche) {
		var ids = $author$project$Components$Referentiel$Type$Model$idsDeLaConfirmation;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('drawer'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('opened', model.ir)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('overlay'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Type$Update$ArchivageAnnule)
						]),
					_List_Nil),
					A2(
					$author$project$Components$Shared$Confirmation$View$view,
					i18n,
					{
						vl: $author$project$Components$Referentiel$Type$Update$clavierDeLaConfirmation,
						j7: {
							Aq: ids.j7,
							Bl: $author$project$I18n$Cles$referentielTypeArchivageConfirmer(i18n),
							C$: $author$project$Components$Referentiel$Type$Update$ArchivageConfirme
						},
						Aq: ids.GN,
						As: ids.Cs,
						At: ids.h6,
						Cs: (!fiche.r0.Id) ? $author$project$I18n$Cles$referentielTypeArchivageMessageSansRole(i18n) : A2(
							$author$project$I18n$Cles$referentielTypeArchivageMessage,
							i18n,
							{w: fiche.r0.Id}),
						Et: model.ir,
						HG: {
							Aq: ids.to,
							Bl: $author$project$I18n$Cles$referentielTypeArchivageAnnuler(i18n),
							C$: $author$project$Components$Referentiel$Type$Update$ArchivageAnnule
						},
						h6: A2(
							$author$project$I18n$Cles$referentielTypeArchivageTitre,
							i18n,
							{Dj: fiche.r0.R.zX}),
						sl: 0
					})
				]));
	});
var $author$project$Components$Referentiel$Type$View$contexteDuRattachement = F2(
	function (model, fiche) {
		return {
			sZ: $author$project$Routes$Route$adresseBibliothequeDeChamps,
			cC: 1,
			Dp: fiche.r0.R.zX,
			pv: $author$project$Components$Shared$Drawer$Model$idRacine(model.lz)
		};
	});
var $author$project$Components$Referentiel$Common$RattacherUnChamp$SansEffet = {$: 0};
var $author$project$Components$Referentiel$Common$RattacherUnChamp$ChampChoisi = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Referentiel$Common$RattacherUnChamp$ChampExistantAChoisir = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Referentiel$Common$RattacherUnChamp$ElargissementConfirme = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Referentiel$Common$RattacherUnChamp$ElargissementDemande = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Referentiel$Common$RattacherUnChamp$ElargissementValide = {$: 12};
var $author$project$Components$Referentiel$Common$RattacherUnChamp$ExigenceReglee = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Referentiel$Common$RattacherUnChamp$LectureReglee = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Referentiel$Common$RattacherUnChamp$MasqueRegle = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Referentiel$Common$RattacherUnChamp$PersonnelleReglee = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Referentiel$Common$RattacherUnChamp$RechercheSaisie = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Common$RattacherUnChamp$messages = F2(
	function (vers, siens) {
		return {
			t4: siens.t4,
			uN: A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$RattacherUnChamp$ChampChoisi, vers),
			uQ: A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$RattacherUnChamp$ChampExistantAChoisir, vers),
			j7: A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$RattacherUnChamp$ElargissementConfirme, vers),
			xU: siens.xU,
			xV: A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$RattacherUnChamp$DuElargissement, vers),
			ya: F2(
				function (champ, ouvreur) {
					return vers(
						A2($author$project$Components$Referentiel$Common$RattacherUnChamp$ElargissementDemande, champ, ouvreur));
				}),
			mo: A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$RattacherUnChamp$ExigenceReglee, vers),
			zG: siens.zG,
			np: A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$RattacherUnChamp$LectureReglee, vers),
			n4: A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$RattacherUnChamp$MasqueRegle, vers),
			n9: A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$RattacherUnChamp$ModeChoisi, vers),
			Ff: $elm$core$Maybe$Just(
				A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$RattacherUnChamp$PersonnelleReglee, vers)),
			G1: siens.G1,
			hC: A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Common$RattacherUnChamp$RechercheSaisie, vers),
			Kv: vers($author$project$Components$Referentiel$Common$RattacherUnChamp$ElargissementValide)
		};
	});
var $author$project$Components$Referentiel$Type$View$messagesDuRattachement = F2(
	function (_v0, _v1) {
		return A2(
			$author$project$Components$Referentiel$Common$RattacherUnChamp$messages,
			$author$project$Components$Referentiel$Type$Update$DuRattachement,
			{
				t4: $author$project$Components$Referentiel$Type$Update$DuRattachement($author$project$Components$Referentiel$Common$RattacherUnChamp$SansEffet),
				xU: $author$project$Components$Referentiel$Type$Update$DuDrawerRattacher,
				zG: function (_v2) {
					return $author$project$Components$Referentiel$Type$Update$DuRattachement($author$project$Components$Referentiel$Common$RattacherUnChamp$SansEffet);
				},
				G1: function (_v3) {
					return $author$project$Components$Referentiel$Type$Update$DuRattachement($author$project$Components$Referentiel$Common$RattacherUnChamp$SansEffet);
				}
			});
	});
var $author$project$Components$Referentiel$Type$View$elargissement = F3(
	function (i18n, model, fiche) {
		return A6(
			$author$project$Components$Shared$Bibliotheque$View$elargir,
			i18n,
			A2($author$project$Components$Referentiel$Type$View$contexteDuRattachement, model, fiche),
			A2($author$project$Components$Referentiel$Type$View$messagesDuRattachement, model, fiche),
			$author$project$Components$Referentiel$Common$EnvoiDeType$enCours(model.l2),
			model.GZ.lP,
			model.GZ.lx);
	});
var $author$project$Components$Referentiel$Type$Update$RenommageOuvert = {$: 15};
var $author$project$Components$Referentiel$Type$Model$enAttente = function (model) {
	return $author$project$Components$Shared$Parcours$Model$enAttente(
		{
			cF: $author$project$Components$Referentiel$Common$EnvoiDeType$enCours(model.l2),
			Go: !_Utils_eq(model.l2, $author$project$API$Envoi$SansProcessUid),
			Hw: 0
		});
};
var $author$project$I18n$Cles$referentielTypeOngletGeneral = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.onglet.general', _List_Nil, 'Général');
};
var $author$project$I18n$Cles$referentielTypesRenommer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.renommer', _List_Nil, 'Renommer');
};
var $author$project$Components$Referentiel$Common$ValeursDeType$libelle = F3(
	function (i18n, code, lu) {
		switch (code) {
			case 'fr':
				return lu.R.zX;
			case 'en':
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$I18n$Cles$saisieDeChampListeAucune(i18n),
					lu.R.yg);
			default:
				return $author$project$I18n$Cles$saisieDeChampListeAucune(i18n);
		}
	});
var $author$project$I18n$Cles$referentielTypesChampApparenceAutre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.types.champ.apparence.autre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'code',
					$author$project$I18n$Traductions$Chaine(p.vx))
				]),
			'Autre (' + (p.vx + ')'));
	});
var $author$project$Components$Referentiel$Common$ValeursDeType$nom = F4(
	function (i18n, aucune, proposes, code) {
		if (code.$ === 1) {
			return aucune;
		} else {
			var porte = code.a;
			return A2(
				$elm$core$Maybe$withDefault,
				A2(
					$author$project$I18n$Cles$referentielTypesChampApparenceAutre,
					i18n,
					{vx: porte}),
				A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$second,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (_v1) {
								var propose = _v1.a;
								return _Utils_eq(propose, porte);
							},
							proposes))));
		}
	});
var $author$project$I18n$Cles$referentielTypesChampLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.champ.libelle', _List_Nil, 'Libellé');
};
var $author$project$Components$Referentiel$Common$ValeursDeType$nomDuLibelle = F2(
	function (i18n, code) {
		return A2(
			$author$project$I18n$Cles$saisieDeChampParNomDeLangue,
			i18n,
			{
				nn: A2($author$project$Referentiel$Langues$nom, i18n, code),
				Bl: $author$project$I18n$Cles$referentielTypesChampLibelle(i18n)
			});
	});
var $author$project$Components$Shared$Apparence$pastille = F2(
	function (i18n, type_) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('apparence'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					A2($author$project$Components$Shared$Apparence$classeDeCouleur, i18n, type_.kf))
				]),
			_List_fromArray(
				[
					A2($author$project$Components$Shared$Apparence$dessin, i18n, type_.aC)
				]));
	});
var $author$project$I18n$Cles$referentielTypesChampArchetype = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.champ.archetype', _List_Nil, 'Archétype');
};
var $author$project$I18n$Cles$referentielTypesChampCouleur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.champ.couleur', _List_Nil, 'Couleur');
};
var $author$project$I18n$Cles$referentielTypesChampCouleurAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.champ.couleur.aucune', _List_Nil, 'Aucune');
};
var $author$project$I18n$Cles$referentielTypesChampIcone = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.champ.icone', _List_Nil, 'Icône');
};
var $author$project$I18n$Cles$referentielTypesChampIconeAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.champ.icone.aucune', _List_Nil, 'Aucune');
};
var $author$project$Components$Referentiel$Common$ValeursDeType$valeur = F2(
	function (nomDeLaValeur, texte) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(nomDeLaValeur)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$strong,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(texte)
						]))
				]));
	});
var $author$project$Components$Referentiel$Common$ValeursDeType$view = F2(
	function (i18n, lu) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$ul,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('valeurs')
				]),
			_Utils_ap(
				A2(
					$elm$core$List$map,
					function (langue) {
						return A2(
							$author$project$Components$Referentiel$Common$ValeursDeType$valeur,
							A2($author$project$Components$Referentiel$Common$ValeursDeType$nomDuLibelle, i18n, langue.vx),
							A3($author$project$Components$Referentiel$Common$ValeursDeType$libelle, i18n, langue.vx, lu));
					},
					$author$project$Referentiel$Langues$desLibelles),
				_List_fromArray(
					[
						A2(
						$author$project$Components$Referentiel$Common$ValeursDeType$valeur,
						$author$project$I18n$Cles$referentielTypesChampArchetype(i18n),
						A2(
							$author$project$I18n$Cles$texte,
							i18n,
							$author$project$Components$Referentiel$Archetype$libelle(lu.fA))),
						A2(
						$author$project$Components$Referentiel$Common$ValeursDeType$valeur,
						$author$project$I18n$Cles$referentielTypesChampIcone(i18n),
						A4(
							$author$project$Components$Referentiel$Common$ValeursDeType$nom,
							i18n,
							$author$project$I18n$Cles$referentielTypesChampIconeAucune(i18n),
							A2(
								$elm$core$List$map,
								function (icone) {
									return _Utils_Tuple2(icone.vx, icone.Bl);
								},
								$author$project$Components$Shared$Apparence$icones(i18n)),
							lu.aC)),
						A2(
						$author$project$Components$Referentiel$Common$ValeursDeType$valeur,
						$author$project$I18n$Cles$referentielTypesChampCouleur(i18n),
						A4(
							$author$project$Components$Referentiel$Common$ValeursDeType$nom,
							i18n,
							$author$project$I18n$Cles$referentielTypesChampCouleurAucune(i18n),
							A2(
								$elm$core$List$map,
								function (couleur) {
									return _Utils_Tuple2(couleur.vx, couleur.Bl);
								},
								$author$project$Components$Shared$Apparence$couleurs(i18n)),
							lu.kf)),
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('dessin'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Apparence$pastille,
								i18n,
								{kf: lu.kf, aC: lu.aC})
							]))
					])));
	});
var $author$project$Components$Referentiel$Type$View$general = F4(
	function (i18n, masquee, model, fiche) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('general'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('hidden', masquee)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					$author$project$I18n$Cles$referentielTypeOngletGeneral(i18n))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					_List_fromArray(
						[
							A2($author$project$Components$Referentiel$Common$ValeursDeType$view, i18n, fiche.r0)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					function () {
						var _v0 = $author$project$Components$Referentiel$Type$Model$modification(fiche);
						if (!_v0.$) {
							return _List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Type$Model$idDuRenommer),
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Type$Update$RenommageOuvert),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
											$author$project$Components$Referentiel$Type$Model$enAttente(model)),
											$rtfeldman$elm_css$Html$Styled$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'loading',
													$author$project$Components$Referentiel$Type$Model$enAttente(model))
												])),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'dialog')
										]),
									$author$project$I18n$Cles$referentielTypesRenommer(i18n))
								]);
						} else {
							return _List_Nil;
						}
					}())
				]));
	});
var $author$project$Components$Referentiel$Type$Update$ArchivageDemande = {$: 18};
var $author$project$Components$Referentiel$Type$Update$RestaurationDemandee = {$: 21};
var $author$project$I18n$Cles$referentielTypeArchiver = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.archiver', _List_Nil, 'Archiver le type');
};
var $author$project$I18n$Cles$referentielTypeArchiverNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.archiver.note', _List_Nil, 'Archiver retire ce type des choix à l\'ouverture d\'un rôle. Les rôles ouverts continuent.');
};
var $author$project$I18n$Cles$referentielTypeRestaurer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.restaurer', _List_Nil, 'Restaurer le type');
};
var $author$project$Components$Referentiel$Type$View$gestes = F3(
	function (i18n, model, fiche) {
		var inactif = $author$project$Components$Referentiel$Type$Model$enAttente(model);
		var _v0 = _Utils_Tuple2(
			$author$project$Components$Referentiel$Type$Model$archivage(fiche),
			$author$project$Components$Referentiel$Type$Model$restauration(fiche));
		if (!_v0.a.$) {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$referentielTypeArchiverNote(i18n))
						])),
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					3,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Type$Model$idDeLArchivage),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Type$Update$ArchivageDemande),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('loading', inactif)
								]))
						]),
					$author$project$I18n$Cles$referentielTypeArchiver(i18n))
				]);
		} else {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				return _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Type$Model$idDeLaRestauration),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Type$Update$RestaurationDemandee),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif),
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('loading', inactif)
									]))
							]),
						$author$project$I18n$Cles$referentielTypeRestaurer(i18n))
					]);
			} else {
				var _v2 = _v0.a;
				var _v3 = _v0.b;
				return _List_Nil;
			}
		}
	});
var $author$project$Components$Referentiel$Type$Update$LimiteOuverte = {$: 3};
var $author$project$Components$Referentiel$Type$Update$SeulementChoisi = {$: 6};
var $author$project$Components$Referentiel$Type$Update$ToutesChoisies = {$: 5};
var $author$project$Components$Referentiel$Type$View$choixRadio = F5(
	function (code, choisi, actif, msg, libelle) {
		var ident = 'type-limite-' + code;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('choix')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(ident),
							$rtfeldman$elm_css$Html$Styled$Attributes$name('type-limite'),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(choisi),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!actif),
							$rtfeldman$elm_css$Html$Styled$Events$onCheck(
							function (_v0) {
								return msg;
							})
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$for(ident)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						]))
				]));
	});
var $author$project$Components$Referentiel$Type$Update$OffreRetiree = function (a) {
	return {$: 7, a: a};
};
var $author$project$I18n$Cles$referentielTypeLimiteOffreArretee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.type.limite.offre-arretee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.Dj + ' (arrêtée)');
	});
var $author$project$Components$Referentiel$Type$View$nomDeLOffre = F2(
	function (i18n, offre) {
		var nom = A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Cles$referentielRoleOffreIndisponible(i18n),
			offre.Dj);
		return offre.tL ? A2(
			$author$project$I18n$Cles$referentielTypeLimiteOffreArretee,
			i18n,
			{Dj: nom}) : nom;
	});
var $author$project$I18n$Cles$referentielTypeLimiteRetirer = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.type.limite.retirer',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer ' + p.Dj);
	});
var $author$project$Components$Referentiel$Type$View$pastilleDOffre = F4(
	function (i18n, geste, model, offre) {
		var retirer = A2(
			$author$project$I18n$Cles$referentielTypeLimiteRetirer,
			i18n,
			{
				Dj: A2($author$project$Components$Referentiel$Type$View$nomDeLOffre, i18n, offre)
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pill'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('arretee', offre.tL)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Referentiel$Type$View$nomDeLOffre, i18n, offre))
						])),
					geste ? A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', retirer),
							$rtfeldman$elm_css$Html$Styled$Attributes$title(retirer),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Referentiel$Type$Update$OffreRetiree(offre.Aq)),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
							$author$project$Components$Referentiel$Type$Model$enAttente(model))
						]),
					_List_fromArray(
						[$author$project$Components$Shared$Svg$svgClose])) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$I18n$Cles$referentielTypeLimiteAjouterOffre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.limite.ajouter-offre', _List_Nil, '+ Offre');
};
var $author$project$I18n$Cles$referentielTypeLimiteNote = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.type.limite.note',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? 'Ces restrictions s\'appliquent aux nouveaux rôles. Le rôle ouvert reste valide.' : ('Ces restrictions s\'appliquent aux nouveaux rôles. Les ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' rôles ouverts restent valides.')));
	});
var $author$project$I18n$Cles$referentielTypeLimiteSeulement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.limite.seulement', _List_Nil, 'Seulement ces offres de service :');
};
var $author$project$I18n$Cles$referentielTypeLimiteTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.limite.titre', _List_Nil, 'Qui peut porter ce rôle');
};
var $author$project$I18n$Cles$referentielTypeLimiteToutes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.limite.toutes', _List_Nil, 'Toutes les offres et la relation générale');
};
var $author$project$Components$Referentiel$Type$Model$seulement = F2(
	function (model, fiche) {
		return model.e2 || (!$elm$core$List$isEmpty(fiche.D3));
	});
var $author$project$Components$Referentiel$Type$View$limite = F4(
	function (i18n, masquee, model, fiche) {
		var seulement = A2($author$project$Components$Referentiel$Type$Model$seulement, model, fiche);
		var geste = !_Utils_eq(
			$author$project$Components$Referentiel$Type$Model$limitation(fiche),
			$elm$core$Maybe$Nothing);
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('offres'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('hidden', masquee)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					$author$project$I18n$Cles$referentielTypeLimiteTitre(i18n))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielTypeLimiteTitre(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$fieldset,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('choix-des-offres')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$legend,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$referentielTypeLimiteTitre(i18n))
												]))
										])),
									A5(
									$author$project$Components$Referentiel$Type$View$choixRadio,
									'toutes',
									!seulement,
									geste && (!$author$project$Components$Referentiel$Type$Model$enAttente(model)),
									$author$project$Components$Referentiel$Type$Update$ToutesChoisies,
									$author$project$I18n$Cles$referentielTypeLimiteToutes(i18n)),
									A5(
									$author$project$Components$Referentiel$Type$View$choixRadio,
									'seulement',
									seulement,
									geste && (!$author$project$Components$Referentiel$Type$Model$enAttente(model)),
									$author$project$Components$Referentiel$Type$Update$SeulementChoisi,
									$author$project$I18n$Cles$referentielTypeLimiteSeulement(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('pills'),
									$rtfeldman$elm_css$Html$Styled$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('hidden', !seulement)
										]))
								]),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									A3($author$project$Components$Referentiel$Type$View$pastilleDOffre, i18n, geste, model),
									fiche.D3),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$li,
										_List_Nil,
										_List_fromArray(
											[
												geste ? A2(
												$rtfeldman$elm_css$Html$Styled$button,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
														$rtfeldman$elm_css$Html$Styled$Attributes$class('ajouter-offre'),
														$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Type$Model$idDeLaLimite),
														$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Type$Update$LimiteOuverte),
														$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
														$author$project$Components$Referentiel$Type$Model$enAttente(model)),
														A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'dialog')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$referentielTypeLimiteAjouterOffre(i18n))
													])) : $rtfeldman$elm_css$Html$Styled$text('')
											]))
									]))),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$referentielTypeLimiteNote,
										i18n,
										{w: fiche.r0.Id}))
								]))
						]))
				]));
	});
var $author$project$I18n$Cles$referentielTypeListeDePrixDeviseEur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.liste-de-prix.devise.eur', _List_Nil, 'Euro (EUR)');
};
var $author$project$Components$Referentiel$Type$View$devise = F2(
	function (i18n, code) {
		return (code === 'EUR') ? $author$project$I18n$Cles$referentielTypeListeDePrixDeviseEur(i18n) : code;
	});
var $author$project$Components$Referentiel$Type$View$ligne = F2(
	function (libelle, valeur) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
						]),
					valeur)
				]));
	});
var $author$project$I18n$Cles$referentielTypeListeDePrixAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.liste-de-prix.aucune', _List_Nil, 'Aucune');
};
var $author$project$I18n$Cles$referentielTypeListeDePrixAvertissement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.liste-de-prix.avertissement', _List_Nil, 'Ce type n\'est dans aucune liste de prix en cours. Ajoutez ce type aux listes de prix concernées.');
};
var $author$project$I18n$Cles$referentielTypeListeDePrixDevise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.liste-de-prix.devise', _List_Nil, 'Devise');
};
var $author$project$I18n$Cles$referentielTypeListeDePrixFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.liste-de-prix.fin', _List_Nil, 'Valide jusqu\'au');
};
var $author$project$I18n$Cles$referentielTypeListeDePrixTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.liste-de-prix.titre', _List_Nil, 'Liste de prix');
};
var $author$project$I18n$Cles$referentielTypeListeDePrixUnique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.liste-de-prix.unique', _List_Nil, 'Un type n\'appartient qu\'à une liste de prix à la fois.');
};
var $author$project$I18n$Cles$referentielTypeListeDePrixVoir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.liste-de-prix.voir', _List_Nil, 'Ouvrir les listes de prix');
};
var $author$project$I18n$Cles$referentielTypeTarifsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.tarifs.titre', _List_Nil, 'Tarifs');
};
var $author$project$Components$Referentiel$Type$View$listeDePrix = F4(
	function (i18n, masquee, model, _v0) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('liste-de-prix'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('hidden', masquee)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					$author$project$I18n$Cles$referentielTypeTarifsTitre(i18n))
				]),
			function () {
				var _v1 = _Utils_Tuple2(model.BW, model.nY);
				if ((!_v1.a.$) && (_v1.b.$ === 1)) {
					var lue = _v1.b.a;
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('section-title')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h3,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$referentielTypeTarifsTitre(i18n))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
								]),
							function () {
								var _v2 = lue.nW;
								if (!_v2.$) {
									var liste = _v2.a;
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$ul,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('lignes')
												]),
											_Utils_ap(
												_List_fromArray(
													[
														A2(
														$author$project$Components$Referentiel$Type$View$ligne,
														$author$project$I18n$Cles$referentielTypeListeDePrixTitre(i18n),
														_List_fromArray(
															[
																A2(
																$rtfeldman$elm_css$Html$Styled$a,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Routes$Route$adresseListesDePrix)
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(liste.Dj.zX)
																	]))
															]))
													]),
												_Utils_ap(
													A2(
														$elm$core$Maybe$withDefault,
														_List_Nil,
														A2(
															$elm$core$Maybe$map,
															function (d) {
																return _List_fromArray(
																	[
																		A2(
																		$author$project$Components$Referentiel$Type$View$ligne,
																		$author$project$I18n$Cles$referentielTypeListeDePrixDevise(i18n),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(
																				A2($author$project$Components$Referentiel$Type$View$devise, i18n, d))
																			]))
																	]);
															},
															liste.kO)),
													A2(
														$elm$core$Maybe$withDefault,
														_List_Nil,
														A2(
															$elm$core$Maybe$map,
															function (f) {
																return _List_fromArray(
																	[
																		A2(
																		$author$project$Components$Referentiel$Type$View$ligne,
																		$author$project$I18n$Cles$referentielTypeListeDePrixFin(i18n),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(
																				A2($author$project$Texte$Jour$enFrancaisLong, i18n, f))
																			]))
																	]);
															},
															liste.mI))))),
											A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$referentielTypeListeDePrixUnique(i18n))
												]))
										]);
								} else {
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$ul,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('lignes')
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Components$Referentiel$Type$View$ligne,
													$author$project$I18n$Cles$referentielTypeListeDePrixTitre(i18n),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$referentielTypeListeDePrixAucune(i18n))
														]))
												])),
											lue.mq ? A2(
											$author$project$Components$Shared$Note$View$view,
											1,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$referentielTypeListeDePrixAvertissement(i18n))
														]))
												])) : $rtfeldman$elm_css$Html$Styled$text(''),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$a,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('button'),
															$rtfeldman$elm_css$Html$Styled$Attributes$class('primary'),
															$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Routes$Route$adresseListesDePrix)
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$span,
															_List_Nil,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	$author$project$I18n$Cles$referentielTypeListeDePrixVoir(i18n))
																]))
														]))
												]))
										]);
								}
							}())
						]);
				} else {
					return _List_Nil;
				}
			}());
	});
var $author$project$I18n$Cles$referentielTypesArchive = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.archive', _List_Nil, 'Archivé');
};
var $author$project$I18n$Cles$referentielTypesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.titre', _List_Nil, 'Types de parties prenantes');
};
var $author$project$Components$Referentiel$Type$Update$EnregistrementDemande = {$: 17};
var $author$project$Components$Referentiel$Common$FormulaireDeType$Fixe = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Common$FormulaireDeType$MotLibelle = 1;
var $author$project$Components$Referentiel$Type$Update$Saisi = function (a) {
	return {$: 14, a: a};
};
var $author$project$I18n$Cles$referentielTypeEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$referentielTypesRenommerDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.types.renommer.de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Renommer ' + p.Dj);
	});
var $author$project$Components$Referentiel$Common$SaisieDeType$Libelle = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Referentiel$Common$SaisieDeType$Couleur = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Referentiel$Common$SaisieDeType$Icone = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Common$FormulaireDeType$choix = F4(
	function (i18n, aucune, proposes, code) {
		return A2(
			$elm$core$List$cons,
			{Bl: aucune, fm: ''},
			_Utils_ap(
				proposes,
				((code === '') || A2(
					$elm$core$List$any,
					function (propose) {
						return _Utils_eq(propose.fm, code);
					},
					proposes)) ? _List_Nil : _List_fromArray(
					[
						{
						Bl: A2(
							$author$project$I18n$Cles$referentielTypesChampApparenceAutre,
							i18n,
							{vx: code}),
						fm: code
					}
					])));
	});
var $author$project$Components$Referentiel$Common$FormulaireDeType$couleurs = function (i18n) {
	return A3(
		$author$project$Components$Referentiel$Common$FormulaireDeType$choix,
		i18n,
		$author$project$I18n$Cles$referentielTypesChampCouleurAucune(i18n),
		A2(
			$elm$core$List$map,
			function (couleur) {
				return {Bl: couleur.Bl, fm: couleur.vx};
			},
			$author$project$Components$Shared$Apparence$couleurs(i18n)));
};
var $author$project$Components$Referentiel$Common$FormulaireDeType$icones = function (i18n) {
	return A3(
		$author$project$Components$Referentiel$Common$FormulaireDeType$choix,
		i18n,
		$author$project$I18n$Cles$referentielTypesChampIconeAucune(i18n),
		A2(
			$elm$core$List$map,
			function (icone) {
				return {Bl: icone.Bl, fm: icone.vx};
			},
			$author$project$Components$Shared$Apparence$icones(i18n)));
};
var $author$project$Components$Referentiel$Common$FormulaireDeType$apparence = F3(
	function (i18n, prefixe, saisie) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('apparence-choix')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: prefixe + '-icone',
						Bl: $author$project$I18n$Cles$referentielTypesChampIcone(i18n),
						he: false
					},
					{
						hg: $author$project$Components$Referentiel$Common$SaisieDeType$Icone,
						o_: A2($author$project$Components$Referentiel$Common$FormulaireDeType$icones, i18n, saisie.aC),
						fm: saisie.aC
					}),
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: prefixe + '-couleur',
						Bl: $author$project$I18n$Cles$referentielTypesChampCouleur(i18n),
						he: false
					},
					{
						hg: $author$project$Components$Referentiel$Common$SaisieDeType$Couleur,
						o_: A2($author$project$Components$Referentiel$Common$FormulaireDeType$couleurs, i18n, saisie.kf),
						fm: saisie.kf
					}),
					A2(
					$author$project$Components$Shared$Apparence$pastille,
					i18n,
					{
						kf: (saisie.kf === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(saisie.kf),
						aC: (saisie.aC === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(saisie.aC)
					})
				]));
	});
var $author$project$Components$Referentiel$Common$SaisieDeType$Archetype = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Referentiel$Common$SaisieDeType$erreurDeLArchetype = function (saisie) {
	return saisie.b5 && _Utils_eq(
		$author$project$Components$Referentiel$Common$SaisieDeType$archetype(saisie),
		$elm$core$Maybe$Nothing);
};
var $author$project$I18n$Cles$referentielTypesChampArchetypeChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.champ.archetype.choisir', _List_Nil, 'Choisir un modèle…');
};
var $author$project$I18n$Cles$referentielTypesChampArchetypeComportement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.champ.archetype.comportement', _List_Nil, 'Il se comporte comme');
};
var $author$project$I18n$Cles$referentielTypesChampArchetypeObligatoire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.champ.archetype.obligatoire', _List_Nil, 'L\'archétype est obligatoire.');
};
var $author$project$Components$Referentiel$Common$FormulaireDeType$archetype = F3(
	function (i18n, prefixe, saisie) {
		return A2(
			$author$project$Components$Shared$Champ$View$liste,
			{
				go: $author$project$Components$Referentiel$Common$SaisieDeType$erreurDeLArchetype(saisie) ? $elm$core$Maybe$Just(
					$author$project$I18n$Cles$referentielTypesChampArchetypeObligatoire(i18n)) : $elm$core$Maybe$Nothing,
				Aq: $author$project$Components$Referentiel$Common$SaisieDeType$idDeLArchetype(prefixe),
				Bl: $author$project$I18n$Cles$referentielTypesChampArchetypeComportement(i18n),
				he: true
			},
			{
				hg: $author$project$Components$Referentiel$Common$SaisieDeType$Archetype,
				o_: A2(
					$elm$core$List$cons,
					{
						Bl: $author$project$I18n$Cles$referentielTypesChampArchetypeChoisir(i18n),
						fm: ''
					},
					A2(
						$elm$core$List$map,
						function (propose) {
							return {
								Bl: A2(
									$author$project$I18n$Cles$texte,
									i18n,
									$author$project$Components$Referentiel$Archetype$libelle(propose)),
								fm: $author$project$Components$Referentiel$Archetype$code(propose)
							};
						},
						$author$project$Components$Referentiel$Archetype$tous)),
				fm: saisie.fA
			});
	});
var $author$project$Components$Referentiel$Common$SaisieDeType$DejaUtilise = 1;
var $author$project$Components$Referentiel$Common$SaisieDeType$Obligatoire = 0;
var $author$project$Components$Referentiel$Common$SaisieDeType$erreurDuLibelle = F2(
	function (code, saisie) {
		return (saisie.b5 && A2(
			$elm$core$List$member,
			code,
			A2($author$project$Components$Shared$LibellesParLangue$Model$manquantes, $author$project$Referentiel$Langues$desLibelles, saisie.R))) ? $elm$core$Maybe$Just(0) : (_Utils_eq(
			saisie.bW,
			$elm$core$Maybe$Just(code)) ? $elm$core$Maybe$Just(1) : $elm$core$Maybe$Nothing);
	});
var $author$project$I18n$Cles$referentielTypesChampLibelleDejaUtilise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.champ.libelle.deja-utilise', _List_Nil, 'Un type porte déjà ce libellé');
};
var $author$project$I18n$Cles$referentielTypesChampLibelleObligatoire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.champ.libelle.obligatoire', _List_Nil, 'Le libellé est obligatoire.');
};
var $author$project$I18n$Cles$referentielTypesChampNomDejaUtilise = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.champ.nom.deja-utilise', _List_Nil, 'Un type porte déjà ce nom, archivé ou non.');
};
var $author$project$I18n$Cles$referentielTypesChampNomObligatoire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.champ.nom.obligatoire', _List_Nil, 'Le nom est obligatoire.');
};
var $author$project$Components$Referentiel$Common$FormulaireDeType$erreurDuLibelle = F4(
	function (i18n, vocabulaire, saisie, code) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$Components$Referentiel$Common$SaisieDeType$erreurDuLibelle, code, saisie),
			vocabulaire);
		if (!_v0.a.$) {
			if (!_v0.a.a) {
				if (!_v0.b) {
					var _v1 = _v0.a.a;
					var _v2 = _v0.b;
					return $elm$core$Maybe$Just(
						$author$project$I18n$Cles$referentielTypesChampNomObligatoire(i18n));
				} else {
					var _v3 = _v0.a.a;
					var _v4 = _v0.b;
					return $elm$core$Maybe$Just(
						$author$project$I18n$Cles$referentielTypesChampLibelleObligatoire(i18n));
				}
			} else {
				if (!_v0.b) {
					var _v5 = _v0.a.a;
					var _v6 = _v0.b;
					return $elm$core$Maybe$Just(
						$author$project$I18n$Cles$referentielTypesChampNomDejaUtilise(i18n));
				} else {
					var _v7 = _v0.a.a;
					var _v8 = _v0.b;
					return $elm$core$Maybe$Just(
						$author$project$I18n$Cles$referentielTypesChampLibelleDejaUtilise(i18n));
				}
			}
		} else {
			var _v9 = _v0.a;
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Referentiel$Common$FormulaireDeType$inactif = F4(
	function (champ, nom, valeur, aide) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$fieldset,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('disabled')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$legend,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id(champ + '-libelle')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(nom)
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$input,
						_Utils_ap(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id(champ),
									$rtfeldman$elm_css$Html$Styled$Attributes$value(valeur),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-labelledby', champ + '-libelle')
								]),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (_v0) {
										return _List_fromArray(
											[
												A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-describedby', champ + '-aide')
											]);
									},
									aide))),
						_List_Nil)
					]),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (dite) {
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('aide'),
											$rtfeldman$elm_css$Html$Styled$Attributes$id(champ + '-aide')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(dite)
										]))
								]);
						},
						aide))));
	});
var $author$project$I18n$Cles$referentielArchetypeClientExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.archetype.client.explication', _List_Nil, 'on lui vend, il a des commandes et des factures.');
};
var $author$project$I18n$Cles$referentielArchetypeCollaborateurExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.archetype.collaborateur.explication', _List_Nil, 'une personne de votre organisation.');
};
var $author$project$I18n$Cles$referentielArchetypeConcurrentExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.archetype.concurrent.explication', _List_Nil, 'un acteur du marché que vos produits comparent.');
};
var $author$project$I18n$Cles$referentielArchetypeFournisseurExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.archetype.fournisseur.explication', _List_Nil, 'on lui achète.');
};
var $author$project$I18n$Cles$referentielArchetypePartenaireExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.archetype.partenaire.explication', _List_Nil, 'on travaille avec lui sans transaction directe.');
};
var $author$project$I18n$Cles$referentielArchetypePrescripteurExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.archetype.prescripteur.explication', _List_Nil, 'il recommande vos produits.');
};
var $author$project$I18n$Cles$referentielArchetypeProspectExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.archetype.prospect.explication', _List_Nil, 'un client possible, en cours de démarche.');
};
var $author$project$I18n$Cles$referentielArchetypeRelationPresseExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.archetype.relation-presse.explication', _List_Nil, 'un journaliste, un média.');
};
var $author$project$I18n$Cles$referentielArchetypeSuspectExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.archetype.suspect.explication', _List_Nil, 'un contact pas encore qualifié.');
};
var $author$project$Components$Referentiel$Archetype$explication = F2(
	function (i18n, archetype) {
		switch (archetype) {
			case 0:
				return $author$project$I18n$Cles$referentielArchetypeSuspectExplication(i18n);
			case 1:
				return $author$project$I18n$Cles$referentielArchetypeProspectExplication(i18n);
			case 2:
				return $author$project$I18n$Cles$referentielArchetypeClientExplication(i18n);
			case 3:
				return $author$project$I18n$Cles$referentielArchetypeCollaborateurExplication(i18n);
			case 4:
				return $author$project$I18n$Cles$referentielArchetypeFournisseurExplication(i18n);
			case 5:
				return $author$project$I18n$Cles$referentielArchetypePartenaireExplication(i18n);
			case 6:
				return $author$project$I18n$Cles$referentielArchetypePrescripteurExplication(i18n);
			case 7:
				return $author$project$I18n$Cles$referentielArchetypeRelationPresseExplication(i18n);
			default:
				return $author$project$I18n$Cles$referentielArchetypeConcurrentExplication(i18n);
		}
	});
var $author$project$I18n$Cles$referentielTypesCreationModele = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.types.creation.modele',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'modele',
					$author$project$I18n$Traductions$Chaine(p.oa)),
					_Utils_Tuple2(
					'explication',
					$author$project$I18n$Traductions$Chaine(p.y8))
				]),
			p.oa + (' : ' + (p.y8 + ' Le modèle ne change plus une fois des fiches ouvertes.')));
	});
var $author$project$Components$Referentiel$Common$FormulaireDeType$modele = F3(
	function (i18n, prefixe, saisie) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('aide'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('modele'),
					$rtfeldman$elm_css$Html$Styled$Attributes$id(
					$author$project$Components$Referentiel$Common$SaisieDeType$idDeLArchetype(prefixe) + '-modele')
				]),
			function () {
				var _v0 = $author$project$Components$Referentiel$Common$SaisieDeType$archetype(saisie);
				if (!_v0.$) {
					var choisi = _v0.a;
					return _List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$referentielTypesCreationModele,
								i18n,
								{
									y8: A2($author$project$Components$Referentiel$Archetype$explication, i18n, choisi),
									oa: A2(
										$author$project$I18n$Cles$texte,
										i18n,
										$author$project$Components$Referentiel$Archetype$libelle(choisi))
								}))
						]);
				} else {
					return _List_Nil;
				}
			}());
	});
var $author$project$I18n$Cles$referentielTypesChampArchetypeFixe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.champ.archetype.fixe', _List_Nil, 'Fixé à la création.');
};
var $author$project$I18n$Cles$referentielTypesChampNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.champ.nom', _List_Nil, 'Nom');
};
var $author$project$Components$Referentiel$Common$FormulaireDeType$view = F3(
	function (i18n, presentation, saisie) {
		var prefixe = presentation.pv;
		var libelles = A4(
			$author$project$Components$Shared$LibellesParLangue$View$avecIndications,
			i18n,
			function (code) {
				return A2($author$project$Components$Shared$LibellesParLangue$Model$obligatoire, $author$project$Referentiel$Langues$desLibelles, code) ? presentation.na : $elm$core$Maybe$Nothing;
			},
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('libelles')
				]),
			{
				go: A3($author$project$Components$Referentiel$Common$FormulaireDeType$erreurDuLibelle, i18n, presentation.il, saisie),
				Ba: $author$project$Referentiel$Langues$desLibelles,
				Bl: function () {
					var _v1 = presentation.il;
					if (!_v1) {
						return $author$project$I18n$Cles$referentielTypesChampNom(i18n);
					} else {
						return $author$project$I18n$Cles$referentielTypesChampLibelle(i18n);
					}
				}(),
				hg: $author$project$Components$Referentiel$Common$SaisieDeType$Libelle,
				pv: $author$project$Components$Referentiel$Common$SaisieDeType$prefixeDesLibelles(prefixe),
				fm: function (code) {
					return A2($author$project$Components$Shared$LibellesParLangue$Model$lire, code, saisie.R);
				}
			});
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Components$Shared$Messages$View$view,
				i18n,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $elm$core$List$singleton, saisie.pZ))),
			_Utils_ap(
				function () {
					var _v0 = presentation.fA;
					if (!_v0.$) {
						return _List_fromArray(
							[
								libelles,
								A3($author$project$Components$Referentiel$Common$FormulaireDeType$archetype, i18n, prefixe, saisie),
								A3($author$project$Components$Referentiel$Common$FormulaireDeType$modele, i18n, prefixe, saisie)
							]);
					} else {
						var nom = _v0.a;
						return _List_fromArray(
							[
								libelles,
								A4(
								$author$project$Components$Referentiel$Common$FormulaireDeType$inactif,
								$author$project$Components$Referentiel$Common$SaisieDeType$idDeLArchetype(prefixe),
								$author$project$I18n$Cles$referentielTypesChampArchetype(i18n),
								nom,
								$elm$core$Maybe$Just(
									$author$project$I18n$Cles$referentielTypesChampArchetypeFixe(i18n)))
							]);
					}
				}(),
				presentation.jf ? _List_fromArray(
					[
						A3($author$project$Components$Referentiel$Common$FormulaireDeType$apparence, i18n, prefixe, saisie)
					]) : _List_Nil));
	});
var $author$project$Components$Referentiel$Type$View$renommage = F3(
	function (i18n, model, fiche) {
		var ouvert = $author$project$Components$Shared$Drawer$Model$estOuvert(model.hL);
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$Type$Update$DuRenommage,
			{
				fs: {
					sR: ouvert && (!$author$project$Components$Referentiel$Type$Model$enAttente(model)),
					Bl: ouvert ? $author$project$I18n$Cles$referentielTypeEnregistrer(i18n) : '',
					C$: $author$project$Components$Referentiel$Type$Update$EnregistrementDemande
				},
				fZ: ouvert ? A2(
					$elm$core$List$map,
					$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Referentiel$Type$Update$Saisi),
					A3(
						$author$project$Components$Referentiel$Common$FormulaireDeType$view,
						i18n,
						{
							fA: $author$project$Components$Referentiel$Common$FormulaireDeType$Fixe(
								A2(
									$author$project$I18n$Cles$texte,
									i18n,
									$author$project$Components$Referentiel$Archetype$libelle(fiche.r0.fA))),
							jf: true,
							na: $elm$core$Maybe$Nothing,
							pv: $author$project$Components$Referentiel$Type$Model$prefixe,
							il: 1
						},
						model.hP)) : _List_Nil,
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: ouvert ? A2(
					$author$project$I18n$Cles$referentielTypesRenommerDe,
					i18n,
					{Dj: fiche.r0.R.zX}) : ''
			},
			model.hL);
	});
var $author$project$Components$Referentiel$Common$Dates$enFrancais = function (date) {
	var _v0 = A2($elm$core$String$split, '-', date);
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
		var annee = _v0.a;
		var _v1 = _v0.b;
		var mois = _v1.a;
		var _v2 = _v1.b;
		var jour = _v2.a;
		return A2(
			$elm$core$List$all,
			$elm$core$String$all($elm$core$Char$isDigit),
			_List_fromArray(
				[annee, mois, jour])) ? A2(
			$elm$core$String$join,
			'/',
			_List_fromArray(
				[jour, mois, annee])) : date;
	} else {
		return date;
	}
};
var $author$project$I18n$Cles$referentielTypeResume = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.type.resume',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'archetype',
					$author$project$I18n$Traductions$Chaine(p.fA)),
					_Utils_Tuple2(
					'roles',
					$author$project$I18n$Traductions$Chaine(p.eX))
				]),
			'Archétype ' + (p.fA + (' · ' + p.eX)));
	});
var $author$project$I18n$Cles$referentielTypeResumeDate = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.type.resume.date',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'archetype',
					$author$project$I18n$Traductions$Chaine(p.fA)),
					_Utils_Tuple2(
					'roles',
					$author$project$I18n$Traductions$Chaine(p.eX)),
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Archétype ' + (p.fA + (' · ' + (p.eX + (' · modifié le ' + p.wv)))));
	});
var $author$project$I18n$Cles$referentielTypeRolesOuverts = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.type.roles-ouverts',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' rôle ouvert') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' rôles ouverts'));
	});
var $author$project$Components$Referentiel$Common$ValeursDeType$resume = F2(
	function (i18n, fiche) {
		var roles = A2(
			$author$project$I18n$Cles$referentielTypeRolesOuverts,
			i18n,
			{w: fiche.r0.Id});
		var archetype = A2(
			$author$project$I18n$Cles$texte,
			i18n,
			$author$project$Components$Referentiel$Archetype$libelle(fiche.r0.fA));
		var _v0 = fiche.CN;
		if (!_v0.$) {
			var date = _v0.a;
			return A2(
				$author$project$I18n$Cles$referentielTypeResumeDate,
				i18n,
				{
					fA: archetype,
					wv: $author$project$Components$Referentiel$Common$Dates$enFrancais(
						A2($elm$core$String$left, 10, date)),
					eX: roles
				});
		} else {
			return A2(
				$author$project$I18n$Cles$referentielTypeResume,
				i18n,
				{fA: archetype, eX: roles});
		}
	});
var $author$project$Components$Referentiel$Type$Update$LimiteEnregistree = {$: 10};
var $author$project$Components$Referentiel$Type$Update$OffreCochee = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Referentiel$Type$Update$OffreRecherchee = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Referentiel$Common$ChoixDesOffres$aChoisir = F3(
	function (i18n, saisie, choisies) {
		var proposeesParLeBack = $author$project$Components$Referentiel$Common$Offres$toutes(saisie.D3);
		var dejaChoisie = function (offre) {
			return A2(
				$elm$core$List$any,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Aq;
					},
					$elm$core$Basics$eq(offre.Aq)),
				choisies);
		};
		var proposees = A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, dejaChoisie),
			proposeesParLeBack);
		var deLEnsemble = A2(
			$elm$core$List$map,
			function (o) {
				return _Utils_update(
					o,
					{
						uK: A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.uK;
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.Aq;
										},
										$elm$core$Basics$eq(o.Aq)),
									proposeesParLeBack)))
					});
			},
			$author$project$Components$Referentiel$Common$Offres$depuis(choisies));
		var cherche = $elm$core$String$toLower(
			$elm$core$String$trim(saisie.hC));
		return A2(
			$elm$core$List$map,
			function (o) {
				return {
					f7: dejaChoisie(o),
					D1: o
				};
			},
			A2(
				$elm$core$List$filter,
				function (o) {
					return A2(
						$elm$core$String$contains,
						cherche,
						$elm$core$String$toLower(
							A2(
								$author$project$I18n$Cles$texte,
								i18n,
								$author$project$Components$Referentiel$Common$Offres$nom(o))));
				},
				_Utils_ap(deLEnsemble, proposees)));
	});
var $author$project$I18n$Cles$referentielTypeLimiteEtatArretee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.limite.etat.arretee', _List_Nil, 'Service · arrêtée');
};
var $author$project$I18n$Cles$referentielTypeLimiteEtatArreteeDansLaListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.limite.etat.arretee-dans-la-liste', _List_Nil, 'Service · arrêtée · dans la liste');
};
var $author$project$I18n$Cles$referentielTypeLimiteEtatEnCours = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.limite.etat.en-cours', _List_Nil, 'Service · en cours');
};
var $author$project$Components$Referentiel$Common$ChoixDesOffres$caseDOffre = F4(
	function (i18n, messages, saisie, _v0) {
		var offre = _v0.D1;
		var dejaChoisie = _v0.f7;
		var ident = messages.Au + ('-offre-' + offre.Aq);
		var figee = offre.tL || ((!messages.qI) && dejaChoisie);
		var cochee = messages.qI ? (A2($elm$core$List$member, offre.Aq, saisie.at) || (offre.tL && dejaChoisie)) : (dejaChoisie || A2($elm$core$List$member, offre.Aq, saisie.at));
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('figee', figee),
							_Utils_Tuple2('choisie', cochee)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(ident),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(cochee),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(figee),
							$rtfeldman$elm_css$Html$Styled$Events$onCheck(
							messages.Jd(offre.Aq))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$for(ident)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$texte,
										i18n,
										$author$project$Components$Referentiel$Common$Offres$nom(offre)))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('etat')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									(offre.tL && dejaChoisie) ? $author$project$I18n$Cles$referentielTypeLimiteEtatArreteeDansLaListe(i18n) : (offre.tL ? $author$project$I18n$Cles$referentielTypeLimiteEtatArretee(i18n) : $author$project$I18n$Cles$referentielTypeLimiteEtatEnCours(i18n)))
								]))
						]))
				]));
	});
var $author$project$I18n$Cles$referentielTypeLimiteAutresOffres = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.limite.autres-offres', _List_Nil, 'Autres offres');
};
var $author$project$Components$Referentiel$Common$ChoixDesOffres$groupe = F4(
	function (i18n, messages, saisie, _v0) {
		var categorie = _v0.a;
		var lignes = _v0.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('groupe')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$I18n$Cles$referentielTypeLimiteAutresOffres(i18n),
								categorie))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('offres-a-cocher')
						]),
					A2(
						$elm$core$List$map,
						A3($author$project$Components$Referentiel$Common$ChoixDesOffres$caseDOffre, i18n, messages, saisie),
						lignes))
				]));
	});
var $author$project$Components$Referentiel$Common$ChoixDesOffres$groupes = function (lignes) {
	var dedoublonner = function (liste) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (c, acc) {
					return A2($elm$core$List$member, c, acc) ? acc : A2($elm$core$List$cons, c, acc);
				}),
			_List_Nil,
			liste);
	};
	var categories = dedoublonner(
		$elm$core$List$sort(
			A2(
				$elm$core$List$filterMap,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.D1;
					},
					function ($) {
						return $.uK;
					}),
				lignes)));
	return _Utils_ap(
		A2(
			$elm$core$List$map,
			function (c) {
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(c),
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.D1;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.uK;
								},
								$elm$core$Basics$eq(
									$elm$core$Maybe$Just(c)))),
						lignes));
			},
			categories),
		function () {
			var _v0 = A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.D1;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.uK;
						},
						$elm$core$Basics$eq($elm$core$Maybe$Nothing))),
				lignes);
			if (!_v0.b) {
				return _List_Nil;
			} else {
				var autres = _v0;
				return _List_fromArray(
					[
						_Utils_Tuple2($elm$core$Maybe$Nothing, autres)
					]);
			}
		}());
};
var $author$project$I18n$Cles$referentielTypeLimiteAideArretee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.limite.aide-arretee', _List_Nil, 'Une offre arrêtée ne se choisit plus. Si elle est déjà dans la liste, elle y reste, marquée « arrêtée ».');
};
var $author$project$I18n$Cles$referentielTypeLimiteChercher = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.limite.chercher', _List_Nil, 'Chercher');
};
var $author$project$I18n$Cles$referentielTypeLimiteRecherche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.limite.recherche', _List_Nil, 'Nom de l\'offre');
};
var $author$project$Components$Referentiel$Common$ChoixDesOffres$contenu = F4(
	function (i18n, messages, saisie, choisies) {
		var lignes = A3($author$project$Components$Referentiel$Common$ChoixDesOffres$aChoisir, i18n, saisie, choisies);
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$fieldset,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('recherche')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$legend,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielTypeLimiteChercher(i18n))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$input,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('search'),
								$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(
								$author$project$I18n$Cles$referentielTypeLimiteRecherche(i18n)),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-label',
								$author$project$I18n$Cles$referentielTypeLimiteRecherche(i18n)),
								$rtfeldman$elm_css$Html$Styled$Attributes$value(saisie.hC),
								$rtfeldman$elm_css$Html$Styled$Events$onInput(messages.Je)
							]),
						_List_Nil)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(messages.bp)
					])),
				function () {
				var _v0 = saisie.D3;
				if (_v0.$ === 2) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielRoleOffreIndisponible(i18n))
							]));
				} else {
					return $elm$core$List$isEmpty(lignes) ? A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(messages.KN)
							])) : A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('groupes')
							]),
						A2(
							$elm$core$List$map,
							A3($author$project$Components$Referentiel$Common$ChoixDesOffres$groupe, i18n, messages, saisie),
							$author$project$Components$Referentiel$Common$ChoixDesOffres$groupes(lignes)));
				}
			}(),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$referentielTypeLimiteAideArretee(i18n))
					]))
			]);
	});
var $author$project$I18n$Cles$referentielTypeLimiteAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.limite.aide', _List_Nil, 'Offres de service de votre catalogue. Une offre déjà choisie est cochée et grisée.');
};
var $author$project$I18n$Cles$referentielTypeLimiteAjouter = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.type.limite.ajouter',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Ajouter ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' offre')) : ('Ajouter ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' offres')));
	});
var $author$project$I18n$Cles$referentielTypeLimiteAucuneOffre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.limite.aucune-offre', _List_Nil, 'Aucune offre de service n\'est proposée.');
};
var $author$project$I18n$Cles$referentielTypeLimiteDrawerKicker = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.type.limite.drawer.kicker',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Type · ' + p.Dj);
	});
var $author$project$I18n$Cles$referentielTypeLimiteDrawerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.type.limite.drawer.titre', _List_Nil, 'Choisir des offres');
};
var $author$project$Components$Referentiel$Type$View$tiroirDeLaLimite = F3(
	function (i18n, model, fiche) {
		var ouvert = $author$project$Components$Shared$Drawer$Model$estOuvert(model.nV);
		var nombre = $elm$core$List$length(model.at);
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$Type$Update$DeLaLimite,
			{
				fs: {
					sR: ouvert && ((nombre > 0) && (!$author$project$Components$Referentiel$Type$Model$enAttente(model))),
					Bl: ouvert ? A2(
						$author$project$I18n$Cles$referentielTypeLimiteAjouter,
						i18n,
						{w: nombre}) : '',
					C$: $author$project$Components$Referentiel$Type$Update$LimiteEnregistree
				},
				fZ: ouvert ? A2(
					$elm$core$List$cons,
					A2(
						$author$project$Components$Shared$Messages$View$view,
						i18n,
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2($elm$core$Maybe$map, $elm$core$List$singleton, model.p2))),
					A4(
						$author$project$Components$Referentiel$Common$ChoixDesOffres$contenu,
						i18n,
						{
							bp: $author$project$I18n$Cles$referentielTypeLimiteAide(i18n),
							Au: 'type-limite',
							qI: false,
							Jd: $author$project$Components$Referentiel$Type$Update$OffreCochee,
							Je: $author$project$Components$Referentiel$Type$Update$OffreRecherchee,
							KN: $author$project$I18n$Cles$referentielTypeLimiteAucuneOffre(i18n)
						},
						$author$project$Components$Referentiel$Type$Model$saisieDesOffres(model),
						fiche.D3)) : _List_Nil,
				A6: ouvert ? $elm$core$Maybe$Just(
					A2(
						$author$project$I18n$Cles$referentielTypeLimiteDrawerKicker,
						i18n,
						{Dj: fiche.r0.R.zX})) : $elm$core$Maybe$Nothing,
				Bc: false,
				h6: ouvert ? $author$project$I18n$Cles$referentielTypeLimiteDrawerTitre(i18n) : ''
			},
			model.nV);
	});
var $author$project$Components$Referentiel$Type$Update$RattachementDemande = {$: 34};
var $author$project$Components$Referentiel$Type$View$tiroirDuRattachement = F3(
	function (i18n, model, fiche) {
		var nom = fiche.r0.R.zX;
		var etat = model.GZ;
		return A5(
			$author$project$Components$Shared$Drawer$View$viewAvecPiedLibre,
			i18n,
			A5(
				$author$project$Components$Shared$Bibliotheque$View$piedDeLAjout,
				i18n,
				A2($author$project$Components$Referentiel$Type$View$messagesDuRattachement, model, fiche),
				1,
				false,
				etat.pN),
			$author$project$Components$Referentiel$Type$Update$DuDrawerRattacher,
			{
				fs: {
					sR: (!_Utils_eq(
						$author$project$Components$Referentiel$Type$Model$rattachement(fiche),
						$elm$core$Maybe$Nothing)) && ((!_Utils_eq(etat.pN.vd, $elm$core$Maybe$Nothing)) && ((!$author$project$Components$Shared$Bibliotheque$Rattachement$horsPortee(etat.pN)) && (!$author$project$Components$Referentiel$Common$EnvoiDeType$enCours(model.l2)))),
					Bl: A2(
						$author$project$I18n$Cles$produitsTypesAjoutRattacherValider,
						i18n,
						{Dp: nom}),
					C$: $author$project$Components$Referentiel$Type$Update$RattachementDemande
				},
				fZ: A4(
					$author$project$Components$Shared$Bibliotheque$View$entrees,
					i18n,
					A2($author$project$Components$Referentiel$Type$View$contexteDuRattachement, model, fiche),
					A2($author$project$Components$Referentiel$Type$View$messagesDuRattachement, model, fiche),
					{
						wZ: {zG: false, G1: false},
						kz: $elm$core$Maybe$Nothing,
						zT: _List_Nil,
						n9: etat.n9,
						hB: true,
						pN: etat.pN,
						JR: ''
					}),
				A6: $elm$core$Maybe$Nothing,
				Bc: true,
				h6: $author$project$I18n$Cles$editeurDeSchemaAjouterTitre(i18n)
			},
			model.lz);
	});
var $author$project$Components$Referentiel$Type$View$page = F5(
	function (i18n, onglet, messages, model, fiche) {
		var type_ = fiche.r0;
		var adresse = function (sous) {
			return $author$project$Routes$Route$toString(
				A2($author$project$Routes$Route$FicheTypeDePartiePrenante, type_.r8, sous));
		};
		return A2(
			$author$project$Components$Shared$Page$View$page,
			$author$project$Components$Referentiel$Type$View$nomDeLaPage,
			{
				ut: _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Messages$View$view,
						i18n,
						_Utils_ap(
							messages,
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2($elm$core$Maybe$map, $elm$core$List$singleton, model.pZ)))),
						A2($author$project$Components$Referentiel$Type$View$concurrence, i18n, model),
						A4($author$project$Components$Referentiel$Type$View$general, i18n, !(!onglet), model, fiche),
						A4($author$project$Components$Referentiel$Type$View$limite, i18n, !(!onglet), model, fiche),
						A4($author$project$Components$Referentiel$Type$View$listeDePrix, i18n, !(!onglet), model, fiche),
						A4($author$project$Components$Referentiel$Type$View$champs, i18n, onglet !== 1, model, fiche)
					]),
				xy: _Utils_ap(
					_List_fromArray(
						[
							A3($author$project$Components$Referentiel$Type$View$confirmation, i18n, model, fiche),
							A3($author$project$Components$Referentiel$Type$View$renommage, i18n, model, fiche),
							A3($author$project$Components$Referentiel$Type$View$tiroirDeLaLimite, i18n, model, fiche),
							A3($author$project$Components$Referentiel$Type$View$tiroirDuRattachement, i18n, model, fiche),
							A3($author$project$Components$Referentiel$Type$View$elargissement, i18n, model, fiche)
						]),
					A3($author$project$Components$Parametrage$NouveauChamp$View$dialogues, i18n, $author$project$Components$Referentiel$Type$Update$DuNouveauChamp, model.oP)),
				zM: A3($author$project$Components$Referentiel$Type$View$gestes, i18n, model, fiche),
				AK: $author$project$Components$Referentiel$Type$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _Utils_ap(
							_List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Apparence$pastille,
									i18n,
									{kf: type_.kf, aC: type_.aC}),
									A2(
									$author$project$Components$Shared$Tag$View$view,
									3,
									A2(
										$author$project$I18n$Cles$texte,
										i18n,
										$author$project$Components$Referentiel$Archetype$libelle(type_.fA)))
								]),
							_Utils_ap(
								type_.tE ? _List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Tag$View$view,
										3,
										$author$project$I18n$Cles$referentielTypesArchive(i18n))
									]) : _List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('resume')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2($author$project$Components$Referentiel$Common$ValeursDeType$resume, i18n, fiche))
											]))
									]))),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adresseTypesDePartiesPrenantes,
								Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
							},
								{
								aa: $author$project$Routes$Route$adresseTypesDePartiesPrenantes,
								Dj: $author$project$I18n$Cles$referentielTypesTitre(i18n)
							}
							]),
						Ef: _List_fromArray(
							[
								$author$project$Components$Shared$Onglets$View$view(
								_List_fromArray(
									[
										{
										sO: !onglet,
										aa: adresse(0),
										vW: $elm$core$Maybe$Nothing,
										Dj: $author$project$I18n$Cles$referentielTypeOngletGeneral(i18n)
									},
										{
										sO: onglet === 1,
										aa: adresse(1),
										vW: $elm$core$Maybe$Nothing,
										Dj: $author$project$I18n$Cles$referentielTypeOngletChamps(i18n)
									}
									]))
							]),
						h6: type_.R.zX
					})
			});
	});
var $author$project$Components$Referentiel$Type$View$view = F4(
	function (i18n, onglet, messages, model) {
		var _v0 = _Utils_Tuple2(model.nf, model.zo);
		if (_v0.a) {
			return A2(
				$author$project$Components$Shared$Introuvable$View$view,
				i18n,
				{
					aa: $author$project$Routes$Route$adresseTypesDePartiesPrenantes,
					Bl: $author$project$I18n$Cles$referentielTypesRetour(i18n)
				});
		} else {
			if (!_v0.b.$) {
				var fiche = _v0.b.a;
				return A5($author$project$Components$Referentiel$Type$View$page, i18n, onglet, messages, model, fiche);
			} else {
				var _v1 = _v0.b;
				return A2(
					$author$project$Components$Shared$Page$View$page,
					$author$project$Components$Referentiel$Type$View$nomDeLaPage,
					{
						ut: _List_fromArray(
							[
								A2($author$project$Components$Shared$Messages$View$view, i18n, messages)
							]),
						xy: _List_Nil,
						zM: _List_Nil,
						AK: false,
						JD: _List_Nil
					});
			}
		}
	});
var $author$project$Components$Referentiel$Common$FormulaireDeType$AChoisir = {$: 0};
var $author$project$Components$Referentiel$Types$Update$CreationDemandee = {$: 9};
var $author$project$Components$Referentiel$Common$FormulaireDeType$MotNom = 0;
var $author$project$Components$Referentiel$Types$Update$Saisi = function (a) {
	return {$: 8, a: a};
};
var $author$project$I18n$Cles$referentielTypesCreationAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.creation.action', _List_Nil, 'Créer');
};
var $author$project$I18n$Cles$referentielTypesCreationIntroduction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.creation.introduction', _List_Nil, 'Donnez-lui le nom que vous employez, puis le modèle dont il suit le fonctionnement.');
};
var $author$project$I18n$Cles$referentielTypesCreerUnType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.creer-un-type', _List_Nil, 'Créer un type');
};
var $author$project$I18n$Cles$referentielTypesEtapeUn = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.etape-un', _List_Nil, 'Étape 1');
};
var $author$project$I18n$Cles$referentielTypesIndication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.indication', _List_Nil, 'Par exemple : Distributeur');
};
var $author$project$Components$Referentiel$Types$View$creation = F2(
	function (i18n, model) {
		var contenu = _Utils_eq(
			$author$project$Components$Referentiel$Types$Model$creation(model),
			$elm$core$Maybe$Nothing) ? _List_Nil : A2(
			$elm$core$List$cons,
			A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('introduction')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$referentielTypesCreationIntroduction(i18n))
					])),
			A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Referentiel$Types$Update$Saisi),
				A3(
					$author$project$Components$Referentiel$Common$FormulaireDeType$view,
					i18n,
					{
						fA: $author$project$Components$Referentiel$Common$FormulaireDeType$AChoisir,
						jf: false,
						na: $elm$core$Maybe$Just(
							$author$project$I18n$Cles$referentielTypesIndication(i18n)),
						pv: $author$project$Components$Referentiel$Types$Model$prefixe(model),
						il: 0
					},
					model.hP)));
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$Types$Update$DuDrawer,
			{
				fs: {
					sR: (!$elm$core$List$isEmpty(contenu)) && (!$author$project$Components$Referentiel$Types$Model$enAttente(model)),
					Bl: $elm$core$List$isEmpty(contenu) ? '' : $author$project$I18n$Cles$referentielTypesCreationAction(i18n),
					C$: $author$project$Components$Referentiel$Types$Update$CreationDemandee
				},
				fZ: contenu,
				A6: $elm$core$List$isEmpty(contenu) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$I18n$Cles$referentielTypesEtapeUn(i18n)),
				Bc: false,
				h6: $elm$core$List$isEmpty(contenu) ? '' : $author$project$I18n$Cles$referentielTypesCreerUnType(i18n)
			},
			model.kX);
	});
var $author$project$Components$Referentiel$Types$Apercu$admises = F2(
	function (i18n, fiche) {
		var ligne = function (texte) {
			return {dX: false, eW: 1, Jx: texte};
		};
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Referentiel$Admission$libelleDeNature(i18n),
					ligne),
				A2(
					$elm$core$List$filter,
					function (nature) {
						return A2($elm$core$List$member, nature, fiche.oo);
					},
					$author$project$Components$Referentiel$Admission$natures)),
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Referentiel$Admission$libelleDeQualite(i18n),
					ligne),
				A2(
					$elm$core$List$filter,
					function (qualite) {
						return A2($elm$core$List$member, qualite, fiche.GG);
					},
					$author$project$Components$Referentiel$Admission$qualites)));
	});
var $author$project$I18n$Cles$referentielParcoursApercuCheminCloture = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.apercu.chemin.cloture', _List_Nil, 'Puis, à la clôture');
};
var $author$project$Components$Referentiel$Types$Chemin$resultatsAffiches = function (resultats) {
	return _Utils_ap(
		A2(
			$elm$core$List$filter,
			function (resultat) {
				return (!resultat.HZ) && (!resultat.rv);
			},
			resultats),
		_Utils_ap(
			A2(
				$elm$core$List$filter,
				function ($) {
					return $.rv;
				},
				resultats),
			A2(
				$elm$core$List$filter,
				function (resultat) {
					return resultat.HZ && (!resultat.rv);
				},
				resultats)));
};
var $author$project$Components$Referentiel$Types$Chemin$statutsAffiches = function (statuts) {
	return _Utils_ap(
		A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Basics$not,
				function ($) {
					return $.HZ;
				}),
			statuts),
		A2(
			$elm$core$List$filter,
			function ($) {
				return $.HZ;
			},
			statuts));
};
var $author$project$Components$Referentiel$Types$Apercu$chemin = F2(
	function (i18n, fiche) {
		var resultats = A2(
			$elm$core$List$map,
			$author$project$Components$Referentiel$Types$Chemin$libelleDuResultat(i18n),
			A2(
				$elm$core$List$filter,
				function (resultat) {
					return (!resultat.HZ) && (!resultat.rv);
				},
				$author$project$Components$Referentiel$Types$Chemin$resultatsAffiches(fiche.bh)));
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (statut) {
					return {dX: false, eW: 1, Jx: statut.R.zX};
				},
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$not,
						function ($) {
							return $.HZ;
						}),
					$author$project$Components$Referentiel$Types$Chemin$statutsAffiches(fiche.I1))),
			$elm$core$List$isEmpty(resultats) ? _List_Nil : _List_fromArray(
				[
					{
					dX: true,
					eW: 0,
					Jx: $author$project$I18n$Cles$referentielParcoursApercuCheminCloture(i18n)
				},
					{
					dX: false,
					eW: 1,
					Jx: A2($elm$core$String$join, ' · ', resultats)
				}
				]));
	});
var $author$project$I18n$Cles$referentielParcoursNombreDeTypesAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.nombre-de-types.aucun', _List_Nil, 'Aucun type');
};
var $author$project$I18n$Cles$referentielParcoursNombreDeTypesDeux = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.nombre-de-types.deux', _List_Nil, 'Deux types');
};
var $author$project$I18n$Cles$referentielParcoursNombreDeTypesHuit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.nombre-de-types.huit', _List_Nil, 'Huit types');
};
var $author$project$I18n$Cles$referentielParcoursNombreDeTypesPlusieurs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parcours.nombre-de-types.plusieurs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			p.w + ' types');
	});
var $author$project$I18n$Cles$referentielParcoursNombreDeTypesUn = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.nombre-de-types.un', _List_Nil, 'Un type');
};
var $author$project$Components$Referentiel$Types$Parcours$nombreDeTypes = F2(
	function (i18n, nombre) {
		switch (nombre) {
			case 0:
				return $author$project$I18n$Cles$referentielParcoursNombreDeTypesAucun(i18n);
			case 1:
				return $author$project$I18n$Cles$referentielParcoursNombreDeTypesUn(i18n);
			case 2:
				return $author$project$I18n$Cles$referentielParcoursNombreDeTypesDeux(i18n);
			case 8:
				return $author$project$I18n$Cles$referentielParcoursNombreDeTypesHuit(i18n);
			default:
				return A2(
					$author$project$I18n$Cles$referentielParcoursNombreDeTypesPlusieurs,
					i18n,
					{
						w: $elm$core$String$fromInt(nombre)
					});
		}
	});
var $author$project$I18n$Cles$referentielParcoursOffresApercuPerimetre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parcours.offres.apercu.perimetre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Périmètre « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$referentielParcoursOffresApercuPerimetreArchive = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parcours.offres.apercu.perimetre.archive',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Périmètre « ' + (p.Dj + ' » (archivé)'));
	});
var $author$project$I18n$Cles$referentielParcoursOffresApercuPerimetreVide = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parcours.offres.apercu.perimetre.vide',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Périmètre « ' + (p.Dj + ' » : 0 offre aujourd\'hui'));
	});
var $author$project$Components$Referentiel$Types$Apercu$perimetreDeLApercu = F2(
	function (i18n, lu) {
		var nom = A2($elm$core$Maybe$withDefault, lu.r8, lu.Dj);
		return lu.tE ? A2(
			$author$project$I18n$Cles$referentielParcoursOffresApercuPerimetreArchive,
			i18n,
			{Dj: nom}) : (_Utils_eq(
			lu.wT,
			$elm$core$Maybe$Just(0)) ? A2(
			$author$project$I18n$Cles$referentielParcoursOffresApercuPerimetreVide,
			i18n,
			{Dj: nom}) : A2(
			$author$project$I18n$Cles$referentielParcoursOffresApercuPerimetre,
			i18n,
			{Dj: nom}));
	});
var $author$project$I18n$Cles$referentielParcoursOffresApercuAucuneAChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.apercu.aucune-a-choisir', _List_Nil, 'Aucune offre à choisir');
};
var $author$project$I18n$Cles$referentielParcoursOffresApercuAucuneChoisie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.apercu.aucune-choisie', _List_Nil, 'Aucune offre choisie');
};
var $author$project$I18n$Cles$referentielParcoursOffresApercuChoisies = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parcours.offres.apercu.choisies',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? 'Une offre choisie' : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' offres choisies'));
	});
var $author$project$I18n$Cles$referentielParcoursOffresApercuSeulement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.apercu.seulement', _List_Nil, 'Seulement ces offres');
};
var $author$project$I18n$Cles$referentielParcoursOffresApercuToutes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.apercu.toutes', _List_Nil, 'Toutes les offres');
};
var $author$project$I18n$Cles$referentielParcoursOffresApercuSansOffreAdmis = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.apercu.sans-offre.admis', _List_Nil, 'Rôle sans offre : admis');
};
var $author$project$I18n$Cles$referentielParcoursOffresApercuSansOffreRefuse = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.apercu.sans-offre.refuse', _List_Nil, 'Rôle sans offre : refusé');
};
var $author$project$Components$Referentiel$Types$Apercu$sansOffre = F2(
	function (i18n, fiche) {
		return fiche.AR ? $author$project$I18n$Cles$referentielParcoursOffresApercuSansOffreRefuse(i18n) : $author$project$I18n$Cles$referentielParcoursOffresApercuSansOffreAdmis(i18n);
	});
var $author$project$Components$Referentiel$Types$Offres$seulement = F2(
	function (choisi, fiche) {
		return choisi || $author$project$Components$Referentiel$Types$Offres$limitee(fiche);
	});
var $author$project$Components$Referentiel$Types$Apercu$offres = F3(
	function (i18n, model, fiche) {
		var ligne = function (texte) {
			return {dX: false, eW: 1, Jx: texte};
		};
		var choisies = $elm$core$List$length(fiche.D3);
		return A2($author$project$Components$Referentiel$Types$Offres$seulement, model.e2, fiche) ? _Utils_ap(
			_List_fromArray(
				[
					ligne(
					$author$project$I18n$Cles$referentielParcoursOffresApercuSeulement(i18n))
				]),
			_Utils_ap(
				(choisies > 0) ? _List_fromArray(
					[
						ligne(
						A2(
							$author$project$I18n$Cles$referentielParcoursOffresApercuChoisies,
							i18n,
							{w: choisies}))
					]) : ((!_Utils_eq(fiche.E9, $elm$core$Maybe$Nothing)) ? _List_Nil : (_Utils_eq(
					model.D4,
					$author$project$Components$Referentiel$Common$Offres$Lue(_List_Nil)) ? _List_fromArray(
					[
						ligne(
						$author$project$I18n$Cles$referentielParcoursOffresApercuAucuneAChoisir(i18n))
					]) : _List_fromArray(
					[
						ligne(
						$author$project$I18n$Cles$referentielParcoursOffresApercuAucuneChoisie(i18n))
					]))),
				_Utils_ap(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Components$Referentiel$Types$Apercu$perimetreDeLApercu(i18n),
								A2($elm$core$Basics$composeR, ligne, $elm$core$List$singleton)),
							fiche.E9)),
					_List_fromArray(
						[
							ligne(
							A2($author$project$Components$Referentiel$Types$Apercu$sansOffre, i18n, fiche))
						])))) : _List_fromArray(
			[
				ligne(
				$author$project$I18n$Cles$referentielParcoursOffresApercuToutes(i18n)),
				ligne(
				A2($author$project$Components$Referentiel$Types$Apercu$sansOffre, i18n, fiche))
			]);
	});
var $author$project$Components$Referentiel$Types$Informations$personnelles = A2(
	$elm$core$Basics$composeR,
	$author$project$Components$Referentiel$Types$Informations$demandees,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$filter(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.uN;
				},
				function ($) {
					return $.xD;
				})),
		$elm$core$List$length));
var $author$project$I18n$Cles$referentielParcoursApercuChemin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.apercu.chemin', _List_Nil, 'Le chemin d’un fournisseur');
};
var $author$project$I18n$Cles$referentielParcoursApercuCheminType = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parcours.apercu.chemin.type',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Le chemin du rôle « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$referentielParcoursApercuInformations = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.apercu.informations', _List_Nil, 'Ce que la fiche demandera');
};
var $author$project$I18n$Cles$referentielParcoursApercuInformationsBloc = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parcours.apercu.informations.bloc',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Bloc « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$referentielParcoursApercuInformationsPersonnelles = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parcours.apercu.informations.personnelles',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('dont ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' donnée personnelle')) : ('dont ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' données personnelles')));
	});
var $author$project$I18n$Cles$referentielParcoursApercuPorteurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.apercu.porteurs', _List_Nil, 'Qui peut le porter');
};
var $author$project$I18n$Cles$referentielParcoursApercuVosTypes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parcours.apercu.vos-types',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'types',
					$author$project$I18n$Traductions$Chaine(p.ib)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			p.ib + (', dont « ' + (p.Dj + ' »')));
	});
var $author$project$I18n$Cles$referentielParcoursApercuVosTypesRienDeRegle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.apercu.vos-types.rien-de-regle', _List_Nil, 'Rien de réglé encore');
};
var $author$project$I18n$Cles$referentielParcoursOffresApercuTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.apercu.titre', _List_Nil, 'Les offres du rôle');
};
var $author$project$Components$Referentiel$Types$Apercu$de = F3(
	function (i18n, etape, model) {
		var _v0 = _Utils_Tuple2(etape, model.aS);
		_v0$5:
		while (true) {
			if (!_v0.b.$) {
				switch (_v0.a) {
					case 0:
						var _v1 = _v0.a;
						var nombre = $elm$core$List$length(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeL,
									$elm$core$Basics$not,
									function ($) {
										return $.tE;
									}),
								$author$project$Components$Referentiel$Types$Model$types(model)));
						var _v2 = $author$project$Components$Referentiel$Types$Model$typeRegle(model);
						if (!_v2.$) {
							var regle = _v2.a;
							return {
								gV: _List_fromArray(
									[
										{dX: true, eW: 0, Jx: regle.R.zX},
										{
										dX: false,
										eW: 1,
										Jx: $author$project$I18n$Cles$referentielParcoursApercuVosTypesRienDeRegle(i18n)
									}
									]),
								h6: $elm$core$Maybe$Just(
									(nombre >= 2) ? A2(
										$author$project$I18n$Cles$referentielParcoursApercuVosTypes,
										i18n,
										{
											Dj: regle.R.zX,
											ib: A2($author$project$Components$Referentiel$Types$Parcours$nombreDeTypes, i18n, nombre)
										}) : A2($author$project$Components$Referentiel$Types$Parcours$nombreDeTypes, i18n, nombre))
							};
						} else {
							return {
								gV: _List_Nil,
								h6: $elm$core$Maybe$Just(
									A2($author$project$Components$Referentiel$Types$Parcours$nombreDeTypes, i18n, nombre))
							};
						}
					case 1:
						var _v3 = _v0.a;
						var _v4 = $author$project$Components$Referentiel$Types$Model$typeRegle(model);
						if (!_v4.$) {
							var regle = _v4.a;
							return {
								gV: A2(
									$elm$core$List$cons,
									{dX: true, eW: 0, Jx: regle.R.zX},
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											$author$project$Components$Referentiel$Types$Apercu$admises(i18n),
											$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model)))),
								h6: $elm$core$Maybe$Just(
									$author$project$I18n$Cles$referentielParcoursApercuPorteurs(i18n))
							};
						} else {
							return {gV: _List_Nil, h6: $elm$core$Maybe$Nothing};
						}
					case 2:
						var _v5 = _v0.a;
						var _v6 = _Utils_Tuple2(
							$author$project$Components$Referentiel$Types$Model$typeRegle(model),
							$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model));
						if ((!_v6.a.$) && (!_v6.b.$)) {
							var regle = _v6.a.a;
							var fiche = _v6.b.a;
							return {
								gV: A2(
									$elm$core$List$cons,
									{dX: true, eW: 0, Jx: regle.R.zX},
									A3($author$project$Components$Referentiel$Types$Apercu$offres, i18n, model, fiche)),
								h6: $elm$core$Maybe$Just(
									$author$project$I18n$Cles$referentielParcoursOffresApercuTitre(i18n))
							};
						} else {
							return {gV: _List_Nil, h6: $elm$core$Maybe$Nothing};
						}
					case 3:
						var _v7 = _v0.a;
						var _v8 = $author$project$Components$Referentiel$Types$Model$typeRegle(model);
						if (!_v8.$) {
							var regle = _v8.a;
							return {
								gV: A2(
									$elm$core$List$cons,
									{dX: true, eW: 0, Jx: regle.R.zX},
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											$author$project$Components$Referentiel$Types$Apercu$chemin(i18n),
											$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model)))),
								h6: $elm$core$Maybe$Just(
									_Utils_eq(
										regle.R.zX,
										$author$project$I18n$Cles$referentielArchetypeFournisseur(i18n)) ? $author$project$I18n$Cles$referentielParcoursApercuChemin(i18n) : A2(
										$author$project$I18n$Cles$referentielParcoursApercuCheminType,
										i18n,
										{Dj: regle.R.zX}))
							};
						} else {
							return {gV: _List_Nil, h6: $elm$core$Maybe$Nothing};
						}
					case 4:
						var _v9 = _v0.a;
						var _v10 = _Utils_Tuple2(
							$author$project$Components$Referentiel$Types$Model$typeRegle(model),
							$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model));
						if ((!_v10.a.$) && (!_v10.b.$)) {
							var regle = _v10.a.a;
							var fiche = _v10.b.a;
							var personnelles = $author$project$Components$Referentiel$Types$Informations$personnelles(fiche);
							return {
								gV: A2(
									$elm$core$List$cons,
									{
										dX: true,
										eW: 0,
										Jx: A2(
											$author$project$I18n$Cles$referentielParcoursApercuInformationsBloc,
											i18n,
											{Dj: regle.R.zX})
									},
									_Utils_ap(
										A2(
											$elm$core$List$map,
											function (lu) {
												return {dX: false, eW: 1, Jx: lu.uN.Bl};
											},
											$author$project$Components$Referentiel$Types$Informations$demandees(fiche)),
										(personnelles > 0) ? _List_fromArray(
											[
												{
												dX: false,
												eW: 0,
												Jx: A2(
													$author$project$I18n$Cles$referentielParcoursApercuInformationsPersonnelles,
													i18n,
													{w: personnelles})
											}
											]) : _List_Nil)),
								h6: $elm$core$Maybe$Just(
									$author$project$I18n$Cles$referentielParcoursApercuInformations(i18n))
							};
						} else {
							return {gV: _List_Nil, h6: $elm$core$Maybe$Nothing};
						}
					default:
						break _v0$5;
				}
			} else {
				break _v0$5;
			}
		}
		return {gV: _List_Nil, h6: $elm$core$Maybe$Nothing};
	});
var $author$project$Components$Referentiel$Types$Update$CheminDemande = {$: 53};
var $author$project$I18n$Cles$referentielTypesAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.ajouter', _List_Nil, 'Ajouter');
};
var $author$project$Components$Referentiel$Types$CheminView$action = F2(
	function (i18n, saisie) {
		var _v0 = saisie.lQ;
		switch (_v0.$) {
			case 2:
				return $author$project$I18n$Cles$referentielTypesAjouter(i18n);
			case 3:
				return $author$project$I18n$Cles$referentielTypesAjouter(i18n);
			default:
				return $author$project$I18n$Cles$referentielTypeEnregistrer(i18n);
		}
	});
var $author$project$Components$Referentiel$Types$Update$CheminSaisi = function (a) {
	return {$: 52, a: a};
};
var $author$project$Components$Referentiel$Types$Chemin$Libelle = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$I18n$Cles$referentielCheminPerime = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.chemin.perime',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Ces changements ne peuvent plus être enregistrés pour « ' + (p.Dj + ' ».'));
	});
var $author$project$Components$Referentiel$Types$Chemin$Depart = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Types$Chemin$Position = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Types$CheminView$caseACocher = F3(
	function (idDeLaCase, libelle, saisie) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$fieldset,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('disabled', saisie.d4)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(idDeLaCase),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(saisie.vt),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(saisie.d4),
							$rtfeldman$elm_css$Html$Styled$Events$onCheck(saisie.D9)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$for(idDeLaCase)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						]))
				]));
	});
var $author$project$Components$Referentiel$Types$Chemin$departImpose = F2(
	function (fiche, saisie) {
		var _v0 = saisie.lQ;
		switch (_v0.$) {
			case 0:
				var id = _v0.a;
				return _Utils_eq(
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.Aq;
						},
						$author$project$Components$Referentiel$Types$Chemin$statutDeDepart(
							$author$project$Components$Referentiel$Types$Chemin$proposesDesStatuts(fiche))),
					$elm$core$Maybe$Just(id));
			case 2:
				return _Utils_eq(
					$author$project$Components$Referentiel$Types$Chemin$statutDeDepart(
						$author$project$Components$Referentiel$Types$Chemin$proposesDesStatuts(fiche)),
					$elm$core$Maybe$Nothing);
			default:
				return false;
		}
	});
var $author$project$Components$Referentiel$Types$Chemin$places = F2(
	function (fiche, saisie) {
		var _v0 = saisie.lQ;
		switch (_v0.$) {
			case 0:
				var id = _v0.a;
				return $elm$core$List$length(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$neq(id)),
						$author$project$Components$Referentiel$Types$Chemin$proposesDesStatuts(fiche))) + 1;
			case 1:
				var id = _v0.a;
				return $elm$core$List$length(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$neq(id)),
						$author$project$Components$Referentiel$Types$Chemin$proposesDesResultats(fiche))) + 1;
			case 2:
				return 0;
			default:
				return 0;
		}
	});
var $author$project$I18n$Cles$referentielCheminCaseDepart = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.chemin.case-depart', _List_Nil, 'Statut de départ');
};
var $author$project$I18n$Cles$referentielCheminPosition = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.chemin.position', _List_Nil, 'Position');
};
var $author$project$Components$Referentiel$Types$Chemin$Retire = function (a) {
	return {$: 3, a: a};
};
var $author$project$I18n$Cles$referentielCheminCaseRetire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.chemin.case-retire', _List_Nil, 'Ne plus le proposer');
};
var $author$project$I18n$Cles$referentielCheminRetireAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.chemin.retire-aide', _List_Nil, 'Les rôles qui le portent déjà le gardent.');
};
var $author$project$Components$Referentiel$Types$Chemin$retraitImpossible = F2(
	function (fiche, saisie) {
		var dernier = F2(
			function (id, proposes) {
				return _Utils_eq(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.Aq;
						},
						proposes),
					_List_fromArray(
						[id]));
			});
		return A2($author$project$Components$Referentiel$Types$Chemin$departImpose, fiche, saisie) || ((saisie.cx && (!saisie.HZ)) || function () {
			var _v0 = saisie.lQ;
			switch (_v0.$) {
				case 0:
					var id = _v0.a;
					return A2(
						dernier,
						id,
						$author$project$Components$Referentiel$Types$Chemin$proposesDesStatuts(fiche));
				case 1:
					var id = _v0.a;
					return A2(
						dernier,
						id,
						$author$project$Components$Referentiel$Types$Chemin$proposesDesResultats(fiche));
				default:
					return false;
			}
		}());
	});
var $author$project$Components$Referentiel$Types$CheminView$retrait = F4(
	function (i18n, fiche, saisie, prefixe) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('retrait')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Components$Referentiel$Types$CheminView$caseACocher,
					prefixe + '-retire',
					$author$project$I18n$Cles$referentielCheminCaseRetire(i18n),
					{
						vt: saisie.HZ,
						d4: A2($author$project$Components$Referentiel$Types$Chemin$retraitImpossible, fiche, saisie),
						D9: A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Types$Chemin$Retire, $author$project$Components$Referentiel$Types$Update$CheminSaisi)
					}),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$referentielCheminRetireAide(i18n))
						]))
				]));
	});
var $author$project$Components$Referentiel$Types$CheminView$reglages = F4(
	function (i18n, prefixe, saisie, fiche) {
		return _Utils_ap(
			((A2($author$project$Components$Referentiel$Types$Chemin$places, fiche, saisie) > 0) && (!saisie.HZ)) ? _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Champ$View$liste,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: prefixe + '-position',
						Bl: $author$project$I18n$Cles$referentielCheminPosition(i18n),
						he: false
					},
					{
						hg: A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Types$Chemin$Position, $author$project$Components$Referentiel$Types$Update$CheminSaisi),
						o_: A2(
							$elm$core$List$map,
							function (rang) {
								return {
									Bl: $elm$core$String$fromInt(rang + 1),
									fm: $elm$core$String$fromInt(rang)
								};
							},
							A2(
								$elm$core$List$range,
								0,
								A2($author$project$Components$Referentiel$Types$Chemin$places, fiche, saisie) - 1)),
						fm: $elm$core$String$fromInt(saisie.bc)
					})
				]) : _List_Nil,
			_Utils_ap(
				$author$project$Components$Referentiel$Types$Chemin$estUnStatut(saisie.lQ) ? _List_fromArray(
					[
						A3(
						$author$project$Components$Referentiel$Types$CheminView$caseACocher,
						prefixe + '-depart',
						$author$project$I18n$Cles$referentielCheminCaseDepart(i18n),
						{
							vt: saisie.cx || A2($author$project$Components$Referentiel$Types$Chemin$departImpose, fiche, saisie),
							d4: A2($author$project$Components$Referentiel$Types$Chemin$departImpose, fiche, saisie) || saisie.HZ,
							D9: A2($elm$core$Basics$composeR, $author$project$Components$Referentiel$Types$Chemin$Depart, $author$project$Components$Referentiel$Types$Update$CheminSaisi)
						})
					]) : _List_Nil,
				function () {
					var _v0 = saisie.lQ;
					switch (_v0.$) {
						case 0:
							return _List_fromArray(
								[
									A4($author$project$Components$Referentiel$Types$CheminView$retrait, i18n, fiche, saisie, prefixe)
								]);
						case 1:
							return _List_fromArray(
								[
									A4($author$project$Components$Referentiel$Types$CheminView$retrait, i18n, fiche, saisie, prefixe)
								]);
						default:
							return _List_Nil;
					}
				}()));
	});
var $author$project$Components$Referentiel$Types$CheminView$contenu = F3(
	function (i18n, model, saisie) {
		var prefixe = $author$project$Components$Referentiel$Types$Model$prefixeDuChemin(model);
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Messages$View$view,
					i18n,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Maybe$map, $elm$core$List$singleton, saisie.pZ))),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('concurrence')
						]),
					saisie.fW ? _List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Note$View$view,
							1,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$referentielTypeConcurrente(i18n))
										]))
								]))
						]) : _List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('perime')
						]),
					function () {
						var _v0 = _Utils_Tuple2(
							$author$project$Components$Referentiel$Types$Model$cheminPerime(model),
							model.u8);
						if (_v0.a && (!_v0.b.$)) {
							var lie = _v0.b.a;
							return _List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Note$View$view,
									1,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$author$project$I18n$Cles$referentielCheminPerime,
														i18n,
														{Dj: lie.Bl}))
												]))
										]))
								]);
						} else {
							return _List_Nil;
						}
					}()),
					A3(
					$author$project$Components$Shared$LibellesParLangue$View$view,
					i18n,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('libelles')
						]),
					{
						go: function (code) {
							return _Utils_eq(
								$author$project$Components$Referentiel$Types$Chemin$libelleManquant(saisie),
								$elm$core$Maybe$Just(code)) ? $elm$core$Maybe$Just(
								$author$project$I18n$Cles$referentielTypesChampLibelleObligatoire(i18n)) : $elm$core$Maybe$Nothing;
						},
						Ba: $author$project$Referentiel$Langues$desLibelles,
						Bl: $author$project$I18n$Cles$referentielTypesChampLibelle(i18n),
						hg: F2(
							function (code, texte) {
								return $author$project$Components$Referentiel$Types$Update$CheminSaisi(
									A2($author$project$Components$Referentiel$Types$Chemin$Libelle, code, texte));
							}),
						pv: prefixe + '-libelle',
						fm: function (code) {
							return A2($author$project$Components$Shared$LibellesParLangue$Model$lire, code, saisie.R);
						}
					})
				]),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A3($author$project$Components$Referentiel$Types$CheminView$reglages, i18n, prefixe, saisie),
					$author$project$Components$Referentiel$Types$Model$ficheDuChemin(model))));
	});
var $author$project$I18n$Cles$referentielCheminAjouterResultat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.chemin.ajouter-resultat', _List_Nil, 'Ajouter un résultat');
};
var $author$project$I18n$Cles$referentielCheminAjouterStatut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.chemin.ajouter-statut', _List_Nil, 'Ajouter un statut');
};
var $author$project$I18n$Cles$referentielCheminTitreResultat = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.chemin.titre-resultat',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Le résultat « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$referentielCheminTitreStatut = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.chemin.titre-statut',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Le statut « ' + (p.Dj + ' »'));
	});
var $author$project$Components$Referentiel$Types$CheminView$titre = F2(
	function (i18n, saisie) {
		var _v0 = saisie.lQ;
		switch (_v0.$) {
			case 2:
				return $author$project$I18n$Cles$referentielCheminAjouterStatut(i18n);
			case 3:
				return $author$project$I18n$Cles$referentielCheminAjouterResultat(i18n);
			case 0:
				return A2(
					$author$project$I18n$Cles$referentielCheminTitreStatut,
					i18n,
					{Dj: saisie.Dj});
			default:
				return A2(
					$author$project$I18n$Cles$referentielCheminTitreResultat,
					i18n,
					{Dj: saisie.Dj});
		}
	});
var $author$project$Components$Referentiel$Types$CheminView$drawer = F2(
	function (i18n, model) {
		var ouvert = $author$project$Components$Shared$Drawer$Model$estOuvert(model.jK);
		var enCours = ouvert ? model.ge : $elm$core$Maybe$Nothing;
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$Types$Update$DuChemin,
			{
				fs: {
					sR: (!_Utils_eq(enCours, $elm$core$Maybe$Nothing)) && ((!$author$project$Components$Referentiel$Types$Model$cheminPerime(model)) && (!$author$project$Components$Referentiel$Types$Model$enAttente(model))),
					Bl: A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							$author$project$Components$Referentiel$Types$CheminView$action(i18n),
							enCours)),
					C$: $author$project$Components$Referentiel$Types$Update$CheminDemande
				},
				fZ: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2($author$project$Components$Referentiel$Types$CheminView$contenu, i18n, model),
						enCours)),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						$author$project$Components$Referentiel$Types$CheminView$titre(i18n),
						enCours))
			},
			model.jK);
	});
var $author$project$Components$Shared$EditeurDeSchema$Resserrage$DesPartiesPrenantes = 1;
var $author$project$Components$Referentiel$Types$Update$InformationDemandee = {$: 61};
var $author$project$Components$Referentiel$Types$Update$InformationSaisie = function (a) {
	return {$: 60, a: a};
};
var $author$project$Components$Referentiel$Types$InformationsView$contexteDeLAjout = F2(
	function (model, fiche) {
		return {
			sZ: $author$project$Routes$Route$adresseBibliothequeDeChamps,
			cC: 1,
			Dp: fiche.r0.R.zX,
			pv: $author$project$Components$Shared$Drawer$Model$idRacine(model.AM.kX)
		};
	});
var $author$project$Components$Referentiel$Types$Update$ElargirLaListeDemandee = function (a) {
	return {$: 99, a: a};
};
var $author$project$I18n$Cles$bibliothequeListeElargirHorsPortee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.liste.elargir.hors-portee', _List_Nil, 'Cette liste n\'est pas proposée aux types de partie prenante : sa portée ne les couvre pas. Élargissez sa portée, puis enregistrez de nouveau.');
};
var $author$project$I18n$Cles$bibliothequeListeElargirOuvrir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.liste.elargir.ouvrir', _List_Nil, 'Élargir la portée de la liste');
};
var $author$project$Components$Referentiel$Types$InformationsView$idDuDeclencheurDeLElargissementDeLaListe = 'referentiel-type-liste-elargir-ouvrir';
var $author$project$Components$Referentiel$Types$InformationsView$elargirLaListe = F2(
	function (i18n, etat) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('liste-hors-portee')
				]),
			function () {
				var _v0 = etat.gf;
				if (!_v0.$) {
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$bibliothequeListeElargirHorsPortee(i18n))
								])),
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Types$InformationsView$idDuDeclencheurDeLElargissementDeLaListe),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Referentiel$Types$Update$ElargirLaListeDemandee($author$project$Components$Referentiel$Types$InformationsView$idDuDeclencheurDeLElargissementDeLaListe))
								]),
							$author$project$I18n$Cles$bibliothequeListeElargirOuvrir(i18n))
						]);
				} else {
					return _List_Nil;
				}
			}());
	});
var $author$project$Components$Referentiel$Types$Update$AutreNomAChoisir = {$: 98};
var $author$project$Components$Referentiel$Types$Update$FiltrableCoche = function (a) {
	return {$: 96, a: a};
};
var $author$project$Components$Referentiel$Types$Update$RecherchableCoche = function (a) {
	return {$: 97, a: a};
};
var $author$project$Components$Referentiel$Types$InformationsView$messagesDeLAjout = A2(
	$author$project$Components$Referentiel$Common$RattacherUnChamp$messages,
	$author$project$Components$Referentiel$Types$Update$DuRattachement,
	{t4: $author$project$Components$Referentiel$Types$Update$AutreNomAChoisir, xU: $author$project$Components$Referentiel$Types$Update$DesInformations, zG: $author$project$Components$Referentiel$Types$Update$FiltrableCoche, G1: $author$project$Components$Referentiel$Types$Update$RecherchableCoche});
var $author$project$I18n$Cles$referentielInformationsAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.informations.ajouter', _List_Nil, 'Ajouter une information');
};
var $author$project$I18n$Cles$referentielInformationsValider = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.informations.valider', _List_Nil, 'Ajouter');
};
var $author$project$I18n$Cles$referentielInformationsAvertissement = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.informations.avertissement',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? 'La fiche existante n\'a pas de valeur ; elle sera demandée à sa prochaine modification.' : ('Les ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiches existantes n\'ont pas de valeur ; elles seront demandées à leur prochaine modification.')));
	});
var $author$project$Components$Referentiel$Types$Informations$ressource = F2(
	function (i18n, fiche) {
		return {
			uj: function (code) {
				return (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$exigenceALEnregistrement) && (fiche.r0.Id > 0)) ? $elm$core$Maybe$Just(
					A2(
						$author$project$I18n$Cles$referentielInformationsAvertissement,
						i18n,
						{w: fiche.r0.Id})) : $elm$core$Maybe$Nothing;
			},
			mo: $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$choixDExigence(i18n),
			Ej: A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.x5;
						},
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.xD;
							},
							function ($) {
								return $.sY;
							})),
					fiche.aN)) ? _List_fromArray(
				[
					{
					vs: true,
					vx: $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$optionDonneePersonnelle,
					Bl: $author$project$I18n$Cles$editeurDeSchemaOptionDonneePersonnelle(i18n)
				}
				]) : _List_Nil
		};
	});
var $author$project$Components$Referentiel$Types$InformationsView$drawer = F2(
	function (i18n, model) {
		var etat = model.AM;
		var ouverte = $author$project$Components$Shared$Drawer$Model$estOuvert(etat.kX) ? A2(
			$elm$core$Maybe$andThen,
			function (fiche) {
				return A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(fiche),
					fiche.aN);
			},
			$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model)) : $elm$core$Maybe$Nothing;
		var avecLaBibliotheque = function () {
			if (!ouverte.$) {
				var _v4 = ouverte.a;
				var fiche = _v4.a;
				return _Utils_eq(etat.hP.lZ, $elm$core$Maybe$Nothing) && ((!_Utils_eq(
					$author$project$Components$Referentiel$Types$Model$lienDeCreationDUnChamp(fiche),
					$elm$core$Maybe$Nothing)) || (!_Utils_eq(
					$author$project$Components$Referentiel$Types$Model$lienDeRattachementDUnChamp(fiche),
					$elm$core$Maybe$Nothing)));
			} else {
				return false;
			}
		}();
		var affiche = avecLaBibliotheque ? A2(
			$author$project$Components$Shared$Drawer$View$viewAvecPiedLibre,
			i18n,
			A5($author$project$Components$Shared$Bibliotheque$View$piedDeLAjout, i18n, $author$project$Components$Referentiel$Types$InformationsView$messagesDeLAjout, etat.GZ.n9, false, etat.GZ.pN)) : A2(
			$author$project$Components$Shared$Drawer$View$viewAvecRenoncement,
			i18n,
			$author$project$I18n$Cles$drawerAnnuler(i18n));
		return A3(
			affiche,
			$author$project$Components$Referentiel$Types$Update$DesInformations,
			function () {
				if (!ouverte.$) {
					var _v1 = ouverte.a;
					var fiche = _v1.a;
					var schema = _v1.b;
					var rattache = (etat.GZ.n9 === 1) && avecLaBibliotheque;
					var presentation = {
						t8: A2(
							$elm$core$List$map,
							function (lu) {
								return {dy: lu.uN.dy, Bl: lu.uN.Bl};
							},
							schema.dw),
						n_: etat.n_,
						pv: $author$project$Components$Shared$Drawer$Model$idRacine(etat.kX),
						Gw: schema.x5,
						HN: A2($author$project$Components$Referentiel$Types$Informations$ressource, i18n, fiche),
						ib: _List_Nil
					};
					var avertissement = A4(
						$author$project$Components$Shared$EditeurDeSchema$Resserrage$avertissement,
						i18n,
						1,
						$author$project$Components$Shared$Drawer$Model$idRacine(etat.kX),
						etat.tq);
					return {
						fs: {
							sR: (!_Utils_eq(
								$author$project$Components$Referentiel$Types$Model$ficheDesInformations(model),
								$elm$core$Maybe$Nothing)) && ((!$author$project$Components$Referentiel$Common$EnvoiDeType$enCours(model.l2)) && ((!$author$project$Components$Referentiel$Types$Model$enAttente(model)) && ((!rattache) || ((!_Utils_eq(etat.GZ.pN.vd, $elm$core$Maybe$Nothing)) && (!$author$project$Components$Shared$Bibliotheque$Rattachement$horsPortee(etat.GZ.pN)))))),
							Bl: function () {
								var _v2 = etat.tq;
								if (_v2.$ === 2) {
									return $author$project$I18n$Cles$produitsTypesResserrageEnregistrerQuandMeme(i18n);
								} else {
									return rattache ? A2(
										$author$project$I18n$Cles$produitsTypesAjoutRattacherValider,
										i18n,
										{Dp: fiche.r0.R.zX}) : ((!_Utils_eq(etat.hP.lZ, $elm$core$Maybe$Nothing)) ? $author$project$I18n$Cles$editeurDeSchemaModifierValider(i18n) : $author$project$I18n$Cles$referentielInformationsValider(i18n));
								}
							}(),
							C$: $author$project$Components$Referentiel$Types$Update$InformationDemandee
						},
						fZ: _Utils_ap(
							avecLaBibliotheque ? A4(
								$author$project$Components$Shared$Bibliotheque$View$entrees,
								i18n,
								A2($author$project$Components$Referentiel$Types$InformationsView$contexteDeLAjout, model, fiche),
								$author$project$Components$Referentiel$Types$InformationsView$messagesDeLAjout,
								{
									wZ: etat.wZ,
									kz: etat.GZ.kz,
									zT: _Utils_ap(
										A2(
											$elm$core$List$map,
											$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Referentiel$Types$Update$InformationSaisie),
											A3($author$project$Components$Shared$EditeurDeSchema$View$formulaireDeCreation, i18n, presentation, etat.hP)),
										_List_fromArray(
											[avertissement])),
									n9: etat.GZ.n9,
									hB: !_Utils_eq(
										$author$project$Components$Referentiel$Types$Model$lienDeRattachementDUnChamp(fiche),
										$elm$core$Maybe$Nothing),
									pN: etat.GZ.pN,
									JR: etat.hP.zT.JR
								}) : function (formulaire) {
								return _Utils_ap(
									formulaire,
									_List_fromArray(
										[avertissement]));
							}(
								A2(
									$elm$core$List$map,
									$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Referentiel$Types$Update$InformationSaisie),
									A3($author$project$Components$Shared$EditeurDeSchema$View$formulaire, i18n, presentation, etat.hP))),
							_List_fromArray(
								[
									A2($author$project$Components$Referentiel$Types$InformationsView$elargirLaListe, i18n, etat)
								])),
						A6: $elm$core$Maybe$Nothing,
						Bc: true,
						h6: (!_Utils_eq(etat.hP.lZ, $elm$core$Maybe$Nothing)) ? $author$project$I18n$Cles$editeurDeSchemaModifierTitre(i18n) : $author$project$I18n$Cles$referentielInformationsAjouter(i18n)
					};
				} else {
					return {
						fs: {sR: false, Bl: '', C$: $author$project$Components$Referentiel$Types$Update$InformationDemandee},
						fZ: _List_Nil,
						A6: $elm$core$Maybe$Nothing,
						Bc: false,
						h6: ''
					};
				}
			}(),
			etat.kX);
	});
var $author$project$Components$Referentiel$Types$Update$OffreCochee = F2(
	function (a, b) {
		return {$: 38, a: a, b: b};
	});
var $author$project$Components$Referentiel$Types$Update$OffreRecherchee = function (a) {
	return {$: 39, a: a};
};
var $author$project$Components$Referentiel$Types$Update$OffresCocheesEnregistrees = {$: 40};
var $author$project$I18n$Cles$referentielParcoursOffresCatalogueOuvrir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.catalogue-ouvrir', _List_Nil, 'Ouvrir le catalogue');
};
var $author$project$I18n$Cles$referentielParcoursOffresCatalogueVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.catalogue-vide', _List_Nil, 'Aucune offre de service n\'est proposée : le catalogue de votre espace n\'en contient pas encore.');
};
var $author$project$I18n$Cles$referentielParcoursOffresCatalogueVideTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.catalogue-vide.titre', _List_Nil, 'Aucune offre de service');
};
var $author$project$I18n$Cles$referentielParcoursOffresDrawerAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.drawer.aide', _List_Nil, 'Offres de service de votre catalogue. Une offre déjà choisie est cochée.');
};
var $author$project$I18n$Cles$referentielParcoursOffresDrawerDecocher = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.drawer.decocher', _List_Nil, 'Décochez une offre pour la retirer');
};
var $author$project$I18n$Cles$referentielParcoursOffresDrawerEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.drawer.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$Components$Referentiel$Types$OffresView$drawer = F2(
	function (i18n, model) {
		var saisie = $author$project$Components$Referentiel$Types$Offres$saisie(model);
		var ouvert = $author$project$Components$Shared$Drawer$Model$estOuvert(model.jQ);
		var fiche = $author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model);
		var choisies = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.D3;
				},
				fiche));
		return (ouvert && _Utils_eq(
			model.D4,
			$author$project$Components$Referentiel$Common$Offres$Lue(_List_Nil))) ? A4(
			$author$project$Components$Shared$Drawer$View$consultationAnnulable,
			i18n,
			$author$project$Components$Referentiel$Types$Update$DuChoixDesOffres,
			{
				fZ: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide-catalogue')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$h3,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielParcoursOffresCatalogueVideTitre(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielParcoursOffresCatalogueVide(i18n))
									])),
								A3(
								$author$project$Components$Shared$Bouton$View$lien,
								0,
								$author$project$Routes$Route$adresseCatalogue,
								$author$project$I18n$Cles$referentielParcoursOffresCatalogueOuvrir(i18n))
							]))
					]),
				G8: false,
				aO: A2(
					$elm$core$Maybe$map,
					function (f) {
						return A2(
							$author$project$I18n$Cles$referentielTypeLimiteDrawerKicker,
							i18n,
							{Dj: f.r0.R.zX});
					},
					fiche),
				h6: $author$project$I18n$Cles$referentielTypeLimiteDrawerTitre(i18n)
			},
			model.jQ) : A6(
			$author$project$Components$Shared$Drawer$View$viewAvecSousTitreEtNote,
			i18n,
			ouvert ? A2(
				$elm$core$Maybe$map,
				function (f) {
					return A2(
						$author$project$I18n$Cles$referentielTypeLimiteDrawerKicker,
						i18n,
						{Dj: f.r0.R.zX});
				},
				fiche) : $elm$core$Maybe$Nothing,
			ouvert ? $elm$core$Maybe$Just(
				$author$project$I18n$Cles$referentielParcoursOffresDrawerDecocher(i18n)) : $elm$core$Maybe$Nothing,
			$author$project$Components$Referentiel$Types$Update$DuChoixDesOffres,
			{
				fs: {
					sR: ouvert && (!$author$project$Components$Referentiel$Types$Model$enAttente(model)),
					Bl: ouvert ? $author$project$I18n$Cles$referentielParcoursOffresDrawerEnregistrer(i18n) : '',
					C$: $author$project$Components$Referentiel$Types$Update$OffresCocheesEnregistrees
				},
				fZ: ouvert ? A2(
					$elm$core$List$cons,
					A2(
						$author$project$Components$Shared$Messages$View$view,
						i18n,
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2($elm$core$Maybe$map, $elm$core$List$singleton, model.p5))),
					A4(
						$author$project$Components$Referentiel$Common$ChoixDesOffres$contenu,
						i18n,
						{
							bp: $author$project$I18n$Cles$referentielParcoursOffresDrawerAide(i18n),
							Au: 'types-offres',
							qI: true,
							Jd: $author$project$Components$Referentiel$Types$Update$OffreCochee,
							Je: $author$project$Components$Referentiel$Types$Update$OffreRecherchee,
							KN: $author$project$I18n$Cles$referentielParcoursOffresCatalogueVide(i18n)
						},
						saisie,
						choisies)) : _List_Nil,
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: ouvert ? $author$project$I18n$Cles$referentielTypeLimiteDrawerTitre(i18n) : ''
			},
			model.jQ);
	});
var $author$project$Components$Referentiel$Types$Update$InformationEnregistree = {$: 72};
var $author$project$Components$Referentiel$Types$Update$LibelleDeLInformation = F2(
	function (a, b) {
		return {$: 69, a: a, b: b};
	});
var $author$project$Components$Referentiel$Types$Update$MasquageDeLInformation = {$: 73};
var $author$project$Components$Referentiel$Types$Update$ObligationCochee = function (a) {
	return {$: 70, a: a};
};
var $author$project$Components$Referentiel$Types$Update$PersonnelleCochee = function (a) {
	return {$: 71, a: a};
};
var $author$project$Components$Referentiel$Types$Update$ReglagesDuChampOuverts = function (a) {
	return {$: 78, a: a};
};
var $author$project$Components$Referentiel$Types$Update$RenommageDeLInformation = {$: 68};
var $author$project$Components$Referentiel$Types$InformationsView$case_ = F5(
	function (identifiant, libelle, coche, inactive, versMsg) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('case'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('disabled', inactive)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(identifiant),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(coche),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactive),
							$rtfeldman$elm_css$Html$Styled$Events$onCheck(versMsg)
						]),
					_List_Nil),
					$rtfeldman$elm_css$Html$Styled$text(libelle)
				]));
	});
var $author$project$I18n$Cles$referentielInformationsNatureChoixMultiple = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.informations.nature.choix-multiple', _List_Nil, 'Choix multiple');
};
var $author$project$Components$Referentiel$Types$Informations$nature = F2(
	function (i18n, lu) {
		var _v0 = lu.JR;
		if (!_v0.$) {
			var code = _v0.a;
			return _Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeChoixMultiples) ? $author$project$I18n$Cles$referentielInformationsNatureChoixMultiple(i18n) : A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeCourt, i18n, code);
		} else {
			return $author$project$I18n$Cles$editeurDeSchemaTypeInconnu(i18n);
		}
	});
var $author$project$Components$Referentiel$Types$InformationsView$definitionPartagee = F3(
	function (i18n, lu, partage) {
		var ligne = F2(
			function (libelle, contenu) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$dt,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(libelle)
								])),
							A2($rtfeldman$elm_css$Html$Styled$dd, _List_Nil, contenu)
						]));
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('definition-partagee')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('titre-de-groupe')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('overline')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$editeurDeSchemaPartageDefinition(i18n))
								])),
							A2(
							$author$project$Components$Shared$Tag$View$view,
							3,
							$author$project$I18n$Cles$editeurDeSchemaPartageLectureSeule(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$dl,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('definition-lue')
						]),
					_List_fromArray(
						[
							A2(
							ligne,
							$author$project$I18n$Cles$editeurDeSchemaChampNomCourt(i18n),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(lu.uN.Bl)
								])),
							A2(
							ligne,
							$author$project$I18n$Cles$editeurDeSchemaChampType(i18n),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Referentiel$Types$Informations$nature, i18n, lu))
								])),
							A2(
							ligne,
							$author$project$I18n$Cles$editeurDeSchemaChampCle(i18n),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$code,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(lu.uN.dy)
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('partage')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Components$Shared$Tag$View$view,
							5,
							A2(
								$author$project$I18n$Cles$editeurDeSchemaPartageUtilisePar,
								i18n,
								{w: partage.sf})),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (_v0) {
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
													$rtfeldman$elm_css$Html$Styled$Attributes$href(
													$author$project$Routes$Route$adresseDuChampDeLaBibliotheque(partage.Aq))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$editeurDeSchemaPartageModifierDansLaBibliotheque(i18n))
												]))
										]);
								},
								A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$modifierDansLaBibliotheque, partage.nQ))))),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$editeurDeSchemaPartageNote,
								i18n,
								{w: partage.sf}))
						]))
				]));
	});
var $author$project$Components$Referentiel$Types$Update$OrdreDesInformations = function (a) {
	return {$: 75, a: a};
};
var $author$project$I18n$Cles$referentielInformationsFacultatif = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.informations.facultatif', _List_Nil, 'facultatif');
};
var $author$project$I18n$Cles$referentielInformationsObligatoire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.informations.obligatoire', _List_Nil, 'obligatoire');
};
var $author$project$Components$Referentiel$Types$Informations$exigence = F2(
	function (i18n, champ) {
		return champ.he ? $author$project$I18n$Cles$referentielInformationsObligatoire(i18n) : $author$project$I18n$Cles$referentielInformationsFacultatif(i18n);
	});
var $author$project$I18n$Cles$referentielInformationOrdreDescendre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.information.ordre.descendre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Descendre ' + p.Dj);
	});
var $author$project$I18n$Cles$referentielInformationOrdreMonter = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.information.ordre.monter',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Monter ' + p.Dj);
	});
var $author$project$I18n$Cles$referentielInformationsLigne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.informations.ligne',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nature',
					$author$project$I18n$Traductions$Chaine(p.g1)),
					_Utils_Tuple2(
					'exigence',
					$author$project$I18n$Traductions$Chaine(p.mo))
				]),
			p.g1 + (' · ' + p.mo));
	});
var $author$project$Components$Referentiel$Types$InformationsView$ligneDOrdre = F6(
	function (i18n, model, ouverte, total, rang, lu) {
		var ordonnable = (!_Utils_eq(
			$author$project$Components$Referentiel$Types$Model$lienDOrdre(model),
			$elm$core$Maybe$Nothing)) && (!$author$project$Components$Referentiel$Types$Model$enAttente(model));
		var cle = lu.uN.dy;
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('element'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'ouverte',
							_Utils_eq(cle, ouverte)),
							_Utils_Tuple2(
							'glisse',
							_Utils_eq(
								model.AM.m_,
								$elm$core$Maybe$Just(cle)))
						])),
					$rtfeldman$elm_css$Html$Styled$Attributes$draggable(
					ordonnable ? 'true' : 'false'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Events$on,
					'dragstart',
					$elm$json$Json$Decode$succeed(
						$author$project$Components$Referentiel$Types$Update$OrdreDesInformations(
							$author$project$Components$Shared$EditeurDeSchema$View$GlisserCommence(cle)))),
					A2(
					$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
					'dragover',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2(
							$author$project$Components$Referentiel$Types$Update$OrdreDesInformations($author$project$Components$Shared$EditeurDeSchema$View$GlisserSurvole),
							true))),
					A2(
					$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
					'drop',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2(
							$author$project$Components$Referentiel$Types$Update$OrdreDesInformations(
								$author$project$Components$Shared$EditeurDeSchema$View$Depose(cle)),
							true))),
					A2(
					$rtfeldman$elm_css$Html$Styled$Events$on,
					'dragend',
					$elm$json$Json$Decode$succeed(
						$author$project$Components$Referentiel$Types$Update$OrdreDesInformations($author$project$Components$Shared$EditeurDeSchema$View$GlisserFini)))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('poignee'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('⠿')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('fleches')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$OrdreView$boutonDOrdre,
							0,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									A2(
										$author$project$I18n$Cles$referentielInformationOrdreMonter,
										i18n,
										{Dj: lu.uN.Bl})),
									$rtfeldman$elm_css$Html$Styled$Attributes$title(
									A2(
										$author$project$I18n$Cles$referentielInformationOrdreMonter,
										i18n,
										{Dj: lu.uN.Bl})),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled((!ordonnable) || (!rang)),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Referentiel$Types$Update$OrdreDesInformations(
										$author$project$Components$Shared$EditeurDeSchema$View$Monte(cle)))
								])),
							A2(
							$author$project$Components$Shared$OrdreView$boutonDOrdre,
							1,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									A2(
										$author$project$I18n$Cles$referentielInformationOrdreDescendre,
										i18n,
										{Dj: lu.uN.Bl})),
									$rtfeldman$elm_css$Html$Styled$Attributes$title(
									A2(
										$author$project$I18n$Cles$referentielInformationOrdreDescendre,
										i18n,
										{Dj: lu.uN.Bl})),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
									(!ordonnable) || _Utils_eq(rang, total - 1)),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Referentiel$Types$Update$OrdreDesInformations(
										$author$project$Components$Shared$EditeurDeSchema$View$Descendu(cle)))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(lu.uN.Bl)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nature')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$referentielInformationsLigne,
										i18n,
										{
											mo: A2($author$project$Components$Referentiel$Types$Informations$exigence, i18n, lu.uN),
											g1: A2($author$project$Components$Referentiel$Types$Informations$nature, i18n, lu)
										}))
								]))
						]))
				]));
	});
var $author$project$Components$Referentiel$Types$Update$DefinitionDemandee = function (a) {
	return {$: 64, a: a};
};
var $author$project$Components$Referentiel$Types$InformationsView$modifierLaDefinition = F4(
	function (i18n, model, prefixe, lu) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
				]),
			((!_Utils_eq(
				$author$project$Components$Referentiel$Types$Model$lienDesInformations(model),
				$elm$core$Maybe$Nothing)) && (!_Utils_eq(lu.JR, $elm$core$Maybe$Nothing))) ? _List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id(prefixe + '-definition'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Referentiel$Types$Update$DefinitionDemandee(lu.uN.dy))
						]),
					A2(
						$author$project$I18n$Cles$editeurDeSchemaActionsModifierDe,
						i18n,
						{Dj: lu.uN.Bl}))
				]) : _List_Nil);
	});
var $author$project$I18n$Cles$referentielInformationAnglais = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.information.anglais',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl))
				]),
			'Anglais : ' + p.Bl);
	});
var $author$project$I18n$Cles$referentielInformationFiches = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.information.fiches',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiche la renseigne.') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiches la renseignent.'));
	});
var $author$project$I18n$Cles$referentielInformationMasquer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.information.masquer', _List_Nil, 'Masquer');
};
var $author$project$I18n$Cles$referentielInformationMasquerAction = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.information.masquer.action',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Masquer « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$referentielInformationMasquerExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.information.masquer.explication', _List_Nil, 'Une information masquée ne se saisit plus. Ce qui a été saisi reste sur les fiches ; elle se réaffiche quand vous voulez.');
};
var $author$project$I18n$Cles$referentielInformationNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.information.nom', _List_Nil, 'Nom');
};
var $author$project$I18n$Cles$referentielInformationObligatoire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.information.obligatoire', _List_Nil, 'Obligatoire pour enregistrer le rôle');
};
var $author$project$I18n$Cles$referentielInformationOrdre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.information.ordre', _List_Nil, 'Ordre sur la fiche');
};
var $author$project$I18n$Cles$referentielInformationPersonnelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.information.personnelle', _List_Nil, 'Donnée personnelle');
};
var $author$project$I18n$Cles$referentielInformationPersonnelleRemplie = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.information.personnelle.remplie',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Déjà remplie sur ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiche : elle ne peut plus être décochée.')) : ('Déjà remplie sur ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiches : elle ne peut plus être décochée.')));
	});
var $author$project$I18n$Cles$referentielInformationRenommer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.information.renommer', _List_Nil, 'Renommer');
};
var $author$project$I18n$Cles$referentielInformationSaisie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.information.saisie', _List_Nil, 'Ce qu\'on y saisit');
};
var $author$project$I18n$Cles$referentielInformationSaisieFacultative = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.information.saisie.facultative', _List_Nil, 'Facultative');
};
var $author$project$I18n$Cles$referentielInformationSaisieObligatoire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.information.saisie.obligatoire', _List_Nil, 'Obligatoire');
};
var $author$project$I18n$Cles$referentielInformationSaisieResume = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.information.saisie.resume',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nature',
					$author$project$I18n$Traductions$Chaine(p.g1)),
					_Utils_Tuple2(
					'exigence',
					$author$project$I18n$Traductions$Chaine(p.mo))
				]),
			p.g1 + ('. ' + (p.mo + '.')));
	});
var $author$project$I18n$Cles$referentielInformationSaisieTypeFige = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.information.saisie.type-fige', _List_Nil, 'Le type ne change plus une fois des fiches remplies ; l\'obligation se modifie.');
};
var $author$project$I18n$Cles$referentielInformationSurtitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.information.surtitre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Information · ' + p.bi);
	});
var $author$project$Components$Referentiel$Types$InformationsView$contenuDUneInformation = F5(
	function (i18n, model, edition, fiche, lu) {
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.AM.zo);
		var demandees = $author$project$Components$Referentiel$Types$Informations$demandees(fiche);
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('surtitre')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$referentielInformationSurtitre,
							i18n,
							{bi: fiche.r0.R.zX}))
					])),
				A2(
				$author$project$Components$Shared$Messages$View$view,
				i18n,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $elm$core$List$singleton, model.AM.pZ))),
				A2(
				$rtfeldman$elm_css$Html$Styled$section,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h3,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielInformationNom(i18n))
							])),
						edition.hL ? A3(
						$author$project$Components$Shared$LibellesParLangue$View$view,
						i18n,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('libelles')
							]),
						{
							go: function (code) {
								return ((code === 'fr') && ($elm$core$String$trim(
									A2($author$project$Components$Shared$LibellesParLangue$Model$lire, code, edition.R)) === '')) ? $elm$core$Maybe$Just(
									$author$project$I18n$Cles$referentielTypesChampLibelleObligatoire(i18n)) : $elm$core$Maybe$Nothing;
							},
							Ba: $author$project$Referentiel$Langues$desLibelles,
							Bl: $author$project$I18n$Cles$referentielInformationNom(i18n),
							hg: $author$project$Components$Referentiel$Types$Update$LibelleDeLInformation,
							pv: prefixe + '-libelle',
							fm: function (code) {
								return A2($author$project$Components$Shared$LibellesParLangue$Model$lire, code, edition.R);
							}
						}) : A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('cadre')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('libelles')
									]),
								A2(
									$elm$core$List$cons,
									A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(lu.uN.Bl)
											])),
									function () {
										var _v0 = A2($author$project$Components$Shared$LibellesParLangue$Model$lire, 'en', edition.R);
										if (_v0 === '') {
											return _List_Nil;
										} else {
											var anglais = _v0;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('traduction')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															A2(
																$author$project$I18n$Cles$referentielInformationAnglais,
																i18n,
																{Bl: anglais}))
														]))
												]);
										}
									}())),
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('renommer'),
										$rtfeldman$elm_css$Html$Styled$Attributes$id(prefixe + '-renommer'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Types$Update$RenommageDeLInformation)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielInformationRenommer(i18n))
									]))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$section,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('saisie')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h3,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielInformationSaisie(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('resume')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$referentielInformationSaisieResume,
									i18n,
									{
										mo: edition.he ? $author$project$I18n$Cles$referentielInformationSaisieObligatoire(i18n) : $author$project$I18n$Cles$referentielInformationSaisieFacultative(i18n),
										g1: A2($author$project$Components$Referentiel$Types$Informations$nature, i18n, lu)
									}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielInformationSaisieTypeFige(i18n))
							])),
						A5(
						$author$project$Components$Referentiel$Types$InformationsView$case_,
						prefixe + '-obligatoire',
						$author$project$I18n$Cles$referentielInformationObligatoire(i18n),
						edition.he,
						false,
						$author$project$Components$Referentiel$Types$Update$ObligationCochee),
						function () {
						var _v1 = A2($elm$core$Dict$get, lu.uN.dy, fiche.dq);
						if (!_v1.$) {
							var partage = _v1.a;
							return partage.hm ? A3($author$project$Components$Referentiel$Types$InformationsView$definitionPartagee, i18n, lu, partage) : A4($author$project$Components$Referentiel$Types$InformationsView$modifierLaDefinition, i18n, model, prefixe, lu);
						} else {
							return A4($author$project$Components$Referentiel$Types$InformationsView$modifierLaDefinition, i18n, model, prefixe, lu);
						}
					}()
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$section,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('personnelle')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h3,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielInformationPersonnelle(i18n))
							])),
						A5(
						$author$project$Components$Referentiel$Types$InformationsView$case_,
						prefixe + '-personnelle',
						$author$project$I18n$Cles$referentielInformationPersonnelle(i18n),
						edition.Ff,
						(!lu.uN.xD) || (!lu.AZ),
						$author$project$Components$Referentiel$Types$Update$PersonnelleCochee),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						(lu.uN.xD && (!lu.AZ)) ? _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$referentielInformationPersonnelleRemplie,
									i18n,
									{w: lu.zu}))
							]) : _List_Nil)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$section,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ordre')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h3,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielInformationOrdre(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('ordre')
							]),
						A2(
							$elm$core$List$indexedMap,
							A4(
								$author$project$Components$Referentiel$Types$InformationsView$ligneDOrdre,
								i18n,
								model,
								lu.uN.dy,
								$elm$core$List$length(demandees)),
							demandees))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$section,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('reglages')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h3,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$reglagesDuChampTitre(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
							]),
						(!_Utils_eq(
							A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reglerLeRattachement, lu.nQ),
							$elm$core$Maybe$Nothing)) ? _List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id(prefixe + '-reglages'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Referentiel$Types$Update$ReglagesDuChampOuverts(lu.uN.dy)),
										$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
										$author$project$Components$Referentiel$Types$Model$enAttente(model))
									]),
								$author$project$I18n$Cles$reglagesDuChampTitre(i18n))
							]) : _List_Nil)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$section,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('masquer')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h3,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielInformationMasquer(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[
											$author$project$I18n$Cles$referentielInformationMasquerExplication(i18n),
											A2(
											$author$project$I18n$Cles$referentielInformationFiches,
											i18n,
											{w: lu.zu})
										])))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
							]),
						(!_Utils_eq(
							A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$masquerUnChamp, lu.nQ),
							$elm$core$Maybe$Nothing)) ? _List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								3,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id(prefixe + '-masquer'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Types$Update$MasquageDeLInformation),
										$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
										$author$project$Components$Referentiel$Types$Model$enAttente(model))
									]),
								A2(
									$author$project$I18n$Cles$referentielInformationMasquerAction,
									i18n,
									{Dj: lu.uN.Bl}))
							]) : _List_Nil)
					]))
			]);
	});
var $author$project$I18n$Cles$referentielInformationEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.information.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$Components$Referentiel$Types$InformationsView$drawerDUneInformation = F2(
	function (i18n, model) {
		var etat = model.AM;
		var ouverte = $author$project$Components$Shared$Drawer$Model$estOuvert(etat.zo) ? A2(
			$elm$core$Maybe$andThen,
			function (_v2) {
				var edition = _v2.a;
				var fiche = _v2.b;
				return A2(
					$elm$core$Maybe$map,
					function (lu) {
						return _Utils_Tuple3(edition, fiche, lu);
					},
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dw;
							},
							$author$project$Components$Referentiel$Types$Informations$parCle(edition.dy)),
						fiche.aN));
			},
			A3(
				$elm$core$Maybe$map2,
				$elm$core$Tuple$pair,
				etat.ge,
				$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model))) : $elm$core$Maybe$Nothing;
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$Types$Update$DeLInformation,
			function () {
				if (!ouverte.$) {
					var _v1 = ouverte.a;
					var edition = _v1.a;
					var fiche = _v1.b;
					var lu = _v1.c;
					return {
						fs: {
							sR: (!_Utils_eq(
								$author$project$Components$Referentiel$Types$Model$informationModifiee(model),
								$elm$core$Maybe$Nothing)) && (!$author$project$Components$Referentiel$Types$Model$enAttente(model)),
							Bl: $author$project$I18n$Cles$referentielInformationEnregistrer(i18n),
							C$: $author$project$Components$Referentiel$Types$Update$InformationEnregistree
						},
						fZ: A5($author$project$Components$Referentiel$Types$InformationsView$contenuDUneInformation, i18n, model, edition, fiche, lu),
						A6: $elm$core$Maybe$Nothing,
						Bc: false,
						h6: lu.uN.Bl
					};
				} else {
					return {
						fs: {sR: false, Bl: '', C$: $author$project$Components$Referentiel$Types$Update$InformationEnregistree},
						fZ: _List_Nil,
						A6: $elm$core$Maybe$Nothing,
						Bc: false,
						h6: ''
					};
				}
			}(),
			etat.zo);
	});
var $author$project$I18n$Cles$ordreDesBlocsPiedTypeDePartiePrenante = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'ordre-des-blocs.pied-type-de-partie-prenante', _List_Nil, 'Valable pour les fiches des parties prenantes de ce type');
};
var $author$project$Components$Referentiel$Types$InformationsView$drawerDeLOrdre = F2(
	function (i18n, model) {
		var nom = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (lue) {
					return lue.r0.R.zX;
				},
				$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model)));
		return A3(
			$author$project$Components$Shared$OrdreDesBlocs$View$drawer,
			i18n,
			{
				cF: $author$project$Components$Referentiel$Common$EnvoiDeType$enCours(model.l2),
				Dj: nom,
				ey: $elm$core$Maybe$Nothing,
				aj: $author$project$I18n$Cles$ordreDesBlocsPiedTypeDePartiePrenante(i18n),
				c0: $author$project$I18n$Cles$ordreDesBlocsCeType(i18n),
				Io: true,
				KD: $author$project$Components$Referentiel$Types$Update$DesBlocs
			},
			model.o1);
	});
var $author$project$Components$Referentiel$Types$Update$ReaffichageDeLInformation = {$: 74};
var $author$project$Texte$Jour$dansLaPhrase = F2(
	function (i18n, jour) {
		var _v0 = A2(
			$author$project$Texte$Jour$lire,
			$author$project$Texte$Jour$moisEntiers(i18n),
			jour);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var quantieme = _v1.a;
			var nom = _v1.b;
			return A2(
				$author$project$I18n$Cles$jourDansLaPhrase,
				i18n,
				{A_: quantieme, CQ: nom});
		} else {
			return jour;
		}
	});
var $author$project$I18n$Cles$referentielInformationMasquee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.information.masquee', _List_Nil, 'Masquée');
};
var $author$project$I18n$Cles$referentielInformationMasqueeDepuis = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.information.masquee.depuis',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'jour',
					$author$project$I18n$Traductions$Chaine(p.A_))
				]),
			'Elle ne se saisit plus depuis le ' + (p.A_ + '.'));
	});
var $author$project$I18n$Cles$referentielInformationMasqueeExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.information.masquee.explication', _List_Nil, 'Ce qui a été saisi est gardé :');
};
var $author$project$I18n$Cles$referentielInformationReafficher = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.information.reafficher',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Réafficher « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$referentielInformationSurtitreMasquee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.information.surtitre.masquee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Information masquée · ' + p.bi);
	});
var $author$project$Components$Referentiel$Types$InformationsView$drawerDeLaMasquee = F2(
	function (i18n, model) {
		var etat = model.AM;
		var ouverte = $author$project$Components$Shared$Drawer$Model$estOuvert(etat.Ca) ? A2(
			$elm$core$Maybe$andThen,
			function (_v4) {
				var edition = _v4.a;
				var fiche = _v4.b;
				return A2(
					$elm$core$Maybe$map,
					function (lu) {
						return _Utils_Tuple3(edition, fiche, lu);
					},
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dw;
							},
							$author$project$Components$Referentiel$Types$Informations$parCle(edition.dy)),
						fiche.aN));
			},
			A3(
				$elm$core$Maybe$map2,
				$elm$core$Tuple$pair,
				etat.ge,
				$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model))) : $elm$core$Maybe$Nothing;
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(etat.Ca);
		var depuis = function (jour) {
			return A2(
				$author$project$I18n$Cles$referentielInformationMasqueeDepuis,
				i18n,
				{A_: jour});
		};
		return A4(
			$author$project$Components$Shared$Drawer$View$consultation,
			i18n,
			$author$project$Components$Referentiel$Types$Update$DeLaMasquee,
			{
				fZ: function () {
					if (!ouverte.$) {
						var _v1 = ouverte.a;
						var edition = _v1.a;
						var fiche = _v1.b;
						var lu = _v1.c;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('surtitre')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$referentielInformationSurtitreMasquee,
											i18n,
											{bi: fiche.r0.R.zX}))
									])),
								A2(
								$author$project$Components$Shared$Messages$View$view,
								i18n,
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2($elm$core$Maybe$map, $elm$core$List$singleton, etat.pZ))),
								A2(
								$rtfeldman$elm_css$Html$Styled$section,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$h3,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$referentielInformationNom(i18n))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('cadre')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('libelles')
													]),
												A2(
													$elm$core$List$cons,
													A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(lu.uN.Bl)
															])),
													function () {
														var _v2 = A2($author$project$Components$Shared$LibellesParLangue$Model$lire, 'en', edition.R);
														if (_v2 === '') {
															return _List_Nil;
														} else {
															var anglais = _v2;
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$span,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class('traduction')
																		]),
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text(
																			A2(
																				$author$project$I18n$Cles$referentielInformationAnglais,
																				i18n,
																				{Bl: anglais}))
																		]))
																]);
														}
													}()))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$section,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('masquee')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$h3,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$referentielInformationMasquee(i18n))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$elm$core$String$join,
													' ',
													_Utils_ap(
														A2(
															$elm$core$Maybe$withDefault,
															_List_Nil,
															A2(
																$elm$core$Maybe$map,
																A2(
																	$elm$core$Basics$composeR,
																	$author$project$Texte$Jour$dansLaPhrase(i18n),
																	A2($elm$core$Basics$composeR, depuis, $elm$core$List$singleton)),
																lu.B9)),
														_List_fromArray(
															[
																$author$project$I18n$Cles$referentielInformationMasqueeExplication(i18n),
																A2(
																$author$project$I18n$Cles$referentielInformationFiches,
																i18n,
																{w: lu.zu})
															]))))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
											]),
										_List_fromArray(
											[
												A3(
												$author$project$Components$Shared$Bouton$View$bouton,
												1,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$id(prefixe + '-reafficher'),
														$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Types$Update$ReaffichageDeLInformation),
														$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
														$author$project$Components$Referentiel$Types$Model$enAttente(model))
													]),
												A2(
													$author$project$I18n$Cles$referentielInformationReafficher,
													i18n,
													{Dj: lu.uN.Bl}))
											]))
									]))
							]);
					} else {
						return _List_Nil;
					}
				}(),
				G8: false,
				h6: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function (_v3) {
							var lu = _v3.c;
							return lu.uN.Bl;
						},
						ouverte))
			},
			etat.Ca);
	});
var $author$project$Components$Referentiel$Types$Update$ChampMasqueDepuisLaRestriction = {$: 90};
var $author$project$Components$Referentiel$Types$Update$RestrictionEnregistree = {$: 88};
var $author$project$Components$Referentiel$Types$Update$RestrictionLevee = {$: 89};
var $author$project$Components$Referentiel$Types$Update$ToutCoche = {$: 86};
var $author$project$Components$Referentiel$Types$Update$ToutDecoche = {$: 87};
var $author$project$Components$Referentiel$Types$Update$ValeurCochee = F2(
	function (a, b) {
		return {$: 85, a: a, b: b};
	});
var $author$project$Components$Referentiel$Types$RestrictionDuChamp$peutLever = F2(
	function (enCours, fiche) {
		return (!_Utils_eq(
			A2($author$project$Components$Referentiel$Types$RestrictionDuChamp$retenuesDe, enCours.dy, fiche),
			_List_Nil)) && (!_Utils_eq(
			A2($author$project$Components$Referentiel$Types$RestrictionDuChamp$lever, enCours, fiche),
			$elm$core$Maybe$Nothing));
	});
var $author$project$Components$Referentiel$Types$RestrictionDuChamp$peutMasquer = F2(
	function (enCours, fiche) {
		return !_Utils_eq(
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nQ;
					},
					$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$masquerUnChamp)),
				A2($author$project$Components$Referentiel$Types$RestrictionDuChamp$champDe, enCours.dy, fiche)),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Components$Referentiel$Types$InformationsView$drawerDeLaRestriction = F2(
	function (i18n, model) {
		var etat = model.AM;
		return A5(
			$author$project$Components$Shared$Bibliotheque$RestrictionView$view,
			i18n,
			{
				xP: $author$project$I18n$Cles$bibliothequeDefinitionDroitPartiesPrenantes(i18n),
				yj: $author$project$Components$Referentiel$Common$EnvoiDeType$enCours(model.l2),
				E$: true,
				Fm: A2(
					$elm$core$Maybe$withDefault,
					false,
					A3(
						$elm$core$Maybe$map2,
						$author$project$Components$Referentiel$Types$RestrictionDuChamp$peutLever,
						etat.al,
						$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model))),
				Fn: A2(
					$elm$core$Maybe$withDefault,
					false,
					A3(
						$elm$core$Maybe$map2,
						$author$project$Components$Referentiel$Types$RestrictionDuChamp$peutMasquer,
						etat.al,
						$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model)))
			},
			{vw: $author$project$Components$Referentiel$Types$Update$ValeurCochee, xU: $author$project$Components$Referentiel$Types$Update$DeLaRestriction, Bj: $author$project$Components$Referentiel$Types$Update$RestrictionLevee, Cc: $author$project$Components$Referentiel$Types$Update$ChampMasqueDepuisLaRestriction, HV: $author$project$Components$Referentiel$Types$Update$RestrictionEnregistree, JI: $author$project$Components$Referentiel$Types$Update$ToutCoche, JJ: $author$project$Components$Referentiel$Types$Update$ToutDecoche},
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.gt;
				},
				etat.al),
			etat.lC);
	});
var $author$project$Components$Referentiel$Types$Update$DesReglages = function (a) {
	return {$: 79, a: a};
};
var $author$project$Components$Referentiel$Types$Update$LectureDuChampReglee = function (a) {
	return {$: 80, a: a};
};
var $author$project$Components$Referentiel$Types$Update$ReglagesDuChampEnregistres = {$: 81};
var $author$project$Components$Referentiel$Types$Update$RestrictionDemandee = function (a) {
	return {$: 82, a: a};
};
var $author$project$Components$Referentiel$Types$RestrictionDuChamp$nombreRetenues = F2(
	function (cle, fiche) {
		return $elm$core$List$length(
			A2($author$project$Components$Referentiel$Types$RestrictionDuChamp$retenuesDe, cle, fiche));
	});
var $author$project$Components$Referentiel$Types$InformationsView$ligneDeRestriction = F3(
	function (i18n, fiche, champ) {
		var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$restreindreLesValeurs, champ.nQ);
		if (!_v0.$) {
			var retenues = A2($author$project$Components$Referentiel$Types$RestrictionDuChamp$nombreRetenues, champ.uN.dy, fiche);
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsTypesRestrictionLigne(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('champ')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								(!retenues) ? $author$project$I18n$Cles$produitsTypesRestrictionAucune(i18n) : A2(
									$author$project$I18n$Cles$produitsTypesRestrictionRetenues,
									i18n,
									{hN: retenues}))
							])),
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Referentiel$Types$Update$RestrictionDemandee(champ.uN.dy))
							]),
						(!retenues) ? $author$project$I18n$Cles$produitsTypesRestrictionPoser(i18n) : $author$project$I18n$Cles$produitsTypesRestrictionModifier(i18n))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Referentiel$Vocabulaire$niveauDeLecture = F2(
	function (i18n, code) {
		if (code === 'detail') {
			return $author$project$I18n$Cles$reglagesDuChampLectureDetail(i18n);
		} else {
			return $author$project$I18n$Cles$reglagesDuChampLectureEssentiel(i18n);
		}
	});
var $author$project$Components$Referentiel$Vocabulaire$niveauxDeLecture = _List_fromArray(
	['essentiel', 'detail']);
var $author$project$Components$Referentiel$Types$InformationsView$drawerDesReglages = F2(
	function (i18n, model) {
		var etat = model.AM;
		var lu = A2(
			$elm$core$Maybe$andThen,
			function (reglage) {
				return A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dw;
						},
						$author$project$Components$Referentiel$Types$Informations$parCle(reglage.dy)),
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.aN;
						},
						$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model)));
			},
			etat.eO);
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$Types$Update$DesReglages,
			function () {
				var _v0 = _Utils_Tuple3(
					etat.eO,
					lu,
					$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model));
				if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
					var reglage = _v0.a.a;
					var champ = _v0.b.a;
					var fiche = _v0.c.a;
					return {
						fs: {
							sR: (!_Utils_eq(reglage.np, champ.g4)) && (!$author$project$Components$Referentiel$Types$Model$enAttente(model)),
							Bl: $author$project$I18n$Cles$reglagesDuChampEnregistrer(i18n),
							C$: $author$project$Components$Referentiel$Types$Update$ReglagesDuChampEnregistres
						},
						fZ: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$reglagesDuChampDetail,
											i18n,
											{uN: champ.uN.Bl, Dp: fiche.r0.R.zX}))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$reglagesDuChampChamp(i18n))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('champ')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$strong,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(champ.uN.Bl)
													]))
											]))
									])),
								A2(
								$author$project$Components$Shared$Champ$View$liste,
								{
									go: $elm$core$Maybe$Nothing,
									Aq: $author$project$Components$Shared$Drawer$Model$idRacine(etat.qc) + '-lecture',
									Bl: $author$project$I18n$Cles$reglagesDuChampLecture(i18n),
									he: false
								},
								{
									hg: $author$project$Components$Referentiel$Types$Update$LectureDuChampReglee,
									o_: A2(
										$elm$core$List$map,
										function (code) {
											return {
												Bl: A2($author$project$Components$Referentiel$Vocabulaire$niveauDeLecture, i18n, code),
												fm: code
											};
										},
										$author$project$Components$Referentiel$Vocabulaire$niveauxDeLecture),
									fm: reglage.np
								}),
								A3($author$project$Components$Referentiel$Types$InformationsView$ligneDeRestriction, i18n, fiche, champ),
								A2(
								$author$project$Components$Shared$Messages$View$view,
								i18n,
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2($elm$core$Maybe$map, $elm$core$List$singleton, etat.pZ)))
							]),
						A6: $elm$core$Maybe$Nothing,
						Bc: false,
						h6: $author$project$I18n$Cles$reglagesDuChampTitre(i18n)
					};
				} else {
					return {
						fs: {sR: false, Bl: '', C$: $author$project$Components$Referentiel$Types$Update$ReglagesDuChampEnregistres},
						fZ: _List_Nil,
						A6: $elm$core$Maybe$Nothing,
						Bc: false,
						h6: ''
					};
				}
			}(),
			etat.qc);
	});
var $author$project$I18n$Cles$referentielVersionsDetailDonneePersonnelleRetiree = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.versions.detail.donnee-personnelle-retiree', _List_Nil, 'donnée personnelle retirée');
};
var $author$project$I18n$Cles$referentielVersionsDetailFacultative = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.versions.detail.facultative', _List_Nil, 'rendue facultative');
};
var $author$project$I18n$Cles$referentielVersionsDetailModifiee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.versions.detail.modifiee', _List_Nil, 'modifiée');
};
var $author$project$I18n$Cles$referentielVersionsDetailObligatoire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.versions.detail.obligatoire', _List_Nil, 'rendue obligatoire');
};
var $author$project$I18n$Cles$referentielVersionsDetailRenommee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.versions.detail.renommee', _List_Nil, 'renommée');
};
var $author$project$Components$Referentiel$Types$Informations$detail = F2(
	function (i18n, _v0) {
		var quoi = _v0.GM;
		var valeur = _v0.fm;
		var _v1 = _Utils_Tuple2(quoi, valeur);
		_v1$4:
		while (true) {
			switch (_v1.a) {
				case 'exigence':
					if (!_v1.b.$) {
						if (_v1.b.a === 'facultatif') {
							return $author$project$I18n$Cles$referentielVersionsDetailFacultative(i18n);
						} else {
							return $author$project$I18n$Cles$referentielVersionsDetailObligatoire(i18n);
						}
					} else {
						break _v1$4;
					}
				case 'nom':
					return $author$project$I18n$Cles$referentielVersionsDetailRenommee(i18n);
				case 'donnee-personnelle':
					return $author$project$I18n$Cles$referentielVersionsDetailDonneePersonnelleRetiree(i18n);
				default:
					break _v1$4;
			}
		}
		return $author$project$I18n$Cles$referentielVersionsDetailModifiee(i18n);
	});
var $author$project$I18n$Cles$referentielVersionsChangement = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.versions.changement',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'details',
					$author$project$I18n$Traductions$Chaine(p.cz))
				]),
			p.Dj + (' ' + p.cz));
	});
var $author$project$I18n$Cles$referentielVersionsDetailAjoutee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.versions.detail.ajoutee', _List_Nil, 'ajoutée');
};
var $author$project$I18n$Cles$referentielVersionsDetailDonneePersonnelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.versions.detail.donnee-personnelle', _List_Nil, 'donnée personnelle');
};
var $author$project$Components$Referentiel$Types$Informations$changement = F3(
	function (i18n, nomme, fait) {
		var details = function () {
			var _v0 = fait.g1;
			if (!_v0) {
				return A2(
					$elm$core$List$cons,
					$author$project$I18n$Cles$referentielVersionsDetailAjoutee(i18n),
					fait.xD ? _List_fromArray(
						[
							$author$project$I18n$Cles$referentielVersionsDetailDonneePersonnelle(i18n)
						]) : _List_Nil);
			} else {
				return function (dits) {
					return $elm$core$List$isEmpty(dits) ? _List_fromArray(
						[
							$author$project$I18n$Cles$referentielVersionsDetailModifiee(i18n)
						]) : dits;
				}(
					A2(
						$elm$core$List$map,
						$author$project$Components$Referentiel$Types$Informations$detail(i18n),
						fait.cz));
			}
		}();
		return A2(
			$author$project$I18n$Cles$referentielVersionsChangement,
			i18n,
			{
				cz: A2($elm$core$String$join, ', ', details),
				Dj: nomme(fait.uN)
			});
	});
var $author$project$I18n$Cles$referentielVersionsEt = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.versions.et',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'debut',
					$author$project$I18n$Traductions$Chaine(p.ku)),
					_Utils_Tuple2(
					'fin',
					$author$project$I18n$Traductions$Chaine(p.mI))
				]),
			p.ku + (' et ' + p.mI));
	});
var $author$project$Components$Referentiel$Types$Informations$enumerer = F2(
	function (i18n, noms) {
		var _v0 = $elm$core$List$reverse(noms);
		if (_v0.b && _v0.b.b) {
			var dernier = _v0.a;
			var _v1 = _v0.b;
			var avant = _v1.a;
			var reste = _v1.b;
			return A2(
				$author$project$I18n$Cles$referentielVersionsEt,
				i18n,
				{
					ku: A2(
						$elm$core$String$join,
						', ',
						$elm$core$List$reverse(
							A2($elm$core$List$cons, avant, reste))),
					mI: dernier
				});
		} else {
			return $elm$core$String$concat(noms);
		}
	});
var $author$project$I18n$Cles$referentielVersionsAjoutee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.versions.ajoutee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'« ' + (p.Dj + ' » ajoutée'));
	});
var $author$project$I18n$Cles$referentielVersionsCreation = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.versions.creation',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi))
				]),
			'Création du type « ' + (p.bi + ' »'));
	});
var $author$project$I18n$Cles$referentielVersionsCreationAvec = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.versions.creation.avec',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$author$project$I18n$Traductions$Chaine(p.bi)),
					_Utils_Tuple2(
					'informations',
					$author$project$I18n$Traductions$Chaine(p.AM))
				]),
			'Création du type « ' + (p.bi + (' » avec ' + p.AM)));
	});
var $author$project$I18n$Cles$referentielVersionsModifiee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.versions.modifiee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'« ' + (p.Dj + ' » modifiée'));
	});
var $author$project$I18n$Cles$referentielVersionsNom = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.versions.nom',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'« ' + (p.Dj + ' »'));
	});
var $author$project$Components$Referentiel$Types$Informations$phraseDeVersion = F4(
	function (i18n, role, nommer, version) {
		var nomme = function (cle) {
			return A2(
				$author$project$I18n$Cles$referentielVersionsNom,
				i18n,
				{
					Dj: nommer(cle)
				});
		};
		var parties = $elm$core$List$isEmpty(version.u3) ? _Utils_ap(
			A2(
				$elm$core$List$map,
				function (cle) {
					return A2(
						$author$project$I18n$Cles$referentielVersionsAjoutee,
						i18n,
						{
							Dj: nommer(cle)
						});
				},
				version.fx),
			A2(
				$elm$core$List$map,
				function (cle) {
					return A2(
						$author$project$I18n$Cles$referentielVersionsModifiee,
						i18n,
						{
							Dj: nommer(cle)
						});
				},
				version.g$)) : A2(
			$elm$core$List$map,
			A2($author$project$Components$Referentiel$Types$Informations$changement, i18n, nomme),
			version.u3);
		var ajoutees = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.g1;
				},
				$elm$core$Basics$eq(0)),
			version.u3);
		return ((version.sq === 1) && _Utils_eq(
			$elm$core$List$length(ajoutees),
			$elm$core$List$length(version.u3))) ? ($elm$core$List$isEmpty(ajoutees) ? (A2(
			$author$project$I18n$Cles$referentielVersionsCreation,
			i18n,
			{bi: role}) + '.') : (A2(
			$author$project$I18n$Cles$referentielVersionsCreationAvec,
			i18n,
			{
				AM: A2(
					$author$project$Components$Referentiel$Types$Informations$enumerer,
					i18n,
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.uN;
							},
							nomme),
						ajoutees)),
				bi: role
			}) + '.')) : (A2($elm$core$String$join, ' ; ', parties) + '.');
	});
var $author$project$I18n$Cles$referentielVersionsExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.versions.explication', _List_Nil, 'Chaque changement des informations crée une version. Une fiche garde ce qu\'elle a saisi sous la version de l\'époque.');
};
var $author$project$I18n$Cles$referentielVersionsGesteMasquee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.versions.geste.masquee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'« ' + (p.Dj + ' » masquée.'));
	});
var $author$project$I18n$Cles$referentielVersionsGesteOrdonnees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.versions.geste.ordonnees', _List_Nil, 'Informations réordonnées.');
};
var $author$project$I18n$Cles$referentielVersionsGesteReaffichee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.versions.geste.reaffichee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'« ' + (p.Dj + ' » réaffichée.'));
	});
var $author$project$I18n$Cles$referentielVersionsQuandAutre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.versions.quand.autre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			p.wv + ' · un autre utilisateur');
	});
var $author$project$I18n$Cles$referentielVersionsQuandMoi = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.versions.quand.moi',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			p.wv + ' · moi');
	});
var $author$project$I18n$Cles$referentielVersionsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.versions.titre', _List_Nil, 'Historique des versions');
};
var $author$project$I18n$Cles$referentielVersionsVersion = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.versions.version',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'numero',
					$author$project$I18n$Traductions$Chaine(p.DX))
				]),
			'Version ' + p.DX);
	});
var $author$project$Components$Referentiel$Types$InformationsView$drawerDesVersions = F2(
	function (i18n, model) {
		var quand = function (lu) {
			return (lu.og ? $author$project$I18n$Cles$referentielVersionsQuandMoi(i18n) : $author$project$I18n$Cles$referentielVersionsQuandAutre(i18n))(
				{
					wv: A2(
						$author$project$Texte$Jour$enFrancais,
						i18n,
						A2($elm$core$String$left, 10, lu.wv))
				});
		};
		var fiche = $author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model);
		var nommer = function (cle) {
			return A2(
				$elm$core$Maybe$withDefault,
				cle,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.uN;
						},
						function ($) {
							return $.Bl;
						}),
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dw;
							},
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$filter(
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.uN;
										},
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.dy;
											},
											$elm$core$Basics$eq(cle)))),
								$elm$core$List$head)),
						A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.aN;
							},
							fiche))));
		};
		var geste = function (fait) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$li,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('geste')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('quand')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										quand(fait))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('changement')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								function () {
									var _v0 = _Utils_Tuple2(
										fait.g1,
										A2($elm$core$Maybe$map, nommer, fait.uN));
									_v0$2:
									while (true) {
										if (!_v0.b.$) {
											switch (_v0.a) {
												case 0:
													var _v1 = _v0.a;
													var nom = _v0.b.a;
													return A2(
														$author$project$I18n$Cles$referentielVersionsGesteMasquee,
														i18n,
														{Dj: nom});
												case 1:
													var _v2 = _v0.a;
													var nom = _v0.b.a;
													return A2(
														$author$project$I18n$Cles$referentielVersionsGesteReaffichee,
														i18n,
														{Dj: nom});
												default:
													break _v0$2;
											}
										} else {
											break _v0$2;
										}
									}
									return $author$project$I18n$Cles$referentielVersionsGesteOrdonnees(i18n);
								}())
							]))
					]));
		};
		var role = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.r0;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.R;
						},
						function ($) {
							return $.zX;
						})),
				fiche));
		var version = function (lue) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$li,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('version')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$referentielVersionsVersion,
											i18n,
											{
												DX: $elm$core$String$fromInt(lue.sq)
											}))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('quand')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										quand(lue))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('changement')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A4($author$project$Components$Referentiel$Types$Informations$phraseDeVersion, i18n, role, nommer, lue))
							]))
					]));
		};
		var etat = model.AM;
		var enChargement = _Utils_eq(etat.m6, $elm$core$Maybe$Nothing) && _Utils_eq(etat.pZ, $elm$core$Maybe$Nothing);
		return A4(
			$author$project$Components$Shared$Drawer$View$consultation,
			i18n,
			$author$project$Components$Referentiel$Types$Update$DesVersions,
			{
				fZ: $author$project$Components$Shared$Drawer$Model$estOuvert(etat.ss) ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('surtitre')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(role)
							])),
						A2(
						$author$project$Components$Shared$Messages$View$view,
						i18n,
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2($elm$core$Maybe$map, $elm$core$List$singleton, etat.pZ))),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('explication')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielVersionsExplication(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('versions'),
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('loading', enChargement)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-busy',
								enChargement ? 'true' : 'false')
							]),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.ss;
									},
									A2(
										$elm$core$Basics$composeR,
										$elm$core$List$sortBy(
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.sq;
												},
												$elm$core$Basics$negate)),
										$elm$core$List$concatMap(
											function (lue) {
												return _Utils_ap(
													A2(
														$elm$core$List$map,
														geste,
														$elm$core$List$reverse(lue.Ab)),
													_List_fromArray(
														[
															version(lue)
														]));
											}))),
								etat.m6)))
					]) : _List_Nil,
				G8: false,
				h6: $author$project$Components$Shared$Drawer$Model$estOuvert(etat.ss) ? $author$project$I18n$Cles$referentielVersionsTitre(i18n) : ''
			},
			etat.ss);
	});
var $author$project$Components$Referentiel$Types$Update$PerimetreEnregistre = {$: 46};
var $author$project$Components$Referentiel$Types$Update$PerimetreRecherche = function (a) {
	return {$: 44, a: a};
};
var $author$project$Components$Referentiel$Types$Update$PerimetreRetire = {$: 47};
var $author$project$Components$Referentiel$Types$Update$PerimetreSelectionne = function (a) {
	return {$: 45, a: a};
};
var $author$project$I18n$Cles$referentielParcoursOffresPerimetreDecompte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parcours.offres.perimetre.decompte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' offre aujourd\'hui') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' offres aujourd\'hui'));
	});
var $author$project$I18n$Cles$referentielParcoursOffresPerimetreDrawerAction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.perimetre.drawer.action', _List_Nil, 'Choisir ce périmètre');
};
var $author$project$I18n$Cles$referentielParcoursOffresPerimetreDrawerArchives = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.perimetre.drawer.archives', _List_Nil, 'Les périmètres archivés ne sont pas proposés.');
};
var $author$project$I18n$Cles$referentielParcoursOffresPerimetreDrawerDecompte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parcours.offres.perimetre.drawer.decompte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' offre') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' offres'));
	});
var $author$project$I18n$Cles$referentielParcoursOffresPerimetreDrawerExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.perimetre.drawer.explication', _List_Nil, 'Le résultat suit le périmètre : il est recalculé à chaque usage.');
};
var $author$project$I18n$Cles$referentielParcoursOffresPerimetreDrawerLiee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.perimetre.drawer.liee', _List_Nil, 'lié à la fiche');
};
var $author$project$I18n$Cles$referentielParcoursOffresPerimetreDrawerNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.perimetre.drawer.nom', _List_Nil, 'Nom du périmètre');
};
var $author$project$I18n$Cles$referentielParcoursOffresPerimetreDrawerRechercher = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.perimetre.drawer.rechercher', _List_Nil, 'Rechercher un périmètre');
};
var $author$project$I18n$Cles$referentielParcoursOffresPerimetreDrawerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.perimetre.drawer.titre', _List_Nil, 'Choisir un périmètre');
};
var $author$project$I18n$Cles$referentielParcoursOffresPerimetreRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.perimetre.retirer', _List_Nil, 'Retirer le périmètre');
};
var $author$project$Components$Referentiel$Types$OffresView$refusDuPerimetre = F2(
	function (i18n, refus) {
		if (!refus.$) {
			var message = refus.a;
			var lu = A2($author$project$I18n$Cles$texte, i18n, message.Jx);
			var _v1 = function () {
				var _v2 = A2($elm$core$String$split, '. ', lu);
				if (_v2.b && _v2.b.b) {
					var debut = _v2.a;
					var _v3 = _v2.b;
					var suite = _v3.a;
					var reste = _v3.b;
					return _Utils_Tuple2(
						debut,
						A2(
							$elm$core$String$join,
							'. ',
							A2($elm$core$List$cons, suite, reste)));
				} else {
					return _Utils_Tuple2('', lu);
				}
			}();
			var titre = _v1.a;
			var corps = _v1.b;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('refus'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(titre)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(corps)
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Referentiel$Types$OffresView$drawerDuPerimetre = F2(
	function (i18n, model) {
		var proposes = function () {
			var _v3 = model.ph;
			if (_v3.$ === 1) {
				var lus = _v3.a;
				return lus;
			} else {
				return _List_Nil;
			}
		}();
		var ouvert = $author$project$Components$Shared$Drawer$Model$estOuvert(model.jR);
		var ligne = function (lu) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$li,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'selectionne',
								_Utils_eq(
									$elm$core$Maybe$Just(lu.Aq),
									model.pf)),
								_Utils_Tuple2(
								'refuse',
								_Utils_eq(
									$elm$core$Maybe$Just(lu.Aq),
									model.pf) && (!_Utils_eq(model.p5, $elm$core$Maybe$Nothing)))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('perimetre-propose'),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-pressed',
								_Utils_eq(
									$elm$core$Maybe$Just(lu.Aq),
									model.pf) ? 'true' : 'false'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Referentiel$Types$Update$PerimetreSelectionne(lu.Aq))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('rond')
									]),
								_List_Nil),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('main')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$strong,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('title')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(lu.Dj)
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('criteres')
											]),
										A2(
											$elm$core$List$map,
											function (segment) {
												return segment.dX ? A2(
													$rtfeldman$elm_css$Html$Styled$strong,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(segment.Jx)
														])) : A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(segment.Jx)
														]));
											},
											lu.wp))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('infos')
									]),
								_List_fromArray(
									[
										lu.Bx ? A2(
										$author$project$Components$Shared$Tag$View$view,
										3,
										$author$project$I18n$Cles$referentielParcoursOffresPerimetreDrawerLiee(i18n)) : A2(
										$author$project$Components$Shared$Tag$View$view,
										5,
										A2(
											$author$project$I18n$Cles$referentielParcoursOffresPerimetreDrawerDecompte,
											i18n,
											{w: lu.wT}))
									]))
							]))
					]));
		};
		var choisi = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (lu) {
					return _Utils_eq(
						$elm$core$Maybe$Just(lu.Aq),
						model.pf);
				},
				proposes));
		return A5(
			$author$project$Components$Shared$Drawer$View$viewAvecSousTitre,
			i18n,
			ouvert ? A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (f) {
						return A2(
							$author$project$I18n$Cles$referentielTypeLimiteDrawerKicker,
							i18n,
							{Dj: f.r0.R.zX});
					},
					$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model))) : '',
			$author$project$Components$Referentiel$Types$Update$DuChoixDuPerimetre,
			{
				fs: {
					sR: ouvert && ((!_Utils_eq(model.pf, $elm$core$Maybe$Nothing)) && (!$author$project$Components$Referentiel$Types$Model$enAttente(model))),
					Bl: ouvert ? $author$project$I18n$Cles$referentielParcoursOffresPerimetreDrawerAction(i18n) : '',
					C$: $author$project$Components$Referentiel$Types$Update$PerimetreEnregistre
				},
				fZ: ouvert ? _Utils_ap(
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$fieldset,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('recherche')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$legend,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$referentielParcoursOffresPerimetreDrawerRechercher(i18n))
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$input,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('search'),
											$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(
											$author$project$I18n$Cles$referentielParcoursOffresPerimetreDrawerNom(i18n)),
											A2(
											$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
											'aria-label',
											$author$project$I18n$Cles$referentielParcoursOffresPerimetreDrawerRechercher(i18n)),
											$rtfeldman$elm_css$Html$Styled$Attributes$value(model.pV),
											$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Referentiel$Types$Update$PerimetreRecherche)
										]),
									_List_Nil)
								])),
							A2($author$project$Components$Referentiel$Types$OffresView$refusDuPerimetre, i18n, model.p5),
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('perimetres')
								]),
							A2($elm$core$List$map, ligne, proposes)),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielParcoursOffresPerimetreDrawerArchives(i18n))
								]))
						]),
					_Utils_ap(
						function () {
							var _v0 = A2(
								$elm$core$Maybe$andThen,
								$author$project$Components$Referentiel$Types$Offres$commandeSansPerimetre,
								$author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model));
							if (!_v0.$) {
								return _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$button,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
												$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Types$Update$PerimetreRetire),
												$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
												$author$project$Components$Referentiel$Types$Model$enAttente(model))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$referentielParcoursOffresPerimetreRetirer(i18n))
											]))
									]);
							} else {
								return _List_Nil;
							}
						}(),
						function () {
							var _v1 = _Utils_Tuple2(choisi, model.p5);
							if ((!_v1.a.$) && (_v1.b.$ === 1)) {
								var lu = _v1.a.a;
								var _v2 = _v1.b;
								return _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('perimetre-choisi')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$strong,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(lu.Dj)
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2(
															$author$project$I18n$Cles$referentielParcoursOffresPerimetreDecompte,
															i18n,
															{w: lu.wT}) + ('. ' + $author$project$I18n$Cles$referentielParcoursOffresPerimetreDrawerExplication(i18n)))
													]))
											]))
									]);
							} else {
								return _List_Nil;
							}
						}())) : _List_Nil,
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: ouvert ? $author$project$I18n$Cles$referentielParcoursOffresPerimetreDrawerTitre(i18n) : ''
			},
			model.jR);
	});
var $author$project$Components$Referentiel$Types$InformationsView$drawerElargir = F2(
	function (i18n, model) {
		var _v0 = $author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model);
		if (!_v0.$) {
			var fiche = _v0.a;
			return A6(
				$author$project$Components$Shared$Bibliotheque$View$elargir,
				i18n,
				A2($author$project$Components$Referentiel$Types$InformationsView$contexteDeLAjout, model, fiche),
				$author$project$Components$Referentiel$Types$InformationsView$messagesDeLAjout,
				$author$project$Components$Referentiel$Common$EnvoiDeType$enCours(model.l2),
				model.AM.GZ.lP,
				model.AM.GZ.lx);
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Referentiel$Types$Update$ElargissementDeLaListeConfirme = function (a) {
	return {$: 101, a: a};
};
var $author$project$Components$Referentiel$Types$Update$ElargissementDeLaListeValide = {$: 102};
var $author$project$I18n$Cles$bibliothequeListeElargirConfirmation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.liste.elargir.confirmation', _List_Nil, 'Je confirme : cette liste devient proposable sur les types de partie prenante.');
};
var $author$project$I18n$Cles$bibliothequeListeElargirConsequence = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.liste.elargir.consequence', _List_Nil, 'La liste devient proposable sur les types de partie prenante, en plus du catalogue. Ses valeurs et son nom ne bougent pas.');
};
var $author$project$I18n$Cles$bibliothequeListeElargirRefus = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.liste.elargir.refus', _List_Nil, 'La portée de la liste n\'a pas pu être élargie.');
};
var $author$project$I18n$Cles$bibliothequeListeElargirSousTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.liste.elargir.sous-titre', _List_Nil, 'Liste partagée citée par une information du type.');
};
var $author$project$I18n$Cles$bibliothequeListeElargirTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.liste.elargir.titre', _List_Nil, 'Élargir la portée de la liste');
};
var $author$project$Components$Shared$Bibliotheque$ElargissementDeListe$view = F5(
	function (i18n, msgs, enCours, elargissement, drawerModel) {
		var vide = {
			fs: {sR: false, Bl: '', C$: msgs.Ku},
			fZ: _List_Nil,
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: ''
		};
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(drawerModel);
		var contenu = function () {
			if (!elargissement.$) {
				var courant = elargissement.a;
				return _Utils_update(
					vide,
					{
						fs: {
							sR: courant.dB && (!enCours),
							Bl: $author$project$I18n$Cles$produitsTypesElargirValider(i18n),
							C$: msgs.Ku
						},
						fZ: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$bibliothequeListeElargirSousTitre(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$produitsTypesElargirPortee(i18n))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('portees')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('portee'),
														$rtfeldman$elm_css$Html$Styled$Attributes$class('actuelle')
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$produitsTypesElargirActuelle(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$strong,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																A2($author$project$Components$Shared$Bibliotheque$Vocabulaire$porteeElargie, i18n, courant.F$))
															]))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('fleche'),
														A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('›')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('portee'),
														$rtfeldman$elm_css$Html$Styled$Attributes$class('proposee')
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$produitsTypesElargirProposee(i18n))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$strong,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																A2($author$project$Components$Shared$Bibliotheque$Vocabulaire$porteeElargie, i18n, 'catalogue-et-parties-prenantes'))
															]))
													]))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('consequence')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$strong,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$produitsTypesElargirConsequence(i18n))
											])),
										$rtfeldman$elm_css$Html$Styled$text(' '),
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$bibliothequeListeElargirConsequence(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('confirmation-de-l-elargissement')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Champ$View$caseACocher,
										{
											go: $elm$core$Maybe$Nothing,
											Aq: prefixe + '-confirmation',
											Bl: $author$project$I18n$Cles$bibliothequeListeElargirConfirmation(i18n),
											he: false
										},
										{vt: courant.dB, D9: msgs.j7})
									])),
								courant.qa ? A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('refus'),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$bibliothequeListeElargirRefus(i18n))
									])) : $rtfeldman$elm_css$Html$Styled$text('')
							]),
						h6: $author$project$I18n$Cles$bibliothequeListeElargirTitre(i18n)
					});
			} else {
				return vide;
			}
		}();
		return A5(
			$author$project$Components$Shared$Drawer$View$viewAvecPiedLibre,
			i18n,
			{
				oJ: $elm$core$Maybe$Just(
					$author$project$I18n$Cles$bibliothequeDefinitionDroitPartiesPrenantes(i18n)),
				HF: function (attributs) {
					return A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_Utils_ap(
							attributs,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									msgs.xU($author$project$Components$Shared$Drawer$Update$Fermer))
								])),
						$author$project$I18n$Cles$drawerAnnuler(i18n));
				},
				Jb: _List_Nil
			},
			msgs.xU,
			contenu,
			drawerModel);
	});
var $author$project$Components$Referentiel$Types$InformationsView$drawerElargirLaListe = F2(
	function (i18n, model) {
		return A5(
			$author$project$Components$Shared$Bibliotheque$ElargissementDeListe$view,
			i18n,
			{j7: $author$project$Components$Referentiel$Types$Update$ElargissementDeLaListeConfirme, xU: $author$project$Components$Referentiel$Types$Update$DuElargissementDeLaListe, Ku: $author$project$Components$Referentiel$Types$Update$ElargissementDeLaListeValide},
			$author$project$Components$Referentiel$Common$EnvoiDeType$enCours(model.l2),
			model.AM.gf,
			model.AM.ly);
	});
var $author$project$Components$Referentiel$Types$InformationsView$adresseDesValeursDuChamp = F2(
	function (fiche, cles) {
		var premiere = $author$project$Routes$Route$premierePage;
		var personnelle = function (cle) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dw;
						},
						$elm$core$List$any(
							function (lu) {
								return _Utils_eq(lu.uN.dy, cle) && lu.uN.xD;
							})),
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.aN;
						},
						fiche)));
		};
		var filtres = $author$project$Routes$Route$aucunFiltre;
		return A2(
			$elm$core$Maybe$andThen,
			function (lue) {
				return A2($elm$core$List$any, personnelle, cles) ? $elm$core$Maybe$Nothing : A2(
					$elm$core$Maybe$map,
					function (_v0) {
						return $author$project$Routes$Route$toString(
							$author$project$Routes$Route$PartiesPrenantesListe(
								_Utils_update(
									premiere,
									{
										mG: _Utils_update(
											filtres,
											{
												qs: cles,
												ib: _List_fromArray(
													[
														$author$project$Components$Referentiel$Identifiants$typeUidToString(lue.r0.r8)
													])
											})
									})));
					},
					A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$entites, lue.r0.gF));
			},
			fiche);
	});
var $author$project$I18n$Cles$collectionsTypeDroitPartiesPrenantes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'collections.type.droit-parties-prenantes', _List_Nil, 'Droit requis : Paramétrage des parties prenantes');
};
var $author$project$Components$Referentiel$Types$InformationsView$drawersDesCollections = F2(
	function (i18n, model) {
		var fiche = $author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model);
		return A4(
			$author$project$Components$Shared$CollectionsDuType$View$drawers,
			i18n,
			{
				s_: $author$project$Components$Referentiel$Types$InformationsView$adresseDesValeursDuChamp(fiche),
				xR: $author$project$I18n$Cles$collectionsTypeDroitPartiesPrenantes(i18n),
				cF: $author$project$Components$Referentiel$Common$EnvoiDeType$enCours(model.l2),
				Dp: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function (lue) {
							return lue.r0.R.zX;
						},
						fiche)),
				eA: true,
				KD: $author$project$Components$Referentiel$Types$Update$DesCollections
			},
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.vE;
					},
					fiche)),
			model.vE);
	});
var $author$project$Components$Referentiel$Types$Update$RechargementDemande = {$: 27};
var $author$project$Components$Referentiel$Types$View$concurrence = F2(
	function (i18n, concurrente) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('concurrence')
				]),
			concurrente ? _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Note$View$view,
					1,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielTypeConcurrente(i18n))
								]))
						])),
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Types$Model$idDuRechargement),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Types$Update$RechargementDemande)
						]),
					$author$project$I18n$Cles$referentielTypeRecharger(i18n))
				]) : _List_Nil);
	});
var $author$project$Components$Referentiel$Types$Update$RenommageOuvert = {$: 20};
var $author$project$Components$Referentiel$Types$Update$ArchivageAnnule = {$: 24};
var $author$project$Components$Referentiel$Types$Update$ArchivageConfirme = {$: 25};
var $author$project$Components$Referentiel$Types$Update$ArchivageDemande = {$: 23};
var $author$project$Components$Referentiel$Types$Update$RestaurationDemandee = {$: 26};
var $author$project$Components$Referentiel$Types$View$idDeLaQuestion = 'type-archivage-question';
var $author$project$Components$Referentiel$Types$View$archivage = F4(
	function (i18n, model, inactif, fiche) {
		var ids = $author$project$Components$Referentiel$Types$Model$idsDeLaConfirmation;
		var _v0 = _Utils_Tuple2(
			$author$project$Components$Referentiel$Types$Model$archivage(model),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ir;
				},
				model.bA));
		if (!_v0.a.$) {
			if ((!_v0.b.$) && _v0.b.a) {
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('archivage'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'group'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-labelledby', $author$project$Components$Referentiel$Types$View$idDeLaQuestion)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('question'),
										$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Types$View$idDeLaQuestion)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$referentielTypeArchivageTitre,
											i18n,
											{Dj: fiche.r0.R.zX}))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('message')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										(!fiche.r0.Id) ? $author$project$I18n$Cles$referentielTypeArchivageMessageSansRole(i18n) : A2(
											$author$project$I18n$Cles$referentielTypeArchivageMessage,
											i18n,
											{w: fiche.r0.Id}))
									])),
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								3,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id(ids.j7),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Types$Update$ArchivageConfirme),
										$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif),
										$rtfeldman$elm_css$Html$Styled$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('loading', inactif)
											]))
									]),
								$author$project$I18n$Cles$referentielTypeArchivageConfirmer(i18n)),
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id(ids.to),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Types$Update$ArchivageAnnule),
										$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif)
									]),
								$author$project$I18n$Cles$referentielTypeArchivageAnnuler(i18n))
							]))
					]);
			} else {
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielTypeArchiverNote(i18n))
							])),
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						3,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Types$Model$idDeLArchivage),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Types$Update$ArchivageDemande),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif),
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('loading', inactif)
									]))
							]),
						$author$project$I18n$Cles$referentielTypeArchiver(i18n))
					]);
			}
		} else {
			var _v1 = _v0.a;
			var _v2 = $author$project$Components$Referentiel$Types$Model$restauration(model);
			if (!_v2.$) {
				return _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Types$Model$idDeLaRestauration),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Types$Update$RestaurationDemandee),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif),
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('loading', inactif)
									]))
							]),
						$author$project$I18n$Cles$referentielTypeRestaurer(i18n))
					]);
			} else {
				return _List_Nil;
			}
		}
	});
var $author$project$I18n$Cles$referentielTypesOuvrirLaFiche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.ouvrir-la-fiche', _List_Nil, 'Ouvrir la fiche');
};
var $author$project$Components$Referentiel$Types$View$contenuDuType = F3(
	function (i18n, model, fiche) {
		var inactif = $author$project$Components$Referentiel$Types$Model$enAttente(model);
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Apparence$pastille,
							i18n,
							{kf: fiche.r0.kf, aC: fiche.r0.aC})
						]),
					fiche.r0.tE ? _List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							3,
							$author$project$I18n$Cles$referentielTypesArchive(i18n))
						]) : _List_Nil)),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('resume')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$Components$Referentiel$Common$ValeursDeType$resume, i18n, fiche))
					])),
				A2($author$project$Components$Referentiel$Common$ValeursDeType$view, i18n, fiche.r0),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
					]),
				_Utils_ap(
					function () {
						var _v0 = $author$project$Components$Referentiel$Types$Model$modification(model);
						if (!_v0.$) {
							return _List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Types$Model$idDuRenommer),
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Types$Update$RenommageOuvert),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif),
											$rtfeldman$elm_css$Html$Styled$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('loading', inactif)
												])),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'dialog')
										]),
									$author$project$I18n$Cles$referentielTypesRenommer(i18n))
								]);
						} else {
							return _List_Nil;
						}
					}(),
					_Utils_ap(
						A4($author$project$Components$Referentiel$Types$View$archivage, i18n, model, inactif, fiche),
						_List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$lien,
								1,
								$author$project$Routes$Route$toString(
									A2($author$project$Routes$Route$FicheTypeDePartiePrenante, fiche.r0.r8, 0)),
								$author$project$I18n$Cles$referentielTypesOuvrirLaFiche(i18n))
							]))))
			]);
	});
var $author$project$Components$Referentiel$Types$View$duType = F2(
	function (i18n, model) {
		var lu = A2(
			$elm$core$Maybe$andThen,
			function (consulte) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.r8;
							},
							$elm$core$Basics$eq(consulte.r8)),
						$author$project$Components$Referentiel$Types$Model$types(model)));
			},
			model.bA);
		var fiche = $author$project$Components$Referentiel$Types$Model$typeConsulte(model);
		return A4(
			$author$project$Components$Shared$Drawer$View$consultation,
			i18n,
			$author$project$Components$Referentiel$Types$Update$DeLaConsultation,
			{
				fZ: function () {
					var _v0 = model.bA;
					if (!_v0.$) {
						var consulte = _v0.a;
						return _List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Messages$View$view,
								i18n,
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2($elm$core$Maybe$map, $elm$core$List$singleton, consulte.pZ))),
								A2($author$project$Components$Referentiel$Types$View$concurrence, i18n, consulte.fW),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('type-consulte'),
										$rtfeldman$elm_css$Html$Styled$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'loading',
												_Utils_eq(fiche, $elm$core$Maybe$Nothing))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
										'aria-busy',
										_Utils_eq(fiche, $elm$core$Maybe$Nothing) ? 'true' : 'false')
									]),
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										A2($author$project$Components$Referentiel$Types$View$contenuDuType, i18n, model),
										fiche)))
							]);
					} else {
						return _List_Nil;
					}
				}(),
				G8: $author$project$Components$Shared$Drawer$Model$estOuvert(model.hL),
				h6: function () {
					var _v1 = _Utils_Tuple2(fiche, lu);
					if (!_v1.a.$) {
						var servie = _v1.a.a;
						return servie.r0.R.zX;
					} else {
						if (!_v1.b.$) {
							var _v2 = _v1.a;
							var dansLAnnuaire = _v1.b.a;
							return dansLAnnuaire.R.zX;
						} else {
							var _v3 = _v1.a;
							var _v4 = _v1.b;
							return '';
						}
					}
				}()
			},
			model.j9);
	});
var $author$project$I18n$Cles$parcoursEtapeBientot = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'parcours.etape.bientot', _List_Nil, 'Cette étape arrive bientôt.');
};
var $author$project$Components$Shared$Parcours$View$bientot = function (i18n) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$p,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('bientot')
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$I18n$Cles$parcoursEtapeBientot(i18n))
			]));
};
var $author$project$Components$Referentiel$Types$Update$RelectureDuTypeRegleDemandee = {$: 49};
var $author$project$Components$Referentiel$Types$View$echecDeLaLecture = F2(
	function (i18n, model) {
		var _v0 = model.x1;
		if (!_v0.$) {
			var echec = _v0.a;
			return _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Messages$View$view,
					i18n,
					_List_fromArray(
						[echec])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('relire')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Types$Update$RelectureDuTypeRegleDemandee)
								]),
							$author$project$I18n$Cles$referentielTypeRecharger(i18n))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Referentiel$Types$Chemin$NouveauResultat = {$: 3};
var $author$project$Components$Referentiel$Types$Chemin$NouveauStatut = {$: 2};
var $author$project$Components$Referentiel$Types$Update$CheminOuvert = function (a) {
	return {$: 50, a: a};
};
var $author$project$Components$Referentiel$Types$CheminView$ajouter = F3(
	function (gestes, element, libelle) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ajouter')
				]),
			gestes.nB ? _List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id(
							$author$project$Components$Referentiel$Types$Model$idDuDeclencheurDuChemin(element)),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('add'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Referentiel$Types$Update$CheminOuvert(element)),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(gestes.d3),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('loading', gestes.d3)
								])),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'dialog')
						]),
					libelle)
				]) : _List_Nil);
	});
var $author$project$I18n$Cles$referentielCheminResultats = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.chemin.resultats', _List_Nil, 'Résultats, quand le rôle se clôt');
};
var $author$project$I18n$Cles$referentielCheminStatuts = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.chemin.statuts', _List_Nil, 'Statuts, tant que le rôle est ouvert');
};
var $author$project$Components$Referentiel$Types$Chemin$Resultat = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Referentiel$Types$CheminView$nom = F3(
	function (gestes, element, libelle) {
		return gestes.nB ? A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('nom'),
					$rtfeldman$elm_css$Html$Styled$Attributes$id(
					$author$project$Components$Referentiel$Types$Model$idDuDeclencheurDuChemin(element)),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Components$Referentiel$Types$Update$CheminOuvert(element)),
					$rtfeldman$elm_css$Html$Styled$Attributes$disabled(gestes.d3),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'dialog')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(libelle)
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(libelle)
				]));
	});
var $author$project$I18n$Cles$referentielCheminSysteme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.chemin.systeme', _List_Nil, '(système)');
};
var $author$project$I18n$Cles$referentielCheminRetire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.chemin.retire', _List_Nil, 'Retiré');
};
var $author$project$Components$Referentiel$Types$CheminView$retire = F2(
	function (i18n, estRetire) {
		return estRetire ? _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Tag$View$view,
				3,
				$author$project$I18n$Cles$referentielCheminRetire(i18n))
			]) : _List_Nil;
	});
var $author$project$Components$Referentiel$Types$CheminView$resultat = F3(
	function (i18n, gestes, lu) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('element'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('systeme', lu.rv),
							_Utils_Tuple2('retire', lu.HZ)
						]))
				]),
			_Utils_ap(
				lu.rv ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$Components$Referentiel$Types$Chemin$libelleDuResultat, i18n, lu))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('systeme')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielCheminSysteme(i18n))
							]))
					]) : _List_fromArray(
					[
						A3(
						$author$project$Components$Referentiel$Types$CheminView$nom,
						gestes,
						$author$project$Components$Referentiel$Types$Chemin$Resultat(lu.Aq),
						A2($author$project$Components$Referentiel$Types$Chemin$libelleDuResultat, i18n, lu))
					]),
				A2($author$project$Components$Referentiel$Types$CheminView$retire, i18n, lu.HZ)));
	});
var $author$project$Components$Referentiel$Types$Chemin$Statut = function (a) {
	return {$: 0, a: a};
};
var $author$project$I18n$Cles$referentielCheminDepart = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.chemin.depart', _List_Nil, 'statut de départ');
};
var $author$project$I18n$Cles$referentielCheminRoles = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.chemin.roles',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' rôle') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' rôles'));
	});
var $author$project$Components$Referentiel$Types$CheminView$statut = F3(
	function (i18n, gestes, lu) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('element'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('initial', lu.AO),
							_Utils_Tuple2('retire', lu.HZ)
						]))
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A3(
						$author$project$Components$Referentiel$Types$CheminView$nom,
						gestes,
						$author$project$Components$Referentiel$Types$Chemin$Statut(lu.Aq),
						lu.R.zX)
					]),
				_Utils_ap(
					lu.AO ? _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('depart')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielCheminDepart(i18n))
								]))
						]) : _List_Nil,
					_Utils_ap(
						(lu.Kg > 0) ? _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('roles')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												'· ' + A2(
													$author$project$I18n$Nombre$formater,
													$author$project$I18n$Traductions$langue(i18n),
													lu.Kg))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('lecture')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$referentielCheminRoles,
													i18n,
													{w: lu.Kg}))
											]))
									]))
							]) : _List_Nil,
						A2($author$project$Components$Referentiel$Types$CheminView$retire, i18n, lu.HZ)))));
	});
var $author$project$Components$Referentiel$Types$CheminView$cartes = F3(
	function (i18n, model, fiche) {
		var gestes = function (element) {
			return {
				d3: $author$project$Components$Referentiel$Types$Model$enAttente(model),
				nB: !_Utils_eq(
					A2($author$project$Components$Referentiel$Types$Model$lienDuChemin, element, model),
					$elm$core$Maybe$Nothing)
			};
		};
		var desStatuts = gestes($author$project$Components$Referentiel$Types$Chemin$NouveauStatut);
		var desResultats = gestes($author$project$Components$Referentiel$Types$Chemin$NouveauResultat);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('cartes')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('carte'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('statuts')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielCheminStatuts(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$ol,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('elements')
								]),
							A2(
								$elm$core$List$map,
								A2($author$project$Components$Referentiel$Types$CheminView$statut, i18n, desStatuts),
								$author$project$Components$Referentiel$Types$Chemin$statutsAffiches(fiche.I1))),
							A3(
							$author$project$Components$Referentiel$Types$CheminView$ajouter,
							desStatuts,
							$author$project$Components$Referentiel$Types$Chemin$NouveauStatut,
							$author$project$I18n$Cles$referentielCheminAjouterStatut(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('carte'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('resultats')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielCheminResultats(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('elements')
								]),
							A2(
								$elm$core$List$map,
								A2($author$project$Components$Referentiel$Types$CheminView$resultat, i18n, desResultats),
								$author$project$Components$Referentiel$Types$Chemin$resultatsAffiches(fiche.bh))),
							A3(
							$author$project$Components$Referentiel$Types$CheminView$ajouter,
							desResultats,
							$author$project$Components$Referentiel$Types$Chemin$NouveauResultat,
							$author$project$I18n$Cles$referentielCheminAjouterResultat(i18n))
						]))
				]));
	});
var $author$project$I18n$Cles$referentielParcoursStatutsNoteCloture = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.statuts.note.cloture', _List_Nil, 'On choisit un résultat au moment de clore son rôle.');
};
var $author$project$I18n$Cles$referentielParcoursStatutsNoteDepart = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parcours.statuts.note.depart',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'statut',
					$author$project$I18n$Traductions$Chaine(p.ri))
				]),
			'Tout nouveau fournisseur commence « ' + (p.ri + ' ».'));
	});
var $author$project$I18n$Cles$referentielParcoursStatutsNoteDepartType = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parcours.statuts.note.depart-type',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj)),
					_Utils_Tuple2(
					'statut',
					$author$project$I18n$Traductions$Chaine(p.ri))
				]),
			'Tout nouveau rôle « ' + (p.Dj + (' » commence « ' + (p.ri + ' ».'))));
	});
var $author$project$Components$Referentiel$Types$Parcours$noteChemin = F3(
	function (i18n, regle, depart) {
		var premiere = function () {
			var _v0 = _Utils_Tuple2(regle, depart);
			if ((!_v0.a.$) && (!_v0.b.$)) {
				var libelle = _v0.a.a;
				var statut = _v0.b.a;
				return _Utils_eq(
					libelle,
					$author$project$I18n$Cles$referentielArchetypeFournisseur(i18n)) ? _List_fromArray(
					[
						A2(
						$author$project$I18n$Cles$referentielParcoursStatutsNoteDepart,
						i18n,
						{ri: statut})
					]) : _List_fromArray(
					[
						A2(
						$author$project$I18n$Cles$referentielParcoursStatutsNoteDepartType,
						i18n,
						{Dj: libelle, ri: statut})
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$elm$core$String$join,
			' ',
			_Utils_ap(
				premiere,
				_List_fromArray(
					[
						$author$project$I18n$Cles$referentielParcoursStatutsNoteCloture(i18n)
					])));
	});
var $author$project$Components$Referentiel$Types$CheminView$etape = F3(
	function (i18n, echec, model) {
		var fiche = $author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model);
		var enChargement = (!_Utils_eq(
			$author$project$Components$Referentiel$Types$Model$typeRegle(model),
			$elm$core$Maybe$Nothing)) && (_Utils_eq(fiche, $elm$core$Maybe$Nothing) && _Utils_eq(model.x1, $elm$core$Maybe$Nothing));
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('chemin')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('loading', enChargement)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-busy',
							enChargement ? 'true' : 'false')
						]),
					_Utils_ap(
						function () {
							if (!fiche.$) {
								var lue = fiche.a;
								return _List_fromArray(
									[
										A3($author$project$Components$Referentiel$Types$CheminView$cartes, i18n, model, lue)
									]);
							} else {
								return echec;
							}
						}(),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A3(
											$author$project$Components$Referentiel$Types$Parcours$noteChemin,
											i18n,
											A2(
												$elm$core$Maybe$map,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.R;
													},
													function ($) {
														return $.zX;
													}),
												$author$project$Components$Referentiel$Types$Model$typeRegle(model)),
											A2(
												$elm$core$Maybe$map,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.R;
													},
													function ($) {
														return $.zX;
													}),
												A2(
													$elm$core$Maybe$andThen,
													A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.I1;
														},
														$author$project$Components$Referentiel$Types$Chemin$statutDeDepart),
													fiche))))
									]))
							])))
				]));
	});
var $author$project$Components$Referentiel$Types$Update$InformationOuverte = {$: 54};
var $author$project$Components$Referentiel$Types$InformationsView$ajouter = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ajouter')
				]),
			(!_Utils_eq(
				$author$project$Components$Referentiel$Types$Model$lienDesInformations(model),
				$elm$core$Maybe$Nothing)) ? _List_fromArray(
				[
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Types$Model$idDeLAjoutDUneInformation),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('add'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Types$Update$InformationOuverte),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
							$author$project$Components$Referentiel$Types$Model$enAttente(model)),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'loading',
									$author$project$Components$Referentiel$Types$Model$enAttente(model))
								])),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'dialog')
						]),
					$author$project$I18n$Cles$referentielInformationsAjouter(i18n))
				]) : _List_Nil);
	});
var $author$project$Components$Referentiel$Types$Update$HistoriqueDemande = {$: 76};
var $author$project$Components$Referentiel$Types$Update$InformationConsultee = function (a) {
	return {$: 62, a: a};
};
var $author$project$Components$Referentiel$Types$Informations$masquees = function (fiche) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.dw;
				},
				$elm$core$List$filter(
					function ($) {
						return $.n4;
					})),
			fiche.aN));
};
var $author$project$I18n$Cles$referentielInformationsHistorique = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.informations.historique', _List_Nil, 'Historique des versions');
};
var $author$project$I18n$Cles$referentielInformationsMasquee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.informations.masquee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'« ' + (p.Dj + ' » masquée'));
	});
var $author$project$Components$Referentiel$Types$InformationsView$autres = F3(
	function (i18n, _v0, fiche) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('autres')
				]),
			_Utils_ap(
				A2(
					$elm$core$List$map,
					function (lu) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('masquee'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id(
									$author$project$Components$Referentiel$Types$Model$idDUneInformation(lu.uN.dy)),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Referentiel$Types$Update$InformationConsultee(lu.uN.dy)),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
									_Utils_eq(
										A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$afficherUnChamp, lu.nQ),
										$elm$core$Maybe$Nothing)),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'dialog')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$referentielInformationsMasquee,
										i18n,
										{Dj: lu.uN.Bl}))
								]));
					},
					$author$project$Components$Referentiel$Types$Informations$masquees(fiche)),
				(!_Utils_eq(
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$versionsDuSchema, fiche.r0.nQ),
					$elm$core$Maybe$Nothing)) ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('historique'),
								$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Referentiel$Types$Model$idDeLHistorique),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Types$Update$HistoriqueDemande),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'dialog')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$referentielInformationsHistorique(i18n))
							]))
					]) : _List_Nil));
	});
var $author$project$Components$Referentiel$Types$InformationsView$contenuDeLaLigne = F3(
	function (i18n, origine, lu) {
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(lu.uN.Bl)
							])),
					_Utils_ap(
						lu.uN.xD ? _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('repere')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielInformationsPersonnelle(i18n))
									]))
							]) : _List_Nil,
						function () {
							if (!origine.$) {
								var dit = origine.a;
								return _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('origine')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Components$Shared$Tag$View$view,
												dit.hm ? 5 : 3,
												dit.Jx)
											]))
									]);
							} else {
								return _List_Nil;
							}
						}()))),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('nature')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$referentielInformationsLigne,
							i18n,
							{
								mo: A2($author$project$Components$Referentiel$Types$Informations$exigence, i18n, lu.uN),
								g1: A2($author$project$Components$Referentiel$Types$Informations$nature, i18n, lu)
							})),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('chevron'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('›')
							]))
					]))
			]);
	});
var $author$project$Components$Referentiel$Types$InformationsView$information = F4(
	function (i18n, modifiable, origine, lu) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('information'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('personnelle', lu.uN.xD)
						]))
				]),
			_List_fromArray(
				[
					(modifiable ? $rtfeldman$elm_css$Html$Styled$button(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(
							$author$project$Components$Referentiel$Types$Model$idDUneInformation(lu.uN.dy)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Referentiel$Types$Update$InformationConsultee(lu.uN.dy)),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'dialog')
						])) : $rtfeldman$elm_css$Html$Styled$div(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne')
						])))(
					A3($author$project$Components$Referentiel$Types$InformationsView$contenuDeLaLigne, i18n, origine, lu))
				]));
	});
var $author$project$Components$Referentiel$Types$InformationsView$origineDuChamp = F3(
	function (i18n, fiche, cle) {
		return A2(
			$elm$core$Maybe$map,
			function (lu) {
				return lu.hm ? {
					hm: true,
					Jx: A2(
						$author$project$I18n$Cles$editeurDeSchemaOrigineBibliotheque,
						i18n,
						{w: lu.sf})
				} : {
					hm: false,
					Jx: $author$project$I18n$Cles$editeurDeSchemaOriginePropre(i18n)
				};
			},
			A2($elm$core$Dict$get, cle, fiche.dq));
	});
var $author$project$Components$Referentiel$Types$InformationsView$liste = F3(
	function (i18n, model, fiche) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$ul,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('informations')
				]),
			A2(
				$elm$core$List$map,
				function (lu) {
					return A4(
						$author$project$Components$Referentiel$Types$InformationsView$information,
						i18n,
						!_Utils_eq(
							$author$project$Components$Referentiel$Types$Model$lienDesInformations(model),
							$elm$core$Maybe$Nothing),
						A3($author$project$Components$Referentiel$Types$InformationsView$origineDuChamp, i18n, fiche, lu.uN.dy),
						lu);
				},
				$author$project$Components$Referentiel$Types$Informations$demandees(fiche)));
	});
var $author$project$I18n$Cles$referentielInformationsEncadreFort = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.informations.encadre.fort', _List_Nil, 'Donnée personnelle');
};
var $author$project$I18n$Cles$referentielInformationsEncadreSuite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.informations.encadre.suite', _List_Nil, ' : à cocher si l\'information permet d\'identifier une personne. Elle est alors chiffrée à part et effacée si la personne le demande. Le choix se fait à la création : on ne peut plus le cocher ensuite, ni le décocher une fois l\'information remplie.');
};
var $author$project$I18n$Cles$referentielInformationsNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.informations.note', _List_Nil, 'Cliquez une information pour la renommer, régler sa saisie, la déplacer ou la masquer. Une information masquée garde ce qui a été saisi.');
};
var $author$project$Components$Referentiel$Types$InformationsView$etape = F3(
	function (i18n, echec, model) {
		var fiche = $author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model);
		var enChargement = (!_Utils_eq(
			$author$project$Components$Referentiel$Types$Model$typeRegle(model),
			$elm$core$Maybe$Nothing)) && (_Utils_eq(fiche, $elm$core$Maybe$Nothing) && _Utils_eq(model.x1, $elm$core$Maybe$Nothing));
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('schema-du-type')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('loading', enChargement)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-busy',
							enChargement ? 'true' : 'false')
						]),
					_Utils_ap(
						function () {
							if (!fiche.$) {
								var lue = fiche.a;
								return _List_fromArray(
									[
										A3($author$project$Components$Referentiel$Types$InformationsView$liste, i18n, model, lue),
										A3($author$project$Components$Referentiel$Types$InformationsView$autres, i18n, model, lue),
										A2($author$project$Components$Referentiel$Types$InformationsView$ajouter, i18n, model),
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$referentielInformationsNote(i18n))
											])),
										A3(
										$author$project$Components$Shared$CollectionsDuType$View$carte,
										i18n,
										{
											Ek: A2(
												$elm$core$Maybe$map,
												function (lien) {
													return $author$project$Components$Referentiel$Types$Update$DesBlocs(
														$author$project$Components$Shared$OrdreDesBlocs$Update$Demander(lien));
												},
												A2(
													$elm$core$Maybe$andThen,
													function (_v1) {
														return A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ordreDesBlocs, lue.r0.nQ);
													},
													A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ordonnerLesBlocs, lue.r0.nQ))),
											Fj: !_Utils_eq(
												A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ajouterUneCollectionAUnType, lue.r0.nQ),
												$elm$core$Maybe$Nothing),
											Fo: !_Utils_eq(
												A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerUneCollectionDUnType, lue.r0.nQ),
												$elm$core$Maybe$Nothing),
											KD: $author$project$Components$Referentiel$Types$Update$DesCollections
										},
										lue.vE)
									]);
							} else {
								return echec;
							}
						}(),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('encadre')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$strong,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$referentielInformationsEncadreFort(i18n))
											])),
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielInformationsEncadreSuite(i18n))
									]))
							])))
				]));
	});
var $author$project$Components$Referentiel$Types$Update$SeulementCesOffresChoisies = {$: 34};
var $author$project$Components$Referentiel$Types$Update$ToutesLesOffresChoisies = {$: 33};
var $author$project$Components$Referentiel$Types$OffresView$catalogueVide = function (i18n) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('limite'),
				$rtfeldman$elm_css$Html$Styled$Attributes$class('catalogue-vide')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$referentielParcoursOffresCatalogueVide(i18n))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
						$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Routes$Route$adresseCatalogue)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$referentielParcoursOffresCatalogueOuvrir(i18n))
					]))
			]));
};
var $author$project$Components$Referentiel$Types$OffresView$choix = function (fourni) {
	var identifiant = 'offres-' + fourni.Dj;
	return A2(
		$rtfeldman$elm_css$Html$Styled$label,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('choix'),
				$rtfeldman$elm_css$Html$Styled$Attributes$for(identifiant),
				$rtfeldman$elm_css$Html$Styled$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('retenu', fourni.HY)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$input,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
						$rtfeldman$elm_css$Html$Styled$Attributes$id(identifiant),
						$rtfeldman$elm_css$Html$Styled$Attributes$name(fourni.m2),
						$rtfeldman$elm_css$Html$Styled$Attributes$checked(fourni.HY),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(fourni.d3),
						$rtfeldman$elm_css$Html$Styled$Events$onCheck(
						function (_v0) {
							return fourni.C$;
						})
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(fourni.Bl)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(fourni.bp)
							]))
					]))
			]));
};
var $author$project$Components$Referentiel$Types$Update$InterdictionChoisie = function (a) {
	return {$: 35, a: a};
};
var $author$project$Components$Referentiel$Types$OffresView$choixDeLInterdiction = F6(
	function (i18n, fiche, attente, valeur, libelle, aide) {
		return $author$project$Components$Referentiel$Types$OffresView$choix(
			{
				bp: aide,
				m2: 'interdiction',
				d3: attente || _Utils_eq(
					$author$project$Components$Referentiel$Types$Offres$lienDeLInterdiction(fiche),
					$elm$core$Maybe$Nothing),
				Bl: libelle,
				C$: $author$project$Components$Referentiel$Types$Update$InterdictionChoisie(valeur),
				Dj: valeur ? 'interdiction-oui' : 'interdiction-non',
				HY: _Utils_eq(fiche.AR, valeur)
			});
	});
var $author$project$Components$Referentiel$Types$Update$PerimetreOuvert = {$: 42};
var $author$project$Components$Referentiel$Types$OffresView$choisirUnPerimetre = F3(
	function (libelle, attente, fiche) {
		return ((!_Utils_eq(
			$author$project$Components$Referentiel$Types$Offres$lienDeLaLimite(fiche),
			$elm$core$Maybe$Nothing)) && (!_Utils_eq(
			A2($author$project$Components$Referentiel$Types$Offres$lienDesPerimetres, '', fiche),
			$elm$core$Maybe$Nothing))) ? A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
					$rtfeldman$elm_css$Html$Styled$Attributes$disabled(attente),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'dialog'),
					$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Types$Update$PerimetreOuvert)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(libelle)
				])) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$Components$Referentiel$Types$Update$OffresOuvertes = {$: 36};
var $author$project$I18n$Cles$referentielParcoursOffresChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.choisir', _List_Nil, 'Choisir des offres');
};
var $author$project$I18n$Cles$referentielParcoursOffresModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.modifier', _List_Nil, 'Modifier les offres');
};
var $author$project$Components$Referentiel$Types$OffresView$modifier = F3(
	function (i18n, fiche, attente) {
		var _v0 = $author$project$Components$Referentiel$Types$Offres$lienDeLaLimite(fiche);
		if (!_v0.$) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('pointille'),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(attente),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'dialog'),
						$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Referentiel$Types$Update$OffresOuvertes)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$elm$core$List$isEmpty(fiche.D3) ? $author$project$I18n$Cles$referentielParcoursOffresChoisir(i18n) : $author$project$I18n$Cles$referentielParcoursOffresModifier(i18n))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Referentiel$Types$OffresView$pastilleDOffre = F2(
	function (i18n, offre) {
		var nom = A2($elm$core$Maybe$withDefault, offre.Aq, offre.Dj);
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('arretee', offre.tL)
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					offre.tL ? A2(
						$author$project$I18n$Cles$referentielTypeLimiteOffreArretee,
						i18n,
						{Dj: nom}) : nom)
				]));
	});
var $author$project$I18n$Cles$referentielParcoursOffresPerimetreArchive = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.perimetre.archive', _List_Nil, 'Archivé');
};
var $author$project$I18n$Cles$referentielParcoursOffresPerimetreVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.perimetre.vide', _List_Nil, 'Aucune offre n\'entre dans ce périmètre pour le moment : les rôles avec une offre attendront qu\'une offre y entre.');
};
var $author$project$Components$Referentiel$Types$OffresView$perimetre = F2(
	function (i18n, lu) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('perimetre-cite'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('archive', lu.tE)
						]))
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($elm$core$Maybe$withDefault, lu.r8, lu.Dj))
							]))
					]),
				_Utils_ap(
					function () {
						var _v0 = lu.wT;
						if (!_v0.$) {
							var nombre = _v0.a;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('decompte')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$referentielParcoursOffresPerimetreDecompte,
												i18n,
												{w: nombre}))
										]))
								]);
						} else {
							return _List_Nil;
						}
					}(),
					_Utils_ap(
						lu.tE ? _List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Tag$View$view,
								3,
								$author$project$I18n$Cles$referentielParcoursOffresPerimetreArchive(i18n))
							]) : _List_Nil,
						_Utils_eq(
							lu.wT,
							$elm$core$Maybe$Just(0)) ? _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$referentielParcoursOffresPerimetreVide(i18n))
									]))
							]) : _List_Nil))));
	});
var $author$project$I18n$Cles$referentielParcoursOffresChoisies = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.choisies', _List_Nil, 'Offres choisies une à une');
};
var $author$project$I18n$Cles$referentielParcoursOffresChoisiesAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.choisies.aucune', _List_Nil, 'Aucune offre choisie');
};
var $author$project$I18n$Cles$referentielParcoursOffresPerimetre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.perimetre', _List_Nil, 'Périmètre d\'offres');
};
var $author$project$I18n$Cles$referentielParcoursOffresPerimetreAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.perimetre.aucun', _List_Nil, 'Aucun périmètre');
};
var $author$project$I18n$Cles$referentielParcoursOffresPerimetreChanger = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.perimetre.changer', _List_Nil, 'Changer de périmètre');
};
var $author$project$I18n$Cles$referentielParcoursOffresPerimetreChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.perimetre.choisir', _List_Nil, 'Choisir un périmètre');
};
var $author$project$Components$Referentiel$Types$OffresView$limite = F3(
	function (i18n, attente, fiche) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('limite')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('offres-choisies')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielParcoursOffresChoisies(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne-pastilles')
								]),
							_List_fromArray(
								[
									$elm$core$List$isEmpty(fiche.D3) ? A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('aucune')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$referentielParcoursOffresChoisiesAucune(i18n))
										])) : A2(
									$rtfeldman$elm_css$Html$Styled$ul,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('pastilles')
										]),
									A2(
										$elm$core$List$map,
										$author$project$Components$Referentiel$Types$OffresView$pastilleDOffre(i18n),
										fiche.D3)),
									A3($author$project$Components$Referentiel$Types$OffresView$modifier, i18n, fiche, attente)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('perimetre')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielParcoursOffresPerimetre(i18n))
								])),
							function () {
							var _v0 = fiche.E9;
							if (!_v0.$) {
								var lu = _v0.a;
								return A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('sans-perimetre')
										]),
									_List_fromArray(
										[
											A2($author$project$Components$Referentiel$Types$OffresView$perimetre, i18n, lu),
											A3(
											$author$project$Components$Referentiel$Types$OffresView$choisirUnPerimetre,
											$author$project$I18n$Cles$referentielParcoursOffresPerimetreChanger(i18n),
											attente,
											fiche)
										]));
							} else {
								return A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('sans-perimetre')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('aucun')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$referentielParcoursOffresPerimetreAucun(i18n))
												])),
											A3(
											$author$project$Components$Referentiel$Types$OffresView$choisirUnPerimetre,
											$author$project$I18n$Cles$referentielParcoursOffresPerimetreChoisir(i18n),
											attente,
											fiche)
										]));
							}
						}()
						]))
				]));
	});
var $author$project$Components$Referentiel$Types$OffresView$limiteImpossible = function (fiche) {
	return _Utils_eq(
		$author$project$Components$Referentiel$Types$Offres$lienDeLaLimite(fiche),
		$elm$core$Maybe$Nothing);
};
var $author$project$I18n$Cles$referentielParcoursOffresAdmises = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.admises', _List_Nil, 'Offres admises');
};
var $author$project$I18n$Cles$referentielParcoursOffresInterdireNon = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.interdire.non', _List_Nil, 'Non');
};
var $author$project$I18n$Cles$referentielParcoursOffresInterdireNonAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.interdire.non.aide', _List_Nil, 'Le rôle peut être attribué même si aucune offre ne lui correspond.');
};
var $author$project$I18n$Cles$referentielParcoursOffresInterdireOui = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.interdire.oui', _List_Nil, 'Oui');
};
var $author$project$I18n$Cles$referentielParcoursOffresInterdireOuiAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.interdire.oui.aide', _List_Nil, 'Le rôle doit porter une offre admise ci-dessus, sinon il est refusé.');
};
var $author$project$I18n$Cles$referentielParcoursOffresInterdireTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.interdire.titre', _List_Nil, 'Interdire l\'attribution du rôle si aucune offre ne lui correspond');
};
var $author$project$I18n$Cles$referentielParcoursOffresSeulement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.seulement', _List_Nil, 'Seulement ces offres');
};
var $author$project$I18n$Cles$referentielParcoursOffresSeulementAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.seulement.aide', _List_Nil, 'Choisissez des offres une à une, un périmètre d\'offres, ou les deux.');
};
var $author$project$I18n$Cles$referentielParcoursOffresToutes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.toutes', _List_Nil, 'Toutes les offres');
};
var $author$project$I18n$Cles$referentielParcoursOffresToutesAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.toutes.aide', _List_Nil, 'Le rôle peut porter n\'importe quelle offre de service du catalogue.');
};
var $author$project$Components$Referentiel$Types$OffresView$contenu = F3(
	function (i18n, model, fiche) {
		var seulement = A2($author$project$Components$Referentiel$Types$Offres$seulement, model.e2, fiche);
		var attente = $author$project$Components$Referentiel$Types$Model$enAttente(model);
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$fieldset,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('groupe'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('admises')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$legend,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$referentielParcoursOffresAdmises(i18n))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('reponses')
								]),
							_List_fromArray(
								[
									$author$project$Components$Referentiel$Types$OffresView$choix(
									{
										bp: $author$project$I18n$Cles$referentielParcoursOffresToutesAide(i18n),
										m2: 'admises',
										d3: attente || ($author$project$Components$Referentiel$Types$OffresView$limiteImpossible(fiche) && $author$project$Components$Referentiel$Types$Offres$limitee(fiche)),
										Bl: $author$project$I18n$Cles$referentielParcoursOffresToutes(i18n),
										C$: $author$project$Components$Referentiel$Types$Update$ToutesLesOffresChoisies,
										Dj: 'toutes',
										HY: !seulement
									}),
									$author$project$Components$Referentiel$Types$OffresView$choix(
									{
										bp: $author$project$I18n$Cles$referentielParcoursOffresSeulementAide(i18n),
										m2: 'admises',
										d3: attente || _Utils_eq(
											$author$project$Components$Referentiel$Types$Offres$lienDeLaLimite(fiche),
											$elm$core$Maybe$Nothing),
										Bl: $author$project$I18n$Cles$referentielParcoursOffresSeulement(i18n),
										C$: $author$project$Components$Referentiel$Types$Update$SeulementCesOffresChoisies,
										Dj: 'seulement',
										HY: seulement
									})
								])),
							(!seulement) ? $rtfeldman$elm_css$Html$Styled$text('') : ((_Utils_eq(
							model.D4,
							$author$project$Components$Referentiel$Common$Offres$Lue(_List_Nil)) && (!$author$project$Components$Shared$Drawer$Model$estOuvert(model.jQ))) ? $author$project$Components$Referentiel$Types$OffresView$catalogueVide(i18n) : A3($author$project$Components$Referentiel$Types$OffresView$limite, i18n, attente, fiche))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$fieldset,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('groupe'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('interdiction')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$legend,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$referentielParcoursOffresInterdireTitre(i18n))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('reponses')
								]),
							_List_fromArray(
								[
									A6(
									$author$project$Components$Referentiel$Types$OffresView$choixDeLInterdiction,
									i18n,
									fiche,
									attente,
									false,
									$author$project$I18n$Cles$referentielParcoursOffresInterdireNon(i18n),
									$author$project$I18n$Cles$referentielParcoursOffresInterdireNonAide(i18n)),
									A6(
									$author$project$Components$Referentiel$Types$OffresView$choixDeLInterdiction,
									i18n,
									fiche,
									attente,
									true,
									$author$project$I18n$Cles$referentielParcoursOffresInterdireOui(i18n),
									$author$project$I18n$Cles$referentielParcoursOffresInterdireOuiAide(i18n))
								])),
							($author$project$Components$Shared$Drawer$Model$estOuvert(model.jR) || $author$project$Components$Shared$Drawer$Model$estOuvert(model.jQ)) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
							$author$project$Components$Shared$Messages$View$view,
							i18n,
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2($elm$core$Maybe$map, $elm$core$List$singleton, model.p5)))
						]))
				]));
	});
var $author$project$I18n$Cles$referentielParcoursPorteursNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.porteurs.note', _List_Nil, 'Ces choix valent pour les nouveaux rôles. Les fournisseurs déjà enregistrés le restent.');
};
var $author$project$I18n$Cles$referentielParcoursPorteursNoteSansType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.porteurs.note.sans-type', _List_Nil, 'Ces choix valent pour les nouveaux rôles. Ceux déjà enregistrés le restent.');
};
var $author$project$I18n$Cles$referentielParcoursPorteursNoteType = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parcours.porteurs.note.type',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Ces choix valent pour les nouveaux rôles. Les rôles « ' + (p.Dj + ' » déjà enregistrés le restent.'));
	});
var $author$project$Components$Referentiel$Types$Parcours$notePorteurs = F2(
	function (i18n, regle) {
		if (!regle.$) {
			var libelle = regle.a;
			return _Utils_eq(
				libelle,
				$author$project$I18n$Cles$referentielArchetypeFournisseur(i18n)) ? $author$project$I18n$Cles$referentielParcoursPorteursNote(i18n) : A2(
				$author$project$I18n$Cles$referentielParcoursPorteursNoteType,
				i18n,
				{Dj: libelle});
		} else {
			return $author$project$I18n$Cles$referentielParcoursPorteursNoteSansType(i18n);
		}
	});
var $author$project$Components$Referentiel$Types$OffresView$etape = F3(
	function (i18n, echec, model) {
		var fiche = $author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model);
		var enChargement = (!_Utils_eq(
			$author$project$Components$Referentiel$Types$Model$typeRegle(model),
			$elm$core$Maybe$Nothing)) && (_Utils_eq(fiche, $elm$core$Maybe$Nothing) && _Utils_eq(model.x1, $elm$core$Maybe$Nothing));
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('offres')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('loading', enChargement)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-busy',
							enChargement ? 'true' : 'false')
						]),
					_Utils_ap(
						function () {
							if (!fiche.$) {
								var lue = fiche.a;
								return A3($author$project$Components$Referentiel$Types$OffresView$contenu, i18n, model, lue);
							} else {
								return echec;
							}
						}(),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$Components$Referentiel$Types$Parcours$notePorteurs,
											i18n,
											A2(
												$elm$core$Maybe$map,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.R;
													},
													function ($) {
														return $.zX;
													}),
												$author$project$Components$Referentiel$Types$Model$typeRegle(model))))
									]))
							])))
				]));
	});
var $author$project$I18n$Cles$referentielParcoursInformationsExplicationDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.informations.explication.debut', _List_Nil, 'Ces ');
};
var $author$project$I18n$Cles$referentielParcoursInformationsExplicationFin = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parcours.informations.explication.fin',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			' s\'ajoutent à celles de toute fiche (nom, adresse, contacts). Elles se rempliront dans le bloc « ' + (p.Dj + ' » de la fiche.'));
	});
var $author$project$I18n$Cles$referentielParcoursInformationsExplicationFinSansType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.informations.explication.fin.sans-type', _List_Nil, ' s\'ajoutent à celles de toute fiche (nom, adresse, contacts). Elles se rempliront dans le bloc du rôle, sur la fiche.');
};
var $author$project$I18n$Cles$referentielParcoursInformationsExplicationFort = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.informations.explication.fort', _List_Nil, 'informations');
};
var $author$project$I18n$Cles$referentielParcoursOffresExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.explication', _List_Nil, 'Dites quelles offres de service ce rôle peut porter. Le rôle ne sera accepté que pour celles-là.');
};
var $author$project$I18n$Cles$referentielParcoursPorteursExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.porteurs.explication', _List_Nil, 'Dites quelles fiches peuvent porter ce rôle. Le rôle ne sera proposé que sur celles-là.');
};
var $author$project$I18n$Cles$referentielParcoursStatutsExplicationDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.statuts.explication.debut', _List_Nil, 'Un ');
};
var $author$project$I18n$Cles$referentielParcoursStatutsExplicationFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.statuts.explication.fin', _List_Nil, ' dit comment elle s\'est terminée.');
};
var $author$project$I18n$Cles$referentielParcoursStatutsExplicationFortResultat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.statuts.explication.fort-resultat', _List_Nil, 'résultat');
};
var $author$project$I18n$Cles$referentielParcoursStatutsExplicationFortStatut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.statuts.explication.fort-statut', _List_Nil, 'statut');
};
var $author$project$I18n$Cles$referentielParcoursStatutsExplicationMilieu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.statuts.explication.milieu', _List_Nil, ' dit où en est la relation tant qu\'elle dure. Un ');
};
var $author$project$I18n$Cles$referentielParcoursVerificationExplication = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parcours.verification.explication',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Voici ce qu\'on verra en ouvrant le rôle « ' + (p.Dj + ' » sur la fiche d\'une organisation. S\'il manque une information, revenez à l\'étape 5.'));
	});
var $author$project$I18n$Cles$referentielParcoursVerificationExplicationSansType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.verification.explication.sans-type', _List_Nil, 'Voici ce qu\'on verra en ouvrant le rôle sur la fiche d\'une organisation. S\'il manque une information, revenez à l\'étape 5.');
};
var $author$project$I18n$Cles$referentielParcoursVosTypesExplicationDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.vos-types.explication.debut', _List_Nil, 'Un ');
};
var $author$project$I18n$Cles$referentielParcoursVosTypesExplicationFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.vos-types.explication.fin', _List_Nil, ' dit le rôle qu\'une personne ou une organisation joue pour vous. Une même fiche peut en porter plusieurs : un fournisseur peut aussi être un client.');
};
var $author$project$I18n$Cles$referentielParcoursVosTypesExplicationFort = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.vos-types.explication.fort', _List_Nil, 'type');
};
var $author$project$Components$Referentiel$Types$Parcours$explication = F3(
	function (i18n, regle, etape) {
		switch (etape) {
			case 0:
				return _List_fromArray(
					[
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$referentielParcoursVosTypesExplicationDebut(i18n)),
						$author$project$Components$Shared$Parcours$Model$Fort(
						$author$project$I18n$Cles$referentielParcoursVosTypesExplicationFort(i18n)),
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$referentielParcoursVosTypesExplicationFin(i18n))
					]);
			case 1:
				return _List_fromArray(
					[
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$referentielParcoursPorteursExplication(i18n))
					]);
			case 2:
				return _List_fromArray(
					[
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$referentielParcoursOffresExplication(i18n))
					]);
			case 3:
				return _List_fromArray(
					[
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$referentielParcoursStatutsExplicationDebut(i18n)),
						$author$project$Components$Shared$Parcours$Model$Fort(
						$author$project$I18n$Cles$referentielParcoursStatutsExplicationFortStatut(i18n)),
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$referentielParcoursStatutsExplicationMilieu(i18n)),
						$author$project$Components$Shared$Parcours$Model$Fort(
						$author$project$I18n$Cles$referentielParcoursStatutsExplicationFortResultat(i18n)),
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$referentielParcoursStatutsExplicationFin(i18n))
					]);
			case 4:
				return _List_fromArray(
					[
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$referentielParcoursInformationsExplicationDebut(i18n)),
						$author$project$Components$Shared$Parcours$Model$Fort(
						$author$project$I18n$Cles$referentielParcoursInformationsExplicationFort(i18n)),
						$author$project$Components$Shared$Parcours$Model$Texte(
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$I18n$Cles$referentielParcoursInformationsExplicationFinSansType(i18n),
							A2(
								$elm$core$Maybe$map,
								function (libelle) {
									return A2(
										$author$project$I18n$Cles$referentielParcoursInformationsExplicationFin,
										i18n,
										{Dj: libelle});
								},
								regle)))
					]);
			case 5:
				return _List_fromArray(
					[
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$conservationEtapeExplication(i18n))
					]);
			case 6:
				return _List_fromArray(
					[
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$relationEtapeExplicationDebut(i18n)),
						$author$project$Components$Shared$Parcours$Model$Fort(
						$author$project$I18n$Cles$relationEtapeExplicationFort(i18n)),
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$relationEtapeExplicationFin(i18n))
					]);
			default:
				return _List_fromArray(
					[
						$author$project$Components$Shared$Parcours$Model$Texte(
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$I18n$Cles$referentielParcoursVerificationExplicationSansType(i18n),
							A2(
								$elm$core$Maybe$map,
								function (libelle) {
									return A2(
										$author$project$I18n$Cles$referentielParcoursVerificationExplication,
										i18n,
										{Dj: libelle});
								},
								regle)))
					]);
		}
	});
var $author$project$Components$Referentiel$Types$Update$EtapeDemandeeAuPied = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Referentiel$Types$View$parcours = function (i18n) {
	return A2($author$project$Components$Referentiel$Types$View$parcoursDe, i18n, $author$project$Components$Referentiel$Types$Update$EtapeDemandeeAuPied);
};
var $author$project$Components$Referentiel$Types$Update$NatureCochee = F2(
	function (a, b) {
		return {$: 31, a: a, b: b};
	});
var $author$project$Components$Referentiel$Types$Update$QualiteCochee = F2(
	function (a, b) {
		return {$: 32, a: a, b: b};
	});
var $author$project$Components$Referentiel$Types$View$groupe = F2(
	function (i18n, fourni) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$fieldset,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('groupe'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(fourni.Dj)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$legend,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(fourni.GJ)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('reponses')
						]),
					A2(
						$elm$core$List$map,
						function (reponse) {
							var idDeLaCase = 'porteurs-' + (fourni.Dj + ('-' + $elm$core$String$toLower(
								fourni.vx(reponse))));
							var cochee = A2($elm$core$List$member, reponse, fourni.vv);
							return A2(
								$rtfeldman$elm_css$Html$Styled$label,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('choix'),
										$rtfeldman$elm_css$Html$Styled$Attributes$for(idDeLaCase),
										$rtfeldman$elm_css$Html$Styled$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('retenu', cochee)
											]))
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$input,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
												$rtfeldman$elm_css$Html$Styled$Attributes$id(idDeLaCase),
												$rtfeldman$elm_css$Html$Styled$Attributes$checked(cochee),
												$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
												fourni.gJ || (cochee && ($elm$core$List$length(fourni.vv) === 1))),
												$rtfeldman$elm_css$Html$Styled$Events$onCheck(
												fourni.vw(reponse))
											]),
										_List_Nil),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												fourni.Bl(reponse))
											]))
									]));
						},
						fourni.hM)),
					A2($author$project$Components$Shared$Messages$View$view, i18n, fourni.pZ)
				]));
	});
var $author$project$I18n$Cles$referentielAdmissionNaturesQuestion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.admission.natures.question', _List_Nil, 'Une personne ou une organisation ?');
};
var $author$project$I18n$Cles$referentielAdmissionQualitesQuestion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.admission.qualites.question', _List_Nil, 'Un particulier ou un professionnel ?');
};
var $author$project$Components$Referentiel$Types$View$porteurs = F2(
	function (i18n, model) {
		var refusDu = function (groupeVise) {
			var _v1 = model.p6;
			if (!_v1.$) {
				var _v2 = _v1.a;
				var groupeRefuse = _v2.a;
				var message = _v2.b;
				return _Utils_eq(groupeRefuse, groupeVise) ? _List_fromArray(
					[message]) : _List_Nil;
			} else {
				return _List_Nil;
			}
		};
		var inactives = _Utils_eq(
			$author$project$Components$Referentiel$Types$Model$restriction(model),
			$elm$core$Maybe$Nothing) || $author$project$Components$Referentiel$Types$Model$enAttente(model);
		var fiche = $author$project$Components$Referentiel$Types$Model$ficheDuTypeRegle(model);
		var enChargement = (!_Utils_eq(
			$author$project$Components$Referentiel$Types$Model$typeRegle(model),
			$elm$core$Maybe$Nothing)) && (_Utils_eq(fiche, $elm$core$Maybe$Nothing) && _Utils_eq(model.x1, $elm$core$Maybe$Nothing));
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('admission')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('loading', enChargement)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-busy',
							enChargement ? 'true' : 'false')
						]),
					_Utils_ap(
						function () {
							if (!fiche.$) {
								var lue = fiche.a;
								var cases = $author$project$Components$Referentiel$Types$Model$casesDuType(lue);
								return _List_fromArray(
									[
										A2(
										$author$project$Components$Referentiel$Types$View$groupe,
										i18n,
										{
											vv: cases.oo,
											vw: $author$project$Components$Referentiel$Types$Update$NatureCochee,
											vx: $author$project$Components$Referentiel$Admission$codeDeNature,
											gJ: inactives,
											Bl: $author$project$Components$Referentiel$Admission$libelleDeNature(i18n),
											Dj: 'natures',
											GJ: $author$project$I18n$Cles$referentielAdmissionNaturesQuestion(i18n),
											pZ: refusDu(0),
											hM: $author$project$Components$Referentiel$Admission$natures
										}),
										A2(
										$author$project$Components$Referentiel$Types$View$groupe,
										i18n,
										{
											vv: cases.GG,
											vw: $author$project$Components$Referentiel$Types$Update$QualiteCochee,
											vx: $author$project$Components$Referentiel$Admission$codeDeQualite,
											gJ: inactives,
											Bl: $author$project$Components$Referentiel$Admission$libelleDeQualite(i18n),
											Dj: 'qualites',
											GJ: $author$project$I18n$Cles$referentielAdmissionQualitesQuestion(i18n),
											pZ: refusDu(1),
											hM: $author$project$Components$Referentiel$Admission$qualites
										})
									]);
							} else {
								return A2($author$project$Components$Referentiel$Types$View$echecDeLaLecture, i18n, model);
							}
						}(),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$Components$Referentiel$Types$Parcours$notePorteurs,
											i18n,
											$author$project$Components$Referentiel$Types$View$regle(model)))
									]))
							])))
				]));
	});
var $author$project$I18n$Cles$referentielParcoursInformationsQuestion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.informations.question', _List_Nil, 'Que voulez-vous savoir d\'un fournisseur ?');
};
var $author$project$I18n$Cles$referentielParcoursInformationsQuestionSansType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.informations.question.sans-type', _List_Nil, 'Que voulez-vous savoir pour le rôle ?');
};
var $author$project$I18n$Cles$referentielParcoursInformationsQuestionType = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parcours.informations.question.type',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Que voulez-vous savoir pour le rôle « ' + (p.Dj + ' » ?'));
	});
var $author$project$I18n$Cles$referentielParcoursOffresQuestionSansType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.offres.question.sans-type', _List_Nil, 'À quelles offres le rôle a-t-il accès ?');
};
var $author$project$I18n$Cles$referentielParcoursOffresQuestionType = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parcours.offres.question.type',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'À quelles offres le rôle « ' + (p.Dj + ' » a-t-il accès ?'));
	});
var $author$project$I18n$Cles$referentielParcoursPorteursQuestion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.porteurs.question', _List_Nil, 'Qui peut être fournisseur ?');
};
var $author$project$I18n$Cles$referentielParcoursPorteursQuestionSansType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.porteurs.question.sans-type', _List_Nil, 'Qui peut porter le rôle ?');
};
var $author$project$I18n$Cles$referentielParcoursPorteursQuestionType = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parcours.porteurs.question.type',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Qui peut porter le rôle « ' + (p.Dj + ' » ?'));
	});
var $author$project$I18n$Cles$referentielParcoursStatutsQuestion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.statuts.question', _List_Nil, 'Par où passe un fournisseur ?');
};
var $author$project$I18n$Cles$referentielParcoursStatutsQuestionSansType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.statuts.question.sans-type', _List_Nil, 'Par où passe le rôle ?');
};
var $author$project$I18n$Cles$referentielParcoursStatutsQuestionType = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parcours.statuts.question.type',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Par où passe le rôle « ' + (p.Dj + ' » ?'));
	});
var $author$project$I18n$Cles$referentielParcoursVerificationQuestion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.verification.question', _List_Nil, 'Vérifiez sur une fiche');
};
var $author$project$I18n$Cles$referentielParcoursVosTypesQuestion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.vos-types.question', _List_Nil, 'Qui sont vos parties prenantes ?');
};
var $author$project$Components$Referentiel$Types$Parcours$question = F3(
	function (i18n, regle, etape) {
		var selonLeType = F3(
			function (maquette, nomme, neutre) {
				if (!regle.$) {
					var libelle = regle.a;
					return _Utils_eq(
						libelle,
						$author$project$I18n$Cles$referentielArchetypeFournisseur(i18n)) ? maquette : nomme(
						{Dj: libelle});
				} else {
					return neutre;
				}
			});
		switch (etape) {
			case 0:
				return $author$project$I18n$Cles$referentielParcoursVosTypesQuestion(i18n);
			case 1:
				return A3(
					selonLeType,
					$author$project$I18n$Cles$referentielParcoursPorteursQuestion(i18n),
					$author$project$I18n$Cles$referentielParcoursPorteursQuestionType(i18n),
					$author$project$I18n$Cles$referentielParcoursPorteursQuestionSansType(i18n));
			case 2:
				if (!regle.$) {
					var libelle = regle.a;
					return A2(
						$author$project$I18n$Cles$referentielParcoursOffresQuestionType,
						i18n,
						{Dj: libelle});
				} else {
					return $author$project$I18n$Cles$referentielParcoursOffresQuestionSansType(i18n);
				}
			case 3:
				return A3(
					selonLeType,
					$author$project$I18n$Cles$referentielParcoursStatutsQuestion(i18n),
					$author$project$I18n$Cles$referentielParcoursStatutsQuestionType(i18n),
					$author$project$I18n$Cles$referentielParcoursStatutsQuestionSansType(i18n));
			case 4:
				return A3(
					selonLeType,
					$author$project$I18n$Cles$referentielParcoursInformationsQuestion(i18n),
					$author$project$I18n$Cles$referentielParcoursInformationsQuestionType(i18n),
					$author$project$I18n$Cles$referentielParcoursInformationsQuestionSansType(i18n));
			case 5:
				return $author$project$I18n$Cles$conservationEtapeQuestion(i18n);
			case 6:
				return $author$project$I18n$Cles$relationEtapeQuestion(i18n);
			default:
				return $author$project$I18n$Cles$referentielParcoursVerificationQuestion(i18n);
		}
	});
var $author$project$Components$Referentiel$Types$Update$RechercheSaisie = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Referentiel$Types$Update$ArchivesChoisies = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Referentiel$Types$View$idDesArchives = 'types-archives';
var $author$project$I18n$Cles$referentielTypesFiltreArchives = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.types.filtre.archives',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Afficher les types archivés (' + (p.w + ')'));
	});
var $author$project$Components$Referentiel$Types$View$archives = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(
			$author$project$Components$Referentiel$Types$Model$archives(model),
			model.aS);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var annuaire = _v0.b.a;
			return _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Champ$View$caseACocher,
					{
						go: $elm$core$Maybe$Nothing,
						Aq: $author$project$Components$Referentiel$Types$View$idDesArchives,
						Bl: A2(
							$author$project$I18n$Cles$referentielTypesFiltreArchives,
							i18n,
							{
								w: $elm$core$String$fromInt(annuaire.i$)
							}),
						he: false
					},
					{vt: model.fG, D9: $author$project$Components$Referentiel$Types$Update$ArchivesChoisies})
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$I18n$Cles$referentielParcoursVosTypesConseil = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.vos-types.conseil', _List_Nil, 'Créez seulement les types dont vous avez besoin : chacun se comporte comme un modèle (client, fournisseur…) et plusieurs types peuvent suivre le même. « Création rapide » en crée plusieurs d\'un coup. Cliquez un type pour le régler dans les étapes suivantes ; le crayon le renomme ou l\'archive.');
};
var $author$project$I18n$Cles$referentielParcoursVosTypesConseilSuite = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.parcours.vos-types.conseil.suite',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'La suite règle le type « ' + (p.Dj + ' ».'));
	});
var $author$project$Components$Referentiel$Types$Parcours$conseil = F2(
	function (i18n, regle) {
		if (!regle.$) {
			var libelle = regle.a;
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[
						$author$project$I18n$Cles$referentielParcoursVosTypesConseil(i18n),
						A2(
						$author$project$I18n$Cles$referentielParcoursVosTypesConseilSuite,
						i18n,
						{Dj: libelle})
					]));
		} else {
			return $author$project$I18n$Cles$referentielParcoursVosTypesConseil(i18n);
		}
	});
var $author$project$Components$Referentiel$Types$Update$CreationOuverte = {$: 7};
var $author$project$Components$Referentiel$Types$Update$RapideOuverte = {$: 10};
var $author$project$I18n$Cles$referentielTypesCreationRapide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.creation-rapide', _List_Nil, 'Création rapide');
};
var $author$project$Components$Referentiel$Types$View$creer = F3(
	function (i18n, sansType, model) {
		var _v0 = $author$project$Components$Referentiel$Types$Model$creation(model);
		if (!_v0.$) {
			var bouton = F4(
				function (variante, idDuBouton, msg, libelle) {
					return A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						variante,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id(idDuBouton),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(msg),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
								$author$project$Components$Referentiel$Types$Model$enAttente(model)),
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'loading',
										$author$project$Components$Referentiel$Types$Model$enAttente(model))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-busy',
								$author$project$Components$Referentiel$Types$Model$enAttente(model) ? 'true' : 'false')
							]),
						libelle);
				});
			var creationRapide = A4(
				bouton,
				sansType ? 0 : 1,
				$author$project$Components$Referentiel$Types$Model$idDeLaCreationRapide,
				$author$project$Components$Referentiel$Types$Update$RapideOuverte,
				$author$project$I18n$Cles$referentielTypesCreationRapide(i18n));
			var unType = A4(
				bouton,
				1,
				$author$project$Components$Referentiel$Types$Model$idDeLaCreation,
				$author$project$Components$Referentiel$Types$Update$CreationOuverte,
				$author$project$I18n$Cles$referentielTypesCreerUnType(i18n));
			return sansType ? _List_fromArray(
				[creationRapide, unType]) : _List_fromArray(
				[unType, creationRapide]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Referentiel$Types$View$intitule = F2(
	function (i18n, model) {
		return _Utils_eq(model.aS, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$I18n$Cles$referentielParcoursVosTypesTitre(i18n))
			]);
	});
var $author$project$Components$Referentiel$Types$Update$TypeConsulte = function (a) {
	return {$: 17, a: a};
};
var $author$project$I18n$Cles$referentielTypesModifier = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.types.modifier',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Modifier ' + p.Dj);
	});
var $author$project$I18n$Cles$referentielTypesModifierInfobulle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.modifier.infobulle', _List_Nil, 'Renommer ou archiver');
};
var $author$project$Components$Referentiel$Types$View$crayon = F2(
	function (i18n, lu) {
		var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$self, lu.nQ);
		if (!_v0.$) {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('crayon'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(
							$author$project$Components$Referentiel$Types$Model$idDeLaPastille(lu.r8)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Referentiel$Types$Update$TypeConsulte(lu.r8)),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-haspopup', 'dialog'),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-label',
							A2(
								$author$project$I18n$Cles$referentielTypesModifier,
								i18n,
								{Dj: lu.R.zX})),
							$rtfeldman$elm_css$Html$Styled$Attributes$title(
							$author$project$I18n$Cles$referentielTypesModifierInfobulle(i18n))
						]),
					_List_fromArray(
						[$author$project$Components$Shared$Svg$svgEdit]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Referentiel$Types$Update$BlocChoisi = function (a) {
	return {$: 28, a: a};
};
var $author$project$Components$Referentiel$Types$View$nomDuType = F2(
	function (estRegle, lu) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$self, lu.nQ),
			lu.tE);
		if ((!_v0.a.$) && (!_v0.b)) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('nom'),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Referentiel$Types$Update$BlocChoisi(lu.r8)),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-pressed',
						estRegle ? 'true' : 'false')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(lu.R.zX)
					]));
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(lu.R.zX)
					]));
		}
	});
var $author$project$I18n$Cles$referentielTypesComme = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.types.comme',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'modele',
					$author$project$I18n$Traductions$Chaine(p.oa))
				]),
			'comme ' + p.oa);
	});
var $author$project$Components$Referentiel$Types$View$rolesOuverts = F2(
	function (i18n, lu) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('roles-ouverts')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							'· ' + A2(
								$author$project$I18n$Nombre$formater,
								$author$project$I18n$Traductions$langue(i18n),
								lu.Id))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('lecture')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$referentielTypeRolesOuverts,
								i18n,
								{w: lu.Id}))
						]))
				]));
	});
var $author$project$Components$Referentiel$Types$View$pastille = F3(
	function (i18n, typeRegle, lu) {
		var estRegle = _Utils_eq(
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.r8;
				},
				typeRegle),
			$elm$core$Maybe$Just(lu.r8));
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('archive', lu.tE),
							_Utils_Tuple2('type-regle', estRegle)
						]))
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2($author$project$Components$Referentiel$Types$View$nomDuType, estRegle, lu),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('modele')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$referentielTypesComme,
									i18n,
									{
										oa: A2(
											$author$project$I18n$Cles$texte,
											i18n,
											$author$project$Components$Referentiel$Archetype$libelle(lu.fA))
									}))
							])),
						A2($author$project$Components$Referentiel$Types$View$rolesOuverts, i18n, lu)
					]),
				_Utils_ap(
					lu.tE ? _List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Tag$View$view,
							3,
							$author$project$I18n$Cles$referentielTypesArchive(i18n))
						]) : _List_Nil,
					A2($author$project$Components$Referentiel$Types$View$crayon, i18n, lu))));
	});
var $author$project$I18n$Cles$referentielParcoursVosTypesVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.parcours.vos-types.vide', _List_Nil, 'Vous n\'avez encore aucun type.');
};
var $author$project$I18n$Cles$referentielTypesGroupeVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.groupe.vide', _List_Nil, 'Aucun type.');
};
var $author$project$I18n$Cles$referentielTypesRecherche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.recherche', _List_Nil, 'Rechercher un type…');
};
var $author$project$Components$Referentiel$Types$View$vosTypes = F2(
	function (i18n, model) {
		var affiches = $author$project$Components$Referentiel$Types$Model$typesAffiches(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('types')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					((!_Utils_eq(model.aS, $elm$core$Maybe$Nothing)) && $elm$core$List$isEmpty(
						$author$project$Components$Referentiel$Types$Model$types(model))) ? _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aucun')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielParcoursVosTypesVide(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('pastilles'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-busy', 'false')
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('archives')
								]),
							A2($author$project$Components$Referentiel$Types$View$archives, i18n, model)),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('creer')
								]),
							A3($author$project$Components$Referentiel$Types$View$creer, i18n, true, model))
						]) : _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							A2($author$project$Components$Referentiel$Types$View$intitule, i18n, model)),
							A2(
							$rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('search'),
									$rtfeldman$elm_css$Html$Styled$Attributes$value(model.hC),
									$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Referentiel$Types$Update$RechercheSaisie),
									$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(
									$author$project$I18n$Cles$referentielTypesRecherche(i18n)),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									$author$project$I18n$Cles$referentielTypesRecherche(i18n))
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('pastilles'),
									$rtfeldman$elm_css$Html$Styled$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'loading',
											_Utils_eq(model.aS, $elm$core$Maybe$Nothing))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-busy',
									_Utils_eq(model.aS, $elm$core$Maybe$Nothing) ? 'true' : 'false')
								]),
							A2(
								$elm$core$List$map,
								A2(
									$author$project$Components$Referentiel$Types$View$pastille,
									i18n,
									$author$project$Components$Referentiel$Types$Model$typeRegle(model)),
								affiches)),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
								]),
							((!_Utils_eq(model.aS, $elm$core$Maybe$Nothing)) && $elm$core$List$isEmpty(affiches)) ? _List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$referentielTypesGroupeVide(i18n))
								]) : _List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('archives')
								]),
							A2($author$project$Components$Referentiel$Types$View$archives, i18n, model)),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('creer')
								]),
							A3($author$project$Components$Referentiel$Types$View$creer, i18n, false, model)),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$Components$Referentiel$Types$Parcours$conseil,
										i18n,
										$author$project$Components$Referentiel$Types$View$regle(model)))
								]))
						]))
				]));
	});
var $author$project$Components$Referentiel$Types$View$etape = F4(
	function (i18n, courante, model, fournie) {
		return A4(
			$author$project$Components$Shared$Parcours$View$etape,
			A2($author$project$Components$Referentiel$Types$View$parcours, i18n, model),
			courante,
			fournie,
			{
				fZ: function () {
					switch (fournie) {
						case 0:
							return _List_fromArray(
								[
									A2($author$project$Components$Referentiel$Types$View$vosTypes, i18n, model)
								]);
						case 1:
							return _List_fromArray(
								[
									A2($author$project$Components$Referentiel$Types$View$porteurs, i18n, model)
								]);
						case 2:
							return _List_fromArray(
								[
									A3(
									$author$project$Components$Referentiel$Types$OffresView$etape,
									i18n,
									A2($author$project$Components$Referentiel$Types$View$echecDeLaLecture, i18n, model),
									model)
								]);
						case 3:
							return _List_fromArray(
								[
									A3(
									$author$project$Components$Referentiel$Types$CheminView$etape,
									i18n,
									A2($author$project$Components$Referentiel$Types$View$echecDeLaLecture, i18n, model),
									model)
								]);
						case 4:
							return _List_fromArray(
								[
									A3(
									$author$project$Components$Referentiel$Types$InformationsView$etape,
									i18n,
									A2($author$project$Components$Referentiel$Types$View$echecDeLaLecture, i18n, model),
									model)
								]);
						case 5:
							return _List_Nil;
						case 6:
							return _List_Nil;
						default:
							return _List_fromArray(
								[
									$author$project$Components$Shared$Parcours$View$bientot(i18n)
								]);
					}
				}(),
				y8: A3(
					$author$project$Components$Referentiel$Types$Parcours$explication,
					i18n,
					$author$project$Components$Referentiel$Types$View$regle(model),
					fournie),
				GJ: A3(
					$author$project$Components$Referentiel$Types$Parcours$question,
					i18n,
					$author$project$Components$Referentiel$Types$View$regle(model),
					fournie)
			});
	});
var $author$project$Components$Referentiel$Types$Update$RapideDemandee = {$: 14};
var $author$project$I18n$Cles$referentielTypesRapideBilanCrees = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.types.rapide.bilan.crees',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' type créé') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' types créés'));
	});
var $author$project$I18n$Cles$referentielTypesRapideBilanRefuses = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.types.rapide.bilan.refuses',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' refusé') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' refusés'));
	});
var $author$project$Components$Referentiel$Types$View$bilan = F2(
	function (i18n, etat) {
		var refuses = $author$project$Components$Referentiel$Types$CreationRapide$nombreRefuses(etat);
		var crees = $author$project$Components$Referentiel$Types$CreationRapide$nombreCrees(etat);
		return (!(crees + refuses)) ? _List_Nil : _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				A2(
					$elm$core$String$join,
					', ',
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								(crees > 0) ? $elm$core$Maybe$Just(
								A2(
									$author$project$I18n$Cles$referentielTypesRapideBilanCrees,
									i18n,
									{w: crees})) : $elm$core$Maybe$Nothing,
								(refuses > 0) ? $elm$core$Maybe$Just(
								A2(
									$author$project$I18n$Cles$referentielTypesRapideBilanRefuses,
									i18n,
									{w: refuses})) : $elm$core$Maybe$Nothing
							]))) + '.')
			]);
	});
var $author$project$Components$Referentiel$Types$Update$RapideCochee = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$Referentiel$Types$Update$RapideNommee = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$I18n$Cles$referentielArchetypeClientDescription = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.archetype.client.description', _List_Nil, 'On lui vend.');
};
var $author$project$I18n$Cles$referentielArchetypeCollaborateurDescription = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.archetype.collaborateur.description', _List_Nil, 'Une personne de votre organisation.');
};
var $author$project$I18n$Cles$referentielArchetypeConcurrentDescription = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.archetype.concurrent.description', _List_Nil, 'Un acteur du marché que vous comparez.');
};
var $author$project$I18n$Cles$referentielArchetypeFournisseurDescription = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.archetype.fournisseur.description', _List_Nil, 'On lui achète.');
};
var $author$project$I18n$Cles$referentielArchetypePartenaireDescription = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.archetype.partenaire.description', _List_Nil, 'On travaille avec lui sans transaction directe.');
};
var $author$project$I18n$Cles$referentielArchetypePrescripteurDescription = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.archetype.prescripteur.description', _List_Nil, 'Il recommande vos produits.');
};
var $author$project$I18n$Cles$referentielArchetypeProspectDescription = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.archetype.prospect.description', _List_Nil, 'Un client possible, en cours de démarche.');
};
var $author$project$I18n$Cles$referentielArchetypeRelationPresseDescription = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.archetype.relation-presse.description', _List_Nil, 'Un journaliste, un média.');
};
var $author$project$I18n$Cles$referentielArchetypeSuspectDescription = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.archetype.suspect.description', _List_Nil, 'Un contact pas encore qualifié.');
};
var $author$project$Components$Referentiel$Archetype$description = F2(
	function (i18n, archetype) {
		switch (archetype) {
			case 0:
				return $author$project$I18n$Cles$referentielArchetypeSuspectDescription(i18n);
			case 1:
				return $author$project$I18n$Cles$referentielArchetypeProspectDescription(i18n);
			case 2:
				return $author$project$I18n$Cles$referentielArchetypeClientDescription(i18n);
			case 3:
				return $author$project$I18n$Cles$referentielArchetypeCollaborateurDescription(i18n);
			case 4:
				return $author$project$I18n$Cles$referentielArchetypeFournisseurDescription(i18n);
			case 5:
				return $author$project$I18n$Cles$referentielArchetypePartenaireDescription(i18n);
			case 6:
				return $author$project$I18n$Cles$referentielArchetypePrescripteurDescription(i18n);
			case 7:
				return $author$project$I18n$Cles$referentielArchetypeRelationPresseDescription(i18n);
			default:
				return $author$project$I18n$Cles$referentielArchetypeConcurrentDescription(i18n);
		}
	});
var $author$project$Components$Referentiel$Types$CreationRapide$idDeLaCase = function (archetype) {
	return $author$project$Components$Referentiel$Types$CreationRapide$prefixe + ('-' + ($elm$core$String$toLower(
		$author$project$Components$Referentiel$Archetype$code(archetype)) + '-case'));
};
var $author$project$I18n$Cles$referentielTypesRapideCree = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.rapide.cree', _List_Nil, 'Créé');
};
var $author$project$I18n$Cles$referentielTypesRapideNom = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.types.rapide.nom',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'modele',
					$author$project$I18n$Traductions$Chaine(p.oa))
				]),
			'Nom du type « ' + (p.oa + ' »'));
	});
var $author$project$Components$Referentiel$Types$View$modele = F4(
	function (i18n, attente, tentee, ligne) {
		var manque = tentee && (ligne.vt && (_Utils_eq(ligne.nh, $elm$core$Maybe$Nothing) && $elm$core$String$isEmpty(
			$elm$core$String$trim(ligne.Dj))));
		var idDeLaCase = $author$project$Components$Referentiel$Types$CreationRapide$idDeLaCase(ligne.fA);
		var cree = _Utils_eq(
			ligne.nh,
			$elm$core$Maybe$Just($author$project$Components$Referentiel$Types$CreationRapide$Creee));
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('modele'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('retenu', ligne.vt),
							_Utils_Tuple2('cree', cree),
							_Utils_Tuple2(
							'refuse',
							(!_Utils_eq(ligne.nh, $elm$core$Maybe$Nothing)) && (!cree))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(idDeLaCase),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(ligne.vt),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(cree || attente),
							$rtfeldman$elm_css$Html$Styled$Events$onCheck(
							$author$project$Components$Referentiel$Types$Update$RapideCochee(ligne.fA))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('contenu')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom'),
									$rtfeldman$elm_css$Html$Styled$Attributes$for(idDeLaCase)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$texte,
										i18n,
										$author$project$Components$Referentiel$Archetype$libelle(ligne.fA)))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Referentiel$Archetype$description, i18n, ligne.fA))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id(
									$author$project$Components$Referentiel$Types$CreationRapide$idDuNom(ligne.fA)),
									$rtfeldman$elm_css$Html$Styled$Attributes$value(ligne.Dj),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled((!ligne.vt) || (cree || attente)),
									$rtfeldman$elm_css$Html$Styled$Events$onInput(
									$author$project$Components$Referentiel$Types$Update$RapideNommee(ligne.fA)),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									A2(
										$author$project$I18n$Cles$referentielTypesRapideNom,
										i18n,
										{
											oa: A2(
												$author$project$I18n$Cles$texte,
												i18n,
												$author$project$Components$Referentiel$Archetype$libelle(ligne.fA))
										}))
								]),
							_List_Nil),
							function () {
							var _v0 = ligne.nh;
							if (!_v0.$) {
								switch (_v0.a.$) {
									case 0:
										var _v1 = _v0.a;
										return A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('etat')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$referentielTypesRapideCree(i18n))
												]));
									case 1:
										var _v2 = _v0.a;
										return A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('erreur')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$referentielTypesChampNomDejaUtilise(i18n))
												]));
									default:
										var message = _v0.a.a;
										return A2(
											$author$project$Components$Shared$Messages$View$view,
											i18n,
											_List_fromArray(
												[message]));
								}
							} else {
								return manque ? A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('erreur')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$referentielTypesChampNomObligatoire(i18n))
										])) : $rtfeldman$elm_css$Html$Styled$text('');
							}
						}()
						]))
				]));
	});
var $author$project$I18n$Cles$referentielTypesRapideAction = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.types.rapide.action',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Créer ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' type')) : ('Créer ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' types')));
	});
var $author$project$I18n$Cles$referentielTypesRapideIntroduction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.types.rapide.introduction', _List_Nil, 'Cochez les modèles qui vous servent ; chacun crée un type, sous le nom que vous voulez. Vous pourrez en créer d\'autres plus tard.');
};
var $author$project$Components$Referentiel$Types$View$rapide = F2(
	function (i18n, model) {
		var etat = _Utils_eq(
			$author$project$Components$Referentiel$Types$Model$creation(model),
			$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Nothing : model.ki;
		var nombre = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $author$project$Components$Referentiel$Types$CreationRapide$nombreACreer, etat));
		var attente = $author$project$Components$Referentiel$Types$Model$enAttente(model);
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$Types$Update$DeLaRapide,
			{
				fs: {
					sR: (nombre > 0) && (!attente),
					Bl: _Utils_eq(etat, $elm$core$Maybe$Nothing) ? '' : ((!nombre) ? $author$project$I18n$Cles$referentielTypesCreationAction(i18n) : A2(
						$author$project$I18n$Cles$referentielTypesRapideAction,
						i18n,
						{w: nombre})),
					C$: $author$project$Components$Referentiel$Types$Update$RapideDemandee
				},
				fZ: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (ouvert) {
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('introduction')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$referentielTypesRapideIntroduction(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('bilan')
										]),
									A2($author$project$Components$Referentiel$Types$View$bilan, i18n, ouvert)),
									A2(
									$rtfeldman$elm_css$Html$Styled$ul,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('modeles')
										]),
									A2(
										$elm$core$List$map,
										A3($author$project$Components$Referentiel$Types$View$modele, i18n, attente, ouvert.b5),
										ouvert.gV))
								]);
						},
						etat)),
				A6: _Utils_eq(etat, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$I18n$Cles$referentielTypesEtapeUn(i18n)),
				Bc: false,
				h6: _Utils_eq(etat, $elm$core$Maybe$Nothing) ? '' : $author$project$I18n$Cles$referentielTypesCreationRapide(i18n)
			},
			model.pJ);
	});
var $author$project$Components$Referentiel$Types$Update$RenommageDemande = {$: 22};
var $author$project$Components$Referentiel$Types$View$renommage = F2(
	function (i18n, model) {
		var fiche = $author$project$Components$Shared$Drawer$Model$estOuvert(model.hL) ? $author$project$Components$Referentiel$Types$Model$typeConsulte(model) : $elm$core$Maybe$Nothing;
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$Types$Update$DuRenommage,
			{
				fs: {
					sR: (!_Utils_eq(fiche, $elm$core$Maybe$Nothing)) && (!$author$project$Components$Referentiel$Types$Model$enAttente(model)),
					Bl: _Utils_eq(fiche, $elm$core$Maybe$Nothing) ? '' : $author$project$I18n$Cles$referentielTypeEnregistrer(i18n),
					C$: $author$project$Components$Referentiel$Types$Update$RenommageDemande
				},
				fZ: function () {
					if (!fiche.$) {
						var lue = fiche.a;
						return A2(
							$elm$core$List$map,
							$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Referentiel$Types$Update$Saisi),
							A3(
								$author$project$Components$Referentiel$Common$FormulaireDeType$view,
								i18n,
								{
									fA: $author$project$Components$Referentiel$Common$FormulaireDeType$Fixe(
										A2(
											$author$project$I18n$Cles$texte,
											i18n,
											$author$project$Components$Referentiel$Archetype$libelle(lue.r0.fA))),
									jf: true,
									na: $elm$core$Maybe$Nothing,
									pv: $author$project$Components$Referentiel$Types$Model$prefixeDuRenommage(model),
									il: 1
								},
								model.hP));
					} else {
						return _List_Nil;
					}
				}(),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function (lue) {
							return A2(
								$author$project$I18n$Cles$referentielTypesRenommerDe,
								i18n,
								{Dj: lue.r0.R.zX});
						},
						fiche))
			},
			model.hL);
	});
var $author$project$Components$Referentiel$Types$View$view = F4(
	function (i18n, courante, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'referentiel-types-list',
			{
				ut: model.qa ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('acces-refuse')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Components$Shared$Note$View$view,
										1,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$droitsAccesRefuse(i18n))
													]))
											]))
									]))
							]))
					]) : (_Utils_eq(model.np, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Parcours$View$etapes,
						i18n,
						A2($author$project$Components$Referentiel$Types$View$parcours, i18n, model),
						courante),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						A2(
							$elm$core$List$cons,
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									A3($author$project$Components$Referentiel$Types$View$etape, i18n, courante, model),
									function ($) {
										return $.yL;
									}(
										A2($author$project$Components$Referentiel$Types$View$parcours, i18n, model))),
								_List_fromArray(
									[
										A3(
										$author$project$Components$Shared$Parcours$View$pied,
										i18n,
										A2($author$project$Components$Referentiel$Types$View$parcours, i18n, model),
										courante)
									])))),
						A3(
						$author$project$Components$Shared$Parcours$View$apercu,
						i18n,
						$author$project$I18n$Cles$referentielParcoursApercu(i18n),
						A3($author$project$Components$Referentiel$Types$Apercu$de, i18n, courante, model))
					])),
				xy: _Utils_ap(
					_List_fromArray(
						[
							A2($author$project$Components$Referentiel$Types$View$creation, i18n, model),
							A2($author$project$Components$Referentiel$Types$View$rapide, i18n, model),
							A2($author$project$Components$Referentiel$Types$View$duType, i18n, model),
							A2($author$project$Components$Referentiel$Types$View$renommage, i18n, model),
							A2($author$project$Components$Referentiel$Types$CheminView$drawer, i18n, model),
							A2($author$project$Components$Referentiel$Types$OffresView$drawer, i18n, model),
							A2($author$project$Components$Referentiel$Types$OffresView$drawerDuPerimetre, i18n, model),
							A2($author$project$Components$Referentiel$Types$InformationsView$drawer, i18n, model),
							A2($author$project$Components$Referentiel$Types$InformationsView$drawersDesCollections, i18n, model),
							A2($author$project$Components$Referentiel$Types$InformationsView$drawerDeLOrdre, i18n, model),
							A2($author$project$Components$Referentiel$Types$InformationsView$drawerDUneInformation, i18n, model),
							A2($author$project$Components$Referentiel$Types$InformationsView$drawerDeLaMasquee, i18n, model),
							A2($author$project$Components$Referentiel$Types$InformationsView$drawerDesReglages, i18n, model),
							A2($author$project$Components$Referentiel$Types$InformationsView$drawerDeLaRestriction, i18n, model),
							A2($author$project$Components$Referentiel$Types$InformationsView$drawerDesVersions, i18n, model),
							A2($author$project$Components$Referentiel$Types$InformationsView$drawerElargir, i18n, model),
							A2($author$project$Components$Referentiel$Types$InformationsView$drawerElargirLaListe, i18n, model)
						]),
					A3($author$project$Components$Parametrage$NouveauChamp$View$dialogues, i18n, $author$project$Components$Referentiel$Types$Update$DuNouveauChamp, model.AM.oP)),
				zM: _List_Nil,
				AK: $author$project$Components$Referentiel$Types$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$Components$Referentiel$Types$Parcours$description,
											i18n,
											$author$project$Components$Referentiel$Types$View$regle(model)))
									]))
							]),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adresseTypesDePartiesPrenantes,
								Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
							},
								{
								aa: $author$project$Routes$Route$adresseTypesDePartiesPrenantes,
								Dj: $author$project$I18n$Cles$referentielParcoursFil(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$referentielParcoursTitre(i18n)
					})
			});
	});
var $author$project$Components$Shared$Version$View$champ = F2(
	function (lire, version) {
		return A2(
			$elm$core$Result$withDefault,
			'',
			A2($elm$core$Result$map, lire, version));
	});
var $author$project$I18n$Cles$versionInconnue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'version.inconnue', _List_Nil, 'Version inconnue');
};
var $author$project$Components$Shared$Version$View$erreurs = F2(
	function (i18n, version) {
		if (!version.$) {
			return _List_Nil;
		} else {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$versionInconnue(i18n))
						]))
				]);
		}
	});
var $author$project$Components$Shared$Version$View$estIllisible = function (version) {
	if (!version.$) {
		return false;
	} else {
		return true;
	}
};
var $author$project$I18n$Cles$versionCommit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'version.commit', _List_Nil, 'Commit : ');
};
var $author$project$I18n$Cles$versionDateBuild = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'version.date-build', _List_Nil, 'Date de build : ');
};
var $author$project$I18n$Cles$versionSectionTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'version.section.titre', _List_Nil, 'Version déployée');
};
var $author$project$Components$Shared$Version$View$view = F3(
	function (i18n, titre, version) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('version'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'version-illisible',
							$author$project$Components$Shared$Version$View$estIllisible(version))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(titre)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$versionSectionTitre(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('version-deployee')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('commit')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$versionCommit(i18n)),
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$Components$Shared$Version$View$champ,
												function ($) {
													return $.vN;
												},
												version))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('date-build')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$versionDateBuild(i18n)),
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$Components$Shared$Version$View$champ,
												function ($) {
													return $.ww;
												},
												version))
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('version-inconnue')
						]),
					A2($author$project$Components$Shared$Version$View$erreurs, i18n, version))
				]));
	});
var $author$project$Components$Produits$Catalogue$View$nomDeLaTypologie = F2(
	function (model, id) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Dj;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(id)),
						model.r7))));
	});
var $author$project$I18n$Cles$produitsReferencesARangerDescription = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.a-ranger.description',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Entier(p.JE)),
					_Utils_Tuple2(
					'typologie',
					$author$project$I18n$Traductions$Chaine(p.r3))
				]),
			((!p.JE) || (p.JE === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.JE) + (' référence n\'a pas encore sa place dans l\'arbre de « ' + (p.r3 + ' ». Elles restent vendables ; rangez-les pour qu\'elles apparaissent sous leur marque et leur gamme.'))) : (A2($author$project$I18n$Nombre$formater, 0, p.JE) + (' références n\'ont pas encore leur place dans l\'arbre de « ' + (p.r3 + ' ». Elles restent vendables ; rangez-les pour qu\'elles apparaissent sous leur marque et leur gamme.'))));
	});
var $author$project$I18n$Cles$produitsReferencesARangerRetour = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.a-ranger.retour', _List_Nil, 'Retour au catalogue');
};
var $author$project$I18n$Cles$produitsReferencesARangerTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.references.a-ranger.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typologie',
					$author$project$I18n$Traductions$Chaine(p.r3))
				]),
			p.r3 + ' · à ranger');
	});
var $author$project$Components$Produits$Catalogue$View$enTeteARanger = F3(
	function (i18n, model, aRanger) {
		var typologie = A2($author$project$Components$Produits$Catalogue$View$nomDeLaTypologie, model, aRanger.r3);
		return A2(
			$author$project$Components$Shared$Page$View$enTete,
			i18n,
			{
				vS: _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								function () {
									var _v0 = A2(
										$elm$core$Maybe$withDefault,
										0,
										A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.JE;
											},
											aRanger.n3));
									if (!_v0) {
										return '';
									} else {
										var total = _v0;
										return A2(
											$author$project$I18n$Cles$produitsReferencesARangerDescription,
											i18n,
											{JE: total, r3: typologie});
									}
								}())
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Routes$Route$adresseCatalogue),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('retour')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsReferencesARangerRetour(i18n))
							]))
					]),
				zE: _List_fromArray(
					[
						{
						aa: $author$project$Routes$Route$adresseCatalogue,
						Dj: $author$project$I18n$Cles$produitsTitre(i18n)
					}
					]),
				Ef: _List_Nil,
				h6: A2(
					$author$project$I18n$Cles$produitsReferencesARangerTitre,
					i18n,
					{r3: typologie})
			});
	});
var $author$project$Components$Produits$Catalogue$Update$RangementOuvert = function (a) {
	return {$: 44, a: a};
};
var $author$project$I18n$Cles$produitsReferencesARangerRanger = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.a-ranger.ranger', _List_Nil, 'Ranger');
};
var $author$project$I18n$Cles$produitsReferencesARangerVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.references.a-ranger.vide', _List_Nil, 'Aucune référence à ranger.');
};
var $author$project$Components$Produits$Catalogue$View$referencesARanger = F3(
	function (i18n, messages, model) {
		var references = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.hD;
				},
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.n3;
					},
					model.iz)));
		var categorieDe = function (reference) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Dj;
						},
						function ($) {
							return $.zX;
						}),
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(reference.fh)),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.ib;
									},
									model.jB))))));
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('a-ranger-liste')
				]),
			_List_fromArray(
				[
					A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('list')
						]),
					A2(
						$elm$core$List$map,
						function (reference) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('item')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$strong,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(reference.vx)
													])),
												$rtfeldman$elm_css$Html$Styled$text(
												' · ' + (reference.Gp.zX + (' · ' + categorieDe(reference))))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$button,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('ranger'),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												$author$project$Components$Produits$Catalogue$Update$RangementOuvert(reference.Aq))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$produitsReferencesARangerRanger(i18n))
											]))
									]));
						},
						references)),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('aide'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'hidden',
									!_Utils_eq(references, _List_Nil))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsReferencesARangerVide(i18n))
						]))
				]));
	});
var $author$project$Components$Produits$Catalogue$View$viewARanger = F3(
	function (i18n, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'produits-catalogue-a-ranger',
			{
				ut: _Utils_eq(model.np, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
					[
						A3($author$project$Components$Produits$Catalogue$View$referencesARanger, i18n, messages, model)
					]),
				xy: _List_fromArray(
					[
						A2($author$project$Components$Produits$Catalogue$View$creation, i18n, model)
					]),
				zM: _List_Nil,
				AK: $author$project$Components$Produits$Catalogue$View$dialogueOuvert(model),
				JD: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2($author$project$Components$Produits$Catalogue$View$enTeteARanger, i18n, model),
						model.iz))
			});
	});
var $author$project$Components$Referentiel$Fusion$Update$ComparerDemande = {$: 7};
var $author$project$Components$Referentiel$Fusion$Update$RechercheSaisie = function (a) {
	return {$: 3, a: a};
};
var $author$project$I18n$Cles$referentielFusionDrawerSeulesLesPersonnes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.drawer.seules-les-personnes', _List_Nil, 'Seules les personnes sont proposées : on ne fusionne que deux fiches de même nature.');
};
var $author$project$Components$Referentiel$Fusion$View$aideDeLaRecherche = F2(
	function (i18n, model) {
		var _v0 = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.g1;
			},
			model.IR);
		if ((!_v0.$) && (!_v0.a)) {
			var _v1 = _v0.a;
			return $author$project$I18n$Cles$referentielFusionDrawerSeulesLesPersonnes(i18n);
		} else {
			return '';
		}
	});
var $author$project$Components$Referentiel$Fusion$Update$PropositionChoisie = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Referentiel$Fusion$View$couleurDuRefus = function (refus) {
	if (refus.$ === 1) {
		return 0;
	} else {
		return 3;
	}
};
var $author$project$Components$Referentiel$Fusion$View$etatDe = F2(
	function (i18n, etat) {
		switch (etat) {
			case 0:
				return $author$project$I18n$Cles$referentielFicheEtatActive(i18n);
			case 1:
				return $author$project$I18n$Cles$referentielFicheEtatClose(i18n);
			case 2:
				return $author$project$I18n$Cles$referentielFicheEtatSupprimee(i18n);
			case 3:
				return $author$project$I18n$Cles$referentielFicheEtatEffacementProgramme(i18n);
			case 4:
				return $author$project$I18n$Cles$referentielFicheEtatEffacee(i18n);
			default:
				return $author$project$I18n$Cles$referentielFicheEtatFusionnee(i18n);
		}
	});
var $author$project$I18n$Cles$referentielFusionRefusEtablissement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.refus.etablissement', _List_Nil, 'Établissement');
};
var $author$project$Components$Referentiel$Fusion$View$etiquetteDeLaProposition = F2(
	function (i18n, candidate) {
		var _v0 = candidate.pZ;
		_v0$3:
		while (true) {
			if (!_v0.$) {
				switch (_v0.a.$) {
					case 1:
						var _v1 = _v0.a;
						return $author$project$I18n$Cles$referentielFusionRefusEtablissement(i18n);
					case 0:
						var _v2 = _v0.a;
						return A2($author$project$Components$Referentiel$Fusion$View$natureDe, i18n, candidate.g1);
					case 5:
						return $author$project$I18n$Cles$referentielFicheEtatFusionnee(i18n);
					default:
						break _v0$3;
				}
			} else {
				break _v0$3;
			}
		}
		return A2($author$project$Components$Referentiel$Fusion$View$etatDe, i18n, candidate.gt);
	});
var $author$project$I18n$Cles$referentielFusionRefusAutreNature = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.refus.autre-nature', _List_Nil, 'Une personne et une organisation ne se fusionnent pas.');
};
var $author$project$I18n$Cles$referentielFusionRefusClose = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.refus.close', _List_Nil, 'Fiche close : rouvrez-la d\'abord.');
};
var $author$project$I18n$Cles$referentielFusionRefusDejaFusionnee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fusion.refus.deja-fusionnee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Déjà fusionnée dans ' + (p.Dj + '.'));
	});
var $author$project$I18n$Cles$referentielFusionRefusSocieteEtablissement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.refus.societe-etablissement', _List_Nil, 'Une société et l\'un de ses établissements ne se fusionnent pas.');
};
var $author$project$I18n$Cles$referentielFusionRefusSupprimee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.refus.supprimee', _List_Nil, 'Fiche supprimée.');
};
var $author$project$Components$Referentiel$Fusion$View$raisonDuRefus = F2(
	function (i18n, refus) {
		switch (refus.$) {
			case 0:
				return $author$project$I18n$Cles$referentielFusionRefusAutreNature(i18n);
			case 1:
				return $author$project$I18n$Cles$referentielFusionRefusSocieteEtablissement(i18n);
			case 2:
				return $author$project$I18n$Cles$referentielFusionRefusClose(i18n);
			case 3:
				return $author$project$I18n$Cles$referentielFusionRefusSupprimee(i18n);
			case 4:
				return '';
			default:
				var nom = refus.a;
				return A2(
					$author$project$I18n$Cles$referentielFusionRefusDejaFusionnee,
					i18n,
					{
						Dj: A2(
							$elm$core$Maybe$withDefault,
							$author$project$I18n$Cles$referentielFicheNomMasque(i18n),
							A2(
								$elm$core$Maybe$map,
								$author$project$I18n$Cles$texte(i18n),
								nom))
					});
		}
	});
var $author$project$I18n$Cles$referentielFusionDrawerCreeLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.fusion.drawer.cree-le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'créée le ' + p.wv);
	});
var $author$project$Components$Referentiel$Fusion$View$proposition = F3(
	function (i18n, model, candidate) {
		var raison = A2(
			$elm$core$Maybe$map,
			$author$project$Components$Referentiel$Fusion$View$raisonDuRefus(i18n),
			candidate.pZ);
		var detail = A2(
			$elm$core$String$join,
			' · ',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						A2($author$project$Components$Referentiel$Fusion$View$natureDe, i18n, candidate.g1)),
						A2(
						$elm$core$Maybe$map,
						$author$project$Referentiel$Normes$nomDePays(model.hd),
						candidate.ho),
						A2(
						$elm$core$Maybe$map,
						function (cree) {
							return A2(
								$author$project$I18n$Cles$referentielFusionDrawerCreeLe,
								i18n,
								{
									wv: A2(
										$author$project$Texte$Jour$enFrancais,
										i18n,
										A2($elm$core$String$left, 10, cree))
								});
						},
						candidate.wn)
					])));
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'refusee',
							!_Utils_eq(raison, $elm$core$Maybe$Nothing)),
							_Utils_Tuple2(
							'selected',
							_Utils_eq(
								model.ve,
								$elm$core$Maybe$Just(candidate.r8)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_Nil,
					_List_fromArray(
						[
							_Utils_eq(raison, $elm$core$Maybe$Nothing) ? A2(
							$rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
									$rtfeldman$elm_css$Html$Styled$Attributes$name('fusion-autre'),
									$rtfeldman$elm_css$Html$Styled$Attributes$checked(
									_Utils_eq(
										model.ve,
										$elm$core$Maybe$Just(candidate.r8))),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Referentiel$Fusion$Update$PropositionChoisie(candidate.r8))
								]),
							_List_Nil) : A2(
							$rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
									$rtfeldman$elm_css$Html$Styled$Attributes$name('fusion-autre'),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$I18n$Cles$texte, i18n, candidate.Dj))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('raison')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($elm$core$Maybe$withDefault, detail, raison))
										]))
								])),
							A2(
							$author$project$Components$Shared$Tag$View$view,
							$author$project$Components$Referentiel$Fusion$View$couleurDuRefus(candidate.pZ),
							A2($author$project$Components$Referentiel$Fusion$View$etiquetteDeLaProposition, i18n, candidate))
						]))
				]));
	});
var $author$project$I18n$Cles$referentielFusionDrawerRecherche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.drawer.recherche', _List_Nil, 'Rechercher la fiche à fusionner');
};
var $author$project$Components$Referentiel$Fusion$View$contenuDuVolet = F2(
	function (i18n, model) {
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Champ$View$texteDecritPar,
				{
					go: $elm$core$Maybe$Nothing,
					Aq: 'fusion-recherche',
					Bl: $author$project$I18n$Cles$referentielFusionDrawerRecherche(i18n),
					he: false
				},
				{wV: 'fusion-recherche-aide', hg: $author$project$Components$Referentiel$Fusion$Update$RechercheSaisie, fm: model.h3}),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id('fusion-recherche-aide'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$Components$Referentiel$Fusion$View$aideDeLaRecherche, i18n, model))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$ul,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('propositions')
					]),
				A2(
					$elm$core$List$map,
					A2($author$project$Components$Referentiel$Fusion$View$proposition, i18n, model),
					A2(
						$elm$core$List$filter,
						function (candidat) {
							return !_Utils_eq(
								candidat.pZ,
								$elm$core$Maybe$Just($author$project$Components$Referentiel$Fusion$Model$RefusEffacee));
						},
						model.Gw)))
			]);
	});
var $author$project$I18n$Cles$referentielFusionDrawerComparer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.drawer.comparer', _List_Nil, 'Comparer et continuer');
};
var $author$project$I18n$Cles$referentielFusionDrawerTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'referentiel.fusion.drawer.titre', _List_Nil, 'Fusionner avec une autre fiche');
};
var $author$project$Components$Referentiel$Fusion$View$volet = F2(
	function (i18n, model) {
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Referentiel$Fusion$Update$DuVolet,
			{
				fs: {
					sR: !_Utils_eq(model.ve, $elm$core$Maybe$Nothing),
					Bl: $author$project$I18n$Cles$referentielFusionDrawerComparer(i18n),
					C$: $author$project$Components$Referentiel$Fusion$Update$ComparerDemande
				},
				fZ: A2($author$project$Components$Referentiel$Fusion$View$contenuDuVolet, i18n, model),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$referentielFusionDrawerTitre(i18n)
			},
			model.im);
	});
var $author$project$Components$Produits$StructureCatalogue$Update$DuFormulaire = function (a) {
	return {$: 92, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$View$aLaFin = function (embarque) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.dC;
				},
				A2(
					$elm$core$Basics$composeR,
					$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Produits$StructureCatalogue$Update$DuFormulaire),
					$elm$core$List$singleton)),
			embarque));
};
var $author$project$Routes$Route$adresseDuParcoursDuCatalogue = $author$project$Routes$Route$adresseParametrageCatalogue + ('/' + $author$project$Routes$Route$segmentDesTypologies);
var $author$project$Components$Produits$StructureCatalogue$Update$AjoutDEtageLibreDemande = {$: 79};
var $author$project$Components$Produits$StructureCatalogue$Etages$View$DansLAjout = 2;
var $author$project$Components$Produits$StructureCatalogue$Update$ReecritureAnnulee = {$: 175};
var $author$project$Components$Produits$StructureCatalogue$Update$ReecritureConfirmee = {$: 174};
var $author$project$Components$Produits$StructureCatalogue$Etages$View$dansLe = F2(
	function (lieu, identifiant) {
		switch (lieu) {
			case 0:
				return identifiant;
			case 1:
				return $author$project$Components$Produits$StructureCatalogue$Etages$Model$auRangement(identifiant);
			default:
				return 'ajout-' + identifiant;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Controles$enCours = function (model) {
	var _v0 = model.l2;
	if (_v0.$ === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Controles$sansProcessUid = function (model) {
	var _v0 = model.l2;
	if (!_v0.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Controles$enAttente = function (model) {
	return $author$project$Components$Shared$Parcours$Model$enAttente(
		{
			cF: $author$project$Components$Produits$StructureCatalogue$Controles$enCours(model),
			Go: !$author$project$Components$Produits$StructureCatalogue$Controles$sansProcessUid(model),
			Hw: model.Hv
		});
};
var $author$project$Catalogue$Formes$repli = function (singulier) {
	return {
		av: false,
		M: 1,
		bT: A2(
			$elm$core$List$any,
			function (fin) {
				return A2(
					$elm$core$String$endsWith,
					fin,
					$elm$core$String$toLower(
						$elm$core$String$trim(singulier)));
			},
			_List_fromArray(
				['s', 'x', 'z'])) ? singulier : (singulier + 's')
	};
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$formeDe = F3(
	function (i18n, niveaux, etage) {
		var _v0 = _Utils_Tuple2(etage.m$, etage.xt);
		if (!_v0.a.$) {
			var formes = _v0.a.a;
			return formes.zX;
		} else {
			if (_v0.b.$ === 1) {
				var _v1 = _v0.a;
				var libelles = _v0.b.a;
				return _Utils_update(
					$author$project$Components$Produits$StructureCatalogue$Etages$Model$formeVide,
					{bT: libelles.zX});
			} else {
				var _v2 = _v0.a;
				var _v3 = _v0.b;
				var niveau = _v3.b;
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Catalogue$Formes$repli(
						A2(
							$author$project$I18n$Cles$texte,
							i18n,
							A2($author$project$Components$Produits$StructureCatalogue$Etages$Model$nom, niveaux, etage))),
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.zX;
						},
						A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.m$;
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.Aq;
										},
										$elm$core$Basics$eq(niveau)),
									niveaux)))));
			}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$View$formeDEtage = F4(
	function (i18n, structure, typologie, id) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Catalogue$Formes$repli(''),
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Components$Produits$StructureCatalogue$Etages$Model$formeDe, i18n, structure.C9),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(id)),
						typologie.yG))));
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$View$fragment = function (fourni) {
	if (!fourni.$) {
		var texte = fourni.a;
		return $rtfeldman$elm_css$Html$Styled$text(texte);
	} else {
		var texte = fourni.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$strong,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(texte)
				]));
	}
};
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom = function (classification) {
	return classification.R.zX;
};
var $author$project$Components$Produits$StructureCatalogue$Etages$View$nomDEtage = F4(
	function (i18n, structure, typologie, id) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Produits$StructureCatalogue$Etages$Model$nom(structure.C9),
					$author$project$I18n$Cles$texte(i18n)),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(id)),
						typologie.yG))));
	});
var $author$project$Components$Produits$StructureCatalogue$Controles$occupe = function (envoiEnCours) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
		'aria-busy',
		envoiEnCours ? 'true' : 'false');
};
var $author$project$I18n$Cles$produitsEtagesApercuARangerFort = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.etages.apercu.a-ranger-fort',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeur') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeurs'));
	});
var $author$project$I18n$Cles$produitsEtagesApercuARangerNoms = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.etages.apercu.a-ranger-noms',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'noms',
					$author$project$I18n$Traductions$Chaine(p.DG))
				]),
			' (' + (p.DG + ')'));
	});
var $author$project$I18n$Cles$produitsEtagesApercuARangerSuite = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.etages.apercu.a-ranger-suite',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ' ira « À ranger »' : ' iront « À ranger »');
	});
var $author$project$I18n$Cles$produitsEtagesApercuAucuneARanger = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.etages.apercu.aucune-a-ranger', _List_Nil, 'aucune valeur n\'ira « À ranger »');
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Phrase$aRanger = F2(
	function (i18n, lu) {
		return (!lu.iz) ? _List_fromArray(
			[
				$author$project$Components$Shared$Parcours$Model$Texte(
				$author$project$I18n$Cles$produitsEtagesApercuAucuneARanger(i18n))
			]) : _List_fromArray(
			[
				$author$project$Components$Shared$Parcours$Model$Fort(
				A2(
					$author$project$I18n$Cles$produitsEtagesApercuARangerFort,
					i18n,
					{w: lu.iz})),
				$author$project$Components$Shared$Parcours$Model$Texte(
				_Utils_ap(
					A2(
						$author$project$I18n$Cles$produitsEtagesApercuARangerSuite,
						i18n,
						{w: lu.iz}),
					$elm$core$List$isEmpty(lu.DH) ? '' : A2(
						$author$project$I18n$Cles$produitsEtagesApercuARangerNoms,
						i18n,
						{
							DG: A2($elm$core$String$join, ', ', lu.DH)
						})))
			]);
	});
var $author$project$I18n$Cles$produitsEtagesApercuGardeFort = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.etages.apercu.garde-fort',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeur') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeurs'));
	});
var $author$project$I18n$Cles$produitsEtagesApercuGardeSuite = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.etages.apercu.garde-suite',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ' garde sa place' : ' gardent leur place');
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Phrase$garde = F2(
	function (i18n, nombre) {
		return (!nombre) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			_List_fromArray(
				[
					$author$project$Components$Shared$Parcours$Model$Fort(
					A2(
						$author$project$I18n$Cles$produitsEtagesApercuGardeFort,
						i18n,
						{w: nombre})),
					$author$project$Components$Shared$Parcours$Model$Texte(
					A2(
						$author$project$I18n$Cles$produitsEtagesApercuGardeSuite,
						i18n,
						{w: nombre}))
				]));
	});
var $author$project$I18n$Cles$produitsEtagesApercuFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.etages.apercu.fin', _List_Nil, '. Aucune référence n\'est modifiée.');
};
var $author$project$I18n$Cles$produitsEtagesApercuIntro = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.etages.apercu.intro',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'article',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeArticle(p.i4))),
					_Utils_Tuple2(
					'typologie',
					$author$project$I18n$Traductions$Chaine(p.r3))
				]),
			'Le rangement ' + (function () {
				var _v0 = p.i4;
				switch (_v0) {
					case 0:
						return 'de ' + p.r3;
					case 1:
						return 'de l\'' + $elm$core$String$toLower(p.r3);
					case 2:
						return 'de la ' + $elm$core$String$toLower(p.r3);
					case 3:
						return 'du ' + $elm$core$String$toLower(p.r3);
					default:
						return 'de ' + p.r3;
				}
			}() + ' sera réorganisé : '));
	});
var $author$project$I18n$Cles$produitsEtagesApercuSeparateur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.etages.apercu.separateur', _List_Nil, ' ; ');
};
var $author$project$I18n$Cles$produitsEtagesApercuRedistribueAvaient = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.etages.apercu.redistribue-avaient',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w)),
					_Utils_Tuple2(
					'avec',
					$author$project$I18n$Traductions$Chaine(p.ub))
				]),
			((!p.w) || (p.w === 1)) ? ('elle avait des ' + $elm$core$String$toLower(p.ub)) : ('elles avaient des ' + $elm$core$String$toLower(p.ub)));
	});
var $author$project$I18n$Cles$produitsEtagesApercuRedistribueDebut = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.etages.apercu.redistribue-debut',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w)),
					_Utils_Tuple2(
					'article',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeArticle(p.i4)))
				]),
			function () {
				if ((!p.w) || (p.w === 1)) {
					var _v0 = p.i4;
					switch (_v0) {
						case 0:
							return '';
						case 1:
							return 'l\'';
						case 2:
							return 'la ';
						case 3:
							return 'le ';
						default:
							return '';
					}
				} else {
					return 'les ';
				}
			}());
	});
var $author$project$I18n$Cles$produitsEtagesApercuRedistribueFort = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.etages.apercu.redistribue-fort',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w)),
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md)),
					_Utils_Tuple2(
					'etages',
					$author$project$I18n$Traductions$Chaine(p.yG))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' ' + $elm$core$String$toLower(p.md))) : (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' ' + $elm$core$String$toLower(p.yG))));
	});
var $author$project$I18n$Cles$produitsEtagesApercuRedistribueSous = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.etages.apercu.redistribue-sous',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'sous',
					$author$project$I18n$Traductions$Chaine(p.IV))
				]),
			' sous chaque ' + ($elm$core$String$toLower(p.IV) + ' où '));
	});
var $author$project$I18n$Cles$produitsEtagesApercuRedistribueVerbe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.etages.apercu.redistribue-verbe',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ' se retrouvera' : ' se retrouveront');
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Phrase$redistribuee = F3(
	function (i18n, contexte, lu) {
		return A2(
			$elm$core$Maybe$map,
			function (sous) {
				var nom = contexte.ow(lu.md);
				var forme = contexte.mO(lu.md);
				return _List_fromArray(
					[
						$author$project$Components$Shared$Parcours$Model$Texte(
						A2(
							$author$project$I18n$Cles$produitsEtagesApercuRedistribueDebut,
							i18n,
							{
								i4: $author$project$Catalogue$Formes$articleDe(forme),
								w: lu.w
							})),
						$author$project$Components$Shared$Parcours$Model$Fort(
						A2(
							$author$project$I18n$Cles$produitsEtagesApercuRedistribueFort,
							i18n,
							{md: nom, yG: forme.bT, w: lu.w})),
						$author$project$Components$Shared$Parcours$Model$Texte(
						_Utils_ap(
							A2(
								$author$project$I18n$Cles$produitsEtagesApercuRedistribueVerbe,
								i18n,
								{w: lu.w}),
							_Utils_ap(
								A2(
									$author$project$I18n$Cles$produitsEtagesApercuRedistribueSous,
									i18n,
									{
										IV: contexte.ow(sous)
									}),
								A2(
									$author$project$I18n$Cles$produitsEtagesApercuRedistribueAvaient,
									i18n,
									{
										ub: contexte.mO(lu.ub).bT,
										w: lu.w
									}))))
					]);
			},
			lu.IV);
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Phrase$phrase = F3(
	function (i18n, contexte, lu) {
		var clauses = _Utils_ap(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2($author$project$Components$Produits$StructureCatalogue$Etages$Phrase$garde, i18n, lu.z6)
					])),
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					A2($author$project$Components$Produits$StructureCatalogue$Etages$Phrase$redistribuee, i18n, contexte),
					lu.Ha),
				_List_fromArray(
					[
						A2($author$project$Components$Produits$StructureCatalogue$Etages$Phrase$aRanger, i18n, lu)
					])));
		return A2(
			$elm$core$List$cons,
			$author$project$Components$Shared$Parcours$Model$Texte(
				A2(
					$author$project$I18n$Cles$produitsEtagesApercuIntro,
					i18n,
					{i4: contexte.i4, r3: contexte.r3})),
			_Utils_ap(
				$elm$core$List$concat(
					A2(
						$elm$core$List$intersperse,
						_List_fromArray(
							[
								$author$project$Components$Shared$Parcours$Model$Texte(
								$author$project$I18n$Cles$produitsEtagesApercuSeparateur(i18n))
							]),
						clauses)),
				_List_fromArray(
					[
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$produitsEtagesApercuFin(i18n))
					])));
	});
var $author$project$I18n$Cles$produitsEtagesApercuAnnuler = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.etages.apercu.annuler', _List_Nil, 'Annuler');
};
var $author$project$I18n$Cles$produitsEtagesApercuConfirmerAjout = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.etages.apercu.confirmer-ajout', _List_Nil, 'Ajouter');
};
var $author$project$I18n$Cles$produitsEtagesApercuConfirmerOrdre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.etages.apercu.confirmer-ordre', _List_Nil, 'Réorganiser');
};
var $author$project$I18n$Cles$produitsEtagesApercuConfirmerRetrait = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.etages.apercu.confirmer-retrait', _List_Nil, 'Retirer');
};
var $author$project$I18n$Cles$produitsEtagesApercuDialogueAjout = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.etages.apercu.dialogue-ajout', _List_Nil, 'Confirmer l\'ajout de l\'étage');
};
var $author$project$I18n$Cles$produitsEtagesApercuDialogueOrdre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.etages.apercu.dialogue-ordre', _List_Nil, 'Confirmer le nouvel ordre');
};
var $author$project$I18n$Cles$produitsEtagesApercuDialogueRetrait = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.etages.apercu.dialogue-retrait', _List_Nil, 'Confirmer le retrait de l\'étage');
};
var $author$project$I18n$Cles$produitsEtagesApercuPerime = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.etages.apercu.perime', _List_Nil, 'L\'arbre a changé depuis l\'aperçu : voici le nouvel aperçu, à confirmer.');
};
var $author$project$I18n$Cles$produitsEtagesApercuTitreAjout = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.etages.apercu.titre-ajout',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md))
				]),
			'Ajouter l\'étage « ' + (p.md + ' » ?'));
	});
var $author$project$I18n$Cles$produitsEtagesApercuTitreDeplacer = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.etages.apercu.titre-deplacer',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md)),
					_Utils_Tuple2(
					'autre',
					$author$project$I18n$Traductions$Chaine(p.t3))
				]),
			'Déplacer « ' + (p.md + (' » à la place de « ' + (p.t3 + ' » ?'))));
	});
var $author$project$I18n$Cles$produitsEtagesApercuTitreDescendre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.etages.apercu.titre-descendre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md)),
					_Utils_Tuple2(
					'autre',
					$author$project$I18n$Traductions$Chaine(p.t3))
				]),
			'Descendre « ' + (p.md + (' » sous « ' + (p.t3 + ' » ?'))));
	});
var $author$project$I18n$Cles$produitsEtagesApercuTitreMonter = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.etages.apercu.titre-monter',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md)),
					_Utils_Tuple2(
					'autre',
					$author$project$I18n$Traductions$Chaine(p.t3))
				]),
			'Monter « ' + (p.md + (' » au-dessus de « ' + (p.t3 + ' » ?'))));
	});
var $author$project$I18n$Cles$produitsEtagesApercuTitreRetrait = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.etages.apercu.titre-retrait',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md))
				]),
			'Retirer l\'étage « ' + (p.md + ' » ?'));
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$View$titre = F2(
	function (i18n, lu) {
		var deux = F2(
			function (premier, second) {
				return {
					t3: A2($author$project$I18n$Cles$texte, i18n, second),
					md: A2($author$project$I18n$Cles$texte, i18n, premier)
				};
			});
		switch (lu.$) {
			case 0:
				var premier = lu.a;
				return A2(
					$author$project$I18n$Cles$produitsEtagesApercuTitreAjout,
					i18n,
					{
						md: A2($author$project$I18n$Cles$texte, i18n, premier)
					});
			case 1:
				var premier = lu.a;
				return A2(
					$author$project$I18n$Cles$produitsEtagesApercuTitreRetrait,
					i18n,
					{
						md: A2($author$project$I18n$Cles$texte, i18n, premier)
					});
			case 2:
				var premier = lu.a;
				var second = lu.b;
				return A2(
					$author$project$I18n$Cles$produitsEtagesApercuTitreMonter,
					i18n,
					A2(deux, premier, second));
			case 3:
				var premier = lu.a;
				var second = lu.b;
				return A2(
					$author$project$I18n$Cles$produitsEtagesApercuTitreDescendre,
					i18n,
					A2(deux, premier, second));
			default:
				var premier = lu.a;
				var second = lu.b;
				return A2(
					$author$project$I18n$Cles$produitsEtagesApercuTitreDeplacer,
					i18n,
					A2(deux, premier, second));
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$View$apercu = F5(
	function (i18n, lieu, model, structure, typologie) {
		var ajoutOuvert = $author$project$Components$Shared$Drawer$Model$estOuvert(model.y);
		var visible = function () {
			switch (lieu) {
				case 2:
					return ajoutOuvert;
				case 1:
					return !ajoutOuvert;
				default:
					return (!ajoutOuvert) && (!$author$project$Components$Shared$Drawer$Model$estOuvert(model.bZ));
			}
		}();
		var _v0 = _Utils_Tuple2(model.q, visible);
		if ((_v0.a.$ === 2) && _v0.b) {
			var lu = _v0.a.a;
			var envoi = $author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model);
			var _v1 = function () {
				var _v2 = lu.h6;
				switch (_v2.$) {
					case 0:
						return _Utils_Tuple2(
							$author$project$I18n$Cles$produitsEtagesApercuDialogueAjout(i18n),
							$author$project$I18n$Cles$produitsEtagesApercuConfirmerAjout(i18n));
					case 1:
						return _Utils_Tuple2(
							$author$project$I18n$Cles$produitsEtagesApercuDialogueRetrait(i18n),
							$author$project$I18n$Cles$produitsEtagesApercuConfirmerRetrait(i18n));
					default:
						return _Utils_Tuple2(
							$author$project$I18n$Cles$produitsEtagesApercuDialogueOrdre(i18n),
							$author$project$I18n$Cles$produitsEtagesApercuConfirmerOrdre(i18n));
				}
			}();
			var dialogue = _v1.a;
			var confirmer = _v1.b;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('avertissement'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu-de-reecriture'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alertdialog'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', dialogue)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('titre'),
								$rtfeldman$elm_css$Html$Styled$Attributes$id(
								A2($author$project$Components$Produits$StructureCatalogue$Etages$View$dansLe, lieu, $author$project$Components$Produits$StructureCatalogue$Etages$Model$idDeLApercu)),
								$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$Components$Produits$StructureCatalogue$Etages$View$titre, i18n, lu.h6))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('perime')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								lu.eC ? $author$project$I18n$Cles$produitsEtagesApercuPerime(i18n) : '')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('message')
							]),
						A2(
							$elm$core$List$map,
							$author$project$Components$Produits$StructureCatalogue$Etages$View$fragment,
							A3(
								$author$project$Components$Produits$StructureCatalogue$Etages$Phrase$phrase,
								i18n,
								{
									i4: $author$project$Catalogue$Formes$article(typologie.m$),
									mO: A3($author$project$Components$Produits$StructureCatalogue$Etages$View$formeDEtage, i18n, structure, typologie),
									ow: A3($author$project$Components$Produits$StructureCatalogue$Etages$View$nomDEtage, i18n, structure, typologie),
									r3: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(typologie)
								},
								lu))),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$StructureCatalogue$Update$ReecritureAnnulee),
										$rtfeldman$elm_css$Html$Styled$Attributes$disabled(envoi)
									]),
								$author$project$I18n$Cles$produitsEtagesApercuAnnuler(i18n)),
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								0,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$StructureCatalogue$Update$ReecritureConfirmee),
										$rtfeldman$elm_css$Html$Styled$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'loading',
												$author$project$Components$Produits$StructureCatalogue$Controles$enCours(model))
											])),
										$author$project$Components$Produits$StructureCatalogue$Controles$occupe(
										$author$project$Components$Produits$StructureCatalogue$Controles$enCours(model)),
										$rtfeldman$elm_css$Html$Styled$Attributes$disabled(envoi)
									]),
								confirmer)
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$View$apercuLu = function (model) {
	var _v0 = model.q;
	if (_v0.$ === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Update$EtageLibreLibelleSaisi = F2(
	function (a, b) {
		return {$: 69, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Controles$entreeEnvoie = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'keydown',
		A2(
			$elm$json$Json$Decode$andThen,
			function (_v0) {
				var touche = _v0.a;
				var balise = _v0.b;
				return ((touche === 'Enter') && (balise === 'INPUT')) ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('touche');
			},
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['target', 'tagName']),
					$elm$json$Json$Decode$string))));
};
var $author$project$I18n$Cles$produitsStructureLibelleObligatoire = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.structure.libelle.obligatoire',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'langue',
					$author$project$I18n$Traductions$Chaine(p.nn))
				]),
			'Le libellé ' + ($elm$core$String$toLower(p.nn) + ' est obligatoire.'));
	});
var $author$project$Components$Produits$StructureCatalogue$Controles$obligatoireManquant = F4(
	function (i18n, tentee, libelles, code) {
		return (tentee && A2(
			$elm$core$List$member,
			code,
			A2($author$project$Components$Shared$LibellesParLangue$Model$manquantes, $author$project$Referentiel$Langues$desLibelles, libelles))) ? $elm$core$Maybe$Just(
			A2(
				$author$project$I18n$Cles$produitsStructureLibelleObligatoire,
				i18n,
				{
					nn: A2($author$project$Referentiel$Langues$nom, i18n, code)
				})) : $elm$core$Maybe$Nothing;
	});
var $author$project$I18n$Cles$produitsStructureLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.structure.libelle', _List_Nil, 'Libellé');
};
var $author$project$Components$Produits$StructureCatalogue$Etages$View$libelles = F4(
	function (i18n, model, prefixe, demande) {
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Messages$View$view,
				i18n,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $elm$core$List$singleton, model.aL))),
				A3(
				$author$project$Components$Shared$LibellesParLangue$View$view,
				i18n,
				_List_fromArray(
					[
						$author$project$Components$Produits$StructureCatalogue$Controles$entreeEnvoie(demande)
					]),
				{
					go: A3($author$project$Components$Produits$StructureCatalogue$Controles$obligatoireManquant, i18n, model.D.b5, model.D.R),
					Ba: $author$project$Referentiel$Langues$desLibelles,
					Bl: $author$project$I18n$Cles$produitsStructureLibelle(i18n),
					hg: $author$project$Components$Produits$StructureCatalogue$Update$EtageLibreLibelleSaisi,
					pv: prefixe,
					fm: function (code) {
						return A2($author$project$Components$Shared$LibellesParLangue$Model$lire, code, model.D.R);
					}
				})
			]);
	});
var $author$project$I18n$Cles$produitsStructureAjoutAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.structure.ajout.ajouter', _List_Nil, 'Ajouter l\'étage');
};
var $author$project$I18n$Cles$produitsStructureAjoutOuvrir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.structure.ajout.ouvrir', _List_Nil, 'Ajouter un étage');
};
var $author$project$Components$Produits$StructureCatalogue$Etages$View$ajout = F2(
	function (i18n, model) {
		var ouvert = $author$project$Components$Shared$Drawer$Model$estOuvert(model.y);
		var offert = !_Utils_eq(
			$elm$core$Maybe$Nothing,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nQ;
					},
					$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$ajouterUnEtage)),
				A2(
					$elm$core$Maybe$andThen,
					function (structure) {
						return A2($author$project$Components$Produits$StructureCatalogue$Typologies$Model$reglee, model.r6, structure.vk);
					},
					model.h$)));
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Produits$StructureCatalogue$Update$DeLAjoutDEtageLibre,
			{
				fs: {
					sR: ouvert && (offert && ((!$author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model)) && (!$author$project$Components$Produits$StructureCatalogue$Etages$View$apercuLu(model)))),
					Bl: ouvert ? $author$project$I18n$Cles$produitsStructureAjoutAjouter(i18n) : '',
					C$: $author$project$Components$Produits$StructureCatalogue$Update$AjoutDEtageLibreDemande
				},
				fZ: ouvert ? _Utils_ap(
					A4($author$project$Components$Produits$StructureCatalogue$Etages$View$libelles, i18n, model, $author$project$Components$Produits$StructureCatalogue$Etages$Model$prefixeDeLAjout, $author$project$Components$Produits$StructureCatalogue$Update$AjoutDEtageLibreDemande),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (_v0) {
								var structure = _v0.a;
								var typologie = _v0.b;
								return _List_fromArray(
									[
										A5($author$project$Components$Produits$StructureCatalogue$Etages$View$apercu, i18n, 2, model, structure, typologie)
									]);
							},
							A2(
								$elm$core$Maybe$andThen,
								function (structure) {
									return A2(
										$elm$core$Maybe$map,
										$elm$core$Tuple$pair(structure),
										A2($author$project$Components$Produits$StructureCatalogue$Typologies$Model$reglee, model.r6, structure.vk));
								},
								model.h$)))) : _List_Nil,
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: ouvert ? $author$project$I18n$Cles$produitsStructureAjoutOuvrir(i18n) : ''
			},
			model.y);
	});
var $author$project$Components$Produits$StructureCatalogue$Update$NouvelEtatDemande = {$: 35};
var $author$project$Components$Produits$StructureCatalogue$Update$NouvelEtatLibelleSaisi = F2(
	function (a, b) {
		return {$: 34, a: a, b: b};
	});
var $author$project$I18n$Cles$produitsStructureEtatAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.structure.etat.ajouter', _List_Nil, 'Ajouter l\'état');
};
var $author$project$I18n$Cles$produitsStructureEtatAjouterOuvrir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.structure.etat.ajouter.ouvrir', _List_Nil, 'Ajouter un état');
};
var $author$project$Components$Produits$StructureCatalogue$Etats$View$refusLu = F2(
	function (i18n, model) {
		return A2(
			$author$project$Components$Shared$Messages$View$view,
			i18n,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $elm$core$List$singleton, model.aL)));
	});
var $author$project$Components$Produits$StructureCatalogue$Etats$View$ajout = F2(
	function (i18n, model) {
		var saisie = model.a9;
		var ouvert = $author$project$Components$Shared$Drawer$Model$estOuvert(model.br);
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Produits$StructureCatalogue$Update$DeLAjoutDEtat,
			{
				fs: {
					sR: ouvert && (!$author$project$Components$Produits$StructureCatalogue$Controles$enCours(model)),
					Bl: ouvert ? $author$project$I18n$Cles$produitsStructureEtatAjouter(i18n) : '',
					C$: $author$project$Components$Produits$StructureCatalogue$Update$NouvelEtatDemande
				},
				fZ: ouvert ? _List_fromArray(
					[
						A2($author$project$Components$Produits$StructureCatalogue$Etats$View$refusLu, i18n, model),
						A3(
						$author$project$Components$Shared$LibellesParLangue$View$view,
						i18n,
						_List_fromArray(
							[
								$author$project$Components$Produits$StructureCatalogue$Controles$entreeEnvoie($author$project$Components$Produits$StructureCatalogue$Update$NouvelEtatDemande)
							]),
						{
							go: A3($author$project$Components$Produits$StructureCatalogue$Controles$obligatoireManquant, i18n, saisie.b5, saisie.R),
							Ba: $author$project$Referentiel$Langues$desLibelles,
							Bl: $author$project$I18n$Cles$produitsStructureLibelle(i18n),
							hg: $author$project$Components$Produits$StructureCatalogue$Update$NouvelEtatLibelleSaisi,
							pv: $author$project$Components$Produits$StructureCatalogue$Etats$Model$prefixeDuNouvelEtat,
							fm: function (code) {
								return A2($author$project$Components$Shared$LibellesParLangue$Model$lire, code, saisie.R);
							}
						})
					]) : _List_Nil,
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: ouvert ? $author$project$I18n$Cles$produitsStructureEtatAjouterOuvrir(i18n) : ''
			},
			model.br);
	});
var $author$project$Components$Produits$StructureCatalogue$Update$AjoutDeTypologieDemande = {$: 39};
var $author$project$Components$Produits$StructureCatalogue$Update$TypologieFormeElisionBasculee = F2(
	function (a, b) {
		return {$: 72, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Update$TypologieFormeGenreChoisi = F2(
	function (a, b) {
		return {$: 71, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Update$TypologieFormePlurielSaisi = F2(
	function (a, b) {
		return {$: 70, a: a, b: b};
	});
var $author$project$I18n$Cles$produitsEtagesFormesElision = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.etages.formes.elision', _List_Nil, 'L\'article s\'élide devant le nom (« l\'électroménager »)');
};
var $author$project$I18n$Cles$produitsEtagesFormesGenre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.etages.formes.genre', _List_Nil, 'Genre');
};
var $author$project$I18n$Cles$produitsEtagesFormesGenreFeminin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.etages.formes.genre.feminin', _List_Nil, 'Féminin');
};
var $author$project$I18n$Cles$produitsEtagesFormesGenreMasculin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.etages.formes.genre.masculin', _List_Nil, 'Masculin');
};
var $author$project$I18n$Cles$produitsEtagesFormesPluriel = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.etages.formes.pluriel', _List_Nil, 'Pluriel');
};
var $author$project$I18n$Cles$produitsEtagesFormesSingulier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.etages.formes.singulier', _List_Nil, 'Singulier (le nom ci-dessus)');
};
var $author$project$Components$Produits$StructureCatalogue$Etages$View$formesDeLaLangue = F3(
	function (i18n, configuration, langue) {
		var forme = (langue.vx === 'en') ? configuration.c7.yg : configuration.c7.zX;
		var champ = F2(
			function (cle, libelle) {
				return {go: $elm$core$Maybe$Nothing, Aq: configuration.pv + ('-' + (cle + ('-' + langue.vx))), Bl: libelle, he: false};
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('formes'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(langue.vx)
				]),
			_Utils_ap(
				(langue.vx === 'fr') ? _List_Nil : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h4,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$Referentiel$Langues$nom, i18n, langue.vx))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Champ$View$texteEnLectureSeule,
						A2(
							champ,
							'singulier',
							$author$project$I18n$Cles$produitsEtagesFormesSingulier(i18n)),
						{
							fm: configuration.IN(langue.vx)
						}),
						A2(
						$author$project$Components$Shared$Champ$View$texte,
						A2(
							champ,
							'pluriel',
							$author$project$I18n$Cles$produitsEtagesFormesPluriel(i18n)),
						{
							hg: configuration.po(langue.vx),
							fm: forme.bT
						}),
						A2(
						$author$project$Components$Shared$Champ$View$liste,
						A2(
							champ,
							'genre',
							$author$project$I18n$Cles$produitsEtagesFormesGenre(i18n)),
						{
							hg: function (code) {
								return A2(
									configuration.mV,
									langue.vx,
									(code === 'feminin') ? 1 : 0);
							},
							o_: _List_fromArray(
								[
									{
									Bl: $author$project$I18n$Cles$produitsEtagesFormesGenreMasculin(i18n),
									fm: 'masculin'
								},
									{
									Bl: $author$project$I18n$Cles$produitsEtagesFormesGenreFeminin(i18n),
									fm: 'feminin'
								}
								]),
							fm: (forme.M === 1) ? 'feminin' : 'masculin'
						}),
						A2(
						$author$project$Components$Shared$Champ$View$caseACocher,
						A2(
							champ,
							'elision',
							$author$project$I18n$Cles$produitsEtagesFormesElision(i18n)),
						{
							vt: forme.av,
							D9: configuration.lS(langue.vx)
						})
					])));
	});
var $author$project$I18n$Cles$produitsEtagesFormesIntroduction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.etages.formes.introduction', _List_Nil, 'Les phrases de l\'écran en tirent l\'article et le pluriel : « le rangement de l\'électroménager », « 3 catégories ». Le singulier est le nom saisi plus haut.');
};
var $author$project$I18n$Cles$produitsEtagesFormesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.etages.formes.titre', _List_Nil, 'Formes du nom');
};
var $author$project$Components$Produits$StructureCatalogue$Etages$View$formesDuNom = F2(
	function (i18n, configuration) {
		var langues = A2(
			$elm$core$List$filter,
			function (langue) {
				return (langue.vx === 'fr') || (configuration.IN(langue.vx) !== '');
			},
			$author$project$Referentiel$Langues$desLibelles);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('section'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('formes-du-nom')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsEtagesFormesTitre(i18n))
						])),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('introduction')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsEtagesFormesIntroduction(i18n))
							])),
					A2(
						$elm$core$List$map,
						A2($author$project$Components$Produits$StructureCatalogue$Etages$View$formesDeLaLangue, i18n, configuration),
						langues))));
	});
var $author$project$I18n$Cles$produitsTypologiesIndication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.indication', _List_Nil, 'Par exemple : Pièces détachées');
};
var $author$project$Components$Produits$StructureCatalogue$Typologies$View$indicationDeLAjout = F2(
	function (i18n, code) {
		return A2($author$project$Components$Shared$LibellesParLangue$Model$obligatoire, $author$project$Referentiel$Langues$desLibelles, code) ? $elm$core$Maybe$Just(
			$author$project$I18n$Cles$produitsTypologiesIndication(i18n)) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$Produits$StructureCatalogue$Update$TypologieLibelleSaisi = F2(
	function (a, b) {
		return {$: 38, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Typologies$View$libelles = F5(
	function (i18n, indication, model, prefixe, demande) {
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Messages$View$view,
				i18n,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $elm$core$List$singleton, model.aL))),
				A4(
				$author$project$Components$Shared$LibellesParLangue$View$avecIndications,
				i18n,
				indication,
				_List_fromArray(
					[
						$author$project$Components$Produits$StructureCatalogue$Controles$entreeEnvoie(demande)
					]),
				{
					go: A3($author$project$Components$Produits$StructureCatalogue$Controles$obligatoireManquant, i18n, model.qU.b5, model.qU.R),
					Ba: $author$project$Referentiel$Langues$desLibelles,
					Bl: $author$project$I18n$Cles$produitsStructureLibelle(i18n),
					hg: $author$project$Components$Produits$StructureCatalogue$Update$TypologieLibelleSaisi,
					pv: prefixe,
					fm: function (code) {
						return A2($author$project$Components$Shared$LibellesParLangue$Model$lire, code, model.qU.R);
					}
				})
			]);
	});
var $author$project$Components$Produits$StructureCatalogue$Typologies$Model$prefixeDesFormesDeLAjout = 'ajout-formes-de-typologie';
var $author$project$I18n$Cles$produitsTypologiesAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.ajouter', _List_Nil, 'Ajouter');
};
var $author$project$I18n$Cles$produitsTypologiesNouvelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.nouvelle', _List_Nil, 'Nouvelle typologie');
};
var $author$project$Components$Produits$StructureCatalogue$Typologies$View$ajout = F2(
	function (i18n, model) {
		var ouvert = $author$project$Components$Shared$Drawer$Model$estOuvert(model.iG);
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Produits$StructureCatalogue$Update$DeLAjoutDeTypologie,
			{
				fs: {
					sR: ouvert && (!$author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model)),
					Bl: ouvert ? $author$project$I18n$Cles$produitsTypologiesAjouter(i18n) : '',
					C$: $author$project$Components$Produits$StructureCatalogue$Update$AjoutDeTypologieDemande
				},
				fZ: ouvert ? _Utils_ap(
					A5(
						$author$project$Components$Produits$StructureCatalogue$Typologies$View$libelles,
						i18n,
						$author$project$Components$Produits$StructureCatalogue$Typologies$View$indicationDeLAjout(i18n),
						model,
						$author$project$Components$Produits$StructureCatalogue$Typologies$Model$prefixeDeLAjout,
						$author$project$Components$Produits$StructureCatalogue$Update$AjoutDeTypologieDemande),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Produits$StructureCatalogue$Etages$View$formesDuNom,
							i18n,
							{
								lS: $author$project$Components$Produits$StructureCatalogue$Update$TypologieFormeElisionBasculee,
								mV: $author$project$Components$Produits$StructureCatalogue$Update$TypologieFormeGenreChoisi,
								po: $author$project$Components$Produits$StructureCatalogue$Update$TypologieFormePlurielSaisi,
								pv: $author$project$Components$Produits$StructureCatalogue$Typologies$Model$prefixeDesFormesDeLAjout,
								c7: model.mQ,
								IN: function (code) {
									return A2($author$project$Components$Shared$LibellesParLangue$Model$lire, code, model.qU.R);
								}
							})
						])) : _List_Nil,
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: ouvert ? $author$project$I18n$Cles$produitsTypologiesNouvelle(i18n) : ''
			},
			model.iG);
	});
var $author$project$I18n$Cles$produitsParcoursApercuVerification = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.apercu.verification', _List_Nil, 'Le catalogue est prêt à recevoir');
};
var $author$project$I18n$Cles$produitsParcoursApercuVerificationAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.apercu.verification.aucune', _List_Nil, 'aucune référence encore');
};
var $author$project$I18n$Cles$produitsParcoursApercuVerificationCreees = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.parcours.apercu.verification.creees',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' référence créée') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' références créées'));
	});
var $author$project$Components$Produits$StructureCatalogue$View$apercuDeLaVerification = F2(
	function (i18n, embarque) {
		var rangement = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.hA;
				},
				embarque));
		var creees = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.wo;
				},
				embarque));
		var etat = (!creees) ? $author$project$I18n$Cles$produitsParcoursApercuVerificationAucune(i18n) : A2(
			$author$project$I18n$Cles$produitsParcoursApercuVerificationCreees,
			i18n,
			{w: creees});
		var categorie = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.uK;
			},
			embarque);
		return {
			gV: _Utils_ap(
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (i, texte) {
							return {dX: i < 2, eW: i, Jx: texte};
						}),
					rangement),
				_List_fromArray(
					[
						{
						dX: false,
						eW: $elm$core$List$length(rangement),
						Jx: A2(
							$elm$core$String$join,
							' · ',
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_List_fromArray(
									[
										categorie,
										$elm$core$Maybe$Just(etat)
									])))
					}
					])),
			h6: $elm$core$Maybe$Just(
				$author$project$I18n$Cles$produitsParcoursApercuVerification(i18n))
		};
	});
var $author$project$I18n$Cles$produitsParcoursApercuInformationsAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.apercu.informations.aucune', _List_Nil, 'aucune information encore');
};
var $author$project$I18n$Cles$produitsParcoursApercuInformationsAucuneCategorie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.apercu.informations.aucune-categorie', _List_Nil, 'Aucune catégorie encore');
};
var $author$project$I18n$Cles$produitsParcoursApercuInformationsNombre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.parcours.apercu.informations.nombre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' information') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' informations'));
	});
var $author$project$Components$Produits$StructureCatalogue$Apercu$categories = F2(
	function (i18n, types) {
		var _v0 = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Basics$not,
				function ($) {
					return $.tE;
				}),
			types);
		if (!_v0.b) {
			return _List_fromArray(
				[
					{
					dX: false,
					eW: 0,
					Jx: $author$project$I18n$Cles$produitsParcoursApercuInformationsAucuneCategorie(i18n)
				}
				]);
		} else {
			var ouvertes = _v0;
			return A2(
				$elm$core$List$concatMap,
				function (categorie) {
					return _List_fromArray(
						[
							{dX: true, eW: 0, Jx: categorie.Dj.zX},
							{
							dX: false,
							eW: 1,
							Jx: (!categorie.dw) ? $author$project$I18n$Cles$produitsParcoursApercuInformationsAucune(i18n) : A2(
								$author$project$I18n$Cles$produitsParcoursApercuInformationsNombre,
								i18n,
								{w: categorie.dw})
						}
						]);
				},
				ouvertes);
		}
	});
var $author$project$I18n$Cles$produitsParcoursApercuInformationsEtat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.apercu.informations.etat', _List_Nil, 'Son état');
};
var $author$project$Components$Produits$StructureCatalogue$Apercu$etats = F2(
	function (i18n, structure) {
		return _List_fromArray(
			[
				{
				dX: true,
				eW: 0,
				Jx: $author$project$I18n$Cles$produitsParcoursApercuInformationsEtat(i18n)
			},
				{
				dX: false,
				eW: 1,
				Jx: A2(
					$elm$core$String$join,
					' · ',
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Produits$StructureCatalogue$Etats$Model$libelleDeLEtat,
							$author$project$I18n$Cles$texte(i18n)),
						structure.mj))
			}
			]);
	});
var $author$project$I18n$Cles$produitsParcoursApercuInformations = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.apercu.informations', _List_Nil, 'Ce qu\'un four demandera');
};
var $author$project$I18n$Cles$produitsParcoursApercuRangement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.apercu.rangement', _List_Nil, 'Chaque typologie a son rangement');
};
var $author$project$I18n$Cles$produitsParcoursApercuValeurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.apercu.valeurs', _List_Nil, 'L\'arbre se remplit');
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$chemin = F3(
	function (i18n, niveaux, etages) {
		return A2(
			$elm$core$String$join,
			' › ',
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Produits$StructureCatalogue$Etages$Model$nom(niveaux),
					$author$project$I18n$Cles$texte(i18n)),
				etages));
	});
var $author$project$Components$Produits$StructureCatalogue$Apercu$rangement = F2(
	function (i18n, structure) {
		var _v0 = $author$project$Components$Produits$StructureCatalogue$Typologies$Model$de(structure.vk);
		if (!_v0.b) {
			var _v1 = A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$libelleDuNiveau,
					$author$project$I18n$Cles$texte(i18n)),
				A2(
					$elm$core$List$filter,
					function ($) {
						return $.Kg;
					},
					structure.C9));
			if (!_v1.b) {
				return _List_Nil;
			} else {
				var etages = _v1;
				return _List_fromArray(
					[
						{
						dX: false,
						eW: 0,
						Jx: A2($elm$core$String$join, ' › ', etages)
					}
					]);
			}
		} else {
			var servies = _v0;
			return A2(
				$elm$core$List$concatMap,
				function (typologie) {
					return _List_fromArray(
						[
							{
							dX: true,
							eW: 0,
							Jx: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(typologie)
						},
							{
							dX: false,
							eW: 1,
							Jx: A3($author$project$Components$Produits$StructureCatalogue$Etages$Model$chemin, i18n, structure.C9, typologie.yG)
						}
						]);
				},
				servies);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$estVide = function (classification) {
	return $elm$core$List$isEmpty(classification.Ki) && $elm$core$List$isEmpty(classification.Di);
};
var $author$project$I18n$Cles$produitsParcoursApercuTypologiesAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.apercu.typologies.aucune', _List_Nil, 'Aucune typologie encore');
};
var $author$project$I18n$Cles$produitsParcoursApercuTypologiesDeux = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.apercu.typologies.deux', _List_Nil, 'Deux typologies');
};
var $author$project$I18n$Cles$produitsParcoursApercuTypologiesPlusieurs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.parcours.apercu.typologies.plusieurs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			p.w + ' typologies');
	});
var $author$project$I18n$Cles$produitsParcoursApercuTypologiesUne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.apercu.typologies.une', _List_Nil, 'Une typologie');
};
var $author$project$I18n$Cles$produitsParcoursApercuTypologiesVidesDeux = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.apercu.typologies.vides.deux', _List_Nil, 'Deux typologies, encore vides');
};
var $author$project$I18n$Cles$produitsParcoursApercuTypologiesVidesPlusieurs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.parcours.apercu.typologies.vides.plusieurs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			p.w + ' typologies, encore vides');
	});
var $author$project$I18n$Cles$produitsParcoursApercuTypologiesVidesUne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.apercu.typologies.vides.une', _List_Nil, 'Une typologie, encore vide');
};
var $author$project$Components$Produits$StructureCatalogue$Apercu$titreDesTypologies = F2(
	function (i18n, fournies) {
		var vides = A2($elm$core$List$all, $author$project$Components$Produits$StructureCatalogue$Classifications$Model$estVide, fournies);
		var _v0 = $elm$core$List$length(fournies);
		switch (_v0) {
			case 0:
				return $author$project$I18n$Cles$produitsParcoursApercuTypologiesAucune(i18n);
			case 1:
				return vides ? $author$project$I18n$Cles$produitsParcoursApercuTypologiesVidesUne(i18n) : $author$project$I18n$Cles$produitsParcoursApercuTypologiesUne(i18n);
			case 2:
				return vides ? $author$project$I18n$Cles$produitsParcoursApercuTypologiesVidesDeux(i18n) : $author$project$I18n$Cles$produitsParcoursApercuTypologiesDeux(i18n);
			default:
				var nombre = _v0;
				return (vides ? $author$project$I18n$Cles$produitsParcoursApercuTypologiesVidesPlusieurs(i18n) : $author$project$I18n$Cles$produitsParcoursApercuTypologiesPlusieurs(i18n))(
					{
						w: $elm$core$String$fromInt(nombre)
					});
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Apercu$typologies = function (structure) {
	return A2(
		$elm$core$List$map,
		function (typologie) {
			return {
				dX: true,
				eW: 0,
				Jx: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(typologie)
			};
		},
		$author$project$Components$Produits$StructureCatalogue$Typologies$Model$de(structure.vk));
};
var $author$project$Components$Produits$StructureCatalogue$Apercu$DesCategories = 3;
var $author$project$Components$Produits$StructureCatalogue$Apercu$DesGammes = 1;
var $author$project$Components$Produits$StructureCatalogue$Apercu$DesMarques = 0;
var $author$project$Components$Produits$StructureCatalogue$Apercu$Nommee = 2;
var $author$project$Components$Produits$StructureCatalogue$Apercu$regroupes = A2(
	$elm$core$List$foldl,
	F2(
		function (nomme, groupes) {
			return A2(
				$elm$core$List$any,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$first,
					$elm$core$Basics$eq(nomme.Dj)),
				groupes) ? A2(
				$elm$core$List$map,
				function (_v0) {
					var nom = _v0.a;
					var ids = _v0.b;
					return _Utils_eq(nom, nomme.Dj) ? _Utils_Tuple2(
						nom,
						_Utils_ap(
							ids,
							_List_fromArray(
								[nomme.ou.Aq]))) : _Utils_Tuple2(nom, ids);
				},
				groupes) : _Utils_ap(
				groupes,
				_List_fromArray(
					[
						_Utils_Tuple2(
						nomme.Dj,
						_List_fromArray(
							[nomme.ou.Aq]))
					]));
		}),
	_List_Nil);
var $author$project$Components$Produits$StructureCatalogue$Apercu$sorteDe = function (etage) {
	var _v0 = etage.xt;
	if (_v0.$ === 1) {
		return 2;
	} else {
		var code = _v0.a;
		return etage.wL ? 3 : (_Utils_eq(code, $author$project$Catalogue$Vocabulaire$codeMarque) ? 0 : (_Utils_eq(code, $author$project$Catalogue$Vocabulaire$codeGamme) ? 1 : 2));
	}
};
var $author$project$Components$Produits$StructureCatalogue$Apercu$surLEtage = F4(
	function (noms, typologie, etage, parents) {
		var sousLesParents = function (noeud) {
			if (parents.$ === 1) {
				return true;
			} else {
				var ids = parents.a;
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (parent) {
							return A2($elm$core$List$member, parent, ids);
						},
						noeud.ey));
			}
		};
		return A2(
			$elm$core$List$filterMap,
			function (noeud) {
				return A2(
					$elm$core$Maybe$map,
					function (nom) {
						return {ou: noeud, Dj: nom};
					},
					A3($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$nomDe, noms, typologie, noeud.fm));
			},
			A2(
				$elm$core$List$filter,
				function (noeud) {
					return _Utils_eq(noeud.md, etage.Aq) && ((!noeud.iz) && sousLesParents(noeud));
				},
				typologie.Di));
	});
var $author$project$Components$Produits$StructureCatalogue$Apercu$descente = F5(
	function (noms, typologie, retrait, etages, parents) {
		if (!etages.b) {
			return _List_Nil;
		} else {
			var etage = etages.a;
			var suivants = etages.b;
			return A2(
				$elm$core$List$concatMap,
				function (_v1) {
					var nom = _v1.a;
					var ids = _v1.b;
					return A2(
						$elm$core$List$cons,
						{
							dX: $author$project$Components$Produits$StructureCatalogue$Apercu$sorteDe(etage) !== 3,
							eW: retrait,
							Jx: nom
						},
						A5(
							$author$project$Components$Produits$StructureCatalogue$Apercu$descente,
							noms,
							typologie,
							retrait + 1,
							suivants,
							$elm$core$Maybe$Just(ids)));
				},
				$author$project$Components$Produits$StructureCatalogue$Apercu$regroupes(
					A4($author$project$Components$Produits$StructureCatalogue$Apercu$surLEtage, noms, typologie, etage, parents)));
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Apercu$arbre = F2(
	function (noms, typologie) {
		var joints = F2(
			function (retrait, nomsJoints) {
				if (!nomsJoints.b) {
					return _List_Nil;
				} else {
					return _List_fromArray(
						[
							{
							dX: false,
							eW: retrait,
							Jx: A2($elm$core$String$join, ' · ', nomsJoints)
						}
						]);
				}
			});
		var etagesDe = function (sorte) {
			return A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Produits$StructureCatalogue$Apercu$sorteDe,
					$elm$core$Basics$eq(sorte)),
				typologie.yG);
		};
		var suivants = _Utils_ap(
			etagesDe(2),
			etagesDe(3));
		var sousLaMarque = F2(
			function (marque, gammes) {
				var lesGammes = A2(
					$elm$core$List$concatMap,
					function (gamme) {
						return A4(
							$author$project$Components$Produits$StructureCatalogue$Apercu$surLEtage,
							noms,
							typologie,
							gamme,
							$elm$core$Maybe$Just(
								_List_fromArray(
									[marque.ou.Aq])));
					},
					gammes);
				var rangees = A2(
					$elm$core$List$map,
					function (gamme) {
						return _Utils_Tuple2(
							gamme,
							A5(
								$author$project$Components$Produits$StructureCatalogue$Apercu$descente,
								noms,
								typologie,
								3,
								suivants,
								$elm$core$Maybe$Just(
									_List_fromArray(
										[gamme.ou.Aq]))));
					},
					lesGammes);
				return A2(
					$elm$core$List$all,
					A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$List$isEmpty),
					rangees) ? A2(
					joints,
					2,
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$first,
						$author$project$Components$Produits$StructureCatalogue$Apercu$regroupes(lesGammes))) : A2(
					$elm$core$List$concatMap,
					function (_v3) {
						var gamme = _v3.a;
						var dessous = _v3.b;
						return A2(
							$elm$core$List$cons,
							{dX: false, eW: 2, Jx: gamme.Dj},
							dessous);
					},
					rangees);
			});
		var marques = function () {
			var _v0 = _Utils_Tuple2(
				etagesDe(0),
				etagesDe(1));
			if (_v0.a.b && (!_v0.a.b.b)) {
				if (!_v0.b.b) {
					var _v1 = _v0.a;
					var etage = _v1.a;
					return A2(
						joints,
						1,
						A2(
							$elm$core$List$map,
							$elm$core$Tuple$first,
							$author$project$Components$Produits$StructureCatalogue$Apercu$regroupes(
								A4($author$project$Components$Produits$StructureCatalogue$Apercu$surLEtage, noms, typologie, etage, $elm$core$Maybe$Nothing))));
				} else {
					var _v2 = _v0.a;
					var etage = _v2.a;
					var gammes = _v0.b;
					return A2(
						$elm$core$List$concatMap,
						function (marque) {
							return A2(
								$elm$core$List$cons,
								{dX: true, eW: 1, Jx: marque.Dj},
								A2(sousLaMarque, marque, gammes));
						},
						A4($author$project$Components$Produits$StructureCatalogue$Apercu$surLEtage, noms, typologie, etage, $elm$core$Maybe$Nothing));
				}
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$elm$core$List$cons,
			{
				dX: true,
				eW: 0,
				Jx: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(typologie)
			},
			_Utils_ap(
				marques,
				(($elm$core$List$length(
					etagesDe(0)) !== 1) || $elm$core$List$isEmpty(
					etagesDe(1))) ? A5($author$project$Components$Produits$StructureCatalogue$Apercu$descente, noms, typologie, 1, suivants, $elm$core$Maybe$Nothing) : _List_Nil));
	});
var $author$project$Components$Produits$StructureCatalogue$Apercu$valeurs = F2(
	function (model, structure) {
		return A2(
			$elm$core$List$concatMap,
			$author$project$Components$Produits$StructureCatalogue$Apercu$arbre(
				$author$project$Components$Produits$StructureCatalogue$Valeurs$Lecture$noms(model)),
			$author$project$Components$Produits$StructureCatalogue$Typologies$Model$de(structure.vk));
	});
var $author$project$Components$Produits$StructureCatalogue$Apercu$de = F3(
	function (i18n, etape, model) {
		var deLaStructure = function (lire) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, lire, model.h$));
		};
		switch (etape) {
			case 0:
				return {
					gV: deLaStructure($author$project$Components$Produits$StructureCatalogue$Apercu$typologies),
					h6: A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.vk;
							},
							A2(
								$elm$core$Basics$composeR,
								$author$project$Components$Produits$StructureCatalogue$Typologies$Model$de,
								$author$project$Components$Produits$StructureCatalogue$Apercu$titreDesTypologies(i18n))),
						model.h$)
				};
			case 4:
				return {gV: _List_Nil, h6: $elm$core$Maybe$Nothing};
			case 1:
				return {
					gV: deLaStructure(
						$author$project$Components$Produits$StructureCatalogue$Apercu$rangement(i18n)),
					h6: $elm$core$Maybe$Just(
						$author$project$I18n$Cles$produitsParcoursApercuRangement(i18n))
				};
			case 2:
				return {
					gV: deLaStructure(
						$author$project$Components$Produits$StructureCatalogue$Apercu$valeurs(model)),
					h6: $elm$core$Maybe$Just(
						$author$project$I18n$Cles$produitsParcoursApercuValeurs(i18n))
				};
			default:
				return {
					gV: _Utils_ap(
						deLaStructure(
							$author$project$Components$Produits$StructureCatalogue$Apercu$etats(i18n)),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.ib;
									},
									$author$project$Components$Produits$StructureCatalogue$Apercu$categories(i18n)),
								model.dt.aS))),
					h6: $elm$core$Maybe$Just(
						$author$project$I18n$Cles$produitsParcoursApercuInformations(i18n))
				};
		}
	});
var $author$project$I18n$Cles$produitsParcoursApercu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.apercu', _List_Nil, 'Aperçu du catalogue');
};
var $author$project$Components$Produits$StructureCatalogue$View$apercu = F4(
	function (i18n, courante, embarque, model) {
		return A3(
			$author$project$Components$Shared$Parcours$View$apercu,
			i18n,
			$author$project$I18n$Cles$produitsParcoursApercu(i18n),
			(courante === 4) ? A2($author$project$Components$Produits$StructureCatalogue$View$apercuDeLaVerification, i18n, embarque) : A3($author$project$Components$Produits$StructureCatalogue$Apercu$de, i18n, courante, model));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$ArticlesDEtageAjoutes = {$: 105};
var $author$project$Components$Produits$StructureCatalogue$Update$ArticleCoche = F2(
	function (a, b) {
		return {$: 116, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Update$FiltreDArticlesBascule = F2(
	function (a, b) {
		return {$: 117, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Update$FiltreDArticlesChoisi = F2(
	function (a, b) {
		return {$: 118, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Update$PageDArticles = function (a) {
	return {$: 115, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$TermeDArticlesSaisi = function (a) {
	return {$: 114, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$messagesDuChoix = {i5: $author$project$Components$Produits$StructureCatalogue$Update$ArticleCoche, kl: $elm$core$Maybe$Nothing, mD: $author$project$Components$Produits$StructureCatalogue$Update$FiltreDArticlesBascule, mE: $author$project$Components$Produits$StructureCatalogue$Update$FiltreDArticlesChoisi, EE: $author$project$Components$Produits$StructureCatalogue$Update$PageDArticles, rC: $author$project$Components$Produits$StructureCatalogue$Update$TermeDArticlesSaisi};
var $author$project$Components$Produits$StructureCatalogue$Update$EtageEnregistre = {$: 101};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$vide_ = {
	fs: {sR: false, Bl: '', C$: $author$project$Components$Produits$StructureCatalogue$Update$EtageEnregistre},
	fZ: _List_Nil,
	A6: $elm$core$Maybe$Nothing,
	Bc: false,
	h6: ''
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$choixDEtage = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.tP, model.s);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var lu = _v0.a.a;
			var ouvert = _v0.b.a;
			return A4(
				$author$project$Components$Shared$Drawer$View$view,
				i18n,
				$author$project$Components$Produits$StructureCatalogue$Update$DuChoixDEtage,
				{
					fs: {
						sR: $author$project$Components$Produits$Common$ChoixDArticles$nombreCoche(lu) > 0,
						Bl: A2(
							$author$project$I18n$Cles$produitsReferenceLiensAjouterN,
							i18n,
							{
								w: $author$project$Components$Produits$Common$ChoixDArticles$nombreCoche(lu)
							}),
						C$: $author$project$Components$Produits$StructureCatalogue$Update$ArticlesDEtageAjoutes
					},
					fZ: A5(
						$author$project$Components$Produits$Common$ChoixDArticlesView$contenu,
						i18n,
						model,
						$author$project$Components$Produits$StructureCatalogue$Informations$View$messagesDuChoix,
						A2(
							$elm$core$List$map,
							function ($) {
								return $.Aq;
							},
							A2($author$project$Components$Produits$StructureCatalogue$Informations$Etage$articlesDe, lu.dy, ouvert)),
						lu),
					A6: $elm$core$Maybe$Nothing,
					Bc: true,
					h6: $author$project$I18n$Cles$produitsReferenceLiensChoisirTitre(i18n)
				},
				model.dM);
		} else {
			return A4($author$project$Components$Shared$Drawer$View$view, i18n, $author$project$Components$Produits$StructureCatalogue$Update$DuChoixDEtage, $author$project$Components$Produits$StructureCatalogue$Informations$View$vide_, model.dM);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Update$PerimetreRetenu = {$: 111};
var $author$project$Components$Produits$StructureCatalogue$Update$PerimetreSelectionne = function (a) {
	return {$: 110, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$TermeDePerimetreSaisi = function (a) {
	return {$: 108, a: a};
};
var $author$project$I18n$Cles$produitsInformationsEtagePerimetresIllisibles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.etage.perimetres-illisibles', _List_Nil, 'La liste des périmètres n\'a pas pu être lue. Fermez ce panneau et réessayez.');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$choixDePerimetre = F2(
	function (i18n, model) {
		var terme = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.h3;
				},
				model.fO));
		var segment = function (s) {
			return s.dX ? A2(
				$rtfeldman$elm_css$Html$Styled$strong,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(s.Jx)
					])) : $rtfeldman$elm_css$Html$Styled$text(s.Jx);
		};
		var proposes = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.pg;
					},
					$author$project$Components$Produits$Common$ChoixDUnPerimetre$proposables),
				model.cl));
		var choisi = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.vd;
			},
			model.fO);
		var ligne = function (lu) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$li,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'selectionne',
								_Utils_eq(
									$elm$core$Maybe$Just(lu.Aq),
									choisi))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('perimetre-propose'),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-pressed',
								_Utils_eq(
									$elm$core$Maybe$Just(lu.Aq),
									choisi) ? 'true' : 'false'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Produits$StructureCatalogue$Update$PerimetreSelectionne(lu.Aq))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('main')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$strong,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('title')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(lu.Dj)
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('criteres')
											]),
										A2($elm$core$List$map, segment, lu.wp))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('infos')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$produitsReferenceLiensPerimetreDecompte,
											i18n,
											{w: lu.wT}))
									]))
							]))
					]));
		};
		return _Utils_eq(model.fO, $elm$core$Maybe$Nothing) ? A4($author$project$Components$Shared$Drawer$View$view, i18n, $author$project$Components$Produits$StructureCatalogue$Update$DuChoixDePerimetre, $author$project$Components$Produits$StructureCatalogue$Informations$View$vide_, model.dN) : A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Produits$StructureCatalogue$Update$DuChoixDePerimetre,
			{
				fs: {
					sR: !_Utils_eq(choisi, $elm$core$Maybe$Nothing),
					Bl: $author$project$I18n$Cles$produitsReferenceLiensChoisirCePerimetre(i18n),
					C$: $author$project$Components$Produits$StructureCatalogue$Update$PerimetreRetenu
				},
				fZ: ($elm$core$List$isEmpty(proposes) && ((terme === '') && (!_Utils_eq(model.cl, $elm$core$Maybe$Nothing)))) ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsReferenceLiensAucunPerimetre(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsReferenceLiensAucunPerimetreAide(i18n))
									]))
							]))
					]) : _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Champ$View$texte,
						{
							go: $elm$core$Maybe$Nothing,
							Aq: 'terme-de-perimetre',
							Bl: $author$project$I18n$Cles$produitsReferenceLiensRechercherUnPerimetre(i18n),
							he: false
						},
						{hg: $author$project$Components$Produits$StructureCatalogue$Update$TermeDePerimetreSaisi, fm: terme}),
						A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.AJ;
							},
							model.fO)) ? A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('refus'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsInformationsEtagePerimetresIllisibles(i18n))
							])) : $rtfeldman$elm_css$Html$Styled$text(''),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('perimetres')
							]),
						A2($elm$core$List$map, ligne, proposes)),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsReferenceLiensArchivesNonProposes(i18n))
							]))
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: $author$project$I18n$Cles$produitsReferenceLiensChoisirUnPerimetre(i18n)
			},
			model.dN);
	});
var $author$project$Components$Produits$StructureCatalogue$Update$DeLaCorrespondance = function (a) {
	return {$: 49, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$ValeurCorrespondue = F2(
	function (a, b) {
		return {$: 54, a: a, b: b};
	});
var $author$project$I18n$Cles$produitsTypologiesArchiverCorrespondanceAranger = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.correspondance.aranger', _List_Nil, 'À ranger (par défaut)');
};
var $author$project$Components$Produits$StructureCatalogue$Archivage$View$groupe = F3(
	function (i18n, archivage, etage) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('groupe')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$I18n$Cles$texte, i18n, etage.md))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (ligne) {
							var choisie = A2(
								$elm$core$Maybe$map,
								$elm$core$Tuple$second,
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$Tuple$first,
											$elm$core$Basics$eq(ligne.IR)),
										archivage.Ki)));
							return A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('source')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(ligne.Dj)
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$select,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Events$onInput(
												$author$project$Components$Produits$StructureCatalogue$Update$ValeurCorrespondue(ligne.IR)),
												$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
												archivage.a6.d8 || (!_Utils_eq(archivage.a6.qD, $elm$core$Maybe$Nothing)))
											]),
										A2(
											$elm$core$List$cons,
											A2(
												$rtfeldman$elm_css$Html$Styled$option,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$value(''),
														$rtfeldman$elm_css$Html$Styled$Attributes$selected(
														_Utils_eq(choisie, $elm$core$Maybe$Nothing))
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$produitsTypologiesArchiverCorrespondanceAranger(i18n))
													])),
											A2(
												$elm$core$List$indexedMap,
												F2(
													function (rang, _v0) {
														var valeur = _v0.a;
														var nom = _v0.b;
														return A2(
															$rtfeldman$elm_css$Html$Styled$option,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$value(
																	$elm$core$String$fromInt(rang)),
																	$rtfeldman$elm_css$Html$Styled$Attributes$selected(
																	_Utils_eq(
																		choisie,
																		$elm$core$Maybe$Just(valeur)))
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(nom)
																]));
													}),
												ligne.o_)))
									]));
						},
						etage.gV))
				]));
	});
var $author$project$I18n$Cles$produitsTypologiesArchiverCorrespondanceIntro = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.correspondance.intro', _List_Nil, 'Pour chaque valeur d\'étage des catégories migrées, choisissez sa valeur dans la cible. Une valeur laissée sans choix devient « À ranger » : elle n\'est jamais refusée.');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverCorrespondanceNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.correspondance.note', _List_Nil, 'Seuls les étages de la source qui existent encore dans la cible sont proposés. Les catégories clôturées n\'ont pas de correspondance.');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverCorrespondanceTitreDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.typologies.archiver.correspondance.titre.de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'source',
					$author$project$I18n$Traductions$Chaine(p.IR)),
					_Utils_Tuple2(
					'cible',
					$author$project$I18n$Traductions$Chaine(p.vf))
				]),
			'Correspondance : ' + (p.IR + (' → ' + p.vf)));
	});
var $author$project$I18n$Cles$produitsTypologiesArchiverCorrespondanceValider = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.correspondance.valider', _List_Nil, 'Valider la correspondance');
};
var $author$project$Components$Produits$StructureCatalogue$Archivage$View$correspondance = F2(
	function (i18n, model) {
		var nomDe = function (id) {
			return A2(
				$elm$core$Maybe$map,
				$author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom,
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.vk;
						},
						$author$project$Components$Produits$StructureCatalogue$Classifications$Model$classificationDe(id)),
					model.h$));
		};
		var archivage = model.tD;
		var titre = A3(
			$elm$core$Maybe$map2,
			F2(
				function (source, cible) {
					return A2(
						$author$project$I18n$Cles$produitsTypologiesArchiverCorrespondanceTitreDe,
						i18n,
						{vf: cible, IR: source});
				}),
			A2($elm$core$Maybe$andThen, nomDe, archivage.r3),
			A2($elm$core$Maybe$andThen, nomDe, archivage.vf));
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Produits$StructureCatalogue$Update$DeLaCorrespondance,
			{
				fs: {
					sR: !_Utils_eq(titre, $elm$core$Maybe$Nothing),
					Bl: _Utils_eq(titre, $elm$core$Maybe$Nothing) ? '' : $author$project$I18n$Cles$produitsTypologiesArchiverCorrespondanceValider(i18n),
					C$: $author$project$Components$Produits$StructureCatalogue$Update$DeLaCorrespondance($author$project$Components$Shared$Drawer$Update$Fermer)
				},
				fZ: _Utils_eq(titre, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('intro')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsTypologiesArchiverCorrespondanceIntro(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('groupes')
							]),
						A2(
							$elm$core$List$map,
							A2($author$project$Components$Produits$StructureCatalogue$Archivage$View$groupe, i18n, archivage),
							$author$project$Components$Produits$StructureCatalogue$Archivage$Update$groupesDe(model))),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsTypologiesArchiverCorrespondanceNote(i18n))
							]))
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: true,
				h6: A2($elm$core$Maybe$withDefault, '', titre)
			},
			archivage.wg);
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$CreationDemandee = {$: 8};
var $author$project$Components$Produits$StructureCatalogue$Categories$Model$Nature = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Model$Nom = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$Saisi = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Model$erreurDuNom = function (saisie) {
	return saisie.b5 && (!$elm$core$List$isEmpty(
		A2($author$project$Components$Shared$LibellesParLangue$Model$manquantes, $author$project$Referentiel$Langues$desLibelles, saisie.R)));
};
var $author$project$I18n$Cles$produitsTypesEnDouble = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.en-double', _List_Nil, 'Cette catégorie existe déjà.');
};
var $author$project$Components$Produits$StructureCatalogue$Categories$View$erreurDuNom = F3(
	function (i18n, saisie, code) {
		return (!A2($author$project$Components$Shared$LibellesParLangue$Model$obligatoire, $author$project$Referentiel$Langues$desLibelles, code)) ? $elm$core$Maybe$Nothing : ($author$project$Components$Produits$StructureCatalogue$Categories$Model$erreurDuNom(saisie) ? $elm$core$Maybe$Just(
			$author$project$I18n$Cles$produitsCatalogueChampNomObligatoire(i18n)) : (saisie.gi ? $elm$core$Maybe$Just(
			$author$project$I18n$Cles$produitsTypesEnDouble(i18n)) : $elm$core$Maybe$Nothing));
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$View$permise = function (annuaire) {
	return A2(
		$elm$core$Maybe$map,
		function (_v0) {
			return 0;
		},
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUnType, annuaire.nQ));
};
var $author$project$I18n$Cles$produitsTypesChampNature = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.champ.nature', _List_Nil, 'Nature par défaut');
};
var $author$project$I18n$Cles$produitsTypesCreer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.creer', _List_Nil, 'Créer la catégorie');
};
var $author$project$I18n$Cles$produitsTypesNouveau = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.types.nouveau', _List_Nil, 'Nouvelle catégorie');
};
var $author$project$I18n$Cles$produitsValeursCategorieRestaurer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.categorie.restaurer', _List_Nil, 'Restaurer et ranger');
};
var $author$project$I18n$Cles$produitsValeursCategorieRestaurerSous = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.categorie.restaurer.sous',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			'Restaurer et ranger sous « ' + (p.fm + ' »'));
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$View$creation = F2(
	function (i18n, model) {
		var saisie = model.hP;
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.kX);
		var contenu = function () {
			var _v4 = model.aS;
			if (!_v4.$) {
				var annuaire = _v4.a;
				return _Utils_eq(
					$author$project$Components$Produits$StructureCatalogue$Categories$View$permise(annuaire),
					$elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Messages$View$view,
						i18n,
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2($elm$core$Maybe$map, $elm$core$List$singleton, saisie.pZ))),
						A3(
						$author$project$Components$Shared$LibellesParLangue$View$view,
						i18n,
						_List_Nil,
						{
							go: A2($author$project$Components$Produits$StructureCatalogue$Categories$View$erreurDuNom, i18n, saisie),
							Ba: $author$project$Referentiel$Langues$desLibelles,
							Bl: $author$project$I18n$Cles$produitsCatalogueChampNom(i18n),
							hg: $author$project$Components$Produits$StructureCatalogue$Categories$Model$Nom,
							pv: $author$project$Components$Produits$StructureCatalogue$Categories$Model$prefixeDuNom(model),
							fm: function (code) {
								return A2($author$project$Components$Shared$LibellesParLangue$Model$lire, code, saisie.R);
							}
						}),
						A2(
						$author$project$Components$Shared$Champ$View$liste,
						{
							go: $elm$core$Maybe$Nothing,
							Aq: prefixe + '-nature',
							Bl: $author$project$I18n$Cles$produitsTypesChampNature(i18n),
							he: true
						},
						{
							hg: $author$project$Components$Produits$StructureCatalogue$Categories$Model$Nature,
							o_: A2(
								$author$project$Catalogue$Vocabulaire$naturesProposees,
								i18n,
								$elm$core$List$isEmpty(model.oo) ? annuaire.oo : model.oo),
							fm: saisie.g1
						})
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Produits$StructureCatalogue$Categories$Update$DuDrawer,
			{
				fs: {
					sR: (!$elm$core$List$isEmpty(contenu)) && (!$author$project$Components$Produits$Common$Envoi$enCours(model.l2)),
					Bl: function () {
						var _v0 = _Utils_Tuple2(
							$elm$core$List$isEmpty(contenu),
							model.hA);
						if (_v0.a) {
							return '';
						} else {
							if (!_v0.b.$) {
								var archivee = _v0.b.a.tI;
								var ouverture = _v0.b.a.ew;
								return archivee ? A2(
									$elm$core$Maybe$withDefault,
									$author$project$I18n$Cles$produitsValeursCategorieRestaurer(i18n),
									A2(
										$elm$core$Maybe$map,
										function (valeur) {
											return A2(
												$author$project$I18n$Cles$produitsValeursCategorieRestaurerSous,
												i18n,
												{fm: valeur});
										},
										ouverture.Dn)) : $author$project$I18n$Cles$produitsTypesCreer(i18n);
							} else {
								var _v1 = _v0.b;
								return $author$project$I18n$Cles$produitsTypesCreer(i18n);
							}
						}
					}(),
					C$: $author$project$Components$Produits$StructureCatalogue$Categories$Update$CreationDemandee
				},
				fZ: A2(
					$elm$core$List$map,
					$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Produits$StructureCatalogue$Categories$Update$Saisi),
					contenu),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: function () {
					var _v2 = _Utils_Tuple2(
						$elm$core$List$isEmpty(contenu),
						model.hA);
					if (_v2.a) {
						return '';
					} else {
						if (!_v2.b.$) {
							var rangement = _v2.b.a;
							return A2($author$project$I18n$Cles$texte, i18n, rangement.ew.h6);
						} else {
							var _v3 = _v2.b;
							return $author$project$I18n$Cles$produitsTypesNouveau(i18n);
						}
					}
				}()
			},
			model.kX);
	});
var $author$project$Components$Produits$StructureCatalogue$Gammes$Update$CreationDemandee = {$: 6};
var $author$project$Components$Produits$StructureCatalogue$Gammes$Update$Saisi = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Gammes$View$creation = F2(
	function (i18n, model) {
		var vide = {
			fs: {sR: false, Bl: '', C$: $author$project$Components$Produits$StructureCatalogue$Gammes$Update$CreationDemandee},
			fZ: _List_Nil,
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: ''
		};
		var contenu = function () {
			var _v0 = _Utils_Tuple2(
				model.ew,
				$author$project$Components$Shared$Drawer$Model$estOuvert(model.kX));
			if ((!_v0.a.$) && _v0.b) {
				var ouverture = _v0.a.a;
				var tournures = $author$project$Catalogue$Vocabulaire$tournures(
					{fA: $author$project$Catalogue$Vocabulaire$codeGamme, Bl: $elm$core$Maybe$Nothing});
				return A4(
					$author$project$Components$Produits$Common$GammeAAjouter$contenu,
					i18n,
					{
						sO: !$author$project$Components$Produits$Common$Envoi$enCours(model.l2),
						f4: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.wD;
							},
							model.fY),
						gi: tournures.gi,
						gG: $author$project$Components$Produits$StructureCatalogue$Gammes$Model$gammesConnues(model),
						gX: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.Dj;
							},
							ouverture.gX),
						hu: A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.hu;
								},
								model.fY)),
						pv: $author$project$Components$Shared$Drawer$Model$idRacine(model.kX),
						fd: _Utils_update(
							tournures,
							{Dj: ouverture.md})
					},
					{hO: $author$project$Components$Produits$StructureCatalogue$Gammes$Update$Saisi, sj: $author$project$Components$Produits$StructureCatalogue$Gammes$Update$CreationDemandee},
					model.hP);
			} else {
				return vide;
			}
		}();
		return A4($author$project$Components$Shared$Drawer$View$view, i18n, $author$project$Components$Produits$StructureCatalogue$Gammes$Update$DuDrawer, contenu, model.kX);
	});
var $author$project$Components$Produits$StructureCatalogue$Marques$Update$CreationDemandee = {$: 7};
var $author$project$Components$Produits$StructureCatalogue$Marques$Update$RestaurationDemandee = {$: 8};
var $author$project$Components$Produits$StructureCatalogue$Marques$Update$Saisi = function (a) {
	return {$: 6, a: a};
};
var $author$project$I18n$Cles$produitsCatalogueMarqueArchiveeIntroduction = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.marque.archivee-introduction', _List_Nil, 'La marque sera proposée au premier étage de chaque typologie rangée par marque.');
};
var $author$project$I18n$Cles$produitsCatalogueMarqueRestaurer = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.marque.restaurer',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Restaurer « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$produitsValeursAjouter = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.ajouter',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md))
				]),
			'Ajouter : ' + p.md);
	});
var $author$project$I18n$Cles$produitsCatalogueMarqueArchiveeAucuneGamme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.marque.archivee-aucune-gamme', _List_Nil, 'aucune gamme');
};
var $author$project$I18n$Cles$produitsCatalogueMarqueArchiveeAucuneReference = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.marque.archivee-aucune-reference', _List_Nil, 'aucune référence');
};
var $author$project$I18n$Cles$produitsCatalogueMarqueArchiveeGammes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.marque.archivee-gammes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? 'sa gamme' : ('ses ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' gammes')));
	});
var $author$project$I18n$Cles$produitsCatalogueMarqueArchiveeLe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.marque.archivee-le',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'jour',
					$author$project$I18n$Traductions$Chaine(p.A_)),
					_Utils_Tuple2(
					'gammes',
					$author$project$I18n$Traductions$Chaine(p.gG)),
					_Utils_Tuple2(
					'references',
					$author$project$I18n$Traductions$Chaine(p.hD))
				]),
			'Archivée le ' + (p.A_ + (', avec ' + (p.gG + (' et ' + (p.hD + '.'))))));
	});
var $author$project$I18n$Cles$produitsCatalogueMarqueArchiveeReferences = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.marque.archivee-references',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? 'sa référence' : ('ses ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' références')));
	});
var $author$project$Components$Produits$StructureCatalogue$Marques$View$ceQueLArchiveEmporte = F2(
	function (i18n, archivee) {
		var _v0 = archivee.tJ;
		if (!_v0.$) {
			var le = _v0.a;
			return A2(
				$author$project$I18n$Cles$produitsCatalogueMarqueArchiveeLe,
				i18n,
				{
					gG: (!archivee.gG) ? $author$project$I18n$Cles$produitsCatalogueMarqueArchiveeAucuneGamme(i18n) : A2(
						$author$project$I18n$Cles$produitsCatalogueMarqueArchiveeGammes,
						i18n,
						{w: archivee.gG}),
					A_: A2(
						$author$project$Texte$Jour$enFrancaisLong,
						i18n,
						A2($elm$core$String$left, 10, le)),
					hD: (!archivee.hD) ? $author$project$I18n$Cles$produitsCatalogueMarqueArchiveeAucuneReference(i18n) : A2(
						$author$project$I18n$Cles$produitsCatalogueMarqueArchiveeReferences,
						i18n,
						{w: archivee.hD})
				}) + ' ';
		} else {
			return '';
		}
	});
var $author$project$I18n$Cles$produitsCatalogueMarqueArchiveeExiste = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.catalogue.marque.archivee-existe',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'« ' + (p.Dj + ' » existe déjà, archivée'));
	});
var $author$project$I18n$Cles$produitsCatalogueMarqueArchiveeExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.marque.archivee-explication', _List_Nil, 'La restaurer la rend de nouveau visible et utilisable, avec ses informations, ses gammes et ses références : rien n\'est créé en double.');
};
var $author$project$I18n$Cles$produitsCatalogueMarqueArchiveeNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.marque.archivee-note', _List_Nil, 'Le même message apparaît partout où un nom est déjà pris par un élément archivé : type de partie prenante, marque, gamme, valeur d\'un étage, liste de choix.');
};
var $author$project$Components$Produits$StructureCatalogue$Marques$View$restauration = F2(
	function (i18n, model) {
		var _v0 = model.tI;
		if (!_v0.$) {
			var archivee = _v0.a;
			return _List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Note$View$view,
					1,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$produitsCatalogueMarqueArchiveeExiste,
										i18n,
										{Dj: model.hP.Dj}))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									_Utils_ap(
										A2($author$project$Components$Produits$StructureCatalogue$Marques$View$ceQueLArchiveEmporte, i18n, archivee),
										$author$project$I18n$Cles$produitsCatalogueMarqueArchiveeExplication(i18n)))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsCatalogueMarqueArchiveeNote(i18n))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Produits$Common$Formulaire$viewEnDeuxLangues = function (i18n) {
	return A2($author$project$Components$Produits$Common$Formulaire$vueAvec, i18n, true);
};
var $author$project$Components$Produits$StructureCatalogue$Marques$View$creation = F3(
	function (i18n, etage, model) {
		var tournures = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Catalogue$Vocabulaire$tournures(
				{fA: $author$project$Catalogue$Vocabulaire$codeMarque, Bl: $elm$core$Maybe$Nothing}),
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$Produits$Common$Elements$tournures(i18n),
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.os;
					},
					model.aS)));
		var introduction = A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$I18n$Cles$produitsCatalogueMarqueArchiveeIntroduction(i18n))
				]));
		var contenu = (_Utils_eq(
			$author$project$Components$Produits$StructureCatalogue$Marques$Model$creation(model),
			$elm$core$Maybe$Nothing) || (!$author$project$Components$Shared$Drawer$Model$estOuvert(model.kX))) ? {
			fs: {sR: false, Bl: '', C$: $author$project$Components$Produits$StructureCatalogue$Marques$Update$CreationDemandee},
			fZ: _List_Nil,
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: ''
		} : {
			fs: function () {
				var _v0 = model.tI;
				if (!_v0.$) {
					return {
						sR: !$author$project$Components$Produits$Common$Envoi$enCours(model.l2),
						Bl: A2(
							$author$project$I18n$Cles$produitsCatalogueMarqueRestaurer,
							i18n,
							{Dj: model.hP.Dj}),
						C$: $author$project$Components$Produits$StructureCatalogue$Marques$Update$RestaurationDemandee
					};
				} else {
					return {
						sR: !$author$project$Components$Produits$Common$Envoi$enCours(model.l2),
						Bl: A2($author$project$I18n$Cles$texte, i18n, tournures.dC),
						C$: $author$project$Components$Produits$StructureCatalogue$Marques$Update$CreationDemandee
					};
				}
			}(),
			fZ: function (formulaire) {
				return A2(
					$elm$core$List$cons,
					introduction,
					_Utils_ap(
						formulaire,
						A2($author$project$Components$Produits$StructureCatalogue$Marques$View$restauration, i18n, model)));
			}(
				A2(
					$elm$core$List$map,
					$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Produits$StructureCatalogue$Marques$Update$Saisi),
					A3(
						$author$project$Components$Produits$Common$Formulaire$viewEnDeuxLangues,
						i18n,
						{
							gi: A2($author$project$I18n$Cles$texte, i18n, tournures.gi),
							gB: 0,
							oJ: '',
							ey: $elm$core$Maybe$Nothing,
							pv: $author$project$Components$Shared$Drawer$Model$idRacine(model.kX)
						},
						model.hP))),
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: A2(
				$author$project$I18n$Cles$produitsValeursAjouter,
				i18n,
				{md: etage})
		};
		return A4($author$project$Components$Shared$Drawer$View$view, i18n, $author$project$Components$Produits$StructureCatalogue$Marques$Update$DuDrawer, contenu, model.kX);
	});
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$CreationDemandee = {$: 14};
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$Saisi = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Produits$View$creation = F2(
	function (i18n, model) {
		var vide = {
			fs: {sR: false, Bl: '', C$: $author$project$Components$Produits$StructureCatalogue$Produits$Update$CreationDemandee},
			fZ: _List_Nil,
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: ''
		};
		var contenu = function () {
			var _v0 = _Utils_Tuple2(
				model.ew,
				$author$project$Components$Shared$Drawer$Model$estOuvert(model.kX));
			if ((!_v0.a.$) && _v0.b) {
				var ouverture = _v0.a.a;
				var tournures = $author$project$Catalogue$Vocabulaire$tournures(
					{fA: $author$project$Catalogue$Vocabulaire$codeProduit, Bl: $elm$core$Maybe$Nothing});
				return {
					fs: {
						sR: !$author$project$Components$Produits$Common$Envoi$enCours(model.l2),
						Bl: A2($author$project$I18n$Cles$texte, i18n, tournures.dC),
						C$: $author$project$Components$Produits$StructureCatalogue$Produits$Update$CreationDemandee
					},
					fZ: A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Produits$StructureCatalogue$Produits$Update$Saisi),
						A3(
							$author$project$Components$Produits$Common$Formulaire$view,
							i18n,
							{
								gi: A2($author$project$I18n$Cles$texte, i18n, tournures.gi),
								gB: 2,
								oJ: '',
								ey: $elm$core$Maybe$Just(
									{
										Bl: A2($author$project$I18n$Cles$texte, i18n, ouverture.C6),
										Dj: ouverture.uK
									}),
								pv: $author$project$Components$Shared$Drawer$Model$idRacine(model.kX)
							},
							model.hP)),
					A6: $elm$core$Maybe$Nothing,
					Bc: false,
					h6: A2(
						$author$project$I18n$Cles$produitsValeursAjouter,
						i18n,
						{
							md: A2($author$project$I18n$Cles$texte, i18n, ouverture.md)
						})
				};
			} else {
				return vide;
			}
		}();
		return A4($author$project$Components$Shared$Drawer$View$view, i18n, $author$project$Components$Produits$StructureCatalogue$Produits$Update$DuDrawer, contenu, model.kX);
	});
var $author$project$Components$Produits$StructureCatalogue$Update$ArchivageDemande = {$: 57};
var $author$project$Components$Produits$StructureCatalogue$Update$CibleDArchivageChoisie = function (a) {
	return {$: 50, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$CorrespondanceDArchivageOuverte = {$: 53};
var $author$project$Components$Produits$StructureCatalogue$Archivage$View$chiffre = function (_v0) {
	var nombre = _v0.a;
	var libelle = _v0.b;
	var particularite = _v0.c;
	return A2(
		$rtfeldman$elm_css$Html$Styled$li,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class(particularite)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$strong,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$elm$core$String$fromInt(nombre))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(libelle)
					]))
			]));
};
var $author$project$Components$Produits$StructureCatalogue$Archivage$View$lienDeConflit = function (conflit) {
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$text(' '),
			A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('code'),
					$rtfeldman$elm_css$Html$Styled$Attributes$href(
					$author$project$Routes$Route$toString(
						$author$project$Routes$Route$FicheReference(conflit.Hc))),
					$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank'),
					$rtfeldman$elm_css$Html$Styled$Attributes$rel('noopener')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(conflit.vx)
				]))
		]);
};
var $author$project$Components$Produits$StructureCatalogue$Archivage$View$nomDeLaCible = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$Basics$identity,
				A3(
					$elm$core$Maybe$map2,
					F2(
						function (id, structure) {
							return A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$classificationDe, id, structure.vk);
						}),
					model.tD.vf,
					model.h$))));
};
var $author$project$I18n$Cles$produitsTypologiesArchiverApercuAranger = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.apercu.aranger', _List_Nil, '« À ranger »');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverApercuCloturees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.apercu.cloturees', _List_Nil, 'clôturées');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverApercuConflits = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.apercu.conflits', _List_Nil, 'en conflit de code');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverApercuMigrees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.apercu.migrees', _List_Nil, 'migrées');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverApercuSansplace = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.apercu.sansplace', _List_Nil, 'sans place dans la cible');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverApercuTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.apercu.titre', _List_Nil, 'Aperçu avant de lancer');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverApercuVerrouillees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.apercu.verrouillees', _List_Nil, 'verrouillées : clôture seule');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverConflitTexteDebut = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.typologies.archiver.conflit.texte.debut',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'cible',
					$author$project$I18n$Traductions$Chaine(p.vf))
				]),
			'Leur code existe déjà dans « ' + (p.vf + ' » :'));
	});
var $author$project$I18n$Cles$produitsTypologiesArchiverConflitTexteFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.conflit.texte.fin', _List_Nil, 'Corrigez ces codes ou clôturez-les, puis relancez l\'aperçu.');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverConflitTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.conflit.titre', _List_Nil, 'Des références ne peuvent pas être migrées');
};
var $author$project$Components$Produits$StructureCatalogue$Archivage$View$apercu = F2(
	function (i18n, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu')
				]),
			function () {
				var _v0 = model.tD.tq;
				if (!_v0.$) {
					var lu = _v0.a;
					return _Utils_ap(
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsTypologiesArchiverApercuTitre(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$ul,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('chiffres')
									]),
								A2(
									$elm$core$List$map,
									$author$project$Components$Produits$StructureCatalogue$Archivage$View$chiffre,
									_List_fromArray(
										[
											_Utils_Tuple3(
											lu.Cw,
											$author$project$I18n$Cles$produitsTypologiesArchiverApercuMigrees(i18n),
											''),
											_Utils_Tuple3(
											lu.vr,
											$author$project$I18n$Cles$produitsTypologiesArchiverApercuCloturees(i18n),
											''),
											_Utils_Tuple3(
											lu.iz,
											$author$project$I18n$Cles$produitsTypologiesArchiverApercuAranger(i18n),
											''),
											_Utils_Tuple3(
											lu.Ip,
											$author$project$I18n$Cles$produitsTypologiesArchiverApercuSansplace(i18n),
											''),
											_Utils_Tuple3(
											lu.KC,
											$author$project$I18n$Cles$produitsTypologiesArchiverApercuVerrouillees(i18n),
											'verrouillees'),
											_Utils_Tuple3(
											lu.yi,
											$author$project$I18n$Cles$produitsTypologiesArchiverApercuConflits(i18n),
											(lu.yi > 0) ? 'en-conflit' : '')
										])))
							]),
						(lu.yi > 0) ? _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('alerte'),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$strong,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$produitsTypologiesArchiverConflitTitre(i18n))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_Nil,
										A2(
											$elm$core$List$cons,
											$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$produitsTypologiesArchiverConflitTexteDebut,
													i18n,
													{
														vf: $author$project$Components$Produits$StructureCatalogue$Archivage$View$nomDeLaCible(model)
													})),
											_Utils_ap(
												A2($elm$core$List$concatMap, $author$project$Components$Produits$StructureCatalogue$Archivage$View$lienDeConflit, lu.He),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														' ' + $author$project$I18n$Cles$produitsTypologiesArchiverConflitTexteFin(i18n))
													]))))
									]))
							]) : _List_Nil);
				} else {
					return _List_Nil;
				}
			}());
	});
var $author$project$I18n$Cles$produitsTypologiesArchiverAvanceeBilan = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.typologies.archiver.avancee.bilan',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'migrees',
					$author$project$I18n$Traductions$Chaine(p.Cw)),
					_Utils_Tuple2(
					'cloturees',
					$author$project$I18n$Traductions$Chaine(p.vr))
				]),
			p.Cw + (' migrées · ' + (p.vr + ' clôturées')));
	});
var $author$project$I18n$Cles$produitsTypologiesArchiverAvanceeLots = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.typologies.archiver.avancee.lots',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'faits',
					$author$project$I18n$Traductions$Entier(p.zi)),
					_Utils_Tuple2(
					'traitees',
					$author$project$I18n$Traductions$Chaine(p.JN))
				]),
			((!p.zi) || (p.zi === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.zi) + (' lot traité · références traitées : ' + p.JN)) : (A2($author$project$I18n$Nombre$formater, 0, p.zi) + (' lots traités · références traitées : ' + p.JN)));
	});
var $author$project$I18n$Cles$produitsTypologiesArchiverAvanceeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.avancee.titre', _List_Nil, 'Archivage en cours, ne fermez pas la page');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverIgnoreesTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.ignorees.texte', _List_Nil, 'Corrigez-les ou clôturez-les, puis relancez : les lots déjà traités ne sont pas refaits.');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverIgnoreesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.ignorees.titre', _List_Nil, 'Le traitement s\'est arrêté sur ces références');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverRestantesTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.restantes.texte', _List_Nil, '« Archiver » reste inactif tant qu\'il en reste.');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverRestantesTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.typologies.archiver.restantes.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' référence restante') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' références restantes'));
	});
var $author$project$Components$Produits$StructureCatalogue$Archivage$View$avancee = F2(
	function (i18n, model) {
		var lots = model.tD.a6;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('avancee')
				]),
			function () {
				var _v0 = lots.qD;
				if (!_v0.$) {
					var restantes = _v0.a;
					return _List_fromArray(
						[
							lots.d8 ? A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsTypologiesArchiverAvanceeTitre(i18n))
								])) : $rtfeldman$elm_css$Html$Styled$text(''),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('lots')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$produitsTypologiesArchiverAvanceeLots,
										i18n,
										{
											zi: lots.zi,
											JN: $elm$core$String$fromInt(lots.JN)
										}))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('bilan')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$produitsTypologiesArchiverAvanceeBilan,
										i18n,
										{
											vr: $elm$core$String$fromInt(lots.uq.vr),
											Cw: $elm$core$String$fromInt(lots.uq.Cw)
										}))
								])),
							(restantes > 0) ? A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('alerte'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$produitsTypologiesArchiverRestantesTitre,
												i18n,
												{w: restantes}))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsTypologiesArchiverRestantesTexte(i18n))
										]))
								])) : $rtfeldman$elm_css$Html$Styled$text(''),
							$elm$core$List$isEmpty(lots.Aw) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('ignorees'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsTypologiesArchiverIgnoreesTitre(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsTypologiesArchiverIgnoreesTexte(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$ul,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (ignoree) {
											return A2(
												$rtfeldman$elm_css$Html$Styled$li,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$Catalogue$Identifiants$referenceIdToString(ignoree.Hc))
													]));
										},
										lots.Aw))
								]))
						]);
				} else {
					return _List_Nil;
				}
			}());
	});
var $author$project$Components$Produits$StructureCatalogue$Update$CategorieDArchivageBasculee = function (a) {
	return {$: 52, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Archivage$View$boolean = function (vrai) {
	return vrai ? 'true' : 'false';
};
var $author$project$Components$Produits$StructureCatalogue$Archivage$Model$categories = F2(
	function (noms, typologie) {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Archivage$Model$uniquesPar,
			function ($) {
				return $.Aq;
			},
			A2(
				$elm$core$List$filterMap,
				function (noeud) {
					var _v0 = noeud.fm;
					if (_v0.$ === 2) {
						var id = _v0.a;
						return A2(
							$elm$core$Maybe$map,
							function (nom) {
								return {Aq: id, Dj: nom};
							},
							A3($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$nomDe, noms, typologie, noeud.fm));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				typologie.Di));
	});
var $author$project$I18n$Cles$produitsTypologiesArchiverCategoriesReferences = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.typologies.archiver.categories.references',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			p.w + ' réf.');
	});
var $author$project$Components$Produits$StructureCatalogue$Archivage$View$nombreDeReferences = F3(
	function (i18n, archivage, id) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (c) {
					return A2(
						$author$project$I18n$Cles$produitsTypologiesArchiverCategoriesReferences,
						i18n,
						{
							w: $elm$core$String$fromInt(c.hD)
						});
				},
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.EL;
						},
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$filter(
								function (c) {
									return _Utils_eq(c.fh, id);
								}),
							$elm$core$List$head)),
					archivage.tq)));
	});
var $author$project$I18n$Cles$produitsTypologiesArchiverCategoriesCloturer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.categories.cloturer', _List_Nil, 'Clôturer');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverCategoriesMigrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.categories.migrer', _List_Nil, 'Migrer');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverCategoriesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.categories.titre', _List_Nil, 'Par catégorie : migrer ou clôturer ?');
};
var $author$project$Components$Produits$StructureCatalogue$Archivage$View$categories = F4(
	function (i18n, model, typologie, figee) {
		var archivage = model.tD;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('categories')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsTypologiesArchiverCategoriesTitre(i18n))
						])),
				A2(
					$elm$core$List$map,
					function (categorie) {
						var cloturee = A2($elm$core$List$member, categorie.Aq, archivage.it);
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('categorie')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(categorie.Dj)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A3($author$project$Components$Produits$StructureCatalogue$Archivage$View$nombreDeReferences, i18n, archivage, categorie.Aq))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('choix')
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Components$Shared$Bouton$View$bouton,
											1,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('on', !cloturee)
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
													'aria-pressed',
													$author$project$Components$Produits$StructureCatalogue$Archivage$View$boolean(!cloturee)),
													$rtfeldman$elm_css$Html$Styled$Attributes$disabled(figee),
													$rtfeldman$elm_css$Html$Styled$Events$onClick(
													$author$project$Components$Produits$StructureCatalogue$Update$CategorieDArchivageBasculee(categorie.Aq))
												]),
											$author$project$I18n$Cles$produitsTypologiesArchiverCategoriesMigrer(i18n)),
											A3(
											$author$project$Components$Shared$Bouton$View$bouton,
											1,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('on', cloturee)
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
													'aria-pressed',
													$author$project$Components$Produits$StructureCatalogue$Archivage$View$boolean(cloturee)),
													$rtfeldman$elm_css$Html$Styled$Attributes$disabled(figee),
													$rtfeldman$elm_css$Html$Styled$Events$onClick(
													$author$project$Components$Produits$StructureCatalogue$Update$CategorieDArchivageBasculee(categorie.Aq))
												]),
											$author$project$I18n$Cles$produitsTypologiesArchiverCategoriesCloturer(i18n))
										]))
								]));
					},
					A2(
						$author$project$Components$Produits$StructureCatalogue$Archivage$Model$categories,
						$author$project$Components$Produits$StructureCatalogue$Valeurs$Lecture$noms(model),
						typologie))));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$PorteeDArchivageChoisie = function (a) {
	return {$: 51, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Archivage$View$choixDePortee = F4(
	function (figee, actuelle, portee, libelle) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'on',
							_Utils_eq(actuelle, portee))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
							$rtfeldman$elm_css$Html$Styled$Attributes$name('portee-archivage'),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(
							_Utils_eq(actuelle, portee)),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(figee),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Produits$StructureCatalogue$Update$PorteeDArchivageChoisie(portee))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						]))
				]));
	});
var $author$project$I18n$Cles$produitsTypologiesArchiverPorteeToutes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.portee.toutes', _List_Nil, 'Toutes les références');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverPorteeToutesNombre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.typologies.archiver.portee.toutes.nombre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			'Toutes les références (' + (p.JE + ')'));
	});
var $author$project$Components$Produits$StructureCatalogue$Archivage$View$libelleDeToutes = F2(
	function (i18n, typologie) {
		var _v0 = typologie.hD;
		if (!_v0.$) {
			var nombre = _v0.a;
			return A2(
				$author$project$I18n$Cles$produitsTypologiesArchiverPorteeToutesNombre,
				i18n,
				{
					JE: A2(
						$author$project$I18n$Nombre$formater,
						$author$project$I18n$Traductions$langue(i18n),
						nombre)
				});
		} else {
			return $author$project$I18n$Cles$produitsTypologiesArchiverPorteeToutes(i18n);
		}
	});
var $author$project$I18n$Cles$produitsTypologiesArchiverCibleAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.cible.aide', _List_Nil, 'Une seule cible pour toute l\'opération. Les typologies archivées ne sont pas proposées.');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverCibleLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.cible.libelle', _List_Nil, 'Typologie cible');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverCorrespondanceAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.correspondance.aide', _List_Nil, 'Sans choix, une valeur sans équivalent devient « À ranger ».');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverCorrespondanceBouton = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.correspondance.bouton', _List_Nil, 'Voir la correspondance étages et valeurs');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverIntro = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.intro', _List_Nil, 'Chaque référence est migrée vers une autre typologie ou clôturée avant l\'archivage.');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverPorteeChoisies = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.portee.choisies', _List_Nil, 'Filtrées ou sélectionnées');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverPorteeFiltrees = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.typologies.archiver.portee.filtrees',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'resume',
					$author$project$I18n$Traductions$Chaine(p.HX))
				]),
			'Filtrées : ' + p.HX);
	});
var $author$project$I18n$Cles$produitsTypologiesArchiverPorteeLibelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.portee.libelle', _List_Nil, 'Portée');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverPorteeSelectionnees = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.typologies.archiver.portee.selectionnees',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Sélectionnée : ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' référence')) : ('Sélectionnées : ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' références')));
	});
var $author$project$I18n$Cles$produitsTypologiesArchiverPorteeSelectionneesNote = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.typologies.archiver.portee.selectionnees.note',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typologie',
					$author$project$I18n$Traductions$Chaine(p.r3))
				]),
			'Cochées dans la liste des références, toutes rangées dans « ' + (p.r3 + ' ».'));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$PorteeDArchivageRetiree = {$: 47};
var $author$project$I18n$Cles$produitsTypologiesArchiverPorteeTouteLaTypologie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.portee.toute-la-typologie', _List_Nil, 'Traiter toute la typologie');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverPorteeTouteLaTypologieNombre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.typologies.archiver.portee.toute-la-typologie-nombre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			'Traiter toute la typologie (' + (p.JE + ')'));
	});
var $author$project$Components$Produits$StructureCatalogue$Archivage$View$traiterToutLaTypologie = F3(
	function (i18n, typologie, figee) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('toute-la-typologie'),
					$rtfeldman$elm_css$Html$Styled$Attributes$disabled(figee),
					$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$StructureCatalogue$Update$PorteeDArchivageRetiree)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					function () {
						var _v0 = typologie.hD;
						if (!_v0.$) {
							var nombre = _v0.a;
							return A2(
								$author$project$I18n$Cles$produitsTypologiesArchiverPorteeTouteLaTypologieNombre,
								i18n,
								{
									JE: A2(
										$author$project$I18n$Nombre$formater,
										$author$project$I18n$Traductions$langue(i18n),
										nombre)
								});
						} else {
							return $author$project$I18n$Cles$produitsTypologiesArchiverPorteeTouteLaTypologie(i18n);
						}
					}())
				]));
	});
var $author$project$Components$Produits$StructureCatalogue$Archivage$View$contenu = F3(
	function (i18n, model, typologie) {
		var toutes = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.vk;
				},
				model.h$));
		var possibles = A2($author$project$Components$Produits$StructureCatalogue$Archivage$Model$cibles, typologie.Aq, toutes);
		var archivage = model.tD;
		var figee = archivage.a6.d8 || (!_Utils_eq(archivage.a6.qD, $elm$core$Maybe$Nothing));
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Messages$View$view,
				i18n,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $elm$core$List$singleton, model.aL))),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('intro')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsTypologiesArchiverIntro(i18n))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('cible')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsTypologiesArchiverCibleLibelle(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$select,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Produits$StructureCatalogue$Update$CibleDArchivageChoisie),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(figee)
							]),
						A2(
							$elm$core$List$map,
							function (cible) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$option,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$author$project$Catalogue$Identifiants$classificationIdToString(cible.Aq)),
											$rtfeldman$elm_css$Html$Styled$Attributes$selected(
											_Utils_eq(
												archivage.vf,
												$elm$core$Maybe$Just(cible.Aq)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(cible))
										]));
							},
							possibles)),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsTypologiesArchiverCibleAide(i18n))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('portee'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('seg'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'radiogroup'),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-label',
						$author$project$I18n$Cles$produitsTypologiesArchiverPorteeLibelle(i18n))
					]),
				function () {
					var _v0 = _Utils_Tuple2(archivage.zH, archivage.hD);
					if (!_v0.a.$) {
						var filtre = _v0.a.a;
						return _List_fromArray(
							[
								A4(
								$author$project$Components$Produits$StructureCatalogue$Archivage$View$choixDePortee,
								figee,
								archivage.F$,
								1,
								A2(
									$author$project$I18n$Cles$produitsTypologiesArchiverPorteeFiltrees,
									i18n,
									{
										HX: A2($author$project$I18n$Cles$texte, i18n, filtre.HX)
									})),
								A3($author$project$Components$Produits$StructureCatalogue$Archivage$View$traiterToutLaTypologie, i18n, typologie, figee)
							]);
					} else {
						if (_v0.b.b) {
							var _v1 = _v0.a;
							var _v2 = _v0.b;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('selection')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$strong,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$author$project$I18n$Cles$produitsTypologiesArchiverPorteeSelectionnees,
														i18n,
														{
															w: $elm$core$List$length(archivage.hD)
														}))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$author$project$I18n$Cles$produitsTypologiesArchiverPorteeSelectionneesNote,
														i18n,
														{
															r3: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(typologie)
														}))
												]))
										])),
									A3($author$project$Components$Produits$StructureCatalogue$Archivage$View$traiterToutLaTypologie, i18n, typologie, figee)
								]);
						} else {
							var _v3 = _v0.a;
							return _List_fromArray(
								[
									A4(
									$author$project$Components$Produits$StructureCatalogue$Archivage$View$choixDePortee,
									figee,
									archivage.F$,
									0,
									A2($author$project$Components$Produits$StructureCatalogue$Archivage$View$libelleDeToutes, i18n, typologie)),
									A4(
									$author$project$Components$Produits$StructureCatalogue$Archivage$View$choixDePortee,
									figee,
									archivage.F$,
									1,
									$author$project$I18n$Cles$produitsTypologiesArchiverPorteeChoisies(i18n))
								]);
						}
					}
				}()),
				A4($author$project$Components$Produits$StructureCatalogue$Archivage$View$categories, i18n, model, typologie, figee),
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				2,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('correspondance'),
						$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$StructureCatalogue$Archivage$Model$idDuBoutonDeCorrespondance),
						$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$StructureCatalogue$Update$CorrespondanceDArchivageOuverte),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
						_Utils_eq(archivage.vf, $elm$core$Maybe$Nothing))
					]),
				$author$project$I18n$Cles$produitsTypologiesArchiverCorrespondanceBouton(i18n)),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsTypologiesArchiverCorrespondanceAide(i18n))
					])),
				A2($author$project$Components$Produits$StructureCatalogue$Archivage$View$apercu, i18n, model),
				A2($author$project$Components$Produits$StructureCatalogue$Archivage$View$avancee, i18n, model)
			]);
	});
var $author$project$Components$Produits$StructureCatalogue$Update$ArchivageInterrompu = {$: 56};
var $author$project$Components$Produits$StructureCatalogue$Update$ArchivageLance = {$: 55};
var $author$project$I18n$Cles$produitsTypologiesArchiverLancer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.lancer', _List_Nil, 'Migrer et clôturer');
};
var $author$project$Components$Produits$StructureCatalogue$Archivage$View$lancer = F2(
	function (i18n, archivage) {
		return A3(
			$author$project$Components$Shared$Bouton$View$bouton,
			0,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('lancer'),
					$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$StructureCatalogue$Update$ArchivageLance),
					$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
					!$author$project$Components$Produits$StructureCatalogue$Archivage$Model$lancable(archivage))
				]),
			$author$project$I18n$Cles$produitsTypologiesArchiverLancer(i18n));
	});
var $author$project$I18n$Cles$produitsTypologiesArchiverInterrompre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.interrompre', _List_Nil, 'Interrompre');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverPiedConflit = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.typologies.archiver.pied.conflit',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Le lancement est bloqué tant que ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' code est en conflit.')) : ('Le lancement est bloqué tant que ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' codes sont en conflit.')));
	});
var $author$project$I18n$Cles$produitsTypologiesArchiverReactivable = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.reactivable', _List_Nil, 'Archiver ne se défait pas des migrations : « Réactiver » reste possible.');
};
var $author$project$Components$Produits$StructureCatalogue$Archivage$View$pied = F2(
	function (i18n, archivage) {
		return archivage.a6.d8 ? {
			oJ: $elm$core$Maybe$Just(
				A2(
					$author$project$I18n$Cles$produitsTypologiesArchiverAvanceeBilan,
					i18n,
					{
						vr: $elm$core$String$fromInt(archivage.a6.uq.vr),
						Cw: $elm$core$String$fromInt(archivage.a6.uq.Cw)
					})),
			HF: function (attributs) {
				return A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_Utils_ap(
						attributs,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('interrompre'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$StructureCatalogue$Update$ArchivageInterrompu)
							])),
					$author$project$I18n$Cles$produitsTypologiesArchiverInterrompre(i18n));
			},
			Jb: _List_Nil
		} : {
			oJ: (!_Utils_eq(archivage.a6.qD, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(
				$author$project$I18n$Cles$produitsTypologiesArchiverReactivable(i18n)) : A2(
				$elm$core$Maybe$andThen,
				function (lu) {
					return (lu.yi > 0) ? $elm$core$Maybe$Just(
						A2(
							$author$project$I18n$Cles$produitsTypologiesArchiverPiedConflit,
							i18n,
							{w: lu.yi})) : $elm$core$Maybe$Nothing;
				},
				archivage.tq),
			HF: function (attributs) {
				return A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_Utils_ap(
						attributs,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Produits$StructureCatalogue$Update$DuArchivage($author$project$Components$Shared$Drawer$Update$Fermer))
							])),
					$author$project$I18n$Cles$drawerAnnuler(i18n));
			},
			Jb: _Utils_eq(archivage.a6.qD, $elm$core$Maybe$Nothing) ? _List_fromArray(
				[
					A2($author$project$Components$Produits$StructureCatalogue$Archivage$View$lancer, i18n, archivage)
				]) : _List_Nil
		};
	});
var $author$project$I18n$Cles$produitsTypologiesArchiverTitreDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.typologies.archiver.titre.de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Archiver « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$produitsTypologiesArchiverValider = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.valider', _List_Nil, 'Archiver');
};
var $author$project$Components$Produits$StructureCatalogue$Archivage$View$drawer = F2(
	function (i18n, model) {
		var archivage = model.tD;
		var source = A2(
			$elm$core$Maybe$andThen,
			function (id) {
				return A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.vk;
						},
						$author$project$Components$Produits$StructureCatalogue$Classifications$Model$classificationDe(id)),
					model.h$);
			},
			archivage.r3);
		return A5(
			$author$project$Components$Shared$Drawer$View$viewAvecPiedLibre,
			i18n,
			A2($author$project$Components$Produits$StructureCatalogue$Archivage$View$pied, i18n, archivage),
			$author$project$Components$Produits$StructureCatalogue$Update$DuArchivage,
			{
				fs: {
					sR: (!_Utils_eq(source, $elm$core$Maybe$Nothing)) && $author$project$Components$Produits$StructureCatalogue$Archivage$Model$archivable(archivage),
					Bl: _Utils_eq(source, $elm$core$Maybe$Nothing) ? '' : $author$project$I18n$Cles$produitsTypologiesArchiverValider(i18n),
					C$: $author$project$Components$Produits$StructureCatalogue$Update$ArchivageDemande
				},
				fZ: function () {
					if (!source.$) {
						var typologie = source.a;
						return A3($author$project$Components$Produits$StructureCatalogue$Archivage$View$contenu, i18n, model, typologie);
					} else {
						return _List_Nil;
					}
				}(),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function (t) {
							return A2(
								$author$project$I18n$Cles$produitsTypologiesArchiverTitreDe,
								i18n,
								{
									Dj: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(t)
								});
						},
						source))
			},
			archivage.kX);
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$ArchivageDemande = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$Valide = {$: 12};
var $author$project$Components$Produits$StructureCatalogue$Classifications$View$annonce = F2(
	function (i18n, section) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('annonce'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-live', 'polite')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2($author$project$I18n$Cles$texte, i18n, section.iP))
				]));
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$etageSous = F3(
	function (niveaux, typologie, parent) {
		var ancetres = function (id) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (mere) {
						return A2(
							$elm$core$List$cons,
							mere,
							ancetres(mere));
					},
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.ey;
						},
						A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$valeurDe, id, typologie))));
		};
		var profondeur = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function (id) {
					return $elm$core$List$length(
						ancetres(id)) + 1;
				},
				parent));
		return $elm$core$List$head(
			A2(
				$elm$core$List$drop,
				profondeur,
				A2(
					$elm$core$List$filterMap,
					function (etage) {
						var _v0 = etage.xt;
						if (_v0.$ === 1) {
							var libelles = _v0.a;
							return $elm$core$Maybe$Just(libelles.zX);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					},
					typologie.yG)));
	});
var $author$project$I18n$Cles$produitsClassificationsLibelles = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.classifications.libelles',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fr',
					$author$project$I18n$Traductions$Chaine(p.zX)),
					_Utils_Tuple2(
					'en',
					$author$project$I18n$Traductions$Chaine(p.yg))
				]),
			p.zX + (' · ' + p.yg));
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$View$libelles = F2(
	function (i18n, fournis) {
		var _v0 = fournis.yg;
		if (!_v0.$) {
			var en = _v0.a;
			return A2(
				$author$project$I18n$Cles$produitsClassificationsLibelles,
				i18n,
				{yg: en, zX: fournis.zX});
		} else {
			return fournis.zX;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$LibelleSaisi = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$View$libellesSaisis = F3(
	function (i18n, libelle, saisie) {
		return A3(
			$author$project$Components$Shared$LibellesParLangue$View$view,
			i18n,
			_List_fromArray(
				[
					$author$project$Components$Produits$StructureCatalogue$Controles$entreeEnvoie($author$project$Components$Produits$StructureCatalogue$Classifications$Update$Valide)
				]),
			{
				go: A3($author$project$Components$Produits$StructureCatalogue$Controles$obligatoireManquant, i18n, saisie.b5, saisie.R),
				Ba: $author$project$Referentiel$Langues$desLibelles,
				Bl: libelle,
				hg: $author$project$Components$Produits$StructureCatalogue$Classifications$Update$LibelleSaisi,
				pv: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$prefixeDesLibelles,
				fm: function (code) {
					return A2($author$project$Components$Shared$LibellesParLangue$Model$lire, code, saisie.R);
				}
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$View$offert = F2(
	function (rel, liens) {
		return !_Utils_eq(
			A2($author$project$API$Liens$trouver, rel, liens),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$Deposee = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$Descendue = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$GlisserCommence = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$GlisserFini = {$: 18};
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$GlisserSurvole = {$: 16};
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$Montee = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$I18n$Cles$produitsStructureLibelleAnglaisManquant = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.structure.libelle.anglais-manquant', _List_Nil, 'Libellé anglais manquant');
};
var $author$project$Components$Produits$StructureCatalogue$Controles$anglaisManquant = F2(
	function (i18n, manquant) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('avertissement')
				]),
			manquant ? _List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$I18n$Cles$produitsStructureLibelleAnglaisManquant(i18n))
				]) : _List_Nil);
	});
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$View$arreter = F2(
	function (evenement, msg) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$Events$custom,
			evenement,
			$elm$json$Json$Decode$succeed(
				{Cs: msg, Gk: true, I2: true}));
	});
var $author$project$Components$Produits$StructureCatalogue$Controles$boutonDOrdre = $author$project$Components$Shared$OrdreView$boutonDOrdre;
var $author$project$I18n$Cles$produitsClassificationsValeurArchivee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.classifications.valeur.archivee', _List_Nil, 'Archivée');
};
var $author$project$Components$Produits$StructureCatalogue$Classifications$View$stopPropagationOn = F2(
	function (evenement, msg) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn,
			evenement,
			$elm$json$Json$Decode$succeed(
				_Utils_Tuple2(msg, true)));
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$View$etage = F4(
	function (i18n, contexte, numero, parent) {
		var soeurs = (numero > 32) ? _List_Nil : A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$fillesDe, parent, contexte.vj.Ki);
		var derniere = $elm$core$List$length(soeurs) - 1;
		return A2(
			$rtfeldman$elm_css$Html$Styled$ul,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('arbre')
				]),
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (place, fournie) {
						return A5(
							$author$project$Components$Produits$StructureCatalogue$Classifications$View$valeur,
							i18n,
							contexte,
							numero,
							{
								xj: _Utils_eq(place, derniere),
								Gf: !place
							},
							fournie);
					}),
				soeurs));
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$View$valeur = F5(
	function (i18n, contexte, numero, place, fournie) {
		var nom = $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nomDeLaValeur(fournie);
		var deplacable = A2($author$project$Components$Produits$StructureCatalogue$Classifications$View$offert, $author$project$API$NavLinksDictionary$deplacerUneValeur, fournie.nQ);
		var classificationId = contexte.vj.Aq;
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('archivee', fournie.tI),
							_Utils_Tuple2(
							'glisse',
							_Utils_eq(
								contexte.hS.m_,
								$elm$core$Maybe$Just(
									_Utils_Tuple2(classificationId, fournie.Aq))))
						])),
				deplacable ? _List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$draggable('true'),
						A2(
						$author$project$Components$Produits$StructureCatalogue$Classifications$View$stopPropagationOn,
						'dragstart',
						A2($author$project$Components$Produits$StructureCatalogue$Classifications$Update$GlisserCommence, classificationId, fournie.Aq)),
						A2(
						$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
						'dragover',
						$elm$json$Json$Decode$succeed(
							_Utils_Tuple2($author$project$Components$Produits$StructureCatalogue$Classifications$Update$GlisserSurvole, true))),
						A2(
						$author$project$Components$Produits$StructureCatalogue$Classifications$View$arreter,
						'drop',
						A2($author$project$Components$Produits$StructureCatalogue$Classifications$Update$Deposee, classificationId, fournie.Aq)),
						A2(
						$rtfeldman$elm_css$Html$Styled$Events$on,
						'dragend',
						$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$Classifications$Update$GlisserFini))
					]) : _List_Nil),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('ordre')
								]),
							deplacable ? _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('poignee')
										]),
									_List_fromArray(
										[$author$project$Components$Shared$Svg$svgDragHandle])),
									A2(
									$author$project$Components$Produits$StructureCatalogue$Controles$boutonDOrdre,
									0,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id(
											A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDuBoutonDOrdre, fournie.Aq, 0)),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											A2($author$project$Components$Produits$StructureCatalogue$Classifications$Update$Montee, classificationId, fournie.Aq)),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(place.Gf || contexte.d3),
											A2(
											$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
											'aria-label',
											A2(
												$author$project$I18n$Cles$produitsStructureOrdreMonterDe,
												i18n,
												{Dj: nom})),
											$rtfeldman$elm_css$Html$Styled$Attributes$title(
											A2(
												$author$project$I18n$Cles$produitsStructureOrdreMonterDe,
												i18n,
												{Dj: nom}))
										])),
									A2(
									$author$project$Components$Produits$StructureCatalogue$Controles$boutonDOrdre,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id(
											A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDuBoutonDOrdre, fournie.Aq, 1)),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											A2($author$project$Components$Produits$StructureCatalogue$Classifications$Update$Descendue, classificationId, fournie.Aq)),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(place.xj || contexte.d3),
											A2(
											$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
											'aria-label',
											A2(
												$author$project$I18n$Cles$produitsStructureOrdreDescendreDe,
												i18n,
												{Dj: nom})),
											$rtfeldman$elm_css$Html$Styled$Attributes$title(
											A2(
												$author$project$I18n$Cles$produitsStructureOrdreDescendreDe,
												i18n,
												{Dj: nom}))
										]))
								]) : _List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$Components$Produits$StructureCatalogue$Classifications$View$libelles, i18n, fournie.R))
										])),
									A2(
									$author$project$Components$Produits$StructureCatalogue$Controles$anglaisManquant,
									i18n,
									_Utils_eq(fournie.R.yg, $elm$core$Maybe$Nothing)),
									fournie.tI ? A2(
									$author$project$Components$Shared$Tag$View$view,
									3,
									$author$project$I18n$Cles$produitsClassificationsValeurArchivee(i18n)) : $rtfeldman$elm_css$Html$Styled$text('')
								]))
						])),
					A4(
					$author$project$Components$Produits$StructureCatalogue$Classifications$View$etage,
					i18n,
					contexte,
					numero + 1,
					$elm$core$Maybe$Just(fournie.Aq))
				]));
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$View$ordre = F4(
	function (i18n, inactif, section, fournie) {
		var contexte = {vj: fournie, d3: inactif, hS: section};
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('valeurs'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('loading', inactif),
							_Utils_Tuple2(
							'en-cours',
							!_Utils_eq(section.pt, $elm$core$Maybe$Nothing))
						])),
					$author$project$Components$Produits$StructureCatalogue$Controles$occupe(inactif)
				]),
			_List_fromArray(
				[
					A4($author$project$Components$Produits$StructureCatalogue$Classifications$View$etage, i18n, contexte, 1, $elm$core$Maybe$Nothing)
				]));
	});
var $author$project$I18n$Cles$produitsClassificationsAjoutAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.classifications.ajout.ajouter', _List_Nil, 'Ajouter la liste');
};
var $author$project$I18n$Cles$produitsClassificationsAjoutOuvrir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.classifications.ajout.ouvrir', _List_Nil, 'Ajouter une liste');
};
var $author$project$I18n$Cles$produitsClassificationsOrdonner = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.classifications.ordonner', _List_Nil, 'Ordonner les valeurs');
};
var $author$project$I18n$Cles$produitsClassificationsOrdonnerPhrase = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.classifications.ordonner.phrase', _List_Nil, 'Glissez une valeur par sa poignée, ou utilisez les flèches : chaque déplacement est enregistré aussitôt.');
};
var $author$project$I18n$Cles$produitsClassificationsValeurAjouterValider = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.classifications.valeur.ajouter.valider', _List_Nil, 'Ajouter la valeur');
};
var $author$project$I18n$Cles$produitsClassificationsValeurArchiver = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.classifications.valeur.archiver', _List_Nil, 'Archiver');
};
var $author$project$I18n$Cles$produitsClassificationsValeurArchiverConfirmer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.classifications.valeur.archiver.confirmer', _List_Nil, 'Confirmer l\'archivage');
};
var $author$project$I18n$Cles$produitsClassificationsValeurArchiverDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.classifications.valeur.archiver.de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Archiver ' + p.Dj);
	});
var $author$project$I18n$Cles$produitsClassificationsValeurArchiverQuestion = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.classifications.valeur.archiver.question',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Archiver « ' + (p.Dj + ' » ? Elle restera dans l\'arbre, marquée archivée.'));
	});
var $author$project$I18n$Cles$produitsClassificationsValeurDrawer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.classifications.valeur.drawer', _List_Nil, 'La valeur');
};
var $author$project$I18n$Cles$produitsClassificationsValeurDrawerArchivee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.classifications.valeur.drawer.archivee', _List_Nil, 'La valeur archivée');
};
var $author$project$I18n$Cles$produitsClassificationsValeurNouvelle = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.classifications.valeur.nouvelle', _List_Nil, 'Nouvelle valeur');
};
var $author$project$I18n$Cles$produitsClassificationsValeurReactiver = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.classifications.valeur.reactiver', _List_Nil, 'Réactiver');
};
var $author$project$I18n$Cles$produitsClassificationsValeurReactiverPhrase = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.classifications.valeur.reactiver.phrase', _List_Nil, 'Elle est archivée : elle ne se propose plus. Réactivée, elle reprend sa place dans la liste.');
};
var $author$project$I18n$Cles$produitsClassificationsValeurRenommerValider = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.classifications.valeur.renommer.valider', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$produitsParcoursInformationsConsultationFermer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.consultation.fermer', _List_Nil, 'Fermer');
};
var $author$project$Components$Produits$StructureCatalogue$Classifications$View$drawer = F2(
	function (i18n, model) {
		var valeurDe = F2(
			function (ouDonc, laquelle) {
				return A2(
					$elm$core$Maybe$andThen,
					function (fournie) {
						return A2(
							$elm$core$Maybe$map,
							$elm$core$Tuple$pair(fournie),
							A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$valeurDe, laquelle, fournie));
					},
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.vk;
							},
							$author$project$Components$Produits$StructureCatalogue$Classifications$Model$classificationDe(ouDonc)),
						model.h$));
			});
		var section = model.vk;
		var refus = A2(
			$author$project$Components$Shared$Messages$View$view,
			i18n,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $elm$core$List$singleton, model.aL)));
		var _v0 = function () {
			var _v1 = section.mW;
			switch (_v1.$) {
				case 1:
					var saisie = _v1.a;
					return _Utils_Tuple3(
						$author$project$I18n$Cles$produitsClassificationsAjoutOuvrir(i18n),
						$author$project$I18n$Cles$produitsClassificationsAjoutAjouter(i18n),
						_List_fromArray(
							[
								refus,
								A3(
								$author$project$Components$Produits$StructureCatalogue$Classifications$View$libellesSaisis,
								i18n,
								$author$project$I18n$Cles$produitsCatalogueChampNom(i18n),
								saisie)
							]));
				case 2:
					var ouDonc = _v1.a;
					var saisie = _v1.b;
					return _Utils_Tuple3(
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$I18n$Cles$produitsClassificationsValeurNouvelle(i18n),
							A2(
								$elm$core$Maybe$map,
								function (nom) {
									return A2(
										$author$project$I18n$Cles$produitsValeursAjouter,
										i18n,
										{md: nom});
								},
								A2(
									$elm$core$Maybe$andThen,
									function (structure) {
										return A2(
											$elm$core$Maybe$andThen,
											function (typologie) {
												return A3($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$etageSous, structure.C9, typologie, $elm$core$Maybe$Nothing);
											},
											A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$classificationDe, ouDonc, structure.vk));
									},
									model.h$))),
						$author$project$I18n$Cles$produitsClassificationsValeurAjouterValider(i18n),
						_List_fromArray(
							[
								refus,
								A3(
								$author$project$Components$Produits$StructureCatalogue$Classifications$View$libellesSaisis,
								i18n,
								$author$project$I18n$Cles$produitsStructureLibelle(i18n),
								saisie)
							]));
				case 3:
					var ajout = _v1.a;
					var saisie = _v1.b;
					return _Utils_Tuple3(
						A2(
							$author$project$I18n$Cles$produitsValeursAjouter,
							i18n,
							{md: ajout.Dj}),
						$author$project$I18n$Cles$produitsClassificationsValeurAjouterValider(i18n),
						_List_fromArray(
							[
								refus,
								A3(
								$author$project$Components$Produits$StructureCatalogue$Classifications$View$libellesSaisis,
								i18n,
								$author$project$I18n$Cles$produitsStructureLibelle(i18n),
								saisie)
							]));
				case 4:
					var ouDonc = _v1.a;
					var laquelle = _v1.b;
					var saisie = _v1.c;
					return _Utils_Tuple3(
						$author$project$I18n$Cles$produitsClassificationsValeurDrawer(i18n),
						$author$project$I18n$Cles$produitsClassificationsValeurRenommerValider(i18n),
						_List_fromArray(
							[
								refus,
								A3(
								$author$project$Components$Produits$StructureCatalogue$Classifications$View$libellesSaisis,
								i18n,
								$author$project$I18n$Cles$produitsStructureLibelle(i18n),
								saisie),
								function () {
								var _v2 = A2(valeurDe, ouDonc, laquelle);
								if (!_v2.$) {
									var _v3 = _v2.a;
									var fournie = _v3.b;
									return A2($author$project$Components$Produits$StructureCatalogue$Classifications$View$offert, $author$project$API$NavLinksDictionary$archiverUneValeur, fournie.nQ) ? A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('section'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('archivage')
											]),
										_List_fromArray(
											[
												A3(
												$author$project$Components$Shared$Bouton$View$bouton,
												1,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('archiver'),
														$rtfeldman$elm_css$Html$Styled$Attributes$id(
														A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDuBouton, 'archiver', laquelle)),
														$rtfeldman$elm_css$Html$Styled$Events$onClick(
														A2($author$project$Components$Produits$StructureCatalogue$Classifications$Update$ArchivageDemande, ouDonc, laquelle)),
														$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
														$author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model))
													]),
												$author$project$I18n$Cles$produitsClassificationsValeurArchiver(i18n))
											])) : $rtfeldman$elm_css$Html$Styled$text('');
								} else {
									return $rtfeldman$elm_css$Html$Styled$text('');
								}
							}()
							]));
				case 5:
					var ouDonc = _v1.a;
					var laquelle = _v1.b;
					var _v4 = A2(valeurDe, ouDonc, laquelle);
					if (!_v4.$) {
						var _v5 = _v4.a;
						var fournie = _v5.b;
						return _Utils_Tuple3(
							A2(
								$author$project$I18n$Cles$produitsClassificationsValeurArchiverDe,
								i18n,
								{
									Dj: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nomDeLaValeur(fournie)
								}),
							$author$project$I18n$Cles$produitsClassificationsValeurArchiverConfirmer(i18n),
							_List_fromArray(
								[
									refus,
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('phrase')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$produitsClassificationsValeurArchiverQuestion,
												i18n,
												{
													Dj: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nomDeLaValeur(fournie)
												}))
										]))
								]));
					} else {
						return _Utils_Tuple3('', '', _List_Nil);
					}
				case 6:
					var ouDonc = _v1.a;
					var laquelle = _v1.b;
					var _v6 = A2(valeurDe, ouDonc, laquelle);
					if (!_v6.$) {
						var _v7 = _v6.a;
						var fournie = _v7.b;
						return _Utils_Tuple3(
							$author$project$I18n$Cles$produitsClassificationsValeurDrawerArchivee(i18n),
							$author$project$I18n$Cles$produitsClassificationsValeurReactiver(i18n),
							_List_fromArray(
								[
									refus,
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('phrase')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$strong,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2($author$project$Components$Produits$StructureCatalogue$Classifications$View$libelles, i18n, fournie.R))
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('phrase')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsClassificationsValeurReactiverPhrase(i18n))
										]))
								]));
					} else {
						return _Utils_Tuple3('', '', _List_Nil);
					}
				case 7:
					var ouDonc = _v1.a;
					var _v8 = A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.vk;
							},
							$author$project$Components$Produits$StructureCatalogue$Classifications$Model$classificationDe(ouDonc)),
						model.h$);
					if (!_v8.$) {
						var fournie = _v8.a;
						return _Utils_Tuple3(
							$author$project$I18n$Cles$produitsClassificationsOrdonner(i18n),
							$author$project$I18n$Cles$produitsParcoursInformationsConsultationFermer(i18n),
							_List_fromArray(
								[
									refus,
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('phrase')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsClassificationsOrdonnerPhrase(i18n))
										])),
									A4(
									$author$project$Components$Produits$StructureCatalogue$Classifications$View$ordre,
									i18n,
									$author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model),
									section,
									fournie),
									A2($author$project$Components$Produits$StructureCatalogue$Classifications$View$annonce, i18n, section)
								]));
					} else {
						return _Utils_Tuple3('', '', _List_Nil);
					}
				default:
					return _Utils_Tuple3('', '', _List_Nil);
			}
		}();
		var titre = _v0.a;
		var action = _v0.b;
		var contenu = _v0.c;
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Produits$StructureCatalogue$Classifications$Update$DuDrawer,
			{
				fs: {
					sR: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$enDrawer(section.mW) && (!$author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model)),
					Bl: action,
					C$: $author$project$Components$Produits$StructureCatalogue$Classifications$Update$Valide
				},
				fZ: contenu,
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: titre
			},
			section.kX);
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$AjoutDeValeurOuvert = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$OrdreOuvert = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$RenommageDeTypologieOuvert = function (a) {
	return {$: 40, a: a};
};
var $author$project$I18n$Cles$produitsClassificationsEnDouble = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.classifications.en-double', _List_Nil, 'Une autre liste porte déjà ce nom.');
};
var $author$project$I18n$Cles$produitsClassificationsValeurAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.classifications.valeur.ajouter', _List_Nil, 'Ajouter une valeur');
};
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerAnglais = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.parcours.informations.drawer.anglais',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Anglais : ' + p.Dj);
	});
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.drawer.nom', _List_Nil, 'Nom');
};
var $author$project$I18n$Cles$produitsParcoursInformationsListeArchivees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.liste.archivees', _List_Nil, 'Archivées');
};
var $author$project$I18n$Cles$produitsParcoursInformationsListeRenommer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.liste.renommer', _List_Nil, 'Renommer la liste');
};
var $author$project$I18n$Cles$produitsParcoursInformationsListeValeurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.liste.valeurs', _List_Nil, 'Valeurs');
};
var $author$project$I18n$Cles$produitsParcoursInformationsListeValeursPhrase = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.liste.valeurs.phrase', _List_Nil, 'Dans l\'ordre où elles seront proposées.');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Consultations$section = F3(
	function (nom, titre, enfants) {
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('section'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(nom)
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$h3,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(titre)
							])),
					enfants))
			]);
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$View$aplatie = function (fournie) {
	var sous = F2(
		function (profondeur, parent) {
			return (profondeur > 32) ? _List_Nil : A2(
				$elm$core$List$concatMap,
				function (fille) {
					return A2(
						$elm$core$List$cons,
						_Utils_Tuple2(profondeur, fille),
						A2(
							sous,
							profondeur + 1,
							$elm$core$Maybe$Just(fille.Aq)));
				},
				A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$fillesDe, parent, fournie.Ki));
		});
	return A2(sous, 0, $elm$core$Maybe$Nothing);
};
var $author$project$Components$Produits$StructureCatalogue$Classifications$Update$ValeurOuverte = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$View$ligne = F4(
	function (i18n, inactif, classification_, _v0) {
		var profondeur = _v0.a;
		var fournie = _v0.b;
		var ouvrable = fournie.tI ? A2($author$project$Components$Produits$StructureCatalogue$Classifications$View$offert, $author$project$API$NavLinksDictionary$reactiverUneValeur, fournie.nQ) : A2($author$project$Components$Produits$StructureCatalogue$Classifications$View$offert, $author$project$API$NavLinksDictionary$traduireUneValeur, fournie.nQ);
		var contenu = _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$strong,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$Components$Produits$StructureCatalogue$Classifications$View$libelles, i18n, fournie.R))
					])),
				A2(
				$author$project$Components$Produits$StructureCatalogue$Controles$anglaisManquant,
				i18n,
				_Utils_eq(fournie.R.yg, $elm$core$Maybe$Nothing)),
				fournie.tI ? A2(
				$author$project$Components$Shared$Tag$View$view,
				3,
				$author$project$I18n$Cles$produitsClassificationsValeurArchivee(i18n)) : $rtfeldman$elm_css$Html$Styled$text('')
			]);
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('archivee', fournie.tI),
							_Utils_Tuple2('sous-valeur', profondeur > 0)
						]))
				]),
			_List_fromArray(
				[
					ouvrable ? A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne'),
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(
							$author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDeLaLigne(fournie.Aq)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							A2($author$project$Components$Produits$StructureCatalogue$Classifications$Update$ValeurOuverte, classification_.Aq, fournie.Aq)),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif)
						]),
					contenu) : A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne')
						]),
					contenu)
				]));
	});
var $author$project$I18n$Cles$produitsClassificationsValeursVide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.classifications.valeurs.vide', _List_Nil, 'Aucune valeur.');
};
var $author$project$Components$Produits$StructureCatalogue$Classifications$View$valeurs = F4(
	function (i18n, inactif, section, ouverte) {
		if (ouverte.$ === 1) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('valeurs'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('hidden')
					]),
				_List_Nil);
		} else {
			var fournie = ouverte.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('valeurs'),
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('loading', inactif),
								_Utils_Tuple2(
								'en-cours',
								!_Utils_eq(section.pt, $elm$core$Maybe$Nothing))
							])),
						$author$project$Components$Produits$StructureCatalogue$Controles$occupe(inactif)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
							]),
						$elm$core$List$isEmpty(fournie.Ki) ? _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsClassificationsValeursVide(i18n))
							]) : _List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('arbre')
							]),
						A2(
							$elm$core$List$map,
							A3($author$project$Components$Produits$StructureCatalogue$Classifications$View$ligne, i18n, inactif, fournie),
							$author$project$Components$Produits$StructureCatalogue$Classifications$View$aplatie(fournie)))
					]));
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Consultations$deLaListe = F3(
	function (i18n, model, liste) {
		var renommable = !_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$renommerUneClassification, liste.nQ),
			$elm$core$Maybe$Nothing);
		var inactif = $author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model);
		var archivees = _Utils_update(
			liste,
			{
				Ki: A2(
					$elm$core$List$map,
					function (v) {
						return _Utils_update(
							v,
							{ey: $elm$core$Maybe$Nothing});
					},
					A2(
						$elm$core$List$filter,
						function ($) {
							return $.tI;
						},
						liste.Ki))
			});
		var appel = F4(
			function (idControle, classe, libelle, message) {
				return A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class(classe),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(idControle),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(message),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif)
						]),
					libelle);
			});
		var ajoutable = !_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ajouterUneValeur, liste.nQ),
			$elm$core$Maybe$Nothing);
		var actives = _Utils_update(
			liste,
			{
				Ki: A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$not,
						function ($) {
							return $.tI;
						}),
					liste.Ki)
			});
		var ordonnable = ($elm$core$List$length(actives.Ki) > 1) && A2(
			$elm$core$List$any,
			function (v) {
				return !_Utils_eq(
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$deplacerUneValeur, v.nQ),
					$elm$core$Maybe$Nothing);
			},
			actives.Ki);
		return $elm$core$List$concat(
			_List_fromArray(
				[
					A3(
					$author$project$Components$Produits$StructureCatalogue$Informations$Consultations$section,
					'nom',
					$author$project$I18n$Cles$produitsParcoursInformationsDrawerNom(i18n),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(liste))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('double'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'note')
								]),
							liste.gi ? _List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsClassificationsEnDouble(i18n))
								]) : _List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('traduction')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$produitsParcoursInformationsDrawerAnglais,
										i18n,
										{
											Dj: A2($elm$core$Maybe$withDefault, '', liste.R.yg)
										}))
								])),
							renommable ? A4(
							appel,
							$author$project$Components$Produits$StructureCatalogue$Typologies$Model$idDuBoutonRenommer(liste.Aq),
							'renommer',
							$author$project$I18n$Cles$produitsParcoursInformationsListeRenommer(i18n),
							$author$project$Components$Produits$StructureCatalogue$Update$RenommageDeTypologieOuvert(liste.Aq)) : $rtfeldman$elm_css$Html$Styled$text('')
						])),
					A3(
					$author$project$Components$Produits$StructureCatalogue$Informations$Consultations$section,
					'valeurs',
					$author$project$I18n$Cles$produitsParcoursInformationsListeValeurs(i18n),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('phrase')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsParcoursInformationsListeValeursPhrase(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Components$Produits$StructureCatalogue$Update$DesClassifications,
							A4(
								$author$project$Components$Produits$StructureCatalogue$Classifications$View$valeurs,
								i18n,
								inactif,
								model.vk,
								$elm$core$Maybe$Just(actives))),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('appels')
								]),
							_List_fromArray(
								[
									ajoutable ? A4(
									appel,
									$author$project$Components$Produits$StructureCatalogue$Classifications$Model$idPourAjouterUneValeur,
									'add',
									$author$project$I18n$Cles$produitsClassificationsValeurAjouter(i18n),
									$author$project$Components$Produits$StructureCatalogue$Update$DesClassifications(
										$author$project$Components$Produits$StructureCatalogue$Classifications$Update$AjoutDeValeurOuvert(liste.Aq))) : $rtfeldman$elm_css$Html$Styled$text(''),
									ordonnable ? A4(
									appel,
									$author$project$Components$Produits$StructureCatalogue$Classifications$Model$idPourOrdonner,
									'ordonner',
									$author$project$I18n$Cles$produitsClassificationsOrdonner(i18n),
									$author$project$Components$Produits$StructureCatalogue$Update$DesClassifications(
										$author$project$Components$Produits$StructureCatalogue$Classifications$Update$OrdreOuvert(liste.Aq))) : $rtfeldman$elm_css$Html$Styled$text('')
								]))
						])),
					$elm$core$List$isEmpty(archivees.Ki) ? _List_Nil : A3(
					$author$project$Components$Produits$StructureCatalogue$Informations$Consultations$section,
					'archivees',
					$author$project$I18n$Cles$produitsParcoursInformationsListeArchivees(i18n),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Components$Produits$StructureCatalogue$Update$DesClassifications,
							A4(
								$author$project$Components$Produits$StructureCatalogue$Classifications$View$valeurs,
								i18n,
								inactif,
								model.vk,
								$elm$core$Maybe$Just(archivees)))
						]))
				]));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$AjoutDEtatOuvert = {$: 32};
var $author$project$Components$Produits$StructureCatalogue$Update$EtatDescendu = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$EtatMonte = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$EtatRetire = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$RenommageDEtatOuvert = function (a) {
	return {$: 18, a: a};
};
var $author$project$I18n$Cles$produitsParcoursInformationsEtatDepart = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.etat.depart', _List_Nil, 'état de départ');
};
var $author$project$Components$Produits$StructureCatalogue$Etats$View$anglais = F3(
	function (i18n, ligne, fourni) {
		return _Utils_ap(
			A2(
				$author$project$I18n$Cles$produitsParcoursInformationsDrawerAnglais,
				i18n,
				{
					Dj: A2(
						$author$project$I18n$Cles$texte,
						i18n,
						$author$project$Components$Produits$StructureCatalogue$Etats$Model$libelleAnglaisDeLEtat(fourni))
				}),
			ligne.Ge ? (' · ' + $author$project$I18n$Cles$produitsParcoursInformationsEtatDepart(i18n)) : '');
	});
var $author$project$I18n$Cles$produitsStructureVerrouillagePastille = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.structure.verrouillage.pastille', _List_Nil, 'fiche verrouillée');
};
var $author$project$Components$Produits$StructureCatalogue$Etats$View$pastille = F2(
	function (i18n, fourni) {
		return fourni.KA ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille-verrouillage')
					]),
				_List_fromArray(
					[
						$author$project$Components$Shared$Svg$svgLock,
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsStructureVerrouillagePastille(i18n))
					]))
			]) : _List_Nil;
	});
var $author$project$I18n$Cles$produitsClassificationsValeurRenommer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.classifications.valeur.renommer', _List_Nil, 'Renommer');
};
var $author$project$I18n$Cles$produitsClassificationsValeurRenommerDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.classifications.valeur.renommer.de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Renommer ' + p.Dj);
	});
var $author$project$I18n$Cles$produitsStructureRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.structure.retirer', _List_Nil, 'Retirer');
};
var $author$project$I18n$Cles$produitsStructureRetirerDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.structure.retirer.de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer ' + p.Dj);
	});
var $author$project$Components$Produits$StructureCatalogue$Etats$View$etat = F3(
	function (i18n, ligne, fourni) {
		var sansAnglais = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.yg;
					},
					$elm$core$Basics$eq($elm$core$Maybe$Nothing)),
				fourni.R));
		var nom = A2(
			$author$project$I18n$Cles$texte,
			i18n,
			$author$project$Components$Produits$StructureCatalogue$Etats$Model$libelleDeLEtat(fourni));
		var libelles = _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$strong,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Html$Styled$text(nom),
					A2($author$project$Components$Produits$StructureCatalogue$Etats$View$pastille, i18n, fourni))),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle-anglais')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A3($author$project$Components$Produits$StructureCatalogue$Etats$View$anglais, i18n, ligne, fourni))
					])),
				A2($author$project$Components$Produits$StructureCatalogue$Controles$anglaisManquant, i18n, sansAnglais)
			]);
		return ligne.f6 ? A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'data-etat',
					$author$project$Catalogue$Identifiants$etatCodeToString(fourni.vx))
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('poignee'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
						]),
					_List_fromArray(
						[$author$project$Components$Shared$Svg$svgDragHandle])),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('ordre')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$Produits$StructureCatalogue$Controles$boutonDOrdre,
								0,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id(
										A2($author$project$Components$Produits$StructureCatalogue$Etats$Model$idDuBoutonDOrdreDeLEtat, fourni.vx, 0)),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Produits$StructureCatalogue$Update$EtatMonte(fourni.vx)),
										$rtfeldman$elm_css$Html$Styled$Attributes$disabled(ligne.Ge || ligne.cF),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
										'aria-label',
										A2(
											$author$project$I18n$Cles$produitsStructureOrdreMonterDe,
											i18n,
											{Dj: nom})),
										$rtfeldman$elm_css$Html$Styled$Attributes$title(
										A2(
											$author$project$I18n$Cles$produitsStructureOrdreMonterDe,
											i18n,
											{Dj: nom}))
									])),
								A2(
								$author$project$Components$Produits$StructureCatalogue$Controles$boutonDOrdre,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id(
										A2($author$project$Components$Produits$StructureCatalogue$Etats$Model$idDuBoutonDOrdreDeLEtat, fourni.vx, 1)),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Produits$StructureCatalogue$Update$EtatDescendu(fourni.vx)),
										$rtfeldman$elm_css$Html$Styled$Attributes$disabled(ligne.xg || ligne.cF),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
										'aria-label',
										A2(
											$author$project$I18n$Cles$produitsStructureOrdreDescendreDe,
											i18n,
											{Dj: nom})),
										$rtfeldman$elm_css$Html$Styled$Attributes$title(
										A2(
											$author$project$I18n$Cles$produitsStructureOrdreDescendreDe,
											i18n,
											{Dj: nom}))
									]))
							])),
					_Utils_ap(
						libelles,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
									]),
								A2(
									$elm$core$List$cons,
									A3(
										$author$project$Components$Shared$Bouton$View$bouton,
										1,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('renommer'),
												$rtfeldman$elm_css$Html$Styled$Attributes$id(
												$author$project$Components$Produits$StructureCatalogue$Etats$Model$idDuBoutonRenommer(fourni.vx)),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												$author$project$Components$Produits$StructureCatalogue$Update$RenommageDEtatOuvert(fourni.vx)),
												$rtfeldman$elm_css$Html$Styled$Attributes$disabled(ligne.cF),
												A2(
												$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
												'aria-label',
												A2(
													$author$project$I18n$Cles$produitsClassificationsValeurRenommerDe,
													i18n,
													{Dj: nom})),
												$rtfeldman$elm_css$Html$Styled$Attributes$title(
												A2(
													$author$project$I18n$Cles$produitsClassificationsValeurRenommerDe,
													i18n,
													{Dj: nom}))
											]),
										$author$project$I18n$Cles$produitsClassificationsValeurRenommer(i18n)),
									ligne.hW ? _List_Nil : _List_fromArray(
										[
											A3(
											$author$project$Components$Shared$Bouton$View$bouton,
											1,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer'),
													$rtfeldman$elm_css$Html$Styled$Events$onClick(
													$author$project$Components$Produits$StructureCatalogue$Update$EtatRetire(fourni.vx)),
													$rtfeldman$elm_css$Html$Styled$Attributes$disabled(ligne.cF),
													A2(
													$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
													'aria-label',
													A2(
														$author$project$I18n$Cles$produitsStructureRetirerDe,
														i18n,
														{Dj: nom})),
													$rtfeldman$elm_css$Html$Styled$Attributes$title(
													A2(
														$author$project$I18n$Cles$produitsStructureRetirerDe,
														i18n,
														{Dj: nom}))
												]),
											$author$project$I18n$Cles$produitsStructureRetirer(i18n))
										])))
							]))))) : A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'data-etat',
					$author$project$Catalogue$Identifiants$etatCodeToString(fourni.vx))
				]),
			libelles);
	});
var $author$project$Components$Produits$StructureCatalogue$Etats$View$liste = F3(
	function (i18n, model, structure) {
		var envoiEnCours = $author$project$Components$Produits$StructureCatalogue$Controles$enCours(model);
		var dernier = $elm$core$List$length(structure.mj) - 1;
		var definissable = !_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$definirLesEtats, structure.nQ),
			$elm$core$Maybe$Nothing);
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$ul,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('etats'),
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('loading', envoiEnCours)
							])),
						$author$project$Components$Produits$StructureCatalogue$Controles$occupe(envoiEnCours)
					]),
				A2(
					$elm$core$List$indexedMap,
					function (place) {
						return A2(
							$author$project$Components$Produits$StructureCatalogue$Etats$View$etat,
							i18n,
							{
								f6: definissable,
								xg: _Utils_eq(place, dernier),
								cF: envoiEnCours,
								Ge: !place,
								hW: !dernier
							});
					},
					structure.mj)),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('annonce'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-live', 'polite')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$I18n$Cles$texte, i18n, model.tl))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ajouter')
					]),
				definissable ? _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('add'),
								$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$StructureCatalogue$Etats$Model$idDeLOuvertureDeLAjout),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$StructureCatalogue$Update$AjoutDEtatOuvert),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(envoiEnCours)
							]),
						$author$project$I18n$Cles$produitsStructureEtatAjouterOuvrir(i18n))
					]) : _List_Nil)
			]);
	});
var $author$project$Components$Produits$StructureCatalogue$Update$RenommageDeNatureOuvert = function (a) {
	return {$: 27, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$NatureDescendue = function (a) {
	return {$: 31, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$NatureMonte = function (a) {
	return {$: 30, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Natures$View$ordre = F4(
	function (i18n, contexte, nature, nom) {
		return (contexte.bP && (!_Utils_eq(nature.vx, $author$project$Catalogue$Vocabulaire$natureDeService))) ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ordre')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$Produits$StructureCatalogue$Controles$boutonDOrdre,
						0,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id(
								A2($author$project$Components$Produits$StructureCatalogue$Natures$Model$idDuBoutonDOrdre, nature.vx, 0)),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Produits$StructureCatalogue$Update$NatureMonte(nature.vx)),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(contexte.Gf || contexte.cF),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-label',
								A2(
									$author$project$I18n$Cles$produitsStructureOrdreMonterDe,
									i18n,
									{Dj: nom})),
								$rtfeldman$elm_css$Html$Styled$Attributes$title(
								A2(
									$author$project$I18n$Cles$produitsStructureOrdreMonterDe,
									i18n,
									{Dj: nom}))
							])),
						A2(
						$author$project$Components$Produits$StructureCatalogue$Controles$boutonDOrdre,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id(
								A2($author$project$Components$Produits$StructureCatalogue$Natures$Model$idDuBoutonDOrdre, nature.vx, 1)),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Produits$StructureCatalogue$Update$NatureDescendue(nature.vx)),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(contexte.xj || contexte.cF),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-label',
								A2(
									$author$project$I18n$Cles$produitsStructureOrdreDescendreDe,
									i18n,
									{Dj: nom})),
								$rtfeldman$elm_css$Html$Styled$Attributes$title(
								A2(
									$author$project$I18n$Cles$produitsStructureOrdreDescendreDe,
									i18n,
									{Dj: nom}))
							]))
					]))
			]) : _List_Nil;
	});
var $author$project$I18n$Cles$produitsParcoursInformationsNatureVerrouillee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.nature.verrouillee', _List_Nil, 'Verrouillée · utilisée par les offres de service');
};
var $author$project$Components$Produits$StructureCatalogue$Natures$View$ligne = F3(
	function (i18n, contexte, nature) {
		var nom = A2(
			$author$project$I18n$Cles$texte,
			i18n,
			$author$project$Components$Produits$StructureCatalogue$Natures$Model$libelleDeLaNature(nature));
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('nature'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-nature', nature.vx)
				]),
			_Utils_ap(
				A4($author$project$Components$Produits$StructureCatalogue$Natures$View$ordre, i18n, contexte, nature, nom),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(nom)
							])),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('libelle-anglais')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$texte,
										i18n,
										$author$project$Components$Produits$StructureCatalogue$Natures$Model$libelleAnglaisDeLaNature(nature)))
								])),
						_Utils_ap(
							_Utils_eq(nature.vx, $author$project$Catalogue$Vocabulaire$natureDeService) ? _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('verrouillee')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsParcoursInformationsNatureVerrouillee(i18n))
										]))
								]) : _List_Nil,
							contexte.hK ? _List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('renommer'),
											$rtfeldman$elm_css$Html$Styled$Attributes$id(
											$author$project$Components$Produits$StructureCatalogue$Natures$Model$idDuBoutonRenommer(nature.vx)),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Produits$StructureCatalogue$Update$RenommageDeNatureOuvert(nature.vx)),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(contexte.cF),
											A2(
											$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
											'aria-label',
											A2(
												$author$project$I18n$Cles$produitsClassificationsValeurRenommerDe,
												i18n,
												{Dj: nom})),
											$rtfeldman$elm_css$Html$Styled$Attributes$title(
											A2(
												$author$project$I18n$Cles$produitsClassificationsValeurRenommerDe,
												i18n,
												{Dj: nom}))
										]),
									$author$project$I18n$Cles$produitsClassificationsValeurRenommer(i18n))
								]) : _List_Nil)))));
	});
var $author$project$Components$Produits$StructureCatalogue$Natures$View$liste = F3(
	function (i18n, model, structure) {
		var renommable = !_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$renommerUneNature, structure.nQ),
			$elm$core$Maybe$Nothing);
		return A2(
			$rtfeldman$elm_css$Html$Styled$ul,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('natures'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'loading',
							$author$project$Components$Produits$StructureCatalogue$Controles$enCours(model))
						]))
				]),
			A2(
				$elm$core$List$indexedMap,
				function (place) {
					return A2(
						$author$project$Components$Produits$StructureCatalogue$Natures$View$ligne,
						i18n,
						{
							xj: _Utils_eq(
								place,
								$elm$core$List$length(
									$author$project$Components$Produits$StructureCatalogue$Natures$Model$deplacables(structure.oo)) - 1),
							cF: $author$project$Components$Produits$StructureCatalogue$Controles$enCours(model),
							bP: !_Utils_eq(
								A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ordonnerLesNatures, structure.nQ),
								$elm$core$Maybe$Nothing),
							Gf: !place,
							hK: renommable
						});
				},
				structure.oo));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$InformationMasqueeReaffichee = F2(
	function (a, b) {
		return {$: 133, a: a, b: b};
	});
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerReafficher = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.parcours.informations.drawer.reafficher',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Réafficher « ' + (p.Dj + ' »'));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$relDuReaffichage = function (portee) {
	if (portee.$ === 3) {
		return $author$project$API$NavLinksDictionary$afficherUnChamp;
	} else {
		return $author$project$API$NavLinksDictionary$afficherUneInformation;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Consultations$reaffichable = F4(
	function (i18n, inactif, portee, lue) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('information')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(lue.uN.Bl)
						])),
					(!_Utils_eq(
					A2(
						$author$project$API$Liens$trouver,
						$author$project$Components$Produits$StructureCatalogue$Informations$Model$relDuReaffichage(portee),
						lue.nQ),
					$elm$core$Maybe$Nothing)) ? A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('reafficher'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							A2($author$project$Components$Produits$StructureCatalogue$Update$InformationMasqueeReaffichee, portee, lue.uN.dy)),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif)
						]),
					A2(
						$author$project$I18n$Cles$produitsParcoursInformationsDrawerReafficher,
						i18n,
						{Dj: lue.uN.Bl})) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Consultations$masquees = F3(
	function (i18n, model, portee) {
		var inactif = $author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model);
		var cachees = A2(
			$elm$core$List$filter,
			function ($) {
				return $.n4;
			},
			A2(
				$elm$core$List$concatMap,
				function ($) {
					return $.dw;
				},
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.F$;
						},
						$elm$core$Basics$eq(portee)),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.F3;
							},
							model.AM)))));
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$ul,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('masquees')
					]),
				A2(
					$elm$core$List$map,
					A3($author$project$Components$Produits$StructureCatalogue$Informations$Consultations$reaffichable, i18n, inactif, portee),
					cachees))
			]);
	});
var $author$project$I18n$Cles$produitsParcoursInformationsEtatKicker = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.etat.kicker', _List_Nil, 'Information · Pour toutes les références');
};
var $author$project$I18n$Cles$produitsParcoursInformationsEtatPhrase = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.etat.phrase', _List_Nil, 'Les états par lesquels passe une référence, dans l\'ordre. Le premier est celui d\'une référence créée.');
};
var $author$project$I18n$Cles$produitsParcoursInformationsEtatTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.etat.titre', _List_Nil, 'État d\'une référence');
};
var $author$project$I18n$Cles$produitsParcoursInformationsListeKicker = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.liste.kicker', _List_Nil, 'Liste de choix');
};
var $author$project$I18n$Cles$produitsParcoursInformationsMasqueesPhrase = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.masquees.phrase', _List_Nil, 'Une information masquée ne se saisit plus. Ce qui a été saisi reste sur les fiches ; réaffichée, elle se saisit de nouveau.');
};
var $author$project$I18n$Cles$produitsParcoursInformationsMasqueesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.masquees.titre', _List_Nil, 'Informations masquées');
};
var $author$project$I18n$Cles$produitsParcoursInformationsNaturePhrase = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.nature.phrase', _List_Nil, 'Ce qu\'est une référence : un produit fini, une pièce, un service… Proposées dans cet ordre à la création d\'une référence et comme nature par défaut d\'une catégorie. « Service » est verrouillée : les offres de service en dépendent.');
};
var $author$project$I18n$Cles$produitsParcoursInformationsNatureTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.nature.titre', _List_Nil, 'Nature d\'article');
};
var $author$project$I18n$Cles$produitsParcoursInformationsNatures = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.natures', _List_Nil, 'Natures');
};
var $author$project$I18n$Cles$produitsStructureSectionEtatsCourt = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.structure.section.etats.court', _List_Nil, 'États');
};
var $author$project$I18n$Cles$produitsStructureVerrouillageTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.structure.verrouillage.titre', _List_Nil, 'Verrouillage de la fiche');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Consultations$sansPied = F6(
	function (i18n, model, kicker, titre, contenu, dernier) {
		return A4(
			$author$project$Components$Shared$Drawer$View$sansPied,
			i18n,
			$author$project$Components$Produits$StructureCatalogue$Update$DeLaConsultation,
			{
				fZ: contenu,
				xg: dernier,
				A6: $elm$core$Maybe$Just(kicker),
				h6: titre
			},
			model.gc);
	});
var $author$project$Components$Produits$StructureCatalogue$Update$VerrouillageChoisi = function (a) {
	return {$: 25, a: a};
};
var $author$project$I18n$Cles$produitsStructureVerrouillageCompteAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.structure.verrouillage.compte-aucune', _List_Nil, 'Aucune référence n\'est aujourd\'hui verrouillée.');
};
var $author$project$I18n$Cles$produitsStructureVerrouillageComptePlusieurs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.structure.verrouillage.compte-plusieurs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			p.w + ' références sont aujourd\'hui verrouillées.');
	});
var $author$project$I18n$Cles$produitsStructureVerrouillageCompteUne = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.structure.verrouillage.compte-une', _List_Nil, '1 référence est aujourd\'hui verrouillée.');
};
var $author$project$Components$Produits$StructureCatalogue$Etats$View$compte = F2(
	function (i18n, nombre) {
		switch (nombre) {
			case 0:
				return $author$project$I18n$Cles$produitsStructureVerrouillageCompteAucune(i18n);
			case 1:
				return $author$project$I18n$Cles$produitsStructureVerrouillageCompteUne(i18n);
			default:
				return A2(
					$author$project$I18n$Cles$produitsStructureVerrouillageComptePlusieurs,
					i18n,
					{
						w: $elm$core$String$fromInt(nombre)
					});
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Etats$View$envoiCle = function (envoiEnCours) {
	return envoiEnCours ? '-envoi-' : '-';
};
var $author$project$Components$Produits$StructureCatalogue$Etats$Model$idDuVerrouillage = 'verrouillage-seuil';
var $author$project$I18n$Cles$produitsStructureVerrouillageAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.structure.verrouillage.aide', _List_Nil, 'Pour corriger une fiche verrouillée, repassez-la à un état antérieur : elle redevient modifiable.');
};
var $author$project$I18n$Cles$produitsStructureVerrouillageJamais = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.structure.verrouillage.jamais', _List_Nil, 'Jamais');
};
var $author$project$I18n$Cles$produitsStructureVerrouillageSelecteur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.structure.verrouillage.selecteur', _List_Nil, 'La fiche est verrouillée à partir de');
};
var $author$project$I18n$Cles$produitsStructureVerrouillageTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.structure.verrouillage.texte', _List_Nil, 'Une fois validée, une référence ne se modifie plus : ses informations, sa place dans l\'arbre et ses valeurs de liste restent figées. Son état, lui, peut toujours changer.');
};
var $author$project$Components$Produits$StructureCatalogue$Etats$View$verrouillage = F3(
	function (i18n, model, structure) {
		var seuil = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Maybe$map, $author$project$Catalogue$Identifiants$etatCodeToString, structure.Kz));
		var envoiEnCours = $author$project$Components$Produits$StructureCatalogue$Controles$enCours(model);
		var choix = F3(
			function (interdit, code, libelle) {
				return _Utils_Tuple2(
					code,
					A2(
						$rtfeldman$elm_css$Html$Styled$option,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'value', code),
								$rtfeldman$elm_css$Html$Styled$Attributes$selected(
								_Utils_eq(code, seuil)),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(interdit)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(libelle)
							])));
			});
		var etats = A2(
			$elm$core$List$indexedMap,
			F2(
				function (rang, e) {
					return A3(
						choix,
						!rang,
						$author$project$Catalogue$Identifiants$etatCodeToString(e.vx),
						A2(
							$author$project$I18n$Cles$texte,
							i18n,
							$author$project$Components$Produits$StructureCatalogue$Etats$Model$libelleDeLEtat(e)));
				}),
			structure.mj);
		var selecteur = (!_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$definirLeVerrouillage, structure.nQ),
			$elm$core$Maybe$Nothing)) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('selecteur')
				]),
			_List_fromArray(
				[
					A3(
					$rtfeldman$elm_css$Html$Styled$Keyed$node,
					'select',
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$StructureCatalogue$Etats$Model$idDuVerrouillage),
							$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Produits$StructureCatalogue$Update$VerrouillageChoisi),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(envoiEnCours),
							$author$project$Components$Produits$StructureCatalogue$Controles$occupe(envoiEnCours)
						]),
					A2(
						$elm$core$List$map,
						function (_v0) {
							var code = _v0.a;
							var enfant = _v0.b;
							return _Utils_Tuple2(
								_Utils_ap(
									seuil,
									_Utils_ap(
										$author$project$Components$Produits$StructureCatalogue$Etats$View$envoiCle(envoiEnCours),
										code)),
								enfant);
						},
						A2(
							$elm$core$List$cons,
							A3(
								choix,
								false,
								'',
								$author$project$I18n$Cles$produitsStructureVerrouillageJamais(i18n)),
							etats))),
					$author$project$Components$Shared$Svg$svgChevronDown
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$strong,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('seuil')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$I18n$Cles$produitsStructureVerrouillageJamais(i18n),
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Components$Produits$StructureCatalogue$Etats$Model$libelleDeLEtat,
								$author$project$I18n$Cles$texte(i18n)),
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.vx;
										},
										A2(
											$elm$core$Basics$composeR,
											$author$project$Catalogue$Identifiants$etatCodeToString,
											$elm$core$Basics$eq(seuil))),
									structure.mj)))))
				]));
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsStructureVerrouillageTexte(i18n))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for($author$project$Components$Produits$StructureCatalogue$Etats$Model$idDuVerrouillage)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsStructureVerrouillageSelecteur(i18n))
							])),
						selecteur
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsStructureVerrouillageAide(i18n) + (' ' + A2($author$project$Components$Produits$StructureCatalogue$Etats$View$compte, i18n, structure.Hf)))
							]))
					]))
			]);
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Consultations$drawer = F2(
	function (i18n, model) {
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(model.j9, model.h$);
			if ((!_v1.a.$) && (!_v1.b.$)) {
				switch (_v1.a.a.$) {
					case 0:
						var id = _v1.a.a.a;
						var structure = _v1.b.a;
						var _v2 = A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$classificationDe, id, structure.vk);
						if (!_v2.$) {
							var liste = _v2.a;
							return _Utils_Tuple3(
								$author$project$I18n$Cles$produitsParcoursInformationsListeKicker(i18n),
								$author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(liste),
								A3($author$project$Components$Produits$StructureCatalogue$Informations$Consultations$deLaListe, i18n, model, liste));
						} else {
							return _Utils_Tuple3('', '', _List_Nil);
						}
					case 1:
						var _v3 = _v1.a.a;
						var structure = _v1.b.a;
						return _Utils_Tuple3(
							$author$project$I18n$Cles$produitsParcoursInformationsEtatKicker(i18n),
							$author$project$I18n$Cles$produitsParcoursInformationsEtatTitre(i18n),
							A2(
								$elm$core$List$cons,
								A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('phrase')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsParcoursInformationsEtatPhrase(i18n))
										])),
								_Utils_ap(
									A3(
										$author$project$Components$Produits$StructureCatalogue$Informations$Consultations$section,
										'etats',
										$author$project$I18n$Cles$produitsStructureSectionEtatsCourt(i18n),
										A3($author$project$Components$Produits$StructureCatalogue$Etats$View$liste, i18n, model, structure)),
									A3(
										$author$project$Components$Produits$StructureCatalogue$Informations$Consultations$section,
										'verrouillage',
										$author$project$I18n$Cles$produitsStructureVerrouillageTitre(i18n),
										A3($author$project$Components$Produits$StructureCatalogue$Etats$View$verrouillage, i18n, model, structure)))));
					case 2:
						var _v4 = _v1.a.a;
						var structure = _v1.b.a;
						return _Utils_Tuple3(
							$author$project$I18n$Cles$produitsParcoursInformationsEtatKicker(i18n),
							$author$project$I18n$Cles$produitsParcoursInformationsNatureTitre(i18n),
							A2(
								$elm$core$List$cons,
								A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('phrase')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsParcoursInformationsNaturePhrase(i18n))
										])),
								A3(
									$author$project$Components$Produits$StructureCatalogue$Informations$Consultations$section,
									'natures',
									$author$project$I18n$Cles$produitsParcoursInformationsNatures(i18n),
									_List_fromArray(
										[
											A3($author$project$Components$Produits$StructureCatalogue$Natures$View$liste, i18n, model, structure)
										]))));
					default:
						var _v5 = _v1.a.a;
						var portee = _v5.a;
						var boite = _v5.b;
						return _Utils_Tuple3(
							boite,
							$author$project$I18n$Cles$produitsParcoursInformationsMasqueesTitre(i18n),
							A2(
								$elm$core$List$cons,
								A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('phrase')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsParcoursInformationsMasqueesPhrase(i18n))
										])),
								A3(
									$author$project$Components$Produits$StructureCatalogue$Informations$Consultations$section,
									'masquees',
									$author$project$I18n$Cles$produitsParcoursInformationsMasqueesTitre(i18n),
									A3($author$project$Components$Produits$StructureCatalogue$Informations$Consultations$masquees, i18n, model, portee))));
				}
			} else {
				return _Utils_Tuple3('', '', _List_Nil);
			}
		}();
		var kicker = _v0.a;
		var titre = _v0.b;
		var contenu = _v0.c;
		var _v6 = _Utils_Tuple2(model.j9, titre);
		_v6$2:
		while (true) {
			if (!_v6.a.$) {
				switch (_v6.a.a.$) {
					case 1:
						var _v7 = _v6.a.a;
						return A6($author$project$Components$Produits$StructureCatalogue$Informations$Consultations$sansPied, i18n, model, kicker, titre, contenu, $author$project$Components$Produits$StructureCatalogue$Etats$Model$idDeLOuvertureDeLAjout);
					case 2:
						var _v8 = _v6.a.a;
						return A6(
							$author$project$Components$Produits$StructureCatalogue$Informations$Consultations$sansPied,
							i18n,
							model,
							kicker,
							titre,
							contenu,
							$author$project$Components$Shared$Drawer$Model$idFermer(model.gc));
					default:
						break _v6$2;
				}
			} else {
				break _v6$2;
			}
		}
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Produits$StructureCatalogue$Update$DeLaConsultation,
			{
				fs: {
					sR: titre !== '',
					Bl: $author$project$I18n$Cles$produitsParcoursInformationsConsultationFermer(i18n),
					C$: $author$project$Components$Produits$StructureCatalogue$Update$DeLaConsultation($author$project$Components$Shared$Drawer$Update$Fermer)
				},
				fZ: contenu,
				A6: (titre === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(kicker),
				Bc: false,
				h6: titre
			},
			model.gc);
	});
var $author$project$Components$Produits$StructureCatalogue$Update$OrdreDemande = {$: 168};
var $author$project$Components$Produits$StructureCatalogue$Update$OrdreDescendu = function (a) {
	return {$: 166, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$OrdreMonte = function (a) {
	return {$: 165, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$ligneDOrdre = F4(
	function (i18n, nombre, place, ligne) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne-d-ordre')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('poignee')
						]),
					_List_fromArray(
						[$author$project$Components$Shared$Svg$svgDragHandle])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(ligne.Dj)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ordre')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$OrdreView$boutonDOrdre,
							0,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Produits$StructureCatalogue$Update$OrdreMonte(ligne.dy)),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!place),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									A2(
										$author$project$I18n$Cles$produitsStructureOrdreMonterDe,
										i18n,
										{Dj: ligne.Dj})),
									$rtfeldman$elm_css$Html$Styled$Attributes$title(
									A2(
										$author$project$I18n$Cles$produitsStructureOrdreMonterDe,
										i18n,
										{Dj: ligne.Dj}))
								])),
							A2(
							$author$project$Components$Shared$OrdreView$boutonDOrdre,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Produits$StructureCatalogue$Update$OrdreDescendu(ligne.dy)),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
									_Utils_eq(place, nombre - 1)),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									A2(
										$author$project$I18n$Cles$produitsStructureOrdreDescendreDe,
										i18n,
										{Dj: ligne.Dj})),
									$rtfeldman$elm_css$Html$Styled$Attributes$title(
									A2(
										$author$project$I18n$Cles$produitsStructureOrdreDescendreDe,
										i18n,
										{Dj: ligne.Dj}))
								]))
						]))
				]));
	});
var $author$project$I18n$Cles$produitsValeursOrdreExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.ordre.explication', _List_Nil, 'Faites glisser une valeur par sa poignée, ou utilisez les flèches. Cet ordre est celui des listes de choix, du catalogue et des portails.');
};
var $author$project$I18n$Cles$produitsValeursOrdreSeulLOrdre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.ordre.seul-l-ordre', _List_Nil, 'Seul l\'ordre change : aucune valeur n\'est renommée, ajoutée ou retirée.');
};
var $author$project$I18n$Cles$produitsValeursOrdreTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.ordre.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md))
				]),
			'Ordonner les ' + $elm$core$String$toLower(p.md));
	});
var $author$project$I18n$Cles$produitsValeursRangementEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.rangement.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$pluriel = function (nom) {
	return A2(
		$elm$core$List$any,
		function (fin) {
			return A2($elm$core$String$endsWith, fin, nom);
		},
		_List_fromArray(
			['s', 'x', 'z'])) ? nom : (nom + 's');
};
var $author$project$I18n$Cles$produitsValeursDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etages',
					$author$project$I18n$Traductions$Chaine(p.yG)),
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			p.yG + (' de « ' + (p.fm + ' »')));
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$titreDe = F2(
	function (i18n, titre) {
		var etages = $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$pluriel(
			A2($author$project$I18n$Cles$texte, i18n, titre.md));
		return A2(
			$elm$core$Maybe$withDefault,
			etages,
			A2(
				$elm$core$Maybe$map,
				function (valeur) {
					return A2(
						$author$project$I18n$Cles$produitsValeursDe,
						i18n,
						{yG: etages, fm: valeur});
				},
				titre.IV));
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$drawerDOrdre = F2(
	function (i18n, model) {
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Produits$StructureCatalogue$Update$DuDrawerDOrdre,
			function () {
				var _v0 = _Utils_Tuple2(
					$author$project$Components$Shared$Drawer$Model$estOuvert(model.k3),
					model.El);
				if (_v0.a && (!_v0.b.$)) {
					var ordre = _v0.b.a;
					return {
						fs: {
							sR: !$author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model),
							Bl: $author$project$I18n$Cles$produitsValeursRangementEnregistrer(i18n),
							C$: $author$project$Components$Produits$StructureCatalogue$Update$OrdreDemande
						},
						fZ: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('explication')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsValeursOrdreExplication(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$ul,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('ordre-des-valeurs'),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
										'aria-label',
										A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$titreDe, i18n, ordre.md))
									]),
								A2(
									$elm$core$List$indexedMap,
									A2(
										$author$project$Components$Produits$StructureCatalogue$Valeurs$View$ligneDOrdre,
										i18n,
										$elm$core$List$length(ordre.gV)),
									ordre.gV)),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsValeursOrdreSeulLOrdre(i18n))
									])),
								A2(
								$author$project$Components$Shared$Messages$View$view,
								i18n,
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2($elm$core$Maybe$map, $elm$core$List$singleton, model.p1)))
							]),
						A6: $elm$core$Maybe$Nothing,
						Bc: false,
						h6: A2(
							$author$project$I18n$Cles$produitsValeursOrdreTitre,
							i18n,
							{
								md: A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$titreDe, i18n, ordre.md)
							})
					};
				} else {
					return {
						fs: {sR: false, Bl: '', C$: $author$project$Components$Produits$StructureCatalogue$Update$OrdreDemande},
						fZ: _List_Nil,
						A6: $elm$core$Maybe$Nothing,
						Bc: false,
						h6: ''
					};
				}
			}(),
			model.k3);
	});
var $author$project$Components$Produits$StructureCatalogue$Update$RangementDemande = {$: 163};
var $author$project$Components$Produits$StructureCatalogue$Update$LicenceCochee = function (a) {
	return {$: 162, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$FamilleArchivee = F2(
	function (a, b) {
		return {$: 172, a: a, b: b};
	});
var $author$project$I18n$Cles$produitsValeursDrawerArchiver = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.drawer.archiver', _List_Nil, 'Archiver');
};
var $author$project$I18n$Cles$produitsValeursDrawerArchiverDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.drawer.archiver.de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Archiver « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$produitsValeursFamilleArchiverPhrase = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.famille.archiver.phrase', _List_Nil, 'Une famille archivée n\'est plus proposée à la saisie. Ses catégories et ses références restent rangées et lisibles ; rien n\'est supprimé.');
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$archivage = F4(
	function (i18n, inactif, typologie, valeur) {
		return _Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$archiverUneValeur, valeur.nQ),
			$elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('archivage')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsValeursDrawerArchiver(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsValeursFamilleArchiverPhrase(i18n))
						])),
					A3(
					$author$project$Components$Shared$Bouton$View$bouton,
					3,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('archiver'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							A2($author$project$Components$Produits$StructureCatalogue$Update$FamilleArchivee, typologie.Aq, valeur.Aq)),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif)
						]),
					A2(
						$author$project$I18n$Cles$produitsValeursDrawerArchiverDe,
						i18n,
						{
							Dj: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nomDeLaValeur(valeur)
						}))
				]));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$AjoutDansLaColonne = function (a) {
	return {$: 170, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$ajoutable = F2(
	function (model, lue) {
		var place = !_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$placerUnNoeud, lue.md.nQ),
			$elm$core$Maybe$Nothing);
		var _v0 = lue.md.xt;
		if (_v0.$ === 1) {
			return !_Utils_eq(
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ajouterUneValeurALEtage, lue.md.nQ),
				$elm$core$Maybe$Nothing);
		} else {
			var code = _v0.a;
			return lue.md.wL ? ((!_Utils_eq(
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ajouterUneCategorie, lue.md.nQ),
				$elm$core$Maybe$Nothing)) && (!_Utils_eq(
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.nQ;
						},
						$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$creerUnType)),
					model.dt.aS),
				$elm$core$Maybe$Nothing))) : (_Utils_eq(code, $author$project$Catalogue$Vocabulaire$codeGamme) ? (!_Utils_eq(
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUneGamme, lue.md.nQ),
				$elm$core$Maybe$Nothing)) : (_Utils_eq(code, $author$project$Catalogue$Vocabulaire$codeProduit) ? (!_Utils_eq(
				$author$project$Components$Produits$StructureCatalogue$Valeurs$Model$noeudDuProduit(lue),
				$elm$core$Maybe$Nothing)) : (place && (_Utils_eq(code, $author$project$Catalogue$Vocabulaire$codeMarque) && (!_Utils_eq(
				$author$project$Components$Produits$StructureCatalogue$Marques$Model$creation(model.cU),
				$elm$core$Maybe$Nothing))))));
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$ajoutSous = F5(
	function (i18n, model, rangement, dessous, inactif) {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Valeurs$View$ajoutable,
			model,
			{
				ve: $elm$core$Maybe$Nothing,
				md: rangement.md,
				gV: _List_Nil,
				Dj: $author$project$I18n$Traductions$tel(dessous),
				bY: rangement.bY + 1,
				IV: $elm$core$Maybe$Just(rangement.ea),
				h6: {
					md: $author$project$I18n$Traductions$tel(dessous),
					IV: $elm$core$Maybe$Nothing
				}
			}) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ajout')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('proposition'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Produits$StructureCatalogue$Update$AjoutDansLaColonne(rangement.bY + 1)),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$produitsValeursAjouter,
										i18n,
										{md: dessous}))
								]))
						]))
				])) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$Components$Produits$StructureCatalogue$Update$CaseDeGammeCochee = function (a) {
	return {$: 171, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$caseDeGamme = F5(
	function (i18n, prefixe, volet, inactif, gamme) {
		var geste = gamme.tx ? $author$project$API$NavLinksDictionary$retirerUneGammeDUneMarque : $author$project$API$NavLinksDictionary$rattacherUneGammeAUneMarque;
		var cochee = !_Utils_eq(
			gamme.tx,
			A2($elm$core$List$member, gamme.Aq, volet.CP));
		var chez = A2(
			$elm$core$String$join,
			$author$project$I18n$Cles$produitsCatalogueGammesSeparateurDeMarques(i18n),
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.R;
					},
					function ($) {
						return $.zX;
					}),
				gamme.cU));
		var ancre = prefixe + ('-gamme-' + $author$project$Catalogue$Identifiants$elementIdToString(gamme.Aq));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('choix'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('cochee', cochee)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(ancre),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(cochee),
							$rtfeldman$elm_css$Html$Styled$Events$onCheck(
							function (_v0) {
								return $author$project$Components$Produits$StructureCatalogue$Update$CaseDeGammeCochee(gamme.Aq);
							}),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
							inactif || _Utils_eq(
								A2($author$project$API$Liens$trouver, geste, gamme.nQ),
								$elm$core$Maybe$Nothing))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$for(ancre)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(gamme.R.zX)
								])),
						gamme.rO ? _List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Tag$View$view,
								5,
								$author$project$I18n$Cles$produitsCatalogueAppartenanceToutes(i18n))
							]) : _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										_Utils_ap(
											$author$project$I18n$Cles$produitsCatalogueGammesSeparateur(i18n),
											chez))
									]))
							])))
				]));
	});
var $author$project$I18n$Cles$produitsValeursGammesExplication = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.gammes.explication',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'marque',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.gX)))
				]),
			'Une gamme appartient à ses marques dans tout le catalogue. Décochez une gamme pour la retirer ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.gX);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.gX);
					default:
						return 'de ' + $elm$core$String$trim(p.gX);
				}
			}() + ' : elle reste chez ses autres marques.'));
	});
var $author$project$I18n$Cles$produitsValeursGammesNote = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.gammes.note',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'marque',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.gX))),
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av)))
				]),
			'Cocher une gamme d\'une autre marque l\'étend à ' + (p.gX + ('. Une gamme « toutes les marques » s\'étend aussi aux marques créées plus tard ; la décocher ici la retire ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.gX);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.gX);
					default:
						return 'de ' + $elm$core$String$trim(p.gX);
				}
			}() + ' seulement. Les mêmes gestes se font depuis la fiche de la marque.'))));
	});
var $author$project$I18n$Cles$produitsValeursGammesQuestion = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.gammes.question',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'marque',
					$author$project$I18n$Traductions$Chaine(p.gX))
				]),
			'Quelles gammes a ' + (p.gX + ' ?'));
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$gammesDeLaMarque = F6(
	function (i18n, model, rangement, volet, dessous, inactif) {
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.le);
		var marque = rangement.ea.Dj;
		var gammes = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$andThen,
				function (connues) {
					return _Utils_eq(connues.wD, volet.gX.Aq) ? $elm$core$Maybe$Just(connues.gG) : $elm$core$Maybe$Nothing;
				},
				model.gG.fY));
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('question')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h3,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$produitsValeursGammesQuestion,
									i18n,
									{gX: marque}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('explication')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$produitsValeursGammesExplication,
									i18n,
									{
										av: $author$project$Texte$Elision$elision(marque),
										gX: marque
									}))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$fieldset,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('dessous')
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$legend,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Components$Produits$StructureCatalogue$Valeurs$Model$pluriel(dessous))
							])),
					A2(
						$elm$core$List$map,
						A4($author$project$Components$Produits$StructureCatalogue$Valeurs$View$caseDeGamme, i18n, prefixe, volet, inactif),
						gammes))),
				A5($author$project$Components$Produits$StructureCatalogue$Valeurs$View$ajoutSous, i18n, model, rangement, dessous, inactif),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$produitsValeursGammesNote,
							i18n,
							{
								av: $author$project$Texte$Elision$elision(marque),
								gX: marque
							}))
					]))
			]);
	});
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDuBoutonRenommer = $author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDuBouton('renommer');
var $author$project$I18n$Cles$produitsValeursDrawerAnglais = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.drawer.anglais',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Anglais : ' + p.Dj);
	});
var $author$project$I18n$Cles$produitsValeursDrawerNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.drawer.nom', _List_Nil, 'Nom');
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$nomDeLaValeur = F4(
	function (i18n, inactif, typologie, valeur) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsValeursDrawerNom(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('libelles')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Components$Produits$StructureCatalogue$Classifications$Model$nomDeLaValeur(valeur))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('anglais')
										]),
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											function (en) {
												return _List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2(
															$author$project$I18n$Cles$produitsValeursDrawerAnglais,
															i18n,
															{Dj: en}))
													]);
											},
											valeur.R.yg)))
								])),
							_Utils_eq(
							A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$traduireUneValeur, valeur.nQ),
							$elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('renommer'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id(
									$author$project$Components$Produits$StructureCatalogue$Classifications$Model$idDuBoutonRenommer(valeur.Aq)),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Produits$StructureCatalogue$Update$DesClassifications(
										A2($author$project$Components$Produits$StructureCatalogue$Classifications$Update$RenommageOuvert, typologie.Aq, valeur.Aq))),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsClassificationsValeurRenommer(i18n))
								]))
						]))
				]));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$ValeurCochee = F2(
	function (a, b) {
		return {$: 161, a: a, b: b};
	});
var $author$project$I18n$Cles$produitsValeursCompteAucune = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.compte.aucune', _List_Nil, 'aucune');
};
var $author$project$I18n$Cles$produitsValeursCompteDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.compte.de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w)),
					_Utils_Tuple2(
					'un',
					$author$project$I18n$Traductions$Chaine(p.J5)),
					_Utils_Tuple2(
					'plusieurs',
					$author$project$I18n$Traductions$Chaine(p.FS))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' ' + $elm$core$String$toLower(p.J5))) : (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' ' + $elm$core$String$toLower(p.FS))));
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$compteDe = F2(
	function (i18n, compte) {
		var etage = A2($author$project$I18n$Cles$texte, i18n, compte.md);
		return (!compte.w) ? $author$project$I18n$Cles$produitsValeursCompteAucune(i18n) : A2(
			$author$project$I18n$Cles$produitsValeursCompteDe,
			i18n,
			{
				w: compte.w,
				FS: $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$pluriel(etage),
				J5: etage
			});
	});
var $author$project$I18n$Cles$produitsValeursRangementCompte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.rangement.compte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'compte',
					$author$project$I18n$Traductions$Chaine(p.vW))
				]),
			' · ' + p.vW);
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$dansLaCase = F2(
	function (i18n, compte) {
		return A2(
			$author$project$I18n$Cles$produitsValeursRangementCompte,
			i18n,
			{vW: compte});
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$indexDe = function (valeur) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$indexedMap($elm$core$Tuple$pair),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$filter(
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$second,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.fm;
						},
						$elm$core$Basics$eq(valeur)))),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$head,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$map($elm$core$Tuple$first),
					$elm$core$Maybe$withDefault(0)))));
};
var $author$project$I18n$Cles$produitsValeursRangementNote = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.rangement.note',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md)),
					_Utils_Tuple2(
					'dessus',
					$author$project$I18n$Traductions$Chaine(p.kL))
				]),
			'Une même ' + ($elm$core$String$toLower(p.md) + (' peut se trouver sous plusieurs ' + ($elm$core$String$toLower(p.kL) + ('. Ce que l\'on range sous chaque ' + ($elm$core$String$toLower(p.md) + ' se règle en la choisissant dans sa colonne.'))))));
	});
var $author$project$I18n$Cles$produitsValeursRangementNoteCategories = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.rangement.note.categories',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md)),
					_Utils_Tuple2(
					'dessus',
					$author$project$I18n$Traductions$Chaine(p.kL))
				]),
			'Une même ' + ($elm$core$String$toLower(p.md) + (' peut se trouver sous plusieurs ' + ($elm$core$String$toLower(p.kL) + '.'))));
	});
var $author$project$I18n$Cles$produitsValeursRangementPhrase = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.rangement.phrase',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etages',
					$author$project$I18n$Traductions$Chaine(p.yG)),
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm)),
					_Utils_Tuple2(
					'suivants',
					$author$project$I18n$Traductions$Chaine(p.I8)),
					_Utils_Tuple2(
					'typologie',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.r3)))
				]),
			'Cochez les ' + ($elm$core$String$toLower(p.yG) + (' ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.r3);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.r3);
					default:
						return 'de ' + $elm$core$String$trim(p.r3);
				}
			}() + (' que l\'on trouve sous ' + (p.fm + ('. À la saisie d\'une référence ' + (p.fm + (', seules celles-ci et leurs ' + ($elm$core$String$toLower(p.I8) + ' seront proposées.'))))))))));
	});
var $author$project$I18n$Cles$produitsValeursRangementPhraseCategories = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.rangement.phrase.categories',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etages',
					$author$project$I18n$Traductions$Chaine(p.yG)),
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm)),
					_Utils_Tuple2(
					'typologie',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.r3)))
				]),
			'Cochez les ' + ($elm$core$String$toLower(p.yG) + (' ' + (function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.r3);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.r3);
					default:
						return 'de ' + $elm$core$String$trim(p.r3);
				}
			}() + (' que l\'on trouve sous ' + (p.fm + ('. À la saisie d\'une référence ' + (p.fm + ', seules celles-ci seront proposées.'))))))));
	});
var $author$project$I18n$Cles$produitsValeursRangementQuestion = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.rangement.question',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			'Que range-t-on sous « ' + (p.fm + ' » ?'));
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$readmissibles = F3(
	function (noms, typologie, rangement) {
		return A2(
			$elm$core$List$filterMap,
			function (exclusion) {
				return A2(
					$elm$core$Maybe$map,
					function (nom) {
						return {Dj: nom, ey: exclusion.ey, F$: exclusion.F$, fm: exclusion.fm};
					},
					A3($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$nomDe, noms, typologie, exclusion.fm));
			},
			A2(
				$elm$core$List$filter,
				function (exclusion) {
					return _Utils_eq(exclusion.md, rangement.md.Aq) && (A2(
						$elm$core$List$any,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(exclusion.ey)),
						rangement.ea.Di) && (!_Utils_eq(
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$readmettreUneValeur, exclusion.nQ),
						$elm$core$Maybe$Nothing)));
				},
				typologie.yX));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$ValeurReadmise = F2(
	function (a, b) {
		return {$: 169, a: a, b: b};
	});
var $author$project$I18n$Cles$produitsValeursReadmettre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.readmettre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'valeur',
					$author$project$I18n$Traductions$Chaine(p.fm))
				]),
			'Ajouter : ' + p.fm);
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$readmissions = F3(
	function (i18n, inactif, retirees) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('readmissions')
				]),
			A2(
				$elm$core$List$map,
				function (retiree) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('proposition'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								A2($author$project$Components$Produits$StructureCatalogue$Update$ValeurReadmise, retiree.F$, retiree.ey)),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$produitsValeursReadmettre,
											i18n,
											{fm: retiree.Dj}))
									]))
							]));
				},
				retirees));
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$pourLesNoeuds = F5(
	function (i18n, model, typologie, rangement, _v0) {
		var x = _v0.sB;
		var dessous = _v0.kK;
		var apres = _v0.iY;
		var dessus = _v0.kL;
		var prefixe = _v0.pv;
		var inactif = _v0.d3;
		var readmissibles = A3(
			$author$project$Components$Produits$StructureCatalogue$Valeurs$Rangement$readmissibles,
			$author$project$Components$Produits$StructureCatalogue$Valeurs$Lecture$noms(model),
			typologie,
			rangement);
		var retirees = A2(
			$elm$core$List$filter,
			function (valeur) {
				return !A2($elm$core$List$member, valeur, rangement.AP);
			},
			A2(
				$elm$core$List$map,
				function ($) {
					return $.fm;
				},
				readmissibles));
		var phrase = (rangement.md.wL || (apres === '')) ? A2(
			$author$project$I18n$Cles$produitsValeursRangementPhraseCategories,
			i18n,
			{
				av: $author$project$Texte$Elision$elision(
					$author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(typologie)),
				yG: $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$pluriel(dessous),
				r3: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(typologie),
				fm: x
			}) : A2(
			$author$project$I18n$Cles$produitsValeursRangementPhrase,
			i18n,
			{
				av: $author$project$Texte$Elision$elision(
					$author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(typologie)),
				yG: $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$pluriel(dessous),
				I8: $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$pluriel(apres),
				r3: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(typologie),
				fm: x
			});
		var notice = (rangement.md.wL ? $author$project$I18n$Cles$produitsValeursRangementNoteCategories(i18n) : $author$project$I18n$Cles$produitsValeursRangementNote(i18n))(
			{
				kL: $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$pluriel(dessus),
				md: dessous
			});
		var caseDeLaValeur = function (option) {
			var ancre = prefixe + ('-' + $elm$core$String$fromInt(
				A2($author$project$Components$Produits$StructureCatalogue$Valeurs$View$indexDe, option.fm, rangement.o_)));
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('choix')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$input,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
								$rtfeldman$elm_css$Html$Styled$Attributes$id(ancre),
								$rtfeldman$elm_css$Html$Styled$Attributes$checked(
								A2($elm$core$List$member, option.fm, rangement.vv)),
								$rtfeldman$elm_css$Html$Styled$Events$onCheck(
								$author$project$Components$Produits$StructureCatalogue$Update$ValeurCochee(option.fm))
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for(ancre)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(option.Dj)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
									]),
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function (compte) {
											return _List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$author$project$Components$Produits$StructureCatalogue$Valeurs$View$dansLaCase,
														i18n,
														A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$compteDe, i18n, compte)))
												]);
										},
										option.vW)))
							]))
					]));
		};
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('question')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h3,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$produitsValeursRangementQuestion,
									i18n,
									{fm: x}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('explication')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(phrase)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$fieldset,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('dessous')
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$legend,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Components$Produits$StructureCatalogue$Valeurs$Model$pluriel(dessous))
							])),
					A2(
						$elm$core$List$map,
						caseDeLaValeur,
						A2(
							$elm$core$List$filter,
							function (option) {
								return !A2($elm$core$List$member, option.fm, retirees);
							},
							rangement.o_)))),
				A3($author$project$Components$Produits$StructureCatalogue$Valeurs$View$readmissions, i18n, inactif, readmissibles),
				A5($author$project$Components$Produits$StructureCatalogue$Valeurs$View$ajoutSous, i18n, model, rangement, dessous, inactif),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(notice)
					]))
			]);
	});
var $author$project$I18n$Cles$produitsCatalogueMarqueSousLicence = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.catalogue.marque.sous-licence', _List_Nil, 'Marque sous licence');
};
var $author$project$I18n$Cles$produitsValeursRangementFiche = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.rangement.fiche',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elision',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeElision(p.av))),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(
						$elm$core$String$trim(p.Dj)))
				]),
			'Voir la fiche ' + function () {
				var _v0 = p.av;
				switch (_v0) {
					case 0:
						return 'de ' + $elm$core$String$trim(p.Dj);
					case 1:
						return 'd\'' + $elm$core$String$trim(p.Dj);
					default:
						return 'de ' + $elm$core$String$trim(p.Dj);
				}
			}());
	});
var $author$project$I18n$Cles$produitsValeursSurtitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.surtitre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md)),
					_Utils_Tuple2(
					'typologie',
					$author$project$I18n$Traductions$Chaine(p.r3))
				]),
			p.md + (' · ' + p.r3));
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$contenuDuRangement = F5(
	function (i18n, model, structure, typologie, rangement) {
		var x = rangement.ea.Dj;
		var valeurLibre = function () {
			var _v5 = rangement.ea.fm;
			if (!_v5.$) {
				var id = _v5.a;
				return A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$valeurDe, id, typologie);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var prefixe = $author$project$Components$Shared$Drawer$Model$idRacine(model.le);
		var inactif = $author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model) || $author$project$Components$Produits$Common$Envoi$enCours(model.cU.l2);
		var etages = A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$Produits$StructureCatalogue$Etages$Model$nom(structure.C9),
				$author$project$I18n$Cles$texte(i18n)),
			typologie.yG);
		var nomA = function (rang) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				$elm$core$List$head(
					A2($elm$core$List$drop, rang, etages)));
		};
		var dessus = nomA(rangement.bY);
		var dessous = A2(
			$author$project$I18n$Cles$texte,
			i18n,
			A2($author$project$Components$Produits$StructureCatalogue$Etages$Model$nom, structure.C9, rangement.md));
		var apres = nomA(rangement.bY + 2);
		return {
			fs: {
				sR: !inactif,
				Bl: $author$project$I18n$Cles$produitsValeursRangementEnregistrer(i18n),
				C$: $author$project$Components$Produits$StructureCatalogue$Update$RangementDemande
			},
			fZ: $elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						if (!valeurLibre.$) {
							var valeur = valeurLibre.a;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('surtitre')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$produitsValeursSurtitre,
												i18n,
												{
													md: nomA(rangement.bY),
													r3: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(typologie)
												}))
										]))
								]);
						} else {
							return _List_Nil;
						}
					}(),
						_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Messages$View$view,
							i18n,
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2($elm$core$Maybe$map, $elm$core$List$singleton, model.p9)))
						]),
						function () {
						var _v1 = rangement.gX;
						if (!_v1.$) {
							var marque = _v1.a;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('nature')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('licence')
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$input,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
															$rtfeldman$elm_css$Html$Styled$Attributes$id(prefixe + '-licence'),
															$rtfeldman$elm_css$Html$Styled$Attributes$checked(rangement.IY),
															$rtfeldman$elm_css$Html$Styled$Events$onCheck($author$project$Components$Produits$StructureCatalogue$Update$LicenceCochee),
															$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
															_Utils_eq(
																A2($author$project$Components$Produits$StructureCatalogue$Marques$Model$commandeDeNature, marque, true),
																$elm$core$Maybe$Nothing))
														]),
													_List_Nil),
													A2(
													$rtfeldman$elm_css$Html$Styled$label,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$for(prefixe + '-licence')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$I18n$Cles$produitsCatalogueMarqueSousLicence(i18n))
														]))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('fiche'),
													$rtfeldman$elm_css$Html$Styled$Attributes$href(
													$author$project$Routes$Route$toString(
														$author$project$Routes$Route$FicheElement(marque.Aq)))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$author$project$I18n$Cles$produitsValeursRangementFiche,
														i18n,
														{
															av: $author$project$Texte$Elision$elision(x),
															Dj: x
														}))
												]))
										]))
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						if (!valeurLibre.$) {
							var valeur = valeurLibre.a;
							return _List_fromArray(
								[
									A4($author$project$Components$Produits$StructureCatalogue$Valeurs$View$nomDeLaValeur, i18n, inactif, typologie, valeur)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v3 = rangement.gG;
						if (!_v3.$) {
							var volet = _v3.a;
							return A6($author$project$Components$Produits$StructureCatalogue$Valeurs$View$gammesDeLaMarque, i18n, model, rangement, volet, dessous, inactif);
						} else {
							return A5(
								$author$project$Components$Produits$StructureCatalogue$Valeurs$View$pourLesNoeuds,
								i18n,
								model,
								typologie,
								rangement,
								{iY: apres, kK: dessous, kL: dessus, d3: inactif, pv: prefixe, sB: x});
						}
					}(),
						function () {
						if (!valeurLibre.$) {
							var valeur = valeurLibre.a;
							return _List_fromArray(
								[
									A4($author$project$Components$Produits$StructureCatalogue$Valeurs$View$archivage, i18n, inactif, typologie, valeur)
								]);
						} else {
							return _List_Nil;
						}
					}()
					])),
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: x
		};
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$drawerDeRangement = F2(
	function (i18n, model) {
		var recouvert = $author$project$Components$Shared$Drawer$Model$estOuvert(model.vk.kX);
		var ouvert = A4(
			$elm$core$Maybe$map3,
			F3(
				function (structure, typologie, rangement) {
					return _Utils_Tuple3(structure, typologie, rangement);
				}),
			model.h$,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.vk;
					},
					$author$project$Components$Produits$StructureCatalogue$Typologies$Model$reglee(model.r6)),
				model.h$),
			model.hA);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			recouvert ? _List_fromArray(
				[
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'inert', '')
				]) : _List_Nil,
			_List_fromArray(
				[
					A4(
					$author$project$Components$Shared$Drawer$View$view,
					i18n,
					$author$project$Components$Produits$StructureCatalogue$Update$DuDrawerDeRangement,
					function () {
						var _v0 = _Utils_Tuple2(
							$author$project$Components$Shared$Drawer$Model$estOuvert(model.le),
							ouvert);
						if (_v0.a && (!_v0.b.$)) {
							var _v1 = _v0.b.a;
							var structure = _v1.a;
							var typologie = _v1.b;
							var rangement = _v1.c;
							return A5($author$project$Components$Produits$StructureCatalogue$Valeurs$View$contenuDuRangement, i18n, model, structure, typologie, rangement);
						} else {
							return {
								fs: {sR: false, Bl: '', C$: $author$project$Components$Produits$StructureCatalogue$Update$RangementDemande},
								fZ: _List_Nil,
								A6: $elm$core$Maybe$Nothing,
								Bc: false,
								h6: ''
							};
						}
					}(),
					model.le)
				]));
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$ArchivageDemande = {$: 16};
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$NomSaisi = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$RenommageDemande = {$: 20};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$noeudsARetirer = F3(
	function (typologie, categorie, valeurs) {
		return A2(
			$elm$core$List$filter,
			function (noeud) {
				return _Utils_eq(
					noeud.fm,
					$author$project$Catalogue$API$QueryAPIModel$ValeurCategorie(categorie)) && ((!noeud.iz) && ((!_Utils_eq(
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerUnNoeud, noeud.nQ),
					$elm$core$Maybe$Nothing)) && A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (dessus) {
							return A2($elm$core$List$member, dessus, valeurs);
						},
						A2(
							$elm$core$Maybe$andThen,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.fm;
								},
								$author$project$Components$Produits$StructureCatalogue$Valeurs$Model$valeurDuDessus),
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (parent) {
										return _Utils_eq(
											$elm$core$Maybe$Just(parent.Aq),
											noeud.ey);
									},
									typologie.Di)))))));
			},
			typologie.Di);
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$cheminsDeLaCategorie = F3(
	function (noms, typologie, categorie) {
		var nom = function (noeud) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					$elm$core$List$singleton,
					A3($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$nomDe, noms, typologie, noeud.fm)));
		};
		var dessus = A2(
			$elm$core$List$filterMap,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.fm;
				},
				$author$project$Components$Produits$StructureCatalogue$Valeurs$Model$valeurDuDessus),
			typologie.Di);
		var ancetres = function (noeud) {
			var _v0 = A2(
				$elm$core$Maybe$andThen,
				function (id) {
					return $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Aq;
								},
								$elm$core$Basics$eq(id)),
							typologie.Di));
				},
				noeud.ey);
			if (!_v0.$) {
				var parent = _v0.a;
				return _Utils_ap(
					ancetres(parent),
					nom(parent));
			} else {
				return _List_Nil;
			}
		};
		return A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				ancetres,
				$elm$core$String$join(' › ')),
			A3($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$noeudsARetirer, typologie, categorie, dessus));
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$DessusBascule = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$PlacesDemandees = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$RenommageOuvert = {$: 17};
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$RetraitOuvert = {$: 21};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$dejaRangeeSous = F2(
	function (typologie, categorie) {
		return A2(
			$elm$core$List$filterMap,
			function (noeud) {
				return A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.fm;
						},
						$author$project$Components$Produits$StructureCatalogue$Valeurs$Model$valeurDuDessus),
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (parent) {
								return _Utils_eq(
									$elm$core$Maybe$Just(parent.Aq),
									noeud.ey);
							},
							typologie.Di)));
			},
			A2(
				$elm$core$List$filter,
				function (noeud) {
					return _Utils_eq(
						noeud.fm,
						$author$project$Catalogue$API$QueryAPIModel$ValeurCategorie(categorie)) && (!noeud.iz);
				},
				typologie.Di));
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$etageDuDessusDesCategories = function (typologie) {
	return A2(
		$elm$core$Maybe$andThen,
		function (_v0) {
			var rang = _v0.a;
			return (!rang) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
				A2($elm$core$List$drop, rang - 1, typologie.yG));
		},
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$second,
					function ($) {
						return $.wL;
					}),
				A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, typologie.yG))));
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$familles = function (typologie) {
	var profondeur = function (valeur) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (mere) {
				return A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$valeurDe, mere, typologie);
			},
			valeur.ey);
		if (!_v0.$) {
			var mere = _v0.a;
			return 1 + profondeur(mere);
		} else {
			return 1;
		}
	};
	var libres = $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			function (etage) {
				var _v1 = etage.xt;
				if (_v1.$ === 1) {
					return true;
				} else {
					return false;
				}
			},
			typologie.yG));
	return A2(
		$elm$core$List$filter,
		function (valeur) {
			return (!valeur.tI) && ((libres > 0) && _Utils_eq(
				profondeur(valeur),
				libres));
		},
		typologie.Ki);
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$dessusDesCategories = F2(
	function (noms, typologie) {
		var _v0 = $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$etageDuDessusDesCategories(typologie);
		if (_v0.$ === 1) {
			return _List_Nil;
		} else {
			var etage = _v0.a;
			var _v1 = etage.xt;
			if (_v1.$ === 1) {
				return A2(
					$elm$core$List$map,
					function (valeur) {
						return {
							Dj: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nomDeLaValeur(valeur),
							fm: $author$project$Catalogue$API$WriteAPIModel$LibreDuDessus(valeur.Aq)
						};
					},
					$author$project$Components$Produits$StructureCatalogue$Valeurs$Model$familles(typologie));
			} else {
				var parentDe = function (ligne) {
					return A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.fm;
						},
						A2(
							$elm$core$Maybe$andThen,
							function (id) {
								return $elm$core$List$head(
									A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.Aq;
											},
											$elm$core$Basics$eq(id)),
										typologie.Di));
							},
							A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.ey;
								},
								$elm$core$List$head(ligne.Di))));
				};
				var lignes = A2(
					$author$project$Components$Produits$StructureCatalogue$Valeurs$Model$lignesDe,
					A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$nomDe, noms, typologie),
					A2(
						$elm$core$List$filter,
						function (noeud) {
							return _Utils_eq(noeud.md, etage.Aq) && (!noeud.iz);
						},
						typologie.Di));
				var parentsDistincts = A3(
					$elm$core$List$foldl,
					F2(
						function (ligne, vus) {
							return A2(
								$elm$core$List$member,
								parentDe(ligne),
								vus) ? vus : A2(
								$elm$core$List$cons,
								parentDe(ligne),
								vus);
						}),
					_List_Nil,
					lignes);
				var plusieursParents = $elm$core$List$length(parentsDistincts) > 1;
				var nomComplet = function (ligne) {
					var _v2 = A2(
						$elm$core$Maybe$andThen,
						A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$nomDe, noms, typologie),
						parentDe(ligne));
					if (!_v2.$) {
						var parent = _v2.a;
						return plusieursParents ? (parent + (' › ' + ligne.Dj)) : ligne.Dj;
					} else {
						return ligne.Dj;
					}
				};
				return A2(
					$elm$core$List$filterMap,
					function (ligne) {
						return A2(
							$elm$core$Maybe$map,
							function (valeur) {
								return {
									Dj: nomComplet(ligne),
									fm: valeur
								};
							},
							$author$project$Components$Produits$StructureCatalogue$Valeurs$Model$valeurDuDessus(ligne.fm));
					},
					lignes);
			}
		}
	});
var $author$project$I18n$Cles$produitsValeursCategorieArchiverPhrase = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.categorie.archiver.phrase', _List_Nil, 'Une catégorie archivée n\'est plus proposée à la création d\'une référence. Ses références restent lisibles ; rien n\'est supprimé.');
};
var $author$project$I18n$Cles$produitsValeursCategorieDessusQuestion = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.categorie.dessus.question',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Sous quelles valeurs de « ' + (p.md + (' » ranger « ' + (p.Dj + ' » ?'))));
	});
var $author$project$I18n$Cles$produitsValeursCategoriePasRangee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.categorie.pas-rangee', _List_Nil, 'Pas encore rangée.');
};
var $author$project$I18n$Cles$produitsValeursCategorieRanger = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.categorie.ranger', _List_Nil, 'Ranger');
};
var $author$project$I18n$Cles$produitsValeursCategorieRangerSous = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.categorie.ranger.sous',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Ranger sous « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$produitsValeursCategorieRangerSousPlusieurs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.categorie.ranger.sous-plusieurs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'compte',
					$author$project$I18n$Traductions$Chaine(p.vW))
				]),
			'Ranger sous ' + (p.vW + ' valeurs'));
	});
var $author$project$I18n$Cles$produitsValeursCategorieRetirerDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.categorie.retirer-de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'noms',
					$author$project$I18n$Traductions$Chaine(p.DG))
				]),
			'Retirer de « ' + (p.DG + ' »'));
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$contenuDeLaCategorie = F6(
	function (i18n, model, structure, typologie, ouverte, renommageOuvert) {
		var lue = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Aq;
					},
					$elm$core$Basics$eq(ouverte.Aq)),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.ib;
						},
						model.dt.aS))));
		var lienDesRangements = _Utils_eq(
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.tE;
				},
				ouverte.zo),
			$elm$core$Maybe$Just(false)) ? A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nQ;
				},
				$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$ajouterUneCategorie)),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function ($) {
						return $.wL;
					},
					typologie.yG))) : $elm$core$Maybe$Nothing;
		var lien = function (rel) {
			return A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nQ;
					},
					$author$project$API$Liens$trouver(rel)),
				ouverte.zo);
		};
		var inactif = $author$project$Components$Produits$Common$Envoi$enCours(model.dt.l2) || ($author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model) || (!_Utils_eq(ouverte.zF, _List_Nil)));
		var etageDuDessus = A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$Produits$StructureCatalogue$Etages$Model$nom(structure.C9),
				$author$project$I18n$Cles$texte(i18n)),
			$author$project$Components$Produits$StructureCatalogue$Valeurs$Model$etageDuDessusDesCategories(typologie));
		var etageDesCategories = A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$Produits$StructureCatalogue$Etages$Model$nom(structure.C9),
				$author$project$I18n$Cles$texte(i18n)),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function ($) {
						return $.wL;
					},
					typologie.yG)));
		var dessus = A2(
			$author$project$Components$Produits$StructureCatalogue$Valeurs$Model$dessusDesCategories,
			$author$project$Components$Produits$StructureCatalogue$Valeurs$Lecture$noms(model),
			typologie);
		var deja = A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$dejaRangeeSous, typologie, ouverte.Aq);
		var categorie = function () {
			var _v3 = ouverte.zo;
			if (!_v3.$) {
				var fiche = _v3.a;
				return $elm$core$Maybe$Just(fiche);
			} else {
				return lue;
			}
		}();
		var nom = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Dj;
					},
					function ($) {
						return $.zX;
					}),
				categorie));
		var basculees = A2(
			$elm$core$List$filter,
			function (unDessus) {
				return A2($elm$core$List$member, unDessus.fm, ouverte.L);
			},
			dessus);
		var choisies = A2(
			$elm$core$List$filter,
			function (unDessus) {
				return !A2($elm$core$List$member, unDessus.fm, deja);
			},
			basculees);
		var decochees = A2(
			$elm$core$List$filter,
			function (unDessus) {
				return A2($elm$core$List$member, unDessus.fm, deja);
			},
			basculees);
		var aRetirer = A3(
			$author$project$Components$Produits$StructureCatalogue$Valeurs$Model$noeudsARetirer,
			typologie,
			ouverte.Aq,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.fm;
				},
				decochees));
		return {
			fs: {
				sR: (!inactif) && (((!_Utils_eq(lienDesRangements, $elm$core$Maybe$Nothing)) && (!_Utils_eq(choisies, _List_Nil))) || (!_Utils_eq(aRetirer, _List_Nil))),
				Bl: function () {
					if (!choisies.b) {
						return $elm$core$List$isEmpty(decochees) ? $author$project$I18n$Cles$produitsValeursCategorieRanger(i18n) : A2(
							$author$project$I18n$Cles$produitsValeursCategorieRetirerDe,
							i18n,
							{
								DG: A2(
									$elm$core$String$join,
									', ',
									A2(
										$elm$core$List$map,
										function ($) {
											return $.Dj;
										},
										decochees))
							});
					} else {
						if (!choisies.b.b) {
							var seul = choisies.a;
							return A2(
								$author$project$I18n$Cles$produitsValeursCategorieRangerSous,
								i18n,
								{Dj: seul.Dj});
						} else {
							var plusieurs = choisies;
							return A2(
								$author$project$I18n$Cles$produitsValeursCategorieRangerSousPlusieurs,
								i18n,
								{
									vW: $elm$core$String$fromInt(
										$elm$core$List$length(plusieurs))
								});
						}
					}
				}(),
				C$: (_Utils_eq(lienDesRangements, $elm$core$Maybe$Nothing) && _Utils_eq(aRetirer, _List_Nil)) ? $author$project$Components$Produits$StructureCatalogue$Update$DesCategories($author$project$Components$Produits$StructureCatalogue$Categories$Update$ArchivageDemande) : $author$project$Components$Produits$StructureCatalogue$Update$DesCategories(
					$author$project$Components$Produits$StructureCatalogue$Categories$Update$PlacesDemandees(
						{
							fx: A2(
								$elm$core$List$map,
								function ($) {
									return $.fm;
								},
								choisies),
							hA: lienDesRangements,
							eW: A2(
								$elm$core$Maybe$andThen,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.nQ;
									},
									$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$retirerUnNoeud)),
								$elm$core$List$head(aRetirer)),
							H2: A2(
								$elm$core$List$map,
								function ($) {
									return $.Aq;
								},
								aRetirer)
						}))
			},
			fZ: _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('surtitre')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$produitsValeursSurtitre,
								i18n,
								{
									md: A2($elm$core$Maybe$withDefault, '', etageDesCategories),
									r3: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(typologie)
								}))
						])),
					A2(
					$author$project$Components$Shared$Messages$View$view,
					i18n,
					renommageOuvert ? _List_Nil : A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Maybe$map, $elm$core$List$singleton, ouverte.pZ))),
					A2(
					$rtfeldman$elm_css$Html$Styled$section,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsValeursDrawerNom(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('libelles')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$strong,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(nom)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('anglais')
												]),
											A2(
												$elm$core$Maybe$withDefault,
												_List_Nil,
												A2(
													$elm$core$Maybe$map,
													function (en) {
														return _List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																A2(
																	$author$project$I18n$Cles$produitsValeursDrawerAnglais,
																	i18n,
																	{Dj: en}))
															]);
													},
													A2(
														$elm$core$Maybe$andThen,
														A2(
															$elm$core$Basics$composeR,
															function ($) {
																return $.Dj;
															},
															function ($) {
																return $.yg;
															}),
														categorie))))
										])),
									_Utils_eq(
									lien($author$project$API$NavLinksDictionary$renommerUnTypeDeProduit),
									$elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('renommer'),
											$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$StructureCatalogue$Categories$Model$idDuRenommer),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Components$Produits$StructureCatalogue$Update$DesCategories($author$project$Components$Produits$StructureCatalogue$Categories$Update$RenommageOuvert)),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsClassificationsValeurRenommer(i18n))
										]))
								]))
						])),
					function () {
					var _v1 = _Utils_Tuple2(etageDuDessus, lienDesRangements);
					if ((!_v1.a.$) && (!_v1.b.$)) {
						var etage = _v1.a.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$section,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('famille')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h3,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(etage)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											_Utils_ap(
												A2(
													$author$project$I18n$Cles$produitsValeursCategorieDessusQuestion,
													i18n,
													{md: etage, Dj: nom}),
												$elm$core$List$isEmpty(deja) ? (' ' + $author$project$I18n$Cles$produitsValeursCategoriePasRangee(i18n)) : ''))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$fieldset,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('dessus')
										]),
									A2(
										$elm$core$List$cons,
										A2(
											$rtfeldman$elm_css$Html$Styled$legend,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(etage)
												])),
										A2(
											$elm$core$List$indexedMap,
											F2(
												function (rang, unDessus) {
													var rangee = A2($elm$core$List$member, unDessus.fm, deja);
													var ancre = 'categorie-dessus-' + $elm$core$String$fromInt(rang);
													return A2(
														$rtfeldman$elm_css$Html$Styled$div,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('choix')
															]),
														_List_fromArray(
															[
																A2(
																$rtfeldman$elm_css$Html$Styled$input,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
																		$rtfeldman$elm_css$Html$Styled$Attributes$id(ancre),
																		$rtfeldman$elm_css$Html$Styled$Attributes$checked(
																		!_Utils_eq(
																			rangee,
																			A2($elm$core$List$member, unDessus.fm, ouverte.L))),
																		$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
																		inactif || (rangee && _Utils_eq(
																			A3(
																				$author$project$Components$Produits$StructureCatalogue$Valeurs$Model$noeudsARetirer,
																				typologie,
																				ouverte.Aq,
																				_List_fromArray(
																					[unDessus.fm])),
																			_List_Nil))),
																		$rtfeldman$elm_css$Html$Styled$Events$onCheck(
																		function (_v2) {
																			return $author$project$Components$Produits$StructureCatalogue$Update$DesCategories(
																				$author$project$Components$Produits$StructureCatalogue$Categories$Update$DessusBascule(unDessus.fm));
																		})
																	]),
																_List_Nil),
																A2(
																$rtfeldman$elm_css$Html$Styled$label,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$for(ancre)
																	]),
																_List_fromArray(
																	[
																		A2(
																		$rtfeldman$elm_css$Html$Styled$span,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(unDessus.Dj)
																			]))
																	]))
															]));
												}),
											dessus)))
								]));
					} else {
						return $rtfeldman$elm_css$Html$Styled$text('');
					}
				}(),
					_Utils_eq(
					lien($author$project$API$NavLinksDictionary$retirerUnTypeDUneTypologie),
					$elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
					$rtfeldman$elm_css$Html$Styled$section,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('retrait-de-la-typologie')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer-de-la-typologie'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$StructureCatalogue$Categories$Model$idDuRetirer),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Produits$StructureCatalogue$Update$DesCategories($author$project$Components$Produits$StructureCatalogue$Categories$Update$RetraitOuvert)),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$produitsValeursCategorieTypologieRetirer,
										i18n,
										{
											Dj: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(typologie)
										}))
								]))
						])),
					_Utils_eq(
					lien($author$project$API$NavLinksDictionary$archiverUnTypeDeProduit),
					$elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
					$rtfeldman$elm_css$Html$Styled$section,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('archivage')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsValeursDrawerArchiver(i18n))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsValeursCategorieArchiverPhrase(i18n))
								])),
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							3,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('archiver'),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Produits$StructureCatalogue$Update$DesCategories($author$project$Components$Produits$StructureCatalogue$Categories$Update$ArchivageDemande)),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif)
								]),
							A2(
								$author$project$I18n$Cles$produitsValeursDrawerArchiverDe,
								i18n,
								{Dj: nom}))
						]))
				]),
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: nom
		};
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$DuRetrait = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$RetraitDemande = {$: 23};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$retraitDeLaPlace = F3(
	function (i18n, categories, chemins) {
		var ouverte = $author$project$Components$Shared$Drawer$Model$estOuvert(categories.eW) ? categories.uK : $elm$core$Maybe$Nothing;
		var nombre = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.hD;
				},
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.zo;
					},
					ouverte)));
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Categories$Update$DuRetrait, $author$project$Components$Produits$StructureCatalogue$Update$DesCategories),
			function () {
				if (!ouverte.$) {
					var categorie = ouverte.a;
					return {
						fs: {
							sR: true,
							Bl: $author$project$I18n$Cles$produitsValeursCategorieTypologieRetirerValider(i18n),
							C$: $author$project$Components$Produits$StructureCatalogue$Update$DesCategories($author$project$Components$Produits$StructureCatalogue$Categories$Update$RetraitDemande)
						},
						fZ: _List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Messages$View$view,
								i18n,
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2($elm$core$Maybe$map, $elm$core$List$singleton, categorie.pZ))),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										(nombre > 0) ? A2(
											$author$project$I18n$Cles$produitsValeursCategorieTypologieRetirerConfirmation,
											i18n,
											{w: nombre}) : $author$project$I18n$Cles$produitsValeursCategorieTypologieRetirerConfirmationSansnombre(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('note', true),
												_Utils_Tuple2('avertissement', true)
											]))
									]),
								$elm$core$List$isEmpty(chemins) ? _List_Nil : _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$strong,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$produitsValeursCategorieTypologieRetirerArbre,
													i18n,
													{
														w: $elm$core$List$length(chemins)
													}))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2($elm$core$String$join, ', ', chemins) + '.')
											]))
									]))
							]),
						A6: $elm$core$Maybe$Nothing,
						Bc: false,
						h6: $author$project$I18n$Cles$produitsValeursCategorieTypologieRetirerTitre(i18n)
					};
				} else {
					return {
						fs: {
							sR: false,
							Bl: '',
							C$: $author$project$Components$Produits$StructureCatalogue$Update$DesCategories($author$project$Components$Produits$StructureCatalogue$Categories$Update$RetraitDemande)
						},
						fZ: _List_Nil,
						A6: $elm$core$Maybe$Nothing,
						Bc: false,
						h6: ''
					};
				}
			}(),
			categories.eW);
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$drawersDeLaCategorie = F2(
	function (i18n, model) {
		var categories = model.dt;
		var ouverte = A3(
			$elm$core$Maybe$map2,
			$elm$core$Tuple$pair,
			categories.uK,
			A2(
				$elm$core$Maybe$andThen,
				function (structure) {
					return A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$pair(structure),
						A2(
							$elm$core$Maybe$andThen,
							function (c) {
								return A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$classificationDe, c.r3, structure.vk);
							},
							categories.uK));
				},
				model.h$));
		var renommageOuvert = $author$project$Components$Shared$Drawer$Model$estOuvert(categories.hL);
		var retraitOuvert = $author$project$Components$Shared$Drawer$Model$estOuvert(categories.eW);
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				(renommageOuvert || retraitOuvert) ? _List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'inert', '')
					]) : _List_Nil,
				_List_fromArray(
					[
						A4(
						$author$project$Components$Shared$Drawer$View$view,
						i18n,
						A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Categories$Update$DuDrawerDeLaCategorie, $author$project$Components$Produits$StructureCatalogue$Update$DesCategories),
						function () {
							var _v0 = _Utils_Tuple2(
								$author$project$Components$Shared$Drawer$Model$estOuvert(categories.la),
								ouverte);
							if (_v0.a && (!_v0.b.$)) {
								var _v1 = _v0.b.a;
								var categorie = _v1.a;
								var _v2 = _v1.b;
								var structure = _v2.a;
								var typologie = _v2.b;
								return A6($author$project$Components$Produits$StructureCatalogue$Valeurs$View$contenuDeLaCategorie, i18n, model, structure, typologie, categorie, renommageOuvert || retraitOuvert);
							} else {
								return {
									fs: {
										sR: false,
										Bl: '',
										C$: $author$project$Components$Produits$StructureCatalogue$Update$DesCategories($author$project$Components$Produits$StructureCatalogue$Categories$Update$ArchivageDemande)
									},
									fZ: _List_Nil,
									A6: $elm$core$Maybe$Nothing,
									Bc: false,
									h6: ''
								};
							}
						}(),
						categories.la)
					])),
				A3(
				$author$project$Components$Produits$StructureCatalogue$Valeurs$View$retraitDeLaPlace,
				i18n,
				categories,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (_v3) {
							var categorie = _v3.a;
							var _v4 = _v3.b;
							var typologie = _v4.b;
							return A3(
								$author$project$Components$Produits$StructureCatalogue$Valeurs$Model$cheminsDeLaCategorie,
								$author$project$Components$Produits$StructureCatalogue$Valeurs$Lecture$noms(model),
								typologie,
								categorie.Aq);
						},
						ouverte))),
				A4(
				$author$project$Components$Shared$Drawer$View$view,
				i18n,
				A2($elm$core$Basics$composeR, $author$project$Components$Produits$StructureCatalogue$Categories$Update$DuRenommage, $author$project$Components$Produits$StructureCatalogue$Update$DesCategories),
				function () {
					var _v5 = _Utils_Tuple2(renommageOuvert, categories.uK);
					if (_v5.a && (!_v5.b.$)) {
						var categorie = _v5.b.a;
						return {
							fs: {
								sR: !$author$project$Components$Produits$Common$Envoi$enCours(categories.l2),
								Bl: $author$project$I18n$Cles$produitsClassificationsValeurRenommerValider(i18n),
								C$: $author$project$Components$Produits$StructureCatalogue$Update$DesCategories($author$project$Components$Produits$StructureCatalogue$Categories$Update$RenommageDemande)
							},
							fZ: _List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Messages$View$view,
									i18n,
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2($elm$core$Maybe$map, $elm$core$List$singleton, categorie.pZ))),
									A3(
									$author$project$Components$Shared$LibellesParLangue$View$view,
									i18n,
									_List_fromArray(
										[
											$author$project$Components$Produits$StructureCatalogue$Controles$entreeEnvoie(
											$author$project$Components$Produits$StructureCatalogue$Update$DesCategories($author$project$Components$Produits$StructureCatalogue$Categories$Update$RenommageDemande))
										]),
									{
										go: function (_v6) {
											return $elm$core$Maybe$Nothing;
										},
										Ba: $author$project$Referentiel$Langues$desLibelles,
										Bl: $author$project$I18n$Cles$produitsCatalogueChampNom(i18n),
										hg: F2(
											function (code, texte) {
												return $author$project$Components$Produits$StructureCatalogue$Update$DesCategories(
													A2($author$project$Components$Produits$StructureCatalogue$Categories$Update$NomSaisi, code, texte));
											}),
										pv: 'categorie-renommer-nom',
										fm: function (code) {
											return A2($author$project$Components$Shared$LibellesParLangue$Model$lire, code, categorie.Dj);
										}
									})
								]),
							A6: $elm$core$Maybe$Nothing,
							Bc: false,
							h6: A2(
								$author$project$I18n$Cles$produitsClassificationsValeurRenommerDe,
								i18n,
								{
									Dj: A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.Dj;
												},
												function ($) {
													return $.zX;
												}),
											categorie.zo))
								})
						};
					} else {
						return {
							fs: {
								sR: false,
								Bl: '',
								C$: $author$project$Components$Produits$StructureCatalogue$Update$DesCategories($author$project$Components$Produits$StructureCatalogue$Categories$Update$RenommageDemande)
							},
							fZ: _List_Nil,
							A6: $elm$core$Maybe$Nothing,
							Bc: false,
							h6: ''
						};
					}
				}(),
				categories.hL)
			]);
	});
var $author$project$Components$Produits$StructureCatalogue$Update$AjoutDInformationOuvert = function (a) {
	return {$: 147, a: a};
};
var $author$project$I18n$Cles$produitsInformationsEtageAjouterInformation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.etage.ajouter-information', _List_Nil, '+ Ajouter une information');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$ajouterUneInformation = F3(
	function (i18n, model, portee) {
		var _v0 = A2($author$project$Components$Produits$StructureCatalogue$Informations$Model$lienDeCreation, portee, model.AM);
		if (!_v0.$) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ajouter-information'),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$StructureCatalogue$Update$AjoutDInformationOuvert(portee))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsInformationsEtageAjouterInformation(i18n))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Update$ArticleDEtageRetire = F2(
	function (a, b) {
		return {$: 100, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Update$ArticlesDEtageDemandes = function (a) {
	return {$: 103, a: a};
};
var $author$project$I18n$Cles$produitsInformationsEtageAjouterArticles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.etage.ajouter-articles', _List_Nil, '+ Ajouter des articles');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$ajouterDesArticles = F3(
	function (i18n, model, cle) {
		var _v0 = A2($author$project$Components$Produits$Common$ChoixDArticles$lienDuLot, model.gF, 1);
		if (!_v0.$) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ajouter-articles'),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$StructureCatalogue$Update$ArticlesDEtageDemandes(cle))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsInformationsEtageAjouterArticles(i18n))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Update$ChoixDUnPerimetreDemande = function (a) {
	return {$: 106, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$choisirUnPerimetre = F3(
	function (i18n, model, cle) {
		var _v0 = model.nI;
		if (!_v0.$) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('choisir-perimetre'),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$StructureCatalogue$Update$ChoixDUnPerimetreDemande(cle))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsReferenceLiensChoisirUnPerimetre(i18n))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$codeEtMarque = function (article) {
	return A2(
		$elm$core$String$join,
		' \u00B7 ',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					article.vx,
					A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.zX;
					},
					article.gX)
				])));
};
var $author$project$Components$Produits$StructureCatalogue$Update$PerimetreDEtageRetire = function (a) {
	return {$: 112, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$PerimetrePoseRetire = function (a) {
	return {$: 113, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$nomDuPose = function (pose) {
	return A2($elm$core$Maybe$withDefault, '', pose.Dj);
};
var $author$project$I18n$Cles$produitsInformationsArticlesRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.articles.retirer', _List_Nil, 'Retirer');
};
var $author$project$I18n$Cles$produitsInformationsEtagePerimetreIndisponible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.etage.perimetre-indisponible', _List_Nil, 'Le périmètre posé sur ce champ n\'est plus disponible (supprimé ou sans droit).');
};
var $author$project$I18n$Cles$produitsInformationsEtagePerimetreRetenu = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.informations.etage.perimetre-retenu',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Périmètre « ' + (p.Dj + ' » : ses articles font partie de la valeur, aujourd\'hui et demain.'));
	});
var $author$project$I18n$Cles$produitsInformationsEtagePerimetreRetirerNom = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.informations.etage.perimetre-retirer-nom',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer le périmètre ' + p.Dj);
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$perimetreDuChamp = F3(
	function (i18n, ouvert, cle) {
		var _v0 = A2($author$project$Components$Produits$StructureCatalogue$Informations$Etage$perimetreDe, cle, ouvert);
		if (!_v0.$) {
			var retenu = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('perimetre-retenu')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$produitsInformationsEtagePerimetreRetenu,
									i18n,
									{Dj: retenu.Dj}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Produits$StructureCatalogue$Update$PerimetreDEtageRetire(cle)),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-label',
								A2(
									$author$project$I18n$Cles$produitsInformationsEtagePerimetreRetirerNom,
									i18n,
									{Dj: retenu.Dj})),
								$rtfeldman$elm_css$Html$Styled$Attributes$title(
								A2(
									$author$project$I18n$Cles$produitsInformationsEtagePerimetreRetirerNom,
									i18n,
									{Dj: retenu.Dj}))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsInformationsArticlesRetirer(i18n))
							]))
					]));
		} else {
			var _v1 = A2($author$project$Components$Produits$StructureCatalogue$Informations$Etage$poseDe, cle, ouvert);
			if (!_v1.$) {
				var pose = _v1.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('perimetre-retenu'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('pose')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									function () {
										var _v2 = _Utils_Tuple2(pose.AJ, pose.Dj);
										if ((!_v2.a) && (!_v2.b.$)) {
											var nom = _v2.b.a;
											return A2(
												$author$project$I18n$Cles$produitsInformationsEtagePerimetreRetenu,
												i18n,
												{Dj: nom});
										} else {
											return $author$project$I18n$Cles$produitsInformationsEtagePerimetreIndisponible(i18n);
										}
									}())
								])),
							pose.tE ? A2(
							$author$project$Components$Shared$Tag$View$view,
							3,
							$author$project$I18n$Cles$perimetresArchive(i18n)) : $rtfeldman$elm_css$Html$Styled$text(''),
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer'),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Produits$StructureCatalogue$Update$PerimetrePoseRetire(cle)),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									A2(
										$author$project$I18n$Cles$produitsInformationsEtagePerimetreRetirerNom,
										i18n,
										{
											Dj: $author$project$Components$Produits$StructureCatalogue$Informations$View$nomDuPose(pose)
										})),
									$rtfeldman$elm_css$Html$Styled$Attributes$title(
									A2(
										$author$project$I18n$Cles$produitsInformationsEtagePerimetreRetirerNom,
										i18n,
										{
											Dj: $author$project$Components$Produits$StructureCatalogue$Informations$View$nomDuPose(pose)
										}))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsInformationsArticlesRetirer(i18n))
								]))
						]));
			} else {
				return $rtfeldman$elm_css$Html$Styled$text('');
			}
		}
	});
var $author$project$I18n$Cles$produitsInformationsArticlesArrete = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.articles.arrete', _List_Nil, '(arrêté)');
};
var $author$project$I18n$Cles$produitsInformationsArticlesAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.articles.aucun', _List_Nil, 'Aucun article lié pour l\'instant.');
};
var $author$project$I18n$Cles$produitsInformationsArticlesRetirerNom = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.informations.articles.retirer-nom',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer le lien vers ' + p.Dj);
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$articlesDuChamp = F4(
	function (i18n, model, ouvert, champ) {
		var cle = champ.uN.dy;
		return _Utils_ap(
			function () {
				var _v0 = A2($author$project$Components$Produits$StructureCatalogue$Informations$Etage$articlesDe, cle, ouvert);
				if (!_v0.b) {
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('aucun')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsInformationsArticlesAucun(i18n))
								]))
						]);
				} else {
					var articles = _v0;
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('articles')
								]),
							A2(
								$elm$core$List$map,
								function (article) {
									var nom = A2(
										$elm$core$Maybe$withDefault,
										A2($elm$core$Maybe$withDefault, '', article.vx),
										A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.zX;
											},
											article.Dj));
									return A2(
										$rtfeldman$elm_css$Html$Styled$li,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('article'),
												$rtfeldman$elm_css$Html$Styled$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'arretee',
														_Utils_eq(article.gt, $author$project$Catalogue$Vocabulaire$etatArrete))
													]))
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$strong,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(nom)
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('code')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$Components$Produits$StructureCatalogue$Informations$View$codeEtMarque(article))
															])),
														_Utils_eq(article.gt, $author$project$Catalogue$Vocabulaire$etatArrete) ? A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('etat')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$I18n$Cles$produitsInformationsArticlesArrete(i18n))
															])) : $rtfeldman$elm_css$Html$Styled$text('')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$button,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
														$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer'),
														$rtfeldman$elm_css$Html$Styled$Events$onClick(
														A2($author$project$Components$Produits$StructureCatalogue$Update$ArticleDEtageRetire, cle, article.Aq)),
														A2(
														$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
														'aria-label',
														A2(
															$author$project$I18n$Cles$produitsInformationsArticlesRetirerNom,
															i18n,
															{Dj: nom})),
														$rtfeldman$elm_css$Html$Styled$Attributes$title(
														A2(
															$author$project$I18n$Cles$produitsInformationsArticlesRetirerNom,
															i18n,
															{Dj: nom}))
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$produitsInformationsArticlesRetirer(i18n))
													]))
											]));
								},
								articles))
						]);
				}
			}(),
			_List_fromArray(
				[
					A3($author$project$Components$Produits$StructureCatalogue$Informations$View$perimetreDuChamp, i18n, ouvert, cle),
					A3($author$project$Components$Produits$StructureCatalogue$Informations$View$ajouterDesArticles, i18n, model, cle),
					A3($author$project$Components$Produits$StructureCatalogue$Informations$View$choisirUnPerimetre, i18n, model, cle)
				]));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$champsDe = F2(
	function (portee, informations) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.dw;
				},
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.F3;
						},
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$filter(
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.F$;
									},
									$elm$core$Basics$eq(portee))),
							$elm$core$List$head)),
					informations)));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$InformationOuverte = F2(
	function (a, b) {
		return {$: 94, a: a, b: b};
	});
var $author$project$I18n$Cles$produitsInformationsEtageLienMention = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.informations.etage.lien-mention',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md))
				]),
			'Lien vers des articles · vaut pour tous les ' + p.md);
	});
var $author$project$I18n$Cles$produitsInformationsEtageModifier = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.etage.modifier', _List_Nil, 'Modifier');
};
var $author$project$I18n$Cles$produitsInformationsEtageModifierInformationNom = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.informations.etage.modifier-information-nom',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Modifier l\'information ' + p.Dj);
	});
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerChoixDansUneListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.drawer.choix-dans-une-liste', _List_Nil, 'Choix dans une liste');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$typeDuChamp = F2(
	function (i18n, type_) {
		switch (type_.$) {
			case 0:
				return A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeDeChamp, i18n, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeTexte);
			case 1:
				return A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeDeChamp, i18n, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeTexteLong);
			case 2:
				return A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeDeChamp, i18n, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeTexteLong);
			case 3:
				return A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeDeChamp, i18n, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeNombre);
			case 4:
				return A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeDeChamp, i18n, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeMontant);
			case 5:
				return A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeDeChamp, i18n, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeDate);
			case 6:
				return A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeDeChamp, i18n, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeOuiNon);
			case 9:
				return A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeDeChamp, i18n, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeFichier);
			case 17:
				return $author$project$I18n$Cles$produitsParcoursInformationsDrawerChoixDansUneListe(i18n);
			case 21:
				return $author$project$I18n$Cles$produitsParcoursInformationsDrawerChoixDansUneListe(i18n);
			case 18:
				return $author$project$I18n$Cles$produitsParcoursInformationsDrawerLienVersDesArticles(i18n);
			default:
				return A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeDeChamp, i18n, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeTexte);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$ligneDInformation = F4(
	function (i18n, portee, nomDeLEtage, champ) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('information')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(champ.uN.Bl)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('type')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							function () {
								var _v0 = champ.uN.r0;
								if (_v0.$ === 18) {
									return A2(
										$author$project$I18n$Cles$produitsInformationsEtageLienMention,
										i18n,
										{md: nomDeLEtage});
								} else {
									var autre = _v0;
									return A2($author$project$Components$Produits$StructureCatalogue$Informations$View$typeDuChamp, i18n, autre);
								}
							}())
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('modifier-information'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							A2($author$project$Components$Produits$StructureCatalogue$Update$InformationOuverte, portee, champ.uN.dy)),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-label',
							A2(
								$author$project$I18n$Cles$produitsInformationsEtageModifierInformationNom,
								i18n,
								{Dj: champ.uN.Bl})),
							$rtfeldman$elm_css$Html$Styled$Attributes$title(
							A2(
								$author$project$I18n$Cles$produitsInformationsEtageModifierInformationNom,
								i18n,
								{Dj: champ.uN.Bl}))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsInformationsEtageModifier(i18n))
						]))
				]));
	});
var $author$project$I18n$Cles$produitsInformationsEtageArticlesTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.informations.etage.articles-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md))
				]),
			'Articles liés à tous les ' + p.md);
	});
var $author$project$I18n$Cles$produitsInformationsEtageEffetTexte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.informations.etage.effet-texte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fiches',
					$author$project$I18n$Traductions$Chaine(p.zu)),
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md)),
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (p.zu + (' ' + (p.md + (' héritent de ce lien. Sur chaque fiche, ils s\'affichent « Hérité · ' + (p.md + ' » et ne se retirent pas.'))))) : (p.zu + (' ' + (p.md + (' héritent de ces ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + (' liens. Sur chaque fiche, ils s\'affichent « Hérité · ' + (p.md + ' » et ne se retirent pas.'))))))));
	});
var $author$project$I18n$Cles$produitsInformationsEtageEffetTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.etage.effet-titre', _List_Nil, 'Effet sur les fiches');
};
var $author$project$I18n$Cles$produitsInformationsEtageEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.etage.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$produitsInformationsEtageInformationsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.etage.informations-titre', _List_Nil, 'Informations de l\'étage');
};
var $author$project$I18n$Cles$produitsInformationsEtageTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.informations.etage.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Modifier « ' + (p.Dj + ' »'));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$RattachementDInformationOuvert = function (a) {
	return {$: 139, a: a};
};
var $author$project$I18n$Cles$produitsInformationsRattacherBouton = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.rattacher.bouton', _List_Nil, 'Rattacher un champ existant');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$rattacherUnChampExistant = F3(
	function (i18n, model, portee) {
		var _v0 = A2($author$project$Components$Produits$StructureCatalogue$Informations$Model$lienDeRattachement, portee, model.AM);
		if (!_v0.$) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('rattacher-champ'),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$StructureCatalogue$Update$RattachementDInformationOuvert(portee))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsInformationsRattacherBouton(i18n))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$section = F3(
	function (nom, titre, enfants) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('section'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(nom)
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(titre)
						])),
				enfants));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$sectionNomDeLEtage = F3(
	function (i18n, model, ouvert) {
		var ligne = F3(
			function (libelles, lien, geste) {
				return A3(
					$author$project$Components$Produits$StructureCatalogue$Informations$View$section,
					'nom-de-l-etage',
					$author$project$I18n$Cles$produitsValeursDrawerNom(i18n),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('libelles')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$strong,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(libelles.zX)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('anglais')
												]),
											A2(
												$elm$core$Maybe$withDefault,
												_List_Nil,
												A2(
													$elm$core$Maybe$map,
													function (en) {
														return _List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																A2(
																	$author$project$I18n$Cles$produitsValeursDrawerAnglais,
																	i18n,
																	{Dj: en}))
															]);
													},
													libelles.yg)))
										])),
									_Utils_eq(
									A2($author$project$API$Liens$trouver, lien, geste.a),
									$elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('renommer'),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(geste.b)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsClassificationsValeurRenommer(i18n))
										]))
								]))
						]));
			});
		var classifications = function (classification) {
			return A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.vk;
					},
					$author$project$Components$Produits$StructureCatalogue$Classifications$Model$classificationDe(classification)),
				model.h$);
		};
		var _v0 = ouvert.F$;
		switch (_v0.$) {
			case 1:
				var classification = _v0.a;
				var _v1 = classifications(classification);
				if (!_v1.$) {
					var typologie = _v1.a;
					return A3(
						ligne,
						typologie.R,
						$author$project$API$NavLinksDictionary$renommerUneClassification,
						_Utils_Tuple2(
							typologie.nQ,
							$author$project$Components$Produits$StructureCatalogue$Update$RenommageDeTypologieOuvert(classification)));
				} else {
					return $rtfeldman$elm_css$Html$Styled$text('');
				}
			case 2:
				var classification = _v0.a;
				var valeur = _v0.b;
				var _v2 = _Utils_Tuple2(
					classifications(classification),
					$author$project$Catalogue$Identifiants$valeurIdFromString(valeur));
				if ((!_v2.a.$) && (!_v2.b.$)) {
					var typologie = _v2.a.a;
					var id = _v2.b.a;
					var _v3 = A2($author$project$Components$Produits$StructureCatalogue$Classifications$Model$valeurDe, id, typologie);
					if (!_v3.$) {
						var noeud = _v3.a;
						return A3(
							ligne,
							noeud.R,
							$author$project$API$NavLinksDictionary$traduireUneValeur,
							_Utils_Tuple2(
								noeud.nQ,
								$author$project$Components$Produits$StructureCatalogue$Update$DesClassifications(
									A2($author$project$Components$Produits$StructureCatalogue$Classifications$Update$RenommageOuvert, classification, id))));
					} else {
						return $rtfeldman$elm_css$Html$Styled$text('');
					}
				} else {
					return $rtfeldman$elm_css$Html$Styled$text('');
				}
			default:
				return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$etage = F2(
	function (i18n, model) {
		var _v0 = model.s;
		if (_v0.$ === 1) {
			return A4($author$project$Components$Shared$Drawer$View$view, i18n, $author$project$Components$Produits$StructureCatalogue$Update$DeLEtage, $author$project$Components$Produits$StructureCatalogue$Informations$View$vide_, model.dK);
		} else {
			var ouvert = _v0.a;
			var champs = A2($author$project$Components$Produits$StructureCatalogue$Informations$View$champsDe, ouvert.F$, model.AM);
			var liens = A2(
				$elm$core$List$filter,
				function (champ) {
					var _v1 = champ.uN.r0;
					if (_v1.$ === 18) {
						return true;
					} else {
						return false;
					}
				},
				champs);
			var total = $elm$core$List$sum(
				A2(
					$elm$core$List$map,
					function (champ) {
						return $elm$core$List$length(
							A2($author$project$Components$Produits$StructureCatalogue$Informations$Etage$articlesDe, champ.uN.dy, ouvert));
					},
					liens));
			return A4(
				$author$project$Components$Shared$Drawer$View$view,
				i18n,
				$author$project$Components$Produits$StructureCatalogue$Update$DeLEtage,
				{
					fs: {
						sR: !$author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model),
						Bl: $author$project$I18n$Cles$produitsInformationsEtageEnregistrer(i18n),
						C$: $author$project$Components$Produits$StructureCatalogue$Update$EtageEnregistre
					},
					fZ: _List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Messages$View$view,
							i18n,
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2($elm$core$Maybe$map, $elm$core$List$singleton, model.aL))),
							A3($author$project$Components$Produits$StructureCatalogue$Informations$View$sectionNomDeLEtage, i18n, model, ouvert),
							A3(
							$author$project$Components$Produits$StructureCatalogue$Informations$View$section,
							'informations-de-l-etage',
							$author$project$I18n$Cles$produitsInformationsEtageInformationsTitre(i18n),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									A3($author$project$Components$Produits$StructureCatalogue$Informations$View$ligneDInformation, i18n, ouvert.F$, ouvert.Dj),
									champs),
								_List_fromArray(
									[
										A3($author$project$Components$Produits$StructureCatalogue$Informations$View$ajouterUneInformation, i18n, model, ouvert.F$),
										A3($author$project$Components$Produits$StructureCatalogue$Informations$View$rattacherUnChampExistant, i18n, model, ouvert.F$)
									]))),
							A3(
							$author$project$Components$Produits$StructureCatalogue$Informations$View$section,
							'articles-lies',
							A2(
								$author$project$I18n$Cles$produitsInformationsEtageArticlesTitre,
								i18n,
								{md: ouvert.Dj}),
							A2(
								$elm$core$List$concatMap,
								A3($author$project$Components$Produits$StructureCatalogue$Informations$View$articlesDuChamp, i18n, model, ouvert),
								liens)),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('effet')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h3,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$I18n$Cles$produitsInformationsEtageEffetTitre(i18n))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$author$project$I18n$Cles$produitsInformationsEtageEffetTexte,
												i18n,
												{
													md: ouvert.Dj,
													zu: $elm$core$String$fromInt(ouvert.zu),
													w: total
												}))
										]))
								]))
						]),
					A6: ouvert.A6,
					Bc: false,
					h6: A2(
						$author$project$I18n$Cles$produitsInformationsEtageTitre,
						i18n,
						{Dj: ouvert.Dj})
				},
				model.dK);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$View$etageDesMarques = F2(
	function (i18n, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				function (structure) {
					return A2(
						$elm$core$Maybe$andThen,
						function (typologie) {
							return A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Components$Produits$StructureCatalogue$Etages$Model$nom(structure.C9),
									$author$project$I18n$Cles$texte(i18n)),
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (etage) {
											var _v0 = etage.xt;
											if (!_v0.$) {
												var code = _v0.a;
												return _Utils_eq(code, $author$project$Catalogue$Vocabulaire$codeMarque);
											} else {
												return false;
											}
										},
										typologie.yG)));
						},
						A2($author$project$Components$Produits$StructureCatalogue$Typologies$Model$reglee, model.r6, structure.vk));
				},
				model.h$));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$EtapeDemandeeAuPied = function (a) {
	return {$: 1, a: a};
};
var $author$project$I18n$Cles$produitsEtagesSansTypologie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.etages.sans-typologie', _List_Nil, 'Créez d\'abord une typologie à l\'étape 1.');
};
var $author$project$I18n$Cles$produitsEtagesSansTypologieLien = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.etages.sans-typologie.lien', _List_Nil, 'Aller à l\'étape 1');
};
var $author$project$Components$Produits$StructureCatalogue$View$sansTypologie = function (i18n) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$p,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('sans-typologie')
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$I18n$Cles$produitsEtagesSansTypologie(i18n)),
				$rtfeldman$elm_css$Html$Styled$text(' '),
				A4(
				$author$project$Components$Shared$Bouton$View$lienAvec,
				1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$StructureCatalogue$Update$EtapeDemandeeAuPied(0))
					]),
				$author$project$Routes$Route$toString(
					A2($author$project$Routes$Route$ParametrageCatalogue, 0, $elm$core$Maybe$Nothing)),
				$author$project$I18n$Cles$produitsEtagesSansTypologieLien(i18n))
			]));
};
var $author$project$Components$Produits$StructureCatalogue$Etages$View$DansLaPage = 0;
var $author$project$Components$Produits$StructureCatalogue$Update$RangementDeTypologieOuvert = {$: 83};
var $author$project$Components$Produits$StructureCatalogue$Update$AjoutDEtageLibreOuvert = function (a) {
	return {$: 67, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$NiveauDEtageAjoute = function (a) {
	return {$: 63, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$ProduitReactive = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$niveauxProposes = F2(
	function (niveaux, etages) {
		var designes = A2(
			$elm$core$List$filterMap,
			function (etage) {
				var _v0 = etage.xt;
				if (!_v0.$) {
					var niveau = _v0.b;
					return $elm$core$Maybe$Just(niveau);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			etages);
		return A2(
			$elm$core$List$filter,
			function (niveau) {
				return niveau.Kg && (A2(
					$elm$core$List$member,
					niveau.fA,
					_List_fromArray(
						[$author$project$Catalogue$Vocabulaire$codeMarque, $author$project$Catalogue$Vocabulaire$codeGamme, $author$project$Catalogue$Vocabulaire$codeProduit])) && (!A2($elm$core$List$member, niveau.Aq, designes)));
			},
			niveaux);
	});
var $author$project$I18n$Cles$produitsStructureAjoutCollection = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.structure.ajout.collection', _List_Nil, 'Collection');
};
var $author$project$I18n$Cles$produitsStructureAjoutInvite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.structure.ajout.invite', _List_Nil, 'Ajouter un étage :');
};
var $author$project$I18n$Cles$produitsStructureAjoutUnAutre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.structure.ajout.un-autre', _List_Nil, 'Un autre');
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$Collection = 0;
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$propositions = F2(
	function (niveaux, etages) {
		return A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$Produits$StructureCatalogue$Etages$Model$nom(niveaux),
				$elm$core$Basics$eq(
					$author$project$I18n$Traductions$tel(
						$author$project$Components$Produits$StructureCatalogue$Etages$Model$nomPropose(0).a))),
			etages) ? _List_fromArray(
			[1]) : _List_fromArray(
			[0, 1]);
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$View$ajouts = F5(
	function (i18n, lieu, inactif, structure, typologie) {
		var pointille = F2(
			function (attributs, libelle) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$button,
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Attributes$class('proposition'),
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif),
								attributs))),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(libelle)
								]))
						]));
			});
		var produit = A2(
			$elm$core$List$map,
			function (niveau) {
				return A2(
					pointille,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('reactiver'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(
							A2(
								$author$project$Components$Produits$StructureCatalogue$Etages$View$dansLe,
								lieu,
								$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$idDuBoutonDActivation(niveau.Aq))),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Produits$StructureCatalogue$Update$ProduitReactive(niveau.Aq))
						]),
					A2(
						$author$project$I18n$Cles$texte,
						i18n,
						$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$libelleDuNiveau(niveau)));
			},
			A2(
				$elm$core$List$filter,
				function (niveau) {
					return _Utils_eq(niveau.fA, $author$project$Catalogue$Vocabulaire$codeProduit) && ((!niveau.Kg) && (!_Utils_eq(
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$activerUnNiveau, niveau.nQ),
						$elm$core$Maybe$Nothing)));
				},
				structure.C9));
		var etagesOfferts = _Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ajouterUnEtage, typologie.nQ),
			$elm$core$Maybe$Nothing) ? _List_Nil : _Utils_ap(
			A2(
				$elm$core$List$map,
				function (niveau) {
					return A2(
						pointille,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('niveau'),
								$rtfeldman$elm_css$Html$Styled$Attributes$id(
								A2(
									$author$project$Components$Produits$StructureCatalogue$Etages$View$dansLe,
									lieu,
									$author$project$Components$Produits$StructureCatalogue$Etages$Model$idDeLAjoutDuNiveau(niveau.Aq))),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Produits$StructureCatalogue$Update$NiveauDEtageAjoute(niveau.Aq))
							]),
						A2(
							$author$project$I18n$Cles$texte,
							i18n,
							$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$libelleDuNiveau(niveau)));
				},
				A2($author$project$Components$Produits$StructureCatalogue$Etages$Model$niveauxProposes, structure.C9, typologie.yG)),
			A2(
				$elm$core$List$map,
				function (proposition) {
					return A2(
						pointille,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id(
								A2(
									$author$project$Components$Produits$StructureCatalogue$Etages$View$dansLe,
									lieu,
									$author$project$Components$Produits$StructureCatalogue$Etages$Model$idDeLOuverture(proposition))),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Produits$StructureCatalogue$Update$AjoutDEtageLibreOuvert(proposition))
							]),
						function () {
							if (proposition === 1) {
								return $author$project$I18n$Cles$produitsStructureAjoutUnAutre(i18n);
							} else {
								return $author$project$I18n$Cles$produitsStructureAjoutCollection(i18n);
							}
						}());
				},
				A2($author$project$Components$Produits$StructureCatalogue$Etages$Model$propositions, structure.C9, typologie.yG)));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ajouts')
				]),
			function () {
				var _v0 = _Utils_ap(etagesOfferts, produit);
				if (!_v0.b) {
					return _List_Nil;
				} else {
					var boutons = _v0;
					return A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('invite')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsStructureAjoutInvite(i18n))
								])),
						boutons);
				}
			}());
	});
var $author$project$Components$Produits$StructureCatalogue$Update$ArchivageDeTypologieOuvert = function (a) {
	return {$: 44, a: a};
};
var $author$project$I18n$Cles$produitsTypologiesArchiverBouton = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.bouton', _List_Nil, 'Archiver la typologie');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverZoneTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.zone.texte', _List_Nil, 'Archivée, elle reste consultable mais n\'accepte plus aucune saisie ; ses références sont d\'abord migrées vers une autre typologie ou clôturées.');
};
var $author$project$I18n$Cles$produitsTypologiesArchiverZoneTexteNombre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.typologies.archiver.zone.texte.nombre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			p.w + ' références y sont rangées. Archivée, elle reste consultable mais n\'accepte plus aucune saisie ; ses références sont d\'abord migrées vers une autre typologie ou clôturées.');
	});
var $author$project$I18n$Cles$produitsTypologiesArchiverZoneTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archiver.zone.titre', _List_Nil, 'Cette typologie');
};
var $author$project$Components$Produits$StructureCatalogue$Etages$View$archivage = F3(
	function (i18n, inactif, typologie) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('zone-typologie')
				]),
			(!_Utils_eq(
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$archiverLaClassification, typologie.nQ),
				$elm$core$Maybe$Nothing)) ? _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsTypologiesArchiverZoneTitre(i18n))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							function () {
								var _v0 = typologie.hD;
								if (!_v0.$) {
									var nombre = _v0.a;
									return A2(
										$author$project$I18n$Cles$produitsTypologiesArchiverZoneTexteNombre,
										i18n,
										{
											w: A2(
												$author$project$I18n$Nombre$formater,
												$author$project$I18n$Traductions$langue(i18n),
												nombre)
										});
								} else {
									return $author$project$I18n$Cles$produitsTypologiesArchiverZoneTexte(i18n);
								}
							}())
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('archiver'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(
							$author$project$Components$Produits$StructureCatalogue$Typologies$Model$idDuBoutonArchiver(typologie.Aq)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Produits$StructureCatalogue$Update$ArchivageDeTypologieOuvert(typologie.Aq)),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsTypologiesArchiverBouton(i18n))
						]))
				]) : _List_Nil);
	});
var $author$project$Components$Produits$StructureCatalogue$Typologies$Model$archivee = function (typologie) {
	return !_Utils_eq(
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reactiverLaClassification, typologie.nQ),
		$elm$core$Maybe$Nothing);
};
var $author$project$Components$Produits$StructureCatalogue$Update$TypologieReglee = function (a) {
	return {$: 62, a: a};
};
var $author$project$I18n$Cles$produitsEtagesRegler = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.etages.regler', _List_Nil, 'Régler cette typologie');
};
var $author$project$I18n$Cles$produitsEtagesSansMarque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.etages.sans-marque', _List_Nil, ', sans marque.');
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$sansMarque = $elm$core$List$all(
	function (etage) {
		var _v0 = etage.xt;
		if (!_v0.$) {
			var code = _v0.a;
			return !_Utils_eq(code, $author$project$Catalogue$Vocabulaire$codeMarque);
		} else {
			return true;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$View$autres = F4(
	function (i18n, inactif, structure, reglee) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('autres-typologies')
				]),
			A2(
				$elm$core$List$map,
				function (autre) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('autre-typologie'),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'data-typologie',
								$author$project$Catalogue$Identifiants$classificationIdToString(autre.Aq))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(autre) + ' : '),
										A2(
										$rtfeldman$elm_css$Html$Styled$strong,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A3($author$project$Components$Produits$StructureCatalogue$Etages$Model$chemin, i18n, structure.C9, autre.yG))
											])),
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$Components$Produits$StructureCatalogue$Etages$Model$sansMarque(autre.yG) ? $author$project$I18n$Cles$produitsEtagesSansMarque(i18n) : '.')
									])),
								A3(
								$author$project$Components$Shared$Bouton$View$bouton,
								1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('regler'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Components$Produits$StructureCatalogue$Update$TypologieReglee(autre.Aq)),
										$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif)
									]),
								$author$project$I18n$Cles$produitsEtagesRegler(i18n))
							]));
				},
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Aq;
						},
						$elm$core$Basics$neq(reglee.Aq)),
					$author$project$Components$Produits$StructureCatalogue$Typologies$Model$de(structure.vk))));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$ReactivationDeTypologieDemandee = function (a) {
	return {$: 59, a: a};
};
var $author$project$I18n$Cles$produitsTypologiesArchiveeReactiver = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archivee.reactiver', _List_Nil, 'Réactiver');
};
var $author$project$I18n$Cles$produitsTypologiesArchiveeReactiverDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.typologies.archivee.reactiver.de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Réactiver la typologie ' + p.Dj);
	});
var $author$project$I18n$Cles$produitsTypologiesArchiveeTexte = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archivee.texte', _List_Nil, 'Lecture seule : ses références ont été migrées ou clôturées. Son nom reste réservé.');
};
var $author$project$I18n$Cles$produitsTypologiesArchiveeTitreDate = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.typologies.archivee.titre.date',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv))
				]),
			'Typologie archivée le ' + p.wv);
	});
var $author$project$I18n$Cles$produitsTypologiesArchiveeTitrePar = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.typologies.archivee.titre.par',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$I18n$Traductions$Chaine(p.wv)),
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Typologie archivée le ' + (p.wv + (' par ' + p.Dj)));
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$View$titreDeLArchivage = F2(
	function (i18n, typologie) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('titre')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					function () {
						var _v0 = typologie.tD;
						if (!_v0.$) {
							var fait = _v0.a;
							var date = A2(
								$author$project$Texte$Jour$enFrancais,
								i18n,
								A2($elm$core$String$left, 10, fait.Bf));
							var _v1 = fait.ET;
							if (!_v1.$) {
								var nom = _v1.a;
								return A2(
									$author$project$I18n$Cles$produitsTypologiesArchiveeTitrePar,
									i18n,
									{wv: date, Dj: nom});
							} else {
								return A2(
									$author$project$I18n$Cles$produitsTypologiesArchiveeTitreDate,
									i18n,
									{wv: date});
							}
						} else {
							return '';
						}
					}())
				]));
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$View$bandeauDArchivage = F3(
	function (i18n, inactif, typologie) {
		var nomDuGeste = A2(
			$author$project$I18n$Cles$produitsTypologiesArchiveeReactiverDe,
			i18n,
			{
				Dj: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(typologie)
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('bandeau-archivage'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('note'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'note')
				]),
			$author$project$Components$Produits$StructureCatalogue$Typologies$Model$archivee(typologie) ? _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
						]),
					_List_fromArray(
						[
							A2($author$project$Components$Produits$StructureCatalogue$Etages$View$titreDeLArchivage, i18n, typologie),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsTypologiesArchiveeTexte(i18n))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('reactiver'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Produits$StructureCatalogue$Update$ReactivationDeTypologieDemandee(typologie.Aq)),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', nomDuGeste),
							$rtfeldman$elm_css$Html$Styled$Attributes$title(nomDuGeste)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsTypologiesArchiveeReactiver(i18n))
						]))
				]) : _List_Nil);
	});
var $author$project$I18n$Cles$produitsTypologiesArchiveeBilan = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.typologies.archivee.bilan',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'migrees',
					$author$project$I18n$Traductions$Chaine(p.Cw)),
					_Utils_Tuple2(
					'aranger',
					$author$project$I18n$Traductions$Chaine(p.iZ)),
					_Utils_Tuple2(
					'cloturees',
					$author$project$I18n$Traductions$Chaine(p.vr))
				]),
			p.Cw + (' références migrées (dont ' + (p.iZ + (' « À ranger »), ' + (p.vr + ' clôturées et toujours lisibles.')))));
	});
var $author$project$I18n$Cles$produitsTypologiesArchiveeBilanTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archivee.bilan.titre', _List_Nil, 'Ce qu\'est devenu l\'existant');
};
var $author$project$I18n$Cles$produitsTypologiesArchiveeBilanVers = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.typologies.archivee.bilan.vers',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'migrees',
					$author$project$I18n$Traductions$Chaine(p.Cw)),
					_Utils_Tuple2(
					'cible',
					$author$project$I18n$Traductions$Chaine(p.vf)),
					_Utils_Tuple2(
					'aranger',
					$author$project$I18n$Traductions$Chaine(p.iZ)),
					_Utils_Tuple2(
					'cloturees',
					$author$project$I18n$Traductions$Chaine(p.vr))
				]),
			p.Cw + (' références migrées vers « ' + (p.vf + (' » (dont ' + (p.iZ + (' « À ranger »), ' + (p.vr + ' clôturées et toujours lisibles.')))))));
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$View$bilanDeLArchivage = F2(
	function (i18n, typologie) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.uq;
			},
			typologie.tD);
		if (!_v0.$) {
			var bilan = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('zone-bilan-archivage'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h3,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsTypologiesArchiveeBilanTitre(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('bilan')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								function () {
									var _v1 = bilan.vf;
									if (!_v1.$) {
										var cible = _v1.a;
										return A2(
											$author$project$I18n$Cles$produitsTypologiesArchiveeBilanVers,
											i18n,
											{
												iZ: $elm$core$String$fromInt(bilan.iz),
												vf: cible.R.zX,
												vr: $elm$core$String$fromInt(bilan.vr),
												Cw: $elm$core$String$fromInt(bilan.Cw)
											});
									} else {
										return A2(
											$author$project$I18n$Cles$produitsTypologiesArchiveeBilan,
											i18n,
											{
												iZ: $elm$core$String$fromInt(bilan.iz),
												vr: $elm$core$String$fromInt(bilan.vr),
												Cw: $elm$core$String$fromInt(bilan.Cw)
											});
									}
								}())
							]))
					]));
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('zone-bilan-archivage')
					]),
				_List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$View$DansLeRangement = 1;
var $author$project$Catalogue$Vocabulaire$codeReference = 'reference';
var $author$project$Components$Produits$StructureCatalogue$Update$EtageDepose = function (a) {
	return {$: 86, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$EtageGlisseCommence = function (a) {
	return {$: 85, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$EtageGlisseFini = {$: 87};
var $author$project$Components$Produits$StructureCatalogue$Update$GlisserSurvole = {$: 16};
var $author$project$Components$Produits$StructureCatalogue$Etages$View$glisser = F2(
	function (ligne, fourni) {
		return (ligne.bP && (!fourni.wL)) ? _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$draggable('true'),
				A2(
				$rtfeldman$elm_css$Html$Styled$Events$on,
				'dragstart',
				$elm$json$Json$Decode$succeed(
					$author$project$Components$Produits$StructureCatalogue$Update$EtageGlisseCommence(fourni.Aq))),
				A2(
				$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
				'dragover',
				$elm$json$Json$Decode$succeed(
					_Utils_Tuple2($author$project$Components$Produits$StructureCatalogue$Update$GlisserSurvole, true))),
				A2(
				$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
				'drop',
				$elm$json$Json$Decode$succeed(
					_Utils_Tuple2(
						$author$project$Components$Produits$StructureCatalogue$Update$EtageDepose(fourni.Aq),
						true))),
				A2(
				$rtfeldman$elm_css$Html$Styled$Events$on,
				'dragend',
				$elm$json$Json$Decode$succeed($author$project$Components$Produits$StructureCatalogue$Update$EtageGlisseFini))
			]) : _List_Nil;
	});
var $author$project$Components$Produits$StructureCatalogue$Update$EtageDescendu = function (a) {
	return {$: 66, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$EtageMonte = function (a) {
	return {$: 65, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Etages$View$ordre = F4(
	function (i18n, ligne, nom, fourni) {
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('poignee')
					]),
				_List_fromArray(
					[$author$project$Components$Shared$Svg$svgDragHandle])),
				A2(
				$author$project$Components$Produits$StructureCatalogue$Controles$boutonDOrdre,
				0,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						A2($author$project$Components$Produits$StructureCatalogue$Etages$Model$idDuBoutonDOrdre, fourni.Aq, 0)),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$StructureCatalogue$Update$EtageMonte(fourni.Aq)),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(fourni.wL || (ligne.Ge || ligne.d3)),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-label',
						A2(
							$author$project$I18n$Cles$produitsStructureOrdreMonterDe,
							i18n,
							{Dj: nom})),
						$rtfeldman$elm_css$Html$Styled$Attributes$title(
						A2(
							$author$project$I18n$Cles$produitsStructureOrdreMonterDe,
							i18n,
							{Dj: nom}))
					])),
				A2(
				$author$project$Components$Produits$StructureCatalogue$Controles$boutonDOrdre,
				1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						A2($author$project$Components$Produits$StructureCatalogue$Etages$Model$idDuBoutonDOrdre, fourni.Aq, 1)),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$StructureCatalogue$Update$EtageDescendu(fourni.Aq)),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(fourni.wL || (ligne.xg || ligne.d3)),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-label',
						A2(
							$author$project$I18n$Cles$produitsStructureOrdreDescendreDe,
							i18n,
							{Dj: nom})),
						$rtfeldman$elm_css$Html$Styled$Attributes$title(
						A2(
							$author$project$I18n$Cles$produitsStructureOrdreDescendreDe,
							i18n,
							{Dj: nom}))
					]))
			]);
	});
var $author$project$I18n$Cles$produitsEtagesRoleCategorie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.etages.role-categorie', _List_Nil, 'C\'est elle qui décide de ce qu\'on saisit');
};
var $author$project$Components$Produits$StructureCatalogue$Etages$View$rang = F2(
	function (lieu, place) {
		switch (lieu) {
			case 0:
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('rang')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$String$fromInt(place))
							]))
					]);
			case 1:
				return _List_Nil;
			default:
				return _List_Nil;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Update$RenommageDEtageLibreOuvert = function (a) {
	return {$: 80, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$RenommageOuvert = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Etages$View$renommerLeNiveau = F5(
	function (i18n, lieu, inactif, nom, niveau) {
		return $author$project$Components$Produits$StructureCatalogue$Niveaux$Model$renommable(niveau) ? _List_fromArray(
			[
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('renommer'),
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						A2(
							$author$project$Components$Produits$StructureCatalogue$Etages$View$dansLe,
							lieu,
							$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$idDuBoutonRenommer(niveau.Aq))),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$StructureCatalogue$Update$RenommageOuvert(niveau.Aq)),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-label',
						A2(
							$author$project$I18n$Cles$produitsClassificationsValeurRenommerDe,
							i18n,
							{Dj: nom})),
						$rtfeldman$elm_css$Html$Styled$Attributes$title(
						A2(
							$author$project$I18n$Cles$produitsClassificationsValeurRenommerDe,
							i18n,
							{Dj: nom}))
					]),
				$author$project$I18n$Cles$produitsClassificationsValeurRenommer(i18n))
			]) : _List_Nil;
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$View$renommerLeNiveauDesigne = F5(
	function (i18n, structure, ligne, nom, designe) {
		return A2(
			$elm$core$List$concatMap,
			A4($author$project$Components$Produits$StructureCatalogue$Etages$View$renommerLeNiveau, i18n, ligne.bN, ligne.d3, nom),
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Aq;
					},
					$elm$core$Basics$eq(designe)),
				structure.C9));
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$View$renommer = F5(
	function (i18n, structure, ligne, nom, fourni) {
		var _v0 = _Utils_Tuple3(fourni.xt, ligne.bN, fourni.wL);
		_v0$3:
		while (true) {
			if (_v0.a.$ === 1) {
				if (_v0.b === 1) {
					var _v1 = _v0.b;
					return (!_Utils_eq(
						A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$renommerUnEtage, fourni.nQ),
						$elm$core$Maybe$Nothing)) ? _List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('renommer'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id(
									$author$project$Components$Produits$StructureCatalogue$Etages$Model$idDuBoutonRenommer(fourni.Aq)),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Produits$StructureCatalogue$Update$RenommageDEtageLibreOuvert(fourni.Aq)),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(ligne.d3),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									A2(
										$author$project$I18n$Cles$produitsClassificationsValeurRenommerDe,
										i18n,
										{Dj: nom})),
									$rtfeldman$elm_css$Html$Styled$Attributes$title(
									A2(
										$author$project$I18n$Cles$produitsClassificationsValeurRenommerDe,
										i18n,
										{Dj: nom}))
								]),
							$author$project$I18n$Cles$produitsClassificationsValeurRenommer(i18n))
						]) : _List_Nil;
				} else {
					break _v0$3;
				}
			} else {
				switch (_v0.b) {
					case 1:
						var _v2 = _v0.a;
						var designe = _v2.b;
						var _v3 = _v0.b;
						return A5($author$project$Components$Produits$StructureCatalogue$Etages$View$renommerLeNiveauDesigne, i18n, structure, ligne, nom, designe);
					case 0:
						if (_v0.c) {
							var _v4 = _v0.a;
							var designe = _v4.b;
							var _v5 = _v0.b;
							return A5($author$project$Components$Produits$StructureCatalogue$Etages$View$renommerLeNiveauDesigne, i18n, structure, ligne, nom, designe);
						} else {
							break _v0$3;
						}
					default:
						break _v0$3;
				}
			}
		}
		return _List_Nil;
	});
var $author$project$Components$Produits$StructureCatalogue$Update$RetraitDEtageDemande = function (a) {
	return {$: 64, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$idDuBoutonRetirer = function (id) {
	return 'etage-' + ($author$project$Catalogue$Identifiants$etageIdToString(id) + '-retirer');
};
var $author$project$Components$Produits$StructureCatalogue$Etages$View$retirer = F4(
	function (i18n, ligne, nom, fourni) {
		return (!_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerUnEtage, fourni.nQ),
			$elm$core$Maybe$Nothing)) ? _List_fromArray(
			[
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer'),
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						A2(
							$author$project$Components$Produits$StructureCatalogue$Etages$View$dansLe,
							ligne.bN,
							$author$project$Components$Produits$StructureCatalogue$Etages$Model$idDuBoutonRetirer(fourni.Aq))),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$StructureCatalogue$Update$RetraitDEtageDemande(fourni.Aq)),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(ligne.d3),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-label',
						A2(
							$author$project$I18n$Cles$produitsStructureRetirerDe,
							i18n,
							{Dj: nom})),
						$rtfeldman$elm_css$Html$Styled$Attributes$title(
						A2(
							$author$project$I18n$Cles$produitsStructureRetirerDe,
							i18n,
							{Dj: nom}))
					]),
				$author$project$I18n$Cles$produitsStructureRetirer(i18n))
			]) : _List_Nil;
	});
var $author$project$Catalogue$Vocabulaire$roleDeLArchetype = function (code) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$I18n$Traductions$tel(''),
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.bi;
			},
			A2($elm$core$Dict$get, code, $author$project$Catalogue$Vocabulaire$archetypes)));
};
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$role = F2(
	function (niveaux, etage) {
		var _v0 = etage.xt;
		if (_v0.$ === 1) {
			return $author$project$I18n$Traductions$tel('');
		} else {
			var code = _v0.a;
			var niveau = _v0.b;
			return $author$project$Catalogue$Vocabulaire$roleDeLArchetype(
				A2(
					$elm$core$Maybe$withDefault,
					A3($author$project$Components$Produits$StructureCatalogue$Etages$Model$archetypeDe, code, niveau, etage),
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.fA;
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.Aq;
									},
									$elm$core$Basics$eq(niveau)),
								niveaux)))));
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$View$etage = F4(
	function (i18n, structure, ligne, fourni) {
		var nom = A2(
			$author$project$I18n$Cles$texte,
			i18n,
			A2($author$project$Components$Produits$StructureCatalogue$Etages$Model$nom, structure.C9, fourni));
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('etage'),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'data-etage',
						$author$project$Catalogue$Identifiants$etageIdToString(fourni.Aq)),
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('decide', fourni.wL),
								_Utils_Tuple2(
								'glisse',
								_Utils_eq(
									ligne.m_,
									$elm$core$Maybe$Just(fourni.Aq)))
							]))
					]),
				A2($author$project$Components$Produits$StructureCatalogue$Etages$View$glisser, ligne, fourni)),
			_Utils_ap(
				A2($author$project$Components$Produits$StructureCatalogue$Etages$View$rang, ligne.bN, ligne.bY),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('ordre')
							]),
						ligne.bP ? A4($author$project$Components$Produits$StructureCatalogue$Etages$View$ordre, i18n, ligne, nom, fourni) : _List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(nom)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('role')
									]),
								function () {
									if (fourni.wL) {
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$produitsEtagesRoleCategorie(i18n))
											]);
									} else {
										var _v0 = A2(
											$author$project$I18n$Cles$texte,
											i18n,
											A2($author$project$Components$Produits$StructureCatalogue$Etages$Model$role, structure.C9, fourni));
										if (_v0 === '') {
											return _List_Nil;
										} else {
											var phrase = _v0;
											return _List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(phrase)
												]);
										}
									}
								}())
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
							]),
						ligne.gQ ? _List_Nil : _Utils_ap(
							A5($author$project$Components$Produits$StructureCatalogue$Etages$View$renommer, i18n, structure, ligne, nom, fourni),
							A4($author$project$Components$Produits$StructureCatalogue$Etages$View$retirer, i18n, ligne, nom, fourni)))
					])));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$ProduitRetire = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Model$idDuBoutonRetirer = function (id) {
	return 'niveau-' + ($author$project$Catalogue$Identifiants$niveauIdToString(id) + '-retirer');
};
var $author$project$Components$Produits$StructureCatalogue$Etages$View$retirerLeProduit = F4(
	function (i18n, lieu, inactif, niveau) {
		var desactivable = !_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$desactiverUnNiveau, niveau.nQ),
			$elm$core$Maybe$Nothing);
		return (_Utils_eq(niveau.fA, $author$project$Catalogue$Vocabulaire$codeProduit) && desactivable) ? _List_fromArray(
			[
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer'),
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						A2(
							$author$project$Components$Produits$StructureCatalogue$Etages$View$dansLe,
							lieu,
							$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$idDuBoutonRetirer(niveau.Aq))),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$StructureCatalogue$Update$ProduitRetire(niveau.Aq)),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-label',
						A2(
							$author$project$I18n$Cles$produitsStructureRetirerDe,
							i18n,
							{
								Dj: A2(
									$author$project$I18n$Cles$texte,
									i18n,
									$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$libelleDuNiveau(niveau))
							})),
						$rtfeldman$elm_css$Html$Styled$Attributes$title(
						A2(
							$author$project$I18n$Cles$produitsStructureRetirerDe,
							i18n,
							{
								Dj: A2(
									$author$project$I18n$Cles$texte,
									i18n,
									$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$libelleDuNiveau(niveau))
							}))
					]),
				$author$project$I18n$Cles$produitsStructureRetirer(i18n))
			]) : _List_Nil;
	});
var $author$project$Catalogue$Vocabulaire$estUneReference = function (code) {
	return code === 'reference';
};
var $author$project$I18n$Cles$produitsEtagesRoleReferenceRangement = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.etages.role-reference.rangement', _List_Nil, 'Ce qui se vend, avec son code');
};
var $author$project$Components$Produits$StructureCatalogue$Etages$View$roleDuNiveauFixe = F3(
	function (i18n, lieu, niveau) {
		return ((lieu === 1) && $author$project$Catalogue$Vocabulaire$estUneReference(niveau.fA)) ? $author$project$I18n$Cles$produitsEtagesRoleReferenceRangement(i18n) : A2(
			$author$project$I18n$Cles$texte,
			i18n,
			$author$project$Catalogue$Vocabulaire$roleDeLArchetype(niveau.fA));
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$View$niveauFixe = F6(
	function (i18n, lieu, inactif, lectureSeule, place, niveau) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('etage'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('niveau-fixe'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'data-niveau',
					$author$project$Catalogue$Identifiants$niveauIdToString(niveau.Aq))
				]),
			_Utils_ap(
				A2($author$project$Components$Produits$StructureCatalogue$Etages$View$rang, lieu, place),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('ordre')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$strong,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$texte,
											i18n,
											$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$libelleDuNiveau(niveau)))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('role')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A3($author$project$Components$Produits$StructureCatalogue$Etages$View$roleDuNiveauFixe, i18n, lieu, niveau))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
							]),
						lectureSeule ? _List_Nil : _Utils_ap(
							A5(
								$author$project$Components$Produits$StructureCatalogue$Etages$View$renommerLeNiveau,
								i18n,
								lieu,
								inactif,
								A2(
									$author$project$I18n$Cles$texte,
									i18n,
									$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$libelleDuNiveau(niveau)),
								niveau),
							A4($author$project$Components$Produits$StructureCatalogue$Etages$View$retirerLeProduit, i18n, lieu, inactif, niveau)))
					])));
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$View$nomDeTypologie = function (typologie) {
	return {
		i4: $author$project$Catalogue$Formes$article(typologie.m$),
		r3: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(typologie)
	};
};
var $author$project$I18n$Cles$produitsEtagesListe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.etages.liste',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'article',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeArticle(p.i4))),
					_Utils_Tuple2(
					'typologie',
					$author$project$I18n$Traductions$Chaine(p.r3))
				]),
			'Étages ' + function () {
				var _v0 = p.i4;
				switch (_v0) {
					case 0:
						return 'de ' + p.r3;
					case 1:
						return 'de l\'' + $elm$core$String$toLower(p.r3);
					case 2:
						return 'de la ' + $elm$core$String$toLower(p.r3);
					case 3:
						return 'du ' + $elm$core$String$toLower(p.r3);
					default:
						return 'de ' + p.r3;
				}
			}());
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$View$liste = F5(
	function (i18n, lieu, model, structure, typologie) {
		var ordonnable = (lieu === 1) && (!_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reordonnerLesEtages, typologie.nQ),
			$elm$core$Maybe$Nothing));
		var inactif = $author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model);
		var designes = A2(
			$elm$core$List$filterMap,
			function (uneEtape) {
				var _v0 = uneEtape.xt;
				if (!_v0.$) {
					var niveau = _v0.b;
					return $elm$core$Maybe$Just(niveau);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			typologie.yG);
		var fixes = A2(
			$elm$core$List$filter,
			function (niveau) {
				return niveau.Kg && (A2(
					$elm$core$List$member,
					niveau.fA,
					_List_fromArray(
						[$author$project$Catalogue$Vocabulaire$codeProduit, $author$project$Catalogue$Vocabulaire$codeReference])) && (!A2($elm$core$List$member, niveau.Aq, designes)));
			},
			structure.C9);
		var dernier = $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Basics$not,
					function ($) {
						return $.wL;
					}),
				typologie.yG)) - 1;
		return A2(
			$rtfeldman$elm_css$Html$Styled$ol,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('etages'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					A2(
						$author$project$I18n$Cles$produitsEtagesListe,
						i18n,
						$author$project$Components$Produits$StructureCatalogue$Etages$View$nomDeTypologie(typologie))),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('loading', inactif),
							_Utils_Tuple2(
							'glisse-en-cours',
							!_Utils_eq(model.cG, $elm$core$Maybe$Nothing))
						])),
					$author$project$Components$Produits$StructureCatalogue$Controles$occupe(inactif)
				]),
			_Utils_ap(
				A2(
					$elm$core$List$indexedMap,
					function (place) {
						return A3(
							$author$project$Components$Produits$StructureCatalogue$Etages$View$etage,
							i18n,
							structure,
							{
								xg: _Utils_eq(place, dernier),
								m_: model.cG,
								d3: inactif,
								gQ: $author$project$Components$Produits$StructureCatalogue$Typologies$Model$archivee(typologie),
								bN: lieu,
								bP: ordonnable,
								Ge: !place,
								bY: place + 1
							});
					},
					typologie.yG),
				A2(
					$elm$core$List$indexedMap,
					function (place) {
						return A5(
							$author$project$Components$Produits$StructureCatalogue$Etages$View$niveauFixe,
							i18n,
							lieu,
							inactif,
							$author$project$Components$Produits$StructureCatalogue$Typologies$Model$archivee(typologie),
							($elm$core$List$length(typologie.yG) + place) + 1);
					},
					fixes)));
	});
var $author$project$I18n$Cles$produitsEtagesRangementModifier = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.etages.rangement.modifier',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'article',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeArticle(p.i4))),
					_Utils_Tuple2(
					'typologie',
					$author$project$I18n$Traductions$Chaine(p.r3))
				]),
			'Modifier le rangement ' + function () {
				var _v0 = p.i4;
				switch (_v0) {
					case 0:
						return 'de ' + p.r3;
					case 1:
						return 'de l\'' + $elm$core$String$toLower(p.r3);
					case 2:
						return 'de la ' + $elm$core$String$toLower(p.r3);
					case 3:
						return 'du ' + $elm$core$String$toLower(p.r3);
					default:
						return 'de ' + p.r3;
				}
			}());
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$View$view = F4(
	function (i18n, model, structure, typologie) {
		var inactif = $author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('etages-de-typologie')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					_Utils_ap(
						_List_fromArray(
							[
								A3($author$project$Components$Produits$StructureCatalogue$Etages$View$bandeauDArchivage, i18n, inactif, typologie),
								A5($author$project$Components$Produits$StructureCatalogue$Etages$View$liste, i18n, 0, model, structure, typologie),
								A2($author$project$Components$Produits$StructureCatalogue$Etages$View$bilanDeLArchivage, i18n, typologie),
								A5($author$project$Components$Produits$StructureCatalogue$Etages$View$apercu, i18n, 0, model, structure, typologie)
							]),
						$author$project$Components$Produits$StructureCatalogue$Typologies$Model$archivee(typologie) ? _List_fromArray(
							[
								A4($author$project$Components$Produits$StructureCatalogue$Etages$View$autres, i18n, inactif, structure, typologie)
							]) : _List_fromArray(
							[
								A5($author$project$Components$Produits$StructureCatalogue$Etages$View$ajouts, i18n, 0, inactif, structure, typologie),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('rangement-de-typologie')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$button,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('rangement-de-typologie'),
												$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$StructureCatalogue$Etages$Model$idDuLienDuRangement),
												$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$StructureCatalogue$Update$RangementDeTypologieOuvert),
												$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$produitsEtagesRangementModifier,
													i18n,
													$author$project$Components$Produits$StructureCatalogue$Etages$View$nomDeTypologie(typologie)))
											]))
									])),
								A4($author$project$Components$Produits$StructureCatalogue$Etages$View$autres, i18n, inactif, structure, typologie),
								A3($author$project$Components$Produits$StructureCatalogue$Etages$View$archivage, i18n, inactif, typologie)
							])))
				]));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$ColonneRemiseATout = function (a) {
	return {$: 156, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$ValeurChoisie = F2(
	function (a, b) {
		return {$: 155, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$champDeListe = F2(
	function (libelle, liste) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$fieldset,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$legend,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(libelle)
								]))
						])),
					liste
				]));
	});
var $author$project$I18n$Cles$produitsParcoursInformationsBarreToutes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.barre.toutes', _List_Nil, 'Toutes');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Boites$texteDe = function (valeur) {
	switch (valeur.$) {
		case 0:
			var id = valeur.a;
			return $author$project$Catalogue$Identifiants$valeurIdToString(id);
		case 1:
			var id = valeur.a;
			return $author$project$Catalogue$Identifiants$elementIdToString(id);
		case 2:
			var id = valeur.a;
			return $author$project$Catalogue$Identifiants$typeDeProduitIdToString(id);
		default:
			var id = valeur.a;
			return $author$project$Catalogue$Identifiants$elementIdToString(id);
	}
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$listeDUnEtage = F2(
	function (i18n, colonne) {
		var choix = function (texte) {
			return A2(
				$elm$core$Maybe$withDefault,
				$author$project$Components$Produits$StructureCatalogue$Update$ColonneRemiseATout(colonne.bY),
				A2(
					$elm$core$Maybe$map,
					function (ligne) {
						return A2($author$project$Components$Produits$StructureCatalogue$Update$ValeurChoisie, colonne.bY, ligne.fm);
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.fm;
								},
								A2(
									$elm$core$Basics$composeR,
									$author$project$Components$Produits$StructureCatalogue$Informations$Boites$texteDe,
									$elm$core$Basics$eq(texte))),
							colonne.gV))));
		};
		var choisie = function (ligne) {
			return _Utils_eq(
				colonne.ve,
				$elm$core$Maybe$Just(ligne.fm));
		};
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Informations$View$champDeListe,
			A2($author$project$I18n$Cles$texte, i18n, colonne.Dj),
			A2(
				$rtfeldman$elm_css$Html$Styled$select,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onInput(choix),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-label',
						A2($author$project$I18n$Cles$texte, i18n, colonne.Dj))
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$option,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(''),
								$rtfeldman$elm_css$Html$Styled$Attributes$selected(
								_Utils_eq(colonne.ve, $elm$core$Maybe$Nothing))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsParcoursInformationsBarreToutes(i18n))
							])),
					A2(
						$elm$core$List$map,
						function (ligne) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$option,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value(
										$author$project$Components$Produits$StructureCatalogue$Informations$Boites$texteDe(ligne.fm)),
										$rtfeldman$elm_css$Html$Styled$Attributes$selected(
										choisie(ligne))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(ligne.Dj)
									]));
						},
						colonne.gV))));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$TypologieDuFiltre = function (a) {
	return {$: 157, a: a};
};
var $author$project$I18n$Cles$produitsParcoursInformationsBarreTypologie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.barre.typologie', _List_Nil, 'Typologie');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$listeDesTypologies = F3(
	function (i18n, structure, choisie) {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Informations$View$champDeListe,
			$author$project$I18n$Cles$produitsParcoursInformationsBarreTypologie(i18n),
			A2(
				$rtfeldman$elm_css$Html$Styled$select,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onInput(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Catalogue$Identifiants$classificationIdFromString,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$withDefault(choisie.Aq),
								$author$project$Components$Produits$StructureCatalogue$Update$TypologieDuFiltre))),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-label',
						$author$project$I18n$Cles$produitsParcoursInformationsBarreTypologie(i18n))
					]),
				A2(
					$elm$core$List$map,
					function (typologie) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$option,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(
									$author$project$Catalogue$Identifiants$classificationIdToString(typologie.Aq)),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(typologie.Aq, choisie.Aq))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(typologie))
								]));
					},
					$author$project$Components$Produits$StructureCatalogue$Typologies$Model$de(structure.vk))));
	});
var $author$project$I18n$Cles$produitsParcoursInformationsBarre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.barre', _List_Nil, 'Choisir ce qu\'on règle');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$barre = F4(
	function (i18n, structure, typologie, colonnes) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('barre'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'search'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					$author$project$I18n$Cles$produitsParcoursInformationsBarre(i18n))
				]),
			A2(
				$elm$core$List$cons,
				A3($author$project$Components$Produits$StructureCatalogue$Informations$View$listeDesTypologies, i18n, structure, typologie),
				A2(
					$elm$core$List$map,
					$author$project$Components$Produits$StructureCatalogue$Informations$View$listeDUnEtage(i18n),
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.gV;
							},
							A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)),
						colonnes))));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$NouvelleListeOuverte = {$: 148};
var $author$project$I18n$Cles$produitsParcoursInformationsListesAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.listes-ajouter', _List_Nil, 'Ajouter : Liste');
};
var $author$project$I18n$Cles$produitsParcoursInformationsListesSous = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.listes-sous', _List_Nil, 'les valeurs proposées par une information « Choix dans une liste »');
};
var $author$project$I18n$Cles$produitsParcoursInformationsListesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.listes-titre', _List_Nil, 'Listes de choix');
};
var $author$project$I18n$Cles$produitsParcoursInformationsListesUneValeur = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.listes-une-valeur', _List_Nil, '1 valeur');
};
var $author$project$I18n$Cles$produitsParcoursInformationsListesValeurs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.parcours.informations.listes-valeurs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			p.w + ' valeurs');
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$boiteDesListes = F2(
	function (i18n, model) {
		var _v0 = model.BX;
		if (!_v0.$) {
			var listes = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('boites')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('boite'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('listes')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$h3,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$produitsParcoursInformationsListesTitre(i18n))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('sous')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$produitsParcoursInformationsListesSous(i18n))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('contenu')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$ul,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('informations')
											]),
										A2(
											$elm$core$List$map,
											function (liste) {
												return A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('information'),
															$rtfeldman$elm_css$Html$Styled$Attributes$class('liste-de-choix')
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$a,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$class('liste'),
																	$rtfeldman$elm_css$Html$Styled$Attributes$href(
																	$author$project$Routes$Route$adresseDeLaListe(liste.Aq))
																]),
															_List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$span,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
																		]),
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text(liste.Dj)
																		])),
																	A2(
																	$rtfeldman$elm_css$Html$Styled$span,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class('valeurs')
																		]),
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text(
																			(liste.Ki === 1) ? $author$project$I18n$Cles$produitsParcoursInformationsListesUneValeur(i18n) : A2(
																				$author$project$I18n$Cles$produitsParcoursInformationsListesValeurs,
																				i18n,
																				{
																					w: $elm$core$String$fromInt(liste.Ki)
																				}))
																		]))
																]))
														]));
											},
											listes)),
										function () {
										var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerUneListe, model.nS);
										if (!_v1.$) {
											return A2(
												$rtfeldman$elm_css$Html$Styled$button,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
														$rtfeldman$elm_css$Html$Styled$Attributes$class('ajouter'),
														$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$StructureCatalogue$Update$NouvelleListeOuverte)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$I18n$Cles$produitsParcoursInformationsListesAjouter(i18n))
													]));
										} else {
											return $rtfeldman$elm_css$Html$Styled$text('');
										}
									}()
									]))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$avecSonLienDAjout = F2(
	function (informations, portee) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$always(portee),
			A2(
				$author$project$Components$Produits$StructureCatalogue$Informations$Model$lienDeCreation,
				portee,
				$elm$core$Maybe$Just(informations)));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$idDuBoutonAjouter = function (portee) {
	return A2($author$project$Components$Produits$StructureCatalogue$Informations$Model$idDeLaPastille, portee, 'ajouter');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Boites$porteeDe = F2(
	function (typologie, boite) {
		switch (boite.$) {
			case 0:
				return $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$Catalogue;
			case 1:
				return $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$Typologie(typologie);
			default:
				var valeur = boite.a.fm;
				if (valeur.$ === 2) {
					var type_ = valeur.a;
					return $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$Categorie(type_);
				} else {
					return A2(
						$author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$Noeud,
						typologie,
						$author$project$Components$Produits$StructureCatalogue$Informations$Boites$texteDe(valeur));
				}
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$porteeDeLaBoite = F2(
	function (typologie, laboite) {
		var _v0 = _Utils_Tuple2(laboite, typologie);
		_v0$0:
		while (true) {
			if (!_v0.b.$) {
				if (!_v0.a.$) {
					break _v0$0;
				} else {
					var id = _v0.b.a;
					return $elm$core$Maybe$Just(
						A2($author$project$Components$Produits$StructureCatalogue$Informations$Boites$porteeDe, id, laboite));
				}
			} else {
				if (!_v0.a.$) {
					break _v0$0;
				} else {
					var _v2 = _v0.b;
					return $elm$core$Maybe$Nothing;
				}
			}
		}
		var _v1 = _v0.a;
		return $elm$core$Maybe$Just($author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$Catalogue);
	});
var $author$project$I18n$Cles$produitsParcoursInformationsAjouter = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.ajouter', _List_Nil, 'Ajouter');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$ajouter = F4(
	function (i18n, informations, typologie, laboite) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			$author$project$Components$Produits$StructureCatalogue$Informations$View$avecSonLienDAjout(informations),
			A2($author$project$Components$Produits$StructureCatalogue$Informations$View$porteeDeLaBoite, typologie, laboite));
		if (!_v0.$) {
			var portee = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ajouter'),
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						$author$project$Components$Produits$StructureCatalogue$Informations$Model$idDuBoutonAjouter(portee)),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$StructureCatalogue$Update$AjoutDInformationOuvert(portee))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsParcoursInformationsAjouter(i18n))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$jusqua = F2(
	function (cible, choisies) {
		if (!choisies.b) {
			return _List_Nil;
		} else {
			var _v1 = choisies.a;
			var valeur = _v1.a;
			var nom = _v1.b;
			var suite = choisies.b;
			return _Utils_eq(valeur, cible) ? _List_fromArray(
				[nom]) : A2(
				$elm$core$List$cons,
				nom,
				A2($author$project$Components$Produits$StructureCatalogue$Informations$View$jusqua, cible, suite));
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$chemin = F2(
	function (colonnes, cible) {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Informations$View$jusqua,
			cible,
			A2(
				$elm$core$List$filterMap,
				function (colonne) {
					return A2(
						$elm$core$Maybe$andThen,
						function (choisie) {
							return A2(
								$elm$core$Maybe$map,
								function (ligne) {
									return _Utils_Tuple2(choisie, ligne.Dj);
								},
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.fm;
											},
											$elm$core$Basics$eq(choisie)),
										colonne.gV)));
						},
						colonne.ve);
				},
				colonnes));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$estUneCategorie = function (valeur) {
	if (valeur.$ === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$I18n$Cles$produitsParcoursInformationsBoiteCatalogueSous = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.boite.catalogue.sous', _List_Nil, 'quelle que soit la typologie');
};
var $author$project$I18n$Cles$produitsParcoursInformationsBoiteCatalogueTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.boite.catalogue.titre', _List_Nil, 'Pour toutes les références');
};
var $author$project$I18n$Cles$produitsParcoursInformationsBoiteNoeudSeulement = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.parcours.informations.boite.noeud.seulement',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'« ' + (p.Dj + ' » · seulement'));
	});
var $author$project$I18n$Cles$produitsParcoursInformationsBoiteNoeudTout = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.parcours.informations.boite.noeud.tout',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'« ' + (p.Dj + ' » · tout ce qui est rangé dessous'));
	});
var $author$project$I18n$Cles$produitsParcoursInformationsBoiteTypologieSous = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.boite.typologie.sous', _List_Nil, 'en plus des précédentes');
};
var $author$project$I18n$Cles$produitsParcoursInformationsBoiteTypologieTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.parcours.informations.boite.typologie.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'« ' + (p.Dj + ' » · tout ce qui est rangé dessous'));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$entete = F4(
	function (i18n, typologie, colonnes, laboite) {
		switch (laboite.$) {
			case 0:
				return _Utils_Tuple3(
					'catalogue',
					$author$project$I18n$Cles$produitsParcoursInformationsBoiteCatalogueTitre(i18n),
					$author$project$I18n$Cles$produitsParcoursInformationsBoiteCatalogueSous(i18n));
			case 1:
				return _Utils_Tuple3(
					'typologie',
					A2(
						$author$project$I18n$Cles$produitsParcoursInformationsBoiteTypologieTitre,
						i18n,
						{Dj: typologie}),
					$author$project$I18n$Cles$produitsParcoursInformationsBoiteTypologieSous(i18n));
			default:
				var noeud = laboite.a;
				var dernier = $author$project$Components$Produits$StructureCatalogue$Informations$View$estUneCategorie(noeud.fm) || _Utils_eq(
					$elm$core$Maybe$Just(noeud.md),
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.Dj;
						},
						$elm$core$List$head(
							$elm$core$List$reverse(colonnes))));
				var titre = dernier ? A2(
					$author$project$I18n$Cles$produitsParcoursInformationsBoiteNoeudSeulement,
					i18n,
					{Dj: noeud.Dj}) : A2(
					$author$project$I18n$Cles$produitsParcoursInformationsBoiteNoeudTout,
					i18n,
					{Dj: noeud.Dj});
				return _Utils_Tuple3(
					'noeud',
					titre,
					A2(
						$elm$core$String$join,
						' › ',
						A2(
							$elm$core$List$cons,
							typologie,
							A2($author$project$Components$Produits$StructureCatalogue$Informations$View$chemin, colonnes, noeud.fm))));
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$DesEtats = {$: 1};
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$DesNatures = {$: 2};
var $author$project$Components$Produits$StructureCatalogue$Informations$Boites$DuCatalogue = {$: 0};
var $author$project$Components$Produits$StructureCatalogue$Update$ConsultationOuverte = function (a) {
	return {$: 95, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$pastilleDeConsultation = F3(
	function (classe, consultation, libelle) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class(classe)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(
							$author$project$Components$Produits$StructureCatalogue$Informations$Model$idDeLaPastilleDeConsultation(consultation)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Produits$StructureCatalogue$Update$ConsultationOuverte(consultation))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('›')
								]))
						]))
				]));
	});
var $author$project$I18n$Cles$produitsParcoursInformationsEtat = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.etat', _List_Nil, 'État');
};
var $author$project$I18n$Cles$produitsParcoursInformationsNature = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.nature', _List_Nil, 'Nature');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$etat = F2(
	function (i18n, laboite) {
		return _Utils_eq(laboite, $author$project$Components$Produits$StructureCatalogue$Informations$Boites$DuCatalogue) ? _List_fromArray(
			[
				A3(
				$author$project$Components$Produits$StructureCatalogue$Informations$View$pastilleDeConsultation,
				'pastille-etat',
				$author$project$Components$Produits$StructureCatalogue$Informations$Model$DesEtats,
				$author$project$I18n$Cles$produitsParcoursInformationsEtat(i18n)),
				A3(
				$author$project$Components$Produits$StructureCatalogue$Informations$View$pastilleDeConsultation,
				'pastille-nature',
				$author$project$Components$Produits$StructureCatalogue$Informations$Model$DesNatures,
				$author$project$I18n$Cles$produitsParcoursInformationsNature(i18n))
			]) : _List_Nil;
	});
var $author$project$I18n$Cles$produitsInformationsEtageKicker = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.informations.etage.kicker',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md))
				]),
			'Étage ' + p.md);
	});
var $author$project$I18n$Cles$produitsInformationsEtageKickerSous = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.informations.etage.kicker-sous',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md)),
					_Utils_Tuple2(
					'parent',
					$author$project$I18n$Traductions$Chaine(p.ey))
				]),
			'Étage ' + (p.md + (' · sous ' + p.ey)));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Boites$kickerDe = F4(
	function (i18n, typologie, boites, laboite) {
		switch (laboite.$) {
			case 0:
				return $elm$core$Maybe$Nothing;
			case 1:
				return $elm$core$Maybe$Just(
					A2(
						$author$project$I18n$Cles$produitsInformationsEtageKicker,
						i18n,
						{md: typologie}));
			default:
				var noeud = laboite.a;
				return function (sous) {
					return _Utils_eq(sous, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
						A2(
							$author$project$I18n$Cles$produitsInformationsEtageKicker,
							i18n,
							{
								md: A2($author$project$I18n$Cles$texte, i18n, noeud.md)
							})) : sous;
				}(
					A2(
						$elm$core$Maybe$andThen,
						function (precedente) {
							switch (precedente.$) {
								case 2:
									var parent = precedente.a;
									return $elm$core$Maybe$Just(
										A2(
											$author$project$I18n$Cles$produitsInformationsEtageKickerSous,
											i18n,
											{
												md: A2($author$project$I18n$Cles$texte, i18n, noeud.md),
												ey: parent.Dj
											}));
								case 1:
									return $elm$core$Maybe$Just(
										A2(
											$author$project$I18n$Cles$produitsInformationsEtageKickerSous,
											i18n,
											{
												md: A2($author$project$I18n$Cles$texte, i18n, noeud.md),
												ey: typologie
											}));
								default:
									return $elm$core$Maybe$Nothing;
							}
						},
						A3(
							$elm$core$List$foldl,
							F2(
								function (suivante, _v1) {
									var precedente = _v1.a;
									var trouvee = _v1.b;
									return _Utils_eq(suivante, laboite) ? _Utils_Tuple2(precedente, true) : (trouvee ? _Utils_Tuple2(precedente, trouvee) : _Utils_Tuple2(
										$elm$core$Maybe$Just(suivante),
										trouvee));
								}),
							_Utils_Tuple2($elm$core$Maybe$Nothing, false),
							boites).a));
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$DesMasquees = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$I18n$Cles$produitsParcoursInformationsMasqueesBouton = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.parcours.informations.masquees.bouton',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' information masquée') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' informations masquées'));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$masquees = F4(
	function (i18n, portee, titre, champs) {
		var _v0 = _Utils_Tuple2(
			portee,
			A2(
				$elm$core$List$filter,
				function ($) {
					return $.n4;
				},
				champs));
		if ((!_v0.a.$) && _v0.b.b) {
			var visee = _v0.a.a;
			var cachees = _v0.b;
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('masquees')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('masquees'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id(
									$author$project$Components$Produits$StructureCatalogue$Informations$Model$idDeLaPastilleDeConsultation(
										A2($author$project$Components$Produits$StructureCatalogue$Informations$Model$DesMasquees, visee, titre))),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Produits$StructureCatalogue$Update$ConsultationOuverte(
										A2($author$project$Components$Produits$StructureCatalogue$Informations$Model$DesMasquees, visee, titre)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$produitsParcoursInformationsMasqueesBouton,
										i18n,
										{
											w: $elm$core$List$length(cachees)
										}))
								]))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Update$EtageOuvert = F3(
	function (a, b, c) {
		return {$: 98, a: a, b: b, c: c};
	});
var $author$project$I18n$Cles$produitsInformationsEtageModifierNom = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.informations.etage.modifier-nom',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Modifier les articles liés à ' + p.Dj);
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$modifierLEtage = F6(
	function (i18n, typologie, kicker, laboite, portee, champs) {
		var unLien = function (champ) {
			var _v2 = champ.uN.r0;
			if (_v2.$ === 18) {
				return true;
			} else {
				return false;
			}
		};
		var nomDeLEtage = function () {
			switch (laboite.$) {
				case 0:
					return '';
				case 1:
					return typologie;
				default:
					var noeud = laboite.a;
					return noeud.Dj;
			}
		}();
		var _v0 = _Utils_Tuple2(portee, nomDeLEtage);
		if (!_v0.a.$) {
			var visee = _v0.a.a;
			var nom = _v0.b;
			return ((nom !== '') && A2($elm$core$List$any, unLien, champs)) ? A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('modifier-etage'),
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						$author$project$Components$Produits$StructureCatalogue$Informations$Etage$idDuBoutonModifier(visee)),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						A3($author$project$Components$Produits$StructureCatalogue$Update$EtageOuvert, visee, nom, kicker)),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-label',
						A2(
							$author$project$I18n$Cles$produitsInformationsEtageModifierNom,
							i18n,
							{Dj: nom})),
						$rtfeldman$elm_css$Html$Styled$Attributes$title(
						A2(
							$author$project$I18n$Cles$produitsInformationsEtageModifierNom,
							i18n,
							{Dj: nom}))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsInformationsEtageModifier(i18n))
					])) : $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$produitsParcoursInformationsOuvrirLaFiche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.ouvrir-la-fiche', _List_Nil, 'Ouvrir la fiche');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$ouvrirLaFiche = F2(
	function (i18n, laboite) {
		if (laboite.$ === 2) {
			var valeur = laboite.a.fm;
			if (valeur.$ === 2) {
				var typeId = valeur.a;
				return A3(
					$author$project$Components$Shared$Bouton$View$lien,
					1,
					$author$project$Routes$Route$toString(
						$author$project$Routes$Route$FicheType(typeId)),
					$author$project$I18n$Cles$produitsParcoursInformationsOuvrirLaFiche(i18n));
			} else {
				return $rtfeldman$elm_css$Html$Styled$text('');
			}
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$pastille = F2(
	function (portee, lu) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('information')
				]),
			_List_fromArray(
				[
					function () {
					if (!portee.$) {
						var visee = portee.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id(
									A2($author$project$Components$Produits$StructureCatalogue$Informations$Model$idDeLaPastille, visee, lu.uN.dy)),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									A2($author$project$Components$Produits$StructureCatalogue$Update$InformationOuverte, visee, lu.uN.dy)),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(lu.uN.Bl)
								]));
					} else {
						return A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(lu.uN.Bl)
								]));
					}
				}()
				]));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Boites$repond = F3(
	function (typologie, boite, portee) {
		var _v0 = _Utils_Tuple2(boite, portee);
		_v0$4:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (!_v0.b.$) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return true;
					} else {
						break _v0$4;
					}
				case 1:
					if (_v0.b.$ === 1) {
						var _v3 = _v0.a;
						var classification = _v0.b.a;
						return _Utils_eq(classification, typologie);
					} else {
						break _v0$4;
					}
				default:
					switch (_v0.b.$) {
						case 2:
							var noeud = _v0.a.a;
							var _v4 = _v0.b;
							var classification = _v4.a;
							var valeur = _v4.b;
							return _Utils_eq(classification, typologie) && _Utils_eq(
								valeur,
								$author$project$Components$Produits$StructureCatalogue$Informations$Boites$texteDe(noeud.fm));
						case 3:
							var valeur = _v0.a.a.fm;
							var type_ = _v0.b.a;
							return _Utils_eq(
								valeur,
								$author$project$Catalogue$API$QueryAPIModel$ValeurCategorie(type_));
						default:
							break _v0$4;
					}
			}
		}
		return false;
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Boites$porteurDe = F3(
	function (typologie, lues, boite) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.F$;
					},
					A2($author$project$Components$Produits$StructureCatalogue$Informations$Boites$repond, typologie, boite)),
				lues.F3));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Boites$porteurDuCatalogue = function (lues) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.F$;
				},
				$elm$core$Basics$eq($author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$Catalogue)),
			lues.F3));
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$avecSonLienDeRattachement = F2(
	function (informations, portee) {
		return A2(
			$elm$core$Maybe$map,
			function (_v0) {
				return portee;
			},
			A2(
				$author$project$Components$Produits$StructureCatalogue$Informations$Model$lienDeRattachement,
				portee,
				$elm$core$Maybe$Just(informations)));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$rattacher = F4(
	function (i18n, informations, typologie, laboite) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			$author$project$Components$Produits$StructureCatalogue$Informations$View$avecSonLienDeRattachement(informations),
			A2($author$project$Components$Produits$StructureCatalogue$Informations$View$porteeDeLaBoite, typologie, laboite));
		if (!_v0.$) {
			var portee = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('rattacher'),
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						$author$project$Components$Produits$StructureCatalogue$Informations$Model$idDuBoutonRattacher(portee)),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$StructureCatalogue$Update$RattachementDInformationOuvert(portee))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsInformationsRattacherBouton(i18n))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$produitsParcoursInformationsBoiteVide = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.parcours.informations.boite.vide',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Aucune information pour « ' + (p.Dj + ' ».'));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$vide = F3(
	function (i18n, laboite, champs) {
		var _v0 = _Utils_Tuple2(laboite, champs);
		if ((_v0.a.$ === 2) && (!_v0.b.b)) {
			var noeud = _v0.a.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('vide')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$produitsParcoursInformationsBoiteVide,
							i18n,
							{Dj: noeud.Dj}))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$boite = F6(
	function (i18n, typologie, colonnes, informations, lesBoites, laboite) {
		var porteur = function () {
			var _v1 = _Utils_Tuple2(laboite, typologie);
			_v1$0:
			while (true) {
				if (!_v1.b.$) {
					if (!_v1.a.$) {
						break _v1$0;
					} else {
						var lue = _v1.b.a;
						return A3($author$project$Components$Produits$StructureCatalogue$Informations$Boites$porteurDe, lue.Aq, informations, laboite);
					}
				} else {
					if (!_v1.a.$) {
						break _v1$0;
					} else {
						var _v3 = _v1.b;
						return $elm$core$Maybe$Nothing;
					}
				}
			}
			var _v2 = _v1.a;
			return $author$project$Components$Produits$StructureCatalogue$Informations$Boites$porteurDuCatalogue(informations);
		}();
		var portee = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.F$;
			},
			porteur);
		var nom = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Maybe$map, $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom, typologie));
		var champs = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.dw;
				},
				porteur));
		var _v0 = A4($author$project$Components$Produits$StructureCatalogue$Informations$View$entete, i18n, nom, colonnes, laboite);
		var classe = _v0.a;
		var titre = _v0.b;
		var sous = _v0.c;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('boite'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(classe)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(titre)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('sous')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(sous)
								])),
							A6(
							$author$project$Components$Produits$StructureCatalogue$Informations$View$modifierLEtage,
							i18n,
							nom,
							A4($author$project$Components$Produits$StructureCatalogue$Informations$Boites$kickerDe, i18n, nom, lesBoites, laboite),
							laboite,
							portee,
							champs),
							A2($author$project$Components$Produits$StructureCatalogue$Informations$View$ouvrirLaFiche, i18n, laboite)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('contenu')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('informations')
								]),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									$author$project$Components$Produits$StructureCatalogue$Informations$View$pastille(portee),
									A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeL,
											$elm$core$Basics$not,
											function ($) {
												return $.n4;
											}),
										champs)),
								_Utils_ap(
									A4($author$project$Components$Produits$StructureCatalogue$Informations$View$masquees, i18n, portee, titre, champs),
									A2($author$project$Components$Produits$StructureCatalogue$Informations$View$etat, i18n, laboite)))),
							A3($author$project$Components$Produits$StructureCatalogue$Informations$View$vide, i18n, laboite, champs),
							A4(
							$author$project$Components$Produits$StructureCatalogue$Informations$View$ajouter,
							i18n,
							informations,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.Aq;
								},
								typologie),
							laboite),
							A4(
							$author$project$Components$Produits$StructureCatalogue$Informations$View$rattacher,
							i18n,
							informations,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.Aq;
								},
								typologie),
							laboite)
						]))
				]));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Boites$DeLaTypologie = {$: 1};
var $author$project$Components$Produits$StructureCatalogue$Informations$Boites$DUnNoeud = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Boites$noeuds = function (colonnes) {
	noeuds:
	while (true) {
		if (!colonnes.b) {
			return _List_Nil;
		} else {
			var colonne = colonnes.a;
			var suivantes = colonnes.b;
			var _v1 = colonne.ve;
			if (_v1.$ === 1) {
				var $temp$colonnes = suivantes;
				colonnes = $temp$colonnes;
				continue noeuds;
			} else {
				var valeur = _v1.a;
				var nom = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Dj;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.fm;
								},
								$elm$core$Basics$eq(valeur)),
							colonne.gV)));
				if (nom.$ === 1) {
					return _List_Nil;
				} else {
					var lu = nom.a;
					return A2(
						$elm$core$List$cons,
						$author$project$Components$Produits$StructureCatalogue$Informations$Boites$DUnNoeud(
							{md: colonne.Dj, Dj: lu, fm: valeur}),
						$author$project$Components$Produits$StructureCatalogue$Informations$Boites$noeuds(suivantes));
				}
			}
		}
	}
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Boites$boitesDe = function (colonnes) {
	return A2(
		$elm$core$List$cons,
		$author$project$Components$Produits$StructureCatalogue$Informations$Boites$DuCatalogue,
		A2(
			$elm$core$List$cons,
			$author$project$Components$Produits$StructureCatalogue$Informations$Boites$DeLaTypologie,
			$author$project$Components$Produits$StructureCatalogue$Informations$Boites$noeuds(colonnes)));
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$keepSansTypologie = F2(
	function (typologie, liste) {
		return _Utils_eq(typologie, $elm$core$Maybe$Nothing) ? A2($elm$core$List$take, 1, liste) : liste;
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$boites = F4(
	function (i18n, typologie, colonnes, lues) {
		if (lues.$ === 1) {
			return _List_Nil;
		} else {
			var informations = lues.a;
			return $elm$core$List$singleton(
				A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('boites')
						]),
					function () {
						var lesBoites = A2(
							$author$project$Components$Produits$StructureCatalogue$Informations$View$keepSansTypologie,
							typologie,
							$author$project$Components$Produits$StructureCatalogue$Informations$Boites$boitesDe(colonnes));
						return A2(
							$elm$core$List$map,
							A5($author$project$Components$Produits$StructureCatalogue$Informations$View$boite, i18n, typologie, colonnes, informations, lesBoites),
							lesBoites);
					}()));
		}
	});
var $author$project$I18n$Cles$produitsParcoursInformationsHistorique = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.parcours.informations.historique',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Historique des versions de « ' + (p.Dj + ' »'));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$historiqueDesVersions = F3(
	function (i18n, model, colonnes) {
		var types = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ib;
				},
				model.dt.aS));
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (choisi) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(choisi)),
						types));
			},
			$elm$core$List$head(
				$elm$core$List$reverse(
					$author$project$Components$Produits$StructureCatalogue$Informations$Boites$categoriesChoisies(colonnes))));
		if (!_v0.$) {
			var type_ = _v0.a;
			var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$versionsDuSchema, type_.nQ);
			if (!_v1.$) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('historique-des-versions'),
							$rtfeldman$elm_css$Html$Styled$Attributes$href(
							$author$project$Routes$Route$toString(
								$author$project$Routes$Route$FicheType(type_.Aq)))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$produitsParcoursInformationsHistorique,
								i18n,
								{Dj: type_.Dj.zX}))
						]));
			} else {
				return $rtfeldman$elm_css$Html$Styled$text('');
			}
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$produitsParcoursInformationsNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.note', _List_Nil, 'Cliquez une information pour la modifier ou la masquer, « État › » pour le cycle de vie, « Nature › » pour les natures d\'article, une liste pour ses valeurs. Les informations « Pour la fiche d\'une marque » se remplissent sur la fiche de chaque marque.');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$note = function (i18n) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$p,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$I18n$Cles$produitsParcoursInformationsNote(i18n))
			]));
};
var $author$project$I18n$Cles$produitsParcoursInformationsSansTypologie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.sans-typologie', _List_Nil, 'Vous n\'avez pas encore de typologie : seules les informations valables pour toutes les références se posent ici. Créez d\'abord une typologie à l\'étape 1 pour poser des informations propres à une famille ou une catégorie.');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$view = F3(
	function (i18n, model, structure) {
		var _v0 = A2($author$project$Components$Produits$StructureCatalogue$Typologies$Model$reglee, model.r6, structure.vk);
		if (!_v0.$) {
			var typologie = _v0.a;
			var colonnes = A3($author$project$Components$Produits$StructureCatalogue$Valeurs$Lecture$colonnes, model, structure, typologie);
			return A2(
				$elm$core$List$cons,
				A4($author$project$Components$Produits$StructureCatalogue$Informations$View$barre, i18n, structure, typologie, colonnes),
				_Utils_ap(
					A4(
						$author$project$Components$Produits$StructureCatalogue$Informations$View$boites,
						i18n,
						$elm$core$Maybe$Just(typologie),
						colonnes,
						model.AM),
					_List_fromArray(
						[
							A3($author$project$Components$Produits$StructureCatalogue$Informations$View$historiqueDesVersions, i18n, model, colonnes),
							A2($author$project$Components$Produits$StructureCatalogue$Informations$View$boiteDesListes, i18n, model),
							$author$project$Components$Produits$StructureCatalogue$Informations$View$note(i18n)
						])));
		} else {
			return _Utils_ap(
				A4($author$project$Components$Produits$StructureCatalogue$Informations$View$boites, i18n, $elm$core$Maybe$Nothing, _List_Nil, model.AM),
				_List_fromArray(
					[
						A2($author$project$Components$Produits$StructureCatalogue$Informations$View$boiteDesListes, i18n, model),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('sans-typologie')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsParcoursInformationsSansTypologie(i18n))
							])),
						$author$project$Components$Produits$StructureCatalogue$Informations$View$note(i18n)
					]));
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Update$AjoutDeTypologieOuvert = {$: 36};
var $author$project$I18n$Cles$produitsParcoursTypologiesTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.typologies.titre', _List_Nil, 'Vos typologies');
};
var $author$project$I18n$Cles$produitsTypologiesConseil = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.conseil', _List_Nil, 'Une seule typologie suffit si tous vos produits se décrivent pareil.');
};
var $author$project$Components$Produits$StructureCatalogue$Typologies$View$boutonRenommer = F3(
	function (i18n, inactif, fournie) {
		return (!_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$renommerUneClassification, fournie.nQ),
			$elm$core$Maybe$Nothing)) ? _List_fromArray(
			[
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('renommer'),
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						$author$project$Components$Produits$StructureCatalogue$Typologies$Model$idDuBoutonRenommer(fournie.Aq)),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$StructureCatalogue$Update$RenommageDeTypologieOuvert(fournie.Aq)),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-label',
						A2(
							$author$project$I18n$Cles$produitsClassificationsValeurRenommerDe,
							i18n,
							{
								Dj: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(fournie)
							})),
						$rtfeldman$elm_css$Html$Styled$Attributes$title(
						A2(
							$author$project$I18n$Cles$produitsClassificationsValeurRenommerDe,
							i18n,
							{
								Dj: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(fournie)
							}))
					]),
				$author$project$I18n$Cles$produitsClassificationsValeurRenommer(i18n))
			]) : _List_Nil;
	});
var $author$project$Components$Produits$StructureCatalogue$Update$RetraitDeTypologieOuvert = function (a) {
	return {$: 43, a: a};
};
var $author$project$I18n$Cles$produitsTypologiesRetirer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.retirer', _List_Nil, 'Retirer');
};
var $author$project$I18n$Cles$produitsTypologiesRetirerDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.typologies.retirer.de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Retirer ' + p.Dj);
	});
var $author$project$Components$Produits$StructureCatalogue$Typologies$View$boutonRetirer = F3(
	function (i18n, inactif, fournie) {
		return (!_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerUneTypologie, fournie.nQ),
			$elm$core$Maybe$Nothing)) ? _List_fromArray(
			[
				A3(
				$author$project$Components$Shared$Bouton$View$bouton,
				1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('retirer'),
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						$author$project$Components$Produits$StructureCatalogue$Typologies$Model$idDuBoutonRetirer(fournie.Aq)),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$StructureCatalogue$Update$RetraitDeTypologieOuvert(fournie.Aq)),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-label',
						A2(
							$author$project$I18n$Cles$produitsTypologiesRetirerDe,
							i18n,
							{
								Dj: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(fournie)
							})),
						$rtfeldman$elm_css$Html$Styled$Attributes$title(
						A2(
							$author$project$I18n$Cles$produitsTypologiesRetirerDe,
							i18n,
							{
								Dj: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(fournie)
							}))
					]),
				$author$project$I18n$Cles$produitsTypologiesRetirer(i18n))
			]) : _List_Nil;
	});
var $author$project$I18n$Cles$produitsTypologiesArchivee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archivee', _List_Nil, 'Archivée');
};
var $author$project$Components$Produits$StructureCatalogue$Typologies$View$typologie = F3(
	function (i18n, inactif, fournie) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('typologie'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'data-typologie',
					$author$project$Catalogue$Identifiants$classificationIdToString(fournie.Aq)),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('en-double', fournie.gi),
							_Utils_Tuple2(
							'archivee',
							$author$project$Components$Produits$StructureCatalogue$Typologies$Model$archivee(fournie))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(fournie))
								])),
						_Utils_ap(
							fournie.gi ? _List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Tag$View$view,
									1,
									$author$project$I18n$Cles$produitsCatalogueEnDouble(i18n))
								]) : _List_Nil,
							$author$project$Components$Produits$StructureCatalogue$Typologies$Model$archivee(fournie) ? _List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Tag$View$view,
									3,
									$author$project$I18n$Cles$produitsTypologiesArchivee(i18n))
								]) : _List_Nil))),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
						]),
					_Utils_ap(
						A3($author$project$Components$Produits$StructureCatalogue$Typologies$View$boutonRenommer, i18n, inactif, fournie),
						A3($author$project$Components$Produits$StructureCatalogue$Typologies$View$boutonRetirer, i18n, inactif, fournie)))
				]));
	});
var $author$project$Components$Produits$StructureCatalogue$Typologies$View$view = F3(
	function (i18n, model, structure) {
		var inactif = $author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('typologies')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('typologies'),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									$author$project$I18n$Cles$produitsParcoursTypologiesTitre(i18n)),
									$rtfeldman$elm_css$Html$Styled$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('loading', inactif)
										])),
									$author$project$Components$Produits$StructureCatalogue$Controles$occupe(inactif)
								]),
							A2(
								$elm$core$List$map,
								A2($author$project$Components$Produits$StructureCatalogue$Typologies$View$typologie, i18n, inactif),
								$author$project$Components$Produits$StructureCatalogue$Typologies$Model$de(structure.vk))),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('ajouter')
								]),
							(!_Utils_eq(
								A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$ajouterUneClassification, structure.nQ),
								$elm$core$Maybe$Nothing)) ? _List_fromArray(
								[
									A3(
									$author$project$Components$Shared$Bouton$View$bouton,
									1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$StructureCatalogue$Typologies$Model$idDuBoutonAjouter),
											$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$StructureCatalogue$Update$AjoutDeTypologieOuvert),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif)
										]),
									$author$project$I18n$Cles$produitsTypologiesAjouter(i18n))
								]) : _List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsTypologiesConseil(i18n))
								]))
						]))
				]));
	});
var $author$project$Components$Produits$StructureCatalogue$Categories$Update$CategorieOuverte = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$idDeLaCategorie = function (id) {
	return 'valeurs-categorie-' + $author$project$Catalogue$Identifiants$typeDeProduitIdToString(id);
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$boutonDeCategorie = F3(
	function (typologie, attributs, categorie) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$id(
						$author$project$Components$Produits$StructureCatalogue$Valeurs$View$idDeLaCategorie(categorie.Aq)),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Components$Produits$StructureCatalogue$Update$DesCategories(
							$author$project$Components$Produits$StructureCatalogue$Categories$Update$CategorieOuverte(
								{
									uK: categorie.Aq,
									xe: $author$project$Components$Produits$StructureCatalogue$Valeurs$View$idDeLaCategorie(categorie.Aq),
									r3: typologie
								})))
					]),
				attributs),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(categorie.Dj)
						]))
				]));
	});
var $author$project$I18n$Cles$produitsValeursARangerExplication = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.a-ranger.explication',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md))
				]),
			'Ces catégories n\'ont pas encore de ' + (p.md + '.'));
	});
var $author$project$I18n$Cles$produitsValeursARangerExplicationVoyelle = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.a-ranger.explication.voyelle',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md))
				]),
			'Ces catégories n\'ont pas encore d\'' + (p.md + '.'));
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$voyelles = _List_fromArray(
	['a', 'e', 'i', 'o', 'u', 'y', 'à', 'â', 'é', 'è', 'ê', 'ë', 'î', 'ï', 'ô', 'ö', 'ù', 'û', 'ü', 'h']);
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$explicationDesCategories = F3(
	function (i18n, model, typologie) {
		var niveaux = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.C9;
				},
				model.h$));
		var dessus = A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$Produits$StructureCatalogue$Etages$Model$nom(niveaux),
				A2(
					$elm$core$Basics$composeR,
					$author$project$I18n$Cles$texte(i18n),
					$elm$core$String$toLower)),
			$elm$core$List$head(
				$elm$core$List$reverse(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeL,
							$elm$core$Basics$not,
							function ($) {
								return $.wL;
							}),
						typologie.yG))));
		if (!dessus.$) {
			var etage = dessus.a;
			return A2(
				$elm$core$String$any,
				function (lettre) {
					return A2($elm$core$List$member, lettre, $author$project$Components$Produits$StructureCatalogue$Valeurs$View$voyelles);
				},
				A2($elm$core$String$left, 1, etage)) ? A2(
				$author$project$I18n$Cles$produitsValeursARangerExplicationVoyelle,
				i18n,
				{md: etage}) : A2(
				$author$project$I18n$Cles$produitsValeursARangerExplication,
				i18n,
				{md: etage});
		} else {
			return '';
		}
	});
var $author$project$I18n$Cles$produitsValeursARanger = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.a-ranger', _List_Nil, 'À ranger :');
};
var $author$project$I18n$Cles$produitsValeursARangerExplicationValeurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.a-ranger.explication.valeurs', _List_Nil, 'Ces valeurs n\'ont pas encore de place : cochez-les sous la valeur qui les range, par « Modifier ».');
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$aRanger = F3(
	function (i18n, model, typologie) {
		var lignes = A2(
			$author$project$Components$Produits$StructureCatalogue$Valeurs$Model$aRanger,
			$author$project$Components$Produits$StructureCatalogue$Valeurs$Lecture$noms(model),
			typologie);
		var categories = A2(
			$elm$core$List$all,
			function (ligne) {
				var _v1 = ligne.fm;
				if (_v1.$ === 2) {
					return true;
				} else {
					return false;
				}
			},
			lignes);
		return $elm$core$List$isEmpty(lignes) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('a-ranger')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('invite')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsValeursARanger(i18n))
						])),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						function (ligne) {
							var _v0 = ligne.fm;
							if (_v0.$ === 2) {
								var categorie = _v0.a;
								return A3(
									$author$project$Components$Produits$StructureCatalogue$Valeurs$View$boutonDeCategorie,
									typologie.Aq,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('categorie')
										]),
									{Aq: categorie, Dj: ligne.Dj});
							} else {
								return A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(ligne.Dj)
										]));
							}
						},
						lignes),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('explication')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									categories ? A3($author$project$Components$Produits$StructureCatalogue$Valeurs$View$explicationDesCategories, i18n, model, typologie) : $author$project$I18n$Cles$produitsValeursARangerExplicationValeurs(i18n))
								]))
						]))));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$RangementOuvert = function (a) {
	return {$: 159, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$RestrictionOuverte = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$gammesNommees = function (typologie) {
	var etagesDesGammes = A2(
		$elm$core$List$map,
		function ($) {
			return $.Aq;
		},
		A2(
			$elm$core$List$filter,
			function (etage) {
				var _v1 = etage.xt;
				if (!_v1.$) {
					var code = _v1.a;
					return _Utils_eq(code, $author$project$Catalogue$Vocabulaire$codeGamme);
				} else {
					return false;
				}
			},
			typologie.yG));
	return A3(
		$elm$core$List$foldl,
		F2(
			function (gamme, vues) {
				return A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Aq;
						},
						$elm$core$Basics$eq(gamme.Aq)),
					vues) ? vues : _Utils_ap(
					vues,
					_List_fromArray(
						[gamme]));
			}),
		_List_Nil,
		A2(
			$elm$core$List$filterMap,
			function (noeud) {
				var _v0 = _Utils_Tuple2(noeud.fm, noeud.R);
				if ((_v0.a.$ === 1) && (!_v0.b.$)) {
					var id = _v0.a.a;
					var libelles = _v0.b.a;
					return $elm$core$Maybe$Just(
						{Aq: id, Dj: libelles.zX});
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			A2(
				$elm$core$List$filter,
				function (noeud) {
					return A2($elm$core$List$member, noeud.md, etagesDesGammes) && (!noeud.iz);
				},
				typologie.Di)));
};
var $author$project$I18n$Cles$produitsValeursRestrictionBouton = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.restriction.bouton', _List_Nil, 'Restreindre');
};
var $author$project$I18n$Cles$produitsValeursRestrictionBoutonEtiquette = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.restriction.bouton.etiquette',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Restreindre « ' + (p.Dj + ' » à des marques et des gammes'));
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$boutonDeRestriction = F6(
	function (i18n, model, typologie, inactif, produit, ligne) {
		var ancre = 'restreindre-' + $author$project$Catalogue$Identifiants$elementIdToString(produit);
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('modifier-categorie'),
					$rtfeldman$elm_css$Html$Styled$Attributes$id(ancre),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					A2(
						$author$project$I18n$Cles$produitsValeursRestrictionBoutonEtiquette,
						i18n,
						{Dj: ligne.Dj})),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Components$Produits$StructureCatalogue$Update$DesProduits(
						$author$project$Components$Produits$StructureCatalogue$Produits$Update$RestrictionOuverte(
							{
								xe: ancre,
								gG: $author$project$Components$Produits$StructureCatalogue$Valeurs$Model$gammesNommees(typologie),
								cU: A2(
									$elm$core$List$map,
									function (marque) {
										return {Aq: marque.Aq, Dj: marque.R.zX};
									},
									$author$project$Components$Produits$StructureCatalogue$Marques$Model$marques(model.cU)),
								Dj: ligne.Dj,
								Gp: produit
							}))),
					$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$I18n$Cles$produitsValeursRestrictionBouton(i18n))
				]));
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$boutonDeValeur = F4(
	function (i18n, inactif, lue, ligne) {
		var choisie = _Utils_eq(
			lue.ve,
			$elm$core$Maybe$Just(ligne.fm));
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('choisie', choisie)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-pressed',
					choisie ? 'true' : 'false'),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					A2($author$project$Components$Produits$StructureCatalogue$Update$ValeurChoisie, lue.bY, ligne.fm)),
					$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(ligne.Dj)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
						]),
					function () {
						var _v0 = ligne.vW;
						if (!_v0.$) {
							var compte = _v0.a;
							return _List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$compteDe, i18n, compte)),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('chevron'),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('›')
										]))
								]);
						} else {
							return _List_Nil;
						}
					}())
				]));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$OrdreOuvert = function (a) {
	return {$: 164, a: a};
};
var $author$project$I18n$Cles$produitsValeursOrdonner = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.ordonner', _List_Nil, 'Ordonner');
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$ordonner = F5(
	function (i18n, model, typologie, inactif, lue) {
		var _v0 = A3($author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$ouvrir, model.cU, typologie, lue);
		if (!_v0.$) {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('ordonner'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(
							$author$project$Components$Produits$StructureCatalogue$Valeurs$Update$idDeLOrdre(lue.bY)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Components$Produits$StructureCatalogue$Update$OrdreOuvert(lue.bY)),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsValeursOrdonner(i18n))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$I18n$Cles$produitsValeursFamilleModifier = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.famille.modifier',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Modifier « ' + (p.Dj + ' »'));
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$sorte = function (lue) {
	var _v0 = lue.md.xt;
	if (_v0.$ === 1) {
		return 'valeurs';
	} else {
		var code = _v0.a;
		return lue.md.wL ? 'categories' : (_Utils_eq(code, $author$project$Catalogue$Vocabulaire$codeMarque) ? 'marques' : (_Utils_eq(code, $author$project$Catalogue$Vocabulaire$codeProduit) ? 'produits' : 'valeurs'));
	}
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$colonne = F6(
	function (i18n, model, typologie, inactif, colonnes, lue) {
		var nombre = $elm$core$List$length(colonnes);
		var modifier = A2(
			$elm$core$Maybe$andThen,
			function (sous) {
				return A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.nQ;
						},
						A2(
							$elm$core$Basics$composeR,
							$author$project$API$Liens$trouver($author$project$API$NavLinksDictionary$rangerSousUnNoeud),
							$elm$core$Basics$neq($elm$core$Maybe$Nothing))),
					sous.Di) ? $elm$core$Maybe$Just(
					A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('modifier'),
								$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$idDeModifier),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Produits$StructureCatalogue$Update$RangementOuvert(lue.bY - 1)),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$produitsValeursFamilleModifier,
									i18n,
									{Dj: sous.Dj}))
							]))) : $elm$core$Maybe$Nothing;
			},
			lue.IV);
		var dernier = _Utils_eq(lue.bY, nombre - 1);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('colonne'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					$author$project$Components$Produits$StructureCatalogue$Valeurs$View$sorte(lue)),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'de-la-choisie',
							!_Utils_eq(lue.IV, $elm$core$Maybe$Nothing))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'data-etage',
					$author$project$Catalogue$Identifiants$etageIdToString(lue.md.Aq))
				]),
			_Utils_ap(
				_List_fromArray(
					[
						function () {
						if (!modifier.$) {
							var bouton = modifier.a;
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('entete')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$h3,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$titreDe, i18n, lue.h6))
											])),
										bouton
									]));
						} else {
							return A2(
								$rtfeldman$elm_css$Html$Styled$h3,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$titreDe, i18n, lue.h6))
									]));
						}
					}(),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-label',
								A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$titreDe, i18n, lue.h6))
							]),
						A2(
							$elm$core$List$map,
							function (ligne) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_Nil,
									_List_fromArray(
										[
											function () {
											var _v1 = _Utils_Tuple2(ligne.fm, dernier);
											switch (_v1.a.$) {
												case 2:
													if (_v1.b) {
														var categorie = _v1.a.a;
														return A3(
															$author$project$Components$Produits$StructureCatalogue$Valeurs$View$boutonDeCategorie,
															typologie.Aq,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
																]),
															{Aq: categorie, Dj: ligne.Dj});
													} else {
														var categorie = _v1.a.a;
														return lue.md.wL ? A2(
															$rtfeldman$elm_css$Html$Styled$div,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$class('categorie-choisie')
																]),
															_List_fromArray(
																[
																	A4($author$project$Components$Produits$StructureCatalogue$Valeurs$View$boutonDeValeur, i18n, inactif, lue, ligne),
																	A3(
																	$author$project$Components$Produits$StructureCatalogue$Valeurs$View$boutonDeCategorie,
																	typologie.Aq,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class('modifier-categorie'),
																			A2(
																			$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
																			'aria-label',
																			A2(
																				$author$project$I18n$Cles$produitsValeursFamilleModifier,
																				i18n,
																				{Dj: ligne.Dj}))
																		]),
																	{
																		Aq: categorie,
																		Dj: $author$project$I18n$Cles$produitsCatalogueActionsModifier(i18n)
																	})
																])) : A4($author$project$Components$Produits$StructureCatalogue$Valeurs$View$boutonDeValeur, i18n, inactif, lue, ligne);
													}
												case 3:
													var produit = _v1.a.a;
													var _v2 = model.aK.jB;
													if (!_v2.$) {
														return A2(
															$rtfeldman$elm_css$Html$Styled$div,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$class('categorie-choisie')
																]),
															_List_fromArray(
																[
																	A4($author$project$Components$Produits$StructureCatalogue$Valeurs$View$boutonDeValeur, i18n, inactif, lue, ligne),
																	A6($author$project$Components$Produits$StructureCatalogue$Valeurs$View$boutonDeRestriction, i18n, model, typologie, inactif, produit, ligne)
																]));
													} else {
														return A4($author$project$Components$Produits$StructureCatalogue$Valeurs$View$boutonDeValeur, i18n, inactif, lue, ligne);
													}
												default:
													return A4($author$project$Components$Produits$StructureCatalogue$Valeurs$View$boutonDeValeur, i18n, inactif, lue, ligne);
											}
										}()
										]));
							},
							lue.gV)),
						A2($author$project$Components$Produits$StructureCatalogue$Valeurs$View$ajoutable, model, lue) ? A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('proposition'),
								$rtfeldman$elm_css$Html$Styled$Attributes$id(
								($author$project$Components$Produits$StructureCatalogue$Valeurs$View$sorte(lue) === 'marques') ? $author$project$Components$Produits$StructureCatalogue$Marques$Model$idDeLaCreation : $author$project$Components$Produits$StructureCatalogue$Valeurs$Update$idDeLAjout(lue.bY)),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Produits$StructureCatalogue$Update$AjoutDansLaColonne(lue.bY)),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(inactif)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$I18n$Cles$produitsValeursAjouter,
											i18n,
											{
												md: A2($author$project$I18n$Cles$texte, i18n, lue.Dj)
											}))
									]))
							])) : $rtfeldman$elm_css$Html$Styled$text('')
					]),
				A5($author$project$Components$Produits$StructureCatalogue$Valeurs$View$ordonner, i18n, model, typologie, inactif, lue)));
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$aLibre = function (typologie) {
	return A2(
		$elm$core$List$any,
		function (etage) {
			var _v0 = etage.xt;
			if (_v0.$ === 1) {
				return true;
			} else {
				return false;
			}
		},
		typologie.yG);
};
var $author$project$I18n$Cles$produitsValeursNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.note', _List_Nil, 'Chaque étage a sa colonne, dans l\'ordre du rangement. Cliquez une valeur pour voir ce qu\'elle contient à l\'étage suivant ; « Modifier » ouvre son volet (pour une marque : son nom et les catégories qu\'elle fabrique).');
};
var $author$project$I18n$Cles$produitsValeursNoteGamme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.note.gamme', _List_Nil, 'Une gamme appartient à une marque.');
};
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$note = F2(
	function (i18n, typologie) {
		var gammes = A2(
			$elm$core$List$any,
			function (etage) {
				var _v0 = etage.xt;
				if (!_v0.$) {
					var code = _v0.a;
					return _Utils_eq(code, $author$project$Catalogue$Vocabulaire$codeGamme);
				} else {
					return false;
				}
			},
			typologie.yG);
		return $author$project$Components$Produits$StructureCatalogue$Valeurs$View$aLibre(typologie) ? A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('conseil')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					_Utils_ap(
						$author$project$I18n$Cles$produitsValeursNote(i18n),
						gammes ? (' ' + $author$project$I18n$Cles$produitsValeursNoteGamme(i18n)) : ''))
				])) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$noms = function (ordre) {
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.Dj;
		},
		ordre.gV);
};
var $author$project$I18n$Cles$produitsValeursOrdreEnregistre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.ordre.enregistre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etage',
					$author$project$I18n$Traductions$Chaine(p.md)),
					_Utils_Tuple2(
					'noms',
					$author$project$I18n$Traductions$Chaine(p.DG))
				]),
			'L\'ordre des ' + ($elm$core$String$toLower(p.md) + (' est enregistré : ' + (p.DG + '.'))));
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$note = F2(
	function (i18n, ordre) {
		return A2(
			$author$project$I18n$Cles$produitsValeursOrdreEnregistre,
			i18n,
			{
				md: A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Model$titreDe, i18n, ordre.md),
				DG: A2(
					$elm$core$String$join,
					', ',
					$author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$noms(ordre))
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$noteDeLOrdre = F2(
	function (i18n, model) {
		var _v0 = model.oK;
		if (!_v0.$) {
			var ordre = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ordre-enregistre'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$Components$Produits$StructureCatalogue$Valeurs$Ordre$note, i18n, ordre))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$produitsParcoursValeursTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.valeurs.titre', _List_Nil, 'Les valeurs de chaque étage');
};
var $author$project$I18n$Cles$produitsValeursTypologieMontree = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.typologie-montree',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typologie',
					$author$project$I18n$Traductions$Chaine(p.r3))
				]),
			'Typologie montrée : ' + p.r3);
	});
var $author$project$Components$Produits$StructureCatalogue$Valeurs$View$view = F4(
	function (i18n, model, structure, typologie) {
		var lues = A3($author$project$Components$Produits$StructureCatalogue$Valeurs$Lecture$colonnes, model, structure, typologie);
		var inactif = $author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('valeurs-de-typologie')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('typologie-montree')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$produitsValeursTypologieMontree,
								i18n,
								{
									r3: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(typologie)
								}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('colonnes'),
									$rtfeldman$elm_css$Html$Styled$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('loading', inactif)
										])),
									$author$project$Components$Produits$StructureCatalogue$Controles$occupe(inactif),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'group'),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									$author$project$I18n$Cles$produitsParcoursValeursTitre(i18n))
								]),
							A2(
								$elm$core$List$map,
								A5($author$project$Components$Produits$StructureCatalogue$Valeurs$View$colonne, i18n, model, typologie, inactif, lues),
								lues)),
							A3($author$project$Components$Produits$StructureCatalogue$Valeurs$View$aRanger, i18n, model, typologie),
							A2($author$project$Components$Produits$StructureCatalogue$Valeurs$View$note, i18n, typologie),
							A2($author$project$Components$Produits$StructureCatalogue$Valeurs$View$noteDeLOrdre, i18n, model)
						]))
				]));
	});
var $author$project$Components$Produits$StructureCatalogue$View$contenu = F4(
	function (i18n, embarque, model, fournie) {
		var deLaStructure = function (section) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, section, $elm$core$List$singleton),
					model.h$));
		};
		switch (fournie) {
			case 0:
				return deLaStructure(
					A2($author$project$Components$Produits$StructureCatalogue$Typologies$View$view, i18n, model));
			case 4:
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.zT;
							},
							A2(
								$elm$core$Basics$composeR,
								$rtfeldman$elm_css$Html$Styled$map($author$project$Components$Produits$StructureCatalogue$Update$DuFormulaire),
								$elm$core$List$singleton)),
						embarque));
			case 1:
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$elm$core$List$singleton,
						A2(
							$elm$core$Maybe$map,
							function (structure) {
								return A2(
									$elm$core$Maybe$withDefault,
									$author$project$Components$Produits$StructureCatalogue$View$sansTypologie(i18n),
									A2(
										$elm$core$Maybe$map,
										A3($author$project$Components$Produits$StructureCatalogue$Etages$View$view, i18n, model, structure),
										A2($author$project$Components$Produits$StructureCatalogue$Typologies$Model$reglee, model.r6, structure.vk)));
							},
							model.h$)));
			case 2:
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$elm$core$List$singleton,
						A2(
							$elm$core$Maybe$map,
							function (structure) {
								return A2(
									$elm$core$Maybe$withDefault,
									$author$project$Components$Produits$StructureCatalogue$View$sansTypologie(i18n),
									A2(
										$elm$core$Maybe$map,
										A3($author$project$Components$Produits$StructureCatalogue$Valeurs$View$view, i18n, model, structure),
										A2($author$project$Components$Produits$StructureCatalogue$Typologies$Model$reglee, model.r6, structure.vk)));
							},
							model.h$)));
			default:
				return deLaStructure(
					A2(
						$elm$core$Basics$composeR,
						A2($author$project$Components$Produits$StructureCatalogue$Informations$View$view, i18n, model),
						$rtfeldman$elm_css$Html$Styled$div(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('informations-du-catalogue')
								]))));
		}
	});
var $author$project$I18n$Cles$produitsParcoursInformationsExplicationDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.explication.debut', _List_Nil, 'Posez chaque ');
};
var $author$project$I18n$Cles$produitsParcoursInformationsExplicationFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.explication.fin', _List_Nil, ' à l\'étage le plus haut où elle a un sens. Elle vaudra pour tout ce qui est rangé en dessous, et se remplira sur la fiche de la référence.');
};
var $author$project$I18n$Cles$produitsParcoursInformationsExplicationFort = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.explication.fort', _List_Nil, 'information');
};
var $author$project$I18n$Cles$produitsParcoursRangementExplicationDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.rangement.explication.debut', _List_Nil, 'Choisissez les ');
};
var $author$project$I18n$Cles$produitsParcoursRangementExplicationFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.rangement.explication.fin', _List_Nil, ' par lesquels on descend jusqu\'à une référence, du plus large au plus précis. Chaque typologie a les siens.');
};
var $author$project$I18n$Cles$produitsParcoursRangementExplicationFort = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.rangement.explication.fort', _List_Nil, 'étages');
};
var $author$project$I18n$Cles$produitsParcoursTypologiesExplicationDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.typologies.explication.debut', _List_Nil, 'Une ');
};
var $author$project$I18n$Cles$produitsParcoursTypologiesExplicationFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.typologies.explication.fin', _List_Nil, ' est un grand ensemble de produits qui se rangent et se décrivent de la même façon. Un fabricant d\'électroménager qui vend aussi des ustensiles en a deux.');
};
var $author$project$I18n$Cles$produitsParcoursTypologiesExplicationFort = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.typologies.explication.fort', _List_Nil, 'typologie');
};
var $author$project$I18n$Cles$produitsParcoursValeursExplicationDebut = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.valeurs.explication.debut', _List_Nil, 'Saisissez une fois les ');
};
var $author$project$I18n$Cles$produitsParcoursValeursExplicationFin = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.valeurs.explication.fin', _List_Nil, ' de chaque étage. Ce sont elles qu\'on choisira dans une liste en créant une référence. Une catégorie appartient à une famille.');
};
var $author$project$I18n$Cles$produitsParcoursValeursExplicationFort = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.valeurs.explication.fort', _List_Nil, 'valeurs');
};
var $author$project$I18n$Cles$produitsParcoursVerificationExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.verification.explication', _List_Nil, 'Voici le formulaire que vos réglages produisent pour un four De Dietrich. S\'il manque une information, revenez à l\'étape 4.');
};
var $author$project$Components$Produits$StructureCatalogue$Parcours$explication = F2(
	function (i18n, etape) {
		switch (etape) {
			case 0:
				return _List_fromArray(
					[
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$produitsParcoursTypologiesExplicationDebut(i18n)),
						$author$project$Components$Shared$Parcours$Model$Fort(
						$author$project$I18n$Cles$produitsParcoursTypologiesExplicationFort(i18n)),
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$produitsParcoursTypologiesExplicationFin(i18n))
					]);
			case 1:
				return _List_fromArray(
					[
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$produitsParcoursRangementExplicationDebut(i18n)),
						$author$project$Components$Shared$Parcours$Model$Fort(
						$author$project$I18n$Cles$produitsParcoursRangementExplicationFort(i18n)),
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$produitsParcoursRangementExplicationFin(i18n))
					]);
			case 2:
				return _List_fromArray(
					[
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$produitsParcoursValeursExplicationDebut(i18n)),
						$author$project$Components$Shared$Parcours$Model$Fort(
						$author$project$I18n$Cles$produitsParcoursValeursExplicationFort(i18n)),
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$produitsParcoursValeursExplicationFin(i18n))
					]);
			case 3:
				return _List_fromArray(
					[
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$produitsParcoursInformationsExplicationDebut(i18n)),
						$author$project$Components$Shared$Parcours$Model$Fort(
						$author$project$I18n$Cles$produitsParcoursInformationsExplicationFort(i18n)),
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$produitsParcoursInformationsExplicationFin(i18n))
					]);
			default:
				return _List_fromArray(
					[
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$produitsParcoursVerificationExplication(i18n))
					]);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Model$etapeRemplie = F2(
	function (model, etape) {
		var dansLaStructure = function (lire) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2($elm$core$Maybe$map, lire, model.h$));
		};
		switch (etape) {
			case 0:
				return dansLaStructure(
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.vk;
						},
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Produits$StructureCatalogue$Typologies$Model$de,
							A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not))));
			case 1:
				return dansLaStructure(
					function (structure) {
						var _v1 = $author$project$Components$Produits$StructureCatalogue$Typologies$Model$de(structure.vk);
						if (!_v1.b) {
							return A2(
								$elm$core$List$any,
								function ($) {
									return $.Kg;
								},
								structure.C9);
						} else {
							var servies = _v1;
							return A2(
								$elm$core$List$any,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.yG;
									},
									$elm$core$List$any(
										A2(
											$elm$core$Basics$composeL,
											$elm$core$Basics$not,
											function ($) {
												return $.wL;
											}))),
								servies);
						}
					});
			case 2:
				return dansLaStructure(
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.vk;
						},
						$elm$core$List$any(
							function (classification) {
								return classification.wE ? (!$author$project$Components$Produits$StructureCatalogue$Classifications$Model$estVide(classification)) : A2(
									$elm$core$List$any,
									A2(
										$elm$core$Basics$composeL,
										$elm$core$Basics$not,
										function ($) {
											return $.tI;
										}),
									classification.Ki);
							})));
			case 3:
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.ib;
							},
							$elm$core$List$any(
								function (categorie) {
									return (!categorie.tE) && (categorie.dw > 0);
								})),
						model.dt.aS));
			default:
				return false;
		}
	});
var $author$project$I18n$Cles$produitsParcoursInformationsTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.titre', _List_Nil, 'Les informations à saisir');
};
var $author$project$I18n$Cles$produitsParcoursRangementTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.rangement.titre', _List_Nil, 'Le rangement');
};
var $author$project$I18n$Cles$produitsParcoursVerificationTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.verification.titre', _List_Nil, 'La première référence');
};
var $author$project$Components$Produits$StructureCatalogue$Parcours$titre = F2(
	function (i18n, etape) {
		switch (etape) {
			case 0:
				return $author$project$I18n$Cles$produitsParcoursTypologiesTitre(i18n);
			case 1:
				return $author$project$I18n$Cles$produitsParcoursRangementTitre(i18n);
			case 2:
				return $author$project$I18n$Cles$produitsParcoursValeursTitre(i18n);
			case 3:
				return $author$project$I18n$Cles$produitsParcoursInformationsTitre(i18n);
			default:
				return $author$project$I18n$Cles$produitsParcoursVerificationTitre(i18n);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$View$typologieMontree = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		model.r6,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Aq;
				},
				$elm$core$Maybe$Just),
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.vk;
					},
					$author$project$Components$Produits$StructureCatalogue$Typologies$Model$reglee(model.r6)),
				model.h$)));
};
var $author$project$Components$Produits$StructureCatalogue$View$parcours = F2(
	function (i18n, model) {
		return {
			aa: function (atteinte) {
				return $author$project$Routes$Route$toString(
					A2(
						$author$project$Routes$Route$ParametrageCatalogue,
						atteinte,
						$author$project$Components$Produits$StructureCatalogue$View$typologieMontree(model)));
			},
			tX: $author$project$Components$Produits$StructureCatalogue$Update$EtapeDemandeeAuPied,
			yL: $author$project$Routes$Route$etapesDuCatalogue,
			Dj: $author$project$Components$Produits$StructureCatalogue$Parcours$nom,
			qm: $author$project$Components$Produits$StructureCatalogue$Model$etapeRemplie(model),
			h6: $author$project$Components$Produits$StructureCatalogue$Parcours$titre(i18n)
		};
	});
var $author$project$I18n$Cles$produitsTypologiesArchiveeExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archivee.explication', _List_Nil, 'Les étages sont conservés tels qu\'ils étaient. Aucun geste de saisie n\'est proposé.');
};
var $author$project$I18n$Cles$produitsTypologiesArchiveePastille = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.archivee.pastille', _List_Nil, 'Archivée');
};
var $author$project$I18n$Cles$produitsParcoursInformationsQuestion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.question', _List_Nil, 'Que saisit-on sur une référence ?');
};
var $author$project$I18n$Cles$produitsParcoursRangementQuestion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.rangement.question', _List_Nil, 'Comment se range votre catalogue ?');
};
var $author$project$I18n$Cles$produitsParcoursRangementQuestionTypologie = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.parcours.rangement.question.typologie',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'typologie',
					$author$project$I18n$Traductions$Chaine(p.r3))
				]),
			'Comment se range ' + (p.r3 + ' ?'));
	});
var $author$project$I18n$Cles$produitsParcoursTypologiesQuestion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.typologies.question', _List_Nil, 'Que vendez-vous ?');
};
var $author$project$I18n$Cles$produitsParcoursValeursQuestion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.valeurs.question', _List_Nil, 'Que propose chaque étage ?');
};
var $author$project$I18n$Cles$produitsParcoursVerificationQuestion = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.verification.question', _List_Nil, 'Vérifiez en créant une référence');
};
var $author$project$Components$Produits$StructureCatalogue$Parcours$question = F3(
	function (i18n, typologie, etape) {
		switch (etape) {
			case 0:
				return $author$project$I18n$Cles$produitsParcoursTypologiesQuestion(i18n);
			case 1:
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$I18n$Cles$produitsParcoursRangementQuestion(i18n),
					A2(
						$elm$core$Maybe$map,
						function (nommee) {
							return A2(
								$author$project$I18n$Cles$produitsParcoursRangementQuestionTypologie,
								i18n,
								{r3: nommee});
						},
						typologie));
			case 2:
				return $author$project$I18n$Cles$produitsParcoursValeursQuestion(i18n);
			case 3:
				return $author$project$I18n$Cles$produitsParcoursInformationsQuestion(i18n);
			default:
				return $author$project$I18n$Cles$produitsParcoursVerificationQuestion(i18n);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$View$typologieArchivee = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$author$project$Components$Produits$StructureCatalogue$Typologies$Model$archivee,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.vk;
					},
					$author$project$Components$Produits$StructureCatalogue$Typologies$Model$reglee(model.r6)),
				model.h$)));
};
var $author$project$Components$Produits$StructureCatalogue$View$typologieNommee = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function (typologie) {
			return A2(
				$author$project$Catalogue$Formes$avecArticle,
				typologie.m$,
				$author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(typologie));
		},
		A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.vk;
				},
				$author$project$Components$Produits$StructureCatalogue$Typologies$Model$reglee(model.r6)),
			model.h$));
};
var $author$project$Components$Produits$StructureCatalogue$View$etape = F5(
	function (i18n, courante, embarque, model, fournie) {
		var archivee = (fournie === 1) && $author$project$Components$Produits$StructureCatalogue$View$typologieArchivee(model);
		return A5(
			$author$project$Components$Shared$Parcours$View$etapeAvecPastille,
			archivee ? $elm$core$Maybe$Just(
				$author$project$I18n$Cles$produitsTypologiesArchiveePastille(i18n)) : $elm$core$Maybe$Nothing,
			A2($author$project$Components$Produits$StructureCatalogue$View$parcours, i18n, model),
			courante,
			fournie,
			{
				fZ: A4($author$project$Components$Produits$StructureCatalogue$View$contenu, i18n, embarque, model, fournie),
				y8: archivee ? _List_fromArray(
					[
						$author$project$Components$Shared$Parcours$Model$Texte(
						$author$project$I18n$Cles$produitsTypologiesArchiveeExplication(i18n))
					]) : A2($author$project$Components$Produits$StructureCatalogue$Parcours$explication, i18n, fournie),
				GJ: A3(
					$author$project$Components$Produits$StructureCatalogue$Parcours$question,
					i18n,
					$author$project$Components$Produits$StructureCatalogue$View$typologieNommee(model),
					fournie)
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Update$InformationEnregistree = {$: 125};
var $author$project$Components$Produits$StructureCatalogue$Update$ObligationDInformationBasculee = function (a) {
	return {$: 122, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$DeplacementDemande = {$: 132};
var $author$project$Components$Produits$StructureCatalogue$Update$DestinationChoisie = function (a) {
	return {$: 131, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$catalogueSeul = F2(
	function (i18n, depuis) {
		return _Utils_eq(depuis, $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$Catalogue) ? _List_Nil : _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$I18n$Cles$produitsParcoursInformationsBoiteCatalogueTitre(i18n),
				$author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$Catalogue)
			]);
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$destinations = F3(
	function (i18n, model, depuis) {
		var _v0 = model.h$;
		if (!_v0.$) {
			var structure = _v0.a;
			var _v1 = A2($author$project$Components$Produits$StructureCatalogue$Typologies$Model$reglee, model.r6, structure.vk);
			if (!_v1.$) {
				var typologie = _v1.a;
				var colonnes = A3($author$project$Components$Produits$StructureCatalogue$Valeurs$Lecture$colonnes, model, structure, typologie);
				return A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$second,
						$elm$core$Basics$neq(depuis)),
					A2(
						$elm$core$List$map,
						function (uneBoite) {
							return _Utils_Tuple2(
								function (_v2) {
									var titre = _v2.b;
									return titre;
								}(
									A4(
										$author$project$Components$Produits$StructureCatalogue$Informations$View$entete,
										i18n,
										$author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(typologie),
										colonnes,
										uneBoite)),
								A2($author$project$Components$Produits$StructureCatalogue$Informations$Boites$porteeDe, typologie.Aq, uneBoite));
						},
						$author$project$Components$Produits$StructureCatalogue$Informations$Boites$boitesDe(colonnes)));
			} else {
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$View$catalogueSeul, i18n, depuis);
			}
		} else {
			return A2($author$project$Components$Produits$StructureCatalogue$Informations$View$catalogueSeul, i18n, depuis);
		}
	});
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerDeplacer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.drawer.deplacer', _List_Nil, 'Déplacer');
};
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerDeplacerAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.drawer.deplacer.aide', _List_Nil, 'L\'information change d\'étage. Renseignée, elle ne remonte que vers un étage plus haut.');
};
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerDeplacerBouton = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.parcours.informations.drawer.deplacer.bouton',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Déplacer « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerDeplacerChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.drawer.deplacer.choisir', _List_Nil, 'Choisir un étage');
};
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerDeplacerVers = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.drawer.deplacer.vers', _List_Nil, 'Déplacer vers…');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$deplacer = F4(
	function (i18n, model, portee, lue) {
		var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$deplacerUneInformation, lue.nQ);
		if (!_v0.$) {
			var arrivees = A3($author$project$Components$Produits$StructureCatalogue$Informations$View$destinations, i18n, model, portee);
			var choisie = A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$first,
				A2(
					$elm$core$Maybe$andThen,
					function (vers) {
						return $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Tuple$second,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Tuple$second,
										$elm$core$Basics$eq(vers))),
								A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, arrivees)));
					},
					model.cy));
			var choix = function (texte) {
				return A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$second,
					A2(
						$elm$core$Maybe$andThen,
						function (rang) {
							return $elm$core$List$head(
								A2($elm$core$List$drop, rang, arrivees));
						},
						$elm$core$String$toInt(texte)));
			};
			return A3(
				$author$project$Components$Produits$StructureCatalogue$Informations$View$section,
				'deplacer',
				$author$project$I18n$Cles$produitsParcoursInformationsDrawerDeplacer(i18n),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsParcoursInformationsDrawerDeplacerAide(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$fieldset,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$legend,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$produitsParcoursInformationsDrawerDeplacerVers(i18n))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$select,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onInput(
										A2($elm$core$Basics$composeR, choix, $author$project$Components$Produits$StructureCatalogue$Update$DestinationChoisie)),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
										'aria-label',
										$author$project$I18n$Cles$produitsParcoursInformationsDrawerDeplacerVers(i18n))
									]),
								A2(
									$elm$core$List$cons,
									A2(
										$rtfeldman$elm_css$Html$Styled$option,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$value(''),
												$rtfeldman$elm_css$Html$Styled$Attributes$selected(
												_Utils_eq(choisie, $elm$core$Maybe$Nothing))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$produitsParcoursInformationsDrawerDeplacerChoisir(i18n))
											])),
									A2(
										$elm$core$List$indexedMap,
										F2(
											function (rang, _v1) {
												var nom = _v1.a;
												return A2(
													$rtfeldman$elm_css$Html$Styled$option,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$value(
															$elm$core$String$fromInt(rang)),
															$rtfeldman$elm_css$Html$Styled$Attributes$selected(
															_Utils_eq(
																choisie,
																$elm$core$Maybe$Just(rang)))
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(nom)
														]));
											}),
										arrivees)))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('deplacer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
								_Utils_eq(model.cy, $elm$core$Maybe$Nothing) || $author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model)),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$StructureCatalogue$Update$DeplacementDemande)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$produitsParcoursInformationsDrawerDeplacerBouton,
									i18n,
									{Dj: lue.uN.Bl}))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Update$InformationMasquee = {$: 126};
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerMasquerBouton = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.parcours.informations.drawer.masquer.bouton',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Masquer « ' + (p.Dj + ' »'));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Model$relDuMasquage = function (portee) {
	if (portee.$ === 3) {
		return $author$project$API$NavLinksDictionary$masquerUnChamp;
	} else {
		return $author$project$API$NavLinksDictionary$masquerUneInformation;
	}
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$issueDuRefus = F4(
	function (i18n, model, portee, lue) {
		var _v0 = _Utils_Tuple2(
			model.ag && (!_Utils_eq(model.aL, $elm$core$Maybe$Nothing)),
			A2(
				$author$project$API$Liens$trouver,
				$author$project$Components$Produits$StructureCatalogue$Informations$Model$relDuMasquage(portee),
				lue.nQ));
		if (_v0.a && (!_v0.b.$)) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('issue')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('masquer'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$StructureCatalogue$Update$InformationMasquee)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$produitsParcoursInformationsDrawerMasquerBouton,
									i18n,
									{Dj: lue.uN.Bl}))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Update$InformationDeplacee = F2(
	function (a, b) {
		return {$: 134, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$ligneDOrdre = F6(
	function (i18n, model, ouverte, dernier, rang, lue) {
		var cle = lue.uN.dy;
		var bouton = F3(
			function (sens, nomme, inactif) {
				return A2(
					$author$project$Components$Produits$StructureCatalogue$Controles$boutonDOrdre,
					sens,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							A2($author$project$Components$Produits$StructureCatalogue$Update$InformationDeplacee, cle, sens)),
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
							inactif || $author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model)),
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'aria-label',
							nomme(
								{Dj: lue.uN.Bl})),
							$rtfeldman$elm_css$Html$Styled$Attributes$title(
							nomme(
								{Dj: lue.uN.Bl}))
						]));
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ligne'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'courante',
							_Utils_eq(cle, ouverte)),
							_Utils_Tuple2('masquee', lue.n4)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('poignee')
						]),
					_List_fromArray(
						[$author$project$Components$Shared$Svg$svgDragHandle])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(lue.uN.Bl)
						])),
					A3(
					bouton,
					0,
					$author$project$I18n$Cles$produitsStructureOrdreMonterDe(i18n),
					!rang),
					A3(
					bouton,
					1,
					$author$project$I18n$Cles$produitsStructureOrdreDescendreDe(i18n),
					_Utils_eq(rang, dernier))
				]));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$lignesDOrdre = F4(
	function (i18n, model, ouverte, champs) {
		var dernier = $elm$core$List$length(champs) - 1;
		return A2(
			$elm$core$List$indexedMap,
			A4($author$project$Components$Produits$StructureCatalogue$Informations$View$ligneDOrdre, i18n, model, ouverte, dernier),
			champs);
	});
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerMasquer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.drawer.masquer', _List_Nil, 'Masquer');
};
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerMasquerAide = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.parcours.informations.drawer.masquer.aide',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Une information masquée ne se saisit plus. Ce qui a été saisi reste sur les fiches ; elle se réaffiche quand vous voulez. ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' référence la renseigne.')) : ('Une information masquée ne se saisit plus. Ce qui a été saisi reste sur les fiches ; elle se réaffiche quand vous voulez. ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' références la renseignent.')));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$masquer = F4(
	function (i18n, portee, nombre, lue) {
		var _v0 = A2(
			$author$project$API$Liens$trouver,
			$author$project$Components$Produits$StructureCatalogue$Informations$Model$relDuMasquage(portee),
			lue.nQ);
		if (!_v0.$) {
			return A3(
				$author$project$Components$Produits$StructureCatalogue$Informations$View$section,
				'masquer',
				$author$project$I18n$Cles$produitsParcoursInformationsDrawerMasquer(i18n),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$produitsParcoursInformationsDrawerMasquerAide,
									i18n,
									{w: nombre}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('masquer'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$StructureCatalogue$Update$InformationMasquee)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$produitsParcoursInformationsDrawerMasquerBouton,
									i18n,
									{Dj: lue.uN.Bl}))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Update$InformationReaffichee = {$: 127};
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerMasquee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.drawer.masquee', _List_Nil, 'Masquée');
};
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerMasqueeAide = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.parcours.informations.drawer.masquee.aide',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Elle ne se saisit plus. Ce qui a été saisi est gardé : ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' référence la renseigne.')) : ('Elle ne se saisit plus. Ce qui a été saisi est gardé : ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' références la renseignent.')));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$reafficher = F4(
	function (i18n, portee, nombre, lue) {
		var _v0 = A2(
			$author$project$API$Liens$trouver,
			$author$project$Components$Produits$StructureCatalogue$Informations$Model$relDuReaffichage(portee),
			lue.nQ);
		if (!_v0.$) {
			return A3(
				$author$project$Components$Produits$StructureCatalogue$Informations$View$section,
				'masquee',
				$author$project$I18n$Cles$produitsParcoursInformationsDrawerMasquee(i18n),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$produitsParcoursInformationsDrawerMasqueeAide,
									i18n,
									{w: nombre}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('reafficher'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$StructureCatalogue$Update$InformationReaffichee)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$produitsParcoursInformationsDrawerReafficher,
									i18n,
									{Dj: lue.uN.Bl}))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$masquerOuReafficher = F4(
	function (i18n, portee, nombre, lue) {
		return lue.n4 ? A4($author$project$Components$Produits$StructureCatalogue$Informations$View$reafficher, i18n, portee, nombre, lue) : A4($author$project$Components$Produits$StructureCatalogue$Informations$View$masquer, i18n, portee, nombre, lue);
	});
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerObligatoire = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.drawer.obligatoire', _List_Nil, 'Obligatoire pour enregistrer la référence');
};
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerOrdre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.drawer.ordre', _List_Nil, 'Ordre sur la fiche');
};
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerSaisie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.drawer.saisie', _List_Nil, 'Ce qu\'on y saisit');
};
var $author$project$Components$Produits$StructureCatalogue$Update$RenommageDInformationOuvert = {$: 135};
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerRenommer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.drawer.renommer', _List_Nil, 'Renommer');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$renommer = F3(
	function (i18n, model, portee) {
		var _v0 = A2($author$project$Components$Produits$StructureCatalogue$Informations$Model$lienDeModification, portee, model.AM);
		if (!_v0.$) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('renommer'),
						$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$StructureCatalogue$Informations$Model$idDuRenommage),
						$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$StructureCatalogue$Update$RenommageDInformationOuvert)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsParcoursInformationsDrawerRenommer(i18n))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Update$MinimaDInformationSaisis = function (a) {
	return {$: 123, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$sectionDesMinima = F2(
	function (i18n, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (saisie) {
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('section'),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('minima-du-fichier')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$map,
									$author$project$Components$Produits$StructureCatalogue$Update$MinimaDInformationSaisis,
									A3($author$project$Components$Shared$EditeurDeSchema$View$minimaDuChamp, i18n, 'information', saisie))
								]))
						]);
				},
				model.cV));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$SuppressionAnnulee = {$: 130};
var $author$project$Components$Produits$StructureCatalogue$Update$SuppressionConfirmee = {$: 129};
var $author$project$Components$Produits$StructureCatalogue$Update$SuppressionDemandee = {$: 128};
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerSupprimer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.drawer.supprimer', _List_Nil, 'Supprimer');
};
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerSupprimerAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.drawer.supprimer.aide', _List_Nil, 'Aucune référence ne renseigne cette information : elle peut quitter le schéma pour de bon. Une information renseignée ne se supprime pas, elle se masque.');
};
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerSupprimerAnnuler = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.drawer.supprimer.annuler', _List_Nil, 'Non, la garder');
};
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerSupprimerBouton = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.parcours.informations.drawer.supprimer.bouton',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Supprimer « ' + (p.Dj + ' »'));
	});
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerSupprimerConfirmation = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.parcours.informations.drawer.supprimer.confirmation',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Supprimer « ' + (p.Dj + ' » du schéma ? Elle disparaît pour de bon.'));
	});
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerSupprimerConfirmer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.drawer.supprimer.confirmer', _List_Nil, 'Oui, supprimer');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$supprimer = F4(
	function (i18n, model, portee, lue) {
		var _v0 = A2(
			$author$project$API$Liens$trouver,
			$author$project$Components$Produits$StructureCatalogue$Informations$Model$relDeLaSuppression(portee),
			lue.nQ);
		if (!_v0.$) {
			return A3(
				$author$project$Components$Produits$StructureCatalogue$Informations$View$section,
				'supprimer',
				$author$project$I18n$Cles$produitsParcoursInformationsDrawerSupprimer(i18n),
				model.bk ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('confirmation')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$produitsParcoursInformationsDrawerSupprimerConfirmation,
									i18n,
									{Dj: lue.uN.Bl}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('supprimer'),
										$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
										$author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model)),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$StructureCatalogue$Update$SuppressionConfirmee)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsParcoursInformationsDrawerSupprimerConfirmer(i18n))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('annuler'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$StructureCatalogue$Update$SuppressionAnnulee)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsParcoursInformationsDrawerSupprimerAnnuler(i18n))
									]))
							]))
					]) : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsParcoursInformationsDrawerSupprimerAide(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('supprimer'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$StructureCatalogue$Update$SuppressionDemandee)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$produitsParcoursInformationsDrawerSupprimerBouton,
									i18n,
									{Dj: lue.uN.Bl}))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Update$TypeDInformationModifie = function (a) {
	return {$: 124, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$avecLeType = F2(
	function (code, changement) {
		return _Utils_update(
			changement,
			{kv: 0, nW: '', FS: false, r0: code, sa: ''});
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$gestesDeType = function (lu) {
	var porte = function (modifie) {
		return $author$project$Components$Produits$StructureCatalogue$Update$TypeDInformationModifie(modifie);
	};
	return {
		kv: function (n) {
			return porte(
				A2($author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$avecDecimales, n, lu));
		},
		M: function (code) {
			return porte(
				A2($author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$avecLeType, code, lu));
		},
		nW: function (liste) {
			return porte(
				A2($author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$avecLaListe, liste, lu));
		},
		T: $elm$core$Maybe$Just($author$project$Components$Produits$StructureCatalogue$Update$NouvelleListeOuverte),
		FS: function (plusieurs) {
			return porte(
				_Utils_update(
					lu,
					{FS: plusieurs}));
		},
		sa: function (unite) {
			return porte(
				A2($author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$avecUnite, unite, lu));
		}
	};
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$caseACocher = F4(
	function (identifiant, libelle, cochee, msg) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$fieldset,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('switch'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(identifiant),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(cochee),
							$rtfeldman$elm_css$Html$Styled$Events$onCheck(msg)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$for(identifiant)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(libelle)
						]))
				]));
	});
var $author$project$I18n$Cles$produitsParcoursInformationsAjoutAChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.ajout.a-choisir', _List_Nil, 'À choisir.');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$manque = F3(
	function (i18n, lu, absent) {
		return (lu.b5 && absent) ? A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('erreur')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$I18n$Cles$produitsParcoursInformationsAjoutAChoisir(i18n))
				])) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$I18n$Cles$produitsParcoursInformationsAjoutDecimales = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.ajout.decimales', _List_Nil, 'Décimales');
};
var $author$project$I18n$Cles$produitsParcoursInformationsAjoutListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.ajout.liste', _List_Nil, 'Liste');
};
var $author$project$I18n$Cles$produitsParcoursInformationsAjoutPlusieurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.ajout.plusieurs', _List_Nil, 'Plusieurs choix possibles');
};
var $author$project$I18n$Cles$produitsParcoursInformationsAjoutPlusieursArticles = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.ajout.plusieurs-articles', _List_Nil, 'Plusieurs articles possibles');
};
var $author$project$I18n$Cles$produitsParcoursInformationsAjoutUnite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.ajout.unite', _List_Nil, 'Unité');
};
var $author$project$I18n$Cles$produitsParcoursInformationsAjoutUniteAChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.ajout.unite.a-choisir', _List_Nil, 'Choisir une unité…');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$selecteurDUnite = F4(
	function (i18n, gestes, lu, unites) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$select,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onInput(gestes.sa),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					$author$project$I18n$Cles$produitsParcoursInformationsAjoutUnite(i18n))
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$option,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$value(''),
							$rtfeldman$elm_css$Html$Styled$Attributes$selected(lu.sa === '')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsParcoursInformationsAjoutUniteAChoisir(i18n))
						])),
				A2(
					$elm$core$List$map,
					function (unite) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$option,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(unite.vx),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(unite.vx, lu.sa))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(unite.vx + (' (' + (unite.Jh + ')')))
								]));
					},
					unites)));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$decimale = F3(
	function (lu, nombre, libelle) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$option,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$value(
					$elm$core$String$fromInt(nombre)),
					$rtfeldman$elm_css$Html$Styled$Attributes$selected(
					_Utils_eq(lu.kv, nombre))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(libelle)
				]));
	});
var $author$project$I18n$Cles$produitsParcoursInformationsAjoutDecimalesAucune = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.parcours.informations.ajout.decimales.aucune',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'exemple',
					$author$project$I18n$Traductions$Chaine(p.yY))
				]),
			'Aucune (' + (p.yY + ')'));
	});
var $author$project$I18n$Cles$produitsParcoursInformationsAjoutDecimalesDeux = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.parcours.informations.ajout.decimales.deux',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'exemple',
					$author$project$I18n$Traductions$Chaine(p.yY))
				]),
			'Deux (' + (p.yY + ')'));
	});
var $author$project$I18n$Cles$produitsParcoursInformationsAjoutDecimalesUne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.parcours.informations.ajout.decimales.une',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'exemple',
					$author$project$I18n$Traductions$Chaine(p.yY))
				]),
			'Une (' + (p.yY + ')'));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$selecteurDeDecimales = F4(
	function (i18n, gestes, lu, unites) {
		var symbole = (lu.sa === '') ? '' : (' ' + A2($author$project$Components$Shared$EditeurDeSchema$Propositions$symbole, unites, lu.sa));
		var exemple = function (decimales) {
			return _Utils_ap(
				function () {
					switch (decimales) {
						case 0:
							return '72';
						case 1:
							return '72,5';
						default:
							return '72,50';
					}
				}(),
				symbole);
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$select,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onInput(
					A2(
						$elm$core$Basics$composeR,
						$elm$core$String$toInt,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$withDefault(0),
							gestes.kv))),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					$author$project$I18n$Cles$produitsParcoursInformationsAjoutDecimales(i18n))
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Components$Produits$StructureCatalogue$Informations$View$decimale,
					lu,
					0,
					A2(
						$author$project$I18n$Cles$produitsParcoursInformationsAjoutDecimalesAucune,
						i18n,
						{
							yY: exemple(0)
						})),
					A3(
					$author$project$Components$Produits$StructureCatalogue$Informations$View$decimale,
					lu,
					1,
					A2(
						$author$project$I18n$Cles$produitsParcoursInformationsAjoutDecimalesUne,
						i18n,
						{
							yY: exemple(1)
						})),
					A3(
					$author$project$Components$Produits$StructureCatalogue$Informations$View$decimale,
					lu,
					2,
					A2(
						$author$project$I18n$Cles$produitsParcoursInformationsAjoutDecimalesDeux,
						i18n,
						{
							yY: exemple(2)
						}))
				]));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$nouvelleListeValeur = 'nouvelle-liste';
var $author$project$I18n$Cles$produitsParcoursInformationsAjoutListeAChoisir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.ajout.liste.a-choisir', _List_Nil, 'Choisir une liste…');
};
var $author$project$I18n$Cles$produitsParcoursInformationsAjoutNouvelleListe = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.ajout.nouvelle-liste', _List_Nil, 'Nouvelle liste…');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$selecteurDeListe = F4(
	function (i18n, gestes, model, lu) {
		var listes = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Maybe$map, $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$listesPartageesDuCatalogue, model.BX));
		var choix = function (texte) {
			var _v0 = _Utils_Tuple2(
				_Utils_eq(texte, $author$project$Components$Produits$StructureCatalogue$Informations$View$nouvelleListeValeur),
				gestes.T);
			if (_v0.a && (!_v0.b.$)) {
				var ouvrir = _v0.b.a;
				return ouvrir;
			} else {
				return gestes.nW(texte);
			}
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$select,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onInput(choix),
					$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$idDuSelecteurDeListe),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					$author$project$I18n$Cles$produitsParcoursInformationsAjoutListe(i18n))
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$option,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$value(''),
							$rtfeldman$elm_css$Html$Styled$Attributes$selected(lu.nW === '')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsParcoursInformationsAjoutListeAChoisir(i18n))
						])),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						function (liste) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$option,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value(liste.Aq),
										$rtfeldman$elm_css$Html$Styled$Attributes$selected(
										_Utils_eq(liste.Aq, lu.nW))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(liste.Dj)
									]));
						},
						listes),
					_Utils_eq(gestes.T, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$option,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value($author$project$Components$Produits$StructureCatalogue$Informations$View$nouvelleListeValeur)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$I18n$Cles$produitsParcoursInformationsAjoutNouvelleListe(i18n))
								]))
						]))));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$precisions = F5(
	function (i18n, gestes, model, lu, unites) {
		return _Utils_eq(lu.r0, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeMesure) ? _List_fromArray(
			[
				A2(
				$author$project$Components$Produits$StructureCatalogue$Informations$View$champDeListe,
				$author$project$I18n$Cles$produitsParcoursInformationsAjoutUnite(i18n),
				A4($author$project$Components$Produits$StructureCatalogue$Informations$View$selecteurDUnite, i18n, gestes, lu, unites)),
				A3($author$project$Components$Produits$StructureCatalogue$Informations$View$manque, i18n, lu, lu.sa === ''),
				A2(
				$author$project$Components$Produits$StructureCatalogue$Informations$View$champDeListe,
				$author$project$I18n$Cles$produitsParcoursInformationsAjoutDecimales(i18n),
				A4($author$project$Components$Produits$StructureCatalogue$Informations$View$selecteurDeDecimales, i18n, gestes, lu, unites))
			]) : (_Utils_eq(lu.r0, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeListeUnique) ? _List_fromArray(
			[
				A2(
				$author$project$Components$Produits$StructureCatalogue$Informations$View$champDeListe,
				$author$project$I18n$Cles$produitsParcoursInformationsAjoutListe(i18n),
				A4($author$project$Components$Produits$StructureCatalogue$Informations$View$selecteurDeListe, i18n, gestes, model, lu)),
				A3($author$project$Components$Produits$StructureCatalogue$Informations$View$manque, i18n, lu, lu.nW === ''),
				A4(
				$author$project$Components$Produits$StructureCatalogue$Informations$View$caseACocher,
				'ajout-plusieurs',
				$author$project$I18n$Cles$produitsParcoursInformationsAjoutPlusieurs(i18n),
				lu.FS,
				gestes.FS)
			]) : ((lu.r0 === 'lien-vers-des-articles') ? _List_fromArray(
			[
				A4(
				$author$project$Components$Produits$StructureCatalogue$Informations$View$caseACocher,
				'ajout-plusieurs-articles',
				$author$project$I18n$Cles$produitsParcoursInformationsAjoutPlusieursArticles(i18n),
				lu.FS,
				gestes.FS)
			]) : _List_Nil));
	});
var $author$project$I18n$Cles$produitsParcoursInformationsAjoutType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.ajout.type', _List_Nil, 'Type');
};
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerFigee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.drawer.figee', _List_Nil, 'Le type et l\'unité ne changent plus une fois des références saisies ; l\'obligation se modifie.');
};
var $author$project$I18n$Cles$produitsParcoursInformationsAjoutTypeNombreAvecUnite = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.ajout.type.nombre-avec-unite', _List_Nil, 'Nombre avec unité');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$nomDuType = F2(
	function (i18n, code) {
		return _Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeMesure) ? $author$project$I18n$Cles$produitsParcoursInformationsAjoutTypeNombreAvecUnite(i18n) : (_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeListeUnique) ? $author$project$I18n$Cles$produitsParcoursInformationsDrawerChoixDansUneListe(i18n) : ((code === 'lien-vers-des-articles') ? $author$project$I18n$Cles$produitsParcoursInformationsDrawerLienVersDesArticles(i18n) : A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeDeChamp, i18n, code)));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$estParametre = function (code) {
	return A2(
		$elm$core$List$member,
		code,
		_List_fromArray(
			[$author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeMesure, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeListeUnique, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeFichier, $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$typeLienVersDesArticles]));
};
var $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$proposes = F2(
	function (listesLues, types) {
		return A2(
			$elm$core$List$filter,
			function (code) {
				return (!_Utils_eq(code, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeListeUnique)) || listesLues;
			},
			A2(
				$elm$core$List$filter,
				function (code) {
					return (!_Utils_eq(
						$author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$sansAttribut(code),
						$elm$core$Maybe$Nothing)) || $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$estParametre(code);
				},
				A2(
					$elm$core$List$map,
					function ($) {
						return $.vx;
					},
					types)));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$selecteurDeType = F4(
	function (i18n, model, gestes, lu) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$select,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onInput(gestes.M),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-label',
					$author$project$I18n$Cles$produitsParcoursInformationsAjoutType(i18n))
				]),
			A2(
				$elm$core$List$map,
				function (code) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$option,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(code),
								$rtfeldman$elm_css$Html$Styled$Attributes$selected(
								_Utils_eq(code, lu.r0))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($author$project$Components$Produits$StructureCatalogue$Informations$View$nomDuType, i18n, code))
							]));
				},
				A2(
					$author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$proposes,
					!_Utils_eq(model.BX, $elm$core$Maybe$Nothing),
					model.J_)));
	});
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerFacultative = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.drawer.facultative', _List_Nil, 'Facultative');
};
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerObligatoireCourt = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.drawer.obligatoire.court', _List_Nil, 'Obligatoire');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$typeEtObligation = F3(
	function (i18n, champ, obligatoire) {
		var type_ = function () {
			var _v0 = champ.r0;
			if (_v0.$ === 10) {
				var mesure = _v0.a;
				return A2($author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeDeChamp, i18n, $author$project$Components$Shared$EditeurDeSchema$Vocabulaire$typeMesure) + (' · ' + mesure.sa);
			} else {
				var autre = _v0;
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$View$typeDuChamp, i18n, autre);
			}
		}();
		return type_ + (' · ' + (obligatoire ? $author$project$I18n$Cles$produitsParcoursInformationsDrawerObligatoireCourt(i18n) : $author$project$I18n$Cles$produitsParcoursInformationsDrawerFacultative(i18n)));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$typeDeLInformation = F3(
	function (i18n, model, lue) {
		var _v0 = model._;
		if (!_v0.$) {
			var edite = _v0.a;
			var unites = A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.sb;
					},
					model.AM));
			var gestes = $author$project$Components$Produits$StructureCatalogue$Informations$View$gestesDeType(edite);
			return A2(
				$elm$core$List$cons,
				A2(
					$author$project$Components$Produits$StructureCatalogue$Informations$View$champDeListe,
					$author$project$I18n$Cles$produitsParcoursInformationsAjoutType(i18n),
					A4($author$project$Components$Produits$StructureCatalogue$Informations$View$selecteurDeType, i18n, model, gestes, edite)),
				A5($author$project$Components$Produits$StructureCatalogue$Informations$View$precisions, i18n, gestes, model, edite, unites));
		} else {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('type')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A3($author$project$Components$Produits$StructureCatalogue$Informations$View$typeEtObligation, i18n, lue.uN, model.c_))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('figee')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$I18n$Cles$produitsParcoursInformationsDrawerFigee(i18n))
						]))
				]);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$contenu = F4(
	function (i18n, model, portee, lue) {
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Messages$View$view,
					i18n,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Maybe$map, $elm$core$List$singleton, model.aL))),
					A4($author$project$Components$Produits$StructureCatalogue$Informations$View$issueDuRefus, i18n, model, portee, lue),
					A3(
					$author$project$Components$Produits$StructureCatalogue$Informations$View$section,
					'nom',
					$author$project$I18n$Cles$produitsParcoursInformationsDrawerNom(i18n),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('valeur')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(lue.uN.Bl)
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('traduction')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$produitsParcoursInformationsDrawerAnglais,
										i18n,
										{
											Dj: A2(
												$author$project$Components$Shared$LibellesParLangue$Model$lire,
												'en',
												$author$project$Components$Produits$StructureCatalogue$Informations$Model$saisieDe(lue.uN).R)
										}))
								])),
							A3($author$project$Components$Produits$StructureCatalogue$Informations$View$renommer, i18n, model, portee)
						])),
					A3(
					$author$project$Components$Produits$StructureCatalogue$Informations$View$section,
					'saisie',
					$author$project$I18n$Cles$produitsParcoursInformationsDrawerSaisie(i18n),
					_Utils_ap(
						A3($author$project$Components$Produits$StructureCatalogue$Informations$View$typeDeLInformation, i18n, model, lue),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$fieldset,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('form-item')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$input,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('switch'),
												$rtfeldman$elm_css$Html$Styled$Attributes$id('information-obligatoire'),
												$rtfeldman$elm_css$Html$Styled$Attributes$checked(model.c_),
												$rtfeldman$elm_css$Html$Styled$Events$onCheck($author$project$Components$Produits$StructureCatalogue$Update$ObligationDInformationBasculee)
											]),
										_List_Nil),
										A2(
										$rtfeldman$elm_css$Html$Styled$label,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$for('information-obligatoire')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$produitsParcoursInformationsDrawerObligatoire(i18n))
											]))
									]))
							])))
				]),
			_Utils_ap(
				A2($author$project$Components$Produits$StructureCatalogue$Informations$View$sectionDesMinima, i18n, model),
				_List_fromArray(
					[
						A3(
						$author$project$Components$Produits$StructureCatalogue$Informations$View$section,
						'ordre',
						$author$project$I18n$Cles$produitsParcoursInformationsDrawerOrdre(i18n),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$ul,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('ordre')
									]),
								A4(
									$author$project$Components$Produits$StructureCatalogue$Informations$View$lignesDOrdre,
									i18n,
									model,
									lue.uN.dy,
									A2($author$project$Components$Produits$StructureCatalogue$Informations$View$champsDe, portee, model.AM)))
							])),
						A4(
						$author$project$Components$Produits$StructureCatalogue$Informations$View$masquerOuReafficher,
						i18n,
						portee,
						A3($author$project$Components$Produits$StructureCatalogue$Informations$Model$renseignees, portee, model.AM, lue.uN.dy),
						lue),
						A4($author$project$Components$Produits$StructureCatalogue$Informations$View$supprimer, i18n, model, portee, lue),
						A4($author$project$Components$Produits$StructureCatalogue$Informations$View$deplacer, i18n, model, portee, lue)
					])));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$enteteDuPorteur = F3(
	function (i18n, model, portee) {
		var _v0 = model.h$;
		if (_v0.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var structure = _v0.a;
			var _v1 = A2($author$project$Components$Produits$StructureCatalogue$Typologies$Model$reglee, model.r6, structure.vk);
			if (!_v1.$) {
				var typologie = _v1.a;
				var colonnes = A3($author$project$Components$Produits$StructureCatalogue$Valeurs$Lecture$colonnes, model, structure, typologie);
				return A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						A3(
							$author$project$Components$Produits$StructureCatalogue$Informations$View$entete,
							i18n,
							$author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(typologie),
							colonnes),
						function (_v2) {
							var titre = _v2.b;
							var sous = _v2.c;
							return _Utils_Tuple2(titre, sous);
						}),
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Components$Produits$StructureCatalogue$Informations$Boites$porteeDe(typologie.Aq),
								$elm$core$Basics$eq(portee)),
							$author$project$Components$Produits$StructureCatalogue$Informations$Boites$boitesDe(colonnes))));
			} else {
				return _Utils_eq(portee, $author$project$Components$Produits$StructureCatalogue$Informations$API$QueryAPIModel$Catalogue) ? $elm$core$Maybe$Just(
					_Utils_Tuple2(
						$author$project$I18n$Cles$produitsParcoursInformationsBoiteCatalogueTitre(i18n),
						$author$project$I18n$Cles$produitsParcoursInformationsBoiteCatalogueSous(i18n))) : $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerKicker = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.drawer.kicker', _List_Nil, 'Information');
};
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerKickerDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.parcours.informations.drawer.kicker.de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'portee',
					$author$project$I18n$Traductions$Chaine(p.F$))
				]),
			'Information · ' + p.F$);
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$kickerDInformation = F3(
	function (i18n, model, portee) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Cles$produitsParcoursInformationsDrawerKicker(i18n),
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var titre = _v0.a;
					return A2(
						$author$project$I18n$Cles$produitsParcoursInformationsDrawerKickerDe,
						i18n,
						{F$: titre});
				},
				A3($author$project$Components$Produits$StructureCatalogue$Informations$View$enteteDuPorteur, i18n, model, portee)));
	});
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.drawer.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$information = F2(
	function (i18n, model) {
		var ouverte = A2(
			$elm$core$Maybe$andThen,
			function (visee) {
				return A2(
					$elm$core$Maybe$map,
					function (lue) {
						return _Utils_Tuple2(visee.F$, lue);
					},
					A3($author$project$Components$Produits$StructureCatalogue$Informations$Model$trouvee, visee.F$, visee.dy, model.AM));
			},
			model.d5);
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Produits$StructureCatalogue$Update$DeLInformation,
			{
				fs: {
					sR: (!_Utils_eq(ouverte, $elm$core$Maybe$Nothing)) && (!$author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model)),
					Bl: _Utils_eq(ouverte, $elm$core$Maybe$Nothing) ? '' : $author$project$I18n$Cles$produitsParcoursInformationsDrawerEnregistrer(i18n),
					C$: $author$project$Components$Produits$StructureCatalogue$Update$InformationEnregistree
				},
				fZ: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (_v0) {
							var portee = _v0.a;
							var lue = _v0.b;
							return A4($author$project$Components$Produits$StructureCatalogue$Informations$View$contenu, i18n, model, portee, lue);
						},
						ouverte)),
				A6: A2(
					$elm$core$Maybe$map,
					function (_v1) {
						var portee = _v1.a;
						return A3($author$project$Components$Produits$StructureCatalogue$Informations$View$kickerDInformation, i18n, model, portee);
					},
					ouverte),
				Bc: false,
				h6: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$second,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.uN;
								},
								function ($) {
									return $.Bl;
								})),
						ouverte))
			},
			model.dL);
	});
var $author$project$I18n$Cles$produitsParcoursInformationsCreerSousTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.parcours.informations.creer.sous-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'portee',
					$author$project$I18n$Traductions$Chaine(p.F$))
				]),
			p.F$ + ' · bibliothèque de champs');
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$nouveauChamp = F2(
	function (i18n, model) {
		var vue = model.oP;
		var sousTitre = function (portee) {
			return A2(
				$author$project$I18n$Cles$produitsParcoursInformationsCreerSousTitre,
				i18n,
				{
					F$: A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							$elm$core$Tuple$first,
							A3($author$project$Components$Produits$StructureCatalogue$Informations$View$enteteDuPorteur, i18n, model, portee)))
				});
		};
		return A3(
			$author$project$Components$Parametrage$NouveauChamp$View$dialogues,
			i18n,
			$author$project$Components$Produits$StructureCatalogue$Update$DuNouveauChamp,
			_Utils_update(
				vue,
				{
					ew: A2(
						$elm$core$Maybe$map,
						function (ouverture) {
							var _v0 = model.oQ;
							if (!_v0.$) {
								var portee = _v0.a;
								return _Utils_update(
									ouverture,
									{
										aO: $author$project$I18n$Traductions$tel(
											sousTitre(portee))
									});
							} else {
								return ouverture;
							}
						},
						vue.ew)
				}));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$LibelleDeListeSaisi = F2(
	function (a, b) {
		return {$: 150, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Update$NouvelleListeDemandee = {$: 154};
var $author$project$Components$Produits$StructureCatalogue$Update$ValeursDeListeSaisies = function (a) {
	return {$: 151, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$idDeLaPorteeDeListe = 'nouvelle-liste-portee';
var $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$idDesValeursDeListe = 'nouvelle-liste-valeurs';
var $author$project$Components$Produits$StructureCatalogue$Update$AutreNomDeListeVoulu = {$: 153};
var $author$project$Components$Produits$StructureCatalogue$Update$ListeExistanteChoisie = function (a) {
	return {$: 152, a: a};
};
var $author$project$I18n$Cles$produitsParcoursInformationsNouvelleListeAutreNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.nouvelle-liste.autre-nom', _List_Nil, 'Choisir un autre nom');
};
var $author$project$I18n$Cles$produitsParcoursInformationsNouvelleListeChoisirExistante = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.nouvelle-liste.choisir-existante', _List_Nil, 'Choisir la liste existante');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$issueDuNomPris = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.ed, model.aL);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var liste = _v0.a.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('issue')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						2,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('choisir-la-liste'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Produits$StructureCatalogue$Update$ListeExistanteChoisie(liste))
							]),
						$author$project$I18n$Cles$produitsParcoursInformationsNouvelleListeChoisirExistante(i18n)),
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						2,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('autre-nom'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Produits$StructureCatalogue$Update$AutreNomDeListeVoulu)
							]),
						$author$project$I18n$Cles$produitsParcoursInformationsNouvelleListeAutreNom(i18n))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$I18n$Cles$produitsParcoursInformationsNouvelleListeCreer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.nouvelle-liste.creer', _List_Nil, 'Créer la liste');
};
var $author$project$I18n$Cles$produitsParcoursInformationsNouvelleListeKicker = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.nouvelle-liste.kicker', _List_Nil, 'Liste partagée · portée Catalogue');
};
var $author$project$I18n$Cles$produitsParcoursInformationsNouvelleListeNom = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.nouvelle-liste.nom', _List_Nil, 'Nom de la liste');
};
var $author$project$I18n$Cles$produitsParcoursInformationsNouvelleListePorteeAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.nouvelle-liste.portee.aide', _List_Nil, 'Étendue aux parties prenantes depuis Paramétrage › Listes.');
};
var $author$project$I18n$Cles$produitsParcoursInformationsNouvelleListeTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.nouvelle-liste.titre', _List_Nil, 'Créer une liste');
};
var $author$project$I18n$Cles$produitsParcoursInformationsNouvelleListeValeurs = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.nouvelle-liste.valeurs', _List_Nil, 'Valeurs');
};
var $author$project$I18n$Cles$produitsParcoursInformationsNouvelleListeValeursAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.informations.nouvelle-liste.valeurs.aide', _List_Nil, 'Une valeur par ligne. L\'ordre, les attributs et les traductions se règlent ensuite dans Paramétrage › Listes.');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$View$nouvelleListe = F2(
	function (i18n, model) {
		var ouvert = $author$project$Components$Shared$Drawer$Model$estOuvert(model.T);
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Produits$StructureCatalogue$Update$DeLaNouvelleListe,
			{
				fs: {
					sR: ouvert && (!$author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model)),
					Bl: ouvert ? $author$project$I18n$Cles$produitsParcoursInformationsNouvelleListeCreer(i18n) : '',
					C$: $author$project$Components$Produits$StructureCatalogue$Update$NouvelleListeDemandee
				},
				fZ: ouvert ? _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Messages$View$view,
						i18n,
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2($elm$core$Maybe$map, $elm$core$List$singleton, model.aL))),
						A2($author$project$Components$Produits$StructureCatalogue$Informations$View$issueDuNomPris, i18n, model),
						A3(
						$author$project$Components$Produits$StructureCatalogue$Informations$View$section,
						'nom',
						$author$project$I18n$Cles$produitsParcoursInformationsNouvelleListeNom(i18n),
						_List_fromArray(
							[
								A3(
								$author$project$Components$Shared$LibellesParLangue$View$nomsDeLangueSeuls,
								i18n,
								_List_fromArray(
									[
										$author$project$Components$Produits$StructureCatalogue$Controles$entreeEnvoie($author$project$Components$Produits$StructureCatalogue$Update$NouvelleListeDemandee)
									]),
								{
									go: A3($author$project$Components$Produits$StructureCatalogue$Controles$obligatoireManquant, i18n, model.am.b5, model.am.R),
									Ba: A2(
										$elm$core$List$filter,
										function (langue) {
											return langue.vx === 'fr';
										},
										$author$project$Referentiel$Langues$desLibelles),
									Bl: $author$project$I18n$Cles$produitsStructureLibelle(i18n),
									hg: $author$project$Components$Produits$StructureCatalogue$Update$LibelleDeListeSaisi,
									pv: $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$prefixeDuLibelleDeListe,
									fm: function (code) {
										return A2($author$project$Components$Shared$LibellesParLangue$Model$lire, code, model.am.R);
									}
								})
							])),
						A3(
						$author$project$Components$Produits$StructureCatalogue$Informations$View$section,
						'valeurs',
						$author$project$I18n$Cles$produitsParcoursInformationsNouvelleListeValeurs(i18n),
						_List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Champ$View$zoneDeTexte,
								{
									go: $elm$core$Maybe$Nothing,
									Aq: $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$idDesValeursDeListe,
									Bl: $author$project$I18n$Cles$produitsParcoursInformationsNouvelleListeValeurs(i18n),
									he: false
								},
								{hg: $author$project$Components$Produits$StructureCatalogue$Update$ValeursDeListeSaisies, fm: model.df}),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsParcoursInformationsNouvelleListeValeursAide(i18n))
									]))
							])),
						A3(
						$author$project$Components$Produits$StructureCatalogue$Informations$View$section,
						'portee',
						$author$project$I18n$Cles$listesPortee(i18n),
						_List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Champ$View$texteEnLectureSeule,
								{
									go: $elm$core$Maybe$Nothing,
									Aq: $author$project$Components$Produits$StructureCatalogue$Informations$ChangerDeType$idDeLaPorteeDeListe,
									Bl: $author$project$I18n$Cles$listesPortee(i18n),
									he: false
								},
								{
									fm: $author$project$I18n$Cles$listesPorteeCatalogue(i18n)
								}),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('aide')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsParcoursInformationsNouvelleListePorteeAide(i18n))
									]))
							]))
					]) : _List_Nil,
				A6: ouvert ? $elm$core$Maybe$Just(
					$author$project$I18n$Cles$produitsParcoursInformationsNouvelleListeKicker(i18n)) : $elm$core$Maybe$Nothing,
				Bc: false,
				h6: ouvert ? $author$project$I18n$Cles$produitsParcoursInformationsNouvelleListeTitre(i18n) : ''
			},
			model.T);
	});
var $author$project$I18n$Cles$produitsParametrageCatalogue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parametrage.catalogue', _List_Nil, 'Catalogue');
};
var $author$project$I18n$Cles$produitsParcoursDescription = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.description', _List_Nil, 'Cinq étapes, dans l\'ordre. À chacune, l\'aperçu de droite montre ce que votre catalogue est devenu.');
};
var $author$project$I18n$Cles$produitsParcoursTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.parcours.titre', _List_Nil, 'Construire votre catalogue');
};
var $author$project$I18n$Cles$produitsEtagesRangementPortee = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.etages.rangement.portee',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'article',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeArticle(p.i4))),
					_Utils_Tuple2(
					'typologie',
					$author$project$I18n$Traductions$Chaine(p.r3))
				]),
			'Les étages ' + (function () {
				var _v0 = p.i4;
				switch (_v0) {
					case 0:
						return 'de ' + p.r3;
					case 1:
						return 'de l\'' + $elm$core$String$toLower(p.r3);
					case 2:
						return 'de la ' + $elm$core$String$toLower(p.r3);
					case 3:
						return 'du ' + $elm$core$String$toLower(p.r3);
					default:
						return 'de ' + p.r3;
				}
			}() + (', du plus large au plus précis. L\'ordre vaut pour ' + (function () {
				var _v1 = p.i4;
				switch (_v1) {
					case 0:
						return p.r3;
					case 1:
						return 'l\'' + $elm$core$String$toLower(p.r3);
					case 2:
						return 'la ' + $elm$core$String$toLower(p.r3);
					case 3:
						return 'le ' + $elm$core$String$toLower(p.r3);
					default:
						return p.r3;
				}
			}() + ' seulement. Sous la catégorie viennent toujours, dans cet ordre, le produit s\'il est utilisé et la référence.'))));
	});
var $author$project$I18n$Cles$produitsEtagesRangementPorteeReorganiser = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.etages.rangement.portee-reorganiser',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'article',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeArticle(p.i4))),
					_Utils_Tuple2(
					'typologie',
					$author$project$I18n$Traductions$Chaine(p.r3))
				]),
			'Les étages ' + (function () {
				var _v0 = p.i4;
				switch (_v0) {
					case 0:
						return 'de ' + p.r3;
					case 1:
						return 'de l\'' + $elm$core$String$toLower(p.r3);
					case 2:
						return 'de la ' + $elm$core$String$toLower(p.r3);
					case 3:
						return 'du ' + $elm$core$String$toLower(p.r3);
					default:
						return 'de ' + p.r3;
				}
			}() + (', du plus large au plus précis. L\'ordre vaut pour ' + (function () {
				var _v1 = p.i4;
				switch (_v1) {
					case 0:
						return p.r3;
					case 1:
						return 'l\'' + $elm$core$String$toLower(p.r3);
					case 2:
						return 'la ' + $elm$core$String$toLower(p.r3);
					case 3:
						return 'le ' + $elm$core$String$toLower(p.r3);
					default:
						return p.r3;
				}
			}() + ' seulement. Chaque valeur se range sous une valeur de l\'étage du dessus. Changer l\'ordre réorganise le rangement : un aperçu dit avant ce qui bouge.'))));
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$View$portee = F3(
	function (i18n, model, typologie) {
		var phrase = function () {
			var _v0 = model.q;
			if (_v0.$ === 2) {
				return $author$project$I18n$Cles$produitsEtagesRangementPorteeReorganiser(i18n);
			} else {
				return $author$project$I18n$Cles$produitsEtagesRangementPortee(i18n);
			}
		}();
		return phrase(
			$author$project$Components$Produits$StructureCatalogue$Etages$View$nomDeTypologie(typologie));
	});
var $author$project$I18n$Cles$produitsEtagesRangementTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.etages.rangement.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'article',
					$author$project$I18n$Traductions$Option(
						$author$project$I18n$Choix$codeArticle(p.i4))),
					_Utils_Tuple2(
					'typologie',
					$author$project$I18n$Traductions$Chaine(p.r3))
				]),
			'Rangement ' + function () {
				var _v0 = p.i4;
				switch (_v0) {
					case 0:
						return 'de ' + p.r3;
					case 1:
						return 'de l\'' + $elm$core$String$toLower(p.r3);
					case 2:
						return 'de la ' + $elm$core$String$toLower(p.r3);
					case 3:
						return 'du ' + $elm$core$String$toLower(p.r3);
					default:
						return 'de ' + p.r3;
				}
			}());
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$View$rangement = F2(
	function (i18n, model) {
		var reglee = A2(
			$elm$core$Maybe$andThen,
			function (structure) {
				return A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(structure),
					A2($author$project$Components$Produits$StructureCatalogue$Typologies$Model$reglee, model.r6, structure.vk));
			},
			model.h$);
		var recouvert = A2(
			$elm$core$List$any,
			$author$project$Components$Shared$Drawer$Model$estOuvert,
			_List_fromArray(
				[model.hL, model.y, model.bg]));
		var ouvert = $author$project$Components$Shared$Drawer$Model$estOuvert(model.bZ);
		return A4(
			$author$project$Components$Shared$Drawer$View$consultation,
			i18n,
			$author$project$Components$Produits$StructureCatalogue$Update$DuRangementDeTypologie,
			{
				fZ: function () {
					var _v0 = _Utils_Tuple2(ouvert, reglee);
					if (_v0.a && (!_v0.b.$)) {
						var _v1 = _v0.b.a;
						var structure = _v1.a;
						var typologie = _v1.b;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('portee')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A3($author$project$Components$Produits$StructureCatalogue$Etages$View$portee, i18n, model, typologie))
									])),
								A2(
								$author$project$Components$Shared$Messages$View$view,
								i18n,
								recouvert ? _List_Nil : A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2($elm$core$Maybe$map, $elm$core$List$singleton, model.aL))),
								A2(
								$rtfeldman$elm_css$Html$Styled$section,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('etages-de-typologie')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('section-content')
											]),
										_List_fromArray(
											[
												A5($author$project$Components$Produits$StructureCatalogue$Etages$View$liste, i18n, 1, model, structure, typologie),
												A5($author$project$Components$Produits$StructureCatalogue$Etages$View$apercu, i18n, 1, model, structure, typologie),
												A5(
												$author$project$Components$Produits$StructureCatalogue$Etages$View$ajouts,
												i18n,
												1,
												$author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model),
												structure,
												typologie)
											]))
									]))
							]);
					} else {
						return _List_Nil;
					}
				}(),
				G8: recouvert,
				h6: function () {
					var _v2 = _Utils_Tuple2(ouvert, reglee);
					if (_v2.a && (!_v2.b.$)) {
						var _v3 = _v2.b.a;
						var typologie = _v3.b;
						return A2(
							$author$project$I18n$Cles$produitsEtagesRangementTitre,
							i18n,
							$author$project$Components$Produits$StructureCatalogue$Etages$View$nomDeTypologie(typologie));
					} else {
						return '';
					}
				}()
			},
			model.bZ);
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Boites$takeWhile = F2(
	function (voulu, liste) {
		if (!liste.b) {
			return _List_Nil;
		} else {
			var premier = liste.a;
			var suite = liste.b;
			return voulu(premier) ? A2(
				$elm$core$List$cons,
				premier,
				A2($author$project$Components$Produits$StructureCatalogue$Informations$Boites$takeWhile, voulu, suite)) : _List_Nil;
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Boites$contexteDuRattachement = F3(
	function (typologie, colonnes, portee) {
		var genreDe = function (boite) {
			var _v1 = _Utils_Tuple2(portee, boite);
			if (_v1.a.$ === 3) {
				return $elm$core$Maybe$Just('type');
			} else {
				if ((!_v1.b.$) && (_v1.b.a.$ === 2)) {
					var noeud = _v1.b.a.a;
					return A2(
						$elm$core$Maybe$andThen,
						function (colonne) {
							var _v2 = colonne.md.xt;
							if (!_v2.$) {
								var code = _v2.a;
								return A2(
									$elm$core$List$member,
									code,
									_List_fromArray(
										[$author$project$Catalogue$Vocabulaire$codeMarque, $author$project$Catalogue$Vocabulaire$codeGamme])) ? $elm$core$Maybe$Just(code) : $elm$core$Maybe$Nothing;
							} else {
								return $elm$core$Maybe$Nothing;
							}
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.Dj;
									},
									$elm$core$Basics$eq(noeud.md)),
								colonnes)));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		};
		var boites = $author$project$Components$Produits$StructureCatalogue$Informations$Boites$boitesDe(colonnes);
		var cible = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Produits$StructureCatalogue$Informations$Boites$porteeDe(typologie),
					$elm$core$Basics$eq(portee)),
				boites));
		var auDessus = A2(
			$author$project$Components$Produits$StructureCatalogue$Informations$Boites$takeWhile,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$Produits$StructureCatalogue$Informations$Boites$porteeDe(typologie),
				$elm$core$Basics$neq(portee)),
			boites);
		return {
			th: A2(
				$elm$core$List$filterMap,
				function (boite) {
					if (boite.$ === 2) {
						var noeud = boite.a;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(
								noeud.Dj,
								A2($author$project$Components$Produits$StructureCatalogue$Informations$Boites$porteeDe, typologie, boite)));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				auDessus),
			M: genreDe(cible)
		};
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$contexteDuRattachement = F2(
	function (model, portee) {
		return A2(
			$elm$core$Maybe$withDefault,
			{th: _List_Nil, M: $elm$core$Maybe$Nothing},
			A2(
				$elm$core$Maybe$andThen,
				function (structure) {
					return A2(
						$elm$core$Maybe$map,
						function (typologie) {
							return A3(
								$author$project$Components$Produits$StructureCatalogue$Informations$Boites$contexteDuRattachement,
								typologie.Aq,
								A3($author$project$Components$Produits$StructureCatalogue$Valeurs$Lecture$colonnes, model, structure, typologie),
								portee);
						},
						A2($author$project$Components$Produits$StructureCatalogue$Typologies$Model$reglee, model.r6, structure.vk));
				},
				model.h$));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$RattachementDInformationDemande = {$: 144};
var $author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$champChoisi = F2(
	function (champs, rattachement) {
		return A2(
			$elm$core$Maybe$andThen,
			function (id) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(id)),
						champs));
			},
			rattachement.vd);
	});
var $author$project$Components$Produits$StructureCatalogue$Update$FormeDeChampChoisie = function (a) {
	return {$: 142, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Update$RechercheDeChampSaisie = function (a) {
	return {$: 141, a: a};
};
var $author$project$I18n$Cles$produitsInformationsRattacherApercuEffet = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.rattacher.apercu-effet', _List_Nil, 'Rattaché ici, vide sur les fiches jusqu\'à saisie.');
};
var $author$project$I18n$Cles$produitsInformationsRattacherApercuNote = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.rattacher.apercu-note', _List_Nil, 'Reste un champ de la bibliothèque, portée Catalogue : le rattacher ne le modifie pas.');
};
var $author$project$I18n$Cles$produitsInformationsRattacherApercuTexte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.informations.rattacher.apercu-texte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'libelle',
					$author$project$I18n$Traductions$Chaine(p.Bl)),
					_Utils_Tuple2(
					'forme',
					$author$project$I18n$Traductions$Chaine(p.gB))
				]),
			p.Bl + (' · ' + p.gB));
	});
var $author$project$I18n$Cles$produitsInformationsRattacherApercuTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.informations.rattacher.apercu-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'porteur',
					$author$project$I18n$Traductions$Chaine(p.c0))
				]),
			'Aperçu sur ' + p.c0);
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$RattachementView$apercu = F3(
	function (i18n, porteur, choisi) {
		if (!choisi.$) {
			var lu = choisi.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$produitsInformationsRattacherApercuTitre,
									i18n,
									{c0: porteur}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$produitsInformationsRattacherApercuTexte,
									i18n,
									{gB: lu.rU, Bl: lu.Bl}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsInformationsRattacherApercuEffet(i18n))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsInformationsRattacherApercuNote(i18n))
							]))
					]));
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('apercu')
					]),
				_List_Nil);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$RattachementView$clesDuPorteur = F2(
	function (model, portee) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.dw;
					},
					$elm$core$List$map(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.uN;
							},
							function ($) {
								return $.dy;
							}))),
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.F3;
						},
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$filter(
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.F$;
									},
									$elm$core$Basics$eq(portee))),
							$elm$core$List$head)),
					model.AM)));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$formes = function (champs) {
	return $elm$core$Set$toList(
		$elm$core$Set$fromList(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.rU;
				},
				champs)));
};
var $author$project$I18n$Cles$produitsInformationsRattacherAucun = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.rattacher.aucun', _List_Nil, 'Aucun champ de la bibliothèque ne correspond.');
};
var $author$project$I18n$Cles$produitsInformationsRattacherCompte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.informations.rattacher.compte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'affiches',
					$author$project$I18n$Traductions$Entier(p.s3)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			((!p.s3) || (p.s3 === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.s3) + (' champ sur ' + p.JE)) : (A2($author$project$I18n$Nombre$formater, 0, p.s3) + (' champs sur ' + p.JE)));
	});
var $author$project$I18n$Cles$produitsInformationsRattacherCompteAide = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.rattacher.compte-aide', _List_Nil, 'les champs déjà portés ici sont grisés ; un champ porté par le parent reste choisissable, la source est nommée.');
};
var $author$project$I18n$Cles$produitsInformationsRattacherForme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.rattacher.forme', _List_Nil, 'Forme');
};
var $author$project$I18n$Cles$produitsInformationsRattacherFormeToutes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.rattacher.forme-toutes', _List_Nil, 'Toutes les formes');
};
var $author$project$I18n$Cles$produitsInformationsRattacherPortee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.rattacher.portee', _List_Nil, 'Portée');
};
var $author$project$I18n$Cles$produitsInformationsRattacherPorteeCatalogue = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.rattacher.portee-catalogue', _List_Nil, 'Catalogue');
};
var $author$project$I18n$Cles$produitsInformationsRattacherRecherche = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.rattacher.recherche', _List_Nil, 'Rechercher par nom dans la bibliothèque');
};
var $author$project$I18n$Cles$produitsInformationsRattacherTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.rattacher.titre', _List_Nil, 'Rattacher un champ existant');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$proposes = function (rattachement) {
	var cherche = $elm$core$String$toLower(
		$elm$core$String$trim(rattachement.hC));
	return $elm$core$List$filter(
		function (lu) {
			return A2($author$project$Components$Shared$Bibliotheque$Domaine$accepte, 0, lu.F$) && (A2(
				$elm$core$String$contains,
				cherche,
				$elm$core$String$toLower(lu.Bl)) && ((rattachement.gB === '') || _Utils_eq(lu.rU, rattachement.gB)));
		});
};
var $author$project$Components$Produits$StructureCatalogue$Update$ChampARattacherChoisi = function (a) {
	return {$: 143, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$dejaSurUnAncetre = F2(
	function (ancetres, lu) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$first,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$second,
						$elm$core$List$member(lu.dy)),
					$elm$core$List$reverse(ancetres))));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$RattachementView$etagesAdmis = F2(
	function (i18n, etages) {
		return A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				$author$project$Catalogue$Vocabulaire$etageAdmisAuRattachement(i18n),
				etages));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$nonAdmis = F2(
	function (genre, lu) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (g) {
					return !A2($elm$core$List$member, g, lu.yG);
				},
				genre));
	});
var $author$project$I18n$Cles$produitsInformationsRattacherNonAdmisGamme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.rattacher.non-admis.gamme', _List_Nil, 'non admis à une gamme');
};
var $author$project$I18n$Cles$produitsInformationsRattacherNonAdmisMarque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.rattacher.non-admis.marque', _List_Nil, 'non admis à une marque');
};
var $author$project$I18n$Cles$produitsInformationsRattacherNonAdmisType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.rattacher.non-admis.type', _List_Nil, 'non admis à une catégorie');
};
var $author$project$Catalogue$Vocabulaire$nonAdmisAuRattachement = F2(
	function (i18n, code) {
		switch (code) {
			case 'marque':
				return $author$project$I18n$Cles$produitsInformationsRattacherNonAdmisMarque(i18n);
			case 'type':
				return $author$project$I18n$Cles$produitsInformationsRattacherNonAdmisType(i18n);
			default:
				return $author$project$I18n$Cles$produitsInformationsRattacherNonAdmisGamme(i18n);
		}
	});
var $author$project$I18n$Cles$produitsInformationsRattacherDejaIci = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.rattacher.deja-ici', _List_Nil, 'déjà ici');
};
var $author$project$I18n$Cles$produitsInformationsRattacherDejaSur = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.informations.rattacher.deja-sur',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'déjà sur ' + p.Dj);
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$RattachementView$etiquette = F5(
	function (i18n, genre, ancetres, dejaIci, lu) {
		if (dejaIci) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('tag', true),
								_Utils_Tuple2('gris', true)
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsInformationsRattacherDejaIci(i18n))
					]));
		} else {
			var _v0 = A2($author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$dejaSurUnAncetre, ancetres, lu);
			if (!_v0.$) {
				var nom = _v0.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('tag', true),
									_Utils_Tuple2('gris', true)
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$I18n$Cles$produitsInformationsRattacherDejaSur,
								i18n,
								{Dj: nom}))
						]));
			} else {
				return A2($author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$nonAdmis, genre, lu) ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('tag', true),
									_Utils_Tuple2('alerte', true)
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$Catalogue$Vocabulaire$nonAdmisAuRattachement,
								i18n,
								A2($elm$core$Maybe$withDefault, '', genre)))
						])) : A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('tag', true),
									_Utils_Tuple2('etages', true)
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Components$Produits$StructureCatalogue$Informations$RattachementView$etagesAdmis, i18n, lu.yG))
						]));
			}
		}
	});
var $author$project$I18n$Cles$produitsInformationsRattacherLigne = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.informations.rattacher.ligne',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'forme',
					$author$project$I18n$Traductions$Chaine(p.gB))
				]),
			p.gB + ' · portée Catalogue');
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$RattachementView$proposition = F6(
	function (i18n, model, genre, cles, ancetres, lu) {
		var nonAdmis = A2($author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$nonAdmis, genre, lu);
		var dejaIci = A2($author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$dejaIci, cles, lu);
		var choisi = _Utils_eq(
			model.pN.vd,
			$elm$core$Maybe$Just(lu.Aq));
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('proposition'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('on', choisi),
							_Utils_Tuple2('deja-ici', dejaIci),
							_Utils_Tuple2('non-admis', nonAdmis && (!dejaIci))
						])),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'radio'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'aria-checked',
					choisi ? 'true' : 'false'),
					$rtfeldman$elm_css$Html$Styled$Attributes$disabled(dejaIci),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Components$Produits$StructureCatalogue$Update$ChampARattacherChoisi(lu.Aq))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('radio'),
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('on', choisi)
								])),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(lu.Bl)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$author$project$I18n$Cles$produitsInformationsRattacherLigne,
										i18n,
										{gB: lu.rU}))
								]))
						])),
					A5($author$project$Components$Produits$StructureCatalogue$Informations$RattachementView$etiquette, i18n, genre, ancetres, dejaIci, lu)
				]));
	});
var $author$project$I18n$Cles$produitsInformationsRattacherHorsPorteeNiveauGamme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.rattacher.hors-portee-niveau.gamme', _List_Nil, 'à une gamme');
};
var $author$project$I18n$Cles$produitsInformationsRattacherHorsPorteeNiveauMarque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.rattacher.hors-portee-niveau.marque', _List_Nil, 'à une marque');
};
var $author$project$I18n$Cles$produitsInformationsRattacherHorsPorteeNiveauType = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.rattacher.hors-portee-niveau.type', _List_Nil, 'à une catégorie');
};
var $author$project$Catalogue$Vocabulaire$niveauRefuseAuRattachement = F2(
	function (i18n, code) {
		switch (code) {
			case 'marque':
				return $author$project$I18n$Cles$produitsInformationsRattacherHorsPorteeNiveauMarque(i18n);
			case 'type':
				return $author$project$I18n$Cles$produitsInformationsRattacherHorsPorteeNiveauType(i18n);
			default:
				return $author$project$I18n$Cles$produitsInformationsRattacherHorsPorteeNiveauGamme(i18n);
		}
	});
var $author$project$I18n$Cles$produitsInformationsRattacherElargir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.rattacher.elargir', _List_Nil, 'Élargir les étages de ce champ');
};
var $author$project$I18n$Cles$produitsInformationsRattacherHorsPorteeTexte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.informations.rattacher.hors-portee-texte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'etages',
					$author$project$I18n$Traductions$Chaine(p.yG))
				]),
			'Ses étages admis sont : ' + (p.yG + '. Rien n\'a été enregistré.'));
	});
var $author$project$I18n$Cles$produitsInformationsRattacherHorsPorteeTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.informations.rattacher.hors-portee-titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'champ',
					$author$project$I18n$Traductions$Chaine(p.uN)),
					_Utils_Tuple2(
					'niveau',
					$author$project$I18n$Traductions$Chaine(p.os))
				]),
			'« ' + (p.uN + (' » n\'est pas admis ' + (p.os + '.'))));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$RattachementView$refus = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.pN.pZ, model.dq);
		if (!_v0.a.$) {
			var refuse = _v0.a.a;
			var bibliotheque = _v0.b;
			var refuse_ = A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$filter(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Aq;
							},
							$elm$core$Basics$eq(refuse.uN))),
					$elm$core$List$head),
				bibliotheque);
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('alerte'),
						$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$idDuRefus),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'tabindex', '-1')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$strong,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2(
									$author$project$I18n$Cles$produitsInformationsRattacherHorsPorteeTitre,
									i18n,
									{
										uN: A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.Bl;
												},
												refuse_)),
										os: A2($author$project$Catalogue$Vocabulaire$niveauRefuseAuRattachement, i18n, refuse.md)
									}))
							])),
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$produitsInformationsRattacherHorsPorteeTexte,
							i18n,
							{
								yG: A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.yG;
											},
											$author$project$Components$Produits$StructureCatalogue$Informations$RattachementView$etagesAdmis(i18n)),
										refuse_))
							})),
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('lien'),
								$rtfeldman$elm_css$Html$Styled$Attributes$href(
								$author$project$Routes$Route$adresseDuChampDeLaBibliotheque(refuse.uN))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsInformationsRattacherElargir(i18n))
							]))
					]));
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$idDuRefus),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'tabindex', '-1')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Messages$View$view,
						i18n,
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2($elm$core$Maybe$map, $elm$core$List$singleton, model.aL)))
					]));
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$RattachementView$contenu = F6(
	function (i18n, model, porteur, contexte, champs, choisi) {
		var proposes = A2($author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$proposes, model.pN, champs);
		var cles = A2($author$project$Components$Produits$StructureCatalogue$Informations$RattachementView$clesDuPorteur, model, model.pN.F$);
		var ancetres = A2(
			$elm$core$List$map,
			function (_v0) {
				var nom = _v0.a;
				var portee = _v0.b;
				return _Utils_Tuple2(
					nom,
					A2($author$project$Components$Produits$StructureCatalogue$Informations$RattachementView$clesDuPorteur, model, portee));
			},
			contexte.th);
		return _List_fromArray(
			[
				A2($author$project$Components$Produits$StructureCatalogue$Informations$RattachementView$refus, i18n, model),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('filtres')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$input,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('search'),
								$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$idDeLaRecherche),
								$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(
								$author$project$I18n$Cles$produitsInformationsRattacherRecherche(i18n)),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-label',
								$author$project$I18n$Cles$produitsInformationsRattacherRecherche(i18n)),
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.pN.hC),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Produits$StructureCatalogue$Update$RechercheDeChampSaisie)
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$select,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-label',
								$author$project$I18n$Cles$produitsInformationsRattacherForme(i18n)),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Components$Produits$StructureCatalogue$Update$FormeDeChampChoisie)
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$rtfeldman$elm_css$Html$Styled$option,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value(''),
										$rtfeldman$elm_css$Html$Styled$Attributes$selected(model.pN.gB === '')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsInformationsRattacherFormeToutes(i18n))
									])),
							A2(
								$elm$core$List$map,
								function (forme) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$option,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$value(forme),
												$rtfeldman$elm_css$Html$Styled$Attributes$selected(
												_Utils_eq(model.pN.gB, forme))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(forme)
											]));
								},
								$author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$formes(champs)))),
						A2(
						$rtfeldman$elm_css$Html$Styled$select,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-label',
								$author$project$I18n$Cles$produitsInformationsRattacherPortee(i18n))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$option,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsInformationsRattacherPorteeCatalogue(i18n))
									]))
							]))
					])),
				$elm$core$List$isEmpty(proposes) ? A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('aucun')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$I18n$Cles$produitsInformationsRattacherAucun(i18n))
					])) : A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('propositions'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'radiogroup'),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'aria-label',
						$author$project$I18n$Cles$produitsInformationsRattacherTitre(i18n))
					]),
				A2(
					$elm$core$List$map,
					A5($author$project$Components$Produits$StructureCatalogue$Informations$RattachementView$proposition, i18n, model, contexte.M, cles, ancetres),
					proposes)),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2(
							$author$project$I18n$Cles$produitsInformationsRattacherCompte,
							i18n,
							{
								s3: $elm$core$List$length(proposes),
								JE: $elm$core$String$fromInt(
									$elm$core$List$length(champs))
							}) + (' · ' + $author$project$I18n$Cles$produitsInformationsRattacherCompteAide(i18n)))
					])),
				A3($author$project$Components$Produits$StructureCatalogue$Informations$RattachementView$apercu, i18n, porteur, choisi)
			]);
	});
var $author$project$I18n$Cles$produitsInformationsRattacherAnnuler = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.rattacher.annuler', _List_Nil, 'Annuler');
};
var $author$project$I18n$Cles$produitsInformationsRattacherUtilise = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.informations.rattacher.utilise',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Utilisé aujourd\'hui par ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' type de produit')) : ('Utilisé aujourd\'hui par ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' types de produit')));
	});
var $author$project$I18n$Cles$produitsInformationsRattacherValider = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.informations.rattacher.valider', _List_Nil, 'Rattacher');
};
var $author$project$Components$Produits$StructureCatalogue$Informations$RattachementView$drawer = F4(
	function (i18n, model, porteur, contexte) {
		var ouvert = $author$project$Components$Shared$Drawer$Model$estOuvert(model.pO);
		var champs = A2($elm$core$Maybe$withDefault, _List_Nil, model.dq);
		var choisi = A2($author$project$Components$Produits$StructureCatalogue$Informations$Rattachement$champChoisi, champs, model.pN);
		return A5(
			$author$project$Components$Shared$Drawer$View$viewAvecPiedLibre,
			i18n,
			{
				oJ: A2(
					$elm$core$Maybe$map,
					function (lu) {
						return A2(
							$author$project$I18n$Cles$produitsInformationsRattacherUtilise,
							i18n,
							{w: lu.sf});
					},
					choisi),
				HF: function (attributs) {
					return A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_Utils_ap(
							attributs,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Produits$StructureCatalogue$Update$DuRattachementDInformation($author$project$Components$Shared$Drawer$Update$Fermer))
								])),
						$author$project$I18n$Cles$produitsInformationsRattacherAnnuler(i18n));
				},
				Jb: _List_Nil
			},
			$author$project$Components$Produits$StructureCatalogue$Update$DuRattachementDInformation,
			{
				fs: {
					sR: ouvert && (!_Utils_eq(choisi, $elm$core$Maybe$Nothing)),
					Bl: ouvert ? $author$project$I18n$Cles$produitsInformationsRattacherValider(i18n) : '',
					C$: $author$project$Components$Produits$StructureCatalogue$Update$RattachementDInformationDemande
				},
				fZ: ouvert ? A6($author$project$Components$Produits$StructureCatalogue$Informations$RattachementView$contenu, i18n, model, porteur, contexte, champs, choisi) : _List_Nil,
				A6: ouvert ? $elm$core$Maybe$Just(porteur) : $elm$core$Maybe$Nothing,
				Bc: false,
				h6: ouvert ? $author$project$I18n$Cles$produitsInformationsRattacherTitre(i18n) : ''
			},
			model.pO);
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$rattachement = F2(
	function (i18n, model) {
		return A4(
			$author$project$Components$Produits$StructureCatalogue$Informations$RattachementView$drawer,
			i18n,
			model,
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$first,
					A3($author$project$Components$Produits$StructureCatalogue$Informations$View$enteteDuPorteur, i18n, model, model.pN.F$))),
			A2($author$project$Components$Produits$StructureCatalogue$Informations$View$contexteDuRattachement, model, model.pN.F$));
	});
var $author$project$Components$Produits$StructureCatalogue$Update$RenommageDEtageLibreDemande = {$: 82};
var $author$project$Components$Produits$StructureCatalogue$Update$EtageFormeElisionBasculee = F2(
	function (a, b) {
		return {$: 78, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Update$EtageFormeGenreChoisi = F2(
	function (a, b) {
		return {$: 77, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Update$EtageFormePlurielSaisi = F2(
	function (a, b) {
		return {$: 76, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$Model$prefixeDesFormes = 'renommage-etage-forme';
var $author$project$Components$Produits$StructureCatalogue$Etages$View$formes = F2(
	function (i18n, model) {
		return A2(
			$author$project$Components$Produits$StructureCatalogue$Etages$View$formesDuNom,
			i18n,
			{
				lS: $author$project$Components$Produits$StructureCatalogue$Update$EtageFormeElisionBasculee,
				mV: $author$project$Components$Produits$StructureCatalogue$Update$EtageFormeGenreChoisi,
				po: $author$project$Components$Produits$StructureCatalogue$Update$EtageFormePlurielSaisi,
				pv: $author$project$Components$Produits$StructureCatalogue$Etages$Model$prefixeDesFormes,
				c7: model.I,
				IN: function (code) {
					return A2($author$project$Components$Shared$LibellesParLangue$Model$lire, code, model.D.R);
				}
			});
	});
var $author$project$Components$Produits$StructureCatalogue$Etages$View$renommage = F2(
	function (i18n, model) {
		var fourni = A2(
			$elm$core$Maybe$andThen,
			$elm$core$Basics$identity,
			A3(
				$elm$core$Maybe$map2,
				F2(
					function (structure, cherche) {
						return A2(
							$elm$core$Maybe$map,
							$elm$core$Tuple$pair(structure),
							A2(
								$elm$core$Maybe$andThen,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.yG;
									},
									A2(
										$elm$core$Basics$composeR,
										$elm$core$List$filter(
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.Aq;
												},
												$elm$core$Basics$eq(cherche))),
										$elm$core$List$head)),
								A2($author$project$Components$Produits$StructureCatalogue$Typologies$Model$reglee, model.r6, structure.vk)));
					}),
				model.h$,
				model.gr));
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Produits$StructureCatalogue$Update$DuRenommageDEtageLibre,
			{
				fs: {
					sR: (!_Utils_eq(fourni, $elm$core$Maybe$Nothing)) && (!$author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model)),
					Bl: _Utils_eq(fourni, $elm$core$Maybe$Nothing) ? '' : $author$project$I18n$Cles$produitsClassificationsValeurRenommerValider(i18n),
					C$: $author$project$Components$Produits$StructureCatalogue$Update$RenommageDEtageLibreDemande
				},
				fZ: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (_v0) {
							var vise = _v0.b;
							return _Utils_ap(
								A4($author$project$Components$Produits$StructureCatalogue$Etages$View$libelles, i18n, model, $author$project$Components$Produits$StructureCatalogue$Etages$Model$prefixeDuRenommage, $author$project$Components$Produits$StructureCatalogue$Update$RenommageDEtageLibreDemande),
								_Utils_ap(
									_List_fromArray(
										[
											A2($author$project$Components$Produits$StructureCatalogue$Etages$View$formes, i18n, model)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Components$Produits$StructureCatalogue$Controles$anglaisManquant,
											i18n,
											function () {
												var _v1 = vise.xt;
												if (_v1.$ === 1) {
													var enregistres = _v1.a;
													return _Utils_eq(enregistres.yg, $elm$core$Maybe$Nothing);
												} else {
													return false;
												}
											}())
										])));
						},
						fourni)),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function (_v2) {
							var structure = _v2.a;
							var vise = _v2.b;
							return A2(
								$author$project$I18n$Cles$produitsClassificationsValeurRenommerDe,
								i18n,
								{
									Dj: A2(
										$author$project$I18n$Cles$texte,
										i18n,
										A2($author$project$Components$Produits$StructureCatalogue$Etages$Model$nom, structure.C9, vise))
								});
						},
						fourni))
			},
			model.bg);
	});
var $author$project$Components$Produits$StructureCatalogue$Update$RenommageDEtatDemande = {$: 20};
var $author$project$Components$Produits$StructureCatalogue$Update$EtatLibelleSaisi = F3(
	function (a, b, c) {
		return {$: 17, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$StructureCatalogue$Update$EtatRetabli = function (a) {
	return {$: 21, a: a};
};
var $author$project$I18n$Cles$produitsStructureRetablir = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.structure.retablir', _List_Nil, 'Libellé par défaut');
};
var $author$project$I18n$Cles$produitsStructureRetablirDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.structure.retablir.de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Rétablir le libellé par défaut de ' + p.Dj);
	});
var $author$project$Components$Produits$StructureCatalogue$Etats$View$contenuDuRenommage = F3(
	function (i18n, model, fourni) {
		var sansAnglais = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.yg;
					},
					$elm$core$Basics$eq($elm$core$Maybe$Nothing)),
				fourni.R));
		return _List_fromArray(
			[
				A2($author$project$Components$Produits$StructureCatalogue$Etats$View$refusLu, i18n, model),
				A3(
				$author$project$Components$Shared$LibellesParLangue$View$view,
				i18n,
				_List_fromArray(
					[
						$author$project$Components$Produits$StructureCatalogue$Controles$entreeEnvoie($author$project$Components$Produits$StructureCatalogue$Update$RenommageDEtatDemande)
					]),
				{
					go: A3($author$project$Components$Produits$StructureCatalogue$Controles$obligatoireManquant, i18n, fourni.hP.b5, fourni.hP.R),
					Ba: $author$project$Referentiel$Langues$desLibelles,
					Bl: $author$project$I18n$Cles$produitsStructureLibelle(i18n),
					hg: function (code) {
						return A2($author$project$Components$Produits$StructureCatalogue$Update$EtatLibelleSaisi, code, fourni.vx);
					},
					pv: $author$project$Components$Produits$StructureCatalogue$Etats$Model$prefixeDuRenommage,
					fm: function (code) {
						return A2($author$project$Components$Shared$LibellesParLangue$Model$lire, code, fourni.hP.R);
					}
				}),
				A2($author$project$Components$Produits$StructureCatalogue$Controles$anglaisManquant, i18n, sansAnglais),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
					]),
				(fourni.o6 && (!_Utils_eq(fourni.R, $elm$core$Maybe$Nothing))) ? _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Bouton$View$bouton,
						1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('retablir'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Produits$StructureCatalogue$Update$EtatRetabli(fourni.vx)),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
								$author$project$Components$Produits$StructureCatalogue$Controles$enCours(model)),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-label',
								A2(
									$author$project$I18n$Cles$produitsStructureRetablirDe,
									i18n,
									{
										Dj: A2(
											$author$project$I18n$Cles$texte,
											i18n,
											$author$project$Components$Produits$StructureCatalogue$Etats$Model$libelleDeLEtat(fourni))
									})),
								$rtfeldman$elm_css$Html$Styled$Attributes$title(
								A2(
									$author$project$I18n$Cles$produitsStructureRetablirDe,
									i18n,
									{
										Dj: A2(
											$author$project$I18n$Cles$texte,
											i18n,
											$author$project$Components$Produits$StructureCatalogue$Etats$Model$libelleDeLEtat(fourni))
									}))
							]),
						$author$project$I18n$Cles$produitsStructureRetablir(i18n))
					]) : _List_Nil)
			]);
	});
var $author$project$Components$Produits$StructureCatalogue$Etats$View$renommage = F2(
	function (i18n, model) {
		var fourni = A2(
			$elm$core$Maybe$andThen,
			function (cherche) {
				return A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.mj;
						},
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$filter(
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.vx;
									},
									$elm$core$Basics$eq(cherche))),
							$elm$core$List$head)),
					model.h$);
			},
			model.dT);
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Produits$StructureCatalogue$Update$DuRenommageDEtat,
			{
				fs: {
					sR: (!_Utils_eq(fourni, $elm$core$Maybe$Nothing)) && (!$author$project$Components$Produits$StructureCatalogue$Controles$enCours(model)),
					Bl: _Utils_eq(fourni, $elm$core$Maybe$Nothing) ? '' : $author$project$I18n$Cles$produitsClassificationsValeurRenommerValider(i18n),
					C$: $author$project$Components$Produits$StructureCatalogue$Update$RenommageDEtatDemande
				},
				fZ: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2($author$project$Components$Produits$StructureCatalogue$Etats$View$contenuDuRenommage, i18n, model),
						fourni)),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function (vise) {
							return A2(
								$author$project$I18n$Cles$produitsClassificationsValeurRenommerDe,
								i18n,
								{
									Dj: A2(
										$author$project$I18n$Cles$texte,
										i18n,
										$author$project$Components$Produits$StructureCatalogue$Etats$Model$libelleDeLEtat(vise))
								});
						},
						fourni))
			},
			model.c5);
	});
var $author$project$Components$Produits$StructureCatalogue$Update$LibelleDInformationSaisi = F2(
	function (a, b) {
		return {$: 137, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Update$RenommageDInformationDemande = {$: 138};
var $author$project$I18n$Cles$produitsParcoursInformationsDrawerRenommerDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.parcours.informations.drawer.renommer.de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Renommer « ' + (p.Dj + ' »'));
	});
var $author$project$Components$Produits$StructureCatalogue$Informations$View$renommage = F2(
	function (i18n, model) {
		var fournie = A2(
			$elm$core$Maybe$andThen,
			function (visee) {
				return A3($author$project$Components$Produits$StructureCatalogue$Informations$Model$trouvee, visee.F$, visee.dy, model.AM);
			},
			model.d5);
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Produits$StructureCatalogue$Update$DuRenommageDInformation,
			{
				fs: {
					sR: (!_Utils_eq(fournie, $elm$core$Maybe$Nothing)) && (!$author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model)),
					Bl: _Utils_eq(fournie, $elm$core$Maybe$Nothing) ? '' : $author$project$I18n$Cles$produitsParcoursInformationsDrawerEnregistrer(i18n),
					C$: $author$project$Components$Produits$StructureCatalogue$Update$RenommageDInformationDemande
				},
				fZ: _Utils_eq(fournie, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Messages$View$view,
						i18n,
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2($elm$core$Maybe$map, $elm$core$List$singleton, model.aL))),
						A4(
						$author$project$Components$Shared$LibellesParLangue$View$avecIndications,
						i18n,
						function (_v0) {
							return $elm$core$Maybe$Nothing;
						},
						_List_fromArray(
							[
								$author$project$Components$Produits$StructureCatalogue$Controles$entreeEnvoie($author$project$Components$Produits$StructureCatalogue$Update$RenommageDInformationDemande)
							]),
						{
							go: A3($author$project$Components$Produits$StructureCatalogue$Controles$obligatoireManquant, i18n, model.aM.b5, model.aM.R),
							Ba: $author$project$Referentiel$Langues$desLibelles,
							Bl: $author$project$I18n$Cles$produitsStructureLibelle(i18n),
							hg: $author$project$Components$Produits$StructureCatalogue$Update$LibelleDInformationSaisi,
							pv: $author$project$Components$Produits$StructureCatalogue$Informations$Model$prefixeDuRenommage,
							fm: function (code) {
								return A2($author$project$Components$Shared$LibellesParLangue$Model$lire, code, model.aM.R);
							}
						})
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function (lue) {
							return A2(
								$author$project$I18n$Cles$produitsParcoursInformationsDrawerRenommerDe,
								i18n,
								{Dj: lue.uN.Bl});
						},
						fournie))
			},
			model.c6);
	});
var $author$project$Components$Produits$StructureCatalogue$Update$RenommageDeNatureDemande = {$: 29};
var $author$project$Components$Produits$StructureCatalogue$Update$NatureLibelleSaisi = F3(
	function (a, b, c) {
		return {$: 26, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$StructureCatalogue$Natures$View$contenu = F3(
	function (i18n, model, fournie) {
		var sansAnglais = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.yg;
					},
					$elm$core$Basics$eq($elm$core$Maybe$Nothing)),
				fournie.R));
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Messages$View$view,
				i18n,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $elm$core$List$singleton, model.aL))),
				A3(
				$author$project$Components$Shared$LibellesParLangue$View$view,
				i18n,
				_List_fromArray(
					[
						$author$project$Components$Produits$StructureCatalogue$Controles$entreeEnvoie($author$project$Components$Produits$StructureCatalogue$Update$RenommageDeNatureDemande)
					]),
				{
					go: A3($author$project$Components$Produits$StructureCatalogue$Controles$obligatoireManquant, i18n, fournie.hP.b5, fournie.hP.R),
					Ba: $author$project$Referentiel$Langues$desLibelles,
					Bl: $author$project$I18n$Cles$produitsStructureLibelle(i18n),
					hg: function (code) {
						return A2($author$project$Components$Produits$StructureCatalogue$Update$NatureLibelleSaisi, code, fournie.vx);
					},
					pv: $author$project$Components$Produits$StructureCatalogue$Natures$Model$prefixeDuRenommage,
					fm: function (code) {
						return A2($author$project$Components$Shared$LibellesParLangue$Model$lire, code, fournie.hP.R);
					}
				}),
				A2($author$project$Components$Produits$StructureCatalogue$Controles$anglaisManquant, i18n, sansAnglais)
			]);
	});
var $author$project$Components$Produits$StructureCatalogue$Natures$View$renommage = F2(
	function (i18n, model) {
		var fournie = A2(
			$elm$core$Maybe$andThen,
			function (cherche) {
				return A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.oo;
						},
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$filter(
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.vx;
									},
									$elm$core$Basics$eq(cherche))),
							$elm$core$List$head)),
					model.h$);
			},
			model.on);
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Produits$StructureCatalogue$Update$DuRenommageDeNature,
			{
				fs: {
					sR: (!_Utils_eq(fournie, $elm$core$Maybe$Nothing)) && (!$author$project$Components$Produits$StructureCatalogue$Controles$enCours(model)),
					Bl: _Utils_eq(fournie, $elm$core$Maybe$Nothing) ? '' : $author$project$I18n$Cles$produitsClassificationsValeurRenommerValider(i18n),
					C$: $author$project$Components$Produits$StructureCatalogue$Update$RenommageDeNatureDemande
				},
				fZ: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2($author$project$Components$Produits$StructureCatalogue$Natures$View$contenu, i18n, model),
						fournie)),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function (vise) {
							return A2(
								$author$project$I18n$Cles$produitsClassificationsValeurRenommerDe,
								i18n,
								{
									Dj: A2(
										$author$project$I18n$Cles$texte,
										i18n,
										$author$project$Components$Produits$StructureCatalogue$Natures$Model$libelleDeLaNature(vise))
								});
						},
						fournie))
			},
			model.qn);
	});
var $author$project$Components$Produits$StructureCatalogue$Update$RenommageDemande = {$: 14};
var $author$project$Components$Produits$StructureCatalogue$Update$LibelleSaisi = F3(
	function (a, b, c) {
		return {$: 11, a: a, b: b, c: c};
	});
var $author$project$Components$Produits$StructureCatalogue$Update$NiveauFormeElisionBasculee = F2(
	function (a, b) {
		return {$: 75, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Update$NiveauFormeGenreChoisi = F2(
	function (a, b) {
		return {$: 74, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Update$NiveauFormePlurielSaisi = F2(
	function (a, b) {
		return {$: 73, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Update$RetablissementDemande = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Produits$StructureCatalogue$Niveaux$View$aDesTypologies = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.vk;
				},
				$elm$core$List$any(
					function ($) {
						return $.wE;
					})),
			model.h$));
};
var $author$project$Components$Shared$LibellesParLangue$View$LUnSousLAutre = 2;
var $author$project$Components$Shared$LibellesParLangue$View$lUnSousLAutre = function (i18n) {
	return A3(
		$author$project$Components$Shared$LibellesParLangue$View$rendre,
		i18n,
		2,
		function (_v0) {
			return $elm$core$Maybe$Nothing;
		});
};
var $author$project$I18n$Cles$produitsEtagesRenommerNiveauPortee = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.etages.renommer-niveau.portee', _List_Nil, 'Son nom vaut pour toutes les typologies.');
};
var $author$project$I18n$Cles$produitsEtagesRenommerNiveauPorteeCategorie = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.etages.renommer-niveau.portee.categorie', _List_Nil, 'Le dernier étage de chaque typologie. Son nom vaut pour toutes les typologies et s\'affiche à la saisie d\'une référence.');
};
var $author$project$Components$Produits$StructureCatalogue$Niveaux$View$portee = F2(
	function (i18n, fourni) {
		return $author$project$Catalogue$Vocabulaire$estUnTypeDeProduit(fourni.fA) ? $author$project$I18n$Cles$produitsEtagesRenommerNiveauPorteeCategorie(i18n) : $author$project$I18n$Cles$produitsEtagesRenommerNiveauPortee(i18n);
	});
var $author$project$Components$Produits$StructureCatalogue$Niveaux$Model$prefixeDesFormes = 'formes-de-niveau';
var $author$project$Components$Produits$StructureCatalogue$Niveaux$View$contenuDuRenommage = F3(
	function (i18n, model, fourni) {
		var sansAnglais = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.yg;
					},
					$elm$core$Basics$eq($elm$core$Maybe$Nothing)),
				fourni.R));
		var offert = function (rel) {
			return !_Utils_eq(
				A2($author$project$API$Liens$trouver, rel, fourni.nQ),
				$elm$core$Maybe$Nothing);
		};
		var offerte = F2(
			function (rel, contenu) {
				return offert(rel) ? contenu : _List_Nil;
			});
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('portee')
					]),
				$author$project$Components$Produits$StructureCatalogue$Niveaux$View$aDesTypologies(model) ? _List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$Components$Produits$StructureCatalogue$Niveaux$View$portee, i18n, fourni))
					]) : _List_Nil),
				A2(
				$author$project$Components$Shared$Messages$View$view,
				i18n,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $elm$core$List$singleton, model.aL))),
				A3(
				$author$project$Components$Shared$LibellesParLangue$View$lUnSousLAutre,
				i18n,
				_List_fromArray(
					[
						$author$project$Components$Produits$StructureCatalogue$Controles$entreeEnvoie($author$project$Components$Produits$StructureCatalogue$Update$RenommageDemande)
					]),
				{
					go: A3($author$project$Components$Produits$StructureCatalogue$Controles$obligatoireManquant, i18n, fourni.hP.b5, fourni.hP.R),
					Ba: offert($author$project$API$NavLinksDictionary$libellerUnNiveau) ? $author$project$Referentiel$Langues$desLibelles : _List_Nil,
					Bl: $author$project$I18n$Cles$produitsStructureLibelle(i18n),
					hg: function (code) {
						return A2($author$project$Components$Produits$StructureCatalogue$Update$LibelleSaisi, code, fourni.Aq);
					},
					pv: $author$project$Components$Produits$StructureCatalogue$Niveaux$Model$prefixeDuRenommage,
					fm: function (code) {
						return A2($author$project$Components$Shared$LibellesParLangue$Model$lire, code, fourni.hP.R);
					}
				}),
				A2($author$project$Components$Produits$StructureCatalogue$Controles$anglaisManquant, i18n, sansAnglais),
				A2(
				$author$project$Components$Produits$StructureCatalogue$Etages$View$formesDuNom,
				i18n,
				{
					lS: $author$project$Components$Produits$StructureCatalogue$Update$NiveauFormeElisionBasculee,
					mV: $author$project$Components$Produits$StructureCatalogue$Update$NiveauFormeGenreChoisi,
					po: $author$project$Components$Produits$StructureCatalogue$Update$NiveauFormePlurielSaisi,
					pv: $author$project$Components$Produits$StructureCatalogue$Niveaux$Model$prefixeDesFormes,
					c7: model.mP,
					IN: function (code) {
						return A2($author$project$Components$Shared$LibellesParLangue$Model$lire, code, fourni.hP.R);
					}
				}),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
					]),
				A2(
					offerte,
					$author$project$API$NavLinksDictionary$retablirLeLibelleDUnNiveau,
					_List_fromArray(
						[
							A3(
							$author$project$Components$Shared$Bouton$View$bouton,
							1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('retablir'),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Components$Produits$StructureCatalogue$Update$RetablissementDemande(fourni.Aq)),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
									$author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model)),
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'aria-label',
									A2(
										$author$project$I18n$Cles$produitsStructureRetablirDe,
										i18n,
										{
											Dj: A2(
												$author$project$I18n$Cles$texte,
												i18n,
												$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$libelleDuNiveau(fourni))
										})),
									$rtfeldman$elm_css$Html$Styled$Attributes$title(
									A2(
										$author$project$I18n$Cles$produitsStructureRetablirDe,
										i18n,
										{
											Dj: A2(
												$author$project$I18n$Cles$texte,
												i18n,
												$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$libelleDuNiveau(fourni))
										}))
								]),
							$author$project$I18n$Cles$produitsStructureRetablir(i18n))
						])))
			]);
	});
var $author$project$I18n$Cles$produitsNiveauxRenommerDe = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.niveaux.renommer-de',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Renommer « ' + (p.Dj + ' »'));
	});
var $author$project$Components$Produits$StructureCatalogue$Niveaux$View$renommage = F2(
	function (i18n, model) {
		var inactif = $author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model);
		var fourni = A2(
			$elm$core$Maybe$andThen,
			function (cherche) {
				return A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.C9;
						},
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$filter(
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.Aq;
									},
									$elm$core$Basics$eq(cherche))),
							$elm$core$List$head)),
					model.h$);
			},
			model.iA);
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Produits$StructureCatalogue$Update$DuRenommage,
			{
				fs: {
					sR: (!_Utils_eq(fourni, $elm$core$Maybe$Nothing)) && (!inactif),
					Bl: _Utils_eq(fourni, $elm$core$Maybe$Nothing) ? '' : $author$project$I18n$Cles$produitsClassificationsValeurRenommerValider(i18n),
					C$: $author$project$Components$Produits$StructureCatalogue$Update$RenommageDemande
				},
				fZ: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2($author$project$Components$Produits$StructureCatalogue$Niveaux$View$contenuDuRenommage, i18n, model),
						fourni)),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function (vise) {
							return A2(
								$author$project$I18n$Cles$produitsNiveauxRenommerDe,
								i18n,
								{
									Dj: A2(
										$author$project$I18n$Cles$texte,
										i18n,
										$author$project$Components$Produits$StructureCatalogue$Niveaux$Model$libelleDuNiveau(vise))
								});
						},
						fourni))
			},
			model.hL);
	});
var $author$project$Components$Produits$StructureCatalogue$Update$RenommageDeTypologieDemande = {$: 42};
var $author$project$Components$Produits$StructureCatalogue$Typologies$Model$prefixeDesFormes = 'formes-de-typologie';
var $author$project$Components$Produits$StructureCatalogue$Typologies$View$renommage = F2(
	function (i18n, model) {
		var fournie = A2(
			$elm$core$Maybe$andThen,
			function (cherchee) {
				return A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.vk;
						},
						$author$project$Components$Produits$StructureCatalogue$Classifications$Model$classificationDe(cherchee)),
					model.h$);
			},
			model.r4);
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Produits$StructureCatalogue$Update$DuRenommageDeTypologie,
			{
				fs: {
					sR: (!_Utils_eq(fournie, $elm$core$Maybe$Nothing)) && (!$author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model)),
					Bl: _Utils_eq(fournie, $elm$core$Maybe$Nothing) ? '' : $author$project$I18n$Cles$produitsClassificationsValeurRenommerValider(i18n),
					C$: $author$project$Components$Produits$StructureCatalogue$Update$RenommageDeTypologieDemande
				},
				fZ: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (visee) {
							return _Utils_ap(
								A5(
									$author$project$Components$Produits$StructureCatalogue$Typologies$View$libelles,
									i18n,
									function (_v0) {
										return $elm$core$Maybe$Nothing;
									},
									model,
									$author$project$Components$Produits$StructureCatalogue$Typologies$Model$prefixeDuRenommage,
									$author$project$Components$Produits$StructureCatalogue$Update$RenommageDeTypologieDemande),
								A2(
									$elm$core$List$cons,
									A2(
										$author$project$Components$Produits$StructureCatalogue$Controles$anglaisManquant,
										i18n,
										_Utils_eq(visee.R.yg, $elm$core$Maybe$Nothing)),
									visee.wE ? _List_fromArray(
										[
											A2(
											$author$project$Components$Produits$StructureCatalogue$Etages$View$formesDuNom,
											i18n,
											{
												lS: $author$project$Components$Produits$StructureCatalogue$Update$TypologieFormeElisionBasculee,
												mV: $author$project$Components$Produits$StructureCatalogue$Update$TypologieFormeGenreChoisi,
												po: $author$project$Components$Produits$StructureCatalogue$Update$TypologieFormePlurielSaisi,
												pv: $author$project$Components$Produits$StructureCatalogue$Typologies$Model$prefixeDesFormes,
												c7: model.mQ,
												IN: function (code) {
													return A2($author$project$Components$Shared$LibellesParLangue$Model$lire, code, model.qU.R);
												}
											})
										]) : _List_Nil));
						},
						fournie)),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function (visee) {
							return visee.wE ? A2(
								$author$project$I18n$Cles$produitsClassificationsValeurRenommerDe,
								i18n,
								{
									Dj: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(visee)
								}) : $author$project$I18n$Cles$produitsParcoursInformationsListeRenommer(i18n);
						},
						fournie))
			},
			model.qo);
	});
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$RestrictionDemandee = {$: 4};
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$CaseDeRestrictionCochee = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Produits$StructureCatalogue$Produits$View$caseDe = F3(
	function (prefixe, ouverte, choix) {
		var cochee = A2($author$project$Components$Produits$StructureCatalogue$Produits$Restriction$cochee, choix.Aq, ouverte);
		var ancre = prefixe + ('-valeur-' + $author$project$Catalogue$Identifiants$elementIdToString(choix.Aq));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('choix'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('cochee', cochee)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(ancre),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(cochee),
							$rtfeldman$elm_css$Html$Styled$Events$onCheck(
							$author$project$Components$Produits$StructureCatalogue$Produits$Update$CaseDeRestrictionCochee(choix.Aq))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$for(ancre)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nom')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(choix.Dj)
								]))
						]))
				]));
	});
var $author$project$Components$Produits$StructureCatalogue$Produits$View$groupe = F6(
	function (prefixe, titre, sansCoche, vide, ouverte, choix) {
		return $elm$core$List$isEmpty(choix) ? _List_Nil : _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$fieldset,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('dessous')
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$legend,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(titre)
							])),
					A2(
						$elm$core$List$map,
						A2($author$project$Components$Produits$StructureCatalogue$Produits$View$caseDe, prefixe, ouverte),
						choix))),
				vide ? A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(sansCoche)
					])) : $rtfeldman$elm_css$Html$Styled$text('')
			]);
	});
var $author$project$I18n$Cles$produitsValeursRestrictionAucuneGamme = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.restriction.aucune-gamme', _List_Nil, 'Cochez au moins une gamme : sans gamme cochée, il faut tout recocher pour qu\'il vaille pour toutes.');
};
var $author$project$I18n$Cles$produitsValeursRestrictionAucuneMarque = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.restriction.aucune-marque', _List_Nil, 'Cochez au moins une marque : sans marque cochée, il faut tout recocher pour qu\'il vaille pour toutes.');
};
var $author$project$I18n$Cles$produitsValeursRestrictionGammes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.restriction.gammes', _List_Nil, 'Gammes');
};
var $author$project$I18n$Cles$produitsValeursRestrictionIllisible = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.restriction.illisible', _List_Nil, 'La fiche de ce produit n\'a pas pu être lue. Fermez ce panneau et rouvrez-le.');
};
var $author$project$I18n$Cles$produitsValeursRestrictionLecture = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.restriction.lecture', _List_Nil, 'Lecture de la fiche du produit…');
};
var $author$project$I18n$Cles$produitsValeursRestrictionMarques = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.restriction.marques', _List_Nil, 'Marques');
};
var $author$project$I18n$Cles$produitsValeursRestrictionSansDroit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.restriction.sans-droit', _List_Nil, 'Vous ne pouvez pas restreindre ce produit.');
};
var $author$project$Components$Produits$StructureCatalogue$Produits$View$corps = F3(
	function (i18n, prefixe, ouverte) {
		var _v0 = ouverte.np;
		switch (_v0.$) {
			case 0:
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsValeursRestrictionLecture(i18n))
							]))
					]);
			case 1:
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsValeursRestrictionLecture(i18n))
							]))
					]);
			case 4:
				return _List_Nil;
			case 5:
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsValeursRestrictionIllisible(i18n))
							]))
					]);
			case 3:
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$I18n$Cles$produitsValeursRestrictionSansDroit(i18n))
							]))
					]);
			default:
				return _Utils_ap(
					A6(
						$author$project$Components$Produits$StructureCatalogue$Produits$View$groupe,
						prefixe,
						$author$project$I18n$Cles$produitsValeursRestrictionMarques(i18n),
						$author$project$I18n$Cles$produitsValeursRestrictionAucuneMarque(i18n),
						$author$project$Components$Produits$StructureCatalogue$Produits$Restriction$aucuneMarque(ouverte),
						ouverte,
						ouverte.cU),
					A6(
						$author$project$Components$Produits$StructureCatalogue$Produits$View$groupe,
						prefixe,
						$author$project$I18n$Cles$produitsValeursRestrictionGammes(i18n),
						$author$project$I18n$Cles$produitsValeursRestrictionAucuneGamme(i18n),
						$author$project$Components$Produits$StructureCatalogue$Produits$Restriction$aucuneGamme(ouverte),
						ouverte,
						ouverte.gG));
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$ArchivageAnnule = {$: 6};
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$ArchivageConfirme = {$: 7};
var $author$project$Components$Produits$StructureCatalogue$Produits$Update$ArchivageDemande = {$: 5};
var $author$project$Components$Produits$StructureCatalogue$Produits$View$gestesDArchivage = {to: $author$project$Components$Produits$StructureCatalogue$Produits$Update$ArchivageAnnule, j7: $author$project$Components$Produits$StructureCatalogue$Produits$Update$ArchivageConfirme, kE: $author$project$Components$Produits$StructureCatalogue$Produits$Update$ArchivageDemande};
var $author$project$I18n$Cles$produitsValeursRestrictionEnregistrer = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.restriction.enregistrer', _List_Nil, 'Enregistrer');
};
var $author$project$I18n$Cles$produitsValeursRestrictionExplication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.valeurs.restriction.explication', _List_Nil, 'Un produit est porté par sa catégorie. Tout est coché : il vaut pour toutes les marques et toutes les gammes. Décochez ce qu\'il ne couvre pas.');
};
var $author$project$I18n$Cles$produitsValeursRestrictionQuestion = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.restriction.question',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'À quelles marques et à quelles gammes s\'applique « ' + (p.Dj + ' » ?'));
	});
var $author$project$I18n$Cles$produitsValeursRestrictionTitre = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.valeurs.restriction.titre',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nom',
					$author$project$I18n$Traductions$Chaine(p.Dj))
				]),
			'Restreindre « ' + (p.Dj + ' »'));
	});
var $author$project$Components$Produits$StructureCatalogue$Produits$View$drawerDeRestriction = F2(
	function (i18n, model) {
		var vide = {
			fs: {sR: false, Bl: '', C$: $author$project$Components$Produits$StructureCatalogue$Produits$Update$RestrictionDemandee},
			fZ: _List_Nil,
			A6: $elm$core$Maybe$Nothing,
			Bc: false,
			h6: ''
		};
		var contenu = function () {
			var _v0 = _Utils_Tuple2(
				model.al,
				$author$project$Components$Shared$Drawer$Model$estOuvert(model.lg));
			if ((!_v0.a.$) && _v0.b) {
				var ouverte = _v0.a.a;
				var refus = A3(
					$author$project$Components$Shared$Messages$View$vueAvecFoyer,
					i18n,
					$author$project$Components$Shared$Drawer$Model$idRacine(model.lg) + '-refus',
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Maybe$map, $elm$core$List$singleton, model.p4)));
				return ouverte.tD.aW ? A3(
					$author$project$Components$Produits$Common$ArchivageDuProduitView$confirmation,
					i18n,
					$author$project$Components$Produits$StructureCatalogue$Produits$View$gestesDArchivage,
					{
						sR: !$author$project$Components$Produits$Common$Envoi$enCours(model.l2),
						Dj: ouverte.Dj,
						pZ: refus
					}) : {
					fs: {
						sR: (!_Utils_eq(
							$author$project$Components$Produits$StructureCatalogue$Produits$Restriction$commande(ouverte),
							$elm$core$Maybe$Nothing)) && (!$author$project$Components$Produits$Common$Envoi$enCours(model.l2)),
						Bl: $author$project$I18n$Cles$produitsValeursRestrictionEnregistrer(i18n),
						C$: $author$project$Components$Produits$StructureCatalogue$Produits$Update$RestrictionDemandee
					},
					fZ: _Utils_ap(
						_List_fromArray(
							[
								refus,
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('question')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$h3,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$produitsValeursRestrictionQuestion,
													i18n,
													{Dj: ouverte.Dj}))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('explication')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$produitsValeursRestrictionExplication(i18n))
											]))
									]))
							]),
						_Utils_ap(
							A3(
								$author$project$Components$Produits$StructureCatalogue$Produits$View$corps,
								i18n,
								$author$project$Components$Shared$Drawer$Model$idRacine(model.lg),
								ouverte),
							A3($author$project$Components$Produits$Common$ArchivageDuProduitView$action, i18n, $author$project$Components$Produits$StructureCatalogue$Produits$View$gestesDArchivage, ouverte.tD))),
					A6: $elm$core$Maybe$Nothing,
					Bc: false,
					h6: A2(
						$author$project$I18n$Cles$produitsValeursRestrictionTitre,
						i18n,
						{Dj: ouverte.Dj})
				};
			} else {
				return vide;
			}
		}();
		return A4($author$project$Components$Shared$Drawer$View$view, i18n, $author$project$Components$Produits$StructureCatalogue$Produits$Update$DuDrawerDeRestriction, contenu, model.lg);
	});
var $author$project$Components$Produits$StructureCatalogue$Produits$View$restriction = F2(
	function (i18n, model) {
		var _v0 = model.al;
		if (!_v0.$) {
			var ouverte = _v0.a;
			var lecture = ouverte.np;
			return (_Utils_eq(lecture, $author$project$Components$Produits$StructureCatalogue$Produits$Restriction$Archive) && $author$project$Components$Shared$Drawer$Model$estOuvert(model.lg)) ? A4(
				$author$project$Components$Shared$Drawer$View$consultation,
				i18n,
				$author$project$Components$Produits$StructureCatalogue$Produits$Update$DuDrawerDeRestriction,
				{
					fZ: A3($author$project$Components$Produits$Common$ArchivageDuProduitView$action, i18n, $author$project$Components$Produits$StructureCatalogue$Produits$View$gestesDArchivage, ouverte.tD),
					G8: false,
					h6: A2(
						$author$project$I18n$Cles$produitsValeursRestrictionTitre,
						i18n,
						{Dj: ouverte.Dj})
				},
				model.lg) : A2($author$project$Components$Produits$StructureCatalogue$Produits$View$drawerDeRestriction, i18n, model);
		} else {
			return A2($author$project$Components$Produits$StructureCatalogue$Produits$View$drawerDeRestriction, i18n, model);
		}
	});
var $author$project$Components$Produits$StructureCatalogue$Update$RetraitDeTypologieDemande = {$: 61};
var $author$project$I18n$Cles$produitsTypologiesRetirerConfirmation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.retirer.confirmation', _List_Nil, 'Cette typologie est vide : elle n\'a ni valeur ni catégorie rangée. Une fois retirée, elle ne compte plus parmi vos classifications et son nom peut être réutilisé.');
};
var $author$project$I18n$Cles$produitsTypologiesRetirerConfirmationAvecvaleurs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'produits.typologies.retirer.confirmation.avecvaleurs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? 'Cette typologie n\'a plus de catégorie rangée. Sa valeur, vide, est retirée avec elle. Une fois retirée, elle ne compte plus parmi vos classifications et son nom peut être réutilisé.' : ('Cette typologie n\'a plus de catégorie rangée. Ses ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' valeurs, vides, sont retirées avec elle. Une fois retirée, elle ne compte plus parmi vos classifications et son nom peut être réutilisé.')));
	});
var $author$project$I18n$Cles$produitsTypologiesRetirerValider = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'produits.typologies.retirer.valider', _List_Nil, 'Retirer cette typologie');
};
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$estDerive = function (noeud) {
	return _Utils_eq(
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$deplacerUnNoeud, noeud.nQ),
		$elm$core$Maybe$Nothing) && (!_Utils_eq(
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$retirerUnNoeud, noeud.nQ),
		$elm$core$Maybe$Nothing));
};
var $author$project$Components$Produits$StructureCatalogue$Classifications$Model$valeursQuiPartent = function (classification) {
	return $elm$core$List$length(classification.Ki) + $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Components$Produits$StructureCatalogue$Classifications$Model$estDerive),
			classification.Di));
};
var $author$project$Components$Produits$StructureCatalogue$Typologies$View$retrait = F2(
	function (i18n, model) {
		var fournie = A2(
			$elm$core$Maybe$andThen,
			function (cherchee) {
				return A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.vk;
						},
						$author$project$Components$Produits$StructureCatalogue$Classifications$Model$classificationDe(cherchee)),
					model.h$);
			},
			model.r5);
		return A4(
			$author$project$Components$Shared$Drawer$View$view,
			i18n,
			$author$project$Components$Produits$StructureCatalogue$Update$DuRetraitDeTypologie,
			{
				fs: {
					sR: (!_Utils_eq(fournie, $elm$core$Maybe$Nothing)) && (!$author$project$Components$Produits$StructureCatalogue$Controles$enAttente(model)),
					Bl: _Utils_eq(fournie, $elm$core$Maybe$Nothing) ? '' : $author$project$I18n$Cles$produitsTypologiesRetirerValider(i18n),
					C$: $author$project$Components$Produits$StructureCatalogue$Update$RetraitDeTypologieDemande
				},
				fZ: _Utils_eq(fournie, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Messages$View$view,
						i18n,
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2($elm$core$Maybe$map, $elm$core$List$singleton, model.aL))),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								function () {
									var _v0 = A2($elm$core$Maybe$map, $author$project$Components$Produits$StructureCatalogue$Classifications$Model$valeursQuiPartent, fournie);
									if (!_v0.$) {
										var nombre = _v0.a;
										return (nombre > 0) ? A2(
											$author$project$I18n$Cles$produitsTypologiesRetirerConfirmationAvecvaleurs,
											i18n,
											{w: nombre}) : $author$project$I18n$Cles$produitsTypologiesRetirerConfirmation(i18n);
									} else {
										return $author$project$I18n$Cles$produitsTypologiesRetirerConfirmation(i18n);
									}
								}())
							]))
					]),
				A6: $elm$core$Maybe$Nothing,
				Bc: false,
				h6: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function (visee) {
							return A2(
								$author$project$I18n$Cles$produitsTypologiesRetirerDe,
								i18n,
								{
									Dj: $author$project$Components$Produits$StructureCatalogue$Classifications$Model$nom(visee)
								});
						},
						fournie))
			},
			model.qM);
	});
var $author$project$Components$Produits$StructureCatalogue$View$vueAvecLeFormulaire = F5(
	function (i18n, courante, embarque, messages, model) {
		return A2(
			$author$project$Components$Shared$Page$View$page,
			'produits-structure-catalogue-detail',
			{
				ut: _List_fromArray(
					[
						A3(
						$author$project$Components$Shared$Parcours$View$etapes,
						i18n,
						A2($author$project$Components$Produits$StructureCatalogue$View$parcours, i18n, model),
						courante),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
							]),
						A2(
							$elm$core$List$cons,
							A2($author$project$Components$Shared$Messages$View$view, i18n, messages),
							A2(
								$elm$core$List$cons,
								A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('envoi'),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Components$Produits$StructureCatalogue$Controles$enCours(model) ? $author$project$I18n$Cles$produitsStructureEnvoiEnCours(i18n) : '')
										])),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										A4($author$project$Components$Produits$StructureCatalogue$View$etape, i18n, courante, embarque, model),
										$author$project$Routes$Route$etapesDuCatalogue),
									_List_fromArray(
										[
											A4(
											$author$project$Components$Shared$Parcours$View$piedAvec,
											i18n,
											$author$project$Components$Produits$StructureCatalogue$View$aLaFin(embarque),
											A2($author$project$Components$Produits$StructureCatalogue$View$parcours, i18n, model),
											courante)
										]))))),
						A4($author$project$Components$Produits$StructureCatalogue$View$apercu, i18n, courante, embarque, model)
					]),
				xy: _Utils_ap(
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Components$Produits$StructureCatalogue$Update$DesCategories,
							A2($author$project$Components$Produits$StructureCatalogue$Categories$View$creation, i18n, model.dt)),
							A2($author$project$Components$Produits$StructureCatalogue$Etages$View$rangement, i18n, model),
							A2($author$project$Components$Produits$StructureCatalogue$Niveaux$View$renommage, i18n, model),
							A2($author$project$Components$Produits$StructureCatalogue$Valeurs$View$drawerDeRangement, i18n, model),
							A2($author$project$Components$Produits$StructureCatalogue$Valeurs$View$drawerDOrdre, i18n, model),
							A2($author$project$Components$Produits$StructureCatalogue$Informations$Consultations$drawer, i18n, model),
							A2($author$project$Components$Produits$StructureCatalogue$Etats$View$renommage, i18n, model),
							A2($author$project$Components$Produits$StructureCatalogue$Etats$View$ajout, i18n, model),
							A2($author$project$Components$Produits$StructureCatalogue$Natures$View$renommage, i18n, model),
							A2($author$project$Components$Produits$StructureCatalogue$Typologies$View$ajout, i18n, model),
							A2($author$project$Components$Produits$StructureCatalogue$Typologies$View$retrait, i18n, model),
							A2($author$project$Components$Produits$StructureCatalogue$Archivage$View$drawer, i18n, model),
							A2($author$project$Components$Produits$StructureCatalogue$Archivage$View$correspondance, i18n, model),
							A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Components$Produits$StructureCatalogue$Update$DesMarques,
							A3(
								$author$project$Components$Produits$StructureCatalogue$Marques$View$creation,
								i18n,
								A2($author$project$Components$Produits$StructureCatalogue$View$etageDesMarques, i18n, model),
								model.cU)),
							A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Components$Produits$StructureCatalogue$Update$DesGammes,
							A2($author$project$Components$Produits$StructureCatalogue$Gammes$View$creation, i18n, model.gG)),
							A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Components$Produits$StructureCatalogue$Update$DesProduits,
							A2($author$project$Components$Produits$StructureCatalogue$Produits$View$creation, i18n, model.aK)),
							A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Components$Produits$StructureCatalogue$Update$DesProduits,
							A2($author$project$Components$Produits$StructureCatalogue$Produits$View$restriction, i18n, model.aK)),
							A2($author$project$Components$Produits$StructureCatalogue$Informations$View$information, i18n, model),
							A2($author$project$Components$Produits$StructureCatalogue$Informations$View$etage, i18n, model),
							A2($author$project$Components$Produits$StructureCatalogue$Informations$View$choixDEtage, i18n, model),
							A2($author$project$Components$Produits$StructureCatalogue$Informations$View$choixDePerimetre, i18n, model),
							A2($author$project$Components$Produits$StructureCatalogue$Informations$View$renommage, i18n, model),
							A2($author$project$Components$Produits$StructureCatalogue$Informations$View$rattachement, i18n, model),
							A2($author$project$Components$Produits$StructureCatalogue$Informations$View$nouvelleListe, i18n, model),
							A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Components$Produits$StructureCatalogue$Update$DesClassifications,
							A2($author$project$Components$Produits$StructureCatalogue$Classifications$View$drawer, i18n, model)),
							A2($author$project$Components$Produits$StructureCatalogue$Typologies$View$renommage, i18n, model),
							A2($author$project$Components$Produits$StructureCatalogue$Etages$View$ajout, i18n, model),
							A2($author$project$Components$Produits$StructureCatalogue$Etages$View$renommage, i18n, model)
						]),
					_Utils_ap(
						A2($author$project$Components$Produits$StructureCatalogue$Valeurs$View$drawersDeLaCategorie, i18n, model),
						A2($author$project$Components$Produits$StructureCatalogue$Informations$View$nouveauChamp, i18n, model))),
				zM: _List_Nil,
				AK: $author$project$Components$Produits$StructureCatalogue$View$dialogueOuvert(model),
				JD: A2(
					$author$project$Components$Shared$Page$View$enTete,
					i18n,
					{
						vS: _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$I18n$Cles$produitsParcoursDescription(i18n))
									]))
							]),
						zE: _List_fromArray(
							[
								{
								aa: $author$project$Routes$Route$adresseDuParcoursDuCatalogue,
								Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n)
							},
								{
								aa: $author$project$Routes$Route$adresseDuParcoursDuCatalogue,
								Dj: $author$project$I18n$Cles$produitsParametrageCatalogue(i18n)
							}
							]),
						Ef: _List_Nil,
						h6: $author$project$I18n$Cles$produitsParcoursTitre(i18n)
					})
			});
	});
var $author$project$Main$View$page = F2(
	function (i18n, model) {
		var _v0 = model.Ih;
		switch (_v0.$) {
			case 0:
				return A3(
					$author$project$Components$Shared$Version$View$view,
					i18n,
					$author$project$I18n$Cles$backofficeTitre(i18n),
					model.sq);
			case 1:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$AccueilMsg,
					A4(
						$author$project$Components$Accueil$View$view,
						i18n,
						model.Ct,
						$author$project$Main$View$utilisateur(model),
						model.sN));
			case 2:
				return A6(
					$author$project$Components$Referentiel$PartiesPrenantes$View$view,
					i18n,
					$author$project$Main$Update$PartiesPrenantesMsg,
					$author$project$Components$Shared$Drawer$Model$estOuvert(
						$author$project$Components$Referentiel$NouvelleFiche$Model$ouvrir(model.oU).im) ? _List_Nil : model.Ct,
					$author$project$Main$View$liensDeLaRacine(model),
					A2(
						$author$project$Referentiel$Normes$poser,
						model.hd,
						$author$project$Components$Referentiel$PartiesPrenantes$Model$ouvrir(model.eA)),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Main$Update$NouvelleFicheMsg,
							A3(
								$author$project$Components$Referentiel$NouvelleFiche$View$view,
								i18n,
								model.Ct,
								A2(
									$author$project$Referentiel$Normes$poser,
									model.hd,
									$author$project$Components$Referentiel$NouvelleFiche$Model$ouvrir(model.oU))))
						]));
			case 3:
				var onglet = _v0.b;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Main$Update$FicheMsg,
							A4(
								$author$project$Components$Referentiel$Fiche$View$view,
								i18n,
								onglet,
								model.Ct,
								A2(
									$author$project$Referentiel$Normes$poser,
									model.hd,
									$author$project$Components$Referentiel$Fiche$Model$ouvrir(model.zo)))),
							A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Main$Update$FusionMsg,
							A2($author$project$Components$Referentiel$Fusion$View$volet, i18n, model.z$))
						]));
			case 4:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$FusionMsg,
					A3(
						$author$project$Components$Referentiel$Fusion$View$view,
						i18n,
						model.Ct,
						A2($author$project$Referentiel$Normes$poser, model.hd, model.z$)));
			case 5:
				return A2(
					$author$project$Components$Shared$Introuvable$View$view,
					i18n,
					{
						aa: $author$project$Routes$Route$adressePartiesPrenantes,
						Bl: $author$project$I18n$Cles$referentielFicheRetour(i18n)
					});
			case 6:
				var etape = _v0.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$StructureCatalogueMsg,
					A5(
						$author$project$Components$Produits$StructureCatalogue$View$vueAvecLeFormulaire,
						i18n,
						etape,
						A2(
							$author$project$Components$Produits$Catalogue$View$formulaireEmbarque,
							i18n,
							A2(
								$author$project$Referentiel$Normes$poser,
								model.hd,
								$author$project$Components$Produits$Catalogue$Model$ouvrir(model.jB))),
						model.Ct,
						$author$project$Components$Produits$StructureCatalogue$Model$ouvrir(model.I3)));
			case 7:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$SchemaDeNiveauMsg,
					A3(
						$author$project$Components$Produits$SchemaDeNiveau$View$view,
						i18n,
						model.Ct,
						A2(
							$author$project$Referentiel$Normes$poser,
							model.hd,
							$author$project$Components$Produits$SchemaDeNiveau$Model$ouvrir(model.Ir))));
			case 23:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$FicheElementMsg,
					A3(
						$author$project$Components$Produits$FicheElement$View$view,
						i18n,
						model.Ct,
						A2(
							$author$project$Referentiel$Normes$poser,
							model.hd,
							$author$project$Components$Produits$FicheElement$Model$ouvrir(model.zr))));
			case 24:
				return A2(
					$author$project$Components$Shared$Introuvable$View$view,
					i18n,
					{
						aa: $author$project$Routes$Route$adresseMarquesEtGammes,
						Bl: $author$project$I18n$Cles$produitsCatalogueRetour(i18n)
					});
			case 8:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$MarquesEtGammesMsg,
					A3(
						$author$project$Components$Produits$MarquesEtGammes$View$view,
						i18n,
						model.Ct,
						$author$project$Components$Produits$MarquesEtGammes$Model$ouvrir(model.B7)));
			case 40:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$FicheTypeMsg,
					A3(
						$author$project$Components$Produits$FicheType$View$view,
						i18n,
						model.Ct,
						A2(
							$author$project$Referentiel$Normes$poser,
							model.hd,
							$author$project$Components$Produits$FicheType$Model$ouvrir(model.zs))));
			case 41:
				return A2(
					$author$project$Components$Shared$Introuvable$View$view,
					i18n,
					{
						aa: $author$project$Routes$Route$toString(
							A2($author$project$Routes$Route$ParametrageCatalogue, 3, $elm$core$Maybe$Nothing)),
						Bl: $author$project$I18n$Cles$produitsTypesRetour(i18n)
					});
			case 25:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$CatalogueMsg,
					A3(
						$author$project$Components$Produits$Catalogue$View$view,
						i18n,
						model.Ct,
						A2(
							$author$project$Referentiel$Normes$poser,
							model.hd,
							$author$project$Components$Produits$Catalogue$Model$ouvrir(model.jB))));
			case 27:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$CatalogueMsg,
					A3(
						$author$project$Components$Produits$Catalogue$View$view,
						i18n,
						model.Ct,
						A2(
							$author$project$Referentiel$Normes$poser,
							model.hd,
							$author$project$Components$Produits$Catalogue$Model$ouvrir(model.jB))));
			case 26:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$CatalogueMsg,
					A3(
						$author$project$Components$Produits$Catalogue$View$viewARanger,
						i18n,
						model.Ct,
						A2(
							$author$project$Referentiel$Normes$poser,
							model.hd,
							$author$project$Components$Produits$Catalogue$Model$ouvrir(model.jB))));
			case 28:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$ReferenceMsg,
					A3(
						$author$project$Components$Produits$Reference$View$view,
						i18n,
						model.Ct,
						A2(
							$author$project$Referentiel$Normes$poser,
							model.hd,
							$author$project$Components$Produits$Reference$Model$ouvrir(model.Hc))));
			case 29:
				return A2(
					$author$project$Components$Shared$Introuvable$View$view,
					i18n,
					{
						aa: $author$project$Routes$Route$adresseCatalogue,
						Bl: $author$project$I18n$Cles$produitsReferencesRetour(i18n)
					});
			case 9:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$PipesMsg,
					A3($author$project$Components$Parametrage$Pipes$View$view, i18n, model.Ct, model.FM));
			case 10:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$ModelesDeTacheMsg,
					A3($author$project$Components$Parametrage$ModelesDeTache$View$view, i18n, model.Ct, model.CL));
			case 11:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$PipeEtape1Msg,
					A3(
						$author$project$Components$Parametrage$PipeEtape1$View$view,
						i18n,
						model.Ct,
						$author$project$Components$Parametrage$PipeEtape1$Model$ouvrir(model.Fy)));
			case 12:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$PipeEtape2Msg,
					A3(
						$author$project$Components$Parametrage$PipeEtape2$View$view,
						i18n,
						model.Ct,
						$author$project$Components$Parametrage$PipeEtape2$Model$ouvrir(model.Fz)));
			case 13:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$PipeEtape3Msg,
					A3(
						$author$project$Components$Parametrage$PipeEtape3$View$view,
						i18n,
						model.Ct,
						$author$project$Components$Parametrage$PipeEtape3$Model$ouvrir(model.FA)));
			case 14:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$PipeEtape4Msg,
					A3(
						$author$project$Components$Parametrage$PipeEtape4$View$view,
						i18n,
						model.Ct,
						$author$project$Components$Parametrage$PipeEtape4$Model$ouvrir(model.FB)));
			case 15:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$PipeEtape5Msg,
					A3(
						$author$project$Components$Parametrage$PipeEtape5$View$view,
						i18n,
						model.Ct,
						$author$project$Components$Parametrage$PipeEtape5$Model$ouvrir(model.FC)));
			case 16:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$PipeEtape6Msg,
					A3(
						$author$project$Components$Parametrage$PipeEtape6$View$view,
						i18n,
						model.Ct,
						$author$project$Components$Parametrage$PipeEtape6$Model$ouvrir(model.FD)));
			case 17:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$PipeEtape7Msg,
					A3(
						$author$project$Components$Parametrage$PipeEtape7$View$view,
						i18n,
						model.Ct,
						$author$project$Components$Parametrage$PipeEtape7$Model$ouvrir(model.FE)));
			case 18:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$PipeEtape8Msg,
					A3($author$project$Components$Parametrage$PipeEtape8$View$view, i18n, model.Ct, model.FF));
			case 19:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$PipeVersionsMsg,
					A3($author$project$Components$Parametrage$PipeVersions$View$view, i18n, model.Ct, model.FL));
			case 20:
				return A3($author$project$Components$Parametrage$PipeOffreUsage$View$view, i18n, model.Ct, model.FG);
			case 21:
				return A3($author$project$Components$Parametrage$PipeDestinations$View$view, i18n, model.Ct, model.Fx);
			case 22:
				return A3($author$project$Components$Parametrage$PipeRelationsExigees$View$view, i18n, model.Ct, model.FJ);
			case 30:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$OffresMsg,
					A3(
						$author$project$Components$Produits$Offres$View$view,
						i18n,
						model.Ct,
						$author$project$Components$Produits$Offres$Model$ouvrir(model.D3)));
			case 31:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$OffreMsg,
					A3(
						$author$project$Components$Produits$Offre$View$view,
						i18n,
						model.Ct,
						A2(
							$author$project$Referentiel$Normes$poser,
							model.hd,
							$author$project$Components$Produits$Offre$Model$ouvrir(model.D1))));
			case 35:
				return A2($author$project$Main$View$pageDesDoublons, i18n, model);
			case 36:
				return A2($author$project$Main$View$pageDesDoublons, i18n, model);
			case 33:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$AlertesMsg,
					A4(
						$author$project$Components$Produits$Alertes$View$view,
						i18n,
						A2($author$project$Main$View$ongletsDesAlertes, i18n, model),
						model.Ct,
						model.tb));
			case 34:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$AlertesPartiesPrenantesMsg,
					A4(
						$author$project$Components$Referentiel$Alertes$View$view,
						i18n,
						A2($author$project$Main$View$ongletsDesAlertes, i18n, model),
						model.Ct,
						model.tc));
			case 37:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$ListesDePrixMsg,
					A3($author$project$Components$Produits$ListesDePrix$View$view, i18n, model.Ct, model.BW));
			case 38:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$ListeDePrixMsg,
					A3(
						$author$project$Components$Produits$ListeDePrix$View$view,
						i18n,
						model.Ct,
						$author$project$Components$Produits$ListeDePrix$Model$ouvrir(model.nY)));
			case 39:
				return A2(
					$author$project$Components$Shared$Introuvable$View$view,
					i18n,
					{
						aa: $author$project$Routes$Route$adresseListesDePrix,
						Bl: $author$project$I18n$Cles$produitsListeDePrixRetour(i18n)
					});
			case 32:
				return A2(
					$author$project$Components$Shared$Introuvable$View$view,
					i18n,
					{
						aa: $author$project$Routes$Route$adresseOffres,
						Bl: $author$project$I18n$Cles$produitsOffresRetour(i18n)
					});
			case 43:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$GroupesMsg,
					A3($author$project$Components$Referentiel$Groupes$View$view, i18n, model.Ct, model.Ac));
			case 52:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$GroupeMsg,
					A3(
						$author$project$Components$Referentiel$Groupe$View$view,
						i18n,
						model.Ct,
						A2(
							$author$project$Referentiel$Normes$poser,
							model.hd,
							$author$project$Components$Referentiel$Groupe$Model$ouvrir(model.m2))));
			case 55:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$LanguesDuClientMsg,
					A3($author$project$Components$Parametrage$LanguesDuClient$View$view, i18n, model.Ct, model.Bb));
			case 56:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$UtilisateursMsg,
					A3(
						$author$project$Components$Parametrage$Utilisateurs$View$view,
						i18n,
						model.Ct,
						$author$project$Components$Parametrage$Utilisateurs$Model$ouvrir(model.Kf)));
			case 57:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$UtilisateursMsg,
					A3(
						$author$project$Components$Parametrage$Utilisateurs$View$view,
						i18n,
						model.Ct,
						$author$project$Components$Parametrage$Utilisateurs$Model$ouvrir(model.Kf)));
			case 58:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$UtilisateursMsg,
					A3(
						$author$project$Components$Parametrage$Utilisateurs$View$view,
						i18n,
						model.Ct,
						$author$project$Components$Parametrage$Utilisateurs$Model$ouvrir(model.Kf)));
			case 59:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$UtilisateursMsg,
					A3(
						$author$project$Components$Parametrage$Utilisateurs$View$view,
						i18n,
						model.Ct,
						$author$project$Components$Parametrage$Utilisateurs$Model$ouvrir(model.Kf)));
			case 66:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$ImportsMsg,
					A3(
						$author$project$Components$Imports$Outil$View$view,
						i18n,
						model.Ct,
						$author$project$Components$Imports$Outil$Model$ouvrir(model.AC)));
			case 68:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$ImportsMsg,
					(!$author$project$Components$Imports$Outil$Model$ouvrir(model.AC).EE) ? A3(
						$author$project$Components$Imports$Outil$View$view,
						i18n,
						model.Ct,
						$author$project$Components$Imports$Outil$Model$ouvrir(model.AC)) : A3(
						$author$project$Components$Imports$Outil$View$historique,
						i18n,
						model.Ct,
						$author$project$Components$Imports$Outil$Model$ouvrir(model.AC)));
			case 67:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$ImportsMsg,
					(!$author$project$Components$Imports$Outil$Model$ouvrir(model.AC).EE) ? A3(
						$author$project$Components$Imports$Outil$View$view,
						i18n,
						model.Ct,
						$author$project$Components$Imports$Outil$Model$ouvrir(model.AC)) : A3(
						$author$project$Components$Imports$Outil$View$historique,
						i18n,
						model.Ct,
						$author$project$Components$Imports$Outil$Model$ouvrir(model.AC)));
			case 60:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$CompteurDeCodeMsg,
					A3($author$project$Components$Parametrage$CompteurDeCode$View$view, i18n, model.Ct, model.v$));
			case 61:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$CompteDEnvoiMsg,
					A3($author$project$Components$Parametrage$CompteDEnvoi$View$view, i18n, model.Ct, model.vX));
			case 63:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$MonCompteMsg,
					A3($author$project$Components$Comptes$MonCompte$View$view, i18n, model.Ct, model.CT));
			case 64:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$SecuriteMsg,
					A3($author$project$Components$Comptes$Securite$View$view, i18n, model.Ct, model.q1));
			case 65:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$SecuriteMsg,
					A3($author$project$Components$Comptes$Securite$View$view, i18n, model.Ct, model.q1));
			case 54:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$ConservationMsg,
					A3($author$project$Components$Parametrage$Conservation$View$echeances, i18n, model.Ct, model.v5));
			case 62:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$NotificationsMsg,
					A3($author$project$Components$Notifications$View$view, i18n, model.Ct, model.oN));
			case 42:
				switch (_v0.a) {
					case 5:
						var _v1 = _v0.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Main$Update$ConservationMsg,
							A4(
								$author$project$Components$Parametrage$Conservation$View$etape,
								i18n,
								A2($author$project$Main$View$habillageDeLaConservation, i18n, model),
								model.Ct,
								model.v5));
					case 6:
						var _v2 = _v0.a;
						return $author$project$Components$Referentiel$Types$Model$ouvrir(model.J0).jh ? A6(
							$author$project$Components$Referentiel$TypesDeRelation$View$etape,
							i18n,
							$author$project$Main$Update$TypesDeRelationMsg,
							A2($author$project$Main$View$habillageDesLiens, i18n, model),
							model.Ct,
							{
								tq: A2($author$project$Components$Referentiel$Postes$View$apercu, i18n, model.F6),
								je: _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$map,
										$author$project$Main$Update$FormesMsg,
										A2($author$project$Components$Referentiel$Formes$View$section, i18n, model.zS))
									]),
								xy: _Utils_ap(
									A2(
										$elm$core$List$map,
										$rtfeldman$elm_css$Html$Styled$map($author$project$Main$Update$PostesMsg),
										A2($author$project$Components$Referentiel$Postes$View$dialogues, i18n, model.F6)),
									A2(
										$elm$core$List$map,
										$rtfeldman$elm_css$Html$Styled$map($author$project$Main$Update$FormesMsg),
										A2($author$project$Components$Referentiel$Formes$View$dialogues, i18n, model.zS))),
								AK: $author$project$Components$Referentiel$Postes$View$dialogueOuvert(model.F6) || $author$project$Components$Referentiel$Formes$View$dialogueOuvert(model.zS),
								hT: _List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$map,
										$author$project$Main$Update$PostesMsg,
										A2($author$project$Components$Referentiel$Postes$View$section, i18n, model.F6))
									])
							},
							model.J2) : A2(
							$author$project$Components$Shared$Introuvable$View$view,
							i18n,
							{
								aa: $author$project$Routes$Route$adresseTypesDePartiesPrenantes,
								Bl: $author$project$I18n$Cles$referentielTypesRetour(i18n)
							});
					default:
						var etape = _v0.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Main$Update$TypesDePartiesPrenantesMsg,
							A4(
								$author$project$Components$Referentiel$Types$View$view,
								i18n,
								etape,
								model.Ct,
								A2(
									$author$project$Referentiel$Normes$poser,
									model.hd,
									$author$project$Components$Referentiel$Types$Model$ouvrir(model.J0))));
				}
			case 44:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$ListesMsg,
					A3(
						$author$project$Components$Produits$Listes$View$view,
						i18n,
						model.Ct,
						A2(
							$author$project$Referentiel$Normes$poser,
							model.hd,
							$author$project$Components$Produits$Listes$Model$ouvrir(model.n_))));
			case 45:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$ListesMsg,
					A3(
						$author$project$Components$Produits$Listes$View$view,
						i18n,
						model.Ct,
						A2(
							$author$project$Referentiel$Normes$poser,
							model.hd,
							$author$project$Components$Produits$Listes$Model$ouvrir(model.n_))));
			case 47:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$PerimetresMsg,
					A3(
						$author$project$Components$Produits$Perimetres$View$view,
						i18n,
						model.Ct,
						$author$project$Components$Produits$Perimetres$Model$ouvrir(model.pg)));
			case 48:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$PerimetresMsg,
					A3(
						$author$project$Components$Produits$Perimetres$View$view,
						i18n,
						model.Ct,
						$author$project$Components$Produits$Perimetres$Model$ouvrir(model.pg)));
			case 49:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$TypesDeQuantiteMsg,
					A3(
						$author$project$Components$Produits$TypesDeQuantite$View$view,
						i18n,
						model.Ct,
						$author$project$Components$Produits$TypesDeQuantite$Model$deballer(model.J1)));
			case 46:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$CorrespondancesMsg,
					A3(
						$author$project$Components$Produits$Correspondances$View$view,
						i18n,
						model.Ct,
						$author$project$Components$Produits$Correspondances$Model$ouvrir(model.wh)));
			case 50:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$CorrespondancesMsg,
					A3(
						$author$project$Components$Produits$Correspondances$View$view,
						i18n,
						model.Ct,
						$author$project$Components$Produits$Correspondances$Model$ouvrir(model.wh)));
			case 51:
				return A5(
					$author$project$Components$Parametrage$BibliothequeDeChamps$View$view,
					i18n,
					$author$project$Main$Update$BibliothequeMsg,
					A4(
						$author$project$Components$Parametrage$CollectionsDeChamps$View$greffon,
						i18n,
						$author$project$Main$Update$CollectionsDeChampsMsg,
						$author$project$Main$View$champsProposables(
							$author$project$Components$Parametrage$BibliothequeDeChamps$Model$ouvrir(model.dq)),
						model.vF),
					model.Ct,
					$author$project$Components$Parametrage$BibliothequeDeChamps$Model$ouvrir(model.dq));
			case 53:
				var etape = _v0.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$DroitsMsg,
					A4(
						$author$project$Components$Parametrage$Droits$View$view,
						i18n,
						etape,
						model.Ct,
						$author$project$Components$Parametrage$Droits$Model$ouvrir(model.xS)));
			case 69:
				var onglet = _v0.b;
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$TypeDePartiePrenanteMsg,
					A4(
						$author$project$Components$Referentiel$Type$View$view,
						i18n,
						onglet,
						model.Ct,
						$author$project$Components$Referentiel$Type$Model$ouvrir(model.JT)));
			case 70:
				return A2(
					$author$project$Components$Shared$Introuvable$View$view,
					i18n,
					{
						aa: $author$project$Routes$Route$adresseTypesDePartiesPrenantes,
						Bl: $author$project$I18n$Cles$referentielTypesRetour(i18n)
					});
			default:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$Update$DemonstrationMsg,
					A4($author$project$Components$Demonstration$View$view, i18n, model.JA, model.Ih, model.xa));
		}
	});
var $author$project$I18n$Cles$coquilleAccesRefuseTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'coquille.acces-refuse.titre', _List_Nil, 'Accès refusé');
};
var $author$project$Components$Socle$Coquille$View$refus = function (i18n) {
	return A2(
		$author$project$Components$Shared$Page$View$page,
		'acces-refuse',
		{
			ut: _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('main')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('acces-refuse')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Note$View$view,
									1,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$coquilleAccesRefuse(i18n))
												]))
										]))
								]))
						]))
				]),
			xy: _List_Nil,
			zM: _List_Nil,
			AK: false,
			JD: A2(
				$author$project$Components$Shared$Page$View$enTete,
				i18n,
				{
					vS: _List_Nil,
					zE: _List_Nil,
					Ef: _List_Nil,
					h6: $author$project$I18n$Cles$coquilleAccesRefuseTitre(i18n)
				})
		});
};
var $author$project$Components$Socle$Coquille$Acces$donne = F2(
	function (connexion, rel) {
		return (!_Utils_eq(
			A2($author$project$API$Liens$trouver, rel, connexion.nQ),
			$elm$core$Maybe$Nothing)) || (!_Utils_eq(
			A2($author$project$API$Liens$trouverGabarit, rel, connexion.gF),
			$elm$core$Maybe$Nothing));
	});
var $author$project$Components$Socle$Coquille$Acces$alertes = _List_fromArray(
	[$author$project$API$NavLinksDictionary$alertesDeProduits, $author$project$API$NavLinksDictionary$alertesDePartiesPrenantes]);
var $author$project$Components$Socle$Coquille$Acces$catalogueParametre = _List_fromArray(
	[$author$project$API$NavLinksDictionary$structureDuCatalogue, $author$project$API$NavLinksDictionary$typesDeProduit]);
var $author$project$API$NavLinksDictionary$concevoirLesPipes = 'concevoir-les-pipes';
var $author$project$Components$Socle$Coquille$Acces$concevoirLesPipes = _List_fromArray(
	[$author$project$API$NavLinksDictionary$concevoirLesPipes]);
var $author$project$Components$Socle$Coquille$Acces$liensQuiOuvrent = function (route) {
	switch (route.$) {
		case 6:
			return $author$project$Components$Socle$Coquille$Acces$catalogueParametre;
		case 7:
			return $author$project$Components$Socle$Coquille$Acces$catalogueParametre;
		case 40:
			return $author$project$Components$Socle$Coquille$Acces$catalogueParametre;
		case 41:
			return $author$project$Components$Socle$Coquille$Acces$catalogueParametre;
		case 8:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$marquesEtGammes]);
		case 23:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$marquesEtGammes]);
		case 24:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$marquesEtGammes]);
		case 25:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$catalogue]);
		case 26:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$catalogue]);
		case 27:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$catalogue]);
		case 28:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$catalogue]);
		case 29:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$catalogue]);
		case 30:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$offresDeService]);
		case 31:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$offresDeService]);
		case 32:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$offresDeService]);
		case 66:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$imports]);
		case 67:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$imports]);
		case 68:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$imports]);
		case 33:
			return $author$project$Components$Socle$Coquille$Acces$alertes;
		case 34:
			return $author$project$Components$Socle$Coquille$Acces$alertes;
		case 37:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$listesDePrix]);
		case 38:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$listesDePrix]);
		case 39:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$listesDePrix]);
		case 42:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$parametrageDesTypesDePartiePrenante]);
		case 69:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$parametrageDesTypesDePartiePrenante]);
		case 70:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$parametrageDesTypesDePartiePrenante]);
		case 43:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$groupes]);
		case 52:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$groupes]);
		case 44:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$listes]);
		case 45:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$listes]);
		case 46:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$listes]);
		case 47:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$perimetres]);
		case 48:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$perimetres]);
		case 49:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$typesDeQuantite]);
		case 50:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$listes]);
		case 51:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$bibliothequeDeChamps]);
		case 9:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$pipes]);
		case 10:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$pipes]);
		case 11:
			return _List_fromArray(
				[$author$project$API$NavLinksDictionary$pipes]);
		case 12:
			return $author$project$Components$Socle$Coquille$Acces$concevoirLesPipes;
		case 13:
			return $author$project$Components$Socle$Coquille$Acces$concevoirLesPipes;
		case 14:
			return $author$project$Components$Socle$Coquille$Acces$concevoirLesPipes;
		case 15:
			return $author$project$Components$Socle$Coquille$Acces$concevoirLesPipes;
		case 16:
			return $author$project$Components$Socle$Coquille$Acces$concevoirLesPipes;
		case 17:
			return $author$project$Components$Socle$Coquille$Acces$concevoirLesPipes;
		case 18:
			return $author$project$Components$Socle$Coquille$Acces$concevoirLesPipes;
		case 19:
			return $author$project$Components$Socle$Coquille$Acces$concevoirLesPipes;
		case 20:
			return $author$project$Components$Socle$Coquille$Acces$concevoirLesPipes;
		case 21:
			return $author$project$Components$Socle$Coquille$Acces$concevoirLesPipes;
		case 22:
			return $author$project$Components$Socle$Coquille$Acces$concevoirLesPipes;
		default:
			return _List_Nil;
	}
};
var $author$project$Components$Socle$Coquille$Acces$refuse = F2(
	function (route, connexion) {
		var _v0 = $author$project$Components$Socle$Coquille$Acces$liensQuiOuvrent(route);
		if (!_v0.b) {
			return false;
		} else {
			var rels = _v0;
			return !A2(
				$elm$core$List$any,
				$author$project$Components$Socle$Coquille$Acces$donne(connexion),
				rels);
		}
	});
var $author$project$Main$View$pageGardee = F2(
	function (i18n, model) {
		var _v0 = model.e1.gt;
		if (_v0.$ === 1) {
			var connexion = _v0.a;
			return connexion.yl ? $author$project$Components$Socle$Coquille$View$enPreparation(i18n) : (A2($author$project$Components$Socle$Coquille$Acces$refuse, model.Ih, connexion) ? $author$project$Components$Socle$Coquille$View$refus(i18n) : A2($author$project$Main$View$page, i18n, model));
		} else {
			return A2($author$project$Main$View$page, i18n, model);
		}
	});
var $author$project$Components$Notifications$Update$ClocheBasculee = {$: 8};
var $author$project$Components$Notifications$Update$NotificationCliquee = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Notifications$Cloche$cible = function (chacune) {
	var _v0 = _Utils_Tuple2(
		chacune.g1,
		$author$project$Components$Referentiel$Identifiants$groupeUidFromString(chacune.zo));
	if ((_v0.a.$ === 1) && (!_v0.b.$)) {
		var _v1 = _v0.a;
		var groupe = _v0.b.a;
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$href(
				$author$project$Routes$Route$toString(
					A2($author$project$Routes$Route$FicheDeGroupe, groupe, $elm$core$Maybe$Nothing)))
			]);
	} else {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Routes$Route$adresseDesNotifications)
			]);
	}
};
var $author$project$I18n$Cles$jourRelatifALInstant = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'jour.relatif.a-l-instant', _List_Nil, 'À l\'instant');
};
var $author$project$I18n$Cles$jourRelatifHeures = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'jour.relatif.heures',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Il y a ' + (p.w + ' h'));
	});
var $author$project$I18n$Cles$jourRelatifMinutes = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'jour.relatif.minutes',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Il y a ' + (p.w + ' min'));
	});
var $author$project$Texte$Jour$ilYA = F3(
	function (i18n, maintenant, instant) {
		var _v0 = $author$project$Texte$Jour$posixDe(instant);
		if (_v0.$ === 1) {
			return A2($author$project$Texte$Jour$horodate, i18n, instant);
		} else {
			var lu = _v0.a;
			var minutes = (($elm$time$Time$posixToMillis(maintenant) - $elm$time$Time$posixToMillis(lu)) / 60000) | 0;
			return (minutes < 1) ? $author$project$I18n$Cles$jourRelatifALInstant(i18n) : ((minutes < 60) ? A2(
				$author$project$I18n$Cles$jourRelatifMinutes,
				i18n,
				{
					w: $elm$core$String$fromInt(minutes)
				}) : ((minutes < 1440) ? A2(
				$author$project$I18n$Cles$jourRelatifHeures,
				i18n,
				{
					w: $elm$core$String$fromInt((minutes / 60) | 0)
				}) : A2($author$project$Texte$Jour$horodate, i18n, instant)));
		}
	});
var $author$project$Components$Notifications$Model$terminePourElle = F2(
	function (notification, traitement) {
		return _Utils_eq(
			$author$project$Components$Referentiel$Identifiants$groupeUidToString(traitement.m2),
			notification.zo) && ((traitement.gt === 2) && _Utils_eq(
			$elm$core$Maybe$Just(notification.xY),
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$left(10),
				traitement.Ju)));
	});
var $author$project$Components$Notifications$Model$traitementDeFin = F2(
	function (model, notification) {
		return $elm$core$List$head(
			$elm$core$List$reverse(
				A2(
					$elm$core$List$sortBy,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Ju;
						},
						$elm$core$Maybe$withDefault('')),
					A2(
						$elm$core$List$filter,
						$author$project$Components$Notifications$Model$terminePourElle(notification),
						A2($elm$core$Maybe$withDefault, _List_Nil, model.h9)))));
	});
var $author$project$Components$Notifications$Cloche$quand = F3(
	function (i18n, model, chacune) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.Ju;
			},
			A2($author$project$Components$Notifications$Model$traitementDeFin, model, chacune));
		if (!_v0.$) {
			var instant = _v0.a;
			var _v1 = model.B3;
			if (!_v1.$) {
				var maintenant = _v1.a;
				return A3($author$project$Texte$Jour$ilYA, i18n, maintenant, instant);
			} else {
				return A2($author$project$Texte$Jour$horodate, i18n, instant);
			}
		} else {
			return A2($author$project$Texte$Jour$enFrancais, i18n, chacune.xY);
		}
	});
var $author$project$Components$Notifications$Cloche$nombre = function (i18n) {
	return $author$project$I18n$Nombre$formater(
		$author$project$I18n$Traductions$langue(i18n));
};
var $author$project$I18n$Cles$notificationsTraitementTermineDetail = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'notifications.traitement-termine.detail',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'groupe',
					$author$project$I18n$Traductions$Chaine(p.m2)),
					_Utils_Tuple2(
					'ajoutees',
					$author$project$I18n$Traductions$Chaine(p.iI))
				]),
			'Groupe « ' + (p.m2 + (' » : ' + (p.iI + ' fiches ajoutées.'))));
	});
var $author$project$I18n$Cles$notificationsTraitementTermineDetailSurTotal = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'notifications.traitement-termine.detail-sur-total',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'groupe',
					$author$project$I18n$Traductions$Chaine(p.m2)),
					_Utils_Tuple2(
					'ajoutees',
					$author$project$I18n$Traductions$Chaine(p.iI)),
					_Utils_Tuple2(
					'total',
					$author$project$I18n$Traductions$Chaine(p.JE))
				]),
			'Groupe « ' + (p.m2 + (' » : ' + (p.iI + (' fiches ajoutées sur ' + (p.JE + '.'))))));
	});
var $author$project$I18n$Cles$notificationsTraitementTermineTitre = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'notifications.traitement-termine.titre', _List_Nil, 'Ajout en lot terminé');
};
var $author$project$I18n$Cles$notificationsTraitementTermineTitreAvecEchecs = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'notifications.traitement-termine.titre-avec-echecs',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Ajout en lot terminé avec ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiche non ajoutée')) : ('Ajout en lot terminé avec ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' fiches non ajoutées')));
	});
var $author$project$Components$Notifications$Cloche$finDeTraitement = F3(
	function (i18n, groupe, traitement) {
		var _v0 = traitement.nh;
		if ((!_v0.$) && (_v0.a === 1)) {
			var _v1 = _v0.a;
			return _Utils_Tuple2(
				A2(
					$author$project$I18n$Cles$notificationsTraitementTermineTitreAvecEchecs,
					i18n,
					{w: traitement.x2}),
				A2(
					$author$project$I18n$Cles$notificationsTraitementTermineDetailSurTotal,
					i18n,
					{
						iI: A2($author$project$Components$Notifications$Cloche$nombre, i18n, traitement.JN),
						m2: groupe,
						JE: A2($author$project$Components$Notifications$Cloche$nombre, i18n, traitement.JE)
					}));
		} else {
			return _Utils_Tuple2(
				$author$project$I18n$Cles$notificationsTraitementTermineTitre(i18n),
				A2(
					$author$project$I18n$Cles$notificationsTraitementTermineDetail,
					i18n,
					{
						iI: A2($author$project$Components$Notifications$Cloche$nombre, i18n, traitement.JN),
						m2: groupe
					}));
		}
	});
var $author$project$Components$Notifications$Model$nomDuGroupe = F2(
	function (model, groupe) {
		return A2($elm$core$Dict$get, groupe, model.DG);
	});
var $author$project$Components$Notifications$Cloche$texte = F3(
	function (i18n, model, chacune) {
		var _v0 = chacune.g1;
		switch (_v0.$) {
			case 0:
				return _Utils_Tuple2(
					A2(
						$author$project$I18n$Cles$notificationsAlerteDeConservation,
						i18n,
						{
							wv: A2($author$project$Texte$Jour$enFrancais, i18n, chacune.xY)
						}),
					'');
			case 1:
				var _v1 = _Utils_Tuple2(
					A2($author$project$Components$Notifications$Model$nomDuGroupe, model, chacune.zo),
					A2($author$project$Components$Notifications$Model$traitementDeFin, model, chacune));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var groupe = _v1.a.a;
					var traitement = _v1.b.a;
					return A3($author$project$Components$Notifications$Cloche$finDeTraitement, i18n, groupe, traitement);
				} else {
					return _Utils_Tuple2(
						$author$project$I18n$Cles$notificationsTraitementTermine(i18n),
						'');
				}
			default:
				return _Utils_Tuple2(
					$author$project$I18n$Cles$notificationsNatureInconnue(i18n),
					'');
		}
	});
var $author$project$Components$Notifications$Cloche$notification = F3(
	function (i18n, model, chacune) {
		var _v0 = A3($author$project$Components$Notifications$Cloche$texte, i18n, model, chacune);
		var titre = _v0.a;
		var detail = _v0.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('item'),
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('non-lue', !chacune.B1)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_Utils_ap(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('notification'),
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('non-lue', !chacune.B1)
									])),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Components$Notifications$Update$NotificationCliquee(chacune.r8))
							]),
						$author$project$Components$Notifications$Cloche$cible(chacune)),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('point'),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('texte')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(titre)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('detail')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(detail)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('date')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A3($author$project$Components$Notifications$Cloche$quand, i18n, model, chacune))
												])),
											_Utils_eq(chacune.g1, $author$project$Components$Notifications$API$QueryAPIModel$TraitementTermine) ? A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('ouvrir')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$I18n$Cles$notificationsOuvrirLeGroupe(i18n))
												])) : $rtfeldman$elm_css$Html$Styled$text('')
										]))
								]))
						]))
				]));
	});
var $author$project$I18n$Cles$notificationsClocheCompte = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'notifications.cloche.compte',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' non lue') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' non lues'));
	});
var $author$project$I18n$Cles$notificationsClocheNom = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'notifications.cloche.nom',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? ('Notifications, ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' non lue')) : ('Notifications, ' + (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' non lues')));
	});
var $author$project$Components$Shared$Svg$svgNotifications = A3($author$project$Components$Shared$Svg$icone, 'notifications', 'M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15zM10 20.5a2 2 0 0 0 4 0', _List_Nil);
var $author$project$Components$Notifications$Cloche$view = F2(
	function (i18n, model) {
		var _v0 = model.nW;
		if (_v0.$ === 1) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var liste = _v0.a;
			var nom = (!liste.oG) ? $author$project$I18n$Cles$notificationsTitre(i18n) : A2(
				$author$project$I18n$Cles$notificationsClocheNom,
				i18n,
				{w: liste.oG});
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('cloche'),
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('opened', model.Es)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('button-icon'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', nom),
								$rtfeldman$elm_css$Html$Styled$Attributes$title(nom),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-expanded',
								model.Es ? 'true' : 'false'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Notifications$Update$ClocheBasculee)
							]),
						_List_fromArray(
							[$author$project$Components$Shared$Svg$svgNotifications])),
						(liste.oG > 0) ? A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('pastille'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$String$fromInt(liste.oG))
							])) : $rtfeldman$elm_css$Html$Styled$text(''),
						model.Es ? A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('fond'),
								$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$Notifications$Update$ClocheFermee)
							]),
						_List_Nil) : $rtfeldman$elm_css$Html$Styled$text(''),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('panneau'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'dialog'),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'aria-label',
								$author$project$I18n$Cles$notificationsTitre(i18n))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('panneau-top')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$strong,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$I18n$Cles$notificationsTitre(i18n))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('compte')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2(
													$author$project$I18n$Cles$notificationsClocheCompte,
													i18n,
													{w: liste.oG}))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$ul,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('liste')
									]),
								A2(
									$elm$core$List$map,
									A2($author$project$Components$Notifications$Cloche$notification, i18n, model),
									liste.oN))
							]))
					]));
		}
	});
var $author$project$Main$View$miseEnPage = F3(
	function (i18n, donnees, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$menu,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('replie', model.C5.qt),
									_Utils_Tuple2('deplie', model.C5.kG)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Main$Update$NavigationMsg,
							A3($author$project$Components$Shared$Navigation$View$barreDesApplications, i18n, donnees, model.C5)),
							A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Main$Update$NavigationMsg,
							A3($author$project$Components$Shared$Navigation$View$menu, i18n, donnees, model.C5))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('layout')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Main$Update$NotificationsMsg,
							A2($author$project$Components$Notifications$Cloche$view, i18n, model.oN)),
							A2($author$project$Main$View$pageGardee, i18n, model)
						]))
				]));
	});
var $author$project$I18n$Cles$alertesPastille = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'alertes.pastille',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Entier(p.w))
				]),
			((!p.w) || (p.w === 1)) ? (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' alerte') : (A2($author$project$I18n$Nombre$formater, 0, p.w) + ' alertes'));
	});
var $author$project$Components$Socle$Coquille$View$alertes = F4(
	function (i18n, route, pastille, connexion) {
		var adresse = (!_Utils_eq(
			A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$alertesDeProduits, connexion.gF),
			$elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just($author$project$Routes$Route$adresseAlertes) : ((!_Utils_eq(
			A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$alertesDePartiesPrenantes, connexion.gF),
			$elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just($author$project$Routes$Route$adresseAlertesDePartiesPrenantes) : $elm$core$Maybe$Nothing);
		if (!adresse.$) {
			var lien = adresse.a;
			return _List_fromArray(
				[
					{
					aa: lien,
					wj: _Utils_eq(route, $author$project$Routes$Route$Alertes) || _Utils_eq(route, $author$project$Routes$Route$AlertesDePartiesPrenantes),
					aC: $author$project$Components$Shared$Svg$svgWarning,
					Dj: $author$project$I18n$Cles$produitsAlertesTitre(i18n),
					hn: A2(
						$elm$core$Maybe$map,
						function (nombre) {
							return {
								Dj: A2(
									$author$project$I18n$Cles$alertesPastille,
									i18n,
									{w: nombre}),
								w: nombre
							};
						},
						pastille),
					hT: _List_Nil,
					hY: _List_Nil
				}
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Socle$Coquille$View$application = function (recue) {
	return {
		aa: $elm$core$Maybe$Just(recue.aa),
		dy: recue.dy,
		wj: recue.wj,
		aC: recue.aC,
		Dj: recue.Dj
	};
};
var $author$project$I18n$Cles$marqueAsriaCockpit = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'marque.asria.cockpit', _List_Nil, 'Asria Cockpit');
};
var $author$project$I18n$Cles$marqueAsriaInsight = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'marque.asria.insight', _List_Nil, 'Asria Insight');
};
var $author$project$Components$Socle$Coquille$View$applicationsAsria = function (i18n) {
	return _List_fromArray(
		[
			{
			aa: $elm$core$Maybe$Just($author$project$Routes$Route$adresseAccueil),
			dy: 'crm',
			wj: true,
			aC: $elm$core$Maybe$Nothing,
			Dj: $author$project$I18n$Cles$marqueAsriaCrm(i18n)
		},
			{
			aa: $elm$core$Maybe$Nothing,
			dy: 'cockpit',
			wj: false,
			aC: $elm$core$Maybe$Nothing,
			Dj: $author$project$I18n$Cles$marqueAsriaCockpit(i18n)
		},
			{
			aa: $elm$core$Maybe$Nothing,
			dy: 'insight',
			wj: false,
			aC: $elm$core$Maybe$Nothing,
			Dj: $author$project$I18n$Cles$marqueAsriaInsight(i18n)
		}
		]);
};
var $author$project$Components$Socle$Coquille$View$espaceDuCompte = F2(
	function (courant, espace) {
		return {
			sO: espace.sO,
			dy: espace.td,
			wi: _Utils_eq(espace.td, courant),
			n$: espace.n$,
			Dj: espace.Dj
		};
	});
var $author$project$I18n$Cles$importsMenuNouvelImport = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'imports.menu.nouvel-import', _List_Nil, 'Nouvel import');
};
var $author$project$Components$Socle$Coquille$View$importer = F3(
	function (i18n, route, connexion) {
		return (!_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$imports, connexion.nQ),
			$elm$core$Maybe$Nothing)) ? _List_fromArray(
			[
				{
				aa: $author$project$Routes$Route$adresseImporter,
				wj: function () {
					switch (route.$) {
						case 66:
							return true;
						case 67:
							return true;
						case 68:
							return true;
						default:
							return false;
					}
				}(),
				aC: $author$project$Components$Shared$Svg$svgArrowUp,
				Dj: $author$project$I18n$Cles$importsMenu(i18n),
				hn: $elm$core$Maybe$Nothing,
				hT: _List_Nil,
				hY: _Utils_ap(
					_List_fromArray(
						[
							{
							aa: $author$project$Routes$Route$adresseImporter,
							wj: function () {
								if (route.$ === 66) {
									return true;
								} else {
									return false;
								}
							}(),
							Dj: $author$project$I18n$Cles$importsMenuNouvelImport(i18n),
							hn: $elm$core$Maybe$Nothing
						}
						]),
					_List_fromArray(
						[
							{
							aa: $author$project$Routes$Route$adresseHistoriqueDesImports,
							wj: _Utils_eq(route, $author$project$Routes$Route$HistoriqueDesImports),
							Dj: $author$project$I18n$Cles$importsMenuHistorique(i18n),
							hn: $elm$core$Maybe$Nothing
						}
						]))
			}
			]) : _List_Nil;
	});
var $author$project$I18n$Cles$notificationsMenu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'notifications.menu', _List_Nil, 'Notifications');
};
var $author$project$I18n$Cles$notificationsMenuNonLues = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'notifications.menu.non-lues',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			'Notifications (' + (p.w + ')'));
	});
var $author$project$Components$Socle$Coquille$View$notifications = F4(
	function (i18n, route, nonLues, connexion) {
		var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$notifications, connexion.nQ);
		if (!_v0.$) {
			return _List_fromArray(
				[
					{
					aa: $author$project$Routes$Route$adresseDesNotifications,
					wj: _Utils_eq(route, $author$project$Routes$Route$Notifications),
					aC: $author$project$Components$Shared$Svg$svgNotifications,
					Dj: function () {
						if (!nonLues.$) {
							var nombre = nonLues.a;
							return (nombre > 0) ? A2(
								$author$project$I18n$Cles$notificationsMenuNonLues,
								i18n,
								{
									w: $elm$core$String$fromInt(nombre)
								}) : $author$project$I18n$Cles$notificationsMenu(i18n);
						} else {
							return $author$project$I18n$Cles$notificationsMenu(i18n);
						}
					}(),
					hn: $elm$core$Maybe$Nothing,
					hT: _List_Nil,
					hY: _List_Nil
				}
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$I18n$Cles$bibliothequeMenu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'bibliotheque.menu', _List_Nil, 'Bibliothèque de champs');
};
var $author$project$I18n$Cles$coquilleMenuRolesEtDroits = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'coquille.menu.roles-et-droits', _List_Nil, 'Rôles et droits');
};
var $author$project$I18n$Cles$coquilleMenuSectionCommunication = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'coquille.menu.section.communication', _List_Nil, 'Communication');
};
var $author$project$I18n$Cles$coquilleMenuSectionDonnees = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'coquille.menu.section.donnees', _List_Nil, 'Données');
};
var $author$project$I18n$Cles$coquilleMenuSectionOrganisation = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'coquille.menu.section.organisation', _List_Nil, 'Organisation');
};
var $author$project$I18n$Cles$coquilleMenuSectionPipes = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'coquille.menu.section.pipes', _List_Nil, 'Pipes');
};
var $author$project$I18n$Cles$listesMenu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'listes.menu', _List_Nil, 'Listes et correspondances');
};
var $author$project$I18n$Cles$perimetresMenu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'perimetres.menu', _List_Nil, 'Périmètres d\'offre');
};
var $author$project$I18n$Cles$typesDeQuantiteMenu = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'types.de.quantite.menu', _List_Nil, 'Types de règles de quantité');
};
var $author$project$Components$Socle$Coquille$View$parametrage = F3(
	function (i18n, route, connexion) {
		var utilisateurs = function () {
			var _v17 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$invitations, connexion.nQ);
			if (!_v17.$) {
				return _List_fromArray(
					[
						{
						aa: $author$project$Routes$Route$adresseDesUtilisateurs,
						wj: A2(
							$elm$core$List$member,
							route,
							_List_fromArray(
								[$author$project$Routes$Route$Utilisateurs, $author$project$Routes$Route$SecuriteDesUtilisateurs])),
						Dj: $author$project$I18n$Cles$utilisateursFil(i18n),
						hn: $elm$core$Maybe$Nothing
					}
					]);
			} else {
				return _List_Nil;
			}
		}();
		var typesDeQuantite = function () {
			var _v16 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$typesDeQuantite, connexion.nQ);
			if (!_v16.$) {
				return _List_fromArray(
					[
						{
						aa: $author$project$Routes$Route$adresseDesTypesDeQuantite,
						wj: _Utils_eq(route, $author$project$Routes$Route$TypesDeQuantite),
						Dj: $author$project$I18n$Cles$typesDeQuantiteMenu(i18n),
						hn: $elm$core$Maybe$Nothing
					}
					]);
			} else {
				return _List_Nil;
			}
		}();
		var surLesTypesDePartiesPrenantes = function () {
			switch (route.$) {
				case 42:
					return true;
				case 69:
					return true;
				case 70:
					return true;
				default:
					return false;
			}
		}();
		var typesDePartiesPrenantes = function () {
			var _v14 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$parametrageDesTypesDePartiePrenante, connexion.nQ);
			if (!_v14.$) {
				return _List_fromArray(
					[
						{
						aa: $author$project$Routes$Route$adresseTypesDePartiesPrenantes,
						wj: surLesTypesDePartiesPrenantes,
						Dj: $author$project$I18n$Cles$referentielTypesTitre(i18n),
						hn: $elm$core$Maybe$Nothing
					}
					]);
			} else {
				return _List_Nil;
			}
		}();
		var surLesPipes = _Utils_eq(route, $author$project$Routes$Route$Pipes);
		var surLesListes = _Utils_eq(route, $author$project$Routes$Route$Listes) || function () {
			switch (route.$) {
				case 45:
					return true;
				case 46:
					return true;
				case 50:
					return true;
				default:
					return false;
			}
		}();
		var surLesGroupes = _Utils_eq(route, $author$project$Routes$Route$Groupes);
		var surLesDroits = function () {
			if (route.$ === 53) {
				return true;
			} else {
				return false;
			}
		}();
		var surLeCatalogue = function () {
			switch (route.$) {
				case 6:
					return true;
				case 7:
					return true;
				case 40:
					return true;
				case 41:
					return true;
				default:
					return false;
			}
		}();
		var pipes = function () {
			var _v10 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$pipes, connexion.nQ);
			if (!_v10.$) {
				return _List_fromArray(
					[
						{
						aa: $author$project$Routes$Route$adressePipes,
						wj: surLesPipes,
						Dj: $author$project$I18n$Cles$pipesTitre(i18n),
						hn: $elm$core$Maybe$Nothing
					}
					]);
			} else {
				return _List_Nil;
			}
		}();
		var perimetres = function () {
			var _v8 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$perimetres, connexion.nQ);
			if (!_v8.$) {
				return _List_fromArray(
					[
						{
						aa: $author$project$Routes$Route$adresseDesPerimetres,
						wj: _Utils_eq(route, $author$project$Routes$Route$Perimetres) || function () {
							if (route.$ === 48) {
								return true;
							} else {
								return false;
							}
						}(),
						Dj: $author$project$I18n$Cles$perimetresMenu(i18n),
						hn: $elm$core$Maybe$Nothing
					}
					]);
			} else {
				return _List_Nil;
			}
		}();
		var offert = A2(
			$elm$core$List$any,
			function (rel) {
				return !_Utils_eq(
					A2($author$project$API$Liens$trouver, rel, connexion.nQ),
					$elm$core$Maybe$Nothing);
			},
			_List_fromArray(
				[$author$project$API$NavLinksDictionary$structureDuCatalogue, $author$project$API$NavLinksDictionary$typesDeProduit]));
		var listes = function () {
			var _v7 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$listes, connexion.nQ);
			if (!_v7.$) {
				return _List_fromArray(
					[
						{
						aa: $author$project$Routes$Route$adresseListes,
						wj: surLesListes,
						Dj: $author$project$I18n$Cles$listesMenu(i18n),
						hn: $elm$core$Maybe$Nothing
					}
					]);
			} else {
				return _List_Nil;
			}
		}();
		var langues = function () {
			var _v6 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$languesDuClient, connexion.nQ);
			if (!_v6.$) {
				return _List_fromArray(
					[
						{
						aa: $author$project$Routes$Route$adresseDesLanguesDuClient,
						wj: _Utils_eq(route, $author$project$Routes$Route$LanguesDuClient),
						Dj: $author$project$I18n$Cles$languesFil(i18n),
						hn: $elm$core$Maybe$Nothing
					}
					]);
			} else {
				return _List_Nil;
			}
		}();
		var groupes = function () {
			var _v5 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$groupes, connexion.nQ);
			if (!_v5.$) {
				return _List_fromArray(
					[
						{
						aa: $author$project$Routes$Route$adresseGroupes,
						wj: surLesGroupes,
						Dj: $author$project$I18n$Cles$referentielGroupesTitre(i18n),
						hn: $elm$core$Maybe$Nothing
					}
					]);
			} else {
				return _List_Nil;
			}
		}();
		var droits = function () {
			var _v4 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$rolesInternes, connexion.nQ);
			if (!_v4.$) {
				return _List_fromArray(
					[
						{
						aa: $author$project$Routes$Route$adresseDesDroits,
						wj: surLesDroits,
						Dj: $author$project$I18n$Cles$coquilleMenuRolesEtDroits(i18n),
						hn: $elm$core$Maybe$Nothing
					}
					]);
			} else {
				return _List_Nil;
			}
		}();
		var organisation = _Utils_ap(utilisateurs, droits);
		var conservation = function () {
			var _v3 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$echeancesDeConservation, connexion.nQ);
			if (!_v3.$) {
				return _List_fromArray(
					[
						{
						aa: $author$project$Routes$Route$adresseDesEcheancesDeConservation,
						wj: _Utils_eq(route, $author$project$Routes$Route$EcheancesDeConservation),
						Dj: $author$project$I18n$Cles$conservationEcheancesFil(i18n),
						hn: $elm$core$Maybe$Nothing
					}
					]);
			} else {
				return _List_Nil;
			}
		}();
		var compteur = (!_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$reglageDuCompteurDeCode, connexion.nQ),
			$elm$core$Maybe$Nothing)) ? _List_fromArray(
			[
				{
				aa: $author$project$Routes$Route$adresseDuCompteurDeCode,
				wj: _Utils_eq(route, $author$project$Routes$Route$CompteurDeCode),
				Dj: $author$project$I18n$Cles$compteurFil(i18n),
				hn: $elm$core$Maybe$Nothing
			}
			]) : _List_Nil;
		var compteDEnvoi = (!_Utils_eq(
			A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$compteDEnvoi, connexion.nQ),
			$elm$core$Maybe$Nothing)) ? _List_fromArray(
			[
				{
				aa: $author$project$Routes$Route$adresseDuCompteDEnvoi,
				wj: _Utils_eq(route, $author$project$Routes$Route$CompteDEnvoi),
				Dj: $author$project$I18n$Cles$compteDEnvoiFil(i18n),
				hn: $elm$core$Maybe$Nothing
			}
			]) : _List_Nil;
		var catalogue = offert ? _List_fromArray(
			[
				{
				aa: $author$project$Routes$Route$adresseDuParcoursDuCatalogue,
				wj: surLeCatalogue,
				Dj: $author$project$I18n$Cles$produitsParametrageCatalogue(i18n),
				hn: $elm$core$Maybe$Nothing
			}
			]) : _List_Nil;
		var bibliotheque = function () {
			var _v1 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$bibliothequeDeChamps, connexion.nQ);
			if (!_v1.$) {
				return _List_fromArray(
					[
						{
						aa: $author$project$Routes$Route$adresseBibliothequeDeChamps,
						wj: function () {
							if (route.$ === 51) {
								return true;
							} else {
								return false;
							}
						}(),
						Dj: $author$project$I18n$Cles$bibliothequeMenu(i18n),
						hn: $elm$core$Maybe$Nothing
					}
					]);
			} else {
				return _List_Nil;
			}
		}();
		var donnees = _Utils_ap(
			typesDePartiesPrenantes,
			_Utils_ap(
				groupes,
				_Utils_ap(
					bibliotheque,
					_Utils_ap(
						listes,
						_Utils_ap(
							catalogue,
							_Utils_ap(
								perimetres,
								_Utils_ap(
									typesDeQuantite,
									_Utils_ap(
										compteur,
										_Utils_ap(conservation, langues)))))))));
		var sections = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.yv;
				},
				A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)),
			_List_fromArray(
				[
					{
					yv: organisation,
					h6: $author$project$I18n$Cles$coquilleMenuSectionOrganisation(i18n)
				},
					{
					yv: donnees,
					h6: $author$project$I18n$Cles$coquilleMenuSectionDonnees(i18n)
				},
					{
					yv: pipes,
					h6: $author$project$I18n$Cles$coquilleMenuSectionPipes(i18n)
				},
					{
					yv: compteDEnvoi,
					h6: $author$project$I18n$Cles$coquilleMenuSectionCommunication(i18n)
				}
				]));
		var pages = A2(
			$elm$core$List$concatMap,
			function ($) {
				return $.yv;
			},
			sections);
		if (pages.b) {
			var premiere = pages.a;
			return _List_fromArray(
				[
					{
					aa: premiere.aa,
					wj: A2(
						$elm$core$List$any,
						function ($) {
							return $.wj;
						},
						pages),
					aC: $author$project$Components$Shared$Svg$svgSettings,
					Dj: $author$project$I18n$Cles$produitsParametrageTitre(i18n),
					hn: $elm$core$Maybe$Nothing,
					hT: sections,
					hY: _List_Nil
				}
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$I18n$Cles$referentielDoublonsMenuPastille = F2(
	function (i18n, p) {
		return A4(
			$author$project$I18n$Cles$lire,
			i18n,
			'referentiel.doublons.menu.pastille',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nombre',
					$author$project$I18n$Traductions$Chaine(p.w))
				]),
			p.w + ' paires à examiner');
	});
var $author$project$Components$Socle$Coquille$View$doublons = F4(
	function (i18n, route, pastille, connexion) {
		return (!_Utils_eq(
			A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$fileDesDoublons, connexion.gF),
			$elm$core$Maybe$Nothing)) ? _List_fromArray(
			[
				{
				aa: $author$project$Routes$Route$adresseDoublons,
				wj: _Utils_eq(route, $author$project$Routes$Route$Doublons) || _Utils_eq(route, $author$project$Routes$Route$DoublonsEcartees),
				Dj: $author$project$I18n$Cles$referentielDoublonsTitre(i18n),
				hn: A2(
					$elm$core$Maybe$map,
					function (nombre) {
						return {
							Dj: A2(
								$author$project$I18n$Cles$referentielDoublonsMenuPastille,
								i18n,
								{
									w: $elm$core$String$fromInt(nombre)
								}),
							w: nombre
						};
					},
					pastille)
			}
			]) : _List_Nil;
	});
var $author$project$Components$Socle$Coquille$View$groupesDuMenu = F3(
	function (i18n, route, connexion) {
		var _v0 = A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$groupes, connexion.nQ);
		if (!_v0.$) {
			return _List_fromArray(
				[
					{
					aa: $author$project$Routes$Route$adresseGroupes,
					wj: _Utils_eq(route, $author$project$Routes$Route$Groupes),
					Dj: $author$project$I18n$Cles$referentielGroupesTitre(i18n),
					hn: $elm$core$Maybe$Nothing
				}
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Socle$Coquille$View$partiesPrenantesParNature = F2(
	function (i18n, route) {
		var pourLaNature = F2(
			function (nature, nom) {
				var demandee = $author$project$Routes$Route$premierePage;
				var aucunFiltre = $author$project$Routes$Route$aucunFiltre;
				var filtree = _Utils_update(
					demandee,
					{
						mG: _Utils_update(
							aucunFiltre,
							{
								g1: $elm$core$Maybe$Just(nature)
							})
					});
				return {
					aa: $author$project$Routes$Route$toString(
						$author$project$Routes$Route$PartiesPrenantesListe(filtree)),
					wj: function () {
						if (route.$ === 2) {
							var courante = route.a;
							return _Utils_eq(
								courante.mG.g1,
								$elm$core$Maybe$Just(nature));
						} else {
							return false;
						}
					}(),
					Dj: nom,
					hn: $elm$core$Maybe$Nothing
				};
			});
		return _List_fromArray(
			[
				A2(
				pourLaNature,
				'Personne',
				$author$project$I18n$Cles$referentielFicheFilPersonnes(i18n)),
				A2(
				pourLaNature,
				'Organisation',
				$author$project$I18n$Cles$referentielFicheFilOrganisations(i18n))
			]);
	});
var $author$project$Components$Socle$Coquille$View$partiesPrenantes = F4(
	function (i18n, route, pastilleDesDoublons, connexion) {
		return {
			aa: $author$project$Routes$Route$adressePartiesPrenantes,
			wj: function () {
				switch (route.$) {
					case 2:
						return true;
					case 3:
						return true;
					case 5:
						return true;
					case 35:
						return true;
					case 36:
						return true;
					default:
						return false;
				}
			}(),
			aC: $author$project$Components$Shared$Svg$svgUsers,
			Dj: $author$project$I18n$Cles$referentielPartiesPrenantesTitre(i18n),
			hn: $elm$core$Maybe$Nothing,
			hT: _List_Nil,
			hY: _Utils_ap(
				A2($author$project$Components$Socle$Coquille$View$partiesPrenantesParNature, i18n, route),
				_Utils_ap(
					A3($author$project$Components$Socle$Coquille$View$groupesDuMenu, i18n, route, connexion),
					A4($author$project$Components$Socle$Coquille$View$doublons, i18n, route, pastilleDesDoublons, connexion)))
		};
	});
var $author$project$Components$Socle$Coquille$View$peutLireLesPartiesPrenantes = function (connexion) {
	return (!_Utils_eq(
		A2($author$project$API$Liens$trouverGabarit, $author$project$API$NavLinksDictionary$entites, connexion.gF),
		$elm$core$Maybe$Nothing)) || (!_Utils_eq(
		A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$creerEntite, connexion.nQ),
		$elm$core$Maybe$Nothing));
};
var $author$project$Components$Socle$Coquille$View$produits = F3(
	function (i18n, route, connexion) {
		var surLesOffres = function () {
			switch (route.$) {
				case 30:
					return true;
				case 31:
					return true;
				case 32:
					return true;
				default:
					return false;
			}
		}();
		var surLesMarques = function () {
			switch (route.$) {
				case 8:
					return true;
				case 23:
					return true;
				case 24:
					return true;
				default:
					return false;
			}
		}();
		var surLesListesDePrix = function () {
			switch (route.$) {
				case 37:
					return true;
				case 38:
					return true;
				case 39:
					return true;
				default:
					return false;
			}
		}();
		var surLeCatalogue = function () {
			switch (route.$) {
				case 25:
					return true;
				case 28:
					return true;
				case 29:
					return true;
				default:
					return false;
			}
		}();
		var pages = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					function (_v1) {
						return {
							aa: $author$project$Routes$Route$adresseCatalogue,
							wj: surLeCatalogue,
							Dj: $author$project$I18n$Cles$produitsReferencesTitre(i18n),
							hn: $elm$core$Maybe$Nothing
						};
					},
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$catalogue, connexion.nQ)),
					A2(
					$elm$core$Maybe$map,
					function (_v2) {
						return {
							aa: $author$project$Routes$Route$adresseOffres,
							wj: surLesOffres,
							Dj: $author$project$I18n$Cles$produitsOffresTitre(i18n),
							hn: $elm$core$Maybe$Nothing
						};
					},
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$offresDeService, connexion.nQ)),
					A2(
					$elm$core$Maybe$map,
					function (_v3) {
						return {
							aa: $author$project$Routes$Route$adresseListesDePrix,
							wj: surLesListesDePrix,
							Dj: $author$project$I18n$Cles$produitsListesDePrixTitre(i18n),
							hn: $elm$core$Maybe$Nothing
						};
					},
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$listesDePrix, connexion.nQ)),
					A2(
					$elm$core$Maybe$map,
					function (_v4) {
						return {
							aa: $author$project$Routes$Route$adresseMarquesEtGammes,
							wj: surLesMarques,
							Dj: $author$project$I18n$Cles$produitsMarquesEtGammesTitre(i18n),
							hn: $elm$core$Maybe$Nothing
						};
					},
					A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$marquesEtGammes, connexion.nQ))
				]));
		if (pages.b) {
			var premiere = pages.a;
			return _List_fromArray(
				[
					{
					aa: premiere.aa,
					wj: A2(
						$elm$core$List$any,
						function ($) {
							return $.wj;
						},
						pages),
					aC: $author$project$Components$Shared$Svg$svgFolders,
					Dj: $author$project$I18n$Cles$produitsTitre(i18n),
					hn: $elm$core$Maybe$Nothing,
					hT: _List_Nil,
					hY: pages
				}
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Socle$Coquille$View$navigation = F7(
	function (i18n, marque, route, nonLues, pastilleDesAlertes, pastilleDesDoublons, connexion) {
		return {
			tz: A2(
				$elm$core$Maybe$withDefault,
				$author$project$Components$Socle$Coquille$View$applicationsAsria(i18n),
				A2(
					$elm$core$Maybe$map,
					$elm$core$List$map($author$project$Components$Socle$Coquille$View$application),
					marque.tz)),
			vW: $elm$core$Maybe$Just(
				{
					AP: $author$project$Texte$Initiales$initiales(connexion.Dj),
					Dj: connexion.Dj,
					En: '',
					bi: ''
				}),
			wU: true,
			yv: A2(
				$elm$core$List$cons,
				{
					aa: $author$project$Routes$Route$adresseAccueil,
					wj: _Utils_eq(route, $author$project$Routes$Route$Accueil),
					aC: $author$project$Components$Shared$Svg$svgDashboard,
					Dj: $author$project$I18n$Cles$accueilTitre(i18n),
					hn: $elm$core$Maybe$Nothing,
					hT: _List_Nil,
					hY: _List_Nil
				},
				_Utils_ap(
					$author$project$Components$Socle$Coquille$View$peutLireLesPartiesPrenantes(connexion) ? _List_fromArray(
						[
							A4($author$project$Components$Socle$Coquille$View$partiesPrenantes, i18n, route, pastilleDesDoublons, connexion)
						]) : _List_Nil,
					_Utils_ap(
						A3($author$project$Components$Socle$Coquille$View$produits, i18n, route, connexion),
						_Utils_ap(
							A3($author$project$Components$Socle$Coquille$View$importer, i18n, route, connexion),
							_Utils_ap(
								A4($author$project$Components$Socle$Coquille$View$alertes, i18n, route, pastilleDesAlertes, connexion),
								_Utils_ap(
									A3($author$project$Components$Socle$Coquille$View$parametrage, i18n, route, connexion),
									A4($author$project$Components$Socle$Coquille$View$notifications, i18n, route, nonLues, connexion))))))),
			yC: A2(
				$elm$core$List$map,
				$author$project$Components$Socle$Coquille$View$espaceDuCompte(connexion.En),
				connexion.yC),
			AK: false,
			n$: marque.n$,
			CT: A2(
				$elm$core$Maybe$map,
				function (_v0) {
					return $author$project$Routes$Route$adresseDeMonCompte;
				},
				A2($author$project$API$Liens$trouver, $author$project$API$NavLinksDictionary$monCompteProfil, connexion.nQ)),
			Dk: A2(
				$elm$core$Maybe$withDefault,
				$author$project$I18n$Cles$marqueAsriaCrm(i18n),
				marque.Dj)
		};
	});
var $author$project$Main$View$pastilleDesAlertes = function (model) {
	var _v0 = _Utils_Tuple2(model.tb.ys, model.tc.ys);
	if ((_v0.a.$ === 1) && (_v0.b.$ === 1)) {
		var _v1 = _v0.a;
		var _v2 = _v0.b;
		return $elm$core$Maybe$Nothing;
	} else {
		var produits = _v0.a;
		var partiesPrenantes = _v0.b;
		var total = A2($elm$core$Maybe$withDefault, 0, produits) + A2($elm$core$Maybe$withDefault, 0, partiesPrenantes);
		return (total > 0) ? $elm$core$Maybe$Just(total) : $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Socle$Theme$Model$themeApplique = function (model) {
	var _v0 = model.gt;
	if (_v0.$ === 2) {
		var theme = _v0.a;
		return $elm$core$Maybe$Just(theme);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Main$View$surcharges = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		{AH: _List_Nil, gX: $author$project$Components$Shared$Theme$Model$marqueAsria, Jg: _List_Nil},
		$author$project$Components$Socle$Theme$Model$themeApplique(model.JA));
};
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
	function (_v0, styles) {
		var newStyles = _v0.b;
		var classname = _v0.c;
		return $elm$core$List$isEmpty(newStyles) ? styles : A3($elm$core$Dict$insert, classname, newStyles, styles);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = function (_v0) {
	var val = _v0.a;
	return val;
};
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_keyedNodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm$virtual_dom$VirtualDom$nodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_nodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
	function (_v6, _v7) {
		var key = _v6.a;
		var html = _v6.b;
		var pairs = _v7.a;
		var styles = _v7.b;
		switch (html.$) {
			case 4:
				var vdom = html.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v9 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v9.a;
				var finalStyles = _v9.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v10 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v10.a;
				var finalStyles = _v10.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v11 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v11.a;
				var finalStyles = _v11.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v12 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v12.a;
				var finalStyles = _v12.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
	function (html, _v0) {
		var nodes = _v0.a;
		var styles = _v0.b;
		switch (html.$) {
			case 4:
				var vdomNode = html.a;
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v2 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v2.a;
				var finalStyles = _v2.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v3 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v3.a;
				var finalStyles = _v3.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v4 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v4.a;
				var finalStyles = _v4.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v5 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v5.a;
				var finalStyles = _v5.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp = F2(
	function (candidate, properties) {
		stylesFromPropertiesHelp:
		while (true) {
			if (!properties.b) {
				return candidate;
			} else {
				var _v1 = properties.a;
				var styles = _v1.b;
				var classname = _v1.c;
				var rest = properties.b;
				if ($elm$core$String$isEmpty(classname)) {
					var $temp$candidate = candidate,
						$temp$properties = rest;
					candidate = $temp$candidate;
					properties = $temp$properties;
					continue stylesFromPropertiesHelp;
				} else {
					var $temp$candidate = $elm$core$Maybe$Just(
						_Utils_Tuple2(classname, styles)),
						$temp$properties = rest;
					candidate = $temp$candidate;
					properties = $temp$properties;
					continue stylesFromPropertiesHelp;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties = function (properties) {
	var _v0 = A2($rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp, $elm$core$Maybe$Nothing, properties);
	if (_v0.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var _v1 = _v0.a;
		var classname = _v1.a;
		var styles = _v1.b;
		return A2($elm$core$Dict$singleton, classname, styles);
	}
};
var $rtfeldman$elm_css$Css$Structure$compactHelp = F2(
	function (declaration, _v0) {
		var keyframesByName = _v0.a;
		var declarations = _v0.b;
		switch (declaration.$) {
			case 0:
				var _v2 = declaration.a;
				var properties = _v2.c;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 1:
				var styleBlocks = declaration.b;
				return A2(
					$elm$core$List$all,
					function (_v3) {
						var properties = _v3.c;
						return $elm$core$List$isEmpty(properties);
					},
					styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 2:
				var otherDeclarations = declaration.b;
				return $elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 3:
				return _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 4:
				var properties = declaration.b;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 5:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 6:
				var record = declaration.a;
				return $elm$core$String$isEmpty(record.wM) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					A3($elm$core$Dict$insert, record.C1, record.wM, keyframesByName),
					declarations);
			case 7:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 8:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			default:
				var tuples = declaration.a;
				return A2(
					$elm$core$List$all,
					function (_v4) {
						var properties = _v4.b;
						return $elm$core$List$isEmpty(properties);
					},
					tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
		}
	});
var $rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
	function (keyframesByName, compactedDeclarations) {
		return A2(
			$elm$core$List$append,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var name = _v0.a;
					var decl = _v0.b;
					return $rtfeldman$elm_css$Css$Structure$Keyframes(
						{wM: decl, C1: name});
				},
				$elm$core$Dict$toList(keyframesByName)),
			compactedDeclarations);
	});
var $rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_v0) {
	var charset = _v0.jJ;
	var imports = _v0.cN;
	var namespaces = _v0.om;
	var declarations = _v0.wN;
	var _v1 = A3(
		$elm$core$List$foldr,
		$rtfeldman$elm_css$Css$Structure$compactHelp,
		_Utils_Tuple2($elm$core$Dict$empty, _List_Nil),
		declarations);
	var keyframesByName = _v1.a;
	var compactedDeclarations = _v1.b;
	var finalDeclarations = A2($rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
	return {jJ: charset, wN: finalDeclarations, cN: imports, om: namespaces};
};
var $rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (str) {
				return '@charset \"' + (str + '\"');
			},
			charset));
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
	return '(' + (expression.mw + (A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$append(': '),
			expression.ap)) + ')'));
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
	switch (mediaType) {
		case 0:
			return 'print';
		case 1:
			return 'screen';
		default:
			return 'speech';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
	var prefixWith = F3(
		function (str, mediaType, expressions) {
			return str + (' ' + A2(
				$elm$core$String$join,
				' and ',
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
		});
	switch (mediaQuery.$) {
		case 0:
			var expressions = mediaQuery.a;
			return A2(
				$elm$core$String$join,
				' and ',
				A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions));
		case 1:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'only', mediaType, expressions);
		case 2:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'not', mediaType, expressions);
		default:
			var str = mediaQuery.a;
			return str;
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
	function (name, mediaQuery) {
		return '@import \"' + (name + ($rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
	});
var $rtfeldman$elm_css$Css$Structure$Output$importToString = function (_v0) {
	var name = _v0.a;
	var mediaQueries = _v0.b;
	return A2(
		$elm$core$String$join,
		'\n',
		A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
			mediaQueries));
};
var $rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_v0) {
	var prefix = _v0.a;
	var str = _v0.b;
	return '@namespace ' + (prefix + ('\"' + (str + '\"')));
};
var $rtfeldman$elm_css$Css$Structure$Output$spaceIndent = '    ';
var $rtfeldman$elm_css$Css$Structure$Output$indent = function (str) {
	return _Utils_ap($rtfeldman$elm_css$Css$Structure$Output$spaceIndent, str);
};
var $rtfeldman$elm_css$Css$Structure$Output$noIndent = '';
var $rtfeldman$elm_css$Css$Structure$Output$emitProperty = function (str) {
	return str + ';';
};
var $rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
	return A2(
		$elm$core$String$join,
		'\n',
		A2(
			$elm$core$List$map,
			A2($elm$core$Basics$composeL, $rtfeldman$elm_css$Css$Structure$Output$indent, $rtfeldman$elm_css$Css$Structure$Output$emitProperty),
			properties));
};
var $elm$core$String$append = _String_append;
var $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_v0) {
	var str = _v0;
	return '::' + str;
};
var $rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
	switch (combinator) {
		case 0:
			return '+';
		case 1:
			return '~';
		case 2:
			return '>';
		default:
			return '';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
	switch (repeatableSimpleSelector.$) {
		case 0:
			var str = repeatableSimpleSelector.a;
			return '.' + str;
		case 1:
			var str = repeatableSimpleSelector.a;
			return '#' + str;
		case 2:
			var str = repeatableSimpleSelector.a;
			return ':' + str;
		default:
			var str = repeatableSimpleSelector.a;
			return '[' + (str + ']');
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
	switch (simpleSelectorSequence.$) {
		case 0:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$cons,
					str,
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
		case 1:
			var repeatableSimpleSelectors = simpleSelectorSequence.a;
			return $elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A2(
				$elm$core$String$join,
				'',
				A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors));
		default:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$cons,
					str,
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_v0) {
	var combinator = _v0.a;
	var sequence = _v0.b;
	return A2(
		$elm$core$String$join,
		' ',
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator),
				$rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence)
			]));
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_v0) {
	var simpleSelectorSequence = _v0.a;
	var chain = _v0.b;
	var pseudoElement = _v0.c;
	var segments = A2(
		$elm$core$List$cons,
		$rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
	var pseudoElementsString = A2(
		$elm$core$String$join,
		'',
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement))
			]));
	return A2(
		$elm$core$String$append,
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
				segments)),
		pseudoElementsString);
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = F2(
	function (indentLevel, _v0) {
		var firstSelector = _v0.a;
		var otherSelectors = _v0.b;
		var properties = _v0.c;
		var selectorStr = A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Css$Structure$Output$selectorToString,
				A2($elm$core$List$cons, firstSelector, otherSelectors)));
		return A2(
			$elm$core$String$join,
			'',
			_List_fromArray(
				[
					selectorStr,
					' {\n',
					indentLevel,
					$rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties),
					'\n',
					indentLevel,
					'}'
				]));
	});
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
	switch (decl.$) {
		case 0:
			var styleBlock = decl.a;
			return A2($rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, $rtfeldman$elm_css$Css$Structure$Output$noIndent, styleBlock);
		case 1:
			var mediaQueries = decl.a;
			var styleBlocks = decl.b;
			var query = A2(
				$elm$core$String$join,
				',\n',
				A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, mediaQueries));
			var blocks = A2(
				$elm$core$String$join,
				'\n\n',
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeL,
						$rtfeldman$elm_css$Css$Structure$Output$indent,
						$rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock($rtfeldman$elm_css$Css$Structure$Output$spaceIndent)),
					styleBlocks));
			return '@media ' + (query + (' {\n' + (blocks + '\n}')));
		case 2:
			return 'TODO';
		case 3:
			return 'TODO';
		case 4:
			return 'TODO';
		case 5:
			return 'TODO';
		case 6:
			var name = decl.a.C1;
			var declaration = decl.a.wM;
			return '@keyframes ' + (name + (' {\n' + (declaration + '\n}')));
		case 7:
			return 'TODO';
		case 8:
			return 'TODO';
		default:
			return 'TODO';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_v0) {
	var charset = _v0.jJ;
	var imports = _v0.cN;
	var namespaces = _v0.om;
	var declarations = _v0.wN;
	return A2(
		$elm$core$String$join,
		'\n\n',
		A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset),
					A2(
					$elm$core$String$join,
					'\n',
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$importToString, imports)),
					A2(
					$elm$core$String$join,
					'\n',
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$namespaceToString, namespaces)),
					A2(
					$elm$core$String$join,
					'\n\n',
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, declarations))
				])));
};
var $rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
	return {$: 8, a: a};
};
var $rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Css$Structure$PageRule = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$Selector = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
	return {$: 7, a: a};
};
var $rtfeldman$elm_css$Css$Structure$MediaRule = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$mapLast = F2(
	function (update, list) {
		if (!list.b) {
			return list;
		} else {
			if (!list.b.b) {
				var only = list.a;
				return _List_fromArray(
					[
						update(only)
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
	function (property, _v0) {
		var firstSelector = _v0.a;
		var otherSelectors = _v0.b;
		var properties = _v0.c;
		return A3(
			$rtfeldman$elm_css$Css$Structure$StyleBlock,
			firstSelector,
			otherSelectors,
			_Utils_ap(
				properties,
				_List_fromArray(
					[property])));
	});
var $rtfeldman$elm_css$Css$Structure$appendProperty = F2(
	function (property, declarations) {
		if (!declarations.b) {
			return declarations;
		} else {
			if (!declarations.b.b) {
				switch (declarations.a.$) {
					case 0:
						var styleBlock = declarations.a.a;
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
								A2($rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
							]);
					case 1:
						var _v1 = declarations.a;
						var mediaQueries = _v1.a;
						var styleBlocks = _v1.b;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Structure$MediaRule,
								mediaQueries,
								A2(
									$rtfeldman$elm_css$Css$Structure$mapLast,
									$rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
									styleBlocks))
							]);
					default:
						return declarations;
				}
			} else {
				var first = declarations.a;
				var rest = declarations.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
	function (f, styleBlock) {
		if (!styleBlock.b.b) {
			var only = styleBlock.a;
			var properties = styleBlock.c;
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
					A3(
					$rtfeldman$elm_css$Css$Structure$StyleBlock,
					f(only),
					_List_Nil,
					_List_Nil)
				]);
		} else {
			var first = styleBlock.a;
			var rest = styleBlock.b;
			var properties = styleBlock.c;
			var newRest = A2($elm$core$List$map, f, rest);
			var newFirst = f(first);
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
				]);
		}
	});
var $rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
	function (pseudo, _v0) {
		var sequence = _v0.a;
		var selectors = _v0.b;
		return A3(
			$rtfeldman$elm_css$Css$Structure$Selector,
			sequence,
			selectors,
			$elm$core$Maybe$Just(pseudo));
	});
var $rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
	function (pseudo, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
	function (selector, sequence) {
		switch (sequence.$) {
			case 0:
				var typeSelector = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
					typeSelector,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			case 1:
				var list = sequence.a;
				return $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			default:
				var str = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$CustomSelector,
					str,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
	function (selector, list) {
		if (!list.b) {
			return _List_Nil;
		} else {
			if (!list.b.b) {
				var _v1 = list.a;
				var combinator = _v1.a;
				var sequence = _v1.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						combinator,
						A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
	function (repeatableSimpleSelector, selector) {
		if (!selector.b.b) {
			var sequence = selector.a;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
				_List_Nil,
				pseudoElement);
		} else {
			var firstSelector = selector.a;
			var tuples = selector.b;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				firstSelector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
				pseudoElement);
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
	function (selector, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
	collectSelectors:
	while (true) {
		if (!declarations.b) {
			return _List_Nil;
		} else {
			if (!declarations.a.$) {
				var _v1 = declarations.a.a;
				var firstSelector = _v1.a;
				var otherSelectors = _v1.b;
				var rest = declarations.b;
				return _Utils_ap(
					A2($elm$core$List$cons, firstSelector, otherSelectors),
					$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
			} else {
				var rest = declarations.b;
				var $temp$declarations = rest;
				declarations = $temp$declarations;
				continue collectSelectors;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
	function (a, b, c, d, e) {
		return {$: 3, a: a, b: b, c: c, d: d, e: e};
	});
var $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
	function (update, declarations) {
		_v0$12:
		while (true) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 0:
							var styleBlock = declarations.a.a;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
								update(styleBlock));
						case 1:
							if (declarations.a.b.b) {
								if (!declarations.a.b.b.b) {
									var _v1 = declarations.a;
									var mediaQueries = _v1.a;
									var _v2 = _v1.b;
									var styleBlock = _v2.a;
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Css$Structure$MediaRule,
											mediaQueries,
											update(styleBlock))
										]);
								} else {
									var _v3 = declarations.a;
									var mediaQueries = _v3.a;
									var _v4 = _v3.b;
									var first = _v4.a;
									var rest = _v4.b;
									var _v5 = A2(
										$rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
										update,
										_List_fromArray(
											[
												A2($rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
											]));
									if ((_v5.b && (_v5.a.$ === 1)) && (!_v5.b.b)) {
										var _v6 = _v5.a;
										var newMediaQueries = _v6.a;
										var newStyleBlocks = _v6.b;
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Css$Structure$MediaRule,
												newMediaQueries,
												A2($elm$core$List$cons, first, newStyleBlocks))
											]);
									} else {
										var newDeclarations = _v5;
										return newDeclarations;
									}
								}
							} else {
								break _v0$12;
							}
						case 2:
							var _v7 = declarations.a;
							var str = _v7.a;
							var nestedDeclarations = _v7.b;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$Structure$SupportsRule,
									str,
									A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
								]);
						case 3:
							var _v8 = declarations.a;
							var str1 = _v8.a;
							var str2 = _v8.b;
							var str3 = _v8.c;
							var str4 = _v8.d;
							var styleBlock = _v8.e;
							return A2(
								$elm$core$List$map,
								A4($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
								update(styleBlock));
						case 4:
							var _v9 = declarations.a;
							return declarations;
						case 5:
							return declarations;
						case 6:
							return declarations;
						case 7:
							return declarations;
						case 8:
							return declarations;
						default:
							return declarations;
					}
				} else {
					break _v0$12;
				}
			}
		}
		var first = declarations.a;
		var rest = declarations.b;
		return A2(
			$elm$core$List$cons,
			first,
			A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {by: charsProcessed, bH: hash, q2: seed, b0: shift};
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$c1 = 3432918353;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$c2 = 461845907;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize = function (data) {
	var acc = (!(!data.bH)) ? (data.q2 ^ A2(
		$rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
		$rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
		A2(
			$rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
			15,
			A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, $rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, data.bH)))) : data.q2;
	var h0 = acc ^ data.by;
	var h1 = A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $elm$core$String$foldl = _String_foldl;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$mix = F2(
	function (h1, k1) {
		return A2(
			$rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
			5,
			A2(
				$rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
				13,
				h1 ^ A2(
					$rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
					$rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
					A2(
						$rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
						15,
						A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, $rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, k1))))) + 3864292196;
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold = F2(
	function (c, data) {
		var res = data.bH | ((255 & $elm$core$Char$toCode(c)) << data.b0);
		var _v0 = data.b0;
		if (_v0 === 24) {
			return {
				by: data.by + 1,
				bH: 0,
				q2: A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$mix, data.q2, res),
				b0: 0
			};
		} else {
			return {by: data.by + 1, bH: res, q2: data.q2, b0: data.b0 + 8};
		}
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString = F2(
	function (seed, str) {
		return $rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize(
			A3(
				$elm$core$String$foldl,
				$rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold,
				A4($rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData, 0, seed, 0, 0),
				str));
	});
var $rtfeldman$elm_css$Hash$murmurSeed = 15739;
var $rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
	unsafeToDigit:
	while (true) {
		switch (num) {
			case 0:
				return '0';
			case 1:
				return '1';
			case 2:
				return '2';
			case 3:
				return '3';
			case 4:
				return '4';
			case 5:
				return '5';
			case 6:
				return '6';
			case 7:
				return '7';
			case 8:
				return '8';
			case 9:
				return '9';
			case 10:
				return 'a';
			case 11:
				return 'b';
			case 12:
				return 'c';
			case 13:
				return 'd';
			case 14:
				return 'e';
			case 15:
				return 'f';
			default:
				var $temp$num = num;
				num = $temp$num;
				continue unsafeToDigit;
		}
	}
};
var $rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
	function (digits, num) {
		unsafePositiveToDigits:
		while (true) {
			if (num < 16) {
				return A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(num),
					digits);
			} else {
				var $temp$digits = A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(
						A2($elm$core$Basics$modBy, 16, num)),
					digits),
					$temp$num = (num / 16) | 0;
				digits = $temp$digits;
				num = $temp$num;
				continue unsafePositiveToDigits;
			}
		}
	});
var $rtfeldman$elm_hex$Hex$toString = function (num) {
	return $elm$core$String$fromList(
		(num < 0) ? A2(
			$elm$core$List$cons,
			'-',
			A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
};
var $rtfeldman$elm_css$Hash$fromString = function (str) {
	return A2(
		$elm$core$String$cons,
		'_',
		$rtfeldman$elm_hex$Hex$toString(
			A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString, $rtfeldman$elm_css$Hash$murmurSeed, str)));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
	last:
	while (true) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!list.b.b) {
				var singleton = list.a;
				return $elm$core$Maybe$Just(singleton);
			} else {
				var rest = list.b;
				var $temp$list = rest;
				list = $temp$list;
				continue last;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
	lastDeclaration:
	while (true) {
		if (!declarations.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!declarations.b.b) {
				var x = declarations.a;
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[x]));
			} else {
				var xs = declarations.b;
				var $temp$declarations = xs;
				declarations = $temp$declarations;
				continue lastDeclaration;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
	oneOf:
	while (true) {
		if (!maybes.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var maybe = maybes.a;
			var rest = maybes.b;
			if (maybe.$ === 1) {
				var $temp$maybes = rest;
				maybes = $temp$maybes;
				continue oneOf;
			} else {
				return maybe;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
	return {$: 9, a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
	var expandTuples = function (tuplesToExpand) {
		if (!tuplesToExpand.b) {
			return _List_Nil;
		} else {
			var properties = tuplesToExpand.a;
			var rest = tuplesToExpand.b;
			return A2(
				$elm$core$List$cons,
				properties,
				expandTuples(rest));
		}
	};
	var newTuples = expandTuples(tuples);
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
		]);
};
var $rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
	function (mediaQueries, declaration) {
		if (!declaration.$) {
			var styleBlock = declaration.a;
			return A2(
				$rtfeldman$elm_css$Css$Structure$MediaRule,
				mediaQueries,
				_List_fromArray(
					[styleBlock]));
		} else {
			return declaration;
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
	function (str1, str2, str3, str4, declaration) {
		if (!declaration.$) {
			var structureStyleBlock = declaration.a;
			return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
		} else {
			return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
	function (mediaQueries, declaration) {
		switch (declaration.$) {
			case 0:
				var structureStyleBlock = declaration.a;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[structureStyleBlock]));
			case 1:
				var newMediaQueries = declaration.a;
				var structureStyleBlocks = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					_Utils_ap(mediaQueries, newMediaQueries),
					structureStyleBlocks);
			case 2:
				var str = declaration.a;
				var declarations = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$SupportsRule,
					str,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
						declarations));
			case 3:
				var str1 = declaration.a;
				var str2 = declaration.b;
				var str3 = declaration.c;
				var str4 = declaration.d;
				var structureStyleBlock = declaration.e;
				return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			case 4:
				return declaration;
			case 5:
				return declaration;
			case 6:
				return declaration;
			case 7:
				return declaration;
			case 8:
				return declaration;
			default:
				return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_v0) {
	var declarations = _v0;
	return declarations;
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
	function (nestedStyles, rest, f, declarations) {
		var withoutParent = function (decls) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$elm$core$List$tail(decls));
		};
		var nextResult = A2(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			rest,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		var newDeclarations = function () {
			var _v14 = _Utils_Tuple2(
				$elm$core$List$head(nextResult),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
			if ((!_v14.a.$) && (!_v14.b.$)) {
				var nextResultParent = _v14.a.a;
				var originalParent = _v14.b.a;
				return _Utils_ap(
					A2(
						$elm$core$List$take,
						$elm$core$List$length(declarations) - 1,
						declarations),
					_List_fromArray(
						[
							(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
						]));
			} else {
				return declarations;
			}
		}();
		var insertStylesToNestedDecl = function (lastDecl) {
			return $elm$core$List$concat(
				A2(
					$rtfeldman$elm_css$Css$Structure$mapLast,
					$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
					A2(
						$elm$core$List$map,
						$elm$core$List$singleton,
						A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
		};
		var initialResult = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				insertStylesToNestedDecl,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		return _Utils_ap(
			newDeclarations,
			_Utils_ap(
				withoutParent(initialResult),
				withoutParent(nextResult)));
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
	function (styles, declarations) {
		if (!styles.b) {
			return declarations;
		} else {
			switch (styles.a.$) {
				case 0:
					var property = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
				case 1:
					var _v4 = styles.a;
					var selector = _v4.a;
					var nestedStyles = _v4.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
						declarations);
				case 2:
					var _v5 = styles.a;
					var selectorCombinator = _v5.a;
					var snippets = _v5.b;
					var rest = styles.b;
					var chain = F2(
						function (_v9, _v10) {
							var originalSequence = _v9.a;
							var originalTuples = _v9.b;
							var originalPseudoElement = _v9.c;
							var newSequence = _v10.a;
							var newTuples = _v10.b;
							var newPseudoElement = _v10.c;
							return A3(
								$rtfeldman$elm_css$Css$Structure$Selector,
								originalSequence,
								_Utils_ap(
									originalTuples,
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(selectorCombinator, newSequence),
										newTuples)),
								$rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
									_List_fromArray(
										[newPseudoElement, originalPseudoElement])));
						});
					var expandDeclaration = function (declaration) {
						switch (declaration.$) {
							case 0:
								var _v7 = declaration.a;
								var firstSelector = _v7.a;
								var otherSelectors = _v7.b;
								var nestedStyles = _v7.c;
								var newSelectors = A2(
									$elm$core$List$concatMap,
									function (originalSelector) {
										return A2(
											$elm$core$List$map,
											chain(originalSelector),
											A2($elm$core$List$cons, firstSelector, otherSelectors));
									},
									$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
								var newDeclarations = function () {
									if (!newSelectors.b) {
										return _List_Nil;
									} else {
										var first = newSelectors.a;
										var remainder = newSelectors.b;
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
											]);
									}
								}();
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
							case 1:
								var mediaQueries = declaration.a;
								var styleBlocks = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
							case 2:
								var str = declaration.a;
								var otherSnippets = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
							case 3:
								var str1 = declaration.a;
								var str2 = declaration.b;
								var str3 = declaration.c;
								var str4 = declaration.d;
								var styleBlock = declaration.e;
								return A2(
									$elm$core$List$map,
									A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
									$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
							case 4:
								var str = declaration.a;
								var properties = declaration.b;
								return _List_fromArray(
									[
										A2($rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
									]);
							case 5:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$FontFace(properties)
									]);
							case 6:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$Viewport(properties)
									]);
							case 7:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
									]);
							default:
								var tuples = declaration.a;
								return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
						}
					};
					return $elm$core$List$concat(
						_Utils_ap(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
								]),
							A2(
								$elm$core$List$map,
								expandDeclaration,
								A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
				case 3:
					var _v11 = styles.a;
					var pseudoElement = _v11.a;
					var nestedStyles = _v11.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
						declarations);
				case 5:
					var str = styles.a.a;
					var rest = styles.b;
					var name = $rtfeldman$elm_css$Hash$fromString(str);
					var newProperty = 'animation-name:' + name;
					var newDeclarations = A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
					return A2(
						$elm$core$List$append,
						newDeclarations,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$Keyframes(
								{wM: str, C1: name})
							]));
				case 4:
					var _v12 = styles.a;
					var mediaQueries = _v12.a;
					var nestedStyles = _v12.b;
					var rest = styles.b;
					var extraDeclarations = function () {
						var _v13 = $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
						if (!_v13.b) {
							return _List_Nil;
						} else {
							var firstSelector = _v13.a;
							var otherSelectors = _v13.b;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
								A2(
									$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
									nestedStyles,
									$elm$core$List$singleton(
										$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
											A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
						}
					}();
					return _Utils_ap(
						A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
						extraDeclarations);
				default:
					var otherStyles = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						_Utils_ap(otherStyles, rest),
						declarations);
			}
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_v2) {
	var firstSelector = _v2.a;
	var otherSelectors = _v2.b;
	var styles = _v2.c;
	return A2(
		$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
		styles,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
			]));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
	if (!snippetDeclarations.b) {
		return _List_Nil;
	} else {
		var first = snippetDeclarations.a;
		var rest = snippetDeclarations.b;
		return _Utils_ap(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
			$rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
	function (mediaQueries, styleBlocks) {
		var handleStyleBlock = function (styleBlock) {
			return A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		};
		return A2($elm$core$List$concatMap, handleStyleBlock, styleBlocks);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
	function (str, snippets) {
		var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return _List_fromArray(
			[
				A2($rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
	switch (snippetDeclaration.$) {
		case 0:
			var styleBlock = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
		case 1:
			var mediaQueries = snippetDeclaration.a;
			var styleBlocks = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
		case 2:
			var str = snippetDeclaration.a;
			var snippets = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
		case 3:
			var str1 = snippetDeclaration.a;
			var str2 = snippetDeclaration.b;
			var str3 = snippetDeclaration.c;
			var str4 = snippetDeclaration.d;
			var styleBlock = snippetDeclaration.e;
			return A2(
				$elm$core$List$map,
				A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		case 4:
			var str = snippetDeclaration.a;
			var properties = snippetDeclaration.b;
			return _List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
				]);
		case 5:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$FontFace(properties)
				]);
		case 6:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$Viewport(properties)
				]);
		case 7:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
				]);
		default:
			var tuples = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_v0) {
	var charset = _v0.jJ;
	var imports = _v0.cN;
	var namespaces = _v0.om;
	var snippets = _v0.rf;
	var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
		A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
	return {jJ: charset, wN: declarations, cN: imports, om: namespaces};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp = function (sheet) {
	return $rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
		$rtfeldman$elm_css$Css$Structure$compactStylesheet(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (styles) {
	return A2(
		$elm$core$String$join,
		'\n\n',
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp, styles));
};
var $rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$Snippet = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
	function (styles, sequence) {
		var selector = A3($rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, $elm$core$Maybe$Nothing);
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
			]);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair = function (_v0) {
	var classname = _v0.a;
	var styles = _v0.b;
	return A2(
		$rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
		styles,
		$rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$ClassSelector(classname)
				])));
};
var $rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
	return {jJ: $elm$core$Maybe$Nothing, cN: _List_Nil, om: _List_Nil, rf: snippets};
};
var $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
	return $rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
		$elm$core$List$singleton(
			$rtfeldman$elm_css$Css$Preprocess$stylesheet(
				A2(
					$elm$core$List$map,
					$rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair,
					$elm$core$Dict$toList(dict)))));
};
var $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = function (styles) {
	return A3(
		$elm$virtual_dom$VirtualDom$node,
		'style',
		_List_Nil,
		$elm$core$List$singleton(
			$elm$virtual_dom$VirtualDom$text(
				$rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(styles))));
};
var $rtfeldman$elm_css$VirtualDom$Styled$unstyle = F3(
	function (elemType, properties, children) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
	function (key, pairs) {
		containsKey:
		while (true) {
			if (!pairs.b) {
				return false;
			} else {
				var _v1 = pairs.a;
				var str = _v1.a;
				var rest = pairs.b;
				if (_Utils_eq(key, str)) {
					return true;
				} else {
					var $temp$key = key,
						$temp$pairs = rest;
					key = $temp$key;
					pairs = $temp$pairs;
					continue containsKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
	function (_default, pairs) {
		getUnusedKey:
		while (true) {
			if (!pairs.b) {
				return _default;
			} else {
				var _v1 = pairs.a;
				var firstKey = _v1.a;
				var rest = pairs.b;
				var newKey = '_' + firstKey;
				if (A2($rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
					var $temp$default = newKey,
						$temp$pairs = rest;
					_default = $temp$default;
					pairs = $temp$pairs;
					continue getUnusedKey;
				} else {
					return newKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F2(
	function (allStyles, keyedChildNodes) {
		var styleNodeKey = A2($rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
		var finalNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(allStyles);
		return _Utils_Tuple2(styleNodeKey, finalNode);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F3(
	function (elemType, properties, keyedChildren) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
		return A3(
			$elm$virtual_dom$VirtualDom$keyedNode,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F4(
	function (ns, elemType, properties, keyedChildren) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
		return A4(
			$elm$virtual_dom$VirtualDom$keyedNodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F4(
	function (ns, elemType, properties, children) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
		return A4(
			$elm$virtual_dom$VirtualDom$nodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
	switch (vdom.$) {
		case 4:
			var plainNode = vdom.a;
			return plainNode;
		case 0:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A3($rtfeldman$elm_css$VirtualDom$Styled$unstyle, elemType, properties, children);
		case 1:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, ns, elemType, properties, children);
		case 2:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A3($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, elemType, properties, children);
		default:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, ns, elemType, properties, children);
	}
};
var $rtfeldman$elm_css$Html$Styled$toUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
var $author$project$Main$View$ecranProtege = F2(
	function (i18n, model) {
		var _v0 = model.e1.gt;
		switch (_v0.$) {
			case 1:
				var connexion = _v0.a;
				return _List_fromArray(
					[
						$author$project$Components$Shared$Theme$View$bloc(
						$author$project$Main$View$surcharges(model)),
						$rtfeldman$elm_css$Html$Styled$toUnstyled(
						A3(
							$author$project$Main$View$miseEnPage,
							i18n,
							A2(
								$author$project$Main$View$inerteSousUnDialogue,
								model,
								A7(
									$author$project$Components$Socle$Coquille$View$navigation,
									i18n,
									$author$project$Main$View$surcharges(model).gX,
									model.Ih,
									$author$project$Components$Notifications$Model$nonLues(model.oN),
									$author$project$Main$View$pastilleDesAlertes(model),
									$author$project$Components$Referentiel$Doublons$Model$compteurDuMenu(
										$author$project$Components$Referentiel$Doublons$Model$ouvrir(model.xM)),
									connexion)),
							model))
					]);
			case 4:
				var cause = _v0.a;
				return _List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$toUnstyled(
						A3(
							$author$project$Components$Socle$Session$View$ecran,
							i18n,
							{
								u4: $author$project$Main$Update$SessionMsg($author$project$Components$Socle$Session$Update$ChangerDEspaceDemande),
								wU: $author$project$Main$Update$SessionMsg($author$project$Components$Socle$Session$Update$DeconnexionDemandee)
							},
							cause))
					]);
			case 2:
				var choix = _v0.a;
				return _List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$toUnstyled(
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Main$Update$SessionMsg,
							A3($author$project$Components$Socle$Session$View$choixDEspace, i18n, model.eF.xi, choix)))
					]);
			default:
				return _List_Nil;
		}
	});
var $author$project$Components$Socle$Theme$Model$enAttente = function (model) {
	return _Utils_eq(model.gt, $author$project$Components$Socle$Theme$Model$EnAttente);
};
var $author$project$Components$Demonstration$Donnees$annuaireDeLaRoute = function (route) {
	switch (route.$) {
		case 72:
			var annuaire = route.a;
			return $elm$core$Maybe$Just(annuaire);
		case 73:
			var annuaire = route.a;
			return $elm$core$Maybe$Just(annuaire);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Demonstration$Donnees$application = function (recue) {
	return {
		aa: $elm$core$Maybe$Just(recue.aa),
		dy: recue.dy,
		wj: recue.wj,
		aC: recue.aC,
		Dj: recue.Dj
	};
};
var $author$project$Components$Demonstration$Donnees$applicationsAsria = function (i18n) {
	return _List_fromArray(
		[
			{
			aa: $elm$core$Maybe$Just($author$project$Routes$Route$adresseDemonstration),
			dy: 'crm',
			wj: true,
			aC: $elm$core$Maybe$Nothing,
			Dj: $author$project$I18n$Cles$marqueAsriaCrm(i18n)
		},
			{
			aa: $elm$core$Maybe$Nothing,
			dy: 'cockpit',
			wj: false,
			aC: $elm$core$Maybe$Nothing,
			Dj: $author$project$I18n$Cles$marqueAsriaCockpit(i18n)
		},
			{
			aa: $elm$core$Maybe$Nothing,
			dy: 'insight',
			wj: false,
			aC: $elm$core$Maybe$Nothing,
			Dj: $author$project$I18n$Cles$marqueAsriaInsight(i18n)
		}
		]);
};
var $author$project$Components$Demonstration$Donnees$compteFictif = {AP: 'CM', Dj: 'Camille Martin', En: 'Asria', bi: 'Administratrice'};
var $author$project$Components$Demonstration$Donnees$navigation = F4(
	function (i18n, marque, route, inerte) {
		return {
			tz: A2(
				$elm$core$Maybe$withDefault,
				$author$project$Components$Demonstration$Donnees$applicationsAsria(i18n),
				A2(
					$elm$core$Maybe$map,
					$elm$core$List$map($author$project$Components$Demonstration$Donnees$application),
					marque.tz)),
			vW: $elm$core$Maybe$Just($author$project$Components$Demonstration$Donnees$compteFictif),
			wU: false,
			yv: _List_fromArray(
				[
					{
					aa: $author$project$Routes$Route$adresseDemonstration,
					wj: _Utils_eq(route, $author$project$Routes$Route$Demonstration),
					aC: $author$project$Components$Shared$Svg$svgDashboard,
					Dj: $author$project$I18n$Cles$demonstrationTitre(i18n),
					hn: $elm$core$Maybe$Nothing,
					hT: _List_Nil,
					hY: _List_Nil
				},
					{
					aa: $author$project$Routes$Route$toString(
						$author$project$Routes$Route$DemonstrationAnnuaire(0)),
					wj: _Utils_eq(
						$author$project$Components$Demonstration$Donnees$annuaireDeLaRoute(route),
						$elm$core$Maybe$Just(0)),
					aC: $author$project$Components$Shared$Svg$svgUsers,
					Dj: $author$project$I18n$Cles$demonstrationAnnuairePartiesPrenantes(i18n),
					hn: $elm$core$Maybe$Nothing,
					hT: _List_Nil,
					hY: _List_Nil
				},
					{
					aa: $author$project$Routes$Route$toString(
						$author$project$Routes$Route$DemonstrationAnnuaire(1)),
					wj: _Utils_eq(
						$author$project$Components$Demonstration$Donnees$annuaireDeLaRoute(route),
						$elm$core$Maybe$Just(1)),
					aC: $author$project$Components$Shared$Svg$svgFolders,
					Dj: $author$project$I18n$Cles$demonstrationAnnuaireDossiers(i18n),
					hn: $elm$core$Maybe$Nothing,
					hT: _List_Nil,
					hY: _List_Nil
				}
				]),
			yC: _List_Nil,
			AK: inerte,
			n$: marque.n$,
			CT: $elm$core$Maybe$Nothing,
			Dk: A2(
				$elm$core$Maybe$withDefault,
				$author$project$I18n$Cles$marqueAsriaCrm(i18n),
				marque.Dj)
		};
	});
var $author$project$Main$View$navigationDeLaDemonstration = F2(
	function (i18n, model) {
		return A4(
			$author$project$Components$Demonstration$Donnees$navigation,
			i18n,
			$author$project$Main$View$surcharges(model).gX,
			model.Ih,
			A2($author$project$Components$Demonstration$Model$dialogueOuvert, model.Ih, model.xa));
	});
var $author$project$Main$View$corps = F2(
	function (i18n, model) {
		return _Utils_eq(model.Ih, $author$project$Routes$Route$Version) ? _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$toUnstyled(
				A2($author$project$Main$View$page, i18n, model))
			]) : ($author$project$Components$Socle$Theme$Model$enAttente(model.JA) ? _List_Nil : ($author$project$Routes$Route$protegee(model.Ih) ? A2($author$project$Main$View$ecranProtege, i18n, model) : _List_fromArray(
			[
				$author$project$Components$Shared$Theme$View$bloc(
				$author$project$Main$View$surcharges(model)),
				$rtfeldman$elm_css$Html$Styled$toUnstyled(
				A3(
					$author$project$Main$View$miseEnPage,
					i18n,
					A2($author$project$Main$View$navigationDeLaDemonstration, i18n, model),
					model))
			])));
	});
var $author$project$I18n$Cles$backofficeTitreDocument = function (i18n) {
	return A4($author$project$I18n$Cles$lire, i18n, 'backoffice.titre-document', _List_Nil, 'ASRIA CRM');
};
var $author$project$Main$View$titre = F2(
	function (i18n, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$I18n$Cles$backofficeTitreDocument(i18n),
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.gX;
					},
					function ($) {
						return $.Dj;
					}),
				$author$project$Components$Socle$Theme$Model$themeApplique(model.JA)));
	});
var $author$project$Main$View$view = function (model) {
	var i18n = model.e1.JL;
	return {
		dr: A2($author$project$Main$View$corps, i18n, model),
		JB: A2($author$project$Main$View$titre, i18n, model)
	};
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{
		AN: F3(
			function (flags, url, key) {
				return A3(
					$elm$core$Tuple$mapBoth,
					$elm$core$Tuple$pair(key),
					$author$project$Main$executerTous(key),
					A2($author$project$Main$Update$init, flags, url));
			}),
		Ec: $author$project$Main$Update$UrlChangee,
		Ed: $author$project$Main$Update$LienClique,
		I5: A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$Main$abonnements),
		Kb: F2(
			function (msg, _v0) {
				var key = _v0.a;
				var model = _v0.b;
				return A2(
					$author$project$Main$suivreLaLangue,
					model,
					A3(
						$elm$core$Tuple$mapBoth,
						$elm$core$Tuple$pair(key),
						$author$project$Main$executerTous(key),
						A2($author$project$Main$Update$update, msg, model)));
			}),
		KO: A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$Main$View$view)
	});
/*
_Platform_export({'Main':{'init':$author$project$Main$main($elm$json$Json$Decode$value)(0)}});}(this));
*/
export const Elm = {'Main':{'init':$author$project$Main$main($elm$json$Json$Decode$value)(0)}};
  